import * as React from "react";
import React__default, { useContext, useMemo as useMemo$1, useState, useEffect, useCallback, forwardRef, Component, createContext, useRef, Suspense, memo as memo$1, PureComponent, Fragment, useLayoutEffect as useLayoutEffect$1, lazy, isValidElement, createElement as createElement$1, Children, Profiler as Profiler$1, version as version$6, useSyncExternalStore, cloneElement } from "react";
import ReactDOM, { flushSync, unstable_batchedUpdates } from "react-dom";
var commonjsGlobal$2 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs$2(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function getAugmentedNamespace(n) {
  if (Object.prototype.hasOwnProperty.call(n, "__esModule")) return n;
  var t = n.default;
  if (typeof t == "function") {
    var g = function d() {
      var k = !1;
      try {
        k = this instanceof d;
      } catch {
      }
      return k ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    g.prototype = t.prototype;
  } else g = {};
  return Object.defineProperty(g, "__esModule", { value: !0 }), Object.keys(n).forEach(function(d) {
    var k = Object.getOwnPropertyDescriptor(n, d);
    Object.defineProperty(g, d, k.get ? k : {
      enumerable: !0,
      get: function() {
        return n[d];
      }
    });
  }), g;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var n = React__default, t = Symbol.for("react.element"), g = Symbol.for("react.fragment"), d = Object.prototype.hasOwnProperty, k = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, H = { key: !0, ref: !0, __self: !0, __source: !0 };
  function AA(gA, IA, CA) {
    var BA, eA = {}, iA = null, QA = null;
    CA !== void 0 && (iA = "" + CA), IA.key !== void 0 && (iA = "" + IA.key), IA.ref !== void 0 && (QA = IA.ref);
    for (BA in IA) d.call(IA, BA) && !H.hasOwnProperty(BA) && (eA[BA] = IA[BA]);
    if (gA && gA.defaultProps) for (BA in IA = gA.defaultProps, IA) eA[BA] === void 0 && (eA[BA] = IA[BA]);
    return { $$typeof: t, type: gA, key: iA, ref: QA, props: eA, _owner: k.current };
  }
  return reactJsxRuntime_production_min.Fragment = g, reactJsxRuntime_production_min.jsx = AA, reactJsxRuntime_production_min.jsxs = AA, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && (function() {
    var n = React__default, t = Symbol.for("react.element"), g = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), k = Symbol.for("react.strict_mode"), H = Symbol.for("react.profiler"), AA = Symbol.for("react.provider"), gA = Symbol.for("react.context"), IA = Symbol.for("react.forward_ref"), CA = Symbol.for("react.suspense"), BA = Symbol.for("react.suspense_list"), eA = Symbol.for("react.memo"), iA = Symbol.for("react.lazy"), QA = Symbol.for("react.offscreen"), tA = Symbol.iterator, oA = "@@iterator";
    function EA(Ag) {
      if (Ag === null || typeof Ag != "object")
        return null;
      var Ng = tA && Ag[tA] || Ag[oA];
      return typeof Ng == "function" ? Ng : null;
    }
    var aA = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function nA(Ag) {
      {
        for (var Ng = arguments.length, UA = new Array(Ng > 1 ? Ng - 1 : 0), qA = 1; qA < Ng; qA++)
          UA[qA - 1] = arguments[qA];
        lA("error", Ag, UA);
      }
    }
    function lA(Ag, Ng, UA) {
      {
        var qA = aA.ReactDebugCurrentFrame, SA = qA.getStackAddendum();
        SA !== "" && (Ng += "%s", UA = UA.concat([SA]));
        var WA = UA.map(function(OA) {
          return String(OA);
        });
        WA.unshift("Warning: " + Ng), Function.prototype.apply.call(console[Ag], console, WA);
      }
    }
    var cA = !1, sA = !1, rA = !1, uA = !1, hA = !1, dA;
    dA = Symbol.for("react.module.reference");
    function GA(Ag) {
      return !!(typeof Ag == "string" || typeof Ag == "function" || Ag === d || Ag === H || hA || Ag === k || Ag === CA || Ag === BA || uA || Ag === QA || cA || sA || rA || typeof Ag == "object" && Ag !== null && (Ag.$$typeof === iA || Ag.$$typeof === eA || Ag.$$typeof === AA || Ag.$$typeof === gA || Ag.$$typeof === IA || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Ag.$$typeof === dA || Ag.getModuleId !== void 0));
    }
    function DA(Ag, Ng, UA) {
      var qA = Ag.displayName;
      if (qA)
        return qA;
      var SA = Ng.displayName || Ng.name || "";
      return SA !== "" ? UA + "(" + SA + ")" : UA;
    }
    function wA(Ag) {
      return Ag.displayName || "Context";
    }
    function bA(Ag) {
      if (Ag == null)
        return null;
      if (typeof Ag.tag == "number" && nA("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Ag == "function")
        return Ag.displayName || Ag.name || null;
      if (typeof Ag == "string")
        return Ag;
      switch (Ag) {
        case d:
          return "Fragment";
        case g:
          return "Portal";
        case H:
          return "Profiler";
        case k:
          return "StrictMode";
        case CA:
          return "Suspense";
        case BA:
          return "SuspenseList";
      }
      if (typeof Ag == "object")
        switch (Ag.$$typeof) {
          case gA:
            var Ng = Ag;
            return wA(Ng) + ".Consumer";
          case AA:
            var UA = Ag;
            return wA(UA._context) + ".Provider";
          case IA:
            return DA(Ag, Ag.render, "ForwardRef");
          case eA:
            var qA = Ag.displayName || null;
            return qA !== null ? qA : bA(Ag.type) || "Memo";
          case iA: {
            var SA = Ag, WA = SA._payload, OA = SA._init;
            try {
              return bA(OA(WA));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var yA = Object.assign, pA = 0, MA, LA, xA, TA, NA, zA, XA;
    function fA() {
    }
    fA.__reactDisabledLog = !0;
    function vA() {
      {
        if (pA === 0) {
          MA = console.log, LA = console.info, xA = console.warn, TA = console.error, NA = console.group, zA = console.groupCollapsed, XA = console.groupEnd;
          var Ag = {
            configurable: !0,
            enumerable: !0,
            value: fA,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Ag,
            log: Ag,
            warn: Ag,
            error: Ag,
            group: Ag,
            groupCollapsed: Ag,
            groupEnd: Ag
          });
        }
        pA++;
      }
    }
    function Cg() {
      {
        if (pA--, pA === 0) {
          var Ag = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: yA({}, Ag, {
              value: MA
            }),
            info: yA({}, Ag, {
              value: LA
            }),
            warn: yA({}, Ag, {
              value: xA
            }),
            error: yA({}, Ag, {
              value: TA
            }),
            group: yA({}, Ag, {
              value: NA
            }),
            groupCollapsed: yA({}, Ag, {
              value: zA
            }),
            groupEnd: yA({}, Ag, {
              value: XA
            })
          });
        }
        pA < 0 && nA("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ig = aA.ReactCurrentDispatcher, gg;
    function og(Ag, Ng, UA) {
      {
        if (gg === void 0)
          try {
            throw Error();
          } catch (SA) {
            var qA = SA.stack.trim().match(/\n( *(at )?)/);
            gg = qA && qA[1] || "";
          }
        return `
` + gg + Ag;
      }
    }
    var eg = !1, kA;
    {
      var YA = typeof WeakMap == "function" ? WeakMap : Map;
      kA = new YA();
    }
    function RA(Ag, Ng) {
      if (!Ag || eg)
        return "";
      {
        var UA = kA.get(Ag);
        if (UA !== void 0)
          return UA;
      }
      var qA;
      eg = !0;
      var SA = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var WA;
      WA = Ig.current, Ig.current = null, vA();
      try {
        if (Ng) {
          var OA = function() {
            throw Error();
          };
          if (Object.defineProperty(OA.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(OA, []);
            } catch (fg) {
              qA = fg;
            }
            Reflect.construct(Ag, [], OA);
          } else {
            try {
              OA.call();
            } catch (fg) {
              qA = fg;
            }
            Ag.call(OA.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (fg) {
            qA = fg;
          }
          Ag();
        }
      } catch (fg) {
        if (fg && qA && typeof fg.stack == "string") {
          for (var Bg = fg.stack.split(`
`), dg = qA.stack.split(`
`), lg = Bg.length - 1, Qg = dg.length - 1; lg >= 1 && Qg >= 0 && Bg[lg] !== dg[Qg]; )
            Qg--;
          for (; lg >= 1 && Qg >= 0; lg--, Qg--)
            if (Bg[lg] !== dg[Qg]) {
              if (lg !== 1 || Qg !== 1)
                do
                  if (lg--, Qg--, Qg < 0 || Bg[lg] !== dg[Qg]) {
                    var pg = `
` + Bg[lg].replace(" at new ", " at ");
                    return Ag.displayName && pg.includes("<anonymous>") && (pg = pg.replace("<anonymous>", Ag.displayName)), typeof Ag == "function" && kA.set(Ag, pg), pg;
                  }
                while (lg >= 1 && Qg >= 0);
              break;
            }
        }
      } finally {
        eg = !1, Ig.current = WA, Cg(), Error.prepareStackTrace = SA;
      }
      var Fg = Ag ? Ag.displayName || Ag.name : "", Yg = Fg ? og(Fg) : "";
      return typeof Ag == "function" && kA.set(Ag, Yg), Yg;
    }
    function FA(Ag, Ng, UA) {
      return RA(Ag, !1);
    }
    function mA(Ag) {
      var Ng = Ag.prototype;
      return !!(Ng && Ng.isReactComponent);
    }
    function JA(Ag, Ng, UA) {
      if (Ag == null)
        return "";
      if (typeof Ag == "function")
        return RA(Ag, mA(Ag));
      if (typeof Ag == "string")
        return og(Ag);
      switch (Ag) {
        case CA:
          return og("Suspense");
        case BA:
          return og("SuspenseList");
      }
      if (typeof Ag == "object")
        switch (Ag.$$typeof) {
          case IA:
            return FA(Ag.render);
          case eA:
            return JA(Ag.type, Ng, UA);
          case iA: {
            var qA = Ag, SA = qA._payload, WA = qA._init;
            try {
              return JA(WA(SA), Ng, UA);
            } catch {
            }
          }
        }
      return "";
    }
    var VA = Object.prototype.hasOwnProperty, HA = {}, jA = aA.ReactDebugCurrentFrame;
    function _A(Ag) {
      if (Ag) {
        var Ng = Ag._owner, UA = JA(Ag.type, Ag._source, Ng ? Ng.type : null);
        jA.setExtraStackFrame(UA);
      } else
        jA.setExtraStackFrame(null);
    }
    function $A(Ag, Ng, UA, qA, SA) {
      {
        var WA = Function.call.bind(VA);
        for (var OA in Ag)
          if (WA(Ag, OA)) {
            var Bg = void 0;
            try {
              if (typeof Ag[OA] != "function") {
                var dg = Error((qA || "React class") + ": " + UA + " type `" + OA + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Ag[OA] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw dg.name = "Invariant Violation", dg;
              }
              Bg = Ag[OA](Ng, OA, qA, UA, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (lg) {
              Bg = lg;
            }
            Bg && !(Bg instanceof Error) && (_A(SA), nA("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", qA || "React class", UA, OA, typeof Bg), _A(null)), Bg instanceof Error && !(Bg.message in HA) && (HA[Bg.message] = !0, _A(SA), nA("Failed %s type: %s", UA, Bg.message), _A(null));
          }
      }
    }
    var rg = Array.isArray;
    function wg(Ag) {
      return rg(Ag);
    }
    function Dg(Ag) {
      {
        var Ng = typeof Symbol == "function" && Symbol.toStringTag, UA = Ng && Ag[Symbol.toStringTag] || Ag.constructor.name || "Object";
        return UA;
      }
    }
    function kg(Ag) {
      try {
        return ig(Ag), !1;
      } catch {
        return !0;
      }
    }
    function ig(Ag) {
      return "" + Ag;
    }
    function ZA(Ag) {
      if (kg(Ag))
        return nA("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Dg(Ag)), ig(Ag);
    }
    var KA = aA.ReactCurrentOwner, PA = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ag, Gg;
    function bg(Ag) {
      if (VA.call(Ag, "ref")) {
        var Ng = Object.getOwnPropertyDescriptor(Ag, "ref").get;
        if (Ng && Ng.isReactWarning)
          return !1;
      }
      return Ag.ref !== void 0;
    }
    function yg(Ag) {
      if (VA.call(Ag, "key")) {
        var Ng = Object.getOwnPropertyDescriptor(Ag, "key").get;
        if (Ng && Ng.isReactWarning)
          return !1;
      }
      return Ag.key !== void 0;
    }
    function hg(Ag, Ng) {
      typeof Ag.ref == "string" && KA.current;
    }
    function tg(Ag, Ng) {
      {
        var UA = function() {
          ag || (ag = !0, nA("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ng));
        };
        UA.isReactWarning = !0, Object.defineProperty(Ag, "key", {
          get: UA,
          configurable: !0
        });
      }
    }
    function Eg(Ag, Ng) {
      {
        var UA = function() {
          Gg || (Gg = !0, nA("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ng));
        };
        UA.isReactWarning = !0, Object.defineProperty(Ag, "ref", {
          get: UA,
          configurable: !0
        });
      }
    }
    var cg = function(Ag, Ng, UA, qA, SA, WA, OA) {
      var Bg = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: Ag,
        key: Ng,
        ref: UA,
        props: OA,
        // Record the component responsible for creating this element.
        _owner: WA
      };
      return Bg._store = {}, Object.defineProperty(Bg._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Bg, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: qA
      }), Object.defineProperty(Bg, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: SA
      }), Object.freeze && (Object.freeze(Bg.props), Object.freeze(Bg)), Bg;
    };
    function sg(Ag, Ng, UA, qA, SA) {
      {
        var WA, OA = {}, Bg = null, dg = null;
        UA !== void 0 && (ZA(UA), Bg = "" + UA), yg(Ng) && (ZA(Ng.key), Bg = "" + Ng.key), bg(Ng) && (dg = Ng.ref, hg(Ng, SA));
        for (WA in Ng)
          VA.call(Ng, WA) && !PA.hasOwnProperty(WA) && (OA[WA] = Ng[WA]);
        if (Ag && Ag.defaultProps) {
          var lg = Ag.defaultProps;
          for (WA in lg)
            OA[WA] === void 0 && (OA[WA] = lg[WA]);
        }
        if (Bg || dg) {
          var Qg = typeof Ag == "function" ? Ag.displayName || Ag.name || "Unknown" : Ag;
          Bg && tg(OA, Qg), dg && Eg(OA, Qg);
        }
        return cg(Ag, Bg, dg, SA, qA, KA.current, OA);
      }
    }
    var ug = aA.ReactCurrentOwner, Mg = aA.ReactDebugCurrentFrame;
    function Rg(Ag) {
      if (Ag) {
        var Ng = Ag._owner, UA = JA(Ag.type, Ag._source, Ng ? Ng.type : null);
        Mg.setExtraStackFrame(UA);
      } else
        Mg.setExtraStackFrame(null);
    }
    var Jg;
    Jg = !1;
    function Hg(Ag) {
      return typeof Ag == "object" && Ag !== null && Ag.$$typeof === t;
    }
    function mg() {
      {
        if (ug.current) {
          var Ag = bA(ug.current.type);
          if (Ag)
            return `

Check the render method of \`` + Ag + "`.";
        }
        return "";
      }
    }
    function Og(Ag) {
      return "";
    }
    var Kg = {};
    function vg(Ag) {
      {
        var Ng = mg();
        if (!Ng) {
          var UA = typeof Ag == "string" ? Ag : Ag.displayName || Ag.name;
          UA && (Ng = `

Check the top-level render call using <` + UA + ">.");
        }
        return Ng;
      }
    }
    function Vg(Ag, Ng) {
      {
        if (!Ag._store || Ag._store.validated || Ag.key != null)
          return;
        Ag._store.validated = !0;
        var UA = vg(Ng);
        if (Kg[UA])
          return;
        Kg[UA] = !0;
        var qA = "";
        Ag && Ag._owner && Ag._owner !== ug.current && (qA = " It was passed a child from " + bA(Ag._owner.type) + "."), Rg(Ag), nA('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', UA, qA), Rg(null);
      }
    }
    function Xg(Ag, Ng) {
      {
        if (typeof Ag != "object")
          return;
        if (wg(Ag))
          for (var UA = 0; UA < Ag.length; UA++) {
            var qA = Ag[UA];
            Hg(qA) && Vg(qA, Ng);
          }
        else if (Hg(Ag))
          Ag._store && (Ag._store.validated = !0);
        else if (Ag) {
          var SA = EA(Ag);
          if (typeof SA == "function" && SA !== Ag.entries)
            for (var WA = SA.call(Ag), OA; !(OA = WA.next()).done; )
              Hg(OA.value) && Vg(OA.value, Ng);
        }
      }
    }
    function jg(Ag) {
      {
        var Ng = Ag.type;
        if (Ng == null || typeof Ng == "string")
          return;
        var UA;
        if (typeof Ng == "function")
          UA = Ng.propTypes;
        else if (typeof Ng == "object" && (Ng.$$typeof === IA || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ng.$$typeof === eA))
          UA = Ng.propTypes;
        else
          return;
        if (UA) {
          var qA = bA(Ng);
          $A(UA, Ag.props, "prop", qA, Ag);
        } else if (Ng.PropTypes !== void 0 && !Jg) {
          Jg = !0;
          var SA = bA(Ng);
          nA("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", SA || "Unknown");
        }
        typeof Ng.getDefaultProps == "function" && !Ng.getDefaultProps.isReactClassApproved && nA("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function gI(Ag) {
      {
        for (var Ng = Object.keys(Ag.props), UA = 0; UA < Ng.length; UA++) {
          var qA = Ng[UA];
          if (qA !== "children" && qA !== "key") {
            Rg(Ag), nA("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", qA), Rg(null);
            break;
          }
        }
        Ag.ref !== null && (Rg(Ag), nA("Invalid attribute `ref` supplied to `React.Fragment`."), Rg(null));
      }
    }
    var II = {};
    function tI(Ag, Ng, UA, qA, SA, WA) {
      {
        var OA = GA(Ag);
        if (!OA) {
          var Bg = "";
          (Ag === void 0 || typeof Ag == "object" && Ag !== null && Object.keys(Ag).length === 0) && (Bg += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var dg = Og();
          dg ? Bg += dg : Bg += mg();
          var lg;
          Ag === null ? lg = "null" : wg(Ag) ? lg = "array" : Ag !== void 0 && Ag.$$typeof === t ? (lg = "<" + (bA(Ag.type) || "Unknown") + " />", Bg = " Did you accidentally export a JSX literal instead of a component?") : lg = typeof Ag, nA("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", lg, Bg);
        }
        var Qg = sg(Ag, Ng, UA, SA, WA);
        if (Qg == null)
          return Qg;
        if (OA) {
          var pg = Ng.children;
          if (pg !== void 0)
            if (qA)
              if (wg(pg)) {
                for (var Fg = 0; Fg < pg.length; Fg++)
                  Xg(pg[Fg], Ag);
                Object.freeze && Object.freeze(pg);
              } else
                nA("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xg(pg, Ag);
        }
        if (VA.call(Ng, "key")) {
          var Yg = bA(Ag), fg = Object.keys(Ng).filter(function(xg) {
            return xg !== "key";
          }), Wg = fg.length > 0 ? "{key: someKey, " + fg.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!II[Yg + Wg]) {
            var Ug = fg.length > 0 ? "{" + fg.join(": ..., ") + ": ...}" : "{}";
            nA(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Wg, Yg, Ug, Yg), II[Yg + Wg] = !0;
          }
        }
        return Ag === d ? gI(Qg) : jg(Qg), Qg;
      }
    }
    function Sg(Ag, Ng, UA) {
      return tI(Ag, Ng, UA, !0);
    }
    function Zg(Ag, Ng, UA) {
      return tI(Ag, Ng, UA, !1);
    }
    var qg = Zg, $g = Sg;
    reactJsxRuntime_development.Fragment = d, reactJsxRuntime_development.jsx = qg, reactJsxRuntime_development.jsxs = $g;
  })()), reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  return hasRequiredJsxRuntime || (hasRequiredJsxRuntime = 1, process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development()), jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime(), loglevel$3 = { exports: {} }, loglevel$2 = loglevel$3.exports, hasRequiredLoglevel$1;
function requireLoglevel$1() {
  return hasRequiredLoglevel$1 || (hasRequiredLoglevel$1 = 1, (function(n) {
    (function(t, g) {
      n.exports ? n.exports = g() : t.log = g();
    })(loglevel$2, function() {
      var t = function() {
      }, g = "undefined", d = typeof window !== g && typeof window.navigator !== g && /Trident\/|MSIE /.test(window.navigator.userAgent), k = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], H = {}, AA = null;
      function gA(oA, EA) {
        var aA = oA[EA];
        if (typeof aA.bind == "function")
          return aA.bind(oA);
        try {
          return Function.prototype.bind.call(aA, oA);
        } catch {
          return function() {
            return Function.prototype.apply.apply(aA, [oA, arguments]);
          };
        }
      }
      function IA() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function CA(oA) {
        return oA === "debug" && (oA = "log"), typeof console === g ? !1 : oA === "trace" && d ? IA : console[oA] !== void 0 ? gA(console, oA) : console.log !== void 0 ? gA(console, "log") : t;
      }
      function BA() {
        for (var oA = this.getLevel(), EA = 0; EA < k.length; EA++) {
          var aA = k[EA];
          this[aA] = EA < oA ? t : this.methodFactory(aA, oA, this.name);
        }
        if (this.log = this.debug, typeof console === g && oA < this.levels.SILENT)
          return "No console available for logging";
      }
      function eA(oA) {
        return function() {
          typeof console !== g && (BA.call(this), this[oA].apply(this, arguments));
        };
      }
      function iA(oA, EA, aA) {
        return CA(oA) || eA.apply(this, arguments);
      }
      function QA(oA, EA) {
        var aA = this, nA, lA, cA, sA = "loglevel";
        typeof oA == "string" ? sA += ":" + oA : typeof oA == "symbol" && (sA = void 0);
        function rA(DA) {
          var wA = (k[DA] || "silent").toUpperCase();
          if (!(typeof window === g || !sA)) {
            try {
              window.localStorage[sA] = wA;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(sA) + "=" + wA + ";";
            } catch {
            }
          }
        }
        function uA() {
          var DA;
          if (!(typeof window === g || !sA)) {
            try {
              DA = window.localStorage[sA];
            } catch {
            }
            if (typeof DA === g)
              try {
                var wA = window.document.cookie, bA = encodeURIComponent(sA), yA = wA.indexOf(bA + "=");
                yA !== -1 && (DA = /^([^;]+)/.exec(
                  wA.slice(yA + bA.length + 1)
                )[1]);
              } catch {
              }
            return aA.levels[DA] === void 0 && (DA = void 0), DA;
          }
        }
        function hA() {
          if (!(typeof window === g || !sA)) {
            try {
              window.localStorage.removeItem(sA);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(sA) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function dA(DA) {
          var wA = DA;
          if (typeof wA == "string" && aA.levels[wA.toUpperCase()] !== void 0 && (wA = aA.levels[wA.toUpperCase()]), typeof wA == "number" && wA >= 0 && wA <= aA.levels.SILENT)
            return wA;
          throw new TypeError("log.setLevel() called with invalid level: " + DA);
        }
        aA.name = oA, aA.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, aA.methodFactory = EA || iA, aA.getLevel = function() {
          return cA ?? lA ?? nA;
        }, aA.setLevel = function(DA, wA) {
          return cA = dA(DA), wA !== !1 && rA(cA), BA.call(aA);
        }, aA.setDefaultLevel = function(DA) {
          lA = dA(DA), uA() || aA.setLevel(DA, !1);
        }, aA.resetLevel = function() {
          cA = null, hA(), BA.call(aA);
        }, aA.enableAll = function(DA) {
          aA.setLevel(aA.levels.TRACE, DA);
        }, aA.disableAll = function(DA) {
          aA.setLevel(aA.levels.SILENT, DA);
        }, aA.rebuild = function() {
          if (AA !== aA && (nA = dA(AA.getLevel())), BA.call(aA), AA === aA)
            for (var DA in H)
              H[DA].rebuild();
        }, nA = dA(
          AA ? AA.getLevel() : "WARN"
        );
        var GA = uA();
        GA != null && (cA = dA(GA)), BA.call(aA);
      }
      AA = new QA(), AA.getLogger = function(EA) {
        if (typeof EA != "symbol" && typeof EA != "string" || EA === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var aA = H[EA];
        return aA || (aA = H[EA] = new QA(
          EA,
          AA.methodFactory
        )), aA;
      };
      var tA = typeof window !== g ? window.log : void 0;
      return AA.noConflict = function() {
        return typeof window !== g && window.log === AA && (window.log = tA), AA;
      }, AA.getLoggers = function() {
        return H;
      }, AA.default = AA, AA;
    });
  })(loglevel$3)), loglevel$3.exports;
}
var loglevelExports$1 = requireLoglevel$1();
const log$6 = /* @__PURE__ */ getDefaultExportFromCjs$2(loglevelExports$1);
let PromiseDelegate$1 = class {
  promise;
  resolveInternal;
  rejectInternal;
  constructor() {
    this.promise = new Promise((t, g) => {
      this.resolveInternal = t, this.rejectInternal = g;
    });
  }
  resolve(t) {
    this.resolveInternal(t);
  }
  reject(t) {
    this.rejectInternal(t);
  }
};
const workerBlobUrlCache = /* @__PURE__ */ new Map();
function getWorkerBlobUrl(n, t = !1) {
  const g = n.toString(), d = workerBlobUrlCache.get(g);
  if (d)
    return console.debug(`Using a cached worker blob URL for ${g}`), d;
  const k = t ? `import "${g}";` : `importScripts("${g}");`, H = new Blob([k], {
    type: t ? "text/javascript;type=module" : "text/javascript"
  }), AA = URL.createObjectURL(H);
  return workerBlobUrlCache.set(g, AA), AA;
}
function isSameOrigin(n) {
  return n.origin === window.location.origin;
}
function createWorker(n, t, g) {
  return t ? typeof window.SharedWorker < "u" ? new SharedWorker(n, g) : (console.warn("SharedWorker is not supported in this browser. Use the regular Worker instead."), new Worker(n, g)) : new Worker(n, g);
}
class CrossOriginWorkerMaker {
  worker;
  constructor(t, {
    shared: g,
    ...d
  }) {
    const k = isSameOrigin(t);
    if (k || t.protocol === "data:")
      console.debug(k ? `Loading a worker script from the same origin: ${t}` : "Loading a worker script from a data URL."), this.worker = createWorker(t, g, d);
    else {
      console.debug(`Loading a worker script from a different origin: ${t}`);
      const H = getWorkerBlobUrl(t, d.type === "module");
      this.worker = createWorker(H, g, d);
    }
  }
}
const LEADING_AND_TRAILING_SLASH_RE = new RegExp("^\\/+|(?<!\\/)\\/+$", "g");
function normalizeBasePath(n) {
  return n.replace(LEADING_AND_TRAILING_SLASH_RE, "");
}
function isPyodideConvertiblePrimitive(n) {
  return typeof n == "string" || typeof n == "number" || typeof n == "boolean" || n === null || n === void 0;
}
function isStreamlitConfig(n) {
  return typeof n == "object" && n != null && Object.entries(n).every(([t, g]) => typeof t == "string" && isPyodideConvertiblePrimitive(g));
}
function assertStreamlitConfig(n) {
  if (!isStreamlitConfig(n))
    throw new Error(`Invalid streamlitConfig: ${n}`);
}
const validateEnvKey = (n) => /^[A-Za-z_][A-Za-z0-9_]*$/.test(n);
function isSharedWorker(n) {
  return typeof window.SharedWorker < "u" && n instanceof SharedWorker;
}
class StliteKernel extends EventTarget {
  _isDisposed = !1;
  _worker;
  _postMessageTarget;
  _loaded = new PromiseDelegate$1();
  _workerInitData;
  basePath;
  // TODO: Move this prop to outside this class. This is not a member of the kernel business logic, but just a globally referred value.
  hostConfigResponse;
  // Will be passed to ConnectionManager to call `onHostConfigResp` from it.
  addEventListener(t, g, d) {
    super.addEventListener(t, g, d);
  }
  removeEventListener(t, g, d) {
    super.removeEventListener(t, g, d);
  }
  dispatchEvent(t) {
    return super.dispatchEvent(t);
  }
  constructor(t) {
    if (super(), this.basePath = normalizeBasePath(t.basePath ?? window.location.pathname), this.hostConfigResponse = t.hostConfigResponse ?? {}, t.worker)
      this._worker = t.worker;
    else {
      const g = new CrossOriginWorkerMaker(new URL(
        /* @vite-ignore */
        "" + new URL("assets/worker-BOuMG9lT.js", import.meta.url).href,
        import.meta.url
      ), {
        /* @vite-ignore */
        // To avoid the Vite error: "[vite:worker-import-meta-url] Vite is unable to parse the worker options as the value is not static.To ignore this error, please use /* @vite-ignore */ in the worker options."
        type: t.workerType,
        shared: t.sharedWorker ?? !1
      });
      this._worker = g.worker;
    }
    isSharedWorker(this._worker) ? (this._worker.port.start(), this._postMessageTarget = this._worker.port) : this._postMessageTarget = this._worker, this._postMessageTarget.onmessage = (g) => {
      this._processWorkerMessage(g.data, g.ports[0]);
    }, t.streamlitConfig != null && assertStreamlitConfig(t.streamlitConfig), this._workerInitData = {
      entrypoint: t.entrypoint,
      files: t.files,
      archives: t.archives,
      requirements: t.requirements,
      prebuiltPackageNames: t.prebuiltPackageNames,
      pyodideUrl: t.pyodideUrl,
      wheels: t.wheelUrls,
      streamlitConfig: t.streamlitConfig,
      idbfsMountpoints: t.idbfsMountpoints,
      moduleAutoLoad: t.moduleAutoLoad ?? !1,
      env: t.env,
      languageServer: t.languageServer ?? !1
    };
  }
  get loaded() {
    return this._loaded.promise;
  }
  connectWebSocket(t) {
    return this._asyncPostMessage({
      type: "websocket:connect",
      data: {
        path: t
      }
    }).then();
  }
  sendWebSocketMessage(t) {
    return this._asyncPostMessage({
      type: "websocket:send",
      data: {
        payload: t
      }
    }).then();
  }
  handleWebSocketMessage = null;
  onWebSocketMessage(t) {
    this.handleWebSocketMessage = t;
  }
  sendHttpRequest(t) {
    return this._asyncPostMessage({
      type: "http:request",
      data: {
        request: t
      }
    }, "http:response").then((g) => ({
      ...g.response,
      headers: new Headers(Object.fromEntries(g.response.headers))
    }));
  }
  writeFile(t, g, d) {
    const k = this._asyncPostMessage({
      type: "file:write",
      data: {
        path: t,
        data: g,
        opts: d
      }
    }).then(() => {
    });
    return this.dispatchEvent(new CustomEvent("writeFile", {
      detail: {
        path: t,
        promise: k
      }
    })), k;
  }
  renameFile(t, g) {
    const d = this._asyncPostMessage({
      type: "file:rename",
      data: {
        oldPath: t,
        newPath: g
      }
    }).then(() => {
    });
    return this.dispatchEvent(new CustomEvent("renameFile", {
      detail: {
        oldPath: t,
        newPath: g,
        promise: d
      }
    })), d;
  }
  readFile(t, g) {
    const d = this._asyncPostMessage({
      type: "file:read",
      data: {
        path: t,
        opts: g
      }
    }, "reply:file:read").then((k) => k.content);
    return this.dispatchEvent(new CustomEvent("readFile", {
      detail: {
        path: t,
        promise: d
      }
    })), d;
  }
  unlink(t) {
    return this._asyncPostMessage({
      type: "file:unlink",
      data: {
        path: t
      }
    }).then();
  }
  install(t, g) {
    const d = this._asyncPostMessage({
      type: "install",
      data: {
        requirements: t,
        options: g
      }
    }).then(() => {
    });
    return this.dispatchEvent(new CustomEvent("install", {
      detail: {
        requirements: t,
        promise: d
      }
    })), d;
  }
  setEnv(t) {
    return Object.keys(t).forEach((g) => {
      if (!validateEnvKey(g))
        throw new Error(`Invalid environment variable name: "${g}"`);
    }), this._asyncPostMessage({
      type: "setEnv",
      data: {
        env: t
      }
    }).then();
  }
  getCodeCompletion(t, g) {
    if (!this._workerInitData.languageServer)
      throw new Error("Language server not loaded, please set languageServer=true to use this method");
    return this._asyncPostMessage({
      type: "code_completion",
      data: {
        code: t,
        line: g.line,
        column: g.column
      }
    }, "reply:code_completion").then((d) => d.codeCompletions);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  runPython(t) {
    return this.loaded.then(() => this._asyncPostMessage({
      type: "run_python",
      data: {
        code: t
      }
    }, "reply:run_python")).then((g) => g.result);
  }
  /**
   * Reboot the Streamlit server.
   * Note that we also need to refresh (rerender) the frontend app after calling this method
   * to reflect the changes on the user-facing side.
   */
  reboot(t) {
    return this._asyncPostMessage({
      type: "reboot",
      data: {
        entrypoint: t
      }
    }).then();
  }
  _asyncPostMessage(t, g = "reply") {
    return new Promise((d, k) => {
      const H = new MessageChannel();
      H.port1.onmessage = (AA) => {
        H.port1.close();
        const gA = AA.data;
        if (gA.error)
          k(gA.error);
        else {
          if (gA.type !== g)
            throw new Error(`Unexpected reply type "${gA.type}"`);
          d(gA.data);
        }
      }, this._postMessageTarget.postMessage(t, [H.port2]);
    });
  }
  /**
   * Process a message coming from the pyodide web worker.
   *
   * @param msg The worker message to process.
   */
  _processWorkerMessage(t, g) {
    switch (t.type) {
      case "event:envSetup": {
        this._postMessageTarget.postMessage({
          type: "initData",
          data: this._workerInitData
        });
        break;
      }
      case "event:loadProgress": {
        this.dispatchEvent(new CustomEvent("loadProgress", {
          detail: t.data.message
        }));
        break;
      }
      case "event:loadError": {
        this.dispatchEvent(new CustomEvent("loadError", {
          detail: t.data.error
        }));
        break;
      }
      case "event:loadFinished": {
        this._loaded.resolve(), this.dispatchEvent(new Event("loadFinished"));
        break;
      }
      case "websocket:message": {
        const {
          payload: d
        } = t.data;
        this.handleWebSocketMessage?.(d);
        break;
      }
      case "event:moduleAutoLoad": {
        if (g == null)
          throw new Error("Port is required for moduleAutoLoad event");
        const d = new Promise((k, H) => {
          g.onmessage = (AA) => {
            const gA = AA.data;
            gA.type === "moduleAutoLoad:success" ? k(gA.data.loadedPackages) : H(gA.error), g.close();
          };
        });
        this.dispatchEvent(new CustomEvent("moduleAutoLoad", {
          detail: {
            packagesToLoad: t.data.packagesToLoad,
            promise: d
          }
        }));
        break;
      }
    }
  }
  /**
   * Return whether the kernel is disposed.
   */
  get isDisposed() {
    return this._isDisposed;
  }
  /**
   * Dispose the kernel.
   */
  dispose() {
    this.isDisposed || (isSharedWorker(this._worker) ? this._worker.port.close() : this._worker.terminate(), this._isDisposed = !0);
  }
}
const StliteKernelContext = React__default.createContext(void 0), Provider$2 = StliteKernelContext.Provider;
function StliteKernelProvider(n) {
  const {
    children: t,
    kernel: g
  } = n, d = useMemo$1(() => ({
    kernel: g
  }), [g]);
  return jsxRuntimeExports.jsx(Provider$2, {
    value: d,
    children: t
  });
}
function useStliteKernel() {
  const n = useContext(StliteKernelContext);
  if (n == null)
    throw new Error("useStliteKernel() must be inside <StliteKernelProvider />");
  return n.kernel;
}
var indexMinimal$1 = {}, minimal$3 = {}, aspromise$1, hasRequiredAspromise$1;
function requireAspromise$1() {
  if (hasRequiredAspromise$1) return aspromise$1;
  hasRequiredAspromise$1 = 1, aspromise$1 = n;
  function n(t, g) {
    for (var d = new Array(arguments.length - 1), k = 0, H = 2, AA = !0; H < arguments.length; )
      d[k++] = arguments[H++];
    return new Promise(function(IA, CA) {
      d[k] = function(eA) {
        if (AA)
          if (AA = !1, eA)
            CA(eA);
          else {
            for (var iA = new Array(arguments.length - 1), QA = 0; QA < iA.length; )
              iA[QA++] = arguments[QA];
            IA.apply(null, iA);
          }
      };
      try {
        t.apply(g || null, d);
      } catch (BA) {
        AA && (AA = !1, CA(BA));
      }
    });
  }
  return aspromise$1;
}
var base64$1 = {}, hasRequiredBase64$1;
function requireBase64$1() {
  return hasRequiredBase64$1 || (hasRequiredBase64$1 = 1, (function(n) {
    var t = n;
    t.length = function(gA) {
      var IA = gA.length;
      if (!IA)
        return 0;
      for (var CA = 0; --IA % 4 > 1 && gA.charAt(IA) === "="; )
        ++CA;
      return Math.ceil(gA.length * 3) / 4 - CA;
    };
    for (var g = new Array(64), d = new Array(123), k = 0; k < 64; )
      d[g[k] = k < 26 ? k + 65 : k < 52 ? k + 71 : k < 62 ? k - 4 : k - 59 | 43] = k++;
    t.encode = function(gA, IA, CA) {
      for (var BA = null, eA = [], iA = 0, QA = 0, tA; IA < CA; ) {
        var oA = gA[IA++];
        switch (QA) {
          case 0:
            eA[iA++] = g[oA >> 2], tA = (oA & 3) << 4, QA = 1;
            break;
          case 1:
            eA[iA++] = g[tA | oA >> 4], tA = (oA & 15) << 2, QA = 2;
            break;
          case 2:
            eA[iA++] = g[tA | oA >> 6], eA[iA++] = g[oA & 63], QA = 0;
            break;
        }
        iA > 8191 && ((BA || (BA = [])).push(String.fromCharCode.apply(String, eA)), iA = 0);
      }
      return QA && (eA[iA++] = g[tA], eA[iA++] = 61, QA === 1 && (eA[iA++] = 61)), BA ? (iA && BA.push(String.fromCharCode.apply(String, eA.slice(0, iA))), BA.join("")) : String.fromCharCode.apply(String, eA.slice(0, iA));
    };
    var H = "invalid encoding";
    t.decode = function(gA, IA, CA) {
      for (var BA = CA, eA = 0, iA, QA = 0; QA < gA.length; ) {
        var tA = gA.charCodeAt(QA++);
        if (tA === 61 && eA > 1)
          break;
        if ((tA = d[tA]) === void 0)
          throw Error(H);
        switch (eA) {
          case 0:
            iA = tA, eA = 1;
            break;
          case 1:
            IA[CA++] = iA << 2 | (tA & 48) >> 4, iA = tA, eA = 2;
            break;
          case 2:
            IA[CA++] = (iA & 15) << 4 | (tA & 60) >> 2, iA = tA, eA = 3;
            break;
          case 3:
            IA[CA++] = (iA & 3) << 6 | tA, eA = 0;
            break;
        }
      }
      if (eA === 1)
        throw Error(H);
      return CA - BA;
    }, t.test = function(gA) {
      return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(gA);
    };
  })(base64$1)), base64$1;
}
var eventemitter$1, hasRequiredEventemitter$1;
function requireEventemitter$1() {
  if (hasRequiredEventemitter$1) return eventemitter$1;
  hasRequiredEventemitter$1 = 1, eventemitter$1 = n;
  function n() {
    this._listeners = {};
  }
  return n.prototype.on = function(g, d, k) {
    return (this._listeners[g] || (this._listeners[g] = [])).push({
      fn: d,
      ctx: k || this
    }), this;
  }, n.prototype.off = function(g, d) {
    if (g === void 0)
      this._listeners = {};
    else if (d === void 0)
      this._listeners[g] = [];
    else
      for (var k = this._listeners[g], H = 0; H < k.length; )
        k[H].fn === d ? k.splice(H, 1) : ++H;
    return this;
  }, n.prototype.emit = function(g) {
    var d = this._listeners[g];
    if (d) {
      for (var k = [], H = 1; H < arguments.length; )
        k.push(arguments[H++]);
      for (H = 0; H < d.length; )
        d[H].fn.apply(d[H++].ctx, k);
    }
    return this;
  }, eventemitter$1;
}
var float$1, hasRequiredFloat$1;
function requireFloat$1() {
  if (hasRequiredFloat$1) return float$1;
  hasRequiredFloat$1 = 1, float$1 = n(n);
  function n(H) {
    return typeof Float32Array < "u" ? (function() {
      var AA = new Float32Array([-0]), gA = new Uint8Array(AA.buffer), IA = gA[3] === 128;
      function CA(QA, tA, oA) {
        AA[0] = QA, tA[oA] = gA[0], tA[oA + 1] = gA[1], tA[oA + 2] = gA[2], tA[oA + 3] = gA[3];
      }
      function BA(QA, tA, oA) {
        AA[0] = QA, tA[oA] = gA[3], tA[oA + 1] = gA[2], tA[oA + 2] = gA[1], tA[oA + 3] = gA[0];
      }
      H.writeFloatLE = IA ? CA : BA, H.writeFloatBE = IA ? BA : CA;
      function eA(QA, tA) {
        return gA[0] = QA[tA], gA[1] = QA[tA + 1], gA[2] = QA[tA + 2], gA[3] = QA[tA + 3], AA[0];
      }
      function iA(QA, tA) {
        return gA[3] = QA[tA], gA[2] = QA[tA + 1], gA[1] = QA[tA + 2], gA[0] = QA[tA + 3], AA[0];
      }
      H.readFloatLE = IA ? eA : iA, H.readFloatBE = IA ? iA : eA;
    })() : (function() {
      function AA(IA, CA, BA, eA) {
        var iA = CA < 0 ? 1 : 0;
        if (iA && (CA = -CA), CA === 0)
          IA(1 / CA > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), BA, eA);
        else if (isNaN(CA))
          IA(2143289344, BA, eA);
        else if (CA > 34028234663852886e22)
          IA((iA << 31 | 2139095040) >>> 0, BA, eA);
        else if (CA < 11754943508222875e-54)
          IA((iA << 31 | Math.round(CA / 1401298464324817e-60)) >>> 0, BA, eA);
        else {
          var QA = Math.floor(Math.log(CA) / Math.LN2), tA = Math.round(CA * Math.pow(2, -QA) * 8388608) & 8388607;
          IA((iA << 31 | QA + 127 << 23 | tA) >>> 0, BA, eA);
        }
      }
      H.writeFloatLE = AA.bind(null, t), H.writeFloatBE = AA.bind(null, g);
      function gA(IA, CA, BA) {
        var eA = IA(CA, BA), iA = (eA >> 31) * 2 + 1, QA = eA >>> 23 & 255, tA = eA & 8388607;
        return QA === 255 ? tA ? NaN : iA * (1 / 0) : QA === 0 ? iA * 1401298464324817e-60 * tA : iA * Math.pow(2, QA - 150) * (tA + 8388608);
      }
      H.readFloatLE = gA.bind(null, d), H.readFloatBE = gA.bind(null, k);
    })(), typeof Float64Array < "u" ? (function() {
      var AA = new Float64Array([-0]), gA = new Uint8Array(AA.buffer), IA = gA[7] === 128;
      function CA(QA, tA, oA) {
        AA[0] = QA, tA[oA] = gA[0], tA[oA + 1] = gA[1], tA[oA + 2] = gA[2], tA[oA + 3] = gA[3], tA[oA + 4] = gA[4], tA[oA + 5] = gA[5], tA[oA + 6] = gA[6], tA[oA + 7] = gA[7];
      }
      function BA(QA, tA, oA) {
        AA[0] = QA, tA[oA] = gA[7], tA[oA + 1] = gA[6], tA[oA + 2] = gA[5], tA[oA + 3] = gA[4], tA[oA + 4] = gA[3], tA[oA + 5] = gA[2], tA[oA + 6] = gA[1], tA[oA + 7] = gA[0];
      }
      H.writeDoubleLE = IA ? CA : BA, H.writeDoubleBE = IA ? BA : CA;
      function eA(QA, tA) {
        return gA[0] = QA[tA], gA[1] = QA[tA + 1], gA[2] = QA[tA + 2], gA[3] = QA[tA + 3], gA[4] = QA[tA + 4], gA[5] = QA[tA + 5], gA[6] = QA[tA + 6], gA[7] = QA[tA + 7], AA[0];
      }
      function iA(QA, tA) {
        return gA[7] = QA[tA], gA[6] = QA[tA + 1], gA[5] = QA[tA + 2], gA[4] = QA[tA + 3], gA[3] = QA[tA + 4], gA[2] = QA[tA + 5], gA[1] = QA[tA + 6], gA[0] = QA[tA + 7], AA[0];
      }
      H.readDoubleLE = IA ? eA : iA, H.readDoubleBE = IA ? iA : eA;
    })() : (function() {
      function AA(IA, CA, BA, eA, iA, QA) {
        var tA = eA < 0 ? 1 : 0;
        if (tA && (eA = -eA), eA === 0)
          IA(0, iA, QA + CA), IA(1 / eA > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), iA, QA + BA);
        else if (isNaN(eA))
          IA(0, iA, QA + CA), IA(2146959360, iA, QA + BA);
        else if (eA > 17976931348623157e292)
          IA(0, iA, QA + CA), IA((tA << 31 | 2146435072) >>> 0, iA, QA + BA);
        else {
          var oA;
          if (eA < 22250738585072014e-324)
            oA = eA / 5e-324, IA(oA >>> 0, iA, QA + CA), IA((tA << 31 | oA / 4294967296) >>> 0, iA, QA + BA);
          else {
            var EA = Math.floor(Math.log(eA) / Math.LN2);
            EA === 1024 && (EA = 1023), oA = eA * Math.pow(2, -EA), IA(oA * 4503599627370496 >>> 0, iA, QA + CA), IA((tA << 31 | EA + 1023 << 20 | oA * 1048576 & 1048575) >>> 0, iA, QA + BA);
          }
        }
      }
      H.writeDoubleLE = AA.bind(null, t, 0, 4), H.writeDoubleBE = AA.bind(null, g, 4, 0);
      function gA(IA, CA, BA, eA, iA) {
        var QA = IA(eA, iA + CA), tA = IA(eA, iA + BA), oA = (tA >> 31) * 2 + 1, EA = tA >>> 20 & 2047, aA = 4294967296 * (tA & 1048575) + QA;
        return EA === 2047 ? aA ? NaN : oA * (1 / 0) : EA === 0 ? oA * 5e-324 * aA : oA * Math.pow(2, EA - 1075) * (aA + 4503599627370496);
      }
      H.readDoubleLE = gA.bind(null, d, 0, 4), H.readDoubleBE = gA.bind(null, k, 4, 0);
    })(), H;
  }
  function t(H, AA, gA) {
    AA[gA] = H & 255, AA[gA + 1] = H >>> 8 & 255, AA[gA + 2] = H >>> 16 & 255, AA[gA + 3] = H >>> 24;
  }
  function g(H, AA, gA) {
    AA[gA] = H >>> 24, AA[gA + 1] = H >>> 16 & 255, AA[gA + 2] = H >>> 8 & 255, AA[gA + 3] = H & 255;
  }
  function d(H, AA) {
    return (H[AA] | H[AA + 1] << 8 | H[AA + 2] << 16 | H[AA + 3] << 24) >>> 0;
  }
  function k(H, AA) {
    return (H[AA] << 24 | H[AA + 1] << 16 | H[AA + 2] << 8 | H[AA + 3]) >>> 0;
  }
  return float$1;
}
var inquire_1$1, hasRequiredInquire$1;
function requireInquire$1() {
  if (hasRequiredInquire$1) return inquire_1$1;
  hasRequiredInquire$1 = 1, inquire_1$1 = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length))
        return mod;
    } catch (n) {
    }
    return null;
  }
  return inquire_1$1;
}
var utf8$1 = {}, hasRequiredUtf8$1;
function requireUtf8$1() {
  return hasRequiredUtf8$1 || (hasRequiredUtf8$1 = 1, (function(n) {
    var t = n;
    t.length = function(d) {
      for (var k = 0, H = 0, AA = 0; AA < d.length; ++AA)
        H = d.charCodeAt(AA), H < 128 ? k += 1 : H < 2048 ? k += 2 : (H & 64512) === 55296 && (d.charCodeAt(AA + 1) & 64512) === 56320 ? (++AA, k += 4) : k += 3;
      return k;
    }, t.read = function(d, k, H) {
      var AA = H - k;
      if (AA < 1)
        return "";
      for (var gA = null, IA = [], CA = 0, BA; k < H; )
        BA = d[k++], BA < 128 ? IA[CA++] = BA : BA > 191 && BA < 224 ? IA[CA++] = (BA & 31) << 6 | d[k++] & 63 : BA > 239 && BA < 365 ? (BA = ((BA & 7) << 18 | (d[k++] & 63) << 12 | (d[k++] & 63) << 6 | d[k++] & 63) - 65536, IA[CA++] = 55296 + (BA >> 10), IA[CA++] = 56320 + (BA & 1023)) : IA[CA++] = (BA & 15) << 12 | (d[k++] & 63) << 6 | d[k++] & 63, CA > 8191 && ((gA || (gA = [])).push(String.fromCharCode.apply(String, IA)), CA = 0);
      return gA ? (CA && gA.push(String.fromCharCode.apply(String, IA.slice(0, CA))), gA.join("")) : String.fromCharCode.apply(String, IA.slice(0, CA));
    }, t.write = function(d, k, H) {
      for (var AA = H, gA, IA, CA = 0; CA < d.length; ++CA)
        gA = d.charCodeAt(CA), gA < 128 ? k[H++] = gA : gA < 2048 ? (k[H++] = gA >> 6 | 192, k[H++] = gA & 63 | 128) : (gA & 64512) === 55296 && ((IA = d.charCodeAt(CA + 1)) & 64512) === 56320 ? (gA = 65536 + ((gA & 1023) << 10) + (IA & 1023), ++CA, k[H++] = gA >> 18 | 240, k[H++] = gA >> 12 & 63 | 128, k[H++] = gA >> 6 & 63 | 128, k[H++] = gA & 63 | 128) : (k[H++] = gA >> 12 | 224, k[H++] = gA >> 6 & 63 | 128, k[H++] = gA & 63 | 128);
      return H - AA;
    };
  })(utf8$1)), utf8$1;
}
var pool_1$1, hasRequiredPool$1;
function requirePool$1() {
  if (hasRequiredPool$1) return pool_1$1;
  hasRequiredPool$1 = 1, pool_1$1 = n;
  function n(t, g, d) {
    var k = d || 8192, H = k >>> 1, AA = null, gA = k;
    return function(CA) {
      if (CA < 1 || CA > H)
        return t(CA);
      gA + CA > k && (AA = t(k), gA = 0);
      var BA = g.call(AA, gA, gA += CA);
      return gA & 7 && (gA = (gA | 7) + 1), BA;
    };
  }
  return pool_1$1;
}
var longbits$1, hasRequiredLongbits$1;
function requireLongbits$1() {
  if (hasRequiredLongbits$1) return longbits$1;
  hasRequiredLongbits$1 = 1, longbits$1 = t;
  var n = requireMinimal$3();
  function t(H, AA) {
    this.lo = H >>> 0, this.hi = AA >>> 0;
  }
  var g = t.zero = new t(0, 0);
  g.toNumber = function() {
    return 0;
  }, g.zzEncode = g.zzDecode = function() {
    return this;
  }, g.length = function() {
    return 1;
  };
  var d = t.zeroHash = "\0\0\0\0\0\0\0\0";
  t.fromNumber = function(AA) {
    if (AA === 0)
      return g;
    var gA = AA < 0;
    gA && (AA = -AA);
    var IA = AA >>> 0, CA = (AA - IA) / 4294967296 >>> 0;
    return gA && (CA = ~CA >>> 0, IA = ~IA >>> 0, ++IA > 4294967295 && (IA = 0, ++CA > 4294967295 && (CA = 0))), new t(IA, CA);
  }, t.from = function(AA) {
    if (typeof AA == "number")
      return t.fromNumber(AA);
    if (n.isString(AA))
      if (n.Long)
        AA = n.Long.fromString(AA);
      else
        return t.fromNumber(parseInt(AA, 10));
    return AA.low || AA.high ? new t(AA.low >>> 0, AA.high >>> 0) : g;
  }, t.prototype.toNumber = function(AA) {
    if (!AA && this.hi >>> 31) {
      var gA = ~this.lo + 1 >>> 0, IA = ~this.hi >>> 0;
      return gA || (IA = IA + 1 >>> 0), -(gA + IA * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, t.prototype.toLong = function(AA) {
    return n.Long ? new n.Long(this.lo | 0, this.hi | 0, !!AA) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!AA };
  };
  var k = String.prototype.charCodeAt;
  return t.fromHash = function(AA) {
    return AA === d ? g : new t(
      (k.call(AA, 0) | k.call(AA, 1) << 8 | k.call(AA, 2) << 16 | k.call(AA, 3) << 24) >>> 0,
      (k.call(AA, 4) | k.call(AA, 5) << 8 | k.call(AA, 6) << 16 | k.call(AA, 7) << 24) >>> 0
    );
  }, t.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, t.prototype.zzEncode = function() {
    var AA = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ AA) >>> 0, this.lo = (this.lo << 1 ^ AA) >>> 0, this;
  }, t.prototype.zzDecode = function() {
    var AA = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ AA) >>> 0, this.hi = (this.hi >>> 1 ^ AA) >>> 0, this;
  }, t.prototype.length = function() {
    var AA = this.lo, gA = (this.lo >>> 28 | this.hi << 4) >>> 0, IA = this.hi >>> 24;
    return IA === 0 ? gA === 0 ? AA < 16384 ? AA < 128 ? 1 : 2 : AA < 2097152 ? 3 : 4 : gA < 16384 ? gA < 128 ? 5 : 6 : gA < 2097152 ? 7 : 8 : IA < 128 ? 9 : 10;
  }, longbits$1;
}
var hasRequiredMinimal$3;
function requireMinimal$3() {
  return hasRequiredMinimal$3 || (hasRequiredMinimal$3 = 1, (function(n) {
    var t = n;
    t.asPromise = requireAspromise$1(), t.base64 = requireBase64$1(), t.EventEmitter = requireEventemitter$1(), t.float = requireFloat$1(), t.inquire = requireInquire$1(), t.utf8 = requireUtf8$1(), t.pool = requirePool$1(), t.LongBits = requireLongbits$1(), t.isNode = !!(typeof commonjsGlobal$2 < "u" && commonjsGlobal$2 && commonjsGlobal$2.process && commonjsGlobal$2.process.versions && commonjsGlobal$2.process.versions.node), t.global = t.isNode && commonjsGlobal$2 || typeof window < "u" && window || typeof self < "u" && self || minimal$3, t.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), t.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), t.isInteger = Number.isInteger || /* istanbul ignore next */
    function(H) {
      return typeof H == "number" && isFinite(H) && Math.floor(H) === H;
    }, t.isString = function(H) {
      return typeof H == "string" || H instanceof String;
    }, t.isObject = function(H) {
      return H && typeof H == "object";
    }, t.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    t.isSet = function(H, AA) {
      var gA = H[AA];
      return gA != null && H.hasOwnProperty(AA) ? typeof gA != "object" || (Array.isArray(gA) ? gA.length : Object.keys(gA).length) > 0 : !1;
    }, t.Buffer = (function() {
      try {
        var k = t.inquire("buffer").Buffer;
        return k.prototype.utf8Write ? k : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    })(), t._Buffer_from = null, t._Buffer_allocUnsafe = null, t.newBuffer = function(H) {
      return typeof H == "number" ? t.Buffer ? t._Buffer_allocUnsafe(H) : new t.Array(H) : t.Buffer ? t._Buffer_from(H) : typeof Uint8Array > "u" ? H : new Uint8Array(H);
    }, t.Array = typeof Uint8Array < "u" ? Uint8Array : Array, t.Long = /* istanbul ignore next */
    t.global.dcodeIO && /* istanbul ignore next */
    t.global.dcodeIO.Long || /* istanbul ignore next */
    t.global.Long || t.inquire("long"), t.key2Re = /^true|false|0|1$/, t.key32Re = /^-?(?:0|[1-9][0-9]*)$/, t.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, t.longToHash = function(H) {
      return H ? t.LongBits.from(H).toHash() : t.LongBits.zeroHash;
    }, t.longFromHash = function(H, AA) {
      var gA = t.LongBits.fromHash(H);
      return t.Long ? t.Long.fromBits(gA.lo, gA.hi, AA) : gA.toNumber(!!AA);
    };
    function g(k, H, AA) {
      for (var gA = Object.keys(H), IA = 0; IA < gA.length; ++IA)
        (k[gA[IA]] === void 0 || !AA) && (k[gA[IA]] = H[gA[IA]]);
      return k;
    }
    t.merge = g, t.lcFirst = function(H) {
      return H.charAt(0).toLowerCase() + H.substring(1);
    };
    function d(k) {
      function H(AA, gA) {
        if (!(this instanceof H))
          return new H(AA, gA);
        Object.defineProperty(this, "message", { get: function() {
          return AA;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, H) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), gA && g(this, gA);
      }
      return H.prototype = Object.create(Error.prototype, {
        constructor: {
          value: H,
          writable: !0,
          enumerable: !1,
          configurable: !0
        },
        name: {
          get: function() {
            return k;
          },
          set: void 0,
          enumerable: !1,
          // configurable: false would accurately preserve the behavior of
          // the original, but I'm guessing that was not intentional.
          // For an actual error subclass, this property would
          // be configurable.
          configurable: !0
        },
        toString: {
          value: function() {
            return this.name + ": " + this.message;
          },
          writable: !0,
          enumerable: !1,
          configurable: !0
        }
      }), H;
    }
    t.newError = d, t.ProtocolError = d("ProtocolError"), t.oneOfGetter = function(H) {
      for (var AA = {}, gA = 0; gA < H.length; ++gA)
        AA[H[gA]] = 1;
      return function() {
        for (var IA = Object.keys(this), CA = IA.length - 1; CA > -1; --CA)
          if (AA[IA[CA]] === 1 && this[IA[CA]] !== void 0 && this[IA[CA]] !== null)
            return IA[CA];
      };
    }, t.oneOfSetter = function(H) {
      return function(AA) {
        for (var gA = 0; gA < H.length; ++gA)
          H[gA] !== AA && delete this[H[gA]];
      };
    }, t.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, t._configure = function() {
      var k = t.Buffer;
      if (!k) {
        t._Buffer_from = t._Buffer_allocUnsafe = null;
        return;
      }
      t._Buffer_from = k.from !== Uint8Array.from && k.from || /* istanbul ignore next */
      function(AA, gA) {
        return new k(AA, gA);
      }, t._Buffer_allocUnsafe = k.allocUnsafe || /* istanbul ignore next */
      function(AA) {
        return new k(AA);
      };
    };
  })(minimal$3)), minimal$3;
}
var writer$1, hasRequiredWriter$1;
function requireWriter$1() {
  if (hasRequiredWriter$1) return writer$1;
  hasRequiredWriter$1 = 1, writer$1 = IA;
  var n = requireMinimal$3(), t, g = n.LongBits, d = n.base64, k = n.utf8;
  function H(EA, aA, nA) {
    this.fn = EA, this.len = aA, this.next = void 0, this.val = nA;
  }
  function AA() {
  }
  function gA(EA) {
    this.head = EA.head, this.tail = EA.tail, this.len = EA.len, this.next = EA.states;
  }
  function IA() {
    this.len = 0, this.head = new H(AA, 0, 0), this.tail = this.head, this.states = null;
  }
  var CA = function() {
    return n.Buffer ? function() {
      return (IA.create = function() {
        return new t();
      })();
    } : function() {
      return new IA();
    };
  };
  IA.create = CA(), IA.alloc = function(aA) {
    return new n.Array(aA);
  }, n.Array !== Array && (IA.alloc = n.pool(IA.alloc, n.Array.prototype.subarray)), IA.prototype._push = function(aA, nA, lA) {
    return this.tail = this.tail.next = new H(aA, nA, lA), this.len += nA, this;
  };
  function BA(EA, aA, nA) {
    aA[nA] = EA & 255;
  }
  function eA(EA, aA, nA) {
    for (; EA > 127; )
      aA[nA++] = EA & 127 | 128, EA >>>= 7;
    aA[nA] = EA;
  }
  function iA(EA, aA) {
    this.len = EA, this.next = void 0, this.val = aA;
  }
  iA.prototype = Object.create(H.prototype), iA.prototype.fn = eA, IA.prototype.uint32 = function(aA) {
    return this.len += (this.tail = this.tail.next = new iA(
      (aA = aA >>> 0) < 128 ? 1 : aA < 16384 ? 2 : aA < 2097152 ? 3 : aA < 268435456 ? 4 : 5,
      aA
    )).len, this;
  }, IA.prototype.int32 = function(aA) {
    return aA < 0 ? this._push(QA, 10, g.fromNumber(aA)) : this.uint32(aA);
  }, IA.prototype.sint32 = function(aA) {
    return this.uint32((aA << 1 ^ aA >> 31) >>> 0);
  };
  function QA(EA, aA, nA) {
    for (; EA.hi; )
      aA[nA++] = EA.lo & 127 | 128, EA.lo = (EA.lo >>> 7 | EA.hi << 25) >>> 0, EA.hi >>>= 7;
    for (; EA.lo > 127; )
      aA[nA++] = EA.lo & 127 | 128, EA.lo = EA.lo >>> 7;
    aA[nA++] = EA.lo;
  }
  IA.prototype.uint64 = function(aA) {
    var nA = g.from(aA);
    return this._push(QA, nA.length(), nA);
  }, IA.prototype.int64 = IA.prototype.uint64, IA.prototype.sint64 = function(aA) {
    var nA = g.from(aA).zzEncode();
    return this._push(QA, nA.length(), nA);
  }, IA.prototype.bool = function(aA) {
    return this._push(BA, 1, aA ? 1 : 0);
  };
  function tA(EA, aA, nA) {
    aA[nA] = EA & 255, aA[nA + 1] = EA >>> 8 & 255, aA[nA + 2] = EA >>> 16 & 255, aA[nA + 3] = EA >>> 24;
  }
  IA.prototype.fixed32 = function(aA) {
    return this._push(tA, 4, aA >>> 0);
  }, IA.prototype.sfixed32 = IA.prototype.fixed32, IA.prototype.fixed64 = function(aA) {
    var nA = g.from(aA);
    return this._push(tA, 4, nA.lo)._push(tA, 4, nA.hi);
  }, IA.prototype.sfixed64 = IA.prototype.fixed64, IA.prototype.float = function(aA) {
    return this._push(n.float.writeFloatLE, 4, aA);
  }, IA.prototype.double = function(aA) {
    return this._push(n.float.writeDoubleLE, 8, aA);
  };
  var oA = n.Array.prototype.set ? function(aA, nA, lA) {
    nA.set(aA, lA);
  } : function(aA, nA, lA) {
    for (var cA = 0; cA < aA.length; ++cA)
      nA[lA + cA] = aA[cA];
  };
  return IA.prototype.bytes = function(aA) {
    var nA = aA.length >>> 0;
    if (!nA)
      return this._push(BA, 1, 0);
    if (n.isString(aA)) {
      var lA = IA.alloc(nA = d.length(aA));
      d.decode(aA, lA, 0), aA = lA;
    }
    return this.uint32(nA)._push(oA, nA, aA);
  }, IA.prototype.string = function(aA) {
    var nA = k.length(aA);
    return nA ? this.uint32(nA)._push(k.write, nA, aA) : this._push(BA, 1, 0);
  }, IA.prototype.fork = function() {
    return this.states = new gA(this), this.head = this.tail = new H(AA, 0, 0), this.len = 0, this;
  }, IA.prototype.reset = function() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new H(AA, 0, 0), this.len = 0), this;
  }, IA.prototype.ldelim = function() {
    var aA = this.head, nA = this.tail, lA = this.len;
    return this.reset().uint32(lA), lA && (this.tail.next = aA.next, this.tail = nA, this.len += lA), this;
  }, IA.prototype.finish = function() {
    for (var aA = this.head.next, nA = this.constructor.alloc(this.len), lA = 0; aA; )
      aA.fn(aA.val, nA, lA), lA += aA.len, aA = aA.next;
    return nA;
  }, IA._configure = function(EA) {
    t = EA, IA.create = CA(), t._configure();
  }, writer$1;
}
var writer_buffer$1, hasRequiredWriter_buffer$1;
function requireWriter_buffer$1() {
  if (hasRequiredWriter_buffer$1) return writer_buffer$1;
  hasRequiredWriter_buffer$1 = 1, writer_buffer$1 = g;
  var n = requireWriter$1();
  (g.prototype = Object.create(n.prototype)).constructor = g;
  var t = requireMinimal$3();
  function g() {
    n.call(this);
  }
  g._configure = function() {
    g.alloc = t._Buffer_allocUnsafe, g.writeBytesBuffer = t.Buffer && t.Buffer.prototype instanceof Uint8Array && t.Buffer.prototype.set.name === "set" ? function(H, AA, gA) {
      AA.set(H, gA);
    } : function(H, AA, gA) {
      if (H.copy)
        H.copy(AA, gA, 0, H.length);
      else for (var IA = 0; IA < H.length; )
        AA[gA++] = H[IA++];
    };
  }, g.prototype.bytes = function(H) {
    t.isString(H) && (H = t._Buffer_from(H, "base64"));
    var AA = H.length >>> 0;
    return this.uint32(AA), AA && this._push(g.writeBytesBuffer, AA, H), this;
  };
  function d(k, H, AA) {
    k.length < 40 ? t.utf8.write(k, H, AA) : H.utf8Write ? H.utf8Write(k, AA) : H.write(k, AA);
  }
  return g.prototype.string = function(H) {
    var AA = t.Buffer.byteLength(H);
    return this.uint32(AA), AA && this._push(d, AA, H), this;
  }, g._configure(), writer_buffer$1;
}
var reader$1, hasRequiredReader$1;
function requireReader$1() {
  if (hasRequiredReader$1) return reader$1;
  hasRequiredReader$1 = 1, reader$1 = H;
  var n = requireMinimal$3(), t, g = n.LongBits, d = n.utf8;
  function k(eA, iA) {
    return RangeError("index out of range: " + eA.pos + " + " + (iA || 1) + " > " + eA.len);
  }
  function H(eA) {
    this.buf = eA, this.pos = 0, this.len = eA.length;
  }
  var AA = typeof Uint8Array < "u" ? function(iA) {
    if (iA instanceof Uint8Array || Array.isArray(iA))
      return new H(iA);
    throw Error("illegal buffer");
  } : function(iA) {
    if (Array.isArray(iA))
      return new H(iA);
    throw Error("illegal buffer");
  }, gA = function() {
    return n.Buffer ? function(QA) {
      return (H.create = function(oA) {
        return n.Buffer.isBuffer(oA) ? new t(oA) : AA(oA);
      })(QA);
    } : AA;
  };
  H.create = gA(), H.prototype._slice = n.Array.prototype.subarray || /* istanbul ignore next */
  n.Array.prototype.slice, H.prototype.uint32 = /* @__PURE__ */ (function() {
    var iA = 4294967295;
    return function() {
      if (iA = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (iA = (iA | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (iA = (iA | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (iA = (iA | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (iA = (iA | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128)) return iA;
      if ((this.pos += 5) > this.len)
        throw this.pos = this.len, k(this, 10);
      return iA;
    };
  })(), H.prototype.int32 = function() {
    return this.uint32() | 0;
  }, H.prototype.sint32 = function() {
    var iA = this.uint32();
    return iA >>> 1 ^ -(iA & 1) | 0;
  };
  function IA() {
    var eA = new g(0, 0), iA = 0;
    if (this.len - this.pos > 4) {
      for (; iA < 4; ++iA)
        if (eA.lo = (eA.lo | (this.buf[this.pos] & 127) << iA * 7) >>> 0, this.buf[this.pos++] < 128)
          return eA;
      if (eA.lo = (eA.lo | (this.buf[this.pos] & 127) << 28) >>> 0, eA.hi = (eA.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
        return eA;
      iA = 0;
    } else {
      for (; iA < 3; ++iA) {
        if (this.pos >= this.len)
          throw k(this);
        if (eA.lo = (eA.lo | (this.buf[this.pos] & 127) << iA * 7) >>> 0, this.buf[this.pos++] < 128)
          return eA;
      }
      return eA.lo = (eA.lo | (this.buf[this.pos++] & 127) << iA * 7) >>> 0, eA;
    }
    if (this.len - this.pos > 4) {
      for (; iA < 5; ++iA)
        if (eA.hi = (eA.hi | (this.buf[this.pos] & 127) << iA * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return eA;
    } else
      for (; iA < 5; ++iA) {
        if (this.pos >= this.len)
          throw k(this);
        if (eA.hi = (eA.hi | (this.buf[this.pos] & 127) << iA * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return eA;
      }
    throw Error("invalid varint encoding");
  }
  H.prototype.bool = function() {
    return this.uint32() !== 0;
  };
  function CA(eA, iA) {
    return (eA[iA - 4] | eA[iA - 3] << 8 | eA[iA - 2] << 16 | eA[iA - 1] << 24) >>> 0;
  }
  H.prototype.fixed32 = function() {
    if (this.pos + 4 > this.len)
      throw k(this, 4);
    return CA(this.buf, this.pos += 4);
  }, H.prototype.sfixed32 = function() {
    if (this.pos + 4 > this.len)
      throw k(this, 4);
    return CA(this.buf, this.pos += 4) | 0;
  };
  function BA() {
    if (this.pos + 8 > this.len)
      throw k(this, 8);
    return new g(CA(this.buf, this.pos += 4), CA(this.buf, this.pos += 4));
  }
  return H.prototype.float = function() {
    if (this.pos + 4 > this.len)
      throw k(this, 4);
    var iA = n.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, iA;
  }, H.prototype.double = function() {
    if (this.pos + 8 > this.len)
      throw k(this, 4);
    var iA = n.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, iA;
  }, H.prototype.bytes = function() {
    var iA = this.uint32(), QA = this.pos, tA = this.pos + iA;
    if (tA > this.len)
      throw k(this, iA);
    if (this.pos += iA, Array.isArray(this.buf))
      return this.buf.slice(QA, tA);
    if (QA === tA) {
      var oA = n.Buffer;
      return oA ? oA.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, QA, tA);
  }, H.prototype.string = function() {
    var iA = this.bytes();
    return d.read(iA, 0, iA.length);
  }, H.prototype.skip = function(iA) {
    if (typeof iA == "number") {
      if (this.pos + iA > this.len)
        throw k(this, iA);
      this.pos += iA;
    } else
      do
        if (this.pos >= this.len)
          throw k(this);
      while (this.buf[this.pos++] & 128);
    return this;
  }, H.prototype.skipType = function(eA) {
    switch (eA) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (eA = this.uint32() & 7) !== 4; )
          this.skipType(eA);
        break;
      case 5:
        this.skip(4);
        break;
      /* istanbul ignore next */
      default:
        throw Error("invalid wire type " + eA + " at offset " + this.pos);
    }
    return this;
  }, H._configure = function(eA) {
    t = eA, H.create = gA(), t._configure();
    var iA = n.Long ? "toLong" : (
      /* istanbul ignore next */
      "toNumber"
    );
    n.merge(H.prototype, {
      int64: function() {
        return IA.call(this)[iA](!1);
      },
      uint64: function() {
        return IA.call(this)[iA](!0);
      },
      sint64: function() {
        return IA.call(this).zzDecode()[iA](!1);
      },
      fixed64: function() {
        return BA.call(this)[iA](!0);
      },
      sfixed64: function() {
        return BA.call(this)[iA](!1);
      }
    });
  }, reader$1;
}
var reader_buffer$1, hasRequiredReader_buffer$1;
function requireReader_buffer$1() {
  if (hasRequiredReader_buffer$1) return reader_buffer$1;
  hasRequiredReader_buffer$1 = 1, reader_buffer$1 = g;
  var n = requireReader$1();
  (g.prototype = Object.create(n.prototype)).constructor = g;
  var t = requireMinimal$3();
  function g(d) {
    n.call(this, d);
  }
  return g._configure = function() {
    t.Buffer && (g.prototype._slice = t.Buffer.prototype.slice);
  }, g.prototype.string = function() {
    var k = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + k, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + k, this.len));
  }, g._configure(), reader_buffer$1;
}
var rpc$1 = {}, service$2, hasRequiredService$2;
function requireService$2() {
  if (hasRequiredService$2) return service$2;
  hasRequiredService$2 = 1, service$2 = t;
  var n = requireMinimal$3();
  (t.prototype = Object.create(n.EventEmitter.prototype)).constructor = t;
  function t(g, d, k) {
    if (typeof g != "function")
      throw TypeError("rpcImpl must be a function");
    n.EventEmitter.call(this), this.rpcImpl = g, this.requestDelimited = !!d, this.responseDelimited = !!k;
  }
  return t.prototype.rpcCall = function g(d, k, H, AA, gA) {
    if (!AA)
      throw TypeError("request must be specified");
    var IA = this;
    if (!gA)
      return n.asPromise(g, IA, d, k, H, AA);
    if (!IA.rpcImpl) {
      setTimeout(function() {
        gA(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return IA.rpcImpl(
        d,
        k[IA.requestDelimited ? "encodeDelimited" : "encode"](AA).finish(),
        function(BA, eA) {
          if (BA)
            return IA.emit("error", BA, d), gA(BA);
          if (eA === null) {
            IA.end(
              /* endedByRPC */
              !0
            );
            return;
          }
          if (!(eA instanceof H))
            try {
              eA = H[IA.responseDelimited ? "decodeDelimited" : "decode"](eA);
            } catch (iA) {
              return IA.emit("error", iA, d), gA(iA);
            }
          return IA.emit("data", eA, d), gA(null, eA);
        }
      );
    } catch (CA) {
      IA.emit("error", CA, d), setTimeout(function() {
        gA(CA);
      }, 0);
      return;
    }
  }, t.prototype.end = function(d) {
    return this.rpcImpl && (d || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  }, service$2;
}
var hasRequiredRpc$1;
function requireRpc$1() {
  return hasRequiredRpc$1 || (hasRequiredRpc$1 = 1, (function(n) {
    var t = n;
    t.Service = requireService$2();
  })(rpc$1)), rpc$1;
}
var roots$1, hasRequiredRoots$1;
function requireRoots$1() {
  return hasRequiredRoots$1 || (hasRequiredRoots$1 = 1, roots$1 = {}), roots$1;
}
var hasRequiredIndexMinimal$1;
function requireIndexMinimal$1() {
  return hasRequiredIndexMinimal$1 || (hasRequiredIndexMinimal$1 = 1, (function(n) {
    var t = n;
    t.build = "minimal", t.Writer = requireWriter$1(), t.BufferWriter = requireWriter_buffer$1(), t.Reader = requireReader$1(), t.BufferReader = requireReader_buffer$1(), t.util = requireMinimal$3(), t.rpc = requireRpc$1(), t.roots = requireRoots$1(), t.configure = g;
    function g() {
      t.util._configure(), t.Writer._configure(t.BufferWriter), t.Reader._configure(t.BufferReader);
    }
    g();
  })(indexMinimal$1)), indexMinimal$1;
}
var minimal$2, hasRequiredMinimal$2;
function requireMinimal$2() {
  return hasRequiredMinimal$2 || (hasRequiredMinimal$2 = 1, minimal$2 = requireIndexMinimal$1()), minimal$2;
}
var minimalExports$1 = requireMinimal$2();
const $Reader$1 = minimalExports$1.Reader, $Writer$1 = minimalExports$1.Writer, $util$1 = minimalExports$1.util, $root$1 = minimalExports$1.roots.default || (minimalExports$1.roots.default = {}), Alert = $root$1.Alert = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.body = "", n.prototype.format = 0, n.prototype.icon = "", n.prototype.widthConfig = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.format != null && Object.hasOwnProperty.call(g, "format") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.format), g.icon != null && Object.hasOwnProperty.call(g, "icon") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.icon), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root$1.streamlit.WidthConfig.encode(g.widthConfig, d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Alert();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.body = g.string();
          break;
        }
        case 2: {
          AA.format = g.int32();
          break;
        }
        case 3: {
          AA.icon = g.string();
          break;
        }
        case 4: {
          AA.widthConfig = $root$1.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.body != null && g.hasOwnProperty("body") && !$util$1.isString(g.body)) return "body: string expected";
    if (g.format != null && g.hasOwnProperty("format")) switch (g.format) {
      default:
        return "format: enum value expected";
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
        break;
    }
    if (g.icon != null && g.hasOwnProperty("icon") && !$util$1.isString(g.icon)) return "icon: string expected";
    if (g.widthConfig != null && g.hasOwnProperty("widthConfig")) {
      let d = $root$1.streamlit.WidthConfig.verify(g.widthConfig);
      if (d) return "widthConfig." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Alert) return g;
    let d = new $root$1.Alert();
    switch (g.body != null && (d.body = String(g.body)), g.format) {
      default:
        if (typeof g.format == "number") {
          d.format = g.format;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        d.format = 0;
        break;
      case "ERROR":
      case 1:
        d.format = 1;
        break;
      case "WARNING":
      case 2:
        d.format = 2;
        break;
      case "INFO":
      case 3:
        d.format = 3;
        break;
      case "SUCCESS":
      case 4:
        d.format = 4;
        break;
    }
    if (g.icon != null && (d.icon = String(g.icon)), g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Alert.widthConfig: object expected");
      d.widthConfig = $root$1.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.body = "", k.format = d.enums === String ? "UNUSED" : 0, k.icon = "", k.widthConfig = null), g.body != null && g.hasOwnProperty("body") && (k.body = g.body), g.format != null && g.hasOwnProperty("format") && (k.format = d.enums === String ? $root$1.Alert.Format[g.format] === void 0 ? g.format : $root$1.Alert.Format[g.format] : g.format), g.icon != null && g.hasOwnProperty("icon") && (k.icon = g.icon), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (k.widthConfig = $root$1.streamlit.WidthConfig.toObject(g.widthConfig, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Alert";
  }, n.Format = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "UNUSED"] = 0, g[t[1] = "ERROR"] = 1, g[t[2] = "WARNING"] = 2, g[t[3] = "INFO"] = 3, g[t[4] = "SUCCESS"] = 4, g;
  })(), n;
})(), streamlit = $root$1.streamlit = (() => {
  const n = {};
  return n.WidthConfig = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.useStretch = null, t.prototype.useContent = null, t.prototype.pixelWidth = null;
    let g;
    return Object.defineProperty(t.prototype, "widthSpec", { get: $util$1.oneOfGetter(g = ["useStretch", "useContent", "pixelWidth"]), set: $util$1.oneOfSetter(g) }), t.create = function(k) {
      return new t(k);
    }, t.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.useStretch != null && Object.hasOwnProperty.call(k, "useStretch") && H.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(k.useStretch), k.useContent != null && Object.hasOwnProperty.call(k, "useContent") && H.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(k.useContent), k.pixelWidth != null && Object.hasOwnProperty.call(k, "pixelWidth") && H.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(k.pixelWidth), H;
    }, t.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, t.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.streamlit.WidthConfig();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.useStretch = k.bool();
            break;
          }
          case 2: {
            IA.useContent = k.bool();
            break;
          }
          case 3: {
            IA.pixelWidth = k.uint32();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, t.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, t.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      let H = {};
      if (k.useStretch != null && k.hasOwnProperty("useStretch") && (H.widthSpec = 1, typeof k.useStretch != "boolean"))
        return "useStretch: boolean expected";
      if (k.useContent != null && k.hasOwnProperty("useContent")) {
        if (H.widthSpec === 1) return "widthSpec: multiple values";
        if (H.widthSpec = 1, typeof k.useContent != "boolean") return "useContent: boolean expected";
      }
      if (k.pixelWidth != null && k.hasOwnProperty("pixelWidth")) {
        if (H.widthSpec === 1) return "widthSpec: multiple values";
        if (H.widthSpec = 1, !$util$1.isInteger(k.pixelWidth)) return "pixelWidth: integer expected";
      }
      return null;
    }, t.fromObject = function(k) {
      if (k instanceof $root$1.streamlit.WidthConfig) return k;
      let H = new $root$1.streamlit.WidthConfig();
      return k.useStretch != null && (H.useStretch = !!k.useStretch), k.useContent != null && (H.useContent = !!k.useContent), k.pixelWidth != null && (H.pixelWidth = k.pixelWidth >>> 0), H;
    }, t.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return k.useStretch != null && k.hasOwnProperty("useStretch") && (AA.useStretch = k.useStretch, H.oneofs && (AA.widthSpec = "useStretch")), k.useContent != null && k.hasOwnProperty("useContent") && (AA.useContent = k.useContent, H.oneofs && (AA.widthSpec = "useContent")), k.pixelWidth != null && k.hasOwnProperty("pixelWidth") && (AA.pixelWidth = k.pixelWidth, H.oneofs && (AA.widthSpec = "pixelWidth")), AA;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/streamlit.WidthConfig";
    }, t;
  })(), n.HeightConfig = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.useStretch = null, t.prototype.useContent = null, t.prototype.pixelHeight = null;
    let g;
    return Object.defineProperty(t.prototype, "heightSpec", { get: $util$1.oneOfGetter(g = ["useStretch", "useContent", "pixelHeight"]), set: $util$1.oneOfSetter(g) }), t.create = function(k) {
      return new t(k);
    }, t.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.useStretch != null && Object.hasOwnProperty.call(k, "useStretch") && H.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(k.useStretch), k.useContent != null && Object.hasOwnProperty.call(k, "useContent") && H.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(k.useContent), k.pixelHeight != null && Object.hasOwnProperty.call(k, "pixelHeight") && H.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(k.pixelHeight), H;
    }, t.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, t.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.streamlit.HeightConfig();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.useStretch = k.bool();
            break;
          }
          case 2: {
            IA.useContent = k.bool();
            break;
          }
          case 3: {
            IA.pixelHeight = k.uint32();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, t.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, t.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      let H = {};
      if (k.useStretch != null && k.hasOwnProperty("useStretch") && (H.heightSpec = 1, typeof k.useStretch != "boolean"))
        return "useStretch: boolean expected";
      if (k.useContent != null && k.hasOwnProperty("useContent")) {
        if (H.heightSpec === 1) return "heightSpec: multiple values";
        if (H.heightSpec = 1, typeof k.useContent != "boolean") return "useContent: boolean expected";
      }
      if (k.pixelHeight != null && k.hasOwnProperty("pixelHeight")) {
        if (H.heightSpec === 1) return "heightSpec: multiple values";
        if (H.heightSpec = 1, !$util$1.isInteger(k.pixelHeight)) return "pixelHeight: integer expected";
      }
      return null;
    }, t.fromObject = function(k) {
      if (k instanceof $root$1.streamlit.HeightConfig) return k;
      let H = new $root$1.streamlit.HeightConfig();
      return k.useStretch != null && (H.useStretch = !!k.useStretch), k.useContent != null && (H.useContent = !!k.useContent), k.pixelHeight != null && (H.pixelHeight = k.pixelHeight >>> 0), H;
    }, t.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return k.useStretch != null && k.hasOwnProperty("useStretch") && (AA.useStretch = k.useStretch, H.oneofs && (AA.heightSpec = "useStretch")), k.useContent != null && k.hasOwnProperty("useContent") && (AA.useContent = k.useContent, H.oneofs && (AA.heightSpec = "useContent")), k.pixelHeight != null && k.hasOwnProperty("pixelHeight") && (AA.pixelHeight = k.pixelHeight, H.oneofs && (AA.heightSpec = "pixelHeight")), AA;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/streamlit.HeightConfig";
    }, t;
  })(), n.GapSize = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "GAP_UNDEFINED"] = 0, g[t[1] = "SMALL"] = 1, g[t[2] = "MEDIUM"] = 2, g[t[3] = "LARGE"] = 3, g[t[4] = "NONE"] = 4, g;
  })(), n.GapConfig = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.gapSize = null;
    let g;
    return Object.defineProperty(t.prototype, "gapSpec", { get: $util$1.oneOfGetter(g = ["gapSize"]), set: $util$1.oneOfSetter(g) }), t.create = function(k) {
      return new t(k);
    }, t.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.gapSize != null && Object.hasOwnProperty.call(k, "gapSize") && H.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(k.gapSize), H;
    }, t.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, t.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.streamlit.GapConfig();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.gapSize = k.int32();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, t.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, t.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      if (k.gapSize != null && k.hasOwnProperty("gapSize"))
        switch (k.gapSize) {
          default:
            return "gapSize: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      return null;
    }, t.fromObject = function(k) {
      if (k instanceof $root$1.streamlit.GapConfig) return k;
      let H = new $root$1.streamlit.GapConfig();
      switch (k.gapSize) {
        default:
          if (typeof k.gapSize == "number") {
            H.gapSize = k.gapSize;
            break;
          }
          break;
        case "GAP_UNDEFINED":
        case 0:
          H.gapSize = 0;
          break;
        case "SMALL":
        case 1:
          H.gapSize = 1;
          break;
        case "MEDIUM":
        case 2:
          H.gapSize = 2;
          break;
        case "LARGE":
        case 3:
          H.gapSize = 3;
          break;
        case "NONE":
        case 4:
          H.gapSize = 4;
          break;
      }
      return H;
    }, t.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return k.gapSize != null && k.hasOwnProperty("gapSize") && (AA.gapSize = H.enums === String ? $root$1.streamlit.GapSize[k.gapSize] === void 0 ? k.gapSize : $root$1.streamlit.GapSize[k.gapSize] : k.gapSize, H.oneofs && (AA.gapSpec = "gapSize")), AA;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/streamlit.GapConfig";
    }, t;
  })(), n;
})();
$root$1.AppPage = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.pageScriptHash = "", n.prototype.pageName = "", n.prototype.icon = "", n.prototype.isDefault = !1, n.prototype.sectionHeader = "", n.prototype.urlPathname = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.pageScriptHash), g.pageName != null && Object.hasOwnProperty.call(g, "pageName") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.pageName), g.icon != null && Object.hasOwnProperty.call(g, "icon") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.icon), g.isDefault != null && Object.hasOwnProperty.call(g, "isDefault") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.isDefault), g.sectionHeader != null && Object.hasOwnProperty.call(g, "sectionHeader") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.sectionHeader), g.urlPathname != null && Object.hasOwnProperty.call(g, "urlPathname") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.urlPathname), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.AppPage();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.pageScriptHash = g.string();
          break;
        }
        case 2: {
          AA.pageName = g.string();
          break;
        }
        case 3: {
          AA.icon = g.string();
          break;
        }
        case 4: {
          AA.isDefault = g.bool();
          break;
        }
        case 5: {
          AA.sectionHeader = g.string();
          break;
        }
        case 6: {
          AA.urlPathname = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && !$util$1.isString(g.pageScriptHash) ? "pageScriptHash: string expected" : g.pageName != null && g.hasOwnProperty("pageName") && !$util$1.isString(g.pageName) ? "pageName: string expected" : g.icon != null && g.hasOwnProperty("icon") && !$util$1.isString(g.icon) ? "icon: string expected" : g.isDefault != null && g.hasOwnProperty("isDefault") && typeof g.isDefault != "boolean" ? "isDefault: boolean expected" : g.sectionHeader != null && g.hasOwnProperty("sectionHeader") && !$util$1.isString(g.sectionHeader) ? "sectionHeader: string expected" : g.urlPathname != null && g.hasOwnProperty("urlPathname") && !$util$1.isString(g.urlPathname) ? "urlPathname: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.AppPage) return g;
    let d = new $root$1.AppPage();
    return g.pageScriptHash != null && (d.pageScriptHash = String(g.pageScriptHash)), g.pageName != null && (d.pageName = String(g.pageName)), g.icon != null && (d.icon = String(g.icon)), g.isDefault != null && (d.isDefault = !!g.isDefault), g.sectionHeader != null && (d.sectionHeader = String(g.sectionHeader)), g.urlPathname != null && (d.urlPathname = String(g.urlPathname)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.pageScriptHash = "", k.pageName = "", k.icon = "", k.isDefault = !1, k.sectionHeader = "", k.urlPathname = ""), g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (k.pageScriptHash = g.pageScriptHash), g.pageName != null && g.hasOwnProperty("pageName") && (k.pageName = g.pageName), g.icon != null && g.hasOwnProperty("icon") && (k.icon = g.icon), g.isDefault != null && g.hasOwnProperty("isDefault") && (k.isDefault = g.isDefault), g.sectionHeader != null && g.hasOwnProperty("sectionHeader") && (k.sectionHeader = g.sectionHeader), g.urlPathname != null && g.hasOwnProperty("urlPathname") && (k.urlPathname = g.urlPathname), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/AppPage";
  }, n;
})();
const Arrow$2 = $root$1.Arrow = (() => {
  function n(g) {
    if (this.columnOrder = [], this.selectionMode = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.data = $util$1.newBuffer([]), n.prototype.styler = null, n.prototype.width = 0, n.prototype.height = 0, n.prototype.useContainerWidth = !1, n.prototype.id = "", n.prototype.columns = "", n.prototype.editingMode = 0, n.prototype.disabled = !1, n.prototype.formId = "", n.prototype.columnOrder = $util$1.emptyArray, n.prototype.selectionMode = $util$1.emptyArray, n.prototype.rowHeight = null, n.prototype.borderMode = 0;
  let t;
  return Object.defineProperty(n.prototype, "_rowHeight", { get: $util$1.oneOfGetter(t = ["rowHeight"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    if (k || (k = $Writer$1.create()), d.data != null && Object.hasOwnProperty.call(d, "data") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(d.data), d.styler != null && Object.hasOwnProperty.call(d, "styler") && $root$1.Styler.encode(d.styler, k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), d.width != null && Object.hasOwnProperty.call(d, "width") && k.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(d.width), d.height != null && Object.hasOwnProperty.call(d, "height") && k.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(d.height), d.useContainerWidth != null && Object.hasOwnProperty.call(d, "useContainerWidth") && k.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(d.useContainerWidth), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.id), d.columns != null && Object.hasOwnProperty.call(d, "columns") && k.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(d.columns), d.editingMode != null && Object.hasOwnProperty.call(d, "editingMode") && k.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(d.editingMode), d.disabled != null && Object.hasOwnProperty.call(d, "disabled") && k.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(d.disabled), d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(d.formId), d.columnOrder != null && d.columnOrder.length) for (let H = 0; H < d.columnOrder.length; ++H) k.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(d.columnOrder[H]);
    if (d.selectionMode != null && d.selectionMode.length) {
      k.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork();
      for (let H = 0; H < d.selectionMode.length; ++H) k.int32(d.selectionMode[H]);
      k.ldelim();
    }
    return d.rowHeight != null && Object.hasOwnProperty.call(d, "rowHeight") && k.uint32(
      /* id 13, wireType 0 =*/
      104
    ).uint32(d.rowHeight), d.borderMode != null && Object.hasOwnProperty.call(d, "borderMode") && k.uint32(
      /* id 14, wireType 0 =*/
      112
    ).int32(d.borderMode), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Arrow();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.data = d.bytes();
          break;
        }
        case 2: {
          gA.styler = $root$1.Styler.decode(d, d.uint32());
          break;
        }
        case 3: {
          gA.width = d.uint32();
          break;
        }
        case 4: {
          gA.height = d.uint32();
          break;
        }
        case 5: {
          gA.useContainerWidth = d.bool();
          break;
        }
        case 6: {
          gA.id = d.string();
          break;
        }
        case 7: {
          gA.columns = d.string();
          break;
        }
        case 8: {
          gA.editingMode = d.int32();
          break;
        }
        case 9: {
          gA.disabled = d.bool();
          break;
        }
        case 10: {
          gA.formId = d.string();
          break;
        }
        case 11: {
          gA.columnOrder && gA.columnOrder.length || (gA.columnOrder = []), gA.columnOrder.push(d.string());
          break;
        }
        case 12: {
          if (gA.selectionMode && gA.selectionMode.length || (gA.selectionMode = []), (IA & 7) === 2) {
            let CA = d.uint32() + d.pos;
            for (; d.pos < CA; ) gA.selectionMode.push(d.int32());
          } else gA.selectionMode.push(d.int32());
          break;
        }
        case 13: {
          gA.rowHeight = d.uint32();
          break;
        }
        case 14: {
          gA.borderMode = d.int32();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.data != null && d.hasOwnProperty("data") && !(d.data && typeof d.data.length == "number" || $util$1.isString(d.data))) return "data: buffer expected";
    if (d.styler != null && d.hasOwnProperty("styler")) {
      let k = $root$1.Styler.verify(d.styler);
      if (k) return "styler." + k;
    }
    if (d.width != null && d.hasOwnProperty("width") && !$util$1.isInteger(d.width)) return "width: integer expected";
    if (d.height != null && d.hasOwnProperty("height") && !$util$1.isInteger(d.height)) return "height: integer expected";
    if (d.useContainerWidth != null && d.hasOwnProperty("useContainerWidth") && typeof d.useContainerWidth != "boolean") return "useContainerWidth: boolean expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.columns != null && d.hasOwnProperty("columns") && !$util$1.isString(d.columns)) return "columns: string expected";
    if (d.editingMode != null && d.hasOwnProperty("editingMode")) switch (d.editingMode) {
      default:
        return "editingMode: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (d.disabled != null && d.hasOwnProperty("disabled") && typeof d.disabled != "boolean") return "disabled: boolean expected";
    if (d.formId != null && d.hasOwnProperty("formId") && !$util$1.isString(d.formId)) return "formId: string expected";
    if (d.columnOrder != null && d.hasOwnProperty("columnOrder")) {
      if (!Array.isArray(d.columnOrder)) return "columnOrder: array expected";
      for (let k = 0; k < d.columnOrder.length; ++k) if (!$util$1.isString(d.columnOrder[k])) return "columnOrder: string[] expected";
    }
    if (d.selectionMode != null && d.hasOwnProperty("selectionMode")) {
      if (!Array.isArray(d.selectionMode)) return "selectionMode: array expected";
      for (let k = 0; k < d.selectionMode.length; ++k) switch (d.selectionMode[k]) {
        default:
          return "selectionMode: enum value[] expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
      }
    }
    if (d.rowHeight != null && d.hasOwnProperty("rowHeight") && !$util$1.isInteger(d.rowHeight))
      return "rowHeight: integer expected";
    if (d.borderMode != null && d.hasOwnProperty("borderMode")) switch (d.borderMode) {
      default:
        return "borderMode: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Arrow) return d;
    let k = new $root$1.Arrow();
    if (d.data != null && (typeof d.data == "string" ? $util$1.base64.decode(d.data, k.data = $util$1.newBuffer($util$1.base64.length(d.data)), 0) : d.data.length >= 0 && (k.data = d.data)), d.styler != null) {
      if (typeof d.styler != "object") throw TypeError(".Arrow.styler: object expected");
      k.styler = $root$1.Styler.fromObject(d.styler);
    }
    switch (d.width != null && (k.width = d.width >>> 0), d.height != null && (k.height = d.height >>> 0), d.useContainerWidth != null && (k.useContainerWidth = !!d.useContainerWidth), d.id != null && (k.id = String(d.id)), d.columns != null && (k.columns = String(d.columns)), d.editingMode) {
      default:
        if (typeof d.editingMode == "number") {
          k.editingMode = d.editingMode;
          break;
        }
        break;
      case "READ_ONLY":
      case 0:
        k.editingMode = 0;
        break;
      case "FIXED":
      case 1:
        k.editingMode = 1;
        break;
      case "DYNAMIC":
      case 2:
        k.editingMode = 2;
        break;
    }
    if (d.disabled != null && (k.disabled = !!d.disabled), d.formId != null && (k.formId = String(d.formId)), d.columnOrder) {
      if (!Array.isArray(d.columnOrder)) throw TypeError(".Arrow.columnOrder: array expected");
      k.columnOrder = [];
      for (let H = 0; H < d.columnOrder.length; ++H) k.columnOrder[H] = String(d.columnOrder[H]);
    }
    if (d.selectionMode) {
      if (!Array.isArray(d.selectionMode)) throw TypeError(".Arrow.selectionMode: array expected");
      k.selectionMode = [];
      for (let H = 0; H < d.selectionMode.length; ++H) switch (d.selectionMode[H]) {
        default:
          if (typeof d.selectionMode[H] == "number") {
            k.selectionMode[H] = d.selectionMode[H];
            break;
          }
        case "SINGLE_ROW":
        case 0:
          k.selectionMode[H] = 0;
          break;
        case "MULTI_ROW":
        case 1:
          k.selectionMode[H] = 1;
          break;
        case "SINGLE_COLUMN":
        case 2:
          k.selectionMode[H] = 2;
          break;
        case "MULTI_COLUMN":
        case 3:
          k.selectionMode[H] = 3;
          break;
        case "SINGLE_CELL":
        case 4:
          k.selectionMode[H] = 4;
          break;
        case "MULTI_CELL":
        case 5:
          k.selectionMode[H] = 5;
          break;
      }
    }
    switch (d.rowHeight != null && (k.rowHeight = d.rowHeight >>> 0), d.borderMode) {
      default:
        if (typeof d.borderMode == "number") {
          k.borderMode = d.borderMode;
          break;
        }
        break;
      case "ALL":
      case 0:
        k.borderMode = 0;
        break;
      case "NONE":
      case 1:
        k.borderMode = 1;
        break;
      case "HORIZONTAL":
      case 2:
        k.borderMode = 2;
        break;
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    if ((k.arrays || k.defaults) && (H.columnOrder = [], H.selectionMode = []), k.defaults && (k.bytes === String ? H.data = "" : (H.data = [], k.bytes !== Array && (H.data = $util$1.newBuffer(H.data))), H.styler = null, H.width = 0, H.height = 0, H.useContainerWidth = !1, H.id = "", H.columns = "", H.editingMode = k.enums === String ? "READ_ONLY" : 0, H.disabled = !1, H.formId = "", H.borderMode = k.enums === String ? "ALL" : 0), d.data != null && d.hasOwnProperty("data") && (H.data = k.bytes === String ? $util$1.base64.encode(d.data, 0, d.data.length) : k.bytes === Array ? Array.prototype.slice.call(d.data) : d.data), d.styler != null && d.hasOwnProperty("styler") && (H.styler = $root$1.Styler.toObject(d.styler, k)), d.width != null && d.hasOwnProperty("width") && (H.width = d.width), d.height != null && d.hasOwnProperty("height") && (H.height = d.height), d.useContainerWidth != null && d.hasOwnProperty("useContainerWidth") && (H.useContainerWidth = d.useContainerWidth), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.columns != null && d.hasOwnProperty("columns") && (H.columns = d.columns), d.editingMode != null && d.hasOwnProperty("editingMode") && (H.editingMode = k.enums === String ? $root$1.Arrow.EditingMode[d.editingMode] === void 0 ? d.editingMode : $root$1.Arrow.EditingMode[d.editingMode] : d.editingMode), d.disabled != null && d.hasOwnProperty("disabled") && (H.disabled = d.disabled), d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.columnOrder && d.columnOrder.length) {
      H.columnOrder = [];
      for (let AA = 0; AA < d.columnOrder.length; ++AA) H.columnOrder[AA] = d.columnOrder[AA];
    }
    if (d.selectionMode && d.selectionMode.length) {
      H.selectionMode = [];
      for (let AA = 0; AA < d.selectionMode.length; ++AA) H.selectionMode[AA] = k.enums === String ? $root$1.Arrow.SelectionMode[d.selectionMode[AA]] === void 0 ? d.selectionMode[AA] : $root$1.Arrow.SelectionMode[d.selectionMode[AA]] : d.selectionMode[AA];
    }
    return d.rowHeight != null && d.hasOwnProperty("rowHeight") && (H.rowHeight = d.rowHeight, k.oneofs && (H._rowHeight = "rowHeight")), d.borderMode != null && d.hasOwnProperty("borderMode") && (H.borderMode = k.enums === String ? $root$1.Arrow.BorderMode[d.borderMode] === void 0 ? d.borderMode : $root$1.Arrow.BorderMode[d.borderMode] : d.borderMode), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Arrow";
  }, n.EditingMode = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "READ_ONLY"] = 0, d[g[1] = "FIXED"] = 1, d[g[2] = "DYNAMIC"] = 2, d;
  })(), n.SelectionMode = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "SINGLE_ROW"] = 0, d[g[1] = "MULTI_ROW"] = 1, d[g[2] = "SINGLE_COLUMN"] = 2, d[g[3] = "MULTI_COLUMN"] = 3, d[g[4] = "SINGLE_CELL"] = 4, d[g[5] = "MULTI_CELL"] = 5, d;
  })(), n.BorderMode = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "ALL"] = 0, d[g[1] = "NONE"] = 1, d[g[2] = "HORIZONTAL"] = 2, d;
  })(), n;
})();
$root$1.Styler = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.uuid = "", n.prototype.caption = "", n.prototype.styles = "", n.prototype.displayValues = $util$1.newBuffer([]), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.uuid != null && Object.hasOwnProperty.call(g, "uuid") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.uuid), g.caption != null && Object.hasOwnProperty.call(g, "caption") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.caption), g.styles != null && Object.hasOwnProperty.call(g, "styles") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.styles), g.displayValues != null && Object.hasOwnProperty.call(g, "displayValues") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(g.displayValues), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Styler();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.uuid = g.string();
          break;
        }
        case 2: {
          AA.caption = g.string();
          break;
        }
        case 3: {
          AA.styles = g.string();
          break;
        }
        case 4: {
          AA.displayValues = g.bytes();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.uuid != null && g.hasOwnProperty("uuid") && !$util$1.isString(g.uuid) ? "uuid: string expected" : g.caption != null && g.hasOwnProperty("caption") && !$util$1.isString(g.caption) ? "caption: string expected" : g.styles != null && g.hasOwnProperty("styles") && !$util$1.isString(g.styles) ? "styles: string expected" : g.displayValues != null && g.hasOwnProperty("displayValues") && !(g.displayValues && typeof g.displayValues.length == "number" || $util$1.isString(g.displayValues)) ? "displayValues: buffer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Styler) return g;
    let d = new $root$1.Styler();
    return g.uuid != null && (d.uuid = String(g.uuid)), g.caption != null && (d.caption = String(g.caption)), g.styles != null && (d.styles = String(g.styles)), g.displayValues != null && (typeof g.displayValues == "string" ? $util$1.base64.decode(g.displayValues, d.displayValues = $util$1.newBuffer($util$1.base64.length(g.displayValues)), 0) : g.displayValues.length >= 0 && (d.displayValues = g.displayValues)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.uuid = "", k.caption = "", k.styles = "", d.bytes === String ? k.displayValues = "" : (k.displayValues = [], d.bytes !== Array && (k.displayValues = $util$1.newBuffer(k.displayValues)))), g.uuid != null && g.hasOwnProperty("uuid") && (k.uuid = g.uuid), g.caption != null && g.hasOwnProperty("caption") && (k.caption = g.caption), g.styles != null && g.hasOwnProperty("styles") && (k.styles = g.styles), g.displayValues != null && g.hasOwnProperty("displayValues") && (k.displayValues = d.bytes === String ? $util$1.base64.encode(g.displayValues, 0, g.displayValues.length) : d.bytes === Array ? Array.prototype.slice.call(g.displayValues) : g.displayValues), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Styler";
  }, n;
})();
$root$1.ArrowNamedDataSet = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.name = "", n.prototype.hasName = !1, n.prototype.data = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.name), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.Arrow.encode(g.data, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.hasName != null && Object.hasOwnProperty.call(g, "hasName") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.hasName), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ArrowNamedDataSet();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.name = g.string();
          break;
        }
        case 3: {
          AA.hasName = g.bool();
          break;
        }
        case 2: {
          AA.data = $root$1.Arrow.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.name != null && g.hasOwnProperty("name") && !$util$1.isString(g.name)) return "name: string expected";
    if (g.hasName != null && g.hasOwnProperty("hasName") && typeof g.hasName != "boolean") return "hasName: boolean expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      let d = $root$1.Arrow.verify(g.data);
      if (d) return "data." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ArrowNamedDataSet) return g;
    let d = new $root$1.ArrowNamedDataSet();
    if (g.name != null && (d.name = String(g.name)), g.hasName != null && (d.hasName = !!g.hasName), g.data != null) {
      if (typeof g.data != "object") throw TypeError(".ArrowNamedDataSet.data: object expected");
      d.data = $root$1.Arrow.fromObject(g.data);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.name = "", k.data = null, k.hasName = !1), g.name != null && g.hasOwnProperty("name") && (k.name = g.name), g.data != null && g.hasOwnProperty("data") && (k.data = $root$1.Arrow.toObject(g.data, d)), g.hasName != null && g.hasOwnProperty("hasName") && (k.hasName = g.hasName), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ArrowNamedDataSet";
  }, n;
})();
$root$1.ArrowVegaLiteChart = (() => {
  function n(t) {
    if (this.datasets = [], this.selectionMode = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.spec = "", n.prototype.data = null, n.prototype.datasets = $util$1.emptyArray, n.prototype.useContainerWidth = !1, n.prototype.theme = "", n.prototype.id = "", n.prototype.selectionMode = $util$1.emptyArray, n.prototype.formId = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.spec != null && Object.hasOwnProperty.call(g, "spec") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.spec), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.Arrow.encode(g.data, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.datasets != null && g.datasets.length) for (let k = 0; k < g.datasets.length; ++k) $root$1.ArrowNamedDataSet.encode(g.datasets[k], d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    if (g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.useContainerWidth), g.theme != null && Object.hasOwnProperty.call(g, "theme") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.theme), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.id), g.selectionMode != null && g.selectionMode.length) for (let k = 0; k < g.selectionMode.length; ++k) d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.selectionMode[k]);
    return g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.formId), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ArrowVegaLiteChart();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.spec = g.string();
          break;
        }
        case 2: {
          AA.data = $root$1.Arrow.decode(g, g.uint32());
          break;
        }
        case 4: {
          AA.datasets && AA.datasets.length || (AA.datasets = []), AA.datasets.push($root$1.ArrowNamedDataSet.decode(g, g.uint32()));
          break;
        }
        case 5: {
          AA.useContainerWidth = g.bool();
          break;
        }
        case 6: {
          AA.theme = g.string();
          break;
        }
        case 7: {
          AA.id = g.string();
          break;
        }
        case 8: {
          AA.selectionMode && AA.selectionMode.length || (AA.selectionMode = []), AA.selectionMode.push(g.string());
          break;
        }
        case 9: {
          AA.formId = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.spec != null && g.hasOwnProperty("spec") && !$util$1.isString(g.spec)) return "spec: string expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      let d = $root$1.Arrow.verify(g.data);
      if (d) return "data." + d;
    }
    if (g.datasets != null && g.hasOwnProperty("datasets")) {
      if (!Array.isArray(g.datasets)) return "datasets: array expected";
      for (let d = 0; d < g.datasets.length; ++d) {
        let k = $root$1.ArrowNamedDataSet.verify(g.datasets[d]);
        if (k) return "datasets." + k;
      }
    }
    if (g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && typeof g.useContainerWidth != "boolean") return "useContainerWidth: boolean expected";
    if (g.theme != null && g.hasOwnProperty("theme") && !$util$1.isString(g.theme)) return "theme: string expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util$1.isString(g.id)) return "id: string expected";
    if (g.selectionMode != null && g.hasOwnProperty("selectionMode")) {
      if (!Array.isArray(g.selectionMode)) return "selectionMode: array expected";
      for (let d = 0; d < g.selectionMode.length; ++d) if (!$util$1.isString(g.selectionMode[d])) return "selectionMode: string[] expected";
    }
    return g.formId != null && g.hasOwnProperty("formId") && !$util$1.isString(g.formId) ? "formId: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ArrowVegaLiteChart) return g;
    let d = new $root$1.ArrowVegaLiteChart();
    if (g.spec != null && (d.spec = String(g.spec)), g.data != null) {
      if (typeof g.data != "object") throw TypeError(".ArrowVegaLiteChart.data: object expected");
      d.data = $root$1.Arrow.fromObject(g.data);
    }
    if (g.datasets) {
      if (!Array.isArray(g.datasets)) throw TypeError(".ArrowVegaLiteChart.datasets: array expected");
      d.datasets = [];
      for (let k = 0; k < g.datasets.length; ++k) {
        if (typeof g.datasets[k] != "object") throw TypeError(".ArrowVegaLiteChart.datasets: object expected");
        d.datasets[k] = $root$1.ArrowNamedDataSet.fromObject(g.datasets[k]);
      }
    }
    if (g.useContainerWidth != null && (d.useContainerWidth = !!g.useContainerWidth), g.theme != null && (d.theme = String(g.theme)), g.id != null && (d.id = String(g.id)), g.selectionMode) {
      if (!Array.isArray(g.selectionMode)) throw TypeError(".ArrowVegaLiteChart.selectionMode: array expected");
      d.selectionMode = [];
      for (let k = 0; k < g.selectionMode.length; ++k) d.selectionMode[k] = String(g.selectionMode[k]);
    }
    return g.formId != null && (d.formId = String(g.formId)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.datasets = [], k.selectionMode = []), d.defaults && (k.spec = "", k.data = null, k.useContainerWidth = !1, k.theme = "", k.id = "", k.formId = ""), g.spec != null && g.hasOwnProperty("spec") && (k.spec = g.spec), g.data != null && g.hasOwnProperty("data") && (k.data = $root$1.Arrow.toObject(g.data, d)), g.datasets && g.datasets.length) {
      k.datasets = [];
      for (let H = 0; H < g.datasets.length; ++H) k.datasets[H] = $root$1.ArrowNamedDataSet.toObject(g.datasets[H], d);
    }
    if (g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (k.useContainerWidth = g.useContainerWidth), g.theme != null && g.hasOwnProperty("theme") && (k.theme = g.theme), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.selectionMode && g.selectionMode.length) {
      k.selectionMode = [];
      for (let H = 0; H < g.selectionMode.length; ++H) k.selectionMode[H] = g.selectionMode[H];
    }
    return g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ArrowVegaLiteChart";
  }, n;
})();
$root$1.Audio = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.url = "", n.prototype.startTime = 0, n.prototype.endTime = 0, n.prototype.loop = !1, n.prototype.autoplay = !1, n.prototype.id = "", n.prototype.widthConfig = null;
  let t;
  return Object.defineProperty(n.prototype, "_widthConfig", { get: $util$1.oneOfGetter(t = ["widthConfig"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.startTime != null && Object.hasOwnProperty.call(d, "startTime") && k.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(d.startTime), d.url != null && Object.hasOwnProperty.call(d, "url") && k.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(d.url), d.endTime != null && Object.hasOwnProperty.call(d, "endTime") && k.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(d.endTime), d.loop != null && Object.hasOwnProperty.call(d, "loop") && k.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(d.loop), d.autoplay != null && Object.hasOwnProperty.call(d, "autoplay") && k.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(d.autoplay), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(d.id), d.widthConfig != null && Object.hasOwnProperty.call(d, "widthConfig") && $root$1.streamlit.WidthConfig.encode(d.widthConfig, k.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Audio();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 5: {
          gA.url = d.string();
          break;
        }
        case 3: {
          gA.startTime = d.int32();
          break;
        }
        case 6: {
          gA.endTime = d.int32();
          break;
        }
        case 7: {
          gA.loop = d.bool();
          break;
        }
        case 8: {
          gA.autoplay = d.bool();
          break;
        }
        case 9: {
          gA.id = d.string();
          break;
        }
        case 10: {
          gA.widthConfig = $root$1.streamlit.WidthConfig.decode(d, d.uint32());
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.url != null && d.hasOwnProperty("url") && !$util$1.isString(d.url)) return "url: string expected";
    if (d.startTime != null && d.hasOwnProperty("startTime") && !$util$1.isInteger(d.startTime)) return "startTime: integer expected";
    if (d.endTime != null && d.hasOwnProperty("endTime") && !$util$1.isInteger(d.endTime)) return "endTime: integer expected";
    if (d.loop != null && d.hasOwnProperty("loop") && typeof d.loop != "boolean") return "loop: boolean expected";
    if (d.autoplay != null && d.hasOwnProperty("autoplay") && typeof d.autoplay != "boolean") return "autoplay: boolean expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.widthConfig != null && d.hasOwnProperty("widthConfig")) {
      let k = $root$1.streamlit.WidthConfig.verify(d.widthConfig);
      if (k) return "widthConfig." + k;
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Audio) return d;
    let k = new $root$1.Audio();
    if (d.url != null && (k.url = String(d.url)), d.startTime != null && (k.startTime = d.startTime | 0), d.endTime != null && (k.endTime = d.endTime | 0), d.loop != null && (k.loop = !!d.loop), d.autoplay != null && (k.autoplay = !!d.autoplay), d.id != null && (k.id = String(d.id)), d.widthConfig != null) {
      if (typeof d.widthConfig != "object") throw TypeError(".Audio.widthConfig: object expected");
      k.widthConfig = $root$1.streamlit.WidthConfig.fromObject(d.widthConfig);
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.startTime = 0, H.url = "", H.endTime = 0, H.loop = !1, H.autoplay = !1, H.id = ""), d.startTime != null && d.hasOwnProperty("startTime") && (H.startTime = d.startTime), d.url != null && d.hasOwnProperty("url") && (H.url = d.url), d.endTime != null && d.hasOwnProperty("endTime") && (H.endTime = d.endTime), d.loop != null && d.hasOwnProperty("loop") && (H.loop = d.loop), d.autoplay != null && d.hasOwnProperty("autoplay") && (H.autoplay = d.autoplay), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.widthConfig != null && d.hasOwnProperty("widthConfig") && (H.widthConfig = $root$1.streamlit.WidthConfig.toObject(d.widthConfig, k), k.oneofs && (H._widthConfig = "widthConfig")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Audio";
  }, n;
})();
$root$1.AudioInput = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.help = "", n.prototype.formId = "", n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.sampleRate = null;
  let t;
  return Object.defineProperty(n.prototype, "_sampleRate", { get: $util$1.oneOfGetter(t = ["sampleRate"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.id), d.label != null && Object.hasOwnProperty.call(d, "label") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.label), d.help != null && Object.hasOwnProperty.call(d, "help") && k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(d.help), d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(d.formId), d.disabled != null && Object.hasOwnProperty.call(d, "disabled") && k.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(d.disabled), d.labelVisibility != null && Object.hasOwnProperty.call(d, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(d.labelVisibility, k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), d.sampleRate != null && Object.hasOwnProperty.call(d, "sampleRate") && k.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(d.sampleRate), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.AudioInput();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.id = d.string();
          break;
        }
        case 2: {
          gA.label = d.string();
          break;
        }
        case 3: {
          gA.help = d.string();
          break;
        }
        case 4: {
          gA.formId = d.string();
          break;
        }
        case 5: {
          gA.disabled = d.bool();
          break;
        }
        case 6: {
          gA.labelVisibility = $root$1.LabelVisibilityMessage.decode(d, d.uint32());
          break;
        }
        case 7: {
          gA.sampleRate = d.int32();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.label != null && d.hasOwnProperty("label") && !$util$1.isString(d.label)) return "label: string expected";
    if (d.help != null && d.hasOwnProperty("help") && !$util$1.isString(d.help)) return "help: string expected";
    if (d.formId != null && d.hasOwnProperty("formId") && !$util$1.isString(d.formId)) return "formId: string expected";
    if (d.disabled != null && d.hasOwnProperty("disabled") && typeof d.disabled != "boolean") return "disabled: boolean expected";
    if (d.labelVisibility != null && d.hasOwnProperty("labelVisibility")) {
      let k = $root$1.LabelVisibilityMessage.verify(d.labelVisibility);
      if (k) return "labelVisibility." + k;
    }
    return d.sampleRate != null && d.hasOwnProperty("sampleRate") && !$util$1.isInteger(d.sampleRate) ? "sampleRate: integer expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.AudioInput) return d;
    let k = new $root$1.AudioInput();
    if (d.id != null && (k.id = String(d.id)), d.label != null && (k.label = String(d.label)), d.help != null && (k.help = String(d.help)), d.formId != null && (k.formId = String(d.formId)), d.disabled != null && (k.disabled = !!d.disabled), d.labelVisibility != null) {
      if (typeof d.labelVisibility != "object") throw TypeError(".AudioInput.labelVisibility: object expected");
      k.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(d.labelVisibility);
    }
    return d.sampleRate != null && (k.sampleRate = d.sampleRate | 0), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.id = "", H.label = "", H.help = "", H.formId = "", H.disabled = !1, H.labelVisibility = null), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.label != null && d.hasOwnProperty("label") && (H.label = d.label), d.help != null && d.hasOwnProperty("help") && (H.help = d.help), d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.disabled != null && d.hasOwnProperty("disabled") && (H.disabled = d.disabled), d.labelVisibility != null && d.hasOwnProperty("labelVisibility") && (H.labelVisibility = $root$1.LabelVisibilityMessage.toObject(d.labelVisibility, k)), d.sampleRate != null && d.hasOwnProperty("sampleRate") && (H.sampleRate = d.sampleRate, k.oneofs && (H._sampleRate = "sampleRate")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/AudioInput";
  }, n;
})();
const LabelVisibilityMessage = $root$1.LabelVisibilityMessage = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.value = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(g.value), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.LabelVisibilityMessage();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.value = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.value != null && g.hasOwnProperty("value")) switch (g.value) {
      default:
        return "value: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.LabelVisibilityMessage) return g;
    let d = new $root$1.LabelVisibilityMessage();
    switch (g.value) {
      default:
        if (typeof g.value == "number") {
          d.value = g.value;
          break;
        }
        break;
      case "VISIBLE":
      case 0:
        d.value = 0;
        break;
      case "HIDDEN":
      case 1:
        d.value = 1;
        break;
      case "COLLAPSED":
      case 2:
        d.value = 2;
        break;
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.value = d.enums === String ? "VISIBLE" : 0), g.value != null && g.hasOwnProperty("value") && (k.value = d.enums === String ? $root$1.LabelVisibilityMessage.LabelVisibilityOptions[g.value] === void 0 ? g.value : $root$1.LabelVisibilityMessage.LabelVisibilityOptions[g.value] : g.value), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/LabelVisibilityMessage";
  }, n.LabelVisibilityOptions = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "VISIBLE"] = 0, g[t[1] = "HIDDEN"] = 1, g[t[2] = "COLLAPSED"] = 2, g;
  })(), n;
})();
$root$1.AuthRedirect = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.url = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.url != null && Object.hasOwnProperty.call(g, "url") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.url), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.AuthRedirect();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.url = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.url != null && g.hasOwnProperty("url") && !$util$1.isString(g.url) ? "url: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.AuthRedirect) return g;
    let d = new $root$1.AuthRedirect();
    return g.url != null && (d.url = String(g.url)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.url = ""), g.url != null && g.hasOwnProperty("url") && (k.url = g.url), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/AuthRedirect";
  }, n;
})();
$root$1.AutoRerun = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.interval = 0, n.prototype.fragmentId = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.interval != null && Object.hasOwnProperty.call(g, "interval") && d.uint32(
      /* id 1, wireType 5 =*/
      13
    ).float(g.interval), g.fragmentId != null && Object.hasOwnProperty.call(g, "fragmentId") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.fragmentId), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.AutoRerun();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.interval = g.float();
          break;
        }
        case 2: {
          AA.fragmentId = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.interval != null && g.hasOwnProperty("interval") && typeof g.interval != "number" ? "interval: number expected" : g.fragmentId != null && g.hasOwnProperty("fragmentId") && !$util$1.isString(g.fragmentId) ? "fragmentId: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.AutoRerun) return g;
    let d = new $root$1.AutoRerun();
    return g.interval != null && (d.interval = Number(g.interval)), g.fragmentId != null && (d.fragmentId = String(g.fragmentId)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.interval = 0, k.fragmentId = ""), g.interval != null && g.hasOwnProperty("interval") && (k.interval = d.json && !isFinite(g.interval) ? String(g.interval) : g.interval), g.fragmentId != null && g.hasOwnProperty("fragmentId") && (k.fragmentId = g.fragmentId), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/AutoRerun";
  }, n;
})();
const BackMsg = $root$1.BackMsg = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.clearCache = null, n.prototype.setRunOnSave = null, n.prototype.stopScript = null, n.prototype.rerunScript = null, n.prototype.loadGitInfo = null, n.prototype.debugDisconnectWebsocket = null, n.prototype.debugShutdownRuntime = null, n.prototype.fileUrlsRequest = null, n.prototype.appHeartbeat = null, n.prototype.debugLastBackmsgId = "";
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util$1.oneOfGetter(t = ["clearCache", "setRunOnSave", "stopScript", "rerunScript", "loadGitInfo", "debugDisconnectWebsocket", "debugShutdownRuntime", "fileUrlsRequest", "appHeartbeat"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.clearCache != null && Object.hasOwnProperty.call(d, "clearCache") && k.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(d.clearCache), d.setRunOnSave != null && Object.hasOwnProperty.call(d, "setRunOnSave") && k.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(d.setRunOnSave), d.stopScript != null && Object.hasOwnProperty.call(d, "stopScript") && k.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(d.stopScript), d.rerunScript != null && Object.hasOwnProperty.call(d, "rerunScript") && $root$1.ClientState.encode(d.rerunScript, k.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), d.loadGitInfo != null && Object.hasOwnProperty.call(d, "loadGitInfo") && k.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(d.loadGitInfo), d.debugLastBackmsgId != null && Object.hasOwnProperty.call(d, "debugLastBackmsgId") && k.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(d.debugLastBackmsgId), d.debugDisconnectWebsocket != null && Object.hasOwnProperty.call(d, "debugDisconnectWebsocket") && k.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(d.debugDisconnectWebsocket), d.debugShutdownRuntime != null && Object.hasOwnProperty.call(d, "debugShutdownRuntime") && k.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(d.debugShutdownRuntime), d.fileUrlsRequest != null && Object.hasOwnProperty.call(d, "fileUrlsRequest") && $root$1.FileURLsRequest.encode(d.fileUrlsRequest, k.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), d.appHeartbeat != null && Object.hasOwnProperty.call(d, "appHeartbeat") && k.uint32(
      /* id 17, wireType 0 =*/
      136
    ).bool(d.appHeartbeat), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.BackMsg();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 5: {
          gA.clearCache = d.bool();
          break;
        }
        case 6: {
          gA.setRunOnSave = d.bool();
          break;
        }
        case 7: {
          gA.stopScript = d.bool();
          break;
        }
        case 11: {
          gA.rerunScript = $root$1.ClientState.decode(d, d.uint32());
          break;
        }
        case 12: {
          gA.loadGitInfo = d.bool();
          break;
        }
        case 14: {
          gA.debugDisconnectWebsocket = d.bool();
          break;
        }
        case 15: {
          gA.debugShutdownRuntime = d.bool();
          break;
        }
        case 16: {
          gA.fileUrlsRequest = $root$1.FileURLsRequest.decode(d, d.uint32());
          break;
        }
        case 17: {
          gA.appHeartbeat = d.bool();
          break;
        }
        case 13: {
          gA.debugLastBackmsgId = d.string();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.clearCache != null && d.hasOwnProperty("clearCache") && (k.type = 1, typeof d.clearCache != "boolean"))
      return "clearCache: boolean expected";
    if (d.setRunOnSave != null && d.hasOwnProperty("setRunOnSave")) {
      if (k.type === 1) return "type: multiple values";
      if (k.type = 1, typeof d.setRunOnSave != "boolean") return "setRunOnSave: boolean expected";
    }
    if (d.stopScript != null && d.hasOwnProperty("stopScript")) {
      if (k.type === 1) return "type: multiple values";
      if (k.type = 1, typeof d.stopScript != "boolean") return "stopScript: boolean expected";
    }
    if (d.rerunScript != null && d.hasOwnProperty("rerunScript")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.ClientState.verify(d.rerunScript);
        if (H) return "rerunScript." + H;
      }
    }
    if (d.loadGitInfo != null && d.hasOwnProperty("loadGitInfo")) {
      if (k.type === 1) return "type: multiple values";
      if (k.type = 1, typeof d.loadGitInfo != "boolean") return "loadGitInfo: boolean expected";
    }
    if (d.debugDisconnectWebsocket != null && d.hasOwnProperty("debugDisconnectWebsocket")) {
      if (k.type === 1) return "type: multiple values";
      if (k.type = 1, typeof d.debugDisconnectWebsocket != "boolean") return "debugDisconnectWebsocket: boolean expected";
    }
    if (d.debugShutdownRuntime != null && d.hasOwnProperty("debugShutdownRuntime")) {
      if (k.type === 1) return "type: multiple values";
      if (k.type = 1, typeof d.debugShutdownRuntime != "boolean") return "debugShutdownRuntime: boolean expected";
    }
    if (d.fileUrlsRequest != null && d.hasOwnProperty("fileUrlsRequest")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.FileURLsRequest.verify(d.fileUrlsRequest);
        if (H) return "fileUrlsRequest." + H;
      }
    }
    if (d.appHeartbeat != null && d.hasOwnProperty("appHeartbeat")) {
      if (k.type === 1) return "type: multiple values";
      if (k.type = 1, typeof d.appHeartbeat != "boolean") return "appHeartbeat: boolean expected";
    }
    return d.debugLastBackmsgId != null && d.hasOwnProperty("debugLastBackmsgId") && !$util$1.isString(d.debugLastBackmsgId) ? "debugLastBackmsgId: string expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.BackMsg) return d;
    let k = new $root$1.BackMsg();
    if (d.clearCache != null && (k.clearCache = !!d.clearCache), d.setRunOnSave != null && (k.setRunOnSave = !!d.setRunOnSave), d.stopScript != null && (k.stopScript = !!d.stopScript), d.rerunScript != null) {
      if (typeof d.rerunScript != "object") throw TypeError(".BackMsg.rerunScript: object expected");
      k.rerunScript = $root$1.ClientState.fromObject(d.rerunScript);
    }
    if (d.loadGitInfo != null && (k.loadGitInfo = !!d.loadGitInfo), d.debugDisconnectWebsocket != null && (k.debugDisconnectWebsocket = !!d.debugDisconnectWebsocket), d.debugShutdownRuntime != null && (k.debugShutdownRuntime = !!d.debugShutdownRuntime), d.fileUrlsRequest != null) {
      if (typeof d.fileUrlsRequest != "object") throw TypeError(".BackMsg.fileUrlsRequest: object expected");
      k.fileUrlsRequest = $root$1.FileURLsRequest.fromObject(d.fileUrlsRequest);
    }
    return d.appHeartbeat != null && (k.appHeartbeat = !!d.appHeartbeat), d.debugLastBackmsgId != null && (k.debugLastBackmsgId = String(d.debugLastBackmsgId)), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.debugLastBackmsgId = ""), d.clearCache != null && d.hasOwnProperty("clearCache") && (H.clearCache = d.clearCache, k.oneofs && (H.type = "clearCache")), d.setRunOnSave != null && d.hasOwnProperty("setRunOnSave") && (H.setRunOnSave = d.setRunOnSave, k.oneofs && (H.type = "setRunOnSave")), d.stopScript != null && d.hasOwnProperty("stopScript") && (H.stopScript = d.stopScript, k.oneofs && (H.type = "stopScript")), d.rerunScript != null && d.hasOwnProperty("rerunScript") && (H.rerunScript = $root$1.ClientState.toObject(d.rerunScript, k), k.oneofs && (H.type = "rerunScript")), d.loadGitInfo != null && d.hasOwnProperty("loadGitInfo") && (H.loadGitInfo = d.loadGitInfo, k.oneofs && (H.type = "loadGitInfo")), d.debugLastBackmsgId != null && d.hasOwnProperty("debugLastBackmsgId") && (H.debugLastBackmsgId = d.debugLastBackmsgId), d.debugDisconnectWebsocket != null && d.hasOwnProperty("debugDisconnectWebsocket") && (H.debugDisconnectWebsocket = d.debugDisconnectWebsocket, k.oneofs && (H.type = "debugDisconnectWebsocket")), d.debugShutdownRuntime != null && d.hasOwnProperty("debugShutdownRuntime") && (H.debugShutdownRuntime = d.debugShutdownRuntime, k.oneofs && (H.type = "debugShutdownRuntime")), d.fileUrlsRequest != null && d.hasOwnProperty("fileUrlsRequest") && (H.fileUrlsRequest = $root$1.FileURLsRequest.toObject(d.fileUrlsRequest, k), k.oneofs && (H.type = "fileUrlsRequest")), d.appHeartbeat != null && d.hasOwnProperty("appHeartbeat") && (H.appHeartbeat = d.appHeartbeat, k.oneofs && (H.type = "appHeartbeat")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/BackMsg";
  }, n;
})();
$root$1.ContextInfo = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.timezone = null, n.prototype.timezoneOffset = null, n.prototype.locale = null, n.prototype.url = null, n.prototype.isEmbedded = null, n.prototype.colorScheme = null;
  let t;
  return Object.defineProperty(n.prototype, "_timezone", { get: $util$1.oneOfGetter(t = ["timezone"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_timezoneOffset", { get: $util$1.oneOfGetter(t = ["timezoneOffset"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_locale", { get: $util$1.oneOfGetter(t = ["locale"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_url", { get: $util$1.oneOfGetter(t = ["url"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_isEmbedded", { get: $util$1.oneOfGetter(t = ["isEmbedded"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_colorScheme", { get: $util$1.oneOfGetter(t = ["colorScheme"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.timezone != null && Object.hasOwnProperty.call(d, "timezone") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.timezone), d.timezoneOffset != null && Object.hasOwnProperty.call(d, "timezoneOffset") && k.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(d.timezoneOffset), d.locale != null && Object.hasOwnProperty.call(d, "locale") && k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(d.locale), d.url != null && Object.hasOwnProperty.call(d, "url") && k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(d.url), d.isEmbedded != null && Object.hasOwnProperty.call(d, "isEmbedded") && k.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(d.isEmbedded), d.colorScheme != null && Object.hasOwnProperty.call(d, "colorScheme") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.colorScheme), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.ContextInfo();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.timezone = d.string();
          break;
        }
        case 2: {
          gA.timezoneOffset = d.int32();
          break;
        }
        case 3: {
          gA.locale = d.string();
          break;
        }
        case 4: {
          gA.url = d.string();
          break;
        }
        case 5: {
          gA.isEmbedded = d.bool();
          break;
        }
        case 6: {
          gA.colorScheme = d.string();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    return typeof d != "object" || d === null ? "object expected" : d.timezone != null && d.hasOwnProperty("timezone") && !$util$1.isString(d.timezone) ? "timezone: string expected" : d.timezoneOffset != null && d.hasOwnProperty("timezoneOffset") && !$util$1.isInteger(d.timezoneOffset) ? "timezoneOffset: integer expected" : d.locale != null && d.hasOwnProperty("locale") && !$util$1.isString(d.locale) ? "locale: string expected" : d.url != null && d.hasOwnProperty("url") && !$util$1.isString(d.url) ? "url: string expected" : d.isEmbedded != null && d.hasOwnProperty("isEmbedded") && typeof d.isEmbedded != "boolean" ? "isEmbedded: boolean expected" : d.colorScheme != null && d.hasOwnProperty("colorScheme") && !$util$1.isString(d.colorScheme) ? "colorScheme: string expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.ContextInfo) return d;
    let k = new $root$1.ContextInfo();
    return d.timezone != null && (k.timezone = String(d.timezone)), d.timezoneOffset != null && (k.timezoneOffset = d.timezoneOffset | 0), d.locale != null && (k.locale = String(d.locale)), d.url != null && (k.url = String(d.url)), d.isEmbedded != null && (k.isEmbedded = !!d.isEmbedded), d.colorScheme != null && (k.colorScheme = String(d.colorScheme)), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return d.timezone != null && d.hasOwnProperty("timezone") && (H.timezone = d.timezone, k.oneofs && (H._timezone = "timezone")), d.timezoneOffset != null && d.hasOwnProperty("timezoneOffset") && (H.timezoneOffset = d.timezoneOffset, k.oneofs && (H._timezoneOffset = "timezoneOffset")), d.locale != null && d.hasOwnProperty("locale") && (H.locale = d.locale, k.oneofs && (H._locale = "locale")), d.url != null && d.hasOwnProperty("url") && (H.url = d.url, k.oneofs && (H._url = "url")), d.isEmbedded != null && d.hasOwnProperty("isEmbedded") && (H.isEmbedded = d.isEmbedded, k.oneofs && (H._isEmbedded = "isEmbedded")), d.colorScheme != null && d.hasOwnProperty("colorScheme") && (H.colorScheme = d.colorScheme, k.oneofs && (H._colorScheme = "colorScheme")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/ContextInfo";
  }, n;
})();
$root$1.ClientState = (() => {
  function n(t) {
    if (this.cachedMessageHashes = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.queryString = "", n.prototype.widgetStates = null, n.prototype.pageScriptHash = "", n.prototype.pageName = "", n.prototype.fragmentId = "", n.prototype.isAutoRerun = !1, n.prototype.cachedMessageHashes = $util$1.emptyArray, n.prototype.contextInfo = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.queryString != null && Object.hasOwnProperty.call(g, "queryString") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.queryString), g.widgetStates != null && Object.hasOwnProperty.call(g, "widgetStates") && $root$1.WidgetStates.encode(g.widgetStates, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.pageScriptHash), g.pageName != null && Object.hasOwnProperty.call(g, "pageName") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.pageName), g.fragmentId != null && Object.hasOwnProperty.call(g, "fragmentId") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.fragmentId), g.isAutoRerun != null && Object.hasOwnProperty.call(g, "isAutoRerun") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.isAutoRerun), g.cachedMessageHashes != null && g.cachedMessageHashes.length) for (let k = 0; k < g.cachedMessageHashes.length; ++k) d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.cachedMessageHashes[k]);
    return g.contextInfo != null && Object.hasOwnProperty.call(g, "contextInfo") && $root$1.ContextInfo.encode(g.contextInfo, d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ClientState();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.queryString = g.string();
          break;
        }
        case 2: {
          AA.widgetStates = $root$1.WidgetStates.decode(g, g.uint32());
          break;
        }
        case 3: {
          AA.pageScriptHash = g.string();
          break;
        }
        case 4: {
          AA.pageName = g.string();
          break;
        }
        case 5: {
          AA.fragmentId = g.string();
          break;
        }
        case 6: {
          AA.isAutoRerun = g.bool();
          break;
        }
        case 7: {
          AA.cachedMessageHashes && AA.cachedMessageHashes.length || (AA.cachedMessageHashes = []), AA.cachedMessageHashes.push(g.string());
          break;
        }
        case 8: {
          AA.contextInfo = $root$1.ContextInfo.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.queryString != null && g.hasOwnProperty("queryString") && !$util$1.isString(g.queryString)) return "queryString: string expected";
    if (g.widgetStates != null && g.hasOwnProperty("widgetStates")) {
      let d = $root$1.WidgetStates.verify(g.widgetStates);
      if (d) return "widgetStates." + d;
    }
    if (g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && !$util$1.isString(g.pageScriptHash)) return "pageScriptHash: string expected";
    if (g.pageName != null && g.hasOwnProperty("pageName") && !$util$1.isString(g.pageName)) return "pageName: string expected";
    if (g.fragmentId != null && g.hasOwnProperty("fragmentId") && !$util$1.isString(g.fragmentId)) return "fragmentId: string expected";
    if (g.isAutoRerun != null && g.hasOwnProperty("isAutoRerun") && typeof g.isAutoRerun != "boolean") return "isAutoRerun: boolean expected";
    if (g.cachedMessageHashes != null && g.hasOwnProperty("cachedMessageHashes")) {
      if (!Array.isArray(g.cachedMessageHashes)) return "cachedMessageHashes: array expected";
      for (let d = 0; d < g.cachedMessageHashes.length; ++d) if (!$util$1.isString(g.cachedMessageHashes[d])) return "cachedMessageHashes: string[] expected";
    }
    if (g.contextInfo != null && g.hasOwnProperty("contextInfo")) {
      let d = $root$1.ContextInfo.verify(g.contextInfo);
      if (d) return "contextInfo." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ClientState) return g;
    let d = new $root$1.ClientState();
    if (g.queryString != null && (d.queryString = String(g.queryString)), g.widgetStates != null) {
      if (typeof g.widgetStates != "object") throw TypeError(".ClientState.widgetStates: object expected");
      d.widgetStates = $root$1.WidgetStates.fromObject(g.widgetStates);
    }
    if (g.pageScriptHash != null && (d.pageScriptHash = String(g.pageScriptHash)), g.pageName != null && (d.pageName = String(g.pageName)), g.fragmentId != null && (d.fragmentId = String(g.fragmentId)), g.isAutoRerun != null && (d.isAutoRerun = !!g.isAutoRerun), g.cachedMessageHashes) {
      if (!Array.isArray(g.cachedMessageHashes)) throw TypeError(".ClientState.cachedMessageHashes: array expected");
      d.cachedMessageHashes = [];
      for (let k = 0; k < g.cachedMessageHashes.length; ++k) d.cachedMessageHashes[k] = String(g.cachedMessageHashes[k]);
    }
    if (g.contextInfo != null) {
      if (typeof g.contextInfo != "object") throw TypeError(".ClientState.contextInfo: object expected");
      d.contextInfo = $root$1.ContextInfo.fromObject(g.contextInfo);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.cachedMessageHashes = []), d.defaults && (k.queryString = "", k.widgetStates = null, k.pageScriptHash = "", k.pageName = "", k.fragmentId = "", k.isAutoRerun = !1, k.contextInfo = null), g.queryString != null && g.hasOwnProperty("queryString") && (k.queryString = g.queryString), g.widgetStates != null && g.hasOwnProperty("widgetStates") && (k.widgetStates = $root$1.WidgetStates.toObject(g.widgetStates, d)), g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (k.pageScriptHash = g.pageScriptHash), g.pageName != null && g.hasOwnProperty("pageName") && (k.pageName = g.pageName), g.fragmentId != null && g.hasOwnProperty("fragmentId") && (k.fragmentId = g.fragmentId), g.isAutoRerun != null && g.hasOwnProperty("isAutoRerun") && (k.isAutoRerun = g.isAutoRerun), g.cachedMessageHashes && g.cachedMessageHashes.length) {
      k.cachedMessageHashes = [];
      for (let H = 0; H < g.cachedMessageHashes.length; ++H) k.cachedMessageHashes[H] = g.cachedMessageHashes[H];
    }
    return g.contextInfo != null && g.hasOwnProperty("contextInfo") && (k.contextInfo = $root$1.ContextInfo.toObject(g.contextInfo, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ClientState";
  }, n;
})();
const WidgetStates = $root$1.WidgetStates = (() => {
  function n(t) {
    if (this.widgets = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.widgets = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.widgets != null && g.widgets.length) for (let k = 0; k < g.widgets.length; ++k) $root$1.WidgetState.encode(g.widgets[k], d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.WidgetStates();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.widgets && AA.widgets.length || (AA.widgets = []), AA.widgets.push($root$1.WidgetState.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.widgets != null && g.hasOwnProperty("widgets")) {
      if (!Array.isArray(g.widgets)) return "widgets: array expected";
      for (let d = 0; d < g.widgets.length; ++d) {
        let k = $root$1.WidgetState.verify(g.widgets[d]);
        if (k) return "widgets." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.WidgetStates) return g;
    let d = new $root$1.WidgetStates();
    if (g.widgets) {
      if (!Array.isArray(g.widgets)) throw TypeError(".WidgetStates.widgets: array expected");
      d.widgets = [];
      for (let k = 0; k < g.widgets.length; ++k) {
        if (typeof g.widgets[k] != "object") throw TypeError(".WidgetStates.widgets: object expected");
        d.widgets[k] = $root$1.WidgetState.fromObject(g.widgets[k]);
      }
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.widgets = []), g.widgets && g.widgets.length) {
      k.widgets = [];
      for (let H = 0; H < g.widgets.length; ++H) k.widgets[H] = $root$1.WidgetState.toObject(g.widgets[H], d);
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/WidgetStates";
  }, n;
})(), WidgetState = $root$1.WidgetState = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.triggerValue = null, n.prototype.boolValue = null, n.prototype.doubleValue = null, n.prototype.intValue = null, n.prototype.stringValue = null, n.prototype.doubleArrayValue = null, n.prototype.intArrayValue = null, n.prototype.stringArrayValue = null, n.prototype.jsonValue = null, n.prototype.arrowValue = null, n.prototype.bytesValue = null, n.prototype.fileUploaderStateValue = null, n.prototype.stringTriggerValue = null, n.prototype.chatInputValue = null;
  let t;
  return Object.defineProperty(n.prototype, "value", { get: $util$1.oneOfGetter(t = ["triggerValue", "boolValue", "doubleValue", "intValue", "stringValue", "doubleArrayValue", "intArrayValue", "stringArrayValue", "jsonValue", "arrowValue", "bytesValue", "fileUploaderStateValue", "stringTriggerValue", "chatInputValue"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.id), d.triggerValue != null && Object.hasOwnProperty.call(d, "triggerValue") && k.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(d.triggerValue), d.boolValue != null && Object.hasOwnProperty.call(d, "boolValue") && k.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(d.boolValue), d.doubleValue != null && Object.hasOwnProperty.call(d, "doubleValue") && k.uint32(
      /* id 4, wireType 1 =*/
      33
    ).double(d.doubleValue), d.intValue != null && Object.hasOwnProperty.call(d, "intValue") && k.uint32(
      /* id 5, wireType 0 =*/
      40
    ).sint64(d.intValue), d.stringValue != null && Object.hasOwnProperty.call(d, "stringValue") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.stringValue), d.doubleArrayValue != null && Object.hasOwnProperty.call(d, "doubleArrayValue") && $root$1.DoubleArray.encode(d.doubleArrayValue, k.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), d.intArrayValue != null && Object.hasOwnProperty.call(d, "intArrayValue") && $root$1.SInt64Array.encode(d.intArrayValue, k.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), d.stringArrayValue != null && Object.hasOwnProperty.call(d, "stringArrayValue") && $root$1.StringArray.encode(d.stringArrayValue, k.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), d.jsonValue != null && Object.hasOwnProperty.call(d, "jsonValue") && k.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(d.jsonValue), d.arrowValue != null && Object.hasOwnProperty.call(d, "arrowValue") && $root$1.ArrowTable.encode(d.arrowValue, k.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), d.bytesValue != null && Object.hasOwnProperty.call(d, "bytesValue") && k.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(d.bytesValue), d.fileUploaderStateValue != null && Object.hasOwnProperty.call(d, "fileUploaderStateValue") && $root$1.FileUploaderState.encode(d.fileUploaderStateValue, k.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), d.stringTriggerValue != null && Object.hasOwnProperty.call(d, "stringTriggerValue") && $root$1.StringTriggerValue.encode(d.stringTriggerValue, k.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), d.chatInputValue != null && Object.hasOwnProperty.call(d, "chatInputValue") && $root$1.ChatInputValue.encode(d.chatInputValue, k.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.WidgetState();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.id = d.string();
          break;
        }
        case 2: {
          gA.triggerValue = d.bool();
          break;
        }
        case 3: {
          gA.boolValue = d.bool();
          break;
        }
        case 4: {
          gA.doubleValue = d.double();
          break;
        }
        case 5: {
          gA.intValue = d.sint64();
          break;
        }
        case 6: {
          gA.stringValue = d.string();
          break;
        }
        case 7: {
          gA.doubleArrayValue = $root$1.DoubleArray.decode(d, d.uint32());
          break;
        }
        case 8: {
          gA.intArrayValue = $root$1.SInt64Array.decode(d, d.uint32());
          break;
        }
        case 9: {
          gA.stringArrayValue = $root$1.StringArray.decode(d, d.uint32());
          break;
        }
        case 10: {
          gA.jsonValue = d.string();
          break;
        }
        case 11: {
          gA.arrowValue = $root$1.ArrowTable.decode(d, d.uint32());
          break;
        }
        case 12: {
          gA.bytesValue = d.bytes();
          break;
        }
        case 13: {
          gA.fileUploaderStateValue = $root$1.FileUploaderState.decode(d, d.uint32());
          break;
        }
        case 14: {
          gA.stringTriggerValue = $root$1.StringTriggerValue.decode(d, d.uint32());
          break;
        }
        case 15: {
          gA.chatInputValue = $root$1.ChatInputValue.decode(d, d.uint32());
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.triggerValue != null && d.hasOwnProperty("triggerValue") && (k.value = 1, typeof d.triggerValue != "boolean"))
      return "triggerValue: boolean expected";
    if (d.boolValue != null && d.hasOwnProperty("boolValue")) {
      if (k.value === 1) return "value: multiple values";
      if (k.value = 1, typeof d.boolValue != "boolean") return "boolValue: boolean expected";
    }
    if (d.doubleValue != null && d.hasOwnProperty("doubleValue")) {
      if (k.value === 1) return "value: multiple values";
      if (k.value = 1, typeof d.doubleValue != "number") return "doubleValue: number expected";
    }
    if (d.intValue != null && d.hasOwnProperty("intValue")) {
      if (k.value === 1) return "value: multiple values";
      if (k.value = 1, !$util$1.isInteger(d.intValue) && !(d.intValue && $util$1.isInteger(d.intValue.low) && $util$1.isInteger(d.intValue.high))) return "intValue: integer|Long expected";
    }
    if (d.stringValue != null && d.hasOwnProperty("stringValue")) {
      if (k.value === 1) return "value: multiple values";
      if (k.value = 1, !$util$1.isString(d.stringValue)) return "stringValue: string expected";
    }
    if (d.doubleArrayValue != null && d.hasOwnProperty("doubleArrayValue")) {
      if (k.value === 1) return "value: multiple values";
      k.value = 1;
      {
        let H = $root$1.DoubleArray.verify(d.doubleArrayValue);
        if (H) return "doubleArrayValue." + H;
      }
    }
    if (d.intArrayValue != null && d.hasOwnProperty("intArrayValue")) {
      if (k.value === 1) return "value: multiple values";
      k.value = 1;
      {
        let H = $root$1.SInt64Array.verify(d.intArrayValue);
        if (H) return "intArrayValue." + H;
      }
    }
    if (d.stringArrayValue != null && d.hasOwnProperty("stringArrayValue")) {
      if (k.value === 1) return "value: multiple values";
      k.value = 1;
      {
        let H = $root$1.StringArray.verify(d.stringArrayValue);
        if (H) return "stringArrayValue." + H;
      }
    }
    if (d.jsonValue != null && d.hasOwnProperty("jsonValue")) {
      if (k.value === 1) return "value: multiple values";
      if (k.value = 1, !$util$1.isString(d.jsonValue)) return "jsonValue: string expected";
    }
    if (d.arrowValue != null && d.hasOwnProperty("arrowValue")) {
      if (k.value === 1) return "value: multiple values";
      k.value = 1;
      {
        let H = $root$1.ArrowTable.verify(d.arrowValue);
        if (H) return "arrowValue." + H;
      }
    }
    if (d.bytesValue != null && d.hasOwnProperty("bytesValue")) {
      if (k.value === 1) return "value: multiple values";
      if (k.value = 1, !(d.bytesValue && typeof d.bytesValue.length == "number" || $util$1.isString(d.bytesValue))) return "bytesValue: buffer expected";
    }
    if (d.fileUploaderStateValue != null && d.hasOwnProperty("fileUploaderStateValue")) {
      if (k.value === 1) return "value: multiple values";
      k.value = 1;
      {
        let H = $root$1.FileUploaderState.verify(d.fileUploaderStateValue);
        if (H) return "fileUploaderStateValue." + H;
      }
    }
    if (d.stringTriggerValue != null && d.hasOwnProperty("stringTriggerValue")) {
      if (k.value === 1) return "value: multiple values";
      k.value = 1;
      {
        let H = $root$1.StringTriggerValue.verify(d.stringTriggerValue);
        if (H) return "stringTriggerValue." + H;
      }
    }
    if (d.chatInputValue != null && d.hasOwnProperty("chatInputValue")) {
      if (k.value === 1) return "value: multiple values";
      k.value = 1;
      {
        let H = $root$1.ChatInputValue.verify(d.chatInputValue);
        if (H) return "chatInputValue." + H;
      }
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.WidgetState) return d;
    let k = new $root$1.WidgetState();
    if (d.id != null && (k.id = String(d.id)), d.triggerValue != null && (k.triggerValue = !!d.triggerValue), d.boolValue != null && (k.boolValue = !!d.boolValue), d.doubleValue != null && (k.doubleValue = Number(d.doubleValue)), d.intValue != null && ($util$1.Long ? (k.intValue = $util$1.Long.fromValue(d.intValue)).unsigned = !1 : typeof d.intValue == "string" ? k.intValue = parseInt(d.intValue, 10) : typeof d.intValue == "number" ? k.intValue = d.intValue : typeof d.intValue == "object" && (k.intValue = new $util$1.LongBits(d.intValue.low >>> 0, d.intValue.high >>> 0).toNumber())), d.stringValue != null && (k.stringValue = String(d.stringValue)), d.doubleArrayValue != null) {
      if (typeof d.doubleArrayValue != "object") throw TypeError(".WidgetState.doubleArrayValue: object expected");
      k.doubleArrayValue = $root$1.DoubleArray.fromObject(d.doubleArrayValue);
    }
    if (d.intArrayValue != null) {
      if (typeof d.intArrayValue != "object") throw TypeError(".WidgetState.intArrayValue: object expected");
      k.intArrayValue = $root$1.SInt64Array.fromObject(d.intArrayValue);
    }
    if (d.stringArrayValue != null) {
      if (typeof d.stringArrayValue != "object") throw TypeError(".WidgetState.stringArrayValue: object expected");
      k.stringArrayValue = $root$1.StringArray.fromObject(d.stringArrayValue);
    }
    if (d.jsonValue != null && (k.jsonValue = String(d.jsonValue)), d.arrowValue != null) {
      if (typeof d.arrowValue != "object") throw TypeError(".WidgetState.arrowValue: object expected");
      k.arrowValue = $root$1.ArrowTable.fromObject(d.arrowValue);
    }
    if (d.bytesValue != null && (typeof d.bytesValue == "string" ? $util$1.base64.decode(d.bytesValue, k.bytesValue = $util$1.newBuffer($util$1.base64.length(d.bytesValue)), 0) : d.bytesValue.length >= 0 && (k.bytesValue = d.bytesValue)), d.fileUploaderStateValue != null) {
      if (typeof d.fileUploaderStateValue != "object") throw TypeError(".WidgetState.fileUploaderStateValue: object expected");
      k.fileUploaderStateValue = $root$1.FileUploaderState.fromObject(d.fileUploaderStateValue);
    }
    if (d.stringTriggerValue != null) {
      if (typeof d.stringTriggerValue != "object") throw TypeError(".WidgetState.stringTriggerValue: object expected");
      k.stringTriggerValue = $root$1.StringTriggerValue.fromObject(d.stringTriggerValue);
    }
    if (d.chatInputValue != null) {
      if (typeof d.chatInputValue != "object") throw TypeError(".WidgetState.chatInputValue: object expected");
      k.chatInputValue = $root$1.ChatInputValue.fromObject(d.chatInputValue);
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.id = ""), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.triggerValue != null && d.hasOwnProperty("triggerValue") && (H.triggerValue = d.triggerValue, k.oneofs && (H.value = "triggerValue")), d.boolValue != null && d.hasOwnProperty("boolValue") && (H.boolValue = d.boolValue, k.oneofs && (H.value = "boolValue")), d.doubleValue != null && d.hasOwnProperty("doubleValue") && (H.doubleValue = k.json && !isFinite(d.doubleValue) ? String(d.doubleValue) : d.doubleValue, k.oneofs && (H.value = "doubleValue")), d.intValue != null && d.hasOwnProperty("intValue") && (typeof d.intValue == "number" ? H.intValue = k.longs === String ? String(d.intValue) : d.intValue : H.intValue = k.longs === String ? $util$1.Long.prototype.toString.call(d.intValue) : k.longs === Number ? new $util$1.LongBits(d.intValue.low >>> 0, d.intValue.high >>> 0).toNumber() : d.intValue, k.oneofs && (H.value = "intValue")), d.stringValue != null && d.hasOwnProperty("stringValue") && (H.stringValue = d.stringValue, k.oneofs && (H.value = "stringValue")), d.doubleArrayValue != null && d.hasOwnProperty("doubleArrayValue") && (H.doubleArrayValue = $root$1.DoubleArray.toObject(d.doubleArrayValue, k), k.oneofs && (H.value = "doubleArrayValue")), d.intArrayValue != null && d.hasOwnProperty("intArrayValue") && (H.intArrayValue = $root$1.SInt64Array.toObject(d.intArrayValue, k), k.oneofs && (H.value = "intArrayValue")), d.stringArrayValue != null && d.hasOwnProperty("stringArrayValue") && (H.stringArrayValue = $root$1.StringArray.toObject(d.stringArrayValue, k), k.oneofs && (H.value = "stringArrayValue")), d.jsonValue != null && d.hasOwnProperty("jsonValue") && (H.jsonValue = d.jsonValue, k.oneofs && (H.value = "jsonValue")), d.arrowValue != null && d.hasOwnProperty("arrowValue") && (H.arrowValue = $root$1.ArrowTable.toObject(d.arrowValue, k), k.oneofs && (H.value = "arrowValue")), d.bytesValue != null && d.hasOwnProperty("bytesValue") && (H.bytesValue = k.bytes === String ? $util$1.base64.encode(d.bytesValue, 0, d.bytesValue.length) : k.bytes === Array ? Array.prototype.slice.call(d.bytesValue) : d.bytesValue, k.oneofs && (H.value = "bytesValue")), d.fileUploaderStateValue != null && d.hasOwnProperty("fileUploaderStateValue") && (H.fileUploaderStateValue = $root$1.FileUploaderState.toObject(d.fileUploaderStateValue, k), k.oneofs && (H.value = "fileUploaderStateValue")), d.stringTriggerValue != null && d.hasOwnProperty("stringTriggerValue") && (H.stringTriggerValue = $root$1.StringTriggerValue.toObject(d.stringTriggerValue, k), k.oneofs && (H.value = "stringTriggerValue")), d.chatInputValue != null && d.hasOwnProperty("chatInputValue") && (H.chatInputValue = $root$1.ChatInputValue.toObject(d.chatInputValue, k), k.oneofs && (H.value = "chatInputValue")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/WidgetState";
  }, n;
})(), StringArray = $root$1.StringArray = (() => {
  function n(t) {
    if (this.data = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.data != null && g.data.length) for (let k = 0; k < g.data.length; ++k) d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.data[k]);
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.StringArray();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.data && AA.data.length || (AA.data = []), AA.data.push(g.string());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      if (!Array.isArray(g.data)) return "data: array expected";
      for (let d = 0; d < g.data.length; ++d) if (!$util$1.isString(g.data[d])) return "data: string[] expected";
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.StringArray) return g;
    let d = new $root$1.StringArray();
    if (g.data) {
      if (!Array.isArray(g.data)) throw TypeError(".StringArray.data: array expected");
      d.data = [];
      for (let k = 0; k < g.data.length; ++k) d.data[k] = String(g.data[k]);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.data = []), g.data && g.data.length) {
      k.data = [];
      for (let H = 0; H < g.data.length; ++H) k.data[H] = g.data[H];
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/StringArray";
  }, n;
})(), DoubleArray = $root$1.DoubleArray = (() => {
  function n(t) {
    if (this.data = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.data != null && g.data.length) {
      d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let k = 0; k < g.data.length; ++k) d.double(g.data[k]);
      d.ldelim();
    }
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.DoubleArray();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          if (AA.data && AA.data.length || (AA.data = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.data.push(g.double());
          } else AA.data.push(g.double());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      if (!Array.isArray(g.data)) return "data: array expected";
      for (let d = 0; d < g.data.length; ++d) if (typeof g.data[d] != "number") return "data: number[] expected";
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.DoubleArray) return g;
    let d = new $root$1.DoubleArray();
    if (g.data) {
      if (!Array.isArray(g.data)) throw TypeError(".DoubleArray.data: array expected");
      d.data = [];
      for (let k = 0; k < g.data.length; ++k) d.data[k] = Number(g.data[k]);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.data = []), g.data && g.data.length) {
      k.data = [];
      for (let H = 0; H < g.data.length; ++H) k.data[H] = d.json && !isFinite(g.data[H]) ? String(g.data[H]) : g.data[H];
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DoubleArray";
  }, n;
})();
$root$1.Int32Array = (() => {
  function n(t) {
    if (this.data = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.data != null && g.data.length) {
      d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let k = 0; k < g.data.length; ++k) d.int32(g.data[k]);
      d.ldelim();
    }
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Int32Array();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          if (AA.data && AA.data.length || (AA.data = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.data.push(g.int32());
          } else AA.data.push(g.int32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      if (!Array.isArray(g.data)) return "data: array expected";
      for (let d = 0; d < g.data.length; ++d) if (!$util$1.isInteger(g.data[d])) return "data: integer[] expected";
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Int32Array) return g;
    let d = new $root$1.Int32Array();
    if (g.data) {
      if (!Array.isArray(g.data)) throw TypeError(".Int32Array.data: array expected");
      d.data = [];
      for (let k = 0; k < g.data.length; ++k) d.data[k] = g.data[k] | 0;
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.data = []), g.data && g.data.length) {
      k.data = [];
      for (let H = 0; H < g.data.length; ++H) k.data[H] = g.data[H];
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Int32Array";
  }, n;
})();
$root$1.Int64Array = (() => {
  function n(t) {
    if (this.data = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.data != null && g.data.length) {
      d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let k = 0; k < g.data.length; ++k) d.int64(g.data[k]);
      d.ldelim();
    }
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Int64Array();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          if (AA.data && AA.data.length || (AA.data = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.data.push(g.int64());
          } else AA.data.push(g.int64());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      if (!Array.isArray(g.data)) return "data: array expected";
      for (let d = 0; d < g.data.length; ++d) if (!$util$1.isInteger(g.data[d]) && !(g.data[d] && $util$1.isInteger(g.data[d].low) && $util$1.isInteger(g.data[d].high))) return "data: integer|Long[] expected";
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Int64Array) return g;
    let d = new $root$1.Int64Array();
    if (g.data) {
      if (!Array.isArray(g.data)) throw TypeError(".Int64Array.data: array expected");
      d.data = [];
      for (let k = 0; k < g.data.length; ++k) $util$1.Long ? (d.data[k] = $util$1.Long.fromValue(g.data[k])).unsigned = !1 : typeof g.data[k] == "string" ? d.data[k] = parseInt(g.data[k], 10) : typeof g.data[k] == "number" ? d.data[k] = g.data[k] : typeof g.data[k] == "object" && (d.data[k] = new $util$1.LongBits(g.data[k].low >>> 0, g.data[k].high >>> 0).toNumber());
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.data = []), g.data && g.data.length) {
      k.data = [];
      for (let H = 0; H < g.data.length; ++H) typeof g.data[H] == "number" ? k.data[H] = d.longs === String ? String(g.data[H]) : g.data[H] : k.data[H] = d.longs === String ? $util$1.Long.prototype.toString.call(g.data[H]) : d.longs === Number ? new $util$1.LongBits(g.data[H].low >>> 0, g.data[H].high >>> 0).toNumber() : g.data[H];
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Int64Array";
  }, n;
})();
const SInt64Array = $root$1.SInt64Array = (() => {
  function n(t) {
    if (this.data = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.data != null && g.data.length) {
      d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let k = 0; k < g.data.length; ++k) d.sint64(g.data[k]);
      d.ldelim();
    }
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.SInt64Array();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          if (AA.data && AA.data.length || (AA.data = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.data.push(g.sint64());
          } else AA.data.push(g.sint64());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      if (!Array.isArray(g.data)) return "data: array expected";
      for (let d = 0; d < g.data.length; ++d) if (!$util$1.isInteger(g.data[d]) && !(g.data[d] && $util$1.isInteger(g.data[d].low) && $util$1.isInteger(g.data[d].high))) return "data: integer|Long[] expected";
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.SInt64Array) return g;
    let d = new $root$1.SInt64Array();
    if (g.data) {
      if (!Array.isArray(g.data)) throw TypeError(".SInt64Array.data: array expected");
      d.data = [];
      for (let k = 0; k < g.data.length; ++k) $util$1.Long ? (d.data[k] = $util$1.Long.fromValue(g.data[k])).unsigned = !1 : typeof g.data[k] == "string" ? d.data[k] = parseInt(g.data[k], 10) : typeof g.data[k] == "number" ? d.data[k] = g.data[k] : typeof g.data[k] == "object" && (d.data[k] = new $util$1.LongBits(g.data[k].low >>> 0, g.data[k].high >>> 0).toNumber());
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.data = []), g.data && g.data.length) {
      k.data = [];
      for (let H = 0; H < g.data.length; ++H) typeof g.data[H] == "number" ? k.data[H] = d.longs === String ? String(g.data[H]) : g.data[H] : k.data[H] = d.longs === String ? $util$1.Long.prototype.toString.call(g.data[H]) : d.longs === Number ? new $util$1.LongBits(g.data[H].low >>> 0, g.data[H].high >>> 0).toNumber() : g.data[H];
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/SInt64Array";
  }, n;
})();
$root$1.UInt32Array = (() => {
  function n(t) {
    if (this.data = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.data != null && g.data.length) {
      d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let k = 0; k < g.data.length; ++k) d.uint32(g.data[k]);
      d.ldelim();
    }
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.UInt32Array();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          if (AA.data && AA.data.length || (AA.data = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.data.push(g.uint32());
          } else AA.data.push(g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      if (!Array.isArray(g.data)) return "data: array expected";
      for (let d = 0; d < g.data.length; ++d) if (!$util$1.isInteger(g.data[d])) return "data: integer[] expected";
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.UInt32Array) return g;
    let d = new $root$1.UInt32Array();
    if (g.data) {
      if (!Array.isArray(g.data)) throw TypeError(".UInt32Array.data: array expected");
      d.data = [];
      for (let k = 0; k < g.data.length; ++k) d.data[k] = g.data[k] >>> 0;
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.data = []), g.data && g.data.length) {
      k.data = [];
      for (let H = 0; H < g.data.length; ++H) k.data[H] = g.data[H];
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/UInt32Array";
  }, n;
})();
$root$1.StringTriggerValue = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.data = null;
  let t;
  return Object.defineProperty(n.prototype, "_data", { get: $util$1.oneOfGetter(t = ["data"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.data != null && Object.hasOwnProperty.call(d, "data") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.data), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.StringTriggerValue();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.data = d.string();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    return typeof d != "object" || d === null ? "object expected" : d.data != null && d.hasOwnProperty("data") && !$util$1.isString(d.data) ? "data: string expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.StringTriggerValue) return d;
    let k = new $root$1.StringTriggerValue();
    return d.data != null && (k.data = String(d.data)), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return d.data != null && d.hasOwnProperty("data") && (H.data = d.data, k.oneofs && (H._data = "data")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/StringTriggerValue";
  }, n;
})();
$root$1.FileURLsRequest = (() => {
  function n(t) {
    if (this.fileNames = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.requestId = "", n.prototype.fileNames = $util$1.emptyArray, n.prototype.sessionId = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.requestId != null && Object.hasOwnProperty.call(g, "requestId") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.requestId), g.fileNames != null && g.fileNames.length) for (let k = 0; k < g.fileNames.length; ++k) d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.fileNames[k]);
    return g.sessionId != null && Object.hasOwnProperty.call(g, "sessionId") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.sessionId), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.FileURLsRequest();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.requestId = g.string();
          break;
        }
        case 2: {
          AA.fileNames && AA.fileNames.length || (AA.fileNames = []), AA.fileNames.push(g.string());
          break;
        }
        case 3: {
          AA.sessionId = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.requestId != null && g.hasOwnProperty("requestId") && !$util$1.isString(g.requestId)) return "requestId: string expected";
    if (g.fileNames != null && g.hasOwnProperty("fileNames")) {
      if (!Array.isArray(g.fileNames)) return "fileNames: array expected";
      for (let d = 0; d < g.fileNames.length; ++d) if (!$util$1.isString(g.fileNames[d])) return "fileNames: string[] expected";
    }
    return g.sessionId != null && g.hasOwnProperty("sessionId") && !$util$1.isString(g.sessionId) ? "sessionId: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.FileURLsRequest) return g;
    let d = new $root$1.FileURLsRequest();
    if (g.requestId != null && (d.requestId = String(g.requestId)), g.fileNames) {
      if (!Array.isArray(g.fileNames)) throw TypeError(".FileURLsRequest.fileNames: array expected");
      d.fileNames = [];
      for (let k = 0; k < g.fileNames.length; ++k) d.fileNames[k] = String(g.fileNames[k]);
    }
    return g.sessionId != null && (d.sessionId = String(g.sessionId)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.fileNames = []), d.defaults && (k.requestId = "", k.sessionId = ""), g.requestId != null && g.hasOwnProperty("requestId") && (k.requestId = g.requestId), g.fileNames && g.fileNames.length) {
      k.fileNames = [];
      for (let H = 0; H < g.fileNames.length; ++H) k.fileNames[H] = g.fileNames[H];
    }
    return g.sessionId != null && g.hasOwnProperty("sessionId") && (k.sessionId = g.sessionId), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FileURLsRequest";
  }, n;
})();
$root$1.FileURLs = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.fileId = "", n.prototype.uploadUrl = "", n.prototype.deleteUrl = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.fileId != null && Object.hasOwnProperty.call(g, "fileId") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.fileId), g.uploadUrl != null && Object.hasOwnProperty.call(g, "uploadUrl") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.uploadUrl), g.deleteUrl != null && Object.hasOwnProperty.call(g, "deleteUrl") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.deleteUrl), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.FileURLs();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.fileId = g.string();
          break;
        }
        case 2: {
          AA.uploadUrl = g.string();
          break;
        }
        case 3: {
          AA.deleteUrl = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.fileId != null && g.hasOwnProperty("fileId") && !$util$1.isString(g.fileId) ? "fileId: string expected" : g.uploadUrl != null && g.hasOwnProperty("uploadUrl") && !$util$1.isString(g.uploadUrl) ? "uploadUrl: string expected" : g.deleteUrl != null && g.hasOwnProperty("deleteUrl") && !$util$1.isString(g.deleteUrl) ? "deleteUrl: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.FileURLs) return g;
    let d = new $root$1.FileURLs();
    return g.fileId != null && (d.fileId = String(g.fileId)), g.uploadUrl != null && (d.uploadUrl = String(g.uploadUrl)), g.deleteUrl != null && (d.deleteUrl = String(g.deleteUrl)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.fileId = "", k.uploadUrl = "", k.deleteUrl = ""), g.fileId != null && g.hasOwnProperty("fileId") && (k.fileId = g.fileId), g.uploadUrl != null && g.hasOwnProperty("uploadUrl") && (k.uploadUrl = g.uploadUrl), g.deleteUrl != null && g.hasOwnProperty("deleteUrl") && (k.deleteUrl = g.deleteUrl), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FileURLs";
  }, n;
})();
$root$1.FileURLsResponse = (() => {
  function n(t) {
    if (this.fileUrls = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.responseId = "", n.prototype.fileUrls = $util$1.emptyArray, n.prototype.errorMsg = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.responseId != null && Object.hasOwnProperty.call(g, "responseId") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.responseId), g.fileUrls != null && g.fileUrls.length) for (let k = 0; k < g.fileUrls.length; ++k) $root$1.FileURLs.encode(g.fileUrls[k], d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return g.errorMsg != null && Object.hasOwnProperty.call(g, "errorMsg") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.errorMsg), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.FileURLsResponse();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.responseId = g.string();
          break;
        }
        case 2: {
          AA.fileUrls && AA.fileUrls.length || (AA.fileUrls = []), AA.fileUrls.push($root$1.FileURLs.decode(g, g.uint32()));
          break;
        }
        case 3: {
          AA.errorMsg = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.responseId != null && g.hasOwnProperty("responseId") && !$util$1.isString(g.responseId)) return "responseId: string expected";
    if (g.fileUrls != null && g.hasOwnProperty("fileUrls")) {
      if (!Array.isArray(g.fileUrls)) return "fileUrls: array expected";
      for (let d = 0; d < g.fileUrls.length; ++d) {
        let k = $root$1.FileURLs.verify(g.fileUrls[d]);
        if (k) return "fileUrls." + k;
      }
    }
    return g.errorMsg != null && g.hasOwnProperty("errorMsg") && !$util$1.isString(g.errorMsg) ? "errorMsg: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.FileURLsResponse) return g;
    let d = new $root$1.FileURLsResponse();
    if (g.responseId != null && (d.responseId = String(g.responseId)), g.fileUrls) {
      if (!Array.isArray(g.fileUrls)) throw TypeError(".FileURLsResponse.fileUrls: array expected");
      d.fileUrls = [];
      for (let k = 0; k < g.fileUrls.length; ++k) {
        if (typeof g.fileUrls[k] != "object") throw TypeError(".FileURLsResponse.fileUrls: object expected");
        d.fileUrls[k] = $root$1.FileURLs.fromObject(g.fileUrls[k]);
      }
    }
    return g.errorMsg != null && (d.errorMsg = String(g.errorMsg)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.fileUrls = []), d.defaults && (k.responseId = "", k.errorMsg = ""), g.responseId != null && g.hasOwnProperty("responseId") && (k.responseId = g.responseId), g.fileUrls && g.fileUrls.length) {
      k.fileUrls = [];
      for (let H = 0; H < g.fileUrls.length; ++H) k.fileUrls[H] = $root$1.FileURLs.toObject(g.fileUrls[H], d);
    }
    return g.errorMsg != null && g.hasOwnProperty("errorMsg") && (k.errorMsg = g.errorMsg), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FileURLsResponse";
  }, n;
})();
const UploadedFileInfo = $root$1.UploadedFileInfo = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, n.prototype.name = "", n.prototype.size = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, n.prototype.fileId = "", n.prototype.fileUrls = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(g.id), g.name != null && Object.hasOwnProperty.call(g, "name") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.name), g.size != null && Object.hasOwnProperty.call(g, "size") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint64(g.size), g.fileId != null && Object.hasOwnProperty.call(g, "fileId") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.fileId), g.fileUrls != null && Object.hasOwnProperty.call(g, "fileUrls") && $root$1.FileURLs.encode(g.fileUrls, d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.UploadedFileInfo();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.sint64();
          break;
        }
        case 2: {
          AA.name = g.string();
          break;
        }
        case 3: {
          AA.size = g.uint64();
          break;
        }
        case 4: {
          AA.fileId = g.string();
          break;
        }
        case 5: {
          AA.fileUrls = $root$1.FileURLs.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util$1.isInteger(g.id) && !(g.id && $util$1.isInteger(g.id.low) && $util$1.isInteger(g.id.high))) return "id: integer|Long expected";
    if (g.name != null && g.hasOwnProperty("name") && !$util$1.isString(g.name)) return "name: string expected";
    if (g.size != null && g.hasOwnProperty("size") && !$util$1.isInteger(g.size) && !(g.size && $util$1.isInteger(g.size.low) && $util$1.isInteger(g.size.high))) return "size: integer|Long expected";
    if (g.fileId != null && g.hasOwnProperty("fileId") && !$util$1.isString(g.fileId)) return "fileId: string expected";
    if (g.fileUrls != null && g.hasOwnProperty("fileUrls")) {
      let d = $root$1.FileURLs.verify(g.fileUrls);
      if (d) return "fileUrls." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.UploadedFileInfo) return g;
    let d = new $root$1.UploadedFileInfo();
    if (g.id != null && ($util$1.Long ? (d.id = $util$1.Long.fromValue(g.id)).unsigned = !1 : typeof g.id == "string" ? d.id = parseInt(g.id, 10) : typeof g.id == "number" ? d.id = g.id : typeof g.id == "object" && (d.id = new $util$1.LongBits(g.id.low >>> 0, g.id.high >>> 0).toNumber())), g.name != null && (d.name = String(g.name)), g.size != null && ($util$1.Long ? (d.size = $util$1.Long.fromValue(g.size)).unsigned = !0 : typeof g.size == "string" ? d.size = parseInt(g.size, 10) : typeof g.size == "number" ? d.size = g.size : typeof g.size == "object" && (d.size = new $util$1.LongBits(g.size.low >>> 0, g.size.high >>> 0).toNumber(!0))), g.fileId != null && (d.fileId = String(g.fileId)), g.fileUrls != null) {
      if (typeof g.fileUrls != "object") throw TypeError(".UploadedFileInfo.fileUrls: object expected");
      d.fileUrls = $root$1.FileURLs.fromObject(g.fileUrls);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if (d.defaults) {
      if ($util$1.Long) {
        let H = new $util$1.Long(0, 0, !1);
        k.id = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
      } else k.id = d.longs === String ? "0" : 0;
      if (k.name = "", $util$1.Long) {
        let H = new $util$1.Long(0, 0, !0);
        k.size = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
      } else k.size = d.longs === String ? "0" : 0;
      k.fileId = "", k.fileUrls = null;
    }
    return g.id != null && g.hasOwnProperty("id") && (typeof g.id == "number" ? k.id = d.longs === String ? String(g.id) : g.id : k.id = d.longs === String ? $util$1.Long.prototype.toString.call(g.id) : d.longs === Number ? new $util$1.LongBits(g.id.low >>> 0, g.id.high >>> 0).toNumber() : g.id), g.name != null && g.hasOwnProperty("name") && (k.name = g.name), g.size != null && g.hasOwnProperty("size") && (typeof g.size == "number" ? k.size = d.longs === String ? String(g.size) : g.size : k.size = d.longs === String ? $util$1.Long.prototype.toString.call(g.size) : d.longs === Number ? new $util$1.LongBits(g.size.low >>> 0, g.size.high >>> 0).toNumber(!0) : g.size), g.fileId != null && g.hasOwnProperty("fileId") && (k.fileId = g.fileId), g.fileUrls != null && g.hasOwnProperty("fileUrls") && (k.fileUrls = $root$1.FileURLs.toObject(g.fileUrls, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/UploadedFileInfo";
  }, n;
})(), FileUploaderState = $root$1.FileUploaderState = (() => {
  function n(t) {
    if (this.uploadedFileInfo = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.maxFileId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, n.prototype.uploadedFileInfo = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.maxFileId != null && Object.hasOwnProperty.call(g, "maxFileId") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(g.maxFileId), g.uploadedFileInfo != null && g.uploadedFileInfo.length) for (let k = 0; k < g.uploadedFileInfo.length; ++k) $root$1.UploadedFileInfo.encode(g.uploadedFileInfo[k], d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.FileUploaderState();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.maxFileId = g.sint64();
          break;
        }
        case 2: {
          AA.uploadedFileInfo && AA.uploadedFileInfo.length || (AA.uploadedFileInfo = []), AA.uploadedFileInfo.push($root$1.UploadedFileInfo.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.maxFileId != null && g.hasOwnProperty("maxFileId") && !$util$1.isInteger(g.maxFileId) && !(g.maxFileId && $util$1.isInteger(g.maxFileId.low) && $util$1.isInteger(g.maxFileId.high))) return "maxFileId: integer|Long expected";
    if (g.uploadedFileInfo != null && g.hasOwnProperty("uploadedFileInfo")) {
      if (!Array.isArray(g.uploadedFileInfo)) return "uploadedFileInfo: array expected";
      for (let d = 0; d < g.uploadedFileInfo.length; ++d) {
        let k = $root$1.UploadedFileInfo.verify(g.uploadedFileInfo[d]);
        if (k) return "uploadedFileInfo." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.FileUploaderState) return g;
    let d = new $root$1.FileUploaderState();
    if (g.maxFileId != null && ($util$1.Long ? (d.maxFileId = $util$1.Long.fromValue(g.maxFileId)).unsigned = !1 : typeof g.maxFileId == "string" ? d.maxFileId = parseInt(g.maxFileId, 10) : typeof g.maxFileId == "number" ? d.maxFileId = g.maxFileId : typeof g.maxFileId == "object" && (d.maxFileId = new $util$1.LongBits(g.maxFileId.low >>> 0, g.maxFileId.high >>> 0).toNumber())), g.uploadedFileInfo) {
      if (!Array.isArray(g.uploadedFileInfo)) throw TypeError(".FileUploaderState.uploadedFileInfo: array expected");
      d.uploadedFileInfo = [];
      for (let k = 0; k < g.uploadedFileInfo.length; ++k) {
        if (typeof g.uploadedFileInfo[k] != "object") throw TypeError(".FileUploaderState.uploadedFileInfo: object expected");
        d.uploadedFileInfo[k] = $root$1.UploadedFileInfo.fromObject(g.uploadedFileInfo[k]);
      }
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.uploadedFileInfo = []), d.defaults) if ($util$1.Long) {
      let H = new $util$1.Long(0, 0, !1);
      k.maxFileId = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
    } else k.maxFileId = d.longs === String ? "0" : 0;
    if (g.maxFileId != null && g.hasOwnProperty("maxFileId") && (typeof g.maxFileId == "number" ? k.maxFileId = d.longs === String ? String(g.maxFileId) : g.maxFileId : k.maxFileId = d.longs === String ? $util$1.Long.prototype.toString.call(g.maxFileId) : d.longs === Number ? new $util$1.LongBits(g.maxFileId.low >>> 0, g.maxFileId.high >>> 0).toNumber() : g.maxFileId), g.uploadedFileInfo && g.uploadedFileInfo.length) {
      k.uploadedFileInfo = [];
      for (let H = 0; H < g.uploadedFileInfo.length; ++H) k.uploadedFileInfo[H] = $root$1.UploadedFileInfo.toObject(g.uploadedFileInfo[H], d);
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FileUploaderState";
  }, n;
})(), ChatInputValue = $root$1.ChatInputValue = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.data = null, n.prototype.fileUploaderState = null;
  let t;
  return Object.defineProperty(n.prototype, "_data", { get: $util$1.oneOfGetter(t = ["data"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_fileUploaderState", { get: $util$1.oneOfGetter(t = ["fileUploaderState"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.data != null && Object.hasOwnProperty.call(d, "data") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.data), d.fileUploaderState != null && Object.hasOwnProperty.call(d, "fileUploaderState") && $root$1.FileUploaderState.encode(d.fileUploaderState, k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.ChatInputValue();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.data = d.string();
          break;
        }
        case 2: {
          gA.fileUploaderState = $root$1.FileUploaderState.decode(d, d.uint32());
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.data != null && d.hasOwnProperty("data") && !$util$1.isString(d.data))
      return "data: string expected";
    if (d.fileUploaderState != null && d.hasOwnProperty("fileUploaderState")) {
      let k = $root$1.FileUploaderState.verify(d.fileUploaderState);
      if (k) return "fileUploaderState." + k;
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.ChatInputValue) return d;
    let k = new $root$1.ChatInputValue();
    if (d.data != null && (k.data = String(d.data)), d.fileUploaderState != null) {
      if (typeof d.fileUploaderState != "object") throw TypeError(".ChatInputValue.fileUploaderState: object expected");
      k.fileUploaderState = $root$1.FileUploaderState.fromObject(d.fileUploaderState);
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return d.data != null && d.hasOwnProperty("data") && (H.data = d.data, k.oneofs && (H._data = "data")), d.fileUploaderState != null && d.hasOwnProperty("fileUploaderState") && (H.fileUploaderState = $root$1.FileUploaderState.toObject(d.fileUploaderState, k), k.oneofs && (H._fileUploaderState = "fileUploaderState")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/ChatInputValue";
  }, n;
})();
$root$1.ComponentInstance = (() => {
  function n(g) {
    if (this.specialArgs = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.jsonArgs = "", n.prototype.specialArgs = $util$1.emptyArray, n.prototype.componentName = "", n.prototype.url = "", n.prototype.formId = "", n.prototype.tabIndex = null;
  let t;
  return Object.defineProperty(n.prototype, "_tabIndex", { get: $util$1.oneOfGetter(t = ["tabIndex"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    if (k || (k = $Writer$1.create()), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.id), d.jsonArgs != null && Object.hasOwnProperty.call(d, "jsonArgs") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.jsonArgs), d.specialArgs != null && d.specialArgs.length) for (let H = 0; H < d.specialArgs.length; ++H) $root$1.SpecialArg.encode(d.specialArgs[H], k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim();
    return d.componentName != null && Object.hasOwnProperty.call(d, "componentName") && k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(d.componentName), d.url != null && Object.hasOwnProperty.call(d, "url") && k.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(d.url), d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.formId), d.tabIndex != null && Object.hasOwnProperty.call(d, "tabIndex") && k.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(d.tabIndex), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.ComponentInstance();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.id = d.string();
          break;
        }
        case 2: {
          gA.jsonArgs = d.string();
          break;
        }
        case 3: {
          gA.specialArgs && gA.specialArgs.length || (gA.specialArgs = []), gA.specialArgs.push($root$1.SpecialArg.decode(d, d.uint32()));
          break;
        }
        case 4: {
          gA.componentName = d.string();
          break;
        }
        case 5: {
          gA.url = d.string();
          break;
        }
        case 6: {
          gA.formId = d.string();
          break;
        }
        case 7: {
          gA.tabIndex = d.int32();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.jsonArgs != null && d.hasOwnProperty("jsonArgs") && !$util$1.isString(d.jsonArgs)) return "jsonArgs: string expected";
    if (d.specialArgs != null && d.hasOwnProperty("specialArgs")) {
      if (!Array.isArray(d.specialArgs)) return "specialArgs: array expected";
      for (let k = 0; k < d.specialArgs.length; ++k) {
        let H = $root$1.SpecialArg.verify(d.specialArgs[k]);
        if (H) return "specialArgs." + H;
      }
    }
    return d.componentName != null && d.hasOwnProperty("componentName") && !$util$1.isString(d.componentName) ? "componentName: string expected" : d.url != null && d.hasOwnProperty("url") && !$util$1.isString(d.url) ? "url: string expected" : d.formId != null && d.hasOwnProperty("formId") && !$util$1.isString(d.formId) ? "formId: string expected" : d.tabIndex != null && d.hasOwnProperty("tabIndex") && !$util$1.isInteger(d.tabIndex) ? "tabIndex: integer expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.ComponentInstance) return d;
    let k = new $root$1.ComponentInstance();
    if (d.id != null && (k.id = String(d.id)), d.jsonArgs != null && (k.jsonArgs = String(d.jsonArgs)), d.specialArgs) {
      if (!Array.isArray(d.specialArgs)) throw TypeError(".ComponentInstance.specialArgs: array expected");
      k.specialArgs = [];
      for (let H = 0; H < d.specialArgs.length; ++H) {
        if (typeof d.specialArgs[H] != "object") throw TypeError(".ComponentInstance.specialArgs: object expected");
        k.specialArgs[H] = $root$1.SpecialArg.fromObject(d.specialArgs[H]);
      }
    }
    return d.componentName != null && (k.componentName = String(d.componentName)), d.url != null && (k.url = String(d.url)), d.formId != null && (k.formId = String(d.formId)), d.tabIndex != null && (k.tabIndex = d.tabIndex | 0), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    if ((k.arrays || k.defaults) && (H.specialArgs = []), k.defaults && (H.id = "", H.jsonArgs = "", H.componentName = "", H.url = "", H.formId = ""), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.jsonArgs != null && d.hasOwnProperty("jsonArgs") && (H.jsonArgs = d.jsonArgs), d.specialArgs && d.specialArgs.length) {
      H.specialArgs = [];
      for (let AA = 0; AA < d.specialArgs.length; ++AA) H.specialArgs[AA] = $root$1.SpecialArg.toObject(d.specialArgs[AA], k);
    }
    return d.componentName != null && d.hasOwnProperty("componentName") && (H.componentName = d.componentName), d.url != null && d.hasOwnProperty("url") && (H.url = d.url), d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.tabIndex != null && d.hasOwnProperty("tabIndex") && (H.tabIndex = d.tabIndex, k.oneofs && (H._tabIndex = "tabIndex")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/ComponentInstance";
  }, n;
})();
$root$1.SpecialArg = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.key = "", n.prototype.arrowDataframe = null, n.prototype.bytes = null;
  let t;
  return Object.defineProperty(n.prototype, "value", { get: $util$1.oneOfGetter(t = ["arrowDataframe", "bytes"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.key != null && Object.hasOwnProperty.call(d, "key") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.key), d.arrowDataframe != null && Object.hasOwnProperty.call(d, "arrowDataframe") && $root$1.ArrowDataframe.encode(d.arrowDataframe, k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), d.bytes != null && Object.hasOwnProperty.call(d, "bytes") && k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(d.bytes), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.SpecialArg();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.key = d.string();
          break;
        }
        case 2: {
          gA.arrowDataframe = $root$1.ArrowDataframe.decode(d, d.uint32());
          break;
        }
        case 3: {
          gA.bytes = d.bytes();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.key != null && d.hasOwnProperty("key") && !$util$1.isString(d.key)) return "key: string expected";
    if (d.arrowDataframe != null && d.hasOwnProperty("arrowDataframe")) {
      k.value = 1;
      {
        let H = $root$1.ArrowDataframe.verify(d.arrowDataframe);
        if (H) return "arrowDataframe." + H;
      }
    }
    if (d.bytes != null && d.hasOwnProperty("bytes")) {
      if (k.value === 1) return "value: multiple values";
      if (k.value = 1, !(d.bytes && typeof d.bytes.length == "number" || $util$1.isString(d.bytes))) return "bytes: buffer expected";
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.SpecialArg) return d;
    let k = new $root$1.SpecialArg();
    if (d.key != null && (k.key = String(d.key)), d.arrowDataframe != null) {
      if (typeof d.arrowDataframe != "object") throw TypeError(".SpecialArg.arrowDataframe: object expected");
      k.arrowDataframe = $root$1.ArrowDataframe.fromObject(d.arrowDataframe);
    }
    return d.bytes != null && (typeof d.bytes == "string" ? $util$1.base64.decode(d.bytes, k.bytes = $util$1.newBuffer($util$1.base64.length(d.bytes)), 0) : d.bytes.length >= 0 && (k.bytes = d.bytes)), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.key = ""), d.key != null && d.hasOwnProperty("key") && (H.key = d.key), d.arrowDataframe != null && d.hasOwnProperty("arrowDataframe") && (H.arrowDataframe = $root$1.ArrowDataframe.toObject(d.arrowDataframe, k), k.oneofs && (H.value = "arrowDataframe")), d.bytes != null && d.hasOwnProperty("bytes") && (H.bytes = k.bytes === String ? $util$1.base64.encode(d.bytes, 0, d.bytes.length) : k.bytes === Array ? Array.prototype.slice.call(d.bytes) : d.bytes, k.oneofs && (H.value = "bytes")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/SpecialArg";
  }, n;
})();
const ArrowDataframe = $root$1.ArrowDataframe = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.prototype.height = 0, n.prototype.width = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.ArrowTable.encode(g.data, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.height != null && Object.hasOwnProperty.call(g, "height") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(g.height), g.width != null && Object.hasOwnProperty.call(g, "width") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(g.width), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ArrowDataframe();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.data = $root$1.ArrowTable.decode(g, g.uint32());
          break;
        }
        case 2: {
          AA.height = g.uint32();
          break;
        }
        case 3: {
          AA.width = g.uint32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      let d = $root$1.ArrowTable.verify(g.data);
      if (d) return "data." + d;
    }
    return g.height != null && g.hasOwnProperty("height") && !$util$1.isInteger(g.height) ? "height: integer expected" : g.width != null && g.hasOwnProperty("width") && !$util$1.isInteger(g.width) ? "width: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ArrowDataframe) return g;
    let d = new $root$1.ArrowDataframe();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".ArrowDataframe.data: object expected");
      d.data = $root$1.ArrowTable.fromObject(g.data);
    }
    return g.height != null && (d.height = g.height >>> 0), g.width != null && (d.width = g.width >>> 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.data = null, k.height = 0, k.width = 0), g.data != null && g.hasOwnProperty("data") && (k.data = $root$1.ArrowTable.toObject(g.data, d)), g.height != null && g.hasOwnProperty("height") && (k.height = g.height), g.width != null && g.hasOwnProperty("width") && (k.width = g.width), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ArrowDataframe";
  }, n;
})();
$root$1.ArrowTable = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util$1.newBuffer([]), n.prototype.index = $util$1.newBuffer([]), n.prototype.columns = $util$1.newBuffer([]), n.prototype.styler = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(g.data), g.index != null && Object.hasOwnProperty.call(g, "index") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).bytes(g.index), g.columns != null && Object.hasOwnProperty.call(g, "columns") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(g.columns), g.styler != null && Object.hasOwnProperty.call(g, "styler") && $root$1.ArrowTableStyler.encode(g.styler, d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ArrowTable();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.data = g.bytes();
          break;
        }
        case 2: {
          AA.index = g.bytes();
          break;
        }
        case 3: {
          AA.columns = g.bytes();
          break;
        }
        case 5: {
          AA.styler = $root$1.ArrowTableStyler.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data") && !(g.data && typeof g.data.length == "number" || $util$1.isString(g.data))) return "data: buffer expected";
    if (g.index != null && g.hasOwnProperty("index") && !(g.index && typeof g.index.length == "number" || $util$1.isString(g.index))) return "index: buffer expected";
    if (g.columns != null && g.hasOwnProperty("columns") && !(g.columns && typeof g.columns.length == "number" || $util$1.isString(g.columns))) return "columns: buffer expected";
    if (g.styler != null && g.hasOwnProperty("styler")) {
      let d = $root$1.ArrowTableStyler.verify(g.styler);
      if (d) return "styler." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ArrowTable) return g;
    let d = new $root$1.ArrowTable();
    if (g.data != null && (typeof g.data == "string" ? $util$1.base64.decode(g.data, d.data = $util$1.newBuffer($util$1.base64.length(g.data)), 0) : g.data.length >= 0 && (d.data = g.data)), g.index != null && (typeof g.index == "string" ? $util$1.base64.decode(g.index, d.index = $util$1.newBuffer($util$1.base64.length(g.index)), 0) : g.index.length >= 0 && (d.index = g.index)), g.columns != null && (typeof g.columns == "string" ? $util$1.base64.decode(g.columns, d.columns = $util$1.newBuffer($util$1.base64.length(g.columns)), 0) : g.columns.length >= 0 && (d.columns = g.columns)), g.styler != null) {
      if (typeof g.styler != "object") throw TypeError(".ArrowTable.styler: object expected");
      d.styler = $root$1.ArrowTableStyler.fromObject(g.styler);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (d.bytes === String ? k.data = "" : (k.data = [], d.bytes !== Array && (k.data = $util$1.newBuffer(k.data))), d.bytes === String ? k.index = "" : (k.index = [], d.bytes !== Array && (k.index = $util$1.newBuffer(k.index))), d.bytes === String ? k.columns = "" : (k.columns = [], d.bytes !== Array && (k.columns = $util$1.newBuffer(k.columns))), k.styler = null), g.data != null && g.hasOwnProperty("data") && (k.data = d.bytes === String ? $util$1.base64.encode(g.data, 0, g.data.length) : d.bytes === Array ? Array.prototype.slice.call(g.data) : g.data), g.index != null && g.hasOwnProperty("index") && (k.index = d.bytes === String ? $util$1.base64.encode(g.index, 0, g.index.length) : d.bytes === Array ? Array.prototype.slice.call(g.index) : g.index), g.columns != null && g.hasOwnProperty("columns") && (k.columns = d.bytes === String ? $util$1.base64.encode(g.columns, 0, g.columns.length) : d.bytes === Array ? Array.prototype.slice.call(g.columns) : g.columns), g.styler != null && g.hasOwnProperty("styler") && (k.styler = $root$1.ArrowTableStyler.toObject(g.styler, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ArrowTable";
  }, n;
})();
$root$1.ArrowTableStyler = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.uuid = "", n.prototype.caption = "", n.prototype.styles = "", n.prototype.displayValues = $util$1.newBuffer([]), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.uuid != null && Object.hasOwnProperty.call(g, "uuid") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.uuid), g.caption != null && Object.hasOwnProperty.call(g, "caption") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.caption), g.styles != null && Object.hasOwnProperty.call(g, "styles") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.styles), g.displayValues != null && Object.hasOwnProperty.call(g, "displayValues") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(g.displayValues), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ArrowTableStyler();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.uuid = g.string();
          break;
        }
        case 2: {
          AA.caption = g.string();
          break;
        }
        case 3: {
          AA.styles = g.string();
          break;
        }
        case 4: {
          AA.displayValues = g.bytes();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.uuid != null && g.hasOwnProperty("uuid") && !$util$1.isString(g.uuid) ? "uuid: string expected" : g.caption != null && g.hasOwnProperty("caption") && !$util$1.isString(g.caption) ? "caption: string expected" : g.styles != null && g.hasOwnProperty("styles") && !$util$1.isString(g.styles) ? "styles: string expected" : g.displayValues != null && g.hasOwnProperty("displayValues") && !(g.displayValues && typeof g.displayValues.length == "number" || $util$1.isString(g.displayValues)) ? "displayValues: buffer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ArrowTableStyler) return g;
    let d = new $root$1.ArrowTableStyler();
    return g.uuid != null && (d.uuid = String(g.uuid)), g.caption != null && (d.caption = String(g.caption)), g.styles != null && (d.styles = String(g.styles)), g.displayValues != null && (typeof g.displayValues == "string" ? $util$1.base64.decode(g.displayValues, d.displayValues = $util$1.newBuffer($util$1.base64.length(g.displayValues)), 0) : g.displayValues.length >= 0 && (d.displayValues = g.displayValues)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.uuid = "", k.caption = "", k.styles = "", d.bytes === String ? k.displayValues = "" : (k.displayValues = [], d.bytes !== Array && (k.displayValues = $util$1.newBuffer(k.displayValues)))), g.uuid != null && g.hasOwnProperty("uuid") && (k.uuid = g.uuid), g.caption != null && g.hasOwnProperty("caption") && (k.caption = g.caption), g.styles != null && g.hasOwnProperty("styles") && (k.styles = g.styles), g.displayValues != null && g.hasOwnProperty("displayValues") && (k.displayValues = d.bytes === String ? $util$1.base64.encode(g.displayValues, 0, g.displayValues.length) : d.bytes === Array ? Array.prototype.slice.call(g.displayValues) : g.displayValues), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ArrowTableStyler";
  }, n;
})();
$root$1.Balloons = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.show = !1, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.show != null && Object.hasOwnProperty.call(g, "show") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.show), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Balloons();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 3: {
          AA.show = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.show != null && g.hasOwnProperty("show") && typeof g.show != "boolean" ? "show: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Balloons) return g;
    let d = new $root$1.Balloons();
    return g.show != null && (d.show = !!g.show), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.show = !1), g.show != null && g.hasOwnProperty("show") && (k.show = g.show), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Balloons";
  }, n;
})();
const Block$2 = $root$1.Block = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.vertical = null, n.prototype.horizontal = null, n.prototype.column = null, n.prototype.expandable = null, n.prototype.form = null, n.prototype.tabContainer = null, n.prototype.tab = null, n.prototype.chatMessage = null, n.prototype.popover = null, n.prototype.dialog = null, n.prototype.flexContainer = null, n.prototype.allowEmpty = !1, n.prototype.id = null, n.prototype.heightConfig = null, n.prototype.widthConfig = null;
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util$1.oneOfGetter(t = ["vertical", "horizontal", "column", "expandable", "form", "tabContainer", "tab", "chatMessage", "popover", "dialog", "flexContainer"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_id", { get: $util$1.oneOfGetter(t = ["id"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_heightConfig", { get: $util$1.oneOfGetter(t = ["heightConfig"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_widthConfig", { get: $util$1.oneOfGetter(t = ["widthConfig"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.vertical != null && Object.hasOwnProperty.call(d, "vertical") && $root$1.Block.Vertical.encode(d.vertical, k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), d.horizontal != null && Object.hasOwnProperty.call(d, "horizontal") && $root$1.Block.Horizontal.encode(d.horizontal, k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), d.column != null && Object.hasOwnProperty.call(d, "column") && $root$1.Block.Column.encode(d.column, k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), d.expandable != null && Object.hasOwnProperty.call(d, "expandable") && $root$1.Block.Expandable.encode(d.expandable, k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), d.form != null && Object.hasOwnProperty.call(d, "form") && $root$1.Block.Form.encode(d.form, k.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), d.tabContainer != null && Object.hasOwnProperty.call(d, "tabContainer") && $root$1.Block.TabContainer.encode(d.tabContainer, k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), d.tab != null && Object.hasOwnProperty.call(d, "tab") && $root$1.Block.Tab.encode(d.tab, k.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), d.allowEmpty != null && Object.hasOwnProperty.call(d, "allowEmpty") && k.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(d.allowEmpty), d.chatMessage != null && Object.hasOwnProperty.call(d, "chatMessage") && $root$1.Block.ChatMessage.encode(d.chatMessage, k.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), d.popover != null && Object.hasOwnProperty.call(d, "popover") && $root$1.Block.Popover.encode(d.popover, k.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), d.dialog != null && Object.hasOwnProperty.call(d, "dialog") && $root$1.Block.Dialog.encode(d.dialog, k.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(d.id), d.flexContainer != null && Object.hasOwnProperty.call(d, "flexContainer") && $root$1.Block.FlexContainer.encode(d.flexContainer, k.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), d.heightConfig != null && Object.hasOwnProperty.call(d, "heightConfig") && $root$1.streamlit.HeightConfig.encode(d.heightConfig, k.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), d.widthConfig != null && Object.hasOwnProperty.call(d, "widthConfig") && $root$1.streamlit.WidthConfig.encode(d.widthConfig, k.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Block();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.vertical = $root$1.Block.Vertical.decode(d, d.uint32());
          break;
        }
        case 2: {
          gA.horizontal = $root$1.Block.Horizontal.decode(d, d.uint32());
          break;
        }
        case 3: {
          gA.column = $root$1.Block.Column.decode(d, d.uint32());
          break;
        }
        case 4: {
          gA.expandable = $root$1.Block.Expandable.decode(d, d.uint32());
          break;
        }
        case 5: {
          gA.form = $root$1.Block.Form.decode(d, d.uint32());
          break;
        }
        case 6: {
          gA.tabContainer = $root$1.Block.TabContainer.decode(d, d.uint32());
          break;
        }
        case 7: {
          gA.tab = $root$1.Block.Tab.decode(d, d.uint32());
          break;
        }
        case 9: {
          gA.chatMessage = $root$1.Block.ChatMessage.decode(d, d.uint32());
          break;
        }
        case 10: {
          gA.popover = $root$1.Block.Popover.decode(d, d.uint32());
          break;
        }
        case 11: {
          gA.dialog = $root$1.Block.Dialog.decode(d, d.uint32());
          break;
        }
        case 13: {
          gA.flexContainer = $root$1.Block.FlexContainer.decode(d, d.uint32());
          break;
        }
        case 8: {
          gA.allowEmpty = d.bool();
          break;
        }
        case 12: {
          gA.id = d.string();
          break;
        }
        case 14: {
          gA.heightConfig = $root$1.streamlit.HeightConfig.decode(d, d.uint32());
          break;
        }
        case 15: {
          gA.widthConfig = $root$1.streamlit.WidthConfig.decode(d, d.uint32());
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.vertical != null && d.hasOwnProperty("vertical")) {
      k.type = 1;
      {
        let H = $root$1.Block.Vertical.verify(d.vertical);
        if (H) return "vertical." + H;
      }
    }
    if (d.horizontal != null && d.hasOwnProperty("horizontal")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Block.Horizontal.verify(d.horizontal);
        if (H) return "horizontal." + H;
      }
    }
    if (d.column != null && d.hasOwnProperty("column")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Block.Column.verify(d.column);
        if (H) return "column." + H;
      }
    }
    if (d.expandable != null && d.hasOwnProperty("expandable")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Block.Expandable.verify(d.expandable);
        if (H) return "expandable." + H;
      }
    }
    if (d.form != null && d.hasOwnProperty("form")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Block.Form.verify(d.form);
        if (H) return "form." + H;
      }
    }
    if (d.tabContainer != null && d.hasOwnProperty("tabContainer")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Block.TabContainer.verify(d.tabContainer);
        if (H) return "tabContainer." + H;
      }
    }
    if (d.tab != null && d.hasOwnProperty("tab")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Block.Tab.verify(d.tab);
        if (H) return "tab." + H;
      }
    }
    if (d.chatMessage != null && d.hasOwnProperty("chatMessage")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Block.ChatMessage.verify(d.chatMessage);
        if (H) return "chatMessage." + H;
      }
    }
    if (d.popover != null && d.hasOwnProperty("popover")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Block.Popover.verify(d.popover);
        if (H) return "popover." + H;
      }
    }
    if (d.dialog != null && d.hasOwnProperty("dialog")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Block.Dialog.verify(d.dialog);
        if (H) return "dialog." + H;
      }
    }
    if (d.flexContainer != null && d.hasOwnProperty("flexContainer")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Block.FlexContainer.verify(d.flexContainer);
        if (H) return "flexContainer." + H;
      }
    }
    if (d.allowEmpty != null && d.hasOwnProperty("allowEmpty") && typeof d.allowEmpty != "boolean") return "allowEmpty: boolean expected";
    if (d.id != null && d.hasOwnProperty("id") && (k._id = 1, !$util$1.isString(d.id)))
      return "id: string expected";
    if (d.heightConfig != null && d.hasOwnProperty("heightConfig")) {
      k._heightConfig = 1;
      {
        let H = $root$1.streamlit.HeightConfig.verify(d.heightConfig);
        if (H) return "heightConfig." + H;
      }
    }
    if (d.widthConfig != null && d.hasOwnProperty("widthConfig")) {
      k._widthConfig = 1;
      {
        let H = $root$1.streamlit.WidthConfig.verify(d.widthConfig);
        if (H) return "widthConfig." + H;
      }
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Block) return d;
    let k = new $root$1.Block();
    if (d.vertical != null) {
      if (typeof d.vertical != "object") throw TypeError(".Block.vertical: object expected");
      k.vertical = $root$1.Block.Vertical.fromObject(d.vertical);
    }
    if (d.horizontal != null) {
      if (typeof d.horizontal != "object") throw TypeError(".Block.horizontal: object expected");
      k.horizontal = $root$1.Block.Horizontal.fromObject(d.horizontal);
    }
    if (d.column != null) {
      if (typeof d.column != "object") throw TypeError(".Block.column: object expected");
      k.column = $root$1.Block.Column.fromObject(d.column);
    }
    if (d.expandable != null) {
      if (typeof d.expandable != "object") throw TypeError(".Block.expandable: object expected");
      k.expandable = $root$1.Block.Expandable.fromObject(d.expandable);
    }
    if (d.form != null) {
      if (typeof d.form != "object") throw TypeError(".Block.form: object expected");
      k.form = $root$1.Block.Form.fromObject(d.form);
    }
    if (d.tabContainer != null) {
      if (typeof d.tabContainer != "object") throw TypeError(".Block.tabContainer: object expected");
      k.tabContainer = $root$1.Block.TabContainer.fromObject(d.tabContainer);
    }
    if (d.tab != null) {
      if (typeof d.tab != "object") throw TypeError(".Block.tab: object expected");
      k.tab = $root$1.Block.Tab.fromObject(d.tab);
    }
    if (d.chatMessage != null) {
      if (typeof d.chatMessage != "object") throw TypeError(".Block.chatMessage: object expected");
      k.chatMessage = $root$1.Block.ChatMessage.fromObject(d.chatMessage);
    }
    if (d.popover != null) {
      if (typeof d.popover != "object") throw TypeError(".Block.popover: object expected");
      k.popover = $root$1.Block.Popover.fromObject(d.popover);
    }
    if (d.dialog != null) {
      if (typeof d.dialog != "object") throw TypeError(".Block.dialog: object expected");
      k.dialog = $root$1.Block.Dialog.fromObject(d.dialog);
    }
    if (d.flexContainer != null) {
      if (typeof d.flexContainer != "object") throw TypeError(".Block.flexContainer: object expected");
      k.flexContainer = $root$1.Block.FlexContainer.fromObject(d.flexContainer);
    }
    if (d.allowEmpty != null && (k.allowEmpty = !!d.allowEmpty), d.id != null && (k.id = String(d.id)), d.heightConfig != null) {
      if (typeof d.heightConfig != "object") throw TypeError(".Block.heightConfig: object expected");
      k.heightConfig = $root$1.streamlit.HeightConfig.fromObject(d.heightConfig);
    }
    if (d.widthConfig != null) {
      if (typeof d.widthConfig != "object") throw TypeError(".Block.widthConfig: object expected");
      k.widthConfig = $root$1.streamlit.WidthConfig.fromObject(d.widthConfig);
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.allowEmpty = !1), d.vertical != null && d.hasOwnProperty("vertical") && (H.vertical = $root$1.Block.Vertical.toObject(d.vertical, k), k.oneofs && (H.type = "vertical")), d.horizontal != null && d.hasOwnProperty("horizontal") && (H.horizontal = $root$1.Block.Horizontal.toObject(d.horizontal, k), k.oneofs && (H.type = "horizontal")), d.column != null && d.hasOwnProperty("column") && (H.column = $root$1.Block.Column.toObject(d.column, k), k.oneofs && (H.type = "column")), d.expandable != null && d.hasOwnProperty("expandable") && (H.expandable = $root$1.Block.Expandable.toObject(d.expandable, k), k.oneofs && (H.type = "expandable")), d.form != null && d.hasOwnProperty("form") && (H.form = $root$1.Block.Form.toObject(d.form, k), k.oneofs && (H.type = "form")), d.tabContainer != null && d.hasOwnProperty("tabContainer") && (H.tabContainer = $root$1.Block.TabContainer.toObject(d.tabContainer, k), k.oneofs && (H.type = "tabContainer")), d.tab != null && d.hasOwnProperty("tab") && (H.tab = $root$1.Block.Tab.toObject(d.tab, k), k.oneofs && (H.type = "tab")), d.allowEmpty != null && d.hasOwnProperty("allowEmpty") && (H.allowEmpty = d.allowEmpty), d.chatMessage != null && d.hasOwnProperty("chatMessage") && (H.chatMessage = $root$1.Block.ChatMessage.toObject(d.chatMessage, k), k.oneofs && (H.type = "chatMessage")), d.popover != null && d.hasOwnProperty("popover") && (H.popover = $root$1.Block.Popover.toObject(d.popover, k), k.oneofs && (H.type = "popover")), d.dialog != null && d.hasOwnProperty("dialog") && (H.dialog = $root$1.Block.Dialog.toObject(d.dialog, k), k.oneofs && (H.type = "dialog")), d.id != null && d.hasOwnProperty("id") && (H.id = d.id, k.oneofs && (H._id = "id")), d.flexContainer != null && d.hasOwnProperty("flexContainer") && (H.flexContainer = $root$1.Block.FlexContainer.toObject(d.flexContainer, k), k.oneofs && (H.type = "flexContainer")), d.heightConfig != null && d.hasOwnProperty("heightConfig") && (H.heightConfig = $root$1.streamlit.HeightConfig.toObject(d.heightConfig, k), k.oneofs && (H._heightConfig = "heightConfig")), d.widthConfig != null && d.hasOwnProperty("widthConfig") && (H.widthConfig = $root$1.streamlit.WidthConfig.toObject(d.widthConfig, k), k.oneofs && (H._widthConfig = "widthConfig")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Block";
  }, n.Vertical = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.border = !1, g.prototype.height = 0, g.create = function(k) {
      return new g(k);
    }, g.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.border != null && Object.hasOwnProperty.call(k, "border") && H.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(k.border), k.height != null && Object.hasOwnProperty.call(k, "height") && H.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint32(k.height), H;
    }, g.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, g.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.Block.Vertical();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.border = k.bool();
            break;
          }
          case 2: {
            IA.height = k.uint32();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, g.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, g.verify = function(k) {
      return typeof k != "object" || k === null ? "object expected" : k.border != null && k.hasOwnProperty("border") && typeof k.border != "boolean" ? "border: boolean expected" : k.height != null && k.hasOwnProperty("height") && !$util$1.isInteger(k.height) ? "height: integer expected" : null;
    }, g.fromObject = function(k) {
      if (k instanceof $root$1.Block.Vertical) return k;
      let H = new $root$1.Block.Vertical();
      return k.border != null && (H.border = !!k.border), k.height != null && (H.height = k.height >>> 0), H;
    }, g.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.border = !1, AA.height = 0), k.border != null && k.hasOwnProperty("border") && (AA.border = k.border), k.height != null && k.hasOwnProperty("height") && (AA.height = k.height), AA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/Block.Vertical";
    }, g;
  })(), n.Horizontal = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.gap = "", g.create = function(k) {
      return new g(k);
    }, g.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.gap != null && Object.hasOwnProperty.call(k, "gap") && H.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(k.gap), H;
    }, g.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, g.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.Block.Horizontal();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.gap = k.string();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, g.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, g.verify = function(k) {
      return typeof k != "object" || k === null ? "object expected" : k.gap != null && k.hasOwnProperty("gap") && !$util$1.isString(k.gap) ? "gap: string expected" : null;
    }, g.fromObject = function(k) {
      if (k instanceof $root$1.Block.Horizontal) return k;
      let H = new $root$1.Block.Horizontal();
      return k.gap != null && (H.gap = String(k.gap)), H;
    }, g.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.gap = ""), k.gap != null && k.hasOwnProperty("gap") && (AA.gap = k.gap), AA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/Block.Horizontal";
    }, g;
  })(), n.FlexContainer = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.border = !1, g.prototype.gapConfig = null, g.prototype.scale = 0, g.prototype.direction = 0, g.prototype.wrap = !1, g.prototype.justify = 0, g.prototype.align = 0, g.create = function(k) {
      return new g(k);
    }, g.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.border != null && Object.hasOwnProperty.call(k, "border") && H.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(k.border), k.gapConfig != null && Object.hasOwnProperty.call(k, "gapConfig") && $root$1.streamlit.GapConfig.encode(k.gapConfig, H.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), k.scale != null && Object.hasOwnProperty.call(k, "scale") && H.uint32(
        /* id 3, wireType 5 =*/
        29
      ).float(k.scale), k.direction != null && Object.hasOwnProperty.call(k, "direction") && H.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(k.direction), k.wrap != null && Object.hasOwnProperty.call(k, "wrap") && H.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(k.wrap), k.justify != null && Object.hasOwnProperty.call(k, "justify") && H.uint32(
        /* id 7, wireType 0 =*/
        56
      ).int32(k.justify), k.align != null && Object.hasOwnProperty.call(k, "align") && H.uint32(
        /* id 8, wireType 0 =*/
        64
      ).int32(k.align), H;
    }, g.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, g.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.Block.FlexContainer();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.border = k.bool();
            break;
          }
          case 2: {
            IA.gapConfig = $root$1.streamlit.GapConfig.decode(k, k.uint32());
            break;
          }
          case 3: {
            IA.scale = k.float();
            break;
          }
          case 4: {
            IA.direction = k.int32();
            break;
          }
          case 5: {
            IA.wrap = k.bool();
            break;
          }
          case 7: {
            IA.justify = k.int32();
            break;
          }
          case 8: {
            IA.align = k.int32();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, g.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, g.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      if (k.border != null && k.hasOwnProperty("border") && typeof k.border != "boolean") return "border: boolean expected";
      if (k.gapConfig != null && k.hasOwnProperty("gapConfig")) {
        let H = $root$1.streamlit.GapConfig.verify(k.gapConfig);
        if (H) return "gapConfig." + H;
      }
      if (k.scale != null && k.hasOwnProperty("scale") && typeof k.scale != "number") return "scale: number expected";
      if (k.direction != null && k.hasOwnProperty("direction")) switch (k.direction) {
        default:
          return "direction: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
      if (k.wrap != null && k.hasOwnProperty("wrap") && typeof k.wrap != "boolean") return "wrap: boolean expected";
      if (k.justify != null && k.hasOwnProperty("justify")) switch (k.justify) {
        default:
          return "justify: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
          break;
      }
      if (k.align != null && k.hasOwnProperty("align")) switch (k.align) {
        default:
          return "align: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
          break;
      }
      return null;
    }, g.fromObject = function(k) {
      if (k instanceof $root$1.Block.FlexContainer) return k;
      let H = new $root$1.Block.FlexContainer();
      if (k.border != null && (H.border = !!k.border), k.gapConfig != null) {
        if (typeof k.gapConfig != "object") throw TypeError(".Block.FlexContainer.gapConfig: object expected");
        H.gapConfig = $root$1.streamlit.GapConfig.fromObject(k.gapConfig);
      }
      switch (k.scale != null && (H.scale = Number(k.scale)), k.direction) {
        default:
          if (typeof k.direction == "number") {
            H.direction = k.direction;
            break;
          }
          break;
        case "DIRECTION_UNDEFINED":
        case 0:
          H.direction = 0;
          break;
        case "VERTICAL":
        case 1:
          H.direction = 1;
          break;
        case "HORIZONTAL":
        case 2:
          H.direction = 2;
          break;
      }
      switch (k.wrap != null && (H.wrap = !!k.wrap), k.justify) {
        default:
          if (typeof k.justify == "number") {
            H.justify = k.justify;
            break;
          }
          break;
        case "JUSTIFY_UNDEFINED":
        case 0:
          H.justify = 0;
          break;
        case "JUSTIFY_START":
        case 1:
          H.justify = 1;
          break;
        case "JUSTIFY_END":
        case 2:
          H.justify = 2;
          break;
        case "JUSTIFY_CENTER":
        case 3:
          H.justify = 3;
          break;
        case "SPACE_BETWEEN":
        case 4:
          H.justify = 4;
          break;
      }
      switch (k.align) {
        default:
          if (typeof k.align == "number") {
            H.align = k.align;
            break;
          }
          break;
        case "ALIGN_UNDEFINED":
        case 0:
          H.align = 0;
          break;
        case "ALIGN_START":
        case 1:
          H.align = 1;
          break;
        case "ALIGN_END":
        case 2:
          H.align = 2;
          break;
        case "ALIGN_CENTER":
        case 3:
          H.align = 3;
          break;
        case "STRETCH":
        case 4:
          H.align = 4;
          break;
      }
      return H;
    }, g.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.border = !1, AA.gapConfig = null, AA.scale = 0, AA.direction = H.enums === String ? "DIRECTION_UNDEFINED" : 0, AA.wrap = !1, AA.justify = H.enums === String ? "JUSTIFY_UNDEFINED" : 0, AA.align = H.enums === String ? "ALIGN_UNDEFINED" : 0), k.border != null && k.hasOwnProperty("border") && (AA.border = k.border), k.gapConfig != null && k.hasOwnProperty("gapConfig") && (AA.gapConfig = $root$1.streamlit.GapConfig.toObject(k.gapConfig, H)), k.scale != null && k.hasOwnProperty("scale") && (AA.scale = H.json && !isFinite(k.scale) ? String(k.scale) : k.scale), k.direction != null && k.hasOwnProperty("direction") && (AA.direction = H.enums === String ? $root$1.Block.FlexContainer.Direction[k.direction] === void 0 ? k.direction : $root$1.Block.FlexContainer.Direction[k.direction] : k.direction), k.wrap != null && k.hasOwnProperty("wrap") && (AA.wrap = k.wrap), k.justify != null && k.hasOwnProperty("justify") && (AA.justify = H.enums === String ? $root$1.Block.FlexContainer.Justify[k.justify] === void 0 ? k.justify : $root$1.Block.FlexContainer.Justify[k.justify] : k.justify), k.align != null && k.hasOwnProperty("align") && (AA.align = H.enums === String ? $root$1.Block.FlexContainer.Align[k.align] === void 0 ? k.align : $root$1.Block.FlexContainer.Align[k.align] : k.align), AA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/Block.FlexContainer";
    }, g.Direction = (function() {
      const d = {}, k = Object.create(d);
      return k[d[0] = "DIRECTION_UNDEFINED"] = 0, k[d[1] = "VERTICAL"] = 1, k[d[2] = "HORIZONTAL"] = 2, k;
    })(), g.Justify = (function() {
      const d = {}, k = Object.create(d);
      return k[d[0] = "JUSTIFY_UNDEFINED"] = 0, k[d[1] = "JUSTIFY_START"] = 1, k[d[2] = "JUSTIFY_END"] = 2, k[d[3] = "JUSTIFY_CENTER"] = 3, k[d[4] = "SPACE_BETWEEN"] = 4, k;
    })(), g.Align = (function() {
      const d = {}, k = Object.create(d);
      return k[d[0] = "ALIGN_UNDEFINED"] = 0, k[d[1] = "ALIGN_START"] = 1, k[d[2] = "ALIGN_END"] = 2, k[d[3] = "ALIGN_CENTER"] = 3, k[d[4] = "STRETCH"] = 4, k;
    })(), g;
  })(), n.Column = (function() {
    function g(k) {
      if (k) for (let H = Object.keys(k), AA = 0; AA < H.length; ++AA) k[H[AA]] != null && (this[H[AA]] = k[H[AA]]);
    }
    g.prototype.weight = 0, g.prototype.gap = "", g.prototype.verticalAlignment = 0, g.prototype.showBorder = !1, g.prototype.gapConfig = null;
    let d;
    return Object.defineProperty(g.prototype, "_gapConfig", { get: $util$1.oneOfGetter(d = ["gapConfig"]), set: $util$1.oneOfSetter(d) }), g.create = function(H) {
      return new g(H);
    }, g.encode = function(H, AA) {
      return AA || (AA = $Writer$1.create()), H.weight != null && Object.hasOwnProperty.call(H, "weight") && AA.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(H.weight), H.gap != null && Object.hasOwnProperty.call(H, "gap") && AA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(H.gap), H.verticalAlignment != null && Object.hasOwnProperty.call(H, "verticalAlignment") && AA.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(H.verticalAlignment), H.showBorder != null && Object.hasOwnProperty.call(H, "showBorder") && AA.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(H.showBorder), H.gapConfig != null && Object.hasOwnProperty.call(H, "gapConfig") && $root$1.streamlit.GapConfig.encode(H.gapConfig, AA.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), AA;
    }, g.encodeDelimited = function(H, AA) {
      return this.encode(H, AA).ldelim();
    }, g.decode = function(H, AA, gA) {
      H instanceof $Reader$1 || (H = $Reader$1.create(H));
      let IA = AA === void 0 ? H.len : H.pos + AA, CA = new $root$1.Block.Column();
      for (; H.pos < IA; ) {
        let BA = H.uint32();
        if (BA === gA) break;
        switch (BA >>> 3) {
          case 1: {
            CA.weight = H.double();
            break;
          }
          case 2: {
            CA.gap = H.string();
            break;
          }
          case 3: {
            CA.verticalAlignment = H.int32();
            break;
          }
          case 4: {
            CA.showBorder = H.bool();
            break;
          }
          case 5: {
            CA.gapConfig = $root$1.streamlit.GapConfig.decode(H, H.uint32());
            break;
          }
          default:
            H.skipType(BA & 7);
            break;
        }
      }
      return CA;
    }, g.decodeDelimited = function(H) {
      return H instanceof $Reader$1 || (H = new $Reader$1(H)), this.decode(H, H.uint32());
    }, g.verify = function(H) {
      if (typeof H != "object" || H === null) return "object expected";
      if (H.weight != null && H.hasOwnProperty("weight") && typeof H.weight != "number") return "weight: number expected";
      if (H.gap != null && H.hasOwnProperty("gap") && !$util$1.isString(H.gap)) return "gap: string expected";
      if (H.verticalAlignment != null && H.hasOwnProperty("verticalAlignment")) switch (H.verticalAlignment) {
        default:
          return "verticalAlignment: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
      if (H.showBorder != null && H.hasOwnProperty("showBorder") && typeof H.showBorder != "boolean") return "showBorder: boolean expected";
      if (H.gapConfig != null && H.hasOwnProperty("gapConfig")) {
        let AA = $root$1.streamlit.GapConfig.verify(H.gapConfig);
        if (AA) return "gapConfig." + AA;
      }
      return null;
    }, g.fromObject = function(H) {
      if (H instanceof $root$1.Block.Column) return H;
      let AA = new $root$1.Block.Column();
      switch (H.weight != null && (AA.weight = Number(H.weight)), H.gap != null && (AA.gap = String(H.gap)), H.verticalAlignment) {
        default:
          if (typeof H.verticalAlignment == "number") {
            AA.verticalAlignment = H.verticalAlignment;
            break;
          }
          break;
        case "TOP":
        case 0:
          AA.verticalAlignment = 0;
          break;
        case "CENTER":
        case 1:
          AA.verticalAlignment = 1;
          break;
        case "BOTTOM":
        case 2:
          AA.verticalAlignment = 2;
          break;
      }
      if (H.showBorder != null && (AA.showBorder = !!H.showBorder), H.gapConfig != null) {
        if (typeof H.gapConfig != "object") throw TypeError(".Block.Column.gapConfig: object expected");
        AA.gapConfig = $root$1.streamlit.GapConfig.fromObject(H.gapConfig);
      }
      return AA;
    }, g.toObject = function(H, AA) {
      AA || (AA = {});
      let gA = {};
      return AA.defaults && (gA.weight = 0, gA.gap = "", gA.verticalAlignment = AA.enums === String ? "TOP" : 0, gA.showBorder = !1), H.weight != null && H.hasOwnProperty("weight") && (gA.weight = AA.json && !isFinite(H.weight) ? String(H.weight) : H.weight), H.gap != null && H.hasOwnProperty("gap") && (gA.gap = H.gap), H.verticalAlignment != null && H.hasOwnProperty("verticalAlignment") && (gA.verticalAlignment = AA.enums === String ? $root$1.Block.Column.VerticalAlignment[H.verticalAlignment] === void 0 ? H.verticalAlignment : $root$1.Block.Column.VerticalAlignment[H.verticalAlignment] : H.verticalAlignment), H.showBorder != null && H.hasOwnProperty("showBorder") && (gA.showBorder = H.showBorder), H.gapConfig != null && H.hasOwnProperty("gapConfig") && (gA.gapConfig = $root$1.streamlit.GapConfig.toObject(H.gapConfig, AA), AA.oneofs && (gA._gapConfig = "gapConfig")), gA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(H) {
      return H === void 0 && (H = "type.googleapis.com"), H + "/Block.Column";
    }, g.VerticalAlignment = (function() {
      const k = {}, H = Object.create(k);
      return H[k[0] = "TOP"] = 0, H[k[1] = "CENTER"] = 1, H[k[2] = "BOTTOM"] = 2, H;
    })(), g;
  })(), n.Expandable = (function() {
    function g(k) {
      if (k) for (let H = Object.keys(k), AA = 0; AA < H.length; ++AA) k[H[AA]] != null && (this[H[AA]] = k[H[AA]]);
    }
    g.prototype.label = "", g.prototype.expanded = null, g.prototype.icon = "";
    let d;
    return Object.defineProperty(g.prototype, "_expanded", { get: $util$1.oneOfGetter(d = ["expanded"]), set: $util$1.oneOfSetter(d) }), g.create = function(H) {
      return new g(H);
    }, g.encode = function(H, AA) {
      return AA || (AA = $Writer$1.create()), H.label != null && Object.hasOwnProperty.call(H, "label") && AA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(H.label), H.expanded != null && Object.hasOwnProperty.call(H, "expanded") && AA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(H.expanded), H.icon != null && Object.hasOwnProperty.call(H, "icon") && AA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(H.icon), AA;
    }, g.encodeDelimited = function(H, AA) {
      return this.encode(H, AA).ldelim();
    }, g.decode = function(H, AA, gA) {
      H instanceof $Reader$1 || (H = $Reader$1.create(H));
      let IA = AA === void 0 ? H.len : H.pos + AA, CA = new $root$1.Block.Expandable();
      for (; H.pos < IA; ) {
        let BA = H.uint32();
        if (BA === gA) break;
        switch (BA >>> 3) {
          case 1: {
            CA.label = H.string();
            break;
          }
          case 2: {
            CA.expanded = H.bool();
            break;
          }
          case 3: {
            CA.icon = H.string();
            break;
          }
          default:
            H.skipType(BA & 7);
            break;
        }
      }
      return CA;
    }, g.decodeDelimited = function(H) {
      return H instanceof $Reader$1 || (H = new $Reader$1(H)), this.decode(H, H.uint32());
    }, g.verify = function(H) {
      return typeof H != "object" || H === null ? "object expected" : H.label != null && H.hasOwnProperty("label") && !$util$1.isString(H.label) ? "label: string expected" : H.expanded != null && H.hasOwnProperty("expanded") && typeof H.expanded != "boolean" ? "expanded: boolean expected" : H.icon != null && H.hasOwnProperty("icon") && !$util$1.isString(H.icon) ? "icon: string expected" : null;
    }, g.fromObject = function(H) {
      if (H instanceof $root$1.Block.Expandable) return H;
      let AA = new $root$1.Block.Expandable();
      return H.label != null && (AA.label = String(H.label)), H.expanded != null && (AA.expanded = !!H.expanded), H.icon != null && (AA.icon = String(H.icon)), AA;
    }, g.toObject = function(H, AA) {
      AA || (AA = {});
      let gA = {};
      return AA.defaults && (gA.label = "", gA.icon = ""), H.label != null && H.hasOwnProperty("label") && (gA.label = H.label), H.expanded != null && H.hasOwnProperty("expanded") && (gA.expanded = H.expanded, AA.oneofs && (gA._expanded = "expanded")), H.icon != null && H.hasOwnProperty("icon") && (gA.icon = H.icon), gA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(H) {
      return H === void 0 && (H = "type.googleapis.com"), H + "/Block.Expandable";
    }, g;
  })(), n.Dialog = (function() {
    function g(k) {
      if (k) for (let H = Object.keys(k), AA = 0; AA < H.length; ++AA) k[H[AA]] != null && (this[H[AA]] = k[H[AA]]);
    }
    g.prototype.title = "", g.prototype.dismissible = !1, g.prototype.width = 0, g.prototype.isOpen = null, g.prototype.id = "";
    let d;
    return Object.defineProperty(g.prototype, "_isOpen", { get: $util$1.oneOfGetter(d = ["isOpen"]), set: $util$1.oneOfSetter(d) }), g.create = function(H) {
      return new g(H);
    }, g.encode = function(H, AA) {
      return AA || (AA = $Writer$1.create()), H.title != null && Object.hasOwnProperty.call(H, "title") && AA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(H.title), H.dismissible != null && Object.hasOwnProperty.call(H, "dismissible") && AA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(H.dismissible), H.width != null && Object.hasOwnProperty.call(H, "width") && AA.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(H.width), H.isOpen != null && Object.hasOwnProperty.call(H, "isOpen") && AA.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(H.isOpen), H.id != null && Object.hasOwnProperty.call(H, "id") && AA.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(H.id), AA;
    }, g.encodeDelimited = function(H, AA) {
      return this.encode(H, AA).ldelim();
    }, g.decode = function(H, AA, gA) {
      H instanceof $Reader$1 || (H = $Reader$1.create(H));
      let IA = AA === void 0 ? H.len : H.pos + AA, CA = new $root$1.Block.Dialog();
      for (; H.pos < IA; ) {
        let BA = H.uint32();
        if (BA === gA) break;
        switch (BA >>> 3) {
          case 1: {
            CA.title = H.string();
            break;
          }
          case 2: {
            CA.dismissible = H.bool();
            break;
          }
          case 3: {
            CA.width = H.int32();
            break;
          }
          case 4: {
            CA.isOpen = H.bool();
            break;
          }
          case 5: {
            CA.id = H.string();
            break;
          }
          default:
            H.skipType(BA & 7);
            break;
        }
      }
      return CA;
    }, g.decodeDelimited = function(H) {
      return H instanceof $Reader$1 || (H = new $Reader$1(H)), this.decode(H, H.uint32());
    }, g.verify = function(H) {
      if (typeof H != "object" || H === null) return "object expected";
      if (H.title != null && H.hasOwnProperty("title") && !$util$1.isString(H.title)) return "title: string expected";
      if (H.dismissible != null && H.hasOwnProperty("dismissible") && typeof H.dismissible != "boolean") return "dismissible: boolean expected";
      if (H.width != null && H.hasOwnProperty("width")) switch (H.width) {
        default:
          return "width: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
      return H.isOpen != null && H.hasOwnProperty("isOpen") && typeof H.isOpen != "boolean" ? "isOpen: boolean expected" : H.id != null && H.hasOwnProperty("id") && !$util$1.isString(H.id) ? "id: string expected" : null;
    }, g.fromObject = function(H) {
      if (H instanceof $root$1.Block.Dialog) return H;
      let AA = new $root$1.Block.Dialog();
      switch (H.title != null && (AA.title = String(H.title)), H.dismissible != null && (AA.dismissible = !!H.dismissible), H.width) {
        default:
          if (typeof H.width == "number") {
            AA.width = H.width;
            break;
          }
          break;
        case "SMALL":
        case 0:
          AA.width = 0;
          break;
        case "LARGE":
        case 1:
          AA.width = 1;
          break;
        case "MEDIUM":
        case 2:
          AA.width = 2;
          break;
      }
      return H.isOpen != null && (AA.isOpen = !!H.isOpen), H.id != null && (AA.id = String(H.id)), AA;
    }, g.toObject = function(H, AA) {
      AA || (AA = {});
      let gA = {};
      return AA.defaults && (gA.title = "", gA.dismissible = !1, gA.width = AA.enums === String ? "SMALL" : 0, gA.id = ""), H.title != null && H.hasOwnProperty("title") && (gA.title = H.title), H.dismissible != null && H.hasOwnProperty("dismissible") && (gA.dismissible = H.dismissible), H.width != null && H.hasOwnProperty("width") && (gA.width = AA.enums === String ? $root$1.Block.Dialog.DialogWidth[H.width] === void 0 ? H.width : $root$1.Block.Dialog.DialogWidth[H.width] : H.width), H.isOpen != null && H.hasOwnProperty("isOpen") && (gA.isOpen = H.isOpen, AA.oneofs && (gA._isOpen = "isOpen")), H.id != null && H.hasOwnProperty("id") && (gA.id = H.id), gA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(H) {
      return H === void 0 && (H = "type.googleapis.com"), H + "/Block.Dialog";
    }, g.DialogWidth = (function() {
      const k = {}, H = Object.create(k);
      return H[k[0] = "SMALL"] = 0, H[k[1] = "LARGE"] = 1, H[k[2] = "MEDIUM"] = 2, H;
    })(), g;
  })(), n.Form = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.formId = "", g.prototype.clearOnSubmit = !1, g.prototype.border = !1, g.prototype.enterToSubmit = !1, g.create = function(k) {
      return new g(k);
    }, g.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.formId != null && Object.hasOwnProperty.call(k, "formId") && H.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(k.formId), k.clearOnSubmit != null && Object.hasOwnProperty.call(k, "clearOnSubmit") && H.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(k.clearOnSubmit), k.border != null && Object.hasOwnProperty.call(k, "border") && H.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(k.border), k.enterToSubmit != null && Object.hasOwnProperty.call(k, "enterToSubmit") && H.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(k.enterToSubmit), H;
    }, g.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, g.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.Block.Form();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.formId = k.string();
            break;
          }
          case 2: {
            IA.clearOnSubmit = k.bool();
            break;
          }
          case 3: {
            IA.border = k.bool();
            break;
          }
          case 4: {
            IA.enterToSubmit = k.bool();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, g.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, g.verify = function(k) {
      return typeof k != "object" || k === null ? "object expected" : k.formId != null && k.hasOwnProperty("formId") && !$util$1.isString(k.formId) ? "formId: string expected" : k.clearOnSubmit != null && k.hasOwnProperty("clearOnSubmit") && typeof k.clearOnSubmit != "boolean" ? "clearOnSubmit: boolean expected" : k.border != null && k.hasOwnProperty("border") && typeof k.border != "boolean" ? "border: boolean expected" : k.enterToSubmit != null && k.hasOwnProperty("enterToSubmit") && typeof k.enterToSubmit != "boolean" ? "enterToSubmit: boolean expected" : null;
    }, g.fromObject = function(k) {
      if (k instanceof $root$1.Block.Form) return k;
      let H = new $root$1.Block.Form();
      return k.formId != null && (H.formId = String(k.formId)), k.clearOnSubmit != null && (H.clearOnSubmit = !!k.clearOnSubmit), k.border != null && (H.border = !!k.border), k.enterToSubmit != null && (H.enterToSubmit = !!k.enterToSubmit), H;
    }, g.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.formId = "", AA.clearOnSubmit = !1, AA.border = !1, AA.enterToSubmit = !1), k.formId != null && k.hasOwnProperty("formId") && (AA.formId = k.formId), k.clearOnSubmit != null && k.hasOwnProperty("clearOnSubmit") && (AA.clearOnSubmit = k.clearOnSubmit), k.border != null && k.hasOwnProperty("border") && (AA.border = k.border), k.enterToSubmit != null && k.hasOwnProperty("enterToSubmit") && (AA.enterToSubmit = k.enterToSubmit), AA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/Block.Form";
    }, g;
  })(), n.TabContainer = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.defaultTabIndex = 0, g.create = function(k) {
      return new g(k);
    }, g.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.defaultTabIndex != null && Object.hasOwnProperty.call(k, "defaultTabIndex") && H.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(k.defaultTabIndex), H;
    }, g.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, g.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.Block.TabContainer();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.defaultTabIndex = k.int32();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, g.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, g.verify = function(k) {
      return typeof k != "object" || k === null ? "object expected" : k.defaultTabIndex != null && k.hasOwnProperty("defaultTabIndex") && !$util$1.isInteger(k.defaultTabIndex) ? "defaultTabIndex: integer expected" : null;
    }, g.fromObject = function(k) {
      if (k instanceof $root$1.Block.TabContainer) return k;
      let H = new $root$1.Block.TabContainer();
      return k.defaultTabIndex != null && (H.defaultTabIndex = k.defaultTabIndex | 0), H;
    }, g.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.defaultTabIndex = 0), k.defaultTabIndex != null && k.hasOwnProperty("defaultTabIndex") && (AA.defaultTabIndex = k.defaultTabIndex), AA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/Block.TabContainer";
    }, g;
  })(), n.Tab = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.label = "", g.create = function(k) {
      return new g(k);
    }, g.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.label != null && Object.hasOwnProperty.call(k, "label") && H.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(k.label), H;
    }, g.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, g.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.Block.Tab();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.label = k.string();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, g.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, g.verify = function(k) {
      return typeof k != "object" || k === null ? "object expected" : k.label != null && k.hasOwnProperty("label") && !$util$1.isString(k.label) ? "label: string expected" : null;
    }, g.fromObject = function(k) {
      if (k instanceof $root$1.Block.Tab) return k;
      let H = new $root$1.Block.Tab();
      return k.label != null && (H.label = String(k.label)), H;
    }, g.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.label = ""), k.label != null && k.hasOwnProperty("label") && (AA.label = k.label), AA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/Block.Tab";
    }, g;
  })(), n.Popover = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.label = "", g.prototype.useContainerWidth = !1, g.prototype.help = "", g.prototype.disabled = !1, g.prototype.icon = "", g.create = function(k) {
      return new g(k);
    }, g.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.label != null && Object.hasOwnProperty.call(k, "label") && H.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(k.label), k.useContainerWidth != null && Object.hasOwnProperty.call(k, "useContainerWidth") && H.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(k.useContainerWidth), k.help != null && Object.hasOwnProperty.call(k, "help") && H.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(k.help), k.disabled != null && Object.hasOwnProperty.call(k, "disabled") && H.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(k.disabled), k.icon != null && Object.hasOwnProperty.call(k, "icon") && H.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(k.icon), H;
    }, g.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, g.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.Block.Popover();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.label = k.string();
            break;
          }
          case 2: {
            IA.useContainerWidth = k.bool();
            break;
          }
          case 3: {
            IA.help = k.string();
            break;
          }
          case 4: {
            IA.disabled = k.bool();
            break;
          }
          case 5: {
            IA.icon = k.string();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, g.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, g.verify = function(k) {
      return typeof k != "object" || k === null ? "object expected" : k.label != null && k.hasOwnProperty("label") && !$util$1.isString(k.label) ? "label: string expected" : k.useContainerWidth != null && k.hasOwnProperty("useContainerWidth") && typeof k.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : k.help != null && k.hasOwnProperty("help") && !$util$1.isString(k.help) ? "help: string expected" : k.disabled != null && k.hasOwnProperty("disabled") && typeof k.disabled != "boolean" ? "disabled: boolean expected" : k.icon != null && k.hasOwnProperty("icon") && !$util$1.isString(k.icon) ? "icon: string expected" : null;
    }, g.fromObject = function(k) {
      if (k instanceof $root$1.Block.Popover) return k;
      let H = new $root$1.Block.Popover();
      return k.label != null && (H.label = String(k.label)), k.useContainerWidth != null && (H.useContainerWidth = !!k.useContainerWidth), k.help != null && (H.help = String(k.help)), k.disabled != null && (H.disabled = !!k.disabled), k.icon != null && (H.icon = String(k.icon)), H;
    }, g.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.label = "", AA.useContainerWidth = !1, AA.help = "", AA.disabled = !1, AA.icon = ""), k.label != null && k.hasOwnProperty("label") && (AA.label = k.label), k.useContainerWidth != null && k.hasOwnProperty("useContainerWidth") && (AA.useContainerWidth = k.useContainerWidth), k.help != null && k.hasOwnProperty("help") && (AA.help = k.help), k.disabled != null && k.hasOwnProperty("disabled") && (AA.disabled = k.disabled), k.icon != null && k.hasOwnProperty("icon") && (AA.icon = k.icon), AA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/Block.Popover";
    }, g;
  })(), n.ChatMessage = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.name = "", g.prototype.avatar = "", g.prototype.avatarType = 0, g.create = function(k) {
      return new g(k);
    }, g.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.name != null && Object.hasOwnProperty.call(k, "name") && H.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(k.name), k.avatar != null && Object.hasOwnProperty.call(k, "avatar") && H.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(k.avatar), k.avatarType != null && Object.hasOwnProperty.call(k, "avatarType") && H.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(k.avatarType), H;
    }, g.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, g.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.Block.ChatMessage();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.name = k.string();
            break;
          }
          case 2: {
            IA.avatar = k.string();
            break;
          }
          case 3: {
            IA.avatarType = k.int32();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, g.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, g.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      if (k.name != null && k.hasOwnProperty("name") && !$util$1.isString(k.name)) return "name: string expected";
      if (k.avatar != null && k.hasOwnProperty("avatar") && !$util$1.isString(k.avatar)) return "avatar: string expected";
      if (k.avatarType != null && k.hasOwnProperty("avatarType")) switch (k.avatarType) {
        default:
          return "avatarType: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
      return null;
    }, g.fromObject = function(k) {
      if (k instanceof $root$1.Block.ChatMessage) return k;
      let H = new $root$1.Block.ChatMessage();
      switch (k.name != null && (H.name = String(k.name)), k.avatar != null && (H.avatar = String(k.avatar)), k.avatarType) {
        default:
          if (typeof k.avatarType == "number") {
            H.avatarType = k.avatarType;
            break;
          }
          break;
        case "IMAGE":
        case 0:
          H.avatarType = 0;
          break;
        case "EMOJI":
        case 1:
          H.avatarType = 1;
          break;
        case "ICON":
        case 2:
          H.avatarType = 2;
          break;
      }
      return H;
    }, g.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.name = "", AA.avatar = "", AA.avatarType = H.enums === String ? "IMAGE" : 0), k.name != null && k.hasOwnProperty("name") && (AA.name = k.name), k.avatar != null && k.hasOwnProperty("avatar") && (AA.avatar = k.avatar), k.avatarType != null && k.hasOwnProperty("avatarType") && (AA.avatarType = H.enums === String ? $root$1.Block.ChatMessage.AvatarType[k.avatarType] === void 0 ? k.avatarType : $root$1.Block.ChatMessage.AvatarType[k.avatarType] : k.avatarType), AA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/Block.ChatMessage";
    }, g.AvatarType = (function() {
      const d = {}, k = Object.create(d);
      return k[d[0] = "IMAGE"] = 0, k[d[1] = "EMOJI"] = 1, k[d[2] = "ICON"] = 2, k;
    })(), g;
  })(), n;
})();
$root$1.BokehChart = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.figure = "", n.prototype.useContainerWidth = !1, n.prototype.elementId = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.figure != null && Object.hasOwnProperty.call(g, "figure") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.figure), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.useContainerWidth), g.elementId != null && Object.hasOwnProperty.call(g, "elementId") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.elementId), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.BokehChart();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.figure = g.string();
          break;
        }
        case 2: {
          AA.useContainerWidth = g.bool();
          break;
        }
        case 3: {
          AA.elementId = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.figure != null && g.hasOwnProperty("figure") && !$util$1.isString(g.figure) ? "figure: string expected" : g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && typeof g.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : g.elementId != null && g.hasOwnProperty("elementId") && !$util$1.isString(g.elementId) ? "elementId: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.BokehChart) return g;
    let d = new $root$1.BokehChart();
    return g.figure != null && (d.figure = String(g.figure)), g.useContainerWidth != null && (d.useContainerWidth = !!g.useContainerWidth), g.elementId != null && (d.elementId = String(g.elementId)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.figure = "", k.useContainerWidth = !1, k.elementId = ""), g.figure != null && g.hasOwnProperty("figure") && (k.figure = g.figure), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (k.useContainerWidth = g.useContainerWidth), g.elementId != null && g.hasOwnProperty("elementId") && (k.elementId = g.elementId), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/BokehChart";
  }, n;
})();
$root$1.Button = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.default = !1, n.prototype.help = "", n.prototype.formId = "", n.prototype.isFormSubmitter = !1, n.prototype.type = "", n.prototype.disabled = !1, n.prototype.useContainerWidth = !1, n.prototype.icon = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.default), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.isFormSubmitter != null && Object.hasOwnProperty.call(g, "isFormSubmitter") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.isFormSubmitter), g.type != null && Object.hasOwnProperty.call(g, "type") && d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.type), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.disabled), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && d.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.useContainerWidth), g.icon != null && Object.hasOwnProperty.call(g, "icon") && d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.icon), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Button();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.default = g.bool();
          break;
        }
        case 4: {
          AA.help = g.string();
          break;
        }
        case 5: {
          AA.formId = g.string();
          break;
        }
        case 6: {
          AA.isFormSubmitter = g.bool();
          break;
        }
        case 7: {
          AA.type = g.string();
          break;
        }
        case 8: {
          AA.disabled = g.bool();
          break;
        }
        case 9: {
          AA.useContainerWidth = g.bool();
          break;
        }
        case 10: {
          AA.icon = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.id != null && g.hasOwnProperty("id") && !$util$1.isString(g.id) ? "id: string expected" : g.label != null && g.hasOwnProperty("label") && !$util$1.isString(g.label) ? "label: string expected" : g.default != null && g.hasOwnProperty("default") && typeof g.default != "boolean" ? "default: boolean expected" : g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help) ? "help: string expected" : g.formId != null && g.hasOwnProperty("formId") && !$util$1.isString(g.formId) ? "formId: string expected" : g.isFormSubmitter != null && g.hasOwnProperty("isFormSubmitter") && typeof g.isFormSubmitter != "boolean" ? "isFormSubmitter: boolean expected" : g.type != null && g.hasOwnProperty("type") && !$util$1.isString(g.type) ? "type: string expected" : g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean" ? "disabled: boolean expected" : g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && typeof g.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : g.icon != null && g.hasOwnProperty("icon") && !$util$1.isString(g.icon) ? "icon: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Button) return g;
    let d = new $root$1.Button();
    return g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.default != null && (d.default = !!g.default), g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.isFormSubmitter != null && (d.isFormSubmitter = !!g.isFormSubmitter), g.type != null && (d.type = String(g.type)), g.disabled != null && (d.disabled = !!g.disabled), g.useContainerWidth != null && (d.useContainerWidth = !!g.useContainerWidth), g.icon != null && (d.icon = String(g.icon)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.id = "", k.label = "", k.default = !1, k.help = "", k.formId = "", k.isFormSubmitter = !1, k.type = "", k.disabled = !1, k.useContainerWidth = !1, k.icon = ""), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.default != null && g.hasOwnProperty("default") && (k.default = g.default), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.isFormSubmitter != null && g.hasOwnProperty("isFormSubmitter") && (k.isFormSubmitter = g.isFormSubmitter), g.type != null && g.hasOwnProperty("type") && (k.type = g.type), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (k.useContainerWidth = g.useContainerWidth), g.icon != null && g.hasOwnProperty("icon") && (k.icon = g.icon), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Button";
  }, n;
})();
const ButtonGroup$1 = $root$1.ButtonGroup = (() => {
  function n(g) {
    if (this.options = [], this.default = [], this.value = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.options = $util$1.emptyArray, n.prototype.default = $util$1.emptyArray, n.prototype.disabled = !1, n.prototype.clickMode = 0, n.prototype.formId = "", n.prototype.value = $util$1.emptyArray, n.prototype.setValue = !1, n.prototype.selectionVisualization = 0, n.prototype.style = 0, n.prototype.label = "", n.prototype.labelVisibility = null, n.prototype.help = null;
  let t;
  return Object.defineProperty(n.prototype, "_help", { get: $util$1.oneOfGetter(t = ["help"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    if (k || (k = $Writer$1.create()), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.id), d.options != null && d.options.length) for (let H = 0; H < d.options.length; ++H) $root$1.ButtonGroup.Option.encode(d.options[H], k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    if (d.default != null && d.default.length) {
      k.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let H = 0; H < d.default.length; ++H) k.uint32(d.default[H]);
      k.ldelim();
    }
    if (d.disabled != null && Object.hasOwnProperty.call(d, "disabled") && k.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(d.disabled), d.clickMode != null && Object.hasOwnProperty.call(d, "clickMode") && k.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(d.clickMode), d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.formId), d.value != null && d.value.length) {
      k.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let H = 0; H < d.value.length; ++H) k.uint32(d.value[H]);
      k.ldelim();
    }
    return d.setValue != null && Object.hasOwnProperty.call(d, "setValue") && k.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(d.setValue), d.selectionVisualization != null && Object.hasOwnProperty.call(d, "selectionVisualization") && k.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(d.selectionVisualization), d.style != null && Object.hasOwnProperty.call(d, "style") && k.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(d.style), d.label != null && Object.hasOwnProperty.call(d, "label") && k.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(d.label), d.labelVisibility != null && Object.hasOwnProperty.call(d, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(d.labelVisibility, k.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), d.help != null && Object.hasOwnProperty.call(d, "help") && k.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(d.help), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.ButtonGroup();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.id = d.string();
          break;
        }
        case 2: {
          gA.options && gA.options.length || (gA.options = []), gA.options.push($root$1.ButtonGroup.Option.decode(d, d.uint32()));
          break;
        }
        case 3: {
          if (gA.default && gA.default.length || (gA.default = []), (IA & 7) === 2) {
            let CA = d.uint32() + d.pos;
            for (; d.pos < CA; ) gA.default.push(d.uint32());
          } else gA.default.push(d.uint32());
          break;
        }
        case 4: {
          gA.disabled = d.bool();
          break;
        }
        case 5: {
          gA.clickMode = d.int32();
          break;
        }
        case 6: {
          gA.formId = d.string();
          break;
        }
        case 7: {
          if (gA.value && gA.value.length || (gA.value = []), (IA & 7) === 2) {
            let CA = d.uint32() + d.pos;
            for (; d.pos < CA; ) gA.value.push(d.uint32());
          } else gA.value.push(d.uint32());
          break;
        }
        case 8: {
          gA.setValue = d.bool();
          break;
        }
        case 9: {
          gA.selectionVisualization = d.int32();
          break;
        }
        case 10: {
          gA.style = d.int32();
          break;
        }
        case 11: {
          gA.label = d.string();
          break;
        }
        case 12: {
          gA.labelVisibility = $root$1.LabelVisibilityMessage.decode(d, d.uint32());
          break;
        }
        case 13: {
          gA.help = d.string();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.options != null && d.hasOwnProperty("options")) {
      if (!Array.isArray(d.options)) return "options: array expected";
      for (let k = 0; k < d.options.length; ++k) {
        let H = $root$1.ButtonGroup.Option.verify(d.options[k]);
        if (H) return "options." + H;
      }
    }
    if (d.default != null && d.hasOwnProperty("default")) {
      if (!Array.isArray(d.default)) return "default: array expected";
      for (let k = 0; k < d.default.length; ++k) if (!$util$1.isInteger(d.default[k])) return "default: integer[] expected";
    }
    if (d.disabled != null && d.hasOwnProperty("disabled") && typeof d.disabled != "boolean") return "disabled: boolean expected";
    if (d.clickMode != null && d.hasOwnProperty("clickMode")) switch (d.clickMode) {
      default:
        return "clickMode: enum value expected";
      case 0:
      case 1:
        break;
    }
    if (d.formId != null && d.hasOwnProperty("formId") && !$util$1.isString(d.formId)) return "formId: string expected";
    if (d.value != null && d.hasOwnProperty("value")) {
      if (!Array.isArray(d.value)) return "value: array expected";
      for (let k = 0; k < d.value.length; ++k) if (!$util$1.isInteger(d.value[k])) return "value: integer[] expected";
    }
    if (d.setValue != null && d.hasOwnProperty("setValue") && typeof d.setValue != "boolean") return "setValue: boolean expected";
    if (d.selectionVisualization != null && d.hasOwnProperty("selectionVisualization")) switch (d.selectionVisualization) {
      default:
        return "selectionVisualization: enum value expected";
      case 0:
      case 1:
        break;
    }
    if (d.style != null && d.hasOwnProperty("style")) switch (d.style) {
      default:
        return "style: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (d.label != null && d.hasOwnProperty("label") && !$util$1.isString(d.label)) return "label: string expected";
    if (d.labelVisibility != null && d.hasOwnProperty("labelVisibility")) {
      let k = $root$1.LabelVisibilityMessage.verify(d.labelVisibility);
      if (k) return "labelVisibility." + k;
    }
    return d.help != null && d.hasOwnProperty("help") && !$util$1.isString(d.help) ? "help: string expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.ButtonGroup) return d;
    let k = new $root$1.ButtonGroup();
    if (d.id != null && (k.id = String(d.id)), d.options) {
      if (!Array.isArray(d.options)) throw TypeError(".ButtonGroup.options: array expected");
      k.options = [];
      for (let H = 0; H < d.options.length; ++H) {
        if (typeof d.options[H] != "object") throw TypeError(".ButtonGroup.options: object expected");
        k.options[H] = $root$1.ButtonGroup.Option.fromObject(d.options[H]);
      }
    }
    if (d.default) {
      if (!Array.isArray(d.default)) throw TypeError(".ButtonGroup.default: array expected");
      k.default = [];
      for (let H = 0; H < d.default.length; ++H) k.default[H] = d.default[H] >>> 0;
    }
    switch (d.disabled != null && (k.disabled = !!d.disabled), d.clickMode) {
      default:
        if (typeof d.clickMode == "number") {
          k.clickMode = d.clickMode;
          break;
        }
        break;
      case "SINGLE_SELECT":
      case 0:
        k.clickMode = 0;
        break;
      case "MULTI_SELECT":
      case 1:
        k.clickMode = 1;
        break;
    }
    if (d.formId != null && (k.formId = String(d.formId)), d.value) {
      if (!Array.isArray(d.value)) throw TypeError(".ButtonGroup.value: array expected");
      k.value = [];
      for (let H = 0; H < d.value.length; ++H) k.value[H] = d.value[H] >>> 0;
    }
    switch (d.setValue != null && (k.setValue = !!d.setValue), d.selectionVisualization) {
      default:
        if (typeof d.selectionVisualization == "number") {
          k.selectionVisualization = d.selectionVisualization;
          break;
        }
        break;
      case "ONLY_SELECTED":
      case 0:
        k.selectionVisualization = 0;
        break;
      case "ALL_UP_TO_SELECTED":
      case 1:
        k.selectionVisualization = 1;
        break;
    }
    switch (d.style) {
      default:
        if (typeof d.style == "number") {
          k.style = d.style;
          break;
        }
        break;
      case "SEGMENTED_CONTROL":
      case 0:
        k.style = 0;
        break;
      case "PILLS":
      case 1:
        k.style = 1;
        break;
      case "BORDERLESS":
      case 2:
        k.style = 2;
        break;
    }
    if (d.label != null && (k.label = String(d.label)), d.labelVisibility != null) {
      if (typeof d.labelVisibility != "object") throw TypeError(".ButtonGroup.labelVisibility: object expected");
      k.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(d.labelVisibility);
    }
    return d.help != null && (k.help = String(d.help)), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    if ((k.arrays || k.defaults) && (H.options = [], H.default = [], H.value = []), k.defaults && (H.id = "", H.disabled = !1, H.clickMode = k.enums === String ? "SINGLE_SELECT" : 0, H.formId = "", H.setValue = !1, H.selectionVisualization = k.enums === String ? "ONLY_SELECTED" : 0, H.style = k.enums === String ? "SEGMENTED_CONTROL" : 0, H.label = "", H.labelVisibility = null), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.options && d.options.length) {
      H.options = [];
      for (let AA = 0; AA < d.options.length; ++AA) H.options[AA] = $root$1.ButtonGroup.Option.toObject(d.options[AA], k);
    }
    if (d.default && d.default.length) {
      H.default = [];
      for (let AA = 0; AA < d.default.length; ++AA) H.default[AA] = d.default[AA];
    }
    if (d.disabled != null && d.hasOwnProperty("disabled") && (H.disabled = d.disabled), d.clickMode != null && d.hasOwnProperty("clickMode") && (H.clickMode = k.enums === String ? $root$1.ButtonGroup.ClickMode[d.clickMode] === void 0 ? d.clickMode : $root$1.ButtonGroup.ClickMode[d.clickMode] : d.clickMode), d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.value && d.value.length) {
      H.value = [];
      for (let AA = 0; AA < d.value.length; ++AA) H.value[AA] = d.value[AA];
    }
    return d.setValue != null && d.hasOwnProperty("setValue") && (H.setValue = d.setValue), d.selectionVisualization != null && d.hasOwnProperty("selectionVisualization") && (H.selectionVisualization = k.enums === String ? $root$1.ButtonGroup.SelectionVisualization[d.selectionVisualization] === void 0 ? d.selectionVisualization : $root$1.ButtonGroup.SelectionVisualization[d.selectionVisualization] : d.selectionVisualization), d.style != null && d.hasOwnProperty("style") && (H.style = k.enums === String ? $root$1.ButtonGroup.Style[d.style] === void 0 ? d.style : $root$1.ButtonGroup.Style[d.style] : d.style), d.label != null && d.hasOwnProperty("label") && (H.label = d.label), d.labelVisibility != null && d.hasOwnProperty("labelVisibility") && (H.labelVisibility = $root$1.LabelVisibilityMessage.toObject(d.labelVisibility, k)), d.help != null && d.hasOwnProperty("help") && (H.help = d.help, k.oneofs && (H._help = "help")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/ButtonGroup";
  }, n.ClickMode = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "SINGLE_SELECT"] = 0, d[g[1] = "MULTI_SELECT"] = 1, d;
  })(), n.Option = (function() {
    function g(k) {
      if (k) for (let H = Object.keys(k), AA = 0; AA < H.length; ++AA) k[H[AA]] != null && (this[H[AA]] = k[H[AA]]);
    }
    g.prototype.content = "", g.prototype.selectedContent = null, g.prototype.contentIcon = null, g.prototype.selectedContentIcon = null;
    let d;
    return Object.defineProperty(g.prototype, "_selectedContent", { get: $util$1.oneOfGetter(d = ["selectedContent"]), set: $util$1.oneOfSetter(d) }), Object.defineProperty(g.prototype, "_contentIcon", { get: $util$1.oneOfGetter(d = ["contentIcon"]), set: $util$1.oneOfSetter(d) }), Object.defineProperty(g.prototype, "_selectedContentIcon", { get: $util$1.oneOfGetter(d = ["selectedContentIcon"]), set: $util$1.oneOfSetter(d) }), g.create = function(H) {
      return new g(H);
    }, g.encode = function(H, AA) {
      return AA || (AA = $Writer$1.create()), H.content != null && Object.hasOwnProperty.call(H, "content") && AA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(H.content), H.selectedContent != null && Object.hasOwnProperty.call(H, "selectedContent") && AA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(H.selectedContent), H.contentIcon != null && Object.hasOwnProperty.call(H, "contentIcon") && AA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(H.contentIcon), H.selectedContentIcon != null && Object.hasOwnProperty.call(H, "selectedContentIcon") && AA.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(H.selectedContentIcon), AA;
    }, g.encodeDelimited = function(H, AA) {
      return this.encode(H, AA).ldelim();
    }, g.decode = function(H, AA, gA) {
      H instanceof $Reader$1 || (H = $Reader$1.create(H));
      let IA = AA === void 0 ? H.len : H.pos + AA, CA = new $root$1.ButtonGroup.Option();
      for (; H.pos < IA; ) {
        let BA = H.uint32();
        if (BA === gA) break;
        switch (BA >>> 3) {
          case 1: {
            CA.content = H.string();
            break;
          }
          case 2: {
            CA.selectedContent = H.string();
            break;
          }
          case 3: {
            CA.contentIcon = H.string();
            break;
          }
          case 4: {
            CA.selectedContentIcon = H.string();
            break;
          }
          default:
            H.skipType(BA & 7);
            break;
        }
      }
      return CA;
    }, g.decodeDelimited = function(H) {
      return H instanceof $Reader$1 || (H = new $Reader$1(H)), this.decode(H, H.uint32());
    }, g.verify = function(H) {
      return typeof H != "object" || H === null ? "object expected" : H.content != null && H.hasOwnProperty("content") && !$util$1.isString(H.content) ? "content: string expected" : H.selectedContent != null && H.hasOwnProperty("selectedContent") && !$util$1.isString(H.selectedContent) ? "selectedContent: string expected" : H.contentIcon != null && H.hasOwnProperty("contentIcon") && !$util$1.isString(H.contentIcon) ? "contentIcon: string expected" : H.selectedContentIcon != null && H.hasOwnProperty("selectedContentIcon") && !$util$1.isString(H.selectedContentIcon) ? "selectedContentIcon: string expected" : null;
    }, g.fromObject = function(H) {
      if (H instanceof $root$1.ButtonGroup.Option) return H;
      let AA = new $root$1.ButtonGroup.Option();
      return H.content != null && (AA.content = String(H.content)), H.selectedContent != null && (AA.selectedContent = String(H.selectedContent)), H.contentIcon != null && (AA.contentIcon = String(H.contentIcon)), H.selectedContentIcon != null && (AA.selectedContentIcon = String(H.selectedContentIcon)), AA;
    }, g.toObject = function(H, AA) {
      AA || (AA = {});
      let gA = {};
      return AA.defaults && (gA.content = ""), H.content != null && H.hasOwnProperty("content") && (gA.content = H.content), H.selectedContent != null && H.hasOwnProperty("selectedContent") && (gA.selectedContent = H.selectedContent, AA.oneofs && (gA._selectedContent = "selectedContent")), H.contentIcon != null && H.hasOwnProperty("contentIcon") && (gA.contentIcon = H.contentIcon, AA.oneofs && (gA._contentIcon = "contentIcon")), H.selectedContentIcon != null && H.hasOwnProperty("selectedContentIcon") && (gA.selectedContentIcon = H.selectedContentIcon, AA.oneofs && (gA._selectedContentIcon = "selectedContentIcon")), gA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, g.getTypeUrl = function(H) {
      return H === void 0 && (H = "type.googleapis.com"), H + "/ButtonGroup.Option";
    }, g;
  })(), n.SelectionVisualization = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "ONLY_SELECTED"] = 0, d[g[1] = "ALL_UP_TO_SELECTED"] = 1, d;
  })(), n.Style = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "SEGMENTED_CONTROL"] = 0, d[g[1] = "PILLS"] = 1, d[g[2] = "BORDERLESS"] = 2, d;
  })(), n;
})();
$root$1.CameraInput = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.help = "", n.prototype.formId = "", n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.formId), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.CameraInput();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.help = g.string();
          break;
        }
        case 4: {
          AA.formId = g.string();
          break;
        }
        case 5: {
          AA.disabled = g.bool();
          break;
        }
        case 6: {
          AA.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util$1.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util$1.isString(g.label)) return "label: string expected";
    if (g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help)) return "help: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util$1.isString(g.formId)) return "formId: string expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root$1.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.CameraInput) return g;
    let d = new $root$1.CameraInput();
    if (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".CameraInput.labelVisibility: object expected");
      d.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.id = "", k.label = "", k.help = "", k.formId = "", k.disabled = !1, k.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/CameraInput";
  }, n;
})();
const ChatInput$1 = $root$1.ChatInput = (() => {
  function n(t) {
    if (this.fileType = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.placeholder = "", n.prototype.maxChars = 0, n.prototype.disabled = !1, n.prototype.value = "", n.prototype.setValue = !1, n.prototype.default = "", n.prototype.position = 0, n.prototype.acceptFile = 0, n.prototype.fileType = $util$1.emptyArray, n.prototype.maxUploadSizeMb = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.placeholder), g.maxChars != null && Object.hasOwnProperty.call(g, "maxChars") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(g.maxChars), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.disabled), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.setValue), g.default != null && Object.hasOwnProperty.call(g, "default") && d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.default), g.position != null && Object.hasOwnProperty.call(g, "position") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.position), g.acceptFile != null && Object.hasOwnProperty.call(g, "acceptFile") && d.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(g.acceptFile), g.fileType != null && g.fileType.length) for (let k = 0; k < g.fileType.length; ++k) d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.fileType[k]);
    return g.maxUploadSizeMb != null && Object.hasOwnProperty.call(g, "maxUploadSizeMb") && d.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(g.maxUploadSizeMb), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ChatInput();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.placeholder = g.string();
          break;
        }
        case 3: {
          AA.maxChars = g.uint32();
          break;
        }
        case 4: {
          AA.disabled = g.bool();
          break;
        }
        case 5: {
          AA.value = g.string();
          break;
        }
        case 6: {
          AA.setValue = g.bool();
          break;
        }
        case 7: {
          AA.default = g.string();
          break;
        }
        case 8: {
          AA.position = g.int32();
          break;
        }
        case 9: {
          AA.acceptFile = g.int32();
          break;
        }
        case 10: {
          AA.fileType && AA.fileType.length || (AA.fileType = []), AA.fileType.push(g.string());
          break;
        }
        case 11: {
          AA.maxUploadSizeMb = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util$1.isString(g.id)) return "id: string expected";
    if (g.placeholder != null && g.hasOwnProperty("placeholder") && !$util$1.isString(g.placeholder)) return "placeholder: string expected";
    if (g.maxChars != null && g.hasOwnProperty("maxChars") && !$util$1.isInteger(g.maxChars)) return "maxChars: integer expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.value != null && g.hasOwnProperty("value") && !$util$1.isString(g.value)) return "value: string expected";
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.default != null && g.hasOwnProperty("default") && !$util$1.isString(g.default)) return "default: string expected";
    if (g.position != null && g.hasOwnProperty("position")) switch (g.position) {
      default:
        return "position: enum value expected";
      case 0:
        break;
    }
    if (g.acceptFile != null && g.hasOwnProperty("acceptFile")) switch (g.acceptFile) {
      default:
        return "acceptFile: enum value expected";
      case 0:
      case 1:
      case 2:
      case 3:
        break;
    }
    if (g.fileType != null && g.hasOwnProperty("fileType")) {
      if (!Array.isArray(g.fileType)) return "fileType: array expected";
      for (let d = 0; d < g.fileType.length; ++d) if (!$util$1.isString(g.fileType[d])) return "fileType: string[] expected";
    }
    return g.maxUploadSizeMb != null && g.hasOwnProperty("maxUploadSizeMb") && !$util$1.isInteger(g.maxUploadSizeMb) ? "maxUploadSizeMb: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ChatInput) return g;
    let d = new $root$1.ChatInput();
    switch (g.id != null && (d.id = String(g.id)), g.placeholder != null && (d.placeholder = String(g.placeholder)), g.maxChars != null && (d.maxChars = g.maxChars >>> 0), g.disabled != null && (d.disabled = !!g.disabled), g.value != null && (d.value = String(g.value)), g.setValue != null && (d.setValue = !!g.setValue), g.default != null && (d.default = String(g.default)), g.position) {
      default:
        if (typeof g.position == "number") {
          d.position = g.position;
          break;
        }
        break;
      case "BOTTOM":
      case 0:
        d.position = 0;
        break;
    }
    switch (g.acceptFile) {
      default:
        if (typeof g.acceptFile == "number") {
          d.acceptFile = g.acceptFile;
          break;
        }
        break;
      case "NONE":
      case 0:
        d.acceptFile = 0;
        break;
      case "SINGLE":
      case 1:
        d.acceptFile = 1;
        break;
      case "MULTIPLE":
      case 2:
        d.acceptFile = 2;
        break;
      case "DIRECTORY":
      case 3:
        d.acceptFile = 3;
        break;
    }
    if (g.fileType) {
      if (!Array.isArray(g.fileType)) throw TypeError(".ChatInput.fileType: array expected");
      d.fileType = [];
      for (let k = 0; k < g.fileType.length; ++k) d.fileType[k] = String(g.fileType[k]);
    }
    return g.maxUploadSizeMb != null && (d.maxUploadSizeMb = g.maxUploadSizeMb | 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.fileType = []), d.defaults && (k.id = "", k.placeholder = "", k.maxChars = 0, k.disabled = !1, k.value = "", k.setValue = !1, k.default = "", k.position = d.enums === String ? "BOTTOM" : 0, k.acceptFile = d.enums === String ? "NONE" : 0, k.maxUploadSizeMb = 0), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.placeholder != null && g.hasOwnProperty("placeholder") && (k.placeholder = g.placeholder), g.maxChars != null && g.hasOwnProperty("maxChars") && (k.maxChars = g.maxChars), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.value != null && g.hasOwnProperty("value") && (k.value = g.value), g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.default != null && g.hasOwnProperty("default") && (k.default = g.default), g.position != null && g.hasOwnProperty("position") && (k.position = d.enums === String ? $root$1.ChatInput.Position[g.position] === void 0 ? g.position : $root$1.ChatInput.Position[g.position] : g.position), g.acceptFile != null && g.hasOwnProperty("acceptFile") && (k.acceptFile = d.enums === String ? $root$1.ChatInput.AcceptFile[g.acceptFile] === void 0 ? g.acceptFile : $root$1.ChatInput.AcceptFile[g.acceptFile] : g.acceptFile), g.fileType && g.fileType.length) {
      k.fileType = [];
      for (let H = 0; H < g.fileType.length; ++H) k.fileType[H] = g.fileType[H];
    }
    return g.maxUploadSizeMb != null && g.hasOwnProperty("maxUploadSizeMb") && (k.maxUploadSizeMb = g.maxUploadSizeMb), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ChatInput";
  }, n.Position = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "BOTTOM"] = 0, g;
  })(), n.AcceptFile = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "NONE"] = 0, g[t[1] = "SINGLE"] = 1, g[t[2] = "MULTIPLE"] = 2, g[t[3] = "DIRECTORY"] = 3, g;
  })(), n;
})(), Checkbox$1 = $root$1.Checkbox = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.default = !1, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = !1, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.type = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.default), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.type != null && Object.hasOwnProperty.call(g, "type") && d.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(g.type), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Checkbox();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.default = g.bool();
          break;
        }
        case 4: {
          AA.help = g.string();
          break;
        }
        case 5: {
          AA.formId = g.string();
          break;
        }
        case 6: {
          AA.value = g.bool();
          break;
        }
        case 7: {
          AA.setValue = g.bool();
          break;
        }
        case 8: {
          AA.disabled = g.bool();
          break;
        }
        case 9: {
          AA.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 10: {
          AA.type = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util$1.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util$1.isString(g.label)) return "label: string expected";
    if (g.default != null && g.hasOwnProperty("default") && typeof g.default != "boolean") return "default: boolean expected";
    if (g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help)) return "help: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util$1.isString(g.formId)) return "formId: string expected";
    if (g.value != null && g.hasOwnProperty("value") && typeof g.value != "boolean") return "value: boolean expected";
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root$1.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    if (g.type != null && g.hasOwnProperty("type")) switch (g.type) {
      default:
        return "type: enum value expected";
      case 0:
      case 1:
        break;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Checkbox) return g;
    let d = new $root$1.Checkbox();
    if (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.default != null && (d.default = !!g.default), g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.value != null && (d.value = !!g.value), g.setValue != null && (d.setValue = !!g.setValue), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".Checkbox.labelVisibility: object expected");
      d.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    switch (g.type) {
      default:
        if (typeof g.type == "number") {
          d.type = g.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        d.type = 0;
        break;
      case "TOGGLE":
      case 1:
        d.type = 1;
        break;
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.id = "", k.label = "", k.default = !1, k.help = "", k.formId = "", k.value = !1, k.setValue = !1, k.disabled = !1, k.labelVisibility = null, k.type = d.enums === String ? "DEFAULT" : 0), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.default != null && g.hasOwnProperty("default") && (k.default = g.default), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (k.value = g.value), g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.type != null && g.hasOwnProperty("type") && (k.type = d.enums === String ? $root$1.Checkbox.StyleType[g.type] === void 0 ? g.type : $root$1.Checkbox.StyleType[g.type] : g.type), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Checkbox";
  }, n.StyleType = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "DEFAULT"] = 0, g[t[1] = "TOGGLE"] = 1, g;
  })(), n;
})();
$root$1.Code = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.codeText = "", n.prototype.language = "", n.prototype.showLineNumbers = !1, n.prototype.wrapLines = !1, n.prototype.height = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.codeText != null && Object.hasOwnProperty.call(g, "codeText") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.codeText), g.language != null && Object.hasOwnProperty.call(g, "language") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.language), g.showLineNumbers != null && Object.hasOwnProperty.call(g, "showLineNumbers") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.showLineNumbers), g.wrapLines != null && Object.hasOwnProperty.call(g, "wrapLines") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.wrapLines), g.height != null && Object.hasOwnProperty.call(g, "height") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(g.height), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Code();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.codeText = g.string();
          break;
        }
        case 2: {
          AA.language = g.string();
          break;
        }
        case 3: {
          AA.showLineNumbers = g.bool();
          break;
        }
        case 4: {
          AA.wrapLines = g.bool();
          break;
        }
        case 5: {
          AA.height = g.uint32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.codeText != null && g.hasOwnProperty("codeText") && !$util$1.isString(g.codeText) ? "codeText: string expected" : g.language != null && g.hasOwnProperty("language") && !$util$1.isString(g.language) ? "language: string expected" : g.showLineNumbers != null && g.hasOwnProperty("showLineNumbers") && typeof g.showLineNumbers != "boolean" ? "showLineNumbers: boolean expected" : g.wrapLines != null && g.hasOwnProperty("wrapLines") && typeof g.wrapLines != "boolean" ? "wrapLines: boolean expected" : g.height != null && g.hasOwnProperty("height") && !$util$1.isInteger(g.height) ? "height: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Code) return g;
    let d = new $root$1.Code();
    return g.codeText != null && (d.codeText = String(g.codeText)), g.language != null && (d.language = String(g.language)), g.showLineNumbers != null && (d.showLineNumbers = !!g.showLineNumbers), g.wrapLines != null && (d.wrapLines = !!g.wrapLines), g.height != null && (d.height = g.height >>> 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.codeText = "", k.language = "", k.showLineNumbers = !1, k.wrapLines = !1, k.height = 0), g.codeText != null && g.hasOwnProperty("codeText") && (k.codeText = g.codeText), g.language != null && g.hasOwnProperty("language") && (k.language = g.language), g.showLineNumbers != null && g.hasOwnProperty("showLineNumbers") && (k.showLineNumbers = g.showLineNumbers), g.wrapLines != null && g.hasOwnProperty("wrapLines") && (k.wrapLines = g.wrapLines), g.height != null && g.hasOwnProperty("height") && (k.height = g.height), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Code";
  }, n;
})();
$root$1.ColorPicker = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.default = "", n.prototype.help = "", n.prototype.formId = "", n.prototype.value = "", n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ColorPicker();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.default = g.string();
          break;
        }
        case 4: {
          AA.help = g.string();
          break;
        }
        case 5: {
          AA.formId = g.string();
          break;
        }
        case 6: {
          AA.value = g.string();
          break;
        }
        case 7: {
          AA.setValue = g.bool();
          break;
        }
        case 8: {
          AA.disabled = g.bool();
          break;
        }
        case 9: {
          AA.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util$1.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util$1.isString(g.label)) return "label: string expected";
    if (g.default != null && g.hasOwnProperty("default") && !$util$1.isString(g.default)) return "default: string expected";
    if (g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help)) return "help: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util$1.isString(g.formId)) return "formId: string expected";
    if (g.value != null && g.hasOwnProperty("value") && !$util$1.isString(g.value)) return "value: string expected";
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root$1.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ColorPicker) return g;
    let d = new $root$1.ColorPicker();
    if (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.default != null && (d.default = String(g.default)), g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.value != null && (d.value = String(g.value)), g.setValue != null && (d.setValue = !!g.setValue), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".ColorPicker.labelVisibility: object expected");
      d.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.id = "", k.label = "", k.default = "", k.help = "", k.formId = "", k.value = "", k.setValue = !1, k.disabled = !1, k.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.default != null && g.hasOwnProperty("default") && (k.default = g.default), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (k.value = g.value), g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ColorPicker";
  }, n;
})();
$root$1.DataFrame = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.prototype.index = null, n.prototype.columns = null, n.prototype.style = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.Table.encode(g.data, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.index != null && Object.hasOwnProperty.call(g, "index") && $root$1.Index.encode(g.index, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.columns != null && Object.hasOwnProperty.call(g, "columns") && $root$1.Index.encode(g.columns, d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.style != null && Object.hasOwnProperty.call(g, "style") && $root$1.TableStyle.encode(g.style, d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.DataFrame();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.data = $root$1.Table.decode(g, g.uint32());
          break;
        }
        case 2: {
          AA.index = $root$1.Index.decode(g, g.uint32());
          break;
        }
        case 3: {
          AA.columns = $root$1.Index.decode(g, g.uint32());
          break;
        }
        case 4: {
          AA.style = $root$1.TableStyle.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      let d = $root$1.Table.verify(g.data);
      if (d) return "data." + d;
    }
    if (g.index != null && g.hasOwnProperty("index")) {
      let d = $root$1.Index.verify(g.index);
      if (d) return "index." + d;
    }
    if (g.columns != null && g.hasOwnProperty("columns")) {
      let d = $root$1.Index.verify(g.columns);
      if (d) return "columns." + d;
    }
    if (g.style != null && g.hasOwnProperty("style")) {
      let d = $root$1.TableStyle.verify(g.style);
      if (d) return "style." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.DataFrame) return g;
    let d = new $root$1.DataFrame();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".DataFrame.data: object expected");
      d.data = $root$1.Table.fromObject(g.data);
    }
    if (g.index != null) {
      if (typeof g.index != "object") throw TypeError(".DataFrame.index: object expected");
      d.index = $root$1.Index.fromObject(g.index);
    }
    if (g.columns != null) {
      if (typeof g.columns != "object") throw TypeError(".DataFrame.columns: object expected");
      d.columns = $root$1.Index.fromObject(g.columns);
    }
    if (g.style != null) {
      if (typeof g.style != "object") throw TypeError(".DataFrame.style: object expected");
      d.style = $root$1.TableStyle.fromObject(g.style);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.data = null, k.index = null, k.columns = null, k.style = null), g.data != null && g.hasOwnProperty("data") && (k.data = $root$1.Table.toObject(g.data, d)), g.index != null && g.hasOwnProperty("index") && (k.index = $root$1.Index.toObject(g.index, d)), g.columns != null && g.hasOwnProperty("columns") && (k.columns = $root$1.Index.toObject(g.columns, d)), g.style != null && g.hasOwnProperty("style") && (k.style = $root$1.TableStyle.toObject(g.style, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DataFrame";
  }, n;
})();
$root$1.Index = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.plainIndex = null, n.prototype.rangeIndex = null, n.prototype.multiIndex = null, n.prototype.datetimeIndex = null, n.prototype.timedeltaIndex = null, n.prototype.int_64Index = null, n.prototype.float_64Index = null;
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util$1.oneOfGetter(t = ["plainIndex", "rangeIndex", "multiIndex", "datetimeIndex", "timedeltaIndex", "int_64Index", "float_64Index"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.plainIndex != null && Object.hasOwnProperty.call(d, "plainIndex") && $root$1.PlainIndex.encode(d.plainIndex, k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), d.rangeIndex != null && Object.hasOwnProperty.call(d, "rangeIndex") && $root$1.RangeIndex.encode(d.rangeIndex, k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), d.multiIndex != null && Object.hasOwnProperty.call(d, "multiIndex") && $root$1.MultiIndex.encode(d.multiIndex, k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), d.datetimeIndex != null && Object.hasOwnProperty.call(d, "datetimeIndex") && $root$1.DatetimeIndex.encode(d.datetimeIndex, k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), d.timedeltaIndex != null && Object.hasOwnProperty.call(d, "timedeltaIndex") && $root$1.TimedeltaIndex.encode(d.timedeltaIndex, k.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), d.int_64Index != null && Object.hasOwnProperty.call(d, "int_64Index") && $root$1.Int64Index.encode(d.int_64Index, k.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), d.float_64Index != null && Object.hasOwnProperty.call(d, "float_64Index") && $root$1.Float64Index.encode(d.float_64Index, k.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Index();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.plainIndex = $root$1.PlainIndex.decode(d, d.uint32());
          break;
        }
        case 2: {
          gA.rangeIndex = $root$1.RangeIndex.decode(d, d.uint32());
          break;
        }
        case 4: {
          gA.multiIndex = $root$1.MultiIndex.decode(d, d.uint32());
          break;
        }
        case 6: {
          gA.datetimeIndex = $root$1.DatetimeIndex.decode(d, d.uint32());
          break;
        }
        case 7: {
          gA.timedeltaIndex = $root$1.TimedeltaIndex.decode(d, d.uint32());
          break;
        }
        case 9: {
          gA.int_64Index = $root$1.Int64Index.decode(d, d.uint32());
          break;
        }
        case 11: {
          gA.float_64Index = $root$1.Float64Index.decode(d, d.uint32());
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.plainIndex != null && d.hasOwnProperty("plainIndex")) {
      k.type = 1;
      {
        let H = $root$1.PlainIndex.verify(d.plainIndex);
        if (H) return "plainIndex." + H;
      }
    }
    if (d.rangeIndex != null && d.hasOwnProperty("rangeIndex")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.RangeIndex.verify(d.rangeIndex);
        if (H) return "rangeIndex." + H;
      }
    }
    if (d.multiIndex != null && d.hasOwnProperty("multiIndex")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.MultiIndex.verify(d.multiIndex);
        if (H) return "multiIndex." + H;
      }
    }
    if (d.datetimeIndex != null && d.hasOwnProperty("datetimeIndex")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.DatetimeIndex.verify(d.datetimeIndex);
        if (H) return "datetimeIndex." + H;
      }
    }
    if (d.timedeltaIndex != null && d.hasOwnProperty("timedeltaIndex")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.TimedeltaIndex.verify(d.timedeltaIndex);
        if (H) return "timedeltaIndex." + H;
      }
    }
    if (d.int_64Index != null && d.hasOwnProperty("int_64Index")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Int64Index.verify(d.int_64Index);
        if (H) return "int_64Index." + H;
      }
    }
    if (d.float_64Index != null && d.hasOwnProperty("float_64Index")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Float64Index.verify(d.float_64Index);
        if (H) return "float_64Index." + H;
      }
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Index) return d;
    let k = new $root$1.Index();
    if (d.plainIndex != null) {
      if (typeof d.plainIndex != "object") throw TypeError(".Index.plainIndex: object expected");
      k.plainIndex = $root$1.PlainIndex.fromObject(d.plainIndex);
    }
    if (d.rangeIndex != null) {
      if (typeof d.rangeIndex != "object") throw TypeError(".Index.rangeIndex: object expected");
      k.rangeIndex = $root$1.RangeIndex.fromObject(d.rangeIndex);
    }
    if (d.multiIndex != null) {
      if (typeof d.multiIndex != "object") throw TypeError(".Index.multiIndex: object expected");
      k.multiIndex = $root$1.MultiIndex.fromObject(d.multiIndex);
    }
    if (d.datetimeIndex != null) {
      if (typeof d.datetimeIndex != "object") throw TypeError(".Index.datetimeIndex: object expected");
      k.datetimeIndex = $root$1.DatetimeIndex.fromObject(d.datetimeIndex);
    }
    if (d.timedeltaIndex != null) {
      if (typeof d.timedeltaIndex != "object") throw TypeError(".Index.timedeltaIndex: object expected");
      k.timedeltaIndex = $root$1.TimedeltaIndex.fromObject(d.timedeltaIndex);
    }
    if (d.int_64Index != null) {
      if (typeof d.int_64Index != "object") throw TypeError(".Index.int_64Index: object expected");
      k.int_64Index = $root$1.Int64Index.fromObject(d.int_64Index);
    }
    if (d.float_64Index != null) {
      if (typeof d.float_64Index != "object") throw TypeError(".Index.float_64Index: object expected");
      k.float_64Index = $root$1.Float64Index.fromObject(d.float_64Index);
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return d.plainIndex != null && d.hasOwnProperty("plainIndex") && (H.plainIndex = $root$1.PlainIndex.toObject(d.plainIndex, k), k.oneofs && (H.type = "plainIndex")), d.rangeIndex != null && d.hasOwnProperty("rangeIndex") && (H.rangeIndex = $root$1.RangeIndex.toObject(d.rangeIndex, k), k.oneofs && (H.type = "rangeIndex")), d.multiIndex != null && d.hasOwnProperty("multiIndex") && (H.multiIndex = $root$1.MultiIndex.toObject(d.multiIndex, k), k.oneofs && (H.type = "multiIndex")), d.datetimeIndex != null && d.hasOwnProperty("datetimeIndex") && (H.datetimeIndex = $root$1.DatetimeIndex.toObject(d.datetimeIndex, k), k.oneofs && (H.type = "datetimeIndex")), d.timedeltaIndex != null && d.hasOwnProperty("timedeltaIndex") && (H.timedeltaIndex = $root$1.TimedeltaIndex.toObject(d.timedeltaIndex, k), k.oneofs && (H.type = "timedeltaIndex")), d.int_64Index != null && d.hasOwnProperty("int_64Index") && (H.int_64Index = $root$1.Int64Index.toObject(d.int_64Index, k), k.oneofs && (H.type = "int_64Index")), d.float_64Index != null && d.hasOwnProperty("float_64Index") && (H.float_64Index = $root$1.Float64Index.toObject(d.float_64Index, k), k.oneofs && (H.type = "float_64Index")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Index";
  }, n;
})();
$root$1.PlainIndex = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.AnyArray.encode(g.data, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.PlainIndex();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.data = $root$1.AnyArray.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      let d = $root$1.AnyArray.verify(g.data);
      if (d) return "data." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.PlainIndex) return g;
    let d = new $root$1.PlainIndex();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".PlainIndex.data: object expected");
      d.data = $root$1.AnyArray.fromObject(g.data);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.data = null), g.data != null && g.hasOwnProperty("data") && (k.data = $root$1.AnyArray.toObject(g.data, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PlainIndex";
  }, n;
})();
$root$1.RangeIndex = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.start = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, n.prototype.stop = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.start != null && Object.hasOwnProperty.call(g, "start") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int64(g.start), g.stop != null && Object.hasOwnProperty.call(g, "stop") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(g.stop), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.RangeIndex();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.start = g.int64();
          break;
        }
        case 2: {
          AA.stop = g.int64();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.start != null && g.hasOwnProperty("start") && !$util$1.isInteger(g.start) && !(g.start && $util$1.isInteger(g.start.low) && $util$1.isInteger(g.start.high)) ? "start: integer|Long expected" : g.stop != null && g.hasOwnProperty("stop") && !$util$1.isInteger(g.stop) && !(g.stop && $util$1.isInteger(g.stop.low) && $util$1.isInteger(g.stop.high)) ? "stop: integer|Long expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.RangeIndex) return g;
    let d = new $root$1.RangeIndex();
    return g.start != null && ($util$1.Long ? (d.start = $util$1.Long.fromValue(g.start)).unsigned = !1 : typeof g.start == "string" ? d.start = parseInt(g.start, 10) : typeof g.start == "number" ? d.start = g.start : typeof g.start == "object" && (d.start = new $util$1.LongBits(g.start.low >>> 0, g.start.high >>> 0).toNumber())), g.stop != null && ($util$1.Long ? (d.stop = $util$1.Long.fromValue(g.stop)).unsigned = !1 : typeof g.stop == "string" ? d.stop = parseInt(g.stop, 10) : typeof g.stop == "number" ? d.stop = g.stop : typeof g.stop == "object" && (d.stop = new $util$1.LongBits(g.stop.low >>> 0, g.stop.high >>> 0).toNumber())), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if (d.defaults) {
      if ($util$1.Long) {
        let H = new $util$1.Long(0, 0, !1);
        k.start = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
      } else k.start = d.longs === String ? "0" : 0;
      if ($util$1.Long) {
        let H = new $util$1.Long(0, 0, !1);
        k.stop = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
      } else k.stop = d.longs === String ? "0" : 0;
    }
    return g.start != null && g.hasOwnProperty("start") && (typeof g.start == "number" ? k.start = d.longs === String ? String(g.start) : g.start : k.start = d.longs === String ? $util$1.Long.prototype.toString.call(g.start) : d.longs === Number ? new $util$1.LongBits(g.start.low >>> 0, g.start.high >>> 0).toNumber() : g.start), g.stop != null && g.hasOwnProperty("stop") && (typeof g.stop == "number" ? k.stop = d.longs === String ? String(g.stop) : g.stop : k.stop = d.longs === String ? $util$1.Long.prototype.toString.call(g.stop) : d.longs === Number ? new $util$1.LongBits(g.stop.low >>> 0, g.stop.high >>> 0).toNumber() : g.stop), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/RangeIndex";
  }, n;
})();
$root$1.MultiIndex = (() => {
  function n(t) {
    if (this.levels = [], this.labels = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.levels = $util$1.emptyArray, n.prototype.labels = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.levels != null && g.levels.length) for (let k = 0; k < g.levels.length; ++k) $root$1.Index.encode(g.levels[k], d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (g.labels != null && g.labels.length) for (let k = 0; k < g.labels.length; ++k) $root$1.Int32Array.encode(g.labels[k], d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.MultiIndex();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.levels && AA.levels.length || (AA.levels = []), AA.levels.push($root$1.Index.decode(g, g.uint32()));
          break;
        }
        case 2: {
          AA.labels && AA.labels.length || (AA.labels = []), AA.labels.push($root$1.Int32Array.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.levels != null && g.hasOwnProperty("levels")) {
      if (!Array.isArray(g.levels)) return "levels: array expected";
      for (let d = 0; d < g.levels.length; ++d) {
        let k = $root$1.Index.verify(g.levels[d]);
        if (k) return "levels." + k;
      }
    }
    if (g.labels != null && g.hasOwnProperty("labels")) {
      if (!Array.isArray(g.labels)) return "labels: array expected";
      for (let d = 0; d < g.labels.length; ++d) {
        let k = $root$1.Int32Array.verify(g.labels[d]);
        if (k) return "labels." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.MultiIndex) return g;
    let d = new $root$1.MultiIndex();
    if (g.levels) {
      if (!Array.isArray(g.levels)) throw TypeError(".MultiIndex.levels: array expected");
      d.levels = [];
      for (let k = 0; k < g.levels.length; ++k) {
        if (typeof g.levels[k] != "object") throw TypeError(".MultiIndex.levels: object expected");
        d.levels[k] = $root$1.Index.fromObject(g.levels[k]);
      }
    }
    if (g.labels) {
      if (!Array.isArray(g.labels)) throw TypeError(".MultiIndex.labels: array expected");
      d.labels = [];
      for (let k = 0; k < g.labels.length; ++k) {
        if (typeof g.labels[k] != "object") throw TypeError(".MultiIndex.labels: object expected");
        d.labels[k] = $root$1.Int32Array.fromObject(g.labels[k]);
      }
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.levels = [], k.labels = []), g.levels && g.levels.length) {
      k.levels = [];
      for (let H = 0; H < g.levels.length; ++H) k.levels[H] = $root$1.Index.toObject(g.levels[H], d);
    }
    if (g.labels && g.labels.length) {
      k.labels = [];
      for (let H = 0; H < g.labels.length; ++H) k.labels[H] = $root$1.Int32Array.toObject(g.labels[H], d);
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/MultiIndex";
  }, n;
})();
$root$1.DatetimeIndex = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.StringArray.encode(g.data, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.DatetimeIndex();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.data = $root$1.StringArray.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      let d = $root$1.StringArray.verify(g.data);
      if (d) return "data." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.DatetimeIndex) return g;
    let d = new $root$1.DatetimeIndex();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".DatetimeIndex.data: object expected");
      d.data = $root$1.StringArray.fromObject(g.data);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.data = null), g.data != null && g.hasOwnProperty("data") && (k.data = $root$1.StringArray.toObject(g.data, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DatetimeIndex";
  }, n;
})();
$root$1.TimedeltaIndex = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.Int64Array.encode(g.data, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.TimedeltaIndex();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.data = $root$1.Int64Array.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      let d = $root$1.Int64Array.verify(g.data);
      if (d) return "data." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.TimedeltaIndex) return g;
    let d = new $root$1.TimedeltaIndex();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".TimedeltaIndex.data: object expected");
      d.data = $root$1.Int64Array.fromObject(g.data);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.data = null), g.data != null && g.hasOwnProperty("data") && (k.data = $root$1.Int64Array.toObject(g.data, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TimedeltaIndex";
  }, n;
})();
$root$1.Int64Index = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.Int64Array.encode(g.data, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Int64Index();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.data = $root$1.Int64Array.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      let d = $root$1.Int64Array.verify(g.data);
      if (d) return "data." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Int64Index) return g;
    let d = new $root$1.Int64Index();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".Int64Index.data: object expected");
      d.data = $root$1.Int64Array.fromObject(g.data);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.data = null), g.data != null && g.hasOwnProperty("data") && (k.data = $root$1.Int64Array.toObject(g.data, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Int64Index";
  }, n;
})();
$root$1.Float64Index = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.DoubleArray.encode(g.data, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Float64Index();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.data = $root$1.DoubleArray.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      let d = $root$1.DoubleArray.verify(g.data);
      if (d) return "data." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Float64Index) return g;
    let d = new $root$1.Float64Index();
    if (g.data != null) {
      if (typeof g.data != "object") throw TypeError(".Float64Index.data: object expected");
      d.data = $root$1.DoubleArray.fromObject(g.data);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.data = null), g.data != null && g.hasOwnProperty("data") && (k.data = $root$1.DoubleArray.toObject(g.data, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Float64Index";
  }, n;
})();
$root$1.CSSStyle = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.property = "", n.prototype.value = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.property != null && Object.hasOwnProperty.call(g, "property") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.property), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.value), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.CSSStyle();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.property = g.string();
          break;
        }
        case 2: {
          AA.value = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.property != null && g.hasOwnProperty("property") && !$util$1.isString(g.property) ? "property: string expected" : g.value != null && g.hasOwnProperty("value") && !$util$1.isString(g.value) ? "value: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.CSSStyle) return g;
    let d = new $root$1.CSSStyle();
    return g.property != null && (d.property = String(g.property)), g.value != null && (d.value = String(g.value)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.property = "", k.value = ""), g.property != null && g.hasOwnProperty("property") && (k.property = g.property), g.value != null && g.hasOwnProperty("value") && (k.value = g.value), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/CSSStyle";
  }, n;
})();
$root$1.CellStyle = (() => {
  function n(t) {
    if (this.css = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.css = $util$1.emptyArray, n.prototype.displayValue = "", n.prototype.hasDisplayValue = !1, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.css != null && g.css.length) for (let k = 0; k < g.css.length; ++k) $root$1.CSSStyle.encode(g.css[k], d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g.displayValue != null && Object.hasOwnProperty.call(g, "displayValue") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.displayValue), g.hasDisplayValue != null && Object.hasOwnProperty.call(g, "hasDisplayValue") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.hasDisplayValue), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.CellStyle();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.css && AA.css.length || (AA.css = []), AA.css.push($root$1.CSSStyle.decode(g, g.uint32()));
          break;
        }
        case 2: {
          AA.displayValue = g.string();
          break;
        }
        case 3: {
          AA.hasDisplayValue = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.css != null && g.hasOwnProperty("css")) {
      if (!Array.isArray(g.css)) return "css: array expected";
      for (let d = 0; d < g.css.length; ++d) {
        let k = $root$1.CSSStyle.verify(g.css[d]);
        if (k) return "css." + k;
      }
    }
    return g.displayValue != null && g.hasOwnProperty("displayValue") && !$util$1.isString(g.displayValue) ? "displayValue: string expected" : g.hasDisplayValue != null && g.hasOwnProperty("hasDisplayValue") && typeof g.hasDisplayValue != "boolean" ? "hasDisplayValue: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.CellStyle) return g;
    let d = new $root$1.CellStyle();
    if (g.css) {
      if (!Array.isArray(g.css)) throw TypeError(".CellStyle.css: array expected");
      d.css = [];
      for (let k = 0; k < g.css.length; ++k) {
        if (typeof g.css[k] != "object") throw TypeError(".CellStyle.css: object expected");
        d.css[k] = $root$1.CSSStyle.fromObject(g.css[k]);
      }
    }
    return g.displayValue != null && (d.displayValue = String(g.displayValue)), g.hasDisplayValue != null && (d.hasDisplayValue = !!g.hasDisplayValue), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.css = []), d.defaults && (k.displayValue = "", k.hasDisplayValue = !1), g.css && g.css.length) {
      k.css = [];
      for (let H = 0; H < g.css.length; ++H) k.css[H] = $root$1.CSSStyle.toObject(g.css[H], d);
    }
    return g.displayValue != null && g.hasOwnProperty("displayValue") && (k.displayValue = g.displayValue), g.hasDisplayValue != null && g.hasOwnProperty("hasDisplayValue") && (k.hasDisplayValue = g.hasDisplayValue), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/CellStyle";
  }, n;
})();
$root$1.CellStyleArray = (() => {
  function n(t) {
    if (this.styles = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.styles = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.styles != null && g.styles.length) for (let k = 0; k < g.styles.length; ++k) $root$1.CellStyle.encode(g.styles[k], d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.CellStyleArray();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.styles && AA.styles.length || (AA.styles = []), AA.styles.push($root$1.CellStyle.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.styles != null && g.hasOwnProperty("styles")) {
      if (!Array.isArray(g.styles)) return "styles: array expected";
      for (let d = 0; d < g.styles.length; ++d) {
        let k = $root$1.CellStyle.verify(g.styles[d]);
        if (k) return "styles." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.CellStyleArray) return g;
    let d = new $root$1.CellStyleArray();
    if (g.styles) {
      if (!Array.isArray(g.styles)) throw TypeError(".CellStyleArray.styles: array expected");
      d.styles = [];
      for (let k = 0; k < g.styles.length; ++k) {
        if (typeof g.styles[k] != "object") throw TypeError(".CellStyleArray.styles: object expected");
        d.styles[k] = $root$1.CellStyle.fromObject(g.styles[k]);
      }
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.styles = []), g.styles && g.styles.length) {
      k.styles = [];
      for (let H = 0; H < g.styles.length; ++H) k.styles[H] = $root$1.CellStyle.toObject(g.styles[H], d);
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/CellStyleArray";
  }, n;
})();
$root$1.AnyArray = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.strings = null, n.prototype.doubles = null, n.prototype.int64s = null, n.prototype.datetimes = null, n.prototype.timedeltas = null;
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util$1.oneOfGetter(t = ["strings", "doubles", "int64s", "datetimes", "timedeltas"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.strings != null && Object.hasOwnProperty.call(d, "strings") && $root$1.StringArray.encode(d.strings, k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), d.doubles != null && Object.hasOwnProperty.call(d, "doubles") && $root$1.DoubleArray.encode(d.doubles, k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), d.int64s != null && Object.hasOwnProperty.call(d, "int64s") && $root$1.Int64Array.encode(d.int64s, k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), d.datetimes != null && Object.hasOwnProperty.call(d, "datetimes") && $root$1.StringArray.encode(d.datetimes, k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), d.timedeltas != null && Object.hasOwnProperty.call(d, "timedeltas") && $root$1.Int64Array.encode(d.timedeltas, k.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.AnyArray();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.strings = $root$1.StringArray.decode(d, d.uint32());
          break;
        }
        case 2: {
          gA.doubles = $root$1.DoubleArray.decode(d, d.uint32());
          break;
        }
        case 3: {
          gA.int64s = $root$1.Int64Array.decode(d, d.uint32());
          break;
        }
        case 4: {
          gA.datetimes = $root$1.StringArray.decode(d, d.uint32());
          break;
        }
        case 5: {
          gA.timedeltas = $root$1.Int64Array.decode(d, d.uint32());
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.strings != null && d.hasOwnProperty("strings")) {
      k.type = 1;
      {
        let H = $root$1.StringArray.verify(d.strings);
        if (H) return "strings." + H;
      }
    }
    if (d.doubles != null && d.hasOwnProperty("doubles")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.DoubleArray.verify(d.doubles);
        if (H) return "doubles." + H;
      }
    }
    if (d.int64s != null && d.hasOwnProperty("int64s")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Int64Array.verify(d.int64s);
        if (H) return "int64s." + H;
      }
    }
    if (d.datetimes != null && d.hasOwnProperty("datetimes")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.StringArray.verify(d.datetimes);
        if (H) return "datetimes." + H;
      }
    }
    if (d.timedeltas != null && d.hasOwnProperty("timedeltas")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Int64Array.verify(d.timedeltas);
        if (H) return "timedeltas." + H;
      }
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.AnyArray) return d;
    let k = new $root$1.AnyArray();
    if (d.strings != null) {
      if (typeof d.strings != "object") throw TypeError(".AnyArray.strings: object expected");
      k.strings = $root$1.StringArray.fromObject(d.strings);
    }
    if (d.doubles != null) {
      if (typeof d.doubles != "object") throw TypeError(".AnyArray.doubles: object expected");
      k.doubles = $root$1.DoubleArray.fromObject(d.doubles);
    }
    if (d.int64s != null) {
      if (typeof d.int64s != "object") throw TypeError(".AnyArray.int64s: object expected");
      k.int64s = $root$1.Int64Array.fromObject(d.int64s);
    }
    if (d.datetimes != null) {
      if (typeof d.datetimes != "object") throw TypeError(".AnyArray.datetimes: object expected");
      k.datetimes = $root$1.StringArray.fromObject(d.datetimes);
    }
    if (d.timedeltas != null) {
      if (typeof d.timedeltas != "object") throw TypeError(".AnyArray.timedeltas: object expected");
      k.timedeltas = $root$1.Int64Array.fromObject(d.timedeltas);
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return d.strings != null && d.hasOwnProperty("strings") && (H.strings = $root$1.StringArray.toObject(d.strings, k), k.oneofs && (H.type = "strings")), d.doubles != null && d.hasOwnProperty("doubles") && (H.doubles = $root$1.DoubleArray.toObject(d.doubles, k), k.oneofs && (H.type = "doubles")), d.int64s != null && d.hasOwnProperty("int64s") && (H.int64s = $root$1.Int64Array.toObject(d.int64s, k), k.oneofs && (H.type = "int64s")), d.datetimes != null && d.hasOwnProperty("datetimes") && (H.datetimes = $root$1.StringArray.toObject(d.datetimes, k), k.oneofs && (H.type = "datetimes")), d.timedeltas != null && d.hasOwnProperty("timedeltas") && (H.timedeltas = $root$1.Int64Array.toObject(d.timedeltas, k), k.oneofs && (H.type = "timedeltas")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/AnyArray";
  }, n;
})();
$root$1.Table = (() => {
  function n(t) {
    if (this.cols = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.cols = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.cols != null && g.cols.length) for (let k = 0; k < g.cols.length; ++k) $root$1.AnyArray.encode(g.cols[k], d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Table();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.cols && AA.cols.length || (AA.cols = []), AA.cols.push($root$1.AnyArray.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.cols != null && g.hasOwnProperty("cols")) {
      if (!Array.isArray(g.cols)) return "cols: array expected";
      for (let d = 0; d < g.cols.length; ++d) {
        let k = $root$1.AnyArray.verify(g.cols[d]);
        if (k) return "cols." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Table) return g;
    let d = new $root$1.Table();
    if (g.cols) {
      if (!Array.isArray(g.cols)) throw TypeError(".Table.cols: array expected");
      d.cols = [];
      for (let k = 0; k < g.cols.length; ++k) {
        if (typeof g.cols[k] != "object") throw TypeError(".Table.cols: object expected");
        d.cols[k] = $root$1.AnyArray.fromObject(g.cols[k]);
      }
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.cols = []), g.cols && g.cols.length) {
      k.cols = [];
      for (let H = 0; H < g.cols.length; ++H) k.cols[H] = $root$1.AnyArray.toObject(g.cols[H], d);
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Table";
  }, n;
})();
$root$1.TableStyle = (() => {
  function n(t) {
    if (this.cols = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.cols = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.cols != null && g.cols.length) for (let k = 0; k < g.cols.length; ++k) $root$1.CellStyleArray.encode(g.cols[k], d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.TableStyle();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.cols && AA.cols.length || (AA.cols = []), AA.cols.push($root$1.CellStyleArray.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.cols != null && g.hasOwnProperty("cols")) {
      if (!Array.isArray(g.cols)) return "cols: array expected";
      for (let d = 0; d < g.cols.length; ++d) {
        let k = $root$1.CellStyleArray.verify(g.cols[d]);
        if (k) return "cols." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.TableStyle) return g;
    let d = new $root$1.TableStyle();
    if (g.cols) {
      if (!Array.isArray(g.cols)) throw TypeError(".TableStyle.cols: array expected");
      d.cols = [];
      for (let k = 0; k < g.cols.length; ++k) {
        if (typeof g.cols[k] != "object") throw TypeError(".TableStyle.cols: object expected");
        d.cols[k] = $root$1.CellStyleArray.fromObject(g.cols[k]);
      }
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.cols = []), g.cols && g.cols.length) {
      k.cols = [];
      for (let H = 0; H < g.cols.length; ++H) k.cols[H] = $root$1.CellStyleArray.toObject(g.cols[H], d);
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TableStyle";
  }, n;
})();
$root$1.DateInput = (() => {
  function n(t) {
    if (this.default = [], this.value = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.default = $util$1.emptyArray, n.prototype.min = "", n.prototype.max = "", n.prototype.isRange = !1, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = $util$1.emptyArray, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.format = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && g.default.length) for (let k = 0; k < g.default.length; ++k) d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default[k]);
    if (g.min != null && Object.hasOwnProperty.call(g, "min") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.min), g.max != null && Object.hasOwnProperty.call(g, "max") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.max), g.isRange != null && Object.hasOwnProperty.call(g, "isRange") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.isRange), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.formId), g.value != null && g.value.length) for (let k = 0; k < g.value.length; ++k) d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.value[k]);
    return g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), g.format != null && Object.hasOwnProperty.call(g, "format") && d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.format), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.DateInput();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.default && AA.default.length || (AA.default = []), AA.default.push(g.string());
          break;
        }
        case 4: {
          AA.min = g.string();
          break;
        }
        case 5: {
          AA.max = g.string();
          break;
        }
        case 6: {
          AA.isRange = g.bool();
          break;
        }
        case 7: {
          AA.help = g.string();
          break;
        }
        case 8: {
          AA.formId = g.string();
          break;
        }
        case 9: {
          AA.value && AA.value.length || (AA.value = []), AA.value.push(g.string());
          break;
        }
        case 10: {
          AA.setValue = g.bool();
          break;
        }
        case 11: {
          AA.disabled = g.bool();
          break;
        }
        case 12: {
          AA.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 13: {
          AA.format = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util$1.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util$1.isString(g.label)) return "label: string expected";
    if (g.default != null && g.hasOwnProperty("default")) {
      if (!Array.isArray(g.default)) return "default: array expected";
      for (let d = 0; d < g.default.length; ++d) if (!$util$1.isString(g.default[d])) return "default: string[] expected";
    }
    if (g.min != null && g.hasOwnProperty("min") && !$util$1.isString(g.min)) return "min: string expected";
    if (g.max != null && g.hasOwnProperty("max") && !$util$1.isString(g.max)) return "max: string expected";
    if (g.isRange != null && g.hasOwnProperty("isRange") && typeof g.isRange != "boolean") return "isRange: boolean expected";
    if (g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help)) return "help: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util$1.isString(g.formId)) return "formId: string expected";
    if (g.value != null && g.hasOwnProperty("value")) {
      if (!Array.isArray(g.value)) return "value: array expected";
      for (let d = 0; d < g.value.length; ++d) if (!$util$1.isString(g.value[d])) return "value: string[] expected";
    }
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root$1.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    return g.format != null && g.hasOwnProperty("format") && !$util$1.isString(g.format) ? "format: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.DateInput) return g;
    let d = new $root$1.DateInput();
    if (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.default) {
      if (!Array.isArray(g.default)) throw TypeError(".DateInput.default: array expected");
      d.default = [];
      for (let k = 0; k < g.default.length; ++k) d.default[k] = String(g.default[k]);
    }
    if (g.min != null && (d.min = String(g.min)), g.max != null && (d.max = String(g.max)), g.isRange != null && (d.isRange = !!g.isRange), g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.value) {
      if (!Array.isArray(g.value)) throw TypeError(".DateInput.value: array expected");
      d.value = [];
      for (let k = 0; k < g.value.length; ++k) d.value[k] = String(g.value[k]);
    }
    if (g.setValue != null && (d.setValue = !!g.setValue), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".DateInput.labelVisibility: object expected");
      d.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.format != null && (d.format = String(g.format)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.default = [], k.value = []), d.defaults && (k.id = "", k.label = "", k.min = "", k.max = "", k.isRange = !1, k.help = "", k.formId = "", k.setValue = !1, k.disabled = !1, k.labelVisibility = null, k.format = ""), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.default && g.default.length) {
      k.default = [];
      for (let H = 0; H < g.default.length; ++H) k.default[H] = g.default[H];
    }
    if (g.min != null && g.hasOwnProperty("min") && (k.min = g.min), g.max != null && g.hasOwnProperty("max") && (k.max = g.max), g.isRange != null && g.hasOwnProperty("isRange") && (k.isRange = g.isRange), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.value && g.value.length) {
      k.value = [];
      for (let H = 0; H < g.value.length; ++H) k.value[H] = g.value[H];
    }
    return g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.format != null && g.hasOwnProperty("format") && (k.format = g.format), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DateInput";
  }, n;
})();
const DeckGlJsonChart$1 = $root$1.DeckGlJsonChart = (() => {
  function n(t) {
    if (this.selectionMode = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.json = "", n.prototype.tooltip = "", n.prototype.useContainerWidth = !1, n.prototype.id = "", n.prototype.mapboxToken = "", n.prototype.width = 0, n.prototype.height = 0, n.prototype.selectionMode = $util$1.emptyArray, n.prototype.formId = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.json != null && Object.hasOwnProperty.call(g, "json") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.json), g.tooltip != null && Object.hasOwnProperty.call(g, "tooltip") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.tooltip), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.useContainerWidth), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.id), g.mapboxToken != null && Object.hasOwnProperty.call(g, "mapboxToken") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.mapboxToken), g.width != null && Object.hasOwnProperty.call(g, "width") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).uint32(g.width), g.height != null && Object.hasOwnProperty.call(g, "height") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).uint32(g.height), g.selectionMode != null && g.selectionMode.length) {
      d.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let k = 0; k < g.selectionMode.length; ++k) d.int32(g.selectionMode[k]);
      d.ldelim();
    }
    return g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.formId), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.DeckGlJsonChart();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.json = g.string();
          break;
        }
        case 2: {
          AA.tooltip = g.string();
          break;
        }
        case 4: {
          AA.useContainerWidth = g.bool();
          break;
        }
        case 5: {
          AA.id = g.string();
          break;
        }
        case 6: {
          AA.mapboxToken = g.string();
          break;
        }
        case 7: {
          AA.width = g.uint32();
          break;
        }
        case 8: {
          AA.height = g.uint32();
          break;
        }
        case 9: {
          if (AA.selectionMode && AA.selectionMode.length || (AA.selectionMode = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.selectionMode.push(g.int32());
          } else AA.selectionMode.push(g.int32());
          break;
        }
        case 10: {
          AA.formId = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.json != null && g.hasOwnProperty("json") && !$util$1.isString(g.json)) return "json: string expected";
    if (g.tooltip != null && g.hasOwnProperty("tooltip") && !$util$1.isString(g.tooltip)) return "tooltip: string expected";
    if (g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && typeof g.useContainerWidth != "boolean") return "useContainerWidth: boolean expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util$1.isString(g.id)) return "id: string expected";
    if (g.mapboxToken != null && g.hasOwnProperty("mapboxToken") && !$util$1.isString(g.mapboxToken)) return "mapboxToken: string expected";
    if (g.width != null && g.hasOwnProperty("width") && !$util$1.isInteger(g.width)) return "width: integer expected";
    if (g.height != null && g.hasOwnProperty("height") && !$util$1.isInteger(g.height)) return "height: integer expected";
    if (g.selectionMode != null && g.hasOwnProperty("selectionMode")) {
      if (!Array.isArray(g.selectionMode)) return "selectionMode: array expected";
      for (let d = 0; d < g.selectionMode.length; ++d) switch (g.selectionMode[d]) {
        default:
          return "selectionMode: enum value[] expected";
        case 0:
        case 1:
          break;
      }
    }
    return g.formId != null && g.hasOwnProperty("formId") && !$util$1.isString(g.formId) ? "formId: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.DeckGlJsonChart) return g;
    let d = new $root$1.DeckGlJsonChart();
    if (g.json != null && (d.json = String(g.json)), g.tooltip != null && (d.tooltip = String(g.tooltip)), g.useContainerWidth != null && (d.useContainerWidth = !!g.useContainerWidth), g.id != null && (d.id = String(g.id)), g.mapboxToken != null && (d.mapboxToken = String(g.mapboxToken)), g.width != null && (d.width = g.width >>> 0), g.height != null && (d.height = g.height >>> 0), g.selectionMode) {
      if (!Array.isArray(g.selectionMode)) throw TypeError(".DeckGlJsonChart.selectionMode: array expected");
      d.selectionMode = [];
      for (let k = 0; k < g.selectionMode.length; ++k) switch (g.selectionMode[k]) {
        default:
          if (typeof g.selectionMode[k] == "number") {
            d.selectionMode[k] = g.selectionMode[k];
            break;
          }
        case "SINGLE_OBJECT":
        case 0:
          d.selectionMode[k] = 0;
          break;
        case "MULTI_OBJECT":
        case 1:
          d.selectionMode[k] = 1;
          break;
      }
    }
    return g.formId != null && (d.formId = String(g.formId)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.selectionMode = []), d.defaults && (k.json = "", k.tooltip = "", k.useContainerWidth = !1, k.id = "", k.mapboxToken = "", k.width = 0, k.height = 0, k.formId = ""), g.json != null && g.hasOwnProperty("json") && (k.json = g.json), g.tooltip != null && g.hasOwnProperty("tooltip") && (k.tooltip = g.tooltip), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (k.useContainerWidth = g.useContainerWidth), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.mapboxToken != null && g.hasOwnProperty("mapboxToken") && (k.mapboxToken = g.mapboxToken), g.width != null && g.hasOwnProperty("width") && (k.width = g.width), g.height != null && g.hasOwnProperty("height") && (k.height = g.height), g.selectionMode && g.selectionMode.length) {
      k.selectionMode = [];
      for (let H = 0; H < g.selectionMode.length; ++H) k.selectionMode[H] = d.enums === String ? $root$1.DeckGlJsonChart.SelectionMode[g.selectionMode[H]] === void 0 ? g.selectionMode[H] : $root$1.DeckGlJsonChart.SelectionMode[g.selectionMode[H]] : g.selectionMode[H];
    }
    return g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DeckGlJsonChart";
  }, n.SelectionMode = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "SINGLE_OBJECT"] = 0, g[t[1] = "MULTI_OBJECT"] = 1, g;
  })(), n;
})();
$root$1.Delta = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.newElement = null, n.prototype.addBlock = null, n.prototype.addRows = null, n.prototype.arrowAddRows = null, n.prototype.fragmentId = "";
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util$1.oneOfGetter(t = ["newElement", "addBlock", "addRows", "arrowAddRows"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.newElement != null && Object.hasOwnProperty.call(d, "newElement") && $root$1.Element.encode(d.newElement, k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), d.addRows != null && Object.hasOwnProperty.call(d, "addRows") && $root$1.NamedDataSet.encode(d.addRows, k.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), d.addBlock != null && Object.hasOwnProperty.call(d, "addBlock") && $root$1.Block.encode(d.addBlock, k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), d.arrowAddRows != null && Object.hasOwnProperty.call(d, "arrowAddRows") && $root$1.ArrowNamedDataSet.encode(d.arrowAddRows, k.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), d.fragmentId != null && Object.hasOwnProperty.call(d, "fragmentId") && k.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(d.fragmentId), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Delta();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 3: {
          gA.newElement = $root$1.Element.decode(d, d.uint32());
          break;
        }
        case 6: {
          gA.addBlock = $root$1.Block.decode(d, d.uint32());
          break;
        }
        case 5: {
          gA.addRows = $root$1.NamedDataSet.decode(d, d.uint32());
          break;
        }
        case 7: {
          gA.arrowAddRows = $root$1.ArrowNamedDataSet.decode(d, d.uint32());
          break;
        }
        case 8: {
          gA.fragmentId = d.string();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.newElement != null && d.hasOwnProperty("newElement")) {
      k.type = 1;
      {
        let H = $root$1.Element.verify(d.newElement);
        if (H) return "newElement." + H;
      }
    }
    if (d.addBlock != null && d.hasOwnProperty("addBlock")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Block.verify(d.addBlock);
        if (H) return "addBlock." + H;
      }
    }
    if (d.addRows != null && d.hasOwnProperty("addRows")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.NamedDataSet.verify(d.addRows);
        if (H) return "addRows." + H;
      }
    }
    if (d.arrowAddRows != null && d.hasOwnProperty("arrowAddRows")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.ArrowNamedDataSet.verify(d.arrowAddRows);
        if (H) return "arrowAddRows." + H;
      }
    }
    return d.fragmentId != null && d.hasOwnProperty("fragmentId") && !$util$1.isString(d.fragmentId) ? "fragmentId: string expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Delta) return d;
    let k = new $root$1.Delta();
    if (d.newElement != null) {
      if (typeof d.newElement != "object") throw TypeError(".Delta.newElement: object expected");
      k.newElement = $root$1.Element.fromObject(d.newElement);
    }
    if (d.addBlock != null) {
      if (typeof d.addBlock != "object") throw TypeError(".Delta.addBlock: object expected");
      k.addBlock = $root$1.Block.fromObject(d.addBlock);
    }
    if (d.addRows != null) {
      if (typeof d.addRows != "object") throw TypeError(".Delta.addRows: object expected");
      k.addRows = $root$1.NamedDataSet.fromObject(d.addRows);
    }
    if (d.arrowAddRows != null) {
      if (typeof d.arrowAddRows != "object") throw TypeError(".Delta.arrowAddRows: object expected");
      k.arrowAddRows = $root$1.ArrowNamedDataSet.fromObject(d.arrowAddRows);
    }
    return d.fragmentId != null && (k.fragmentId = String(d.fragmentId)), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.fragmentId = ""), d.newElement != null && d.hasOwnProperty("newElement") && (H.newElement = $root$1.Element.toObject(d.newElement, k), k.oneofs && (H.type = "newElement")), d.addRows != null && d.hasOwnProperty("addRows") && (H.addRows = $root$1.NamedDataSet.toObject(d.addRows, k), k.oneofs && (H.type = "addRows")), d.addBlock != null && d.hasOwnProperty("addBlock") && (H.addBlock = $root$1.Block.toObject(d.addBlock, k), k.oneofs && (H.type = "addBlock")), d.arrowAddRows != null && d.hasOwnProperty("arrowAddRows") && (H.arrowAddRows = $root$1.ArrowNamedDataSet.toObject(d.arrowAddRows, k), k.oneofs && (H.type = "arrowAddRows")), d.fragmentId != null && d.hasOwnProperty("fragmentId") && (H.fragmentId = d.fragmentId), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Delta";
  }, n;
})();
const Element$1 = $root$1.Element = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.heightConfig = null, n.prototype.widthConfig = null, n.prototype.alert = null, n.prototype.arrowDataFrame = null, n.prototype.arrowTable = null, n.prototype.arrowVegaLiteChart = null, n.prototype.audio = null, n.prototype.audioInput = null, n.prototype.balloons = null, n.prototype.bokehChart = null, n.prototype.button = null, n.prototype.buttonGroup = null, n.prototype.downloadButton = null, n.prototype.cameraInput = null, n.prototype.chatInput = null, n.prototype.checkbox = null, n.prototype.colorPicker = null, n.prototype.componentInstance = null, n.prototype.dataFrame = null, n.prototype.table = null, n.prototype.dateInput = null, n.prototype.deckGlJsonChart = null, n.prototype.docString = null, n.prototype.empty = null, n.prototype.exception = null, n.prototype.favicon = null, n.prototype.fileUploader = null, n.prototype.graphvizChart = null, n.prototype.html = null, n.prototype.iframe = null, n.prototype.imgs = null, n.prototype.json = null, n.prototype.linkButton = null, n.prototype.markdown = null, n.prototype.metric = null, n.prototype.multiselect = null, n.prototype.numberInput = null, n.prototype.pageLink = null, n.prototype.plotlyChart = null, n.prototype.progress = null, n.prototype.radio = null, n.prototype.selectbox = null, n.prototype.skeleton = null, n.prototype.slider = null, n.prototype.snow = null, n.prototype.spinner = null, n.prototype.text = null, n.prototype.textArea = null, n.prototype.textInput = null, n.prototype.timeInput = null, n.prototype.toast = null, n.prototype.vegaLiteChart = null, n.prototype.video = null, n.prototype.heading = null, n.prototype.code = null;
  let t;
  return Object.defineProperty(n.prototype, "_heightConfig", { get: $util$1.oneOfGetter(t = ["heightConfig"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_widthConfig", { get: $util$1.oneOfGetter(t = ["widthConfig"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "type", { get: $util$1.oneOfGetter(t = ["alert", "arrowDataFrame", "arrowTable", "arrowVegaLiteChart", "audio", "audioInput", "balloons", "bokehChart", "button", "buttonGroup", "downloadButton", "cameraInput", "chatInput", "checkbox", "colorPicker", "componentInstance", "dataFrame", "table", "dateInput", "deckGlJsonChart", "docString", "empty", "exception", "favicon", "fileUploader", "graphvizChart", "html", "iframe", "imgs", "json", "linkButton", "markdown", "metric", "multiselect", "numberInput", "pageLink", "plotlyChart", "progress", "radio", "selectbox", "skeleton", "slider", "snow", "spinner", "text", "textArea", "textInput", "timeInput", "toast", "vegaLiteChart", "video", "heading", "code"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.text != null && Object.hasOwnProperty.call(d, "text") && $root$1.Text.encode(d.text, k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), d.empty != null && Object.hasOwnProperty.call(d, "empty") && $root$1.Empty.encode(d.empty, k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), d.dataFrame != null && Object.hasOwnProperty.call(d, "dataFrame") && $root$1.DataFrame.encode(d.dataFrame, k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), d.progress != null && Object.hasOwnProperty.call(d, "progress") && $root$1.Progress.encode(d.progress, k.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), d.imgs != null && Object.hasOwnProperty.call(d, "imgs") && $root$1.ImageList.encode(d.imgs, k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), d.docString != null && Object.hasOwnProperty.call(d, "docString") && $root$1.DocString.encode(d.docString, k.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), d.exception != null && Object.hasOwnProperty.call(d, "exception") && $root$1.Exception.encode(d.exception, k.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), d.vegaLiteChart != null && Object.hasOwnProperty.call(d, "vegaLiteChart") && $root$1.VegaLiteChart.encode(d.vegaLiteChart, k.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), d.table != null && Object.hasOwnProperty.call(d, "table") && $root$1.DataFrame.encode(d.table, k.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), d.balloons != null && Object.hasOwnProperty.call(d, "balloons") && $root$1.Balloons.encode(d.balloons, k.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), d.audio != null && Object.hasOwnProperty.call(d, "audio") && $root$1.Audio.encode(d.audio, k.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), d.video != null && Object.hasOwnProperty.call(d, "video") && $root$1.Video.encode(d.video, k.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), d.plotlyChart != null && Object.hasOwnProperty.call(d, "plotlyChart") && $root$1.PlotlyChart.encode(d.plotlyChart, k.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), d.bokehChart != null && Object.hasOwnProperty.call(d, "bokehChart") && $root$1.BokehChart.encode(d.bokehChart, k.uint32(
      /* id 17, wireType 2 =*/
      138
    ).fork()).ldelim(), d.graphvizChart != null && Object.hasOwnProperty.call(d, "graphvizChart") && $root$1.GraphVizChart.encode(d.graphvizChart, k.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), d.button != null && Object.hasOwnProperty.call(d, "button") && $root$1.Button.encode(d.button, k.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), d.checkbox != null && Object.hasOwnProperty.call(d, "checkbox") && $root$1.Checkbox.encode(d.checkbox, k.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), d.slider != null && Object.hasOwnProperty.call(d, "slider") && $root$1.Slider.encode(d.slider, k.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), d.textArea != null && Object.hasOwnProperty.call(d, "textArea") && $root$1.TextArea.encode(d.textArea, k.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), d.radio != null && Object.hasOwnProperty.call(d, "radio") && $root$1.Radio.encode(d.radio, k.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), d.textInput != null && Object.hasOwnProperty.call(d, "textInput") && $root$1.TextInput.encode(d.textInput, k.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), d.selectbox != null && Object.hasOwnProperty.call(d, "selectbox") && $root$1.Selectbox.encode(d.selectbox, k.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), d.timeInput != null && Object.hasOwnProperty.call(d, "timeInput") && $root$1.TimeInput.encode(d.timeInput, k.uint32(
      /* id 26, wireType 2 =*/
      210
    ).fork()).ldelim(), d.dateInput != null && Object.hasOwnProperty.call(d, "dateInput") && $root$1.DateInput.encode(d.dateInput, k.uint32(
      /* id 27, wireType 2 =*/
      218
    ).fork()).ldelim(), d.multiselect != null && Object.hasOwnProperty.call(d, "multiselect") && $root$1.MultiSelect.encode(d.multiselect, k.uint32(
      /* id 28, wireType 2 =*/
      226
    ).fork()).ldelim(), d.markdown != null && Object.hasOwnProperty.call(d, "markdown") && $root$1.Markdown.encode(d.markdown, k.uint32(
      /* id 29, wireType 2 =*/
      234
    ).fork()).ldelim(), d.alert != null && Object.hasOwnProperty.call(d, "alert") && $root$1.Alert.encode(d.alert, k.uint32(
      /* id 30, wireType 2 =*/
      242
    ).fork()).ldelim(), d.json != null && Object.hasOwnProperty.call(d, "json") && $root$1.Json.encode(d.json, k.uint32(
      /* id 31, wireType 2 =*/
      250
    ).fork()).ldelim(), d.numberInput != null && Object.hasOwnProperty.call(d, "numberInput") && $root$1.NumberInput.encode(d.numberInput, k.uint32(
      /* id 32, wireType 2 =*/
      258
    ).fork()).ldelim(), d.fileUploader != null && Object.hasOwnProperty.call(d, "fileUploader") && $root$1.FileUploader.encode(d.fileUploader, k.uint32(
      /* id 33, wireType 2 =*/
      266
    ).fork()).ldelim(), d.deckGlJsonChart != null && Object.hasOwnProperty.call(d, "deckGlJsonChart") && $root$1.DeckGlJsonChart.encode(d.deckGlJsonChart, k.uint32(
      /* id 34, wireType 2 =*/
      274
    ).fork()).ldelim(), d.colorPicker != null && Object.hasOwnProperty.call(d, "colorPicker") && $root$1.ColorPicker.encode(d.colorPicker, k.uint32(
      /* id 35, wireType 2 =*/
      282
    ).fork()).ldelim(), d.favicon != null && Object.hasOwnProperty.call(d, "favicon") && $root$1.Favicon.encode(d.favicon, k.uint32(
      /* id 36, wireType 2 =*/
      290
    ).fork()).ldelim(), d.componentInstance != null && Object.hasOwnProperty.call(d, "componentInstance") && $root$1.ComponentInstance.encode(d.componentInstance, k.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim(), d.iframe != null && Object.hasOwnProperty.call(d, "iframe") && $root$1.IFrame.encode(d.iframe, k.uint32(
      /* id 38, wireType 2 =*/
      306
    ).fork()).ldelim(), d.arrowTable != null && Object.hasOwnProperty.call(d, "arrowTable") && $root$1.Arrow.encode(d.arrowTable, k.uint32(
      /* id 39, wireType 2 =*/
      314
    ).fork()).ldelim(), d.arrowDataFrame != null && Object.hasOwnProperty.call(d, "arrowDataFrame") && $root$1.Arrow.encode(d.arrowDataFrame, k.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), d.arrowVegaLiteChart != null && Object.hasOwnProperty.call(d, "arrowVegaLiteChart") && $root$1.ArrowVegaLiteChart.encode(d.arrowVegaLiteChart, k.uint32(
      /* id 41, wireType 2 =*/
      330
    ).fork()).ldelim(), d.metric != null && Object.hasOwnProperty.call(d, "metric") && $root$1.Metric.encode(d.metric, k.uint32(
      /* id 42, wireType 2 =*/
      338
    ).fork()).ldelim(), d.downloadButton != null && Object.hasOwnProperty.call(d, "downloadButton") && $root$1.DownloadButton.encode(d.downloadButton, k.uint32(
      /* id 43, wireType 2 =*/
      346
    ).fork()).ldelim(), d.spinner != null && Object.hasOwnProperty.call(d, "spinner") && $root$1.Spinner.encode(d.spinner, k.uint32(
      /* id 44, wireType 2 =*/
      354
    ).fork()).ldelim(), d.cameraInput != null && Object.hasOwnProperty.call(d, "cameraInput") && $root$1.CameraInput.encode(d.cameraInput, k.uint32(
      /* id 45, wireType 2 =*/
      362
    ).fork()).ldelim(), d.snow != null && Object.hasOwnProperty.call(d, "snow") && $root$1.Snow.encode(d.snow, k.uint32(
      /* id 46, wireType 2 =*/
      370
    ).fork()).ldelim(), d.heading != null && Object.hasOwnProperty.call(d, "heading") && $root$1.Heading.encode(d.heading, k.uint32(
      /* id 47, wireType 2 =*/
      378
    ).fork()).ldelim(), d.code != null && Object.hasOwnProperty.call(d, "code") && $root$1.Code.encode(d.code, k.uint32(
      /* id 48, wireType 2 =*/
      386
    ).fork()).ldelim(), d.chatInput != null && Object.hasOwnProperty.call(d, "chatInput") && $root$1.ChatInput.encode(d.chatInput, k.uint32(
      /* id 49, wireType 2 =*/
      394
    ).fork()).ldelim(), d.toast != null && Object.hasOwnProperty.call(d, "toast") && $root$1.Toast.encode(d.toast, k.uint32(
      /* id 50, wireType 2 =*/
      402
    ).fork()).ldelim(), d.linkButton != null && Object.hasOwnProperty.call(d, "linkButton") && $root$1.LinkButton.encode(d.linkButton, k.uint32(
      /* id 51, wireType 2 =*/
      410
    ).fork()).ldelim(), d.skeleton != null && Object.hasOwnProperty.call(d, "skeleton") && $root$1.Skeleton.encode(d.skeleton, k.uint32(
      /* id 52, wireType 2 =*/
      418
    ).fork()).ldelim(), d.pageLink != null && Object.hasOwnProperty.call(d, "pageLink") && $root$1.PageLink.encode(d.pageLink, k.uint32(
      /* id 53, wireType 2 =*/
      426
    ).fork()).ldelim(), d.html != null && Object.hasOwnProperty.call(d, "html") && $root$1.Html.encode(d.html, k.uint32(
      /* id 54, wireType 2 =*/
      434
    ).fork()).ldelim(), d.buttonGroup != null && Object.hasOwnProperty.call(d, "buttonGroup") && $root$1.ButtonGroup.encode(d.buttonGroup, k.uint32(
      /* id 55, wireType 2 =*/
      442
    ).fork()).ldelim(), d.audioInput != null && Object.hasOwnProperty.call(d, "audioInput") && $root$1.AudioInput.encode(d.audioInput, k.uint32(
      /* id 56, wireType 2 =*/
      450
    ).fork()).ldelim(), d.heightConfig != null && Object.hasOwnProperty.call(d, "heightConfig") && $root$1.streamlit.HeightConfig.encode(d.heightConfig, k.uint32(
      /* id 57, wireType 2 =*/
      458
    ).fork()).ldelim(), d.widthConfig != null && Object.hasOwnProperty.call(d, "widthConfig") && $root$1.streamlit.WidthConfig.encode(d.widthConfig, k.uint32(
      /* id 58, wireType 2 =*/
      466
    ).fork()).ldelim(), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Element();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 57: {
          gA.heightConfig = $root$1.streamlit.HeightConfig.decode(d, d.uint32());
          break;
        }
        case 58: {
          gA.widthConfig = $root$1.streamlit.WidthConfig.decode(d, d.uint32());
          break;
        }
        case 30: {
          gA.alert = $root$1.Alert.decode(d, d.uint32());
          break;
        }
        case 40: {
          gA.arrowDataFrame = $root$1.Arrow.decode(d, d.uint32());
          break;
        }
        case 39: {
          gA.arrowTable = $root$1.Arrow.decode(d, d.uint32());
          break;
        }
        case 41: {
          gA.arrowVegaLiteChart = $root$1.ArrowVegaLiteChart.decode(d, d.uint32());
          break;
        }
        case 13: {
          gA.audio = $root$1.Audio.decode(d, d.uint32());
          break;
        }
        case 56: {
          gA.audioInput = $root$1.AudioInput.decode(d, d.uint32());
          break;
        }
        case 12: {
          gA.balloons = $root$1.Balloons.decode(d, d.uint32());
          break;
        }
        case 17: {
          gA.bokehChart = $root$1.BokehChart.decode(d, d.uint32());
          break;
        }
        case 19: {
          gA.button = $root$1.Button.decode(d, d.uint32());
          break;
        }
        case 55: {
          gA.buttonGroup = $root$1.ButtonGroup.decode(d, d.uint32());
          break;
        }
        case 43: {
          gA.downloadButton = $root$1.DownloadButton.decode(d, d.uint32());
          break;
        }
        case 45: {
          gA.cameraInput = $root$1.CameraInput.decode(d, d.uint32());
          break;
        }
        case 49: {
          gA.chatInput = $root$1.ChatInput.decode(d, d.uint32());
          break;
        }
        case 20: {
          gA.checkbox = $root$1.Checkbox.decode(d, d.uint32());
          break;
        }
        case 35: {
          gA.colorPicker = $root$1.ColorPicker.decode(d, d.uint32());
          break;
        }
        case 37: {
          gA.componentInstance = $root$1.ComponentInstance.decode(d, d.uint32());
          break;
        }
        case 3: {
          gA.dataFrame = $root$1.DataFrame.decode(d, d.uint32());
          break;
        }
        case 11: {
          gA.table = $root$1.DataFrame.decode(d, d.uint32());
          break;
        }
        case 27: {
          gA.dateInput = $root$1.DateInput.decode(d, d.uint32());
          break;
        }
        case 34: {
          gA.deckGlJsonChart = $root$1.DeckGlJsonChart.decode(d, d.uint32());
          break;
        }
        case 7: {
          gA.docString = $root$1.DocString.decode(d, d.uint32());
          break;
        }
        case 2: {
          gA.empty = $root$1.Empty.decode(d, d.uint32());
          break;
        }
        case 8: {
          gA.exception = $root$1.Exception.decode(d, d.uint32());
          break;
        }
        case 36: {
          gA.favicon = $root$1.Favicon.decode(d, d.uint32());
          break;
        }
        case 33: {
          gA.fileUploader = $root$1.FileUploader.decode(d, d.uint32());
          break;
        }
        case 18: {
          gA.graphvizChart = $root$1.GraphVizChart.decode(d, d.uint32());
          break;
        }
        case 54: {
          gA.html = $root$1.Html.decode(d, d.uint32());
          break;
        }
        case 38: {
          gA.iframe = $root$1.IFrame.decode(d, d.uint32());
          break;
        }
        case 6: {
          gA.imgs = $root$1.ImageList.decode(d, d.uint32());
          break;
        }
        case 31: {
          gA.json = $root$1.Json.decode(d, d.uint32());
          break;
        }
        case 51: {
          gA.linkButton = $root$1.LinkButton.decode(d, d.uint32());
          break;
        }
        case 29: {
          gA.markdown = $root$1.Markdown.decode(d, d.uint32());
          break;
        }
        case 42: {
          gA.metric = $root$1.Metric.decode(d, d.uint32());
          break;
        }
        case 28: {
          gA.multiselect = $root$1.MultiSelect.decode(d, d.uint32());
          break;
        }
        case 32: {
          gA.numberInput = $root$1.NumberInput.decode(d, d.uint32());
          break;
        }
        case 53: {
          gA.pageLink = $root$1.PageLink.decode(d, d.uint32());
          break;
        }
        case 16: {
          gA.plotlyChart = $root$1.PlotlyChart.decode(d, d.uint32());
          break;
        }
        case 5: {
          gA.progress = $root$1.Progress.decode(d, d.uint32());
          break;
        }
        case 23: {
          gA.radio = $root$1.Radio.decode(d, d.uint32());
          break;
        }
        case 25: {
          gA.selectbox = $root$1.Selectbox.decode(d, d.uint32());
          break;
        }
        case 52: {
          gA.skeleton = $root$1.Skeleton.decode(d, d.uint32());
          break;
        }
        case 21: {
          gA.slider = $root$1.Slider.decode(d, d.uint32());
          break;
        }
        case 46: {
          gA.snow = $root$1.Snow.decode(d, d.uint32());
          break;
        }
        case 44: {
          gA.spinner = $root$1.Spinner.decode(d, d.uint32());
          break;
        }
        case 1: {
          gA.text = $root$1.Text.decode(d, d.uint32());
          break;
        }
        case 22: {
          gA.textArea = $root$1.TextArea.decode(d, d.uint32());
          break;
        }
        case 24: {
          gA.textInput = $root$1.TextInput.decode(d, d.uint32());
          break;
        }
        case 26: {
          gA.timeInput = $root$1.TimeInput.decode(d, d.uint32());
          break;
        }
        case 50: {
          gA.toast = $root$1.Toast.decode(d, d.uint32());
          break;
        }
        case 10: {
          gA.vegaLiteChart = $root$1.VegaLiteChart.decode(d, d.uint32());
          break;
        }
        case 14: {
          gA.video = $root$1.Video.decode(d, d.uint32());
          break;
        }
        case 47: {
          gA.heading = $root$1.Heading.decode(d, d.uint32());
          break;
        }
        case 48: {
          gA.code = $root$1.Code.decode(d, d.uint32());
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.heightConfig != null && d.hasOwnProperty("heightConfig")) {
      k._heightConfig = 1;
      {
        let H = $root$1.streamlit.HeightConfig.verify(d.heightConfig);
        if (H) return "heightConfig." + H;
      }
    }
    if (d.widthConfig != null && d.hasOwnProperty("widthConfig")) {
      k._widthConfig = 1;
      {
        let H = $root$1.streamlit.WidthConfig.verify(d.widthConfig);
        if (H) return "widthConfig." + H;
      }
    }
    if (d.alert != null && d.hasOwnProperty("alert")) {
      k.type = 1;
      {
        let H = $root$1.Alert.verify(d.alert);
        if (H) return "alert." + H;
      }
    }
    if (d.arrowDataFrame != null && d.hasOwnProperty("arrowDataFrame")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Arrow.verify(d.arrowDataFrame);
        if (H) return "arrowDataFrame." + H;
      }
    }
    if (d.arrowTable != null && d.hasOwnProperty("arrowTable")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Arrow.verify(d.arrowTable);
        if (H) return "arrowTable." + H;
      }
    }
    if (d.arrowVegaLiteChart != null && d.hasOwnProperty("arrowVegaLiteChart")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.ArrowVegaLiteChart.verify(d.arrowVegaLiteChart);
        if (H) return "arrowVegaLiteChart." + H;
      }
    }
    if (d.audio != null && d.hasOwnProperty("audio")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Audio.verify(d.audio);
        if (H) return "audio." + H;
      }
    }
    if (d.audioInput != null && d.hasOwnProperty("audioInput")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.AudioInput.verify(d.audioInput);
        if (H) return "audioInput." + H;
      }
    }
    if (d.balloons != null && d.hasOwnProperty("balloons")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Balloons.verify(d.balloons);
        if (H) return "balloons." + H;
      }
    }
    if (d.bokehChart != null && d.hasOwnProperty("bokehChart")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.BokehChart.verify(d.bokehChart);
        if (H) return "bokehChart." + H;
      }
    }
    if (d.button != null && d.hasOwnProperty("button")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Button.verify(d.button);
        if (H) return "button." + H;
      }
    }
    if (d.buttonGroup != null && d.hasOwnProperty("buttonGroup")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.ButtonGroup.verify(d.buttonGroup);
        if (H) return "buttonGroup." + H;
      }
    }
    if (d.downloadButton != null && d.hasOwnProperty("downloadButton")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.DownloadButton.verify(d.downloadButton);
        if (H) return "downloadButton." + H;
      }
    }
    if (d.cameraInput != null && d.hasOwnProperty("cameraInput")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.CameraInput.verify(d.cameraInput);
        if (H) return "cameraInput." + H;
      }
    }
    if (d.chatInput != null && d.hasOwnProperty("chatInput")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.ChatInput.verify(d.chatInput);
        if (H) return "chatInput." + H;
      }
    }
    if (d.checkbox != null && d.hasOwnProperty("checkbox")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Checkbox.verify(d.checkbox);
        if (H) return "checkbox." + H;
      }
    }
    if (d.colorPicker != null && d.hasOwnProperty("colorPicker")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.ColorPicker.verify(d.colorPicker);
        if (H) return "colorPicker." + H;
      }
    }
    if (d.componentInstance != null && d.hasOwnProperty("componentInstance")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.ComponentInstance.verify(d.componentInstance);
        if (H) return "componentInstance." + H;
      }
    }
    if (d.dataFrame != null && d.hasOwnProperty("dataFrame")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.DataFrame.verify(d.dataFrame);
        if (H) return "dataFrame." + H;
      }
    }
    if (d.table != null && d.hasOwnProperty("table")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.DataFrame.verify(d.table);
        if (H) return "table." + H;
      }
    }
    if (d.dateInput != null && d.hasOwnProperty("dateInput")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.DateInput.verify(d.dateInput);
        if (H) return "dateInput." + H;
      }
    }
    if (d.deckGlJsonChart != null && d.hasOwnProperty("deckGlJsonChart")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.DeckGlJsonChart.verify(d.deckGlJsonChart);
        if (H) return "deckGlJsonChart." + H;
      }
    }
    if (d.docString != null && d.hasOwnProperty("docString")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.DocString.verify(d.docString);
        if (H) return "docString." + H;
      }
    }
    if (d.empty != null && d.hasOwnProperty("empty")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Empty.verify(d.empty);
        if (H) return "empty." + H;
      }
    }
    if (d.exception != null && d.hasOwnProperty("exception")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Exception.verify(d.exception);
        if (H) return "exception." + H;
      }
    }
    if (d.favicon != null && d.hasOwnProperty("favicon")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Favicon.verify(d.favicon);
        if (H) return "favicon." + H;
      }
    }
    if (d.fileUploader != null && d.hasOwnProperty("fileUploader")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.FileUploader.verify(d.fileUploader);
        if (H) return "fileUploader." + H;
      }
    }
    if (d.graphvizChart != null && d.hasOwnProperty("graphvizChart")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.GraphVizChart.verify(d.graphvizChart);
        if (H) return "graphvizChart." + H;
      }
    }
    if (d.html != null && d.hasOwnProperty("html")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Html.verify(d.html);
        if (H) return "html." + H;
      }
    }
    if (d.iframe != null && d.hasOwnProperty("iframe")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.IFrame.verify(d.iframe);
        if (H) return "iframe." + H;
      }
    }
    if (d.imgs != null && d.hasOwnProperty("imgs")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.ImageList.verify(d.imgs);
        if (H) return "imgs." + H;
      }
    }
    if (d.json != null && d.hasOwnProperty("json")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Json.verify(d.json);
        if (H) return "json." + H;
      }
    }
    if (d.linkButton != null && d.hasOwnProperty("linkButton")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.LinkButton.verify(d.linkButton);
        if (H) return "linkButton." + H;
      }
    }
    if (d.markdown != null && d.hasOwnProperty("markdown")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Markdown.verify(d.markdown);
        if (H) return "markdown." + H;
      }
    }
    if (d.metric != null && d.hasOwnProperty("metric")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Metric.verify(d.metric);
        if (H) return "metric." + H;
      }
    }
    if (d.multiselect != null && d.hasOwnProperty("multiselect")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.MultiSelect.verify(d.multiselect);
        if (H) return "multiselect." + H;
      }
    }
    if (d.numberInput != null && d.hasOwnProperty("numberInput")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.NumberInput.verify(d.numberInput);
        if (H) return "numberInput." + H;
      }
    }
    if (d.pageLink != null && d.hasOwnProperty("pageLink")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.PageLink.verify(d.pageLink);
        if (H) return "pageLink." + H;
      }
    }
    if (d.plotlyChart != null && d.hasOwnProperty("plotlyChart")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.PlotlyChart.verify(d.plotlyChart);
        if (H) return "plotlyChart." + H;
      }
    }
    if (d.progress != null && d.hasOwnProperty("progress")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Progress.verify(d.progress);
        if (H) return "progress." + H;
      }
    }
    if (d.radio != null && d.hasOwnProperty("radio")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Radio.verify(d.radio);
        if (H) return "radio." + H;
      }
    }
    if (d.selectbox != null && d.hasOwnProperty("selectbox")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Selectbox.verify(d.selectbox);
        if (H) return "selectbox." + H;
      }
    }
    if (d.skeleton != null && d.hasOwnProperty("skeleton")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Skeleton.verify(d.skeleton);
        if (H) return "skeleton." + H;
      }
    }
    if (d.slider != null && d.hasOwnProperty("slider")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Slider.verify(d.slider);
        if (H) return "slider." + H;
      }
    }
    if (d.snow != null && d.hasOwnProperty("snow")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Snow.verify(d.snow);
        if (H) return "snow." + H;
      }
    }
    if (d.spinner != null && d.hasOwnProperty("spinner")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Spinner.verify(d.spinner);
        if (H) return "spinner." + H;
      }
    }
    if (d.text != null && d.hasOwnProperty("text")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Text.verify(d.text);
        if (H) return "text." + H;
      }
    }
    if (d.textArea != null && d.hasOwnProperty("textArea")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.TextArea.verify(d.textArea);
        if (H) return "textArea." + H;
      }
    }
    if (d.textInput != null && d.hasOwnProperty("textInput")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.TextInput.verify(d.textInput);
        if (H) return "textInput." + H;
      }
    }
    if (d.timeInput != null && d.hasOwnProperty("timeInput")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.TimeInput.verify(d.timeInput);
        if (H) return "timeInput." + H;
      }
    }
    if (d.toast != null && d.hasOwnProperty("toast")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Toast.verify(d.toast);
        if (H) return "toast." + H;
      }
    }
    if (d.vegaLiteChart != null && d.hasOwnProperty("vegaLiteChart")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.VegaLiteChart.verify(d.vegaLiteChart);
        if (H) return "vegaLiteChart." + H;
      }
    }
    if (d.video != null && d.hasOwnProperty("video")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Video.verify(d.video);
        if (H) return "video." + H;
      }
    }
    if (d.heading != null && d.hasOwnProperty("heading")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Heading.verify(d.heading);
        if (H) return "heading." + H;
      }
    }
    if (d.code != null && d.hasOwnProperty("code")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Code.verify(d.code);
        if (H) return "code." + H;
      }
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Element) return d;
    let k = new $root$1.Element();
    if (d.heightConfig != null) {
      if (typeof d.heightConfig != "object") throw TypeError(".Element.heightConfig: object expected");
      k.heightConfig = $root$1.streamlit.HeightConfig.fromObject(d.heightConfig);
    }
    if (d.widthConfig != null) {
      if (typeof d.widthConfig != "object") throw TypeError(".Element.widthConfig: object expected");
      k.widthConfig = $root$1.streamlit.WidthConfig.fromObject(d.widthConfig);
    }
    if (d.alert != null) {
      if (typeof d.alert != "object") throw TypeError(".Element.alert: object expected");
      k.alert = $root$1.Alert.fromObject(d.alert);
    }
    if (d.arrowDataFrame != null) {
      if (typeof d.arrowDataFrame != "object") throw TypeError(".Element.arrowDataFrame: object expected");
      k.arrowDataFrame = $root$1.Arrow.fromObject(d.arrowDataFrame);
    }
    if (d.arrowTable != null) {
      if (typeof d.arrowTable != "object") throw TypeError(".Element.arrowTable: object expected");
      k.arrowTable = $root$1.Arrow.fromObject(d.arrowTable);
    }
    if (d.arrowVegaLiteChart != null) {
      if (typeof d.arrowVegaLiteChart != "object") throw TypeError(".Element.arrowVegaLiteChart: object expected");
      k.arrowVegaLiteChart = $root$1.ArrowVegaLiteChart.fromObject(d.arrowVegaLiteChart);
    }
    if (d.audio != null) {
      if (typeof d.audio != "object") throw TypeError(".Element.audio: object expected");
      k.audio = $root$1.Audio.fromObject(d.audio);
    }
    if (d.audioInput != null) {
      if (typeof d.audioInput != "object") throw TypeError(".Element.audioInput: object expected");
      k.audioInput = $root$1.AudioInput.fromObject(d.audioInput);
    }
    if (d.balloons != null) {
      if (typeof d.balloons != "object") throw TypeError(".Element.balloons: object expected");
      k.balloons = $root$1.Balloons.fromObject(d.balloons);
    }
    if (d.bokehChart != null) {
      if (typeof d.bokehChart != "object") throw TypeError(".Element.bokehChart: object expected");
      k.bokehChart = $root$1.BokehChart.fromObject(d.bokehChart);
    }
    if (d.button != null) {
      if (typeof d.button != "object") throw TypeError(".Element.button: object expected");
      k.button = $root$1.Button.fromObject(d.button);
    }
    if (d.buttonGroup != null) {
      if (typeof d.buttonGroup != "object") throw TypeError(".Element.buttonGroup: object expected");
      k.buttonGroup = $root$1.ButtonGroup.fromObject(d.buttonGroup);
    }
    if (d.downloadButton != null) {
      if (typeof d.downloadButton != "object") throw TypeError(".Element.downloadButton: object expected");
      k.downloadButton = $root$1.DownloadButton.fromObject(d.downloadButton);
    }
    if (d.cameraInput != null) {
      if (typeof d.cameraInput != "object") throw TypeError(".Element.cameraInput: object expected");
      k.cameraInput = $root$1.CameraInput.fromObject(d.cameraInput);
    }
    if (d.chatInput != null) {
      if (typeof d.chatInput != "object") throw TypeError(".Element.chatInput: object expected");
      k.chatInput = $root$1.ChatInput.fromObject(d.chatInput);
    }
    if (d.checkbox != null) {
      if (typeof d.checkbox != "object") throw TypeError(".Element.checkbox: object expected");
      k.checkbox = $root$1.Checkbox.fromObject(d.checkbox);
    }
    if (d.colorPicker != null) {
      if (typeof d.colorPicker != "object") throw TypeError(".Element.colorPicker: object expected");
      k.colorPicker = $root$1.ColorPicker.fromObject(d.colorPicker);
    }
    if (d.componentInstance != null) {
      if (typeof d.componentInstance != "object") throw TypeError(".Element.componentInstance: object expected");
      k.componentInstance = $root$1.ComponentInstance.fromObject(d.componentInstance);
    }
    if (d.dataFrame != null) {
      if (typeof d.dataFrame != "object") throw TypeError(".Element.dataFrame: object expected");
      k.dataFrame = $root$1.DataFrame.fromObject(d.dataFrame);
    }
    if (d.table != null) {
      if (typeof d.table != "object") throw TypeError(".Element.table: object expected");
      k.table = $root$1.DataFrame.fromObject(d.table);
    }
    if (d.dateInput != null) {
      if (typeof d.dateInput != "object") throw TypeError(".Element.dateInput: object expected");
      k.dateInput = $root$1.DateInput.fromObject(d.dateInput);
    }
    if (d.deckGlJsonChart != null) {
      if (typeof d.deckGlJsonChart != "object") throw TypeError(".Element.deckGlJsonChart: object expected");
      k.deckGlJsonChart = $root$1.DeckGlJsonChart.fromObject(d.deckGlJsonChart);
    }
    if (d.docString != null) {
      if (typeof d.docString != "object") throw TypeError(".Element.docString: object expected");
      k.docString = $root$1.DocString.fromObject(d.docString);
    }
    if (d.empty != null) {
      if (typeof d.empty != "object") throw TypeError(".Element.empty: object expected");
      k.empty = $root$1.Empty.fromObject(d.empty);
    }
    if (d.exception != null) {
      if (typeof d.exception != "object") throw TypeError(".Element.exception: object expected");
      k.exception = $root$1.Exception.fromObject(d.exception);
    }
    if (d.favicon != null) {
      if (typeof d.favicon != "object") throw TypeError(".Element.favicon: object expected");
      k.favicon = $root$1.Favicon.fromObject(d.favicon);
    }
    if (d.fileUploader != null) {
      if (typeof d.fileUploader != "object") throw TypeError(".Element.fileUploader: object expected");
      k.fileUploader = $root$1.FileUploader.fromObject(d.fileUploader);
    }
    if (d.graphvizChart != null) {
      if (typeof d.graphvizChart != "object") throw TypeError(".Element.graphvizChart: object expected");
      k.graphvizChart = $root$1.GraphVizChart.fromObject(d.graphvizChart);
    }
    if (d.html != null) {
      if (typeof d.html != "object") throw TypeError(".Element.html: object expected");
      k.html = $root$1.Html.fromObject(d.html);
    }
    if (d.iframe != null) {
      if (typeof d.iframe != "object") throw TypeError(".Element.iframe: object expected");
      k.iframe = $root$1.IFrame.fromObject(d.iframe);
    }
    if (d.imgs != null) {
      if (typeof d.imgs != "object") throw TypeError(".Element.imgs: object expected");
      k.imgs = $root$1.ImageList.fromObject(d.imgs);
    }
    if (d.json != null) {
      if (typeof d.json != "object") throw TypeError(".Element.json: object expected");
      k.json = $root$1.Json.fromObject(d.json);
    }
    if (d.linkButton != null) {
      if (typeof d.linkButton != "object") throw TypeError(".Element.linkButton: object expected");
      k.linkButton = $root$1.LinkButton.fromObject(d.linkButton);
    }
    if (d.markdown != null) {
      if (typeof d.markdown != "object") throw TypeError(".Element.markdown: object expected");
      k.markdown = $root$1.Markdown.fromObject(d.markdown);
    }
    if (d.metric != null) {
      if (typeof d.metric != "object") throw TypeError(".Element.metric: object expected");
      k.metric = $root$1.Metric.fromObject(d.metric);
    }
    if (d.multiselect != null) {
      if (typeof d.multiselect != "object") throw TypeError(".Element.multiselect: object expected");
      k.multiselect = $root$1.MultiSelect.fromObject(d.multiselect);
    }
    if (d.numberInput != null) {
      if (typeof d.numberInput != "object") throw TypeError(".Element.numberInput: object expected");
      k.numberInput = $root$1.NumberInput.fromObject(d.numberInput);
    }
    if (d.pageLink != null) {
      if (typeof d.pageLink != "object") throw TypeError(".Element.pageLink: object expected");
      k.pageLink = $root$1.PageLink.fromObject(d.pageLink);
    }
    if (d.plotlyChart != null) {
      if (typeof d.plotlyChart != "object") throw TypeError(".Element.plotlyChart: object expected");
      k.plotlyChart = $root$1.PlotlyChart.fromObject(d.plotlyChart);
    }
    if (d.progress != null) {
      if (typeof d.progress != "object") throw TypeError(".Element.progress: object expected");
      k.progress = $root$1.Progress.fromObject(d.progress);
    }
    if (d.radio != null) {
      if (typeof d.radio != "object") throw TypeError(".Element.radio: object expected");
      k.radio = $root$1.Radio.fromObject(d.radio);
    }
    if (d.selectbox != null) {
      if (typeof d.selectbox != "object") throw TypeError(".Element.selectbox: object expected");
      k.selectbox = $root$1.Selectbox.fromObject(d.selectbox);
    }
    if (d.skeleton != null) {
      if (typeof d.skeleton != "object") throw TypeError(".Element.skeleton: object expected");
      k.skeleton = $root$1.Skeleton.fromObject(d.skeleton);
    }
    if (d.slider != null) {
      if (typeof d.slider != "object") throw TypeError(".Element.slider: object expected");
      k.slider = $root$1.Slider.fromObject(d.slider);
    }
    if (d.snow != null) {
      if (typeof d.snow != "object") throw TypeError(".Element.snow: object expected");
      k.snow = $root$1.Snow.fromObject(d.snow);
    }
    if (d.spinner != null) {
      if (typeof d.spinner != "object") throw TypeError(".Element.spinner: object expected");
      k.spinner = $root$1.Spinner.fromObject(d.spinner);
    }
    if (d.text != null) {
      if (typeof d.text != "object") throw TypeError(".Element.text: object expected");
      k.text = $root$1.Text.fromObject(d.text);
    }
    if (d.textArea != null) {
      if (typeof d.textArea != "object") throw TypeError(".Element.textArea: object expected");
      k.textArea = $root$1.TextArea.fromObject(d.textArea);
    }
    if (d.textInput != null) {
      if (typeof d.textInput != "object") throw TypeError(".Element.textInput: object expected");
      k.textInput = $root$1.TextInput.fromObject(d.textInput);
    }
    if (d.timeInput != null) {
      if (typeof d.timeInput != "object") throw TypeError(".Element.timeInput: object expected");
      k.timeInput = $root$1.TimeInput.fromObject(d.timeInput);
    }
    if (d.toast != null) {
      if (typeof d.toast != "object") throw TypeError(".Element.toast: object expected");
      k.toast = $root$1.Toast.fromObject(d.toast);
    }
    if (d.vegaLiteChart != null) {
      if (typeof d.vegaLiteChart != "object") throw TypeError(".Element.vegaLiteChart: object expected");
      k.vegaLiteChart = $root$1.VegaLiteChart.fromObject(d.vegaLiteChart);
    }
    if (d.video != null) {
      if (typeof d.video != "object") throw TypeError(".Element.video: object expected");
      k.video = $root$1.Video.fromObject(d.video);
    }
    if (d.heading != null) {
      if (typeof d.heading != "object") throw TypeError(".Element.heading: object expected");
      k.heading = $root$1.Heading.fromObject(d.heading);
    }
    if (d.code != null) {
      if (typeof d.code != "object") throw TypeError(".Element.code: object expected");
      k.code = $root$1.Code.fromObject(d.code);
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return d.text != null && d.hasOwnProperty("text") && (H.text = $root$1.Text.toObject(d.text, k), k.oneofs && (H.type = "text")), d.empty != null && d.hasOwnProperty("empty") && (H.empty = $root$1.Empty.toObject(d.empty, k), k.oneofs && (H.type = "empty")), d.dataFrame != null && d.hasOwnProperty("dataFrame") && (H.dataFrame = $root$1.DataFrame.toObject(d.dataFrame, k), k.oneofs && (H.type = "dataFrame")), d.progress != null && d.hasOwnProperty("progress") && (H.progress = $root$1.Progress.toObject(d.progress, k), k.oneofs && (H.type = "progress")), d.imgs != null && d.hasOwnProperty("imgs") && (H.imgs = $root$1.ImageList.toObject(d.imgs, k), k.oneofs && (H.type = "imgs")), d.docString != null && d.hasOwnProperty("docString") && (H.docString = $root$1.DocString.toObject(d.docString, k), k.oneofs && (H.type = "docString")), d.exception != null && d.hasOwnProperty("exception") && (H.exception = $root$1.Exception.toObject(d.exception, k), k.oneofs && (H.type = "exception")), d.vegaLiteChart != null && d.hasOwnProperty("vegaLiteChart") && (H.vegaLiteChart = $root$1.VegaLiteChart.toObject(d.vegaLiteChart, k), k.oneofs && (H.type = "vegaLiteChart")), d.table != null && d.hasOwnProperty("table") && (H.table = $root$1.DataFrame.toObject(d.table, k), k.oneofs && (H.type = "table")), d.balloons != null && d.hasOwnProperty("balloons") && (H.balloons = $root$1.Balloons.toObject(d.balloons, k), k.oneofs && (H.type = "balloons")), d.audio != null && d.hasOwnProperty("audio") && (H.audio = $root$1.Audio.toObject(d.audio, k), k.oneofs && (H.type = "audio")), d.video != null && d.hasOwnProperty("video") && (H.video = $root$1.Video.toObject(d.video, k), k.oneofs && (H.type = "video")), d.plotlyChart != null && d.hasOwnProperty("plotlyChart") && (H.plotlyChart = $root$1.PlotlyChart.toObject(d.plotlyChart, k), k.oneofs && (H.type = "plotlyChart")), d.bokehChart != null && d.hasOwnProperty("bokehChart") && (H.bokehChart = $root$1.BokehChart.toObject(d.bokehChart, k), k.oneofs && (H.type = "bokehChart")), d.graphvizChart != null && d.hasOwnProperty("graphvizChart") && (H.graphvizChart = $root$1.GraphVizChart.toObject(d.graphvizChart, k), k.oneofs && (H.type = "graphvizChart")), d.button != null && d.hasOwnProperty("button") && (H.button = $root$1.Button.toObject(d.button, k), k.oneofs && (H.type = "button")), d.checkbox != null && d.hasOwnProperty("checkbox") && (H.checkbox = $root$1.Checkbox.toObject(d.checkbox, k), k.oneofs && (H.type = "checkbox")), d.slider != null && d.hasOwnProperty("slider") && (H.slider = $root$1.Slider.toObject(d.slider, k), k.oneofs && (H.type = "slider")), d.textArea != null && d.hasOwnProperty("textArea") && (H.textArea = $root$1.TextArea.toObject(d.textArea, k), k.oneofs && (H.type = "textArea")), d.radio != null && d.hasOwnProperty("radio") && (H.radio = $root$1.Radio.toObject(d.radio, k), k.oneofs && (H.type = "radio")), d.textInput != null && d.hasOwnProperty("textInput") && (H.textInput = $root$1.TextInput.toObject(d.textInput, k), k.oneofs && (H.type = "textInput")), d.selectbox != null && d.hasOwnProperty("selectbox") && (H.selectbox = $root$1.Selectbox.toObject(d.selectbox, k), k.oneofs && (H.type = "selectbox")), d.timeInput != null && d.hasOwnProperty("timeInput") && (H.timeInput = $root$1.TimeInput.toObject(d.timeInput, k), k.oneofs && (H.type = "timeInput")), d.dateInput != null && d.hasOwnProperty("dateInput") && (H.dateInput = $root$1.DateInput.toObject(d.dateInput, k), k.oneofs && (H.type = "dateInput")), d.multiselect != null && d.hasOwnProperty("multiselect") && (H.multiselect = $root$1.MultiSelect.toObject(d.multiselect, k), k.oneofs && (H.type = "multiselect")), d.markdown != null && d.hasOwnProperty("markdown") && (H.markdown = $root$1.Markdown.toObject(d.markdown, k), k.oneofs && (H.type = "markdown")), d.alert != null && d.hasOwnProperty("alert") && (H.alert = $root$1.Alert.toObject(d.alert, k), k.oneofs && (H.type = "alert")), d.json != null && d.hasOwnProperty("json") && (H.json = $root$1.Json.toObject(d.json, k), k.oneofs && (H.type = "json")), d.numberInput != null && d.hasOwnProperty("numberInput") && (H.numberInput = $root$1.NumberInput.toObject(d.numberInput, k), k.oneofs && (H.type = "numberInput")), d.fileUploader != null && d.hasOwnProperty("fileUploader") && (H.fileUploader = $root$1.FileUploader.toObject(d.fileUploader, k), k.oneofs && (H.type = "fileUploader")), d.deckGlJsonChart != null && d.hasOwnProperty("deckGlJsonChart") && (H.deckGlJsonChart = $root$1.DeckGlJsonChart.toObject(d.deckGlJsonChart, k), k.oneofs && (H.type = "deckGlJsonChart")), d.colorPicker != null && d.hasOwnProperty("colorPicker") && (H.colorPicker = $root$1.ColorPicker.toObject(d.colorPicker, k), k.oneofs && (H.type = "colorPicker")), d.favicon != null && d.hasOwnProperty("favicon") && (H.favicon = $root$1.Favicon.toObject(d.favicon, k), k.oneofs && (H.type = "favicon")), d.componentInstance != null && d.hasOwnProperty("componentInstance") && (H.componentInstance = $root$1.ComponentInstance.toObject(d.componentInstance, k), k.oneofs && (H.type = "componentInstance")), d.iframe != null && d.hasOwnProperty("iframe") && (H.iframe = $root$1.IFrame.toObject(d.iframe, k), k.oneofs && (H.type = "iframe")), d.arrowTable != null && d.hasOwnProperty("arrowTable") && (H.arrowTable = $root$1.Arrow.toObject(d.arrowTable, k), k.oneofs && (H.type = "arrowTable")), d.arrowDataFrame != null && d.hasOwnProperty("arrowDataFrame") && (H.arrowDataFrame = $root$1.Arrow.toObject(d.arrowDataFrame, k), k.oneofs && (H.type = "arrowDataFrame")), d.arrowVegaLiteChart != null && d.hasOwnProperty("arrowVegaLiteChart") && (H.arrowVegaLiteChart = $root$1.ArrowVegaLiteChart.toObject(d.arrowVegaLiteChart, k), k.oneofs && (H.type = "arrowVegaLiteChart")), d.metric != null && d.hasOwnProperty("metric") && (H.metric = $root$1.Metric.toObject(d.metric, k), k.oneofs && (H.type = "metric")), d.downloadButton != null && d.hasOwnProperty("downloadButton") && (H.downloadButton = $root$1.DownloadButton.toObject(d.downloadButton, k), k.oneofs && (H.type = "downloadButton")), d.spinner != null && d.hasOwnProperty("spinner") && (H.spinner = $root$1.Spinner.toObject(d.spinner, k), k.oneofs && (H.type = "spinner")), d.cameraInput != null && d.hasOwnProperty("cameraInput") && (H.cameraInput = $root$1.CameraInput.toObject(d.cameraInput, k), k.oneofs && (H.type = "cameraInput")), d.snow != null && d.hasOwnProperty("snow") && (H.snow = $root$1.Snow.toObject(d.snow, k), k.oneofs && (H.type = "snow")), d.heading != null && d.hasOwnProperty("heading") && (H.heading = $root$1.Heading.toObject(d.heading, k), k.oneofs && (H.type = "heading")), d.code != null && d.hasOwnProperty("code") && (H.code = $root$1.Code.toObject(d.code, k), k.oneofs && (H.type = "code")), d.chatInput != null && d.hasOwnProperty("chatInput") && (H.chatInput = $root$1.ChatInput.toObject(d.chatInput, k), k.oneofs && (H.type = "chatInput")), d.toast != null && d.hasOwnProperty("toast") && (H.toast = $root$1.Toast.toObject(d.toast, k), k.oneofs && (H.type = "toast")), d.linkButton != null && d.hasOwnProperty("linkButton") && (H.linkButton = $root$1.LinkButton.toObject(d.linkButton, k), k.oneofs && (H.type = "linkButton")), d.skeleton != null && d.hasOwnProperty("skeleton") && (H.skeleton = $root$1.Skeleton.toObject(d.skeleton, k), k.oneofs && (H.type = "skeleton")), d.pageLink != null && d.hasOwnProperty("pageLink") && (H.pageLink = $root$1.PageLink.toObject(d.pageLink, k), k.oneofs && (H.type = "pageLink")), d.html != null && d.hasOwnProperty("html") && (H.html = $root$1.Html.toObject(d.html, k), k.oneofs && (H.type = "html")), d.buttonGroup != null && d.hasOwnProperty("buttonGroup") && (H.buttonGroup = $root$1.ButtonGroup.toObject(d.buttonGroup, k), k.oneofs && (H.type = "buttonGroup")), d.audioInput != null && d.hasOwnProperty("audioInput") && (H.audioInput = $root$1.AudioInput.toObject(d.audioInput, k), k.oneofs && (H.type = "audioInput")), d.heightConfig != null && d.hasOwnProperty("heightConfig") && (H.heightConfig = $root$1.streamlit.HeightConfig.toObject(d.heightConfig, k), k.oneofs && (H._heightConfig = "heightConfig")), d.widthConfig != null && d.hasOwnProperty("widthConfig") && (H.widthConfig = $root$1.streamlit.WidthConfig.toObject(d.widthConfig, k), k.oneofs && (H._widthConfig = "widthConfig")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Element";
  }, n;
})();
$root$1.DownloadButton = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.default = !1, n.prototype.help = "", n.prototype.formId = "", n.prototype.url = "", n.prototype.disabled = !1, n.prototype.useContainerWidth = !1, n.prototype.type = "", n.prototype.icon = "", n.prototype.ignoreRerun = !1, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.default), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.url != null && Object.hasOwnProperty.call(g, "url") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.url), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.disabled), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.useContainerWidth), g.type != null && Object.hasOwnProperty.call(g, "type") && d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.type), g.icon != null && Object.hasOwnProperty.call(g, "icon") && d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.icon), g.ignoreRerun != null && Object.hasOwnProperty.call(g, "ignoreRerun") && d.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.ignoreRerun), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.DownloadButton();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.default = g.bool();
          break;
        }
        case 4: {
          AA.help = g.string();
          break;
        }
        case 5: {
          AA.formId = g.string();
          break;
        }
        case 6: {
          AA.url = g.string();
          break;
        }
        case 7: {
          AA.disabled = g.bool();
          break;
        }
        case 8: {
          AA.useContainerWidth = g.bool();
          break;
        }
        case 9: {
          AA.type = g.string();
          break;
        }
        case 10: {
          AA.icon = g.string();
          break;
        }
        case 11: {
          AA.ignoreRerun = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.id != null && g.hasOwnProperty("id") && !$util$1.isString(g.id) ? "id: string expected" : g.label != null && g.hasOwnProperty("label") && !$util$1.isString(g.label) ? "label: string expected" : g.default != null && g.hasOwnProperty("default") && typeof g.default != "boolean" ? "default: boolean expected" : g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help) ? "help: string expected" : g.formId != null && g.hasOwnProperty("formId") && !$util$1.isString(g.formId) ? "formId: string expected" : g.url != null && g.hasOwnProperty("url") && !$util$1.isString(g.url) ? "url: string expected" : g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean" ? "disabled: boolean expected" : g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && typeof g.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : g.type != null && g.hasOwnProperty("type") && !$util$1.isString(g.type) ? "type: string expected" : g.icon != null && g.hasOwnProperty("icon") && !$util$1.isString(g.icon) ? "icon: string expected" : g.ignoreRerun != null && g.hasOwnProperty("ignoreRerun") && typeof g.ignoreRerun != "boolean" ? "ignoreRerun: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.DownloadButton) return g;
    let d = new $root$1.DownloadButton();
    return g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.default != null && (d.default = !!g.default), g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.url != null && (d.url = String(g.url)), g.disabled != null && (d.disabled = !!g.disabled), g.useContainerWidth != null && (d.useContainerWidth = !!g.useContainerWidth), g.type != null && (d.type = String(g.type)), g.icon != null && (d.icon = String(g.icon)), g.ignoreRerun != null && (d.ignoreRerun = !!g.ignoreRerun), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.id = "", k.label = "", k.default = !1, k.help = "", k.formId = "", k.url = "", k.disabled = !1, k.useContainerWidth = !1, k.type = "", k.icon = "", k.ignoreRerun = !1), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.default != null && g.hasOwnProperty("default") && (k.default = g.default), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.url != null && g.hasOwnProperty("url") && (k.url = g.url), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (k.useContainerWidth = g.useContainerWidth), g.type != null && g.hasOwnProperty("type") && (k.type = g.type), g.icon != null && g.hasOwnProperty("icon") && (k.icon = g.icon), g.ignoreRerun != null && g.hasOwnProperty("ignoreRerun") && (k.ignoreRerun = g.ignoreRerun), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DownloadButton";
  }, n;
})();
$root$1.DocString = (() => {
  function n(t) {
    if (this.members = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.docString = "", n.prototype.type = "", n.prototype.name = "", n.prototype.value = "", n.prototype.members = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.docString != null && Object.hasOwnProperty.call(g, "docString") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.docString), g.type != null && Object.hasOwnProperty.call(g, "type") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.type), g.name != null && Object.hasOwnProperty.call(g, "name") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.name), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.value), g.members != null && g.members.length) for (let k = 0; k < g.members.length; ++k) $root$1.Member.encode(g.members[k], d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.DocString();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 3: {
          AA.docString = g.string();
          break;
        }
        case 4: {
          AA.type = g.string();
          break;
        }
        case 6: {
          AA.name = g.string();
          break;
        }
        case 7: {
          AA.value = g.string();
          break;
        }
        case 8: {
          AA.members && AA.members.length || (AA.members = []), AA.members.push($root$1.Member.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.docString != null && g.hasOwnProperty("docString") && !$util$1.isString(g.docString)) return "docString: string expected";
    if (g.type != null && g.hasOwnProperty("type") && !$util$1.isString(g.type)) return "type: string expected";
    if (g.name != null && g.hasOwnProperty("name") && !$util$1.isString(g.name)) return "name: string expected";
    if (g.value != null && g.hasOwnProperty("value") && !$util$1.isString(g.value)) return "value: string expected";
    if (g.members != null && g.hasOwnProperty("members")) {
      if (!Array.isArray(g.members)) return "members: array expected";
      for (let d = 0; d < g.members.length; ++d) {
        let k = $root$1.Member.verify(g.members[d]);
        if (k) return "members." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.DocString) return g;
    let d = new $root$1.DocString();
    if (g.docString != null && (d.docString = String(g.docString)), g.type != null && (d.type = String(g.type)), g.name != null && (d.name = String(g.name)), g.value != null && (d.value = String(g.value)), g.members) {
      if (!Array.isArray(g.members)) throw TypeError(".DocString.members: array expected");
      d.members = [];
      for (let k = 0; k < g.members.length; ++k) {
        if (typeof g.members[k] != "object") throw TypeError(".DocString.members: object expected");
        d.members[k] = $root$1.Member.fromObject(g.members[k]);
      }
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.members = []), d.defaults && (k.docString = "", k.type = "", k.name = "", k.value = ""), g.docString != null && g.hasOwnProperty("docString") && (k.docString = g.docString), g.type != null && g.hasOwnProperty("type") && (k.type = g.type), g.name != null && g.hasOwnProperty("name") && (k.name = g.name), g.value != null && g.hasOwnProperty("value") && (k.value = g.value), g.members && g.members.length) {
      k.members = [];
      for (let H = 0; H < g.members.length; ++H) k.members[H] = $root$1.Member.toObject(g.members[H], d);
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/DocString";
  }, n;
})();
$root$1.Member = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.name = "", n.prototype.type = "", n.prototype.value = null, n.prototype.docString = null;
  let t;
  return Object.defineProperty(n.prototype, "contents", { get: $util$1.oneOfGetter(t = ["value", "docString"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.name != null && Object.hasOwnProperty.call(d, "name") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.name), d.type != null && Object.hasOwnProperty.call(d, "type") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.type), d.value != null && Object.hasOwnProperty.call(d, "value") && k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(d.value), d.docString != null && Object.hasOwnProperty.call(d, "docString") && k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(d.docString), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Member();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.name = d.string();
          break;
        }
        case 2: {
          gA.type = d.string();
          break;
        }
        case 3: {
          gA.value = d.string();
          break;
        }
        case 4: {
          gA.docString = d.string();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.name != null && d.hasOwnProperty("name") && !$util$1.isString(d.name)) return "name: string expected";
    if (d.type != null && d.hasOwnProperty("type") && !$util$1.isString(d.type)) return "type: string expected";
    if (d.value != null && d.hasOwnProperty("value") && (k.contents = 1, !$util$1.isString(d.value)))
      return "value: string expected";
    if (d.docString != null && d.hasOwnProperty("docString")) {
      if (k.contents === 1) return "contents: multiple values";
      if (k.contents = 1, !$util$1.isString(d.docString)) return "docString: string expected";
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Member) return d;
    let k = new $root$1.Member();
    return d.name != null && (k.name = String(d.name)), d.type != null && (k.type = String(d.type)), d.value != null && (k.value = String(d.value)), d.docString != null && (k.docString = String(d.docString)), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.name = "", H.type = ""), d.name != null && d.hasOwnProperty("name") && (H.name = d.name), d.type != null && d.hasOwnProperty("type") && (H.type = d.type), d.value != null && d.hasOwnProperty("value") && (H.value = d.value, k.oneofs && (H.contents = "value")), d.docString != null && d.hasOwnProperty("docString") && (H.docString = d.docString, k.oneofs && (H.contents = "docString")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Member";
  }, n;
})();
$root$1.Empty = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Empty();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : null;
  }, n.fromObject = function(g) {
    return g instanceof $root$1.Empty ? g : new $root$1.Empty();
  }, n.toObject = function() {
    return {};
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Empty";
  }, n;
})();
$root$1.Exception = (() => {
  function n(t) {
    if (this.stackTrace = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.type = "", n.prototype.message = "", n.prototype.messageIsMarkdown = !1, n.prototype.stackTrace = $util$1.emptyArray, n.prototype.isWarning = !1, n.prototype.widthConfig = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.type != null && Object.hasOwnProperty.call(g, "type") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.type), g.message != null && Object.hasOwnProperty.call(g, "message") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.message), g.stackTrace != null && g.stackTrace.length) for (let k = 0; k < g.stackTrace.length; ++k) d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.stackTrace[k]);
    return g.messageIsMarkdown != null && Object.hasOwnProperty.call(g, "messageIsMarkdown") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.messageIsMarkdown), g.isWarning != null && Object.hasOwnProperty.call(g, "isWarning") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.isWarning), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root$1.streamlit.WidthConfig.encode(g.widthConfig, d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Exception();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.type = g.string();
          break;
        }
        case 2: {
          AA.message = g.string();
          break;
        }
        case 4: {
          AA.messageIsMarkdown = g.bool();
          break;
        }
        case 3: {
          AA.stackTrace && AA.stackTrace.length || (AA.stackTrace = []), AA.stackTrace.push(g.string());
          break;
        }
        case 5: {
          AA.isWarning = g.bool();
          break;
        }
        case 6: {
          AA.widthConfig = $root$1.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.type != null && g.hasOwnProperty("type") && !$util$1.isString(g.type)) return "type: string expected";
    if (g.message != null && g.hasOwnProperty("message") && !$util$1.isString(g.message)) return "message: string expected";
    if (g.messageIsMarkdown != null && g.hasOwnProperty("messageIsMarkdown") && typeof g.messageIsMarkdown != "boolean") return "messageIsMarkdown: boolean expected";
    if (g.stackTrace != null && g.hasOwnProperty("stackTrace")) {
      if (!Array.isArray(g.stackTrace)) return "stackTrace: array expected";
      for (let d = 0; d < g.stackTrace.length; ++d) if (!$util$1.isString(g.stackTrace[d])) return "stackTrace: string[] expected";
    }
    if (g.isWarning != null && g.hasOwnProperty("isWarning") && typeof g.isWarning != "boolean") return "isWarning: boolean expected";
    if (g.widthConfig != null && g.hasOwnProperty("widthConfig")) {
      let d = $root$1.streamlit.WidthConfig.verify(g.widthConfig);
      if (d) return "widthConfig." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Exception) return g;
    let d = new $root$1.Exception();
    if (g.type != null && (d.type = String(g.type)), g.message != null && (d.message = String(g.message)), g.messageIsMarkdown != null && (d.messageIsMarkdown = !!g.messageIsMarkdown), g.stackTrace) {
      if (!Array.isArray(g.stackTrace)) throw TypeError(".Exception.stackTrace: array expected");
      d.stackTrace = [];
      for (let k = 0; k < g.stackTrace.length; ++k) d.stackTrace[k] = String(g.stackTrace[k]);
    }
    if (g.isWarning != null && (d.isWarning = !!g.isWarning), g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Exception.widthConfig: object expected");
      d.widthConfig = $root$1.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.stackTrace = []), d.defaults && (k.type = "", k.message = "", k.messageIsMarkdown = !1, k.isWarning = !1, k.widthConfig = null), g.type != null && g.hasOwnProperty("type") && (k.type = g.type), g.message != null && g.hasOwnProperty("message") && (k.message = g.message), g.stackTrace && g.stackTrace.length) {
      k.stackTrace = [];
      for (let H = 0; H < g.stackTrace.length; ++H) k.stackTrace[H] = g.stackTrace[H];
    }
    return g.messageIsMarkdown != null && g.hasOwnProperty("messageIsMarkdown") && (k.messageIsMarkdown = g.messageIsMarkdown), g.isWarning != null && g.hasOwnProperty("isWarning") && (k.isWarning = g.isWarning), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (k.widthConfig = $root$1.streamlit.WidthConfig.toObject(g.widthConfig, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Exception";
  }, n;
})();
$root$1.Favicon = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.url = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.url != null && Object.hasOwnProperty.call(g, "url") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.url), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Favicon();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.url = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.url != null && g.hasOwnProperty("url") && !$util$1.isString(g.url) ? "url: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Favicon) return g;
    let d = new $root$1.Favicon();
    return g.url != null && (d.url = String(g.url)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.url = ""), g.url != null && g.hasOwnProperty("url") && (k.url = g.url), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Favicon";
  }, n;
})();
$root$1.FileUploader = (() => {
  function n(t) {
    if (this.type = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.type = $util$1.emptyArray, n.prototype.maxUploadSizeMb = 0, n.prototype.multipleFiles = !1, n.prototype.help = "", n.prototype.formId = "", n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.acceptDirectory = !1, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.type != null && g.type.length) for (let k = 0; k < g.type.length; ++k) d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.type[k]);
    return g.maxUploadSizeMb != null && Object.hasOwnProperty.call(g, "maxUploadSizeMb") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(g.maxUploadSizeMb), g.multipleFiles != null && Object.hasOwnProperty.call(g, "multipleFiles") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.multipleFiles), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.formId), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.acceptDirectory != null && Object.hasOwnProperty.call(g, "acceptDirectory") && d.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.acceptDirectory), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.FileUploader();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.type && AA.type.length || (AA.type = []), AA.type.push(g.string());
          break;
        }
        case 4: {
          AA.maxUploadSizeMb = g.int32();
          break;
        }
        case 6: {
          AA.multipleFiles = g.bool();
          break;
        }
        case 7: {
          AA.help = g.string();
          break;
        }
        case 8: {
          AA.formId = g.string();
          break;
        }
        case 9: {
          AA.disabled = g.bool();
          break;
        }
        case 10: {
          AA.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 11: {
          AA.acceptDirectory = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util$1.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util$1.isString(g.label)) return "label: string expected";
    if (g.type != null && g.hasOwnProperty("type")) {
      if (!Array.isArray(g.type)) return "type: array expected";
      for (let d = 0; d < g.type.length; ++d) if (!$util$1.isString(g.type[d])) return "type: string[] expected";
    }
    if (g.maxUploadSizeMb != null && g.hasOwnProperty("maxUploadSizeMb") && !$util$1.isInteger(g.maxUploadSizeMb)) return "maxUploadSizeMb: integer expected";
    if (g.multipleFiles != null && g.hasOwnProperty("multipleFiles") && typeof g.multipleFiles != "boolean") return "multipleFiles: boolean expected";
    if (g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help)) return "help: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util$1.isString(g.formId)) return "formId: string expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root$1.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    return g.acceptDirectory != null && g.hasOwnProperty("acceptDirectory") && typeof g.acceptDirectory != "boolean" ? "acceptDirectory: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.FileUploader) return g;
    let d = new $root$1.FileUploader();
    if (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.type) {
      if (!Array.isArray(g.type)) throw TypeError(".FileUploader.type: array expected");
      d.type = [];
      for (let k = 0; k < g.type.length; ++k) d.type[k] = String(g.type[k]);
    }
    if (g.maxUploadSizeMb != null && (d.maxUploadSizeMb = g.maxUploadSizeMb | 0), g.multipleFiles != null && (d.multipleFiles = !!g.multipleFiles), g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".FileUploader.labelVisibility: object expected");
      d.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.acceptDirectory != null && (d.acceptDirectory = !!g.acceptDirectory), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.type = []), d.defaults && (k.id = "", k.label = "", k.maxUploadSizeMb = 0, k.multipleFiles = !1, k.help = "", k.formId = "", k.disabled = !1, k.labelVisibility = null, k.acceptDirectory = !1), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.type && g.type.length) {
      k.type = [];
      for (let H = 0; H < g.type.length; ++H) k.type[H] = g.type[H];
    }
    return g.maxUploadSizeMb != null && g.hasOwnProperty("maxUploadSizeMb") && (k.maxUploadSizeMb = g.maxUploadSizeMb), g.multipleFiles != null && g.hasOwnProperty("multipleFiles") && (k.multipleFiles = g.multipleFiles), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.acceptDirectory != null && g.hasOwnProperty("acceptDirectory") && (k.acceptDirectory = g.acceptDirectory), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FileUploader";
  }, n;
})();
$root$1.GraphVizChart = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.spec = "", n.prototype.useContainerWidth = !1, n.prototype.elementId = "", n.prototype.engine = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.spec != null && Object.hasOwnProperty.call(g, "spec") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.spec), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.useContainerWidth), g.elementId != null && Object.hasOwnProperty.call(g, "elementId") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.elementId), g.engine != null && Object.hasOwnProperty.call(g, "engine") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.engine), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.GraphVizChart();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.spec = g.string();
          break;
        }
        case 4: {
          AA.useContainerWidth = g.bool();
          break;
        }
        case 5: {
          AA.elementId = g.string();
          break;
        }
        case 6: {
          AA.engine = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.spec != null && g.hasOwnProperty("spec") && !$util$1.isString(g.spec) ? "spec: string expected" : g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && typeof g.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : g.elementId != null && g.hasOwnProperty("elementId") && !$util$1.isString(g.elementId) ? "elementId: string expected" : g.engine != null && g.hasOwnProperty("engine") && !$util$1.isString(g.engine) ? "engine: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.GraphVizChart) return g;
    let d = new $root$1.GraphVizChart();
    return g.spec != null && (d.spec = String(g.spec)), g.useContainerWidth != null && (d.useContainerWidth = !!g.useContainerWidth), g.elementId != null && (d.elementId = String(g.elementId)), g.engine != null && (d.engine = String(g.engine)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.spec = "", k.useContainerWidth = !1, k.elementId = "", k.engine = ""), g.spec != null && g.hasOwnProperty("spec") && (k.spec = g.spec), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (k.useContainerWidth = g.useContainerWidth), g.elementId != null && g.hasOwnProperty("elementId") && (k.elementId = g.elementId), g.engine != null && g.hasOwnProperty("engine") && (k.engine = g.engine), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/GraphVizChart";
  }, n;
})();
$root$1.Html = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.body = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Html();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.body = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.body != null && g.hasOwnProperty("body") && !$util$1.isString(g.body) ? "body: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Html) return g;
    let d = new $root$1.Html();
    return g.body != null && (d.body = String(g.body)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.body = ""), g.body != null && g.hasOwnProperty("body") && (k.body = g.body), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Html";
  }, n;
})();
$root$1.IFrame = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.src = null, n.prototype.srcdoc = null, n.prototype.width = 0, n.prototype.hasWidth = !1, n.prototype.height = 0, n.prototype.scrolling = !1, n.prototype.tabIndex = null;
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util$1.oneOfGetter(t = ["src", "srcdoc"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_tabIndex", { get: $util$1.oneOfGetter(t = ["tabIndex"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.src != null && Object.hasOwnProperty.call(d, "src") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.src), d.srcdoc != null && Object.hasOwnProperty.call(d, "srcdoc") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.srcdoc), d.width != null && Object.hasOwnProperty.call(d, "width") && k.uint32(
      /* id 3, wireType 5 =*/
      29
    ).float(d.width), d.hasWidth != null && Object.hasOwnProperty.call(d, "hasWidth") && k.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(d.hasWidth), d.height != null && Object.hasOwnProperty.call(d, "height") && k.uint32(
      /* id 5, wireType 5 =*/
      45
    ).float(d.height), d.scrolling != null && Object.hasOwnProperty.call(d, "scrolling") && k.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(d.scrolling), d.tabIndex != null && Object.hasOwnProperty.call(d, "tabIndex") && k.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(d.tabIndex), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.IFrame();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.src = d.string();
          break;
        }
        case 2: {
          gA.srcdoc = d.string();
          break;
        }
        case 3: {
          gA.width = d.float();
          break;
        }
        case 4: {
          gA.hasWidth = d.bool();
          break;
        }
        case 5: {
          gA.height = d.float();
          break;
        }
        case 7: {
          gA.scrolling = d.bool();
          break;
        }
        case 8: {
          gA.tabIndex = d.int32();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.src != null && d.hasOwnProperty("src") && (k.type = 1, !$util$1.isString(d.src)))
      return "src: string expected";
    if (d.srcdoc != null && d.hasOwnProperty("srcdoc")) {
      if (k.type === 1) return "type: multiple values";
      if (k.type = 1, !$util$1.isString(d.srcdoc)) return "srcdoc: string expected";
    }
    return d.width != null && d.hasOwnProperty("width") && typeof d.width != "number" ? "width: number expected" : d.hasWidth != null && d.hasOwnProperty("hasWidth") && typeof d.hasWidth != "boolean" ? "hasWidth: boolean expected" : d.height != null && d.hasOwnProperty("height") && typeof d.height != "number" ? "height: number expected" : d.scrolling != null && d.hasOwnProperty("scrolling") && typeof d.scrolling != "boolean" ? "scrolling: boolean expected" : d.tabIndex != null && d.hasOwnProperty("tabIndex") && (k._tabIndex = 1, !$util$1.isInteger(d.tabIndex)) ? "tabIndex: integer expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.IFrame) return d;
    let k = new $root$1.IFrame();
    return d.src != null && (k.src = String(d.src)), d.srcdoc != null && (k.srcdoc = String(d.srcdoc)), d.width != null && (k.width = Number(d.width)), d.hasWidth != null && (k.hasWidth = !!d.hasWidth), d.height != null && (k.height = Number(d.height)), d.scrolling != null && (k.scrolling = !!d.scrolling), d.tabIndex != null && (k.tabIndex = d.tabIndex | 0), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.width = 0, H.hasWidth = !1, H.height = 0, H.scrolling = !1), d.src != null && d.hasOwnProperty("src") && (H.src = d.src, k.oneofs && (H.type = "src")), d.srcdoc != null && d.hasOwnProperty("srcdoc") && (H.srcdoc = d.srcdoc, k.oneofs && (H.type = "srcdoc")), d.width != null && d.hasOwnProperty("width") && (H.width = k.json && !isFinite(d.width) ? String(d.width) : d.width), d.hasWidth != null && d.hasOwnProperty("hasWidth") && (H.hasWidth = d.hasWidth), d.height != null && d.hasOwnProperty("height") && (H.height = k.json && !isFinite(d.height) ? String(d.height) : d.height), d.scrolling != null && d.hasOwnProperty("scrolling") && (H.scrolling = d.scrolling), d.tabIndex != null && d.hasOwnProperty("tabIndex") && (H.tabIndex = d.tabIndex, k.oneofs && (H._tabIndex = "tabIndex")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/IFrame";
  }, n;
})();
$root$1.Image = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.url = "", n.prototype.caption = "", n.prototype.markup = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.caption != null && Object.hasOwnProperty.call(g, "caption") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.caption), g.url != null && Object.hasOwnProperty.call(g, "url") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.url), g.markup != null && Object.hasOwnProperty.call(g, "markup") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.markup), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Image();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 3: {
          AA.url = g.string();
          break;
        }
        case 2: {
          AA.caption = g.string();
          break;
        }
        case 4: {
          AA.markup = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.url != null && g.hasOwnProperty("url") && !$util$1.isString(g.url) ? "url: string expected" : g.caption != null && g.hasOwnProperty("caption") && !$util$1.isString(g.caption) ? "caption: string expected" : g.markup != null && g.hasOwnProperty("markup") && !$util$1.isString(g.markup) ? "markup: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Image) return g;
    let d = new $root$1.Image();
    return g.url != null && (d.url = String(g.url)), g.caption != null && (d.caption = String(g.caption)), g.markup != null && (d.markup = String(g.markup)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.caption = "", k.url = "", k.markup = ""), g.caption != null && g.hasOwnProperty("caption") && (k.caption = g.caption), g.url != null && g.hasOwnProperty("url") && (k.url = g.url), g.markup != null && g.hasOwnProperty("markup") && (k.markup = g.markup), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Image";
  }, n;
})();
$root$1.ImageList = (() => {
  function n(t) {
    if (this.imgs = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.imgs = $util$1.emptyArray, n.prototype.width = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.imgs != null && g.imgs.length) for (let k = 0; k < g.imgs.length; ++k) $root$1.Image.encode(g.imgs[k], d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g.width != null && Object.hasOwnProperty.call(g, "width") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.width), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ImageList();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.imgs && AA.imgs.length || (AA.imgs = []), AA.imgs.push($root$1.Image.decode(g, g.uint32()));
          break;
        }
        case 2: {
          AA.width = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.imgs != null && g.hasOwnProperty("imgs")) {
      if (!Array.isArray(g.imgs)) return "imgs: array expected";
      for (let d = 0; d < g.imgs.length; ++d) {
        let k = $root$1.Image.verify(g.imgs[d]);
        if (k) return "imgs." + k;
      }
    }
    return g.width != null && g.hasOwnProperty("width") && !$util$1.isInteger(g.width) ? "width: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ImageList) return g;
    let d = new $root$1.ImageList();
    if (g.imgs) {
      if (!Array.isArray(g.imgs)) throw TypeError(".ImageList.imgs: array expected");
      d.imgs = [];
      for (let k = 0; k < g.imgs.length; ++k) {
        if (typeof g.imgs[k] != "object") throw TypeError(".ImageList.imgs: object expected");
        d.imgs[k] = $root$1.Image.fromObject(g.imgs[k]);
      }
    }
    return g.width != null && (d.width = g.width | 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.imgs = []), d.defaults && (k.width = 0), g.imgs && g.imgs.length) {
      k.imgs = [];
      for (let H = 0; H < g.imgs.length; ++H) k.imgs[H] = $root$1.Image.toObject(g.imgs[H], d);
    }
    return g.width != null && g.hasOwnProperty("width") && (k.width = g.width), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ImageList";
  }, n;
})();
$root$1.Json = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.body = "", n.prototype.expanded = !1, n.prototype.maxExpandDepth = null;
  let t;
  return Object.defineProperty(n.prototype, "_maxExpandDepth", { get: $util$1.oneOfGetter(t = ["maxExpandDepth"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.body != null && Object.hasOwnProperty.call(d, "body") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.body), d.expanded != null && Object.hasOwnProperty.call(d, "expanded") && k.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(d.expanded), d.maxExpandDepth != null && Object.hasOwnProperty.call(d, "maxExpandDepth") && k.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(d.maxExpandDepth), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Json();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.body = d.string();
          break;
        }
        case 2: {
          gA.expanded = d.bool();
          break;
        }
        case 3: {
          gA.maxExpandDepth = d.int32();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    return typeof d != "object" || d === null ? "object expected" : d.body != null && d.hasOwnProperty("body") && !$util$1.isString(d.body) ? "body: string expected" : d.expanded != null && d.hasOwnProperty("expanded") && typeof d.expanded != "boolean" ? "expanded: boolean expected" : d.maxExpandDepth != null && d.hasOwnProperty("maxExpandDepth") && !$util$1.isInteger(d.maxExpandDepth) ? "maxExpandDepth: integer expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Json) return d;
    let k = new $root$1.Json();
    return d.body != null && (k.body = String(d.body)), d.expanded != null && (k.expanded = !!d.expanded), d.maxExpandDepth != null && (k.maxExpandDepth = d.maxExpandDepth | 0), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.body = "", H.expanded = !1), d.body != null && d.hasOwnProperty("body") && (H.body = d.body), d.expanded != null && d.hasOwnProperty("expanded") && (H.expanded = d.expanded), d.maxExpandDepth != null && d.hasOwnProperty("maxExpandDepth") && (H.maxExpandDepth = d.maxExpandDepth, k.oneofs && (H._maxExpandDepth = "maxExpandDepth")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Json";
  }, n;
})();
$root$1.LinkButton = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.label = "", n.prototype.help = "", n.prototype.url = "", n.prototype.disabled = !1, n.prototype.useContainerWidth = !1, n.prototype.type = "", n.prototype.icon = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.url != null && Object.hasOwnProperty.call(g, "url") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.url), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.disabled), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.useContainerWidth), g.type != null && Object.hasOwnProperty.call(g, "type") && d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.type), g.icon != null && Object.hasOwnProperty.call(g, "icon") && d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.icon), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.LinkButton();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 2: {
          AA.label = g.string();
          break;
        }
        case 4: {
          AA.help = g.string();
          break;
        }
        case 6: {
          AA.url = g.string();
          break;
        }
        case 7: {
          AA.disabled = g.bool();
          break;
        }
        case 8: {
          AA.useContainerWidth = g.bool();
          break;
        }
        case 9: {
          AA.type = g.string();
          break;
        }
        case 10: {
          AA.icon = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.label != null && g.hasOwnProperty("label") && !$util$1.isString(g.label) ? "label: string expected" : g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help) ? "help: string expected" : g.url != null && g.hasOwnProperty("url") && !$util$1.isString(g.url) ? "url: string expected" : g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean" ? "disabled: boolean expected" : g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && typeof g.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : g.type != null && g.hasOwnProperty("type") && !$util$1.isString(g.type) ? "type: string expected" : g.icon != null && g.hasOwnProperty("icon") && !$util$1.isString(g.icon) ? "icon: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.LinkButton) return g;
    let d = new $root$1.LinkButton();
    return g.label != null && (d.label = String(g.label)), g.help != null && (d.help = String(g.help)), g.url != null && (d.url = String(g.url)), g.disabled != null && (d.disabled = !!g.disabled), g.useContainerWidth != null && (d.useContainerWidth = !!g.useContainerWidth), g.type != null && (d.type = String(g.type)), g.icon != null && (d.icon = String(g.icon)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.label = "", k.help = "", k.url = "", k.disabled = !1, k.useContainerWidth = !1, k.type = "", k.icon = ""), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.url != null && g.hasOwnProperty("url") && (k.url = g.url), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (k.useContainerWidth = g.useContainerWidth), g.type != null && g.hasOwnProperty("type") && (k.type = g.type), g.icon != null && g.hasOwnProperty("icon") && (k.icon = g.icon), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/LinkButton";
  }, n;
})();
const NumberInput$1 = $root$1.NumberInput = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.formId = "", n.prototype.format = "", n.prototype.hasMin = !1, n.prototype.hasMax = !1, n.prototype.dataType = 0, n.prototype.default = null, n.prototype.step = 0, n.prototype.min = 0, n.prototype.max = 0, n.prototype.help = "", n.prototype.value = null, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.placeholder = "", n.prototype.icon = "";
  let t;
  return Object.defineProperty(n.prototype, "_default", { get: $util$1.oneOfGetter(t = ["default"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_value", { get: $util$1.oneOfGetter(t = ["value"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.id), d.label != null && Object.hasOwnProperty.call(d, "label") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.label), d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(d.formId), d.format != null && Object.hasOwnProperty.call(d, "format") && k.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(d.format), d.hasMin != null && Object.hasOwnProperty.call(d, "hasMin") && k.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(d.hasMin), d.hasMax != null && Object.hasOwnProperty.call(d, "hasMax") && k.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(d.hasMax), d.dataType != null && Object.hasOwnProperty.call(d, "dataType") && k.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(d.dataType), d.default != null && Object.hasOwnProperty.call(d, "default") && k.uint32(
      /* id 14, wireType 1 =*/
      113
    ).double(d.default), d.step != null && Object.hasOwnProperty.call(d, "step") && k.uint32(
      /* id 15, wireType 1 =*/
      121
    ).double(d.step), d.min != null && Object.hasOwnProperty.call(d, "min") && k.uint32(
      /* id 16, wireType 1 =*/
      129
    ).double(d.min), d.max != null && Object.hasOwnProperty.call(d, "max") && k.uint32(
      /* id 17, wireType 1 =*/
      137
    ).double(d.max), d.help != null && Object.hasOwnProperty.call(d, "help") && k.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(d.help), d.value != null && Object.hasOwnProperty.call(d, "value") && k.uint32(
      /* id 19, wireType 1 =*/
      153
    ).double(d.value), d.setValue != null && Object.hasOwnProperty.call(d, "setValue") && k.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(d.setValue), d.disabled != null && Object.hasOwnProperty.call(d, "disabled") && k.uint32(
      /* id 21, wireType 0 =*/
      168
    ).bool(d.disabled), d.labelVisibility != null && Object.hasOwnProperty.call(d, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(d.labelVisibility, k.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), d.placeholder != null && Object.hasOwnProperty.call(d, "placeholder") && k.uint32(
      /* id 23, wireType 2 =*/
      186
    ).string(d.placeholder), d.icon != null && Object.hasOwnProperty.call(d, "icon") && k.uint32(
      /* id 24, wireType 2 =*/
      194
    ).string(d.icon), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.NumberInput();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.id = d.string();
          break;
        }
        case 2: {
          gA.label = d.string();
          break;
        }
        case 3: {
          gA.formId = d.string();
          break;
        }
        case 8: {
          gA.format = d.string();
          break;
        }
        case 11: {
          gA.hasMin = d.bool();
          break;
        }
        case 12: {
          gA.hasMax = d.bool();
          break;
        }
        case 13: {
          gA.dataType = d.int32();
          break;
        }
        case 14: {
          gA.default = d.double();
          break;
        }
        case 15: {
          gA.step = d.double();
          break;
        }
        case 16: {
          gA.min = d.double();
          break;
        }
        case 17: {
          gA.max = d.double();
          break;
        }
        case 18: {
          gA.help = d.string();
          break;
        }
        case 19: {
          gA.value = d.double();
          break;
        }
        case 20: {
          gA.setValue = d.bool();
          break;
        }
        case 21: {
          gA.disabled = d.bool();
          break;
        }
        case 22: {
          gA.labelVisibility = $root$1.LabelVisibilityMessage.decode(d, d.uint32());
          break;
        }
        case 23: {
          gA.placeholder = d.string();
          break;
        }
        case 24: {
          gA.icon = d.string();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.label != null && d.hasOwnProperty("label") && !$util$1.isString(d.label)) return "label: string expected";
    if (d.formId != null && d.hasOwnProperty("formId") && !$util$1.isString(d.formId)) return "formId: string expected";
    if (d.format != null && d.hasOwnProperty("format") && !$util$1.isString(d.format)) return "format: string expected";
    if (d.hasMin != null && d.hasOwnProperty("hasMin") && typeof d.hasMin != "boolean") return "hasMin: boolean expected";
    if (d.hasMax != null && d.hasOwnProperty("hasMax") && typeof d.hasMax != "boolean") return "hasMax: boolean expected";
    if (d.dataType != null && d.hasOwnProperty("dataType")) switch (d.dataType) {
      default:
        return "dataType: enum value expected";
      case 0:
      case 1:
        break;
    }
    if (d.default != null && d.hasOwnProperty("default") && typeof d.default != "number")
      return "default: number expected";
    if (d.step != null && d.hasOwnProperty("step") && typeof d.step != "number") return "step: number expected";
    if (d.min != null && d.hasOwnProperty("min") && typeof d.min != "number") return "min: number expected";
    if (d.max != null && d.hasOwnProperty("max") && typeof d.max != "number") return "max: number expected";
    if (d.help != null && d.hasOwnProperty("help") && !$util$1.isString(d.help)) return "help: string expected";
    if (d.value != null && d.hasOwnProperty("value") && typeof d.value != "number")
      return "value: number expected";
    if (d.setValue != null && d.hasOwnProperty("setValue") && typeof d.setValue != "boolean") return "setValue: boolean expected";
    if (d.disabled != null && d.hasOwnProperty("disabled") && typeof d.disabled != "boolean") return "disabled: boolean expected";
    if (d.labelVisibility != null && d.hasOwnProperty("labelVisibility")) {
      let k = $root$1.LabelVisibilityMessage.verify(d.labelVisibility);
      if (k) return "labelVisibility." + k;
    }
    return d.placeholder != null && d.hasOwnProperty("placeholder") && !$util$1.isString(d.placeholder) ? "placeholder: string expected" : d.icon != null && d.hasOwnProperty("icon") && !$util$1.isString(d.icon) ? "icon: string expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.NumberInput) return d;
    let k = new $root$1.NumberInput();
    switch (d.id != null && (k.id = String(d.id)), d.label != null && (k.label = String(d.label)), d.formId != null && (k.formId = String(d.formId)), d.format != null && (k.format = String(d.format)), d.hasMin != null && (k.hasMin = !!d.hasMin), d.hasMax != null && (k.hasMax = !!d.hasMax), d.dataType) {
      default:
        if (typeof d.dataType == "number") {
          k.dataType = d.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        k.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        k.dataType = 1;
        break;
    }
    if (d.default != null && (k.default = Number(d.default)), d.step != null && (k.step = Number(d.step)), d.min != null && (k.min = Number(d.min)), d.max != null && (k.max = Number(d.max)), d.help != null && (k.help = String(d.help)), d.value != null && (k.value = Number(d.value)), d.setValue != null && (k.setValue = !!d.setValue), d.disabled != null && (k.disabled = !!d.disabled), d.labelVisibility != null) {
      if (typeof d.labelVisibility != "object") throw TypeError(".NumberInput.labelVisibility: object expected");
      k.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(d.labelVisibility);
    }
    return d.placeholder != null && (k.placeholder = String(d.placeholder)), d.icon != null && (k.icon = String(d.icon)), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.id = "", H.label = "", H.formId = "", H.format = "", H.hasMin = !1, H.hasMax = !1, H.dataType = k.enums === String ? "INT" : 0, H.step = 0, H.min = 0, H.max = 0, H.help = "", H.setValue = !1, H.disabled = !1, H.labelVisibility = null, H.placeholder = "", H.icon = ""), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.label != null && d.hasOwnProperty("label") && (H.label = d.label), d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.format != null && d.hasOwnProperty("format") && (H.format = d.format), d.hasMin != null && d.hasOwnProperty("hasMin") && (H.hasMin = d.hasMin), d.hasMax != null && d.hasOwnProperty("hasMax") && (H.hasMax = d.hasMax), d.dataType != null && d.hasOwnProperty("dataType") && (H.dataType = k.enums === String ? $root$1.NumberInput.DataType[d.dataType] === void 0 ? d.dataType : $root$1.NumberInput.DataType[d.dataType] : d.dataType), d.default != null && d.hasOwnProperty("default") && (H.default = k.json && !isFinite(d.default) ? String(d.default) : d.default, k.oneofs && (H._default = "default")), d.step != null && d.hasOwnProperty("step") && (H.step = k.json && !isFinite(d.step) ? String(d.step) : d.step), d.min != null && d.hasOwnProperty("min") && (H.min = k.json && !isFinite(d.min) ? String(d.min) : d.min), d.max != null && d.hasOwnProperty("max") && (H.max = k.json && !isFinite(d.max) ? String(d.max) : d.max), d.help != null && d.hasOwnProperty("help") && (H.help = d.help), d.value != null && d.hasOwnProperty("value") && (H.value = k.json && !isFinite(d.value) ? String(d.value) : d.value, k.oneofs && (H._value = "value")), d.setValue != null && d.hasOwnProperty("setValue") && (H.setValue = d.setValue), d.disabled != null && d.hasOwnProperty("disabled") && (H.disabled = d.disabled), d.labelVisibility != null && d.hasOwnProperty("labelVisibility") && (H.labelVisibility = $root$1.LabelVisibilityMessage.toObject(d.labelVisibility, k)), d.placeholder != null && d.hasOwnProperty("placeholder") && (H.placeholder = d.placeholder), d.icon != null && d.hasOwnProperty("icon") && (H.icon = d.icon), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/NumberInput";
  }, n.DataType = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "INT"] = 0, d[g[1] = "FLOAT"] = 1, d;
  })(), n;
})(), Markdown$3 = $root$1.Markdown = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.body = "", n.prototype.allowHtml = !1, n.prototype.isCaption = !1, n.prototype.elementType = 0, n.prototype.help = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.allowHtml != null && Object.hasOwnProperty.call(g, "allowHtml") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.allowHtml), g.isCaption != null && Object.hasOwnProperty.call(g, "isCaption") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.isCaption), g.elementType != null && Object.hasOwnProperty.call(g, "elementType") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(g.elementType), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Markdown();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.body = g.string();
          break;
        }
        case 2: {
          AA.allowHtml = g.bool();
          break;
        }
        case 3: {
          AA.isCaption = g.bool();
          break;
        }
        case 4: {
          AA.elementType = g.int32();
          break;
        }
        case 5: {
          AA.help = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.body != null && g.hasOwnProperty("body") && !$util$1.isString(g.body)) return "body: string expected";
    if (g.allowHtml != null && g.hasOwnProperty("allowHtml") && typeof g.allowHtml != "boolean") return "allowHtml: boolean expected";
    if (g.isCaption != null && g.hasOwnProperty("isCaption") && typeof g.isCaption != "boolean") return "isCaption: boolean expected";
    if (g.elementType != null && g.hasOwnProperty("elementType")) switch (g.elementType) {
      default:
        return "elementType: enum value expected";
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
    }
    return g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help) ? "help: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Markdown) return g;
    let d = new $root$1.Markdown();
    switch (g.body != null && (d.body = String(g.body)), g.allowHtml != null && (d.allowHtml = !!g.allowHtml), g.isCaption != null && (d.isCaption = !!g.isCaption), g.elementType) {
      default:
        if (typeof g.elementType == "number") {
          d.elementType = g.elementType;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        d.elementType = 0;
        break;
      case "NATIVE":
      case 1:
        d.elementType = 1;
        break;
      case "CAPTION":
      case 2:
        d.elementType = 2;
        break;
      case "CODE":
      case 3:
        d.elementType = 3;
        break;
      case "LATEX":
      case 4:
        d.elementType = 4;
        break;
      case "DIVIDER":
      case 5:
        d.elementType = 5;
        break;
    }
    return g.help != null && (d.help = String(g.help)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.body = "", k.allowHtml = !1, k.isCaption = !1, k.elementType = d.enums === String ? "UNSPECIFIED" : 0, k.help = ""), g.body != null && g.hasOwnProperty("body") && (k.body = g.body), g.allowHtml != null && g.hasOwnProperty("allowHtml") && (k.allowHtml = g.allowHtml), g.isCaption != null && g.hasOwnProperty("isCaption") && (k.isCaption = g.isCaption), g.elementType != null && g.hasOwnProperty("elementType") && (k.elementType = d.enums === String ? $root$1.Markdown.Type[g.elementType] === void 0 ? g.elementType : $root$1.Markdown.Type[g.elementType] : g.elementType), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Markdown";
  }, n.Type = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "UNSPECIFIED"] = 0, g[t[1] = "NATIVE"] = 1, g[t[2] = "CAPTION"] = 2, g[t[3] = "CODE"] = 3, g[t[4] = "LATEX"] = 4, g[t[5] = "DIVIDER"] = 5, g;
  })(), n;
})(), Metric$2 = $root$1.Metric = (() => {
  function n(t) {
    if (this.chartData = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.label = "", n.prototype.body = "", n.prototype.delta = "", n.prototype.direction = 0, n.prototype.color = 0, n.prototype.help = "", n.prototype.labelVisibility = null, n.prototype.showBorder = !1, n.prototype.chartData = $util$1.emptyArray, n.prototype.chartType = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.label), g.body != null && Object.hasOwnProperty.call(g, "body") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.body), g.delta != null && Object.hasOwnProperty.call(g, "delta") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.delta), g.direction != null && Object.hasOwnProperty.call(g, "direction") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(g.direction), g.color != null && Object.hasOwnProperty.call(g, "color") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.color), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.help), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.showBorder != null && Object.hasOwnProperty.call(g, "showBorder") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.showBorder), g.chartData != null && g.chartData.length) {
      d.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let k = 0; k < g.chartData.length; ++k) d.double(g.chartData[k]);
      d.ldelim();
    }
    return g.chartType != null && Object.hasOwnProperty.call(g, "chartType") && d.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(g.chartType), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Metric();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.label = g.string();
          break;
        }
        case 2: {
          AA.body = g.string();
          break;
        }
        case 3: {
          AA.delta = g.string();
          break;
        }
        case 4: {
          AA.direction = g.int32();
          break;
        }
        case 5: {
          AA.color = g.int32();
          break;
        }
        case 6: {
          AA.help = g.string();
          break;
        }
        case 7: {
          AA.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 8: {
          AA.showBorder = g.bool();
          break;
        }
        case 9: {
          if (AA.chartData && AA.chartData.length || (AA.chartData = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.chartData.push(g.double());
          } else AA.chartData.push(g.double());
          break;
        }
        case 10: {
          AA.chartType = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util$1.isString(g.label)) return "label: string expected";
    if (g.body != null && g.hasOwnProperty("body") && !$util$1.isString(g.body)) return "body: string expected";
    if (g.delta != null && g.hasOwnProperty("delta") && !$util$1.isString(g.delta)) return "delta: string expected";
    if (g.direction != null && g.hasOwnProperty("direction")) switch (g.direction) {
      default:
        return "direction: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (g.color != null && g.hasOwnProperty("color")) switch (g.color) {
      default:
        return "color: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help)) return "help: string expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root$1.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    if (g.showBorder != null && g.hasOwnProperty("showBorder") && typeof g.showBorder != "boolean") return "showBorder: boolean expected";
    if (g.chartData != null && g.hasOwnProperty("chartData")) {
      if (!Array.isArray(g.chartData)) return "chartData: array expected";
      for (let d = 0; d < g.chartData.length; ++d) if (typeof g.chartData[d] != "number") return "chartData: number[] expected";
    }
    if (g.chartType != null && g.hasOwnProperty("chartType")) switch (g.chartType) {
      default:
        return "chartType: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Metric) return g;
    let d = new $root$1.Metric();
    switch (g.label != null && (d.label = String(g.label)), g.body != null && (d.body = String(g.body)), g.delta != null && (d.delta = String(g.delta)), g.direction) {
      default:
        if (typeof g.direction == "number") {
          d.direction = g.direction;
          break;
        }
        break;
      case "DOWN":
      case 0:
        d.direction = 0;
        break;
      case "UP":
      case 1:
        d.direction = 1;
        break;
      case "NONE":
      case 2:
        d.direction = 2;
        break;
    }
    switch (g.color) {
      default:
        if (typeof g.color == "number") {
          d.color = g.color;
          break;
        }
        break;
      case "RED":
      case 0:
        d.color = 0;
        break;
      case "GREEN":
      case 1:
        d.color = 1;
        break;
      case "GRAY":
      case 2:
        d.color = 2;
        break;
    }
    if (g.help != null && (d.help = String(g.help)), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".Metric.labelVisibility: object expected");
      d.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    if (g.showBorder != null && (d.showBorder = !!g.showBorder), g.chartData) {
      if (!Array.isArray(g.chartData)) throw TypeError(".Metric.chartData: array expected");
      d.chartData = [];
      for (let k = 0; k < g.chartData.length; ++k) d.chartData[k] = Number(g.chartData[k]);
    }
    switch (g.chartType) {
      default:
        if (typeof g.chartType == "number") {
          d.chartType = g.chartType;
          break;
        }
        break;
      case "LINE":
      case 0:
        d.chartType = 0;
        break;
      case "BAR":
      case 1:
        d.chartType = 1;
        break;
      case "AREA":
      case 2:
        d.chartType = 2;
        break;
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.chartData = []), d.defaults && (k.label = "", k.body = "", k.delta = "", k.direction = d.enums === String ? "DOWN" : 0, k.color = d.enums === String ? "RED" : 0, k.help = "", k.labelVisibility = null, k.showBorder = !1, k.chartType = d.enums === String ? "LINE" : 0), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.body != null && g.hasOwnProperty("body") && (k.body = g.body), g.delta != null && g.hasOwnProperty("delta") && (k.delta = g.delta), g.direction != null && g.hasOwnProperty("direction") && (k.direction = d.enums === String ? $root$1.Metric.MetricDirection[g.direction] === void 0 ? g.direction : $root$1.Metric.MetricDirection[g.direction] : g.direction), g.color != null && g.hasOwnProperty("color") && (k.color = d.enums === String ? $root$1.Metric.MetricColor[g.color] === void 0 ? g.color : $root$1.Metric.MetricColor[g.color] : g.color), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.showBorder != null && g.hasOwnProperty("showBorder") && (k.showBorder = g.showBorder), g.chartData && g.chartData.length) {
      k.chartData = [];
      for (let H = 0; H < g.chartData.length; ++H) k.chartData[H] = d.json && !isFinite(g.chartData[H]) ? String(g.chartData[H]) : g.chartData[H];
    }
    return g.chartType != null && g.hasOwnProperty("chartType") && (k.chartType = d.enums === String ? $root$1.Metric.ChartType[g.chartType] === void 0 ? g.chartType : $root$1.Metric.ChartType[g.chartType] : g.chartType), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Metric";
  }, n.MetricDirection = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "DOWN"] = 0, g[t[1] = "UP"] = 1, g[t[2] = "NONE"] = 2, g;
  })(), n.MetricColor = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "RED"] = 0, g[t[1] = "GREEN"] = 1, g[t[2] = "GRAY"] = 2, g;
  })(), n.ChartType = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "LINE"] = 0, g[t[1] = "BAR"] = 1, g[t[2] = "AREA"] = 2, g;
  })(), n;
})();
$root$1.MultiSelect = (() => {
  function n(g) {
    if (this.default = [], this.options = [], this.value = [], this.rawValues = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.default = $util$1.emptyArray, n.prototype.options = $util$1.emptyArray, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = $util$1.emptyArray, n.prototype.rawValues = $util$1.emptyArray, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.maxSelections = 0, n.prototype.placeholder = "", n.prototype.acceptNewOptions = null;
  let t;
  return Object.defineProperty(n.prototype, "_acceptNewOptions", { get: $util$1.oneOfGetter(t = ["acceptNewOptions"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    if (k || (k = $Writer$1.create()), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.id), d.label != null && Object.hasOwnProperty.call(d, "label") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.label), d.default != null && d.default.length) {
      k.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let H = 0; H < d.default.length; ++H) k.int32(d.default[H]);
      k.ldelim();
    }
    if (d.options != null && d.options.length) for (let H = 0; H < d.options.length; ++H) k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(d.options[H]);
    if (d.help != null && Object.hasOwnProperty.call(d, "help") && k.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(d.help), d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.formId), d.value != null && d.value.length) {
      k.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let H = 0; H < d.value.length; ++H) k.int32(d.value[H]);
      k.ldelim();
    }
    if (d.setValue != null && Object.hasOwnProperty.call(d, "setValue") && k.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(d.setValue), d.disabled != null && Object.hasOwnProperty.call(d, "disabled") && k.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(d.disabled), d.labelVisibility != null && Object.hasOwnProperty.call(d, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(d.labelVisibility, k.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), d.maxSelections != null && Object.hasOwnProperty.call(d, "maxSelections") && k.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(d.maxSelections), d.placeholder != null && Object.hasOwnProperty.call(d, "placeholder") && k.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(d.placeholder), d.acceptNewOptions != null && Object.hasOwnProperty.call(d, "acceptNewOptions") && k.uint32(
      /* id 13, wireType 0 =*/
      104
    ).bool(d.acceptNewOptions), d.rawValues != null && d.rawValues.length) for (let H = 0; H < d.rawValues.length; ++H) k.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(d.rawValues[H]);
    return k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.MultiSelect();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.id = d.string();
          break;
        }
        case 2: {
          gA.label = d.string();
          break;
        }
        case 3: {
          if (gA.default && gA.default.length || (gA.default = []), (IA & 7) === 2) {
            let CA = d.uint32() + d.pos;
            for (; d.pos < CA; ) gA.default.push(d.int32());
          } else gA.default.push(d.int32());
          break;
        }
        case 4: {
          gA.options && gA.options.length || (gA.options = []), gA.options.push(d.string());
          break;
        }
        case 5: {
          gA.help = d.string();
          break;
        }
        case 6: {
          gA.formId = d.string();
          break;
        }
        case 7: {
          if (gA.value && gA.value.length || (gA.value = []), (IA & 7) === 2) {
            let CA = d.uint32() + d.pos;
            for (; d.pos < CA; ) gA.value.push(d.int32());
          } else gA.value.push(d.int32());
          break;
        }
        case 14: {
          gA.rawValues && gA.rawValues.length || (gA.rawValues = []), gA.rawValues.push(d.string());
          break;
        }
        case 8: {
          gA.setValue = d.bool();
          break;
        }
        case 9: {
          gA.disabled = d.bool();
          break;
        }
        case 10: {
          gA.labelVisibility = $root$1.LabelVisibilityMessage.decode(d, d.uint32());
          break;
        }
        case 11: {
          gA.maxSelections = d.int32();
          break;
        }
        case 12: {
          gA.placeholder = d.string();
          break;
        }
        case 13: {
          gA.acceptNewOptions = d.bool();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.label != null && d.hasOwnProperty("label") && !$util$1.isString(d.label)) return "label: string expected";
    if (d.default != null && d.hasOwnProperty("default")) {
      if (!Array.isArray(d.default)) return "default: array expected";
      for (let k = 0; k < d.default.length; ++k) if (!$util$1.isInteger(d.default[k])) return "default: integer[] expected";
    }
    if (d.options != null && d.hasOwnProperty("options")) {
      if (!Array.isArray(d.options)) return "options: array expected";
      for (let k = 0; k < d.options.length; ++k) if (!$util$1.isString(d.options[k])) return "options: string[] expected";
    }
    if (d.help != null && d.hasOwnProperty("help") && !$util$1.isString(d.help)) return "help: string expected";
    if (d.formId != null && d.hasOwnProperty("formId") && !$util$1.isString(d.formId)) return "formId: string expected";
    if (d.value != null && d.hasOwnProperty("value")) {
      if (!Array.isArray(d.value)) return "value: array expected";
      for (let k = 0; k < d.value.length; ++k) if (!$util$1.isInteger(d.value[k])) return "value: integer[] expected";
    }
    if (d.rawValues != null && d.hasOwnProperty("rawValues")) {
      if (!Array.isArray(d.rawValues)) return "rawValues: array expected";
      for (let k = 0; k < d.rawValues.length; ++k) if (!$util$1.isString(d.rawValues[k])) return "rawValues: string[] expected";
    }
    if (d.setValue != null && d.hasOwnProperty("setValue") && typeof d.setValue != "boolean") return "setValue: boolean expected";
    if (d.disabled != null && d.hasOwnProperty("disabled") && typeof d.disabled != "boolean") return "disabled: boolean expected";
    if (d.labelVisibility != null && d.hasOwnProperty("labelVisibility")) {
      let k = $root$1.LabelVisibilityMessage.verify(d.labelVisibility);
      if (k) return "labelVisibility." + k;
    }
    return d.maxSelections != null && d.hasOwnProperty("maxSelections") && !$util$1.isInteger(d.maxSelections) ? "maxSelections: integer expected" : d.placeholder != null && d.hasOwnProperty("placeholder") && !$util$1.isString(d.placeholder) ? "placeholder: string expected" : d.acceptNewOptions != null && d.hasOwnProperty("acceptNewOptions") && typeof d.acceptNewOptions != "boolean" ? "acceptNewOptions: boolean expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.MultiSelect) return d;
    let k = new $root$1.MultiSelect();
    if (d.id != null && (k.id = String(d.id)), d.label != null && (k.label = String(d.label)), d.default) {
      if (!Array.isArray(d.default)) throw TypeError(".MultiSelect.default: array expected");
      k.default = [];
      for (let H = 0; H < d.default.length; ++H) k.default[H] = d.default[H] | 0;
    }
    if (d.options) {
      if (!Array.isArray(d.options)) throw TypeError(".MultiSelect.options: array expected");
      k.options = [];
      for (let H = 0; H < d.options.length; ++H) k.options[H] = String(d.options[H]);
    }
    if (d.help != null && (k.help = String(d.help)), d.formId != null && (k.formId = String(d.formId)), d.value) {
      if (!Array.isArray(d.value)) throw TypeError(".MultiSelect.value: array expected");
      k.value = [];
      for (let H = 0; H < d.value.length; ++H) k.value[H] = d.value[H] | 0;
    }
    if (d.rawValues) {
      if (!Array.isArray(d.rawValues)) throw TypeError(".MultiSelect.rawValues: array expected");
      k.rawValues = [];
      for (let H = 0; H < d.rawValues.length; ++H) k.rawValues[H] = String(d.rawValues[H]);
    }
    if (d.setValue != null && (k.setValue = !!d.setValue), d.disabled != null && (k.disabled = !!d.disabled), d.labelVisibility != null) {
      if (typeof d.labelVisibility != "object") throw TypeError(".MultiSelect.labelVisibility: object expected");
      k.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(d.labelVisibility);
    }
    return d.maxSelections != null && (k.maxSelections = d.maxSelections | 0), d.placeholder != null && (k.placeholder = String(d.placeholder)), d.acceptNewOptions != null && (k.acceptNewOptions = !!d.acceptNewOptions), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    if ((k.arrays || k.defaults) && (H.default = [], H.options = [], H.value = [], H.rawValues = []), k.defaults && (H.id = "", H.label = "", H.help = "", H.formId = "", H.setValue = !1, H.disabled = !1, H.labelVisibility = null, H.maxSelections = 0, H.placeholder = ""), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.label != null && d.hasOwnProperty("label") && (H.label = d.label), d.default && d.default.length) {
      H.default = [];
      for (let AA = 0; AA < d.default.length; ++AA) H.default[AA] = d.default[AA];
    }
    if (d.options && d.options.length) {
      H.options = [];
      for (let AA = 0; AA < d.options.length; ++AA) H.options[AA] = d.options[AA];
    }
    if (d.help != null && d.hasOwnProperty("help") && (H.help = d.help), d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.value && d.value.length) {
      H.value = [];
      for (let AA = 0; AA < d.value.length; ++AA) H.value[AA] = d.value[AA];
    }
    if (d.setValue != null && d.hasOwnProperty("setValue") && (H.setValue = d.setValue), d.disabled != null && d.hasOwnProperty("disabled") && (H.disabled = d.disabled), d.labelVisibility != null && d.hasOwnProperty("labelVisibility") && (H.labelVisibility = $root$1.LabelVisibilityMessage.toObject(d.labelVisibility, k)), d.maxSelections != null && d.hasOwnProperty("maxSelections") && (H.maxSelections = d.maxSelections), d.placeholder != null && d.hasOwnProperty("placeholder") && (H.placeholder = d.placeholder), d.acceptNewOptions != null && d.hasOwnProperty("acceptNewOptions") && (H.acceptNewOptions = d.acceptNewOptions, k.oneofs && (H._acceptNewOptions = "acceptNewOptions")), d.rawValues && d.rawValues.length) {
      H.rawValues = [];
      for (let AA = 0; AA < d.rawValues.length; ++AA) H.rawValues[AA] = d.rawValues[AA];
    }
    return H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/MultiSelect";
  }, n;
})();
$root$1.PageLink = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.page = "", n.prototype.label = "", n.prototype.icon = "", n.prototype.pageScriptHash = "", n.prototype.help = "", n.prototype.useContainerWidth = null, n.prototype.disabled = !1, n.prototype.external = !1;
  let t;
  return Object.defineProperty(n.prototype, "_useContainerWidth", { get: $util$1.oneOfGetter(t = ["useContainerWidth"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.page != null && Object.hasOwnProperty.call(d, "page") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.page), d.label != null && Object.hasOwnProperty.call(d, "label") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.label), d.icon != null && Object.hasOwnProperty.call(d, "icon") && k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(d.icon), d.pageScriptHash != null && Object.hasOwnProperty.call(d, "pageScriptHash") && k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(d.pageScriptHash), d.help != null && Object.hasOwnProperty.call(d, "help") && k.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(d.help), d.useContainerWidth != null && Object.hasOwnProperty.call(d, "useContainerWidth") && k.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(d.useContainerWidth), d.disabled != null && Object.hasOwnProperty.call(d, "disabled") && k.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(d.disabled), d.external != null && Object.hasOwnProperty.call(d, "external") && k.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(d.external), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.PageLink();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.page = d.string();
          break;
        }
        case 2: {
          gA.label = d.string();
          break;
        }
        case 3: {
          gA.icon = d.string();
          break;
        }
        case 4: {
          gA.pageScriptHash = d.string();
          break;
        }
        case 5: {
          gA.help = d.string();
          break;
        }
        case 6: {
          gA.useContainerWidth = d.bool();
          break;
        }
        case 7: {
          gA.disabled = d.bool();
          break;
        }
        case 8: {
          gA.external = d.bool();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    return typeof d != "object" || d === null ? "object expected" : d.page != null && d.hasOwnProperty("page") && !$util$1.isString(d.page) ? "page: string expected" : d.label != null && d.hasOwnProperty("label") && !$util$1.isString(d.label) ? "label: string expected" : d.icon != null && d.hasOwnProperty("icon") && !$util$1.isString(d.icon) ? "icon: string expected" : d.pageScriptHash != null && d.hasOwnProperty("pageScriptHash") && !$util$1.isString(d.pageScriptHash) ? "pageScriptHash: string expected" : d.help != null && d.hasOwnProperty("help") && !$util$1.isString(d.help) ? "help: string expected" : d.useContainerWidth != null && d.hasOwnProperty("useContainerWidth") && typeof d.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : d.disabled != null && d.hasOwnProperty("disabled") && typeof d.disabled != "boolean" ? "disabled: boolean expected" : d.external != null && d.hasOwnProperty("external") && typeof d.external != "boolean" ? "external: boolean expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.PageLink) return d;
    let k = new $root$1.PageLink();
    return d.page != null && (k.page = String(d.page)), d.label != null && (k.label = String(d.label)), d.icon != null && (k.icon = String(d.icon)), d.pageScriptHash != null && (k.pageScriptHash = String(d.pageScriptHash)), d.help != null && (k.help = String(d.help)), d.useContainerWidth != null && (k.useContainerWidth = !!d.useContainerWidth), d.disabled != null && (k.disabled = !!d.disabled), d.external != null && (k.external = !!d.external), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.page = "", H.label = "", H.icon = "", H.pageScriptHash = "", H.help = "", H.disabled = !1, H.external = !1), d.page != null && d.hasOwnProperty("page") && (H.page = d.page), d.label != null && d.hasOwnProperty("label") && (H.label = d.label), d.icon != null && d.hasOwnProperty("icon") && (H.icon = d.icon), d.pageScriptHash != null && d.hasOwnProperty("pageScriptHash") && (H.pageScriptHash = d.pageScriptHash), d.help != null && d.hasOwnProperty("help") && (H.help = d.help), d.useContainerWidth != null && d.hasOwnProperty("useContainerWidth") && (H.useContainerWidth = d.useContainerWidth, k.oneofs && (H._useContainerWidth = "useContainerWidth")), d.disabled != null && d.hasOwnProperty("disabled") && (H.disabled = d.disabled), d.external != null && d.hasOwnProperty("external") && (H.external = d.external), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/PageLink";
  }, n;
})();
const PlotlyChart$1 = $root$1.PlotlyChart = (() => {
  function n(g) {
    if (this.selectionMode = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.useContainerWidth = !1, n.prototype.theme = "", n.prototype.id = "", n.prototype.selectionMode = $util$1.emptyArray, n.prototype.formId = "", n.prototype.spec = "", n.prototype.config = "", n.prototype.url = null, n.prototype.figure = null;
  let t;
  return Object.defineProperty(n.prototype, "chart", { get: $util$1.oneOfGetter(t = ["url", "figure"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    if (k || (k = $Writer$1.create()), d.url != null && Object.hasOwnProperty.call(d, "url") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.url), d.figure != null && Object.hasOwnProperty.call(d, "figure") && $root$1.Figure.encode(d.figure, k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), d.useContainerWidth != null && Object.hasOwnProperty.call(d, "useContainerWidth") && k.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(d.useContainerWidth), d.theme != null && Object.hasOwnProperty.call(d, "theme") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.theme), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(d.id), d.selectionMode != null && d.selectionMode.length) {
      k.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork();
      for (let H = 0; H < d.selectionMode.length; ++H) k.int32(d.selectionMode[H]);
      k.ldelim();
    }
    return d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(d.formId), d.spec != null && Object.hasOwnProperty.call(d, "spec") && k.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(d.spec), d.config != null && Object.hasOwnProperty.call(d, "config") && k.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(d.config), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.PlotlyChart();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 5: {
          gA.useContainerWidth = d.bool();
          break;
        }
        case 6: {
          gA.theme = d.string();
          break;
        }
        case 7: {
          gA.id = d.string();
          break;
        }
        case 8: {
          if (gA.selectionMode && gA.selectionMode.length || (gA.selectionMode = []), (IA & 7) === 2) {
            let CA = d.uint32() + d.pos;
            for (; d.pos < CA; ) gA.selectionMode.push(d.int32());
          } else gA.selectionMode.push(d.int32());
          break;
        }
        case 9: {
          gA.formId = d.string();
          break;
        }
        case 10: {
          gA.spec = d.string();
          break;
        }
        case 11: {
          gA.config = d.string();
          break;
        }
        case 1: {
          gA.url = d.string();
          break;
        }
        case 2: {
          gA.figure = $root$1.Figure.decode(d, d.uint32());
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.useContainerWidth != null && d.hasOwnProperty("useContainerWidth") && typeof d.useContainerWidth != "boolean") return "useContainerWidth: boolean expected";
    if (d.theme != null && d.hasOwnProperty("theme") && !$util$1.isString(d.theme)) return "theme: string expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.selectionMode != null && d.hasOwnProperty("selectionMode")) {
      if (!Array.isArray(d.selectionMode)) return "selectionMode: array expected";
      for (let H = 0; H < d.selectionMode.length; ++H) switch (d.selectionMode[H]) {
        default:
          return "selectionMode: enum value[] expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    }
    if (d.formId != null && d.hasOwnProperty("formId") && !$util$1.isString(d.formId)) return "formId: string expected";
    if (d.spec != null && d.hasOwnProperty("spec") && !$util$1.isString(d.spec)) return "spec: string expected";
    if (d.config != null && d.hasOwnProperty("config") && !$util$1.isString(d.config)) return "config: string expected";
    if (d.url != null && d.hasOwnProperty("url") && (k.chart = 1, !$util$1.isString(d.url)))
      return "url: string expected";
    if (d.figure != null && d.hasOwnProperty("figure")) {
      if (k.chart === 1) return "chart: multiple values";
      k.chart = 1;
      {
        let H = $root$1.Figure.verify(d.figure);
        if (H) return "figure." + H;
      }
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.PlotlyChart) return d;
    let k = new $root$1.PlotlyChart();
    if (d.useContainerWidth != null && (k.useContainerWidth = !!d.useContainerWidth), d.theme != null && (k.theme = String(d.theme)), d.id != null && (k.id = String(d.id)), d.selectionMode) {
      if (!Array.isArray(d.selectionMode)) throw TypeError(".PlotlyChart.selectionMode: array expected");
      k.selectionMode = [];
      for (let H = 0; H < d.selectionMode.length; ++H) switch (d.selectionMode[H]) {
        default:
          if (typeof d.selectionMode[H] == "number") {
            k.selectionMode[H] = d.selectionMode[H];
            break;
          }
        case "POINTS":
        case 0:
          k.selectionMode[H] = 0;
          break;
        case "BOX":
        case 1:
          k.selectionMode[H] = 1;
          break;
        case "LASSO":
        case 2:
          k.selectionMode[H] = 2;
          break;
      }
    }
    if (d.formId != null && (k.formId = String(d.formId)), d.spec != null && (k.spec = String(d.spec)), d.config != null && (k.config = String(d.config)), d.url != null && (k.url = String(d.url)), d.figure != null) {
      if (typeof d.figure != "object") throw TypeError(".PlotlyChart.figure: object expected");
      k.figure = $root$1.Figure.fromObject(d.figure);
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    if ((k.arrays || k.defaults) && (H.selectionMode = []), k.defaults && (H.useContainerWidth = !1, H.theme = "", H.id = "", H.formId = "", H.spec = "", H.config = ""), d.url != null && d.hasOwnProperty("url") && (H.url = d.url, k.oneofs && (H.chart = "url")), d.figure != null && d.hasOwnProperty("figure") && (H.figure = $root$1.Figure.toObject(d.figure, k), k.oneofs && (H.chart = "figure")), d.useContainerWidth != null && d.hasOwnProperty("useContainerWidth") && (H.useContainerWidth = d.useContainerWidth), d.theme != null && d.hasOwnProperty("theme") && (H.theme = d.theme), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.selectionMode && d.selectionMode.length) {
      H.selectionMode = [];
      for (let AA = 0; AA < d.selectionMode.length; ++AA) H.selectionMode[AA] = k.enums === String ? $root$1.PlotlyChart.SelectionMode[d.selectionMode[AA]] === void 0 ? d.selectionMode[AA] : $root$1.PlotlyChart.SelectionMode[d.selectionMode[AA]] : d.selectionMode[AA];
    }
    return d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.spec != null && d.hasOwnProperty("spec") && (H.spec = d.spec), d.config != null && d.hasOwnProperty("config") && (H.config = d.config), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/PlotlyChart";
  }, n.SelectionMode = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "POINTS"] = 0, d[g[1] = "BOX"] = 1, d[g[2] = "LASSO"] = 2, d;
  })(), n;
})();
$root$1.Figure = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.spec = "", n.prototype.config = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.spec != null && Object.hasOwnProperty.call(g, "spec") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.spec), g.config != null && Object.hasOwnProperty.call(g, "config") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.config), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Figure();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.spec = g.string();
          break;
        }
        case 2: {
          AA.config = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.spec != null && g.hasOwnProperty("spec") && !$util$1.isString(g.spec) ? "spec: string expected" : g.config != null && g.hasOwnProperty("config") && !$util$1.isString(g.config) ? "config: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Figure) return g;
    let d = new $root$1.Figure();
    return g.spec != null && (d.spec = String(g.spec)), g.config != null && (d.config = String(g.config)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.spec = "", k.config = ""), g.spec != null && g.hasOwnProperty("spec") && (k.spec = g.spec), g.config != null && g.hasOwnProperty("config") && (k.config = g.config), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Figure";
  }, n;
})();
$root$1.Progress = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.value = 0, n.prototype.text = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(g.value), g.text != null && Object.hasOwnProperty.call(g, "text") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.text), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Progress();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.value = g.uint32();
          break;
        }
        case 2: {
          AA.text = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.value != null && g.hasOwnProperty("value") && !$util$1.isInteger(g.value) ? "value: integer expected" : g.text != null && g.hasOwnProperty("text") && !$util$1.isString(g.text) ? "text: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Progress) return g;
    let d = new $root$1.Progress();
    return g.value != null && (d.value = g.value >>> 0), g.text != null && (d.text = String(g.text)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.value = 0, k.text = ""), g.value != null && g.hasOwnProperty("value") && (k.value = g.value), g.text != null && g.hasOwnProperty("text") && (k.text = g.text), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Progress";
  }, n;
})();
$root$1.Snow = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.show = !1, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.show != null && Object.hasOwnProperty.call(g, "show") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(g.show), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Snow();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.show = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.show != null && g.hasOwnProperty("show") && typeof g.show != "boolean" ? "show: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Snow) return g;
    let d = new $root$1.Snow();
    return g.show != null && (d.show = !!g.show), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.show = !1), g.show != null && g.hasOwnProperty("show") && (k.show = g.show), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Snow";
  }, n;
})();
$root$1.Spinner = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.text = "", n.prototype.cache = !1, n.prototype.showTime = !1, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.text != null && Object.hasOwnProperty.call(g, "text") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.text), g.cache != null && Object.hasOwnProperty.call(g, "cache") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.cache), g.showTime != null && Object.hasOwnProperty.call(g, "showTime") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.showTime), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Spinner();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.text = g.string();
          break;
        }
        case 2: {
          AA.cache = g.bool();
          break;
        }
        case 3: {
          AA.showTime = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.text != null && g.hasOwnProperty("text") && !$util$1.isString(g.text) ? "text: string expected" : g.cache != null && g.hasOwnProperty("cache") && typeof g.cache != "boolean" ? "cache: boolean expected" : g.showTime != null && g.hasOwnProperty("showTime") && typeof g.showTime != "boolean" ? "showTime: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Spinner) return g;
    let d = new $root$1.Spinner();
    return g.text != null && (d.text = String(g.text)), g.cache != null && (d.cache = !!g.cache), g.showTime != null && (d.showTime = !!g.showTime), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.text = "", k.cache = !1, k.showTime = !1), g.text != null && g.hasOwnProperty("text") && (k.text = g.text), g.cache != null && g.hasOwnProperty("cache") && (k.cache = g.cache), g.showTime != null && g.hasOwnProperty("showTime") && (k.showTime = g.showTime), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Spinner";
  }, n;
})();
$root$1.Radio = (() => {
  function n(g) {
    if (this.options = [], this.captions = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.default = null, n.prototype.options = $util$1.emptyArray, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = null, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.horizontal = !1, n.prototype.labelVisibility = null, n.prototype.captions = $util$1.emptyArray;
  let t;
  return Object.defineProperty(n.prototype, "_default", { get: $util$1.oneOfGetter(t = ["default"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_value", { get: $util$1.oneOfGetter(t = ["value"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    if (k || (k = $Writer$1.create()), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.id), d.label != null && Object.hasOwnProperty.call(d, "label") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.label), d.default != null && Object.hasOwnProperty.call(d, "default") && k.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(d.default), d.options != null && d.options.length) for (let H = 0; H < d.options.length; ++H) k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(d.options[H]);
    if (d.help != null && Object.hasOwnProperty.call(d, "help") && k.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(d.help), d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.formId), d.value != null && Object.hasOwnProperty.call(d, "value") && k.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(d.value), d.setValue != null && Object.hasOwnProperty.call(d, "setValue") && k.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(d.setValue), d.disabled != null && Object.hasOwnProperty.call(d, "disabled") && k.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(d.disabled), d.horizontal != null && Object.hasOwnProperty.call(d, "horizontal") && k.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(d.horizontal), d.labelVisibility != null && Object.hasOwnProperty.call(d, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(d.labelVisibility, k.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), d.captions != null && d.captions.length) for (let H = 0; H < d.captions.length; ++H) k.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(d.captions[H]);
    return k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Radio();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.id = d.string();
          break;
        }
        case 2: {
          gA.label = d.string();
          break;
        }
        case 3: {
          gA.default = d.int32();
          break;
        }
        case 4: {
          gA.options && gA.options.length || (gA.options = []), gA.options.push(d.string());
          break;
        }
        case 5: {
          gA.help = d.string();
          break;
        }
        case 6: {
          gA.formId = d.string();
          break;
        }
        case 7: {
          gA.value = d.int32();
          break;
        }
        case 8: {
          gA.setValue = d.bool();
          break;
        }
        case 9: {
          gA.disabled = d.bool();
          break;
        }
        case 10: {
          gA.horizontal = d.bool();
          break;
        }
        case 11: {
          gA.labelVisibility = $root$1.LabelVisibilityMessage.decode(d, d.uint32());
          break;
        }
        case 12: {
          gA.captions && gA.captions.length || (gA.captions = []), gA.captions.push(d.string());
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.label != null && d.hasOwnProperty("label") && !$util$1.isString(d.label)) return "label: string expected";
    if (d.default != null && d.hasOwnProperty("default") && !$util$1.isInteger(d.default))
      return "default: integer expected";
    if (d.options != null && d.hasOwnProperty("options")) {
      if (!Array.isArray(d.options)) return "options: array expected";
      for (let k = 0; k < d.options.length; ++k) if (!$util$1.isString(d.options[k])) return "options: string[] expected";
    }
    if (d.help != null && d.hasOwnProperty("help") && !$util$1.isString(d.help)) return "help: string expected";
    if (d.formId != null && d.hasOwnProperty("formId") && !$util$1.isString(d.formId)) return "formId: string expected";
    if (d.value != null && d.hasOwnProperty("value") && !$util$1.isInteger(d.value))
      return "value: integer expected";
    if (d.setValue != null && d.hasOwnProperty("setValue") && typeof d.setValue != "boolean") return "setValue: boolean expected";
    if (d.disabled != null && d.hasOwnProperty("disabled") && typeof d.disabled != "boolean") return "disabled: boolean expected";
    if (d.horizontal != null && d.hasOwnProperty("horizontal") && typeof d.horizontal != "boolean") return "horizontal: boolean expected";
    if (d.labelVisibility != null && d.hasOwnProperty("labelVisibility")) {
      let k = $root$1.LabelVisibilityMessage.verify(d.labelVisibility);
      if (k) return "labelVisibility." + k;
    }
    if (d.captions != null && d.hasOwnProperty("captions")) {
      if (!Array.isArray(d.captions)) return "captions: array expected";
      for (let k = 0; k < d.captions.length; ++k) if (!$util$1.isString(d.captions[k])) return "captions: string[] expected";
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Radio) return d;
    let k = new $root$1.Radio();
    if (d.id != null && (k.id = String(d.id)), d.label != null && (k.label = String(d.label)), d.default != null && (k.default = d.default | 0), d.options) {
      if (!Array.isArray(d.options)) throw TypeError(".Radio.options: array expected");
      k.options = [];
      for (let H = 0; H < d.options.length; ++H) k.options[H] = String(d.options[H]);
    }
    if (d.help != null && (k.help = String(d.help)), d.formId != null && (k.formId = String(d.formId)), d.value != null && (k.value = d.value | 0), d.setValue != null && (k.setValue = !!d.setValue), d.disabled != null && (k.disabled = !!d.disabled), d.horizontal != null && (k.horizontal = !!d.horizontal), d.labelVisibility != null) {
      if (typeof d.labelVisibility != "object") throw TypeError(".Radio.labelVisibility: object expected");
      k.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(d.labelVisibility);
    }
    if (d.captions) {
      if (!Array.isArray(d.captions)) throw TypeError(".Radio.captions: array expected");
      k.captions = [];
      for (let H = 0; H < d.captions.length; ++H) k.captions[H] = String(d.captions[H]);
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    if ((k.arrays || k.defaults) && (H.options = [], H.captions = []), k.defaults && (H.id = "", H.label = "", H.help = "", H.formId = "", H.setValue = !1, H.disabled = !1, H.horizontal = !1, H.labelVisibility = null), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.label != null && d.hasOwnProperty("label") && (H.label = d.label), d.default != null && d.hasOwnProperty("default") && (H.default = d.default, k.oneofs && (H._default = "default")), d.options && d.options.length) {
      H.options = [];
      for (let AA = 0; AA < d.options.length; ++AA) H.options[AA] = d.options[AA];
    }
    if (d.help != null && d.hasOwnProperty("help") && (H.help = d.help), d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.value != null && d.hasOwnProperty("value") && (H.value = d.value, k.oneofs && (H._value = "value")), d.setValue != null && d.hasOwnProperty("setValue") && (H.setValue = d.setValue), d.disabled != null && d.hasOwnProperty("disabled") && (H.disabled = d.disabled), d.horizontal != null && d.hasOwnProperty("horizontal") && (H.horizontal = d.horizontal), d.labelVisibility != null && d.hasOwnProperty("labelVisibility") && (H.labelVisibility = $root$1.LabelVisibilityMessage.toObject(d.labelVisibility, k)), d.captions && d.captions.length) {
      H.captions = [];
      for (let AA = 0; AA < d.captions.length; ++AA) H.captions[AA] = d.captions[AA];
    }
    return H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Radio";
  }, n;
})();
$root$1.Selectbox = (() => {
  function n(g) {
    if (this.options = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.default = null, n.prototype.options = $util$1.emptyArray, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = null, n.prototype.rawValue = null, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.placeholder = "", n.prototype.acceptNewOptions = null;
  let t;
  return Object.defineProperty(n.prototype, "_default", { get: $util$1.oneOfGetter(t = ["default"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_value", { get: $util$1.oneOfGetter(t = ["value"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_rawValue", { get: $util$1.oneOfGetter(t = ["rawValue"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_acceptNewOptions", { get: $util$1.oneOfGetter(t = ["acceptNewOptions"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    if (k || (k = $Writer$1.create()), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.id), d.label != null && Object.hasOwnProperty.call(d, "label") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.label), d.default != null && Object.hasOwnProperty.call(d, "default") && k.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(d.default), d.options != null && d.options.length) for (let H = 0; H < d.options.length; ++H) k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(d.options[H]);
    return d.help != null && Object.hasOwnProperty.call(d, "help") && k.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(d.help), d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.formId), d.value != null && Object.hasOwnProperty.call(d, "value") && k.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(d.value), d.setValue != null && Object.hasOwnProperty.call(d, "setValue") && k.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(d.setValue), d.disabled != null && Object.hasOwnProperty.call(d, "disabled") && k.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(d.disabled), d.labelVisibility != null && Object.hasOwnProperty.call(d, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(d.labelVisibility, k.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), d.placeholder != null && Object.hasOwnProperty.call(d, "placeholder") && k.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(d.placeholder), d.acceptNewOptions != null && Object.hasOwnProperty.call(d, "acceptNewOptions") && k.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(d.acceptNewOptions), d.rawValue != null && Object.hasOwnProperty.call(d, "rawValue") && k.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(d.rawValue), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Selectbox();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.id = d.string();
          break;
        }
        case 2: {
          gA.label = d.string();
          break;
        }
        case 3: {
          gA.default = d.int32();
          break;
        }
        case 4: {
          gA.options && gA.options.length || (gA.options = []), gA.options.push(d.string());
          break;
        }
        case 5: {
          gA.help = d.string();
          break;
        }
        case 6: {
          gA.formId = d.string();
          break;
        }
        case 7: {
          gA.value = d.int32();
          break;
        }
        case 13: {
          gA.rawValue = d.string();
          break;
        }
        case 8: {
          gA.setValue = d.bool();
          break;
        }
        case 9: {
          gA.disabled = d.bool();
          break;
        }
        case 10: {
          gA.labelVisibility = $root$1.LabelVisibilityMessage.decode(d, d.uint32());
          break;
        }
        case 11: {
          gA.placeholder = d.string();
          break;
        }
        case 12: {
          gA.acceptNewOptions = d.bool();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.label != null && d.hasOwnProperty("label") && !$util$1.isString(d.label)) return "label: string expected";
    if (d.default != null && d.hasOwnProperty("default") && !$util$1.isInteger(d.default))
      return "default: integer expected";
    if (d.options != null && d.hasOwnProperty("options")) {
      if (!Array.isArray(d.options)) return "options: array expected";
      for (let k = 0; k < d.options.length; ++k) if (!$util$1.isString(d.options[k])) return "options: string[] expected";
    }
    if (d.help != null && d.hasOwnProperty("help") && !$util$1.isString(d.help)) return "help: string expected";
    if (d.formId != null && d.hasOwnProperty("formId") && !$util$1.isString(d.formId)) return "formId: string expected";
    if (d.value != null && d.hasOwnProperty("value") && !$util$1.isInteger(d.value))
      return "value: integer expected";
    if (d.rawValue != null && d.hasOwnProperty("rawValue") && !$util$1.isString(d.rawValue))
      return "rawValue: string expected";
    if (d.setValue != null && d.hasOwnProperty("setValue") && typeof d.setValue != "boolean") return "setValue: boolean expected";
    if (d.disabled != null && d.hasOwnProperty("disabled") && typeof d.disabled != "boolean") return "disabled: boolean expected";
    if (d.labelVisibility != null && d.hasOwnProperty("labelVisibility")) {
      let k = $root$1.LabelVisibilityMessage.verify(d.labelVisibility);
      if (k) return "labelVisibility." + k;
    }
    return d.placeholder != null && d.hasOwnProperty("placeholder") && !$util$1.isString(d.placeholder) ? "placeholder: string expected" : d.acceptNewOptions != null && d.hasOwnProperty("acceptNewOptions") && typeof d.acceptNewOptions != "boolean" ? "acceptNewOptions: boolean expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Selectbox) return d;
    let k = new $root$1.Selectbox();
    if (d.id != null && (k.id = String(d.id)), d.label != null && (k.label = String(d.label)), d.default != null && (k.default = d.default | 0), d.options) {
      if (!Array.isArray(d.options)) throw TypeError(".Selectbox.options: array expected");
      k.options = [];
      for (let H = 0; H < d.options.length; ++H) k.options[H] = String(d.options[H]);
    }
    if (d.help != null && (k.help = String(d.help)), d.formId != null && (k.formId = String(d.formId)), d.value != null && (k.value = d.value | 0), d.rawValue != null && (k.rawValue = String(d.rawValue)), d.setValue != null && (k.setValue = !!d.setValue), d.disabled != null && (k.disabled = !!d.disabled), d.labelVisibility != null) {
      if (typeof d.labelVisibility != "object") throw TypeError(".Selectbox.labelVisibility: object expected");
      k.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(d.labelVisibility);
    }
    return d.placeholder != null && (k.placeholder = String(d.placeholder)), d.acceptNewOptions != null && (k.acceptNewOptions = !!d.acceptNewOptions), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    if ((k.arrays || k.defaults) && (H.options = []), k.defaults && (H.id = "", H.label = "", H.help = "", H.formId = "", H.setValue = !1, H.disabled = !1, H.labelVisibility = null, H.placeholder = ""), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.label != null && d.hasOwnProperty("label") && (H.label = d.label), d.default != null && d.hasOwnProperty("default") && (H.default = d.default, k.oneofs && (H._default = "default")), d.options && d.options.length) {
      H.options = [];
      for (let AA = 0; AA < d.options.length; ++AA) H.options[AA] = d.options[AA];
    }
    return d.help != null && d.hasOwnProperty("help") && (H.help = d.help), d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.value != null && d.hasOwnProperty("value") && (H.value = d.value, k.oneofs && (H._value = "value")), d.setValue != null && d.hasOwnProperty("setValue") && (H.setValue = d.setValue), d.disabled != null && d.hasOwnProperty("disabled") && (H.disabled = d.disabled), d.labelVisibility != null && d.hasOwnProperty("labelVisibility") && (H.labelVisibility = $root$1.LabelVisibilityMessage.toObject(d.labelVisibility, k)), d.placeholder != null && d.hasOwnProperty("placeholder") && (H.placeholder = d.placeholder), d.acceptNewOptions != null && d.hasOwnProperty("acceptNewOptions") && (H.acceptNewOptions = d.acceptNewOptions, k.oneofs && (H._acceptNewOptions = "acceptNewOptions")), d.rawValue != null && d.hasOwnProperty("rawValue") && (H.rawValue = d.rawValue, k.oneofs && (H._rawValue = "rawValue")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Selectbox";
  }, n;
})();
const Skeleton$1 = $root$1.Skeleton = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.style = 0, n.prototype.height = null;
  let t;
  return Object.defineProperty(n.prototype, "_height", { get: $util$1.oneOfGetter(t = ["height"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.style != null && Object.hasOwnProperty.call(d, "style") && k.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(d.style), d.height != null && Object.hasOwnProperty.call(d, "height") && k.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(d.height), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Skeleton();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.style = d.int32();
          break;
        }
        case 2: {
          gA.height = d.int32();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.style != null && d.hasOwnProperty("style")) switch (d.style) {
      default:
        return "style: enum value expected";
      case 0:
      case 1:
        break;
    }
    return d.height != null && d.hasOwnProperty("height") && !$util$1.isInteger(d.height) ? "height: integer expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Skeleton) return d;
    let k = new $root$1.Skeleton();
    switch (d.style) {
      default:
        if (typeof d.style == "number") {
          k.style = d.style;
          break;
        }
        break;
      case "ELEMENT":
      case 0:
        k.style = 0;
        break;
      case "APP":
      case 1:
        k.style = 1;
        break;
    }
    return d.height != null && (k.height = d.height | 0), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.style = k.enums === String ? "ELEMENT" : 0), d.style != null && d.hasOwnProperty("style") && (H.style = k.enums === String ? $root$1.Skeleton.SkeletonStyle[d.style] === void 0 ? d.style : $root$1.Skeleton.SkeletonStyle[d.style] : d.style), d.height != null && d.hasOwnProperty("height") && (H.height = d.height, k.oneofs && (H._height = "height")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Skeleton";
  }, n.SkeletonStyle = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "ELEMENT"] = 0, d[g[1] = "APP"] = 1, d;
  })(), n;
})(), Slider$2 = $root$1.Slider = (() => {
  function n(t) {
    if (this.default = [], this.value = [], this.options = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.formId = "", n.prototype.label = "", n.prototype.format = "", n.prototype.dataType = 0, n.prototype.default = $util$1.emptyArray, n.prototype.min = 0, n.prototype.max = 0, n.prototype.step = 0, n.prototype.value = $util$1.emptyArray, n.prototype.setValue = !1, n.prototype.options = $util$1.emptyArray, n.prototype.help = "", n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.type = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.formId), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.label), g.format != null && Object.hasOwnProperty.call(g, "format") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.format), g.dataType != null && Object.hasOwnProperty.call(g, "dataType") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.dataType), g.default != null && g.default.length) {
      d.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork();
      for (let k = 0; k < g.default.length; ++k) d.double(g.default[k]);
      d.ldelim();
    }
    if (g.min != null && Object.hasOwnProperty.call(g, "min") && d.uint32(
      /* id 7, wireType 1 =*/
      57
    ).double(g.min), g.max != null && Object.hasOwnProperty.call(g, "max") && d.uint32(
      /* id 8, wireType 1 =*/
      65
    ).double(g.max), g.step != null && Object.hasOwnProperty.call(g, "step") && d.uint32(
      /* id 9, wireType 1 =*/
      73
    ).double(g.step), g.value != null && g.value.length) {
      d.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork();
      for (let k = 0; k < g.value.length; ++k) d.double(g.value[k]);
      d.ldelim();
    }
    if (g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.setValue), g.options != null && g.options.length) for (let k = 0; k < g.options.length; ++k) d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.options[k]);
    return g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.help), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.type != null && Object.hasOwnProperty.call(g, "type") && d.uint32(
      /* id 17, wireType 0 =*/
      136
    ).int32(g.type), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Slider();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.formId = g.string();
          break;
        }
        case 3: {
          AA.label = g.string();
          break;
        }
        case 4: {
          AA.format = g.string();
          break;
        }
        case 5: {
          AA.dataType = g.int32();
          break;
        }
        case 6: {
          if (AA.default && AA.default.length || (AA.default = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.default.push(g.double());
          } else AA.default.push(g.double());
          break;
        }
        case 7: {
          AA.min = g.double();
          break;
        }
        case 8: {
          AA.max = g.double();
          break;
        }
        case 9: {
          AA.step = g.double();
          break;
        }
        case 10: {
          if (AA.value && AA.value.length || (AA.value = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.value.push(g.double());
          } else AA.value.push(g.double());
          break;
        }
        case 11: {
          AA.setValue = g.bool();
          break;
        }
        case 13: {
          AA.options && AA.options.length || (AA.options = []), AA.options.push(g.string());
          break;
        }
        case 14: {
          AA.help = g.string();
          break;
        }
        case 15: {
          AA.disabled = g.bool();
          break;
        }
        case 16: {
          AA.labelVisibility = $root$1.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 17: {
          AA.type = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util$1.isString(g.id)) return "id: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util$1.isString(g.formId)) return "formId: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util$1.isString(g.label)) return "label: string expected";
    if (g.format != null && g.hasOwnProperty("format") && !$util$1.isString(g.format)) return "format: string expected";
    if (g.dataType != null && g.hasOwnProperty("dataType")) switch (g.dataType) {
      default:
        return "dataType: enum value expected";
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
        break;
    }
    if (g.default != null && g.hasOwnProperty("default")) {
      if (!Array.isArray(g.default)) return "default: array expected";
      for (let d = 0; d < g.default.length; ++d) if (typeof g.default[d] != "number") return "default: number[] expected";
    }
    if (g.min != null && g.hasOwnProperty("min") && typeof g.min != "number") return "min: number expected";
    if (g.max != null && g.hasOwnProperty("max") && typeof g.max != "number") return "max: number expected";
    if (g.step != null && g.hasOwnProperty("step") && typeof g.step != "number") return "step: number expected";
    if (g.value != null && g.hasOwnProperty("value")) {
      if (!Array.isArray(g.value)) return "value: array expected";
      for (let d = 0; d < g.value.length; ++d) if (typeof g.value[d] != "number") return "value: number[] expected";
    }
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.options != null && g.hasOwnProperty("options")) {
      if (!Array.isArray(g.options)) return "options: array expected";
      for (let d = 0; d < g.options.length; ++d) if (!$util$1.isString(g.options[d])) return "options: string[] expected";
    }
    if (g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help)) return "help: string expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root$1.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    if (g.type != null && g.hasOwnProperty("type")) switch (g.type) {
      default:
        return "type: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Slider) return g;
    let d = new $root$1.Slider();
    switch (g.id != null && (d.id = String(g.id)), g.formId != null && (d.formId = String(g.formId)), g.label != null && (d.label = String(g.label)), g.format != null && (d.format = String(g.format)), g.dataType) {
      default:
        if (typeof g.dataType == "number") {
          d.dataType = g.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        d.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        d.dataType = 1;
        break;
      case "DATETIME":
      case 2:
        d.dataType = 2;
        break;
      case "DATE":
      case 3:
        d.dataType = 3;
        break;
      case "TIME":
      case 4:
        d.dataType = 4;
        break;
    }
    if (g.default) {
      if (!Array.isArray(g.default)) throw TypeError(".Slider.default: array expected");
      d.default = [];
      for (let k = 0; k < g.default.length; ++k) d.default[k] = Number(g.default[k]);
    }
    if (g.min != null && (d.min = Number(g.min)), g.max != null && (d.max = Number(g.max)), g.step != null && (d.step = Number(g.step)), g.value) {
      if (!Array.isArray(g.value)) throw TypeError(".Slider.value: array expected");
      d.value = [];
      for (let k = 0; k < g.value.length; ++k) d.value[k] = Number(g.value[k]);
    }
    if (g.setValue != null && (d.setValue = !!g.setValue), g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".Slider.options: array expected");
      d.options = [];
      for (let k = 0; k < g.options.length; ++k) d.options[k] = String(g.options[k]);
    }
    if (g.help != null && (d.help = String(g.help)), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".Slider.labelVisibility: object expected");
      d.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    switch (g.type) {
      default:
        if (typeof g.type == "number") {
          d.type = g.type;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        d.type = 0;
        break;
      case "SLIDER":
      case 1:
        d.type = 1;
        break;
      case "SELECT_SLIDER":
      case 2:
        d.type = 2;
        break;
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.default = [], k.value = [], k.options = []), d.defaults && (k.id = "", k.formId = "", k.label = "", k.format = "", k.dataType = d.enums === String ? "INT" : 0, k.min = 0, k.max = 0, k.step = 0, k.setValue = !1, k.help = "", k.disabled = !1, k.labelVisibility = null, k.type = d.enums === String ? "UNSPECIFIED" : 0), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.format != null && g.hasOwnProperty("format") && (k.format = g.format), g.dataType != null && g.hasOwnProperty("dataType") && (k.dataType = d.enums === String ? $root$1.Slider.DataType[g.dataType] === void 0 ? g.dataType : $root$1.Slider.DataType[g.dataType] : g.dataType), g.default && g.default.length) {
      k.default = [];
      for (let H = 0; H < g.default.length; ++H) k.default[H] = d.json && !isFinite(g.default[H]) ? String(g.default[H]) : g.default[H];
    }
    if (g.min != null && g.hasOwnProperty("min") && (k.min = d.json && !isFinite(g.min) ? String(g.min) : g.min), g.max != null && g.hasOwnProperty("max") && (k.max = d.json && !isFinite(g.max) ? String(g.max) : g.max), g.step != null && g.hasOwnProperty("step") && (k.step = d.json && !isFinite(g.step) ? String(g.step) : g.step), g.value && g.value.length) {
      k.value = [];
      for (let H = 0; H < g.value.length; ++H) k.value[H] = d.json && !isFinite(g.value[H]) ? String(g.value[H]) : g.value[H];
    }
    if (g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.options && g.options.length) {
      k.options = [];
      for (let H = 0; H < g.options.length; ++H) k.options[H] = g.options[H];
    }
    return g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root$1.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.type != null && g.hasOwnProperty("type") && (k.type = d.enums === String ? $root$1.Slider.Type[g.type] === void 0 ? g.type : $root$1.Slider.Type[g.type] : g.type), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Slider";
  }, n.DataType = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "INT"] = 0, g[t[1] = "FLOAT"] = 1, g[t[2] = "DATETIME"] = 2, g[t[3] = "DATE"] = 3, g[t[4] = "TIME"] = 4, g;
  })(), n.Type = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "UNSPECIFIED"] = 0, g[t[1] = "SLIDER"] = 1, g[t[2] = "SELECT_SLIDER"] = 2, g;
  })(), n;
})();
$root$1.Text = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.body = "", n.prototype.help = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.help), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Text();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.body = g.string();
          break;
        }
        case 2: {
          AA.help = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.body != null && g.hasOwnProperty("body") && !$util$1.isString(g.body) ? "body: string expected" : g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help) ? "help: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Text) return g;
    let d = new $root$1.Text();
    return g.body != null && (d.body = String(g.body)), g.help != null && (d.help = String(g.help)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.body = "", k.help = ""), g.body != null && g.hasOwnProperty("body") && (k.body = g.body), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Text";
  }, n;
})();
$root$1.TextArea = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.default = null, n.prototype.height = 0, n.prototype.maxChars = 0, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = null, n.prototype.setValue = !1, n.prototype.placeholder = "", n.prototype.disabled = !1, n.prototype.labelVisibility = null;
  let t;
  return Object.defineProperty(n.prototype, "_default", { get: $util$1.oneOfGetter(t = ["default"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_value", { get: $util$1.oneOfGetter(t = ["value"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.id), d.label != null && Object.hasOwnProperty.call(d, "label") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.label), d.default != null && Object.hasOwnProperty.call(d, "default") && k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(d.default), d.height != null && Object.hasOwnProperty.call(d, "height") && k.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(d.height), d.maxChars != null && Object.hasOwnProperty.call(d, "maxChars") && k.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(d.maxChars), d.help != null && Object.hasOwnProperty.call(d, "help") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.help), d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(d.formId), d.value != null && Object.hasOwnProperty.call(d, "value") && k.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(d.value), d.setValue != null && Object.hasOwnProperty.call(d, "setValue") && k.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(d.setValue), d.placeholder != null && Object.hasOwnProperty.call(d, "placeholder") && k.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(d.placeholder), d.disabled != null && Object.hasOwnProperty.call(d, "disabled") && k.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(d.disabled), d.labelVisibility != null && Object.hasOwnProperty.call(d, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(d.labelVisibility, k.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.TextArea();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.id = d.string();
          break;
        }
        case 2: {
          gA.label = d.string();
          break;
        }
        case 3: {
          gA.default = d.string();
          break;
        }
        case 4: {
          gA.height = d.uint32();
          break;
        }
        case 5: {
          gA.maxChars = d.uint32();
          break;
        }
        case 6: {
          gA.help = d.string();
          break;
        }
        case 7: {
          gA.formId = d.string();
          break;
        }
        case 8: {
          gA.value = d.string();
          break;
        }
        case 9: {
          gA.setValue = d.bool();
          break;
        }
        case 10: {
          gA.placeholder = d.string();
          break;
        }
        case 11: {
          gA.disabled = d.bool();
          break;
        }
        case 12: {
          gA.labelVisibility = $root$1.LabelVisibilityMessage.decode(d, d.uint32());
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.label != null && d.hasOwnProperty("label") && !$util$1.isString(d.label)) return "label: string expected";
    if (d.default != null && d.hasOwnProperty("default") && !$util$1.isString(d.default))
      return "default: string expected";
    if (d.height != null && d.hasOwnProperty("height") && !$util$1.isInteger(d.height)) return "height: integer expected";
    if (d.maxChars != null && d.hasOwnProperty("maxChars") && !$util$1.isInteger(d.maxChars)) return "maxChars: integer expected";
    if (d.help != null && d.hasOwnProperty("help") && !$util$1.isString(d.help)) return "help: string expected";
    if (d.formId != null && d.hasOwnProperty("formId") && !$util$1.isString(d.formId)) return "formId: string expected";
    if (d.value != null && d.hasOwnProperty("value") && !$util$1.isString(d.value))
      return "value: string expected";
    if (d.setValue != null && d.hasOwnProperty("setValue") && typeof d.setValue != "boolean") return "setValue: boolean expected";
    if (d.placeholder != null && d.hasOwnProperty("placeholder") && !$util$1.isString(d.placeholder)) return "placeholder: string expected";
    if (d.disabled != null && d.hasOwnProperty("disabled") && typeof d.disabled != "boolean") return "disabled: boolean expected";
    if (d.labelVisibility != null && d.hasOwnProperty("labelVisibility")) {
      let k = $root$1.LabelVisibilityMessage.verify(d.labelVisibility);
      if (k) return "labelVisibility." + k;
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.TextArea) return d;
    let k = new $root$1.TextArea();
    if (d.id != null && (k.id = String(d.id)), d.label != null && (k.label = String(d.label)), d.default != null && (k.default = String(d.default)), d.height != null && (k.height = d.height >>> 0), d.maxChars != null && (k.maxChars = d.maxChars >>> 0), d.help != null && (k.help = String(d.help)), d.formId != null && (k.formId = String(d.formId)), d.value != null && (k.value = String(d.value)), d.setValue != null && (k.setValue = !!d.setValue), d.placeholder != null && (k.placeholder = String(d.placeholder)), d.disabled != null && (k.disabled = !!d.disabled), d.labelVisibility != null) {
      if (typeof d.labelVisibility != "object") throw TypeError(".TextArea.labelVisibility: object expected");
      k.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(d.labelVisibility);
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.id = "", H.label = "", H.height = 0, H.maxChars = 0, H.help = "", H.formId = "", H.setValue = !1, H.placeholder = "", H.disabled = !1, H.labelVisibility = null), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.label != null && d.hasOwnProperty("label") && (H.label = d.label), d.default != null && d.hasOwnProperty("default") && (H.default = d.default, k.oneofs && (H._default = "default")), d.height != null && d.hasOwnProperty("height") && (H.height = d.height), d.maxChars != null && d.hasOwnProperty("maxChars") && (H.maxChars = d.maxChars), d.help != null && d.hasOwnProperty("help") && (H.help = d.help), d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.value != null && d.hasOwnProperty("value") && (H.value = d.value, k.oneofs && (H._value = "value")), d.setValue != null && d.hasOwnProperty("setValue") && (H.setValue = d.setValue), d.placeholder != null && d.hasOwnProperty("placeholder") && (H.placeholder = d.placeholder), d.disabled != null && d.hasOwnProperty("disabled") && (H.disabled = d.disabled), d.labelVisibility != null && d.hasOwnProperty("labelVisibility") && (H.labelVisibility = $root$1.LabelVisibilityMessage.toObject(d.labelVisibility, k)), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/TextArea";
  }, n;
})();
const TextInput$1 = $root$1.TextInput = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.default = null, n.prototype.type = 0, n.prototype.maxChars = 0, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = null, n.prototype.setValue = !1, n.prototype.autocomplete = "", n.prototype.placeholder = "", n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.icon = "";
  let t;
  return Object.defineProperty(n.prototype, "_default", { get: $util$1.oneOfGetter(t = ["default"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_value", { get: $util$1.oneOfGetter(t = ["value"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.id), d.label != null && Object.hasOwnProperty.call(d, "label") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.label), d.default != null && Object.hasOwnProperty.call(d, "default") && k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(d.default), d.type != null && Object.hasOwnProperty.call(d, "type") && k.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(d.type), d.maxChars != null && Object.hasOwnProperty.call(d, "maxChars") && k.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(d.maxChars), d.help != null && Object.hasOwnProperty.call(d, "help") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.help), d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(d.formId), d.value != null && Object.hasOwnProperty.call(d, "value") && k.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(d.value), d.setValue != null && Object.hasOwnProperty.call(d, "setValue") && k.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(d.setValue), d.autocomplete != null && Object.hasOwnProperty.call(d, "autocomplete") && k.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(d.autocomplete), d.placeholder != null && Object.hasOwnProperty.call(d, "placeholder") && k.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(d.placeholder), d.disabled != null && Object.hasOwnProperty.call(d, "disabled") && k.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(d.disabled), d.labelVisibility != null && Object.hasOwnProperty.call(d, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(d.labelVisibility, k.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), d.icon != null && Object.hasOwnProperty.call(d, "icon") && k.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(d.icon), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.TextInput();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.id = d.string();
          break;
        }
        case 2: {
          gA.label = d.string();
          break;
        }
        case 3: {
          gA.default = d.string();
          break;
        }
        case 4: {
          gA.type = d.int32();
          break;
        }
        case 5: {
          gA.maxChars = d.uint32();
          break;
        }
        case 6: {
          gA.help = d.string();
          break;
        }
        case 7: {
          gA.formId = d.string();
          break;
        }
        case 8: {
          gA.value = d.string();
          break;
        }
        case 9: {
          gA.setValue = d.bool();
          break;
        }
        case 10: {
          gA.autocomplete = d.string();
          break;
        }
        case 11: {
          gA.placeholder = d.string();
          break;
        }
        case 12: {
          gA.disabled = d.bool();
          break;
        }
        case 13: {
          gA.labelVisibility = $root$1.LabelVisibilityMessage.decode(d, d.uint32());
          break;
        }
        case 14: {
          gA.icon = d.string();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.label != null && d.hasOwnProperty("label") && !$util$1.isString(d.label)) return "label: string expected";
    if (d.default != null && d.hasOwnProperty("default") && !$util$1.isString(d.default))
      return "default: string expected";
    if (d.type != null && d.hasOwnProperty("type")) switch (d.type) {
      default:
        return "type: enum value expected";
      case 0:
      case 1:
        break;
    }
    if (d.maxChars != null && d.hasOwnProperty("maxChars") && !$util$1.isInteger(d.maxChars)) return "maxChars: integer expected";
    if (d.help != null && d.hasOwnProperty("help") && !$util$1.isString(d.help)) return "help: string expected";
    if (d.formId != null && d.hasOwnProperty("formId") && !$util$1.isString(d.formId)) return "formId: string expected";
    if (d.value != null && d.hasOwnProperty("value") && !$util$1.isString(d.value))
      return "value: string expected";
    if (d.setValue != null && d.hasOwnProperty("setValue") && typeof d.setValue != "boolean") return "setValue: boolean expected";
    if (d.autocomplete != null && d.hasOwnProperty("autocomplete") && !$util$1.isString(d.autocomplete)) return "autocomplete: string expected";
    if (d.placeholder != null && d.hasOwnProperty("placeholder") && !$util$1.isString(d.placeholder)) return "placeholder: string expected";
    if (d.disabled != null && d.hasOwnProperty("disabled") && typeof d.disabled != "boolean") return "disabled: boolean expected";
    if (d.labelVisibility != null && d.hasOwnProperty("labelVisibility")) {
      let k = $root$1.LabelVisibilityMessage.verify(d.labelVisibility);
      if (k) return "labelVisibility." + k;
    }
    return d.icon != null && d.hasOwnProperty("icon") && !$util$1.isString(d.icon) ? "icon: string expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.TextInput) return d;
    let k = new $root$1.TextInput();
    switch (d.id != null && (k.id = String(d.id)), d.label != null && (k.label = String(d.label)), d.default != null && (k.default = String(d.default)), d.type) {
      default:
        if (typeof d.type == "number") {
          k.type = d.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        k.type = 0;
        break;
      case "PASSWORD":
      case 1:
        k.type = 1;
        break;
    }
    if (d.maxChars != null && (k.maxChars = d.maxChars >>> 0), d.help != null && (k.help = String(d.help)), d.formId != null && (k.formId = String(d.formId)), d.value != null && (k.value = String(d.value)), d.setValue != null && (k.setValue = !!d.setValue), d.autocomplete != null && (k.autocomplete = String(d.autocomplete)), d.placeholder != null && (k.placeholder = String(d.placeholder)), d.disabled != null && (k.disabled = !!d.disabled), d.labelVisibility != null) {
      if (typeof d.labelVisibility != "object") throw TypeError(".TextInput.labelVisibility: object expected");
      k.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(d.labelVisibility);
    }
    return d.icon != null && (k.icon = String(d.icon)), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.id = "", H.label = "", H.type = k.enums === String ? "DEFAULT" : 0, H.maxChars = 0, H.help = "", H.formId = "", H.setValue = !1, H.autocomplete = "", H.placeholder = "", H.disabled = !1, H.labelVisibility = null, H.icon = ""), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.label != null && d.hasOwnProperty("label") && (H.label = d.label), d.default != null && d.hasOwnProperty("default") && (H.default = d.default, k.oneofs && (H._default = "default")), d.type != null && d.hasOwnProperty("type") && (H.type = k.enums === String ? $root$1.TextInput.Type[d.type] === void 0 ? d.type : $root$1.TextInput.Type[d.type] : d.type), d.maxChars != null && d.hasOwnProperty("maxChars") && (H.maxChars = d.maxChars), d.help != null && d.hasOwnProperty("help") && (H.help = d.help), d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.value != null && d.hasOwnProperty("value") && (H.value = d.value, k.oneofs && (H._value = "value")), d.setValue != null && d.hasOwnProperty("setValue") && (H.setValue = d.setValue), d.autocomplete != null && d.hasOwnProperty("autocomplete") && (H.autocomplete = d.autocomplete), d.placeholder != null && d.hasOwnProperty("placeholder") && (H.placeholder = d.placeholder), d.disabled != null && d.hasOwnProperty("disabled") && (H.disabled = d.disabled), d.labelVisibility != null && d.hasOwnProperty("labelVisibility") && (H.labelVisibility = $root$1.LabelVisibilityMessage.toObject(d.labelVisibility, k)), d.icon != null && d.hasOwnProperty("icon") && (H.icon = d.icon), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/TextInput";
  }, n.Type = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "DEFAULT"] = 0, d[g[1] = "PASSWORD"] = 1, d;
  })(), n;
})();
$root$1.TimeInput = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.default = null, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = null, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.step = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0;
  let t;
  return Object.defineProperty(n.prototype, "_default", { get: $util$1.oneOfGetter(t = ["default"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_value", { get: $util$1.oneOfGetter(t = ["value"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.id), d.label != null && Object.hasOwnProperty.call(d, "label") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.label), d.default != null && Object.hasOwnProperty.call(d, "default") && k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(d.default), d.help != null && Object.hasOwnProperty.call(d, "help") && k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(d.help), d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(d.formId), d.value != null && Object.hasOwnProperty.call(d, "value") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.value), d.setValue != null && Object.hasOwnProperty.call(d, "setValue") && k.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(d.setValue), d.disabled != null && Object.hasOwnProperty.call(d, "disabled") && k.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(d.disabled), d.labelVisibility != null && Object.hasOwnProperty.call(d, "labelVisibility") && $root$1.LabelVisibilityMessage.encode(d.labelVisibility, k.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), d.step != null && Object.hasOwnProperty.call(d, "step") && k.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int64(d.step), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.TimeInput();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.id = d.string();
          break;
        }
        case 2: {
          gA.label = d.string();
          break;
        }
        case 3: {
          gA.default = d.string();
          break;
        }
        case 4: {
          gA.help = d.string();
          break;
        }
        case 5: {
          gA.formId = d.string();
          break;
        }
        case 6: {
          gA.value = d.string();
          break;
        }
        case 7: {
          gA.setValue = d.bool();
          break;
        }
        case 8: {
          gA.disabled = d.bool();
          break;
        }
        case 9: {
          gA.labelVisibility = $root$1.LabelVisibilityMessage.decode(d, d.uint32());
          break;
        }
        case 10: {
          gA.step = d.int64();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.label != null && d.hasOwnProperty("label") && !$util$1.isString(d.label)) return "label: string expected";
    if (d.default != null && d.hasOwnProperty("default") && !$util$1.isString(d.default))
      return "default: string expected";
    if (d.help != null && d.hasOwnProperty("help") && !$util$1.isString(d.help)) return "help: string expected";
    if (d.formId != null && d.hasOwnProperty("formId") && !$util$1.isString(d.formId)) return "formId: string expected";
    if (d.value != null && d.hasOwnProperty("value") && !$util$1.isString(d.value))
      return "value: string expected";
    if (d.setValue != null && d.hasOwnProperty("setValue") && typeof d.setValue != "boolean") return "setValue: boolean expected";
    if (d.disabled != null && d.hasOwnProperty("disabled") && typeof d.disabled != "boolean") return "disabled: boolean expected";
    if (d.labelVisibility != null && d.hasOwnProperty("labelVisibility")) {
      let k = $root$1.LabelVisibilityMessage.verify(d.labelVisibility);
      if (k) return "labelVisibility." + k;
    }
    return d.step != null && d.hasOwnProperty("step") && !$util$1.isInteger(d.step) && !(d.step && $util$1.isInteger(d.step.low) && $util$1.isInteger(d.step.high)) ? "step: integer|Long expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.TimeInput) return d;
    let k = new $root$1.TimeInput();
    if (d.id != null && (k.id = String(d.id)), d.label != null && (k.label = String(d.label)), d.default != null && (k.default = String(d.default)), d.help != null && (k.help = String(d.help)), d.formId != null && (k.formId = String(d.formId)), d.value != null && (k.value = String(d.value)), d.setValue != null && (k.setValue = !!d.setValue), d.disabled != null && (k.disabled = !!d.disabled), d.labelVisibility != null) {
      if (typeof d.labelVisibility != "object") throw TypeError(".TimeInput.labelVisibility: object expected");
      k.labelVisibility = $root$1.LabelVisibilityMessage.fromObject(d.labelVisibility);
    }
    return d.step != null && ($util$1.Long ? (k.step = $util$1.Long.fromValue(d.step)).unsigned = !1 : typeof d.step == "string" ? k.step = parseInt(d.step, 10) : typeof d.step == "number" ? k.step = d.step : typeof d.step == "object" && (k.step = new $util$1.LongBits(d.step.low >>> 0, d.step.high >>> 0).toNumber())), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    if (k.defaults)
      if (H.id = "", H.label = "", H.help = "", H.formId = "", H.setValue = !1, H.disabled = !1, H.labelVisibility = null, $util$1.Long) {
        let AA = new $util$1.Long(0, 0, !1);
        H.step = k.longs === String ? AA.toString() : k.longs === Number ? AA.toNumber() : AA;
      } else H.step = k.longs === String ? "0" : 0;
    return d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.label != null && d.hasOwnProperty("label") && (H.label = d.label), d.default != null && d.hasOwnProperty("default") && (H.default = d.default, k.oneofs && (H._default = "default")), d.help != null && d.hasOwnProperty("help") && (H.help = d.help), d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.value != null && d.hasOwnProperty("value") && (H.value = d.value, k.oneofs && (H._value = "value")), d.setValue != null && d.hasOwnProperty("setValue") && (H.setValue = d.setValue), d.disabled != null && d.hasOwnProperty("disabled") && (H.disabled = d.disabled), d.labelVisibility != null && d.hasOwnProperty("labelVisibility") && (H.labelVisibility = $root$1.LabelVisibilityMessage.toObject(d.labelVisibility, k)), d.step != null && d.hasOwnProperty("step") && (typeof d.step == "number" ? H.step = k.longs === String ? String(d.step) : d.step : H.step = k.longs === String ? $util$1.Long.prototype.toString.call(d.step) : k.longs === Number ? new $util$1.LongBits(d.step.low >>> 0, d.step.high >>> 0).toNumber() : d.step), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/TimeInput";
  }, n;
})();
$root$1.Toast = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.body = "", n.prototype.icon = "", n.prototype.duration = null;
  let t;
  return Object.defineProperty(n.prototype, "_duration", { get: $util$1.oneOfGetter(t = ["duration"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.body != null && Object.hasOwnProperty.call(d, "body") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.body), d.icon != null && Object.hasOwnProperty.call(d, "icon") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.icon), d.duration != null && Object.hasOwnProperty.call(d, "duration") && k.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(d.duration), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Toast();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.body = d.string();
          break;
        }
        case 2: {
          gA.icon = d.string();
          break;
        }
        case 3: {
          gA.duration = d.int32();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    return typeof d != "object" || d === null ? "object expected" : d.body != null && d.hasOwnProperty("body") && !$util$1.isString(d.body) ? "body: string expected" : d.icon != null && d.hasOwnProperty("icon") && !$util$1.isString(d.icon) ? "icon: string expected" : d.duration != null && d.hasOwnProperty("duration") && !$util$1.isInteger(d.duration) ? "duration: integer expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Toast) return d;
    let k = new $root$1.Toast();
    return d.body != null && (k.body = String(d.body)), d.icon != null && (k.icon = String(d.icon)), d.duration != null && (k.duration = d.duration | 0), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.body = "", H.icon = ""), d.body != null && d.hasOwnProperty("body") && (H.body = d.body), d.icon != null && d.hasOwnProperty("icon") && (H.icon = d.icon), d.duration != null && d.hasOwnProperty("duration") && (H.duration = d.duration, k.oneofs && (H._duration = "duration")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Toast";
  }, n;
})();
$root$1.VegaLiteChart = (() => {
  function n(t) {
    if (this.datasets = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.spec = "", n.prototype.data = null, n.prototype.datasets = $util$1.emptyArray, n.prototype.useContainerWidth = !1, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.spec != null && Object.hasOwnProperty.call(g, "spec") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.spec), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.DataFrame.encode(g.data, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.datasets != null && g.datasets.length) for (let k = 0; k < g.datasets.length; ++k) $root$1.NamedDataSet.encode(g.datasets[k], d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    return g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.useContainerWidth), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.VegaLiteChart();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.spec = g.string();
          break;
        }
        case 2: {
          AA.data = $root$1.DataFrame.decode(g, g.uint32());
          break;
        }
        case 4: {
          AA.datasets && AA.datasets.length || (AA.datasets = []), AA.datasets.push($root$1.NamedDataSet.decode(g, g.uint32()));
          break;
        }
        case 5: {
          AA.useContainerWidth = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.spec != null && g.hasOwnProperty("spec") && !$util$1.isString(g.spec)) return "spec: string expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      let d = $root$1.DataFrame.verify(g.data);
      if (d) return "data." + d;
    }
    if (g.datasets != null && g.hasOwnProperty("datasets")) {
      if (!Array.isArray(g.datasets)) return "datasets: array expected";
      for (let d = 0; d < g.datasets.length; ++d) {
        let k = $root$1.NamedDataSet.verify(g.datasets[d]);
        if (k) return "datasets." + k;
      }
    }
    return g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && typeof g.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.VegaLiteChart) return g;
    let d = new $root$1.VegaLiteChart();
    if (g.spec != null && (d.spec = String(g.spec)), g.data != null) {
      if (typeof g.data != "object") throw TypeError(".VegaLiteChart.data: object expected");
      d.data = $root$1.DataFrame.fromObject(g.data);
    }
    if (g.datasets) {
      if (!Array.isArray(g.datasets)) throw TypeError(".VegaLiteChart.datasets: array expected");
      d.datasets = [];
      for (let k = 0; k < g.datasets.length; ++k) {
        if (typeof g.datasets[k] != "object") throw TypeError(".VegaLiteChart.datasets: object expected");
        d.datasets[k] = $root$1.NamedDataSet.fromObject(g.datasets[k]);
      }
    }
    return g.useContainerWidth != null && (d.useContainerWidth = !!g.useContainerWidth), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.datasets = []), d.defaults && (k.spec = "", k.data = null, k.useContainerWidth = !1), g.spec != null && g.hasOwnProperty("spec") && (k.spec = g.spec), g.data != null && g.hasOwnProperty("data") && (k.data = $root$1.DataFrame.toObject(g.data, d)), g.datasets && g.datasets.length) {
      k.datasets = [];
      for (let H = 0; H < g.datasets.length; ++H) k.datasets[H] = $root$1.NamedDataSet.toObject(g.datasets[H], d);
    }
    return g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (k.useContainerWidth = g.useContainerWidth), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/VegaLiteChart";
  }, n;
})();
$root$1.NamedDataSet = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.name = "", n.prototype.hasName = !1, n.prototype.data = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.name), g.data != null && Object.hasOwnProperty.call(g, "data") && $root$1.DataFrame.encode(g.data, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.hasName != null && Object.hasOwnProperty.call(g, "hasName") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.hasName), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.NamedDataSet();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.name = g.string();
          break;
        }
        case 3: {
          AA.hasName = g.bool();
          break;
        }
        case 2: {
          AA.data = $root$1.DataFrame.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.name != null && g.hasOwnProperty("name") && !$util$1.isString(g.name)) return "name: string expected";
    if (g.hasName != null && g.hasOwnProperty("hasName") && typeof g.hasName != "boolean") return "hasName: boolean expected";
    if (g.data != null && g.hasOwnProperty("data")) {
      let d = $root$1.DataFrame.verify(g.data);
      if (d) return "data." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.NamedDataSet) return g;
    let d = new $root$1.NamedDataSet();
    if (g.name != null && (d.name = String(g.name)), g.hasName != null && (d.hasName = !!g.hasName), g.data != null) {
      if (typeof g.data != "object") throw TypeError(".NamedDataSet.data: object expected");
      d.data = $root$1.DataFrame.fromObject(g.data);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.name = "", k.data = null, k.hasName = !1), g.name != null && g.hasOwnProperty("name") && (k.name = g.name), g.data != null && g.hasOwnProperty("data") && (k.data = $root$1.DataFrame.toObject(g.data, d)), g.hasName != null && g.hasOwnProperty("hasName") && (k.hasName = g.hasName), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/NamedDataSet";
  }, n;
})();
$root$1.SubtitleTrack = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.label = "", n.prototype.url = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.label), g.url != null && Object.hasOwnProperty.call(g, "url") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.url), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.SubtitleTrack();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.label = g.string();
          break;
        }
        case 2: {
          AA.url = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.label != null && g.hasOwnProperty("label") && !$util$1.isString(g.label) ? "label: string expected" : g.url != null && g.hasOwnProperty("url") && !$util$1.isString(g.url) ? "url: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.SubtitleTrack) return g;
    let d = new $root$1.SubtitleTrack();
    return g.label != null && (d.label = String(g.label)), g.url != null && (d.url = String(g.url)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.label = "", k.url = ""), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.url != null && g.hasOwnProperty("url") && (k.url = g.url), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/SubtitleTrack";
  }, n;
})();
const Video$1 = $root$1.Video = (() => {
  function n(g) {
    if (this.subtitles = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.url = "", n.prototype.startTime = 0, n.prototype.type = 0, n.prototype.subtitles = $util$1.emptyArray, n.prototype.endTime = 0, n.prototype.loop = !1, n.prototype.autoplay = !1, n.prototype.muted = !1, n.prototype.id = "", n.prototype.widthConfig = null;
  let t;
  return Object.defineProperty(n.prototype, "_widthConfig", { get: $util$1.oneOfGetter(t = ["widthConfig"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    if (k || (k = $Writer$1.create()), d.startTime != null && Object.hasOwnProperty.call(d, "startTime") && k.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(d.startTime), d.type != null && Object.hasOwnProperty.call(d, "type") && k.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(d.type), d.url != null && Object.hasOwnProperty.call(d, "url") && k.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(d.url), d.subtitles != null && d.subtitles.length) for (let H = 0; H < d.subtitles.length; ++H) $root$1.SubtitleTrack.encode(d.subtitles[H], k.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim();
    return d.endTime != null && Object.hasOwnProperty.call(d, "endTime") && k.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(d.endTime), d.loop != null && Object.hasOwnProperty.call(d, "loop") && k.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(d.loop), d.autoplay != null && Object.hasOwnProperty.call(d, "autoplay") && k.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(d.autoplay), d.muted != null && Object.hasOwnProperty.call(d, "muted") && k.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(d.muted), d.id != null && Object.hasOwnProperty.call(d, "id") && k.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(d.id), d.widthConfig != null && Object.hasOwnProperty.call(d, "widthConfig") && $root$1.streamlit.WidthConfig.encode(d.widthConfig, k.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.Video();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 6: {
          gA.url = d.string();
          break;
        }
        case 3: {
          gA.startTime = d.int32();
          break;
        }
        case 5: {
          gA.type = d.int32();
          break;
        }
        case 7: {
          gA.subtitles && gA.subtitles.length || (gA.subtitles = []), gA.subtitles.push($root$1.SubtitleTrack.decode(d, d.uint32()));
          break;
        }
        case 8: {
          gA.endTime = d.int32();
          break;
        }
        case 9: {
          gA.loop = d.bool();
          break;
        }
        case 10: {
          gA.autoplay = d.bool();
          break;
        }
        case 11: {
          gA.muted = d.bool();
          break;
        }
        case 12: {
          gA.id = d.string();
          break;
        }
        case 13: {
          gA.widthConfig = $root$1.streamlit.WidthConfig.decode(d, d.uint32());
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.url != null && d.hasOwnProperty("url") && !$util$1.isString(d.url)) return "url: string expected";
    if (d.startTime != null && d.hasOwnProperty("startTime") && !$util$1.isInteger(d.startTime)) return "startTime: integer expected";
    if (d.type != null && d.hasOwnProperty("type")) switch (d.type) {
      default:
        return "type: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (d.subtitles != null && d.hasOwnProperty("subtitles")) {
      if (!Array.isArray(d.subtitles)) return "subtitles: array expected";
      for (let k = 0; k < d.subtitles.length; ++k) {
        let H = $root$1.SubtitleTrack.verify(d.subtitles[k]);
        if (H) return "subtitles." + H;
      }
    }
    if (d.endTime != null && d.hasOwnProperty("endTime") && !$util$1.isInteger(d.endTime)) return "endTime: integer expected";
    if (d.loop != null && d.hasOwnProperty("loop") && typeof d.loop != "boolean") return "loop: boolean expected";
    if (d.autoplay != null && d.hasOwnProperty("autoplay") && typeof d.autoplay != "boolean") return "autoplay: boolean expected";
    if (d.muted != null && d.hasOwnProperty("muted") && typeof d.muted != "boolean") return "muted: boolean expected";
    if (d.id != null && d.hasOwnProperty("id") && !$util$1.isString(d.id)) return "id: string expected";
    if (d.widthConfig != null && d.hasOwnProperty("widthConfig")) {
      let k = $root$1.streamlit.WidthConfig.verify(d.widthConfig);
      if (k) return "widthConfig." + k;
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.Video) return d;
    let k = new $root$1.Video();
    switch (d.url != null && (k.url = String(d.url)), d.startTime != null && (k.startTime = d.startTime | 0), d.type) {
      default:
        if (typeof d.type == "number") {
          k.type = d.type;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        k.type = 0;
        break;
      case "NATIVE":
      case 1:
        k.type = 1;
        break;
      case "YOUTUBE_IFRAME":
      case 2:
        k.type = 2;
        break;
    }
    if (d.subtitles) {
      if (!Array.isArray(d.subtitles)) throw TypeError(".Video.subtitles: array expected");
      k.subtitles = [];
      for (let H = 0; H < d.subtitles.length; ++H) {
        if (typeof d.subtitles[H] != "object") throw TypeError(".Video.subtitles: object expected");
        k.subtitles[H] = $root$1.SubtitleTrack.fromObject(d.subtitles[H]);
      }
    }
    if (d.endTime != null && (k.endTime = d.endTime | 0), d.loop != null && (k.loop = !!d.loop), d.autoplay != null && (k.autoplay = !!d.autoplay), d.muted != null && (k.muted = !!d.muted), d.id != null && (k.id = String(d.id)), d.widthConfig != null) {
      if (typeof d.widthConfig != "object") throw TypeError(".Video.widthConfig: object expected");
      k.widthConfig = $root$1.streamlit.WidthConfig.fromObject(d.widthConfig);
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    if ((k.arrays || k.defaults) && (H.subtitles = []), k.defaults && (H.startTime = 0, H.type = k.enums === String ? "UNUSED" : 0, H.url = "", H.endTime = 0, H.loop = !1, H.autoplay = !1, H.muted = !1, H.id = ""), d.startTime != null && d.hasOwnProperty("startTime") && (H.startTime = d.startTime), d.type != null && d.hasOwnProperty("type") && (H.type = k.enums === String ? $root$1.Video.Type[d.type] === void 0 ? d.type : $root$1.Video.Type[d.type] : d.type), d.url != null && d.hasOwnProperty("url") && (H.url = d.url), d.subtitles && d.subtitles.length) {
      H.subtitles = [];
      for (let AA = 0; AA < d.subtitles.length; ++AA) H.subtitles[AA] = $root$1.SubtitleTrack.toObject(d.subtitles[AA], k);
    }
    return d.endTime != null && d.hasOwnProperty("endTime") && (H.endTime = d.endTime), d.loop != null && d.hasOwnProperty("loop") && (H.loop = d.loop), d.autoplay != null && d.hasOwnProperty("autoplay") && (H.autoplay = d.autoplay), d.muted != null && d.hasOwnProperty("muted") && (H.muted = d.muted), d.id != null && d.hasOwnProperty("id") && (H.id = d.id), d.widthConfig != null && d.hasOwnProperty("widthConfig") && (H.widthConfig = $root$1.streamlit.WidthConfig.toObject(d.widthConfig, k), k.oneofs && (H._widthConfig = "widthConfig")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/Video";
  }, n.Type = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "UNUSED"] = 0, d[g[1] = "NATIVE"] = 1, d[g[2] = "YOUTUBE_IFRAME"] = 2, d;
  })(), n;
})();
$root$1.Heading = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.tag = "", n.prototype.anchor = "", n.prototype.body = "", n.prototype.help = "", n.prototype.hideAnchor = !1, n.prototype.divider = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.tag != null && Object.hasOwnProperty.call(g, "tag") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.tag), g.anchor != null && Object.hasOwnProperty.call(g, "anchor") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.anchor), g.body != null && Object.hasOwnProperty.call(g, "body") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.body), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.hideAnchor != null && Object.hasOwnProperty.call(g, "hideAnchor") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.hideAnchor), g.divider != null && Object.hasOwnProperty.call(g, "divider") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.divider), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Heading();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.tag = g.string();
          break;
        }
        case 2: {
          AA.anchor = g.string();
          break;
        }
        case 3: {
          AA.body = g.string();
          break;
        }
        case 4: {
          AA.help = g.string();
          break;
        }
        case 5: {
          AA.hideAnchor = g.bool();
          break;
        }
        case 6: {
          AA.divider = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.tag != null && g.hasOwnProperty("tag") && !$util$1.isString(g.tag) ? "tag: string expected" : g.anchor != null && g.hasOwnProperty("anchor") && !$util$1.isString(g.anchor) ? "anchor: string expected" : g.body != null && g.hasOwnProperty("body") && !$util$1.isString(g.body) ? "body: string expected" : g.help != null && g.hasOwnProperty("help") && !$util$1.isString(g.help) ? "help: string expected" : g.hideAnchor != null && g.hasOwnProperty("hideAnchor") && typeof g.hideAnchor != "boolean" ? "hideAnchor: boolean expected" : g.divider != null && g.hasOwnProperty("divider") && !$util$1.isString(g.divider) ? "divider: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Heading) return g;
    let d = new $root$1.Heading();
    return g.tag != null && (d.tag = String(g.tag)), g.anchor != null && (d.anchor = String(g.anchor)), g.body != null && (d.body = String(g.body)), g.help != null && (d.help = String(g.help)), g.hideAnchor != null && (d.hideAnchor = !!g.hideAnchor), g.divider != null && (d.divider = String(g.divider)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.tag = "", k.anchor = "", k.body = "", k.help = "", k.hideAnchor = !1, k.divider = ""), g.tag != null && g.hasOwnProperty("tag") && (k.tag = g.tag), g.anchor != null && g.hasOwnProperty("anchor") && (k.anchor = g.anchor), g.body != null && g.hasOwnProperty("body") && (k.body = g.body), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.hideAnchor != null && g.hasOwnProperty("hideAnchor") && (k.hideAnchor = g.hideAnchor), g.divider != null && g.hasOwnProperty("divider") && (k.divider = g.divider), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Heading";
  }, n;
})();
const ForwardMsg = $root$1.ForwardMsg = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.hash = "", n.prototype.metadata = null, n.prototype.newSession = null, n.prototype.delta = null, n.prototype.pageInfoChanged = null, n.prototype.pageConfigChanged = null, n.prototype.scriptFinished = null, n.prototype.gitInfoChanged = null, n.prototype.pageProfile = null, n.prototype.sessionStatusChanged = null, n.prototype.sessionEvent = null, n.prototype.navigation = null, n.prototype.pageNotFound = null, n.prototype.pagesChanged = null, n.prototype.fileUrlsResponse = null, n.prototype.autoRerun = null, n.prototype.logo = null, n.prototype.authRedirect = null, n.prototype.parentMessage = null, n.prototype.refHash = null, n.prototype.debugLastBackmsgId = "";
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util$1.oneOfGetter(t = ["newSession", "delta", "pageInfoChanged", "pageConfigChanged", "scriptFinished", "gitInfoChanged", "pageProfile", "sessionStatusChanged", "sessionEvent", "navigation", "pageNotFound", "pagesChanged", "fileUrlsResponse", "autoRerun", "logo", "authRedirect", "parentMessage", "refHash"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.hash != null && Object.hasOwnProperty.call(d, "hash") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.hash), d.metadata != null && Object.hasOwnProperty.call(d, "metadata") && $root$1.ForwardMsgMetadata.encode(d.metadata, k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), d.newSession != null && Object.hasOwnProperty.call(d, "newSession") && $root$1.NewSession.encode(d.newSession, k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), d.delta != null && Object.hasOwnProperty.call(d, "delta") && $root$1.Delta.encode(d.delta, k.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), d.scriptFinished != null && Object.hasOwnProperty.call(d, "scriptFinished") && k.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(d.scriptFinished), d.sessionStatusChanged != null && Object.hasOwnProperty.call(d, "sessionStatusChanged") && $root$1.SessionStatus.encode(d.sessionStatusChanged, k.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), d.sessionEvent != null && Object.hasOwnProperty.call(d, "sessionEvent") && $root$1.SessionEvent.encode(d.sessionEvent, k.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), d.refHash != null && Object.hasOwnProperty.call(d, "refHash") && k.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(d.refHash), d.pageInfoChanged != null && Object.hasOwnProperty.call(d, "pageInfoChanged") && $root$1.PageInfo.encode(d.pageInfoChanged, k.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), d.pageConfigChanged != null && Object.hasOwnProperty.call(d, "pageConfigChanged") && $root$1.PageConfig.encode(d.pageConfigChanged, k.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), d.gitInfoChanged != null && Object.hasOwnProperty.call(d, "gitInfoChanged") && $root$1.GitInfo.encode(d.gitInfoChanged, k.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), d.pageNotFound != null && Object.hasOwnProperty.call(d, "pageNotFound") && $root$1.PageNotFound.encode(d.pageNotFound, k.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), d.pagesChanged != null && Object.hasOwnProperty.call(d, "pagesChanged") && $root$1.PagesChanged.encode(d.pagesChanged, k.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), d.debugLastBackmsgId != null && Object.hasOwnProperty.call(d, "debugLastBackmsgId") && k.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(d.debugLastBackmsgId), d.pageProfile != null && Object.hasOwnProperty.call(d, "pageProfile") && $root$1.PageProfile.encode(d.pageProfile, k.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), d.fileUrlsResponse != null && Object.hasOwnProperty.call(d, "fileUrlsResponse") && $root$1.FileURLsResponse.encode(d.fileUrlsResponse, k.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), d.parentMessage != null && Object.hasOwnProperty.call(d, "parentMessage") && $root$1.ParentMessage.encode(d.parentMessage, k.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), d.autoRerun != null && Object.hasOwnProperty.call(d, "autoRerun") && $root$1.AutoRerun.encode(d.autoRerun, k.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), d.logo != null && Object.hasOwnProperty.call(d, "logo") && $root$1.Logo.encode(d.logo, k.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), d.navigation != null && Object.hasOwnProperty.call(d, "navigation") && $root$1.Navigation.encode(d.navigation, k.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), d.authRedirect != null && Object.hasOwnProperty.call(d, "authRedirect") && $root$1.AuthRedirect.encode(d.authRedirect, k.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.ForwardMsg();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.hash = d.string();
          break;
        }
        case 2: {
          gA.metadata = $root$1.ForwardMsgMetadata.decode(d, d.uint32());
          break;
        }
        case 4: {
          gA.newSession = $root$1.NewSession.decode(d, d.uint32());
          break;
        }
        case 5: {
          gA.delta = $root$1.Delta.decode(d, d.uint32());
          break;
        }
        case 12: {
          gA.pageInfoChanged = $root$1.PageInfo.decode(d, d.uint32());
          break;
        }
        case 13: {
          gA.pageConfigChanged = $root$1.PageConfig.decode(d, d.uint32());
          break;
        }
        case 6: {
          gA.scriptFinished = d.int32();
          break;
        }
        case 14: {
          gA.gitInfoChanged = $root$1.GitInfo.decode(d, d.uint32());
          break;
        }
        case 18: {
          gA.pageProfile = $root$1.PageProfile.decode(d, d.uint32());
          break;
        }
        case 9: {
          gA.sessionStatusChanged = $root$1.SessionStatus.decode(d, d.uint32());
          break;
        }
        case 10: {
          gA.sessionEvent = $root$1.SessionEvent.decode(d, d.uint32());
          break;
        }
        case 23: {
          gA.navigation = $root$1.Navigation.decode(d, d.uint32());
          break;
        }
        case 15: {
          gA.pageNotFound = $root$1.PageNotFound.decode(d, d.uint32());
          break;
        }
        case 16: {
          gA.pagesChanged = $root$1.PagesChanged.decode(d, d.uint32());
          break;
        }
        case 19: {
          gA.fileUrlsResponse = $root$1.FileURLsResponse.decode(d, d.uint32());
          break;
        }
        case 21: {
          gA.autoRerun = $root$1.AutoRerun.decode(d, d.uint32());
          break;
        }
        case 22: {
          gA.logo = $root$1.Logo.decode(d, d.uint32());
          break;
        }
        case 24: {
          gA.authRedirect = $root$1.AuthRedirect.decode(d, d.uint32());
          break;
        }
        case 20: {
          gA.parentMessage = $root$1.ParentMessage.decode(d, d.uint32());
          break;
        }
        case 11: {
          gA.refHash = d.string();
          break;
        }
        case 17: {
          gA.debugLastBackmsgId = d.string();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.hash != null && d.hasOwnProperty("hash") && !$util$1.isString(d.hash)) return "hash: string expected";
    if (d.metadata != null && d.hasOwnProperty("metadata")) {
      let H = $root$1.ForwardMsgMetadata.verify(d.metadata);
      if (H) return "metadata." + H;
    }
    if (d.newSession != null && d.hasOwnProperty("newSession")) {
      k.type = 1;
      {
        let H = $root$1.NewSession.verify(d.newSession);
        if (H) return "newSession." + H;
      }
    }
    if (d.delta != null && d.hasOwnProperty("delta")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Delta.verify(d.delta);
        if (H) return "delta." + H;
      }
    }
    if (d.pageInfoChanged != null && d.hasOwnProperty("pageInfoChanged")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.PageInfo.verify(d.pageInfoChanged);
        if (H) return "pageInfoChanged." + H;
      }
    }
    if (d.pageConfigChanged != null && d.hasOwnProperty("pageConfigChanged")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.PageConfig.verify(d.pageConfigChanged);
        if (H) return "pageConfigChanged." + H;
      }
    }
    if (d.scriptFinished != null && d.hasOwnProperty("scriptFinished")) {
      if (k.type === 1) return "type: multiple values";
      switch (k.type = 1, d.scriptFinished) {
        default:
          return "scriptFinished: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
          break;
      }
    }
    if (d.gitInfoChanged != null && d.hasOwnProperty("gitInfoChanged")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.GitInfo.verify(d.gitInfoChanged);
        if (H) return "gitInfoChanged." + H;
      }
    }
    if (d.pageProfile != null && d.hasOwnProperty("pageProfile")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.PageProfile.verify(d.pageProfile);
        if (H) return "pageProfile." + H;
      }
    }
    if (d.sessionStatusChanged != null && d.hasOwnProperty("sessionStatusChanged")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.SessionStatus.verify(d.sessionStatusChanged);
        if (H) return "sessionStatusChanged." + H;
      }
    }
    if (d.sessionEvent != null && d.hasOwnProperty("sessionEvent")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.SessionEvent.verify(d.sessionEvent);
        if (H) return "sessionEvent." + H;
      }
    }
    if (d.navigation != null && d.hasOwnProperty("navigation")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Navigation.verify(d.navigation);
        if (H) return "navigation." + H;
      }
    }
    if (d.pageNotFound != null && d.hasOwnProperty("pageNotFound")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.PageNotFound.verify(d.pageNotFound);
        if (H) return "pageNotFound." + H;
      }
    }
    if (d.pagesChanged != null && d.hasOwnProperty("pagesChanged")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.PagesChanged.verify(d.pagesChanged);
        if (H) return "pagesChanged." + H;
      }
    }
    if (d.fileUrlsResponse != null && d.hasOwnProperty("fileUrlsResponse")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.FileURLsResponse.verify(d.fileUrlsResponse);
        if (H) return "fileUrlsResponse." + H;
      }
    }
    if (d.autoRerun != null && d.hasOwnProperty("autoRerun")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.AutoRerun.verify(d.autoRerun);
        if (H) return "autoRerun." + H;
      }
    }
    if (d.logo != null && d.hasOwnProperty("logo")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Logo.verify(d.logo);
        if (H) return "logo." + H;
      }
    }
    if (d.authRedirect != null && d.hasOwnProperty("authRedirect")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.AuthRedirect.verify(d.authRedirect);
        if (H) return "authRedirect." + H;
      }
    }
    if (d.parentMessage != null && d.hasOwnProperty("parentMessage")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.ParentMessage.verify(d.parentMessage);
        if (H) return "parentMessage." + H;
      }
    }
    if (d.refHash != null && d.hasOwnProperty("refHash")) {
      if (k.type === 1) return "type: multiple values";
      if (k.type = 1, !$util$1.isString(d.refHash)) return "refHash: string expected";
    }
    return d.debugLastBackmsgId != null && d.hasOwnProperty("debugLastBackmsgId") && !$util$1.isString(d.debugLastBackmsgId) ? "debugLastBackmsgId: string expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.ForwardMsg) return d;
    let k = new $root$1.ForwardMsg();
    if (d.hash != null && (k.hash = String(d.hash)), d.metadata != null) {
      if (typeof d.metadata != "object") throw TypeError(".ForwardMsg.metadata: object expected");
      k.metadata = $root$1.ForwardMsgMetadata.fromObject(d.metadata);
    }
    if (d.newSession != null) {
      if (typeof d.newSession != "object") throw TypeError(".ForwardMsg.newSession: object expected");
      k.newSession = $root$1.NewSession.fromObject(d.newSession);
    }
    if (d.delta != null) {
      if (typeof d.delta != "object") throw TypeError(".ForwardMsg.delta: object expected");
      k.delta = $root$1.Delta.fromObject(d.delta);
    }
    if (d.pageInfoChanged != null) {
      if (typeof d.pageInfoChanged != "object") throw TypeError(".ForwardMsg.pageInfoChanged: object expected");
      k.pageInfoChanged = $root$1.PageInfo.fromObject(d.pageInfoChanged);
    }
    if (d.pageConfigChanged != null) {
      if (typeof d.pageConfigChanged != "object") throw TypeError(".ForwardMsg.pageConfigChanged: object expected");
      k.pageConfigChanged = $root$1.PageConfig.fromObject(d.pageConfigChanged);
    }
    switch (d.scriptFinished) {
      default:
        if (typeof d.scriptFinished == "number") {
          k.scriptFinished = d.scriptFinished;
          break;
        }
        break;
      case "FINISHED_SUCCESSFULLY":
      case 0:
        k.scriptFinished = 0;
        break;
      case "FINISHED_WITH_COMPILE_ERROR":
      case 1:
        k.scriptFinished = 1;
        break;
      case "FINISHED_EARLY_FOR_RERUN":
      case 2:
        k.scriptFinished = 2;
        break;
      case "FINISHED_FRAGMENT_RUN_SUCCESSFULLY":
      case 3:
        k.scriptFinished = 3;
        break;
    }
    if (d.gitInfoChanged != null) {
      if (typeof d.gitInfoChanged != "object") throw TypeError(".ForwardMsg.gitInfoChanged: object expected");
      k.gitInfoChanged = $root$1.GitInfo.fromObject(d.gitInfoChanged);
    }
    if (d.pageProfile != null) {
      if (typeof d.pageProfile != "object") throw TypeError(".ForwardMsg.pageProfile: object expected");
      k.pageProfile = $root$1.PageProfile.fromObject(d.pageProfile);
    }
    if (d.sessionStatusChanged != null) {
      if (typeof d.sessionStatusChanged != "object") throw TypeError(".ForwardMsg.sessionStatusChanged: object expected");
      k.sessionStatusChanged = $root$1.SessionStatus.fromObject(d.sessionStatusChanged);
    }
    if (d.sessionEvent != null) {
      if (typeof d.sessionEvent != "object") throw TypeError(".ForwardMsg.sessionEvent: object expected");
      k.sessionEvent = $root$1.SessionEvent.fromObject(d.sessionEvent);
    }
    if (d.navigation != null) {
      if (typeof d.navigation != "object") throw TypeError(".ForwardMsg.navigation: object expected");
      k.navigation = $root$1.Navigation.fromObject(d.navigation);
    }
    if (d.pageNotFound != null) {
      if (typeof d.pageNotFound != "object") throw TypeError(".ForwardMsg.pageNotFound: object expected");
      k.pageNotFound = $root$1.PageNotFound.fromObject(d.pageNotFound);
    }
    if (d.pagesChanged != null) {
      if (typeof d.pagesChanged != "object") throw TypeError(".ForwardMsg.pagesChanged: object expected");
      k.pagesChanged = $root$1.PagesChanged.fromObject(d.pagesChanged);
    }
    if (d.fileUrlsResponse != null) {
      if (typeof d.fileUrlsResponse != "object") throw TypeError(".ForwardMsg.fileUrlsResponse: object expected");
      k.fileUrlsResponse = $root$1.FileURLsResponse.fromObject(d.fileUrlsResponse);
    }
    if (d.autoRerun != null) {
      if (typeof d.autoRerun != "object") throw TypeError(".ForwardMsg.autoRerun: object expected");
      k.autoRerun = $root$1.AutoRerun.fromObject(d.autoRerun);
    }
    if (d.logo != null) {
      if (typeof d.logo != "object") throw TypeError(".ForwardMsg.logo: object expected");
      k.logo = $root$1.Logo.fromObject(d.logo);
    }
    if (d.authRedirect != null) {
      if (typeof d.authRedirect != "object") throw TypeError(".ForwardMsg.authRedirect: object expected");
      k.authRedirect = $root$1.AuthRedirect.fromObject(d.authRedirect);
    }
    if (d.parentMessage != null) {
      if (typeof d.parentMessage != "object") throw TypeError(".ForwardMsg.parentMessage: object expected");
      k.parentMessage = $root$1.ParentMessage.fromObject(d.parentMessage);
    }
    return d.refHash != null && (k.refHash = String(d.refHash)), d.debugLastBackmsgId != null && (k.debugLastBackmsgId = String(d.debugLastBackmsgId)), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return k.defaults && (H.hash = "", H.metadata = null, H.debugLastBackmsgId = ""), d.hash != null && d.hasOwnProperty("hash") && (H.hash = d.hash), d.metadata != null && d.hasOwnProperty("metadata") && (H.metadata = $root$1.ForwardMsgMetadata.toObject(d.metadata, k)), d.newSession != null && d.hasOwnProperty("newSession") && (H.newSession = $root$1.NewSession.toObject(d.newSession, k), k.oneofs && (H.type = "newSession")), d.delta != null && d.hasOwnProperty("delta") && (H.delta = $root$1.Delta.toObject(d.delta, k), k.oneofs && (H.type = "delta")), d.scriptFinished != null && d.hasOwnProperty("scriptFinished") && (H.scriptFinished = k.enums === String ? $root$1.ForwardMsg.ScriptFinishedStatus[d.scriptFinished] === void 0 ? d.scriptFinished : $root$1.ForwardMsg.ScriptFinishedStatus[d.scriptFinished] : d.scriptFinished, k.oneofs && (H.type = "scriptFinished")), d.sessionStatusChanged != null && d.hasOwnProperty("sessionStatusChanged") && (H.sessionStatusChanged = $root$1.SessionStatus.toObject(d.sessionStatusChanged, k), k.oneofs && (H.type = "sessionStatusChanged")), d.sessionEvent != null && d.hasOwnProperty("sessionEvent") && (H.sessionEvent = $root$1.SessionEvent.toObject(d.sessionEvent, k), k.oneofs && (H.type = "sessionEvent")), d.refHash != null && d.hasOwnProperty("refHash") && (H.refHash = d.refHash, k.oneofs && (H.type = "refHash")), d.pageInfoChanged != null && d.hasOwnProperty("pageInfoChanged") && (H.pageInfoChanged = $root$1.PageInfo.toObject(d.pageInfoChanged, k), k.oneofs && (H.type = "pageInfoChanged")), d.pageConfigChanged != null && d.hasOwnProperty("pageConfigChanged") && (H.pageConfigChanged = $root$1.PageConfig.toObject(d.pageConfigChanged, k), k.oneofs && (H.type = "pageConfigChanged")), d.gitInfoChanged != null && d.hasOwnProperty("gitInfoChanged") && (H.gitInfoChanged = $root$1.GitInfo.toObject(d.gitInfoChanged, k), k.oneofs && (H.type = "gitInfoChanged")), d.pageNotFound != null && d.hasOwnProperty("pageNotFound") && (H.pageNotFound = $root$1.PageNotFound.toObject(d.pageNotFound, k), k.oneofs && (H.type = "pageNotFound")), d.pagesChanged != null && d.hasOwnProperty("pagesChanged") && (H.pagesChanged = $root$1.PagesChanged.toObject(d.pagesChanged, k), k.oneofs && (H.type = "pagesChanged")), d.debugLastBackmsgId != null && d.hasOwnProperty("debugLastBackmsgId") && (H.debugLastBackmsgId = d.debugLastBackmsgId), d.pageProfile != null && d.hasOwnProperty("pageProfile") && (H.pageProfile = $root$1.PageProfile.toObject(d.pageProfile, k), k.oneofs && (H.type = "pageProfile")), d.fileUrlsResponse != null && d.hasOwnProperty("fileUrlsResponse") && (H.fileUrlsResponse = $root$1.FileURLsResponse.toObject(d.fileUrlsResponse, k), k.oneofs && (H.type = "fileUrlsResponse")), d.parentMessage != null && d.hasOwnProperty("parentMessage") && (H.parentMessage = $root$1.ParentMessage.toObject(d.parentMessage, k), k.oneofs && (H.type = "parentMessage")), d.autoRerun != null && d.hasOwnProperty("autoRerun") && (H.autoRerun = $root$1.AutoRerun.toObject(d.autoRerun, k), k.oneofs && (H.type = "autoRerun")), d.logo != null && d.hasOwnProperty("logo") && (H.logo = $root$1.Logo.toObject(d.logo, k), k.oneofs && (H.type = "logo")), d.navigation != null && d.hasOwnProperty("navigation") && (H.navigation = $root$1.Navigation.toObject(d.navigation, k), k.oneofs && (H.type = "navigation")), d.authRedirect != null && d.hasOwnProperty("authRedirect") && (H.authRedirect = $root$1.AuthRedirect.toObject(d.authRedirect, k), k.oneofs && (H.type = "authRedirect")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/ForwardMsg";
  }, n.ScriptFinishedStatus = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "FINISHED_SUCCESSFULLY"] = 0, d[g[1] = "FINISHED_WITH_COMPILE_ERROR"] = 1, d[g[2] = "FINISHED_EARLY_FOR_RERUN"] = 2, d[g[3] = "FINISHED_FRAGMENT_RUN_SUCCESSFULLY"] = 3, d;
  })(), n;
})(), ForwardMsgMetadata = $root$1.ForwardMsgMetadata = (() => {
  function n(t) {
    if (this.deltaPath = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.cacheable = !1, n.prototype.deltaPath = $util$1.emptyArray, n.prototype.elementDimensionSpec = null, n.prototype.activeScriptHash = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.cacheable != null && Object.hasOwnProperty.call(g, "cacheable") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(g.cacheable), g.deltaPath != null && g.deltaPath.length) {
      d.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork();
      for (let k = 0; k < g.deltaPath.length; ++k) d.uint32(g.deltaPath[k]);
      d.ldelim();
    }
    return g.elementDimensionSpec != null && Object.hasOwnProperty.call(g, "elementDimensionSpec") && $root$1.ElementDimensionSpec.encode(g.elementDimensionSpec, d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.activeScriptHash != null && Object.hasOwnProperty.call(g, "activeScriptHash") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.activeScriptHash), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ForwardMsgMetadata();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.cacheable = g.bool();
          break;
        }
        case 2: {
          if (AA.deltaPath && AA.deltaPath.length || (AA.deltaPath = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.deltaPath.push(g.uint32());
          } else AA.deltaPath.push(g.uint32());
          break;
        }
        case 3: {
          AA.elementDimensionSpec = $root$1.ElementDimensionSpec.decode(g, g.uint32());
          break;
        }
        case 4: {
          AA.activeScriptHash = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.cacheable != null && g.hasOwnProperty("cacheable") && typeof g.cacheable != "boolean") return "cacheable: boolean expected";
    if (g.deltaPath != null && g.hasOwnProperty("deltaPath")) {
      if (!Array.isArray(g.deltaPath)) return "deltaPath: array expected";
      for (let d = 0; d < g.deltaPath.length; ++d) if (!$util$1.isInteger(g.deltaPath[d])) return "deltaPath: integer[] expected";
    }
    if (g.elementDimensionSpec != null && g.hasOwnProperty("elementDimensionSpec")) {
      let d = $root$1.ElementDimensionSpec.verify(g.elementDimensionSpec);
      if (d) return "elementDimensionSpec." + d;
    }
    return g.activeScriptHash != null && g.hasOwnProperty("activeScriptHash") && !$util$1.isString(g.activeScriptHash) ? "activeScriptHash: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ForwardMsgMetadata) return g;
    let d = new $root$1.ForwardMsgMetadata();
    if (g.cacheable != null && (d.cacheable = !!g.cacheable), g.deltaPath) {
      if (!Array.isArray(g.deltaPath)) throw TypeError(".ForwardMsgMetadata.deltaPath: array expected");
      d.deltaPath = [];
      for (let k = 0; k < g.deltaPath.length; ++k) d.deltaPath[k] = g.deltaPath[k] >>> 0;
    }
    if (g.elementDimensionSpec != null) {
      if (typeof g.elementDimensionSpec != "object") throw TypeError(".ForwardMsgMetadata.elementDimensionSpec: object expected");
      d.elementDimensionSpec = $root$1.ElementDimensionSpec.fromObject(g.elementDimensionSpec);
    }
    return g.activeScriptHash != null && (d.activeScriptHash = String(g.activeScriptHash)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.deltaPath = []), d.defaults && (k.cacheable = !1, k.elementDimensionSpec = null, k.activeScriptHash = ""), g.cacheable != null && g.hasOwnProperty("cacheable") && (k.cacheable = g.cacheable), g.deltaPath && g.deltaPath.length) {
      k.deltaPath = [];
      for (let H = 0; H < g.deltaPath.length; ++H) k.deltaPath[H] = g.deltaPath[H];
    }
    return g.elementDimensionSpec != null && g.hasOwnProperty("elementDimensionSpec") && (k.elementDimensionSpec = $root$1.ElementDimensionSpec.toObject(g.elementDimensionSpec, d)), g.activeScriptHash != null && g.hasOwnProperty("activeScriptHash") && (k.activeScriptHash = g.activeScriptHash), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ForwardMsgMetadata";
  }, n;
})();
$root$1.ElementDimensionSpec = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.width = 0, n.prototype.height = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.width != null && Object.hasOwnProperty.call(g, "width") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(g.width), g.height != null && Object.hasOwnProperty.call(g, "height") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(g.height), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ElementDimensionSpec();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.width = g.uint32();
          break;
        }
        case 2: {
          AA.height = g.uint32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.width != null && g.hasOwnProperty("width") && !$util$1.isInteger(g.width) ? "width: integer expected" : g.height != null && g.hasOwnProperty("height") && !$util$1.isInteger(g.height) ? "height: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ElementDimensionSpec) return g;
    let d = new $root$1.ElementDimensionSpec();
    return g.width != null && (d.width = g.width >>> 0), g.height != null && (d.height = g.height >>> 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.width = 0, k.height = 0), g.width != null && g.hasOwnProperty("width") && (k.width = g.width), g.height != null && g.hasOwnProperty("height") && (k.height = g.height), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ElementDimensionSpec";
  }, n;
})();
$root$1.ForwardMsgList = (() => {
  function n(t) {
    if (this.messages = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.messages = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.messages != null && g.messages.length) for (let k = 0; k < g.messages.length; ++k) $root$1.ForwardMsg.encode(g.messages[k], d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ForwardMsgList();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.messages && AA.messages.length || (AA.messages = []), AA.messages.push($root$1.ForwardMsg.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.messages != null && g.hasOwnProperty("messages")) {
      if (!Array.isArray(g.messages)) return "messages: array expected";
      for (let d = 0; d < g.messages.length; ++d) {
        let k = $root$1.ForwardMsg.verify(g.messages[d]);
        if (k) return "messages." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ForwardMsgList) return g;
    let d = new $root$1.ForwardMsgList();
    if (g.messages) {
      if (!Array.isArray(g.messages)) throw TypeError(".ForwardMsgList.messages: array expected");
      d.messages = [];
      for (let k = 0; k < g.messages.length; ++k) {
        if (typeof g.messages[k] != "object") throw TypeError(".ForwardMsgList.messages: object expected");
        d.messages[k] = $root$1.ForwardMsg.fromObject(g.messages[k]);
      }
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.messages = []), g.messages && g.messages.length) {
      k.messages = [];
      for (let H = 0; H < g.messages.length; ++H) k.messages[H] = $root$1.ForwardMsg.toObject(g.messages[H], d);
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ForwardMsgList";
  }, n;
})();
const GitInfo = $root$1.GitInfo = (() => {
  function n(t) {
    if (this.untrackedFiles = [], this.uncommittedFiles = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.repository = "", n.prototype.branch = "", n.prototype.module = "", n.prototype.untrackedFiles = $util$1.emptyArray, n.prototype.uncommittedFiles = $util$1.emptyArray, n.prototype.state = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.repository != null && Object.hasOwnProperty.call(g, "repository") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.repository), g.branch != null && Object.hasOwnProperty.call(g, "branch") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.branch), g.module != null && Object.hasOwnProperty.call(g, "module") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.module), g.untrackedFiles != null && g.untrackedFiles.length) for (let k = 0; k < g.untrackedFiles.length; ++k) d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.untrackedFiles[k]);
    if (g.uncommittedFiles != null && g.uncommittedFiles.length) for (let k = 0; k < g.uncommittedFiles.length; ++k) d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.uncommittedFiles[k]);
    return g.state != null && Object.hasOwnProperty.call(g, "state") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(g.state), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.GitInfo();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.repository = g.string();
          break;
        }
        case 2: {
          AA.branch = g.string();
          break;
        }
        case 3: {
          AA.module = g.string();
          break;
        }
        case 4: {
          AA.untrackedFiles && AA.untrackedFiles.length || (AA.untrackedFiles = []), AA.untrackedFiles.push(g.string());
          break;
        }
        case 5: {
          AA.uncommittedFiles && AA.uncommittedFiles.length || (AA.uncommittedFiles = []), AA.uncommittedFiles.push(g.string());
          break;
        }
        case 6: {
          AA.state = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.repository != null && g.hasOwnProperty("repository") && !$util$1.isString(g.repository)) return "repository: string expected";
    if (g.branch != null && g.hasOwnProperty("branch") && !$util$1.isString(g.branch)) return "branch: string expected";
    if (g.module != null && g.hasOwnProperty("module") && !$util$1.isString(g.module)) return "module: string expected";
    if (g.untrackedFiles != null && g.hasOwnProperty("untrackedFiles")) {
      if (!Array.isArray(g.untrackedFiles)) return "untrackedFiles: array expected";
      for (let d = 0; d < g.untrackedFiles.length; ++d) if (!$util$1.isString(g.untrackedFiles[d])) return "untrackedFiles: string[] expected";
    }
    if (g.uncommittedFiles != null && g.hasOwnProperty("uncommittedFiles")) {
      if (!Array.isArray(g.uncommittedFiles)) return "uncommittedFiles: array expected";
      for (let d = 0; d < g.uncommittedFiles.length; ++d) if (!$util$1.isString(g.uncommittedFiles[d])) return "uncommittedFiles: string[] expected";
    }
    if (g.state != null && g.hasOwnProperty("state")) switch (g.state) {
      default:
        return "state: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.GitInfo) return g;
    let d = new $root$1.GitInfo();
    if (g.repository != null && (d.repository = String(g.repository)), g.branch != null && (d.branch = String(g.branch)), g.module != null && (d.module = String(g.module)), g.untrackedFiles) {
      if (!Array.isArray(g.untrackedFiles)) throw TypeError(".GitInfo.untrackedFiles: array expected");
      d.untrackedFiles = [];
      for (let k = 0; k < g.untrackedFiles.length; ++k) d.untrackedFiles[k] = String(g.untrackedFiles[k]);
    }
    if (g.uncommittedFiles) {
      if (!Array.isArray(g.uncommittedFiles)) throw TypeError(".GitInfo.uncommittedFiles: array expected");
      d.uncommittedFiles = [];
      for (let k = 0; k < g.uncommittedFiles.length; ++k) d.uncommittedFiles[k] = String(g.uncommittedFiles[k]);
    }
    switch (g.state) {
      default:
        if (typeof g.state == "number") {
          d.state = g.state;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        d.state = 0;
        break;
      case "HEAD_DETACHED":
      case 1:
        d.state = 1;
        break;
      case "AHEAD_OF_REMOTE":
      case 2:
        d.state = 2;
        break;
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.untrackedFiles = [], k.uncommittedFiles = []), d.defaults && (k.repository = "", k.branch = "", k.module = "", k.state = d.enums === String ? "DEFAULT" : 0), g.repository != null && g.hasOwnProperty("repository") && (k.repository = g.repository), g.branch != null && g.hasOwnProperty("branch") && (k.branch = g.branch), g.module != null && g.hasOwnProperty("module") && (k.module = g.module), g.untrackedFiles && g.untrackedFiles.length) {
      k.untrackedFiles = [];
      for (let H = 0; H < g.untrackedFiles.length; ++H) k.untrackedFiles[H] = g.untrackedFiles[H];
    }
    if (g.uncommittedFiles && g.uncommittedFiles.length) {
      k.uncommittedFiles = [];
      for (let H = 0; H < g.uncommittedFiles.length; ++H) k.uncommittedFiles[H] = g.uncommittedFiles[H];
    }
    return g.state != null && g.hasOwnProperty("state") && (k.state = d.enums === String ? $root$1.GitInfo.GitStates[g.state] === void 0 ? g.state : $root$1.GitInfo.GitStates[g.state] : g.state), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/GitInfo";
  }, n.GitStates = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "DEFAULT"] = 0, g[t[1] = "HEAD_DETACHED"] = 1, g[t[2] = "AHEAD_OF_REMOTE"] = 2, g;
  })(), n;
})();
$root$1.Logo = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.image = "", n.prototype.link = "", n.prototype.iconImage = "", n.prototype.size = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.image != null && Object.hasOwnProperty.call(g, "image") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.image), g.link != null && Object.hasOwnProperty.call(g, "link") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.link), g.iconImage != null && Object.hasOwnProperty.call(g, "iconImage") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.iconImage), g.size != null && Object.hasOwnProperty.call(g, "size") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.size), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Logo();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.image = g.string();
          break;
        }
        case 2: {
          AA.link = g.string();
          break;
        }
        case 3: {
          AA.iconImage = g.string();
          break;
        }
        case 4: {
          AA.size = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.image != null && g.hasOwnProperty("image") && !$util$1.isString(g.image) ? "image: string expected" : g.link != null && g.hasOwnProperty("link") && !$util$1.isString(g.link) ? "link: string expected" : g.iconImage != null && g.hasOwnProperty("iconImage") && !$util$1.isString(g.iconImage) ? "iconImage: string expected" : g.size != null && g.hasOwnProperty("size") && !$util$1.isString(g.size) ? "size: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Logo) return g;
    let d = new $root$1.Logo();
    return g.image != null && (d.image = String(g.image)), g.link != null && (d.link = String(g.link)), g.iconImage != null && (d.iconImage = String(g.iconImage)), g.size != null && (d.size = String(g.size)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.image = "", k.link = "", k.iconImage = "", k.size = ""), g.image != null && g.hasOwnProperty("image") && (k.image = g.image), g.link != null && g.hasOwnProperty("link") && (k.link = g.link), g.iconImage != null && g.hasOwnProperty("iconImage") && (k.iconImage = g.iconImage), g.size != null && g.hasOwnProperty("size") && (k.size = g.size), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Logo";
  }, n;
})();
const Navigation = $root$1.Navigation = (() => {
  function n(t) {
    if (this.sections = [], this.appPages = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.sections = $util$1.emptyArray, n.prototype.appPages = $util$1.emptyArray, n.prototype.position = 0, n.prototype.pageScriptHash = "", n.prototype.expanded = !1, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.sections != null && g.sections.length) for (let k = 0; k < g.sections.length; ++k) d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.sections[k]);
    if (g.appPages != null && g.appPages.length) for (let k = 0; k < g.appPages.length; ++k) $root$1.AppPage.encode(g.appPages[k], d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return g.position != null && Object.hasOwnProperty.call(g, "position") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.position), g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.pageScriptHash), g.expanded != null && Object.hasOwnProperty.call(g, "expanded") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.expanded), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Navigation();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.sections && AA.sections.length || (AA.sections = []), AA.sections.push(g.string());
          break;
        }
        case 2: {
          AA.appPages && AA.appPages.length || (AA.appPages = []), AA.appPages.push($root$1.AppPage.decode(g, g.uint32()));
          break;
        }
        case 3: {
          AA.position = g.int32();
          break;
        }
        case 4: {
          AA.pageScriptHash = g.string();
          break;
        }
        case 5: {
          AA.expanded = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.sections != null && g.hasOwnProperty("sections")) {
      if (!Array.isArray(g.sections)) return "sections: array expected";
      for (let d = 0; d < g.sections.length; ++d) if (!$util$1.isString(g.sections[d])) return "sections: string[] expected";
    }
    if (g.appPages != null && g.hasOwnProperty("appPages")) {
      if (!Array.isArray(g.appPages)) return "appPages: array expected";
      for (let d = 0; d < g.appPages.length; ++d) {
        let k = $root$1.AppPage.verify(g.appPages[d]);
        if (k) return "appPages." + k;
      }
    }
    if (g.position != null && g.hasOwnProperty("position")) switch (g.position) {
      default:
        return "position: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    return g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && !$util$1.isString(g.pageScriptHash) ? "pageScriptHash: string expected" : g.expanded != null && g.hasOwnProperty("expanded") && typeof g.expanded != "boolean" ? "expanded: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Navigation) return g;
    let d = new $root$1.Navigation();
    if (g.sections) {
      if (!Array.isArray(g.sections)) throw TypeError(".Navigation.sections: array expected");
      d.sections = [];
      for (let k = 0; k < g.sections.length; ++k) d.sections[k] = String(g.sections[k]);
    }
    if (g.appPages) {
      if (!Array.isArray(g.appPages)) throw TypeError(".Navigation.appPages: array expected");
      d.appPages = [];
      for (let k = 0; k < g.appPages.length; ++k) {
        if (typeof g.appPages[k] != "object") throw TypeError(".Navigation.appPages: object expected");
        d.appPages[k] = $root$1.AppPage.fromObject(g.appPages[k]);
      }
    }
    switch (g.position) {
      default:
        if (typeof g.position == "number") {
          d.position = g.position;
          break;
        }
        break;
      case "HIDDEN":
      case 0:
        d.position = 0;
        break;
      case "SIDEBAR":
      case 1:
        d.position = 1;
        break;
      case "TOP":
      case 2:
        d.position = 2;
        break;
    }
    return g.pageScriptHash != null && (d.pageScriptHash = String(g.pageScriptHash)), g.expanded != null && (d.expanded = !!g.expanded), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.sections = [], k.appPages = []), d.defaults && (k.position = d.enums === String ? "HIDDEN" : 0, k.pageScriptHash = "", k.expanded = !1), g.sections && g.sections.length) {
      k.sections = [];
      for (let H = 0; H < g.sections.length; ++H) k.sections[H] = g.sections[H];
    }
    if (g.appPages && g.appPages.length) {
      k.appPages = [];
      for (let H = 0; H < g.appPages.length; ++H) k.appPages[H] = $root$1.AppPage.toObject(g.appPages[H], d);
    }
    return g.position != null && g.hasOwnProperty("position") && (k.position = d.enums === String ? $root$1.Navigation.Position[g.position] === void 0 ? g.position : $root$1.Navigation.Position[g.position] : g.position), g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (k.pageScriptHash = g.pageScriptHash), g.expanded != null && g.hasOwnProperty("expanded") && (k.expanded = g.expanded), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Navigation";
  }, n.Position = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "HIDDEN"] = 0, g[t[1] = "SIDEBAR"] = 1, g[t[2] = "TOP"] = 2, g;
  })(), n;
})();
$root$1.NewSession = (() => {
  function n(t) {
    if (this.appPages = [], this.fragmentIdsThisRun = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.initialize = null, n.prototype.scriptRunId = "", n.prototype.name = "", n.prototype.mainScriptPath = "", n.prototype.config = null, n.prototype.customTheme = null, n.prototype.appPages = $util$1.emptyArray, n.prototype.pageScriptHash = "", n.prototype.fragmentIdsThisRun = $util$1.emptyArray, n.prototype.mainScriptHash = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.initialize != null && Object.hasOwnProperty.call(g, "initialize") && $root$1.Initialize.encode(g.initialize, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.scriptRunId != null && Object.hasOwnProperty.call(g, "scriptRunId") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.scriptRunId), g.name != null && Object.hasOwnProperty.call(g, "name") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.name), g.mainScriptPath != null && Object.hasOwnProperty.call(g, "mainScriptPath") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.mainScriptPath), g.config != null && Object.hasOwnProperty.call(g, "config") && $root$1.Config.encode(g.config, d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.customTheme != null && Object.hasOwnProperty.call(g, "customTheme") && $root$1.CustomThemeConfig.encode(g.customTheme, d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.appPages != null && g.appPages.length) for (let k = 0; k < g.appPages.length; ++k) $root$1.AppPage.encode(g.appPages[k], d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    if (g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.pageScriptHash), g.fragmentIdsThisRun != null && g.fragmentIdsThisRun.length) for (let k = 0; k < g.fragmentIdsThisRun.length; ++k) d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.fragmentIdsThisRun[k]);
    return g.mainScriptHash != null && Object.hasOwnProperty.call(g, "mainScriptHash") && d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.mainScriptHash), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.NewSession();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.initialize = $root$1.Initialize.decode(g, g.uint32());
          break;
        }
        case 2: {
          AA.scriptRunId = g.string();
          break;
        }
        case 3: {
          AA.name = g.string();
          break;
        }
        case 4: {
          AA.mainScriptPath = g.string();
          break;
        }
        case 6: {
          AA.config = $root$1.Config.decode(g, g.uint32());
          break;
        }
        case 7: {
          AA.customTheme = $root$1.CustomThemeConfig.decode(g, g.uint32());
          break;
        }
        case 8: {
          AA.appPages && AA.appPages.length || (AA.appPages = []), AA.appPages.push($root$1.AppPage.decode(g, g.uint32()));
          break;
        }
        case 9: {
          AA.pageScriptHash = g.string();
          break;
        }
        case 10: {
          AA.fragmentIdsThisRun && AA.fragmentIdsThisRun.length || (AA.fragmentIdsThisRun = []), AA.fragmentIdsThisRun.push(g.string());
          break;
        }
        case 11: {
          AA.mainScriptHash = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.initialize != null && g.hasOwnProperty("initialize")) {
      let d = $root$1.Initialize.verify(g.initialize);
      if (d) return "initialize." + d;
    }
    if (g.scriptRunId != null && g.hasOwnProperty("scriptRunId") && !$util$1.isString(g.scriptRunId)) return "scriptRunId: string expected";
    if (g.name != null && g.hasOwnProperty("name") && !$util$1.isString(g.name)) return "name: string expected";
    if (g.mainScriptPath != null && g.hasOwnProperty("mainScriptPath") && !$util$1.isString(g.mainScriptPath)) return "mainScriptPath: string expected";
    if (g.config != null && g.hasOwnProperty("config")) {
      let d = $root$1.Config.verify(g.config);
      if (d) return "config." + d;
    }
    if (g.customTheme != null && g.hasOwnProperty("customTheme")) {
      let d = $root$1.CustomThemeConfig.verify(g.customTheme);
      if (d) return "customTheme." + d;
    }
    if (g.appPages != null && g.hasOwnProperty("appPages")) {
      if (!Array.isArray(g.appPages)) return "appPages: array expected";
      for (let d = 0; d < g.appPages.length; ++d) {
        let k = $root$1.AppPage.verify(g.appPages[d]);
        if (k) return "appPages." + k;
      }
    }
    if (g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && !$util$1.isString(g.pageScriptHash)) return "pageScriptHash: string expected";
    if (g.fragmentIdsThisRun != null && g.hasOwnProperty("fragmentIdsThisRun")) {
      if (!Array.isArray(g.fragmentIdsThisRun)) return "fragmentIdsThisRun: array expected";
      for (let d = 0; d < g.fragmentIdsThisRun.length; ++d) if (!$util$1.isString(g.fragmentIdsThisRun[d])) return "fragmentIdsThisRun: string[] expected";
    }
    return g.mainScriptHash != null && g.hasOwnProperty("mainScriptHash") && !$util$1.isString(g.mainScriptHash) ? "mainScriptHash: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.NewSession) return g;
    let d = new $root$1.NewSession();
    if (g.initialize != null) {
      if (typeof g.initialize != "object") throw TypeError(".NewSession.initialize: object expected");
      d.initialize = $root$1.Initialize.fromObject(g.initialize);
    }
    if (g.scriptRunId != null && (d.scriptRunId = String(g.scriptRunId)), g.name != null && (d.name = String(g.name)), g.mainScriptPath != null && (d.mainScriptPath = String(g.mainScriptPath)), g.config != null) {
      if (typeof g.config != "object") throw TypeError(".NewSession.config: object expected");
      d.config = $root$1.Config.fromObject(g.config);
    }
    if (g.customTheme != null) {
      if (typeof g.customTheme != "object") throw TypeError(".NewSession.customTheme: object expected");
      d.customTheme = $root$1.CustomThemeConfig.fromObject(g.customTheme);
    }
    if (g.appPages) {
      if (!Array.isArray(g.appPages)) throw TypeError(".NewSession.appPages: array expected");
      d.appPages = [];
      for (let k = 0; k < g.appPages.length; ++k) {
        if (typeof g.appPages[k] != "object") throw TypeError(".NewSession.appPages: object expected");
        d.appPages[k] = $root$1.AppPage.fromObject(g.appPages[k]);
      }
    }
    if (g.pageScriptHash != null && (d.pageScriptHash = String(g.pageScriptHash)), g.fragmentIdsThisRun) {
      if (!Array.isArray(g.fragmentIdsThisRun)) throw TypeError(".NewSession.fragmentIdsThisRun: array expected");
      d.fragmentIdsThisRun = [];
      for (let k = 0; k < g.fragmentIdsThisRun.length; ++k) d.fragmentIdsThisRun[k] = String(g.fragmentIdsThisRun[k]);
    }
    return g.mainScriptHash != null && (d.mainScriptHash = String(g.mainScriptHash)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.appPages = [], k.fragmentIdsThisRun = []), d.defaults && (k.initialize = null, k.scriptRunId = "", k.name = "", k.mainScriptPath = "", k.config = null, k.customTheme = null, k.pageScriptHash = "", k.mainScriptHash = ""), g.initialize != null && g.hasOwnProperty("initialize") && (k.initialize = $root$1.Initialize.toObject(g.initialize, d)), g.scriptRunId != null && g.hasOwnProperty("scriptRunId") && (k.scriptRunId = g.scriptRunId), g.name != null && g.hasOwnProperty("name") && (k.name = g.name), g.mainScriptPath != null && g.hasOwnProperty("mainScriptPath") && (k.mainScriptPath = g.mainScriptPath), g.config != null && g.hasOwnProperty("config") && (k.config = $root$1.Config.toObject(g.config, d)), g.customTheme != null && g.hasOwnProperty("customTheme") && (k.customTheme = $root$1.CustomThemeConfig.toObject(g.customTheme, d)), g.appPages && g.appPages.length) {
      k.appPages = [];
      for (let H = 0; H < g.appPages.length; ++H) k.appPages[H] = $root$1.AppPage.toObject(g.appPages[H], d);
    }
    if (g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (k.pageScriptHash = g.pageScriptHash), g.fragmentIdsThisRun && g.fragmentIdsThisRun.length) {
      k.fragmentIdsThisRun = [];
      for (let H = 0; H < g.fragmentIdsThisRun.length; ++H) k.fragmentIdsThisRun[H] = g.fragmentIdsThisRun[H];
    }
    return g.mainScriptHash != null && g.hasOwnProperty("mainScriptHash") && (k.mainScriptHash = g.mainScriptHash), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/NewSession";
  }, n;
})();
$root$1.Initialize = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.userInfo = null, n.prototype.environmentInfo = null, n.prototype.sessionStatus = null, n.prototype.commandLine = "", n.prototype.sessionId = "", n.prototype.isHello = !1, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.userInfo != null && Object.hasOwnProperty.call(g, "userInfo") && $root$1.UserInfo.encode(g.userInfo, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.environmentInfo != null && Object.hasOwnProperty.call(g, "environmentInfo") && $root$1.EnvironmentInfo.encode(g.environmentInfo, d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.sessionStatus != null && Object.hasOwnProperty.call(g, "sessionStatus") && $root$1.SessionStatus.encode(g.sessionStatus, d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.commandLine != null && Object.hasOwnProperty.call(g, "commandLine") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.commandLine), g.sessionId != null && Object.hasOwnProperty.call(g, "sessionId") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.sessionId), g.isHello != null && Object.hasOwnProperty.call(g, "isHello") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.isHello), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Initialize();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.userInfo = $root$1.UserInfo.decode(g, g.uint32());
          break;
        }
        case 3: {
          AA.environmentInfo = $root$1.EnvironmentInfo.decode(g, g.uint32());
          break;
        }
        case 4: {
          AA.sessionStatus = $root$1.SessionStatus.decode(g, g.uint32());
          break;
        }
        case 5: {
          AA.commandLine = g.string();
          break;
        }
        case 6: {
          AA.sessionId = g.string();
          break;
        }
        case 7: {
          AA.isHello = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.userInfo != null && g.hasOwnProperty("userInfo")) {
      let d = $root$1.UserInfo.verify(g.userInfo);
      if (d) return "userInfo." + d;
    }
    if (g.environmentInfo != null && g.hasOwnProperty("environmentInfo")) {
      let d = $root$1.EnvironmentInfo.verify(g.environmentInfo);
      if (d) return "environmentInfo." + d;
    }
    if (g.sessionStatus != null && g.hasOwnProperty("sessionStatus")) {
      let d = $root$1.SessionStatus.verify(g.sessionStatus);
      if (d) return "sessionStatus." + d;
    }
    return g.commandLine != null && g.hasOwnProperty("commandLine") && !$util$1.isString(g.commandLine) ? "commandLine: string expected" : g.sessionId != null && g.hasOwnProperty("sessionId") && !$util$1.isString(g.sessionId) ? "sessionId: string expected" : g.isHello != null && g.hasOwnProperty("isHello") && typeof g.isHello != "boolean" ? "isHello: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Initialize) return g;
    let d = new $root$1.Initialize();
    if (g.userInfo != null) {
      if (typeof g.userInfo != "object") throw TypeError(".Initialize.userInfo: object expected");
      d.userInfo = $root$1.UserInfo.fromObject(g.userInfo);
    }
    if (g.environmentInfo != null) {
      if (typeof g.environmentInfo != "object") throw TypeError(".Initialize.environmentInfo: object expected");
      d.environmentInfo = $root$1.EnvironmentInfo.fromObject(g.environmentInfo);
    }
    if (g.sessionStatus != null) {
      if (typeof g.sessionStatus != "object") throw TypeError(".Initialize.sessionStatus: object expected");
      d.sessionStatus = $root$1.SessionStatus.fromObject(g.sessionStatus);
    }
    return g.commandLine != null && (d.commandLine = String(g.commandLine)), g.sessionId != null && (d.sessionId = String(g.sessionId)), g.isHello != null && (d.isHello = !!g.isHello), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.userInfo = null, k.environmentInfo = null, k.sessionStatus = null, k.commandLine = "", k.sessionId = "", k.isHello = !1), g.userInfo != null && g.hasOwnProperty("userInfo") && (k.userInfo = $root$1.UserInfo.toObject(g.userInfo, d)), g.environmentInfo != null && g.hasOwnProperty("environmentInfo") && (k.environmentInfo = $root$1.EnvironmentInfo.toObject(g.environmentInfo, d)), g.sessionStatus != null && g.hasOwnProperty("sessionStatus") && (k.sessionStatus = $root$1.SessionStatus.toObject(g.sessionStatus, d)), g.commandLine != null && g.hasOwnProperty("commandLine") && (k.commandLine = g.commandLine), g.sessionId != null && g.hasOwnProperty("sessionId") && (k.sessionId = g.sessionId), g.isHello != null && g.hasOwnProperty("isHello") && (k.isHello = g.isHello), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Initialize";
  }, n;
})();
const Config = $root$1.Config = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.gatherUsageStats = !1, n.prototype.maxCachedMessageAge = 0, n.prototype.mapboxToken = "", n.prototype.allowRunOnSave = !1, n.prototype.hideTopBar = !1, n.prototype.hideSidebarNav = !1, n.prototype.toolbarMode = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.gatherUsageStats != null && Object.hasOwnProperty.call(g, "gatherUsageStats") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.gatherUsageStats), g.maxCachedMessageAge != null && Object.hasOwnProperty.call(g, "maxCachedMessageAge") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.maxCachedMessageAge), g.mapboxToken != null && Object.hasOwnProperty.call(g, "mapboxToken") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.mapboxToken), g.allowRunOnSave != null && Object.hasOwnProperty.call(g, "allowRunOnSave") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.allowRunOnSave), g.hideTopBar != null && Object.hasOwnProperty.call(g, "hideTopBar") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.hideTopBar), g.hideSidebarNav != null && Object.hasOwnProperty.call(g, "hideSidebarNav") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.hideSidebarNav), g.toolbarMode != null && Object.hasOwnProperty.call(g, "toolbarMode") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.toolbarMode), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Config();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 2: {
          AA.gatherUsageStats = g.bool();
          break;
        }
        case 3: {
          AA.maxCachedMessageAge = g.int32();
          break;
        }
        case 4: {
          AA.mapboxToken = g.string();
          break;
        }
        case 5: {
          AA.allowRunOnSave = g.bool();
          break;
        }
        case 6: {
          AA.hideTopBar = g.bool();
          break;
        }
        case 7: {
          AA.hideSidebarNav = g.bool();
          break;
        }
        case 8: {
          AA.toolbarMode = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.gatherUsageStats != null && g.hasOwnProperty("gatherUsageStats") && typeof g.gatherUsageStats != "boolean") return "gatherUsageStats: boolean expected";
    if (g.maxCachedMessageAge != null && g.hasOwnProperty("maxCachedMessageAge") && !$util$1.isInteger(g.maxCachedMessageAge)) return "maxCachedMessageAge: integer expected";
    if (g.mapboxToken != null && g.hasOwnProperty("mapboxToken") && !$util$1.isString(g.mapboxToken)) return "mapboxToken: string expected";
    if (g.allowRunOnSave != null && g.hasOwnProperty("allowRunOnSave") && typeof g.allowRunOnSave != "boolean") return "allowRunOnSave: boolean expected";
    if (g.hideTopBar != null && g.hasOwnProperty("hideTopBar") && typeof g.hideTopBar != "boolean") return "hideTopBar: boolean expected";
    if (g.hideSidebarNav != null && g.hasOwnProperty("hideSidebarNav") && typeof g.hideSidebarNav != "boolean") return "hideSidebarNav: boolean expected";
    if (g.toolbarMode != null && g.hasOwnProperty("toolbarMode")) switch (g.toolbarMode) {
      default:
        return "toolbarMode: enum value expected";
      case 0:
      case 1:
      case 2:
      case 3:
        break;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Config) return g;
    let d = new $root$1.Config();
    switch (g.gatherUsageStats != null && (d.gatherUsageStats = !!g.gatherUsageStats), g.maxCachedMessageAge != null && (d.maxCachedMessageAge = g.maxCachedMessageAge | 0), g.mapboxToken != null && (d.mapboxToken = String(g.mapboxToken)), g.allowRunOnSave != null && (d.allowRunOnSave = !!g.allowRunOnSave), g.hideTopBar != null && (d.hideTopBar = !!g.hideTopBar), g.hideSidebarNav != null && (d.hideSidebarNav = !!g.hideSidebarNav), g.toolbarMode) {
      default:
        if (typeof g.toolbarMode == "number") {
          d.toolbarMode = g.toolbarMode;
          break;
        }
        break;
      case "AUTO":
      case 0:
        d.toolbarMode = 0;
        break;
      case "DEVELOPER":
      case 1:
        d.toolbarMode = 1;
        break;
      case "VIEWER":
      case 2:
        d.toolbarMode = 2;
        break;
      case "MINIMAL":
      case 3:
        d.toolbarMode = 3;
        break;
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.gatherUsageStats = !1, k.maxCachedMessageAge = 0, k.mapboxToken = "", k.allowRunOnSave = !1, k.hideTopBar = !1, k.hideSidebarNav = !1, k.toolbarMode = d.enums === String ? "AUTO" : 0), g.gatherUsageStats != null && g.hasOwnProperty("gatherUsageStats") && (k.gatherUsageStats = g.gatherUsageStats), g.maxCachedMessageAge != null && g.hasOwnProperty("maxCachedMessageAge") && (k.maxCachedMessageAge = g.maxCachedMessageAge), g.mapboxToken != null && g.hasOwnProperty("mapboxToken") && (k.mapboxToken = g.mapboxToken), g.allowRunOnSave != null && g.hasOwnProperty("allowRunOnSave") && (k.allowRunOnSave = g.allowRunOnSave), g.hideTopBar != null && g.hasOwnProperty("hideTopBar") && (k.hideTopBar = g.hideTopBar), g.hideSidebarNav != null && g.hasOwnProperty("hideSidebarNav") && (k.hideSidebarNav = g.hideSidebarNav), g.toolbarMode != null && g.hasOwnProperty("toolbarMode") && (k.toolbarMode = d.enums === String ? $root$1.Config.ToolbarMode[g.toolbarMode] === void 0 ? g.toolbarMode : $root$1.Config.ToolbarMode[g.toolbarMode] : g.toolbarMode), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Config";
  }, n.ToolbarMode = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "AUTO"] = 0, g[t[1] = "DEVELOPER"] = 1, g[t[2] = "VIEWER"] = 2, g[t[3] = "MINIMAL"] = 3, g;
  })(), n;
})(), CustomThemeConfig = $root$1.CustomThemeConfig = (() => {
  function n(g) {
    if (this.fontFaces = [], this.fontSources = [], this.headingFontSizes = [], this.headingFontWeights = [], this.chartCategoricalColors = [], this.chartSequentialColors = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.primaryColor = "", n.prototype.secondaryBackgroundColor = "", n.prototype.backgroundColor = "", n.prototype.textColor = "", n.prototype.font = 0, n.prototype.base = 0, n.prototype.widgetBackgroundColor = "", n.prototype.widgetBorderColor = "", n.prototype.radii = null, n.prototype.headingFont = "", n.prototype.bodyFont = "", n.prototype.codeFont = "", n.prototype.fontFaces = $util$1.emptyArray, n.prototype.fontSources = $util$1.emptyArray, n.prototype.fontSizes = null, n.prototype.skeletonBackgroundColor = "", n.prototype.baseRadius = null, n.prototype.buttonRadius = null, n.prototype.borderColor = null, n.prototype.dataframeBorderColor = null, n.prototype.showWidgetBorder = null, n.prototype.linkColor = null, n.prototype.linkUnderline = null, n.prototype.baseFontSize = null, n.prototype.baseFontWeight = null, n.prototype.codeFontWeight = null, n.prototype.codeFontSize = null, n.prototype.headingFontSizes = $util$1.emptyArray, n.prototype.headingFontWeights = $util$1.emptyArray, n.prototype.showSidebarBorder = null, n.prototype.sidebar = null, n.prototype.codeBackgroundColor = null, n.prototype.dataframeHeaderBackgroundColor = null, n.prototype.chartCategoricalColors = $util$1.emptyArray, n.prototype.chartSequentialColors = $util$1.emptyArray, n.prototype.redColor = null, n.prototype.orangeColor = null, n.prototype.yellowColor = null, n.prototype.blueColor = null, n.prototype.greenColor = null, n.prototype.violetColor = null, n.prototype.grayColor = null, n.prototype.redBackgroundColor = null, n.prototype.orangeBackgroundColor = null, n.prototype.yellowBackgroundColor = null, n.prototype.blueBackgroundColor = null, n.prototype.greenBackgroundColor = null, n.prototype.violetBackgroundColor = null, n.prototype.grayBackgroundColor = null, n.prototype.redTextColor = null, n.prototype.orangeTextColor = null, n.prototype.yellowTextColor = null, n.prototype.blueTextColor = null, n.prototype.greenTextColor = null, n.prototype.violetTextColor = null, n.prototype.grayTextColor = null;
  let t;
  return Object.defineProperty(n.prototype, "_baseRadius", { get: $util$1.oneOfGetter(t = ["baseRadius"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_buttonRadius", { get: $util$1.oneOfGetter(t = ["buttonRadius"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_borderColor", { get: $util$1.oneOfGetter(t = ["borderColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_dataframeBorderColor", { get: $util$1.oneOfGetter(t = ["dataframeBorderColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_showWidgetBorder", { get: $util$1.oneOfGetter(t = ["showWidgetBorder"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_linkColor", { get: $util$1.oneOfGetter(t = ["linkColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_linkUnderline", { get: $util$1.oneOfGetter(t = ["linkUnderline"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_baseFontSize", { get: $util$1.oneOfGetter(t = ["baseFontSize"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_baseFontWeight", { get: $util$1.oneOfGetter(t = ["baseFontWeight"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_codeFontWeight", { get: $util$1.oneOfGetter(t = ["codeFontWeight"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_codeFontSize", { get: $util$1.oneOfGetter(t = ["codeFontSize"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_showSidebarBorder", { get: $util$1.oneOfGetter(t = ["showSidebarBorder"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_sidebar", { get: $util$1.oneOfGetter(t = ["sidebar"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_codeBackgroundColor", { get: $util$1.oneOfGetter(t = ["codeBackgroundColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_dataframeHeaderBackgroundColor", { get: $util$1.oneOfGetter(t = ["dataframeHeaderBackgroundColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_redColor", { get: $util$1.oneOfGetter(t = ["redColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_orangeColor", { get: $util$1.oneOfGetter(t = ["orangeColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_yellowColor", { get: $util$1.oneOfGetter(t = ["yellowColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_blueColor", { get: $util$1.oneOfGetter(t = ["blueColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_greenColor", { get: $util$1.oneOfGetter(t = ["greenColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_violetColor", { get: $util$1.oneOfGetter(t = ["violetColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_grayColor", { get: $util$1.oneOfGetter(t = ["grayColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_redBackgroundColor", { get: $util$1.oneOfGetter(t = ["redBackgroundColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_orangeBackgroundColor", { get: $util$1.oneOfGetter(t = ["orangeBackgroundColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_yellowBackgroundColor", { get: $util$1.oneOfGetter(t = ["yellowBackgroundColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_blueBackgroundColor", { get: $util$1.oneOfGetter(t = ["blueBackgroundColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_greenBackgroundColor", { get: $util$1.oneOfGetter(t = ["greenBackgroundColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_violetBackgroundColor", { get: $util$1.oneOfGetter(t = ["violetBackgroundColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_grayBackgroundColor", { get: $util$1.oneOfGetter(t = ["grayBackgroundColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_redTextColor", { get: $util$1.oneOfGetter(t = ["redTextColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_orangeTextColor", { get: $util$1.oneOfGetter(t = ["orangeTextColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_yellowTextColor", { get: $util$1.oneOfGetter(t = ["yellowTextColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_blueTextColor", { get: $util$1.oneOfGetter(t = ["blueTextColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_greenTextColor", { get: $util$1.oneOfGetter(t = ["greenTextColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_violetTextColor", { get: $util$1.oneOfGetter(t = ["violetTextColor"]), set: $util$1.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_grayTextColor", { get: $util$1.oneOfGetter(t = ["grayTextColor"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    if (k || (k = $Writer$1.create()), d.primaryColor != null && Object.hasOwnProperty.call(d, "primaryColor") && k.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(d.primaryColor), d.secondaryBackgroundColor != null && Object.hasOwnProperty.call(d, "secondaryBackgroundColor") && k.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(d.secondaryBackgroundColor), d.backgroundColor != null && Object.hasOwnProperty.call(d, "backgroundColor") && k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(d.backgroundColor), d.textColor != null && Object.hasOwnProperty.call(d, "textColor") && k.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(d.textColor), d.font != null && Object.hasOwnProperty.call(d, "font") && k.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(d.font), d.base != null && Object.hasOwnProperty.call(d, "base") && k.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(d.base), d.widgetBackgroundColor != null && Object.hasOwnProperty.call(d, "widgetBackgroundColor") && k.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(d.widgetBackgroundColor), d.widgetBorderColor != null && Object.hasOwnProperty.call(d, "widgetBorderColor") && k.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(d.widgetBorderColor), d.radii != null && Object.hasOwnProperty.call(d, "radii") && $root$1.Radii.encode(d.radii, k.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), d.headingFont != null && Object.hasOwnProperty.call(d, "headingFont") && k.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(d.headingFont), d.bodyFont != null && Object.hasOwnProperty.call(d, "bodyFont") && k.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(d.bodyFont), d.codeFont != null && Object.hasOwnProperty.call(d, "codeFont") && k.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(d.codeFont), d.fontFaces != null && d.fontFaces.length) for (let H = 0; H < d.fontFaces.length; ++H) $root$1.FontFace.encode(d.fontFaces[H], k.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim();
    if (d.fontSizes != null && Object.hasOwnProperty.call(d, "fontSizes") && $root$1.FontSizes.encode(d.fontSizes, k.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), d.skeletonBackgroundColor != null && Object.hasOwnProperty.call(d, "skeletonBackgroundColor") && k.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(d.skeletonBackgroundColor), d.baseRadius != null && Object.hasOwnProperty.call(d, "baseRadius") && k.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(d.baseRadius), d.borderColor != null && Object.hasOwnProperty.call(d, "borderColor") && k.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(d.borderColor), d.showWidgetBorder != null && Object.hasOwnProperty.call(d, "showWidgetBorder") && k.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(d.showWidgetBorder), d.linkColor != null && Object.hasOwnProperty.call(d, "linkColor") && k.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(d.linkColor), d.baseFontSize != null && Object.hasOwnProperty.call(d, "baseFontSize") && k.uint32(
      /* id 22, wireType 0 =*/
      176
    ).int32(d.baseFontSize), d.showSidebarBorder != null && Object.hasOwnProperty.call(d, "showSidebarBorder") && k.uint32(
      /* id 23, wireType 0 =*/
      184
    ).bool(d.showSidebarBorder), d.sidebar != null && Object.hasOwnProperty.call(d, "sidebar") && $root$1.CustomThemeConfig.encode(d.sidebar, k.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), d.codeBackgroundColor != null && Object.hasOwnProperty.call(d, "codeBackgroundColor") && k.uint32(
      /* id 25, wireType 2 =*/
      202
    ).string(d.codeBackgroundColor), d.buttonRadius != null && Object.hasOwnProperty.call(d, "buttonRadius") && k.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(d.buttonRadius), d.dataframeBorderColor != null && Object.hasOwnProperty.call(d, "dataframeBorderColor") && k.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(d.dataframeBorderColor), d.codeFontSize != null && Object.hasOwnProperty.call(d, "codeFontSize") && k.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(d.codeFontSize), d.linkUnderline != null && Object.hasOwnProperty.call(d, "linkUnderline") && k.uint32(
      /* id 29, wireType 0 =*/
      232
    ).bool(d.linkUnderline), d.baseFontWeight != null && Object.hasOwnProperty.call(d, "baseFontWeight") && k.uint32(
      /* id 30, wireType 0 =*/
      240
    ).int32(d.baseFontWeight), d.dataframeHeaderBackgroundColor != null && Object.hasOwnProperty.call(d, "dataframeHeaderBackgroundColor") && k.uint32(
      /* id 31, wireType 2 =*/
      250
    ).string(d.dataframeHeaderBackgroundColor), d.codeFontWeight != null && Object.hasOwnProperty.call(d, "codeFontWeight") && k.uint32(
      /* id 32, wireType 0 =*/
      256
    ).int32(d.codeFontWeight), d.chartCategoricalColors != null && d.chartCategoricalColors.length) for (let H = 0; H < d.chartCategoricalColors.length; ++H) k.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(d.chartCategoricalColors[H]);
    if (d.headingFontWeights != null && d.headingFontWeights.length) {
      k.uint32(
        /* id 34, wireType 2 =*/
        274
      ).fork();
      for (let H = 0; H < d.headingFontWeights.length; ++H) k.int32(d.headingFontWeights[H]);
      k.ldelim();
    }
    if (d.headingFontSizes != null && d.headingFontSizes.length) for (let H = 0; H < d.headingFontSizes.length; ++H) k.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(d.headingFontSizes[H]);
    if (d.chartSequentialColors != null && d.chartSequentialColors.length) for (let H = 0; H < d.chartSequentialColors.length; ++H) k.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(d.chartSequentialColors[H]);
    if (d.fontSources != null && d.fontSources.length) for (let H = 0; H < d.fontSources.length; ++H) $root$1.FontSource.encode(d.fontSources[H], k.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim();
    return d.redColor != null && Object.hasOwnProperty.call(d, "redColor") && k.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(d.redColor), d.orangeColor != null && Object.hasOwnProperty.call(d, "orangeColor") && k.uint32(
      /* id 39, wireType 2 =*/
      314
    ).string(d.orangeColor), d.yellowColor != null && Object.hasOwnProperty.call(d, "yellowColor") && k.uint32(
      /* id 40, wireType 2 =*/
      322
    ).string(d.yellowColor), d.blueColor != null && Object.hasOwnProperty.call(d, "blueColor") && k.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(d.blueColor), d.greenColor != null && Object.hasOwnProperty.call(d, "greenColor") && k.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(d.greenColor), d.violetColor != null && Object.hasOwnProperty.call(d, "violetColor") && k.uint32(
      /* id 43, wireType 2 =*/
      346
    ).string(d.violetColor), d.grayColor != null && Object.hasOwnProperty.call(d, "grayColor") && k.uint32(
      /* id 44, wireType 2 =*/
      354
    ).string(d.grayColor), d.redBackgroundColor != null && Object.hasOwnProperty.call(d, "redBackgroundColor") && k.uint32(
      /* id 45, wireType 2 =*/
      362
    ).string(d.redBackgroundColor), d.orangeBackgroundColor != null && Object.hasOwnProperty.call(d, "orangeBackgroundColor") && k.uint32(
      /* id 46, wireType 2 =*/
      370
    ).string(d.orangeBackgroundColor), d.yellowBackgroundColor != null && Object.hasOwnProperty.call(d, "yellowBackgroundColor") && k.uint32(
      /* id 47, wireType 2 =*/
      378
    ).string(d.yellowBackgroundColor), d.blueBackgroundColor != null && Object.hasOwnProperty.call(d, "blueBackgroundColor") && k.uint32(
      /* id 48, wireType 2 =*/
      386
    ).string(d.blueBackgroundColor), d.greenBackgroundColor != null && Object.hasOwnProperty.call(d, "greenBackgroundColor") && k.uint32(
      /* id 49, wireType 2 =*/
      394
    ).string(d.greenBackgroundColor), d.violetBackgroundColor != null && Object.hasOwnProperty.call(d, "violetBackgroundColor") && k.uint32(
      /* id 50, wireType 2 =*/
      402
    ).string(d.violetBackgroundColor), d.grayBackgroundColor != null && Object.hasOwnProperty.call(d, "grayBackgroundColor") && k.uint32(
      /* id 51, wireType 2 =*/
      410
    ).string(d.grayBackgroundColor), d.redTextColor != null && Object.hasOwnProperty.call(d, "redTextColor") && k.uint32(
      /* id 52, wireType 2 =*/
      418
    ).string(d.redTextColor), d.orangeTextColor != null && Object.hasOwnProperty.call(d, "orangeTextColor") && k.uint32(
      /* id 53, wireType 2 =*/
      426
    ).string(d.orangeTextColor), d.yellowTextColor != null && Object.hasOwnProperty.call(d, "yellowTextColor") && k.uint32(
      /* id 54, wireType 2 =*/
      434
    ).string(d.yellowTextColor), d.blueTextColor != null && Object.hasOwnProperty.call(d, "blueTextColor") && k.uint32(
      /* id 55, wireType 2 =*/
      442
    ).string(d.blueTextColor), d.greenTextColor != null && Object.hasOwnProperty.call(d, "greenTextColor") && k.uint32(
      /* id 56, wireType 2 =*/
      450
    ).string(d.greenTextColor), d.violetTextColor != null && Object.hasOwnProperty.call(d, "violetTextColor") && k.uint32(
      /* id 57, wireType 2 =*/
      458
    ).string(d.violetTextColor), d.grayTextColor != null && Object.hasOwnProperty.call(d, "grayTextColor") && k.uint32(
      /* id 58, wireType 2 =*/
      466
    ).string(d.grayTextColor), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.CustomThemeConfig();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.primaryColor = d.string();
          break;
        }
        case 2: {
          gA.secondaryBackgroundColor = d.string();
          break;
        }
        case 3: {
          gA.backgroundColor = d.string();
          break;
        }
        case 4: {
          gA.textColor = d.string();
          break;
        }
        case 5: {
          gA.font = d.int32();
          break;
        }
        case 6: {
          gA.base = d.int32();
          break;
        }
        case 7: {
          gA.widgetBackgroundColor = d.string();
          break;
        }
        case 8: {
          gA.widgetBorderColor = d.string();
          break;
        }
        case 9: {
          gA.radii = $root$1.Radii.decode(d, d.uint32());
          break;
        }
        case 12: {
          gA.headingFont = d.string();
          break;
        }
        case 13: {
          gA.bodyFont = d.string();
          break;
        }
        case 14: {
          gA.codeFont = d.string();
          break;
        }
        case 15: {
          gA.fontFaces && gA.fontFaces.length || (gA.fontFaces = []), gA.fontFaces.push($root$1.FontFace.decode(d, d.uint32()));
          break;
        }
        case 37: {
          gA.fontSources && gA.fontSources.length || (gA.fontSources = []), gA.fontSources.push($root$1.FontSource.decode(d, d.uint32()));
          break;
        }
        case 16: {
          gA.fontSizes = $root$1.FontSizes.decode(d, d.uint32());
          break;
        }
        case 17: {
          gA.skeletonBackgroundColor = d.string();
          break;
        }
        case 18: {
          gA.baseRadius = d.string();
          break;
        }
        case 26: {
          gA.buttonRadius = d.string();
          break;
        }
        case 19: {
          gA.borderColor = d.string();
          break;
        }
        case 27: {
          gA.dataframeBorderColor = d.string();
          break;
        }
        case 20: {
          gA.showWidgetBorder = d.bool();
          break;
        }
        case 21: {
          gA.linkColor = d.string();
          break;
        }
        case 29: {
          gA.linkUnderline = d.bool();
          break;
        }
        case 22: {
          gA.baseFontSize = d.int32();
          break;
        }
        case 30: {
          gA.baseFontWeight = d.int32();
          break;
        }
        case 32: {
          gA.codeFontWeight = d.int32();
          break;
        }
        case 28: {
          gA.codeFontSize = d.string();
          break;
        }
        case 35: {
          gA.headingFontSizes && gA.headingFontSizes.length || (gA.headingFontSizes = []), gA.headingFontSizes.push(d.string());
          break;
        }
        case 34: {
          if (gA.headingFontWeights && gA.headingFontWeights.length || (gA.headingFontWeights = []), (IA & 7) === 2) {
            let CA = d.uint32() + d.pos;
            for (; d.pos < CA; ) gA.headingFontWeights.push(d.int32());
          } else gA.headingFontWeights.push(d.int32());
          break;
        }
        case 23: {
          gA.showSidebarBorder = d.bool();
          break;
        }
        case 24: {
          gA.sidebar = $root$1.CustomThemeConfig.decode(d, d.uint32());
          break;
        }
        case 25: {
          gA.codeBackgroundColor = d.string();
          break;
        }
        case 31: {
          gA.dataframeHeaderBackgroundColor = d.string();
          break;
        }
        case 33: {
          gA.chartCategoricalColors && gA.chartCategoricalColors.length || (gA.chartCategoricalColors = []), gA.chartCategoricalColors.push(d.string());
          break;
        }
        case 36: {
          gA.chartSequentialColors && gA.chartSequentialColors.length || (gA.chartSequentialColors = []), gA.chartSequentialColors.push(d.string());
          break;
        }
        case 38: {
          gA.redColor = d.string();
          break;
        }
        case 39: {
          gA.orangeColor = d.string();
          break;
        }
        case 40: {
          gA.yellowColor = d.string();
          break;
        }
        case 41: {
          gA.blueColor = d.string();
          break;
        }
        case 42: {
          gA.greenColor = d.string();
          break;
        }
        case 43: {
          gA.violetColor = d.string();
          break;
        }
        case 44: {
          gA.grayColor = d.string();
          break;
        }
        case 45: {
          gA.redBackgroundColor = d.string();
          break;
        }
        case 46: {
          gA.orangeBackgroundColor = d.string();
          break;
        }
        case 47: {
          gA.yellowBackgroundColor = d.string();
          break;
        }
        case 48: {
          gA.blueBackgroundColor = d.string();
          break;
        }
        case 49: {
          gA.greenBackgroundColor = d.string();
          break;
        }
        case 50: {
          gA.violetBackgroundColor = d.string();
          break;
        }
        case 51: {
          gA.grayBackgroundColor = d.string();
          break;
        }
        case 52: {
          gA.redTextColor = d.string();
          break;
        }
        case 53: {
          gA.orangeTextColor = d.string();
          break;
        }
        case 54: {
          gA.yellowTextColor = d.string();
          break;
        }
        case 55: {
          gA.blueTextColor = d.string();
          break;
        }
        case 56: {
          gA.greenTextColor = d.string();
          break;
        }
        case 57: {
          gA.violetTextColor = d.string();
          break;
        }
        case 58: {
          gA.grayTextColor = d.string();
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    if (d.primaryColor != null && d.hasOwnProperty("primaryColor") && !$util$1.isString(d.primaryColor)) return "primaryColor: string expected";
    if (d.secondaryBackgroundColor != null && d.hasOwnProperty("secondaryBackgroundColor") && !$util$1.isString(d.secondaryBackgroundColor)) return "secondaryBackgroundColor: string expected";
    if (d.backgroundColor != null && d.hasOwnProperty("backgroundColor") && !$util$1.isString(d.backgroundColor)) return "backgroundColor: string expected";
    if (d.textColor != null && d.hasOwnProperty("textColor") && !$util$1.isString(d.textColor)) return "textColor: string expected";
    if (d.font != null && d.hasOwnProperty("font")) switch (d.font) {
      default:
        return "font: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (d.base != null && d.hasOwnProperty("base")) switch (d.base) {
      default:
        return "base: enum value expected";
      case 0:
      case 1:
        break;
    }
    if (d.widgetBackgroundColor != null && d.hasOwnProperty("widgetBackgroundColor") && !$util$1.isString(d.widgetBackgroundColor)) return "widgetBackgroundColor: string expected";
    if (d.widgetBorderColor != null && d.hasOwnProperty("widgetBorderColor") && !$util$1.isString(d.widgetBorderColor)) return "widgetBorderColor: string expected";
    if (d.radii != null && d.hasOwnProperty("radii")) {
      let k = $root$1.Radii.verify(d.radii);
      if (k) return "radii." + k;
    }
    if (d.headingFont != null && d.hasOwnProperty("headingFont") && !$util$1.isString(d.headingFont)) return "headingFont: string expected";
    if (d.bodyFont != null && d.hasOwnProperty("bodyFont") && !$util$1.isString(d.bodyFont)) return "bodyFont: string expected";
    if (d.codeFont != null && d.hasOwnProperty("codeFont") && !$util$1.isString(d.codeFont)) return "codeFont: string expected";
    if (d.fontFaces != null && d.hasOwnProperty("fontFaces")) {
      if (!Array.isArray(d.fontFaces)) return "fontFaces: array expected";
      for (let k = 0; k < d.fontFaces.length; ++k) {
        let H = $root$1.FontFace.verify(d.fontFaces[k]);
        if (H) return "fontFaces." + H;
      }
    }
    if (d.fontSources != null && d.hasOwnProperty("fontSources")) {
      if (!Array.isArray(d.fontSources)) return "fontSources: array expected";
      for (let k = 0; k < d.fontSources.length; ++k) {
        let H = $root$1.FontSource.verify(d.fontSources[k]);
        if (H) return "fontSources." + H;
      }
    }
    if (d.fontSizes != null && d.hasOwnProperty("fontSizes")) {
      let k = $root$1.FontSizes.verify(d.fontSizes);
      if (k) return "fontSizes." + k;
    }
    if (d.skeletonBackgroundColor != null && d.hasOwnProperty("skeletonBackgroundColor") && !$util$1.isString(d.skeletonBackgroundColor)) return "skeletonBackgroundColor: string expected";
    if (d.baseRadius != null && d.hasOwnProperty("baseRadius") && !$util$1.isString(d.baseRadius))
      return "baseRadius: string expected";
    if (d.buttonRadius != null && d.hasOwnProperty("buttonRadius") && !$util$1.isString(d.buttonRadius))
      return "buttonRadius: string expected";
    if (d.borderColor != null && d.hasOwnProperty("borderColor") && !$util$1.isString(d.borderColor))
      return "borderColor: string expected";
    if (d.dataframeBorderColor != null && d.hasOwnProperty("dataframeBorderColor") && !$util$1.isString(d.dataframeBorderColor))
      return "dataframeBorderColor: string expected";
    if (d.showWidgetBorder != null && d.hasOwnProperty("showWidgetBorder") && typeof d.showWidgetBorder != "boolean")
      return "showWidgetBorder: boolean expected";
    if (d.linkColor != null && d.hasOwnProperty("linkColor") && !$util$1.isString(d.linkColor))
      return "linkColor: string expected";
    if (d.linkUnderline != null && d.hasOwnProperty("linkUnderline") && typeof d.linkUnderline != "boolean")
      return "linkUnderline: boolean expected";
    if (d.baseFontSize != null && d.hasOwnProperty("baseFontSize") && !$util$1.isInteger(d.baseFontSize))
      return "baseFontSize: integer expected";
    if (d.baseFontWeight != null && d.hasOwnProperty("baseFontWeight") && !$util$1.isInteger(d.baseFontWeight))
      return "baseFontWeight: integer expected";
    if (d.codeFontWeight != null && d.hasOwnProperty("codeFontWeight") && !$util$1.isInteger(d.codeFontWeight))
      return "codeFontWeight: integer expected";
    if (d.codeFontSize != null && d.hasOwnProperty("codeFontSize") && !$util$1.isString(d.codeFontSize))
      return "codeFontSize: string expected";
    if (d.headingFontSizes != null && d.hasOwnProperty("headingFontSizes")) {
      if (!Array.isArray(d.headingFontSizes)) return "headingFontSizes: array expected";
      for (let k = 0; k < d.headingFontSizes.length; ++k) if (!$util$1.isString(d.headingFontSizes[k])) return "headingFontSizes: string[] expected";
    }
    if (d.headingFontWeights != null && d.hasOwnProperty("headingFontWeights")) {
      if (!Array.isArray(d.headingFontWeights)) return "headingFontWeights: array expected";
      for (let k = 0; k < d.headingFontWeights.length; ++k) if (!$util$1.isInteger(d.headingFontWeights[k])) return "headingFontWeights: integer[] expected";
    }
    if (d.showSidebarBorder != null && d.hasOwnProperty("showSidebarBorder") && typeof d.showSidebarBorder != "boolean")
      return "showSidebarBorder: boolean expected";
    if (d.sidebar != null && d.hasOwnProperty("sidebar")) {
      let k = $root$1.CustomThemeConfig.verify(d.sidebar);
      if (k) return "sidebar." + k;
    }
    if (d.codeBackgroundColor != null && d.hasOwnProperty("codeBackgroundColor") && !$util$1.isString(d.codeBackgroundColor))
      return "codeBackgroundColor: string expected";
    if (d.dataframeHeaderBackgroundColor != null && d.hasOwnProperty("dataframeHeaderBackgroundColor") && !$util$1.isString(d.dataframeHeaderBackgroundColor))
      return "dataframeHeaderBackgroundColor: string expected";
    if (d.chartCategoricalColors != null && d.hasOwnProperty("chartCategoricalColors")) {
      if (!Array.isArray(d.chartCategoricalColors)) return "chartCategoricalColors: array expected";
      for (let k = 0; k < d.chartCategoricalColors.length; ++k) if (!$util$1.isString(d.chartCategoricalColors[k])) return "chartCategoricalColors: string[] expected";
    }
    if (d.chartSequentialColors != null && d.hasOwnProperty("chartSequentialColors")) {
      if (!Array.isArray(d.chartSequentialColors)) return "chartSequentialColors: array expected";
      for (let k = 0; k < d.chartSequentialColors.length; ++k) if (!$util$1.isString(d.chartSequentialColors[k])) return "chartSequentialColors: string[] expected";
    }
    return d.redColor != null && d.hasOwnProperty("redColor") && !$util$1.isString(d.redColor) ? "redColor: string expected" : d.orangeColor != null && d.hasOwnProperty("orangeColor") && !$util$1.isString(d.orangeColor) ? "orangeColor: string expected" : d.yellowColor != null && d.hasOwnProperty("yellowColor") && !$util$1.isString(d.yellowColor) ? "yellowColor: string expected" : d.blueColor != null && d.hasOwnProperty("blueColor") && !$util$1.isString(d.blueColor) ? "blueColor: string expected" : d.greenColor != null && d.hasOwnProperty("greenColor") && !$util$1.isString(d.greenColor) ? "greenColor: string expected" : d.violetColor != null && d.hasOwnProperty("violetColor") && !$util$1.isString(d.violetColor) ? "violetColor: string expected" : d.grayColor != null && d.hasOwnProperty("grayColor") && !$util$1.isString(d.grayColor) ? "grayColor: string expected" : d.redBackgroundColor != null && d.hasOwnProperty("redBackgroundColor") && !$util$1.isString(d.redBackgroundColor) ? "redBackgroundColor: string expected" : d.orangeBackgroundColor != null && d.hasOwnProperty("orangeBackgroundColor") && !$util$1.isString(d.orangeBackgroundColor) ? "orangeBackgroundColor: string expected" : d.yellowBackgroundColor != null && d.hasOwnProperty("yellowBackgroundColor") && !$util$1.isString(d.yellowBackgroundColor) ? "yellowBackgroundColor: string expected" : d.blueBackgroundColor != null && d.hasOwnProperty("blueBackgroundColor") && !$util$1.isString(d.blueBackgroundColor) ? "blueBackgroundColor: string expected" : d.greenBackgroundColor != null && d.hasOwnProperty("greenBackgroundColor") && !$util$1.isString(d.greenBackgroundColor) ? "greenBackgroundColor: string expected" : d.violetBackgroundColor != null && d.hasOwnProperty("violetBackgroundColor") && !$util$1.isString(d.violetBackgroundColor) ? "violetBackgroundColor: string expected" : d.grayBackgroundColor != null && d.hasOwnProperty("grayBackgroundColor") && !$util$1.isString(d.grayBackgroundColor) ? "grayBackgroundColor: string expected" : d.redTextColor != null && d.hasOwnProperty("redTextColor") && !$util$1.isString(d.redTextColor) ? "redTextColor: string expected" : d.orangeTextColor != null && d.hasOwnProperty("orangeTextColor") && !$util$1.isString(d.orangeTextColor) ? "orangeTextColor: string expected" : d.yellowTextColor != null && d.hasOwnProperty("yellowTextColor") && !$util$1.isString(d.yellowTextColor) ? "yellowTextColor: string expected" : d.blueTextColor != null && d.hasOwnProperty("blueTextColor") && !$util$1.isString(d.blueTextColor) ? "blueTextColor: string expected" : d.greenTextColor != null && d.hasOwnProperty("greenTextColor") && !$util$1.isString(d.greenTextColor) ? "greenTextColor: string expected" : d.violetTextColor != null && d.hasOwnProperty("violetTextColor") && !$util$1.isString(d.violetTextColor) ? "violetTextColor: string expected" : d.grayTextColor != null && d.hasOwnProperty("grayTextColor") && !$util$1.isString(d.grayTextColor) ? "grayTextColor: string expected" : null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.CustomThemeConfig) return d;
    let k = new $root$1.CustomThemeConfig();
    switch (d.primaryColor != null && (k.primaryColor = String(d.primaryColor)), d.secondaryBackgroundColor != null && (k.secondaryBackgroundColor = String(d.secondaryBackgroundColor)), d.backgroundColor != null && (k.backgroundColor = String(d.backgroundColor)), d.textColor != null && (k.textColor = String(d.textColor)), d.font) {
      default:
        if (typeof d.font == "number") {
          k.font = d.font;
          break;
        }
        break;
      case "SANS_SERIF":
      case 0:
        k.font = 0;
        break;
      case "SERIF":
      case 1:
        k.font = 1;
        break;
      case "MONOSPACE":
      case 2:
        k.font = 2;
        break;
    }
    switch (d.base) {
      default:
        if (typeof d.base == "number") {
          k.base = d.base;
          break;
        }
        break;
      case "LIGHT":
      case 0:
        k.base = 0;
        break;
      case "DARK":
      case 1:
        k.base = 1;
        break;
    }
    if (d.widgetBackgroundColor != null && (k.widgetBackgroundColor = String(d.widgetBackgroundColor)), d.widgetBorderColor != null && (k.widgetBorderColor = String(d.widgetBorderColor)), d.radii != null) {
      if (typeof d.radii != "object") throw TypeError(".CustomThemeConfig.radii: object expected");
      k.radii = $root$1.Radii.fromObject(d.radii);
    }
    if (d.headingFont != null && (k.headingFont = String(d.headingFont)), d.bodyFont != null && (k.bodyFont = String(d.bodyFont)), d.codeFont != null && (k.codeFont = String(d.codeFont)), d.fontFaces) {
      if (!Array.isArray(d.fontFaces)) throw TypeError(".CustomThemeConfig.fontFaces: array expected");
      k.fontFaces = [];
      for (let H = 0; H < d.fontFaces.length; ++H) {
        if (typeof d.fontFaces[H] != "object") throw TypeError(".CustomThemeConfig.fontFaces: object expected");
        k.fontFaces[H] = $root$1.FontFace.fromObject(d.fontFaces[H]);
      }
    }
    if (d.fontSources) {
      if (!Array.isArray(d.fontSources)) throw TypeError(".CustomThemeConfig.fontSources: array expected");
      k.fontSources = [];
      for (let H = 0; H < d.fontSources.length; ++H) {
        if (typeof d.fontSources[H] != "object") throw TypeError(".CustomThemeConfig.fontSources: object expected");
        k.fontSources[H] = $root$1.FontSource.fromObject(d.fontSources[H]);
      }
    }
    if (d.fontSizes != null) {
      if (typeof d.fontSizes != "object") throw TypeError(".CustomThemeConfig.fontSizes: object expected");
      k.fontSizes = $root$1.FontSizes.fromObject(d.fontSizes);
    }
    if (d.skeletonBackgroundColor != null && (k.skeletonBackgroundColor = String(d.skeletonBackgroundColor)), d.baseRadius != null && (k.baseRadius = String(d.baseRadius)), d.buttonRadius != null && (k.buttonRadius = String(d.buttonRadius)), d.borderColor != null && (k.borderColor = String(d.borderColor)), d.dataframeBorderColor != null && (k.dataframeBorderColor = String(d.dataframeBorderColor)), d.showWidgetBorder != null && (k.showWidgetBorder = !!d.showWidgetBorder), d.linkColor != null && (k.linkColor = String(d.linkColor)), d.linkUnderline != null && (k.linkUnderline = !!d.linkUnderline), d.baseFontSize != null && (k.baseFontSize = d.baseFontSize | 0), d.baseFontWeight != null && (k.baseFontWeight = d.baseFontWeight | 0), d.codeFontWeight != null && (k.codeFontWeight = d.codeFontWeight | 0), d.codeFontSize != null && (k.codeFontSize = String(d.codeFontSize)), d.headingFontSizes) {
      if (!Array.isArray(d.headingFontSizes)) throw TypeError(".CustomThemeConfig.headingFontSizes: array expected");
      k.headingFontSizes = [];
      for (let H = 0; H < d.headingFontSizes.length; ++H) k.headingFontSizes[H] = String(d.headingFontSizes[H]);
    }
    if (d.headingFontWeights) {
      if (!Array.isArray(d.headingFontWeights)) throw TypeError(".CustomThemeConfig.headingFontWeights: array expected");
      k.headingFontWeights = [];
      for (let H = 0; H < d.headingFontWeights.length; ++H) k.headingFontWeights[H] = d.headingFontWeights[H] | 0;
    }
    if (d.showSidebarBorder != null && (k.showSidebarBorder = !!d.showSidebarBorder), d.sidebar != null) {
      if (typeof d.sidebar != "object") throw TypeError(".CustomThemeConfig.sidebar: object expected");
      k.sidebar = $root$1.CustomThemeConfig.fromObject(d.sidebar);
    }
    if (d.codeBackgroundColor != null && (k.codeBackgroundColor = String(d.codeBackgroundColor)), d.dataframeHeaderBackgroundColor != null && (k.dataframeHeaderBackgroundColor = String(d.dataframeHeaderBackgroundColor)), d.chartCategoricalColors) {
      if (!Array.isArray(d.chartCategoricalColors)) throw TypeError(".CustomThemeConfig.chartCategoricalColors: array expected");
      k.chartCategoricalColors = [];
      for (let H = 0; H < d.chartCategoricalColors.length; ++H) k.chartCategoricalColors[H] = String(d.chartCategoricalColors[H]);
    }
    if (d.chartSequentialColors) {
      if (!Array.isArray(d.chartSequentialColors)) throw TypeError(".CustomThemeConfig.chartSequentialColors: array expected");
      k.chartSequentialColors = [];
      for (let H = 0; H < d.chartSequentialColors.length; ++H) k.chartSequentialColors[H] = String(d.chartSequentialColors[H]);
    }
    return d.redColor != null && (k.redColor = String(d.redColor)), d.orangeColor != null && (k.orangeColor = String(d.orangeColor)), d.yellowColor != null && (k.yellowColor = String(d.yellowColor)), d.blueColor != null && (k.blueColor = String(d.blueColor)), d.greenColor != null && (k.greenColor = String(d.greenColor)), d.violetColor != null && (k.violetColor = String(d.violetColor)), d.grayColor != null && (k.grayColor = String(d.grayColor)), d.redBackgroundColor != null && (k.redBackgroundColor = String(d.redBackgroundColor)), d.orangeBackgroundColor != null && (k.orangeBackgroundColor = String(d.orangeBackgroundColor)), d.yellowBackgroundColor != null && (k.yellowBackgroundColor = String(d.yellowBackgroundColor)), d.blueBackgroundColor != null && (k.blueBackgroundColor = String(d.blueBackgroundColor)), d.greenBackgroundColor != null && (k.greenBackgroundColor = String(d.greenBackgroundColor)), d.violetBackgroundColor != null && (k.violetBackgroundColor = String(d.violetBackgroundColor)), d.grayBackgroundColor != null && (k.grayBackgroundColor = String(d.grayBackgroundColor)), d.redTextColor != null && (k.redTextColor = String(d.redTextColor)), d.orangeTextColor != null && (k.orangeTextColor = String(d.orangeTextColor)), d.yellowTextColor != null && (k.yellowTextColor = String(d.yellowTextColor)), d.blueTextColor != null && (k.blueTextColor = String(d.blueTextColor)), d.greenTextColor != null && (k.greenTextColor = String(d.greenTextColor)), d.violetTextColor != null && (k.violetTextColor = String(d.violetTextColor)), d.grayTextColor != null && (k.grayTextColor = String(d.grayTextColor)), k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    if ((k.arrays || k.defaults) && (H.fontFaces = [], H.chartCategoricalColors = [], H.headingFontWeights = [], H.headingFontSizes = [], H.chartSequentialColors = [], H.fontSources = []), k.defaults && (H.primaryColor = "", H.secondaryBackgroundColor = "", H.backgroundColor = "", H.textColor = "", H.font = k.enums === String ? "SANS_SERIF" : 0, H.base = k.enums === String ? "LIGHT" : 0, H.widgetBackgroundColor = "", H.widgetBorderColor = "", H.radii = null, H.headingFont = "", H.bodyFont = "", H.codeFont = "", H.fontSizes = null, H.skeletonBackgroundColor = ""), d.primaryColor != null && d.hasOwnProperty("primaryColor") && (H.primaryColor = d.primaryColor), d.secondaryBackgroundColor != null && d.hasOwnProperty("secondaryBackgroundColor") && (H.secondaryBackgroundColor = d.secondaryBackgroundColor), d.backgroundColor != null && d.hasOwnProperty("backgroundColor") && (H.backgroundColor = d.backgroundColor), d.textColor != null && d.hasOwnProperty("textColor") && (H.textColor = d.textColor), d.font != null && d.hasOwnProperty("font") && (H.font = k.enums === String ? $root$1.CustomThemeConfig.FontFamily[d.font] === void 0 ? d.font : $root$1.CustomThemeConfig.FontFamily[d.font] : d.font), d.base != null && d.hasOwnProperty("base") && (H.base = k.enums === String ? $root$1.CustomThemeConfig.BaseTheme[d.base] === void 0 ? d.base : $root$1.CustomThemeConfig.BaseTheme[d.base] : d.base), d.widgetBackgroundColor != null && d.hasOwnProperty("widgetBackgroundColor") && (H.widgetBackgroundColor = d.widgetBackgroundColor), d.widgetBorderColor != null && d.hasOwnProperty("widgetBorderColor") && (H.widgetBorderColor = d.widgetBorderColor), d.radii != null && d.hasOwnProperty("radii") && (H.radii = $root$1.Radii.toObject(d.radii, k)), d.headingFont != null && d.hasOwnProperty("headingFont") && (H.headingFont = d.headingFont), d.bodyFont != null && d.hasOwnProperty("bodyFont") && (H.bodyFont = d.bodyFont), d.codeFont != null && d.hasOwnProperty("codeFont") && (H.codeFont = d.codeFont), d.fontFaces && d.fontFaces.length) {
      H.fontFaces = [];
      for (let AA = 0; AA < d.fontFaces.length; ++AA) H.fontFaces[AA] = $root$1.FontFace.toObject(d.fontFaces[AA], k);
    }
    if (d.fontSizes != null && d.hasOwnProperty("fontSizes") && (H.fontSizes = $root$1.FontSizes.toObject(d.fontSizes, k)), d.skeletonBackgroundColor != null && d.hasOwnProperty("skeletonBackgroundColor") && (H.skeletonBackgroundColor = d.skeletonBackgroundColor), d.baseRadius != null && d.hasOwnProperty("baseRadius") && (H.baseRadius = d.baseRadius, k.oneofs && (H._baseRadius = "baseRadius")), d.borderColor != null && d.hasOwnProperty("borderColor") && (H.borderColor = d.borderColor, k.oneofs && (H._borderColor = "borderColor")), d.showWidgetBorder != null && d.hasOwnProperty("showWidgetBorder") && (H.showWidgetBorder = d.showWidgetBorder, k.oneofs && (H._showWidgetBorder = "showWidgetBorder")), d.linkColor != null && d.hasOwnProperty("linkColor") && (H.linkColor = d.linkColor, k.oneofs && (H._linkColor = "linkColor")), d.baseFontSize != null && d.hasOwnProperty("baseFontSize") && (H.baseFontSize = d.baseFontSize, k.oneofs && (H._baseFontSize = "baseFontSize")), d.showSidebarBorder != null && d.hasOwnProperty("showSidebarBorder") && (H.showSidebarBorder = d.showSidebarBorder, k.oneofs && (H._showSidebarBorder = "showSidebarBorder")), d.sidebar != null && d.hasOwnProperty("sidebar") && (H.sidebar = $root$1.CustomThemeConfig.toObject(d.sidebar, k), k.oneofs && (H._sidebar = "sidebar")), d.codeBackgroundColor != null && d.hasOwnProperty("codeBackgroundColor") && (H.codeBackgroundColor = d.codeBackgroundColor, k.oneofs && (H._codeBackgroundColor = "codeBackgroundColor")), d.buttonRadius != null && d.hasOwnProperty("buttonRadius") && (H.buttonRadius = d.buttonRadius, k.oneofs && (H._buttonRadius = "buttonRadius")), d.dataframeBorderColor != null && d.hasOwnProperty("dataframeBorderColor") && (H.dataframeBorderColor = d.dataframeBorderColor, k.oneofs && (H._dataframeBorderColor = "dataframeBorderColor")), d.codeFontSize != null && d.hasOwnProperty("codeFontSize") && (H.codeFontSize = d.codeFontSize, k.oneofs && (H._codeFontSize = "codeFontSize")), d.linkUnderline != null && d.hasOwnProperty("linkUnderline") && (H.linkUnderline = d.linkUnderline, k.oneofs && (H._linkUnderline = "linkUnderline")), d.baseFontWeight != null && d.hasOwnProperty("baseFontWeight") && (H.baseFontWeight = d.baseFontWeight, k.oneofs && (H._baseFontWeight = "baseFontWeight")), d.dataframeHeaderBackgroundColor != null && d.hasOwnProperty("dataframeHeaderBackgroundColor") && (H.dataframeHeaderBackgroundColor = d.dataframeHeaderBackgroundColor, k.oneofs && (H._dataframeHeaderBackgroundColor = "dataframeHeaderBackgroundColor")), d.codeFontWeight != null && d.hasOwnProperty("codeFontWeight") && (H.codeFontWeight = d.codeFontWeight, k.oneofs && (H._codeFontWeight = "codeFontWeight")), d.chartCategoricalColors && d.chartCategoricalColors.length) {
      H.chartCategoricalColors = [];
      for (let AA = 0; AA < d.chartCategoricalColors.length; ++AA) H.chartCategoricalColors[AA] = d.chartCategoricalColors[AA];
    }
    if (d.headingFontWeights && d.headingFontWeights.length) {
      H.headingFontWeights = [];
      for (let AA = 0; AA < d.headingFontWeights.length; ++AA) H.headingFontWeights[AA] = d.headingFontWeights[AA];
    }
    if (d.headingFontSizes && d.headingFontSizes.length) {
      H.headingFontSizes = [];
      for (let AA = 0; AA < d.headingFontSizes.length; ++AA) H.headingFontSizes[AA] = d.headingFontSizes[AA];
    }
    if (d.chartSequentialColors && d.chartSequentialColors.length) {
      H.chartSequentialColors = [];
      for (let AA = 0; AA < d.chartSequentialColors.length; ++AA) H.chartSequentialColors[AA] = d.chartSequentialColors[AA];
    }
    if (d.fontSources && d.fontSources.length) {
      H.fontSources = [];
      for (let AA = 0; AA < d.fontSources.length; ++AA) H.fontSources[AA] = $root$1.FontSource.toObject(d.fontSources[AA], k);
    }
    return d.redColor != null && d.hasOwnProperty("redColor") && (H.redColor = d.redColor, k.oneofs && (H._redColor = "redColor")), d.orangeColor != null && d.hasOwnProperty("orangeColor") && (H.orangeColor = d.orangeColor, k.oneofs && (H._orangeColor = "orangeColor")), d.yellowColor != null && d.hasOwnProperty("yellowColor") && (H.yellowColor = d.yellowColor, k.oneofs && (H._yellowColor = "yellowColor")), d.blueColor != null && d.hasOwnProperty("blueColor") && (H.blueColor = d.blueColor, k.oneofs && (H._blueColor = "blueColor")), d.greenColor != null && d.hasOwnProperty("greenColor") && (H.greenColor = d.greenColor, k.oneofs && (H._greenColor = "greenColor")), d.violetColor != null && d.hasOwnProperty("violetColor") && (H.violetColor = d.violetColor, k.oneofs && (H._violetColor = "violetColor")), d.grayColor != null && d.hasOwnProperty("grayColor") && (H.grayColor = d.grayColor, k.oneofs && (H._grayColor = "grayColor")), d.redBackgroundColor != null && d.hasOwnProperty("redBackgroundColor") && (H.redBackgroundColor = d.redBackgroundColor, k.oneofs && (H._redBackgroundColor = "redBackgroundColor")), d.orangeBackgroundColor != null && d.hasOwnProperty("orangeBackgroundColor") && (H.orangeBackgroundColor = d.orangeBackgroundColor, k.oneofs && (H._orangeBackgroundColor = "orangeBackgroundColor")), d.yellowBackgroundColor != null && d.hasOwnProperty("yellowBackgroundColor") && (H.yellowBackgroundColor = d.yellowBackgroundColor, k.oneofs && (H._yellowBackgroundColor = "yellowBackgroundColor")), d.blueBackgroundColor != null && d.hasOwnProperty("blueBackgroundColor") && (H.blueBackgroundColor = d.blueBackgroundColor, k.oneofs && (H._blueBackgroundColor = "blueBackgroundColor")), d.greenBackgroundColor != null && d.hasOwnProperty("greenBackgroundColor") && (H.greenBackgroundColor = d.greenBackgroundColor, k.oneofs && (H._greenBackgroundColor = "greenBackgroundColor")), d.violetBackgroundColor != null && d.hasOwnProperty("violetBackgroundColor") && (H.violetBackgroundColor = d.violetBackgroundColor, k.oneofs && (H._violetBackgroundColor = "violetBackgroundColor")), d.grayBackgroundColor != null && d.hasOwnProperty("grayBackgroundColor") && (H.grayBackgroundColor = d.grayBackgroundColor, k.oneofs && (H._grayBackgroundColor = "grayBackgroundColor")), d.redTextColor != null && d.hasOwnProperty("redTextColor") && (H.redTextColor = d.redTextColor, k.oneofs && (H._redTextColor = "redTextColor")), d.orangeTextColor != null && d.hasOwnProperty("orangeTextColor") && (H.orangeTextColor = d.orangeTextColor, k.oneofs && (H._orangeTextColor = "orangeTextColor")), d.yellowTextColor != null && d.hasOwnProperty("yellowTextColor") && (H.yellowTextColor = d.yellowTextColor, k.oneofs && (H._yellowTextColor = "yellowTextColor")), d.blueTextColor != null && d.hasOwnProperty("blueTextColor") && (H.blueTextColor = d.blueTextColor, k.oneofs && (H._blueTextColor = "blueTextColor")), d.greenTextColor != null && d.hasOwnProperty("greenTextColor") && (H.greenTextColor = d.greenTextColor, k.oneofs && (H._greenTextColor = "greenTextColor")), d.violetTextColor != null && d.hasOwnProperty("violetTextColor") && (H.violetTextColor = d.violetTextColor, k.oneofs && (H._violetTextColor = "violetTextColor")), d.grayTextColor != null && d.hasOwnProperty("grayTextColor") && (H.grayTextColor = d.grayTextColor, k.oneofs && (H._grayTextColor = "grayTextColor")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/CustomThemeConfig";
  }, n.BaseTheme = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "LIGHT"] = 0, d[g[1] = "DARK"] = 1, d;
  })(), n.FontFamily = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "SANS_SERIF"] = 0, d[g[1] = "SERIF"] = 1, d[g[2] = "MONOSPACE"] = 2, d;
  })(), n;
})();
$root$1.FontFace = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.url = "", n.prototype.family = "", n.prototype.weight = 0, n.prototype.weightRange = "", n.prototype.style = "", n.prototype.unicodeRange = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.url != null && Object.hasOwnProperty.call(g, "url") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.url), g.family != null && Object.hasOwnProperty.call(g, "family") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.family), g.weight != null && Object.hasOwnProperty.call(g, "weight") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.weight), g.style != null && Object.hasOwnProperty.call(g, "style") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.style), g.weightRange != null && Object.hasOwnProperty.call(g, "weightRange") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.weightRange), g.unicodeRange != null && Object.hasOwnProperty.call(g, "unicodeRange") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.unicodeRange), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.FontFace();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.url = g.string();
          break;
        }
        case 2: {
          AA.family = g.string();
          break;
        }
        case 3: {
          AA.weight = g.int32();
          break;
        }
        case 5: {
          AA.weightRange = g.string();
          break;
        }
        case 4: {
          AA.style = g.string();
          break;
        }
        case 6: {
          AA.unicodeRange = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.url != null && g.hasOwnProperty("url") && !$util$1.isString(g.url) ? "url: string expected" : g.family != null && g.hasOwnProperty("family") && !$util$1.isString(g.family) ? "family: string expected" : g.weight != null && g.hasOwnProperty("weight") && !$util$1.isInteger(g.weight) ? "weight: integer expected" : g.weightRange != null && g.hasOwnProperty("weightRange") && !$util$1.isString(g.weightRange) ? "weightRange: string expected" : g.style != null && g.hasOwnProperty("style") && !$util$1.isString(g.style) ? "style: string expected" : g.unicodeRange != null && g.hasOwnProperty("unicodeRange") && !$util$1.isString(g.unicodeRange) ? "unicodeRange: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.FontFace) return g;
    let d = new $root$1.FontFace();
    return g.url != null && (d.url = String(g.url)), g.family != null && (d.family = String(g.family)), g.weight != null && (d.weight = g.weight | 0), g.weightRange != null && (d.weightRange = String(g.weightRange)), g.style != null && (d.style = String(g.style)), g.unicodeRange != null && (d.unicodeRange = String(g.unicodeRange)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.url = "", k.family = "", k.weight = 0, k.style = "", k.weightRange = "", k.unicodeRange = ""), g.url != null && g.hasOwnProperty("url") && (k.url = g.url), g.family != null && g.hasOwnProperty("family") && (k.family = g.family), g.weight != null && g.hasOwnProperty("weight") && (k.weight = g.weight), g.style != null && g.hasOwnProperty("style") && (k.style = g.style), g.weightRange != null && g.hasOwnProperty("weightRange") && (k.weightRange = g.weightRange), g.unicodeRange != null && g.hasOwnProperty("unicodeRange") && (k.unicodeRange = g.unicodeRange), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FontFace";
  }, n;
})();
$root$1.FontSource = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.configName = "", n.prototype.sourceUrl = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.configName != null && Object.hasOwnProperty.call(g, "configName") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.configName), g.sourceUrl != null && Object.hasOwnProperty.call(g, "sourceUrl") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.sourceUrl), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.FontSource();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.configName = g.string();
          break;
        }
        case 2: {
          AA.sourceUrl = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.configName != null && g.hasOwnProperty("configName") && !$util$1.isString(g.configName) ? "configName: string expected" : g.sourceUrl != null && g.hasOwnProperty("sourceUrl") && !$util$1.isString(g.sourceUrl) ? "sourceUrl: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.FontSource) return g;
    let d = new $root$1.FontSource();
    return g.configName != null && (d.configName = String(g.configName)), g.sourceUrl != null && (d.sourceUrl = String(g.sourceUrl)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.configName = "", k.sourceUrl = ""), g.configName != null && g.hasOwnProperty("configName") && (k.configName = g.configName), g.sourceUrl != null && g.hasOwnProperty("sourceUrl") && (k.sourceUrl = g.sourceUrl), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FontSource";
  }, n;
})();
$root$1.Radii = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.baseWidgetRadius = 0, n.prototype.checkboxRadius = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.baseWidgetRadius != null && Object.hasOwnProperty.call(g, "baseWidgetRadius") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(g.baseWidgetRadius), g.checkboxRadius != null && Object.hasOwnProperty.call(g, "checkboxRadius") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.checkboxRadius), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Radii();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.baseWidgetRadius = g.int32();
          break;
        }
        case 2: {
          AA.checkboxRadius = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.baseWidgetRadius != null && g.hasOwnProperty("baseWidgetRadius") && !$util$1.isInteger(g.baseWidgetRadius) ? "baseWidgetRadius: integer expected" : g.checkboxRadius != null && g.hasOwnProperty("checkboxRadius") && !$util$1.isInteger(g.checkboxRadius) ? "checkboxRadius: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Radii) return g;
    let d = new $root$1.Radii();
    return g.baseWidgetRadius != null && (d.baseWidgetRadius = g.baseWidgetRadius | 0), g.checkboxRadius != null && (d.checkboxRadius = g.checkboxRadius | 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.baseWidgetRadius = 0, k.checkboxRadius = 0), g.baseWidgetRadius != null && g.hasOwnProperty("baseWidgetRadius") && (k.baseWidgetRadius = g.baseWidgetRadius), g.checkboxRadius != null && g.hasOwnProperty("checkboxRadius") && (k.checkboxRadius = g.checkboxRadius), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Radii";
  }, n;
})();
$root$1.FontSizes = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.tinyFontSize = 0, n.prototype.smallFontSize = 0, n.prototype.baseFontSize = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.tinyFontSize != null && Object.hasOwnProperty.call(g, "tinyFontSize") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(g.tinyFontSize), g.smallFontSize != null && Object.hasOwnProperty.call(g, "smallFontSize") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.smallFontSize), g.baseFontSize != null && Object.hasOwnProperty.call(g, "baseFontSize") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.baseFontSize), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.FontSizes();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.tinyFontSize = g.int32();
          break;
        }
        case 2: {
          AA.smallFontSize = g.int32();
          break;
        }
        case 3: {
          AA.baseFontSize = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.tinyFontSize != null && g.hasOwnProperty("tinyFontSize") && !$util$1.isInteger(g.tinyFontSize) ? "tinyFontSize: integer expected" : g.smallFontSize != null && g.hasOwnProperty("smallFontSize") && !$util$1.isInteger(g.smallFontSize) ? "smallFontSize: integer expected" : g.baseFontSize != null && g.hasOwnProperty("baseFontSize") && !$util$1.isInteger(g.baseFontSize) ? "baseFontSize: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.FontSizes) return g;
    let d = new $root$1.FontSizes();
    return g.tinyFontSize != null && (d.tinyFontSize = g.tinyFontSize | 0), g.smallFontSize != null && (d.smallFontSize = g.smallFontSize | 0), g.baseFontSize != null && (d.baseFontSize = g.baseFontSize | 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.tinyFontSize = 0, k.smallFontSize = 0, k.baseFontSize = 0), g.tinyFontSize != null && g.hasOwnProperty("tinyFontSize") && (k.tinyFontSize = g.tinyFontSize), g.smallFontSize != null && g.hasOwnProperty("smallFontSize") && (k.smallFontSize = g.smallFontSize), g.baseFontSize != null && g.hasOwnProperty("baseFontSize") && (k.baseFontSize = g.baseFontSize), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/FontSizes";
  }, n;
})();
$root$1.UserInfo = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.installationId = "", n.prototype.installationIdV3 = "", n.prototype.installationIdV4 = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.installationId != null && Object.hasOwnProperty.call(g, "installationId") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.installationId), g.installationIdV3 != null && Object.hasOwnProperty.call(g, "installationIdV3") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.installationIdV3), g.installationIdV4 != null && Object.hasOwnProperty.call(g, "installationIdV4") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.installationIdV4), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.UserInfo();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.installationId = g.string();
          break;
        }
        case 5: {
          AA.installationIdV3 = g.string();
          break;
        }
        case 6: {
          AA.installationIdV4 = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.installationId != null && g.hasOwnProperty("installationId") && !$util$1.isString(g.installationId) ? "installationId: string expected" : g.installationIdV3 != null && g.hasOwnProperty("installationIdV3") && !$util$1.isString(g.installationIdV3) ? "installationIdV3: string expected" : g.installationIdV4 != null && g.hasOwnProperty("installationIdV4") && !$util$1.isString(g.installationIdV4) ? "installationIdV4: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.UserInfo) return g;
    let d = new $root$1.UserInfo();
    return g.installationId != null && (d.installationId = String(g.installationId)), g.installationIdV3 != null && (d.installationIdV3 = String(g.installationIdV3)), g.installationIdV4 != null && (d.installationIdV4 = String(g.installationIdV4)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.installationId = "", k.installationIdV3 = "", k.installationIdV4 = ""), g.installationId != null && g.hasOwnProperty("installationId") && (k.installationId = g.installationId), g.installationIdV3 != null && g.hasOwnProperty("installationIdV3") && (k.installationIdV3 = g.installationIdV3), g.installationIdV4 != null && g.hasOwnProperty("installationIdV4") && (k.installationIdV4 = g.installationIdV4), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/UserInfo";
  }, n;
})();
$root$1.EnvironmentInfo = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.streamlitVersion = "", n.prototype.pythonVersion = "", n.prototype.serverOs = "", n.prototype.hasDisplay = !1, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.streamlitVersion != null && Object.hasOwnProperty.call(g, "streamlitVersion") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.streamlitVersion), g.pythonVersion != null && Object.hasOwnProperty.call(g, "pythonVersion") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.pythonVersion), g.serverOs != null && Object.hasOwnProperty.call(g, "serverOs") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.serverOs), g.hasDisplay != null && Object.hasOwnProperty.call(g, "hasDisplay") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.hasDisplay), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.EnvironmentInfo();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.streamlitVersion = g.string();
          break;
        }
        case 2: {
          AA.pythonVersion = g.string();
          break;
        }
        case 3: {
          AA.serverOs = g.string();
          break;
        }
        case 4: {
          AA.hasDisplay = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.streamlitVersion != null && g.hasOwnProperty("streamlitVersion") && !$util$1.isString(g.streamlitVersion) ? "streamlitVersion: string expected" : g.pythonVersion != null && g.hasOwnProperty("pythonVersion") && !$util$1.isString(g.pythonVersion) ? "pythonVersion: string expected" : g.serverOs != null && g.hasOwnProperty("serverOs") && !$util$1.isString(g.serverOs) ? "serverOs: string expected" : g.hasDisplay != null && g.hasOwnProperty("hasDisplay") && typeof g.hasDisplay != "boolean" ? "hasDisplay: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.EnvironmentInfo) return g;
    let d = new $root$1.EnvironmentInfo();
    return g.streamlitVersion != null && (d.streamlitVersion = String(g.streamlitVersion)), g.pythonVersion != null && (d.pythonVersion = String(g.pythonVersion)), g.serverOs != null && (d.serverOs = String(g.serverOs)), g.hasDisplay != null && (d.hasDisplay = !!g.hasDisplay), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.streamlitVersion = "", k.pythonVersion = "", k.serverOs = "", k.hasDisplay = !1), g.streamlitVersion != null && g.hasOwnProperty("streamlitVersion") && (k.streamlitVersion = g.streamlitVersion), g.pythonVersion != null && g.hasOwnProperty("pythonVersion") && (k.pythonVersion = g.pythonVersion), g.serverOs != null && g.hasOwnProperty("serverOs") && (k.serverOs = g.serverOs), g.hasDisplay != null && g.hasOwnProperty("hasDisplay") && (k.hasDisplay = g.hasDisplay), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/EnvironmentInfo";
  }, n;
})();
$root$1.SessionStatus = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.runOnSave = !1, n.prototype.scriptIsRunning = !1, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.runOnSave != null && Object.hasOwnProperty.call(g, "runOnSave") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(g.runOnSave), g.scriptIsRunning != null && Object.hasOwnProperty.call(g, "scriptIsRunning") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.scriptIsRunning), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.SessionStatus();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.runOnSave = g.bool();
          break;
        }
        case 2: {
          AA.scriptIsRunning = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.runOnSave != null && g.hasOwnProperty("runOnSave") && typeof g.runOnSave != "boolean" ? "runOnSave: boolean expected" : g.scriptIsRunning != null && g.hasOwnProperty("scriptIsRunning") && typeof g.scriptIsRunning != "boolean" ? "scriptIsRunning: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.SessionStatus) return g;
    let d = new $root$1.SessionStatus();
    return g.runOnSave != null && (d.runOnSave = !!g.runOnSave), g.scriptIsRunning != null && (d.scriptIsRunning = !!g.scriptIsRunning), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.runOnSave = !1, k.scriptIsRunning = !1), g.runOnSave != null && g.hasOwnProperty("runOnSave") && (k.runOnSave = g.runOnSave), g.scriptIsRunning != null && g.hasOwnProperty("scriptIsRunning") && (k.scriptIsRunning = g.scriptIsRunning), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/SessionStatus";
  }, n;
})();
const PageConfig = $root$1.PageConfig = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.title = "", n.prototype.favicon = "", n.prototype.layout = 0, n.prototype.initialSidebarState = 0, n.prototype.menuItems = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.title != null && Object.hasOwnProperty.call(g, "title") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.title), g.favicon != null && Object.hasOwnProperty.call(g, "favicon") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.favicon), g.layout != null && Object.hasOwnProperty.call(g, "layout") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.layout), g.initialSidebarState != null && Object.hasOwnProperty.call(g, "initialSidebarState") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(g.initialSidebarState), g.menuItems != null && Object.hasOwnProperty.call(g, "menuItems") && $root$1.PageConfig.MenuItems.encode(g.menuItems, d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.PageConfig();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.title = g.string();
          break;
        }
        case 2: {
          AA.favicon = g.string();
          break;
        }
        case 3: {
          AA.layout = g.int32();
          break;
        }
        case 4: {
          AA.initialSidebarState = g.int32();
          break;
        }
        case 5: {
          AA.menuItems = $root$1.PageConfig.MenuItems.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.title != null && g.hasOwnProperty("title") && !$util$1.isString(g.title)) return "title: string expected";
    if (g.favicon != null && g.hasOwnProperty("favicon") && !$util$1.isString(g.favicon)) return "favicon: string expected";
    if (g.layout != null && g.hasOwnProperty("layout")) switch (g.layout) {
      default:
        return "layout: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (g.initialSidebarState != null && g.hasOwnProperty("initialSidebarState")) switch (g.initialSidebarState) {
      default:
        return "initialSidebarState: enum value expected";
      case 0:
      case 1:
      case 2:
      case 3:
        break;
    }
    if (g.menuItems != null && g.hasOwnProperty("menuItems")) {
      let d = $root$1.PageConfig.MenuItems.verify(g.menuItems);
      if (d) return "menuItems." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.PageConfig) return g;
    let d = new $root$1.PageConfig();
    switch (g.title != null && (d.title = String(g.title)), g.favicon != null && (d.favicon = String(g.favicon)), g.layout) {
      default:
        if (typeof g.layout == "number") {
          d.layout = g.layout;
          break;
        }
        break;
      case "CENTERED":
      case 0:
        d.layout = 0;
        break;
      case "WIDE":
      case 1:
        d.layout = 1;
        break;
      case "LAYOUT_UNSET":
      case 2:
        d.layout = 2;
        break;
    }
    switch (g.initialSidebarState) {
      default:
        if (typeof g.initialSidebarState == "number") {
          d.initialSidebarState = g.initialSidebarState;
          break;
        }
        break;
      case "AUTO":
      case 0:
        d.initialSidebarState = 0;
        break;
      case "EXPANDED":
      case 1:
        d.initialSidebarState = 1;
        break;
      case "COLLAPSED":
      case 2:
        d.initialSidebarState = 2;
        break;
      case "SIDEBAR_UNSET":
      case 3:
        d.initialSidebarState = 3;
        break;
    }
    if (g.menuItems != null) {
      if (typeof g.menuItems != "object") throw TypeError(".PageConfig.menuItems: object expected");
      d.menuItems = $root$1.PageConfig.MenuItems.fromObject(g.menuItems);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.title = "", k.favicon = "", k.layout = d.enums === String ? "CENTERED" : 0, k.initialSidebarState = d.enums === String ? "AUTO" : 0, k.menuItems = null), g.title != null && g.hasOwnProperty("title") && (k.title = g.title), g.favicon != null && g.hasOwnProperty("favicon") && (k.favicon = g.favicon), g.layout != null && g.hasOwnProperty("layout") && (k.layout = d.enums === String ? $root$1.PageConfig.Layout[g.layout] === void 0 ? g.layout : $root$1.PageConfig.Layout[g.layout] : g.layout), g.initialSidebarState != null && g.hasOwnProperty("initialSidebarState") && (k.initialSidebarState = d.enums === String ? $root$1.PageConfig.SidebarState[g.initialSidebarState] === void 0 ? g.initialSidebarState : $root$1.PageConfig.SidebarState[g.initialSidebarState] : g.initialSidebarState), g.menuItems != null && g.hasOwnProperty("menuItems") && (k.menuItems = $root$1.PageConfig.MenuItems.toObject(g.menuItems, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PageConfig";
  }, n.MenuItems = (function() {
    function t(g) {
      if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.getHelpUrl = "", t.prototype.hideGetHelp = !1, t.prototype.reportABugUrl = "", t.prototype.hideReportABug = !1, t.prototype.aboutSectionMd = "", t.prototype.clearAboutMd = !1, t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      return k || (k = $Writer$1.create()), d.getHelpUrl != null && Object.hasOwnProperty.call(d, "getHelpUrl") && k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(d.getHelpUrl), d.hideGetHelp != null && Object.hasOwnProperty.call(d, "hideGetHelp") && k.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(d.hideGetHelp), d.reportABugUrl != null && Object.hasOwnProperty.call(d, "reportABugUrl") && k.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(d.reportABugUrl), d.hideReportABug != null && Object.hasOwnProperty.call(d, "hideReportABug") && k.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(d.hideReportABug), d.aboutSectionMd != null && Object.hasOwnProperty.call(d, "aboutSectionMd") && k.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(d.aboutSectionMd), d.clearAboutMd != null && Object.hasOwnProperty.call(d, "clearAboutMd") && k.uint32(
        /* id 6, wireType 0 =*/
        48
      ).bool(d.clearAboutMd), k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader$1 || (d = $Reader$1.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.PageConfig.MenuItems();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.getHelpUrl = d.string();
            break;
          }
          case 2: {
            gA.hideGetHelp = d.bool();
            break;
          }
          case 3: {
            gA.reportABugUrl = d.string();
            break;
          }
          case 4: {
            gA.hideReportABug = d.bool();
            break;
          }
          case 5: {
            gA.aboutSectionMd = d.string();
            break;
          }
          case 6: {
            gA.clearAboutMd = d.bool();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      return typeof d != "object" || d === null ? "object expected" : d.getHelpUrl != null && d.hasOwnProperty("getHelpUrl") && !$util$1.isString(d.getHelpUrl) ? "getHelpUrl: string expected" : d.hideGetHelp != null && d.hasOwnProperty("hideGetHelp") && typeof d.hideGetHelp != "boolean" ? "hideGetHelp: boolean expected" : d.reportABugUrl != null && d.hasOwnProperty("reportABugUrl") && !$util$1.isString(d.reportABugUrl) ? "reportABugUrl: string expected" : d.hideReportABug != null && d.hasOwnProperty("hideReportABug") && typeof d.hideReportABug != "boolean" ? "hideReportABug: boolean expected" : d.aboutSectionMd != null && d.hasOwnProperty("aboutSectionMd") && !$util$1.isString(d.aboutSectionMd) ? "aboutSectionMd: string expected" : d.clearAboutMd != null && d.hasOwnProperty("clearAboutMd") && typeof d.clearAboutMd != "boolean" ? "clearAboutMd: boolean expected" : null;
    }, t.fromObject = function(d) {
      if (d instanceof $root$1.PageConfig.MenuItems) return d;
      let k = new $root$1.PageConfig.MenuItems();
      return d.getHelpUrl != null && (k.getHelpUrl = String(d.getHelpUrl)), d.hideGetHelp != null && (k.hideGetHelp = !!d.hideGetHelp), d.reportABugUrl != null && (k.reportABugUrl = String(d.reportABugUrl)), d.hideReportABug != null && (k.hideReportABug = !!d.hideReportABug), d.aboutSectionMd != null && (k.aboutSectionMd = String(d.aboutSectionMd)), d.clearAboutMd != null && (k.clearAboutMd = !!d.clearAboutMd), k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return k.defaults && (H.getHelpUrl = "", H.hideGetHelp = !1, H.reportABugUrl = "", H.hideReportABug = !1, H.aboutSectionMd = "", H.clearAboutMd = !1), d.getHelpUrl != null && d.hasOwnProperty("getHelpUrl") && (H.getHelpUrl = d.getHelpUrl), d.hideGetHelp != null && d.hasOwnProperty("hideGetHelp") && (H.hideGetHelp = d.hideGetHelp), d.reportABugUrl != null && d.hasOwnProperty("reportABugUrl") && (H.reportABugUrl = d.reportABugUrl), d.hideReportABug != null && d.hasOwnProperty("hideReportABug") && (H.hideReportABug = d.hideReportABug), d.aboutSectionMd != null && d.hasOwnProperty("aboutSectionMd") && (H.aboutSectionMd = d.aboutSectionMd), d.clearAboutMd != null && d.hasOwnProperty("clearAboutMd") && (H.clearAboutMd = d.clearAboutMd), H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/PageConfig.MenuItems";
    }, t;
  })(), n.Layout = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "CENTERED"] = 0, g[t[1] = "WIDE"] = 1, g[t[2] = "LAYOUT_UNSET"] = 2, g;
  })(), n.SidebarState = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "AUTO"] = 0, g[t[1] = "EXPANDED"] = 1, g[t[2] = "COLLAPSED"] = 2, g[t[3] = "SIDEBAR_UNSET"] = 3, g;
  })(), n;
})();
$root$1.PageInfo = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.queryString = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.queryString != null && Object.hasOwnProperty.call(g, "queryString") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.queryString), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.PageInfo();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.queryString = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.queryString != null && g.hasOwnProperty("queryString") && !$util$1.isString(g.queryString) ? "queryString: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.PageInfo) return g;
    let d = new $root$1.PageInfo();
    return g.queryString != null && (d.queryString = String(g.queryString)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.queryString = ""), g.queryString != null && g.hasOwnProperty("queryString") && (k.queryString = g.queryString), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PageInfo";
  }, n;
})();
const PageProfile = $root$1.PageProfile = (() => {
  function n(t) {
    if (this.commands = [], this.config = [], this.attributions = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.commands = $util$1.emptyArray, n.prototype.execTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, n.prototype.prepTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, n.prototype.config = $util$1.emptyArray, n.prototype.uncaughtException = "", n.prototype.attributions = $util$1.emptyArray, n.prototype.os = "", n.prototype.timezone = "", n.prototype.headless = !1, n.prototype.isFragmentRun = !1, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.commands != null && g.commands.length) for (let k = 0; k < g.commands.length; ++k) $root$1.Command.encode(g.commands[k], d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (g.execTime != null && Object.hasOwnProperty.call(g, "execTime") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(g.execTime), g.prepTime != null && Object.hasOwnProperty.call(g, "prepTime") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int64(g.prepTime), g.config != null && g.config.length) for (let k = 0; k < g.config.length; ++k) d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.config[k]);
    if (g.uncaughtException != null && Object.hasOwnProperty.call(g, "uncaughtException") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.uncaughtException), g.attributions != null && g.attributions.length) for (let k = 0; k < g.attributions.length; ++k) d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.attributions[k]);
    return g.os != null && Object.hasOwnProperty.call(g, "os") && d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.os), g.timezone != null && Object.hasOwnProperty.call(g, "timezone") && d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.timezone), g.headless != null && Object.hasOwnProperty.call(g, "headless") && d.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(g.headless), g.isFragmentRun != null && Object.hasOwnProperty.call(g, "isFragmentRun") && d.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.isFragmentRun), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.PageProfile();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.commands && AA.commands.length || (AA.commands = []), AA.commands.push($root$1.Command.decode(g, g.uint32()));
          break;
        }
        case 2: {
          AA.execTime = g.int64();
          break;
        }
        case 3: {
          AA.prepTime = g.int64();
          break;
        }
        case 5: {
          AA.config && AA.config.length || (AA.config = []), AA.config.push(g.string());
          break;
        }
        case 6: {
          AA.uncaughtException = g.string();
          break;
        }
        case 7: {
          AA.attributions && AA.attributions.length || (AA.attributions = []), AA.attributions.push(g.string());
          break;
        }
        case 8: {
          AA.os = g.string();
          break;
        }
        case 9: {
          AA.timezone = g.string();
          break;
        }
        case 10: {
          AA.headless = g.bool();
          break;
        }
        case 11: {
          AA.isFragmentRun = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.commands != null && g.hasOwnProperty("commands")) {
      if (!Array.isArray(g.commands)) return "commands: array expected";
      for (let d = 0; d < g.commands.length; ++d) {
        let k = $root$1.Command.verify(g.commands[d]);
        if (k) return "commands." + k;
      }
    }
    if (g.execTime != null && g.hasOwnProperty("execTime") && !$util$1.isInteger(g.execTime) && !(g.execTime && $util$1.isInteger(g.execTime.low) && $util$1.isInteger(g.execTime.high))) return "execTime: integer|Long expected";
    if (g.prepTime != null && g.hasOwnProperty("prepTime") && !$util$1.isInteger(g.prepTime) && !(g.prepTime && $util$1.isInteger(g.prepTime.low) && $util$1.isInteger(g.prepTime.high))) return "prepTime: integer|Long expected";
    if (g.config != null && g.hasOwnProperty("config")) {
      if (!Array.isArray(g.config)) return "config: array expected";
      for (let d = 0; d < g.config.length; ++d) if (!$util$1.isString(g.config[d])) return "config: string[] expected";
    }
    if (g.uncaughtException != null && g.hasOwnProperty("uncaughtException") && !$util$1.isString(g.uncaughtException)) return "uncaughtException: string expected";
    if (g.attributions != null && g.hasOwnProperty("attributions")) {
      if (!Array.isArray(g.attributions)) return "attributions: array expected";
      for (let d = 0; d < g.attributions.length; ++d) if (!$util$1.isString(g.attributions[d])) return "attributions: string[] expected";
    }
    return g.os != null && g.hasOwnProperty("os") && !$util$1.isString(g.os) ? "os: string expected" : g.timezone != null && g.hasOwnProperty("timezone") && !$util$1.isString(g.timezone) ? "timezone: string expected" : g.headless != null && g.hasOwnProperty("headless") && typeof g.headless != "boolean" ? "headless: boolean expected" : g.isFragmentRun != null && g.hasOwnProperty("isFragmentRun") && typeof g.isFragmentRun != "boolean" ? "isFragmentRun: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.PageProfile) return g;
    let d = new $root$1.PageProfile();
    if (g.commands) {
      if (!Array.isArray(g.commands)) throw TypeError(".PageProfile.commands: array expected");
      d.commands = [];
      for (let k = 0; k < g.commands.length; ++k) {
        if (typeof g.commands[k] != "object") throw TypeError(".PageProfile.commands: object expected");
        d.commands[k] = $root$1.Command.fromObject(g.commands[k]);
      }
    }
    if (g.execTime != null && ($util$1.Long ? (d.execTime = $util$1.Long.fromValue(g.execTime)).unsigned = !1 : typeof g.execTime == "string" ? d.execTime = parseInt(g.execTime, 10) : typeof g.execTime == "number" ? d.execTime = g.execTime : typeof g.execTime == "object" && (d.execTime = new $util$1.LongBits(g.execTime.low >>> 0, g.execTime.high >>> 0).toNumber())), g.prepTime != null && ($util$1.Long ? (d.prepTime = $util$1.Long.fromValue(g.prepTime)).unsigned = !1 : typeof g.prepTime == "string" ? d.prepTime = parseInt(g.prepTime, 10) : typeof g.prepTime == "number" ? d.prepTime = g.prepTime : typeof g.prepTime == "object" && (d.prepTime = new $util$1.LongBits(g.prepTime.low >>> 0, g.prepTime.high >>> 0).toNumber())), g.config) {
      if (!Array.isArray(g.config)) throw TypeError(".PageProfile.config: array expected");
      d.config = [];
      for (let k = 0; k < g.config.length; ++k) d.config[k] = String(g.config[k]);
    }
    if (g.uncaughtException != null && (d.uncaughtException = String(g.uncaughtException)), g.attributions) {
      if (!Array.isArray(g.attributions)) throw TypeError(".PageProfile.attributions: array expected");
      d.attributions = [];
      for (let k = 0; k < g.attributions.length; ++k) d.attributions[k] = String(g.attributions[k]);
    }
    return g.os != null && (d.os = String(g.os)), g.timezone != null && (d.timezone = String(g.timezone)), g.headless != null && (d.headless = !!g.headless), g.isFragmentRun != null && (d.isFragmentRun = !!g.isFragmentRun), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.commands = [], k.config = [], k.attributions = []), d.defaults) {
      if ($util$1.Long) {
        let H = new $util$1.Long(0, 0, !1);
        k.execTime = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
      } else k.execTime = d.longs === String ? "0" : 0;
      if ($util$1.Long) {
        let H = new $util$1.Long(0, 0, !1);
        k.prepTime = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
      } else k.prepTime = d.longs === String ? "0" : 0;
      k.uncaughtException = "", k.os = "", k.timezone = "", k.headless = !1, k.isFragmentRun = !1;
    }
    if (g.commands && g.commands.length) {
      k.commands = [];
      for (let H = 0; H < g.commands.length; ++H) k.commands[H] = $root$1.Command.toObject(g.commands[H], d);
    }
    if (g.execTime != null && g.hasOwnProperty("execTime") && (typeof g.execTime == "number" ? k.execTime = d.longs === String ? String(g.execTime) : g.execTime : k.execTime = d.longs === String ? $util$1.Long.prototype.toString.call(g.execTime) : d.longs === Number ? new $util$1.LongBits(g.execTime.low >>> 0, g.execTime.high >>> 0).toNumber() : g.execTime), g.prepTime != null && g.hasOwnProperty("prepTime") && (typeof g.prepTime == "number" ? k.prepTime = d.longs === String ? String(g.prepTime) : g.prepTime : k.prepTime = d.longs === String ? $util$1.Long.prototype.toString.call(g.prepTime) : d.longs === Number ? new $util$1.LongBits(g.prepTime.low >>> 0, g.prepTime.high >>> 0).toNumber() : g.prepTime), g.config && g.config.length) {
      k.config = [];
      for (let H = 0; H < g.config.length; ++H) k.config[H] = g.config[H];
    }
    if (g.uncaughtException != null && g.hasOwnProperty("uncaughtException") && (k.uncaughtException = g.uncaughtException), g.attributions && g.attributions.length) {
      k.attributions = [];
      for (let H = 0; H < g.attributions.length; ++H) k.attributions[H] = g.attributions[H];
    }
    return g.os != null && g.hasOwnProperty("os") && (k.os = g.os), g.timezone != null && g.hasOwnProperty("timezone") && (k.timezone = g.timezone), g.headless != null && g.hasOwnProperty("headless") && (k.headless = g.headless), g.isFragmentRun != null && g.hasOwnProperty("isFragmentRun") && (k.isFragmentRun = g.isFragmentRun), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PageProfile";
  }, n;
})();
$root$1.Argument = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.k = "", n.prototype.t = "", n.prototype.m = "", n.prototype.p = 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.k != null && Object.hasOwnProperty.call(g, "k") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.k), g.t != null && Object.hasOwnProperty.call(g, "t") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.t), g.m != null && Object.hasOwnProperty.call(g, "m") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.m), g.p != null && Object.hasOwnProperty.call(g, "p") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.p), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Argument();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.k = g.string();
          break;
        }
        case 2: {
          AA.t = g.string();
          break;
        }
        case 3: {
          AA.m = g.string();
          break;
        }
        case 5: {
          AA.p = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.k != null && g.hasOwnProperty("k") && !$util$1.isString(g.k) ? "k: string expected" : g.t != null && g.hasOwnProperty("t") && !$util$1.isString(g.t) ? "t: string expected" : g.m != null && g.hasOwnProperty("m") && !$util$1.isString(g.m) ? "m: string expected" : g.p != null && g.hasOwnProperty("p") && !$util$1.isInteger(g.p) ? "p: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Argument) return g;
    let d = new $root$1.Argument();
    return g.k != null && (d.k = String(g.k)), g.t != null && (d.t = String(g.t)), g.m != null && (d.m = String(g.m)), g.p != null && (d.p = g.p | 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.k = "", k.t = "", k.m = "", k.p = 0), g.k != null && g.hasOwnProperty("k") && (k.k = g.k), g.t != null && g.hasOwnProperty("t") && (k.t = g.t), g.m != null && g.hasOwnProperty("m") && (k.m = g.m), g.p != null && g.hasOwnProperty("p") && (k.p = g.p), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Argument";
  }, n;
})();
$root$1.Command = (() => {
  function n(t) {
    if (this.args = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.name = "", n.prototype.args = $util$1.emptyArray, n.prototype.time = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.name), g.args != null && g.args.length) for (let k = 0; k < g.args.length; ++k) $root$1.Argument.encode(g.args[k], d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return g.time != null && Object.hasOwnProperty.call(g, "time") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int64(g.time), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.Command();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.name = g.string();
          break;
        }
        case 2: {
          AA.args && AA.args.length || (AA.args = []), AA.args.push($root$1.Argument.decode(g, g.uint32()));
          break;
        }
        case 4: {
          AA.time = g.int64();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.name != null && g.hasOwnProperty("name") && !$util$1.isString(g.name)) return "name: string expected";
    if (g.args != null && g.hasOwnProperty("args")) {
      if (!Array.isArray(g.args)) return "args: array expected";
      for (let d = 0; d < g.args.length; ++d) {
        let k = $root$1.Argument.verify(g.args[d]);
        if (k) return "args." + k;
      }
    }
    return g.time != null && g.hasOwnProperty("time") && !$util$1.isInteger(g.time) && !(g.time && $util$1.isInteger(g.time.low) && $util$1.isInteger(g.time.high)) ? "time: integer|Long expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.Command) return g;
    let d = new $root$1.Command();
    if (g.name != null && (d.name = String(g.name)), g.args) {
      if (!Array.isArray(g.args)) throw TypeError(".Command.args: array expected");
      d.args = [];
      for (let k = 0; k < g.args.length; ++k) {
        if (typeof g.args[k] != "object") throw TypeError(".Command.args: object expected");
        d.args[k] = $root$1.Argument.fromObject(g.args[k]);
      }
    }
    return g.time != null && ($util$1.Long ? (d.time = $util$1.Long.fromValue(g.time)).unsigned = !1 : typeof g.time == "string" ? d.time = parseInt(g.time, 10) : typeof g.time == "number" ? d.time = g.time : typeof g.time == "object" && (d.time = new $util$1.LongBits(g.time.low >>> 0, g.time.high >>> 0).toNumber())), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.args = []), d.defaults)
      if (k.name = "", $util$1.Long) {
        let H = new $util$1.Long(0, 0, !1);
        k.time = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
      } else k.time = d.longs === String ? "0" : 0;
    if (g.name != null && g.hasOwnProperty("name") && (k.name = g.name), g.args && g.args.length) {
      k.args = [];
      for (let H = 0; H < g.args.length; ++H) k.args[H] = $root$1.Argument.toObject(g.args[H], d);
    }
    return g.time != null && g.hasOwnProperty("time") && (typeof g.time == "number" ? k.time = d.longs === String ? String(g.time) : g.time : k.time = d.longs === String ? $util$1.Long.prototype.toString.call(g.time) : d.longs === Number ? new $util$1.LongBits(g.time.low >>> 0, g.time.high >>> 0).toNumber() : g.time), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Command";
  }, n;
})();
$root$1.PageNotFound = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.pageName = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.pageName != null && Object.hasOwnProperty.call(g, "pageName") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.pageName), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.PageNotFound();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.pageName = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.pageName != null && g.hasOwnProperty("pageName") && !$util$1.isString(g.pageName) ? "pageName: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.PageNotFound) return g;
    let d = new $root$1.PageNotFound();
    return g.pageName != null && (d.pageName = String(g.pageName)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.pageName = ""), g.pageName != null && g.hasOwnProperty("pageName") && (k.pageName = g.pageName), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PageNotFound";
  }, n;
})();
$root$1.PagesChanged = (() => {
  function n(t) {
    if (this.appPages = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.appPages = $util$1.emptyArray, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.appPages != null && g.appPages.length) for (let k = 0; k < g.appPages.length; ++k) $root$1.AppPage.encode(g.appPages[k], d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.PagesChanged();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.appPages && AA.appPages.length || (AA.appPages = []), AA.appPages.push($root$1.AppPage.decode(g, g.uint32()));
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.appPages != null && g.hasOwnProperty("appPages")) {
      if (!Array.isArray(g.appPages)) return "appPages: array expected";
      for (let d = 0; d < g.appPages.length; ++d) {
        let k = $root$1.AppPage.verify(g.appPages[d]);
        if (k) return "appPages." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.PagesChanged) return g;
    let d = new $root$1.PagesChanged();
    if (g.appPages) {
      if (!Array.isArray(g.appPages)) throw TypeError(".PagesChanged.appPages: array expected");
      d.appPages = [];
      for (let k = 0; k < g.appPages.length; ++k) {
        if (typeof g.appPages[k] != "object") throw TypeError(".PagesChanged.appPages: object expected");
        d.appPages[k] = $root$1.AppPage.fromObject(g.appPages[k]);
      }
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.appPages = []), g.appPages && g.appPages.length) {
      k.appPages = [];
      for (let H = 0; H < g.appPages.length; ++H) k.appPages[H] = $root$1.AppPage.toObject(g.appPages[H], d);
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PagesChanged";
  }, n;
})();
$root$1.ParentMessage = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.message = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.message != null && Object.hasOwnProperty.call(g, "message") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.message), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.ParentMessage();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.message = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.message != null && g.hasOwnProperty("message") && !$util$1.isString(g.message) ? "message: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.ParentMessage) return g;
    let d = new $root$1.ParentMessage();
    return g.message != null && (d.message = String(g.message)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.message = ""), g.message != null && g.hasOwnProperty("message") && (k.message = g.message), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ParentMessage";
  }, n;
})();
$root$1.SessionEvent = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.scriptChangedOnDisk = null, n.prototype.scriptWasManuallyStopped = null, n.prototype.scriptCompilationException = null;
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util$1.oneOfGetter(t = ["scriptChangedOnDisk", "scriptWasManuallyStopped", "scriptCompilationException"]), set: $util$1.oneOfSetter(t) }), n.create = function(d) {
    return new n(d);
  }, n.encode = function(d, k) {
    return k || (k = $Writer$1.create()), d.scriptChangedOnDisk != null && Object.hasOwnProperty.call(d, "scriptChangedOnDisk") && k.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(d.scriptChangedOnDisk), d.scriptWasManuallyStopped != null && Object.hasOwnProperty.call(d, "scriptWasManuallyStopped") && k.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(d.scriptWasManuallyStopped), d.scriptCompilationException != null && Object.hasOwnProperty.call(d, "scriptCompilationException") && $root$1.Exception.encode(d.scriptCompilationException, k.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), k;
  }, n.encodeDelimited = function(d, k) {
    return this.encode(d, k).ldelim();
  }, n.decode = function(d, k, H) {
    d instanceof $Reader$1 || (d = $Reader$1.create(d));
    let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.SessionEvent();
    for (; d.pos < AA; ) {
      let IA = d.uint32();
      if (IA === H) break;
      switch (IA >>> 3) {
        case 1: {
          gA.scriptChangedOnDisk = d.bool();
          break;
        }
        case 2: {
          gA.scriptWasManuallyStopped = d.bool();
          break;
        }
        case 3: {
          gA.scriptCompilationException = $root$1.Exception.decode(d, d.uint32());
          break;
        }
        default:
          d.skipType(IA & 7);
          break;
      }
    }
    return gA;
  }, n.decodeDelimited = function(d) {
    return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
  }, n.verify = function(d) {
    if (typeof d != "object" || d === null) return "object expected";
    let k = {};
    if (d.scriptChangedOnDisk != null && d.hasOwnProperty("scriptChangedOnDisk") && (k.type = 1, typeof d.scriptChangedOnDisk != "boolean"))
      return "scriptChangedOnDisk: boolean expected";
    if (d.scriptWasManuallyStopped != null && d.hasOwnProperty("scriptWasManuallyStopped")) {
      if (k.type === 1) return "type: multiple values";
      if (k.type = 1, typeof d.scriptWasManuallyStopped != "boolean") return "scriptWasManuallyStopped: boolean expected";
    }
    if (d.scriptCompilationException != null && d.hasOwnProperty("scriptCompilationException")) {
      if (k.type === 1) return "type: multiple values";
      k.type = 1;
      {
        let H = $root$1.Exception.verify(d.scriptCompilationException);
        if (H) return "scriptCompilationException." + H;
      }
    }
    return null;
  }, n.fromObject = function(d) {
    if (d instanceof $root$1.SessionEvent) return d;
    let k = new $root$1.SessionEvent();
    if (d.scriptChangedOnDisk != null && (k.scriptChangedOnDisk = !!d.scriptChangedOnDisk), d.scriptWasManuallyStopped != null && (k.scriptWasManuallyStopped = !!d.scriptWasManuallyStopped), d.scriptCompilationException != null) {
      if (typeof d.scriptCompilationException != "object") throw TypeError(".SessionEvent.scriptCompilationException: object expected");
      k.scriptCompilationException = $root$1.Exception.fromObject(d.scriptCompilationException);
    }
    return k;
  }, n.toObject = function(d, k) {
    k || (k = {});
    let H = {};
    return d.scriptChangedOnDisk != null && d.hasOwnProperty("scriptChangedOnDisk") && (H.scriptChangedOnDisk = d.scriptChangedOnDisk, k.oneofs && (H.type = "scriptChangedOnDisk")), d.scriptWasManuallyStopped != null && d.hasOwnProperty("scriptWasManuallyStopped") && (H.scriptWasManuallyStopped = d.scriptWasManuallyStopped, k.oneofs && (H.type = "scriptWasManuallyStopped")), d.scriptCompilationException != null && d.hasOwnProperty("scriptCompilationException") && (H.scriptCompilationException = $root$1.Exception.toObject(d.scriptCompilationException, k), k.oneofs && (H.type = "scriptCompilationException")), H;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(d) {
    return d === void 0 && (d = "type.googleapis.com"), d + "/SessionEvent";
  }, n;
})();
const MetricsEvent = $root$1.MetricsEvent = (() => {
  function n(t) {
    if (this.commands = [], this.config = [], this.attributions = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.event = "", n.prototype.anonymousId = "", n.prototype.machineIdV3 = "", n.prototype.machineIdV4 = "", n.prototype.reportHash = "", n.prototype.dev = !1, n.prototype.source = "", n.prototype.streamlitVersion = "", n.prototype.isHello = !1, n.prototype.appId = "", n.prototype.sessionId = "", n.prototype.pythonVersion = "", n.prototype.serverOs = "", n.prototype.hasDisplay = !1, n.prototype.isWebdriver = !1, n.prototype.hostedAt = "", n.prototype.owner = "", n.prototype.repo = "", n.prototype.branch = "", n.prototype.mainModule = "", n.prototype.creatorId = "", n.prototype.contextPageUrl = "", n.prototype.contextPageTitle = "", n.prototype.contextPagePath = "", n.prototype.contextPageReferrer = "", n.prototype.contextPageSearch = "", n.prototype.contextLocale = "", n.prototype.contextUserAgent = "", n.prototype.label = "", n.prototype.commands = $util$1.emptyArray, n.prototype.execTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, n.prototype.prepTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, n.prototype.config = $util$1.emptyArray, n.prototype.uncaughtException = "", n.prototype.attributions = $util$1.emptyArray, n.prototype.os = "", n.prototype.timezone = "", n.prototype.headless = !1, n.prototype.isFragmentRun = !1, n.prototype.numPages = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, n.prototype.pageScriptHash = "", n.prototype.activeTheme = "", n.prototype.totalLoadTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, n.prototype.browserInfo = null, n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer$1.create()), g.event != null && Object.hasOwnProperty.call(g, "event") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.event), g.anonymousId != null && Object.hasOwnProperty.call(g, "anonymousId") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.anonymousId), g.machineIdV3 != null && Object.hasOwnProperty.call(g, "machineIdV3") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.machineIdV3), g.reportHash != null && Object.hasOwnProperty.call(g, "reportHash") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.reportHash), g.dev != null && Object.hasOwnProperty.call(g, "dev") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.dev), g.source != null && Object.hasOwnProperty.call(g, "source") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.source), g.streamlitVersion != null && Object.hasOwnProperty.call(g, "streamlitVersion") && d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.streamlitVersion), g.isHello != null && Object.hasOwnProperty.call(g, "isHello") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.isHello), g.hostedAt != null && Object.hasOwnProperty.call(g, "hostedAt") && d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.hostedAt), g.owner != null && Object.hasOwnProperty.call(g, "owner") && d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.owner), g.repo != null && Object.hasOwnProperty.call(g, "repo") && d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.repo), g.branch != null && Object.hasOwnProperty.call(g, "branch") && d.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.branch), g.mainModule != null && Object.hasOwnProperty.call(g, "mainModule") && d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.mainModule), g.creatorId != null && Object.hasOwnProperty.call(g, "creatorId") && d.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.creatorId), g.contextPageUrl != null && Object.hasOwnProperty.call(g, "contextPageUrl") && d.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(g.contextPageUrl), g.contextPageTitle != null && Object.hasOwnProperty.call(g, "contextPageTitle") && d.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(g.contextPageTitle), g.contextPagePath != null && Object.hasOwnProperty.call(g, "contextPagePath") && d.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(g.contextPagePath), g.contextPageReferrer != null && Object.hasOwnProperty.call(g, "contextPageReferrer") && d.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(g.contextPageReferrer), g.contextPageSearch != null && Object.hasOwnProperty.call(g, "contextPageSearch") && d.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(g.contextPageSearch), g.contextLocale != null && Object.hasOwnProperty.call(g, "contextLocale") && d.uint32(
      /* id 20, wireType 2 =*/
      162
    ).string(g.contextLocale), g.contextUserAgent != null && Object.hasOwnProperty.call(g, "contextUserAgent") && d.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(g.contextUserAgent), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 22, wireType 2 =*/
      178
    ).string(g.label), g.commands != null && g.commands.length) for (let k = 0; k < g.commands.length; ++k) $root$1.Command.encode(g.commands[k], d.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim();
    if (g.execTime != null && Object.hasOwnProperty.call(g, "execTime") && d.uint32(
      /* id 24, wireType 0 =*/
      192
    ).int64(g.execTime), g.prepTime != null && Object.hasOwnProperty.call(g, "prepTime") && d.uint32(
      /* id 25, wireType 0 =*/
      200
    ).int64(g.prepTime), g.config != null && g.config.length) for (let k = 0; k < g.config.length; ++k) d.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(g.config[k]);
    if (g.uncaughtException != null && Object.hasOwnProperty.call(g, "uncaughtException") && d.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(g.uncaughtException), g.attributions != null && g.attributions.length) for (let k = 0; k < g.attributions.length; ++k) d.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(g.attributions[k]);
    return g.os != null && Object.hasOwnProperty.call(g, "os") && d.uint32(
      /* id 29, wireType 2 =*/
      234
    ).string(g.os), g.timezone != null && Object.hasOwnProperty.call(g, "timezone") && d.uint32(
      /* id 30, wireType 2 =*/
      242
    ).string(g.timezone), g.headless != null && Object.hasOwnProperty.call(g, "headless") && d.uint32(
      /* id 31, wireType 0 =*/
      248
    ).bool(g.headless), g.isFragmentRun != null && Object.hasOwnProperty.call(g, "isFragmentRun") && d.uint32(
      /* id 32, wireType 0 =*/
      256
    ).bool(g.isFragmentRun), g.appId != null && Object.hasOwnProperty.call(g, "appId") && d.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(g.appId), g.numPages != null && Object.hasOwnProperty.call(g, "numPages") && d.uint32(
      /* id 34, wireType 0 =*/
      272
    ).int64(g.numPages), g.sessionId != null && Object.hasOwnProperty.call(g, "sessionId") && d.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(g.sessionId), g.pythonVersion != null && Object.hasOwnProperty.call(g, "pythonVersion") && d.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(g.pythonVersion), g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && d.uint32(
      /* id 37, wireType 2 =*/
      298
    ).string(g.pageScriptHash), g.activeTheme != null && Object.hasOwnProperty.call(g, "activeTheme") && d.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(g.activeTheme), g.totalLoadTime != null && Object.hasOwnProperty.call(g, "totalLoadTime") && d.uint32(
      /* id 39, wireType 0 =*/
      312
    ).int64(g.totalLoadTime), g.browserInfo != null && Object.hasOwnProperty.call(g, "browserInfo") && $root$1.BrowserInfo.encode(g.browserInfo, d.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), g.machineIdV4 != null && Object.hasOwnProperty.call(g, "machineIdV4") && d.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(g.machineIdV4), g.serverOs != null && Object.hasOwnProperty.call(g, "serverOs") && d.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(g.serverOs), g.hasDisplay != null && Object.hasOwnProperty.call(g, "hasDisplay") && d.uint32(
      /* id 43, wireType 0 =*/
      344
    ).bool(g.hasDisplay), g.isWebdriver != null && Object.hasOwnProperty.call(g, "isWebdriver") && d.uint32(
      /* id 44, wireType 0 =*/
      352
    ).bool(g.isWebdriver), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.MetricsEvent();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.event = g.string();
          break;
        }
        case 2: {
          AA.anonymousId = g.string();
          break;
        }
        case 3: {
          AA.machineIdV3 = g.string();
          break;
        }
        case 41: {
          AA.machineIdV4 = g.string();
          break;
        }
        case 4: {
          AA.reportHash = g.string();
          break;
        }
        case 5: {
          AA.dev = g.bool();
          break;
        }
        case 6: {
          AA.source = g.string();
          break;
        }
        case 7: {
          AA.streamlitVersion = g.string();
          break;
        }
        case 8: {
          AA.isHello = g.bool();
          break;
        }
        case 33: {
          AA.appId = g.string();
          break;
        }
        case 35: {
          AA.sessionId = g.string();
          break;
        }
        case 36: {
          AA.pythonVersion = g.string();
          break;
        }
        case 42: {
          AA.serverOs = g.string();
          break;
        }
        case 43: {
          AA.hasDisplay = g.bool();
          break;
        }
        case 44: {
          AA.isWebdriver = g.bool();
          break;
        }
        case 9: {
          AA.hostedAt = g.string();
          break;
        }
        case 10: {
          AA.owner = g.string();
          break;
        }
        case 11: {
          AA.repo = g.string();
          break;
        }
        case 12: {
          AA.branch = g.string();
          break;
        }
        case 13: {
          AA.mainModule = g.string();
          break;
        }
        case 14: {
          AA.creatorId = g.string();
          break;
        }
        case 15: {
          AA.contextPageUrl = g.string();
          break;
        }
        case 16: {
          AA.contextPageTitle = g.string();
          break;
        }
        case 17: {
          AA.contextPagePath = g.string();
          break;
        }
        case 18: {
          AA.contextPageReferrer = g.string();
          break;
        }
        case 19: {
          AA.contextPageSearch = g.string();
          break;
        }
        case 20: {
          AA.contextLocale = g.string();
          break;
        }
        case 21: {
          AA.contextUserAgent = g.string();
          break;
        }
        case 22: {
          AA.label = g.string();
          break;
        }
        case 23: {
          AA.commands && AA.commands.length || (AA.commands = []), AA.commands.push($root$1.Command.decode(g, g.uint32()));
          break;
        }
        case 24: {
          AA.execTime = g.int64();
          break;
        }
        case 25: {
          AA.prepTime = g.int64();
          break;
        }
        case 26: {
          AA.config && AA.config.length || (AA.config = []), AA.config.push(g.string());
          break;
        }
        case 27: {
          AA.uncaughtException = g.string();
          break;
        }
        case 28: {
          AA.attributions && AA.attributions.length || (AA.attributions = []), AA.attributions.push(g.string());
          break;
        }
        case 29: {
          AA.os = g.string();
          break;
        }
        case 30: {
          AA.timezone = g.string();
          break;
        }
        case 31: {
          AA.headless = g.bool();
          break;
        }
        case 32: {
          AA.isFragmentRun = g.bool();
          break;
        }
        case 34: {
          AA.numPages = g.int64();
          break;
        }
        case 37: {
          AA.pageScriptHash = g.string();
          break;
        }
        case 38: {
          AA.activeTheme = g.string();
          break;
        }
        case 39: {
          AA.totalLoadTime = g.int64();
          break;
        }
        case 40: {
          AA.browserInfo = $root$1.BrowserInfo.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.event != null && g.hasOwnProperty("event") && !$util$1.isString(g.event)) return "event: string expected";
    if (g.anonymousId != null && g.hasOwnProperty("anonymousId") && !$util$1.isString(g.anonymousId)) return "anonymousId: string expected";
    if (g.machineIdV3 != null && g.hasOwnProperty("machineIdV3") && !$util$1.isString(g.machineIdV3)) return "machineIdV3: string expected";
    if (g.machineIdV4 != null && g.hasOwnProperty("machineIdV4") && !$util$1.isString(g.machineIdV4)) return "machineIdV4: string expected";
    if (g.reportHash != null && g.hasOwnProperty("reportHash") && !$util$1.isString(g.reportHash)) return "reportHash: string expected";
    if (g.dev != null && g.hasOwnProperty("dev") && typeof g.dev != "boolean") return "dev: boolean expected";
    if (g.source != null && g.hasOwnProperty("source") && !$util$1.isString(g.source)) return "source: string expected";
    if (g.streamlitVersion != null && g.hasOwnProperty("streamlitVersion") && !$util$1.isString(g.streamlitVersion)) return "streamlitVersion: string expected";
    if (g.isHello != null && g.hasOwnProperty("isHello") && typeof g.isHello != "boolean") return "isHello: boolean expected";
    if (g.appId != null && g.hasOwnProperty("appId") && !$util$1.isString(g.appId)) return "appId: string expected";
    if (g.sessionId != null && g.hasOwnProperty("sessionId") && !$util$1.isString(g.sessionId)) return "sessionId: string expected";
    if (g.pythonVersion != null && g.hasOwnProperty("pythonVersion") && !$util$1.isString(g.pythonVersion)) return "pythonVersion: string expected";
    if (g.serverOs != null && g.hasOwnProperty("serverOs") && !$util$1.isString(g.serverOs)) return "serverOs: string expected";
    if (g.hasDisplay != null && g.hasOwnProperty("hasDisplay") && typeof g.hasDisplay != "boolean") return "hasDisplay: boolean expected";
    if (g.isWebdriver != null && g.hasOwnProperty("isWebdriver") && typeof g.isWebdriver != "boolean") return "isWebdriver: boolean expected";
    if (g.hostedAt != null && g.hasOwnProperty("hostedAt") && !$util$1.isString(g.hostedAt)) return "hostedAt: string expected";
    if (g.owner != null && g.hasOwnProperty("owner") && !$util$1.isString(g.owner)) return "owner: string expected";
    if (g.repo != null && g.hasOwnProperty("repo") && !$util$1.isString(g.repo)) return "repo: string expected";
    if (g.branch != null && g.hasOwnProperty("branch") && !$util$1.isString(g.branch)) return "branch: string expected";
    if (g.mainModule != null && g.hasOwnProperty("mainModule") && !$util$1.isString(g.mainModule)) return "mainModule: string expected";
    if (g.creatorId != null && g.hasOwnProperty("creatorId") && !$util$1.isString(g.creatorId)) return "creatorId: string expected";
    if (g.contextPageUrl != null && g.hasOwnProperty("contextPageUrl") && !$util$1.isString(g.contextPageUrl)) return "contextPageUrl: string expected";
    if (g.contextPageTitle != null && g.hasOwnProperty("contextPageTitle") && !$util$1.isString(g.contextPageTitle)) return "contextPageTitle: string expected";
    if (g.contextPagePath != null && g.hasOwnProperty("contextPagePath") && !$util$1.isString(g.contextPagePath)) return "contextPagePath: string expected";
    if (g.contextPageReferrer != null && g.hasOwnProperty("contextPageReferrer") && !$util$1.isString(g.contextPageReferrer)) return "contextPageReferrer: string expected";
    if (g.contextPageSearch != null && g.hasOwnProperty("contextPageSearch") && !$util$1.isString(g.contextPageSearch)) return "contextPageSearch: string expected";
    if (g.contextLocale != null && g.hasOwnProperty("contextLocale") && !$util$1.isString(g.contextLocale)) return "contextLocale: string expected";
    if (g.contextUserAgent != null && g.hasOwnProperty("contextUserAgent") && !$util$1.isString(g.contextUserAgent)) return "contextUserAgent: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util$1.isString(g.label)) return "label: string expected";
    if (g.commands != null && g.hasOwnProperty("commands")) {
      if (!Array.isArray(g.commands)) return "commands: array expected";
      for (let d = 0; d < g.commands.length; ++d) {
        let k = $root$1.Command.verify(g.commands[d]);
        if (k) return "commands." + k;
      }
    }
    if (g.execTime != null && g.hasOwnProperty("execTime") && !$util$1.isInteger(g.execTime) && !(g.execTime && $util$1.isInteger(g.execTime.low) && $util$1.isInteger(g.execTime.high))) return "execTime: integer|Long expected";
    if (g.prepTime != null && g.hasOwnProperty("prepTime") && !$util$1.isInteger(g.prepTime) && !(g.prepTime && $util$1.isInteger(g.prepTime.low) && $util$1.isInteger(g.prepTime.high))) return "prepTime: integer|Long expected";
    if (g.config != null && g.hasOwnProperty("config")) {
      if (!Array.isArray(g.config)) return "config: array expected";
      for (let d = 0; d < g.config.length; ++d) if (!$util$1.isString(g.config[d])) return "config: string[] expected";
    }
    if (g.uncaughtException != null && g.hasOwnProperty("uncaughtException") && !$util$1.isString(g.uncaughtException)) return "uncaughtException: string expected";
    if (g.attributions != null && g.hasOwnProperty("attributions")) {
      if (!Array.isArray(g.attributions)) return "attributions: array expected";
      for (let d = 0; d < g.attributions.length; ++d) if (!$util$1.isString(g.attributions[d])) return "attributions: string[] expected";
    }
    if (g.os != null && g.hasOwnProperty("os") && !$util$1.isString(g.os)) return "os: string expected";
    if (g.timezone != null && g.hasOwnProperty("timezone") && !$util$1.isString(g.timezone)) return "timezone: string expected";
    if (g.headless != null && g.hasOwnProperty("headless") && typeof g.headless != "boolean") return "headless: boolean expected";
    if (g.isFragmentRun != null && g.hasOwnProperty("isFragmentRun") && typeof g.isFragmentRun != "boolean") return "isFragmentRun: boolean expected";
    if (g.numPages != null && g.hasOwnProperty("numPages") && !$util$1.isInteger(g.numPages) && !(g.numPages && $util$1.isInteger(g.numPages.low) && $util$1.isInteger(g.numPages.high))) return "numPages: integer|Long expected";
    if (g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && !$util$1.isString(g.pageScriptHash)) return "pageScriptHash: string expected";
    if (g.activeTheme != null && g.hasOwnProperty("activeTheme") && !$util$1.isString(g.activeTheme)) return "activeTheme: string expected";
    if (g.totalLoadTime != null && g.hasOwnProperty("totalLoadTime") && !$util$1.isInteger(g.totalLoadTime) && !(g.totalLoadTime && $util$1.isInteger(g.totalLoadTime.low) && $util$1.isInteger(g.totalLoadTime.high))) return "totalLoadTime: integer|Long expected";
    if (g.browserInfo != null && g.hasOwnProperty("browserInfo")) {
      let d = $root$1.BrowserInfo.verify(g.browserInfo);
      if (d) return "browserInfo." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.MetricsEvent) return g;
    let d = new $root$1.MetricsEvent();
    if (g.event != null && (d.event = String(g.event)), g.anonymousId != null && (d.anonymousId = String(g.anonymousId)), g.machineIdV3 != null && (d.machineIdV3 = String(g.machineIdV3)), g.machineIdV4 != null && (d.machineIdV4 = String(g.machineIdV4)), g.reportHash != null && (d.reportHash = String(g.reportHash)), g.dev != null && (d.dev = !!g.dev), g.source != null && (d.source = String(g.source)), g.streamlitVersion != null && (d.streamlitVersion = String(g.streamlitVersion)), g.isHello != null && (d.isHello = !!g.isHello), g.appId != null && (d.appId = String(g.appId)), g.sessionId != null && (d.sessionId = String(g.sessionId)), g.pythonVersion != null && (d.pythonVersion = String(g.pythonVersion)), g.serverOs != null && (d.serverOs = String(g.serverOs)), g.hasDisplay != null && (d.hasDisplay = !!g.hasDisplay), g.isWebdriver != null && (d.isWebdriver = !!g.isWebdriver), g.hostedAt != null && (d.hostedAt = String(g.hostedAt)), g.owner != null && (d.owner = String(g.owner)), g.repo != null && (d.repo = String(g.repo)), g.branch != null && (d.branch = String(g.branch)), g.mainModule != null && (d.mainModule = String(g.mainModule)), g.creatorId != null && (d.creatorId = String(g.creatorId)), g.contextPageUrl != null && (d.contextPageUrl = String(g.contextPageUrl)), g.contextPageTitle != null && (d.contextPageTitle = String(g.contextPageTitle)), g.contextPagePath != null && (d.contextPagePath = String(g.contextPagePath)), g.contextPageReferrer != null && (d.contextPageReferrer = String(g.contextPageReferrer)), g.contextPageSearch != null && (d.contextPageSearch = String(g.contextPageSearch)), g.contextLocale != null && (d.contextLocale = String(g.contextLocale)), g.contextUserAgent != null && (d.contextUserAgent = String(g.contextUserAgent)), g.label != null && (d.label = String(g.label)), g.commands) {
      if (!Array.isArray(g.commands)) throw TypeError(".MetricsEvent.commands: array expected");
      d.commands = [];
      for (let k = 0; k < g.commands.length; ++k) {
        if (typeof g.commands[k] != "object") throw TypeError(".MetricsEvent.commands: object expected");
        d.commands[k] = $root$1.Command.fromObject(g.commands[k]);
      }
    }
    if (g.execTime != null && ($util$1.Long ? (d.execTime = $util$1.Long.fromValue(g.execTime)).unsigned = !1 : typeof g.execTime == "string" ? d.execTime = parseInt(g.execTime, 10) : typeof g.execTime == "number" ? d.execTime = g.execTime : typeof g.execTime == "object" && (d.execTime = new $util$1.LongBits(g.execTime.low >>> 0, g.execTime.high >>> 0).toNumber())), g.prepTime != null && ($util$1.Long ? (d.prepTime = $util$1.Long.fromValue(g.prepTime)).unsigned = !1 : typeof g.prepTime == "string" ? d.prepTime = parseInt(g.prepTime, 10) : typeof g.prepTime == "number" ? d.prepTime = g.prepTime : typeof g.prepTime == "object" && (d.prepTime = new $util$1.LongBits(g.prepTime.low >>> 0, g.prepTime.high >>> 0).toNumber())), g.config) {
      if (!Array.isArray(g.config)) throw TypeError(".MetricsEvent.config: array expected");
      d.config = [];
      for (let k = 0; k < g.config.length; ++k) d.config[k] = String(g.config[k]);
    }
    if (g.uncaughtException != null && (d.uncaughtException = String(g.uncaughtException)), g.attributions) {
      if (!Array.isArray(g.attributions)) throw TypeError(".MetricsEvent.attributions: array expected");
      d.attributions = [];
      for (let k = 0; k < g.attributions.length; ++k) d.attributions[k] = String(g.attributions[k]);
    }
    if (g.os != null && (d.os = String(g.os)), g.timezone != null && (d.timezone = String(g.timezone)), g.headless != null && (d.headless = !!g.headless), g.isFragmentRun != null && (d.isFragmentRun = !!g.isFragmentRun), g.numPages != null && ($util$1.Long ? (d.numPages = $util$1.Long.fromValue(g.numPages)).unsigned = !1 : typeof g.numPages == "string" ? d.numPages = parseInt(g.numPages, 10) : typeof g.numPages == "number" ? d.numPages = g.numPages : typeof g.numPages == "object" && (d.numPages = new $util$1.LongBits(g.numPages.low >>> 0, g.numPages.high >>> 0).toNumber())), g.pageScriptHash != null && (d.pageScriptHash = String(g.pageScriptHash)), g.activeTheme != null && (d.activeTheme = String(g.activeTheme)), g.totalLoadTime != null && ($util$1.Long ? (d.totalLoadTime = $util$1.Long.fromValue(g.totalLoadTime)).unsigned = !1 : typeof g.totalLoadTime == "string" ? d.totalLoadTime = parseInt(g.totalLoadTime, 10) : typeof g.totalLoadTime == "number" ? d.totalLoadTime = g.totalLoadTime : typeof g.totalLoadTime == "object" && (d.totalLoadTime = new $util$1.LongBits(g.totalLoadTime.low >>> 0, g.totalLoadTime.high >>> 0).toNumber())), g.browserInfo != null) {
      if (typeof g.browserInfo != "object") throw TypeError(".MetricsEvent.browserInfo: object expected");
      d.browserInfo = $root$1.BrowserInfo.fromObject(g.browserInfo);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.commands = [], k.config = [], k.attributions = []), d.defaults) {
      if (k.event = "", k.anonymousId = "", k.machineIdV3 = "", k.reportHash = "", k.dev = !1, k.source = "", k.streamlitVersion = "", k.isHello = !1, k.hostedAt = "", k.owner = "", k.repo = "", k.branch = "", k.mainModule = "", k.creatorId = "", k.contextPageUrl = "", k.contextPageTitle = "", k.contextPagePath = "", k.contextPageReferrer = "", k.contextPageSearch = "", k.contextLocale = "", k.contextUserAgent = "", k.label = "", $util$1.Long) {
        let H = new $util$1.Long(0, 0, !1);
        k.execTime = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
      } else k.execTime = d.longs === String ? "0" : 0;
      if ($util$1.Long) {
        let H = new $util$1.Long(0, 0, !1);
        k.prepTime = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
      } else k.prepTime = d.longs === String ? "0" : 0;
      if (k.uncaughtException = "", k.os = "", k.timezone = "", k.headless = !1, k.isFragmentRun = !1, k.appId = "", $util$1.Long) {
        let H = new $util$1.Long(0, 0, !1);
        k.numPages = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
      } else k.numPages = d.longs === String ? "0" : 0;
      if (k.sessionId = "", k.pythonVersion = "", k.pageScriptHash = "", k.activeTheme = "", $util$1.Long) {
        let H = new $util$1.Long(0, 0, !1);
        k.totalLoadTime = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
      } else k.totalLoadTime = d.longs === String ? "0" : 0;
      k.browserInfo = null, k.machineIdV4 = "", k.serverOs = "", k.hasDisplay = !1, k.isWebdriver = !1;
    }
    if (g.event != null && g.hasOwnProperty("event") && (k.event = g.event), g.anonymousId != null && g.hasOwnProperty("anonymousId") && (k.anonymousId = g.anonymousId), g.machineIdV3 != null && g.hasOwnProperty("machineIdV3") && (k.machineIdV3 = g.machineIdV3), g.reportHash != null && g.hasOwnProperty("reportHash") && (k.reportHash = g.reportHash), g.dev != null && g.hasOwnProperty("dev") && (k.dev = g.dev), g.source != null && g.hasOwnProperty("source") && (k.source = g.source), g.streamlitVersion != null && g.hasOwnProperty("streamlitVersion") && (k.streamlitVersion = g.streamlitVersion), g.isHello != null && g.hasOwnProperty("isHello") && (k.isHello = g.isHello), g.hostedAt != null && g.hasOwnProperty("hostedAt") && (k.hostedAt = g.hostedAt), g.owner != null && g.hasOwnProperty("owner") && (k.owner = g.owner), g.repo != null && g.hasOwnProperty("repo") && (k.repo = g.repo), g.branch != null && g.hasOwnProperty("branch") && (k.branch = g.branch), g.mainModule != null && g.hasOwnProperty("mainModule") && (k.mainModule = g.mainModule), g.creatorId != null && g.hasOwnProperty("creatorId") && (k.creatorId = g.creatorId), g.contextPageUrl != null && g.hasOwnProperty("contextPageUrl") && (k.contextPageUrl = g.contextPageUrl), g.contextPageTitle != null && g.hasOwnProperty("contextPageTitle") && (k.contextPageTitle = g.contextPageTitle), g.contextPagePath != null && g.hasOwnProperty("contextPagePath") && (k.contextPagePath = g.contextPagePath), g.contextPageReferrer != null && g.hasOwnProperty("contextPageReferrer") && (k.contextPageReferrer = g.contextPageReferrer), g.contextPageSearch != null && g.hasOwnProperty("contextPageSearch") && (k.contextPageSearch = g.contextPageSearch), g.contextLocale != null && g.hasOwnProperty("contextLocale") && (k.contextLocale = g.contextLocale), g.contextUserAgent != null && g.hasOwnProperty("contextUserAgent") && (k.contextUserAgent = g.contextUserAgent), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.commands && g.commands.length) {
      k.commands = [];
      for (let H = 0; H < g.commands.length; ++H) k.commands[H] = $root$1.Command.toObject(g.commands[H], d);
    }
    if (g.execTime != null && g.hasOwnProperty("execTime") && (typeof g.execTime == "number" ? k.execTime = d.longs === String ? String(g.execTime) : g.execTime : k.execTime = d.longs === String ? $util$1.Long.prototype.toString.call(g.execTime) : d.longs === Number ? new $util$1.LongBits(g.execTime.low >>> 0, g.execTime.high >>> 0).toNumber() : g.execTime), g.prepTime != null && g.hasOwnProperty("prepTime") && (typeof g.prepTime == "number" ? k.prepTime = d.longs === String ? String(g.prepTime) : g.prepTime : k.prepTime = d.longs === String ? $util$1.Long.prototype.toString.call(g.prepTime) : d.longs === Number ? new $util$1.LongBits(g.prepTime.low >>> 0, g.prepTime.high >>> 0).toNumber() : g.prepTime), g.config && g.config.length) {
      k.config = [];
      for (let H = 0; H < g.config.length; ++H) k.config[H] = g.config[H];
    }
    if (g.uncaughtException != null && g.hasOwnProperty("uncaughtException") && (k.uncaughtException = g.uncaughtException), g.attributions && g.attributions.length) {
      k.attributions = [];
      for (let H = 0; H < g.attributions.length; ++H) k.attributions[H] = g.attributions[H];
    }
    return g.os != null && g.hasOwnProperty("os") && (k.os = g.os), g.timezone != null && g.hasOwnProperty("timezone") && (k.timezone = g.timezone), g.headless != null && g.hasOwnProperty("headless") && (k.headless = g.headless), g.isFragmentRun != null && g.hasOwnProperty("isFragmentRun") && (k.isFragmentRun = g.isFragmentRun), g.appId != null && g.hasOwnProperty("appId") && (k.appId = g.appId), g.numPages != null && g.hasOwnProperty("numPages") && (typeof g.numPages == "number" ? k.numPages = d.longs === String ? String(g.numPages) : g.numPages : k.numPages = d.longs === String ? $util$1.Long.prototype.toString.call(g.numPages) : d.longs === Number ? new $util$1.LongBits(g.numPages.low >>> 0, g.numPages.high >>> 0).toNumber() : g.numPages), g.sessionId != null && g.hasOwnProperty("sessionId") && (k.sessionId = g.sessionId), g.pythonVersion != null && g.hasOwnProperty("pythonVersion") && (k.pythonVersion = g.pythonVersion), g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (k.pageScriptHash = g.pageScriptHash), g.activeTheme != null && g.hasOwnProperty("activeTheme") && (k.activeTheme = g.activeTheme), g.totalLoadTime != null && g.hasOwnProperty("totalLoadTime") && (typeof g.totalLoadTime == "number" ? k.totalLoadTime = d.longs === String ? String(g.totalLoadTime) : g.totalLoadTime : k.totalLoadTime = d.longs === String ? $util$1.Long.prototype.toString.call(g.totalLoadTime) : d.longs === Number ? new $util$1.LongBits(g.totalLoadTime.low >>> 0, g.totalLoadTime.high >>> 0).toNumber() : g.totalLoadTime), g.browserInfo != null && g.hasOwnProperty("browserInfo") && (k.browserInfo = $root$1.BrowserInfo.toObject(g.browserInfo, d)), g.machineIdV4 != null && g.hasOwnProperty("machineIdV4") && (k.machineIdV4 = g.machineIdV4), g.serverOs != null && g.hasOwnProperty("serverOs") && (k.serverOs = g.serverOs), g.hasDisplay != null && g.hasOwnProperty("hasDisplay") && (k.hasDisplay = g.hasDisplay), g.isWebdriver != null && g.hasOwnProperty("isWebdriver") && (k.isWebdriver = g.isWebdriver), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/MetricsEvent";
  }, n;
})();
$root$1.BrowserInfo = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.browserName = "", n.prototype.browserVersion = "", n.prototype.deviceType = "", n.prototype.os = "", n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer$1.create()), g.browserName != null && Object.hasOwnProperty.call(g, "browserName") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.browserName), g.browserVersion != null && Object.hasOwnProperty.call(g, "browserVersion") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.browserVersion), g.deviceType != null && Object.hasOwnProperty.call(g, "deviceType") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.deviceType), g.os != null && Object.hasOwnProperty.call(g, "os") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.os), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader$1 || (g = $Reader$1.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root$1.BrowserInfo();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.browserName = g.string();
          break;
        }
        case 2: {
          AA.browserVersion = g.string();
          break;
        }
        case 3: {
          AA.deviceType = g.string();
          break;
        }
        case 4: {
          AA.os = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader$1 || (g = new $Reader$1(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.browserName != null && g.hasOwnProperty("browserName") && !$util$1.isString(g.browserName) ? "browserName: string expected" : g.browserVersion != null && g.hasOwnProperty("browserVersion") && !$util$1.isString(g.browserVersion) ? "browserVersion: string expected" : g.deviceType != null && g.hasOwnProperty("deviceType") && !$util$1.isString(g.deviceType) ? "deviceType: string expected" : g.os != null && g.hasOwnProperty("os") && !$util$1.isString(g.os) ? "os: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root$1.BrowserInfo) return g;
    let d = new $root$1.BrowserInfo();
    return g.browserName != null && (d.browserName = String(g.browserName)), g.browserVersion != null && (d.browserVersion = String(g.browserVersion)), g.deviceType != null && (d.deviceType = String(g.deviceType)), g.os != null && (d.os = String(g.os)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.browserName = "", k.browserVersion = "", k.deviceType = "", k.os = ""), g.browserName != null && g.hasOwnProperty("browserName") && (k.browserName = g.browserName), g.browserVersion != null && g.hasOwnProperty("browserVersion") && (k.browserVersion = g.browserVersion), g.deviceType != null && g.hasOwnProperty("deviceType") && (k.deviceType = g.deviceType), g.os != null && g.hasOwnProperty("os") && (k.os = g.os), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/BrowserInfo";
  }, n;
})();
$root$1.openmetrics = (() => {
  const n = {};
  return n.MetricSet = (function() {
    function t(g) {
      if (this.metricFamilies = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.metricFamilies = $util$1.emptyArray, t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      if (k || (k = $Writer$1.create()), d.metricFamilies != null && d.metricFamilies.length) for (let H = 0; H < d.metricFamilies.length; ++H) $root$1.openmetrics.MetricFamily.encode(d.metricFamilies[H], k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader$1 || (d = $Reader$1.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.openmetrics.MetricSet();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.metricFamilies && gA.metricFamilies.length || (gA.metricFamilies = []), gA.metricFamilies.push($root$1.openmetrics.MetricFamily.decode(d, d.uint32()));
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      if (d.metricFamilies != null && d.hasOwnProperty("metricFamilies")) {
        if (!Array.isArray(d.metricFamilies)) return "metricFamilies: array expected";
        for (let k = 0; k < d.metricFamilies.length; ++k) {
          let H = $root$1.openmetrics.MetricFamily.verify(d.metricFamilies[k]);
          if (H) return "metricFamilies." + H;
        }
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root$1.openmetrics.MetricSet) return d;
      let k = new $root$1.openmetrics.MetricSet();
      if (d.metricFamilies) {
        if (!Array.isArray(d.metricFamilies)) throw TypeError(".openmetrics.MetricSet.metricFamilies: array expected");
        k.metricFamilies = [];
        for (let H = 0; H < d.metricFamilies.length; ++H) {
          if (typeof d.metricFamilies[H] != "object") throw TypeError(".openmetrics.MetricSet.metricFamilies: object expected");
          k.metricFamilies[H] = $root$1.openmetrics.MetricFamily.fromObject(d.metricFamilies[H]);
        }
      }
      return k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      if ((k.arrays || k.defaults) && (H.metricFamilies = []), d.metricFamilies && d.metricFamilies.length) {
        H.metricFamilies = [];
        for (let AA = 0; AA < d.metricFamilies.length; ++AA) H.metricFamilies[AA] = $root$1.openmetrics.MetricFamily.toObject(d.metricFamilies[AA], k);
      }
      return H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.MetricSet";
    }, t;
  })(), n.MetricFamily = (function() {
    function t(g) {
      if (this.metrics = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.name = "", t.prototype.type = 0, t.prototype.unit = "", t.prototype.help = "", t.prototype.metrics = $util$1.emptyArray, t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      if (k || (k = $Writer$1.create()), d.name != null && Object.hasOwnProperty.call(d, "name") && k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(d.name), d.type != null && Object.hasOwnProperty.call(d, "type") && k.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(d.type), d.unit != null && Object.hasOwnProperty.call(d, "unit") && k.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(d.unit), d.help != null && Object.hasOwnProperty.call(d, "help") && k.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(d.help), d.metrics != null && d.metrics.length) for (let H = 0; H < d.metrics.length; ++H) $root$1.Metric.encode(d.metrics[H], k.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader$1 || (d = $Reader$1.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.openmetrics.MetricFamily();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.name = d.string();
            break;
          }
          case 2: {
            gA.type = d.int32();
            break;
          }
          case 3: {
            gA.unit = d.string();
            break;
          }
          case 4: {
            gA.help = d.string();
            break;
          }
          case 5: {
            gA.metrics && gA.metrics.length || (gA.metrics = []), gA.metrics.push($root$1.Metric.decode(d, d.uint32()));
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      if (d.name != null && d.hasOwnProperty("name") && !$util$1.isString(d.name)) return "name: string expected";
      if (d.type != null && d.hasOwnProperty("type")) switch (d.type) {
        default:
          return "type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          break;
      }
      if (d.unit != null && d.hasOwnProperty("unit") && !$util$1.isString(d.unit)) return "unit: string expected";
      if (d.help != null && d.hasOwnProperty("help") && !$util$1.isString(d.help)) return "help: string expected";
      if (d.metrics != null && d.hasOwnProperty("metrics")) {
        if (!Array.isArray(d.metrics)) return "metrics: array expected";
        for (let k = 0; k < d.metrics.length; ++k) {
          let H = $root$1.Metric.verify(d.metrics[k]);
          if (H) return "metrics." + H;
        }
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root$1.openmetrics.MetricFamily) return d;
      let k = new $root$1.openmetrics.MetricFamily();
      switch (d.name != null && (k.name = String(d.name)), d.type) {
        default:
          if (typeof d.type == "number") {
            k.type = d.type;
            break;
          }
          break;
        case "UNKNOWN":
        case 0:
          k.type = 0;
          break;
        case "GAUGE":
        case 1:
          k.type = 1;
          break;
        case "COUNTER":
        case 2:
          k.type = 2;
          break;
        case "STATE_SET":
        case 3:
          k.type = 3;
          break;
        case "INFO":
        case 4:
          k.type = 4;
          break;
        case "HISTOGRAM":
        case 5:
          k.type = 5;
          break;
        case "GAUGE_HISTOGRAM":
        case 6:
          k.type = 6;
          break;
        case "SUMMARY":
        case 7:
          k.type = 7;
          break;
      }
      if (d.unit != null && (k.unit = String(d.unit)), d.help != null && (k.help = String(d.help)), d.metrics) {
        if (!Array.isArray(d.metrics)) throw TypeError(".openmetrics.MetricFamily.metrics: array expected");
        k.metrics = [];
        for (let H = 0; H < d.metrics.length; ++H) {
          if (typeof d.metrics[H] != "object") throw TypeError(".openmetrics.MetricFamily.metrics: object expected");
          k.metrics[H] = $root$1.Metric.fromObject(d.metrics[H]);
        }
      }
      return k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      if ((k.arrays || k.defaults) && (H.metrics = []), k.defaults && (H.name = "", H.type = k.enums === String ? "UNKNOWN" : 0, H.unit = "", H.help = ""), d.name != null && d.hasOwnProperty("name") && (H.name = d.name), d.type != null && d.hasOwnProperty("type") && (H.type = k.enums === String ? $root$1.openmetrics.MetricType[d.type] === void 0 ? d.type : $root$1.openmetrics.MetricType[d.type] : d.type), d.unit != null && d.hasOwnProperty("unit") && (H.unit = d.unit), d.help != null && d.hasOwnProperty("help") && (H.help = d.help), d.metrics && d.metrics.length) {
        H.metrics = [];
        for (let AA = 0; AA < d.metrics.length; ++AA) H.metrics[AA] = $root$1.Metric.toObject(d.metrics[AA], k);
      }
      return H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.MetricFamily";
    }, t;
  })(), n.MetricType = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "UNKNOWN"] = 0, g[t[1] = "GAUGE"] = 1, g[t[2] = "COUNTER"] = 2, g[t[3] = "STATE_SET"] = 3, g[t[4] = "INFO"] = 4, g[t[5] = "HISTOGRAM"] = 5, g[t[6] = "GAUGE_HISTOGRAM"] = 6, g[t[7] = "SUMMARY"] = 7, g;
  })(), n.Metric = (function() {
    function t(g) {
      if (this.labels = [], this.metricPoints = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.labels = $util$1.emptyArray, t.prototype.metricPoints = $util$1.emptyArray, t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      if (k || (k = $Writer$1.create()), d.labels != null && d.labels.length) for (let H = 0; H < d.labels.length; ++H) $root$1.openmetrics.Label.encode(d.labels[H], k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      if (d.metricPoints != null && d.metricPoints.length) for (let H = 0; H < d.metricPoints.length; ++H) $root$1.openmetrics.MetricPoint.encode(d.metricPoints[H], k.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim();
      return k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader$1 || (d = $Reader$1.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.openmetrics.Metric();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.labels && gA.labels.length || (gA.labels = []), gA.labels.push($root$1.openmetrics.Label.decode(d, d.uint32()));
            break;
          }
          case 2: {
            gA.metricPoints && gA.metricPoints.length || (gA.metricPoints = []), gA.metricPoints.push($root$1.openmetrics.MetricPoint.decode(d, d.uint32()));
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      if (d.labels != null && d.hasOwnProperty("labels")) {
        if (!Array.isArray(d.labels)) return "labels: array expected";
        for (let k = 0; k < d.labels.length; ++k) {
          let H = $root$1.openmetrics.Label.verify(d.labels[k]);
          if (H) return "labels." + H;
        }
      }
      if (d.metricPoints != null && d.hasOwnProperty("metricPoints")) {
        if (!Array.isArray(d.metricPoints)) return "metricPoints: array expected";
        for (let k = 0; k < d.metricPoints.length; ++k) {
          let H = $root$1.openmetrics.MetricPoint.verify(d.metricPoints[k]);
          if (H) return "metricPoints." + H;
        }
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root$1.openmetrics.Metric) return d;
      let k = new $root$1.openmetrics.Metric();
      if (d.labels) {
        if (!Array.isArray(d.labels)) throw TypeError(".openmetrics.Metric.labels: array expected");
        k.labels = [];
        for (let H = 0; H < d.labels.length; ++H) {
          if (typeof d.labels[H] != "object") throw TypeError(".openmetrics.Metric.labels: object expected");
          k.labels[H] = $root$1.openmetrics.Label.fromObject(d.labels[H]);
        }
      }
      if (d.metricPoints) {
        if (!Array.isArray(d.metricPoints)) throw TypeError(".openmetrics.Metric.metricPoints: array expected");
        k.metricPoints = [];
        for (let H = 0; H < d.metricPoints.length; ++H) {
          if (typeof d.metricPoints[H] != "object") throw TypeError(".openmetrics.Metric.metricPoints: object expected");
          k.metricPoints[H] = $root$1.openmetrics.MetricPoint.fromObject(d.metricPoints[H]);
        }
      }
      return k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      if ((k.arrays || k.defaults) && (H.labels = [], H.metricPoints = []), d.labels && d.labels.length) {
        H.labels = [];
        for (let AA = 0; AA < d.labels.length; ++AA) H.labels[AA] = $root$1.openmetrics.Label.toObject(d.labels[AA], k);
      }
      if (d.metricPoints && d.metricPoints.length) {
        H.metricPoints = [];
        for (let AA = 0; AA < d.metricPoints.length; ++AA) H.metricPoints[AA] = $root$1.openmetrics.MetricPoint.toObject(d.metricPoints[AA], k);
      }
      return H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.Metric";
    }, t;
  })(), n.Label = (function() {
    function t(g) {
      if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.name = "", t.prototype.value = "", t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      return k || (k = $Writer$1.create()), d.name != null && Object.hasOwnProperty.call(d, "name") && k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(d.name), d.value != null && Object.hasOwnProperty.call(d, "value") && k.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(d.value), k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader$1 || (d = $Reader$1.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.openmetrics.Label();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.name = d.string();
            break;
          }
          case 2: {
            gA.value = d.string();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      return typeof d != "object" || d === null ? "object expected" : d.name != null && d.hasOwnProperty("name") && !$util$1.isString(d.name) ? "name: string expected" : d.value != null && d.hasOwnProperty("value") && !$util$1.isString(d.value) ? "value: string expected" : null;
    }, t.fromObject = function(d) {
      if (d instanceof $root$1.openmetrics.Label) return d;
      let k = new $root$1.openmetrics.Label();
      return d.name != null && (k.name = String(d.name)), d.value != null && (k.value = String(d.value)), k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return k.defaults && (H.name = "", H.value = ""), d.name != null && d.hasOwnProperty("name") && (H.name = d.name), d.value != null && d.hasOwnProperty("value") && (H.value = d.value), H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.Label";
    }, t;
  })(), n.MetricPoint = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.unknownValue = null, t.prototype.gaugeValue = null, t.prototype.counterValue = null, t.prototype.histogramValue = null, t.prototype.stateSetValue = null, t.prototype.infoValue = null, t.prototype.summaryValue = null, t.prototype.timestamp = null;
    let g;
    return Object.defineProperty(t.prototype, "value", { get: $util$1.oneOfGetter(g = ["unknownValue", "gaugeValue", "counterValue", "histogramValue", "stateSetValue", "infoValue", "summaryValue"]), set: $util$1.oneOfSetter(g) }), t.create = function(k) {
      return new t(k);
    }, t.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.unknownValue != null && Object.hasOwnProperty.call(k, "unknownValue") && $root$1.openmetrics.UnknownValue.encode(k.unknownValue, H.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), k.gaugeValue != null && Object.hasOwnProperty.call(k, "gaugeValue") && $root$1.openmetrics.GaugeValue.encode(k.gaugeValue, H.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), k.counterValue != null && Object.hasOwnProperty.call(k, "counterValue") && $root$1.openmetrics.CounterValue.encode(k.counterValue, H.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), k.histogramValue != null && Object.hasOwnProperty.call(k, "histogramValue") && $root$1.openmetrics.HistogramValue.encode(k.histogramValue, H.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), k.stateSetValue != null && Object.hasOwnProperty.call(k, "stateSetValue") && $root$1.openmetrics.StateSetValue.encode(k.stateSetValue, H.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), k.infoValue != null && Object.hasOwnProperty.call(k, "infoValue") && $root$1.openmetrics.InfoValue.encode(k.infoValue, H.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), k.summaryValue != null && Object.hasOwnProperty.call(k, "summaryValue") && $root$1.openmetrics.SummaryValue.encode(k.summaryValue, H.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), k.timestamp != null && Object.hasOwnProperty.call(k, "timestamp") && $root$1.google.protobuf.Timestamp.encode(k.timestamp, H.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), H;
    }, t.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, t.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.openmetrics.MetricPoint();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.unknownValue = $root$1.openmetrics.UnknownValue.decode(k, k.uint32());
            break;
          }
          case 2: {
            IA.gaugeValue = $root$1.openmetrics.GaugeValue.decode(k, k.uint32());
            break;
          }
          case 3: {
            IA.counterValue = $root$1.openmetrics.CounterValue.decode(k, k.uint32());
            break;
          }
          case 4: {
            IA.histogramValue = $root$1.openmetrics.HistogramValue.decode(k, k.uint32());
            break;
          }
          case 5: {
            IA.stateSetValue = $root$1.openmetrics.StateSetValue.decode(k, k.uint32());
            break;
          }
          case 6: {
            IA.infoValue = $root$1.openmetrics.InfoValue.decode(k, k.uint32());
            break;
          }
          case 7: {
            IA.summaryValue = $root$1.openmetrics.SummaryValue.decode(k, k.uint32());
            break;
          }
          case 8: {
            IA.timestamp = $root$1.google.protobuf.Timestamp.decode(k, k.uint32());
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, t.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, t.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      let H = {};
      if (k.unknownValue != null && k.hasOwnProperty("unknownValue")) {
        H.value = 1;
        {
          let AA = $root$1.openmetrics.UnknownValue.verify(k.unknownValue);
          if (AA) return "unknownValue." + AA;
        }
      }
      if (k.gaugeValue != null && k.hasOwnProperty("gaugeValue")) {
        if (H.value === 1) return "value: multiple values";
        H.value = 1;
        {
          let AA = $root$1.openmetrics.GaugeValue.verify(k.gaugeValue);
          if (AA) return "gaugeValue." + AA;
        }
      }
      if (k.counterValue != null && k.hasOwnProperty("counterValue")) {
        if (H.value === 1) return "value: multiple values";
        H.value = 1;
        {
          let AA = $root$1.openmetrics.CounterValue.verify(k.counterValue);
          if (AA) return "counterValue." + AA;
        }
      }
      if (k.histogramValue != null && k.hasOwnProperty("histogramValue")) {
        if (H.value === 1) return "value: multiple values";
        H.value = 1;
        {
          let AA = $root$1.openmetrics.HistogramValue.verify(k.histogramValue);
          if (AA) return "histogramValue." + AA;
        }
      }
      if (k.stateSetValue != null && k.hasOwnProperty("stateSetValue")) {
        if (H.value === 1) return "value: multiple values";
        H.value = 1;
        {
          let AA = $root$1.openmetrics.StateSetValue.verify(k.stateSetValue);
          if (AA) return "stateSetValue." + AA;
        }
      }
      if (k.infoValue != null && k.hasOwnProperty("infoValue")) {
        if (H.value === 1) return "value: multiple values";
        H.value = 1;
        {
          let AA = $root$1.openmetrics.InfoValue.verify(k.infoValue);
          if (AA) return "infoValue." + AA;
        }
      }
      if (k.summaryValue != null && k.hasOwnProperty("summaryValue")) {
        if (H.value === 1) return "value: multiple values";
        H.value = 1;
        {
          let AA = $root$1.openmetrics.SummaryValue.verify(k.summaryValue);
          if (AA) return "summaryValue." + AA;
        }
      }
      if (k.timestamp != null && k.hasOwnProperty("timestamp")) {
        let AA = $root$1.google.protobuf.Timestamp.verify(k.timestamp);
        if (AA) return "timestamp." + AA;
      }
      return null;
    }, t.fromObject = function(k) {
      if (k instanceof $root$1.openmetrics.MetricPoint) return k;
      let H = new $root$1.openmetrics.MetricPoint();
      if (k.unknownValue != null) {
        if (typeof k.unknownValue != "object") throw TypeError(".openmetrics.MetricPoint.unknownValue: object expected");
        H.unknownValue = $root$1.openmetrics.UnknownValue.fromObject(k.unknownValue);
      }
      if (k.gaugeValue != null) {
        if (typeof k.gaugeValue != "object") throw TypeError(".openmetrics.MetricPoint.gaugeValue: object expected");
        H.gaugeValue = $root$1.openmetrics.GaugeValue.fromObject(k.gaugeValue);
      }
      if (k.counterValue != null) {
        if (typeof k.counterValue != "object") throw TypeError(".openmetrics.MetricPoint.counterValue: object expected");
        H.counterValue = $root$1.openmetrics.CounterValue.fromObject(k.counterValue);
      }
      if (k.histogramValue != null) {
        if (typeof k.histogramValue != "object") throw TypeError(".openmetrics.MetricPoint.histogramValue: object expected");
        H.histogramValue = $root$1.openmetrics.HistogramValue.fromObject(k.histogramValue);
      }
      if (k.stateSetValue != null) {
        if (typeof k.stateSetValue != "object") throw TypeError(".openmetrics.MetricPoint.stateSetValue: object expected");
        H.stateSetValue = $root$1.openmetrics.StateSetValue.fromObject(k.stateSetValue);
      }
      if (k.infoValue != null) {
        if (typeof k.infoValue != "object") throw TypeError(".openmetrics.MetricPoint.infoValue: object expected");
        H.infoValue = $root$1.openmetrics.InfoValue.fromObject(k.infoValue);
      }
      if (k.summaryValue != null) {
        if (typeof k.summaryValue != "object") throw TypeError(".openmetrics.MetricPoint.summaryValue: object expected");
        H.summaryValue = $root$1.openmetrics.SummaryValue.fromObject(k.summaryValue);
      }
      if (k.timestamp != null) {
        if (typeof k.timestamp != "object") throw TypeError(".openmetrics.MetricPoint.timestamp: object expected");
        H.timestamp = $root$1.google.protobuf.Timestamp.fromObject(k.timestamp);
      }
      return H;
    }, t.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.timestamp = null), k.unknownValue != null && k.hasOwnProperty("unknownValue") && (AA.unknownValue = $root$1.openmetrics.UnknownValue.toObject(k.unknownValue, H), H.oneofs && (AA.value = "unknownValue")), k.gaugeValue != null && k.hasOwnProperty("gaugeValue") && (AA.gaugeValue = $root$1.openmetrics.GaugeValue.toObject(k.gaugeValue, H), H.oneofs && (AA.value = "gaugeValue")), k.counterValue != null && k.hasOwnProperty("counterValue") && (AA.counterValue = $root$1.openmetrics.CounterValue.toObject(k.counterValue, H), H.oneofs && (AA.value = "counterValue")), k.histogramValue != null && k.hasOwnProperty("histogramValue") && (AA.histogramValue = $root$1.openmetrics.HistogramValue.toObject(k.histogramValue, H), H.oneofs && (AA.value = "histogramValue")), k.stateSetValue != null && k.hasOwnProperty("stateSetValue") && (AA.stateSetValue = $root$1.openmetrics.StateSetValue.toObject(k.stateSetValue, H), H.oneofs && (AA.value = "stateSetValue")), k.infoValue != null && k.hasOwnProperty("infoValue") && (AA.infoValue = $root$1.openmetrics.InfoValue.toObject(k.infoValue, H), H.oneofs && (AA.value = "infoValue")), k.summaryValue != null && k.hasOwnProperty("summaryValue") && (AA.summaryValue = $root$1.openmetrics.SummaryValue.toObject(k.summaryValue, H), H.oneofs && (AA.value = "summaryValue")), k.timestamp != null && k.hasOwnProperty("timestamp") && (AA.timestamp = $root$1.google.protobuf.Timestamp.toObject(k.timestamp, H)), AA;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/openmetrics.MetricPoint";
    }, t;
  })(), n.UnknownValue = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.doubleValue = null, t.prototype.intValue = null;
    let g;
    return Object.defineProperty(t.prototype, "value", { get: $util$1.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(g) }), t.create = function(k) {
      return new t(k);
    }, t.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.doubleValue != null && Object.hasOwnProperty.call(k, "doubleValue") && H.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(k.doubleValue), k.intValue != null && Object.hasOwnProperty.call(k, "intValue") && H.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(k.intValue), H;
    }, t.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, t.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.openmetrics.UnknownValue();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.doubleValue = k.double();
            break;
          }
          case 2: {
            IA.intValue = k.int64();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, t.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, t.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      let H = {};
      if (k.doubleValue != null && k.hasOwnProperty("doubleValue") && (H.value = 1, typeof k.doubleValue != "number"))
        return "doubleValue: number expected";
      if (k.intValue != null && k.hasOwnProperty("intValue")) {
        if (H.value === 1) return "value: multiple values";
        if (H.value = 1, !$util$1.isInteger(k.intValue) && !(k.intValue && $util$1.isInteger(k.intValue.low) && $util$1.isInteger(k.intValue.high))) return "intValue: integer|Long expected";
      }
      return null;
    }, t.fromObject = function(k) {
      if (k instanceof $root$1.openmetrics.UnknownValue) return k;
      let H = new $root$1.openmetrics.UnknownValue();
      return k.doubleValue != null && (H.doubleValue = Number(k.doubleValue)), k.intValue != null && ($util$1.Long ? (H.intValue = $util$1.Long.fromValue(k.intValue)).unsigned = !1 : typeof k.intValue == "string" ? H.intValue = parseInt(k.intValue, 10) : typeof k.intValue == "number" ? H.intValue = k.intValue : typeof k.intValue == "object" && (H.intValue = new $util$1.LongBits(k.intValue.low >>> 0, k.intValue.high >>> 0).toNumber())), H;
    }, t.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return k.doubleValue != null && k.hasOwnProperty("doubleValue") && (AA.doubleValue = H.json && !isFinite(k.doubleValue) ? String(k.doubleValue) : k.doubleValue, H.oneofs && (AA.value = "doubleValue")), k.intValue != null && k.hasOwnProperty("intValue") && (typeof k.intValue == "number" ? AA.intValue = H.longs === String ? String(k.intValue) : k.intValue : AA.intValue = H.longs === String ? $util$1.Long.prototype.toString.call(k.intValue) : H.longs === Number ? new $util$1.LongBits(k.intValue.low >>> 0, k.intValue.high >>> 0).toNumber() : k.intValue, H.oneofs && (AA.value = "intValue")), AA;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/openmetrics.UnknownValue";
    }, t;
  })(), n.GaugeValue = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.doubleValue = null, t.prototype.intValue = null;
    let g;
    return Object.defineProperty(t.prototype, "value", { get: $util$1.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(g) }), t.create = function(k) {
      return new t(k);
    }, t.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.doubleValue != null && Object.hasOwnProperty.call(k, "doubleValue") && H.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(k.doubleValue), k.intValue != null && Object.hasOwnProperty.call(k, "intValue") && H.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(k.intValue), H;
    }, t.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, t.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.openmetrics.GaugeValue();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.doubleValue = k.double();
            break;
          }
          case 2: {
            IA.intValue = k.int64();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, t.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, t.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      let H = {};
      if (k.doubleValue != null && k.hasOwnProperty("doubleValue") && (H.value = 1, typeof k.doubleValue != "number"))
        return "doubleValue: number expected";
      if (k.intValue != null && k.hasOwnProperty("intValue")) {
        if (H.value === 1) return "value: multiple values";
        if (H.value = 1, !$util$1.isInteger(k.intValue) && !(k.intValue && $util$1.isInteger(k.intValue.low) && $util$1.isInteger(k.intValue.high))) return "intValue: integer|Long expected";
      }
      return null;
    }, t.fromObject = function(k) {
      if (k instanceof $root$1.openmetrics.GaugeValue) return k;
      let H = new $root$1.openmetrics.GaugeValue();
      return k.doubleValue != null && (H.doubleValue = Number(k.doubleValue)), k.intValue != null && ($util$1.Long ? (H.intValue = $util$1.Long.fromValue(k.intValue)).unsigned = !1 : typeof k.intValue == "string" ? H.intValue = parseInt(k.intValue, 10) : typeof k.intValue == "number" ? H.intValue = k.intValue : typeof k.intValue == "object" && (H.intValue = new $util$1.LongBits(k.intValue.low >>> 0, k.intValue.high >>> 0).toNumber())), H;
    }, t.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return k.doubleValue != null && k.hasOwnProperty("doubleValue") && (AA.doubleValue = H.json && !isFinite(k.doubleValue) ? String(k.doubleValue) : k.doubleValue, H.oneofs && (AA.value = "doubleValue")), k.intValue != null && k.hasOwnProperty("intValue") && (typeof k.intValue == "number" ? AA.intValue = H.longs === String ? String(k.intValue) : k.intValue : AA.intValue = H.longs === String ? $util$1.Long.prototype.toString.call(k.intValue) : H.longs === Number ? new $util$1.LongBits(k.intValue.low >>> 0, k.intValue.high >>> 0).toNumber() : k.intValue, H.oneofs && (AA.value = "intValue")), AA;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/openmetrics.GaugeValue";
    }, t;
  })(), n.CounterValue = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.doubleValue = null, t.prototype.intValue = null, t.prototype.created = null, t.prototype.exemplar = null;
    let g;
    return Object.defineProperty(t.prototype, "total", { get: $util$1.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(g) }), t.create = function(k) {
      return new t(k);
    }, t.encode = function(k, H) {
      return H || (H = $Writer$1.create()), k.doubleValue != null && Object.hasOwnProperty.call(k, "doubleValue") && H.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(k.doubleValue), k.intValue != null && Object.hasOwnProperty.call(k, "intValue") && H.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(k.intValue), k.created != null && Object.hasOwnProperty.call(k, "created") && $root$1.google.protobuf.Timestamp.encode(k.created, H.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), k.exemplar != null && Object.hasOwnProperty.call(k, "exemplar") && $root$1.openmetrics.Exemplar.encode(k.exemplar, H.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), H;
    }, t.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, t.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.openmetrics.CounterValue();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.doubleValue = k.double();
            break;
          }
          case 2: {
            IA.intValue = k.uint64();
            break;
          }
          case 3: {
            IA.created = $root$1.google.protobuf.Timestamp.decode(k, k.uint32());
            break;
          }
          case 4: {
            IA.exemplar = $root$1.openmetrics.Exemplar.decode(k, k.uint32());
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, t.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, t.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      let H = {};
      if (k.doubleValue != null && k.hasOwnProperty("doubleValue") && (H.total = 1, typeof k.doubleValue != "number"))
        return "doubleValue: number expected";
      if (k.intValue != null && k.hasOwnProperty("intValue")) {
        if (H.total === 1) return "total: multiple values";
        if (H.total = 1, !$util$1.isInteger(k.intValue) && !(k.intValue && $util$1.isInteger(k.intValue.low) && $util$1.isInteger(k.intValue.high))) return "intValue: integer|Long expected";
      }
      if (k.created != null && k.hasOwnProperty("created")) {
        let AA = $root$1.google.protobuf.Timestamp.verify(k.created);
        if (AA) return "created." + AA;
      }
      if (k.exemplar != null && k.hasOwnProperty("exemplar")) {
        let AA = $root$1.openmetrics.Exemplar.verify(k.exemplar);
        if (AA) return "exemplar." + AA;
      }
      return null;
    }, t.fromObject = function(k) {
      if (k instanceof $root$1.openmetrics.CounterValue) return k;
      let H = new $root$1.openmetrics.CounterValue();
      if (k.doubleValue != null && (H.doubleValue = Number(k.doubleValue)), k.intValue != null && ($util$1.Long ? (H.intValue = $util$1.Long.fromValue(k.intValue)).unsigned = !0 : typeof k.intValue == "string" ? H.intValue = parseInt(k.intValue, 10) : typeof k.intValue == "number" ? H.intValue = k.intValue : typeof k.intValue == "object" && (H.intValue = new $util$1.LongBits(k.intValue.low >>> 0, k.intValue.high >>> 0).toNumber(!0))), k.created != null) {
        if (typeof k.created != "object") throw TypeError(".openmetrics.CounterValue.created: object expected");
        H.created = $root$1.google.protobuf.Timestamp.fromObject(k.created);
      }
      if (k.exemplar != null) {
        if (typeof k.exemplar != "object") throw TypeError(".openmetrics.CounterValue.exemplar: object expected");
        H.exemplar = $root$1.openmetrics.Exemplar.fromObject(k.exemplar);
      }
      return H;
    }, t.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.created = null, AA.exemplar = null), k.doubleValue != null && k.hasOwnProperty("doubleValue") && (AA.doubleValue = H.json && !isFinite(k.doubleValue) ? String(k.doubleValue) : k.doubleValue, H.oneofs && (AA.total = "doubleValue")), k.intValue != null && k.hasOwnProperty("intValue") && (typeof k.intValue == "number" ? AA.intValue = H.longs === String ? String(k.intValue) : k.intValue : AA.intValue = H.longs === String ? $util$1.Long.prototype.toString.call(k.intValue) : H.longs === Number ? new $util$1.LongBits(k.intValue.low >>> 0, k.intValue.high >>> 0).toNumber(!0) : k.intValue, H.oneofs && (AA.total = "intValue")), k.created != null && k.hasOwnProperty("created") && (AA.created = $root$1.google.protobuf.Timestamp.toObject(k.created, H)), k.exemplar != null && k.hasOwnProperty("exemplar") && (AA.exemplar = $root$1.openmetrics.Exemplar.toObject(k.exemplar, H)), AA;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/openmetrics.CounterValue";
    }, t;
  })(), n.HistogramValue = (function() {
    function t(d) {
      if (this.buckets = [], d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.doubleValue = null, t.prototype.intValue = null, t.prototype.count = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, t.prototype.created = null, t.prototype.buckets = $util$1.emptyArray;
    let g;
    return Object.defineProperty(t.prototype, "sum", { get: $util$1.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(g) }), t.create = function(k) {
      return new t(k);
    }, t.encode = function(k, H) {
      if (H || (H = $Writer$1.create()), k.doubleValue != null && Object.hasOwnProperty.call(k, "doubleValue") && H.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(k.doubleValue), k.intValue != null && Object.hasOwnProperty.call(k, "intValue") && H.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(k.intValue), k.count != null && Object.hasOwnProperty.call(k, "count") && H.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(k.count), k.created != null && Object.hasOwnProperty.call(k, "created") && $root$1.google.protobuf.Timestamp.encode(k.created, H.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), k.buckets != null && k.buckets.length) for (let AA = 0; AA < k.buckets.length; ++AA) $root$1.openmetrics.HistogramValue.Bucket.encode(k.buckets[AA], H.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return H;
    }, t.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, t.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.openmetrics.HistogramValue();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.doubleValue = k.double();
            break;
          }
          case 2: {
            IA.intValue = k.int64();
            break;
          }
          case 3: {
            IA.count = k.uint64();
            break;
          }
          case 4: {
            IA.created = $root$1.google.protobuf.Timestamp.decode(k, k.uint32());
            break;
          }
          case 5: {
            IA.buckets && IA.buckets.length || (IA.buckets = []), IA.buckets.push($root$1.openmetrics.HistogramValue.Bucket.decode(k, k.uint32()));
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, t.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, t.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      let H = {};
      if (k.doubleValue != null && k.hasOwnProperty("doubleValue") && (H.sum = 1, typeof k.doubleValue != "number"))
        return "doubleValue: number expected";
      if (k.intValue != null && k.hasOwnProperty("intValue")) {
        if (H.sum === 1) return "sum: multiple values";
        if (H.sum = 1, !$util$1.isInteger(k.intValue) && !(k.intValue && $util$1.isInteger(k.intValue.low) && $util$1.isInteger(k.intValue.high))) return "intValue: integer|Long expected";
      }
      if (k.count != null && k.hasOwnProperty("count") && !$util$1.isInteger(k.count) && !(k.count && $util$1.isInteger(k.count.low) && $util$1.isInteger(k.count.high))) return "count: integer|Long expected";
      if (k.created != null && k.hasOwnProperty("created")) {
        let AA = $root$1.google.protobuf.Timestamp.verify(k.created);
        if (AA) return "created." + AA;
      }
      if (k.buckets != null && k.hasOwnProperty("buckets")) {
        if (!Array.isArray(k.buckets)) return "buckets: array expected";
        for (let AA = 0; AA < k.buckets.length; ++AA) {
          let gA = $root$1.openmetrics.HistogramValue.Bucket.verify(k.buckets[AA]);
          if (gA) return "buckets." + gA;
        }
      }
      return null;
    }, t.fromObject = function(k) {
      if (k instanceof $root$1.openmetrics.HistogramValue) return k;
      let H = new $root$1.openmetrics.HistogramValue();
      if (k.doubleValue != null && (H.doubleValue = Number(k.doubleValue)), k.intValue != null && ($util$1.Long ? (H.intValue = $util$1.Long.fromValue(k.intValue)).unsigned = !1 : typeof k.intValue == "string" ? H.intValue = parseInt(k.intValue, 10) : typeof k.intValue == "number" ? H.intValue = k.intValue : typeof k.intValue == "object" && (H.intValue = new $util$1.LongBits(k.intValue.low >>> 0, k.intValue.high >>> 0).toNumber())), k.count != null && ($util$1.Long ? (H.count = $util$1.Long.fromValue(k.count)).unsigned = !0 : typeof k.count == "string" ? H.count = parseInt(k.count, 10) : typeof k.count == "number" ? H.count = k.count : typeof k.count == "object" && (H.count = new $util$1.LongBits(k.count.low >>> 0, k.count.high >>> 0).toNumber(!0))), k.created != null) {
        if (typeof k.created != "object") throw TypeError(".openmetrics.HistogramValue.created: object expected");
        H.created = $root$1.google.protobuf.Timestamp.fromObject(k.created);
      }
      if (k.buckets) {
        if (!Array.isArray(k.buckets)) throw TypeError(".openmetrics.HistogramValue.buckets: array expected");
        H.buckets = [];
        for (let AA = 0; AA < k.buckets.length; ++AA) {
          if (typeof k.buckets[AA] != "object") throw TypeError(".openmetrics.HistogramValue.buckets: object expected");
          H.buckets[AA] = $root$1.openmetrics.HistogramValue.Bucket.fromObject(k.buckets[AA]);
        }
      }
      return H;
    }, t.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      if ((H.arrays || H.defaults) && (AA.buckets = []), H.defaults) {
        if ($util$1.Long) {
          let gA = new $util$1.Long(0, 0, !0);
          AA.count = H.longs === String ? gA.toString() : H.longs === Number ? gA.toNumber() : gA;
        } else AA.count = H.longs === String ? "0" : 0;
        AA.created = null;
      }
      if (k.doubleValue != null && k.hasOwnProperty("doubleValue") && (AA.doubleValue = H.json && !isFinite(k.doubleValue) ? String(k.doubleValue) : k.doubleValue, H.oneofs && (AA.sum = "doubleValue")), k.intValue != null && k.hasOwnProperty("intValue") && (typeof k.intValue == "number" ? AA.intValue = H.longs === String ? String(k.intValue) : k.intValue : AA.intValue = H.longs === String ? $util$1.Long.prototype.toString.call(k.intValue) : H.longs === Number ? new $util$1.LongBits(k.intValue.low >>> 0, k.intValue.high >>> 0).toNumber() : k.intValue, H.oneofs && (AA.sum = "intValue")), k.count != null && k.hasOwnProperty("count") && (typeof k.count == "number" ? AA.count = H.longs === String ? String(k.count) : k.count : AA.count = H.longs === String ? $util$1.Long.prototype.toString.call(k.count) : H.longs === Number ? new $util$1.LongBits(k.count.low >>> 0, k.count.high >>> 0).toNumber(!0) : k.count), k.created != null && k.hasOwnProperty("created") && (AA.created = $root$1.google.protobuf.Timestamp.toObject(k.created, H)), k.buckets && k.buckets.length) {
        AA.buckets = [];
        for (let gA = 0; gA < k.buckets.length; ++gA) AA.buckets[gA] = $root$1.openmetrics.HistogramValue.Bucket.toObject(k.buckets[gA], H);
      }
      return AA;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/openmetrics.HistogramValue";
    }, t.Bucket = (function() {
      function d(k) {
        if (k) for (let H = Object.keys(k), AA = 0; AA < H.length; ++AA) k[H[AA]] != null && (this[H[AA]] = k[H[AA]]);
      }
      return d.prototype.count = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, d.prototype.upperBound = 0, d.prototype.exemplar = null, d.create = function(H) {
        return new d(H);
      }, d.encode = function(H, AA) {
        return AA || (AA = $Writer$1.create()), H.count != null && Object.hasOwnProperty.call(H, "count") && AA.uint32(
          /* id 1, wireType 0 =*/
          8
        ).uint64(H.count), H.upperBound != null && Object.hasOwnProperty.call(H, "upperBound") && AA.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(H.upperBound), H.exemplar != null && Object.hasOwnProperty.call(H, "exemplar") && $root$1.openmetrics.Exemplar.encode(H.exemplar, AA.uint32(
          /* id 3, wireType 2 =*/
          26
        ).fork()).ldelim(), AA;
      }, d.encodeDelimited = function(H, AA) {
        return this.encode(H, AA).ldelim();
      }, d.decode = function(H, AA, gA) {
        H instanceof $Reader$1 || (H = $Reader$1.create(H));
        let IA = AA === void 0 ? H.len : H.pos + AA, CA = new $root$1.openmetrics.HistogramValue.Bucket();
        for (; H.pos < IA; ) {
          let BA = H.uint32();
          if (BA === gA) break;
          switch (BA >>> 3) {
            case 1: {
              CA.count = H.uint64();
              break;
            }
            case 2: {
              CA.upperBound = H.double();
              break;
            }
            case 3: {
              CA.exemplar = $root$1.openmetrics.Exemplar.decode(H, H.uint32());
              break;
            }
            default:
              H.skipType(BA & 7);
              break;
          }
        }
        return CA;
      }, d.decodeDelimited = function(H) {
        return H instanceof $Reader$1 || (H = new $Reader$1(H)), this.decode(H, H.uint32());
      }, d.verify = function(H) {
        if (typeof H != "object" || H === null) return "object expected";
        if (H.count != null && H.hasOwnProperty("count") && !$util$1.isInteger(H.count) && !(H.count && $util$1.isInteger(H.count.low) && $util$1.isInteger(H.count.high))) return "count: integer|Long expected";
        if (H.upperBound != null && H.hasOwnProperty("upperBound") && typeof H.upperBound != "number") return "upperBound: number expected";
        if (H.exemplar != null && H.hasOwnProperty("exemplar")) {
          let AA = $root$1.openmetrics.Exemplar.verify(H.exemplar);
          if (AA) return "exemplar." + AA;
        }
        return null;
      }, d.fromObject = function(H) {
        if (H instanceof $root$1.openmetrics.HistogramValue.Bucket) return H;
        let AA = new $root$1.openmetrics.HistogramValue.Bucket();
        if (H.count != null && ($util$1.Long ? (AA.count = $util$1.Long.fromValue(H.count)).unsigned = !0 : typeof H.count == "string" ? AA.count = parseInt(H.count, 10) : typeof H.count == "number" ? AA.count = H.count : typeof H.count == "object" && (AA.count = new $util$1.LongBits(H.count.low >>> 0, H.count.high >>> 0).toNumber(!0))), H.upperBound != null && (AA.upperBound = Number(H.upperBound)), H.exemplar != null) {
          if (typeof H.exemplar != "object") throw TypeError(".openmetrics.HistogramValue.Bucket.exemplar: object expected");
          AA.exemplar = $root$1.openmetrics.Exemplar.fromObject(H.exemplar);
        }
        return AA;
      }, d.toObject = function(H, AA) {
        AA || (AA = {});
        let gA = {};
        if (AA.defaults) {
          if ($util$1.Long) {
            let IA = new $util$1.Long(0, 0, !0);
            gA.count = AA.longs === String ? IA.toString() : AA.longs === Number ? IA.toNumber() : IA;
          } else gA.count = AA.longs === String ? "0" : 0;
          gA.upperBound = 0, gA.exemplar = null;
        }
        return H.count != null && H.hasOwnProperty("count") && (typeof H.count == "number" ? gA.count = AA.longs === String ? String(H.count) : H.count : gA.count = AA.longs === String ? $util$1.Long.prototype.toString.call(H.count) : AA.longs === Number ? new $util$1.LongBits(H.count.low >>> 0, H.count.high >>> 0).toNumber(!0) : H.count), H.upperBound != null && H.hasOwnProperty("upperBound") && (gA.upperBound = AA.json && !isFinite(H.upperBound) ? String(H.upperBound) : H.upperBound), H.exemplar != null && H.hasOwnProperty("exemplar") && (gA.exemplar = $root$1.openmetrics.Exemplar.toObject(H.exemplar, AA)), gA;
      }, d.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
      }, d.getTypeUrl = function(H) {
        return H === void 0 && (H = "type.googleapis.com"), H + "/openmetrics.HistogramValue.Bucket";
      }, d;
    })(), t;
  })(), n.Exemplar = (function() {
    function t(g) {
      if (this.label = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.value = 0, t.prototype.timestamp = null, t.prototype.label = $util$1.emptyArray, t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      if (k || (k = $Writer$1.create()), d.value != null && Object.hasOwnProperty.call(d, "value") && k.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(d.value), d.timestamp != null && Object.hasOwnProperty.call(d, "timestamp") && $root$1.google.protobuf.Timestamp.encode(d.timestamp, k.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), d.label != null && d.label.length) for (let H = 0; H < d.label.length; ++H) $root$1.openmetrics.Label.encode(d.label[H], k.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim();
      return k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader$1 || (d = $Reader$1.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.openmetrics.Exemplar();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.value = d.double();
            break;
          }
          case 2: {
            gA.timestamp = $root$1.google.protobuf.Timestamp.decode(d, d.uint32());
            break;
          }
          case 3: {
            gA.label && gA.label.length || (gA.label = []), gA.label.push($root$1.openmetrics.Label.decode(d, d.uint32()));
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      if (d.value != null && d.hasOwnProperty("value") && typeof d.value != "number") return "value: number expected";
      if (d.timestamp != null && d.hasOwnProperty("timestamp")) {
        let k = $root$1.google.protobuf.Timestamp.verify(d.timestamp);
        if (k) return "timestamp." + k;
      }
      if (d.label != null && d.hasOwnProperty("label")) {
        if (!Array.isArray(d.label)) return "label: array expected";
        for (let k = 0; k < d.label.length; ++k) {
          let H = $root$1.openmetrics.Label.verify(d.label[k]);
          if (H) return "label." + H;
        }
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root$1.openmetrics.Exemplar) return d;
      let k = new $root$1.openmetrics.Exemplar();
      if (d.value != null && (k.value = Number(d.value)), d.timestamp != null) {
        if (typeof d.timestamp != "object") throw TypeError(".openmetrics.Exemplar.timestamp: object expected");
        k.timestamp = $root$1.google.protobuf.Timestamp.fromObject(d.timestamp);
      }
      if (d.label) {
        if (!Array.isArray(d.label)) throw TypeError(".openmetrics.Exemplar.label: array expected");
        k.label = [];
        for (let H = 0; H < d.label.length; ++H) {
          if (typeof d.label[H] != "object") throw TypeError(".openmetrics.Exemplar.label: object expected");
          k.label[H] = $root$1.openmetrics.Label.fromObject(d.label[H]);
        }
      }
      return k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      if ((k.arrays || k.defaults) && (H.label = []), k.defaults && (H.value = 0, H.timestamp = null), d.value != null && d.hasOwnProperty("value") && (H.value = k.json && !isFinite(d.value) ? String(d.value) : d.value), d.timestamp != null && d.hasOwnProperty("timestamp") && (H.timestamp = $root$1.google.protobuf.Timestamp.toObject(d.timestamp, k)), d.label && d.label.length) {
        H.label = [];
        for (let AA = 0; AA < d.label.length; ++AA) H.label[AA] = $root$1.openmetrics.Label.toObject(d.label[AA], k);
      }
      return H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.Exemplar";
    }, t;
  })(), n.StateSetValue = (function() {
    function t(g) {
      if (this.states = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.states = $util$1.emptyArray, t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      if (k || (k = $Writer$1.create()), d.states != null && d.states.length) for (let H = 0; H < d.states.length; ++H) $root$1.openmetrics.StateSetValue.State.encode(d.states[H], k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader$1 || (d = $Reader$1.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.openmetrics.StateSetValue();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.states && gA.states.length || (gA.states = []), gA.states.push($root$1.openmetrics.StateSetValue.State.decode(d, d.uint32()));
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      if (d.states != null && d.hasOwnProperty("states")) {
        if (!Array.isArray(d.states)) return "states: array expected";
        for (let k = 0; k < d.states.length; ++k) {
          let H = $root$1.openmetrics.StateSetValue.State.verify(d.states[k]);
          if (H) return "states." + H;
        }
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root$1.openmetrics.StateSetValue) return d;
      let k = new $root$1.openmetrics.StateSetValue();
      if (d.states) {
        if (!Array.isArray(d.states)) throw TypeError(".openmetrics.StateSetValue.states: array expected");
        k.states = [];
        for (let H = 0; H < d.states.length; ++H) {
          if (typeof d.states[H] != "object") throw TypeError(".openmetrics.StateSetValue.states: object expected");
          k.states[H] = $root$1.openmetrics.StateSetValue.State.fromObject(d.states[H]);
        }
      }
      return k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      if ((k.arrays || k.defaults) && (H.states = []), d.states && d.states.length) {
        H.states = [];
        for (let AA = 0; AA < d.states.length; ++AA) H.states[AA] = $root$1.openmetrics.StateSetValue.State.toObject(d.states[AA], k);
      }
      return H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.StateSetValue";
    }, t.State = (function() {
      function g(d) {
        if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
      }
      return g.prototype.enabled = !1, g.prototype.name = "", g.create = function(k) {
        return new g(k);
      }, g.encode = function(k, H) {
        return H || (H = $Writer$1.create()), k.enabled != null && Object.hasOwnProperty.call(k, "enabled") && H.uint32(
          /* id 1, wireType 0 =*/
          8
        ).bool(k.enabled), k.name != null && Object.hasOwnProperty.call(k, "name") && H.uint32(
          /* id 2, wireType 2 =*/
          18
        ).string(k.name), H;
      }, g.encodeDelimited = function(k, H) {
        return this.encode(k, H).ldelim();
      }, g.decode = function(k, H, AA) {
        k instanceof $Reader$1 || (k = $Reader$1.create(k));
        let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.openmetrics.StateSetValue.State();
        for (; k.pos < gA; ) {
          let CA = k.uint32();
          if (CA === AA) break;
          switch (CA >>> 3) {
            case 1: {
              IA.enabled = k.bool();
              break;
            }
            case 2: {
              IA.name = k.string();
              break;
            }
            default:
              k.skipType(CA & 7);
              break;
          }
        }
        return IA;
      }, g.decodeDelimited = function(k) {
        return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
      }, g.verify = function(k) {
        return typeof k != "object" || k === null ? "object expected" : k.enabled != null && k.hasOwnProperty("enabled") && typeof k.enabled != "boolean" ? "enabled: boolean expected" : k.name != null && k.hasOwnProperty("name") && !$util$1.isString(k.name) ? "name: string expected" : null;
      }, g.fromObject = function(k) {
        if (k instanceof $root$1.openmetrics.StateSetValue.State) return k;
        let H = new $root$1.openmetrics.StateSetValue.State();
        return k.enabled != null && (H.enabled = !!k.enabled), k.name != null && (H.name = String(k.name)), H;
      }, g.toObject = function(k, H) {
        H || (H = {});
        let AA = {};
        return H.defaults && (AA.enabled = !1, AA.name = ""), k.enabled != null && k.hasOwnProperty("enabled") && (AA.enabled = k.enabled), k.name != null && k.hasOwnProperty("name") && (AA.name = k.name), AA;
      }, g.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
      }, g.getTypeUrl = function(k) {
        return k === void 0 && (k = "type.googleapis.com"), k + "/openmetrics.StateSetValue.State";
      }, g;
    })(), t;
  })(), n.InfoValue = (function() {
    function t(g) {
      if (this.info = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.info = $util$1.emptyArray, t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      if (k || (k = $Writer$1.create()), d.info != null && d.info.length) for (let H = 0; H < d.info.length; ++H) $root$1.openmetrics.Label.encode(d.info[H], k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader$1 || (d = $Reader$1.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root$1.openmetrics.InfoValue();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.info && gA.info.length || (gA.info = []), gA.info.push($root$1.openmetrics.Label.decode(d, d.uint32()));
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader$1 || (d = new $Reader$1(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      if (d.info != null && d.hasOwnProperty("info")) {
        if (!Array.isArray(d.info)) return "info: array expected";
        for (let k = 0; k < d.info.length; ++k) {
          let H = $root$1.openmetrics.Label.verify(d.info[k]);
          if (H) return "info." + H;
        }
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root$1.openmetrics.InfoValue) return d;
      let k = new $root$1.openmetrics.InfoValue();
      if (d.info) {
        if (!Array.isArray(d.info)) throw TypeError(".openmetrics.InfoValue.info: array expected");
        k.info = [];
        for (let H = 0; H < d.info.length; ++H) {
          if (typeof d.info[H] != "object") throw TypeError(".openmetrics.InfoValue.info: object expected");
          k.info[H] = $root$1.openmetrics.Label.fromObject(d.info[H]);
        }
      }
      return k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      if ((k.arrays || k.defaults) && (H.info = []), d.info && d.info.length) {
        H.info = [];
        for (let AA = 0; AA < d.info.length; ++AA) H.info[AA] = $root$1.openmetrics.Label.toObject(d.info[AA], k);
      }
      return H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.InfoValue";
    }, t;
  })(), n.SummaryValue = (function() {
    function t(d) {
      if (this.quantile = [], d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.doubleValue = null, t.prototype.intValue = null, t.prototype.count = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, t.prototype.created = null, t.prototype.quantile = $util$1.emptyArray;
    let g;
    return Object.defineProperty(t.prototype, "sum", { get: $util$1.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(g) }), t.create = function(k) {
      return new t(k);
    }, t.encode = function(k, H) {
      if (H || (H = $Writer$1.create()), k.doubleValue != null && Object.hasOwnProperty.call(k, "doubleValue") && H.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(k.doubleValue), k.intValue != null && Object.hasOwnProperty.call(k, "intValue") && H.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(k.intValue), k.count != null && Object.hasOwnProperty.call(k, "count") && H.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(k.count), k.created != null && Object.hasOwnProperty.call(k, "created") && $root$1.google.protobuf.Timestamp.encode(k.created, H.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), k.quantile != null && k.quantile.length) for (let AA = 0; AA < k.quantile.length; ++AA) $root$1.openmetrics.SummaryValue.Quantile.encode(k.quantile[AA], H.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return H;
    }, t.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, t.decode = function(k, H, AA) {
      k instanceof $Reader$1 || (k = $Reader$1.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.openmetrics.SummaryValue();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.doubleValue = k.double();
            break;
          }
          case 2: {
            IA.intValue = k.int64();
            break;
          }
          case 3: {
            IA.count = k.uint64();
            break;
          }
          case 4: {
            IA.created = $root$1.google.protobuf.Timestamp.decode(k, k.uint32());
            break;
          }
          case 5: {
            IA.quantile && IA.quantile.length || (IA.quantile = []), IA.quantile.push($root$1.openmetrics.SummaryValue.Quantile.decode(k, k.uint32()));
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, t.decodeDelimited = function(k) {
      return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
    }, t.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      let H = {};
      if (k.doubleValue != null && k.hasOwnProperty("doubleValue") && (H.sum = 1, typeof k.doubleValue != "number"))
        return "doubleValue: number expected";
      if (k.intValue != null && k.hasOwnProperty("intValue")) {
        if (H.sum === 1) return "sum: multiple values";
        if (H.sum = 1, !$util$1.isInteger(k.intValue) && !(k.intValue && $util$1.isInteger(k.intValue.low) && $util$1.isInteger(k.intValue.high))) return "intValue: integer|Long expected";
      }
      if (k.count != null && k.hasOwnProperty("count") && !$util$1.isInteger(k.count) && !(k.count && $util$1.isInteger(k.count.low) && $util$1.isInteger(k.count.high))) return "count: integer|Long expected";
      if (k.created != null && k.hasOwnProperty("created")) {
        let AA = $root$1.google.protobuf.Timestamp.verify(k.created);
        if (AA) return "created." + AA;
      }
      if (k.quantile != null && k.hasOwnProperty("quantile")) {
        if (!Array.isArray(k.quantile)) return "quantile: array expected";
        for (let AA = 0; AA < k.quantile.length; ++AA) {
          let gA = $root$1.openmetrics.SummaryValue.Quantile.verify(k.quantile[AA]);
          if (gA) return "quantile." + gA;
        }
      }
      return null;
    }, t.fromObject = function(k) {
      if (k instanceof $root$1.openmetrics.SummaryValue) return k;
      let H = new $root$1.openmetrics.SummaryValue();
      if (k.doubleValue != null && (H.doubleValue = Number(k.doubleValue)), k.intValue != null && ($util$1.Long ? (H.intValue = $util$1.Long.fromValue(k.intValue)).unsigned = !1 : typeof k.intValue == "string" ? H.intValue = parseInt(k.intValue, 10) : typeof k.intValue == "number" ? H.intValue = k.intValue : typeof k.intValue == "object" && (H.intValue = new $util$1.LongBits(k.intValue.low >>> 0, k.intValue.high >>> 0).toNumber())), k.count != null && ($util$1.Long ? (H.count = $util$1.Long.fromValue(k.count)).unsigned = !0 : typeof k.count == "string" ? H.count = parseInt(k.count, 10) : typeof k.count == "number" ? H.count = k.count : typeof k.count == "object" && (H.count = new $util$1.LongBits(k.count.low >>> 0, k.count.high >>> 0).toNumber(!0))), k.created != null) {
        if (typeof k.created != "object") throw TypeError(".openmetrics.SummaryValue.created: object expected");
        H.created = $root$1.google.protobuf.Timestamp.fromObject(k.created);
      }
      if (k.quantile) {
        if (!Array.isArray(k.quantile)) throw TypeError(".openmetrics.SummaryValue.quantile: array expected");
        H.quantile = [];
        for (let AA = 0; AA < k.quantile.length; ++AA) {
          if (typeof k.quantile[AA] != "object") throw TypeError(".openmetrics.SummaryValue.quantile: object expected");
          H.quantile[AA] = $root$1.openmetrics.SummaryValue.Quantile.fromObject(k.quantile[AA]);
        }
      }
      return H;
    }, t.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      if ((H.arrays || H.defaults) && (AA.quantile = []), H.defaults) {
        if ($util$1.Long) {
          let gA = new $util$1.Long(0, 0, !0);
          AA.count = H.longs === String ? gA.toString() : H.longs === Number ? gA.toNumber() : gA;
        } else AA.count = H.longs === String ? "0" : 0;
        AA.created = null;
      }
      if (k.doubleValue != null && k.hasOwnProperty("doubleValue") && (AA.doubleValue = H.json && !isFinite(k.doubleValue) ? String(k.doubleValue) : k.doubleValue, H.oneofs && (AA.sum = "doubleValue")), k.intValue != null && k.hasOwnProperty("intValue") && (typeof k.intValue == "number" ? AA.intValue = H.longs === String ? String(k.intValue) : k.intValue : AA.intValue = H.longs === String ? $util$1.Long.prototype.toString.call(k.intValue) : H.longs === Number ? new $util$1.LongBits(k.intValue.low >>> 0, k.intValue.high >>> 0).toNumber() : k.intValue, H.oneofs && (AA.sum = "intValue")), k.count != null && k.hasOwnProperty("count") && (typeof k.count == "number" ? AA.count = H.longs === String ? String(k.count) : k.count : AA.count = H.longs === String ? $util$1.Long.prototype.toString.call(k.count) : H.longs === Number ? new $util$1.LongBits(k.count.low >>> 0, k.count.high >>> 0).toNumber(!0) : k.count), k.created != null && k.hasOwnProperty("created") && (AA.created = $root$1.google.protobuf.Timestamp.toObject(k.created, H)), k.quantile && k.quantile.length) {
        AA.quantile = [];
        for (let gA = 0; gA < k.quantile.length; ++gA) AA.quantile[gA] = $root$1.openmetrics.SummaryValue.Quantile.toObject(k.quantile[gA], H);
      }
      return AA;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
    }, t.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/openmetrics.SummaryValue";
    }, t.Quantile = (function() {
      function d(k) {
        if (k) for (let H = Object.keys(k), AA = 0; AA < H.length; ++AA) k[H[AA]] != null && (this[H[AA]] = k[H[AA]]);
      }
      return d.prototype.quantile = 0, d.prototype.value = 0, d.create = function(H) {
        return new d(H);
      }, d.encode = function(H, AA) {
        return AA || (AA = $Writer$1.create()), H.quantile != null && Object.hasOwnProperty.call(H, "quantile") && AA.uint32(
          /* id 1, wireType 1 =*/
          9
        ).double(H.quantile), H.value != null && Object.hasOwnProperty.call(H, "value") && AA.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(H.value), AA;
      }, d.encodeDelimited = function(H, AA) {
        return this.encode(H, AA).ldelim();
      }, d.decode = function(H, AA, gA) {
        H instanceof $Reader$1 || (H = $Reader$1.create(H));
        let IA = AA === void 0 ? H.len : H.pos + AA, CA = new $root$1.openmetrics.SummaryValue.Quantile();
        for (; H.pos < IA; ) {
          let BA = H.uint32();
          if (BA === gA) break;
          switch (BA >>> 3) {
            case 1: {
              CA.quantile = H.double();
              break;
            }
            case 2: {
              CA.value = H.double();
              break;
            }
            default:
              H.skipType(BA & 7);
              break;
          }
        }
        return CA;
      }, d.decodeDelimited = function(H) {
        return H instanceof $Reader$1 || (H = new $Reader$1(H)), this.decode(H, H.uint32());
      }, d.verify = function(H) {
        return typeof H != "object" || H === null ? "object expected" : H.quantile != null && H.hasOwnProperty("quantile") && typeof H.quantile != "number" ? "quantile: number expected" : H.value != null && H.hasOwnProperty("value") && typeof H.value != "number" ? "value: number expected" : null;
      }, d.fromObject = function(H) {
        if (H instanceof $root$1.openmetrics.SummaryValue.Quantile) return H;
        let AA = new $root$1.openmetrics.SummaryValue.Quantile();
        return H.quantile != null && (AA.quantile = Number(H.quantile)), H.value != null && (AA.value = Number(H.value)), AA;
      }, d.toObject = function(H, AA) {
        AA || (AA = {});
        let gA = {};
        return AA.defaults && (gA.quantile = 0, gA.value = 0), H.quantile != null && H.hasOwnProperty("quantile") && (gA.quantile = AA.json && !isFinite(H.quantile) ? String(H.quantile) : H.quantile), H.value != null && H.hasOwnProperty("value") && (gA.value = AA.json && !isFinite(H.value) ? String(H.value) : H.value), gA;
      }, d.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
      }, d.getTypeUrl = function(H) {
        return H === void 0 && (H = "type.googleapis.com"), H + "/openmetrics.SummaryValue.Quantile";
      }, d;
    })(), t;
  })(), n;
})();
$root$1.google = (() => {
  const n = {};
  return n.protobuf = (function() {
    const t = {};
    return t.Timestamp = (function() {
      function g(d) {
        if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
      }
      return g.prototype.seconds = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, g.prototype.nanos = 0, g.create = function(k) {
        return new g(k);
      }, g.encode = function(k, H) {
        return H || (H = $Writer$1.create()), k.seconds != null && Object.hasOwnProperty.call(k, "seconds") && H.uint32(
          /* id 1, wireType 0 =*/
          8
        ).int64(k.seconds), k.nanos != null && Object.hasOwnProperty.call(k, "nanos") && H.uint32(
          /* id 2, wireType 0 =*/
          16
        ).int32(k.nanos), H;
      }, g.encodeDelimited = function(k, H) {
        return this.encode(k, H).ldelim();
      }, g.decode = function(k, H, AA) {
        k instanceof $Reader$1 || (k = $Reader$1.create(k));
        let gA = H === void 0 ? k.len : k.pos + H, IA = new $root$1.google.protobuf.Timestamp();
        for (; k.pos < gA; ) {
          let CA = k.uint32();
          if (CA === AA) break;
          switch (CA >>> 3) {
            case 1: {
              IA.seconds = k.int64();
              break;
            }
            case 2: {
              IA.nanos = k.int32();
              break;
            }
            default:
              k.skipType(CA & 7);
              break;
          }
        }
        return IA;
      }, g.decodeDelimited = function(k) {
        return k instanceof $Reader$1 || (k = new $Reader$1(k)), this.decode(k, k.uint32());
      }, g.verify = function(k) {
        return typeof k != "object" || k === null ? "object expected" : k.seconds != null && k.hasOwnProperty("seconds") && !$util$1.isInteger(k.seconds) && !(k.seconds && $util$1.isInteger(k.seconds.low) && $util$1.isInteger(k.seconds.high)) ? "seconds: integer|Long expected" : k.nanos != null && k.hasOwnProperty("nanos") && !$util$1.isInteger(k.nanos) ? "nanos: integer expected" : null;
      }, g.fromObject = function(k) {
        if (k instanceof $root$1.google.protobuf.Timestamp) return k;
        let H = new $root$1.google.protobuf.Timestamp();
        return k.seconds != null && ($util$1.Long ? (H.seconds = $util$1.Long.fromValue(k.seconds)).unsigned = !1 : typeof k.seconds == "string" ? H.seconds = parseInt(k.seconds, 10) : typeof k.seconds == "number" ? H.seconds = k.seconds : typeof k.seconds == "object" && (H.seconds = new $util$1.LongBits(k.seconds.low >>> 0, k.seconds.high >>> 0).toNumber())), k.nanos != null && (H.nanos = k.nanos | 0), H;
      }, g.toObject = function(k, H) {
        H || (H = {});
        let AA = {};
        if (H.defaults) {
          if ($util$1.Long) {
            let gA = new $util$1.Long(0, 0, !1);
            AA.seconds = H.longs === String ? gA.toString() : H.longs === Number ? gA.toNumber() : gA;
          } else AA.seconds = H.longs === String ? "0" : 0;
          AA.nanos = 0;
        }
        return k.seconds != null && k.hasOwnProperty("seconds") && (typeof k.seconds == "number" ? AA.seconds = H.longs === String ? String(k.seconds) : k.seconds : AA.seconds = H.longs === String ? $util$1.Long.prototype.toString.call(k.seconds) : H.longs === Number ? new $util$1.LongBits(k.seconds.low >>> 0, k.seconds.high >>> 0).toNumber() : k.seconds), k.nanos != null && k.hasOwnProperty("nanos") && (AA.nanos = k.nanos), AA;
      }, g.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports$1.util.toJSONOptions);
      }, g.getTypeUrl = function(k) {
        return k === void 0 && (k = "type.googleapis.com"), k + "/google.protobuf.Timestamp";
      }, g;
    })(), t;
  })(), n;
})();
$root$1.RootContainer = (() => {
  const n = {}, t = Object.create(n);
  return t[n[0] = "MAIN"] = 0, t[n[1] = "SIDEBAR"] = 1, t[n[2] = "EVENT"] = 2, t[n[3] = "BOTTOM"] = 3, t;
})();
var commonjsGlobal$1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, loglevel$1 = { exports: {} }, loglevel = loglevel$1.exports, hasRequiredLoglevel;
function requireLoglevel() {
  return hasRequiredLoglevel || (hasRequiredLoglevel = 1, (function(n) {
    (function(t, g) {
      n.exports ? n.exports = g() : t.log = g();
    })(loglevel, function() {
      var t = function() {
      }, g = "undefined", d = typeof window !== g && typeof window.navigator !== g && /Trident\/|MSIE /.test(window.navigator.userAgent), k = ["trace", "debug", "info", "warn", "error"], H = {}, AA = null;
      function gA(oA, EA) {
        var aA = oA[EA];
        if (typeof aA.bind == "function") return aA.bind(oA);
        try {
          return Function.prototype.bind.call(aA, oA);
        } catch {
          return function() {
            return Function.prototype.apply.apply(aA, [oA, arguments]);
          };
        }
      }
      function IA() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function CA(oA) {
        return oA === "debug" && (oA = "log"), typeof console === g ? !1 : oA === "trace" && d ? IA : console[oA] !== void 0 ? gA(console, oA) : console.log !== void 0 ? gA(console, "log") : t;
      }
      function BA() {
        for (var oA = this.getLevel(), EA = 0; EA < k.length; EA++) {
          var aA = k[EA];
          this[aA] = EA < oA ? t : this.methodFactory(aA, oA, this.name);
        }
        if (this.log = this.debug, typeof console === g && oA < this.levels.SILENT) return "No console available for logging";
      }
      function eA(oA) {
        return function() {
          typeof console !== g && (BA.call(this), this[oA].apply(this, arguments));
        };
      }
      function iA(oA, EA, aA) {
        return CA(oA) || eA.apply(this, arguments);
      }
      function QA(oA, EA) {
        var aA = this, nA, lA, cA, sA = "loglevel";
        typeof oA == "string" ? sA += ":" + oA : typeof oA == "symbol" && (sA = void 0);
        function rA(DA) {
          var wA = (k[DA] || "silent").toUpperCase();
          if (!(typeof window === g || !sA)) {
            try {
              window.localStorage[sA] = wA;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(sA) + "=" + wA + ";";
            } catch {
            }
          }
        }
        function uA() {
          var DA;
          if (!(typeof window === g || !sA)) {
            try {
              DA = window.localStorage[sA];
            } catch {
            }
            if (typeof DA === g) try {
              var wA = window.document.cookie, bA = encodeURIComponent(sA), yA = wA.indexOf(bA + "=");
              yA !== -1 && (DA = /^([^;]+)/.exec(wA.slice(yA + bA.length + 1))[1]);
            } catch {
            }
            return aA.levels[DA] === void 0 && (DA = void 0), DA;
          }
        }
        function hA() {
          if (!(typeof window === g || !sA)) {
            try {
              window.localStorage.removeItem(sA);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(sA) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function dA(DA) {
          var wA = DA;
          if (typeof wA == "string" && aA.levels[wA.toUpperCase()] !== void 0 && (wA = aA.levels[wA.toUpperCase()]), typeof wA == "number" && wA >= 0 && wA <= aA.levels.SILENT) return wA;
          throw new TypeError("log.setLevel() called with invalid level: " + DA);
        }
        aA.name = oA, aA.levels = { TRACE: 0, DEBUG: 1, INFO: 2, WARN: 3, ERROR: 4, SILENT: 5 }, aA.methodFactory = EA || iA, aA.getLevel = function() {
          return cA ?? lA ?? nA;
        }, aA.setLevel = function(DA, wA) {
          return cA = dA(DA), wA !== !1 && rA(cA), BA.call(aA);
        }, aA.setDefaultLevel = function(DA) {
          lA = dA(DA), uA() || aA.setLevel(DA, !1);
        }, aA.resetLevel = function() {
          cA = null, hA(), BA.call(aA);
        }, aA.enableAll = function(DA) {
          aA.setLevel(aA.levels.TRACE, DA);
        }, aA.disableAll = function(DA) {
          aA.setLevel(aA.levels.SILENT, DA);
        }, aA.rebuild = function() {
          if (AA !== aA && (nA = dA(AA.getLevel())), BA.call(aA), AA === aA) for (var DA in H) H[DA].rebuild();
        }, nA = dA(AA ? AA.getLevel() : "WARN");
        var GA = uA();
        GA != null && (cA = dA(GA)), BA.call(aA);
      }
      AA = new QA(), AA.getLogger = function(oA) {
        if (typeof oA != "symbol" && typeof oA != "string" || oA === "") throw new TypeError("You must supply a name when creating a logger.");
        var EA = H[oA];
        return EA || (EA = H[oA] = new QA(oA, AA.methodFactory)), EA;
      };
      var tA = typeof window !== g ? window.log : void 0;
      return AA.noConflict = function() {
        return typeof window !== g && window.log === AA && (window.log = tA), AA;
      }, AA.getLoggers = function() {
        return H;
      }, AA.default = AA, AA;
    });
  })(loglevel$1)), loglevel$1.exports;
}
var loglevelExports = requireLoglevel(), ConnectionState$1 = /* @__PURE__ */ ((n) => (n.CONNECTED = "CONNECTED", n.DISCONNECTED_FOREVER = "DISCONNECTED_FOREVER", n.INITIAL = "INITIAL", n.PINGING_SERVER = "PINGING_SERVER", n.CONNECTING = "CONNECTING", n.STATIC_CONNECTING = "STATIC_CONNECTING", n.STATIC_CONNECTED = "STATIC_CONNECTED", n))(ConnectionState$1 || {});
process.env.NODE_ENV;
var indexMinimal = {}, minimal$1 = {}, aspromise, hasRequiredAspromise;
function requireAspromise() {
  if (hasRequiredAspromise) return aspromise;
  hasRequiredAspromise = 1, aspromise = n;
  function n(t, g) {
    for (var d = new Array(arguments.length - 1), k = 0, H = 2, AA = !0; H < arguments.length; ) d[k++] = arguments[H++];
    return new Promise(function(gA, IA) {
      d[k] = function(CA) {
        if (AA) if (AA = !1, CA) IA(CA);
        else {
          for (var BA = new Array(arguments.length - 1), eA = 0; eA < BA.length; ) BA[eA++] = arguments[eA];
          gA.apply(null, BA);
        }
      };
      try {
        t.apply(g || null, d);
      } catch (CA) {
        AA && (AA = !1, IA(CA));
      }
    });
  }
  return aspromise;
}
var base64 = {}, hasRequiredBase64;
function requireBase64() {
  return hasRequiredBase64 || (hasRequiredBase64 = 1, (function(n) {
    var t = n;
    t.length = function(AA) {
      var gA = AA.length;
      if (!gA) return 0;
      for (var IA = 0; --gA % 4 > 1 && AA.charAt(gA) === "="; ) ++IA;
      return Math.ceil(AA.length * 3) / 4 - IA;
    };
    for (var g = new Array(64), d = new Array(123), k = 0; k < 64; ) d[g[k] = k < 26 ? k + 65 : k < 52 ? k + 71 : k < 62 ? k - 4 : k - 59 | 43] = k++;
    t.encode = function(AA, gA, IA) {
      for (var CA = null, BA = [], eA = 0, iA = 0, QA; gA < IA; ) {
        var tA = AA[gA++];
        switch (iA) {
          case 0:
            BA[eA++] = g[tA >> 2], QA = (tA & 3) << 4, iA = 1;
            break;
          case 1:
            BA[eA++] = g[QA | tA >> 4], QA = (tA & 15) << 2, iA = 2;
            break;
          case 2:
            BA[eA++] = g[QA | tA >> 6], BA[eA++] = g[tA & 63], iA = 0;
            break;
        }
        eA > 8191 && ((CA || (CA = [])).push(String.fromCharCode.apply(String, BA)), eA = 0);
      }
      return iA && (BA[eA++] = g[QA], BA[eA++] = 61, iA === 1 && (BA[eA++] = 61)), CA ? (eA && CA.push(String.fromCharCode.apply(String, BA.slice(0, eA))), CA.join("")) : String.fromCharCode.apply(String, BA.slice(0, eA));
    };
    var H = "invalid encoding";
    t.decode = function(AA, gA, IA) {
      for (var CA = IA, BA = 0, eA, iA = 0; iA < AA.length; ) {
        var QA = AA.charCodeAt(iA++);
        if (QA === 61 && BA > 1) break;
        if ((QA = d[QA]) === void 0) throw Error(H);
        switch (BA) {
          case 0:
            eA = QA, BA = 1;
            break;
          case 1:
            gA[IA++] = eA << 2 | (QA & 48) >> 4, eA = QA, BA = 2;
            break;
          case 2:
            gA[IA++] = (eA & 15) << 4 | (QA & 60) >> 2, eA = QA, BA = 3;
            break;
          case 3:
            gA[IA++] = (eA & 3) << 6 | QA, BA = 0;
            break;
        }
      }
      if (BA === 1) throw Error(H);
      return IA - CA;
    }, t.test = function(AA) {
      return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(AA);
    };
  })(base64)), base64;
}
var eventemitter, hasRequiredEventemitter;
function requireEventemitter() {
  if (hasRequiredEventemitter) return eventemitter;
  hasRequiredEventemitter = 1, eventemitter = n;
  function n() {
    this._listeners = {};
  }
  return n.prototype.on = function(t, g, d) {
    return (this._listeners[t] || (this._listeners[t] = [])).push({ fn: g, ctx: d || this }), this;
  }, n.prototype.off = function(t, g) {
    if (t === void 0) this._listeners = {};
    else if (g === void 0) this._listeners[t] = [];
    else for (var d = this._listeners[t], k = 0; k < d.length; ) d[k].fn === g ? d.splice(k, 1) : ++k;
    return this;
  }, n.prototype.emit = function(t) {
    var g = this._listeners[t];
    if (g) {
      for (var d = [], k = 1; k < arguments.length; ) d.push(arguments[k++]);
      for (k = 0; k < g.length; ) g[k].fn.apply(g[k++].ctx, d);
    }
    return this;
  }, eventemitter;
}
var float, hasRequiredFloat;
function requireFloat() {
  if (hasRequiredFloat) return float;
  hasRequiredFloat = 1, float = n(n);
  function n(H) {
    return typeof Float32Array < "u" ? (function() {
      var AA = new Float32Array([-0]), gA = new Uint8Array(AA.buffer), IA = gA[3] === 128;
      function CA(QA, tA, oA) {
        AA[0] = QA, tA[oA] = gA[0], tA[oA + 1] = gA[1], tA[oA + 2] = gA[2], tA[oA + 3] = gA[3];
      }
      function BA(QA, tA, oA) {
        AA[0] = QA, tA[oA] = gA[3], tA[oA + 1] = gA[2], tA[oA + 2] = gA[1], tA[oA + 3] = gA[0];
      }
      H.writeFloatLE = IA ? CA : BA, H.writeFloatBE = IA ? BA : CA;
      function eA(QA, tA) {
        return gA[0] = QA[tA], gA[1] = QA[tA + 1], gA[2] = QA[tA + 2], gA[3] = QA[tA + 3], AA[0];
      }
      function iA(QA, tA) {
        return gA[3] = QA[tA], gA[2] = QA[tA + 1], gA[1] = QA[tA + 2], gA[0] = QA[tA + 3], AA[0];
      }
      H.readFloatLE = IA ? eA : iA, H.readFloatBE = IA ? iA : eA;
    })() : (function() {
      function AA(IA, CA, BA, eA) {
        var iA = CA < 0 ? 1 : 0;
        if (iA && (CA = -CA), CA === 0) IA(1 / CA > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), BA, eA);
        else if (isNaN(CA)) IA(2143289344, BA, eA);
        else if (CA > 34028234663852886e22) IA((iA << 31 | 2139095040) >>> 0, BA, eA);
        else if (CA < 11754943508222875e-54) IA((iA << 31 | Math.round(CA / 1401298464324817e-60)) >>> 0, BA, eA);
        else {
          var QA = Math.floor(Math.log(CA) / Math.LN2), tA = Math.round(CA * Math.pow(2, -QA) * 8388608) & 8388607;
          IA((iA << 31 | QA + 127 << 23 | tA) >>> 0, BA, eA);
        }
      }
      H.writeFloatLE = AA.bind(null, t), H.writeFloatBE = AA.bind(null, g);
      function gA(IA, CA, BA) {
        var eA = IA(CA, BA), iA = (eA >> 31) * 2 + 1, QA = eA >>> 23 & 255, tA = eA & 8388607;
        return QA === 255 ? tA ? NaN : iA * (1 / 0) : QA === 0 ? iA * 1401298464324817e-60 * tA : iA * Math.pow(2, QA - 150) * (tA + 8388608);
      }
      H.readFloatLE = gA.bind(null, d), H.readFloatBE = gA.bind(null, k);
    })(), typeof Float64Array < "u" ? (function() {
      var AA = new Float64Array([-0]), gA = new Uint8Array(AA.buffer), IA = gA[7] === 128;
      function CA(QA, tA, oA) {
        AA[0] = QA, tA[oA] = gA[0], tA[oA + 1] = gA[1], tA[oA + 2] = gA[2], tA[oA + 3] = gA[3], tA[oA + 4] = gA[4], tA[oA + 5] = gA[5], tA[oA + 6] = gA[6], tA[oA + 7] = gA[7];
      }
      function BA(QA, tA, oA) {
        AA[0] = QA, tA[oA] = gA[7], tA[oA + 1] = gA[6], tA[oA + 2] = gA[5], tA[oA + 3] = gA[4], tA[oA + 4] = gA[3], tA[oA + 5] = gA[2], tA[oA + 6] = gA[1], tA[oA + 7] = gA[0];
      }
      H.writeDoubleLE = IA ? CA : BA, H.writeDoubleBE = IA ? BA : CA;
      function eA(QA, tA) {
        return gA[0] = QA[tA], gA[1] = QA[tA + 1], gA[2] = QA[tA + 2], gA[3] = QA[tA + 3], gA[4] = QA[tA + 4], gA[5] = QA[tA + 5], gA[6] = QA[tA + 6], gA[7] = QA[tA + 7], AA[0];
      }
      function iA(QA, tA) {
        return gA[7] = QA[tA], gA[6] = QA[tA + 1], gA[5] = QA[tA + 2], gA[4] = QA[tA + 3], gA[3] = QA[tA + 4], gA[2] = QA[tA + 5], gA[1] = QA[tA + 6], gA[0] = QA[tA + 7], AA[0];
      }
      H.readDoubleLE = IA ? eA : iA, H.readDoubleBE = IA ? iA : eA;
    })() : (function() {
      function AA(IA, CA, BA, eA, iA, QA) {
        var tA = eA < 0 ? 1 : 0;
        if (tA && (eA = -eA), eA === 0) IA(0, iA, QA + CA), IA(1 / eA > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), iA, QA + BA);
        else if (isNaN(eA)) IA(0, iA, QA + CA), IA(2146959360, iA, QA + BA);
        else if (eA > 17976931348623157e292) IA(0, iA, QA + CA), IA((tA << 31 | 2146435072) >>> 0, iA, QA + BA);
        else {
          var oA;
          if (eA < 22250738585072014e-324) oA = eA / 5e-324, IA(oA >>> 0, iA, QA + CA), IA((tA << 31 | oA / 4294967296) >>> 0, iA, QA + BA);
          else {
            var EA = Math.floor(Math.log(eA) / Math.LN2);
            EA === 1024 && (EA = 1023), oA = eA * Math.pow(2, -EA), IA(oA * 4503599627370496 >>> 0, iA, QA + CA), IA((tA << 31 | EA + 1023 << 20 | oA * 1048576 & 1048575) >>> 0, iA, QA + BA);
          }
        }
      }
      H.writeDoubleLE = AA.bind(null, t, 0, 4), H.writeDoubleBE = AA.bind(null, g, 4, 0);
      function gA(IA, CA, BA, eA, iA) {
        var QA = IA(eA, iA + CA), tA = IA(eA, iA + BA), oA = (tA >> 31) * 2 + 1, EA = tA >>> 20 & 2047, aA = 4294967296 * (tA & 1048575) + QA;
        return EA === 2047 ? aA ? NaN : oA * (1 / 0) : EA === 0 ? oA * 5e-324 * aA : oA * Math.pow(2, EA - 1075) * (aA + 4503599627370496);
      }
      H.readDoubleLE = gA.bind(null, d, 0, 4), H.readDoubleBE = gA.bind(null, k, 4, 0);
    })(), H;
  }
  function t(H, AA, gA) {
    AA[gA] = H & 255, AA[gA + 1] = H >>> 8 & 255, AA[gA + 2] = H >>> 16 & 255, AA[gA + 3] = H >>> 24;
  }
  function g(H, AA, gA) {
    AA[gA] = H >>> 24, AA[gA + 1] = H >>> 16 & 255, AA[gA + 2] = H >>> 8 & 255, AA[gA + 3] = H & 255;
  }
  function d(H, AA) {
    return (H[AA] | H[AA + 1] << 8 | H[AA + 2] << 16 | H[AA + 3] << 24) >>> 0;
  }
  function k(H, AA) {
    return (H[AA] << 24 | H[AA + 1] << 16 | H[AA + 2] << 8 | H[AA + 3]) >>> 0;
  }
  return float;
}
var inquire_1, hasRequiredInquire;
function requireInquire() {
  if (hasRequiredInquire) return inquire_1;
  hasRequiredInquire = 1, inquire_1 = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch (n) {
    }
    return null;
  }
  return inquire_1;
}
var utf8 = {}, hasRequiredUtf8;
function requireUtf8() {
  return hasRequiredUtf8 || (hasRequiredUtf8 = 1, (function(n) {
    var t = n;
    t.length = function(g) {
      for (var d = 0, k = 0, H = 0; H < g.length; ++H) k = g.charCodeAt(H), k < 128 ? d += 1 : k < 2048 ? d += 2 : (k & 64512) === 55296 && (g.charCodeAt(H + 1) & 64512) === 56320 ? (++H, d += 4) : d += 3;
      return d;
    }, t.read = function(g, d, k) {
      var H = k - d;
      if (H < 1) return "";
      for (var AA = null, gA = [], IA = 0, CA; d < k; ) CA = g[d++], CA < 128 ? gA[IA++] = CA : CA > 191 && CA < 224 ? gA[IA++] = (CA & 31) << 6 | g[d++] & 63 : CA > 239 && CA < 365 ? (CA = ((CA & 7) << 18 | (g[d++] & 63) << 12 | (g[d++] & 63) << 6 | g[d++] & 63) - 65536, gA[IA++] = 55296 + (CA >> 10), gA[IA++] = 56320 + (CA & 1023)) : gA[IA++] = (CA & 15) << 12 | (g[d++] & 63) << 6 | g[d++] & 63, IA > 8191 && ((AA || (AA = [])).push(String.fromCharCode.apply(String, gA)), IA = 0);
      return AA ? (IA && AA.push(String.fromCharCode.apply(String, gA.slice(0, IA))), AA.join("")) : String.fromCharCode.apply(String, gA.slice(0, IA));
    }, t.write = function(g, d, k) {
      for (var H = k, AA, gA, IA = 0; IA < g.length; ++IA) AA = g.charCodeAt(IA), AA < 128 ? d[k++] = AA : AA < 2048 ? (d[k++] = AA >> 6 | 192, d[k++] = AA & 63 | 128) : (AA & 64512) === 55296 && ((gA = g.charCodeAt(IA + 1)) & 64512) === 56320 ? (AA = 65536 + ((AA & 1023) << 10) + (gA & 1023), ++IA, d[k++] = AA >> 18 | 240, d[k++] = AA >> 12 & 63 | 128, d[k++] = AA >> 6 & 63 | 128, d[k++] = AA & 63 | 128) : (d[k++] = AA >> 12 | 224, d[k++] = AA >> 6 & 63 | 128, d[k++] = AA & 63 | 128);
      return k - H;
    };
  })(utf8)), utf8;
}
var pool_1, hasRequiredPool;
function requirePool() {
  if (hasRequiredPool) return pool_1;
  hasRequiredPool = 1, pool_1 = n;
  function n(t, g, d) {
    var k = d || 8192, H = k >>> 1, AA = null, gA = k;
    return function(IA) {
      if (IA < 1 || IA > H) return t(IA);
      gA + IA > k && (AA = t(k), gA = 0);
      var CA = g.call(AA, gA, gA += IA);
      return gA & 7 && (gA = (gA | 7) + 1), CA;
    };
  }
  return pool_1;
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits) return longbits;
  hasRequiredLongbits = 1, longbits = t;
  var n = requireMinimal$1();
  function t(H, AA) {
    this.lo = H >>> 0, this.hi = AA >>> 0;
  }
  var g = t.zero = new t(0, 0);
  g.toNumber = function() {
    return 0;
  }, g.zzEncode = g.zzDecode = function() {
    return this;
  }, g.length = function() {
    return 1;
  };
  var d = t.zeroHash = "\0\0\0\0\0\0\0\0";
  t.fromNumber = function(H) {
    if (H === 0) return g;
    var AA = H < 0;
    AA && (H = -H);
    var gA = H >>> 0, IA = (H - gA) / 4294967296 >>> 0;
    return AA && (IA = ~IA >>> 0, gA = ~gA >>> 0, ++gA > 4294967295 && (gA = 0, ++IA > 4294967295 && (IA = 0))), new t(gA, IA);
  }, t.from = function(H) {
    if (typeof H == "number") return t.fromNumber(H);
    if (n.isString(H)) if (n.Long) H = n.Long.fromString(H);
    else return t.fromNumber(parseInt(H, 10));
    return H.low || H.high ? new t(H.low >>> 0, H.high >>> 0) : g;
  }, t.prototype.toNumber = function(H) {
    if (!H && this.hi >>> 31) {
      var AA = ~this.lo + 1 >>> 0, gA = ~this.hi >>> 0;
      return AA || (gA = gA + 1 >>> 0), -(AA + gA * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, t.prototype.toLong = function(H) {
    return n.Long ? new n.Long(this.lo | 0, this.hi | 0, !!H) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!H };
  };
  var k = String.prototype.charCodeAt;
  return t.fromHash = function(H) {
    return H === d ? g : new t((k.call(H, 0) | k.call(H, 1) << 8 | k.call(H, 2) << 16 | k.call(H, 3) << 24) >>> 0, (k.call(H, 4) | k.call(H, 5) << 8 | k.call(H, 6) << 16 | k.call(H, 7) << 24) >>> 0);
  }, t.prototype.toHash = function() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
  }, t.prototype.zzEncode = function() {
    var H = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ H) >>> 0, this.lo = (this.lo << 1 ^ H) >>> 0, this;
  }, t.prototype.zzDecode = function() {
    var H = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ H) >>> 0, this.hi = (this.hi >>> 1 ^ H) >>> 0, this;
  }, t.prototype.length = function() {
    var H = this.lo, AA = (this.lo >>> 28 | this.hi << 4) >>> 0, gA = this.hi >>> 24;
    return gA === 0 ? AA === 0 ? H < 16384 ? H < 128 ? 1 : 2 : H < 2097152 ? 3 : 4 : AA < 16384 ? AA < 128 ? 5 : 6 : AA < 2097152 ? 7 : 8 : gA < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal$1;
function requireMinimal$1() {
  return hasRequiredMinimal$1 || (hasRequiredMinimal$1 = 1, (function(n) {
    var t = n;
    t.asPromise = requireAspromise(), t.base64 = requireBase64(), t.EventEmitter = requireEventemitter(), t.float = requireFloat(), t.inquire = requireInquire(), t.utf8 = requireUtf8(), t.pool = requirePool(), t.LongBits = requireLongbits(), t.isNode = !!(typeof commonjsGlobal$1 < "u" && commonjsGlobal$1 && commonjsGlobal$1.process && commonjsGlobal$1.process.versions && commonjsGlobal$1.process.versions.node), t.global = t.isNode && commonjsGlobal$1 || typeof window < "u" && window || typeof self < "u" && self || minimal$1, t.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), t.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), t.isInteger = Number.isInteger || /* istanbul ignore next */
    function(k) {
      return typeof k == "number" && isFinite(k) && Math.floor(k) === k;
    }, t.isString = function(k) {
      return typeof k == "string" || k instanceof String;
    }, t.isObject = function(k) {
      return k && typeof k == "object";
    }, t.isset = /**
    * Checks if a property on a message is considered to be present.
    * @param {Object} obj Plain object or message instance
    * @param {string} prop Property name
    * @returns {boolean} `true` if considered to be present, otherwise `false`
    */
    t.isSet = function(k, H) {
      var AA = k[H];
      return AA != null && k.hasOwnProperty(H) ? typeof AA != "object" || (Array.isArray(AA) ? AA.length : Object.keys(AA).length) > 0 : !1;
    }, t.Buffer = (function() {
      try {
        var k = t.inquire("buffer").Buffer;
        return k.prototype.utf8Write ? k : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    })(), t._Buffer_from = null, t._Buffer_allocUnsafe = null, t.newBuffer = function(k) {
      return typeof k == "number" ? t.Buffer ? t._Buffer_allocUnsafe(k) : new t.Array(k) : t.Buffer ? t._Buffer_from(k) : typeof Uint8Array > "u" ? k : new Uint8Array(k);
    }, t.Array = typeof Uint8Array < "u" ? Uint8Array : Array, t.Long = /* istanbul ignore next */
    t.global.dcodeIO && /* istanbul ignore next */
    t.global.dcodeIO.Long || /* istanbul ignore next */
    t.global.Long || t.inquire("long"), t.key2Re = /^true|false|0|1$/, t.key32Re = /^-?(?:0|[1-9][0-9]*)$/, t.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, t.longToHash = function(k) {
      return k ? t.LongBits.from(k).toHash() : t.LongBits.zeroHash;
    }, t.longFromHash = function(k, H) {
      var AA = t.LongBits.fromHash(k);
      return t.Long ? t.Long.fromBits(AA.lo, AA.hi, H) : AA.toNumber(!!H);
    };
    function g(k, H, AA) {
      for (var gA = Object.keys(H), IA = 0; IA < gA.length; ++IA) (k[gA[IA]] === void 0 || !AA) && (k[gA[IA]] = H[gA[IA]]);
      return k;
    }
    t.merge = g, t.lcFirst = function(k) {
      return k.charAt(0).toLowerCase() + k.substring(1);
    };
    function d(k) {
      function H(AA, gA) {
        if (!(this instanceof H)) return new H(AA, gA);
        Object.defineProperty(this, "message", { get: function() {
          return AA;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, H) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), gA && g(this, gA);
      }
      return H.prototype = Object.create(Error.prototype, { constructor: { value: H, writable: !0, enumerable: !1, configurable: !0 }, name: {
        get: function() {
          return k;
        },
        set: void 0,
        enumerable: !1,
        // configurable: false would accurately preserve the behavior of
        // the original, but I'm guessing that was not intentional.
        // For an actual error subclass, this property would
        // be configurable.
        configurable: !0
      }, toString: { value: function() {
        return this.name + ": " + this.message;
      }, writable: !0, enumerable: !1, configurable: !0 } }), H;
    }
    t.newError = d, t.ProtocolError = d("ProtocolError"), t.oneOfGetter = function(k) {
      for (var H = {}, AA = 0; AA < k.length; ++AA) H[k[AA]] = 1;
      return function() {
        for (var gA = Object.keys(this), IA = gA.length - 1; IA > -1; --IA) if (H[gA[IA]] === 1 && this[gA[IA]] !== void 0 && this[gA[IA]] !== null) return gA[IA];
      };
    }, t.oneOfSetter = function(k) {
      return function(H) {
        for (var AA = 0; AA < k.length; ++AA) k[AA] !== H && delete this[k[AA]];
      };
    }, t.toJSONOptions = { longs: String, enums: String, bytes: String, json: !0 }, t._configure = function() {
      var k = t.Buffer;
      if (!k) {
        t._Buffer_from = t._Buffer_allocUnsafe = null;
        return;
      }
      t._Buffer_from = k.from !== Uint8Array.from && k.from || /* istanbul ignore next */
      function(H, AA) {
        return new k(H, AA);
      }, t._Buffer_allocUnsafe = k.allocUnsafe || /* istanbul ignore next */
      function(H) {
        return new k(H);
      };
    };
  })(minimal$1)), minimal$1;
}
var writer, hasRequiredWriter;
function requireWriter() {
  if (hasRequiredWriter) return writer;
  hasRequiredWriter = 1, writer = IA;
  var n = requireMinimal$1(), t, g = n.LongBits, d = n.base64, k = n.utf8;
  function H(EA, aA, nA) {
    this.fn = EA, this.len = aA, this.next = void 0, this.val = nA;
  }
  function AA() {
  }
  function gA(EA) {
    this.head = EA.head, this.tail = EA.tail, this.len = EA.len, this.next = EA.states;
  }
  function IA() {
    this.len = 0, this.head = new H(AA, 0, 0), this.tail = this.head, this.states = null;
  }
  var CA = function() {
    return n.Buffer ? function() {
      return (IA.create = function() {
        return new t();
      })();
    } : function() {
      return new IA();
    };
  };
  IA.create = CA(), IA.alloc = function(EA) {
    return new n.Array(EA);
  }, n.Array !== Array && (IA.alloc = n.pool(IA.alloc, n.Array.prototype.subarray)), IA.prototype._push = function(EA, aA, nA) {
    return this.tail = this.tail.next = new H(EA, aA, nA), this.len += aA, this;
  };
  function BA(EA, aA, nA) {
    aA[nA] = EA & 255;
  }
  function eA(EA, aA, nA) {
    for (; EA > 127; ) aA[nA++] = EA & 127 | 128, EA >>>= 7;
    aA[nA] = EA;
  }
  function iA(EA, aA) {
    this.len = EA, this.next = void 0, this.val = aA;
  }
  iA.prototype = Object.create(H.prototype), iA.prototype.fn = eA, IA.prototype.uint32 = function(EA) {
    return this.len += (this.tail = this.tail.next = new iA((EA = EA >>> 0) < 128 ? 1 : EA < 16384 ? 2 : EA < 2097152 ? 3 : EA < 268435456 ? 4 : 5, EA)).len, this;
  }, IA.prototype.int32 = function(EA) {
    return EA < 0 ? this._push(QA, 10, g.fromNumber(EA)) : this.uint32(EA);
  }, IA.prototype.sint32 = function(EA) {
    return this.uint32((EA << 1 ^ EA >> 31) >>> 0);
  };
  function QA(EA, aA, nA) {
    for (; EA.hi; ) aA[nA++] = EA.lo & 127 | 128, EA.lo = (EA.lo >>> 7 | EA.hi << 25) >>> 0, EA.hi >>>= 7;
    for (; EA.lo > 127; ) aA[nA++] = EA.lo & 127 | 128, EA.lo = EA.lo >>> 7;
    aA[nA++] = EA.lo;
  }
  IA.prototype.uint64 = function(EA) {
    var aA = g.from(EA);
    return this._push(QA, aA.length(), aA);
  }, IA.prototype.int64 = IA.prototype.uint64, IA.prototype.sint64 = function(EA) {
    var aA = g.from(EA).zzEncode();
    return this._push(QA, aA.length(), aA);
  }, IA.prototype.bool = function(EA) {
    return this._push(BA, 1, EA ? 1 : 0);
  };
  function tA(EA, aA, nA) {
    aA[nA] = EA & 255, aA[nA + 1] = EA >>> 8 & 255, aA[nA + 2] = EA >>> 16 & 255, aA[nA + 3] = EA >>> 24;
  }
  IA.prototype.fixed32 = function(EA) {
    return this._push(tA, 4, EA >>> 0);
  }, IA.prototype.sfixed32 = IA.prototype.fixed32, IA.prototype.fixed64 = function(EA) {
    var aA = g.from(EA);
    return this._push(tA, 4, aA.lo)._push(tA, 4, aA.hi);
  }, IA.prototype.sfixed64 = IA.prototype.fixed64, IA.prototype.float = function(EA) {
    return this._push(n.float.writeFloatLE, 4, EA);
  }, IA.prototype.double = function(EA) {
    return this._push(n.float.writeDoubleLE, 8, EA);
  };
  var oA = n.Array.prototype.set ? function(EA, aA, nA) {
    aA.set(EA, nA);
  } : function(EA, aA, nA) {
    for (var lA = 0; lA < EA.length; ++lA) aA[nA + lA] = EA[lA];
  };
  return IA.prototype.bytes = function(EA) {
    var aA = EA.length >>> 0;
    if (!aA) return this._push(BA, 1, 0);
    if (n.isString(EA)) {
      var nA = IA.alloc(aA = d.length(EA));
      d.decode(EA, nA, 0), EA = nA;
    }
    return this.uint32(aA)._push(oA, aA, EA);
  }, IA.prototype.string = function(EA) {
    var aA = k.length(EA);
    return aA ? this.uint32(aA)._push(k.write, aA, EA) : this._push(BA, 1, 0);
  }, IA.prototype.fork = function() {
    return this.states = new gA(this), this.head = this.tail = new H(AA, 0, 0), this.len = 0, this;
  }, IA.prototype.reset = function() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new H(AA, 0, 0), this.len = 0), this;
  }, IA.prototype.ldelim = function() {
    var EA = this.head, aA = this.tail, nA = this.len;
    return this.reset().uint32(nA), nA && (this.tail.next = EA.next, this.tail = aA, this.len += nA), this;
  }, IA.prototype.finish = function() {
    for (var EA = this.head.next, aA = this.constructor.alloc(this.len), nA = 0; EA; ) EA.fn(EA.val, aA, nA), nA += EA.len, EA = EA.next;
    return aA;
  }, IA._configure = function(EA) {
    t = EA, IA.create = CA(), t._configure();
  }, writer;
}
var writer_buffer, hasRequiredWriter_buffer;
function requireWriter_buffer() {
  if (hasRequiredWriter_buffer) return writer_buffer;
  hasRequiredWriter_buffer = 1, writer_buffer = g;
  var n = requireWriter();
  (g.prototype = Object.create(n.prototype)).constructor = g;
  var t = requireMinimal$1();
  function g() {
    n.call(this);
  }
  g._configure = function() {
    g.alloc = t._Buffer_allocUnsafe, g.writeBytesBuffer = t.Buffer && t.Buffer.prototype instanceof Uint8Array && t.Buffer.prototype.set.name === "set" ? function(k, H, AA) {
      H.set(k, AA);
    } : function(k, H, AA) {
      if (k.copy) k.copy(H, AA, 0, k.length);
      else for (var gA = 0; gA < k.length; ) H[AA++] = k[gA++];
    };
  }, g.prototype.bytes = function(k) {
    t.isString(k) && (k = t._Buffer_from(k, "base64"));
    var H = k.length >>> 0;
    return this.uint32(H), H && this._push(g.writeBytesBuffer, H, k), this;
  };
  function d(k, H, AA) {
    k.length < 40 ? t.utf8.write(k, H, AA) : H.utf8Write ? H.utf8Write(k, AA) : H.write(k, AA);
  }
  return g.prototype.string = function(k) {
    var H = t.Buffer.byteLength(k);
    return this.uint32(H), H && this._push(d, H, k), this;
  }, g._configure(), writer_buffer;
}
var reader, hasRequiredReader;
function requireReader() {
  if (hasRequiredReader) return reader;
  hasRequiredReader = 1, reader = H;
  var n = requireMinimal$1(), t, g = n.LongBits, d = n.utf8;
  function k(eA, iA) {
    return RangeError("index out of range: " + eA.pos + " + " + (iA || 1) + " > " + eA.len);
  }
  function H(eA) {
    this.buf = eA, this.pos = 0, this.len = eA.length;
  }
  var AA = typeof Uint8Array < "u" ? function(eA) {
    if (eA instanceof Uint8Array || Array.isArray(eA)) return new H(eA);
    throw Error("illegal buffer");
  } : function(eA) {
    if (Array.isArray(eA)) return new H(eA);
    throw Error("illegal buffer");
  }, gA = function() {
    return n.Buffer ? function(eA) {
      return (H.create = function(iA) {
        return n.Buffer.isBuffer(iA) ? new t(iA) : AA(iA);
      })(eA);
    } : AA;
  };
  H.create = gA(), H.prototype._slice = n.Array.prototype.subarray || /* istanbul ignore next */
  n.Array.prototype.slice, H.prototype.uint32 = /* @__PURE__ */ (function() {
    var eA = 4294967295;
    return function() {
      if (eA = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (eA = (eA | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (eA = (eA | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (eA = (eA | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (eA = (eA | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128)) return eA;
      if ((this.pos += 5) > this.len) throw this.pos = this.len, k(this, 10);
      return eA;
    };
  })(), H.prototype.int32 = function() {
    return this.uint32() | 0;
  }, H.prototype.sint32 = function() {
    var eA = this.uint32();
    return eA >>> 1 ^ -(eA & 1) | 0;
  };
  function IA() {
    var eA = new g(0, 0), iA = 0;
    if (this.len - this.pos > 4) {
      for (; iA < 4; ++iA) if (eA.lo = (eA.lo | (this.buf[this.pos] & 127) << iA * 7) >>> 0, this.buf[this.pos++] < 128) return eA;
      if (eA.lo = (eA.lo | (this.buf[this.pos] & 127) << 28) >>> 0, eA.hi = (eA.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128) return eA;
      iA = 0;
    } else {
      for (; iA < 3; ++iA) {
        if (this.pos >= this.len) throw k(this);
        if (eA.lo = (eA.lo | (this.buf[this.pos] & 127) << iA * 7) >>> 0, this.buf[this.pos++] < 128) return eA;
      }
      return eA.lo = (eA.lo | (this.buf[this.pos++] & 127) << iA * 7) >>> 0, eA;
    }
    if (this.len - this.pos > 4) {
      for (; iA < 5; ++iA) if (eA.hi = (eA.hi | (this.buf[this.pos] & 127) << iA * 7 + 3) >>> 0, this.buf[this.pos++] < 128) return eA;
    } else for (; iA < 5; ++iA) {
      if (this.pos >= this.len) throw k(this);
      if (eA.hi = (eA.hi | (this.buf[this.pos] & 127) << iA * 7 + 3) >>> 0, this.buf[this.pos++] < 128) return eA;
    }
    throw Error("invalid varint encoding");
  }
  H.prototype.bool = function() {
    return this.uint32() !== 0;
  };
  function CA(eA, iA) {
    return (eA[iA - 4] | eA[iA - 3] << 8 | eA[iA - 2] << 16 | eA[iA - 1] << 24) >>> 0;
  }
  H.prototype.fixed32 = function() {
    if (this.pos + 4 > this.len) throw k(this, 4);
    return CA(this.buf, this.pos += 4);
  }, H.prototype.sfixed32 = function() {
    if (this.pos + 4 > this.len) throw k(this, 4);
    return CA(this.buf, this.pos += 4) | 0;
  };
  function BA() {
    if (this.pos + 8 > this.len) throw k(this, 8);
    return new g(CA(this.buf, this.pos += 4), CA(this.buf, this.pos += 4));
  }
  return H.prototype.float = function() {
    if (this.pos + 4 > this.len) throw k(this, 4);
    var eA = n.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, eA;
  }, H.prototype.double = function() {
    if (this.pos + 8 > this.len) throw k(this, 4);
    var eA = n.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, eA;
  }, H.prototype.bytes = function() {
    var eA = this.uint32(), iA = this.pos, QA = this.pos + eA;
    if (QA > this.len) throw k(this, eA);
    if (this.pos += eA, Array.isArray(this.buf)) return this.buf.slice(iA, QA);
    if (iA === QA) {
      var tA = n.Buffer;
      return tA ? tA.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, iA, QA);
  }, H.prototype.string = function() {
    var eA = this.bytes();
    return d.read(eA, 0, eA.length);
  }, H.prototype.skip = function(eA) {
    if (typeof eA == "number") {
      if (this.pos + eA > this.len) throw k(this, eA);
      this.pos += eA;
    } else do
      if (this.pos >= this.len) throw k(this);
    while (this.buf[this.pos++] & 128);
    return this;
  }, H.prototype.skipType = function(eA) {
    switch (eA) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (eA = this.uint32() & 7) !== 4; ) this.skipType(eA);
        break;
      case 5:
        this.skip(4);
        break;
      /* istanbul ignore next */
      default:
        throw Error("invalid wire type " + eA + " at offset " + this.pos);
    }
    return this;
  }, H._configure = function(eA) {
    t = eA, H.create = gA(), t._configure();
    var iA = n.Long ? "toLong" : (
      /* istanbul ignore next */
      "toNumber"
    );
    n.merge(H.prototype, { int64: function() {
      return IA.call(this)[iA](!1);
    }, uint64: function() {
      return IA.call(this)[iA](!0);
    }, sint64: function() {
      return IA.call(this).zzDecode()[iA](!1);
    }, fixed64: function() {
      return BA.call(this)[iA](!0);
    }, sfixed64: function() {
      return BA.call(this)[iA](!1);
    } });
  }, reader;
}
var reader_buffer, hasRequiredReader_buffer;
function requireReader_buffer() {
  if (hasRequiredReader_buffer) return reader_buffer;
  hasRequiredReader_buffer = 1, reader_buffer = g;
  var n = requireReader();
  (g.prototype = Object.create(n.prototype)).constructor = g;
  var t = requireMinimal$1();
  function g(d) {
    n.call(this, d);
  }
  return g._configure = function() {
    t.Buffer && (g.prototype._slice = t.Buffer.prototype.slice);
  }, g.prototype.string = function() {
    var d = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + d, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + d, this.len));
  }, g._configure(), reader_buffer;
}
var rpc = {}, service$1, hasRequiredService$1;
function requireService$1() {
  if (hasRequiredService$1) return service$1;
  hasRequiredService$1 = 1, service$1 = t;
  var n = requireMinimal$1();
  (t.prototype = Object.create(n.EventEmitter.prototype)).constructor = t;
  function t(g, d, k) {
    if (typeof g != "function") throw TypeError("rpcImpl must be a function");
    n.EventEmitter.call(this), this.rpcImpl = g, this.requestDelimited = !!d, this.responseDelimited = !!k;
  }
  return t.prototype.rpcCall = function g(d, k, H, AA, gA) {
    if (!AA) throw TypeError("request must be specified");
    var IA = this;
    if (!gA) return n.asPromise(g, IA, d, k, H, AA);
    if (!IA.rpcImpl) {
      setTimeout(function() {
        gA(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return IA.rpcImpl(d, k[IA.requestDelimited ? "encodeDelimited" : "encode"](AA).finish(), function(CA, BA) {
        if (CA) return IA.emit("error", CA, d), gA(CA);
        if (BA === null) {
          IA.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(BA instanceof H)) try {
          BA = H[IA.responseDelimited ? "decodeDelimited" : "decode"](BA);
        } catch (eA) {
          return IA.emit("error", eA, d), gA(eA);
        }
        return IA.emit("data", BA, d), gA(null, BA);
      });
    } catch (CA) {
      IA.emit("error", CA, d), setTimeout(function() {
        gA(CA);
      }, 0);
      return;
    }
  }, t.prototype.end = function(g) {
    return this.rpcImpl && (g || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  }, service$1;
}
var hasRequiredRpc;
function requireRpc() {
  return hasRequiredRpc || (hasRequiredRpc = 1, (function(n) {
    var t = n;
    t.Service = requireService$1();
  })(rpc)), rpc;
}
var roots, hasRequiredRoots;
function requireRoots() {
  return hasRequiredRoots || (hasRequiredRoots = 1, roots = {}), roots;
}
var hasRequiredIndexMinimal;
function requireIndexMinimal() {
  return hasRequiredIndexMinimal || (hasRequiredIndexMinimal = 1, (function(n) {
    var t = n;
    t.build = "minimal", t.Writer = requireWriter(), t.BufferWriter = requireWriter_buffer(), t.Reader = requireReader(), t.BufferReader = requireReader_buffer(), t.util = requireMinimal$1(), t.rpc = requireRpc(), t.roots = requireRoots(), t.configure = g;
    function g() {
      t.util._configure(), t.Writer._configure(t.BufferWriter), t.Reader._configure(t.BufferReader);
    }
    g();
  })(indexMinimal)), indexMinimal;
}
var minimal, hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, minimal = requireIndexMinimal()), minimal;
}
var minimalExports = requireMinimal();
const $Reader = minimalExports.Reader, $Writer = minimalExports.Writer, $util = minimalExports.util, $root = minimalExports.roots.default || (minimalExports.roots.default = {});
$root.Alert = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.body = "", n.prototype.format = 0, n.prototype.icon = "", n.prototype.widthConfig = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.body != null && Object.hasOwnProperty.call(t, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.body), t.format != null && Object.hasOwnProperty.call(t, "format") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(t.format), t.icon != null && Object.hasOwnProperty.call(t, "icon") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.icon), t.widthConfig != null && Object.hasOwnProperty.call(t, "widthConfig") && $root.streamlit.WidthConfig.encode(t.widthConfig, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Alert();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.body = t.string();
          break;
        }
        case 2: {
          H.format = t.int32();
          break;
        }
        case 3: {
          H.icon = t.string();
          break;
        }
        case 4: {
          H.widthConfig = $root.streamlit.WidthConfig.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.body != null && t.hasOwnProperty("body") && !$util.isString(t.body)) return "body: string expected";
    if (t.format != null && t.hasOwnProperty("format")) switch (t.format) {
      default:
        return "format: enum value expected";
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
        break;
    }
    if (t.icon != null && t.hasOwnProperty("icon") && !$util.isString(t.icon)) return "icon: string expected";
    if (t.widthConfig != null && t.hasOwnProperty("widthConfig")) {
      let g = $root.streamlit.WidthConfig.verify(t.widthConfig);
      if (g) return "widthConfig." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Alert) return t;
    let g = new $root.Alert();
    switch (t.body != null && (g.body = String(t.body)), t.format) {
      default:
        if (typeof t.format == "number") {
          g.format = t.format;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        g.format = 0;
        break;
      case "ERROR":
      case 1:
        g.format = 1;
        break;
      case "WARNING":
      case 2:
        g.format = 2;
        break;
      case "INFO":
      case 3:
        g.format = 3;
        break;
      case "SUCCESS":
      case 4:
        g.format = 4;
        break;
    }
    if (t.icon != null && (g.icon = String(t.icon)), t.widthConfig != null) {
      if (typeof t.widthConfig != "object") throw TypeError(".Alert.widthConfig: object expected");
      g.widthConfig = $root.streamlit.WidthConfig.fromObject(t.widthConfig);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.body = "", d.format = g.enums === String ? "UNUSED" : 0, d.icon = "", d.widthConfig = null), t.body != null && t.hasOwnProperty("body") && (d.body = t.body), t.format != null && t.hasOwnProperty("format") && (d.format = g.enums === String ? $root.Alert.Format[t.format] === void 0 ? t.format : $root.Alert.Format[t.format] : t.format), t.icon != null && t.hasOwnProperty("icon") && (d.icon = t.icon), t.widthConfig != null && t.hasOwnProperty("widthConfig") && (d.widthConfig = $root.streamlit.WidthConfig.toObject(t.widthConfig, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Alert";
  }, n.Format = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "UNUSED"] = 0, g[t[1] = "ERROR"] = 1, g[t[2] = "WARNING"] = 2, g[t[3] = "INFO"] = 3, g[t[4] = "SUCCESS"] = 4, g;
  })(), n;
})();
$root.streamlit = (() => {
  const n = {};
  return n.WidthConfig = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.useStretch = null, t.prototype.useContent = null, t.prototype.pixelWidth = null;
    let g;
    return Object.defineProperty(t.prototype, "widthSpec", { get: $util.oneOfGetter(g = ["useStretch", "useContent", "pixelWidth"]), set: $util.oneOfSetter(g) }), t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      return k || (k = $Writer.create()), d.useStretch != null && Object.hasOwnProperty.call(d, "useStretch") && k.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(d.useStretch), d.useContent != null && Object.hasOwnProperty.call(d, "useContent") && k.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(d.useContent), d.pixelWidth != null && Object.hasOwnProperty.call(d, "pixelWidth") && k.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(d.pixelWidth), k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.streamlit.WidthConfig();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.useStretch = d.bool();
            break;
          }
          case 2: {
            gA.useContent = d.bool();
            break;
          }
          case 3: {
            gA.pixelWidth = d.uint32();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      let k = {};
      if (d.useStretch != null && d.hasOwnProperty("useStretch") && (k.widthSpec = 1, typeof d.useStretch != "boolean")) return "useStretch: boolean expected";
      if (d.useContent != null && d.hasOwnProperty("useContent")) {
        if (k.widthSpec === 1) return "widthSpec: multiple values";
        if (k.widthSpec = 1, typeof d.useContent != "boolean") return "useContent: boolean expected";
      }
      if (d.pixelWidth != null && d.hasOwnProperty("pixelWidth")) {
        if (k.widthSpec === 1) return "widthSpec: multiple values";
        if (k.widthSpec = 1, !$util.isInteger(d.pixelWidth)) return "pixelWidth: integer expected";
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root.streamlit.WidthConfig) return d;
      let k = new $root.streamlit.WidthConfig();
      return d.useStretch != null && (k.useStretch = !!d.useStretch), d.useContent != null && (k.useContent = !!d.useContent), d.pixelWidth != null && (k.pixelWidth = d.pixelWidth >>> 0), k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return d.useStretch != null && d.hasOwnProperty("useStretch") && (H.useStretch = d.useStretch, k.oneofs && (H.widthSpec = "useStretch")), d.useContent != null && d.hasOwnProperty("useContent") && (H.useContent = d.useContent, k.oneofs && (H.widthSpec = "useContent")), d.pixelWidth != null && d.hasOwnProperty("pixelWidth") && (H.pixelWidth = d.pixelWidth, k.oneofs && (H.widthSpec = "pixelWidth")), H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/streamlit.WidthConfig";
    }, t;
  })(), n.HeightConfig = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.useStretch = null, t.prototype.useContent = null, t.prototype.pixelHeight = null;
    let g;
    return Object.defineProperty(t.prototype, "heightSpec", { get: $util.oneOfGetter(g = ["useStretch", "useContent", "pixelHeight"]), set: $util.oneOfSetter(g) }), t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      return k || (k = $Writer.create()), d.useStretch != null && Object.hasOwnProperty.call(d, "useStretch") && k.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(d.useStretch), d.useContent != null && Object.hasOwnProperty.call(d, "useContent") && k.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(d.useContent), d.pixelHeight != null && Object.hasOwnProperty.call(d, "pixelHeight") && k.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(d.pixelHeight), k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.streamlit.HeightConfig();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.useStretch = d.bool();
            break;
          }
          case 2: {
            gA.useContent = d.bool();
            break;
          }
          case 3: {
            gA.pixelHeight = d.uint32();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      let k = {};
      if (d.useStretch != null && d.hasOwnProperty("useStretch") && (k.heightSpec = 1, typeof d.useStretch != "boolean")) return "useStretch: boolean expected";
      if (d.useContent != null && d.hasOwnProperty("useContent")) {
        if (k.heightSpec === 1) return "heightSpec: multiple values";
        if (k.heightSpec = 1, typeof d.useContent != "boolean") return "useContent: boolean expected";
      }
      if (d.pixelHeight != null && d.hasOwnProperty("pixelHeight")) {
        if (k.heightSpec === 1) return "heightSpec: multiple values";
        if (k.heightSpec = 1, !$util.isInteger(d.pixelHeight)) return "pixelHeight: integer expected";
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root.streamlit.HeightConfig) return d;
      let k = new $root.streamlit.HeightConfig();
      return d.useStretch != null && (k.useStretch = !!d.useStretch), d.useContent != null && (k.useContent = !!d.useContent), d.pixelHeight != null && (k.pixelHeight = d.pixelHeight >>> 0), k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return d.useStretch != null && d.hasOwnProperty("useStretch") && (H.useStretch = d.useStretch, k.oneofs && (H.heightSpec = "useStretch")), d.useContent != null && d.hasOwnProperty("useContent") && (H.useContent = d.useContent, k.oneofs && (H.heightSpec = "useContent")), d.pixelHeight != null && d.hasOwnProperty("pixelHeight") && (H.pixelHeight = d.pixelHeight, k.oneofs && (H.heightSpec = "pixelHeight")), H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/streamlit.HeightConfig";
    }, t;
  })(), n.GapSize = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "GAP_UNDEFINED"] = 0, g[t[1] = "SMALL"] = 1, g[t[2] = "MEDIUM"] = 2, g[t[3] = "LARGE"] = 3, g[t[4] = "NONE"] = 4, g;
  })(), n.GapConfig = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.gapSize = null;
    let g;
    return Object.defineProperty(t.prototype, "gapSpec", { get: $util.oneOfGetter(g = ["gapSize"]), set: $util.oneOfSetter(g) }), t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      return k || (k = $Writer.create()), d.gapSize != null && Object.hasOwnProperty.call(d, "gapSize") && k.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(d.gapSize), k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.streamlit.GapConfig();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.gapSize = d.int32();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      if (d.gapSize != null && d.hasOwnProperty("gapSize")) switch (d.gapSize) {
        default:
          return "gapSize: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
          break;
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root.streamlit.GapConfig) return d;
      let k = new $root.streamlit.GapConfig();
      switch (d.gapSize) {
        default:
          if (typeof d.gapSize == "number") {
            k.gapSize = d.gapSize;
            break;
          }
          break;
        case "GAP_UNDEFINED":
        case 0:
          k.gapSize = 0;
          break;
        case "SMALL":
        case 1:
          k.gapSize = 1;
          break;
        case "MEDIUM":
        case 2:
          k.gapSize = 2;
          break;
        case "LARGE":
        case 3:
          k.gapSize = 3;
          break;
        case "NONE":
        case 4:
          k.gapSize = 4;
          break;
      }
      return k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return d.gapSize != null && d.hasOwnProperty("gapSize") && (H.gapSize = k.enums === String ? $root.streamlit.GapSize[d.gapSize] === void 0 ? d.gapSize : $root.streamlit.GapSize[d.gapSize] : d.gapSize, k.oneofs && (H.gapSpec = "gapSize")), H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/streamlit.GapConfig";
    }, t;
  })(), n;
})();
$root.AppPage = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.pageScriptHash = "", n.prototype.pageName = "", n.prototype.icon = "", n.prototype.isDefault = !1, n.prototype.sectionHeader = "", n.prototype.urlPathname = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.pageScriptHash != null && Object.hasOwnProperty.call(t, "pageScriptHash") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.pageScriptHash), t.pageName != null && Object.hasOwnProperty.call(t, "pageName") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.pageName), t.icon != null && Object.hasOwnProperty.call(t, "icon") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.icon), t.isDefault != null && Object.hasOwnProperty.call(t, "isDefault") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(t.isDefault), t.sectionHeader != null && Object.hasOwnProperty.call(t, "sectionHeader") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.sectionHeader), t.urlPathname != null && Object.hasOwnProperty.call(t, "urlPathname") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.urlPathname), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.AppPage();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.pageScriptHash = t.string();
          break;
        }
        case 2: {
          H.pageName = t.string();
          break;
        }
        case 3: {
          H.icon = t.string();
          break;
        }
        case 4: {
          H.isDefault = t.bool();
          break;
        }
        case 5: {
          H.sectionHeader = t.string();
          break;
        }
        case 6: {
          H.urlPathname = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.pageScriptHash != null && t.hasOwnProperty("pageScriptHash") && !$util.isString(t.pageScriptHash) ? "pageScriptHash: string expected" : t.pageName != null && t.hasOwnProperty("pageName") && !$util.isString(t.pageName) ? "pageName: string expected" : t.icon != null && t.hasOwnProperty("icon") && !$util.isString(t.icon) ? "icon: string expected" : t.isDefault != null && t.hasOwnProperty("isDefault") && typeof t.isDefault != "boolean" ? "isDefault: boolean expected" : t.sectionHeader != null && t.hasOwnProperty("sectionHeader") && !$util.isString(t.sectionHeader) ? "sectionHeader: string expected" : t.urlPathname != null && t.hasOwnProperty("urlPathname") && !$util.isString(t.urlPathname) ? "urlPathname: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.AppPage) return t;
    let g = new $root.AppPage();
    return t.pageScriptHash != null && (g.pageScriptHash = String(t.pageScriptHash)), t.pageName != null && (g.pageName = String(t.pageName)), t.icon != null && (g.icon = String(t.icon)), t.isDefault != null && (g.isDefault = !!t.isDefault), t.sectionHeader != null && (g.sectionHeader = String(t.sectionHeader)), t.urlPathname != null && (g.urlPathname = String(t.urlPathname)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.pageScriptHash = "", d.pageName = "", d.icon = "", d.isDefault = !1, d.sectionHeader = "", d.urlPathname = ""), t.pageScriptHash != null && t.hasOwnProperty("pageScriptHash") && (d.pageScriptHash = t.pageScriptHash), t.pageName != null && t.hasOwnProperty("pageName") && (d.pageName = t.pageName), t.icon != null && t.hasOwnProperty("icon") && (d.icon = t.icon), t.isDefault != null && t.hasOwnProperty("isDefault") && (d.isDefault = t.isDefault), t.sectionHeader != null && t.hasOwnProperty("sectionHeader") && (d.sectionHeader = t.sectionHeader), t.urlPathname != null && t.hasOwnProperty("urlPathname") && (d.urlPathname = t.urlPathname), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/AppPage";
  }, n;
})();
$root.Arrow = (() => {
  function n(g) {
    if (this.columnOrder = [], this.selectionMode = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.data = $util.newBuffer([]), n.prototype.styler = null, n.prototype.width = 0, n.prototype.height = 0, n.prototype.useContainerWidth = !1, n.prototype.id = "", n.prototype.columns = "", n.prototype.editingMode = 0, n.prototype.disabled = !1, n.prototype.formId = "", n.prototype.columnOrder = $util.emptyArray, n.prototype.selectionMode = $util.emptyArray, n.prototype.rowHeight = null, n.prototype.borderMode = 0;
  let t;
  return Object.defineProperty(n.prototype, "_rowHeight", { get: $util.oneOfGetter(t = ["rowHeight"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(g.data), g.styler != null && Object.hasOwnProperty.call(g, "styler") && $root.Styler.encode(g.styler, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.width != null && Object.hasOwnProperty.call(g, "width") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(g.width), g.height != null && Object.hasOwnProperty.call(g, "height") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(g.height), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.useContainerWidth), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.id), g.columns != null && Object.hasOwnProperty.call(g, "columns") && d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.columns), g.editingMode != null && Object.hasOwnProperty.call(g, "editingMode") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.editingMode), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.formId), g.columnOrder != null && g.columnOrder.length) for (let k = 0; k < g.columnOrder.length; ++k) d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.columnOrder[k]);
    if (g.selectionMode != null && g.selectionMode.length) {
      d.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork();
      for (let k = 0; k < g.selectionMode.length; ++k) d.int32(g.selectionMode[k]);
      d.ldelim();
    }
    return g.rowHeight != null && Object.hasOwnProperty.call(g, "rowHeight") && d.uint32(
      /* id 13, wireType 0 =*/
      104
    ).uint32(g.rowHeight), g.borderMode != null && Object.hasOwnProperty.call(g, "borderMode") && d.uint32(
      /* id 14, wireType 0 =*/
      112
    ).int32(g.borderMode), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Arrow();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.data = g.bytes();
          break;
        }
        case 2: {
          AA.styler = $root.Styler.decode(g, g.uint32());
          break;
        }
        case 3: {
          AA.width = g.uint32();
          break;
        }
        case 4: {
          AA.height = g.uint32();
          break;
        }
        case 5: {
          AA.useContainerWidth = g.bool();
          break;
        }
        case 6: {
          AA.id = g.string();
          break;
        }
        case 7: {
          AA.columns = g.string();
          break;
        }
        case 8: {
          AA.editingMode = g.int32();
          break;
        }
        case 9: {
          AA.disabled = g.bool();
          break;
        }
        case 10: {
          AA.formId = g.string();
          break;
        }
        case 11: {
          AA.columnOrder && AA.columnOrder.length || (AA.columnOrder = []), AA.columnOrder.push(g.string());
          break;
        }
        case 12: {
          if (AA.selectionMode && AA.selectionMode.length || (AA.selectionMode = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.selectionMode.push(g.int32());
          } else AA.selectionMode.push(g.int32());
          break;
        }
        case 13: {
          AA.rowHeight = g.uint32();
          break;
        }
        case 14: {
          AA.borderMode = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data") && !(g.data && typeof g.data.length == "number" || $util.isString(g.data))) return "data: buffer expected";
    if (g.styler != null && g.hasOwnProperty("styler")) {
      let d = $root.Styler.verify(g.styler);
      if (d) return "styler." + d;
    }
    if (g.width != null && g.hasOwnProperty("width") && !$util.isInteger(g.width)) return "width: integer expected";
    if (g.height != null && g.hasOwnProperty("height") && !$util.isInteger(g.height)) return "height: integer expected";
    if (g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && typeof g.useContainerWidth != "boolean") return "useContainerWidth: boolean expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.columns != null && g.hasOwnProperty("columns") && !$util.isString(g.columns)) return "columns: string expected";
    if (g.editingMode != null && g.hasOwnProperty("editingMode")) switch (g.editingMode) {
      default:
        return "editingMode: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util.isString(g.formId)) return "formId: string expected";
    if (g.columnOrder != null && g.hasOwnProperty("columnOrder")) {
      if (!Array.isArray(g.columnOrder)) return "columnOrder: array expected";
      for (let d = 0; d < g.columnOrder.length; ++d) if (!$util.isString(g.columnOrder[d])) return "columnOrder: string[] expected";
    }
    if (g.selectionMode != null && g.hasOwnProperty("selectionMode")) {
      if (!Array.isArray(g.selectionMode)) return "selectionMode: array expected";
      for (let d = 0; d < g.selectionMode.length; ++d) switch (g.selectionMode[d]) {
        default:
          return "selectionMode: enum value[] expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
      }
    }
    if (g.rowHeight != null && g.hasOwnProperty("rowHeight") && !$util.isInteger(g.rowHeight)) return "rowHeight: integer expected";
    if (g.borderMode != null && g.hasOwnProperty("borderMode")) switch (g.borderMode) {
      default:
        return "borderMode: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Arrow) return g;
    let d = new $root.Arrow();
    if (g.data != null && (typeof g.data == "string" ? $util.base64.decode(g.data, d.data = $util.newBuffer($util.base64.length(g.data)), 0) : g.data.length >= 0 && (d.data = g.data)), g.styler != null) {
      if (typeof g.styler != "object") throw TypeError(".Arrow.styler: object expected");
      d.styler = $root.Styler.fromObject(g.styler);
    }
    switch (g.width != null && (d.width = g.width >>> 0), g.height != null && (d.height = g.height >>> 0), g.useContainerWidth != null && (d.useContainerWidth = !!g.useContainerWidth), g.id != null && (d.id = String(g.id)), g.columns != null && (d.columns = String(g.columns)), g.editingMode) {
      default:
        if (typeof g.editingMode == "number") {
          d.editingMode = g.editingMode;
          break;
        }
        break;
      case "READ_ONLY":
      case 0:
        d.editingMode = 0;
        break;
      case "FIXED":
      case 1:
        d.editingMode = 1;
        break;
      case "DYNAMIC":
      case 2:
        d.editingMode = 2;
        break;
    }
    if (g.disabled != null && (d.disabled = !!g.disabled), g.formId != null && (d.formId = String(g.formId)), g.columnOrder) {
      if (!Array.isArray(g.columnOrder)) throw TypeError(".Arrow.columnOrder: array expected");
      d.columnOrder = [];
      for (let k = 0; k < g.columnOrder.length; ++k) d.columnOrder[k] = String(g.columnOrder[k]);
    }
    if (g.selectionMode) {
      if (!Array.isArray(g.selectionMode)) throw TypeError(".Arrow.selectionMode: array expected");
      d.selectionMode = [];
      for (let k = 0; k < g.selectionMode.length; ++k) switch (g.selectionMode[k]) {
        default:
          if (typeof g.selectionMode[k] == "number") {
            d.selectionMode[k] = g.selectionMode[k];
            break;
          }
        case "SINGLE_ROW":
        case 0:
          d.selectionMode[k] = 0;
          break;
        case "MULTI_ROW":
        case 1:
          d.selectionMode[k] = 1;
          break;
        case "SINGLE_COLUMN":
        case 2:
          d.selectionMode[k] = 2;
          break;
        case "MULTI_COLUMN":
        case 3:
          d.selectionMode[k] = 3;
          break;
        case "SINGLE_CELL":
        case 4:
          d.selectionMode[k] = 4;
          break;
        case "MULTI_CELL":
        case 5:
          d.selectionMode[k] = 5;
          break;
      }
    }
    switch (g.rowHeight != null && (d.rowHeight = g.rowHeight >>> 0), g.borderMode) {
      default:
        if (typeof g.borderMode == "number") {
          d.borderMode = g.borderMode;
          break;
        }
        break;
      case "ALL":
      case 0:
        d.borderMode = 0;
        break;
      case "NONE":
      case 1:
        d.borderMode = 1;
        break;
      case "HORIZONTAL":
      case 2:
        d.borderMode = 2;
        break;
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.columnOrder = [], k.selectionMode = []), d.defaults && (d.bytes === String ? k.data = "" : (k.data = [], d.bytes !== Array && (k.data = $util.newBuffer(k.data))), k.styler = null, k.width = 0, k.height = 0, k.useContainerWidth = !1, k.id = "", k.columns = "", k.editingMode = d.enums === String ? "READ_ONLY" : 0, k.disabled = !1, k.formId = "", k.borderMode = d.enums === String ? "ALL" : 0), g.data != null && g.hasOwnProperty("data") && (k.data = d.bytes === String ? $util.base64.encode(g.data, 0, g.data.length) : d.bytes === Array ? Array.prototype.slice.call(g.data) : g.data), g.styler != null && g.hasOwnProperty("styler") && (k.styler = $root.Styler.toObject(g.styler, d)), g.width != null && g.hasOwnProperty("width") && (k.width = g.width), g.height != null && g.hasOwnProperty("height") && (k.height = g.height), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (k.useContainerWidth = g.useContainerWidth), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.columns != null && g.hasOwnProperty("columns") && (k.columns = g.columns), g.editingMode != null && g.hasOwnProperty("editingMode") && (k.editingMode = d.enums === String ? $root.Arrow.EditingMode[g.editingMode] === void 0 ? g.editingMode : $root.Arrow.EditingMode[g.editingMode] : g.editingMode), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.columnOrder && g.columnOrder.length) {
      k.columnOrder = [];
      for (let H = 0; H < g.columnOrder.length; ++H) k.columnOrder[H] = g.columnOrder[H];
    }
    if (g.selectionMode && g.selectionMode.length) {
      k.selectionMode = [];
      for (let H = 0; H < g.selectionMode.length; ++H) k.selectionMode[H] = d.enums === String ? $root.Arrow.SelectionMode[g.selectionMode[H]] === void 0 ? g.selectionMode[H] : $root.Arrow.SelectionMode[g.selectionMode[H]] : g.selectionMode[H];
    }
    return g.rowHeight != null && g.hasOwnProperty("rowHeight") && (k.rowHeight = g.rowHeight, d.oneofs && (k._rowHeight = "rowHeight")), g.borderMode != null && g.hasOwnProperty("borderMode") && (k.borderMode = d.enums === String ? $root.Arrow.BorderMode[g.borderMode] === void 0 ? g.borderMode : $root.Arrow.BorderMode[g.borderMode] : g.borderMode), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Arrow";
  }, n.EditingMode = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "READ_ONLY"] = 0, d[g[1] = "FIXED"] = 1, d[g[2] = "DYNAMIC"] = 2, d;
  })(), n.SelectionMode = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "SINGLE_ROW"] = 0, d[g[1] = "MULTI_ROW"] = 1, d[g[2] = "SINGLE_COLUMN"] = 2, d[g[3] = "MULTI_COLUMN"] = 3, d[g[4] = "SINGLE_CELL"] = 4, d[g[5] = "MULTI_CELL"] = 5, d;
  })(), n.BorderMode = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "ALL"] = 0, d[g[1] = "NONE"] = 1, d[g[2] = "HORIZONTAL"] = 2, d;
  })(), n;
})();
$root.Styler = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.uuid = "", n.prototype.caption = "", n.prototype.styles = "", n.prototype.displayValues = $util.newBuffer([]), n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.uuid != null && Object.hasOwnProperty.call(t, "uuid") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.uuid), t.caption != null && Object.hasOwnProperty.call(t, "caption") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.caption), t.styles != null && Object.hasOwnProperty.call(t, "styles") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.styles), t.displayValues != null && Object.hasOwnProperty.call(t, "displayValues") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(t.displayValues), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Styler();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.uuid = t.string();
          break;
        }
        case 2: {
          H.caption = t.string();
          break;
        }
        case 3: {
          H.styles = t.string();
          break;
        }
        case 4: {
          H.displayValues = t.bytes();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.uuid != null && t.hasOwnProperty("uuid") && !$util.isString(t.uuid) ? "uuid: string expected" : t.caption != null && t.hasOwnProperty("caption") && !$util.isString(t.caption) ? "caption: string expected" : t.styles != null && t.hasOwnProperty("styles") && !$util.isString(t.styles) ? "styles: string expected" : t.displayValues != null && t.hasOwnProperty("displayValues") && !(t.displayValues && typeof t.displayValues.length == "number" || $util.isString(t.displayValues)) ? "displayValues: buffer expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Styler) return t;
    let g = new $root.Styler();
    return t.uuid != null && (g.uuid = String(t.uuid)), t.caption != null && (g.caption = String(t.caption)), t.styles != null && (g.styles = String(t.styles)), t.displayValues != null && (typeof t.displayValues == "string" ? $util.base64.decode(t.displayValues, g.displayValues = $util.newBuffer($util.base64.length(t.displayValues)), 0) : t.displayValues.length >= 0 && (g.displayValues = t.displayValues)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.uuid = "", d.caption = "", d.styles = "", g.bytes === String ? d.displayValues = "" : (d.displayValues = [], g.bytes !== Array && (d.displayValues = $util.newBuffer(d.displayValues)))), t.uuid != null && t.hasOwnProperty("uuid") && (d.uuid = t.uuid), t.caption != null && t.hasOwnProperty("caption") && (d.caption = t.caption), t.styles != null && t.hasOwnProperty("styles") && (d.styles = t.styles), t.displayValues != null && t.hasOwnProperty("displayValues") && (d.displayValues = g.bytes === String ? $util.base64.encode(t.displayValues, 0, t.displayValues.length) : g.bytes === Array ? Array.prototype.slice.call(t.displayValues) : t.displayValues), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Styler";
  }, n;
})();
$root.ArrowNamedDataSet = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.name = "", n.prototype.hasName = !1, n.prototype.data = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.name != null && Object.hasOwnProperty.call(t, "name") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.name), t.data != null && Object.hasOwnProperty.call(t, "data") && $root.Arrow.encode(t.data, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.hasName != null && Object.hasOwnProperty.call(t, "hasName") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(t.hasName), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ArrowNamedDataSet();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.name = t.string();
          break;
        }
        case 3: {
          H.hasName = t.bool();
          break;
        }
        case 2: {
          H.data = $root.Arrow.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name)) return "name: string expected";
    if (t.hasName != null && t.hasOwnProperty("hasName") && typeof t.hasName != "boolean") return "hasName: boolean expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      let g = $root.Arrow.verify(t.data);
      if (g) return "data." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ArrowNamedDataSet) return t;
    let g = new $root.ArrowNamedDataSet();
    if (t.name != null && (g.name = String(t.name)), t.hasName != null && (g.hasName = !!t.hasName), t.data != null) {
      if (typeof t.data != "object") throw TypeError(".ArrowNamedDataSet.data: object expected");
      g.data = $root.Arrow.fromObject(t.data);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.name = "", d.data = null, d.hasName = !1), t.name != null && t.hasOwnProperty("name") && (d.name = t.name), t.data != null && t.hasOwnProperty("data") && (d.data = $root.Arrow.toObject(t.data, g)), t.hasName != null && t.hasOwnProperty("hasName") && (d.hasName = t.hasName), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ArrowNamedDataSet";
  }, n;
})();
$root.ArrowVegaLiteChart = (() => {
  function n(t) {
    if (this.datasets = [], this.selectionMode = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.spec = "", n.prototype.data = null, n.prototype.datasets = $util.emptyArray, n.prototype.useContainerWidth = !1, n.prototype.theme = "", n.prototype.id = "", n.prototype.selectionMode = $util.emptyArray, n.prototype.formId = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.spec != null && Object.hasOwnProperty.call(t, "spec") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.spec), t.data != null && Object.hasOwnProperty.call(t, "data") && $root.Arrow.encode(t.data, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.datasets != null && t.datasets.length) for (let d = 0; d < t.datasets.length; ++d) $root.ArrowNamedDataSet.encode(t.datasets[d], g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    if (t.useContainerWidth != null && Object.hasOwnProperty.call(t, "useContainerWidth") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.useContainerWidth), t.theme != null && Object.hasOwnProperty.call(t, "theme") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.theme), t.id != null && Object.hasOwnProperty.call(t, "id") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.id), t.selectionMode != null && t.selectionMode.length) for (let d = 0; d < t.selectionMode.length; ++d) g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(t.selectionMode[d]);
    return t.formId != null && Object.hasOwnProperty.call(t, "formId") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(t.formId), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ArrowVegaLiteChart();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.spec = t.string();
          break;
        }
        case 2: {
          H.data = $root.Arrow.decode(t, t.uint32());
          break;
        }
        case 4: {
          H.datasets && H.datasets.length || (H.datasets = []), H.datasets.push($root.ArrowNamedDataSet.decode(t, t.uint32()));
          break;
        }
        case 5: {
          H.useContainerWidth = t.bool();
          break;
        }
        case 6: {
          H.theme = t.string();
          break;
        }
        case 7: {
          H.id = t.string();
          break;
        }
        case 8: {
          H.selectionMode && H.selectionMode.length || (H.selectionMode = []), H.selectionMode.push(t.string());
          break;
        }
        case 9: {
          H.formId = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.spec != null && t.hasOwnProperty("spec") && !$util.isString(t.spec)) return "spec: string expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      let g = $root.Arrow.verify(t.data);
      if (g) return "data." + g;
    }
    if (t.datasets != null && t.hasOwnProperty("datasets")) {
      if (!Array.isArray(t.datasets)) return "datasets: array expected";
      for (let g = 0; g < t.datasets.length; ++g) {
        let d = $root.ArrowNamedDataSet.verify(t.datasets[g]);
        if (d) return "datasets." + d;
      }
    }
    if (t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && typeof t.useContainerWidth != "boolean") return "useContainerWidth: boolean expected";
    if (t.theme != null && t.hasOwnProperty("theme") && !$util.isString(t.theme)) return "theme: string expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id)) return "id: string expected";
    if (t.selectionMode != null && t.hasOwnProperty("selectionMode")) {
      if (!Array.isArray(t.selectionMode)) return "selectionMode: array expected";
      for (let g = 0; g < t.selectionMode.length; ++g) if (!$util.isString(t.selectionMode[g])) return "selectionMode: string[] expected";
    }
    return t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId) ? "formId: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ArrowVegaLiteChart) return t;
    let g = new $root.ArrowVegaLiteChart();
    if (t.spec != null && (g.spec = String(t.spec)), t.data != null) {
      if (typeof t.data != "object") throw TypeError(".ArrowVegaLiteChart.data: object expected");
      g.data = $root.Arrow.fromObject(t.data);
    }
    if (t.datasets) {
      if (!Array.isArray(t.datasets)) throw TypeError(".ArrowVegaLiteChart.datasets: array expected");
      g.datasets = [];
      for (let d = 0; d < t.datasets.length; ++d) {
        if (typeof t.datasets[d] != "object") throw TypeError(".ArrowVegaLiteChart.datasets: object expected");
        g.datasets[d] = $root.ArrowNamedDataSet.fromObject(t.datasets[d]);
      }
    }
    if (t.useContainerWidth != null && (g.useContainerWidth = !!t.useContainerWidth), t.theme != null && (g.theme = String(t.theme)), t.id != null && (g.id = String(t.id)), t.selectionMode) {
      if (!Array.isArray(t.selectionMode)) throw TypeError(".ArrowVegaLiteChart.selectionMode: array expected");
      g.selectionMode = [];
      for (let d = 0; d < t.selectionMode.length; ++d) g.selectionMode[d] = String(t.selectionMode[d]);
    }
    return t.formId != null && (g.formId = String(t.formId)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.datasets = [], d.selectionMode = []), g.defaults && (d.spec = "", d.data = null, d.useContainerWidth = !1, d.theme = "", d.id = "", d.formId = ""), t.spec != null && t.hasOwnProperty("spec") && (d.spec = t.spec), t.data != null && t.hasOwnProperty("data") && (d.data = $root.Arrow.toObject(t.data, g)), t.datasets && t.datasets.length) {
      d.datasets = [];
      for (let k = 0; k < t.datasets.length; ++k) d.datasets[k] = $root.ArrowNamedDataSet.toObject(t.datasets[k], g);
    }
    if (t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && (d.useContainerWidth = t.useContainerWidth), t.theme != null && t.hasOwnProperty("theme") && (d.theme = t.theme), t.id != null && t.hasOwnProperty("id") && (d.id = t.id), t.selectionMode && t.selectionMode.length) {
      d.selectionMode = [];
      for (let k = 0; k < t.selectionMode.length; ++k) d.selectionMode[k] = t.selectionMode[k];
    }
    return t.formId != null && t.hasOwnProperty("formId") && (d.formId = t.formId), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ArrowVegaLiteChart";
  }, n;
})();
$root.Audio = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.url = "", n.prototype.startTime = 0, n.prototype.endTime = 0, n.prototype.loop = !1, n.prototype.autoplay = !1, n.prototype.id = "", n.prototype.widthConfig = null;
  let t;
  return Object.defineProperty(n.prototype, "_widthConfig", { get: $util.oneOfGetter(t = ["widthConfig"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.startTime != null && Object.hasOwnProperty.call(g, "startTime") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.startTime), g.url != null && Object.hasOwnProperty.call(g, "url") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.url), g.endTime != null && Object.hasOwnProperty.call(g, "endTime") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(g.endTime), g.loop != null && Object.hasOwnProperty.call(g, "loop") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.loop), g.autoplay != null && Object.hasOwnProperty.call(g, "autoplay") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.autoplay), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.id), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root.streamlit.WidthConfig.encode(g.widthConfig, d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Audio();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 5: {
          AA.url = g.string();
          break;
        }
        case 3: {
          AA.startTime = g.int32();
          break;
        }
        case 6: {
          AA.endTime = g.int32();
          break;
        }
        case 7: {
          AA.loop = g.bool();
          break;
        }
        case 8: {
          AA.autoplay = g.bool();
          break;
        }
        case 9: {
          AA.id = g.string();
          break;
        }
        case 10: {
          AA.widthConfig = $root.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.url != null && g.hasOwnProperty("url") && !$util.isString(g.url)) return "url: string expected";
    if (g.startTime != null && g.hasOwnProperty("startTime") && !$util.isInteger(g.startTime)) return "startTime: integer expected";
    if (g.endTime != null && g.hasOwnProperty("endTime") && !$util.isInteger(g.endTime)) return "endTime: integer expected";
    if (g.loop != null && g.hasOwnProperty("loop") && typeof g.loop != "boolean") return "loop: boolean expected";
    if (g.autoplay != null && g.hasOwnProperty("autoplay") && typeof g.autoplay != "boolean") return "autoplay: boolean expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.widthConfig != null && g.hasOwnProperty("widthConfig")) {
      let d = $root.streamlit.WidthConfig.verify(g.widthConfig);
      if (d) return "widthConfig." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Audio) return g;
    let d = new $root.Audio();
    if (g.url != null && (d.url = String(g.url)), g.startTime != null && (d.startTime = g.startTime | 0), g.endTime != null && (d.endTime = g.endTime | 0), g.loop != null && (d.loop = !!g.loop), g.autoplay != null && (d.autoplay = !!g.autoplay), g.id != null && (d.id = String(g.id)), g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Audio.widthConfig: object expected");
      d.widthConfig = $root.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.startTime = 0, k.url = "", k.endTime = 0, k.loop = !1, k.autoplay = !1, k.id = ""), g.startTime != null && g.hasOwnProperty("startTime") && (k.startTime = g.startTime), g.url != null && g.hasOwnProperty("url") && (k.url = g.url), g.endTime != null && g.hasOwnProperty("endTime") && (k.endTime = g.endTime), g.loop != null && g.hasOwnProperty("loop") && (k.loop = g.loop), g.autoplay != null && g.hasOwnProperty("autoplay") && (k.autoplay = g.autoplay), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (k.widthConfig = $root.streamlit.WidthConfig.toObject(g.widthConfig, d), d.oneofs && (k._widthConfig = "widthConfig")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Audio";
  }, n;
})();
$root.AudioInput = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.help = "", n.prototype.formId = "", n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.sampleRate = null;
  let t;
  return Object.defineProperty(n.prototype, "_sampleRate", { get: $util.oneOfGetter(t = ["sampleRate"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.formId), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.sampleRate != null && Object.hasOwnProperty.call(g, "sampleRate") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(g.sampleRate), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.AudioInput();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.help = g.string();
          break;
        }
        case 4: {
          AA.formId = g.string();
          break;
        }
        case 5: {
          AA.disabled = g.bool();
          break;
        }
        case 6: {
          AA.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 7: {
          AA.sampleRate = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util.isString(g.label)) return "label: string expected";
    if (g.help != null && g.hasOwnProperty("help") && !$util.isString(g.help)) return "help: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util.isString(g.formId)) return "formId: string expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    return g.sampleRate != null && g.hasOwnProperty("sampleRate") && !$util.isInteger(g.sampleRate) ? "sampleRate: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.AudioInput) return g;
    let d = new $root.AudioInput();
    if (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".AudioInput.labelVisibility: object expected");
      d.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.sampleRate != null && (d.sampleRate = g.sampleRate | 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.id = "", k.label = "", k.help = "", k.formId = "", k.disabled = !1, k.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.sampleRate != null && g.hasOwnProperty("sampleRate") && (k.sampleRate = g.sampleRate, d.oneofs && (k._sampleRate = "sampleRate")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/AudioInput";
  }, n;
})();
$root.LabelVisibilityMessage = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.value = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.value != null && Object.hasOwnProperty.call(t, "value") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(t.value), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.LabelVisibilityMessage();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.value = t.int32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.value != null && t.hasOwnProperty("value")) switch (t.value) {
      default:
        return "value: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.LabelVisibilityMessage) return t;
    let g = new $root.LabelVisibilityMessage();
    switch (t.value) {
      default:
        if (typeof t.value == "number") {
          g.value = t.value;
          break;
        }
        break;
      case "VISIBLE":
      case 0:
        g.value = 0;
        break;
      case "HIDDEN":
      case 1:
        g.value = 1;
        break;
      case "COLLAPSED":
      case 2:
        g.value = 2;
        break;
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.value = g.enums === String ? "VISIBLE" : 0), t.value != null && t.hasOwnProperty("value") && (d.value = g.enums === String ? $root.LabelVisibilityMessage.LabelVisibilityOptions[t.value] === void 0 ? t.value : $root.LabelVisibilityMessage.LabelVisibilityOptions[t.value] : t.value), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/LabelVisibilityMessage";
  }, n.LabelVisibilityOptions = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "VISIBLE"] = 0, g[t[1] = "HIDDEN"] = 1, g[t[2] = "COLLAPSED"] = 2, g;
  })(), n;
})();
$root.AuthRedirect = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.url = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.url != null && Object.hasOwnProperty.call(t, "url") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.url), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.AuthRedirect();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.url = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.url != null && t.hasOwnProperty("url") && !$util.isString(t.url) ? "url: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.AuthRedirect) return t;
    let g = new $root.AuthRedirect();
    return t.url != null && (g.url = String(t.url)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.url = ""), t.url != null && t.hasOwnProperty("url") && (d.url = t.url), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/AuthRedirect";
  }, n;
})();
$root.AutoRerun = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.interval = 0, n.prototype.fragmentId = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.interval != null && Object.hasOwnProperty.call(t, "interval") && g.uint32(
      /* id 1, wireType 5 =*/
      13
    ).float(t.interval), t.fragmentId != null && Object.hasOwnProperty.call(t, "fragmentId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.fragmentId), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.AutoRerun();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.interval = t.float();
          break;
        }
        case 2: {
          H.fragmentId = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.interval != null && t.hasOwnProperty("interval") && typeof t.interval != "number" ? "interval: number expected" : t.fragmentId != null && t.hasOwnProperty("fragmentId") && !$util.isString(t.fragmentId) ? "fragmentId: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.AutoRerun) return t;
    let g = new $root.AutoRerun();
    return t.interval != null && (g.interval = Number(t.interval)), t.fragmentId != null && (g.fragmentId = String(t.fragmentId)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.interval = 0, d.fragmentId = ""), t.interval != null && t.hasOwnProperty("interval") && (d.interval = g.json && !isFinite(t.interval) ? String(t.interval) : t.interval), t.fragmentId != null && t.hasOwnProperty("fragmentId") && (d.fragmentId = t.fragmentId), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/AutoRerun";
  }, n;
})();
$root.BackMsg = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.clearCache = null, n.prototype.setRunOnSave = null, n.prototype.stopScript = null, n.prototype.rerunScript = null, n.prototype.loadGitInfo = null, n.prototype.debugDisconnectWebsocket = null, n.prototype.debugShutdownRuntime = null, n.prototype.fileUrlsRequest = null, n.prototype.appHeartbeat = null, n.prototype.debugLastBackmsgId = "";
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util.oneOfGetter(t = ["clearCache", "setRunOnSave", "stopScript", "rerunScript", "loadGitInfo", "debugDisconnectWebsocket", "debugShutdownRuntime", "fileUrlsRequest", "appHeartbeat"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.clearCache != null && Object.hasOwnProperty.call(g, "clearCache") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.clearCache), g.setRunOnSave != null && Object.hasOwnProperty.call(g, "setRunOnSave") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.setRunOnSave), g.stopScript != null && Object.hasOwnProperty.call(g, "stopScript") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.stopScript), g.rerunScript != null && Object.hasOwnProperty.call(g, "rerunScript") && $root.ClientState.encode(g.rerunScript, d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.loadGitInfo != null && Object.hasOwnProperty.call(g, "loadGitInfo") && d.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.loadGitInfo), g.debugLastBackmsgId != null && Object.hasOwnProperty.call(g, "debugLastBackmsgId") && d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.debugLastBackmsgId), g.debugDisconnectWebsocket != null && Object.hasOwnProperty.call(g, "debugDisconnectWebsocket") && d.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(g.debugDisconnectWebsocket), g.debugShutdownRuntime != null && Object.hasOwnProperty.call(g, "debugShutdownRuntime") && d.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(g.debugShutdownRuntime), g.fileUrlsRequest != null && Object.hasOwnProperty.call(g, "fileUrlsRequest") && $root.FileURLsRequest.encode(g.fileUrlsRequest, d.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.appHeartbeat != null && Object.hasOwnProperty.call(g, "appHeartbeat") && d.uint32(
      /* id 17, wireType 0 =*/
      136
    ).bool(g.appHeartbeat), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.BackMsg();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 5: {
          AA.clearCache = g.bool();
          break;
        }
        case 6: {
          AA.setRunOnSave = g.bool();
          break;
        }
        case 7: {
          AA.stopScript = g.bool();
          break;
        }
        case 11: {
          AA.rerunScript = $root.ClientState.decode(g, g.uint32());
          break;
        }
        case 12: {
          AA.loadGitInfo = g.bool();
          break;
        }
        case 14: {
          AA.debugDisconnectWebsocket = g.bool();
          break;
        }
        case 15: {
          AA.debugShutdownRuntime = g.bool();
          break;
        }
        case 16: {
          AA.fileUrlsRequest = $root.FileURLsRequest.decode(g, g.uint32());
          break;
        }
        case 17: {
          AA.appHeartbeat = g.bool();
          break;
        }
        case 13: {
          AA.debugLastBackmsgId = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.clearCache != null && g.hasOwnProperty("clearCache") && (d.type = 1, typeof g.clearCache != "boolean")) return "clearCache: boolean expected";
    if (g.setRunOnSave != null && g.hasOwnProperty("setRunOnSave")) {
      if (d.type === 1) return "type: multiple values";
      if (d.type = 1, typeof g.setRunOnSave != "boolean") return "setRunOnSave: boolean expected";
    }
    if (g.stopScript != null && g.hasOwnProperty("stopScript")) {
      if (d.type === 1) return "type: multiple values";
      if (d.type = 1, typeof g.stopScript != "boolean") return "stopScript: boolean expected";
    }
    if (g.rerunScript != null && g.hasOwnProperty("rerunScript")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.ClientState.verify(g.rerunScript);
        if (k) return "rerunScript." + k;
      }
    }
    if (g.loadGitInfo != null && g.hasOwnProperty("loadGitInfo")) {
      if (d.type === 1) return "type: multiple values";
      if (d.type = 1, typeof g.loadGitInfo != "boolean") return "loadGitInfo: boolean expected";
    }
    if (g.debugDisconnectWebsocket != null && g.hasOwnProperty("debugDisconnectWebsocket")) {
      if (d.type === 1) return "type: multiple values";
      if (d.type = 1, typeof g.debugDisconnectWebsocket != "boolean") return "debugDisconnectWebsocket: boolean expected";
    }
    if (g.debugShutdownRuntime != null && g.hasOwnProperty("debugShutdownRuntime")) {
      if (d.type === 1) return "type: multiple values";
      if (d.type = 1, typeof g.debugShutdownRuntime != "boolean") return "debugShutdownRuntime: boolean expected";
    }
    if (g.fileUrlsRequest != null && g.hasOwnProperty("fileUrlsRequest")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.FileURLsRequest.verify(g.fileUrlsRequest);
        if (k) return "fileUrlsRequest." + k;
      }
    }
    if (g.appHeartbeat != null && g.hasOwnProperty("appHeartbeat")) {
      if (d.type === 1) return "type: multiple values";
      if (d.type = 1, typeof g.appHeartbeat != "boolean") return "appHeartbeat: boolean expected";
    }
    return g.debugLastBackmsgId != null && g.hasOwnProperty("debugLastBackmsgId") && !$util.isString(g.debugLastBackmsgId) ? "debugLastBackmsgId: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.BackMsg) return g;
    let d = new $root.BackMsg();
    if (g.clearCache != null && (d.clearCache = !!g.clearCache), g.setRunOnSave != null && (d.setRunOnSave = !!g.setRunOnSave), g.stopScript != null && (d.stopScript = !!g.stopScript), g.rerunScript != null) {
      if (typeof g.rerunScript != "object") throw TypeError(".BackMsg.rerunScript: object expected");
      d.rerunScript = $root.ClientState.fromObject(g.rerunScript);
    }
    if (g.loadGitInfo != null && (d.loadGitInfo = !!g.loadGitInfo), g.debugDisconnectWebsocket != null && (d.debugDisconnectWebsocket = !!g.debugDisconnectWebsocket), g.debugShutdownRuntime != null && (d.debugShutdownRuntime = !!g.debugShutdownRuntime), g.fileUrlsRequest != null) {
      if (typeof g.fileUrlsRequest != "object") throw TypeError(".BackMsg.fileUrlsRequest: object expected");
      d.fileUrlsRequest = $root.FileURLsRequest.fromObject(g.fileUrlsRequest);
    }
    return g.appHeartbeat != null && (d.appHeartbeat = !!g.appHeartbeat), g.debugLastBackmsgId != null && (d.debugLastBackmsgId = String(g.debugLastBackmsgId)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.debugLastBackmsgId = ""), g.clearCache != null && g.hasOwnProperty("clearCache") && (k.clearCache = g.clearCache, d.oneofs && (k.type = "clearCache")), g.setRunOnSave != null && g.hasOwnProperty("setRunOnSave") && (k.setRunOnSave = g.setRunOnSave, d.oneofs && (k.type = "setRunOnSave")), g.stopScript != null && g.hasOwnProperty("stopScript") && (k.stopScript = g.stopScript, d.oneofs && (k.type = "stopScript")), g.rerunScript != null && g.hasOwnProperty("rerunScript") && (k.rerunScript = $root.ClientState.toObject(g.rerunScript, d), d.oneofs && (k.type = "rerunScript")), g.loadGitInfo != null && g.hasOwnProperty("loadGitInfo") && (k.loadGitInfo = g.loadGitInfo, d.oneofs && (k.type = "loadGitInfo")), g.debugLastBackmsgId != null && g.hasOwnProperty("debugLastBackmsgId") && (k.debugLastBackmsgId = g.debugLastBackmsgId), g.debugDisconnectWebsocket != null && g.hasOwnProperty("debugDisconnectWebsocket") && (k.debugDisconnectWebsocket = g.debugDisconnectWebsocket, d.oneofs && (k.type = "debugDisconnectWebsocket")), g.debugShutdownRuntime != null && g.hasOwnProperty("debugShutdownRuntime") && (k.debugShutdownRuntime = g.debugShutdownRuntime, d.oneofs && (k.type = "debugShutdownRuntime")), g.fileUrlsRequest != null && g.hasOwnProperty("fileUrlsRequest") && (k.fileUrlsRequest = $root.FileURLsRequest.toObject(g.fileUrlsRequest, d), d.oneofs && (k.type = "fileUrlsRequest")), g.appHeartbeat != null && g.hasOwnProperty("appHeartbeat") && (k.appHeartbeat = g.appHeartbeat, d.oneofs && (k.type = "appHeartbeat")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/BackMsg";
  }, n;
})();
$root.ContextInfo = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.timezone = null, n.prototype.timezoneOffset = null, n.prototype.locale = null, n.prototype.url = null, n.prototype.isEmbedded = null, n.prototype.colorScheme = null;
  let t;
  return Object.defineProperty(n.prototype, "_timezone", { get: $util.oneOfGetter(t = ["timezone"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_timezoneOffset", { get: $util.oneOfGetter(t = ["timezoneOffset"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_locale", { get: $util.oneOfGetter(t = ["locale"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_url", { get: $util.oneOfGetter(t = ["url"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_isEmbedded", { get: $util.oneOfGetter(t = ["isEmbedded"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_colorScheme", { get: $util.oneOfGetter(t = ["colorScheme"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.timezone != null && Object.hasOwnProperty.call(g, "timezone") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.timezone), g.timezoneOffset != null && Object.hasOwnProperty.call(g, "timezoneOffset") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.timezoneOffset), g.locale != null && Object.hasOwnProperty.call(g, "locale") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.locale), g.url != null && Object.hasOwnProperty.call(g, "url") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.url), g.isEmbedded != null && Object.hasOwnProperty.call(g, "isEmbedded") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.isEmbedded), g.colorScheme != null && Object.hasOwnProperty.call(g, "colorScheme") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.colorScheme), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.ContextInfo();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.timezone = g.string();
          break;
        }
        case 2: {
          AA.timezoneOffset = g.int32();
          break;
        }
        case 3: {
          AA.locale = g.string();
          break;
        }
        case 4: {
          AA.url = g.string();
          break;
        }
        case 5: {
          AA.isEmbedded = g.bool();
          break;
        }
        case 6: {
          AA.colorScheme = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.timezone != null && g.hasOwnProperty("timezone") && !$util.isString(g.timezone) ? "timezone: string expected" : g.timezoneOffset != null && g.hasOwnProperty("timezoneOffset") && !$util.isInteger(g.timezoneOffset) ? "timezoneOffset: integer expected" : g.locale != null && g.hasOwnProperty("locale") && !$util.isString(g.locale) ? "locale: string expected" : g.url != null && g.hasOwnProperty("url") && !$util.isString(g.url) ? "url: string expected" : g.isEmbedded != null && g.hasOwnProperty("isEmbedded") && typeof g.isEmbedded != "boolean" ? "isEmbedded: boolean expected" : g.colorScheme != null && g.hasOwnProperty("colorScheme") && !$util.isString(g.colorScheme) ? "colorScheme: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.ContextInfo) return g;
    let d = new $root.ContextInfo();
    return g.timezone != null && (d.timezone = String(g.timezone)), g.timezoneOffset != null && (d.timezoneOffset = g.timezoneOffset | 0), g.locale != null && (d.locale = String(g.locale)), g.url != null && (d.url = String(g.url)), g.isEmbedded != null && (d.isEmbedded = !!g.isEmbedded), g.colorScheme != null && (d.colorScheme = String(g.colorScheme)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return g.timezone != null && g.hasOwnProperty("timezone") && (k.timezone = g.timezone, d.oneofs && (k._timezone = "timezone")), g.timezoneOffset != null && g.hasOwnProperty("timezoneOffset") && (k.timezoneOffset = g.timezoneOffset, d.oneofs && (k._timezoneOffset = "timezoneOffset")), g.locale != null && g.hasOwnProperty("locale") && (k.locale = g.locale, d.oneofs && (k._locale = "locale")), g.url != null && g.hasOwnProperty("url") && (k.url = g.url, d.oneofs && (k._url = "url")), g.isEmbedded != null && g.hasOwnProperty("isEmbedded") && (k.isEmbedded = g.isEmbedded, d.oneofs && (k._isEmbedded = "isEmbedded")), g.colorScheme != null && g.hasOwnProperty("colorScheme") && (k.colorScheme = g.colorScheme, d.oneofs && (k._colorScheme = "colorScheme")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ContextInfo";
  }, n;
})();
$root.ClientState = (() => {
  function n(t) {
    if (this.cachedMessageHashes = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.queryString = "", n.prototype.widgetStates = null, n.prototype.pageScriptHash = "", n.prototype.pageName = "", n.prototype.fragmentId = "", n.prototype.isAutoRerun = !1, n.prototype.cachedMessageHashes = $util.emptyArray, n.prototype.contextInfo = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.queryString != null && Object.hasOwnProperty.call(t, "queryString") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.queryString), t.widgetStates != null && Object.hasOwnProperty.call(t, "widgetStates") && $root.WidgetStates.encode(t.widgetStates, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.pageScriptHash != null && Object.hasOwnProperty.call(t, "pageScriptHash") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.pageScriptHash), t.pageName != null && Object.hasOwnProperty.call(t, "pageName") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.pageName), t.fragmentId != null && Object.hasOwnProperty.call(t, "fragmentId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.fragmentId), t.isAutoRerun != null && Object.hasOwnProperty.call(t, "isAutoRerun") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(t.isAutoRerun), t.cachedMessageHashes != null && t.cachedMessageHashes.length) for (let d = 0; d < t.cachedMessageHashes.length; ++d) g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.cachedMessageHashes[d]);
    return t.contextInfo != null && Object.hasOwnProperty.call(t, "contextInfo") && $root.ContextInfo.encode(t.contextInfo, g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ClientState();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.queryString = t.string();
          break;
        }
        case 2: {
          H.widgetStates = $root.WidgetStates.decode(t, t.uint32());
          break;
        }
        case 3: {
          H.pageScriptHash = t.string();
          break;
        }
        case 4: {
          H.pageName = t.string();
          break;
        }
        case 5: {
          H.fragmentId = t.string();
          break;
        }
        case 6: {
          H.isAutoRerun = t.bool();
          break;
        }
        case 7: {
          H.cachedMessageHashes && H.cachedMessageHashes.length || (H.cachedMessageHashes = []), H.cachedMessageHashes.push(t.string());
          break;
        }
        case 8: {
          H.contextInfo = $root.ContextInfo.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.queryString != null && t.hasOwnProperty("queryString") && !$util.isString(t.queryString)) return "queryString: string expected";
    if (t.widgetStates != null && t.hasOwnProperty("widgetStates")) {
      let g = $root.WidgetStates.verify(t.widgetStates);
      if (g) return "widgetStates." + g;
    }
    if (t.pageScriptHash != null && t.hasOwnProperty("pageScriptHash") && !$util.isString(t.pageScriptHash)) return "pageScriptHash: string expected";
    if (t.pageName != null && t.hasOwnProperty("pageName") && !$util.isString(t.pageName)) return "pageName: string expected";
    if (t.fragmentId != null && t.hasOwnProperty("fragmentId") && !$util.isString(t.fragmentId)) return "fragmentId: string expected";
    if (t.isAutoRerun != null && t.hasOwnProperty("isAutoRerun") && typeof t.isAutoRerun != "boolean") return "isAutoRerun: boolean expected";
    if (t.cachedMessageHashes != null && t.hasOwnProperty("cachedMessageHashes")) {
      if (!Array.isArray(t.cachedMessageHashes)) return "cachedMessageHashes: array expected";
      for (let g = 0; g < t.cachedMessageHashes.length; ++g) if (!$util.isString(t.cachedMessageHashes[g])) return "cachedMessageHashes: string[] expected";
    }
    if (t.contextInfo != null && t.hasOwnProperty("contextInfo")) {
      let g = $root.ContextInfo.verify(t.contextInfo);
      if (g) return "contextInfo." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ClientState) return t;
    let g = new $root.ClientState();
    if (t.queryString != null && (g.queryString = String(t.queryString)), t.widgetStates != null) {
      if (typeof t.widgetStates != "object") throw TypeError(".ClientState.widgetStates: object expected");
      g.widgetStates = $root.WidgetStates.fromObject(t.widgetStates);
    }
    if (t.pageScriptHash != null && (g.pageScriptHash = String(t.pageScriptHash)), t.pageName != null && (g.pageName = String(t.pageName)), t.fragmentId != null && (g.fragmentId = String(t.fragmentId)), t.isAutoRerun != null && (g.isAutoRerun = !!t.isAutoRerun), t.cachedMessageHashes) {
      if (!Array.isArray(t.cachedMessageHashes)) throw TypeError(".ClientState.cachedMessageHashes: array expected");
      g.cachedMessageHashes = [];
      for (let d = 0; d < t.cachedMessageHashes.length; ++d) g.cachedMessageHashes[d] = String(t.cachedMessageHashes[d]);
    }
    if (t.contextInfo != null) {
      if (typeof t.contextInfo != "object") throw TypeError(".ClientState.contextInfo: object expected");
      g.contextInfo = $root.ContextInfo.fromObject(t.contextInfo);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.cachedMessageHashes = []), g.defaults && (d.queryString = "", d.widgetStates = null, d.pageScriptHash = "", d.pageName = "", d.fragmentId = "", d.isAutoRerun = !1, d.contextInfo = null), t.queryString != null && t.hasOwnProperty("queryString") && (d.queryString = t.queryString), t.widgetStates != null && t.hasOwnProperty("widgetStates") && (d.widgetStates = $root.WidgetStates.toObject(t.widgetStates, g)), t.pageScriptHash != null && t.hasOwnProperty("pageScriptHash") && (d.pageScriptHash = t.pageScriptHash), t.pageName != null && t.hasOwnProperty("pageName") && (d.pageName = t.pageName), t.fragmentId != null && t.hasOwnProperty("fragmentId") && (d.fragmentId = t.fragmentId), t.isAutoRerun != null && t.hasOwnProperty("isAutoRerun") && (d.isAutoRerun = t.isAutoRerun), t.cachedMessageHashes && t.cachedMessageHashes.length) {
      d.cachedMessageHashes = [];
      for (let k = 0; k < t.cachedMessageHashes.length; ++k) d.cachedMessageHashes[k] = t.cachedMessageHashes[k];
    }
    return t.contextInfo != null && t.hasOwnProperty("contextInfo") && (d.contextInfo = $root.ContextInfo.toObject(t.contextInfo, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ClientState";
  }, n;
})();
$root.WidgetStates = (() => {
  function n(t) {
    if (this.widgets = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.widgets = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.widgets != null && t.widgets.length) for (let d = 0; d < t.widgets.length; ++d) $root.WidgetState.encode(t.widgets[d], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.WidgetStates();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.widgets && H.widgets.length || (H.widgets = []), H.widgets.push($root.WidgetState.decode(t, t.uint32()));
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.widgets != null && t.hasOwnProperty("widgets")) {
      if (!Array.isArray(t.widgets)) return "widgets: array expected";
      for (let g = 0; g < t.widgets.length; ++g) {
        let d = $root.WidgetState.verify(t.widgets[g]);
        if (d) return "widgets." + d;
      }
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.WidgetStates) return t;
    let g = new $root.WidgetStates();
    if (t.widgets) {
      if (!Array.isArray(t.widgets)) throw TypeError(".WidgetStates.widgets: array expected");
      g.widgets = [];
      for (let d = 0; d < t.widgets.length; ++d) {
        if (typeof t.widgets[d] != "object") throw TypeError(".WidgetStates.widgets: object expected");
        g.widgets[d] = $root.WidgetState.fromObject(t.widgets[d]);
      }
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.widgets = []), t.widgets && t.widgets.length) {
      d.widgets = [];
      for (let k = 0; k < t.widgets.length; ++k) d.widgets[k] = $root.WidgetState.toObject(t.widgets[k], g);
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/WidgetStates";
  }, n;
})();
$root.WidgetState = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.triggerValue = null, n.prototype.boolValue = null, n.prototype.doubleValue = null, n.prototype.intValue = null, n.prototype.stringValue = null, n.prototype.doubleArrayValue = null, n.prototype.intArrayValue = null, n.prototype.stringArrayValue = null, n.prototype.jsonValue = null, n.prototype.arrowValue = null, n.prototype.bytesValue = null, n.prototype.fileUploaderStateValue = null, n.prototype.stringTriggerValue = null, n.prototype.chatInputValue = null;
  let t;
  return Object.defineProperty(n.prototype, "value", { get: $util.oneOfGetter(t = ["triggerValue", "boolValue", "doubleValue", "intValue", "stringValue", "doubleArrayValue", "intArrayValue", "stringArrayValue", "jsonValue", "arrowValue", "bytesValue", "fileUploaderStateValue", "stringTriggerValue", "chatInputValue"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.triggerValue != null && Object.hasOwnProperty.call(g, "triggerValue") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.triggerValue), g.boolValue != null && Object.hasOwnProperty.call(g, "boolValue") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(g.boolValue), g.doubleValue != null && Object.hasOwnProperty.call(g, "doubleValue") && d.uint32(
      /* id 4, wireType 1 =*/
      33
    ).double(g.doubleValue), g.intValue != null && Object.hasOwnProperty.call(g, "intValue") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).sint64(g.intValue), g.stringValue != null && Object.hasOwnProperty.call(g, "stringValue") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.stringValue), g.doubleArrayValue != null && Object.hasOwnProperty.call(g, "doubleArrayValue") && $root.DoubleArray.encode(g.doubleArrayValue, d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.intArrayValue != null && Object.hasOwnProperty.call(g, "intArrayValue") && $root.SInt64Array.encode(g.intArrayValue, d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), g.stringArrayValue != null && Object.hasOwnProperty.call(g, "stringArrayValue") && $root.StringArray.encode(g.stringArrayValue, d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.jsonValue != null && Object.hasOwnProperty.call(g, "jsonValue") && d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.jsonValue), g.arrowValue != null && Object.hasOwnProperty.call(g, "arrowValue") && $root.ArrowTable.encode(g.arrowValue, d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.bytesValue != null && Object.hasOwnProperty.call(g, "bytesValue") && d.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(g.bytesValue), g.fileUploaderStateValue != null && Object.hasOwnProperty.call(g, "fileUploaderStateValue") && $root.FileUploaderState.encode(g.fileUploaderStateValue, d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.stringTriggerValue != null && Object.hasOwnProperty.call(g, "stringTriggerValue") && $root.StringTriggerValue.encode(g.stringTriggerValue, d.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), g.chatInputValue != null && Object.hasOwnProperty.call(g, "chatInputValue") && $root.ChatInputValue.encode(g.chatInputValue, d.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.WidgetState();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.triggerValue = g.bool();
          break;
        }
        case 3: {
          AA.boolValue = g.bool();
          break;
        }
        case 4: {
          AA.doubleValue = g.double();
          break;
        }
        case 5: {
          AA.intValue = g.sint64();
          break;
        }
        case 6: {
          AA.stringValue = g.string();
          break;
        }
        case 7: {
          AA.doubleArrayValue = $root.DoubleArray.decode(g, g.uint32());
          break;
        }
        case 8: {
          AA.intArrayValue = $root.SInt64Array.decode(g, g.uint32());
          break;
        }
        case 9: {
          AA.stringArrayValue = $root.StringArray.decode(g, g.uint32());
          break;
        }
        case 10: {
          AA.jsonValue = g.string();
          break;
        }
        case 11: {
          AA.arrowValue = $root.ArrowTable.decode(g, g.uint32());
          break;
        }
        case 12: {
          AA.bytesValue = g.bytes();
          break;
        }
        case 13: {
          AA.fileUploaderStateValue = $root.FileUploaderState.decode(g, g.uint32());
          break;
        }
        case 14: {
          AA.stringTriggerValue = $root.StringTriggerValue.decode(g, g.uint32());
          break;
        }
        case 15: {
          AA.chatInputValue = $root.ChatInputValue.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.triggerValue != null && g.hasOwnProperty("triggerValue") && (d.value = 1, typeof g.triggerValue != "boolean")) return "triggerValue: boolean expected";
    if (g.boolValue != null && g.hasOwnProperty("boolValue")) {
      if (d.value === 1) return "value: multiple values";
      if (d.value = 1, typeof g.boolValue != "boolean") return "boolValue: boolean expected";
    }
    if (g.doubleValue != null && g.hasOwnProperty("doubleValue")) {
      if (d.value === 1) return "value: multiple values";
      if (d.value = 1, typeof g.doubleValue != "number") return "doubleValue: number expected";
    }
    if (g.intValue != null && g.hasOwnProperty("intValue")) {
      if (d.value === 1) return "value: multiple values";
      if (d.value = 1, !$util.isInteger(g.intValue) && !(g.intValue && $util.isInteger(g.intValue.low) && $util.isInteger(g.intValue.high))) return "intValue: integer|Long expected";
    }
    if (g.stringValue != null && g.hasOwnProperty("stringValue")) {
      if (d.value === 1) return "value: multiple values";
      if (d.value = 1, !$util.isString(g.stringValue)) return "stringValue: string expected";
    }
    if (g.doubleArrayValue != null && g.hasOwnProperty("doubleArrayValue")) {
      if (d.value === 1) return "value: multiple values";
      d.value = 1;
      {
        let k = $root.DoubleArray.verify(g.doubleArrayValue);
        if (k) return "doubleArrayValue." + k;
      }
    }
    if (g.intArrayValue != null && g.hasOwnProperty("intArrayValue")) {
      if (d.value === 1) return "value: multiple values";
      d.value = 1;
      {
        let k = $root.SInt64Array.verify(g.intArrayValue);
        if (k) return "intArrayValue." + k;
      }
    }
    if (g.stringArrayValue != null && g.hasOwnProperty("stringArrayValue")) {
      if (d.value === 1) return "value: multiple values";
      d.value = 1;
      {
        let k = $root.StringArray.verify(g.stringArrayValue);
        if (k) return "stringArrayValue." + k;
      }
    }
    if (g.jsonValue != null && g.hasOwnProperty("jsonValue")) {
      if (d.value === 1) return "value: multiple values";
      if (d.value = 1, !$util.isString(g.jsonValue)) return "jsonValue: string expected";
    }
    if (g.arrowValue != null && g.hasOwnProperty("arrowValue")) {
      if (d.value === 1) return "value: multiple values";
      d.value = 1;
      {
        let k = $root.ArrowTable.verify(g.arrowValue);
        if (k) return "arrowValue." + k;
      }
    }
    if (g.bytesValue != null && g.hasOwnProperty("bytesValue")) {
      if (d.value === 1) return "value: multiple values";
      if (d.value = 1, !(g.bytesValue && typeof g.bytesValue.length == "number" || $util.isString(g.bytesValue))) return "bytesValue: buffer expected";
    }
    if (g.fileUploaderStateValue != null && g.hasOwnProperty("fileUploaderStateValue")) {
      if (d.value === 1) return "value: multiple values";
      d.value = 1;
      {
        let k = $root.FileUploaderState.verify(g.fileUploaderStateValue);
        if (k) return "fileUploaderStateValue." + k;
      }
    }
    if (g.stringTriggerValue != null && g.hasOwnProperty("stringTriggerValue")) {
      if (d.value === 1) return "value: multiple values";
      d.value = 1;
      {
        let k = $root.StringTriggerValue.verify(g.stringTriggerValue);
        if (k) return "stringTriggerValue." + k;
      }
    }
    if (g.chatInputValue != null && g.hasOwnProperty("chatInputValue")) {
      if (d.value === 1) return "value: multiple values";
      d.value = 1;
      {
        let k = $root.ChatInputValue.verify(g.chatInputValue);
        if (k) return "chatInputValue." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.WidgetState) return g;
    let d = new $root.WidgetState();
    if (g.id != null && (d.id = String(g.id)), g.triggerValue != null && (d.triggerValue = !!g.triggerValue), g.boolValue != null && (d.boolValue = !!g.boolValue), g.doubleValue != null && (d.doubleValue = Number(g.doubleValue)), g.intValue != null && ($util.Long ? (d.intValue = $util.Long.fromValue(g.intValue)).unsigned = !1 : typeof g.intValue == "string" ? d.intValue = parseInt(g.intValue, 10) : typeof g.intValue == "number" ? d.intValue = g.intValue : typeof g.intValue == "object" && (d.intValue = new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber())), g.stringValue != null && (d.stringValue = String(g.stringValue)), g.doubleArrayValue != null) {
      if (typeof g.doubleArrayValue != "object") throw TypeError(".WidgetState.doubleArrayValue: object expected");
      d.doubleArrayValue = $root.DoubleArray.fromObject(g.doubleArrayValue);
    }
    if (g.intArrayValue != null) {
      if (typeof g.intArrayValue != "object") throw TypeError(".WidgetState.intArrayValue: object expected");
      d.intArrayValue = $root.SInt64Array.fromObject(g.intArrayValue);
    }
    if (g.stringArrayValue != null) {
      if (typeof g.stringArrayValue != "object") throw TypeError(".WidgetState.stringArrayValue: object expected");
      d.stringArrayValue = $root.StringArray.fromObject(g.stringArrayValue);
    }
    if (g.jsonValue != null && (d.jsonValue = String(g.jsonValue)), g.arrowValue != null) {
      if (typeof g.arrowValue != "object") throw TypeError(".WidgetState.arrowValue: object expected");
      d.arrowValue = $root.ArrowTable.fromObject(g.arrowValue);
    }
    if (g.bytesValue != null && (typeof g.bytesValue == "string" ? $util.base64.decode(g.bytesValue, d.bytesValue = $util.newBuffer($util.base64.length(g.bytesValue)), 0) : g.bytesValue.length >= 0 && (d.bytesValue = g.bytesValue)), g.fileUploaderStateValue != null) {
      if (typeof g.fileUploaderStateValue != "object") throw TypeError(".WidgetState.fileUploaderStateValue: object expected");
      d.fileUploaderStateValue = $root.FileUploaderState.fromObject(g.fileUploaderStateValue);
    }
    if (g.stringTriggerValue != null) {
      if (typeof g.stringTriggerValue != "object") throw TypeError(".WidgetState.stringTriggerValue: object expected");
      d.stringTriggerValue = $root.StringTriggerValue.fromObject(g.stringTriggerValue);
    }
    if (g.chatInputValue != null) {
      if (typeof g.chatInputValue != "object") throw TypeError(".WidgetState.chatInputValue: object expected");
      d.chatInputValue = $root.ChatInputValue.fromObject(g.chatInputValue);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.id = ""), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.triggerValue != null && g.hasOwnProperty("triggerValue") && (k.triggerValue = g.triggerValue, d.oneofs && (k.value = "triggerValue")), g.boolValue != null && g.hasOwnProperty("boolValue") && (k.boolValue = g.boolValue, d.oneofs && (k.value = "boolValue")), g.doubleValue != null && g.hasOwnProperty("doubleValue") && (k.doubleValue = d.json && !isFinite(g.doubleValue) ? String(g.doubleValue) : g.doubleValue, d.oneofs && (k.value = "doubleValue")), g.intValue != null && g.hasOwnProperty("intValue") && (typeof g.intValue == "number" ? k.intValue = d.longs === String ? String(g.intValue) : g.intValue : k.intValue = d.longs === String ? $util.Long.prototype.toString.call(g.intValue) : d.longs === Number ? new $util.LongBits(g.intValue.low >>> 0, g.intValue.high >>> 0).toNumber() : g.intValue, d.oneofs && (k.value = "intValue")), g.stringValue != null && g.hasOwnProperty("stringValue") && (k.stringValue = g.stringValue, d.oneofs && (k.value = "stringValue")), g.doubleArrayValue != null && g.hasOwnProperty("doubleArrayValue") && (k.doubleArrayValue = $root.DoubleArray.toObject(g.doubleArrayValue, d), d.oneofs && (k.value = "doubleArrayValue")), g.intArrayValue != null && g.hasOwnProperty("intArrayValue") && (k.intArrayValue = $root.SInt64Array.toObject(g.intArrayValue, d), d.oneofs && (k.value = "intArrayValue")), g.stringArrayValue != null && g.hasOwnProperty("stringArrayValue") && (k.stringArrayValue = $root.StringArray.toObject(g.stringArrayValue, d), d.oneofs && (k.value = "stringArrayValue")), g.jsonValue != null && g.hasOwnProperty("jsonValue") && (k.jsonValue = g.jsonValue, d.oneofs && (k.value = "jsonValue")), g.arrowValue != null && g.hasOwnProperty("arrowValue") && (k.arrowValue = $root.ArrowTable.toObject(g.arrowValue, d), d.oneofs && (k.value = "arrowValue")), g.bytesValue != null && g.hasOwnProperty("bytesValue") && (k.bytesValue = d.bytes === String ? $util.base64.encode(g.bytesValue, 0, g.bytesValue.length) : d.bytes === Array ? Array.prototype.slice.call(g.bytesValue) : g.bytesValue, d.oneofs && (k.value = "bytesValue")), g.fileUploaderStateValue != null && g.hasOwnProperty("fileUploaderStateValue") && (k.fileUploaderStateValue = $root.FileUploaderState.toObject(g.fileUploaderStateValue, d), d.oneofs && (k.value = "fileUploaderStateValue")), g.stringTriggerValue != null && g.hasOwnProperty("stringTriggerValue") && (k.stringTriggerValue = $root.StringTriggerValue.toObject(g.stringTriggerValue, d), d.oneofs && (k.value = "stringTriggerValue")), g.chatInputValue != null && g.hasOwnProperty("chatInputValue") && (k.chatInputValue = $root.ChatInputValue.toObject(g.chatInputValue, d), d.oneofs && (k.value = "chatInputValue")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/WidgetState";
  }, n;
})();
$root.StringArray = (() => {
  function n(t) {
    if (this.data = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.data != null && t.data.length) for (let d = 0; d < t.data.length; ++d) g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.data[d]);
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.StringArray();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.data && H.data.length || (H.data = []), H.data.push(t.string());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      if (!Array.isArray(t.data)) return "data: array expected";
      for (let g = 0; g < t.data.length; ++g) if (!$util.isString(t.data[g])) return "data: string[] expected";
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.StringArray) return t;
    let g = new $root.StringArray();
    if (t.data) {
      if (!Array.isArray(t.data)) throw TypeError(".StringArray.data: array expected");
      g.data = [];
      for (let d = 0; d < t.data.length; ++d) g.data[d] = String(t.data[d]);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.data = []), t.data && t.data.length) {
      d.data = [];
      for (let k = 0; k < t.data.length; ++k) d.data[k] = t.data[k];
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/StringArray";
  }, n;
})();
$root.DoubleArray = (() => {
  function n(t) {
    if (this.data = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.data != null && t.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let d = 0; d < t.data.length; ++d) g.double(t.data[d]);
      g.ldelim();
    }
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.DoubleArray();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          if (H.data && H.data.length || (H.data = []), (AA & 7) === 2) {
            let gA = t.uint32() + t.pos;
            for (; t.pos < gA; ) H.data.push(t.double());
          } else H.data.push(t.double());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      if (!Array.isArray(t.data)) return "data: array expected";
      for (let g = 0; g < t.data.length; ++g) if (typeof t.data[g] != "number") return "data: number[] expected";
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.DoubleArray) return t;
    let g = new $root.DoubleArray();
    if (t.data) {
      if (!Array.isArray(t.data)) throw TypeError(".DoubleArray.data: array expected");
      g.data = [];
      for (let d = 0; d < t.data.length; ++d) g.data[d] = Number(t.data[d]);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.data = []), t.data && t.data.length) {
      d.data = [];
      for (let k = 0; k < t.data.length; ++k) d.data[k] = g.json && !isFinite(t.data[k]) ? String(t.data[k]) : t.data[k];
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/DoubleArray";
  }, n;
})();
$root.Int32Array = (() => {
  function n(t) {
    if (this.data = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.data != null && t.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let d = 0; d < t.data.length; ++d) g.int32(t.data[d]);
      g.ldelim();
    }
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Int32Array();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          if (H.data && H.data.length || (H.data = []), (AA & 7) === 2) {
            let gA = t.uint32() + t.pos;
            for (; t.pos < gA; ) H.data.push(t.int32());
          } else H.data.push(t.int32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      if (!Array.isArray(t.data)) return "data: array expected";
      for (let g = 0; g < t.data.length; ++g) if (!$util.isInteger(t.data[g])) return "data: integer[] expected";
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Int32Array) return t;
    let g = new $root.Int32Array();
    if (t.data) {
      if (!Array.isArray(t.data)) throw TypeError(".Int32Array.data: array expected");
      g.data = [];
      for (let d = 0; d < t.data.length; ++d) g.data[d] = t.data[d] | 0;
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.data = []), t.data && t.data.length) {
      d.data = [];
      for (let k = 0; k < t.data.length; ++k) d.data[k] = t.data[k];
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Int32Array";
  }, n;
})();
$root.Int64Array = (() => {
  function n(t) {
    if (this.data = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.data != null && t.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let d = 0; d < t.data.length; ++d) g.int64(t.data[d]);
      g.ldelim();
    }
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Int64Array();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          if (H.data && H.data.length || (H.data = []), (AA & 7) === 2) {
            let gA = t.uint32() + t.pos;
            for (; t.pos < gA; ) H.data.push(t.int64());
          } else H.data.push(t.int64());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      if (!Array.isArray(t.data)) return "data: array expected";
      for (let g = 0; g < t.data.length; ++g) if (!$util.isInteger(t.data[g]) && !(t.data[g] && $util.isInteger(t.data[g].low) && $util.isInteger(t.data[g].high))) return "data: integer|Long[] expected";
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Int64Array) return t;
    let g = new $root.Int64Array();
    if (t.data) {
      if (!Array.isArray(t.data)) throw TypeError(".Int64Array.data: array expected");
      g.data = [];
      for (let d = 0; d < t.data.length; ++d) $util.Long ? (g.data[d] = $util.Long.fromValue(t.data[d])).unsigned = !1 : typeof t.data[d] == "string" ? g.data[d] = parseInt(t.data[d], 10) : typeof t.data[d] == "number" ? g.data[d] = t.data[d] : typeof t.data[d] == "object" && (g.data[d] = new $util.LongBits(t.data[d].low >>> 0, t.data[d].high >>> 0).toNumber());
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.data = []), t.data && t.data.length) {
      d.data = [];
      for (let k = 0; k < t.data.length; ++k) typeof t.data[k] == "number" ? d.data[k] = g.longs === String ? String(t.data[k]) : t.data[k] : d.data[k] = g.longs === String ? $util.Long.prototype.toString.call(t.data[k]) : g.longs === Number ? new $util.LongBits(t.data[k].low >>> 0, t.data[k].high >>> 0).toNumber() : t.data[k];
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Int64Array";
  }, n;
})();
$root.SInt64Array = (() => {
  function n(t) {
    if (this.data = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.data != null && t.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let d = 0; d < t.data.length; ++d) g.sint64(t.data[d]);
      g.ldelim();
    }
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.SInt64Array();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          if (H.data && H.data.length || (H.data = []), (AA & 7) === 2) {
            let gA = t.uint32() + t.pos;
            for (; t.pos < gA; ) H.data.push(t.sint64());
          } else H.data.push(t.sint64());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      if (!Array.isArray(t.data)) return "data: array expected";
      for (let g = 0; g < t.data.length; ++g) if (!$util.isInteger(t.data[g]) && !(t.data[g] && $util.isInteger(t.data[g].low) && $util.isInteger(t.data[g].high))) return "data: integer|Long[] expected";
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.SInt64Array) return t;
    let g = new $root.SInt64Array();
    if (t.data) {
      if (!Array.isArray(t.data)) throw TypeError(".SInt64Array.data: array expected");
      g.data = [];
      for (let d = 0; d < t.data.length; ++d) $util.Long ? (g.data[d] = $util.Long.fromValue(t.data[d])).unsigned = !1 : typeof t.data[d] == "string" ? g.data[d] = parseInt(t.data[d], 10) : typeof t.data[d] == "number" ? g.data[d] = t.data[d] : typeof t.data[d] == "object" && (g.data[d] = new $util.LongBits(t.data[d].low >>> 0, t.data[d].high >>> 0).toNumber());
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.data = []), t.data && t.data.length) {
      d.data = [];
      for (let k = 0; k < t.data.length; ++k) typeof t.data[k] == "number" ? d.data[k] = g.longs === String ? String(t.data[k]) : t.data[k] : d.data[k] = g.longs === String ? $util.Long.prototype.toString.call(t.data[k]) : g.longs === Number ? new $util.LongBits(t.data[k].low >>> 0, t.data[k].high >>> 0).toNumber() : t.data[k];
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/SInt64Array";
  }, n;
})();
$root.UInt32Array = (() => {
  function n(t) {
    if (this.data = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.data != null && t.data.length) {
      g.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let d = 0; d < t.data.length; ++d) g.uint32(t.data[d]);
      g.ldelim();
    }
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.UInt32Array();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          if (H.data && H.data.length || (H.data = []), (AA & 7) === 2) {
            let gA = t.uint32() + t.pos;
            for (; t.pos < gA; ) H.data.push(t.uint32());
          } else H.data.push(t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      if (!Array.isArray(t.data)) return "data: array expected";
      for (let g = 0; g < t.data.length; ++g) if (!$util.isInteger(t.data[g])) return "data: integer[] expected";
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.UInt32Array) return t;
    let g = new $root.UInt32Array();
    if (t.data) {
      if (!Array.isArray(t.data)) throw TypeError(".UInt32Array.data: array expected");
      g.data = [];
      for (let d = 0; d < t.data.length; ++d) g.data[d] = t.data[d] >>> 0;
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.data = []), t.data && t.data.length) {
      d.data = [];
      for (let k = 0; k < t.data.length; ++k) d.data[k] = t.data[k];
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/UInt32Array";
  }, n;
})();
$root.StringTriggerValue = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.data = null;
  let t;
  return Object.defineProperty(n.prototype, "_data", { get: $util.oneOfGetter(t = ["data"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.data), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.StringTriggerValue();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.data = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.data != null && g.hasOwnProperty("data") && !$util.isString(g.data) ? "data: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.StringTriggerValue) return g;
    let d = new $root.StringTriggerValue();
    return g.data != null && (d.data = String(g.data)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return g.data != null && g.hasOwnProperty("data") && (k.data = g.data, d.oneofs && (k._data = "data")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/StringTriggerValue";
  }, n;
})();
$root.FileURLsRequest = (() => {
  function n(t) {
    if (this.fileNames = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.requestId = "", n.prototype.fileNames = $util.emptyArray, n.prototype.sessionId = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.requestId != null && Object.hasOwnProperty.call(t, "requestId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.requestId), t.fileNames != null && t.fileNames.length) for (let d = 0; d < t.fileNames.length; ++d) g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.fileNames[d]);
    return t.sessionId != null && Object.hasOwnProperty.call(t, "sessionId") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.sessionId), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.FileURLsRequest();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.requestId = t.string();
          break;
        }
        case 2: {
          H.fileNames && H.fileNames.length || (H.fileNames = []), H.fileNames.push(t.string());
          break;
        }
        case 3: {
          H.sessionId = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.requestId != null && t.hasOwnProperty("requestId") && !$util.isString(t.requestId)) return "requestId: string expected";
    if (t.fileNames != null && t.hasOwnProperty("fileNames")) {
      if (!Array.isArray(t.fileNames)) return "fileNames: array expected";
      for (let g = 0; g < t.fileNames.length; ++g) if (!$util.isString(t.fileNames[g])) return "fileNames: string[] expected";
    }
    return t.sessionId != null && t.hasOwnProperty("sessionId") && !$util.isString(t.sessionId) ? "sessionId: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.FileURLsRequest) return t;
    let g = new $root.FileURLsRequest();
    if (t.requestId != null && (g.requestId = String(t.requestId)), t.fileNames) {
      if (!Array.isArray(t.fileNames)) throw TypeError(".FileURLsRequest.fileNames: array expected");
      g.fileNames = [];
      for (let d = 0; d < t.fileNames.length; ++d) g.fileNames[d] = String(t.fileNames[d]);
    }
    return t.sessionId != null && (g.sessionId = String(t.sessionId)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.fileNames = []), g.defaults && (d.requestId = "", d.sessionId = ""), t.requestId != null && t.hasOwnProperty("requestId") && (d.requestId = t.requestId), t.fileNames && t.fileNames.length) {
      d.fileNames = [];
      for (let k = 0; k < t.fileNames.length; ++k) d.fileNames[k] = t.fileNames[k];
    }
    return t.sessionId != null && t.hasOwnProperty("sessionId") && (d.sessionId = t.sessionId), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/FileURLsRequest";
  }, n;
})();
$root.FileURLs = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.fileId = "", n.prototype.uploadUrl = "", n.prototype.deleteUrl = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.fileId != null && Object.hasOwnProperty.call(t, "fileId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.fileId), t.uploadUrl != null && Object.hasOwnProperty.call(t, "uploadUrl") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.uploadUrl), t.deleteUrl != null && Object.hasOwnProperty.call(t, "deleteUrl") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.deleteUrl), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.FileURLs();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.fileId = t.string();
          break;
        }
        case 2: {
          H.uploadUrl = t.string();
          break;
        }
        case 3: {
          H.deleteUrl = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.fileId != null && t.hasOwnProperty("fileId") && !$util.isString(t.fileId) ? "fileId: string expected" : t.uploadUrl != null && t.hasOwnProperty("uploadUrl") && !$util.isString(t.uploadUrl) ? "uploadUrl: string expected" : t.deleteUrl != null && t.hasOwnProperty("deleteUrl") && !$util.isString(t.deleteUrl) ? "deleteUrl: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.FileURLs) return t;
    let g = new $root.FileURLs();
    return t.fileId != null && (g.fileId = String(t.fileId)), t.uploadUrl != null && (g.uploadUrl = String(t.uploadUrl)), t.deleteUrl != null && (g.deleteUrl = String(t.deleteUrl)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.fileId = "", d.uploadUrl = "", d.deleteUrl = ""), t.fileId != null && t.hasOwnProperty("fileId") && (d.fileId = t.fileId), t.uploadUrl != null && t.hasOwnProperty("uploadUrl") && (d.uploadUrl = t.uploadUrl), t.deleteUrl != null && t.hasOwnProperty("deleteUrl") && (d.deleteUrl = t.deleteUrl), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/FileURLs";
  }, n;
})();
$root.FileURLsResponse = (() => {
  function n(t) {
    if (this.fileUrls = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.responseId = "", n.prototype.fileUrls = $util.emptyArray, n.prototype.errorMsg = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.responseId != null && Object.hasOwnProperty.call(t, "responseId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.responseId), t.fileUrls != null && t.fileUrls.length) for (let d = 0; d < t.fileUrls.length; ++d) $root.FileURLs.encode(t.fileUrls[d], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return t.errorMsg != null && Object.hasOwnProperty.call(t, "errorMsg") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.errorMsg), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.FileURLsResponse();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.responseId = t.string();
          break;
        }
        case 2: {
          H.fileUrls && H.fileUrls.length || (H.fileUrls = []), H.fileUrls.push($root.FileURLs.decode(t, t.uint32()));
          break;
        }
        case 3: {
          H.errorMsg = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.responseId != null && t.hasOwnProperty("responseId") && !$util.isString(t.responseId)) return "responseId: string expected";
    if (t.fileUrls != null && t.hasOwnProperty("fileUrls")) {
      if (!Array.isArray(t.fileUrls)) return "fileUrls: array expected";
      for (let g = 0; g < t.fileUrls.length; ++g) {
        let d = $root.FileURLs.verify(t.fileUrls[g]);
        if (d) return "fileUrls." + d;
      }
    }
    return t.errorMsg != null && t.hasOwnProperty("errorMsg") && !$util.isString(t.errorMsg) ? "errorMsg: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.FileURLsResponse) return t;
    let g = new $root.FileURLsResponse();
    if (t.responseId != null && (g.responseId = String(t.responseId)), t.fileUrls) {
      if (!Array.isArray(t.fileUrls)) throw TypeError(".FileURLsResponse.fileUrls: array expected");
      g.fileUrls = [];
      for (let d = 0; d < t.fileUrls.length; ++d) {
        if (typeof t.fileUrls[d] != "object") throw TypeError(".FileURLsResponse.fileUrls: object expected");
        g.fileUrls[d] = $root.FileURLs.fromObject(t.fileUrls[d]);
      }
    }
    return t.errorMsg != null && (g.errorMsg = String(t.errorMsg)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.fileUrls = []), g.defaults && (d.responseId = "", d.errorMsg = ""), t.responseId != null && t.hasOwnProperty("responseId") && (d.responseId = t.responseId), t.fileUrls && t.fileUrls.length) {
      d.fileUrls = [];
      for (let k = 0; k < t.fileUrls.length; ++k) d.fileUrls[k] = $root.FileURLs.toObject(t.fileUrls[k], g);
    }
    return t.errorMsg != null && t.hasOwnProperty("errorMsg") && (d.errorMsg = t.errorMsg), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/FileURLsResponse";
  }, n;
})();
$root.UploadedFileInfo = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, n.prototype.name = "", n.prototype.size = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, n.prototype.fileId = "", n.prototype.fileUrls = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(t.id), t.name != null && Object.hasOwnProperty.call(t, "name") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.name), t.size != null && Object.hasOwnProperty.call(t, "size") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint64(t.size), t.fileId != null && Object.hasOwnProperty.call(t, "fileId") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.fileId), t.fileUrls != null && Object.hasOwnProperty.call(t, "fileUrls") && $root.FileURLs.encode(t.fileUrls, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.UploadedFileInfo();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.id = t.sint64();
          break;
        }
        case 2: {
          H.name = t.string();
          break;
        }
        case 3: {
          H.size = t.uint64();
          break;
        }
        case 4: {
          H.fileId = t.string();
          break;
        }
        case 5: {
          H.fileUrls = $root.FileURLs.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isInteger(t.id) && !(t.id && $util.isInteger(t.id.low) && $util.isInteger(t.id.high))) return "id: integer|Long expected";
    if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name)) return "name: string expected";
    if (t.size != null && t.hasOwnProperty("size") && !$util.isInteger(t.size) && !(t.size && $util.isInteger(t.size.low) && $util.isInteger(t.size.high))) return "size: integer|Long expected";
    if (t.fileId != null && t.hasOwnProperty("fileId") && !$util.isString(t.fileId)) return "fileId: string expected";
    if (t.fileUrls != null && t.hasOwnProperty("fileUrls")) {
      let g = $root.FileURLs.verify(t.fileUrls);
      if (g) return "fileUrls." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.UploadedFileInfo) return t;
    let g = new $root.UploadedFileInfo();
    if (t.id != null && ($util.Long ? (g.id = $util.Long.fromValue(t.id)).unsigned = !1 : typeof t.id == "string" ? g.id = parseInt(t.id, 10) : typeof t.id == "number" ? g.id = t.id : typeof t.id == "object" && (g.id = new $util.LongBits(t.id.low >>> 0, t.id.high >>> 0).toNumber())), t.name != null && (g.name = String(t.name)), t.size != null && ($util.Long ? (g.size = $util.Long.fromValue(t.size)).unsigned = !0 : typeof t.size == "string" ? g.size = parseInt(t.size, 10) : typeof t.size == "number" ? g.size = t.size : typeof t.size == "object" && (g.size = new $util.LongBits(t.size.low >>> 0, t.size.high >>> 0).toNumber(!0))), t.fileId != null && (g.fileId = String(t.fileId)), t.fileUrls != null) {
      if (typeof t.fileUrls != "object") throw TypeError(".UploadedFileInfo.fileUrls: object expected");
      g.fileUrls = $root.FileURLs.fromObject(t.fileUrls);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if (g.defaults) {
      if ($util.Long) {
        let k = new $util.Long(0, 0, !1);
        d.id = g.longs === String ? k.toString() : g.longs === Number ? k.toNumber() : k;
      } else d.id = g.longs === String ? "0" : 0;
      if (d.name = "", $util.Long) {
        let k = new $util.Long(0, 0, !0);
        d.size = g.longs === String ? k.toString() : g.longs === Number ? k.toNumber() : k;
      } else d.size = g.longs === String ? "0" : 0;
      d.fileId = "", d.fileUrls = null;
    }
    return t.id != null && t.hasOwnProperty("id") && (typeof t.id == "number" ? d.id = g.longs === String ? String(t.id) : t.id : d.id = g.longs === String ? $util.Long.prototype.toString.call(t.id) : g.longs === Number ? new $util.LongBits(t.id.low >>> 0, t.id.high >>> 0).toNumber() : t.id), t.name != null && t.hasOwnProperty("name") && (d.name = t.name), t.size != null && t.hasOwnProperty("size") && (typeof t.size == "number" ? d.size = g.longs === String ? String(t.size) : t.size : d.size = g.longs === String ? $util.Long.prototype.toString.call(t.size) : g.longs === Number ? new $util.LongBits(t.size.low >>> 0, t.size.high >>> 0).toNumber(!0) : t.size), t.fileId != null && t.hasOwnProperty("fileId") && (d.fileId = t.fileId), t.fileUrls != null && t.hasOwnProperty("fileUrls") && (d.fileUrls = $root.FileURLs.toObject(t.fileUrls, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/UploadedFileInfo";
  }, n;
})();
$root.FileUploaderState = (() => {
  function n(t) {
    if (this.uploadedFileInfo = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.maxFileId = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, n.prototype.uploadedFileInfo = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.maxFileId != null && Object.hasOwnProperty.call(t, "maxFileId") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(t.maxFileId), t.uploadedFileInfo != null && t.uploadedFileInfo.length) for (let d = 0; d < t.uploadedFileInfo.length; ++d) $root.UploadedFileInfo.encode(t.uploadedFileInfo[d], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.FileUploaderState();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.maxFileId = t.sint64();
          break;
        }
        case 2: {
          H.uploadedFileInfo && H.uploadedFileInfo.length || (H.uploadedFileInfo = []), H.uploadedFileInfo.push($root.UploadedFileInfo.decode(t, t.uint32()));
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.maxFileId != null && t.hasOwnProperty("maxFileId") && !$util.isInteger(t.maxFileId) && !(t.maxFileId && $util.isInteger(t.maxFileId.low) && $util.isInteger(t.maxFileId.high))) return "maxFileId: integer|Long expected";
    if (t.uploadedFileInfo != null && t.hasOwnProperty("uploadedFileInfo")) {
      if (!Array.isArray(t.uploadedFileInfo)) return "uploadedFileInfo: array expected";
      for (let g = 0; g < t.uploadedFileInfo.length; ++g) {
        let d = $root.UploadedFileInfo.verify(t.uploadedFileInfo[g]);
        if (d) return "uploadedFileInfo." + d;
      }
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.FileUploaderState) return t;
    let g = new $root.FileUploaderState();
    if (t.maxFileId != null && ($util.Long ? (g.maxFileId = $util.Long.fromValue(t.maxFileId)).unsigned = !1 : typeof t.maxFileId == "string" ? g.maxFileId = parseInt(t.maxFileId, 10) : typeof t.maxFileId == "number" ? g.maxFileId = t.maxFileId : typeof t.maxFileId == "object" && (g.maxFileId = new $util.LongBits(t.maxFileId.low >>> 0, t.maxFileId.high >>> 0).toNumber())), t.uploadedFileInfo) {
      if (!Array.isArray(t.uploadedFileInfo)) throw TypeError(".FileUploaderState.uploadedFileInfo: array expected");
      g.uploadedFileInfo = [];
      for (let d = 0; d < t.uploadedFileInfo.length; ++d) {
        if (typeof t.uploadedFileInfo[d] != "object") throw TypeError(".FileUploaderState.uploadedFileInfo: object expected");
        g.uploadedFileInfo[d] = $root.UploadedFileInfo.fromObject(t.uploadedFileInfo[d]);
      }
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.uploadedFileInfo = []), g.defaults) if ($util.Long) {
      let k = new $util.Long(0, 0, !1);
      d.maxFileId = g.longs === String ? k.toString() : g.longs === Number ? k.toNumber() : k;
    } else d.maxFileId = g.longs === String ? "0" : 0;
    if (t.maxFileId != null && t.hasOwnProperty("maxFileId") && (typeof t.maxFileId == "number" ? d.maxFileId = g.longs === String ? String(t.maxFileId) : t.maxFileId : d.maxFileId = g.longs === String ? $util.Long.prototype.toString.call(t.maxFileId) : g.longs === Number ? new $util.LongBits(t.maxFileId.low >>> 0, t.maxFileId.high >>> 0).toNumber() : t.maxFileId), t.uploadedFileInfo && t.uploadedFileInfo.length) {
      d.uploadedFileInfo = [];
      for (let k = 0; k < t.uploadedFileInfo.length; ++k) d.uploadedFileInfo[k] = $root.UploadedFileInfo.toObject(t.uploadedFileInfo[k], g);
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/FileUploaderState";
  }, n;
})();
$root.ChatInputValue = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.data = null, n.prototype.fileUploaderState = null;
  let t;
  return Object.defineProperty(n.prototype, "_data", { get: $util.oneOfGetter(t = ["data"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_fileUploaderState", { get: $util.oneOfGetter(t = ["fileUploaderState"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.data != null && Object.hasOwnProperty.call(g, "data") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.data), g.fileUploaderState != null && Object.hasOwnProperty.call(g, "fileUploaderState") && $root.FileUploaderState.encode(g.fileUploaderState, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.ChatInputValue();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.data = g.string();
          break;
        }
        case 2: {
          AA.fileUploaderState = $root.FileUploaderState.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.data != null && g.hasOwnProperty("data") && !$util.isString(g.data)) return "data: string expected";
    if (g.fileUploaderState != null && g.hasOwnProperty("fileUploaderState")) {
      let d = $root.FileUploaderState.verify(g.fileUploaderState);
      if (d) return "fileUploaderState." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.ChatInputValue) return g;
    let d = new $root.ChatInputValue();
    if (g.data != null && (d.data = String(g.data)), g.fileUploaderState != null) {
      if (typeof g.fileUploaderState != "object") throw TypeError(".ChatInputValue.fileUploaderState: object expected");
      d.fileUploaderState = $root.FileUploaderState.fromObject(g.fileUploaderState);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return g.data != null && g.hasOwnProperty("data") && (k.data = g.data, d.oneofs && (k._data = "data")), g.fileUploaderState != null && g.hasOwnProperty("fileUploaderState") && (k.fileUploaderState = $root.FileUploaderState.toObject(g.fileUploaderState, d), d.oneofs && (k._fileUploaderState = "fileUploaderState")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ChatInputValue";
  }, n;
})();
$root.ComponentInstance = (() => {
  function n(g) {
    if (this.specialArgs = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.jsonArgs = "", n.prototype.specialArgs = $util.emptyArray, n.prototype.componentName = "", n.prototype.url = "", n.prototype.formId = "", n.prototype.tabIndex = null;
  let t;
  return Object.defineProperty(n.prototype, "_tabIndex", { get: $util.oneOfGetter(t = ["tabIndex"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.jsonArgs != null && Object.hasOwnProperty.call(g, "jsonArgs") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.jsonArgs), g.specialArgs != null && g.specialArgs.length) for (let k = 0; k < g.specialArgs.length; ++k) $root.SpecialArg.encode(g.specialArgs[k], d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim();
    return g.componentName != null && Object.hasOwnProperty.call(g, "componentName") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.componentName), g.url != null && Object.hasOwnProperty.call(g, "url") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.url), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.tabIndex != null && Object.hasOwnProperty.call(g, "tabIndex") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(g.tabIndex), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.ComponentInstance();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.jsonArgs = g.string();
          break;
        }
        case 3: {
          AA.specialArgs && AA.specialArgs.length || (AA.specialArgs = []), AA.specialArgs.push($root.SpecialArg.decode(g, g.uint32()));
          break;
        }
        case 4: {
          AA.componentName = g.string();
          break;
        }
        case 5: {
          AA.url = g.string();
          break;
        }
        case 6: {
          AA.formId = g.string();
          break;
        }
        case 7: {
          AA.tabIndex = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.jsonArgs != null && g.hasOwnProperty("jsonArgs") && !$util.isString(g.jsonArgs)) return "jsonArgs: string expected";
    if (g.specialArgs != null && g.hasOwnProperty("specialArgs")) {
      if (!Array.isArray(g.specialArgs)) return "specialArgs: array expected";
      for (let d = 0; d < g.specialArgs.length; ++d) {
        let k = $root.SpecialArg.verify(g.specialArgs[d]);
        if (k) return "specialArgs." + k;
      }
    }
    return g.componentName != null && g.hasOwnProperty("componentName") && !$util.isString(g.componentName) ? "componentName: string expected" : g.url != null && g.hasOwnProperty("url") && !$util.isString(g.url) ? "url: string expected" : g.formId != null && g.hasOwnProperty("formId") && !$util.isString(g.formId) ? "formId: string expected" : g.tabIndex != null && g.hasOwnProperty("tabIndex") && !$util.isInteger(g.tabIndex) ? "tabIndex: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.ComponentInstance) return g;
    let d = new $root.ComponentInstance();
    if (g.id != null && (d.id = String(g.id)), g.jsonArgs != null && (d.jsonArgs = String(g.jsonArgs)), g.specialArgs) {
      if (!Array.isArray(g.specialArgs)) throw TypeError(".ComponentInstance.specialArgs: array expected");
      d.specialArgs = [];
      for (let k = 0; k < g.specialArgs.length; ++k) {
        if (typeof g.specialArgs[k] != "object") throw TypeError(".ComponentInstance.specialArgs: object expected");
        d.specialArgs[k] = $root.SpecialArg.fromObject(g.specialArgs[k]);
      }
    }
    return g.componentName != null && (d.componentName = String(g.componentName)), g.url != null && (d.url = String(g.url)), g.formId != null && (d.formId = String(g.formId)), g.tabIndex != null && (d.tabIndex = g.tabIndex | 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.specialArgs = []), d.defaults && (k.id = "", k.jsonArgs = "", k.componentName = "", k.url = "", k.formId = ""), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.jsonArgs != null && g.hasOwnProperty("jsonArgs") && (k.jsonArgs = g.jsonArgs), g.specialArgs && g.specialArgs.length) {
      k.specialArgs = [];
      for (let H = 0; H < g.specialArgs.length; ++H) k.specialArgs[H] = $root.SpecialArg.toObject(g.specialArgs[H], d);
    }
    return g.componentName != null && g.hasOwnProperty("componentName") && (k.componentName = g.componentName), g.url != null && g.hasOwnProperty("url") && (k.url = g.url), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.tabIndex != null && g.hasOwnProperty("tabIndex") && (k.tabIndex = g.tabIndex, d.oneofs && (k._tabIndex = "tabIndex")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ComponentInstance";
  }, n;
})();
$root.SpecialArg = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.key = "", n.prototype.arrowDataframe = null, n.prototype.bytes = null;
  let t;
  return Object.defineProperty(n.prototype, "value", { get: $util.oneOfGetter(t = ["arrowDataframe", "bytes"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.key != null && Object.hasOwnProperty.call(g, "key") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.key), g.arrowDataframe != null && Object.hasOwnProperty.call(g, "arrowDataframe") && $root.ArrowDataframe.encode(g.arrowDataframe, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.bytes != null && Object.hasOwnProperty.call(g, "bytes") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(g.bytes), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.SpecialArg();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.key = g.string();
          break;
        }
        case 2: {
          AA.arrowDataframe = $root.ArrowDataframe.decode(g, g.uint32());
          break;
        }
        case 3: {
          AA.bytes = g.bytes();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.key != null && g.hasOwnProperty("key") && !$util.isString(g.key)) return "key: string expected";
    if (g.arrowDataframe != null && g.hasOwnProperty("arrowDataframe")) {
      d.value = 1;
      {
        let k = $root.ArrowDataframe.verify(g.arrowDataframe);
        if (k) return "arrowDataframe." + k;
      }
    }
    if (g.bytes != null && g.hasOwnProperty("bytes")) {
      if (d.value === 1) return "value: multiple values";
      if (d.value = 1, !(g.bytes && typeof g.bytes.length == "number" || $util.isString(g.bytes))) return "bytes: buffer expected";
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.SpecialArg) return g;
    let d = new $root.SpecialArg();
    if (g.key != null && (d.key = String(g.key)), g.arrowDataframe != null) {
      if (typeof g.arrowDataframe != "object") throw TypeError(".SpecialArg.arrowDataframe: object expected");
      d.arrowDataframe = $root.ArrowDataframe.fromObject(g.arrowDataframe);
    }
    return g.bytes != null && (typeof g.bytes == "string" ? $util.base64.decode(g.bytes, d.bytes = $util.newBuffer($util.base64.length(g.bytes)), 0) : g.bytes.length >= 0 && (d.bytes = g.bytes)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.key = ""), g.key != null && g.hasOwnProperty("key") && (k.key = g.key), g.arrowDataframe != null && g.hasOwnProperty("arrowDataframe") && (k.arrowDataframe = $root.ArrowDataframe.toObject(g.arrowDataframe, d), d.oneofs && (k.value = "arrowDataframe")), g.bytes != null && g.hasOwnProperty("bytes") && (k.bytes = d.bytes === String ? $util.base64.encode(g.bytes, 0, g.bytes.length) : d.bytes === Array ? Array.prototype.slice.call(g.bytes) : g.bytes, d.oneofs && (k.value = "bytes")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/SpecialArg";
  }, n;
})();
$root.ArrowDataframe = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.prototype.height = 0, n.prototype.width = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.data != null && Object.hasOwnProperty.call(t, "data") && $root.ArrowTable.encode(t.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t.height != null && Object.hasOwnProperty.call(t, "height") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(t.height), t.width != null && Object.hasOwnProperty.call(t, "width") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(t.width), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ArrowDataframe();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.data = $root.ArrowTable.decode(t, t.uint32());
          break;
        }
        case 2: {
          H.height = t.uint32();
          break;
        }
        case 3: {
          H.width = t.uint32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      let g = $root.ArrowTable.verify(t.data);
      if (g) return "data." + g;
    }
    return t.height != null && t.hasOwnProperty("height") && !$util.isInteger(t.height) ? "height: integer expected" : t.width != null && t.hasOwnProperty("width") && !$util.isInteger(t.width) ? "width: integer expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ArrowDataframe) return t;
    let g = new $root.ArrowDataframe();
    if (t.data != null) {
      if (typeof t.data != "object") throw TypeError(".ArrowDataframe.data: object expected");
      g.data = $root.ArrowTable.fromObject(t.data);
    }
    return t.height != null && (g.height = t.height >>> 0), t.width != null && (g.width = t.width >>> 0), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.data = null, d.height = 0, d.width = 0), t.data != null && t.hasOwnProperty("data") && (d.data = $root.ArrowTable.toObject(t.data, g)), t.height != null && t.hasOwnProperty("height") && (d.height = t.height), t.width != null && t.hasOwnProperty("width") && (d.width = t.width), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ArrowDataframe";
  }, n;
})();
$root.ArrowTable = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = $util.newBuffer([]), n.prototype.index = $util.newBuffer([]), n.prototype.columns = $util.newBuffer([]), n.prototype.styler = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.data != null && Object.hasOwnProperty.call(t, "data") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(t.data), t.index != null && Object.hasOwnProperty.call(t, "index") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).bytes(t.index), t.columns != null && Object.hasOwnProperty.call(t, "columns") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(t.columns), t.styler != null && Object.hasOwnProperty.call(t, "styler") && $root.ArrowTableStyler.encode(t.styler, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ArrowTable();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.data = t.bytes();
          break;
        }
        case 2: {
          H.index = t.bytes();
          break;
        }
        case 3: {
          H.columns = t.bytes();
          break;
        }
        case 5: {
          H.styler = $root.ArrowTableStyler.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data") && !(t.data && typeof t.data.length == "number" || $util.isString(t.data))) return "data: buffer expected";
    if (t.index != null && t.hasOwnProperty("index") && !(t.index && typeof t.index.length == "number" || $util.isString(t.index))) return "index: buffer expected";
    if (t.columns != null && t.hasOwnProperty("columns") && !(t.columns && typeof t.columns.length == "number" || $util.isString(t.columns))) return "columns: buffer expected";
    if (t.styler != null && t.hasOwnProperty("styler")) {
      let g = $root.ArrowTableStyler.verify(t.styler);
      if (g) return "styler." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ArrowTable) return t;
    let g = new $root.ArrowTable();
    if (t.data != null && (typeof t.data == "string" ? $util.base64.decode(t.data, g.data = $util.newBuffer($util.base64.length(t.data)), 0) : t.data.length >= 0 && (g.data = t.data)), t.index != null && (typeof t.index == "string" ? $util.base64.decode(t.index, g.index = $util.newBuffer($util.base64.length(t.index)), 0) : t.index.length >= 0 && (g.index = t.index)), t.columns != null && (typeof t.columns == "string" ? $util.base64.decode(t.columns, g.columns = $util.newBuffer($util.base64.length(t.columns)), 0) : t.columns.length >= 0 && (g.columns = t.columns)), t.styler != null) {
      if (typeof t.styler != "object") throw TypeError(".ArrowTable.styler: object expected");
      g.styler = $root.ArrowTableStyler.fromObject(t.styler);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (g.bytes === String ? d.data = "" : (d.data = [], g.bytes !== Array && (d.data = $util.newBuffer(d.data))), g.bytes === String ? d.index = "" : (d.index = [], g.bytes !== Array && (d.index = $util.newBuffer(d.index))), g.bytes === String ? d.columns = "" : (d.columns = [], g.bytes !== Array && (d.columns = $util.newBuffer(d.columns))), d.styler = null), t.data != null && t.hasOwnProperty("data") && (d.data = g.bytes === String ? $util.base64.encode(t.data, 0, t.data.length) : g.bytes === Array ? Array.prototype.slice.call(t.data) : t.data), t.index != null && t.hasOwnProperty("index") && (d.index = g.bytes === String ? $util.base64.encode(t.index, 0, t.index.length) : g.bytes === Array ? Array.prototype.slice.call(t.index) : t.index), t.columns != null && t.hasOwnProperty("columns") && (d.columns = g.bytes === String ? $util.base64.encode(t.columns, 0, t.columns.length) : g.bytes === Array ? Array.prototype.slice.call(t.columns) : t.columns), t.styler != null && t.hasOwnProperty("styler") && (d.styler = $root.ArrowTableStyler.toObject(t.styler, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ArrowTable";
  }, n;
})();
$root.ArrowTableStyler = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.uuid = "", n.prototype.caption = "", n.prototype.styles = "", n.prototype.displayValues = $util.newBuffer([]), n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.uuid != null && Object.hasOwnProperty.call(t, "uuid") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.uuid), t.caption != null && Object.hasOwnProperty.call(t, "caption") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.caption), t.styles != null && Object.hasOwnProperty.call(t, "styles") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.styles), t.displayValues != null && Object.hasOwnProperty.call(t, "displayValues") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(t.displayValues), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ArrowTableStyler();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.uuid = t.string();
          break;
        }
        case 2: {
          H.caption = t.string();
          break;
        }
        case 3: {
          H.styles = t.string();
          break;
        }
        case 4: {
          H.displayValues = t.bytes();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.uuid != null && t.hasOwnProperty("uuid") && !$util.isString(t.uuid) ? "uuid: string expected" : t.caption != null && t.hasOwnProperty("caption") && !$util.isString(t.caption) ? "caption: string expected" : t.styles != null && t.hasOwnProperty("styles") && !$util.isString(t.styles) ? "styles: string expected" : t.displayValues != null && t.hasOwnProperty("displayValues") && !(t.displayValues && typeof t.displayValues.length == "number" || $util.isString(t.displayValues)) ? "displayValues: buffer expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ArrowTableStyler) return t;
    let g = new $root.ArrowTableStyler();
    return t.uuid != null && (g.uuid = String(t.uuid)), t.caption != null && (g.caption = String(t.caption)), t.styles != null && (g.styles = String(t.styles)), t.displayValues != null && (typeof t.displayValues == "string" ? $util.base64.decode(t.displayValues, g.displayValues = $util.newBuffer($util.base64.length(t.displayValues)), 0) : t.displayValues.length >= 0 && (g.displayValues = t.displayValues)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.uuid = "", d.caption = "", d.styles = "", g.bytes === String ? d.displayValues = "" : (d.displayValues = [], g.bytes !== Array && (d.displayValues = $util.newBuffer(d.displayValues)))), t.uuid != null && t.hasOwnProperty("uuid") && (d.uuid = t.uuid), t.caption != null && t.hasOwnProperty("caption") && (d.caption = t.caption), t.styles != null && t.hasOwnProperty("styles") && (d.styles = t.styles), t.displayValues != null && t.hasOwnProperty("displayValues") && (d.displayValues = g.bytes === String ? $util.base64.encode(t.displayValues, 0, t.displayValues.length) : g.bytes === Array ? Array.prototype.slice.call(t.displayValues) : t.displayValues), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ArrowTableStyler";
  }, n;
})();
$root.Balloons = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.show = !1, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.show != null && Object.hasOwnProperty.call(t, "show") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(t.show), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Balloons();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 3: {
          H.show = t.bool();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.show != null && t.hasOwnProperty("show") && typeof t.show != "boolean" ? "show: boolean expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Balloons) return t;
    let g = new $root.Balloons();
    return t.show != null && (g.show = !!t.show), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.show = !1), t.show != null && t.hasOwnProperty("show") && (d.show = t.show), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Balloons";
  }, n;
})();
$root.Block = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.vertical = null, n.prototype.horizontal = null, n.prototype.column = null, n.prototype.expandable = null, n.prototype.form = null, n.prototype.tabContainer = null, n.prototype.tab = null, n.prototype.chatMessage = null, n.prototype.popover = null, n.prototype.dialog = null, n.prototype.flexContainer = null, n.prototype.allowEmpty = !1, n.prototype.id = null, n.prototype.heightConfig = null, n.prototype.widthConfig = null;
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util.oneOfGetter(t = ["vertical", "horizontal", "column", "expandable", "form", "tabContainer", "tab", "chatMessage", "popover", "dialog", "flexContainer"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_id", { get: $util.oneOfGetter(t = ["id"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_heightConfig", { get: $util.oneOfGetter(t = ["heightConfig"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_widthConfig", { get: $util.oneOfGetter(t = ["widthConfig"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.vertical != null && Object.hasOwnProperty.call(g, "vertical") && $root.Block.Vertical.encode(g.vertical, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.horizontal != null && Object.hasOwnProperty.call(g, "horizontal") && $root.Block.Horizontal.encode(g.horizontal, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.column != null && Object.hasOwnProperty.call(g, "column") && $root.Block.Column.encode(g.column, d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.expandable != null && Object.hasOwnProperty.call(g, "expandable") && $root.Block.Expandable.encode(g.expandable, d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.form != null && Object.hasOwnProperty.call(g, "form") && $root.Block.Form.encode(g.form, d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.tabContainer != null && Object.hasOwnProperty.call(g, "tabContainer") && $root.Block.TabContainer.encode(g.tabContainer, d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.tab != null && Object.hasOwnProperty.call(g, "tab") && $root.Block.Tab.encode(g.tab, d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.allowEmpty != null && Object.hasOwnProperty.call(g, "allowEmpty") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.allowEmpty), g.chatMessage != null && Object.hasOwnProperty.call(g, "chatMessage") && $root.Block.ChatMessage.encode(g.chatMessage, d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.popover != null && Object.hasOwnProperty.call(g, "popover") && $root.Block.Popover.encode(g.popover, d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.dialog != null && Object.hasOwnProperty.call(g, "dialog") && $root.Block.Dialog.encode(g.dialog, d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.id), g.flexContainer != null && Object.hasOwnProperty.call(g, "flexContainer") && $root.Block.FlexContainer.encode(g.flexContainer, d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.heightConfig != null && Object.hasOwnProperty.call(g, "heightConfig") && $root.streamlit.HeightConfig.encode(g.heightConfig, d.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root.streamlit.WidthConfig.encode(g.widthConfig, d.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Block();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.vertical = $root.Block.Vertical.decode(g, g.uint32());
          break;
        }
        case 2: {
          AA.horizontal = $root.Block.Horizontal.decode(g, g.uint32());
          break;
        }
        case 3: {
          AA.column = $root.Block.Column.decode(g, g.uint32());
          break;
        }
        case 4: {
          AA.expandable = $root.Block.Expandable.decode(g, g.uint32());
          break;
        }
        case 5: {
          AA.form = $root.Block.Form.decode(g, g.uint32());
          break;
        }
        case 6: {
          AA.tabContainer = $root.Block.TabContainer.decode(g, g.uint32());
          break;
        }
        case 7: {
          AA.tab = $root.Block.Tab.decode(g, g.uint32());
          break;
        }
        case 9: {
          AA.chatMessage = $root.Block.ChatMessage.decode(g, g.uint32());
          break;
        }
        case 10: {
          AA.popover = $root.Block.Popover.decode(g, g.uint32());
          break;
        }
        case 11: {
          AA.dialog = $root.Block.Dialog.decode(g, g.uint32());
          break;
        }
        case 13: {
          AA.flexContainer = $root.Block.FlexContainer.decode(g, g.uint32());
          break;
        }
        case 8: {
          AA.allowEmpty = g.bool();
          break;
        }
        case 12: {
          AA.id = g.string();
          break;
        }
        case 14: {
          AA.heightConfig = $root.streamlit.HeightConfig.decode(g, g.uint32());
          break;
        }
        case 15: {
          AA.widthConfig = $root.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.vertical != null && g.hasOwnProperty("vertical")) {
      d.type = 1;
      {
        let k = $root.Block.Vertical.verify(g.vertical);
        if (k) return "vertical." + k;
      }
    }
    if (g.horizontal != null && g.hasOwnProperty("horizontal")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Block.Horizontal.verify(g.horizontal);
        if (k) return "horizontal." + k;
      }
    }
    if (g.column != null && g.hasOwnProperty("column")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Block.Column.verify(g.column);
        if (k) return "column." + k;
      }
    }
    if (g.expandable != null && g.hasOwnProperty("expandable")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Block.Expandable.verify(g.expandable);
        if (k) return "expandable." + k;
      }
    }
    if (g.form != null && g.hasOwnProperty("form")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Block.Form.verify(g.form);
        if (k) return "form." + k;
      }
    }
    if (g.tabContainer != null && g.hasOwnProperty("tabContainer")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Block.TabContainer.verify(g.tabContainer);
        if (k) return "tabContainer." + k;
      }
    }
    if (g.tab != null && g.hasOwnProperty("tab")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Block.Tab.verify(g.tab);
        if (k) return "tab." + k;
      }
    }
    if (g.chatMessage != null && g.hasOwnProperty("chatMessage")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Block.ChatMessage.verify(g.chatMessage);
        if (k) return "chatMessage." + k;
      }
    }
    if (g.popover != null && g.hasOwnProperty("popover")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Block.Popover.verify(g.popover);
        if (k) return "popover." + k;
      }
    }
    if (g.dialog != null && g.hasOwnProperty("dialog")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Block.Dialog.verify(g.dialog);
        if (k) return "dialog." + k;
      }
    }
    if (g.flexContainer != null && g.hasOwnProperty("flexContainer")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Block.FlexContainer.verify(g.flexContainer);
        if (k) return "flexContainer." + k;
      }
    }
    if (g.allowEmpty != null && g.hasOwnProperty("allowEmpty") && typeof g.allowEmpty != "boolean") return "allowEmpty: boolean expected";
    if (g.id != null && g.hasOwnProperty("id") && (d._id = 1, !$util.isString(g.id))) return "id: string expected";
    if (g.heightConfig != null && g.hasOwnProperty("heightConfig")) {
      d._heightConfig = 1;
      {
        let k = $root.streamlit.HeightConfig.verify(g.heightConfig);
        if (k) return "heightConfig." + k;
      }
    }
    if (g.widthConfig != null && g.hasOwnProperty("widthConfig")) {
      d._widthConfig = 1;
      {
        let k = $root.streamlit.WidthConfig.verify(g.widthConfig);
        if (k) return "widthConfig." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Block) return g;
    let d = new $root.Block();
    if (g.vertical != null) {
      if (typeof g.vertical != "object") throw TypeError(".Block.vertical: object expected");
      d.vertical = $root.Block.Vertical.fromObject(g.vertical);
    }
    if (g.horizontal != null) {
      if (typeof g.horizontal != "object") throw TypeError(".Block.horizontal: object expected");
      d.horizontal = $root.Block.Horizontal.fromObject(g.horizontal);
    }
    if (g.column != null) {
      if (typeof g.column != "object") throw TypeError(".Block.column: object expected");
      d.column = $root.Block.Column.fromObject(g.column);
    }
    if (g.expandable != null) {
      if (typeof g.expandable != "object") throw TypeError(".Block.expandable: object expected");
      d.expandable = $root.Block.Expandable.fromObject(g.expandable);
    }
    if (g.form != null) {
      if (typeof g.form != "object") throw TypeError(".Block.form: object expected");
      d.form = $root.Block.Form.fromObject(g.form);
    }
    if (g.tabContainer != null) {
      if (typeof g.tabContainer != "object") throw TypeError(".Block.tabContainer: object expected");
      d.tabContainer = $root.Block.TabContainer.fromObject(g.tabContainer);
    }
    if (g.tab != null) {
      if (typeof g.tab != "object") throw TypeError(".Block.tab: object expected");
      d.tab = $root.Block.Tab.fromObject(g.tab);
    }
    if (g.chatMessage != null) {
      if (typeof g.chatMessage != "object") throw TypeError(".Block.chatMessage: object expected");
      d.chatMessage = $root.Block.ChatMessage.fromObject(g.chatMessage);
    }
    if (g.popover != null) {
      if (typeof g.popover != "object") throw TypeError(".Block.popover: object expected");
      d.popover = $root.Block.Popover.fromObject(g.popover);
    }
    if (g.dialog != null) {
      if (typeof g.dialog != "object") throw TypeError(".Block.dialog: object expected");
      d.dialog = $root.Block.Dialog.fromObject(g.dialog);
    }
    if (g.flexContainer != null) {
      if (typeof g.flexContainer != "object") throw TypeError(".Block.flexContainer: object expected");
      d.flexContainer = $root.Block.FlexContainer.fromObject(g.flexContainer);
    }
    if (g.allowEmpty != null && (d.allowEmpty = !!g.allowEmpty), g.id != null && (d.id = String(g.id)), g.heightConfig != null) {
      if (typeof g.heightConfig != "object") throw TypeError(".Block.heightConfig: object expected");
      d.heightConfig = $root.streamlit.HeightConfig.fromObject(g.heightConfig);
    }
    if (g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Block.widthConfig: object expected");
      d.widthConfig = $root.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.allowEmpty = !1), g.vertical != null && g.hasOwnProperty("vertical") && (k.vertical = $root.Block.Vertical.toObject(g.vertical, d), d.oneofs && (k.type = "vertical")), g.horizontal != null && g.hasOwnProperty("horizontal") && (k.horizontal = $root.Block.Horizontal.toObject(g.horizontal, d), d.oneofs && (k.type = "horizontal")), g.column != null && g.hasOwnProperty("column") && (k.column = $root.Block.Column.toObject(g.column, d), d.oneofs && (k.type = "column")), g.expandable != null && g.hasOwnProperty("expandable") && (k.expandable = $root.Block.Expandable.toObject(g.expandable, d), d.oneofs && (k.type = "expandable")), g.form != null && g.hasOwnProperty("form") && (k.form = $root.Block.Form.toObject(g.form, d), d.oneofs && (k.type = "form")), g.tabContainer != null && g.hasOwnProperty("tabContainer") && (k.tabContainer = $root.Block.TabContainer.toObject(g.tabContainer, d), d.oneofs && (k.type = "tabContainer")), g.tab != null && g.hasOwnProperty("tab") && (k.tab = $root.Block.Tab.toObject(g.tab, d), d.oneofs && (k.type = "tab")), g.allowEmpty != null && g.hasOwnProperty("allowEmpty") && (k.allowEmpty = g.allowEmpty), g.chatMessage != null && g.hasOwnProperty("chatMessage") && (k.chatMessage = $root.Block.ChatMessage.toObject(g.chatMessage, d), d.oneofs && (k.type = "chatMessage")), g.popover != null && g.hasOwnProperty("popover") && (k.popover = $root.Block.Popover.toObject(g.popover, d), d.oneofs && (k.type = "popover")), g.dialog != null && g.hasOwnProperty("dialog") && (k.dialog = $root.Block.Dialog.toObject(g.dialog, d), d.oneofs && (k.type = "dialog")), g.id != null && g.hasOwnProperty("id") && (k.id = g.id, d.oneofs && (k._id = "id")), g.flexContainer != null && g.hasOwnProperty("flexContainer") && (k.flexContainer = $root.Block.FlexContainer.toObject(g.flexContainer, d), d.oneofs && (k.type = "flexContainer")), g.heightConfig != null && g.hasOwnProperty("heightConfig") && (k.heightConfig = $root.streamlit.HeightConfig.toObject(g.heightConfig, d), d.oneofs && (k._heightConfig = "heightConfig")), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (k.widthConfig = $root.streamlit.WidthConfig.toObject(g.widthConfig, d), d.oneofs && (k._widthConfig = "widthConfig")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Block";
  }, n.Vertical = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.border = !1, g.prototype.height = 0, g.create = function(d) {
      return new g(d);
    }, g.encode = function(d, k) {
      return k || (k = $Writer.create()), d.border != null && Object.hasOwnProperty.call(d, "border") && k.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(d.border), d.height != null && Object.hasOwnProperty.call(d, "height") && k.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint32(d.height), k;
    }, g.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, g.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.Block.Vertical();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.border = d.bool();
            break;
          }
          case 2: {
            gA.height = d.uint32();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, g.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, g.verify = function(d) {
      return typeof d != "object" || d === null ? "object expected" : d.border != null && d.hasOwnProperty("border") && typeof d.border != "boolean" ? "border: boolean expected" : d.height != null && d.hasOwnProperty("height") && !$util.isInteger(d.height) ? "height: integer expected" : null;
    }, g.fromObject = function(d) {
      if (d instanceof $root.Block.Vertical) return d;
      let k = new $root.Block.Vertical();
      return d.border != null && (k.border = !!d.border), d.height != null && (k.height = d.height >>> 0), k;
    }, g.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return k.defaults && (H.border = !1, H.height = 0), d.border != null && d.hasOwnProperty("border") && (H.border = d.border), d.height != null && d.hasOwnProperty("height") && (H.height = d.height), H;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/Block.Vertical";
    }, g;
  })(), n.Horizontal = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.gap = "", g.create = function(d) {
      return new g(d);
    }, g.encode = function(d, k) {
      return k || (k = $Writer.create()), d.gap != null && Object.hasOwnProperty.call(d, "gap") && k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(d.gap), k;
    }, g.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, g.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.Block.Horizontal();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.gap = d.string();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, g.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, g.verify = function(d) {
      return typeof d != "object" || d === null ? "object expected" : d.gap != null && d.hasOwnProperty("gap") && !$util.isString(d.gap) ? "gap: string expected" : null;
    }, g.fromObject = function(d) {
      if (d instanceof $root.Block.Horizontal) return d;
      let k = new $root.Block.Horizontal();
      return d.gap != null && (k.gap = String(d.gap)), k;
    }, g.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return k.defaults && (H.gap = ""), d.gap != null && d.hasOwnProperty("gap") && (H.gap = d.gap), H;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/Block.Horizontal";
    }, g;
  })(), n.FlexContainer = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.border = !1, g.prototype.gapConfig = null, g.prototype.scale = 0, g.prototype.direction = 0, g.prototype.wrap = !1, g.prototype.justify = 0, g.prototype.align = 0, g.create = function(d) {
      return new g(d);
    }, g.encode = function(d, k) {
      return k || (k = $Writer.create()), d.border != null && Object.hasOwnProperty.call(d, "border") && k.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(d.border), d.gapConfig != null && Object.hasOwnProperty.call(d, "gapConfig") && $root.streamlit.GapConfig.encode(d.gapConfig, k.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), d.scale != null && Object.hasOwnProperty.call(d, "scale") && k.uint32(
        /* id 3, wireType 5 =*/
        29
      ).float(d.scale), d.direction != null && Object.hasOwnProperty.call(d, "direction") && k.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(d.direction), d.wrap != null && Object.hasOwnProperty.call(d, "wrap") && k.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(d.wrap), d.justify != null && Object.hasOwnProperty.call(d, "justify") && k.uint32(
        /* id 7, wireType 0 =*/
        56
      ).int32(d.justify), d.align != null && Object.hasOwnProperty.call(d, "align") && k.uint32(
        /* id 8, wireType 0 =*/
        64
      ).int32(d.align), k;
    }, g.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, g.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.Block.FlexContainer();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.border = d.bool();
            break;
          }
          case 2: {
            gA.gapConfig = $root.streamlit.GapConfig.decode(d, d.uint32());
            break;
          }
          case 3: {
            gA.scale = d.float();
            break;
          }
          case 4: {
            gA.direction = d.int32();
            break;
          }
          case 5: {
            gA.wrap = d.bool();
            break;
          }
          case 7: {
            gA.justify = d.int32();
            break;
          }
          case 8: {
            gA.align = d.int32();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, g.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, g.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      if (d.border != null && d.hasOwnProperty("border") && typeof d.border != "boolean") return "border: boolean expected";
      if (d.gapConfig != null && d.hasOwnProperty("gapConfig")) {
        let k = $root.streamlit.GapConfig.verify(d.gapConfig);
        if (k) return "gapConfig." + k;
      }
      if (d.scale != null && d.hasOwnProperty("scale") && typeof d.scale != "number") return "scale: number expected";
      if (d.direction != null && d.hasOwnProperty("direction")) switch (d.direction) {
        default:
          return "direction: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
      if (d.wrap != null && d.hasOwnProperty("wrap") && typeof d.wrap != "boolean") return "wrap: boolean expected";
      if (d.justify != null && d.hasOwnProperty("justify")) switch (d.justify) {
        default:
          return "justify: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
          break;
      }
      if (d.align != null && d.hasOwnProperty("align")) switch (d.align) {
        default:
          return "align: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
          break;
      }
      return null;
    }, g.fromObject = function(d) {
      if (d instanceof $root.Block.FlexContainer) return d;
      let k = new $root.Block.FlexContainer();
      if (d.border != null && (k.border = !!d.border), d.gapConfig != null) {
        if (typeof d.gapConfig != "object") throw TypeError(".Block.FlexContainer.gapConfig: object expected");
        k.gapConfig = $root.streamlit.GapConfig.fromObject(d.gapConfig);
      }
      switch (d.scale != null && (k.scale = Number(d.scale)), d.direction) {
        default:
          if (typeof d.direction == "number") {
            k.direction = d.direction;
            break;
          }
          break;
        case "DIRECTION_UNDEFINED":
        case 0:
          k.direction = 0;
          break;
        case "VERTICAL":
        case 1:
          k.direction = 1;
          break;
        case "HORIZONTAL":
        case 2:
          k.direction = 2;
          break;
      }
      switch (d.wrap != null && (k.wrap = !!d.wrap), d.justify) {
        default:
          if (typeof d.justify == "number") {
            k.justify = d.justify;
            break;
          }
          break;
        case "JUSTIFY_UNDEFINED":
        case 0:
          k.justify = 0;
          break;
        case "JUSTIFY_START":
        case 1:
          k.justify = 1;
          break;
        case "JUSTIFY_END":
        case 2:
          k.justify = 2;
          break;
        case "JUSTIFY_CENTER":
        case 3:
          k.justify = 3;
          break;
        case "SPACE_BETWEEN":
        case 4:
          k.justify = 4;
          break;
      }
      switch (d.align) {
        default:
          if (typeof d.align == "number") {
            k.align = d.align;
            break;
          }
          break;
        case "ALIGN_UNDEFINED":
        case 0:
          k.align = 0;
          break;
        case "ALIGN_START":
        case 1:
          k.align = 1;
          break;
        case "ALIGN_END":
        case 2:
          k.align = 2;
          break;
        case "ALIGN_CENTER":
        case 3:
          k.align = 3;
          break;
        case "STRETCH":
        case 4:
          k.align = 4;
          break;
      }
      return k;
    }, g.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return k.defaults && (H.border = !1, H.gapConfig = null, H.scale = 0, H.direction = k.enums === String ? "DIRECTION_UNDEFINED" : 0, H.wrap = !1, H.justify = k.enums === String ? "JUSTIFY_UNDEFINED" : 0, H.align = k.enums === String ? "ALIGN_UNDEFINED" : 0), d.border != null && d.hasOwnProperty("border") && (H.border = d.border), d.gapConfig != null && d.hasOwnProperty("gapConfig") && (H.gapConfig = $root.streamlit.GapConfig.toObject(d.gapConfig, k)), d.scale != null && d.hasOwnProperty("scale") && (H.scale = k.json && !isFinite(d.scale) ? String(d.scale) : d.scale), d.direction != null && d.hasOwnProperty("direction") && (H.direction = k.enums === String ? $root.Block.FlexContainer.Direction[d.direction] === void 0 ? d.direction : $root.Block.FlexContainer.Direction[d.direction] : d.direction), d.wrap != null && d.hasOwnProperty("wrap") && (H.wrap = d.wrap), d.justify != null && d.hasOwnProperty("justify") && (H.justify = k.enums === String ? $root.Block.FlexContainer.Justify[d.justify] === void 0 ? d.justify : $root.Block.FlexContainer.Justify[d.justify] : d.justify), d.align != null && d.hasOwnProperty("align") && (H.align = k.enums === String ? $root.Block.FlexContainer.Align[d.align] === void 0 ? d.align : $root.Block.FlexContainer.Align[d.align] : d.align), H;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/Block.FlexContainer";
    }, g.Direction = (function() {
      const d = {}, k = Object.create(d);
      return k[d[0] = "DIRECTION_UNDEFINED"] = 0, k[d[1] = "VERTICAL"] = 1, k[d[2] = "HORIZONTAL"] = 2, k;
    })(), g.Justify = (function() {
      const d = {}, k = Object.create(d);
      return k[d[0] = "JUSTIFY_UNDEFINED"] = 0, k[d[1] = "JUSTIFY_START"] = 1, k[d[2] = "JUSTIFY_END"] = 2, k[d[3] = "JUSTIFY_CENTER"] = 3, k[d[4] = "SPACE_BETWEEN"] = 4, k;
    })(), g.Align = (function() {
      const d = {}, k = Object.create(d);
      return k[d[0] = "ALIGN_UNDEFINED"] = 0, k[d[1] = "ALIGN_START"] = 1, k[d[2] = "ALIGN_END"] = 2, k[d[3] = "ALIGN_CENTER"] = 3, k[d[4] = "STRETCH"] = 4, k;
    })(), g;
  })(), n.Column = (function() {
    function g(k) {
      if (k) for (let H = Object.keys(k), AA = 0; AA < H.length; ++AA) k[H[AA]] != null && (this[H[AA]] = k[H[AA]]);
    }
    g.prototype.weight = 0, g.prototype.gap = "", g.prototype.verticalAlignment = 0, g.prototype.showBorder = !1, g.prototype.gapConfig = null;
    let d;
    return Object.defineProperty(g.prototype, "_gapConfig", { get: $util.oneOfGetter(d = ["gapConfig"]), set: $util.oneOfSetter(d) }), g.create = function(k) {
      return new g(k);
    }, g.encode = function(k, H) {
      return H || (H = $Writer.create()), k.weight != null && Object.hasOwnProperty.call(k, "weight") && H.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(k.weight), k.gap != null && Object.hasOwnProperty.call(k, "gap") && H.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(k.gap), k.verticalAlignment != null && Object.hasOwnProperty.call(k, "verticalAlignment") && H.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(k.verticalAlignment), k.showBorder != null && Object.hasOwnProperty.call(k, "showBorder") && H.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(k.showBorder), k.gapConfig != null && Object.hasOwnProperty.call(k, "gapConfig") && $root.streamlit.GapConfig.encode(k.gapConfig, H.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), H;
    }, g.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, g.decode = function(k, H, AA) {
      k instanceof $Reader || (k = $Reader.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root.Block.Column();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.weight = k.double();
            break;
          }
          case 2: {
            IA.gap = k.string();
            break;
          }
          case 3: {
            IA.verticalAlignment = k.int32();
            break;
          }
          case 4: {
            IA.showBorder = k.bool();
            break;
          }
          case 5: {
            IA.gapConfig = $root.streamlit.GapConfig.decode(k, k.uint32());
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, g.decodeDelimited = function(k) {
      return k instanceof $Reader || (k = new $Reader(k)), this.decode(k, k.uint32());
    }, g.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      if (k.weight != null && k.hasOwnProperty("weight") && typeof k.weight != "number") return "weight: number expected";
      if (k.gap != null && k.hasOwnProperty("gap") && !$util.isString(k.gap)) return "gap: string expected";
      if (k.verticalAlignment != null && k.hasOwnProperty("verticalAlignment")) switch (k.verticalAlignment) {
        default:
          return "verticalAlignment: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
      if (k.showBorder != null && k.hasOwnProperty("showBorder") && typeof k.showBorder != "boolean") return "showBorder: boolean expected";
      if (k.gapConfig != null && k.hasOwnProperty("gapConfig")) {
        let H = $root.streamlit.GapConfig.verify(k.gapConfig);
        if (H) return "gapConfig." + H;
      }
      return null;
    }, g.fromObject = function(k) {
      if (k instanceof $root.Block.Column) return k;
      let H = new $root.Block.Column();
      switch (k.weight != null && (H.weight = Number(k.weight)), k.gap != null && (H.gap = String(k.gap)), k.verticalAlignment) {
        default:
          if (typeof k.verticalAlignment == "number") {
            H.verticalAlignment = k.verticalAlignment;
            break;
          }
          break;
        case "TOP":
        case 0:
          H.verticalAlignment = 0;
          break;
        case "CENTER":
        case 1:
          H.verticalAlignment = 1;
          break;
        case "BOTTOM":
        case 2:
          H.verticalAlignment = 2;
          break;
      }
      if (k.showBorder != null && (H.showBorder = !!k.showBorder), k.gapConfig != null) {
        if (typeof k.gapConfig != "object") throw TypeError(".Block.Column.gapConfig: object expected");
        H.gapConfig = $root.streamlit.GapConfig.fromObject(k.gapConfig);
      }
      return H;
    }, g.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.weight = 0, AA.gap = "", AA.verticalAlignment = H.enums === String ? "TOP" : 0, AA.showBorder = !1), k.weight != null && k.hasOwnProperty("weight") && (AA.weight = H.json && !isFinite(k.weight) ? String(k.weight) : k.weight), k.gap != null && k.hasOwnProperty("gap") && (AA.gap = k.gap), k.verticalAlignment != null && k.hasOwnProperty("verticalAlignment") && (AA.verticalAlignment = H.enums === String ? $root.Block.Column.VerticalAlignment[k.verticalAlignment] === void 0 ? k.verticalAlignment : $root.Block.Column.VerticalAlignment[k.verticalAlignment] : k.verticalAlignment), k.showBorder != null && k.hasOwnProperty("showBorder") && (AA.showBorder = k.showBorder), k.gapConfig != null && k.hasOwnProperty("gapConfig") && (AA.gapConfig = $root.streamlit.GapConfig.toObject(k.gapConfig, H), H.oneofs && (AA._gapConfig = "gapConfig")), AA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/Block.Column";
    }, g.VerticalAlignment = (function() {
      const k = {}, H = Object.create(k);
      return H[k[0] = "TOP"] = 0, H[k[1] = "CENTER"] = 1, H[k[2] = "BOTTOM"] = 2, H;
    })(), g;
  })(), n.Expandable = (function() {
    function g(k) {
      if (k) for (let H = Object.keys(k), AA = 0; AA < H.length; ++AA) k[H[AA]] != null && (this[H[AA]] = k[H[AA]]);
    }
    g.prototype.label = "", g.prototype.expanded = null, g.prototype.icon = "";
    let d;
    return Object.defineProperty(g.prototype, "_expanded", { get: $util.oneOfGetter(d = ["expanded"]), set: $util.oneOfSetter(d) }), g.create = function(k) {
      return new g(k);
    }, g.encode = function(k, H) {
      return H || (H = $Writer.create()), k.label != null && Object.hasOwnProperty.call(k, "label") && H.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(k.label), k.expanded != null && Object.hasOwnProperty.call(k, "expanded") && H.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(k.expanded), k.icon != null && Object.hasOwnProperty.call(k, "icon") && H.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(k.icon), H;
    }, g.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, g.decode = function(k, H, AA) {
      k instanceof $Reader || (k = $Reader.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root.Block.Expandable();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.label = k.string();
            break;
          }
          case 2: {
            IA.expanded = k.bool();
            break;
          }
          case 3: {
            IA.icon = k.string();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, g.decodeDelimited = function(k) {
      return k instanceof $Reader || (k = new $Reader(k)), this.decode(k, k.uint32());
    }, g.verify = function(k) {
      return typeof k != "object" || k === null ? "object expected" : k.label != null && k.hasOwnProperty("label") && !$util.isString(k.label) ? "label: string expected" : k.expanded != null && k.hasOwnProperty("expanded") && typeof k.expanded != "boolean" ? "expanded: boolean expected" : k.icon != null && k.hasOwnProperty("icon") && !$util.isString(k.icon) ? "icon: string expected" : null;
    }, g.fromObject = function(k) {
      if (k instanceof $root.Block.Expandable) return k;
      let H = new $root.Block.Expandable();
      return k.label != null && (H.label = String(k.label)), k.expanded != null && (H.expanded = !!k.expanded), k.icon != null && (H.icon = String(k.icon)), H;
    }, g.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.label = "", AA.icon = ""), k.label != null && k.hasOwnProperty("label") && (AA.label = k.label), k.expanded != null && k.hasOwnProperty("expanded") && (AA.expanded = k.expanded, H.oneofs && (AA._expanded = "expanded")), k.icon != null && k.hasOwnProperty("icon") && (AA.icon = k.icon), AA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/Block.Expandable";
    }, g;
  })(), n.Dialog = (function() {
    function g(k) {
      if (k) for (let H = Object.keys(k), AA = 0; AA < H.length; ++AA) k[H[AA]] != null && (this[H[AA]] = k[H[AA]]);
    }
    g.prototype.title = "", g.prototype.dismissible = !1, g.prototype.width = 0, g.prototype.isOpen = null, g.prototype.id = "";
    let d;
    return Object.defineProperty(g.prototype, "_isOpen", { get: $util.oneOfGetter(d = ["isOpen"]), set: $util.oneOfSetter(d) }), g.create = function(k) {
      return new g(k);
    }, g.encode = function(k, H) {
      return H || (H = $Writer.create()), k.title != null && Object.hasOwnProperty.call(k, "title") && H.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(k.title), k.dismissible != null && Object.hasOwnProperty.call(k, "dismissible") && H.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(k.dismissible), k.width != null && Object.hasOwnProperty.call(k, "width") && H.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(k.width), k.isOpen != null && Object.hasOwnProperty.call(k, "isOpen") && H.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(k.isOpen), k.id != null && Object.hasOwnProperty.call(k, "id") && H.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(k.id), H;
    }, g.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, g.decode = function(k, H, AA) {
      k instanceof $Reader || (k = $Reader.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root.Block.Dialog();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.title = k.string();
            break;
          }
          case 2: {
            IA.dismissible = k.bool();
            break;
          }
          case 3: {
            IA.width = k.int32();
            break;
          }
          case 4: {
            IA.isOpen = k.bool();
            break;
          }
          case 5: {
            IA.id = k.string();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, g.decodeDelimited = function(k) {
      return k instanceof $Reader || (k = new $Reader(k)), this.decode(k, k.uint32());
    }, g.verify = function(k) {
      if (typeof k != "object" || k === null) return "object expected";
      if (k.title != null && k.hasOwnProperty("title") && !$util.isString(k.title)) return "title: string expected";
      if (k.dismissible != null && k.hasOwnProperty("dismissible") && typeof k.dismissible != "boolean") return "dismissible: boolean expected";
      if (k.width != null && k.hasOwnProperty("width")) switch (k.width) {
        default:
          return "width: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
      return k.isOpen != null && k.hasOwnProperty("isOpen") && typeof k.isOpen != "boolean" ? "isOpen: boolean expected" : k.id != null && k.hasOwnProperty("id") && !$util.isString(k.id) ? "id: string expected" : null;
    }, g.fromObject = function(k) {
      if (k instanceof $root.Block.Dialog) return k;
      let H = new $root.Block.Dialog();
      switch (k.title != null && (H.title = String(k.title)), k.dismissible != null && (H.dismissible = !!k.dismissible), k.width) {
        default:
          if (typeof k.width == "number") {
            H.width = k.width;
            break;
          }
          break;
        case "SMALL":
        case 0:
          H.width = 0;
          break;
        case "LARGE":
        case 1:
          H.width = 1;
          break;
        case "MEDIUM":
        case 2:
          H.width = 2;
          break;
      }
      return k.isOpen != null && (H.isOpen = !!k.isOpen), k.id != null && (H.id = String(k.id)), H;
    }, g.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.title = "", AA.dismissible = !1, AA.width = H.enums === String ? "SMALL" : 0, AA.id = ""), k.title != null && k.hasOwnProperty("title") && (AA.title = k.title), k.dismissible != null && k.hasOwnProperty("dismissible") && (AA.dismissible = k.dismissible), k.width != null && k.hasOwnProperty("width") && (AA.width = H.enums === String ? $root.Block.Dialog.DialogWidth[k.width] === void 0 ? k.width : $root.Block.Dialog.DialogWidth[k.width] : k.width), k.isOpen != null && k.hasOwnProperty("isOpen") && (AA.isOpen = k.isOpen, H.oneofs && (AA._isOpen = "isOpen")), k.id != null && k.hasOwnProperty("id") && (AA.id = k.id), AA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/Block.Dialog";
    }, g.DialogWidth = (function() {
      const k = {}, H = Object.create(k);
      return H[k[0] = "SMALL"] = 0, H[k[1] = "LARGE"] = 1, H[k[2] = "MEDIUM"] = 2, H;
    })(), g;
  })(), n.Form = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.formId = "", g.prototype.clearOnSubmit = !1, g.prototype.border = !1, g.prototype.enterToSubmit = !1, g.create = function(d) {
      return new g(d);
    }, g.encode = function(d, k) {
      return k || (k = $Writer.create()), d.formId != null && Object.hasOwnProperty.call(d, "formId") && k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(d.formId), d.clearOnSubmit != null && Object.hasOwnProperty.call(d, "clearOnSubmit") && k.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(d.clearOnSubmit), d.border != null && Object.hasOwnProperty.call(d, "border") && k.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(d.border), d.enterToSubmit != null && Object.hasOwnProperty.call(d, "enterToSubmit") && k.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(d.enterToSubmit), k;
    }, g.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, g.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.Block.Form();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.formId = d.string();
            break;
          }
          case 2: {
            gA.clearOnSubmit = d.bool();
            break;
          }
          case 3: {
            gA.border = d.bool();
            break;
          }
          case 4: {
            gA.enterToSubmit = d.bool();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, g.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, g.verify = function(d) {
      return typeof d != "object" || d === null ? "object expected" : d.formId != null && d.hasOwnProperty("formId") && !$util.isString(d.formId) ? "formId: string expected" : d.clearOnSubmit != null && d.hasOwnProperty("clearOnSubmit") && typeof d.clearOnSubmit != "boolean" ? "clearOnSubmit: boolean expected" : d.border != null && d.hasOwnProperty("border") && typeof d.border != "boolean" ? "border: boolean expected" : d.enterToSubmit != null && d.hasOwnProperty("enterToSubmit") && typeof d.enterToSubmit != "boolean" ? "enterToSubmit: boolean expected" : null;
    }, g.fromObject = function(d) {
      if (d instanceof $root.Block.Form) return d;
      let k = new $root.Block.Form();
      return d.formId != null && (k.formId = String(d.formId)), d.clearOnSubmit != null && (k.clearOnSubmit = !!d.clearOnSubmit), d.border != null && (k.border = !!d.border), d.enterToSubmit != null && (k.enterToSubmit = !!d.enterToSubmit), k;
    }, g.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return k.defaults && (H.formId = "", H.clearOnSubmit = !1, H.border = !1, H.enterToSubmit = !1), d.formId != null && d.hasOwnProperty("formId") && (H.formId = d.formId), d.clearOnSubmit != null && d.hasOwnProperty("clearOnSubmit") && (H.clearOnSubmit = d.clearOnSubmit), d.border != null && d.hasOwnProperty("border") && (H.border = d.border), d.enterToSubmit != null && d.hasOwnProperty("enterToSubmit") && (H.enterToSubmit = d.enterToSubmit), H;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/Block.Form";
    }, g;
  })(), n.TabContainer = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.defaultTabIndex = 0, g.create = function(d) {
      return new g(d);
    }, g.encode = function(d, k) {
      return k || (k = $Writer.create()), d.defaultTabIndex != null && Object.hasOwnProperty.call(d, "defaultTabIndex") && k.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(d.defaultTabIndex), k;
    }, g.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, g.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.Block.TabContainer();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.defaultTabIndex = d.int32();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, g.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, g.verify = function(d) {
      return typeof d != "object" || d === null ? "object expected" : d.defaultTabIndex != null && d.hasOwnProperty("defaultTabIndex") && !$util.isInteger(d.defaultTabIndex) ? "defaultTabIndex: integer expected" : null;
    }, g.fromObject = function(d) {
      if (d instanceof $root.Block.TabContainer) return d;
      let k = new $root.Block.TabContainer();
      return d.defaultTabIndex != null && (k.defaultTabIndex = d.defaultTabIndex | 0), k;
    }, g.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return k.defaults && (H.defaultTabIndex = 0), d.defaultTabIndex != null && d.hasOwnProperty("defaultTabIndex") && (H.defaultTabIndex = d.defaultTabIndex), H;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/Block.TabContainer";
    }, g;
  })(), n.Tab = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.label = "", g.create = function(d) {
      return new g(d);
    }, g.encode = function(d, k) {
      return k || (k = $Writer.create()), d.label != null && Object.hasOwnProperty.call(d, "label") && k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(d.label), k;
    }, g.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, g.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.Block.Tab();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.label = d.string();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, g.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, g.verify = function(d) {
      return typeof d != "object" || d === null ? "object expected" : d.label != null && d.hasOwnProperty("label") && !$util.isString(d.label) ? "label: string expected" : null;
    }, g.fromObject = function(d) {
      if (d instanceof $root.Block.Tab) return d;
      let k = new $root.Block.Tab();
      return d.label != null && (k.label = String(d.label)), k;
    }, g.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return k.defaults && (H.label = ""), d.label != null && d.hasOwnProperty("label") && (H.label = d.label), H;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/Block.Tab";
    }, g;
  })(), n.Popover = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.label = "", g.prototype.useContainerWidth = !1, g.prototype.help = "", g.prototype.disabled = !1, g.prototype.icon = "", g.create = function(d) {
      return new g(d);
    }, g.encode = function(d, k) {
      return k || (k = $Writer.create()), d.label != null && Object.hasOwnProperty.call(d, "label") && k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(d.label), d.useContainerWidth != null && Object.hasOwnProperty.call(d, "useContainerWidth") && k.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(d.useContainerWidth), d.help != null && Object.hasOwnProperty.call(d, "help") && k.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(d.help), d.disabled != null && Object.hasOwnProperty.call(d, "disabled") && k.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(d.disabled), d.icon != null && Object.hasOwnProperty.call(d, "icon") && k.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(d.icon), k;
    }, g.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, g.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.Block.Popover();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.label = d.string();
            break;
          }
          case 2: {
            gA.useContainerWidth = d.bool();
            break;
          }
          case 3: {
            gA.help = d.string();
            break;
          }
          case 4: {
            gA.disabled = d.bool();
            break;
          }
          case 5: {
            gA.icon = d.string();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, g.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, g.verify = function(d) {
      return typeof d != "object" || d === null ? "object expected" : d.label != null && d.hasOwnProperty("label") && !$util.isString(d.label) ? "label: string expected" : d.useContainerWidth != null && d.hasOwnProperty("useContainerWidth") && typeof d.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : d.help != null && d.hasOwnProperty("help") && !$util.isString(d.help) ? "help: string expected" : d.disabled != null && d.hasOwnProperty("disabled") && typeof d.disabled != "boolean" ? "disabled: boolean expected" : d.icon != null && d.hasOwnProperty("icon") && !$util.isString(d.icon) ? "icon: string expected" : null;
    }, g.fromObject = function(d) {
      if (d instanceof $root.Block.Popover) return d;
      let k = new $root.Block.Popover();
      return d.label != null && (k.label = String(d.label)), d.useContainerWidth != null && (k.useContainerWidth = !!d.useContainerWidth), d.help != null && (k.help = String(d.help)), d.disabled != null && (k.disabled = !!d.disabled), d.icon != null && (k.icon = String(d.icon)), k;
    }, g.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return k.defaults && (H.label = "", H.useContainerWidth = !1, H.help = "", H.disabled = !1, H.icon = ""), d.label != null && d.hasOwnProperty("label") && (H.label = d.label), d.useContainerWidth != null && d.hasOwnProperty("useContainerWidth") && (H.useContainerWidth = d.useContainerWidth), d.help != null && d.hasOwnProperty("help") && (H.help = d.help), d.disabled != null && d.hasOwnProperty("disabled") && (H.disabled = d.disabled), d.icon != null && d.hasOwnProperty("icon") && (H.icon = d.icon), H;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/Block.Popover";
    }, g;
  })(), n.ChatMessage = (function() {
    function g(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    return g.prototype.name = "", g.prototype.avatar = "", g.prototype.avatarType = 0, g.create = function(d) {
      return new g(d);
    }, g.encode = function(d, k) {
      return k || (k = $Writer.create()), d.name != null && Object.hasOwnProperty.call(d, "name") && k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(d.name), d.avatar != null && Object.hasOwnProperty.call(d, "avatar") && k.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(d.avatar), d.avatarType != null && Object.hasOwnProperty.call(d, "avatarType") && k.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(d.avatarType), k;
    }, g.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, g.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.Block.ChatMessage();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.name = d.string();
            break;
          }
          case 2: {
            gA.avatar = d.string();
            break;
          }
          case 3: {
            gA.avatarType = d.int32();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, g.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, g.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      if (d.name != null && d.hasOwnProperty("name") && !$util.isString(d.name)) return "name: string expected";
      if (d.avatar != null && d.hasOwnProperty("avatar") && !$util.isString(d.avatar)) return "avatar: string expected";
      if (d.avatarType != null && d.hasOwnProperty("avatarType")) switch (d.avatarType) {
        default:
          return "avatarType: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
      return null;
    }, g.fromObject = function(d) {
      if (d instanceof $root.Block.ChatMessage) return d;
      let k = new $root.Block.ChatMessage();
      switch (d.name != null && (k.name = String(d.name)), d.avatar != null && (k.avatar = String(d.avatar)), d.avatarType) {
        default:
          if (typeof d.avatarType == "number") {
            k.avatarType = d.avatarType;
            break;
          }
          break;
        case "IMAGE":
        case 0:
          k.avatarType = 0;
          break;
        case "EMOJI":
        case 1:
          k.avatarType = 1;
          break;
        case "ICON":
        case 2:
          k.avatarType = 2;
          break;
      }
      return k;
    }, g.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return k.defaults && (H.name = "", H.avatar = "", H.avatarType = k.enums === String ? "IMAGE" : 0), d.name != null && d.hasOwnProperty("name") && (H.name = d.name), d.avatar != null && d.hasOwnProperty("avatar") && (H.avatar = d.avatar), d.avatarType != null && d.hasOwnProperty("avatarType") && (H.avatarType = k.enums === String ? $root.Block.ChatMessage.AvatarType[d.avatarType] === void 0 ? d.avatarType : $root.Block.ChatMessage.AvatarType[d.avatarType] : d.avatarType), H;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/Block.ChatMessage";
    }, g.AvatarType = (function() {
      const d = {}, k = Object.create(d);
      return k[d[0] = "IMAGE"] = 0, k[d[1] = "EMOJI"] = 1, k[d[2] = "ICON"] = 2, k;
    })(), g;
  })(), n;
})();
$root.BokehChart = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.figure = "", n.prototype.useContainerWidth = !1, n.prototype.elementId = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.figure != null && Object.hasOwnProperty.call(t, "figure") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.figure), t.useContainerWidth != null && Object.hasOwnProperty.call(t, "useContainerWidth") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(t.useContainerWidth), t.elementId != null && Object.hasOwnProperty.call(t, "elementId") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.elementId), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.BokehChart();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.figure = t.string();
          break;
        }
        case 2: {
          H.useContainerWidth = t.bool();
          break;
        }
        case 3: {
          H.elementId = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.figure != null && t.hasOwnProperty("figure") && !$util.isString(t.figure) ? "figure: string expected" : t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && typeof t.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : t.elementId != null && t.hasOwnProperty("elementId") && !$util.isString(t.elementId) ? "elementId: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.BokehChart) return t;
    let g = new $root.BokehChart();
    return t.figure != null && (g.figure = String(t.figure)), t.useContainerWidth != null && (g.useContainerWidth = !!t.useContainerWidth), t.elementId != null && (g.elementId = String(t.elementId)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.figure = "", d.useContainerWidth = !1, d.elementId = ""), t.figure != null && t.hasOwnProperty("figure") && (d.figure = t.figure), t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && (d.useContainerWidth = t.useContainerWidth), t.elementId != null && t.hasOwnProperty("elementId") && (d.elementId = t.elementId), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/BokehChart";
  }, n;
})();
$root.Button = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.default = !1, n.prototype.help = "", n.prototype.formId = "", n.prototype.isFormSubmitter = !1, n.prototype.type = "", n.prototype.disabled = !1, n.prototype.useContainerWidth = !1, n.prototype.icon = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.default != null && Object.hasOwnProperty.call(t, "default") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(t.default), t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.formId), t.isFormSubmitter != null && Object.hasOwnProperty.call(t, "isFormSubmitter") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(t.isFormSubmitter), t.type != null && Object.hasOwnProperty.call(t, "type") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.type), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.disabled), t.useContainerWidth != null && Object.hasOwnProperty.call(t, "useContainerWidth") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(t.useContainerWidth), t.icon != null && Object.hasOwnProperty.call(t, "icon") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(t.icon), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Button();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.id = t.string();
          break;
        }
        case 2: {
          H.label = t.string();
          break;
        }
        case 3: {
          H.default = t.bool();
          break;
        }
        case 4: {
          H.help = t.string();
          break;
        }
        case 5: {
          H.formId = t.string();
          break;
        }
        case 6: {
          H.isFormSubmitter = t.bool();
          break;
        }
        case 7: {
          H.type = t.string();
          break;
        }
        case 8: {
          H.disabled = t.bool();
          break;
        }
        case 9: {
          H.useContainerWidth = t.bool();
          break;
        }
        case 10: {
          H.icon = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id) ? "id: string expected" : t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label) ? "label: string expected" : t.default != null && t.hasOwnProperty("default") && typeof t.default != "boolean" ? "default: boolean expected" : t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help) ? "help: string expected" : t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId) ? "formId: string expected" : t.isFormSubmitter != null && t.hasOwnProperty("isFormSubmitter") && typeof t.isFormSubmitter != "boolean" ? "isFormSubmitter: boolean expected" : t.type != null && t.hasOwnProperty("type") && !$util.isString(t.type) ? "type: string expected" : t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean" ? "disabled: boolean expected" : t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && typeof t.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : t.icon != null && t.hasOwnProperty("icon") && !$util.isString(t.icon) ? "icon: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Button) return t;
    let g = new $root.Button();
    return t.id != null && (g.id = String(t.id)), t.label != null && (g.label = String(t.label)), t.default != null && (g.default = !!t.default), t.help != null && (g.help = String(t.help)), t.formId != null && (g.formId = String(t.formId)), t.isFormSubmitter != null && (g.isFormSubmitter = !!t.isFormSubmitter), t.type != null && (g.type = String(t.type)), t.disabled != null && (g.disabled = !!t.disabled), t.useContainerWidth != null && (g.useContainerWidth = !!t.useContainerWidth), t.icon != null && (g.icon = String(t.icon)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.id = "", d.label = "", d.default = !1, d.help = "", d.formId = "", d.isFormSubmitter = !1, d.type = "", d.disabled = !1, d.useContainerWidth = !1, d.icon = ""), t.id != null && t.hasOwnProperty("id") && (d.id = t.id), t.label != null && t.hasOwnProperty("label") && (d.label = t.label), t.default != null && t.hasOwnProperty("default") && (d.default = t.default), t.help != null && t.hasOwnProperty("help") && (d.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (d.formId = t.formId), t.isFormSubmitter != null && t.hasOwnProperty("isFormSubmitter") && (d.isFormSubmitter = t.isFormSubmitter), t.type != null && t.hasOwnProperty("type") && (d.type = t.type), t.disabled != null && t.hasOwnProperty("disabled") && (d.disabled = t.disabled), t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && (d.useContainerWidth = t.useContainerWidth), t.icon != null && t.hasOwnProperty("icon") && (d.icon = t.icon), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Button";
  }, n;
})();
$root.ButtonGroup = (() => {
  function n(g) {
    if (this.options = [], this.default = [], this.value = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.options = $util.emptyArray, n.prototype.default = $util.emptyArray, n.prototype.disabled = !1, n.prototype.clickMode = 0, n.prototype.formId = "", n.prototype.value = $util.emptyArray, n.prototype.setValue = !1, n.prototype.selectionVisualization = 0, n.prototype.style = 0, n.prototype.label = "", n.prototype.labelVisibility = null, n.prototype.help = null;
  let t;
  return Object.defineProperty(n.prototype, "_help", { get: $util.oneOfGetter(t = ["help"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.options != null && g.options.length) for (let k = 0; k < g.options.length; ++k) $root.ButtonGroup.Option.encode(g.options[k], d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    if (g.default != null && g.default.length) {
      d.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let k = 0; k < g.default.length; ++k) d.uint32(g.default[k]);
      d.ldelim();
    }
    if (g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.disabled), g.clickMode != null && Object.hasOwnProperty.call(g, "clickMode") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.clickMode), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.value != null && g.value.length) {
      d.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let k = 0; k < g.value.length; ++k) d.uint32(g.value[k]);
      d.ldelim();
    }
    return g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.setValue), g.selectionVisualization != null && Object.hasOwnProperty.call(g, "selectionVisualization") && d.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(g.selectionVisualization), g.style != null && Object.hasOwnProperty.call(g, "style") && d.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(g.style), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.label), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.help), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.ButtonGroup();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.options && AA.options.length || (AA.options = []), AA.options.push($root.ButtonGroup.Option.decode(g, g.uint32()));
          break;
        }
        case 3: {
          if (AA.default && AA.default.length || (AA.default = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.default.push(g.uint32());
          } else AA.default.push(g.uint32());
          break;
        }
        case 4: {
          AA.disabled = g.bool();
          break;
        }
        case 5: {
          AA.clickMode = g.int32();
          break;
        }
        case 6: {
          AA.formId = g.string();
          break;
        }
        case 7: {
          if (AA.value && AA.value.length || (AA.value = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.value.push(g.uint32());
          } else AA.value.push(g.uint32());
          break;
        }
        case 8: {
          AA.setValue = g.bool();
          break;
        }
        case 9: {
          AA.selectionVisualization = g.int32();
          break;
        }
        case 10: {
          AA.style = g.int32();
          break;
        }
        case 11: {
          AA.label = g.string();
          break;
        }
        case 12: {
          AA.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 13: {
          AA.help = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.options != null && g.hasOwnProperty("options")) {
      if (!Array.isArray(g.options)) return "options: array expected";
      for (let d = 0; d < g.options.length; ++d) {
        let k = $root.ButtonGroup.Option.verify(g.options[d]);
        if (k) return "options." + k;
      }
    }
    if (g.default != null && g.hasOwnProperty("default")) {
      if (!Array.isArray(g.default)) return "default: array expected";
      for (let d = 0; d < g.default.length; ++d) if (!$util.isInteger(g.default[d])) return "default: integer[] expected";
    }
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.clickMode != null && g.hasOwnProperty("clickMode")) switch (g.clickMode) {
      default:
        return "clickMode: enum value expected";
      case 0:
      case 1:
        break;
    }
    if (g.formId != null && g.hasOwnProperty("formId") && !$util.isString(g.formId)) return "formId: string expected";
    if (g.value != null && g.hasOwnProperty("value")) {
      if (!Array.isArray(g.value)) return "value: array expected";
      for (let d = 0; d < g.value.length; ++d) if (!$util.isInteger(g.value[d])) return "value: integer[] expected";
    }
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.selectionVisualization != null && g.hasOwnProperty("selectionVisualization")) switch (g.selectionVisualization) {
      default:
        return "selectionVisualization: enum value expected";
      case 0:
      case 1:
        break;
    }
    if (g.style != null && g.hasOwnProperty("style")) switch (g.style) {
      default:
        return "style: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (g.label != null && g.hasOwnProperty("label") && !$util.isString(g.label)) return "label: string expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    return g.help != null && g.hasOwnProperty("help") && !$util.isString(g.help) ? "help: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.ButtonGroup) return g;
    let d = new $root.ButtonGroup();
    if (g.id != null && (d.id = String(g.id)), g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".ButtonGroup.options: array expected");
      d.options = [];
      for (let k = 0; k < g.options.length; ++k) {
        if (typeof g.options[k] != "object") throw TypeError(".ButtonGroup.options: object expected");
        d.options[k] = $root.ButtonGroup.Option.fromObject(g.options[k]);
      }
    }
    if (g.default) {
      if (!Array.isArray(g.default)) throw TypeError(".ButtonGroup.default: array expected");
      d.default = [];
      for (let k = 0; k < g.default.length; ++k) d.default[k] = g.default[k] >>> 0;
    }
    switch (g.disabled != null && (d.disabled = !!g.disabled), g.clickMode) {
      default:
        if (typeof g.clickMode == "number") {
          d.clickMode = g.clickMode;
          break;
        }
        break;
      case "SINGLE_SELECT":
      case 0:
        d.clickMode = 0;
        break;
      case "MULTI_SELECT":
      case 1:
        d.clickMode = 1;
        break;
    }
    if (g.formId != null && (d.formId = String(g.formId)), g.value) {
      if (!Array.isArray(g.value)) throw TypeError(".ButtonGroup.value: array expected");
      d.value = [];
      for (let k = 0; k < g.value.length; ++k) d.value[k] = g.value[k] >>> 0;
    }
    switch (g.setValue != null && (d.setValue = !!g.setValue), g.selectionVisualization) {
      default:
        if (typeof g.selectionVisualization == "number") {
          d.selectionVisualization = g.selectionVisualization;
          break;
        }
        break;
      case "ONLY_SELECTED":
      case 0:
        d.selectionVisualization = 0;
        break;
      case "ALL_UP_TO_SELECTED":
      case 1:
        d.selectionVisualization = 1;
        break;
    }
    switch (g.style) {
      default:
        if (typeof g.style == "number") {
          d.style = g.style;
          break;
        }
        break;
      case "SEGMENTED_CONTROL":
      case 0:
        d.style = 0;
        break;
      case "PILLS":
      case 1:
        d.style = 1;
        break;
      case "BORDERLESS":
      case 2:
        d.style = 2;
        break;
    }
    if (g.label != null && (d.label = String(g.label)), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".ButtonGroup.labelVisibility: object expected");
      d.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.help != null && (d.help = String(g.help)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.options = [], k.default = [], k.value = []), d.defaults && (k.id = "", k.disabled = !1, k.clickMode = d.enums === String ? "SINGLE_SELECT" : 0, k.formId = "", k.setValue = !1, k.selectionVisualization = d.enums === String ? "ONLY_SELECTED" : 0, k.style = d.enums === String ? "SEGMENTED_CONTROL" : 0, k.label = "", k.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.options && g.options.length) {
      k.options = [];
      for (let H = 0; H < g.options.length; ++H) k.options[H] = $root.ButtonGroup.Option.toObject(g.options[H], d);
    }
    if (g.default && g.default.length) {
      k.default = [];
      for (let H = 0; H < g.default.length; ++H) k.default[H] = g.default[H];
    }
    if (g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.clickMode != null && g.hasOwnProperty("clickMode") && (k.clickMode = d.enums === String ? $root.ButtonGroup.ClickMode[g.clickMode] === void 0 ? g.clickMode : $root.ButtonGroup.ClickMode[g.clickMode] : g.clickMode), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.value && g.value.length) {
      k.value = [];
      for (let H = 0; H < g.value.length; ++H) k.value[H] = g.value[H];
    }
    return g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.selectionVisualization != null && g.hasOwnProperty("selectionVisualization") && (k.selectionVisualization = d.enums === String ? $root.ButtonGroup.SelectionVisualization[g.selectionVisualization] === void 0 ? g.selectionVisualization : $root.ButtonGroup.SelectionVisualization[g.selectionVisualization] : g.selectionVisualization), g.style != null && g.hasOwnProperty("style") && (k.style = d.enums === String ? $root.ButtonGroup.Style[g.style] === void 0 ? g.style : $root.ButtonGroup.Style[g.style] : g.style), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.help != null && g.hasOwnProperty("help") && (k.help = g.help, d.oneofs && (k._help = "help")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ButtonGroup";
  }, n.ClickMode = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "SINGLE_SELECT"] = 0, d[g[1] = "MULTI_SELECT"] = 1, d;
  })(), n.Option = (function() {
    function g(k) {
      if (k) for (let H = Object.keys(k), AA = 0; AA < H.length; ++AA) k[H[AA]] != null && (this[H[AA]] = k[H[AA]]);
    }
    g.prototype.content = "", g.prototype.selectedContent = null, g.prototype.contentIcon = null, g.prototype.selectedContentIcon = null;
    let d;
    return Object.defineProperty(g.prototype, "_selectedContent", { get: $util.oneOfGetter(d = ["selectedContent"]), set: $util.oneOfSetter(d) }), Object.defineProperty(g.prototype, "_contentIcon", { get: $util.oneOfGetter(d = ["contentIcon"]), set: $util.oneOfSetter(d) }), Object.defineProperty(g.prototype, "_selectedContentIcon", { get: $util.oneOfGetter(d = ["selectedContentIcon"]), set: $util.oneOfSetter(d) }), g.create = function(k) {
      return new g(k);
    }, g.encode = function(k, H) {
      return H || (H = $Writer.create()), k.content != null && Object.hasOwnProperty.call(k, "content") && H.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(k.content), k.selectedContent != null && Object.hasOwnProperty.call(k, "selectedContent") && H.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(k.selectedContent), k.contentIcon != null && Object.hasOwnProperty.call(k, "contentIcon") && H.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(k.contentIcon), k.selectedContentIcon != null && Object.hasOwnProperty.call(k, "selectedContentIcon") && H.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(k.selectedContentIcon), H;
    }, g.encodeDelimited = function(k, H) {
      return this.encode(k, H).ldelim();
    }, g.decode = function(k, H, AA) {
      k instanceof $Reader || (k = $Reader.create(k));
      let gA = H === void 0 ? k.len : k.pos + H, IA = new $root.ButtonGroup.Option();
      for (; k.pos < gA; ) {
        let CA = k.uint32();
        if (CA === AA) break;
        switch (CA >>> 3) {
          case 1: {
            IA.content = k.string();
            break;
          }
          case 2: {
            IA.selectedContent = k.string();
            break;
          }
          case 3: {
            IA.contentIcon = k.string();
            break;
          }
          case 4: {
            IA.selectedContentIcon = k.string();
            break;
          }
          default:
            k.skipType(CA & 7);
            break;
        }
      }
      return IA;
    }, g.decodeDelimited = function(k) {
      return k instanceof $Reader || (k = new $Reader(k)), this.decode(k, k.uint32());
    }, g.verify = function(k) {
      return typeof k != "object" || k === null ? "object expected" : k.content != null && k.hasOwnProperty("content") && !$util.isString(k.content) ? "content: string expected" : k.selectedContent != null && k.hasOwnProperty("selectedContent") && !$util.isString(k.selectedContent) ? "selectedContent: string expected" : k.contentIcon != null && k.hasOwnProperty("contentIcon") && !$util.isString(k.contentIcon) ? "contentIcon: string expected" : k.selectedContentIcon != null && k.hasOwnProperty("selectedContentIcon") && !$util.isString(k.selectedContentIcon) ? "selectedContentIcon: string expected" : null;
    }, g.fromObject = function(k) {
      if (k instanceof $root.ButtonGroup.Option) return k;
      let H = new $root.ButtonGroup.Option();
      return k.content != null && (H.content = String(k.content)), k.selectedContent != null && (H.selectedContent = String(k.selectedContent)), k.contentIcon != null && (H.contentIcon = String(k.contentIcon)), k.selectedContentIcon != null && (H.selectedContentIcon = String(k.selectedContentIcon)), H;
    }, g.toObject = function(k, H) {
      H || (H = {});
      let AA = {};
      return H.defaults && (AA.content = ""), k.content != null && k.hasOwnProperty("content") && (AA.content = k.content), k.selectedContent != null && k.hasOwnProperty("selectedContent") && (AA.selectedContent = k.selectedContent, H.oneofs && (AA._selectedContent = "selectedContent")), k.contentIcon != null && k.hasOwnProperty("contentIcon") && (AA.contentIcon = k.contentIcon, H.oneofs && (AA._contentIcon = "contentIcon")), k.selectedContentIcon != null && k.hasOwnProperty("selectedContentIcon") && (AA.selectedContentIcon = k.selectedContentIcon, H.oneofs && (AA._selectedContentIcon = "selectedContentIcon")), AA;
    }, g.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, g.getTypeUrl = function(k) {
      return k === void 0 && (k = "type.googleapis.com"), k + "/ButtonGroup.Option";
    }, g;
  })(), n.SelectionVisualization = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "ONLY_SELECTED"] = 0, d[g[1] = "ALL_UP_TO_SELECTED"] = 1, d;
  })(), n.Style = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "SEGMENTED_CONTROL"] = 0, d[g[1] = "PILLS"] = 1, d[g[2] = "BORDERLESS"] = 2, d;
  })(), n;
})();
$root.CameraInput = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.help = "", n.prototype.formId = "", n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.formId), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.CameraInput();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.id = t.string();
          break;
        }
        case 2: {
          H.label = t.string();
          break;
        }
        case 3: {
          H.help = t.string();
          break;
        }
        case 4: {
          H.formId = t.string();
          break;
        }
        case 5: {
          H.disabled = t.bool();
          break;
        }
        case 6: {
          H.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id)) return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label)) return "label: string expected";
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help)) return "help: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId)) return "formId: string expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean") return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let g = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (g) return "labelVisibility." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.CameraInput) return t;
    let g = new $root.CameraInput();
    if (t.id != null && (g.id = String(t.id)), t.label != null && (g.label = String(t.label)), t.help != null && (g.help = String(t.help)), t.formId != null && (g.formId = String(t.formId)), t.disabled != null && (g.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object") throw TypeError(".CameraInput.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.id = "", d.label = "", d.help = "", d.formId = "", d.disabled = !1, d.labelVisibility = null), t.id != null && t.hasOwnProperty("id") && (d.id = t.id), t.label != null && t.hasOwnProperty("label") && (d.label = t.label), t.help != null && t.hasOwnProperty("help") && (d.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (d.formId = t.formId), t.disabled != null && t.hasOwnProperty("disabled") && (d.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (d.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/CameraInput";
  }, n;
})();
$root.ChatInput = (() => {
  function n(t) {
    if (this.fileType = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.placeholder = "", n.prototype.maxChars = 0, n.prototype.disabled = !1, n.prototype.value = "", n.prototype.setValue = !1, n.prototype.default = "", n.prototype.position = 0, n.prototype.acceptFile = 0, n.prototype.fileType = $util.emptyArray, n.prototype.maxUploadSizeMb = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.placeholder != null && Object.hasOwnProperty.call(t, "placeholder") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.placeholder), t.maxChars != null && Object.hasOwnProperty.call(t, "maxChars") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(t.maxChars), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(t.disabled), t.value != null && Object.hasOwnProperty.call(t, "value") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.value), t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(t.setValue), t.default != null && Object.hasOwnProperty.call(t, "default") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.default), t.position != null && Object.hasOwnProperty.call(t, "position") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(t.position), t.acceptFile != null && Object.hasOwnProperty.call(t, "acceptFile") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(t.acceptFile), t.fileType != null && t.fileType.length) for (let d = 0; d < t.fileType.length; ++d) g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(t.fileType[d]);
    return t.maxUploadSizeMb != null && Object.hasOwnProperty.call(t, "maxUploadSizeMb") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(t.maxUploadSizeMb), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ChatInput();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.id = t.string();
          break;
        }
        case 2: {
          H.placeholder = t.string();
          break;
        }
        case 3: {
          H.maxChars = t.uint32();
          break;
        }
        case 4: {
          H.disabled = t.bool();
          break;
        }
        case 5: {
          H.value = t.string();
          break;
        }
        case 6: {
          H.setValue = t.bool();
          break;
        }
        case 7: {
          H.default = t.string();
          break;
        }
        case 8: {
          H.position = t.int32();
          break;
        }
        case 9: {
          H.acceptFile = t.int32();
          break;
        }
        case 10: {
          H.fileType && H.fileType.length || (H.fileType = []), H.fileType.push(t.string());
          break;
        }
        case 11: {
          H.maxUploadSizeMb = t.int32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id)) return "id: string expected";
    if (t.placeholder != null && t.hasOwnProperty("placeholder") && !$util.isString(t.placeholder)) return "placeholder: string expected";
    if (t.maxChars != null && t.hasOwnProperty("maxChars") && !$util.isInteger(t.maxChars)) return "maxChars: integer expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean") return "disabled: boolean expected";
    if (t.value != null && t.hasOwnProperty("value") && !$util.isString(t.value)) return "value: string expected";
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean") return "setValue: boolean expected";
    if (t.default != null && t.hasOwnProperty("default") && !$util.isString(t.default)) return "default: string expected";
    if (t.position != null && t.hasOwnProperty("position")) switch (t.position) {
      default:
        return "position: enum value expected";
      case 0:
        break;
    }
    if (t.acceptFile != null && t.hasOwnProperty("acceptFile")) switch (t.acceptFile) {
      default:
        return "acceptFile: enum value expected";
      case 0:
      case 1:
      case 2:
      case 3:
        break;
    }
    if (t.fileType != null && t.hasOwnProperty("fileType")) {
      if (!Array.isArray(t.fileType)) return "fileType: array expected";
      for (let g = 0; g < t.fileType.length; ++g) if (!$util.isString(t.fileType[g])) return "fileType: string[] expected";
    }
    return t.maxUploadSizeMb != null && t.hasOwnProperty("maxUploadSizeMb") && !$util.isInteger(t.maxUploadSizeMb) ? "maxUploadSizeMb: integer expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ChatInput) return t;
    let g = new $root.ChatInput();
    switch (t.id != null && (g.id = String(t.id)), t.placeholder != null && (g.placeholder = String(t.placeholder)), t.maxChars != null && (g.maxChars = t.maxChars >>> 0), t.disabled != null && (g.disabled = !!t.disabled), t.value != null && (g.value = String(t.value)), t.setValue != null && (g.setValue = !!t.setValue), t.default != null && (g.default = String(t.default)), t.position) {
      default:
        if (typeof t.position == "number") {
          g.position = t.position;
          break;
        }
        break;
      case "BOTTOM":
      case 0:
        g.position = 0;
        break;
    }
    switch (t.acceptFile) {
      default:
        if (typeof t.acceptFile == "number") {
          g.acceptFile = t.acceptFile;
          break;
        }
        break;
      case "NONE":
      case 0:
        g.acceptFile = 0;
        break;
      case "SINGLE":
      case 1:
        g.acceptFile = 1;
        break;
      case "MULTIPLE":
      case 2:
        g.acceptFile = 2;
        break;
      case "DIRECTORY":
      case 3:
        g.acceptFile = 3;
        break;
    }
    if (t.fileType) {
      if (!Array.isArray(t.fileType)) throw TypeError(".ChatInput.fileType: array expected");
      g.fileType = [];
      for (let d = 0; d < t.fileType.length; ++d) g.fileType[d] = String(t.fileType[d]);
    }
    return t.maxUploadSizeMb != null && (g.maxUploadSizeMb = t.maxUploadSizeMb | 0), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.fileType = []), g.defaults && (d.id = "", d.placeholder = "", d.maxChars = 0, d.disabled = !1, d.value = "", d.setValue = !1, d.default = "", d.position = g.enums === String ? "BOTTOM" : 0, d.acceptFile = g.enums === String ? "NONE" : 0, d.maxUploadSizeMb = 0), t.id != null && t.hasOwnProperty("id") && (d.id = t.id), t.placeholder != null && t.hasOwnProperty("placeholder") && (d.placeholder = t.placeholder), t.maxChars != null && t.hasOwnProperty("maxChars") && (d.maxChars = t.maxChars), t.disabled != null && t.hasOwnProperty("disabled") && (d.disabled = t.disabled), t.value != null && t.hasOwnProperty("value") && (d.value = t.value), t.setValue != null && t.hasOwnProperty("setValue") && (d.setValue = t.setValue), t.default != null && t.hasOwnProperty("default") && (d.default = t.default), t.position != null && t.hasOwnProperty("position") && (d.position = g.enums === String ? $root.ChatInput.Position[t.position] === void 0 ? t.position : $root.ChatInput.Position[t.position] : t.position), t.acceptFile != null && t.hasOwnProperty("acceptFile") && (d.acceptFile = g.enums === String ? $root.ChatInput.AcceptFile[t.acceptFile] === void 0 ? t.acceptFile : $root.ChatInput.AcceptFile[t.acceptFile] : t.acceptFile), t.fileType && t.fileType.length) {
      d.fileType = [];
      for (let k = 0; k < t.fileType.length; ++k) d.fileType[k] = t.fileType[k];
    }
    return t.maxUploadSizeMb != null && t.hasOwnProperty("maxUploadSizeMb") && (d.maxUploadSizeMb = t.maxUploadSizeMb), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ChatInput";
  }, n.Position = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "BOTTOM"] = 0, g;
  })(), n.AcceptFile = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "NONE"] = 0, g[t[1] = "SINGLE"] = 1, g[t[2] = "MULTIPLE"] = 2, g[t[3] = "DIRECTORY"] = 3, g;
  })(), n;
})();
$root.Checkbox = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.default = !1, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = !1, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.type = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.default != null && Object.hasOwnProperty.call(t, "default") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(t.default), t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.formId), t.value != null && Object.hasOwnProperty.call(t, "value") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(t.value), t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(t.setValue), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), t.type != null && Object.hasOwnProperty.call(t, "type") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(t.type), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Checkbox();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.id = t.string();
          break;
        }
        case 2: {
          H.label = t.string();
          break;
        }
        case 3: {
          H.default = t.bool();
          break;
        }
        case 4: {
          H.help = t.string();
          break;
        }
        case 5: {
          H.formId = t.string();
          break;
        }
        case 6: {
          H.value = t.bool();
          break;
        }
        case 7: {
          H.setValue = t.bool();
          break;
        }
        case 8: {
          H.disabled = t.bool();
          break;
        }
        case 9: {
          H.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 10: {
          H.type = t.int32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id)) return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label)) return "label: string expected";
    if (t.default != null && t.hasOwnProperty("default") && typeof t.default != "boolean") return "default: boolean expected";
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help)) return "help: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId)) return "formId: string expected";
    if (t.value != null && t.hasOwnProperty("value") && typeof t.value != "boolean") return "value: boolean expected";
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean") return "setValue: boolean expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean") return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let g = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (g) return "labelVisibility." + g;
    }
    if (t.type != null && t.hasOwnProperty("type")) switch (t.type) {
      default:
        return "type: enum value expected";
      case 0:
      case 1:
        break;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Checkbox) return t;
    let g = new $root.Checkbox();
    if (t.id != null && (g.id = String(t.id)), t.label != null && (g.label = String(t.label)), t.default != null && (g.default = !!t.default), t.help != null && (g.help = String(t.help)), t.formId != null && (g.formId = String(t.formId)), t.value != null && (g.value = !!t.value), t.setValue != null && (g.setValue = !!t.setValue), t.disabled != null && (g.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object") throw TypeError(".Checkbox.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    switch (t.type) {
      default:
        if (typeof t.type == "number") {
          g.type = t.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        g.type = 0;
        break;
      case "TOGGLE":
      case 1:
        g.type = 1;
        break;
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.id = "", d.label = "", d.default = !1, d.help = "", d.formId = "", d.value = !1, d.setValue = !1, d.disabled = !1, d.labelVisibility = null, d.type = g.enums === String ? "DEFAULT" : 0), t.id != null && t.hasOwnProperty("id") && (d.id = t.id), t.label != null && t.hasOwnProperty("label") && (d.label = t.label), t.default != null && t.hasOwnProperty("default") && (d.default = t.default), t.help != null && t.hasOwnProperty("help") && (d.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (d.formId = t.formId), t.value != null && t.hasOwnProperty("value") && (d.value = t.value), t.setValue != null && t.hasOwnProperty("setValue") && (d.setValue = t.setValue), t.disabled != null && t.hasOwnProperty("disabled") && (d.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (d.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, g)), t.type != null && t.hasOwnProperty("type") && (d.type = g.enums === String ? $root.Checkbox.StyleType[t.type] === void 0 ? t.type : $root.Checkbox.StyleType[t.type] : t.type), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Checkbox";
  }, n.StyleType = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "DEFAULT"] = 0, g[t[1] = "TOGGLE"] = 1, g;
  })(), n;
})();
$root.Code = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.codeText = "", n.prototype.language = "", n.prototype.showLineNumbers = !1, n.prototype.wrapLines = !1, n.prototype.height = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.codeText != null && Object.hasOwnProperty.call(t, "codeText") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.codeText), t.language != null && Object.hasOwnProperty.call(t, "language") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.language), t.showLineNumbers != null && Object.hasOwnProperty.call(t, "showLineNumbers") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(t.showLineNumbers), t.wrapLines != null && Object.hasOwnProperty.call(t, "wrapLines") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(t.wrapLines), t.height != null && Object.hasOwnProperty.call(t, "height") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(t.height), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Code();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.codeText = t.string();
          break;
        }
        case 2: {
          H.language = t.string();
          break;
        }
        case 3: {
          H.showLineNumbers = t.bool();
          break;
        }
        case 4: {
          H.wrapLines = t.bool();
          break;
        }
        case 5: {
          H.height = t.uint32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.codeText != null && t.hasOwnProperty("codeText") && !$util.isString(t.codeText) ? "codeText: string expected" : t.language != null && t.hasOwnProperty("language") && !$util.isString(t.language) ? "language: string expected" : t.showLineNumbers != null && t.hasOwnProperty("showLineNumbers") && typeof t.showLineNumbers != "boolean" ? "showLineNumbers: boolean expected" : t.wrapLines != null && t.hasOwnProperty("wrapLines") && typeof t.wrapLines != "boolean" ? "wrapLines: boolean expected" : t.height != null && t.hasOwnProperty("height") && !$util.isInteger(t.height) ? "height: integer expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Code) return t;
    let g = new $root.Code();
    return t.codeText != null && (g.codeText = String(t.codeText)), t.language != null && (g.language = String(t.language)), t.showLineNumbers != null && (g.showLineNumbers = !!t.showLineNumbers), t.wrapLines != null && (g.wrapLines = !!t.wrapLines), t.height != null && (g.height = t.height >>> 0), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.codeText = "", d.language = "", d.showLineNumbers = !1, d.wrapLines = !1, d.height = 0), t.codeText != null && t.hasOwnProperty("codeText") && (d.codeText = t.codeText), t.language != null && t.hasOwnProperty("language") && (d.language = t.language), t.showLineNumbers != null && t.hasOwnProperty("showLineNumbers") && (d.showLineNumbers = t.showLineNumbers), t.wrapLines != null && t.hasOwnProperty("wrapLines") && (d.wrapLines = t.wrapLines), t.height != null && t.hasOwnProperty("height") && (d.height = t.height), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Code";
  }, n;
})();
$root.ColorPicker = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.default = "", n.prototype.help = "", n.prototype.formId = "", n.prototype.value = "", n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.default != null && Object.hasOwnProperty.call(t, "default") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.default), t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.formId), t.value != null && Object.hasOwnProperty.call(t, "value") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.value), t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(t.setValue), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ColorPicker();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.id = t.string();
          break;
        }
        case 2: {
          H.label = t.string();
          break;
        }
        case 3: {
          H.default = t.string();
          break;
        }
        case 4: {
          H.help = t.string();
          break;
        }
        case 5: {
          H.formId = t.string();
          break;
        }
        case 6: {
          H.value = t.string();
          break;
        }
        case 7: {
          H.setValue = t.bool();
          break;
        }
        case 8: {
          H.disabled = t.bool();
          break;
        }
        case 9: {
          H.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id)) return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label)) return "label: string expected";
    if (t.default != null && t.hasOwnProperty("default") && !$util.isString(t.default)) return "default: string expected";
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help)) return "help: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId)) return "formId: string expected";
    if (t.value != null && t.hasOwnProperty("value") && !$util.isString(t.value)) return "value: string expected";
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean") return "setValue: boolean expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean") return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let g = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (g) return "labelVisibility." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ColorPicker) return t;
    let g = new $root.ColorPicker();
    if (t.id != null && (g.id = String(t.id)), t.label != null && (g.label = String(t.label)), t.default != null && (g.default = String(t.default)), t.help != null && (g.help = String(t.help)), t.formId != null && (g.formId = String(t.formId)), t.value != null && (g.value = String(t.value)), t.setValue != null && (g.setValue = !!t.setValue), t.disabled != null && (g.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object") throw TypeError(".ColorPicker.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.id = "", d.label = "", d.default = "", d.help = "", d.formId = "", d.value = "", d.setValue = !1, d.disabled = !1, d.labelVisibility = null), t.id != null && t.hasOwnProperty("id") && (d.id = t.id), t.label != null && t.hasOwnProperty("label") && (d.label = t.label), t.default != null && t.hasOwnProperty("default") && (d.default = t.default), t.help != null && t.hasOwnProperty("help") && (d.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (d.formId = t.formId), t.value != null && t.hasOwnProperty("value") && (d.value = t.value), t.setValue != null && t.hasOwnProperty("setValue") && (d.setValue = t.setValue), t.disabled != null && t.hasOwnProperty("disabled") && (d.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (d.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ColorPicker";
  }, n;
})();
$root.DataFrame = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.prototype.index = null, n.prototype.columns = null, n.prototype.style = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.data != null && Object.hasOwnProperty.call(t, "data") && $root.Table.encode(t.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t.index != null && Object.hasOwnProperty.call(t, "index") && $root.Index.encode(t.index, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.columns != null && Object.hasOwnProperty.call(t, "columns") && $root.Index.encode(t.columns, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), t.style != null && Object.hasOwnProperty.call(t, "style") && $root.TableStyle.encode(t.style, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.DataFrame();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.data = $root.Table.decode(t, t.uint32());
          break;
        }
        case 2: {
          H.index = $root.Index.decode(t, t.uint32());
          break;
        }
        case 3: {
          H.columns = $root.Index.decode(t, t.uint32());
          break;
        }
        case 4: {
          H.style = $root.TableStyle.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      let g = $root.Table.verify(t.data);
      if (g) return "data." + g;
    }
    if (t.index != null && t.hasOwnProperty("index")) {
      let g = $root.Index.verify(t.index);
      if (g) return "index." + g;
    }
    if (t.columns != null && t.hasOwnProperty("columns")) {
      let g = $root.Index.verify(t.columns);
      if (g) return "columns." + g;
    }
    if (t.style != null && t.hasOwnProperty("style")) {
      let g = $root.TableStyle.verify(t.style);
      if (g) return "style." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.DataFrame) return t;
    let g = new $root.DataFrame();
    if (t.data != null) {
      if (typeof t.data != "object") throw TypeError(".DataFrame.data: object expected");
      g.data = $root.Table.fromObject(t.data);
    }
    if (t.index != null) {
      if (typeof t.index != "object") throw TypeError(".DataFrame.index: object expected");
      g.index = $root.Index.fromObject(t.index);
    }
    if (t.columns != null) {
      if (typeof t.columns != "object") throw TypeError(".DataFrame.columns: object expected");
      g.columns = $root.Index.fromObject(t.columns);
    }
    if (t.style != null) {
      if (typeof t.style != "object") throw TypeError(".DataFrame.style: object expected");
      g.style = $root.TableStyle.fromObject(t.style);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.data = null, d.index = null, d.columns = null, d.style = null), t.data != null && t.hasOwnProperty("data") && (d.data = $root.Table.toObject(t.data, g)), t.index != null && t.hasOwnProperty("index") && (d.index = $root.Index.toObject(t.index, g)), t.columns != null && t.hasOwnProperty("columns") && (d.columns = $root.Index.toObject(t.columns, g)), t.style != null && t.hasOwnProperty("style") && (d.style = $root.TableStyle.toObject(t.style, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/DataFrame";
  }, n;
})();
$root.Index = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.plainIndex = null, n.prototype.rangeIndex = null, n.prototype.multiIndex = null, n.prototype.datetimeIndex = null, n.prototype.timedeltaIndex = null, n.prototype.int_64Index = null, n.prototype.float_64Index = null;
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util.oneOfGetter(t = ["plainIndex", "rangeIndex", "multiIndex", "datetimeIndex", "timedeltaIndex", "int_64Index", "float_64Index"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.plainIndex != null && Object.hasOwnProperty.call(g, "plainIndex") && $root.PlainIndex.encode(g.plainIndex, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.rangeIndex != null && Object.hasOwnProperty.call(g, "rangeIndex") && $root.RangeIndex.encode(g.rangeIndex, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.multiIndex != null && Object.hasOwnProperty.call(g, "multiIndex") && $root.MultiIndex.encode(g.multiIndex, d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.datetimeIndex != null && Object.hasOwnProperty.call(g, "datetimeIndex") && $root.DatetimeIndex.encode(g.datetimeIndex, d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.timedeltaIndex != null && Object.hasOwnProperty.call(g, "timedeltaIndex") && $root.TimedeltaIndex.encode(g.timedeltaIndex, d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.int_64Index != null && Object.hasOwnProperty.call(g, "int_64Index") && $root.Int64Index.encode(g.int_64Index, d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.float_64Index != null && Object.hasOwnProperty.call(g, "float_64Index") && $root.Float64Index.encode(g.float_64Index, d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Index();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.plainIndex = $root.PlainIndex.decode(g, g.uint32());
          break;
        }
        case 2: {
          AA.rangeIndex = $root.RangeIndex.decode(g, g.uint32());
          break;
        }
        case 4: {
          AA.multiIndex = $root.MultiIndex.decode(g, g.uint32());
          break;
        }
        case 6: {
          AA.datetimeIndex = $root.DatetimeIndex.decode(g, g.uint32());
          break;
        }
        case 7: {
          AA.timedeltaIndex = $root.TimedeltaIndex.decode(g, g.uint32());
          break;
        }
        case 9: {
          AA.int_64Index = $root.Int64Index.decode(g, g.uint32());
          break;
        }
        case 11: {
          AA.float_64Index = $root.Float64Index.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.plainIndex != null && g.hasOwnProperty("plainIndex")) {
      d.type = 1;
      {
        let k = $root.PlainIndex.verify(g.plainIndex);
        if (k) return "plainIndex." + k;
      }
    }
    if (g.rangeIndex != null && g.hasOwnProperty("rangeIndex")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.RangeIndex.verify(g.rangeIndex);
        if (k) return "rangeIndex." + k;
      }
    }
    if (g.multiIndex != null && g.hasOwnProperty("multiIndex")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.MultiIndex.verify(g.multiIndex);
        if (k) return "multiIndex." + k;
      }
    }
    if (g.datetimeIndex != null && g.hasOwnProperty("datetimeIndex")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.DatetimeIndex.verify(g.datetimeIndex);
        if (k) return "datetimeIndex." + k;
      }
    }
    if (g.timedeltaIndex != null && g.hasOwnProperty("timedeltaIndex")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.TimedeltaIndex.verify(g.timedeltaIndex);
        if (k) return "timedeltaIndex." + k;
      }
    }
    if (g.int_64Index != null && g.hasOwnProperty("int_64Index")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Int64Index.verify(g.int_64Index);
        if (k) return "int_64Index." + k;
      }
    }
    if (g.float_64Index != null && g.hasOwnProperty("float_64Index")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Float64Index.verify(g.float_64Index);
        if (k) return "float_64Index." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Index) return g;
    let d = new $root.Index();
    if (g.plainIndex != null) {
      if (typeof g.plainIndex != "object") throw TypeError(".Index.plainIndex: object expected");
      d.plainIndex = $root.PlainIndex.fromObject(g.plainIndex);
    }
    if (g.rangeIndex != null) {
      if (typeof g.rangeIndex != "object") throw TypeError(".Index.rangeIndex: object expected");
      d.rangeIndex = $root.RangeIndex.fromObject(g.rangeIndex);
    }
    if (g.multiIndex != null) {
      if (typeof g.multiIndex != "object") throw TypeError(".Index.multiIndex: object expected");
      d.multiIndex = $root.MultiIndex.fromObject(g.multiIndex);
    }
    if (g.datetimeIndex != null) {
      if (typeof g.datetimeIndex != "object") throw TypeError(".Index.datetimeIndex: object expected");
      d.datetimeIndex = $root.DatetimeIndex.fromObject(g.datetimeIndex);
    }
    if (g.timedeltaIndex != null) {
      if (typeof g.timedeltaIndex != "object") throw TypeError(".Index.timedeltaIndex: object expected");
      d.timedeltaIndex = $root.TimedeltaIndex.fromObject(g.timedeltaIndex);
    }
    if (g.int_64Index != null) {
      if (typeof g.int_64Index != "object") throw TypeError(".Index.int_64Index: object expected");
      d.int_64Index = $root.Int64Index.fromObject(g.int_64Index);
    }
    if (g.float_64Index != null) {
      if (typeof g.float_64Index != "object") throw TypeError(".Index.float_64Index: object expected");
      d.float_64Index = $root.Float64Index.fromObject(g.float_64Index);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return g.plainIndex != null && g.hasOwnProperty("plainIndex") && (k.plainIndex = $root.PlainIndex.toObject(g.plainIndex, d), d.oneofs && (k.type = "plainIndex")), g.rangeIndex != null && g.hasOwnProperty("rangeIndex") && (k.rangeIndex = $root.RangeIndex.toObject(g.rangeIndex, d), d.oneofs && (k.type = "rangeIndex")), g.multiIndex != null && g.hasOwnProperty("multiIndex") && (k.multiIndex = $root.MultiIndex.toObject(g.multiIndex, d), d.oneofs && (k.type = "multiIndex")), g.datetimeIndex != null && g.hasOwnProperty("datetimeIndex") && (k.datetimeIndex = $root.DatetimeIndex.toObject(g.datetimeIndex, d), d.oneofs && (k.type = "datetimeIndex")), g.timedeltaIndex != null && g.hasOwnProperty("timedeltaIndex") && (k.timedeltaIndex = $root.TimedeltaIndex.toObject(g.timedeltaIndex, d), d.oneofs && (k.type = "timedeltaIndex")), g.int_64Index != null && g.hasOwnProperty("int_64Index") && (k.int_64Index = $root.Int64Index.toObject(g.int_64Index, d), d.oneofs && (k.type = "int_64Index")), g.float_64Index != null && g.hasOwnProperty("float_64Index") && (k.float_64Index = $root.Float64Index.toObject(g.float_64Index, d), d.oneofs && (k.type = "float_64Index")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Index";
  }, n;
})();
$root.PlainIndex = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.data != null && Object.hasOwnProperty.call(t, "data") && $root.AnyArray.encode(t.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.PlainIndex();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.data = $root.AnyArray.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      let g = $root.AnyArray.verify(t.data);
      if (g) return "data." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.PlainIndex) return t;
    let g = new $root.PlainIndex();
    if (t.data != null) {
      if (typeof t.data != "object") throw TypeError(".PlainIndex.data: object expected");
      g.data = $root.AnyArray.fromObject(t.data);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.data = null), t.data != null && t.hasOwnProperty("data") && (d.data = $root.AnyArray.toObject(t.data, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/PlainIndex";
  }, n;
})();
$root.RangeIndex = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.start = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, n.prototype.stop = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.start != null && Object.hasOwnProperty.call(t, "start") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int64(t.start), t.stop != null && Object.hasOwnProperty.call(t, "stop") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(t.stop), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.RangeIndex();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.start = t.int64();
          break;
        }
        case 2: {
          H.stop = t.int64();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.start != null && t.hasOwnProperty("start") && !$util.isInteger(t.start) && !(t.start && $util.isInteger(t.start.low) && $util.isInteger(t.start.high)) ? "start: integer|Long expected" : t.stop != null && t.hasOwnProperty("stop") && !$util.isInteger(t.stop) && !(t.stop && $util.isInteger(t.stop.low) && $util.isInteger(t.stop.high)) ? "stop: integer|Long expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.RangeIndex) return t;
    let g = new $root.RangeIndex();
    return t.start != null && ($util.Long ? (g.start = $util.Long.fromValue(t.start)).unsigned = !1 : typeof t.start == "string" ? g.start = parseInt(t.start, 10) : typeof t.start == "number" ? g.start = t.start : typeof t.start == "object" && (g.start = new $util.LongBits(t.start.low >>> 0, t.start.high >>> 0).toNumber())), t.stop != null && ($util.Long ? (g.stop = $util.Long.fromValue(t.stop)).unsigned = !1 : typeof t.stop == "string" ? g.stop = parseInt(t.stop, 10) : typeof t.stop == "number" ? g.stop = t.stop : typeof t.stop == "object" && (g.stop = new $util.LongBits(t.stop.low >>> 0, t.stop.high >>> 0).toNumber())), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if (g.defaults) {
      if ($util.Long) {
        let k = new $util.Long(0, 0, !1);
        d.start = g.longs === String ? k.toString() : g.longs === Number ? k.toNumber() : k;
      } else d.start = g.longs === String ? "0" : 0;
      if ($util.Long) {
        let k = new $util.Long(0, 0, !1);
        d.stop = g.longs === String ? k.toString() : g.longs === Number ? k.toNumber() : k;
      } else d.stop = g.longs === String ? "0" : 0;
    }
    return t.start != null && t.hasOwnProperty("start") && (typeof t.start == "number" ? d.start = g.longs === String ? String(t.start) : t.start : d.start = g.longs === String ? $util.Long.prototype.toString.call(t.start) : g.longs === Number ? new $util.LongBits(t.start.low >>> 0, t.start.high >>> 0).toNumber() : t.start), t.stop != null && t.hasOwnProperty("stop") && (typeof t.stop == "number" ? d.stop = g.longs === String ? String(t.stop) : t.stop : d.stop = g.longs === String ? $util.Long.prototype.toString.call(t.stop) : g.longs === Number ? new $util.LongBits(t.stop.low >>> 0, t.stop.high >>> 0).toNumber() : t.stop), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/RangeIndex";
  }, n;
})();
$root.MultiIndex = (() => {
  function n(t) {
    if (this.levels = [], this.labels = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.levels = $util.emptyArray, n.prototype.labels = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.levels != null && t.levels.length) for (let d = 0; d < t.levels.length; ++d) $root.Index.encode(t.levels[d], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (t.labels != null && t.labels.length) for (let d = 0; d < t.labels.length; ++d) $root.Int32Array.encode(t.labels[d], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.MultiIndex();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.levels && H.levels.length || (H.levels = []), H.levels.push($root.Index.decode(t, t.uint32()));
          break;
        }
        case 2: {
          H.labels && H.labels.length || (H.labels = []), H.labels.push($root.Int32Array.decode(t, t.uint32()));
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.levels != null && t.hasOwnProperty("levels")) {
      if (!Array.isArray(t.levels)) return "levels: array expected";
      for (let g = 0; g < t.levels.length; ++g) {
        let d = $root.Index.verify(t.levels[g]);
        if (d) return "levels." + d;
      }
    }
    if (t.labels != null && t.hasOwnProperty("labels")) {
      if (!Array.isArray(t.labels)) return "labels: array expected";
      for (let g = 0; g < t.labels.length; ++g) {
        let d = $root.Int32Array.verify(t.labels[g]);
        if (d) return "labels." + d;
      }
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.MultiIndex) return t;
    let g = new $root.MultiIndex();
    if (t.levels) {
      if (!Array.isArray(t.levels)) throw TypeError(".MultiIndex.levels: array expected");
      g.levels = [];
      for (let d = 0; d < t.levels.length; ++d) {
        if (typeof t.levels[d] != "object") throw TypeError(".MultiIndex.levels: object expected");
        g.levels[d] = $root.Index.fromObject(t.levels[d]);
      }
    }
    if (t.labels) {
      if (!Array.isArray(t.labels)) throw TypeError(".MultiIndex.labels: array expected");
      g.labels = [];
      for (let d = 0; d < t.labels.length; ++d) {
        if (typeof t.labels[d] != "object") throw TypeError(".MultiIndex.labels: object expected");
        g.labels[d] = $root.Int32Array.fromObject(t.labels[d]);
      }
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.levels = [], d.labels = []), t.levels && t.levels.length) {
      d.levels = [];
      for (let k = 0; k < t.levels.length; ++k) d.levels[k] = $root.Index.toObject(t.levels[k], g);
    }
    if (t.labels && t.labels.length) {
      d.labels = [];
      for (let k = 0; k < t.labels.length; ++k) d.labels[k] = $root.Int32Array.toObject(t.labels[k], g);
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/MultiIndex";
  }, n;
})();
$root.DatetimeIndex = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.data != null && Object.hasOwnProperty.call(t, "data") && $root.StringArray.encode(t.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.DatetimeIndex();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.data = $root.StringArray.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      let g = $root.StringArray.verify(t.data);
      if (g) return "data." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.DatetimeIndex) return t;
    let g = new $root.DatetimeIndex();
    if (t.data != null) {
      if (typeof t.data != "object") throw TypeError(".DatetimeIndex.data: object expected");
      g.data = $root.StringArray.fromObject(t.data);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.data = null), t.data != null && t.hasOwnProperty("data") && (d.data = $root.StringArray.toObject(t.data, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/DatetimeIndex";
  }, n;
})();
$root.TimedeltaIndex = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.data != null && Object.hasOwnProperty.call(t, "data") && $root.Int64Array.encode(t.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.TimedeltaIndex();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.data = $root.Int64Array.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      let g = $root.Int64Array.verify(t.data);
      if (g) return "data." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.TimedeltaIndex) return t;
    let g = new $root.TimedeltaIndex();
    if (t.data != null) {
      if (typeof t.data != "object") throw TypeError(".TimedeltaIndex.data: object expected");
      g.data = $root.Int64Array.fromObject(t.data);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.data = null), t.data != null && t.hasOwnProperty("data") && (d.data = $root.Int64Array.toObject(t.data, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/TimedeltaIndex";
  }, n;
})();
$root.Int64Index = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.data != null && Object.hasOwnProperty.call(t, "data") && $root.Int64Array.encode(t.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Int64Index();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.data = $root.Int64Array.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      let g = $root.Int64Array.verify(t.data);
      if (g) return "data." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Int64Index) return t;
    let g = new $root.Int64Index();
    if (t.data != null) {
      if (typeof t.data != "object") throw TypeError(".Int64Index.data: object expected");
      g.data = $root.Int64Array.fromObject(t.data);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.data = null), t.data != null && t.hasOwnProperty("data") && (d.data = $root.Int64Array.toObject(t.data, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Int64Index";
  }, n;
})();
$root.Float64Index = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.data = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.data != null && Object.hasOwnProperty.call(t, "data") && $root.DoubleArray.encode(t.data, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Float64Index();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.data = $root.DoubleArray.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      let g = $root.DoubleArray.verify(t.data);
      if (g) return "data." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Float64Index) return t;
    let g = new $root.Float64Index();
    if (t.data != null) {
      if (typeof t.data != "object") throw TypeError(".Float64Index.data: object expected");
      g.data = $root.DoubleArray.fromObject(t.data);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.data = null), t.data != null && t.hasOwnProperty("data") && (d.data = $root.DoubleArray.toObject(t.data, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Float64Index";
  }, n;
})();
$root.CSSStyle = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.property = "", n.prototype.value = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.property != null && Object.hasOwnProperty.call(t, "property") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.property), t.value != null && Object.hasOwnProperty.call(t, "value") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.value), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.CSSStyle();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.property = t.string();
          break;
        }
        case 2: {
          H.value = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.property != null && t.hasOwnProperty("property") && !$util.isString(t.property) ? "property: string expected" : t.value != null && t.hasOwnProperty("value") && !$util.isString(t.value) ? "value: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.CSSStyle) return t;
    let g = new $root.CSSStyle();
    return t.property != null && (g.property = String(t.property)), t.value != null && (g.value = String(t.value)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.property = "", d.value = ""), t.property != null && t.hasOwnProperty("property") && (d.property = t.property), t.value != null && t.hasOwnProperty("value") && (d.value = t.value), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/CSSStyle";
  }, n;
})();
$root.CellStyle = (() => {
  function n(t) {
    if (this.css = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.css = $util.emptyArray, n.prototype.displayValue = "", n.prototype.hasDisplayValue = !1, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.css != null && t.css.length) for (let d = 0; d < t.css.length; ++d) $root.CSSStyle.encode(t.css[d], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return t.displayValue != null && Object.hasOwnProperty.call(t, "displayValue") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.displayValue), t.hasDisplayValue != null && Object.hasOwnProperty.call(t, "hasDisplayValue") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(t.hasDisplayValue), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.CellStyle();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.css && H.css.length || (H.css = []), H.css.push($root.CSSStyle.decode(t, t.uint32()));
          break;
        }
        case 2: {
          H.displayValue = t.string();
          break;
        }
        case 3: {
          H.hasDisplayValue = t.bool();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.css != null && t.hasOwnProperty("css")) {
      if (!Array.isArray(t.css)) return "css: array expected";
      for (let g = 0; g < t.css.length; ++g) {
        let d = $root.CSSStyle.verify(t.css[g]);
        if (d) return "css." + d;
      }
    }
    return t.displayValue != null && t.hasOwnProperty("displayValue") && !$util.isString(t.displayValue) ? "displayValue: string expected" : t.hasDisplayValue != null && t.hasOwnProperty("hasDisplayValue") && typeof t.hasDisplayValue != "boolean" ? "hasDisplayValue: boolean expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.CellStyle) return t;
    let g = new $root.CellStyle();
    if (t.css) {
      if (!Array.isArray(t.css)) throw TypeError(".CellStyle.css: array expected");
      g.css = [];
      for (let d = 0; d < t.css.length; ++d) {
        if (typeof t.css[d] != "object") throw TypeError(".CellStyle.css: object expected");
        g.css[d] = $root.CSSStyle.fromObject(t.css[d]);
      }
    }
    return t.displayValue != null && (g.displayValue = String(t.displayValue)), t.hasDisplayValue != null && (g.hasDisplayValue = !!t.hasDisplayValue), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.css = []), g.defaults && (d.displayValue = "", d.hasDisplayValue = !1), t.css && t.css.length) {
      d.css = [];
      for (let k = 0; k < t.css.length; ++k) d.css[k] = $root.CSSStyle.toObject(t.css[k], g);
    }
    return t.displayValue != null && t.hasOwnProperty("displayValue") && (d.displayValue = t.displayValue), t.hasDisplayValue != null && t.hasOwnProperty("hasDisplayValue") && (d.hasDisplayValue = t.hasDisplayValue), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/CellStyle";
  }, n;
})();
$root.CellStyleArray = (() => {
  function n(t) {
    if (this.styles = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.styles = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.styles != null && t.styles.length) for (let d = 0; d < t.styles.length; ++d) $root.CellStyle.encode(t.styles[d], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.CellStyleArray();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.styles && H.styles.length || (H.styles = []), H.styles.push($root.CellStyle.decode(t, t.uint32()));
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.styles != null && t.hasOwnProperty("styles")) {
      if (!Array.isArray(t.styles)) return "styles: array expected";
      for (let g = 0; g < t.styles.length; ++g) {
        let d = $root.CellStyle.verify(t.styles[g]);
        if (d) return "styles." + d;
      }
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.CellStyleArray) return t;
    let g = new $root.CellStyleArray();
    if (t.styles) {
      if (!Array.isArray(t.styles)) throw TypeError(".CellStyleArray.styles: array expected");
      g.styles = [];
      for (let d = 0; d < t.styles.length; ++d) {
        if (typeof t.styles[d] != "object") throw TypeError(".CellStyleArray.styles: object expected");
        g.styles[d] = $root.CellStyle.fromObject(t.styles[d]);
      }
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.styles = []), t.styles && t.styles.length) {
      d.styles = [];
      for (let k = 0; k < t.styles.length; ++k) d.styles[k] = $root.CellStyle.toObject(t.styles[k], g);
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/CellStyleArray";
  }, n;
})();
$root.AnyArray = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.strings = null, n.prototype.doubles = null, n.prototype.int64s = null, n.prototype.datetimes = null, n.prototype.timedeltas = null;
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util.oneOfGetter(t = ["strings", "doubles", "int64s", "datetimes", "timedeltas"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.strings != null && Object.hasOwnProperty.call(g, "strings") && $root.StringArray.encode(g.strings, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.doubles != null && Object.hasOwnProperty.call(g, "doubles") && $root.DoubleArray.encode(g.doubles, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.int64s != null && Object.hasOwnProperty.call(g, "int64s") && $root.Int64Array.encode(g.int64s, d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.datetimes != null && Object.hasOwnProperty.call(g, "datetimes") && $root.StringArray.encode(g.datetimes, d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.timedeltas != null && Object.hasOwnProperty.call(g, "timedeltas") && $root.Int64Array.encode(g.timedeltas, d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.AnyArray();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.strings = $root.StringArray.decode(g, g.uint32());
          break;
        }
        case 2: {
          AA.doubles = $root.DoubleArray.decode(g, g.uint32());
          break;
        }
        case 3: {
          AA.int64s = $root.Int64Array.decode(g, g.uint32());
          break;
        }
        case 4: {
          AA.datetimes = $root.StringArray.decode(g, g.uint32());
          break;
        }
        case 5: {
          AA.timedeltas = $root.Int64Array.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.strings != null && g.hasOwnProperty("strings")) {
      d.type = 1;
      {
        let k = $root.StringArray.verify(g.strings);
        if (k) return "strings." + k;
      }
    }
    if (g.doubles != null && g.hasOwnProperty("doubles")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.DoubleArray.verify(g.doubles);
        if (k) return "doubles." + k;
      }
    }
    if (g.int64s != null && g.hasOwnProperty("int64s")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Int64Array.verify(g.int64s);
        if (k) return "int64s." + k;
      }
    }
    if (g.datetimes != null && g.hasOwnProperty("datetimes")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.StringArray.verify(g.datetimes);
        if (k) return "datetimes." + k;
      }
    }
    if (g.timedeltas != null && g.hasOwnProperty("timedeltas")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Int64Array.verify(g.timedeltas);
        if (k) return "timedeltas." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.AnyArray) return g;
    let d = new $root.AnyArray();
    if (g.strings != null) {
      if (typeof g.strings != "object") throw TypeError(".AnyArray.strings: object expected");
      d.strings = $root.StringArray.fromObject(g.strings);
    }
    if (g.doubles != null) {
      if (typeof g.doubles != "object") throw TypeError(".AnyArray.doubles: object expected");
      d.doubles = $root.DoubleArray.fromObject(g.doubles);
    }
    if (g.int64s != null) {
      if (typeof g.int64s != "object") throw TypeError(".AnyArray.int64s: object expected");
      d.int64s = $root.Int64Array.fromObject(g.int64s);
    }
    if (g.datetimes != null) {
      if (typeof g.datetimes != "object") throw TypeError(".AnyArray.datetimes: object expected");
      d.datetimes = $root.StringArray.fromObject(g.datetimes);
    }
    if (g.timedeltas != null) {
      if (typeof g.timedeltas != "object") throw TypeError(".AnyArray.timedeltas: object expected");
      d.timedeltas = $root.Int64Array.fromObject(g.timedeltas);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return g.strings != null && g.hasOwnProperty("strings") && (k.strings = $root.StringArray.toObject(g.strings, d), d.oneofs && (k.type = "strings")), g.doubles != null && g.hasOwnProperty("doubles") && (k.doubles = $root.DoubleArray.toObject(g.doubles, d), d.oneofs && (k.type = "doubles")), g.int64s != null && g.hasOwnProperty("int64s") && (k.int64s = $root.Int64Array.toObject(g.int64s, d), d.oneofs && (k.type = "int64s")), g.datetimes != null && g.hasOwnProperty("datetimes") && (k.datetimes = $root.StringArray.toObject(g.datetimes, d), d.oneofs && (k.type = "datetimes")), g.timedeltas != null && g.hasOwnProperty("timedeltas") && (k.timedeltas = $root.Int64Array.toObject(g.timedeltas, d), d.oneofs && (k.type = "timedeltas")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/AnyArray";
  }, n;
})();
$root.Table = (() => {
  function n(t) {
    if (this.cols = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.cols = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.cols != null && t.cols.length) for (let d = 0; d < t.cols.length; ++d) $root.AnyArray.encode(t.cols[d], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Table();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.cols && H.cols.length || (H.cols = []), H.cols.push($root.AnyArray.decode(t, t.uint32()));
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.cols != null && t.hasOwnProperty("cols")) {
      if (!Array.isArray(t.cols)) return "cols: array expected";
      for (let g = 0; g < t.cols.length; ++g) {
        let d = $root.AnyArray.verify(t.cols[g]);
        if (d) return "cols." + d;
      }
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Table) return t;
    let g = new $root.Table();
    if (t.cols) {
      if (!Array.isArray(t.cols)) throw TypeError(".Table.cols: array expected");
      g.cols = [];
      for (let d = 0; d < t.cols.length; ++d) {
        if (typeof t.cols[d] != "object") throw TypeError(".Table.cols: object expected");
        g.cols[d] = $root.AnyArray.fromObject(t.cols[d]);
      }
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.cols = []), t.cols && t.cols.length) {
      d.cols = [];
      for (let k = 0; k < t.cols.length; ++k) d.cols[k] = $root.AnyArray.toObject(t.cols[k], g);
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Table";
  }, n;
})();
$root.TableStyle = (() => {
  function n(t) {
    if (this.cols = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.cols = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.cols != null && t.cols.length) for (let d = 0; d < t.cols.length; ++d) $root.CellStyleArray.encode(t.cols[d], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.TableStyle();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.cols && H.cols.length || (H.cols = []), H.cols.push($root.CellStyleArray.decode(t, t.uint32()));
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.cols != null && t.hasOwnProperty("cols")) {
      if (!Array.isArray(t.cols)) return "cols: array expected";
      for (let g = 0; g < t.cols.length; ++g) {
        let d = $root.CellStyleArray.verify(t.cols[g]);
        if (d) return "cols." + d;
      }
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.TableStyle) return t;
    let g = new $root.TableStyle();
    if (t.cols) {
      if (!Array.isArray(t.cols)) throw TypeError(".TableStyle.cols: array expected");
      g.cols = [];
      for (let d = 0; d < t.cols.length; ++d) {
        if (typeof t.cols[d] != "object") throw TypeError(".TableStyle.cols: object expected");
        g.cols[d] = $root.CellStyleArray.fromObject(t.cols[d]);
      }
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.cols = []), t.cols && t.cols.length) {
      d.cols = [];
      for (let k = 0; k < t.cols.length; ++k) d.cols[k] = $root.CellStyleArray.toObject(t.cols[k], g);
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/TableStyle";
  }, n;
})();
$root.DateInput = (() => {
  function n(t) {
    if (this.default = [], this.value = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.default = $util.emptyArray, n.prototype.min = "", n.prototype.max = "", n.prototype.isRange = !1, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = $util.emptyArray, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.format = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.default != null && t.default.length) for (let d = 0; d < t.default.length; ++d) g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.default[d]);
    if (t.min != null && Object.hasOwnProperty.call(t, "min") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.min), t.max != null && Object.hasOwnProperty.call(t, "max") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.max), t.isRange != null && Object.hasOwnProperty.call(t, "isRange") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(t.isRange), t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(t.formId), t.value != null && t.value.length) for (let d = 0; d < t.value.length; ++d) g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(t.value[d]);
    return t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(t.setValue), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), t.format != null && Object.hasOwnProperty.call(t, "format") && g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(t.format), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.DateInput();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.id = t.string();
          break;
        }
        case 2: {
          H.label = t.string();
          break;
        }
        case 3: {
          H.default && H.default.length || (H.default = []), H.default.push(t.string());
          break;
        }
        case 4: {
          H.min = t.string();
          break;
        }
        case 5: {
          H.max = t.string();
          break;
        }
        case 6: {
          H.isRange = t.bool();
          break;
        }
        case 7: {
          H.help = t.string();
          break;
        }
        case 8: {
          H.formId = t.string();
          break;
        }
        case 9: {
          H.value && H.value.length || (H.value = []), H.value.push(t.string());
          break;
        }
        case 10: {
          H.setValue = t.bool();
          break;
        }
        case 11: {
          H.disabled = t.bool();
          break;
        }
        case 12: {
          H.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 13: {
          H.format = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id)) return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label)) return "label: string expected";
    if (t.default != null && t.hasOwnProperty("default")) {
      if (!Array.isArray(t.default)) return "default: array expected";
      for (let g = 0; g < t.default.length; ++g) if (!$util.isString(t.default[g])) return "default: string[] expected";
    }
    if (t.min != null && t.hasOwnProperty("min") && !$util.isString(t.min)) return "min: string expected";
    if (t.max != null && t.hasOwnProperty("max") && !$util.isString(t.max)) return "max: string expected";
    if (t.isRange != null && t.hasOwnProperty("isRange") && typeof t.isRange != "boolean") return "isRange: boolean expected";
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help)) return "help: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId)) return "formId: string expected";
    if (t.value != null && t.hasOwnProperty("value")) {
      if (!Array.isArray(t.value)) return "value: array expected";
      for (let g = 0; g < t.value.length; ++g) if (!$util.isString(t.value[g])) return "value: string[] expected";
    }
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean") return "setValue: boolean expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean") return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let g = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (g) return "labelVisibility." + g;
    }
    return t.format != null && t.hasOwnProperty("format") && !$util.isString(t.format) ? "format: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.DateInput) return t;
    let g = new $root.DateInput();
    if (t.id != null && (g.id = String(t.id)), t.label != null && (g.label = String(t.label)), t.default) {
      if (!Array.isArray(t.default)) throw TypeError(".DateInput.default: array expected");
      g.default = [];
      for (let d = 0; d < t.default.length; ++d) g.default[d] = String(t.default[d]);
    }
    if (t.min != null && (g.min = String(t.min)), t.max != null && (g.max = String(t.max)), t.isRange != null && (g.isRange = !!t.isRange), t.help != null && (g.help = String(t.help)), t.formId != null && (g.formId = String(t.formId)), t.value) {
      if (!Array.isArray(t.value)) throw TypeError(".DateInput.value: array expected");
      g.value = [];
      for (let d = 0; d < t.value.length; ++d) g.value[d] = String(t.value[d]);
    }
    if (t.setValue != null && (g.setValue = !!t.setValue), t.disabled != null && (g.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object") throw TypeError(".DateInput.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    return t.format != null && (g.format = String(t.format)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.default = [], d.value = []), g.defaults && (d.id = "", d.label = "", d.min = "", d.max = "", d.isRange = !1, d.help = "", d.formId = "", d.setValue = !1, d.disabled = !1, d.labelVisibility = null, d.format = ""), t.id != null && t.hasOwnProperty("id") && (d.id = t.id), t.label != null && t.hasOwnProperty("label") && (d.label = t.label), t.default && t.default.length) {
      d.default = [];
      for (let k = 0; k < t.default.length; ++k) d.default[k] = t.default[k];
    }
    if (t.min != null && t.hasOwnProperty("min") && (d.min = t.min), t.max != null && t.hasOwnProperty("max") && (d.max = t.max), t.isRange != null && t.hasOwnProperty("isRange") && (d.isRange = t.isRange), t.help != null && t.hasOwnProperty("help") && (d.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (d.formId = t.formId), t.value && t.value.length) {
      d.value = [];
      for (let k = 0; k < t.value.length; ++k) d.value[k] = t.value[k];
    }
    return t.setValue != null && t.hasOwnProperty("setValue") && (d.setValue = t.setValue), t.disabled != null && t.hasOwnProperty("disabled") && (d.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (d.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, g)), t.format != null && t.hasOwnProperty("format") && (d.format = t.format), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/DateInput";
  }, n;
})();
$root.DeckGlJsonChart = (() => {
  function n(t) {
    if (this.selectionMode = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.json = "", n.prototype.tooltip = "", n.prototype.useContainerWidth = !1, n.prototype.id = "", n.prototype.mapboxToken = "", n.prototype.width = 0, n.prototype.height = 0, n.prototype.selectionMode = $util.emptyArray, n.prototype.formId = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.json != null && Object.hasOwnProperty.call(t, "json") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.json), t.tooltip != null && Object.hasOwnProperty.call(t, "tooltip") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.tooltip), t.useContainerWidth != null && Object.hasOwnProperty.call(t, "useContainerWidth") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(t.useContainerWidth), t.id != null && Object.hasOwnProperty.call(t, "id") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.id), t.mapboxToken != null && Object.hasOwnProperty.call(t, "mapboxToken") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.mapboxToken), t.width != null && Object.hasOwnProperty.call(t, "width") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).uint32(t.width), t.height != null && Object.hasOwnProperty.call(t, "height") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).uint32(t.height), t.selectionMode != null && t.selectionMode.length) {
      g.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let d = 0; d < t.selectionMode.length; ++d) g.int32(t.selectionMode[d]);
      g.ldelim();
    }
    return t.formId != null && Object.hasOwnProperty.call(t, "formId") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(t.formId), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.DeckGlJsonChart();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.json = t.string();
          break;
        }
        case 2: {
          H.tooltip = t.string();
          break;
        }
        case 4: {
          H.useContainerWidth = t.bool();
          break;
        }
        case 5: {
          H.id = t.string();
          break;
        }
        case 6: {
          H.mapboxToken = t.string();
          break;
        }
        case 7: {
          H.width = t.uint32();
          break;
        }
        case 8: {
          H.height = t.uint32();
          break;
        }
        case 9: {
          if (H.selectionMode && H.selectionMode.length || (H.selectionMode = []), (AA & 7) === 2) {
            let gA = t.uint32() + t.pos;
            for (; t.pos < gA; ) H.selectionMode.push(t.int32());
          } else H.selectionMode.push(t.int32());
          break;
        }
        case 10: {
          H.formId = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.json != null && t.hasOwnProperty("json") && !$util.isString(t.json)) return "json: string expected";
    if (t.tooltip != null && t.hasOwnProperty("tooltip") && !$util.isString(t.tooltip)) return "tooltip: string expected";
    if (t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && typeof t.useContainerWidth != "boolean") return "useContainerWidth: boolean expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id)) return "id: string expected";
    if (t.mapboxToken != null && t.hasOwnProperty("mapboxToken") && !$util.isString(t.mapboxToken)) return "mapboxToken: string expected";
    if (t.width != null && t.hasOwnProperty("width") && !$util.isInteger(t.width)) return "width: integer expected";
    if (t.height != null && t.hasOwnProperty("height") && !$util.isInteger(t.height)) return "height: integer expected";
    if (t.selectionMode != null && t.hasOwnProperty("selectionMode")) {
      if (!Array.isArray(t.selectionMode)) return "selectionMode: array expected";
      for (let g = 0; g < t.selectionMode.length; ++g) switch (t.selectionMode[g]) {
        default:
          return "selectionMode: enum value[] expected";
        case 0:
        case 1:
          break;
      }
    }
    return t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId) ? "formId: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.DeckGlJsonChart) return t;
    let g = new $root.DeckGlJsonChart();
    if (t.json != null && (g.json = String(t.json)), t.tooltip != null && (g.tooltip = String(t.tooltip)), t.useContainerWidth != null && (g.useContainerWidth = !!t.useContainerWidth), t.id != null && (g.id = String(t.id)), t.mapboxToken != null && (g.mapboxToken = String(t.mapboxToken)), t.width != null && (g.width = t.width >>> 0), t.height != null && (g.height = t.height >>> 0), t.selectionMode) {
      if (!Array.isArray(t.selectionMode)) throw TypeError(".DeckGlJsonChart.selectionMode: array expected");
      g.selectionMode = [];
      for (let d = 0; d < t.selectionMode.length; ++d) switch (t.selectionMode[d]) {
        default:
          if (typeof t.selectionMode[d] == "number") {
            g.selectionMode[d] = t.selectionMode[d];
            break;
          }
        case "SINGLE_OBJECT":
        case 0:
          g.selectionMode[d] = 0;
          break;
        case "MULTI_OBJECT":
        case 1:
          g.selectionMode[d] = 1;
          break;
      }
    }
    return t.formId != null && (g.formId = String(t.formId)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.selectionMode = []), g.defaults && (d.json = "", d.tooltip = "", d.useContainerWidth = !1, d.id = "", d.mapboxToken = "", d.width = 0, d.height = 0, d.formId = ""), t.json != null && t.hasOwnProperty("json") && (d.json = t.json), t.tooltip != null && t.hasOwnProperty("tooltip") && (d.tooltip = t.tooltip), t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && (d.useContainerWidth = t.useContainerWidth), t.id != null && t.hasOwnProperty("id") && (d.id = t.id), t.mapboxToken != null && t.hasOwnProperty("mapboxToken") && (d.mapboxToken = t.mapboxToken), t.width != null && t.hasOwnProperty("width") && (d.width = t.width), t.height != null && t.hasOwnProperty("height") && (d.height = t.height), t.selectionMode && t.selectionMode.length) {
      d.selectionMode = [];
      for (let k = 0; k < t.selectionMode.length; ++k) d.selectionMode[k] = g.enums === String ? $root.DeckGlJsonChart.SelectionMode[t.selectionMode[k]] === void 0 ? t.selectionMode[k] : $root.DeckGlJsonChart.SelectionMode[t.selectionMode[k]] : t.selectionMode[k];
    }
    return t.formId != null && t.hasOwnProperty("formId") && (d.formId = t.formId), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/DeckGlJsonChart";
  }, n.SelectionMode = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "SINGLE_OBJECT"] = 0, g[t[1] = "MULTI_OBJECT"] = 1, g;
  })(), n;
})();
$root.Delta = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.newElement = null, n.prototype.addBlock = null, n.prototype.addRows = null, n.prototype.arrowAddRows = null, n.prototype.fragmentId = "";
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util.oneOfGetter(t = ["newElement", "addBlock", "addRows", "arrowAddRows"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.newElement != null && Object.hasOwnProperty.call(g, "newElement") && $root.Element.encode(g.newElement, d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.addRows != null && Object.hasOwnProperty.call(g, "addRows") && $root.NamedDataSet.encode(g.addRows, d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.addBlock != null && Object.hasOwnProperty.call(g, "addBlock") && $root.Block.encode(g.addBlock, d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.arrowAddRows != null && Object.hasOwnProperty.call(g, "arrowAddRows") && $root.ArrowNamedDataSet.encode(g.arrowAddRows, d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.fragmentId != null && Object.hasOwnProperty.call(g, "fragmentId") && d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.fragmentId), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Delta();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 3: {
          AA.newElement = $root.Element.decode(g, g.uint32());
          break;
        }
        case 6: {
          AA.addBlock = $root.Block.decode(g, g.uint32());
          break;
        }
        case 5: {
          AA.addRows = $root.NamedDataSet.decode(g, g.uint32());
          break;
        }
        case 7: {
          AA.arrowAddRows = $root.ArrowNamedDataSet.decode(g, g.uint32());
          break;
        }
        case 8: {
          AA.fragmentId = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.newElement != null && g.hasOwnProperty("newElement")) {
      d.type = 1;
      {
        let k = $root.Element.verify(g.newElement);
        if (k) return "newElement." + k;
      }
    }
    if (g.addBlock != null && g.hasOwnProperty("addBlock")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Block.verify(g.addBlock);
        if (k) return "addBlock." + k;
      }
    }
    if (g.addRows != null && g.hasOwnProperty("addRows")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.NamedDataSet.verify(g.addRows);
        if (k) return "addRows." + k;
      }
    }
    if (g.arrowAddRows != null && g.hasOwnProperty("arrowAddRows")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.ArrowNamedDataSet.verify(g.arrowAddRows);
        if (k) return "arrowAddRows." + k;
      }
    }
    return g.fragmentId != null && g.hasOwnProperty("fragmentId") && !$util.isString(g.fragmentId) ? "fragmentId: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Delta) return g;
    let d = new $root.Delta();
    if (g.newElement != null) {
      if (typeof g.newElement != "object") throw TypeError(".Delta.newElement: object expected");
      d.newElement = $root.Element.fromObject(g.newElement);
    }
    if (g.addBlock != null) {
      if (typeof g.addBlock != "object") throw TypeError(".Delta.addBlock: object expected");
      d.addBlock = $root.Block.fromObject(g.addBlock);
    }
    if (g.addRows != null) {
      if (typeof g.addRows != "object") throw TypeError(".Delta.addRows: object expected");
      d.addRows = $root.NamedDataSet.fromObject(g.addRows);
    }
    if (g.arrowAddRows != null) {
      if (typeof g.arrowAddRows != "object") throw TypeError(".Delta.arrowAddRows: object expected");
      d.arrowAddRows = $root.ArrowNamedDataSet.fromObject(g.arrowAddRows);
    }
    return g.fragmentId != null && (d.fragmentId = String(g.fragmentId)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.fragmentId = ""), g.newElement != null && g.hasOwnProperty("newElement") && (k.newElement = $root.Element.toObject(g.newElement, d), d.oneofs && (k.type = "newElement")), g.addRows != null && g.hasOwnProperty("addRows") && (k.addRows = $root.NamedDataSet.toObject(g.addRows, d), d.oneofs && (k.type = "addRows")), g.addBlock != null && g.hasOwnProperty("addBlock") && (k.addBlock = $root.Block.toObject(g.addBlock, d), d.oneofs && (k.type = "addBlock")), g.arrowAddRows != null && g.hasOwnProperty("arrowAddRows") && (k.arrowAddRows = $root.ArrowNamedDataSet.toObject(g.arrowAddRows, d), d.oneofs && (k.type = "arrowAddRows")), g.fragmentId != null && g.hasOwnProperty("fragmentId") && (k.fragmentId = g.fragmentId), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Delta";
  }, n;
})();
$root.Element = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.heightConfig = null, n.prototype.widthConfig = null, n.prototype.alert = null, n.prototype.arrowDataFrame = null, n.prototype.arrowTable = null, n.prototype.arrowVegaLiteChart = null, n.prototype.audio = null, n.prototype.audioInput = null, n.prototype.balloons = null, n.prototype.bokehChart = null, n.prototype.button = null, n.prototype.buttonGroup = null, n.prototype.downloadButton = null, n.prototype.cameraInput = null, n.prototype.chatInput = null, n.prototype.checkbox = null, n.prototype.colorPicker = null, n.prototype.componentInstance = null, n.prototype.dataFrame = null, n.prototype.table = null, n.prototype.dateInput = null, n.prototype.deckGlJsonChart = null, n.prototype.docString = null, n.prototype.empty = null, n.prototype.exception = null, n.prototype.favicon = null, n.prototype.fileUploader = null, n.prototype.graphvizChart = null, n.prototype.html = null, n.prototype.iframe = null, n.prototype.imgs = null, n.prototype.json = null, n.prototype.linkButton = null, n.prototype.markdown = null, n.prototype.metric = null, n.prototype.multiselect = null, n.prototype.numberInput = null, n.prototype.pageLink = null, n.prototype.plotlyChart = null, n.prototype.progress = null, n.prototype.radio = null, n.prototype.selectbox = null, n.prototype.skeleton = null, n.prototype.slider = null, n.prototype.snow = null, n.prototype.spinner = null, n.prototype.text = null, n.prototype.textArea = null, n.prototype.textInput = null, n.prototype.timeInput = null, n.prototype.toast = null, n.prototype.vegaLiteChart = null, n.prototype.video = null, n.prototype.heading = null, n.prototype.code = null;
  let t;
  return Object.defineProperty(n.prototype, "_heightConfig", { get: $util.oneOfGetter(t = ["heightConfig"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_widthConfig", { get: $util.oneOfGetter(t = ["widthConfig"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "type", { get: $util.oneOfGetter(t = ["alert", "arrowDataFrame", "arrowTable", "arrowVegaLiteChart", "audio", "audioInput", "balloons", "bokehChart", "button", "buttonGroup", "downloadButton", "cameraInput", "chatInput", "checkbox", "colorPicker", "componentInstance", "dataFrame", "table", "dateInput", "deckGlJsonChart", "docString", "empty", "exception", "favicon", "fileUploader", "graphvizChart", "html", "iframe", "imgs", "json", "linkButton", "markdown", "metric", "multiselect", "numberInput", "pageLink", "plotlyChart", "progress", "radio", "selectbox", "skeleton", "slider", "snow", "spinner", "text", "textArea", "textInput", "timeInput", "toast", "vegaLiteChart", "video", "heading", "code"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.text != null && Object.hasOwnProperty.call(g, "text") && $root.Text.encode(g.text, d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), g.empty != null && Object.hasOwnProperty.call(g, "empty") && $root.Empty.encode(g.empty, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.dataFrame != null && Object.hasOwnProperty.call(g, "dataFrame") && $root.DataFrame.encode(g.dataFrame, d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), g.progress != null && Object.hasOwnProperty.call(g, "progress") && $root.Progress.encode(g.progress, d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.imgs != null && Object.hasOwnProperty.call(g, "imgs") && $root.ImageList.encode(g.imgs, d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g.docString != null && Object.hasOwnProperty.call(g, "docString") && $root.DocString.encode(g.docString, d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), g.exception != null && Object.hasOwnProperty.call(g, "exception") && $root.Exception.encode(g.exception, d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), g.vegaLiteChart != null && Object.hasOwnProperty.call(g, "vegaLiteChart") && $root.VegaLiteChart.encode(g.vegaLiteChart, d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.table != null && Object.hasOwnProperty.call(g, "table") && $root.DataFrame.encode(g.table, d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.balloons != null && Object.hasOwnProperty.call(g, "balloons") && $root.Balloons.encode(g.balloons, d.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), g.audio != null && Object.hasOwnProperty.call(g, "audio") && $root.Audio.encode(g.audio, d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.video != null && Object.hasOwnProperty.call(g, "video") && $root.Video.encode(g.video, d.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), g.plotlyChart != null && Object.hasOwnProperty.call(g, "plotlyChart") && $root.PlotlyChart.encode(g.plotlyChart, d.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.bokehChart != null && Object.hasOwnProperty.call(g, "bokehChart") && $root.BokehChart.encode(g.bokehChart, d.uint32(
      /* id 17, wireType 2 =*/
      138
    ).fork()).ldelim(), g.graphvizChart != null && Object.hasOwnProperty.call(g, "graphvizChart") && $root.GraphVizChart.encode(g.graphvizChart, d.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), g.button != null && Object.hasOwnProperty.call(g, "button") && $root.Button.encode(g.button, d.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), g.checkbox != null && Object.hasOwnProperty.call(g, "checkbox") && $root.Checkbox.encode(g.checkbox, d.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), g.slider != null && Object.hasOwnProperty.call(g, "slider") && $root.Slider.encode(g.slider, d.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), g.textArea != null && Object.hasOwnProperty.call(g, "textArea") && $root.TextArea.encode(g.textArea, d.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), g.radio != null && Object.hasOwnProperty.call(g, "radio") && $root.Radio.encode(g.radio, d.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), g.textInput != null && Object.hasOwnProperty.call(g, "textInput") && $root.TextInput.encode(g.textInput, d.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), g.selectbox != null && Object.hasOwnProperty.call(g, "selectbox") && $root.Selectbox.encode(g.selectbox, d.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), g.timeInput != null && Object.hasOwnProperty.call(g, "timeInput") && $root.TimeInput.encode(g.timeInput, d.uint32(
      /* id 26, wireType 2 =*/
      210
    ).fork()).ldelim(), g.dateInput != null && Object.hasOwnProperty.call(g, "dateInput") && $root.DateInput.encode(g.dateInput, d.uint32(
      /* id 27, wireType 2 =*/
      218
    ).fork()).ldelim(), g.multiselect != null && Object.hasOwnProperty.call(g, "multiselect") && $root.MultiSelect.encode(g.multiselect, d.uint32(
      /* id 28, wireType 2 =*/
      226
    ).fork()).ldelim(), g.markdown != null && Object.hasOwnProperty.call(g, "markdown") && $root.Markdown.encode(g.markdown, d.uint32(
      /* id 29, wireType 2 =*/
      234
    ).fork()).ldelim(), g.alert != null && Object.hasOwnProperty.call(g, "alert") && $root.Alert.encode(g.alert, d.uint32(
      /* id 30, wireType 2 =*/
      242
    ).fork()).ldelim(), g.json != null && Object.hasOwnProperty.call(g, "json") && $root.Json.encode(g.json, d.uint32(
      /* id 31, wireType 2 =*/
      250
    ).fork()).ldelim(), g.numberInput != null && Object.hasOwnProperty.call(g, "numberInput") && $root.NumberInput.encode(g.numberInput, d.uint32(
      /* id 32, wireType 2 =*/
      258
    ).fork()).ldelim(), g.fileUploader != null && Object.hasOwnProperty.call(g, "fileUploader") && $root.FileUploader.encode(g.fileUploader, d.uint32(
      /* id 33, wireType 2 =*/
      266
    ).fork()).ldelim(), g.deckGlJsonChart != null && Object.hasOwnProperty.call(g, "deckGlJsonChart") && $root.DeckGlJsonChart.encode(g.deckGlJsonChart, d.uint32(
      /* id 34, wireType 2 =*/
      274
    ).fork()).ldelim(), g.colorPicker != null && Object.hasOwnProperty.call(g, "colorPicker") && $root.ColorPicker.encode(g.colorPicker, d.uint32(
      /* id 35, wireType 2 =*/
      282
    ).fork()).ldelim(), g.favicon != null && Object.hasOwnProperty.call(g, "favicon") && $root.Favicon.encode(g.favicon, d.uint32(
      /* id 36, wireType 2 =*/
      290
    ).fork()).ldelim(), g.componentInstance != null && Object.hasOwnProperty.call(g, "componentInstance") && $root.ComponentInstance.encode(g.componentInstance, d.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim(), g.iframe != null && Object.hasOwnProperty.call(g, "iframe") && $root.IFrame.encode(g.iframe, d.uint32(
      /* id 38, wireType 2 =*/
      306
    ).fork()).ldelim(), g.arrowTable != null && Object.hasOwnProperty.call(g, "arrowTable") && $root.Arrow.encode(g.arrowTable, d.uint32(
      /* id 39, wireType 2 =*/
      314
    ).fork()).ldelim(), g.arrowDataFrame != null && Object.hasOwnProperty.call(g, "arrowDataFrame") && $root.Arrow.encode(g.arrowDataFrame, d.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), g.arrowVegaLiteChart != null && Object.hasOwnProperty.call(g, "arrowVegaLiteChart") && $root.ArrowVegaLiteChart.encode(g.arrowVegaLiteChart, d.uint32(
      /* id 41, wireType 2 =*/
      330
    ).fork()).ldelim(), g.metric != null && Object.hasOwnProperty.call(g, "metric") && $root.Metric.encode(g.metric, d.uint32(
      /* id 42, wireType 2 =*/
      338
    ).fork()).ldelim(), g.downloadButton != null && Object.hasOwnProperty.call(g, "downloadButton") && $root.DownloadButton.encode(g.downloadButton, d.uint32(
      /* id 43, wireType 2 =*/
      346
    ).fork()).ldelim(), g.spinner != null && Object.hasOwnProperty.call(g, "spinner") && $root.Spinner.encode(g.spinner, d.uint32(
      /* id 44, wireType 2 =*/
      354
    ).fork()).ldelim(), g.cameraInput != null && Object.hasOwnProperty.call(g, "cameraInput") && $root.CameraInput.encode(g.cameraInput, d.uint32(
      /* id 45, wireType 2 =*/
      362
    ).fork()).ldelim(), g.snow != null && Object.hasOwnProperty.call(g, "snow") && $root.Snow.encode(g.snow, d.uint32(
      /* id 46, wireType 2 =*/
      370
    ).fork()).ldelim(), g.heading != null && Object.hasOwnProperty.call(g, "heading") && $root.Heading.encode(g.heading, d.uint32(
      /* id 47, wireType 2 =*/
      378
    ).fork()).ldelim(), g.code != null && Object.hasOwnProperty.call(g, "code") && $root.Code.encode(g.code, d.uint32(
      /* id 48, wireType 2 =*/
      386
    ).fork()).ldelim(), g.chatInput != null && Object.hasOwnProperty.call(g, "chatInput") && $root.ChatInput.encode(g.chatInput, d.uint32(
      /* id 49, wireType 2 =*/
      394
    ).fork()).ldelim(), g.toast != null && Object.hasOwnProperty.call(g, "toast") && $root.Toast.encode(g.toast, d.uint32(
      /* id 50, wireType 2 =*/
      402
    ).fork()).ldelim(), g.linkButton != null && Object.hasOwnProperty.call(g, "linkButton") && $root.LinkButton.encode(g.linkButton, d.uint32(
      /* id 51, wireType 2 =*/
      410
    ).fork()).ldelim(), g.skeleton != null && Object.hasOwnProperty.call(g, "skeleton") && $root.Skeleton.encode(g.skeleton, d.uint32(
      /* id 52, wireType 2 =*/
      418
    ).fork()).ldelim(), g.pageLink != null && Object.hasOwnProperty.call(g, "pageLink") && $root.PageLink.encode(g.pageLink, d.uint32(
      /* id 53, wireType 2 =*/
      426
    ).fork()).ldelim(), g.html != null && Object.hasOwnProperty.call(g, "html") && $root.Html.encode(g.html, d.uint32(
      /* id 54, wireType 2 =*/
      434
    ).fork()).ldelim(), g.buttonGroup != null && Object.hasOwnProperty.call(g, "buttonGroup") && $root.ButtonGroup.encode(g.buttonGroup, d.uint32(
      /* id 55, wireType 2 =*/
      442
    ).fork()).ldelim(), g.audioInput != null && Object.hasOwnProperty.call(g, "audioInput") && $root.AudioInput.encode(g.audioInput, d.uint32(
      /* id 56, wireType 2 =*/
      450
    ).fork()).ldelim(), g.heightConfig != null && Object.hasOwnProperty.call(g, "heightConfig") && $root.streamlit.HeightConfig.encode(g.heightConfig, d.uint32(
      /* id 57, wireType 2 =*/
      458
    ).fork()).ldelim(), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root.streamlit.WidthConfig.encode(g.widthConfig, d.uint32(
      /* id 58, wireType 2 =*/
      466
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Element();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 57: {
          AA.heightConfig = $root.streamlit.HeightConfig.decode(g, g.uint32());
          break;
        }
        case 58: {
          AA.widthConfig = $root.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        case 30: {
          AA.alert = $root.Alert.decode(g, g.uint32());
          break;
        }
        case 40: {
          AA.arrowDataFrame = $root.Arrow.decode(g, g.uint32());
          break;
        }
        case 39: {
          AA.arrowTable = $root.Arrow.decode(g, g.uint32());
          break;
        }
        case 41: {
          AA.arrowVegaLiteChart = $root.ArrowVegaLiteChart.decode(g, g.uint32());
          break;
        }
        case 13: {
          AA.audio = $root.Audio.decode(g, g.uint32());
          break;
        }
        case 56: {
          AA.audioInput = $root.AudioInput.decode(g, g.uint32());
          break;
        }
        case 12: {
          AA.balloons = $root.Balloons.decode(g, g.uint32());
          break;
        }
        case 17: {
          AA.bokehChart = $root.BokehChart.decode(g, g.uint32());
          break;
        }
        case 19: {
          AA.button = $root.Button.decode(g, g.uint32());
          break;
        }
        case 55: {
          AA.buttonGroup = $root.ButtonGroup.decode(g, g.uint32());
          break;
        }
        case 43: {
          AA.downloadButton = $root.DownloadButton.decode(g, g.uint32());
          break;
        }
        case 45: {
          AA.cameraInput = $root.CameraInput.decode(g, g.uint32());
          break;
        }
        case 49: {
          AA.chatInput = $root.ChatInput.decode(g, g.uint32());
          break;
        }
        case 20: {
          AA.checkbox = $root.Checkbox.decode(g, g.uint32());
          break;
        }
        case 35: {
          AA.colorPicker = $root.ColorPicker.decode(g, g.uint32());
          break;
        }
        case 37: {
          AA.componentInstance = $root.ComponentInstance.decode(g, g.uint32());
          break;
        }
        case 3: {
          AA.dataFrame = $root.DataFrame.decode(g, g.uint32());
          break;
        }
        case 11: {
          AA.table = $root.DataFrame.decode(g, g.uint32());
          break;
        }
        case 27: {
          AA.dateInput = $root.DateInput.decode(g, g.uint32());
          break;
        }
        case 34: {
          AA.deckGlJsonChart = $root.DeckGlJsonChart.decode(g, g.uint32());
          break;
        }
        case 7: {
          AA.docString = $root.DocString.decode(g, g.uint32());
          break;
        }
        case 2: {
          AA.empty = $root.Empty.decode(g, g.uint32());
          break;
        }
        case 8: {
          AA.exception = $root.Exception.decode(g, g.uint32());
          break;
        }
        case 36: {
          AA.favicon = $root.Favicon.decode(g, g.uint32());
          break;
        }
        case 33: {
          AA.fileUploader = $root.FileUploader.decode(g, g.uint32());
          break;
        }
        case 18: {
          AA.graphvizChart = $root.GraphVizChart.decode(g, g.uint32());
          break;
        }
        case 54: {
          AA.html = $root.Html.decode(g, g.uint32());
          break;
        }
        case 38: {
          AA.iframe = $root.IFrame.decode(g, g.uint32());
          break;
        }
        case 6: {
          AA.imgs = $root.ImageList.decode(g, g.uint32());
          break;
        }
        case 31: {
          AA.json = $root.Json.decode(g, g.uint32());
          break;
        }
        case 51: {
          AA.linkButton = $root.LinkButton.decode(g, g.uint32());
          break;
        }
        case 29: {
          AA.markdown = $root.Markdown.decode(g, g.uint32());
          break;
        }
        case 42: {
          AA.metric = $root.Metric.decode(g, g.uint32());
          break;
        }
        case 28: {
          AA.multiselect = $root.MultiSelect.decode(g, g.uint32());
          break;
        }
        case 32: {
          AA.numberInput = $root.NumberInput.decode(g, g.uint32());
          break;
        }
        case 53: {
          AA.pageLink = $root.PageLink.decode(g, g.uint32());
          break;
        }
        case 16: {
          AA.plotlyChart = $root.PlotlyChart.decode(g, g.uint32());
          break;
        }
        case 5: {
          AA.progress = $root.Progress.decode(g, g.uint32());
          break;
        }
        case 23: {
          AA.radio = $root.Radio.decode(g, g.uint32());
          break;
        }
        case 25: {
          AA.selectbox = $root.Selectbox.decode(g, g.uint32());
          break;
        }
        case 52: {
          AA.skeleton = $root.Skeleton.decode(g, g.uint32());
          break;
        }
        case 21: {
          AA.slider = $root.Slider.decode(g, g.uint32());
          break;
        }
        case 46: {
          AA.snow = $root.Snow.decode(g, g.uint32());
          break;
        }
        case 44: {
          AA.spinner = $root.Spinner.decode(g, g.uint32());
          break;
        }
        case 1: {
          AA.text = $root.Text.decode(g, g.uint32());
          break;
        }
        case 22: {
          AA.textArea = $root.TextArea.decode(g, g.uint32());
          break;
        }
        case 24: {
          AA.textInput = $root.TextInput.decode(g, g.uint32());
          break;
        }
        case 26: {
          AA.timeInput = $root.TimeInput.decode(g, g.uint32());
          break;
        }
        case 50: {
          AA.toast = $root.Toast.decode(g, g.uint32());
          break;
        }
        case 10: {
          AA.vegaLiteChart = $root.VegaLiteChart.decode(g, g.uint32());
          break;
        }
        case 14: {
          AA.video = $root.Video.decode(g, g.uint32());
          break;
        }
        case 47: {
          AA.heading = $root.Heading.decode(g, g.uint32());
          break;
        }
        case 48: {
          AA.code = $root.Code.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.heightConfig != null && g.hasOwnProperty("heightConfig")) {
      d._heightConfig = 1;
      {
        let k = $root.streamlit.HeightConfig.verify(g.heightConfig);
        if (k) return "heightConfig." + k;
      }
    }
    if (g.widthConfig != null && g.hasOwnProperty("widthConfig")) {
      d._widthConfig = 1;
      {
        let k = $root.streamlit.WidthConfig.verify(g.widthConfig);
        if (k) return "widthConfig." + k;
      }
    }
    if (g.alert != null && g.hasOwnProperty("alert")) {
      d.type = 1;
      {
        let k = $root.Alert.verify(g.alert);
        if (k) return "alert." + k;
      }
    }
    if (g.arrowDataFrame != null && g.hasOwnProperty("arrowDataFrame")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Arrow.verify(g.arrowDataFrame);
        if (k) return "arrowDataFrame." + k;
      }
    }
    if (g.arrowTable != null && g.hasOwnProperty("arrowTable")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Arrow.verify(g.arrowTable);
        if (k) return "arrowTable." + k;
      }
    }
    if (g.arrowVegaLiteChart != null && g.hasOwnProperty("arrowVegaLiteChart")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.ArrowVegaLiteChart.verify(g.arrowVegaLiteChart);
        if (k) return "arrowVegaLiteChart." + k;
      }
    }
    if (g.audio != null && g.hasOwnProperty("audio")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Audio.verify(g.audio);
        if (k) return "audio." + k;
      }
    }
    if (g.audioInput != null && g.hasOwnProperty("audioInput")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.AudioInput.verify(g.audioInput);
        if (k) return "audioInput." + k;
      }
    }
    if (g.balloons != null && g.hasOwnProperty("balloons")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Balloons.verify(g.balloons);
        if (k) return "balloons." + k;
      }
    }
    if (g.bokehChart != null && g.hasOwnProperty("bokehChart")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.BokehChart.verify(g.bokehChart);
        if (k) return "bokehChart." + k;
      }
    }
    if (g.button != null && g.hasOwnProperty("button")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Button.verify(g.button);
        if (k) return "button." + k;
      }
    }
    if (g.buttonGroup != null && g.hasOwnProperty("buttonGroup")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.ButtonGroup.verify(g.buttonGroup);
        if (k) return "buttonGroup." + k;
      }
    }
    if (g.downloadButton != null && g.hasOwnProperty("downloadButton")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.DownloadButton.verify(g.downloadButton);
        if (k) return "downloadButton." + k;
      }
    }
    if (g.cameraInput != null && g.hasOwnProperty("cameraInput")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.CameraInput.verify(g.cameraInput);
        if (k) return "cameraInput." + k;
      }
    }
    if (g.chatInput != null && g.hasOwnProperty("chatInput")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.ChatInput.verify(g.chatInput);
        if (k) return "chatInput." + k;
      }
    }
    if (g.checkbox != null && g.hasOwnProperty("checkbox")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Checkbox.verify(g.checkbox);
        if (k) return "checkbox." + k;
      }
    }
    if (g.colorPicker != null && g.hasOwnProperty("colorPicker")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.ColorPicker.verify(g.colorPicker);
        if (k) return "colorPicker." + k;
      }
    }
    if (g.componentInstance != null && g.hasOwnProperty("componentInstance")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.ComponentInstance.verify(g.componentInstance);
        if (k) return "componentInstance." + k;
      }
    }
    if (g.dataFrame != null && g.hasOwnProperty("dataFrame")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.DataFrame.verify(g.dataFrame);
        if (k) return "dataFrame." + k;
      }
    }
    if (g.table != null && g.hasOwnProperty("table")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.DataFrame.verify(g.table);
        if (k) return "table." + k;
      }
    }
    if (g.dateInput != null && g.hasOwnProperty("dateInput")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.DateInput.verify(g.dateInput);
        if (k) return "dateInput." + k;
      }
    }
    if (g.deckGlJsonChart != null && g.hasOwnProperty("deckGlJsonChart")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.DeckGlJsonChart.verify(g.deckGlJsonChart);
        if (k) return "deckGlJsonChart." + k;
      }
    }
    if (g.docString != null && g.hasOwnProperty("docString")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.DocString.verify(g.docString);
        if (k) return "docString." + k;
      }
    }
    if (g.empty != null && g.hasOwnProperty("empty")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Empty.verify(g.empty);
        if (k) return "empty." + k;
      }
    }
    if (g.exception != null && g.hasOwnProperty("exception")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Exception.verify(g.exception);
        if (k) return "exception." + k;
      }
    }
    if (g.favicon != null && g.hasOwnProperty("favicon")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Favicon.verify(g.favicon);
        if (k) return "favicon." + k;
      }
    }
    if (g.fileUploader != null && g.hasOwnProperty("fileUploader")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.FileUploader.verify(g.fileUploader);
        if (k) return "fileUploader." + k;
      }
    }
    if (g.graphvizChart != null && g.hasOwnProperty("graphvizChart")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.GraphVizChart.verify(g.graphvizChart);
        if (k) return "graphvizChart." + k;
      }
    }
    if (g.html != null && g.hasOwnProperty("html")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Html.verify(g.html);
        if (k) return "html." + k;
      }
    }
    if (g.iframe != null && g.hasOwnProperty("iframe")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.IFrame.verify(g.iframe);
        if (k) return "iframe." + k;
      }
    }
    if (g.imgs != null && g.hasOwnProperty("imgs")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.ImageList.verify(g.imgs);
        if (k) return "imgs." + k;
      }
    }
    if (g.json != null && g.hasOwnProperty("json")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Json.verify(g.json);
        if (k) return "json." + k;
      }
    }
    if (g.linkButton != null && g.hasOwnProperty("linkButton")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.LinkButton.verify(g.linkButton);
        if (k) return "linkButton." + k;
      }
    }
    if (g.markdown != null && g.hasOwnProperty("markdown")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Markdown.verify(g.markdown);
        if (k) return "markdown." + k;
      }
    }
    if (g.metric != null && g.hasOwnProperty("metric")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Metric.verify(g.metric);
        if (k) return "metric." + k;
      }
    }
    if (g.multiselect != null && g.hasOwnProperty("multiselect")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.MultiSelect.verify(g.multiselect);
        if (k) return "multiselect." + k;
      }
    }
    if (g.numberInput != null && g.hasOwnProperty("numberInput")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.NumberInput.verify(g.numberInput);
        if (k) return "numberInput." + k;
      }
    }
    if (g.pageLink != null && g.hasOwnProperty("pageLink")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.PageLink.verify(g.pageLink);
        if (k) return "pageLink." + k;
      }
    }
    if (g.plotlyChart != null && g.hasOwnProperty("plotlyChart")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.PlotlyChart.verify(g.plotlyChart);
        if (k) return "plotlyChart." + k;
      }
    }
    if (g.progress != null && g.hasOwnProperty("progress")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Progress.verify(g.progress);
        if (k) return "progress." + k;
      }
    }
    if (g.radio != null && g.hasOwnProperty("radio")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Radio.verify(g.radio);
        if (k) return "radio." + k;
      }
    }
    if (g.selectbox != null && g.hasOwnProperty("selectbox")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Selectbox.verify(g.selectbox);
        if (k) return "selectbox." + k;
      }
    }
    if (g.skeleton != null && g.hasOwnProperty("skeleton")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Skeleton.verify(g.skeleton);
        if (k) return "skeleton." + k;
      }
    }
    if (g.slider != null && g.hasOwnProperty("slider")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Slider.verify(g.slider);
        if (k) return "slider." + k;
      }
    }
    if (g.snow != null && g.hasOwnProperty("snow")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Snow.verify(g.snow);
        if (k) return "snow." + k;
      }
    }
    if (g.spinner != null && g.hasOwnProperty("spinner")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Spinner.verify(g.spinner);
        if (k) return "spinner." + k;
      }
    }
    if (g.text != null && g.hasOwnProperty("text")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Text.verify(g.text);
        if (k) return "text." + k;
      }
    }
    if (g.textArea != null && g.hasOwnProperty("textArea")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.TextArea.verify(g.textArea);
        if (k) return "textArea." + k;
      }
    }
    if (g.textInput != null && g.hasOwnProperty("textInput")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.TextInput.verify(g.textInput);
        if (k) return "textInput." + k;
      }
    }
    if (g.timeInput != null && g.hasOwnProperty("timeInput")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.TimeInput.verify(g.timeInput);
        if (k) return "timeInput." + k;
      }
    }
    if (g.toast != null && g.hasOwnProperty("toast")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Toast.verify(g.toast);
        if (k) return "toast." + k;
      }
    }
    if (g.vegaLiteChart != null && g.hasOwnProperty("vegaLiteChart")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.VegaLiteChart.verify(g.vegaLiteChart);
        if (k) return "vegaLiteChart." + k;
      }
    }
    if (g.video != null && g.hasOwnProperty("video")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Video.verify(g.video);
        if (k) return "video." + k;
      }
    }
    if (g.heading != null && g.hasOwnProperty("heading")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Heading.verify(g.heading);
        if (k) return "heading." + k;
      }
    }
    if (g.code != null && g.hasOwnProperty("code")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Code.verify(g.code);
        if (k) return "code." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Element) return g;
    let d = new $root.Element();
    if (g.heightConfig != null) {
      if (typeof g.heightConfig != "object") throw TypeError(".Element.heightConfig: object expected");
      d.heightConfig = $root.streamlit.HeightConfig.fromObject(g.heightConfig);
    }
    if (g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Element.widthConfig: object expected");
      d.widthConfig = $root.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    if (g.alert != null) {
      if (typeof g.alert != "object") throw TypeError(".Element.alert: object expected");
      d.alert = $root.Alert.fromObject(g.alert);
    }
    if (g.arrowDataFrame != null) {
      if (typeof g.arrowDataFrame != "object") throw TypeError(".Element.arrowDataFrame: object expected");
      d.arrowDataFrame = $root.Arrow.fromObject(g.arrowDataFrame);
    }
    if (g.arrowTable != null) {
      if (typeof g.arrowTable != "object") throw TypeError(".Element.arrowTable: object expected");
      d.arrowTable = $root.Arrow.fromObject(g.arrowTable);
    }
    if (g.arrowVegaLiteChart != null) {
      if (typeof g.arrowVegaLiteChart != "object") throw TypeError(".Element.arrowVegaLiteChart: object expected");
      d.arrowVegaLiteChart = $root.ArrowVegaLiteChart.fromObject(g.arrowVegaLiteChart);
    }
    if (g.audio != null) {
      if (typeof g.audio != "object") throw TypeError(".Element.audio: object expected");
      d.audio = $root.Audio.fromObject(g.audio);
    }
    if (g.audioInput != null) {
      if (typeof g.audioInput != "object") throw TypeError(".Element.audioInput: object expected");
      d.audioInput = $root.AudioInput.fromObject(g.audioInput);
    }
    if (g.balloons != null) {
      if (typeof g.balloons != "object") throw TypeError(".Element.balloons: object expected");
      d.balloons = $root.Balloons.fromObject(g.balloons);
    }
    if (g.bokehChart != null) {
      if (typeof g.bokehChart != "object") throw TypeError(".Element.bokehChart: object expected");
      d.bokehChart = $root.BokehChart.fromObject(g.bokehChart);
    }
    if (g.button != null) {
      if (typeof g.button != "object") throw TypeError(".Element.button: object expected");
      d.button = $root.Button.fromObject(g.button);
    }
    if (g.buttonGroup != null) {
      if (typeof g.buttonGroup != "object") throw TypeError(".Element.buttonGroup: object expected");
      d.buttonGroup = $root.ButtonGroup.fromObject(g.buttonGroup);
    }
    if (g.downloadButton != null) {
      if (typeof g.downloadButton != "object") throw TypeError(".Element.downloadButton: object expected");
      d.downloadButton = $root.DownloadButton.fromObject(g.downloadButton);
    }
    if (g.cameraInput != null) {
      if (typeof g.cameraInput != "object") throw TypeError(".Element.cameraInput: object expected");
      d.cameraInput = $root.CameraInput.fromObject(g.cameraInput);
    }
    if (g.chatInput != null) {
      if (typeof g.chatInput != "object") throw TypeError(".Element.chatInput: object expected");
      d.chatInput = $root.ChatInput.fromObject(g.chatInput);
    }
    if (g.checkbox != null) {
      if (typeof g.checkbox != "object") throw TypeError(".Element.checkbox: object expected");
      d.checkbox = $root.Checkbox.fromObject(g.checkbox);
    }
    if (g.colorPicker != null) {
      if (typeof g.colorPicker != "object") throw TypeError(".Element.colorPicker: object expected");
      d.colorPicker = $root.ColorPicker.fromObject(g.colorPicker);
    }
    if (g.componentInstance != null) {
      if (typeof g.componentInstance != "object") throw TypeError(".Element.componentInstance: object expected");
      d.componentInstance = $root.ComponentInstance.fromObject(g.componentInstance);
    }
    if (g.dataFrame != null) {
      if (typeof g.dataFrame != "object") throw TypeError(".Element.dataFrame: object expected");
      d.dataFrame = $root.DataFrame.fromObject(g.dataFrame);
    }
    if (g.table != null) {
      if (typeof g.table != "object") throw TypeError(".Element.table: object expected");
      d.table = $root.DataFrame.fromObject(g.table);
    }
    if (g.dateInput != null) {
      if (typeof g.dateInput != "object") throw TypeError(".Element.dateInput: object expected");
      d.dateInput = $root.DateInput.fromObject(g.dateInput);
    }
    if (g.deckGlJsonChart != null) {
      if (typeof g.deckGlJsonChart != "object") throw TypeError(".Element.deckGlJsonChart: object expected");
      d.deckGlJsonChart = $root.DeckGlJsonChart.fromObject(g.deckGlJsonChart);
    }
    if (g.docString != null) {
      if (typeof g.docString != "object") throw TypeError(".Element.docString: object expected");
      d.docString = $root.DocString.fromObject(g.docString);
    }
    if (g.empty != null) {
      if (typeof g.empty != "object") throw TypeError(".Element.empty: object expected");
      d.empty = $root.Empty.fromObject(g.empty);
    }
    if (g.exception != null) {
      if (typeof g.exception != "object") throw TypeError(".Element.exception: object expected");
      d.exception = $root.Exception.fromObject(g.exception);
    }
    if (g.favicon != null) {
      if (typeof g.favicon != "object") throw TypeError(".Element.favicon: object expected");
      d.favicon = $root.Favicon.fromObject(g.favicon);
    }
    if (g.fileUploader != null) {
      if (typeof g.fileUploader != "object") throw TypeError(".Element.fileUploader: object expected");
      d.fileUploader = $root.FileUploader.fromObject(g.fileUploader);
    }
    if (g.graphvizChart != null) {
      if (typeof g.graphvizChart != "object") throw TypeError(".Element.graphvizChart: object expected");
      d.graphvizChart = $root.GraphVizChart.fromObject(g.graphvizChart);
    }
    if (g.html != null) {
      if (typeof g.html != "object") throw TypeError(".Element.html: object expected");
      d.html = $root.Html.fromObject(g.html);
    }
    if (g.iframe != null) {
      if (typeof g.iframe != "object") throw TypeError(".Element.iframe: object expected");
      d.iframe = $root.IFrame.fromObject(g.iframe);
    }
    if (g.imgs != null) {
      if (typeof g.imgs != "object") throw TypeError(".Element.imgs: object expected");
      d.imgs = $root.ImageList.fromObject(g.imgs);
    }
    if (g.json != null) {
      if (typeof g.json != "object") throw TypeError(".Element.json: object expected");
      d.json = $root.Json.fromObject(g.json);
    }
    if (g.linkButton != null) {
      if (typeof g.linkButton != "object") throw TypeError(".Element.linkButton: object expected");
      d.linkButton = $root.LinkButton.fromObject(g.linkButton);
    }
    if (g.markdown != null) {
      if (typeof g.markdown != "object") throw TypeError(".Element.markdown: object expected");
      d.markdown = $root.Markdown.fromObject(g.markdown);
    }
    if (g.metric != null) {
      if (typeof g.metric != "object") throw TypeError(".Element.metric: object expected");
      d.metric = $root.Metric.fromObject(g.metric);
    }
    if (g.multiselect != null) {
      if (typeof g.multiselect != "object") throw TypeError(".Element.multiselect: object expected");
      d.multiselect = $root.MultiSelect.fromObject(g.multiselect);
    }
    if (g.numberInput != null) {
      if (typeof g.numberInput != "object") throw TypeError(".Element.numberInput: object expected");
      d.numberInput = $root.NumberInput.fromObject(g.numberInput);
    }
    if (g.pageLink != null) {
      if (typeof g.pageLink != "object") throw TypeError(".Element.pageLink: object expected");
      d.pageLink = $root.PageLink.fromObject(g.pageLink);
    }
    if (g.plotlyChart != null) {
      if (typeof g.plotlyChart != "object") throw TypeError(".Element.plotlyChart: object expected");
      d.plotlyChart = $root.PlotlyChart.fromObject(g.plotlyChart);
    }
    if (g.progress != null) {
      if (typeof g.progress != "object") throw TypeError(".Element.progress: object expected");
      d.progress = $root.Progress.fromObject(g.progress);
    }
    if (g.radio != null) {
      if (typeof g.radio != "object") throw TypeError(".Element.radio: object expected");
      d.radio = $root.Radio.fromObject(g.radio);
    }
    if (g.selectbox != null) {
      if (typeof g.selectbox != "object") throw TypeError(".Element.selectbox: object expected");
      d.selectbox = $root.Selectbox.fromObject(g.selectbox);
    }
    if (g.skeleton != null) {
      if (typeof g.skeleton != "object") throw TypeError(".Element.skeleton: object expected");
      d.skeleton = $root.Skeleton.fromObject(g.skeleton);
    }
    if (g.slider != null) {
      if (typeof g.slider != "object") throw TypeError(".Element.slider: object expected");
      d.slider = $root.Slider.fromObject(g.slider);
    }
    if (g.snow != null) {
      if (typeof g.snow != "object") throw TypeError(".Element.snow: object expected");
      d.snow = $root.Snow.fromObject(g.snow);
    }
    if (g.spinner != null) {
      if (typeof g.spinner != "object") throw TypeError(".Element.spinner: object expected");
      d.spinner = $root.Spinner.fromObject(g.spinner);
    }
    if (g.text != null) {
      if (typeof g.text != "object") throw TypeError(".Element.text: object expected");
      d.text = $root.Text.fromObject(g.text);
    }
    if (g.textArea != null) {
      if (typeof g.textArea != "object") throw TypeError(".Element.textArea: object expected");
      d.textArea = $root.TextArea.fromObject(g.textArea);
    }
    if (g.textInput != null) {
      if (typeof g.textInput != "object") throw TypeError(".Element.textInput: object expected");
      d.textInput = $root.TextInput.fromObject(g.textInput);
    }
    if (g.timeInput != null) {
      if (typeof g.timeInput != "object") throw TypeError(".Element.timeInput: object expected");
      d.timeInput = $root.TimeInput.fromObject(g.timeInput);
    }
    if (g.toast != null) {
      if (typeof g.toast != "object") throw TypeError(".Element.toast: object expected");
      d.toast = $root.Toast.fromObject(g.toast);
    }
    if (g.vegaLiteChart != null) {
      if (typeof g.vegaLiteChart != "object") throw TypeError(".Element.vegaLiteChart: object expected");
      d.vegaLiteChart = $root.VegaLiteChart.fromObject(g.vegaLiteChart);
    }
    if (g.video != null) {
      if (typeof g.video != "object") throw TypeError(".Element.video: object expected");
      d.video = $root.Video.fromObject(g.video);
    }
    if (g.heading != null) {
      if (typeof g.heading != "object") throw TypeError(".Element.heading: object expected");
      d.heading = $root.Heading.fromObject(g.heading);
    }
    if (g.code != null) {
      if (typeof g.code != "object") throw TypeError(".Element.code: object expected");
      d.code = $root.Code.fromObject(g.code);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return g.text != null && g.hasOwnProperty("text") && (k.text = $root.Text.toObject(g.text, d), d.oneofs && (k.type = "text")), g.empty != null && g.hasOwnProperty("empty") && (k.empty = $root.Empty.toObject(g.empty, d), d.oneofs && (k.type = "empty")), g.dataFrame != null && g.hasOwnProperty("dataFrame") && (k.dataFrame = $root.DataFrame.toObject(g.dataFrame, d), d.oneofs && (k.type = "dataFrame")), g.progress != null && g.hasOwnProperty("progress") && (k.progress = $root.Progress.toObject(g.progress, d), d.oneofs && (k.type = "progress")), g.imgs != null && g.hasOwnProperty("imgs") && (k.imgs = $root.ImageList.toObject(g.imgs, d), d.oneofs && (k.type = "imgs")), g.docString != null && g.hasOwnProperty("docString") && (k.docString = $root.DocString.toObject(g.docString, d), d.oneofs && (k.type = "docString")), g.exception != null && g.hasOwnProperty("exception") && (k.exception = $root.Exception.toObject(g.exception, d), d.oneofs && (k.type = "exception")), g.vegaLiteChart != null && g.hasOwnProperty("vegaLiteChart") && (k.vegaLiteChart = $root.VegaLiteChart.toObject(g.vegaLiteChart, d), d.oneofs && (k.type = "vegaLiteChart")), g.table != null && g.hasOwnProperty("table") && (k.table = $root.DataFrame.toObject(g.table, d), d.oneofs && (k.type = "table")), g.balloons != null && g.hasOwnProperty("balloons") && (k.balloons = $root.Balloons.toObject(g.balloons, d), d.oneofs && (k.type = "balloons")), g.audio != null && g.hasOwnProperty("audio") && (k.audio = $root.Audio.toObject(g.audio, d), d.oneofs && (k.type = "audio")), g.video != null && g.hasOwnProperty("video") && (k.video = $root.Video.toObject(g.video, d), d.oneofs && (k.type = "video")), g.plotlyChart != null && g.hasOwnProperty("plotlyChart") && (k.plotlyChart = $root.PlotlyChart.toObject(g.plotlyChart, d), d.oneofs && (k.type = "plotlyChart")), g.bokehChart != null && g.hasOwnProperty("bokehChart") && (k.bokehChart = $root.BokehChart.toObject(g.bokehChart, d), d.oneofs && (k.type = "bokehChart")), g.graphvizChart != null && g.hasOwnProperty("graphvizChart") && (k.graphvizChart = $root.GraphVizChart.toObject(g.graphvizChart, d), d.oneofs && (k.type = "graphvizChart")), g.button != null && g.hasOwnProperty("button") && (k.button = $root.Button.toObject(g.button, d), d.oneofs && (k.type = "button")), g.checkbox != null && g.hasOwnProperty("checkbox") && (k.checkbox = $root.Checkbox.toObject(g.checkbox, d), d.oneofs && (k.type = "checkbox")), g.slider != null && g.hasOwnProperty("slider") && (k.slider = $root.Slider.toObject(g.slider, d), d.oneofs && (k.type = "slider")), g.textArea != null && g.hasOwnProperty("textArea") && (k.textArea = $root.TextArea.toObject(g.textArea, d), d.oneofs && (k.type = "textArea")), g.radio != null && g.hasOwnProperty("radio") && (k.radio = $root.Radio.toObject(g.radio, d), d.oneofs && (k.type = "radio")), g.textInput != null && g.hasOwnProperty("textInput") && (k.textInput = $root.TextInput.toObject(g.textInput, d), d.oneofs && (k.type = "textInput")), g.selectbox != null && g.hasOwnProperty("selectbox") && (k.selectbox = $root.Selectbox.toObject(g.selectbox, d), d.oneofs && (k.type = "selectbox")), g.timeInput != null && g.hasOwnProperty("timeInput") && (k.timeInput = $root.TimeInput.toObject(g.timeInput, d), d.oneofs && (k.type = "timeInput")), g.dateInput != null && g.hasOwnProperty("dateInput") && (k.dateInput = $root.DateInput.toObject(g.dateInput, d), d.oneofs && (k.type = "dateInput")), g.multiselect != null && g.hasOwnProperty("multiselect") && (k.multiselect = $root.MultiSelect.toObject(g.multiselect, d), d.oneofs && (k.type = "multiselect")), g.markdown != null && g.hasOwnProperty("markdown") && (k.markdown = $root.Markdown.toObject(g.markdown, d), d.oneofs && (k.type = "markdown")), g.alert != null && g.hasOwnProperty("alert") && (k.alert = $root.Alert.toObject(g.alert, d), d.oneofs && (k.type = "alert")), g.json != null && g.hasOwnProperty("json") && (k.json = $root.Json.toObject(g.json, d), d.oneofs && (k.type = "json")), g.numberInput != null && g.hasOwnProperty("numberInput") && (k.numberInput = $root.NumberInput.toObject(g.numberInput, d), d.oneofs && (k.type = "numberInput")), g.fileUploader != null && g.hasOwnProperty("fileUploader") && (k.fileUploader = $root.FileUploader.toObject(g.fileUploader, d), d.oneofs && (k.type = "fileUploader")), g.deckGlJsonChart != null && g.hasOwnProperty("deckGlJsonChart") && (k.deckGlJsonChart = $root.DeckGlJsonChart.toObject(g.deckGlJsonChart, d), d.oneofs && (k.type = "deckGlJsonChart")), g.colorPicker != null && g.hasOwnProperty("colorPicker") && (k.colorPicker = $root.ColorPicker.toObject(g.colorPicker, d), d.oneofs && (k.type = "colorPicker")), g.favicon != null && g.hasOwnProperty("favicon") && (k.favicon = $root.Favicon.toObject(g.favicon, d), d.oneofs && (k.type = "favicon")), g.componentInstance != null && g.hasOwnProperty("componentInstance") && (k.componentInstance = $root.ComponentInstance.toObject(g.componentInstance, d), d.oneofs && (k.type = "componentInstance")), g.iframe != null && g.hasOwnProperty("iframe") && (k.iframe = $root.IFrame.toObject(g.iframe, d), d.oneofs && (k.type = "iframe")), g.arrowTable != null && g.hasOwnProperty("arrowTable") && (k.arrowTable = $root.Arrow.toObject(g.arrowTable, d), d.oneofs && (k.type = "arrowTable")), g.arrowDataFrame != null && g.hasOwnProperty("arrowDataFrame") && (k.arrowDataFrame = $root.Arrow.toObject(g.arrowDataFrame, d), d.oneofs && (k.type = "arrowDataFrame")), g.arrowVegaLiteChart != null && g.hasOwnProperty("arrowVegaLiteChart") && (k.arrowVegaLiteChart = $root.ArrowVegaLiteChart.toObject(g.arrowVegaLiteChart, d), d.oneofs && (k.type = "arrowVegaLiteChart")), g.metric != null && g.hasOwnProperty("metric") && (k.metric = $root.Metric.toObject(g.metric, d), d.oneofs && (k.type = "metric")), g.downloadButton != null && g.hasOwnProperty("downloadButton") && (k.downloadButton = $root.DownloadButton.toObject(g.downloadButton, d), d.oneofs && (k.type = "downloadButton")), g.spinner != null && g.hasOwnProperty("spinner") && (k.spinner = $root.Spinner.toObject(g.spinner, d), d.oneofs && (k.type = "spinner")), g.cameraInput != null && g.hasOwnProperty("cameraInput") && (k.cameraInput = $root.CameraInput.toObject(g.cameraInput, d), d.oneofs && (k.type = "cameraInput")), g.snow != null && g.hasOwnProperty("snow") && (k.snow = $root.Snow.toObject(g.snow, d), d.oneofs && (k.type = "snow")), g.heading != null && g.hasOwnProperty("heading") && (k.heading = $root.Heading.toObject(g.heading, d), d.oneofs && (k.type = "heading")), g.code != null && g.hasOwnProperty("code") && (k.code = $root.Code.toObject(g.code, d), d.oneofs && (k.type = "code")), g.chatInput != null && g.hasOwnProperty("chatInput") && (k.chatInput = $root.ChatInput.toObject(g.chatInput, d), d.oneofs && (k.type = "chatInput")), g.toast != null && g.hasOwnProperty("toast") && (k.toast = $root.Toast.toObject(g.toast, d), d.oneofs && (k.type = "toast")), g.linkButton != null && g.hasOwnProperty("linkButton") && (k.linkButton = $root.LinkButton.toObject(g.linkButton, d), d.oneofs && (k.type = "linkButton")), g.skeleton != null && g.hasOwnProperty("skeleton") && (k.skeleton = $root.Skeleton.toObject(g.skeleton, d), d.oneofs && (k.type = "skeleton")), g.pageLink != null && g.hasOwnProperty("pageLink") && (k.pageLink = $root.PageLink.toObject(g.pageLink, d), d.oneofs && (k.type = "pageLink")), g.html != null && g.hasOwnProperty("html") && (k.html = $root.Html.toObject(g.html, d), d.oneofs && (k.type = "html")), g.buttonGroup != null && g.hasOwnProperty("buttonGroup") && (k.buttonGroup = $root.ButtonGroup.toObject(g.buttonGroup, d), d.oneofs && (k.type = "buttonGroup")), g.audioInput != null && g.hasOwnProperty("audioInput") && (k.audioInput = $root.AudioInput.toObject(g.audioInput, d), d.oneofs && (k.type = "audioInput")), g.heightConfig != null && g.hasOwnProperty("heightConfig") && (k.heightConfig = $root.streamlit.HeightConfig.toObject(g.heightConfig, d), d.oneofs && (k._heightConfig = "heightConfig")), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (k.widthConfig = $root.streamlit.WidthConfig.toObject(g.widthConfig, d), d.oneofs && (k._widthConfig = "widthConfig")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Element";
  }, n;
})();
$root.DownloadButton = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.default = !1, n.prototype.help = "", n.prototype.formId = "", n.prototype.url = "", n.prototype.disabled = !1, n.prototype.useContainerWidth = !1, n.prototype.type = "", n.prototype.icon = "", n.prototype.ignoreRerun = !1, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.default != null && Object.hasOwnProperty.call(t, "default") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(t.default), t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.formId), t.url != null && Object.hasOwnProperty.call(t, "url") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.url), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(t.disabled), t.useContainerWidth != null && Object.hasOwnProperty.call(t, "useContainerWidth") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.useContainerWidth), t.type != null && Object.hasOwnProperty.call(t, "type") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(t.type), t.icon != null && Object.hasOwnProperty.call(t, "icon") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(t.icon), t.ignoreRerun != null && Object.hasOwnProperty.call(t, "ignoreRerun") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(t.ignoreRerun), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.DownloadButton();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.id = t.string();
          break;
        }
        case 2: {
          H.label = t.string();
          break;
        }
        case 3: {
          H.default = t.bool();
          break;
        }
        case 4: {
          H.help = t.string();
          break;
        }
        case 5: {
          H.formId = t.string();
          break;
        }
        case 6: {
          H.url = t.string();
          break;
        }
        case 7: {
          H.disabled = t.bool();
          break;
        }
        case 8: {
          H.useContainerWidth = t.bool();
          break;
        }
        case 9: {
          H.type = t.string();
          break;
        }
        case 10: {
          H.icon = t.string();
          break;
        }
        case 11: {
          H.ignoreRerun = t.bool();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id) ? "id: string expected" : t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label) ? "label: string expected" : t.default != null && t.hasOwnProperty("default") && typeof t.default != "boolean" ? "default: boolean expected" : t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help) ? "help: string expected" : t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId) ? "formId: string expected" : t.url != null && t.hasOwnProperty("url") && !$util.isString(t.url) ? "url: string expected" : t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean" ? "disabled: boolean expected" : t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && typeof t.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : t.type != null && t.hasOwnProperty("type") && !$util.isString(t.type) ? "type: string expected" : t.icon != null && t.hasOwnProperty("icon") && !$util.isString(t.icon) ? "icon: string expected" : t.ignoreRerun != null && t.hasOwnProperty("ignoreRerun") && typeof t.ignoreRerun != "boolean" ? "ignoreRerun: boolean expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.DownloadButton) return t;
    let g = new $root.DownloadButton();
    return t.id != null && (g.id = String(t.id)), t.label != null && (g.label = String(t.label)), t.default != null && (g.default = !!t.default), t.help != null && (g.help = String(t.help)), t.formId != null && (g.formId = String(t.formId)), t.url != null && (g.url = String(t.url)), t.disabled != null && (g.disabled = !!t.disabled), t.useContainerWidth != null && (g.useContainerWidth = !!t.useContainerWidth), t.type != null && (g.type = String(t.type)), t.icon != null && (g.icon = String(t.icon)), t.ignoreRerun != null && (g.ignoreRerun = !!t.ignoreRerun), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.id = "", d.label = "", d.default = !1, d.help = "", d.formId = "", d.url = "", d.disabled = !1, d.useContainerWidth = !1, d.type = "", d.icon = "", d.ignoreRerun = !1), t.id != null && t.hasOwnProperty("id") && (d.id = t.id), t.label != null && t.hasOwnProperty("label") && (d.label = t.label), t.default != null && t.hasOwnProperty("default") && (d.default = t.default), t.help != null && t.hasOwnProperty("help") && (d.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (d.formId = t.formId), t.url != null && t.hasOwnProperty("url") && (d.url = t.url), t.disabled != null && t.hasOwnProperty("disabled") && (d.disabled = t.disabled), t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && (d.useContainerWidth = t.useContainerWidth), t.type != null && t.hasOwnProperty("type") && (d.type = t.type), t.icon != null && t.hasOwnProperty("icon") && (d.icon = t.icon), t.ignoreRerun != null && t.hasOwnProperty("ignoreRerun") && (d.ignoreRerun = t.ignoreRerun), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/DownloadButton";
  }, n;
})();
$root.DocString = (() => {
  function n(t) {
    if (this.members = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.docString = "", n.prototype.type = "", n.prototype.name = "", n.prototype.value = "", n.prototype.members = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.docString != null && Object.hasOwnProperty.call(t, "docString") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.docString), t.type != null && Object.hasOwnProperty.call(t, "type") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.type), t.name != null && Object.hasOwnProperty.call(t, "name") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.name), t.value != null && Object.hasOwnProperty.call(t, "value") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.value), t.members != null && t.members.length) for (let d = 0; d < t.members.length; ++d) $root.Member.encode(t.members[d], g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.DocString();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 3: {
          H.docString = t.string();
          break;
        }
        case 4: {
          H.type = t.string();
          break;
        }
        case 6: {
          H.name = t.string();
          break;
        }
        case 7: {
          H.value = t.string();
          break;
        }
        case 8: {
          H.members && H.members.length || (H.members = []), H.members.push($root.Member.decode(t, t.uint32()));
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.docString != null && t.hasOwnProperty("docString") && !$util.isString(t.docString)) return "docString: string expected";
    if (t.type != null && t.hasOwnProperty("type") && !$util.isString(t.type)) return "type: string expected";
    if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name)) return "name: string expected";
    if (t.value != null && t.hasOwnProperty("value") && !$util.isString(t.value)) return "value: string expected";
    if (t.members != null && t.hasOwnProperty("members")) {
      if (!Array.isArray(t.members)) return "members: array expected";
      for (let g = 0; g < t.members.length; ++g) {
        let d = $root.Member.verify(t.members[g]);
        if (d) return "members." + d;
      }
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.DocString) return t;
    let g = new $root.DocString();
    if (t.docString != null && (g.docString = String(t.docString)), t.type != null && (g.type = String(t.type)), t.name != null && (g.name = String(t.name)), t.value != null && (g.value = String(t.value)), t.members) {
      if (!Array.isArray(t.members)) throw TypeError(".DocString.members: array expected");
      g.members = [];
      for (let d = 0; d < t.members.length; ++d) {
        if (typeof t.members[d] != "object") throw TypeError(".DocString.members: object expected");
        g.members[d] = $root.Member.fromObject(t.members[d]);
      }
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.members = []), g.defaults && (d.docString = "", d.type = "", d.name = "", d.value = ""), t.docString != null && t.hasOwnProperty("docString") && (d.docString = t.docString), t.type != null && t.hasOwnProperty("type") && (d.type = t.type), t.name != null && t.hasOwnProperty("name") && (d.name = t.name), t.value != null && t.hasOwnProperty("value") && (d.value = t.value), t.members && t.members.length) {
      d.members = [];
      for (let k = 0; k < t.members.length; ++k) d.members[k] = $root.Member.toObject(t.members[k], g);
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/DocString";
  }, n;
})();
$root.Member = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.name = "", n.prototype.type = "", n.prototype.value = null, n.prototype.docString = null;
  let t;
  return Object.defineProperty(n.prototype, "contents", { get: $util.oneOfGetter(t = ["value", "docString"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.name), g.type != null && Object.hasOwnProperty.call(g, "type") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.type), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.value), g.docString != null && Object.hasOwnProperty.call(g, "docString") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.docString), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Member();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.name = g.string();
          break;
        }
        case 2: {
          AA.type = g.string();
          break;
        }
        case 3: {
          AA.value = g.string();
          break;
        }
        case 4: {
          AA.docString = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.name != null && g.hasOwnProperty("name") && !$util.isString(g.name)) return "name: string expected";
    if (g.type != null && g.hasOwnProperty("type") && !$util.isString(g.type)) return "type: string expected";
    if (g.value != null && g.hasOwnProperty("value") && (d.contents = 1, !$util.isString(g.value))) return "value: string expected";
    if (g.docString != null && g.hasOwnProperty("docString")) {
      if (d.contents === 1) return "contents: multiple values";
      if (d.contents = 1, !$util.isString(g.docString)) return "docString: string expected";
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Member) return g;
    let d = new $root.Member();
    return g.name != null && (d.name = String(g.name)), g.type != null && (d.type = String(g.type)), g.value != null && (d.value = String(g.value)), g.docString != null && (d.docString = String(g.docString)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.name = "", k.type = ""), g.name != null && g.hasOwnProperty("name") && (k.name = g.name), g.type != null && g.hasOwnProperty("type") && (k.type = g.type), g.value != null && g.hasOwnProperty("value") && (k.value = g.value, d.oneofs && (k.contents = "value")), g.docString != null && g.hasOwnProperty("docString") && (k.docString = g.docString, d.oneofs && (k.contents = "docString")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Member";
  }, n;
})();
$root.Empty = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Empty();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : null;
  }, n.fromObject = function(t) {
    return t instanceof $root.Empty ? t : new $root.Empty();
  }, n.toObject = function() {
    return {};
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Empty";
  }, n;
})();
$root.Exception = (() => {
  function n(t) {
    if (this.stackTrace = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.type = "", n.prototype.message = "", n.prototype.messageIsMarkdown = !1, n.prototype.stackTrace = $util.emptyArray, n.prototype.isWarning = !1, n.prototype.widthConfig = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.type != null && Object.hasOwnProperty.call(t, "type") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.type), t.message != null && Object.hasOwnProperty.call(t, "message") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.message), t.stackTrace != null && t.stackTrace.length) for (let d = 0; d < t.stackTrace.length; ++d) g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.stackTrace[d]);
    return t.messageIsMarkdown != null && Object.hasOwnProperty.call(t, "messageIsMarkdown") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(t.messageIsMarkdown), t.isWarning != null && Object.hasOwnProperty.call(t, "isWarning") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.isWarning), t.widthConfig != null && Object.hasOwnProperty.call(t, "widthConfig") && $root.streamlit.WidthConfig.encode(t.widthConfig, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Exception();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.type = t.string();
          break;
        }
        case 2: {
          H.message = t.string();
          break;
        }
        case 4: {
          H.messageIsMarkdown = t.bool();
          break;
        }
        case 3: {
          H.stackTrace && H.stackTrace.length || (H.stackTrace = []), H.stackTrace.push(t.string());
          break;
        }
        case 5: {
          H.isWarning = t.bool();
          break;
        }
        case 6: {
          H.widthConfig = $root.streamlit.WidthConfig.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.type != null && t.hasOwnProperty("type") && !$util.isString(t.type)) return "type: string expected";
    if (t.message != null && t.hasOwnProperty("message") && !$util.isString(t.message)) return "message: string expected";
    if (t.messageIsMarkdown != null && t.hasOwnProperty("messageIsMarkdown") && typeof t.messageIsMarkdown != "boolean") return "messageIsMarkdown: boolean expected";
    if (t.stackTrace != null && t.hasOwnProperty("stackTrace")) {
      if (!Array.isArray(t.stackTrace)) return "stackTrace: array expected";
      for (let g = 0; g < t.stackTrace.length; ++g) if (!$util.isString(t.stackTrace[g])) return "stackTrace: string[] expected";
    }
    if (t.isWarning != null && t.hasOwnProperty("isWarning") && typeof t.isWarning != "boolean") return "isWarning: boolean expected";
    if (t.widthConfig != null && t.hasOwnProperty("widthConfig")) {
      let g = $root.streamlit.WidthConfig.verify(t.widthConfig);
      if (g) return "widthConfig." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Exception) return t;
    let g = new $root.Exception();
    if (t.type != null && (g.type = String(t.type)), t.message != null && (g.message = String(t.message)), t.messageIsMarkdown != null && (g.messageIsMarkdown = !!t.messageIsMarkdown), t.stackTrace) {
      if (!Array.isArray(t.stackTrace)) throw TypeError(".Exception.stackTrace: array expected");
      g.stackTrace = [];
      for (let d = 0; d < t.stackTrace.length; ++d) g.stackTrace[d] = String(t.stackTrace[d]);
    }
    if (t.isWarning != null && (g.isWarning = !!t.isWarning), t.widthConfig != null) {
      if (typeof t.widthConfig != "object") throw TypeError(".Exception.widthConfig: object expected");
      g.widthConfig = $root.streamlit.WidthConfig.fromObject(t.widthConfig);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.stackTrace = []), g.defaults && (d.type = "", d.message = "", d.messageIsMarkdown = !1, d.isWarning = !1, d.widthConfig = null), t.type != null && t.hasOwnProperty("type") && (d.type = t.type), t.message != null && t.hasOwnProperty("message") && (d.message = t.message), t.stackTrace && t.stackTrace.length) {
      d.stackTrace = [];
      for (let k = 0; k < t.stackTrace.length; ++k) d.stackTrace[k] = t.stackTrace[k];
    }
    return t.messageIsMarkdown != null && t.hasOwnProperty("messageIsMarkdown") && (d.messageIsMarkdown = t.messageIsMarkdown), t.isWarning != null && t.hasOwnProperty("isWarning") && (d.isWarning = t.isWarning), t.widthConfig != null && t.hasOwnProperty("widthConfig") && (d.widthConfig = $root.streamlit.WidthConfig.toObject(t.widthConfig, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Exception";
  }, n;
})();
$root.Favicon = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.url = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.url != null && Object.hasOwnProperty.call(t, "url") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.url), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Favicon();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.url = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.url != null && t.hasOwnProperty("url") && !$util.isString(t.url) ? "url: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Favicon) return t;
    let g = new $root.Favicon();
    return t.url != null && (g.url = String(t.url)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.url = ""), t.url != null && t.hasOwnProperty("url") && (d.url = t.url), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Favicon";
  }, n;
})();
$root.FileUploader = (() => {
  function n(t) {
    if (this.type = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.label = "", n.prototype.type = $util.emptyArray, n.prototype.maxUploadSizeMb = 0, n.prototype.multipleFiles = !1, n.prototype.help = "", n.prototype.formId = "", n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.acceptDirectory = !1, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.type != null && t.type.length) for (let d = 0; d < t.type.length; ++d) g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.type[d]);
    return t.maxUploadSizeMb != null && Object.hasOwnProperty.call(t, "maxUploadSizeMb") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(t.maxUploadSizeMb), t.multipleFiles != null && Object.hasOwnProperty.call(t, "multipleFiles") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(t.multipleFiles), t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(t.formId), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && g.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), t.acceptDirectory != null && Object.hasOwnProperty.call(t, "acceptDirectory") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(t.acceptDirectory), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.FileUploader();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.id = t.string();
          break;
        }
        case 2: {
          H.label = t.string();
          break;
        }
        case 3: {
          H.type && H.type.length || (H.type = []), H.type.push(t.string());
          break;
        }
        case 4: {
          H.maxUploadSizeMb = t.int32();
          break;
        }
        case 6: {
          H.multipleFiles = t.bool();
          break;
        }
        case 7: {
          H.help = t.string();
          break;
        }
        case 8: {
          H.formId = t.string();
          break;
        }
        case 9: {
          H.disabled = t.bool();
          break;
        }
        case 10: {
          H.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 11: {
          H.acceptDirectory = t.bool();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id)) return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label)) return "label: string expected";
    if (t.type != null && t.hasOwnProperty("type")) {
      if (!Array.isArray(t.type)) return "type: array expected";
      for (let g = 0; g < t.type.length; ++g) if (!$util.isString(t.type[g])) return "type: string[] expected";
    }
    if (t.maxUploadSizeMb != null && t.hasOwnProperty("maxUploadSizeMb") && !$util.isInteger(t.maxUploadSizeMb)) return "maxUploadSizeMb: integer expected";
    if (t.multipleFiles != null && t.hasOwnProperty("multipleFiles") && typeof t.multipleFiles != "boolean") return "multipleFiles: boolean expected";
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help)) return "help: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId)) return "formId: string expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean") return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let g = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (g) return "labelVisibility." + g;
    }
    return t.acceptDirectory != null && t.hasOwnProperty("acceptDirectory") && typeof t.acceptDirectory != "boolean" ? "acceptDirectory: boolean expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.FileUploader) return t;
    let g = new $root.FileUploader();
    if (t.id != null && (g.id = String(t.id)), t.label != null && (g.label = String(t.label)), t.type) {
      if (!Array.isArray(t.type)) throw TypeError(".FileUploader.type: array expected");
      g.type = [];
      for (let d = 0; d < t.type.length; ++d) g.type[d] = String(t.type[d]);
    }
    if (t.maxUploadSizeMb != null && (g.maxUploadSizeMb = t.maxUploadSizeMb | 0), t.multipleFiles != null && (g.multipleFiles = !!t.multipleFiles), t.help != null && (g.help = String(t.help)), t.formId != null && (g.formId = String(t.formId)), t.disabled != null && (g.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object") throw TypeError(".FileUploader.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    return t.acceptDirectory != null && (g.acceptDirectory = !!t.acceptDirectory), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.type = []), g.defaults && (d.id = "", d.label = "", d.maxUploadSizeMb = 0, d.multipleFiles = !1, d.help = "", d.formId = "", d.disabled = !1, d.labelVisibility = null, d.acceptDirectory = !1), t.id != null && t.hasOwnProperty("id") && (d.id = t.id), t.label != null && t.hasOwnProperty("label") && (d.label = t.label), t.type && t.type.length) {
      d.type = [];
      for (let k = 0; k < t.type.length; ++k) d.type[k] = t.type[k];
    }
    return t.maxUploadSizeMb != null && t.hasOwnProperty("maxUploadSizeMb") && (d.maxUploadSizeMb = t.maxUploadSizeMb), t.multipleFiles != null && t.hasOwnProperty("multipleFiles") && (d.multipleFiles = t.multipleFiles), t.help != null && t.hasOwnProperty("help") && (d.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (d.formId = t.formId), t.disabled != null && t.hasOwnProperty("disabled") && (d.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (d.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, g)), t.acceptDirectory != null && t.hasOwnProperty("acceptDirectory") && (d.acceptDirectory = t.acceptDirectory), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/FileUploader";
  }, n;
})();
$root.GraphVizChart = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.spec = "", n.prototype.useContainerWidth = !1, n.prototype.elementId = "", n.prototype.engine = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.spec != null && Object.hasOwnProperty.call(t, "spec") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.spec), t.useContainerWidth != null && Object.hasOwnProperty.call(t, "useContainerWidth") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(t.useContainerWidth), t.elementId != null && Object.hasOwnProperty.call(t, "elementId") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.elementId), t.engine != null && Object.hasOwnProperty.call(t, "engine") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.engine), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.GraphVizChart();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.spec = t.string();
          break;
        }
        case 4: {
          H.useContainerWidth = t.bool();
          break;
        }
        case 5: {
          H.elementId = t.string();
          break;
        }
        case 6: {
          H.engine = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.spec != null && t.hasOwnProperty("spec") && !$util.isString(t.spec) ? "spec: string expected" : t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && typeof t.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : t.elementId != null && t.hasOwnProperty("elementId") && !$util.isString(t.elementId) ? "elementId: string expected" : t.engine != null && t.hasOwnProperty("engine") && !$util.isString(t.engine) ? "engine: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.GraphVizChart) return t;
    let g = new $root.GraphVizChart();
    return t.spec != null && (g.spec = String(t.spec)), t.useContainerWidth != null && (g.useContainerWidth = !!t.useContainerWidth), t.elementId != null && (g.elementId = String(t.elementId)), t.engine != null && (g.engine = String(t.engine)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.spec = "", d.useContainerWidth = !1, d.elementId = "", d.engine = ""), t.spec != null && t.hasOwnProperty("spec") && (d.spec = t.spec), t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && (d.useContainerWidth = t.useContainerWidth), t.elementId != null && t.hasOwnProperty("elementId") && (d.elementId = t.elementId), t.engine != null && t.hasOwnProperty("engine") && (d.engine = t.engine), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/GraphVizChart";
  }, n;
})();
$root.Html = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.body = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.body != null && Object.hasOwnProperty.call(t, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.body), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Html();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.body = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.body != null && t.hasOwnProperty("body") && !$util.isString(t.body) ? "body: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Html) return t;
    let g = new $root.Html();
    return t.body != null && (g.body = String(t.body)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.body = ""), t.body != null && t.hasOwnProperty("body") && (d.body = t.body), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Html";
  }, n;
})();
$root.IFrame = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.src = null, n.prototype.srcdoc = null, n.prototype.width = 0, n.prototype.hasWidth = !1, n.prototype.height = 0, n.prototype.scrolling = !1, n.prototype.tabIndex = null;
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util.oneOfGetter(t = ["src", "srcdoc"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_tabIndex", { get: $util.oneOfGetter(t = ["tabIndex"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.src != null && Object.hasOwnProperty.call(g, "src") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.src), g.srcdoc != null && Object.hasOwnProperty.call(g, "srcdoc") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.srcdoc), g.width != null && Object.hasOwnProperty.call(g, "width") && d.uint32(
      /* id 3, wireType 5 =*/
      29
    ).float(g.width), g.hasWidth != null && Object.hasOwnProperty.call(g, "hasWidth") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(g.hasWidth), g.height != null && Object.hasOwnProperty.call(g, "height") && d.uint32(
      /* id 5, wireType 5 =*/
      45
    ).float(g.height), g.scrolling != null && Object.hasOwnProperty.call(g, "scrolling") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.scrolling), g.tabIndex != null && Object.hasOwnProperty.call(g, "tabIndex") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.tabIndex), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.IFrame();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.src = g.string();
          break;
        }
        case 2: {
          AA.srcdoc = g.string();
          break;
        }
        case 3: {
          AA.width = g.float();
          break;
        }
        case 4: {
          AA.hasWidth = g.bool();
          break;
        }
        case 5: {
          AA.height = g.float();
          break;
        }
        case 7: {
          AA.scrolling = g.bool();
          break;
        }
        case 8: {
          AA.tabIndex = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.src != null && g.hasOwnProperty("src") && (d.type = 1, !$util.isString(g.src))) return "src: string expected";
    if (g.srcdoc != null && g.hasOwnProperty("srcdoc")) {
      if (d.type === 1) return "type: multiple values";
      if (d.type = 1, !$util.isString(g.srcdoc)) return "srcdoc: string expected";
    }
    return g.width != null && g.hasOwnProperty("width") && typeof g.width != "number" ? "width: number expected" : g.hasWidth != null && g.hasOwnProperty("hasWidth") && typeof g.hasWidth != "boolean" ? "hasWidth: boolean expected" : g.height != null && g.hasOwnProperty("height") && typeof g.height != "number" ? "height: number expected" : g.scrolling != null && g.hasOwnProperty("scrolling") && typeof g.scrolling != "boolean" ? "scrolling: boolean expected" : g.tabIndex != null && g.hasOwnProperty("tabIndex") && (d._tabIndex = 1, !$util.isInteger(g.tabIndex)) ? "tabIndex: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.IFrame) return g;
    let d = new $root.IFrame();
    return g.src != null && (d.src = String(g.src)), g.srcdoc != null && (d.srcdoc = String(g.srcdoc)), g.width != null && (d.width = Number(g.width)), g.hasWidth != null && (d.hasWidth = !!g.hasWidth), g.height != null && (d.height = Number(g.height)), g.scrolling != null && (d.scrolling = !!g.scrolling), g.tabIndex != null && (d.tabIndex = g.tabIndex | 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.width = 0, k.hasWidth = !1, k.height = 0, k.scrolling = !1), g.src != null && g.hasOwnProperty("src") && (k.src = g.src, d.oneofs && (k.type = "src")), g.srcdoc != null && g.hasOwnProperty("srcdoc") && (k.srcdoc = g.srcdoc, d.oneofs && (k.type = "srcdoc")), g.width != null && g.hasOwnProperty("width") && (k.width = d.json && !isFinite(g.width) ? String(g.width) : g.width), g.hasWidth != null && g.hasOwnProperty("hasWidth") && (k.hasWidth = g.hasWidth), g.height != null && g.hasOwnProperty("height") && (k.height = d.json && !isFinite(g.height) ? String(g.height) : g.height), g.scrolling != null && g.hasOwnProperty("scrolling") && (k.scrolling = g.scrolling), g.tabIndex != null && g.hasOwnProperty("tabIndex") && (k.tabIndex = g.tabIndex, d.oneofs && (k._tabIndex = "tabIndex")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/IFrame";
  }, n;
})();
$root.Image = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.url = "", n.prototype.caption = "", n.prototype.markup = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.caption != null && Object.hasOwnProperty.call(t, "caption") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.caption), t.url != null && Object.hasOwnProperty.call(t, "url") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.url), t.markup != null && Object.hasOwnProperty.call(t, "markup") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.markup), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Image();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 3: {
          H.url = t.string();
          break;
        }
        case 2: {
          H.caption = t.string();
          break;
        }
        case 4: {
          H.markup = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.url != null && t.hasOwnProperty("url") && !$util.isString(t.url) ? "url: string expected" : t.caption != null && t.hasOwnProperty("caption") && !$util.isString(t.caption) ? "caption: string expected" : t.markup != null && t.hasOwnProperty("markup") && !$util.isString(t.markup) ? "markup: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Image) return t;
    let g = new $root.Image();
    return t.url != null && (g.url = String(t.url)), t.caption != null && (g.caption = String(t.caption)), t.markup != null && (g.markup = String(t.markup)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.caption = "", d.url = "", d.markup = ""), t.caption != null && t.hasOwnProperty("caption") && (d.caption = t.caption), t.url != null && t.hasOwnProperty("url") && (d.url = t.url), t.markup != null && t.hasOwnProperty("markup") && (d.markup = t.markup), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Image";
  }, n;
})();
$root.ImageList = (() => {
  function n(t) {
    if (this.imgs = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.imgs = $util.emptyArray, n.prototype.width = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.imgs != null && t.imgs.length) for (let d = 0; d < t.imgs.length; ++d) $root.Image.encode(t.imgs[d], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return t.width != null && Object.hasOwnProperty.call(t, "width") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(t.width), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ImageList();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.imgs && H.imgs.length || (H.imgs = []), H.imgs.push($root.Image.decode(t, t.uint32()));
          break;
        }
        case 2: {
          H.width = t.int32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.imgs != null && t.hasOwnProperty("imgs")) {
      if (!Array.isArray(t.imgs)) return "imgs: array expected";
      for (let g = 0; g < t.imgs.length; ++g) {
        let d = $root.Image.verify(t.imgs[g]);
        if (d) return "imgs." + d;
      }
    }
    return t.width != null && t.hasOwnProperty("width") && !$util.isInteger(t.width) ? "width: integer expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ImageList) return t;
    let g = new $root.ImageList();
    if (t.imgs) {
      if (!Array.isArray(t.imgs)) throw TypeError(".ImageList.imgs: array expected");
      g.imgs = [];
      for (let d = 0; d < t.imgs.length; ++d) {
        if (typeof t.imgs[d] != "object") throw TypeError(".ImageList.imgs: object expected");
        g.imgs[d] = $root.Image.fromObject(t.imgs[d]);
      }
    }
    return t.width != null && (g.width = t.width | 0), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.imgs = []), g.defaults && (d.width = 0), t.imgs && t.imgs.length) {
      d.imgs = [];
      for (let k = 0; k < t.imgs.length; ++k) d.imgs[k] = $root.Image.toObject(t.imgs[k], g);
    }
    return t.width != null && t.hasOwnProperty("width") && (d.width = t.width), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ImageList";
  }, n;
})();
$root.Json = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.body = "", n.prototype.expanded = !1, n.prototype.maxExpandDepth = null;
  let t;
  return Object.defineProperty(n.prototype, "_maxExpandDepth", { get: $util.oneOfGetter(t = ["maxExpandDepth"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.expanded != null && Object.hasOwnProperty.call(g, "expanded") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.expanded), g.maxExpandDepth != null && Object.hasOwnProperty.call(g, "maxExpandDepth") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.maxExpandDepth), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Json();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.body = g.string();
          break;
        }
        case 2: {
          AA.expanded = g.bool();
          break;
        }
        case 3: {
          AA.maxExpandDepth = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.body != null && g.hasOwnProperty("body") && !$util.isString(g.body) ? "body: string expected" : g.expanded != null && g.hasOwnProperty("expanded") && typeof g.expanded != "boolean" ? "expanded: boolean expected" : g.maxExpandDepth != null && g.hasOwnProperty("maxExpandDepth") && !$util.isInteger(g.maxExpandDepth) ? "maxExpandDepth: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Json) return g;
    let d = new $root.Json();
    return g.body != null && (d.body = String(g.body)), g.expanded != null && (d.expanded = !!g.expanded), g.maxExpandDepth != null && (d.maxExpandDepth = g.maxExpandDepth | 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.body = "", k.expanded = !1), g.body != null && g.hasOwnProperty("body") && (k.body = g.body), g.expanded != null && g.hasOwnProperty("expanded") && (k.expanded = g.expanded), g.maxExpandDepth != null && g.hasOwnProperty("maxExpandDepth") && (k.maxExpandDepth = g.maxExpandDepth, d.oneofs && (k._maxExpandDepth = "maxExpandDepth")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Json";
  }, n;
})();
$root.LinkButton = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.label = "", n.prototype.help = "", n.prototype.url = "", n.prototype.disabled = !1, n.prototype.useContainerWidth = !1, n.prototype.type = "", n.prototype.icon = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.label != null && Object.hasOwnProperty.call(t, "label") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.help), t.url != null && Object.hasOwnProperty.call(t, "url") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.url), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(t.disabled), t.useContainerWidth != null && Object.hasOwnProperty.call(t, "useContainerWidth") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.useContainerWidth), t.type != null && Object.hasOwnProperty.call(t, "type") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(t.type), t.icon != null && Object.hasOwnProperty.call(t, "icon") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(t.icon), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.LinkButton();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 2: {
          H.label = t.string();
          break;
        }
        case 4: {
          H.help = t.string();
          break;
        }
        case 6: {
          H.url = t.string();
          break;
        }
        case 7: {
          H.disabled = t.bool();
          break;
        }
        case 8: {
          H.useContainerWidth = t.bool();
          break;
        }
        case 9: {
          H.type = t.string();
          break;
        }
        case 10: {
          H.icon = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label) ? "label: string expected" : t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help) ? "help: string expected" : t.url != null && t.hasOwnProperty("url") && !$util.isString(t.url) ? "url: string expected" : t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean" ? "disabled: boolean expected" : t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && typeof t.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : t.type != null && t.hasOwnProperty("type") && !$util.isString(t.type) ? "type: string expected" : t.icon != null && t.hasOwnProperty("icon") && !$util.isString(t.icon) ? "icon: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.LinkButton) return t;
    let g = new $root.LinkButton();
    return t.label != null && (g.label = String(t.label)), t.help != null && (g.help = String(t.help)), t.url != null && (g.url = String(t.url)), t.disabled != null && (g.disabled = !!t.disabled), t.useContainerWidth != null && (g.useContainerWidth = !!t.useContainerWidth), t.type != null && (g.type = String(t.type)), t.icon != null && (g.icon = String(t.icon)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.label = "", d.help = "", d.url = "", d.disabled = !1, d.useContainerWidth = !1, d.type = "", d.icon = ""), t.label != null && t.hasOwnProperty("label") && (d.label = t.label), t.help != null && t.hasOwnProperty("help") && (d.help = t.help), t.url != null && t.hasOwnProperty("url") && (d.url = t.url), t.disabled != null && t.hasOwnProperty("disabled") && (d.disabled = t.disabled), t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && (d.useContainerWidth = t.useContainerWidth), t.type != null && t.hasOwnProperty("type") && (d.type = t.type), t.icon != null && t.hasOwnProperty("icon") && (d.icon = t.icon), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/LinkButton";
  }, n;
})();
$root.NumberInput = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.formId = "", n.prototype.format = "", n.prototype.hasMin = !1, n.prototype.hasMax = !1, n.prototype.dataType = 0, n.prototype.default = null, n.prototype.step = 0, n.prototype.min = 0, n.prototype.max = 0, n.prototype.help = "", n.prototype.value = null, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.placeholder = "", n.prototype.icon = "";
  let t;
  return Object.defineProperty(n.prototype, "_default", { get: $util.oneOfGetter(t = ["default"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_value", { get: $util.oneOfGetter(t = ["value"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.formId), g.format != null && Object.hasOwnProperty.call(g, "format") && d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.format), g.hasMin != null && Object.hasOwnProperty.call(g, "hasMin") && d.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.hasMin), g.hasMax != null && Object.hasOwnProperty.call(g, "hasMax") && d.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.hasMax), g.dataType != null && Object.hasOwnProperty.call(g, "dataType") && d.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(g.dataType), g.default != null && Object.hasOwnProperty.call(g, "default") && d.uint32(
      /* id 14, wireType 1 =*/
      113
    ).double(g.default), g.step != null && Object.hasOwnProperty.call(g, "step") && d.uint32(
      /* id 15, wireType 1 =*/
      121
    ).double(g.step), g.min != null && Object.hasOwnProperty.call(g, "min") && d.uint32(
      /* id 16, wireType 1 =*/
      129
    ).double(g.min), g.max != null && Object.hasOwnProperty.call(g, "max") && d.uint32(
      /* id 17, wireType 1 =*/
      137
    ).double(g.max), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(g.help), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 19, wireType 1 =*/
      153
    ).double(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 21, wireType 0 =*/
      168
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && d.uint32(
      /* id 23, wireType 2 =*/
      186
    ).string(g.placeholder), g.icon != null && Object.hasOwnProperty.call(g, "icon") && d.uint32(
      /* id 24, wireType 2 =*/
      194
    ).string(g.icon), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.NumberInput();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.formId = g.string();
          break;
        }
        case 8: {
          AA.format = g.string();
          break;
        }
        case 11: {
          AA.hasMin = g.bool();
          break;
        }
        case 12: {
          AA.hasMax = g.bool();
          break;
        }
        case 13: {
          AA.dataType = g.int32();
          break;
        }
        case 14: {
          AA.default = g.double();
          break;
        }
        case 15: {
          AA.step = g.double();
          break;
        }
        case 16: {
          AA.min = g.double();
          break;
        }
        case 17: {
          AA.max = g.double();
          break;
        }
        case 18: {
          AA.help = g.string();
          break;
        }
        case 19: {
          AA.value = g.double();
          break;
        }
        case 20: {
          AA.setValue = g.bool();
          break;
        }
        case 21: {
          AA.disabled = g.bool();
          break;
        }
        case 22: {
          AA.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 23: {
          AA.placeholder = g.string();
          break;
        }
        case 24: {
          AA.icon = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util.isString(g.label)) return "label: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util.isString(g.formId)) return "formId: string expected";
    if (g.format != null && g.hasOwnProperty("format") && !$util.isString(g.format)) return "format: string expected";
    if (g.hasMin != null && g.hasOwnProperty("hasMin") && typeof g.hasMin != "boolean") return "hasMin: boolean expected";
    if (g.hasMax != null && g.hasOwnProperty("hasMax") && typeof g.hasMax != "boolean") return "hasMax: boolean expected";
    if (g.dataType != null && g.hasOwnProperty("dataType")) switch (g.dataType) {
      default:
        return "dataType: enum value expected";
      case 0:
      case 1:
        break;
    }
    if (g.default != null && g.hasOwnProperty("default") && typeof g.default != "number") return "default: number expected";
    if (g.step != null && g.hasOwnProperty("step") && typeof g.step != "number") return "step: number expected";
    if (g.min != null && g.hasOwnProperty("min") && typeof g.min != "number") return "min: number expected";
    if (g.max != null && g.hasOwnProperty("max") && typeof g.max != "number") return "max: number expected";
    if (g.help != null && g.hasOwnProperty("help") && !$util.isString(g.help)) return "help: string expected";
    if (g.value != null && g.hasOwnProperty("value") && typeof g.value != "number") return "value: number expected";
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    return g.placeholder != null && g.hasOwnProperty("placeholder") && !$util.isString(g.placeholder) ? "placeholder: string expected" : g.icon != null && g.hasOwnProperty("icon") && !$util.isString(g.icon) ? "icon: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.NumberInput) return g;
    let d = new $root.NumberInput();
    switch (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.formId != null && (d.formId = String(g.formId)), g.format != null && (d.format = String(g.format)), g.hasMin != null && (d.hasMin = !!g.hasMin), g.hasMax != null && (d.hasMax = !!g.hasMax), g.dataType) {
      default:
        if (typeof g.dataType == "number") {
          d.dataType = g.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        d.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        d.dataType = 1;
        break;
    }
    if (g.default != null && (d.default = Number(g.default)), g.step != null && (d.step = Number(g.step)), g.min != null && (d.min = Number(g.min)), g.max != null && (d.max = Number(g.max)), g.help != null && (d.help = String(g.help)), g.value != null && (d.value = Number(g.value)), g.setValue != null && (d.setValue = !!g.setValue), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".NumberInput.labelVisibility: object expected");
      d.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.placeholder != null && (d.placeholder = String(g.placeholder)), g.icon != null && (d.icon = String(g.icon)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.id = "", k.label = "", k.formId = "", k.format = "", k.hasMin = !1, k.hasMax = !1, k.dataType = d.enums === String ? "INT" : 0, k.step = 0, k.min = 0, k.max = 0, k.help = "", k.setValue = !1, k.disabled = !1, k.labelVisibility = null, k.placeholder = "", k.icon = ""), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.format != null && g.hasOwnProperty("format") && (k.format = g.format), g.hasMin != null && g.hasOwnProperty("hasMin") && (k.hasMin = g.hasMin), g.hasMax != null && g.hasOwnProperty("hasMax") && (k.hasMax = g.hasMax), g.dataType != null && g.hasOwnProperty("dataType") && (k.dataType = d.enums === String ? $root.NumberInput.DataType[g.dataType] === void 0 ? g.dataType : $root.NumberInput.DataType[g.dataType] : g.dataType), g.default != null && g.hasOwnProperty("default") && (k.default = d.json && !isFinite(g.default) ? String(g.default) : g.default, d.oneofs && (k._default = "default")), g.step != null && g.hasOwnProperty("step") && (k.step = d.json && !isFinite(g.step) ? String(g.step) : g.step), g.min != null && g.hasOwnProperty("min") && (k.min = d.json && !isFinite(g.min) ? String(g.min) : g.min), g.max != null && g.hasOwnProperty("max") && (k.max = d.json && !isFinite(g.max) ? String(g.max) : g.max), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.value != null && g.hasOwnProperty("value") && (k.value = d.json && !isFinite(g.value) ? String(g.value) : g.value, d.oneofs && (k._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.placeholder != null && g.hasOwnProperty("placeholder") && (k.placeholder = g.placeholder), g.icon != null && g.hasOwnProperty("icon") && (k.icon = g.icon), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/NumberInput";
  }, n.DataType = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "INT"] = 0, d[g[1] = "FLOAT"] = 1, d;
  })(), n;
})();
$root.Markdown = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.body = "", n.prototype.allowHtml = !1, n.prototype.isCaption = !1, n.prototype.elementType = 0, n.prototype.help = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.body != null && Object.hasOwnProperty.call(t, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.body), t.allowHtml != null && Object.hasOwnProperty.call(t, "allowHtml") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(t.allowHtml), t.isCaption != null && Object.hasOwnProperty.call(t, "isCaption") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(t.isCaption), t.elementType != null && Object.hasOwnProperty.call(t, "elementType") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(t.elementType), t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.help), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Markdown();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.body = t.string();
          break;
        }
        case 2: {
          H.allowHtml = t.bool();
          break;
        }
        case 3: {
          H.isCaption = t.bool();
          break;
        }
        case 4: {
          H.elementType = t.int32();
          break;
        }
        case 5: {
          H.help = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.body != null && t.hasOwnProperty("body") && !$util.isString(t.body)) return "body: string expected";
    if (t.allowHtml != null && t.hasOwnProperty("allowHtml") && typeof t.allowHtml != "boolean") return "allowHtml: boolean expected";
    if (t.isCaption != null && t.hasOwnProperty("isCaption") && typeof t.isCaption != "boolean") return "isCaption: boolean expected";
    if (t.elementType != null && t.hasOwnProperty("elementType")) switch (t.elementType) {
      default:
        return "elementType: enum value expected";
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
    }
    return t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help) ? "help: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Markdown) return t;
    let g = new $root.Markdown();
    switch (t.body != null && (g.body = String(t.body)), t.allowHtml != null && (g.allowHtml = !!t.allowHtml), t.isCaption != null && (g.isCaption = !!t.isCaption), t.elementType) {
      default:
        if (typeof t.elementType == "number") {
          g.elementType = t.elementType;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        g.elementType = 0;
        break;
      case "NATIVE":
      case 1:
        g.elementType = 1;
        break;
      case "CAPTION":
      case 2:
        g.elementType = 2;
        break;
      case "CODE":
      case 3:
        g.elementType = 3;
        break;
      case "LATEX":
      case 4:
        g.elementType = 4;
        break;
      case "DIVIDER":
      case 5:
        g.elementType = 5;
        break;
    }
    return t.help != null && (g.help = String(t.help)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.body = "", d.allowHtml = !1, d.isCaption = !1, d.elementType = g.enums === String ? "UNSPECIFIED" : 0, d.help = ""), t.body != null && t.hasOwnProperty("body") && (d.body = t.body), t.allowHtml != null && t.hasOwnProperty("allowHtml") && (d.allowHtml = t.allowHtml), t.isCaption != null && t.hasOwnProperty("isCaption") && (d.isCaption = t.isCaption), t.elementType != null && t.hasOwnProperty("elementType") && (d.elementType = g.enums === String ? $root.Markdown.Type[t.elementType] === void 0 ? t.elementType : $root.Markdown.Type[t.elementType] : t.elementType), t.help != null && t.hasOwnProperty("help") && (d.help = t.help), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Markdown";
  }, n.Type = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "UNSPECIFIED"] = 0, g[t[1] = "NATIVE"] = 1, g[t[2] = "CAPTION"] = 2, g[t[3] = "CODE"] = 3, g[t[4] = "LATEX"] = 4, g[t[5] = "DIVIDER"] = 5, g;
  })(), n;
})();
$root.Metric = (() => {
  function n(t) {
    if (this.chartData = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.label = "", n.prototype.body = "", n.prototype.delta = "", n.prototype.direction = 0, n.prototype.color = 0, n.prototype.help = "", n.prototype.labelVisibility = null, n.prototype.showBorder = !1, n.prototype.chartData = $util.emptyArray, n.prototype.chartType = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.label != null && Object.hasOwnProperty.call(t, "label") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.label), t.body != null && Object.hasOwnProperty.call(t, "body") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.body), t.delta != null && Object.hasOwnProperty.call(t, "delta") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.delta), t.direction != null && Object.hasOwnProperty.call(t, "direction") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(t.direction), t.color != null && Object.hasOwnProperty.call(t, "color") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(t.color), t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.help), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), t.showBorder != null && Object.hasOwnProperty.call(t, "showBorder") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.showBorder), t.chartData != null && t.chartData.length) {
      g.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let d = 0; d < t.chartData.length; ++d) g.double(t.chartData[d]);
      g.ldelim();
    }
    return t.chartType != null && Object.hasOwnProperty.call(t, "chartType") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(t.chartType), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Metric();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.label = t.string();
          break;
        }
        case 2: {
          H.body = t.string();
          break;
        }
        case 3: {
          H.delta = t.string();
          break;
        }
        case 4: {
          H.direction = t.int32();
          break;
        }
        case 5: {
          H.color = t.int32();
          break;
        }
        case 6: {
          H.help = t.string();
          break;
        }
        case 7: {
          H.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 8: {
          H.showBorder = t.bool();
          break;
        }
        case 9: {
          if (H.chartData && H.chartData.length || (H.chartData = []), (AA & 7) === 2) {
            let gA = t.uint32() + t.pos;
            for (; t.pos < gA; ) H.chartData.push(t.double());
          } else H.chartData.push(t.double());
          break;
        }
        case 10: {
          H.chartType = t.int32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label)) return "label: string expected";
    if (t.body != null && t.hasOwnProperty("body") && !$util.isString(t.body)) return "body: string expected";
    if (t.delta != null && t.hasOwnProperty("delta") && !$util.isString(t.delta)) return "delta: string expected";
    if (t.direction != null && t.hasOwnProperty("direction")) switch (t.direction) {
      default:
        return "direction: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (t.color != null && t.hasOwnProperty("color")) switch (t.color) {
      default:
        return "color: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help)) return "help: string expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let g = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (g) return "labelVisibility." + g;
    }
    if (t.showBorder != null && t.hasOwnProperty("showBorder") && typeof t.showBorder != "boolean") return "showBorder: boolean expected";
    if (t.chartData != null && t.hasOwnProperty("chartData")) {
      if (!Array.isArray(t.chartData)) return "chartData: array expected";
      for (let g = 0; g < t.chartData.length; ++g) if (typeof t.chartData[g] != "number") return "chartData: number[] expected";
    }
    if (t.chartType != null && t.hasOwnProperty("chartType")) switch (t.chartType) {
      default:
        return "chartType: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Metric) return t;
    let g = new $root.Metric();
    switch (t.label != null && (g.label = String(t.label)), t.body != null && (g.body = String(t.body)), t.delta != null && (g.delta = String(t.delta)), t.direction) {
      default:
        if (typeof t.direction == "number") {
          g.direction = t.direction;
          break;
        }
        break;
      case "DOWN":
      case 0:
        g.direction = 0;
        break;
      case "UP":
      case 1:
        g.direction = 1;
        break;
      case "NONE":
      case 2:
        g.direction = 2;
        break;
    }
    switch (t.color) {
      default:
        if (typeof t.color == "number") {
          g.color = t.color;
          break;
        }
        break;
      case "RED":
      case 0:
        g.color = 0;
        break;
      case "GREEN":
      case 1:
        g.color = 1;
        break;
      case "GRAY":
      case 2:
        g.color = 2;
        break;
    }
    if (t.help != null && (g.help = String(t.help)), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object") throw TypeError(".Metric.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    if (t.showBorder != null && (g.showBorder = !!t.showBorder), t.chartData) {
      if (!Array.isArray(t.chartData)) throw TypeError(".Metric.chartData: array expected");
      g.chartData = [];
      for (let d = 0; d < t.chartData.length; ++d) g.chartData[d] = Number(t.chartData[d]);
    }
    switch (t.chartType) {
      default:
        if (typeof t.chartType == "number") {
          g.chartType = t.chartType;
          break;
        }
        break;
      case "LINE":
      case 0:
        g.chartType = 0;
        break;
      case "BAR":
      case 1:
        g.chartType = 1;
        break;
      case "AREA":
      case 2:
        g.chartType = 2;
        break;
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.chartData = []), g.defaults && (d.label = "", d.body = "", d.delta = "", d.direction = g.enums === String ? "DOWN" : 0, d.color = g.enums === String ? "RED" : 0, d.help = "", d.labelVisibility = null, d.showBorder = !1, d.chartType = g.enums === String ? "LINE" : 0), t.label != null && t.hasOwnProperty("label") && (d.label = t.label), t.body != null && t.hasOwnProperty("body") && (d.body = t.body), t.delta != null && t.hasOwnProperty("delta") && (d.delta = t.delta), t.direction != null && t.hasOwnProperty("direction") && (d.direction = g.enums === String ? $root.Metric.MetricDirection[t.direction] === void 0 ? t.direction : $root.Metric.MetricDirection[t.direction] : t.direction), t.color != null && t.hasOwnProperty("color") && (d.color = g.enums === String ? $root.Metric.MetricColor[t.color] === void 0 ? t.color : $root.Metric.MetricColor[t.color] : t.color), t.help != null && t.hasOwnProperty("help") && (d.help = t.help), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (d.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, g)), t.showBorder != null && t.hasOwnProperty("showBorder") && (d.showBorder = t.showBorder), t.chartData && t.chartData.length) {
      d.chartData = [];
      for (let k = 0; k < t.chartData.length; ++k) d.chartData[k] = g.json && !isFinite(t.chartData[k]) ? String(t.chartData[k]) : t.chartData[k];
    }
    return t.chartType != null && t.hasOwnProperty("chartType") && (d.chartType = g.enums === String ? $root.Metric.ChartType[t.chartType] === void 0 ? t.chartType : $root.Metric.ChartType[t.chartType] : t.chartType), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Metric";
  }, n.MetricDirection = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "DOWN"] = 0, g[t[1] = "UP"] = 1, g[t[2] = "NONE"] = 2, g;
  })(), n.MetricColor = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "RED"] = 0, g[t[1] = "GREEN"] = 1, g[t[2] = "GRAY"] = 2, g;
  })(), n.ChartType = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "LINE"] = 0, g[t[1] = "BAR"] = 1, g[t[2] = "AREA"] = 2, g;
  })(), n;
})();
$root.MultiSelect = (() => {
  function n(g) {
    if (this.default = [], this.options = [], this.value = [], this.rawValues = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.default = $util.emptyArray, n.prototype.options = $util.emptyArray, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = $util.emptyArray, n.prototype.rawValues = $util.emptyArray, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.maxSelections = 0, n.prototype.placeholder = "", n.prototype.acceptNewOptions = null;
  let t;
  return Object.defineProperty(n.prototype, "_acceptNewOptions", { get: $util.oneOfGetter(t = ["acceptNewOptions"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && g.default.length) {
      d.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let k = 0; k < g.default.length; ++k) d.int32(g.default[k]);
      d.ldelim();
    }
    if (g.options != null && g.options.length) for (let k = 0; k < g.options.length; ++k) d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.options[k]);
    if (g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.value != null && g.value.length) {
      d.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let k = 0; k < g.value.length; ++k) d.int32(g.value[k]);
      d.ldelim();
    }
    if (g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.maxSelections != null && Object.hasOwnProperty.call(g, "maxSelections") && d.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(g.maxSelections), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && d.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.placeholder), g.acceptNewOptions != null && Object.hasOwnProperty.call(g, "acceptNewOptions") && d.uint32(
      /* id 13, wireType 0 =*/
      104
    ).bool(g.acceptNewOptions), g.rawValues != null && g.rawValues.length) for (let k = 0; k < g.rawValues.length; ++k) d.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.rawValues[k]);
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.MultiSelect();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          if (AA.default && AA.default.length || (AA.default = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.default.push(g.int32());
          } else AA.default.push(g.int32());
          break;
        }
        case 4: {
          AA.options && AA.options.length || (AA.options = []), AA.options.push(g.string());
          break;
        }
        case 5: {
          AA.help = g.string();
          break;
        }
        case 6: {
          AA.formId = g.string();
          break;
        }
        case 7: {
          if (AA.value && AA.value.length || (AA.value = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.value.push(g.int32());
          } else AA.value.push(g.int32());
          break;
        }
        case 14: {
          AA.rawValues && AA.rawValues.length || (AA.rawValues = []), AA.rawValues.push(g.string());
          break;
        }
        case 8: {
          AA.setValue = g.bool();
          break;
        }
        case 9: {
          AA.disabled = g.bool();
          break;
        }
        case 10: {
          AA.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 11: {
          AA.maxSelections = g.int32();
          break;
        }
        case 12: {
          AA.placeholder = g.string();
          break;
        }
        case 13: {
          AA.acceptNewOptions = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util.isString(g.label)) return "label: string expected";
    if (g.default != null && g.hasOwnProperty("default")) {
      if (!Array.isArray(g.default)) return "default: array expected";
      for (let d = 0; d < g.default.length; ++d) if (!$util.isInteger(g.default[d])) return "default: integer[] expected";
    }
    if (g.options != null && g.hasOwnProperty("options")) {
      if (!Array.isArray(g.options)) return "options: array expected";
      for (let d = 0; d < g.options.length; ++d) if (!$util.isString(g.options[d])) return "options: string[] expected";
    }
    if (g.help != null && g.hasOwnProperty("help") && !$util.isString(g.help)) return "help: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util.isString(g.formId)) return "formId: string expected";
    if (g.value != null && g.hasOwnProperty("value")) {
      if (!Array.isArray(g.value)) return "value: array expected";
      for (let d = 0; d < g.value.length; ++d) if (!$util.isInteger(g.value[d])) return "value: integer[] expected";
    }
    if (g.rawValues != null && g.hasOwnProperty("rawValues")) {
      if (!Array.isArray(g.rawValues)) return "rawValues: array expected";
      for (let d = 0; d < g.rawValues.length; ++d) if (!$util.isString(g.rawValues[d])) return "rawValues: string[] expected";
    }
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    return g.maxSelections != null && g.hasOwnProperty("maxSelections") && !$util.isInteger(g.maxSelections) ? "maxSelections: integer expected" : g.placeholder != null && g.hasOwnProperty("placeholder") && !$util.isString(g.placeholder) ? "placeholder: string expected" : g.acceptNewOptions != null && g.hasOwnProperty("acceptNewOptions") && typeof g.acceptNewOptions != "boolean" ? "acceptNewOptions: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.MultiSelect) return g;
    let d = new $root.MultiSelect();
    if (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.default) {
      if (!Array.isArray(g.default)) throw TypeError(".MultiSelect.default: array expected");
      d.default = [];
      for (let k = 0; k < g.default.length; ++k) d.default[k] = g.default[k] | 0;
    }
    if (g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".MultiSelect.options: array expected");
      d.options = [];
      for (let k = 0; k < g.options.length; ++k) d.options[k] = String(g.options[k]);
    }
    if (g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.value) {
      if (!Array.isArray(g.value)) throw TypeError(".MultiSelect.value: array expected");
      d.value = [];
      for (let k = 0; k < g.value.length; ++k) d.value[k] = g.value[k] | 0;
    }
    if (g.rawValues) {
      if (!Array.isArray(g.rawValues)) throw TypeError(".MultiSelect.rawValues: array expected");
      d.rawValues = [];
      for (let k = 0; k < g.rawValues.length; ++k) d.rawValues[k] = String(g.rawValues[k]);
    }
    if (g.setValue != null && (d.setValue = !!g.setValue), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".MultiSelect.labelVisibility: object expected");
      d.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.maxSelections != null && (d.maxSelections = g.maxSelections | 0), g.placeholder != null && (d.placeholder = String(g.placeholder)), g.acceptNewOptions != null && (d.acceptNewOptions = !!g.acceptNewOptions), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.default = [], k.options = [], k.value = [], k.rawValues = []), d.defaults && (k.id = "", k.label = "", k.help = "", k.formId = "", k.setValue = !1, k.disabled = !1, k.labelVisibility = null, k.maxSelections = 0, k.placeholder = ""), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.default && g.default.length) {
      k.default = [];
      for (let H = 0; H < g.default.length; ++H) k.default[H] = g.default[H];
    }
    if (g.options && g.options.length) {
      k.options = [];
      for (let H = 0; H < g.options.length; ++H) k.options[H] = g.options[H];
    }
    if (g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.value && g.value.length) {
      k.value = [];
      for (let H = 0; H < g.value.length; ++H) k.value[H] = g.value[H];
    }
    if (g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.maxSelections != null && g.hasOwnProperty("maxSelections") && (k.maxSelections = g.maxSelections), g.placeholder != null && g.hasOwnProperty("placeholder") && (k.placeholder = g.placeholder), g.acceptNewOptions != null && g.hasOwnProperty("acceptNewOptions") && (k.acceptNewOptions = g.acceptNewOptions, d.oneofs && (k._acceptNewOptions = "acceptNewOptions")), g.rawValues && g.rawValues.length) {
      k.rawValues = [];
      for (let H = 0; H < g.rawValues.length; ++H) k.rawValues[H] = g.rawValues[H];
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/MultiSelect";
  }, n;
})();
$root.PageLink = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.page = "", n.prototype.label = "", n.prototype.icon = "", n.prototype.pageScriptHash = "", n.prototype.help = "", n.prototype.useContainerWidth = null, n.prototype.disabled = !1, n.prototype.external = !1;
  let t;
  return Object.defineProperty(n.prototype, "_useContainerWidth", { get: $util.oneOfGetter(t = ["useContainerWidth"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.page != null && Object.hasOwnProperty.call(g, "page") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.page), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.icon != null && Object.hasOwnProperty.call(g, "icon") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.icon), g.pageScriptHash != null && Object.hasOwnProperty.call(g, "pageScriptHash") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.pageScriptHash), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(g.useContainerWidth), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.disabled), g.external != null && Object.hasOwnProperty.call(g, "external") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.external), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.PageLink();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.page = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.icon = g.string();
          break;
        }
        case 4: {
          AA.pageScriptHash = g.string();
          break;
        }
        case 5: {
          AA.help = g.string();
          break;
        }
        case 6: {
          AA.useContainerWidth = g.bool();
          break;
        }
        case 7: {
          AA.disabled = g.bool();
          break;
        }
        case 8: {
          AA.external = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.page != null && g.hasOwnProperty("page") && !$util.isString(g.page) ? "page: string expected" : g.label != null && g.hasOwnProperty("label") && !$util.isString(g.label) ? "label: string expected" : g.icon != null && g.hasOwnProperty("icon") && !$util.isString(g.icon) ? "icon: string expected" : g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && !$util.isString(g.pageScriptHash) ? "pageScriptHash: string expected" : g.help != null && g.hasOwnProperty("help") && !$util.isString(g.help) ? "help: string expected" : g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && typeof g.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean" ? "disabled: boolean expected" : g.external != null && g.hasOwnProperty("external") && typeof g.external != "boolean" ? "external: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.PageLink) return g;
    let d = new $root.PageLink();
    return g.page != null && (d.page = String(g.page)), g.label != null && (d.label = String(g.label)), g.icon != null && (d.icon = String(g.icon)), g.pageScriptHash != null && (d.pageScriptHash = String(g.pageScriptHash)), g.help != null && (d.help = String(g.help)), g.useContainerWidth != null && (d.useContainerWidth = !!g.useContainerWidth), g.disabled != null && (d.disabled = !!g.disabled), g.external != null && (d.external = !!g.external), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.page = "", k.label = "", k.icon = "", k.pageScriptHash = "", k.help = "", k.disabled = !1, k.external = !1), g.page != null && g.hasOwnProperty("page") && (k.page = g.page), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.icon != null && g.hasOwnProperty("icon") && (k.icon = g.icon), g.pageScriptHash != null && g.hasOwnProperty("pageScriptHash") && (k.pageScriptHash = g.pageScriptHash), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (k.useContainerWidth = g.useContainerWidth, d.oneofs && (k._useContainerWidth = "useContainerWidth")), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.external != null && g.hasOwnProperty("external") && (k.external = g.external), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PageLink";
  }, n;
})();
$root.PlotlyChart = (() => {
  function n(g) {
    if (this.selectionMode = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.useContainerWidth = !1, n.prototype.theme = "", n.prototype.id = "", n.prototype.selectionMode = $util.emptyArray, n.prototype.formId = "", n.prototype.spec = "", n.prototype.config = "", n.prototype.url = null, n.prototype.figure = null;
  let t;
  return Object.defineProperty(n.prototype, "chart", { get: $util.oneOfGetter(t = ["url", "figure"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer.create()), g.url != null && Object.hasOwnProperty.call(g, "url") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.url), g.figure != null && Object.hasOwnProperty.call(g, "figure") && $root.Figure.encode(g.figure, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.useContainerWidth != null && Object.hasOwnProperty.call(g, "useContainerWidth") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(g.useContainerWidth), g.theme != null && Object.hasOwnProperty.call(g, "theme") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.theme), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.id), g.selectionMode != null && g.selectionMode.length) {
      d.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork();
      for (let k = 0; k < g.selectionMode.length; ++k) d.int32(g.selectionMode[k]);
      d.ldelim();
    }
    return g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(g.formId), g.spec != null && Object.hasOwnProperty.call(g, "spec") && d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.spec), g.config != null && Object.hasOwnProperty.call(g, "config") && d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.config), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.PlotlyChart();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 5: {
          AA.useContainerWidth = g.bool();
          break;
        }
        case 6: {
          AA.theme = g.string();
          break;
        }
        case 7: {
          AA.id = g.string();
          break;
        }
        case 8: {
          if (AA.selectionMode && AA.selectionMode.length || (AA.selectionMode = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.selectionMode.push(g.int32());
          } else AA.selectionMode.push(g.int32());
          break;
        }
        case 9: {
          AA.formId = g.string();
          break;
        }
        case 10: {
          AA.spec = g.string();
          break;
        }
        case 11: {
          AA.config = g.string();
          break;
        }
        case 1: {
          AA.url = g.string();
          break;
        }
        case 2: {
          AA.figure = $root.Figure.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && typeof g.useContainerWidth != "boolean") return "useContainerWidth: boolean expected";
    if (g.theme != null && g.hasOwnProperty("theme") && !$util.isString(g.theme)) return "theme: string expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.selectionMode != null && g.hasOwnProperty("selectionMode")) {
      if (!Array.isArray(g.selectionMode)) return "selectionMode: array expected";
      for (let k = 0; k < g.selectionMode.length; ++k) switch (g.selectionMode[k]) {
        default:
          return "selectionMode: enum value[] expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    }
    if (g.formId != null && g.hasOwnProperty("formId") && !$util.isString(g.formId)) return "formId: string expected";
    if (g.spec != null && g.hasOwnProperty("spec") && !$util.isString(g.spec)) return "spec: string expected";
    if (g.config != null && g.hasOwnProperty("config") && !$util.isString(g.config)) return "config: string expected";
    if (g.url != null && g.hasOwnProperty("url") && (d.chart = 1, !$util.isString(g.url))) return "url: string expected";
    if (g.figure != null && g.hasOwnProperty("figure")) {
      if (d.chart === 1) return "chart: multiple values";
      d.chart = 1;
      {
        let k = $root.Figure.verify(g.figure);
        if (k) return "figure." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.PlotlyChart) return g;
    let d = new $root.PlotlyChart();
    if (g.useContainerWidth != null && (d.useContainerWidth = !!g.useContainerWidth), g.theme != null && (d.theme = String(g.theme)), g.id != null && (d.id = String(g.id)), g.selectionMode) {
      if (!Array.isArray(g.selectionMode)) throw TypeError(".PlotlyChart.selectionMode: array expected");
      d.selectionMode = [];
      for (let k = 0; k < g.selectionMode.length; ++k) switch (g.selectionMode[k]) {
        default:
          if (typeof g.selectionMode[k] == "number") {
            d.selectionMode[k] = g.selectionMode[k];
            break;
          }
        case "POINTS":
        case 0:
          d.selectionMode[k] = 0;
          break;
        case "BOX":
        case 1:
          d.selectionMode[k] = 1;
          break;
        case "LASSO":
        case 2:
          d.selectionMode[k] = 2;
          break;
      }
    }
    if (g.formId != null && (d.formId = String(g.formId)), g.spec != null && (d.spec = String(g.spec)), g.config != null && (d.config = String(g.config)), g.url != null && (d.url = String(g.url)), g.figure != null) {
      if (typeof g.figure != "object") throw TypeError(".PlotlyChart.figure: object expected");
      d.figure = $root.Figure.fromObject(g.figure);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.selectionMode = []), d.defaults && (k.useContainerWidth = !1, k.theme = "", k.id = "", k.formId = "", k.spec = "", k.config = ""), g.url != null && g.hasOwnProperty("url") && (k.url = g.url, d.oneofs && (k.chart = "url")), g.figure != null && g.hasOwnProperty("figure") && (k.figure = $root.Figure.toObject(g.figure, d), d.oneofs && (k.chart = "figure")), g.useContainerWidth != null && g.hasOwnProperty("useContainerWidth") && (k.useContainerWidth = g.useContainerWidth), g.theme != null && g.hasOwnProperty("theme") && (k.theme = g.theme), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.selectionMode && g.selectionMode.length) {
      k.selectionMode = [];
      for (let H = 0; H < g.selectionMode.length; ++H) k.selectionMode[H] = d.enums === String ? $root.PlotlyChart.SelectionMode[g.selectionMode[H]] === void 0 ? g.selectionMode[H] : $root.PlotlyChart.SelectionMode[g.selectionMode[H]] : g.selectionMode[H];
    }
    return g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.spec != null && g.hasOwnProperty("spec") && (k.spec = g.spec), g.config != null && g.hasOwnProperty("config") && (k.config = g.config), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/PlotlyChart";
  }, n.SelectionMode = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "POINTS"] = 0, d[g[1] = "BOX"] = 1, d[g[2] = "LASSO"] = 2, d;
  })(), n;
})();
$root.Figure = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.spec = "", n.prototype.config = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.spec != null && Object.hasOwnProperty.call(t, "spec") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.spec), t.config != null && Object.hasOwnProperty.call(t, "config") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.config), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Figure();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.spec = t.string();
          break;
        }
        case 2: {
          H.config = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.spec != null && t.hasOwnProperty("spec") && !$util.isString(t.spec) ? "spec: string expected" : t.config != null && t.hasOwnProperty("config") && !$util.isString(t.config) ? "config: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Figure) return t;
    let g = new $root.Figure();
    return t.spec != null && (g.spec = String(t.spec)), t.config != null && (g.config = String(t.config)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.spec = "", d.config = ""), t.spec != null && t.hasOwnProperty("spec") && (d.spec = t.spec), t.config != null && t.hasOwnProperty("config") && (d.config = t.config), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Figure";
  }, n;
})();
$root.Progress = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.value = 0, n.prototype.text = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.value != null && Object.hasOwnProperty.call(t, "value") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(t.value), t.text != null && Object.hasOwnProperty.call(t, "text") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.text), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Progress();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.value = t.uint32();
          break;
        }
        case 2: {
          H.text = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.value != null && t.hasOwnProperty("value") && !$util.isInteger(t.value) ? "value: integer expected" : t.text != null && t.hasOwnProperty("text") && !$util.isString(t.text) ? "text: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Progress) return t;
    let g = new $root.Progress();
    return t.value != null && (g.value = t.value >>> 0), t.text != null && (g.text = String(t.text)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.value = 0, d.text = ""), t.value != null && t.hasOwnProperty("value") && (d.value = t.value), t.text != null && t.hasOwnProperty("text") && (d.text = t.text), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Progress";
  }, n;
})();
$root.Snow = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.show = !1, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.show != null && Object.hasOwnProperty.call(t, "show") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(t.show), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Snow();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.show = t.bool();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.show != null && t.hasOwnProperty("show") && typeof t.show != "boolean" ? "show: boolean expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Snow) return t;
    let g = new $root.Snow();
    return t.show != null && (g.show = !!t.show), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.show = !1), t.show != null && t.hasOwnProperty("show") && (d.show = t.show), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Snow";
  }, n;
})();
$root.Spinner = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.text = "", n.prototype.cache = !1, n.prototype.showTime = !1, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.text != null && Object.hasOwnProperty.call(t, "text") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.text), t.cache != null && Object.hasOwnProperty.call(t, "cache") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(t.cache), t.showTime != null && Object.hasOwnProperty.call(t, "showTime") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(t.showTime), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Spinner();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.text = t.string();
          break;
        }
        case 2: {
          H.cache = t.bool();
          break;
        }
        case 3: {
          H.showTime = t.bool();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.text != null && t.hasOwnProperty("text") && !$util.isString(t.text) ? "text: string expected" : t.cache != null && t.hasOwnProperty("cache") && typeof t.cache != "boolean" ? "cache: boolean expected" : t.showTime != null && t.hasOwnProperty("showTime") && typeof t.showTime != "boolean" ? "showTime: boolean expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Spinner) return t;
    let g = new $root.Spinner();
    return t.text != null && (g.text = String(t.text)), t.cache != null && (g.cache = !!t.cache), t.showTime != null && (g.showTime = !!t.showTime), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.text = "", d.cache = !1, d.showTime = !1), t.text != null && t.hasOwnProperty("text") && (d.text = t.text), t.cache != null && t.hasOwnProperty("cache") && (d.cache = t.cache), t.showTime != null && t.hasOwnProperty("showTime") && (d.showTime = t.showTime), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Spinner";
  }, n;
})();
$root.Radio = (() => {
  function n(g) {
    if (this.options = [], this.captions = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.default = null, n.prototype.options = $util.emptyArray, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = null, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.horizontal = !1, n.prototype.labelVisibility = null, n.prototype.captions = $util.emptyArray;
  let t;
  return Object.defineProperty(n.prototype, "_default", { get: $util.oneOfGetter(t = ["default"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_value", { get: $util.oneOfGetter(t = ["value"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.default), g.options != null && g.options.length) for (let k = 0; k < g.options.length; ++k) d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.options[k]);
    if (g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.horizontal != null && Object.hasOwnProperty.call(g, "horizontal") && d.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(g.horizontal), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), g.captions != null && g.captions.length) for (let k = 0; k < g.captions.length; ++k) d.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.captions[k]);
    return d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Radio();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.default = g.int32();
          break;
        }
        case 4: {
          AA.options && AA.options.length || (AA.options = []), AA.options.push(g.string());
          break;
        }
        case 5: {
          AA.help = g.string();
          break;
        }
        case 6: {
          AA.formId = g.string();
          break;
        }
        case 7: {
          AA.value = g.int32();
          break;
        }
        case 8: {
          AA.setValue = g.bool();
          break;
        }
        case 9: {
          AA.disabled = g.bool();
          break;
        }
        case 10: {
          AA.horizontal = g.bool();
          break;
        }
        case 11: {
          AA.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 12: {
          AA.captions && AA.captions.length || (AA.captions = []), AA.captions.push(g.string());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util.isString(g.label)) return "label: string expected";
    if (g.default != null && g.hasOwnProperty("default") && !$util.isInteger(g.default)) return "default: integer expected";
    if (g.options != null && g.hasOwnProperty("options")) {
      if (!Array.isArray(g.options)) return "options: array expected";
      for (let d = 0; d < g.options.length; ++d) if (!$util.isString(g.options[d])) return "options: string[] expected";
    }
    if (g.help != null && g.hasOwnProperty("help") && !$util.isString(g.help)) return "help: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util.isString(g.formId)) return "formId: string expected";
    if (g.value != null && g.hasOwnProperty("value") && !$util.isInteger(g.value)) return "value: integer expected";
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.horizontal != null && g.hasOwnProperty("horizontal") && typeof g.horizontal != "boolean") return "horizontal: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    if (g.captions != null && g.hasOwnProperty("captions")) {
      if (!Array.isArray(g.captions)) return "captions: array expected";
      for (let d = 0; d < g.captions.length; ++d) if (!$util.isString(g.captions[d])) return "captions: string[] expected";
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Radio) return g;
    let d = new $root.Radio();
    if (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.default != null && (d.default = g.default | 0), g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".Radio.options: array expected");
      d.options = [];
      for (let k = 0; k < g.options.length; ++k) d.options[k] = String(g.options[k]);
    }
    if (g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.value != null && (d.value = g.value | 0), g.setValue != null && (d.setValue = !!g.setValue), g.disabled != null && (d.disabled = !!g.disabled), g.horizontal != null && (d.horizontal = !!g.horizontal), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".Radio.labelVisibility: object expected");
      d.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    if (g.captions) {
      if (!Array.isArray(g.captions)) throw TypeError(".Radio.captions: array expected");
      d.captions = [];
      for (let k = 0; k < g.captions.length; ++k) d.captions[k] = String(g.captions[k]);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.options = [], k.captions = []), d.defaults && (k.id = "", k.label = "", k.help = "", k.formId = "", k.setValue = !1, k.disabled = !1, k.horizontal = !1, k.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.default != null && g.hasOwnProperty("default") && (k.default = g.default, d.oneofs && (k._default = "default")), g.options && g.options.length) {
      k.options = [];
      for (let H = 0; H < g.options.length; ++H) k.options[H] = g.options[H];
    }
    if (g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (k.value = g.value, d.oneofs && (k._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.horizontal != null && g.hasOwnProperty("horizontal") && (k.horizontal = g.horizontal), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.captions && g.captions.length) {
      k.captions = [];
      for (let H = 0; H < g.captions.length; ++H) k.captions[H] = g.captions[H];
    }
    return k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Radio";
  }, n;
})();
$root.Selectbox = (() => {
  function n(g) {
    if (this.options = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.default = null, n.prototype.options = $util.emptyArray, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = null, n.prototype.rawValue = null, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.placeholder = "", n.prototype.acceptNewOptions = null;
  let t;
  return Object.defineProperty(n.prototype, "_default", { get: $util.oneOfGetter(t = ["default"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_value", { get: $util.oneOfGetter(t = ["value"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_rawValue", { get: $util.oneOfGetter(t = ["rawValue"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_acceptNewOptions", { get: $util.oneOfGetter(t = ["acceptNewOptions"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.default), g.options != null && g.options.length) for (let k = 0; k < g.options.length; ++k) d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.options[k]);
    return g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.placeholder), g.acceptNewOptions != null && Object.hasOwnProperty.call(g, "acceptNewOptions") && d.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.acceptNewOptions), g.rawValue != null && Object.hasOwnProperty.call(g, "rawValue") && d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.rawValue), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Selectbox();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.default = g.int32();
          break;
        }
        case 4: {
          AA.options && AA.options.length || (AA.options = []), AA.options.push(g.string());
          break;
        }
        case 5: {
          AA.help = g.string();
          break;
        }
        case 6: {
          AA.formId = g.string();
          break;
        }
        case 7: {
          AA.value = g.int32();
          break;
        }
        case 13: {
          AA.rawValue = g.string();
          break;
        }
        case 8: {
          AA.setValue = g.bool();
          break;
        }
        case 9: {
          AA.disabled = g.bool();
          break;
        }
        case 10: {
          AA.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 11: {
          AA.placeholder = g.string();
          break;
        }
        case 12: {
          AA.acceptNewOptions = g.bool();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util.isString(g.label)) return "label: string expected";
    if (g.default != null && g.hasOwnProperty("default") && !$util.isInteger(g.default)) return "default: integer expected";
    if (g.options != null && g.hasOwnProperty("options")) {
      if (!Array.isArray(g.options)) return "options: array expected";
      for (let d = 0; d < g.options.length; ++d) if (!$util.isString(g.options[d])) return "options: string[] expected";
    }
    if (g.help != null && g.hasOwnProperty("help") && !$util.isString(g.help)) return "help: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util.isString(g.formId)) return "formId: string expected";
    if (g.value != null && g.hasOwnProperty("value") && !$util.isInteger(g.value)) return "value: integer expected";
    if (g.rawValue != null && g.hasOwnProperty("rawValue") && !$util.isString(g.rawValue)) return "rawValue: string expected";
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    return g.placeholder != null && g.hasOwnProperty("placeholder") && !$util.isString(g.placeholder) ? "placeholder: string expected" : g.acceptNewOptions != null && g.hasOwnProperty("acceptNewOptions") && typeof g.acceptNewOptions != "boolean" ? "acceptNewOptions: boolean expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Selectbox) return g;
    let d = new $root.Selectbox();
    if (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.default != null && (d.default = g.default | 0), g.options) {
      if (!Array.isArray(g.options)) throw TypeError(".Selectbox.options: array expected");
      d.options = [];
      for (let k = 0; k < g.options.length; ++k) d.options[k] = String(g.options[k]);
    }
    if (g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.value != null && (d.value = g.value | 0), g.rawValue != null && (d.rawValue = String(g.rawValue)), g.setValue != null && (d.setValue = !!g.setValue), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".Selectbox.labelVisibility: object expected");
      d.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.placeholder != null && (d.placeholder = String(g.placeholder)), g.acceptNewOptions != null && (d.acceptNewOptions = !!g.acceptNewOptions), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.options = []), d.defaults && (k.id = "", k.label = "", k.help = "", k.formId = "", k.setValue = !1, k.disabled = !1, k.labelVisibility = null, k.placeholder = ""), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.default != null && g.hasOwnProperty("default") && (k.default = g.default, d.oneofs && (k._default = "default")), g.options && g.options.length) {
      k.options = [];
      for (let H = 0; H < g.options.length; ++H) k.options[H] = g.options[H];
    }
    return g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (k.value = g.value, d.oneofs && (k._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.placeholder != null && g.hasOwnProperty("placeholder") && (k.placeholder = g.placeholder), g.acceptNewOptions != null && g.hasOwnProperty("acceptNewOptions") && (k.acceptNewOptions = g.acceptNewOptions, d.oneofs && (k._acceptNewOptions = "acceptNewOptions")), g.rawValue != null && g.hasOwnProperty("rawValue") && (k.rawValue = g.rawValue, d.oneofs && (k._rawValue = "rawValue")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Selectbox";
  }, n;
})();
$root.Skeleton = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.style = 0, n.prototype.height = null;
  let t;
  return Object.defineProperty(n.prototype, "_height", { get: $util.oneOfGetter(t = ["height"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.style != null && Object.hasOwnProperty.call(g, "style") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(g.style), g.height != null && Object.hasOwnProperty.call(g, "height") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(g.height), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Skeleton();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.style = g.int32();
          break;
        }
        case 2: {
          AA.height = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.style != null && g.hasOwnProperty("style")) switch (g.style) {
      default:
        return "style: enum value expected";
      case 0:
      case 1:
        break;
    }
    return g.height != null && g.hasOwnProperty("height") && !$util.isInteger(g.height) ? "height: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Skeleton) return g;
    let d = new $root.Skeleton();
    switch (g.style) {
      default:
        if (typeof g.style == "number") {
          d.style = g.style;
          break;
        }
        break;
      case "ELEMENT":
      case 0:
        d.style = 0;
        break;
      case "APP":
      case 1:
        d.style = 1;
        break;
    }
    return g.height != null && (d.height = g.height | 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.style = d.enums === String ? "ELEMENT" : 0), g.style != null && g.hasOwnProperty("style") && (k.style = d.enums === String ? $root.Skeleton.SkeletonStyle[g.style] === void 0 ? g.style : $root.Skeleton.SkeletonStyle[g.style] : g.style), g.height != null && g.hasOwnProperty("height") && (k.height = g.height, d.oneofs && (k._height = "height")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Skeleton";
  }, n.SkeletonStyle = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "ELEMENT"] = 0, d[g[1] = "APP"] = 1, d;
  })(), n;
})();
$root.Slider = (() => {
  function n(t) {
    if (this.default = [], this.value = [], this.options = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.id = "", n.prototype.formId = "", n.prototype.label = "", n.prototype.format = "", n.prototype.dataType = 0, n.prototype.default = $util.emptyArray, n.prototype.min = 0, n.prototype.max = 0, n.prototype.step = 0, n.prototype.value = $util.emptyArray, n.prototype.setValue = !1, n.prototype.options = $util.emptyArray, n.prototype.help = "", n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.type = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.formId != null && Object.hasOwnProperty.call(t, "formId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.formId), t.label != null && Object.hasOwnProperty.call(t, "label") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.label), t.format != null && Object.hasOwnProperty.call(t, "format") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.format), t.dataType != null && Object.hasOwnProperty.call(t, "dataType") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(t.dataType), t.default != null && t.default.length) {
      g.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork();
      for (let d = 0; d < t.default.length; ++d) g.double(t.default[d]);
      g.ldelim();
    }
    if (t.min != null && Object.hasOwnProperty.call(t, "min") && g.uint32(
      /* id 7, wireType 1 =*/
      57
    ).double(t.min), t.max != null && Object.hasOwnProperty.call(t, "max") && g.uint32(
      /* id 8, wireType 1 =*/
      65
    ).double(t.max), t.step != null && Object.hasOwnProperty.call(t, "step") && g.uint32(
      /* id 9, wireType 1 =*/
      73
    ).double(t.step), t.value != null && t.value.length) {
      g.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork();
      for (let d = 0; d < t.value.length; ++d) g.double(t.value[d]);
      g.ldelim();
    }
    if (t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(t.setValue), t.options != null && t.options.length) for (let d = 0; d < t.options.length; ++d) g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(t.options[d]);
    return t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(t.help), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && g.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, g.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), t.type != null && Object.hasOwnProperty.call(t, "type") && g.uint32(
      /* id 17, wireType 0 =*/
      136
    ).int32(t.type), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Slider();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.id = t.string();
          break;
        }
        case 2: {
          H.formId = t.string();
          break;
        }
        case 3: {
          H.label = t.string();
          break;
        }
        case 4: {
          H.format = t.string();
          break;
        }
        case 5: {
          H.dataType = t.int32();
          break;
        }
        case 6: {
          if (H.default && H.default.length || (H.default = []), (AA & 7) === 2) {
            let gA = t.uint32() + t.pos;
            for (; t.pos < gA; ) H.default.push(t.double());
          } else H.default.push(t.double());
          break;
        }
        case 7: {
          H.min = t.double();
          break;
        }
        case 8: {
          H.max = t.double();
          break;
        }
        case 9: {
          H.step = t.double();
          break;
        }
        case 10: {
          if (H.value && H.value.length || (H.value = []), (AA & 7) === 2) {
            let gA = t.uint32() + t.pos;
            for (; t.pos < gA; ) H.value.push(t.double());
          } else H.value.push(t.double());
          break;
        }
        case 11: {
          H.setValue = t.bool();
          break;
        }
        case 13: {
          H.options && H.options.length || (H.options = []), H.options.push(t.string());
          break;
        }
        case 14: {
          H.help = t.string();
          break;
        }
        case 15: {
          H.disabled = t.bool();
          break;
        }
        case 16: {
          H.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 17: {
          H.type = t.int32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id)) return "id: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId)) return "formId: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label)) return "label: string expected";
    if (t.format != null && t.hasOwnProperty("format") && !$util.isString(t.format)) return "format: string expected";
    if (t.dataType != null && t.hasOwnProperty("dataType")) switch (t.dataType) {
      default:
        return "dataType: enum value expected";
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
        break;
    }
    if (t.default != null && t.hasOwnProperty("default")) {
      if (!Array.isArray(t.default)) return "default: array expected";
      for (let g = 0; g < t.default.length; ++g) if (typeof t.default[g] != "number") return "default: number[] expected";
    }
    if (t.min != null && t.hasOwnProperty("min") && typeof t.min != "number") return "min: number expected";
    if (t.max != null && t.hasOwnProperty("max") && typeof t.max != "number") return "max: number expected";
    if (t.step != null && t.hasOwnProperty("step") && typeof t.step != "number") return "step: number expected";
    if (t.value != null && t.hasOwnProperty("value")) {
      if (!Array.isArray(t.value)) return "value: array expected";
      for (let g = 0; g < t.value.length; ++g) if (typeof t.value[g] != "number") return "value: number[] expected";
    }
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean") return "setValue: boolean expected";
    if (t.options != null && t.hasOwnProperty("options")) {
      if (!Array.isArray(t.options)) return "options: array expected";
      for (let g = 0; g < t.options.length; ++g) if (!$util.isString(t.options[g])) return "options: string[] expected";
    }
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help)) return "help: string expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean") return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let g = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (g) return "labelVisibility." + g;
    }
    if (t.type != null && t.hasOwnProperty("type")) switch (t.type) {
      default:
        return "type: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Slider) return t;
    let g = new $root.Slider();
    switch (t.id != null && (g.id = String(t.id)), t.formId != null && (g.formId = String(t.formId)), t.label != null && (g.label = String(t.label)), t.format != null && (g.format = String(t.format)), t.dataType) {
      default:
        if (typeof t.dataType == "number") {
          g.dataType = t.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        g.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        g.dataType = 1;
        break;
      case "DATETIME":
      case 2:
        g.dataType = 2;
        break;
      case "DATE":
      case 3:
        g.dataType = 3;
        break;
      case "TIME":
      case 4:
        g.dataType = 4;
        break;
    }
    if (t.default) {
      if (!Array.isArray(t.default)) throw TypeError(".Slider.default: array expected");
      g.default = [];
      for (let d = 0; d < t.default.length; ++d) g.default[d] = Number(t.default[d]);
    }
    if (t.min != null && (g.min = Number(t.min)), t.max != null && (g.max = Number(t.max)), t.step != null && (g.step = Number(t.step)), t.value) {
      if (!Array.isArray(t.value)) throw TypeError(".Slider.value: array expected");
      g.value = [];
      for (let d = 0; d < t.value.length; ++d) g.value[d] = Number(t.value[d]);
    }
    if (t.setValue != null && (g.setValue = !!t.setValue), t.options) {
      if (!Array.isArray(t.options)) throw TypeError(".Slider.options: array expected");
      g.options = [];
      for (let d = 0; d < t.options.length; ++d) g.options[d] = String(t.options[d]);
    }
    if (t.help != null && (g.help = String(t.help)), t.disabled != null && (g.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object") throw TypeError(".Slider.labelVisibility: object expected");
      g.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    switch (t.type) {
      default:
        if (typeof t.type == "number") {
          g.type = t.type;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        g.type = 0;
        break;
      case "SLIDER":
      case 1:
        g.type = 1;
        break;
      case "SELECT_SLIDER":
      case 2:
        g.type = 2;
        break;
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.default = [], d.value = [], d.options = []), g.defaults && (d.id = "", d.formId = "", d.label = "", d.format = "", d.dataType = g.enums === String ? "INT" : 0, d.min = 0, d.max = 0, d.step = 0, d.setValue = !1, d.help = "", d.disabled = !1, d.labelVisibility = null, d.type = g.enums === String ? "UNSPECIFIED" : 0), t.id != null && t.hasOwnProperty("id") && (d.id = t.id), t.formId != null && t.hasOwnProperty("formId") && (d.formId = t.formId), t.label != null && t.hasOwnProperty("label") && (d.label = t.label), t.format != null && t.hasOwnProperty("format") && (d.format = t.format), t.dataType != null && t.hasOwnProperty("dataType") && (d.dataType = g.enums === String ? $root.Slider.DataType[t.dataType] === void 0 ? t.dataType : $root.Slider.DataType[t.dataType] : t.dataType), t.default && t.default.length) {
      d.default = [];
      for (let k = 0; k < t.default.length; ++k) d.default[k] = g.json && !isFinite(t.default[k]) ? String(t.default[k]) : t.default[k];
    }
    if (t.min != null && t.hasOwnProperty("min") && (d.min = g.json && !isFinite(t.min) ? String(t.min) : t.min), t.max != null && t.hasOwnProperty("max") && (d.max = g.json && !isFinite(t.max) ? String(t.max) : t.max), t.step != null && t.hasOwnProperty("step") && (d.step = g.json && !isFinite(t.step) ? String(t.step) : t.step), t.value && t.value.length) {
      d.value = [];
      for (let k = 0; k < t.value.length; ++k) d.value[k] = g.json && !isFinite(t.value[k]) ? String(t.value[k]) : t.value[k];
    }
    if (t.setValue != null && t.hasOwnProperty("setValue") && (d.setValue = t.setValue), t.options && t.options.length) {
      d.options = [];
      for (let k = 0; k < t.options.length; ++k) d.options[k] = t.options[k];
    }
    return t.help != null && t.hasOwnProperty("help") && (d.help = t.help), t.disabled != null && t.hasOwnProperty("disabled") && (d.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (d.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, g)), t.type != null && t.hasOwnProperty("type") && (d.type = g.enums === String ? $root.Slider.Type[t.type] === void 0 ? t.type : $root.Slider.Type[t.type] : t.type), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Slider";
  }, n.DataType = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "INT"] = 0, g[t[1] = "FLOAT"] = 1, g[t[2] = "DATETIME"] = 2, g[t[3] = "DATE"] = 3, g[t[4] = "TIME"] = 4, g;
  })(), n.Type = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "UNSPECIFIED"] = 0, g[t[1] = "SLIDER"] = 1, g[t[2] = "SELECT_SLIDER"] = 2, g;
  })(), n;
})();
$root.Text = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.body = "", n.prototype.help = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.body != null && Object.hasOwnProperty.call(t, "body") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.body), t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.help), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Text();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.body = t.string();
          break;
        }
        case 2: {
          H.help = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.body != null && t.hasOwnProperty("body") && !$util.isString(t.body) ? "body: string expected" : t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help) ? "help: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Text) return t;
    let g = new $root.Text();
    return t.body != null && (g.body = String(t.body)), t.help != null && (g.help = String(t.help)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.body = "", d.help = ""), t.body != null && t.hasOwnProperty("body") && (d.body = t.body), t.help != null && t.hasOwnProperty("help") && (d.help = t.help), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Text";
  }, n;
})();
$root.TextArea = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.default = null, n.prototype.height = 0, n.prototype.maxChars = 0, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = null, n.prototype.setValue = !1, n.prototype.placeholder = "", n.prototype.disabled = !1, n.prototype.labelVisibility = null;
  let t;
  return Object.defineProperty(n.prototype, "_default", { get: $util.oneOfGetter(t = ["default"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_value", { get: $util.oneOfGetter(t = ["value"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default), g.height != null && Object.hasOwnProperty.call(g, "height") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(g.height), g.maxChars != null && Object.hasOwnProperty.call(g, "maxChars") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(g.maxChars), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.setValue), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.placeholder), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.TextArea();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.default = g.string();
          break;
        }
        case 4: {
          AA.height = g.uint32();
          break;
        }
        case 5: {
          AA.maxChars = g.uint32();
          break;
        }
        case 6: {
          AA.help = g.string();
          break;
        }
        case 7: {
          AA.formId = g.string();
          break;
        }
        case 8: {
          AA.value = g.string();
          break;
        }
        case 9: {
          AA.setValue = g.bool();
          break;
        }
        case 10: {
          AA.placeholder = g.string();
          break;
        }
        case 11: {
          AA.disabled = g.bool();
          break;
        }
        case 12: {
          AA.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util.isString(g.label)) return "label: string expected";
    if (g.default != null && g.hasOwnProperty("default") && !$util.isString(g.default)) return "default: string expected";
    if (g.height != null && g.hasOwnProperty("height") && !$util.isInteger(g.height)) return "height: integer expected";
    if (g.maxChars != null && g.hasOwnProperty("maxChars") && !$util.isInteger(g.maxChars)) return "maxChars: integer expected";
    if (g.help != null && g.hasOwnProperty("help") && !$util.isString(g.help)) return "help: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util.isString(g.formId)) return "formId: string expected";
    if (g.value != null && g.hasOwnProperty("value") && !$util.isString(g.value)) return "value: string expected";
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.placeholder != null && g.hasOwnProperty("placeholder") && !$util.isString(g.placeholder)) return "placeholder: string expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.TextArea) return g;
    let d = new $root.TextArea();
    if (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.default != null && (d.default = String(g.default)), g.height != null && (d.height = g.height >>> 0), g.maxChars != null && (d.maxChars = g.maxChars >>> 0), g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.value != null && (d.value = String(g.value)), g.setValue != null && (d.setValue = !!g.setValue), g.placeholder != null && (d.placeholder = String(g.placeholder)), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".TextArea.labelVisibility: object expected");
      d.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.id = "", k.label = "", k.height = 0, k.maxChars = 0, k.help = "", k.formId = "", k.setValue = !1, k.placeholder = "", k.disabled = !1, k.labelVisibility = null), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.default != null && g.hasOwnProperty("default") && (k.default = g.default, d.oneofs && (k._default = "default")), g.height != null && g.hasOwnProperty("height") && (k.height = g.height), g.maxChars != null && g.hasOwnProperty("maxChars") && (k.maxChars = g.maxChars), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (k.value = g.value, d.oneofs && (k._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.placeholder != null && g.hasOwnProperty("placeholder") && (k.placeholder = g.placeholder), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, d)), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TextArea";
  }, n;
})();
$root.TextInput = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.default = null, n.prototype.type = 0, n.prototype.maxChars = 0, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = null, n.prototype.setValue = !1, n.prototype.autocomplete = "", n.prototype.placeholder = "", n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.icon = "";
  let t;
  return Object.defineProperty(n.prototype, "_default", { get: $util.oneOfGetter(t = ["default"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_value", { get: $util.oneOfGetter(t = ["value"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default), g.type != null && Object.hasOwnProperty.call(g, "type") && d.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(g.type), g.maxChars != null && Object.hasOwnProperty.call(g, "maxChars") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(g.maxChars), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.setValue), g.autocomplete != null && Object.hasOwnProperty.call(g, "autocomplete") && d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(g.autocomplete), g.placeholder != null && Object.hasOwnProperty.call(g, "placeholder") && d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.placeholder), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.icon != null && Object.hasOwnProperty.call(g, "icon") && d.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.icon), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.TextInput();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.default = g.string();
          break;
        }
        case 4: {
          AA.type = g.int32();
          break;
        }
        case 5: {
          AA.maxChars = g.uint32();
          break;
        }
        case 6: {
          AA.help = g.string();
          break;
        }
        case 7: {
          AA.formId = g.string();
          break;
        }
        case 8: {
          AA.value = g.string();
          break;
        }
        case 9: {
          AA.setValue = g.bool();
          break;
        }
        case 10: {
          AA.autocomplete = g.string();
          break;
        }
        case 11: {
          AA.placeholder = g.string();
          break;
        }
        case 12: {
          AA.disabled = g.bool();
          break;
        }
        case 13: {
          AA.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 14: {
          AA.icon = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util.isString(g.label)) return "label: string expected";
    if (g.default != null && g.hasOwnProperty("default") && !$util.isString(g.default)) return "default: string expected";
    if (g.type != null && g.hasOwnProperty("type")) switch (g.type) {
      default:
        return "type: enum value expected";
      case 0:
      case 1:
        break;
    }
    if (g.maxChars != null && g.hasOwnProperty("maxChars") && !$util.isInteger(g.maxChars)) return "maxChars: integer expected";
    if (g.help != null && g.hasOwnProperty("help") && !$util.isString(g.help)) return "help: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util.isString(g.formId)) return "formId: string expected";
    if (g.value != null && g.hasOwnProperty("value") && !$util.isString(g.value)) return "value: string expected";
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.autocomplete != null && g.hasOwnProperty("autocomplete") && !$util.isString(g.autocomplete)) return "autocomplete: string expected";
    if (g.placeholder != null && g.hasOwnProperty("placeholder") && !$util.isString(g.placeholder)) return "placeholder: string expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    return g.icon != null && g.hasOwnProperty("icon") && !$util.isString(g.icon) ? "icon: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.TextInput) return g;
    let d = new $root.TextInput();
    switch (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.default != null && (d.default = String(g.default)), g.type) {
      default:
        if (typeof g.type == "number") {
          d.type = g.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        d.type = 0;
        break;
      case "PASSWORD":
      case 1:
        d.type = 1;
        break;
    }
    if (g.maxChars != null && (d.maxChars = g.maxChars >>> 0), g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.value != null && (d.value = String(g.value)), g.setValue != null && (d.setValue = !!g.setValue), g.autocomplete != null && (d.autocomplete = String(g.autocomplete)), g.placeholder != null && (d.placeholder = String(g.placeholder)), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".TextInput.labelVisibility: object expected");
      d.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.icon != null && (d.icon = String(g.icon)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.id = "", k.label = "", k.type = d.enums === String ? "DEFAULT" : 0, k.maxChars = 0, k.help = "", k.formId = "", k.setValue = !1, k.autocomplete = "", k.placeholder = "", k.disabled = !1, k.labelVisibility = null, k.icon = ""), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.default != null && g.hasOwnProperty("default") && (k.default = g.default, d.oneofs && (k._default = "default")), g.type != null && g.hasOwnProperty("type") && (k.type = d.enums === String ? $root.TextInput.Type[g.type] === void 0 ? g.type : $root.TextInput.Type[g.type] : g.type), g.maxChars != null && g.hasOwnProperty("maxChars") && (k.maxChars = g.maxChars), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (k.value = g.value, d.oneofs && (k._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.autocomplete != null && g.hasOwnProperty("autocomplete") && (k.autocomplete = g.autocomplete), g.placeholder != null && g.hasOwnProperty("placeholder") && (k.placeholder = g.placeholder), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.icon != null && g.hasOwnProperty("icon") && (k.icon = g.icon), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TextInput";
  }, n.Type = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "DEFAULT"] = 0, d[g[1] = "PASSWORD"] = 1, d;
  })(), n;
})();
$root.TimeInput = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.id = "", n.prototype.label = "", n.prototype.default = null, n.prototype.help = "", n.prototype.formId = "", n.prototype.value = null, n.prototype.setValue = !1, n.prototype.disabled = !1, n.prototype.labelVisibility = null, n.prototype.step = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0;
  let t;
  return Object.defineProperty(n.prototype, "_default", { get: $util.oneOfGetter(t = ["default"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_value", { get: $util.oneOfGetter(t = ["value"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.id), g.label != null && Object.hasOwnProperty.call(g, "label") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.label), g.default != null && Object.hasOwnProperty.call(g, "default") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.default), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.help), g.formId != null && Object.hasOwnProperty.call(g, "formId") && d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(g.formId), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.value), g.setValue != null && Object.hasOwnProperty.call(g, "setValue") && d.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(g.setValue), g.disabled != null && Object.hasOwnProperty.call(g, "disabled") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(g.disabled), g.labelVisibility != null && Object.hasOwnProperty.call(g, "labelVisibility") && $root.LabelVisibilityMessage.encode(g.labelVisibility, d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.step != null && Object.hasOwnProperty.call(g, "step") && d.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int64(g.step), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.TimeInput();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.id = g.string();
          break;
        }
        case 2: {
          AA.label = g.string();
          break;
        }
        case 3: {
          AA.default = g.string();
          break;
        }
        case 4: {
          AA.help = g.string();
          break;
        }
        case 5: {
          AA.formId = g.string();
          break;
        }
        case 6: {
          AA.value = g.string();
          break;
        }
        case 7: {
          AA.setValue = g.bool();
          break;
        }
        case 8: {
          AA.disabled = g.bool();
          break;
        }
        case 9: {
          AA.labelVisibility = $root.LabelVisibilityMessage.decode(g, g.uint32());
          break;
        }
        case 10: {
          AA.step = g.int64();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.label != null && g.hasOwnProperty("label") && !$util.isString(g.label)) return "label: string expected";
    if (g.default != null && g.hasOwnProperty("default") && !$util.isString(g.default)) return "default: string expected";
    if (g.help != null && g.hasOwnProperty("help") && !$util.isString(g.help)) return "help: string expected";
    if (g.formId != null && g.hasOwnProperty("formId") && !$util.isString(g.formId)) return "formId: string expected";
    if (g.value != null && g.hasOwnProperty("value") && !$util.isString(g.value)) return "value: string expected";
    if (g.setValue != null && g.hasOwnProperty("setValue") && typeof g.setValue != "boolean") return "setValue: boolean expected";
    if (g.disabled != null && g.hasOwnProperty("disabled") && typeof g.disabled != "boolean") return "disabled: boolean expected";
    if (g.labelVisibility != null && g.hasOwnProperty("labelVisibility")) {
      let d = $root.LabelVisibilityMessage.verify(g.labelVisibility);
      if (d) return "labelVisibility." + d;
    }
    return g.step != null && g.hasOwnProperty("step") && !$util.isInteger(g.step) && !(g.step && $util.isInteger(g.step.low) && $util.isInteger(g.step.high)) ? "step: integer|Long expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.TimeInput) return g;
    let d = new $root.TimeInput();
    if (g.id != null && (d.id = String(g.id)), g.label != null && (d.label = String(g.label)), g.default != null && (d.default = String(g.default)), g.help != null && (d.help = String(g.help)), g.formId != null && (d.formId = String(g.formId)), g.value != null && (d.value = String(g.value)), g.setValue != null && (d.setValue = !!g.setValue), g.disabled != null && (d.disabled = !!g.disabled), g.labelVisibility != null) {
      if (typeof g.labelVisibility != "object") throw TypeError(".TimeInput.labelVisibility: object expected");
      d.labelVisibility = $root.LabelVisibilityMessage.fromObject(g.labelVisibility);
    }
    return g.step != null && ($util.Long ? (d.step = $util.Long.fromValue(g.step)).unsigned = !1 : typeof g.step == "string" ? d.step = parseInt(g.step, 10) : typeof g.step == "number" ? d.step = g.step : typeof g.step == "object" && (d.step = new $util.LongBits(g.step.low >>> 0, g.step.high >>> 0).toNumber())), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if (d.defaults) if (k.id = "", k.label = "", k.help = "", k.formId = "", k.setValue = !1, k.disabled = !1, k.labelVisibility = null, $util.Long) {
      let H = new $util.Long(0, 0, !1);
      k.step = d.longs === String ? H.toString() : d.longs === Number ? H.toNumber() : H;
    } else k.step = d.longs === String ? "0" : 0;
    return g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.label != null && g.hasOwnProperty("label") && (k.label = g.label), g.default != null && g.hasOwnProperty("default") && (k.default = g.default, d.oneofs && (k._default = "default")), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.formId != null && g.hasOwnProperty("formId") && (k.formId = g.formId), g.value != null && g.hasOwnProperty("value") && (k.value = g.value, d.oneofs && (k._value = "value")), g.setValue != null && g.hasOwnProperty("setValue") && (k.setValue = g.setValue), g.disabled != null && g.hasOwnProperty("disabled") && (k.disabled = g.disabled), g.labelVisibility != null && g.hasOwnProperty("labelVisibility") && (k.labelVisibility = $root.LabelVisibilityMessage.toObject(g.labelVisibility, d)), g.step != null && g.hasOwnProperty("step") && (typeof g.step == "number" ? k.step = d.longs === String ? String(g.step) : g.step : k.step = d.longs === String ? $util.Long.prototype.toString.call(g.step) : d.longs === Number ? new $util.LongBits(g.step.low >>> 0, g.step.high >>> 0).toNumber() : g.step), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/TimeInput";
  }, n;
})();
$root.Toast = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.body = "", n.prototype.icon = "", n.prototype.duration = null;
  let t;
  return Object.defineProperty(n.prototype, "_duration", { get: $util.oneOfGetter(t = ["duration"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.body != null && Object.hasOwnProperty.call(g, "body") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.body), g.icon != null && Object.hasOwnProperty.call(g, "icon") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.icon), g.duration != null && Object.hasOwnProperty.call(g, "duration") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.duration), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Toast();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.body = g.string();
          break;
        }
        case 2: {
          AA.icon = g.string();
          break;
        }
        case 3: {
          AA.duration = g.int32();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    return typeof g != "object" || g === null ? "object expected" : g.body != null && g.hasOwnProperty("body") && !$util.isString(g.body) ? "body: string expected" : g.icon != null && g.hasOwnProperty("icon") && !$util.isString(g.icon) ? "icon: string expected" : g.duration != null && g.hasOwnProperty("duration") && !$util.isInteger(g.duration) ? "duration: integer expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Toast) return g;
    let d = new $root.Toast();
    return g.body != null && (d.body = String(g.body)), g.icon != null && (d.icon = String(g.icon)), g.duration != null && (d.duration = g.duration | 0), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.body = "", k.icon = ""), g.body != null && g.hasOwnProperty("body") && (k.body = g.body), g.icon != null && g.hasOwnProperty("icon") && (k.icon = g.icon), g.duration != null && g.hasOwnProperty("duration") && (k.duration = g.duration, d.oneofs && (k._duration = "duration")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Toast";
  }, n;
})();
$root.VegaLiteChart = (() => {
  function n(t) {
    if (this.datasets = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.spec = "", n.prototype.data = null, n.prototype.datasets = $util.emptyArray, n.prototype.useContainerWidth = !1, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.spec != null && Object.hasOwnProperty.call(t, "spec") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.spec), t.data != null && Object.hasOwnProperty.call(t, "data") && $root.DataFrame.encode(t.data, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.datasets != null && t.datasets.length) for (let d = 0; d < t.datasets.length; ++d) $root.NamedDataSet.encode(t.datasets[d], g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    return t.useContainerWidth != null && Object.hasOwnProperty.call(t, "useContainerWidth") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.useContainerWidth), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.VegaLiteChart();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.spec = t.string();
          break;
        }
        case 2: {
          H.data = $root.DataFrame.decode(t, t.uint32());
          break;
        }
        case 4: {
          H.datasets && H.datasets.length || (H.datasets = []), H.datasets.push($root.NamedDataSet.decode(t, t.uint32()));
          break;
        }
        case 5: {
          H.useContainerWidth = t.bool();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.spec != null && t.hasOwnProperty("spec") && !$util.isString(t.spec)) return "spec: string expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      let g = $root.DataFrame.verify(t.data);
      if (g) return "data." + g;
    }
    if (t.datasets != null && t.hasOwnProperty("datasets")) {
      if (!Array.isArray(t.datasets)) return "datasets: array expected";
      for (let g = 0; g < t.datasets.length; ++g) {
        let d = $root.NamedDataSet.verify(t.datasets[g]);
        if (d) return "datasets." + d;
      }
    }
    return t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && typeof t.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.VegaLiteChart) return t;
    let g = new $root.VegaLiteChart();
    if (t.spec != null && (g.spec = String(t.spec)), t.data != null) {
      if (typeof t.data != "object") throw TypeError(".VegaLiteChart.data: object expected");
      g.data = $root.DataFrame.fromObject(t.data);
    }
    if (t.datasets) {
      if (!Array.isArray(t.datasets)) throw TypeError(".VegaLiteChart.datasets: array expected");
      g.datasets = [];
      for (let d = 0; d < t.datasets.length; ++d) {
        if (typeof t.datasets[d] != "object") throw TypeError(".VegaLiteChart.datasets: object expected");
        g.datasets[d] = $root.NamedDataSet.fromObject(t.datasets[d]);
      }
    }
    return t.useContainerWidth != null && (g.useContainerWidth = !!t.useContainerWidth), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.datasets = []), g.defaults && (d.spec = "", d.data = null, d.useContainerWidth = !1), t.spec != null && t.hasOwnProperty("spec") && (d.spec = t.spec), t.data != null && t.hasOwnProperty("data") && (d.data = $root.DataFrame.toObject(t.data, g)), t.datasets && t.datasets.length) {
      d.datasets = [];
      for (let k = 0; k < t.datasets.length; ++k) d.datasets[k] = $root.NamedDataSet.toObject(t.datasets[k], g);
    }
    return t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && (d.useContainerWidth = t.useContainerWidth), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/VegaLiteChart";
  }, n;
})();
$root.NamedDataSet = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.name = "", n.prototype.hasName = !1, n.prototype.data = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.name != null && Object.hasOwnProperty.call(t, "name") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.name), t.data != null && Object.hasOwnProperty.call(t, "data") && $root.DataFrame.encode(t.data, g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.hasName != null && Object.hasOwnProperty.call(t, "hasName") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(t.hasName), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.NamedDataSet();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.name = t.string();
          break;
        }
        case 3: {
          H.hasName = t.bool();
          break;
        }
        case 2: {
          H.data = $root.DataFrame.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name)) return "name: string expected";
    if (t.hasName != null && t.hasOwnProperty("hasName") && typeof t.hasName != "boolean") return "hasName: boolean expected";
    if (t.data != null && t.hasOwnProperty("data")) {
      let g = $root.DataFrame.verify(t.data);
      if (g) return "data." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.NamedDataSet) return t;
    let g = new $root.NamedDataSet();
    if (t.name != null && (g.name = String(t.name)), t.hasName != null && (g.hasName = !!t.hasName), t.data != null) {
      if (typeof t.data != "object") throw TypeError(".NamedDataSet.data: object expected");
      g.data = $root.DataFrame.fromObject(t.data);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.name = "", d.data = null, d.hasName = !1), t.name != null && t.hasOwnProperty("name") && (d.name = t.name), t.data != null && t.hasOwnProperty("data") && (d.data = $root.DataFrame.toObject(t.data, g)), t.hasName != null && t.hasOwnProperty("hasName") && (d.hasName = t.hasName), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/NamedDataSet";
  }, n;
})();
$root.SubtitleTrack = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.label = "", n.prototype.url = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.label != null && Object.hasOwnProperty.call(t, "label") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.label), t.url != null && Object.hasOwnProperty.call(t, "url") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.url), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.SubtitleTrack();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.label = t.string();
          break;
        }
        case 2: {
          H.url = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label) ? "label: string expected" : t.url != null && t.hasOwnProperty("url") && !$util.isString(t.url) ? "url: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.SubtitleTrack) return t;
    let g = new $root.SubtitleTrack();
    return t.label != null && (g.label = String(t.label)), t.url != null && (g.url = String(t.url)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.label = "", d.url = ""), t.label != null && t.hasOwnProperty("label") && (d.label = t.label), t.url != null && t.hasOwnProperty("url") && (d.url = t.url), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/SubtitleTrack";
  }, n;
})();
$root.Video = (() => {
  function n(g) {
    if (this.subtitles = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.url = "", n.prototype.startTime = 0, n.prototype.type = 0, n.prototype.subtitles = $util.emptyArray, n.prototype.endTime = 0, n.prototype.loop = !1, n.prototype.autoplay = !1, n.prototype.muted = !1, n.prototype.id = "", n.prototype.widthConfig = null;
  let t;
  return Object.defineProperty(n.prototype, "_widthConfig", { get: $util.oneOfGetter(t = ["widthConfig"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer.create()), g.startTime != null && Object.hasOwnProperty.call(g, "startTime") && d.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(g.startTime), g.type != null && Object.hasOwnProperty.call(g, "type") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.type), g.url != null && Object.hasOwnProperty.call(g, "url") && d.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(g.url), g.subtitles != null && g.subtitles.length) for (let k = 0; k < g.subtitles.length; ++k) $root.SubtitleTrack.encode(g.subtitles[k], d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim();
    return g.endTime != null && Object.hasOwnProperty.call(g, "endTime") && d.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(g.endTime), g.loop != null && Object.hasOwnProperty.call(g, "loop") && d.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(g.loop), g.autoplay != null && Object.hasOwnProperty.call(g, "autoplay") && d.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(g.autoplay), g.muted != null && Object.hasOwnProperty.call(g, "muted") && d.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(g.muted), g.id != null && Object.hasOwnProperty.call(g, "id") && d.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.id), g.widthConfig != null && Object.hasOwnProperty.call(g, "widthConfig") && $root.streamlit.WidthConfig.encode(g.widthConfig, d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.Video();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 6: {
          AA.url = g.string();
          break;
        }
        case 3: {
          AA.startTime = g.int32();
          break;
        }
        case 5: {
          AA.type = g.int32();
          break;
        }
        case 7: {
          AA.subtitles && AA.subtitles.length || (AA.subtitles = []), AA.subtitles.push($root.SubtitleTrack.decode(g, g.uint32()));
          break;
        }
        case 8: {
          AA.endTime = g.int32();
          break;
        }
        case 9: {
          AA.loop = g.bool();
          break;
        }
        case 10: {
          AA.autoplay = g.bool();
          break;
        }
        case 11: {
          AA.muted = g.bool();
          break;
        }
        case 12: {
          AA.id = g.string();
          break;
        }
        case 13: {
          AA.widthConfig = $root.streamlit.WidthConfig.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.url != null && g.hasOwnProperty("url") && !$util.isString(g.url)) return "url: string expected";
    if (g.startTime != null && g.hasOwnProperty("startTime") && !$util.isInteger(g.startTime)) return "startTime: integer expected";
    if (g.type != null && g.hasOwnProperty("type")) switch (g.type) {
      default:
        return "type: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (g.subtitles != null && g.hasOwnProperty("subtitles")) {
      if (!Array.isArray(g.subtitles)) return "subtitles: array expected";
      for (let d = 0; d < g.subtitles.length; ++d) {
        let k = $root.SubtitleTrack.verify(g.subtitles[d]);
        if (k) return "subtitles." + k;
      }
    }
    if (g.endTime != null && g.hasOwnProperty("endTime") && !$util.isInteger(g.endTime)) return "endTime: integer expected";
    if (g.loop != null && g.hasOwnProperty("loop") && typeof g.loop != "boolean") return "loop: boolean expected";
    if (g.autoplay != null && g.hasOwnProperty("autoplay") && typeof g.autoplay != "boolean") return "autoplay: boolean expected";
    if (g.muted != null && g.hasOwnProperty("muted") && typeof g.muted != "boolean") return "muted: boolean expected";
    if (g.id != null && g.hasOwnProperty("id") && !$util.isString(g.id)) return "id: string expected";
    if (g.widthConfig != null && g.hasOwnProperty("widthConfig")) {
      let d = $root.streamlit.WidthConfig.verify(g.widthConfig);
      if (d) return "widthConfig." + d;
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.Video) return g;
    let d = new $root.Video();
    switch (g.url != null && (d.url = String(g.url)), g.startTime != null && (d.startTime = g.startTime | 0), g.type) {
      default:
        if (typeof g.type == "number") {
          d.type = g.type;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        d.type = 0;
        break;
      case "NATIVE":
      case 1:
        d.type = 1;
        break;
      case "YOUTUBE_IFRAME":
      case 2:
        d.type = 2;
        break;
    }
    if (g.subtitles) {
      if (!Array.isArray(g.subtitles)) throw TypeError(".Video.subtitles: array expected");
      d.subtitles = [];
      for (let k = 0; k < g.subtitles.length; ++k) {
        if (typeof g.subtitles[k] != "object") throw TypeError(".Video.subtitles: object expected");
        d.subtitles[k] = $root.SubtitleTrack.fromObject(g.subtitles[k]);
      }
    }
    if (g.endTime != null && (d.endTime = g.endTime | 0), g.loop != null && (d.loop = !!g.loop), g.autoplay != null && (d.autoplay = !!g.autoplay), g.muted != null && (d.muted = !!g.muted), g.id != null && (d.id = String(g.id)), g.widthConfig != null) {
      if (typeof g.widthConfig != "object") throw TypeError(".Video.widthConfig: object expected");
      d.widthConfig = $root.streamlit.WidthConfig.fromObject(g.widthConfig);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.subtitles = []), d.defaults && (k.startTime = 0, k.type = d.enums === String ? "UNUSED" : 0, k.url = "", k.endTime = 0, k.loop = !1, k.autoplay = !1, k.muted = !1, k.id = ""), g.startTime != null && g.hasOwnProperty("startTime") && (k.startTime = g.startTime), g.type != null && g.hasOwnProperty("type") && (k.type = d.enums === String ? $root.Video.Type[g.type] === void 0 ? g.type : $root.Video.Type[g.type] : g.type), g.url != null && g.hasOwnProperty("url") && (k.url = g.url), g.subtitles && g.subtitles.length) {
      k.subtitles = [];
      for (let H = 0; H < g.subtitles.length; ++H) k.subtitles[H] = $root.SubtitleTrack.toObject(g.subtitles[H], d);
    }
    return g.endTime != null && g.hasOwnProperty("endTime") && (k.endTime = g.endTime), g.loop != null && g.hasOwnProperty("loop") && (k.loop = g.loop), g.autoplay != null && g.hasOwnProperty("autoplay") && (k.autoplay = g.autoplay), g.muted != null && g.hasOwnProperty("muted") && (k.muted = g.muted), g.id != null && g.hasOwnProperty("id") && (k.id = g.id), g.widthConfig != null && g.hasOwnProperty("widthConfig") && (k.widthConfig = $root.streamlit.WidthConfig.toObject(g.widthConfig, d), d.oneofs && (k._widthConfig = "widthConfig")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/Video";
  }, n.Type = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "UNUSED"] = 0, d[g[1] = "NATIVE"] = 1, d[g[2] = "YOUTUBE_IFRAME"] = 2, d;
  })(), n;
})();
$root.Heading = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.tag = "", n.prototype.anchor = "", n.prototype.body = "", n.prototype.help = "", n.prototype.hideAnchor = !1, n.prototype.divider = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.tag != null && Object.hasOwnProperty.call(t, "tag") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.tag), t.anchor != null && Object.hasOwnProperty.call(t, "anchor") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.anchor), t.body != null && Object.hasOwnProperty.call(t, "body") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.body), t.help != null && Object.hasOwnProperty.call(t, "help") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.help), t.hideAnchor != null && Object.hasOwnProperty.call(t, "hideAnchor") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.hideAnchor), t.divider != null && Object.hasOwnProperty.call(t, "divider") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.divider), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Heading();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.tag = t.string();
          break;
        }
        case 2: {
          H.anchor = t.string();
          break;
        }
        case 3: {
          H.body = t.string();
          break;
        }
        case 4: {
          H.help = t.string();
          break;
        }
        case 5: {
          H.hideAnchor = t.bool();
          break;
        }
        case 6: {
          H.divider = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.tag != null && t.hasOwnProperty("tag") && !$util.isString(t.tag) ? "tag: string expected" : t.anchor != null && t.hasOwnProperty("anchor") && !$util.isString(t.anchor) ? "anchor: string expected" : t.body != null && t.hasOwnProperty("body") && !$util.isString(t.body) ? "body: string expected" : t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help) ? "help: string expected" : t.hideAnchor != null && t.hasOwnProperty("hideAnchor") && typeof t.hideAnchor != "boolean" ? "hideAnchor: boolean expected" : t.divider != null && t.hasOwnProperty("divider") && !$util.isString(t.divider) ? "divider: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Heading) return t;
    let g = new $root.Heading();
    return t.tag != null && (g.tag = String(t.tag)), t.anchor != null && (g.anchor = String(t.anchor)), t.body != null && (g.body = String(t.body)), t.help != null && (g.help = String(t.help)), t.hideAnchor != null && (g.hideAnchor = !!t.hideAnchor), t.divider != null && (g.divider = String(t.divider)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.tag = "", d.anchor = "", d.body = "", d.help = "", d.hideAnchor = !1, d.divider = ""), t.tag != null && t.hasOwnProperty("tag") && (d.tag = t.tag), t.anchor != null && t.hasOwnProperty("anchor") && (d.anchor = t.anchor), t.body != null && t.hasOwnProperty("body") && (d.body = t.body), t.help != null && t.hasOwnProperty("help") && (d.help = t.help), t.hideAnchor != null && t.hasOwnProperty("hideAnchor") && (d.hideAnchor = t.hideAnchor), t.divider != null && t.hasOwnProperty("divider") && (d.divider = t.divider), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Heading";
  }, n;
})();
$root.ForwardMsg = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.hash = "", n.prototype.metadata = null, n.prototype.newSession = null, n.prototype.delta = null, n.prototype.pageInfoChanged = null, n.prototype.pageConfigChanged = null, n.prototype.scriptFinished = null, n.prototype.gitInfoChanged = null, n.prototype.pageProfile = null, n.prototype.sessionStatusChanged = null, n.prototype.sessionEvent = null, n.prototype.navigation = null, n.prototype.pageNotFound = null, n.prototype.pagesChanged = null, n.prototype.fileUrlsResponse = null, n.prototype.autoRerun = null, n.prototype.logo = null, n.prototype.authRedirect = null, n.prototype.parentMessage = null, n.prototype.refHash = null, n.prototype.debugLastBackmsgId = "";
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util.oneOfGetter(t = ["newSession", "delta", "pageInfoChanged", "pageConfigChanged", "scriptFinished", "gitInfoChanged", "pageProfile", "sessionStatusChanged", "sessionEvent", "navigation", "pageNotFound", "pagesChanged", "fileUrlsResponse", "autoRerun", "logo", "authRedirect", "parentMessage", "refHash"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.hash != null && Object.hasOwnProperty.call(g, "hash") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.hash), g.metadata != null && Object.hasOwnProperty.call(g, "metadata") && $root.ForwardMsgMetadata.encode(g.metadata, d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), g.newSession != null && Object.hasOwnProperty.call(g, "newSession") && $root.NewSession.encode(g.newSession, d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), g.delta != null && Object.hasOwnProperty.call(g, "delta") && $root.Delta.encode(g.delta, d.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g.scriptFinished != null && Object.hasOwnProperty.call(g, "scriptFinished") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(g.scriptFinished), g.sessionStatusChanged != null && Object.hasOwnProperty.call(g, "sessionStatusChanged") && $root.SessionStatus.encode(g.sessionStatusChanged, d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.sessionEvent != null && Object.hasOwnProperty.call(g, "sessionEvent") && $root.SessionEvent.encode(g.sessionEvent, d.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), g.refHash != null && Object.hasOwnProperty.call(g, "refHash") && d.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(g.refHash), g.pageInfoChanged != null && Object.hasOwnProperty.call(g, "pageInfoChanged") && $root.PageInfo.encode(g.pageInfoChanged, d.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), g.pageConfigChanged != null && Object.hasOwnProperty.call(g, "pageConfigChanged") && $root.PageConfig.encode(g.pageConfigChanged, d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), g.gitInfoChanged != null && Object.hasOwnProperty.call(g, "gitInfoChanged") && $root.GitInfo.encode(g.gitInfoChanged, d.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), g.pageNotFound != null && Object.hasOwnProperty.call(g, "pageNotFound") && $root.PageNotFound.encode(g.pageNotFound, d.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), g.pagesChanged != null && Object.hasOwnProperty.call(g, "pagesChanged") && $root.PagesChanged.encode(g.pagesChanged, d.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.debugLastBackmsgId != null && Object.hasOwnProperty.call(g, "debugLastBackmsgId") && d.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(g.debugLastBackmsgId), g.pageProfile != null && Object.hasOwnProperty.call(g, "pageProfile") && $root.PageProfile.encode(g.pageProfile, d.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), g.fileUrlsResponse != null && Object.hasOwnProperty.call(g, "fileUrlsResponse") && $root.FileURLsResponse.encode(g.fileUrlsResponse, d.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), g.parentMessage != null && Object.hasOwnProperty.call(g, "parentMessage") && $root.ParentMessage.encode(g.parentMessage, d.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), g.autoRerun != null && Object.hasOwnProperty.call(g, "autoRerun") && $root.AutoRerun.encode(g.autoRerun, d.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), g.logo != null && Object.hasOwnProperty.call(g, "logo") && $root.Logo.encode(g.logo, d.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), g.navigation != null && Object.hasOwnProperty.call(g, "navigation") && $root.Navigation.encode(g.navigation, d.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), g.authRedirect != null && Object.hasOwnProperty.call(g, "authRedirect") && $root.AuthRedirect.encode(g.authRedirect, d.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.ForwardMsg();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.hash = g.string();
          break;
        }
        case 2: {
          AA.metadata = $root.ForwardMsgMetadata.decode(g, g.uint32());
          break;
        }
        case 4: {
          AA.newSession = $root.NewSession.decode(g, g.uint32());
          break;
        }
        case 5: {
          AA.delta = $root.Delta.decode(g, g.uint32());
          break;
        }
        case 12: {
          AA.pageInfoChanged = $root.PageInfo.decode(g, g.uint32());
          break;
        }
        case 13: {
          AA.pageConfigChanged = $root.PageConfig.decode(g, g.uint32());
          break;
        }
        case 6: {
          AA.scriptFinished = g.int32();
          break;
        }
        case 14: {
          AA.gitInfoChanged = $root.GitInfo.decode(g, g.uint32());
          break;
        }
        case 18: {
          AA.pageProfile = $root.PageProfile.decode(g, g.uint32());
          break;
        }
        case 9: {
          AA.sessionStatusChanged = $root.SessionStatus.decode(g, g.uint32());
          break;
        }
        case 10: {
          AA.sessionEvent = $root.SessionEvent.decode(g, g.uint32());
          break;
        }
        case 23: {
          AA.navigation = $root.Navigation.decode(g, g.uint32());
          break;
        }
        case 15: {
          AA.pageNotFound = $root.PageNotFound.decode(g, g.uint32());
          break;
        }
        case 16: {
          AA.pagesChanged = $root.PagesChanged.decode(g, g.uint32());
          break;
        }
        case 19: {
          AA.fileUrlsResponse = $root.FileURLsResponse.decode(g, g.uint32());
          break;
        }
        case 21: {
          AA.autoRerun = $root.AutoRerun.decode(g, g.uint32());
          break;
        }
        case 22: {
          AA.logo = $root.Logo.decode(g, g.uint32());
          break;
        }
        case 24: {
          AA.authRedirect = $root.AuthRedirect.decode(g, g.uint32());
          break;
        }
        case 20: {
          AA.parentMessage = $root.ParentMessage.decode(g, g.uint32());
          break;
        }
        case 11: {
          AA.refHash = g.string();
          break;
        }
        case 17: {
          AA.debugLastBackmsgId = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.hash != null && g.hasOwnProperty("hash") && !$util.isString(g.hash)) return "hash: string expected";
    if (g.metadata != null && g.hasOwnProperty("metadata")) {
      let k = $root.ForwardMsgMetadata.verify(g.metadata);
      if (k) return "metadata." + k;
    }
    if (g.newSession != null && g.hasOwnProperty("newSession")) {
      d.type = 1;
      {
        let k = $root.NewSession.verify(g.newSession);
        if (k) return "newSession." + k;
      }
    }
    if (g.delta != null && g.hasOwnProperty("delta")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Delta.verify(g.delta);
        if (k) return "delta." + k;
      }
    }
    if (g.pageInfoChanged != null && g.hasOwnProperty("pageInfoChanged")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.PageInfo.verify(g.pageInfoChanged);
        if (k) return "pageInfoChanged." + k;
      }
    }
    if (g.pageConfigChanged != null && g.hasOwnProperty("pageConfigChanged")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.PageConfig.verify(g.pageConfigChanged);
        if (k) return "pageConfigChanged." + k;
      }
    }
    if (g.scriptFinished != null && g.hasOwnProperty("scriptFinished")) {
      if (d.type === 1) return "type: multiple values";
      switch (d.type = 1, g.scriptFinished) {
        default:
          return "scriptFinished: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
          break;
      }
    }
    if (g.gitInfoChanged != null && g.hasOwnProperty("gitInfoChanged")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.GitInfo.verify(g.gitInfoChanged);
        if (k) return "gitInfoChanged." + k;
      }
    }
    if (g.pageProfile != null && g.hasOwnProperty("pageProfile")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.PageProfile.verify(g.pageProfile);
        if (k) return "pageProfile." + k;
      }
    }
    if (g.sessionStatusChanged != null && g.hasOwnProperty("sessionStatusChanged")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.SessionStatus.verify(g.sessionStatusChanged);
        if (k) return "sessionStatusChanged." + k;
      }
    }
    if (g.sessionEvent != null && g.hasOwnProperty("sessionEvent")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.SessionEvent.verify(g.sessionEvent);
        if (k) return "sessionEvent." + k;
      }
    }
    if (g.navigation != null && g.hasOwnProperty("navigation")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Navigation.verify(g.navigation);
        if (k) return "navigation." + k;
      }
    }
    if (g.pageNotFound != null && g.hasOwnProperty("pageNotFound")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.PageNotFound.verify(g.pageNotFound);
        if (k) return "pageNotFound." + k;
      }
    }
    if (g.pagesChanged != null && g.hasOwnProperty("pagesChanged")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.PagesChanged.verify(g.pagesChanged);
        if (k) return "pagesChanged." + k;
      }
    }
    if (g.fileUrlsResponse != null && g.hasOwnProperty("fileUrlsResponse")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.FileURLsResponse.verify(g.fileUrlsResponse);
        if (k) return "fileUrlsResponse." + k;
      }
    }
    if (g.autoRerun != null && g.hasOwnProperty("autoRerun")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.AutoRerun.verify(g.autoRerun);
        if (k) return "autoRerun." + k;
      }
    }
    if (g.logo != null && g.hasOwnProperty("logo")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Logo.verify(g.logo);
        if (k) return "logo." + k;
      }
    }
    if (g.authRedirect != null && g.hasOwnProperty("authRedirect")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.AuthRedirect.verify(g.authRedirect);
        if (k) return "authRedirect." + k;
      }
    }
    if (g.parentMessage != null && g.hasOwnProperty("parentMessage")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.ParentMessage.verify(g.parentMessage);
        if (k) return "parentMessage." + k;
      }
    }
    if (g.refHash != null && g.hasOwnProperty("refHash")) {
      if (d.type === 1) return "type: multiple values";
      if (d.type = 1, !$util.isString(g.refHash)) return "refHash: string expected";
    }
    return g.debugLastBackmsgId != null && g.hasOwnProperty("debugLastBackmsgId") && !$util.isString(g.debugLastBackmsgId) ? "debugLastBackmsgId: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.ForwardMsg) return g;
    let d = new $root.ForwardMsg();
    if (g.hash != null && (d.hash = String(g.hash)), g.metadata != null) {
      if (typeof g.metadata != "object") throw TypeError(".ForwardMsg.metadata: object expected");
      d.metadata = $root.ForwardMsgMetadata.fromObject(g.metadata);
    }
    if (g.newSession != null) {
      if (typeof g.newSession != "object") throw TypeError(".ForwardMsg.newSession: object expected");
      d.newSession = $root.NewSession.fromObject(g.newSession);
    }
    if (g.delta != null) {
      if (typeof g.delta != "object") throw TypeError(".ForwardMsg.delta: object expected");
      d.delta = $root.Delta.fromObject(g.delta);
    }
    if (g.pageInfoChanged != null) {
      if (typeof g.pageInfoChanged != "object") throw TypeError(".ForwardMsg.pageInfoChanged: object expected");
      d.pageInfoChanged = $root.PageInfo.fromObject(g.pageInfoChanged);
    }
    if (g.pageConfigChanged != null) {
      if (typeof g.pageConfigChanged != "object") throw TypeError(".ForwardMsg.pageConfigChanged: object expected");
      d.pageConfigChanged = $root.PageConfig.fromObject(g.pageConfigChanged);
    }
    switch (g.scriptFinished) {
      default:
        if (typeof g.scriptFinished == "number") {
          d.scriptFinished = g.scriptFinished;
          break;
        }
        break;
      case "FINISHED_SUCCESSFULLY":
      case 0:
        d.scriptFinished = 0;
        break;
      case "FINISHED_WITH_COMPILE_ERROR":
      case 1:
        d.scriptFinished = 1;
        break;
      case "FINISHED_EARLY_FOR_RERUN":
      case 2:
        d.scriptFinished = 2;
        break;
      case "FINISHED_FRAGMENT_RUN_SUCCESSFULLY":
      case 3:
        d.scriptFinished = 3;
        break;
    }
    if (g.gitInfoChanged != null) {
      if (typeof g.gitInfoChanged != "object") throw TypeError(".ForwardMsg.gitInfoChanged: object expected");
      d.gitInfoChanged = $root.GitInfo.fromObject(g.gitInfoChanged);
    }
    if (g.pageProfile != null) {
      if (typeof g.pageProfile != "object") throw TypeError(".ForwardMsg.pageProfile: object expected");
      d.pageProfile = $root.PageProfile.fromObject(g.pageProfile);
    }
    if (g.sessionStatusChanged != null) {
      if (typeof g.sessionStatusChanged != "object") throw TypeError(".ForwardMsg.sessionStatusChanged: object expected");
      d.sessionStatusChanged = $root.SessionStatus.fromObject(g.sessionStatusChanged);
    }
    if (g.sessionEvent != null) {
      if (typeof g.sessionEvent != "object") throw TypeError(".ForwardMsg.sessionEvent: object expected");
      d.sessionEvent = $root.SessionEvent.fromObject(g.sessionEvent);
    }
    if (g.navigation != null) {
      if (typeof g.navigation != "object") throw TypeError(".ForwardMsg.navigation: object expected");
      d.navigation = $root.Navigation.fromObject(g.navigation);
    }
    if (g.pageNotFound != null) {
      if (typeof g.pageNotFound != "object") throw TypeError(".ForwardMsg.pageNotFound: object expected");
      d.pageNotFound = $root.PageNotFound.fromObject(g.pageNotFound);
    }
    if (g.pagesChanged != null) {
      if (typeof g.pagesChanged != "object") throw TypeError(".ForwardMsg.pagesChanged: object expected");
      d.pagesChanged = $root.PagesChanged.fromObject(g.pagesChanged);
    }
    if (g.fileUrlsResponse != null) {
      if (typeof g.fileUrlsResponse != "object") throw TypeError(".ForwardMsg.fileUrlsResponse: object expected");
      d.fileUrlsResponse = $root.FileURLsResponse.fromObject(g.fileUrlsResponse);
    }
    if (g.autoRerun != null) {
      if (typeof g.autoRerun != "object") throw TypeError(".ForwardMsg.autoRerun: object expected");
      d.autoRerun = $root.AutoRerun.fromObject(g.autoRerun);
    }
    if (g.logo != null) {
      if (typeof g.logo != "object") throw TypeError(".ForwardMsg.logo: object expected");
      d.logo = $root.Logo.fromObject(g.logo);
    }
    if (g.authRedirect != null) {
      if (typeof g.authRedirect != "object") throw TypeError(".ForwardMsg.authRedirect: object expected");
      d.authRedirect = $root.AuthRedirect.fromObject(g.authRedirect);
    }
    if (g.parentMessage != null) {
      if (typeof g.parentMessage != "object") throw TypeError(".ForwardMsg.parentMessage: object expected");
      d.parentMessage = $root.ParentMessage.fromObject(g.parentMessage);
    }
    return g.refHash != null && (d.refHash = String(g.refHash)), g.debugLastBackmsgId != null && (d.debugLastBackmsgId = String(g.debugLastBackmsgId)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return d.defaults && (k.hash = "", k.metadata = null, k.debugLastBackmsgId = ""), g.hash != null && g.hasOwnProperty("hash") && (k.hash = g.hash), g.metadata != null && g.hasOwnProperty("metadata") && (k.metadata = $root.ForwardMsgMetadata.toObject(g.metadata, d)), g.newSession != null && g.hasOwnProperty("newSession") && (k.newSession = $root.NewSession.toObject(g.newSession, d), d.oneofs && (k.type = "newSession")), g.delta != null && g.hasOwnProperty("delta") && (k.delta = $root.Delta.toObject(g.delta, d), d.oneofs && (k.type = "delta")), g.scriptFinished != null && g.hasOwnProperty("scriptFinished") && (k.scriptFinished = d.enums === String ? $root.ForwardMsg.ScriptFinishedStatus[g.scriptFinished] === void 0 ? g.scriptFinished : $root.ForwardMsg.ScriptFinishedStatus[g.scriptFinished] : g.scriptFinished, d.oneofs && (k.type = "scriptFinished")), g.sessionStatusChanged != null && g.hasOwnProperty("sessionStatusChanged") && (k.sessionStatusChanged = $root.SessionStatus.toObject(g.sessionStatusChanged, d), d.oneofs && (k.type = "sessionStatusChanged")), g.sessionEvent != null && g.hasOwnProperty("sessionEvent") && (k.sessionEvent = $root.SessionEvent.toObject(g.sessionEvent, d), d.oneofs && (k.type = "sessionEvent")), g.refHash != null && g.hasOwnProperty("refHash") && (k.refHash = g.refHash, d.oneofs && (k.type = "refHash")), g.pageInfoChanged != null && g.hasOwnProperty("pageInfoChanged") && (k.pageInfoChanged = $root.PageInfo.toObject(g.pageInfoChanged, d), d.oneofs && (k.type = "pageInfoChanged")), g.pageConfigChanged != null && g.hasOwnProperty("pageConfigChanged") && (k.pageConfigChanged = $root.PageConfig.toObject(g.pageConfigChanged, d), d.oneofs && (k.type = "pageConfigChanged")), g.gitInfoChanged != null && g.hasOwnProperty("gitInfoChanged") && (k.gitInfoChanged = $root.GitInfo.toObject(g.gitInfoChanged, d), d.oneofs && (k.type = "gitInfoChanged")), g.pageNotFound != null && g.hasOwnProperty("pageNotFound") && (k.pageNotFound = $root.PageNotFound.toObject(g.pageNotFound, d), d.oneofs && (k.type = "pageNotFound")), g.pagesChanged != null && g.hasOwnProperty("pagesChanged") && (k.pagesChanged = $root.PagesChanged.toObject(g.pagesChanged, d), d.oneofs && (k.type = "pagesChanged")), g.debugLastBackmsgId != null && g.hasOwnProperty("debugLastBackmsgId") && (k.debugLastBackmsgId = g.debugLastBackmsgId), g.pageProfile != null && g.hasOwnProperty("pageProfile") && (k.pageProfile = $root.PageProfile.toObject(g.pageProfile, d), d.oneofs && (k.type = "pageProfile")), g.fileUrlsResponse != null && g.hasOwnProperty("fileUrlsResponse") && (k.fileUrlsResponse = $root.FileURLsResponse.toObject(g.fileUrlsResponse, d), d.oneofs && (k.type = "fileUrlsResponse")), g.parentMessage != null && g.hasOwnProperty("parentMessage") && (k.parentMessage = $root.ParentMessage.toObject(g.parentMessage, d), d.oneofs && (k.type = "parentMessage")), g.autoRerun != null && g.hasOwnProperty("autoRerun") && (k.autoRerun = $root.AutoRerun.toObject(g.autoRerun, d), d.oneofs && (k.type = "autoRerun")), g.logo != null && g.hasOwnProperty("logo") && (k.logo = $root.Logo.toObject(g.logo, d), d.oneofs && (k.type = "logo")), g.navigation != null && g.hasOwnProperty("navigation") && (k.navigation = $root.Navigation.toObject(g.navigation, d), d.oneofs && (k.type = "navigation")), g.authRedirect != null && g.hasOwnProperty("authRedirect") && (k.authRedirect = $root.AuthRedirect.toObject(g.authRedirect, d), d.oneofs && (k.type = "authRedirect")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/ForwardMsg";
  }, n.ScriptFinishedStatus = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "FINISHED_SUCCESSFULLY"] = 0, d[g[1] = "FINISHED_WITH_COMPILE_ERROR"] = 1, d[g[2] = "FINISHED_EARLY_FOR_RERUN"] = 2, d[g[3] = "FINISHED_FRAGMENT_RUN_SUCCESSFULLY"] = 3, d;
  })(), n;
})();
$root.ForwardMsgMetadata = (() => {
  function n(t) {
    if (this.deltaPath = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.cacheable = !1, n.prototype.deltaPath = $util.emptyArray, n.prototype.elementDimensionSpec = null, n.prototype.activeScriptHash = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.cacheable != null && Object.hasOwnProperty.call(t, "cacheable") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(t.cacheable), t.deltaPath != null && t.deltaPath.length) {
      g.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork();
      for (let d = 0; d < t.deltaPath.length; ++d) g.uint32(t.deltaPath[d]);
      g.ldelim();
    }
    return t.elementDimensionSpec != null && Object.hasOwnProperty.call(t, "elementDimensionSpec") && $root.ElementDimensionSpec.encode(t.elementDimensionSpec, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), t.activeScriptHash != null && Object.hasOwnProperty.call(t, "activeScriptHash") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.activeScriptHash), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ForwardMsgMetadata();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.cacheable = t.bool();
          break;
        }
        case 2: {
          if (H.deltaPath && H.deltaPath.length || (H.deltaPath = []), (AA & 7) === 2) {
            let gA = t.uint32() + t.pos;
            for (; t.pos < gA; ) H.deltaPath.push(t.uint32());
          } else H.deltaPath.push(t.uint32());
          break;
        }
        case 3: {
          H.elementDimensionSpec = $root.ElementDimensionSpec.decode(t, t.uint32());
          break;
        }
        case 4: {
          H.activeScriptHash = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.cacheable != null && t.hasOwnProperty("cacheable") && typeof t.cacheable != "boolean") return "cacheable: boolean expected";
    if (t.deltaPath != null && t.hasOwnProperty("deltaPath")) {
      if (!Array.isArray(t.deltaPath)) return "deltaPath: array expected";
      for (let g = 0; g < t.deltaPath.length; ++g) if (!$util.isInteger(t.deltaPath[g])) return "deltaPath: integer[] expected";
    }
    if (t.elementDimensionSpec != null && t.hasOwnProperty("elementDimensionSpec")) {
      let g = $root.ElementDimensionSpec.verify(t.elementDimensionSpec);
      if (g) return "elementDimensionSpec." + g;
    }
    return t.activeScriptHash != null && t.hasOwnProperty("activeScriptHash") && !$util.isString(t.activeScriptHash) ? "activeScriptHash: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ForwardMsgMetadata) return t;
    let g = new $root.ForwardMsgMetadata();
    if (t.cacheable != null && (g.cacheable = !!t.cacheable), t.deltaPath) {
      if (!Array.isArray(t.deltaPath)) throw TypeError(".ForwardMsgMetadata.deltaPath: array expected");
      g.deltaPath = [];
      for (let d = 0; d < t.deltaPath.length; ++d) g.deltaPath[d] = t.deltaPath[d] >>> 0;
    }
    if (t.elementDimensionSpec != null) {
      if (typeof t.elementDimensionSpec != "object") throw TypeError(".ForwardMsgMetadata.elementDimensionSpec: object expected");
      g.elementDimensionSpec = $root.ElementDimensionSpec.fromObject(t.elementDimensionSpec);
    }
    return t.activeScriptHash != null && (g.activeScriptHash = String(t.activeScriptHash)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.deltaPath = []), g.defaults && (d.cacheable = !1, d.elementDimensionSpec = null, d.activeScriptHash = ""), t.cacheable != null && t.hasOwnProperty("cacheable") && (d.cacheable = t.cacheable), t.deltaPath && t.deltaPath.length) {
      d.deltaPath = [];
      for (let k = 0; k < t.deltaPath.length; ++k) d.deltaPath[k] = t.deltaPath[k];
    }
    return t.elementDimensionSpec != null && t.hasOwnProperty("elementDimensionSpec") && (d.elementDimensionSpec = $root.ElementDimensionSpec.toObject(t.elementDimensionSpec, g)), t.activeScriptHash != null && t.hasOwnProperty("activeScriptHash") && (d.activeScriptHash = t.activeScriptHash), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ForwardMsgMetadata";
  }, n;
})();
$root.ElementDimensionSpec = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.width = 0, n.prototype.height = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.width != null && Object.hasOwnProperty.call(t, "width") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(t.width), t.height != null && Object.hasOwnProperty.call(t, "height") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(t.height), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ElementDimensionSpec();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.width = t.uint32();
          break;
        }
        case 2: {
          H.height = t.uint32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.width != null && t.hasOwnProperty("width") && !$util.isInteger(t.width) ? "width: integer expected" : t.height != null && t.hasOwnProperty("height") && !$util.isInteger(t.height) ? "height: integer expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ElementDimensionSpec) return t;
    let g = new $root.ElementDimensionSpec();
    return t.width != null && (g.width = t.width >>> 0), t.height != null && (g.height = t.height >>> 0), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.width = 0, d.height = 0), t.width != null && t.hasOwnProperty("width") && (d.width = t.width), t.height != null && t.hasOwnProperty("height") && (d.height = t.height), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ElementDimensionSpec";
  }, n;
})();
$root.ForwardMsgList = (() => {
  function n(t) {
    if (this.messages = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.messages = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.messages != null && t.messages.length) for (let d = 0; d < t.messages.length; ++d) $root.ForwardMsg.encode(t.messages[d], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ForwardMsgList();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.messages && H.messages.length || (H.messages = []), H.messages.push($root.ForwardMsg.decode(t, t.uint32()));
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.messages != null && t.hasOwnProperty("messages")) {
      if (!Array.isArray(t.messages)) return "messages: array expected";
      for (let g = 0; g < t.messages.length; ++g) {
        let d = $root.ForwardMsg.verify(t.messages[g]);
        if (d) return "messages." + d;
      }
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ForwardMsgList) return t;
    let g = new $root.ForwardMsgList();
    if (t.messages) {
      if (!Array.isArray(t.messages)) throw TypeError(".ForwardMsgList.messages: array expected");
      g.messages = [];
      for (let d = 0; d < t.messages.length; ++d) {
        if (typeof t.messages[d] != "object") throw TypeError(".ForwardMsgList.messages: object expected");
        g.messages[d] = $root.ForwardMsg.fromObject(t.messages[d]);
      }
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.messages = []), t.messages && t.messages.length) {
      d.messages = [];
      for (let k = 0; k < t.messages.length; ++k) d.messages[k] = $root.ForwardMsg.toObject(t.messages[k], g);
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ForwardMsgList";
  }, n;
})();
$root.GitInfo = (() => {
  function n(t) {
    if (this.untrackedFiles = [], this.uncommittedFiles = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.repository = "", n.prototype.branch = "", n.prototype.module = "", n.prototype.untrackedFiles = $util.emptyArray, n.prototype.uncommittedFiles = $util.emptyArray, n.prototype.state = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.repository != null && Object.hasOwnProperty.call(t, "repository") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.repository), t.branch != null && Object.hasOwnProperty.call(t, "branch") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.branch), t.module != null && Object.hasOwnProperty.call(t, "module") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.module), t.untrackedFiles != null && t.untrackedFiles.length) for (let d = 0; d < t.untrackedFiles.length; ++d) g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.untrackedFiles[d]);
    if (t.uncommittedFiles != null && t.uncommittedFiles.length) for (let d = 0; d < t.uncommittedFiles.length; ++d) g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.uncommittedFiles[d]);
    return t.state != null && Object.hasOwnProperty.call(t, "state") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(t.state), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.GitInfo();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.repository = t.string();
          break;
        }
        case 2: {
          H.branch = t.string();
          break;
        }
        case 3: {
          H.module = t.string();
          break;
        }
        case 4: {
          H.untrackedFiles && H.untrackedFiles.length || (H.untrackedFiles = []), H.untrackedFiles.push(t.string());
          break;
        }
        case 5: {
          H.uncommittedFiles && H.uncommittedFiles.length || (H.uncommittedFiles = []), H.uncommittedFiles.push(t.string());
          break;
        }
        case 6: {
          H.state = t.int32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.repository != null && t.hasOwnProperty("repository") && !$util.isString(t.repository)) return "repository: string expected";
    if (t.branch != null && t.hasOwnProperty("branch") && !$util.isString(t.branch)) return "branch: string expected";
    if (t.module != null && t.hasOwnProperty("module") && !$util.isString(t.module)) return "module: string expected";
    if (t.untrackedFiles != null && t.hasOwnProperty("untrackedFiles")) {
      if (!Array.isArray(t.untrackedFiles)) return "untrackedFiles: array expected";
      for (let g = 0; g < t.untrackedFiles.length; ++g) if (!$util.isString(t.untrackedFiles[g])) return "untrackedFiles: string[] expected";
    }
    if (t.uncommittedFiles != null && t.hasOwnProperty("uncommittedFiles")) {
      if (!Array.isArray(t.uncommittedFiles)) return "uncommittedFiles: array expected";
      for (let g = 0; g < t.uncommittedFiles.length; ++g) if (!$util.isString(t.uncommittedFiles[g])) return "uncommittedFiles: string[] expected";
    }
    if (t.state != null && t.hasOwnProperty("state")) switch (t.state) {
      default:
        return "state: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.GitInfo) return t;
    let g = new $root.GitInfo();
    if (t.repository != null && (g.repository = String(t.repository)), t.branch != null && (g.branch = String(t.branch)), t.module != null && (g.module = String(t.module)), t.untrackedFiles) {
      if (!Array.isArray(t.untrackedFiles)) throw TypeError(".GitInfo.untrackedFiles: array expected");
      g.untrackedFiles = [];
      for (let d = 0; d < t.untrackedFiles.length; ++d) g.untrackedFiles[d] = String(t.untrackedFiles[d]);
    }
    if (t.uncommittedFiles) {
      if (!Array.isArray(t.uncommittedFiles)) throw TypeError(".GitInfo.uncommittedFiles: array expected");
      g.uncommittedFiles = [];
      for (let d = 0; d < t.uncommittedFiles.length; ++d) g.uncommittedFiles[d] = String(t.uncommittedFiles[d]);
    }
    switch (t.state) {
      default:
        if (typeof t.state == "number") {
          g.state = t.state;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        g.state = 0;
        break;
      case "HEAD_DETACHED":
      case 1:
        g.state = 1;
        break;
      case "AHEAD_OF_REMOTE":
      case 2:
        g.state = 2;
        break;
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.untrackedFiles = [], d.uncommittedFiles = []), g.defaults && (d.repository = "", d.branch = "", d.module = "", d.state = g.enums === String ? "DEFAULT" : 0), t.repository != null && t.hasOwnProperty("repository") && (d.repository = t.repository), t.branch != null && t.hasOwnProperty("branch") && (d.branch = t.branch), t.module != null && t.hasOwnProperty("module") && (d.module = t.module), t.untrackedFiles && t.untrackedFiles.length) {
      d.untrackedFiles = [];
      for (let k = 0; k < t.untrackedFiles.length; ++k) d.untrackedFiles[k] = t.untrackedFiles[k];
    }
    if (t.uncommittedFiles && t.uncommittedFiles.length) {
      d.uncommittedFiles = [];
      for (let k = 0; k < t.uncommittedFiles.length; ++k) d.uncommittedFiles[k] = t.uncommittedFiles[k];
    }
    return t.state != null && t.hasOwnProperty("state") && (d.state = g.enums === String ? $root.GitInfo.GitStates[t.state] === void 0 ? t.state : $root.GitInfo.GitStates[t.state] : t.state), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/GitInfo";
  }, n.GitStates = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "DEFAULT"] = 0, g[t[1] = "HEAD_DETACHED"] = 1, g[t[2] = "AHEAD_OF_REMOTE"] = 2, g;
  })(), n;
})();
$root.Logo = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.image = "", n.prototype.link = "", n.prototype.iconImage = "", n.prototype.size = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.image != null && Object.hasOwnProperty.call(t, "image") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.image), t.link != null && Object.hasOwnProperty.call(t, "link") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.link), t.iconImage != null && Object.hasOwnProperty.call(t, "iconImage") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.iconImage), t.size != null && Object.hasOwnProperty.call(t, "size") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.size), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Logo();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.image = t.string();
          break;
        }
        case 2: {
          H.link = t.string();
          break;
        }
        case 3: {
          H.iconImage = t.string();
          break;
        }
        case 4: {
          H.size = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.image != null && t.hasOwnProperty("image") && !$util.isString(t.image) ? "image: string expected" : t.link != null && t.hasOwnProperty("link") && !$util.isString(t.link) ? "link: string expected" : t.iconImage != null && t.hasOwnProperty("iconImage") && !$util.isString(t.iconImage) ? "iconImage: string expected" : t.size != null && t.hasOwnProperty("size") && !$util.isString(t.size) ? "size: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Logo) return t;
    let g = new $root.Logo();
    return t.image != null && (g.image = String(t.image)), t.link != null && (g.link = String(t.link)), t.iconImage != null && (g.iconImage = String(t.iconImage)), t.size != null && (g.size = String(t.size)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.image = "", d.link = "", d.iconImage = "", d.size = ""), t.image != null && t.hasOwnProperty("image") && (d.image = t.image), t.link != null && t.hasOwnProperty("link") && (d.link = t.link), t.iconImage != null && t.hasOwnProperty("iconImage") && (d.iconImage = t.iconImage), t.size != null && t.hasOwnProperty("size") && (d.size = t.size), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Logo";
  }, n;
})();
$root.Navigation = (() => {
  function n(t) {
    if (this.sections = [], this.appPages = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.sections = $util.emptyArray, n.prototype.appPages = $util.emptyArray, n.prototype.position = 0, n.prototype.pageScriptHash = "", n.prototype.expanded = !1, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.sections != null && t.sections.length) for (let d = 0; d < t.sections.length; ++d) g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.sections[d]);
    if (t.appPages != null && t.appPages.length) for (let d = 0; d < t.appPages.length; ++d) $root.AppPage.encode(t.appPages[d], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return t.position != null && Object.hasOwnProperty.call(t, "position") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(t.position), t.pageScriptHash != null && Object.hasOwnProperty.call(t, "pageScriptHash") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.pageScriptHash), t.expanded != null && Object.hasOwnProperty.call(t, "expanded") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.expanded), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Navigation();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.sections && H.sections.length || (H.sections = []), H.sections.push(t.string());
          break;
        }
        case 2: {
          H.appPages && H.appPages.length || (H.appPages = []), H.appPages.push($root.AppPage.decode(t, t.uint32()));
          break;
        }
        case 3: {
          H.position = t.int32();
          break;
        }
        case 4: {
          H.pageScriptHash = t.string();
          break;
        }
        case 5: {
          H.expanded = t.bool();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.sections != null && t.hasOwnProperty("sections")) {
      if (!Array.isArray(t.sections)) return "sections: array expected";
      for (let g = 0; g < t.sections.length; ++g) if (!$util.isString(t.sections[g])) return "sections: string[] expected";
    }
    if (t.appPages != null && t.hasOwnProperty("appPages")) {
      if (!Array.isArray(t.appPages)) return "appPages: array expected";
      for (let g = 0; g < t.appPages.length; ++g) {
        let d = $root.AppPage.verify(t.appPages[g]);
        if (d) return "appPages." + d;
      }
    }
    if (t.position != null && t.hasOwnProperty("position")) switch (t.position) {
      default:
        return "position: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    return t.pageScriptHash != null && t.hasOwnProperty("pageScriptHash") && !$util.isString(t.pageScriptHash) ? "pageScriptHash: string expected" : t.expanded != null && t.hasOwnProperty("expanded") && typeof t.expanded != "boolean" ? "expanded: boolean expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Navigation) return t;
    let g = new $root.Navigation();
    if (t.sections) {
      if (!Array.isArray(t.sections)) throw TypeError(".Navigation.sections: array expected");
      g.sections = [];
      for (let d = 0; d < t.sections.length; ++d) g.sections[d] = String(t.sections[d]);
    }
    if (t.appPages) {
      if (!Array.isArray(t.appPages)) throw TypeError(".Navigation.appPages: array expected");
      g.appPages = [];
      for (let d = 0; d < t.appPages.length; ++d) {
        if (typeof t.appPages[d] != "object") throw TypeError(".Navigation.appPages: object expected");
        g.appPages[d] = $root.AppPage.fromObject(t.appPages[d]);
      }
    }
    switch (t.position) {
      default:
        if (typeof t.position == "number") {
          g.position = t.position;
          break;
        }
        break;
      case "HIDDEN":
      case 0:
        g.position = 0;
        break;
      case "SIDEBAR":
      case 1:
        g.position = 1;
        break;
      case "TOP":
      case 2:
        g.position = 2;
        break;
    }
    return t.pageScriptHash != null && (g.pageScriptHash = String(t.pageScriptHash)), t.expanded != null && (g.expanded = !!t.expanded), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.sections = [], d.appPages = []), g.defaults && (d.position = g.enums === String ? "HIDDEN" : 0, d.pageScriptHash = "", d.expanded = !1), t.sections && t.sections.length) {
      d.sections = [];
      for (let k = 0; k < t.sections.length; ++k) d.sections[k] = t.sections[k];
    }
    if (t.appPages && t.appPages.length) {
      d.appPages = [];
      for (let k = 0; k < t.appPages.length; ++k) d.appPages[k] = $root.AppPage.toObject(t.appPages[k], g);
    }
    return t.position != null && t.hasOwnProperty("position") && (d.position = g.enums === String ? $root.Navigation.Position[t.position] === void 0 ? t.position : $root.Navigation.Position[t.position] : t.position), t.pageScriptHash != null && t.hasOwnProperty("pageScriptHash") && (d.pageScriptHash = t.pageScriptHash), t.expanded != null && t.hasOwnProperty("expanded") && (d.expanded = t.expanded), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Navigation";
  }, n.Position = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "HIDDEN"] = 0, g[t[1] = "SIDEBAR"] = 1, g[t[2] = "TOP"] = 2, g;
  })(), n;
})();
$root.NewSession = (() => {
  function n(t) {
    if (this.appPages = [], this.fragmentIdsThisRun = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.initialize = null, n.prototype.scriptRunId = "", n.prototype.name = "", n.prototype.mainScriptPath = "", n.prototype.config = null, n.prototype.customTheme = null, n.prototype.appPages = $util.emptyArray, n.prototype.pageScriptHash = "", n.prototype.fragmentIdsThisRun = $util.emptyArray, n.prototype.mainScriptHash = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.initialize != null && Object.hasOwnProperty.call(t, "initialize") && $root.Initialize.encode(t.initialize, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t.scriptRunId != null && Object.hasOwnProperty.call(t, "scriptRunId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.scriptRunId), t.name != null && Object.hasOwnProperty.call(t, "name") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.name), t.mainScriptPath != null && Object.hasOwnProperty.call(t, "mainScriptPath") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.mainScriptPath), t.config != null && Object.hasOwnProperty.call(t, "config") && $root.Config.encode(t.config, g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), t.customTheme != null && Object.hasOwnProperty.call(t, "customTheme") && $root.CustomThemeConfig.encode(t.customTheme, g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), t.appPages != null && t.appPages.length) for (let d = 0; d < t.appPages.length; ++d) $root.AppPage.encode(t.appPages[d], g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    if (t.pageScriptHash != null && Object.hasOwnProperty.call(t, "pageScriptHash") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(t.pageScriptHash), t.fragmentIdsThisRun != null && t.fragmentIdsThisRun.length) for (let d = 0; d < t.fragmentIdsThisRun.length; ++d) g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(t.fragmentIdsThisRun[d]);
    return t.mainScriptHash != null && Object.hasOwnProperty.call(t, "mainScriptHash") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(t.mainScriptHash), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.NewSession();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.initialize = $root.Initialize.decode(t, t.uint32());
          break;
        }
        case 2: {
          H.scriptRunId = t.string();
          break;
        }
        case 3: {
          H.name = t.string();
          break;
        }
        case 4: {
          H.mainScriptPath = t.string();
          break;
        }
        case 6: {
          H.config = $root.Config.decode(t, t.uint32());
          break;
        }
        case 7: {
          H.customTheme = $root.CustomThemeConfig.decode(t, t.uint32());
          break;
        }
        case 8: {
          H.appPages && H.appPages.length || (H.appPages = []), H.appPages.push($root.AppPage.decode(t, t.uint32()));
          break;
        }
        case 9: {
          H.pageScriptHash = t.string();
          break;
        }
        case 10: {
          H.fragmentIdsThisRun && H.fragmentIdsThisRun.length || (H.fragmentIdsThisRun = []), H.fragmentIdsThisRun.push(t.string());
          break;
        }
        case 11: {
          H.mainScriptHash = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.initialize != null && t.hasOwnProperty("initialize")) {
      let g = $root.Initialize.verify(t.initialize);
      if (g) return "initialize." + g;
    }
    if (t.scriptRunId != null && t.hasOwnProperty("scriptRunId") && !$util.isString(t.scriptRunId)) return "scriptRunId: string expected";
    if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name)) return "name: string expected";
    if (t.mainScriptPath != null && t.hasOwnProperty("mainScriptPath") && !$util.isString(t.mainScriptPath)) return "mainScriptPath: string expected";
    if (t.config != null && t.hasOwnProperty("config")) {
      let g = $root.Config.verify(t.config);
      if (g) return "config." + g;
    }
    if (t.customTheme != null && t.hasOwnProperty("customTheme")) {
      let g = $root.CustomThemeConfig.verify(t.customTheme);
      if (g) return "customTheme." + g;
    }
    if (t.appPages != null && t.hasOwnProperty("appPages")) {
      if (!Array.isArray(t.appPages)) return "appPages: array expected";
      for (let g = 0; g < t.appPages.length; ++g) {
        let d = $root.AppPage.verify(t.appPages[g]);
        if (d) return "appPages." + d;
      }
    }
    if (t.pageScriptHash != null && t.hasOwnProperty("pageScriptHash") && !$util.isString(t.pageScriptHash)) return "pageScriptHash: string expected";
    if (t.fragmentIdsThisRun != null && t.hasOwnProperty("fragmentIdsThisRun")) {
      if (!Array.isArray(t.fragmentIdsThisRun)) return "fragmentIdsThisRun: array expected";
      for (let g = 0; g < t.fragmentIdsThisRun.length; ++g) if (!$util.isString(t.fragmentIdsThisRun[g])) return "fragmentIdsThisRun: string[] expected";
    }
    return t.mainScriptHash != null && t.hasOwnProperty("mainScriptHash") && !$util.isString(t.mainScriptHash) ? "mainScriptHash: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.NewSession) return t;
    let g = new $root.NewSession();
    if (t.initialize != null) {
      if (typeof t.initialize != "object") throw TypeError(".NewSession.initialize: object expected");
      g.initialize = $root.Initialize.fromObject(t.initialize);
    }
    if (t.scriptRunId != null && (g.scriptRunId = String(t.scriptRunId)), t.name != null && (g.name = String(t.name)), t.mainScriptPath != null && (g.mainScriptPath = String(t.mainScriptPath)), t.config != null) {
      if (typeof t.config != "object") throw TypeError(".NewSession.config: object expected");
      g.config = $root.Config.fromObject(t.config);
    }
    if (t.customTheme != null) {
      if (typeof t.customTheme != "object") throw TypeError(".NewSession.customTheme: object expected");
      g.customTheme = $root.CustomThemeConfig.fromObject(t.customTheme);
    }
    if (t.appPages) {
      if (!Array.isArray(t.appPages)) throw TypeError(".NewSession.appPages: array expected");
      g.appPages = [];
      for (let d = 0; d < t.appPages.length; ++d) {
        if (typeof t.appPages[d] != "object") throw TypeError(".NewSession.appPages: object expected");
        g.appPages[d] = $root.AppPage.fromObject(t.appPages[d]);
      }
    }
    if (t.pageScriptHash != null && (g.pageScriptHash = String(t.pageScriptHash)), t.fragmentIdsThisRun) {
      if (!Array.isArray(t.fragmentIdsThisRun)) throw TypeError(".NewSession.fragmentIdsThisRun: array expected");
      g.fragmentIdsThisRun = [];
      for (let d = 0; d < t.fragmentIdsThisRun.length; ++d) g.fragmentIdsThisRun[d] = String(t.fragmentIdsThisRun[d]);
    }
    return t.mainScriptHash != null && (g.mainScriptHash = String(t.mainScriptHash)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.appPages = [], d.fragmentIdsThisRun = []), g.defaults && (d.initialize = null, d.scriptRunId = "", d.name = "", d.mainScriptPath = "", d.config = null, d.customTheme = null, d.pageScriptHash = "", d.mainScriptHash = ""), t.initialize != null && t.hasOwnProperty("initialize") && (d.initialize = $root.Initialize.toObject(t.initialize, g)), t.scriptRunId != null && t.hasOwnProperty("scriptRunId") && (d.scriptRunId = t.scriptRunId), t.name != null && t.hasOwnProperty("name") && (d.name = t.name), t.mainScriptPath != null && t.hasOwnProperty("mainScriptPath") && (d.mainScriptPath = t.mainScriptPath), t.config != null && t.hasOwnProperty("config") && (d.config = $root.Config.toObject(t.config, g)), t.customTheme != null && t.hasOwnProperty("customTheme") && (d.customTheme = $root.CustomThemeConfig.toObject(t.customTheme, g)), t.appPages && t.appPages.length) {
      d.appPages = [];
      for (let k = 0; k < t.appPages.length; ++k) d.appPages[k] = $root.AppPage.toObject(t.appPages[k], g);
    }
    if (t.pageScriptHash != null && t.hasOwnProperty("pageScriptHash") && (d.pageScriptHash = t.pageScriptHash), t.fragmentIdsThisRun && t.fragmentIdsThisRun.length) {
      d.fragmentIdsThisRun = [];
      for (let k = 0; k < t.fragmentIdsThisRun.length; ++k) d.fragmentIdsThisRun[k] = t.fragmentIdsThisRun[k];
    }
    return t.mainScriptHash != null && t.hasOwnProperty("mainScriptHash") && (d.mainScriptHash = t.mainScriptHash), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/NewSession";
  }, n;
})();
$root.Initialize = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.userInfo = null, n.prototype.environmentInfo = null, n.prototype.sessionStatus = null, n.prototype.commandLine = "", n.prototype.sessionId = "", n.prototype.isHello = !1, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.userInfo != null && Object.hasOwnProperty.call(t, "userInfo") && $root.UserInfo.encode(t.userInfo, g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t.environmentInfo != null && Object.hasOwnProperty.call(t, "environmentInfo") && $root.EnvironmentInfo.encode(t.environmentInfo, g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), t.sessionStatus != null && Object.hasOwnProperty.call(t, "sessionStatus") && $root.SessionStatus.encode(t.sessionStatus, g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), t.commandLine != null && Object.hasOwnProperty.call(t, "commandLine") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.commandLine), t.sessionId != null && Object.hasOwnProperty.call(t, "sessionId") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.sessionId), t.isHello != null && Object.hasOwnProperty.call(t, "isHello") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(t.isHello), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Initialize();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.userInfo = $root.UserInfo.decode(t, t.uint32());
          break;
        }
        case 3: {
          H.environmentInfo = $root.EnvironmentInfo.decode(t, t.uint32());
          break;
        }
        case 4: {
          H.sessionStatus = $root.SessionStatus.decode(t, t.uint32());
          break;
        }
        case 5: {
          H.commandLine = t.string();
          break;
        }
        case 6: {
          H.sessionId = t.string();
          break;
        }
        case 7: {
          H.isHello = t.bool();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.userInfo != null && t.hasOwnProperty("userInfo")) {
      let g = $root.UserInfo.verify(t.userInfo);
      if (g) return "userInfo." + g;
    }
    if (t.environmentInfo != null && t.hasOwnProperty("environmentInfo")) {
      let g = $root.EnvironmentInfo.verify(t.environmentInfo);
      if (g) return "environmentInfo." + g;
    }
    if (t.sessionStatus != null && t.hasOwnProperty("sessionStatus")) {
      let g = $root.SessionStatus.verify(t.sessionStatus);
      if (g) return "sessionStatus." + g;
    }
    return t.commandLine != null && t.hasOwnProperty("commandLine") && !$util.isString(t.commandLine) ? "commandLine: string expected" : t.sessionId != null && t.hasOwnProperty("sessionId") && !$util.isString(t.sessionId) ? "sessionId: string expected" : t.isHello != null && t.hasOwnProperty("isHello") && typeof t.isHello != "boolean" ? "isHello: boolean expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Initialize) return t;
    let g = new $root.Initialize();
    if (t.userInfo != null) {
      if (typeof t.userInfo != "object") throw TypeError(".Initialize.userInfo: object expected");
      g.userInfo = $root.UserInfo.fromObject(t.userInfo);
    }
    if (t.environmentInfo != null) {
      if (typeof t.environmentInfo != "object") throw TypeError(".Initialize.environmentInfo: object expected");
      g.environmentInfo = $root.EnvironmentInfo.fromObject(t.environmentInfo);
    }
    if (t.sessionStatus != null) {
      if (typeof t.sessionStatus != "object") throw TypeError(".Initialize.sessionStatus: object expected");
      g.sessionStatus = $root.SessionStatus.fromObject(t.sessionStatus);
    }
    return t.commandLine != null && (g.commandLine = String(t.commandLine)), t.sessionId != null && (g.sessionId = String(t.sessionId)), t.isHello != null && (g.isHello = !!t.isHello), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.userInfo = null, d.environmentInfo = null, d.sessionStatus = null, d.commandLine = "", d.sessionId = "", d.isHello = !1), t.userInfo != null && t.hasOwnProperty("userInfo") && (d.userInfo = $root.UserInfo.toObject(t.userInfo, g)), t.environmentInfo != null && t.hasOwnProperty("environmentInfo") && (d.environmentInfo = $root.EnvironmentInfo.toObject(t.environmentInfo, g)), t.sessionStatus != null && t.hasOwnProperty("sessionStatus") && (d.sessionStatus = $root.SessionStatus.toObject(t.sessionStatus, g)), t.commandLine != null && t.hasOwnProperty("commandLine") && (d.commandLine = t.commandLine), t.sessionId != null && t.hasOwnProperty("sessionId") && (d.sessionId = t.sessionId), t.isHello != null && t.hasOwnProperty("isHello") && (d.isHello = t.isHello), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Initialize";
  }, n;
})();
$root.Config = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.gatherUsageStats = !1, n.prototype.maxCachedMessageAge = 0, n.prototype.mapboxToken = "", n.prototype.allowRunOnSave = !1, n.prototype.hideTopBar = !1, n.prototype.hideSidebarNav = !1, n.prototype.toolbarMode = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.gatherUsageStats != null && Object.hasOwnProperty.call(t, "gatherUsageStats") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(t.gatherUsageStats), t.maxCachedMessageAge != null && Object.hasOwnProperty.call(t, "maxCachedMessageAge") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(t.maxCachedMessageAge), t.mapboxToken != null && Object.hasOwnProperty.call(t, "mapboxToken") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.mapboxToken), t.allowRunOnSave != null && Object.hasOwnProperty.call(t, "allowRunOnSave") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.allowRunOnSave), t.hideTopBar != null && Object.hasOwnProperty.call(t, "hideTopBar") && g.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(t.hideTopBar), t.hideSidebarNav != null && Object.hasOwnProperty.call(t, "hideSidebarNav") && g.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(t.hideSidebarNav), t.toolbarMode != null && Object.hasOwnProperty.call(t, "toolbarMode") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(t.toolbarMode), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Config();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 2: {
          H.gatherUsageStats = t.bool();
          break;
        }
        case 3: {
          H.maxCachedMessageAge = t.int32();
          break;
        }
        case 4: {
          H.mapboxToken = t.string();
          break;
        }
        case 5: {
          H.allowRunOnSave = t.bool();
          break;
        }
        case 6: {
          H.hideTopBar = t.bool();
          break;
        }
        case 7: {
          H.hideSidebarNav = t.bool();
          break;
        }
        case 8: {
          H.toolbarMode = t.int32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.gatherUsageStats != null && t.hasOwnProperty("gatherUsageStats") && typeof t.gatherUsageStats != "boolean") return "gatherUsageStats: boolean expected";
    if (t.maxCachedMessageAge != null && t.hasOwnProperty("maxCachedMessageAge") && !$util.isInteger(t.maxCachedMessageAge)) return "maxCachedMessageAge: integer expected";
    if (t.mapboxToken != null && t.hasOwnProperty("mapboxToken") && !$util.isString(t.mapboxToken)) return "mapboxToken: string expected";
    if (t.allowRunOnSave != null && t.hasOwnProperty("allowRunOnSave") && typeof t.allowRunOnSave != "boolean") return "allowRunOnSave: boolean expected";
    if (t.hideTopBar != null && t.hasOwnProperty("hideTopBar") && typeof t.hideTopBar != "boolean") return "hideTopBar: boolean expected";
    if (t.hideSidebarNav != null && t.hasOwnProperty("hideSidebarNav") && typeof t.hideSidebarNav != "boolean") return "hideSidebarNav: boolean expected";
    if (t.toolbarMode != null && t.hasOwnProperty("toolbarMode")) switch (t.toolbarMode) {
      default:
        return "toolbarMode: enum value expected";
      case 0:
      case 1:
      case 2:
      case 3:
        break;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Config) return t;
    let g = new $root.Config();
    switch (t.gatherUsageStats != null && (g.gatherUsageStats = !!t.gatherUsageStats), t.maxCachedMessageAge != null && (g.maxCachedMessageAge = t.maxCachedMessageAge | 0), t.mapboxToken != null && (g.mapboxToken = String(t.mapboxToken)), t.allowRunOnSave != null && (g.allowRunOnSave = !!t.allowRunOnSave), t.hideTopBar != null && (g.hideTopBar = !!t.hideTopBar), t.hideSidebarNav != null && (g.hideSidebarNav = !!t.hideSidebarNav), t.toolbarMode) {
      default:
        if (typeof t.toolbarMode == "number") {
          g.toolbarMode = t.toolbarMode;
          break;
        }
        break;
      case "AUTO":
      case 0:
        g.toolbarMode = 0;
        break;
      case "DEVELOPER":
      case 1:
        g.toolbarMode = 1;
        break;
      case "VIEWER":
      case 2:
        g.toolbarMode = 2;
        break;
      case "MINIMAL":
      case 3:
        g.toolbarMode = 3;
        break;
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.gatherUsageStats = !1, d.maxCachedMessageAge = 0, d.mapboxToken = "", d.allowRunOnSave = !1, d.hideTopBar = !1, d.hideSidebarNav = !1, d.toolbarMode = g.enums === String ? "AUTO" : 0), t.gatherUsageStats != null && t.hasOwnProperty("gatherUsageStats") && (d.gatherUsageStats = t.gatherUsageStats), t.maxCachedMessageAge != null && t.hasOwnProperty("maxCachedMessageAge") && (d.maxCachedMessageAge = t.maxCachedMessageAge), t.mapboxToken != null && t.hasOwnProperty("mapboxToken") && (d.mapboxToken = t.mapboxToken), t.allowRunOnSave != null && t.hasOwnProperty("allowRunOnSave") && (d.allowRunOnSave = t.allowRunOnSave), t.hideTopBar != null && t.hasOwnProperty("hideTopBar") && (d.hideTopBar = t.hideTopBar), t.hideSidebarNav != null && t.hasOwnProperty("hideSidebarNav") && (d.hideSidebarNav = t.hideSidebarNav), t.toolbarMode != null && t.hasOwnProperty("toolbarMode") && (d.toolbarMode = g.enums === String ? $root.Config.ToolbarMode[t.toolbarMode] === void 0 ? t.toolbarMode : $root.Config.ToolbarMode[t.toolbarMode] : t.toolbarMode), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Config";
  }, n.ToolbarMode = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "AUTO"] = 0, g[t[1] = "DEVELOPER"] = 1, g[t[2] = "VIEWER"] = 2, g[t[3] = "MINIMAL"] = 3, g;
  })(), n;
})();
$root.CustomThemeConfig = (() => {
  function n(g) {
    if (this.fontFaces = [], this.fontSources = [], this.headingFontSizes = [], this.headingFontWeights = [], this.chartCategoricalColors = [], this.chartSequentialColors = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.primaryColor = "", n.prototype.secondaryBackgroundColor = "", n.prototype.backgroundColor = "", n.prototype.textColor = "", n.prototype.font = 0, n.prototype.base = 0, n.prototype.widgetBackgroundColor = "", n.prototype.widgetBorderColor = "", n.prototype.radii = null, n.prototype.headingFont = "", n.prototype.bodyFont = "", n.prototype.codeFont = "", n.prototype.fontFaces = $util.emptyArray, n.prototype.fontSources = $util.emptyArray, n.prototype.fontSizes = null, n.prototype.skeletonBackgroundColor = "", n.prototype.baseRadius = null, n.prototype.buttonRadius = null, n.prototype.borderColor = null, n.prototype.dataframeBorderColor = null, n.prototype.showWidgetBorder = null, n.prototype.linkColor = null, n.prototype.linkUnderline = null, n.prototype.baseFontSize = null, n.prototype.baseFontWeight = null, n.prototype.codeFontWeight = null, n.prototype.codeFontSize = null, n.prototype.headingFontSizes = $util.emptyArray, n.prototype.headingFontWeights = $util.emptyArray, n.prototype.showSidebarBorder = null, n.prototype.sidebar = null, n.prototype.codeBackgroundColor = null, n.prototype.dataframeHeaderBackgroundColor = null, n.prototype.chartCategoricalColors = $util.emptyArray, n.prototype.chartSequentialColors = $util.emptyArray, n.prototype.redColor = null, n.prototype.orangeColor = null, n.prototype.yellowColor = null, n.prototype.blueColor = null, n.prototype.greenColor = null, n.prototype.violetColor = null, n.prototype.grayColor = null, n.prototype.redBackgroundColor = null, n.prototype.orangeBackgroundColor = null, n.prototype.yellowBackgroundColor = null, n.prototype.blueBackgroundColor = null, n.prototype.greenBackgroundColor = null, n.prototype.violetBackgroundColor = null, n.prototype.grayBackgroundColor = null, n.prototype.redTextColor = null, n.prototype.orangeTextColor = null, n.prototype.yellowTextColor = null, n.prototype.blueTextColor = null, n.prototype.greenTextColor = null, n.prototype.violetTextColor = null, n.prototype.grayTextColor = null;
  let t;
  return Object.defineProperty(n.prototype, "_baseRadius", { get: $util.oneOfGetter(t = ["baseRadius"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_buttonRadius", { get: $util.oneOfGetter(t = ["buttonRadius"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_borderColor", { get: $util.oneOfGetter(t = ["borderColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_dataframeBorderColor", { get: $util.oneOfGetter(t = ["dataframeBorderColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_showWidgetBorder", { get: $util.oneOfGetter(t = ["showWidgetBorder"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_linkColor", { get: $util.oneOfGetter(t = ["linkColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_linkUnderline", { get: $util.oneOfGetter(t = ["linkUnderline"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_baseFontSize", { get: $util.oneOfGetter(t = ["baseFontSize"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_baseFontWeight", { get: $util.oneOfGetter(t = ["baseFontWeight"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_codeFontWeight", { get: $util.oneOfGetter(t = ["codeFontWeight"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_codeFontSize", { get: $util.oneOfGetter(t = ["codeFontSize"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_showSidebarBorder", { get: $util.oneOfGetter(t = ["showSidebarBorder"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_sidebar", { get: $util.oneOfGetter(t = ["sidebar"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_codeBackgroundColor", { get: $util.oneOfGetter(t = ["codeBackgroundColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_dataframeHeaderBackgroundColor", { get: $util.oneOfGetter(t = ["dataframeHeaderBackgroundColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_redColor", { get: $util.oneOfGetter(t = ["redColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_orangeColor", { get: $util.oneOfGetter(t = ["orangeColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_yellowColor", { get: $util.oneOfGetter(t = ["yellowColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_blueColor", { get: $util.oneOfGetter(t = ["blueColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_greenColor", { get: $util.oneOfGetter(t = ["greenColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_violetColor", { get: $util.oneOfGetter(t = ["violetColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_grayColor", { get: $util.oneOfGetter(t = ["grayColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_redBackgroundColor", { get: $util.oneOfGetter(t = ["redBackgroundColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_orangeBackgroundColor", { get: $util.oneOfGetter(t = ["orangeBackgroundColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_yellowBackgroundColor", { get: $util.oneOfGetter(t = ["yellowBackgroundColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_blueBackgroundColor", { get: $util.oneOfGetter(t = ["blueBackgroundColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_greenBackgroundColor", { get: $util.oneOfGetter(t = ["greenBackgroundColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_violetBackgroundColor", { get: $util.oneOfGetter(t = ["violetBackgroundColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_grayBackgroundColor", { get: $util.oneOfGetter(t = ["grayBackgroundColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_redTextColor", { get: $util.oneOfGetter(t = ["redTextColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_orangeTextColor", { get: $util.oneOfGetter(t = ["orangeTextColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_yellowTextColor", { get: $util.oneOfGetter(t = ["yellowTextColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_blueTextColor", { get: $util.oneOfGetter(t = ["blueTextColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_greenTextColor", { get: $util.oneOfGetter(t = ["greenTextColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_violetTextColor", { get: $util.oneOfGetter(t = ["violetTextColor"]), set: $util.oneOfSetter(t) }), Object.defineProperty(n.prototype, "_grayTextColor", { get: $util.oneOfGetter(t = ["grayTextColor"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    if (d || (d = $Writer.create()), g.primaryColor != null && Object.hasOwnProperty.call(g, "primaryColor") && d.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(g.primaryColor), g.secondaryBackgroundColor != null && Object.hasOwnProperty.call(g, "secondaryBackgroundColor") && d.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(g.secondaryBackgroundColor), g.backgroundColor != null && Object.hasOwnProperty.call(g, "backgroundColor") && d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(g.backgroundColor), g.textColor != null && Object.hasOwnProperty.call(g, "textColor") && d.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(g.textColor), g.font != null && Object.hasOwnProperty.call(g, "font") && d.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(g.font), g.base != null && Object.hasOwnProperty.call(g, "base") && d.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(g.base), g.widgetBackgroundColor != null && Object.hasOwnProperty.call(g, "widgetBackgroundColor") && d.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(g.widgetBackgroundColor), g.widgetBorderColor != null && Object.hasOwnProperty.call(g, "widgetBorderColor") && d.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(g.widgetBorderColor), g.radii != null && Object.hasOwnProperty.call(g, "radii") && $root.Radii.encode(g.radii, d.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), g.headingFont != null && Object.hasOwnProperty.call(g, "headingFont") && d.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(g.headingFont), g.bodyFont != null && Object.hasOwnProperty.call(g, "bodyFont") && d.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(g.bodyFont), g.codeFont != null && Object.hasOwnProperty.call(g, "codeFont") && d.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(g.codeFont), g.fontFaces != null && g.fontFaces.length) for (let k = 0; k < g.fontFaces.length; ++k) $root.FontFace.encode(g.fontFaces[k], d.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim();
    if (g.fontSizes != null && Object.hasOwnProperty.call(g, "fontSizes") && $root.FontSizes.encode(g.fontSizes, d.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), g.skeletonBackgroundColor != null && Object.hasOwnProperty.call(g, "skeletonBackgroundColor") && d.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(g.skeletonBackgroundColor), g.baseRadius != null && Object.hasOwnProperty.call(g, "baseRadius") && d.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(g.baseRadius), g.borderColor != null && Object.hasOwnProperty.call(g, "borderColor") && d.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(g.borderColor), g.showWidgetBorder != null && Object.hasOwnProperty.call(g, "showWidgetBorder") && d.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(g.showWidgetBorder), g.linkColor != null && Object.hasOwnProperty.call(g, "linkColor") && d.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(g.linkColor), g.baseFontSize != null && Object.hasOwnProperty.call(g, "baseFontSize") && d.uint32(
      /* id 22, wireType 0 =*/
      176
    ).int32(g.baseFontSize), g.showSidebarBorder != null && Object.hasOwnProperty.call(g, "showSidebarBorder") && d.uint32(
      /* id 23, wireType 0 =*/
      184
    ).bool(g.showSidebarBorder), g.sidebar != null && Object.hasOwnProperty.call(g, "sidebar") && $root.CustomThemeConfig.encode(g.sidebar, d.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), g.codeBackgroundColor != null && Object.hasOwnProperty.call(g, "codeBackgroundColor") && d.uint32(
      /* id 25, wireType 2 =*/
      202
    ).string(g.codeBackgroundColor), g.buttonRadius != null && Object.hasOwnProperty.call(g, "buttonRadius") && d.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(g.buttonRadius), g.dataframeBorderColor != null && Object.hasOwnProperty.call(g, "dataframeBorderColor") && d.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(g.dataframeBorderColor), g.codeFontSize != null && Object.hasOwnProperty.call(g, "codeFontSize") && d.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(g.codeFontSize), g.linkUnderline != null && Object.hasOwnProperty.call(g, "linkUnderline") && d.uint32(
      /* id 29, wireType 0 =*/
      232
    ).bool(g.linkUnderline), g.baseFontWeight != null && Object.hasOwnProperty.call(g, "baseFontWeight") && d.uint32(
      /* id 30, wireType 0 =*/
      240
    ).int32(g.baseFontWeight), g.dataframeHeaderBackgroundColor != null && Object.hasOwnProperty.call(g, "dataframeHeaderBackgroundColor") && d.uint32(
      /* id 31, wireType 2 =*/
      250
    ).string(g.dataframeHeaderBackgroundColor), g.codeFontWeight != null && Object.hasOwnProperty.call(g, "codeFontWeight") && d.uint32(
      /* id 32, wireType 0 =*/
      256
    ).int32(g.codeFontWeight), g.chartCategoricalColors != null && g.chartCategoricalColors.length) for (let k = 0; k < g.chartCategoricalColors.length; ++k) d.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(g.chartCategoricalColors[k]);
    if (g.headingFontWeights != null && g.headingFontWeights.length) {
      d.uint32(
        /* id 34, wireType 2 =*/
        274
      ).fork();
      for (let k = 0; k < g.headingFontWeights.length; ++k) d.int32(g.headingFontWeights[k]);
      d.ldelim();
    }
    if (g.headingFontSizes != null && g.headingFontSizes.length) for (let k = 0; k < g.headingFontSizes.length; ++k) d.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(g.headingFontSizes[k]);
    if (g.chartSequentialColors != null && g.chartSequentialColors.length) for (let k = 0; k < g.chartSequentialColors.length; ++k) d.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(g.chartSequentialColors[k]);
    if (g.fontSources != null && g.fontSources.length) for (let k = 0; k < g.fontSources.length; ++k) $root.FontSource.encode(g.fontSources[k], d.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim();
    return g.redColor != null && Object.hasOwnProperty.call(g, "redColor") && d.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(g.redColor), g.orangeColor != null && Object.hasOwnProperty.call(g, "orangeColor") && d.uint32(
      /* id 39, wireType 2 =*/
      314
    ).string(g.orangeColor), g.yellowColor != null && Object.hasOwnProperty.call(g, "yellowColor") && d.uint32(
      /* id 40, wireType 2 =*/
      322
    ).string(g.yellowColor), g.blueColor != null && Object.hasOwnProperty.call(g, "blueColor") && d.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(g.blueColor), g.greenColor != null && Object.hasOwnProperty.call(g, "greenColor") && d.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(g.greenColor), g.violetColor != null && Object.hasOwnProperty.call(g, "violetColor") && d.uint32(
      /* id 43, wireType 2 =*/
      346
    ).string(g.violetColor), g.grayColor != null && Object.hasOwnProperty.call(g, "grayColor") && d.uint32(
      /* id 44, wireType 2 =*/
      354
    ).string(g.grayColor), g.redBackgroundColor != null && Object.hasOwnProperty.call(g, "redBackgroundColor") && d.uint32(
      /* id 45, wireType 2 =*/
      362
    ).string(g.redBackgroundColor), g.orangeBackgroundColor != null && Object.hasOwnProperty.call(g, "orangeBackgroundColor") && d.uint32(
      /* id 46, wireType 2 =*/
      370
    ).string(g.orangeBackgroundColor), g.yellowBackgroundColor != null && Object.hasOwnProperty.call(g, "yellowBackgroundColor") && d.uint32(
      /* id 47, wireType 2 =*/
      378
    ).string(g.yellowBackgroundColor), g.blueBackgroundColor != null && Object.hasOwnProperty.call(g, "blueBackgroundColor") && d.uint32(
      /* id 48, wireType 2 =*/
      386
    ).string(g.blueBackgroundColor), g.greenBackgroundColor != null && Object.hasOwnProperty.call(g, "greenBackgroundColor") && d.uint32(
      /* id 49, wireType 2 =*/
      394
    ).string(g.greenBackgroundColor), g.violetBackgroundColor != null && Object.hasOwnProperty.call(g, "violetBackgroundColor") && d.uint32(
      /* id 50, wireType 2 =*/
      402
    ).string(g.violetBackgroundColor), g.grayBackgroundColor != null && Object.hasOwnProperty.call(g, "grayBackgroundColor") && d.uint32(
      /* id 51, wireType 2 =*/
      410
    ).string(g.grayBackgroundColor), g.redTextColor != null && Object.hasOwnProperty.call(g, "redTextColor") && d.uint32(
      /* id 52, wireType 2 =*/
      418
    ).string(g.redTextColor), g.orangeTextColor != null && Object.hasOwnProperty.call(g, "orangeTextColor") && d.uint32(
      /* id 53, wireType 2 =*/
      426
    ).string(g.orangeTextColor), g.yellowTextColor != null && Object.hasOwnProperty.call(g, "yellowTextColor") && d.uint32(
      /* id 54, wireType 2 =*/
      434
    ).string(g.yellowTextColor), g.blueTextColor != null && Object.hasOwnProperty.call(g, "blueTextColor") && d.uint32(
      /* id 55, wireType 2 =*/
      442
    ).string(g.blueTextColor), g.greenTextColor != null && Object.hasOwnProperty.call(g, "greenTextColor") && d.uint32(
      /* id 56, wireType 2 =*/
      450
    ).string(g.greenTextColor), g.violetTextColor != null && Object.hasOwnProperty.call(g, "violetTextColor") && d.uint32(
      /* id 57, wireType 2 =*/
      458
    ).string(g.violetTextColor), g.grayTextColor != null && Object.hasOwnProperty.call(g, "grayTextColor") && d.uint32(
      /* id 58, wireType 2 =*/
      466
    ).string(g.grayTextColor), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.CustomThemeConfig();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.primaryColor = g.string();
          break;
        }
        case 2: {
          AA.secondaryBackgroundColor = g.string();
          break;
        }
        case 3: {
          AA.backgroundColor = g.string();
          break;
        }
        case 4: {
          AA.textColor = g.string();
          break;
        }
        case 5: {
          AA.font = g.int32();
          break;
        }
        case 6: {
          AA.base = g.int32();
          break;
        }
        case 7: {
          AA.widgetBackgroundColor = g.string();
          break;
        }
        case 8: {
          AA.widgetBorderColor = g.string();
          break;
        }
        case 9: {
          AA.radii = $root.Radii.decode(g, g.uint32());
          break;
        }
        case 12: {
          AA.headingFont = g.string();
          break;
        }
        case 13: {
          AA.bodyFont = g.string();
          break;
        }
        case 14: {
          AA.codeFont = g.string();
          break;
        }
        case 15: {
          AA.fontFaces && AA.fontFaces.length || (AA.fontFaces = []), AA.fontFaces.push($root.FontFace.decode(g, g.uint32()));
          break;
        }
        case 37: {
          AA.fontSources && AA.fontSources.length || (AA.fontSources = []), AA.fontSources.push($root.FontSource.decode(g, g.uint32()));
          break;
        }
        case 16: {
          AA.fontSizes = $root.FontSizes.decode(g, g.uint32());
          break;
        }
        case 17: {
          AA.skeletonBackgroundColor = g.string();
          break;
        }
        case 18: {
          AA.baseRadius = g.string();
          break;
        }
        case 26: {
          AA.buttonRadius = g.string();
          break;
        }
        case 19: {
          AA.borderColor = g.string();
          break;
        }
        case 27: {
          AA.dataframeBorderColor = g.string();
          break;
        }
        case 20: {
          AA.showWidgetBorder = g.bool();
          break;
        }
        case 21: {
          AA.linkColor = g.string();
          break;
        }
        case 29: {
          AA.linkUnderline = g.bool();
          break;
        }
        case 22: {
          AA.baseFontSize = g.int32();
          break;
        }
        case 30: {
          AA.baseFontWeight = g.int32();
          break;
        }
        case 32: {
          AA.codeFontWeight = g.int32();
          break;
        }
        case 28: {
          AA.codeFontSize = g.string();
          break;
        }
        case 35: {
          AA.headingFontSizes && AA.headingFontSizes.length || (AA.headingFontSizes = []), AA.headingFontSizes.push(g.string());
          break;
        }
        case 34: {
          if (AA.headingFontWeights && AA.headingFontWeights.length || (AA.headingFontWeights = []), (gA & 7) === 2) {
            let IA = g.uint32() + g.pos;
            for (; g.pos < IA; ) AA.headingFontWeights.push(g.int32());
          } else AA.headingFontWeights.push(g.int32());
          break;
        }
        case 23: {
          AA.showSidebarBorder = g.bool();
          break;
        }
        case 24: {
          AA.sidebar = $root.CustomThemeConfig.decode(g, g.uint32());
          break;
        }
        case 25: {
          AA.codeBackgroundColor = g.string();
          break;
        }
        case 31: {
          AA.dataframeHeaderBackgroundColor = g.string();
          break;
        }
        case 33: {
          AA.chartCategoricalColors && AA.chartCategoricalColors.length || (AA.chartCategoricalColors = []), AA.chartCategoricalColors.push(g.string());
          break;
        }
        case 36: {
          AA.chartSequentialColors && AA.chartSequentialColors.length || (AA.chartSequentialColors = []), AA.chartSequentialColors.push(g.string());
          break;
        }
        case 38: {
          AA.redColor = g.string();
          break;
        }
        case 39: {
          AA.orangeColor = g.string();
          break;
        }
        case 40: {
          AA.yellowColor = g.string();
          break;
        }
        case 41: {
          AA.blueColor = g.string();
          break;
        }
        case 42: {
          AA.greenColor = g.string();
          break;
        }
        case 43: {
          AA.violetColor = g.string();
          break;
        }
        case 44: {
          AA.grayColor = g.string();
          break;
        }
        case 45: {
          AA.redBackgroundColor = g.string();
          break;
        }
        case 46: {
          AA.orangeBackgroundColor = g.string();
          break;
        }
        case 47: {
          AA.yellowBackgroundColor = g.string();
          break;
        }
        case 48: {
          AA.blueBackgroundColor = g.string();
          break;
        }
        case 49: {
          AA.greenBackgroundColor = g.string();
          break;
        }
        case 50: {
          AA.violetBackgroundColor = g.string();
          break;
        }
        case 51: {
          AA.grayBackgroundColor = g.string();
          break;
        }
        case 52: {
          AA.redTextColor = g.string();
          break;
        }
        case 53: {
          AA.orangeTextColor = g.string();
          break;
        }
        case 54: {
          AA.yellowTextColor = g.string();
          break;
        }
        case 55: {
          AA.blueTextColor = g.string();
          break;
        }
        case 56: {
          AA.greenTextColor = g.string();
          break;
        }
        case 57: {
          AA.violetTextColor = g.string();
          break;
        }
        case 58: {
          AA.grayTextColor = g.string();
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    if (g.primaryColor != null && g.hasOwnProperty("primaryColor") && !$util.isString(g.primaryColor)) return "primaryColor: string expected";
    if (g.secondaryBackgroundColor != null && g.hasOwnProperty("secondaryBackgroundColor") && !$util.isString(g.secondaryBackgroundColor)) return "secondaryBackgroundColor: string expected";
    if (g.backgroundColor != null && g.hasOwnProperty("backgroundColor") && !$util.isString(g.backgroundColor)) return "backgroundColor: string expected";
    if (g.textColor != null && g.hasOwnProperty("textColor") && !$util.isString(g.textColor)) return "textColor: string expected";
    if (g.font != null && g.hasOwnProperty("font")) switch (g.font) {
      default:
        return "font: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (g.base != null && g.hasOwnProperty("base")) switch (g.base) {
      default:
        return "base: enum value expected";
      case 0:
      case 1:
        break;
    }
    if (g.widgetBackgroundColor != null && g.hasOwnProperty("widgetBackgroundColor") && !$util.isString(g.widgetBackgroundColor)) return "widgetBackgroundColor: string expected";
    if (g.widgetBorderColor != null && g.hasOwnProperty("widgetBorderColor") && !$util.isString(g.widgetBorderColor)) return "widgetBorderColor: string expected";
    if (g.radii != null && g.hasOwnProperty("radii")) {
      let d = $root.Radii.verify(g.radii);
      if (d) return "radii." + d;
    }
    if (g.headingFont != null && g.hasOwnProperty("headingFont") && !$util.isString(g.headingFont)) return "headingFont: string expected";
    if (g.bodyFont != null && g.hasOwnProperty("bodyFont") && !$util.isString(g.bodyFont)) return "bodyFont: string expected";
    if (g.codeFont != null && g.hasOwnProperty("codeFont") && !$util.isString(g.codeFont)) return "codeFont: string expected";
    if (g.fontFaces != null && g.hasOwnProperty("fontFaces")) {
      if (!Array.isArray(g.fontFaces)) return "fontFaces: array expected";
      for (let d = 0; d < g.fontFaces.length; ++d) {
        let k = $root.FontFace.verify(g.fontFaces[d]);
        if (k) return "fontFaces." + k;
      }
    }
    if (g.fontSources != null && g.hasOwnProperty("fontSources")) {
      if (!Array.isArray(g.fontSources)) return "fontSources: array expected";
      for (let d = 0; d < g.fontSources.length; ++d) {
        let k = $root.FontSource.verify(g.fontSources[d]);
        if (k) return "fontSources." + k;
      }
    }
    if (g.fontSizes != null && g.hasOwnProperty("fontSizes")) {
      let d = $root.FontSizes.verify(g.fontSizes);
      if (d) return "fontSizes." + d;
    }
    if (g.skeletonBackgroundColor != null && g.hasOwnProperty("skeletonBackgroundColor") && !$util.isString(g.skeletonBackgroundColor)) return "skeletonBackgroundColor: string expected";
    if (g.baseRadius != null && g.hasOwnProperty("baseRadius") && !$util.isString(g.baseRadius)) return "baseRadius: string expected";
    if (g.buttonRadius != null && g.hasOwnProperty("buttonRadius") && !$util.isString(g.buttonRadius)) return "buttonRadius: string expected";
    if (g.borderColor != null && g.hasOwnProperty("borderColor") && !$util.isString(g.borderColor)) return "borderColor: string expected";
    if (g.dataframeBorderColor != null && g.hasOwnProperty("dataframeBorderColor") && !$util.isString(g.dataframeBorderColor)) return "dataframeBorderColor: string expected";
    if (g.showWidgetBorder != null && g.hasOwnProperty("showWidgetBorder") && typeof g.showWidgetBorder != "boolean") return "showWidgetBorder: boolean expected";
    if (g.linkColor != null && g.hasOwnProperty("linkColor") && !$util.isString(g.linkColor)) return "linkColor: string expected";
    if (g.linkUnderline != null && g.hasOwnProperty("linkUnderline") && typeof g.linkUnderline != "boolean") return "linkUnderline: boolean expected";
    if (g.baseFontSize != null && g.hasOwnProperty("baseFontSize") && !$util.isInteger(g.baseFontSize)) return "baseFontSize: integer expected";
    if (g.baseFontWeight != null && g.hasOwnProperty("baseFontWeight") && !$util.isInteger(g.baseFontWeight)) return "baseFontWeight: integer expected";
    if (g.codeFontWeight != null && g.hasOwnProperty("codeFontWeight") && !$util.isInteger(g.codeFontWeight)) return "codeFontWeight: integer expected";
    if (g.codeFontSize != null && g.hasOwnProperty("codeFontSize") && !$util.isString(g.codeFontSize)) return "codeFontSize: string expected";
    if (g.headingFontSizes != null && g.hasOwnProperty("headingFontSizes")) {
      if (!Array.isArray(g.headingFontSizes)) return "headingFontSizes: array expected";
      for (let d = 0; d < g.headingFontSizes.length; ++d) if (!$util.isString(g.headingFontSizes[d])) return "headingFontSizes: string[] expected";
    }
    if (g.headingFontWeights != null && g.hasOwnProperty("headingFontWeights")) {
      if (!Array.isArray(g.headingFontWeights)) return "headingFontWeights: array expected";
      for (let d = 0; d < g.headingFontWeights.length; ++d) if (!$util.isInteger(g.headingFontWeights[d])) return "headingFontWeights: integer[] expected";
    }
    if (g.showSidebarBorder != null && g.hasOwnProperty("showSidebarBorder") && typeof g.showSidebarBorder != "boolean") return "showSidebarBorder: boolean expected";
    if (g.sidebar != null && g.hasOwnProperty("sidebar")) {
      let d = $root.CustomThemeConfig.verify(g.sidebar);
      if (d) return "sidebar." + d;
    }
    if (g.codeBackgroundColor != null && g.hasOwnProperty("codeBackgroundColor") && !$util.isString(g.codeBackgroundColor)) return "codeBackgroundColor: string expected";
    if (g.dataframeHeaderBackgroundColor != null && g.hasOwnProperty("dataframeHeaderBackgroundColor") && !$util.isString(g.dataframeHeaderBackgroundColor)) return "dataframeHeaderBackgroundColor: string expected";
    if (g.chartCategoricalColors != null && g.hasOwnProperty("chartCategoricalColors")) {
      if (!Array.isArray(g.chartCategoricalColors)) return "chartCategoricalColors: array expected";
      for (let d = 0; d < g.chartCategoricalColors.length; ++d) if (!$util.isString(g.chartCategoricalColors[d])) return "chartCategoricalColors: string[] expected";
    }
    if (g.chartSequentialColors != null && g.hasOwnProperty("chartSequentialColors")) {
      if (!Array.isArray(g.chartSequentialColors)) return "chartSequentialColors: array expected";
      for (let d = 0; d < g.chartSequentialColors.length; ++d) if (!$util.isString(g.chartSequentialColors[d])) return "chartSequentialColors: string[] expected";
    }
    return g.redColor != null && g.hasOwnProperty("redColor") && !$util.isString(g.redColor) ? "redColor: string expected" : g.orangeColor != null && g.hasOwnProperty("orangeColor") && !$util.isString(g.orangeColor) ? "orangeColor: string expected" : g.yellowColor != null && g.hasOwnProperty("yellowColor") && !$util.isString(g.yellowColor) ? "yellowColor: string expected" : g.blueColor != null && g.hasOwnProperty("blueColor") && !$util.isString(g.blueColor) ? "blueColor: string expected" : g.greenColor != null && g.hasOwnProperty("greenColor") && !$util.isString(g.greenColor) ? "greenColor: string expected" : g.violetColor != null && g.hasOwnProperty("violetColor") && !$util.isString(g.violetColor) ? "violetColor: string expected" : g.grayColor != null && g.hasOwnProperty("grayColor") && !$util.isString(g.grayColor) ? "grayColor: string expected" : g.redBackgroundColor != null && g.hasOwnProperty("redBackgroundColor") && !$util.isString(g.redBackgroundColor) ? "redBackgroundColor: string expected" : g.orangeBackgroundColor != null && g.hasOwnProperty("orangeBackgroundColor") && !$util.isString(g.orangeBackgroundColor) ? "orangeBackgroundColor: string expected" : g.yellowBackgroundColor != null && g.hasOwnProperty("yellowBackgroundColor") && !$util.isString(g.yellowBackgroundColor) ? "yellowBackgroundColor: string expected" : g.blueBackgroundColor != null && g.hasOwnProperty("blueBackgroundColor") && !$util.isString(g.blueBackgroundColor) ? "blueBackgroundColor: string expected" : g.greenBackgroundColor != null && g.hasOwnProperty("greenBackgroundColor") && !$util.isString(g.greenBackgroundColor) ? "greenBackgroundColor: string expected" : g.violetBackgroundColor != null && g.hasOwnProperty("violetBackgroundColor") && !$util.isString(g.violetBackgroundColor) ? "violetBackgroundColor: string expected" : g.grayBackgroundColor != null && g.hasOwnProperty("grayBackgroundColor") && !$util.isString(g.grayBackgroundColor) ? "grayBackgroundColor: string expected" : g.redTextColor != null && g.hasOwnProperty("redTextColor") && !$util.isString(g.redTextColor) ? "redTextColor: string expected" : g.orangeTextColor != null && g.hasOwnProperty("orangeTextColor") && !$util.isString(g.orangeTextColor) ? "orangeTextColor: string expected" : g.yellowTextColor != null && g.hasOwnProperty("yellowTextColor") && !$util.isString(g.yellowTextColor) ? "yellowTextColor: string expected" : g.blueTextColor != null && g.hasOwnProperty("blueTextColor") && !$util.isString(g.blueTextColor) ? "blueTextColor: string expected" : g.greenTextColor != null && g.hasOwnProperty("greenTextColor") && !$util.isString(g.greenTextColor) ? "greenTextColor: string expected" : g.violetTextColor != null && g.hasOwnProperty("violetTextColor") && !$util.isString(g.violetTextColor) ? "violetTextColor: string expected" : g.grayTextColor != null && g.hasOwnProperty("grayTextColor") && !$util.isString(g.grayTextColor) ? "grayTextColor: string expected" : null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.CustomThemeConfig) return g;
    let d = new $root.CustomThemeConfig();
    switch (g.primaryColor != null && (d.primaryColor = String(g.primaryColor)), g.secondaryBackgroundColor != null && (d.secondaryBackgroundColor = String(g.secondaryBackgroundColor)), g.backgroundColor != null && (d.backgroundColor = String(g.backgroundColor)), g.textColor != null && (d.textColor = String(g.textColor)), g.font) {
      default:
        if (typeof g.font == "number") {
          d.font = g.font;
          break;
        }
        break;
      case "SANS_SERIF":
      case 0:
        d.font = 0;
        break;
      case "SERIF":
      case 1:
        d.font = 1;
        break;
      case "MONOSPACE":
      case 2:
        d.font = 2;
        break;
    }
    switch (g.base) {
      default:
        if (typeof g.base == "number") {
          d.base = g.base;
          break;
        }
        break;
      case "LIGHT":
      case 0:
        d.base = 0;
        break;
      case "DARK":
      case 1:
        d.base = 1;
        break;
    }
    if (g.widgetBackgroundColor != null && (d.widgetBackgroundColor = String(g.widgetBackgroundColor)), g.widgetBorderColor != null && (d.widgetBorderColor = String(g.widgetBorderColor)), g.radii != null) {
      if (typeof g.radii != "object") throw TypeError(".CustomThemeConfig.radii: object expected");
      d.radii = $root.Radii.fromObject(g.radii);
    }
    if (g.headingFont != null && (d.headingFont = String(g.headingFont)), g.bodyFont != null && (d.bodyFont = String(g.bodyFont)), g.codeFont != null && (d.codeFont = String(g.codeFont)), g.fontFaces) {
      if (!Array.isArray(g.fontFaces)) throw TypeError(".CustomThemeConfig.fontFaces: array expected");
      d.fontFaces = [];
      for (let k = 0; k < g.fontFaces.length; ++k) {
        if (typeof g.fontFaces[k] != "object") throw TypeError(".CustomThemeConfig.fontFaces: object expected");
        d.fontFaces[k] = $root.FontFace.fromObject(g.fontFaces[k]);
      }
    }
    if (g.fontSources) {
      if (!Array.isArray(g.fontSources)) throw TypeError(".CustomThemeConfig.fontSources: array expected");
      d.fontSources = [];
      for (let k = 0; k < g.fontSources.length; ++k) {
        if (typeof g.fontSources[k] != "object") throw TypeError(".CustomThemeConfig.fontSources: object expected");
        d.fontSources[k] = $root.FontSource.fromObject(g.fontSources[k]);
      }
    }
    if (g.fontSizes != null) {
      if (typeof g.fontSizes != "object") throw TypeError(".CustomThemeConfig.fontSizes: object expected");
      d.fontSizes = $root.FontSizes.fromObject(g.fontSizes);
    }
    if (g.skeletonBackgroundColor != null && (d.skeletonBackgroundColor = String(g.skeletonBackgroundColor)), g.baseRadius != null && (d.baseRadius = String(g.baseRadius)), g.buttonRadius != null && (d.buttonRadius = String(g.buttonRadius)), g.borderColor != null && (d.borderColor = String(g.borderColor)), g.dataframeBorderColor != null && (d.dataframeBorderColor = String(g.dataframeBorderColor)), g.showWidgetBorder != null && (d.showWidgetBorder = !!g.showWidgetBorder), g.linkColor != null && (d.linkColor = String(g.linkColor)), g.linkUnderline != null && (d.linkUnderline = !!g.linkUnderline), g.baseFontSize != null && (d.baseFontSize = g.baseFontSize | 0), g.baseFontWeight != null && (d.baseFontWeight = g.baseFontWeight | 0), g.codeFontWeight != null && (d.codeFontWeight = g.codeFontWeight | 0), g.codeFontSize != null && (d.codeFontSize = String(g.codeFontSize)), g.headingFontSizes) {
      if (!Array.isArray(g.headingFontSizes)) throw TypeError(".CustomThemeConfig.headingFontSizes: array expected");
      d.headingFontSizes = [];
      for (let k = 0; k < g.headingFontSizes.length; ++k) d.headingFontSizes[k] = String(g.headingFontSizes[k]);
    }
    if (g.headingFontWeights) {
      if (!Array.isArray(g.headingFontWeights)) throw TypeError(".CustomThemeConfig.headingFontWeights: array expected");
      d.headingFontWeights = [];
      for (let k = 0; k < g.headingFontWeights.length; ++k) d.headingFontWeights[k] = g.headingFontWeights[k] | 0;
    }
    if (g.showSidebarBorder != null && (d.showSidebarBorder = !!g.showSidebarBorder), g.sidebar != null) {
      if (typeof g.sidebar != "object") throw TypeError(".CustomThemeConfig.sidebar: object expected");
      d.sidebar = $root.CustomThemeConfig.fromObject(g.sidebar);
    }
    if (g.codeBackgroundColor != null && (d.codeBackgroundColor = String(g.codeBackgroundColor)), g.dataframeHeaderBackgroundColor != null && (d.dataframeHeaderBackgroundColor = String(g.dataframeHeaderBackgroundColor)), g.chartCategoricalColors) {
      if (!Array.isArray(g.chartCategoricalColors)) throw TypeError(".CustomThemeConfig.chartCategoricalColors: array expected");
      d.chartCategoricalColors = [];
      for (let k = 0; k < g.chartCategoricalColors.length; ++k) d.chartCategoricalColors[k] = String(g.chartCategoricalColors[k]);
    }
    if (g.chartSequentialColors) {
      if (!Array.isArray(g.chartSequentialColors)) throw TypeError(".CustomThemeConfig.chartSequentialColors: array expected");
      d.chartSequentialColors = [];
      for (let k = 0; k < g.chartSequentialColors.length; ++k) d.chartSequentialColors[k] = String(g.chartSequentialColors[k]);
    }
    return g.redColor != null && (d.redColor = String(g.redColor)), g.orangeColor != null && (d.orangeColor = String(g.orangeColor)), g.yellowColor != null && (d.yellowColor = String(g.yellowColor)), g.blueColor != null && (d.blueColor = String(g.blueColor)), g.greenColor != null && (d.greenColor = String(g.greenColor)), g.violetColor != null && (d.violetColor = String(g.violetColor)), g.grayColor != null && (d.grayColor = String(g.grayColor)), g.redBackgroundColor != null && (d.redBackgroundColor = String(g.redBackgroundColor)), g.orangeBackgroundColor != null && (d.orangeBackgroundColor = String(g.orangeBackgroundColor)), g.yellowBackgroundColor != null && (d.yellowBackgroundColor = String(g.yellowBackgroundColor)), g.blueBackgroundColor != null && (d.blueBackgroundColor = String(g.blueBackgroundColor)), g.greenBackgroundColor != null && (d.greenBackgroundColor = String(g.greenBackgroundColor)), g.violetBackgroundColor != null && (d.violetBackgroundColor = String(g.violetBackgroundColor)), g.grayBackgroundColor != null && (d.grayBackgroundColor = String(g.grayBackgroundColor)), g.redTextColor != null && (d.redTextColor = String(g.redTextColor)), g.orangeTextColor != null && (d.orangeTextColor = String(g.orangeTextColor)), g.yellowTextColor != null && (d.yellowTextColor = String(g.yellowTextColor)), g.blueTextColor != null && (d.blueTextColor = String(g.blueTextColor)), g.greenTextColor != null && (d.greenTextColor = String(g.greenTextColor)), g.violetTextColor != null && (d.violetTextColor = String(g.violetTextColor)), g.grayTextColor != null && (d.grayTextColor = String(g.grayTextColor)), d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    if ((d.arrays || d.defaults) && (k.fontFaces = [], k.chartCategoricalColors = [], k.headingFontWeights = [], k.headingFontSizes = [], k.chartSequentialColors = [], k.fontSources = []), d.defaults && (k.primaryColor = "", k.secondaryBackgroundColor = "", k.backgroundColor = "", k.textColor = "", k.font = d.enums === String ? "SANS_SERIF" : 0, k.base = d.enums === String ? "LIGHT" : 0, k.widgetBackgroundColor = "", k.widgetBorderColor = "", k.radii = null, k.headingFont = "", k.bodyFont = "", k.codeFont = "", k.fontSizes = null, k.skeletonBackgroundColor = ""), g.primaryColor != null && g.hasOwnProperty("primaryColor") && (k.primaryColor = g.primaryColor), g.secondaryBackgroundColor != null && g.hasOwnProperty("secondaryBackgroundColor") && (k.secondaryBackgroundColor = g.secondaryBackgroundColor), g.backgroundColor != null && g.hasOwnProperty("backgroundColor") && (k.backgroundColor = g.backgroundColor), g.textColor != null && g.hasOwnProperty("textColor") && (k.textColor = g.textColor), g.font != null && g.hasOwnProperty("font") && (k.font = d.enums === String ? $root.CustomThemeConfig.FontFamily[g.font] === void 0 ? g.font : $root.CustomThemeConfig.FontFamily[g.font] : g.font), g.base != null && g.hasOwnProperty("base") && (k.base = d.enums === String ? $root.CustomThemeConfig.BaseTheme[g.base] === void 0 ? g.base : $root.CustomThemeConfig.BaseTheme[g.base] : g.base), g.widgetBackgroundColor != null && g.hasOwnProperty("widgetBackgroundColor") && (k.widgetBackgroundColor = g.widgetBackgroundColor), g.widgetBorderColor != null && g.hasOwnProperty("widgetBorderColor") && (k.widgetBorderColor = g.widgetBorderColor), g.radii != null && g.hasOwnProperty("radii") && (k.radii = $root.Radii.toObject(g.radii, d)), g.headingFont != null && g.hasOwnProperty("headingFont") && (k.headingFont = g.headingFont), g.bodyFont != null && g.hasOwnProperty("bodyFont") && (k.bodyFont = g.bodyFont), g.codeFont != null && g.hasOwnProperty("codeFont") && (k.codeFont = g.codeFont), g.fontFaces && g.fontFaces.length) {
      k.fontFaces = [];
      for (let H = 0; H < g.fontFaces.length; ++H) k.fontFaces[H] = $root.FontFace.toObject(g.fontFaces[H], d);
    }
    if (g.fontSizes != null && g.hasOwnProperty("fontSizes") && (k.fontSizes = $root.FontSizes.toObject(g.fontSizes, d)), g.skeletonBackgroundColor != null && g.hasOwnProperty("skeletonBackgroundColor") && (k.skeletonBackgroundColor = g.skeletonBackgroundColor), g.baseRadius != null && g.hasOwnProperty("baseRadius") && (k.baseRadius = g.baseRadius, d.oneofs && (k._baseRadius = "baseRadius")), g.borderColor != null && g.hasOwnProperty("borderColor") && (k.borderColor = g.borderColor, d.oneofs && (k._borderColor = "borderColor")), g.showWidgetBorder != null && g.hasOwnProperty("showWidgetBorder") && (k.showWidgetBorder = g.showWidgetBorder, d.oneofs && (k._showWidgetBorder = "showWidgetBorder")), g.linkColor != null && g.hasOwnProperty("linkColor") && (k.linkColor = g.linkColor, d.oneofs && (k._linkColor = "linkColor")), g.baseFontSize != null && g.hasOwnProperty("baseFontSize") && (k.baseFontSize = g.baseFontSize, d.oneofs && (k._baseFontSize = "baseFontSize")), g.showSidebarBorder != null && g.hasOwnProperty("showSidebarBorder") && (k.showSidebarBorder = g.showSidebarBorder, d.oneofs && (k._showSidebarBorder = "showSidebarBorder")), g.sidebar != null && g.hasOwnProperty("sidebar") && (k.sidebar = $root.CustomThemeConfig.toObject(g.sidebar, d), d.oneofs && (k._sidebar = "sidebar")), g.codeBackgroundColor != null && g.hasOwnProperty("codeBackgroundColor") && (k.codeBackgroundColor = g.codeBackgroundColor, d.oneofs && (k._codeBackgroundColor = "codeBackgroundColor")), g.buttonRadius != null && g.hasOwnProperty("buttonRadius") && (k.buttonRadius = g.buttonRadius, d.oneofs && (k._buttonRadius = "buttonRadius")), g.dataframeBorderColor != null && g.hasOwnProperty("dataframeBorderColor") && (k.dataframeBorderColor = g.dataframeBorderColor, d.oneofs && (k._dataframeBorderColor = "dataframeBorderColor")), g.codeFontSize != null && g.hasOwnProperty("codeFontSize") && (k.codeFontSize = g.codeFontSize, d.oneofs && (k._codeFontSize = "codeFontSize")), g.linkUnderline != null && g.hasOwnProperty("linkUnderline") && (k.linkUnderline = g.linkUnderline, d.oneofs && (k._linkUnderline = "linkUnderline")), g.baseFontWeight != null && g.hasOwnProperty("baseFontWeight") && (k.baseFontWeight = g.baseFontWeight, d.oneofs && (k._baseFontWeight = "baseFontWeight")), g.dataframeHeaderBackgroundColor != null && g.hasOwnProperty("dataframeHeaderBackgroundColor") && (k.dataframeHeaderBackgroundColor = g.dataframeHeaderBackgroundColor, d.oneofs && (k._dataframeHeaderBackgroundColor = "dataframeHeaderBackgroundColor")), g.codeFontWeight != null && g.hasOwnProperty("codeFontWeight") && (k.codeFontWeight = g.codeFontWeight, d.oneofs && (k._codeFontWeight = "codeFontWeight")), g.chartCategoricalColors && g.chartCategoricalColors.length) {
      k.chartCategoricalColors = [];
      for (let H = 0; H < g.chartCategoricalColors.length; ++H) k.chartCategoricalColors[H] = g.chartCategoricalColors[H];
    }
    if (g.headingFontWeights && g.headingFontWeights.length) {
      k.headingFontWeights = [];
      for (let H = 0; H < g.headingFontWeights.length; ++H) k.headingFontWeights[H] = g.headingFontWeights[H];
    }
    if (g.headingFontSizes && g.headingFontSizes.length) {
      k.headingFontSizes = [];
      for (let H = 0; H < g.headingFontSizes.length; ++H) k.headingFontSizes[H] = g.headingFontSizes[H];
    }
    if (g.chartSequentialColors && g.chartSequentialColors.length) {
      k.chartSequentialColors = [];
      for (let H = 0; H < g.chartSequentialColors.length; ++H) k.chartSequentialColors[H] = g.chartSequentialColors[H];
    }
    if (g.fontSources && g.fontSources.length) {
      k.fontSources = [];
      for (let H = 0; H < g.fontSources.length; ++H) k.fontSources[H] = $root.FontSource.toObject(g.fontSources[H], d);
    }
    return g.redColor != null && g.hasOwnProperty("redColor") && (k.redColor = g.redColor, d.oneofs && (k._redColor = "redColor")), g.orangeColor != null && g.hasOwnProperty("orangeColor") && (k.orangeColor = g.orangeColor, d.oneofs && (k._orangeColor = "orangeColor")), g.yellowColor != null && g.hasOwnProperty("yellowColor") && (k.yellowColor = g.yellowColor, d.oneofs && (k._yellowColor = "yellowColor")), g.blueColor != null && g.hasOwnProperty("blueColor") && (k.blueColor = g.blueColor, d.oneofs && (k._blueColor = "blueColor")), g.greenColor != null && g.hasOwnProperty("greenColor") && (k.greenColor = g.greenColor, d.oneofs && (k._greenColor = "greenColor")), g.violetColor != null && g.hasOwnProperty("violetColor") && (k.violetColor = g.violetColor, d.oneofs && (k._violetColor = "violetColor")), g.grayColor != null && g.hasOwnProperty("grayColor") && (k.grayColor = g.grayColor, d.oneofs && (k._grayColor = "grayColor")), g.redBackgroundColor != null && g.hasOwnProperty("redBackgroundColor") && (k.redBackgroundColor = g.redBackgroundColor, d.oneofs && (k._redBackgroundColor = "redBackgroundColor")), g.orangeBackgroundColor != null && g.hasOwnProperty("orangeBackgroundColor") && (k.orangeBackgroundColor = g.orangeBackgroundColor, d.oneofs && (k._orangeBackgroundColor = "orangeBackgroundColor")), g.yellowBackgroundColor != null && g.hasOwnProperty("yellowBackgroundColor") && (k.yellowBackgroundColor = g.yellowBackgroundColor, d.oneofs && (k._yellowBackgroundColor = "yellowBackgroundColor")), g.blueBackgroundColor != null && g.hasOwnProperty("blueBackgroundColor") && (k.blueBackgroundColor = g.blueBackgroundColor, d.oneofs && (k._blueBackgroundColor = "blueBackgroundColor")), g.greenBackgroundColor != null && g.hasOwnProperty("greenBackgroundColor") && (k.greenBackgroundColor = g.greenBackgroundColor, d.oneofs && (k._greenBackgroundColor = "greenBackgroundColor")), g.violetBackgroundColor != null && g.hasOwnProperty("violetBackgroundColor") && (k.violetBackgroundColor = g.violetBackgroundColor, d.oneofs && (k._violetBackgroundColor = "violetBackgroundColor")), g.grayBackgroundColor != null && g.hasOwnProperty("grayBackgroundColor") && (k.grayBackgroundColor = g.grayBackgroundColor, d.oneofs && (k._grayBackgroundColor = "grayBackgroundColor")), g.redTextColor != null && g.hasOwnProperty("redTextColor") && (k.redTextColor = g.redTextColor, d.oneofs && (k._redTextColor = "redTextColor")), g.orangeTextColor != null && g.hasOwnProperty("orangeTextColor") && (k.orangeTextColor = g.orangeTextColor, d.oneofs && (k._orangeTextColor = "orangeTextColor")), g.yellowTextColor != null && g.hasOwnProperty("yellowTextColor") && (k.yellowTextColor = g.yellowTextColor, d.oneofs && (k._yellowTextColor = "yellowTextColor")), g.blueTextColor != null && g.hasOwnProperty("blueTextColor") && (k.blueTextColor = g.blueTextColor, d.oneofs && (k._blueTextColor = "blueTextColor")), g.greenTextColor != null && g.hasOwnProperty("greenTextColor") && (k.greenTextColor = g.greenTextColor, d.oneofs && (k._greenTextColor = "greenTextColor")), g.violetTextColor != null && g.hasOwnProperty("violetTextColor") && (k.violetTextColor = g.violetTextColor, d.oneofs && (k._violetTextColor = "violetTextColor")), g.grayTextColor != null && g.hasOwnProperty("grayTextColor") && (k.grayTextColor = g.grayTextColor, d.oneofs && (k._grayTextColor = "grayTextColor")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/CustomThemeConfig";
  }, n.BaseTheme = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "LIGHT"] = 0, d[g[1] = "DARK"] = 1, d;
  })(), n.FontFamily = (function() {
    const g = {}, d = Object.create(g);
    return d[g[0] = "SANS_SERIF"] = 0, d[g[1] = "SERIF"] = 1, d[g[2] = "MONOSPACE"] = 2, d;
  })(), n;
})();
$root.FontFace = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.url = "", n.prototype.family = "", n.prototype.weight = 0, n.prototype.weightRange = "", n.prototype.style = "", n.prototype.unicodeRange = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.url != null && Object.hasOwnProperty.call(t, "url") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.url), t.family != null && Object.hasOwnProperty.call(t, "family") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.family), t.weight != null && Object.hasOwnProperty.call(t, "weight") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(t.weight), t.style != null && Object.hasOwnProperty.call(t, "style") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.style), t.weightRange != null && Object.hasOwnProperty.call(t, "weightRange") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.weightRange), t.unicodeRange != null && Object.hasOwnProperty.call(t, "unicodeRange") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.unicodeRange), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.FontFace();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.url = t.string();
          break;
        }
        case 2: {
          H.family = t.string();
          break;
        }
        case 3: {
          H.weight = t.int32();
          break;
        }
        case 5: {
          H.weightRange = t.string();
          break;
        }
        case 4: {
          H.style = t.string();
          break;
        }
        case 6: {
          H.unicodeRange = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.url != null && t.hasOwnProperty("url") && !$util.isString(t.url) ? "url: string expected" : t.family != null && t.hasOwnProperty("family") && !$util.isString(t.family) ? "family: string expected" : t.weight != null && t.hasOwnProperty("weight") && !$util.isInteger(t.weight) ? "weight: integer expected" : t.weightRange != null && t.hasOwnProperty("weightRange") && !$util.isString(t.weightRange) ? "weightRange: string expected" : t.style != null && t.hasOwnProperty("style") && !$util.isString(t.style) ? "style: string expected" : t.unicodeRange != null && t.hasOwnProperty("unicodeRange") && !$util.isString(t.unicodeRange) ? "unicodeRange: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.FontFace) return t;
    let g = new $root.FontFace();
    return t.url != null && (g.url = String(t.url)), t.family != null && (g.family = String(t.family)), t.weight != null && (g.weight = t.weight | 0), t.weightRange != null && (g.weightRange = String(t.weightRange)), t.style != null && (g.style = String(t.style)), t.unicodeRange != null && (g.unicodeRange = String(t.unicodeRange)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.url = "", d.family = "", d.weight = 0, d.style = "", d.weightRange = "", d.unicodeRange = ""), t.url != null && t.hasOwnProperty("url") && (d.url = t.url), t.family != null && t.hasOwnProperty("family") && (d.family = t.family), t.weight != null && t.hasOwnProperty("weight") && (d.weight = t.weight), t.style != null && t.hasOwnProperty("style") && (d.style = t.style), t.weightRange != null && t.hasOwnProperty("weightRange") && (d.weightRange = t.weightRange), t.unicodeRange != null && t.hasOwnProperty("unicodeRange") && (d.unicodeRange = t.unicodeRange), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/FontFace";
  }, n;
})();
$root.FontSource = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.configName = "", n.prototype.sourceUrl = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.configName != null && Object.hasOwnProperty.call(t, "configName") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.configName), t.sourceUrl != null && Object.hasOwnProperty.call(t, "sourceUrl") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.sourceUrl), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.FontSource();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.configName = t.string();
          break;
        }
        case 2: {
          H.sourceUrl = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.configName != null && t.hasOwnProperty("configName") && !$util.isString(t.configName) ? "configName: string expected" : t.sourceUrl != null && t.hasOwnProperty("sourceUrl") && !$util.isString(t.sourceUrl) ? "sourceUrl: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.FontSource) return t;
    let g = new $root.FontSource();
    return t.configName != null && (g.configName = String(t.configName)), t.sourceUrl != null && (g.sourceUrl = String(t.sourceUrl)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.configName = "", d.sourceUrl = ""), t.configName != null && t.hasOwnProperty("configName") && (d.configName = t.configName), t.sourceUrl != null && t.hasOwnProperty("sourceUrl") && (d.sourceUrl = t.sourceUrl), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/FontSource";
  }, n;
})();
$root.Radii = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.baseWidgetRadius = 0, n.prototype.checkboxRadius = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.baseWidgetRadius != null && Object.hasOwnProperty.call(t, "baseWidgetRadius") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(t.baseWidgetRadius), t.checkboxRadius != null && Object.hasOwnProperty.call(t, "checkboxRadius") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(t.checkboxRadius), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Radii();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.baseWidgetRadius = t.int32();
          break;
        }
        case 2: {
          H.checkboxRadius = t.int32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.baseWidgetRadius != null && t.hasOwnProperty("baseWidgetRadius") && !$util.isInteger(t.baseWidgetRadius) ? "baseWidgetRadius: integer expected" : t.checkboxRadius != null && t.hasOwnProperty("checkboxRadius") && !$util.isInteger(t.checkboxRadius) ? "checkboxRadius: integer expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Radii) return t;
    let g = new $root.Radii();
    return t.baseWidgetRadius != null && (g.baseWidgetRadius = t.baseWidgetRadius | 0), t.checkboxRadius != null && (g.checkboxRadius = t.checkboxRadius | 0), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.baseWidgetRadius = 0, d.checkboxRadius = 0), t.baseWidgetRadius != null && t.hasOwnProperty("baseWidgetRadius") && (d.baseWidgetRadius = t.baseWidgetRadius), t.checkboxRadius != null && t.hasOwnProperty("checkboxRadius") && (d.checkboxRadius = t.checkboxRadius), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Radii";
  }, n;
})();
$root.FontSizes = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.tinyFontSize = 0, n.prototype.smallFontSize = 0, n.prototype.baseFontSize = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.tinyFontSize != null && Object.hasOwnProperty.call(t, "tinyFontSize") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(t.tinyFontSize), t.smallFontSize != null && Object.hasOwnProperty.call(t, "smallFontSize") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(t.smallFontSize), t.baseFontSize != null && Object.hasOwnProperty.call(t, "baseFontSize") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(t.baseFontSize), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.FontSizes();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.tinyFontSize = t.int32();
          break;
        }
        case 2: {
          H.smallFontSize = t.int32();
          break;
        }
        case 3: {
          H.baseFontSize = t.int32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.tinyFontSize != null && t.hasOwnProperty("tinyFontSize") && !$util.isInteger(t.tinyFontSize) ? "tinyFontSize: integer expected" : t.smallFontSize != null && t.hasOwnProperty("smallFontSize") && !$util.isInteger(t.smallFontSize) ? "smallFontSize: integer expected" : t.baseFontSize != null && t.hasOwnProperty("baseFontSize") && !$util.isInteger(t.baseFontSize) ? "baseFontSize: integer expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.FontSizes) return t;
    let g = new $root.FontSizes();
    return t.tinyFontSize != null && (g.tinyFontSize = t.tinyFontSize | 0), t.smallFontSize != null && (g.smallFontSize = t.smallFontSize | 0), t.baseFontSize != null && (g.baseFontSize = t.baseFontSize | 0), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.tinyFontSize = 0, d.smallFontSize = 0, d.baseFontSize = 0), t.tinyFontSize != null && t.hasOwnProperty("tinyFontSize") && (d.tinyFontSize = t.tinyFontSize), t.smallFontSize != null && t.hasOwnProperty("smallFontSize") && (d.smallFontSize = t.smallFontSize), t.baseFontSize != null && t.hasOwnProperty("baseFontSize") && (d.baseFontSize = t.baseFontSize), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/FontSizes";
  }, n;
})();
$root.UserInfo = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.installationId = "", n.prototype.installationIdV3 = "", n.prototype.installationIdV4 = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.installationId != null && Object.hasOwnProperty.call(t, "installationId") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.installationId), t.installationIdV3 != null && Object.hasOwnProperty.call(t, "installationIdV3") && g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.installationIdV3), t.installationIdV4 != null && Object.hasOwnProperty.call(t, "installationIdV4") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.installationIdV4), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.UserInfo();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.installationId = t.string();
          break;
        }
        case 5: {
          H.installationIdV3 = t.string();
          break;
        }
        case 6: {
          H.installationIdV4 = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.installationId != null && t.hasOwnProperty("installationId") && !$util.isString(t.installationId) ? "installationId: string expected" : t.installationIdV3 != null && t.hasOwnProperty("installationIdV3") && !$util.isString(t.installationIdV3) ? "installationIdV3: string expected" : t.installationIdV4 != null && t.hasOwnProperty("installationIdV4") && !$util.isString(t.installationIdV4) ? "installationIdV4: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.UserInfo) return t;
    let g = new $root.UserInfo();
    return t.installationId != null && (g.installationId = String(t.installationId)), t.installationIdV3 != null && (g.installationIdV3 = String(t.installationIdV3)), t.installationIdV4 != null && (g.installationIdV4 = String(t.installationIdV4)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.installationId = "", d.installationIdV3 = "", d.installationIdV4 = ""), t.installationId != null && t.hasOwnProperty("installationId") && (d.installationId = t.installationId), t.installationIdV3 != null && t.hasOwnProperty("installationIdV3") && (d.installationIdV3 = t.installationIdV3), t.installationIdV4 != null && t.hasOwnProperty("installationIdV4") && (d.installationIdV4 = t.installationIdV4), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/UserInfo";
  }, n;
})();
$root.EnvironmentInfo = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.streamlitVersion = "", n.prototype.pythonVersion = "", n.prototype.serverOs = "", n.prototype.hasDisplay = !1, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.streamlitVersion != null && Object.hasOwnProperty.call(t, "streamlitVersion") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.streamlitVersion), t.pythonVersion != null && Object.hasOwnProperty.call(t, "pythonVersion") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.pythonVersion), t.serverOs != null && Object.hasOwnProperty.call(t, "serverOs") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.serverOs), t.hasDisplay != null && Object.hasOwnProperty.call(t, "hasDisplay") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(t.hasDisplay), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.EnvironmentInfo();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.streamlitVersion = t.string();
          break;
        }
        case 2: {
          H.pythonVersion = t.string();
          break;
        }
        case 3: {
          H.serverOs = t.string();
          break;
        }
        case 4: {
          H.hasDisplay = t.bool();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.streamlitVersion != null && t.hasOwnProperty("streamlitVersion") && !$util.isString(t.streamlitVersion) ? "streamlitVersion: string expected" : t.pythonVersion != null && t.hasOwnProperty("pythonVersion") && !$util.isString(t.pythonVersion) ? "pythonVersion: string expected" : t.serverOs != null && t.hasOwnProperty("serverOs") && !$util.isString(t.serverOs) ? "serverOs: string expected" : t.hasDisplay != null && t.hasOwnProperty("hasDisplay") && typeof t.hasDisplay != "boolean" ? "hasDisplay: boolean expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.EnvironmentInfo) return t;
    let g = new $root.EnvironmentInfo();
    return t.streamlitVersion != null && (g.streamlitVersion = String(t.streamlitVersion)), t.pythonVersion != null && (g.pythonVersion = String(t.pythonVersion)), t.serverOs != null && (g.serverOs = String(t.serverOs)), t.hasDisplay != null && (g.hasDisplay = !!t.hasDisplay), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.streamlitVersion = "", d.pythonVersion = "", d.serverOs = "", d.hasDisplay = !1), t.streamlitVersion != null && t.hasOwnProperty("streamlitVersion") && (d.streamlitVersion = t.streamlitVersion), t.pythonVersion != null && t.hasOwnProperty("pythonVersion") && (d.pythonVersion = t.pythonVersion), t.serverOs != null && t.hasOwnProperty("serverOs") && (d.serverOs = t.serverOs), t.hasDisplay != null && t.hasOwnProperty("hasDisplay") && (d.hasDisplay = t.hasDisplay), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/EnvironmentInfo";
  }, n;
})();
$root.SessionStatus = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.runOnSave = !1, n.prototype.scriptIsRunning = !1, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.runOnSave != null && Object.hasOwnProperty.call(t, "runOnSave") && g.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(t.runOnSave), t.scriptIsRunning != null && Object.hasOwnProperty.call(t, "scriptIsRunning") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(t.scriptIsRunning), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.SessionStatus();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.runOnSave = t.bool();
          break;
        }
        case 2: {
          H.scriptIsRunning = t.bool();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.runOnSave != null && t.hasOwnProperty("runOnSave") && typeof t.runOnSave != "boolean" ? "runOnSave: boolean expected" : t.scriptIsRunning != null && t.hasOwnProperty("scriptIsRunning") && typeof t.scriptIsRunning != "boolean" ? "scriptIsRunning: boolean expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.SessionStatus) return t;
    let g = new $root.SessionStatus();
    return t.runOnSave != null && (g.runOnSave = !!t.runOnSave), t.scriptIsRunning != null && (g.scriptIsRunning = !!t.scriptIsRunning), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.runOnSave = !1, d.scriptIsRunning = !1), t.runOnSave != null && t.hasOwnProperty("runOnSave") && (d.runOnSave = t.runOnSave), t.scriptIsRunning != null && t.hasOwnProperty("scriptIsRunning") && (d.scriptIsRunning = t.scriptIsRunning), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/SessionStatus";
  }, n;
})();
$root.PageConfig = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.title = "", n.prototype.favicon = "", n.prototype.layout = 0, n.prototype.initialSidebarState = 0, n.prototype.menuItems = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.title != null && Object.hasOwnProperty.call(t, "title") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.title), t.favicon != null && Object.hasOwnProperty.call(t, "favicon") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.favicon), t.layout != null && Object.hasOwnProperty.call(t, "layout") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(t.layout), t.initialSidebarState != null && Object.hasOwnProperty.call(t, "initialSidebarState") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(t.initialSidebarState), t.menuItems != null && Object.hasOwnProperty.call(t, "menuItems") && $root.PageConfig.MenuItems.encode(t.menuItems, g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.PageConfig();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.title = t.string();
          break;
        }
        case 2: {
          H.favicon = t.string();
          break;
        }
        case 3: {
          H.layout = t.int32();
          break;
        }
        case 4: {
          H.initialSidebarState = t.int32();
          break;
        }
        case 5: {
          H.menuItems = $root.PageConfig.MenuItems.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.title != null && t.hasOwnProperty("title") && !$util.isString(t.title)) return "title: string expected";
    if (t.favicon != null && t.hasOwnProperty("favicon") && !$util.isString(t.favicon)) return "favicon: string expected";
    if (t.layout != null && t.hasOwnProperty("layout")) switch (t.layout) {
      default:
        return "layout: enum value expected";
      case 0:
      case 1:
      case 2:
        break;
    }
    if (t.initialSidebarState != null && t.hasOwnProperty("initialSidebarState")) switch (t.initialSidebarState) {
      default:
        return "initialSidebarState: enum value expected";
      case 0:
      case 1:
      case 2:
      case 3:
        break;
    }
    if (t.menuItems != null && t.hasOwnProperty("menuItems")) {
      let g = $root.PageConfig.MenuItems.verify(t.menuItems);
      if (g) return "menuItems." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.PageConfig) return t;
    let g = new $root.PageConfig();
    switch (t.title != null && (g.title = String(t.title)), t.favicon != null && (g.favicon = String(t.favicon)), t.layout) {
      default:
        if (typeof t.layout == "number") {
          g.layout = t.layout;
          break;
        }
        break;
      case "CENTERED":
      case 0:
        g.layout = 0;
        break;
      case "WIDE":
      case 1:
        g.layout = 1;
        break;
      case "LAYOUT_UNSET":
      case 2:
        g.layout = 2;
        break;
    }
    switch (t.initialSidebarState) {
      default:
        if (typeof t.initialSidebarState == "number") {
          g.initialSidebarState = t.initialSidebarState;
          break;
        }
        break;
      case "AUTO":
      case 0:
        g.initialSidebarState = 0;
        break;
      case "EXPANDED":
      case 1:
        g.initialSidebarState = 1;
        break;
      case "COLLAPSED":
      case 2:
        g.initialSidebarState = 2;
        break;
      case "SIDEBAR_UNSET":
      case 3:
        g.initialSidebarState = 3;
        break;
    }
    if (t.menuItems != null) {
      if (typeof t.menuItems != "object") throw TypeError(".PageConfig.menuItems: object expected");
      g.menuItems = $root.PageConfig.MenuItems.fromObject(t.menuItems);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.title = "", d.favicon = "", d.layout = g.enums === String ? "CENTERED" : 0, d.initialSidebarState = g.enums === String ? "AUTO" : 0, d.menuItems = null), t.title != null && t.hasOwnProperty("title") && (d.title = t.title), t.favicon != null && t.hasOwnProperty("favicon") && (d.favicon = t.favicon), t.layout != null && t.hasOwnProperty("layout") && (d.layout = g.enums === String ? $root.PageConfig.Layout[t.layout] === void 0 ? t.layout : $root.PageConfig.Layout[t.layout] : t.layout), t.initialSidebarState != null && t.hasOwnProperty("initialSidebarState") && (d.initialSidebarState = g.enums === String ? $root.PageConfig.SidebarState[t.initialSidebarState] === void 0 ? t.initialSidebarState : $root.PageConfig.SidebarState[t.initialSidebarState] : t.initialSidebarState), t.menuItems != null && t.hasOwnProperty("menuItems") && (d.menuItems = $root.PageConfig.MenuItems.toObject(t.menuItems, g)), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/PageConfig";
  }, n.MenuItems = (function() {
    function t(g) {
      if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.getHelpUrl = "", t.prototype.hideGetHelp = !1, t.prototype.reportABugUrl = "", t.prototype.hideReportABug = !1, t.prototype.aboutSectionMd = "", t.prototype.clearAboutMd = !1, t.create = function(g) {
      return new t(g);
    }, t.encode = function(g, d) {
      return d || (d = $Writer.create()), g.getHelpUrl != null && Object.hasOwnProperty.call(g, "getHelpUrl") && d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.getHelpUrl), g.hideGetHelp != null && Object.hasOwnProperty.call(g, "hideGetHelp") && d.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(g.hideGetHelp), g.reportABugUrl != null && Object.hasOwnProperty.call(g, "reportABugUrl") && d.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(g.reportABugUrl), g.hideReportABug != null && Object.hasOwnProperty.call(g, "hideReportABug") && d.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(g.hideReportABug), g.aboutSectionMd != null && Object.hasOwnProperty.call(g, "aboutSectionMd") && d.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(g.aboutSectionMd), g.clearAboutMd != null && Object.hasOwnProperty.call(g, "clearAboutMd") && d.uint32(
        /* id 6, wireType 0 =*/
        48
      ).bool(g.clearAboutMd), d;
    }, t.encodeDelimited = function(g, d) {
      return this.encode(g, d).ldelim();
    }, t.decode = function(g, d, k) {
      g instanceof $Reader || (g = $Reader.create(g));
      let H = d === void 0 ? g.len : g.pos + d, AA = new $root.PageConfig.MenuItems();
      for (; g.pos < H; ) {
        let gA = g.uint32();
        if (gA === k) break;
        switch (gA >>> 3) {
          case 1: {
            AA.getHelpUrl = g.string();
            break;
          }
          case 2: {
            AA.hideGetHelp = g.bool();
            break;
          }
          case 3: {
            AA.reportABugUrl = g.string();
            break;
          }
          case 4: {
            AA.hideReportABug = g.bool();
            break;
          }
          case 5: {
            AA.aboutSectionMd = g.string();
            break;
          }
          case 6: {
            AA.clearAboutMd = g.bool();
            break;
          }
          default:
            g.skipType(gA & 7);
            break;
        }
      }
      return AA;
    }, t.decodeDelimited = function(g) {
      return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
    }, t.verify = function(g) {
      return typeof g != "object" || g === null ? "object expected" : g.getHelpUrl != null && g.hasOwnProperty("getHelpUrl") && !$util.isString(g.getHelpUrl) ? "getHelpUrl: string expected" : g.hideGetHelp != null && g.hasOwnProperty("hideGetHelp") && typeof g.hideGetHelp != "boolean" ? "hideGetHelp: boolean expected" : g.reportABugUrl != null && g.hasOwnProperty("reportABugUrl") && !$util.isString(g.reportABugUrl) ? "reportABugUrl: string expected" : g.hideReportABug != null && g.hasOwnProperty("hideReportABug") && typeof g.hideReportABug != "boolean" ? "hideReportABug: boolean expected" : g.aboutSectionMd != null && g.hasOwnProperty("aboutSectionMd") && !$util.isString(g.aboutSectionMd) ? "aboutSectionMd: string expected" : g.clearAboutMd != null && g.hasOwnProperty("clearAboutMd") && typeof g.clearAboutMd != "boolean" ? "clearAboutMd: boolean expected" : null;
    }, t.fromObject = function(g) {
      if (g instanceof $root.PageConfig.MenuItems) return g;
      let d = new $root.PageConfig.MenuItems();
      return g.getHelpUrl != null && (d.getHelpUrl = String(g.getHelpUrl)), g.hideGetHelp != null && (d.hideGetHelp = !!g.hideGetHelp), g.reportABugUrl != null && (d.reportABugUrl = String(g.reportABugUrl)), g.hideReportABug != null && (d.hideReportABug = !!g.hideReportABug), g.aboutSectionMd != null && (d.aboutSectionMd = String(g.aboutSectionMd)), g.clearAboutMd != null && (d.clearAboutMd = !!g.clearAboutMd), d;
    }, t.toObject = function(g, d) {
      d || (d = {});
      let k = {};
      return d.defaults && (k.getHelpUrl = "", k.hideGetHelp = !1, k.reportABugUrl = "", k.hideReportABug = !1, k.aboutSectionMd = "", k.clearAboutMd = !1), g.getHelpUrl != null && g.hasOwnProperty("getHelpUrl") && (k.getHelpUrl = g.getHelpUrl), g.hideGetHelp != null && g.hasOwnProperty("hideGetHelp") && (k.hideGetHelp = g.hideGetHelp), g.reportABugUrl != null && g.hasOwnProperty("reportABugUrl") && (k.reportABugUrl = g.reportABugUrl), g.hideReportABug != null && g.hasOwnProperty("hideReportABug") && (k.hideReportABug = g.hideReportABug), g.aboutSectionMd != null && g.hasOwnProperty("aboutSectionMd") && (k.aboutSectionMd = g.aboutSectionMd), g.clearAboutMd != null && g.hasOwnProperty("clearAboutMd") && (k.clearAboutMd = g.clearAboutMd), k;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/PageConfig.MenuItems";
    }, t;
  })(), n.Layout = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "CENTERED"] = 0, g[t[1] = "WIDE"] = 1, g[t[2] = "LAYOUT_UNSET"] = 2, g;
  })(), n.SidebarState = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "AUTO"] = 0, g[t[1] = "EXPANDED"] = 1, g[t[2] = "COLLAPSED"] = 2, g[t[3] = "SIDEBAR_UNSET"] = 3, g;
  })(), n;
})();
$root.PageInfo = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.queryString = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.queryString != null && Object.hasOwnProperty.call(t, "queryString") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.queryString), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.PageInfo();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.queryString = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.queryString != null && t.hasOwnProperty("queryString") && !$util.isString(t.queryString) ? "queryString: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.PageInfo) return t;
    let g = new $root.PageInfo();
    return t.queryString != null && (g.queryString = String(t.queryString)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.queryString = ""), t.queryString != null && t.hasOwnProperty("queryString") && (d.queryString = t.queryString), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/PageInfo";
  }, n;
})();
$root.PageProfile = (() => {
  function n(t) {
    if (this.commands = [], this.config = [], this.attributions = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.commands = $util.emptyArray, n.prototype.execTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, n.prototype.prepTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, n.prototype.config = $util.emptyArray, n.prototype.uncaughtException = "", n.prototype.attributions = $util.emptyArray, n.prototype.os = "", n.prototype.timezone = "", n.prototype.headless = !1, n.prototype.isFragmentRun = !1, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.commands != null && t.commands.length) for (let d = 0; d < t.commands.length; ++d) $root.Command.encode(t.commands[d], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (t.execTime != null && Object.hasOwnProperty.call(t, "execTime") && g.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(t.execTime), t.prepTime != null && Object.hasOwnProperty.call(t, "prepTime") && g.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int64(t.prepTime), t.config != null && t.config.length) for (let d = 0; d < t.config.length; ++d) g.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.config[d]);
    if (t.uncaughtException != null && Object.hasOwnProperty.call(t, "uncaughtException") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.uncaughtException), t.attributions != null && t.attributions.length) for (let d = 0; d < t.attributions.length; ++d) g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.attributions[d]);
    return t.os != null && Object.hasOwnProperty.call(t, "os") && g.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(t.os), t.timezone != null && Object.hasOwnProperty.call(t, "timezone") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(t.timezone), t.headless != null && Object.hasOwnProperty.call(t, "headless") && g.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(t.headless), t.isFragmentRun != null && Object.hasOwnProperty.call(t, "isFragmentRun") && g.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(t.isFragmentRun), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.PageProfile();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.commands && H.commands.length || (H.commands = []), H.commands.push($root.Command.decode(t, t.uint32()));
          break;
        }
        case 2: {
          H.execTime = t.int64();
          break;
        }
        case 3: {
          H.prepTime = t.int64();
          break;
        }
        case 5: {
          H.config && H.config.length || (H.config = []), H.config.push(t.string());
          break;
        }
        case 6: {
          H.uncaughtException = t.string();
          break;
        }
        case 7: {
          H.attributions && H.attributions.length || (H.attributions = []), H.attributions.push(t.string());
          break;
        }
        case 8: {
          H.os = t.string();
          break;
        }
        case 9: {
          H.timezone = t.string();
          break;
        }
        case 10: {
          H.headless = t.bool();
          break;
        }
        case 11: {
          H.isFragmentRun = t.bool();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.commands != null && t.hasOwnProperty("commands")) {
      if (!Array.isArray(t.commands)) return "commands: array expected";
      for (let g = 0; g < t.commands.length; ++g) {
        let d = $root.Command.verify(t.commands[g]);
        if (d) return "commands." + d;
      }
    }
    if (t.execTime != null && t.hasOwnProperty("execTime") && !$util.isInteger(t.execTime) && !(t.execTime && $util.isInteger(t.execTime.low) && $util.isInteger(t.execTime.high))) return "execTime: integer|Long expected";
    if (t.prepTime != null && t.hasOwnProperty("prepTime") && !$util.isInteger(t.prepTime) && !(t.prepTime && $util.isInteger(t.prepTime.low) && $util.isInteger(t.prepTime.high))) return "prepTime: integer|Long expected";
    if (t.config != null && t.hasOwnProperty("config")) {
      if (!Array.isArray(t.config)) return "config: array expected";
      for (let g = 0; g < t.config.length; ++g) if (!$util.isString(t.config[g])) return "config: string[] expected";
    }
    if (t.uncaughtException != null && t.hasOwnProperty("uncaughtException") && !$util.isString(t.uncaughtException)) return "uncaughtException: string expected";
    if (t.attributions != null && t.hasOwnProperty("attributions")) {
      if (!Array.isArray(t.attributions)) return "attributions: array expected";
      for (let g = 0; g < t.attributions.length; ++g) if (!$util.isString(t.attributions[g])) return "attributions: string[] expected";
    }
    return t.os != null && t.hasOwnProperty("os") && !$util.isString(t.os) ? "os: string expected" : t.timezone != null && t.hasOwnProperty("timezone") && !$util.isString(t.timezone) ? "timezone: string expected" : t.headless != null && t.hasOwnProperty("headless") && typeof t.headless != "boolean" ? "headless: boolean expected" : t.isFragmentRun != null && t.hasOwnProperty("isFragmentRun") && typeof t.isFragmentRun != "boolean" ? "isFragmentRun: boolean expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.PageProfile) return t;
    let g = new $root.PageProfile();
    if (t.commands) {
      if (!Array.isArray(t.commands)) throw TypeError(".PageProfile.commands: array expected");
      g.commands = [];
      for (let d = 0; d < t.commands.length; ++d) {
        if (typeof t.commands[d] != "object") throw TypeError(".PageProfile.commands: object expected");
        g.commands[d] = $root.Command.fromObject(t.commands[d]);
      }
    }
    if (t.execTime != null && ($util.Long ? (g.execTime = $util.Long.fromValue(t.execTime)).unsigned = !1 : typeof t.execTime == "string" ? g.execTime = parseInt(t.execTime, 10) : typeof t.execTime == "number" ? g.execTime = t.execTime : typeof t.execTime == "object" && (g.execTime = new $util.LongBits(t.execTime.low >>> 0, t.execTime.high >>> 0).toNumber())), t.prepTime != null && ($util.Long ? (g.prepTime = $util.Long.fromValue(t.prepTime)).unsigned = !1 : typeof t.prepTime == "string" ? g.prepTime = parseInt(t.prepTime, 10) : typeof t.prepTime == "number" ? g.prepTime = t.prepTime : typeof t.prepTime == "object" && (g.prepTime = new $util.LongBits(t.prepTime.low >>> 0, t.prepTime.high >>> 0).toNumber())), t.config) {
      if (!Array.isArray(t.config)) throw TypeError(".PageProfile.config: array expected");
      g.config = [];
      for (let d = 0; d < t.config.length; ++d) g.config[d] = String(t.config[d]);
    }
    if (t.uncaughtException != null && (g.uncaughtException = String(t.uncaughtException)), t.attributions) {
      if (!Array.isArray(t.attributions)) throw TypeError(".PageProfile.attributions: array expected");
      g.attributions = [];
      for (let d = 0; d < t.attributions.length; ++d) g.attributions[d] = String(t.attributions[d]);
    }
    return t.os != null && (g.os = String(t.os)), t.timezone != null && (g.timezone = String(t.timezone)), t.headless != null && (g.headless = !!t.headless), t.isFragmentRun != null && (g.isFragmentRun = !!t.isFragmentRun), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.commands = [], d.config = [], d.attributions = []), g.defaults) {
      if ($util.Long) {
        let k = new $util.Long(0, 0, !1);
        d.execTime = g.longs === String ? k.toString() : g.longs === Number ? k.toNumber() : k;
      } else d.execTime = g.longs === String ? "0" : 0;
      if ($util.Long) {
        let k = new $util.Long(0, 0, !1);
        d.prepTime = g.longs === String ? k.toString() : g.longs === Number ? k.toNumber() : k;
      } else d.prepTime = g.longs === String ? "0" : 0;
      d.uncaughtException = "", d.os = "", d.timezone = "", d.headless = !1, d.isFragmentRun = !1;
    }
    if (t.commands && t.commands.length) {
      d.commands = [];
      for (let k = 0; k < t.commands.length; ++k) d.commands[k] = $root.Command.toObject(t.commands[k], g);
    }
    if (t.execTime != null && t.hasOwnProperty("execTime") && (typeof t.execTime == "number" ? d.execTime = g.longs === String ? String(t.execTime) : t.execTime : d.execTime = g.longs === String ? $util.Long.prototype.toString.call(t.execTime) : g.longs === Number ? new $util.LongBits(t.execTime.low >>> 0, t.execTime.high >>> 0).toNumber() : t.execTime), t.prepTime != null && t.hasOwnProperty("prepTime") && (typeof t.prepTime == "number" ? d.prepTime = g.longs === String ? String(t.prepTime) : t.prepTime : d.prepTime = g.longs === String ? $util.Long.prototype.toString.call(t.prepTime) : g.longs === Number ? new $util.LongBits(t.prepTime.low >>> 0, t.prepTime.high >>> 0).toNumber() : t.prepTime), t.config && t.config.length) {
      d.config = [];
      for (let k = 0; k < t.config.length; ++k) d.config[k] = t.config[k];
    }
    if (t.uncaughtException != null && t.hasOwnProperty("uncaughtException") && (d.uncaughtException = t.uncaughtException), t.attributions && t.attributions.length) {
      d.attributions = [];
      for (let k = 0; k < t.attributions.length; ++k) d.attributions[k] = t.attributions[k];
    }
    return t.os != null && t.hasOwnProperty("os") && (d.os = t.os), t.timezone != null && t.hasOwnProperty("timezone") && (d.timezone = t.timezone), t.headless != null && t.hasOwnProperty("headless") && (d.headless = t.headless), t.isFragmentRun != null && t.hasOwnProperty("isFragmentRun") && (d.isFragmentRun = t.isFragmentRun), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/PageProfile";
  }, n;
})();
$root.Argument = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.k = "", n.prototype.t = "", n.prototype.m = "", n.prototype.p = 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.k != null && Object.hasOwnProperty.call(t, "k") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.k), t.t != null && Object.hasOwnProperty.call(t, "t") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.t), t.m != null && Object.hasOwnProperty.call(t, "m") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.m), t.p != null && Object.hasOwnProperty.call(t, "p") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(t.p), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Argument();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.k = t.string();
          break;
        }
        case 2: {
          H.t = t.string();
          break;
        }
        case 3: {
          H.m = t.string();
          break;
        }
        case 5: {
          H.p = t.int32();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.k != null && t.hasOwnProperty("k") && !$util.isString(t.k) ? "k: string expected" : t.t != null && t.hasOwnProperty("t") && !$util.isString(t.t) ? "t: string expected" : t.m != null && t.hasOwnProperty("m") && !$util.isString(t.m) ? "m: string expected" : t.p != null && t.hasOwnProperty("p") && !$util.isInteger(t.p) ? "p: integer expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Argument) return t;
    let g = new $root.Argument();
    return t.k != null && (g.k = String(t.k)), t.t != null && (g.t = String(t.t)), t.m != null && (g.m = String(t.m)), t.p != null && (g.p = t.p | 0), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.k = "", d.t = "", d.m = "", d.p = 0), t.k != null && t.hasOwnProperty("k") && (d.k = t.k), t.t != null && t.hasOwnProperty("t") && (d.t = t.t), t.m != null && t.hasOwnProperty("m") && (d.m = t.m), t.p != null && t.hasOwnProperty("p") && (d.p = t.p), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Argument";
  }, n;
})();
$root.Command = (() => {
  function n(t) {
    if (this.args = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.name = "", n.prototype.args = $util.emptyArray, n.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.name != null && Object.hasOwnProperty.call(t, "name") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.name), t.args != null && t.args.length) for (let d = 0; d < t.args.length; ++d) $root.Argument.encode(t.args[d], g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return t.time != null && Object.hasOwnProperty.call(t, "time") && g.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int64(t.time), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.Command();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.name = t.string();
          break;
        }
        case 2: {
          H.args && H.args.length || (H.args = []), H.args.push($root.Argument.decode(t, t.uint32()));
          break;
        }
        case 4: {
          H.time = t.int64();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name)) return "name: string expected";
    if (t.args != null && t.hasOwnProperty("args")) {
      if (!Array.isArray(t.args)) return "args: array expected";
      for (let g = 0; g < t.args.length; ++g) {
        let d = $root.Argument.verify(t.args[g]);
        if (d) return "args." + d;
      }
    }
    return t.time != null && t.hasOwnProperty("time") && !$util.isInteger(t.time) && !(t.time && $util.isInteger(t.time.low) && $util.isInteger(t.time.high)) ? "time: integer|Long expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.Command) return t;
    let g = new $root.Command();
    if (t.name != null && (g.name = String(t.name)), t.args) {
      if (!Array.isArray(t.args)) throw TypeError(".Command.args: array expected");
      g.args = [];
      for (let d = 0; d < t.args.length; ++d) {
        if (typeof t.args[d] != "object") throw TypeError(".Command.args: object expected");
        g.args[d] = $root.Argument.fromObject(t.args[d]);
      }
    }
    return t.time != null && ($util.Long ? (g.time = $util.Long.fromValue(t.time)).unsigned = !1 : typeof t.time == "string" ? g.time = parseInt(t.time, 10) : typeof t.time == "number" ? g.time = t.time : typeof t.time == "object" && (g.time = new $util.LongBits(t.time.low >>> 0, t.time.high >>> 0).toNumber())), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.args = []), g.defaults) if (d.name = "", $util.Long) {
      let k = new $util.Long(0, 0, !1);
      d.time = g.longs === String ? k.toString() : g.longs === Number ? k.toNumber() : k;
    } else d.time = g.longs === String ? "0" : 0;
    if (t.name != null && t.hasOwnProperty("name") && (d.name = t.name), t.args && t.args.length) {
      d.args = [];
      for (let k = 0; k < t.args.length; ++k) d.args[k] = $root.Argument.toObject(t.args[k], g);
    }
    return t.time != null && t.hasOwnProperty("time") && (typeof t.time == "number" ? d.time = g.longs === String ? String(t.time) : t.time : d.time = g.longs === String ? $util.Long.prototype.toString.call(t.time) : g.longs === Number ? new $util.LongBits(t.time.low >>> 0, t.time.high >>> 0).toNumber() : t.time), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Command";
  }, n;
})();
$root.PageNotFound = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.pageName = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.pageName != null && Object.hasOwnProperty.call(t, "pageName") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.pageName), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.PageNotFound();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.pageName = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.pageName != null && t.hasOwnProperty("pageName") && !$util.isString(t.pageName) ? "pageName: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.PageNotFound) return t;
    let g = new $root.PageNotFound();
    return t.pageName != null && (g.pageName = String(t.pageName)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.pageName = ""), t.pageName != null && t.hasOwnProperty("pageName") && (d.pageName = t.pageName), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/PageNotFound";
  }, n;
})();
$root.PagesChanged = (() => {
  function n(t) {
    if (this.appPages = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.appPages = $util.emptyArray, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.appPages != null && t.appPages.length) for (let d = 0; d < t.appPages.length; ++d) $root.AppPage.encode(t.appPages[d], g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.PagesChanged();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.appPages && H.appPages.length || (H.appPages = []), H.appPages.push($root.AppPage.decode(t, t.uint32()));
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.appPages != null && t.hasOwnProperty("appPages")) {
      if (!Array.isArray(t.appPages)) return "appPages: array expected";
      for (let g = 0; g < t.appPages.length; ++g) {
        let d = $root.AppPage.verify(t.appPages[g]);
        if (d) return "appPages." + d;
      }
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.PagesChanged) return t;
    let g = new $root.PagesChanged();
    if (t.appPages) {
      if (!Array.isArray(t.appPages)) throw TypeError(".PagesChanged.appPages: array expected");
      g.appPages = [];
      for (let d = 0; d < t.appPages.length; ++d) {
        if (typeof t.appPages[d] != "object") throw TypeError(".PagesChanged.appPages: object expected");
        g.appPages[d] = $root.AppPage.fromObject(t.appPages[d]);
      }
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.appPages = []), t.appPages && t.appPages.length) {
      d.appPages = [];
      for (let k = 0; k < t.appPages.length; ++k) d.appPages[k] = $root.AppPage.toObject(t.appPages[k], g);
    }
    return d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/PagesChanged";
  }, n;
})();
$root.ParentMessage = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.message = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.message != null && Object.hasOwnProperty.call(t, "message") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.message), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.ParentMessage();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.message = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.message != null && t.hasOwnProperty("message") && !$util.isString(t.message) ? "message: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.ParentMessage) return t;
    let g = new $root.ParentMessage();
    return t.message != null && (g.message = String(t.message)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.message = ""), t.message != null && t.hasOwnProperty("message") && (d.message = t.message), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ParentMessage";
  }, n;
})();
$root.SessionEvent = (() => {
  function n(g) {
    if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
  }
  n.prototype.scriptChangedOnDisk = null, n.prototype.scriptWasManuallyStopped = null, n.prototype.scriptCompilationException = null;
  let t;
  return Object.defineProperty(n.prototype, "type", { get: $util.oneOfGetter(t = ["scriptChangedOnDisk", "scriptWasManuallyStopped", "scriptCompilationException"]), set: $util.oneOfSetter(t) }), n.create = function(g) {
    return new n(g);
  }, n.encode = function(g, d) {
    return d || (d = $Writer.create()), g.scriptChangedOnDisk != null && Object.hasOwnProperty.call(g, "scriptChangedOnDisk") && d.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(g.scriptChangedOnDisk), g.scriptWasManuallyStopped != null && Object.hasOwnProperty.call(g, "scriptWasManuallyStopped") && d.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(g.scriptWasManuallyStopped), g.scriptCompilationException != null && Object.hasOwnProperty.call(g, "scriptCompilationException") && $root.Exception.encode(g.scriptCompilationException, d.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), d;
  }, n.encodeDelimited = function(g, d) {
    return this.encode(g, d).ldelim();
  }, n.decode = function(g, d, k) {
    g instanceof $Reader || (g = $Reader.create(g));
    let H = d === void 0 ? g.len : g.pos + d, AA = new $root.SessionEvent();
    for (; g.pos < H; ) {
      let gA = g.uint32();
      if (gA === k) break;
      switch (gA >>> 3) {
        case 1: {
          AA.scriptChangedOnDisk = g.bool();
          break;
        }
        case 2: {
          AA.scriptWasManuallyStopped = g.bool();
          break;
        }
        case 3: {
          AA.scriptCompilationException = $root.Exception.decode(g, g.uint32());
          break;
        }
        default:
          g.skipType(gA & 7);
          break;
      }
    }
    return AA;
  }, n.decodeDelimited = function(g) {
    return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
  }, n.verify = function(g) {
    if (typeof g != "object" || g === null) return "object expected";
    let d = {};
    if (g.scriptChangedOnDisk != null && g.hasOwnProperty("scriptChangedOnDisk") && (d.type = 1, typeof g.scriptChangedOnDisk != "boolean")) return "scriptChangedOnDisk: boolean expected";
    if (g.scriptWasManuallyStopped != null && g.hasOwnProperty("scriptWasManuallyStopped")) {
      if (d.type === 1) return "type: multiple values";
      if (d.type = 1, typeof g.scriptWasManuallyStopped != "boolean") return "scriptWasManuallyStopped: boolean expected";
    }
    if (g.scriptCompilationException != null && g.hasOwnProperty("scriptCompilationException")) {
      if (d.type === 1) return "type: multiple values";
      d.type = 1;
      {
        let k = $root.Exception.verify(g.scriptCompilationException);
        if (k) return "scriptCompilationException." + k;
      }
    }
    return null;
  }, n.fromObject = function(g) {
    if (g instanceof $root.SessionEvent) return g;
    let d = new $root.SessionEvent();
    if (g.scriptChangedOnDisk != null && (d.scriptChangedOnDisk = !!g.scriptChangedOnDisk), g.scriptWasManuallyStopped != null && (d.scriptWasManuallyStopped = !!g.scriptWasManuallyStopped), g.scriptCompilationException != null) {
      if (typeof g.scriptCompilationException != "object") throw TypeError(".SessionEvent.scriptCompilationException: object expected");
      d.scriptCompilationException = $root.Exception.fromObject(g.scriptCompilationException);
    }
    return d;
  }, n.toObject = function(g, d) {
    d || (d = {});
    let k = {};
    return g.scriptChangedOnDisk != null && g.hasOwnProperty("scriptChangedOnDisk") && (k.scriptChangedOnDisk = g.scriptChangedOnDisk, d.oneofs && (k.type = "scriptChangedOnDisk")), g.scriptWasManuallyStopped != null && g.hasOwnProperty("scriptWasManuallyStopped") && (k.scriptWasManuallyStopped = g.scriptWasManuallyStopped, d.oneofs && (k.type = "scriptWasManuallyStopped")), g.scriptCompilationException != null && g.hasOwnProperty("scriptCompilationException") && (k.scriptCompilationException = $root.Exception.toObject(g.scriptCompilationException, d), d.oneofs && (k.type = "scriptCompilationException")), k;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(g) {
    return g === void 0 && (g = "type.googleapis.com"), g + "/SessionEvent";
  }, n;
})();
$root.MetricsEvent = (() => {
  function n(t) {
    if (this.commands = [], this.config = [], this.attributions = [], t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.event = "", n.prototype.anonymousId = "", n.prototype.machineIdV3 = "", n.prototype.machineIdV4 = "", n.prototype.reportHash = "", n.prototype.dev = !1, n.prototype.source = "", n.prototype.streamlitVersion = "", n.prototype.isHello = !1, n.prototype.appId = "", n.prototype.sessionId = "", n.prototype.pythonVersion = "", n.prototype.serverOs = "", n.prototype.hasDisplay = !1, n.prototype.isWebdriver = !1, n.prototype.hostedAt = "", n.prototype.owner = "", n.prototype.repo = "", n.prototype.branch = "", n.prototype.mainModule = "", n.prototype.creatorId = "", n.prototype.contextPageUrl = "", n.prototype.contextPageTitle = "", n.prototype.contextPagePath = "", n.prototype.contextPageReferrer = "", n.prototype.contextPageSearch = "", n.prototype.contextLocale = "", n.prototype.contextUserAgent = "", n.prototype.label = "", n.prototype.commands = $util.emptyArray, n.prototype.execTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, n.prototype.prepTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, n.prototype.config = $util.emptyArray, n.prototype.uncaughtException = "", n.prototype.attributions = $util.emptyArray, n.prototype.os = "", n.prototype.timezone = "", n.prototype.headless = !1, n.prototype.isFragmentRun = !1, n.prototype.numPages = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, n.prototype.pageScriptHash = "", n.prototype.activeTheme = "", n.prototype.totalLoadTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, n.prototype.browserInfo = null, n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    if (g || (g = $Writer.create()), t.event != null && Object.hasOwnProperty.call(t, "event") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.event), t.anonymousId != null && Object.hasOwnProperty.call(t, "anonymousId") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.anonymousId), t.machineIdV3 != null && Object.hasOwnProperty.call(t, "machineIdV3") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.machineIdV3), t.reportHash != null && Object.hasOwnProperty.call(t, "reportHash") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.reportHash), t.dev != null && Object.hasOwnProperty.call(t, "dev") && g.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.dev), t.source != null && Object.hasOwnProperty.call(t, "source") && g.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.source), t.streamlitVersion != null && Object.hasOwnProperty.call(t, "streamlitVersion") && g.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.streamlitVersion), t.isHello != null && Object.hasOwnProperty.call(t, "isHello") && g.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.isHello), t.hostedAt != null && Object.hasOwnProperty.call(t, "hostedAt") && g.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(t.hostedAt), t.owner != null && Object.hasOwnProperty.call(t, "owner") && g.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(t.owner), t.repo != null && Object.hasOwnProperty.call(t, "repo") && g.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(t.repo), t.branch != null && Object.hasOwnProperty.call(t, "branch") && g.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(t.branch), t.mainModule != null && Object.hasOwnProperty.call(t, "mainModule") && g.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(t.mainModule), t.creatorId != null && Object.hasOwnProperty.call(t, "creatorId") && g.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(t.creatorId), t.contextPageUrl != null && Object.hasOwnProperty.call(t, "contextPageUrl") && g.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(t.contextPageUrl), t.contextPageTitle != null && Object.hasOwnProperty.call(t, "contextPageTitle") && g.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(t.contextPageTitle), t.contextPagePath != null && Object.hasOwnProperty.call(t, "contextPagePath") && g.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(t.contextPagePath), t.contextPageReferrer != null && Object.hasOwnProperty.call(t, "contextPageReferrer") && g.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(t.contextPageReferrer), t.contextPageSearch != null && Object.hasOwnProperty.call(t, "contextPageSearch") && g.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(t.contextPageSearch), t.contextLocale != null && Object.hasOwnProperty.call(t, "contextLocale") && g.uint32(
      /* id 20, wireType 2 =*/
      162
    ).string(t.contextLocale), t.contextUserAgent != null && Object.hasOwnProperty.call(t, "contextUserAgent") && g.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(t.contextUserAgent), t.label != null && Object.hasOwnProperty.call(t, "label") && g.uint32(
      /* id 22, wireType 2 =*/
      178
    ).string(t.label), t.commands != null && t.commands.length) for (let d = 0; d < t.commands.length; ++d) $root.Command.encode(t.commands[d], g.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim();
    if (t.execTime != null && Object.hasOwnProperty.call(t, "execTime") && g.uint32(
      /* id 24, wireType 0 =*/
      192
    ).int64(t.execTime), t.prepTime != null && Object.hasOwnProperty.call(t, "prepTime") && g.uint32(
      /* id 25, wireType 0 =*/
      200
    ).int64(t.prepTime), t.config != null && t.config.length) for (let d = 0; d < t.config.length; ++d) g.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(t.config[d]);
    if (t.uncaughtException != null && Object.hasOwnProperty.call(t, "uncaughtException") && g.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(t.uncaughtException), t.attributions != null && t.attributions.length) for (let d = 0; d < t.attributions.length; ++d) g.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(t.attributions[d]);
    return t.os != null && Object.hasOwnProperty.call(t, "os") && g.uint32(
      /* id 29, wireType 2 =*/
      234
    ).string(t.os), t.timezone != null && Object.hasOwnProperty.call(t, "timezone") && g.uint32(
      /* id 30, wireType 2 =*/
      242
    ).string(t.timezone), t.headless != null && Object.hasOwnProperty.call(t, "headless") && g.uint32(
      /* id 31, wireType 0 =*/
      248
    ).bool(t.headless), t.isFragmentRun != null && Object.hasOwnProperty.call(t, "isFragmentRun") && g.uint32(
      /* id 32, wireType 0 =*/
      256
    ).bool(t.isFragmentRun), t.appId != null && Object.hasOwnProperty.call(t, "appId") && g.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(t.appId), t.numPages != null && Object.hasOwnProperty.call(t, "numPages") && g.uint32(
      /* id 34, wireType 0 =*/
      272
    ).int64(t.numPages), t.sessionId != null && Object.hasOwnProperty.call(t, "sessionId") && g.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(t.sessionId), t.pythonVersion != null && Object.hasOwnProperty.call(t, "pythonVersion") && g.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(t.pythonVersion), t.pageScriptHash != null && Object.hasOwnProperty.call(t, "pageScriptHash") && g.uint32(
      /* id 37, wireType 2 =*/
      298
    ).string(t.pageScriptHash), t.activeTheme != null && Object.hasOwnProperty.call(t, "activeTheme") && g.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(t.activeTheme), t.totalLoadTime != null && Object.hasOwnProperty.call(t, "totalLoadTime") && g.uint32(
      /* id 39, wireType 0 =*/
      312
    ).int64(t.totalLoadTime), t.browserInfo != null && Object.hasOwnProperty.call(t, "browserInfo") && $root.BrowserInfo.encode(t.browserInfo, g.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), t.machineIdV4 != null && Object.hasOwnProperty.call(t, "machineIdV4") && g.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(t.machineIdV4), t.serverOs != null && Object.hasOwnProperty.call(t, "serverOs") && g.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(t.serverOs), t.hasDisplay != null && Object.hasOwnProperty.call(t, "hasDisplay") && g.uint32(
      /* id 43, wireType 0 =*/
      344
    ).bool(t.hasDisplay), t.isWebdriver != null && Object.hasOwnProperty.call(t, "isWebdriver") && g.uint32(
      /* id 44, wireType 0 =*/
      352
    ).bool(t.isWebdriver), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.MetricsEvent();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.event = t.string();
          break;
        }
        case 2: {
          H.anonymousId = t.string();
          break;
        }
        case 3: {
          H.machineIdV3 = t.string();
          break;
        }
        case 41: {
          H.machineIdV4 = t.string();
          break;
        }
        case 4: {
          H.reportHash = t.string();
          break;
        }
        case 5: {
          H.dev = t.bool();
          break;
        }
        case 6: {
          H.source = t.string();
          break;
        }
        case 7: {
          H.streamlitVersion = t.string();
          break;
        }
        case 8: {
          H.isHello = t.bool();
          break;
        }
        case 33: {
          H.appId = t.string();
          break;
        }
        case 35: {
          H.sessionId = t.string();
          break;
        }
        case 36: {
          H.pythonVersion = t.string();
          break;
        }
        case 42: {
          H.serverOs = t.string();
          break;
        }
        case 43: {
          H.hasDisplay = t.bool();
          break;
        }
        case 44: {
          H.isWebdriver = t.bool();
          break;
        }
        case 9: {
          H.hostedAt = t.string();
          break;
        }
        case 10: {
          H.owner = t.string();
          break;
        }
        case 11: {
          H.repo = t.string();
          break;
        }
        case 12: {
          H.branch = t.string();
          break;
        }
        case 13: {
          H.mainModule = t.string();
          break;
        }
        case 14: {
          H.creatorId = t.string();
          break;
        }
        case 15: {
          H.contextPageUrl = t.string();
          break;
        }
        case 16: {
          H.contextPageTitle = t.string();
          break;
        }
        case 17: {
          H.contextPagePath = t.string();
          break;
        }
        case 18: {
          H.contextPageReferrer = t.string();
          break;
        }
        case 19: {
          H.contextPageSearch = t.string();
          break;
        }
        case 20: {
          H.contextLocale = t.string();
          break;
        }
        case 21: {
          H.contextUserAgent = t.string();
          break;
        }
        case 22: {
          H.label = t.string();
          break;
        }
        case 23: {
          H.commands && H.commands.length || (H.commands = []), H.commands.push($root.Command.decode(t, t.uint32()));
          break;
        }
        case 24: {
          H.execTime = t.int64();
          break;
        }
        case 25: {
          H.prepTime = t.int64();
          break;
        }
        case 26: {
          H.config && H.config.length || (H.config = []), H.config.push(t.string());
          break;
        }
        case 27: {
          H.uncaughtException = t.string();
          break;
        }
        case 28: {
          H.attributions && H.attributions.length || (H.attributions = []), H.attributions.push(t.string());
          break;
        }
        case 29: {
          H.os = t.string();
          break;
        }
        case 30: {
          H.timezone = t.string();
          break;
        }
        case 31: {
          H.headless = t.bool();
          break;
        }
        case 32: {
          H.isFragmentRun = t.bool();
          break;
        }
        case 34: {
          H.numPages = t.int64();
          break;
        }
        case 37: {
          H.pageScriptHash = t.string();
          break;
        }
        case 38: {
          H.activeTheme = t.string();
          break;
        }
        case 39: {
          H.totalLoadTime = t.int64();
          break;
        }
        case 40: {
          H.browserInfo = $root.BrowserInfo.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    if (typeof t != "object" || t === null) return "object expected";
    if (t.event != null && t.hasOwnProperty("event") && !$util.isString(t.event)) return "event: string expected";
    if (t.anonymousId != null && t.hasOwnProperty("anonymousId") && !$util.isString(t.anonymousId)) return "anonymousId: string expected";
    if (t.machineIdV3 != null && t.hasOwnProperty("machineIdV3") && !$util.isString(t.machineIdV3)) return "machineIdV3: string expected";
    if (t.machineIdV4 != null && t.hasOwnProperty("machineIdV4") && !$util.isString(t.machineIdV4)) return "machineIdV4: string expected";
    if (t.reportHash != null && t.hasOwnProperty("reportHash") && !$util.isString(t.reportHash)) return "reportHash: string expected";
    if (t.dev != null && t.hasOwnProperty("dev") && typeof t.dev != "boolean") return "dev: boolean expected";
    if (t.source != null && t.hasOwnProperty("source") && !$util.isString(t.source)) return "source: string expected";
    if (t.streamlitVersion != null && t.hasOwnProperty("streamlitVersion") && !$util.isString(t.streamlitVersion)) return "streamlitVersion: string expected";
    if (t.isHello != null && t.hasOwnProperty("isHello") && typeof t.isHello != "boolean") return "isHello: boolean expected";
    if (t.appId != null && t.hasOwnProperty("appId") && !$util.isString(t.appId)) return "appId: string expected";
    if (t.sessionId != null && t.hasOwnProperty("sessionId") && !$util.isString(t.sessionId)) return "sessionId: string expected";
    if (t.pythonVersion != null && t.hasOwnProperty("pythonVersion") && !$util.isString(t.pythonVersion)) return "pythonVersion: string expected";
    if (t.serverOs != null && t.hasOwnProperty("serverOs") && !$util.isString(t.serverOs)) return "serverOs: string expected";
    if (t.hasDisplay != null && t.hasOwnProperty("hasDisplay") && typeof t.hasDisplay != "boolean") return "hasDisplay: boolean expected";
    if (t.isWebdriver != null && t.hasOwnProperty("isWebdriver") && typeof t.isWebdriver != "boolean") return "isWebdriver: boolean expected";
    if (t.hostedAt != null && t.hasOwnProperty("hostedAt") && !$util.isString(t.hostedAt)) return "hostedAt: string expected";
    if (t.owner != null && t.hasOwnProperty("owner") && !$util.isString(t.owner)) return "owner: string expected";
    if (t.repo != null && t.hasOwnProperty("repo") && !$util.isString(t.repo)) return "repo: string expected";
    if (t.branch != null && t.hasOwnProperty("branch") && !$util.isString(t.branch)) return "branch: string expected";
    if (t.mainModule != null && t.hasOwnProperty("mainModule") && !$util.isString(t.mainModule)) return "mainModule: string expected";
    if (t.creatorId != null && t.hasOwnProperty("creatorId") && !$util.isString(t.creatorId)) return "creatorId: string expected";
    if (t.contextPageUrl != null && t.hasOwnProperty("contextPageUrl") && !$util.isString(t.contextPageUrl)) return "contextPageUrl: string expected";
    if (t.contextPageTitle != null && t.hasOwnProperty("contextPageTitle") && !$util.isString(t.contextPageTitle)) return "contextPageTitle: string expected";
    if (t.contextPagePath != null && t.hasOwnProperty("contextPagePath") && !$util.isString(t.contextPagePath)) return "contextPagePath: string expected";
    if (t.contextPageReferrer != null && t.hasOwnProperty("contextPageReferrer") && !$util.isString(t.contextPageReferrer)) return "contextPageReferrer: string expected";
    if (t.contextPageSearch != null && t.hasOwnProperty("contextPageSearch") && !$util.isString(t.contextPageSearch)) return "contextPageSearch: string expected";
    if (t.contextLocale != null && t.hasOwnProperty("contextLocale") && !$util.isString(t.contextLocale)) return "contextLocale: string expected";
    if (t.contextUserAgent != null && t.hasOwnProperty("contextUserAgent") && !$util.isString(t.contextUserAgent)) return "contextUserAgent: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label)) return "label: string expected";
    if (t.commands != null && t.hasOwnProperty("commands")) {
      if (!Array.isArray(t.commands)) return "commands: array expected";
      for (let g = 0; g < t.commands.length; ++g) {
        let d = $root.Command.verify(t.commands[g]);
        if (d) return "commands." + d;
      }
    }
    if (t.execTime != null && t.hasOwnProperty("execTime") && !$util.isInteger(t.execTime) && !(t.execTime && $util.isInteger(t.execTime.low) && $util.isInteger(t.execTime.high))) return "execTime: integer|Long expected";
    if (t.prepTime != null && t.hasOwnProperty("prepTime") && !$util.isInteger(t.prepTime) && !(t.prepTime && $util.isInteger(t.prepTime.low) && $util.isInteger(t.prepTime.high))) return "prepTime: integer|Long expected";
    if (t.config != null && t.hasOwnProperty("config")) {
      if (!Array.isArray(t.config)) return "config: array expected";
      for (let g = 0; g < t.config.length; ++g) if (!$util.isString(t.config[g])) return "config: string[] expected";
    }
    if (t.uncaughtException != null && t.hasOwnProperty("uncaughtException") && !$util.isString(t.uncaughtException)) return "uncaughtException: string expected";
    if (t.attributions != null && t.hasOwnProperty("attributions")) {
      if (!Array.isArray(t.attributions)) return "attributions: array expected";
      for (let g = 0; g < t.attributions.length; ++g) if (!$util.isString(t.attributions[g])) return "attributions: string[] expected";
    }
    if (t.os != null && t.hasOwnProperty("os") && !$util.isString(t.os)) return "os: string expected";
    if (t.timezone != null && t.hasOwnProperty("timezone") && !$util.isString(t.timezone)) return "timezone: string expected";
    if (t.headless != null && t.hasOwnProperty("headless") && typeof t.headless != "boolean") return "headless: boolean expected";
    if (t.isFragmentRun != null && t.hasOwnProperty("isFragmentRun") && typeof t.isFragmentRun != "boolean") return "isFragmentRun: boolean expected";
    if (t.numPages != null && t.hasOwnProperty("numPages") && !$util.isInteger(t.numPages) && !(t.numPages && $util.isInteger(t.numPages.low) && $util.isInteger(t.numPages.high))) return "numPages: integer|Long expected";
    if (t.pageScriptHash != null && t.hasOwnProperty("pageScriptHash") && !$util.isString(t.pageScriptHash)) return "pageScriptHash: string expected";
    if (t.activeTheme != null && t.hasOwnProperty("activeTheme") && !$util.isString(t.activeTheme)) return "activeTheme: string expected";
    if (t.totalLoadTime != null && t.hasOwnProperty("totalLoadTime") && !$util.isInteger(t.totalLoadTime) && !(t.totalLoadTime && $util.isInteger(t.totalLoadTime.low) && $util.isInteger(t.totalLoadTime.high))) return "totalLoadTime: integer|Long expected";
    if (t.browserInfo != null && t.hasOwnProperty("browserInfo")) {
      let g = $root.BrowserInfo.verify(t.browserInfo);
      if (g) return "browserInfo." + g;
    }
    return null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.MetricsEvent) return t;
    let g = new $root.MetricsEvent();
    if (t.event != null && (g.event = String(t.event)), t.anonymousId != null && (g.anonymousId = String(t.anonymousId)), t.machineIdV3 != null && (g.machineIdV3 = String(t.machineIdV3)), t.machineIdV4 != null && (g.machineIdV4 = String(t.machineIdV4)), t.reportHash != null && (g.reportHash = String(t.reportHash)), t.dev != null && (g.dev = !!t.dev), t.source != null && (g.source = String(t.source)), t.streamlitVersion != null && (g.streamlitVersion = String(t.streamlitVersion)), t.isHello != null && (g.isHello = !!t.isHello), t.appId != null && (g.appId = String(t.appId)), t.sessionId != null && (g.sessionId = String(t.sessionId)), t.pythonVersion != null && (g.pythonVersion = String(t.pythonVersion)), t.serverOs != null && (g.serverOs = String(t.serverOs)), t.hasDisplay != null && (g.hasDisplay = !!t.hasDisplay), t.isWebdriver != null && (g.isWebdriver = !!t.isWebdriver), t.hostedAt != null && (g.hostedAt = String(t.hostedAt)), t.owner != null && (g.owner = String(t.owner)), t.repo != null && (g.repo = String(t.repo)), t.branch != null && (g.branch = String(t.branch)), t.mainModule != null && (g.mainModule = String(t.mainModule)), t.creatorId != null && (g.creatorId = String(t.creatorId)), t.contextPageUrl != null && (g.contextPageUrl = String(t.contextPageUrl)), t.contextPageTitle != null && (g.contextPageTitle = String(t.contextPageTitle)), t.contextPagePath != null && (g.contextPagePath = String(t.contextPagePath)), t.contextPageReferrer != null && (g.contextPageReferrer = String(t.contextPageReferrer)), t.contextPageSearch != null && (g.contextPageSearch = String(t.contextPageSearch)), t.contextLocale != null && (g.contextLocale = String(t.contextLocale)), t.contextUserAgent != null && (g.contextUserAgent = String(t.contextUserAgent)), t.label != null && (g.label = String(t.label)), t.commands) {
      if (!Array.isArray(t.commands)) throw TypeError(".MetricsEvent.commands: array expected");
      g.commands = [];
      for (let d = 0; d < t.commands.length; ++d) {
        if (typeof t.commands[d] != "object") throw TypeError(".MetricsEvent.commands: object expected");
        g.commands[d] = $root.Command.fromObject(t.commands[d]);
      }
    }
    if (t.execTime != null && ($util.Long ? (g.execTime = $util.Long.fromValue(t.execTime)).unsigned = !1 : typeof t.execTime == "string" ? g.execTime = parseInt(t.execTime, 10) : typeof t.execTime == "number" ? g.execTime = t.execTime : typeof t.execTime == "object" && (g.execTime = new $util.LongBits(t.execTime.low >>> 0, t.execTime.high >>> 0).toNumber())), t.prepTime != null && ($util.Long ? (g.prepTime = $util.Long.fromValue(t.prepTime)).unsigned = !1 : typeof t.prepTime == "string" ? g.prepTime = parseInt(t.prepTime, 10) : typeof t.prepTime == "number" ? g.prepTime = t.prepTime : typeof t.prepTime == "object" && (g.prepTime = new $util.LongBits(t.prepTime.low >>> 0, t.prepTime.high >>> 0).toNumber())), t.config) {
      if (!Array.isArray(t.config)) throw TypeError(".MetricsEvent.config: array expected");
      g.config = [];
      for (let d = 0; d < t.config.length; ++d) g.config[d] = String(t.config[d]);
    }
    if (t.uncaughtException != null && (g.uncaughtException = String(t.uncaughtException)), t.attributions) {
      if (!Array.isArray(t.attributions)) throw TypeError(".MetricsEvent.attributions: array expected");
      g.attributions = [];
      for (let d = 0; d < t.attributions.length; ++d) g.attributions[d] = String(t.attributions[d]);
    }
    if (t.os != null && (g.os = String(t.os)), t.timezone != null && (g.timezone = String(t.timezone)), t.headless != null && (g.headless = !!t.headless), t.isFragmentRun != null && (g.isFragmentRun = !!t.isFragmentRun), t.numPages != null && ($util.Long ? (g.numPages = $util.Long.fromValue(t.numPages)).unsigned = !1 : typeof t.numPages == "string" ? g.numPages = parseInt(t.numPages, 10) : typeof t.numPages == "number" ? g.numPages = t.numPages : typeof t.numPages == "object" && (g.numPages = new $util.LongBits(t.numPages.low >>> 0, t.numPages.high >>> 0).toNumber())), t.pageScriptHash != null && (g.pageScriptHash = String(t.pageScriptHash)), t.activeTheme != null && (g.activeTheme = String(t.activeTheme)), t.totalLoadTime != null && ($util.Long ? (g.totalLoadTime = $util.Long.fromValue(t.totalLoadTime)).unsigned = !1 : typeof t.totalLoadTime == "string" ? g.totalLoadTime = parseInt(t.totalLoadTime, 10) : typeof t.totalLoadTime == "number" ? g.totalLoadTime = t.totalLoadTime : typeof t.totalLoadTime == "object" && (g.totalLoadTime = new $util.LongBits(t.totalLoadTime.low >>> 0, t.totalLoadTime.high >>> 0).toNumber())), t.browserInfo != null) {
      if (typeof t.browserInfo != "object") throw TypeError(".MetricsEvent.browserInfo: object expected");
      g.browserInfo = $root.BrowserInfo.fromObject(t.browserInfo);
    }
    return g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    if ((g.arrays || g.defaults) && (d.commands = [], d.config = [], d.attributions = []), g.defaults) {
      if (d.event = "", d.anonymousId = "", d.machineIdV3 = "", d.reportHash = "", d.dev = !1, d.source = "", d.streamlitVersion = "", d.isHello = !1, d.hostedAt = "", d.owner = "", d.repo = "", d.branch = "", d.mainModule = "", d.creatorId = "", d.contextPageUrl = "", d.contextPageTitle = "", d.contextPagePath = "", d.contextPageReferrer = "", d.contextPageSearch = "", d.contextLocale = "", d.contextUserAgent = "", d.label = "", $util.Long) {
        let k = new $util.Long(0, 0, !1);
        d.execTime = g.longs === String ? k.toString() : g.longs === Number ? k.toNumber() : k;
      } else d.execTime = g.longs === String ? "0" : 0;
      if ($util.Long) {
        let k = new $util.Long(0, 0, !1);
        d.prepTime = g.longs === String ? k.toString() : g.longs === Number ? k.toNumber() : k;
      } else d.prepTime = g.longs === String ? "0" : 0;
      if (d.uncaughtException = "", d.os = "", d.timezone = "", d.headless = !1, d.isFragmentRun = !1, d.appId = "", $util.Long) {
        let k = new $util.Long(0, 0, !1);
        d.numPages = g.longs === String ? k.toString() : g.longs === Number ? k.toNumber() : k;
      } else d.numPages = g.longs === String ? "0" : 0;
      if (d.sessionId = "", d.pythonVersion = "", d.pageScriptHash = "", d.activeTheme = "", $util.Long) {
        let k = new $util.Long(0, 0, !1);
        d.totalLoadTime = g.longs === String ? k.toString() : g.longs === Number ? k.toNumber() : k;
      } else d.totalLoadTime = g.longs === String ? "0" : 0;
      d.browserInfo = null, d.machineIdV4 = "", d.serverOs = "", d.hasDisplay = !1, d.isWebdriver = !1;
    }
    if (t.event != null && t.hasOwnProperty("event") && (d.event = t.event), t.anonymousId != null && t.hasOwnProperty("anonymousId") && (d.anonymousId = t.anonymousId), t.machineIdV3 != null && t.hasOwnProperty("machineIdV3") && (d.machineIdV3 = t.machineIdV3), t.reportHash != null && t.hasOwnProperty("reportHash") && (d.reportHash = t.reportHash), t.dev != null && t.hasOwnProperty("dev") && (d.dev = t.dev), t.source != null && t.hasOwnProperty("source") && (d.source = t.source), t.streamlitVersion != null && t.hasOwnProperty("streamlitVersion") && (d.streamlitVersion = t.streamlitVersion), t.isHello != null && t.hasOwnProperty("isHello") && (d.isHello = t.isHello), t.hostedAt != null && t.hasOwnProperty("hostedAt") && (d.hostedAt = t.hostedAt), t.owner != null && t.hasOwnProperty("owner") && (d.owner = t.owner), t.repo != null && t.hasOwnProperty("repo") && (d.repo = t.repo), t.branch != null && t.hasOwnProperty("branch") && (d.branch = t.branch), t.mainModule != null && t.hasOwnProperty("mainModule") && (d.mainModule = t.mainModule), t.creatorId != null && t.hasOwnProperty("creatorId") && (d.creatorId = t.creatorId), t.contextPageUrl != null && t.hasOwnProperty("contextPageUrl") && (d.contextPageUrl = t.contextPageUrl), t.contextPageTitle != null && t.hasOwnProperty("contextPageTitle") && (d.contextPageTitle = t.contextPageTitle), t.contextPagePath != null && t.hasOwnProperty("contextPagePath") && (d.contextPagePath = t.contextPagePath), t.contextPageReferrer != null && t.hasOwnProperty("contextPageReferrer") && (d.contextPageReferrer = t.contextPageReferrer), t.contextPageSearch != null && t.hasOwnProperty("contextPageSearch") && (d.contextPageSearch = t.contextPageSearch), t.contextLocale != null && t.hasOwnProperty("contextLocale") && (d.contextLocale = t.contextLocale), t.contextUserAgent != null && t.hasOwnProperty("contextUserAgent") && (d.contextUserAgent = t.contextUserAgent), t.label != null && t.hasOwnProperty("label") && (d.label = t.label), t.commands && t.commands.length) {
      d.commands = [];
      for (let k = 0; k < t.commands.length; ++k) d.commands[k] = $root.Command.toObject(t.commands[k], g);
    }
    if (t.execTime != null && t.hasOwnProperty("execTime") && (typeof t.execTime == "number" ? d.execTime = g.longs === String ? String(t.execTime) : t.execTime : d.execTime = g.longs === String ? $util.Long.prototype.toString.call(t.execTime) : g.longs === Number ? new $util.LongBits(t.execTime.low >>> 0, t.execTime.high >>> 0).toNumber() : t.execTime), t.prepTime != null && t.hasOwnProperty("prepTime") && (typeof t.prepTime == "number" ? d.prepTime = g.longs === String ? String(t.prepTime) : t.prepTime : d.prepTime = g.longs === String ? $util.Long.prototype.toString.call(t.prepTime) : g.longs === Number ? new $util.LongBits(t.prepTime.low >>> 0, t.prepTime.high >>> 0).toNumber() : t.prepTime), t.config && t.config.length) {
      d.config = [];
      for (let k = 0; k < t.config.length; ++k) d.config[k] = t.config[k];
    }
    if (t.uncaughtException != null && t.hasOwnProperty("uncaughtException") && (d.uncaughtException = t.uncaughtException), t.attributions && t.attributions.length) {
      d.attributions = [];
      for (let k = 0; k < t.attributions.length; ++k) d.attributions[k] = t.attributions[k];
    }
    return t.os != null && t.hasOwnProperty("os") && (d.os = t.os), t.timezone != null && t.hasOwnProperty("timezone") && (d.timezone = t.timezone), t.headless != null && t.hasOwnProperty("headless") && (d.headless = t.headless), t.isFragmentRun != null && t.hasOwnProperty("isFragmentRun") && (d.isFragmentRun = t.isFragmentRun), t.appId != null && t.hasOwnProperty("appId") && (d.appId = t.appId), t.numPages != null && t.hasOwnProperty("numPages") && (typeof t.numPages == "number" ? d.numPages = g.longs === String ? String(t.numPages) : t.numPages : d.numPages = g.longs === String ? $util.Long.prototype.toString.call(t.numPages) : g.longs === Number ? new $util.LongBits(t.numPages.low >>> 0, t.numPages.high >>> 0).toNumber() : t.numPages), t.sessionId != null && t.hasOwnProperty("sessionId") && (d.sessionId = t.sessionId), t.pythonVersion != null && t.hasOwnProperty("pythonVersion") && (d.pythonVersion = t.pythonVersion), t.pageScriptHash != null && t.hasOwnProperty("pageScriptHash") && (d.pageScriptHash = t.pageScriptHash), t.activeTheme != null && t.hasOwnProperty("activeTheme") && (d.activeTheme = t.activeTheme), t.totalLoadTime != null && t.hasOwnProperty("totalLoadTime") && (typeof t.totalLoadTime == "number" ? d.totalLoadTime = g.longs === String ? String(t.totalLoadTime) : t.totalLoadTime : d.totalLoadTime = g.longs === String ? $util.Long.prototype.toString.call(t.totalLoadTime) : g.longs === Number ? new $util.LongBits(t.totalLoadTime.low >>> 0, t.totalLoadTime.high >>> 0).toNumber() : t.totalLoadTime), t.browserInfo != null && t.hasOwnProperty("browserInfo") && (d.browserInfo = $root.BrowserInfo.toObject(t.browserInfo, g)), t.machineIdV4 != null && t.hasOwnProperty("machineIdV4") && (d.machineIdV4 = t.machineIdV4), t.serverOs != null && t.hasOwnProperty("serverOs") && (d.serverOs = t.serverOs), t.hasDisplay != null && t.hasOwnProperty("hasDisplay") && (d.hasDisplay = t.hasDisplay), t.isWebdriver != null && t.hasOwnProperty("isWebdriver") && (d.isWebdriver = t.isWebdriver), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/MetricsEvent";
  }, n;
})();
$root.BrowserInfo = (() => {
  function n(t) {
    if (t) for (let g = Object.keys(t), d = 0; d < g.length; ++d) t[g[d]] != null && (this[g[d]] = t[g[d]]);
  }
  return n.prototype.browserName = "", n.prototype.browserVersion = "", n.prototype.deviceType = "", n.prototype.os = "", n.create = function(t) {
    return new n(t);
  }, n.encode = function(t, g) {
    return g || (g = $Writer.create()), t.browserName != null && Object.hasOwnProperty.call(t, "browserName") && g.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.browserName), t.browserVersion != null && Object.hasOwnProperty.call(t, "browserVersion") && g.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.browserVersion), t.deviceType != null && Object.hasOwnProperty.call(t, "deviceType") && g.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.deviceType), t.os != null && Object.hasOwnProperty.call(t, "os") && g.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.os), g;
  }, n.encodeDelimited = function(t, g) {
    return this.encode(t, g).ldelim();
  }, n.decode = function(t, g, d) {
    t instanceof $Reader || (t = $Reader.create(t));
    let k = g === void 0 ? t.len : t.pos + g, H = new $root.BrowserInfo();
    for (; t.pos < k; ) {
      let AA = t.uint32();
      if (AA === d) break;
      switch (AA >>> 3) {
        case 1: {
          H.browserName = t.string();
          break;
        }
        case 2: {
          H.browserVersion = t.string();
          break;
        }
        case 3: {
          H.deviceType = t.string();
          break;
        }
        case 4: {
          H.os = t.string();
          break;
        }
        default:
          t.skipType(AA & 7);
          break;
      }
    }
    return H;
  }, n.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, n.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.browserName != null && t.hasOwnProperty("browserName") && !$util.isString(t.browserName) ? "browserName: string expected" : t.browserVersion != null && t.hasOwnProperty("browserVersion") && !$util.isString(t.browserVersion) ? "browserVersion: string expected" : t.deviceType != null && t.hasOwnProperty("deviceType") && !$util.isString(t.deviceType) ? "deviceType: string expected" : t.os != null && t.hasOwnProperty("os") && !$util.isString(t.os) ? "os: string expected" : null;
  }, n.fromObject = function(t) {
    if (t instanceof $root.BrowserInfo) return t;
    let g = new $root.BrowserInfo();
    return t.browserName != null && (g.browserName = String(t.browserName)), t.browserVersion != null && (g.browserVersion = String(t.browserVersion)), t.deviceType != null && (g.deviceType = String(t.deviceType)), t.os != null && (g.os = String(t.os)), g;
  }, n.toObject = function(t, g) {
    g || (g = {});
    let d = {};
    return g.defaults && (d.browserName = "", d.browserVersion = "", d.deviceType = "", d.os = ""), t.browserName != null && t.hasOwnProperty("browserName") && (d.browserName = t.browserName), t.browserVersion != null && t.hasOwnProperty("browserVersion") && (d.browserVersion = t.browserVersion), t.deviceType != null && t.hasOwnProperty("deviceType") && (d.deviceType = t.deviceType), t.os != null && t.hasOwnProperty("os") && (d.os = t.os), d;
  }, n.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, n.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/BrowserInfo";
  }, n;
})();
$root.openmetrics = (() => {
  const n = {};
  return n.MetricSet = (function() {
    function t(g) {
      if (this.metricFamilies = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.metricFamilies = $util.emptyArray, t.create = function(g) {
      return new t(g);
    }, t.encode = function(g, d) {
      if (d || (d = $Writer.create()), g.metricFamilies != null && g.metricFamilies.length) for (let k = 0; k < g.metricFamilies.length; ++k) $root.openmetrics.MetricFamily.encode(g.metricFamilies[k], d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return d;
    }, t.encodeDelimited = function(g, d) {
      return this.encode(g, d).ldelim();
    }, t.decode = function(g, d, k) {
      g instanceof $Reader || (g = $Reader.create(g));
      let H = d === void 0 ? g.len : g.pos + d, AA = new $root.openmetrics.MetricSet();
      for (; g.pos < H; ) {
        let gA = g.uint32();
        if (gA === k) break;
        switch (gA >>> 3) {
          case 1: {
            AA.metricFamilies && AA.metricFamilies.length || (AA.metricFamilies = []), AA.metricFamilies.push($root.openmetrics.MetricFamily.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(gA & 7);
            break;
        }
      }
      return AA;
    }, t.decodeDelimited = function(g) {
      return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
    }, t.verify = function(g) {
      if (typeof g != "object" || g === null) return "object expected";
      if (g.metricFamilies != null && g.hasOwnProperty("metricFamilies")) {
        if (!Array.isArray(g.metricFamilies)) return "metricFamilies: array expected";
        for (let d = 0; d < g.metricFamilies.length; ++d) {
          let k = $root.openmetrics.MetricFamily.verify(g.metricFamilies[d]);
          if (k) return "metricFamilies." + k;
        }
      }
      return null;
    }, t.fromObject = function(g) {
      if (g instanceof $root.openmetrics.MetricSet) return g;
      let d = new $root.openmetrics.MetricSet();
      if (g.metricFamilies) {
        if (!Array.isArray(g.metricFamilies)) throw TypeError(".openmetrics.MetricSet.metricFamilies: array expected");
        d.metricFamilies = [];
        for (let k = 0; k < g.metricFamilies.length; ++k) {
          if (typeof g.metricFamilies[k] != "object") throw TypeError(".openmetrics.MetricSet.metricFamilies: object expected");
          d.metricFamilies[k] = $root.openmetrics.MetricFamily.fromObject(g.metricFamilies[k]);
        }
      }
      return d;
    }, t.toObject = function(g, d) {
      d || (d = {});
      let k = {};
      if ((d.arrays || d.defaults) && (k.metricFamilies = []), g.metricFamilies && g.metricFamilies.length) {
        k.metricFamilies = [];
        for (let H = 0; H < g.metricFamilies.length; ++H) k.metricFamilies[H] = $root.openmetrics.MetricFamily.toObject(g.metricFamilies[H], d);
      }
      return k;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.MetricSet";
    }, t;
  })(), n.MetricFamily = (function() {
    function t(g) {
      if (this.metrics = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.name = "", t.prototype.type = 0, t.prototype.unit = "", t.prototype.help = "", t.prototype.metrics = $util.emptyArray, t.create = function(g) {
      return new t(g);
    }, t.encode = function(g, d) {
      if (d || (d = $Writer.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.name), g.type != null && Object.hasOwnProperty.call(g, "type") && d.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(g.type), g.unit != null && Object.hasOwnProperty.call(g, "unit") && d.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(g.unit), g.help != null && Object.hasOwnProperty.call(g, "help") && d.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(g.help), g.metrics != null && g.metrics.length) for (let k = 0; k < g.metrics.length; ++k) $root.Metric.encode(g.metrics[k], d.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return d;
    }, t.encodeDelimited = function(g, d) {
      return this.encode(g, d).ldelim();
    }, t.decode = function(g, d, k) {
      g instanceof $Reader || (g = $Reader.create(g));
      let H = d === void 0 ? g.len : g.pos + d, AA = new $root.openmetrics.MetricFamily();
      for (; g.pos < H; ) {
        let gA = g.uint32();
        if (gA === k) break;
        switch (gA >>> 3) {
          case 1: {
            AA.name = g.string();
            break;
          }
          case 2: {
            AA.type = g.int32();
            break;
          }
          case 3: {
            AA.unit = g.string();
            break;
          }
          case 4: {
            AA.help = g.string();
            break;
          }
          case 5: {
            AA.metrics && AA.metrics.length || (AA.metrics = []), AA.metrics.push($root.Metric.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(gA & 7);
            break;
        }
      }
      return AA;
    }, t.decodeDelimited = function(g) {
      return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
    }, t.verify = function(g) {
      if (typeof g != "object" || g === null) return "object expected";
      if (g.name != null && g.hasOwnProperty("name") && !$util.isString(g.name)) return "name: string expected";
      if (g.type != null && g.hasOwnProperty("type")) switch (g.type) {
        default:
          return "type: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          break;
      }
      if (g.unit != null && g.hasOwnProperty("unit") && !$util.isString(g.unit)) return "unit: string expected";
      if (g.help != null && g.hasOwnProperty("help") && !$util.isString(g.help)) return "help: string expected";
      if (g.metrics != null && g.hasOwnProperty("metrics")) {
        if (!Array.isArray(g.metrics)) return "metrics: array expected";
        for (let d = 0; d < g.metrics.length; ++d) {
          let k = $root.Metric.verify(g.metrics[d]);
          if (k) return "metrics." + k;
        }
      }
      return null;
    }, t.fromObject = function(g) {
      if (g instanceof $root.openmetrics.MetricFamily) return g;
      let d = new $root.openmetrics.MetricFamily();
      switch (g.name != null && (d.name = String(g.name)), g.type) {
        default:
          if (typeof g.type == "number") {
            d.type = g.type;
            break;
          }
          break;
        case "UNKNOWN":
        case 0:
          d.type = 0;
          break;
        case "GAUGE":
        case 1:
          d.type = 1;
          break;
        case "COUNTER":
        case 2:
          d.type = 2;
          break;
        case "STATE_SET":
        case 3:
          d.type = 3;
          break;
        case "INFO":
        case 4:
          d.type = 4;
          break;
        case "HISTOGRAM":
        case 5:
          d.type = 5;
          break;
        case "GAUGE_HISTOGRAM":
        case 6:
          d.type = 6;
          break;
        case "SUMMARY":
        case 7:
          d.type = 7;
          break;
      }
      if (g.unit != null && (d.unit = String(g.unit)), g.help != null && (d.help = String(g.help)), g.metrics) {
        if (!Array.isArray(g.metrics)) throw TypeError(".openmetrics.MetricFamily.metrics: array expected");
        d.metrics = [];
        for (let k = 0; k < g.metrics.length; ++k) {
          if (typeof g.metrics[k] != "object") throw TypeError(".openmetrics.MetricFamily.metrics: object expected");
          d.metrics[k] = $root.Metric.fromObject(g.metrics[k]);
        }
      }
      return d;
    }, t.toObject = function(g, d) {
      d || (d = {});
      let k = {};
      if ((d.arrays || d.defaults) && (k.metrics = []), d.defaults && (k.name = "", k.type = d.enums === String ? "UNKNOWN" : 0, k.unit = "", k.help = ""), g.name != null && g.hasOwnProperty("name") && (k.name = g.name), g.type != null && g.hasOwnProperty("type") && (k.type = d.enums === String ? $root.openmetrics.MetricType[g.type] === void 0 ? g.type : $root.openmetrics.MetricType[g.type] : g.type), g.unit != null && g.hasOwnProperty("unit") && (k.unit = g.unit), g.help != null && g.hasOwnProperty("help") && (k.help = g.help), g.metrics && g.metrics.length) {
        k.metrics = [];
        for (let H = 0; H < g.metrics.length; ++H) k.metrics[H] = $root.Metric.toObject(g.metrics[H], d);
      }
      return k;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.MetricFamily";
    }, t;
  })(), n.MetricType = (function() {
    const t = {}, g = Object.create(t);
    return g[t[0] = "UNKNOWN"] = 0, g[t[1] = "GAUGE"] = 1, g[t[2] = "COUNTER"] = 2, g[t[3] = "STATE_SET"] = 3, g[t[4] = "INFO"] = 4, g[t[5] = "HISTOGRAM"] = 5, g[t[6] = "GAUGE_HISTOGRAM"] = 6, g[t[7] = "SUMMARY"] = 7, g;
  })(), n.Metric = (function() {
    function t(g) {
      if (this.labels = [], this.metricPoints = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.labels = $util.emptyArray, t.prototype.metricPoints = $util.emptyArray, t.create = function(g) {
      return new t(g);
    }, t.encode = function(g, d) {
      if (d || (d = $Writer.create()), g.labels != null && g.labels.length) for (let k = 0; k < g.labels.length; ++k) $root.openmetrics.Label.encode(g.labels[k], d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      if (g.metricPoints != null && g.metricPoints.length) for (let k = 0; k < g.metricPoints.length; ++k) $root.openmetrics.MetricPoint.encode(g.metricPoints[k], d.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim();
      return d;
    }, t.encodeDelimited = function(g, d) {
      return this.encode(g, d).ldelim();
    }, t.decode = function(g, d, k) {
      g instanceof $Reader || (g = $Reader.create(g));
      let H = d === void 0 ? g.len : g.pos + d, AA = new $root.openmetrics.Metric();
      for (; g.pos < H; ) {
        let gA = g.uint32();
        if (gA === k) break;
        switch (gA >>> 3) {
          case 1: {
            AA.labels && AA.labels.length || (AA.labels = []), AA.labels.push($root.openmetrics.Label.decode(g, g.uint32()));
            break;
          }
          case 2: {
            AA.metricPoints && AA.metricPoints.length || (AA.metricPoints = []), AA.metricPoints.push($root.openmetrics.MetricPoint.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(gA & 7);
            break;
        }
      }
      return AA;
    }, t.decodeDelimited = function(g) {
      return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
    }, t.verify = function(g) {
      if (typeof g != "object" || g === null) return "object expected";
      if (g.labels != null && g.hasOwnProperty("labels")) {
        if (!Array.isArray(g.labels)) return "labels: array expected";
        for (let d = 0; d < g.labels.length; ++d) {
          let k = $root.openmetrics.Label.verify(g.labels[d]);
          if (k) return "labels." + k;
        }
      }
      if (g.metricPoints != null && g.hasOwnProperty("metricPoints")) {
        if (!Array.isArray(g.metricPoints)) return "metricPoints: array expected";
        for (let d = 0; d < g.metricPoints.length; ++d) {
          let k = $root.openmetrics.MetricPoint.verify(g.metricPoints[d]);
          if (k) return "metricPoints." + k;
        }
      }
      return null;
    }, t.fromObject = function(g) {
      if (g instanceof $root.openmetrics.Metric) return g;
      let d = new $root.openmetrics.Metric();
      if (g.labels) {
        if (!Array.isArray(g.labels)) throw TypeError(".openmetrics.Metric.labels: array expected");
        d.labels = [];
        for (let k = 0; k < g.labels.length; ++k) {
          if (typeof g.labels[k] != "object") throw TypeError(".openmetrics.Metric.labels: object expected");
          d.labels[k] = $root.openmetrics.Label.fromObject(g.labels[k]);
        }
      }
      if (g.metricPoints) {
        if (!Array.isArray(g.metricPoints)) throw TypeError(".openmetrics.Metric.metricPoints: array expected");
        d.metricPoints = [];
        for (let k = 0; k < g.metricPoints.length; ++k) {
          if (typeof g.metricPoints[k] != "object") throw TypeError(".openmetrics.Metric.metricPoints: object expected");
          d.metricPoints[k] = $root.openmetrics.MetricPoint.fromObject(g.metricPoints[k]);
        }
      }
      return d;
    }, t.toObject = function(g, d) {
      d || (d = {});
      let k = {};
      if ((d.arrays || d.defaults) && (k.labels = [], k.metricPoints = []), g.labels && g.labels.length) {
        k.labels = [];
        for (let H = 0; H < g.labels.length; ++H) k.labels[H] = $root.openmetrics.Label.toObject(g.labels[H], d);
      }
      if (g.metricPoints && g.metricPoints.length) {
        k.metricPoints = [];
        for (let H = 0; H < g.metricPoints.length; ++H) k.metricPoints[H] = $root.openmetrics.MetricPoint.toObject(g.metricPoints[H], d);
      }
      return k;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.Metric";
    }, t;
  })(), n.Label = (function() {
    function t(g) {
      if (g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.name = "", t.prototype.value = "", t.create = function(g) {
      return new t(g);
    }, t.encode = function(g, d) {
      return d || (d = $Writer.create()), g.name != null && Object.hasOwnProperty.call(g, "name") && d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(g.name), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(g.value), d;
    }, t.encodeDelimited = function(g, d) {
      return this.encode(g, d).ldelim();
    }, t.decode = function(g, d, k) {
      g instanceof $Reader || (g = $Reader.create(g));
      let H = d === void 0 ? g.len : g.pos + d, AA = new $root.openmetrics.Label();
      for (; g.pos < H; ) {
        let gA = g.uint32();
        if (gA === k) break;
        switch (gA >>> 3) {
          case 1: {
            AA.name = g.string();
            break;
          }
          case 2: {
            AA.value = g.string();
            break;
          }
          default:
            g.skipType(gA & 7);
            break;
        }
      }
      return AA;
    }, t.decodeDelimited = function(g) {
      return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
    }, t.verify = function(g) {
      return typeof g != "object" || g === null ? "object expected" : g.name != null && g.hasOwnProperty("name") && !$util.isString(g.name) ? "name: string expected" : g.value != null && g.hasOwnProperty("value") && !$util.isString(g.value) ? "value: string expected" : null;
    }, t.fromObject = function(g) {
      if (g instanceof $root.openmetrics.Label) return g;
      let d = new $root.openmetrics.Label();
      return g.name != null && (d.name = String(g.name)), g.value != null && (d.value = String(g.value)), d;
    }, t.toObject = function(g, d) {
      d || (d = {});
      let k = {};
      return d.defaults && (k.name = "", k.value = ""), g.name != null && g.hasOwnProperty("name") && (k.name = g.name), g.value != null && g.hasOwnProperty("value") && (k.value = g.value), k;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.Label";
    }, t;
  })(), n.MetricPoint = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.unknownValue = null, t.prototype.gaugeValue = null, t.prototype.counterValue = null, t.prototype.histogramValue = null, t.prototype.stateSetValue = null, t.prototype.infoValue = null, t.prototype.summaryValue = null, t.prototype.timestamp = null;
    let g;
    return Object.defineProperty(t.prototype, "value", { get: $util.oneOfGetter(g = ["unknownValue", "gaugeValue", "counterValue", "histogramValue", "stateSetValue", "infoValue", "summaryValue"]), set: $util.oneOfSetter(g) }), t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      return k || (k = $Writer.create()), d.unknownValue != null && Object.hasOwnProperty.call(d, "unknownValue") && $root.openmetrics.UnknownValue.encode(d.unknownValue, k.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), d.gaugeValue != null && Object.hasOwnProperty.call(d, "gaugeValue") && $root.openmetrics.GaugeValue.encode(d.gaugeValue, k.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), d.counterValue != null && Object.hasOwnProperty.call(d, "counterValue") && $root.openmetrics.CounterValue.encode(d.counterValue, k.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), d.histogramValue != null && Object.hasOwnProperty.call(d, "histogramValue") && $root.openmetrics.HistogramValue.encode(d.histogramValue, k.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), d.stateSetValue != null && Object.hasOwnProperty.call(d, "stateSetValue") && $root.openmetrics.StateSetValue.encode(d.stateSetValue, k.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), d.infoValue != null && Object.hasOwnProperty.call(d, "infoValue") && $root.openmetrics.InfoValue.encode(d.infoValue, k.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), d.summaryValue != null && Object.hasOwnProperty.call(d, "summaryValue") && $root.openmetrics.SummaryValue.encode(d.summaryValue, k.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), d.timestamp != null && Object.hasOwnProperty.call(d, "timestamp") && $root.google.protobuf.Timestamp.encode(d.timestamp, k.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.openmetrics.MetricPoint();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.unknownValue = $root.openmetrics.UnknownValue.decode(d, d.uint32());
            break;
          }
          case 2: {
            gA.gaugeValue = $root.openmetrics.GaugeValue.decode(d, d.uint32());
            break;
          }
          case 3: {
            gA.counterValue = $root.openmetrics.CounterValue.decode(d, d.uint32());
            break;
          }
          case 4: {
            gA.histogramValue = $root.openmetrics.HistogramValue.decode(d, d.uint32());
            break;
          }
          case 5: {
            gA.stateSetValue = $root.openmetrics.StateSetValue.decode(d, d.uint32());
            break;
          }
          case 6: {
            gA.infoValue = $root.openmetrics.InfoValue.decode(d, d.uint32());
            break;
          }
          case 7: {
            gA.summaryValue = $root.openmetrics.SummaryValue.decode(d, d.uint32());
            break;
          }
          case 8: {
            gA.timestamp = $root.google.protobuf.Timestamp.decode(d, d.uint32());
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      let k = {};
      if (d.unknownValue != null && d.hasOwnProperty("unknownValue")) {
        k.value = 1;
        {
          let H = $root.openmetrics.UnknownValue.verify(d.unknownValue);
          if (H) return "unknownValue." + H;
        }
      }
      if (d.gaugeValue != null && d.hasOwnProperty("gaugeValue")) {
        if (k.value === 1) return "value: multiple values";
        k.value = 1;
        {
          let H = $root.openmetrics.GaugeValue.verify(d.gaugeValue);
          if (H) return "gaugeValue." + H;
        }
      }
      if (d.counterValue != null && d.hasOwnProperty("counterValue")) {
        if (k.value === 1) return "value: multiple values";
        k.value = 1;
        {
          let H = $root.openmetrics.CounterValue.verify(d.counterValue);
          if (H) return "counterValue." + H;
        }
      }
      if (d.histogramValue != null && d.hasOwnProperty("histogramValue")) {
        if (k.value === 1) return "value: multiple values";
        k.value = 1;
        {
          let H = $root.openmetrics.HistogramValue.verify(d.histogramValue);
          if (H) return "histogramValue." + H;
        }
      }
      if (d.stateSetValue != null && d.hasOwnProperty("stateSetValue")) {
        if (k.value === 1) return "value: multiple values";
        k.value = 1;
        {
          let H = $root.openmetrics.StateSetValue.verify(d.stateSetValue);
          if (H) return "stateSetValue." + H;
        }
      }
      if (d.infoValue != null && d.hasOwnProperty("infoValue")) {
        if (k.value === 1) return "value: multiple values";
        k.value = 1;
        {
          let H = $root.openmetrics.InfoValue.verify(d.infoValue);
          if (H) return "infoValue." + H;
        }
      }
      if (d.summaryValue != null && d.hasOwnProperty("summaryValue")) {
        if (k.value === 1) return "value: multiple values";
        k.value = 1;
        {
          let H = $root.openmetrics.SummaryValue.verify(d.summaryValue);
          if (H) return "summaryValue." + H;
        }
      }
      if (d.timestamp != null && d.hasOwnProperty("timestamp")) {
        let H = $root.google.protobuf.Timestamp.verify(d.timestamp);
        if (H) return "timestamp." + H;
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root.openmetrics.MetricPoint) return d;
      let k = new $root.openmetrics.MetricPoint();
      if (d.unknownValue != null) {
        if (typeof d.unknownValue != "object") throw TypeError(".openmetrics.MetricPoint.unknownValue: object expected");
        k.unknownValue = $root.openmetrics.UnknownValue.fromObject(d.unknownValue);
      }
      if (d.gaugeValue != null) {
        if (typeof d.gaugeValue != "object") throw TypeError(".openmetrics.MetricPoint.gaugeValue: object expected");
        k.gaugeValue = $root.openmetrics.GaugeValue.fromObject(d.gaugeValue);
      }
      if (d.counterValue != null) {
        if (typeof d.counterValue != "object") throw TypeError(".openmetrics.MetricPoint.counterValue: object expected");
        k.counterValue = $root.openmetrics.CounterValue.fromObject(d.counterValue);
      }
      if (d.histogramValue != null) {
        if (typeof d.histogramValue != "object") throw TypeError(".openmetrics.MetricPoint.histogramValue: object expected");
        k.histogramValue = $root.openmetrics.HistogramValue.fromObject(d.histogramValue);
      }
      if (d.stateSetValue != null) {
        if (typeof d.stateSetValue != "object") throw TypeError(".openmetrics.MetricPoint.stateSetValue: object expected");
        k.stateSetValue = $root.openmetrics.StateSetValue.fromObject(d.stateSetValue);
      }
      if (d.infoValue != null) {
        if (typeof d.infoValue != "object") throw TypeError(".openmetrics.MetricPoint.infoValue: object expected");
        k.infoValue = $root.openmetrics.InfoValue.fromObject(d.infoValue);
      }
      if (d.summaryValue != null) {
        if (typeof d.summaryValue != "object") throw TypeError(".openmetrics.MetricPoint.summaryValue: object expected");
        k.summaryValue = $root.openmetrics.SummaryValue.fromObject(d.summaryValue);
      }
      if (d.timestamp != null) {
        if (typeof d.timestamp != "object") throw TypeError(".openmetrics.MetricPoint.timestamp: object expected");
        k.timestamp = $root.google.protobuf.Timestamp.fromObject(d.timestamp);
      }
      return k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return k.defaults && (H.timestamp = null), d.unknownValue != null && d.hasOwnProperty("unknownValue") && (H.unknownValue = $root.openmetrics.UnknownValue.toObject(d.unknownValue, k), k.oneofs && (H.value = "unknownValue")), d.gaugeValue != null && d.hasOwnProperty("gaugeValue") && (H.gaugeValue = $root.openmetrics.GaugeValue.toObject(d.gaugeValue, k), k.oneofs && (H.value = "gaugeValue")), d.counterValue != null && d.hasOwnProperty("counterValue") && (H.counterValue = $root.openmetrics.CounterValue.toObject(d.counterValue, k), k.oneofs && (H.value = "counterValue")), d.histogramValue != null && d.hasOwnProperty("histogramValue") && (H.histogramValue = $root.openmetrics.HistogramValue.toObject(d.histogramValue, k), k.oneofs && (H.value = "histogramValue")), d.stateSetValue != null && d.hasOwnProperty("stateSetValue") && (H.stateSetValue = $root.openmetrics.StateSetValue.toObject(d.stateSetValue, k), k.oneofs && (H.value = "stateSetValue")), d.infoValue != null && d.hasOwnProperty("infoValue") && (H.infoValue = $root.openmetrics.InfoValue.toObject(d.infoValue, k), k.oneofs && (H.value = "infoValue")), d.summaryValue != null && d.hasOwnProperty("summaryValue") && (H.summaryValue = $root.openmetrics.SummaryValue.toObject(d.summaryValue, k), k.oneofs && (H.value = "summaryValue")), d.timestamp != null && d.hasOwnProperty("timestamp") && (H.timestamp = $root.google.protobuf.Timestamp.toObject(d.timestamp, k)), H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.MetricPoint";
    }, t;
  })(), n.UnknownValue = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.doubleValue = null, t.prototype.intValue = null;
    let g;
    return Object.defineProperty(t.prototype, "value", { get: $util.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util.oneOfSetter(g) }), t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      return k || (k = $Writer.create()), d.doubleValue != null && Object.hasOwnProperty.call(d, "doubleValue") && k.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(d.doubleValue), d.intValue != null && Object.hasOwnProperty.call(d, "intValue") && k.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(d.intValue), k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.openmetrics.UnknownValue();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.doubleValue = d.double();
            break;
          }
          case 2: {
            gA.intValue = d.int64();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      let k = {};
      if (d.doubleValue != null && d.hasOwnProperty("doubleValue") && (k.value = 1, typeof d.doubleValue != "number")) return "doubleValue: number expected";
      if (d.intValue != null && d.hasOwnProperty("intValue")) {
        if (k.value === 1) return "value: multiple values";
        if (k.value = 1, !$util.isInteger(d.intValue) && !(d.intValue && $util.isInteger(d.intValue.low) && $util.isInteger(d.intValue.high))) return "intValue: integer|Long expected";
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root.openmetrics.UnknownValue) return d;
      let k = new $root.openmetrics.UnknownValue();
      return d.doubleValue != null && (k.doubleValue = Number(d.doubleValue)), d.intValue != null && ($util.Long ? (k.intValue = $util.Long.fromValue(d.intValue)).unsigned = !1 : typeof d.intValue == "string" ? k.intValue = parseInt(d.intValue, 10) : typeof d.intValue == "number" ? k.intValue = d.intValue : typeof d.intValue == "object" && (k.intValue = new $util.LongBits(d.intValue.low >>> 0, d.intValue.high >>> 0).toNumber())), k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return d.doubleValue != null && d.hasOwnProperty("doubleValue") && (H.doubleValue = k.json && !isFinite(d.doubleValue) ? String(d.doubleValue) : d.doubleValue, k.oneofs && (H.value = "doubleValue")), d.intValue != null && d.hasOwnProperty("intValue") && (typeof d.intValue == "number" ? H.intValue = k.longs === String ? String(d.intValue) : d.intValue : H.intValue = k.longs === String ? $util.Long.prototype.toString.call(d.intValue) : k.longs === Number ? new $util.LongBits(d.intValue.low >>> 0, d.intValue.high >>> 0).toNumber() : d.intValue, k.oneofs && (H.value = "intValue")), H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.UnknownValue";
    }, t;
  })(), n.GaugeValue = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.doubleValue = null, t.prototype.intValue = null;
    let g;
    return Object.defineProperty(t.prototype, "value", { get: $util.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util.oneOfSetter(g) }), t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      return k || (k = $Writer.create()), d.doubleValue != null && Object.hasOwnProperty.call(d, "doubleValue") && k.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(d.doubleValue), d.intValue != null && Object.hasOwnProperty.call(d, "intValue") && k.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(d.intValue), k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.openmetrics.GaugeValue();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.doubleValue = d.double();
            break;
          }
          case 2: {
            gA.intValue = d.int64();
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      let k = {};
      if (d.doubleValue != null && d.hasOwnProperty("doubleValue") && (k.value = 1, typeof d.doubleValue != "number")) return "doubleValue: number expected";
      if (d.intValue != null && d.hasOwnProperty("intValue")) {
        if (k.value === 1) return "value: multiple values";
        if (k.value = 1, !$util.isInteger(d.intValue) && !(d.intValue && $util.isInteger(d.intValue.low) && $util.isInteger(d.intValue.high))) return "intValue: integer|Long expected";
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root.openmetrics.GaugeValue) return d;
      let k = new $root.openmetrics.GaugeValue();
      return d.doubleValue != null && (k.doubleValue = Number(d.doubleValue)), d.intValue != null && ($util.Long ? (k.intValue = $util.Long.fromValue(d.intValue)).unsigned = !1 : typeof d.intValue == "string" ? k.intValue = parseInt(d.intValue, 10) : typeof d.intValue == "number" ? k.intValue = d.intValue : typeof d.intValue == "object" && (k.intValue = new $util.LongBits(d.intValue.low >>> 0, d.intValue.high >>> 0).toNumber())), k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return d.doubleValue != null && d.hasOwnProperty("doubleValue") && (H.doubleValue = k.json && !isFinite(d.doubleValue) ? String(d.doubleValue) : d.doubleValue, k.oneofs && (H.value = "doubleValue")), d.intValue != null && d.hasOwnProperty("intValue") && (typeof d.intValue == "number" ? H.intValue = k.longs === String ? String(d.intValue) : d.intValue : H.intValue = k.longs === String ? $util.Long.prototype.toString.call(d.intValue) : k.longs === Number ? new $util.LongBits(d.intValue.low >>> 0, d.intValue.high >>> 0).toNumber() : d.intValue, k.oneofs && (H.value = "intValue")), H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.GaugeValue";
    }, t;
  })(), n.CounterValue = (function() {
    function t(d) {
      if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.doubleValue = null, t.prototype.intValue = null, t.prototype.created = null, t.prototype.exemplar = null;
    let g;
    return Object.defineProperty(t.prototype, "total", { get: $util.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util.oneOfSetter(g) }), t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      return k || (k = $Writer.create()), d.doubleValue != null && Object.hasOwnProperty.call(d, "doubleValue") && k.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(d.doubleValue), d.intValue != null && Object.hasOwnProperty.call(d, "intValue") && k.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(d.intValue), d.created != null && Object.hasOwnProperty.call(d, "created") && $root.google.protobuf.Timestamp.encode(d.created, k.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), d.exemplar != null && Object.hasOwnProperty.call(d, "exemplar") && $root.openmetrics.Exemplar.encode(d.exemplar, k.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.openmetrics.CounterValue();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.doubleValue = d.double();
            break;
          }
          case 2: {
            gA.intValue = d.uint64();
            break;
          }
          case 3: {
            gA.created = $root.google.protobuf.Timestamp.decode(d, d.uint32());
            break;
          }
          case 4: {
            gA.exemplar = $root.openmetrics.Exemplar.decode(d, d.uint32());
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      let k = {};
      if (d.doubleValue != null && d.hasOwnProperty("doubleValue") && (k.total = 1, typeof d.doubleValue != "number")) return "doubleValue: number expected";
      if (d.intValue != null && d.hasOwnProperty("intValue")) {
        if (k.total === 1) return "total: multiple values";
        if (k.total = 1, !$util.isInteger(d.intValue) && !(d.intValue && $util.isInteger(d.intValue.low) && $util.isInteger(d.intValue.high))) return "intValue: integer|Long expected";
      }
      if (d.created != null && d.hasOwnProperty("created")) {
        let H = $root.google.protobuf.Timestamp.verify(d.created);
        if (H) return "created." + H;
      }
      if (d.exemplar != null && d.hasOwnProperty("exemplar")) {
        let H = $root.openmetrics.Exemplar.verify(d.exemplar);
        if (H) return "exemplar." + H;
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root.openmetrics.CounterValue) return d;
      let k = new $root.openmetrics.CounterValue();
      if (d.doubleValue != null && (k.doubleValue = Number(d.doubleValue)), d.intValue != null && ($util.Long ? (k.intValue = $util.Long.fromValue(d.intValue)).unsigned = !0 : typeof d.intValue == "string" ? k.intValue = parseInt(d.intValue, 10) : typeof d.intValue == "number" ? k.intValue = d.intValue : typeof d.intValue == "object" && (k.intValue = new $util.LongBits(d.intValue.low >>> 0, d.intValue.high >>> 0).toNumber(!0))), d.created != null) {
        if (typeof d.created != "object") throw TypeError(".openmetrics.CounterValue.created: object expected");
        k.created = $root.google.protobuf.Timestamp.fromObject(d.created);
      }
      if (d.exemplar != null) {
        if (typeof d.exemplar != "object") throw TypeError(".openmetrics.CounterValue.exemplar: object expected");
        k.exemplar = $root.openmetrics.Exemplar.fromObject(d.exemplar);
      }
      return k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      return k.defaults && (H.created = null, H.exemplar = null), d.doubleValue != null && d.hasOwnProperty("doubleValue") && (H.doubleValue = k.json && !isFinite(d.doubleValue) ? String(d.doubleValue) : d.doubleValue, k.oneofs && (H.total = "doubleValue")), d.intValue != null && d.hasOwnProperty("intValue") && (typeof d.intValue == "number" ? H.intValue = k.longs === String ? String(d.intValue) : d.intValue : H.intValue = k.longs === String ? $util.Long.prototype.toString.call(d.intValue) : k.longs === Number ? new $util.LongBits(d.intValue.low >>> 0, d.intValue.high >>> 0).toNumber(!0) : d.intValue, k.oneofs && (H.total = "intValue")), d.created != null && d.hasOwnProperty("created") && (H.created = $root.google.protobuf.Timestamp.toObject(d.created, k)), d.exemplar != null && d.hasOwnProperty("exemplar") && (H.exemplar = $root.openmetrics.Exemplar.toObject(d.exemplar, k)), H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.CounterValue";
    }, t;
  })(), n.HistogramValue = (function() {
    function t(d) {
      if (this.buckets = [], d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.doubleValue = null, t.prototype.intValue = null, t.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, t.prototype.created = null, t.prototype.buckets = $util.emptyArray;
    let g;
    return Object.defineProperty(t.prototype, "sum", { get: $util.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util.oneOfSetter(g) }), t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      if (k || (k = $Writer.create()), d.doubleValue != null && Object.hasOwnProperty.call(d, "doubleValue") && k.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(d.doubleValue), d.intValue != null && Object.hasOwnProperty.call(d, "intValue") && k.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(d.intValue), d.count != null && Object.hasOwnProperty.call(d, "count") && k.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(d.count), d.created != null && Object.hasOwnProperty.call(d, "created") && $root.google.protobuf.Timestamp.encode(d.created, k.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), d.buckets != null && d.buckets.length) for (let H = 0; H < d.buckets.length; ++H) $root.openmetrics.HistogramValue.Bucket.encode(d.buckets[H], k.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.openmetrics.HistogramValue();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.doubleValue = d.double();
            break;
          }
          case 2: {
            gA.intValue = d.int64();
            break;
          }
          case 3: {
            gA.count = d.uint64();
            break;
          }
          case 4: {
            gA.created = $root.google.protobuf.Timestamp.decode(d, d.uint32());
            break;
          }
          case 5: {
            gA.buckets && gA.buckets.length || (gA.buckets = []), gA.buckets.push($root.openmetrics.HistogramValue.Bucket.decode(d, d.uint32()));
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      let k = {};
      if (d.doubleValue != null && d.hasOwnProperty("doubleValue") && (k.sum = 1, typeof d.doubleValue != "number")) return "doubleValue: number expected";
      if (d.intValue != null && d.hasOwnProperty("intValue")) {
        if (k.sum === 1) return "sum: multiple values";
        if (k.sum = 1, !$util.isInteger(d.intValue) && !(d.intValue && $util.isInteger(d.intValue.low) && $util.isInteger(d.intValue.high))) return "intValue: integer|Long expected";
      }
      if (d.count != null && d.hasOwnProperty("count") && !$util.isInteger(d.count) && !(d.count && $util.isInteger(d.count.low) && $util.isInteger(d.count.high))) return "count: integer|Long expected";
      if (d.created != null && d.hasOwnProperty("created")) {
        let H = $root.google.protobuf.Timestamp.verify(d.created);
        if (H) return "created." + H;
      }
      if (d.buckets != null && d.hasOwnProperty("buckets")) {
        if (!Array.isArray(d.buckets)) return "buckets: array expected";
        for (let H = 0; H < d.buckets.length; ++H) {
          let AA = $root.openmetrics.HistogramValue.Bucket.verify(d.buckets[H]);
          if (AA) return "buckets." + AA;
        }
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root.openmetrics.HistogramValue) return d;
      let k = new $root.openmetrics.HistogramValue();
      if (d.doubleValue != null && (k.doubleValue = Number(d.doubleValue)), d.intValue != null && ($util.Long ? (k.intValue = $util.Long.fromValue(d.intValue)).unsigned = !1 : typeof d.intValue == "string" ? k.intValue = parseInt(d.intValue, 10) : typeof d.intValue == "number" ? k.intValue = d.intValue : typeof d.intValue == "object" && (k.intValue = new $util.LongBits(d.intValue.low >>> 0, d.intValue.high >>> 0).toNumber())), d.count != null && ($util.Long ? (k.count = $util.Long.fromValue(d.count)).unsigned = !0 : typeof d.count == "string" ? k.count = parseInt(d.count, 10) : typeof d.count == "number" ? k.count = d.count : typeof d.count == "object" && (k.count = new $util.LongBits(d.count.low >>> 0, d.count.high >>> 0).toNumber(!0))), d.created != null) {
        if (typeof d.created != "object") throw TypeError(".openmetrics.HistogramValue.created: object expected");
        k.created = $root.google.protobuf.Timestamp.fromObject(d.created);
      }
      if (d.buckets) {
        if (!Array.isArray(d.buckets)) throw TypeError(".openmetrics.HistogramValue.buckets: array expected");
        k.buckets = [];
        for (let H = 0; H < d.buckets.length; ++H) {
          if (typeof d.buckets[H] != "object") throw TypeError(".openmetrics.HistogramValue.buckets: object expected");
          k.buckets[H] = $root.openmetrics.HistogramValue.Bucket.fromObject(d.buckets[H]);
        }
      }
      return k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      if ((k.arrays || k.defaults) && (H.buckets = []), k.defaults) {
        if ($util.Long) {
          let AA = new $util.Long(0, 0, !0);
          H.count = k.longs === String ? AA.toString() : k.longs === Number ? AA.toNumber() : AA;
        } else H.count = k.longs === String ? "0" : 0;
        H.created = null;
      }
      if (d.doubleValue != null && d.hasOwnProperty("doubleValue") && (H.doubleValue = k.json && !isFinite(d.doubleValue) ? String(d.doubleValue) : d.doubleValue, k.oneofs && (H.sum = "doubleValue")), d.intValue != null && d.hasOwnProperty("intValue") && (typeof d.intValue == "number" ? H.intValue = k.longs === String ? String(d.intValue) : d.intValue : H.intValue = k.longs === String ? $util.Long.prototype.toString.call(d.intValue) : k.longs === Number ? new $util.LongBits(d.intValue.low >>> 0, d.intValue.high >>> 0).toNumber() : d.intValue, k.oneofs && (H.sum = "intValue")), d.count != null && d.hasOwnProperty("count") && (typeof d.count == "number" ? H.count = k.longs === String ? String(d.count) : d.count : H.count = k.longs === String ? $util.Long.prototype.toString.call(d.count) : k.longs === Number ? new $util.LongBits(d.count.low >>> 0, d.count.high >>> 0).toNumber(!0) : d.count), d.created != null && d.hasOwnProperty("created") && (H.created = $root.google.protobuf.Timestamp.toObject(d.created, k)), d.buckets && d.buckets.length) {
        H.buckets = [];
        for (let AA = 0; AA < d.buckets.length; ++AA) H.buckets[AA] = $root.openmetrics.HistogramValue.Bucket.toObject(d.buckets[AA], k);
      }
      return H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.HistogramValue";
    }, t.Bucket = (function() {
      function d(k) {
        if (k) for (let H = Object.keys(k), AA = 0; AA < H.length; ++AA) k[H[AA]] != null && (this[H[AA]] = k[H[AA]]);
      }
      return d.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, d.prototype.upperBound = 0, d.prototype.exemplar = null, d.create = function(k) {
        return new d(k);
      }, d.encode = function(k, H) {
        return H || (H = $Writer.create()), k.count != null && Object.hasOwnProperty.call(k, "count") && H.uint32(
          /* id 1, wireType 0 =*/
          8
        ).uint64(k.count), k.upperBound != null && Object.hasOwnProperty.call(k, "upperBound") && H.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(k.upperBound), k.exemplar != null && Object.hasOwnProperty.call(k, "exemplar") && $root.openmetrics.Exemplar.encode(k.exemplar, H.uint32(
          /* id 3, wireType 2 =*/
          26
        ).fork()).ldelim(), H;
      }, d.encodeDelimited = function(k, H) {
        return this.encode(k, H).ldelim();
      }, d.decode = function(k, H, AA) {
        k instanceof $Reader || (k = $Reader.create(k));
        let gA = H === void 0 ? k.len : k.pos + H, IA = new $root.openmetrics.HistogramValue.Bucket();
        for (; k.pos < gA; ) {
          let CA = k.uint32();
          if (CA === AA) break;
          switch (CA >>> 3) {
            case 1: {
              IA.count = k.uint64();
              break;
            }
            case 2: {
              IA.upperBound = k.double();
              break;
            }
            case 3: {
              IA.exemplar = $root.openmetrics.Exemplar.decode(k, k.uint32());
              break;
            }
            default:
              k.skipType(CA & 7);
              break;
          }
        }
        return IA;
      }, d.decodeDelimited = function(k) {
        return k instanceof $Reader || (k = new $Reader(k)), this.decode(k, k.uint32());
      }, d.verify = function(k) {
        if (typeof k != "object" || k === null) return "object expected";
        if (k.count != null && k.hasOwnProperty("count") && !$util.isInteger(k.count) && !(k.count && $util.isInteger(k.count.low) && $util.isInteger(k.count.high))) return "count: integer|Long expected";
        if (k.upperBound != null && k.hasOwnProperty("upperBound") && typeof k.upperBound != "number") return "upperBound: number expected";
        if (k.exemplar != null && k.hasOwnProperty("exemplar")) {
          let H = $root.openmetrics.Exemplar.verify(k.exemplar);
          if (H) return "exemplar." + H;
        }
        return null;
      }, d.fromObject = function(k) {
        if (k instanceof $root.openmetrics.HistogramValue.Bucket) return k;
        let H = new $root.openmetrics.HistogramValue.Bucket();
        if (k.count != null && ($util.Long ? (H.count = $util.Long.fromValue(k.count)).unsigned = !0 : typeof k.count == "string" ? H.count = parseInt(k.count, 10) : typeof k.count == "number" ? H.count = k.count : typeof k.count == "object" && (H.count = new $util.LongBits(k.count.low >>> 0, k.count.high >>> 0).toNumber(!0))), k.upperBound != null && (H.upperBound = Number(k.upperBound)), k.exemplar != null) {
          if (typeof k.exemplar != "object") throw TypeError(".openmetrics.HistogramValue.Bucket.exemplar: object expected");
          H.exemplar = $root.openmetrics.Exemplar.fromObject(k.exemplar);
        }
        return H;
      }, d.toObject = function(k, H) {
        H || (H = {});
        let AA = {};
        if (H.defaults) {
          if ($util.Long) {
            let gA = new $util.Long(0, 0, !0);
            AA.count = H.longs === String ? gA.toString() : H.longs === Number ? gA.toNumber() : gA;
          } else AA.count = H.longs === String ? "0" : 0;
          AA.upperBound = 0, AA.exemplar = null;
        }
        return k.count != null && k.hasOwnProperty("count") && (typeof k.count == "number" ? AA.count = H.longs === String ? String(k.count) : k.count : AA.count = H.longs === String ? $util.Long.prototype.toString.call(k.count) : H.longs === Number ? new $util.LongBits(k.count.low >>> 0, k.count.high >>> 0).toNumber(!0) : k.count), k.upperBound != null && k.hasOwnProperty("upperBound") && (AA.upperBound = H.json && !isFinite(k.upperBound) ? String(k.upperBound) : k.upperBound), k.exemplar != null && k.hasOwnProperty("exemplar") && (AA.exemplar = $root.openmetrics.Exemplar.toObject(k.exemplar, H)), AA;
      }, d.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, d.getTypeUrl = function(k) {
        return k === void 0 && (k = "type.googleapis.com"), k + "/openmetrics.HistogramValue.Bucket";
      }, d;
    })(), t;
  })(), n.Exemplar = (function() {
    function t(g) {
      if (this.label = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.value = 0, t.prototype.timestamp = null, t.prototype.label = $util.emptyArray, t.create = function(g) {
      return new t(g);
    }, t.encode = function(g, d) {
      if (d || (d = $Writer.create()), g.value != null && Object.hasOwnProperty.call(g, "value") && d.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(g.value), g.timestamp != null && Object.hasOwnProperty.call(g, "timestamp") && $root.google.protobuf.Timestamp.encode(g.timestamp, d.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), g.label != null && g.label.length) for (let k = 0; k < g.label.length; ++k) $root.openmetrics.Label.encode(g.label[k], d.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim();
      return d;
    }, t.encodeDelimited = function(g, d) {
      return this.encode(g, d).ldelim();
    }, t.decode = function(g, d, k) {
      g instanceof $Reader || (g = $Reader.create(g));
      let H = d === void 0 ? g.len : g.pos + d, AA = new $root.openmetrics.Exemplar();
      for (; g.pos < H; ) {
        let gA = g.uint32();
        if (gA === k) break;
        switch (gA >>> 3) {
          case 1: {
            AA.value = g.double();
            break;
          }
          case 2: {
            AA.timestamp = $root.google.protobuf.Timestamp.decode(g, g.uint32());
            break;
          }
          case 3: {
            AA.label && AA.label.length || (AA.label = []), AA.label.push($root.openmetrics.Label.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(gA & 7);
            break;
        }
      }
      return AA;
    }, t.decodeDelimited = function(g) {
      return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
    }, t.verify = function(g) {
      if (typeof g != "object" || g === null) return "object expected";
      if (g.value != null && g.hasOwnProperty("value") && typeof g.value != "number") return "value: number expected";
      if (g.timestamp != null && g.hasOwnProperty("timestamp")) {
        let d = $root.google.protobuf.Timestamp.verify(g.timestamp);
        if (d) return "timestamp." + d;
      }
      if (g.label != null && g.hasOwnProperty("label")) {
        if (!Array.isArray(g.label)) return "label: array expected";
        for (let d = 0; d < g.label.length; ++d) {
          let k = $root.openmetrics.Label.verify(g.label[d]);
          if (k) return "label." + k;
        }
      }
      return null;
    }, t.fromObject = function(g) {
      if (g instanceof $root.openmetrics.Exemplar) return g;
      let d = new $root.openmetrics.Exemplar();
      if (g.value != null && (d.value = Number(g.value)), g.timestamp != null) {
        if (typeof g.timestamp != "object") throw TypeError(".openmetrics.Exemplar.timestamp: object expected");
        d.timestamp = $root.google.protobuf.Timestamp.fromObject(g.timestamp);
      }
      if (g.label) {
        if (!Array.isArray(g.label)) throw TypeError(".openmetrics.Exemplar.label: array expected");
        d.label = [];
        for (let k = 0; k < g.label.length; ++k) {
          if (typeof g.label[k] != "object") throw TypeError(".openmetrics.Exemplar.label: object expected");
          d.label[k] = $root.openmetrics.Label.fromObject(g.label[k]);
        }
      }
      return d;
    }, t.toObject = function(g, d) {
      d || (d = {});
      let k = {};
      if ((d.arrays || d.defaults) && (k.label = []), d.defaults && (k.value = 0, k.timestamp = null), g.value != null && g.hasOwnProperty("value") && (k.value = d.json && !isFinite(g.value) ? String(g.value) : g.value), g.timestamp != null && g.hasOwnProperty("timestamp") && (k.timestamp = $root.google.protobuf.Timestamp.toObject(g.timestamp, d)), g.label && g.label.length) {
        k.label = [];
        for (let H = 0; H < g.label.length; ++H) k.label[H] = $root.openmetrics.Label.toObject(g.label[H], d);
      }
      return k;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.Exemplar";
    }, t;
  })(), n.StateSetValue = (function() {
    function t(g) {
      if (this.states = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.states = $util.emptyArray, t.create = function(g) {
      return new t(g);
    }, t.encode = function(g, d) {
      if (d || (d = $Writer.create()), g.states != null && g.states.length) for (let k = 0; k < g.states.length; ++k) $root.openmetrics.StateSetValue.State.encode(g.states[k], d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return d;
    }, t.encodeDelimited = function(g, d) {
      return this.encode(g, d).ldelim();
    }, t.decode = function(g, d, k) {
      g instanceof $Reader || (g = $Reader.create(g));
      let H = d === void 0 ? g.len : g.pos + d, AA = new $root.openmetrics.StateSetValue();
      for (; g.pos < H; ) {
        let gA = g.uint32();
        if (gA === k) break;
        switch (gA >>> 3) {
          case 1: {
            AA.states && AA.states.length || (AA.states = []), AA.states.push($root.openmetrics.StateSetValue.State.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(gA & 7);
            break;
        }
      }
      return AA;
    }, t.decodeDelimited = function(g) {
      return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
    }, t.verify = function(g) {
      if (typeof g != "object" || g === null) return "object expected";
      if (g.states != null && g.hasOwnProperty("states")) {
        if (!Array.isArray(g.states)) return "states: array expected";
        for (let d = 0; d < g.states.length; ++d) {
          let k = $root.openmetrics.StateSetValue.State.verify(g.states[d]);
          if (k) return "states." + k;
        }
      }
      return null;
    }, t.fromObject = function(g) {
      if (g instanceof $root.openmetrics.StateSetValue) return g;
      let d = new $root.openmetrics.StateSetValue();
      if (g.states) {
        if (!Array.isArray(g.states)) throw TypeError(".openmetrics.StateSetValue.states: array expected");
        d.states = [];
        for (let k = 0; k < g.states.length; ++k) {
          if (typeof g.states[k] != "object") throw TypeError(".openmetrics.StateSetValue.states: object expected");
          d.states[k] = $root.openmetrics.StateSetValue.State.fromObject(g.states[k]);
        }
      }
      return d;
    }, t.toObject = function(g, d) {
      d || (d = {});
      let k = {};
      if ((d.arrays || d.defaults) && (k.states = []), g.states && g.states.length) {
        k.states = [];
        for (let H = 0; H < g.states.length; ++H) k.states[H] = $root.openmetrics.StateSetValue.State.toObject(g.states[H], d);
      }
      return k;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.StateSetValue";
    }, t.State = (function() {
      function g(d) {
        if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
      }
      return g.prototype.enabled = !1, g.prototype.name = "", g.create = function(d) {
        return new g(d);
      }, g.encode = function(d, k) {
        return k || (k = $Writer.create()), d.enabled != null && Object.hasOwnProperty.call(d, "enabled") && k.uint32(
          /* id 1, wireType 0 =*/
          8
        ).bool(d.enabled), d.name != null && Object.hasOwnProperty.call(d, "name") && k.uint32(
          /* id 2, wireType 2 =*/
          18
        ).string(d.name), k;
      }, g.encodeDelimited = function(d, k) {
        return this.encode(d, k).ldelim();
      }, g.decode = function(d, k, H) {
        d instanceof $Reader || (d = $Reader.create(d));
        let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.openmetrics.StateSetValue.State();
        for (; d.pos < AA; ) {
          let IA = d.uint32();
          if (IA === H) break;
          switch (IA >>> 3) {
            case 1: {
              gA.enabled = d.bool();
              break;
            }
            case 2: {
              gA.name = d.string();
              break;
            }
            default:
              d.skipType(IA & 7);
              break;
          }
        }
        return gA;
      }, g.decodeDelimited = function(d) {
        return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
      }, g.verify = function(d) {
        return typeof d != "object" || d === null ? "object expected" : d.enabled != null && d.hasOwnProperty("enabled") && typeof d.enabled != "boolean" ? "enabled: boolean expected" : d.name != null && d.hasOwnProperty("name") && !$util.isString(d.name) ? "name: string expected" : null;
      }, g.fromObject = function(d) {
        if (d instanceof $root.openmetrics.StateSetValue.State) return d;
        let k = new $root.openmetrics.StateSetValue.State();
        return d.enabled != null && (k.enabled = !!d.enabled), d.name != null && (k.name = String(d.name)), k;
      }, g.toObject = function(d, k) {
        k || (k = {});
        let H = {};
        return k.defaults && (H.enabled = !1, H.name = ""), d.enabled != null && d.hasOwnProperty("enabled") && (H.enabled = d.enabled), d.name != null && d.hasOwnProperty("name") && (H.name = d.name), H;
      }, g.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, g.getTypeUrl = function(d) {
        return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.StateSetValue.State";
      }, g;
    })(), t;
  })(), n.InfoValue = (function() {
    function t(g) {
      if (this.info = [], g) for (let d = Object.keys(g), k = 0; k < d.length; ++k) g[d[k]] != null && (this[d[k]] = g[d[k]]);
    }
    return t.prototype.info = $util.emptyArray, t.create = function(g) {
      return new t(g);
    }, t.encode = function(g, d) {
      if (d || (d = $Writer.create()), g.info != null && g.info.length) for (let k = 0; k < g.info.length; ++k) $root.openmetrics.Label.encode(g.info[k], d.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return d;
    }, t.encodeDelimited = function(g, d) {
      return this.encode(g, d).ldelim();
    }, t.decode = function(g, d, k) {
      g instanceof $Reader || (g = $Reader.create(g));
      let H = d === void 0 ? g.len : g.pos + d, AA = new $root.openmetrics.InfoValue();
      for (; g.pos < H; ) {
        let gA = g.uint32();
        if (gA === k) break;
        switch (gA >>> 3) {
          case 1: {
            AA.info && AA.info.length || (AA.info = []), AA.info.push($root.openmetrics.Label.decode(g, g.uint32()));
            break;
          }
          default:
            g.skipType(gA & 7);
            break;
        }
      }
      return AA;
    }, t.decodeDelimited = function(g) {
      return g instanceof $Reader || (g = new $Reader(g)), this.decode(g, g.uint32());
    }, t.verify = function(g) {
      if (typeof g != "object" || g === null) return "object expected";
      if (g.info != null && g.hasOwnProperty("info")) {
        if (!Array.isArray(g.info)) return "info: array expected";
        for (let d = 0; d < g.info.length; ++d) {
          let k = $root.openmetrics.Label.verify(g.info[d]);
          if (k) return "info." + k;
        }
      }
      return null;
    }, t.fromObject = function(g) {
      if (g instanceof $root.openmetrics.InfoValue) return g;
      let d = new $root.openmetrics.InfoValue();
      if (g.info) {
        if (!Array.isArray(g.info)) throw TypeError(".openmetrics.InfoValue.info: array expected");
        d.info = [];
        for (let k = 0; k < g.info.length; ++k) {
          if (typeof g.info[k] != "object") throw TypeError(".openmetrics.InfoValue.info: object expected");
          d.info[k] = $root.openmetrics.Label.fromObject(g.info[k]);
        }
      }
      return d;
    }, t.toObject = function(g, d) {
      d || (d = {});
      let k = {};
      if ((d.arrays || d.defaults) && (k.info = []), g.info && g.info.length) {
        k.info = [];
        for (let H = 0; H < g.info.length; ++H) k.info[H] = $root.openmetrics.Label.toObject(g.info[H], d);
      }
      return k;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(g) {
      return g === void 0 && (g = "type.googleapis.com"), g + "/openmetrics.InfoValue";
    }, t;
  })(), n.SummaryValue = (function() {
    function t(d) {
      if (this.quantile = [], d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
    }
    t.prototype.doubleValue = null, t.prototype.intValue = null, t.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, t.prototype.created = null, t.prototype.quantile = $util.emptyArray;
    let g;
    return Object.defineProperty(t.prototype, "sum", { get: $util.oneOfGetter(g = ["doubleValue", "intValue"]), set: $util.oneOfSetter(g) }), t.create = function(d) {
      return new t(d);
    }, t.encode = function(d, k) {
      if (k || (k = $Writer.create()), d.doubleValue != null && Object.hasOwnProperty.call(d, "doubleValue") && k.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(d.doubleValue), d.intValue != null && Object.hasOwnProperty.call(d, "intValue") && k.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(d.intValue), d.count != null && Object.hasOwnProperty.call(d, "count") && k.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(d.count), d.created != null && Object.hasOwnProperty.call(d, "created") && $root.google.protobuf.Timestamp.encode(d.created, k.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), d.quantile != null && d.quantile.length) for (let H = 0; H < d.quantile.length; ++H) $root.openmetrics.SummaryValue.Quantile.encode(d.quantile[H], k.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return k;
    }, t.encodeDelimited = function(d, k) {
      return this.encode(d, k).ldelim();
    }, t.decode = function(d, k, H) {
      d instanceof $Reader || (d = $Reader.create(d));
      let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.openmetrics.SummaryValue();
      for (; d.pos < AA; ) {
        let IA = d.uint32();
        if (IA === H) break;
        switch (IA >>> 3) {
          case 1: {
            gA.doubleValue = d.double();
            break;
          }
          case 2: {
            gA.intValue = d.int64();
            break;
          }
          case 3: {
            gA.count = d.uint64();
            break;
          }
          case 4: {
            gA.created = $root.google.protobuf.Timestamp.decode(d, d.uint32());
            break;
          }
          case 5: {
            gA.quantile && gA.quantile.length || (gA.quantile = []), gA.quantile.push($root.openmetrics.SummaryValue.Quantile.decode(d, d.uint32()));
            break;
          }
          default:
            d.skipType(IA & 7);
            break;
        }
      }
      return gA;
    }, t.decodeDelimited = function(d) {
      return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
    }, t.verify = function(d) {
      if (typeof d != "object" || d === null) return "object expected";
      let k = {};
      if (d.doubleValue != null && d.hasOwnProperty("doubleValue") && (k.sum = 1, typeof d.doubleValue != "number")) return "doubleValue: number expected";
      if (d.intValue != null && d.hasOwnProperty("intValue")) {
        if (k.sum === 1) return "sum: multiple values";
        if (k.sum = 1, !$util.isInteger(d.intValue) && !(d.intValue && $util.isInteger(d.intValue.low) && $util.isInteger(d.intValue.high))) return "intValue: integer|Long expected";
      }
      if (d.count != null && d.hasOwnProperty("count") && !$util.isInteger(d.count) && !(d.count && $util.isInteger(d.count.low) && $util.isInteger(d.count.high))) return "count: integer|Long expected";
      if (d.created != null && d.hasOwnProperty("created")) {
        let H = $root.google.protobuf.Timestamp.verify(d.created);
        if (H) return "created." + H;
      }
      if (d.quantile != null && d.hasOwnProperty("quantile")) {
        if (!Array.isArray(d.quantile)) return "quantile: array expected";
        for (let H = 0; H < d.quantile.length; ++H) {
          let AA = $root.openmetrics.SummaryValue.Quantile.verify(d.quantile[H]);
          if (AA) return "quantile." + AA;
        }
      }
      return null;
    }, t.fromObject = function(d) {
      if (d instanceof $root.openmetrics.SummaryValue) return d;
      let k = new $root.openmetrics.SummaryValue();
      if (d.doubleValue != null && (k.doubleValue = Number(d.doubleValue)), d.intValue != null && ($util.Long ? (k.intValue = $util.Long.fromValue(d.intValue)).unsigned = !1 : typeof d.intValue == "string" ? k.intValue = parseInt(d.intValue, 10) : typeof d.intValue == "number" ? k.intValue = d.intValue : typeof d.intValue == "object" && (k.intValue = new $util.LongBits(d.intValue.low >>> 0, d.intValue.high >>> 0).toNumber())), d.count != null && ($util.Long ? (k.count = $util.Long.fromValue(d.count)).unsigned = !0 : typeof d.count == "string" ? k.count = parseInt(d.count, 10) : typeof d.count == "number" ? k.count = d.count : typeof d.count == "object" && (k.count = new $util.LongBits(d.count.low >>> 0, d.count.high >>> 0).toNumber(!0))), d.created != null) {
        if (typeof d.created != "object") throw TypeError(".openmetrics.SummaryValue.created: object expected");
        k.created = $root.google.protobuf.Timestamp.fromObject(d.created);
      }
      if (d.quantile) {
        if (!Array.isArray(d.quantile)) throw TypeError(".openmetrics.SummaryValue.quantile: array expected");
        k.quantile = [];
        for (let H = 0; H < d.quantile.length; ++H) {
          if (typeof d.quantile[H] != "object") throw TypeError(".openmetrics.SummaryValue.quantile: object expected");
          k.quantile[H] = $root.openmetrics.SummaryValue.Quantile.fromObject(d.quantile[H]);
        }
      }
      return k;
    }, t.toObject = function(d, k) {
      k || (k = {});
      let H = {};
      if ((k.arrays || k.defaults) && (H.quantile = []), k.defaults) {
        if ($util.Long) {
          let AA = new $util.Long(0, 0, !0);
          H.count = k.longs === String ? AA.toString() : k.longs === Number ? AA.toNumber() : AA;
        } else H.count = k.longs === String ? "0" : 0;
        H.created = null;
      }
      if (d.doubleValue != null && d.hasOwnProperty("doubleValue") && (H.doubleValue = k.json && !isFinite(d.doubleValue) ? String(d.doubleValue) : d.doubleValue, k.oneofs && (H.sum = "doubleValue")), d.intValue != null && d.hasOwnProperty("intValue") && (typeof d.intValue == "number" ? H.intValue = k.longs === String ? String(d.intValue) : d.intValue : H.intValue = k.longs === String ? $util.Long.prototype.toString.call(d.intValue) : k.longs === Number ? new $util.LongBits(d.intValue.low >>> 0, d.intValue.high >>> 0).toNumber() : d.intValue, k.oneofs && (H.sum = "intValue")), d.count != null && d.hasOwnProperty("count") && (typeof d.count == "number" ? H.count = k.longs === String ? String(d.count) : d.count : H.count = k.longs === String ? $util.Long.prototype.toString.call(d.count) : k.longs === Number ? new $util.LongBits(d.count.low >>> 0, d.count.high >>> 0).toNumber(!0) : d.count), d.created != null && d.hasOwnProperty("created") && (H.created = $root.google.protobuf.Timestamp.toObject(d.created, k)), d.quantile && d.quantile.length) {
        H.quantile = [];
        for (let AA = 0; AA < d.quantile.length; ++AA) H.quantile[AA] = $root.openmetrics.SummaryValue.Quantile.toObject(d.quantile[AA], k);
      }
      return H;
    }, t.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, t.getTypeUrl = function(d) {
      return d === void 0 && (d = "type.googleapis.com"), d + "/openmetrics.SummaryValue";
    }, t.Quantile = (function() {
      function d(k) {
        if (k) for (let H = Object.keys(k), AA = 0; AA < H.length; ++AA) k[H[AA]] != null && (this[H[AA]] = k[H[AA]]);
      }
      return d.prototype.quantile = 0, d.prototype.value = 0, d.create = function(k) {
        return new d(k);
      }, d.encode = function(k, H) {
        return H || (H = $Writer.create()), k.quantile != null && Object.hasOwnProperty.call(k, "quantile") && H.uint32(
          /* id 1, wireType 1 =*/
          9
        ).double(k.quantile), k.value != null && Object.hasOwnProperty.call(k, "value") && H.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(k.value), H;
      }, d.encodeDelimited = function(k, H) {
        return this.encode(k, H).ldelim();
      }, d.decode = function(k, H, AA) {
        k instanceof $Reader || (k = $Reader.create(k));
        let gA = H === void 0 ? k.len : k.pos + H, IA = new $root.openmetrics.SummaryValue.Quantile();
        for (; k.pos < gA; ) {
          let CA = k.uint32();
          if (CA === AA) break;
          switch (CA >>> 3) {
            case 1: {
              IA.quantile = k.double();
              break;
            }
            case 2: {
              IA.value = k.double();
              break;
            }
            default:
              k.skipType(CA & 7);
              break;
          }
        }
        return IA;
      }, d.decodeDelimited = function(k) {
        return k instanceof $Reader || (k = new $Reader(k)), this.decode(k, k.uint32());
      }, d.verify = function(k) {
        return typeof k != "object" || k === null ? "object expected" : k.quantile != null && k.hasOwnProperty("quantile") && typeof k.quantile != "number" ? "quantile: number expected" : k.value != null && k.hasOwnProperty("value") && typeof k.value != "number" ? "value: number expected" : null;
      }, d.fromObject = function(k) {
        if (k instanceof $root.openmetrics.SummaryValue.Quantile) return k;
        let H = new $root.openmetrics.SummaryValue.Quantile();
        return k.quantile != null && (H.quantile = Number(k.quantile)), k.value != null && (H.value = Number(k.value)), H;
      }, d.toObject = function(k, H) {
        H || (H = {});
        let AA = {};
        return H.defaults && (AA.quantile = 0, AA.value = 0), k.quantile != null && k.hasOwnProperty("quantile") && (AA.quantile = H.json && !isFinite(k.quantile) ? String(k.quantile) : k.quantile), k.value != null && k.hasOwnProperty("value") && (AA.value = H.json && !isFinite(k.value) ? String(k.value) : k.value), AA;
      }, d.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, d.getTypeUrl = function(k) {
        return k === void 0 && (k = "type.googleapis.com"), k + "/openmetrics.SummaryValue.Quantile";
      }, d;
    })(), t;
  })(), n;
})();
$root.google = (() => {
  const n = {};
  return n.protobuf = (function() {
    const t = {};
    return t.Timestamp = (function() {
      function g(d) {
        if (d) for (let k = Object.keys(d), H = 0; H < k.length; ++H) d[k[H]] != null && (this[k[H]] = d[k[H]]);
      }
      return g.prototype.seconds = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, g.prototype.nanos = 0, g.create = function(d) {
        return new g(d);
      }, g.encode = function(d, k) {
        return k || (k = $Writer.create()), d.seconds != null && Object.hasOwnProperty.call(d, "seconds") && k.uint32(
          /* id 1, wireType 0 =*/
          8
        ).int64(d.seconds), d.nanos != null && Object.hasOwnProperty.call(d, "nanos") && k.uint32(
          /* id 2, wireType 0 =*/
          16
        ).int32(d.nanos), k;
      }, g.encodeDelimited = function(d, k) {
        return this.encode(d, k).ldelim();
      }, g.decode = function(d, k, H) {
        d instanceof $Reader || (d = $Reader.create(d));
        let AA = k === void 0 ? d.len : d.pos + k, gA = new $root.google.protobuf.Timestamp();
        for (; d.pos < AA; ) {
          let IA = d.uint32();
          if (IA === H) break;
          switch (IA >>> 3) {
            case 1: {
              gA.seconds = d.int64();
              break;
            }
            case 2: {
              gA.nanos = d.int32();
              break;
            }
            default:
              d.skipType(IA & 7);
              break;
          }
        }
        return gA;
      }, g.decodeDelimited = function(d) {
        return d instanceof $Reader || (d = new $Reader(d)), this.decode(d, d.uint32());
      }, g.verify = function(d) {
        return typeof d != "object" || d === null ? "object expected" : d.seconds != null && d.hasOwnProperty("seconds") && !$util.isInteger(d.seconds) && !(d.seconds && $util.isInteger(d.seconds.low) && $util.isInteger(d.seconds.high)) ? "seconds: integer|Long expected" : d.nanos != null && d.hasOwnProperty("nanos") && !$util.isInteger(d.nanos) ? "nanos: integer expected" : null;
      }, g.fromObject = function(d) {
        if (d instanceof $root.google.protobuf.Timestamp) return d;
        let k = new $root.google.protobuf.Timestamp();
        return d.seconds != null && ($util.Long ? (k.seconds = $util.Long.fromValue(d.seconds)).unsigned = !1 : typeof d.seconds == "string" ? k.seconds = parseInt(d.seconds, 10) : typeof d.seconds == "number" ? k.seconds = d.seconds : typeof d.seconds == "object" && (k.seconds = new $util.LongBits(d.seconds.low >>> 0, d.seconds.high >>> 0).toNumber())), d.nanos != null && (k.nanos = d.nanos | 0), k;
      }, g.toObject = function(d, k) {
        k || (k = {});
        let H = {};
        if (k.defaults) {
          if ($util.Long) {
            let AA = new $util.Long(0, 0, !1);
            H.seconds = k.longs === String ? AA.toString() : k.longs === Number ? AA.toNumber() : AA;
          } else H.seconds = k.longs === String ? "0" : 0;
          H.nanos = 0;
        }
        return d.seconds != null && d.hasOwnProperty("seconds") && (typeof d.seconds == "number" ? H.seconds = k.longs === String ? String(d.seconds) : d.seconds : H.seconds = k.longs === String ? $util.Long.prototype.toString.call(d.seconds) : k.longs === Number ? new $util.LongBits(d.seconds.low >>> 0, d.seconds.high >>> 0).toNumber() : d.seconds), d.nanos != null && d.hasOwnProperty("nanos") && (H.nanos = d.nanos), H;
      }, g.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, g.getTypeUrl = function(d) {
        return d === void 0 && (d = "type.googleapis.com"), d + "/google.protobuf.Timestamp";
      }, g;
    })(), t;
  })(), n;
})();
$root.RootContainer = (() => {
  const n = {}, t = Object.create(n);
  return t[n[0] = "MAIN"] = 0, t[n[1] = "SIDEBAR"] = 1, t[n[2] = "EVENT"] = 2, t[n[3] = "BOTTOM"] = 3, t;
})();
typeof Promise.withResolvers > "u" && (Promise.withResolvers = () => {
  let n, t;
  const g = new Promise((d, k) => {
    n = d, t = k;
  });
  return { resolve: n, reject: t, promise: g };
});
loglevelExports.getLogger("StaticConnection");
function bind$3(n, t) {
  return function() {
    return n.apply(t, arguments);
  };
}
const { toString: toString$7 } = Object.prototype, { getPrototypeOf: getPrototypeOf$2 } = Object, { iterator: iterator$1, toStringTag: toStringTag$1 } = Symbol, kindOf$1 = /* @__PURE__ */ ((n) => (t) => {
  const g = toString$7.call(t);
  return n[g] || (n[g] = g.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest$1 = (n) => (n = n.toLowerCase(), (t) => kindOf$1(t) === n), typeOfTest$1 = (n) => (t) => typeof t === n, { isArray: isArray$5 } = Array, isUndefined$3 = typeOfTest$1("undefined");
function isBuffer$4(n) {
  return n !== null && !isUndefined$3(n) && n.constructor !== null && !isUndefined$3(n.constructor) && isFunction$1$1(n.constructor.isBuffer) && n.constructor.isBuffer(n);
}
const isArrayBuffer$1 = kindOfTest$1("ArrayBuffer");
function isArrayBufferView$1(n) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(n) : t = n && n.buffer && isArrayBuffer$1(n.buffer), t;
}
const isString$4 = typeOfTest$1("string"), isFunction$1$1 = typeOfTest$1("function"), isNumber$7 = typeOfTest$1("number"), isObject$9 = (n) => n !== null && typeof n == "object", isBoolean$6 = (n) => n === !0 || n === !1, isPlainObject$5 = (n) => {
  if (kindOf$1(n) !== "object") return !1;
  const t = getPrototypeOf$2(n);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(toStringTag$1 in n) && !(iterator$1 in n);
}, isEmptyObject$1 = (n) => {
  if (!isObject$9(n) || isBuffer$4(n)) return !1;
  try {
    return Object.keys(n).length === 0 && Object.getPrototypeOf(n) === Object.prototype;
  } catch {
    return !1;
  }
}, isDate$4 = kindOfTest$1("Date"), isFile$2 = kindOfTest$1("File"), isBlob$1 = kindOfTest$1("Blob"), isFileList$1 = kindOfTest$1("FileList"), isStream$1 = (n) => isObject$9(n) && isFunction$1$1(n.pipe), isFormData$2 = (n) => {
  let t;
  return n && (typeof FormData == "function" && n instanceof FormData || isFunction$1$1(n.append) && ((t = kindOf$1(n)) === "formdata" || // detect form-data instance
  t === "object" && isFunction$1$1(n.toString) && n.toString() === "[object FormData]"));
}, isURLSearchParams$1 = kindOfTest$1("URLSearchParams"), [isReadableStream$1, isRequest$1, isResponse$1, isHeaders$1] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest$1), trim$2 = (n) => n.trim ? n.trim() : n.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach$3(n, t, { allOwnKeys: g = !1 } = {}) {
  if (n === null || typeof n > "u") return;
  let d, k;
  if (typeof n != "object" && (n = [n]), isArray$5(n)) for (d = 0, k = n.length; d < k; d++) t.call(null, n[d], d, n);
  else {
    if (isBuffer$4(n)) return;
    const H = g ? Object.getOwnPropertyNames(n) : Object.keys(n), AA = H.length;
    let gA;
    for (d = 0; d < AA; d++) gA = H[d], t.call(null, n[gA], gA, n);
  }
}
function findKey$1(n, t) {
  if (isBuffer$4(n)) return null;
  t = t.toLowerCase();
  const g = Object.keys(n);
  let d = g.length, k;
  for (; d-- > 0; ) if (k = g[d], t === k.toLowerCase()) return k;
  return null;
}
const _global$1 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, isContextDefined$1 = (n) => !isUndefined$3(n) && n !== _global$1;
function merge$9() {
  const { caseless: n, skipUndefined: t } = isContextDefined$1(this) && this || {}, g = {}, d = (k, H) => {
    const AA = n && findKey$1(g, H) || H;
    isPlainObject$5(g[AA]) && isPlainObject$5(k) ? g[AA] = merge$9(g[AA], k) : isPlainObject$5(k) ? g[AA] = merge$9({}, k) : isArray$5(k) ? g[AA] = k.slice() : (!t || !isUndefined$3(k)) && (g[AA] = k);
  };
  for (let k = 0, H = arguments.length; k < H; k++) arguments[k] && forEach$3(arguments[k], d);
  return g;
}
const extend$6 = (n, t, g, { allOwnKeys: d } = {}) => (forEach$3(t, (k, H) => {
  g && isFunction$1$1(k) ? n[H] = bind$3(k, g) : n[H] = k;
}, { allOwnKeys: d }), n), stripBOM$1 = (n) => (n.charCodeAt(0) === 65279 && (n = n.slice(1)), n), inherits$2 = (n, t, g, d) => {
  n.prototype = Object.create(t.prototype, d), n.prototype.constructor = n, Object.defineProperty(n, "super", { value: t.prototype }), g && Object.assign(n.prototype, g);
}, toFlatObject$1 = (n, t, g, d) => {
  let k, H, AA;
  const gA = {};
  if (t = t || {}, n == null) return t;
  do {
    for (k = Object.getOwnPropertyNames(n), H = k.length; H-- > 0; ) AA = k[H], (!d || d(AA, n, t)) && !gA[AA] && (t[AA] = n[AA], gA[AA] = !0);
    n = g !== !1 && getPrototypeOf$2(n);
  } while (n && (!g || g(n, t)) && n !== Object.prototype);
  return t;
}, endsWith$1 = (n, t, g) => {
  n = String(n), (g === void 0 || g > n.length) && (g = n.length), g -= t.length;
  const d = n.indexOf(t, g);
  return d !== -1 && d === g;
}, toArray$5 = (n) => {
  if (!n) return null;
  if (isArray$5(n)) return n;
  let t = n.length;
  if (!isNumber$7(t)) return null;
  const g = new Array(t);
  for (; t-- > 0; ) g[t] = n[t];
  return g;
}, isTypedArray$2 = /* @__PURE__ */ ((n) => (t) => n && t instanceof n)(typeof Uint8Array < "u" && getPrototypeOf$2(Uint8Array)), forEachEntry$1 = (n, t) => {
  const g = (n && n[iterator$1]).call(n);
  let d;
  for (; (d = g.next()) && !d.done; ) {
    const k = d.value;
    t.call(n, k[0], k[1]);
  }
}, matchAll$1 = (n, t) => {
  let g;
  const d = [];
  for (; (g = n.exec(t)) !== null; ) d.push(g);
  return d;
}, isHTMLForm$1 = kindOfTest$1("HTMLFormElement"), toCamelCase$1 = (n) => n.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, g, d) {
  return g.toUpperCase() + d;
}), hasOwnProperty$f = (({ hasOwnProperty: n }) => (t, g) => n.call(t, g))(Object.prototype), isRegExp$2 = kindOfTest$1("RegExp"), reduceDescriptors$1 = (n, t) => {
  const g = Object.getOwnPropertyDescriptors(n), d = {};
  forEach$3(g, (k, H) => {
    let AA;
    (AA = t(k, H, n)) !== !1 && (d[H] = AA || k);
  }), Object.defineProperties(n, d);
}, freezeMethods$1 = (n) => {
  reduceDescriptors$1(n, (t, g) => {
    if (isFunction$1$1(n) && ["arguments", "caller", "callee"].indexOf(g) !== -1) return !1;
    const d = n[g];
    if (isFunction$1$1(d)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + g + "'");
      });
    }
  });
}, toObjectSet$1 = (n, t) => {
  const g = {}, d = (k) => {
    k.forEach((H) => {
      g[H] = !0;
    });
  };
  return isArray$5(n) ? d(n) : d(String(n).split(t)), g;
}, noop$7 = () => {
}, toFiniteNumber$1 = (n, t) => n != null && Number.isFinite(n = +n) ? n : t;
function isSpecCompliantForm$1(n) {
  return !!(n && isFunction$1$1(n.append) && n[toStringTag$1] === "FormData" && n[iterator$1]);
}
const toJSONObject$1 = (n) => {
  const t = new Array(10), g = (d, k) => {
    if (isObject$9(d)) {
      if (t.indexOf(d) >= 0) return;
      if (isBuffer$4(d)) return d;
      if (!("toJSON" in d)) {
        t[k] = d;
        const H = isArray$5(d) ? [] : {};
        return forEach$3(d, (AA, gA) => {
          const IA = g(AA, k + 1);
          !isUndefined$3(IA) && (H[gA] = IA);
        }), t[k] = void 0, H;
      }
    }
    return d;
  };
  return g(n, 0);
}, isAsyncFn$1 = kindOfTest$1("AsyncFunction"), isThenable$1 = (n) => n && (isObject$9(n) || isFunction$1$1(n)) && isFunction$1$1(n.then) && isFunction$1$1(n.catch), _setImmediate$1 = ((n, t) => n ? setImmediate : t ? ((g, d) => (_global$1.addEventListener("message", ({ source: k, data: H }) => {
  k === _global$1 && H === g && d.length && d.shift()();
}, !1), (k) => {
  d.push(k), _global$1.postMessage(g, "*");
}))(`axios@${Math.random()}`, []) : (g) => setTimeout(g))(typeof setImmediate == "function", isFunction$1$1(_global$1.postMessage)), asap$1 = typeof queueMicrotask < "u" ? queueMicrotask.bind(_global$1) : typeof process < "u" && process.nextTick || _setImmediate$1, isIterable$3 = (n) => n != null && isFunction$1$1(n[iterator$1]), utils$1$1 = {
  isArray: isArray$5,
  isArrayBuffer: isArrayBuffer$1,
  isBuffer: isBuffer$4,
  isFormData: isFormData$2,
  isArrayBufferView: isArrayBufferView$1,
  isString: isString$4,
  isNumber: isNumber$7,
  isBoolean: isBoolean$6,
  isObject: isObject$9,
  isPlainObject: isPlainObject$5,
  isEmptyObject: isEmptyObject$1,
  isReadableStream: isReadableStream$1,
  isRequest: isRequest$1,
  isResponse: isResponse$1,
  isHeaders: isHeaders$1,
  isUndefined: isUndefined$3,
  isDate: isDate$4,
  isFile: isFile$2,
  isBlob: isBlob$1,
  isRegExp: isRegExp$2,
  isFunction: isFunction$1$1,
  isStream: isStream$1,
  isURLSearchParams: isURLSearchParams$1,
  isTypedArray: isTypedArray$2,
  isFileList: isFileList$1,
  forEach: forEach$3,
  merge: merge$9,
  extend: extend$6,
  trim: trim$2,
  stripBOM: stripBOM$1,
  inherits: inherits$2,
  toFlatObject: toFlatObject$1,
  kindOf: kindOf$1,
  kindOfTest: kindOfTest$1,
  endsWith: endsWith$1,
  toArray: toArray$5,
  forEachEntry: forEachEntry$1,
  matchAll: matchAll$1,
  isHTMLForm: isHTMLForm$1,
  hasOwnProperty: hasOwnProperty$f,
  hasOwnProp: hasOwnProperty$f,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: reduceDescriptors$1,
  freezeMethods: freezeMethods$1,
  toObjectSet: toObjectSet$1,
  toCamelCase: toCamelCase$1,
  noop: noop$7,
  toFiniteNumber: toFiniteNumber$1,
  findKey: findKey$1,
  global: _global$1,
  isContextDefined: isContextDefined$1,
  isSpecCompliantForm: isSpecCompliantForm$1,
  toJSONObject: toJSONObject$1,
  isAsyncFn: isAsyncFn$1,
  isThenable: isThenable$1,
  setImmediate: _setImmediate$1,
  asap: asap$1,
  isIterable: isIterable$3
};
function AxiosError$1$1(n, t, g, d, k) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = n, this.name = "AxiosError", t && (this.code = t), g && (this.config = g), d && (this.request = d), k && (this.response = k, this.status = k.status ? k.status : null);
}
utils$1$1.inherits(AxiosError$1$1, Error, { toJSON: function n() {
  return {
    // Standard
    message: this.message,
    name: this.name,
    // Microsoft
    description: this.description,
    number: this.number,
    // Mozilla
    fileName: this.fileName,
    lineNumber: this.lineNumber,
    columnNumber: this.columnNumber,
    stack: this.stack,
    // Axios
    config: utils$1$1.toJSONObject(this.config),
    code: this.code,
    status: this.status
  };
} });
const prototype$1$2 = AxiosError$1$1.prototype, descriptors$1 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((n) => {
  descriptors$1[n] = { value: n };
});
Object.defineProperties(AxiosError$1$1, descriptors$1);
Object.defineProperty(prototype$1$2, "isAxiosError", { value: !0 });
AxiosError$1$1.from = (n, t, g, d, k, H) => {
  const AA = Object.create(prototype$1$2);
  utils$1$1.toFlatObject(n, AA, function(CA) {
    return CA !== Error.prototype;
  }, (CA) => CA !== "isAxiosError");
  const gA = n && n.message ? n.message : "Error", IA = t == null && n ? n.code : t;
  return AxiosError$1$1.call(AA, gA, IA, g, d, k), n && AA.cause == null && Object.defineProperty(AA, "cause", { value: n, configurable: !0 }), AA.name = n && n.name || "Error", H && Object.assign(AA, H), AA;
};
const httpAdapter$1 = null;
function isVisitable$1(n) {
  return utils$1$1.isPlainObject(n) || utils$1$1.isArray(n);
}
function removeBrackets$1(n) {
  return utils$1$1.endsWith(n, "[]") ? n.slice(0, -2) : n;
}
function renderKey$1(n, t, g) {
  return n ? n.concat(t).map(function(d, k) {
    return d = removeBrackets$1(d), !g && k ? "[" + d + "]" : d;
  }).join(g ? "." : "") : t;
}
function isFlatArray$1(n) {
  return utils$1$1.isArray(n) && !n.some(isVisitable$1);
}
const predicates$1 = utils$1$1.toFlatObject(utils$1$1, {}, null, function n(t) {
  return /^is[A-Z]/.test(t);
});
function toFormData$1$1(n, t, g) {
  if (!utils$1$1.isObject(n)) throw new TypeError("target must be an object");
  t = t || new FormData(), g = utils$1$1.toFlatObject(g, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(QA, tA) {
    return !utils$1$1.isUndefined(tA[QA]);
  });
  const d = g.metaTokens, k = g.visitor || CA, H = g.dots, AA = g.indexes, gA = (g.Blob || typeof Blob < "u" && Blob) && utils$1$1.isSpecCompliantForm(t);
  if (!utils$1$1.isFunction(k)) throw new TypeError("visitor must be a function");
  function IA(QA) {
    if (QA === null) return "";
    if (utils$1$1.isDate(QA)) return QA.toISOString();
    if (utils$1$1.isBoolean(QA)) return QA.toString();
    if (!gA && utils$1$1.isBlob(QA)) throw new AxiosError$1$1("Blob is not supported. Use a Buffer instead.");
    return utils$1$1.isArrayBuffer(QA) || utils$1$1.isTypedArray(QA) ? gA && typeof Blob == "function" ? new Blob([QA]) : Buffer.from(QA) : QA;
  }
  function CA(QA, tA, oA) {
    let EA = QA;
    if (QA && !oA && typeof QA == "object") {
      if (utils$1$1.endsWith(tA, "{}")) tA = d ? tA : tA.slice(0, -2), QA = JSON.stringify(QA);
      else if (utils$1$1.isArray(QA) && isFlatArray$1(QA) || (utils$1$1.isFileList(QA) || utils$1$1.endsWith(tA, "[]")) && (EA = utils$1$1.toArray(QA))) return tA = removeBrackets$1(tA), EA.forEach(function(aA, nA) {
        !(utils$1$1.isUndefined(aA) || aA === null) && t.append(
          // eslint-disable-next-line no-nested-ternary
          AA === !0 ? renderKey$1([tA], nA, H) : AA === null ? tA : tA + "[]",
          IA(aA)
        );
      }), !1;
    }
    return isVisitable$1(QA) ? !0 : (t.append(renderKey$1(oA, tA, H), IA(QA)), !1);
  }
  const BA = [], eA = Object.assign(predicates$1, { defaultVisitor: CA, convertValue: IA, isVisitable: isVisitable$1 });
  function iA(QA, tA) {
    if (!utils$1$1.isUndefined(QA)) {
      if (BA.indexOf(QA) !== -1) throw Error("Circular reference detected in " + tA.join("."));
      BA.push(QA), utils$1$1.forEach(QA, function(oA, EA) {
        (!(utils$1$1.isUndefined(oA) || oA === null) && k.call(t, oA, utils$1$1.isString(EA) ? EA.trim() : EA, tA, eA)) === !0 && iA(oA, tA ? tA.concat(EA) : [EA]);
      }), BA.pop();
    }
  }
  if (!utils$1$1.isObject(n)) throw new TypeError("data must be an object");
  return iA(n), t;
}
function encode$1$1(n) {
  const t = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(n).replace(/[!'()~]|%20|%00/g, function(g) {
    return t[g];
  });
}
function AxiosURLSearchParams$1(n, t) {
  this._pairs = [], n && toFormData$1$1(n, this, t);
}
const prototype$3 = AxiosURLSearchParams$1.prototype;
prototype$3.append = function n(t, g) {
  this._pairs.push([t, g]);
};
prototype$3.toString = function n(t) {
  const g = t ? function(d) {
    return t.call(this, d, encode$1$1);
  } : encode$1$1;
  return this._pairs.map(function(d) {
    return g(d[0]) + "=" + g(d[1]);
  }, "").join("&");
};
function encode$5(n) {
  return encodeURIComponent(n).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function buildURL$1(n, t, g) {
  if (!t) return n;
  const d = g && g.encode || encode$5;
  utils$1$1.isFunction(g) && (g = { serialize: g });
  const k = g && g.serialize;
  let H;
  if (k ? H = k(t, g) : H = utils$1$1.isURLSearchParams(t) ? t.toString() : new AxiosURLSearchParams$1(t, g).toString(d), H) {
    const AA = n.indexOf("#");
    AA !== -1 && (n = n.slice(0, AA)), n += (n.indexOf("?") === -1 ? "?" : "&") + H;
  }
  return n;
}
let InterceptorManager$1 = class {
  constructor() {
    this.handlers = [];
  }
  /**
  * Add a new interceptor to the stack
  *
  * @param {Function} fulfilled The function to handle `then` for a `Promise`
  * @param {Function} rejected The function to handle `reject` for a `Promise`
  *
  * @return {Number} An ID used to remove interceptor later
  */
  use(t, g, d) {
    return this.handlers.push({ fulfilled: t, rejected: g, synchronous: d ? d.synchronous : !1, runWhen: d ? d.runWhen : null }), this.handlers.length - 1;
  }
  /**
  * Remove an interceptor from the stack
  *
  * @param {Number} id The ID that was returned by `use`
  *
  * @returns {void}
  */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
  * Clear all interceptors from the stack
  *
  * @returns {void}
  */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
  * Iterate over all the registered interceptors
  *
  * This method is particularly useful for skipping over any
  * interceptors that may have become `null` calling `eject`.
  *
  * @param {Function} fn The function to call for each interceptor
  *
  * @returns {void}
  */
  forEach(t) {
    utils$1$1.forEach(this.handlers, function(g) {
      g !== null && t(g);
    });
  }
};
const transitionalDefaults$1 = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, URLSearchParams$1$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams$1, FormData$1$1 = typeof FormData < "u" ? FormData : null, Blob$1$1 = typeof Blob < "u" ? Blob : null, platform$1$1 = { isBrowser: !0, classes: { URLSearchParams: URLSearchParams$1$1, FormData: FormData$1$1, Blob: Blob$1$1 }, protocols: ["http", "https", "file", "blob", "url", "data"] }, hasBrowserEnv$1 = typeof window < "u" && typeof document < "u", _navigator$1 = typeof navigator == "object" && navigator || void 0, hasStandardBrowserEnv$1 = hasBrowserEnv$1 && (!_navigator$1 || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator$1.product) < 0), hasStandardBrowserWebWorkerEnv$1 = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", origin$1 = hasBrowserEnv$1 && window.location.href || "http://localhost", utils$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({ __proto__: null, hasBrowserEnv: hasBrowserEnv$1, hasStandardBrowserEnv: hasStandardBrowserEnv$1, hasStandardBrowserWebWorkerEnv: hasStandardBrowserWebWorkerEnv$1, navigator: _navigator$1, origin: origin$1 }, Symbol.toStringTag, { value: "Module" })), platform$2 = { ...utils$3, ...platform$1$1 };
function toURLEncodedForm$1(n, t) {
  return toFormData$1$1(n, new platform$2.classes.URLSearchParams(), { visitor: function(g, d, k, H) {
    return platform$2.isNode && utils$1$1.isBuffer(g) ? (this.append(d, g.toString("base64")), !1) : H.defaultVisitor.apply(this, arguments);
  }, ...t });
}
function parsePropPath$1(n) {
  return utils$1$1.matchAll(/\w+|\[(\w*)]/g, n).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function arrayToObject$1(n) {
  const t = {}, g = Object.keys(n);
  let d;
  const k = g.length;
  let H;
  for (d = 0; d < k; d++) H = g[d], t[H] = n[H];
  return t;
}
function formDataToJSON$1(n) {
  function t(g, d, k, H) {
    let AA = g[H++];
    if (AA === "__proto__") return !0;
    const gA = Number.isFinite(+AA), IA = H >= g.length;
    return AA = !AA && utils$1$1.isArray(k) ? k.length : AA, IA ? (utils$1$1.hasOwnProp(k, AA) ? k[AA] = [k[AA], d] : k[AA] = d, !gA) : ((!k[AA] || !utils$1$1.isObject(k[AA])) && (k[AA] = []), t(g, d, k[AA], H) && utils$1$1.isArray(k[AA]) && (k[AA] = arrayToObject$1(k[AA])), !gA);
  }
  if (utils$1$1.isFormData(n) && utils$1$1.isFunction(n.entries)) {
    const g = {};
    return utils$1$1.forEachEntry(n, (d, k) => {
      t(parsePropPath$1(d), k, g, 0);
    }), g;
  }
  return null;
}
function stringifySafely$1(n, t, g) {
  if (utils$1$1.isString(n)) try {
    return (t || JSON.parse)(n), utils$1$1.trim(n);
  } catch (d) {
    if (d.name !== "SyntaxError") throw d;
  }
  return (g || JSON.stringify)(n);
}
const defaults$3 = {
  transitional: transitionalDefaults$1,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function n(t, g) {
    const d = g.getContentType() || "", k = d.indexOf("application/json") > -1, H = utils$1$1.isObject(t);
    if (H && utils$1$1.isHTMLForm(t) && (t = new FormData(t)), utils$1$1.isFormData(t)) return k ? JSON.stringify(formDataToJSON$1(t)) : t;
    if (utils$1$1.isArrayBuffer(t) || utils$1$1.isBuffer(t) || utils$1$1.isStream(t) || utils$1$1.isFile(t) || utils$1$1.isBlob(t) || utils$1$1.isReadableStream(t)) return t;
    if (utils$1$1.isArrayBufferView(t)) return t.buffer;
    if (utils$1$1.isURLSearchParams(t)) return g.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let AA;
    if (H) {
      if (d.indexOf("application/x-www-form-urlencoded") > -1) return toURLEncodedForm$1(t, this.formSerializer).toString();
      if ((AA = utils$1$1.isFileList(t)) || d.indexOf("multipart/form-data") > -1) {
        const gA = this.env && this.env.FormData;
        return toFormData$1$1(AA ? { "files[]": t } : t, gA && new gA(), this.formSerializer);
      }
    }
    return H || k ? (g.setContentType("application/json", !1), stringifySafely$1(t)) : t;
  }],
  transformResponse: [function n(t) {
    const g = this.transitional || defaults$3.transitional, d = g && g.forcedJSONParsing, k = this.responseType === "json";
    if (utils$1$1.isResponse(t) || utils$1$1.isReadableStream(t)) return t;
    if (t && utils$1$1.isString(t) && (d && !this.responseType || k)) {
      const H = !(g && g.silentJSONParsing) && k;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (AA) {
        if (H) throw AA.name === "SyntaxError" ? AxiosError$1$1.from(AA, AxiosError$1$1.ERR_BAD_RESPONSE, this, null, this.response) : AA;
      }
    }
    return t;
  }],
  /**
  * A timeout in milliseconds to abort a request. If set to 0 (default) a
  * timeout is not created.
  */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: { FormData: platform$2.classes.FormData, Blob: platform$2.classes.Blob },
  validateStatus: function n(t) {
    return t >= 200 && t < 300;
  },
  headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } }
};
utils$1$1.forEach(["delete", "get", "head", "post", "put", "patch"], (n) => {
  defaults$3.headers[n] = {};
});
const ignoreDuplicateOf$1 = utils$1$1.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), parseHeaders$1 = (n) => {
  const t = {};
  let g, d, k;
  return n && n.split(`
`).forEach(function(H) {
    k = H.indexOf(":"), g = H.substring(0, k).trim().toLowerCase(), d = H.substring(k + 1).trim(), !(!g || t[g] && ignoreDuplicateOf$1[g]) && (g === "set-cookie" ? t[g] ? t[g].push(d) : t[g] = [d] : t[g] = t[g] ? t[g] + ", " + d : d);
  }), t;
}, $internals$1 = Symbol("internals");
function normalizeHeader$1(n) {
  return n && String(n).trim().toLowerCase();
}
function normalizeValue$2(n) {
  return n === !1 || n == null ? n : utils$1$1.isArray(n) ? n.map(normalizeValue$2) : String(n);
}
function parseTokens$1(n) {
  const t = /* @__PURE__ */ Object.create(null), g = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let d;
  for (; d = g.exec(n); ) t[d[1]] = d[2];
  return t;
}
const isValidHeaderName$1 = (n) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(n.trim());
function matchHeaderValue$1(n, t, g, d, k) {
  if (utils$1$1.isFunction(d)) return d.call(this, t, g);
  if (k && (t = g), !!utils$1$1.isString(t)) {
    if (utils$1$1.isString(d)) return t.indexOf(d) !== -1;
    if (utils$1$1.isRegExp(d)) return d.test(t);
  }
}
function formatHeader$1(n) {
  return n.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, g, d) => g.toUpperCase() + d);
}
function buildAccessors$1(n, t) {
  const g = utils$1$1.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((d) => {
    Object.defineProperty(n, d + g, { value: function(k, H, AA) {
      return this[d].call(this, t, k, H, AA);
    }, configurable: !0 });
  });
}
let AxiosHeaders$1$1 = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, g, d) {
    const k = this;
    function H(gA, IA, CA) {
      const BA = normalizeHeader$1(IA);
      if (!BA) throw new Error("header name must be a non-empty string");
      const eA = utils$1$1.findKey(k, BA);
      (!eA || k[eA] === void 0 || CA === !0 || CA === void 0 && k[eA] !== !1) && (k[eA || IA] = normalizeValue$2(gA));
    }
    const AA = (gA, IA) => utils$1$1.forEach(gA, (CA, BA) => H(CA, BA, IA));
    if (utils$1$1.isPlainObject(t) || t instanceof this.constructor) AA(t, g);
    else if (utils$1$1.isString(t) && (t = t.trim()) && !isValidHeaderName$1(t)) AA(parseHeaders$1(t), g);
    else if (utils$1$1.isObject(t) && utils$1$1.isIterable(t)) {
      let gA = {}, IA, CA;
      for (const BA of t) {
        if (!utils$1$1.isArray(BA)) throw TypeError("Object iterator must return a key-value pair");
        gA[CA = BA[0]] = (IA = gA[CA]) ? utils$1$1.isArray(IA) ? [...IA, BA[1]] : [IA, BA[1]] : BA[1];
      }
      AA(gA, g);
    } else t != null && H(g, t, d);
    return this;
  }
  get(t, g) {
    if (t = normalizeHeader$1(t), t) {
      const d = utils$1$1.findKey(this, t);
      if (d) {
        const k = this[d];
        if (!g) return k;
        if (g === !0) return parseTokens$1(k);
        if (utils$1$1.isFunction(g)) return g.call(this, k, d);
        if (utils$1$1.isRegExp(g)) return g.exec(k);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, g) {
    if (t = normalizeHeader$1(t), t) {
      const d = utils$1$1.findKey(this, t);
      return !!(d && this[d] !== void 0 && (!g || matchHeaderValue$1(this, this[d], d, g)));
    }
    return !1;
  }
  delete(t, g) {
    const d = this;
    let k = !1;
    function H(AA) {
      if (AA = normalizeHeader$1(AA), AA) {
        const gA = utils$1$1.findKey(d, AA);
        gA && (!g || matchHeaderValue$1(d, d[gA], gA, g)) && (delete d[gA], k = !0);
      }
    }
    return utils$1$1.isArray(t) ? t.forEach(H) : H(t), k;
  }
  clear(t) {
    const g = Object.keys(this);
    let d = g.length, k = !1;
    for (; d--; ) {
      const H = g[d];
      (!t || matchHeaderValue$1(this, this[H], H, t, !0)) && (delete this[H], k = !0);
    }
    return k;
  }
  normalize(t) {
    const g = this, d = {};
    return utils$1$1.forEach(this, (k, H) => {
      const AA = utils$1$1.findKey(d, H);
      if (AA) {
        g[AA] = normalizeValue$2(k), delete g[H];
        return;
      }
      const gA = t ? formatHeader$1(H) : String(H).trim();
      gA !== H && delete g[H], g[gA] = normalizeValue$2(k), d[gA] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const g = /* @__PURE__ */ Object.create(null);
    return utils$1$1.forEach(this, (d, k) => {
      d != null && d !== !1 && (g[k] = t && utils$1$1.isArray(d) ? d.join(", ") : d);
    }), g;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, g]) => t + ": " + g).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...g) {
    const d = new this(t);
    return g.forEach((k) => d.set(k)), d;
  }
  static accessor(t) {
    const g = (this[$internals$1] = this[$internals$1] = { accessors: {} }).accessors, d = this.prototype;
    function k(H) {
      const AA = normalizeHeader$1(H);
      g[AA] || (buildAccessors$1(d, H), g[AA] = !0);
    }
    return utils$1$1.isArray(t) ? t.forEach(k) : k(t), this;
  }
};
AxiosHeaders$1$1.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1$1.reduceDescriptors(AxiosHeaders$1$1.prototype, ({ value: n }, t) => {
  let g = t[0].toUpperCase() + t.slice(1);
  return { get: () => n, set(d) {
    this[g] = d;
  } };
});
utils$1$1.freezeMethods(AxiosHeaders$1$1);
function transformData$1(n, t) {
  const g = this || defaults$3, d = t || g, k = AxiosHeaders$1$1.from(d.headers);
  let H = d.data;
  return utils$1$1.forEach(n, function(AA) {
    H = AA.call(g, H, k.normalize(), t ? t.status : void 0);
  }), k.normalize(), H;
}
function isCancel$1$1(n) {
  return !!(n && n.__CANCEL__);
}
function CanceledError$1$1(n, t, g) {
  AxiosError$1$1.call(this, n ?? "canceled", AxiosError$1$1.ERR_CANCELED, t, g), this.name = "CanceledError";
}
utils$1$1.inherits(CanceledError$1$1, AxiosError$1$1, { __CANCEL__: !0 });
function settle$1(n, t, g) {
  const d = g.config.validateStatus;
  !g.status || !d || d(g.status) ? n(g) : t(new AxiosError$1$1("Request failed with status code " + g.status, [AxiosError$1$1.ERR_BAD_REQUEST, AxiosError$1$1.ERR_BAD_RESPONSE][Math.floor(g.status / 100) - 4], g.config, g.request, g));
}
function parseProtocol$1(n) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(n);
  return t && t[1] || "";
}
function speedometer$1(n, t) {
  n = n || 10;
  const g = new Array(n), d = new Array(n);
  let k = 0, H = 0, AA;
  return t = t !== void 0 ? t : 1e3, function(gA) {
    const IA = Date.now(), CA = d[H];
    AA || (AA = IA), g[k] = gA, d[k] = IA;
    let BA = H, eA = 0;
    for (; BA !== k; ) eA += g[BA++], BA = BA % n;
    if (k = (k + 1) % n, k === H && (H = (H + 1) % n), IA - AA < t) return;
    const iA = CA && IA - CA;
    return iA ? Math.round(eA * 1e3 / iA) : void 0;
  };
}
function throttle$3(n, t) {
  let g = 0, d = 1e3 / t, k, H;
  const AA = (gA, IA = Date.now()) => {
    g = IA, k = null, H && (clearTimeout(H), H = null), n(...gA);
  };
  return [(...gA) => {
    const IA = Date.now(), CA = IA - g;
    CA >= d ? AA(gA, IA) : (k = gA, H || (H = setTimeout(() => {
      H = null, AA(k);
    }, d - CA)));
  }, () => k && AA(k)];
}
const progressEventReducer$1 = (n, t, g = 3) => {
  let d = 0;
  const k = speedometer$1(50, 250);
  return throttle$3((H) => {
    const AA = H.loaded, gA = H.lengthComputable ? H.total : void 0, IA = AA - d, CA = k(IA), BA = AA <= gA;
    d = AA;
    const eA = { loaded: AA, total: gA, progress: gA ? AA / gA : void 0, bytes: IA, rate: CA || void 0, estimated: CA && gA && BA ? (gA - AA) / CA : void 0, event: H, lengthComputable: gA != null, [t ? "download" : "upload"]: !0 };
    n(eA);
  }, g);
}, progressEventDecorator$1 = (n, t) => {
  const g = n != null;
  return [(d) => t[0]({ lengthComputable: g, total: n, loaded: d }), t[1]];
}, asyncDecorator$1 = (n) => (...t) => utils$1$1.asap(() => n(...t)), isURLSameOrigin$1 = platform$2.hasStandardBrowserEnv ? /* @__PURE__ */ ((n, t) => (g) => (g = new URL(g, platform$2.origin), n.protocol === g.protocol && n.host === g.host && (t || n.port === g.port)))(new URL(platform$2.origin), platform$2.navigator && /(msie|trident)/i.test(platform$2.navigator.userAgent)) : () => !0, cookies$1 = platform$2.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  { write(n, t, g, d, k, H, AA) {
    if (typeof document > "u") return;
    const gA = [`${n}=${encodeURIComponent(t)}`];
    utils$1$1.isNumber(g) && gA.push(`expires=${new Date(g).toUTCString()}`), utils$1$1.isString(d) && gA.push(`path=${d}`), utils$1$1.isString(k) && gA.push(`domain=${k}`), H === !0 && gA.push("secure"), utils$1$1.isString(AA) && gA.push(`SameSite=${AA}`), document.cookie = gA.join("; ");
  }, read(n) {
    if (typeof document > "u") return null;
    const t = document.cookie.match(new RegExp("(?:^|; )" + n + "=([^;]*)"));
    return t ? decodeURIComponent(t[1]) : null;
  }, remove(n) {
    this.write(n, "", Date.now() - 864e5, "/");
  } }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  { write() {
  }, read() {
    return null;
  }, remove() {
  } }
);
function isAbsoluteURL$1(n) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(n);
}
function combineURLs$1(n, t) {
  return t ? n.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : n;
}
function buildFullPath$1(n, t, g) {
  let d = !isAbsoluteURL$1(t);
  return n && (d || g == !1) ? combineURLs$1(n, t) : t;
}
const headersToObject$1 = (n) => n instanceof AxiosHeaders$1$1 ? { ...n } : n;
function mergeConfig$1$1(n, t) {
  t = t || {};
  const g = {};
  function d(CA, BA, eA, iA) {
    return utils$1$1.isPlainObject(CA) && utils$1$1.isPlainObject(BA) ? utils$1$1.merge.call({ caseless: iA }, CA, BA) : utils$1$1.isPlainObject(BA) ? utils$1$1.merge({}, BA) : utils$1$1.isArray(BA) ? BA.slice() : BA;
  }
  function k(CA, BA, eA, iA) {
    if (utils$1$1.isUndefined(BA)) {
      if (!utils$1$1.isUndefined(CA)) return d(void 0, CA, eA, iA);
    } else return d(CA, BA, eA, iA);
  }
  function H(CA, BA) {
    if (!utils$1$1.isUndefined(BA)) return d(void 0, BA);
  }
  function AA(CA, BA) {
    if (utils$1$1.isUndefined(BA)) {
      if (!utils$1$1.isUndefined(CA)) return d(void 0, CA);
    } else return d(void 0, BA);
  }
  function gA(CA, BA, eA) {
    if (eA in t) return d(CA, BA);
    if (eA in n) return d(void 0, CA);
  }
  const IA = { url: H, method: H, data: H, baseURL: AA, transformRequest: AA, transformResponse: AA, paramsSerializer: AA, timeout: AA, timeoutMessage: AA, withCredentials: AA, withXSRFToken: AA, adapter: AA, responseType: AA, xsrfCookieName: AA, xsrfHeaderName: AA, onUploadProgress: AA, onDownloadProgress: AA, decompress: AA, maxContentLength: AA, maxBodyLength: AA, beforeRedirect: AA, transport: AA, httpAgent: AA, httpsAgent: AA, cancelToken: AA, socketPath: AA, responseEncoding: AA, validateStatus: gA, headers: (CA, BA, eA) => k(headersToObject$1(CA), headersToObject$1(BA), eA, !0) };
  return utils$1$1.forEach(Object.keys({ ...n, ...t }), function(CA) {
    const BA = IA[CA] || k, eA = BA(n[CA], t[CA], CA);
    utils$1$1.isUndefined(eA) && BA !== gA || (g[CA] = eA);
  }), g;
}
const resolveConfig$1 = (n) => {
  const t = mergeConfig$1$1({}, n);
  let { data: g, withXSRFToken: d, xsrfHeaderName: k, xsrfCookieName: H, headers: AA, auth: gA } = t;
  if (t.headers = AA = AxiosHeaders$1$1.from(AA), t.url = buildURL$1(buildFullPath$1(t.baseURL, t.url, t.allowAbsoluteUrls), n.params, n.paramsSerializer), gA && AA.set("Authorization", "Basic " + btoa((gA.username || "") + ":" + (gA.password ? unescape(encodeURIComponent(gA.password)) : ""))), utils$1$1.isFormData(g)) {
    if (platform$2.hasStandardBrowserEnv || platform$2.hasStandardBrowserWebWorkerEnv) AA.setContentType(void 0);
    else if (utils$1$1.isFunction(g.getHeaders)) {
      const IA = g.getHeaders(), CA = ["content-type", "content-length"];
      Object.entries(IA).forEach(([BA, eA]) => {
        CA.includes(BA.toLowerCase()) && AA.set(BA, eA);
      });
    }
  }
  if (platform$2.hasStandardBrowserEnv && (d && utils$1$1.isFunction(d) && (d = d(t)), d || d !== !1 && isURLSameOrigin$1(t.url))) {
    const IA = k && H && cookies$1.read(H);
    IA && AA.set(k, IA);
  }
  return t;
}, isXHRAdapterSupported$1 = typeof XMLHttpRequest < "u", xhrAdapter$1 = isXHRAdapterSupported$1 && function(n) {
  return new Promise(function(t, g) {
    const d = resolveConfig$1(n);
    let k = d.data;
    const H = AxiosHeaders$1$1.from(d.headers).normalize();
    let { responseType: AA, onUploadProgress: gA, onDownloadProgress: IA } = d, CA, BA, eA, iA, QA;
    function tA() {
      iA && iA(), QA && QA(), d.cancelToken && d.cancelToken.unsubscribe(CA), d.signal && d.signal.removeEventListener("abort", CA);
    }
    let oA = new XMLHttpRequest();
    oA.open(d.method.toUpperCase(), d.url, !0), oA.timeout = d.timeout;
    function EA() {
      if (!oA) return;
      const nA = AxiosHeaders$1$1.from("getAllResponseHeaders" in oA && oA.getAllResponseHeaders()), lA = { data: !AA || AA === "text" || AA === "json" ? oA.responseText : oA.response, status: oA.status, statusText: oA.statusText, headers: nA, config: n, request: oA };
      settle$1(function(cA) {
        t(cA), tA();
      }, function(cA) {
        g(cA), tA();
      }, lA), oA = null;
    }
    "onloadend" in oA ? oA.onloadend = EA : oA.onreadystatechange = function() {
      !oA || oA.readyState !== 4 || oA.status === 0 && !(oA.responseURL && oA.responseURL.indexOf("file:") === 0) || setTimeout(EA);
    }, oA.onabort = function() {
      oA && (g(new AxiosError$1$1("Request aborted", AxiosError$1$1.ECONNABORTED, n, oA)), oA = null);
    }, oA.onerror = function(nA) {
      const lA = nA && nA.message ? nA.message : "Network Error", cA = new AxiosError$1$1(lA, AxiosError$1$1.ERR_NETWORK, n, oA);
      cA.event = nA || null, g(cA), oA = null;
    }, oA.ontimeout = function() {
      let nA = d.timeout ? "timeout of " + d.timeout + "ms exceeded" : "timeout exceeded";
      const lA = d.transitional || transitionalDefaults$1;
      d.timeoutErrorMessage && (nA = d.timeoutErrorMessage), g(new AxiosError$1$1(nA, lA.clarifyTimeoutError ? AxiosError$1$1.ETIMEDOUT : AxiosError$1$1.ECONNABORTED, n, oA)), oA = null;
    }, k === void 0 && H.setContentType(null), "setRequestHeader" in oA && utils$1$1.forEach(H.toJSON(), function(nA, lA) {
      oA.setRequestHeader(lA, nA);
    }), utils$1$1.isUndefined(d.withCredentials) || (oA.withCredentials = !!d.withCredentials), AA && AA !== "json" && (oA.responseType = d.responseType), IA && ([eA, QA] = progressEventReducer$1(IA, !0), oA.addEventListener("progress", eA)), gA && oA.upload && ([BA, iA] = progressEventReducer$1(gA), oA.upload.addEventListener("progress", BA), oA.upload.addEventListener("loadend", iA)), (d.cancelToken || d.signal) && (CA = (nA) => {
      oA && (g(!nA || nA.type ? new CanceledError$1$1(null, n, oA) : nA), oA.abort(), oA = null);
    }, d.cancelToken && d.cancelToken.subscribe(CA), d.signal && (d.signal.aborted ? CA() : d.signal.addEventListener("abort", CA)));
    const aA = parseProtocol$1(d.url);
    if (aA && platform$2.protocols.indexOf(aA) === -1) {
      g(new AxiosError$1$1("Unsupported protocol " + aA + ":", AxiosError$1$1.ERR_BAD_REQUEST, n));
      return;
    }
    oA.send(k || null);
  });
}, composeSignals$1 = (n, t) => {
  const { length: g } = n = n ? n.filter(Boolean) : [];
  if (t || g) {
    let d = new AbortController(), k;
    const H = function(CA) {
      if (!k) {
        k = !0, gA();
        const BA = CA instanceof Error ? CA : this.reason;
        d.abort(BA instanceof AxiosError$1$1 ? BA : new CanceledError$1$1(BA instanceof Error ? BA.message : BA));
      }
    };
    let AA = t && setTimeout(() => {
      AA = null, H(new AxiosError$1$1(`timeout ${t} of ms exceeded`, AxiosError$1$1.ETIMEDOUT));
    }, t);
    const gA = () => {
      n && (AA && clearTimeout(AA), AA = null, n.forEach((CA) => {
        CA.unsubscribe ? CA.unsubscribe(H) : CA.removeEventListener("abort", H);
      }), n = null);
    };
    n.forEach((CA) => CA.addEventListener("abort", H));
    const { signal: IA } = d;
    return IA.unsubscribe = () => utils$1$1.asap(gA), IA;
  }
}, streamChunk$1 = function* (n, t) {
  let g = n.byteLength;
  if (g < t) {
    yield n;
    return;
  }
  let d = 0, k;
  for (; d < g; ) k = d + t, yield n.slice(d, k), d = k;
}, readBytes$1 = async function* (n, t) {
  for await (const g of readStream$2(n)) yield* streamChunk$1(g, t);
}, readStream$2 = async function* (n) {
  if (n[Symbol.asyncIterator]) {
    yield* n;
    return;
  }
  const t = n.getReader();
  try {
    for (; ; ) {
      const { done: g, value: d } = await t.read();
      if (g) break;
      yield d;
    }
  } finally {
    await t.cancel();
  }
}, trackStream$1 = (n, t, g, d) => {
  const k = readBytes$1(n, t);
  let H = 0, AA, gA = (IA) => {
    AA || (AA = !0, d && d(IA));
  };
  return new ReadableStream({ async pull(IA) {
    try {
      const { done: CA, value: BA } = await k.next();
      if (CA) {
        gA(), IA.close();
        return;
      }
      let eA = BA.byteLength;
      if (g) {
        let iA = H += eA;
        g(iA);
      }
      IA.enqueue(new Uint8Array(BA));
    } catch (CA) {
      throw gA(CA), CA;
    }
  }, cancel(IA) {
    return gA(IA), k.return();
  } }, { highWaterMark: 2 });
}, DEFAULT_CHUNK_SIZE$1 = 64 * 1024, { isFunction: isFunction$9 } = utils$1$1, globalFetchAPI$1 = (({ Request: n, Response: t }) => ({ Request: n, Response: t }))(utils$1$1.global), { ReadableStream: ReadableStream$1$1, TextEncoder: TextEncoder$2 } = utils$1$1.global, test$2 = (n, ...t) => {
  try {
    return !!n(...t);
  } catch {
    return !1;
  }
}, factory$2 = (n) => {
  n = utils$1$1.merge.call({ skipUndefined: !0 }, globalFetchAPI$1, n);
  const { fetch: t, Request: g, Response: d } = n, k = t ? isFunction$9(t) : typeof fetch == "function", H = isFunction$9(g), AA = isFunction$9(d);
  if (!k) return !1;
  const gA = k && isFunction$9(ReadableStream$1$1), IA = k && (typeof TextEncoder$2 == "function" ? /* @__PURE__ */ ((tA) => (oA) => tA.encode(oA))(new TextEncoder$2()) : async (tA) => new Uint8Array(await new g(tA).arrayBuffer())), CA = H && gA && test$2(() => {
    let tA = !1;
    const oA = new g(platform$2.origin, { body: new ReadableStream$1$1(), method: "POST", get duplex() {
      return tA = !0, "half";
    } }).headers.has("Content-Type");
    return tA && !oA;
  }), BA = AA && gA && test$2(() => utils$1$1.isReadableStream(new d("").body)), eA = { stream: BA && ((tA) => tA.body) };
  k && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((tA) => {
    !eA[tA] && (eA[tA] = (oA, EA) => {
      let aA = oA && oA[tA];
      if (aA) return aA.call(oA);
      throw new AxiosError$1$1(`Response type '${tA}' is not supported`, AxiosError$1$1.ERR_NOT_SUPPORT, EA);
    });
  });
  const iA = async (tA) => {
    if (tA == null) return 0;
    if (utils$1$1.isBlob(tA)) return tA.size;
    if (utils$1$1.isSpecCompliantForm(tA)) return (await new g(platform$2.origin, { method: "POST", body: tA }).arrayBuffer()).byteLength;
    if (utils$1$1.isArrayBufferView(tA) || utils$1$1.isArrayBuffer(tA)) return tA.byteLength;
    if (utils$1$1.isURLSearchParams(tA) && (tA = tA + ""), utils$1$1.isString(tA)) return (await IA(tA)).byteLength;
  }, QA = async (tA, oA) => utils$1$1.toFiniteNumber(tA.getContentLength()) ?? iA(oA);
  return async (tA) => {
    let { url: oA, method: EA, data: aA, signal: nA, cancelToken: lA, timeout: cA, onDownloadProgress: sA, onUploadProgress: rA, responseType: uA, headers: hA, withCredentials: dA = "same-origin", fetchOptions: GA } = resolveConfig$1(tA), DA = t || fetch;
    uA = uA ? (uA + "").toLowerCase() : "text";
    let wA = composeSignals$1([nA, lA && lA.toAbortSignal()], cA), bA = null;
    const yA = wA && wA.unsubscribe && (() => {
      wA.unsubscribe();
    });
    let pA;
    try {
      if (rA && CA && EA !== "get" && EA !== "head" && (pA = await QA(hA, aA)) !== 0) {
        let zA = new g(oA, { method: "POST", body: aA, duplex: "half" }), XA;
        if (utils$1$1.isFormData(aA) && (XA = zA.headers.get("content-type")) && hA.setContentType(XA), zA.body) {
          const [fA, vA] = progressEventDecorator$1(pA, progressEventReducer$1(asyncDecorator$1(rA)));
          aA = trackStream$1(zA.body, DEFAULT_CHUNK_SIZE$1, fA, vA);
        }
      }
      utils$1$1.isString(dA) || (dA = dA ? "include" : "omit");
      const MA = H && "credentials" in g.prototype, LA = { ...GA, signal: wA, method: EA.toUpperCase(), headers: hA.normalize().toJSON(), body: aA, duplex: "half", credentials: MA ? dA : void 0 };
      bA = H && new g(oA, LA);
      let xA = await (H ? DA(bA, GA) : DA(oA, LA));
      const TA = BA && (uA === "stream" || uA === "response");
      if (BA && (sA || TA && yA)) {
        const zA = {};
        ["status", "statusText", "headers"].forEach((Cg) => {
          zA[Cg] = xA[Cg];
        });
        const XA = utils$1$1.toFiniteNumber(xA.headers.get("content-length")), [fA, vA] = sA && progressEventDecorator$1(XA, progressEventReducer$1(asyncDecorator$1(sA), !0)) || [];
        xA = new d(trackStream$1(xA.body, DEFAULT_CHUNK_SIZE$1, fA, () => {
          vA && vA(), yA && yA();
        }), zA);
      }
      uA = uA || "text";
      let NA = await eA[utils$1$1.findKey(eA, uA) || "text"](xA, tA);
      return !TA && yA && yA(), await new Promise((zA, XA) => {
        settle$1(zA, XA, { data: NA, headers: AxiosHeaders$1$1.from(xA.headers), status: xA.status, statusText: xA.statusText, config: tA, request: bA });
      });
    } catch (MA) {
      throw yA && yA(), MA && MA.name === "TypeError" && /Load failed|fetch/i.test(MA.message) ? Object.assign(new AxiosError$1$1("Network Error", AxiosError$1$1.ERR_NETWORK, tA, bA), { cause: MA.cause || MA }) : AxiosError$1$1.from(MA, MA && MA.code, tA, bA);
    }
  };
}, seedCache$1 = /* @__PURE__ */ new Map(), getFetch$1 = (n) => {
  let t = n && n.env || {};
  const { fetch: g, Request: d, Response: k } = t, H = [d, k, g];
  let AA = H.length, gA = AA, IA, CA, BA = seedCache$1;
  for (; gA--; ) IA = H[gA], CA = BA.get(IA), CA === void 0 && BA.set(IA, CA = gA ? /* @__PURE__ */ new Map() : factory$2(t)), BA = CA;
  return CA;
};
getFetch$1();
const knownAdapters$1 = { http: httpAdapter$1, xhr: xhrAdapter$1, fetch: { get: getFetch$1 } };
utils$1$1.forEach(knownAdapters$1, (n, t) => {
  if (n) {
    try {
      Object.defineProperty(n, "name", { value: t });
    } catch {
    }
    Object.defineProperty(n, "adapterName", { value: t });
  }
});
const renderReason$1 = (n) => `- ${n}`, isResolvedHandle$1 = (n) => utils$1$1.isFunction(n) || n === null || n === !1;
function getAdapter$1$1(n, t) {
  n = utils$1$1.isArray(n) ? n : [n];
  const { length: g } = n;
  let d, k;
  const H = {};
  for (let AA = 0; AA < g; AA++) {
    d = n[AA];
    let gA;
    if (k = d, !isResolvedHandle$1(d) && (k = knownAdapters$1[(gA = String(d)).toLowerCase()], k === void 0)) throw new AxiosError$1$1(`Unknown adapter '${gA}'`);
    if (k && (utils$1$1.isFunction(k) || (k = k.get(t)))) break;
    H[gA || "#" + AA] = k;
  }
  if (!k) {
    const AA = Object.entries(H).map(([IA, CA]) => `adapter ${IA} ` + (CA === !1 ? "is not supported by the environment" : "is not available in the build"));
    let gA = g ? AA.length > 1 ? `since :
` + AA.map(renderReason$1).join(`
`) : " " + renderReason$1(AA[0]) : "as no adapter specified";
    throw new AxiosError$1$1("There is no suitable adapter to dispatch the request " + gA, "ERR_NOT_SUPPORT");
  }
  return k;
}
const adapters$1 = {
  /**
  * Resolve an adapter from a list of adapter names or functions.
  * @type {Function}
  */
  getAdapter: getAdapter$1$1,
  /**
  * Exposes all known adapters
  * @type {Object<string, Function|Object>}
  */
  adapters: knownAdapters$1
};
function throwIfCancellationRequested$1(n) {
  if (n.cancelToken && n.cancelToken.throwIfRequested(), n.signal && n.signal.aborted) throw new CanceledError$1$1(null, n);
}
function dispatchRequest$1(n) {
  return throwIfCancellationRequested$1(n), n.headers = AxiosHeaders$1$1.from(n.headers), n.data = transformData$1.call(n, n.transformRequest), ["post", "put", "patch"].indexOf(n.method) !== -1 && n.headers.setContentType("application/x-www-form-urlencoded", !1), adapters$1.getAdapter(n.adapter || defaults$3.adapter, n)(n).then(function(t) {
    return throwIfCancellationRequested$1(n), t.data = transformData$1.call(n, n.transformResponse, t), t.headers = AxiosHeaders$1$1.from(t.headers), t;
  }, function(t) {
    return isCancel$1$1(t) || (throwIfCancellationRequested$1(n), t && t.response && (t.response.data = transformData$1.call(n, n.transformResponse, t.response), t.response.headers = AxiosHeaders$1$1.from(t.response.headers))), Promise.reject(t);
  });
}
const VERSION$1$1 = "1.13.2", validators$1$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((n, t) => {
  validators$1$1[n] = function(g) {
    return typeof g === n || "a" + (t < 1 ? "n " : " ") + n;
  };
});
const deprecatedWarnings$1 = {};
validators$1$1.transitional = function n(t, g, d) {
  function k(H, AA) {
    return "[Axios v" + VERSION$1$1 + "] Transitional option '" + H + "'" + AA + (d ? ". " + d : "");
  }
  return (H, AA, gA) => {
    if (t === !1) throw new AxiosError$1$1(k(AA, " has been removed" + (g ? " in " + g : "")), AxiosError$1$1.ERR_DEPRECATED);
    return g && !deprecatedWarnings$1[AA] && (deprecatedWarnings$1[AA] = !0, console.warn(k(AA, " has been deprecated since v" + g + " and will be removed in the near future"))), t ? t(H, AA, gA) : !0;
  };
};
validators$1$1.spelling = function n(t) {
  return (g, d) => (console.warn(`${d} is likely a misspelling of ${t}`), !0);
};
function assertOptions$1(n, t, g) {
  if (typeof n != "object") throw new AxiosError$1$1("options must be an object", AxiosError$1$1.ERR_BAD_OPTION_VALUE);
  const d = Object.keys(n);
  let k = d.length;
  for (; k-- > 0; ) {
    const H = d[k], AA = t[H];
    if (AA) {
      const gA = n[H], IA = gA === void 0 || AA(gA, H, n);
      if (IA !== !0) throw new AxiosError$1$1("option " + H + " must be " + IA, AxiosError$1$1.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (g !== !0) throw new AxiosError$1$1("Unknown option " + H, AxiosError$1$1.ERR_BAD_OPTION);
  }
}
const validator$3 = { assertOptions: assertOptions$1, validators: validators$1$1 }, validators$2 = validator$3.validators;
let Axios$1$1 = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = { request: new InterceptorManager$1(), response: new InterceptorManager$1() };
  }
  /**
  * Dispatch a request
  *
  * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
  * @param {?Object} config
  *
  * @returns {Promise} The Promise to be fulfilled
  */
  async request(t, g) {
    try {
      return await this._request(t, g);
    } catch (d) {
      if (d instanceof Error) {
        let k = {};
        Error.captureStackTrace ? Error.captureStackTrace(k) : k = new Error();
        const H = k.stack ? k.stack.replace(/^.+\n/, "") : "";
        try {
          d.stack ? H && !String(d.stack).endsWith(H.replace(/^.+\n.+\n/, "")) && (d.stack += `
` + H) : d.stack = H;
        } catch {
        }
      }
      throw d;
    }
  }
  _request(t, g) {
    typeof t == "string" ? (g = g || {}, g.url = t) : g = t || {}, g = mergeConfig$1$1(this.defaults, g);
    const { transitional: d, paramsSerializer: k, headers: H } = g;
    d !== void 0 && validator$3.assertOptions(d, { silentJSONParsing: validators$2.transitional(validators$2.boolean), forcedJSONParsing: validators$2.transitional(validators$2.boolean), clarifyTimeoutError: validators$2.transitional(validators$2.boolean) }, !1), k != null && (utils$1$1.isFunction(k) ? g.paramsSerializer = { serialize: k } : validator$3.assertOptions(k, { encode: validators$2.function, serialize: validators$2.function }, !0)), g.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? g.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : g.allowAbsoluteUrls = !0), validator$3.assertOptions(g, { baseUrl: validators$2.spelling("baseURL"), withXsrfToken: validators$2.spelling("withXSRFToken") }, !0), g.method = (g.method || this.defaults.method || "get").toLowerCase();
    let AA = H && utils$1$1.merge(H.common, H[g.method]);
    H && utils$1$1.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (tA) => {
      delete H[tA];
    }), g.headers = AxiosHeaders$1$1.concat(AA, H);
    const gA = [];
    let IA = !0;
    this.interceptors.request.forEach(function(tA) {
      typeof tA.runWhen == "function" && tA.runWhen(g) === !1 || (IA = IA && tA.synchronous, gA.unshift(tA.fulfilled, tA.rejected));
    });
    const CA = [];
    this.interceptors.response.forEach(function(tA) {
      CA.push(tA.fulfilled, tA.rejected);
    });
    let BA, eA = 0, iA;
    if (!IA) {
      const tA = [dispatchRequest$1.bind(this), void 0];
      for (tA.unshift(...gA), tA.push(...CA), iA = tA.length, BA = Promise.resolve(g); eA < iA; ) BA = BA.then(tA[eA++], tA[eA++]);
      return BA;
    }
    iA = gA.length;
    let QA = g;
    for (; eA < iA; ) {
      const tA = gA[eA++], oA = gA[eA++];
      try {
        QA = tA(QA);
      } catch (EA) {
        oA.call(this, EA);
        break;
      }
    }
    try {
      BA = dispatchRequest$1.call(this, QA);
    } catch (tA) {
      return Promise.reject(tA);
    }
    for (eA = 0, iA = CA.length; eA < iA; ) BA = BA.then(CA[eA++], CA[eA++]);
    return BA;
  }
  getUri(t) {
    t = mergeConfig$1$1(this.defaults, t);
    const g = buildFullPath$1(t.baseURL, t.url, t.allowAbsoluteUrls);
    return buildURL$1(g, t.params, t.paramsSerializer);
  }
};
utils$1$1.forEach(["delete", "get", "head", "options"], function n(t) {
  Axios$1$1.prototype[t] = function(g, d) {
    return this.request(mergeConfig$1$1(d || {}, { method: t, url: g, data: (d || {}).data }));
  };
});
utils$1$1.forEach(["post", "put", "patch"], function n(t) {
  function g(d) {
    return function(k, H, AA) {
      return this.request(mergeConfig$1$1(AA || {}, { method: t, headers: d ? { "Content-Type": "multipart/form-data" } : {}, url: k, data: H }));
    };
  }
  Axios$1$1.prototype[t] = g(), Axios$1$1.prototype[t + "Form"] = g(!0);
});
let CancelToken$1$1 = class XI {
  constructor(t) {
    if (typeof t != "function") throw new TypeError("executor must be a function.");
    let g;
    this.promise = new Promise(function(k) {
      g = k;
    });
    const d = this;
    this.promise.then((k) => {
      if (!d._listeners) return;
      let H = d._listeners.length;
      for (; H-- > 0; ) d._listeners[H](k);
      d._listeners = null;
    }), this.promise.then = (k) => {
      let H;
      const AA = new Promise((gA) => {
        d.subscribe(gA), H = gA;
      }).then(k);
      return AA.cancel = function() {
        d.unsubscribe(H);
      }, AA;
    }, t(function(k, H, AA) {
      d.reason || (d.reason = new CanceledError$1$1(k, H, AA), g(d.reason));
    });
  }
  /**
  * Throws a `CanceledError` if cancellation has been requested.
  */
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  /**
  * Subscribe to the cancel signal
  */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
  * Unsubscribe from the cancel signal
  */
  unsubscribe(t) {
    if (!this._listeners) return;
    const g = this._listeners.indexOf(t);
    g !== -1 && this._listeners.splice(g, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), g = (d) => {
      t.abort(d);
    };
    return this.subscribe(g), t.signal.unsubscribe = () => this.unsubscribe(g), t.signal;
  }
  /**
  * Returns an object that contains a new `CancelToken` and a function that, when called,
  * cancels the `CancelToken`.
  */
  static source() {
    let t;
    return { token: new XI(function(g) {
      t = g;
    }), cancel: t };
  }
};
function spread$1$1(n) {
  return function(t) {
    return n.apply(null, t);
  };
}
function isAxiosError$1$1(n) {
  return utils$1$1.isObject(n) && n.isAxiosError === !0;
}
const HttpStatusCode$1$1 = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511, WebServerIsDown: 521, ConnectionTimedOut: 522, OriginIsUnreachable: 523, TimeoutOccurred: 524, SslHandshakeFailed: 525, InvalidSslCertificate: 526 };
Object.entries(HttpStatusCode$1$1).forEach(([n, t]) => {
  HttpStatusCode$1$1[t] = n;
});
function createInstance$1(n) {
  const t = new Axios$1$1(n), g = bind$3(Axios$1$1.prototype.request, t);
  return utils$1$1.extend(g, Axios$1$1.prototype, t, { allOwnKeys: !0 }), utils$1$1.extend(g, t, null, { allOwnKeys: !0 }), g.create = function(d) {
    return createInstance$1(mergeConfig$1$1(n, d));
  }, g;
}
const axios$1 = createInstance$1(defaults$3);
axios$1.Axios = Axios$1$1;
axios$1.CanceledError = CanceledError$1$1;
axios$1.CancelToken = CancelToken$1$1;
axios$1.isCancel = isCancel$1$1;
axios$1.VERSION = VERSION$1$1;
axios$1.toFormData = toFormData$1$1;
axios$1.AxiosError = AxiosError$1$1;
axios$1.Cancel = axios$1.CanceledError;
axios$1.all = function n(t) {
  return Promise.all(t);
};
axios$1.spread = spread$1$1;
axios$1.isAxiosError = isAxiosError$1$1;
axios$1.mergeConfig = mergeConfig$1$1;
axios$1.AxiosHeaders = AxiosHeaders$1$1;
axios$1.formToJSON = (n) => formDataToJSON$1(utils$1$1.isHTMLForm(n) ? new FormData(n) : n);
axios$1.getAdapter = adapters$1.getAdapter;
axios$1.HttpStatusCode = HttpStatusCode$1$1;
axios$1.default = axios$1;
const { Axios: Axios$2, AxiosError: AxiosError$2, CanceledError: CanceledError$2, isCancel: isCancel$2, CancelToken: CancelToken$2, VERSION: VERSION$4, all: all$6, Cancel: Cancel$1, isAxiosError: isAxiosError$2, spread: spread$2, toFormData: toFormData$2, AxiosHeaders: AxiosHeaders$2, HttpStatusCode: HttpStatusCode$2, formToJSON: formToJSON$1, getAdapter: getAdapter$2, mergeConfig: mergeConfig$4 } = axios$1;
loglevelExports.getLogger("DoInitPings");
loglevelExports.getLogger("ForwardMessageCache");
loglevelExports.getLogger("WebsocketConnection");
loglevelExports.getLogger("ConnectionManager");
loglevelExports.getLogger("DefaultStreamlitEndpoints");
const LOG$f = loglevelExports$1.getLogger("ConnectionManager");
class ConnectionManager {
  props;
  connectionState = ConnectionState$1.INITIAL;
  constructor(t) {
    this.props = t, this.connect();
  }
  /**
   * Indicates whether we're connected to the server.
   */
  isConnected() {
    return this.connectionState === ConnectionState$1.CONNECTED;
  }
  /**
   * Return the BaseUriParts for the server we're connected to,
   * if we are connected to a server.
   */
  getBaseUriParts() {
    if (this.connectionState === ConnectionState$1.CONNECTED) {
      const t = new URL("https://stlite.invalid/");
      return t.pathname = this.props.kernel.basePath, t;
    }
  }
  sendMessage(t) {
    if (this.isConnected()) {
      const g = BackMsg.create(t), d = BackMsg.encode(g).finish();
      this.props.kernel.sendWebSocketMessage(d);
    } else
      LOG$f.error(`Cannot send message when server is disconnected: ${t}`);
  }
  /**
   * Increment the runCount on our message cache, and clear entries
   * whose age is greater than the max.
   */
  incrementMessageCacheRunCount(t, g) {
  }
  getCachedMessageHashes() {
    return [];
  }
  /**
   * Establish either a WebsocketConnection or StaticConnection
   * based on query params.
   */
  async connect() {
    const t = "_stcore/stream";
    try {
      this.props.kernel.onWebSocketMessage((g) => {
        if (typeof g == "string") {
          LOG$f.error("Unexpected payload type.");
          return;
        }
        this.handleMessage(g);
      }), await this.props.kernel.loaded, console.debug("The kernel has been loaded. Start connecting."), this.props.onHostConfigResp(this.props.kernel.hostConfigResponse), await this.props.kernel.connectWebSocket("/" + t), this.setConnectionState(ConnectionState$1.CONNECTED);
    } catch (g) {
      const d = g instanceof Error ? g : new Error(`${g}`);
      LOG$f.error(`Client Error: Websocket connection - ${d.message}`), this.props.sendClientError("Failed to establish websocket connection", d.message, "Connection Manager"), this.setConnectionState(ConnectionState$1.DISCONNECTED_FOREVER, d.message);
    }
  }
  disconnect() {
  }
  setConnectionState = (t, g) => {
    this.connectionState !== t && (this.connectionState = t, this.props.connectionStateChanged(t)), g && this.props.onConnectionError(g);
  };
  // Stlite: the following properties and methods are copied from WebsocketConnection.tsx
  /**
   * To guarantee packet transmission order, this is the index of the last
   * dispatched incoming message.
   */
  lastDispatchedMessageIndex = -1;
  /**
   * And this is the index of the next message we receive.
   */
  nextMessageIndex = 0;
  /**
   * This dictionary stores received messages that we haven't sent out yet
   * (because we're still decoding previous messages)
   */
  messageQueue = {};
  async handleMessage(t) {
    const g = this.nextMessageIndex;
    this.nextMessageIndex += 1;
    const d = new Uint8Array(t), k = ForwardMsg.decode(d);
    if (k.type === "refHash")
      throw new Error("Unexpected cache reference message.");
    for (this.messageQueue[g] = k; this.lastDispatchedMessageIndex + 1 in this.messageQueue; ) {
      const H = this.lastDispatchedMessageIndex + 1;
      this.props.onMessage(this.messageQueue[H]), delete this.messageQueue[H], this.lastDispatchedMessageIndex = H;
    }
  }
}
const MEDIA_ENDPOINT$1 = "/media";
function resolveStliteObjectUrl(n, t) {
  return n.sendHttpRequest({
    method: "GET",
    path: t,
    headers: {},
    body: ""
  }).then(({
    statusCode: g,
    headers: d,
    body: k
  }) => {
    if (g !== 200)
      throw new Error(`Failed to fetch media object: ${g}`);
    const H = d.get("Content-Type"), AA = new Blob([k], H ? {
      type: H
    } : void 0);
    return URL.createObjectURL(AA);
  });
}
function resolveStliteObjectUrlIfNeeded(n, t) {
  return t.startsWith(MEDIA_ENDPOINT$1) ? resolveStliteObjectUrl(n, t) : Promise.resolve(t);
}
function resolveLogo(n, t) {
  return Promise.all([resolveStliteObjectUrlIfNeeded(n, t.image), resolveStliteObjectUrlIfNeeded(n, t.iconImage)]).then(([g, d]) => ({
    ...t,
    image: g,
    iconImage: d
  }));
}
function useStliteResolvedLogo(n) {
  const t = useStliteKernel(), [g, d] = useState(null);
  return useEffect(() => {
    if (n == null)
      return;
    let k = !1;
    const H = [];
    return resolveLogo(t, n).then((AA) => {
      k || (H.push(AA.image), H.push(AA.iconImage), d(AA));
    }), () => {
      H.forEach((AA) => {
        URL.revokeObjectURL(AA);
      }), k = !0;
    };
  }, [t, n]), g;
}
function useStliteMediaObjectUrl(n) {
  const t = useStliteKernel(), [g, d] = useState(n);
  return useEffect(() => {
    if (t == null || !n.startsWith(MEDIA_ENDPOINT$1))
      return;
    let k = !1;
    const H = [];
    return resolveStliteObjectUrl(t, n).then((AA) => {
      k || (H.push(AA), d(AA));
    }), () => {
      k = !0, H.forEach((AA) => {
        URL.revokeObjectURL(AA);
      });
    };
  }, [t, n]), g;
}
function useStliteMediaObjects(n) {
  const [t, g] = useState(n.filter((k) => k.url == null || !k.url.startsWith(MEDIA_ENDPOINT$1))), d = useStliteKernel();
  return useEffect(() => {
    if (d == null)
      return;
    let k = !1;
    const H = [], AA = n.map((gA) => gA.url == null || !gA.url.startsWith(MEDIA_ENDPOINT$1) ? gA : resolveStliteObjectUrl(d, gA.url).then((IA) => k ? gA : (H.push(IA), {
      ...gA,
      url: IA
    })));
    return Promise.all(AA).then((gA) => {
      k || g(gA);
    }), () => {
      k = !0, H.forEach((gA) => {
        URL.revokeObjectURL(gA);
      });
    };
  }, [d, n]), t;
}
function extractCustomComponentPath(n, t) {
  const g = new URL(t), d = new URL(n, "https://stlite.invalid/");
  if (g.hostname !== d.hostname)
    return null;
  const k = d.pathname.replace(/\/$/, ""), H = new RegExp(`^${k}(/.*?$)`), AA = g.pathname.match(H);
  return AA == null ? null : AA[1] + g.search + g.hash;
}
function getParentPath(n) {
  const t = n.split("/").slice(0, -1).join("/");
  return t.startsWith("/") ? t : "/" + t;
}
function getRelativePath(n, t, g) {
  const d = getParentPath(t);
  if (!(g.host === n && g.pathname.startsWith(d)))
    return null;
  const H = g.pathname.slice(d.length);
  return H.startsWith("/") ? H.slice(1) : H;
}
var lib$3 = {}, activitymonitor = {}, ArrayExt;
(function(n) {
  function t(uA, hA, dA = 0, GA = -1) {
    let DA = uA.length;
    if (DA === 0)
      return -1;
    dA < 0 ? dA = Math.max(0, dA + DA) : dA = Math.min(dA, DA - 1), GA < 0 ? GA = Math.max(0, GA + DA) : GA = Math.min(GA, DA - 1);
    let wA;
    GA < dA ? wA = GA + 1 + (DA - dA) : wA = GA - dA + 1;
    for (let bA = 0; bA < wA; ++bA) {
      let yA = (dA + bA) % DA;
      if (uA[yA] === hA)
        return yA;
    }
    return -1;
  }
  n.firstIndexOf = t;
  function g(uA, hA, dA = -1, GA = 0) {
    let DA = uA.length;
    if (DA === 0)
      return -1;
    dA < 0 ? dA = Math.max(0, dA + DA) : dA = Math.min(dA, DA - 1), GA < 0 ? GA = Math.max(0, GA + DA) : GA = Math.min(GA, DA - 1);
    let wA;
    dA < GA ? wA = dA + 1 + (DA - GA) : wA = dA - GA + 1;
    for (let bA = 0; bA < wA; ++bA) {
      let yA = (dA - bA + DA) % DA;
      if (uA[yA] === hA)
        return yA;
    }
    return -1;
  }
  n.lastIndexOf = g;
  function d(uA, hA, dA = 0, GA = -1) {
    let DA = uA.length;
    if (DA === 0)
      return -1;
    dA < 0 ? dA = Math.max(0, dA + DA) : dA = Math.min(dA, DA - 1), GA < 0 ? GA = Math.max(0, GA + DA) : GA = Math.min(GA, DA - 1);
    let wA;
    GA < dA ? wA = GA + 1 + (DA - dA) : wA = GA - dA + 1;
    for (let bA = 0; bA < wA; ++bA) {
      let yA = (dA + bA) % DA;
      if (hA(uA[yA], yA))
        return yA;
    }
    return -1;
  }
  n.findFirstIndex = d;
  function k(uA, hA, dA = -1, GA = 0) {
    let DA = uA.length;
    if (DA === 0)
      return -1;
    dA < 0 ? dA = Math.max(0, dA + DA) : dA = Math.min(dA, DA - 1), GA < 0 ? GA = Math.max(0, GA + DA) : GA = Math.min(GA, DA - 1);
    let wA;
    dA < GA ? wA = dA + 1 + (DA - GA) : wA = dA - GA + 1;
    for (let bA = 0; bA < wA; ++bA) {
      let yA = (dA - bA + DA) % DA;
      if (hA(uA[yA], yA))
        return yA;
    }
    return -1;
  }
  n.findLastIndex = k;
  function H(uA, hA, dA = 0, GA = -1) {
    let DA = d(uA, hA, dA, GA);
    return DA !== -1 ? uA[DA] : void 0;
  }
  n.findFirstValue = H;
  function AA(uA, hA, dA = -1, GA = 0) {
    let DA = k(uA, hA, dA, GA);
    return DA !== -1 ? uA[DA] : void 0;
  }
  n.findLastValue = AA;
  function gA(uA, hA, dA, GA = 0, DA = -1) {
    let wA = uA.length;
    if (wA === 0)
      return 0;
    GA < 0 ? GA = Math.max(0, GA + wA) : GA = Math.min(GA, wA - 1), DA < 0 ? DA = Math.max(0, DA + wA) : DA = Math.min(DA, wA - 1);
    let bA = GA, yA = DA - GA + 1;
    for (; yA > 0; ) {
      let pA = yA >> 1, MA = bA + pA;
      dA(uA[MA], hA) < 0 ? (bA = MA + 1, yA -= pA + 1) : yA = pA;
    }
    return bA;
  }
  n.lowerBound = gA;
  function IA(uA, hA, dA, GA = 0, DA = -1) {
    let wA = uA.length;
    if (wA === 0)
      return 0;
    GA < 0 ? GA = Math.max(0, GA + wA) : GA = Math.min(GA, wA - 1), DA < 0 ? DA = Math.max(0, DA + wA) : DA = Math.min(DA, wA - 1);
    let bA = GA, yA = DA - GA + 1;
    for (; yA > 0; ) {
      let pA = yA >> 1, MA = bA + pA;
      dA(uA[MA], hA) > 0 ? yA = pA : (bA = MA + 1, yA -= pA + 1);
    }
    return bA;
  }
  n.upperBound = IA;
  function CA(uA, hA, dA) {
    if (uA === hA)
      return !0;
    if (uA.length !== hA.length)
      return !1;
    for (let GA = 0, DA = uA.length; GA < DA; ++GA)
      if (dA ? !dA(uA[GA], hA[GA]) : uA[GA] !== hA[GA])
        return !1;
    return !0;
  }
  n.shallowEqual = CA;
  function BA(uA, hA = {}) {
    let { start: dA, stop: GA, step: DA } = hA;
    if (DA === void 0 && (DA = 1), DA === 0)
      throw new Error("Slice `step` cannot be zero.");
    let wA = uA.length;
    dA === void 0 ? dA = DA < 0 ? wA - 1 : 0 : dA < 0 ? dA = Math.max(dA + wA, DA < 0 ? -1 : 0) : dA >= wA && (dA = DA < 0 ? wA - 1 : wA), GA === void 0 ? GA = DA < 0 ? -1 : wA : GA < 0 ? GA = Math.max(GA + wA, DA < 0 ? -1 : 0) : GA >= wA && (GA = DA < 0 ? wA - 1 : wA);
    let bA;
    DA < 0 && GA >= dA || DA > 0 && dA >= GA ? bA = 0 : DA < 0 ? bA = Math.floor((GA - dA + 1) / DA + 1) : bA = Math.floor((GA - dA - 1) / DA + 1);
    let yA = [];
    for (let pA = 0; pA < bA; ++pA)
      yA[pA] = uA[dA + pA * DA];
    return yA;
  }
  n.slice = BA;
  function eA(uA, hA, dA) {
    let GA = uA.length;
    if (GA <= 1 || (hA < 0 ? hA = Math.max(0, hA + GA) : hA = Math.min(hA, GA - 1), dA < 0 ? dA = Math.max(0, dA + GA) : dA = Math.min(dA, GA - 1), hA === dA))
      return;
    let DA = uA[hA], wA = hA < dA ? 1 : -1;
    for (let bA = hA; bA !== dA; bA += wA)
      uA[bA] = uA[bA + wA];
    uA[dA] = DA;
  }
  n.move = eA;
  function iA(uA, hA = 0, dA = -1) {
    let GA = uA.length;
    if (!(GA <= 1))
      for (hA < 0 ? hA = Math.max(0, hA + GA) : hA = Math.min(hA, GA - 1), dA < 0 ? dA = Math.max(0, dA + GA) : dA = Math.min(dA, GA - 1); hA < dA; ) {
        let DA = uA[hA], wA = uA[dA];
        uA[hA++] = wA, uA[dA--] = DA;
      }
  }
  n.reverse = iA;
  function QA(uA, hA, dA = 0, GA = -1) {
    let DA = uA.length;
    if (DA <= 1 || (dA < 0 ? dA = Math.max(0, dA + DA) : dA = Math.min(dA, DA - 1), GA < 0 ? GA = Math.max(0, GA + DA) : GA = Math.min(GA, DA - 1), dA >= GA))
      return;
    let wA = GA - dA + 1;
    if (hA > 0 ? hA = hA % wA : hA < 0 && (hA = (hA % wA + wA) % wA), hA === 0)
      return;
    let bA = dA + hA;
    iA(uA, dA, bA - 1), iA(uA, bA, GA), iA(uA, dA, GA);
  }
  n.rotate = QA;
  function tA(uA, hA, dA = 0, GA = -1) {
    let DA = uA.length;
    if (DA === 0)
      return;
    dA < 0 ? dA = Math.max(0, dA + DA) : dA = Math.min(dA, DA - 1), GA < 0 ? GA = Math.max(0, GA + DA) : GA = Math.min(GA, DA - 1);
    let wA;
    GA < dA ? wA = GA + 1 + (DA - dA) : wA = GA - dA + 1;
    for (let bA = 0; bA < wA; ++bA)
      uA[(dA + bA) % DA] = hA;
  }
  n.fill = tA;
  function oA(uA, hA, dA) {
    let GA = uA.length;
    hA < 0 ? hA = Math.max(0, hA + GA) : hA = Math.min(hA, GA);
    for (let DA = GA; DA > hA; --DA)
      uA[DA] = uA[DA - 1];
    uA[hA] = dA;
  }
  n.insert = oA;
  function EA(uA, hA) {
    let dA = uA.length;
    if (hA < 0 && (hA += dA), hA < 0 || hA >= dA)
      return;
    let GA = uA[hA];
    for (let DA = hA + 1; DA < dA; ++DA)
      uA[DA - 1] = uA[DA];
    return uA.length = dA - 1, GA;
  }
  n.removeAt = EA;
  function aA(uA, hA, dA = 0, GA = -1) {
    let DA = t(uA, hA, dA, GA);
    return DA !== -1 && EA(uA, DA), DA;
  }
  n.removeFirstOf = aA;
  function nA(uA, hA, dA = -1, GA = 0) {
    let DA = g(uA, hA, dA, GA);
    return DA !== -1 && EA(uA, DA), DA;
  }
  n.removeLastOf = nA;
  function lA(uA, hA, dA = 0, GA = -1) {
    let DA = uA.length;
    if (DA === 0)
      return 0;
    dA < 0 ? dA = Math.max(0, dA + DA) : dA = Math.min(dA, DA - 1), GA < 0 ? GA = Math.max(0, GA + DA) : GA = Math.min(GA, DA - 1);
    let wA = 0;
    for (let bA = 0; bA < DA; ++bA)
      dA <= GA && bA >= dA && bA <= GA && uA[bA] === hA || GA < dA && (bA <= GA || bA >= dA) && uA[bA] === hA ? wA++ : wA > 0 && (uA[bA - wA] = uA[bA]);
    return wA > 0 && (uA.length = DA - wA), wA;
  }
  n.removeAllOf = lA;
  function cA(uA, hA, dA = 0, GA = -1) {
    let DA, wA = d(uA, hA, dA, GA);
    return wA !== -1 && (DA = EA(uA, wA)), { index: wA, value: DA };
  }
  n.removeFirstWhere = cA;
  function sA(uA, hA, dA = -1, GA = 0) {
    let DA, wA = k(uA, hA, dA, GA);
    return wA !== -1 && (DA = EA(uA, wA)), { index: wA, value: DA };
  }
  n.removeLastWhere = sA;
  function rA(uA, hA, dA = 0, GA = -1) {
    let DA = uA.length;
    if (DA === 0)
      return 0;
    dA < 0 ? dA = Math.max(0, dA + DA) : dA = Math.min(dA, DA - 1), GA < 0 ? GA = Math.max(0, GA + DA) : GA = Math.min(GA, DA - 1);
    let wA = 0;
    for (let bA = 0; bA < DA; ++bA)
      dA <= GA && bA >= dA && bA <= GA && hA(uA[bA], bA) || GA < dA && (bA <= GA || bA >= dA) && hA(uA[bA], bA) ? wA++ : wA > 0 && (uA[bA - wA] = uA[bA]);
    return wA > 0 && (uA.length = DA - wA), wA;
  }
  n.removeAllWhere = rA;
})(ArrayExt || (ArrayExt = {}));
function* chain(...n) {
  for (const t of n)
    yield* t;
}
function* empty$2() {
}
function* enumerate(n, t = 0) {
  for (const g of n)
    yield [t++, g];
}
function* filter$4(n, t) {
  let g = 0;
  for (const d of n)
    t(d, g++) && (yield d);
}
function find$6(n, t) {
  let g = 0;
  for (const d of n)
    if (t(d, g++))
      return d;
}
function findIndex$1(n, t) {
  let g = 0;
  for (const d of n)
    if (t(d, g++))
      return g - 1;
  return -1;
}
function min$4(n, t) {
  let g;
  for (const d of n) {
    if (g === void 0) {
      g = d;
      continue;
    }
    t(d, g) < 0 && (g = d);
  }
  return g;
}
function max$4(n, t) {
  let g;
  for (const d of n) {
    if (g === void 0) {
      g = d;
      continue;
    }
    t(d, g) > 0 && (g = d);
  }
  return g;
}
function minmax(n, t) {
  let g = !0, d, k;
  for (const H of n)
    g ? (d = H, k = H, g = !1) : t(H, d) < 0 ? d = H : t(H, k) > 0 && (k = H);
  return g ? void 0 : [d, k];
}
function toArray$4(n) {
  return Array.from(n);
}
function toObject$1(n) {
  const t = {};
  for (const [g, d] of n)
    t[g] = d;
  return t;
}
function each$1(n, t) {
  let g = 0;
  for (const d of n)
    if (t(d, g++) === !1)
      return;
}
function every$1(n, t) {
  let g = 0;
  for (const d of n)
    if (t(d, g++) === !1)
      return !1;
  return !0;
}
function some$2(n, t) {
  let g = 0;
  for (const d of n)
    if (t(d, g++))
      return !0;
  return !1;
}
function* map$6(n, t) {
  let g = 0;
  for (const d of n)
    yield t(d, g++);
}
function* range$7(n, t, g) {
  t === void 0 ? (t = n, n = 0, g = 1) : g === void 0 && (g = 1);
  const d = Private$2.rangeLength(n, t, g);
  for (let k = 0; k < d; k++)
    yield n + g * k;
}
var Private$2;
(function(n) {
  function t(g, d, k) {
    return k === 0 ? 1 / 0 : g > d && k > 0 || g < d && k < 0 ? 0 : Math.ceil((d - g) / k);
  }
  n.rangeLength = t;
})(Private$2 || (Private$2 = {}));
function reduce$1(n, t, g) {
  const d = n[Symbol.iterator]();
  let k = 0, H = d.next();
  if (H.done && g === void 0)
    throw new TypeError("Reduce of empty iterable with no initial value.");
  if (H.done)
    return g;
  let AA = d.next();
  if (AA.done && g === void 0)
    return H.value;
  if (AA.done)
    return t(g, H.value, k++);
  let gA;
  g === void 0 ? gA = t(H.value, AA.value, k++) : gA = t(t(g, H.value, k++), AA.value, k++);
  let IA;
  for (; !(IA = d.next()).done; )
    gA = t(gA, IA.value, k++);
  return gA;
}
function* repeat$2(n, t) {
  for (; 0 < t--; )
    yield n;
}
function* once$1(n) {
  yield n;
}
function* retro(n) {
  if (typeof n.retro == "function")
    yield* n.retro();
  else
    for (let t = n.length - 1; t > -1; t--)
      yield n[t];
}
function topologicSort(n) {
  let t = [], g = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Map();
  for (const AA of n)
    k(AA);
  for (const [AA] of d)
    H(AA);
  return t;
  function k(AA) {
    let [gA, IA] = AA, CA = d.get(IA);
    CA ? CA.push(gA) : d.set(IA, [gA]);
  }
  function H(AA) {
    if (g.has(AA))
      return;
    g.add(AA);
    let gA = d.get(AA);
    if (gA)
      for (const IA of gA)
        H(IA);
    t.push(AA);
  }
}
function* stride(n, t) {
  let g = 0;
  for (const d of n)
    g++ % t === 0 && (yield d);
}
var StringExt;
(function(n) {
  function t(AA, gA, IA = 0) {
    let CA = new Array(gA.length);
    for (let BA = 0, eA = IA, iA = gA.length; BA < iA; ++BA, ++eA) {
      if (eA = AA.indexOf(gA[BA], eA), eA === -1)
        return null;
      CA[BA] = eA;
    }
    return CA;
  }
  n.findIndices = t;
  function g(AA, gA, IA = 0) {
    let CA = t(AA, gA, IA);
    if (!CA)
      return null;
    let BA = 0;
    for (let eA = 0, iA = CA.length; eA < iA; ++eA) {
      let QA = CA[eA] - IA;
      BA += QA * QA;
    }
    return { score: BA, indices: CA };
  }
  n.matchSumOfSquares = g;
  function d(AA, gA, IA = 0) {
    let CA = t(AA, gA, IA);
    if (!CA)
      return null;
    let BA = 0, eA = IA - 1;
    for (let iA = 0, QA = CA.length; iA < QA; ++iA) {
      let tA = CA[iA];
      BA += tA - eA - 1, eA = tA;
    }
    return { score: BA, indices: CA };
  }
  n.matchSumOfDeltas = d;
  function k(AA, gA, IA) {
    let CA = [], BA = 0, eA = 0, iA = gA.length;
    for (; BA < iA; ) {
      let QA = gA[BA], tA = gA[BA];
      for (; ++BA < iA && gA[BA] === tA + 1; )
        tA++;
      eA < QA && CA.push(AA.slice(eA, QA)), QA < tA + 1 && CA.push(IA(AA.slice(QA, tA + 1))), eA = tA + 1;
    }
    return eA < AA.length && CA.push(AA.slice(eA)), CA;
  }
  n.highlight = k;
  function H(AA, gA) {
    return AA < gA ? -1 : AA > gA ? 1 : 0;
  }
  n.cmp = H;
})(StringExt || (StringExt = {}));
function* take(n, t) {
  if (t < 1)
    return;
  const g = n[Symbol.iterator]();
  let d;
  for (; 0 < t-- && !(d = g.next()).done; )
    yield d.value;
}
function* zip$1(...n) {
  const t = n.map((d) => d[Symbol.iterator]());
  let g = t.map((d) => d.next());
  for (; every$1(g, (d) => !d.done); g = t.map((d) => d.next()))
    yield g.map((d) => d.value);
}
const index_es6$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ArrayExt() {
    return ArrayExt;
  },
  get StringExt() {
    return StringExt;
  },
  chain,
  each: each$1,
  empty: empty$2,
  enumerate,
  every: every$1,
  filter: filter$4,
  find: find$6,
  findIndex: findIndex$1,
  map: map$6,
  max: max$4,
  min: min$4,
  minmax,
  once: once$1,
  range: range$7,
  reduce: reduce$1,
  repeat: repeat$2,
  retro,
  some: some$2,
  stride,
  take,
  toArray: toArray$4,
  toObject: toObject$1,
  topologicSort,
  zip: zip$1
}, Symbol.toStringTag, { value: "Module" }));
var JSONExt;
(function(n) {
  n.emptyObject = Object.freeze({}), n.emptyArray = Object.freeze([]);
  function t(BA) {
    return BA === null || typeof BA == "boolean" || typeof BA == "number" || typeof BA == "string";
  }
  n.isPrimitive = t;
  function g(BA) {
    return Array.isArray(BA);
  }
  n.isArray = g;
  function d(BA) {
    return !t(BA) && !g(BA);
  }
  n.isObject = d;
  function k(BA, eA) {
    if (BA === eA)
      return !0;
    if (t(BA) || t(eA))
      return !1;
    let iA = g(BA), QA = g(eA);
    return iA !== QA ? !1 : iA && QA ? AA(BA, eA) : gA(BA, eA);
  }
  n.deepEqual = k;
  function H(BA) {
    return t(BA) ? BA : g(BA) ? IA(BA) : CA(BA);
  }
  n.deepCopy = H;
  function AA(BA, eA) {
    if (BA === eA)
      return !0;
    if (BA.length !== eA.length)
      return !1;
    for (let iA = 0, QA = BA.length; iA < QA; ++iA)
      if (!k(BA[iA], eA[iA]))
        return !1;
    return !0;
  }
  function gA(BA, eA) {
    if (BA === eA)
      return !0;
    for (let iA in BA)
      if (BA[iA] !== void 0 && !(iA in eA))
        return !1;
    for (let iA in eA)
      if (eA[iA] !== void 0 && !(iA in BA))
        return !1;
    for (let iA in BA) {
      let QA = BA[iA], tA = eA[iA];
      if (!(QA === void 0 && tA === void 0) && (QA === void 0 || tA === void 0 || !k(QA, tA)))
        return !1;
    }
    return !0;
  }
  function IA(BA) {
    let eA = new Array(BA.length);
    for (let iA = 0, QA = BA.length; iA < QA; ++iA)
      eA[iA] = H(BA[iA]);
    return eA;
  }
  function CA(BA) {
    let eA = {};
    for (let iA in BA) {
      let QA = BA[iA];
      QA !== void 0 && (eA[iA] = H(QA));
    }
    return eA;
  }
})(JSONExt || (JSONExt = {}));
var Private$1;
(function(n) {
  class t {
    constructor(gA) {
      var IA, CA, BA, eA;
      this._activated = !1, this._promise = null, this._service = null, this.id = gA.id, this.description = (IA = gA.description) !== null && IA !== void 0 ? IA : "", this.activate = gA.activate, this.deactivate = (CA = gA.deactivate) !== null && CA !== void 0 ? CA : null, this.provides = (BA = gA.provides) !== null && BA !== void 0 ? BA : null, this.autoStart = (eA = gA.autoStart) !== null && eA !== void 0 ? eA : !1, this.requires = gA.requires ? gA.requires.slice() : [], this.optional = gA.optional ? gA.optional.slice() : [];
    }
    /**
     * Whether the plugin has been activated.
     */
    get activated() {
      return this._activated;
    }
    set activated(gA) {
      this._activated = gA;
    }
    /**
     * The resolved service for the plugin, or `null`.
     */
    get service() {
      return this._service;
    }
    set service(gA) {
      this._service = gA;
    }
    /**
     * The pending resolver promise, or `null`.
     */
    get promise() {
      return this._promise;
    }
    set promise(gA) {
      this._promise = gA;
    }
  }
  function g(AA) {
    return new t(AA);
  }
  n.createPluginData = g;
  function d(AA, gA, IA) {
    const CA = [...AA.requires, ...AA.optional], BA = (iA) => {
      if (iA === AA.provides)
        return !0;
      const QA = IA.get(iA);
      if (!QA)
        return !1;
      const tA = gA.get(QA), oA = [...tA.requires, ...tA.optional];
      return oA.length === 0 ? !1 : (eA.push(QA), oA.some(BA) ? !0 : (eA.pop(), !1));
    };
    if (!AA.provides || CA.length === 0)
      return;
    const eA = [AA.id];
    if (CA.some(BA))
      throw new ReferenceError(`Cycle detected: ${eA.join(" -> ")}.`);
  }
  n.ensureNoCycle = d;
  function k(AA, gA, IA) {
    const CA = new Array(), BA = (oA) => {
      const EA = gA.get(oA), aA = [...EA.requires, ...EA.optional];
      CA.push(...aA.reduce((nA, lA) => {
        const cA = IA.get(lA);
        return cA && nA.push([oA, cA]), nA;
      }, []));
    };
    for (const oA of gA.keys())
      BA(oA);
    const eA = CA.filter((oA) => oA[1] === AA);
    let iA = 0;
    for (; eA.length > iA; ) {
      const oA = eA.length, EA = new Set(eA.map((aA) => aA[0]));
      for (const aA of EA)
        CA.filter((nA) => nA[1] === aA).forEach((nA) => {
          eA.includes(nA) || eA.push(nA);
        });
      iA = oA;
    }
    const QA = topologicSort(eA), tA = QA.findIndex((oA) => oA === AA);
    return tA === -1 ? [AA] : QA.slice(0, tA + 1);
  }
  n.findDependents = k;
  function H(AA, gA) {
    const IA = /* @__PURE__ */ new Set();
    for (const CA of AA.keys())
      AA.get(CA).autoStart === !0 && IA.add(CA);
    if (gA.startPlugins)
      for (const CA of gA.startPlugins)
        IA.add(CA);
    if (gA.ignorePlugins)
      for (const CA of gA.ignorePlugins)
        IA.delete(CA);
    return Array.from(IA);
  }
  n.collectStartupPlugins = H;
})(Private$1 || (Private$1 = {}));
class PromiseDelegate {
  /**
   * Construct a new promise delegate.
   */
  constructor() {
    this.promise = new Promise((t, g) => {
      this._resolve = t, this._reject = g;
    });
  }
  /**
   * Resolve the wrapped promise with the given value.
   *
   * @param value - The value to use for resolving the promise.
   */
  resolve(t) {
    let g = this._resolve;
    g(t);
  }
  /**
   * Reject the wrapped promise with the given value.
   *
   * @reason - The reason for rejecting the promise.
   */
  reject(t) {
    let g = this._reject;
    g(t);
  }
}
function fallbackRandomValues(n) {
  let t = 0;
  for (let g = 0, d = n.length; g < d; ++g)
    g % 4 === 0 && (t = Math.random() * 4294967295 >>> 0), n[g] = t & 255, t >>>= 8;
}
var Random;
(function(n) {
  n.getRandomValues = (() => {
    const t = typeof window < "u" && (window.crypto || window.msCrypto) || null;
    return t && typeof t.getRandomValues == "function" ? function(d) {
      return t.getRandomValues(d);
    } : fallbackRandomValues;
  })();
})(Random || (Random = {}));
function uuid4Factory(n) {
  const t = new Uint8Array(16), g = new Array(256);
  for (let d = 0; d < 16; ++d)
    g[d] = "0" + d.toString(16);
  for (let d = 16; d < 256; ++d)
    g[d] = d.toString(16);
  return function() {
    return n(t), t[6] = 64 | t[6] & 15, t[8] = 128 | t[8] & 63, g[t[0]] + g[t[1]] + g[t[2]] + g[t[3]] + "-" + g[t[4]] + g[t[5]] + "-" + g[t[6]] + g[t[7]] + "-" + g[t[8]] + g[t[9]] + "-" + g[t[10]] + g[t[11]] + g[t[12]] + g[t[13]] + g[t[14]] + g[t[15]];
  };
}
var UUID;
(function(n) {
  n.uuid4 = uuid4Factory(Random.getRandomValues);
})(UUID || (UUID = {}));
let Signal$1 = class {
  /**
   * Construct a new signal.
   *
   * @param sender - The sender which owns the signal.
   */
  constructor(t) {
    this.sender = t;
  }
  /**
   * Connect a slot to the signal.
   *
   * @param slot - The slot to invoke when the signal is emitted.
   *
   * @param thisArg - The `this` context for the slot. If provided,
   *   this must be a non-primitive object.
   *
   * @returns `true` if the connection succeeds, `false` otherwise.
   */
  connect(t, g) {
    return Private.connect(this, t, g);
  }
  /**
   * Disconnect a slot from the signal.
   *
   * @param slot - The slot to disconnect from the signal.
   *
   * @param thisArg - The `this` context for the slot. If provided,
   *   this must be a non-primitive object.
   *
   * @returns `true` if the connection is removed, `false` otherwise.
   */
  disconnect(t, g) {
    return Private.disconnect(this, t, g);
  }
  /**
   * Emit the signal and invoke the connected slots.
   *
   * @param args - The args to pass to the connected slots.
   *
   * #### Notes
   * Slots are invoked synchronously in connection order.
   *
   * Exceptions thrown by connected slots will be caught and logged.
   */
  emit(t) {
    Private.emit(this, t);
  }
};
(function(n) {
  function t(IA, CA) {
    Private.disconnectBetween(IA, CA);
  }
  n.disconnectBetween = t;
  function g(IA) {
    Private.disconnectSender(IA);
  }
  n.disconnectSender = g;
  function d(IA) {
    Private.disconnectReceiver(IA);
  }
  n.disconnectReceiver = d;
  function k(IA) {
    Private.disconnectAll(IA);
  }
  n.disconnectAll = k;
  function H(IA) {
    Private.disconnectAll(IA);
  }
  n.clearData = H;
  function AA() {
    return Private.exceptionHandler;
  }
  n.getExceptionHandler = AA;
  function gA(IA) {
    let CA = Private.exceptionHandler;
    return Private.exceptionHandler = IA, CA;
  }
  n.setExceptionHandler = gA;
})(Signal$1 || (Signal$1 = {}));
class Stream extends Signal$1 {
  constructor() {
    super(...arguments), this._pending = new PromiseDelegate();
  }
  /**
   * Return an async iterator that yields every emission.
   */
  async *[Symbol.asyncIterator]() {
    let t = this._pending;
    for (; ; )
      try {
        const { args: g, next: d } = await t.promise;
        t = d, yield g;
      } catch {
        return;
      }
  }
  /**
   * Emit the signal, invoke the connected slots, and yield the emission.
   *
   * @param args - The args to pass to the connected slots.
   */
  emit(t) {
    const g = this._pending, d = this._pending = new PromiseDelegate();
    g.resolve({ args: t, next: d }), super.emit(t);
  }
  /**
   * Stop the stream's async iteration.
   */
  stop() {
    this._pending.promise.catch(() => {
    }), this._pending.reject("stop"), this._pending = new PromiseDelegate();
  }
}
var Private;
(function(n) {
  n.exceptionHandler = (nA) => {
    console.error(nA);
  };
  function t(nA, lA, cA) {
    cA = cA || void 0;
    let sA = IA.get(nA.sender);
    if (sA || (sA = [], IA.set(nA.sender, sA)), iA(sA, nA, lA, cA))
      return !1;
    let rA = cA || lA, uA = CA.get(rA);
    uA || (uA = [], CA.set(rA, uA));
    let hA = { signal: nA, slot: lA, thisArg: cA };
    return sA.push(hA), uA.push(hA), !0;
  }
  n.connect = t;
  function g(nA, lA, cA) {
    cA = cA || void 0;
    let sA = IA.get(nA.sender);
    if (!sA || sA.length === 0)
      return !1;
    let rA = iA(sA, nA, lA, cA);
    if (!rA)
      return !1;
    let uA = cA || lA, hA = CA.get(uA);
    return rA.signal = null, tA(sA), tA(hA), !0;
  }
  n.disconnect = g;
  function d(nA, lA) {
    let cA = IA.get(nA);
    if (!cA || cA.length === 0)
      return;
    let sA = CA.get(lA);
    if (!(!sA || sA.length === 0)) {
      for (const rA of sA)
        rA.signal && rA.signal.sender === nA && (rA.signal = null);
      tA(cA), tA(sA);
    }
  }
  n.disconnectBetween = d;
  function k(nA) {
    let lA = IA.get(nA);
    if (!(!lA || lA.length === 0)) {
      for (const cA of lA) {
        if (!cA.signal)
          continue;
        let sA = cA.thisArg || cA.slot;
        cA.signal = null, tA(CA.get(sA));
      }
      tA(lA);
    }
  }
  n.disconnectSender = k;
  function H(nA) {
    let lA = CA.get(nA);
    if (!(!lA || lA.length === 0)) {
      for (const cA of lA) {
        if (!cA.signal)
          continue;
        let sA = cA.signal.sender;
        cA.signal = null, tA(IA.get(sA));
      }
      tA(lA);
    }
  }
  n.disconnectReceiver = H;
  function AA(nA) {
    k(nA), H(nA);
  }
  n.disconnectAll = AA;
  function gA(nA, lA) {
    let cA = IA.get(nA.sender);
    if (!(!cA || cA.length === 0))
      for (let sA = 0, rA = cA.length; sA < rA; ++sA) {
        let uA = cA[sA];
        uA.signal === nA && QA(uA, lA);
      }
  }
  n.emit = gA;
  const IA = /* @__PURE__ */ new WeakMap(), CA = /* @__PURE__ */ new WeakMap(), BA = /* @__PURE__ */ new Set(), eA = typeof requestAnimationFrame == "function" ? requestAnimationFrame : setImmediate;
  function iA(nA, lA, cA, sA) {
    return find$6(nA, (rA) => rA.signal === lA && rA.slot === cA && rA.thisArg === sA);
  }
  function QA(nA, lA) {
    let { signal: cA, slot: sA, thisArg: rA } = nA;
    try {
      sA.call(rA, cA.sender, lA);
    } catch (uA) {
      n.exceptionHandler(uA);
    }
  }
  function tA(nA) {
    BA.size === 0 && eA(oA), BA.add(nA);
  }
  function oA() {
    BA.forEach(EA), BA.clear();
  }
  function EA(nA) {
    ArrayExt.removeAllWhere(nA, aA);
  }
  function aA(nA) {
    return nA.signal === null;
  }
})(Private || (Private = {}));
const index_es6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get Signal() {
    return Signal$1;
  },
  Stream
}, Symbol.toStringTag, { value: "Module" })), require$$0$5 = /* @__PURE__ */ getAugmentedNamespace(index_es6);
var hasRequiredActivitymonitor;
function requireActivitymonitor() {
  if (hasRequiredActivitymonitor) return activitymonitor;
  hasRequiredActivitymonitor = 1, Object.defineProperty(activitymonitor, "__esModule", { value: !0 }), activitymonitor.ActivityMonitor = void 0;
  const n = require$$0$5;
  class t {
    /**
     * Construct a new activity monitor.
     */
    constructor(d) {
      this._timer = -1, this._timeout = -1, this._isDisposed = !1, this._activityStopped = new n.Signal(this), d.signal.connect(this._onSignalFired, this), this._timeout = d.timeout || 1e3;
    }
    /**
     * A signal emitted when activity has ceased.
     */
    get activityStopped() {
      return this._activityStopped;
    }
    /**
     * The timeout associated with the monitor, in milliseconds.
     */
    get timeout() {
      return this._timeout;
    }
    set timeout(d) {
      this._timeout = d;
    }
    /**
     * Test whether the monitor has been disposed.
     *
     * #### Notes
     * This is a read-only property.
     */
    get isDisposed() {
      return this._isDisposed;
    }
    /**
     * Dispose of the resources used by the activity monitor.
     */
    dispose() {
      this._isDisposed || (this._isDisposed = !0, n.Signal.clearData(this));
    }
    /**
     * A signal handler for the monitored signal.
     */
    _onSignalFired(d, k) {
      clearTimeout(this._timer), this._sender = d, this._args = k, this._timer = setTimeout(() => {
        this._activityStopped.emit({
          sender: this._sender,
          args: this._args
        });
      }, this._timeout);
    }
  }
  return activitymonitor.ActivityMonitor = t, activitymonitor;
}
var interfaces = {}, hasRequiredInterfaces;
function requireInterfaces() {
  return hasRequiredInterfaces || (hasRequiredInterfaces = 1, Object.defineProperty(interfaces, "__esModule", { value: !0 })), interfaces;
}
var lru = {}, hasRequiredLru;
function requireLru() {
  if (hasRequiredLru) return lru;
  hasRequiredLru = 1, Object.defineProperty(lru, "__esModule", { value: !0 }), lru.LruCache = void 0;
  const n = 128;
  class t {
    constructor(d = {}) {
      this._map = /* @__PURE__ */ new Map(), this._maxSize = d?.maxSize || n;
    }
    /**
     * Return the current size of the cache.
     */
    get size() {
      return this._map.size;
    }
    /**
     * Clear the values in the cache.
     */
    clear() {
      this._map.clear();
    }
    /**
     * Get a value (or null) from the cache, pushing the item to the front of the cache.
     */
    get(d) {
      const k = this._map.get(d) || null;
      return k != null && (this._map.delete(d), this._map.set(d, k)), k;
    }
    /**
     * Set a value in the cache, potentially evicting an old item.
     */
    set(d, k) {
      this._map.size >= this._maxSize && this._map.delete(this._map.keys().next().value), this._map.set(d, k);
    }
  }
  return lru.LruCache = t, lru;
}
var markdowncodeblocks = {}, hasRequiredMarkdowncodeblocks;
function requireMarkdowncodeblocks() {
  if (hasRequiredMarkdowncodeblocks) return markdowncodeblocks;
  hasRequiredMarkdowncodeblocks = 1, Object.defineProperty(markdowncodeblocks, "__esModule", { value: !0 }), markdowncodeblocks.MarkdownCodeBlocks = void 0;
  var n;
  return (function(t) {
    t.CODE_BLOCK_MARKER = "```";
    const g = [
      ".markdown",
      ".mdown",
      ".mkdn",
      ".md",
      ".mkd",
      ".mdwn",
      ".mdtxt",
      ".mdtext",
      ".text",
      ".txt",
      ".Rmd"
    ];
    class d {
      constructor(gA) {
        this.startLine = gA, this.code = "", this.endLine = -1;
      }
    }
    t.MarkdownCodeBlock = d;
    function k(AA) {
      return g.indexOf(AA) > -1;
    }
    t.isMarkdown = k;
    function H(AA) {
      if (!AA || AA === "")
        return [];
      const gA = AA.split(`
`), IA = [];
      let CA = null;
      for (let BA = 0; BA < gA.length; BA++) {
        const eA = gA[BA], iA = eA.indexOf(t.CODE_BLOCK_MARKER) === 0, QA = CA != null;
        if (!(!iA && !QA))
          if (QA)
            CA && (iA ? (CA.endLine = BA - 1, IA.push(CA), CA = null) : CA.code += eA + `
`);
          else {
            CA = new d(BA);
            const tA = eA.indexOf(t.CODE_BLOCK_MARKER), oA = eA.lastIndexOf(t.CODE_BLOCK_MARKER);
            tA !== oA && (CA.code = eA.substring(tA + t.CODE_BLOCK_MARKER.length, oA), CA.endLine = BA, IA.push(CA), CA = null);
          }
      }
      return IA;
    }
    t.findMarkdownCodeBlocks = H;
  })(n || (markdowncodeblocks.MarkdownCodeBlocks = n = {})), markdowncodeblocks;
}
var pageconfig = {}, dist$4 = { exports: {} };
const require$$0$4 = /* @__PURE__ */ getAugmentedNamespace(index_es6$1);
var dist$3 = dist$4.exports, hasRequiredDist$2;
function requireDist$2() {
  return hasRequiredDist$2 || (hasRequiredDist$2 = 1, (function(n, t) {
    (function(g, d) {
      d(t, require$$0$4);
    })(dist$3, (function(g, d) {
      g.JSONExt = void 0, (function(eA) {
        eA.emptyObject = Object.freeze({}), eA.emptyArray = Object.freeze([]);
        function iA(sA) {
          return sA === null || typeof sA == "boolean" || typeof sA == "number" || typeof sA == "string";
        }
        eA.isPrimitive = iA;
        function QA(sA) {
          return Array.isArray(sA);
        }
        eA.isArray = QA;
        function tA(sA) {
          return !iA(sA) && !QA(sA);
        }
        eA.isObject = tA;
        function oA(sA, rA) {
          if (sA === rA)
            return !0;
          if (iA(sA) || iA(rA))
            return !1;
          let uA = QA(sA), hA = QA(rA);
          return uA !== hA ? !1 : uA && hA ? aA(sA, rA) : nA(sA, rA);
        }
        eA.deepEqual = oA;
        function EA(sA) {
          return iA(sA) ? sA : QA(sA) ? lA(sA) : cA(sA);
        }
        eA.deepCopy = EA;
        function aA(sA, rA) {
          if (sA === rA)
            return !0;
          if (sA.length !== rA.length)
            return !1;
          for (let uA = 0, hA = sA.length; uA < hA; ++uA)
            if (!oA(sA[uA], rA[uA]))
              return !1;
          return !0;
        }
        function nA(sA, rA) {
          if (sA === rA)
            return !0;
          for (let uA in sA)
            if (sA[uA] !== void 0 && !(uA in rA))
              return !1;
          for (let uA in rA)
            if (rA[uA] !== void 0 && !(uA in sA))
              return !1;
          for (let uA in sA) {
            let hA = sA[uA], dA = rA[uA];
            if (!(hA === void 0 && dA === void 0) && (hA === void 0 || dA === void 0 || !oA(hA, dA)))
              return !1;
          }
          return !0;
        }
        function lA(sA) {
          let rA = new Array(sA.length);
          for (let uA = 0, hA = sA.length; uA < hA; ++uA)
            rA[uA] = EA(sA[uA]);
          return rA;
        }
        function cA(sA) {
          let rA = {};
          for (let uA in sA) {
            let hA = sA[uA];
            hA !== void 0 && (rA[uA] = EA(hA));
          }
          return rA;
        }
      })(g.JSONExt || (g.JSONExt = {}));
      class k {
        constructor() {
          this._types = [], this._values = [];
        }
        /**
         * Get an array of the MIME types contained within the dataset.
         *
         * @returns A new array of the MIME types, in order of insertion.
         */
        types() {
          return this._types.slice();
        }
        /**
         * Test whether the dataset has an entry for the given type.
         *
         * @param mime - The MIME type of interest.
         *
         * @returns `true` if the dataset contains a value for the given
         *   MIME type, `false` otherwise.
         */
        hasData(iA) {
          return this._types.indexOf(iA) !== -1;
        }
        /**
         * Get the data value for the given MIME type.
         *
         * @param mime - The MIME type of interest.
         *
         * @returns The value for the given MIME type, or `undefined` if
         *   the dataset does not contain a value for the type.
         */
        getData(iA) {
          let QA = this._types.indexOf(iA);
          return QA !== -1 ? this._values[QA] : void 0;
        }
        /**
         * Set the data value for the given MIME type.
         *
         * @param mime - The MIME type of interest.
         *
         * @param data - The data value for the given MIME type.
         *
         * #### Notes
         * This will overwrite any previous entry for the MIME type.
         */
        setData(iA, QA) {
          this.clearData(iA), this._types.push(iA), this._values.push(QA);
        }
        /**
         * Remove the data entry for the given MIME type.
         *
         * @param mime - The MIME type of interest.
         *
         * #### Notes
         * This is a no-op if there is no entry for the given MIME type.
         */
        clearData(iA) {
          let QA = this._types.indexOf(iA);
          QA !== -1 && (this._types.splice(QA, 1), this._values.splice(QA, 1));
        }
        /**
         * Remove all data entries from the dataset.
         */
        clear() {
          this._types.length = 0, this._values.length = 0;
        }
      }
      class H {
        constructor(iA = {}) {
          this._application = null, this._validatePlugin = () => !0, this._plugins = /* @__PURE__ */ new Map(), this._services = /* @__PURE__ */ new Map(), iA.validatePlugin && (console.info("Plugins may be rejected by the custom validation plugin method."), this._validatePlugin = iA.validatePlugin);
        }
        /**
         * The application object.
         *
         * It will be provided as first argument to the
         * plugins activation and deactivation functions.
         *
         * It can only be set once.
         *
         * By default, it is `null`.
         */
        get application() {
          return this._application;
        }
        set application(iA) {
          if (this._application !== null)
            throw Error("PluginRegistry.application is already set. It cannot be overridden.");
          this._application = iA;
        }
        /**
         * The list of all the deferred plugins.
         */
        get deferredPlugins() {
          return Array.from(this._plugins).filter(([iA, QA]) => QA.autoStart === "defer").map(([iA, QA]) => iA);
        }
        /**
         * Get a plugin description.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns The plugin description.
         */
        getPluginDescription(iA) {
          var QA, tA;
          return (tA = (QA = this._plugins.get(iA)) === null || QA === void 0 ? void 0 : QA.description) !== null && tA !== void 0 ? tA : "";
        }
        /**
         * Test whether a plugin is registered with the application.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns `true` if the plugin is registered, `false` otherwise.
         */
        hasPlugin(iA) {
          return this._plugins.has(iA);
        }
        /**
         * Test whether a plugin is activated with the application.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns `true` if the plugin is activated, `false` otherwise.
         */
        isPluginActivated(iA) {
          var QA, tA;
          return (tA = (QA = this._plugins.get(iA)) === null || QA === void 0 ? void 0 : QA.activated) !== null && tA !== void 0 ? tA : !1;
        }
        /**
         * List the IDs of the plugins registered with the application.
         *
         * @returns A new array of the registered plugin IDs.
         */
        listPlugins() {
          return Array.from(this._plugins.keys());
        }
        /**
         * Register a plugin with the application.
         *
         * @param plugin - The plugin to register.
         *
         * #### Notes
         * An error will be thrown if a plugin with the same ID is already
         * registered, or if the plugin has a circular dependency.
         *
         * If the plugin provides a service which has already been provided
         * by another plugin, the new service will override the old service.
         */
        registerPlugin(iA) {
          if (this._plugins.has(iA.id))
            throw new TypeError(`Plugin '${iA.id}' is already registered.`);
          if (!this._validatePlugin(iA))
            throw new Error(`Plugin '${iA.id}' is not valid.`);
          const QA = AA.createPluginData(iA);
          AA.ensureNoCycle(QA, this._plugins, this._services), QA.provides && this._services.set(QA.provides, QA.id), this._plugins.set(QA.id, QA);
        }
        /**
         * Register multiple plugins with the application.
         *
         * @param plugins - The plugins to register.
         *
         * #### Notes
         * This calls `registerPlugin()` for each of the given plugins.
         */
        registerPlugins(iA) {
          for (const QA of iA)
            this.registerPlugin(QA);
        }
        /**
         * Deregister a plugin with the application.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @param force - Whether to deregister the plugin even if it is active.
         */
        deregisterPlugin(iA, QA) {
          const tA = this._plugins.get(iA);
          if (tA) {
            if (tA.activated && !QA)
              throw new Error(`Plugin '${iA}' is still active.`);
            this._plugins.delete(iA);
          }
        }
        /**
         * Activate the plugin with the given ID.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns A promise which resolves when the plugin is activated
         *   or rejects with an error if it cannot be activated.
         */
        async activatePlugin(iA) {
          const QA = this._plugins.get(iA);
          if (!QA)
            throw new ReferenceError(`Plugin '${iA}' is not registered.`);
          if (QA.activated)
            return;
          if (QA.promise)
            return QA.promise;
          const tA = QA.requires.map((EA) => this.resolveRequiredService(EA)), oA = QA.optional.map((EA) => this.resolveOptionalService(EA));
          return QA.promise = Promise.all([...tA, ...oA]).then((EA) => QA.activate.apply(void 0, [this.application, ...EA])).then((EA) => {
            QA.service = EA, QA.activated = !0, QA.promise = null;
          }).catch((EA) => {
            throw QA.promise = null, EA;
          }), QA.promise;
        }
        /**
         * Activate all the deferred plugins.
         *
         * @returns A promise which will resolve when each plugin is activated
         * or rejects with an error if one cannot be activated.
         */
        async activatePlugins(iA, QA = {}) {
          switch (iA) {
            case "defer": {
              const tA = this.deferredPlugins.filter((oA) => this._plugins.get(oA).autoStart).map((oA) => this.activatePlugin(oA));
              await Promise.all(tA);
              break;
            }
            case "startUp": {
              const oA = AA.collectStartupPlugins(this._plugins, QA).map(async (EA) => {
                try {
                  return await this.activatePlugin(EA);
                } catch (aA) {
                  console.error(`Plugin '${EA}' failed to activate.`, aA);
                }
              });
              await Promise.all(oA);
              break;
            }
          }
        }
        /**
         * Deactivate the plugin and its downstream dependents if and only if the
         * plugin and its dependents all support `deactivate`.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns A list of IDs of downstream plugins deactivated with this one.
         */
        async deactivatePlugin(iA) {
          const QA = this._plugins.get(iA);
          if (!QA)
            throw new ReferenceError(`Plugin '${iA}' is not registered.`);
          if (!QA.activated)
            return [];
          if (!QA.deactivate)
            throw new TypeError(`Plugin '${iA}'#deactivate() method missing`);
          const tA = AA.findDependents(iA, this._plugins, this._services), oA = tA.map((EA) => this._plugins.get(EA));
          for (const EA of oA)
            if (!EA.deactivate)
              throw new TypeError(`Plugin ${EA.id}#deactivate() method missing (depends on ${iA})`);
          for (const EA of oA) {
            const aA = [...EA.requires, ...EA.optional].map((nA) => {
              const lA = this._services.get(nA);
              return lA ? this._plugins.get(lA).service : null;
            });
            await EA.deactivate(this.application, ...aA), EA.service = null, EA.activated = !1;
          }
          return tA.pop(), tA;
        }
        /**
         * Resolve a required service of a given type.
         *
         * @param token - The token for the service type of interest.
         *
         * @returns A promise which resolves to an instance of the requested
         *   service, or rejects with an error if it cannot be resolved.
         *
         * #### Notes
         * Services are singletons. The same instance will be returned each
         * time a given service token is resolved.
         *
         * If the plugin which provides the service has not been activated,
         * resolving the service will automatically activate the plugin.
         *
         * User code will not typically call this method directly. Instead,
         * the required services for the user's plugins will be resolved
         * automatically when the plugin is activated.
         */
        async resolveRequiredService(iA) {
          const QA = this._services.get(iA);
          if (!QA)
            throw new TypeError(`No provider for: ${iA.name}.`);
          const tA = this._plugins.get(QA);
          return tA.activated || await this.activatePlugin(QA), tA.service;
        }
        /**
         * Resolve an optional service of a given type.
         *
         * @param token - The token for the service type of interest.
         *
         * @returns A promise which resolves to an instance of the requested
         *   service, or `null` if it cannot be resolved.
         *
         * #### Notes
         * Services are singletons. The same instance will be returned each
         * time a given service token is resolved.
         *
         * If the plugin which provides the service has not been activated,
         * resolving the service will automatically activate the plugin.
         *
         * User code will not typically call this method directly. Instead,
         * the optional services for the user's plugins will be resolved
         * automatically when the plugin is activated.
         */
        async resolveOptionalService(iA) {
          const QA = this._services.get(iA);
          if (!QA)
            return null;
          const tA = this._plugins.get(QA);
          if (!tA.activated)
            try {
              await this.activatePlugin(QA);
            } catch (oA) {
              return console.error(oA), null;
            }
          return tA.service;
        }
      }
      var AA;
      (function(eA) {
        class iA {
          constructor(nA) {
            var lA, cA, sA, rA;
            this._activated = !1, this._promise = null, this._service = null, this.id = nA.id, this.description = (lA = nA.description) !== null && lA !== void 0 ? lA : "", this.activate = nA.activate, this.deactivate = (cA = nA.deactivate) !== null && cA !== void 0 ? cA : null, this.provides = (sA = nA.provides) !== null && sA !== void 0 ? sA : null, this.autoStart = (rA = nA.autoStart) !== null && rA !== void 0 ? rA : !1, this.requires = nA.requires ? nA.requires.slice() : [], this.optional = nA.optional ? nA.optional.slice() : [];
          }
          /**
           * Whether the plugin has been activated.
           */
          get activated() {
            return this._activated;
          }
          set activated(nA) {
            this._activated = nA;
          }
          /**
           * The resolved service for the plugin, or `null`.
           */
          get service() {
            return this._service;
          }
          set service(nA) {
            this._service = nA;
          }
          /**
           * The pending resolver promise, or `null`.
           */
          get promise() {
            return this._promise;
          }
          set promise(nA) {
            this._promise = nA;
          }
        }
        function QA(aA) {
          return new iA(aA);
        }
        eA.createPluginData = QA;
        function tA(aA, nA, lA) {
          const cA = [...aA.requires, ...aA.optional], sA = (uA) => {
            if (uA === aA.provides)
              return !0;
            const hA = lA.get(uA);
            if (!hA)
              return !1;
            const dA = nA.get(hA), GA = [...dA.requires, ...dA.optional];
            return GA.length === 0 ? !1 : (rA.push(hA), GA.some(sA) ? !0 : (rA.pop(), !1));
          };
          if (!aA.provides || cA.length === 0)
            return;
          const rA = [aA.id];
          if (cA.some(sA))
            throw new ReferenceError(`Cycle detected: ${rA.join(" -> ")}.`);
        }
        eA.ensureNoCycle = tA;
        function oA(aA, nA, lA) {
          const cA = new Array(), sA = (GA) => {
            const DA = nA.get(GA), wA = [...DA.requires, ...DA.optional];
            cA.push(...wA.reduce((bA, yA) => {
              const pA = lA.get(yA);
              return pA && bA.push([GA, pA]), bA;
            }, []));
          };
          for (const GA of nA.keys())
            sA(GA);
          const rA = cA.filter((GA) => GA[1] === aA);
          let uA = 0;
          for (; rA.length > uA; ) {
            const GA = rA.length, DA = new Set(rA.map((wA) => wA[0]));
            for (const wA of DA)
              cA.filter((bA) => bA[1] === wA).forEach((bA) => {
                rA.includes(bA) || rA.push(bA);
              });
            uA = GA;
          }
          const hA = d.topologicSort(rA), dA = hA.findIndex((GA) => GA === aA);
          return dA === -1 ? [aA] : hA.slice(0, dA + 1);
        }
        eA.findDependents = oA;
        function EA(aA, nA) {
          const lA = /* @__PURE__ */ new Set();
          for (const cA of aA.keys())
            aA.get(cA).autoStart === !0 && lA.add(cA);
          if (nA.startPlugins)
            for (const cA of nA.startPlugins)
              lA.add(cA);
          if (nA.ignorePlugins)
            for (const cA of nA.ignorePlugins)
              lA.delete(cA);
          return Array.from(lA);
        }
        eA.collectStartupPlugins = EA;
      })(AA || (AA = {}));
      class gA {
        /**
         * Construct a new promise delegate.
         */
        constructor() {
          this.promise = new Promise((iA, QA) => {
            this._resolve = iA, this._reject = QA;
          });
        }
        /**
         * Resolve the wrapped promise with the given value.
         *
         * @param value - The value to use for resolving the promise.
         */
        resolve(iA) {
          let QA = this._resolve;
          QA(iA);
        }
        /**
         * Reject the wrapped promise with the given value.
         *
         * @reason - The reason for rejecting the promise.
         */
        reject(iA) {
          let QA = this._reject;
          QA(iA);
        }
      }
      class IA {
        /**
         * Construct a new token.
         *
         * @param name - A human readable name for the token.
         * @param description - Token purpose description for documentation.
         */
        constructor(iA, QA) {
          this.name = iA, this.description = QA ?? "", this._tokenStructuralPropertyT = null;
        }
      }
      function CA(eA) {
        let iA = 0;
        for (let QA = 0, tA = eA.length; QA < tA; ++QA)
          QA % 4 === 0 && (iA = Math.random() * 4294967295 >>> 0), eA[QA] = iA & 255, iA >>>= 8;
      }
      g.Random = void 0, (function(eA) {
        eA.getRandomValues = (() => {
          const iA = typeof window < "u" && (window.crypto || window.msCrypto) || null;
          return iA && typeof iA.getRandomValues == "function" ? function(tA) {
            return iA.getRandomValues(tA);
          } : CA;
        })();
      })(g.Random || (g.Random = {}));
      function BA(eA) {
        const iA = new Uint8Array(16), QA = new Array(256);
        for (let tA = 0; tA < 16; ++tA)
          QA[tA] = "0" + tA.toString(16);
        for (let tA = 16; tA < 256; ++tA)
          QA[tA] = tA.toString(16);
        return function() {
          return eA(iA), iA[6] = 64 | iA[6] & 15, iA[8] = 128 | iA[8] & 63, QA[iA[0]] + QA[iA[1]] + QA[iA[2]] + QA[iA[3]] + "-" + QA[iA[4]] + QA[iA[5]] + "-" + QA[iA[6]] + QA[iA[7]] + "-" + QA[iA[8]] + QA[iA[9]] + "-" + QA[iA[10]] + QA[iA[11]] + QA[iA[12]] + QA[iA[13]] + QA[iA[14]] + QA[iA[15]];
        };
      }
      g.UUID = void 0, (function(eA) {
        eA.uuid4 = BA(g.Random.getRandomValues);
      })(g.UUID || (g.UUID = {})), g.MimeData = k, g.PluginRegistry = H, g.PromiseDelegate = gA, g.Token = IA;
    }));
  })(dist$4, dist$4.exports)), dist$4.exports;
}
var minimist, hasRequiredMinimist;
function requireMinimist() {
  if (hasRequiredMinimist) return minimist;
  hasRequiredMinimist = 1;
  function n(d, k) {
    var H = d;
    k.slice(0, -1).forEach(function(gA) {
      H = H[gA] || {};
    });
    var AA = k[k.length - 1];
    return AA in H;
  }
  function t(d) {
    return typeof d == "number" || /^0x[0-9a-f]+$/i.test(d) ? !0 : /^[-+]?(?:\d+(?:\.\d*)?|\.\d+)(e[-+]?\d+)?$/.test(d);
  }
  function g(d, k) {
    return k === "constructor" && typeof d[k] == "function" || k === "__proto__";
  }
  return minimist = function(d, k) {
    k || (k = {});
    var H = {
      bools: {},
      strings: {},
      unknownFn: null
    };
    typeof k.unknown == "function" && (H.unknownFn = k.unknown), typeof k.boolean == "boolean" && k.boolean ? H.allBools = !0 : [].concat(k.boolean).filter(Boolean).forEach(function(uA) {
      H.bools[uA] = !0;
    });
    var AA = {};
    function gA(uA) {
      return AA[uA].some(function(hA) {
        return H.bools[hA];
      });
    }
    Object.keys(k.alias || {}).forEach(function(uA) {
      AA[uA] = [].concat(k.alias[uA]), AA[uA].forEach(function(hA) {
        AA[hA] = [uA].concat(AA[uA].filter(function(dA) {
          return hA !== dA;
        }));
      });
    }), [].concat(k.string).filter(Boolean).forEach(function(uA) {
      H.strings[uA] = !0, AA[uA] && [].concat(AA[uA]).forEach(function(hA) {
        H.strings[hA] = !0;
      });
    });
    var IA = k.default || {}, CA = { _: [] };
    function BA(uA, hA) {
      return H.allBools && /^--[^=]+$/.test(hA) || H.strings[uA] || H.bools[uA] || AA[uA];
    }
    function eA(uA, hA, dA) {
      for (var GA = uA, DA = 0; DA < hA.length - 1; DA++) {
        var wA = hA[DA];
        if (g(GA, wA))
          return;
        GA[wA] === void 0 && (GA[wA] = {}), (GA[wA] === Object.prototype || GA[wA] === Number.prototype || GA[wA] === String.prototype) && (GA[wA] = {}), GA[wA] === Array.prototype && (GA[wA] = []), GA = GA[wA];
      }
      var bA = hA[hA.length - 1];
      g(GA, bA) || ((GA === Object.prototype || GA === Number.prototype || GA === String.prototype) && (GA = {}), GA === Array.prototype && (GA = []), GA[bA] === void 0 || H.bools[bA] || typeof GA[bA] == "boolean" ? GA[bA] = dA : Array.isArray(GA[bA]) ? GA[bA].push(dA) : GA[bA] = [GA[bA], dA]);
    }
    function iA(uA, hA, dA) {
      if (!(dA && H.unknownFn && !BA(uA, dA) && H.unknownFn(dA) === !1)) {
        var GA = !H.strings[uA] && t(hA) ? Number(hA) : hA;
        eA(CA, uA.split("."), GA), (AA[uA] || []).forEach(function(DA) {
          eA(CA, DA.split("."), GA);
        });
      }
    }
    Object.keys(H.bools).forEach(function(uA) {
      iA(uA, IA[uA] === void 0 ? !1 : IA[uA]);
    });
    var QA = [];
    d.indexOf("--") !== -1 && (QA = d.slice(d.indexOf("--") + 1), d = d.slice(0, d.indexOf("--")));
    for (var tA = 0; tA < d.length; tA++) {
      var oA = d[tA], EA, aA;
      if (/^--.+=/.test(oA)) {
        var nA = oA.match(/^--([^=]+)=([\s\S]*)$/);
        EA = nA[1];
        var lA = nA[2];
        H.bools[EA] && (lA = lA !== "false"), iA(EA, lA, oA);
      } else if (/^--no-.+/.test(oA))
        EA = oA.match(/^--no-(.+)/)[1], iA(EA, !1, oA);
      else if (/^--.+/.test(oA))
        EA = oA.match(/^--(.+)/)[1], aA = d[tA + 1], aA !== void 0 && !/^(-|--)[^-]/.test(aA) && !H.bools[EA] && !H.allBools && (!AA[EA] || !gA(EA)) ? (iA(EA, aA, oA), tA += 1) : /^(true|false)$/.test(aA) ? (iA(EA, aA === "true", oA), tA += 1) : iA(EA, H.strings[EA] ? "" : !0, oA);
      else if (/^-[^-]+/.test(oA)) {
        for (var cA = oA.slice(1, -1).split(""), sA = !1, rA = 0; rA < cA.length; rA++) {
          if (aA = oA.slice(rA + 2), aA === "-") {
            iA(cA[rA], aA, oA);
            continue;
          }
          if (/[A-Za-z]/.test(cA[rA]) && aA[0] === "=") {
            iA(cA[rA], aA.slice(1), oA), sA = !0;
            break;
          }
          if (/[A-Za-z]/.test(cA[rA]) && /-?\d+(\.\d*)?(e-?\d+)?$/.test(aA)) {
            iA(cA[rA], aA, oA), sA = !0;
            break;
          }
          if (cA[rA + 1] && cA[rA + 1].match(/\W/)) {
            iA(cA[rA], oA.slice(rA + 2), oA), sA = !0;
            break;
          } else
            iA(cA[rA], H.strings[cA[rA]] ? "" : !0, oA);
        }
        EA = oA.slice(-1)[0], !sA && EA !== "-" && (d[tA + 1] && !/^(-|--)[^-]/.test(d[tA + 1]) && !H.bools[EA] && (!AA[EA] || !gA(EA)) ? (iA(EA, d[tA + 1], oA), tA += 1) : d[tA + 1] && /^(true|false)$/.test(d[tA + 1]) ? (iA(EA, d[tA + 1] === "true", oA), tA += 1) : iA(EA, H.strings[EA] ? "" : !0, oA));
      } else if ((!H.unknownFn || H.unknownFn(oA) !== !1) && CA._.push(H.strings._ || !t(oA) ? oA : Number(oA)), k.stopEarly) {
        CA._.push.apply(CA._, d.slice(tA + 1));
        break;
      }
    }
    return Object.keys(IA).forEach(function(uA) {
      n(CA, uA.split(".")) || (eA(CA, uA.split("."), IA[uA]), (AA[uA] || []).forEach(function(hA) {
        eA(CA, hA.split("."), IA[uA]);
      }));
    }), k["--"] ? CA["--"] = QA.slice() : QA.forEach(function(uA) {
      CA._.push(uA);
    }), CA;
  }, minimist;
}
var url = {}, pathBrowserify, hasRequiredPathBrowserify;
function requirePathBrowserify() {
  if (hasRequiredPathBrowserify) return pathBrowserify;
  hasRequiredPathBrowserify = 1;
  function n(k) {
    if (typeof k != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(k));
  }
  function t(k, H) {
    for (var AA = "", gA = 0, IA = -1, CA = 0, BA, eA = 0; eA <= k.length; ++eA) {
      if (eA < k.length)
        BA = k.charCodeAt(eA);
      else {
        if (BA === 47)
          break;
        BA = 47;
      }
      if (BA === 47) {
        if (!(IA === eA - 1 || CA === 1)) if (IA !== eA - 1 && CA === 2) {
          if (AA.length < 2 || gA !== 2 || AA.charCodeAt(AA.length - 1) !== 46 || AA.charCodeAt(AA.length - 2) !== 46) {
            if (AA.length > 2) {
              var iA = AA.lastIndexOf("/");
              if (iA !== AA.length - 1) {
                iA === -1 ? (AA = "", gA = 0) : (AA = AA.slice(0, iA), gA = AA.length - 1 - AA.lastIndexOf("/")), IA = eA, CA = 0;
                continue;
              }
            } else if (AA.length === 2 || AA.length === 1) {
              AA = "", gA = 0, IA = eA, CA = 0;
              continue;
            }
          }
          H && (AA.length > 0 ? AA += "/.." : AA = "..", gA = 2);
        } else
          AA.length > 0 ? AA += "/" + k.slice(IA + 1, eA) : AA = k.slice(IA + 1, eA), gA = eA - IA - 1;
        IA = eA, CA = 0;
      } else BA === 46 && CA !== -1 ? ++CA : CA = -1;
    }
    return AA;
  }
  function g(k, H) {
    var AA = H.dir || H.root, gA = H.base || (H.name || "") + (H.ext || "");
    return AA ? AA === H.root ? AA + gA : AA + k + gA : gA;
  }
  var d = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var H = "", AA = !1, gA, IA = arguments.length - 1; IA >= -1 && !AA; IA--) {
        var CA;
        IA >= 0 ? CA = arguments[IA] : (gA === void 0 && (gA = process.cwd()), CA = gA), n(CA), CA.length !== 0 && (H = CA + "/" + H, AA = CA.charCodeAt(0) === 47);
      }
      return H = t(H, !AA), AA ? H.length > 0 ? "/" + H : "/" : H.length > 0 ? H : ".";
    },
    normalize: function(H) {
      if (n(H), H.length === 0) return ".";
      var AA = H.charCodeAt(0) === 47, gA = H.charCodeAt(H.length - 1) === 47;
      return H = t(H, !AA), H.length === 0 && !AA && (H = "."), H.length > 0 && gA && (H += "/"), AA ? "/" + H : H;
    },
    isAbsolute: function(H) {
      return n(H), H.length > 0 && H.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var H, AA = 0; AA < arguments.length; ++AA) {
        var gA = arguments[AA];
        n(gA), gA.length > 0 && (H === void 0 ? H = gA : H += "/" + gA);
      }
      return H === void 0 ? "." : d.normalize(H);
    },
    relative: function(H, AA) {
      if (n(H), n(AA), H === AA || (H = d.resolve(H), AA = d.resolve(AA), H === AA)) return "";
      for (var gA = 1; gA < H.length && H.charCodeAt(gA) === 47; ++gA)
        ;
      for (var IA = H.length, CA = IA - gA, BA = 1; BA < AA.length && AA.charCodeAt(BA) === 47; ++BA)
        ;
      for (var eA = AA.length, iA = eA - BA, QA = CA < iA ? CA : iA, tA = -1, oA = 0; oA <= QA; ++oA) {
        if (oA === QA) {
          if (iA > QA) {
            if (AA.charCodeAt(BA + oA) === 47)
              return AA.slice(BA + oA + 1);
            if (oA === 0)
              return AA.slice(BA + oA);
          } else CA > QA && (H.charCodeAt(gA + oA) === 47 ? tA = oA : oA === 0 && (tA = 0));
          break;
        }
        var EA = H.charCodeAt(gA + oA), aA = AA.charCodeAt(BA + oA);
        if (EA !== aA)
          break;
        EA === 47 && (tA = oA);
      }
      var nA = "";
      for (oA = gA + tA + 1; oA <= IA; ++oA)
        (oA === IA || H.charCodeAt(oA) === 47) && (nA.length === 0 ? nA += ".." : nA += "/..");
      return nA.length > 0 ? nA + AA.slice(BA + tA) : (BA += tA, AA.charCodeAt(BA) === 47 && ++BA, AA.slice(BA));
    },
    _makeLong: function(H) {
      return H;
    },
    dirname: function(H) {
      if (n(H), H.length === 0) return ".";
      for (var AA = H.charCodeAt(0), gA = AA === 47, IA = -1, CA = !0, BA = H.length - 1; BA >= 1; --BA)
        if (AA = H.charCodeAt(BA), AA === 47) {
          if (!CA) {
            IA = BA;
            break;
          }
        } else
          CA = !1;
      return IA === -1 ? gA ? "/" : "." : gA && IA === 1 ? "//" : H.slice(0, IA);
    },
    basename: function(H, AA) {
      if (AA !== void 0 && typeof AA != "string") throw new TypeError('"ext" argument must be a string');
      n(H);
      var gA = 0, IA = -1, CA = !0, BA;
      if (AA !== void 0 && AA.length > 0 && AA.length <= H.length) {
        if (AA.length === H.length && AA === H) return "";
        var eA = AA.length - 1, iA = -1;
        for (BA = H.length - 1; BA >= 0; --BA) {
          var QA = H.charCodeAt(BA);
          if (QA === 47) {
            if (!CA) {
              gA = BA + 1;
              break;
            }
          } else
            iA === -1 && (CA = !1, iA = BA + 1), eA >= 0 && (QA === AA.charCodeAt(eA) ? --eA === -1 && (IA = BA) : (eA = -1, IA = iA));
        }
        return gA === IA ? IA = iA : IA === -1 && (IA = H.length), H.slice(gA, IA);
      } else {
        for (BA = H.length - 1; BA >= 0; --BA)
          if (H.charCodeAt(BA) === 47) {
            if (!CA) {
              gA = BA + 1;
              break;
            }
          } else IA === -1 && (CA = !1, IA = BA + 1);
        return IA === -1 ? "" : H.slice(gA, IA);
      }
    },
    extname: function(H) {
      n(H);
      for (var AA = -1, gA = 0, IA = -1, CA = !0, BA = 0, eA = H.length - 1; eA >= 0; --eA) {
        var iA = H.charCodeAt(eA);
        if (iA === 47) {
          if (!CA) {
            gA = eA + 1;
            break;
          }
          continue;
        }
        IA === -1 && (CA = !1, IA = eA + 1), iA === 46 ? AA === -1 ? AA = eA : BA !== 1 && (BA = 1) : AA !== -1 && (BA = -1);
      }
      return AA === -1 || IA === -1 || // We saw a non-dot character immediately before the dot
      BA === 0 || // The (right-most) trimmed path component is exactly '..'
      BA === 1 && AA === IA - 1 && AA === gA + 1 ? "" : H.slice(AA, IA);
    },
    format: function(H) {
      if (H === null || typeof H != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof H);
      return g("/", H);
    },
    parse: function(H) {
      n(H);
      var AA = { root: "", dir: "", base: "", ext: "", name: "" };
      if (H.length === 0) return AA;
      var gA = H.charCodeAt(0), IA = gA === 47, CA;
      IA ? (AA.root = "/", CA = 1) : CA = 0;
      for (var BA = -1, eA = 0, iA = -1, QA = !0, tA = H.length - 1, oA = 0; tA >= CA; --tA) {
        if (gA = H.charCodeAt(tA), gA === 47) {
          if (!QA) {
            eA = tA + 1;
            break;
          }
          continue;
        }
        iA === -1 && (QA = !1, iA = tA + 1), gA === 46 ? BA === -1 ? BA = tA : oA !== 1 && (oA = 1) : BA !== -1 && (oA = -1);
      }
      return BA === -1 || iA === -1 || // We saw a non-dot character immediately before the dot
      oA === 0 || // The (right-most) trimmed path component is exactly '..'
      oA === 1 && BA === iA - 1 && BA === eA + 1 ? iA !== -1 && (eA === 0 && IA ? AA.base = AA.name = H.slice(1, iA) : AA.base = AA.name = H.slice(eA, iA)) : (eA === 0 && IA ? (AA.name = H.slice(1, BA), AA.base = H.slice(1, iA)) : (AA.name = H.slice(eA, BA), AA.base = H.slice(eA, iA)), AA.ext = H.slice(BA, iA)), eA > 0 ? AA.dir = H.slice(0, eA - 1) : IA && (AA.dir = "/"), AA;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return d.posix = d, pathBrowserify = d, pathBrowserify;
}
var requiresPort, hasRequiredRequiresPort;
function requireRequiresPort() {
  return hasRequiredRequiresPort || (hasRequiredRequiresPort = 1, requiresPort = function(t, g) {
    if (g = g.split(":")[0], t = +t, !t) return !1;
    switch (g) {
      case "http":
      case "ws":
        return t !== 80;
      case "https":
      case "wss":
        return t !== 443;
      case "ftp":
        return t !== 21;
      case "gopher":
        return t !== 70;
      case "file":
        return !1;
    }
    return t !== 0;
  }), requiresPort;
}
var querystringify = {}, hasRequiredQuerystringify;
function requireQuerystringify() {
  if (hasRequiredQuerystringify) return querystringify;
  hasRequiredQuerystringify = 1;
  var n = Object.prototype.hasOwnProperty, t;
  function g(AA) {
    try {
      return decodeURIComponent(AA.replace(/\+/g, " "));
    } catch {
      return null;
    }
  }
  function d(AA) {
    try {
      return encodeURIComponent(AA);
    } catch {
      return null;
    }
  }
  function k(AA) {
    for (var gA = /([^=?#&]+)=?([^&]*)/g, IA = {}, CA; CA = gA.exec(AA); ) {
      var BA = g(CA[1]), eA = g(CA[2]);
      BA === null || eA === null || BA in IA || (IA[BA] = eA);
    }
    return IA;
  }
  function H(AA, gA) {
    gA = gA || "";
    var IA = [], CA, BA;
    typeof gA != "string" && (gA = "?");
    for (BA in AA)
      if (n.call(AA, BA)) {
        if (CA = AA[BA], !CA && (CA === null || CA === t || isNaN(CA)) && (CA = ""), BA = d(BA), CA = d(CA), BA === null || CA === null) continue;
        IA.push(BA + "=" + CA);
      }
    return IA.length ? gA + IA.join("&") : "";
  }
  return querystringify.stringify = H, querystringify.parse = k, querystringify;
}
var urlParse, hasRequiredUrlParse;
function requireUrlParse() {
  if (hasRequiredUrlParse) return urlParse;
  hasRequiredUrlParse = 1;
  var n = requireRequiresPort(), t = requireQuerystringify(), g = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, d = /[\n\r\t]/g, k = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, H = /:\d+$/, AA = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, gA = /^[a-zA-Z]:/;
  function IA(nA) {
    return (nA || "").toString().replace(g, "");
  }
  var CA = [
    ["#", "hash"],
    // Extract from the back.
    ["?", "query"],
    // Extract from the back.
    function(lA, cA) {
      return iA(cA.protocol) ? lA.replace(/\\/g, "/") : lA;
    },
    ["/", "pathname"],
    // Extract from the back.
    ["@", "auth", 1],
    // Extract from the front.
    [NaN, "host", void 0, 1, 1],
    // Set left over value.
    [/:(\d*)$/, "port", void 0, 1],
    // RegExp the back.
    [NaN, "hostname", void 0, 1, 1]
    // Set left over.
  ], BA = { hash: 1, query: 1 };
  function eA(nA) {
    var lA;
    typeof window < "u" ? lA = window : typeof commonjsGlobal$2 < "u" ? lA = commonjsGlobal$2 : typeof self < "u" ? lA = self : lA = {};
    var cA = lA.location || {};
    nA = nA || cA;
    var sA = {}, rA = typeof nA, uA;
    if (nA.protocol === "blob:")
      sA = new oA(unescape(nA.pathname), {});
    else if (rA === "string") {
      sA = new oA(nA, {});
      for (uA in BA) delete sA[uA];
    } else if (rA === "object") {
      for (uA in nA)
        uA in BA || (sA[uA] = nA[uA]);
      sA.slashes === void 0 && (sA.slashes = k.test(nA.href));
    }
    return sA;
  }
  function iA(nA) {
    return nA === "file:" || nA === "ftp:" || nA === "http:" || nA === "https:" || nA === "ws:" || nA === "wss:";
  }
  function QA(nA, lA) {
    nA = IA(nA), nA = nA.replace(d, ""), lA = lA || {};
    var cA = AA.exec(nA), sA = cA[1] ? cA[1].toLowerCase() : "", rA = !!cA[2], uA = !!cA[3], hA = 0, dA;
    return rA ? uA ? (dA = cA[2] + cA[3] + cA[4], hA = cA[2].length + cA[3].length) : (dA = cA[2] + cA[4], hA = cA[2].length) : uA ? (dA = cA[3] + cA[4], hA = cA[3].length) : dA = cA[4], sA === "file:" ? hA >= 2 && (dA = dA.slice(2)) : iA(sA) ? dA = cA[4] : sA ? rA && (dA = dA.slice(2)) : hA >= 2 && iA(lA.protocol) && (dA = cA[4]), {
      protocol: sA,
      slashes: rA || iA(sA),
      slashesCount: hA,
      rest: dA
    };
  }
  function tA(nA, lA) {
    if (nA === "") return lA;
    for (var cA = (lA || "/").split("/").slice(0, -1).concat(nA.split("/")), sA = cA.length, rA = cA[sA - 1], uA = !1, hA = 0; sA--; )
      cA[sA] === "." ? cA.splice(sA, 1) : cA[sA] === ".." ? (cA.splice(sA, 1), hA++) : hA && (sA === 0 && (uA = !0), cA.splice(sA, 1), hA--);
    return uA && cA.unshift(""), (rA === "." || rA === "..") && cA.push(""), cA.join("/");
  }
  function oA(nA, lA, cA) {
    if (nA = IA(nA), nA = nA.replace(d, ""), !(this instanceof oA))
      return new oA(nA, lA, cA);
    var sA, rA, uA, hA, dA, GA, DA = CA.slice(), wA = typeof lA, bA = this, yA = 0;
    for (wA !== "object" && wA !== "string" && (cA = lA, lA = null), cA && typeof cA != "function" && (cA = t.parse), lA = eA(lA), rA = QA(nA || "", lA), sA = !rA.protocol && !rA.slashes, bA.slashes = rA.slashes || sA && lA.slashes, bA.protocol = rA.protocol || lA.protocol || "", nA = rA.rest, (rA.protocol === "file:" && (rA.slashesCount !== 2 || gA.test(nA)) || !rA.slashes && (rA.protocol || rA.slashesCount < 2 || !iA(bA.protocol))) && (DA[3] = [/(.*)/, "pathname"]); yA < DA.length; yA++) {
      if (hA = DA[yA], typeof hA == "function") {
        nA = hA(nA, bA);
        continue;
      }
      uA = hA[0], GA = hA[1], uA !== uA ? bA[GA] = nA : typeof uA == "string" ? (dA = uA === "@" ? nA.lastIndexOf(uA) : nA.indexOf(uA), ~dA && (typeof hA[2] == "number" ? (bA[GA] = nA.slice(0, dA), nA = nA.slice(dA + hA[2])) : (bA[GA] = nA.slice(dA), nA = nA.slice(0, dA)))) : (dA = uA.exec(nA)) && (bA[GA] = dA[1], nA = nA.slice(0, dA.index)), bA[GA] = bA[GA] || sA && hA[3] && lA[GA] || "", hA[4] && (bA[GA] = bA[GA].toLowerCase());
    }
    cA && (bA.query = cA(bA.query)), sA && lA.slashes && bA.pathname.charAt(0) !== "/" && (bA.pathname !== "" || lA.pathname !== "") && (bA.pathname = tA(bA.pathname, lA.pathname)), bA.pathname.charAt(0) !== "/" && iA(bA.protocol) && (bA.pathname = "/" + bA.pathname), n(bA.port, bA.protocol) || (bA.host = bA.hostname, bA.port = ""), bA.username = bA.password = "", bA.auth && (dA = bA.auth.indexOf(":"), ~dA ? (bA.username = bA.auth.slice(0, dA), bA.username = encodeURIComponent(decodeURIComponent(bA.username)), bA.password = bA.auth.slice(dA + 1), bA.password = encodeURIComponent(decodeURIComponent(bA.password))) : bA.username = encodeURIComponent(decodeURIComponent(bA.auth)), bA.auth = bA.password ? bA.username + ":" + bA.password : bA.username), bA.origin = bA.protocol !== "file:" && iA(bA.protocol) && bA.host ? bA.protocol + "//" + bA.host : "null", bA.href = bA.toString();
  }
  function EA(nA, lA, cA) {
    var sA = this;
    switch (nA) {
      case "query":
        typeof lA == "string" && lA.length && (lA = (cA || t.parse)(lA)), sA[nA] = lA;
        break;
      case "port":
        sA[nA] = lA, n(lA, sA.protocol) ? lA && (sA.host = sA.hostname + ":" + lA) : (sA.host = sA.hostname, sA[nA] = "");
        break;
      case "hostname":
        sA[nA] = lA, sA.port && (lA += ":" + sA.port), sA.host = lA;
        break;
      case "host":
        sA[nA] = lA, H.test(lA) ? (lA = lA.split(":"), sA.port = lA.pop(), sA.hostname = lA.join(":")) : (sA.hostname = lA, sA.port = "");
        break;
      case "protocol":
        sA.protocol = lA.toLowerCase(), sA.slashes = !cA;
        break;
      case "pathname":
      case "hash":
        if (lA) {
          var rA = nA === "pathname" ? "/" : "#";
          sA[nA] = lA.charAt(0) !== rA ? rA + lA : lA;
        } else
          sA[nA] = lA;
        break;
      case "username":
      case "password":
        sA[nA] = encodeURIComponent(lA);
        break;
      case "auth":
        var uA = lA.indexOf(":");
        ~uA ? (sA.username = lA.slice(0, uA), sA.username = encodeURIComponent(decodeURIComponent(sA.username)), sA.password = lA.slice(uA + 1), sA.password = encodeURIComponent(decodeURIComponent(sA.password))) : sA.username = encodeURIComponent(decodeURIComponent(lA));
    }
    for (var hA = 0; hA < CA.length; hA++) {
      var dA = CA[hA];
      dA[4] && (sA[dA[1]] = sA[dA[1]].toLowerCase());
    }
    return sA.auth = sA.password ? sA.username + ":" + sA.password : sA.username, sA.origin = sA.protocol !== "file:" && iA(sA.protocol) && sA.host ? sA.protocol + "//" + sA.host : "null", sA.href = sA.toString(), sA;
  }
  function aA(nA) {
    (!nA || typeof nA != "function") && (nA = t.stringify);
    var lA, cA = this, sA = cA.host, rA = cA.protocol;
    rA && rA.charAt(rA.length - 1) !== ":" && (rA += ":");
    var uA = rA + (cA.protocol && cA.slashes || iA(cA.protocol) ? "//" : "");
    return cA.username ? (uA += cA.username, cA.password && (uA += ":" + cA.password), uA += "@") : cA.password ? (uA += ":" + cA.password, uA += "@") : cA.protocol !== "file:" && iA(cA.protocol) && !sA && cA.pathname !== "/" && (uA += "@"), (sA[sA.length - 1] === ":" || H.test(cA.hostname) && !cA.port) && (sA += ":"), uA += sA + cA.pathname, lA = typeof cA.query == "object" ? nA(cA.query) : cA.query, lA && (uA += lA.charAt(0) !== "?" ? "?" + lA : lA), cA.hash && (uA += cA.hash), uA;
  }
  return oA.prototype = { set: EA, toString: aA }, oA.extractProtocol = QA, oA.location = eA, oA.trimLeft = IA, oA.qs = t, urlParse = oA, urlParse;
}
var hasRequiredUrl;
function requireUrl() {
  if (hasRequiredUrl) return url;
  hasRequiredUrl = 1;
  var n = url && url.__importDefault || function(k) {
    return k && k.__esModule ? k : { default: k };
  };
  Object.defineProperty(url, "__esModule", { value: !0 }), url.URLExt = void 0;
  const t = requirePathBrowserify(), g = n(requireUrlParse());
  var d;
  return (function(k) {
    function H(QA) {
      if (typeof document < "u" && document) {
        const tA = document.createElement("a");
        return tA.href = QA, tA;
      }
      return (0, g.default)(QA);
    }
    k.parse = H;
    function AA(QA) {
      return (0, g.default)(QA).hostname;
    }
    k.getHostName = AA;
    function gA(QA) {
      return QA && H(QA).toString();
    }
    k.normalize = gA;
    function IA(...QA) {
      let tA = (0, g.default)(QA[0], {});
      const oA = tA.protocol === "" && tA.slashes;
      oA && (tA = (0, g.default)(QA[0], "https:" + QA[0]));
      const EA = `${oA ? "" : tA.protocol}${tA.slashes ? "//" : ""}${tA.auth}${tA.auth ? "@" : ""}${tA.host}`, aA = t.posix.join(`${EA && tA.pathname[0] !== "/" ? "/" : ""}${tA.pathname}`, ...QA.slice(1));
      return `${EA}${aA === "." ? "" : aA}`;
    }
    k.join = IA;
    function CA(QA) {
      return IA(...QA.split("/").map(encodeURIComponent));
    }
    k.encodeParts = CA;
    function BA(QA) {
      const tA = Object.keys(QA).filter((oA) => oA.length > 0);
      return tA.length ? "?" + tA.map((oA) => {
        const EA = encodeURIComponent(String(QA[oA]));
        return oA + (EA ? "=" + EA : "");
      }).join("&") : "";
    }
    k.objectToQueryString = BA;
    function eA(QA) {
      return QA.replace(/^\?/, "").split("&").reduce((tA, oA) => {
        const [EA, aA] = oA.split("=");
        return EA.length > 0 && (tA[EA] = decodeURIComponent(aA || "")), tA;
      }, {});
    }
    k.queryStringToObject = eA;
    function iA(QA, tA = !1) {
      const { protocol: oA } = H(QA);
      return (!oA || QA.toLowerCase().indexOf(oA) !== 0) && (tA ? QA.indexOf("//") !== 0 : QA.indexOf("/") !== 0);
    }
    k.isLocal = iA;
  })(d || (url.URLExt = d = {})), url;
}
var hasRequiredPageconfig;
function requirePageconfig() {
  if (hasRequiredPageconfig) return pageconfig;
  hasRequiredPageconfig = 1;
  var __importDefault = pageconfig && pageconfig.__importDefault || function(n) {
    return n && n.__esModule ? n : { default: n };
  };
  Object.defineProperty(pageconfig, "__esModule", { value: !0 }), pageconfig.PageConfig = void 0;
  const coreutils_1 = requireDist$2(), minimist_1 = __importDefault(requireMinimist()), url_1 = /* @__PURE__ */ requireUrl();
  var PageConfig;
  return (function(PageConfig) {
    function getOption(name) {
      if (configData)
        return configData[name] || getBodyData(name);
      configData = /* @__PURE__ */ Object.create(null);
      let found = !1;
      if (typeof document < "u" && document) {
        const n = document.getElementById("jupyter-config-data");
        n && (configData = JSON.parse(n.textContent || ""), found = !0);
      }
      if (!found && typeof process < "u" && process.argv)
        try {
          const cli = (0, minimist_1.default)(process.argv.slice(2)), path = requirePathBrowserify();
          let fullPath = "";
          "jupyter-config-data" in cli ? fullPath = path.resolve(cli["jupyter-config-data"]) : "JUPYTER_CONFIG_DATA" in process.env && (fullPath = path.resolve(process.env.JUPYTER_CONFIG_DATA)), fullPath && (configData = eval("require")(fullPath));
        } catch (n) {
          console.error(n);
        }
      if (!coreutils_1.JSONExt.isObject(configData))
        configData = /* @__PURE__ */ Object.create(null);
      else
        for (const n in configData)
          typeof configData[n] != "string" && (configData[n] = JSON.stringify(configData[n]));
      return configData[name] || getBodyData(name);
    }
    PageConfig.getOption = getOption;
    function setOption(n, t) {
      const g = getOption(n);
      return configData[n] = t, g;
    }
    PageConfig.setOption = setOption;
    function getBaseUrl() {
      return url_1.URLExt.normalize(getOption("baseUrl") || "/");
    }
    PageConfig.getBaseUrl = getBaseUrl;
    function getTreeUrl() {
      return url_1.URLExt.join(getBaseUrl(), getOption("treeUrl"));
    }
    PageConfig.getTreeUrl = getTreeUrl;
    function getShareUrl() {
      return url_1.URLExt.normalize(getOption("shareUrl") || getBaseUrl());
    }
    PageConfig.getShareUrl = getShareUrl;
    function getTreeShareUrl() {
      return url_1.URLExt.normalize(url_1.URLExt.join(getShareUrl(), getOption("treeUrl")));
    }
    PageConfig.getTreeShareUrl = getTreeShareUrl;
    function getUrl(n) {
      var t, g, d, k;
      let H = n.toShare ? getShareUrl() : getBaseUrl();
      const AA = (t = n.mode) !== null && t !== void 0 ? t : getOption("mode"), gA = (g = n.workspace) !== null && g !== void 0 ? g : getOption("workspace"), IA = AA === "single-document" ? "doc" : "lab";
      H = url_1.URLExt.join(H, IA), gA !== PageConfig.defaultWorkspace && (H = url_1.URLExt.join(H, "workspaces", encodeURIComponent((d = getOption("workspace")) !== null && d !== void 0 ? d : PageConfig.defaultWorkspace)));
      const CA = (k = n.treePath) !== null && k !== void 0 ? k : getOption("treePath");
      return CA && (H = url_1.URLExt.join(H, "tree", url_1.URLExt.encodeParts(CA))), H;
    }
    PageConfig.getUrl = getUrl, PageConfig.defaultWorkspace = "default";
    function getWsUrl(n) {
      let t = getOption("wsUrl");
      if (!t) {
        if (n = n ? url_1.URLExt.normalize(n) : getBaseUrl(), n.indexOf("http") !== 0)
          return "";
        t = "ws" + n.slice(4);
      }
      return url_1.URLExt.normalize(t);
    }
    PageConfig.getWsUrl = getWsUrl;
    function getNBConvertURL({ path: n, format: t, download: g }) {
      const d = url_1.URLExt.encodeParts(n), k = url_1.URLExt.join(getBaseUrl(), "nbconvert", t, d);
      return g ? k + "?download=true" : k;
    }
    PageConfig.getNBConvertURL = getNBConvertURL;
    function getToken() {
      return getOption("token") || getBodyData("jupyterApiToken");
    }
    PageConfig.getToken = getToken;
    function getNotebookVersion() {
      const n = getOption("notebookVersion");
      return n === "" ? [0, 0, 0] : JSON.parse(n);
    }
    PageConfig.getNotebookVersion = getNotebookVersion;
    let configData = null;
    function getBodyData(n) {
      if (typeof document > "u" || !document.body)
        return "";
      const t = document.body.dataset[n];
      return typeof t > "u" ? "" : decodeURIComponent(t);
    }
    (function(n) {
      function t(k) {
        try {
          const H = getOption(k);
          if (H)
            return JSON.parse(H);
        } catch (H) {
          console.warn(`Unable to parse ${k}.`, H);
        }
        return [];
      }
      n.deferred = t("deferredExtensions"), n.disabled = t("disabledExtensions");
      function g(k) {
        const H = k.indexOf(":");
        let AA = "";
        return H !== -1 && (AA = k.slice(0, H)), n.deferred.some((gA) => gA === k || AA && gA === AA);
      }
      n.isDeferred = g;
      function d(k) {
        const H = k.indexOf(":");
        let AA = "";
        return H !== -1 && (AA = k.slice(0, H)), n.disabled.some((gA) => gA === k || AA && gA === AA);
      }
      n.isDisabled = d;
    })(PageConfig.Extension || (PageConfig.Extension = {}));
  })(PageConfig || (pageconfig.PageConfig = PageConfig = {})), pageconfig;
}
var path$7 = {}, hasRequiredPath$1;
function requirePath$1() {
  if (hasRequiredPath$1) return path$7;
  hasRequiredPath$1 = 1, Object.defineProperty(path$7, "__esModule", { value: !0 }), path$7.PathExt = void 0;
  const n = requirePathBrowserify();
  var t;
  return (function(g) {
    function d(...QA) {
      const tA = n.posix.join(...QA);
      return tA === "." ? "" : iA(tA);
    }
    g.join = d;
    function k(...QA) {
      const tA = n.posix.join(...QA);
      return tA === "." ? "" : tA;
    }
    g.joinWithLeadingSlash = k;
    function H(QA, tA) {
      return n.posix.basename(QA, tA);
    }
    g.basename = H;
    function AA(QA) {
      const tA = iA(n.posix.dirname(QA));
      return tA === "." ? "" : tA;
    }
    g.dirname = AA;
    function gA(QA) {
      return n.posix.extname(QA);
    }
    g.extname = gA;
    function IA(QA) {
      return QA === "" ? "" : iA(n.posix.normalize(QA));
    }
    g.normalize = IA;
    function CA(...QA) {
      return iA(n.posix.resolve(...QA));
    }
    g.resolve = CA;
    function BA(QA, tA) {
      return iA(n.posix.relative(QA, tA));
    }
    g.relative = BA;
    function eA(QA) {
      return QA.length > 0 && QA.indexOf(".") !== 0 && (QA = `.${QA}`), QA;
    }
    g.normalizeExtension = eA;
    function iA(QA) {
      return QA.indexOf("/") === 0 && (QA = QA.slice(1)), QA;
    }
    g.removeSlash = iA;
  })(t || (path$7.PathExt = t = {})), path$7;
}
var signal = {}, hasRequiredSignal$1;
function requireSignal$1() {
  if (hasRequiredSignal$1) return signal;
  hasRequiredSignal$1 = 1, Object.defineProperty(signal, "__esModule", { value: !0 }), signal.signalToPromise = t;
  const n = requireDist$2();
  function t(g, d) {
    const k = new n.PromiseDelegate();
    function H() {
      g.disconnect(AA);
    }
    function AA(gA, IA) {
      H(), k.resolve([gA, IA]);
    }
    return g.connect(AA), (d ?? 0) > 0 && setTimeout(() => {
      H(), k.reject(`Signal not emitted within ${d} ms.`);
    }, d), k.promise;
  }
  return signal;
}
var text$d = {}, hasRequiredText;
function requireText() {
  if (hasRequiredText) return text$d;
  hasRequiredText = 1, Object.defineProperty(text$d, "__esModule", { value: !0 }), text$d.Text = void 0;
  var n;
  return (function(t) {
    function d(gA, IA) {
      return gA;
    }
    t.jsIndexToCharIndex = d;
    function k(gA, IA) {
      return gA;
    }
    t.charIndexToJsIndex = k;
    function H(gA, IA = !1) {
      return gA.replace(/^(\w)|[\s-_:]+(\w)/g, function(CA, BA, eA) {
        return eA ? eA.toUpperCase() : IA ? BA.toUpperCase() : BA.toLowerCase();
      });
    }
    t.camelCase = H;
    function AA(gA) {
      return (gA || "").toLowerCase().split(" ").map((IA) => IA.charAt(0).toUpperCase() + IA.slice(1)).join(" ");
    }
    t.titleCase = AA;
  })(n || (text$d.Text = n = {})), text$d;
}
var time$2 = {}, hasRequiredTime;
function requireTime() {
  if (hasRequiredTime) return time$2;
  hasRequiredTime = 1, Object.defineProperty(time$2, "__esModule", { value: !0 }), time$2.Time = void 0;
  const n = [
    { name: "years", milliseconds: 365 * 24 * 60 * 60 * 1e3 },
    { name: "months", milliseconds: 720 * 60 * 60 * 1e3 },
    { name: "days", milliseconds: 1440 * 60 * 1e3 },
    { name: "hours", milliseconds: 3600 * 1e3 },
    { name: "minutes", milliseconds: 60 * 1e3 },
    { name: "seconds", milliseconds: 1e3 }
  ];
  var t;
  return (function(g) {
    function d(H, AA = "long") {
      const gA = document.documentElement.lang || "en", IA = new Intl.RelativeTimeFormat(gA, {
        numeric: "auto",
        style: AA
      }), CA = new Date(H).getTime() - Date.now();
      for (let BA of n) {
        const eA = Math.ceil(CA / BA.milliseconds);
        if (eA !== 0)
          return IA.format(eA, BA.name);
      }
      return IA.format(0, "seconds");
    }
    g.formatHuman = d;
    function k(H) {
      const AA = document.documentElement.lang || "en";
      return new Intl.DateTimeFormat(AA, {
        dateStyle: "short",
        timeStyle: "short"
      }).format(new Date(H));
    }
    g.format = k;
  })(t || (time$2.Time = t = {})), time$2;
}
var hasRequiredLib$2;
function requireLib$2() {
  return hasRequiredLib$2 || (hasRequiredLib$2 = 1, (function(n) {
    var t = lib$3 && lib$3.__createBinding || (Object.create ? (function(d, k, H, AA) {
      AA === void 0 && (AA = H);
      var gA = Object.getOwnPropertyDescriptor(k, H);
      (!gA || ("get" in gA ? !k.__esModule : gA.writable || gA.configurable)) && (gA = { enumerable: !0, get: function() {
        return k[H];
      } }), Object.defineProperty(d, AA, gA);
    }) : (function(d, k, H, AA) {
      AA === void 0 && (AA = H), d[AA] = k[H];
    })), g = lib$3 && lib$3.__exportStar || function(d, k) {
      for (var H in d) H !== "default" && !Object.prototype.hasOwnProperty.call(k, H) && t(k, d, H);
    };
    Object.defineProperty(n, "__esModule", { value: !0 }), g(/* @__PURE__ */ requireActivitymonitor(), n), g(/* @__PURE__ */ requireInterfaces(), n), g(/* @__PURE__ */ requireLru(), n), g(/* @__PURE__ */ requireMarkdowncodeblocks(), n), g(/* @__PURE__ */ requirePageconfig(), n), g(/* @__PURE__ */ requirePath$1(), n), g(/* @__PURE__ */ requireSignal$1(), n), g(/* @__PURE__ */ requireText(), n), g(/* @__PURE__ */ requireTime(), n), g(/* @__PURE__ */ requireUrl(), n);
  })(lib$3)), lib$3;
}
var libExports$2 = /* @__PURE__ */ requireLib$2();
function manipulateIFrameDocument(n, t, g) {
  const d = [], k = t.getElementsByTagName("script");
  for (const AA of k) {
    if (AA.src === "")
      continue;
    const gA = getRelativePath(window.location.host, window.location.pathname, new URL(AA.src));
    if (gA == null)
      continue;
    const IA = libExports$2.URLExt.join(g, gA), CA = n.sendHttpRequest({
      method: "GET",
      headers: {},
      path: IA,
      body: ""
    }).then(({
      statusCode: BA,
      headers: eA,
      body: iA
    }) => {
      if (BA !== 200)
        return;
      const QA = eA.get("Content-Type");
      return new Blob([iA], QA ? {
        type: QA
      } : void 0).text().then((oA) => {
        const EA = t.createElement("script");
        EA.text = oA, EA.type = "text/javascript", EA.setAttribute("data-stlite", ""), AA.replaceWith(EA);
      });
    });
    d.push(CA);
  }
  const H = t.querySelectorAll("link[rel=stylesheet]");
  for (const AA of H) {
    const gA = getRelativePath(window.location.host, window.location.pathname, new URL(AA.href));
    if (gA == null)
      continue;
    const IA = libExports$2.URLExt.join(g, gA), CA = n.sendHttpRequest({
      method: "GET",
      headers: {},
      path: IA,
      body: ""
    }).then(({
      statusCode: BA,
      headers: eA,
      body: iA
    }) => {
      if (BA !== 200)
        return;
      const QA = eA.get("Content-Type");
      return new Blob([iA], QA ? {
        type: QA
      } : void 0).text().then((oA) => {
        const EA = t.createElement("style");
        EA.innerHTML = oA, EA.setAttribute("data-stlite", ""), AA.replaceWith(EA);
      });
    });
    d.push(CA);
  }
  return Promise.all(d).then();
}
const InnerIFrame = React__default.forwardRef(({
  src: n,
  IframeComponent: t,
  ...g
}, d) => {
  const k = useStliteKernel(), [H, AA] = useState();
  useEffect(() => {
    if (k == null || !n.startsWith("/component"))
      return;
    let IA = !1;
    return k.sendHttpRequest({
      method: "GET",
      path: n,
      headers: {},
      body: ""
    }).then(({
      statusCode: CA,
      headers: BA,
      body: eA
    }) => {
      if (IA || CA !== 200)
        return;
      const iA = BA.get("Content-Type");
      new Blob([eA], iA ? {
        type: iA
      } : void 0).text().then((tA) => {
        IA || AA(tA);
      });
    }), () => {
      IA = !0;
    };
  }, [k, n]);
  const gA = useCallback((IA) => {
    const BA = IA.target.contentWindow?.document;
    if (BA == null) {
      console.warn("document not found in iframe");
      return;
    }
    manipulateIFrameDocument(k, BA, getParentPath(n));
  }, [k, n]);
  return jsxRuntimeExports.jsx(t, {
    ...g,
    srcDoc: H,
    onLoad: gA,
    ref: d
  });
});
InnerIFrame.displayName = "InnerIFrame";
const CustomComponentIFrame = React__default.forwardRef((n, t) => {
  const g = useStliteKernel(), d = useMemo$1(() => extractCustomComponentPath(g.basePath, n.src), [g.basePath, n.src]);
  return d == null ? jsxRuntimeExports.jsx("iframe", {
    ...n,
    ref: t
  }) : jsxRuntimeExports.jsx(InnerIFrame, {
    ...n,
    src: d,
    ref: t
  });
});
CustomComponentIFrame.displayName = "StliteCustomComponentIFrame";
function sheetForTag(n) {
  if (n.sheet)
    return n.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === n)
      return document.styleSheets[t];
}
function createStyleElement(n) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", n.key), n.nonce !== void 0 && t.setAttribute("nonce", n.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var StyleSheet = /* @__PURE__ */ (function() {
  function n(g) {
    var d = this;
    this._insertTag = function(k) {
      var H;
      d.tags.length === 0 ? d.insertionPoint ? H = d.insertionPoint.nextSibling : d.prepend ? H = d.container.firstChild : H = d.before : H = d.tags[d.tags.length - 1].nextSibling, d.container.insertBefore(k, H), d.tags.push(k);
    }, this.isSpeedy = g.speedy === void 0 ? !0 : g.speedy, this.tags = [], this.ctr = 0, this.nonce = g.nonce, this.key = g.key, this.container = g.container, this.prepend = g.prepend, this.insertionPoint = g.insertionPoint, this.before = null;
  }
  var t = n.prototype;
  return t.hydrate = function(d) {
    d.forEach(this._insertTag);
  }, t.insert = function(d) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var k = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var H = sheetForTag(k);
      try {
        H.insertRule(d, H.cssRules.length);
      } catch {
      }
    } else
      k.appendChild(document.createTextNode(d));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(d) {
      var k;
      return (k = d.parentNode) == null ? void 0 : k.removeChild(d);
    }), this.tags = [], this.ctr = 0;
  }, n;
})(), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs$4 = Math.abs, from$1 = String.fromCharCode, assign$1 = Object.assign;
function hash$3(n, t) {
  return charat(n, 0) ^ 45 ? (((t << 2 ^ charat(n, 0)) << 2 ^ charat(n, 1)) << 2 ^ charat(n, 2)) << 2 ^ charat(n, 3) : 0;
}
function trim$1(n) {
  return n.trim();
}
function match$2(n, t) {
  return (n = t.exec(n)) ? n[0] : n;
}
function replace$3(n, t, g) {
  return n.replace(t, g);
}
function indexof$1(n, t) {
  return n.indexOf(t);
}
function charat(n, t) {
  return n.charCodeAt(t) | 0;
}
function substr(n, t, g) {
  return n.slice(t, g);
}
function strlen(n) {
  return n.length;
}
function sizeof(n) {
  return n.length;
}
function append$2(n, t) {
  return t.push(n), n;
}
function combine(n, t) {
  return n.map(t).join("");
}
var line$4 = 1, column$1 = 1, length$2 = 0, position$5 = 0, character = 0, characters = "";
function node$1(n, t, g, d, k, H, AA) {
  return { value: n, root: t, parent: g, type: d, props: k, children: H, line: line$4, column: column$1, length: AA, return: "" };
}
function copy$4(n, t) {
  return assign$1(node$1("", null, null, "", null, null, 0), n, { length: -n.length }, t);
}
function char() {
  return character;
}
function prev() {
  return character = position$5 > 0 ? charat(characters, --position$5) : 0, column$1--, character === 10 && (column$1 = 1, line$4--), character;
}
function next$1() {
  return character = position$5 < length$2 ? charat(characters, position$5++) : 0, column$1++, character === 10 && (column$1 = 1, line$4++), character;
}
function peek$5() {
  return charat(characters, position$5);
}
function caret() {
  return position$5;
}
function slice$3(n, t) {
  return substr(characters, n, t);
}
function token$3(n) {
  switch (n) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(n) {
  return line$4 = column$1 = 1, length$2 = strlen(characters = n), position$5 = 0, [];
}
function dealloc(n) {
  return characters = "", n;
}
function delimit(n) {
  return trim$1(slice$3(position$5 - 1, delimiter$1(n === 91 ? n + 2 : n === 40 ? n + 1 : n)));
}
function whitespace$1(n) {
  for (; (character = peek$5()) && character < 33; )
    next$1();
  return token$3(n) > 2 || token$3(character) > 3 ? "" : " ";
}
function escaping(n, t) {
  for (; --t && next$1() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice$3(n, caret() + (t < 6 && peek$5() == 32 && next$1() == 32));
}
function delimiter$1(n) {
  for (; next$1(); )
    switch (character) {
      // ] ) " '
      case n:
        return position$5;
      // " '
      case 34:
      case 39:
        n !== 34 && n !== 39 && delimiter$1(character);
        break;
      // (
      case 40:
        n === 41 && delimiter$1(n);
        break;
      // \
      case 92:
        next$1();
        break;
    }
  return position$5;
}
function commenter(n, t) {
  for (; next$1() && n + character !== 57; )
    if (n + character === 84 && peek$5() === 47)
      break;
  return "/*" + slice$3(t, position$5 - 1) + "*" + from$1(n === 47 ? n : next$1());
}
function identifier(n) {
  for (; !token$3(peek$5()); )
    next$1();
  return slice$3(n, position$5);
}
function compile$1(n) {
  return dealloc(parse$c("", null, null, null, [""], n = alloc(n), 0, [0], n));
}
function parse$c(n, t, g, d, k, H, AA, gA, IA) {
  for (var CA = 0, BA = 0, eA = AA, iA = 0, QA = 0, tA = 0, oA = 1, EA = 1, aA = 1, nA = 0, lA = "", cA = k, sA = H, rA = d, uA = lA; EA; )
    switch (tA = nA, nA = next$1()) {
      // (
      case 40:
        if (tA != 108 && charat(uA, eA - 1) == 58) {
          indexof$1(uA += replace$3(delimit(nA), "&", "&\f"), "&\f") != -1 && (aA = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        uA += delimit(nA);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        uA += whitespace$1(tA);
        break;
      // \
      case 92:
        uA += escaping(caret() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek$5()) {
          case 42:
          case 47:
            append$2(comment$3(commenter(next$1(), caret()), t, g), IA);
            break;
          default:
            uA += "/";
        }
        break;
      // {
      case 123 * oA:
        gA[CA++] = strlen(uA) * aA;
      // } ; \0
      case 125 * oA:
      case 59:
      case 0:
        switch (nA) {
          // \0 }
          case 0:
          case 125:
            EA = 0;
          // ;
          case 59 + BA:
            aA == -1 && (uA = replace$3(uA, /\f/g, "")), QA > 0 && strlen(uA) - eA && append$2(QA > 32 ? declaration(uA + ";", d, g, eA - 1) : declaration(replace$3(uA, " ", "") + ";", d, g, eA - 2), IA);
            break;
          // @ ;
          case 59:
            uA += ";";
          // { rule/at-rule
          default:
            if (append$2(rA = ruleset(uA, t, g, CA, BA, k, gA, lA, cA = [], sA = [], eA), H), nA === 123)
              if (BA === 0)
                parse$c(uA, t, rA, rA, cA, H, eA, gA, sA);
              else
                switch (iA === 99 && charat(uA, 3) === 110 ? 100 : iA) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$c(n, rA, rA, d && append$2(ruleset(n, rA, rA, 0, 0, k, gA, lA, k, cA = [], eA), sA), k, sA, eA, gA, d ? cA : sA);
                    break;
                  default:
                    parse$c(uA, rA, rA, rA, [""], sA, 0, gA, sA);
                }
        }
        CA = BA = QA = 0, oA = aA = 1, lA = uA = "", eA = AA;
        break;
      // :
      case 58:
        eA = 1 + strlen(uA), QA = tA;
      default:
        if (oA < 1) {
          if (nA == 123)
            --oA;
          else if (nA == 125 && oA++ == 0 && prev() == 125)
            continue;
        }
        switch (uA += from$1(nA), nA * oA) {
          // &
          case 38:
            aA = BA > 0 ? 1 : (uA += "\f", -1);
            break;
          // ,
          case 44:
            gA[CA++] = (strlen(uA) - 1) * aA, aA = 1;
            break;
          // @
          case 64:
            peek$5() === 45 && (uA += delimit(next$1())), iA = peek$5(), BA = eA = strlen(lA = uA += identifier(caret())), nA++;
            break;
          // -
          case 45:
            tA === 45 && strlen(uA) == 2 && (oA = 0);
        }
    }
  return H;
}
function ruleset(n, t, g, d, k, H, AA, gA, IA, CA, BA) {
  for (var eA = k - 1, iA = k === 0 ? H : [""], QA = sizeof(iA), tA = 0, oA = 0, EA = 0; tA < d; ++tA)
    for (var aA = 0, nA = substr(n, eA + 1, eA = abs$4(oA = AA[tA])), lA = n; aA < QA; ++aA)
      (lA = trim$1(oA > 0 ? iA[aA] + " " + nA : replace$3(nA, /&\f/g, iA[aA]))) && (IA[EA++] = lA);
  return node$1(n, t, g, k === 0 ? RULESET : gA, IA, CA, BA);
}
function comment$3(n, t, g) {
  return node$1(n, t, g, COMMENT, from$1(char()), substr(n, 2, -2), 0);
}
function declaration(n, t, g, d) {
  return node$1(n, t, g, DECLARATION, substr(n, 0, d), substr(n, d + 1, -1), d);
}
function serialize$2(n, t) {
  for (var g = "", d = sizeof(n), k = 0; k < d; k++)
    g += t(n[k], k, n, t) || "";
  return g;
}
function stringify$7(n, t, g, d) {
  switch (n.type) {
    case LAYER:
      if (n.children.length) break;
    case IMPORT:
    case DECLARATION:
      return n.return = n.return || n.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return n.return = n.value + "{" + serialize$2(n.children, d) + "}";
    case RULESET:
      n.value = n.props.join(",");
  }
  return strlen(g = serialize$2(n.children, d)) ? n.return = n.value + "{" + g + "}" : "";
}
function middleware(n) {
  var t = sizeof(n);
  return function(g, d, k, H) {
    for (var AA = "", gA = 0; gA < t; gA++)
      AA += n[gA](g, d, k, H) || "";
    return AA;
  };
}
function rulesheet(n) {
  return function(t) {
    t.root || (t = t.return) && n(t);
  };
}
var weakMemoize = function n(t) {
  var g = /* @__PURE__ */ new WeakMap();
  return function(d) {
    if (g.has(d))
      return g.get(d);
    var k = t(d);
    return g.set(d, k), k;
  };
};
function memoize$2(n) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(g) {
    return t[g] === void 0 && (t[g] = n(g)), t[g];
  };
}
var identifierWithPointTracking = function n(t, g, d) {
  for (var k = 0, H = 0; k = H, H = peek$5(), k === 38 && H === 12 && (g[d] = 1), !token$3(H); )
    next$1();
  return slice$3(t, position$5);
}, toRules = function n(t, g) {
  var d = -1, k = 44;
  do
    switch (token$3(k)) {
      case 0:
        k === 38 && peek$5() === 12 && (g[d] = 1), t[d] += identifierWithPointTracking(position$5 - 1, g, d);
        break;
      case 2:
        t[d] += delimit(k);
        break;
      case 4:
        if (k === 44) {
          t[++d] = peek$5() === 58 ? "&\f" : "", g[d] = t[d].length;
          break;
        }
      // fallthrough
      default:
        t[d] += from$1(k);
    }
  while (k = next$1());
  return t;
}, getRules = function n(t, g) {
  return dealloc(toRules(alloc(t), g));
}, fixedElements = /* @__PURE__ */ new WeakMap(), compat = function n(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var g = t.value, d = t.parent, k = t.column === d.column && t.line === d.line; d.type !== "rule"; )
      if (d = d.parent, !d) return;
    if (!(t.props.length === 1 && g.charCodeAt(0) !== 58 && !fixedElements.get(d)) && !k) {
      fixedElements.set(t, !0);
      for (var H = [], AA = getRules(g, H), gA = d.props, IA = 0, CA = 0; IA < AA.length; IA++)
        for (var BA = 0; BA < gA.length; BA++, CA++)
          t.props[CA] = H[IA] ? AA[IA].replace(/&\f/g, gA[BA]) : gA[BA] + " " + AA[IA];
    }
  }
}, removeLabel = function n(t) {
  if (t.type === "decl") {
    var g = t.value;
    // charcode for l
    g.charCodeAt(0) === 108 && // charcode for b
    g.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function prefix$1(n, t) {
  switch (hash$3(n, t)) {
    // color-adjust
    case 5103:
      return WEBKIT + "print-" + n + n;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + n + n;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + n + MOZ + n + MS + n + n;
    // flex, flex-direction
    case 6828:
    case 4268:
      return WEBKIT + n + MS + n + n;
    // order
    case 6165:
      return WEBKIT + n + MS + "flex-" + n + n;
    // align-items
    case 5187:
      return WEBKIT + n + replace$3(n, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + n;
    // align-self
    case 5443:
      return WEBKIT + n + MS + "flex-item-" + replace$3(n, /flex-|-self/, "") + n;
    // align-content
    case 4675:
      return WEBKIT + n + MS + "flex-line-pack" + replace$3(n, /align-content|flex-|-self/, "") + n;
    // flex-shrink
    case 5548:
      return WEBKIT + n + MS + replace$3(n, "shrink", "negative") + n;
    // flex-basis
    case 5292:
      return WEBKIT + n + MS + replace$3(n, "basis", "preferred-size") + n;
    // flex-grow
    case 6060:
      return WEBKIT + "box-" + replace$3(n, "-grow", "") + WEBKIT + n + MS + replace$3(n, "grow", "positive") + n;
    // transition
    case 4554:
      return WEBKIT + replace$3(n, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + n;
    // cursor
    case 6187:
      return replace$3(replace$3(replace$3(n, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), n, "") + n;
    // background, background-image
    case 5495:
    case 3959:
      return replace$3(n, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    // justify-content
    case 4968:
      return replace$3(replace$3(n, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + n + n;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$3(n, /(.+)-inline(.+)/, WEBKIT + "$1$2") + n;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(n) - 1 - t > 6) switch (charat(n, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (charat(n, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return replace$3(n, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(n, t + 3) == 108 ? "$3" : "$2-$3")) + n;
        // (s)tretch
        case 115:
          return ~indexof$1(n, "stretch") ? prefix$1(replace$3(n, "stretch", "fill-available"), t) + n : n;
      }
      break;
    // position: sticky
    case 4949:
      if (charat(n, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (charat(n, strlen(n) - 3 - (~indexof$1(n, "!important") && 10))) {
        // stic(k)y
        case 107:
          return replace$3(n, ":", ":" + WEBKIT) + n;
        // (inline-)?fl(e)x
        case 101:
          return replace$3(n, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(n, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + n;
      }
      break;
    // writing-mode
    case 5936:
      switch (charat(n, t + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + n + MS + replace$3(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
        // vertical-r(l)
        case 108:
          return WEBKIT + n + MS + replace$3(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
        // horizontal(-)tb
        case 45:
          return WEBKIT + n + MS + replace$3(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
      }
      return WEBKIT + n + MS + n + n;
  }
  return n;
}
var prefixer = function n(t, g, d, k) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case DECLARATION:
      t.return = prefix$1(t.value, t.length);
      break;
    case KEYFRAMES:
      return serialize$2([copy$4(t, {
        value: replace$3(t.value, "@", "@" + WEBKIT)
      })], k);
    case RULESET:
      if (t.length) return combine(t.props, function(H) {
        switch (match$2(H, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return serialize$2([copy$4(t, {
              props: [replace$3(H, /:(read-\w+)/, ":" + MOZ + "$1")]
            })], k);
          // :placeholder
          case "::placeholder":
            return serialize$2([copy$4(t, {
              props: [replace$3(H, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
            }), copy$4(t, {
              props: [replace$3(H, /:(plac\w+)/, ":" + MOZ + "$1")]
            }), copy$4(t, {
              props: [replace$3(H, /:(plac\w+)/, MS + "input-$1")]
            })], k);
        }
        return "";
      });
  }
}, defaultStylisPlugins = [prefixer], createCache = function n(t) {
  var g = t.key;
  if (g === "css") {
    var d = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(d, function(oA) {
      var EA = oA.getAttribute("data-emotion");
      EA.indexOf(" ") !== -1 && (document.head.appendChild(oA), oA.setAttribute("data-s", ""));
    });
  }
  var k = t.stylisPlugins || defaultStylisPlugins, H = {}, AA, gA = [];
  AA = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + g + ' "]'),
    function(oA) {
      for (var EA = oA.getAttribute("data-emotion").split(" "), aA = 1; aA < EA.length; aA++)
        H[EA[aA]] = !0;
      gA.push(oA);
    }
  );
  var IA, CA = [compat, removeLabel];
  {
    var BA, eA = [stringify$7, rulesheet(function(oA) {
      BA.insert(oA);
    })], iA = middleware(CA.concat(k, eA)), QA = function(EA) {
      return serialize$2(compile$1(EA), iA);
    };
    IA = function(EA, aA, nA, lA) {
      BA = nA, QA(EA ? EA + "{" + aA.styles + "}" : aA.styles), lA && (tA.inserted[aA.name] = !0);
    };
  }
  var tA = {
    key: g,
    sheet: new StyleSheet({
      key: g,
      container: AA,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: H,
    registered: {},
    insert: IA
  };
  return tA.sheet.hydrate(gA), tA;
};
function _extends$M() {
  return _extends$M = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g) ({}).hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$M.apply(null, arguments);
}
var reactIs$1 = { exports: {} }, reactIs_production_min$1 = {};
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var n = typeof Symbol == "function" && Symbol.for, t = n ? Symbol.for("react.element") : 60103, g = n ? Symbol.for("react.portal") : 60106, d = n ? Symbol.for("react.fragment") : 60107, k = n ? Symbol.for("react.strict_mode") : 60108, H = n ? Symbol.for("react.profiler") : 60114, AA = n ? Symbol.for("react.provider") : 60109, gA = n ? Symbol.for("react.context") : 60110, IA = n ? Symbol.for("react.async_mode") : 60111, CA = n ? Symbol.for("react.concurrent_mode") : 60111, BA = n ? Symbol.for("react.forward_ref") : 60112, eA = n ? Symbol.for("react.suspense") : 60113, iA = n ? Symbol.for("react.suspense_list") : 60120, QA = n ? Symbol.for("react.memo") : 60115, tA = n ? Symbol.for("react.lazy") : 60116, oA = n ? Symbol.for("react.block") : 60121, EA = n ? Symbol.for("react.fundamental") : 60117, aA = n ? Symbol.for("react.responder") : 60118, nA = n ? Symbol.for("react.scope") : 60119;
  function lA(sA) {
    if (typeof sA == "object" && sA !== null) {
      var rA = sA.$$typeof;
      switch (rA) {
        case t:
          switch (sA = sA.type, sA) {
            case IA:
            case CA:
            case d:
            case H:
            case k:
            case eA:
              return sA;
            default:
              switch (sA = sA && sA.$$typeof, sA) {
                case gA:
                case BA:
                case tA:
                case QA:
                case AA:
                  return sA;
                default:
                  return rA;
              }
          }
        case g:
          return rA;
      }
    }
  }
  function cA(sA) {
    return lA(sA) === CA;
  }
  return reactIs_production_min$1.AsyncMode = IA, reactIs_production_min$1.ConcurrentMode = CA, reactIs_production_min$1.ContextConsumer = gA, reactIs_production_min$1.ContextProvider = AA, reactIs_production_min$1.Element = t, reactIs_production_min$1.ForwardRef = BA, reactIs_production_min$1.Fragment = d, reactIs_production_min$1.Lazy = tA, reactIs_production_min$1.Memo = QA, reactIs_production_min$1.Portal = g, reactIs_production_min$1.Profiler = H, reactIs_production_min$1.StrictMode = k, reactIs_production_min$1.Suspense = eA, reactIs_production_min$1.isAsyncMode = function(sA) {
    return cA(sA) || lA(sA) === IA;
  }, reactIs_production_min$1.isConcurrentMode = cA, reactIs_production_min$1.isContextConsumer = function(sA) {
    return lA(sA) === gA;
  }, reactIs_production_min$1.isContextProvider = function(sA) {
    return lA(sA) === AA;
  }, reactIs_production_min$1.isElement = function(sA) {
    return typeof sA == "object" && sA !== null && sA.$$typeof === t;
  }, reactIs_production_min$1.isForwardRef = function(sA) {
    return lA(sA) === BA;
  }, reactIs_production_min$1.isFragment = function(sA) {
    return lA(sA) === d;
  }, reactIs_production_min$1.isLazy = function(sA) {
    return lA(sA) === tA;
  }, reactIs_production_min$1.isMemo = function(sA) {
    return lA(sA) === QA;
  }, reactIs_production_min$1.isPortal = function(sA) {
    return lA(sA) === g;
  }, reactIs_production_min$1.isProfiler = function(sA) {
    return lA(sA) === H;
  }, reactIs_production_min$1.isStrictMode = function(sA) {
    return lA(sA) === k;
  }, reactIs_production_min$1.isSuspense = function(sA) {
    return lA(sA) === eA;
  }, reactIs_production_min$1.isValidElementType = function(sA) {
    return typeof sA == "string" || typeof sA == "function" || sA === d || sA === CA || sA === H || sA === k || sA === eA || sA === iA || typeof sA == "object" && sA !== null && (sA.$$typeof === tA || sA.$$typeof === QA || sA.$$typeof === AA || sA.$$typeof === gA || sA.$$typeof === BA || sA.$$typeof === EA || sA.$$typeof === aA || sA.$$typeof === nA || sA.$$typeof === oA);
  }, reactIs_production_min$1.typeOf = lA, reactIs_production_min$1;
}
var reactIs_development$1 = {};
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var n = typeof Symbol == "function" && Symbol.for, t = n ? Symbol.for("react.element") : 60103, g = n ? Symbol.for("react.portal") : 60106, d = n ? Symbol.for("react.fragment") : 60107, k = n ? Symbol.for("react.strict_mode") : 60108, H = n ? Symbol.for("react.profiler") : 60114, AA = n ? Symbol.for("react.provider") : 60109, gA = n ? Symbol.for("react.context") : 60110, IA = n ? Symbol.for("react.async_mode") : 60111, CA = n ? Symbol.for("react.concurrent_mode") : 60111, BA = n ? Symbol.for("react.forward_ref") : 60112, eA = n ? Symbol.for("react.suspense") : 60113, iA = n ? Symbol.for("react.suspense_list") : 60120, QA = n ? Symbol.for("react.memo") : 60115, tA = n ? Symbol.for("react.lazy") : 60116, oA = n ? Symbol.for("react.block") : 60121, EA = n ? Symbol.for("react.fundamental") : 60117, aA = n ? Symbol.for("react.responder") : 60118, nA = n ? Symbol.for("react.scope") : 60119;
    function lA(RA) {
      return typeof RA == "string" || typeof RA == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      RA === d || RA === CA || RA === H || RA === k || RA === eA || RA === iA || typeof RA == "object" && RA !== null && (RA.$$typeof === tA || RA.$$typeof === QA || RA.$$typeof === AA || RA.$$typeof === gA || RA.$$typeof === BA || RA.$$typeof === EA || RA.$$typeof === aA || RA.$$typeof === nA || RA.$$typeof === oA);
    }
    function cA(RA) {
      if (typeof RA == "object" && RA !== null) {
        var FA = RA.$$typeof;
        switch (FA) {
          case t:
            var mA = RA.type;
            switch (mA) {
              case IA:
              case CA:
              case d:
              case H:
              case k:
              case eA:
                return mA;
              default:
                var JA = mA && mA.$$typeof;
                switch (JA) {
                  case gA:
                  case BA:
                  case tA:
                  case QA:
                  case AA:
                    return JA;
                  default:
                    return FA;
                }
            }
          case g:
            return FA;
        }
      }
    }
    var sA = IA, rA = CA, uA = gA, hA = AA, dA = t, GA = BA, DA = d, wA = tA, bA = QA, yA = g, pA = H, MA = k, LA = eA, xA = !1;
    function TA(RA) {
      return xA || (xA = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), NA(RA) || cA(RA) === IA;
    }
    function NA(RA) {
      return cA(RA) === CA;
    }
    function zA(RA) {
      return cA(RA) === gA;
    }
    function XA(RA) {
      return cA(RA) === AA;
    }
    function fA(RA) {
      return typeof RA == "object" && RA !== null && RA.$$typeof === t;
    }
    function vA(RA) {
      return cA(RA) === BA;
    }
    function Cg(RA) {
      return cA(RA) === d;
    }
    function Ig(RA) {
      return cA(RA) === tA;
    }
    function gg(RA) {
      return cA(RA) === QA;
    }
    function og(RA) {
      return cA(RA) === g;
    }
    function eg(RA) {
      return cA(RA) === H;
    }
    function kA(RA) {
      return cA(RA) === k;
    }
    function YA(RA) {
      return cA(RA) === eA;
    }
    reactIs_development$1.AsyncMode = sA, reactIs_development$1.ConcurrentMode = rA, reactIs_development$1.ContextConsumer = uA, reactIs_development$1.ContextProvider = hA, reactIs_development$1.Element = dA, reactIs_development$1.ForwardRef = GA, reactIs_development$1.Fragment = DA, reactIs_development$1.Lazy = wA, reactIs_development$1.Memo = bA, reactIs_development$1.Portal = yA, reactIs_development$1.Profiler = pA, reactIs_development$1.StrictMode = MA, reactIs_development$1.Suspense = LA, reactIs_development$1.isAsyncMode = TA, reactIs_development$1.isConcurrentMode = NA, reactIs_development$1.isContextConsumer = zA, reactIs_development$1.isContextProvider = XA, reactIs_development$1.isElement = fA, reactIs_development$1.isForwardRef = vA, reactIs_development$1.isFragment = Cg, reactIs_development$1.isLazy = Ig, reactIs_development$1.isMemo = gg, reactIs_development$1.isPortal = og, reactIs_development$1.isProfiler = eg, reactIs_development$1.isStrictMode = kA, reactIs_development$1.isSuspense = YA, reactIs_development$1.isValidElementType = lA, reactIs_development$1.typeOf = cA;
  })()), reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  return hasRequiredReactIs$1 || (hasRequiredReactIs$1 = 1, process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$1()), reactIs$1.exports;
}
var hoistNonReactStatics_cjs, hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var n = requireReactIs$1(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, g = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, d = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, k = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, H = {};
  H[n.ForwardRef] = d, H[n.Memo] = k;
  function AA(tA) {
    return n.isMemo(tA) ? k : H[tA.$$typeof] || t;
  }
  var gA = Object.defineProperty, IA = Object.getOwnPropertyNames, CA = Object.getOwnPropertySymbols, BA = Object.getOwnPropertyDescriptor, eA = Object.getPrototypeOf, iA = Object.prototype;
  function QA(tA, oA, EA) {
    if (typeof oA != "string") {
      if (iA) {
        var aA = eA(oA);
        aA && aA !== iA && QA(tA, aA, EA);
      }
      var nA = IA(oA);
      CA && (nA = nA.concat(CA(oA)));
      for (var lA = AA(tA), cA = AA(oA), sA = 0; sA < nA.length; ++sA) {
        var rA = nA[sA];
        if (!g[rA] && !(EA && EA[rA]) && !(cA && cA[rA]) && !(lA && lA[rA])) {
          var uA = BA(oA, rA);
          try {
            gA(tA, rA, uA);
          } catch {
          }
        }
      }
    }
    return tA;
  }
  return hoistNonReactStatics_cjs = QA, hoistNonReactStatics_cjs;
}
var hoistNonReactStatics_cjsExports = requireHoistNonReactStatics_cjs();
const hoistNonReactStatics = /* @__PURE__ */ getDefaultExportFromCjs$2(hoistNonReactStatics_cjsExports);
var isBrowser$2 = !0;
function getRegisteredStyles(n, t, g) {
  var d = "";
  return g.split(" ").forEach(function(k) {
    n[k] !== void 0 ? t.push(n[k] + ";") : k && (d += k + " ");
  }), d;
}
var registerStyles = function n(t, g, d) {
  var k = t.key + "-" + g.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (d === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === !1) && t.registered[k] === void 0 && (t.registered[k] = g.styles);
}, insertStyles = function n(t, g, d) {
  registerStyles(t, g, d);
  var k = t.key + "-" + g.name;
  if (t.inserted[g.name] === void 0) {
    var H = g;
    do
      t.insert(g === H ? "." + k : "", H, t.sheet, !0), H = H.next;
    while (H !== void 0);
  }
};
function murmur2(n) {
  for (var t = 0, g, d = 0, k = n.length; k >= 4; ++d, k -= 4)
    g = n.charCodeAt(d) & 255 | (n.charCodeAt(++d) & 255) << 8 | (n.charCodeAt(++d) & 255) << 16 | (n.charCodeAt(++d) & 255) << 24, g = /* Math.imul(k, m): */
    (g & 65535) * 1540483477 + ((g >>> 16) * 59797 << 16), g ^= /* k >>> r: */
    g >>> 24, t = /* Math.imul(k, m): */
    (g & 65535) * 1540483477 + ((g >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (k) {
    case 3:
      t ^= (n.charCodeAt(d + 2) & 255) << 16;
    case 2:
      t ^= (n.charCodeAt(d + 1) & 255) << 8;
    case 1:
      t ^= n.charCodeAt(d) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function n(t) {
  return t.charCodeAt(1) === 45;
}, isProcessableValue = function n(t) {
  return t != null && typeof t != "boolean";
}, processStyleName = /* @__PURE__ */ memoize$2(function(n) {
  return isCustomProperty(n) ? n : n.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function n(t, g) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof g == "string")
        return g.replace(animationRegex, function(d, k, H) {
          return cursor$3 = {
            name: k,
            styles: H,
            next: cursor$3
          }, k;
        });
  }
  return unitlessKeys[t] !== 1 && !isCustomProperty(t) && typeof g == "number" && g !== 0 ? g + "px" : g;
};
function handleInterpolation(n, t, g) {
  if (g == null)
    return "";
  var d = g;
  if (d.__emotion_styles !== void 0)
    return d;
  switch (typeof g) {
    case "boolean":
      return "";
    case "object": {
      var k = g;
      if (k.anim === 1)
        return cursor$3 = {
          name: k.name,
          styles: k.styles,
          next: cursor$3
        }, k.name;
      var H = g;
      if (H.styles !== void 0) {
        var AA = H.next;
        if (AA !== void 0)
          for (; AA !== void 0; )
            cursor$3 = {
              name: AA.name,
              styles: AA.styles,
              next: cursor$3
            }, AA = AA.next;
        var gA = H.styles + ";";
        return gA;
      }
      return createStringFromObject(n, t, g);
    }
    case "function": {
      if (n !== void 0) {
        var IA = cursor$3, CA = g(n);
        return cursor$3 = IA, handleInterpolation(n, t, CA);
      }
      break;
    }
  }
  var BA = g;
  if (t == null)
    return BA;
  var eA = t[BA];
  return eA !== void 0 ? eA : BA;
}
function createStringFromObject(n, t, g) {
  var d = "";
  if (Array.isArray(g))
    for (var k = 0; k < g.length; k++)
      d += handleInterpolation(n, t, g[k]) + ";";
  else
    for (var H in g) {
      var AA = g[H];
      if (typeof AA != "object") {
        var gA = AA;
        t != null && t[gA] !== void 0 ? d += H + "{" + t[gA] + "}" : isProcessableValue(gA) && (d += processStyleName(H) + ":" + processStyleValue(H, gA) + ";");
      } else if (Array.isArray(AA) && typeof AA[0] == "string" && (t == null || t[AA[0]] === void 0))
        for (var IA = 0; IA < AA.length; IA++)
          isProcessableValue(AA[IA]) && (d += processStyleName(H) + ":" + processStyleValue(H, AA[IA]) + ";");
      else {
        var CA = handleInterpolation(n, t, AA);
        switch (H) {
          case "animation":
          case "animationName": {
            d += processStyleName(H) + ":" + CA + ";";
            break;
          }
          default:
            d += H + "{" + CA + "}";
        }
      }
    }
  return d;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g, cursor$3;
function serializeStyles(n, t, g) {
  if (n.length === 1 && typeof n[0] == "object" && n[0] !== null && n[0].styles !== void 0)
    return n[0];
  var d = !0, k = "";
  cursor$3 = void 0;
  var H = n[0];
  if (H == null || H.raw === void 0)
    d = !1, k += handleInterpolation(g, t, H);
  else {
    var AA = H;
    k += AA[0];
  }
  for (var gA = 1; gA < n.length; gA++)
    if (k += handleInterpolation(g, t, n[gA]), d) {
      var IA = H;
      k += IA[gA];
    }
  labelPattern.lastIndex = 0;
  for (var CA = "", BA; (BA = labelPattern.exec(k)) !== null; )
    CA += "-" + BA[1];
  var eA = murmur2(k) + CA;
  return {
    name: eA,
    styles: k,
    next: cursor$3
  };
}
var syncFallback = function n(t) {
  return t();
}, useInsertionEffect = React.useInsertionEffect ? React.useInsertionEffect : !1, useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback, useInsertionEffectWithLayoutFallback = useInsertionEffect || React.useLayoutEffect, EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
), CacheProvider = EmotionCacheContext.Provider, withEmotionCache = function n(t) {
  return /* @__PURE__ */ forwardRef(function(g, d) {
    var k = useContext(EmotionCacheContext);
    return t(g, k, d);
  });
}, ThemeContext$1 = /* @__PURE__ */ React.createContext({}), useTheme = function n() {
  return React.useContext(ThemeContext$1);
}, getTheme = function n(t, g) {
  if (typeof g == "function") {
    var d = g(t);
    return d;
  }
  return _extends$M({}, t, g);
}, createCacheWithTheme = /* @__PURE__ */ weakMemoize(function(n) {
  return weakMemoize(function(t) {
    return getTheme(n, t);
  });
}), ThemeProvider$2 = function n(t) {
  var g = React.useContext(ThemeContext$1);
  return t.theme !== g && (g = createCacheWithTheme(g)(t.theme)), /* @__PURE__ */ React.createElement(ThemeContext$1.Provider, {
    value: g
  }, t.children);
}, hasOwn = {}.hasOwnProperty, typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", createEmotionProps = function n(t, g) {
  var d = {};
  for (var k in g)
    hasOwn.call(g, k) && (d[k] = g[k]);
  return d[typePropName] = t, d;
}, Insertion$1 = function n(t) {
  var g = t.cache, d = t.serialized, k = t.isStringTag;
  return registerStyles(g, d, k), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(g, d, k);
  }), null;
}, Emotion = /* @__PURE__ */ withEmotionCache(function(n, t, g) {
  var d = n.css;
  typeof d == "string" && t.registered[d] !== void 0 && (d = t.registered[d]);
  var k = n[typePropName], H = [d], AA = "";
  typeof n.className == "string" ? AA = getRegisteredStyles(t.registered, H, n.className) : n.className != null && (AA = n.className + " ");
  var gA = serializeStyles(H, void 0, React.useContext(ThemeContext$1));
  AA += t.key + "-" + gA.name;
  var IA = {};
  for (var CA in n)
    hasOwn.call(n, CA) && CA !== "css" && CA !== typePropName && (IA[CA] = n[CA]);
  return IA.className = AA, g && (IA.ref = g), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$1, {
    cache: t,
    serialized: gA,
    isStringTag: typeof k == "string"
  }), /* @__PURE__ */ React.createElement(k, IA));
}), Emotion$1 = Emotion, jsx = function n(t, g) {
  var d = arguments;
  if (g == null || !hasOwn.call(g, "css"))
    return React.createElement.apply(void 0, d);
  var k = d.length, H = new Array(k);
  H[0] = Emotion$1, H[1] = createEmotionProps(t, g);
  for (var AA = 2; AA < k; AA++)
    H[AA] = d[AA];
  return React.createElement.apply(null, H);
};
(function(n) {
  var t;
  t || (t = n.JSX || (n.JSX = {}));
})(jsx || (jsx = {}));
var Global = /* @__PURE__ */ withEmotionCache(function(n, t) {
  var g = n.styles, d = serializeStyles([g], void 0, React.useContext(ThemeContext$1)), k = React.useRef();
  return useInsertionEffectWithLayoutFallback(function() {
    var H = t.key + "-global", AA = new t.sheet.constructor({
      key: H,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), gA = !1, IA = document.querySelector('style[data-emotion="' + H + " " + d.name + '"]');
    return t.sheet.tags.length && (AA.before = t.sheet.tags[0]), IA !== null && (gA = !0, IA.setAttribute("data-emotion", H), AA.hydrate([IA])), k.current = [AA, gA], function() {
      AA.flush();
    };
  }, [t]), useInsertionEffectWithLayoutFallback(function() {
    var H = k.current, AA = H[0], gA = H[1];
    if (gA) {
      H[1] = !1;
      return;
    }
    if (d.next !== void 0 && insertStyles(t, d.next, !0), AA.tags.length) {
      var IA = AA.tags[AA.tags.length - 1].nextElementSibling;
      AA.before = IA, AA.flush();
    }
    t.insert("", d, AA, !1);
  }, [t, d.name]), null;
});
function css() {
  for (var n = arguments.length, t = new Array(n), g = 0; g < n; g++)
    t[g] = arguments[g];
  return serializeStyles(t);
}
function keyframes() {
  var n = css.apply(void 0, arguments), t = "animation-" + n.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + n.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
const FontFaceDeclaration = ({
  fontFaces: n
}) => {
  const t = n.map((g) => {
    const {
      family: d,
      weight: k,
      weightRange: H,
      url: AA,
      style: gA,
      unicodeRange: IA
    } = g, CA = H || k;
    return `
      @font-face {
        font-family: ${d};
        src: url(${AA}) format("woff2");
        font-display: swap;
        ${gA ? `font-style: ${gA};` : ""}
        ${CA ? `font-weight: ${CA};` : ""}
        ${IA ? `unicode-range: ${IA};` : ""}
      }
    `;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Global, { styles: /* @__PURE__ */ css(t, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:FontFaceDeclaration;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") });
};
var reactFastCompare, hasRequiredReactFastCompare;
function requireReactFastCompare() {
  if (hasRequiredReactFastCompare) return reactFastCompare;
  hasRequiredReactFastCompare = 1;
  var n = typeof Element < "u", t = typeof Map == "function", g = typeof Set == "function", d = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function k(H, AA) {
    if (H === AA) return !0;
    if (H && AA && typeof H == "object" && typeof AA == "object") {
      if (H.constructor !== AA.constructor) return !1;
      var gA, IA, CA;
      if (Array.isArray(H)) {
        if (gA = H.length, gA != AA.length) return !1;
        for (IA = gA; IA-- !== 0; )
          if (!k(H[IA], AA[IA])) return !1;
        return !0;
      }
      var BA;
      if (t && H instanceof Map && AA instanceof Map) {
        if (H.size !== AA.size) return !1;
        for (BA = H.entries(); !(IA = BA.next()).done; )
          if (!AA.has(IA.value[0])) return !1;
        for (BA = H.entries(); !(IA = BA.next()).done; )
          if (!k(IA.value[1], AA.get(IA.value[0]))) return !1;
        return !0;
      }
      if (g && H instanceof Set && AA instanceof Set) {
        if (H.size !== AA.size) return !1;
        for (BA = H.entries(); !(IA = BA.next()).done; )
          if (!AA.has(IA.value[0])) return !1;
        return !0;
      }
      if (d && ArrayBuffer.isView(H) && ArrayBuffer.isView(AA)) {
        if (gA = H.length, gA != AA.length) return !1;
        for (IA = gA; IA-- !== 0; )
          if (H[IA] !== AA[IA]) return !1;
        return !0;
      }
      if (H.constructor === RegExp) return H.source === AA.source && H.flags === AA.flags;
      if (H.valueOf !== Object.prototype.valueOf && typeof H.valueOf == "function" && typeof AA.valueOf == "function") return H.valueOf() === AA.valueOf();
      if (H.toString !== Object.prototype.toString && typeof H.toString == "function" && typeof AA.toString == "function") return H.toString() === AA.toString();
      if (CA = Object.keys(H), gA = CA.length, gA !== Object.keys(AA).length) return !1;
      for (IA = gA; IA-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(AA, CA[IA])) return !1;
      if (n && H instanceof Element) return !1;
      for (IA = gA; IA-- !== 0; )
        if (!((CA[IA] === "_owner" || CA[IA] === "__v" || CA[IA] === "__o") && H.$$typeof) && !k(H[CA[IA]], AA[CA[IA]]))
          return !1;
      return !0;
    }
    return H !== H && AA !== AA;
  }
  return reactFastCompare = function(AA, gA) {
    try {
      return k(AA, gA);
    } catch (IA) {
      if ((IA.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw IA;
    }
  }, reactFastCompare;
}
var reactFastCompareExports = requireReactFastCompare();
const fastCompare = /* @__PURE__ */ getDefaultExportFromCjs$2(reactFastCompareExports);
var browser, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  var n = function(t, g, d, k, H, AA, gA, IA) {
    if (process.env.NODE_ENV !== "production" && g === void 0)
      throw new Error("invariant requires an error message argument");
    if (!t) {
      var CA;
      if (g === void 0)
        CA = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var BA = [d, k, H, AA, gA, IA], eA = 0;
        CA = new Error(
          g.replace(/%s/g, function() {
            return BA[eA++];
          })
        ), CA.name = "Invariant Violation";
      }
      throw CA.framesToPop = 1, CA;
    }
  };
  return browser = n, browser;
}
var browserExports = requireBrowser();
const invariant = /* @__PURE__ */ getDefaultExportFromCjs$2(browserExports);
var shallowequal, hasRequiredShallowequal;
function requireShallowequal() {
  return hasRequiredShallowequal || (hasRequiredShallowequal = 1, shallowequal = function(t, g, d, k) {
    var H = d ? d.call(k, t, g) : void 0;
    if (H !== void 0)
      return !!H;
    if (t === g)
      return !0;
    if (typeof t != "object" || !t || typeof g != "object" || !g)
      return !1;
    var AA = Object.keys(t), gA = Object.keys(g);
    if (AA.length !== gA.length)
      return !1;
    for (var IA = Object.prototype.hasOwnProperty.bind(g), CA = 0; CA < AA.length; CA++) {
      var BA = AA[CA];
      if (!IA(BA))
        return !1;
      var eA = t[BA], iA = g[BA];
      if (H = d ? d.call(k, eA, iA, BA) : void 0, H === !1 || H === void 0 && eA !== iA)
        return !1;
    }
    return !0;
  }), shallowequal;
}
var shallowequalExports = requireShallowequal();
const shallowEqual = /* @__PURE__ */ getDefaultExportFromCjs$2(shallowequalExports);
var TAG_NAMES$1 = /* @__PURE__ */ ((n) => (n.BASE = "base", n.BODY = "body", n.HEAD = "head", n.HTML = "html", n.LINK = "link", n.META = "meta", n.NOSCRIPT = "noscript", n.SCRIPT = "script", n.STYLE = "style", n.TITLE = "title", n.FRAGMENT = "Symbol(react.fragment)", n))(TAG_NAMES$1 || {}), SEO_PRIORITY_TAGS = {
  link: { rel: ["amphtml", "canonical", "alternate"] },
  script: { type: ["application/ld+json"] },
  meta: {
    charset: "",
    name: ["generator", "robots", "description"],
    property: [
      "og:type",
      "og:title",
      "og:url",
      "og:image",
      "og:image:alt",
      "og:description",
      "twitter:url",
      "twitter:title",
      "twitter:description",
      "twitter:image",
      "twitter:image:alt",
      "twitter:card",
      "twitter:site"
    ]
  }
}, VALID_TAG_NAMES = Object.values(TAG_NAMES$1), REACT_TAG_MAP = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
}, HTML_TAG_MAP = Object.entries(REACT_TAG_MAP).reduce(
  (n, [t, g]) => (n[g] = t, n),
  {}
), HELMET_ATTRIBUTE = "data-rh", HELMET_PROPS = {
  DEFAULT_TITLE: "defaultTitle",
  DEFER: "defer",
  ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
  ON_CHANGE_CLIENT_STATE: "onChangeClientState",
  TITLE_TEMPLATE: "titleTemplate",
  PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
}, getInnermostProperty = (n, t) => {
  for (let g = n.length - 1; g >= 0; g -= 1) {
    const d = n[g];
    if (Object.prototype.hasOwnProperty.call(d, t))
      return d[t];
  }
  return null;
}, getTitleFromPropsList = (n) => {
  let t = getInnermostProperty(
    n,
    "title"
    /* TITLE */
  );
  const g = getInnermostProperty(n, HELMET_PROPS.TITLE_TEMPLATE);
  if (Array.isArray(t) && (t = t.join("")), g && t)
    return g.replace(/%s/g, () => t);
  const d = getInnermostProperty(n, HELMET_PROPS.DEFAULT_TITLE);
  return t || d || void 0;
}, getOnChangeClientState = (n) => getInnermostProperty(n, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (() => {
}), getAttributesFromPropsList = (n, t) => t.filter((g) => typeof g[n] < "u").map((g) => g[n]).reduce((g, d) => ({ ...g, ...d }), {}), getBaseTagFromPropsList = (n, t) => t.filter((g) => typeof g.base < "u").map((g) => g.base).reverse().reduce((g, d) => {
  if (!g.length) {
    const k = Object.keys(d);
    for (let H = 0; H < k.length; H += 1) {
      const gA = k[H].toLowerCase();
      if (n.indexOf(gA) !== -1 && d[gA])
        return g.concat(d);
    }
  }
  return g;
}, []), warn$3 = (n) => console && typeof console.warn == "function" && console.warn(n), getTagsFromPropsList = (n, t, g) => {
  const d = {};
  return g.filter((k) => Array.isArray(k[n]) ? !0 : (typeof k[n] < "u" && warn$3(
    `Helmet: ${n} should be of type "Array". Instead found type "${typeof k[n]}"`
  ), !1)).map((k) => k[n]).reverse().reduce((k, H) => {
    const AA = {};
    H.filter((IA) => {
      let CA;
      const BA = Object.keys(IA);
      for (let iA = 0; iA < BA.length; iA += 1) {
        const QA = BA[iA], tA = QA.toLowerCase();
        t.indexOf(tA) !== -1 && !(CA === "rel" && IA[CA].toLowerCase() === "canonical") && !(tA === "rel" && IA[tA].toLowerCase() === "stylesheet") && (CA = tA), t.indexOf(QA) !== -1 && (QA === "innerHTML" || QA === "cssText" || QA === "itemprop") && (CA = QA);
      }
      if (!CA || !IA[CA])
        return !1;
      const eA = IA[CA].toLowerCase();
      return d[CA] || (d[CA] = {}), AA[CA] || (AA[CA] = {}), d[CA][eA] ? !1 : (AA[CA][eA] = !0, !0);
    }).reverse().forEach((IA) => k.push(IA));
    const gA = Object.keys(AA);
    for (let IA = 0; IA < gA.length; IA += 1) {
      const CA = gA[IA], BA = {
        ...d[CA],
        ...AA[CA]
      };
      d[CA] = BA;
    }
    return k;
  }, []).reverse();
}, getAnyTrueFromPropsList = (n, t) => {
  if (Array.isArray(n) && n.length) {
    for (let g = 0; g < n.length; g += 1)
      if (n[g][t])
        return !0;
  }
  return !1;
}, reducePropsToState$1 = (n) => ({
  baseTag: getBaseTagFromPropsList([
    "href"
    /* HREF */
  ], n),
  bodyAttributes: getAttributesFromPropsList("bodyAttributes", n),
  defer: getInnermostProperty(n, HELMET_PROPS.DEFER),
  encode: getInnermostProperty(n, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
  htmlAttributes: getAttributesFromPropsList("htmlAttributes", n),
  linkTags: getTagsFromPropsList(
    "link",
    [
      "rel",
      "href"
      /* HREF */
    ],
    n
  ),
  metaTags: getTagsFromPropsList(
    "meta",
    [
      "name",
      "charset",
      "http-equiv",
      "property",
      "itemprop"
      /* ITEM_PROP */
    ],
    n
  ),
  noscriptTags: getTagsFromPropsList("noscript", [
    "innerHTML"
    /* INNER_HTML */
  ], n),
  onChangeClientState: getOnChangeClientState(n),
  scriptTags: getTagsFromPropsList(
    "script",
    [
      "src",
      "innerHTML"
      /* INNER_HTML */
    ],
    n
  ),
  styleTags: getTagsFromPropsList("style", [
    "cssText"
    /* CSS_TEXT */
  ], n),
  title: getTitleFromPropsList(n),
  titleAttributes: getAttributesFromPropsList("titleAttributes", n),
  prioritizeSeoTags: getAnyTrueFromPropsList(n, HELMET_PROPS.PRIORITIZE_SEO_TAGS)
}), flattenArray = (n) => Array.isArray(n) ? n.join("") : n, checkIfPropsMatch = (n, t) => {
  const g = Object.keys(n);
  for (let d = 0; d < g.length; d += 1)
    if (t[g[d]] && t[g[d]].includes(n[g[d]]))
      return !0;
  return !1;
}, prioritizer = (n, t) => Array.isArray(n) ? n.reduce(
  (g, d) => (checkIfPropsMatch(d, t) ? g.priority.push(d) : g.default.push(d), g),
  { priority: [], default: [] }
) : { default: n, priority: [] }, without$1 = (n, t) => ({
  ...n,
  [t]: void 0
}), SELF_CLOSING_TAGS = [
  "noscript",
  "script",
  "style"
  /* STYLE */
], encodeSpecialCharacters = (n, t = !0) => t === !1 ? String(n) : String(n).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;"), generateElementAttributesAsString = (n) => Object.keys(n).reduce((t, g) => {
  const d = typeof n[g] < "u" ? `${g}="${n[g]}"` : `${g}`;
  return t ? `${t} ${d}` : d;
}, ""), generateTitleAsString = (n, t, g, d) => {
  const k = generateElementAttributesAsString(g), H = flattenArray(t);
  return k ? `<${n} ${HELMET_ATTRIBUTE}="true" ${k}>${encodeSpecialCharacters(
    H,
    d
  )}</${n}>` : `<${n} ${HELMET_ATTRIBUTE}="true">${encodeSpecialCharacters(
    H,
    d
  )}</${n}>`;
}, generateTagsAsString = (n, t, g = !0) => t.reduce((d, k) => {
  const H = k, AA = Object.keys(H).filter(
    (CA) => !(CA === "innerHTML" || CA === "cssText")
  ).reduce((CA, BA) => {
    const eA = typeof H[BA] > "u" ? BA : `${BA}="${encodeSpecialCharacters(H[BA], g)}"`;
    return CA ? `${CA} ${eA}` : eA;
  }, ""), gA = H.innerHTML || H.cssText || "", IA = SELF_CLOSING_TAGS.indexOf(n) === -1;
  return `${d}<${n} ${HELMET_ATTRIBUTE}="true" ${AA}${IA ? "/>" : `>${gA}</${n}>`}`;
}, ""), convertElementAttributesToReactProps = (n, t = {}) => Object.keys(n).reduce((g, d) => {
  const k = REACT_TAG_MAP[d];
  return g[k || d] = n[d], g;
}, t), generateTitleAsReactComponent = (n, t, g) => {
  const d = {
    key: t,
    [HELMET_ATTRIBUTE]: !0
  }, k = convertElementAttributesToReactProps(g, d);
  return [React__default.createElement("title", k, t)];
}, generateTagsAsReactComponent = (n, t) => t.map((g, d) => {
  const k = {
    key: d,
    [HELMET_ATTRIBUTE]: !0
  };
  return Object.keys(g).forEach((H) => {
    const gA = REACT_TAG_MAP[H] || H;
    if (gA === "innerHTML" || gA === "cssText") {
      const IA = g.innerHTML || g.cssText;
      k.dangerouslySetInnerHTML = { __html: IA };
    } else
      k[gA] = g[H];
  }), React__default.createElement(n, k);
}), getMethodsForTag = (n, t, g = !0) => {
  switch (n) {
    case "title":
      return {
        toComponent: () => generateTitleAsReactComponent(n, t.title, t.titleAttributes),
        toString: () => generateTitleAsString(n, t.title, t.titleAttributes, g)
      };
    case "bodyAttributes":
    case "htmlAttributes":
      return {
        toComponent: () => convertElementAttributesToReactProps(t),
        toString: () => generateElementAttributesAsString(t)
      };
    default:
      return {
        toComponent: () => generateTagsAsReactComponent(n, t),
        toString: () => generateTagsAsString(n, t, g)
      };
  }
}, getPriorityMethods = ({ metaTags: n, linkTags: t, scriptTags: g, encode: d }) => {
  const k = prioritizer(n, SEO_PRIORITY_TAGS.meta), H = prioritizer(t, SEO_PRIORITY_TAGS.link), AA = prioritizer(g, SEO_PRIORITY_TAGS.script);
  return {
    priorityMethods: {
      toComponent: () => [
        ...generateTagsAsReactComponent("meta", k.priority),
        ...generateTagsAsReactComponent("link", H.priority),
        ...generateTagsAsReactComponent("script", AA.priority)
      ],
      toString: () => (
        // generate all the tags as strings and concatenate them
        `${getMethodsForTag("meta", k.priority, d)} ${getMethodsForTag(
          "link",
          H.priority,
          d
        )} ${getMethodsForTag("script", AA.priority, d)}`
      )
    },
    metaTags: k.default,
    linkTags: H.default,
    scriptTags: AA.default
  };
}, mapStateOnServer = (n) => {
  const {
    baseTag: t,
    bodyAttributes: g,
    encode: d = !0,
    htmlAttributes: k,
    noscriptTags: H,
    styleTags: AA,
    title: gA = "",
    titleAttributes: IA,
    prioritizeSeoTags: CA
  } = n;
  let { linkTags: BA, metaTags: eA, scriptTags: iA } = n, QA = {
    toComponent: () => {
    },
    toString: () => ""
  };
  return CA && ({ priorityMethods: QA, linkTags: BA, metaTags: eA, scriptTags: iA } = getPriorityMethods(n)), {
    priority: QA,
    base: getMethodsForTag("base", t, d),
    bodyAttributes: getMethodsForTag("bodyAttributes", g, d),
    htmlAttributes: getMethodsForTag("htmlAttributes", k, d),
    link: getMethodsForTag("link", BA, d),
    meta: getMethodsForTag("meta", eA, d),
    noscript: getMethodsForTag("noscript", H, d),
    script: getMethodsForTag("script", iA, d),
    style: getMethodsForTag("style", AA, d),
    title: getMethodsForTag("title", { title: gA, titleAttributes: IA }, d)
  };
}, server_default = mapStateOnServer, instances = [], isDocument = !!(typeof window < "u" && window.document && window.document.createElement), HelmetData = class {
  instances = [];
  canUseDOM = isDocument;
  context;
  value = {
    setHelmet: (n) => {
      this.context.helmet = n;
    },
    helmetInstances: {
      get: () => this.canUseDOM ? instances : this.instances,
      add: (n) => {
        (this.canUseDOM ? instances : this.instances).push(n);
      },
      remove: (n) => {
        const t = (this.canUseDOM ? instances : this.instances).indexOf(n);
        (this.canUseDOM ? instances : this.instances).splice(t, 1);
      }
    }
  };
  constructor(n, t) {
    this.context = n, this.canUseDOM = t || !1, t || (n.helmet = server_default({
      baseTag: [],
      bodyAttributes: {},
      htmlAttributes: {},
      linkTags: [],
      metaTags: [],
      noscriptTags: [],
      scriptTags: [],
      styleTags: [],
      title: "",
      titleAttributes: {}
    }));
  }
}, defaultValue = {}, Context$1 = React__default.createContext(defaultValue), HelmetProvider = class TI extends Component {
  static canUseDOM = isDocument;
  helmetData;
  constructor(t) {
    super(t), this.helmetData = new HelmetData(this.props.context || {}, TI.canUseDOM);
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(Context$1.Provider, { value: this.helmetData.value }, this.props.children);
  }
}, updateTags = (n, t) => {
  const g = document.head || document.querySelector(
    "head"
    /* HEAD */
  ), d = g.querySelectorAll(`${n}[${HELMET_ATTRIBUTE}]`), k = [].slice.call(d), H = [];
  let AA;
  return t && t.length && t.forEach((gA) => {
    const IA = document.createElement(n);
    for (const CA in gA)
      if (Object.prototype.hasOwnProperty.call(gA, CA))
        if (CA === "innerHTML")
          IA.innerHTML = gA.innerHTML;
        else if (CA === "cssText")
          IA.styleSheet ? IA.styleSheet.cssText = gA.cssText : IA.appendChild(document.createTextNode(gA.cssText));
        else {
          const BA = CA, eA = typeof gA[BA] > "u" ? "" : gA[BA];
          IA.setAttribute(CA, eA);
        }
    IA.setAttribute(HELMET_ATTRIBUTE, "true"), k.some((CA, BA) => (AA = BA, IA.isEqualNode(CA))) ? k.splice(AA, 1) : H.push(IA);
  }), k.forEach((gA) => gA.parentNode?.removeChild(gA)), H.forEach((gA) => g.appendChild(gA)), {
    oldTags: k,
    newTags: H
  };
}, updateAttributes = (n, t) => {
  const g = document.getElementsByTagName(n)[0];
  if (!g)
    return;
  const d = g.getAttribute(HELMET_ATTRIBUTE), k = d ? d.split(",") : [], H = [...k], AA = Object.keys(t);
  for (const gA of AA) {
    const IA = t[gA] || "";
    g.getAttribute(gA) !== IA && g.setAttribute(gA, IA), k.indexOf(gA) === -1 && k.push(gA);
    const CA = H.indexOf(gA);
    CA !== -1 && H.splice(CA, 1);
  }
  for (let gA = H.length - 1; gA >= 0; gA -= 1)
    g.removeAttribute(H[gA]);
  k.length === H.length ? g.removeAttribute(HELMET_ATTRIBUTE) : g.getAttribute(HELMET_ATTRIBUTE) !== AA.join(",") && g.setAttribute(HELMET_ATTRIBUTE, AA.join(","));
}, updateTitle = (n, t) => {
  typeof n < "u" && document.title !== n && (document.title = flattenArray(n)), updateAttributes("title", t);
}, commitTagChanges = (n, t) => {
  const {
    baseTag: g,
    bodyAttributes: d,
    htmlAttributes: k,
    linkTags: H,
    metaTags: AA,
    noscriptTags: gA,
    onChangeClientState: IA,
    scriptTags: CA,
    styleTags: BA,
    title: eA,
    titleAttributes: iA
  } = n;
  updateAttributes("body", d), updateAttributes("html", k), updateTitle(eA, iA);
  const QA = {
    baseTag: updateTags("base", g),
    linkTags: updateTags("link", H),
    metaTags: updateTags("meta", AA),
    noscriptTags: updateTags("noscript", gA),
    scriptTags: updateTags("script", CA),
    styleTags: updateTags("style", BA)
  }, tA = {}, oA = {};
  Object.keys(QA).forEach((EA) => {
    const { newTags: aA, oldTags: nA } = QA[EA];
    aA.length && (tA[EA] = aA), nA.length && (oA[EA] = QA[EA].oldTags);
  }), t && t(), IA(n, tA, oA);
}, _helmetCallback = null, handleStateChangeOnClient$1 = (n) => {
  _helmetCallback && cancelAnimationFrame(_helmetCallback), n.defer ? _helmetCallback = requestAnimationFrame(() => {
    commitTagChanges(n, () => {
      _helmetCallback = null;
    });
  }) : (commitTagChanges(n), _helmetCallback = null);
}, client_default = handleStateChangeOnClient$1, HelmetDispatcher = class extends Component {
  rendered = !1;
  shouldComponentUpdate(n) {
    return !shallowEqual(n, this.props);
  }
  componentDidUpdate() {
    this.emitChange();
  }
  componentWillUnmount() {
    const { helmetInstances: n } = this.props.context;
    n.remove(this), this.emitChange();
  }
  emitChange() {
    const { helmetInstances: n, setHelmet: t } = this.props.context;
    let g = null;
    const d = reducePropsToState$1(
      n.get().map((k) => {
        const H = { ...k.props };
        return delete H.context, H;
      })
    );
    HelmetProvider.canUseDOM ? client_default(d) : server_default && (g = server_default(d)), t(g);
  }
  // componentWillMount will be deprecated
  // for SSR, initialize on first render
  // constructor is also unsafe in StrictMode
  init() {
    if (this.rendered)
      return;
    this.rendered = !0;
    const { helmetInstances: n } = this.props.context;
    n.add(this), this.emitChange();
  }
  render() {
    return this.init(), null;
  }
}, Helmet = class extends Component {
  static defaultProps = {
    defer: !0,
    encodeSpecialCharacters: !0,
    prioritizeSeoTags: !1
  };
  shouldComponentUpdate(n) {
    return !fastCompare(without$1(this.props, "helmetData"), without$1(n, "helmetData"));
  }
  mapNestedChildrenToProps(n, t) {
    if (!t)
      return null;
    switch (n.type) {
      case "script":
      case "noscript":
        return {
          innerHTML: t
        };
      case "style":
        return {
          cssText: t
        };
      default:
        throw new Error(
          `<${n.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`
        );
    }
  }
  flattenArrayTypeChildren(n, t, g, d) {
    return {
      ...t,
      [n.type]: [
        ...t[n.type] || [],
        {
          ...g,
          ...this.mapNestedChildrenToProps(n, d)
        }
      ]
    };
  }
  mapObjectTypeChildren(n, t, g, d) {
    switch (n.type) {
      case "title":
        return {
          ...t,
          [n.type]: d,
          titleAttributes: { ...g }
        };
      case "body":
        return {
          ...t,
          bodyAttributes: { ...g }
        };
      case "html":
        return {
          ...t,
          htmlAttributes: { ...g }
        };
      default:
        return {
          ...t,
          [n.type]: { ...g }
        };
    }
  }
  mapArrayTypeChildrenToProps(n, t) {
    let g = { ...t };
    return Object.keys(n).forEach((d) => {
      g = {
        ...g,
        [d]: n[d]
      };
    }), g;
  }
  warnOnInvalidChildren(n, t) {
    return invariant(
      VALID_TAG_NAMES.some((g) => n.type === g),
      typeof n.type == "function" ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : `Only elements types ${VALID_TAG_NAMES.join(
        ", "
      )} are allowed. Helmet does not support rendering <${n.type}> elements. Refer to our API for more information.`
    ), invariant(
      !t || typeof t == "string" || Array.isArray(t) && !t.some((g) => typeof g != "string"),
      `Helmet expects a string as a child of <${n.type}>. Did you forget to wrap your children in braces? ( <${n.type}>{\`\`}</${n.type}> ) Refer to our API for more information.`
    ), !0;
  }
  mapChildrenToProps(n, t) {
    let g = {};
    return React__default.Children.forEach(n, (d) => {
      if (!d || !d.props)
        return;
      const { children: k, ...H } = d.props, AA = Object.keys(H).reduce((IA, CA) => (IA[HTML_TAG_MAP[CA] || CA] = H[CA], IA), {});
      let { type: gA } = d;
      switch (typeof gA == "symbol" ? gA = gA.toString() : this.warnOnInvalidChildren(d, k), gA) {
        case "Symbol(react.fragment)":
          t = this.mapChildrenToProps(k, t);
          break;
        case "link":
        case "meta":
        case "noscript":
        case "script":
        case "style":
          g = this.flattenArrayTypeChildren(
            d,
            g,
            AA,
            k
          );
          break;
        default:
          t = this.mapObjectTypeChildren(d, t, AA, k);
          break;
      }
    }), this.mapArrayTypeChildrenToProps(g, t);
  }
  render() {
    const { children: n, ...t } = this.props;
    let g = { ...t }, { helmetData: d } = t;
    if (n && (g = this.mapChildrenToProps(n, g)), d && !(d instanceof HelmetData)) {
      const k = d;
      d = new HelmetData(k.context, !0), delete g.helmetData;
    }
    return d ? /* @__PURE__ */ React__default.createElement(HelmetDispatcher, { ...g, context: d.value }) : /* @__PURE__ */ React__default.createElement(Context$1.Consumer, null, (k) => /* @__PURE__ */ React__default.createElement(HelmetDispatcher, { ...g, context: k }));
  }
};
const FontSources = ({
  fontSources: n
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Helmet, { children: Object.entries(n).map(([t, g]) => /* @__PURE__ */ jsxRuntimeExports.jsx("link", { id: t, rel: "stylesheet", href: g }, t)) });
typeof Promise.withResolvers > "u" && (Promise.withResolvers = () => {
  let n, t;
  const g = new Promise((d, k) => {
    n = d, t = k;
  });
  return {
    resolve: n,
    reject: t,
    promise: g
  };
});
function getCookie(n) {
  const t = document.cookie.match(`\\b${n}=([^;]*)\\b`);
  return t ? t[1] : void 0;
}
function localStorageAvailable() {
  const n = "testData";
  try {
    const {
      localStorage: t
    } = window;
    t.setItem(n, n), t.getItem(n), t.removeItem(n);
  } catch {
    return !1;
  }
  return !0;
}
function notNullOrUndefined(n) {
  return n != null;
}
function isNullOrUndefined$1(n) {
  return n == null;
}
const isLocalhost = () => window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
var NOTHING = Symbol.for("immer-nothing"), DRAFTABLE = Symbol.for("immer-draftable"), DRAFT_STATE = Symbol.for("immer-state"), errors = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(n) {
    return `The plugin for '${n}' has not been loaded into Immer. To enable the plugin, import and call \`enable${n}()\` when initializing your application.`;
  },
  function(n) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${n}'`;
  },
  "This object has been frozen and should not be mutated",
  function(n) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(n) {
    return `'current' expects a draft, got: ${n}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(n) {
    return `'original' expects a draft, got: ${n}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(n, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const g = errors[n], d = typeof g == "function" ? g.apply(null, t) : g;
    throw new Error(`[Immer] ${d}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${n}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var getPrototypeOf$1 = Object.getPrototypeOf;
function isDraft(n) {
  return !!n && !!n[DRAFT_STATE];
}
function isDraftable(n) {
  return n ? isPlainObject$4(n) || Array.isArray(n) || !!n[DRAFTABLE] || !!n.constructor?.[DRAFTABLE] || isMap(n) || isSet(n) : !1;
}
var objectCtorString$1 = Object.prototype.constructor.toString(), cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject$4(n) {
  if (!n || typeof n != "object")
    return !1;
  const t = Object.getPrototypeOf(n);
  if (t === null || t === Object.prototype)
    return !0;
  const g = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  if (g === Object)
    return !0;
  if (typeof g != "function")
    return !1;
  let d = cachedCtorStrings.get(g);
  return d === void 0 && (d = Function.toString.call(g), cachedCtorStrings.set(g, d)), d === objectCtorString$1;
}
function each(n, t, g = !0) {
  getArchtype(n) === 0 ? (g ? Reflect.ownKeys(n) : Object.keys(n)).forEach((k) => {
    t(k, n[k], n);
  }) : n.forEach((d, k) => t(k, d, n));
}
function getArchtype(n) {
  const t = n[DRAFT_STATE];
  return t ? t.type_ : Array.isArray(n) ? 1 : isMap(n) ? 2 : isSet(n) ? 3 : 0;
}
function has$5(n, t) {
  return getArchtype(n) === 2 ? n.has(t) : Object.prototype.hasOwnProperty.call(n, t);
}
function get$a(n, t) {
  return getArchtype(n) === 2 ? n.get(t) : n[t];
}
function set$8(n, t, g) {
  const d = getArchtype(n);
  d === 2 ? n.set(t, g) : d === 3 ? n.add(g) : n[t] = g;
}
function is(n, t) {
  return n === t ? n !== 0 || 1 / n === 1 / t : n !== n && t !== t;
}
function isMap(n) {
  return n instanceof Map;
}
function isSet(n) {
  return n instanceof Set;
}
function latest(n) {
  return n.copy_ || n.base_;
}
function shallowCopy(n, t) {
  if (isMap(n))
    return new Map(n);
  if (isSet(n))
    return new Set(n);
  if (Array.isArray(n))
    return Array.prototype.slice.call(n);
  const g = isPlainObject$4(n);
  if (t === !0 || t === "class_only" && !g) {
    const d = Object.getOwnPropertyDescriptors(n);
    delete d[DRAFT_STATE];
    let k = Reflect.ownKeys(d);
    for (let H = 0; H < k.length; H++) {
      const AA = k[H], gA = d[AA];
      gA.writable === !1 && (gA.writable = !0, gA.configurable = !0), (gA.get || gA.set) && (d[AA] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: gA.enumerable,
        value: n[AA]
      });
    }
    return Object.create(getPrototypeOf$1(n), d);
  } else {
    const d = getPrototypeOf$1(n);
    if (d !== null && g)
      return { ...n };
    const k = Object.create(d);
    return Object.assign(k, n);
  }
}
function freeze(n, t = !1) {
  return isFrozen(n) || isDraft(n) || !isDraftable(n) || (getArchtype(n) > 1 && Object.defineProperties(n, {
    set: dontMutateMethodOverride,
    add: dontMutateMethodOverride,
    clear: dontMutateMethodOverride,
    delete: dontMutateMethodOverride
  }), Object.freeze(n), t && Object.values(n).forEach((g) => freeze(g, !0))), n;
}
function dontMutateFrozenCollections() {
  die(2);
}
var dontMutateMethodOverride = {
  value: dontMutateFrozenCollections
};
function isFrozen(n) {
  return n === null || typeof n != "object" ? !0 : Object.isFrozen(n);
}
var plugins$1 = {};
function getPlugin(n) {
  const t = plugins$1[n];
  return t || die(0, n), t;
}
function loadPlugin(n, t) {
  plugins$1[n] || (plugins$1[n] = t);
}
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(n, t) {
  return {
    drafts_: [],
    parent_: n,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(n, t) {
  t && (getPlugin("Patches"), n.patches_ = [], n.inversePatches_ = [], n.patchListener_ = t);
}
function revokeScope(n) {
  leaveScope(n), n.drafts_.forEach(revokeDraft), n.drafts_ = null;
}
function leaveScope(n) {
  n === currentScope && (currentScope = n.parent_);
}
function enterScope(n) {
  return currentScope = createScope(currentScope, n);
}
function revokeDraft(n) {
  const t = n[DRAFT_STATE];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function processResult(n, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const g = t.drafts_[0];
  return n !== void 0 && n !== g ? (g[DRAFT_STATE].modified_ && (revokeScope(t), die(4)), isDraftable(n) && (n = finalize$1(t, n), t.parent_ || maybeFreeze(t, n)), t.patches_ && getPlugin("Patches").generateReplacementPatches_(
    g[DRAFT_STATE].base_,
    n,
    t.patches_,
    t.inversePatches_
  )) : n = finalize$1(t, g, []), revokeScope(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), n !== NOTHING ? n : void 0;
}
function finalize$1(n, t, g) {
  if (isFrozen(t))
    return t;
  const d = n.immer_.shouldUseStrictIteration(), k = t[DRAFT_STATE];
  if (!k)
    return each(
      t,
      (H, AA) => finalizeProperty(n, k, t, H, AA, g),
      d
    ), t;
  if (k.scope_ !== n)
    return t;
  if (!k.modified_)
    return maybeFreeze(n, k.base_, !0), k.base_;
  if (!k.finalized_) {
    k.finalized_ = !0, k.scope_.unfinalizedDrafts_--;
    const H = k.copy_;
    let AA = H, gA = !1;
    k.type_ === 3 && (AA = new Set(H), H.clear(), gA = !0), each(
      AA,
      (IA, CA) => finalizeProperty(
        n,
        k,
        H,
        IA,
        CA,
        g,
        gA
      ),
      d
    ), maybeFreeze(n, H, !1), g && n.patches_ && getPlugin("Patches").generatePatches_(
      k,
      g,
      n.patches_,
      n.inversePatches_
    );
  }
  return k.copy_;
}
function finalizeProperty(n, t, g, d, k, H, AA) {
  if (k == null || typeof k != "object" && !AA)
    return;
  const gA = isFrozen(k);
  if (!(gA && !AA)) {
    if (process.env.NODE_ENV !== "production" && k === g && die(5), isDraft(k)) {
      const IA = H && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
      !has$5(t.assigned_, d) ? H.concat(d) : void 0, CA = finalize$1(n, k, IA);
      if (set$8(g, d, CA), isDraft(CA))
        n.canAutoFreeze_ = !1;
      else
        return;
    } else AA && g.add(k);
    if (isDraftable(k) && !gA) {
      if (!n.immer_.autoFreeze_ && n.unfinalizedDrafts_ < 1 || t && t.base_ && t.base_[d] === k && gA)
        return;
      finalize$1(n, k), (!t || !t.scope_.parent_) && typeof d != "symbol" && (isMap(g) ? g.has(d) : Object.prototype.propertyIsEnumerable.call(g, d)) && maybeFreeze(n, k);
    }
  }
}
function maybeFreeze(n, t, g = !1) {
  !n.parent_ && n.immer_.autoFreeze_ && n.canAutoFreeze_ && freeze(t, g);
}
function createProxyProxy(n, t) {
  const g = Array.isArray(n), d = {
    type_: g ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: n,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let k = d, H = objectTraps;
  g && (k = [d], H = arrayTraps);
  const { revoke: AA, proxy: gA } = Proxy.revocable(k, H);
  return d.draft_ = gA, d.revoke_ = AA, gA;
}
var objectTraps = {
  get(n, t) {
    if (t === DRAFT_STATE)
      return n;
    const g = latest(n);
    if (!has$5(g, t))
      return readPropFromProto(n, g, t);
    const d = g[t];
    return n.finalized_ || !isDraftable(d) ? d : d === peek$4(n.base_, t) ? (prepareCopy(n), n.copy_[t] = createProxy(d, n)) : d;
  },
  has(n, t) {
    return t in latest(n);
  },
  ownKeys(n) {
    return Reflect.ownKeys(latest(n));
  },
  set(n, t, g) {
    const d = getDescriptorFromProto(latest(n), t);
    if (d?.set)
      return d.set.call(n.draft_, g), !0;
    if (!n.modified_) {
      const k = peek$4(latest(n), t), H = k?.[DRAFT_STATE];
      if (H && H.base_ === g)
        return n.copy_[t] = g, n.assigned_[t] = !1, !0;
      if (is(g, k) && (g !== void 0 || has$5(n.base_, t)))
        return !0;
      prepareCopy(n), markChanged(n);
    }
    return n.copy_[t] === g && // special case: handle new props with value 'undefined'
    (g !== void 0 || t in n.copy_) || // special case: NaN
    Number.isNaN(g) && Number.isNaN(n.copy_[t]) || (n.copy_[t] = g, n.assigned_[t] = !0), !0;
  },
  deleteProperty(n, t) {
    return peek$4(n.base_, t) !== void 0 || t in n.base_ ? (n.assigned_[t] = !1, prepareCopy(n), markChanged(n)) : delete n.assigned_[t], n.copy_ && delete n.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(n, t) {
    const g = latest(n), d = Reflect.getOwnPropertyDescriptor(g, t);
    return d && {
      writable: !0,
      configurable: n.type_ !== 1 || t !== "length",
      enumerable: d.enumerable,
      value: g[t]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(n) {
    return getPrototypeOf$1(n.base_);
  },
  setPrototypeOf() {
    die(12);
  }
}, arrayTraps = {};
each(objectTraps, (n, t) => {
  arrayTraps[n] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(n, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && die(13), arrayTraps.set.call(this, n, t, void 0);
};
arrayTraps.set = function(n, t, g) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && die(14), objectTraps.set.call(this, n[0], t, g, n[0]);
};
function peek$4(n, t) {
  const g = n[DRAFT_STATE];
  return (g ? latest(g) : n)[t];
}
function readPropFromProto(n, t, g) {
  const d = getDescriptorFromProto(t, g);
  return d ? "value" in d ? d.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    d.get?.call(n.draft_)
  ) : void 0;
}
function getDescriptorFromProto(n, t) {
  if (!(t in n))
    return;
  let g = getPrototypeOf$1(n);
  for (; g; ) {
    const d = Object.getOwnPropertyDescriptor(g, t);
    if (d)
      return d;
    g = getPrototypeOf$1(g);
  }
}
function markChanged(n) {
  n.modified_ || (n.modified_ = !0, n.parent_ && markChanged(n.parent_));
}
function prepareCopy(n) {
  n.copy_ || (n.copy_ = shallowCopy(
    n.base_,
    n.scope_.immer_.useStrictShallowCopy_
  ));
}
var Immer2 = class {
  constructor(n) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !0, this.produce = (t, g, d) => {
      if (typeof t == "function" && typeof g != "function") {
        const H = g;
        g = t;
        const AA = this;
        return function(IA = H, ...CA) {
          return AA.produce(IA, (BA) => g.call(this, BA, ...CA));
        };
      }
      typeof g != "function" && die(6), d !== void 0 && typeof d != "function" && die(7);
      let k;
      if (isDraftable(t)) {
        const H = enterScope(this), AA = createProxy(t, void 0);
        let gA = !0;
        try {
          k = g(AA), gA = !1;
        } finally {
          gA ? revokeScope(H) : leaveScope(H);
        }
        return usePatchesInScope(H, d), processResult(k, H);
      } else if (!t || typeof t != "object") {
        if (k = g(t), k === void 0 && (k = t), k === NOTHING && (k = void 0), this.autoFreeze_ && freeze(k, !0), d) {
          const H = [], AA = [];
          getPlugin("Patches").generateReplacementPatches_(t, k, H, AA), d(H, AA);
        }
        return k;
      } else
        die(1, t);
    }, this.produceWithPatches = (t, g) => {
      if (typeof t == "function")
        return (AA, ...gA) => this.produceWithPatches(AA, (IA) => t(IA, ...gA));
      let d, k;
      return [this.produce(t, g, (AA, gA) => {
        d = AA, k = gA;
      }), d, k];
    }, typeof n?.autoFreeze == "boolean" && this.setAutoFreeze(n.autoFreeze), typeof n?.useStrictShallowCopy == "boolean" && this.setUseStrictShallowCopy(n.useStrictShallowCopy), typeof n?.useStrictIteration == "boolean" && this.setUseStrictIteration(n.useStrictIteration);
  }
  createDraft(n) {
    isDraftable(n) || die(8), isDraft(n) && (n = current$1(n));
    const t = enterScope(this), g = createProxy(n, void 0);
    return g[DRAFT_STATE].isManual_ = !0, leaveScope(t), g;
  }
  finishDraft(n, t) {
    const g = n && n[DRAFT_STATE];
    (!g || !g.isManual_) && die(9);
    const { scope_: d } = g;
    return usePatchesInScope(d, t), processResult(void 0, d);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(n) {
    this.autoFreeze_ = n;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(n) {
    this.useStrictShallowCopy_ = n;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(n) {
    this.useStrictIteration_ = n;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(n, t) {
    let g;
    for (g = t.length - 1; g >= 0; g--) {
      const k = t[g];
      if (k.path.length === 0 && k.op === "replace") {
        n = k.value;
        break;
      }
    }
    g > -1 && (t = t.slice(g + 1));
    const d = getPlugin("Patches").applyPatches_;
    return isDraft(n) ? d(n, t) : this.produce(
      n,
      (k) => d(k, t)
    );
  }
};
function createProxy(n, t) {
  const g = isMap(n) ? getPlugin("MapSet").proxyMap_(n, t) : isSet(n) ? getPlugin("MapSet").proxySet_(n, t) : createProxyProxy(n, t);
  return (t ? t.scope_ : getCurrentScope()).drafts_.push(g), g;
}
function current$1(n) {
  return isDraft(n) || die(10, n), currentImpl(n);
}
function currentImpl(n) {
  if (!isDraftable(n) || isFrozen(n))
    return n;
  const t = n[DRAFT_STATE];
  let g, d = !0;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, g = shallowCopy(n, t.scope_.immer_.useStrictShallowCopy_), d = t.scope_.immer_.shouldUseStrictIteration();
  } else
    g = shallowCopy(n, !0);
  return each(
    g,
    (k, H) => {
      set$8(g, k, currentImpl(H));
    },
    d
  ), t && (t.finalized_ = !1), g;
}
function enablePatches() {
  process.env.NODE_ENV !== "production" && errors.push(
    'Sets cannot have "replace" patches.',
    function(iA) {
      return "Unsupported patch operation: " + iA;
    },
    function(iA) {
      return "Cannot apply patch, path doesn't resolve: " + iA;
    },
    "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
  );
  const t = "replace", g = "add", d = "remove";
  function k(iA, QA, tA, oA) {
    switch (iA.type_) {
      case 0:
      case 2:
        return AA(
          iA,
          QA,
          tA,
          oA
        );
      case 1:
        return H(iA, QA, tA, oA);
      case 3:
        return gA(
          iA,
          QA,
          tA,
          oA
        );
    }
  }
  function H(iA, QA, tA, oA) {
    let { base_: EA, assigned_: aA } = iA, nA = iA.copy_;
    nA.length < EA.length && ([EA, nA] = [nA, EA], [tA, oA] = [oA, tA]);
    for (let lA = 0; lA < EA.length; lA++)
      if (aA[lA] && nA[lA] !== EA[lA]) {
        const cA = QA.concat([lA]);
        tA.push({
          op: t,
          path: cA,
          // Need to maybe clone it, as it can in fact be the original value
          // due to the base/copy inversion at the start of this function
          value: eA(nA[lA])
        }), oA.push({
          op: t,
          path: cA,
          value: eA(EA[lA])
        });
      }
    for (let lA = EA.length; lA < nA.length; lA++) {
      const cA = QA.concat([lA]);
      tA.push({
        op: g,
        path: cA,
        // Need to maybe clone it, as it can in fact be the original value
        // due to the base/copy inversion at the start of this function
        value: eA(nA[lA])
      });
    }
    for (let lA = nA.length - 1; EA.length <= lA; --lA) {
      const cA = QA.concat([lA]);
      oA.push({
        op: d,
        path: cA
      });
    }
  }
  function AA(iA, QA, tA, oA) {
    const { base_: EA, copy_: aA } = iA;
    each(iA.assigned_, (nA, lA) => {
      const cA = get$a(EA, nA), sA = get$a(aA, nA), rA = lA ? has$5(EA, nA) ? t : g : d;
      if (cA === sA && rA === t)
        return;
      const uA = QA.concat(nA);
      tA.push(rA === d ? { op: rA, path: uA } : { op: rA, path: uA, value: sA }), oA.push(
        rA === g ? { op: d, path: uA } : rA === d ? { op: g, path: uA, value: eA(cA) } : { op: t, path: uA, value: eA(cA) }
      );
    });
  }
  function gA(iA, QA, tA, oA) {
    let { base_: EA, copy_: aA } = iA, nA = 0;
    EA.forEach((lA) => {
      if (!aA.has(lA)) {
        const cA = QA.concat([nA]);
        tA.push({
          op: d,
          path: cA,
          value: lA
        }), oA.unshift({
          op: g,
          path: cA,
          value: lA
        });
      }
      nA++;
    }), nA = 0, aA.forEach((lA) => {
      if (!EA.has(lA)) {
        const cA = QA.concat([nA]);
        tA.push({
          op: g,
          path: cA,
          value: lA
        }), oA.unshift({
          op: d,
          path: cA,
          value: lA
        });
      }
      nA++;
    });
  }
  function IA(iA, QA, tA, oA) {
    tA.push({
      op: t,
      path: [],
      value: QA === NOTHING ? void 0 : QA
    }), oA.push({
      op: t,
      path: [],
      value: iA
    });
  }
  function CA(iA, QA) {
    return QA.forEach((tA) => {
      const { path: oA, op: EA } = tA;
      let aA = iA;
      for (let sA = 0; sA < oA.length - 1; sA++) {
        const rA = getArchtype(aA);
        let uA = oA[sA];
        typeof uA != "string" && typeof uA != "number" && (uA = "" + uA), (rA === 0 || rA === 1) && (uA === "__proto__" || uA === "constructor") && die(19), typeof aA == "function" && uA === "prototype" && die(19), aA = get$a(aA, uA), typeof aA != "object" && die(18, oA.join("/"));
      }
      const nA = getArchtype(aA), lA = BA(tA.value), cA = oA[oA.length - 1];
      switch (EA) {
        case t:
          switch (nA) {
            case 2:
              return aA.set(cA, lA);
            case 3:
              die(16);
            default:
              return aA[cA] = lA;
          }
        case g:
          switch (nA) {
            case 1:
              return cA === "-" ? aA.push(lA) : aA.splice(cA, 0, lA);
            case 2:
              return aA.set(cA, lA);
            case 3:
              return aA.add(lA);
            default:
              return aA[cA] = lA;
          }
        case d:
          switch (nA) {
            case 1:
              return aA.splice(cA, 1);
            case 2:
              return aA.delete(cA);
            case 3:
              return aA.delete(tA.value);
            default:
              return delete aA[cA];
          }
        default:
          die(17, EA);
      }
    }), iA;
  }
  function BA(iA) {
    if (!isDraftable(iA))
      return iA;
    if (Array.isArray(iA))
      return iA.map(BA);
    if (isMap(iA))
      return new Map(
        Array.from(iA.entries()).map(([tA, oA]) => [tA, BA(oA)])
      );
    if (isSet(iA))
      return new Set(Array.from(iA).map(BA));
    const QA = Object.create(getPrototypeOf$1(iA));
    for (const tA in iA)
      QA[tA] = BA(iA[tA]);
    return has$5(iA, DRAFTABLE) && (QA[DRAFTABLE] = iA[DRAFTABLE]), QA;
  }
  function eA(iA) {
    return isDraft(iA) ? BA(iA) : iA;
  }
  loadPlugin("Patches", {
    applyPatches_: CA,
    generatePatches_: k,
    generateReplacementPatches_: IA
  });
}
function enableMapSet() {
  class n extends Map {
    constructor(IA, CA) {
      super(), this[DRAFT_STATE] = {
        type_: 2,
        parent_: CA,
        scope_: CA ? CA.scope_ : getCurrentScope(),
        modified_: !1,
        finalized_: !1,
        copy_: void 0,
        assigned_: void 0,
        base_: IA,
        draft_: this,
        isManual_: !1,
        revoked_: !1
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(IA) {
      return latest(this[DRAFT_STATE]).has(IA);
    }
    set(IA, CA) {
      const BA = this[DRAFT_STATE];
      return AA(BA), (!latest(BA).has(IA) || latest(BA).get(IA) !== CA) && (g(BA), markChanged(BA), BA.assigned_.set(IA, !0), BA.copy_.set(IA, CA), BA.assigned_.set(IA, !0)), this;
    }
    delete(IA) {
      if (!this.has(IA))
        return !1;
      const CA = this[DRAFT_STATE];
      return AA(CA), g(CA), markChanged(CA), CA.base_.has(IA) ? CA.assigned_.set(IA, !1) : CA.assigned_.delete(IA), CA.copy_.delete(IA), !0;
    }
    clear() {
      const IA = this[DRAFT_STATE];
      AA(IA), latest(IA).size && (g(IA), markChanged(IA), IA.assigned_ = /* @__PURE__ */ new Map(), each(IA.base_, (CA) => {
        IA.assigned_.set(CA, !1);
      }), IA.copy_.clear());
    }
    forEach(IA, CA) {
      const BA = this[DRAFT_STATE];
      latest(BA).forEach((eA, iA, QA) => {
        IA.call(CA, this.get(iA), iA, this);
      });
    }
    get(IA) {
      const CA = this[DRAFT_STATE];
      AA(CA);
      const BA = latest(CA).get(IA);
      if (CA.finalized_ || !isDraftable(BA) || BA !== CA.base_.get(IA))
        return BA;
      const eA = createProxy(BA, CA);
      return g(CA), CA.copy_.set(IA, eA), eA;
    }
    keys() {
      return latest(this[DRAFT_STATE]).keys();
    }
    values() {
      const IA = this.keys();
      return {
        [Symbol.iterator]: () => this.values(),
        next: () => {
          const CA = IA.next();
          return CA.done ? CA : {
            done: !1,
            value: this.get(CA.value)
          };
        }
      };
    }
    entries() {
      const IA = this.keys();
      return {
        [Symbol.iterator]: () => this.entries(),
        next: () => {
          const CA = IA.next();
          if (CA.done)
            return CA;
          const BA = this.get(CA.value);
          return {
            done: !1,
            value: [CA.value, BA]
          };
        }
      };
    }
    [Symbol.iterator]() {
      return this.entries();
    }
  }
  function t(gA, IA) {
    return new n(gA, IA);
  }
  function g(gA) {
    gA.copy_ || (gA.assigned_ = /* @__PURE__ */ new Map(), gA.copy_ = new Map(gA.base_));
  }
  class d extends Set {
    constructor(IA, CA) {
      super(), this[DRAFT_STATE] = {
        type_: 3,
        parent_: CA,
        scope_: CA ? CA.scope_ : getCurrentScope(),
        modified_: !1,
        finalized_: !1,
        copy_: void 0,
        base_: IA,
        draft_: this,
        drafts_: /* @__PURE__ */ new Map(),
        revoked_: !1,
        isManual_: !1
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(IA) {
      const CA = this[DRAFT_STATE];
      return AA(CA), CA.copy_ ? !!(CA.copy_.has(IA) || CA.drafts_.has(IA) && CA.copy_.has(CA.drafts_.get(IA))) : CA.base_.has(IA);
    }
    add(IA) {
      const CA = this[DRAFT_STATE];
      return AA(CA), this.has(IA) || (H(CA), markChanged(CA), CA.copy_.add(IA)), this;
    }
    delete(IA) {
      if (!this.has(IA))
        return !1;
      const CA = this[DRAFT_STATE];
      return AA(CA), H(CA), markChanged(CA), CA.copy_.delete(IA) || (CA.drafts_.has(IA) ? CA.copy_.delete(CA.drafts_.get(IA)) : (
        /* istanbul ignore next */
        !1
      ));
    }
    clear() {
      const IA = this[DRAFT_STATE];
      AA(IA), latest(IA).size && (H(IA), markChanged(IA), IA.copy_.clear());
    }
    values() {
      const IA = this[DRAFT_STATE];
      return AA(IA), H(IA), IA.copy_.values();
    }
    entries() {
      const IA = this[DRAFT_STATE];
      return AA(IA), H(IA), IA.copy_.entries();
    }
    keys() {
      return this.values();
    }
    [Symbol.iterator]() {
      return this.values();
    }
    forEach(IA, CA) {
      const BA = this.values();
      let eA = BA.next();
      for (; !eA.done; )
        IA.call(CA, eA.value, eA.value, this), eA = BA.next();
    }
  }
  function k(gA, IA) {
    return new d(gA, IA);
  }
  function H(gA) {
    gA.copy_ || (gA.copy_ = /* @__PURE__ */ new Set(), gA.base_.forEach((IA) => {
      if (isDraftable(IA)) {
        const CA = createProxy(IA, gA);
        gA.drafts_.set(IA, CA), gA.copy_.add(CA);
      } else
        gA.copy_.add(IA);
    }));
  }
  function AA(gA) {
    gA.revoked_ && die(3, JSON.stringify(latest(gA)));
  }
  loadPlugin("MapSet", { proxyMap_: t, proxySet_: k });
}
var immer = new Immer2(), produce = immer.produce;
const handlePreserveConsecutiveUppercase = (n, t) => (n = n.replace(
  new RegExp("((?<![\\p{Uppercase_Letter}\\d])[\\p{Uppercase_Letter}\\d](?![\\p{Uppercase_Letter}\\d]))", "gu"),
  (g) => g.toLowerCase()
), n.replace(
  new RegExp("(?<!\\p{Uppercase_Letter})(\\p{Uppercase_Letter}+)(\\p{Uppercase_Letter}\\p{Lowercase_Letter}+)", "gu"),
  (g, d, k) => d + t + k.toLowerCase()
));
function decamelize$1(n, {
  separator: t = "_",
  preserveConsecutiveUppercase: g = !1
} = {}) {
  if (!(typeof n == "string" && typeof t == "string"))
    throw new TypeError(
      "The `text` and `separator` arguments should be of type `string`"
    );
  if (n.length < 2)
    return g ? n : n.toLowerCase();
  const d = `$1${t}$2`, k = n.replace(
    new RegExp("([\\p{Lowercase_Letter}\\d])(\\p{Uppercase_Letter})", "gu"),
    d
  );
  return g ? handlePreserveConsecutiveUppercase(k, t) : k.replace(
    new RegExp("(\\p{Uppercase_Letter})(\\p{Uppercase_Letter}\\p{Lowercase_Letter}+)", "gu"),
    d
  ).toLowerCase();
}
var isArray_1, hasRequiredIsArray;
function requireIsArray() {
  if (hasRequiredIsArray) return isArray_1;
  hasRequiredIsArray = 1;
  var n = Array.isArray;
  return isArray_1 = n, isArray_1;
}
var _freeGlobal, hasRequired_freeGlobal;
function require_freeGlobal() {
  if (hasRequired_freeGlobal) return _freeGlobal;
  hasRequired_freeGlobal = 1;
  var n = typeof commonjsGlobal$2 == "object" && commonjsGlobal$2 && commonjsGlobal$2.Object === Object && commonjsGlobal$2;
  return _freeGlobal = n, _freeGlobal;
}
var _root, hasRequired_root;
function require_root() {
  if (hasRequired_root) return _root;
  hasRequired_root = 1;
  var n = require_freeGlobal(), t = typeof self == "object" && self && self.Object === Object && self, g = n || t || Function("return this")();
  return _root = g, _root;
}
var _Symbol, hasRequired_Symbol;
function require_Symbol() {
  if (hasRequired_Symbol) return _Symbol;
  hasRequired_Symbol = 1;
  var n = require_root(), t = n.Symbol;
  return _Symbol = t, _Symbol;
}
var _getRawTag, hasRequired_getRawTag;
function require_getRawTag() {
  if (hasRequired_getRawTag) return _getRawTag;
  hasRequired_getRawTag = 1;
  var n = require_Symbol(), t = Object.prototype, g = t.hasOwnProperty, d = t.toString, k = n ? n.toStringTag : void 0;
  function H(AA) {
    var gA = g.call(AA, k), IA = AA[k];
    try {
      AA[k] = void 0;
      var CA = !0;
    } catch {
    }
    var BA = d.call(AA);
    return CA && (gA ? AA[k] = IA : delete AA[k]), BA;
  }
  return _getRawTag = H, _getRawTag;
}
var _objectToString, hasRequired_objectToString;
function require_objectToString() {
  if (hasRequired_objectToString) return _objectToString;
  hasRequired_objectToString = 1;
  var n = Object.prototype, t = n.toString;
  function g(d) {
    return t.call(d);
  }
  return _objectToString = g, _objectToString;
}
var _baseGetTag, hasRequired_baseGetTag;
function require_baseGetTag() {
  if (hasRequired_baseGetTag) return _baseGetTag;
  hasRequired_baseGetTag = 1;
  var n = require_Symbol(), t = require_getRawTag(), g = require_objectToString(), d = "[object Null]", k = "[object Undefined]", H = n ? n.toStringTag : void 0;
  function AA(gA) {
    return gA == null ? gA === void 0 ? k : d : H && H in Object(gA) ? t(gA) : g(gA);
  }
  return _baseGetTag = AA, _baseGetTag;
}
var isObjectLike_1, hasRequiredIsObjectLike;
function requireIsObjectLike() {
  if (hasRequiredIsObjectLike) return isObjectLike_1;
  hasRequiredIsObjectLike = 1;
  function n(t) {
    return t != null && typeof t == "object";
  }
  return isObjectLike_1 = n, isObjectLike_1;
}
var isSymbol_1, hasRequiredIsSymbol;
function requireIsSymbol() {
  if (hasRequiredIsSymbol) return isSymbol_1;
  hasRequiredIsSymbol = 1;
  var n = require_baseGetTag(), t = requireIsObjectLike(), g = "[object Symbol]";
  function d(k) {
    return typeof k == "symbol" || t(k) && n(k) == g;
  }
  return isSymbol_1 = d, isSymbol_1;
}
var _isKey, hasRequired_isKey;
function require_isKey() {
  if (hasRequired_isKey) return _isKey;
  hasRequired_isKey = 1;
  var n = requireIsArray(), t = requireIsSymbol(), g = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, d = /^\w*$/;
  function k(H, AA) {
    if (n(H))
      return !1;
    var gA = typeof H;
    return gA == "number" || gA == "symbol" || gA == "boolean" || H == null || t(H) ? !0 : d.test(H) || !g.test(H) || AA != null && H in Object(AA);
  }
  return _isKey = k, _isKey;
}
var isObject_1, hasRequiredIsObject;
function requireIsObject() {
  if (hasRequiredIsObject) return isObject_1;
  hasRequiredIsObject = 1;
  function n(t) {
    var g = typeof t;
    return t != null && (g == "object" || g == "function");
  }
  return isObject_1 = n, isObject_1;
}
var isFunction_1, hasRequiredIsFunction;
function requireIsFunction() {
  if (hasRequiredIsFunction) return isFunction_1;
  hasRequiredIsFunction = 1;
  var n = require_baseGetTag(), t = requireIsObject(), g = "[object AsyncFunction]", d = "[object Function]", k = "[object GeneratorFunction]", H = "[object Proxy]";
  function AA(gA) {
    if (!t(gA))
      return !1;
    var IA = n(gA);
    return IA == d || IA == k || IA == g || IA == H;
  }
  return isFunction_1 = AA, isFunction_1;
}
var _coreJsData, hasRequired_coreJsData;
function require_coreJsData() {
  if (hasRequired_coreJsData) return _coreJsData;
  hasRequired_coreJsData = 1;
  var n = require_root(), t = n["__core-js_shared__"];
  return _coreJsData = t, _coreJsData;
}
var _isMasked, hasRequired_isMasked;
function require_isMasked() {
  if (hasRequired_isMasked) return _isMasked;
  hasRequired_isMasked = 1;
  var n = require_coreJsData(), t = (function() {
    var d = /[^.]+$/.exec(n && n.keys && n.keys.IE_PROTO || "");
    return d ? "Symbol(src)_1." + d : "";
  })();
  function g(d) {
    return !!t && t in d;
  }
  return _isMasked = g, _isMasked;
}
var _toSource, hasRequired_toSource;
function require_toSource() {
  if (hasRequired_toSource) return _toSource;
  hasRequired_toSource = 1;
  var n = Function.prototype, t = n.toString;
  function g(d) {
    if (d != null) {
      try {
        return t.call(d);
      } catch {
      }
      try {
        return d + "";
      } catch {
      }
    }
    return "";
  }
  return _toSource = g, _toSource;
}
var _baseIsNative, hasRequired_baseIsNative;
function require_baseIsNative() {
  if (hasRequired_baseIsNative) return _baseIsNative;
  hasRequired_baseIsNative = 1;
  var n = requireIsFunction(), t = require_isMasked(), g = requireIsObject(), d = require_toSource(), k = /[\\^$.*+?()[\]{}|]/g, H = /^\[object .+?Constructor\]$/, AA = Function.prototype, gA = Object.prototype, IA = AA.toString, CA = gA.hasOwnProperty, BA = RegExp(
    "^" + IA.call(CA).replace(k, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function eA(iA) {
    if (!g(iA) || t(iA))
      return !1;
    var QA = n(iA) ? BA : H;
    return QA.test(d(iA));
  }
  return _baseIsNative = eA, _baseIsNative;
}
var _getValue, hasRequired_getValue;
function require_getValue() {
  if (hasRequired_getValue) return _getValue;
  hasRequired_getValue = 1;
  function n(t, g) {
    return t?.[g];
  }
  return _getValue = n, _getValue;
}
var _getNative, hasRequired_getNative;
function require_getNative() {
  if (hasRequired_getNative) return _getNative;
  hasRequired_getNative = 1;
  var n = require_baseIsNative(), t = require_getValue();
  function g(d, k) {
    var H = t(d, k);
    return n(H) ? H : void 0;
  }
  return _getNative = g, _getNative;
}
var _nativeCreate, hasRequired_nativeCreate;
function require_nativeCreate() {
  if (hasRequired_nativeCreate) return _nativeCreate;
  hasRequired_nativeCreate = 1;
  var n = require_getNative(), t = n(Object, "create");
  return _nativeCreate = t, _nativeCreate;
}
var _hashClear, hasRequired_hashClear;
function require_hashClear() {
  if (hasRequired_hashClear) return _hashClear;
  hasRequired_hashClear = 1;
  var n = require_nativeCreate();
  function t() {
    this.__data__ = n ? n(null) : {}, this.size = 0;
  }
  return _hashClear = t, _hashClear;
}
var _hashDelete, hasRequired_hashDelete;
function require_hashDelete() {
  if (hasRequired_hashDelete) return _hashDelete;
  hasRequired_hashDelete = 1;
  function n(t) {
    var g = this.has(t) && delete this.__data__[t];
    return this.size -= g ? 1 : 0, g;
  }
  return _hashDelete = n, _hashDelete;
}
var _hashGet, hasRequired_hashGet;
function require_hashGet() {
  if (hasRequired_hashGet) return _hashGet;
  hasRequired_hashGet = 1;
  var n = require_nativeCreate(), t = "__lodash_hash_undefined__", g = Object.prototype, d = g.hasOwnProperty;
  function k(H) {
    var AA = this.__data__;
    if (n) {
      var gA = AA[H];
      return gA === t ? void 0 : gA;
    }
    return d.call(AA, H) ? AA[H] : void 0;
  }
  return _hashGet = k, _hashGet;
}
var _hashHas, hasRequired_hashHas;
function require_hashHas() {
  if (hasRequired_hashHas) return _hashHas;
  hasRequired_hashHas = 1;
  var n = require_nativeCreate(), t = Object.prototype, g = t.hasOwnProperty;
  function d(k) {
    var H = this.__data__;
    return n ? H[k] !== void 0 : g.call(H, k);
  }
  return _hashHas = d, _hashHas;
}
var _hashSet, hasRequired_hashSet;
function require_hashSet() {
  if (hasRequired_hashSet) return _hashSet;
  hasRequired_hashSet = 1;
  var n = require_nativeCreate(), t = "__lodash_hash_undefined__";
  function g(d, k) {
    var H = this.__data__;
    return this.size += this.has(d) ? 0 : 1, H[d] = n && k === void 0 ? t : k, this;
  }
  return _hashSet = g, _hashSet;
}
var _Hash, hasRequired_Hash;
function require_Hash() {
  if (hasRequired_Hash) return _Hash;
  hasRequired_Hash = 1;
  var n = require_hashClear(), t = require_hashDelete(), g = require_hashGet(), d = require_hashHas(), k = require_hashSet();
  function H(AA) {
    var gA = -1, IA = AA == null ? 0 : AA.length;
    for (this.clear(); ++gA < IA; ) {
      var CA = AA[gA];
      this.set(CA[0], CA[1]);
    }
  }
  return H.prototype.clear = n, H.prototype.delete = t, H.prototype.get = g, H.prototype.has = d, H.prototype.set = k, _Hash = H, _Hash;
}
var _listCacheClear, hasRequired_listCacheClear;
function require_listCacheClear() {
  if (hasRequired_listCacheClear) return _listCacheClear;
  hasRequired_listCacheClear = 1;
  function n() {
    this.__data__ = [], this.size = 0;
  }
  return _listCacheClear = n, _listCacheClear;
}
var eq_1$1, hasRequiredEq$1;
function requireEq$1() {
  if (hasRequiredEq$1) return eq_1$1;
  hasRequiredEq$1 = 1;
  function n(t, g) {
    return t === g || t !== t && g !== g;
  }
  return eq_1$1 = n, eq_1$1;
}
var _assocIndexOf, hasRequired_assocIndexOf;
function require_assocIndexOf() {
  if (hasRequired_assocIndexOf) return _assocIndexOf;
  hasRequired_assocIndexOf = 1;
  var n = requireEq$1();
  function t(g, d) {
    for (var k = g.length; k--; )
      if (n(g[k][0], d))
        return k;
    return -1;
  }
  return _assocIndexOf = t, _assocIndexOf;
}
var _listCacheDelete, hasRequired_listCacheDelete;
function require_listCacheDelete() {
  if (hasRequired_listCacheDelete) return _listCacheDelete;
  hasRequired_listCacheDelete = 1;
  var n = require_assocIndexOf(), t = Array.prototype, g = t.splice;
  function d(k) {
    var H = this.__data__, AA = n(H, k);
    if (AA < 0)
      return !1;
    var gA = H.length - 1;
    return AA == gA ? H.pop() : g.call(H, AA, 1), --this.size, !0;
  }
  return _listCacheDelete = d, _listCacheDelete;
}
var _listCacheGet, hasRequired_listCacheGet;
function require_listCacheGet() {
  if (hasRequired_listCacheGet) return _listCacheGet;
  hasRequired_listCacheGet = 1;
  var n = require_assocIndexOf();
  function t(g) {
    var d = this.__data__, k = n(d, g);
    return k < 0 ? void 0 : d[k][1];
  }
  return _listCacheGet = t, _listCacheGet;
}
var _listCacheHas, hasRequired_listCacheHas;
function require_listCacheHas() {
  if (hasRequired_listCacheHas) return _listCacheHas;
  hasRequired_listCacheHas = 1;
  var n = require_assocIndexOf();
  function t(g) {
    return n(this.__data__, g) > -1;
  }
  return _listCacheHas = t, _listCacheHas;
}
var _listCacheSet, hasRequired_listCacheSet;
function require_listCacheSet() {
  if (hasRequired_listCacheSet) return _listCacheSet;
  hasRequired_listCacheSet = 1;
  var n = require_assocIndexOf();
  function t(g, d) {
    var k = this.__data__, H = n(k, g);
    return H < 0 ? (++this.size, k.push([g, d])) : k[H][1] = d, this;
  }
  return _listCacheSet = t, _listCacheSet;
}
var _ListCache, hasRequired_ListCache;
function require_ListCache() {
  if (hasRequired_ListCache) return _ListCache;
  hasRequired_ListCache = 1;
  var n = require_listCacheClear(), t = require_listCacheDelete(), g = require_listCacheGet(), d = require_listCacheHas(), k = require_listCacheSet();
  function H(AA) {
    var gA = -1, IA = AA == null ? 0 : AA.length;
    for (this.clear(); ++gA < IA; ) {
      var CA = AA[gA];
      this.set(CA[0], CA[1]);
    }
  }
  return H.prototype.clear = n, H.prototype.delete = t, H.prototype.get = g, H.prototype.has = d, H.prototype.set = k, _ListCache = H, _ListCache;
}
var _Map, hasRequired_Map;
function require_Map() {
  if (hasRequired_Map) return _Map;
  hasRequired_Map = 1;
  var n = require_getNative(), t = require_root(), g = n(t, "Map");
  return _Map = g, _Map;
}
var _mapCacheClear, hasRequired_mapCacheClear;
function require_mapCacheClear() {
  if (hasRequired_mapCacheClear) return _mapCacheClear;
  hasRequired_mapCacheClear = 1;
  var n = require_Hash(), t = require_ListCache(), g = require_Map();
  function d() {
    this.size = 0, this.__data__ = {
      hash: new n(),
      map: new (g || t)(),
      string: new n()
    };
  }
  return _mapCacheClear = d, _mapCacheClear;
}
var _isKeyable, hasRequired_isKeyable;
function require_isKeyable() {
  if (hasRequired_isKeyable) return _isKeyable;
  hasRequired_isKeyable = 1;
  function n(t) {
    var g = typeof t;
    return g == "string" || g == "number" || g == "symbol" || g == "boolean" ? t !== "__proto__" : t === null;
  }
  return _isKeyable = n, _isKeyable;
}
var _getMapData, hasRequired_getMapData;
function require_getMapData() {
  if (hasRequired_getMapData) return _getMapData;
  hasRequired_getMapData = 1;
  var n = require_isKeyable();
  function t(g, d) {
    var k = g.__data__;
    return n(d) ? k[typeof d == "string" ? "string" : "hash"] : k.map;
  }
  return _getMapData = t, _getMapData;
}
var _mapCacheDelete, hasRequired_mapCacheDelete;
function require_mapCacheDelete() {
  if (hasRequired_mapCacheDelete) return _mapCacheDelete;
  hasRequired_mapCacheDelete = 1;
  var n = require_getMapData();
  function t(g) {
    var d = n(this, g).delete(g);
    return this.size -= d ? 1 : 0, d;
  }
  return _mapCacheDelete = t, _mapCacheDelete;
}
var _mapCacheGet, hasRequired_mapCacheGet;
function require_mapCacheGet() {
  if (hasRequired_mapCacheGet) return _mapCacheGet;
  hasRequired_mapCacheGet = 1;
  var n = require_getMapData();
  function t(g) {
    return n(this, g).get(g);
  }
  return _mapCacheGet = t, _mapCacheGet;
}
var _mapCacheHas, hasRequired_mapCacheHas;
function require_mapCacheHas() {
  if (hasRequired_mapCacheHas) return _mapCacheHas;
  hasRequired_mapCacheHas = 1;
  var n = require_getMapData();
  function t(g) {
    return n(this, g).has(g);
  }
  return _mapCacheHas = t, _mapCacheHas;
}
var _mapCacheSet, hasRequired_mapCacheSet;
function require_mapCacheSet() {
  if (hasRequired_mapCacheSet) return _mapCacheSet;
  hasRequired_mapCacheSet = 1;
  var n = require_getMapData();
  function t(g, d) {
    var k = n(this, g), H = k.size;
    return k.set(g, d), this.size += k.size == H ? 0 : 1, this;
  }
  return _mapCacheSet = t, _mapCacheSet;
}
var _MapCache, hasRequired_MapCache;
function require_MapCache() {
  if (hasRequired_MapCache) return _MapCache;
  hasRequired_MapCache = 1;
  var n = require_mapCacheClear(), t = require_mapCacheDelete(), g = require_mapCacheGet(), d = require_mapCacheHas(), k = require_mapCacheSet();
  function H(AA) {
    var gA = -1, IA = AA == null ? 0 : AA.length;
    for (this.clear(); ++gA < IA; ) {
      var CA = AA[gA];
      this.set(CA[0], CA[1]);
    }
  }
  return H.prototype.clear = n, H.prototype.delete = t, H.prototype.get = g, H.prototype.has = d, H.prototype.set = k, _MapCache = H, _MapCache;
}
var memoize_1, hasRequiredMemoize;
function requireMemoize() {
  if (hasRequiredMemoize) return memoize_1;
  hasRequiredMemoize = 1;
  var n = require_MapCache(), t = "Expected a function";
  function g(d, k) {
    if (typeof d != "function" || k != null && typeof k != "function")
      throw new TypeError(t);
    var H = function() {
      var AA = arguments, gA = k ? k.apply(this, AA) : AA[0], IA = H.cache;
      if (IA.has(gA))
        return IA.get(gA);
      var CA = d.apply(this, AA);
      return H.cache = IA.set(gA, CA) || IA, CA;
    };
    return H.cache = new (g.Cache || n)(), H;
  }
  return g.Cache = n, memoize_1 = g, memoize_1;
}
var _memoizeCapped, hasRequired_memoizeCapped;
function require_memoizeCapped() {
  if (hasRequired_memoizeCapped) return _memoizeCapped;
  hasRequired_memoizeCapped = 1;
  var n = requireMemoize(), t = 500;
  function g(d) {
    var k = n(d, function(AA) {
      return H.size === t && H.clear(), AA;
    }), H = k.cache;
    return k;
  }
  return _memoizeCapped = g, _memoizeCapped;
}
var _stringToPath, hasRequired_stringToPath;
function require_stringToPath() {
  if (hasRequired_stringToPath) return _stringToPath;
  hasRequired_stringToPath = 1;
  var n = require_memoizeCapped(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, g = /\\(\\)?/g, d = n(function(k) {
    var H = [];
    return k.charCodeAt(0) === 46 && H.push(""), k.replace(t, function(AA, gA, IA, CA) {
      H.push(IA ? CA.replace(g, "$1") : gA || AA);
    }), H;
  });
  return _stringToPath = d, _stringToPath;
}
var _arrayMap, hasRequired_arrayMap;
function require_arrayMap() {
  if (hasRequired_arrayMap) return _arrayMap;
  hasRequired_arrayMap = 1;
  function n(t, g) {
    for (var d = -1, k = t == null ? 0 : t.length, H = Array(k); ++d < k; )
      H[d] = g(t[d], d, t);
    return H;
  }
  return _arrayMap = n, _arrayMap;
}
var _baseToString, hasRequired_baseToString;
function require_baseToString() {
  if (hasRequired_baseToString) return _baseToString;
  hasRequired_baseToString = 1;
  var n = require_Symbol(), t = require_arrayMap(), g = requireIsArray(), d = requireIsSymbol(), k = n ? n.prototype : void 0, H = k ? k.toString : void 0;
  function AA(gA) {
    if (typeof gA == "string")
      return gA;
    if (g(gA))
      return t(gA, AA) + "";
    if (d(gA))
      return H ? H.call(gA) : "";
    var IA = gA + "";
    return IA == "0" && 1 / gA == -1 / 0 ? "-0" : IA;
  }
  return _baseToString = AA, _baseToString;
}
var toString_1, hasRequiredToString;
function requireToString() {
  if (hasRequiredToString) return toString_1;
  hasRequiredToString = 1;
  var n = require_baseToString();
  function t(g) {
    return g == null ? "" : n(g);
  }
  return toString_1 = t, toString_1;
}
var _castPath, hasRequired_castPath;
function require_castPath() {
  if (hasRequired_castPath) return _castPath;
  hasRequired_castPath = 1;
  var n = requireIsArray(), t = require_isKey(), g = require_stringToPath(), d = requireToString();
  function k(H, AA) {
    return n(H) ? H : t(H, AA) ? [H] : g(d(H));
  }
  return _castPath = k, _castPath;
}
var _toKey, hasRequired_toKey;
function require_toKey() {
  if (hasRequired_toKey) return _toKey;
  hasRequired_toKey = 1;
  var n = requireIsSymbol();
  function t(g) {
    if (typeof g == "string" || n(g))
      return g;
    var d = g + "";
    return d == "0" && 1 / g == -1 / 0 ? "-0" : d;
  }
  return _toKey = t, _toKey;
}
var _baseGet, hasRequired_baseGet;
function require_baseGet() {
  if (hasRequired_baseGet) return _baseGet;
  hasRequired_baseGet = 1;
  var n = require_castPath(), t = require_toKey();
  function g(d, k) {
    k = n(k, d);
    for (var H = 0, AA = k.length; d != null && H < AA; )
      d = d[t(k[H++])];
    return H && H == AA ? d : void 0;
  }
  return _baseGet = g, _baseGet;
}
var get_1, hasRequiredGet;
function requireGet() {
  if (hasRequiredGet) return get_1;
  hasRequiredGet = 1;
  var n = require_baseGet();
  function t(g, d, k) {
    var H = g == null ? void 0 : n(g, d);
    return H === void 0 ? k : H;
  }
  return get_1 = t, get_1;
}
var getExports = requireGet();
const get$9 = /* @__PURE__ */ getDefaultExportFromCjs$2(getExports);
var cuint = {}, uint32$1 = { exports: {} }, uint32 = uint32$1.exports, hasRequiredUint32;
function requireUint32() {
  return hasRequiredUint32 || (hasRequiredUint32 = 1, (function(n) {
    (function(t) {
      g(Math.pow(36, 5)), g(Math.pow(16, 7)), g(Math.pow(10, 9)), g(Math.pow(2, 30)), g(36), g(16), g(10), g(2);
      function g(AA, gA) {
        if (!(this instanceof g))
          return new g(AA, gA);
        if (this._low = 0, this._high = 0, this.remainder = null, typeof gA > "u")
          return k.call(this, AA);
        if (typeof AA == "string")
          return H.call(this, AA, gA);
        d.call(this, AA, gA);
      }
      function d(AA, gA) {
        return this._low = AA | 0, this._high = gA | 0, this;
      }
      g.prototype.fromBits = d;
      function k(AA) {
        return this._low = AA & 65535, this._high = AA >>> 16, this;
      }
      g.prototype.fromNumber = k;
      function H(AA, gA) {
        var IA = parseInt(AA, gA || 10);
        return this._low = IA & 65535, this._high = IA >>> 16, this;
      }
      g.prototype.fromString = H, g.prototype.toNumber = function() {
        return this._high * 65536 + this._low;
      }, g.prototype.toString = function(AA) {
        return this.toNumber().toString(AA || 10);
      }, g.prototype.add = function(AA) {
        var gA = this._low + AA._low, IA = gA >>> 16;
        return IA += this._high + AA._high, this._low = gA & 65535, this._high = IA & 65535, this;
      }, g.prototype.subtract = function(AA) {
        return this.add(AA.clone().negate());
      }, g.prototype.multiply = function(AA) {
        var gA = this._high, IA = this._low, CA = AA._high, BA = AA._low, eA, iA;
        return iA = IA * BA, eA = iA >>> 16, eA += gA * BA, eA &= 65535, eA += IA * CA, this._low = iA & 65535, this._high = eA & 65535, this;
      }, g.prototype.div = function(AA) {
        if (AA._low == 0 && AA._high == 0) throw Error("division by zero");
        if (AA._high == 0 && AA._low == 1)
          return this.remainder = new g(0), this;
        if (AA.gt(this))
          return this.remainder = this.clone(), this._low = 0, this._high = 0, this;
        if (this.eq(AA))
          return this.remainder = new g(0), this._low = 1, this._high = 0, this;
        for (var gA = AA.clone(), IA = -1; !this.lt(gA); )
          gA.shiftLeft(1, !0), IA++;
        for (this.remainder = this.clone(), this._low = 0, this._high = 0; IA >= 0; IA--)
          gA.shiftRight(1), this.remainder.lt(gA) || (this.remainder.subtract(gA), IA >= 16 ? this._high |= 1 << IA - 16 : this._low |= 1 << IA);
        return this;
      }, g.prototype.negate = function() {
        var AA = (~this._low & 65535) + 1;
        return this._low = AA & 65535, this._high = ~this._high + (AA >>> 16) & 65535, this;
      }, g.prototype.equals = g.prototype.eq = function(AA) {
        return this._low == AA._low && this._high == AA._high;
      }, g.prototype.greaterThan = g.prototype.gt = function(AA) {
        return this._high > AA._high ? !0 : this._high < AA._high ? !1 : this._low > AA._low;
      }, g.prototype.lessThan = g.prototype.lt = function(AA) {
        return this._high < AA._high ? !0 : this._high > AA._high ? !1 : this._low < AA._low;
      }, g.prototype.or = function(AA) {
        return this._low |= AA._low, this._high |= AA._high, this;
      }, g.prototype.and = function(AA) {
        return this._low &= AA._low, this._high &= AA._high, this;
      }, g.prototype.not = function() {
        return this._low = ~this._low & 65535, this._high = ~this._high & 65535, this;
      }, g.prototype.xor = function(AA) {
        return this._low ^= AA._low, this._high ^= AA._high, this;
      }, g.prototype.shiftRight = g.prototype.shiftr = function(AA) {
        return AA > 16 ? (this._low = this._high >> AA - 16, this._high = 0) : AA == 16 ? (this._low = this._high, this._high = 0) : (this._low = this._low >> AA | this._high << 16 - AA & 65535, this._high >>= AA), this;
      }, g.prototype.shiftLeft = g.prototype.shiftl = function(AA, gA) {
        return AA > 16 ? (this._high = this._low << AA - 16, this._low = 0, gA || (this._high &= 65535)) : AA == 16 ? (this._high = this._low, this._low = 0) : (this._high = this._high << AA | this._low >> 16 - AA, this._low = this._low << AA & 65535, gA || (this._high &= 65535)), this;
      }, g.prototype.rotateLeft = g.prototype.rotl = function(AA) {
        var gA = this._high << 16 | this._low;
        return gA = gA << AA | gA >>> 32 - AA, this._low = gA & 65535, this._high = gA >>> 16, this;
      }, g.prototype.rotateRight = g.prototype.rotr = function(AA) {
        var gA = this._high << 16 | this._low;
        return gA = gA >>> AA | gA << 32 - AA, this._low = gA & 65535, this._high = gA >>> 16, this;
      }, g.prototype.clone = function() {
        return new g(this._low, this._high);
      }, n.exports ? n.exports = g : t.UINT32 = g;
    })(uint32);
  })(uint32$1)), uint32$1.exports;
}
var uint64$1 = { exports: {} }, uint64 = uint64$1.exports, hasRequiredUint64;
function requireUint64() {
  return hasRequiredUint64 || (hasRequiredUint64 = 1, (function(n) {
    (function(t) {
      var g = {
        16: k(Math.pow(16, 5)),
        10: k(Math.pow(10, 5)),
        2: k(Math.pow(2, 5))
      }, d = {
        16: k(16),
        10: k(10),
        2: k(2)
      };
      function k(IA, CA, BA, eA) {
        if (!(this instanceof k))
          return new k(IA, CA, BA, eA);
        if (this.remainder = null, typeof IA == "string")
          return gA.call(this, IA, CA);
        if (typeof CA > "u")
          return AA.call(this, IA);
        H.apply(this, arguments);
      }
      function H(IA, CA, BA, eA) {
        return typeof BA > "u" ? (this._a00 = IA & 65535, this._a16 = IA >>> 16, this._a32 = CA & 65535, this._a48 = CA >>> 16, this) : (this._a00 = IA | 0, this._a16 = CA | 0, this._a32 = BA | 0, this._a48 = eA | 0, this);
      }
      k.prototype.fromBits = H;
      function AA(IA) {
        return this._a00 = IA & 65535, this._a16 = IA >>> 16, this._a32 = 0, this._a48 = 0, this;
      }
      k.prototype.fromNumber = AA;
      function gA(IA, CA) {
        CA = CA || 10, this._a00 = 0, this._a16 = 0, this._a32 = 0, this._a48 = 0;
        for (var BA = g[CA] || new k(Math.pow(CA, 5)), eA = 0, iA = IA.length; eA < iA; eA += 5) {
          var QA = Math.min(5, iA - eA), tA = parseInt(IA.slice(eA, eA + QA), CA);
          this.multiply(
            QA < 5 ? new k(Math.pow(CA, QA)) : BA
          ).add(new k(tA));
        }
        return this;
      }
      k.prototype.fromString = gA, k.prototype.toNumber = function() {
        return this._a16 * 65536 + this._a00;
      }, k.prototype.toString = function(IA) {
        IA = IA || 10;
        var CA = d[IA] || new k(IA);
        if (!this.gt(CA)) return this.toNumber().toString(IA);
        for (var BA = this.clone(), eA = new Array(64), iA = 63; iA >= 0 && (BA.div(CA), eA[iA] = BA.remainder.toNumber().toString(IA), !!BA.gt(CA)); iA--)
          ;
        return eA[iA - 1] = BA.toNumber().toString(IA), eA.join("");
      }, k.prototype.add = function(IA) {
        var CA = this._a00 + IA._a00, BA = CA >>> 16;
        BA += this._a16 + IA._a16;
        var eA = BA >>> 16;
        eA += this._a32 + IA._a32;
        var iA = eA >>> 16;
        return iA += this._a48 + IA._a48, this._a00 = CA & 65535, this._a16 = BA & 65535, this._a32 = eA & 65535, this._a48 = iA & 65535, this;
      }, k.prototype.subtract = function(IA) {
        return this.add(IA.clone().negate());
      }, k.prototype.multiply = function(IA) {
        var CA = this._a00, BA = this._a16, eA = this._a32, iA = this._a48, QA = IA._a00, tA = IA._a16, oA = IA._a32, EA = IA._a48, aA = CA * QA, nA = aA >>> 16;
        nA += CA * tA;
        var lA = nA >>> 16;
        nA &= 65535, nA += BA * QA, lA += nA >>> 16, lA += CA * oA;
        var cA = lA >>> 16;
        return lA &= 65535, lA += BA * tA, cA += lA >>> 16, lA &= 65535, lA += eA * QA, cA += lA >>> 16, cA += CA * EA, cA &= 65535, cA += BA * oA, cA &= 65535, cA += eA * tA, cA &= 65535, cA += iA * QA, this._a00 = aA & 65535, this._a16 = nA & 65535, this._a32 = lA & 65535, this._a48 = cA & 65535, this;
      }, k.prototype.div = function(IA) {
        if (IA._a16 == 0 && IA._a32 == 0 && IA._a48 == 0) {
          if (IA._a00 == 0) throw Error("division by zero");
          if (IA._a00 == 1)
            return this.remainder = new k(0), this;
        }
        if (IA.gt(this))
          return this.remainder = this.clone(), this._a00 = 0, this._a16 = 0, this._a32 = 0, this._a48 = 0, this;
        if (this.eq(IA))
          return this.remainder = new k(0), this._a00 = 1, this._a16 = 0, this._a32 = 0, this._a48 = 0, this;
        for (var CA = IA.clone(), BA = -1; !this.lt(CA); )
          CA.shiftLeft(1, !0), BA++;
        for (this.remainder = this.clone(), this._a00 = 0, this._a16 = 0, this._a32 = 0, this._a48 = 0; BA >= 0; BA--)
          CA.shiftRight(1), this.remainder.lt(CA) || (this.remainder.subtract(CA), BA >= 48 ? this._a48 |= 1 << BA - 48 : BA >= 32 ? this._a32 |= 1 << BA - 32 : BA >= 16 ? this._a16 |= 1 << BA - 16 : this._a00 |= 1 << BA);
        return this;
      }, k.prototype.negate = function() {
        var IA = (~this._a00 & 65535) + 1;
        return this._a00 = IA & 65535, IA = (~this._a16 & 65535) + (IA >>> 16), this._a16 = IA & 65535, IA = (~this._a32 & 65535) + (IA >>> 16), this._a32 = IA & 65535, this._a48 = ~this._a48 + (IA >>> 16) & 65535, this;
      }, k.prototype.equals = k.prototype.eq = function(IA) {
        return this._a48 == IA._a48 && this._a00 == IA._a00 && this._a32 == IA._a32 && this._a16 == IA._a16;
      }, k.prototype.greaterThan = k.prototype.gt = function(IA) {
        return this._a48 > IA._a48 ? !0 : this._a48 < IA._a48 ? !1 : this._a32 > IA._a32 ? !0 : this._a32 < IA._a32 ? !1 : this._a16 > IA._a16 ? !0 : this._a16 < IA._a16 ? !1 : this._a00 > IA._a00;
      }, k.prototype.lessThan = k.prototype.lt = function(IA) {
        return this._a48 < IA._a48 ? !0 : this._a48 > IA._a48 ? !1 : this._a32 < IA._a32 ? !0 : this._a32 > IA._a32 ? !1 : this._a16 < IA._a16 ? !0 : this._a16 > IA._a16 ? !1 : this._a00 < IA._a00;
      }, k.prototype.or = function(IA) {
        return this._a00 |= IA._a00, this._a16 |= IA._a16, this._a32 |= IA._a32, this._a48 |= IA._a48, this;
      }, k.prototype.and = function(IA) {
        return this._a00 &= IA._a00, this._a16 &= IA._a16, this._a32 &= IA._a32, this._a48 &= IA._a48, this;
      }, k.prototype.xor = function(IA) {
        return this._a00 ^= IA._a00, this._a16 ^= IA._a16, this._a32 ^= IA._a32, this._a48 ^= IA._a48, this;
      }, k.prototype.not = function() {
        return this._a00 = ~this._a00 & 65535, this._a16 = ~this._a16 & 65535, this._a32 = ~this._a32 & 65535, this._a48 = ~this._a48 & 65535, this;
      }, k.prototype.shiftRight = k.prototype.shiftr = function(IA) {
        return IA %= 64, IA >= 48 ? (this._a00 = this._a48 >> IA - 48, this._a16 = 0, this._a32 = 0, this._a48 = 0) : IA >= 32 ? (IA -= 32, this._a00 = (this._a32 >> IA | this._a48 << 16 - IA) & 65535, this._a16 = this._a48 >> IA & 65535, this._a32 = 0, this._a48 = 0) : IA >= 16 ? (IA -= 16, this._a00 = (this._a16 >> IA | this._a32 << 16 - IA) & 65535, this._a16 = (this._a32 >> IA | this._a48 << 16 - IA) & 65535, this._a32 = this._a48 >> IA & 65535, this._a48 = 0) : (this._a00 = (this._a00 >> IA | this._a16 << 16 - IA) & 65535, this._a16 = (this._a16 >> IA | this._a32 << 16 - IA) & 65535, this._a32 = (this._a32 >> IA | this._a48 << 16 - IA) & 65535, this._a48 = this._a48 >> IA & 65535), this;
      }, k.prototype.shiftLeft = k.prototype.shiftl = function(IA, CA) {
        return IA %= 64, IA >= 48 ? (this._a48 = this._a00 << IA - 48, this._a32 = 0, this._a16 = 0, this._a00 = 0) : IA >= 32 ? (IA -= 32, this._a48 = this._a16 << IA | this._a00 >> 16 - IA, this._a32 = this._a00 << IA & 65535, this._a16 = 0, this._a00 = 0) : IA >= 16 ? (IA -= 16, this._a48 = this._a32 << IA | this._a16 >> 16 - IA, this._a32 = (this._a16 << IA | this._a00 >> 16 - IA) & 65535, this._a16 = this._a00 << IA & 65535, this._a00 = 0) : (this._a48 = this._a48 << IA | this._a32 >> 16 - IA, this._a32 = (this._a32 << IA | this._a16 >> 16 - IA) & 65535, this._a16 = (this._a16 << IA | this._a00 >> 16 - IA) & 65535, this._a00 = this._a00 << IA & 65535), CA || (this._a48 &= 65535), this;
      }, k.prototype.rotateLeft = k.prototype.rotl = function(IA) {
        if (IA %= 64, IA == 0) return this;
        if (IA >= 32) {
          var CA = this._a00;
          if (this._a00 = this._a32, this._a32 = CA, CA = this._a48, this._a48 = this._a16, this._a16 = CA, IA == 32) return this;
          IA -= 32;
        }
        var BA = this._a48 << 16 | this._a32, eA = this._a16 << 16 | this._a00, iA = BA << IA | eA >>> 32 - IA, QA = eA << IA | BA >>> 32 - IA;
        return this._a00 = QA & 65535, this._a16 = QA >>> 16, this._a32 = iA & 65535, this._a48 = iA >>> 16, this;
      }, k.prototype.rotateRight = k.prototype.rotr = function(IA) {
        if (IA %= 64, IA == 0) return this;
        if (IA >= 32) {
          var CA = this._a00;
          if (this._a00 = this._a32, this._a32 = CA, CA = this._a48, this._a48 = this._a16, this._a16 = CA, IA == 32) return this;
          IA -= 32;
        }
        var BA = this._a48 << 16 | this._a32, eA = this._a16 << 16 | this._a00, iA = BA >>> IA | eA << 32 - IA, QA = eA >>> IA | BA << 32 - IA;
        return this._a00 = QA & 65535, this._a16 = QA >>> 16, this._a32 = iA & 65535, this._a48 = iA >>> 16, this;
      }, k.prototype.clone = function() {
        return new k(this._a00, this._a16, this._a32, this._a48);
      }, n.exports ? n.exports = k : t.UINT64 = k;
    })(uint64);
  })(uint64$1)), uint64$1.exports;
}
var hasRequiredCuint;
function requireCuint() {
  return hasRequiredCuint || (hasRequiredCuint = 1, cuint.UINT32 = requireUint32(), cuint.UINT64 = requireUint64()), cuint;
}
var xxhash$1, hasRequiredXxhash;
function requireXxhash() {
  if (hasRequiredXxhash) return xxhash$1;
  hasRequiredXxhash = 1;
  var n = requireCuint().UINT32;
  n.prototype.xxh_update = function(CA, BA) {
    var eA = g._low, iA = g._high, QA, tA;
    tA = CA * eA, QA = tA >>> 16, QA += BA * eA, QA &= 65535, QA += CA * iA;
    var oA = this._low + (tA & 65535), EA = oA >>> 16;
    EA += this._high + (QA & 65535);
    var aA = EA << 16 | oA & 65535;
    aA = aA << 13 | aA >>> 19, oA = aA & 65535, EA = aA >>> 16, eA = t._low, iA = t._high, tA = oA * eA, QA = tA >>> 16, QA += EA * eA, QA &= 65535, QA += oA * iA, this._low = tA & 65535, this._high = QA & 65535;
  };
  var t = n("2654435761"), g = n("2246822519"), d = n("3266489917"), k = n("668265263"), H = n("374761393");
  function AA(CA) {
    for (var BA = [], eA = 0, iA = CA.length; eA < iA; eA++) {
      var QA = CA.charCodeAt(eA);
      QA < 128 ? BA.push(QA) : QA < 2048 ? BA.push(
        192 | QA >> 6,
        128 | QA & 63
      ) : QA < 55296 || QA >= 57344 ? BA.push(
        224 | QA >> 12,
        128 | QA >> 6 & 63,
        128 | QA & 63
      ) : (eA++, QA = 65536 + ((QA & 1023) << 10 | CA.charCodeAt(eA) & 1023), BA.push(
        240 | QA >> 18,
        128 | QA >> 12 & 63,
        128 | QA >> 6 & 63,
        128 | QA & 63
      ));
    }
    return new Uint8Array(BA);
  }
  function gA() {
    if (arguments.length == 2)
      return new gA(arguments[1]).update(arguments[0]).digest();
    if (!(this instanceof gA))
      return new gA(arguments[0]);
    IA.call(this, arguments[0]);
  }
  function IA(CA) {
    return this.seed = CA instanceof n ? CA.clone() : n(CA), this.v1 = this.seed.clone().add(t).add(g), this.v2 = this.seed.clone().add(g), this.v3 = this.seed.clone(), this.v4 = this.seed.clone().subtract(t), this.total_len = 0, this.memsize = 0, this.memory = null, this;
  }
  return gA.prototype.init = IA, gA.prototype.update = function(CA) {
    var BA = typeof CA == "string", eA;
    BA && (CA = AA(CA), BA = !1, eA = !0), typeof ArrayBuffer < "u" && CA instanceof ArrayBuffer && (eA = !0, CA = new Uint8Array(CA));
    var iA = 0, QA = CA.length, tA = iA + QA;
    if (QA == 0) return this;
    if (this.total_len += QA, this.memsize == 0 && (BA ? this.memory = "" : eA ? this.memory = new Uint8Array(16) : this.memory = new Buffer(16)), this.memsize + QA < 16)
      return BA ? this.memory += CA : eA ? this.memory.set(CA.subarray(0, QA), this.memsize) : CA.copy(this.memory, this.memsize, 0, QA), this.memsize += QA, this;
    if (this.memsize > 0) {
      BA ? this.memory += CA.slice(0, 16 - this.memsize) : eA ? this.memory.set(CA.subarray(0, 16 - this.memsize), this.memsize) : CA.copy(this.memory, this.memsize, 0, 16 - this.memsize);
      var oA = 0;
      BA ? (this.v1.xxh_update(
        this.memory.charCodeAt(oA + 1) << 8 | this.memory.charCodeAt(oA),
        this.memory.charCodeAt(oA + 3) << 8 | this.memory.charCodeAt(oA + 2)
      ), oA += 4, this.v2.xxh_update(
        this.memory.charCodeAt(oA + 1) << 8 | this.memory.charCodeAt(oA),
        this.memory.charCodeAt(oA + 3) << 8 | this.memory.charCodeAt(oA + 2)
      ), oA += 4, this.v3.xxh_update(
        this.memory.charCodeAt(oA + 1) << 8 | this.memory.charCodeAt(oA),
        this.memory.charCodeAt(oA + 3) << 8 | this.memory.charCodeAt(oA + 2)
      ), oA += 4, this.v4.xxh_update(
        this.memory.charCodeAt(oA + 1) << 8 | this.memory.charCodeAt(oA),
        this.memory.charCodeAt(oA + 3) << 8 | this.memory.charCodeAt(oA + 2)
      )) : (this.v1.xxh_update(
        this.memory[oA + 1] << 8 | this.memory[oA],
        this.memory[oA + 3] << 8 | this.memory[oA + 2]
      ), oA += 4, this.v2.xxh_update(
        this.memory[oA + 1] << 8 | this.memory[oA],
        this.memory[oA + 3] << 8 | this.memory[oA + 2]
      ), oA += 4, this.v3.xxh_update(
        this.memory[oA + 1] << 8 | this.memory[oA],
        this.memory[oA + 3] << 8 | this.memory[oA + 2]
      ), oA += 4, this.v4.xxh_update(
        this.memory[oA + 1] << 8 | this.memory[oA],
        this.memory[oA + 3] << 8 | this.memory[oA + 2]
      )), iA += 16 - this.memsize, this.memsize = 0, BA && (this.memory = "");
    }
    if (iA <= tA - 16) {
      var EA = tA - 16;
      do
        BA ? (this.v1.xxh_update(
          CA.charCodeAt(iA + 1) << 8 | CA.charCodeAt(iA),
          CA.charCodeAt(iA + 3) << 8 | CA.charCodeAt(iA + 2)
        ), iA += 4, this.v2.xxh_update(
          CA.charCodeAt(iA + 1) << 8 | CA.charCodeAt(iA),
          CA.charCodeAt(iA + 3) << 8 | CA.charCodeAt(iA + 2)
        ), iA += 4, this.v3.xxh_update(
          CA.charCodeAt(iA + 1) << 8 | CA.charCodeAt(iA),
          CA.charCodeAt(iA + 3) << 8 | CA.charCodeAt(iA + 2)
        ), iA += 4, this.v4.xxh_update(
          CA.charCodeAt(iA + 1) << 8 | CA.charCodeAt(iA),
          CA.charCodeAt(iA + 3) << 8 | CA.charCodeAt(iA + 2)
        )) : (this.v1.xxh_update(
          CA[iA + 1] << 8 | CA[iA],
          CA[iA + 3] << 8 | CA[iA + 2]
        ), iA += 4, this.v2.xxh_update(
          CA[iA + 1] << 8 | CA[iA],
          CA[iA + 3] << 8 | CA[iA + 2]
        ), iA += 4, this.v3.xxh_update(
          CA[iA + 1] << 8 | CA[iA],
          CA[iA + 3] << 8 | CA[iA + 2]
        ), iA += 4, this.v4.xxh_update(
          CA[iA + 1] << 8 | CA[iA],
          CA[iA + 3] << 8 | CA[iA + 2]
        )), iA += 4;
      while (iA <= EA);
    }
    return iA < tA && (BA ? this.memory += CA.slice(iA) : eA ? this.memory.set(CA.subarray(iA, tA), this.memsize) : CA.copy(this.memory, this.memsize, iA, tA), this.memsize = tA - iA), this;
  }, gA.prototype.digest = function() {
    var CA = this.memory, BA = typeof CA == "string", eA = 0, iA = this.memsize, QA, tA, oA = new n();
    for (this.total_len >= 16 ? QA = this.v1.rotl(1).add(this.v2.rotl(7).add(this.v3.rotl(12).add(this.v4.rotl(18)))) : QA = this.seed.clone().add(H), QA.add(oA.fromNumber(this.total_len)); eA <= iA - 4; )
      BA ? oA.fromBits(
        CA.charCodeAt(eA + 1) << 8 | CA.charCodeAt(eA),
        CA.charCodeAt(eA + 3) << 8 | CA.charCodeAt(eA + 2)
      ) : oA.fromBits(
        CA[eA + 1] << 8 | CA[eA],
        CA[eA + 3] << 8 | CA[eA + 2]
      ), QA.add(oA.multiply(d)).rotl(17).multiply(k), eA += 4;
    for (; eA < iA; )
      oA.fromBits(BA ? CA.charCodeAt(eA++) : CA[eA++], 0), QA.add(oA.multiply(H)).rotl(11).multiply(t);
    return tA = QA.clone().shiftRight(15), QA.xor(tA).multiply(g), tA = QA.clone().shiftRight(13), QA.xor(tA).multiply(d), tA = QA.clone().shiftRight(16), QA.xor(tA), this.init(this.seed), QA;
  }, xxhash$1 = gA, xxhash$1;
}
var xxhash64, hasRequiredXxhash64;
function requireXxhash64() {
  if (hasRequiredXxhash64) return xxhash64;
  hasRequiredXxhash64 = 1;
  var n = requireCuint().UINT64, t = n("11400714785074694791"), g = n("14029467366897019727"), d = n("1609587929392839161"), k = n("9650029242287828579"), H = n("2870177450012600261");
  function AA(CA) {
    for (var BA = [], eA = 0, iA = CA.length; eA < iA; eA++) {
      var QA = CA.charCodeAt(eA);
      QA < 128 ? BA.push(QA) : QA < 2048 ? BA.push(
        192 | QA >> 6,
        128 | QA & 63
      ) : QA < 55296 || QA >= 57344 ? BA.push(
        224 | QA >> 12,
        128 | QA >> 6 & 63,
        128 | QA & 63
      ) : (eA++, QA = 65536 + ((QA & 1023) << 10 | CA.charCodeAt(eA) & 1023), BA.push(
        240 | QA >> 18,
        128 | QA >> 12 & 63,
        128 | QA >> 6 & 63,
        128 | QA & 63
      ));
    }
    return new Uint8Array(BA);
  }
  function gA() {
    if (arguments.length == 2)
      return new gA(arguments[1]).update(arguments[0]).digest();
    if (!(this instanceof gA))
      return new gA(arguments[0]);
    IA.call(this, arguments[0]);
  }
  function IA(CA) {
    return this.seed = CA instanceof n ? CA.clone() : n(CA), this.v1 = this.seed.clone().add(t).add(g), this.v2 = this.seed.clone().add(g), this.v3 = this.seed.clone(), this.v4 = this.seed.clone().subtract(t), this.total_len = 0, this.memsize = 0, this.memory = null, this;
  }
  return gA.prototype.init = IA, gA.prototype.update = function(CA) {
    var BA = typeof CA == "string", eA;
    BA && (CA = AA(CA), BA = !1, eA = !0), typeof ArrayBuffer < "u" && CA instanceof ArrayBuffer && (eA = !0, CA = new Uint8Array(CA));
    var iA = 0, QA = CA.length, tA = iA + QA;
    if (QA == 0) return this;
    if (this.total_len += QA, this.memsize == 0 && (BA ? this.memory = "" : eA ? this.memory = new Uint8Array(32) : this.memory = new Buffer(32)), this.memsize + QA < 32)
      return BA ? this.memory += CA : eA ? this.memory.set(CA.subarray(0, QA), this.memsize) : CA.copy(this.memory, this.memsize, 0, QA), this.memsize += QA, this;
    if (this.memsize > 0) {
      BA ? this.memory += CA.slice(0, 32 - this.memsize) : eA ? this.memory.set(CA.subarray(0, 32 - this.memsize), this.memsize) : CA.copy(this.memory, this.memsize, 0, 32 - this.memsize);
      var oA = 0;
      if (BA) {
        var EA;
        EA = n(
          this.memory.charCodeAt(oA + 1) << 8 | this.memory.charCodeAt(oA),
          this.memory.charCodeAt(oA + 3) << 8 | this.memory.charCodeAt(oA + 2),
          this.memory.charCodeAt(oA + 5) << 8 | this.memory.charCodeAt(oA + 4),
          this.memory.charCodeAt(oA + 7) << 8 | this.memory.charCodeAt(oA + 6)
        ), this.v1.add(EA.multiply(g)).rotl(31).multiply(t), oA += 8, EA = n(
          this.memory.charCodeAt(oA + 1) << 8 | this.memory.charCodeAt(oA),
          this.memory.charCodeAt(oA + 3) << 8 | this.memory.charCodeAt(oA + 2),
          this.memory.charCodeAt(oA + 5) << 8 | this.memory.charCodeAt(oA + 4),
          this.memory.charCodeAt(oA + 7) << 8 | this.memory.charCodeAt(oA + 6)
        ), this.v2.add(EA.multiply(g)).rotl(31).multiply(t), oA += 8, EA = n(
          this.memory.charCodeAt(oA + 1) << 8 | this.memory.charCodeAt(oA),
          this.memory.charCodeAt(oA + 3) << 8 | this.memory.charCodeAt(oA + 2),
          this.memory.charCodeAt(oA + 5) << 8 | this.memory.charCodeAt(oA + 4),
          this.memory.charCodeAt(oA + 7) << 8 | this.memory.charCodeAt(oA + 6)
        ), this.v3.add(EA.multiply(g)).rotl(31).multiply(t), oA += 8, EA = n(
          this.memory.charCodeAt(oA + 1) << 8 | this.memory.charCodeAt(oA),
          this.memory.charCodeAt(oA + 3) << 8 | this.memory.charCodeAt(oA + 2),
          this.memory.charCodeAt(oA + 5) << 8 | this.memory.charCodeAt(oA + 4),
          this.memory.charCodeAt(oA + 7) << 8 | this.memory.charCodeAt(oA + 6)
        ), this.v4.add(EA.multiply(g)).rotl(31).multiply(t);
      } else {
        var EA;
        EA = n(
          this.memory[oA + 1] << 8 | this.memory[oA],
          this.memory[oA + 3] << 8 | this.memory[oA + 2],
          this.memory[oA + 5] << 8 | this.memory[oA + 4],
          this.memory[oA + 7] << 8 | this.memory[oA + 6]
        ), this.v1.add(EA.multiply(g)).rotl(31).multiply(t), oA += 8, EA = n(
          this.memory[oA + 1] << 8 | this.memory[oA],
          this.memory[oA + 3] << 8 | this.memory[oA + 2],
          this.memory[oA + 5] << 8 | this.memory[oA + 4],
          this.memory[oA + 7] << 8 | this.memory[oA + 6]
        ), this.v2.add(EA.multiply(g)).rotl(31).multiply(t), oA += 8, EA = n(
          this.memory[oA + 1] << 8 | this.memory[oA],
          this.memory[oA + 3] << 8 | this.memory[oA + 2],
          this.memory[oA + 5] << 8 | this.memory[oA + 4],
          this.memory[oA + 7] << 8 | this.memory[oA + 6]
        ), this.v3.add(EA.multiply(g)).rotl(31).multiply(t), oA += 8, EA = n(
          this.memory[oA + 1] << 8 | this.memory[oA],
          this.memory[oA + 3] << 8 | this.memory[oA + 2],
          this.memory[oA + 5] << 8 | this.memory[oA + 4],
          this.memory[oA + 7] << 8 | this.memory[oA + 6]
        ), this.v4.add(EA.multiply(g)).rotl(31).multiply(t);
      }
      iA += 32 - this.memsize, this.memsize = 0, BA && (this.memory = "");
    }
    if (iA <= tA - 32) {
      var aA = tA - 32;
      do {
        if (BA) {
          var EA;
          EA = n(
            CA.charCodeAt(iA + 1) << 8 | CA.charCodeAt(iA),
            CA.charCodeAt(iA + 3) << 8 | CA.charCodeAt(iA + 2),
            CA.charCodeAt(iA + 5) << 8 | CA.charCodeAt(iA + 4),
            CA.charCodeAt(iA + 7) << 8 | CA.charCodeAt(iA + 6)
          ), this.v1.add(EA.multiply(g)).rotl(31).multiply(t), iA += 8, EA = n(
            CA.charCodeAt(iA + 1) << 8 | CA.charCodeAt(iA),
            CA.charCodeAt(iA + 3) << 8 | CA.charCodeAt(iA + 2),
            CA.charCodeAt(iA + 5) << 8 | CA.charCodeAt(iA + 4),
            CA.charCodeAt(iA + 7) << 8 | CA.charCodeAt(iA + 6)
          ), this.v2.add(EA.multiply(g)).rotl(31).multiply(t), iA += 8, EA = n(
            CA.charCodeAt(iA + 1) << 8 | CA.charCodeAt(iA),
            CA.charCodeAt(iA + 3) << 8 | CA.charCodeAt(iA + 2),
            CA.charCodeAt(iA + 5) << 8 | CA.charCodeAt(iA + 4),
            CA.charCodeAt(iA + 7) << 8 | CA.charCodeAt(iA + 6)
          ), this.v3.add(EA.multiply(g)).rotl(31).multiply(t), iA += 8, EA = n(
            CA.charCodeAt(iA + 1) << 8 | CA.charCodeAt(iA),
            CA.charCodeAt(iA + 3) << 8 | CA.charCodeAt(iA + 2),
            CA.charCodeAt(iA + 5) << 8 | CA.charCodeAt(iA + 4),
            CA.charCodeAt(iA + 7) << 8 | CA.charCodeAt(iA + 6)
          ), this.v4.add(EA.multiply(g)).rotl(31).multiply(t);
        } else {
          var EA;
          EA = n(
            CA[iA + 1] << 8 | CA[iA],
            CA[iA + 3] << 8 | CA[iA + 2],
            CA[iA + 5] << 8 | CA[iA + 4],
            CA[iA + 7] << 8 | CA[iA + 6]
          ), this.v1.add(EA.multiply(g)).rotl(31).multiply(t), iA += 8, EA = n(
            CA[iA + 1] << 8 | CA[iA],
            CA[iA + 3] << 8 | CA[iA + 2],
            CA[iA + 5] << 8 | CA[iA + 4],
            CA[iA + 7] << 8 | CA[iA + 6]
          ), this.v2.add(EA.multiply(g)).rotl(31).multiply(t), iA += 8, EA = n(
            CA[iA + 1] << 8 | CA[iA],
            CA[iA + 3] << 8 | CA[iA + 2],
            CA[iA + 5] << 8 | CA[iA + 4],
            CA[iA + 7] << 8 | CA[iA + 6]
          ), this.v3.add(EA.multiply(g)).rotl(31).multiply(t), iA += 8, EA = n(
            CA[iA + 1] << 8 | CA[iA],
            CA[iA + 3] << 8 | CA[iA + 2],
            CA[iA + 5] << 8 | CA[iA + 4],
            CA[iA + 7] << 8 | CA[iA + 6]
          ), this.v4.add(EA.multiply(g)).rotl(31).multiply(t);
        }
        iA += 8;
      } while (iA <= aA);
    }
    return iA < tA && (BA ? this.memory += CA.slice(iA) : eA ? this.memory.set(CA.subarray(iA, tA), this.memsize) : CA.copy(this.memory, this.memsize, iA, tA), this.memsize = tA - iA), this;
  }, gA.prototype.digest = function() {
    var CA = this.memory, BA = typeof CA == "string", eA = 0, iA = this.memsize, QA, tA, oA = new n();
    for (this.total_len >= 32 ? (QA = this.v1.clone().rotl(1), QA.add(this.v2.clone().rotl(7)), QA.add(this.v3.clone().rotl(12)), QA.add(this.v4.clone().rotl(18)), QA.xor(this.v1.multiply(g).rotl(31).multiply(t)), QA.multiply(t).add(k), QA.xor(this.v2.multiply(g).rotl(31).multiply(t)), QA.multiply(t).add(k), QA.xor(this.v3.multiply(g).rotl(31).multiply(t)), QA.multiply(t).add(k), QA.xor(this.v4.multiply(g).rotl(31).multiply(t)), QA.multiply(t).add(k)) : QA = this.seed.clone().add(H), QA.add(oA.fromNumber(this.total_len)); eA <= iA - 8; )
      BA ? oA.fromBits(
        CA.charCodeAt(eA + 1) << 8 | CA.charCodeAt(eA),
        CA.charCodeAt(eA + 3) << 8 | CA.charCodeAt(eA + 2),
        CA.charCodeAt(eA + 5) << 8 | CA.charCodeAt(eA + 4),
        CA.charCodeAt(eA + 7) << 8 | CA.charCodeAt(eA + 6)
      ) : oA.fromBits(
        CA[eA + 1] << 8 | CA[eA],
        CA[eA + 3] << 8 | CA[eA + 2],
        CA[eA + 5] << 8 | CA[eA + 4],
        CA[eA + 7] << 8 | CA[eA + 6]
      ), oA.multiply(g).rotl(31).multiply(t), QA.xor(oA).rotl(27).multiply(t).add(k), eA += 8;
    for (eA + 4 <= iA && (BA ? oA.fromBits(
      CA.charCodeAt(eA + 1) << 8 | CA.charCodeAt(eA),
      CA.charCodeAt(eA + 3) << 8 | CA.charCodeAt(eA + 2),
      0,
      0
    ) : oA.fromBits(
      CA[eA + 1] << 8 | CA[eA],
      CA[eA + 3] << 8 | CA[eA + 2],
      0,
      0
    ), QA.xor(oA.multiply(t)).rotl(23).multiply(g).add(d), eA += 4); eA < iA; )
      oA.fromBits(BA ? CA.charCodeAt(eA++) : CA[eA++], 0, 0, 0), QA.xor(oA.multiply(H)).rotl(11).multiply(t);
    return tA = QA.clone().shiftRight(33), QA.xor(tA).multiply(g), tA = QA.clone().shiftRight(29), QA.xor(tA).multiply(d), tA = QA.clone().shiftRight(32), QA.xor(tA), this.init(this.seed), QA;
  }, xxhash64 = gA, xxhash64;
}
var lib$2, hasRequiredLib$1;
function requireLib$1() {
  return hasRequiredLib$1 || (hasRequiredLib$1 = 1, lib$2 = {
    h32: requireXxhash(),
    h64: requireXxhash64()
  }), lib$2;
}
var libExports$1 = requireLib$1();
const xxhash = /* @__PURE__ */ getDefaultExportFromCjs$2(libExports$1), assertNever = (n) => {
  throw new Error(`Reached a branch with non-exhaustive item: ${n}`);
}, GENERATED_ELEMENT_ID_PREFIX = "$$ID";
function debounce$4(n, t) {
  let g;
  return (...d) => {
    g && clearTimeout(g), g = setTimeout(() => {
      t(...d), g = null;
    }, n);
  };
}
const EMBED_QUERY_PARAM_KEY = "embed", EMBED_OPTIONS_QUERY_PARAM_KEY = "embed_options", EMBED_SHOW_TOOLBAR = "show_toolbar", EMBED_SHOW_PADDING = "show_padding", EMBED_DISABLE_SCROLLING = "disable_scrolling", EMBED_LIGHT_THEME = "light_theme", EMBED_DARK_THEME = "dark_theme", EMBED_TRUE = "true", EMBED_HIDE_LOADING_SCREEN = "hide_loading_screen", EMBED_SHOW_LOADING_SCREEN_V1 = "show_loading_screen_v1", EMBED_SHOW_LOADING_SCREEN_V2 = "show_loading_screen_v2", EMBED_QUERY_PARAM_VALUES = [EMBED_SHOW_TOOLBAR, EMBED_SHOW_PADDING, EMBED_DISABLE_SCROLLING, EMBED_LIGHT_THEME, EMBED_DARK_THEME, EMBED_HIDE_LOADING_SCREEN, EMBED_SHOW_LOADING_SCREEN_V1, EMBED_SHOW_LOADING_SCREEN_V2, EMBED_TRUE];
var LoadingScreenType = /* @__PURE__ */ ((n) => (n[n.NONE = 0] = "NONE", n[n.V1 = 1] = "V1", n[n.V2 = 2] = "V2", n))(LoadingScreenType || {});
function getEmbedUrlParams(n) {
  const t = /* @__PURE__ */ new Set();
  return new URLSearchParams(window.location.search).forEach((d, k) => {
    k = k.toString().toLowerCase(), d = d.toString().toLowerCase(), k === n && EMBED_QUERY_PARAM_VALUES.includes(d) && t.add(d);
  }), t;
}
function preserveEmbedQueryParams() {
  if (!isEmbed())
    return "";
  const n = new URLSearchParams(window.location.search).getAll(EMBED_OPTIONS_QUERY_PARAM_KEY), t = [];
  return t.push([EMBED_QUERY_PARAM_KEY, EMBED_TRUE]), n.forEach((g) => {
    t.push([EMBED_OPTIONS_QUERY_PARAM_KEY, g]);
  }), new URLSearchParams(t).toString();
}
function isEmbed() {
  return getEmbedUrlParams(EMBED_QUERY_PARAM_KEY).has(EMBED_TRUE);
}
function isToolbarDisplayed() {
  return isEmbed() && getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_SHOW_TOOLBAR);
}
function isScrollingHidden() {
  return isEmbed() && getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_DISABLE_SCROLLING);
}
function isPaddingDisplayed() {
  return isEmbed() && getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_SHOW_PADDING);
}
function isLightThemeInQueryParams() {
  return getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_LIGHT_THEME);
}
function isDarkThemeInQueryParams() {
  return getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_DARK_THEME);
}
function isInChildFrame() {
  return window.parent !== window;
}
function getUrl() {
  let n;
  try {
    isInChildFrame() && window.top ? n = window.top.location.href : n = document.location.href;
  } catch {
    n = document.location.href;
  }
  const t = new URL(n);
  return t.search = "", t.hash = "", t.toString();
}
function getTimezone$1() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function getTimezoneOffset() {
  return (/* @__PURE__ */ new Date()).getTimezoneOffset();
}
function getLocaleLanguage() {
  return navigator.language;
}
function getLoadingScreenType() {
  const n = getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY);
  return n.has(EMBED_HIDE_LOADING_SCREEN) ? 0 : n.has(EMBED_SHOW_LOADING_SCREEN_V1) ? 1 : 2;
}
function makeElementWithInfoText(n) {
  return new Element$1({
    alert: {
      body: n,
      format: Alert.Format.INFO
    }
  });
}
function makeElementWithErrorText(n) {
  return new Element$1({
    alert: {
      body: n,
      format: Alert.Format.ERROR
    }
  });
}
function makeAppSkeletonElement() {
  return new Element$1({
    skeleton: {
      style: Skeleton$1.SkeletonStyle.APP
    }
  });
}
function hashString(n) {
  return xxhash.h32(n, 3735928559).toString(16);
}
function requireNonNull(n) {
  if (isNullOrUndefined$1(n))
    throw new Error("value is null");
  return n;
}
function notUndefined(n) {
  return n !== void 0;
}
function isFromMac() {
  return /Mac/i.test(navigator.platform);
}
function isFromWindows() {
  return /^Win/i.test(navigator.platform);
}
function setCookie(n, t, g) {
  const d = t ? g : /* @__PURE__ */ new Date(), k = d ? `expires=${d.toUTCString()};` : "";
  document.cookie = `${n}=${t};${k}path=/`;
}
function isValidElementId(n) {
  return n ? n.startsWith(GENERATED_ELEMENT_ID_PREFIX) && // There must be at least 3 parts: $$ID-<hash>-<userKey>
  n.split("-").length >= 3 : !1;
}
function getElementId(n) {
  const t = get$9(n, [requireNonNull(n.type), "id"]);
  if (t && isValidElementId(t))
    return t;
}
function isValidFormId(n) {
  return notNullOrUndefined(n) && n.length > 0;
}
function isInForm(n) {
  return isValidFormId(n.formId);
}
function getSelectPlaceholder(n, t, g, d = !1) {
  let k = !1;
  return n !== "" ? {
    placeholder: n,
    shouldDisable: k
  } : (t.length === 0 ? g ? n = d ? "Add options" : "Add an option" : (n = "No options to select", k = !0) : g ? n = d ? "Choose or add options" : "Choose or add an option" : n = d ? "Choose options" : "Choose an option", {
    placeholder: n,
    shouldDisable: k
  });
}
var LabelVisibilityOptions = /* @__PURE__ */ ((n) => (n[n.Visible = 0] = "Visible", n[n.Hidden = 1] = "Hidden", n[n.Collapsed = 2] = "Collapsed", n))(LabelVisibilityOptions || {});
function labelVisibilityProtoValueToEnum(n) {
  switch (n) {
    case LabelVisibilityMessage.LabelVisibilityOptions.VISIBLE:
      return 0;
    case LabelVisibilityMessage.LabelVisibilityOptions.HIDDEN:
      return 1;
    case LabelVisibilityMessage.LabelVisibilityOptions.COLLAPSED:
      return 2;
    default:
      return 0;
  }
}
var AcceptFileValue = /* @__PURE__ */ ((n) => (n[n.None = 0] = "None", n[n.Single = 1] = "Single", n[n.Multiple = 2] = "Multiple", n[n.Directory = 3] = "Directory", n))(AcceptFileValue || {});
function chatInputAcceptFileProtoValueToEnum(n) {
  switch (n) {
    case ChatInput$1.AcceptFile.NONE:
      return 0;
    case ChatInput$1.AcceptFile.SINGLE:
      return 1;
    case ChatInput$1.AcceptFile.MULTIPLE:
      return 2;
    case ChatInput$1.AcceptFile.DIRECTORY:
      return 3;
    default:
      return assertNever(n), 0;
  }
}
function findAnIFrameWithClassName(n, t) {
  for (let g = 0; g < n.length; g++) {
    const d = n[g].contentDocument;
    if (d && d.getElementsByClassName(t).length > 0)
      return n[g];
  }
  return null;
}
function canAccessIFrame(n) {
  try {
    if (n.contentWindow === null) return !1;
    const g = (n.contentDocument || n.contentWindow.document).body.innerHTML;
    return g !== null && g !== "";
  } catch {
    return !1;
  }
}
function getIFrameEnclosingApp(n) {
  if (!isInChildFrame())
    return null;
  const t = getEmbeddingIdClassName(n), g = 'iframe[title="streamlitApp"]';
  let d = window.document.querySelectorAll(g), k = findAnIFrameWithClassName(d, t);
  if (k && !canAccessIFrame(k))
    return null;
  if (k)
    return k;
  if (window.parent && (d = window.parent.document.querySelectorAll(g)), k = findAnIFrameWithClassName(d, t), k && !canAccessIFrame(k))
    return null;
  if (k)
    return k;
  let H = window.document.getElementsByTagName("iframe");
  return k = findAnIFrameWithClassName(H, t), k && !canAccessIFrame(k) ? null : k || (window.parent && (H = window.parent.document.getElementsByTagName("iframe")), k = findAnIFrameWithClassName(H, t), k && !canAccessIFrame(k) ? null : k);
}
function generateUID$2() {
  return Math.floor(Date.now() / 1e3).toString(36) + Math.random().toString(36).slice(-6);
}
function getEmbeddingIdClassName(n) {
  return `stAppEmbeddingId-${n}`;
}
function extractPageNameFromPathName(n, t) {
  return decodeURIComponent(n.replace(t, "").replace(new RegExp("^/?"), "").replace(new RegExp("/$"), ""));
}
function keysToSnakeCase(n) {
  return Object.keys(n).reduce(
    (t, g) => {
      const d = decamelize$1(g, {
        preserveConsecutiveUppercase: !0
      }).replace(".", "_");
      let k = n[g];
      return k && typeof k == "object" && !Array.isArray(k) && (k = keysToSnakeCase(k)), Array.isArray(k) && (k = k.map((H) => H !== null && typeof H == "object" ? keysToSnakeCase(H) : H)), t[d] = k, t;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
    {}
  );
}
var __assign$2 = function() {
  return __assign$2 = Object.assign || function(t) {
    for (var g, d = 1, k = arguments.length; d < k; d++) {
      g = arguments[d];
      for (var H in g) Object.prototype.hasOwnProperty.call(g, H) && (t[H] = g[H]);
    }
    return t;
  }, __assign$2.apply(this, arguments);
};
function __awaiter(n, t, g, d) {
  function k(H) {
    return H instanceof g ? H : new g(function(AA) {
      AA(H);
    });
  }
  return new (g || (g = Promise))(function(H, AA) {
    function gA(BA) {
      try {
        CA(d.next(BA));
      } catch (eA) {
        AA(eA);
      }
    }
    function IA(BA) {
      try {
        CA(d.throw(BA));
      } catch (eA) {
        AA(eA);
      }
    }
    function CA(BA) {
      BA.done ? H(BA.value) : k(BA.value).then(gA, IA);
    }
    CA((d = d.apply(n, t || [])).next());
  });
}
function __values(n) {
  var t = typeof Symbol == "function" && Symbol.iterator, g = t && n[t], d = 0;
  if (g) return g.call(n);
  if (n && typeof n.length == "number") return {
    next: function() {
      return n && d >= n.length && (n = void 0), { value: n && n[d++], done: !n };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __await(n) {
  return this instanceof __await ? (this.v = n, this) : new __await(n);
}
function __asyncGenerator(n, t, g) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var d = g.apply(n, t || []), k, H = [];
  return k = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), gA("next"), gA("throw"), gA("return", AA), k[Symbol.asyncIterator] = function() {
    return this;
  }, k;
  function AA(QA) {
    return function(tA) {
      return Promise.resolve(tA).then(QA, eA);
    };
  }
  function gA(QA, tA) {
    d[QA] && (k[QA] = function(oA) {
      return new Promise(function(EA, aA) {
        H.push([QA, oA, EA, aA]) > 1 || IA(QA, oA);
      });
    }, tA && (k[QA] = tA(k[QA])));
  }
  function IA(QA, tA) {
    try {
      CA(d[QA](tA));
    } catch (oA) {
      iA(H[0][3], oA);
    }
  }
  function CA(QA) {
    QA.value instanceof __await ? Promise.resolve(QA.value.v).then(BA, eA) : iA(H[0][2], QA);
  }
  function BA(QA) {
    IA("next", QA);
  }
  function eA(QA) {
    IA("throw", QA);
  }
  function iA(QA, tA) {
    QA(tA), H.shift(), H.length && IA(H[0][0], H[0][1]);
  }
}
function __asyncDelegator(n) {
  var t, g;
  return t = {}, d("next"), d("throw", function(k) {
    throw k;
  }), d("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function d(k, H) {
    t[k] = n[k] ? function(AA) {
      return (g = !g) ? { value: __await(n[k](AA)), done: !1 } : H ? H(AA) : AA;
    } : H;
  }
}
function __asyncValues(n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = n[Symbol.asyncIterator], g;
  return t ? t.call(n) : (n = typeof __values == "function" ? __values(n) : n[Symbol.iterator](), g = {}, d("next"), d("throw"), d("return"), g[Symbol.asyncIterator] = function() {
    return this;
  }, g);
  function d(H) {
    g[H] = n[H] && function(AA) {
      return new Promise(function(gA, IA) {
        AA = n[H](AA), k(gA, IA, AA.done, AA.value);
      });
    };
  }
  function k(H, AA, gA, IA) {
    Promise.resolve(IA).then(function(CA) {
      H({ value: CA, done: gA });
    }, AA);
  }
}
typeof SuppressedError == "function" && SuppressedError;
const decoder = new TextDecoder("utf-8"), decodeUtf8 = decoder.decode.bind(decoder), encoder$1 = new TextEncoder(), encodeUtf8 = (n) => encoder$1.encode(n), isNumber$6 = (n) => typeof n == "number", isBoolean$5 = (n) => typeof n == "boolean", isFunction$8 = (n) => typeof n == "function", isObject$8 = (n) => n != null && Object(n) === n, isPromise = (n) => isObject$8(n) && isFunction$8(n.then), isIterable$2 = (n) => isObject$8(n) && isFunction$8(n[Symbol.iterator]), isAsyncIterable$1 = (n) => isObject$8(n) && isFunction$8(n[Symbol.asyncIterator]), isArrowJSON = (n) => isObject$8(n) && isObject$8(n.schema), isIteratorResult = (n) => isObject$8(n) && "done" in n && "value" in n, isFileHandle = (n) => isObject$8(n) && isFunction$8(n.stat) && isNumber$6(n.fd), isFetchResponse = (n) => isObject$8(n) && isReadableDOMStream(n.body), isReadableInterop = (n) => "_getDOMStream" in n && "_getNodeStream" in n, isReadableDOMStream = (n) => isObject$8(n) && isFunction$8(n.cancel) && isFunction$8(n.getReader) && !isReadableInterop(n), isReadableNodeStream = (n) => isObject$8(n) && isFunction$8(n.read) && isFunction$8(n.pipe) && isBoolean$5(n.readable) && !isReadableInterop(n), isFlatbuffersByteBuffer = (n) => isObject$8(n) && isFunction$8(n.clear) && isFunction$8(n.bytes) && isFunction$8(n.position) && isFunction$8(n.setPosition) && isFunction$8(n.capacity) && isFunction$8(n.getBufferIdentifier) && isFunction$8(n.createLong), SharedArrayBuf = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : ArrayBuffer;
function collapseContiguousByteRanges(n) {
  const t = n[0] ? [n[0]] : [];
  let g, d, k, H;
  for (let AA, gA, IA = 0, CA = 0, BA = n.length; ++IA < BA; ) {
    if (AA = t[CA], gA = n[IA], !AA || !gA || AA.buffer !== gA.buffer || gA.byteOffset < AA.byteOffset) {
      gA && (t[++CA] = gA);
      continue;
    }
    if ({ byteOffset: g, byteLength: k } = AA, { byteOffset: d, byteLength: H } = gA, g + k < d || d + H < g) {
      gA && (t[++CA] = gA);
      continue;
    }
    t[CA] = new Uint8Array(AA.buffer, g, d - g + H);
  }
  return t;
}
function memcpy(n, t, g = 0, d = t.byteLength) {
  const k = n.byteLength, H = new Uint8Array(n.buffer, n.byteOffset, k), AA = new Uint8Array(t.buffer, t.byteOffset, Math.min(d, k));
  return H.set(AA, g), n;
}
function joinUint8Arrays(n, t) {
  const g = collapseContiguousByteRanges(n), d = g.reduce((BA, eA) => BA + eA.byteLength, 0);
  let k, H, AA, gA = 0, IA = -1;
  const CA = Math.min(t || Number.POSITIVE_INFINITY, d);
  for (const BA = g.length; ++IA < BA; ) {
    if (k = g[IA], H = k.subarray(0, Math.min(k.length, CA - gA)), CA <= gA + H.length) {
      H.length < k.length ? g[IA] = k.subarray(H.length) : H.length === k.length && IA++, AA ? memcpy(AA, H, gA) : AA = H;
      break;
    }
    memcpy(AA || (AA = new Uint8Array(CA)), H, gA), gA += H.length;
  }
  return [AA || new Uint8Array(0), g.slice(IA), d - (AA ? AA.byteLength : 0)];
}
function toArrayBufferView(n, t) {
  let g = isIteratorResult(t) ? t.value : t;
  return g instanceof n ? n === Uint8Array ? new n(g.buffer, g.byteOffset, g.byteLength) : g : g ? (typeof g == "string" && (g = encodeUtf8(g)), g instanceof ArrayBuffer ? new n(g) : g instanceof SharedArrayBuf ? new n(g) : isFlatbuffersByteBuffer(g) ? toArrayBufferView(n, g.bytes()) : ArrayBuffer.isView(g) ? g.byteLength <= 0 ? new n(0) : new n(g.buffer, g.byteOffset, g.byteLength / n.BYTES_PER_ELEMENT) : n.from(g)) : new n(0);
}
const toInt8Array = (n) => toArrayBufferView(Int8Array, n), toInt16Array = (n) => toArrayBufferView(Int16Array, n), toInt32Array = (n) => toArrayBufferView(Int32Array, n), toBigInt64Array = (n) => toArrayBufferView(BigInt64Array, n), toUint8Array = (n) => toArrayBufferView(Uint8Array, n), toUint16Array = (n) => toArrayBufferView(Uint16Array, n), toUint32Array = (n) => toArrayBufferView(Uint32Array, n), toBigUint64Array = (n) => toArrayBufferView(BigUint64Array, n), toFloat32Array = (n) => toArrayBufferView(Float32Array, n), toFloat64Array = (n) => toArrayBufferView(Float64Array, n), toUint8ClampedArray = (n) => toArrayBufferView(Uint8ClampedArray, n), pump$1 = (n) => (n.next(), n);
function* toArrayBufferViewIterator(n, t) {
  const g = function* (k) {
    yield k;
  }, d = typeof t == "string" || ArrayBuffer.isView(t) || t instanceof ArrayBuffer || t instanceof SharedArrayBuf ? g(t) : isIterable$2(t) ? t : g(t);
  return yield* pump$1((function* (k) {
    let H = null;
    do
      H = k.next(yield toArrayBufferView(n, H));
    while (!H.done);
  })(d[Symbol.iterator]())), new n();
}
const toInt8ArrayIterator = (n) => toArrayBufferViewIterator(Int8Array, n), toInt16ArrayIterator = (n) => toArrayBufferViewIterator(Int16Array, n), toInt32ArrayIterator = (n) => toArrayBufferViewIterator(Int32Array, n), toUint8ArrayIterator = (n) => toArrayBufferViewIterator(Uint8Array, n), toUint16ArrayIterator = (n) => toArrayBufferViewIterator(Uint16Array, n), toUint32ArrayIterator = (n) => toArrayBufferViewIterator(Uint32Array, n), toFloat32ArrayIterator = (n) => toArrayBufferViewIterator(Float32Array, n), toFloat64ArrayIterator = (n) => toArrayBufferViewIterator(Float64Array, n), toUint8ClampedArrayIterator = (n) => toArrayBufferViewIterator(Uint8ClampedArray, n);
function toArrayBufferViewAsyncIterator(n, t) {
  return __asyncGenerator(this, arguments, function* () {
    if (isPromise(t))
      return yield __await(yield __await(yield* __asyncDelegator(__asyncValues(toArrayBufferViewAsyncIterator(n, yield __await(t))))));
    const d = function(AA) {
      return __asyncGenerator(this, arguments, function* () {
        yield yield __await(yield __await(AA));
      });
    }, k = function(AA) {
      return __asyncGenerator(this, arguments, function* () {
        yield __await(yield* __asyncDelegator(__asyncValues(pump$1((function* (gA) {
          let IA = null;
          do
            IA = gA.next(yield IA?.value);
          while (!IA.done);
        })(AA[Symbol.iterator]())))));
      });
    }, H = typeof t == "string" || ArrayBuffer.isView(t) || t instanceof ArrayBuffer || t instanceof SharedArrayBuf ? d(t) : isIterable$2(t) ? k(t) : isAsyncIterable$1(t) ? t : d(t);
    return yield __await(
      // otherwise if AsyncIterable, use it
      yield* __asyncDelegator(__asyncValues(pump$1((function(AA) {
        return __asyncGenerator(this, arguments, function* () {
          let gA = null;
          do
            gA = yield __await(AA.next(yield yield __await(toArrayBufferView(n, gA))));
          while (!gA.done);
        });
      })(H[Symbol.asyncIterator]()))))
    ), yield __await(new n());
  });
}
const toInt8ArrayAsyncIterator = (n) => toArrayBufferViewAsyncIterator(Int8Array, n), toInt16ArrayAsyncIterator = (n) => toArrayBufferViewAsyncIterator(Int16Array, n), toInt32ArrayAsyncIterator = (n) => toArrayBufferViewAsyncIterator(Int32Array, n), toUint8ArrayAsyncIterator = (n) => toArrayBufferViewAsyncIterator(Uint8Array, n), toUint16ArrayAsyncIterator = (n) => toArrayBufferViewAsyncIterator(Uint16Array, n), toUint32ArrayAsyncIterator = (n) => toArrayBufferViewAsyncIterator(Uint32Array, n), toFloat32ArrayAsyncIterator = (n) => toArrayBufferViewAsyncIterator(Float32Array, n), toFloat64ArrayAsyncIterator = (n) => toArrayBufferViewAsyncIterator(Float64Array, n), toUint8ClampedArrayAsyncIterator = (n) => toArrayBufferViewAsyncIterator(Uint8ClampedArray, n);
function rebaseValueOffsets(n, t, g) {
  if (n !== 0) {
    g = g.slice(0, t);
    for (let d = -1, k = g.length; ++d < k; )
      g[d] += n;
  }
  return g.subarray(0, t);
}
function compareArrayLike(n, t) {
  let g = 0;
  const d = n.length;
  if (d !== t.length)
    return !1;
  if (d > 0)
    do
      if (n[g] !== t[g])
        return !1;
    while (++g < d);
  return !0;
}
const util_buffer_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compareArrayLike,
  joinUint8Arrays,
  memcpy,
  rebaseValueOffsets,
  toArrayBufferView,
  toArrayBufferViewAsyncIterator,
  toArrayBufferViewIterator,
  toBigInt64Array,
  toBigUint64Array,
  toFloat32Array,
  toFloat32ArrayAsyncIterator,
  toFloat32ArrayIterator,
  toFloat64Array,
  toFloat64ArrayAsyncIterator,
  toFloat64ArrayIterator,
  toInt16Array,
  toInt16ArrayAsyncIterator,
  toInt16ArrayIterator,
  toInt32Array,
  toInt32ArrayAsyncIterator,
  toInt32ArrayIterator,
  toInt8Array,
  toInt8ArrayAsyncIterator,
  toInt8ArrayIterator,
  toUint16Array,
  toUint16ArrayAsyncIterator,
  toUint16ArrayIterator,
  toUint32Array,
  toUint32ArrayAsyncIterator,
  toUint32ArrayIterator,
  toUint8Array,
  toUint8ArrayAsyncIterator,
  toUint8ArrayIterator,
  toUint8ClampedArray,
  toUint8ClampedArrayAsyncIterator,
  toUint8ClampedArrayIterator
}, Symbol.toStringTag, { value: "Module" })), streamAdapters = {
  fromIterable(n) {
    return pump(fromIterable(n));
  },
  fromAsyncIterable(n) {
    return pump(fromAsyncIterable(n));
  },
  fromDOMStream(n) {
    return pump(fromDOMStream(n));
  },
  fromNodeStream(n) {
    return pump(fromNodeStream(n));
  },
  // @ts-ignore
  toDOMStream(n, t) {
    throw new Error('"toDOMStream" not available in this environment');
  },
  // @ts-ignore
  toNodeStream(n, t) {
    throw new Error('"toNodeStream" not available in this environment');
  }
}, pump = (n) => (n.next(), n);
function* fromIterable(n) {
  let t, g = !1, d = [], k, H, AA, gA = 0;
  function IA() {
    return H === "peek" ? joinUint8Arrays(d, AA)[0] : ([k, d, gA] = joinUint8Arrays(d, AA), k);
  }
  ({ cmd: H, size: AA } = (yield null) || { cmd: "read", size: 0 });
  const CA = toUint8ArrayIterator(n)[Symbol.iterator]();
  try {
    do
      if ({ done: t, value: k } = Number.isNaN(AA - gA) ? CA.next() : CA.next(AA - gA), !t && k.byteLength > 0 && (d.push(k), gA += k.byteLength), t || AA <= gA)
        do
          ({ cmd: H, size: AA } = yield IA());
        while (AA < gA);
    while (!t);
  } catch (BA) {
    g = !0, typeof CA.throw == "function" && CA.throw(BA);
  } finally {
    g === !1 && typeof CA.return == "function" && CA.return(null);
  }
  return null;
}
function fromAsyncIterable(n) {
  return __asyncGenerator(this, arguments, function* () {
    let g, d = !1, k = [], H, AA, gA, IA = 0;
    function CA() {
      return AA === "peek" ? joinUint8Arrays(k, gA)[0] : ([H, k, IA] = joinUint8Arrays(k, gA), H);
    }
    ({ cmd: AA, size: gA } = (yield yield __await(null)) || { cmd: "read", size: 0 });
    const BA = toUint8ArrayAsyncIterator(n)[Symbol.asyncIterator]();
    try {
      do
        if ({ done: g, value: H } = Number.isNaN(gA - IA) ? yield __await(BA.next()) : yield __await(BA.next(gA - IA)), !g && H.byteLength > 0 && (k.push(H), IA += H.byteLength), g || gA <= IA)
          do
            ({ cmd: AA, size: gA } = yield yield __await(CA()));
          while (gA < IA);
      while (!g);
    } catch (eA) {
      d = !0, typeof BA.throw == "function" && (yield __await(BA.throw(eA)));
    } finally {
      d === !1 && typeof BA.return == "function" && (yield __await(BA.return(new Uint8Array(0))));
    }
    return yield __await(null);
  });
}
function fromDOMStream(n) {
  return __asyncGenerator(this, arguments, function* () {
    let g = !1, d = !1, k = [], H, AA, gA, IA = 0;
    function CA() {
      return AA === "peek" ? joinUint8Arrays(k, gA)[0] : ([H, k, IA] = joinUint8Arrays(k, gA), H);
    }
    ({ cmd: AA, size: gA } = (yield yield __await(null)) || { cmd: "read", size: 0 });
    const BA = new AdaptiveByteReader(n);
    try {
      do
        if ({ done: g, value: H } = Number.isNaN(gA - IA) ? yield __await(BA.read()) : yield __await(BA.read(gA - IA)), !g && H.byteLength > 0 && (k.push(toUint8Array(H)), IA += H.byteLength), g || gA <= IA)
          do
            ({ cmd: AA, size: gA } = yield yield __await(CA()));
          while (gA < IA);
      while (!g);
    } catch (eA) {
      d = !0, yield __await(BA.cancel(eA));
    } finally {
      d === !1 ? yield __await(BA.cancel()) : n.locked && BA.releaseLock();
    }
    return yield __await(null);
  });
}
class AdaptiveByteReader {
  constructor(t) {
    this.source = t, this.reader = null, this.reader = this.source.getReader(), this.reader.closed.catch(() => {
    });
  }
  get closed() {
    return this.reader ? this.reader.closed.catch(() => {
    }) : Promise.resolve();
  }
  releaseLock() {
    this.reader && this.reader.releaseLock(), this.reader = null;
  }
  cancel(t) {
    return __awaiter(this, void 0, void 0, function* () {
      const { reader: g, source: d } = this;
      g && (yield g.cancel(t).catch(() => {
      })), d && d.locked && this.releaseLock();
    });
  }
  read(t) {
    return __awaiter(this, void 0, void 0, function* () {
      if (t === 0)
        return { done: this.reader == null, value: new Uint8Array(0) };
      const g = yield this.reader.read();
      return !g.done && (g.value = toUint8Array(g)), g;
    });
  }
}
const onEvent = (n, t) => {
  const g = (k) => d([t, k]);
  let d;
  return [t, g, new Promise((k) => (d = k) && n.once(t, g))];
};
function fromNodeStream(n) {
  return __asyncGenerator(this, arguments, function* () {
    const g = [];
    let d = "error", k = !1, H = null, AA, gA, IA = 0, CA = [], BA;
    function eA() {
      return AA === "peek" ? joinUint8Arrays(CA, gA)[0] : ([BA, CA, IA] = joinUint8Arrays(CA, gA), BA);
    }
    if ({ cmd: AA, size: gA } = (yield yield __await(null)) || { cmd: "read", size: 0 }, n.isTTY)
      return yield yield __await(new Uint8Array(0)), yield __await(null);
    try {
      g[0] = onEvent(n, "end"), g[1] = onEvent(n, "error");
      do {
        if (g[2] = onEvent(n, "readable"), [d, H] = yield __await(Promise.race(g.map((QA) => QA[2]))), d === "error")
          break;
        if ((k = d === "end") || (Number.isFinite(gA - IA) ? (BA = toUint8Array(n.read(gA - IA)), BA.byteLength < gA - IA && (BA = toUint8Array(n.read()))) : BA = toUint8Array(n.read()), BA.byteLength > 0 && (CA.push(BA), IA += BA.byteLength)), k || gA <= IA)
          do
            ({ cmd: AA, size: gA } = yield yield __await(eA()));
          while (gA < IA);
      } while (!k);
    } finally {
      yield __await(iA(g, d === "error" ? H : null));
    }
    return yield __await(null);
    function iA(QA, tA) {
      return BA = CA = null, new Promise((oA, EA) => {
        for (const [aA, nA] of QA)
          n.off(aA, nA);
        try {
          const aA = n.destroy;
          aA && aA.call(n, tA), tA = void 0;
        } catch (aA) {
          tA = aA || tA;
        } finally {
          tA != null ? EA(tA) : oA();
        }
      });
    }
  });
}
var MetadataVersion;
(function(n) {
  n[n.V1 = 0] = "V1", n[n.V2 = 1] = "V2", n[n.V3 = 2] = "V3", n[n.V4 = 3] = "V4", n[n.V5 = 4] = "V5";
})(MetadataVersion || (MetadataVersion = {}));
var UnionMode;
(function(n) {
  n[n.Sparse = 0] = "Sparse", n[n.Dense = 1] = "Dense";
})(UnionMode || (UnionMode = {}));
var Precision;
(function(n) {
  n[n.HALF = 0] = "HALF", n[n.SINGLE = 1] = "SINGLE", n[n.DOUBLE = 2] = "DOUBLE";
})(Precision || (Precision = {}));
var DateUnit;
(function(n) {
  n[n.DAY = 0] = "DAY", n[n.MILLISECOND = 1] = "MILLISECOND";
})(DateUnit || (DateUnit = {}));
var TimeUnit$1;
(function(n) {
  n[n.SECOND = 0] = "SECOND", n[n.MILLISECOND = 1] = "MILLISECOND", n[n.MICROSECOND = 2] = "MICROSECOND", n[n.NANOSECOND = 3] = "NANOSECOND";
})(TimeUnit$1 || (TimeUnit$1 = {}));
var IntervalUnit;
(function(n) {
  n[n.YEAR_MONTH = 0] = "YEAR_MONTH", n[n.DAY_TIME = 1] = "DAY_TIME", n[n.MONTH_DAY_NANO = 2] = "MONTH_DAY_NANO";
})(IntervalUnit || (IntervalUnit = {}));
const SIZEOF_SHORT = 2, SIZEOF_INT = 4, FILE_IDENTIFIER_LENGTH = 4, SIZE_PREFIX_LENGTH = 4, int32 = new Int32Array(2), float32 = new Float32Array(int32.buffer), float64 = new Float64Array(int32.buffer), isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;
var Encoding;
(function(n) {
  n[n.UTF8_BYTES = 1] = "UTF8_BYTES", n[n.UTF16_STRING = 2] = "UTF16_STRING";
})(Encoding || (Encoding = {}));
let ByteBuffer$2 = class jI {
  /**
   * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
   */
  constructor(t) {
    this.bytes_ = t, this.position_ = 0, this.text_decoder_ = new TextDecoder();
  }
  /**
   * Create and allocate a new ByteBuffer with a given size.
   */
  static allocate(t) {
    return new jI(new Uint8Array(t));
  }
  clear() {
    this.position_ = 0;
  }
  /**
   * Get the underlying `Uint8Array`.
   */
  bytes() {
    return this.bytes_;
  }
  /**
   * Get the buffer's position.
   */
  position() {
    return this.position_;
  }
  /**
   * Set the buffer's position.
   */
  setPosition(t) {
    this.position_ = t;
  }
  /**
   * Get the buffer's capacity.
   */
  capacity() {
    return this.bytes_.length;
  }
  readInt8(t) {
    return this.readUint8(t) << 24 >> 24;
  }
  readUint8(t) {
    return this.bytes_[t];
  }
  readInt16(t) {
    return this.readUint16(t) << 16 >> 16;
  }
  readUint16(t) {
    return this.bytes_[t] | this.bytes_[t + 1] << 8;
  }
  readInt32(t) {
    return this.bytes_[t] | this.bytes_[t + 1] << 8 | this.bytes_[t + 2] << 16 | this.bytes_[t + 3] << 24;
  }
  readUint32(t) {
    return this.readInt32(t) >>> 0;
  }
  readInt64(t) {
    return BigInt.asIntN(64, BigInt(this.readUint32(t)) + (BigInt(this.readUint32(t + 4)) << BigInt(32)));
  }
  readUint64(t) {
    return BigInt.asUintN(64, BigInt(this.readUint32(t)) + (BigInt(this.readUint32(t + 4)) << BigInt(32)));
  }
  readFloat32(t) {
    return int32[0] = this.readInt32(t), float32[0];
  }
  readFloat64(t) {
    return int32[isLittleEndian ? 0 : 1] = this.readInt32(t), int32[isLittleEndian ? 1 : 0] = this.readInt32(t + 4), float64[0];
  }
  writeInt8(t, g) {
    this.bytes_[t] = g;
  }
  writeUint8(t, g) {
    this.bytes_[t] = g;
  }
  writeInt16(t, g) {
    this.bytes_[t] = g, this.bytes_[t + 1] = g >> 8;
  }
  writeUint16(t, g) {
    this.bytes_[t] = g, this.bytes_[t + 1] = g >> 8;
  }
  writeInt32(t, g) {
    this.bytes_[t] = g, this.bytes_[t + 1] = g >> 8, this.bytes_[t + 2] = g >> 16, this.bytes_[t + 3] = g >> 24;
  }
  writeUint32(t, g) {
    this.bytes_[t] = g, this.bytes_[t + 1] = g >> 8, this.bytes_[t + 2] = g >> 16, this.bytes_[t + 3] = g >> 24;
  }
  writeInt64(t, g) {
    this.writeInt32(t, Number(BigInt.asIntN(32, g))), this.writeInt32(t + 4, Number(BigInt.asIntN(32, g >> BigInt(32))));
  }
  writeUint64(t, g) {
    this.writeUint32(t, Number(BigInt.asUintN(32, g))), this.writeUint32(t + 4, Number(BigInt.asUintN(32, g >> BigInt(32))));
  }
  writeFloat32(t, g) {
    float32[0] = g, this.writeInt32(t, int32[0]);
  }
  writeFloat64(t, g) {
    float64[0] = g, this.writeInt32(t, int32[isLittleEndian ? 0 : 1]), this.writeInt32(t + 4, int32[isLittleEndian ? 1 : 0]);
  }
  /**
   * Return the file identifier.   Behavior is undefined for FlatBuffers whose
   * schema does not include a file_identifier (likely points at padding or the
   * start of a the root vtable).
   */
  getBufferIdentifier() {
    if (this.bytes_.length < this.position_ + SIZEOF_INT + FILE_IDENTIFIER_LENGTH)
      throw new Error("FlatBuffers: ByteBuffer is too short to contain an identifier.");
    let t = "";
    for (let g = 0; g < FILE_IDENTIFIER_LENGTH; g++)
      t += String.fromCharCode(this.readInt8(this.position_ + SIZEOF_INT + g));
    return t;
  }
  /**
   * Look up a field in the vtable, return an offset into the object, or 0 if the
   * field is not present.
   */
  __offset(t, g) {
    const d = t - this.readInt32(t);
    return g < this.readInt16(d) ? this.readInt16(d + g) : 0;
  }
  /**
   * Initialize any Table-derived type to point to the union at the given offset.
   */
  __union(t, g) {
    return t.bb_pos = g + this.readInt32(g), t.bb = this, t;
  }
  /**
   * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
   * This allocates a new string and converts to wide chars upon each access.
   *
   * To avoid the conversion to string, pass Encoding.UTF8_BYTES as the
   * "optionalEncoding" argument. This is useful for avoiding conversion when
   * the data will just be packaged back up in another FlatBuffer later on.
   *
   * @param offset
   * @param opt_encoding Defaults to UTF16_STRING
   */
  __string(t, g) {
    t += this.readInt32(t);
    const d = this.readInt32(t);
    t += SIZEOF_INT;
    const k = this.bytes_.subarray(t, t + d);
    return g === Encoding.UTF8_BYTES ? k : this.text_decoder_.decode(k);
  }
  /**
   * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
   * if a string then return a new one
   *
   * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
   * makes the behaviour of __union_with_string different compared to __union
   */
  __union_with_string(t, g) {
    return typeof t == "string" ? this.__string(g) : this.__union(t, g);
  }
  /**
   * Retrieve the relative offset stored at "offset"
   */
  __indirect(t) {
    return t + this.readInt32(t);
  }
  /**
   * Get the start of data of a vector whose offset is stored at "offset" in this object.
   */
  __vector(t) {
    return t + this.readInt32(t) + SIZEOF_INT;
  }
  /**
   * Get the length of a vector whose offset is stored at "offset" in this object.
   */
  __vector_len(t) {
    return this.readInt32(t + this.readInt32(t));
  }
  __has_identifier(t) {
    if (t.length != FILE_IDENTIFIER_LENGTH)
      throw new Error("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
    for (let g = 0; g < FILE_IDENTIFIER_LENGTH; g++)
      if (t.charCodeAt(g) != this.readInt8(this.position() + SIZEOF_INT + g))
        return !1;
    return !0;
  }
  /**
   * A helper function for generating list for obj api
   */
  createScalarList(t, g) {
    const d = [];
    for (let k = 0; k < g; ++k) {
      const H = t(k);
      H !== null && d.push(H);
    }
    return d;
  }
  /**
   * A helper function for generating list for obj api
   * @param listAccessor function that accepts an index and return data at that index
   * @param listLength listLength
   * @param res result list
   */
  createObjList(t, g) {
    const d = [];
    for (let k = 0; k < g; ++k) {
      const H = t(k);
      H !== null && d.push(H.unpack());
    }
    return d;
  }
}, Builder$2 = class PI {
  /**
   * Create a FlatBufferBuilder.
   */
  constructor(t) {
    this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null, this.text_encoder = new TextEncoder();
    let g;
    t ? g = t : g = 1024, this.bb = ByteBuffer$2.allocate(g), this.space = g;
  }
  clear() {
    this.bb.clear(), this.space = this.bb.capacity(), this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null;
  }
  /**
   * In order to save space, fields that are set to their default value
   * don't get serialized into the buffer. Forcing defaults provides a
   * way to manually disable this optimization.
   *
   * @param forceDefaults true always serializes default values
   */
  forceDefaults(t) {
    this.force_defaults = t;
  }
  /**
   * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
   * called finish(). The actual data starts at the ByteBuffer's current position,
   * not necessarily at 0.
   */
  dataBuffer() {
    return this.bb;
  }
  /**
   * Get the bytes representing the FlatBuffer. Only call this after you've
   * called finish().
   */
  asUint8Array() {
    return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
  }
  /**
   * Prepare to write an element of `size` after `additional_bytes` have been
   * written, e.g. if you write a string, you need to align such the int length
   * field is aligned to 4 bytes, and the string data follows it directly. If all
   * you need to do is alignment, `additional_bytes` will be 0.
   *
   * @param size This is the of the new element to write
   * @param additional_bytes The padding size
   */
  prep(t, g) {
    t > this.minalign && (this.minalign = t);
    const d = ~(this.bb.capacity() - this.space + g) + 1 & t - 1;
    for (; this.space < d + t + g; ) {
      const k = this.bb.capacity();
      this.bb = PI.growByteBuffer(this.bb), this.space += this.bb.capacity() - k;
    }
    this.pad(d);
  }
  pad(t) {
    for (let g = 0; g < t; g++)
      this.bb.writeInt8(--this.space, 0);
  }
  writeInt8(t) {
    this.bb.writeInt8(this.space -= 1, t);
  }
  writeInt16(t) {
    this.bb.writeInt16(this.space -= 2, t);
  }
  writeInt32(t) {
    this.bb.writeInt32(this.space -= 4, t);
  }
  writeInt64(t) {
    this.bb.writeInt64(this.space -= 8, t);
  }
  writeFloat32(t) {
    this.bb.writeFloat32(this.space -= 4, t);
  }
  writeFloat64(t) {
    this.bb.writeFloat64(this.space -= 8, t);
  }
  /**
   * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int8` to add the buffer.
   */
  addInt8(t) {
    this.prep(1, 0), this.writeInt8(t);
  }
  /**
   * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int16` to add the buffer.
   */
  addInt16(t) {
    this.prep(2, 0), this.writeInt16(t);
  }
  /**
   * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int32` to add the buffer.
   */
  addInt32(t) {
    this.prep(4, 0), this.writeInt32(t);
  }
  /**
   * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int64` to add the buffer.
   */
  addInt64(t) {
    this.prep(8, 0), this.writeInt64(t);
  }
  /**
   * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float32` to add the buffer.
   */
  addFloat32(t) {
    this.prep(4, 0), this.writeFloat32(t);
  }
  /**
   * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float64` to add the buffer.
   */
  addFloat64(t) {
    this.prep(8, 0), this.writeFloat64(t);
  }
  addFieldInt8(t, g, d) {
    (this.force_defaults || g != d) && (this.addInt8(g), this.slot(t));
  }
  addFieldInt16(t, g, d) {
    (this.force_defaults || g != d) && (this.addInt16(g), this.slot(t));
  }
  addFieldInt32(t, g, d) {
    (this.force_defaults || g != d) && (this.addInt32(g), this.slot(t));
  }
  addFieldInt64(t, g, d) {
    (this.force_defaults || g !== d) && (this.addInt64(g), this.slot(t));
  }
  addFieldFloat32(t, g, d) {
    (this.force_defaults || g != d) && (this.addFloat32(g), this.slot(t));
  }
  addFieldFloat64(t, g, d) {
    (this.force_defaults || g != d) && (this.addFloat64(g), this.slot(t));
  }
  addFieldOffset(t, g, d) {
    (this.force_defaults || g != d) && (this.addOffset(g), this.slot(t));
  }
  /**
   * Structs are stored inline, so nothing additional is being added. `d` is always 0.
   */
  addFieldStruct(t, g, d) {
    g != d && (this.nested(g), this.slot(t));
  }
  /**
   * Structures are always stored inline, they need to be created right
   * where they're used.  You'll get this assertion failure if you
   * created it elsewhere.
   */
  nested(t) {
    if (t != this.offset())
      throw new TypeError("FlatBuffers: struct must be serialized inline.");
  }
  /**
   * Should not be creating any other object, string or vector
   * while an object is being constructed
   */
  notNested() {
    if (this.isNested)
      throw new TypeError("FlatBuffers: object serialization must not be nested.");
  }
  /**
   * Set the current vtable at `voffset` to the current location in the buffer.
   */
  slot(t) {
    this.vtable !== null && (this.vtable[t] = this.offset());
  }
  /**
   * @returns Offset relative to the end of the buffer.
   */
  offset() {
    return this.bb.capacity() - this.space;
  }
  /**
   * Doubles the size of the backing ByteBuffer and copies the old data towards
   * the end of the new buffer (since we build the buffer backwards).
   *
   * @param bb The current buffer with the existing data
   * @returns A new byte buffer with the old data copied
   * to it. The data is located at the end of the buffer.
   *
   * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
   * it a uint8Array we need to suppress the type check:
   * @suppress {checkTypes}
   */
  static growByteBuffer(t) {
    const g = t.capacity();
    if (g & 3221225472)
      throw new Error("FlatBuffers: cannot grow buffer beyond 2 gigabytes.");
    const d = g << 1, k = ByteBuffer$2.allocate(d);
    return k.setPosition(d - g), k.bytes().set(t.bytes(), d - g), k;
  }
  /**
   * Adds on offset, relative to where it will be written.
   *
   * @param offset The offset to add.
   */
  addOffset(t) {
    this.prep(SIZEOF_INT, 0), this.writeInt32(this.offset() - t + SIZEOF_INT);
  }
  /**
   * Start encoding a new object in the buffer.  Users will not usually need to
   * call this directly. The FlatBuffers compiler will generate helper methods
   * that call this method internally.
   */
  startObject(t) {
    this.notNested(), this.vtable == null && (this.vtable = []), this.vtable_in_use = t;
    for (let g = 0; g < t; g++)
      this.vtable[g] = 0;
    this.isNested = !0, this.object_start = this.offset();
  }
  /**
   * Finish off writing the object that is under construction.
   *
   * @returns The offset to the object inside `dataBuffer`
   */
  endObject() {
    if (this.vtable == null || !this.isNested)
      throw new Error("FlatBuffers: endObject called without startObject");
    this.addInt32(0);
    const t = this.offset();
    let g = this.vtable_in_use - 1;
    for (; g >= 0 && this.vtable[g] == 0; g--)
      ;
    const d = g + 1;
    for (; g >= 0; g--)
      this.addInt16(this.vtable[g] != 0 ? t - this.vtable[g] : 0);
    const k = 2;
    this.addInt16(t - this.object_start);
    const H = (d + k) * SIZEOF_SHORT;
    this.addInt16(H);
    let AA = 0;
    const gA = this.space;
    A: for (g = 0; g < this.vtables.length; g++) {
      const IA = this.bb.capacity() - this.vtables[g];
      if (H == this.bb.readInt16(IA)) {
        for (let CA = SIZEOF_SHORT; CA < H; CA += SIZEOF_SHORT)
          if (this.bb.readInt16(gA + CA) != this.bb.readInt16(IA + CA))
            continue A;
        AA = this.vtables[g];
        break;
      }
    }
    return AA ? (this.space = this.bb.capacity() - t, this.bb.writeInt32(this.space, AA - t)) : (this.vtables.push(this.offset()), this.bb.writeInt32(this.bb.capacity() - t, this.offset() - t)), this.isNested = !1, t;
  }
  /**
   * Finalize a buffer, poiting to the given `root_table`.
   */
  finish(t, g, d) {
    const k = d ? SIZE_PREFIX_LENGTH : 0;
    if (g) {
      const H = g;
      if (this.prep(this.minalign, SIZEOF_INT + FILE_IDENTIFIER_LENGTH + k), H.length != FILE_IDENTIFIER_LENGTH)
        throw new TypeError("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
      for (let AA = FILE_IDENTIFIER_LENGTH - 1; AA >= 0; AA--)
        this.writeInt8(H.charCodeAt(AA));
    }
    this.prep(this.minalign, SIZEOF_INT + k), this.addOffset(t), k && this.addInt32(this.bb.capacity() - this.space), this.bb.setPosition(this.space);
  }
  /**
   * Finalize a size prefixed buffer, pointing to the given `root_table`.
   */
  finishSizePrefixed(t, g) {
    this.finish(t, g, !0);
  }
  /**
   * This checks a required field has been set in a given table that has
   * just been constructed.
   */
  requiredField(t, g) {
    const d = this.bb.capacity() - t, k = d - this.bb.readInt32(d);
    if (!(g < this.bb.readInt16(k) && this.bb.readInt16(k + g) != 0))
      throw new TypeError("FlatBuffers: field " + g + " must be set");
  }
  /**
   * Start a new array/vector of objects.  Users usually will not call
   * this directly. The FlatBuffers compiler will create a start/end
   * method for vector types in generated code.
   *
   * @param elem_size The size of each element in the array
   * @param num_elems The number of elements in the array
   * @param alignment The alignment of the array
   */
  startVector(t, g, d) {
    this.notNested(), this.vector_num_elems = g, this.prep(SIZEOF_INT, t * g), this.prep(d, t * g);
  }
  /**
   * Finish off the creation of an array and all its elements. The array must be
   * created with `startVector`.
   *
   * @returns The offset at which the newly created array
   * starts.
   */
  endVector() {
    return this.writeInt32(this.vector_num_elems), this.offset();
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If the string passed has
   * already been seen, we return the offset of the already written string
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createSharedString(t) {
    if (!t)
      return 0;
    if (this.string_maps || (this.string_maps = /* @__PURE__ */ new Map()), this.string_maps.has(t))
      return this.string_maps.get(t);
    const g = this.createString(t);
    return this.string_maps.set(t, g), g;
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
   * instead of a string, it is assumed to contain valid UTF-8 encoded data.
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createString(t) {
    if (t == null)
      return 0;
    let g;
    return t instanceof Uint8Array ? g = t : g = this.text_encoder.encode(t), this.addInt8(0), this.startVector(1, g.length, 1), this.bb.setPosition(this.space -= g.length), this.bb.bytes().set(g, this.space), this.endVector();
  }
  /**
   * Create a byte vector.
   *
   * @param v The bytes to add
   * @returns The offset in the buffer where the byte vector starts
   */
  createByteVector(t) {
    return t == null ? 0 : (this.startVector(1, t.length, 1), this.bb.setPosition(this.space -= t.length), this.bb.bytes().set(t, this.space), this.endVector());
  }
  /**
   * A helper function to pack an object
   *
   * @returns offset of obj
   */
  createObjectOffset(t) {
    return t === null ? 0 : typeof t == "string" ? this.createString(t) : t.pack(this);
  }
  /**
   * A helper function to pack a list of object
   *
   * @returns list of offsets of each non null object
   */
  createObjectOffsetList(t) {
    const g = [];
    for (let d = 0; d < t.length; ++d) {
      const k = t[d];
      if (k !== null)
        g.push(this.createObjectOffset(k));
      else
        throw new TypeError("FlatBuffers: Argument for createObjectOffsetList cannot contain null.");
    }
    return g;
  }
  createStructOffsetList(t, g) {
    return g(this, t.length), this.createObjectOffsetList(t.slice().reverse()), this.endVector();
  }
};
var BodyCompressionMethod;
(function(n) {
  n[n.BUFFER = 0] = "BUFFER";
})(BodyCompressionMethod || (BodyCompressionMethod = {}));
var CompressionType;
(function(n) {
  n[n.LZ4_FRAME = 0] = "LZ4_FRAME", n[n.ZSTD = 1] = "ZSTD";
})(CompressionType || (CompressionType = {}));
let BodyCompression$1 = class oI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsBodyCompression(t, g) {
    return (g || new oI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsBodyCompression(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new oI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Compressor library.
   * For LZ4_FRAME, each compressed buffer must consist of a single frame.
   */
  codec() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt8(this.bb_pos + t) : CompressionType.LZ4_FRAME;
  }
  /**
   * Indicates the way the record batch body was compressed
   */
  method() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readInt8(this.bb_pos + t) : BodyCompressionMethod.BUFFER;
  }
  static startBodyCompression(t) {
    t.startObject(2);
  }
  static addCodec(t, g) {
    t.addFieldInt8(0, g, CompressionType.LZ4_FRAME);
  }
  static addMethod(t, g) {
    t.addFieldInt8(1, g, BodyCompressionMethod.BUFFER);
  }
  static endBodyCompression(t) {
    return t.endObject();
  }
  static createBodyCompression(t, g, d) {
    return oI.startBodyCompression(t), oI.addCodec(t, g), oI.addMethod(t, d), oI.endBodyCompression(t);
  }
}, Buffer$3 = class {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  /**
   * The relative offset into the shared memory page where the bytes for this
   * buffer starts
   */
  offset() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * The absolute length (in bytes) of the memory buffer. The memory is found
   * from offset (inclusive) to offset + length (non-inclusive). When building
   * messages using the encapsulated IPC message, padding bytes may be written
   * after a buffer, but such padding bytes do not need to be accounted for in
   * the size here.
   */
  length() {
    return this.bb.readInt64(this.bb_pos + 8);
  }
  static sizeOf() {
    return 16;
  }
  static createBuffer(t, g, d) {
    return t.prep(8, 16), t.writeInt64(BigInt(d ?? 0)), t.writeInt64(BigInt(g ?? 0)), t.offset();
  }
}, FieldNode$1 = class {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  /**
   * The number of value slots in the Arrow array at this level of a nested
   * tree
   */
  length() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * The number of observed nulls. Fields with null_count == 0 may choose not
   * to write their physical validity bitmap out as a materialized buffer,
   * instead setting the length of the bitmap buffer to 0.
   */
  nullCount() {
    return this.bb.readInt64(this.bb_pos + 8);
  }
  static sizeOf() {
    return 16;
  }
  static createFieldNode(t, g, d) {
    return t.prep(8, 16), t.writeInt64(BigInt(d ?? 0)), t.writeInt64(BigInt(g ?? 0)), t.offset();
  }
}, RecordBatch$3 = class WI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsRecordBatch(t, g) {
    return (g || new WI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsRecordBatch(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new WI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * number of records / rows. The arrays in the batch should all have this
   * length
   */
  length() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt64(this.bb_pos + t) : BigInt("0");
  }
  /**
   * Nodes correspond to the pre-ordered flattened logical schema
   */
  nodes(t, g) {
    const d = this.bb.__offset(this.bb_pos, 6);
    return d ? (g || new FieldNode$1()).__init(this.bb.__vector(this.bb_pos + d) + t * 16, this.bb) : null;
  }
  nodesLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * Buffers correspond to the pre-ordered flattened buffer tree
   *
   * The number of buffers appended to this list depends on the schema. For
   * example, most primitive arrays will have 2 buffers, 1 for the validity
   * bitmap and 1 for the values. For struct arrays, there will only be a
   * single buffer for the validity (nulls) bitmap
   */
  buffers(t, g) {
    const d = this.bb.__offset(this.bb_pos, 8);
    return d ? (g || new Buffer$3()).__init(this.bb.__vector(this.bb_pos + d) + t * 16, this.bb) : null;
  }
  buffersLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * Optional compression of the message body
   */
  compression(t) {
    const g = this.bb.__offset(this.bb_pos, 10);
    return g ? (t || new BodyCompression$1()).__init(this.bb.__indirect(this.bb_pos + g), this.bb) : null;
  }
  static startRecordBatch(t) {
    t.startObject(4);
  }
  static addLength(t, g) {
    t.addFieldInt64(0, g, BigInt("0"));
  }
  static addNodes(t, g) {
    t.addFieldOffset(1, g, 0);
  }
  static startNodesVector(t, g) {
    t.startVector(16, g, 8);
  }
  static addBuffers(t, g) {
    t.addFieldOffset(2, g, 0);
  }
  static startBuffersVector(t, g) {
    t.startVector(16, g, 8);
  }
  static addCompression(t, g) {
    t.addFieldOffset(3, g, 0);
  }
  static endRecordBatch(t) {
    return t.endObject();
  }
}, DictionaryBatch$1 = class xI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsDictionaryBatch(t, g) {
    return (g || new xI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDictionaryBatch(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new xI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  id() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt64(this.bb_pos + t) : BigInt("0");
  }
  data(t) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? (t || new RecordBatch$3()).__init(this.bb.__indirect(this.bb_pos + g), this.bb) : null;
  }
  /**
   * If isDelta is true the values in the dictionary are to be appended to a
   * dictionary with the indicated id. If isDelta is false this dictionary
   * should replace the existing dictionary.
   */
  isDelta() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  static startDictionaryBatch(t) {
    t.startObject(3);
  }
  static addId(t, g) {
    t.addFieldInt64(0, g, BigInt("0"));
  }
  static addData(t, g) {
    t.addFieldOffset(1, g, 0);
  }
  static addIsDelta(t, g) {
    t.addFieldInt8(2, +g, 0);
  }
  static endDictionaryBatch(t) {
    return t.endObject();
  }
};
var Endianness;
(function(n) {
  n[n.Little = 0] = "Little", n[n.Big = 1] = "Big";
})(Endianness || (Endianness = {}));
var DictionaryKind;
(function(n) {
  n[n.DenseArray = 0] = "DenseArray";
})(DictionaryKind || (DictionaryKind = {}));
class Int {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsInt(t, g) {
    return (g || new Int()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsInt(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new Int()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  bitWidth() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  isSigned() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  static startInt(t) {
    t.startObject(2);
  }
  static addBitWidth(t, g) {
    t.addFieldInt32(0, g, 0);
  }
  static addIsSigned(t, g) {
    t.addFieldInt8(1, +g, 0);
  }
  static endInt(t) {
    return t.endObject();
  }
  static createInt(t, g, d) {
    return Int.startInt(t), Int.addBitWidth(t, g), Int.addIsSigned(t, d), Int.endInt(t);
  }
}
class DictionaryEncoding {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsDictionaryEncoding(t, g) {
    return (g || new DictionaryEncoding()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDictionaryEncoding(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new DictionaryEncoding()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * The known dictionary id in the application where this data is used. In
   * the file or streaming formats, the dictionary ids are found in the
   * DictionaryBatch messages
   */
  id() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt64(this.bb_pos + t) : BigInt("0");
  }
  /**
   * The dictionary indices are constrained to be non-negative integers. If
   * this field is null, the indices must be signed int32. To maximize
   * cross-language compatibility and performance, implementations are
   * recommended to prefer signed integer types over unsigned integer types
   * and to avoid uint64 indices unless they are required by an application.
   */
  indexType(t) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? (t || new Int()).__init(this.bb.__indirect(this.bb_pos + g), this.bb) : null;
  }
  /**
   * By default, dictionaries are not ordered, or the order does not have
   * semantic meaning. In some statistical, applications, dictionary-encoding
   * is used to represent ordered categorical data, and we provide a way to
   * preserve that metadata here
   */
  isOrdered() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  dictionaryKind() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.readInt16(this.bb_pos + t) : DictionaryKind.DenseArray;
  }
  static startDictionaryEncoding(t) {
    t.startObject(4);
  }
  static addId(t, g) {
    t.addFieldInt64(0, g, BigInt("0"));
  }
  static addIndexType(t, g) {
    t.addFieldOffset(1, g, 0);
  }
  static addIsOrdered(t, g) {
    t.addFieldInt8(2, +g, 0);
  }
  static addDictionaryKind(t, g) {
    t.addFieldInt16(3, g, DictionaryKind.DenseArray);
  }
  static endDictionaryEncoding(t) {
    return t.endObject();
  }
}
class KeyValue {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsKeyValue(t, g) {
    return (g || new KeyValue()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsKeyValue(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new KeyValue()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  key(t) {
    const g = this.bb.__offset(this.bb_pos, 4);
    return g ? this.bb.__string(this.bb_pos + g, t) : null;
  }
  value(t) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? this.bb.__string(this.bb_pos + g, t) : null;
  }
  static startKeyValue(t) {
    t.startObject(2);
  }
  static addKey(t, g) {
    t.addFieldOffset(0, g, 0);
  }
  static addValue(t, g) {
    t.addFieldOffset(1, g, 0);
  }
  static endKeyValue(t) {
    return t.endObject();
  }
  static createKeyValue(t, g, d) {
    return KeyValue.startKeyValue(t), KeyValue.addKey(t, g), KeyValue.addValue(t, d), KeyValue.endKeyValue(t);
  }
}
let Binary$1 = class wI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsBinary(t, g) {
    return (g || new wI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsBinary(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new wI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startBinary(t) {
    t.startObject(0);
  }
  static endBinary(t) {
    return t.endObject();
  }
  static createBinary(t) {
    return wI.startBinary(t), wI.endBinary(t);
  }
}, Bool$1 = class yI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsBool(t, g) {
    return (g || new yI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsBool(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new yI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startBool(t) {
    t.startObject(0);
  }
  static endBool(t) {
    return t.endObject();
  }
  static createBool(t) {
    return yI.startBool(t), yI.endBool(t);
  }
}, Date$1 = class dI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsDate(t, g) {
    return (g || new dI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDate(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new dI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : DateUnit.MILLISECOND;
  }
  static startDate(t) {
    t.startObject(1);
  }
  static addUnit(t, g) {
    t.addFieldInt16(0, g, DateUnit.MILLISECOND);
  }
  static endDate(t) {
    return t.endObject();
  }
  static createDate(t, g) {
    return dI.startDate(t), dI.addUnit(t, g), dI.endDate(t);
  }
}, Decimal$1 = class QI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsDecimal(t, g) {
    return (g || new QI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDecimal(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new QI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Total number of decimal digits
   */
  precision() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  /**
   * Number of digits after the decimal point "."
   */
  scale() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  /**
   * Number of bits per value. The only accepted widths are 128 and 256.
   * We use bitWidth for consistency with Int::bitWidth.
   */
  bitWidth() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.readInt32(this.bb_pos + t) : 128;
  }
  static startDecimal(t) {
    t.startObject(3);
  }
  static addPrecision(t, g) {
    t.addFieldInt32(0, g, 0);
  }
  static addScale(t, g) {
    t.addFieldInt32(1, g, 0);
  }
  static addBitWidth(t, g) {
    t.addFieldInt32(2, g, 128);
  }
  static endDecimal(t) {
    return t.endObject();
  }
  static createDecimal(t, g, d, k) {
    return QI.startDecimal(t), QI.addPrecision(t, g), QI.addScale(t, d), QI.addBitWidth(t, k), QI.endDecimal(t);
  }
}, Duration$2 = class GI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsDuration(t, g) {
    return (g || new GI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsDuration(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new GI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : TimeUnit$1.MILLISECOND;
  }
  static startDuration(t) {
    t.startObject(1);
  }
  static addUnit(t, g) {
    t.addFieldInt16(0, g, TimeUnit$1.MILLISECOND);
  }
  static endDuration(t) {
    return t.endObject();
  }
  static createDuration(t, g) {
    return GI.startDuration(t), GI.addUnit(t, g), GI.endDuration(t);
  }
}, FixedSizeBinary$1 = class hI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsFixedSizeBinary(t, g) {
    return (g || new hI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsFixedSizeBinary(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new hI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Number of bytes per value
   */
  byteWidth() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  static startFixedSizeBinary(t) {
    t.startObject(1);
  }
  static addByteWidth(t, g) {
    t.addFieldInt32(0, g, 0);
  }
  static endFixedSizeBinary(t) {
    return t.endObject();
  }
  static createFixedSizeBinary(t, g) {
    return hI.startFixedSizeBinary(t), hI.addByteWidth(t, g), hI.endFixedSizeBinary(t);
  }
}, FixedSizeList$2 = class DI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsFixedSizeList(t, g) {
    return (g || new DI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsFixedSizeList(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new DI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Number of list items per value
   */
  listSize() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt32(this.bb_pos + t) : 0;
  }
  static startFixedSizeList(t) {
    t.startObject(1);
  }
  static addListSize(t, g) {
    t.addFieldInt32(0, g, 0);
  }
  static endFixedSizeList(t) {
    return t.endObject();
  }
  static createFixedSizeList(t, g) {
    return DI.startFixedSizeList(t), DI.addListSize(t, g), DI.endFixedSizeList(t);
  }
};
class FloatingPoint {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsFloatingPoint(t, g) {
    return (g || new FloatingPoint()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsFloatingPoint(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new FloatingPoint()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  precision() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : Precision.HALF;
  }
  static startFloatingPoint(t) {
    t.startObject(1);
  }
  static addPrecision(t, g) {
    t.addFieldInt16(0, g, Precision.HALF);
  }
  static endFloatingPoint(t) {
    return t.endObject();
  }
  static createFloatingPoint(t, g) {
    return FloatingPoint.startFloatingPoint(t), FloatingPoint.addPrecision(t, g), FloatingPoint.endFloatingPoint(t);
  }
}
class Interval {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsInterval(t, g) {
    return (g || new Interval()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsInterval(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new Interval()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : IntervalUnit.YEAR_MONTH;
  }
  static startInterval(t) {
    t.startObject(1);
  }
  static addUnit(t, g) {
    t.addFieldInt16(0, g, IntervalUnit.YEAR_MONTH);
  }
  static endInterval(t) {
    return t.endObject();
  }
  static createInterval(t, g) {
    return Interval.startInterval(t), Interval.addUnit(t, g), Interval.endInterval(t);
  }
}
let LargeBinary$1 = class NI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsLargeBinary(t, g) {
    return (g || new NI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsLargeBinary(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new NI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startLargeBinary(t) {
    t.startObject(0);
  }
  static endLargeBinary(t) {
    return t.endObject();
  }
  static createLargeBinary(t) {
    return NI.startLargeBinary(t), NI.endLargeBinary(t);
  }
}, LargeUtf8$1 = class MI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsLargeUtf8(t, g) {
    return (g || new MI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsLargeUtf8(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new MI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startLargeUtf8(t) {
    t.startObject(0);
  }
  static endLargeUtf8(t) {
    return t.endObject();
  }
  static createLargeUtf8(t) {
    return MI.startLargeUtf8(t), MI.endLargeUtf8(t);
  }
}, List$1 = class kI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsList(t, g) {
    return (g || new kI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsList(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new kI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startList(t) {
    t.startObject(0);
  }
  static endList(t) {
    return t.endObject();
  }
  static createList(t) {
    return kI.startList(t), kI.endList(t);
  }
}, Map$2 = class bI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsMap(t, g) {
    return (g || new bI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsMap(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new bI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * Set to true if the keys within each value are sorted
   */
  keysSorted() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  static startMap(t) {
    t.startObject(1);
  }
  static addKeysSorted(t, g) {
    t.addFieldInt8(0, +g, 0);
  }
  static endMap(t) {
    return t.endObject();
  }
  static createMap(t, g) {
    return bI.startMap(t), bI.addKeysSorted(t, g), bI.endMap(t);
  }
}, Null$1 = class RI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsNull(t, g) {
    return (g || new RI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsNull(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new RI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startNull(t) {
    t.startObject(0);
  }
  static endNull(t) {
    return t.endObject();
  }
  static createNull(t) {
    return RI.startNull(t), RI.endNull(t);
  }
};
class Struct_ {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsStruct_(t, g) {
    return (g || new Struct_()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsStruct_(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new Struct_()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startStruct_(t) {
    t.startObject(0);
  }
  static endStruct_(t) {
    return t.endObject();
  }
  static createStruct_(t) {
    return Struct_.startStruct_(t), Struct_.endStruct_(t);
  }
}
let Time$1 = class EI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsTime(t, g) {
    return (g || new EI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsTime(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new EI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : TimeUnit$1.MILLISECOND;
  }
  bitWidth() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readInt32(this.bb_pos + t) : 32;
  }
  static startTime(t) {
    t.startObject(2);
  }
  static addUnit(t, g) {
    t.addFieldInt16(0, g, TimeUnit$1.MILLISECOND);
  }
  static addBitWidth(t, g) {
    t.addFieldInt32(1, g, 32);
  }
  static endTime(t) {
    return t.endObject();
  }
  static createTime(t, g, d) {
    return EI.startTime(t), EI.addUnit(t, g), EI.addBitWidth(t, d), EI.endTime(t);
  }
};
class Timestamp {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsTimestamp(t, g) {
    return (g || new Timestamp()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsTimestamp(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new Timestamp()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  unit() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : TimeUnit$1.SECOND;
  }
  timezone(t) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? this.bb.__string(this.bb_pos + g, t) : null;
  }
  static startTimestamp(t) {
    t.startObject(2);
  }
  static addUnit(t, g) {
    t.addFieldInt16(0, g, TimeUnit$1.SECOND);
  }
  static addTimezone(t, g) {
    t.addFieldOffset(1, g, 0);
  }
  static endTimestamp(t) {
    return t.endObject();
  }
  static createTimestamp(t, g, d) {
    return Timestamp.startTimestamp(t), Timestamp.addUnit(t, g), Timestamp.addTimezone(t, d), Timestamp.endTimestamp(t);
  }
}
let Union$1 = class aI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsUnion(t, g) {
    return (g || new aI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsUnion(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new aI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  mode() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : UnionMode.Sparse;
  }
  typeIds(t) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? this.bb.readInt32(this.bb.__vector(this.bb_pos + g) + t * 4) : 0;
  }
  typeIdsLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  typeIdsArray() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? new Int32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  static startUnion(t) {
    t.startObject(2);
  }
  static addMode(t, g) {
    t.addFieldInt16(0, g, UnionMode.Sparse);
  }
  static addTypeIds(t, g) {
    t.addFieldOffset(1, g, 0);
  }
  static createTypeIdsVector(t, g) {
    t.startVector(4, g.length, 4);
    for (let d = g.length - 1; d >= 0; d--)
      t.addInt32(g[d]);
    return t.endVector();
  }
  static startTypeIdsVector(t, g) {
    t.startVector(4, g, 4);
  }
  static endUnion(t) {
    return t.endObject();
  }
  static createUnion(t, g, d) {
    return aI.startUnion(t), aI.addMode(t, g), aI.addTypeIds(t, d), aI.endUnion(t);
  }
}, Utf8$1 = class FI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsUtf8(t, g) {
    return (g || new FI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsUtf8(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new FI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static startUtf8(t) {
    t.startObject(0);
  }
  static endUtf8(t) {
    return t.endObject();
  }
  static createUtf8(t) {
    return FI.startUtf8(t), FI.endUtf8(t);
  }
};
var Type$2;
(function(n) {
  n[n.NONE = 0] = "NONE", n[n.Null = 1] = "Null", n[n.Int = 2] = "Int", n[n.FloatingPoint = 3] = "FloatingPoint", n[n.Binary = 4] = "Binary", n[n.Utf8 = 5] = "Utf8", n[n.Bool = 6] = "Bool", n[n.Decimal = 7] = "Decimal", n[n.Date = 8] = "Date", n[n.Time = 9] = "Time", n[n.Timestamp = 10] = "Timestamp", n[n.Interval = 11] = "Interval", n[n.List = 12] = "List", n[n.Struct_ = 13] = "Struct_", n[n.Union = 14] = "Union", n[n.FixedSizeBinary = 15] = "FixedSizeBinary", n[n.FixedSizeList = 16] = "FixedSizeList", n[n.Map = 17] = "Map", n[n.Duration = 18] = "Duration", n[n.LargeBinary = 19] = "LargeBinary", n[n.LargeUtf8 = 20] = "LargeUtf8", n[n.LargeList = 21] = "LargeList", n[n.RunEndEncoded = 22] = "RunEndEncoded";
})(Type$2 || (Type$2 = {}));
let Field$3 = class JI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsField(t, g) {
    return (g || new JI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsField(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new JI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  name(t) {
    const g = this.bb.__offset(this.bb_pos, 4);
    return g ? this.bb.__string(this.bb_pos + g, t) : null;
  }
  /**
   * Whether or not this field can contain nulls. Should be true in general.
   */
  nullable() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? !!this.bb.readInt8(this.bb_pos + t) : !1;
  }
  typeType() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.readUint8(this.bb_pos + t) : Type$2.NONE;
  }
  /**
   * This is the type of the decoded value if the field is dictionary encoded.
   */
  type(t) {
    const g = this.bb.__offset(this.bb_pos, 10);
    return g ? this.bb.__union(t, this.bb_pos + g) : null;
  }
  /**
   * Present only if the field is dictionary encoded.
   */
  dictionary(t) {
    const g = this.bb.__offset(this.bb_pos, 12);
    return g ? (t || new DictionaryEncoding()).__init(this.bb.__indirect(this.bb_pos + g), this.bb) : null;
  }
  /**
   * children apply only to nested data types like Struct, List and Union. For
   * primitive types children will have length 0.
   */
  children(t, g) {
    const d = this.bb.__offset(this.bb_pos, 14);
    return d ? (g || new JI()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + d) + t * 4), this.bb) : null;
  }
  childrenLength() {
    const t = this.bb.__offset(this.bb_pos, 14);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * User-defined metadata
   */
  customMetadata(t, g) {
    const d = this.bb.__offset(this.bb_pos, 16);
    return d ? (g || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + d) + t * 4), this.bb) : null;
  }
  customMetadataLength() {
    const t = this.bb.__offset(this.bb_pos, 16);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startField(t) {
    t.startObject(7);
  }
  static addName(t, g) {
    t.addFieldOffset(0, g, 0);
  }
  static addNullable(t, g) {
    t.addFieldInt8(1, +g, 0);
  }
  static addTypeType(t, g) {
    t.addFieldInt8(2, g, Type$2.NONE);
  }
  static addType(t, g) {
    t.addFieldOffset(3, g, 0);
  }
  static addDictionary(t, g) {
    t.addFieldOffset(4, g, 0);
  }
  static addChildren(t, g) {
    t.addFieldOffset(5, g, 0);
  }
  static createChildrenVector(t, g) {
    t.startVector(4, g.length, 4);
    for (let d = g.length - 1; d >= 0; d--)
      t.addOffset(g[d]);
    return t.endVector();
  }
  static startChildrenVector(t, g) {
    t.startVector(4, g, 4);
  }
  static addCustomMetadata(t, g) {
    t.addFieldOffset(6, g, 0);
  }
  static createCustomMetadataVector(t, g) {
    t.startVector(4, g.length, 4);
    for (let d = g.length - 1; d >= 0; d--)
      t.addOffset(g[d]);
    return t.endVector();
  }
  static startCustomMetadataVector(t, g) {
    t.startVector(4, g, 4);
  }
  static endField(t) {
    return t.endObject();
  }
}, Schema$4 = class iI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsSchema(t, g) {
    return (g || new iI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsSchema(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new iI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  /**
   * endianness of the buffer
   * it is Little Endian by default
   * if endianness doesn't match the underlying system then the vectors need to be converted
   */
  endianness() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : Endianness.Little;
  }
  fields(t, g) {
    const d = this.bb.__offset(this.bb_pos, 6);
    return d ? (g || new Field$3()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + d) + t * 4), this.bb) : null;
  }
  fieldsLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  customMetadata(t, g) {
    const d = this.bb.__offset(this.bb_pos, 8);
    return d ? (g || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + d) + t * 4), this.bb) : null;
  }
  customMetadataLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * Features used in the stream/file.
   */
  features(t) {
    const g = this.bb.__offset(this.bb_pos, 10);
    return g ? this.bb.readInt64(this.bb.__vector(this.bb_pos + g) + t * 8) : BigInt(0);
  }
  featuresLength() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startSchema(t) {
    t.startObject(4);
  }
  static addEndianness(t, g) {
    t.addFieldInt16(0, g, Endianness.Little);
  }
  static addFields(t, g) {
    t.addFieldOffset(1, g, 0);
  }
  static createFieldsVector(t, g) {
    t.startVector(4, g.length, 4);
    for (let d = g.length - 1; d >= 0; d--)
      t.addOffset(g[d]);
    return t.endVector();
  }
  static startFieldsVector(t, g) {
    t.startVector(4, g, 4);
  }
  static addCustomMetadata(t, g) {
    t.addFieldOffset(2, g, 0);
  }
  static createCustomMetadataVector(t, g) {
    t.startVector(4, g.length, 4);
    for (let d = g.length - 1; d >= 0; d--)
      t.addOffset(g[d]);
    return t.endVector();
  }
  static startCustomMetadataVector(t, g) {
    t.startVector(4, g, 4);
  }
  static addFeatures(t, g) {
    t.addFieldOffset(3, g, 0);
  }
  static createFeaturesVector(t, g) {
    t.startVector(8, g.length, 8);
    for (let d = g.length - 1; d >= 0; d--)
      t.addInt64(g[d]);
    return t.endVector();
  }
  static startFeaturesVector(t, g) {
    t.startVector(8, g, 8);
  }
  static endSchema(t) {
    return t.endObject();
  }
  static finishSchemaBuffer(t, g) {
    t.finish(g);
  }
  static finishSizePrefixedSchemaBuffer(t, g) {
    t.finish(g, void 0, !0);
  }
  static createSchema(t, g, d, k, H) {
    return iI.startSchema(t), iI.addEndianness(t, g), iI.addFields(t, d), iI.addCustomMetadata(t, k), iI.addFeatures(t, H), iI.endSchema(t);
  }
};
var MessageHeader;
(function(n) {
  n[n.NONE = 0] = "NONE", n[n.Schema = 1] = "Schema", n[n.DictionaryBatch = 2] = "DictionaryBatch", n[n.RecordBatch = 3] = "RecordBatch", n[n.Tensor = 4] = "Tensor", n[n.SparseTensor = 5] = "SparseTensor";
})(MessageHeader || (MessageHeader = {}));
var Type$1;
(function(n) {
  n[n.NONE = 0] = "NONE", n[n.Null = 1] = "Null", n[n.Int = 2] = "Int", n[n.Float = 3] = "Float", n[n.Binary = 4] = "Binary", n[n.Utf8 = 5] = "Utf8", n[n.Bool = 6] = "Bool", n[n.Decimal = 7] = "Decimal", n[n.Date = 8] = "Date", n[n.Time = 9] = "Time", n[n.Timestamp = 10] = "Timestamp", n[n.Interval = 11] = "Interval", n[n.List = 12] = "List", n[n.Struct = 13] = "Struct", n[n.Union = 14] = "Union", n[n.FixedSizeBinary = 15] = "FixedSizeBinary", n[n.FixedSizeList = 16] = "FixedSizeList", n[n.Map = 17] = "Map", n[n.Duration = 18] = "Duration", n[n.LargeBinary = 19] = "LargeBinary", n[n.LargeUtf8 = 20] = "LargeUtf8", n[n.Dictionary = -1] = "Dictionary", n[n.Int8 = -2] = "Int8", n[n.Int16 = -3] = "Int16", n[n.Int32 = -4] = "Int32", n[n.Int64 = -5] = "Int64", n[n.Uint8 = -6] = "Uint8", n[n.Uint16 = -7] = "Uint16", n[n.Uint32 = -8] = "Uint32", n[n.Uint64 = -9] = "Uint64", n[n.Float16 = -10] = "Float16", n[n.Float32 = -11] = "Float32", n[n.Float64 = -12] = "Float64", n[n.DateDay = -13] = "DateDay", n[n.DateMillisecond = -14] = "DateMillisecond", n[n.TimestampSecond = -15] = "TimestampSecond", n[n.TimestampMillisecond = -16] = "TimestampMillisecond", n[n.TimestampMicrosecond = -17] = "TimestampMicrosecond", n[n.TimestampNanosecond = -18] = "TimestampNanosecond", n[n.TimeSecond = -19] = "TimeSecond", n[n.TimeMillisecond = -20] = "TimeMillisecond", n[n.TimeMicrosecond = -21] = "TimeMicrosecond", n[n.TimeNanosecond = -22] = "TimeNanosecond", n[n.DenseUnion = -23] = "DenseUnion", n[n.SparseUnion = -24] = "SparseUnion", n[n.IntervalDayTime = -25] = "IntervalDayTime", n[n.IntervalYearMonth = -26] = "IntervalYearMonth", n[n.DurationSecond = -27] = "DurationSecond", n[n.DurationMillisecond = -28] = "DurationMillisecond", n[n.DurationMicrosecond = -29] = "DurationMicrosecond", n[n.DurationNanosecond = -30] = "DurationNanosecond", n[n.IntervalMonthDayNano = -31] = "IntervalMonthDayNano";
})(Type$1 || (Type$1 = {}));
var BufferType;
(function(n) {
  n[n.OFFSET = 0] = "OFFSET", n[n.DATA = 1] = "DATA", n[n.VALIDITY = 2] = "VALIDITY", n[n.TYPE = 3] = "TYPE";
})(BufferType || (BufferType = {}));
const undf = void 0;
function valueToString(n) {
  if (n === null)
    return "null";
  if (n === undf)
    return "undefined";
  switch (typeof n) {
    case "number":
      return `${n}`;
    case "bigint":
      return `${n}`;
    case "string":
      return `"${n}"`;
  }
  return typeof n[Symbol.toPrimitive] == "function" ? n[Symbol.toPrimitive]("string") : ArrayBuffer.isView(n) ? n instanceof BigInt64Array || n instanceof BigUint64Array ? `[${[...n].map((t) => valueToString(t))}]` : `[${n}]` : ArrayBuffer.isView(n) ? `[${n}]` : JSON.stringify(n, (t, g) => typeof g == "bigint" ? `${g}` : g);
}
const util_pretty_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  valueToString
}, Symbol.toStringTag, { value: "Module" }));
function bigIntToNumber(n) {
  if (typeof n == "bigint" && (n < Number.MIN_SAFE_INTEGER || n > Number.MAX_SAFE_INTEGER))
    throw new TypeError(`${n} is not safe to convert to a number.`);
  return Number(n);
}
function divideBigInts(n, t) {
  return bigIntToNumber(n / t) + bigIntToNumber(n % t) / bigIntToNumber(t);
}
const isArrowBigNumSymbol = Symbol.for("isArrowBigNum");
function BigNum(n, ...t) {
  return t.length === 0 ? Object.setPrototypeOf(toArrayBufferView(this.TypedArray, n), this.constructor.prototype) : Object.setPrototypeOf(new this.TypedArray(n, ...t), this.constructor.prototype);
}
BigNum.prototype[isArrowBigNumSymbol] = !0;
BigNum.prototype.toJSON = function() {
  return `"${bigNumToString(this)}"`;
};
BigNum.prototype.valueOf = function(n) {
  return bigNumToNumber(this, n);
};
BigNum.prototype.toString = function() {
  return bigNumToString(this);
};
BigNum.prototype[Symbol.toPrimitive] = function(n = "default") {
  switch (n) {
    case "number":
      return bigNumToNumber(this);
    case "string":
      return bigNumToString(this);
    case "default":
      return bigNumToBigInt(this);
  }
  return bigNumToString(this);
};
function SignedBigNum(...n) {
  return BigNum.apply(this, n);
}
function UnsignedBigNum(...n) {
  return BigNum.apply(this, n);
}
function DecimalBigNum(...n) {
  return BigNum.apply(this, n);
}
Object.setPrototypeOf(SignedBigNum.prototype, Object.create(Int32Array.prototype));
Object.setPrototypeOf(UnsignedBigNum.prototype, Object.create(Uint32Array.prototype));
Object.setPrototypeOf(DecimalBigNum.prototype, Object.create(Uint32Array.prototype));
Object.assign(SignedBigNum.prototype, BigNum.prototype, { constructor: SignedBigNum, signed: !0, TypedArray: Int32Array, BigIntArray: BigInt64Array });
Object.assign(UnsignedBigNum.prototype, BigNum.prototype, { constructor: UnsignedBigNum, signed: !1, TypedArray: Uint32Array, BigIntArray: BigUint64Array });
Object.assign(DecimalBigNum.prototype, BigNum.prototype, { constructor: DecimalBigNum, signed: !0, TypedArray: Uint32Array, BigIntArray: BigUint64Array });
const TWO_TO_THE_64 = BigInt(4294967296) * BigInt(4294967296), TWO_TO_THE_64_MINUS_1 = TWO_TO_THE_64 - BigInt(1);
function bigNumToNumber(n, t) {
  const { buffer: g, byteOffset: d, byteLength: k, signed: H } = n, AA = new BigUint64Array(g, d, k / 8), gA = H && AA.at(-1) & BigInt(1) << BigInt(63);
  let IA = BigInt(0), CA = 0;
  if (gA) {
    for (const BA of AA)
      IA |= (BA ^ TWO_TO_THE_64_MINUS_1) * (BigInt(1) << BigInt(64 * CA++));
    IA *= BigInt(-1), IA -= BigInt(1);
  } else
    for (const BA of AA)
      IA |= BA * (BigInt(1) << BigInt(64 * CA++));
  if (typeof t == "number" && t > 0) {
    const BA = BigInt("1".padEnd(t + 1, "0")), eA = IA / BA, iA = gA ? -(IA % BA) : IA % BA, QA = bigIntToNumber(eA), tA = `${iA}`.padStart(t, "0");
    return +`${gA && QA === 0 ? "-" : ""}${QA}.${tA}`;
  }
  return bigIntToNumber(IA);
}
function bigNumToString(n) {
  if (n.byteLength === 8)
    return `${new n.BigIntArray(n.buffer, n.byteOffset, 1)[0]}`;
  if (!n.signed)
    return unsignedBigNumToString(n);
  let t = new Uint16Array(n.buffer, n.byteOffset, n.byteLength / 2);
  if (new Int16Array([t.at(-1)])[0] >= 0)
    return unsignedBigNumToString(n);
  t = t.slice();
  let d = 1;
  for (let H = 0; H < t.length; H++) {
    const AA = t[H], gA = ~AA + d;
    t[H] = gA, d &= AA === 0 ? 1 : 0;
  }
  return `-${unsignedBigNumToString(t)}`;
}
function bigNumToBigInt(n) {
  return n.byteLength === 8 ? new n.BigIntArray(n.buffer, n.byteOffset, 1)[0] : bigNumToString(n);
}
function unsignedBigNumToString(n) {
  let t = "";
  const g = new Uint32Array(2);
  let d = new Uint16Array(n.buffer, n.byteOffset, n.byteLength / 2);
  const k = new Uint32Array((d = new Uint16Array(d).reverse()).buffer);
  let H = -1;
  const AA = d.length - 1;
  do {
    for (g[0] = d[H = 0]; H < AA; )
      d[H++] = g[1] = g[0] / 10, g[0] = (g[0] - g[1] * 10 << 16) + d[H];
    d[H] = g[1] = g[0] / 10, g[0] = g[0] - g[1] * 10, t = `${g[0]}${t}`;
  } while (k[0] || k[1] || k[2] || k[3]);
  return t ?? "0";
}
class BN {
  /** @nocollapse */
  static new(t, g) {
    switch (g) {
      case !0:
        return new SignedBigNum(t);
      case !1:
        return new UnsignedBigNum(t);
    }
    switch (t.constructor) {
      case Int8Array:
      case Int16Array:
      case Int32Array:
      case BigInt64Array:
        return new SignedBigNum(t);
    }
    return t.byteLength === 16 ? new DecimalBigNum(t) : new UnsignedBigNum(t);
  }
  /** @nocollapse */
  static signed(t) {
    return new SignedBigNum(t);
  }
  /** @nocollapse */
  static unsigned(t) {
    return new UnsignedBigNum(t);
  }
  /** @nocollapse */
  static decimal(t) {
    return new DecimalBigNum(t);
  }
  constructor(t, g) {
    return BN.new(t, g);
  }
}
const util_bn_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BN,
  bigNumToBigInt,
  bigNumToNumber,
  bigNumToString,
  isArrowBigNumSymbol
}, Symbol.toStringTag, { value: "Module" }));
var _a$4, _b, _c$1, _d$1, _e, _f$1, _g$1, _h, _j, _k$1, _l, _m, _o$2, _p, _q, _r$1, _s, _t$2, _u$1, _v, _w, _x$1;
class DataType {
  /** @nocollapse */
  static isNull(t) {
    return t?.typeId === Type$1.Null;
  }
  /** @nocollapse */
  static isInt(t) {
    return t?.typeId === Type$1.Int;
  }
  /** @nocollapse */
  static isFloat(t) {
    return t?.typeId === Type$1.Float;
  }
  /** @nocollapse */
  static isBinary(t) {
    return t?.typeId === Type$1.Binary;
  }
  /** @nocollapse */
  static isLargeBinary(t) {
    return t?.typeId === Type$1.LargeBinary;
  }
  /** @nocollapse */
  static isUtf8(t) {
    return t?.typeId === Type$1.Utf8;
  }
  /** @nocollapse */
  static isLargeUtf8(t) {
    return t?.typeId === Type$1.LargeUtf8;
  }
  /** @nocollapse */
  static isBool(t) {
    return t?.typeId === Type$1.Bool;
  }
  /** @nocollapse */
  static isDecimal(t) {
    return t?.typeId === Type$1.Decimal;
  }
  /** @nocollapse */
  static isDate(t) {
    return t?.typeId === Type$1.Date;
  }
  /** @nocollapse */
  static isTime(t) {
    return t?.typeId === Type$1.Time;
  }
  /** @nocollapse */
  static isTimestamp(t) {
    return t?.typeId === Type$1.Timestamp;
  }
  /** @nocollapse */
  static isInterval(t) {
    return t?.typeId === Type$1.Interval;
  }
  /** @nocollapse */
  static isDuration(t) {
    return t?.typeId === Type$1.Duration;
  }
  /** @nocollapse */
  static isList(t) {
    return t?.typeId === Type$1.List;
  }
  /** @nocollapse */
  static isStruct(t) {
    return t?.typeId === Type$1.Struct;
  }
  /** @nocollapse */
  static isUnion(t) {
    return t?.typeId === Type$1.Union;
  }
  /** @nocollapse */
  static isFixedSizeBinary(t) {
    return t?.typeId === Type$1.FixedSizeBinary;
  }
  /** @nocollapse */
  static isFixedSizeList(t) {
    return t?.typeId === Type$1.FixedSizeList;
  }
  /** @nocollapse */
  static isMap(t) {
    return t?.typeId === Type$1.Map;
  }
  /** @nocollapse */
  static isDictionary(t) {
    return t?.typeId === Type$1.Dictionary;
  }
  /** @nocollapse */
  static isDenseUnion(t) {
    return DataType.isUnion(t) && t.mode === UnionMode.Dense;
  }
  /** @nocollapse */
  static isSparseUnion(t) {
    return DataType.isUnion(t) && t.mode === UnionMode.Sparse;
  }
  constructor(t) {
    this.typeId = t;
  }
}
_a$4 = Symbol.toStringTag;
DataType[_a$4] = ((n) => (n.children = null, n.ArrayType = Array, n.OffsetArrayType = Int32Array, n[Symbol.toStringTag] = "DataType"))(DataType.prototype);
class Null extends DataType {
  constructor() {
    super(Type$1.Null);
  }
  toString() {
    return "Null";
  }
}
_b = Symbol.toStringTag;
Null[_b] = ((n) => n[Symbol.toStringTag] = "Null")(Null.prototype);
class Int_ extends DataType {
  constructor(t, g) {
    super(Type$1.Int), this.isSigned = t, this.bitWidth = g;
  }
  get ArrayType() {
    switch (this.bitWidth) {
      case 8:
        return this.isSigned ? Int8Array : Uint8Array;
      case 16:
        return this.isSigned ? Int16Array : Uint16Array;
      case 32:
        return this.isSigned ? Int32Array : Uint32Array;
      case 64:
        return this.isSigned ? BigInt64Array : BigUint64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
  toString() {
    return `${this.isSigned ? "I" : "Ui"}nt${this.bitWidth}`;
  }
}
_c$1 = Symbol.toStringTag;
Int_[_c$1] = ((n) => (n.isSigned = null, n.bitWidth = null, n[Symbol.toStringTag] = "Int"))(Int_.prototype);
class Int32 extends Int_ {
  constructor() {
    super(!0, 32);
  }
  get ArrayType() {
    return Int32Array;
  }
}
Object.defineProperty(Int32.prototype, "ArrayType", { value: Int32Array });
class Float extends DataType {
  constructor(t) {
    super(Type$1.Float), this.precision = t;
  }
  get ArrayType() {
    switch (this.precision) {
      case Precision.HALF:
        return Uint16Array;
      case Precision.SINGLE:
        return Float32Array;
      case Precision.DOUBLE:
        return Float64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
  toString() {
    return `Float${this.precision << 5 || 16}`;
  }
}
_d$1 = Symbol.toStringTag;
Float[_d$1] = ((n) => (n.precision = null, n[Symbol.toStringTag] = "Float"))(Float.prototype);
class Binary extends DataType {
  constructor() {
    super(Type$1.Binary);
  }
  toString() {
    return "Binary";
  }
}
_e = Symbol.toStringTag;
Binary[_e] = ((n) => (n.ArrayType = Uint8Array, n[Symbol.toStringTag] = "Binary"))(Binary.prototype);
class LargeBinary extends DataType {
  constructor() {
    super(Type$1.LargeBinary);
  }
  toString() {
    return "LargeBinary";
  }
}
_f$1 = Symbol.toStringTag;
LargeBinary[_f$1] = ((n) => (n.ArrayType = Uint8Array, n.OffsetArrayType = BigInt64Array, n[Symbol.toStringTag] = "LargeBinary"))(LargeBinary.prototype);
class Utf8 extends DataType {
  constructor() {
    super(Type$1.Utf8);
  }
  toString() {
    return "Utf8";
  }
}
_g$1 = Symbol.toStringTag;
Utf8[_g$1] = ((n) => (n.ArrayType = Uint8Array, n[Symbol.toStringTag] = "Utf8"))(Utf8.prototype);
class LargeUtf8 extends DataType {
  constructor() {
    super(Type$1.LargeUtf8);
  }
  toString() {
    return "LargeUtf8";
  }
}
_h = Symbol.toStringTag;
LargeUtf8[_h] = ((n) => (n.ArrayType = Uint8Array, n.OffsetArrayType = BigInt64Array, n[Symbol.toStringTag] = "LargeUtf8"))(LargeUtf8.prototype);
class Bool extends DataType {
  constructor() {
    super(Type$1.Bool);
  }
  toString() {
    return "Bool";
  }
}
_j = Symbol.toStringTag;
Bool[_j] = ((n) => (n.ArrayType = Uint8Array, n[Symbol.toStringTag] = "Bool"))(Bool.prototype);
class Decimal extends DataType {
  constructor(t, g, d = 128) {
    super(Type$1.Decimal), this.scale = t, this.precision = g, this.bitWidth = d;
  }
  toString() {
    return `Decimal[${this.precision}e${this.scale > 0 ? "+" : ""}${this.scale}]`;
  }
}
_k$1 = Symbol.toStringTag;
Decimal[_k$1] = ((n) => (n.scale = null, n.precision = null, n.ArrayType = Uint32Array, n[Symbol.toStringTag] = "Decimal"))(Decimal.prototype);
class Date_ extends DataType {
  constructor(t) {
    super(Type$1.Date), this.unit = t;
  }
  toString() {
    return `Date${(this.unit + 1) * 32}<${DateUnit[this.unit]}>`;
  }
  get ArrayType() {
    return this.unit === DateUnit.DAY ? Int32Array : BigInt64Array;
  }
}
_l = Symbol.toStringTag;
Date_[_l] = ((n) => (n.unit = null, n[Symbol.toStringTag] = "Date"))(Date_.prototype);
class Time_ extends DataType {
  constructor(t, g) {
    super(Type$1.Time), this.unit = t, this.bitWidth = g;
  }
  toString() {
    return `Time${this.bitWidth}<${TimeUnit$1[this.unit]}>`;
  }
  get ArrayType() {
    switch (this.bitWidth) {
      case 32:
        return Int32Array;
      case 64:
        return BigInt64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
}
_m = Symbol.toStringTag;
Time_[_m] = ((n) => (n.unit = null, n.bitWidth = null, n[Symbol.toStringTag] = "Time"))(Time_.prototype);
class Timestamp_ extends DataType {
  constructor(t, g) {
    super(Type$1.Timestamp), this.unit = t, this.timezone = g;
  }
  toString() {
    return `Timestamp<${TimeUnit$1[this.unit]}${this.timezone ? `, ${this.timezone}` : ""}>`;
  }
}
_o$2 = Symbol.toStringTag;
Timestamp_[_o$2] = ((n) => (n.unit = null, n.timezone = null, n.ArrayType = BigInt64Array, n[Symbol.toStringTag] = "Timestamp"))(Timestamp_.prototype);
class Interval_ extends DataType {
  constructor(t) {
    super(Type$1.Interval), this.unit = t;
  }
  toString() {
    return `Interval<${IntervalUnit[this.unit]}>`;
  }
}
_p = Symbol.toStringTag;
Interval_[_p] = ((n) => (n.unit = null, n.ArrayType = Int32Array, n[Symbol.toStringTag] = "Interval"))(Interval_.prototype);
let Duration$1 = class extends DataType {
  constructor(t) {
    super(Type$1.Duration), this.unit = t;
  }
  toString() {
    return `Duration<${TimeUnit$1[this.unit]}>`;
  }
};
_q = Symbol.toStringTag;
Duration$1[_q] = ((n) => (n.unit = null, n.ArrayType = BigInt64Array, n[Symbol.toStringTag] = "Duration"))(Duration$1.prototype);
class List extends DataType {
  constructor(t) {
    super(Type$1.List), this.children = [t];
  }
  toString() {
    return `List<${this.valueType}>`;
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get ArrayType() {
    return this.valueType.ArrayType;
  }
}
_r$1 = Symbol.toStringTag;
List[_r$1] = ((n) => (n.children = null, n[Symbol.toStringTag] = "List"))(List.prototype);
class Struct extends DataType {
  constructor(t) {
    super(Type$1.Struct), this.children = t;
  }
  toString() {
    return `Struct<{${this.children.map((t) => `${t.name}:${t.type}`).join(", ")}}>`;
  }
}
_s = Symbol.toStringTag;
Struct[_s] = ((n) => (n.children = null, n[Symbol.toStringTag] = "Struct"))(Struct.prototype);
class Union_ extends DataType {
  constructor(t, g, d) {
    super(Type$1.Union), this.mode = t, this.children = d, this.typeIds = g = Int32Array.from(g), this.typeIdToChildIndex = g.reduce((k, H, AA) => (k[H] = AA) && k || k, /* @__PURE__ */ Object.create(null));
  }
  toString() {
    return `${this[Symbol.toStringTag]}<${this.children.map((t) => `${t.type}`).join(" | ")}>`;
  }
}
_t$2 = Symbol.toStringTag;
Union_[_t$2] = ((n) => (n.mode = null, n.typeIds = null, n.children = null, n.typeIdToChildIndex = null, n.ArrayType = Int8Array, n[Symbol.toStringTag] = "Union"))(Union_.prototype);
class FixedSizeBinary extends DataType {
  constructor(t) {
    super(Type$1.FixedSizeBinary), this.byteWidth = t;
  }
  toString() {
    return `FixedSizeBinary[${this.byteWidth}]`;
  }
}
_u$1 = Symbol.toStringTag;
FixedSizeBinary[_u$1] = ((n) => (n.byteWidth = null, n.ArrayType = Uint8Array, n[Symbol.toStringTag] = "FixedSizeBinary"))(FixedSizeBinary.prototype);
let FixedSizeList$1 = class extends DataType {
  constructor(t, g) {
    super(Type$1.FixedSizeList), this.listSize = t, this.children = [g];
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get ArrayType() {
    return this.valueType.ArrayType;
  }
  toString() {
    return `FixedSizeList[${this.listSize}]<${this.valueType}>`;
  }
};
_v = Symbol.toStringTag;
FixedSizeList$1[_v] = ((n) => (n.children = null, n.listSize = null, n[Symbol.toStringTag] = "FixedSizeList"))(FixedSizeList$1.prototype);
class Map_ extends DataType {
  constructor(t, g = !1) {
    var d, k, H;
    if (super(Type$1.Map), this.children = [t], this.keysSorted = g, t && (t.name = "entries", !((d = t?.type) === null || d === void 0) && d.children)) {
      const AA = (k = t?.type) === null || k === void 0 ? void 0 : k.children[0];
      AA && (AA.name = "key");
      const gA = (H = t?.type) === null || H === void 0 ? void 0 : H.children[1];
      gA && (gA.name = "value");
    }
  }
  get keyType() {
    return this.children[0].type.children[0].type;
  }
  get valueType() {
    return this.children[0].type.children[1].type;
  }
  get childType() {
    return this.children[0].type;
  }
  toString() {
    return `Map<{${this.children[0].type.children.map((t) => `${t.name}:${t.type}`).join(", ")}}>`;
  }
}
_w = Symbol.toStringTag;
Map_[_w] = ((n) => (n.children = null, n.keysSorted = null, n[Symbol.toStringTag] = "Map_"))(Map_.prototype);
const getId$1 = /* @__PURE__ */ ((n) => () => ++n)(-1);
class Dictionary extends DataType {
  constructor(t, g, d, k) {
    super(Type$1.Dictionary), this.indices = g, this.dictionary = t, this.isOrdered = k || !1, this.id = d == null ? getId$1() : bigIntToNumber(d);
  }
  get children() {
    return this.dictionary.children;
  }
  get valueType() {
    return this.dictionary;
  }
  get ArrayType() {
    return this.dictionary.ArrayType;
  }
  toString() {
    return `Dictionary<${this.indices}, ${this.dictionary}>`;
  }
}
_x$1 = Symbol.toStringTag;
Dictionary[_x$1] = ((n) => (n.id = null, n.indices = null, n.isOrdered = null, n.dictionary = null, n[Symbol.toStringTag] = "Dictionary"))(Dictionary.prototype);
function strideForType(n) {
  const t = n;
  switch (n.typeId) {
    case Type$1.Decimal:
      return n.bitWidth / 32;
    case Type$1.Interval:
      return t.unit === IntervalUnit.MONTH_DAY_NANO ? 4 : 1 + t.unit;
    // case Type.Int: return 1 + +((t as Int_).bitWidth > 32);
    // case Type.Time: return 1 + +((t as Time_).bitWidth > 32);
    case Type$1.FixedSizeList:
      return t.listSize;
    case Type$1.FixedSizeBinary:
      return t.byteWidth;
    default:
      return 1;
  }
}
class Visitor {
  visitMany(t, ...g) {
    return t.map((d, k) => this.visit(d, ...g.map((H) => H[k])));
  }
  visit(...t) {
    return this.getVisitFn(t[0], !1).apply(this, t);
  }
  getVisitFn(t, g = !0) {
    return getVisitFn(this, t, g);
  }
  getVisitFnByTypeId(t, g = !0) {
    return getVisitFnByTypeId(this, t, g);
  }
  visitNull(t, ...g) {
    return null;
  }
  visitBool(t, ...g) {
    return null;
  }
  visitInt(t, ...g) {
    return null;
  }
  visitFloat(t, ...g) {
    return null;
  }
  visitUtf8(t, ...g) {
    return null;
  }
  visitLargeUtf8(t, ...g) {
    return null;
  }
  visitBinary(t, ...g) {
    return null;
  }
  visitLargeBinary(t, ...g) {
    return null;
  }
  visitFixedSizeBinary(t, ...g) {
    return null;
  }
  visitDate(t, ...g) {
    return null;
  }
  visitTimestamp(t, ...g) {
    return null;
  }
  visitTime(t, ...g) {
    return null;
  }
  visitDecimal(t, ...g) {
    return null;
  }
  visitList(t, ...g) {
    return null;
  }
  visitStruct(t, ...g) {
    return null;
  }
  visitUnion(t, ...g) {
    return null;
  }
  visitDictionary(t, ...g) {
    return null;
  }
  visitInterval(t, ...g) {
    return null;
  }
  visitDuration(t, ...g) {
    return null;
  }
  visitFixedSizeList(t, ...g) {
    return null;
  }
  visitMap(t, ...g) {
    return null;
  }
}
function getVisitFn(n, t, g = !0) {
  return typeof t == "number" ? getVisitFnByTypeId(n, t, g) : typeof t == "string" && t in Type$1 ? getVisitFnByTypeId(n, Type$1[t], g) : t && t instanceof DataType ? getVisitFnByTypeId(n, inferDType(t), g) : t?.type && t.type instanceof DataType ? getVisitFnByTypeId(n, inferDType(t.type), g) : getVisitFnByTypeId(n, Type$1.NONE, g);
}
function getVisitFnByTypeId(n, t, g = !0) {
  let d = null;
  switch (t) {
    case Type$1.Null:
      d = n.visitNull;
      break;
    case Type$1.Bool:
      d = n.visitBool;
      break;
    case Type$1.Int:
      d = n.visitInt;
      break;
    case Type$1.Int8:
      d = n.visitInt8 || n.visitInt;
      break;
    case Type$1.Int16:
      d = n.visitInt16 || n.visitInt;
      break;
    case Type$1.Int32:
      d = n.visitInt32 || n.visitInt;
      break;
    case Type$1.Int64:
      d = n.visitInt64 || n.visitInt;
      break;
    case Type$1.Uint8:
      d = n.visitUint8 || n.visitInt;
      break;
    case Type$1.Uint16:
      d = n.visitUint16 || n.visitInt;
      break;
    case Type$1.Uint32:
      d = n.visitUint32 || n.visitInt;
      break;
    case Type$1.Uint64:
      d = n.visitUint64 || n.visitInt;
      break;
    case Type$1.Float:
      d = n.visitFloat;
      break;
    case Type$1.Float16:
      d = n.visitFloat16 || n.visitFloat;
      break;
    case Type$1.Float32:
      d = n.visitFloat32 || n.visitFloat;
      break;
    case Type$1.Float64:
      d = n.visitFloat64 || n.visitFloat;
      break;
    case Type$1.Utf8:
      d = n.visitUtf8;
      break;
    case Type$1.LargeUtf8:
      d = n.visitLargeUtf8;
      break;
    case Type$1.Binary:
      d = n.visitBinary;
      break;
    case Type$1.LargeBinary:
      d = n.visitLargeBinary;
      break;
    case Type$1.FixedSizeBinary:
      d = n.visitFixedSizeBinary;
      break;
    case Type$1.Date:
      d = n.visitDate;
      break;
    case Type$1.DateDay:
      d = n.visitDateDay || n.visitDate;
      break;
    case Type$1.DateMillisecond:
      d = n.visitDateMillisecond || n.visitDate;
      break;
    case Type$1.Timestamp:
      d = n.visitTimestamp;
      break;
    case Type$1.TimestampSecond:
      d = n.visitTimestampSecond || n.visitTimestamp;
      break;
    case Type$1.TimestampMillisecond:
      d = n.visitTimestampMillisecond || n.visitTimestamp;
      break;
    case Type$1.TimestampMicrosecond:
      d = n.visitTimestampMicrosecond || n.visitTimestamp;
      break;
    case Type$1.TimestampNanosecond:
      d = n.visitTimestampNanosecond || n.visitTimestamp;
      break;
    case Type$1.Time:
      d = n.visitTime;
      break;
    case Type$1.TimeSecond:
      d = n.visitTimeSecond || n.visitTime;
      break;
    case Type$1.TimeMillisecond:
      d = n.visitTimeMillisecond || n.visitTime;
      break;
    case Type$1.TimeMicrosecond:
      d = n.visitTimeMicrosecond || n.visitTime;
      break;
    case Type$1.TimeNanosecond:
      d = n.visitTimeNanosecond || n.visitTime;
      break;
    case Type$1.Decimal:
      d = n.visitDecimal;
      break;
    case Type$1.List:
      d = n.visitList;
      break;
    case Type$1.Struct:
      d = n.visitStruct;
      break;
    case Type$1.Union:
      d = n.visitUnion;
      break;
    case Type$1.DenseUnion:
      d = n.visitDenseUnion || n.visitUnion;
      break;
    case Type$1.SparseUnion:
      d = n.visitSparseUnion || n.visitUnion;
      break;
    case Type$1.Dictionary:
      d = n.visitDictionary;
      break;
    case Type$1.Interval:
      d = n.visitInterval;
      break;
    case Type$1.IntervalDayTime:
      d = n.visitIntervalDayTime || n.visitInterval;
      break;
    case Type$1.IntervalYearMonth:
      d = n.visitIntervalYearMonth || n.visitInterval;
      break;
    case Type$1.IntervalMonthDayNano:
      d = n.visitIntervalMonthDayNano || n.visitInterval;
      break;
    case Type$1.Duration:
      d = n.visitDuration;
      break;
    case Type$1.DurationSecond:
      d = n.visitDurationSecond || n.visitDuration;
      break;
    case Type$1.DurationMillisecond:
      d = n.visitDurationMillisecond || n.visitDuration;
      break;
    case Type$1.DurationMicrosecond:
      d = n.visitDurationMicrosecond || n.visitDuration;
      break;
    case Type$1.DurationNanosecond:
      d = n.visitDurationNanosecond || n.visitDuration;
      break;
    case Type$1.FixedSizeList:
      d = n.visitFixedSizeList;
      break;
    case Type$1.Map:
      d = n.visitMap;
      break;
  }
  if (typeof d == "function")
    return d;
  if (!g)
    return () => null;
  throw new Error(`Unrecognized type '${Type$1[t]}'`);
}
function inferDType(n) {
  switch (n.typeId) {
    case Type$1.Null:
      return Type$1.Null;
    case Type$1.Int: {
      const { bitWidth: t, isSigned: g } = n;
      switch (t) {
        case 8:
          return g ? Type$1.Int8 : Type$1.Uint8;
        case 16:
          return g ? Type$1.Int16 : Type$1.Uint16;
        case 32:
          return g ? Type$1.Int32 : Type$1.Uint32;
        case 64:
          return g ? Type$1.Int64 : Type$1.Uint64;
      }
      return Type$1.Int;
    }
    case Type$1.Float:
      switch (n.precision) {
        case Precision.HALF:
          return Type$1.Float16;
        case Precision.SINGLE:
          return Type$1.Float32;
        case Precision.DOUBLE:
          return Type$1.Float64;
      }
      return Type$1.Float;
    case Type$1.Binary:
      return Type$1.Binary;
    case Type$1.LargeBinary:
      return Type$1.LargeBinary;
    case Type$1.Utf8:
      return Type$1.Utf8;
    case Type$1.LargeUtf8:
      return Type$1.LargeUtf8;
    case Type$1.Bool:
      return Type$1.Bool;
    case Type$1.Decimal:
      return Type$1.Decimal;
    case Type$1.Time:
      switch (n.unit) {
        case TimeUnit$1.SECOND:
          return Type$1.TimeSecond;
        case TimeUnit$1.MILLISECOND:
          return Type$1.TimeMillisecond;
        case TimeUnit$1.MICROSECOND:
          return Type$1.TimeMicrosecond;
        case TimeUnit$1.NANOSECOND:
          return Type$1.TimeNanosecond;
      }
      return Type$1.Time;
    case Type$1.Timestamp:
      switch (n.unit) {
        case TimeUnit$1.SECOND:
          return Type$1.TimestampSecond;
        case TimeUnit$1.MILLISECOND:
          return Type$1.TimestampMillisecond;
        case TimeUnit$1.MICROSECOND:
          return Type$1.TimestampMicrosecond;
        case TimeUnit$1.NANOSECOND:
          return Type$1.TimestampNanosecond;
      }
      return Type$1.Timestamp;
    case Type$1.Date:
      switch (n.unit) {
        case DateUnit.DAY:
          return Type$1.DateDay;
        case DateUnit.MILLISECOND:
          return Type$1.DateMillisecond;
      }
      return Type$1.Date;
    case Type$1.Interval:
      switch (n.unit) {
        case IntervalUnit.DAY_TIME:
          return Type$1.IntervalDayTime;
        case IntervalUnit.YEAR_MONTH:
          return Type$1.IntervalYearMonth;
        case IntervalUnit.MONTH_DAY_NANO:
          return Type$1.IntervalMonthDayNano;
      }
      return Type$1.Interval;
    case Type$1.Duration:
      switch (n.unit) {
        case TimeUnit$1.SECOND:
          return Type$1.DurationSecond;
        case TimeUnit$1.MILLISECOND:
          return Type$1.DurationMillisecond;
        case TimeUnit$1.MICROSECOND:
          return Type$1.DurationMicrosecond;
        case TimeUnit$1.NANOSECOND:
          return Type$1.DurationNanosecond;
      }
      return Type$1.Duration;
    case Type$1.Map:
      return Type$1.Map;
    case Type$1.List:
      return Type$1.List;
    case Type$1.Struct:
      return Type$1.Struct;
    case Type$1.Union:
      switch (n.mode) {
        case UnionMode.Dense:
          return Type$1.DenseUnion;
        case UnionMode.Sparse:
          return Type$1.SparseUnion;
      }
      return Type$1.Union;
    case Type$1.FixedSizeBinary:
      return Type$1.FixedSizeBinary;
    case Type$1.FixedSizeList:
      return Type$1.FixedSizeList;
    case Type$1.Dictionary:
      return Type$1.Dictionary;
  }
  throw new Error(`Unrecognized type '${Type$1[n.typeId]}'`);
}
Visitor.prototype.visitInt8 = null;
Visitor.prototype.visitInt16 = null;
Visitor.prototype.visitInt32 = null;
Visitor.prototype.visitInt64 = null;
Visitor.prototype.visitUint8 = null;
Visitor.prototype.visitUint16 = null;
Visitor.prototype.visitUint32 = null;
Visitor.prototype.visitUint64 = null;
Visitor.prototype.visitFloat16 = null;
Visitor.prototype.visitFloat32 = null;
Visitor.prototype.visitFloat64 = null;
Visitor.prototype.visitDateDay = null;
Visitor.prototype.visitDateMillisecond = null;
Visitor.prototype.visitTimestampSecond = null;
Visitor.prototype.visitTimestampMillisecond = null;
Visitor.prototype.visitTimestampMicrosecond = null;
Visitor.prototype.visitTimestampNanosecond = null;
Visitor.prototype.visitTimeSecond = null;
Visitor.prototype.visitTimeMillisecond = null;
Visitor.prototype.visitTimeMicrosecond = null;
Visitor.prototype.visitTimeNanosecond = null;
Visitor.prototype.visitDenseUnion = null;
Visitor.prototype.visitSparseUnion = null;
Visitor.prototype.visitIntervalDayTime = null;
Visitor.prototype.visitIntervalYearMonth = null;
Visitor.prototype.visitIntervalMonthDayNano = null;
Visitor.prototype.visitDuration = null;
Visitor.prototype.visitDurationSecond = null;
Visitor.prototype.visitDurationMillisecond = null;
Visitor.prototype.visitDurationMicrosecond = null;
Visitor.prototype.visitDurationNanosecond = null;
const f64 = new Float64Array(1), u32 = new Uint32Array(f64.buffer);
function uint16ToFloat64(n) {
  const t = (n & 31744) >> 10, g = (n & 1023) / 1024, d = Math.pow(-1, (n & 32768) >> 15);
  switch (t) {
    case 31:
      return d * (g ? Number.NaN : 1 / 0);
    case 0:
      return d * (g ? 6103515625e-14 * g : 0);
  }
  return d * Math.pow(2, t - 15) * (1 + g);
}
function float64ToUint16(n) {
  if (n !== n)
    return 32256;
  f64[0] = n;
  const t = (u32[1] & 2147483648) >> 16 & 65535;
  let g = u32[1] & 2146435072, d = 0;
  return g >= 1089470464 ? u32[0] > 0 ? g = 31744 : (g = (g & 2080374784) >> 16, d = (u32[1] & 1048575) >> 10) : g <= 1056964608 ? (d = 1048576 + (u32[1] & 1048575), d = 1048576 + (d << (g >> 20) - 998) >> 21, g = 0) : (g = g - 1056964608 >> 10, d = (u32[1] & 1048575) + 512 >> 10), t | g | d & 65535;
}
const util_math_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  float64ToUint16,
  uint16ToFloat64
}, Symbol.toStringTag, { value: "Module" }));
class SetVisitor extends Visitor {
}
function wrapSet(n) {
  return (t, g, d) => {
    if (t.setValid(g, d != null))
      return n(t, g, d);
  };
}
const setEpochMsToDays = (n, t, g) => {
  n[t] = Math.floor(g / 864e5);
}, setVariableWidthBytes = (n, t, g, d) => {
  if (g + 1 < t.length) {
    const k = bigIntToNumber(t[g]), H = bigIntToNumber(t[g + 1]);
    n.set(d.subarray(0, H - k), k);
  }
}, setBool$1 = ({ offset: n, values: t }, g, d) => {
  const k = n + g;
  d ? t[k >> 3] |= 1 << k % 8 : t[k >> 3] &= ~(1 << k % 8);
}, setInt = ({ values: n }, t, g) => {
  n[t] = g;
}, setFloat = ({ values: n }, t, g) => {
  n[t] = g;
}, setFloat16 = ({ values: n }, t, g) => {
  n[t] = float64ToUint16(g);
}, setAnyFloat = (n, t, g) => {
  switch (n.type.precision) {
    case Precision.HALF:
      return setFloat16(n, t, g);
    case Precision.SINGLE:
    case Precision.DOUBLE:
      return setFloat(n, t, g);
  }
}, setDateDay = ({ values: n }, t, g) => {
  setEpochMsToDays(n, t, g.valueOf());
}, setDateMillisecond = ({ values: n }, t, g) => {
  n[t] = BigInt(g);
}, setFixedSizeBinary = ({ stride: n, values: t }, g, d) => {
  t.set(d.subarray(0, n), n * g);
}, setBinary = ({ values: n, valueOffsets: t }, g, d) => setVariableWidthBytes(n, t, g, d), setUtf8 = ({ values: n, valueOffsets: t }, g, d) => setVariableWidthBytes(n, t, g, encodeUtf8(d)), setDate = (n, t, g) => {
  n.type.unit === DateUnit.DAY ? setDateDay(n, t, g) : setDateMillisecond(n, t, g);
}, setTimestampSecond = ({ values: n }, t, g) => {
  n[t] = BigInt(g / 1e3);
}, setTimestampMillisecond = ({ values: n }, t, g) => {
  n[t] = BigInt(g);
}, setTimestampMicrosecond = ({ values: n }, t, g) => {
  n[t] = BigInt(g * 1e3);
}, setTimestampNanosecond = ({ values: n }, t, g) => {
  n[t] = BigInt(g * 1e6);
}, setTimestamp = (n, t, g) => {
  switch (n.type.unit) {
    case TimeUnit$1.SECOND:
      return setTimestampSecond(n, t, g);
    case TimeUnit$1.MILLISECOND:
      return setTimestampMillisecond(n, t, g);
    case TimeUnit$1.MICROSECOND:
      return setTimestampMicrosecond(n, t, g);
    case TimeUnit$1.NANOSECOND:
      return setTimestampNanosecond(n, t, g);
  }
}, setTimeSecond = ({ values: n }, t, g) => {
  n[t] = g;
}, setTimeMillisecond = ({ values: n }, t, g) => {
  n[t] = g;
}, setTimeMicrosecond = ({ values: n }, t, g) => {
  n[t] = g;
}, setTimeNanosecond = ({ values: n }, t, g) => {
  n[t] = g;
}, setTime = (n, t, g) => {
  switch (n.type.unit) {
    case TimeUnit$1.SECOND:
      return setTimeSecond(n, t, g);
    case TimeUnit$1.MILLISECOND:
      return setTimeMillisecond(n, t, g);
    case TimeUnit$1.MICROSECOND:
      return setTimeMicrosecond(n, t, g);
    case TimeUnit$1.NANOSECOND:
      return setTimeNanosecond(n, t, g);
  }
}, setDecimal = ({ values: n, stride: t }, g, d) => {
  n.set(d.subarray(0, t), t * g);
}, setList = (n, t, g) => {
  const d = n.children[0], k = n.valueOffsets, H = instance$5.getVisitFn(d);
  if (Array.isArray(g))
    for (let AA = -1, gA = k[t], IA = k[t + 1]; gA < IA; )
      H(d, gA++, g[++AA]);
  else
    for (let AA = -1, gA = k[t], IA = k[t + 1]; gA < IA; )
      H(d, gA++, g.get(++AA));
}, setMap = (n, t, g) => {
  const d = n.children[0], { valueOffsets: k } = n, H = instance$5.getVisitFn(d);
  let { [t]: AA, [t + 1]: gA } = k;
  const IA = g instanceof Map ? g.entries() : Object.entries(g);
  for (const CA of IA)
    if (H(d, AA, CA), ++AA >= gA)
      break;
}, _setStructArrayValue = (n, t) => (g, d, k, H) => d && g(d, n, t[H]), _setStructVectorValue = (n, t) => (g, d, k, H) => d && g(d, n, t.get(H)), _setStructMapValue = (n, t) => (g, d, k, H) => d && g(d, n, t.get(k.name)), _setStructObjectValue = (n, t) => (g, d, k, H) => d && g(d, n, t[k.name]), setStruct = (n, t, g) => {
  const d = n.type.children.map((H) => instance$5.getVisitFn(H.type)), k = g instanceof Map ? _setStructMapValue(t, g) : g instanceof Vector ? _setStructVectorValue(t, g) : Array.isArray(g) ? _setStructArrayValue(t, g) : _setStructObjectValue(t, g);
  n.type.children.forEach((H, AA) => k(d[AA], n.children[AA], H, AA));
}, setUnion = (n, t, g) => {
  n.type.mode === UnionMode.Dense ? setDenseUnion(n, t, g) : setSparseUnion(n, t, g);
}, setDenseUnion = (n, t, g) => {
  const d = n.type.typeIdToChildIndex[n.typeIds[t]], k = n.children[d];
  instance$5.visit(k, n.valueOffsets[t], g);
}, setSparseUnion = (n, t, g) => {
  const d = n.type.typeIdToChildIndex[n.typeIds[t]], k = n.children[d];
  instance$5.visit(k, t, g);
}, setDictionary = (n, t, g) => {
  var d;
  (d = n.dictionary) === null || d === void 0 || d.set(n.values[t], g);
}, setIntervalValue = (n, t, g) => {
  switch (n.type.unit) {
    case IntervalUnit.YEAR_MONTH:
      return setIntervalYearMonth(n, t, g);
    case IntervalUnit.DAY_TIME:
      return setIntervalDayTime(n, t, g);
    case IntervalUnit.MONTH_DAY_NANO:
      return setIntervalMonthDayNano(n, t, g);
  }
}, setIntervalDayTime = ({ values: n }, t, g) => {
  n.set(g.subarray(0, 2), 2 * t);
}, setIntervalYearMonth = ({ values: n }, t, g) => {
  n[t] = g[0] * 12 + g[1] % 12;
}, setIntervalMonthDayNano = ({ values: n, stride: t }, g, d) => {
  n.set(d.subarray(0, t), t * g);
}, setDurationSecond = ({ values: n }, t, g) => {
  n[t] = g;
}, setDurationMillisecond = ({ values: n }, t, g) => {
  n[t] = g;
}, setDurationMicrosecond = ({ values: n }, t, g) => {
  n[t] = g;
}, setDurationNanosecond = ({ values: n }, t, g) => {
  n[t] = g;
}, setDuration = (n, t, g) => {
  switch (n.type.unit) {
    case TimeUnit$1.SECOND:
      return setDurationSecond(n, t, g);
    case TimeUnit$1.MILLISECOND:
      return setDurationMillisecond(n, t, g);
    case TimeUnit$1.MICROSECOND:
      return setDurationMicrosecond(n, t, g);
    case TimeUnit$1.NANOSECOND:
      return setDurationNanosecond(n, t, g);
  }
}, setFixedSizeList = (n, t, g) => {
  const { stride: d } = n, k = n.children[0], H = instance$5.getVisitFn(k);
  if (Array.isArray(g))
    for (let AA = -1, gA = t * d; ++AA < d; )
      H(k, gA + AA, g[AA]);
  else
    for (let AA = -1, gA = t * d; ++AA < d; )
      H(k, gA + AA, g.get(AA));
};
SetVisitor.prototype.visitBool = wrapSet(setBool$1);
SetVisitor.prototype.visitInt = wrapSet(setInt);
SetVisitor.prototype.visitInt8 = wrapSet(setInt);
SetVisitor.prototype.visitInt16 = wrapSet(setInt);
SetVisitor.prototype.visitInt32 = wrapSet(setInt);
SetVisitor.prototype.visitInt64 = wrapSet(setInt);
SetVisitor.prototype.visitUint8 = wrapSet(setInt);
SetVisitor.prototype.visitUint16 = wrapSet(setInt);
SetVisitor.prototype.visitUint32 = wrapSet(setInt);
SetVisitor.prototype.visitUint64 = wrapSet(setInt);
SetVisitor.prototype.visitFloat = wrapSet(setAnyFloat);
SetVisitor.prototype.visitFloat16 = wrapSet(setFloat16);
SetVisitor.prototype.visitFloat32 = wrapSet(setFloat);
SetVisitor.prototype.visitFloat64 = wrapSet(setFloat);
SetVisitor.prototype.visitUtf8 = wrapSet(setUtf8);
SetVisitor.prototype.visitLargeUtf8 = wrapSet(setUtf8);
SetVisitor.prototype.visitBinary = wrapSet(setBinary);
SetVisitor.prototype.visitLargeBinary = wrapSet(setBinary);
SetVisitor.prototype.visitFixedSizeBinary = wrapSet(setFixedSizeBinary);
SetVisitor.prototype.visitDate = wrapSet(setDate);
SetVisitor.prototype.visitDateDay = wrapSet(setDateDay);
SetVisitor.prototype.visitDateMillisecond = wrapSet(setDateMillisecond);
SetVisitor.prototype.visitTimestamp = wrapSet(setTimestamp);
SetVisitor.prototype.visitTimestampSecond = wrapSet(setTimestampSecond);
SetVisitor.prototype.visitTimestampMillisecond = wrapSet(setTimestampMillisecond);
SetVisitor.prototype.visitTimestampMicrosecond = wrapSet(setTimestampMicrosecond);
SetVisitor.prototype.visitTimestampNanosecond = wrapSet(setTimestampNanosecond);
SetVisitor.prototype.visitTime = wrapSet(setTime);
SetVisitor.prototype.visitTimeSecond = wrapSet(setTimeSecond);
SetVisitor.prototype.visitTimeMillisecond = wrapSet(setTimeMillisecond);
SetVisitor.prototype.visitTimeMicrosecond = wrapSet(setTimeMicrosecond);
SetVisitor.prototype.visitTimeNanosecond = wrapSet(setTimeNanosecond);
SetVisitor.prototype.visitDecimal = wrapSet(setDecimal);
SetVisitor.prototype.visitList = wrapSet(setList);
SetVisitor.prototype.visitStruct = wrapSet(setStruct);
SetVisitor.prototype.visitUnion = wrapSet(setUnion);
SetVisitor.prototype.visitDenseUnion = wrapSet(setDenseUnion);
SetVisitor.prototype.visitSparseUnion = wrapSet(setSparseUnion);
SetVisitor.prototype.visitDictionary = wrapSet(setDictionary);
SetVisitor.prototype.visitInterval = wrapSet(setIntervalValue);
SetVisitor.prototype.visitIntervalDayTime = wrapSet(setIntervalDayTime);
SetVisitor.prototype.visitIntervalYearMonth = wrapSet(setIntervalYearMonth);
SetVisitor.prototype.visitIntervalMonthDayNano = wrapSet(setIntervalMonthDayNano);
SetVisitor.prototype.visitDuration = wrapSet(setDuration);
SetVisitor.prototype.visitDurationSecond = wrapSet(setDurationSecond);
SetVisitor.prototype.visitDurationMillisecond = wrapSet(setDurationMillisecond);
SetVisitor.prototype.visitDurationMicrosecond = wrapSet(setDurationMicrosecond);
SetVisitor.prototype.visitDurationNanosecond = wrapSet(setDurationNanosecond);
SetVisitor.prototype.visitFixedSizeList = wrapSet(setFixedSizeList);
SetVisitor.prototype.visitMap = wrapSet(setMap);
const instance$5 = new SetVisitor(), kParent = Symbol.for("parent"), kRowIndex = Symbol.for("rowIndex");
class StructRow {
  constructor(t, g) {
    return this[kParent] = t, this[kRowIndex] = g, new Proxy(this, structRowProxyHandler);
  }
  toArray() {
    return Object.values(this.toJSON());
  }
  toJSON() {
    const t = this[kRowIndex], g = this[kParent], d = g.type.children, k = {};
    for (let H = -1, AA = d.length; ++H < AA; )
      k[d[H].name] = instance$4.visit(g.children[H], t);
    return k;
  }
  toString() {
    return `{${[...this].map(([t, g]) => `${valueToString(t)}: ${valueToString(g)}`).join(", ")}}`;
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
  [Symbol.iterator]() {
    return new StructRowIterator(this[kParent], this[kRowIndex]);
  }
}
class StructRowIterator {
  constructor(t, g) {
    this.childIndex = 0, this.children = t.children, this.rowIndex = g, this.childFields = t.type.children, this.numChildren = this.childFields.length;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    const t = this.childIndex;
    return t < this.numChildren ? (this.childIndex = t + 1, {
      done: !1,
      value: [
        this.childFields[t].name,
        instance$4.visit(this.children[t], this.rowIndex)
      ]
    }) : { done: !0, value: null };
  }
}
Object.defineProperties(StructRow.prototype, {
  [Symbol.toStringTag]: { enumerable: !1, configurable: !1, value: "Row" },
  [kParent]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [kRowIndex]: { writable: !0, enumerable: !1, configurable: !1, value: -1 }
});
class StructRowProxyHandler {
  isExtensible() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !0;
  }
  ownKeys(t) {
    return t[kParent].type.children.map((g) => g.name);
  }
  has(t, g) {
    return t[kParent].type.children.some((d) => d.name === g);
  }
  getOwnPropertyDescriptor(t, g) {
    if (t[kParent].type.children.some((d) => d.name === g))
      return { writable: !0, enumerable: !0, configurable: !0 };
  }
  get(t, g) {
    if (Reflect.has(t, g))
      return t[g];
    const d = t[kParent].type.children.findIndex((k) => k.name === g);
    if (d !== -1) {
      const k = instance$4.visit(t[kParent].children[d], t[kRowIndex]);
      return Reflect.set(t, g, k), k;
    }
  }
  set(t, g, d) {
    const k = t[kParent].type.children.findIndex((H) => H.name === g);
    return k !== -1 ? (instance$5.visit(t[kParent].children[k], t[kRowIndex], d), Reflect.set(t, g, d)) : Reflect.has(t, g) || typeof g == "symbol" ? Reflect.set(t, g, d) : !1;
  }
}
const structRowProxyHandler = new StructRowProxyHandler();
class GetVisitor extends Visitor {
}
function wrapGet(n) {
  return (t, g) => t.getValid(g) ? n(t, g) : null;
}
const epochDaysToMs = (n, t) => 864e5 * n[t], getNull = (n, t) => null, getVariableWidthBytes = (n, t, g) => {
  if (g + 1 >= t.length)
    return null;
  const d = bigIntToNumber(t[g]), k = bigIntToNumber(t[g + 1]);
  return n.subarray(d, k);
}, getBool$1 = ({ offset: n, values: t }, g) => {
  const d = n + g;
  return (t[d >> 3] & 1 << d % 8) !== 0;
}, getDateDay = ({ values: n }, t) => epochDaysToMs(n, t), getDateMillisecond = ({ values: n }, t) => bigIntToNumber(n[t]), getNumeric = ({ stride: n, values: t }, g) => t[n * g], getFloat16 = ({ stride: n, values: t }, g) => uint16ToFloat64(t[n * g]), getBigInts = ({ values: n }, t) => n[t], getFixedSizeBinary = ({ stride: n, values: t }, g) => t.subarray(n * g, n * (g + 1)), getBinary = ({ values: n, valueOffsets: t }, g) => getVariableWidthBytes(n, t, g), getUtf8 = ({ values: n, valueOffsets: t }, g) => {
  const d = getVariableWidthBytes(n, t, g);
  return d !== null ? decodeUtf8(d) : null;
}, getInt = ({ values: n }, t) => n[t], getFloat = ({ type: n, values: t }, g) => n.precision !== Precision.HALF ? t[g] : uint16ToFloat64(t[g]), getDate = (n, t) => n.type.unit === DateUnit.DAY ? getDateDay(n, t) : getDateMillisecond(n, t), getTimestampSecond = ({ values: n }, t) => 1e3 * bigIntToNumber(n[t]), getTimestampMillisecond = ({ values: n }, t) => bigIntToNumber(n[t]), getTimestampMicrosecond = ({ values: n }, t) => divideBigInts(n[t], BigInt(1e3)), getTimestampNanosecond = ({ values: n }, t) => divideBigInts(n[t], BigInt(1e6)), getTimestamp = (n, t) => {
  switch (n.type.unit) {
    case TimeUnit$1.SECOND:
      return getTimestampSecond(n, t);
    case TimeUnit$1.MILLISECOND:
      return getTimestampMillisecond(n, t);
    case TimeUnit$1.MICROSECOND:
      return getTimestampMicrosecond(n, t);
    case TimeUnit$1.NANOSECOND:
      return getTimestampNanosecond(n, t);
  }
}, getTimeSecond = ({ values: n }, t) => n[t], getTimeMillisecond = ({ values: n }, t) => n[t], getTimeMicrosecond = ({ values: n }, t) => n[t], getTimeNanosecond = ({ values: n }, t) => n[t], getTime = (n, t) => {
  switch (n.type.unit) {
    case TimeUnit$1.SECOND:
      return getTimeSecond(n, t);
    case TimeUnit$1.MILLISECOND:
      return getTimeMillisecond(n, t);
    case TimeUnit$1.MICROSECOND:
      return getTimeMicrosecond(n, t);
    case TimeUnit$1.NANOSECOND:
      return getTimeNanosecond(n, t);
  }
}, getDecimal = ({ values: n, stride: t }, g) => BN.decimal(n.subarray(t * g, t * (g + 1))), getList = (n, t) => {
  const { valueOffsets: g, stride: d, children: k } = n, { [t * d]: H, [t * d + 1]: AA } = g, IA = k[0].slice(H, AA - H);
  return new Vector([IA]);
}, getMap = (n, t) => {
  const { valueOffsets: g, children: d } = n, { [t]: k, [t + 1]: H } = g, AA = d[0];
  return new MapRow(AA.slice(k, H - k));
}, getStruct = (n, t) => new StructRow(n, t), getUnion = (n, t) => n.type.mode === UnionMode.Dense ? getDenseUnion(n, t) : getSparseUnion(n, t), getDenseUnion = (n, t) => {
  const g = n.type.typeIdToChildIndex[n.typeIds[t]], d = n.children[g];
  return instance$4.visit(d, n.valueOffsets[t]);
}, getSparseUnion = (n, t) => {
  const g = n.type.typeIdToChildIndex[n.typeIds[t]], d = n.children[g];
  return instance$4.visit(d, t);
}, getDictionary = (n, t) => {
  var g;
  return (g = n.dictionary) === null || g === void 0 ? void 0 : g.get(n.values[t]);
}, getInterval = (n, t) => n.type.unit === IntervalUnit.MONTH_DAY_NANO ? getIntervalMonthDayNano(n, t) : n.type.unit === IntervalUnit.DAY_TIME ? getIntervalDayTime(n, t) : getIntervalYearMonth(n, t), getIntervalDayTime = ({ values: n }, t) => n.subarray(2 * t, 2 * (t + 1)), getIntervalYearMonth = ({ values: n }, t) => {
  const g = n[t], d = new Int32Array(2);
  return d[0] = Math.trunc(g / 12), d[1] = Math.trunc(g % 12), d;
}, getIntervalMonthDayNano = ({ values: n }, t) => n.subarray(4 * t, 4 * (t + 1)), getDurationSecond = ({ values: n }, t) => n[t], getDurationMillisecond = ({ values: n }, t) => n[t], getDurationMicrosecond = ({ values: n }, t) => n[t], getDurationNanosecond = ({ values: n }, t) => n[t], getDuration = (n, t) => {
  switch (n.type.unit) {
    case TimeUnit$1.SECOND:
      return getDurationSecond(n, t);
    case TimeUnit$1.MILLISECOND:
      return getDurationMillisecond(n, t);
    case TimeUnit$1.MICROSECOND:
      return getDurationMicrosecond(n, t);
    case TimeUnit$1.NANOSECOND:
      return getDurationNanosecond(n, t);
  }
}, getFixedSizeList = (n, t) => {
  const { stride: g, children: d } = n, H = d[0].slice(t * g, g);
  return new Vector([H]);
};
GetVisitor.prototype.visitNull = wrapGet(getNull);
GetVisitor.prototype.visitBool = wrapGet(getBool$1);
GetVisitor.prototype.visitInt = wrapGet(getInt);
GetVisitor.prototype.visitInt8 = wrapGet(getNumeric);
GetVisitor.prototype.visitInt16 = wrapGet(getNumeric);
GetVisitor.prototype.visitInt32 = wrapGet(getNumeric);
GetVisitor.prototype.visitInt64 = wrapGet(getBigInts);
GetVisitor.prototype.visitUint8 = wrapGet(getNumeric);
GetVisitor.prototype.visitUint16 = wrapGet(getNumeric);
GetVisitor.prototype.visitUint32 = wrapGet(getNumeric);
GetVisitor.prototype.visitUint64 = wrapGet(getBigInts);
GetVisitor.prototype.visitFloat = wrapGet(getFloat);
GetVisitor.prototype.visitFloat16 = wrapGet(getFloat16);
GetVisitor.prototype.visitFloat32 = wrapGet(getNumeric);
GetVisitor.prototype.visitFloat64 = wrapGet(getNumeric);
GetVisitor.prototype.visitUtf8 = wrapGet(getUtf8);
GetVisitor.prototype.visitLargeUtf8 = wrapGet(getUtf8);
GetVisitor.prototype.visitBinary = wrapGet(getBinary);
GetVisitor.prototype.visitLargeBinary = wrapGet(getBinary);
GetVisitor.prototype.visitFixedSizeBinary = wrapGet(getFixedSizeBinary);
GetVisitor.prototype.visitDate = wrapGet(getDate);
GetVisitor.prototype.visitDateDay = wrapGet(getDateDay);
GetVisitor.prototype.visitDateMillisecond = wrapGet(getDateMillisecond);
GetVisitor.prototype.visitTimestamp = wrapGet(getTimestamp);
GetVisitor.prototype.visitTimestampSecond = wrapGet(getTimestampSecond);
GetVisitor.prototype.visitTimestampMillisecond = wrapGet(getTimestampMillisecond);
GetVisitor.prototype.visitTimestampMicrosecond = wrapGet(getTimestampMicrosecond);
GetVisitor.prototype.visitTimestampNanosecond = wrapGet(getTimestampNanosecond);
GetVisitor.prototype.visitTime = wrapGet(getTime);
GetVisitor.prototype.visitTimeSecond = wrapGet(getTimeSecond);
GetVisitor.prototype.visitTimeMillisecond = wrapGet(getTimeMillisecond);
GetVisitor.prototype.visitTimeMicrosecond = wrapGet(getTimeMicrosecond);
GetVisitor.prototype.visitTimeNanosecond = wrapGet(getTimeNanosecond);
GetVisitor.prototype.visitDecimal = wrapGet(getDecimal);
GetVisitor.prototype.visitList = wrapGet(getList);
GetVisitor.prototype.visitStruct = wrapGet(getStruct);
GetVisitor.prototype.visitUnion = wrapGet(getUnion);
GetVisitor.prototype.visitDenseUnion = wrapGet(getDenseUnion);
GetVisitor.prototype.visitSparseUnion = wrapGet(getSparseUnion);
GetVisitor.prototype.visitDictionary = wrapGet(getDictionary);
GetVisitor.prototype.visitInterval = wrapGet(getInterval);
GetVisitor.prototype.visitIntervalDayTime = wrapGet(getIntervalDayTime);
GetVisitor.prototype.visitIntervalYearMonth = wrapGet(getIntervalYearMonth);
GetVisitor.prototype.visitIntervalMonthDayNano = wrapGet(getIntervalMonthDayNano);
GetVisitor.prototype.visitDuration = wrapGet(getDuration);
GetVisitor.prototype.visitDurationSecond = wrapGet(getDurationSecond);
GetVisitor.prototype.visitDurationMillisecond = wrapGet(getDurationMillisecond);
GetVisitor.prototype.visitDurationMicrosecond = wrapGet(getDurationMicrosecond);
GetVisitor.prototype.visitDurationNanosecond = wrapGet(getDurationNanosecond);
GetVisitor.prototype.visitFixedSizeList = wrapGet(getFixedSizeList);
GetVisitor.prototype.visitMap = wrapGet(getMap);
const instance$4 = new GetVisitor(), kKeys = Symbol.for("keys"), kVals = Symbol.for("vals"), kKeysAsStrings = Symbol.for("kKeysAsStrings"), _kKeysAsStrings = Symbol.for("_kKeysAsStrings");
class MapRow {
  constructor(t) {
    return this[kKeys] = new Vector([t.children[0]]).memoize(), this[kVals] = t.children[1], new Proxy(this, new MapRowProxyHandler());
  }
  /** @ignore */
  get [kKeysAsStrings]() {
    return this[_kKeysAsStrings] || (this[_kKeysAsStrings] = Array.from(this[kKeys].toArray(), String));
  }
  [Symbol.iterator]() {
    return new MapRowIterator(this[kKeys], this[kVals]);
  }
  get size() {
    return this[kKeys].length;
  }
  toArray() {
    return Object.values(this.toJSON());
  }
  toJSON() {
    const t = this[kKeys], g = this[kVals], d = {};
    for (let k = -1, H = t.length; ++k < H; )
      d[t.get(k)] = instance$4.visit(g, k);
    return d;
  }
  toString() {
    return `{${[...this].map(([t, g]) => `${valueToString(t)}: ${valueToString(g)}`).join(", ")}}`;
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
}
class MapRowIterator {
  constructor(t, g) {
    this.keys = t, this.vals = g, this.keyIndex = 0, this.numKeys = t.length;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    const t = this.keyIndex;
    return t === this.numKeys ? { done: !0, value: null } : (this.keyIndex++, {
      done: !1,
      value: [
        this.keys.get(t),
        instance$4.visit(this.vals, t)
      ]
    });
  }
}
class MapRowProxyHandler {
  isExtensible() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !0;
  }
  ownKeys(t) {
    return t[kKeysAsStrings];
  }
  has(t, g) {
    return t[kKeysAsStrings].includes(g);
  }
  getOwnPropertyDescriptor(t, g) {
    if (t[kKeysAsStrings].indexOf(g) !== -1)
      return { writable: !0, enumerable: !0, configurable: !0 };
  }
  get(t, g) {
    if (Reflect.has(t, g))
      return t[g];
    const d = t[kKeysAsStrings].indexOf(g);
    if (d !== -1) {
      const k = instance$4.visit(Reflect.get(t, kVals), d);
      return Reflect.set(t, g, k), k;
    }
  }
  set(t, g, d) {
    const k = t[kKeysAsStrings].indexOf(g);
    return k !== -1 ? (instance$5.visit(Reflect.get(t, kVals), k, d), Reflect.set(t, g, d)) : Reflect.has(t, g) ? Reflect.set(t, g, d) : !1;
  }
}
Object.defineProperties(MapRow.prototype, {
  [Symbol.toStringTag]: { enumerable: !1, configurable: !1, value: "Row" },
  [kKeys]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [kVals]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [_kKeysAsStrings]: { writable: !0, enumerable: !1, configurable: !1, value: null }
});
let tmp;
function clampRange$1(n, t, g, d) {
  const { length: k = 0 } = n;
  let H = typeof t != "number" ? 0 : t, AA = typeof g != "number" ? k : g;
  return H < 0 && (H = (H % k + k) % k), AA < 0 && (AA = (AA % k + k) % k), AA < H && (tmp = H, H = AA, AA = tmp), AA > k && (AA = k), d ? d(n, H, AA) : [H, AA];
}
const wrapIndex = (n, t) => n < 0 ? t + n : n, isNaNFast = (n) => n !== n;
function createElementComparator(n) {
  if (typeof n !== "object" || n === null)
    return isNaNFast(n) ? isNaNFast : (g) => g === n;
  if (n instanceof Date) {
    const g = n.valueOf();
    return (d) => d instanceof Date ? d.valueOf() === g : !1;
  }
  return ArrayBuffer.isView(n) ? (g) => g ? compareArrayLike(n, g) : !1 : n instanceof Map ? createMapComparator(n) : Array.isArray(n) ? createArrayLikeComparator(n) : n instanceof Vector ? createVectorComparator(n) : createObjectComparator(n, !0);
}
function createArrayLikeComparator(n) {
  const t = [];
  for (let g = -1, d = n.length; ++g < d; )
    t[g] = createElementComparator(n[g]);
  return createSubElementsComparator(t);
}
function createMapComparator(n) {
  let t = -1;
  const g = [];
  for (const d of n.values())
    g[++t] = createElementComparator(d);
  return createSubElementsComparator(g);
}
function createVectorComparator(n) {
  const t = [];
  for (let g = -1, d = n.length; ++g < d; )
    t[g] = createElementComparator(n.get(g));
  return createSubElementsComparator(t);
}
function createObjectComparator(n, t = !1) {
  const g = Object.keys(n);
  if (!t && g.length === 0)
    return () => !1;
  const d = [];
  for (let k = -1, H = g.length; ++k < H; )
    d[k] = createElementComparator(n[g[k]]);
  return createSubElementsComparator(d, g);
}
function createSubElementsComparator(n, t) {
  return (g) => {
    if (!g || typeof g != "object")
      return !1;
    switch (g.constructor) {
      case Array:
        return compareArray$1(n, g);
      case Map:
        return compareObject(n, g, g.keys());
      case MapRow:
      case StructRow:
      case Object:
      case void 0:
        return compareObject(n, g, t || Object.keys(g));
    }
    return g instanceof Vector ? compareVector(n, g) : !1;
  };
}
function compareArray$1(n, t) {
  const g = n.length;
  if (t.length !== g)
    return !1;
  for (let d = -1; ++d < g; )
    if (!n[d](t[d]))
      return !1;
  return !0;
}
function compareVector(n, t) {
  const g = n.length;
  if (t.length !== g)
    return !1;
  for (let d = -1; ++d < g; )
    if (!n[d](t.get(d)))
      return !1;
  return !0;
}
function compareObject(n, t, g) {
  const d = g[Symbol.iterator](), k = t instanceof Map ? t.keys() : Object.keys(t)[Symbol.iterator](), H = t instanceof Map ? t.values() : Object.values(t)[Symbol.iterator]();
  let AA = 0;
  const gA = n.length;
  let IA = H.next(), CA = d.next(), BA = k.next();
  for (; AA < gA && !CA.done && !BA.done && !IA.done && !(CA.value !== BA.value || !n[AA](IA.value)); ++AA, CA = d.next(), BA = k.next(), IA = H.next())
    ;
  return AA === gA && CA.done && BA.done && IA.done ? !0 : (d.return && d.return(), k.return && k.return(), H.return && H.return(), !1);
}
const util_vector_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clampRange: clampRange$1,
  createElementComparator,
  wrapIndex
}, Symbol.toStringTag, { value: "Module" }));
function getBool(n, t, g, d) {
  return (g & 1 << d) !== 0;
}
function getBit(n, t, g, d) {
  return (g & 1 << d) >> d;
}
function setBool(n, t, g) {
  return g ? !!(n[t >> 3] |= 1 << t % 8) || !0 : !(n[t >> 3] &= ~(1 << t % 8)) && !1;
}
function truncateBitmap(n, t, g) {
  const d = g.byteLength + 7 & -8;
  if (n > 0 || g.byteLength < d) {
    const k = new Uint8Array(d);
    return k.set(n % 8 === 0 ? g.subarray(n >> 3) : (
      // Otherwise iterate each bit from the offset and return a new one
      packBools(new BitIterator(g, n, t, null, getBool)).subarray(0, d)
    )), k;
  }
  return g;
}
function packBools(n) {
  const t = [];
  let g = 0, d = 0, k = 0;
  for (const AA of n)
    AA && (k |= 1 << d), ++d === 8 && (t[g++] = k, k = d = 0);
  (g === 0 || d > 0) && (t[g++] = k);
  const H = new Uint8Array(t.length + 7 & -8);
  return H.set(t), H;
}
class BitIterator {
  constructor(t, g, d, k, H) {
    this.bytes = t, this.length = d, this.context = k, this.get = H, this.bit = g % 8, this.byteIndex = g >> 3, this.byte = t[this.byteIndex++], this.index = 0;
  }
  next() {
    return this.index < this.length ? (this.bit === 8 && (this.bit = 0, this.byte = this.bytes[this.byteIndex++]), {
      value: this.get(this.context, this.index++, this.byte, this.bit++)
    }) : { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
function popcnt_bit_range(n, t, g) {
  if (g - t <= 0)
    return 0;
  if (g - t < 8) {
    let H = 0;
    for (const AA of new BitIterator(n, t, g - t, n, getBit))
      H += AA;
    return H;
  }
  const d = g >> 3 << 3, k = t + (t % 8 === 0 ? 0 : 8 - t % 8);
  return (
    // Get the popcnt of bits between the left hand side, and the next highest multiple of 8
    popcnt_bit_range(n, t, k) + // Get the popcnt of bits between the right hand side, and the next lowest multiple of 8
    popcnt_bit_range(n, d, g) + // Get the popcnt of all bits between the left and right hand sides' multiples of 8
    popcnt_array(n, k >> 3, d - k >> 3)
  );
}
function popcnt_array(n, t, g) {
  let d = 0, k = Math.trunc(t);
  const H = new DataView(n.buffer, n.byteOffset, n.byteLength), AA = g === void 0 ? n.byteLength : k + g;
  for (; AA - k >= 4; )
    d += popcnt_uint32(H.getUint32(k)), k += 4;
  for (; AA - k >= 2; )
    d += popcnt_uint32(H.getUint16(k)), k += 2;
  for (; AA - k >= 1; )
    d += popcnt_uint32(H.getUint8(k)), k += 1;
  return d;
}
function popcnt_uint32(n) {
  let t = Math.trunc(n);
  return t = t - (t >>> 1 & 1431655765), t = (t & 858993459) + (t >>> 2 & 858993459), (t + (t >>> 4) & 252645135) * 16843009 >>> 24;
}
const util_bit_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BitIterator,
  getBit,
  getBool,
  packBools,
  popcnt_array,
  popcnt_bit_range,
  popcnt_uint32,
  setBool,
  truncateBitmap
}, Symbol.toStringTag, { value: "Module" })), kUnknownNullCount = -1;
class Data {
  get typeId() {
    return this.type.typeId;
  }
  get ArrayType() {
    return this.type.ArrayType;
  }
  get buffers() {
    return [this.valueOffsets, this.values, this.nullBitmap, this.typeIds];
  }
  get nullable() {
    if (this._nullCount !== 0) {
      const { type: t } = this;
      return DataType.isSparseUnion(t) ? this.children.some((g) => g.nullable) : DataType.isDenseUnion(t) ? this.children.some((g) => g.nullable) : this.nullBitmap && this.nullBitmap.byteLength > 0;
    }
    return !0;
  }
  get byteLength() {
    let t = 0;
    const { valueOffsets: g, values: d, nullBitmap: k, typeIds: H } = this;
    return g && (t += g.byteLength), d && (t += d.byteLength), k && (t += k.byteLength), H && (t += H.byteLength), this.children.reduce((AA, gA) => AA + gA.byteLength, t);
  }
  get nullCount() {
    if (DataType.isUnion(this.type))
      return this.children.reduce((d, k) => d + k.nullCount, 0);
    let t = this._nullCount, g;
    return t <= kUnknownNullCount && (g = this.nullBitmap) && (this._nullCount = t = g.length === 0 ? (
      // no null bitmap, so all values are valid
      0
    ) : this.length - popcnt_bit_range(g, this.offset, this.offset + this.length)), t;
  }
  constructor(t, g, d, k, H, AA = [], gA) {
    this.type = t, this.children = AA, this.dictionary = gA, this.offset = Math.floor(Math.max(g || 0, 0)), this.length = Math.floor(Math.max(d || 0, 0)), this._nullCount = Math.floor(Math.max(k || 0, -1));
    let IA;
    H instanceof Data ? (this.stride = H.stride, this.values = H.values, this.typeIds = H.typeIds, this.nullBitmap = H.nullBitmap, this.valueOffsets = H.valueOffsets) : (this.stride = strideForType(t), H && ((IA = H[0]) && (this.valueOffsets = IA), (IA = H[1]) && (this.values = IA), (IA = H[2]) && (this.nullBitmap = IA), (IA = H[3]) && (this.typeIds = IA)));
  }
  getValid(t) {
    const { type: g } = this;
    if (DataType.isUnion(g)) {
      const d = g, k = this.children[d.typeIdToChildIndex[this.typeIds[t]]], H = d.mode === UnionMode.Dense ? this.valueOffsets[t] : t;
      return k.getValid(H);
    }
    if (this.nullable && this.nullCount > 0) {
      const d = this.offset + t;
      return (this.nullBitmap[d >> 3] & 1 << d % 8) !== 0;
    }
    return !0;
  }
  setValid(t, g) {
    let d;
    const { type: k } = this;
    if (DataType.isUnion(k)) {
      const H = k, AA = this.children[H.typeIdToChildIndex[this.typeIds[t]]], gA = H.mode === UnionMode.Dense ? this.valueOffsets[t] : t;
      d = AA.getValid(gA), AA.setValid(gA, g);
    } else {
      let { nullBitmap: H } = this;
      const { offset: AA, length: gA } = this, IA = AA + t, CA = 1 << IA % 8, BA = IA >> 3;
      (!H || H.byteLength <= BA) && (H = new Uint8Array((AA + gA + 63 & -64) >> 3).fill(255), this.nullCount > 0 ? (H.set(truncateBitmap(AA, gA, this.nullBitmap), 0), Object.assign(this, { nullBitmap: H })) : Object.assign(this, { nullBitmap: H, _nullCount: 0 }));
      const eA = H[BA];
      d = (eA & CA) !== 0, H[BA] = g ? eA | CA : eA & ~CA;
    }
    return d !== !!g && (this._nullCount = this.nullCount + (g ? -1 : 1)), g;
  }
  clone(t = this.type, g = this.offset, d = this.length, k = this._nullCount, H = this, AA = this.children) {
    return new Data(t, g, d, k, H, AA, this.dictionary);
  }
  slice(t, g) {
    const { stride: d, typeId: k, children: H } = this, AA = +(this._nullCount === 0) - 1, gA = k === 16 ? d : 1, IA = this._sliceBuffers(t, g, d, k);
    return this.clone(
      this.type,
      this.offset + t,
      g,
      AA,
      IA,
      // Don't slice children if we have value offsets (the variable-width types)
      H.length === 0 || this.valueOffsets ? H : this._sliceChildren(H, gA * t, gA * g)
    );
  }
  _changeLengthAndBackfillNullBitmap(t) {
    if (this.typeId === Type$1.Null)
      return this.clone(this.type, 0, t, 0);
    const { length: g, nullCount: d } = this, k = new Uint8Array((t + 63 & -64) >> 3).fill(255, 0, g >> 3);
    k[g >> 3] = (1 << g - (g & -8)) - 1, d > 0 && k.set(truncateBitmap(this.offset, g, this.nullBitmap), 0);
    const H = this.buffers;
    return H[BufferType.VALIDITY] = k, this.clone(this.type, 0, t, d + (t - g), H);
  }
  _sliceBuffers(t, g, d, k) {
    let H;
    const { buffers: AA } = this;
    return (H = AA[BufferType.TYPE]) && (AA[BufferType.TYPE] = H.subarray(t, t + g)), (H = AA[BufferType.OFFSET]) && (AA[BufferType.OFFSET] = H.subarray(t, t + g + 1)) || // Otherwise if no offsets, slice the data buffer. Don't slice the data vector for Booleans, since the offset goes by bits not bytes
    (H = AA[BufferType.DATA]) && (AA[BufferType.DATA] = k === 6 ? H : H.subarray(d * t, d * (t + g))), AA;
  }
  _sliceChildren(t, g, d) {
    return t.map((k) => k.slice(g, d));
  }
}
Data.prototype.children = Object.freeze([]);
class MakeDataVisitor extends Visitor {
  visit(t) {
    return this.getVisitFn(t.type).call(this, t);
  }
  visitNull(t) {
    const { ["type"]: g, ["offset"]: d = 0, ["length"]: k = 0 } = t;
    return new Data(g, d, k, k);
  }
  visitBool(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.nullBitmap), H = toArrayBufferView(g.ArrayType, t.data), { ["length"]: AA = H.length >> 3, ["nullCount"]: gA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, AA, gA, [void 0, H, k]);
  }
  visitInt(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.nullBitmap), H = toArrayBufferView(g.ArrayType, t.data), { ["length"]: AA = H.length, ["nullCount"]: gA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, AA, gA, [void 0, H, k]);
  }
  visitFloat(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.nullBitmap), H = toArrayBufferView(g.ArrayType, t.data), { ["length"]: AA = H.length, ["nullCount"]: gA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, AA, gA, [void 0, H, k]);
  }
  visitUtf8(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.data), H = toUint8Array(t.nullBitmap), AA = toInt32Array(t.valueOffsets), { ["length"]: gA = AA.length - 1, ["nullCount"]: IA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, gA, IA, [AA, k, H]);
  }
  visitLargeUtf8(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.data), H = toUint8Array(t.nullBitmap), AA = toBigInt64Array(t.valueOffsets), { ["length"]: gA = AA.length - 1, ["nullCount"]: IA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, gA, IA, [AA, k, H]);
  }
  visitBinary(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.data), H = toUint8Array(t.nullBitmap), AA = toInt32Array(t.valueOffsets), { ["length"]: gA = AA.length - 1, ["nullCount"]: IA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, gA, IA, [AA, k, H]);
  }
  visitLargeBinary(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.data), H = toUint8Array(t.nullBitmap), AA = toBigInt64Array(t.valueOffsets), { ["length"]: gA = AA.length - 1, ["nullCount"]: IA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, gA, IA, [AA, k, H]);
  }
  visitFixedSizeBinary(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.nullBitmap), H = toArrayBufferView(g.ArrayType, t.data), { ["length"]: AA = H.length / strideForType(g), ["nullCount"]: gA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, AA, gA, [void 0, H, k]);
  }
  visitDate(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.nullBitmap), H = toArrayBufferView(g.ArrayType, t.data), { ["length"]: AA = H.length / strideForType(g), ["nullCount"]: gA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, AA, gA, [void 0, H, k]);
  }
  visitTimestamp(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.nullBitmap), H = toArrayBufferView(g.ArrayType, t.data), { ["length"]: AA = H.length / strideForType(g), ["nullCount"]: gA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, AA, gA, [void 0, H, k]);
  }
  visitTime(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.nullBitmap), H = toArrayBufferView(g.ArrayType, t.data), { ["length"]: AA = H.length / strideForType(g), ["nullCount"]: gA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, AA, gA, [void 0, H, k]);
  }
  visitDecimal(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.nullBitmap), H = toArrayBufferView(g.ArrayType, t.data), { ["length"]: AA = H.length / strideForType(g), ["nullCount"]: gA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, AA, gA, [void 0, H, k]);
  }
  visitList(t) {
    const { ["type"]: g, ["offset"]: d = 0, ["child"]: k } = t, H = toUint8Array(t.nullBitmap), AA = toInt32Array(t.valueOffsets), { ["length"]: gA = AA.length - 1, ["nullCount"]: IA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, gA, IA, [AA, void 0, H], [k]);
  }
  visitStruct(t) {
    const { ["type"]: g, ["offset"]: d = 0, ["children"]: k = [] } = t, H = toUint8Array(t.nullBitmap), { length: AA = k.reduce((IA, { length: CA }) => Math.max(IA, CA), 0), nullCount: gA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, AA, gA, [void 0, void 0, H], k);
  }
  visitUnion(t) {
    const { ["type"]: g, ["offset"]: d = 0, ["children"]: k = [] } = t, H = toArrayBufferView(g.ArrayType, t.typeIds), { ["length"]: AA = H.length, ["nullCount"]: gA = -1 } = t;
    if (DataType.isSparseUnion(g))
      return new Data(g, d, AA, gA, [void 0, void 0, void 0, H], k);
    const IA = toInt32Array(t.valueOffsets);
    return new Data(g, d, AA, gA, [IA, void 0, void 0, H], k);
  }
  visitDictionary(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.nullBitmap), H = toArrayBufferView(g.indices.ArrayType, t.data), { ["dictionary"]: AA = new Vector([new MakeDataVisitor().visit({ type: g.dictionary })]) } = t, { ["length"]: gA = H.length, ["nullCount"]: IA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, gA, IA, [void 0, H, k], [], AA);
  }
  visitInterval(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.nullBitmap), H = toArrayBufferView(g.ArrayType, t.data), { ["length"]: AA = H.length / strideForType(g), ["nullCount"]: gA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, AA, gA, [void 0, H, k]);
  }
  visitDuration(t) {
    const { ["type"]: g, ["offset"]: d = 0 } = t, k = toUint8Array(t.nullBitmap), H = toArrayBufferView(g.ArrayType, t.data), { ["length"]: AA = H.length, ["nullCount"]: gA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, AA, gA, [void 0, H, k]);
  }
  visitFixedSizeList(t) {
    const { ["type"]: g, ["offset"]: d = 0, ["child"]: k = new MakeDataVisitor().visit({ type: g.valueType }) } = t, H = toUint8Array(t.nullBitmap), { ["length"]: AA = k.length / strideForType(g), ["nullCount"]: gA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, AA, gA, [void 0, void 0, H], [k]);
  }
  visitMap(t) {
    const { ["type"]: g, ["offset"]: d = 0, ["child"]: k = new MakeDataVisitor().visit({ type: g.childType }) } = t, H = toUint8Array(t.nullBitmap), AA = toInt32Array(t.valueOffsets), { ["length"]: gA = AA.length - 1, ["nullCount"]: IA = t.nullBitmap ? -1 : 0 } = t;
    return new Data(g, d, gA, IA, [AA, void 0, H], [k]);
  }
}
const makeDataVisitor = new MakeDataVisitor();
function makeData(n) {
  return makeDataVisitor.visit(n);
}
class ChunkedIterator {
  constructor(t = 0, g) {
    this.numChunks = t, this.getChunkIterator = g, this.chunkIndex = 0, this.chunkIterator = this.getChunkIterator(0);
  }
  next() {
    for (; this.chunkIndex < this.numChunks; ) {
      const t = this.chunkIterator.next();
      if (!t.done)
        return t;
      ++this.chunkIndex < this.numChunks && (this.chunkIterator = this.getChunkIterator(this.chunkIndex));
    }
    return { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
function computeChunkNullable(n) {
  return n.some((t) => t.nullable);
}
function computeChunkNullCounts(n) {
  return n.reduce((t, g) => t + g.nullCount, 0);
}
function computeChunkOffsets(n) {
  return n.reduce((t, g, d) => (t[d + 1] = t[d] + g.length, t), new Uint32Array(n.length + 1));
}
function sliceChunks$1(n, t, g, d) {
  const k = [];
  for (let H = -1, AA = n.length; ++H < AA; ) {
    const gA = n[H], IA = t[H], { length: CA } = gA;
    if (IA >= d)
      break;
    if (g >= IA + CA)
      continue;
    if (IA >= g && IA + CA <= d) {
      k.push(gA);
      continue;
    }
    const BA = Math.max(0, g - IA), eA = Math.min(d - IA, CA);
    k.push(gA.slice(BA, eA - BA));
  }
  return k.length === 0 && k.push(n[0].slice(0, 0)), k;
}
function binarySearch(n, t, g, d) {
  let k = 0, H = 0, AA = t.length - 1;
  do {
    if (k >= AA - 1)
      return g < t[AA] ? d(n, k, g - t[k]) : null;
    H = k + Math.trunc((AA - k) * 0.5), g < t[H] ? AA = H : k = H;
  } while (k < AA);
}
function isChunkedValid(n, t) {
  return n.getValid(t);
}
function wrapChunkedCall1(n) {
  function t(g, d, k) {
    return n(g[d], k);
  }
  return function(g) {
    const d = this.data;
    return binarySearch(d, this._offsets, g, t);
  };
}
function wrapChunkedCall2(n) {
  let t;
  function g(d, k, H) {
    return n(d[k], H, t);
  }
  return function(d, k) {
    const H = this.data;
    t = k;
    const AA = binarySearch(H, this._offsets, d, g);
    return t = void 0, AA;
  };
}
function wrapChunkedIndexOf(n) {
  let t;
  function g(d, k, H) {
    let AA = H, gA = 0, IA = 0;
    for (let CA = k - 1, BA = d.length; ++CA < BA; ) {
      const eA = d[CA];
      if (~(gA = n(eA, t, AA)))
        return IA + gA;
      AA = 0, IA += eA.length;
    }
    return -1;
  }
  return function(d, k) {
    t = d;
    const H = this.data, AA = typeof k != "number" ? g(H, 0, 0) : binarySearch(H, this._offsets, k, g);
    return t = void 0, AA;
  };
}
class IndexOfVisitor extends Visitor {
}
function nullIndexOf(n, t) {
  return t === null && n.length > 0 ? 0 : -1;
}
function indexOfNull(n, t) {
  const { nullBitmap: g } = n;
  if (!g || n.nullCount <= 0)
    return -1;
  let d = 0;
  for (const k of new BitIterator(g, n.offset + (t || 0), n.length, g, getBool)) {
    if (!k)
      return d;
    ++d;
  }
  return -1;
}
function indexOfValue(n, t, g) {
  if (t === void 0)
    return -1;
  if (t === null)
    switch (n.typeId) {
      // Unions don't have a nullBitmap of its own, so compare the `searchElement` to `get()`.
      case Type$1.Union:
        break;
      // Dictionaries do have a nullBitmap, but their dictionary could also have null elements.
      case Type$1.Dictionary:
        break;
      // All other types can iterate the null bitmap
      default:
        return indexOfNull(n, g);
    }
  const d = instance$4.getVisitFn(n), k = createElementComparator(t);
  for (let H = (g || 0) - 1, AA = n.length; ++H < AA; )
    if (k(d(n, H)))
      return H;
  return -1;
}
function indexOfUnion(n, t, g) {
  const d = instance$4.getVisitFn(n), k = createElementComparator(t);
  for (let H = (g || 0) - 1, AA = n.length; ++H < AA; )
    if (k(d(n, H)))
      return H;
  return -1;
}
IndexOfVisitor.prototype.visitNull = nullIndexOf;
IndexOfVisitor.prototype.visitBool = indexOfValue;
IndexOfVisitor.prototype.visitInt = indexOfValue;
IndexOfVisitor.prototype.visitInt8 = indexOfValue;
IndexOfVisitor.prototype.visitInt16 = indexOfValue;
IndexOfVisitor.prototype.visitInt32 = indexOfValue;
IndexOfVisitor.prototype.visitInt64 = indexOfValue;
IndexOfVisitor.prototype.visitUint8 = indexOfValue;
IndexOfVisitor.prototype.visitUint16 = indexOfValue;
IndexOfVisitor.prototype.visitUint32 = indexOfValue;
IndexOfVisitor.prototype.visitUint64 = indexOfValue;
IndexOfVisitor.prototype.visitFloat = indexOfValue;
IndexOfVisitor.prototype.visitFloat16 = indexOfValue;
IndexOfVisitor.prototype.visitFloat32 = indexOfValue;
IndexOfVisitor.prototype.visitFloat64 = indexOfValue;
IndexOfVisitor.prototype.visitUtf8 = indexOfValue;
IndexOfVisitor.prototype.visitLargeUtf8 = indexOfValue;
IndexOfVisitor.prototype.visitBinary = indexOfValue;
IndexOfVisitor.prototype.visitLargeBinary = indexOfValue;
IndexOfVisitor.prototype.visitFixedSizeBinary = indexOfValue;
IndexOfVisitor.prototype.visitDate = indexOfValue;
IndexOfVisitor.prototype.visitDateDay = indexOfValue;
IndexOfVisitor.prototype.visitDateMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestamp = indexOfValue;
IndexOfVisitor.prototype.visitTimestampSecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitTime = indexOfValue;
IndexOfVisitor.prototype.visitTimeSecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitDecimal = indexOfValue;
IndexOfVisitor.prototype.visitList = indexOfValue;
IndexOfVisitor.prototype.visitStruct = indexOfValue;
IndexOfVisitor.prototype.visitUnion = indexOfValue;
IndexOfVisitor.prototype.visitDenseUnion = indexOfUnion;
IndexOfVisitor.prototype.visitSparseUnion = indexOfUnion;
IndexOfVisitor.prototype.visitDictionary = indexOfValue;
IndexOfVisitor.prototype.visitInterval = indexOfValue;
IndexOfVisitor.prototype.visitIntervalDayTime = indexOfValue;
IndexOfVisitor.prototype.visitIntervalYearMonth = indexOfValue;
IndexOfVisitor.prototype.visitIntervalMonthDayNano = indexOfValue;
IndexOfVisitor.prototype.visitDuration = indexOfValue;
IndexOfVisitor.prototype.visitDurationSecond = indexOfValue;
IndexOfVisitor.prototype.visitDurationMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitDurationMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitDurationNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitFixedSizeList = indexOfValue;
IndexOfVisitor.prototype.visitMap = indexOfValue;
const instance$3 = new IndexOfVisitor();
class IteratorVisitor extends Visitor {
}
function vectorIterator(n) {
  const { type: t } = n;
  if (n.nullCount === 0 && n.stride === 1 && // Don't defer to native iterator for timestamps since Numbers are expected
  // (DataType.isTimestamp(type)) && type.unit === TimeUnit.MILLISECOND ||
  (DataType.isInt(t) && t.bitWidth !== 64 || DataType.isTime(t) && t.bitWidth !== 64 || DataType.isFloat(t) && t.precision !== Precision.HALF))
    return new ChunkedIterator(n.data.length, (d) => {
      const k = n.data[d];
      return k.values.subarray(0, k.length)[Symbol.iterator]();
    });
  let g = 0;
  return new ChunkedIterator(n.data.length, (d) => {
    const H = n.data[d].length, AA = n.slice(g, g + H);
    return g += H, new VectorIterator(AA);
  });
}
class VectorIterator {
  constructor(t) {
    this.vector = t, this.index = 0;
  }
  next() {
    return this.index < this.vector.length ? {
      value: this.vector.get(this.index++)
    } : { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
IteratorVisitor.prototype.visitNull = vectorIterator;
IteratorVisitor.prototype.visitBool = vectorIterator;
IteratorVisitor.prototype.visitInt = vectorIterator;
IteratorVisitor.prototype.visitInt8 = vectorIterator;
IteratorVisitor.prototype.visitInt16 = vectorIterator;
IteratorVisitor.prototype.visitInt32 = vectorIterator;
IteratorVisitor.prototype.visitInt64 = vectorIterator;
IteratorVisitor.prototype.visitUint8 = vectorIterator;
IteratorVisitor.prototype.visitUint16 = vectorIterator;
IteratorVisitor.prototype.visitUint32 = vectorIterator;
IteratorVisitor.prototype.visitUint64 = vectorIterator;
IteratorVisitor.prototype.visitFloat = vectorIterator;
IteratorVisitor.prototype.visitFloat16 = vectorIterator;
IteratorVisitor.prototype.visitFloat32 = vectorIterator;
IteratorVisitor.prototype.visitFloat64 = vectorIterator;
IteratorVisitor.prototype.visitUtf8 = vectorIterator;
IteratorVisitor.prototype.visitLargeUtf8 = vectorIterator;
IteratorVisitor.prototype.visitBinary = vectorIterator;
IteratorVisitor.prototype.visitLargeBinary = vectorIterator;
IteratorVisitor.prototype.visitFixedSizeBinary = vectorIterator;
IteratorVisitor.prototype.visitDate = vectorIterator;
IteratorVisitor.prototype.visitDateDay = vectorIterator;
IteratorVisitor.prototype.visitDateMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimestamp = vectorIterator;
IteratorVisitor.prototype.visitTimestampSecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampNanosecond = vectorIterator;
IteratorVisitor.prototype.visitTime = vectorIterator;
IteratorVisitor.prototype.visitTimeSecond = vectorIterator;
IteratorVisitor.prototype.visitTimeMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimeMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitTimeNanosecond = vectorIterator;
IteratorVisitor.prototype.visitDecimal = vectorIterator;
IteratorVisitor.prototype.visitList = vectorIterator;
IteratorVisitor.prototype.visitStruct = vectorIterator;
IteratorVisitor.prototype.visitUnion = vectorIterator;
IteratorVisitor.prototype.visitDenseUnion = vectorIterator;
IteratorVisitor.prototype.visitSparseUnion = vectorIterator;
IteratorVisitor.prototype.visitDictionary = vectorIterator;
IteratorVisitor.prototype.visitInterval = vectorIterator;
IteratorVisitor.prototype.visitIntervalDayTime = vectorIterator;
IteratorVisitor.prototype.visitIntervalYearMonth = vectorIterator;
IteratorVisitor.prototype.visitIntervalMonthDayNano = vectorIterator;
IteratorVisitor.prototype.visitDuration = vectorIterator;
IteratorVisitor.prototype.visitDurationSecond = vectorIterator;
IteratorVisitor.prototype.visitDurationMillisecond = vectorIterator;
IteratorVisitor.prototype.visitDurationMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitDurationNanosecond = vectorIterator;
IteratorVisitor.prototype.visitFixedSizeList = vectorIterator;
IteratorVisitor.prototype.visitMap = vectorIterator;
const instance$2 = new IteratorVisitor();
var _a$3;
const visitorsByTypeId = {}, vectorPrototypesByTypeId = {};
class Vector {
  constructor(t) {
    var g, d, k;
    const H = t[0] instanceof Vector ? t.flatMap((gA) => gA.data) : t;
    if (H.length === 0 || H.some((gA) => !(gA instanceof Data)))
      throw new TypeError("Vector constructor expects an Array of Data instances.");
    const AA = (g = H[0]) === null || g === void 0 ? void 0 : g.type;
    switch (H.length) {
      case 0:
        this._offsets = [0];
        break;
      case 1: {
        const { get: gA, set: IA, indexOf: CA } = visitorsByTypeId[AA.typeId], BA = H[0];
        this.isValid = (eA) => isChunkedValid(BA, eA), this.get = (eA) => gA(BA, eA), this.set = (eA, iA) => IA(BA, eA, iA), this.indexOf = (eA) => CA(BA, eA), this._offsets = [0, BA.length];
        break;
      }
      default:
        Object.setPrototypeOf(this, vectorPrototypesByTypeId[AA.typeId]), this._offsets = computeChunkOffsets(H);
        break;
    }
    this.data = H, this.type = AA, this.stride = strideForType(AA), this.numChildren = (k = (d = AA.children) === null || d === void 0 ? void 0 : d.length) !== null && k !== void 0 ? k : 0, this.length = this._offsets.at(-1);
  }
  /**
   * The aggregate size (in bytes) of this Vector's buffers and/or child Vectors.
   */
  get byteLength() {
    return this.data.reduce((t, g) => t + g.byteLength, 0);
  }
  /**
   * Whether this Vector's elements can contain null values.
   */
  get nullable() {
    return computeChunkNullable(this.data);
  }
  /**
   * The number of null elements in this Vector.
   */
  get nullCount() {
    return computeChunkNullCounts(this.data);
  }
  /**
   * The Array or TypedArray constructor used for the JS representation
   *  of the element's values in {@link Vector.prototype.toArray `toArray()`}.
   */
  get ArrayType() {
    return this.type.ArrayType;
  }
  /**
   * The name that should be printed when the Vector is logged in a message.
   */
  get [Symbol.toStringTag]() {
    return `${this.VectorName}<${this.type[Symbol.toStringTag]}>`;
  }
  /**
   * The name of this Vector.
   */
  get VectorName() {
    return `${Type$1[this.type.typeId]}Vector`;
  }
  /**
   * Check whether an element is null.
   * @param index The index at which to read the validity bitmap.
   */
  // @ts-ignore
  isValid(t) {
    return !1;
  }
  /**
   * Get an element value by position.
   * @param index The index of the element to read.
   */
  // @ts-ignore
  get(t) {
    return null;
  }
  /**
   * Get an element value by position.
   * @param index The index of the element to read. A negative index will count back from the last element.
   */
  at(t) {
    return this.get(wrapIndex(t, this.length));
  }
  /**
   * Set an element value by position.
   * @param index The index of the element to write.
   * @param value The value to set.
   */
  // @ts-ignore
  set(t, g) {
  }
  /**
   * Retrieve the index of the first occurrence of a value in an Vector.
   * @param element The value to locate in the Vector.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  // @ts-ignore
  indexOf(t, g) {
    return -1;
  }
  includes(t, g) {
    return this.indexOf(t, g) > -1;
  }
  /**
   * Iterator for the Vector's elements.
   */
  [Symbol.iterator]() {
    return instance$2.visit(this);
  }
  /**
   * Combines two or more Vectors of the same type.
   * @param others Additional Vectors to add to the end of this Vector.
   */
  concat(...t) {
    return new Vector(this.data.concat(t.flatMap((g) => g.data).flat(Number.POSITIVE_INFINITY)));
  }
  /**
   * Return a zero-copy sub-section of this Vector.
   * @param start The beginning of the specified portion of the Vector.
   * @param end The end of the specified portion of the Vector. This is exclusive of the element at the index 'end'.
   */
  slice(t, g) {
    return new Vector(clampRange$1(this, t, g, ({ data: d, _offsets: k }, H, AA) => sliceChunks$1(d, k, H, AA)));
  }
  toJSON() {
    return [...this];
  }
  /**
   * Return a JavaScript Array or TypedArray of the Vector's elements.
   *
   * @note If this Vector contains a single Data chunk and the Vector's type is a
   *  primitive numeric type corresponding to one of the JavaScript TypedArrays, this
   *  method returns a zero-copy slice of the underlying TypedArray values. If there's
   *  more than one chunk, the resulting TypedArray will be a copy of the data from each
   *  chunk's underlying TypedArray values.
   *
   * @returns An Array or TypedArray of the Vector's elements, based on the Vector's DataType.
   */
  toArray() {
    const { type: t, data: g, length: d, stride: k, ArrayType: H } = this;
    switch (t.typeId) {
      case Type$1.Int:
      case Type$1.Float:
      case Type$1.Decimal:
      case Type$1.Time:
      case Type$1.Timestamp:
        switch (g.length) {
          case 0:
            return new H();
          case 1:
            return g[0].values.subarray(0, d * k);
          default:
            return g.reduce((AA, { values: gA, length: IA }) => (AA.array.set(gA.subarray(0, IA * k), AA.offset), AA.offset += IA * k, AA), { array: new H(d * k), offset: 0 }).array;
        }
    }
    return [...this];
  }
  /**
   * Returns a string representation of the Vector.
   *
   * @returns A string representation of the Vector.
   */
  toString() {
    return `[${[...this].join(",")}]`;
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   * @param name The name of the child to retrieve.
   */
  getChild(t) {
    var g;
    return this.getChildAt((g = this.type.children) === null || g === void 0 ? void 0 : g.findIndex((d) => d.name === t));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   * @param index The index of the child to retrieve.
   */
  getChildAt(t) {
    return t > -1 && t < this.numChildren ? new Vector(this.data.map(({ children: g }) => g[t])) : null;
  }
  get isMemoized() {
    return DataType.isDictionary(this.type) ? this.data[0].dictionary.isMemoized : !1;
  }
  /**
   * Adds memoization to the Vector's {@link get} method. For dictionary
   * vectors, this method return a vector that memoizes only the dictionary
   * values.
   *
   * Memoization is very useful when decoding a value is expensive such as
   * Utf8. The memoization creates a cache of the size of the Vector and
   * therefore increases memory usage.
   *
   * @returns A new vector that memoizes calls to {@link get}.
   */
  memoize() {
    if (DataType.isDictionary(this.type)) {
      const t = new MemoizedVector(this.data[0].dictionary), g = this.data.map((d) => {
        const k = d.clone();
        return k.dictionary = t, k;
      });
      return new Vector(g);
    }
    return new MemoizedVector(this);
  }
  /**
   * Returns a vector without memoization of the {@link get} method. If this
   * vector is not memoized, this method returns this vector.
   *
   * @returns A new vector without memoization.
   */
  unmemoize() {
    if (DataType.isDictionary(this.type) && this.isMemoized) {
      const t = this.data[0].dictionary.unmemoize(), g = this.data.map((d) => {
        const k = d.clone();
        return k.dictionary = t, k;
      });
      return new Vector(g);
    }
    return this;
  }
}
_a$3 = Symbol.toStringTag;
Vector[_a$3] = ((n) => {
  n.type = DataType.prototype, n.data = [], n.length = 0, n.stride = 1, n.numChildren = 0, n._offsets = new Uint32Array([0]), n[Symbol.isConcatSpreadable] = !0;
  const t = Object.keys(Type$1).map((g) => Type$1[g]).filter((g) => typeof g == "number" && g !== Type$1.NONE);
  for (const g of t) {
    const d = instance$4.getVisitFnByTypeId(g), k = instance$5.getVisitFnByTypeId(g), H = instance$3.getVisitFnByTypeId(g);
    visitorsByTypeId[g] = { get: d, set: k, indexOf: H }, vectorPrototypesByTypeId[g] = Object.create(n, {
      isValid: { value: wrapChunkedCall1(isChunkedValid) },
      get: { value: wrapChunkedCall1(instance$4.getVisitFnByTypeId(g)) },
      set: { value: wrapChunkedCall2(instance$5.getVisitFnByTypeId(g)) },
      indexOf: { value: wrapChunkedIndexOf(instance$3.getVisitFnByTypeId(g)) }
    });
  }
  return "Vector";
})(Vector.prototype);
class MemoizedVector extends Vector {
  constructor(t) {
    super(t.data);
    const g = this.get, d = this.set, k = this.slice, H = new Array(this.length);
    Object.defineProperty(this, "get", {
      value(AA) {
        const gA = H[AA];
        if (gA !== void 0)
          return gA;
        const IA = g.call(this, AA);
        return H[AA] = IA, IA;
      }
    }), Object.defineProperty(this, "set", {
      value(AA, gA) {
        d.call(this, AA, gA), H[AA] = gA;
      }
    }), Object.defineProperty(this, "slice", {
      value: (AA, gA) => new MemoizedVector(k.call(this, AA, gA))
    }), Object.defineProperty(this, "isMemoized", { value: !0 }), Object.defineProperty(this, "unmemoize", {
      value: () => new Vector(this.data)
    }), Object.defineProperty(this, "memoize", {
      value: () => this
    });
  }
}
let Block$1 = class {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  /**
   * Index to the start of the RecordBlock (note this is past the Message header)
   */
  offset() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * Length of the metadata
   */
  metaDataLength() {
    return this.bb.readInt32(this.bb_pos + 8);
  }
  /**
   * Length of the data (this is aligned so there can be a gap between this and
   * the metadata).
   */
  bodyLength() {
    return this.bb.readInt64(this.bb_pos + 16);
  }
  static sizeOf() {
    return 24;
  }
  static createBlock(t, g, d, k) {
    return t.prep(8, 24), t.writeInt64(BigInt(k ?? 0)), t.pad(4), t.writeInt32(d), t.writeInt64(BigInt(g ?? 0)), t.offset();
  }
};
class Footer {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsFooter(t, g) {
    return (g || new Footer()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsFooter(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new Footer()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  version() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : MetadataVersion.V1;
  }
  schema(t) {
    const g = this.bb.__offset(this.bb_pos, 6);
    return g ? (t || new Schema$4()).__init(this.bb.__indirect(this.bb_pos + g), this.bb) : null;
  }
  dictionaries(t, g) {
    const d = this.bb.__offset(this.bb_pos, 8);
    return d ? (g || new Block$1()).__init(this.bb.__vector(this.bb_pos + d) + t * 24, this.bb) : null;
  }
  dictionariesLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  recordBatches(t, g) {
    const d = this.bb.__offset(this.bb_pos, 10);
    return d ? (g || new Block$1()).__init(this.bb.__vector(this.bb_pos + d) + t * 24, this.bb) : null;
  }
  recordBatchesLength() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  /**
   * User-defined metadata
   */
  customMetadata(t, g) {
    const d = this.bb.__offset(this.bb_pos, 12);
    return d ? (g || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + d) + t * 4), this.bb) : null;
  }
  customMetadataLength() {
    const t = this.bb.__offset(this.bb_pos, 12);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startFooter(t) {
    t.startObject(5);
  }
  static addVersion(t, g) {
    t.addFieldInt16(0, g, MetadataVersion.V1);
  }
  static addSchema(t, g) {
    t.addFieldOffset(1, g, 0);
  }
  static addDictionaries(t, g) {
    t.addFieldOffset(2, g, 0);
  }
  static startDictionariesVector(t, g) {
    t.startVector(24, g, 8);
  }
  static addRecordBatches(t, g) {
    t.addFieldOffset(3, g, 0);
  }
  static startRecordBatchesVector(t, g) {
    t.startVector(24, g, 8);
  }
  static addCustomMetadata(t, g) {
    t.addFieldOffset(4, g, 0);
  }
  static createCustomMetadataVector(t, g) {
    t.startVector(4, g.length, 4);
    for (let d = g.length - 1; d >= 0; d--)
      t.addOffset(g[d]);
    return t.endVector();
  }
  static startCustomMetadataVector(t, g) {
    t.startVector(4, g, 4);
  }
  static endFooter(t) {
    return t.endObject();
  }
  static finishFooterBuffer(t, g) {
    t.finish(g);
  }
  static finishSizePrefixedFooterBuffer(t, g) {
    t.finish(g, void 0, !0);
  }
}
let Schema$3 = class nI {
  constructor(t = [], g, d, k = MetadataVersion.V5) {
    this.fields = t || [], this.metadata = g || /* @__PURE__ */ new Map(), d || (d = generateDictionaryMap(this.fields)), this.dictionaries = d, this.metadataVersion = k;
  }
  get [Symbol.toStringTag]() {
    return "Schema";
  }
  get names() {
    return this.fields.map((t) => t.name);
  }
  toString() {
    return `Schema<{ ${this.fields.map((t, g) => `${g}: ${t}`).join(", ")} }>`;
  }
  /**
   * Construct a new Schema containing only specified fields.
   *
   * @param fieldNames Names of fields to keep.
   * @returns A new Schema of fields matching the specified names.
   */
  select(t) {
    const g = new Set(t), d = this.fields.filter((k) => g.has(k.name));
    return new nI(d, this.metadata);
  }
  /**
   * Construct a new Schema containing only fields at the specified indices.
   *
   * @param fieldIndices Indices of fields to keep.
   * @returns A new Schema of fields at the specified indices.
   */
  selectAt(t) {
    const g = t.map((d) => this.fields[d]).filter(Boolean);
    return new nI(g, this.metadata);
  }
  assign(...t) {
    const g = t[0] instanceof nI ? t[0] : Array.isArray(t[0]) ? new nI(t[0]) : new nI(t), d = [...this.fields], k = mergeMaps(mergeMaps(/* @__PURE__ */ new Map(), this.metadata), g.metadata), H = g.fields.filter((gA) => {
      const IA = d.findIndex((CA) => CA.name === gA.name);
      return ~IA ? (d[IA] = gA.clone({
        metadata: mergeMaps(mergeMaps(/* @__PURE__ */ new Map(), d[IA].metadata), gA.metadata)
      })) && !1 : !0;
    }), AA = generateDictionaryMap(H, /* @__PURE__ */ new Map());
    return new nI([...d, ...H], k, new Map([...this.dictionaries, ...AA]));
  }
};
Schema$3.prototype.fields = null;
Schema$3.prototype.metadata = null;
Schema$3.prototype.dictionaries = null;
let Field$2 = class KI {
  /** @nocollapse */
  static new(...t) {
    let [g, d, k, H] = t;
    return t[0] && typeof t[0] == "object" && ({ name: g } = t[0], d === void 0 && (d = t[0].type), k === void 0 && (k = t[0].nullable), H === void 0 && (H = t[0].metadata)), new KI(`${g}`, d, k, H);
  }
  constructor(t, g, d = !1, k) {
    this.name = t, this.type = g, this.nullable = d, this.metadata = k || /* @__PURE__ */ new Map();
  }
  get typeId() {
    return this.type.typeId;
  }
  get [Symbol.toStringTag]() {
    return "Field";
  }
  toString() {
    return `${this.name}: ${this.type}`;
  }
  clone(...t) {
    let [g, d, k, H] = t;
    return !t[0] || typeof t[0] != "object" ? [g = this.name, d = this.type, k = this.nullable, H = this.metadata] = t : { name: g = this.name, type: d = this.type, nullable: k = this.nullable, metadata: H = this.metadata } = t[0], KI.new(g, d, k, H);
  }
};
Field$2.prototype.type = null;
Field$2.prototype.name = null;
Field$2.prototype.nullable = null;
Field$2.prototype.metadata = null;
function mergeMaps(n, t) {
  return new Map([...n || /* @__PURE__ */ new Map(), ...t || /* @__PURE__ */ new Map()]);
}
function generateDictionaryMap(n, t = /* @__PURE__ */ new Map()) {
  for (let g = -1, d = n.length; ++g < d; ) {
    const H = n[g].type;
    if (DataType.isDictionary(H)) {
      if (!t.has(H.id))
        t.set(H.id, H.dictionary);
      else if (t.get(H.id) !== H.dictionary)
        throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
    }
    H.children && H.children.length > 0 && generateDictionaryMap(H.children, t);
  }
  return t;
}
var Builder$1 = Builder$2, ByteBuffer$1 = ByteBuffer$2;
class Footer_ {
  /** @nocollapse */
  static decode(t) {
    t = new ByteBuffer$1(toUint8Array(t));
    const g = Footer.getRootAsFooter(t), d = Schema$3.decode(g.schema(), /* @__PURE__ */ new Map(), g.version());
    return new OffHeapFooter(d, g);
  }
  /** @nocollapse */
  static encode(t) {
    const g = new Builder$1(), d = Schema$3.encode(g, t.schema);
    Footer.startRecordBatchesVector(g, t.numRecordBatches);
    for (const AA of [...t.recordBatches()].slice().reverse())
      FileBlock.encode(g, AA);
    const k = g.endVector();
    Footer.startDictionariesVector(g, t.numDictionaries);
    for (const AA of [...t.dictionaryBatches()].slice().reverse())
      FileBlock.encode(g, AA);
    const H = g.endVector();
    return Footer.startFooter(g), Footer.addSchema(g, d), Footer.addVersion(g, MetadataVersion.V5), Footer.addRecordBatches(g, k), Footer.addDictionaries(g, H), Footer.finishFooterBuffer(g, Footer.endFooter(g)), g.asUint8Array();
  }
  get numRecordBatches() {
    return this._recordBatches.length;
  }
  get numDictionaries() {
    return this._dictionaryBatches.length;
  }
  constructor(t, g = MetadataVersion.V5, d, k) {
    this.schema = t, this.version = g, d && (this._recordBatches = d), k && (this._dictionaryBatches = k);
  }
  *recordBatches() {
    for (let t, g = -1, d = this.numRecordBatches; ++g < d; )
      (t = this.getRecordBatch(g)) && (yield t);
  }
  *dictionaryBatches() {
    for (let t, g = -1, d = this.numDictionaries; ++g < d; )
      (t = this.getDictionaryBatch(g)) && (yield t);
  }
  getRecordBatch(t) {
    return t >= 0 && t < this.numRecordBatches && this._recordBatches[t] || null;
  }
  getDictionaryBatch(t) {
    return t >= 0 && t < this.numDictionaries && this._dictionaryBatches[t] || null;
  }
}
class OffHeapFooter extends Footer_ {
  get numRecordBatches() {
    return this._footer.recordBatchesLength();
  }
  get numDictionaries() {
    return this._footer.dictionariesLength();
  }
  constructor(t, g) {
    super(t, g.version()), this._footer = g;
  }
  getRecordBatch(t) {
    if (t >= 0 && t < this.numRecordBatches) {
      const g = this._footer.recordBatches(t);
      if (g)
        return FileBlock.decode(g);
    }
    return null;
  }
  getDictionaryBatch(t) {
    if (t >= 0 && t < this.numDictionaries) {
      const g = this._footer.dictionaries(t);
      if (g)
        return FileBlock.decode(g);
    }
    return null;
  }
}
class FileBlock {
  /** @nocollapse */
  static decode(t) {
    return new FileBlock(t.metaDataLength(), t.bodyLength(), t.offset());
  }
  /** @nocollapse */
  static encode(t, g) {
    const { metaDataLength: d } = g, k = BigInt(g.offset), H = BigInt(g.bodyLength);
    return Block$1.createBlock(t, k, d, H);
  }
  constructor(t, g, d) {
    this.metaDataLength = t, this.offset = bigIntToNumber(d), this.bodyLength = bigIntToNumber(g);
  }
}
let Message$1 = class CI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(t, g) {
    return this.bb_pos = t, this.bb = g, this;
  }
  static getRootAsMessage(t, g) {
    return (g || new CI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsMessage(t, g) {
    return t.setPosition(t.position() + SIZE_PREFIX_LENGTH), (g || new CI()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  version() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readInt16(this.bb_pos + t) : MetadataVersion.V1;
  }
  headerType() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readUint8(this.bb_pos + t) : MessageHeader.NONE;
  }
  header(t) {
    const g = this.bb.__offset(this.bb_pos, 8);
    return g ? this.bb.__union(t, this.bb_pos + g) : null;
  }
  bodyLength() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.readInt64(this.bb_pos + t) : BigInt("0");
  }
  customMetadata(t, g) {
    const d = this.bb.__offset(this.bb_pos, 12);
    return d ? (g || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + d) + t * 4), this.bb) : null;
  }
  customMetadataLength() {
    const t = this.bb.__offset(this.bb_pos, 12);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startMessage(t) {
    t.startObject(5);
  }
  static addVersion(t, g) {
    t.addFieldInt16(0, g, MetadataVersion.V1);
  }
  static addHeaderType(t, g) {
    t.addFieldInt8(1, g, MessageHeader.NONE);
  }
  static addHeader(t, g) {
    t.addFieldOffset(2, g, 0);
  }
  static addBodyLength(t, g) {
    t.addFieldInt64(3, g, BigInt("0"));
  }
  static addCustomMetadata(t, g) {
    t.addFieldOffset(4, g, 0);
  }
  static createCustomMetadataVector(t, g) {
    t.startVector(4, g.length, 4);
    for (let d = g.length - 1; d >= 0; d--)
      t.addOffset(g[d]);
    return t.endVector();
  }
  static startCustomMetadataVector(t, g) {
    t.startVector(4, g, 4);
  }
  static endMessage(t) {
    return t.endObject();
  }
  static finishMessageBuffer(t, g) {
    t.finish(g);
  }
  static finishSizePrefixedMessageBuffer(t, g) {
    t.finish(g, void 0, !0);
  }
  static createMessage(t, g, d, k, H, AA) {
    return CI.startMessage(t), CI.addVersion(t, g), CI.addHeaderType(t, d), CI.addHeader(t, k), CI.addBodyLength(t, H), CI.addCustomMetadata(t, AA), CI.endMessage(t);
  }
};
class TypeAssembler extends Visitor {
  visit(t, g) {
    return t == null || g == null ? void 0 : super.visit(t, g);
  }
  visitNull(t, g) {
    return Null$1.startNull(g), Null$1.endNull(g);
  }
  visitInt(t, g) {
    return Int.startInt(g), Int.addBitWidth(g, t.bitWidth), Int.addIsSigned(g, t.isSigned), Int.endInt(g);
  }
  visitFloat(t, g) {
    return FloatingPoint.startFloatingPoint(g), FloatingPoint.addPrecision(g, t.precision), FloatingPoint.endFloatingPoint(g);
  }
  visitBinary(t, g) {
    return Binary$1.startBinary(g), Binary$1.endBinary(g);
  }
  visitLargeBinary(t, g) {
    return LargeBinary$1.startLargeBinary(g), LargeBinary$1.endLargeBinary(g);
  }
  visitBool(t, g) {
    return Bool$1.startBool(g), Bool$1.endBool(g);
  }
  visitUtf8(t, g) {
    return Utf8$1.startUtf8(g), Utf8$1.endUtf8(g);
  }
  visitLargeUtf8(t, g) {
    return LargeUtf8$1.startLargeUtf8(g), LargeUtf8$1.endLargeUtf8(g);
  }
  visitDecimal(t, g) {
    return Decimal$1.startDecimal(g), Decimal$1.addScale(g, t.scale), Decimal$1.addPrecision(g, t.precision), Decimal$1.addBitWidth(g, t.bitWidth), Decimal$1.endDecimal(g);
  }
  visitDate(t, g) {
    return Date$1.startDate(g), Date$1.addUnit(g, t.unit), Date$1.endDate(g);
  }
  visitTime(t, g) {
    return Time$1.startTime(g), Time$1.addUnit(g, t.unit), Time$1.addBitWidth(g, t.bitWidth), Time$1.endTime(g);
  }
  visitTimestamp(t, g) {
    const d = t.timezone && g.createString(t.timezone) || void 0;
    return Timestamp.startTimestamp(g), Timestamp.addUnit(g, t.unit), d !== void 0 && Timestamp.addTimezone(g, d), Timestamp.endTimestamp(g);
  }
  visitInterval(t, g) {
    return Interval.startInterval(g), Interval.addUnit(g, t.unit), Interval.endInterval(g);
  }
  visitDuration(t, g) {
    return Duration$2.startDuration(g), Duration$2.addUnit(g, t.unit), Duration$2.endDuration(g);
  }
  visitList(t, g) {
    return List$1.startList(g), List$1.endList(g);
  }
  visitStruct(t, g) {
    return Struct_.startStruct_(g), Struct_.endStruct_(g);
  }
  visitUnion(t, g) {
    Union$1.startTypeIdsVector(g, t.typeIds.length);
    const d = Union$1.createTypeIdsVector(g, t.typeIds);
    return Union$1.startUnion(g), Union$1.addMode(g, t.mode), Union$1.addTypeIds(g, d), Union$1.endUnion(g);
  }
  visitDictionary(t, g) {
    const d = this.visit(t.indices, g);
    return DictionaryEncoding.startDictionaryEncoding(g), DictionaryEncoding.addId(g, BigInt(t.id)), DictionaryEncoding.addIsOrdered(g, t.isOrdered), d !== void 0 && DictionaryEncoding.addIndexType(g, d), DictionaryEncoding.endDictionaryEncoding(g);
  }
  visitFixedSizeBinary(t, g) {
    return FixedSizeBinary$1.startFixedSizeBinary(g), FixedSizeBinary$1.addByteWidth(g, t.byteWidth), FixedSizeBinary$1.endFixedSizeBinary(g);
  }
  visitFixedSizeList(t, g) {
    return FixedSizeList$2.startFixedSizeList(g), FixedSizeList$2.addListSize(g, t.listSize), FixedSizeList$2.endFixedSizeList(g);
  }
  visitMap(t, g) {
    return Map$2.startMap(g), Map$2.addKeysSorted(g, t.keysSorted), Map$2.endMap(g);
  }
}
const instance$1 = new TypeAssembler();
function schemaFromJSON(n, t = /* @__PURE__ */ new Map()) {
  return new Schema$3(schemaFieldsFromJSON(n, t), customMetadataFromJSON(n.metadata), t);
}
function recordBatchFromJSON(n) {
  return new RecordBatch$2(n.count, fieldNodesFromJSON(n.columns), buffersFromJSON(n.columns), null);
}
function dictionaryBatchFromJSON(n) {
  return new DictionaryBatch(recordBatchFromJSON(n.data), n.id, n.isDelta);
}
function schemaFieldsFromJSON(n, t) {
  return (n.fields || []).filter(Boolean).map((g) => Field$2.fromJSON(g, t));
}
function fieldChildrenFromJSON(n, t) {
  return (n.children || []).filter(Boolean).map((g) => Field$2.fromJSON(g, t));
}
function fieldNodesFromJSON(n) {
  return (n || []).reduce((t, g) => [
    ...t,
    new FieldNode(g.count, nullCountFromJSON(g.VALIDITY)),
    ...fieldNodesFromJSON(g.children)
  ], []);
}
function buffersFromJSON(n, t = []) {
  for (let g = -1, d = (n || []).length; ++g < d; ) {
    const k = n[g];
    k.VALIDITY && t.push(new BufferRegion(t.length, k.VALIDITY.length)), k.TYPE_ID && t.push(new BufferRegion(t.length, k.TYPE_ID.length)), k.OFFSET && t.push(new BufferRegion(t.length, k.OFFSET.length)), k.DATA && t.push(new BufferRegion(t.length, k.DATA.length)), t = buffersFromJSON(k.children, t);
  }
  return t;
}
function nullCountFromJSON(n) {
  return (n || []).reduce((t, g) => t + +(g === 0), 0);
}
function fieldFromJSON(n, t) {
  let g, d, k, H, AA, gA;
  return !t || !(H = n.dictionary) ? (AA = typeFromJSON(n, fieldChildrenFromJSON(n, t)), k = new Field$2(n.name, AA, n.nullable, customMetadataFromJSON(n.metadata))) : t.has(g = H.id) ? (d = (d = H.indexType) ? indexTypeFromJSON(d) : new Int32(), gA = new Dictionary(t.get(g), d, g, H.isOrdered), k = new Field$2(n.name, gA, n.nullable, customMetadataFromJSON(n.metadata))) : (d = (d = H.indexType) ? indexTypeFromJSON(d) : new Int32(), t.set(g, AA = typeFromJSON(n, fieldChildrenFromJSON(n, t))), gA = new Dictionary(AA, d, g, H.isOrdered), k = new Field$2(n.name, gA, n.nullable, customMetadataFromJSON(n.metadata))), k || null;
}
function customMetadataFromJSON(n = []) {
  return new Map(n.map(({ key: t, value: g }) => [t, g]));
}
function indexTypeFromJSON(n) {
  return new Int_(n.isSigned, n.bitWidth);
}
function typeFromJSON(n, t) {
  const g = n.type.name;
  switch (g) {
    case "NONE":
      return new Null();
    case "null":
      return new Null();
    case "binary":
      return new Binary();
    case "largebinary":
      return new LargeBinary();
    case "utf8":
      return new Utf8();
    case "largeutf8":
      return new LargeUtf8();
    case "bool":
      return new Bool();
    case "list":
      return new List((t || [])[0]);
    case "struct":
      return new Struct(t || []);
    case "struct_":
      return new Struct(t || []);
  }
  switch (g) {
    case "int": {
      const d = n.type;
      return new Int_(d.isSigned, d.bitWidth);
    }
    case "floatingpoint": {
      const d = n.type;
      return new Float(Precision[d.precision]);
    }
    case "decimal": {
      const d = n.type;
      return new Decimal(d.scale, d.precision, d.bitWidth);
    }
    case "date": {
      const d = n.type;
      return new Date_(DateUnit[d.unit]);
    }
    case "time": {
      const d = n.type;
      return new Time_(TimeUnit$1[d.unit], d.bitWidth);
    }
    case "timestamp": {
      const d = n.type;
      return new Timestamp_(TimeUnit$1[d.unit], d.timezone);
    }
    case "interval": {
      const d = n.type;
      return new Interval_(IntervalUnit[d.unit]);
    }
    case "duration": {
      const d = n.type;
      return new Duration$1(TimeUnit$1[d.unit]);
    }
    case "union": {
      const d = n.type, [k, ...H] = (d.mode + "").toLowerCase(), AA = k.toUpperCase() + H.join("");
      return new Union_(UnionMode[AA], d.typeIds || [], t || []);
    }
    case "fixedsizebinary": {
      const d = n.type;
      return new FixedSizeBinary(d.byteWidth);
    }
    case "fixedsizelist": {
      const d = n.type;
      return new FixedSizeList$1(d.listSize, (t || [])[0]);
    }
    case "map": {
      const d = n.type;
      return new Map_((t || [])[0], d.keysSorted);
    }
  }
  throw new Error(`Unrecognized type: "${g}"`);
}
var Builder = Builder$2, ByteBuffer = ByteBuffer$2;
class Message {
  /** @nocollapse */
  static fromJSON(t, g) {
    const d = new Message(0, MetadataVersion.V5, g);
    return d._createHeader = messageHeaderFromJSON(t, g), d;
  }
  /** @nocollapse */
  static decode(t) {
    t = new ByteBuffer(toUint8Array(t));
    const g = Message$1.getRootAsMessage(t), d = g.bodyLength(), k = g.version(), H = g.headerType(), AA = new Message(d, k, H);
    return AA._createHeader = decodeMessageHeader(g, H), AA;
  }
  /** @nocollapse */
  static encode(t) {
    const g = new Builder();
    let d = -1;
    return t.isSchema() ? d = Schema$3.encode(g, t.header()) : t.isRecordBatch() ? d = RecordBatch$2.encode(g, t.header()) : t.isDictionaryBatch() && (d = DictionaryBatch.encode(g, t.header())), Message$1.startMessage(g), Message$1.addVersion(g, MetadataVersion.V5), Message$1.addHeader(g, d), Message$1.addHeaderType(g, t.headerType), Message$1.addBodyLength(g, BigInt(t.bodyLength)), Message$1.finishMessageBuffer(g, Message$1.endMessage(g)), g.asUint8Array();
  }
  /** @nocollapse */
  static from(t, g = 0) {
    if (t instanceof Schema$3)
      return new Message(0, MetadataVersion.V5, MessageHeader.Schema, t);
    if (t instanceof RecordBatch$2)
      return new Message(g, MetadataVersion.V5, MessageHeader.RecordBatch, t);
    if (t instanceof DictionaryBatch)
      return new Message(g, MetadataVersion.V5, MessageHeader.DictionaryBatch, t);
    throw new Error(`Unrecognized Message header: ${t}`);
  }
  get type() {
    return this.headerType;
  }
  get version() {
    return this._version;
  }
  get headerType() {
    return this._headerType;
  }
  get compression() {
    return this._compression;
  }
  get bodyLength() {
    return this._bodyLength;
  }
  header() {
    return this._createHeader();
  }
  isSchema() {
    return this.headerType === MessageHeader.Schema;
  }
  isRecordBatch() {
    return this.headerType === MessageHeader.RecordBatch;
  }
  isDictionaryBatch() {
    return this.headerType === MessageHeader.DictionaryBatch;
  }
  constructor(t, g, d, k) {
    this._version = g, this._headerType = d, this.body = new Uint8Array(0), this._compression = k?.compression, k && (this._createHeader = () => k), this._bodyLength = bigIntToNumber(t);
  }
}
let RecordBatch$2 = class {
  get nodes() {
    return this._nodes;
  }
  get length() {
    return this._length;
  }
  get buffers() {
    return this._buffers;
  }
  get compression() {
    return this._compression;
  }
  constructor(t, g, d, k) {
    this._nodes = g, this._buffers = d, this._length = bigIntToNumber(t), this._compression = k;
  }
};
class DictionaryBatch {
  get id() {
    return this._id;
  }
  get data() {
    return this._data;
  }
  get isDelta() {
    return this._isDelta;
  }
  get length() {
    return this.data.length;
  }
  get nodes() {
    return this.data.nodes;
  }
  get buffers() {
    return this.data.buffers;
  }
  constructor(t, g, d = !1) {
    this._data = t, this._isDelta = d, this._id = bigIntToNumber(g);
  }
}
class BufferRegion {
  constructor(t, g) {
    this.offset = bigIntToNumber(t), this.length = bigIntToNumber(g);
  }
}
class FieldNode {
  constructor(t, g) {
    this.length = bigIntToNumber(t), this.nullCount = bigIntToNumber(g);
  }
}
class BodyCompression {
  constructor(t, g = BodyCompressionMethod.BUFFER) {
    this.type = t, this.method = g;
  }
}
function messageHeaderFromJSON(n, t) {
  return (() => {
    switch (t) {
      case MessageHeader.Schema:
        return Schema$3.fromJSON(n);
      case MessageHeader.RecordBatch:
        return RecordBatch$2.fromJSON(n);
      case MessageHeader.DictionaryBatch:
        return DictionaryBatch.fromJSON(n);
    }
    throw new Error(`Unrecognized Message type: { name: ${MessageHeader[t]}, type: ${t} }`);
  });
}
function decodeMessageHeader(n, t) {
  return (() => {
    switch (t) {
      case MessageHeader.Schema:
        return Schema$3.decode(n.header(new Schema$4()), /* @__PURE__ */ new Map(), n.version());
      case MessageHeader.RecordBatch:
        return RecordBatch$2.decode(n.header(new RecordBatch$3()), n.version());
      case MessageHeader.DictionaryBatch:
        return DictionaryBatch.decode(n.header(new DictionaryBatch$1()), n.version());
    }
    throw new Error(`Unrecognized Message type: { name: ${MessageHeader[t]}, type: ${t} }`);
  });
}
Field$2.encode = encodeField;
Field$2.decode = decodeField;
Field$2.fromJSON = fieldFromJSON;
Schema$3.encode = encodeSchema;
Schema$3.decode = decodeSchema;
Schema$3.fromJSON = schemaFromJSON;
RecordBatch$2.encode = encodeRecordBatch;
RecordBatch$2.decode = decodeRecordBatch;
RecordBatch$2.fromJSON = recordBatchFromJSON;
DictionaryBatch.encode = encodeDictionaryBatch;
DictionaryBatch.decode = decodeDictionaryBatch;
DictionaryBatch.fromJSON = dictionaryBatchFromJSON;
FieldNode.encode = encodeFieldNode;
FieldNode.decode = decodeFieldNode;
BufferRegion.encode = encodeBufferRegion;
BufferRegion.decode = decodeBufferRegion;
BodyCompression.encode = encodeBodyCompression;
BodyCompression.decode = decodeBodyCompression;
function decodeSchema(n, t = /* @__PURE__ */ new Map(), g = MetadataVersion.V5) {
  const d = decodeSchemaFields(n, t);
  return new Schema$3(d, decodeCustomMetadata(n), t, g);
}
function decodeRecordBatch(n, t = MetadataVersion.V5) {
  return new RecordBatch$2(n.length(), decodeFieldNodes(n), decodeBuffers(n, t), decodeBodyCompression(n.compression()));
}
function decodeDictionaryBatch(n, t = MetadataVersion.V5) {
  return new DictionaryBatch(RecordBatch$2.decode(n.data(), t), n.id(), n.isDelta());
}
function decodeBufferRegion(n) {
  return new BufferRegion(n.offset(), n.length());
}
function decodeFieldNode(n) {
  return new FieldNode(n.length(), n.nullCount());
}
function decodeFieldNodes(n) {
  const t = [];
  for (let g, d = -1, k = -1, H = n.nodesLength(); ++d < H; )
    (g = n.nodes(d)) && (t[++k] = FieldNode.decode(g));
  return t;
}
function decodeBuffers(n, t) {
  const g = [];
  for (let d, k = -1, H = -1, AA = n.buffersLength(); ++k < AA; )
    (d = n.buffers(k)) && (t < MetadataVersion.V4 && (d.bb_pos += 8 * (k + 1)), g[++H] = BufferRegion.decode(d));
  return g;
}
function decodeSchemaFields(n, t) {
  const g = [];
  for (let d, k = -1, H = -1, AA = n.fieldsLength(); ++k < AA; )
    (d = n.fields(k)) && (g[++H] = Field$2.decode(d, t));
  return g;
}
function decodeFieldChildren(n, t) {
  const g = [];
  for (let d, k = -1, H = -1, AA = n.childrenLength(); ++k < AA; )
    (d = n.children(k)) && (g[++H] = Field$2.decode(d, t));
  return g;
}
function decodeField(n, t) {
  let g, d, k, H, AA, gA;
  return !t || !(gA = n.dictionary()) ? (k = decodeFieldType(n, decodeFieldChildren(n, t)), d = new Field$2(n.name(), k, n.nullable(), decodeCustomMetadata(n))) : t.has(g = bigIntToNumber(gA.id())) ? (H = (H = gA.indexType()) ? decodeIndexType(H) : new Int32(), AA = new Dictionary(t.get(g), H, g, gA.isOrdered()), d = new Field$2(n.name(), AA, n.nullable(), decodeCustomMetadata(n))) : (H = (H = gA.indexType()) ? decodeIndexType(H) : new Int32(), t.set(g, k = decodeFieldType(n, decodeFieldChildren(n, t))), AA = new Dictionary(k, H, g, gA.isOrdered()), d = new Field$2(n.name(), AA, n.nullable(), decodeCustomMetadata(n))), d || null;
}
function decodeCustomMetadata(n) {
  const t = /* @__PURE__ */ new Map();
  if (n)
    for (let g, d, k = -1, H = Math.trunc(n.customMetadataLength()); ++k < H; )
      (g = n.customMetadata(k)) && (d = g.key()) != null && t.set(d, g.value());
  return t;
}
function decodeIndexType(n) {
  return new Int_(n.isSigned(), n.bitWidth());
}
function decodeFieldType(n, t) {
  const g = n.typeType();
  switch (g) {
    case Type$2.NONE:
      return new Null();
    case Type$2.Null:
      return new Null();
    case Type$2.Binary:
      return new Binary();
    case Type$2.LargeBinary:
      return new LargeBinary();
    case Type$2.Utf8:
      return new Utf8();
    case Type$2.LargeUtf8:
      return new LargeUtf8();
    case Type$2.Bool:
      return new Bool();
    case Type$2.List:
      return new List((t || [])[0]);
    case Type$2.Struct_:
      return new Struct(t || []);
  }
  switch (g) {
    case Type$2.Int: {
      const d = n.type(new Int());
      return new Int_(d.isSigned(), d.bitWidth());
    }
    case Type$2.FloatingPoint: {
      const d = n.type(new FloatingPoint());
      return new Float(d.precision());
    }
    case Type$2.Decimal: {
      const d = n.type(new Decimal$1());
      return new Decimal(d.scale(), d.precision(), d.bitWidth());
    }
    case Type$2.Date: {
      const d = n.type(new Date$1());
      return new Date_(d.unit());
    }
    case Type$2.Time: {
      const d = n.type(new Time$1());
      return new Time_(d.unit(), d.bitWidth());
    }
    case Type$2.Timestamp: {
      const d = n.type(new Timestamp());
      return new Timestamp_(d.unit(), d.timezone());
    }
    case Type$2.Interval: {
      const d = n.type(new Interval());
      return new Interval_(d.unit());
    }
    case Type$2.Duration: {
      const d = n.type(new Duration$2());
      return new Duration$1(d.unit());
    }
    case Type$2.Union: {
      const d = n.type(new Union$1());
      return new Union_(d.mode(), d.typeIdsArray() || [], t || []);
    }
    case Type$2.FixedSizeBinary: {
      const d = n.type(new FixedSizeBinary$1());
      return new FixedSizeBinary(d.byteWidth());
    }
    case Type$2.FixedSizeList: {
      const d = n.type(new FixedSizeList$2());
      return new FixedSizeList$1(d.listSize(), (t || [])[0]);
    }
    case Type$2.Map: {
      const d = n.type(new Map$2());
      return new Map_((t || [])[0], d.keysSorted());
    }
  }
  throw new Error(`Unrecognized type: "${Type$2[g]}" (${g})`);
}
function decodeBodyCompression(n) {
  return n ? new BodyCompression(n.codec(), n.method()) : null;
}
function encodeSchema(n, t) {
  const g = t.fields.map((H) => Field$2.encode(n, H));
  Schema$4.startFieldsVector(n, g.length);
  const d = Schema$4.createFieldsVector(n, g), k = t.metadata && t.metadata.size > 0 ? Schema$4.createCustomMetadataVector(n, [...t.metadata].map(([H, AA]) => {
    const gA = n.createString(`${H}`), IA = n.createString(`${AA}`);
    return KeyValue.startKeyValue(n), KeyValue.addKey(n, gA), KeyValue.addValue(n, IA), KeyValue.endKeyValue(n);
  })) : -1;
  return Schema$4.startSchema(n), Schema$4.addFields(n, d), Schema$4.addEndianness(n, platformIsLittleEndian ? Endianness.Little : Endianness.Big), k !== -1 && Schema$4.addCustomMetadata(n, k), Schema$4.endSchema(n);
}
function encodeField(n, t) {
  let g = -1, d = -1, k = -1;
  const H = t.type;
  let AA = t.typeId;
  DataType.isDictionary(H) ? (AA = H.dictionary.typeId, k = instance$1.visit(H, n), d = instance$1.visit(H.dictionary, n)) : d = instance$1.visit(H, n);
  const gA = (H.children || []).map((BA) => Field$2.encode(n, BA)), IA = Field$3.createChildrenVector(n, gA), CA = t.metadata && t.metadata.size > 0 ? Field$3.createCustomMetadataVector(n, [...t.metadata].map(([BA, eA]) => {
    const iA = n.createString(`${BA}`), QA = n.createString(`${eA}`);
    return KeyValue.startKeyValue(n), KeyValue.addKey(n, iA), KeyValue.addValue(n, QA), KeyValue.endKeyValue(n);
  })) : -1;
  return t.name && (g = n.createString(t.name)), Field$3.startField(n), Field$3.addType(n, d), Field$3.addTypeType(n, AA), Field$3.addChildren(n, IA), Field$3.addNullable(n, !!t.nullable), g !== -1 && Field$3.addName(n, g), k !== -1 && Field$3.addDictionary(n, k), CA !== -1 && Field$3.addCustomMetadata(n, CA), Field$3.endField(n);
}
function encodeRecordBatch(n, t) {
  const g = t.nodes || [], d = t.buffers || [];
  RecordBatch$3.startNodesVector(n, g.length);
  for (const gA of g.slice().reverse())
    FieldNode.encode(n, gA);
  const k = n.endVector();
  RecordBatch$3.startBuffersVector(n, d.length);
  for (const gA of d.slice().reverse())
    BufferRegion.encode(n, gA);
  const H = n.endVector();
  let AA = null;
  return t.compression !== null && (AA = encodeBodyCompression(n, t.compression)), RecordBatch$3.startRecordBatch(n), RecordBatch$3.addLength(n, BigInt(t.length)), RecordBatch$3.addNodes(n, k), RecordBatch$3.addBuffers(n, H), t.compression !== null && AA && RecordBatch$3.addCompression(n, AA), RecordBatch$3.endRecordBatch(n);
}
function encodeBodyCompression(n, t) {
  return BodyCompression$1.startBodyCompression(n), BodyCompression$1.addCodec(n, t.type), BodyCompression$1.addMethod(n, t.method), BodyCompression$1.endBodyCompression(n);
}
function encodeDictionaryBatch(n, t) {
  const g = RecordBatch$2.encode(n, t.data);
  return DictionaryBatch$1.startDictionaryBatch(n), DictionaryBatch$1.addId(n, BigInt(t.id)), DictionaryBatch$1.addIsDelta(n, t.isDelta), DictionaryBatch$1.addData(n, g), DictionaryBatch$1.endDictionaryBatch(n);
}
function encodeFieldNode(n, t) {
  return FieldNode$1.createFieldNode(n, BigInt(t.length), BigInt(t.nullCount));
}
function encodeBufferRegion(n, t) {
  return Buffer$3.createBuffer(n, BigInt(t.offset), BigInt(t.length));
}
const platformIsLittleEndian = (() => {
  const n = new ArrayBuffer(2);
  return new DataView(n).setInt16(
    0,
    256,
    !0
    /* littleEndian */
  ), new Int16Array(n)[0] === 256;
})(), ITERATOR_DONE = Object.freeze({ done: !0, value: void 0 });
class ArrowJSON {
  constructor(t) {
    this._json = t;
  }
  get schema() {
    return this._json.schema;
  }
  get batches() {
    return this._json.batches || [];
  }
  get dictionaries() {
    return this._json.dictionaries || [];
  }
}
class ReadableInterop {
  tee() {
    return this._getDOMStream().tee();
  }
  pipe(t, g) {
    return this._getNodeStream().pipe(t, g);
  }
  pipeTo(t, g) {
    return this._getDOMStream().pipeTo(t, g);
  }
  pipeThrough(t, g) {
    return this._getDOMStream().pipeThrough(t, g);
  }
  _getDOMStream() {
    return this._DOMStream || (this._DOMStream = this.toDOMStream());
  }
  _getNodeStream() {
    return this._nodeStream || (this._nodeStream = this.toNodeStream());
  }
}
class AsyncQueue extends ReadableInterop {
  constructor() {
    super(), this._values = [], this.resolvers = [], this._closedPromise = new Promise((t) => this._closedPromiseResolve = t);
  }
  get closed() {
    return this._closedPromise;
  }
  cancel(t) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.return(t);
    });
  }
  write(t) {
    this._ensureOpen() && (this.resolvers.length <= 0 ? this._values.push(t) : this.resolvers.shift().resolve({ done: !1, value: t }));
  }
  abort(t) {
    this._closedPromiseResolve && (this.resolvers.length <= 0 ? this._error = { error: t } : this.resolvers.shift().reject({ done: !0, value: t }));
  }
  close() {
    if (this._closedPromiseResolve) {
      const { resolvers: t } = this;
      for (; t.length > 0; )
        t.shift().resolve(ITERATOR_DONE);
      this._closedPromiseResolve(), this._closedPromiseResolve = void 0;
    }
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  toDOMStream(t) {
    return streamAdapters.toDOMStream(this._closedPromiseResolve || this._error ? this : this._values, t);
  }
  toNodeStream(t) {
    return streamAdapters.toNodeStream(this._closedPromiseResolve || this._error ? this : this._values, t);
  }
  throw(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.abort(t), ITERATOR_DONE;
    });
  }
  return(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.close(), ITERATOR_DONE;
    });
  }
  read(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(t, "read")).value;
    });
  }
  peek(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(t, "peek")).value;
    });
  }
  next(...t) {
    return this._values.length > 0 ? Promise.resolve({ done: !1, value: this._values.shift() }) : this._error ? Promise.reject({ done: !0, value: this._error.error }) : this._closedPromiseResolve ? new Promise((g, d) => {
      this.resolvers.push({ resolve: g, reject: d });
    }) : Promise.resolve(ITERATOR_DONE);
  }
  _ensureOpen() {
    if (this._closedPromiseResolve)
      return !0;
    throw new Error("AsyncQueue is closed");
  }
}
class AsyncByteQueue extends AsyncQueue {
  write(t) {
    if ((t = toUint8Array(t)).byteLength > 0)
      return super.write(t);
  }
  toString(t = !1) {
    return t ? decodeUtf8(this.toUint8Array(!0)) : this.toUint8Array(!1).then(decodeUtf8);
  }
  toUint8Array(t = !1) {
    return t ? joinUint8Arrays(this._values)[0] : __awaiter(this, void 0, void 0, function* () {
      var g, d, k, H;
      const AA = [];
      let gA = 0;
      try {
        for (var IA = !0, CA = __asyncValues(this), BA; BA = yield CA.next(), g = BA.done, !g; IA = !0) {
          H = BA.value, IA = !1;
          const eA = H;
          AA.push(eA), gA += eA.byteLength;
        }
      } catch (eA) {
        d = { error: eA };
      } finally {
        try {
          !IA && !g && (k = CA.return) && (yield k.call(CA));
        } finally {
          if (d) throw d.error;
        }
      }
      return joinUint8Arrays(AA, gA)[0];
    });
  }
}
class ByteStream {
  constructor(t) {
    t && (this.source = new ByteStreamSource(streamAdapters.fromIterable(t)));
  }
  [Symbol.iterator]() {
    return this;
  }
  next(t) {
    return this.source.next(t);
  }
  throw(t) {
    return this.source.throw(t);
  }
  return(t) {
    return this.source.return(t);
  }
  peek(t) {
    return this.source.peek(t);
  }
  read(t) {
    return this.source.read(t);
  }
}
class AsyncByteStream {
  constructor(t) {
    t instanceof AsyncByteStream ? this.source = t.source : t instanceof AsyncByteQueue ? this.source = new AsyncByteStreamSource(streamAdapters.fromAsyncIterable(t)) : isReadableNodeStream(t) ? this.source = new AsyncByteStreamSource(streamAdapters.fromNodeStream(t)) : isReadableDOMStream(t) ? this.source = new AsyncByteStreamSource(streamAdapters.fromDOMStream(t)) : isFetchResponse(t) ? this.source = new AsyncByteStreamSource(streamAdapters.fromDOMStream(t.body)) : isIterable$2(t) ? this.source = new AsyncByteStreamSource(streamAdapters.fromIterable(t)) : isPromise(t) ? this.source = new AsyncByteStreamSource(streamAdapters.fromAsyncIterable(t)) : isAsyncIterable$1(t) && (this.source = new AsyncByteStreamSource(streamAdapters.fromAsyncIterable(t)));
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next(t) {
    return this.source.next(t);
  }
  throw(t) {
    return this.source.throw(t);
  }
  return(t) {
    return this.source.return(t);
  }
  get closed() {
    return this.source.closed;
  }
  cancel(t) {
    return this.source.cancel(t);
  }
  peek(t) {
    return this.source.peek(t);
  }
  read(t) {
    return this.source.read(t);
  }
}
class ByteStreamSource {
  constructor(t) {
    this.source = t;
  }
  cancel(t) {
    this.return(t);
  }
  peek(t) {
    return this.next(t, "peek").value;
  }
  read(t) {
    return this.next(t, "read").value;
  }
  next(t, g = "read") {
    return this.source.next({ cmd: g, size: t });
  }
  throw(t) {
    return Object.create(this.source.throw && this.source.throw(t) || ITERATOR_DONE);
  }
  return(t) {
    return Object.create(this.source.return && this.source.return(t) || ITERATOR_DONE);
  }
}
class AsyncByteStreamSource {
  constructor(t) {
    this.source = t, this._closedPromise = new Promise((g) => this._closedPromiseResolve = g);
  }
  cancel(t) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.return(t);
    });
  }
  get closed() {
    return this._closedPromise;
  }
  read(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(t, "read")).value;
    });
  }
  peek(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(t, "peek")).value;
    });
  }
  next(t) {
    return __awaiter(this, arguments, void 0, function* (g, d = "read") {
      return yield this.source.next({ cmd: d, size: g });
    });
  }
  throw(t) {
    return __awaiter(this, void 0, void 0, function* () {
      const g = this.source.throw && (yield this.source.throw(t)) || ITERATOR_DONE;
      return this._closedPromiseResolve && this._closedPromiseResolve(), this._closedPromiseResolve = void 0, Object.create(g);
    });
  }
  return(t) {
    return __awaiter(this, void 0, void 0, function* () {
      const g = this.source.return && (yield this.source.return(t)) || ITERATOR_DONE;
      return this._closedPromiseResolve && this._closedPromiseResolve(), this._closedPromiseResolve = void 0, Object.create(g);
    });
  }
}
class RandomAccessFile extends ByteStream {
  constructor(t, g) {
    super(), this.position = 0, this.buffer = toUint8Array(t), this.size = g === void 0 ? this.buffer.byteLength : g;
  }
  readInt32(t) {
    const { buffer: g, byteOffset: d } = this.readAt(t, 4);
    return new DataView(g, d).getInt32(0, !0);
  }
  seek(t) {
    return this.position = Math.min(t, this.size), t < this.size;
  }
  read(t) {
    const { buffer: g, size: d, position: k } = this;
    return g && k < d ? (typeof t != "number" && (t = Number.POSITIVE_INFINITY), this.position = Math.min(d, k + Math.min(d - k, t)), g.subarray(k, this.position)) : null;
  }
  readAt(t, g) {
    const d = this.buffer, k = Math.min(this.size, t + g);
    return d ? d.subarray(t, k) : new Uint8Array(g);
  }
  close() {
    this.buffer && (this.buffer = null);
  }
  throw(t) {
    return this.close(), { done: !0, value: t };
  }
  return(t) {
    return this.close(), { done: !0, value: t };
  }
}
class AsyncRandomAccessFile extends AsyncByteStream {
  constructor(t, g) {
    super(), this.position = 0, this._handle = t, typeof g == "number" ? this.size = g : this._pending = __awaiter(this, void 0, void 0, function* () {
      this.size = (yield t.stat()).size, delete this._pending;
    });
  }
  readInt32(t) {
    return __awaiter(this, void 0, void 0, function* () {
      const { buffer: g, byteOffset: d } = yield this.readAt(t, 4);
      return new DataView(g, d).getInt32(0, !0);
    });
  }
  seek(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._pending && (yield this._pending), this.position = Math.min(t, this.size), t < this.size;
    });
  }
  read(t) {
    return __awaiter(this, void 0, void 0, function* () {
      this._pending && (yield this._pending);
      const { _handle: g, size: d, position: k } = this;
      if (g && k < d) {
        typeof t != "number" && (t = Number.POSITIVE_INFINITY);
        let H = k, AA = 0, gA = 0;
        const IA = Math.min(d, H + Math.min(d - H, t)), CA = new Uint8Array(Math.max(0, (this.position = IA) - H));
        for (; (H += gA) < IA && (AA += gA) < CA.byteLength; )
          ({ bytesRead: gA } = yield g.read(CA, AA, CA.byteLength - AA, H));
        return CA;
      }
      return null;
    });
  }
  readAt(t, g) {
    return __awaiter(this, void 0, void 0, function* () {
      this._pending && (yield this._pending);
      const { _handle: d, size: k } = this;
      if (d && t + g < k) {
        const H = Math.min(k, t + g), AA = new Uint8Array(H - t);
        return (yield d.read(AA, 0, g, t)).buffer;
      }
      return new Uint8Array(g);
    });
  }
  close() {
    return __awaiter(this, void 0, void 0, function* () {
      const t = this._handle;
      this._handle = null, t && (yield t.close());
    });
  }
  throw(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.close(), { done: !0, value: t };
    });
  }
  return(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.close(), { done: !0, value: t };
    });
  }
}
const carryBit16 = 65536;
function intAsHex(n) {
  return n < 0 && (n = 4294967295 + n + 1), `0x${n.toString(16)}`;
}
const kInt32DecimalDigits = 8, kPowersOfTen = [
  1,
  10,
  100,
  1e3,
  1e4,
  1e5,
  1e6,
  1e7,
  1e8
];
class BaseInt64 {
  constructor(t) {
    this.buffer = t;
  }
  high() {
    return this.buffer[1];
  }
  low() {
    return this.buffer[0];
  }
  _times(t) {
    const g = new Uint32Array([
      this.buffer[1] >>> 16,
      this.buffer[1] & 65535,
      this.buffer[0] >>> 16,
      this.buffer[0] & 65535
    ]), d = new Uint32Array([
      t.buffer[1] >>> 16,
      t.buffer[1] & 65535,
      t.buffer[0] >>> 16,
      t.buffer[0] & 65535
    ]);
    let k = g[3] * d[3];
    this.buffer[0] = k & 65535;
    let H = k >>> 16;
    return k = g[2] * d[3], H += k, k = g[3] * d[2] >>> 0, H += k, this.buffer[0] += H << 16, this.buffer[1] = H >>> 0 < k ? carryBit16 : 0, this.buffer[1] += H >>> 16, this.buffer[1] += g[1] * d[3] + g[2] * d[2] + g[3] * d[1], this.buffer[1] += g[0] * d[3] + g[1] * d[2] + g[2] * d[1] + g[3] * d[0] << 16, this;
  }
  _plus(t) {
    const g = this.buffer[0] + t.buffer[0] >>> 0;
    this.buffer[1] += t.buffer[1], g < this.buffer[0] >>> 0 && ++this.buffer[1], this.buffer[0] = g;
  }
  lessThan(t) {
    return this.buffer[1] < t.buffer[1] || this.buffer[1] === t.buffer[1] && this.buffer[0] < t.buffer[0];
  }
  equals(t) {
    return this.buffer[1] === t.buffer[1] && this.buffer[0] == t.buffer[0];
  }
  greaterThan(t) {
    return t.lessThan(this);
  }
  hex() {
    return `${intAsHex(this.buffer[1])} ${intAsHex(this.buffer[0])}`;
  }
}
class Uint64 extends BaseInt64 {
  times(t) {
    return this._times(t), this;
  }
  plus(t) {
    return this._plus(t), this;
  }
  /** @nocollapse */
  static from(t, g = new Uint32Array(2)) {
    return Uint64.fromString(typeof t == "string" ? t : t.toString(), g);
  }
  /** @nocollapse */
  static fromNumber(t, g = new Uint32Array(2)) {
    return Uint64.fromString(t.toString(), g);
  }
  /** @nocollapse */
  static fromString(t, g = new Uint32Array(2)) {
    const d = t.length, k = new Uint64(g);
    for (let H = 0; H < d; ) {
      const AA = kInt32DecimalDigits < d - H ? kInt32DecimalDigits : d - H, gA = new Uint64(new Uint32Array([Number.parseInt(t.slice(H, H + AA), 10), 0])), IA = new Uint64(new Uint32Array([kPowersOfTen[AA], 0]));
      k.times(IA), k.plus(gA), H += AA;
    }
    return k;
  }
  /** @nocollapse */
  static convertArray(t) {
    const g = new Uint32Array(t.length * 2);
    for (let d = -1, k = t.length; ++d < k; )
      Uint64.from(t[d], new Uint32Array(g.buffer, g.byteOffset + 2 * d * 4, 2));
    return g;
  }
  /** @nocollapse */
  static multiply(t, g) {
    return new Uint64(new Uint32Array(t.buffer)).times(g);
  }
  /** @nocollapse */
  static add(t, g) {
    return new Uint64(new Uint32Array(t.buffer)).plus(g);
  }
}
class Int64 extends BaseInt64 {
  negate() {
    return this.buffer[0] = ~this.buffer[0] + 1, this.buffer[1] = ~this.buffer[1], this.buffer[0] == 0 && ++this.buffer[1], this;
  }
  times(t) {
    return this._times(t), this;
  }
  plus(t) {
    return this._plus(t), this;
  }
  lessThan(t) {
    const g = this.buffer[1] << 0, d = t.buffer[1] << 0;
    return g < d || g === d && this.buffer[0] < t.buffer[0];
  }
  /** @nocollapse */
  static from(t, g = new Uint32Array(2)) {
    return Int64.fromString(typeof t == "string" ? t : t.toString(), g);
  }
  /** @nocollapse */
  static fromNumber(t, g = new Uint32Array(2)) {
    return Int64.fromString(t.toString(), g);
  }
  /** @nocollapse */
  static fromString(t, g = new Uint32Array(2)) {
    const d = t.startsWith("-"), k = t.length, H = new Int64(g);
    for (let AA = d ? 1 : 0; AA < k; ) {
      const gA = kInt32DecimalDigits < k - AA ? kInt32DecimalDigits : k - AA, IA = new Int64(new Uint32Array([Number.parseInt(t.slice(AA, AA + gA), 10), 0])), CA = new Int64(new Uint32Array([kPowersOfTen[gA], 0]));
      H.times(CA), H.plus(IA), AA += gA;
    }
    return d ? H.negate() : H;
  }
  /** @nocollapse */
  static convertArray(t) {
    const g = new Uint32Array(t.length * 2);
    for (let d = -1, k = t.length; ++d < k; )
      Int64.from(t[d], new Uint32Array(g.buffer, g.byteOffset + 2 * d * 4, 2));
    return g;
  }
  /** @nocollapse */
  static multiply(t, g) {
    return new Int64(new Uint32Array(t.buffer)).times(g);
  }
  /** @nocollapse */
  static add(t, g) {
    return new Int64(new Uint32Array(t.buffer)).plus(g);
  }
}
class Int128 {
  constructor(t) {
    this.buffer = t;
  }
  high() {
    return new Int64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2));
  }
  low() {
    return new Int64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset, 2));
  }
  negate() {
    return this.buffer[0] = ~this.buffer[0] + 1, this.buffer[1] = ~this.buffer[1], this.buffer[2] = ~this.buffer[2], this.buffer[3] = ~this.buffer[3], this.buffer[0] == 0 && ++this.buffer[1], this.buffer[1] == 0 && ++this.buffer[2], this.buffer[2] == 0 && ++this.buffer[3], this;
  }
  times(t) {
    const g = new Uint64(new Uint32Array([this.buffer[3], 0])), d = new Uint64(new Uint32Array([this.buffer[2], 0])), k = new Uint64(new Uint32Array([this.buffer[1], 0])), H = new Uint64(new Uint32Array([this.buffer[0], 0])), AA = new Uint64(new Uint32Array([t.buffer[3], 0])), gA = new Uint64(new Uint32Array([t.buffer[2], 0])), IA = new Uint64(new Uint32Array([t.buffer[1], 0])), CA = new Uint64(new Uint32Array([t.buffer[0], 0]));
    let BA = Uint64.multiply(H, CA);
    this.buffer[0] = BA.low();
    const eA = new Uint64(new Uint32Array([BA.high(), 0]));
    return BA = Uint64.multiply(k, CA), eA.plus(BA), BA = Uint64.multiply(H, IA), eA.plus(BA), this.buffer[1] = eA.low(), this.buffer[3] = eA.lessThan(BA) ? 1 : 0, this.buffer[2] = eA.high(), new Uint64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2)).plus(Uint64.multiply(d, CA)).plus(Uint64.multiply(k, IA)).plus(Uint64.multiply(H, gA)), this.buffer[3] += Uint64.multiply(g, CA).plus(Uint64.multiply(d, IA)).plus(Uint64.multiply(k, gA)).plus(Uint64.multiply(H, AA)).low(), this;
  }
  plus(t) {
    const g = new Uint32Array(4);
    return g[3] = this.buffer[3] + t.buffer[3] >>> 0, g[2] = this.buffer[2] + t.buffer[2] >>> 0, g[1] = this.buffer[1] + t.buffer[1] >>> 0, g[0] = this.buffer[0] + t.buffer[0] >>> 0, g[0] < this.buffer[0] >>> 0 && ++g[1], g[1] < this.buffer[1] >>> 0 && ++g[2], g[2] < this.buffer[2] >>> 0 && ++g[3], this.buffer[3] = g[3], this.buffer[2] = g[2], this.buffer[1] = g[1], this.buffer[0] = g[0], this;
  }
  hex() {
    return `${intAsHex(this.buffer[3])} ${intAsHex(this.buffer[2])} ${intAsHex(this.buffer[1])} ${intAsHex(this.buffer[0])}`;
  }
  /** @nocollapse */
  static multiply(t, g) {
    return new Int128(new Uint32Array(t.buffer)).times(g);
  }
  /** @nocollapse */
  static add(t, g) {
    return new Int128(new Uint32Array(t.buffer)).plus(g);
  }
  /** @nocollapse */
  static from(t, g = new Uint32Array(4)) {
    return Int128.fromString(typeof t == "string" ? t : t.toString(), g);
  }
  /** @nocollapse */
  static fromNumber(t, g = new Uint32Array(4)) {
    return Int128.fromString(t.toString(), g);
  }
  /** @nocollapse */
  static fromString(t, g = new Uint32Array(4)) {
    const d = t.startsWith("-"), k = t.length, H = new Int128(g);
    for (let AA = d ? 1 : 0; AA < k; ) {
      const gA = kInt32DecimalDigits < k - AA ? kInt32DecimalDigits : k - AA, IA = new Int128(new Uint32Array([Number.parseInt(t.slice(AA, AA + gA), 10), 0, 0, 0])), CA = new Int128(new Uint32Array([kPowersOfTen[gA], 0, 0, 0]));
      H.times(CA), H.plus(IA), AA += gA;
    }
    return d ? H.negate() : H;
  }
  /** @nocollapse */
  static convertArray(t) {
    const g = new Uint32Array(t.length * 4);
    for (let d = -1, k = t.length; ++d < k; )
      Int128.from(t[d], new Uint32Array(g.buffer, g.byteOffset + 16 * d, 4));
    return g;
  }
}
const util_int_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseInt64,
  Int128,
  Int64,
  Uint64
}, Symbol.toStringTag, { value: "Module" }));
function toIntervalDayTimeInt32Array(n) {
  var t, g;
  const d = n.length, k = new Int32Array(d * 2);
  for (let H = 0, AA = 0; H < d; H++) {
    const gA = n[H];
    k[AA++] = (t = gA.days) !== null && t !== void 0 ? t : 0, k[AA++] = (g = gA.milliseconds) !== null && g !== void 0 ? g : 0;
  }
  return k;
}
function toIntervalMonthDayNanoInt32Array(n) {
  var t, g;
  const d = n.length, k = new Int32Array(d * 4);
  for (let H = 0, AA = 0; H < d; H++) {
    const gA = n[H];
    k[AA++] = (t = gA.months) !== null && t !== void 0 ? t : 0, k[AA++] = (g = gA.days) !== null && g !== void 0 ? g : 0;
    const IA = gA.nanoseconds;
    IA ? (k[AA++] = Number(BigInt(IA) & BigInt(4294967295)), k[AA++] = Number(BigInt(IA) >> BigInt(32))) : AA += 2;
  }
  return k;
}
function toIntervalDayTimeObjects(n) {
  const t = n.length, g = new Array(t / 2);
  for (let d = 0, k = 0; d < t; d += 2)
    g[k++] = {
      days: n[d],
      milliseconds: n[d + 1]
    };
  return g;
}
function toIntervalMonthDayNanoObjects(n, t) {
  const g = n.length, d = new Array(g / 4);
  for (let k = 0, H = 0; k < g; k += 4) {
    const AA = BigInt(n[k + 3]) << BigInt(32) | BigInt(n[k + 2] >>> 0);
    d[H++] = {
      months: n[k],
      days: n[k + 1],
      nanoseconds: t ? `${AA}` : AA
    };
  }
  return d;
}
const util_interval_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  toIntervalDayTimeInt32Array,
  toIntervalDayTimeObjects,
  toIntervalMonthDayNanoInt32Array,
  toIntervalMonthDayNanoObjects
}, Symbol.toStringTag, { value: "Module" }));
class VectorLoader extends Visitor {
  constructor(t, g, d, k, H = MetadataVersion.V5) {
    super(), this.nodesIndex = -1, this.buffersIndex = -1, this.bytes = t, this.nodes = g, this.buffers = d, this.dictionaries = k, this.metadataVersion = H;
  }
  visit(t) {
    return super.visit(t instanceof Field$2 ? t.type : t);
  }
  visitNull(t, { length: g } = this.nextFieldNode()) {
    return makeData({ type: t, length: g });
  }
  visitBool(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), data: this.readData(t) });
  }
  visitInt(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), data: this.readData(t) });
  }
  visitFloat(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), data: this.readData(t) });
  }
  visitUtf8(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), valueOffsets: this.readOffsets(t), data: this.readData(t) });
  }
  visitLargeUtf8(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), valueOffsets: this.readOffsets(t), data: this.readData(t) });
  }
  visitBinary(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), valueOffsets: this.readOffsets(t), data: this.readData(t) });
  }
  visitLargeBinary(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), valueOffsets: this.readOffsets(t), data: this.readData(t) });
  }
  visitFixedSizeBinary(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), data: this.readData(t) });
  }
  visitDate(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), data: this.readData(t) });
  }
  visitTimestamp(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), data: this.readData(t) });
  }
  visitTime(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), data: this.readData(t) });
  }
  visitDecimal(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), data: this.readData(t) });
  }
  visitList(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), valueOffsets: this.readOffsets(t), child: this.visit(t.children[0]) });
  }
  visitStruct(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), children: this.visitMany(t.children) });
  }
  visitUnion(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return this.metadataVersion < MetadataVersion.V5 && this.readNullBitmap(t, d), t.mode === UnionMode.Sparse ? this.visitSparseUnion(t, { length: g, nullCount: d }) : this.visitDenseUnion(t, { length: g, nullCount: d });
  }
  visitDenseUnion(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, typeIds: this.readTypeIds(t), valueOffsets: this.readOffsets(t), children: this.visitMany(t.children) });
  }
  visitSparseUnion(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, typeIds: this.readTypeIds(t), children: this.visitMany(t.children) });
  }
  visitDictionary(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), data: this.readData(t.indices), dictionary: this.readDictionary(t) });
  }
  visitInterval(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), data: this.readData(t) });
  }
  visitDuration(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), data: this.readData(t) });
  }
  visitFixedSizeList(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), child: this.visit(t.children[0]) });
  }
  visitMap(t, { length: g, nullCount: d } = this.nextFieldNode()) {
    return makeData({ type: t, length: g, nullCount: d, nullBitmap: this.readNullBitmap(t, d), valueOffsets: this.readOffsets(t), child: this.visit(t.children[0]) });
  }
  nextFieldNode() {
    return this.nodes[++this.nodesIndex];
  }
  nextBufferRange() {
    return this.buffers[++this.buffersIndex];
  }
  readNullBitmap(t, g, d = this.nextBufferRange()) {
    return g > 0 && this.readData(t, d) || new Uint8Array(0);
  }
  readOffsets(t, g) {
    return this.readData(t, g);
  }
  readTypeIds(t, g) {
    return this.readData(t, g);
  }
  readData(t, { length: g, offset: d } = this.nextBufferRange()) {
    return this.bytes.subarray(d, d + g);
  }
  readDictionary(t) {
    return this.dictionaries.get(t.id);
  }
}
class JSONVectorLoader extends VectorLoader {
  constructor(t, g, d, k, H) {
    super(new Uint8Array(0), g, d, k, H), this.sources = t;
  }
  readNullBitmap(t, g, { offset: d } = this.nextBufferRange()) {
    return g <= 0 ? new Uint8Array(0) : packBools(this.sources[d]);
  }
  readOffsets(t, { offset: g } = this.nextBufferRange()) {
    return toArrayBufferView(Uint8Array, toArrayBufferView(t.OffsetArrayType, this.sources[g]));
  }
  readTypeIds(t, { offset: g } = this.nextBufferRange()) {
    return toArrayBufferView(Uint8Array, toArrayBufferView(t.ArrayType, this.sources[g]));
  }
  readData(t, { offset: g } = this.nextBufferRange()) {
    const { sources: d } = this;
    if (DataType.isTimestamp(t))
      return toArrayBufferView(Uint8Array, Int64.convertArray(d[g]));
    if ((DataType.isInt(t) || DataType.isTime(t)) && t.bitWidth === 64 || DataType.isDuration(t))
      return toArrayBufferView(Uint8Array, Int64.convertArray(d[g]));
    if (DataType.isDate(t) && t.unit === DateUnit.MILLISECOND)
      return toArrayBufferView(Uint8Array, Int64.convertArray(d[g]));
    if (DataType.isDecimal(t))
      return toArrayBufferView(Uint8Array, Int128.convertArray(d[g]));
    if (DataType.isBinary(t) || DataType.isLargeBinary(t) || DataType.isFixedSizeBinary(t))
      return binaryDataFromJSON(d[g]);
    if (DataType.isBool(t))
      return packBools(d[g]);
    if (DataType.isUtf8(t) || DataType.isLargeUtf8(t))
      return encodeUtf8(d[g].join(""));
    if (DataType.isInterval(t))
      switch (t.unit) {
        case IntervalUnit.DAY_TIME:
          return toIntervalDayTimeInt32Array(d[g]);
        case IntervalUnit.MONTH_DAY_NANO:
          return toIntervalMonthDayNanoInt32Array(d[g]);
      }
    return toArrayBufferView(Uint8Array, toArrayBufferView(t.ArrayType, d[g].map((k) => +k)));
  }
}
function binaryDataFromJSON(n) {
  const t = n.join(""), g = new Uint8Array(t.length / 2);
  for (let d = 0; d < t.length; d += 2)
    g[d >> 1] = Number.parseInt(t.slice(d, d + 2), 16);
  return g;
}
class CompressedVectorLoader extends VectorLoader {
  constructor(t, g, d, k, H) {
    super(new Uint8Array(0), g, d, k, H), this.bodyChunks = t;
  }
  readData(t, g = this.nextBufferRange()) {
    return this.bodyChunks[this.buffersIndex];
  }
}
class TypeComparator extends Visitor {
  compareSchemas(t, g) {
    return t === g || g instanceof t.constructor && this.compareManyFields(t.fields, g.fields);
  }
  compareManyFields(t, g) {
    return t === g || Array.isArray(t) && Array.isArray(g) && t.length === g.length && t.every((d, k) => this.compareFields(d, g[k]));
  }
  compareFields(t, g) {
    return t === g || g instanceof t.constructor && t.name === g.name && t.nullable === g.nullable && this.visit(t.type, g.type);
  }
}
function compareConstructor(n, t) {
  return t instanceof n.constructor;
}
function compareAny(n, t) {
  return n === t || compareConstructor(n, t);
}
function compareInt(n, t) {
  return n === t || compareConstructor(n, t) && n.bitWidth === t.bitWidth && n.isSigned === t.isSigned;
}
function compareFloat(n, t) {
  return n === t || compareConstructor(n, t) && n.precision === t.precision;
}
function compareFixedSizeBinary(n, t) {
  return n === t || compareConstructor(n, t) && n.byteWidth === t.byteWidth;
}
function compareDate(n, t) {
  return n === t || compareConstructor(n, t) && n.unit === t.unit;
}
function compareTimestamp(n, t) {
  return n === t || compareConstructor(n, t) && n.unit === t.unit && n.timezone === t.timezone;
}
function compareTime(n, t) {
  return n === t || compareConstructor(n, t) && n.unit === t.unit && n.bitWidth === t.bitWidth;
}
function compareList(n, t) {
  return n === t || compareConstructor(n, t) && n.children.length === t.children.length && instance.compareManyFields(n.children, t.children);
}
function compareStruct(n, t) {
  return n === t || compareConstructor(n, t) && n.children.length === t.children.length && instance.compareManyFields(n.children, t.children);
}
function compareUnion(n, t) {
  return n === t || compareConstructor(n, t) && n.mode === t.mode && n.typeIds.every((g, d) => g === t.typeIds[d]) && instance.compareManyFields(n.children, t.children);
}
function compareDictionary(n, t) {
  return n === t || compareConstructor(n, t) && n.id === t.id && n.isOrdered === t.isOrdered && instance.visit(n.indices, t.indices) && instance.visit(n.dictionary, t.dictionary);
}
function compareInterval(n, t) {
  return n === t || compareConstructor(n, t) && n.unit === t.unit;
}
function compareDuration(n, t) {
  return n === t || compareConstructor(n, t) && n.unit === t.unit;
}
function compareFixedSizeList(n, t) {
  return n === t || compareConstructor(n, t) && n.listSize === t.listSize && n.children.length === t.children.length && instance.compareManyFields(n.children, t.children);
}
function compareMap(n, t) {
  return n === t || compareConstructor(n, t) && n.keysSorted === t.keysSorted && n.children.length === t.children.length && instance.compareManyFields(n.children, t.children);
}
TypeComparator.prototype.visitNull = compareAny;
TypeComparator.prototype.visitBool = compareAny;
TypeComparator.prototype.visitInt = compareInt;
TypeComparator.prototype.visitInt8 = compareInt;
TypeComparator.prototype.visitInt16 = compareInt;
TypeComparator.prototype.visitInt32 = compareInt;
TypeComparator.prototype.visitInt64 = compareInt;
TypeComparator.prototype.visitUint8 = compareInt;
TypeComparator.prototype.visitUint16 = compareInt;
TypeComparator.prototype.visitUint32 = compareInt;
TypeComparator.prototype.visitUint64 = compareInt;
TypeComparator.prototype.visitFloat = compareFloat;
TypeComparator.prototype.visitFloat16 = compareFloat;
TypeComparator.prototype.visitFloat32 = compareFloat;
TypeComparator.prototype.visitFloat64 = compareFloat;
TypeComparator.prototype.visitUtf8 = compareAny;
TypeComparator.prototype.visitLargeUtf8 = compareAny;
TypeComparator.prototype.visitBinary = compareAny;
TypeComparator.prototype.visitLargeBinary = compareAny;
TypeComparator.prototype.visitFixedSizeBinary = compareFixedSizeBinary;
TypeComparator.prototype.visitDate = compareDate;
TypeComparator.prototype.visitDateDay = compareDate;
TypeComparator.prototype.visitDateMillisecond = compareDate;
TypeComparator.prototype.visitTimestamp = compareTimestamp;
TypeComparator.prototype.visitTimestampSecond = compareTimestamp;
TypeComparator.prototype.visitTimestampMillisecond = compareTimestamp;
TypeComparator.prototype.visitTimestampMicrosecond = compareTimestamp;
TypeComparator.prototype.visitTimestampNanosecond = compareTimestamp;
TypeComparator.prototype.visitTime = compareTime;
TypeComparator.prototype.visitTimeSecond = compareTime;
TypeComparator.prototype.visitTimeMillisecond = compareTime;
TypeComparator.prototype.visitTimeMicrosecond = compareTime;
TypeComparator.prototype.visitTimeNanosecond = compareTime;
TypeComparator.prototype.visitDecimal = compareAny;
TypeComparator.prototype.visitList = compareList;
TypeComparator.prototype.visitStruct = compareStruct;
TypeComparator.prototype.visitUnion = compareUnion;
TypeComparator.prototype.visitDenseUnion = compareUnion;
TypeComparator.prototype.visitSparseUnion = compareUnion;
TypeComparator.prototype.visitDictionary = compareDictionary;
TypeComparator.prototype.visitInterval = compareInterval;
TypeComparator.prototype.visitIntervalDayTime = compareInterval;
TypeComparator.prototype.visitIntervalYearMonth = compareInterval;
TypeComparator.prototype.visitIntervalMonthDayNano = compareInterval;
TypeComparator.prototype.visitDuration = compareDuration;
TypeComparator.prototype.visitDurationSecond = compareDuration;
TypeComparator.prototype.visitDurationMillisecond = compareDuration;
TypeComparator.prototype.visitDurationMicrosecond = compareDuration;
TypeComparator.prototype.visitDurationNanosecond = compareDuration;
TypeComparator.prototype.visitFixedSizeList = compareFixedSizeList;
TypeComparator.prototype.visitMap = compareMap;
const instance = new TypeComparator();
function compareSchemas(n, t) {
  return instance.compareSchemas(n, t);
}
function compareFields(n, t) {
  return instance.compareFields(n, t);
}
function compareTypes(n, t) {
  return instance.visit(n, t);
}
function distributeVectorsIntoRecordBatches(n, t) {
  return uniformlyDistributeChunksAcrossRecordBatches(n, t.map((g) => g.data.concat()));
}
function uniformlyDistributeChunksAcrossRecordBatches(n, t) {
  const g = [...n.fields], d = [], k = { numBatches: t.reduce((eA, iA) => Math.max(eA, iA.length), 0) };
  let H = 0, AA = 0, gA = -1;
  const IA = t.length;
  let CA, BA = [];
  for (; k.numBatches-- > 0; ) {
    for (AA = Number.POSITIVE_INFINITY, gA = -1; ++gA < IA; )
      BA[gA] = CA = t[gA].shift(), AA = Math.min(AA, CA ? CA.length : AA);
    Number.isFinite(AA) && (BA = distributeChildren(g, AA, BA, t, k), AA > 0 && (d[H++] = makeData({
      type: new Struct(g),
      length: AA,
      nullCount: 0,
      children: BA.slice()
    })));
  }
  return [
    n = n.assign(g),
    d.map((eA) => new RecordBatch$1(n, eA))
  ];
}
function distributeChildren(n, t, g, d, k) {
  var H;
  const AA = (t + 63 & -64) >> 3;
  for (let gA = -1, IA = d.length; ++gA < IA; ) {
    const CA = g[gA], BA = CA?.length;
    if (BA >= t)
      BA === t ? g[gA] = CA : (g[gA] = CA.slice(0, t), k.numBatches = Math.max(k.numBatches, d[gA].unshift(CA.slice(t, BA - t))));
    else {
      const eA = n[gA];
      n[gA] = eA.clone({ nullable: !0 }), g[gA] = (H = CA?._changeLengthAndBackfillNullBitmap(t)) !== null && H !== void 0 ? H : makeData({
        type: eA.type,
        length: t,
        nullCount: t,
        nullBitmap: new Uint8Array(AA)
      });
    }
  }
  return g;
}
var _a$2;
let Table$1 = class rI {
  constructor(...t) {
    var g, d;
    if (t.length === 0)
      return this.batches = [], this.schema = new Schema$3([]), this._offsets = [0], this;
    let k, H;
    t[0] instanceof Schema$3 && (k = t.shift()), t.at(-1) instanceof Uint32Array && (H = t.pop());
    const AA = (IA) => {
      if (IA) {
        if (IA instanceof RecordBatch$1)
          return [IA];
        if (IA instanceof rI)
          return IA.batches;
        if (IA instanceof Data) {
          if (IA.type instanceof Struct)
            return [new RecordBatch$1(new Schema$3(IA.type.children), IA)];
        } else {
          if (Array.isArray(IA))
            return IA.flatMap((CA) => AA(CA));
          if (typeof IA[Symbol.iterator] == "function")
            return [...IA].flatMap((CA) => AA(CA));
          if (typeof IA == "object") {
            const CA = Object.keys(IA), BA = CA.map((QA) => new Vector([IA[QA]])), eA = k ?? new Schema$3(CA.map((QA, tA) => new Field$2(String(QA), BA[tA].type, BA[tA].nullable))), [, iA] = distributeVectorsIntoRecordBatches(eA, BA);
            return iA.length === 0 ? [new RecordBatch$1(IA)] : iA;
          }
        }
      }
      return [];
    }, gA = t.flatMap((IA) => AA(IA));
    if (k = (d = k ?? ((g = gA[0]) === null || g === void 0 ? void 0 : g.schema)) !== null && d !== void 0 ? d : new Schema$3([]), !(k instanceof Schema$3))
      throw new TypeError("Table constructor expects a [Schema, RecordBatch[]] pair.");
    for (const IA of gA) {
      if (!(IA instanceof RecordBatch$1))
        throw new TypeError("Table constructor expects a [Schema, RecordBatch[]] pair.");
      if (!compareSchemas(k, IA.schema))
        throw new TypeError("Table and inner RecordBatch schemas must be equivalent.");
    }
    this.schema = k, this.batches = gA, this._offsets = H ?? computeChunkOffsets(this.data);
  }
  /**
   * The contiguous {@link RecordBatch `RecordBatch`} chunks of the Table rows.
   */
  get data() {
    return this.batches.map(({ data: t }) => t);
  }
  /**
   * The number of columns in this Table.
   */
  get numCols() {
    return this.schema.fields.length;
  }
  /**
   * The number of rows in this Table.
   */
  get numRows() {
    return this.data.reduce((t, g) => t + g.length, 0);
  }
  /**
   * The number of null rows in this Table.
   */
  get nullCount() {
    return this._nullCount === -1 && (this._nullCount = computeChunkNullCounts(this.data)), this._nullCount;
  }
  /**
   * Check whether an element is null.
   *
   * @param index The index at which to read the validity bitmap.
   */
  // @ts-ignore
  isValid(t) {
    return !1;
  }
  /**
   * Get an element value by position.
   *
   * @param index The index of the element to read.
   */
  // @ts-ignore
  get(t) {
    return null;
  }
  /**
    * Get an element value by position.
    * @param index The index of the element to read. A negative index will count back from the last element.
    */
  // @ts-ignore
  at(t) {
    return this.get(wrapIndex(t, this.numRows));
  }
  /**
   * Set an element value by position.
   *
   * @param index The index of the element to write.
   * @param value The value to set.
   */
  // @ts-ignore
  set(t, g) {
  }
  /**
   * Retrieve the index of the first occurrence of a value in an Vector.
   *
   * @param element The value to locate in the Vector.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  // @ts-ignore
  indexOf(t, g) {
    return -1;
  }
  /**
   * Iterator for rows in this Table.
   */
  [Symbol.iterator]() {
    return this.batches.length > 0 ? instance$2.visit(new Vector(this.data)) : new Array(0)[Symbol.iterator]();
  }
  /**
   * Return a JavaScript Array of the Table rows.
   *
   * @returns An Array of Table rows.
   */
  toArray() {
    return [...this];
  }
  /**
   * Returns a string representation of the Table rows.
   *
   * @returns A string representation of the Table rows.
   */
  toString() {
    return `[
  ${this.toArray().join(`,
  `)}
]`;
  }
  /**
   * Combines two or more Tables of the same schema.
   *
   * @param others Additional Tables to add to the end of this Tables.
   */
  concat(...t) {
    const g = this.schema, d = this.data.concat(t.flatMap(({ data: k }) => k));
    return new rI(g, d.map((k) => new RecordBatch$1(g, k)));
  }
  /**
   * Return a zero-copy sub-section of this Table.
   *
   * @param begin The beginning of the specified portion of the Table.
   * @param end The end of the specified portion of the Table. This is exclusive of the element at the index 'end'.
   */
  slice(t, g) {
    const d = this.schema;
    [t, g] = clampRange$1({ length: this.numRows }, t, g);
    const k = sliceChunks$1(this.data, this._offsets, t, g);
    return new rI(d, k.map((H) => new RecordBatch$1(d, H)));
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   *
   * @param name The name of the child to retrieve.
   */
  getChild(t) {
    return this.getChildAt(this.schema.fields.findIndex((g) => g.name === t));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   *
   * @param index The index of the child to retrieve.
   */
  getChildAt(t) {
    if (t > -1 && t < this.schema.fields.length) {
      const g = this.data.map((d) => d.children[t]);
      if (g.length === 0) {
        const { type: d } = this.schema.fields[t], k = makeData({ type: d, length: 0, nullCount: 0 });
        g.push(k._changeLengthAndBackfillNullBitmap(this.numRows));
      }
      return new Vector(g);
    }
    return null;
  }
  /**
   * Sets a child Vector by name.
   *
   * @param name The name of the child to overwrite.
   * @returns A new Table with the supplied child for the specified name.
   */
  setChild(t, g) {
    var d;
    return this.setChildAt((d = this.schema.fields) === null || d === void 0 ? void 0 : d.findIndex((k) => k.name === t), g);
  }
  setChildAt(t, g) {
    let d = this.schema, k = [...this.batches];
    if (t > -1 && t < this.numCols) {
      g || (g = new Vector([makeData({ type: new Null(), length: this.numRows })]));
      const H = d.fields.slice(), AA = H[t].clone({ type: g.type }), gA = this.schema.fields.map((IA, CA) => this.getChildAt(CA));
      [H[t], gA[t]] = [AA, g], [d, k] = distributeVectorsIntoRecordBatches(d, gA);
    }
    return new rI(d, k);
  }
  /**
   * Construct a new Table containing only specified columns.
   *
   * @param columnNames Names of columns to keep.
   * @returns A new Table of columns matching the specified names.
   */
  select(t) {
    const g = this.schema.fields.reduce((d, k, H) => d.set(k.name, H), /* @__PURE__ */ new Map());
    return this.selectAt(t.map((d) => g.get(d)).filter((d) => d > -1));
  }
  /**
   * Construct a new Table containing only columns at the specified indices.
   *
   * @param columnIndices Indices of columns to keep.
   * @returns A new Table of columns at the specified indices.
   */
  selectAt(t) {
    const g = this.schema.selectAt(t), d = this.batches.map((k) => k.selectAt(t));
    return new rI(g, d);
  }
  assign(t) {
    const g = this.schema.fields, [d, k] = t.schema.fields.reduce((gA, IA, CA) => {
      const [BA, eA] = gA, iA = g.findIndex((QA) => QA.name === IA.name);
      return ~iA ? eA[iA] = CA : BA.push(CA), gA;
    }, [[], []]), H = this.schema.assign(t.schema), AA = [
      ...g.map((gA, IA) => [IA, k[IA]]).map(([gA, IA]) => IA === void 0 ? this.getChildAt(gA) : t.getChildAt(IA)),
      ...d.map((gA) => t.getChildAt(gA))
    ].filter(Boolean);
    return new rI(...distributeVectorsIntoRecordBatches(H, AA));
  }
};
_a$2 = Symbol.toStringTag;
Table$1[_a$2] = ((n) => (n.schema = null, n.batches = [], n._offsets = new Uint32Array([0]), n._nullCount = -1, n[Symbol.isConcatSpreadable] = !0, n.isValid = wrapChunkedCall1(isChunkedValid), n.get = wrapChunkedCall1(instance$4.getVisitFn(Type$1.Struct)), n.set = wrapChunkedCall2(instance$5.getVisitFn(Type$1.Struct)), n.indexOf = wrapChunkedIndexOf(instance$3.getVisitFn(Type$1.Struct)), "Table"))(Table$1.prototype);
var _a$1;
let RecordBatch$1 = class mI {
  constructor(...t) {
    switch (t.length) {
      case 2: {
        if ([this.schema] = t, !(this.schema instanceof Schema$3))
          throw new TypeError("RecordBatch constructor expects a [Schema, Data] pair.");
        if ([
          ,
          this.data = makeData({
            nullCount: 0,
            type: new Struct(this.schema.fields),
            children: this.schema.fields.map((g) => makeData({ type: g.type, nullCount: 0 }))
          })
        ] = t, !(this.data instanceof Data))
          throw new TypeError("RecordBatch constructor expects a [Schema, Data] pair.");
        [this.schema, this.data] = ensureSameLengthData(this.schema, this.data.children);
        break;
      }
      case 1: {
        const [g] = t, { fields: d, children: k, length: H } = Object.keys(g).reduce((IA, CA, BA) => (IA.children[BA] = g[CA], IA.length = Math.max(IA.length, g[CA].length), IA.fields[BA] = Field$2.new({ name: CA, type: g[CA].type, nullable: !0 }), IA), {
          length: 0,
          fields: new Array(),
          children: new Array()
        }), AA = new Schema$3(d), gA = makeData({ type: new Struct(d), length: H, children: k, nullCount: 0 });
        [this.schema, this.data] = ensureSameLengthData(AA, gA.children, H);
        break;
      }
      default:
        throw new TypeError("RecordBatch constructor expects an Object mapping names to child Data, or a [Schema, Data] pair.");
    }
  }
  get dictionaries() {
    return this._dictionaries || (this._dictionaries = collectDictionaries(this.schema.fields, this.data.children));
  }
  /**
   * The number of columns in this RecordBatch.
   */
  get numCols() {
    return this.schema.fields.length;
  }
  /**
   * The number of rows in this RecordBatch.
   */
  get numRows() {
    return this.data.length;
  }
  /**
   * The number of null rows in this RecordBatch.
   */
  get nullCount() {
    return this.data.nullCount;
  }
  /**
   * Check whether an row is null.
   * @param index The index at which to read the validity bitmap.
   */
  isValid(t) {
    return this.data.getValid(t);
  }
  /**
   * Get a row by position.
   * @param index The index of the row to read.
   */
  get(t) {
    return instance$4.visit(this.data, t);
  }
  /**
    * Get a row value by position.
    * @param index The index of the row to read. A negative index will count back from the last row.
    */
  at(t) {
    return this.get(wrapIndex(t, this.numRows));
  }
  /**
   * Set a row by position.
   * @param index The index of the row to write.
   * @param value The value to set.
   */
  set(t, g) {
    return instance$5.visit(this.data, t, g);
  }
  /**
   * Retrieve the index of the first occurrence of a row in an RecordBatch.
   * @param element The row to locate in the RecordBatch.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  indexOf(t, g) {
    return instance$3.visit(this.data, t, g);
  }
  /**
   * Iterator for rows in this RecordBatch.
   */
  [Symbol.iterator]() {
    return instance$2.visit(new Vector([this.data]));
  }
  /**
   * Return a JavaScript Array of the RecordBatch rows.
   * @returns An Array of RecordBatch rows.
   */
  toArray() {
    return [...this];
  }
  /**
   * Combines two or more RecordBatch of the same schema.
   * @param others Additional RecordBatch to add to the end of this RecordBatch.
   */
  concat(...t) {
    return new Table$1(this.schema, [this, ...t]);
  }
  /**
   * Return a zero-copy sub-section of this RecordBatch.
   * @param start The beginning of the specified portion of the RecordBatch.
   * @param end The end of the specified portion of the RecordBatch. This is exclusive of the row at the index 'end'.
   */
  slice(t, g) {
    const [d] = new Vector([this.data]).slice(t, g).data;
    return new mI(this.schema, d);
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   * @param name The name of the child to retrieve.
   */
  getChild(t) {
    var g;
    return this.getChildAt((g = this.schema.fields) === null || g === void 0 ? void 0 : g.findIndex((d) => d.name === t));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   * @param index The index of the child to retrieve.
   */
  getChildAt(t) {
    return t > -1 && t < this.schema.fields.length ? new Vector([this.data.children[t]]) : null;
  }
  /**
   * Sets a child Vector by name.
   * @param name The name of the child to overwrite.
   * @returns A new RecordBatch with the new child for the specified name.
   */
  setChild(t, g) {
    var d;
    return this.setChildAt((d = this.schema.fields) === null || d === void 0 ? void 0 : d.findIndex((k) => k.name === t), g);
  }
  setChildAt(t, g) {
    let d = this.schema, k = this.data;
    if (t > -1 && t < this.numCols) {
      g || (g = new Vector([makeData({ type: new Null(), length: this.numRows })]));
      const H = d.fields.slice(), AA = k.children.slice(), gA = H[t].clone({ type: g.type });
      [H[t], AA[t]] = [gA, g.data[0]], d = new Schema$3(H, new Map(this.schema.metadata)), k = makeData({ type: new Struct(H), children: AA });
    }
    return new mI(d, k);
  }
  /**
   * Construct a new RecordBatch containing only specified columns.
   *
   * @param columnNames Names of columns to keep.
   * @returns A new RecordBatch of columns matching the specified names.
   */
  select(t) {
    const g = this.schema.select(t), d = new Struct(g.fields), k = [];
    for (const H of t) {
      const AA = this.schema.fields.findIndex((gA) => gA.name === H);
      ~AA && (k[AA] = this.data.children[AA]);
    }
    return new mI(g, makeData({ type: d, length: this.numRows, children: k }));
  }
  /**
   * Construct a new RecordBatch containing only columns at the specified indices.
   *
   * @param columnIndices Indices of columns to keep.
   * @returns A new RecordBatch of columns matching at the specified indices.
   */
  selectAt(t) {
    const g = this.schema.selectAt(t), d = t.map((H) => this.data.children[H]).filter(Boolean), k = makeData({ type: new Struct(g.fields), length: this.numRows, children: d });
    return new mI(g, k);
  }
};
_a$1 = Symbol.toStringTag;
RecordBatch$1[_a$1] = ((n) => (n._nullCount = -1, n[Symbol.isConcatSpreadable] = !0, "RecordBatch"))(RecordBatch$1.prototype);
function ensureSameLengthData(n, t, g = t.reduce((d, k) => Math.max(d, k.length), 0)) {
  var d;
  const k = [...n.fields], H = [...t], AA = (g + 63 & -64) >> 3;
  for (const [gA, IA] of n.fields.entries()) {
    const CA = t[gA];
    (!CA || CA.length !== g) && (k[gA] = IA.clone({ nullable: !0 }), H[gA] = (d = CA?._changeLengthAndBackfillNullBitmap(g)) !== null && d !== void 0 ? d : makeData({
      type: IA.type,
      length: g,
      nullCount: g,
      nullBitmap: new Uint8Array(AA)
    }));
  }
  return [
    n.assign(k),
    makeData({ type: new Struct(k), length: g, children: H })
  ];
}
function collectDictionaries(n, t, g = /* @__PURE__ */ new Map()) {
  var d, k;
  if (((d = n?.length) !== null && d !== void 0 ? d : 0) > 0 && n?.length === t?.length)
    for (let H = -1, AA = n.length; ++H < AA; ) {
      const { type: gA } = n[H], IA = t[H];
      for (const CA of [IA, ...((k = IA?.dictionary) === null || k === void 0 ? void 0 : k.data) || []])
        collectDictionaries(gA.children, CA?.children, g);
      if (DataType.isDictionary(gA)) {
        const { id: CA } = gA;
        if (!g.has(CA))
          IA?.dictionary && g.set(CA, IA.dictionary);
        else if (g.get(CA) !== IA.dictionary)
          throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
      }
    }
  return g;
}
class _InternalEmptyPlaceholderRecordBatch extends RecordBatch$1 {
  constructor(t) {
    const g = t.fields.map((k) => makeData({ type: k.type })), d = makeData({ type: new Struct(t.fields), nullCount: 0, children: g });
    super(t, d);
  }
}
const invalidMessageType = (n) => `Expected ${MessageHeader[n]} Message in stream, but was null or length 0.`, nullMessage = (n) => `Header pointer of flatbuffer-encoded ${MessageHeader[n]} Message is null or length 0.`, invalidMessageMetadata = (n, t) => `Expected to read ${n} metadata bytes, but only read ${t}.`, invalidMessageBodyLength = (n, t) => `Expected to read ${n} bytes for message body, but only read ${t}.`;
class MessageReader {
  constructor(t) {
    this.source = t instanceof ByteStream ? t : new ByteStream(t);
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    let t;
    return (t = this.readMetadataLength()).done || t.value === -1 && (t = this.readMetadataLength()).done || (t = this.readMetadata(t.value)).done ? ITERATOR_DONE : t;
  }
  throw(t) {
    return this.source.throw(t);
  }
  return(t) {
    return this.source.return(t);
  }
  readMessage(t) {
    let g;
    if ((g = this.next()).done)
      return null;
    if (t != null && g.value.headerType !== t)
      throw new Error(invalidMessageType(t));
    return g.value;
  }
  readMessageBody(t) {
    if (t <= 0)
      return new Uint8Array(0);
    const g = toUint8Array(this.source.read(t));
    if (g.byteLength < t)
      throw new Error(invalidMessageBodyLength(t, g.byteLength));
    return (
      /* 1. */
      g.byteOffset % 8 === 0 && /* 2. */
      g.byteOffset + g.byteLength <= g.buffer.byteLength ? g : g.slice()
    );
  }
  readSchema(t = !1) {
    const g = MessageHeader.Schema, d = this.readMessage(g), k = d?.header();
    if (t && !k)
      throw new Error(nullMessage(g));
    return k;
  }
  readMetadataLength() {
    const t = this.source.read(PADDING), g = t && new ByteBuffer$2(t), d = g?.readInt32(0) || 0;
    return { done: d === 0, value: d };
  }
  readMetadata(t) {
    const g = this.source.read(t);
    if (!g)
      return ITERATOR_DONE;
    if (g.byteLength < t)
      throw new Error(invalidMessageMetadata(t, g.byteLength));
    return { done: !1, value: Message.decode(g) };
  }
}
class AsyncMessageReader {
  constructor(t, g) {
    this.source = t instanceof AsyncByteStream ? t : isFileHandle(t) ? new AsyncRandomAccessFile(t, g) : new AsyncByteStream(t);
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next() {
    return __awaiter(this, void 0, void 0, function* () {
      let t;
      return (t = yield this.readMetadataLength()).done || t.value === -1 && (t = yield this.readMetadataLength()).done || (t = yield this.readMetadata(t.value)).done ? ITERATOR_DONE : t;
    });
  }
  throw(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.source.throw(t);
    });
  }
  return(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.source.return(t);
    });
  }
  readMessage(t) {
    return __awaiter(this, void 0, void 0, function* () {
      let g;
      if ((g = yield this.next()).done)
        return null;
      if (t != null && g.value.headerType !== t)
        throw new Error(invalidMessageType(t));
      return g.value;
    });
  }
  readMessageBody(t) {
    return __awaiter(this, void 0, void 0, function* () {
      if (t <= 0)
        return new Uint8Array(0);
      const g = toUint8Array(yield this.source.read(t));
      if (g.byteLength < t)
        throw new Error(invalidMessageBodyLength(t, g.byteLength));
      return (
        /* 1. */
        g.byteOffset % 8 === 0 && /* 2. */
        g.byteOffset + g.byteLength <= g.buffer.byteLength ? g : g.slice()
      );
    });
  }
  readSchema() {
    return __awaiter(this, arguments, void 0, function* (t = !1) {
      const g = MessageHeader.Schema, d = yield this.readMessage(g), k = d?.header();
      if (t && !k)
        throw new Error(nullMessage(g));
      return k;
    });
  }
  readMetadataLength() {
    return __awaiter(this, void 0, void 0, function* () {
      const t = yield this.source.read(PADDING), g = t && new ByteBuffer$2(t), d = g?.readInt32(0) || 0;
      return { done: d === 0, value: d };
    });
  }
  readMetadata(t) {
    return __awaiter(this, void 0, void 0, function* () {
      const g = yield this.source.read(t);
      if (!g)
        return ITERATOR_DONE;
      if (g.byteLength < t)
        throw new Error(invalidMessageMetadata(t, g.byteLength));
      return { done: !1, value: Message.decode(g) };
    });
  }
}
class JSONMessageReader extends MessageReader {
  constructor(t) {
    super(new Uint8Array(0)), this._schema = !1, this._body = [], this._batchIndex = 0, this._dictionaryIndex = 0, this._json = t instanceof ArrowJSON ? t : new ArrowJSON(t);
  }
  next() {
    const { _json: t } = this;
    if (!this._schema)
      return this._schema = !0, { done: !1, value: Message.fromJSON(t.schema, MessageHeader.Schema) };
    if (this._dictionaryIndex < t.dictionaries.length) {
      const g = t.dictionaries[this._dictionaryIndex++];
      return this._body = g.data.columns, { done: !1, value: Message.fromJSON(g, MessageHeader.DictionaryBatch) };
    }
    if (this._batchIndex < t.batches.length) {
      const g = t.batches[this._batchIndex++];
      return this._body = g.columns, { done: !1, value: Message.fromJSON(g, MessageHeader.RecordBatch) };
    }
    return this._body = [], ITERATOR_DONE;
  }
  readMessageBody(t) {
    return g(this._body);
    function g(d) {
      return (d || []).reduce((k, H) => [
        ...k,
        ...H.VALIDITY && [H.VALIDITY] || [],
        ...H.TYPE_ID && [H.TYPE_ID] || [],
        ...H.OFFSET && [H.OFFSET] || [],
        ...H.DATA && [H.DATA] || [],
        ...g(H.children)
      ], []);
    }
  }
  readMessage(t) {
    let g;
    if ((g = this.next()).done)
      return null;
    if (t != null && g.value.headerType !== t)
      throw new Error(invalidMessageType(t));
    return g.value;
  }
  readSchema() {
    const t = MessageHeader.Schema, g = this.readMessage(t), d = g?.header();
    if (!g || !d)
      throw new Error(nullMessage(t));
    return d;
  }
}
const PADDING = 4, MAGIC_STR = "ARROW1", MAGIC = new Uint8Array(MAGIC_STR.length);
for (let n = 0; n < MAGIC_STR.length; n += 1)
  MAGIC[n] = MAGIC_STR.codePointAt(n);
function checkForMagicArrowString(n, t = 0) {
  for (let g = -1, d = MAGIC.length; ++g < d; )
    if (MAGIC[g] !== n[t + g])
      return !1;
  return !0;
}
const magicLength = MAGIC.length, magicAndPadding = magicLength + PADDING, magicX2AndPadding = magicLength * 2 + PADDING;
class Lz4FrameValidator {
  constructor() {
    this.LZ4_FRAME_MAGIC = new Uint8Array([4, 34, 77, 24]), this.MIN_HEADER_LENGTH = 7;
  }
  isValidCodecEncode(t) {
    const g = new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8]), d = t.encode(g);
    return this._isValidCompressed(d);
  }
  _isValidCompressed(t) {
    return this._hasMinimumLength(t) && this._hasValidMagicNumber(t) && this._hasValidVersion(t);
  }
  _hasMinimumLength(t) {
    return t.length >= this.MIN_HEADER_LENGTH;
  }
  _hasValidMagicNumber(t) {
    return this.LZ4_FRAME_MAGIC.every((g, d) => t[d] === g);
  }
  _hasValidVersion(t) {
    return (t[4] & 192) >> 6 === 1;
  }
}
class ZstdValidator {
  constructor() {
    this.ZSTD_MAGIC = new Uint8Array([40, 181, 47, 253]), this.MIN_HEADER_LENGTH = 6;
  }
  isValidCodecEncode(t) {
    const g = new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8]), d = t.encode(g);
    return this._isValidCompressed(d);
  }
  _isValidCompressed(t) {
    return this._hasMinimumLength(t) && this._hasValidMagicNumber(t);
  }
  _hasMinimumLength(t) {
    return t.length >= this.MIN_HEADER_LENGTH;
  }
  _hasValidMagicNumber(t) {
    return this.ZSTD_MAGIC.every((g, d) => t[d] === g);
  }
}
const compressionValidators = {
  [CompressionType.LZ4_FRAME]: new Lz4FrameValidator(),
  [CompressionType.ZSTD]: new ZstdValidator()
};
class _CompressionRegistry {
  constructor() {
    this.registry = {};
  }
  set(t, g) {
    if (g?.encode && typeof g.encode == "function" && !compressionValidators[t].isValidCodecEncode(g))
      throw new Error(`Encoder for ${CompressionType[t]} is not valid.`);
    this.registry[t] = g;
  }
  get(t) {
    var g;
    return ((g = this.registry) === null || g === void 0 ? void 0 : g[t]) || null;
  }
}
const compressionRegistry = new _CompressionRegistry(), LENGTH_NO_COMPRESSED_DATA = -1, COMPRESS_LENGTH_PREFIX = 8;
class RecordBatchReader extends ReadableInterop {
  constructor(t) {
    super(), this._impl = t;
  }
  get closed() {
    return this._impl.closed;
  }
  get schema() {
    return this._impl.schema;
  }
  get autoDestroy() {
    return this._impl.autoDestroy;
  }
  get dictionaries() {
    return this._impl.dictionaries;
  }
  get numDictionaries() {
    return this._impl.numDictionaries;
  }
  get numRecordBatches() {
    return this._impl.numRecordBatches;
  }
  get footer() {
    return this._impl.isFile() ? this._impl.footer : null;
  }
  isSync() {
    return this._impl.isSync();
  }
  isAsync() {
    return this._impl.isAsync();
  }
  isFile() {
    return this._impl.isFile();
  }
  isStream() {
    return this._impl.isStream();
  }
  next() {
    return this._impl.next();
  }
  throw(t) {
    return this._impl.throw(t);
  }
  return(t) {
    return this._impl.return(t);
  }
  cancel() {
    return this._impl.cancel();
  }
  reset(t) {
    return this._impl.reset(t), this._DOMStream = void 0, this._nodeStream = void 0, this;
  }
  open(t) {
    const g = this._impl.open(t);
    return isPromise(g) ? g.then(() => this) : this;
  }
  readRecordBatch(t) {
    return this._impl.isFile() ? this._impl.readRecordBatch(t) : null;
  }
  [Symbol.iterator]() {
    return this._impl[Symbol.iterator]();
  }
  [Symbol.asyncIterator]() {
    return this._impl[Symbol.asyncIterator]();
  }
  toDOMStream() {
    return streamAdapters.toDOMStream(this.isSync() ? { [Symbol.iterator]: () => this } : { [Symbol.asyncIterator]: () => this });
  }
  toNodeStream() {
    return streamAdapters.toNodeStream(this.isSync() ? { [Symbol.iterator]: () => this } : { [Symbol.asyncIterator]: () => this }, { objectMode: !0 });
  }
  /** @nocollapse */
  // @ts-ignore
  static throughNode(t) {
    throw new Error('"throughNode" not available in this environment');
  }
  /** @nocollapse */
  static throughDOM(t, g) {
    throw new Error('"throughDOM" not available in this environment');
  }
  /** @nocollapse */
  static from(t) {
    return t instanceof RecordBatchReader ? t : isArrowJSON(t) ? fromArrowJSON(t) : isFileHandle(t) ? fromFileHandle(t) : isPromise(t) ? __awaiter(this, void 0, void 0, function* () {
      return yield RecordBatchReader.from(yield t);
    }) : isFetchResponse(t) || isReadableDOMStream(t) || isReadableNodeStream(t) || isAsyncIterable$1(t) ? fromAsyncByteStream(new AsyncByteStream(t)) : fromByteStream(new ByteStream(t));
  }
  /** @nocollapse */
  static readAll(t) {
    return t instanceof RecordBatchReader ? t.isSync() ? readAllSync(t) : readAllAsync(t) : isArrowJSON(t) || ArrayBuffer.isView(t) || isIterable$2(t) || isIteratorResult(t) ? readAllSync(t) : readAllAsync(t);
  }
}
class RecordBatchStreamReader extends RecordBatchReader {
  constructor(t) {
    super(t), this._impl = t;
  }
  readAll() {
    return [...this];
  }
  [Symbol.iterator]() {
    return this._impl[Symbol.iterator]();
  }
  [Symbol.asyncIterator]() {
    return __asyncGenerator(this, arguments, function* () {
      yield __await(yield* __asyncDelegator(__asyncValues(this[Symbol.iterator]())));
    });
  }
}
class AsyncRecordBatchStreamReader extends RecordBatchReader {
  constructor(t) {
    super(t), this._impl = t;
  }
  readAll() {
    return __awaiter(this, void 0, void 0, function* () {
      var t, g, d, k;
      const H = new Array();
      try {
        for (var AA = !0, gA = __asyncValues(this), IA; IA = yield gA.next(), t = IA.done, !t; AA = !0) {
          k = IA.value, AA = !1;
          const CA = k;
          H.push(CA);
        }
      } catch (CA) {
        g = { error: CA };
      } finally {
        try {
          !AA && !t && (d = gA.return) && (yield d.call(gA));
        } finally {
          if (g) throw g.error;
        }
      }
      return H;
    });
  }
  [Symbol.iterator]() {
    throw new Error("AsyncRecordBatchStreamReader is not Iterable");
  }
  [Symbol.asyncIterator]() {
    return this._impl[Symbol.asyncIterator]();
  }
}
class RecordBatchFileReader extends RecordBatchStreamReader {
  constructor(t) {
    super(t), this._impl = t;
  }
}
class AsyncRecordBatchFileReader extends AsyncRecordBatchStreamReader {
  constructor(t) {
    super(t), this._impl = t;
  }
}
class RecordBatchReaderImpl {
  get numDictionaries() {
    return this._dictionaryIndex;
  }
  get numRecordBatches() {
    return this._recordBatchIndex;
  }
  constructor(t = /* @__PURE__ */ new Map()) {
    this.closed = !1, this.autoDestroy = !0, this._dictionaryIndex = 0, this._recordBatchIndex = 0, this.dictionaries = t;
  }
  isSync() {
    return !1;
  }
  isAsync() {
    return !1;
  }
  isFile() {
    return !1;
  }
  isStream() {
    return !1;
  }
  reset(t) {
    return this._dictionaryIndex = 0, this._recordBatchIndex = 0, this.schema = t, this.dictionaries = /* @__PURE__ */ new Map(), this;
  }
  _loadRecordBatch(t, g) {
    let d;
    if (t.compression != null) {
      const H = compressionRegistry.get(t.compression.type);
      if (H?.decode && typeof H.decode == "function") {
        const { decommpressedBody: AA, buffers: gA } = this._decompressBuffers(t, g, H);
        d = this._loadCompressedVectors(t, AA, this.schema.fields), t = new RecordBatch$2(t.length, t.nodes, gA, null);
      } else
        throw new Error("Record batch is compressed but codec not found");
    } else
      d = this._loadVectors(t, g, this.schema.fields);
    const k = makeData({ type: new Struct(this.schema.fields), length: t.length, children: d });
    return new RecordBatch$1(this.schema, k);
  }
  _loadDictionaryBatch(t, g) {
    const { id: d, isDelta: k } = t, { dictionaries: H, schema: AA } = this, gA = H.get(d), IA = AA.dictionaries.get(d);
    let CA;
    if (t.data.compression != null) {
      const BA = compressionRegistry.get(t.data.compression.type);
      if (BA?.decode && typeof BA.decode == "function") {
        const { decommpressedBody: eA, buffers: iA } = this._decompressBuffers(t.data, g, BA);
        CA = this._loadCompressedVectors(t.data, eA, [IA]), t = new DictionaryBatch(new RecordBatch$2(t.data.length, t.data.nodes, iA, null), d, k);
      } else
        throw new Error("Dictionary batch is compressed but codec not found");
    } else
      CA = this._loadVectors(t.data, g, [IA]);
    return (gA && k ? gA.concat(new Vector(CA)) : new Vector(CA)).memoize();
  }
  _loadVectors(t, g, d) {
    return new VectorLoader(g, t.nodes, t.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(d);
  }
  _loadCompressedVectors(t, g, d) {
    return new CompressedVectorLoader(g, t.nodes, t.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(d);
  }
  _decompressBuffers(t, g, d) {
    const k = [], H = [];
    let AA = 0;
    for (const { offset: gA, length: IA } of t.buffers) {
      if (IA === 0) {
        k.push(new Uint8Array(0)), H.push(new BufferRegion(AA, 0));
        continue;
      }
      const CA = new ByteBuffer$2(g.subarray(gA, gA + IA)), BA = bigIntToNumber(CA.readInt64(0)), eA = CA.bytes().subarray(COMPRESS_LENGTH_PREFIX), iA = BA === LENGTH_NO_COMPRESSED_DATA ? eA : d.decode(eA);
      k.push(iA);
      const QA = (AA + 7 & -8) - AA;
      AA += QA, H.push(new BufferRegion(AA, iA.length)), AA += iA.length;
    }
    return {
      decommpressedBody: k,
      buffers: H
    };
  }
}
class RecordBatchStreamReaderImpl extends RecordBatchReaderImpl {
  constructor(t, g) {
    super(g), this._reader = isArrowJSON(t) ? new JSONMessageReader(this._handle = t) : new MessageReader(this._handle = t);
  }
  isSync() {
    return !0;
  }
  isStream() {
    return !0;
  }
  [Symbol.iterator]() {
    return this;
  }
  cancel() {
    !this.closed && (this.closed = !0) && (this.reset()._reader.return(), this._reader = null, this.dictionaries = null);
  }
  open(t) {
    return this.closed || (this.autoDestroy = shouldAutoDestroy(this, t), this.schema || (this.schema = this._reader.readSchema()) || this.cancel()), this;
  }
  throw(t) {
    return !this.closed && this.autoDestroy && (this.closed = !0) ? this.reset()._reader.throw(t) : ITERATOR_DONE;
  }
  return(t) {
    return !this.closed && this.autoDestroy && (this.closed = !0) ? this.reset()._reader.return(t) : ITERATOR_DONE;
  }
  next() {
    if (this.closed)
      return ITERATOR_DONE;
    let t;
    const { _reader: g } = this;
    for (; t = this._readNextMessageAndValidate(); )
      if (t.isSchema())
        this.reset(t.header());
      else if (t.isRecordBatch()) {
        this._recordBatchIndex++;
        const d = t.header(), k = g.readMessageBody(t.bodyLength);
        return { done: !1, value: this._loadRecordBatch(d, k) };
      } else if (t.isDictionaryBatch()) {
        this._dictionaryIndex++;
        const d = t.header(), k = g.readMessageBody(t.bodyLength), H = this._loadDictionaryBatch(d, k);
        this.dictionaries.set(d.id, H);
      }
    return this.schema && this._recordBatchIndex === 0 ? (this._recordBatchIndex++, { done: !1, value: new _InternalEmptyPlaceholderRecordBatch(this.schema) }) : this.return();
  }
  _readNextMessageAndValidate(t) {
    return this._reader.readMessage(t);
  }
}
class AsyncRecordBatchStreamReaderImpl extends RecordBatchReaderImpl {
  constructor(t, g) {
    super(g), this._reader = new AsyncMessageReader(this._handle = t);
  }
  isAsync() {
    return !0;
  }
  isStream() {
    return !0;
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  cancel() {
    return __awaiter(this, void 0, void 0, function* () {
      !this.closed && (this.closed = !0) && (yield this.reset()._reader.return(), this._reader = null, this.dictionaries = null);
    });
  }
  open(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.closed || (this.autoDestroy = shouldAutoDestroy(this, t), this.schema || (this.schema = yield this._reader.readSchema()) || (yield this.cancel())), this;
    });
  }
  throw(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return !this.closed && this.autoDestroy && (this.closed = !0) ? yield this.reset()._reader.throw(t) : ITERATOR_DONE;
    });
  }
  return(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return !this.closed && this.autoDestroy && (this.closed = !0) ? yield this.reset()._reader.return(t) : ITERATOR_DONE;
    });
  }
  next() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.closed)
        return ITERATOR_DONE;
      let t;
      const { _reader: g } = this;
      for (; t = yield this._readNextMessageAndValidate(); )
        if (t.isSchema())
          yield this.reset(t.header());
        else if (t.isRecordBatch()) {
          this._recordBatchIndex++;
          const d = t.header(), k = yield g.readMessageBody(t.bodyLength);
          return { done: !1, value: this._loadRecordBatch(d, k) };
        } else if (t.isDictionaryBatch()) {
          this._dictionaryIndex++;
          const d = t.header(), k = yield g.readMessageBody(t.bodyLength), H = this._loadDictionaryBatch(d, k);
          this.dictionaries.set(d.id, H);
        }
      return this.schema && this._recordBatchIndex === 0 ? (this._recordBatchIndex++, { done: !1, value: new _InternalEmptyPlaceholderRecordBatch(this.schema) }) : yield this.return();
    });
  }
  _readNextMessageAndValidate(t) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this._reader.readMessage(t);
    });
  }
}
class RecordBatchFileReaderImpl extends RecordBatchStreamReaderImpl {
  get footer() {
    return this._footer;
  }
  get numDictionaries() {
    return this._footer ? this._footer.numDictionaries : 0;
  }
  get numRecordBatches() {
    return this._footer ? this._footer.numRecordBatches : 0;
  }
  constructor(t, g) {
    super(t instanceof RandomAccessFile ? t : new RandomAccessFile(t), g);
  }
  isSync() {
    return !0;
  }
  isFile() {
    return !0;
  }
  open(t) {
    if (!this.closed && !this._footer) {
      this.schema = (this._footer = this._readFooter()).schema;
      for (const g of this._footer.dictionaryBatches())
        g && this._readDictionaryBatch(this._dictionaryIndex++);
    }
    return super.open(t);
  }
  readRecordBatch(t) {
    var g;
    if (this.closed)
      return null;
    this._footer || this.open();
    const d = (g = this._footer) === null || g === void 0 ? void 0 : g.getRecordBatch(t);
    if (d && this._handle.seek(d.offset)) {
      const k = this._reader.readMessage(MessageHeader.RecordBatch);
      if (k?.isRecordBatch()) {
        const H = k.header(), AA = this._reader.readMessageBody(k.bodyLength);
        return this._loadRecordBatch(H, AA);
      }
    }
    return null;
  }
  _readDictionaryBatch(t) {
    var g;
    const d = (g = this._footer) === null || g === void 0 ? void 0 : g.getDictionaryBatch(t);
    if (d && this._handle.seek(d.offset)) {
      const k = this._reader.readMessage(MessageHeader.DictionaryBatch);
      if (k?.isDictionaryBatch()) {
        const H = k.header(), AA = this._reader.readMessageBody(k.bodyLength), gA = this._loadDictionaryBatch(H, AA);
        this.dictionaries.set(H.id, gA);
      }
    }
  }
  _readFooter() {
    const { _handle: t } = this, g = t.size - magicAndPadding, d = t.readInt32(g), k = t.readAt(g - d, d);
    return Footer_.decode(k);
  }
  _readNextMessageAndValidate(t) {
    var g;
    if (this._footer || this.open(), this._footer && this._recordBatchIndex < this.numRecordBatches) {
      const d = (g = this._footer) === null || g === void 0 ? void 0 : g.getRecordBatch(this._recordBatchIndex);
      if (d && this._handle.seek(d.offset))
        return this._reader.readMessage(t);
    }
    return null;
  }
}
class AsyncRecordBatchFileReaderImpl extends AsyncRecordBatchStreamReaderImpl {
  get footer() {
    return this._footer;
  }
  get numDictionaries() {
    return this._footer ? this._footer.numDictionaries : 0;
  }
  get numRecordBatches() {
    return this._footer ? this._footer.numRecordBatches : 0;
  }
  constructor(t, ...g) {
    const d = typeof g[0] != "number" ? g.shift() : void 0, k = g[0] instanceof Map ? g.shift() : void 0;
    super(t instanceof AsyncRandomAccessFile ? t : new AsyncRandomAccessFile(t, d), k);
  }
  isFile() {
    return !0;
  }
  isAsync() {
    return !0;
  }
  open(t) {
    const g = Object.create(null, {
      open: { get: () => super.open }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.closed && !this._footer) {
        this.schema = (this._footer = yield this._readFooter()).schema;
        for (const d of this._footer.dictionaryBatches())
          d && (yield this._readDictionaryBatch(this._dictionaryIndex++));
      }
      return yield g.open.call(this, t);
    });
  }
  readRecordBatch(t) {
    return __awaiter(this, void 0, void 0, function* () {
      var g;
      if (this.closed)
        return null;
      this._footer || (yield this.open());
      const d = (g = this._footer) === null || g === void 0 ? void 0 : g.getRecordBatch(t);
      if (d && (yield this._handle.seek(d.offset))) {
        const k = yield this._reader.readMessage(MessageHeader.RecordBatch);
        if (k?.isRecordBatch()) {
          const H = k.header(), AA = yield this._reader.readMessageBody(k.bodyLength);
          return this._loadRecordBatch(H, AA);
        }
      }
      return null;
    });
  }
  _readDictionaryBatch(t) {
    return __awaiter(this, void 0, void 0, function* () {
      var g;
      const d = (g = this._footer) === null || g === void 0 ? void 0 : g.getDictionaryBatch(t);
      if (d && (yield this._handle.seek(d.offset))) {
        const k = yield this._reader.readMessage(MessageHeader.DictionaryBatch);
        if (k?.isDictionaryBatch()) {
          const H = k.header(), AA = yield this._reader.readMessageBody(k.bodyLength), gA = this._loadDictionaryBatch(H, AA);
          this.dictionaries.set(H.id, gA);
        }
      }
    });
  }
  _readFooter() {
    return __awaiter(this, void 0, void 0, function* () {
      const { _handle: t } = this;
      t._pending && (yield t._pending);
      const g = t.size - magicAndPadding, d = yield t.readInt32(g), k = yield t.readAt(g - d, d);
      return Footer_.decode(k);
    });
  }
  _readNextMessageAndValidate(t) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._footer || (yield this.open()), this._footer && this._recordBatchIndex < this.numRecordBatches) {
        const g = this._footer.getRecordBatch(this._recordBatchIndex);
        if (g && (yield this._handle.seek(g.offset)))
          return yield this._reader.readMessage(t);
      }
      return null;
    });
  }
}
class RecordBatchJSONReaderImpl extends RecordBatchStreamReaderImpl {
  constructor(t, g) {
    super(t, g);
  }
  _loadVectors(t, g, d) {
    return new JSONVectorLoader(g, t.nodes, t.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(d);
  }
}
function shouldAutoDestroy(n, t) {
  return t && typeof t.autoDestroy == "boolean" ? t.autoDestroy : n.autoDestroy;
}
function* readAllSync(n) {
  const t = RecordBatchReader.from(n);
  try {
    if (!t.open({ autoDestroy: !1 }).closed)
      do
        yield t;
      while (!t.reset().open().closed);
  } finally {
    t.cancel();
  }
}
function readAllAsync(n) {
  return __asyncGenerator(this, arguments, function* () {
    const g = yield __await(RecordBatchReader.from(n));
    try {
      if (!(yield __await(g.open({ autoDestroy: !1 }))).closed)
        do
          yield yield __await(g);
        while (!(yield __await(g.reset().open())).closed);
    } finally {
      yield __await(g.cancel());
    }
  });
}
function fromArrowJSON(n) {
  return new RecordBatchStreamReader(new RecordBatchJSONReaderImpl(n));
}
function fromByteStream(n) {
  const t = n.peek(magicLength + 7 & -8);
  return t && t.byteLength >= 4 ? checkForMagicArrowString(t) ? new RecordBatchFileReader(new RecordBatchFileReaderImpl(n.read())) : new RecordBatchStreamReader(new RecordBatchStreamReaderImpl(n)) : new RecordBatchStreamReader(new RecordBatchStreamReaderImpl((function* () {
  })()));
}
function fromAsyncByteStream(n) {
  return __awaiter(this, void 0, void 0, function* () {
    const t = yield n.peek(magicLength + 7 & -8);
    return t && t.byteLength >= 4 ? checkForMagicArrowString(t) ? new RecordBatchFileReader(new RecordBatchFileReaderImpl(yield n.read())) : new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl(n)) : new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl((function() {
      return __asyncGenerator(this, arguments, function* () {
      });
    })()));
  });
}
function fromFileHandle(n) {
  return __awaiter(this, void 0, void 0, function* () {
    const { size: t } = yield n.stat(), g = new AsyncRandomAccessFile(n, t);
    return t >= magicX2AndPadding && checkForMagicArrowString(yield g.readAt(0, magicLength + 7 & -8)) ? new AsyncRecordBatchFileReader(new AsyncRecordBatchFileReaderImpl(g)) : new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl(g));
  });
}
function tableFromIPC(n) {
  const t = RecordBatchReader.from(n);
  return isPromise(t) ? t.then((g) => tableFromIPC(g)) : t.isAsync() ? t.readAll().then((g) => new Table$1(g)) : new Table$1(t.readAll());
}
const util$2 = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, util_bn_), util_int_), util_bit_), util_math_), util_buffer_), util_vector_), util_pretty_), util_interval_), {
  compareSchemas,
  compareFields,
  compareTypes
});
var _baseRange, hasRequired_baseRange;
function require_baseRange() {
  if (hasRequired_baseRange) return _baseRange;
  hasRequired_baseRange = 1;
  var n = Math.ceil, t = Math.max;
  function g(d, k, H, AA) {
    for (var gA = -1, IA = t(n((k - d) / (H || 1)), 0), CA = Array(IA); IA--; )
      CA[AA ? IA : ++gA] = d, d += H;
    return CA;
  }
  return _baseRange = g, _baseRange;
}
var isLength_1, hasRequiredIsLength;
function requireIsLength() {
  if (hasRequiredIsLength) return isLength_1;
  hasRequiredIsLength = 1;
  var n = 9007199254740991;
  function t(g) {
    return typeof g == "number" && g > -1 && g % 1 == 0 && g <= n;
  }
  return isLength_1 = t, isLength_1;
}
var isArrayLike_1, hasRequiredIsArrayLike;
function requireIsArrayLike() {
  if (hasRequiredIsArrayLike) return isArrayLike_1;
  hasRequiredIsArrayLike = 1;
  var n = requireIsFunction(), t = requireIsLength();
  function g(d) {
    return d != null && t(d.length) && !n(d);
  }
  return isArrayLike_1 = g, isArrayLike_1;
}
var _isIndex, hasRequired_isIndex;
function require_isIndex() {
  if (hasRequired_isIndex) return _isIndex;
  hasRequired_isIndex = 1;
  var n = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function g(d, k) {
    var H = typeof d;
    return k = k ?? n, !!k && (H == "number" || H != "symbol" && t.test(d)) && d > -1 && d % 1 == 0 && d < k;
  }
  return _isIndex = g, _isIndex;
}
var _isIterateeCall, hasRequired_isIterateeCall;
function require_isIterateeCall() {
  if (hasRequired_isIterateeCall) return _isIterateeCall;
  hasRequired_isIterateeCall = 1;
  var n = requireEq$1(), t = requireIsArrayLike(), g = require_isIndex(), d = requireIsObject();
  function k(H, AA, gA) {
    if (!d(gA))
      return !1;
    var IA = typeof AA;
    return (IA == "number" ? t(gA) && g(AA, gA.length) : IA == "string" && AA in gA) ? n(gA[AA], H) : !1;
  }
  return _isIterateeCall = k, _isIterateeCall;
}
var _trimmedEndIndex, hasRequired_trimmedEndIndex;
function require_trimmedEndIndex() {
  if (hasRequired_trimmedEndIndex) return _trimmedEndIndex;
  hasRequired_trimmedEndIndex = 1;
  var n = /\s/;
  function t(g) {
    for (var d = g.length; d-- && n.test(g.charAt(d)); )
      ;
    return d;
  }
  return _trimmedEndIndex = t, _trimmedEndIndex;
}
var _baseTrim, hasRequired_baseTrim;
function require_baseTrim() {
  if (hasRequired_baseTrim) return _baseTrim;
  hasRequired_baseTrim = 1;
  var n = require_trimmedEndIndex(), t = /^\s+/;
  function g(d) {
    return d && d.slice(0, n(d) + 1).replace(t, "");
  }
  return _baseTrim = g, _baseTrim;
}
var toNumber_1, hasRequiredToNumber;
function requireToNumber() {
  if (hasRequiredToNumber) return toNumber_1;
  hasRequiredToNumber = 1;
  var n = require_baseTrim(), t = requireIsObject(), g = requireIsSymbol(), d = NaN, k = /^[-+]0x[0-9a-f]+$/i, H = /^0b[01]+$/i, AA = /^0o[0-7]+$/i, gA = parseInt;
  function IA(CA) {
    if (typeof CA == "number")
      return CA;
    if (g(CA))
      return d;
    if (t(CA)) {
      var BA = typeof CA.valueOf == "function" ? CA.valueOf() : CA;
      CA = t(BA) ? BA + "" : BA;
    }
    if (typeof CA != "string")
      return CA === 0 ? CA : +CA;
    CA = n(CA);
    var eA = H.test(CA);
    return eA || AA.test(CA) ? gA(CA.slice(2), eA ? 2 : 8) : k.test(CA) ? d : +CA;
  }
  return toNumber_1 = IA, toNumber_1;
}
var toFinite_1, hasRequiredToFinite;
function requireToFinite() {
  if (hasRequiredToFinite) return toFinite_1;
  hasRequiredToFinite = 1;
  var n = requireToNumber(), t = 1 / 0, g = 17976931348623157e292;
  function d(k) {
    if (!k)
      return k === 0 ? k : 0;
    if (k = n(k), k === t || k === -t) {
      var H = k < 0 ? -1 : 1;
      return H * g;
    }
    return k === k ? k : 0;
  }
  return toFinite_1 = d, toFinite_1;
}
var _createRange, hasRequired_createRange;
function require_createRange() {
  if (hasRequired_createRange) return _createRange;
  hasRequired_createRange = 1;
  var n = require_baseRange(), t = require_isIterateeCall(), g = requireToFinite();
  function d(k) {
    return function(H, AA, gA) {
      return gA && typeof gA != "number" && t(H, AA, gA) && (AA = gA = void 0), H = g(H), AA === void 0 ? (AA = H, H = 0) : AA = g(AA), gA = gA === void 0 ? H < AA ? 1 : -1 : g(gA), n(H, AA, gA, k);
    };
  }
  return _createRange = d, _createRange;
}
var range_1, hasRequiredRange$1;
function requireRange$1() {
  if (hasRequiredRange$1) return range_1;
  hasRequiredRange$1 = 1;
  var n = require_createRange(), t = n();
  return range_1 = t, range_1;
}
var rangeExports = requireRange$1();
const range$6 = /* @__PURE__ */ getDefaultExportFromCjs$2(rangeExports);
var identity_1, hasRequiredIdentity;
function requireIdentity() {
  if (hasRequiredIdentity) return identity_1;
  hasRequiredIdentity = 1;
  function n(t) {
    return t;
  }
  return identity_1 = n, identity_1;
}
var _apply, hasRequired_apply;
function require_apply() {
  if (hasRequired_apply) return _apply;
  hasRequired_apply = 1;
  function n(t, g, d) {
    switch (d.length) {
      case 0:
        return t.call(g);
      case 1:
        return t.call(g, d[0]);
      case 2:
        return t.call(g, d[0], d[1]);
      case 3:
        return t.call(g, d[0], d[1], d[2]);
    }
    return t.apply(g, d);
  }
  return _apply = n, _apply;
}
var _overRest, hasRequired_overRest;
function require_overRest() {
  if (hasRequired_overRest) return _overRest;
  hasRequired_overRest = 1;
  var n = require_apply(), t = Math.max;
  function g(d, k, H) {
    return k = t(k === void 0 ? d.length - 1 : k, 0), function() {
      for (var AA = arguments, gA = -1, IA = t(AA.length - k, 0), CA = Array(IA); ++gA < IA; )
        CA[gA] = AA[k + gA];
      gA = -1;
      for (var BA = Array(k + 1); ++gA < k; )
        BA[gA] = AA[gA];
      return BA[k] = H(CA), n(d, this, BA);
    };
  }
  return _overRest = g, _overRest;
}
var constant_1, hasRequiredConstant;
function requireConstant() {
  if (hasRequiredConstant) return constant_1;
  hasRequiredConstant = 1;
  function n(t) {
    return function() {
      return t;
    };
  }
  return constant_1 = n, constant_1;
}
var _defineProperty$H, hasRequired_defineProperty;
function require_defineProperty() {
  if (hasRequired_defineProperty) return _defineProperty$H;
  hasRequired_defineProperty = 1;
  var n = require_getNative(), t = (function() {
    try {
      var g = n(Object, "defineProperty");
      return g({}, "", {}), g;
    } catch {
    }
  })();
  return _defineProperty$H = t, _defineProperty$H;
}
var _baseSetToString, hasRequired_baseSetToString;
function require_baseSetToString() {
  if (hasRequired_baseSetToString) return _baseSetToString;
  hasRequired_baseSetToString = 1;
  var n = requireConstant(), t = require_defineProperty(), g = requireIdentity(), d = t ? function(k, H) {
    return t(k, "toString", {
      configurable: !0,
      enumerable: !1,
      value: n(H),
      writable: !0
    });
  } : g;
  return _baseSetToString = d, _baseSetToString;
}
var _shortOut, hasRequired_shortOut;
function require_shortOut() {
  if (hasRequired_shortOut) return _shortOut;
  hasRequired_shortOut = 1;
  var n = 800, t = 16, g = Date.now;
  function d(k) {
    var H = 0, AA = 0;
    return function() {
      var gA = g(), IA = t - (gA - AA);
      if (AA = gA, IA > 0) {
        if (++H >= n)
          return arguments[0];
      } else
        H = 0;
      return k.apply(void 0, arguments);
    };
  }
  return _shortOut = d, _shortOut;
}
var _setToString, hasRequired_setToString;
function require_setToString() {
  if (hasRequired_setToString) return _setToString;
  hasRequired_setToString = 1;
  var n = require_baseSetToString(), t = require_shortOut(), g = t(n);
  return _setToString = g, _setToString;
}
var _baseRest, hasRequired_baseRest;
function require_baseRest() {
  if (hasRequired_baseRest) return _baseRest;
  hasRequired_baseRest = 1;
  var n = requireIdentity(), t = require_overRest(), g = require_setToString();
  function d(k, H) {
    return g(t(k, H, n), k + "");
  }
  return _baseRest = d, _baseRest;
}
var _arrayFilter, hasRequired_arrayFilter;
function require_arrayFilter() {
  if (hasRequired_arrayFilter) return _arrayFilter;
  hasRequired_arrayFilter = 1;
  function n(t, g) {
    for (var d = -1, k = t == null ? 0 : t.length, H = 0, AA = []; ++d < k; ) {
      var gA = t[d];
      g(gA, d, t) && (AA[H++] = gA);
    }
    return AA;
  }
  return _arrayFilter = n, _arrayFilter;
}
var _baseProperty, hasRequired_baseProperty;
function require_baseProperty() {
  if (hasRequired_baseProperty) return _baseProperty;
  hasRequired_baseProperty = 1;
  function n(t) {
    return function(g) {
      return g?.[t];
    };
  }
  return _baseProperty = n, _baseProperty;
}
var _baseTimes, hasRequired_baseTimes;
function require_baseTimes() {
  if (hasRequired_baseTimes) return _baseTimes;
  hasRequired_baseTimes = 1;
  function n(t, g) {
    for (var d = -1, k = Array(t); ++d < t; )
      k[d] = g(d);
    return k;
  }
  return _baseTimes = n, _baseTimes;
}
var isArrayLikeObject_1, hasRequiredIsArrayLikeObject;
function requireIsArrayLikeObject() {
  if (hasRequiredIsArrayLikeObject) return isArrayLikeObject_1;
  hasRequiredIsArrayLikeObject = 1;
  var n = requireIsArrayLike(), t = requireIsObjectLike();
  function g(d) {
    return t(d) && n(d);
  }
  return isArrayLikeObject_1 = g, isArrayLikeObject_1;
}
var unzip_1, hasRequiredUnzip;
function requireUnzip() {
  if (hasRequiredUnzip) return unzip_1;
  hasRequiredUnzip = 1;
  var n = require_arrayFilter(), t = require_arrayMap(), g = require_baseProperty(), d = require_baseTimes(), k = requireIsArrayLikeObject(), H = Math.max;
  function AA(gA) {
    if (!(gA && gA.length))
      return [];
    var IA = 0;
    return gA = n(gA, function(CA) {
      if (k(CA))
        return IA = H(CA.length, IA), !0;
    }), d(IA, function(CA) {
      return t(gA, g(CA));
    });
  }
  return unzip_1 = AA, unzip_1;
}
var zip_1, hasRequiredZip;
function requireZip() {
  if (hasRequiredZip) return zip_1;
  hasRequiredZip = 1;
  var n = require_baseRest(), t = requireUnzip(), g = n(t);
  return zip_1 = g, zip_1;
}
var zipExports = requireZip();
const zip = /* @__PURE__ */ getDefaultExportFromCjs$2(zipExports), PandasRangeIndexType = "range";
var DataFrameCellType = /* @__PURE__ */ ((n) => (n.INDEX = "index", n.DATA = "data", n))(DataFrameCellType || {});
function convertVectorToList(n) {
  const t = [];
  for (let g = 0; g < n.length; g++)
    t.push(n.get(g));
  return t;
}
function getPandasTypeName(n) {
  return isNullOrUndefined$1(n.pandasType) ? void 0 : (n.pandasType.pandas_type === "object" ? n.pandasType.numpy_type : n.pandasType.pandas_type).toLowerCase().trim();
}
function getTimezone(n) {
  return n.arrowField?.type?.timezone ?? n.pandasType?.metadata?.timezone;
}
function isIntegerType(n) {
  if (isNullOrUndefined$1(n))
    return !1;
  const t = getPandasTypeName(n) ?? "";
  return (
    // Period types are integers with an extra extension name
    DataType.isInt(n.arrowField.type) && !isPeriodType(n) || t.startsWith("int") && !isIntervalType(n) || isRangeIndexType(n) || isUnsignedIntegerType(n)
  );
}
function isUnsignedIntegerType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isInt(n.arrowField.type) && n.arrowField.type.isSigned === !1 || (getPandasTypeName(n)?.startsWith("uint") ?? !1);
}
function isFloatType(n) {
  return isNullOrUndefined$1(n) ? !1 : (DataType.isFloat(n.arrowField.type) || getPandasTypeName(n)?.startsWith("float")) ?? !1;
}
function isDecimalType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isDecimal(n.arrowField.type) || getPandasTypeName(n) === "decimal";
}
function isNumericType(n) {
  return isNullOrUndefined$1(n) ? !1 : isIntegerType(n) || isFloatType(n) || isDecimalType(n);
}
function isBooleanType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isBool(n.arrowField.type) || getPandasTypeName(n) === "bool";
}
function isDurationType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isDuration(n.arrowField.type) || (getPandasTypeName(n)?.startsWith("timedelta") ?? !1);
}
function isPeriodType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isInt(n.arrowField.type) && n.arrowField.metadata.get("ARROW:extension:name") === "period" || (getPandasTypeName(n)?.startsWith("period") ?? !1);
}
function isDatetimeType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isTimestamp(n.arrowField.type) || (getPandasTypeName(n)?.startsWith("datetime") ?? !1);
}
function isDateType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isDate(n.arrowField.type) || getPandasTypeName(n) === "date";
}
function isTimeType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isTime(n.arrowField.type) || getPandasTypeName(n) === "time";
}
function isCategoricalType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isDictionary(n.arrowField.type) || getPandasTypeName(n) === "categorical";
}
function isListType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isList(n.arrowField.type) || DataType.isFixedSizeList(n.arrowField.type) || (getPandasTypeName(n)?.startsWith("list") ?? !1);
}
function isObjectType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isStruct(n.arrowField.type) || DataType.isMap(n.arrowField.type) || getPandasTypeName(n) === "object";
}
function isBytesType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isBinary(n.arrowField.type) || DataType.isLargeBinary(n.arrowField.type) || getPandasTypeName(n) === "bytes";
}
function isStringType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isUtf8(n.arrowField.type) || DataType.isLargeUtf8(n.arrowField.type) || ["unicode", "large_string[pyarrow]"].includes(getPandasTypeName(n) ?? "");
}
function isEmptyType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isNull(n.arrowField.type) || getPandasTypeName(n) === "empty";
}
function isIntervalType(n) {
  return isNullOrUndefined$1(n) ? !1 : DataType.isStruct(n.arrowField.type) && n.arrowField.metadata.get("ARROW:extension:name") === "interval" || (getPandasTypeName(n)?.startsWith("interval") ?? !1);
}
function isRangeIndexType(n) {
  return isNullOrUndefined$1(n) ? !1 : getPandasTypeName(n) === PandasRangeIndexType;
}
function sameDataTypes(n, t) {
  return n.every((g, d) => g.pandasType?.pandas_type === t[d]?.pandasType?.pandas_type);
}
function sameIndexTypes(n, t) {
  return n.length !== t.length ? !1 : n.every((g, d) => d < t.length && getPandasTypeName(g) === getPandasTypeName(t[d]));
}
function concatIndexes(n, t, g, d) {
  if (g.length === 0)
    return n;
  if (n.length === 0)
    return g;
  if (!sameIndexTypes(t, d)) {
    const H = d.map((gA) => getPandasTypeName(gA)), AA = t.map((gA) => getPandasTypeName(gA));
    throw new Error(`
Unsupported operation. The data passed into \`add_rows()\` must have the same
index signature as the original data.

In this case, \`add_rows()\` received \`${JSON.stringify(H)}\`
but was expecting \`${JSON.stringify(AA)}\`.
`);
  }
  if (t.length === 0)
    throw new Error("There was an error while parsing index types.");
  if (isRangeIndexType(t[0])) {
    const {
      step: H,
      stop: AA
    } = t[0].pandasType?.metadata;
    g = [range$6(
      AA,
      // End is not inclusive
      AA + g[0].length * H,
      H
    )];
  }
  return zip(n, g).map((H) => H[0].concat(H[1]));
}
function concatData(n, t, g, d) {
  if (g.numCols === 0)
    return n;
  if (n.numCols === 0)
    return g;
  if (!sameDataTypes(t, d)) {
    const H = d.map((gA) => gA.pandasType?.pandas_type), AA = t.map((gA) => gA.pandasType?.pandas_type);
    throw new Error(`
Unsupported operation. The data passed into \`add_rows()\` must have the same
data signature as the original data.

In this case, \`add_rows()\` received \`${JSON.stringify(H)}\`
but was expecting \`${JSON.stringify(AA)}\`.
`);
  }
  const k = g.selectAt(range$6(0, n.numCols));
  return n.concat(k);
}
function concatTypes(n, t, g, d) {
  const k = concatIndexTypes(n, g), H = concatDataTypes(t, d);
  return {
    indexTypes: k,
    dataTypes: H
  };
}
function concatIndexTypes(n, t) {
  if (t.length === 0)
    return n;
  if (n.length === 0)
    return t;
  if (!sameIndexTypes(n, t)) {
    const g = t.map((k) => getPandasTypeName(k)), d = n.map((k) => getPandasTypeName(k));
    throw new Error(`
Unsupported operation. The data passed into \`add_rows()\` must have the same
index signature as the original data.

In this case, \`add_rows()\` received \`${JSON.stringify(g)}\`
but was expecting \`${JSON.stringify(d)}\`.
`);
  }
  return n.map((g) => {
    if (isRangeIndexType(g) && g.pandasType) {
      const {
        stop: d,
        step: k
      } = g.pandasType.metadata, {
        start: H,
        stop: AA,
        step: gA
      } = t[0].pandasType?.metadata, IA = (AA - H) / gA, CA = d + IA * k;
      return {
        ...g,
        pandasType: {
          ...g.pandasType,
          metadata: {
            ...g.pandasType.metadata,
            stop: CA
          }
        }
      };
    }
    return g;
  });
}
function concatDataTypes(n, t) {
  return n.length === 0 ? t : n;
}
function concat(n, t, g, d, k, H, AA, gA) {
  const IA = concatIndexes(g, t, AA, H), CA = concatData(d, n, gA, k), {
    indexTypes: BA,
    dataTypes: eA
  } = concatTypes(t, n, H, k);
  return {
    index: IA,
    data: CA,
    indexTypes: BA,
    dataTypes: eA
  };
}
var unzipExports = requireUnzip();
const unzip = /* @__PURE__ */ getDefaultExportFromCjs$2(unzipExports);
let wasm;
const heap = new Array(128).fill(void 0);
heap.push(void 0, null, !0, !1);
let heap_next = heap.length;
function addHeapObject(n) {
  heap_next === heap.length && heap.push(heap.length + 1);
  const t = heap_next;
  return heap_next = heap[t], heap[t] = n, t;
}
function getObject(n) {
  return heap[n];
}
function dropObject(n) {
  n < 132 || (heap[n] = heap_next, heap_next = n);
}
function takeObject(n) {
  const t = getObject(n);
  return dropObject(n), t;
}
const cachedTextDecoder = typeof TextDecoder < "u" ? new TextDecoder("utf-8", { ignoreBOM: !0, fatal: !0 }) : { decode: () => {
  throw Error("TextDecoder not available");
} };
typeof TextDecoder < "u" && cachedTextDecoder.decode();
let cachedUint8Memory0 = null;
function getUint8Memory0() {
  return (cachedUint8Memory0 === null || cachedUint8Memory0.byteLength === 0) && (cachedUint8Memory0 = new Uint8Array(wasm.memory.buffer)), cachedUint8Memory0;
}
function getStringFromWasm0(n, t) {
  return n = n >>> 0, cachedTextDecoder.decode(getUint8Memory0().subarray(n, n + t));
}
function isLikeNone(n) {
  return n == null;
}
let cachedFloat64Memory0 = null;
function getFloat64Memory0() {
  return (cachedFloat64Memory0 === null || cachedFloat64Memory0.byteLength === 0) && (cachedFloat64Memory0 = new Float64Array(wasm.memory.buffer)), cachedFloat64Memory0;
}
let cachedInt32Memory0 = null;
function getInt32Memory0() {
  return (cachedInt32Memory0 === null || cachedInt32Memory0.byteLength === 0) && (cachedInt32Memory0 = new Int32Array(wasm.memory.buffer)), cachedInt32Memory0;
}
let WASM_VECTOR_LEN = 0;
const cachedTextEncoder = typeof TextEncoder < "u" ? new TextEncoder("utf-8") : { encode: () => {
  throw Error("TextEncoder not available");
} }, encodeString = typeof cachedTextEncoder.encodeInto == "function" ? function(n, t) {
  return cachedTextEncoder.encodeInto(n, t);
} : function(n, t) {
  const g = cachedTextEncoder.encode(n);
  return t.set(g), {
    read: n.length,
    written: g.length
  };
};
function passStringToWasm0(n, t, g) {
  if (g === void 0) {
    const gA = cachedTextEncoder.encode(n), IA = t(gA.length, 1) >>> 0;
    return getUint8Memory0().subarray(IA, IA + gA.length).set(gA), WASM_VECTOR_LEN = gA.length, IA;
  }
  let d = n.length, k = t(d, 1) >>> 0;
  const H = getUint8Memory0();
  let AA = 0;
  for (; AA < d; AA++) {
    const gA = n.charCodeAt(AA);
    if (gA > 127) break;
    H[k + AA] = gA;
  }
  if (AA !== d) {
    AA !== 0 && (n = n.slice(AA)), k = g(k, d, d = AA + n.length * 3, 1) >>> 0;
    const gA = getUint8Memory0().subarray(k + AA, k + d), IA = encodeString(n, gA);
    AA += IA.written, k = g(k, d, AA, 1) >>> 0;
  }
  return WASM_VECTOR_LEN = AA, k;
}
let cachedBigInt64Memory0 = null;
function getBigInt64Memory0() {
  return (cachedBigInt64Memory0 === null || cachedBigInt64Memory0.byteLength === 0) && (cachedBigInt64Memory0 = new BigInt64Array(wasm.memory.buffer)), cachedBigInt64Memory0;
}
function debugString(n) {
  const t = typeof n;
  if (t == "number" || t == "boolean" || n == null)
    return `${n}`;
  if (t == "string")
    return `"${n}"`;
  if (t == "symbol") {
    const k = n.description;
    return k == null ? "Symbol" : `Symbol(${k})`;
  }
  if (t == "function") {
    const k = n.name;
    return typeof k == "string" && k.length > 0 ? `Function(${k})` : "Function";
  }
  if (Array.isArray(n)) {
    const k = n.length;
    let H = "[";
    k > 0 && (H += debugString(n[0]));
    for (let AA = 1; AA < k; AA++)
      H += ", " + debugString(n[AA]);
    return H += "]", H;
  }
  const g = /\[object ([^\]]+)\]/.exec(toString.call(n));
  let d;
  if (g.length > 1)
    d = g[1];
  else
    return toString.call(n);
  if (d == "Object")
    try {
      return "Object(" + JSON.stringify(n) + ")";
    } catch {
      return "Object";
    }
  return n instanceof Error ? `${n.name}: ${n.message}
${n.stack}` : d;
}
const CLOSURE_DTORS = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => {
  wasm.__wbindgen_export_2.get(n.dtor)(n.a, n.b);
});
function makeMutClosure(n, t, g, d) {
  const k = { a: n, b: t, cnt: 1, dtor: g }, H = (...AA) => {
    k.cnt++;
    const gA = k.a;
    k.a = 0;
    try {
      return d(gA, k.b, ...AA);
    } finally {
      --k.cnt === 0 ? (wasm.__wbindgen_export_2.get(k.dtor)(gA, k.b), CLOSURE_DTORS.unregister(k)) : k.a = gA;
    }
  };
  return H.original = k, CLOSURE_DTORS.register(H, k, k), H;
}
function __wbg_adapter_50(n, t, g) {
  wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h1de40baa0df51db0(n, t, addHeapObject(g));
}
function passArray8ToWasm0(n, t) {
  const g = t(n.length * 1, 1) >>> 0;
  return getUint8Memory0().set(n, g / 1), WASM_VECTOR_LEN = n.length, g;
}
function readParquet(n, t) {
  try {
    const H = wasm.__wbindgen_add_to_stack_pointer(-16), AA = passArray8ToWasm0(n, wasm.__wbindgen_malloc), gA = WASM_VECTOR_LEN;
    wasm.readParquet(H, AA, gA, isLikeNone(t) ? 0 : addHeapObject(t));
    var g = getInt32Memory0()[H / 4 + 0], d = getInt32Memory0()[H / 4 + 1], k = getInt32Memory0()[H / 4 + 2];
    if (k)
      throw takeObject(d);
    return Table.__wrap(g);
  } finally {
    wasm.__wbindgen_add_to_stack_pointer(16);
  }
}
function _assertClass(n, t) {
  if (!(n instanceof t))
    throw new Error(`expected instance of ${t.name}`);
  return n.ptr;
}
function getArrayU8FromWasm0(n, t) {
  return n = n >>> 0, getUint8Memory0().subarray(n / 1, n / 1 + t);
}
let cachedUint32Memory0 = null;
function getUint32Memory0() {
  return (cachedUint32Memory0 === null || cachedUint32Memory0.byteLength === 0) && (cachedUint32Memory0 = new Uint32Array(wasm.memory.buffer)), cachedUint32Memory0;
}
function getArrayJsValueFromWasm0(n, t) {
  n = n >>> 0;
  const d = getUint32Memory0().subarray(n / 4, n / 4 + t), k = [];
  for (let H = 0; H < d.length; H++)
    k.push(takeObject(d[H]));
  return k;
}
function handleError(n, t) {
  try {
    return n.apply(this, t);
  } catch (g) {
    wasm.__wbindgen_exn_store(addHeapObject(g));
  }
}
function getArrayU32FromWasm0(n, t) {
  return n = n >>> 0, getUint32Memory0().subarray(n / 4, n / 4 + t);
}
function __wbg_adapter_285(n, t, g, d) {
  wasm.wasm_bindgen__convert__closures__invoke2_mut__h26b6dc7d05b06fdf(n, t, addHeapObject(g), addHeapObject(d));
}
const ColumnChunkMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_columnchunkmetadata_free(n >>> 0));
class ColumnChunkMetaData {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(ColumnChunkMetaData.prototype);
    return g.__wbg_ptr = t, ColumnChunkMetaDataFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ColumnChunkMetaDataFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_columnchunkmetadata_free(t);
  }
  /**
  * File where the column chunk is stored.
  *
  * If not set, assumed to belong to the same file as the metadata.
  * This path is relative to the current file.
  * @returns {string | undefined}
  */
  filePath() {
    try {
      const d = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.columnchunkmetadata_filePath(d, this.__wbg_ptr);
      var t = getInt32Memory0()[d / 4 + 0], g = getInt32Memory0()[d / 4 + 1];
      let k;
      return t !== 0 && (k = getStringFromWasm0(t, g).slice(), wasm.__wbindgen_free(t, g * 1, 1)), k;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Byte offset in `file_path()`.
  * @returns {bigint}
  */
  fileOffset() {
    return wasm.columnchunkmetadata_fileOffset(this.__wbg_ptr);
  }
  /**
  * Path (or identifier) of this column.
  * @returns {(string)[]}
  */
  columnPath() {
    try {
      const k = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.columnchunkmetadata_columnPath(k, this.__wbg_ptr);
      var t = getInt32Memory0()[k / 4 + 0], g = getInt32Memory0()[k / 4 + 1], d = getArrayJsValueFromWasm0(t, g).slice();
      return wasm.__wbindgen_free(t, g * 4, 4), d;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * All encodings used for this column.
  * @returns {any[]}
  */
  encodings() {
    try {
      const k = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.columnchunkmetadata_encodings(k, this.__wbg_ptr);
      var t = getInt32Memory0()[k / 4 + 0], g = getInt32Memory0()[k / 4 + 1], d = getArrayJsValueFromWasm0(t, g).slice();
      return wasm.__wbindgen_free(t, g * 4, 4), d;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Total number of values in this column chunk.
  * @returns {number}
  */
  numValues() {
    return wasm.columnchunkmetadata_numValues(this.__wbg_ptr);
  }
  /**
  * Compression for this column.
  * @returns {Compression}
  */
  compression() {
    return wasm.columnchunkmetadata_compression(this.__wbg_ptr);
  }
  /**
  * Returns the total compressed data size of this column chunk.
  * @returns {number}
  */
  compressedSize() {
    return wasm.columnchunkmetadata_compressedSize(this.__wbg_ptr);
  }
  /**
  * Returns the total uncompressed data size of this column chunk.
  * @returns {number}
  */
  uncompressedSize() {
    return wasm.columnchunkmetadata_uncompressedSize(this.__wbg_ptr);
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((n) => wasm.__wbg_ffiarrowarray_free(n >>> 0));
const FFIArrowSchemaFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_ffiarrowschema_free(n >>> 0));
class FFIArrowSchema {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(FFIArrowSchema.prototype);
    return g.__wbg_ptr = t, FFIArrowSchemaFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FFIArrowSchemaFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_ffiarrowschema_free(t);
  }
  /**
  * Access the pointer to the
  * [`ArrowSchema`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct. This can be viewed or copied (without serialization) to an Arrow JS `Field` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmRecordBatch: FFIRecordBatch = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * // Pass `true` to copy arrays across the boundary instead of creating views.
  * const jsRecordBatch = parseRecordBatch(
  *   wasmMemory.buffer,
  *   wasmRecordBatch.arrayAddr(),
  *   wasmRecordBatch.schemaAddr(),
  *   true
  * );
  * ```
  * @returns {number}
  */
  addr() {
    return wasm.ffiarrowschema_addr(this.__wbg_ptr) >>> 0;
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((n) => wasm.__wbg_ffidata_free(n >>> 0));
const FFIRecordBatchFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_ffirecordbatch_free(n >>> 0));
class FFIRecordBatch {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(FFIRecordBatch.prototype);
    return g.__wbg_ptr = t, FFIRecordBatchFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FFIRecordBatchFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_ffirecordbatch_free(t);
  }
  /**
  * Access the pointer to the
  * [`ArrowArray`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct. This can be viewed or copied (without serialization) to an Arrow JS `RecordBatch` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmRecordBatch: FFIRecordBatch = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * // Pass `true` to copy arrays across the boundary instead of creating views.
  * const jsRecordBatch = parseRecordBatch(
  *   wasmMemory.buffer,
  *   wasmRecordBatch.arrayAddr(),
  *   wasmRecordBatch.schemaAddr(),
  *   true
  * );
  * ```
  * @returns {number}
  */
  arrayAddr() {
    return wasm.ffirecordbatch_arrayAddr(this.__wbg_ptr) >>> 0;
  }
  /**
  * Access the pointer to the
  * [`ArrowSchema`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct. This can be viewed or copied (without serialization) to an Arrow JS `Field` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmRecordBatch: FFIRecordBatch = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * // Pass `true` to copy arrays across the boundary instead of creating views.
  * const jsRecordBatch = parseRecordBatch(
  *   wasmMemory.buffer,
  *   wasmRecordBatch.arrayAddr(),
  *   wasmRecordBatch.schemaAddr(),
  *   true
  * );
  * ```
  * @returns {number}
  */
  schemaAddr() {
    return wasm.ffirecordbatch_schemaAddr(this.__wbg_ptr) >>> 0;
  }
}
const FFITableFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_ffitable_free(n >>> 0));
class FFITable {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(FFITable.prototype);
    return g.__wbg_ptr = t, FFITableFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FFITableFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_ffitable_free(t);
  }
  /**
  * Get the total number of record batches in the table
  * @returns {number}
  */
  numBatches() {
    return wasm.ffitable_numBatches(this.__wbg_ptr) >>> 0;
  }
  /**
  * Get the pointer to one ArrowSchema FFI struct
  * @returns {number}
  */
  schemaAddr() {
    return wasm.ffitable_schemaAddr(this.__wbg_ptr) >>> 0;
  }
  /**
  * Get the pointer to one ArrowArray FFI struct for a given chunk index and column index
  *
  * Access the pointer to one
  * [`ArrowArray`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct representing one of the internal `RecordBatch`es. This can be viewed or copied (without serialization) to an Arrow JS `RecordBatch` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import * as arrow from "apache-arrow";
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmTable: FFITable = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * const jsBatches: arrow.RecordBatch[] = []
  * for (let i = 0; i < wasmTable.numBatches(); i++) {
  *   // Pass `true` to copy arrays across the boundary instead of creating views.
  *   const jsRecordBatch = parseRecordBatch(
  *     wasmMemory.buffer,
  *     wasmTable.arrayAddr(i),
  *     wasmTable.schemaAddr(),
  *     true
  *   );
  *   jsBatches.push(jsRecordBatch);
  * }
  * const jsTable = new arrow.Table(jsBatches);
  * ```
  *
  * @param chunk number The chunk index to use
  * @returns number pointer to an ArrowArray FFI struct in Wasm memory
  * @param {number} chunk
  * @returns {number}
  */
  arrayAddr(t) {
    return wasm.ffitable_arrayAddr(this.__wbg_ptr, t) >>> 0;
  }
  /**
  * @returns {Uint32Array}
  */
  arrayAddrs() {
    try {
      const k = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.ffitable_arrayAddrs(k, this.__wbg_ptr);
      var t = getInt32Memory0()[k / 4 + 0], g = getInt32Memory0()[k / 4 + 1], d = getArrayU32FromWasm0(t, g).slice();
      return wasm.__wbindgen_free(t, g * 4, 4), d;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  */
  drop() {
    const t = this.__destroy_into_raw();
    wasm.ffitable_drop(t);
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((n) => wasm.__wbg_ffivector_free(n >>> 0));
const FileMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_filemetadata_free(n >>> 0));
class FileMetaData {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(FileMetaData.prototype);
    return g.__wbg_ptr = t, FileMetaDataFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FileMetaDataFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_filemetadata_free(t);
  }
  /**
  * Returns version of this file.
  * @returns {number}
  */
  version() {
    return wasm.filemetadata_version(this.__wbg_ptr);
  }
  /**
  * Returns number of rows in the file.
  * @returns {number}
  */
  numRows() {
    return wasm.filemetadata_numRows(this.__wbg_ptr);
  }
  /**
  * String message for application that wrote this file.
  *
  * This should have the following format:
  * `<application> version <application version> (build <application build hash>)`.
  *
  * ```shell
  * parquet-mr version 1.8.0 (build 0fda28af84b9746396014ad6a415b90592a98b3b)
  * ```
  * @returns {string | undefined}
  */
  createdBy() {
    try {
      const d = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.filemetadata_createdBy(d, this.__wbg_ptr);
      var t = getInt32Memory0()[d / 4 + 0], g = getInt32Memory0()[d / 4 + 1];
      let k;
      return t !== 0 && (k = getStringFromWasm0(t, g).slice(), wasm.__wbindgen_free(t, g * 1, 1)), k;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Returns key_value_metadata of this file.
  * @returns {Map<any, any>}
  */
  keyValueMetadata() {
    try {
      const k = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.filemetadata_keyValueMetadata(k, this.__wbg_ptr);
      var t = getInt32Memory0()[k / 4 + 0], g = getInt32Memory0()[k / 4 + 1], d = getInt32Memory0()[k / 4 + 2];
      if (d)
        throw takeObject(g);
      return takeObject(t);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((n) => wasm.__wbg_intounderlyingbytesource_free(n >>> 0));
typeof FinalizationRegistry > "u" || new FinalizationRegistry((n) => wasm.__wbg_intounderlyingsink_free(n >>> 0));
const IntoUnderlyingSourceFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_intounderlyingsource_free(n >>> 0));
class IntoUnderlyingSource {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(IntoUnderlyingSource.prototype);
    return g.__wbg_ptr = t, IntoUnderlyingSourceFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, IntoUnderlyingSourceFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_intounderlyingsource_free(t);
  }
  /**
  * @param {ReadableStreamDefaultController} controller
  * @returns {Promise<any>}
  */
  pull(t) {
    const g = wasm.intounderlyingsource_pull(this.__wbg_ptr, addHeapObject(t));
    return takeObject(g);
  }
  /**
  */
  cancel() {
    const t = this.__destroy_into_raw();
    wasm.intounderlyingsource_cancel(t);
  }
}
const ParquetFileFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_parquetfile_free(n >>> 0));
class ParquetFile {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(ParquetFile.prototype);
    return g.__wbg_ptr = t, ParquetFileFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ParquetFileFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_parquetfile_free(t);
  }
  /**
  * Construct a ParquetFile from a new URL.
  *
  * @param options The options to pass into `object-store`'s [`parse_url_opts`][parse_url_opts]
  *
  * [parse_url_opts]: https://docs.rs/object_store/latest/object_store/fn.parse_url_opts.html
  * @param {string} url
  * @param {Map<any, any> | undefined} [options]
  * @returns {Promise<ParquetFile>}
  */
  static fromUrl(t, g) {
    const d = passStringToWasm0(t, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), k = WASM_VECTOR_LEN, H = wasm.parquetfile_fromUrl(d, k, isLikeNone(g) ? 0 : addHeapObject(g));
    return takeObject(H);
  }
  /**
  * Construct a ParquetFile from a new [Blob] or [File] handle.
  *
  * [Blob]: https://developer.mozilla.org/en-US/docs/Web/API/Blob
  * [File]: https://developer.mozilla.org/en-US/docs/Web/API/File
  *
  * Safety: Do not use this in a multi-threaded environment,
  * (transitively depends on `!Send` `web_sys::Blob`)
  * @param {Blob} handle
  * @returns {Promise<ParquetFile>}
  */
  static fromFile(t) {
    const g = wasm.parquetfile_fromFile(addHeapObject(t));
    return takeObject(g);
  }
  /**
  * @returns {ParquetMetaData}
  */
  metadata() {
    try {
      const k = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.parquetfile_metadata(k, this.__wbg_ptr);
      var t = getInt32Memory0()[k / 4 + 0], g = getInt32Memory0()[k / 4 + 1], d = getInt32Memory0()[k / 4 + 2];
      if (d)
        throw takeObject(g);
      return ParquetMetaData.__wrap(t);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Read from the Parquet file in an async fashion.
  *
  * @param options
  *
  *    Options for reading Parquet data. Optional keys include:
  *
  *    - `batchSize`: The number of rows in each batch. If not provided, the upstream parquet
  *           default is 1024.
  *    - `rowGroups`: Only read data from the provided row group indexes.
  *    - `limit`: Provide a limit to the number of rows to be read.
  *    - `offset`: Provide an offset to skip over the given number of rows.
  *    - `columns`: The column names from the file to read.
  * @param {ReaderOptions | undefined} [options]
  * @returns {Promise<Table>}
  */
  read(t) {
    const g = wasm.parquetfile_read(this.__wbg_ptr, isLikeNone(t) ? 0 : addHeapObject(t));
    return takeObject(g);
  }
  /**
  * Create a readable stream of record batches.
  *
  * Each item in the stream will be a {@linkcode RecordBatch}.
  *
  * @param options
  *
  *    Options for reading Parquet data. Optional keys include:
  *
  *    - `batchSize`: The number of rows in each batch. If not provided, the upstream parquet
  *           default is 1024.
  *    - `rowGroups`: Only read data from the provided row group indexes.
  *    - `limit`: Provide a limit to the number of rows to be read.
  *    - `offset`: Provide an offset to skip over the given number of rows.
  *    - `columns`: The column names from the file to read.
  *    - `concurrency`: The number of concurrent requests to make
  * @param {ReaderOptions | undefined} [options]
  * @returns {Promise<ReadableStream>}
  */
  stream(t) {
    const g = wasm.parquetfile_stream(this.__wbg_ptr, isLikeNone(t) ? 0 : addHeapObject(t));
    return takeObject(g);
  }
}
const ParquetMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_parquetmetadata_free(n >>> 0));
class ParquetMetaData {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(ParquetMetaData.prototype);
    return g.__wbg_ptr = t, ParquetMetaDataFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ParquetMetaDataFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_parquetmetadata_free(t);
  }
  /**
  * Returns file metadata as reference.
  * @returns {FileMetaData}
  */
  fileMetadata() {
    const t = wasm.parquetmetadata_fileMetadata(this.__wbg_ptr);
    return FileMetaData.__wrap(t);
  }
  /**
  * Returns number of row groups in this file.
  * @returns {number}
  */
  numRowGroups() {
    return wasm.parquetmetadata_numRowGroups(this.__wbg_ptr) >>> 0;
  }
  /**
  * Returns row group metadata for `i`th position.
  * Position should be less than number of row groups `num_row_groups`.
  * @param {number} i
  * @returns {RowGroupMetaData}
  */
  rowGroup(t) {
    const g = wasm.parquetmetadata_rowGroup(this.__wbg_ptr, t);
    return RowGroupMetaData.__wrap(g);
  }
  /**
  * Returns row group metadata for all row groups
  * @returns {(RowGroupMetaData)[]}
  */
  rowGroups() {
    try {
      const k = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.parquetmetadata_rowGroups(k, this.__wbg_ptr);
      var t = getInt32Memory0()[k / 4 + 0], g = getInt32Memory0()[k / 4 + 1], d = getArrayJsValueFromWasm0(t, g).slice();
      return wasm.__wbindgen_free(t, g * 4, 4), d;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
const RecordBatchFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_recordbatch_free(n >>> 0));
class RecordBatch {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(RecordBatch.prototype);
    return g.__wbg_ptr = t, RecordBatchFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, RecordBatchFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_recordbatch_free(t);
  }
  /**
  * The number of rows in this RecordBatch.
  * @returns {number}
  */
  get numRows() {
    return wasm.recordbatch_numRows(this.__wbg_ptr) >>> 0;
  }
  /**
  * The number of columns in this RecordBatch.
  * @returns {number}
  */
  get numColumns() {
    return wasm.recordbatch_numColumns(this.__wbg_ptr) >>> 0;
  }
  /**
  * The {@linkcode Schema} of this RecordBatch.
  * @returns {Schema}
  */
  get schema() {
    const t = wasm.recordbatch_schema(this.__wbg_ptr);
    return Schema$2.__wrap(t);
  }
  /**
  * Export this RecordBatch to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does not consume** the RecordBatch, so you must remember to call {@linkcode
  * RecordBatch.free} to release the resources. The underlying arrays are reference counted, so
  * this method does not copy data, it only prevents the data from being released.
  * @returns {FFIRecordBatch}
  */
  toFFI() {
    try {
      const k = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.recordbatch_toFFI(k, this.__wbg_ptr);
      var t = getInt32Memory0()[k / 4 + 0], g = getInt32Memory0()[k / 4 + 1], d = getInt32Memory0()[k / 4 + 2];
      if (d)
        throw takeObject(g);
      return FFIRecordBatch.__wrap(t);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Export this RecordBatch to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does consume** the RecordBatch, so the original RecordBatch will be
  * inaccessible after this call. You must still call {@linkcode FFIRecordBatch.free} after
  * you've finished using the FFIRecordBatch.
  * @returns {FFIRecordBatch}
  */
  intoFFI() {
    try {
      const k = this.__destroy_into_raw(), H = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.recordbatch_intoFFI(H, k);
      var t = getInt32Memory0()[H / 4 + 0], g = getInt32Memory0()[H / 4 + 1], d = getInt32Memory0()[H / 4 + 2];
      if (d)
        throw takeObject(g);
      return FFIRecordBatch.__wrap(t);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Consume this RecordBatch and convert to an Arrow IPC Stream buffer
  * @returns {Uint8Array}
  */
  intoIPCStream() {
    try {
      const AA = this.__destroy_into_raw(), gA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.recordbatch_intoIPCStream(gA, AA);
      var t = getInt32Memory0()[gA / 4 + 0], g = getInt32Memory0()[gA / 4 + 1], d = getInt32Memory0()[gA / 4 + 2], k = getInt32Memory0()[gA / 4 + 3];
      if (k)
        throw takeObject(d);
      var H = getArrayU8FromWasm0(t, g).slice();
      return wasm.__wbindgen_free(t, g * 1, 1), H;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Override the schema of this [`RecordBatch`]
  *
  * Returns an error if `schema` is not a superset of the current schema
  * as determined by [`Schema::contains`]
  * @param {Schema} schema
  * @returns {RecordBatch}
  */
  withSchema(t) {
    try {
      const AA = wasm.__wbindgen_add_to_stack_pointer(-16);
      _assertClass(t, Schema$2);
      var g = t.__destroy_into_raw();
      wasm.recordbatch_withSchema(AA, this.__wbg_ptr, g);
      var d = getInt32Memory0()[AA / 4 + 0], k = getInt32Memory0()[AA / 4 + 1], H = getInt32Memory0()[AA / 4 + 2];
      if (H)
        throw takeObject(k);
      return RecordBatch.__wrap(d);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Return a new RecordBatch where each column is sliced
  * according to `offset` and `length`
  * @param {number} offset
  * @param {number} length
  * @returns {RecordBatch}
  */
  slice(t, g) {
    const d = wasm.recordbatch_slice(this.__wbg_ptr, t, g);
    return RecordBatch.__wrap(d);
  }
  /**
  * Returns the total number of bytes of memory occupied physically by this batch.
  * @returns {number}
  */
  getArrayMemorySize() {
    return wasm.recordbatch_getArrayMemorySize(this.__wbg_ptr) >>> 0;
  }
}
const RowGroupMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_rowgroupmetadata_free(n >>> 0));
class RowGroupMetaData {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(RowGroupMetaData.prototype);
    return g.__wbg_ptr = t, RowGroupMetaDataFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, RowGroupMetaDataFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_rowgroupmetadata_free(t);
  }
  /**
  * Number of columns in this row group.
  * @returns {number}
  */
  numColumns() {
    return wasm.rowgroupmetadata_numColumns(this.__wbg_ptr) >>> 0;
  }
  /**
  * Returns column chunk metadata for `i`th column.
  * @param {number} i
  * @returns {ColumnChunkMetaData}
  */
  column(t) {
    const g = wasm.rowgroupmetadata_column(this.__wbg_ptr, t);
    return ColumnChunkMetaData.__wrap(g);
  }
  /**
  * Returns column chunk metadata for all columns
  * @returns {(ColumnChunkMetaData)[]}
  */
  columns() {
    try {
      const k = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.rowgroupmetadata_columns(k, this.__wbg_ptr);
      var t = getInt32Memory0()[k / 4 + 0], g = getInt32Memory0()[k / 4 + 1], d = getArrayJsValueFromWasm0(t, g).slice();
      return wasm.__wbindgen_free(t, g * 4, 4), d;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Number of rows in this row group.
  * @returns {number}
  */
  numRows() {
    return wasm.rowgroupmetadata_numRows(this.__wbg_ptr);
  }
  /**
  * Total byte size of all uncompressed column data in this row group.
  * @returns {number}
  */
  totalByteSize() {
    return wasm.rowgroupmetadata_totalByteSize(this.__wbg_ptr);
  }
  /**
  * Total size of all compressed column data in this row group.
  * @returns {number}
  */
  compressedSize() {
    return wasm.rowgroupmetadata_compressedSize(this.__wbg_ptr);
  }
}
const SchemaFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_schema_free(n >>> 0));
let Schema$2 = class OI {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(OI.prototype);
    return g.__wbg_ptr = t, SchemaFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, SchemaFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_schema_free(t);
  }
  /**
  * Export this schema to an FFIArrowSchema object, which can be read with arrow-js-ffi.
  *
  * This method **does not consume** the Schema, so you must remember to call {@linkcode
  * Schema.free} to release the resources. The underlying arrays are reference counted, so
  * this method does not copy data, it only prevents the data from being released.
  * @returns {FFIArrowSchema}
  */
  toFFI() {
    try {
      const k = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_toFFI(k, this.__wbg_ptr);
      var t = getInt32Memory0()[k / 4 + 0], g = getInt32Memory0()[k / 4 + 1], d = getInt32Memory0()[k / 4 + 2];
      if (d)
        throw takeObject(g);
      return FFIArrowSchema.__wrap(t);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Export this Table to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does consume** the Table, so the original Table will be
  * inaccessible after this call. You must still call {@linkcode FFITable.free} after
  * you've finished using the FFITable.
  * @returns {FFIArrowSchema}
  */
  intoFFI() {
    try {
      const k = this.__destroy_into_raw(), H = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_intoFFI(H, k);
      var t = getInt32Memory0()[H / 4 + 0], g = getInt32Memory0()[H / 4 + 1], d = getInt32Memory0()[H / 4 + 2];
      if (d)
        throw takeObject(g);
      return FFIArrowSchema.__wrap(t);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Consume this schema and convert to an Arrow IPC Stream buffer
  * @returns {Uint8Array}
  */
  intoIPCStream() {
    try {
      const AA = this.__destroy_into_raw(), gA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_intoIPCStream(gA, AA);
      var t = getInt32Memory0()[gA / 4 + 0], g = getInt32Memory0()[gA / 4 + 1], d = getInt32Memory0()[gA / 4 + 2], k = getInt32Memory0()[gA / 4 + 3];
      if (k)
        throw takeObject(d);
      var H = getArrayU8FromWasm0(t, g).slice();
      return wasm.__wbindgen_free(t, g * 1, 1), H;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Sets the metadata of this `Schema` to be `metadata` and returns a new object
  * @param {SchemaMetadata} metadata
  * @returns {Schema}
  */
  withMetadata(t) {
    try {
      const H = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_withMetadata(H, this.__wbg_ptr, addHeapObject(t));
      var g = getInt32Memory0()[H / 4 + 0], d = getInt32Memory0()[H / 4 + 1], k = getInt32Memory0()[H / 4 + 2];
      if (k)
        throw takeObject(d);
      return OI.__wrap(g);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Find the index of the column with the given name.
  * @param {string} name
  * @returns {number}
  */
  indexOf(t) {
    try {
      const H = wasm.__wbindgen_add_to_stack_pointer(-16), AA = passStringToWasm0(t, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), gA = WASM_VECTOR_LEN;
      wasm.schema_indexOf(H, this.__wbg_ptr, AA, gA);
      var g = getInt32Memory0()[H / 4 + 0], d = getInt32Memory0()[H / 4 + 1], k = getInt32Memory0()[H / 4 + 2];
      if (k)
        throw takeObject(d);
      return g >>> 0;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Returns an immutable reference to the Map of custom metadata key-value pairs.
  * @returns {SchemaMetadata}
  */
  metadata() {
    try {
      const k = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_metadata(k, this.__wbg_ptr);
      var t = getInt32Memory0()[k / 4 + 0], g = getInt32Memory0()[k / 4 + 1], d = getInt32Memory0()[k / 4 + 2];
      if (d)
        throw takeObject(g);
      return takeObject(t);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
};
const TableFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_table_free(n >>> 0));
class Table {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(Table.prototype);
    return g.__wbg_ptr = t, TableFinalization.register(g, g.__wbg_ptr, g), g;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, TableFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_table_free(t);
  }
  /**
  * Access the Table's {@linkcode Schema}.
  * @returns {Schema}
  */
  get schema() {
    const t = wasm.table_schema(this.__wbg_ptr);
    return Schema$2.__wrap(t);
  }
  /**
  * The number of batches in the Table
  * @returns {number}
  */
  get numBatches() {
    return wasm.table_numBatches(this.__wbg_ptr) >>> 0;
  }
  /**
  * Export this Table to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does not consume** the Table, so you must remember to call {@linkcode
  * Table.free} to release the resources. The underlying arrays are reference counted, so
  * this method does not copy data, it only prevents the data from being released.
  * @returns {FFITable}
  */
  toFFI() {
    try {
      const k = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.table_toFFI(k, this.__wbg_ptr);
      var t = getInt32Memory0()[k / 4 + 0], g = getInt32Memory0()[k / 4 + 1], d = getInt32Memory0()[k / 4 + 2];
      if (d)
        throw takeObject(g);
      return FFITable.__wrap(t);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Export this Table to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does consume** the Table, so the original Table will be
  * inaccessible after this call. You must still call {@linkcode FFITable.free} after
  * you've finished using the FFITable.
  * @returns {FFITable}
  */
  intoFFI() {
    try {
      const k = this.__destroy_into_raw(), H = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.table_intoFFI(H, k);
      var t = getInt32Memory0()[H / 4 + 0], g = getInt32Memory0()[H / 4 + 1], d = getInt32Memory0()[H / 4 + 2];
      if (d)
        throw takeObject(g);
      return FFITable.__wrap(t);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Consume this table and convert to an Arrow IPC Stream buffer
  * @returns {Uint8Array}
  */
  intoIPCStream() {
    try {
      const AA = this.__destroy_into_raw(), gA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.table_intoIPCStream(gA, AA);
      var t = getInt32Memory0()[gA / 4 + 0], g = getInt32Memory0()[gA / 4 + 1], d = getInt32Memory0()[gA / 4 + 2], k = getInt32Memory0()[gA / 4 + 3];
      if (k)
        throw takeObject(d);
      var H = getArrayU8FromWasm0(t, g).slice();
      return wasm.__wbindgen_free(t, g * 1, 1), H;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Create a table from an Arrow IPC Stream buffer
  * @param {Uint8Array} buf
  * @returns {Table}
  */
  static fromIPCStream(t) {
    try {
      const H = wasm.__wbindgen_add_to_stack_pointer(-16), AA = passArray8ToWasm0(t, wasm.__wbindgen_malloc), gA = WASM_VECTOR_LEN;
      wasm.table_fromIPCStream(H, AA, gA);
      var g = getInt32Memory0()[H / 4 + 0], d = getInt32Memory0()[H / 4 + 1], k = getInt32Memory0()[H / 4 + 2];
      if (k)
        throw takeObject(d);
      return Table.__wrap(g);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Returns the total number of bytes of memory occupied physically by all batches in this
  * table.
  * @returns {number}
  */
  getArrayMemorySize() {
    return wasm.table_getArrayMemorySize(this.__wbg_ptr) >>> 0;
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((n) => wasm.__wbg_wasmgetoptions_free(n >>> 0));
const WasmObjectMetaFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((n) => wasm.__wbg_wasmobjectmeta_free(n >>> 0));
class WasmObjectMeta {
  static __wrap(t) {
    t = t >>> 0;
    const g = Object.create(WasmObjectMeta.prototype);
    return g.__wbg_ptr = t, WasmObjectMetaFinalization.register(g, g.__wbg_ptr, g), g;
  }
  toJSON() {
    return {
      location: this.location,
      last_modified: this.last_modified,
      size: this.size,
      e_tag: this.e_tag,
      version: this.version
    };
  }
  toString() {
    return JSON.stringify(this);
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, WasmObjectMetaFinalization.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    wasm.__wbg_wasmobjectmeta_free(t);
  }
  /**
  * The full path to the object
  * @returns {string}
  */
  get location() {
    let t, g;
    try {
      const H = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_wasmobjectmeta_location(H, this.__wbg_ptr);
      var d = getInt32Memory0()[H / 4 + 0], k = getInt32Memory0()[H / 4 + 1];
      return t = d, g = k, getStringFromWasm0(d, k);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16), wasm.__wbindgen_free(t, g, 1);
    }
  }
  /**
  * The full path to the object
  * @param {string} arg0
  */
  set location(t) {
    const g = passStringToWasm0(t, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), d = WASM_VECTOR_LEN;
    wasm.__wbg_set_wasmobjectmeta_location(this.__wbg_ptr, g, d);
  }
  /**
  * The last modified time
  * @returns {Date}
  */
  get last_modified() {
    const t = wasm.__wbg_get_wasmobjectmeta_last_modified(this.__wbg_ptr);
    return takeObject(t);
  }
  /**
  * The last modified time
  * @param {Date} arg0
  */
  set last_modified(t) {
    wasm.__wbg_set_wasmobjectmeta_last_modified(this.__wbg_ptr, addHeapObject(t));
  }
  /**
  * The size in bytes of the object
  * @returns {number}
  */
  get size() {
    return wasm.__wbg_get_wasmobjectmeta_size(this.__wbg_ptr) >>> 0;
  }
  /**
  * The size in bytes of the object
  * @param {number} arg0
  */
  set size(t) {
    wasm.__wbg_set_wasmobjectmeta_size(this.__wbg_ptr, t);
  }
  /**
  * The unique identifier for the object
  *
  * <https://datatracker.ietf.org/doc/html/rfc9110#name-etag>
  * @returns {string | undefined}
  */
  get e_tag() {
    try {
      const d = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_wasmobjectmeta_e_tag(d, this.__wbg_ptr);
      var t = getInt32Memory0()[d / 4 + 0], g = getInt32Memory0()[d / 4 + 1];
      let k;
      return t !== 0 && (k = getStringFromWasm0(t, g).slice(), wasm.__wbindgen_free(t, g * 1, 1)), k;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * The unique identifier for the object
  *
  * <https://datatracker.ietf.org/doc/html/rfc9110#name-etag>
  * @param {string | undefined} [arg0]
  */
  set e_tag(t) {
    var g = isLikeNone(t) ? 0 : passStringToWasm0(t, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), d = WASM_VECTOR_LEN;
    wasm.__wbg_set_wasmobjectmeta_e_tag(this.__wbg_ptr, g, d);
  }
  /**
  * A version indicator for this object
  * @returns {string | undefined}
  */
  get version() {
    try {
      const d = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_wasmobjectmeta_version(d, this.__wbg_ptr);
      var t = getInt32Memory0()[d / 4 + 0], g = getInt32Memory0()[d / 4 + 1];
      let k;
      return t !== 0 && (k = getStringFromWasm0(t, g).slice(), wasm.__wbindgen_free(t, g * 1, 1)), k;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * A version indicator for this object
  * @param {string | undefined} [arg0]
  */
  set version(t) {
    var g = isLikeNone(t) ? 0 : passStringToWasm0(t, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), d = WASM_VECTOR_LEN;
    wasm.__wbg_set_wasmobjectmeta_version(this.__wbg_ptr, g, d);
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((n) => wasm.__wbg_wasmobjectstore_free(n >>> 0));
typeof FinalizationRegistry > "u" || new FinalizationRegistry((n) => wasm.__wbg_writerproperties_free(n >>> 0));
typeof FinalizationRegistry > "u" || new FinalizationRegistry((n) => wasm.__wbg_writerpropertiesbuilder_free(n >>> 0));
async function __wbg_load(n, t) {
  if (typeof Response == "function" && n instanceof Response) {
    if (typeof WebAssembly.instantiateStreaming == "function")
      try {
        return await WebAssembly.instantiateStreaming(n, t);
      } catch (d) {
        if (n.headers.get("Content-Type") != "application/wasm")
          console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", d);
        else
          throw d;
      }
    const g = await n.arrayBuffer();
    return await WebAssembly.instantiate(g, t);
  } else {
    const g = await WebAssembly.instantiate(n, t);
    return g instanceof WebAssembly.Instance ? { instance: g, module: n } : g;
  }
}
function __wbg_get_imports() {
  const n = {};
  return n.wbg = {}, n.wbg.__wbindgen_number_new = function(t) {
    return addHeapObject(t);
  }, n.wbg.__wbg_columnchunkmetadata_new = function(t) {
    const g = ColumnChunkMetaData.__wrap(t);
    return addHeapObject(g);
  }, n.wbg.__wbg_rowgroupmetadata_new = function(t) {
    const g = RowGroupMetaData.__wrap(t);
    return addHeapObject(g);
  }, n.wbg.__wbg_parquetfile_new = function(t) {
    const g = ParquetFile.__wrap(t);
    return addHeapObject(g);
  }, n.wbg.__wbindgen_object_drop_ref = function(t) {
    takeObject(t);
  }, n.wbg.__wbindgen_object_clone_ref = function(t) {
    const g = getObject(t);
    return addHeapObject(g);
  }, n.wbg.__wbindgen_error_new = function(t, g) {
    const d = new Error(getStringFromWasm0(t, g));
    return addHeapObject(d);
  }, n.wbg.__wbindgen_is_undefined = function(t) {
    return getObject(t) === void 0;
  }, n.wbg.__wbindgen_in = function(t, g) {
    return getObject(t) in getObject(g);
  }, n.wbg.__wbindgen_is_bigint = function(t) {
    return typeof getObject(t) == "bigint";
  }, n.wbg.__wbindgen_bigint_from_u64 = function(t) {
    const g = BigInt.asUintN(64, t);
    return addHeapObject(g);
  }, n.wbg.__wbindgen_jsval_eq = function(t, g) {
    return getObject(t) === getObject(g);
  }, n.wbg.__wbindgen_is_object = function(t) {
    const g = getObject(t);
    return typeof g == "object" && g !== null;
  }, n.wbg.__wbindgen_string_new = function(t, g) {
    const d = getStringFromWasm0(t, g);
    return addHeapObject(d);
  }, n.wbg.__wbindgen_number_get = function(t, g) {
    const d = getObject(g), k = typeof d == "number" ? d : void 0;
    getFloat64Memory0()[t / 8 + 1] = isLikeNone(k) ? 0 : k, getInt32Memory0()[t / 4 + 0] = !isLikeNone(k);
  }, n.wbg.__wbg_fetch_1db5b0ae726d68b5 = function(t) {
    const g = fetch(getObject(t));
    return addHeapObject(g);
  }, n.wbg.__wbg_wasmobjectmeta_new = function(t) {
    const g = WasmObjectMeta.__wrap(t);
    return addHeapObject(g);
  }, n.wbg.__wbindgen_string_get = function(t, g) {
    const d = getObject(g), k = typeof d == "string" ? d : void 0;
    var H = isLikeNone(k) ? 0 : passStringToWasm0(k, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), AA = WASM_VECTOR_LEN;
    getInt32Memory0()[t / 4 + 1] = AA, getInt32Memory0()[t / 4 + 0] = H;
  }, n.wbg.__wbg_fetch_bc7c8e27076a5c84 = function(t) {
    const g = fetch(getObject(t));
    return addHeapObject(g);
  }, n.wbg.__wbg_done_2ffa852272310e47 = function(t) {
    return getObject(t).done;
  }, n.wbg.__wbg_value_9f6eeb1e2aab8d96 = function(t) {
    const g = getObject(t).value;
    return addHeapObject(g);
  }, n.wbg.__wbg_newwithintounderlyingsource_a03a82aa1bbbb292 = function(t, g) {
    const d = new ReadableStream(IntoUnderlyingSource.__wrap(t), takeObject(g));
    return addHeapObject(d);
  }, n.wbg.__wbg_getReader_ab94afcb5cb7689a = function() {
    return handleError(function(t) {
      const g = getObject(t).getReader();
      return addHeapObject(g);
    }, arguments);
  }, n.wbg.__wbg_sethighWaterMark_ea50ed3ec2143088 = function(t, g) {
    getObject(t).highWaterMark = g;
  }, n.wbg.__wbg_recordbatch_new = function(t) {
    const g = RecordBatch.__wrap(t);
    return addHeapObject(g);
  }, n.wbg.__wbg_table_new = function(t) {
    const g = Table.__wrap(t);
    return addHeapObject(g);
  }, n.wbg.__wbindgen_jsval_loose_eq = function(t, g) {
    return getObject(t) == getObject(g);
  }, n.wbg.__wbindgen_boolean_get = function(t) {
    const g = getObject(t);
    return typeof g == "boolean" ? g ? 1 : 0 : 2;
  }, n.wbg.__wbindgen_as_number = function(t) {
    return +getObject(t);
  }, n.wbg.__wbg_String_b9412f8799faab3e = function(t, g) {
    const d = String(getObject(g)), k = passStringToWasm0(d, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), H = WASM_VECTOR_LEN;
    getInt32Memory0()[t / 4 + 1] = H, getInt32Memory0()[t / 4 + 0] = k;
  }, n.wbg.__wbg_getwithrefkey_edc2c8960f0f1191 = function(t, g) {
    const d = getObject(t)[getObject(g)];
    return addHeapObject(d);
  }, n.wbg.__wbg_set_f975102236d3c502 = function(t, g, d) {
    getObject(t)[takeObject(g)] = takeObject(d);
  }, n.wbg.__wbindgen_cb_drop = function(t) {
    const g = takeObject(t).original;
    return g.cnt-- == 1 ? (g.a = 0, !0) : !1;
  }, n.wbg.__wbg_queueMicrotask_481971b0d87f3dd4 = function(t) {
    queueMicrotask(getObject(t));
  }, n.wbg.__wbg_queueMicrotask_3cbae2ec6b6cd3d6 = function(t) {
    const g = getObject(t).queueMicrotask;
    return addHeapObject(g);
  }, n.wbg.__wbindgen_is_function = function(t) {
    return typeof getObject(t) == "function";
  }, n.wbg.__wbg_fetch_921fad6ef9e883dd = function(t, g) {
    const d = getObject(t).fetch(getObject(g));
    return addHeapObject(d);
  }, n.wbg.__wbg_new_ab6fd82b10560829 = function() {
    return handleError(function() {
      const t = new Headers();
      return addHeapObject(t);
    }, arguments);
  }, n.wbg.__wbg_append_7bfcb4937d1d5e29 = function() {
    return handleError(function(t, g, d, k, H) {
      getObject(t).append(getStringFromWasm0(g, d), getStringFromWasm0(k, H));
    }, arguments);
  }, n.wbg.__wbg_close_a994f9425dab445c = function() {
    return handleError(function(t) {
      getObject(t).close();
    }, arguments);
  }, n.wbg.__wbg_enqueue_ea194723156c0cc2 = function() {
    return handleError(function(t, g) {
      getObject(t).enqueue(getObject(g));
    }, arguments);
  }, n.wbg.__wbg_size_9c7e57fbd4f0f4b5 = function(t) {
    return getObject(t).size;
  }, n.wbg.__wbg_arrayBuffer_307ddd1bd1d04e23 = function(t) {
    const g = getObject(t).arrayBuffer();
    return addHeapObject(g);
  }, n.wbg.__wbg_slice_1991e6e71a6587f3 = function() {
    return handleError(function(t, g, d) {
      const k = getObject(t).slice(g, d);
      return addHeapObject(k);
    }, arguments);
  }, n.wbg.__wbg_read_e7d0f8a49be01d86 = function(t) {
    const g = getObject(t).read();
    return addHeapObject(g);
  }, n.wbg.__wbg_releaseLock_5c49db976c08b864 = function(t) {
    getObject(t).releaseLock();
  }, n.wbg.__wbg_cancel_6ee33d4006737aef = function(t) {
    const g = getObject(t).cancel();
    return addHeapObject(g);
  }, n.wbg.__wbg_byobRequest_72fca99f9c32c193 = function(t) {
    const g = getObject(t).byobRequest;
    return isLikeNone(g) ? 0 : addHeapObject(g);
  }, n.wbg.__wbg_close_184931724d961ccc = function() {
    return handleError(function(t) {
      getObject(t).close();
    }, arguments);
  }, n.wbg.__wbg_instanceof_Response_849eb93e75734b6e = function(t) {
    let g;
    try {
      g = getObject(t) instanceof Response;
    } catch {
      g = !1;
    }
    return g;
  }, n.wbg.__wbg_url_5f6dc4009ac5f99d = function(t, g) {
    const d = getObject(g).url, k = passStringToWasm0(d, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), H = WASM_VECTOR_LEN;
    getInt32Memory0()[t / 4 + 1] = H, getInt32Memory0()[t / 4 + 0] = k;
  }, n.wbg.__wbg_status_61a01141acd3cf74 = function(t) {
    return getObject(t).status;
  }, n.wbg.__wbg_headers_9620bfada380764a = function(t) {
    const g = getObject(t).headers;
    return addHeapObject(g);
  }, n.wbg.__wbg_body_9545a94f397829db = function(t) {
    const g = getObject(t).body;
    return isLikeNone(g) ? 0 : addHeapObject(g);
  }, n.wbg.__wbg_arrayBuffer_29931d52c7206b02 = function() {
    return handleError(function(t) {
      const g = getObject(t).arrayBuffer();
      return addHeapObject(g);
    }, arguments);
  }, n.wbg.__wbg_signal_a61f78a3478fd9bc = function(t) {
    const g = getObject(t).signal;
    return addHeapObject(g);
  }, n.wbg.__wbg_new_0d76b0581eca6298 = function() {
    return handleError(function() {
      const t = new AbortController();
      return addHeapObject(t);
    }, arguments);
  }, n.wbg.__wbg_abort_2aa7521d5690750e = function(t) {
    getObject(t).abort();
  }, n.wbg.__wbg_view_7f0ce470793a340f = function(t) {
    const g = getObject(t).view;
    return isLikeNone(g) ? 0 : addHeapObject(g);
  }, n.wbg.__wbg_respond_b1a43b2e3a06d525 = function() {
    return handleError(function(t, g) {
      getObject(t).respond(g >>> 0);
    }, arguments);
  }, n.wbg.__wbg_newwithstrandinit_3fd6fba4083ff2d0 = function() {
    return handleError(function(t, g, d) {
      const k = new Request(getStringFromWasm0(t, g), getObject(d));
      return addHeapObject(k);
    }, arguments);
  }, n.wbg.__wbg_get_bd8e338fbd5f5cc8 = function(t, g) {
    const d = getObject(t)[g >>> 0];
    return addHeapObject(d);
  }, n.wbg.__wbg_length_cd7af8117672b8b8 = function(t) {
    return getObject(t).length;
  }, n.wbg.__wbg_newnoargs_e258087cd0daa0ea = function(t, g) {
    const d = new Function(getStringFromWasm0(t, g));
    return addHeapObject(d);
  }, n.wbg.__wbg_new_d9bc3a0147634640 = function() {
    return addHeapObject(/* @__PURE__ */ new Map());
  }, n.wbg.__wbg_next_40fc327bfc8770e6 = function(t) {
    const g = getObject(t).next;
    return addHeapObject(g);
  }, n.wbg.__wbg_next_196c84450b364254 = function() {
    return handleError(function(t) {
      const g = getObject(t).next();
      return addHeapObject(g);
    }, arguments);
  }, n.wbg.__wbg_done_298b57d23c0fc80c = function(t) {
    return getObject(t).done;
  }, n.wbg.__wbg_value_d93c65011f51a456 = function(t) {
    const g = getObject(t).value;
    return addHeapObject(g);
  }, n.wbg.__wbg_iterator_2cee6dadfd956dfa = function() {
    return addHeapObject(Symbol.iterator);
  }, n.wbg.__wbg_get_e3c254076557e348 = function() {
    return handleError(function(t, g) {
      const d = Reflect.get(getObject(t), getObject(g));
      return addHeapObject(d);
    }, arguments);
  }, n.wbg.__wbg_call_27c0f87801dedf93 = function() {
    return handleError(function(t, g) {
      const d = getObject(t).call(getObject(g));
      return addHeapObject(d);
    }, arguments);
  }, n.wbg.__wbg_new_72fb9a18b5ae2624 = function() {
    const t = new Object();
    return addHeapObject(t);
  }, n.wbg.__wbindgen_is_string = function(t) {
    return typeof getObject(t) == "string";
  }, n.wbg.__wbg_self_ce0dbfc45cf2f5be = function() {
    return handleError(function() {
      const t = self.self;
      return addHeapObject(t);
    }, arguments);
  }, n.wbg.__wbg_window_c6fb939a7f436783 = function() {
    return handleError(function() {
      const t = window.window;
      return addHeapObject(t);
    }, arguments);
  }, n.wbg.__wbg_globalThis_d1e6af4856ba331b = function() {
    return handleError(function() {
      const t = globalThis.globalThis;
      return addHeapObject(t);
    }, arguments);
  }, n.wbg.__wbg_global_207b558942527489 = function() {
    return handleError(function() {
      const t = global.global;
      return addHeapObject(t);
    }, arguments);
  }, n.wbg.__wbg_isArray_2ab64d95e09ea0ae = function(t) {
    return Array.isArray(getObject(t));
  }, n.wbg.__wbg_instanceof_ArrayBuffer_836825be07d4c9d2 = function(t) {
    let g;
    try {
      g = getObject(t) instanceof ArrayBuffer;
    } catch {
      g = !1;
    }
    return g;
  }, n.wbg.__wbg_new_28c511d9baebfa89 = function(t, g) {
    const d = new Error(getStringFromWasm0(t, g));
    return addHeapObject(d);
  }, n.wbg.__wbg_call_b3ca7c6051f9bec1 = function() {
    return handleError(function(t, g, d) {
      const k = getObject(t).call(getObject(g), getObject(d));
      return addHeapObject(k);
    }, arguments);
  }, n.wbg.__wbg_set_8417257aaedc936b = function(t, g, d) {
    const k = getObject(t).set(getObject(g), getObject(d));
    return addHeapObject(k);
  }, n.wbg.__wbg_isSafeInteger_f7b04ef02296c4d2 = function(t) {
    return Number.isSafeInteger(getObject(t));
  }, n.wbg.__wbg_new_cf3ec55744a78578 = function(t) {
    const g = new Date(getObject(t));
    return addHeapObject(g);
  }, n.wbg.__wbg_entries_95cc2c823b285a09 = function(t) {
    const g = Object.entries(getObject(t));
    return addHeapObject(g);
  }, n.wbg.__wbg_new_81740750da40724f = function(t, g) {
    try {
      var d = { a: t, b: g }, k = (AA, gA) => {
        const IA = d.a;
        d.a = 0;
        try {
          return __wbg_adapter_285(IA, d.b, AA, gA);
        } finally {
          d.a = IA;
        }
      };
      const H = new Promise(k);
      return addHeapObject(H);
    } finally {
      d.a = d.b = 0;
    }
  }, n.wbg.__wbg_resolve_b0083a7967828ec8 = function(t) {
    const g = Promise.resolve(getObject(t));
    return addHeapObject(g);
  }, n.wbg.__wbg_catch_0260e338d10f79ae = function(t, g) {
    const d = getObject(t).catch(getObject(g));
    return addHeapObject(d);
  }, n.wbg.__wbg_then_0c86a60e8fcfe9f6 = function(t, g) {
    const d = getObject(t).then(getObject(g));
    return addHeapObject(d);
  }, n.wbg.__wbg_then_a73caa9a87991566 = function(t, g, d) {
    const k = getObject(t).then(getObject(g), getObject(d));
    return addHeapObject(k);
  }, n.wbg.__wbg_buffer_12d079cc21e14bdb = function(t) {
    const g = getObject(t).buffer;
    return addHeapObject(g);
  }, n.wbg.__wbg_newwithbyteoffsetandlength_aa4a17c33a06e5cb = function(t, g, d) {
    const k = new Uint8Array(getObject(t), g >>> 0, d >>> 0);
    return addHeapObject(k);
  }, n.wbg.__wbg_new_63b92bc8671ed464 = function(t) {
    const g = new Uint8Array(getObject(t));
    return addHeapObject(g);
  }, n.wbg.__wbg_set_a47bac70306a19a7 = function(t, g, d) {
    getObject(t).set(getObject(g), d >>> 0);
  }, n.wbg.__wbg_length_c20a40f15020d68a = function(t) {
    return getObject(t).length;
  }, n.wbg.__wbg_instanceof_Uint8Array_2b3bbecd033d19f6 = function(t) {
    let g;
    try {
      g = getObject(t) instanceof Uint8Array;
    } catch {
      g = !1;
    }
    return g;
  }, n.wbg.__wbg_newwithlength_e9b4878cebadb3d3 = function(t) {
    const g = new Uint8Array(t >>> 0);
    return addHeapObject(g);
  }, n.wbg.__wbg_newwithbyteoffset_27c6424791adc775 = function(t, g) {
    const d = new Uint8Array(getObject(t), g >>> 0);
    return addHeapObject(d);
  }, n.wbg.__wbg_buffer_dd7f74bc60f1faab = function(t) {
    const g = getObject(t).buffer;
    return addHeapObject(g);
  }, n.wbg.__wbg_byteLength_58f7b4fab1919d44 = function(t) {
    return getObject(t).byteLength;
  }, n.wbg.__wbg_byteOffset_81d60f7392524f62 = function(t) {
    return getObject(t).byteOffset;
  }, n.wbg.__wbg_stringify_8887fe74e1c50d81 = function() {
    return handleError(function(t) {
      const g = JSON.stringify(getObject(t));
      return addHeapObject(g);
    }, arguments);
  }, n.wbg.__wbg_has_0af94d20077affa2 = function() {
    return handleError(function(t, g) {
      return Reflect.has(getObject(t), getObject(g));
    }, arguments);
  }, n.wbg.__wbg_set_1f9b04f170055d33 = function() {
    return handleError(function(t, g, d) {
      return Reflect.set(getObject(t), getObject(g), getObject(d));
    }, arguments);
  }, n.wbg.__wbindgen_bigint_get_as_i64 = function(t, g) {
    const d = getObject(g), k = typeof d == "bigint" ? d : void 0;
    getBigInt64Memory0()[t / 8 + 1] = isLikeNone(k) ? BigInt(0) : k, getInt32Memory0()[t / 4 + 0] = !isLikeNone(k);
  }, n.wbg.__wbindgen_debug_string = function(t, g) {
    const d = debugString(getObject(g)), k = passStringToWasm0(d, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), H = WASM_VECTOR_LEN;
    getInt32Memory0()[t / 4 + 1] = H, getInt32Memory0()[t / 4 + 0] = k;
  }, n.wbg.__wbindgen_throw = function(t, g) {
    throw new Error(getStringFromWasm0(t, g));
  }, n.wbg.__wbindgen_memory = function() {
    const t = wasm.memory;
    return addHeapObject(t);
  }, n.wbg.__wbindgen_function_table = function() {
    const t = wasm.__wbindgen_export_2;
    return addHeapObject(t);
  }, n.wbg.__wbindgen_closure_wrapper13295 = function(t, g, d) {
    const k = makeMutClosure(t, g, 3248, __wbg_adapter_50);
    return addHeapObject(k);
  }, n;
}
function __wbg_finalize_init(n, t) {
  return wasm = n.exports, __wbg_init.__wbindgen_wasm_module = t, cachedBigInt64Memory0 = null, cachedFloat64Memory0 = null, cachedInt32Memory0 = null, cachedUint32Memory0 = null, cachedUint8Memory0 = null, wasm;
}
async function __wbg_init(n) {
  if (wasm !== void 0) return wasm;
  typeof n > "u" && (n = new URL("./assets/1b1a876c211e4f13.wasm", import.meta.url));
  const t = __wbg_get_imports();
  (typeof n == "string" || typeof Request == "function" && n instanceof Request || typeof URL == "function" && n instanceof URL) && (n = fetch(n));
  const { instance: g, module: d } = await __wbg_load(await n, t);
  return __wbg_finalize_init(g, d);
}
__wbg_init();
function isPandasRangeIndex(n) {
  return typeof n == "object" && n.kind === "range";
}
function parsePandasSchema(n) {
  const t = n.schema.metadata.get("pandas");
  if (!isNullOrUndefined$1(t))
    return JSON.parse(t);
}
function parsePandasIndexData(n, t) {
  return t ? t.index_columns.map((g) => {
    if (isPandasRangeIndex(g)) {
      const {
        start: k,
        stop: H,
        step: AA
      } = g;
      return range$6(k, H, AA);
    }
    const d = n.getChild(g);
    return d instanceof Vector && d.type instanceof Null ? null : d;
  }).filter((g) => g !== null) : [];
}
function parseHeaderName(n, t) {
  if (t === 1)
    return [n];
  try {
    return JSON.parse(n.trim().replace(/^\(/, "[").replace(/\)$/, "]").replace(/'/g, '"'));
  } catch {
    return [...Array(t - 1).fill(""), n];
  }
}
function parseColumnNames(n, t, g) {
  const d = t.concat(n);
  return unzip(d.map((k) => k.arrowField.name.startsWith("__index_level_") ? "" : k.arrowField.name).map((k) => (
    // If DataFrame `columns` has multi-level indexing, the length of
    // `column_indexes` will show how many levels there are.
    parseHeaderName(k, g?.column_indexes.length ?? 1)
  )));
}
function parseData$3(n, t) {
  const g = n.numRows, d = t.length;
  if (g === 0 || d === 0)
    return n.select([]);
  const k = t.map((H) => H.arrowField.name);
  return n.select(k);
}
function parsePandasIndexColumnTypes(n, t, g) {
  return t ? t.index_columns.map((k) => {
    if (isPandasRangeIndex(k)) {
      const AA = k.name || "";
      return {
        type: DataFrameCellType.INDEX,
        arrowField: new Field$2(AA, new Int_(!0, 64), !0),
        pandasType: {
          field_name: AA,
          name: AA,
          pandas_type: PandasRangeIndexType,
          numpy_type: PandasRangeIndexType,
          metadata: k
        }
      };
    }
    const H = n.fields.find((AA) => AA.name === k);
    if (!H)
      throw new Error(`Index field ${k} not found in arrow schema`);
    return {
      type: DataFrameCellType.INDEX,
      arrowField: H,
      pandasType: t.columns.find((AA) => AA.field_name === k),
      categoricalOptions: g[H.name]
    };
  }) : [];
}
function parseDataColumnTypes(n, t, g) {
  return n.fields.filter((H) => t ? !t.index_columns.includes(H.name) : !0).map((H) => ({
    type: DataFrameCellType.DATA,
    arrowField: H,
    pandasType: t?.columns.find((AA) => AA.field_name === H.name),
    categoricalOptions: g[H.name]
  }));
}
function parseCategoricalOptionsForColumns(n) {
  const t = {};
  return n.schema.fields.forEach((g, d) => {
    if (g.type instanceof Dictionary) {
      const k = n.getChildAt(d)?.data[0]?.dictionary;
      notNullOrUndefined(k) && (t[g.name] = convertVectorToList(k));
    }
  }), t;
}
function parseArrowIpcBytes(n) {
  const t = tableFromIPC(n && readParquet(n).intoIPCStream()), g = t.schema, d = parsePandasSchema(t), k = parseCategoricalOptionsForColumns(t), H = parsePandasIndexColumnTypes(g, d, k), AA = parseDataColumnTypes(g, d, k), gA = parseData$3(t, AA), IA = parsePandasIndexData(t, d), CA = parseColumnNames(AA, H, d);
  return {
    pandasIndexData: IA,
    data: gA,
    columnNames: CA,
    pandasIndexColumnTypes: H,
    dataColumnTypes: AA
  };
}
var _a;
_a = DRAFTABLE;
class Quiver {
  constructor(t) {
    this[_a] = !0;
    const {
      pandasIndexData: g,
      columnNames: d,
      data: k,
      dataColumnTypes: H,
      pandasIndexColumnTypes: AA
    } = parseArrowIpcBytes(t.data), gA = t.styler ? parseStyler(t.styler) : void 0;
    this._pandasIndexData = g, this._columnNames = d, this._data = k, this._dataColumnTypes = H, this._pandasIndexColumnTypes = AA, this._styler = gA, this._num_bytes = t.data?.length ?? 0, this._columnTypes = this._pandasIndexColumnTypes.concat(this._dataColumnTypes);
  }
  /** Matrix of column names of the index- & data-columns.
   *
   * This is a matrix to support multi-level headers.
   * Index columns only exist if the DataFrame was created based on a Pandas DataFrame.
   */
  get columnNames() {
    return this._columnNames;
  }
  /** List of column types for every index- & data-column. */
  get columnTypes() {
    return this._columnTypes;
  }
  /** Pandas Styler data. This will only be defined if the user styled the dataframe
   * via Pandas Styler.
   */
  get styler() {
    return this._styler;
  }
  /** Dimensions of the DataFrame. */
  get dimensions() {
    const t = this._pandasIndexColumnTypes.length || 0, g = this._columnNames.length || 1, d = this._data.numRows || 0, k = this._dataColumnTypes.length || 0, H = g + d, AA = t + k;
    return {
      numHeaderRows: g,
      numIndexColumns: t,
      numDataRows: d,
      numDataColumns: k,
      numRows: H,
      numColumns: AA
    };
  }
  /**
   * A hash that identifies the underlying data.
   *
   * This hash is based on various descriptive information
   * but is not 100% guaranteed to be unique.
   */
  get hash() {
    const t = [this.dimensions.numColumns, this.dimensions.numDataColumns, this.dimensions.numDataRows, this.dimensions.numIndexColumns, this.dimensions.numHeaderRows, this.dimensions.numRows, this._num_bytes, this._columnNames];
    return hashString(t.join("-"));
  }
  /** Return a single cell from an (Pandas) index- or data-column of the DataFrame.
   *
   * @param rowIndex - The row index of the cell (0 is the first data or index row excluding header rows)
   * @param columnIndex - The column index of the cell (0 is the first data or index column)
   * @returns The cell's content, type, and field.
   */
  getCell(t, g) {
    const {
      numIndexColumns: d,
      numDataRows: k,
      numColumns: H
    } = this.dimensions;
    if (t < 0 || t >= k)
      throw new Error(`Row index is out of range: ${t}`);
    if (g < 0 || g >= H)
      throw new Error(`Column index is out of range: ${g}`);
    if (g < d) {
      const BA = this._pandasIndexColumnTypes[g], eA = this.getIndexValue(t, g);
      return {
        type: DataFrameCellType.INDEX,
        content: eA,
        contentType: BA,
        field: BA.arrowField
      };
    }
    const gA = g - d, IA = this._dataColumnTypes[gA], CA = this.getDataValue(t, gA);
    return {
      type: DataFrameCellType.DATA,
      content: CA,
      contentType: IA,
      field: IA.arrowField
    };
  }
  /** Get the raw value of an index cell.
   *
   * Index columns only exist if the DataFrame was created based on a Pandas DataFrame.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  getIndexValue(t, g) {
    const d = this._pandasIndexData[g];
    return d instanceof Vector ? d.get(t) : d[t];
  }
  /** Get the raw value of a data cell. */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  getDataValue(t, g) {
    return this._data.getChildAt(g)?.get(t);
  }
  /**
   * Add the contents of another table (data + indexes) to this table.
   * Extra columns will not be created.
   */
  addRows(t) {
    if (this.styler || t.styler)
      throw new Error("\nUnsupported operation. `add_rows()` does not support Pandas Styler objects.\n\nIf you do not need the Styler's styles, try passing the `.data` attribute of\nthe Styler object instead to concatenate just the underlying dataframe.\n\nFor example:\n```\nst.add_rows(my_styler.data)\n```\n");
    if (t.dimensions.numDataRows === 0)
      return produce(this, (AA) => AA);
    if (this.dimensions.numDataRows === 0)
      return produce(t, (AA) => AA);
    const {
      index: g,
      data: d,
      indexTypes: k,
      dataTypes: H
    } = concat(this._dataColumnTypes, this._pandasIndexColumnTypes, this._pandasIndexData, this._data, t._dataColumnTypes, t._pandasIndexColumnTypes, t._pandasIndexData, t._data);
    return produce(this, (AA) => {
      AA._pandasIndexData = g, AA._data = d, AA._pandasIndexColumnTypes = k, AA._dataColumnTypes = H, AA._columnTypes = k.concat(H);
    });
  }
}
function parseStyler(n) {
  return {
    uuid: n.uuid,
    caption: n.caption,
    cssStyles: n.styles,
    cssId: n.uuid ? `T_${n.uuid}` : void 0,
    // Recursively create a new Quiver instance for Styler's display values.
    // This values will be used for rendering the DataFrame, while the original values
    // will be used for sorting, etc.
    displayValues: new Quiver({
      data: n.displayValues
    })
  };
}
function ensureError(n) {
  return n instanceof Error ? n : new Error(`${n}`);
}
const NO_SCRIPT_RUN_ID = "NO_SCRIPT_RUN_ID";
class ElementNode {
  /** Create a new ElementNode. */
  constructor(t, g, d, k, H) {
    this.element = t, this.metadata = g, this.scriptRunId = d, this.activeScriptHash = k, this.fragmentId = H;
  }
  get quiverElement() {
    if (this.lazyQuiverElement !== void 0)
      return this.lazyQuiverElement;
    if (this.element.type !== "arrowTable" && this.element.type !== "arrowDataFrame")
      throw new Error(`elementType '${this.element.type}' is not a valid Quiver element!`);
    const t = new Quiver(this.element[this.element.type]);
    return this.lazyQuiverElement = t, t;
  }
  get vegaLiteChartElement() {
    if (this.lazyVegaLiteChartElement !== void 0)
      return this.lazyVegaLiteChartElement;
    if (this.element.type !== "arrowVegaLiteChart")
      throw new Error(`elementType '${this.element.type}' is not a valid VegaLiteChartElement!`);
    const t = this.element.arrowVegaLiteChart, g = t.data ? new Quiver(t.data) : null, d = t.datasets.length > 0 ? wrapDatasets(t.datasets) : [], k = {
      data: g,
      spec: t.spec,
      datasets: d,
      useContainerWidth: t.useContainerWidth,
      vegaLiteTheme: t.theme,
      id: t.id,
      selectionMode: t.selectionMode,
      formId: t.formId
    };
    return this.lazyVegaLiteChartElement = k, k;
  }
  getIn() {
  }
  setIn() {
    throw new Error("'setIn' cannot be called on an ElementNode");
  }
  filterMainScriptElements(t) {
    if (this.activeScriptHash === t)
      return this;
  }
  clearStaleNodes(t, g, d) {
    return g?.length && (!this.fragmentId || !d || this.scriptRunId === t) ? this : this.scriptRunId === t ? this : void 0;
  }
  getElements(t) {
    return isNullOrUndefined$1(t) && (t = /* @__PURE__ */ new Set()), t.add(this.element), t;
  }
  arrowAddRows(t, g) {
    const d = this.element.type, k = new ElementNode(this.element, this.metadata, g, this.activeScriptHash, this.fragmentId);
    switch (d) {
      case "arrowTable":
      case "arrowDataFrame": {
        k.lazyQuiverElement = ElementNode.quiverAddRowsHelper(this.quiverElement, t);
        break;
      }
      case "arrowVegaLiteChart": {
        k.lazyVegaLiteChartElement = ElementNode.vegaLiteChartAddRowsHelper(this.vegaLiteChartElement, t);
        break;
      }
      default:
        throw new Error(`elementType '${this.element.type}' is not a valid arrowAddRows target!`);
    }
    return k;
  }
  static quiverAddRowsHelper(t, g) {
    if (g.hasName)
      throw new Error("Add rows cannot be used with a named dataset for this element.");
    const d = new Quiver(g.data);
    return t.addRows(d);
  }
  static vegaLiteChartAddRowsHelper(t, g) {
    const d = g.hasName ? g.name : null, k = new Quiver(g.data);
    return produce(t, (H) => {
      const AA = getNamedDataSet(H.datasets, d);
      AA ? AA.data = AA.data.addRows(k) : H.data = H.data ? H.data.addRows(k) : k;
    });
  }
}
function getNamedDataSet(n, t) {
  return n.length === 1 ? n[0] : n.find((g) => g.hasName && g.name === t);
}
class BlockNode {
  constructor(t, g, d, k, H, AA) {
    this.activeScriptHash = t, this.children = g ?? [], this.deltaBlock = d ?? new Block$2({}), this.scriptRunId = k ?? NO_SCRIPT_RUN_ID, this.fragmentId = H, this.deltaMsgReceivedAt = AA;
  }
  /** True if this Block has no children. */
  get isEmpty() {
    return this.children.length === 0;
  }
  getIn(t) {
    if (t.length === 0)
      return;
    const g = t[0];
    if (!(g < 0 || g >= this.children.length))
      return t.length === 1 ? this.children[g] : this.children[g].getIn(t.slice(1));
  }
  setIn(t, g, d) {
    if (t.length === 0)
      throw new Error("empty path!");
    const k = t[0];
    if (k < 0 || k > this.children.length)
      throw new Error(`Bad 'setIn' index ${k} (should be between [0, ${this.children.length}])`);
    const H = this.children.slice();
    return t.length === 1 ? H[k] = g : H[k] = H[k].setIn(t.slice(1), g, d), new BlockNode(this.activeScriptHash, H, this.deltaBlock, d, this.fragmentId, this.deltaMsgReceivedAt);
  }
  filterMainScriptElements(t) {
    if (this.activeScriptHash !== t)
      return;
    const g = this.children.map((d) => d.filterMainScriptElements(t)).filter(notUndefined);
    return new BlockNode(this.activeScriptHash, g, this.deltaBlock, this.scriptRunId, this.fragmentId, this.deltaMsgReceivedAt);
  }
  clearStaleNodes(t, g, d) {
    if (g?.length) {
      if (d && this.scriptRunId !== t)
        return;
      this.fragmentId && g.includes(this.fragmentId) && this.scriptRunId === t && (d = this.fragmentId);
    } else if (this.scriptRunId !== t)
      return;
    const k = this.children.map((H) => H.clearStaleNodes(t, g, d)).filter(notUndefined);
    return new BlockNode(this.activeScriptHash, k, this.deltaBlock, t, this.fragmentId, this.deltaMsgReceivedAt);
  }
  getElements(t) {
    isNullOrUndefined$1(t) && (t = /* @__PURE__ */ new Set());
    for (const g of this.children)
      g.getElements(t);
    return t;
  }
}
class AppRoot {
  /**
   * Create an empty AppRoot with a placeholder "skeleton" element.
   */
  static empty(t = "", g = !0, d, k) {
    const H = [];
    let AA;
    switch (getLoadingScreenType()) {
      case LoadingScreenType.NONE:
        break;
      case LoadingScreenType.V1:
        g && (AA = makeElementWithInfoText("Please wait..."));
        break;
      default:
        AA = makeAppSkeletonElement();
    }
    AA && H.push(new ElementNode(AA, ForwardMsgMetadata.create({}), NO_SCRIPT_RUN_ID, t));
    const gA = new BlockNode(t, H, new Block$2({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), IA = d || new BlockNode(t, [], new Block$2({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), CA = new BlockNode(t, [], new Block$2({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), BA = new BlockNode(t, [], new Block$2({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), eA = k ? {
      logo: k,
      activeScriptHash: t,
      scriptRunId: NO_SCRIPT_RUN_ID
    } : null;
    return new AppRoot(t, new BlockNode(t, [gA, IA, CA, BA]), eA);
  }
  constructor(t, g, d = null) {
    if (this.mainScriptHash = t, this.root = g, this.appLogo = d, this.root.children.length !== 4 || isNullOrUndefined$1(this.main) || isNullOrUndefined$1(this.sidebar) || isNullOrUndefined$1(this.event) || isNullOrUndefined$1(this.bottom))
      throw new Error(`Invalid root node children! ${g}`);
  }
  get main() {
    const [t] = this.root.children;
    return t;
  }
  get sidebar() {
    const [, t] = this.root.children;
    return t;
  }
  get event() {
    const [, , t] = this.root.children;
    return t;
  }
  get bottom() {
    const [, , , t] = this.root.children;
    return t;
  }
  get logo() {
    return this.appLogo?.logo ?? null;
  }
  appRootWithLogo(t, g) {
    return new AppRoot(this.mainScriptHash, this.root, {
      logo: t,
      ...g
    });
  }
  applyDelta(t, g, d) {
    const {
      deltaPath: k,
      activeScriptHash: H
    } = d;
    switch (g.type) {
      case "newElement": {
        const AA = g.newElement;
        return this.addElement(k, t, AA, d, H, g.fragmentId);
      }
      case "addBlock": {
        const AA = Date.now();
        return this.addBlock(k, g.addBlock, t, H, g.fragmentId, AA);
      }
      case "arrowAddRows":
        try {
          return this.arrowAddRows(k, g.arrowAddRows, t);
        } catch (AA) {
          const gA = makeElementWithErrorText(ensureError(AA).message);
          return this.addElement(k, t, gA, d, H);
        }
      default:
        throw new Error(`Unrecognized deltaType: '${g.type}'`);
    }
  }
  filterMainScriptElements(t) {
    const g = this.main.scriptRunId, d = this.main.filterMainScriptElements(t) || new BlockNode(t), k = this.sidebar.filterMainScriptElements(t) || new BlockNode(t), H = this.event.filterMainScriptElements(t) || new BlockNode(t), AA = this.bottom.filterMainScriptElements(t) || new BlockNode(t), gA = this.appLogo?.activeScriptHash === t ? this.appLogo : null;
    return new AppRoot(t, new BlockNode(t, [d, k, H, AA], new Block$2({
      allowEmpty: !0
    }), g), gA);
  }
  clearStaleNodes(t, g) {
    const d = this.main.clearStaleNodes(t, g) || new BlockNode(this.mainScriptHash), k = this.sidebar.clearStaleNodes(t, g) || new BlockNode(this.mainScriptHash), H = this.event.clearStaleNodes(t, g) || new BlockNode(this.mainScriptHash), AA = this.bottom.clearStaleNodes(t, g) || new BlockNode(this.mainScriptHash), IA = g && g.length > 0 || this.appLogo?.scriptRunId === t ? this.appLogo : null;
    return new AppRoot(this.mainScriptHash, new BlockNode(this.mainScriptHash, [d, k, H, AA], new Block$2({
      allowEmpty: !0
    }), t), IA);
  }
  /** Return a Set containing all Elements in the tree. */
  getElements() {
    const t = /* @__PURE__ */ new Set();
    return this.main.getElements(t), this.sidebar.getElements(t), this.event.getElements(t), this.bottom.getElements(t), t;
  }
  addElement(t, g, d, k, H, AA) {
    const gA = new ElementNode(d, k, g, H, AA);
    return new AppRoot(this.mainScriptHash, this.root.setIn(t, gA, g), this.appLogo);
  }
  addBlock(t, g, d, k, H, AA) {
    const gA = this.root.getIn(t);
    let IA = [];
    gA instanceof BlockNode && gA.deltaBlock.type === g.type && (IA = gA.children);
    const CA = new BlockNode(k, IA, g, d, H, AA);
    return new AppRoot(this.mainScriptHash, this.root.setIn(t, CA, d), this.appLogo);
  }
  arrowAddRows(t, g, d) {
    const k = this.root.getIn(t);
    if (isNullOrUndefined$1(k))
      throw new Error(`Can't arrowAddRows: invalid deltaPath: ${t}`);
    const H = k.arrowAddRows(g, d);
    return new AppRoot(this.mainScriptHash, this.root.setIn(t, H, d), this.appLogo);
  }
}
function wrapDatasets(n) {
  return n.map((t) => ({
    hasName: t.hasName,
    name: t.name,
    data: new Quiver(t.data)
  }));
}
var classnames = { exports: {} };
var hasRequiredClassnames;
function requireClassnames() {
  return hasRequiredClassnames || (hasRequiredClassnames = 1, (function(n) {
    (function() {
      var t = {}.hasOwnProperty;
      function g() {
        for (var H = "", AA = 0; AA < arguments.length; AA++) {
          var gA = arguments[AA];
          gA && (H = k(H, d(gA)));
        }
        return H;
      }
      function d(H) {
        if (typeof H == "string" || typeof H == "number")
          return H;
        if (typeof H != "object")
          return "";
        if (Array.isArray(H))
          return g.apply(null, H);
        if (H.toString !== Object.prototype.toString && !H.toString.toString().includes("[native code]"))
          return H.toString();
        var AA = "";
        for (var gA in H)
          t.call(H, gA) && H[gA] && (AA = k(AA, gA));
        return AA;
      }
      function k(H, AA) {
        return AA ? H ? H + " " + AA : H + AA : H;
      }
      n.exports ? (g.default = g, n.exports = g) : window.classNames = g;
    })();
  })(classnames)), classnames.exports;
}
var classnamesExports = requireClassnames();
const classNames = /* @__PURE__ */ getDefaultExportFromCjs$2(classnamesExports), FormsContext = createContext(null);
FormsContext.displayName = "FormsContext";
var Direction = /* @__PURE__ */ ((n) => (n.HORIZONTAL = "row", n.VERTICAL = "column", n))(Direction || {});
function getDirectionOfBlock(n) {
  return n.flexContainer ? n.flexContainer.direction == Block$2.FlexContainer.Direction.HORIZONTAL ? "row" : "column" : n.vertical ? "column" : n.horizontal ? "row" : "column";
}
function shouldWidthStretch(n) {
  return !!(n?.useStretch || n?.pixelWidth);
}
function shouldHeightStretch(n) {
  return !!(n?.useStretch || n?.pixelHeight);
}
const FlexContext = createContext(null);
FlexContext.displayName = "FlexContext";
const FlexContextProvider = ({
  children: n,
  direction: t
}) => {
  const g = useMemo$1(() => {
    const d = t === Direction.HORIZONTAL;
    return {
      direction: t,
      isInHorizontalLayout: d
    };
  }, [t]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FlexContext.Provider, { value: g, children: n });
}, isPositiveNumber = (n) => typeof n == "number" && n >= 0 && !isNaN(n), isNonZeroPositiveNumber = (n) => typeof n == "number" && n > 0 && !isNaN(n), getWidth = (n, t) => {
  let g, d;
  const k = n.widthConfig?.useStretch || t?.widthConfig?.useStretch, H = n?.widthConfig?.useContent || t?.widthConfig?.useContent, AA = n?.widthConfig?.pixelWidth || t?.widthConfig?.pixelWidth || n.widthConfig?.pixelWidth === 0;
  return k ? d = "stretch" : H ? d = "content" : AA && isPositiveNumber(n.widthConfig?.pixelWidth) ? (d = "pixel", g = n.widthConfig?.pixelWidth) : AA && isPositiveNumber(t?.widthConfig?.pixelWidth) ? (d = "pixel", g = t?.widthConfig?.pixelWidth) : isNonZeroPositiveNumber(t?.width) && !n.widthConfig && (g = t?.width, d = "pixel"), t?.useContainerWidth && (d = "stretch"), {
    pixels: g,
    type: d
  };
}, getHeight = (n, t) => {
  let g, d;
  const k = !!n.heightConfig?.useStretch, H = !!n.heightConfig?.useContent, AA = !!n.heightConfig?.pixelHeight || n.heightConfig?.pixelHeight === 0;
  return k ? d = "stretch" : H ? d = "content" : AA && isPositiveNumber(n.heightConfig?.pixelHeight) ? (d = "pixel", g = n.heightConfig?.pixelHeight) : isNonZeroPositiveNumber(t?.height) && !n.heightConfig && (g = t?.height, d = "pixel"), {
    pixels: g,
    type: d
  };
}, getFlex = (n, t, g, d, k, H) => {
  if (n === "pixel" && k === Direction.HORIZONTAL)
    return `0 0 ${t}px`;
  if (g === "pixel" && k === Direction.VERTICAL)
    return `0 0 ${d}px`;
  if (n === "content" && k === Direction.HORIZONTAL)
    return "0 0 fit-content";
  if (n === "stretch" && k === Direction.HORIZONTAL)
    return `1 1 ${H ?? "fit-content"}`;
}, getDirection$1 = (n) => n?.direction, useLayoutStyles = ({
  element: n,
  subElement: t,
  styleOverrides: g,
  minStretchBehavior: d
}) => {
  const k = useContext(FlexContext);
  return useMemo$1(() => {
    if (!n)
      return {
        width: "auto",
        height: "auto",
        overflow: "visible"
      };
    const {
      pixels: AA,
      type: gA
    } = getWidth(n, t);
    let IA = "auto";
    gA === "stretch" ? IA = "100%" : gA === "pixel" ? IA = `${AA}px` : gA === "content" && (IA = "fit-content");
    const {
      pixels: CA,
      type: BA
    } = getHeight(n, t);
    let eA = "auto", iA = "visible";
    BA === "stretch" ? eA = "100%" : BA === "content" ? eA = "auto" : BA === "pixel" && (eA = `${CA}px`, iA = "auto");
    const QA = getFlex(gA, AA, BA, CA, getDirection$1(k), d);
    return {
      ...{
        width: IA,
        height: eA,
        overflow: iA,
        flex: QA
      },
      ...g
    };
  }, [n, t, g, k, d]);
}, token$2 = "%[a-f0-9]{2}", singleMatcher = new RegExp("(" + token$2 + ")|([^%]+?)", "gi"), multiMatcher = new RegExp("(" + token$2 + ")+", "gi");
function decodeComponents(n, t) {
  try {
    return [decodeURIComponent(n.join(""))];
  } catch {
  }
  if (n.length === 1)
    return n;
  t = t || 1;
  const g = n.slice(0, t), d = n.slice(t);
  return Array.prototype.concat.call([], decodeComponents(g), decodeComponents(d));
}
function decode$2(n) {
  try {
    return decodeURIComponent(n);
  } catch {
    let t = n.match(singleMatcher) || [];
    for (let g = 1; g < t.length; g++)
      n = decodeComponents(t, g).join(""), t = n.match(singleMatcher) || [];
    return n;
  }
}
function customDecodeURIComponent(n) {
  const t = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let g = multiMatcher.exec(n);
  for (; g; ) {
    try {
      t[g[0]] = decodeURIComponent(g[0]);
    } catch {
      const k = decode$2(g[0]);
      k !== g[0] && (t[g[0]] = k);
    }
    g = multiMatcher.exec(n);
  }
  t["%C2"] = "�";
  const d = Object.keys(t);
  for (const k of d)
    n = n.replace(new RegExp(k, "g"), t[k]);
  return n;
}
function decodeUriComponent(n) {
  if (typeof n != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof n + "`");
  try {
    return decodeURIComponent(n);
  } catch {
    return customDecodeURIComponent(n);
  }
}
function includeKeys(n, t) {
  const g = {};
  if (Array.isArray(t))
    for (const d of t) {
      const k = Object.getOwnPropertyDescriptor(n, d);
      k?.enumerable && Object.defineProperty(g, d, k);
    }
  else
    for (const d of Reflect.ownKeys(n)) {
      const k = Object.getOwnPropertyDescriptor(n, d);
      if (k.enumerable) {
        const H = n[d];
        t(d, H, n) && Object.defineProperty(g, d, k);
      }
    }
  return g;
}
function splitOnFirst(n, t) {
  if (!(typeof n == "string" && typeof t == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (n === "" || t === "")
    return [];
  const g = n.indexOf(t);
  return g === -1 ? [] : [
    n.slice(0, g),
    n.slice(g + t.length)
  ];
}
const isNullOrUndefined = (n) => n == null, strictUriEncode = (n) => encodeURIComponent(n).replaceAll(/[!'()*]/g, (t) => `%${t.charCodeAt(0).toString(16).toUpperCase()}`), encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function encoderForArrayFormat(n) {
  switch (n.arrayFormat) {
    case "index":
      return (t) => (g, d) => {
        const k = g.length;
        return d === void 0 || n.skipNull && d === null || n.skipEmptyString && d === "" ? g : d === null ? [
          ...g,
          [encode$4(t, n), "[", k, "]"].join("")
        ] : [
          ...g,
          [encode$4(t, n), "[", encode$4(k, n), "]=", encode$4(d, n)].join("")
        ];
      };
    case "bracket":
      return (t) => (g, d) => d === void 0 || n.skipNull && d === null || n.skipEmptyString && d === "" ? g : d === null ? [
        ...g,
        [encode$4(t, n), "[]"].join("")
      ] : [
        ...g,
        [encode$4(t, n), "[]=", encode$4(d, n)].join("")
      ];
    case "colon-list-separator":
      return (t) => (g, d) => d === void 0 || n.skipNull && d === null || n.skipEmptyString && d === "" ? g : d === null ? [
        ...g,
        [encode$4(t, n), ":list="].join("")
      ] : [
        ...g,
        [encode$4(t, n), ":list=", encode$4(d, n)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const t = n.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (g) => (d, k) => k === void 0 || n.skipNull && k === null || n.skipEmptyString && k === "" ? d : (k = k === null ? "" : k, d.length === 0 ? [[encode$4(g, n), t, encode$4(k, n)].join("")] : [[d, encode$4(k, n)].join(n.arrayFormatSeparator)]);
    }
    default:
      return (t) => (g, d) => d === void 0 || n.skipNull && d === null || n.skipEmptyString && d === "" ? g : d === null ? [
        ...g,
        encode$4(t, n)
      ] : [
        ...g,
        [encode$4(t, n), "=", encode$4(d, n)].join("")
      ];
  }
}
function parserForArrayFormat(n) {
  let t;
  switch (n.arrayFormat) {
    case "index":
      return (g, d, k) => {
        if (t = /\[(\d*)]$/.exec(g), g = g.replace(/\[\d*]$/, ""), !t) {
          k[g] = d;
          return;
        }
        k[g] === void 0 && (k[g] = {}), k[g][t[1]] = d;
      };
    case "bracket":
      return (g, d, k) => {
        if (t = /(\[])$/.exec(g), g = g.replace(/\[]$/, ""), !t) {
          k[g] = d;
          return;
        }
        if (k[g] === void 0) {
          k[g] = [d];
          return;
        }
        k[g] = [...k[g], d];
      };
    case "colon-list-separator":
      return (g, d, k) => {
        if (t = /(:list)$/.exec(g), g = g.replace(/:list$/, ""), !t) {
          k[g] = d;
          return;
        }
        if (k[g] === void 0) {
          k[g] = [d];
          return;
        }
        k[g] = [...k[g], d];
      };
    case "comma":
    case "separator":
      return (g, d, k) => {
        const AA = typeof d == "string" && d.includes(n.arrayFormatSeparator) ? d.split(n.arrayFormatSeparator).map((gA) => decode$1(gA, n)) : d === null ? d : decode$1(d, n);
        k[g] = AA;
      };
    case "bracket-separator":
      return (g, d, k) => {
        const H = /(\[])$/.test(g);
        if (g = g.replace(/\[]$/, ""), !H) {
          k[g] = d && decode$1(d, n);
          return;
        }
        const AA = d === null ? [] : decode$1(d, n).split(n.arrayFormatSeparator);
        if (k[g] === void 0) {
          k[g] = AA;
          return;
        }
        k[g] = [...k[g], ...AA];
      };
    default:
      return (g, d, k) => {
        if (k[g] === void 0) {
          k[g] = d;
          return;
        }
        k[g] = [...[k[g]].flat(), d];
      };
  }
}
function validateArrayFormatSeparator(n) {
  if (typeof n != "string" || n.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function encode$4(n, t) {
  return t.encode ? t.strict ? strictUriEncode(n) : encodeURIComponent(n) : n;
}
function decode$1(n, t) {
  return t.decode ? decodeUriComponent(n) : n;
}
function keysSorter(n) {
  return Array.isArray(n) ? n.sort() : typeof n == "object" ? keysSorter(Object.keys(n)).sort((t, g) => Number(t) - Number(g)).map((t) => n[t]) : n;
}
function removeHash(n) {
  const t = n.indexOf("#");
  return t !== -1 && (n = n.slice(0, t)), n;
}
function getHash(n) {
  let t = "";
  const g = n.indexOf("#");
  return g !== -1 && (t = n.slice(g)), t;
}
function parseValue(n, t, g) {
  return g === "string" && typeof n == "string" ? n : typeof g == "function" && typeof n == "string" ? g(n) : g === "boolean" && n === null ? !0 : g === "boolean" && n !== null && (n.toLowerCase() === "true" || n.toLowerCase() === "false") ? n.toLowerCase() === "true" : g === "boolean" && n !== null && (n.toLowerCase() === "1" || n.toLowerCase() === "0") ? n.toLowerCase() === "1" : g === "string[]" && t.arrayFormat !== "none" && typeof n == "string" ? [n] : g === "number[]" && t.arrayFormat !== "none" && !Number.isNaN(Number(n)) && typeof n == "string" && n.trim() !== "" ? [Number(n)] : g === "number" && !Number.isNaN(Number(n)) && typeof n == "string" && n.trim() !== "" ? Number(n) : t.parseBooleans && n !== null && (n.toLowerCase() === "true" || n.toLowerCase() === "false") ? n.toLowerCase() === "true" : t.parseNumbers && !Number.isNaN(Number(n)) && typeof n == "string" && n.trim() !== "" ? Number(n) : n;
}
function extract(n) {
  n = removeHash(n);
  const t = n.indexOf("?");
  return t === -1 ? "" : n.slice(t + 1);
}
function parse$b(n, t) {
  t = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    types: /* @__PURE__ */ Object.create(null),
    ...t
  }, validateArrayFormatSeparator(t.arrayFormatSeparator);
  const g = parserForArrayFormat(t), d = /* @__PURE__ */ Object.create(null);
  if (typeof n != "string" || (n = n.trim().replace(/^[?#&]/, ""), !n))
    return d;
  for (const k of n.split("&")) {
    if (k === "")
      continue;
    const H = t.decode ? k.replaceAll("+", " ") : k;
    let [AA, gA] = splitOnFirst(H, "=");
    AA === void 0 && (AA = H), gA = gA === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(t.arrayFormat) ? gA : decode$1(gA, t), g(decode$1(AA, t), gA, d);
  }
  for (const [k, H] of Object.entries(d))
    if (typeof H == "object" && H !== null && t.types[k] !== "string")
      for (const [AA, gA] of Object.entries(H)) {
        const IA = t.types[k], CA = typeof IA == "function" ? IA : IA ? IA.replace("[]", "") : void 0;
        H[AA] = parseValue(gA, t, CA);
      }
    else typeof H == "object" && H !== null && t.types[k] === "string" ? d[k] = Object.values(H).join(t.arrayFormatSeparator) : d[k] = parseValue(H, t, t.types[k]);
  return t.sort === !1 ? d : (t.sort === !0 ? Object.keys(d).sort() : Object.keys(d).sort(t.sort)).reduce((k, H) => {
    const AA = d[H];
    return k[H] = AA && typeof AA == "object" && !Array.isArray(AA) ? keysSorter(AA) : AA, k;
  }, /* @__PURE__ */ Object.create(null));
}
function stringify$6(n, t) {
  if (!n)
    return "";
  t = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...t
  }, validateArrayFormatSeparator(t.arrayFormatSeparator);
  const g = (AA) => t.skipNull && isNullOrUndefined(n[AA]) || t.skipEmptyString && n[AA] === "", d = encoderForArrayFormat(t), k = {};
  for (const [AA, gA] of Object.entries(n))
    g(AA) || (k[AA] = gA);
  const H = Object.keys(k);
  return t.sort !== !1 && H.sort(t.sort), H.map((AA) => {
    let gA = n[AA];
    if (t.replacer && (gA = t.replacer(AA, gA), gA === void 0) || gA === void 0)
      return "";
    if (gA === null)
      return encode$4(AA, t);
    if (Array.isArray(gA)) {
      if (gA.length === 0 && t.arrayFormat === "bracket-separator")
        return encode$4(AA, t) + "[]";
      let IA = gA;
      return t.replacer && (IA = gA.map(
        (CA, BA) => t.replacer(`${AA}[${BA}]`, CA)
      ).filter((CA) => CA !== void 0)), IA.reduce(d(AA), []).join("&");
    }
    return encode$4(AA, t) + "=" + encode$4(gA, t);
  }).filter((AA) => AA.length > 0).join("&");
}
function parseUrl(n, t) {
  t = {
    decode: !0,
    ...t
  };
  let [g, d] = splitOnFirst(n, "#");
  return g === void 0 && (g = n), {
    url: g?.split("?")?.[0] ?? "",
    query: parse$b(extract(n), t),
    ...t && t.parseFragmentIdentifier && d ? { fragmentIdentifier: decode$1(d, t) } : {}
  };
}
function stringifyUrl(n, t) {
  t = {
    encode: !0,
    strict: !0,
    [encodeFragmentIdentifier]: !0,
    ...t
  };
  const g = removeHash(n.url).split("?")[0] || "", d = extract(n.url), k = {
    ...parse$b(d, { sort: !1, ...t }),
    ...n.query
  };
  let H = stringify$6(k, t);
  H &&= `?${H}`;
  let AA = getHash(n.url);
  if (typeof n.fragmentIdentifier == "string") {
    const gA = new URL(g);
    gA.hash = n.fragmentIdentifier, AA = t[encodeFragmentIdentifier] ? gA.hash : `#${n.fragmentIdentifier}`;
  }
  return `${g}${H}${AA}`;
}
function pick$5(n, t, g) {
  g = {
    parseFragmentIdentifier: !0,
    [encodeFragmentIdentifier]: !1,
    ...g
  };
  const { url: d, query: k, fragmentIdentifier: H } = parseUrl(n, g);
  return stringifyUrl({
    url: d,
    query: includeKeys(k, t),
    fragmentIdentifier: H
  }, g);
}
function exclude(n, t, g) {
  const d = Array.isArray(t) ? (k) => !t.includes(k) : (k, H) => !t(k, H);
  return pick$5(n, d, g);
}
const queryString = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude,
  extract,
  parse: parse$b,
  parseUrl,
  pick: pick$5,
  stringify: stringify$6,
  stringifyUrl
}, Symbol.toStringTag, { value: "Module" }));
var reactPropsRegex$1 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid$1 = /* @__PURE__ */ memoize$2(
  function(n) {
    return reactPropsRegex$1.test(n) || n.charCodeAt(0) === 111 && n.charCodeAt(1) === 110 && n.charCodeAt(2) < 91;
  }
  /* Z+1 */
), testOmitPropsOnStringTag = isPropValid$1, testOmitPropsOnComponent = function n(t) {
  return t !== "theme";
}, getDefaultShouldForwardProp = function n(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
}, composeShouldForwardProps = function n(t, g, d) {
  var k;
  if (g) {
    var H = g.shouldForwardProp;
    k = t.__emotion_forwardProp && H ? function(AA) {
      return t.__emotion_forwardProp(AA) && H(AA);
    } : H;
  }
  return typeof k != "function" && d && (k = t.__emotion_forwardProp), k;
}, Insertion = function n(t) {
  var g = t.cache, d = t.serialized, k = t.isStringTag;
  return registerStyles(g, d, k), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(g, d, k);
  }), null;
}, createStyled$1 = function n(t, g) {
  var d = t.__emotion_real === t, k = d && t.__emotion_base || t, H, AA;
  g !== void 0 && (H = g.label, AA = g.target);
  var gA = composeShouldForwardProps(t, g, d), IA = gA || getDefaultShouldForwardProp(k), CA = !IA("as");
  return function() {
    var BA = arguments, eA = d && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (H !== void 0 && eA.push("label:" + H + ";"), BA[0] == null || BA[0].raw === void 0)
      eA.push.apply(eA, BA);
    else {
      var iA = BA[0];
      eA.push(iA[0]);
      for (var QA = BA.length, tA = 1; tA < QA; tA++)
        eA.push(BA[tA], iA[tA]);
    }
    var oA = withEmotionCache(function(EA, aA, nA) {
      var lA = CA && EA.as || k, cA = "", sA = [], rA = EA;
      if (EA.theme == null) {
        rA = {};
        for (var uA in EA)
          rA[uA] = EA[uA];
        rA.theme = React.useContext(ThemeContext$1);
      }
      typeof EA.className == "string" ? cA = getRegisteredStyles(aA.registered, sA, EA.className) : EA.className != null && (cA = EA.className + " ");
      var hA = serializeStyles(eA.concat(sA), aA.registered, rA);
      cA += aA.key + "-" + hA.name, AA !== void 0 && (cA += " " + AA);
      var dA = CA && gA === void 0 ? getDefaultShouldForwardProp(lA) : IA, GA = {};
      for (var DA in EA)
        CA && DA === "as" || dA(DA) && (GA[DA] = EA[DA]);
      return GA.className = cA, nA && (GA.ref = nA), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion, {
        cache: aA,
        serialized: hA,
        isStringTag: typeof lA == "string"
      }), /* @__PURE__ */ React.createElement(lA, GA));
    });
    return oA.displayName = H !== void 0 ? H : "Styled(" + (typeof k == "string" ? k : k.displayName || k.name || "Component") + ")", oA.defaultProps = t.defaultProps, oA.__emotion_real = oA, oA.__emotion_base = k, oA.__emotion_styles = eA, oA.__emotion_forwardProp = gA, Object.defineProperty(oA, "toString", {
      value: function() {
        return "." + AA;
      }
    }), oA.withComponent = function(EA, aA) {
      var nA = n(EA, _extends$M({}, g, aA, {
        shouldForwardProp: composeShouldForwardProps(oA, aA, !0)
      }));
      return nA.apply(void 0, eA);
    }, oA;
  };
};
const Box = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "epl6yf30"
} : {
  target: "epl6yf30",
  label: "Box"
})(({
  width: n = "100%",
  height: t
}) => ({
  width: n,
  height: t
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZS9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFvQm1CIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZS9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBDU1NQcm9wZXJ0aWVzIH0gZnJvbSBcInJlYWN0XCJcblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IEJveCA9IHN0eWxlZC5kaXY8e1xuICB3aWR0aD86IENTU1Byb3BlcnRpZXNbXCJ3aWR0aFwiXVxuICBoZWlnaHQ/OiBDU1NQcm9wZXJ0aWVzW1wiaGVpZ2h0XCJdXG59PigoeyB3aWR0aCA9IFwiMTAwJVwiLCBoZWlnaHQgfSkgPT4gKHtcbiAgd2lkdGgsXG4gIGhlaWdodCxcbn0pKVxuIl19 */"), useResizeObserver = (n, t = []) => {
  const g = useRef(null), [d, k] = useState([]), H = useCallback(() => {
    if (!g.current)
      return [];
    const AA = g.current.getBoundingClientRect();
    return n.map((gA) => AA[gA]);
  }, [n]);
  return useEffect(() => {
    if (!g.current)
      return;
    k(H());
    let AA;
    const gA = new ResizeObserver(() => {
      AA = window.requestAnimationFrame(() => {
        k(H());
      });
    });
    return gA.observe(g.current), () => {
      gA.disconnect(), AA && cancelAnimationFrame(AA);
    };
  }, [n, H, ...t]), {
    values: d,
    elementRef: g
  };
}, useCalculatedDimensions = (n = [], t = -1) => {
  const {
    values: [g, d],
    elementRef: k
  } = useResizeObserver(useMemo$1(() => ["width", "height"], []), n);
  return {
    width: g || t,
    height: d || t,
    elementRef: k
  };
}, withCalculatedWidth = (n) => {
  const t = (g) => {
    const {
      width: d,
      elementRef: k
    } = useCalculatedDimensions();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ref: k, children: /* @__PURE__ */ jsxRuntimeExports.jsx(n, { ...g, width: d }) });
  };
  return t.displayName = `withCalculatedWidth(${n.displayName || n.name})`, hoistNonReactStatics(t, n);
};
var reactIsExports$1 = requireReactIs$1();
function _typeof$m(n) {
  "@babel/helpers - typeof";
  return _typeof$m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$m(n);
}
function deepMerge$1(n) {
  n = n || {};
  for (var t = arguments.length <= 1 ? 0 : arguments.length - 1, g, d, k = 0; k < t; k++) {
    g = (k + 1 < 1 || arguments.length <= k + 1 ? void 0 : arguments[k + 1]) || {};
    for (var H in g)
      _typeof$m(g[H]) !== void 0 && (d = g[H], isCloneable(d) ? n[H] = deepMerge$1(
        /* eslint-disable-next-line no-mixed-operators */
        n[H] || Array.isArray(d) && [] || {},
        d
      ) : n[H] = d);
  }
  return n;
}
function isCloneable(n) {
  return Array.isArray(n) || {}.toString.call(n) == "[object Object]";
}
function _extends$L() {
  return _extends$L = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$L.apply(this, arguments);
}
function ownKeys$A(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$y(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$A(Object(g), !0).forEach(function(d) {
      _defineProperty$G(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$A(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$G(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function _typeof$l(n) {
  "@babel/helpers - typeof";
  return _typeof$l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$l(n);
}
function getOverride(n) {
  return reactIsExports$1.isValidElementType(n) ? n : n && _typeof$l(n) === "object" ? n.component : n;
}
function getOverrideProps(n) {
  return n && _typeof$l(n) === "object" ? _typeof$l(n.props) === "object" ? _objectSpread$y(_objectSpread$y({}, n.props), {}, {
    $style: n.style
  }) : {
    $style: n.style
  } : {};
}
function toObjectOverride(n) {
  return reactIsExports$1.isValidElementType(n) ? {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: n
  } : n || {};
}
function getOverrides(n, t) {
  var g = getOverride(n) || t;
  if (n && _typeof$l(n) === "object" && typeof n.props == "function") {
    process.env.NODE_ENV !== "production" && console.warn("baseui:Overrides Props as a function will be removed in the next major version. Override the whole component instead. See https://baseweb.design/guides/understanding-overrides/#override-the-entire-subcomponent");
    var d = /* @__PURE__ */ React.forwardRef(function(H, AA) {
      var gA = n.props(H), IA = getOverrideProps(_objectSpread$y(_objectSpread$y({}, n), {}, {
        props: gA
      }));
      return /* @__PURE__ */ React.createElement(g, _extends$L({
        ref: AA
      }, IA));
    });
    return d.displayName = g.displayName, [d, {}];
  }
  var k = getOverrideProps(n);
  return [g, k];
}
function mergeOverrides() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, g = Object.assign({}, n, t), d = Object.keys(g);
  return d.reduce(function(k, H) {
    return k[H] = mergeOverride(toObjectOverride(n[H]), toObjectOverride(t[H])), k;
  }, {});
}
function mergeOverride(n, t) {
  var g = _objectSpread$y(_objectSpread$y({}, n), t);
  return n.props && t.props && (g.props = mergeConfigurationOverrides(n.props, t.props)), n.style && t.style && (g.style = mergeConfigurationOverrides(n.style, t.style)), g;
}
function mergeConfigurationOverrides(n, t) {
  return _typeof$l(n) === "object" && _typeof$l(t) === "object" ? deepMerge$1({}, n, t) : function() {
    return deepMerge$1({}, typeof n == "function" ? n.apply(void 0, arguments) : n, typeof t == "function" ? t.apply(void 0, arguments) : t);
  };
}
var KIND$1 = Object.freeze({
  info: "info",
  positive: "positive",
  warning: "warning",
  negative: "negative"
}), TYPE$1 = Object.freeze({
  inline: "inline",
  toast: "toast"
}), PLACEMENT$1 = Object.freeze({
  topLeft: "topLeft",
  top: "top",
  topRight: "topRight",
  bottomRight: "bottomRight",
  bottom: "bottom",
  bottomLeft: "bottomLeft"
}), colors$3 = {
  white: "#FFFFFF",
  gray50: "#F6F6F6",
  gray100: "#EEEEEE",
  gray200: "#E2E2E2",
  gray300: "#CBCBCB",
  gray400: "#AFAFAF",
  gray500: "#6B6B6B",
  gray600: "#545454",
  gray700: "#333333",
  gray800: "#1F1F1F",
  gray900: "#141414",
  black: "#000000",
  platinum400: "#8EA3AD",
  red50: "#FFEFED",
  red100: "#FED7D2",
  red200: "#F1998E",
  red300: "#E85C4A",
  red400: "#E11900",
  red500: "#AB1300",
  red600: "#870F00",
  red700: "#5A0A00",
  orange200: "#FABDA5",
  orange300: "#FA9269",
  orange400: "#FF6937",
  orange500: "#C14F29",
  orange600: "#9A3F21",
  orange700: "#672A16",
  yellow50: "#FFFAF0",
  yellow100: "#FFF2D9",
  yellow200: "#FFE3AC",
  yellow300: "#FFCF70",
  yellow400: "#FFC043",
  yellow500: "#BC8B2C",
  yellow600: "#996F00",
  yellow700: "#674D1B",
  green50: "#E6F2ED",
  green100: "#ADDEC9",
  green200: "#66D19E",
  green300: "#06C167",
  green400: "#048848",
  green500: "#03703C",
  green600: "#03582F",
  green700: "#10462D",
  blue50: "#EFF3FE",
  blue100: "#D4E2FC",
  blue200: "#A0BFF8",
  blue300: "#5B91F5",
  blue400: "#276EF1",
  blue500: "#1E54B7",
  blue600: "#174291",
  blue700: "#102C60",
  cobalt400: "#0E1FC1",
  purple200: "#C1B4E2",
  purple300: "#957FCE",
  purple400: "#7356BF",
  purple500: "#574191",
  purple600: "#453473",
  purple700: "#2E224C",
  brown200: "#D2BBB0",
  brown300: "#B18977",
  brown400: "#99644C",
  brown500: "#744C3A",
  brown600: "#5C3C2E",
  brown700: "#3D281E"
}, lightColorTokens = {
  // Primary Palette
  primaryA: colors$3.black,
  primaryB: colors$3.white,
  primary: colors$3.black,
  primary50: colors$3.gray50,
  primary100: colors$3.gray100,
  primary200: colors$3.gray200,
  primary300: colors$3.gray300,
  primary400: colors$3.gray400,
  primary500: colors$3.gray500,
  primary600: colors$3.gray600,
  primary700: colors$3.gray700,
  // Accent Palette
  accent: colors$3.blue400,
  accent50: colors$3.blue50,
  accent100: colors$3.blue100,
  accent200: colors$3.blue200,
  accent300: colors$3.blue300,
  accent400: colors$3.blue400,
  accent500: colors$3.blue500,
  accent600: colors$3.blue600,
  accent700: colors$3.blue700,
  // Negative Palette
  negative: colors$3.red400,
  negative50: colors$3.red50,
  negative100: colors$3.red100,
  negative200: colors$3.red200,
  negative300: colors$3.red300,
  negative400: colors$3.red400,
  negative500: colors$3.red500,
  negative600: colors$3.red600,
  negative700: colors$3.red700,
  // Warning Palette
  warning: colors$3.yellow400,
  warning50: colors$3.yellow50,
  warning100: colors$3.yellow100,
  warning200: colors$3.yellow200,
  warning300: colors$3.yellow300,
  warning400: colors$3.yellow400,
  warning500: colors$3.yellow500,
  warning600: colors$3.yellow600,
  warning700: colors$3.yellow700,
  // Positive Palette
  positive: colors$3.green500,
  positive50: colors$3.green50,
  positive100: colors$3.green100,
  positive200: colors$3.green200,
  positive300: colors$3.green300,
  positive400: colors$3.green400,
  positive500: colors$3.green500,
  positive600: colors$3.green600,
  positive700: colors$3.green700,
  // Monochrome Palette
  white: colors$3.white,
  black: colors$3.black,
  mono100: colors$3.white,
  mono200: colors$3.gray50,
  mono300: colors$3.gray100,
  mono400: colors$3.gray200,
  mono500: colors$3.gray300,
  mono600: colors$3.gray400,
  mono700: colors$3.gray500,
  mono800: colors$3.gray600,
  mono900: colors$3.gray700,
  mono1000: colors$3.black,
  // Rating Palette,
  ratingInactiveFill: colors$3.gray100,
  ratingStroke: colors$3.gray300
};
function hexToRgb() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "1", g = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  n = n.replace(g, function(k, H, AA, gA) {
    return H + H + AA + AA + gA + gA;
  });
  var d = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(n);
  return d ? "rgba(".concat(parseInt(d[1], 16), ", ").concat(parseInt(d[2], 16), ", ").concat(parseInt(d[3], 16), ", ").concat(t, ")") : null;
}
var ellipsisText = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  wordWrap: "normal"
};
function expandBorderStyles(n) {
  return {
    borderTopWidth: n.borderWidth,
    borderTopStyle: n.borderStyle,
    borderTopColor: n.borderColor,
    borderBottomWidth: n.borderWidth,
    borderBottomStyle: n.borderStyle,
    borderBottomColor: n.borderColor,
    borderLeftWidth: n.borderWidth,
    borderLeftStyle: n.borderStyle,
    borderLeftColor: n.borderColor,
    borderRightWidth: n.borderWidth,
    borderRightStyle: n.borderStyle,
    borderRightColor: n.borderColor
  };
}
function ownKeys$z(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$x(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$z(Object(g), !0).forEach(function(d) {
      _defineProperty$F(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$z(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$F(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
const getSemanticColorTokens = (function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : lightColorTokens, t = {
    // Background
    backgroundPrimary: n.primaryB,
    backgroundSecondary: colors$3.gray50,
    backgroundTertiary: colors$3.gray100,
    backgroundInversePrimary: n.primaryA,
    backgroundInverseSecondary: colors$3.gray800,
    // Content
    contentPrimary: n.primaryA,
    contentSecondary: colors$3.gray600,
    contentTertiary: colors$3.gray500,
    contentInversePrimary: n.primaryB,
    contentInverseSecondary: colors$3.gray300,
    contentInverseTertiary: colors$3.gray400,
    // Border
    borderOpaque: colors$3.gray200,
    borderTransparent: hexToRgb(n.primaryA, "0.08"),
    borderSelected: n.primaryA,
    borderInverseOpaque: colors$3.gray700,
    borderInverseTransparent: hexToRgb(n.primaryB, "0.2"),
    borderInverseSelected: n.primaryB
  }, g = {
    // Backgrounds
    backgroundStateDisabled: colors$3.gray50,
    backgroundOverlayDark: hexToRgb(colors$3.black, "0.3"),
    backgroundOverlayLight: hexToRgb(colors$3.black, "0.08"),
    backgroundOverlayArt: hexToRgb(colors$3.black, "0.00"),
    backgroundAccent: n.accent,
    backgroundNegative: n.negative,
    backgroundWarning: n.warning,
    backgroundPositive: colors$3.green400,
    backgroundLightAccent: colors$3.blue50,
    backgroundLightNegative: colors$3.red50,
    backgroundLightWarning: colors$3.yellow50,
    backgroundLightPositive: colors$3.green50,
    backgroundAlwaysDark: colors$3.black,
    backgroundAlwaysLight: colors$3.white,
    // Content
    contentStateDisabled: colors$3.gray400,
    contentAccent: n.accent,
    contentOnColor: colors$3.white,
    contentOnColorInverse: colors$3.black,
    contentNegative: n.negative,
    contentWarning: colors$3.yellow600,
    contentPositive: colors$3.green400,
    // Border
    borderStateDisabled: colors$3.gray50,
    borderAccent: colors$3.blue400,
    borderAccentLight: colors$3.blue200,
    borderNegative: colors$3.red200,
    borderWarning: colors$3.yellow200,
    borderPositive: colors$3.green200,
    // Programs
    safety: colors$3.blue400,
    eatsGreen400: colors$3.green400,
    freightBlue400: colors$3.cobalt400,
    jumpRed400: colors$3.red400,
    rewardsTier1: colors$3.blue400,
    rewardsTier2: colors$3.yellow400,
    rewardsTier3: colors$3.platinum400,
    rewardsTier4: colors$3.black,
    membership: colors$3.yellow600
  };
  return _objectSpread$x(_objectSpread$x({}, t), g);
});
var tagHoverBackground = "rgba(0, 0, 0, 0.08)";
const getComponentColorTokens = (function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : lightColorTokens;
  return {
    bannerActionLowInfo: n.accent100,
    bannerActionLowNegative: n.negative100,
    bannerActionLowPositive: n.positive100,
    bannerActionLowWarning: n.warning200,
    bannerActionHighInfo: n.accent500,
    bannerActionHighNegative: n.negative500,
    bannerActionHighPositive: n.positive500,
    bannerActionHighWarning: n.warning200,
    // Buttons
    buttonPrimaryFill: n.primary,
    buttonPrimaryText: n.white,
    buttonPrimaryHover: n.primary700,
    buttonPrimaryActive: n.primary600,
    buttonPrimarySelectedFill: n.primary600,
    buttonPrimarySelectedText: n.white,
    buttonPrimarySpinnerForeground: n.accent,
    buttonPrimarySpinnerBackground: n.primaryB,
    buttonSecondaryFill: n.primary100,
    buttonSecondaryText: n.primary,
    buttonSecondaryHover: n.primary200,
    buttonSecondaryActive: n.primary300,
    buttonSecondarySelectedFill: n.primary300,
    buttonSecondarySelectedText: n.primary,
    buttonSecondarySpinnerForeground: n.accent,
    buttonSecondarySpinnerBackground: n.primaryB,
    buttonTertiaryFill: "transparent",
    buttonTertiaryText: n.primary,
    buttonTertiaryHover: n.primary50,
    buttonTertiaryActive: n.primary100,
    buttonTertiarySelectedFill: n.primary100,
    buttonTertiarySelectedText: n.primary,
    buttonTertiaryDisabledActiveFill: n.primary50,
    buttonTertiaryDisabledActiveText: n.mono600,
    buttonTertiarySpinnerForeground: n.accent,
    buttonTertiarySpinnerBackground: n.primary100,
    buttonDisabledFill: n.mono200,
    buttonDisabledText: n.mono600,
    buttonDisabledActiveFill: n.mono700,
    buttonDisabledActiveText: n.mono100,
    buttonDisabledSpinnerForeground: n.mono600,
    buttonDisabledSpinnerBackground: n.mono400,
    // Breadcrumbs
    breadcrumbsText: n.black,
    breadcrumbsSeparatorFill: n.mono700,
    // Datepicker
    calendarBackground: n.mono100,
    calendarForeground: n.mono1000,
    calendarForegroundDisabled: n.mono500,
    calendarHeaderBackground: n.white,
    calendarHeaderForeground: n.primary,
    calendarHeaderBackgroundActive: n.primary700,
    calendarHeaderForegroundDisabled: n.primary500,
    calendarDayForegroundPseudoSelected: n.mono1000,
    calendarDayBackgroundPseudoSelectedHighlighted: n.primary200,
    calendarDayForegroundPseudoSelectedHighlighted: n.mono1000,
    calendarDayBackgroundSelected: n.primary,
    calendarDayForegroundSelected: n.white,
    calendarDayBackgroundSelectedHighlighted: n.primary,
    calendarDayForegroundSelectedHighlighted: n.white,
    // Combobox
    comboboxListItemFocus: n.mono200,
    comboboxListItemHover: n.mono300,
    // FileUploader
    fileUploaderBackgroundColor: n.mono200,
    fileUploaderBackgroundColorActive: n.primary50,
    fileUploaderBorderColorActive: n.primary,
    fileUploaderBorderColorDefault: n.mono500,
    fileUploaderMessageColor: n.mono800,
    // Links
    linkText: n.primary,
    linkVisited: n.primary700,
    linkHover: n.primary600,
    linkActive: n.primary500,
    // List
    listHeaderFill: n.white,
    listBodyFill: n.white,
    // ProgressSteps
    progressStepsCompletedText: n.white,
    progressStepsCompletedFill: n.primary,
    progressStepsActiveText: n.white,
    progressStepsActiveFill: n.primary,
    // Toggle
    toggleFill: n.white,
    toggleFillChecked: n.primary,
    toggleFillDisabled: n.mono600,
    toggleTrackFill: n.mono400,
    toggleTrackFillDisabled: n.mono300,
    // Tick
    tickFill: n.mono100,
    tickFillHover: n.mono200,
    tickFillActive: n.mono300,
    tickFillSelected: n.primary,
    tickFillSelectedHover: n.primary700,
    tickFillSelectedHoverActive: n.primary600,
    tickFillError: n.negative50,
    tickFillErrorHover: n.negative100,
    tickFillErrorHoverActive: n.negative200,
    tickFillErrorSelected: n.negative400,
    tickFillErrorSelectedHover: n.negative500,
    tickFillErrorSelectedHoverActive: n.negative600,
    tickFillDisabled: n.mono600,
    tickBorder: n.mono700,
    tickBorderError: n.negative400,
    tickMarkFill: n.white,
    tickMarkFillError: n.white,
    tickMarkFillDisabled: n.mono100,
    // Slider/Toggle
    sliderTrackFill: "transparent",
    sliderHandleFill: n.primaryA,
    sliderHandleFillDisabled: n.primary400,
    sliderHandleInnerFill: n.primaryA,
    sliderTrackFillHover: n.mono500,
    sliderTrackFillActive: n.mono600,
    sliderTrackFillDisabled: n.mono300,
    sliderHandleInnerFillDisabled: n.mono400,
    sliderHandleInnerFillSelectedHover: n.primary,
    sliderHandleInnerFillSelectedActive: n.primary500,
    // Inputs
    inputBorder: n.mono300,
    inputFill: n.mono300,
    inputFillError: n.negative50,
    inputFillDisabled: n.mono200,
    inputFillActive: n.mono200,
    inputFillPositive: n.positive50,
    inputTextDisabled: n.mono600,
    inputBorderError: n.negative200,
    inputBorderPositive: n.positive200,
    inputEnhancerFill: n.mono300,
    inputEnhancerFillDisabled: n.mono300,
    inputEnhancerTextDisabled: n.mono600,
    inputPlaceholder: n.mono700,
    inputPlaceholderDisabled: n.mono600,
    // Menu
    menuFill: n.mono100,
    menuFillHover: n.mono200,
    menuFontDefault: n.mono800,
    menuFontDisabled: n.mono500,
    menuFontHighlighted: n.mono1000,
    menuFontSelected: n.mono1000,
    // Modal
    modalCloseColor: n.mono1000,
    modalCloseColorHover: n.mono800,
    modalCloseColorFocus: n.mono800,
    // Tab
    tabBarFill: n.mono200,
    tabColor: n.mono800,
    // Notification
    notificationInfoBackground: n.accent50,
    notificationInfoText: n.primaryA,
    notificationPositiveBackground: n.positive50,
    notificationPositiveText: n.primaryA,
    notificationWarningBackground: n.warning50,
    notificationWarningText: n.primaryA,
    notificationNegativeBackground: n.negative50,
    notificationNegativeText: n.primaryA,
    // Tag
    // Custom ramps
    tagFontDisabledRampUnit: "100",
    tagSolidFontRampUnit: "0",
    tagSolidRampUnit: "400",
    tagOutlinedFontRampUnit: "400",
    tagOutlinedRampUnit: "200",
    // Deprecated
    tagSolidHoverRampUnit: "50",
    tagSolidActiveRampUnit: "100",
    tagSolidDisabledRampUnit: "50",
    tagSolidFontHoverRampUnit: "500",
    tagLightRampUnit: "50",
    tagLightHoverRampUnit: "100",
    tagLightActiveRampUnit: "100",
    tagLightFontRampUnit: "500",
    tagLightFontHoverRampUnit: "500",
    tagOutlinedHoverRampUnit: "50",
    tagOutlinedActiveRampUnit: "0",
    tagOutlinedFontHoverRampUnit: "400",
    // Neutral
    tagNeutralFontDisabled: n.mono600,
    tagNeutralOutlinedDisabled: n.mono400,
    tagNeutralSolidFont: n.white,
    tagNeutralSolidBackground: n.black,
    tagNeutralOutlinedBackground: n.mono600,
    tagNeutralOutlinedFont: n.black,
    // Deprecated
    tagNeutralSolidHover: n.mono300,
    tagNeutralSolidActive: n.mono400,
    tagNeutralSolidDisabled: n.mono200,
    tagNeutralSolidFontHover: n.mono900,
    tagNeutralLightBackground: n.mono300,
    tagNeutralLightHover: n.mono300,
    tagNeutralLightActive: n.mono400,
    tagNeutralLightDisabled: n.mono200,
    tagNeutralLightFont: n.mono900,
    tagNeutralLightFontHover: n.mono900,
    tagNeutralOutlinedActive: n.mono900,
    tagNeutralOutlinedFontHover: n.mono800,
    tagNeutralOutlinedHover: tagHoverBackground,
    // Primary
    tagPrimaryFontDisabled: n.primary400,
    tagPrimaryOutlinedDisabled: n.primary200,
    tagPrimarySolidFont: n.white,
    tagPrimarySolidBackground: n.primary,
    tagPrimaryOutlinedFontHover: n.primary,
    tagPrimaryOutlinedFont: n.primary,
    // Deprecated
    tagPrimarySolidHover: n.primary100,
    tagPrimarySolidActive: n.primary200,
    tagPrimarySolidDisabled: n.primary50,
    tagPrimarySolidFontHover: n.primary700,
    tagPrimaryLightBackground: n.primary50,
    tagPrimaryLightHover: n.primary100,
    tagPrimaryLightActive: n.primary100,
    tagPrimaryLightDisabled: n.primary50,
    tagPrimaryLightFont: n.primary500,
    tagPrimaryLightFontHover: n.primary500,
    tagPrimaryOutlinedActive: n.primary600,
    tagPrimaryOutlinedHover: tagHoverBackground,
    tagPrimaryOutlinedBackground: n.primary400,
    // Accent
    tagAccentFontDisabled: n.accent200,
    tagAccentOutlinedDisabled: n.accent200,
    tagAccentSolidFont: n.white,
    tagAccentSolidBackground: n.accent400,
    tagAccentOutlinedBackground: n.accent200,
    tagAccentOutlinedFont: n.accent400,
    // Deprecated
    tagAccentSolidHover: n.accent50,
    tagAccentSolidActive: n.accent100,
    tagAccentSolidDisabled: n.accent50,
    tagAccentSolidFontHover: n.accent500,
    tagAccentLightBackground: n.accent50,
    tagAccentLightHover: n.accent100,
    tagAccentLightActive: n.accent100,
    tagAccentLightDisabled: n.accent50,
    tagAccentLightFont: n.accent500,
    tagAccentLightFontHover: n.accent500,
    tagAccentOutlinedActive: n.accent600,
    tagAccentOutlinedFontHover: n.accent400,
    tagAccentOutlinedHover: tagHoverBackground,
    // Positive
    tagPositiveFontDisabled: n.positive200,
    tagPositiveOutlinedDisabled: n.positive200,
    tagPositiveSolidFont: n.white,
    tagPositiveSolidBackground: n.positive400,
    tagPositiveOutlinedBackground: n.positive200,
    tagPositiveOutlinedFont: n.positive400,
    // Deprecated
    tagPositiveSolidHover: n.positive50,
    tagPositiveSolidActive: n.positive100,
    tagPositiveSolidDisabled: n.positive50,
    tagPositiveSolidFontHover: n.positive500,
    tagPositiveLightBackground: n.positive50,
    tagPositiveLightHover: n.positive100,
    tagPositiveLightActive: n.positive100,
    tagPositiveLightDisabled: n.positive50,
    tagPositiveLightFont: n.positive500,
    tagPositiveLightFontHover: n.positive500,
    tagPositiveOutlinedActive: n.positive600,
    tagPositiveOutlinedFontHover: n.positive400,
    tagPositiveOutlinedHover: tagHoverBackground,
    // Warning
    tagWarningFontDisabled: n.warning300,
    tagWarningOutlinedDisabled: n.warning300,
    tagWarningSolidFont: n.warning700,
    tagWarningSolidBackground: n.warning400,
    tagWarningOutlinedBackground: n.warning300,
    tagWarningOutlinedFont: n.warning600,
    // Deprecated
    tagWarningSolidHover: n.warning50,
    tagWarningSolidActive: n.warning100,
    tagWarningSolidDisabled: n.warning50,
    tagWarningSolidFontHover: n.warning500,
    tagWarningLightBackground: n.warning50,
    tagWarningLightHover: n.warning100,
    tagWarningLightActive: n.warning100,
    tagWarningLightDisabled: n.warning50,
    tagWarningLightFont: n.warning500,
    tagWarningLightFontHover: n.warning500,
    tagWarningOutlinedActive: n.warning600,
    tagWarningOutlinedFontHover: n.warning600,
    tagWarningOutlinedHover: tagHoverBackground,
    // Negative
    tagNegativeFontDisabled: n.negative200,
    tagNegativeOutlinedDisabled: n.negative200,
    tagNegativeSolidFont: n.white,
    tagNegativeSolidBackground: n.negative400,
    tagNegativeOutlinedBackground: n.negative200,
    tagNegativeOutlinedFont: n.negative400,
    // Deprecated
    tagNegativeSolidHover: n.negative50,
    tagNegativeSolidActive: n.negative100,
    tagNegativeSolidDisabled: n.negative50,
    tagNegativeSolidFontHover: n.negative500,
    tagNegativeLightBackground: n.negative50,
    tagNegativeLightHover: n.negative100,
    tagNegativeLightActive: n.negative100,
    tagNegativeLightDisabled: n.negative50,
    tagNegativeLightFont: n.negative500,
    tagNegativeLightFontHover: n.negative500,
    tagNegativeOutlinedActive: n.negative600,
    tagNegativeOutlinedFontHover: n.negative400,
    tagNegativeOutlinedHover: tagHoverBackground,
    // Table
    tableHeadBackgroundColor: n.mono100,
    tableBackground: n.mono100,
    tableStripedBackground: n.mono200,
    tableFilter: n.mono600,
    tableFilterHeading: n.mono700,
    tableFilterBackground: n.mono100,
    tableFilterFooterBackground: n.mono200,
    // Toast
    toastText: n.white,
    toastPrimaryText: n.white,
    toastInfoBackground: n.accent400,
    toastInfoText: n.white,
    toastPositiveBackground: n.positive400,
    toastPositiveText: n.white,
    toastWarningBackground: n.warning400,
    toastWarningText: n.black,
    toastNegativeBackground: n.negative400,
    toastNegativeText: n.white,
    // Spinner
    spinnerTrackFill: n.mono900,
    // Progress bar
    progressbarTrackFill: n.mono900,
    // Tooltip
    tooltipBackground: n.mono900,
    tooltipText: n.mono100
  };
});
var borders = {
  border100: {
    borderColor: "hsla(0, 0%, 0%, 0.04)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border200: {
    borderColor: "hsla(0, 0%, 0%, 0.08)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border300: {
    borderColor: "hsla(0, 0%, 0%, 0.12)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border400: {
    borderColor: "hsla(0, 0%, 0%, 0.16)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border500: {
    borderColor: "hsla(0, 0%, 0%, 0.2)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border600: {
    borderColor: "hsla(0, 0%, 0%, 0.24)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  radius100: "2px",
  radius200: "4px",
  radius300: "8px",
  radius400: "12px",
  radius500: "16px",
  /** Datepicker (Range), Progress Bar, Slider, Tag */
  useRoundedCorners: !0,
  /** Button, ButtonGroup */
  buttonBorderRadiusMini: "4px",
  buttonBorderRadius: "8px",
  /** Checkbox */
  checkboxBorderRadius: "0px",
  /** Input, Select, Textarea */
  inputBorderRadiusMini: "4px",
  inputBorderRadius: "8px",
  /** Popover, Menu, Tooltip */
  popoverBorderRadius: "8px",
  /** Card, Datepicker, Modal, Toast, Notification */
  surfaceBorderRadius: "0px",
  /** Tag */
  tagBorderRadius: "24px"
}, lighting = {
  shadow400: "0 1px 4px hsla(0, 0%, 0%, 0.16)",
  shadow500: "0 2px 8px hsla(0, 0%, 0%, 0.16)",
  shadow600: "0 4px 16px hsla(0, 0%, 0%, 0.16)",
  shadow700: "0 8px 24px hsla(0, 0%, 0%, 0.16)",
  overlay0: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0)",
  overlay100: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.04)",
  overlay200: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.08)",
  overlay300: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.12)",
  overlay400: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.16)",
  overlay500: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.2)",
  overlay600: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.24)",
  shallowAbove: "0px -4px 16px rgba(0, 0, 0, 0.12)",
  shallowBelow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
  deepAbove: "0px -16px 48px rgba(0, 0, 0, 0.22)",
  deepBelow: "0px 16px 48px rgba(0, 0, 0, 0.22)"
};
function ownKeys$y(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$w(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$y(Object(g), !0).forEach(function(d) {
      _defineProperty$E(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$y(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$E(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var defaultFontTokens = {
  primaryFontFamily: 'system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif'
}, monoFontFamily = '"Lucida Console", Monaco, monospace';
const getTypography = (function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultFontTokens, t = {
    fontFamily: n.primaryFontFamily,
    fontSize: "12px",
    fontWeight: "normal",
    lineHeight: "20px"
  }, g = {
    fontFamily: n.primaryFontFamily,
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px"
  }, d = {
    fontFamily: n.primaryFontFamily,
    fontSize: "14px",
    fontWeight: "normal",
    lineHeight: "20px"
  }, k = {
    fontFamily: n.primaryFontFamily,
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "16px"
  }, H = {
    fontFamily: n.primaryFontFamily,
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: "24px"
  }, AA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "20px"
  }, gA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "18px",
    fontWeight: "normal",
    lineHeight: "28px"
  }, IA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "24px"
  }, CA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "28px"
  }, BA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "32px"
  }, eA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "28px",
    fontWeight: 700,
    lineHeight: "36px"
  }, iA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "32px",
    fontWeight: 700,
    lineHeight: "40px"
  }, QA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "36px",
    fontWeight: 700,
    lineHeight: "44px"
  }, tA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "52px"
  }, oA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "36px",
    fontWeight: 700,
    lineHeight: "44px"
  }, EA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "44px",
    fontWeight: 700,
    lineHeight: "52px"
  }, aA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "52px",
    fontWeight: 700,
    lineHeight: "64px"
  }, nA = {
    fontFamily: n.primaryFontFamily,
    fontSize: "96px",
    fontWeight: 700,
    lineHeight: "112px"
  };
  return {
    font100: t,
    font150: g,
    font200: d,
    font250: k,
    font300: H,
    font350: AA,
    font400: gA,
    font450: IA,
    font550: CA,
    font650: BA,
    font750: eA,
    font850: iA,
    font950: QA,
    font1050: tA,
    font1150: oA,
    font1250: EA,
    font1350: aA,
    font1450: nA,
    ParagraphXSmall: t,
    ParagraphSmall: d,
    ParagraphMedium: H,
    ParagraphLarge: gA,
    LabelXSmall: g,
    LabelSmall: k,
    LabelMedium: AA,
    LabelLarge: IA,
    HeadingXSmall: CA,
    HeadingSmall: BA,
    HeadingMedium: eA,
    HeadingLarge: iA,
    HeadingXLarge: QA,
    HeadingXXLarge: tA,
    DisplayXSmall: oA,
    DisplaySmall: EA,
    DisplayMedium: aA,
    DisplayLarge: nA,
    MonoParagraphXSmall: _objectSpread$w(_objectSpread$w({}, t), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphSmall: _objectSpread$w(_objectSpread$w({}, d), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphMedium: _objectSpread$w(_objectSpread$w({}, H), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphLarge: _objectSpread$w(_objectSpread$w({}, gA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelXSmall: _objectSpread$w(_objectSpread$w({}, g), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelSmall: _objectSpread$w(_objectSpread$w({}, k), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelMedium: _objectSpread$w(_objectSpread$w({}, AA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelLarge: _objectSpread$w(_objectSpread$w({}, IA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXSmall: _objectSpread$w(_objectSpread$w({}, CA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingSmall: _objectSpread$w(_objectSpread$w({}, BA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingMedium: _objectSpread$w(_objectSpread$w({}, eA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingLarge: _objectSpread$w(_objectSpread$w({}, iA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXLarge: _objectSpread$w(_objectSpread$w({}, QA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXXLarge: _objectSpread$w(_objectSpread$w({}, tA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayXSmall: _objectSpread$w(_objectSpread$w({}, oA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplaySmall: _objectSpread$w(_objectSpread$w({}, EA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayMedium: _objectSpread$w(_objectSpread$w({}, aA), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayLarge: _objectSpread$w(_objectSpread$w({}, nA), {}, {
      fontFamily: monoFontFamily
    })
  };
});
var animation = {
  timing100: "100ms",
  timing200: "200ms",
  timing300: "300ms",
  timing400: "400ms",
  timing500: "500ms",
  timing600: "600ms",
  timing700: "700ms",
  timing800: "800ms",
  timing900: "900ms",
  timing1000: "1000ms",
  easeInCurve: "cubic-bezier(.8, .2, .6, 1)",
  easeOutCurve: "cubic-bezier(.2, .8, .4, 1)",
  easeInOutCurve: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeInQuinticCurve: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  easeOutQuinticCurve: "cubic-bezier(0.23, 1, 0.32, 1)",
  easeInOutQuinticCurve: "cubic-bezier(0.86, 0, 0.07, 1)",
  linearCurve: "cubic-bezier(0, 0, 1, 1)"
}, breakpoints$1 = {
  small: 320,
  medium: 600,
  large: 1136
}, grid$1 = {
  columns: [4, 8, 12],
  gutters: [16, 36, 36],
  margins: [16, 36, 64],
  gaps: 0,
  unit: "px",
  maxWidth: 1280
}, getMediaQuery = function n(t) {
  return "@media screen and (min-width: ".concat(t, "px)");
}, mediaQuery = {
  small: getMediaQuery(breakpoints$1.small),
  medium: getMediaQuery(breakpoints$1.medium),
  large: getMediaQuery(breakpoints$1.large)
}, sizing$1 = {
  scale0: "2px",
  scale100: "4px",
  scale200: "6px",
  scale300: "8px",
  scale400: "10px",
  scale500: "12px",
  scale550: "14px",
  scale600: "16px",
  scale650: "18px",
  scale700: "20px",
  scale750: "22px",
  scale800: "24px",
  scale850: "28px",
  scale900: "32px",
  scale950: "36px",
  scale1000: "40px",
  scale1200: "48px",
  scale1400: "56px",
  scale1600: "64px",
  scale2400: "96px",
  scale3200: "128px",
  scale4800: "192px"
};
function ownKeys$x(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$v(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$x(Object(g), !0).forEach(function(d) {
      _defineProperty$D(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$x(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$D(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var LightTheme = {
  name: "light-theme",
  colors: _objectSpread$v(_objectSpread$v(_objectSpread$v({}, lightColorTokens), getComponentColorTokens()), getSemanticColorTokens()),
  animation,
  breakpoints: breakpoints$1,
  borders,
  direction: "auto",
  grid: grid$1,
  lighting,
  mediaQuery,
  sizing: sizing$1,
  typography: getTypography(),
  // TODO(#2318) Remove it in the next v11 major version.
  // Do not use.
  zIndex: {
    modal: 2e3
  }
}, darkColorTokens = {
  // Primary Palette
  primaryA: colors$3.gray200,
  primaryB: colors$3.gray900,
  primary: colors$3.white,
  primary50: colors$3.gray50,
  primary100: colors$3.gray100,
  primary200: colors$3.gray200,
  primary300: colors$3.gray300,
  primary400: colors$3.gray400,
  primary500: colors$3.gray500,
  primary600: colors$3.gray600,
  primary700: colors$3.gray700,
  // Accent Palette
  accent: colors$3.blue400,
  accent50: colors$3.blue50,
  accent100: colors$3.blue100,
  accent200: colors$3.blue200,
  accent300: colors$3.blue300,
  accent400: colors$3.blue400,
  accent500: colors$3.blue500,
  accent600: colors$3.blue600,
  accent700: colors$3.blue700,
  // Negative Palette
  negative: colors$3.red500,
  negative50: colors$3.red50,
  negative100: colors$3.red100,
  negative200: colors$3.red200,
  negative300: colors$3.red300,
  negative400: colors$3.red400,
  negative500: colors$3.red500,
  negative600: colors$3.red600,
  negative700: colors$3.red700,
  // Warning Palette
  warning: colors$3.yellow500,
  warning50: colors$3.yellow50,
  warning100: colors$3.yellow100,
  warning200: colors$3.yellow200,
  warning300: colors$3.yellow300,
  warning400: colors$3.yellow400,
  warning500: colors$3.yellow500,
  warning600: colors$3.yellow600,
  warning700: colors$3.yellow700,
  // Positive Palette
  positive: colors$3.green400,
  positive50: colors$3.green50,
  positive100: colors$3.green100,
  positive200: colors$3.green200,
  positive300: colors$3.green300,
  positive400: colors$3.green400,
  positive500: colors$3.green500,
  positive600: colors$3.green600,
  positive700: colors$3.green700,
  // Monochrome Palette
  white: colors$3.white,
  black: colors$3.black,
  mono100: colors$3.gray300,
  mono200: colors$3.gray400,
  mono300: colors$3.gray500,
  mono400: colors$3.gray600,
  mono500: colors$3.gray700,
  // mono600 and mono900 are not in official brand tokens atm
  mono600: "#292929",
  mono700: "#1F1F1F",
  mono800: "#141414",
  mono900: "#111111",
  mono1000: colors$3.black,
  // Rating Palette,
  ratingInactiveFill: colors$3.gray500,
  ratingStroke: colors$3.gray700
}, _excluded$r = ["primaryFontFamily"];
function ownKeys$w(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$u(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$w(Object(g), !0).forEach(function(d) {
      _defineProperty$C(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$w(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$C(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function _objectWithoutProperties$t(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$t(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$t(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function createLightTheme() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0, g = n.primaryFontFamily, d = _objectWithoutProperties$t(n, _excluded$r), k = _objectSpread$u(_objectSpread$u({}, lightColorTokens), d), H = {
    animation,
    borders,
    breakpoints: breakpoints$1,
    colors: _objectSpread$u(_objectSpread$u(_objectSpread$u({}, k), getComponentColorTokens(k)), getSemanticColorTokens(k)),
    direction: "auto",
    grid: grid$1,
    lighting,
    mediaQuery,
    sizing: sizing$1,
    // If primaryFontFamily is not provided, we use our default font tokens
    typography: g ? getTypography({
      primaryFontFamily: g
    }) : getTypography(),
    // TODO(#2318) Remove in v11, the next major version.
    // Do not use.
    zIndex: {
      modal: 2e3
    }
  };
  return deepMerge$1(H, t);
}
function ownKeys$v(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$t(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$v(Object(g), !0).forEach(function(d) {
      _defineProperty$B(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$v(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$B(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var primitives$1 = _objectSpread$t(_objectSpread$t({}, darkColorTokens), defaultFontTokens);
function ownKeys$u(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$s(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$u(Object(g), !0).forEach(function(d) {
      _defineProperty$A(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$u(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$A(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var primitives = _objectSpread$s(_objectSpread$s({}, lightColorTokens), defaultFontTokens), ThemeContext = /* @__PURE__ */ React.createContext(LightTheme), ThemeProvider$1 = function n(t) {
  var g = t.theme, d = t.children;
  return /* @__PURE__ */ React.createElement(ThemeContext.Provider, {
    value: g
  }, d);
};
function driver(n, t) {
  const g = renderDeclarativeRules(n, t);
  return t.renderStyle(g);
}
function getInitialStyle() {
  return {};
}
function renderDeclarativeRules(n, t) {
  for (const g in n) {
    const d = n[g];
    if (g === "animationName" && typeof d != "string") {
      n.animationName = t.renderKeyframes(d);
      continue;
    }
    if (g === "fontFamily" && typeof d != "string")
      if (Array.isArray(d)) {
        let k = "";
        for (const H of d)
          typeof H == "object" ? k += `${t.renderFontFace(H)},` : typeof H == "string" && (k += `${H},`);
        n.fontFamily = k.slice(0, -1);
        continue;
      } else {
        if (d === void 0)
          continue;
        n.fontFamily = t.renderFontFace(d);
        continue;
      }
    typeof d == "object" && d !== null && renderDeclarativeRules(d, t);
  }
  return n;
}
function addDebugMetadata(n, t) {
  const {
    stack: g,
    stacktrace: d,
    message: k
  } = new Error("stacktrace source");
  n.debug = {
    stackInfo: {
      stack: g,
      stacktrace: d,
      message: k
    },
    stackIndex: t
  };
}
const setupDevtoolsExtension = () => {
  const n = {}, t = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Map(), d = (k) => {
    const H = {};
    if (typeof k != "string")
      return H;
    if (g.has(k)) {
      H.styles = g.get(k);
      const AA = k.split(" ");
      if (AA.length) {
        const gA = {};
        AA.forEach((IA) => {
          gA[IA] = n[IA];
        }), H.classes = gA;
      }
      if (t.has(k)) {
        const gA = t.get(k);
        H.extends = gA;
      }
      return H;
    }
  };
  window.__STYLETRON_DEVTOOLS__ = {
    atomicMap: n,
    extensionsMap: t,
    stylesMap: g,
    getStyles: d
  };
};
function _extends$K() {
  return _extends$K = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$K.apply(this, arguments);
}
const noopEngine = {
  renderStyle: () => "",
  renderKeyframes: () => "",
  renderFontFace: () => ""
}, StyletronContext = /* @__PURE__ */ React.createContext(noopEngine), HydrationContext = /* @__PURE__ */ React.createContext(!1), DebugEngineContext = /* @__PURE__ */ React.createContext(void 0);
class DevProvider extends React.Component {
  constructor(t) {
    super(t), this.state = {
      hydrating: !!t.debugAfterHydration
    };
  }
  componentDidMount() {
    this.state.hydrating === !0 && this.setState({
      hydrating: !1
    });
  }
  render() {
    return /* @__PURE__ */ React.createElement(StyletronContext.Provider, {
      value: this.props.value
    }, /* @__PURE__ */ React.createElement(DebugEngineContext.Provider, {
      value: this.props.debug
    }, /* @__PURE__ */ React.createElement(HydrationContext.Provider, {
      value: this.state.hydrating
    }, this.props.children)));
  }
}
const Provider$1 = process.env.NODE_ENV !== "production" ? DevProvider : StyletronContext.Provider;
process.env.NODE_ENV !== "production" && !window.__STYLETRON_DEVTOOLS__ && setupDevtoolsExtension();
function checkNoopEngine(n) {
  process.env.NODE_ENV !== "test" && n === noopEngine && // eslint-disable-next-line no-console
  console.warn(process.env.NODE_ENV !== "production" ? `
Styletron has been switched to a no-op (test) mode.

A Styletron styled component was rendered, but no Styletron engine instance was provided in React context.

Did you forget to provide a Styletron engine instance to React context via using the Styletron provider component?

Note: Providers and Consumers must come from the exact same React.createContext call to work.
If your app has multiple instances of the "styletron-react" package in your node_module tree,
your Provider may be coming from a different React.createContext call, which means the styled components
will not recieve the provided engine instance. This scenario can arise, for example, when using "npm link".
` : "Styletron Provider is not set up. Defaulting to no-op.");
}
function useStyletron$1() {
  const n = React.useContext(StyletronContext), t = React.useContext(DebugEngineContext), g = React.useContext(HydrationContext);
  checkNoopEngine(n);
  const d = React.useRef(""), k = React.useRef([]);
  return [function(AA) {
    const gA = driver(AA, n);
    if (process.env.NODE_ENV === "production")
      return gA;
    const {
      stack: IA,
      message: CA
    } = new Error("stacktrace source"), BA = [t, g];
    return (k.current[0] !== BA[0] || k.current[1] !== BA[1]) && (t && !g && (d.current = t.debug({
      stackInfo: {
        stack: IA,
        message: CA
      },
      stackIndex: 1
    })), k.current = BA), d.current ? `${d.current} ${gA}` : gA;
  }];
}
function createStyled({
  getInitialStyle: n,
  driver: t,
  wrapper: g
}) {
  function d(k, H) {
    process.env.NODE_ENV !== "production" && k.__STYLETRON__ && (console.warn("It appears you are passing a styled component into `styled`."), console.warn("For composition with existing styled components, use `withStyle` or `withTransform` instead."));
    const AA = {
      reducers: [],
      base: k,
      driver: t,
      getInitialStyle: n,
      wrapper: g
    };
    return process.env.NODE_ENV !== "production" && addDebugMetadata(AA, 2), createStyledElementComponent(autoComposeShallow(AA, H));
  }
  return d;
}
const withStyleDeep = (n, t) => {
  const g = n.__STYLETRON__;
  return process.env.NODE_ENV !== "production" && (g || console.warn("The first parameter to `withStyle` must be a styled component (without extra wrappers).")), process.env.NODE_ENV !== "production" ? (addDebugMetadata(g, 2), createStyledElementComponent(addExtension(autoComposeDeep(g, t), n, t))) : createStyledElementComponent(autoComposeDeep(g, t));
}, withStyle$1 = withStyleDeep, withWrapper$1 = (n, t) => {
  const g = n.__STYLETRON__;
  process.env.NODE_ENV !== "production" && (g || console.warn("The first parameter to `withWrapper` must be a styled component (without extra wrappers)."));
  const d = {
    getInitialStyle: g.getInitialStyle,
    base: g.base,
    driver: g.driver,
    wrapper: t,
    reducers: g.reducers
  };
  return process.env.NODE_ENV !== "production" && addDebugMetadata(d, 2), createStyledElementComponent(d);
};
function autoComposeShallow(n, t) {
  return typeof t == "function" ? dynamicComposeShallow(n, t) : staticComposeShallow(n, t);
}
function addExtension(n, t, g) {
  return {
    ...n,
    ext: {
      with: g,
      name: t.displayName,
      base: t.__STYLETRON__.base,
      getInitialStyle: t.__STYLETRON__.reducers.length ? t.__STYLETRON__.reducers[0].reducer : t.__STYLETRON__.getInitialStyle
    }
  };
}
function autoComposeDeep(n, t) {
  return typeof t == "function" ? dynamicComposeDeep(n, t) : staticComposeDeep(n, t);
}
function staticComposeShallow(n, t) {
  return composeStatic(n, createShallowMergeReducer(t));
}
function staticComposeDeep(n, t) {
  return composeStatic(n, createDeepMergeReducer(t));
}
function dynamicComposeShallow(n, t) {
  return composeDynamic(n, (g, d) => shallowMerge(g, t(d)));
}
function dynamicComposeDeep(n, t) {
  return composeDynamic(n, (g, d) => deepMerge(g, t(d)));
}
function createShallowMergeReducer(n) {
  return {
    reducer: (t) => shallowMerge(t, n),
    assignmentCommutative: !0,
    factory: createShallowMergeReducer,
    style: n
  };
}
function createDeepMergeReducer(n) {
  return {
    reducer: (t) => deepMerge(t, n),
    assignmentCommutative: !0,
    factory: createDeepMergeReducer,
    style: n
  };
}
function composeStatic(n, t) {
  if (n.reducers.length === 0) {
    const g = t.reducer(n.getInitialStyle()), d = {
      reducers: n.reducers,
      base: n.base,
      driver: n.driver,
      wrapper: n.wrapper,
      getInitialStyle: () => g
    };
    return process.env.NODE_ENV !== "production" && (d.debug = n.debug), d;
  } else {
    const g = n.reducers[0];
    if (g.assignmentCommutative === !0 && t.assignmentCommutative === !0) {
      const d = t.reducer(g.style), k = {
        getInitialStyle: n.getInitialStyle,
        base: n.base,
        driver: n.driver,
        wrapper: n.wrapper,
        reducers: [g.factory(d)].concat(n.reducers.slice(1))
      };
      return process.env.NODE_ENV !== "production" && (k.debug = n.debug), k;
    }
    return composeDynamic(n, t.reducer);
  }
}
function composeDynamic(n, t) {
  const g = {
    getInitialStyle: n.getInitialStyle,
    base: n.base,
    driver: n.driver,
    wrapper: n.wrapper,
    // @ts-ignore
    reducers: [{
      assignmentCommutative: !1,
      reducer: t
    }].concat(n.reducers)
  };
  return process.env.NODE_ENV !== "production" && (g.debug = n.debug), g;
}
function createStyledElementComponent(n) {
  const {
    reducers: t,
    base: g,
    driver: d,
    wrapper: k,
    getInitialStyle: H,
    ext: AA
  } = n;
  if (process.env.NODE_ENV !== "production") {
    var gA, IA;
    n.debug && (gA = n.debug.stackInfo, IA = n.debug.stackIndex);
  }
  if (process.env.NODE_ENV !== "production")
    var CA;
  const eA = k(/* @__PURE__ */ React.forwardRef((iA, QA) => {
    const tA = React.useContext(StyletronContext), oA = React.useContext(DebugEngineContext), EA = React.useContext(HydrationContext);
    checkNoopEngine(tA);
    const aA = omitPrefixedKeys(iA);
    let nA = resolveStyle(H, t, iA);
    iA.$style && (typeof iA.$style == "function" ? nA = deepMerge(nA, iA.$style(iA)) : nA = deepMerge(nA, iA.$style));
    const lA = d(nA, tA), cA = iA.$as ? iA.$as : g;
    if (aA.className = iA.className ? `${iA.className} ${lA}` : lA, process.env.NODE_ENV !== "production" && oA && !EA) {
      CA || (CA = oA.debug({
        stackInfo: gA,
        stackIndex: IA
      }));
      const sA = `${CA} ${aA.className}`;
      aA.className = sA;
    }
    return process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && (window.__STYLETRON_DEVTOOLS__.stylesMap.set(aA.className, nA), AA && window.__STYLETRON_DEVTOOLS__.extensionsMap.set(aA.className, {
      base: AA.base,
      displayName: AA.name,
      initialStyles: AA.getInitialStyle({}, iA),
      styleOverrides: typeof AA.with == "function" ? AA.with(iA) : AA.with
    })), iA.$ref && console.warn("The prop `$ref` has been deprecated. Use `ref` instead. Refs are now forwarded with React.forwardRef."), /* @__PURE__ */ React.createElement(cA, _extends$K({}, aA, {
      ref: QA || iA.$ref
    }));
  }));
  if (eA.__STYLETRON__ = {
    base: g,
    reducers: t,
    driver: d,
    wrapper: k,
    getInitialStyle: H
  }, process.env.NODE_ENV !== "production") {
    let iA;
    typeof g == "string" ? iA = g : g.displayName ? iA = g.displayName : g.name ? iA = g.name : iA = "Unknown", eA.displayName = `Styled(${iA})`;
  }
  return eA;
}
function resolveStyle(n, t, g) {
  let d = n(), k = t.length;
  for (; k--; ) {
    const H = t[k].reducer;
    d = H(d, g);
  }
  return d;
}
function isObject$7(n) {
  return typeof n == "object" && n !== null;
}
function omitPrefixedKeys(n) {
  const t = {};
  for (const g in n)
    g[0] !== "$" && (t[g] = n[g]);
  return t;
}
function deepMerge(n, t) {
  const g = assign({}, n);
  for (const d in t) {
    const k = t[d];
    isObject$7(k) && isObject$7(n[d]) ? g[d] = deepMerge(n[d], k) : g[d] = k;
  }
  return g;
}
function shallowMerge(n, t) {
  return assign(assign({}, n), t);
}
function assign(n, t) {
  for (const g in t)
    n[g] = t[g];
  return n;
}
function ownKeys$t(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$r(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$t(Object(g), !0).forEach(function(d) {
      _defineProperty$z(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$t(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$z(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function _slicedToArray$n(n, t) {
  return _arrayWithHoles$m(n) || _iterableToArrayLimit$m(n, t) || _unsupportedIterableToArray$n(n, t) || _nonIterableRest$m();
}
function _nonIterableRest$m() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$n(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$n(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$n(n, t);
  }
}
function _arrayLikeToArray$n(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$m(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$m(n) {
  if (Array.isArray(n)) return n;
}
function _extends$J() {
  return _extends$J = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$J.apply(this, arguments);
}
var wrapper = function n(t) {
  return /* @__PURE__ */ React.forwardRef(function(g, d) {
    return /* @__PURE__ */ React.createElement(ThemeContext.Consumer, null, function(k) {
      return /* @__PURE__ */ React.createElement(t, _extends$J({
        ref: d
      }, g, {
        $theme: k
      }));
    });
  });
};
function createThemedStyled() {
  return createStyled({
    wrapper,
    getInitialStyle,
    driver
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  });
}
var styled = createThemedStyled();
function createThemedWithStyle() {
  return withStyle$1;
}
var withStyle = createThemedWithStyle();
function createThemedUseStyletron() {
  return function() {
    var n = React.useContext(ThemeContext), t = useStyletron$1(), g = _slicedToArray$n(t, 1), d = g[0];
    return [d, n];
  };
}
var useStyletron = createThemedUseStyletron();
function withWrapper(n, t) {
  return withWrapper$1(n, function(g) {
    return /* @__PURE__ */ React.forwardRef(function(d, k) {
      return /* @__PURE__ */ React.createElement(ThemeContext.Consumer, null, function(H) {
        return (
          // @ts-ignore
          t(g)(_objectSpread$r(_objectSpread$r({
            ref: k
          }, d), {}, {
            $theme: H
          }))
        );
      });
    });
  });
}
function getSvgStyles$1(n) {
  var t = n.$theme, g = n.$size, d = n.$color, k = t.sizing.scale600;
  g && (t.sizing[g] ? k = t.sizing[g] : typeof g == "number" ? k = "".concat(g, "px") : k = g);
  var H = "currentColor";
  return d && (t.colors[d] ? H = t.colors[d] : H = d), {
    display: "inline-block",
    fill: H,
    color: H,
    height: k,
    width: k
  };
}
var Svg = styled("svg", getSvgStyles$1);
Svg.displayName = "Svg";
Svg.displayName = "Svg";
function _objectDestructuringEmpty(n) {
  if (n == null) throw new TypeError("Cannot destructure undefined");
}
function ownKeys$s(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$q(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$s(Object(g), !0).forEach(function(d) {
      _defineProperty$y(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$s(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$y(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function getBackgroundColor$1(n, t, g) {
  var d, k = t === TYPE$1.inline;
  return (d = {}, _defineProperty$y(d, KIND$1.info, k ? g.colors.notificationInfoBackground : g.colors.toastInfoBackground), _defineProperty$y(d, KIND$1.positive, k ? g.colors.notificationPositiveBackground : g.colors.toastPositiveBackground), _defineProperty$y(d, KIND$1.warning, k ? g.colors.notificationWarningBackground : g.colors.toastWarningBackground), _defineProperty$y(d, KIND$1.negative, k ? g.colors.notificationNegativeBackground : g.colors.toastNegativeBackground), d)[n];
}
function getFontColor$1(n, t, g) {
  var d, k = t === TYPE$1.inline;
  if (k) {
    var H;
    return (H = {}, _defineProperty$y(H, KIND$1.info, g.colors.notificationInfoText), _defineProperty$y(H, KIND$1.positive, g.colors.notificationPositiveText), _defineProperty$y(H, KIND$1.warning, g.colors.notificationWarningText), _defineProperty$y(H, KIND$1.negative, g.colors.notificationNegativeText), H)[n];
  }
  return (d = {}, _defineProperty$y(d, KIND$1.info, g.colors.toastInfoText), _defineProperty$y(d, KIND$1.positive, g.colors.toastPositiveText), _defineProperty$y(d, KIND$1.warning, g.colors.toastWarningText), _defineProperty$y(d, KIND$1.negative, g.colors.toastNegativeText), d)[n];
}
function getPlacement(n) {
  switch (n) {
    case PLACEMENT$1.topLeft:
      return {
        top: 0,
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column"
      };
    case PLACEMENT$1.top:
      return {
        top: 0,
        alignItems: "center",
        justifyContent: "flex-start",
        flexDirection: "column"
      };
    case PLACEMENT$1.topRight:
      return {
        top: 0,
        alignItems: "flex-end",
        justifyContent: "flex-start",
        flexDirection: "column"
      };
    case PLACEMENT$1.bottomRight:
      return {
        bottom: 0,
        alignItems: "flex-end",
        justifyContent: "flex-end",
        flexDirection: "column-reverse"
      };
    case PLACEMENT$1.bottom:
      return {
        bottom: 0,
        alignItems: "center",
        justifyContent: "flex-end",
        flexDirection: "column-reverse"
      };
    case PLACEMENT$1.bottomLeft:
      return {
        bottom: 0,
        alignItems: "flex-start",
        justifyContent: "flex-end",
        flexDirection: "column-reverse"
      };
  }
}
var Root$3 = styled("div", function(n) {
  var t = n.$placement, g = n.$theme;
  return _objectSpread$q({
    pointerEvents: "none",
    position: "fixed",
    right: 0,
    left: 0,
    display: "flex",
    marginTop: g.sizing.scale300,
    marginBottom: g.sizing.scale300,
    marginLeft: g.sizing.scale600,
    marginRight: g.sizing.scale600
  }, getPlacement(t));
});
Root$3.displayName = "Root";
Root$3.displayName = "Root";
var InnerContainer = styled(
  "div",
  // eslint-disable-next-line no-empty-pattern
  function(n) {
    return _objectDestructuringEmpty(n), {};
  }
);
InnerContainer.displayName = "InnerContainer";
InnerContainer.displayName = "InnerContainer";
var Body$3 = styled("div", function(n) {
  var t = n.$isVisible, g = n.$kind, d = n.$type, k = n.$theme, H = d === TYPE$1.inline;
  return _objectSpread$q(_objectSpread$q({}, k.typography.font300), {}, {
    pointerEvents: "auto",
    color: getFontColor$1(g, d, k),
    height: "auto",
    width: "288px",
    paddingTop: k.sizing.scale600,
    paddingRight: k.sizing.scale600,
    paddingBottom: k.sizing.scale600,
    paddingLeft: k.sizing.scale600,
    marginTop: k.sizing.scale300,
    marginBottom: k.sizing.scale300,
    backgroundColor: getBackgroundColor$1(g, d, k) || k.colors.accent,
    borderTopLeftRadius: k.borders.radius400,
    borderTopRightRadius: k.borders.radius400,
    borderBottomRightRadius: k.borders.radius400,
    borderBottomLeftRadius: k.borders.radius400,
    boxShadow: H ? "none" : k.lighting.shadow600,
    opacity: t ? 1 : 0,
    transitionProperty: "all",
    transitionDuration: k.animation.timing200,
    transitionTimingFunction: k.animation.easeInOutCurve,
    display: "flex",
    justifyContent: "space-between"
  });
});
Body$3.displayName = "Body";
Body$3.displayName = "Body";
var CloseIconSvg = styled("svg", function(n) {
  var t = n.$theme, g = n.$size, d = n.$color, k = n.$isFocusVisible;
  return _objectSpread$q(_objectSpread$q({}, getSvgStyles$1({
    $theme: t,
    $size: g,
    $color: d
  })), {}, {
    cursor: "pointer",
    width: g || "16px",
    flexShrink: 0,
    outline: k ? "3px solid ".concat(t.colors.accent) : "none"
  });
});
CloseIconSvg.displayName = "CloseIconSvg";
CloseIconSvg.displayName = "CloseIconSvg";
function omitDollarPrefixedKeys(n) {
  var t = {};
  for (var g in n)
    g[0] !== "$" && (t[g] = n[g]);
  return t;
}
var _excluded$q = ["children", "title", "size", "color", "overrides"];
function _extends$I() {
  return _extends$I = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$I.apply(this, arguments);
}
function ownKeys$r(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$p(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$r(Object(g), !0).forEach(function(d) {
      _defineProperty$x(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$r(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$x(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function _slicedToArray$m(n, t) {
  return _arrayWithHoles$l(n) || _iterableToArrayLimit$l(n, t) || _unsupportedIterableToArray$m(n, t) || _nonIterableRest$l();
}
function _nonIterableRest$l() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$m(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$m(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$m(n, t);
  }
}
function _arrayLikeToArray$m(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$l(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$l(n) {
  if (Array.isArray(n)) return n;
}
function _objectWithoutProperties$s(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$s(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$s(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
var Icon$1 = function n(t, g) {
  var d = t.children, k = t.title, H = t.size, AA = t.color, gA = t.overrides, IA = gA === void 0 ? {} : gA, CA = _objectWithoutProperties$s(t, _excluded$q), BA = getOverrides(IA.Svg, Svg), eA = _slicedToArray$m(BA, 2), iA = eA[0], QA = eA[1], tA = iA.__STYLETRON__ ? _objectSpread$p(_objectSpread$p({
    title: k,
    $color: AA,
    $size: H
  }, CA), QA) : _objectSpread$p(_objectSpread$p({
    title: k,
    color: AA,
    size: H
  }, omitDollarPrefixedKeys(CA)), omitDollarPrefixedKeys(QA));
  return /* @__PURE__ */ React.createElement(iA, _extends$I({
    "data-baseweb": "icon",
    ref: g
  }, tA), k ? /* @__PURE__ */ React.createElement("title", null, k) : null, d);
};
const Icon$2 = /* @__PURE__ */ React.forwardRef(Icon$1);
var _excluded$p = ["title", "size", "color", "overrides"];
function _extends$H() {
  return _extends$H = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$H.apply(this, arguments);
}
function _objectWithoutProperties$r(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$r(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$r(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _slicedToArray$l(n, t) {
  return _arrayWithHoles$k(n) || _iterableToArrayLimit$k(n, t) || _unsupportedIterableToArray$l(n, t) || _nonIterableRest$k();
}
function _nonIterableRest$k() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$l(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$l(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$l(n, t);
  }
}
function _arrayLikeToArray$l(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$k(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$k(n) {
  if (Array.isArray(n)) return n;
}
function Delete(n, t) {
  var g = useStyletron(), d = _slicedToArray$l(g, 2), k = d[1], H = n.title, AA = H === void 0 ? "Delete" : H, gA = n.size, IA = n.color, CA = n.overrides, BA = CA === void 0 ? {} : CA, eA = _objectWithoutProperties$r(n, _excluded$p), iA = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: k.icons && k.icons.Delete ? k.icons.Delete : null
    },
    BA && BA.Svg ? toObjectOverride(BA.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$2, _extends$H({
    viewBox: "0 0 24 24",
    ref: t,
    title: AA,
    size: gA,
    color: IA,
    overrides: {
      Svg: iA
    }
  }, eA), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 7.29289C7.68342 6.90237 8.31658 6.90237 8.70711 7.29289L12 10.5858L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711L13.4142 12L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L12 13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L10.5858 12L7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289Z"
  }));
}
const DeleteIcon = /* @__PURE__ */ React.forwardRef(Delete);
var locale$f = {
  collapse: "Collapse",
  expand: "Expand"
}, locale$e = {
  ariaLabel: "Breadcrumbs navigation"
}, locale$d = {
  ariaLabel: "Select a date.",
  ariaLabelRange: "Select a date range.",
  ariaLabelCalendar: "Calendar.",
  ariaRoleDescriptionCalendarMonth: "Calendar month",
  previousMonth: "Previous month.",
  nextMonth: "Next month.",
  pastWeek: "Past Week",
  pastMonth: "Past Month",
  pastThreeMonths: "Past 3 Months",
  pastSixMonths: "Past 6 Months",
  pastYear: "Past Year",
  pastTwoYears: "Past 2 Years",
  screenReaderMessageInput: "Press the down arrow key to interact with the calendar and select a date. Press the escape button to close the calendar.",
  selectedDate: "Selected date is ${date}.",
  selectedDateRange: "Selected date range is from ${startDate} to ${endDate}.",
  selectSecondDatePrompt: "Select the second date.",
  quickSelectLabel: "Choose a date range",
  quickSelectAriaLabel: "Choose a date range",
  quickSelectPlaceholder: "None",
  timeSelectEndLabel: "End time",
  timeSelectStartLabel: "Start time",
  timePickerAriaLabel12Hour: "Select a time, 12-hour format.",
  timePickerAriaLabel24Hour: "Select a time, 24-hour format.",
  timezonePickerAriaLabel: "Select a timezone.",
  selectedStartDateLabel: "Selected start date.",
  selectedEndDateLabel: "Selected end date.",
  dateNotAvailableLabel: "Not available.",
  dateAvailableLabel: "It's available.",
  selectedLabel: "Selected.",
  chooseLabel: "Choose"
}, locale$c = {
  emptyState: "No rows match the filter criteria defined. Please remove one or more filters to view more data.",
  loadingState: "Loading rows.",
  searchAriaLabel: "Search by text",
  filterAdd: "Add Filter",
  filterExclude: "Exclude",
  filterApply: "Apply",
  filterExcludeRange: "Exclude range",
  filterExcludeValue: "Exclude value",
  filterAppliedTo: "filter applied to",
  optionsLabel: "Select column to filter by",
  optionsSearch: "Search for a column to filter by...",
  optionsEmpty: "No columns available.",
  categoricalFilterSelectAll: "Select All",
  categoricalFilterSelectClear: "Clear",
  categoricalFilterEmpty: "No categories found",
  datetimeFilterRange: "Range",
  datetimeFilterRangeDatetime: "Date, Time",
  datetimeFilterRangeDate: "Date",
  datetimeFilterRangeTime: "Time",
  datetimeFilterCategorical: "Categorical",
  datetimeFilterCategoricalWeekday: "Weekday",
  datetimeFilterCategoricalMonth: "Month",
  datetimeFilterCategoricalQuarter: "Quarter",
  datetimeFilterCategoricalHalf: "Half",
  datetimeFilterCategoricalFirstHalf: "H1",
  datetimeFilterCategoricalSecondHalf: "H2",
  datetimeFilterCategoricalYear: "Year",
  numericalFilterRange: "Range",
  numericalFilterSingleValue: "Single Value",
  booleanFilterTrue: "true",
  booleanFilterFalse: "false",
  booleanColumnTrueShort: "T",
  booleanColumnFalseShort: "F",
  selectRow: "Select row",
  selectAllRows: "Select all rows"
}, locale$b = {
  ariaLabel: "button group"
}, locale$a = {
  dropFilesToUpload: "Drop files here to upload...",
  or: "",
  browseFiles: "Browse files",
  retry: "Retry Upload",
  cancel: "Cancel"
}, locale$9 = {
  noResultsMsg: "No results",
  parentMenuItemAriaLabel: "You are currently at an item that opens a nested listbox. Press right arrow to enter that element and left arrow to return."
}, locale$8 = {
  close: "Close"
}, locale$7 = {
  close: "Close"
}, locale$6 = {
  prev: "Prev",
  next: "Next",
  preposition: "of"
}, locale$5 = {
  // Remove noResultsMsg prop in the next major version
  noResultsMsg: "No results found",
  placeholder: "Select...",
  create: "Create"
}, locale$4 = {
  close: "Close"
}, en_US = {
  accordion: locale$f,
  breadcrumbs: locale$e,
  datepicker: locale$d,
  datatable: locale$c,
  buttongroup: locale$b,
  fileuploader: locale$a,
  menu: locale$9,
  modal: locale$8,
  drawer: locale$7,
  pagination: locale$6,
  select: locale$5,
  toast: locale$4
}, LocaleContext = /* @__PURE__ */ React.createContext(en_US), initialized = !1, hadKeyboardEvent = !0, inputTypesWhitelist = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function focusTriggersKeyboardModality(n) {
  var t = n.type, g = n.tagName;
  return !!(g === "INPUT" && inputTypesWhitelist[t] && !n.readOnly || g === "TEXTAREA" && !n.readOnly || n.isContentEditable);
}
function handleKeyDown(n) {
  n.metaKey || n.altKey || n.ctrlKey || (hadKeyboardEvent = !0);
}
function handlePointerDown() {
  hadKeyboardEvent = !1;
}
function handleVisibilityChange() {
  this.visibilityState;
}
function prepare$1(n) {
  n.addEventListener("keydown", handleKeyDown, !0), n.addEventListener("mousedown", handlePointerDown, !0), n.addEventListener("pointerdown", handlePointerDown, !0), n.addEventListener("touchstart", handlePointerDown, !0), n.addEventListener("visibilitychange", handleVisibilityChange, !0);
}
function isFocusVisible(n) {
  try {
    return n.target.matches(":focus-visible");
  } catch {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(n.target);
}
function initFocusVisible(n) {
  !initialized && n != null && (initialized = !0, prepare$1(n.ownerDocument));
}
var forkFocus = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function n(t, g) {
    return function(d) {
      typeof t.onFocus == "function" && t.onFocus(d), g(d);
    };
  }
), forkBlur = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function n(t, g) {
    return function(d) {
      typeof t.onBlur == "function" && t.onBlur(d), g(d);
    };
  }
);
function _typeof$k(n) {
  "@babel/helpers - typeof";
  return _typeof$k = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$k(n);
}
function _extends$G() {
  return _extends$G = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$G.apply(this, arguments);
}
function _slicedToArray$k(n, t) {
  return _arrayWithHoles$j(n) || _iterableToArrayLimit$j(n, t) || _unsupportedIterableToArray$k(n, t) || _nonIterableRest$j();
}
function _nonIterableRest$j() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$k(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$k(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$k(n, t);
  }
}
function _arrayLikeToArray$k(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$j(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$j(n) {
  if (Array.isArray(n)) return n;
}
function _classCallCheck$o(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$g(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$o(n, t, g) {
  return t && _defineProperties$g(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$o(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$h(n, t);
}
function _setPrototypeOf$h(n, t) {
  return _setPrototypeOf$h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$h(n, t);
}
function _createSuper$g(n) {
  var t = _isNativeReflectConstruct$g();
  return function() {
    var d = _getPrototypeOf$g(n), k;
    if (t) {
      var H = _getPrototypeOf$g(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$o(this, k);
  };
}
function _possibleConstructorReturn$o(n, t) {
  if (t && (_typeof$k(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$h(n);
}
function _assertThisInitialized$h(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$g() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$g(n) {
  return _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$g(n);
}
function _defineProperty$w(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var Toast$1 = /* @__PURE__ */ (function(n) {
  _inherits$o(g, n);
  var t = _createSuper$g(g);
  function g(d) {
    var k;
    return _classCallCheck$o(this, g), k = t.call(this, d), _defineProperty$w(_assertThisInitialized$h(k), "autoHideTimeout", void 0), _defineProperty$w(_assertThisInitialized$h(k), "animateInTimer", void 0), _defineProperty$w(_assertThisInitialized$h(k), "animateOutCompleteTimer", void 0), _defineProperty$w(_assertThisInitialized$h(k), "closeRef", void 0), _defineProperty$w(_assertThisInitialized$h(k), "previouslyFocusedElement", void 0), _defineProperty$w(_assertThisInitialized$h(k), "state", {
      isVisible: !1,
      isRendered: !0,
      isFocusVisible: !1
    }), _defineProperty$w(_assertThisInitialized$h(k), "handleFocus", function(H) {
      isFocusVisible(H) && k.setState({
        isFocusVisible: !0
      });
    }), _defineProperty$w(_assertThisInitialized$h(k), "handleBlur", function(H) {
      k.state.isFocusVisible !== !1 && k.setState({
        isFocusVisible: !1
      });
    }), _defineProperty$w(_assertThisInitialized$h(k), "animateIn", function() {
      k.animateInTimer = setTimeout(function() {
        k.setState({
          isVisible: !0
        });
      }, 0);
    }), _defineProperty$w(_assertThisInitialized$h(k), "animateOut", function() {
      var H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
      };
      k.setState({
        isVisible: !1
      }), k.animateOutCompleteTimer = setTimeout(function() {
        k.setState({
          isRendered: !1
        }), H();
      }, 600);
    }), _defineProperty$w(_assertThisInitialized$h(k), "dismiss", function() {
      k.animateOut(k.props.onClose), k.props.autoFocus && k.previouslyFocusedElement && k.previouslyFocusedElement.focus();
    }), _defineProperty$w(_assertThisInitialized$h(k), "onFocus", function(H) {
      k.state.isVisible && (clearTimeout(k.autoHideTimeout), clearTimeout(k.animateOutCompleteTimer), typeof k.props.onFocus == "function" && k.props.onFocus(H));
    }), _defineProperty$w(_assertThisInitialized$h(k), "onMouseEnter", function(H) {
      k.state.isVisible && (clearTimeout(k.autoHideTimeout), clearTimeout(k.animateOutCompleteTimer), typeof k.props.onMouseEnter == "function" && k.props.onMouseEnter(H));
    }), _defineProperty$w(_assertThisInitialized$h(k), "onBlur", function(H) {
      k.startTimeout(), typeof k.props.onBlur == "function" && k.props.onBlur(H);
    }), _defineProperty$w(_assertThisInitialized$h(k), "onMouseLeave", function(H) {
      k.startTimeout(), typeof k.props.onMouseLeave == "function" && k.props.onMouseLeave(H);
    }), k.closeRef = /* @__PURE__ */ React.createRef(), k.previouslyFocusedElement = null, k;
  }
  return _createClass$o(g, [{
    key: "componentDidMount",
    value: function() {
      this.animateIn(), this.startTimeout(), typeof document < "u" && this.props.autoFocus && this.closeRef && this.closeRef.current && this.closeRef.current.focus && typeof this.closeRef.current.focus == "function" && (this.previouslyFocusedElement = document.activeElement, this.closeRef.current.focus(), this.setState({
        isFocusVisible: !0
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function(k) {
      (this.props.autoHideDuration !== k.autoHideDuration || this.props.__updated !== k.__updated) && this.startTimeout();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearTimeout();
    }
  }, {
    key: "startTimeout",
    value: function() {
      this.props.autoHideDuration && (this.autoHideTimeout && clearTimeout(this.autoHideTimeout), this.autoHideTimeout = setTimeout(this.dismiss, this.props.autoHideDuration));
    }
  }, {
    key: "clearTimeout",
    value: (function(d) {
      function k() {
        return d.apply(this, arguments);
      }
      return k.toString = function() {
        return d.toString();
      }, k;
    })(function() {
      [this.autoHideTimeout, this.animateInTimer, this.animateOutCompleteTimer].forEach(function(d) {
        d && clearTimeout(d);
      });
    })
  }, {
    key: "getSharedProps",
    value: function() {
      var k = this.props, H = k.kind, AA = k.notificationType, gA = k.closeable, IA = this.state, CA = IA.isRendered, BA = IA.isVisible;
      return {
        $kind: H,
        $type: AA,
        $closeable: gA,
        $isRendered: CA,
        $isVisible: BA
      };
    }
  }, {
    key: "render",
    value: function() {
      var k = this, H = this.props, AA = H.children, gA = H.closeable, IA = this.state.isRendered, CA = this.props.overrides, BA = CA.Body, eA = CA.CloseIcon, iA = CA.InnerContainer, QA = getOverrides(BA, Body$3), tA = _slicedToArray$k(QA, 2), oA = tA[0], EA = tA[1], aA = getOverrides(iA, InnerContainer), nA = _slicedToArray$k(aA, 2), lA = nA[0], cA = nA[1], sA = getOverrides(eA, CloseIconSvg), rA = _slicedToArray$k(sA, 2), uA = rA[0], hA = rA[1], dA = mergeOverrides({
        Svg: {
          component: uA
        }
      }, {
        Svg: eA
      }), GA = this.getSharedProps();
      return IA ? /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(DA) {
        return /* @__PURE__ */ React.createElement(oA, _extends$G({
          role: "alert",
          "data-baseweb": k.props["data-baseweb"] || "toast"
        }, GA, EA, {
          // the properties below have to go after overrides
          onBlur: k.onBlur,
          onFocus: k.onFocus,
          onMouseEnter: k.onMouseEnter,
          onMouseLeave: k.onMouseLeave
        }), /* @__PURE__ */ React.createElement(lA, _extends$G({}, GA, cA), typeof AA == "function" ? AA({
          dismiss: k.dismiss
        }) : AA), gA ? /* @__PURE__ */ React.createElement(DeleteIcon, _extends$G({
          ref: k.closeRef,
          role: "button",
          tabIndex: 0,
          $isFocusVisible: k.state.isFocusVisible,
          onClick: k.dismiss,
          onKeyPress: function(bA) {
            bA.key === "Enter" && k.dismiss();
          },
          title: DA.toast.close
        }, GA, hA, {
          onFocus: forkFocus(hA, k.handleFocus),
          onBlur: forkBlur(hA, k.handleBlur),
          overrides: dA
        })) : null);
      }) : null;
    }
  }]), g;
})(React.Component);
_defineProperty$w(Toast$1, "defaultProps", {
  autoFocus: !1,
  autoHideDuration: 0,
  closeable: !0,
  kind: KIND$1.info,
  notificationType: TYPE$1.toast,
  // Do we need a separate handler for
  // when a notification dismisses automatically
  onClose: function n() {
  },
  onBlur: function n() {
  },
  onFocus: function n() {
  },
  onMouseEnter: function n() {
  },
  onMouseLeave: function n() {
  },
  overrides: {}
});
function _typeof$j(n) {
  "@babel/helpers - typeof";
  return _typeof$j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$j(n);
}
var _excluded$o = ["onClose", "children", "key"];
function _slicedToArray$j(n, t) {
  return _arrayWithHoles$i(n) || _iterableToArrayLimit$i(n, t) || _unsupportedIterableToArray$j(n, t) || _nonIterableRest$i();
}
function _nonIterableRest$i() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$i(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$i(n) {
  if (Array.isArray(n)) return n;
}
function _extends$F() {
  return _extends$F = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$F.apply(this, arguments);
}
function _objectWithoutProperties$q(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$q(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$q(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _toConsumableArray$4(n) {
  return _arrayWithoutHoles$4(n) || _iterableToArray$4(n) || _unsupportedIterableToArray$j(n) || _nonIterableSpread$4();
}
function _nonIterableSpread$4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$j(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$j(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$j(n, t);
  }
}
function _iterableToArray$4(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function _arrayWithoutHoles$4(n) {
  if (Array.isArray(n)) return _arrayLikeToArray$j(n);
}
function _arrayLikeToArray$j(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function ownKeys$q(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$o(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$q(Object(g), !0).forEach(function(d) {
      _defineProperty$v(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$q(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _classCallCheck$n(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$f(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$n(n, t, g) {
  return t && _defineProperties$f(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$n(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$g(n, t);
}
function _setPrototypeOf$g(n, t) {
  return _setPrototypeOf$g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$g(n, t);
}
function _createSuper$f(n) {
  var t = _isNativeReflectConstruct$f();
  return function() {
    var d = _getPrototypeOf$f(n), k;
    if (t) {
      var H = _getPrototypeOf$f(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$n(this, k);
  };
}
function _possibleConstructorReturn$n(n, t) {
  if (t && (_typeof$j(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$g(n);
}
function _assertThisInitialized$g(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$f() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$f(n) {
  return _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$f(n);
}
function _defineProperty$v(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var toasterRef, ToasterContainer = /* @__PURE__ */ (function(n) {
  _inherits$n(g, n);
  var t = _createSuper$f(g);
  function g(d) {
    var k;
    return _classCallCheck$n(this, g), k = t.call(this, d), _defineProperty$v(_assertThisInitialized$g(k), "state", {
      isMounted: !1,
      toasts: []
    }), _defineProperty$v(_assertThisInitialized$g(k), "dismissHandlers", {}), _defineProperty$v(_assertThisInitialized$g(k), "toastId", 0), _defineProperty$v(_assertThisInitialized$g(k), "getToastProps", function(H) {
      var AA = k.props, gA = AA.autoFocus, IA = AA.autoHideDuration, CA = AA.closeable, BA = H.key || "toast-".concat(k.toastId++);
      return _objectSpread$o(_objectSpread$o({
        autoFocus: gA,
        autoHideDuration: IA,
        closeable: CA
      }, H), {}, {
        key: BA
      });
    }), _defineProperty$v(_assertThisInitialized$g(k), "show", function() {
      var H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (k.state.toasts.map(function(gA) {
        return gA.key;
      }).includes(H.key))
        return k.update(H.key, H), H.key;
      var AA = k.getToastProps(H);
      return k.setState(function(gA) {
        var IA = gA.toasts;
        return {
          toasts: [].concat(_toConsumableArray$4(IA), [AA])
        };
      }), AA.key;
    }), _defineProperty$v(_assertThisInitialized$g(k), "update", function(H, AA) {
      k.setState(function(gA) {
        var IA = gA.toasts, CA = IA.map(function(BA) {
          if (BA.key === H) {
            var eA = _objectSpread$o(_objectSpread$o(_objectSpread$o({}, BA), k.getToastProps(_objectSpread$o({
              autoHideDuration: BA.autoHideDuration
            }, AA))), {}, {
              key: H
            }, k.props.resetAutoHideTimerOnUpdate ? {
              __updated: (+BA.__updated || 0) + 1
            } : {});
            return eA;
          }
          return BA;
        });
        return {
          toasts: CA
        };
      });
    }), _defineProperty$v(_assertThisInitialized$g(k), "dismiss", function(H) {
      k.dismissHandlers[H] && k.dismissHandlers[H]();
    }), _defineProperty$v(_assertThisInitialized$g(k), "clearAll", function() {
      Object.keys(k.dismissHandlers).forEach(function(H) {
        k.dismissHandlers[H]();
      });
    }), _defineProperty$v(_assertThisInitialized$g(k), "clear", function(H) {
      H === void 0 ? k.clearAll() : k.dismiss(H);
    }), _defineProperty$v(_assertThisInitialized$g(k), "internalOnClose", function(H) {
      delete k.dismissHandlers[H], k.setState(function(AA) {
        var gA = AA.toasts;
        return {
          toasts: gA.filter(function(IA) {
            return IA.key !== H;
          })
        };
      });
    }), _defineProperty$v(_assertThisInitialized$g(k), "getOnCloseHandler", function(H, AA) {
      return function() {
        k.internalOnClose(H), typeof AA == "function" && AA();
      };
    }), _defineProperty$v(_assertThisInitialized$g(k), "renderToast", function(H) {
      var AA = H.onClose, gA = H.children, IA = H.key, CA = _objectWithoutProperties$q(H, _excluded$o), BA = k.props.overrides, eA = BA.ToastBody, iA = BA.ToastCloseIcon, QA = BA.ToastInnerContainer, tA = mergeOverrides({
        Body: Body$3,
        CloseIcon: CloseIconSvg,
        InnerContainer
      }, {
        Body: eA || {},
        CloseIcon: iA || {},
        InnerContainer: QA || {}
      }), oA = mergeOverrides(tA, H.overrides);
      return /* @__PURE__ */ React.createElement(Toast$1, _extends$F({}, CA, {
        overrides: oA,
        key: IA,
        onClose: k.getOnCloseHandler(IA, AA)
      }), function(EA) {
        var aA = EA.dismiss;
        return k.dismissHandlers[IA] = aA, gA;
      });
    }), _defineProperty$v(_assertThisInitialized$g(k), "getSharedProps", function() {
      var H = k.props.placement;
      return {
        $placement: H
      };
    }), toasterRef = _assertThisInitialized$g(k), k;
  }
  return _createClass$n(g, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "render",
    value: function() {
      for (var k = this.getSharedProps(), H = this.props.overrides.Root, AA = getOverrides(H, Root$3), gA = _slicedToArray$j(AA, 2), IA = gA[0], CA = gA[1], BA = this.state.toasts.length, eA = [], iA = BA - 1; iA >= 0; iA--)
        eA.push(this.renderToast(this.state.toasts[iA]));
      var QA = /* @__PURE__ */ React.createElement(IA, _extends$F({
        "data-baseweb": "toaster"
      }, k, CA), eA);
      return this.state.isMounted ? /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.usePortal && typeof document < "u" && document.body ? /* @__PURE__ */ ReactDOM.createPortal(QA, document.body) : QA, this.props.children) : /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.children);
    }
  }]), g;
})(React.Component);
_defineProperty$v(ToasterContainer, "defaultProps", {
  autoFocus: !1,
  autoHideDuration: 0,
  children: null,
  closeable: !0,
  overrides: {},
  placement: PLACEMENT$1.top,
  resetAutoHideTimerOnUpdate: !0,
  usePortal: !0
});
var toaster = {
  getRef: function n() {
    return toasterRef;
  },
  show: function n(t) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, d = this.getRef();
    if (d)
      return d.show(_objectSpread$o(_objectSpread$o({}, g), {}, {
        children: t
      }));
    if (process.env.NODE_ENV !== "production")
      throw new Error("Please make sure to add the ToasterContainer to your application, and it is mounted, before adding toasts! You can find more information here: https://baseweb.design/components/toast");
  },
  info: function n(t) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(t, _objectSpread$o(_objectSpread$o({}, g), {}, {
      kind: KIND$1.info
    }));
  },
  positive: function n(t) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(t, _objectSpread$o(_objectSpread$o({}, g), {}, {
      kind: KIND$1.positive
    }));
  },
  warning: function n(t) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(t, _objectSpread$o(_objectSpread$o({}, g), {}, {
      kind: KIND$1.warning
    }));
  },
  negative: function n(t) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(t, _objectSpread$o(_objectSpread$o({}, g), {}, {
      kind: KIND$1.negative
    }));
  },
  update: function n(t, g) {
    var d = this.getRef();
    d ? d.update(t, g) : process.env.NODE_ENV !== "production" && console.error("No ToasterContainer is mounted yet.");
  },
  clear: function n(t) {
    var g = this.getRef();
    g ? g.clear(t) : process.env.NODE_ENV !== "production" && console.error("No ToasterContainer is mounted yet.");
  }
};
function _typeof$i(n) {
  "@babel/helpers - typeof";
  return _typeof$i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$i(n);
}
function _extends$E() {
  return _extends$E = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$E.apply(this, arguments);
}
function _classCallCheck$m(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$e(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$m(n, t, g) {
  return t && _defineProperties$e(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$m(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$f(n, t);
}
function _setPrototypeOf$f(n, t) {
  return _setPrototypeOf$f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$f(n, t);
}
function _createSuper$e(n) {
  var t = _isNativeReflectConstruct$e();
  return function() {
    var d = _getPrototypeOf$e(n), k;
    if (t) {
      var H = _getPrototypeOf$e(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$m(this, k);
  };
}
function _possibleConstructorReturn$m(n, t) {
  if (t && (_typeof$i(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$f(n);
}
function _assertThisInitialized$f(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$e(n) {
  return _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$e(n);
}
function _defineProperty$u(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var Notification = /* @__PURE__ */ (function(n) {
  _inherits$m(g, n);
  var t = _createSuper$e(g);
  function g() {
    return _classCallCheck$m(this, g), t.apply(this, arguments);
  }
  return _createClass$m(g, [{
    key: "render",
    value: function() {
      var k = mergeOverrides({
        Body: {
          style: function(AA) {
            var gA = AA.$theme;
            return {
              marginTop: gA.sizing.scale600,
              marginRight: gA.sizing.scale600,
              marginBottom: gA.sizing.scale600,
              marginLeft: gA.sizing.scale600
            };
          }
        }
      }, this.props.overrides);
      return /* @__PURE__ */ React.createElement(Toast$1, _extends$E({
        "data-baseweb": "notification"
      }, this.props, {
        overrides: k
      }));
    }
  }]), g;
})(React.Component);
_defineProperty$u(Notification, "defaultProps", {
  notificationType: TYPE$1.inline,
  closeable: !1
});
const useEmotionTheme = () => useTheme(), StyledAlertContent$1 = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1e4pi9i0"
} : {
  target: "e1e4pi9i0",
  label: "StyledAlertContent"
})(({
  theme: n
}) => ({
  pre: {
    backgroundColor: n.colors.transparent,
    paddingTop: n.spacing.lg,
    paddingBottom: n.spacing.lg,
    paddingRight: n.spacing.lg,
    paddingLeft: n.spacing.lg,
    border: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
    "pre, code": {
      backgroundColor: n.colors.transparent,
      color: "inherit"
    }
  },
  code: {
    backgroundColor: n.colors.transparent,
    padding: n.spacing.none
  },
  "pre, code": {
    color: "inherit"
  },
  a: {
    color: "inherit",
    textDecoration: "underline"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var Kind = /* @__PURE__ */ ((n) => (n.ERROR = "error", n.INFO = "info", n.SUCCESS = "success", n.WARNING = "warning", n))(Kind || {});
function getNotificationKind(n) {
  switch (n) {
    case "error":
      return KIND$1.negative;
    case "info":
      return KIND$1.info;
    case "success":
      return KIND$1.positive;
    case "warning":
      return KIND$1.warning;
    default:
      throw new Error(`Unexpected alert type: ${n}`);
  }
}
function AlertContainer({
  kind: n,
  width: t,
  children: g
}) {
  const d = useEmotionTheme(), k = n.charAt(0).toUpperCase() + n.slice(1);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Notification, { kind: getNotificationKind(n), overrides: {
    Body: {
      style: {
        fontWeight: d.fontWeights.normal,
        marginTop: d.spacing.none,
        marginBottom: d.spacing.none,
        marginLeft: d.spacing.none,
        marginRight: d.spacing.none,
        width: t ? t.toString() : void 0,
        border: 0,
        borderTopRightRadius: d.radii.default,
        borderBottomRightRadius: d.radii.default,
        borderTopLeftRadius: d.radii.default,
        borderBottomLeftRadius: d.radii.default,
        paddingTop: d.spacing.lg,
        paddingBottom: d.spacing.lg,
        paddingRight: d.spacing.lg,
        paddingLeft: d.spacing.lg
      },
      props: {
        "data-testid": "stAlertContainer",
        className: "stAlertContainer"
      }
    },
    InnerContainer: {
      style: {
        width: "100%",
        lineHeight: d.lineHeights.small
      }
    }
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAlertContent$1, { "data-testid": `stAlertContent${k}`, children: g }) });
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize$2(
  function(n) {
    return reactPropsRegex.test(n) || n.charCodeAt(0) === 111 && n.charCodeAt(1) === 110 && n.charCodeAt(2) < 91;
  }
  /* Z+1 */
), SIZE$5 = {
  medium: "medium"
}, spin = {
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(360deg)"
  }
}, StyledSpinner = styled("i", function(n) {
  var t = n.$theme, g = n.$color, d = g === void 0 ? t.colors.contentAccent : g, k = n.$borderWidth, H = n.$size, AA = H === void 0 ? SIZE$5.medium : H, gA = {
    large: t.sizing.scale300,
    medium: t.sizing.scale100,
    small: t.sizing.scale0
  }[k || AA], IA = {
    large: t.sizing.scale1000,
    medium: t.sizing.scale900,
    small: t.sizing.scale800
  }[AA];
  return gA || (gA = t.sizing[k], gA || (gA = "".concat(parseInt(k), "px"))), IA || (IA = t.sizing[AA], IA || (IA = "".concat(parseInt(AA), "px"))), {
    display: "block",
    animationName: spin,
    animationDuration: t.animation.timing1000,
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderRadius: "50%",
    borderTopColor: d,
    borderRightColor: t.colors.backgroundTertiary,
    borderBottomColor: t.colors.backgroundTertiary,
    borderLeftColor: t.colors.backgroundTertiary,
    borderLeftWidth: gA,
    borderRightWidth: gA,
    borderTopWidth: gA,
    borderBottomWidth: gA,
    width: IA,
    height: IA,
    cursor: "wait"
  };
});
StyledSpinner.displayName = "StyledSpinner";
StyledSpinner.displayName = "StyledSpinner";
var generateUID$1 = function() {
  var n = 1, t = /* @__PURE__ */ new WeakMap(), g = function(d, k) {
    return typeof d == "number" || typeof d == "string" ? k ? "idx-".concat(k) : "val-".concat(d) : t.has(d) ? "uid" + t.get(d) : (t.set(d, n++), g(d));
  };
  return g;
}, createSource = function(n) {
  return n === void 0 && (n = ""), {
    value: 1,
    prefix: n,
    uid: generateUID$1()
  };
}, counter = createSource(), source$4 = React.createContext(createSource()), getId = function(n) {
  return n.value++;
}, getPrefix = function(n) {
  return n ? n.prefix : "";
}, __extends$2 = /* @__PURE__ */ (function() {
  var n = function(t, g) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, k) {
      d.__proto__ = k;
    } || function(d, k) {
      for (var H in k) Object.prototype.hasOwnProperty.call(k, H) && (d[H] = k[H]);
    }, n(t, g);
  };
  return function(t, g) {
    if (typeof g != "function" && g !== null)
      throw new TypeError("Class extends value " + String(g) + " is not a constructor or null");
    n(t, g);
    function d() {
      this.constructor = t;
    }
    t.prototype = g === null ? Object.create(g) : (d.prototype = g.prototype, new d());
  };
})(), prefixId = function(n, t, g) {
  var d = t + n;
  return String(g ? g(d) : d);
}, UID = (
  /** @class */
  (function(n) {
    __extends$2(t, n);
    function t() {
      var g = n !== null && n.apply(this, arguments) || this;
      return g.state = {
        quartz: g.props.idSource || counter,
        prefix: getPrefix(g.props.idSource),
        id: getId(g.props.idSource || counter)
      }, g.uid = function(d) {
        return prefixId(g.state.id + "-" + g.state.quartz.uid(d), g.state.prefix, g.props.name);
      }, g;
    }
    return t.prototype.render = function() {
      var g = this.props, d = g.children, k = g.name, H = this.state, AA = H.id, gA = H.prefix;
      return d(prefixId(AA, gA, k), this.uid);
    }, t;
  })(React.Component)
), generateUID = function(n) {
  var t = n || counter, g = getPrefix(t), d = getId(t), k = g + d, H = function(AA) {
    return k + t.uid(AA);
  };
  return { uid: k, gen: H };
}, useUIDState = function() {
  if (process.env.NODE_ENV !== "production" && !("useContext" in React))
    throw new Error("Hooks API requires React 16.8+");
  var n = useContext(source$4), t = useState(function() {
    return generateUID(n);
  })[0];
  return t;
}, useUID = function() {
  var n = useUIDState().uid;
  return n;
}, useUIDSeed = function() {
  var n = useUIDState().gen;
  return n;
}, UIDReset = function(n) {
  var t = n.children, g = n.prefix, d = g === void 0 ? "" : g, k = useState(function() {
    return createSource(d);
  })[0];
  return React.createElement(source$4.Provider, { value: k }, t);
}, UIDConsumer = function(n) {
  var t = n.name, g = n.children;
  return React.createElement(source$4.Consumer, null, function(d) {
    return React.createElement(UID, { name: t, idSource: d, children: g });
  });
};
function _typeof$h(n) {
  "@babel/helpers - typeof";
  return _typeof$h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$h(n);
}
function _extends$D() {
  return _extends$D = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$D.apply(this, arguments);
}
function _slicedToArray$i(n, t) {
  return _arrayWithHoles$h(n) || _iterableToArrayLimit$h(n, t) || _unsupportedIterableToArray$i(n, t) || _nonIterableRest$h();
}
function _nonIterableRest$h() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$h(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$h(n) {
  if (Array.isArray(n)) return n;
}
function _toConsumableArray$3(n) {
  return _arrayWithoutHoles$3(n) || _iterableToArray$3(n) || _unsupportedIterableToArray$i(n) || _nonIterableSpread$3();
}
function _nonIterableSpread$3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$i(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$i(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$i(n, t);
  }
}
function _iterableToArray$3(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function _arrayWithoutHoles$3(n) {
  if (Array.isArray(n)) return _arrayLikeToArray$i(n);
}
function _arrayLikeToArray$i(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _classCallCheck$l(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$d(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$l(n, t, g) {
  return t && _defineProperties$d(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$l(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$e(n, t);
}
function _setPrototypeOf$e(n, t) {
  return _setPrototypeOf$e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$e(n, t);
}
function _createSuper$d(n) {
  var t = _isNativeReflectConstruct$d();
  return function() {
    var d = _getPrototypeOf$d(n), k;
    if (t) {
      var H = _getPrototypeOf$d(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$l(this, k);
  };
}
function _possibleConstructorReturn$l(n, t) {
  if (t && (_typeof$h(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$e(n);
}
function _assertThisInitialized$e(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$d() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$d(n) {
  return _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$d(n);
}
function _defineProperty$t(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var StyledAppContainer = styled("div", {});
StyledAppContainer.displayName = "StyledAppContainer";
var StyledLayersContainer = styled("div", {});
StyledLayersContainer.displayName = "StyledLayersContainer";
function defaultEventHandlerFn() {
  process.env.NODE_ENV !== "production" && console.warn("`LayersManager` was not found. This occurs if you are attempting to use a component requiring `Layer` without using the `BaseProvider` at the root of your app. Please visit https://baseweb.design/components/base-provider/ for more information");
}
var LayersContext = /* @__PURE__ */ React.createContext({
  addEscapeHandler: defaultEventHandlerFn,
  removeEscapeHandler: defaultEventHandlerFn,
  addKeyDownHandler: defaultEventHandlerFn,
  removeKeyDownHandler: defaultEventHandlerFn,
  addKeyUpHandler: defaultEventHandlerFn,
  removeKeyUpHandler: defaultEventHandlerFn,
  addKeyPressHandler: defaultEventHandlerFn,
  removeKeyPressHandler: defaultEventHandlerFn,
  addDocClickHandler: defaultEventHandlerFn,
  removeDocClickHandler: defaultEventHandlerFn,
  host: void 0,
  zIndex: void 0
}), Provider = LayersContext.Provider, Consumer = LayersContext.Consumer, LayersManager = /* @__PURE__ */ (function(n) {
  _inherits$l(g, n);
  var t = _createSuper$d(g);
  function g(d) {
    var k;
    return _classCallCheck$l(this, g), k = t.call(this, d), _defineProperty$t(_assertThisInitialized$e(k), "host", /* @__PURE__ */ React.createRef()), _defineProperty$t(_assertThisInitialized$e(k), "containerRef", /* @__PURE__ */ React.createRef()), _defineProperty$t(_assertThisInitialized$e(k), "onDocumentClick", function(H) {
      var AA = k.state.docClickHandlers[k.state.docClickHandlers.length - 1];
      AA && AA(H);
    }), _defineProperty$t(_assertThisInitialized$e(k), "onKeyDown", function(H) {
      var AA = k.state.keyDownHandlers[k.state.keyDownHandlers.length - 1];
      AA && AA(H);
    }), _defineProperty$t(_assertThisInitialized$e(k), "onKeyUp", function(H) {
      if (H.key === "Escape") {
        var AA = k.state.escapeKeyHandlers[k.state.escapeKeyHandlers.length - 1];
        AA && AA();
      }
      var gA = k.state.keyUpHandlers[k.state.keyUpHandlers.length - 1];
      gA && gA(H);
    }), _defineProperty$t(_assertThisInitialized$e(k), "onKeyPress", function(H) {
      var AA = k.state.keyPressHandlers[k.state.keyPressHandlers.length - 1];
      AA && AA(H);
    }), _defineProperty$t(_assertThisInitialized$e(k), "onAddEscapeHandler", function(H) {
      k.setState(function(AA) {
        return {
          escapeKeyHandlers: [].concat(_toConsumableArray$3(AA.escapeKeyHandlers), [H])
        };
      });
    }), _defineProperty$t(_assertThisInitialized$e(k), "onRemoveEscapeHandler", function(H) {
      k.setState(function(AA) {
        return {
          escapeKeyHandlers: AA.escapeKeyHandlers.filter(function(gA) {
            return gA !== H;
          })
        };
      });
    }), _defineProperty$t(_assertThisInitialized$e(k), "onAddKeyDownHandler", function(H) {
      k.setState(function(AA) {
        return {
          keyDownHandlers: [].concat(_toConsumableArray$3(AA.keyDownHandlers), [H])
        };
      });
    }), _defineProperty$t(_assertThisInitialized$e(k), "onRemoveKeyDownHandler", function(H) {
      k.setState(function(AA) {
        return {
          keyDownHandlers: AA.keyDownHandlers.filter(function(gA) {
            return gA !== H;
          })
        };
      });
    }), _defineProperty$t(_assertThisInitialized$e(k), "onAddKeyUpHandler", function(H) {
      k.setState(function(AA) {
        return {
          keyUpHandlers: [].concat(_toConsumableArray$3(AA.keyUpHandlers), [H])
        };
      });
    }), _defineProperty$t(_assertThisInitialized$e(k), "onRemoveKeyUpHandler", function(H) {
      k.setState(function(AA) {
        return {
          keyUpHandlers: AA.keyUpHandlers.filter(function(gA) {
            return gA !== H;
          })
        };
      });
    }), _defineProperty$t(_assertThisInitialized$e(k), "onAddKeyPressHandler", function(H) {
      k.setState(function(AA) {
        return {
          keyPressHandlers: [].concat(_toConsumableArray$3(AA.keyPressHandlers), [H])
        };
      });
    }), _defineProperty$t(_assertThisInitialized$e(k), "onRemoveKeyPressHandler", function(H) {
      k.setState(function(AA) {
        return {
          keyPressHandlers: AA.keyPressHandlers.filter(function(gA) {
            return gA !== H;
          })
        };
      });
    }), _defineProperty$t(_assertThisInitialized$e(k), "onAddDocClickHandler", function(H) {
      k.setState(function(AA) {
        return {
          docClickHandlers: [].concat(_toConsumableArray$3(AA.docClickHandlers), [H])
        };
      });
    }), _defineProperty$t(_assertThisInitialized$e(k), "onRemoveDocClickHandler", function(H) {
      k.setState(function(AA) {
        return {
          docClickHandlers: AA.docClickHandlers.filter(function(gA) {
            return gA !== H;
          })
        };
      });
    }), k.state = {
      escapeKeyHandlers: [],
      keyDownHandlers: [],
      keyUpHandlers: [],
      keyPressHandlers: [],
      docClickHandlers: []
    }, k;
  }
  return _createClass$l(g, [{
    key: "componentDidMount",
    value: function() {
      this.forceUpdate(), initFocusVisible(this.containerRef.current), typeof document < "u" && (document.addEventListener("keydown", this.onKeyDown), document.addEventListener("keyup", this.onKeyUp), document.addEventListener("keypress", this.onKeyPress), document.addEventListener("mousedown", this.onDocumentClick));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      typeof document < "u" && (document.removeEventListener("keydown", this.onKeyDown), document.removeEventListener("keyup", this.onKeyUp), document.removeEventListener("keypress", this.onKeyPress), document.removeEventListener("mousedown", this.onDocumentClick));
    }
  }, {
    key: "render",
    value: function() {
      var k = this, H = this.props.overrides, AA = H === void 0 ? {} : H, gA = getOverrides(AA.AppContainer, StyledAppContainer), IA = _slicedToArray$i(gA, 2), CA = IA[0], BA = IA[1], eA = getOverrides(AA.LayersContainer, StyledLayersContainer), iA = _slicedToArray$i(eA, 2), QA = iA[0], tA = iA[1];
      return /* @__PURE__ */ React.createElement(Consumer, null, function(oA) {
        var EA = oA.host;
        return process.env.NODE_ENV !== "production" && EA !== void 0 && console.warn("There is a LayersManager already exists in your application. It is not recommended to have more than one LayersManager in an application."), /* @__PURE__ */ React.createElement(Provider, {
          value: {
            host: EA || k.host.current,
            zIndex: k.props.zIndex,
            addEscapeHandler: k.onAddEscapeHandler,
            removeEscapeHandler: k.onRemoveEscapeHandler,
            addKeyDownHandler: k.onAddKeyDownHandler,
            removeKeyDownHandler: k.onRemoveKeyDownHandler,
            addKeyUpHandler: k.onAddKeyUpHandler,
            removeKeyUpHandler: k.onRemoveKeyUpHandler,
            addKeyPressHandler: k.onAddKeyPressHandler,
            removeKeyPressHandler: k.onRemoveKeyPressHandler,
            addDocClickHandler: k.onAddDocClickHandler,
            removeDocClickHandler: k.onRemoveDocClickHandler
          }
        }, /* @__PURE__ */ React.createElement(CA, _extends$D({}, BA, {
          ref: k.containerRef
        }), k.props.children), /* @__PURE__ */ React.createElement(QA, _extends$D({}, tA, {
          ref: k.host
        })));
      });
    }
  }]), g;
})(React.Component);
function _typeof$g(n) {
  "@babel/helpers - typeof";
  return _typeof$g = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$g(n);
}
function _extends$C() {
  return _extends$C = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$C.apply(this, arguments);
}
function _classCallCheck$k(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$c(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$k(n, t, g) {
  return t && _defineProperties$c(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$k(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$d(n, t);
}
function _setPrototypeOf$d(n, t) {
  return _setPrototypeOf$d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$d(n, t);
}
function _createSuper$c(n) {
  var t = _isNativeReflectConstruct$c();
  return function() {
    var d = _getPrototypeOf$c(n), k;
    if (t) {
      var H = _getPrototypeOf$c(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$k(this, k);
  };
}
function _possibleConstructorReturn$k(n, t) {
  if (t && (_typeof$g(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$d(n);
}
function _assertThisInitialized$d(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$c() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$c(n) {
  return _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$c(n);
}
function _defineProperty$s(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var Container = styled("div", function(n) {
  var t = n.$zIndex;
  return {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: t || null
  };
});
Container.displayName = "Container";
var LayerComponent = /* @__PURE__ */ (function(n) {
  _inherits$k(g, n);
  var t = _createSuper$c(g);
  function g() {
    var d;
    _classCallCheck$k(this, g);
    for (var k = arguments.length, H = new Array(k), AA = 0; AA < k; AA++)
      H[AA] = arguments[AA];
    return d = t.call.apply(t, [this].concat(H)), _defineProperty$s(_assertThisInitialized$d(d), "state", {
      container: null
    }), _defineProperty$s(_assertThisInitialized$d(d), "onEscape", function() {
      d.props.onEscape && d.props.onEscape();
    }), _defineProperty$s(_assertThisInitialized$d(d), "onKeyDown", function(gA) {
      d.props.onKeyDown && d.props.onKeyDown(gA);
    }), _defineProperty$s(_assertThisInitialized$d(d), "onKeyUp", function(gA) {
      d.props.onKeyUp && d.props.onKeyUp(gA);
    }), _defineProperty$s(_assertThisInitialized$d(d), "onKeyPress", function(gA) {
      d.props.onKeyPress && d.props.onKeyPress(gA);
    }), _defineProperty$s(_assertThisInitialized$d(d), "onDocumentClick", function(gA) {
      d.props.onDocumentClick && d.props.onDocumentClick(gA);
    }), d;
  }
  return _createClass$k(g, [{
    key: "componentDidMount",
    value: function() {
      this.context.addEscapeHandler(this.onEscape), this.context.addKeyDownHandler(this.onKeyDown), this.context.addKeyUpHandler(this.onKeyUp), this.context.addKeyPressHandler(this.onKeyPress), this.props.isHoverLayer || this.context.addDocClickHandler(this.onDocumentClick);
      var k = this.props, H = k.onMount, AA = k.mountNode, gA = k.host;
      if (AA) {
        H && H();
        return;
      }
      var IA = gA !== void 0;
      process.env.NODE_ENV !== "production" && (IA || console.warn("`LayersManager` was not found. This occurs if you are attempting to use a component requiring `Layer` without using the `BaseProvider` at the root of your app. Please visit https://baseweb.design/components/base-provider/ for more information"));
      var CA = IA ? gA : document.body;
      CA && this.addContainer(CA);
    }
  }, {
    key: "componentDidUpdate",
    value: function(k) {
      var H = this.props, AA = H.host, gA = H.mountNode;
      gA || (AA && AA !== k.host && k.host === null && this.addContainer(AA), k.isHoverLayer != this.props.isHoverLayer && (this.props.isHoverLayer ? this.context.removeDocClickHandler(this.onDocumentClick) : this.context.addDocClickHandler(this.onDocumentClick)));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.context.removeEscapeHandler(this.onEscape), this.context.removeKeyDownHandler(this.onKeyDown), this.context.removeKeyUpHandler(this.onKeyUp), this.context.removeKeyPressHandler(this.onKeyPress), this.context.removeDocClickHandler(this.onDocumentClick), this.props.onUnmount && this.props.onUnmount();
      var k = this.props.host, H = this.state.container;
      k && H && k.contains(H) && k.removeChild(H);
    }
  }, {
    key: "addContainer",
    value: function(k) {
      var H = this.props, AA = H.index, gA = H.mountNode, IA = H.onMount;
      if (!gA && k) {
        var CA = k.ownerDocument.createElement("div"), BA = typeof AA == "number" ? k.children[AA] : null;
        BA ? k.insertBefore(CA, BA) : k.appendChild(CA), this.setState({
          container: CA
        }, function() {
          IA && IA();
        });
      }
    }
  }, {
    key: "render",
    value: function() {
      var k = this.state.container, H = this.props, AA = H.children, gA = H.mountNode, IA = H.zIndex, CA = IA ? /* @__PURE__ */ React.createElement(Container, {
        $zIndex: IA
      }, AA) : AA;
      return typeof document < "u" ? gA ? /* @__PURE__ */ ReactDOM.createPortal(CA, gA) : k ? /* @__PURE__ */ ReactDOM.createPortal(CA, k) : null : null;
    }
  }]), g;
})(React.Component);
_defineProperty$s(LayerComponent, "contextType", LayersContext);
function Layer(n) {
  return /* @__PURE__ */ React.createElement(Consumer, null, function(t) {
    var g = t.host, d = t.zIndex;
    return /* @__PURE__ */ React.createElement(LayerComponent, _extends$C({}, n, {
      host: g,
      zIndex: d
    }));
  });
}
var isBrowser$1 = typeof window < "u" && typeof document < "u" && typeof navigator < "u", timeoutDuration = (function() {
  for (var n = ["Edge", "Trident", "Firefox"], t = 0; t < n.length; t += 1)
    if (isBrowser$1 && navigator.userAgent.indexOf(n[t]) >= 0)
      return 1;
  return 0;
})();
function microtaskDebounce(n) {
  var t = !1;
  return function() {
    t || (t = !0, window.Promise.resolve().then(function() {
      t = !1, n();
    }));
  };
}
function taskDebounce(n) {
  var t = !1;
  return function() {
    t || (t = !0, setTimeout(function() {
      t = !1, n();
    }, timeoutDuration));
  };
}
var supportsMicroTasks = isBrowser$1 && window.Promise, debounce$3 = supportsMicroTasks ? microtaskDebounce : taskDebounce;
function isFunction$7(n) {
  var t = {};
  return n && t.toString.call(n) === "[object Function]";
}
function getStyleComputedProperty(n, t) {
  if (n.nodeType !== 1)
    return [];
  var g = n.ownerDocument.defaultView, d = g.getComputedStyle(n, null);
  return t ? d[t] : d;
}
function getParentNode$1(n) {
  return n.nodeName === "HTML" ? n : n.parentNode || n.host;
}
function getScrollParent(n) {
  if (!n)
    return document.body;
  switch (n.nodeName) {
    case "HTML":
    case "BODY":
      return n.ownerDocument.body;
    case "#document":
      return n.body;
  }
  var t = getStyleComputedProperty(n), g = t.overflow, d = t.overflowX, k = t.overflowY;
  return /(auto|scroll|overlay)/.test(g + k + d) ? n : getScrollParent(getParentNode$1(n));
}
function getReferenceNode(n) {
  return n && n.referenceNode ? n.referenceNode : n;
}
var isIE11 = isBrowser$1 && !!(window.MSInputMethodContext && document.documentMode), isIE10 = isBrowser$1 && /MSIE 10/.test(navigator.userAgent);
function isIE(n) {
  return n === 11 ? isIE11 : n === 10 ? isIE10 : isIE11 || isIE10;
}
function getOffsetParent(n) {
  if (!n)
    return document.documentElement;
  for (var t = isIE(10) ? document.body : null, g = n.offsetParent || null; g === t && n.nextElementSibling; )
    g = (n = n.nextElementSibling).offsetParent;
  var d = g && g.nodeName;
  return !d || d === "BODY" || d === "HTML" ? n ? n.ownerDocument.documentElement : document.documentElement : ["TH", "TD", "TABLE"].indexOf(g.nodeName) !== -1 && getStyleComputedProperty(g, "position") === "static" ? getOffsetParent(g) : g;
}
function isOffsetContainer(n) {
  var t = n.nodeName;
  return t === "BODY" ? !1 : t === "HTML" || getOffsetParent(n.firstElementChild) === n;
}
function getRoot$1(n) {
  return n.parentNode !== null ? getRoot$1(n.parentNode) : n;
}
function findCommonOffsetParent(n, t) {
  if (!n || !n.nodeType || !t || !t.nodeType)
    return document.documentElement;
  var g = n.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING, d = g ? n : t, k = g ? t : n, H = document.createRange();
  H.setStart(d, 0), H.setEnd(k, 0);
  var AA = H.commonAncestorContainer;
  if (n !== AA && t !== AA || d.contains(k))
    return isOffsetContainer(AA) ? AA : getOffsetParent(AA);
  var gA = getRoot$1(n);
  return gA.host ? findCommonOffsetParent(gA.host, t) : findCommonOffsetParent(n, getRoot$1(t).host);
}
function getScroll(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top", g = t === "top" ? "scrollTop" : "scrollLeft", d = n.nodeName;
  if (d === "BODY" || d === "HTML") {
    var k = n.ownerDocument.documentElement, H = n.ownerDocument.scrollingElement || k;
    return H[g];
  }
  return n[g];
}
function includeScroll(n, t) {
  var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, d = getScroll(t, "top"), k = getScroll(t, "left"), H = g ? -1 : 1;
  return n.top += d * H, n.bottom += d * H, n.left += k * H, n.right += k * H, n;
}
function getBordersSize$1(n, t) {
  var g = t === "x" ? "Left" : "Top", d = g === "Left" ? "Right" : "Bottom";
  return parseFloat(n["border" + g + "Width"]) + parseFloat(n["border" + d + "Width"]);
}
function getSize(n, t, g, d) {
  return Math.max(t["offset" + n], t["scroll" + n], g["client" + n], g["offset" + n], g["scroll" + n], isIE(10) ? parseInt(g["offset" + n]) + parseInt(d["margin" + (n === "Height" ? "Top" : "Left")]) + parseInt(d["margin" + (n === "Height" ? "Bottom" : "Right")]) : 0);
}
function getWindowSizes(n) {
  var t = n.body, g = n.documentElement, d = isIE(10) && getComputedStyle(g);
  return {
    height: getSize("Height", t, g, d),
    width: getSize("Width", t, g, d)
  };
}
var classCallCheck = function(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}, createClass$1 = /* @__PURE__ */ (function() {
  function n(t, g) {
    for (var d = 0; d < g.length; d++) {
      var k = g[d];
      k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(t, k.key, k);
    }
  }
  return function(t, g, d) {
    return g && n(t.prototype, g), d && n(t, d), t;
  };
})(), defineProperty$1 = function(n, t, g) {
  return t in n ? Object.defineProperty(n, t, {
    value: g,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[t] = g, n;
}, _extends$B = Object.assign || function(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t];
    for (var d in g)
      Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
  }
  return n;
};
function getClientRect(n) {
  return _extends$B({}, n, {
    right: n.left + n.width,
    bottom: n.top + n.height
  });
}
function getBoundingClientRect(n) {
  var t = {};
  try {
    if (isIE(10)) {
      t = n.getBoundingClientRect();
      var g = getScroll(n, "top"), d = getScroll(n, "left");
      t.top += g, t.left += d, t.bottom += g, t.right += d;
    } else
      t = n.getBoundingClientRect();
  } catch {
  }
  var k = {
    left: t.left,
    top: t.top,
    width: t.right - t.left,
    height: t.bottom - t.top
  }, H = n.nodeName === "HTML" ? getWindowSizes(n.ownerDocument) : {}, AA = H.width || n.clientWidth || k.width, gA = H.height || n.clientHeight || k.height, IA = n.offsetWidth - AA, CA = n.offsetHeight - gA;
  if (IA || CA) {
    var BA = getStyleComputedProperty(n);
    IA -= getBordersSize$1(BA, "x"), CA -= getBordersSize$1(BA, "y"), k.width -= IA, k.height -= CA;
  }
  return getClientRect(k);
}
function getOffsetRectRelativeToArbitraryNode(n, t) {
  var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, d = isIE(10), k = t.nodeName === "HTML", H = getBoundingClientRect(n), AA = getBoundingClientRect(t), gA = getScrollParent(n), IA = getStyleComputedProperty(t), CA = parseFloat(IA.borderTopWidth), BA = parseFloat(IA.borderLeftWidth);
  g && k && (AA.top = Math.max(AA.top, 0), AA.left = Math.max(AA.left, 0));
  var eA = getClientRect({
    top: H.top - AA.top - CA,
    left: H.left - AA.left - BA,
    width: H.width,
    height: H.height
  });
  if (eA.marginTop = 0, eA.marginLeft = 0, !d && k) {
    var iA = parseFloat(IA.marginTop), QA = parseFloat(IA.marginLeft);
    eA.top -= CA - iA, eA.bottom -= CA - iA, eA.left -= BA - QA, eA.right -= BA - QA, eA.marginTop = iA, eA.marginLeft = QA;
  }
  return (d && !g ? t.contains(gA) : t === gA && gA.nodeName !== "BODY") && (eA = includeScroll(eA, t)), eA;
}
function getViewportOffsetRectRelativeToArtbitraryNode(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, g = n.ownerDocument.documentElement, d = getOffsetRectRelativeToArbitraryNode(n, g), k = Math.max(g.clientWidth, window.innerWidth || 0), H = Math.max(g.clientHeight, window.innerHeight || 0), AA = t ? 0 : getScroll(g), gA = t ? 0 : getScroll(g, "left"), IA = {
    top: AA - d.top + d.marginTop,
    left: gA - d.left + d.marginLeft,
    width: k,
    height: H
  };
  return getClientRect(IA);
}
function isFixed$1(n) {
  var t = n.nodeName;
  if (t === "BODY" || t === "HTML")
    return !1;
  if (getStyleComputedProperty(n, "position") === "fixed")
    return !0;
  var g = getParentNode$1(n);
  return g ? isFixed$1(g) : !1;
}
function getFixedPositionOffsetParent(n) {
  if (!n || !n.parentElement || isIE())
    return document.documentElement;
  for (var t = n.parentElement; t && getStyleComputedProperty(t, "transform") === "none"; )
    t = t.parentElement;
  return t || document.documentElement;
}
function getBoundaries(n, t, g, d) {
  var k = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, H = { top: 0, left: 0 }, AA = k ? getFixedPositionOffsetParent(n) : findCommonOffsetParent(n, getReferenceNode(t));
  if (d === "viewport")
    H = getViewportOffsetRectRelativeToArtbitraryNode(AA, k);
  else {
    var gA = void 0;
    d === "scrollParent" ? (gA = getScrollParent(getParentNode$1(t)), gA.nodeName === "BODY" && (gA = n.ownerDocument.documentElement)) : d === "window" ? gA = n.ownerDocument.documentElement : gA = d;
    var IA = getOffsetRectRelativeToArbitraryNode(gA, AA, k);
    if (gA.nodeName === "HTML" && !isFixed$1(AA)) {
      var CA = getWindowSizes(n.ownerDocument), BA = CA.height, eA = CA.width;
      H.top += IA.top - IA.marginTop, H.bottom = BA + IA.top, H.left += IA.left - IA.marginLeft, H.right = eA + IA.left;
    } else
      H = IA;
  }
  g = g || 0;
  var iA = typeof g == "number";
  return H.left += iA ? g : g.left || 0, H.top += iA ? g : g.top || 0, H.right -= iA ? g : g.right || 0, H.bottom -= iA ? g : g.bottom || 0, H;
}
function getArea(n) {
  var t = n.width, g = n.height;
  return t * g;
}
function computeAutoPlacement(n, t, g, d, k) {
  var H = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (n.indexOf("auto") === -1)
    return n;
  var AA = getBoundaries(g, d, H, k), gA = {
    top: {
      width: AA.width,
      height: t.top - AA.top
    },
    right: {
      width: AA.right - t.right,
      height: AA.height
    },
    bottom: {
      width: AA.width,
      height: AA.bottom - t.bottom
    },
    left: {
      width: t.left - AA.left,
      height: AA.height
    }
  }, IA = Object.keys(gA).map(function(iA) {
    return _extends$B({
      key: iA
    }, gA[iA], {
      area: getArea(gA[iA])
    });
  }).sort(function(iA, QA) {
    return QA.area - iA.area;
  }), CA = IA.filter(function(iA) {
    var QA = iA.width, tA = iA.height;
    return QA >= g.clientWidth && tA >= g.clientHeight;
  }), BA = CA.length > 0 ? CA[0].key : IA[0].key, eA = n.split("-")[1];
  return BA + (eA ? "-" + eA : "");
}
function getReferenceOffsets(n, t, g) {
  var d = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, k = d ? getFixedPositionOffsetParent(t) : findCommonOffsetParent(t, getReferenceNode(g));
  return getOffsetRectRelativeToArbitraryNode(g, k, d);
}
function getOuterSizes(n) {
  var t = n.ownerDocument.defaultView, g = t.getComputedStyle(n), d = parseFloat(g.marginTop || 0) + parseFloat(g.marginBottom || 0), k = parseFloat(g.marginLeft || 0) + parseFloat(g.marginRight || 0), H = {
    width: n.offsetWidth + k,
    height: n.offsetHeight + d
  };
  return H;
}
function getOppositePlacement(n) {
  var t = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return n.replace(/left|right|bottom|top/g, function(g) {
    return t[g];
  });
}
function getPopperOffsets(n, t, g) {
  g = g.split("-")[0];
  var d = getOuterSizes(n), k = {
    width: d.width,
    height: d.height
  }, H = ["right", "left"].indexOf(g) !== -1, AA = H ? "top" : "left", gA = H ? "left" : "top", IA = H ? "height" : "width", CA = H ? "width" : "height";
  return k[AA] = t[AA] + t[IA] / 2 - d[IA] / 2, g === gA ? k[gA] = t[gA] - d[CA] : k[gA] = t[getOppositePlacement(gA)], k;
}
function find$5(n, t) {
  return Array.prototype.find ? n.find(t) : n.filter(t)[0];
}
function findIndex(n, t, g) {
  if (Array.prototype.findIndex)
    return n.findIndex(function(k) {
      return k[t] === g;
    });
  var d = find$5(n, function(k) {
    return k[t] === g;
  });
  return n.indexOf(d);
}
function runModifiers(n, t, g) {
  var d = g === void 0 ? n : n.slice(0, findIndex(n, "name", g));
  return d.forEach(function(k) {
    k.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    var H = k.function || k.fn;
    k.enabled && isFunction$7(H) && (t.offsets.popper = getClientRect(t.offsets.popper), t.offsets.reference = getClientRect(t.offsets.reference), t = H(t, k));
  }), t;
}
function update$7() {
  if (!this.state.isDestroyed) {
    var n = {
      instance: this,
      styles: {},
      arrowStyles: {},
      attributes: {},
      flipped: !1,
      offsets: {}
    };
    n.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed), n.placement = computeAutoPlacement(this.options.placement, n.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), n.originalPlacement = n.placement, n.positionFixed = this.options.positionFixed, n.offsets.popper = getPopperOffsets(this.popper, n.offsets.reference, n.placement), n.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", n = runModifiers(this.modifiers, n), this.state.isCreated ? this.options.onUpdate(n) : (this.state.isCreated = !0, this.options.onCreate(n));
  }
}
function isModifierEnabled(n, t) {
  return n.some(function(g) {
    var d = g.name, k = g.enabled;
    return k && d === t;
  });
}
function getSupportedPropertyName(n) {
  for (var t = [!1, "ms", "Webkit", "Moz", "O"], g = n.charAt(0).toUpperCase() + n.slice(1), d = 0; d < t.length; d++) {
    var k = t[d], H = k ? "" + k + g : n;
    if (typeof document.body.style[H] < "u")
      return H;
  }
  return null;
}
function destroy() {
  return this.state.isDestroyed = !0, isModifierEnabled(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[getSupportedPropertyName("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
}
function getWindow(n) {
  var t = n.ownerDocument;
  return t ? t.defaultView : window;
}
function attachToScrollParents(n, t, g, d) {
  var k = n.nodeName === "BODY", H = k ? n.ownerDocument.defaultView : n;
  H.addEventListener(t, g, { passive: !0 }), k || attachToScrollParents(getScrollParent(H.parentNode), t, g, d), d.push(H);
}
function setupEventListeners(n, t, g, d) {
  g.updateBound = d, getWindow(n).addEventListener("resize", g.updateBound, { passive: !0 });
  var k = getScrollParent(n);
  return attachToScrollParents(k, "scroll", g.updateBound, g.scrollParents), g.scrollElement = k, g.eventsEnabled = !0, g;
}
function enableEventListeners() {
  this.state.eventsEnabled || (this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate));
}
function removeEventListeners(n, t) {
  return getWindow(n).removeEventListener("resize", t.updateBound), t.scrollParents.forEach(function(g) {
    g.removeEventListener("scroll", t.updateBound);
  }), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t;
}
function disableEventListeners() {
  this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = removeEventListeners(this.reference, this.state));
}
function isNumeric$1(n) {
  return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
}
function setStyles(n, t) {
  Object.keys(t).forEach(function(g) {
    var d = "";
    ["width", "height", "top", "right", "bottom", "left"].indexOf(g) !== -1 && isNumeric$1(t[g]) && (d = "px"), n.style[g] = t[g] + d;
  });
}
function setAttributes$1(n, t) {
  Object.keys(t).forEach(function(g) {
    var d = t[g];
    d !== !1 ? n.setAttribute(g, t[g]) : n.removeAttribute(g);
  });
}
function applyStyle(n) {
  return setStyles(n.instance.popper, n.styles), setAttributes$1(n.instance.popper, n.attributes), n.arrowElement && Object.keys(n.arrowStyles).length && setStyles(n.arrowElement, n.arrowStyles), n;
}
function applyStyleOnLoad(n, t, g, d, k) {
  var H = getReferenceOffsets(k, t, n, g.positionFixed), AA = computeAutoPlacement(g.placement, H, t, n, g.modifiers.flip.boundariesElement, g.modifiers.flip.padding);
  return t.setAttribute("x-placement", AA), setStyles(t, { position: g.positionFixed ? "fixed" : "absolute" }), g;
}
function getRoundedOffsets(n, t) {
  var g = n.offsets, d = g.popper, k = g.reference, H = Math.round, AA = Math.floor, gA = function(aA) {
    return aA;
  }, IA = H(k.width), CA = H(d.width), BA = ["left", "right"].indexOf(n.placement) !== -1, eA = n.placement.indexOf("-") !== -1, iA = IA % 2 === CA % 2, QA = IA % 2 === 1 && CA % 2 === 1, tA = t ? BA || eA || iA ? H : AA : gA, oA = t ? H : gA;
  return {
    left: tA(QA && !eA && t ? d.left - 1 : d.left),
    top: oA(d.top),
    bottom: oA(d.bottom),
    right: tA(d.right)
  };
}
var isFirefox = isBrowser$1 && /Firefox/i.test(navigator.userAgent);
function computeStyle(n, t) {
  var g = t.x, d = t.y, k = n.offsets.popper, H = find$5(n.instance.modifiers, function(lA) {
    return lA.name === "applyStyle";
  }).gpuAcceleration;
  H !== void 0 && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  var AA = H !== void 0 ? H : t.gpuAcceleration, gA = getOffsetParent(n.instance.popper), IA = getBoundingClientRect(gA), CA = {
    position: k.position
  }, BA = getRoundedOffsets(n, window.devicePixelRatio < 2 || !isFirefox), eA = g === "bottom" ? "top" : "bottom", iA = d === "right" ? "left" : "right", QA = getSupportedPropertyName("transform"), tA = void 0, oA = void 0;
  if (eA === "bottom" ? gA.nodeName === "HTML" ? oA = -gA.clientHeight + BA.bottom : oA = -IA.height + BA.bottom : oA = BA.top, iA === "right" ? gA.nodeName === "HTML" ? tA = -gA.clientWidth + BA.right : tA = -IA.width + BA.right : tA = BA.left, AA && QA)
    CA[QA] = "translate3d(" + tA + "px, " + oA + "px, 0)", CA[eA] = 0, CA[iA] = 0, CA.willChange = "transform";
  else {
    var EA = eA === "bottom" ? -1 : 1, aA = iA === "right" ? -1 : 1;
    CA[eA] = oA * EA, CA[iA] = tA * aA, CA.willChange = eA + ", " + iA;
  }
  var nA = {
    "x-placement": n.placement
  };
  return n.attributes = _extends$B({}, nA, n.attributes), n.styles = _extends$B({}, CA, n.styles), n.arrowStyles = _extends$B({}, n.offsets.arrow, n.arrowStyles), n;
}
function isModifierRequired(n, t, g) {
  var d = find$5(n, function(gA) {
    var IA = gA.name;
    return IA === t;
  }), k = !!d && n.some(function(gA) {
    return gA.name === g && gA.enabled && gA.order < d.order;
  });
  if (!k) {
    var H = "`" + t + "`", AA = "`" + g + "`";
    console.warn(AA + " modifier is required by " + H + " modifier in order to work, be sure to include it before " + H + "!");
  }
  return k;
}
function arrow(n, t) {
  var g;
  if (!isModifierRequired(n.instance.modifiers, "arrow", "keepTogether"))
    return n;
  var d = t.element;
  if (typeof d == "string") {
    if (d = n.instance.popper.querySelector(d), !d)
      return n;
  } else if (!n.instance.popper.contains(d))
    return console.warn("WARNING: `arrow.element` must be child of its popper element!"), n;
  var k = n.placement.split("-")[0], H = n.offsets, AA = H.popper, gA = H.reference, IA = ["left", "right"].indexOf(k) !== -1, CA = IA ? "height" : "width", BA = IA ? "Top" : "Left", eA = BA.toLowerCase(), iA = IA ? "left" : "top", QA = IA ? "bottom" : "right", tA = getOuterSizes(d)[CA];
  gA[QA] - tA < AA[eA] && (n.offsets.popper[eA] -= AA[eA] - (gA[QA] - tA)), gA[eA] + tA > AA[QA] && (n.offsets.popper[eA] += gA[eA] + tA - AA[QA]), n.offsets.popper = getClientRect(n.offsets.popper);
  var oA = gA[eA] + gA[CA] / 2 - tA / 2, EA = getStyleComputedProperty(n.instance.popper), aA = parseFloat(EA["margin" + BA]), nA = parseFloat(EA["border" + BA + "Width"]), lA = oA - n.offsets.popper[eA] - aA - nA;
  return lA = Math.max(Math.min(AA[CA] - tA, lA), 0), n.arrowElement = d, n.offsets.arrow = (g = {}, defineProperty$1(g, eA, Math.round(lA)), defineProperty$1(g, iA, ""), g), n;
}
function getOppositeVariation(n) {
  return n === "end" ? "start" : n === "start" ? "end" : n;
}
var placements = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], validPlacements = placements.slice(3);
function clockwise(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, g = validPlacements.indexOf(n), d = validPlacements.slice(g + 1).concat(validPlacements.slice(0, g));
  return t ? d.reverse() : d;
}
var BEHAVIORS = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function flip$2(n, t) {
  if (isModifierEnabled(n.instance.modifiers, "inner") || n.flipped && n.placement === n.originalPlacement)
    return n;
  var g = getBoundaries(n.instance.popper, n.instance.reference, t.padding, t.boundariesElement, n.positionFixed), d = n.placement.split("-")[0], k = getOppositePlacement(d), H = n.placement.split("-")[1] || "", AA = [];
  switch (t.behavior) {
    case BEHAVIORS.FLIP:
      AA = [d, k];
      break;
    case BEHAVIORS.CLOCKWISE:
      AA = clockwise(d);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      AA = clockwise(d, !0);
      break;
    default:
      AA = t.behavior;
  }
  return AA.forEach(function(gA, IA) {
    if (d !== gA || AA.length === IA + 1)
      return n;
    d = n.placement.split("-")[0], k = getOppositePlacement(d);
    var CA = n.offsets.popper, BA = n.offsets.reference, eA = Math.floor, iA = d === "left" && eA(CA.right) > eA(BA.left) || d === "right" && eA(CA.left) < eA(BA.right) || d === "top" && eA(CA.bottom) > eA(BA.top) || d === "bottom" && eA(CA.top) < eA(BA.bottom), QA = eA(CA.left) < eA(g.left), tA = eA(CA.right) > eA(g.right), oA = eA(CA.top) < eA(g.top), EA = eA(CA.bottom) > eA(g.bottom), aA = d === "left" && QA || d === "right" && tA || d === "top" && oA || d === "bottom" && EA, nA = ["top", "bottom"].indexOf(d) !== -1, lA = !!t.flipVariations && (nA && H === "start" && QA || nA && H === "end" && tA || !nA && H === "start" && oA || !nA && H === "end" && EA), cA = !!t.flipVariationsByContent && (nA && H === "start" && tA || nA && H === "end" && QA || !nA && H === "start" && EA || !nA && H === "end" && oA), sA = lA || cA;
    (iA || aA || sA) && (n.flipped = !0, (iA || aA) && (d = AA[IA + 1]), sA && (H = getOppositeVariation(H)), n.placement = d + (H ? "-" + H : ""), n.offsets.popper = _extends$B({}, n.offsets.popper, getPopperOffsets(n.instance.popper, n.offsets.reference, n.placement)), n = runModifiers(n.instance.modifiers, n, "flip"));
  }), n;
}
function keepTogether(n) {
  var t = n.offsets, g = t.popper, d = t.reference, k = n.placement.split("-")[0], H = Math.floor, AA = ["top", "bottom"].indexOf(k) !== -1, gA = AA ? "right" : "bottom", IA = AA ? "left" : "top", CA = AA ? "width" : "height";
  return g[gA] < H(d[IA]) && (n.offsets.popper[IA] = H(d[IA]) - g[CA]), g[IA] > H(d[gA]) && (n.offsets.popper[IA] = H(d[gA])), n;
}
function toValue(n, t, g, d) {
  var k = n.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), H = +k[1], AA = k[2];
  if (!H)
    return n;
  if (AA.indexOf("%") === 0) {
    var gA = void 0;
    switch (AA) {
      case "%p":
        gA = g;
        break;
      case "%":
      case "%r":
      default:
        gA = d;
    }
    var IA = getClientRect(gA);
    return IA[t] / 100 * H;
  } else if (AA === "vh" || AA === "vw") {
    var CA = void 0;
    return AA === "vh" ? CA = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : CA = Math.max(document.documentElement.clientWidth, window.innerWidth || 0), CA / 100 * H;
  } else
    return H;
}
function parseOffset(n, t, g, d) {
  var k = [0, 0], H = ["right", "left"].indexOf(d) !== -1, AA = n.split(/(\+|\-)/).map(function(BA) {
    return BA.trim();
  }), gA = AA.indexOf(find$5(AA, function(BA) {
    return BA.search(/,|\s/) !== -1;
  }));
  AA[gA] && AA[gA].indexOf(",") === -1 && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  var IA = /\s*,\s*|\s+/, CA = gA !== -1 ? [AA.slice(0, gA).concat([AA[gA].split(IA)[0]]), [AA[gA].split(IA)[1]].concat(AA.slice(gA + 1))] : [AA];
  return CA = CA.map(function(BA, eA) {
    var iA = (eA === 1 ? !H : H) ? "height" : "width", QA = !1;
    return BA.reduce(function(tA, oA) {
      return tA[tA.length - 1] === "" && ["+", "-"].indexOf(oA) !== -1 ? (tA[tA.length - 1] = oA, QA = !0, tA) : QA ? (tA[tA.length - 1] += oA, QA = !1, tA) : tA.concat(oA);
    }, []).map(function(tA) {
      return toValue(tA, iA, t, g);
    });
  }), CA.forEach(function(BA, eA) {
    BA.forEach(function(iA, QA) {
      isNumeric$1(iA) && (k[eA] += iA * (BA[QA - 1] === "-" ? -1 : 1));
    });
  }), k;
}
function offset$5(n, t) {
  var g = t.offset, d = n.placement, k = n.offsets, H = k.popper, AA = k.reference, gA = d.split("-")[0], IA = void 0;
  return isNumeric$1(+g) ? IA = [+g, 0] : IA = parseOffset(g, H, AA, gA), gA === "left" ? (H.top += IA[0], H.left -= IA[1]) : gA === "right" ? (H.top += IA[0], H.left += IA[1]) : gA === "top" ? (H.left += IA[0], H.top -= IA[1]) : gA === "bottom" && (H.left += IA[0], H.top += IA[1]), n.popper = H, n;
}
function preventOverflow(n, t) {
  var g = t.boundariesElement || getOffsetParent(n.instance.popper);
  n.instance.reference === g && (g = getOffsetParent(g));
  var d = getSupportedPropertyName("transform"), k = n.instance.popper.style, H = k.top, AA = k.left, gA = k[d];
  k.top = "", k.left = "", k[d] = "";
  var IA = getBoundaries(n.instance.popper, n.instance.reference, t.padding, g, n.positionFixed);
  k.top = H, k.left = AA, k[d] = gA, t.boundaries = IA;
  var CA = t.priority, BA = n.offsets.popper, eA = {
    primary: function(QA) {
      var tA = BA[QA];
      return BA[QA] < IA[QA] && !t.escapeWithReference && (tA = Math.max(BA[QA], IA[QA])), defineProperty$1({}, QA, tA);
    },
    secondary: function(QA) {
      var tA = QA === "right" ? "left" : "top", oA = BA[tA];
      return BA[QA] > IA[QA] && !t.escapeWithReference && (oA = Math.min(BA[tA], IA[QA] - (QA === "right" ? BA.width : BA.height))), defineProperty$1({}, tA, oA);
    }
  };
  return CA.forEach(function(iA) {
    var QA = ["left", "top"].indexOf(iA) !== -1 ? "primary" : "secondary";
    BA = _extends$B({}, BA, eA[QA](iA));
  }), n.offsets.popper = BA, n;
}
function shift(n) {
  var t = n.placement, g = t.split("-")[0], d = t.split("-")[1];
  if (d) {
    var k = n.offsets, H = k.reference, AA = k.popper, gA = ["bottom", "top"].indexOf(g) !== -1, IA = gA ? "left" : "top", CA = gA ? "width" : "height", BA = {
      start: defineProperty$1({}, IA, H[IA]),
      end: defineProperty$1({}, IA, H[IA] + H[CA] - AA[CA])
    };
    n.offsets.popper = _extends$B({}, AA, BA[d]);
  }
  return n;
}
function hide(n) {
  if (!isModifierRequired(n.instance.modifiers, "hide", "preventOverflow"))
    return n;
  var t = n.offsets.reference, g = find$5(n.instance.modifiers, function(d) {
    return d.name === "preventOverflow";
  }).boundaries;
  if (t.bottom < g.top || t.left > g.right || t.top > g.bottom || t.right < g.left) {
    if (n.hide === !0)
      return n;
    n.hide = !0, n.attributes["x-out-of-boundaries"] = "";
  } else {
    if (n.hide === !1)
      return n;
    n.hide = !1, n.attributes["x-out-of-boundaries"] = !1;
  }
  return n;
}
function inner$1(n) {
  var t = n.placement, g = t.split("-")[0], d = n.offsets, k = d.popper, H = d.reference, AA = ["left", "right"].indexOf(g) !== -1, gA = ["top", "left"].indexOf(g) === -1;
  return k[AA ? "left" : "top"] = H[g] - (gA ? k[AA ? "width" : "height"] : 0), n.placement = getOppositePlacement(t), n.offsets.popper = getClientRect(k), n;
}
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: shift
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: offset$5,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: flip$2,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: !1,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: !1
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: !1,
    /** @prop {ModifierFn} */
    fn: inner$1
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: hide
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: !0,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
}, Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: !1,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: !0,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: !1,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function n() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function n() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers
}, Popper = (function() {
  function n(t, g) {
    var d = this, k = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    classCallCheck(this, n), this.scheduleUpdate = function() {
      return requestAnimationFrame(d.update);
    }, this.update = debounce$3(this.update.bind(this)), this.options = _extends$B({}, n.Defaults, k), this.state = {
      isDestroyed: !1,
      isCreated: !1,
      scrollParents: []
    }, this.reference = t && t.jquery ? t[0] : t, this.popper = g && g.jquery ? g[0] : g, this.options.modifiers = {}, Object.keys(_extends$B({}, n.Defaults.modifiers, k.modifiers)).forEach(function(AA) {
      d.options.modifiers[AA] = _extends$B({}, n.Defaults.modifiers[AA] || {}, k.modifiers ? k.modifiers[AA] : {});
    }), this.modifiers = Object.keys(this.options.modifiers).map(function(AA) {
      return _extends$B({
        name: AA
      }, d.options.modifiers[AA]);
    }).sort(function(AA, gA) {
      return AA.order - gA.order;
    }), this.modifiers.forEach(function(AA) {
      AA.enabled && isFunction$7(AA.onLoad) && AA.onLoad(d.reference, d.popper, d.options, AA, d.state);
    }), this.update();
    var H = this.options.eventsEnabled;
    H && this.enableEventListeners(), this.state.eventsEnabled = H;
  }
  return createClass$1(n, [{
    key: "update",
    value: function() {
      return update$7.call(this);
    }
  }, {
    key: "destroy",
    value: function() {
      return destroy.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function() {
      return enableEventListeners.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function() {
      return disableEventListeners.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]), n;
})();
Popper.Utils = (typeof window < "u" ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
function toPopperPlacement(n) {
  return n.replace(/(Top|Left)$/, "-start").replace(/(Right|Bottom)$/, "-end");
}
function parsePopperOffset(n) {
  return {
    top: Math.floor(n.top || 0),
    left: Math.floor(n.left || 0)
  };
}
var TETHER_PLACEMENT = {
  auto: "auto"
};
function _typeof$f(n) {
  "@babel/helpers - typeof";
  return _typeof$f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$f(n);
}
var _excluded$n = ["modifiers"];
function ownKeys$p(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$n(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$p(Object(g), !0).forEach(function(d) {
      _defineProperty$r(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$p(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _objectWithoutProperties$p(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$p(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$p(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _classCallCheck$j(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$b(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$j(n, t, g) {
  return t && _defineProperties$b(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$j(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$c(n, t);
}
function _setPrototypeOf$c(n, t) {
  return _setPrototypeOf$c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$c(n, t);
}
function _createSuper$b(n) {
  var t = _isNativeReflectConstruct$b();
  return function() {
    var d = _getPrototypeOf$b(n), k;
    if (t) {
      var H = _getPrototypeOf$b(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$j(this, k);
  };
}
function _possibleConstructorReturn$j(n, t) {
  if (t && (_typeof$f(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$c(n);
}
function _assertThisInitialized$c(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$b() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$b(n) {
  return _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$b(n);
}
function _defineProperty$r(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var Tether = /* @__PURE__ */ (function(n) {
  _inherits$j(g, n);
  var t = _createSuper$b(g);
  function g() {
    var d;
    _classCallCheck$j(this, g);
    for (var k = arguments.length, H = new Array(k), AA = 0; AA < k; AA++)
      H[AA] = arguments[AA];
    return d = t.call.apply(t, [this].concat(H)), _defineProperty$r(_assertThisInitialized$c(d), "popper", void 0), _defineProperty$r(_assertThisInitialized$c(d), "popperHeight", 0), _defineProperty$r(_assertThisInitialized$c(d), "popperWidth", 0), _defineProperty$r(_assertThisInitialized$c(d), "anchorHeight", 0), _defineProperty$r(_assertThisInitialized$c(d), "anchorWidth", 0), _defineProperty$r(_assertThisInitialized$c(d), "state", {
      isMounted: !1
    }), _defineProperty$r(_assertThisInitialized$c(d), "onPopperUpdate", function(gA) {
      var IA = {
        popper: parsePopperOffset(gA.offsets.popper),
        arrow: gA.offsets.arrow ? parsePopperOffset(gA.offsets.arrow) : {
          top: 0,
          left: 0
        }
      };
      d.props.onPopperUpdate(IA, gA);
    }), d;
  }
  return _createClass$j(g, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(k, H) {
      if (this.props.anchorRef) {
        var AA = this.props.anchorRef.getBoundingClientRect(), gA = AA.height, IA = AA.width;
        (this.anchorHeight !== gA || this.anchorWidth !== IA) && (this.anchorHeight = gA, this.anchorWidth = IA, this.popper && this.popper.scheduleUpdate());
      }
      if (this.props.popperRef) {
        var CA = this.props.popperRef.getBoundingClientRect(), BA = CA.height, eA = CA.width;
        (this.popperHeight !== BA || this.popperWidth !== eA) && (this.popperHeight = BA, this.popperWidth = eA, this.popper && this.popper.scheduleUpdate()), this.state.isMounted !== H.isMounted && (this.props.anchorRef ? this.initializePopper() : process.env.NODE_ENV !== "production" && console.warn(`[baseui][TetherBehavior] ref has not been passed to the Popper's anchor element.
              See how to pass the ref to an anchor element in the Popover example
              https://baseweb.design/components/popover/#anchor-ref-handling-example`));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyPopover();
    }
  }, {
    key: "initializePopper",
    value: function() {
      var k = this.props, H = k.placement, AA = k.popperOptions, gA = AA.modifiers, IA = _objectWithoutProperties$p(AA, _excluded$n);
      !this.props.anchorRef || !this.props.popperRef || (this.popper = new Popper(this.props.anchorRef, this.props.popperRef, _objectSpread$n({
        // Recommended placement (popper may ignore if it causes a viewport overflow, etc)
        placement: toPopperPlacement(H),
        modifiers: _objectSpread$n({
          // Passing the arrow ref will measure the arrow when calculating styles
          arrow: {
            element: this.props.arrowRef,
            enabled: !!this.props.arrowRef
          },
          computeStyle: {
            // Make popper use top/left instead of transform translate, this is because
            // we use transform for animations and we dont want them to conflict
            gpuAcceleration: !1
          },
          applyStyle: {
            // Disable default styling modifier, we'll apply styles on our own
            enabled: !1
          },
          applyReactStyle: {
            enabled: !0,
            fn: this.onPopperUpdate,
            order: 900
          },
          preventOverflow: {
            enabled: !0
          }
        }, gA)
      }, IA)));
    }
  }, {
    key: "destroyPopover",
    value: function() {
      this.popper && (this.popper.destroy(), delete this.popper);
    }
  }, {
    key: "render",
    value: function() {
      return this.props.children || null;
    }
  }]), g;
})(React.Component);
_defineProperty$r(Tether, "defaultProps", {
  anchorRef: null,
  onPopperUpdate: function n() {
    return null;
  },
  placement: TETHER_PLACEMENT.auto,
  popperRef: null,
  popperOptions: {}
});
var BaseProvider = function n(t) {
  var g = t.children, d = t.overrides, k = t.theme, H = t.zIndex;
  return /* @__PURE__ */ React.createElement(LayersManager, {
    zIndex: H,
    overrides: d
  }, /* @__PURE__ */ React.createElement(UIDReset, {
    prefix: "bui"
  }, /* @__PURE__ */ React.createElement(ThemeProvider$1, {
    theme: k
  }, g)));
};
function guard(n, t, g) {
  return Math.min(Math.max(n, g), t);
}
class ColorError extends Error {
  constructor(t) {
    super(`Failed to parse color: "${t}"`);
  }
}
var ColorError$1 = ColorError;
function parseToRgba(n) {
  if (typeof n != "string") throw new ColorError$1(n);
  if (n.trim().toLowerCase() === "transparent") return [0, 0, 0, 0];
  let t = n.trim();
  t = namedColorRegex.test(n) ? nameToHex(n) : n;
  const g = reducedHexRegex.exec(t);
  if (g) {
    const AA = Array.from(g).slice(1);
    return [...AA.slice(0, 3).map((gA) => parseInt(r$1(gA, 2), 16)), parseInt(r$1(AA[3] || "f", 2), 16) / 255];
  }
  const d = hexRegex.exec(t);
  if (d) {
    const AA = Array.from(d).slice(1);
    return [...AA.slice(0, 3).map((gA) => parseInt(gA, 16)), parseInt(AA[3] || "ff", 16) / 255];
  }
  const k = rgbaRegex.exec(t);
  if (k) {
    const AA = Array.from(k).slice(1);
    return [...AA.slice(0, 3).map((gA) => parseInt(gA, 10)), parseFloat(AA[3] || "1")];
  }
  const H = hslaRegex.exec(t);
  if (H) {
    const [AA, gA, IA, CA] = Array.from(H).slice(1).map(parseFloat);
    if (guard(0, 100, gA) !== gA) throw new ColorError$1(n);
    if (guard(0, 100, IA) !== IA) throw new ColorError$1(n);
    return [...hslToRgb$1(AA, gA, IA), Number.isNaN(CA) ? 1 : CA];
  }
  throw new ColorError$1(n);
}
function hash$2(n) {
  let t = 5381, g = n.length;
  for (; g; )
    t = t * 33 ^ n.charCodeAt(--g);
  return (t >>> 0) % 2341;
}
const colorToInt = (n) => parseInt(n.replace(/_/g, ""), 36), compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((n, t) => {
  const g = colorToInt(t.substring(0, 3)), d = colorToInt(t.substring(3)).toString(16);
  let k = "";
  for (let H = 0; H < 6 - d.length; H++)
    k += "0";
  return n[g] = `${k}${d}`, n;
}, {});
function nameToHex(n) {
  const t = n.toLowerCase().trim(), g = compressedColorMap[hash$2(t)];
  if (!g) throw new ColorError$1(n);
  return `#${g}`;
}
const r$1 = (n, t) => Array.from(Array(t)).map(() => n).join(""), reducedHexRegex = new RegExp(`^#${r$1("([a-f0-9])", 3)}([a-f0-9])?$`, "i"), hexRegex = new RegExp(`^#${r$1("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i"), rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${r$1(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i"), hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i, namedColorRegex = /^[a-z]+$/i, roundColor = (n) => Math.round(n * 255), hslToRgb$1 = (n, t, g) => {
  let d = g / 100;
  if (t === 0)
    return [d, d, d].map(roundColor);
  const k = (n % 360 + 360) % 360 / 60, H = (1 - Math.abs(2 * d - 1)) * (t / 100), AA = H * (1 - Math.abs(k % 2 - 1));
  let gA = 0, IA = 0, CA = 0;
  k >= 0 && k < 1 ? (gA = H, IA = AA) : k >= 1 && k < 2 ? (gA = AA, IA = H) : k >= 2 && k < 3 ? (IA = H, CA = AA) : k >= 3 && k < 4 ? (IA = AA, CA = H) : k >= 4 && k < 5 ? (gA = AA, CA = H) : k >= 5 && k < 6 && (gA = H, CA = AA);
  const BA = d - H / 2, eA = gA + BA, iA = IA + BA, QA = CA + BA;
  return [eA, iA, QA].map(roundColor);
};
function parseToHsla(n) {
  const [t, g, d, k] = parseToRgba(n).map((eA, iA) => (
    // 3rd index is alpha channel which is already normalized
    iA === 3 ? eA : eA / 255
  )), H = Math.max(t, g, d), AA = Math.min(t, g, d), gA = (H + AA) / 2;
  if (H === AA) return [0, 0, gA, k];
  const IA = H - AA, CA = gA > 0.5 ? IA / (2 - H - AA) : IA / (H + AA);
  return [60 * (t === H ? (g - d) / IA + (g < d ? 6 : 0) : g === H ? (d - t) / IA + 2 : (t - g) / IA + 4), CA, gA, k];
}
function hsla$1(n, t, g, d) {
  return `hsla(${(n % 360).toFixed()}, ${guard(0, 100, t * 100).toFixed()}%, ${guard(0, 100, g * 100).toFixed()}%, ${parseFloat(guard(0, 1, d).toFixed(3))})`;
}
function darken(n, t) {
  const [g, d, k, H] = parseToHsla(n);
  return hsla$1(g, d, k - t, H);
}
function getLuminance(n) {
  if (n === "transparent") return 0;
  function t(H) {
    const AA = H / 255;
    return AA <= 0.04045 ? AA / 12.92 : Math.pow((AA + 0.055) / 1.055, 2.4);
  }
  const [g, d, k] = parseToRgba(n);
  return 0.2126 * t(g) + 0.7152 * t(d) + 0.0722 * t(k);
}
function rgba$2(n, t, g, d) {
  return `rgba(${guard(0, 255, n).toFixed()}, ${guard(0, 255, t).toFixed()}, ${guard(0, 255, g).toFixed()}, ${parseFloat(guard(0, 1, d).toFixed(3))})`;
}
function mix$1(n, t, g) {
  const d = (sA, rA) => (
    // 3rd index is alpha channel which is already normalized
    rA === 3 ? sA : sA / 255
  ), [k, H, AA, gA] = parseToRgba(n).map(d), [IA, CA, BA, eA] = parseToRgba(t).map(d), iA = eA - gA, QA = g * 2 - 1, oA = ((QA * iA === -1 ? QA : QA + iA / (1 + QA * iA)) + 1) / 2, EA = 1 - oA, aA = (k * EA + IA * oA) * 255, nA = (H * EA + CA * oA) * 255, lA = (AA * EA + BA * oA) * 255, cA = eA * g + gA * (1 - g);
  return rgba$2(aA, nA, lA, cA);
}
function lighten(n, t) {
  return darken(n, -t);
}
function transparentize(n, t) {
  const [g, d, k, H] = parseToRgba(n);
  return rgba$2(g, d, k, H - t);
}
function toHex(n) {
  const [t, g, d, k] = parseToRgba(n);
  let H = (AA) => {
    const gA = guard(0, 255, AA).toString(16);
    return gA.length === 1 ? `0${gA}` : gA;
  };
  return `#${H(t)}${H(g)}${H(d)}${k < 1 ? H(Math.round(k * 255)) : ""}`;
}
const createBaseUiThemePrimitives = (n, t) => {
  const {
    colors: g,
    genericFonts: d
  } = t;
  return {
    ...n,
    primaryFontFamily: d.bodyFont,
    primary100: g.primary,
    primary200: g.primary,
    primary300: g.primary,
    primary400: g.primary,
    primary500: g.primary,
    primary600: g.primary,
    primary700: g.primary,
    // Override gray values based on what is actually used in BaseWeb, and the
    // way we want it to match our theme originating from Bootstrap.
    mono100: g.bgColor,
    // Popup menu
    mono200: g.secondaryBg,
    // Text input, text area, selectbox
    mono300: g.gray30,
    // Disabled widget background
    mono400: g.gray30,
    // Slider track
    mono500: g.gray60,
    // Clicked checkbox and radio
    mono600: g.fadedText40,
    // Disabled widget text
    mono700: g.gray60,
    // Unselected checkbox and radio
    mono800: g.bodyText,
    // Selectbox text
    mono900: g.bodyText,
    // Not used, but just in case.
    mono1000: g.black
  };
}, createBaseUiThemeOverrides = (n) => {
  const {
    inSidebar: t,
    colors: g,
    genericFonts: d,
    fontSizes: k,
    lineHeights: H,
    radii: AA
  } = n, gA = {
    fontFamily: d.bodyFont,
    fontSize: k.md,
    fontSizeSm: k.sm,
    fontWeight: "normal",
    lineHeight: H.base,
    lineHeightTight: H.tight
  }, IA = g.secondaryBg, CA = t ? g.secondaryBg : g.bgColor, BA = t ? g.bgColor : g.secondaryBg;
  return {
    borders: {
      // Override borders that are declared from literals in
      // https://github.com/uber/baseweb/blob/master/src/themes/shared/borders.ts
      radius100: AA.default,
      radius200: AA.default,
      radius300: AA.default,
      radius400: AA.default,
      radius500: AA.default,
      /** Datepicker (Range), Progress Bar, Slider, Tag */
      useRoundedCorners: !0,
      /** Button, ButtonGroup */
      buttonBorderRadiusMini: AA.md,
      // Unused today.
      buttonBorderRadius: AA.default,
      /** Checkbox */
      checkboxBorderRadius: `min(${AA.md}, ${AA.maxCheckbox})`,
      /** Input, Select, Textarea */
      inputBorderRadiusMini: AA.md,
      // Unused today.
      inputBorderRadius: AA.default,
      /** Popover, Menu, Tooltip */
      popoverBorderRadius: AA.default,
      /** Card, Datepicker, Modal, Toast, Notification */
      surfaceBorderRadius: AA.default,
      /** Tag */
      tagBorderRadius: AA.md
    },
    typography: {
      // Here we override some fonts that are used in widgets. We don't care
      // about the ones that are not used.
      font100: {},
      font150: {
        ...gA
      },
      // Popup menus
      font200: {},
      font250: {},
      font300: {
        ...gA
      },
      // Popup menus
      font350: {
        ...gA
      },
      // Checkbox
      font400: {
        ...gA
      },
      // Textinput, textarea, selectboxes
      font450: {
        ...gA
      },
      // Radio
      font460: {
        ...gA
      },
      // Calendar header buttons
      font470: {
        ...gA
      },
      // Button
      font500: {
        ...gA
      },
      // Selected items in selectbox
      font600: {},
      LabelXSmall: {
        ...gA
      },
      LabelSmall: {
        ...gA
      },
      LabelMedium: {
        ...gA
      },
      LabelLarge: {
        ...gA
      },
      ParagraphSmall: {
        ...gA
      }
    },
    colors: {
      white: g.white,
      black: g.black,
      primary: g.primary,
      primaryA: g.primary,
      backgroundPrimary: g.bgColor,
      backgroundSecondary: IA,
      backgroundTertiary: g.bgColor,
      borderOpaque: g.darkenedBgMix25,
      accent: transparentize(g.primary, 0.5),
      tagPrimarySolidBackground: g.primary,
      tagPrimaryFontDisabled: g.fadedText40,
      tagPrimaryOutlinedDisabled: g.transparent,
      borderSelected: g.primary,
      contentPrimary: g.bodyText,
      inputPlaceholder: g.fadedText60,
      tickFillDisabled: g.fadedText40,
      tickMarkFill: g.gray20,
      tickFillSelected: g.primary,
      datepickerBackground: CA,
      calendarBackground: CA,
      calendarForeground: g.bodyText,
      calendarDayForegroundPseudoSelected: g.bodyText,
      calendarHeaderBackground: BA,
      calendarHeaderBackgroundActive: BA,
      calendarHeaderForeground: g.bodyText,
      calendarHeaderForegroundDisabled: g.gray40,
      calendarDayBackgroundSelected: g.primary,
      calendarDayBackgroundSelectedHighlighted: g.primary,
      calendarDayForegroundSelected: g.white,
      calendarDayForegroundSelectedHighlighted: g.white,
      calendarDayForegroundPseudoSelectedHighlighted: g.bodyText,
      menuFontHighlighted: g.bodyText,
      menuFontSelected: g.bodyText,
      modalCloseColor: g.bodyText,
      notificationInfoBackground: g.blueBackgroundColor,
      notificationInfoText: g.blueTextColor,
      notificationPositiveBackground: g.greenBackgroundColor,
      notificationPositiveText: g.greenTextColor,
      notificationWarningBackground: g.yellowBackgroundColor,
      notificationWarningText: g.yellowTextColor,
      notificationNegativeBackground: g.redBackgroundColor,
      notificationNegativeText: g.redTextColor,
      progressbarTrackFill: IA,
      // mono100 overrides
      tickFill: g.lightenedBg05,
      // Checkbox and Radio
      tickMarkFillDisabled: g.lightenedBg05,
      // We want menuFill to always use bgColor. But when in sidebar, bgColor and secondaryBg are
      // swapped! So here we unswap them.
      menuFill: CA,
      // mono200 overrides
      buttonDisabledFill: g.lightenedBg05,
      tickFillHover: IA,
      inputFillDisabled: IA,
      inputFillActive: IA,
      // mono300 overrides
      toggleTrackFillDisabled: IA,
      tickFillActive: IA,
      sliderTrackFillDisabled: IA,
      inputBorder: g.widgetBorderColor || IA,
      inputFill: IA,
      inputEnhanceFill: IA,
      inputEnhancerFillDisabled: IA,
      // mono400 overrides
      buttonDisabledSpinnerBackground: g.gray40,
      toggleTrackFill: g.gray40,
      sliderTrackFill: g.gray40,
      sliderHandleInnerFill: g.gray40,
      sliderHandleInnerFillDisabled: g.gray40
    }
  };
}, createBaseUiTheme = (n, t = primitives) => createLightTheme(createBaseUiThemePrimitives(t, n), createBaseUiThemeOverrides(n)), computeDerivedColors = (n) => {
  const {
    bodyText: t,
    secondaryBg: g,
    bgColor: d
  } = n, k = getLuminance(d) > 0.5, H = transparentize(t, 0.9), AA = transparentize(t, 0.8), gA = transparentize(t, 0.7), IA = transparentize(t, 0.6), CA = transparentize(t, 0.4), BA = mix$1(d, g, 0.5), eA = k ? darken(BA, 0.3) : lighten(BA, 0.6), iA = transparentize(eA, 0.75), QA = transparentize(eA, 0.85), tA = lighten(d, 0.025);
  return {
    fadedText05: H,
    fadedText10: AA,
    fadedText20: gA,
    fadedText40: IA,
    fadedText60: CA,
    bgMix: BA,
    darkenedBgMix100: eA,
    darkenedBgMix25: iA,
    darkenedBgMix15: QA,
    lightenedBg05: tA
  };
};
function _isLightBackground(n) {
  return getLuminance(n) > 0.5;
}
function hasLightBackgroundColor(n) {
  return _isLightBackground(n.colors.bgColor);
}
const createEmotionColors = (n) => {
  const t = computeDerivedColors(n), g = defaultCategoricalColorsArray(n), d = defaultSequentialColorsArray(n);
  return {
    ...n,
    ...t,
    link: n.blueTextColor,
    codeTextColor: n.greenTextColor,
    codeBackgroundColor: t.bgMix,
    borderColor: t.fadedText10,
    borderColorLight: t.fadedText05,
    dataframeBorderColor: t.fadedText05,
    dataframeHeaderBackgroundColor: t.bgMix,
    headingColor: n.bodyText,
    chartCategoricalColors: g,
    chartSequentialColors: d
  };
};
function getDividerColors(n) {
  const {
    redColor: t,
    orangeColor: g,
    yellowColor: d,
    blueColor: k,
    greenColor: H,
    violetColor: AA,
    grayColor: gA
  } = n.colors;
  return {
    red: t,
    orange: g,
    yellow: d,
    blue: k,
    green: H,
    violet: AA,
    gray: gA,
    grey: gA,
    rainbow: `linear-gradient(to right, ${t}, ${g}, ${d}, ${H}, ${k}, ${AA})`
  };
}
function getMetricColor(n, t) {
  switch (t) {
    case Metric$2.MetricColor.RED:
      return n.colors.redColor;
    case Metric$2.MetricColor.GREEN:
      return n.colors.greenColor;
    // this must be grey
    default:
      return n.colors.grayColor;
  }
}
function getMarkdownBgColors(n) {
  const t = hasLightBackgroundColor(n), g = n.colors;
  return {
    redbg: g.redBackgroundColor,
    orangebg: g.orangeBackgroundColor,
    yellowbg: g.yellowBackgroundColor,
    bluebg: g.blueBackgroundColor,
    greenbg: g.greenBackgroundColor,
    violetbg: g.violetBackgroundColor,
    purplebg: transparentize(g[t ? "purple90" : "purple80"], t ? 0.9 : 0.7),
    graybg: g.grayBackgroundColor,
    primarybg: transparentize(g.primary, t ? 0.9 : 0.7)
  };
}
function getMetricBackgroundColor(n, t) {
  switch (t) {
    case Metric$2.MetricColor.RED:
      return n.colors.redBackgroundColor;
    case Metric$2.MetricColor.GREEN:
      return n.colors.greenBackgroundColor;
    // this must be grey
    default:
      return n.colors.grayBackgroundColor;
  }
}
function getMarkdownTextColors(n) {
  const t = hasLightBackgroundColor(n), g = n.colors, d = g.primary, k = g.redTextColor, H = g.orangeTextColor, AA = g.yellowTextColor, gA = g.blueTextColor, IA = g.greenTextColor, CA = g.violetTextColor, BA = t ? g.purple100 : g.purple80, eA = g.grayTextColor;
  return {
    red: k,
    orange: H,
    yellow: AA,
    green: IA,
    blue: gA,
    violet: CA,
    purple: BA,
    gray: eA,
    primary: d
  };
}
function getMetricTextColor(n, t) {
  switch (t) {
    case Metric$2.MetricColor.RED:
      return n.colors.redTextColor;
    case Metric$2.MetricColor.GREEN:
      return n.colors.greenTextColor;
    // this must be grey
    default:
      return n.colors.grayTextColor;
  }
}
function getGray70(n) {
  return hasLightBackgroundColor(n) ? n.colors.gray70 : n.colors.gray30;
}
function getGray30(n) {
  return hasLightBackgroundColor(n) ? n.colors.gray30 : n.colors.gray85;
}
function getGray90(n) {
  return hasLightBackgroundColor(n) ? n.colors.gray90 : n.colors.gray10;
}
function getBlue80(n) {
  return hasLightBackgroundColor(n) ? n.colors.blue80 : n.colors.blue40;
}
function getBlueArrayAsc(n) {
  return [n.blue10, n.blue20, n.blue30, n.blue40, n.blue50, n.blue60, n.blue70, n.blue80, n.blue90, n.blue100];
}
function getBlueArrayDesc(n) {
  return [n.blue100, n.blue90, n.blue80, n.blue70, n.blue60, n.blue50, n.blue40, n.blue30, n.blue20, n.blue10];
}
function getDivergingColorsArray(n) {
  const {
    colors: t
  } = n;
  return [t.red100, t.red90, t.red70, t.red50, t.red30, t.blue30, t.blue50, t.blue70, t.blue90, t.blue100];
}
function defaultSequentialColorsArray(n) {
  return _isLightBackground(n.bgColor) ? getBlueArrayAsc(n) : getBlueArrayDesc(n);
}
function defaultCategoricalColorsArray(n) {
  return _isLightBackground(n.bgColor) ? [n.blue80, n.blue40, n.red80, n.red40, n.blueGreen80, n.green40, n.orange80, n.orange50, n.purple80, n.gray40] : [n.blue40, n.blue80, n.red40, n.red80, n.green40, n.blueGreen80, n.orange50, n.orange80, n.purple80, n.gray40];
}
function getDecreasingRed(n) {
  return hasLightBackgroundColor(n) ? n.colors.red80 : n.colors.red40;
}
function getIncreasingGreen(n) {
  return hasLightBackgroundColor(n) ? n.colors.blueGreen80 : n.colors.green40;
}
const breakpoints = {
  // This value is used to determine whether we should hide/show the "Please enter to apply" in all widgets.
  hideWidgetDetails: 180,
  // This value is used to determine whether we should hide/show the - and + buttons in st.number_input.
  hideNumberInputControls: 120,
  sm: "576px",
  columns: "640px",
  md: "768px"
}, colors$2 = {
  transparent: "transparent",
  black: "#000000",
  white: "#ffffff",
  gray10: "#fafafa",
  gray20: "#f0f2f6",
  gray30: "#e6eaf1",
  gray40: "#d5dae5",
  gray50: "#bfc5d3",
  gray60: "#a3a8b8",
  gray70: "#808495",
  gray80: "#555867",
  gray85: "#31333F",
  gray90: "#262730",
  gray100: "#0e1117",
  red10: "#fff0f0",
  red20: "#ffdede",
  red30: "#ffc7c7",
  red40: "#ffabab",
  red50: "#ff8c8c",
  red60: "#ff6c6c",
  red70: "#ff4b4b",
  red80: "#ff2b2b",
  red90: "#bd4043",
  red100: "#7d353b",
  orange10: "#fffae8",
  orange20: "#fff6d0",
  orange30: "#ffecb0",
  orange40: "#ffe08e",
  orange50: "#ffd16a",
  orange60: "#ffbd45",
  orange70: "#ffa421",
  orange80: "#ff8700",
  orange90: "#ed6f13",
  orange95: "#e2660c",
  orange100: "#d95a00",
  yellow10: "#ffffe1",
  yellow20: "#ffffc2",
  yellow30: "#ffffa0",
  yellow40: "#ffff7d",
  yellow50: "#ffff59",
  yellow60: "#fff835",
  yellow65: "#ffff12",
  yellow70: "#ffe312",
  yellow80: "#faca2b",
  yellow90: "#edbb16",
  yellow100: "#dea816",
  yellow110: "#916e10",
  yellow115: "#926c05",
  green10: "#dffde9",
  green20: "#c0fcd3",
  green30: "#9ef6bb",
  green40: "#7defa1",
  green50: "#5ce488",
  green60: "#3dd56d",
  green70: "#21c354",
  green80: "#09ab3b",
  green90: "#158237",
  green100: "#177233",
  blueGreen10: "#dcfffb",
  blueGreen20: "#bafff7",
  blueGreen30: "#93ffee",
  blueGreen40: "#6bfde3",
  blueGreen50: "#45f4d5",
  blueGreen60: "#20e7c5",
  blueGreen70: "#00d4b1",
  blueGreen80: "#29b09d",
  blueGreen90: "#2c867c",
  blueGreen100: "#246e69",
  lightBlue10: "#e0feff",
  lightBlue20: "#bffdff",
  lightBlue30: "#9af8ff",
  lightBlue40: "#73efff",
  lightBlue50: "#4be4ff",
  lightBlue60: "#24d4ff",
  lightBlue70: "#00c0f2",
  lightBlue80: "#00a4d4",
  lightBlue90: "#0d8cb5",
  lightBlue100: "#15799e",
  blue10: "#e4f5ff",
  blue20: "#c7ebff",
  blue30: "#a6dcff",
  blue40: "#83c9ff",
  blue50: "#60b4ff",
  blue60: "#3d9df3",
  blue65: "#1c83ff",
  blue70: "#1c83e1",
  blue80: "#0068c9",
  blue90: "#0054a3",
  blue100: "#004280",
  purple10: "#f5ebff",
  purple20: "#ebd6ff",
  purple30: "#dbbbff",
  purple40: "#c89dff",
  purple50: "#b27eff",
  purple60: "#9a5dff",
  purple70: "#803df5",
  purple80: "#6d3fc0",
  purple90: "#583f84",
  purple100: "#3f3163"
}, iconSizes = {
  xs: "0.5rem",
  sm: "0.75rem",
  md: "0.9rem",
  base: "1rem",
  lg: "1.25rem",
  xl: "1.5rem",
  twoXL: "1.8rem",
  threeXL: "2.3rem"
}, radii = {
  md: "0.25rem",
  // This is the default radius used in most elements:
  default: "0.5rem",
  xl: "0.75rem",
  xxl: "1rem",
  // Radius specific to buttons (enables buttonRadius config):
  button: "0.5rem",
  // Chat input enforces a more rounded look:
  chatInput: "1.25rem",
  // Ensures that the element is fully rounded:
  full: "9999px",
  // The maximum radius for checkboxes to still be recognizable as a checkbox:
  maxCheckbox: "0.35rem"
}, sizes = {
  full: "100%",
  headerHeight: "3.75rem",
  // Old header height to avoid addtl cascading visual/snapshot changes
  fullScreenHeaderHeight: "2.875rem",
  sidebarTopSpace: "6rem",
  toastWidth: "21rem",
  // Use px here since we want to keep the width the same
  // regardless of the root font size.
  contentMaxWidth: "736px",
  maxChartTooltipWidth: "30rem",
  // Used for checkboxes, radio, and toggles:
  checkbox: "1rem",
  borderWidth: "1px",
  // Used for checkboxes/toggle
  smallElementHeight: "1.5rem",
  // min height used for most input widgets
  minElementHeight: "2.5rem",
  // min height for larger input widgets like text area and audio input
  largestElementHeight: "4.25rem",
  smallLogoHeight: "1.25rem",
  defaultLogoHeight: "1.5rem",
  largeLogoHeight: "2rem",
  sliderThumb: "0.75rem",
  wideSidePadding: "5rem",
  headerDecorationHeight: "0.125rem",
  appRunningMen: "1.6rem",
  appStatusMaxWidth: "20rem",
  spinnerSize: "1.375rem",
  spinnerThickness: "0.125rem",
  tabHeight: "2.5rem",
  // Min width used for popover and dialog:
  minPopupWidth: "20rem",
  maxTooltipHeight: "18.75rem",
  chatAvatarSize: "2rem",
  // Used for the clear icon used by some Input elements
  clearIconSize: "1.5em",
  numberInputControlsWidth: "2rem",
  emptyDropdownHeight: "5.625rem",
  dropdownItemHeight: "2.5rem",
  maxDropdownHeight: "18.75rem",
  appDefaultBottomPadding: "3.5rem",
  defaultMapHeight: "31.25rem",
  defaultChartHeight: "21.875rem",
  defaultChartWidth: "25rem",
  // The minimum width of the menu (used for the dataframe column menu)
  minMenuWidth: "8rem",
  minChatInputFileListHeight: "3rem",
  headerItemHeight: "1.75rem",
  headerRightContentMaxWidth: "12.5rem"
}, spacing$1 = {
  px: "1px",
  none: "0",
  threeXS: "0.125rem",
  // 2px
  twoXS: "0.25rem",
  // 4px
  xs: "0.375rem",
  // 6px
  sm: "0.5rem",
  // 8px
  md: "0.75rem",
  // 12px
  lg: "1rem",
  // 16px
  xl: "1.25rem",
  // 20px
  twoXL: "1.5rem",
  // 24px
  threeXL: "2rem",
  // 32px
  fourXL: "4rem"
  // 64px
}, fonts = {
  sansSerif: '"Source Sans", sans-serif',
  monospace: '"Source Code Pro", monospace',
  serif: '"Source Serif", serif',
  materialIcons: "Material Symbols Rounded"
}, genericFonts = {
  bodyFont: fonts.sansSerif,
  codeFont: fonts.monospace,
  headingFont: fonts.sansSerif,
  iconFont: fonts.materialIcons
}, fontSizes = {
  // baseFontSize equals to md, but in pixels (this value can also be configured by the user)
  // The baseFontSize should only be used in global styles.
  baseFontSize: 16,
  twoSm: "0.75rem",
  sm: "0.875rem",
  md: "1rem",
  mdLg: "1.125rem",
  lg: "1.25rem",
  xl: "1.5rem",
  twoXL: "1.75rem",
  threeXL: "2.25rem",
  fourXL: "2.75rem",
  codeFontSize: "0.875rem",
  // Inline code font size as em value for proper scaling w/ headers, captions,
  // sidebar, etc.
  inlineCodeFontSize: "0.75em",
  // Header font sizes - unaffected by baseFontSize, configured via headingFontSizes
  h1FontSize: "2.75rem",
  h2FontSize: "2.25rem",
  h3FontSize: "1.75rem",
  h4FontSize: "1.5rem",
  h5FontSize: "1.25rem",
  h6FontSize: "1rem"
}, fontWeights = {
  normal: 400,
  semiBold: 500,
  bold: 600,
  extrabold: 700,
  // codeFontWeight separately configurable
  code: 400,
  codeBold: 600,
  codeExtraBold: 700,
  // baseFontWeight config does not affect headers
  // defaults set here for h1-h6
  h1FontWeight: 700,
  h2FontWeight: 600,
  h3FontWeight: 600,
  h4FontWeight: 600,
  h5FontWeight: 600,
  h6FontWeight: 600
}, lineHeights = {
  none: 1,
  headings: 1.2,
  tight: 1.25,
  inputWidget: 1.4,
  small: 1.5,
  base: 1.6,
  menuItem: 2
}, sidebar = 100, menuButton = sidebar + 10, balloons = 1e6, header = balloons - 10, bottom = sidebar - 1, sidebarMobile = balloons - 5, fullscreenWrapper = balloons + 50, headerDecoration = balloons - 1, popup = fullscreenWrapper + 10, tablePortal = fullscreenWrapper + 60, cacheSpinner = sidebar + 1, toast = popup + 1, zIndices = {
  hide: -1,
  auto: "auto",
  base: 0,
  // this is used if we want to ensure that an element
  // is shown above the parent elements.
  priority: 1,
  sidebar,
  menuButton,
  balloons,
  header,
  sidebarMobile,
  popup,
  fullscreenWrapper,
  tablePortal,
  bottom,
  cacheSpinner,
  toast,
  headerDecoration
}, requiredThemeColors = {
  bgColor: colors$2.white,
  secondaryBg: colors$2.gray20,
  bodyText: colors$2.gray85,
  primary: colors$2.red70,
  secondary: colors$2.blue70,
  // Used in progress bar
  // Default main theme colors (light theme)
  redColor: colors$2.red70,
  orangeColor: colors$2.orange70,
  yellowColor: colors$2.yellow80,
  blueColor: colors$2.blue70,
  greenColor: colors$2.green70,
  violetColor: colors$2.purple70,
  grayColor: colors$2.gray60,
  // Default background theme colors (light theme)
  redBackgroundColor: transparentize(colors$2.red80, 0.9),
  orangeBackgroundColor: transparentize(colors$2.orange70, 0.9),
  yellowBackgroundColor: transparentize(colors$2.yellow65, 0.9),
  blueBackgroundColor: transparentize(colors$2.blue65, 0.9),
  greenBackgroundColor: transparentize(colors$2.green70, 0.9),
  violetBackgroundColor: transparentize(colors$2.purple60, 0.9),
  grayBackgroundColor: transparentize(colors$2.gray85, 0.9),
  // Default text theme colors (light theme)
  redTextColor: colors$2.red90,
  orangeTextColor: colors$2.orange95,
  yellowTextColor: colors$2.yellow115,
  blueTextColor: colors$2.blue90,
  greenTextColor: colors$2.green90,
  violetTextColor: colors$2.purple90,
  grayTextColor: transparentize(colors$2.gray85, 0.4)
}, optionalThemeColors = {}, themeColors = {
  ...colors$2,
  ...requiredThemeColors,
  ...optionalThemeColors
}, emotionBaseTheme = {
  inSidebar: !1,
  showSidebarBorder: !1,
  linkUnderline: !0,
  breakpoints,
  colors: createEmotionColors(themeColors),
  fonts,
  fontSizes,
  fontWeights,
  genericFonts,
  iconSizes,
  lineHeights,
  radii,
  sizes,
  spacing: spacing$1,
  zIndices
}, genericColors$1 = {
  ...colors$2,
  bgColor: colors$2.gray100,
  bodyText: colors$2.gray10,
  primary: colors$2.red70,
  secondaryBg: colors$2.gray90,
  // Default main theme colors (dark theme)
  redColor: colors$2.red80,
  orangeColor: colors$2.orange80,
  yellowColor: colors$2.yellow70,
  blueColor: colors$2.blue80,
  greenColor: colors$2.green80,
  violetColor: colors$2.purple70,
  grayColor: colors$2.gray80,
  // Default background theme colors (dark theme)
  redBackgroundColor: transparentize(colors$2.red60, 0.8),
  orangeBackgroundColor: transparentize(colors$2.orange80, 0.8),
  yellowBackgroundColor: transparentize(colors$2.yellow65, 0.8),
  blueBackgroundColor: transparentize(colors$2.blue60, 0.8),
  greenBackgroundColor: transparentize(colors$2.green60, 0.8),
  violetBackgroundColor: transparentize(colors$2.purple60, 0.8),
  grayBackgroundColor: transparentize(colors$2.gray70, 0.8),
  // Default text theme colors (dark theme)
  redTextColor: colors$2.red60,
  orangeTextColor: colors$2.orange60,
  yellowTextColor: colors$2.yellow20,
  blueTextColor: colors$2.blue60,
  greenTextColor: colors$2.green50,
  violetTextColor: colors$2.purple50,
  grayTextColor: transparentize(colors$2.gray10, 0.4)
}, emotionDarkTheme = {
  ...emotionBaseTheme,
  inSidebar: !1,
  colors: createEmotionColors({
    ...emotionBaseTheme.colors,
    ...genericColors$1
  })
}, genericColors = {
  ...colors$2
}, emotionLightTheme = {
  ...emotionBaseTheme,
  inSidebar: !1,
  colors: createEmotionColors({
    ...emotionBaseTheme.colors,
    ...genericColors
  })
}, baseuiLightTheme = createBaseUiTheme(emotionLightTheme, primitives), baseuiDarkTheme = createBaseUiTheme(emotionDarkTheme, primitives$1), globalStyles = (n) => /* @__PURE__ */ css("html{font-size:", n.fontSizes.baseFontSize, "px;}@media print{html{height:100%;print-color-adjust:exact;-webkit-print-color-adjust:exact;}}*,*::before,*::after{box-sizing:border-box;}body{margin:0;font-family:", n.genericFonts.bodyFont, ";font-weight:", n.fontWeights.normal, ";line-height:", n.lineHeights.base, ";color:", n.colors.bodyText, ";background-color:", n.colors.bgColor, ";-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:", transparentize(n.colors.black, 1), ';-webkit-font-smoothing:auto;}body.embedded{overflow:hidden;}body.embedded:hover{overflow:auto;}[tabindex="-1"]:focus:not(:focus-visible){outline:0!important;}p,ol,ul,dl{margin:0 0 1rem 0;padding:0;font-size:1rem;font-weight:', n.fontWeights.normal, ';}ol ol,ul ul,ol ul,ul ol{margin-bottom:0;}a:not([href]):not([class]){&,&:hover{color:inherit;text-decoration:none;}}img,svg{vertical-align:middle;}input,button,select,optgroup,textarea{margin:0;font-family:inherit;line-height:inherit;font-size:inherit;}button,input{overflow:visible;}button,[role="button"]{&:not(:disabled){cursor:pointer;}}button,[type="button"],[type="reset"],[type="submit"]{-webkit-appearance:button;}[hidden]{display:none!important;}@supports (scrollbar-color: transparent transparent){*{scrollbar-width:thin;scrollbar-color:transparent transparent;}*:hover{scrollbar-color:', n.colors.fadedText40, " transparent;}}@supports not (scrollbar-color: transparent transparent){::-webkit-scrollbar{background:transparent;border-radius:", n.radii.full, ";height:6px;width:6px;}::-webkit-scrollbar:active{background:", n.colors.fadedText10, ";}:hover::-webkit-scrollbar-thumb:vertical,:hover::-webkit-scrollbar-thumb:horizontal{background:", n.colors.fadedText40, ";border-radius:", n.radii.full, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:globalStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), baseTheme = {
  name: "base",
  emotion: emotionBaseTheme,
  basewebTheme: baseuiLightTheme,
  primitives
}, darkTheme$1 = {
  name: "Dark",
  emotion: emotionDarkTheme,
  basewebTheme: baseuiDarkTheme,
  primitives: primitives$1
}, lightTheme = {
  name: "Light",
  emotion: emotionLightTheme,
  basewebTheme: baseuiLightTheme,
  primitives
};
var _stackClear, hasRequired_stackClear;
function require_stackClear() {
  if (hasRequired_stackClear) return _stackClear;
  hasRequired_stackClear = 1;
  var n = require_ListCache();
  function t() {
    this.__data__ = new n(), this.size = 0;
  }
  return _stackClear = t, _stackClear;
}
var _stackDelete, hasRequired_stackDelete;
function require_stackDelete() {
  if (hasRequired_stackDelete) return _stackDelete;
  hasRequired_stackDelete = 1;
  function n(t) {
    var g = this.__data__, d = g.delete(t);
    return this.size = g.size, d;
  }
  return _stackDelete = n, _stackDelete;
}
var _stackGet, hasRequired_stackGet;
function require_stackGet() {
  if (hasRequired_stackGet) return _stackGet;
  hasRequired_stackGet = 1;
  function n(t) {
    return this.__data__.get(t);
  }
  return _stackGet = n, _stackGet;
}
var _stackHas, hasRequired_stackHas;
function require_stackHas() {
  if (hasRequired_stackHas) return _stackHas;
  hasRequired_stackHas = 1;
  function n(t) {
    return this.__data__.has(t);
  }
  return _stackHas = n, _stackHas;
}
var _stackSet, hasRequired_stackSet;
function require_stackSet() {
  if (hasRequired_stackSet) return _stackSet;
  hasRequired_stackSet = 1;
  var n = require_ListCache(), t = require_Map(), g = require_MapCache(), d = 200;
  function k(H, AA) {
    var gA = this.__data__;
    if (gA instanceof n) {
      var IA = gA.__data__;
      if (!t || IA.length < d - 1)
        return IA.push([H, AA]), this.size = ++gA.size, this;
      gA = this.__data__ = new g(IA);
    }
    return gA.set(H, AA), this.size = gA.size, this;
  }
  return _stackSet = k, _stackSet;
}
var _Stack, hasRequired_Stack;
function require_Stack() {
  if (hasRequired_Stack) return _Stack;
  hasRequired_Stack = 1;
  var n = require_ListCache(), t = require_stackClear(), g = require_stackDelete(), d = require_stackGet(), k = require_stackHas(), H = require_stackSet();
  function AA(gA) {
    var IA = this.__data__ = new n(gA);
    this.size = IA.size;
  }
  return AA.prototype.clear = t, AA.prototype.delete = g, AA.prototype.get = d, AA.prototype.has = k, AA.prototype.set = H, _Stack = AA, _Stack;
}
var _arrayEach, hasRequired_arrayEach;
function require_arrayEach() {
  if (hasRequired_arrayEach) return _arrayEach;
  hasRequired_arrayEach = 1;
  function n(t, g) {
    for (var d = -1, k = t == null ? 0 : t.length; ++d < k && g(t[d], d, t) !== !1; )
      ;
    return t;
  }
  return _arrayEach = n, _arrayEach;
}
var _baseAssignValue, hasRequired_baseAssignValue;
function require_baseAssignValue() {
  if (hasRequired_baseAssignValue) return _baseAssignValue;
  hasRequired_baseAssignValue = 1;
  var n = require_defineProperty();
  function t(g, d, k) {
    d == "__proto__" && n ? n(g, d, {
      configurable: !0,
      enumerable: !0,
      value: k,
      writable: !0
    }) : g[d] = k;
  }
  return _baseAssignValue = t, _baseAssignValue;
}
var _assignValue, hasRequired_assignValue;
function require_assignValue() {
  if (hasRequired_assignValue) return _assignValue;
  hasRequired_assignValue = 1;
  var n = require_baseAssignValue(), t = requireEq$1(), g = Object.prototype, d = g.hasOwnProperty;
  function k(H, AA, gA) {
    var IA = H[AA];
    (!(d.call(H, AA) && t(IA, gA)) || gA === void 0 && !(AA in H)) && n(H, AA, gA);
  }
  return _assignValue = k, _assignValue;
}
var _copyObject, hasRequired_copyObject;
function require_copyObject() {
  if (hasRequired_copyObject) return _copyObject;
  hasRequired_copyObject = 1;
  var n = require_assignValue(), t = require_baseAssignValue();
  function g(d, k, H, AA) {
    var gA = !H;
    H || (H = {});
    for (var IA = -1, CA = k.length; ++IA < CA; ) {
      var BA = k[IA], eA = AA ? AA(H[BA], d[BA], BA, H, d) : void 0;
      eA === void 0 && (eA = d[BA]), gA ? t(H, BA, eA) : n(H, BA, eA);
    }
    return H;
  }
  return _copyObject = g, _copyObject;
}
var _baseIsArguments, hasRequired_baseIsArguments;
function require_baseIsArguments() {
  if (hasRequired_baseIsArguments) return _baseIsArguments;
  hasRequired_baseIsArguments = 1;
  var n = require_baseGetTag(), t = requireIsObjectLike(), g = "[object Arguments]";
  function d(k) {
    return t(k) && n(k) == g;
  }
  return _baseIsArguments = d, _baseIsArguments;
}
var isArguments_1, hasRequiredIsArguments;
function requireIsArguments() {
  if (hasRequiredIsArguments) return isArguments_1;
  hasRequiredIsArguments = 1;
  var n = require_baseIsArguments(), t = requireIsObjectLike(), g = Object.prototype, d = g.hasOwnProperty, k = g.propertyIsEnumerable, H = n(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? n : function(AA) {
    return t(AA) && d.call(AA, "callee") && !k.call(AA, "callee");
  };
  return isArguments_1 = H, isArguments_1;
}
var isBuffer$3 = { exports: {} }, stubFalse_1, hasRequiredStubFalse;
function requireStubFalse() {
  if (hasRequiredStubFalse) return stubFalse_1;
  hasRequiredStubFalse = 1;
  function n() {
    return !1;
  }
  return stubFalse_1 = n, stubFalse_1;
}
isBuffer$3.exports;
var hasRequiredIsBuffer;
function requireIsBuffer() {
  return hasRequiredIsBuffer || (hasRequiredIsBuffer = 1, (function(n, t) {
    var g = require_root(), d = requireStubFalse(), k = t && !t.nodeType && t, H = k && !0 && n && !n.nodeType && n, AA = H && H.exports === k, gA = AA ? g.Buffer : void 0, IA = gA ? gA.isBuffer : void 0, CA = IA || d;
    n.exports = CA;
  })(isBuffer$3, isBuffer$3.exports)), isBuffer$3.exports;
}
var _baseIsTypedArray, hasRequired_baseIsTypedArray;
function require_baseIsTypedArray() {
  if (hasRequired_baseIsTypedArray) return _baseIsTypedArray;
  hasRequired_baseIsTypedArray = 1;
  var n = require_baseGetTag(), t = requireIsLength(), g = requireIsObjectLike(), d = "[object Arguments]", k = "[object Array]", H = "[object Boolean]", AA = "[object Date]", gA = "[object Error]", IA = "[object Function]", CA = "[object Map]", BA = "[object Number]", eA = "[object Object]", iA = "[object RegExp]", QA = "[object Set]", tA = "[object String]", oA = "[object WeakMap]", EA = "[object ArrayBuffer]", aA = "[object DataView]", nA = "[object Float32Array]", lA = "[object Float64Array]", cA = "[object Int8Array]", sA = "[object Int16Array]", rA = "[object Int32Array]", uA = "[object Uint8Array]", hA = "[object Uint8ClampedArray]", dA = "[object Uint16Array]", GA = "[object Uint32Array]", DA = {};
  DA[nA] = DA[lA] = DA[cA] = DA[sA] = DA[rA] = DA[uA] = DA[hA] = DA[dA] = DA[GA] = !0, DA[d] = DA[k] = DA[EA] = DA[H] = DA[aA] = DA[AA] = DA[gA] = DA[IA] = DA[CA] = DA[BA] = DA[eA] = DA[iA] = DA[QA] = DA[tA] = DA[oA] = !1;
  function wA(bA) {
    return g(bA) && t(bA.length) && !!DA[n(bA)];
  }
  return _baseIsTypedArray = wA, _baseIsTypedArray;
}
var _baseUnary, hasRequired_baseUnary;
function require_baseUnary() {
  if (hasRequired_baseUnary) return _baseUnary;
  hasRequired_baseUnary = 1;
  function n(t) {
    return function(g) {
      return t(g);
    };
  }
  return _baseUnary = n, _baseUnary;
}
var _nodeUtil = { exports: {} };
_nodeUtil.exports;
var hasRequired_nodeUtil;
function require_nodeUtil() {
  return hasRequired_nodeUtil || (hasRequired_nodeUtil = 1, (function(n, t) {
    var g = require_freeGlobal(), d = t && !t.nodeType && t, k = d && !0 && n && !n.nodeType && n, H = k && k.exports === d, AA = H && g.process, gA = (function() {
      try {
        var IA = k && k.require && k.require("util").types;
        return IA || AA && AA.binding && AA.binding("util");
      } catch {
      }
    })();
    n.exports = gA;
  })(_nodeUtil, _nodeUtil.exports)), _nodeUtil.exports;
}
var isTypedArray_1, hasRequiredIsTypedArray;
function requireIsTypedArray() {
  if (hasRequiredIsTypedArray) return isTypedArray_1;
  hasRequiredIsTypedArray = 1;
  var n = require_baseIsTypedArray(), t = require_baseUnary(), g = require_nodeUtil(), d = g && g.isTypedArray, k = d ? t(d) : n;
  return isTypedArray_1 = k, isTypedArray_1;
}
var _arrayLikeKeys, hasRequired_arrayLikeKeys;
function require_arrayLikeKeys() {
  if (hasRequired_arrayLikeKeys) return _arrayLikeKeys;
  hasRequired_arrayLikeKeys = 1;
  var n = require_baseTimes(), t = requireIsArguments(), g = requireIsArray(), d = requireIsBuffer(), k = require_isIndex(), H = requireIsTypedArray(), AA = Object.prototype, gA = AA.hasOwnProperty;
  function IA(CA, BA) {
    var eA = g(CA), iA = !eA && t(CA), QA = !eA && !iA && d(CA), tA = !eA && !iA && !QA && H(CA), oA = eA || iA || QA || tA, EA = oA ? n(CA.length, String) : [], aA = EA.length;
    for (var nA in CA)
      (BA || gA.call(CA, nA)) && !(oA && // Safari 9 has enumerable `arguments.length` in strict mode.
      (nA == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      QA && (nA == "offset" || nA == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      tA && (nA == "buffer" || nA == "byteLength" || nA == "byteOffset") || // Skip index properties.
      k(nA, aA))) && EA.push(nA);
    return EA;
  }
  return _arrayLikeKeys = IA, _arrayLikeKeys;
}
var _isPrototype, hasRequired_isPrototype;
function require_isPrototype() {
  if (hasRequired_isPrototype) return _isPrototype;
  hasRequired_isPrototype = 1;
  var n = Object.prototype;
  function t(g) {
    var d = g && g.constructor, k = typeof d == "function" && d.prototype || n;
    return g === k;
  }
  return _isPrototype = t, _isPrototype;
}
var _overArg, hasRequired_overArg;
function require_overArg() {
  if (hasRequired_overArg) return _overArg;
  hasRequired_overArg = 1;
  function n(t, g) {
    return function(d) {
      return t(g(d));
    };
  }
  return _overArg = n, _overArg;
}
var _nativeKeys, hasRequired_nativeKeys;
function require_nativeKeys() {
  if (hasRequired_nativeKeys) return _nativeKeys;
  hasRequired_nativeKeys = 1;
  var n = require_overArg(), t = n(Object.keys, Object);
  return _nativeKeys = t, _nativeKeys;
}
var _baseKeys, hasRequired_baseKeys;
function require_baseKeys() {
  if (hasRequired_baseKeys) return _baseKeys;
  hasRequired_baseKeys = 1;
  var n = require_isPrototype(), t = require_nativeKeys(), g = Object.prototype, d = g.hasOwnProperty;
  function k(H) {
    if (!n(H))
      return t(H);
    var AA = [];
    for (var gA in Object(H))
      d.call(H, gA) && gA != "constructor" && AA.push(gA);
    return AA;
  }
  return _baseKeys = k, _baseKeys;
}
var keys_1, hasRequiredKeys;
function requireKeys() {
  if (hasRequiredKeys) return keys_1;
  hasRequiredKeys = 1;
  var n = require_arrayLikeKeys(), t = require_baseKeys(), g = requireIsArrayLike();
  function d(k) {
    return g(k) ? n(k) : t(k);
  }
  return keys_1 = d, keys_1;
}
var _baseAssign, hasRequired_baseAssign;
function require_baseAssign() {
  if (hasRequired_baseAssign) return _baseAssign;
  hasRequired_baseAssign = 1;
  var n = require_copyObject(), t = requireKeys();
  function g(d, k) {
    return d && n(k, t(k), d);
  }
  return _baseAssign = g, _baseAssign;
}
var _nativeKeysIn, hasRequired_nativeKeysIn;
function require_nativeKeysIn() {
  if (hasRequired_nativeKeysIn) return _nativeKeysIn;
  hasRequired_nativeKeysIn = 1;
  function n(t) {
    var g = [];
    if (t != null)
      for (var d in Object(t))
        g.push(d);
    return g;
  }
  return _nativeKeysIn = n, _nativeKeysIn;
}
var _baseKeysIn, hasRequired_baseKeysIn;
function require_baseKeysIn() {
  if (hasRequired_baseKeysIn) return _baseKeysIn;
  hasRequired_baseKeysIn = 1;
  var n = requireIsObject(), t = require_isPrototype(), g = require_nativeKeysIn(), d = Object.prototype, k = d.hasOwnProperty;
  function H(AA) {
    if (!n(AA))
      return g(AA);
    var gA = t(AA), IA = [];
    for (var CA in AA)
      CA == "constructor" && (gA || !k.call(AA, CA)) || IA.push(CA);
    return IA;
  }
  return _baseKeysIn = H, _baseKeysIn;
}
var keysIn_1, hasRequiredKeysIn;
function requireKeysIn() {
  if (hasRequiredKeysIn) return keysIn_1;
  hasRequiredKeysIn = 1;
  var n = require_arrayLikeKeys(), t = require_baseKeysIn(), g = requireIsArrayLike();
  function d(k) {
    return g(k) ? n(k, !0) : t(k);
  }
  return keysIn_1 = d, keysIn_1;
}
var _baseAssignIn, hasRequired_baseAssignIn;
function require_baseAssignIn() {
  if (hasRequired_baseAssignIn) return _baseAssignIn;
  hasRequired_baseAssignIn = 1;
  var n = require_copyObject(), t = requireKeysIn();
  function g(d, k) {
    return d && n(k, t(k), d);
  }
  return _baseAssignIn = g, _baseAssignIn;
}
var _cloneBuffer = { exports: {} };
_cloneBuffer.exports;
var hasRequired_cloneBuffer;
function require_cloneBuffer() {
  return hasRequired_cloneBuffer || (hasRequired_cloneBuffer = 1, (function(n, t) {
    var g = require_root(), d = t && !t.nodeType && t, k = d && !0 && n && !n.nodeType && n, H = k && k.exports === d, AA = H ? g.Buffer : void 0, gA = AA ? AA.allocUnsafe : void 0;
    function IA(CA, BA) {
      if (BA)
        return CA.slice();
      var eA = CA.length, iA = gA ? gA(eA) : new CA.constructor(eA);
      return CA.copy(iA), iA;
    }
    n.exports = IA;
  })(_cloneBuffer, _cloneBuffer.exports)), _cloneBuffer.exports;
}
var _copyArray, hasRequired_copyArray;
function require_copyArray() {
  if (hasRequired_copyArray) return _copyArray;
  hasRequired_copyArray = 1;
  function n(t, g) {
    var d = -1, k = t.length;
    for (g || (g = Array(k)); ++d < k; )
      g[d] = t[d];
    return g;
  }
  return _copyArray = n, _copyArray;
}
var stubArray_1, hasRequiredStubArray;
function requireStubArray() {
  if (hasRequiredStubArray) return stubArray_1;
  hasRequiredStubArray = 1;
  function n() {
    return [];
  }
  return stubArray_1 = n, stubArray_1;
}
var _getSymbols, hasRequired_getSymbols;
function require_getSymbols() {
  if (hasRequired_getSymbols) return _getSymbols;
  hasRequired_getSymbols = 1;
  var n = require_arrayFilter(), t = requireStubArray(), g = Object.prototype, d = g.propertyIsEnumerable, k = Object.getOwnPropertySymbols, H = k ? function(AA) {
    return AA == null ? [] : (AA = Object(AA), n(k(AA), function(gA) {
      return d.call(AA, gA);
    }));
  } : t;
  return _getSymbols = H, _getSymbols;
}
var _copySymbols, hasRequired_copySymbols;
function require_copySymbols() {
  if (hasRequired_copySymbols) return _copySymbols;
  hasRequired_copySymbols = 1;
  var n = require_copyObject(), t = require_getSymbols();
  function g(d, k) {
    return n(d, t(d), k);
  }
  return _copySymbols = g, _copySymbols;
}
var _arrayPush, hasRequired_arrayPush;
function require_arrayPush() {
  if (hasRequired_arrayPush) return _arrayPush;
  hasRequired_arrayPush = 1;
  function n(t, g) {
    for (var d = -1, k = g.length, H = t.length; ++d < k; )
      t[H + d] = g[d];
    return t;
  }
  return _arrayPush = n, _arrayPush;
}
var _getPrototype, hasRequired_getPrototype;
function require_getPrototype() {
  if (hasRequired_getPrototype) return _getPrototype;
  hasRequired_getPrototype = 1;
  var n = require_overArg(), t = n(Object.getPrototypeOf, Object);
  return _getPrototype = t, _getPrototype;
}
var _getSymbolsIn, hasRequired_getSymbolsIn;
function require_getSymbolsIn() {
  if (hasRequired_getSymbolsIn) return _getSymbolsIn;
  hasRequired_getSymbolsIn = 1;
  var n = require_arrayPush(), t = require_getPrototype(), g = require_getSymbols(), d = requireStubArray(), k = Object.getOwnPropertySymbols, H = k ? function(AA) {
    for (var gA = []; AA; )
      n(gA, g(AA)), AA = t(AA);
    return gA;
  } : d;
  return _getSymbolsIn = H, _getSymbolsIn;
}
var _copySymbolsIn, hasRequired_copySymbolsIn;
function require_copySymbolsIn() {
  if (hasRequired_copySymbolsIn) return _copySymbolsIn;
  hasRequired_copySymbolsIn = 1;
  var n = require_copyObject(), t = require_getSymbolsIn();
  function g(d, k) {
    return n(d, t(d), k);
  }
  return _copySymbolsIn = g, _copySymbolsIn;
}
var _baseGetAllKeys, hasRequired_baseGetAllKeys;
function require_baseGetAllKeys() {
  if (hasRequired_baseGetAllKeys) return _baseGetAllKeys;
  hasRequired_baseGetAllKeys = 1;
  var n = require_arrayPush(), t = requireIsArray();
  function g(d, k, H) {
    var AA = k(d);
    return t(d) ? AA : n(AA, H(d));
  }
  return _baseGetAllKeys = g, _baseGetAllKeys;
}
var _getAllKeys, hasRequired_getAllKeys;
function require_getAllKeys() {
  if (hasRequired_getAllKeys) return _getAllKeys;
  hasRequired_getAllKeys = 1;
  var n = require_baseGetAllKeys(), t = require_getSymbols(), g = requireKeys();
  function d(k) {
    return n(k, g, t);
  }
  return _getAllKeys = d, _getAllKeys;
}
var _getAllKeysIn, hasRequired_getAllKeysIn;
function require_getAllKeysIn() {
  if (hasRequired_getAllKeysIn) return _getAllKeysIn;
  hasRequired_getAllKeysIn = 1;
  var n = require_baseGetAllKeys(), t = require_getSymbolsIn(), g = requireKeysIn();
  function d(k) {
    return n(k, g, t);
  }
  return _getAllKeysIn = d, _getAllKeysIn;
}
var _DataView, hasRequired_DataView;
function require_DataView() {
  if (hasRequired_DataView) return _DataView;
  hasRequired_DataView = 1;
  var n = require_getNative(), t = require_root(), g = n(t, "DataView");
  return _DataView = g, _DataView;
}
var _Promise, hasRequired_Promise;
function require_Promise() {
  if (hasRequired_Promise) return _Promise;
  hasRequired_Promise = 1;
  var n = require_getNative(), t = require_root(), g = n(t, "Promise");
  return _Promise = g, _Promise;
}
var _Set, hasRequired_Set;
function require_Set() {
  if (hasRequired_Set) return _Set;
  hasRequired_Set = 1;
  var n = require_getNative(), t = require_root(), g = n(t, "Set");
  return _Set = g, _Set;
}
var _WeakMap, hasRequired_WeakMap;
function require_WeakMap() {
  if (hasRequired_WeakMap) return _WeakMap;
  hasRequired_WeakMap = 1;
  var n = require_getNative(), t = require_root(), g = n(t, "WeakMap");
  return _WeakMap = g, _WeakMap;
}
var _getTag, hasRequired_getTag;
function require_getTag() {
  if (hasRequired_getTag) return _getTag;
  hasRequired_getTag = 1;
  var n = require_DataView(), t = require_Map(), g = require_Promise(), d = require_Set(), k = require_WeakMap(), H = require_baseGetTag(), AA = require_toSource(), gA = "[object Map]", IA = "[object Object]", CA = "[object Promise]", BA = "[object Set]", eA = "[object WeakMap]", iA = "[object DataView]", QA = AA(n), tA = AA(t), oA = AA(g), EA = AA(d), aA = AA(k), nA = H;
  return (n && nA(new n(new ArrayBuffer(1))) != iA || t && nA(new t()) != gA || g && nA(g.resolve()) != CA || d && nA(new d()) != BA || k && nA(new k()) != eA) && (nA = function(lA) {
    var cA = H(lA), sA = cA == IA ? lA.constructor : void 0, rA = sA ? AA(sA) : "";
    if (rA)
      switch (rA) {
        case QA:
          return iA;
        case tA:
          return gA;
        case oA:
          return CA;
        case EA:
          return BA;
        case aA:
          return eA;
      }
    return cA;
  }), _getTag = nA, _getTag;
}
var _initCloneArray, hasRequired_initCloneArray;
function require_initCloneArray() {
  if (hasRequired_initCloneArray) return _initCloneArray;
  hasRequired_initCloneArray = 1;
  var n = Object.prototype, t = n.hasOwnProperty;
  function g(d) {
    var k = d.length, H = new d.constructor(k);
    return k && typeof d[0] == "string" && t.call(d, "index") && (H.index = d.index, H.input = d.input), H;
  }
  return _initCloneArray = g, _initCloneArray;
}
var _Uint8Array, hasRequired_Uint8Array;
function require_Uint8Array() {
  if (hasRequired_Uint8Array) return _Uint8Array;
  hasRequired_Uint8Array = 1;
  var n = require_root(), t = n.Uint8Array;
  return _Uint8Array = t, _Uint8Array;
}
var _cloneArrayBuffer, hasRequired_cloneArrayBuffer;
function require_cloneArrayBuffer() {
  if (hasRequired_cloneArrayBuffer) return _cloneArrayBuffer;
  hasRequired_cloneArrayBuffer = 1;
  var n = require_Uint8Array();
  function t(g) {
    var d = new g.constructor(g.byteLength);
    return new n(d).set(new n(g)), d;
  }
  return _cloneArrayBuffer = t, _cloneArrayBuffer;
}
var _cloneDataView, hasRequired_cloneDataView;
function require_cloneDataView() {
  if (hasRequired_cloneDataView) return _cloneDataView;
  hasRequired_cloneDataView = 1;
  var n = require_cloneArrayBuffer();
  function t(g, d) {
    var k = d ? n(g.buffer) : g.buffer;
    return new g.constructor(k, g.byteOffset, g.byteLength);
  }
  return _cloneDataView = t, _cloneDataView;
}
var _cloneRegExp, hasRequired_cloneRegExp;
function require_cloneRegExp() {
  if (hasRequired_cloneRegExp) return _cloneRegExp;
  hasRequired_cloneRegExp = 1;
  var n = /\w*$/;
  function t(g) {
    var d = new g.constructor(g.source, n.exec(g));
    return d.lastIndex = g.lastIndex, d;
  }
  return _cloneRegExp = t, _cloneRegExp;
}
var _cloneSymbol, hasRequired_cloneSymbol;
function require_cloneSymbol() {
  if (hasRequired_cloneSymbol) return _cloneSymbol;
  hasRequired_cloneSymbol = 1;
  var n = require_Symbol(), t = n ? n.prototype : void 0, g = t ? t.valueOf : void 0;
  function d(k) {
    return g ? Object(g.call(k)) : {};
  }
  return _cloneSymbol = d, _cloneSymbol;
}
var _cloneTypedArray, hasRequired_cloneTypedArray;
function require_cloneTypedArray() {
  if (hasRequired_cloneTypedArray) return _cloneTypedArray;
  hasRequired_cloneTypedArray = 1;
  var n = require_cloneArrayBuffer();
  function t(g, d) {
    var k = d ? n(g.buffer) : g.buffer;
    return new g.constructor(k, g.byteOffset, g.length);
  }
  return _cloneTypedArray = t, _cloneTypedArray;
}
var _initCloneByTag, hasRequired_initCloneByTag;
function require_initCloneByTag() {
  if (hasRequired_initCloneByTag) return _initCloneByTag;
  hasRequired_initCloneByTag = 1;
  var n = require_cloneArrayBuffer(), t = require_cloneDataView(), g = require_cloneRegExp(), d = require_cloneSymbol(), k = require_cloneTypedArray(), H = "[object Boolean]", AA = "[object Date]", gA = "[object Map]", IA = "[object Number]", CA = "[object RegExp]", BA = "[object Set]", eA = "[object String]", iA = "[object Symbol]", QA = "[object ArrayBuffer]", tA = "[object DataView]", oA = "[object Float32Array]", EA = "[object Float64Array]", aA = "[object Int8Array]", nA = "[object Int16Array]", lA = "[object Int32Array]", cA = "[object Uint8Array]", sA = "[object Uint8ClampedArray]", rA = "[object Uint16Array]", uA = "[object Uint32Array]";
  function hA(dA, GA, DA) {
    var wA = dA.constructor;
    switch (GA) {
      case QA:
        return n(dA);
      case H:
      case AA:
        return new wA(+dA);
      case tA:
        return t(dA, DA);
      case oA:
      case EA:
      case aA:
      case nA:
      case lA:
      case cA:
      case sA:
      case rA:
      case uA:
        return k(dA, DA);
      case gA:
        return new wA();
      case IA:
      case eA:
        return new wA(dA);
      case CA:
        return g(dA);
      case BA:
        return new wA();
      case iA:
        return d(dA);
    }
  }
  return _initCloneByTag = hA, _initCloneByTag;
}
var _baseCreate, hasRequired_baseCreate;
function require_baseCreate() {
  if (hasRequired_baseCreate) return _baseCreate;
  hasRequired_baseCreate = 1;
  var n = requireIsObject(), t = Object.create, g = /* @__PURE__ */ (function() {
    function d() {
    }
    return function(k) {
      if (!n(k))
        return {};
      if (t)
        return t(k);
      d.prototype = k;
      var H = new d();
      return d.prototype = void 0, H;
    };
  })();
  return _baseCreate = g, _baseCreate;
}
var _initCloneObject, hasRequired_initCloneObject;
function require_initCloneObject() {
  if (hasRequired_initCloneObject) return _initCloneObject;
  hasRequired_initCloneObject = 1;
  var n = require_baseCreate(), t = require_getPrototype(), g = require_isPrototype();
  function d(k) {
    return typeof k.constructor == "function" && !g(k) ? n(t(k)) : {};
  }
  return _initCloneObject = d, _initCloneObject;
}
var _baseIsMap, hasRequired_baseIsMap;
function require_baseIsMap() {
  if (hasRequired_baseIsMap) return _baseIsMap;
  hasRequired_baseIsMap = 1;
  var n = require_getTag(), t = requireIsObjectLike(), g = "[object Map]";
  function d(k) {
    return t(k) && n(k) == g;
  }
  return _baseIsMap = d, _baseIsMap;
}
var isMap_1, hasRequiredIsMap;
function requireIsMap() {
  if (hasRequiredIsMap) return isMap_1;
  hasRequiredIsMap = 1;
  var n = require_baseIsMap(), t = require_baseUnary(), g = require_nodeUtil(), d = g && g.isMap, k = d ? t(d) : n;
  return isMap_1 = k, isMap_1;
}
var _baseIsSet, hasRequired_baseIsSet;
function require_baseIsSet() {
  if (hasRequired_baseIsSet) return _baseIsSet;
  hasRequired_baseIsSet = 1;
  var n = require_getTag(), t = requireIsObjectLike(), g = "[object Set]";
  function d(k) {
    return t(k) && n(k) == g;
  }
  return _baseIsSet = d, _baseIsSet;
}
var isSet_1, hasRequiredIsSet;
function requireIsSet() {
  if (hasRequiredIsSet) return isSet_1;
  hasRequiredIsSet = 1;
  var n = require_baseIsSet(), t = require_baseUnary(), g = require_nodeUtil(), d = g && g.isSet, k = d ? t(d) : n;
  return isSet_1 = k, isSet_1;
}
var _baseClone, hasRequired_baseClone;
function require_baseClone() {
  if (hasRequired_baseClone) return _baseClone;
  hasRequired_baseClone = 1;
  var n = require_Stack(), t = require_arrayEach(), g = require_assignValue(), d = require_baseAssign(), k = require_baseAssignIn(), H = require_cloneBuffer(), AA = require_copyArray(), gA = require_copySymbols(), IA = require_copySymbolsIn(), CA = require_getAllKeys(), BA = require_getAllKeysIn(), eA = require_getTag(), iA = require_initCloneArray(), QA = require_initCloneByTag(), tA = require_initCloneObject(), oA = requireIsArray(), EA = requireIsBuffer(), aA = requireIsMap(), nA = requireIsObject(), lA = requireIsSet(), cA = requireKeys(), sA = requireKeysIn(), rA = 1, uA = 2, hA = 4, dA = "[object Arguments]", GA = "[object Array]", DA = "[object Boolean]", wA = "[object Date]", bA = "[object Error]", yA = "[object Function]", pA = "[object GeneratorFunction]", MA = "[object Map]", LA = "[object Number]", xA = "[object Object]", TA = "[object RegExp]", NA = "[object Set]", zA = "[object String]", XA = "[object Symbol]", fA = "[object WeakMap]", vA = "[object ArrayBuffer]", Cg = "[object DataView]", Ig = "[object Float32Array]", gg = "[object Float64Array]", og = "[object Int8Array]", eg = "[object Int16Array]", kA = "[object Int32Array]", YA = "[object Uint8Array]", RA = "[object Uint8ClampedArray]", FA = "[object Uint16Array]", mA = "[object Uint32Array]", JA = {};
  JA[dA] = JA[GA] = JA[vA] = JA[Cg] = JA[DA] = JA[wA] = JA[Ig] = JA[gg] = JA[og] = JA[eg] = JA[kA] = JA[MA] = JA[LA] = JA[xA] = JA[TA] = JA[NA] = JA[zA] = JA[XA] = JA[YA] = JA[RA] = JA[FA] = JA[mA] = !0, JA[bA] = JA[yA] = JA[fA] = !1;
  function VA(HA, jA, _A, $A, rg, wg) {
    var Dg, kg = jA & rA, ig = jA & uA, ZA = jA & hA;
    if (_A && (Dg = rg ? _A(HA, $A, rg, wg) : _A(HA)), Dg !== void 0)
      return Dg;
    if (!nA(HA))
      return HA;
    var KA = oA(HA);
    if (KA) {
      if (Dg = iA(HA), !kg)
        return AA(HA, Dg);
    } else {
      var PA = eA(HA), ag = PA == yA || PA == pA;
      if (EA(HA))
        return H(HA, kg);
      if (PA == xA || PA == dA || ag && !rg) {
        if (Dg = ig || ag ? {} : tA(HA), !kg)
          return ig ? IA(HA, k(Dg, HA)) : gA(HA, d(Dg, HA));
      } else {
        if (!JA[PA])
          return rg ? HA : {};
        Dg = QA(HA, PA, kg);
      }
    }
    wg || (wg = new n());
    var Gg = wg.get(HA);
    if (Gg)
      return Gg;
    wg.set(HA, Dg), lA(HA) ? HA.forEach(function(hg) {
      Dg.add(VA(hg, jA, _A, hg, HA, wg));
    }) : aA(HA) && HA.forEach(function(hg, tg) {
      Dg.set(tg, VA(hg, jA, _A, tg, HA, wg));
    });
    var bg = ZA ? ig ? BA : CA : ig ? sA : cA, yg = KA ? void 0 : bg(HA);
    return t(yg || HA, function(hg, tg) {
      yg && (tg = hg, hg = HA[tg]), g(Dg, tg, VA(hg, jA, _A, tg, HA, wg));
    }), Dg;
  }
  return _baseClone = VA, _baseClone;
}
var cloneDeep_1, hasRequiredCloneDeep;
function requireCloneDeep() {
  if (hasRequiredCloneDeep) return cloneDeep_1;
  hasRequiredCloneDeep = 1;
  var n = require_baseClone(), t = 1, g = 4;
  function d(k) {
    return n(k, t | g);
  }
  return cloneDeep_1 = d, cloneDeep_1;
}
var cloneDeepExports = requireCloneDeep();
const cloneDeep = /* @__PURE__ */ getDefaultExportFromCjs$2(cloneDeepExports);
var isObjectExports = requireIsObject();
const isObject$6 = /* @__PURE__ */ getDefaultExportFromCjs$2(isObjectExports);
var _assignMergeValue, hasRequired_assignMergeValue;
function require_assignMergeValue() {
  if (hasRequired_assignMergeValue) return _assignMergeValue;
  hasRequired_assignMergeValue = 1;
  var n = require_baseAssignValue(), t = requireEq$1();
  function g(d, k, H) {
    (H !== void 0 && !t(d[k], H) || H === void 0 && !(k in d)) && n(d, k, H);
  }
  return _assignMergeValue = g, _assignMergeValue;
}
var _createBaseFor, hasRequired_createBaseFor;
function require_createBaseFor() {
  if (hasRequired_createBaseFor) return _createBaseFor;
  hasRequired_createBaseFor = 1;
  function n(t) {
    return function(g, d, k) {
      for (var H = -1, AA = Object(g), gA = k(g), IA = gA.length; IA--; ) {
        var CA = gA[t ? IA : ++H];
        if (d(AA[CA], CA, AA) === !1)
          break;
      }
      return g;
    };
  }
  return _createBaseFor = n, _createBaseFor;
}
var _baseFor, hasRequired_baseFor;
function require_baseFor() {
  if (hasRequired_baseFor) return _baseFor;
  hasRequired_baseFor = 1;
  var n = require_createBaseFor(), t = n();
  return _baseFor = t, _baseFor;
}
var isPlainObject_1, hasRequiredIsPlainObject;
function requireIsPlainObject() {
  if (hasRequiredIsPlainObject) return isPlainObject_1;
  hasRequiredIsPlainObject = 1;
  var n = require_baseGetTag(), t = require_getPrototype(), g = requireIsObjectLike(), d = "[object Object]", k = Function.prototype, H = Object.prototype, AA = k.toString, gA = H.hasOwnProperty, IA = AA.call(Object);
  function CA(BA) {
    if (!g(BA) || n(BA) != d)
      return !1;
    var eA = t(BA);
    if (eA === null)
      return !0;
    var iA = gA.call(eA, "constructor") && eA.constructor;
    return typeof iA == "function" && iA instanceof iA && AA.call(iA) == IA;
  }
  return isPlainObject_1 = CA, isPlainObject_1;
}
var _safeGet, hasRequired_safeGet;
function require_safeGet() {
  if (hasRequired_safeGet) return _safeGet;
  hasRequired_safeGet = 1;
  function n(t, g) {
    if (!(g === "constructor" && typeof t[g] == "function") && g != "__proto__")
      return t[g];
  }
  return _safeGet = n, _safeGet;
}
var toPlainObject_1, hasRequiredToPlainObject;
function requireToPlainObject() {
  if (hasRequiredToPlainObject) return toPlainObject_1;
  hasRequiredToPlainObject = 1;
  var n = require_copyObject(), t = requireKeysIn();
  function g(d) {
    return n(d, t(d));
  }
  return toPlainObject_1 = g, toPlainObject_1;
}
var _baseMergeDeep, hasRequired_baseMergeDeep;
function require_baseMergeDeep() {
  if (hasRequired_baseMergeDeep) return _baseMergeDeep;
  hasRequired_baseMergeDeep = 1;
  var n = require_assignMergeValue(), t = require_cloneBuffer(), g = require_cloneTypedArray(), d = require_copyArray(), k = require_initCloneObject(), H = requireIsArguments(), AA = requireIsArray(), gA = requireIsArrayLikeObject(), IA = requireIsBuffer(), CA = requireIsFunction(), BA = requireIsObject(), eA = requireIsPlainObject(), iA = requireIsTypedArray(), QA = require_safeGet(), tA = requireToPlainObject();
  function oA(EA, aA, nA, lA, cA, sA, rA) {
    var uA = QA(EA, nA), hA = QA(aA, nA), dA = rA.get(hA);
    if (dA) {
      n(EA, nA, dA);
      return;
    }
    var GA = sA ? sA(uA, hA, nA + "", EA, aA, rA) : void 0, DA = GA === void 0;
    if (DA) {
      var wA = AA(hA), bA = !wA && IA(hA), yA = !wA && !bA && iA(hA);
      GA = hA, wA || bA || yA ? AA(uA) ? GA = uA : gA(uA) ? GA = d(uA) : bA ? (DA = !1, GA = t(hA, !0)) : yA ? (DA = !1, GA = g(hA, !0)) : GA = [] : eA(hA) || H(hA) ? (GA = uA, H(uA) ? GA = tA(uA) : (!BA(uA) || CA(uA)) && (GA = k(hA))) : DA = !1;
    }
    DA && (rA.set(hA, GA), cA(GA, hA, lA, sA, rA), rA.delete(hA)), n(EA, nA, GA);
  }
  return _baseMergeDeep = oA, _baseMergeDeep;
}
var _baseMerge, hasRequired_baseMerge;
function require_baseMerge() {
  if (hasRequired_baseMerge) return _baseMerge;
  hasRequired_baseMerge = 1;
  var n = require_Stack(), t = require_assignMergeValue(), g = require_baseFor(), d = require_baseMergeDeep(), k = requireIsObject(), H = requireKeysIn(), AA = require_safeGet();
  function gA(IA, CA, BA, eA, iA) {
    IA !== CA && g(CA, function(QA, tA) {
      if (iA || (iA = new n()), k(QA))
        d(IA, CA, tA, BA, gA, eA, iA);
      else {
        var oA = eA ? eA(AA(IA, tA), QA, tA + "", IA, CA, iA) : void 0;
        oA === void 0 && (oA = QA), t(IA, tA, oA);
      }
    }, H);
  }
  return _baseMerge = gA, _baseMerge;
}
var _createAssigner, hasRequired_createAssigner;
function require_createAssigner() {
  if (hasRequired_createAssigner) return _createAssigner;
  hasRequired_createAssigner = 1;
  var n = require_baseRest(), t = require_isIterateeCall();
  function g(d) {
    return n(function(k, H) {
      var AA = -1, gA = H.length, IA = gA > 1 ? H[gA - 1] : void 0, CA = gA > 2 ? H[2] : void 0;
      for (IA = d.length > 3 && typeof IA == "function" ? (gA--, IA) : void 0, CA && t(H[0], H[1], CA) && (IA = gA < 3 ? void 0 : IA, gA = 1), k = Object(k); ++AA < gA; ) {
        var BA = H[AA];
        BA && d(k, BA, AA, IA);
      }
      return k;
    });
  }
  return _createAssigner = g, _createAssigner;
}
var merge_1$1, hasRequiredMerge$1;
function requireMerge$1() {
  if (hasRequiredMerge$1) return merge_1$1;
  hasRequiredMerge$1 = 1;
  var n = require_baseMerge(), t = require_createAssigner(), g = t(function(d, k, H) {
    n(d, k, H);
  });
  return merge_1$1 = g, merge_1$1;
}
var mergeExports = requireMerge$1();
const merge$8 = /* @__PURE__ */ getDefaultExportFromCjs$2(mergeExports);
var toInteger_1, hasRequiredToInteger;
function requireToInteger() {
  if (hasRequiredToInteger) return toInteger_1;
  hasRequiredToInteger = 1;
  var n = requireToFinite();
  function t(g) {
    var d = n(g), k = d % 1;
    return d === d ? k ? d - k : d : 0;
  }
  return toInteger_1 = t, toInteger_1;
}
var before_1, hasRequiredBefore;
function requireBefore() {
  if (hasRequiredBefore) return before_1;
  hasRequiredBefore = 1;
  var n = requireToInteger(), t = "Expected a function";
  function g(d, k) {
    var H;
    if (typeof k != "function")
      throw new TypeError(t);
    return d = n(d), function() {
      return --d > 0 && (H = k.apply(this, arguments)), d <= 1 && (k = void 0), H;
    };
  }
  return before_1 = g, before_1;
}
var once_1, hasRequiredOnce;
function requireOnce() {
  if (hasRequiredOnce) return once_1;
  hasRequiredOnce = 1;
  var n = requireBefore();
  function t(g) {
    return n(2, g);
  }
  return once_1 = t, once_1;
}
var onceExports = requireOnce();
const once = /* @__PURE__ */ getDefaultExportFromCjs$2(onceExports), CACHED_THEME_VERSION = 1, CACHED_THEME_BASE_KEY = `stActiveTheme-${window.location.pathname}`, LocalStore = {
  CACHED_THEME_VERSION,
  CACHED_THEME_BASE_KEY,
  ACTIVE_THEME: `${CACHED_THEME_BASE_KEY}-v${CACHED_THEME_VERSION}`
}, AUTO_THEME_NAME = "Use system setting", CUSTOM_THEME_NAME = "Custom Theme", LOG$e = loglevelExports$1.getLogger("theme:utils");
function mergeTheme(n, t) {
  if (t && isObject$6(t)) {
    const g = new CustomThemeConfig(t);
    return createTheme(n.name, g, n);
  }
  return n;
}
const getMergedLightTheme = once(() => mergeTheme(lightTheme, window.__streamlit?.LIGHT_THEME)), getMergedDarkTheme = once(() => mergeTheme(darkTheme$1, window.__streamlit?.DARK_THEME)), getSystemTheme = () => window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? getMergedDarkTheme() : getMergedLightTheme(), createAutoTheme = () => ({
  ...getSystemTheme(),
  name: AUTO_THEME_NAME
}), createPresetThemes = () => [createAutoTheme(), getMergedLightTheme(), getMergedDarkTheme()], isPresetTheme = (n) => createPresetThemes().map((g) => g.name).includes(n.name), bgColorToBaseString = (n) => n === void 0 || getLuminance(n) > 0.5 ? "light" : "dark", isColor = (n) => {
  const t = new Option().style;
  return t.color = n, t.color !== "";
}, roundFontSizeToNearestEighth = (n) => Math.round(n * 8) / 8, parseFont = (n) => {
  const t = {
    "sans-serif": fonts.sansSerif,
    serif: fonts.serif,
    monospace: fonts.monospace
  }, g = n.toLowerCase().replaceAll(" ", "-");
  return g in t ? t[g] : n;
}, parseColor = (n, t, g = !1) => {
  if (isColor(n))
    return n;
  if (isColor(`#${n}`))
    return `#${n}`;
  if (t.toLowerCase().includes("color")) {
    const k = g ? "theme.sidebar" : "theme";
    LOG$e.warn(`Invalid color passed for ${t} in ${k}: "${n}"`);
  }
}, resolveBgColor = (n, t, g, d) => n || (t ? transparentize(t, d ? 0.9 : 0.8) : g), resolveTextColor = (n, t, g, d) => n || (t ? d ? darken(t, 0.15) : lighten(t, 0.15) : g), setBackgroundColors = (n, t) => {
  const g = {
    ...n
  }, d = {
    redBackgroundColor: {
      main: t.redColor,
      background: t.redBackgroundColor
    },
    orangeBackgroundColor: {
      main: t.orangeColor,
      background: t.orangeBackgroundColor
    },
    yellowBackgroundColor: {
      main: t.yellowColor,
      background: t.yellowBackgroundColor
    },
    blueBackgroundColor: {
      main: t.blueColor,
      background: t.blueBackgroundColor
    },
    greenBackgroundColor: {
      main: t.greenColor,
      background: t.greenBackgroundColor
    },
    violetBackgroundColor: {
      main: t.violetColor,
      background: t.violetBackgroundColor
    },
    grayBackgroundColor: {
      main: t.grayColor,
      background: t.grayBackgroundColor
    }
  }, k = getLuminance(g.bgColor) > 0.5;
  return Object.entries(d).forEach(([H, {
    main: AA,
    background: gA
  }]) => {
    const IA = H;
    g[IA] = resolveBgColor(gA, AA, n[IA], k);
  }), g;
}, setTextColors = (n, t) => {
  const g = {
    ...n
  }, d = {
    redTextColor: {
      main: t.redColor,
      text: t.redTextColor
    },
    orangeTextColor: {
      main: t.orangeColor,
      text: t.orangeTextColor
    },
    yellowTextColor: {
      main: t.yellowColor,
      text: t.yellowTextColor
    },
    blueTextColor: {
      main: t.blueColor,
      text: t.blueTextColor
    },
    greenTextColor: {
      main: t.greenColor,
      text: t.greenTextColor
    },
    violetTextColor: {
      main: t.violetColor,
      text: t.violetTextColor
    },
    grayTextColor: {
      main: t.grayColor,
      text: t.grayTextColor
    }
  }, k = getLuminance(g.bgColor) > 0.5;
  return Object.entries(d).forEach(([H, {
    main: AA,
    text: gA
  }]) => {
    const IA = H;
    g[IA] = resolveTextColor(gA, AA, n[IA], k);
  }), g;
}, parseRadius = (n) => {
  let t = "rem", g;
  const d = n.trim().toLowerCase();
  return d === "none" ? g = 0 : d === "small" ? g = 0.35 : d === "medium" ? g = 0.5 : d === "large" ? g = 1 : d === "full" ? g = 1.4 : d.endsWith("rem") ? g = parseFloat(d) : d.endsWith("px") ? (g = parseFloat(d), t = "px") : isNaN(parseFloat(d)) || (g = parseFloat(d), t = "px"), [g, t];
}, parseFontSize = (n, t, g) => {
  const d = g ? "theme.sidebar" : "theme";
  if (typeof t == "string") {
    const k = t.trim().toLowerCase(), H = parseFloat(k);
    if (H && (k.endsWith("rem") || k.endsWith("px")))
      return k;
    if (H.toString() === k)
      return `${k}px`;
  }
  LOG$e.warn(`Invalid size passed for ${n} in ${d}: ${t}. Falling back to default ${n}.`);
}, isValidFontWeight = (n, t, g, d, k) => {
  const H = k ? "theme.sidebar" : "theme";
  if (notNullOrUndefined(t)) {
    const AA = Number.isInteger(t), gA = t % 100 === 0, IA = t >= g && t <= d;
    return !AA || !gA || !IA ? (LOG$e.warn(`Invalid ${n}: ${t} in ${H}. The ${n} must be an integer ${g}-${d}, and an increment of 100. Falling back to default font weight.`), !1) : !0;
  }
  return !1;
}, convertHeadingFontSizeToRem = (n, t, g, d) => {
  const k = parseFontSize(n, t, d);
  if (k?.endsWith("rem"))
    return k;
  if (k?.endsWith("px"))
    return `${parseFloat(k) / g}rem`;
}, setHeadingFontSizes = (n, t, g, d) => {
  const k = {
    ...n
  };
  return d && d.forEach((H, AA) => {
    const gA = `h${AA + 1}FontSize`, IA = convertHeadingFontSizeToRem(`${gA} in headingFontSizes`, H, g, t);
    IA && (k[gA] = IA);
  }), k;
}, setFontWeights = (n, t, g, d, k) => {
  const H = {
    ...n,
    // Override default h1FontWeight for sidebar to 600
    // Default for main theme set in typography (700)
    h1FontWeight: t ? 600 : n.h1FontWeight
  };
  return g && isValidFontWeight("baseFontWeight", g, 100, 600) && (H.normal = g, H.semiBold = g + 100, H.bold = g + 200, H.extrabold = g + 300, H.code = g, H.codeBold = g + 200, H.codeExtraBold = g + 300), d && isValidFontWeight("codeFontWeight", d, 100, 600) && (H.code = d, H.codeBold = d + 200, H.codeExtraBold = d + 300), k && k.forEach((AA, gA) => {
    const IA = `h${gA + 1}FontWeight`;
    isValidFontWeight(`${IA} in headingFontWeights`, AA, 100, 900, t) && (H[IA] = AA);
  }), H;
}, validateChartColors = (n, t) => t.map((g) => parseColor(g, n)).filter((g) => g !== void 0), createEmotionTheme = (n, t = baseTheme) => {
  const {
    colors: g,
    genericFonts: d,
    inSidebar: k
  } = t.emotion, {
    baseFontSize: H,
    baseFontWeight: AA,
    baseRadius: gA,
    buttonRadius: IA,
    codeFontSize: CA,
    codeFontWeight: BA,
    showWidgetBorder: eA,
    headingFont: iA,
    headingFontSizes: QA,
    headingFontWeights: tA,
    bodyFont: oA,
    codeFont: EA,
    showSidebarBorder: aA,
    linkUnderline: nA,
    // Since chart color configs passed as array, handle separate from parsedColors
    chartCategoricalColors: lA,
    chartSequentialColors: cA,
    ...sA
  } = n, rA = Object.entries(sA).reduce((gg, [og, eg]) => {
    const kA = parseColor(eg, og, k);
    return kA && (gg[og] = kA), gg;
  }, {}), {
    secondaryBackgroundColor: uA,
    backgroundColor: hA,
    primaryColor: dA,
    textColor: GA,
    dataframeBorderColor: DA,
    dataframeHeaderBackgroundColor: wA,
    widgetBorderColor: bA,
    borderColor: yA,
    linkColor: pA,
    codeBackgroundColor: MA,
    redColor: LA,
    orangeColor: xA,
    yellowColor: TA,
    blueColor: NA,
    greenColor: zA,
    violetColor: XA,
    grayColor: fA
  } = rA, vA = {
    ...g,
    primary: dA ?? g.primary,
    bodyText: GA ?? g.bodyText,
    secondaryBg: uA ?? g.secondaryBg,
    bgColor: hA ?? g.bgColor,
    // Main theme colors
    redColor: LA ?? g.redColor,
    orangeColor: xA ?? g.orangeColor,
    yellowColor: TA ?? g.yellowColor,
    blueColor: NA ?? g.blueColor,
    greenColor: zA ?? g.greenColor,
    violetColor: XA ?? g.violetColor,
    grayColor: fA ?? g.grayColor,
    // Secondary color is not yet configurable. Set secondary color to primary color
    // by default for all custom themes.
    secondary: dA ?? g.primary
  }, Cg = {
    colors: {
      ...createEmotionColors(vA)
    },
    showSidebarBorder: aA ?? t.emotion.showSidebarBorder,
    linkUnderline: nA ?? t.emotion.linkUnderline,
    // Copy over the default values for the other configurable theme properties
    radii: {
      ...t.emotion.radii
    },
    fontSizes: {
      ...t.emotion.fontSizes
    },
    fontWeights: {
      ...t.emotion.fontWeights
    }
  };
  if (Cg.colors.link = pA ?? g.link, Cg.colors.codeBackgroundColor = MA ?? g.codeBackgroundColor, Cg.colors.dataframeHeaderBackgroundColor = wA ?? g.dataframeHeaderBackgroundColor, notNullOrUndefined(yA)) {
    Cg.colors.borderColor = yA;
    const gg = transparentize(yA, 0.55);
    Cg.colors.borderColorLight = gg, Cg.colors.dataframeBorderColor = gg;
  }
  if (notNullOrUndefined(DA) && (Cg.colors.dataframeBorderColor = DA), (eA || bA) && (Cg.colors.widgetBorderColor = bA || Cg.colors.borderColor), Cg.colors = setBackgroundColors(Cg.colors, rA), Cg.colors = setTextColors(Cg.colors, rA), notNullOrUndefined(lA) && lA.length > 0) {
    const gg = validateChartColors("chartCategoricalColors", lA);
    gg.length > 0 && (Cg.colors.chartCategoricalColors = gg);
  }
  if (notNullOrUndefined(cA) && cA.length > 0) {
    const gg = validateChartColors("chartSequentialColors", cA);
    gg.length === 10 ? Cg.colors.chartSequentialColors = gg : LOG$e.warn(`Invalid chartSequentialColors: ${cA.toString()}. Falling back to default chartSequentialColors.`);
  }
  if (notNullOrUndefined(gA)) {
    const [gg, og] = parseRadius(gA);
    if (notNullOrUndefined(gg) && !isNaN(gg)) {
      const eg = addCssUnit(gg, og);
      Cg.radii.default = eg, Cg.radii.button = eg, Cg.radii.md = addCssUnit(roundToTwoDecimals(gg * 0.5), og), Cg.radii.xl = addCssUnit(roundToTwoDecimals(gg * 1.5), og), Cg.radii.xxl = addCssUnit(roundToTwoDecimals(gg * 2), og);
    } else
      LOG$e.warn(`Invalid base radius: ${gA}. Falling back to default base radius.`);
  }
  if (notNullOrUndefined(IA)) {
    const [gg, og] = parseRadius(IA);
    notNullOrUndefined(gg) && !isNaN(gg) ? Cg.radii.button = addCssUnit(gg, og) : LOG$e.warn(`Invalid button radius: ${IA}. Falling back to default button radius.`);
  }
  if (H && H > 0 && (Cg.fontSizes.baseFontSize = H), CA) {
    const gg = parseFontSize("codeFontSize", CA, k);
    gg && (Cg.fontSizes.codeFontSize = gg);
  }
  Cg.fontSizes = setHeadingFontSizes(Cg.fontSizes, k, Cg.fontSizes.baseFontSize, QA), Cg.fontWeights = setFontWeights(t.emotion.fontWeights, k, AA, BA, tA);
  const Ig = {
    // Default values for the generic fonts
    ...d,
    // Override properties if configured
    bodyFont: oA ? parseFont(oA) : d.bodyFont,
    codeFont: EA ? parseFont(EA) : d.codeFont,
    headingFont: iA ? parseFont(iA) : d.headingFont
  };
  return oA && !iA && (Ig.headingFont = parseFont(oA)), {
    ...t.emotion,
    genericFonts: Ig,
    ...Cg
  };
}, toThemeInput = (n) => {
  const {
    colors: t
  } = n;
  return {
    primaryColor: t.primary,
    backgroundColor: t.bgColor,
    secondaryBackgroundColor: t.secondaryBg,
    textColor: t.bodyText,
    bodyFont: n.genericFonts.bodyFont
  };
}, toExportedTheme = (n) => {
  const {
    colors: t
  } = n, g = toThemeInput(n);
  return {
    primaryColor: g.primaryColor,
    backgroundColor: g.backgroundColor,
    secondaryBackgroundColor: g.secondaryBackgroundColor,
    textColor: g.textColor,
    bodyFont: g.bodyFont,
    base: bgColorToBaseString(g.backgroundColor),
    ...computeDerivedColors(t)
  };
}, completeThemeInput = (n, t) => new CustomThemeConfig({
  ...toThemeInput(t.emotion),
  ...n
}), createTheme = (n, t, g, d = !1) => {
  let k;
  g ? k = completeThemeInput(t, g) : t.base === CustomThemeConfig.BaseTheme.DARK ? k = completeThemeInput(t, darkTheme$1) : k = completeThemeInput(t, lightTheme);
  const H = k.backgroundColor, AA = merge$8(cloneDeep(g || (getLuminance(H) > 0.5 ? lightTheme : darkTheme$1)), {
    emotion: {
      inSidebar: d
    }
  }), gA = createEmotionTheme(k, AA), IA = cloneDeep(createBaseUiTheme(gA, AA.primitives));
  return {
    ...AA,
    name: n,
    emotion: gA,
    basewebTheme: IA,
    themeInput: t
  };
}, getCachedTheme = () => {
  if (!localStorageAvailable())
    return null;
  const n = window.localStorage.getItem(LocalStore.ACTIVE_THEME);
  if (!n)
    return null;
  const {
    name: t,
    themeInput: g
  } = JSON.parse(n);
  switch (t) {
    case lightTheme.name:
      return getMergedLightTheme();
    case darkTheme$1.name:
      return getMergedDarkTheme();
    default:
      return createTheme(t, g);
  }
}, deleteOldCachedThemes = () => {
  const {
    CACHED_THEME_VERSION: n,
    CACHED_THEME_BASE_KEY: t
  } = LocalStore, {
    localStorage: g
  } = window;
  g.removeItem("stActiveTheme"), g.removeItem(t);
  for (let d = 1; d <= n; d++)
    g.removeItem(`${t}-v${d}`);
}, setCachedTheme = (n) => {
  if (!localStorageAvailable() || (deleteOldCachedThemes(), isLightThemeInQueryParams() || isDarkThemeInQueryParams()))
    return;
  const t = {
    name: n.name,
    ...!isPresetTheme(n) && {
      themeInput: toThemeInput(n.emotion)
    }
  };
  window.localStorage.setItem(LocalStore.ACTIVE_THEME, JSON.stringify(t));
}, removeCachedTheme = () => {
  localStorageAvailable() && window.localStorage.removeItem(LocalStore.ACTIVE_THEME);
}, getHostSpecifiedTheme = () => isLightThemeInQueryParams() ? getMergedLightTheme() : isDarkThemeInQueryParams() ? getMergedDarkTheme() : createAutoTheme(), getDefaultTheme = () => {
  const n = getCachedTheme();
  return n && n.name !== AUTO_THEME_NAME ? n : getHostSpecifiedTheme();
}, whiteSpace = /\s+/;
function computeSpacingStyle(n, t) {
  return n === "" ? "" : n.split(whiteSpace).map((g) => g === "0" ? t.spacing.none : g in t.spacing ? t.spacing[g] : (LOG$e.error(`Invalid spacing value: ${g}`), t.spacing.none)).join(" ");
}
function addCssUnit(n, t) {
  return `${n}${t}`;
}
function roundToTwoDecimals(n) {
  return parseFloat(n.toFixed(2));
}
function blend$1(n, t) {
  if (t === void 0) return n;
  const [g, d, k, H] = parseToRgba(n);
  if (H === 1) return n;
  const [AA, gA, IA, CA] = parseToRgba(t), BA = H + CA * (1 - H), eA = Math.round((H * g + CA * AA * (1 - H)) / BA), iA = Math.round((H * d + CA * gA * (1 - H)) / BA), QA = Math.round((H * k + CA * IA * (1 - H)) / BA);
  return toHex(`rgba(${eA}, ${iA}, ${QA}, ${BA})`);
}
const convertRemToPx = (n) => (
  // TODO(lukasmasuch): We might want to somehow cache this value at some point.
  // However, I did experimented with the performance of calling this, and
  // it seems not like a big deal to call it many times.
  parseFloat(n.replace(/rem$/, "")) * // We fallback to 16px if the fontSize is not defined (should only happen in tests)
  (parseFloat(getComputedStyle(document.documentElement).fontSize) || 16)
), STALE_TRANSITION_PARAMS = "1s ease-in 0.5s", STALE_STYLES = {
  opacity: 0.33,
  transition: `opacity ${STALE_TRANSITION_PARAMS}`
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$f() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledSpinnerIcon = /* @__PURE__ */ createStyled$1(StyledSpinner, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: (n) => isPropValid(n) && !["size"].includes(n),
  target: "eyeqlp54"
} : {
  shouldForwardProp: (n) => isPropValid(n) && !["size"].includes(n),
  target: "eyeqlp54",
  label: "StyledSpinnerIcon"
})(({
  size: n,
  margin: t,
  padding: g,
  theme: d
}) => ({
  width: d.iconSizes[n],
  height: d.iconSizes[n],
  fontSize: d.iconSizes[n],
  justifyContents: "center",
  margin: computeSpacingStyle(t, d),
  padding: computeSpacingStyle(g, d),
  borderColor: d.colors.fadedText10,
  borderTopColor: d.colors.bodyText,
  borderWidth: d.sizes.spinnerThickness,
  flexGrow: 0,
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIcon = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  shouldForwardProp: (n) => isPropValid(n) && !["size", "as"].includes(n),
  target: "eyeqlp53"
} : {
  shouldForwardProp: (n) => isPropValid(n) && !["size", "as"].includes(n),
  target: "eyeqlp53",
  label: "StyledIcon"
})(({
  color: n,
  size: t,
  margin: g,
  padding: d,
  theme: k
}) => ({
  color: n || "inherit",
  fill: "currentColor",
  display: "inline-flex",
  alignItems: "center",
  justifyContents: "center",
  fontSize: k.iconSizes[t],
  width: k.iconSizes[t],
  height: k.iconSizes[t],
  margin: computeSpacingStyle(g, k),
  padding: computeSpacingStyle(d, k),
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDynamicIcon = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "eyeqlp52"
} : {
  target: "eyeqlp52",
  label: "StyledDynamicIcon"
})(({
  size: n = "lg",
  margin: t = "",
  padding: g = "",
  theme: d
}) => ({
  fill: "currentColor",
  display: "inline-flex",
  alignItems: "center",
  justifyContents: "center",
  fontSize: d.iconSizes[n],
  width: d.iconSizes[n],
  height: d.iconSizes[n],
  margin: computeSpacingStyle(t, d),
  padding: computeSpacingStyle(g, d),
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledImageIcon = /* @__PURE__ */ createStyled$1("img", process.env.NODE_ENV === "production" ? {
  target: "eyeqlp51"
} : {
  target: "eyeqlp51",
  label: "StyledImageIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "w1atjl",
  styles: "width:100%;height:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
}), StyledEmojiIcon = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "eyeqlp50"
} : {
  target: "eyeqlp50",
  label: "StyledEmojiIcon"
})(({
  size: n,
  margin: t,
  padding: g,
  theme: d,
  color: k
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContents: "center",
  fontSize: d.iconSizes[n],
  width: d.iconSizes[n],
  height: d.iconSizes[n],
  margin: computeSpacingStyle(t, d),
  padding: computeSpacingStyle(g, d),
  color: k
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getDefaultProps$1 = ({
  size: n,
  margin: t,
  padding: g,
  color: d
}) => ({
  size: n || "md",
  margin: t || "",
  padding: g || "",
  color: d || void 0
}), Icon = ({
  content: n,
  color: t,
  size: g,
  margin: d,
  padding: k,
  testid: H
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIcon, { as: n, "aria-hidden": "true", "data-testid": H, ...getDefaultProps$1({
  size: g,
  margin: d,
  padding: k,
  color: t
}) }), EmojiIcon = ({
  size: n,
  margin: t,
  padding: g,
  children: d,
  color: k,
  testid: H
}) => (typeof d == "string" && (d = d.replace(/^emoji:/, "")), /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEmojiIcon, { "data-testid": H || "stIconEmoji", "aria-hidden": "true", ...getDefaultProps$1({
  size: n,
  margin: t,
  padding: g,
  color: k
}), children: d })), StyledMaterialIcon = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "e16edly10"
} : {
  target: "e16edly10",
  label: "StyledMaterialIcon"
})(({
  size: n,
  margin: t,
  padding: g,
  theme: d,
  color: k
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContents: "center",
  color: k,
  fontSize: d.iconSizes[n],
  width: d.iconSizes[n],
  height: d.iconSizes[n],
  margin: computeSpacingStyle(t, d),
  padding: computeSpacingStyle(g, d),
  userSelect: "none",
  fontFamily: d.genericFonts.iconFont,
  fontWeight: d.fontWeights.normal,
  fontStyle: "normal",
  lineHeight: d.lineHeights.none,
  letterSpacing: "normal",
  textTransform: "none",
  whiteSpace: "nowrap",
  wordWrap: "normal",
  direction: "ltr",
  fontFeatureSettings: "liga",
  MozFontFeatureSettings: "liga",
  WebkitFontFeatureSettings: "liga",
  WebkitFontSmoothing: "antialiased"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getDefaultProps = ({
  size: n,
  margin: t,
  padding: g,
  color: d
}) => ({
  size: n || "md",
  margin: t || "",
  padding: g || "",
  color: d || "inherit"
}), MaterialFontIcon = ({
  iconName: n,
  ...t
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  StyledMaterialIcon,
  {
    ...getDefaultProps(t),
    "data-testid": t.testid || "stIconMaterial",
    translate: "no",
    children: n
  }
);
function parseIconPackEntry(n) {
  const t = n.match(/^:(.+)\/(.+):$/);
  if (t === null)
    return {
      pack: "emoji",
      icon: n
    };
  const g = t[1], d = t[2];
  return {
    pack: g,
    icon: d
  };
}
function isMaterialIcon(n) {
  const t = parseIconPackEntry(n);
  return t.pack === "material" && t.icon !== "";
}
function getFilledStarIconSrc() {
  return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTg2MF84NDMpIj48cGF0aCBkPSJNOS45OTk5NCAxNC4zOTE2TDEzLjQ1ODMgMTYuNDgzM0MxNC4wOTE2IDE2Ljg2NjYgMTQuODY2NiAxNi4zIDE0LjY5OTkgMTUuNTgzM0wxMy43ODMzIDExLjY1TDE2Ljg0MTYgOC45OTk5N0MxNy4zOTk5IDguNTE2NjMgMTcuMDk5OSA3LjU5OTk3IDE2LjM2NjYgNy41NDE2M0wxMi4zNDE2IDcuMTk5OTdMMTAuNzY2NiAzLjQ4MzNDMTAuNDgzMyAyLjgwODMgOS41MTY2MSAyLjgwODMgOS4yMzMyNyAzLjQ4MzNMNy42NTgyNyA3LjE5MTYzTDMuNjMzMjcgNy41MzMzQzIuODk5OTQgNy41OTE2MyAyLjU5OTk0IDguNTA4MyAzLjE1ODI3IDguOTkxNjNMNi4yMTY2MSAxMS42NDE2TDUuMjk5OTQgMTUuNTc1QzUuMTMzMjcgMTYuMjkxNiA1LjkwODI3IDE2Ljg1ODMgNi41NDE2MSAxNi40NzVMOS45OTk5NCAxNC4zOTE2WiIgZmlsbD0iI0ZBQ0EyQiIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImNsaXAwXzE4NjBfODQzIj48cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IndoaXRlIi8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+";
}
const DynamicIconDispatcher = ({
  iconValue: n,
  ...t
}) => {
  const {
    pack: g,
    icon: d
  } = parseIconPackEntry(n);
  switch (g) {
    case "material":
      switch (d) {
        case "star_filled":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...t, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledImageIcon, { src: getFilledStarIconSrc(), "data-testid": t.testid || "stImageIcon" }) });
        default:
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...t, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MaterialFontIcon, { pack: g, iconName: d, ...t }) });
      }
    case "emoji":
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...t, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmojiIcon, { ...t, children: d }) });
  }
}, DynamicIcon = (n) => /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...n, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmojiIcon, { ...n, children: " " }) }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIconDispatcher, { ...n }) }, n.iconValue);
function escapeStringRegexp$1(n) {
  if (typeof n != "string")
    throw new TypeError("Expected a string");
  return n.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const replacements = [
  // German umlauts
  ["ß", "ss"],
  ["ẞ", "Ss"],
  ["ä", "ae"],
  ["Ä", "Ae"],
  ["ö", "oe"],
  ["Ö", "Oe"],
  ["ü", "ue"],
  ["Ü", "Ue"],
  // Latin
  ["À", "A"],
  ["Á", "A"],
  ["Â", "A"],
  ["Ã", "A"],
  ["Ä", "Ae"],
  ["Å", "A"],
  ["Æ", "AE"],
  ["Ç", "C"],
  ["È", "E"],
  ["É", "E"],
  ["Ê", "E"],
  ["Ë", "E"],
  ["Ə", "A"],
  // Azerbaijani schwa
  ["Ì", "I"],
  ["Í", "I"],
  ["Î", "I"],
  ["Ï", "I"],
  ["Ð", "D"],
  ["Ñ", "N"],
  ["Ò", "O"],
  ["Ó", "O"],
  ["Ô", "O"],
  ["Õ", "O"],
  ["Ö", "Oe"],
  ["Ō", "O"],
  ["Ő", "O"],
  ["Ø", "O"],
  ["Œ", "OE"],
  // French ligature
  ["Ù", "U"],
  ["Ú", "U"],
  ["Û", "U"],
  ["Ü", "Ue"],
  ["Ű", "U"],
  ["Ý", "Y"],
  ["Þ", "TH"],
  ["ß", "ss"],
  ["à", "a"],
  ["á", "a"],
  ["â", "a"],
  ["ã", "a"],
  ["ä", "ae"],
  ["å", "a"],
  ["æ", "ae"],
  ["ç", "c"],
  ["è", "e"],
  ["é", "e"],
  ["ê", "e"],
  ["ë", "e"],
  ["ə", "a"],
  // Azerbaijani schwa
  ["ì", "i"],
  ["í", "i"],
  ["î", "i"],
  ["ï", "i"],
  ["ð", "d"],
  ["ñ", "n"],
  ["ò", "o"],
  ["ó", "o"],
  ["ô", "o"],
  ["õ", "o"],
  ["ö", "oe"],
  ["ō", "o"],
  ["ő", "o"],
  ["ø", "o"],
  ["œ", "oe"],
  // French ligature
  ["ù", "u"],
  ["ú", "u"],
  ["û", "u"],
  ["ü", "ue"],
  ["ű", "u"],
  ["ý", "y"],
  ["þ", "th"],
  ["ÿ", "y"],
  // Vietnamese
  ["à", "a"],
  ["À", "A"],
  ["á", "a"],
  ["Á", "A"],
  ["â", "a"],
  ["Â", "A"],
  ["ã", "a"],
  ["Ã", "A"],
  ["è", "e"],
  ["È", "E"],
  ["é", "e"],
  ["É", "E"],
  ["ê", "e"],
  ["Ê", "E"],
  ["ì", "i"],
  ["Ì", "I"],
  ["í", "i"],
  ["Í", "I"],
  ["ò", "o"],
  ["Ò", "O"],
  ["ó", "o"],
  ["Ó", "O"],
  ["ô", "o"],
  ["Ô", "O"],
  ["õ", "o"],
  ["Õ", "O"],
  ["ù", "u"],
  ["Ù", "U"],
  ["ú", "u"],
  ["Ú", "U"],
  ["ý", "y"],
  ["Ý", "Y"],
  ["ă", "a"],
  ["Ă", "A"],
  ["Đ", "D"],
  ["đ", "d"],
  ["ĩ", "i"],
  ["Ĩ", "I"],
  ["ũ", "u"],
  ["Ũ", "U"],
  ["ơ", "o"],
  ["Ơ", "O"],
  ["ư", "u"],
  ["Ư", "U"],
  ["ạ", "a"],
  ["Ạ", "A"],
  ["ả", "a"],
  ["Ả", "A"],
  ["ấ", "a"],
  ["Ấ", "A"],
  ["ầ", "a"],
  ["Ầ", "A"],
  ["ẩ", "a"],
  ["Ẩ", "A"],
  ["ẫ", "a"],
  ["Ẫ", "A"],
  ["ậ", "a"],
  ["Ậ", "A"],
  ["ắ", "a"],
  ["Ắ", "A"],
  ["ằ", "a"],
  ["Ằ", "A"],
  ["ẳ", "a"],
  ["Ẳ", "A"],
  ["ẵ", "a"],
  ["Ẵ", "A"],
  ["ặ", "a"],
  ["Ặ", "A"],
  ["ẹ", "e"],
  ["Ẹ", "E"],
  ["ẻ", "e"],
  ["Ẻ", "E"],
  ["ẽ", "e"],
  ["Ẽ", "E"],
  ["ế", "e"],
  ["Ế", "E"],
  ["ề", "e"],
  ["Ề", "E"],
  ["ể", "e"],
  ["Ể", "E"],
  ["ễ", "e"],
  ["Ễ", "E"],
  ["ệ", "e"],
  ["Ệ", "E"],
  ["ỉ", "i"],
  ["Ỉ", "I"],
  ["ị", "i"],
  ["Ị", "I"],
  ["ọ", "o"],
  ["Ọ", "O"],
  ["ỏ", "o"],
  ["Ỏ", "O"],
  ["ố", "o"],
  ["Ố", "O"],
  ["ồ", "o"],
  ["Ồ", "O"],
  ["ổ", "o"],
  ["Ổ", "O"],
  ["ỗ", "o"],
  ["Ỗ", "O"],
  ["ộ", "o"],
  ["Ộ", "O"],
  ["ớ", "o"],
  ["Ớ", "O"],
  ["ờ", "o"],
  ["Ờ", "O"],
  ["ở", "o"],
  ["Ở", "O"],
  ["ỡ", "o"],
  ["Ỡ", "O"],
  ["ợ", "o"],
  ["Ợ", "O"],
  ["ụ", "u"],
  ["Ụ", "U"],
  ["ủ", "u"],
  ["Ủ", "U"],
  ["ứ", "u"],
  ["Ứ", "U"],
  ["ừ", "u"],
  ["Ừ", "U"],
  ["ử", "u"],
  ["Ử", "U"],
  ["ữ", "u"],
  ["Ữ", "U"],
  ["ự", "u"],
  ["Ự", "U"],
  ["ỳ", "y"],
  ["Ỳ", "Y"],
  ["ỵ", "y"],
  ["Ỵ", "Y"],
  ["ỷ", "y"],
  ["Ỷ", "Y"],
  ["ỹ", "y"],
  ["Ỹ", "Y"],
  // Arabic
  ["ء", "e"],
  ["آ", "a"],
  ["أ", "a"],
  ["ؤ", "w"],
  ["إ", "a"],
  ["ئ", "y"],
  ["ا", "a"],
  ["ب", "b"],
  ["ة", "t"],
  ["ت", "t"],
  ["ث", "th"],
  ["ج", "j"],
  ["ح", "h"],
  ["خ", "kh"],
  ["د", "d"],
  ["ذ", "dh"],
  ["ر", "r"],
  ["ز", "z"],
  ["س", "s"],
  ["ش", "sh"],
  ["ص", "s"],
  ["ض", "d"],
  ["ط", "t"],
  ["ظ", "z"],
  ["ع", "e"],
  ["غ", "gh"],
  ["ـ", "_"],
  ["ف", "f"],
  ["ق", "q"],
  ["ك", "k"],
  ["ل", "l"],
  ["م", "m"],
  ["ن", "n"],
  ["ه", "h"],
  ["و", "w"],
  ["ى", "a"],
  ["ي", "y"],
  ["َ‎", "a"],
  ["ُ", "u"],
  ["ِ‎", "i"],
  ["٠", "0"],
  ["١", "1"],
  ["٢", "2"],
  ["٣", "3"],
  ["٤", "4"],
  ["٥", "5"],
  ["٦", "6"],
  ["٧", "7"],
  ["٨", "8"],
  ["٩", "9"],
  // Persian / Farsi
  ["چ", "ch"],
  ["ک", "k"],
  ["گ", "g"],
  ["پ", "p"],
  ["ژ", "zh"],
  ["ی", "y"],
  ["۰", "0"],
  ["۱", "1"],
  ["۲", "2"],
  ["۳", "3"],
  ["۴", "4"],
  ["۵", "5"],
  ["۶", "6"],
  ["۷", "7"],
  ["۸", "8"],
  ["۹", "9"],
  // Pashto
  ["ټ", "p"],
  ["ځ", "z"],
  ["څ", "c"],
  ["ډ", "d"],
  ["ﺫ", "d"],
  ["ﺭ", "r"],
  ["ړ", "r"],
  ["ﺯ", "z"],
  ["ږ", "g"],
  ["ښ", "x"],
  ["ګ", "g"],
  ["ڼ", "n"],
  ["ۀ", "e"],
  ["ې", "e"],
  ["ۍ", "ai"],
  // Urdu
  ["ٹ", "t"],
  ["ڈ", "d"],
  ["ڑ", "r"],
  ["ں", "n"],
  ["ہ", "h"],
  ["ھ", "h"],
  ["ے", "e"],
  // Russian
  ["А", "A"],
  ["а", "a"],
  ["Б", "B"],
  ["б", "b"],
  ["В", "V"],
  ["в", "v"],
  ["Г", "G"],
  ["г", "g"],
  ["Д", "D"],
  ["д", "d"],
  ["ъе", "ye"],
  ["Ъе", "Ye"],
  ["ъЕ", "yE"],
  ["ЪЕ", "YE"],
  ["Е", "E"],
  ["е", "e"],
  ["Ё", "Yo"],
  ["ё", "yo"],
  ["Ж", "Zh"],
  ["ж", "zh"],
  ["З", "Z"],
  ["з", "z"],
  ["И", "I"],
  ["и", "i"],
  ["ый", "iy"],
  ["Ый", "Iy"],
  ["ЫЙ", "IY"],
  ["ыЙ", "iY"],
  ["Й", "Y"],
  ["й", "y"],
  ["К", "K"],
  ["к", "k"],
  ["Л", "L"],
  ["л", "l"],
  ["М", "M"],
  ["м", "m"],
  ["Н", "N"],
  ["н", "n"],
  ["О", "O"],
  ["о", "o"],
  ["П", "P"],
  ["п", "p"],
  ["Р", "R"],
  ["р", "r"],
  ["С", "S"],
  ["с", "s"],
  ["Т", "T"],
  ["т", "t"],
  ["У", "U"],
  ["у", "u"],
  ["Ф", "F"],
  ["ф", "f"],
  ["Х", "Kh"],
  ["х", "kh"],
  ["Ц", "Ts"],
  ["ц", "ts"],
  ["Ч", "Ch"],
  ["ч", "ch"],
  ["Ш", "Sh"],
  ["ш", "sh"],
  ["Щ", "Sch"],
  ["щ", "sch"],
  ["Ъ", ""],
  ["ъ", ""],
  ["Ы", "Y"],
  ["ы", "y"],
  ["Ь", ""],
  ["ь", ""],
  ["Э", "E"],
  ["э", "e"],
  ["Ю", "Yu"],
  ["ю", "yu"],
  ["Я", "Ya"],
  ["я", "ya"],
  // Romanian
  ["ă", "a"],
  ["Ă", "A"],
  ["ș", "s"],
  ["Ș", "S"],
  ["ț", "t"],
  ["Ț", "T"],
  ["ţ", "t"],
  ["Ţ", "T"],
  // Turkish
  ["ş", "s"],
  ["Ş", "S"],
  ["ç", "c"],
  ["Ç", "C"],
  ["ğ", "g"],
  ["Ğ", "G"],
  ["ı", "i"],
  ["İ", "I"],
  // Armenian
  ["ա", "a"],
  ["Ա", "A"],
  ["բ", "b"],
  ["Բ", "B"],
  ["գ", "g"],
  ["Գ", "G"],
  ["դ", "d"],
  ["Դ", "D"],
  ["ե", "ye"],
  ["Ե", "Ye"],
  ["զ", "z"],
  ["Զ", "Z"],
  ["է", "e"],
  ["Է", "E"],
  ["ը", "y"],
  ["Ը", "Y"],
  ["թ", "t"],
  ["Թ", "T"],
  ["ժ", "zh"],
  ["Ժ", "Zh"],
  ["ի", "i"],
  ["Ի", "I"],
  ["լ", "l"],
  ["Լ", "L"],
  ["խ", "kh"],
  ["Խ", "Kh"],
  ["ծ", "ts"],
  ["Ծ", "Ts"],
  ["կ", "k"],
  ["Կ", "K"],
  ["հ", "h"],
  ["Հ", "H"],
  ["ձ", "dz"],
  ["Ձ", "Dz"],
  ["ղ", "gh"],
  ["Ղ", "Gh"],
  ["ճ", "tch"],
  ["Ճ", "Tch"],
  ["մ", "m"],
  ["Մ", "M"],
  ["յ", "y"],
  ["Յ", "Y"],
  ["ն", "n"],
  ["Ն", "N"],
  ["շ", "sh"],
  ["Շ", "Sh"],
  // NOTE: Longer Armenian sequences must come before shorter ones
  ["ու", "u"],
  ["ՈՒ", "U"],
  ["Ու", "U"],
  ["ո", "vo"],
  ["Ո", "Vo"],
  ["չ", "ch"],
  ["Չ", "Ch"],
  ["պ", "p"],
  ["Պ", "P"],
  ["ջ", "j"],
  ["Ջ", "J"],
  ["ռ", "r"],
  ["Ռ", "R"],
  ["ս", "s"],
  ["Ս", "S"],
  ["վ", "v"],
  ["Վ", "V"],
  ["տ", "t"],
  ["Տ", "T"],
  ["ր", "r"],
  ["Ր", "R"],
  ["ց", "c"],
  ["Ց", "C"],
  ["փ", "p"],
  ["Փ", "P"],
  ["ք", "q"],
  ["Ք", "Q"],
  ["օ", "o"],
  ["Օ", "O"],
  ["ֆ", "f"],
  ["Ֆ", "F"],
  ["և", "yev"],
  // Georgian
  ["ა", "a"],
  ["ბ", "b"],
  ["გ", "g"],
  ["დ", "d"],
  ["ე", "e"],
  ["ვ", "v"],
  ["ზ", "z"],
  ["თ", "t"],
  ["ი", "i"],
  ["კ", "k"],
  ["ლ", "l"],
  ["მ", "m"],
  ["ნ", "n"],
  ["ო", "o"],
  ["პ", "p"],
  ["ჟ", "zh"],
  ["რ", "r"],
  ["ს", "s"],
  ["ტ", "t"],
  ["უ", "u"],
  ["ფ", "ph"],
  ["ქ", "q"],
  ["ღ", "gh"],
  ["ყ", "k"],
  ["შ", "sh"],
  ["ჩ", "ch"],
  ["ც", "ts"],
  ["ძ", "dz"],
  ["წ", "ts"],
  ["ჭ", "tch"],
  ["ხ", "kh"],
  ["ჯ", "j"],
  ["ჰ", "h"],
  // Czech
  ["č", "c"],
  ["ď", "d"],
  ["ě", "e"],
  ["ň", "n"],
  ["ř", "r"],
  ["š", "s"],
  ["ť", "t"],
  ["ů", "u"],
  ["ž", "z"],
  ["Č", "C"],
  ["Ď", "D"],
  ["Ě", "E"],
  ["Ň", "N"],
  ["Ř", "R"],
  ["Š", "S"],
  ["Ť", "T"],
  ["Ů", "U"],
  ["Ž", "Z"],
  // Dhivehi
  ["ހ", "h"],
  ["ށ", "sh"],
  ["ނ", "n"],
  ["ރ", "r"],
  ["ބ", "b"],
  ["ޅ", "lh"],
  ["ކ", "k"],
  ["އ", "a"],
  ["ވ", "v"],
  ["މ", "m"],
  ["ފ", "f"],
  ["ދ", "dh"],
  ["ތ", "th"],
  ["ލ", "l"],
  ["ގ", "g"],
  ["ޏ", "gn"],
  ["ސ", "s"],
  ["ޑ", "d"],
  ["ޒ", "z"],
  ["ޓ", "t"],
  ["ޔ", "y"],
  ["ޕ", "p"],
  ["ޖ", "j"],
  ["ޗ", "ch"],
  ["ޘ", "tt"],
  ["ޙ", "hh"],
  ["ޚ", "kh"],
  ["ޛ", "th"],
  ["ޜ", "z"],
  ["ޝ", "sh"],
  ["ޞ", "s"],
  ["ޟ", "d"],
  ["ޠ", "t"],
  ["ޡ", "z"],
  ["ޢ", "a"],
  ["ޣ", "gh"],
  ["ޤ", "q"],
  ["ޥ", "w"],
  ["ަ", "a"],
  ["ާ", "aa"],
  ["ި", "i"],
  ["ީ", "ee"],
  ["ު", "u"],
  ["ޫ", "oo"],
  ["ެ", "e"],
  ["ޭ", "ey"],
  ["ޮ", "o"],
  ["ޯ", "oa"],
  ["ް", ""],
  // Greek
  ["α", "a"],
  ["β", "v"],
  ["γ", "g"],
  ["δ", "d"],
  ["ε", "e"],
  ["ζ", "z"],
  ["η", "i"],
  ["θ", "th"],
  ["ι", "i"],
  ["κ", "k"],
  ["λ", "l"],
  ["μ", "m"],
  ["ν", "n"],
  ["ξ", "ks"],
  ["ο", "o"],
  ["π", "p"],
  ["ρ", "r"],
  ["σ", "s"],
  ["τ", "t"],
  ["υ", "y"],
  ["φ", "f"],
  ["χ", "x"],
  ["ψ", "ps"],
  ["ω", "o"],
  ["ά", "a"],
  ["έ", "e"],
  ["ί", "i"],
  ["ό", "o"],
  ["ύ", "y"],
  ["ή", "i"],
  ["ώ", "o"],
  ["ς", "s"],
  ["ϊ", "i"],
  ["ΰ", "y"],
  ["ϋ", "y"],
  ["ΐ", "i"],
  ["Α", "A"],
  ["Β", "B"],
  ["Γ", "G"],
  ["Δ", "D"],
  ["Ε", "E"],
  ["Ζ", "Z"],
  ["Η", "I"],
  ["Θ", "TH"],
  ["Ι", "I"],
  ["Κ", "K"],
  ["Λ", "L"],
  ["Μ", "M"],
  ["Ν", "N"],
  ["Ξ", "KS"],
  ["Ο", "O"],
  ["Π", "P"],
  ["Ρ", "R"],
  ["Σ", "S"],
  ["Τ", "T"],
  ["Υ", "Y"],
  ["Φ", "F"],
  ["Χ", "X"],
  ["Ψ", "PS"],
  ["Ω", "O"],
  ["Ά", "A"],
  ["Έ", "E"],
  ["Ί", "I"],
  ["Ό", "O"],
  ["Ύ", "Y"],
  ["Ή", "I"],
  ["Ώ", "O"],
  ["Ϊ", "I"],
  ["Ϋ", "Y"],
  // Disabled as it conflicts with German and Latin.
  // Hungarian
  // ['ä', 'a'],
  // ['Ä', 'A'],
  // ['ö', 'o'],
  // ['Ö', 'O'],
  // ['ü', 'u'],
  // ['Ü', 'U'],
  // ['ű', 'u'],
  // ['Ű', 'U'],
  // Latvian
  ["ā", "a"],
  ["ē", "e"],
  ["ģ", "g"],
  ["ī", "i"],
  ["ķ", "k"],
  ["ļ", "l"],
  ["ņ", "n"],
  ["ū", "u"],
  ["Ā", "A"],
  ["Ē", "E"],
  ["Ģ", "G"],
  ["Ī", "I"],
  ["Ķ", "K"],
  ["Ļ", "L"],
  ["Ņ", "N"],
  ["Ū", "U"],
  ["č", "c"],
  ["š", "s"],
  ["ž", "z"],
  ["Č", "C"],
  ["Š", "S"],
  ["Ž", "Z"],
  // Lithuanian
  ["ą", "a"],
  ["č", "c"],
  ["ę", "e"],
  ["ė", "e"],
  ["į", "i"],
  ["š", "s"],
  ["ų", "u"],
  ["ū", "u"],
  ["ž", "z"],
  ["Ą", "A"],
  ["Č", "C"],
  ["Ę", "E"],
  ["Ė", "E"],
  ["Į", "I"],
  ["Š", "S"],
  ["Ų", "U"],
  ["Ū", "U"],
  // Macedonian
  ["Ќ", "Kj"],
  ["ќ", "kj"],
  ["Љ", "Lj"],
  ["љ", "lj"],
  ["Њ", "Nj"],
  ["њ", "nj"],
  ["Тс", "Ts"],
  ["тс", "ts"],
  // Polish
  ["ą", "a"],
  ["ć", "c"],
  ["ę", "e"],
  ["ł", "l"],
  ["ń", "n"],
  ["ś", "s"],
  ["ź", "z"],
  ["ż", "z"],
  ["Ą", "A"],
  ["Ć", "C"],
  ["Ę", "E"],
  ["Ł", "L"],
  ["Ń", "N"],
  ["Ś", "S"],
  ["Ź", "Z"],
  ["Ż", "Z"],
  // Disabled as it conflicts with Vietnamese.
  // Serbian
  // ['љ', 'lj'],
  // ['њ', 'nj'],
  // ['Љ', 'Lj'],
  // ['Њ', 'Nj'],
  // ['đ', 'dj'],
  // ['Đ', 'Dj'],
  // ['ђ', 'dj'],
  // ['ј', 'j'],
  // ['ћ', 'c'],
  // ['џ', 'dz'],
  // ['Ђ', 'Dj'],
  // ['Ј', 'j'],
  // ['Ћ', 'C'],
  // ['Џ', 'Dz'],
  // Disabled as it conflicts with German and Latin.
  // Slovak
  // ['ä', 'a'],
  // ['Ä', 'A'],
  // ['ľ', 'l'],
  // ['ĺ', 'l'],
  // ['ŕ', 'r'],
  // ['Ľ', 'L'],
  // ['Ĺ', 'L'],
  // ['Ŕ', 'R'],
  // Disabled as it conflicts with German and Latin.
  // Swedish
  // ['å', 'o'],
  // ['Å', 'o'],
  // ['ä', 'a'],
  // ['Ä', 'A'],
  // ['ë', 'e'],
  // ['Ë', 'E'],
  // ['ö', 'o'],
  // ['Ö', 'O'],
  // Ukrainian
  ["Є", "Ye"],
  ["І", "I"],
  ["Ї", "Yi"],
  ["Ґ", "G"],
  ["є", "ye"],
  ["і", "i"],
  ["ї", "yi"],
  ["ґ", "g"],
  // Dutch
  ["Ĳ", "IJ"],
  ["ĳ", "ij"],
  // Danish
  // ['Æ', 'Ae'],
  // ['Ø', 'Oe'],
  // ['Å', 'Aa'],
  // ['æ', 'ae'],
  // ['ø', 'oe'],
  // ['å', 'aa']
  // Currencies
  ["¢", "c"],
  ["¥", "Y"],
  ["߿", "b"],
  ["৳", "t"],
  ["૱", "Bo"],
  ["฿", "B"],
  ["₠", "CE"],
  ["₡", "C"],
  ["₢", "Cr"],
  ["₣", "F"],
  ["₥", "m"],
  ["₦", "N"],
  ["₧", "Pt"],
  ["₨", "Rs"],
  ["₩", "W"],
  ["₫", "s"],
  ["€", "E"],
  ["₭", "K"],
  ["₮", "T"],
  ["₯", "Dp"],
  ["₰", "S"],
  ["₱", "P"],
  ["₲", "G"],
  ["₳", "A"],
  ["₴", "S"],
  ["₵", "C"],
  ["₶", "tt"],
  ["₷", "S"],
  ["₸", "T"],
  ["₹", "R"],
  ["₺", "L"],
  ["₽", "P"],
  ["₿", "B"],
  ["﹩", "$"],
  ["￠", "c"],
  ["￥", "Y"],
  ["￦", "W"],
  // Latin
  ["𝐀", "A"],
  ["𝐁", "B"],
  ["𝐂", "C"],
  ["𝐃", "D"],
  ["𝐄", "E"],
  ["𝐅", "F"],
  ["𝐆", "G"],
  ["𝐇", "H"],
  ["𝐈", "I"],
  ["𝐉", "J"],
  ["𝐊", "K"],
  ["𝐋", "L"],
  ["𝐌", "M"],
  ["𝐍", "N"],
  ["𝐎", "O"],
  ["𝐏", "P"],
  ["𝐐", "Q"],
  ["𝐑", "R"],
  ["𝐒", "S"],
  ["𝐓", "T"],
  ["𝐔", "U"],
  ["𝐕", "V"],
  ["𝐖", "W"],
  ["𝐗", "X"],
  ["𝐘", "Y"],
  ["𝐙", "Z"],
  ["𝐚", "a"],
  ["𝐛", "b"],
  ["𝐜", "c"],
  ["𝐝", "d"],
  ["𝐞", "e"],
  ["𝐟", "f"],
  ["𝐠", "g"],
  ["𝐡", "h"],
  ["𝐢", "i"],
  ["𝐣", "j"],
  ["𝐤", "k"],
  ["𝐥", "l"],
  ["𝐦", "m"],
  ["𝐧", "n"],
  ["𝐨", "o"],
  ["𝐩", "p"],
  ["𝐪", "q"],
  ["𝐫", "r"],
  ["𝐬", "s"],
  ["𝐭", "t"],
  ["𝐮", "u"],
  ["𝐯", "v"],
  ["𝐰", "w"],
  ["𝐱", "x"],
  ["𝐲", "y"],
  ["𝐳", "z"],
  ["𝐴", "A"],
  ["𝐵", "B"],
  ["𝐶", "C"],
  ["𝐷", "D"],
  ["𝐸", "E"],
  ["𝐹", "F"],
  ["𝐺", "G"],
  ["𝐻", "H"],
  ["𝐼", "I"],
  ["𝐽", "J"],
  ["𝐾", "K"],
  ["𝐿", "L"],
  ["𝑀", "M"],
  ["𝑁", "N"],
  ["𝑂", "O"],
  ["𝑃", "P"],
  ["𝑄", "Q"],
  ["𝑅", "R"],
  ["𝑆", "S"],
  ["𝑇", "T"],
  ["𝑈", "U"],
  ["𝑉", "V"],
  ["𝑊", "W"],
  ["𝑋", "X"],
  ["𝑌", "Y"],
  ["𝑍", "Z"],
  ["𝑎", "a"],
  ["𝑏", "b"],
  ["𝑐", "c"],
  ["𝑑", "d"],
  ["𝑒", "e"],
  ["𝑓", "f"],
  ["𝑔", "g"],
  ["𝑖", "i"],
  ["𝑗", "j"],
  ["𝑘", "k"],
  ["𝑙", "l"],
  ["𝑚", "m"],
  ["𝑛", "n"],
  ["𝑜", "o"],
  ["𝑝", "p"],
  ["𝑞", "q"],
  ["𝑟", "r"],
  ["𝑠", "s"],
  ["𝑡", "t"],
  ["𝑢", "u"],
  ["𝑣", "v"],
  ["𝑤", "w"],
  ["𝑥", "x"],
  ["𝑦", "y"],
  ["𝑧", "z"],
  ["𝑨", "A"],
  ["𝑩", "B"],
  ["𝑪", "C"],
  ["𝑫", "D"],
  ["𝑬", "E"],
  ["𝑭", "F"],
  ["𝑮", "G"],
  ["𝑯", "H"],
  ["𝑰", "I"],
  ["𝑱", "J"],
  ["𝑲", "K"],
  ["𝑳", "L"],
  ["𝑴", "M"],
  ["𝑵", "N"],
  ["𝑶", "O"],
  ["𝑷", "P"],
  ["𝑸", "Q"],
  ["𝑹", "R"],
  ["𝑺", "S"],
  ["𝑻", "T"],
  ["𝑼", "U"],
  ["𝑽", "V"],
  ["𝑾", "W"],
  ["𝑿", "X"],
  ["𝒀", "Y"],
  ["𝒁", "Z"],
  ["𝒂", "a"],
  ["𝒃", "b"],
  ["𝒄", "c"],
  ["𝒅", "d"],
  ["𝒆", "e"],
  ["𝒇", "f"],
  ["𝒈", "g"],
  ["𝒉", "h"],
  ["𝒊", "i"],
  ["𝒋", "j"],
  ["𝒌", "k"],
  ["𝒍", "l"],
  ["𝒎", "m"],
  ["𝒏", "n"],
  ["𝒐", "o"],
  ["𝒑", "p"],
  ["𝒒", "q"],
  ["𝒓", "r"],
  ["𝒔", "s"],
  ["𝒕", "t"],
  ["𝒖", "u"],
  ["𝒗", "v"],
  ["𝒘", "w"],
  ["𝒙", "x"],
  ["𝒚", "y"],
  ["𝒛", "z"],
  ["𝒜", "A"],
  ["𝒞", "C"],
  ["𝒟", "D"],
  ["𝒢", "g"],
  ["𝒥", "J"],
  ["𝒦", "K"],
  ["𝒩", "N"],
  ["𝒪", "O"],
  ["𝒫", "P"],
  ["𝒬", "Q"],
  ["𝒮", "S"],
  ["𝒯", "T"],
  ["𝒰", "U"],
  ["𝒱", "V"],
  ["𝒲", "W"],
  ["𝒳", "X"],
  ["𝒴", "Y"],
  ["𝒵", "Z"],
  ["𝒶", "a"],
  ["𝒷", "b"],
  ["𝒸", "c"],
  ["𝒹", "d"],
  ["𝒻", "f"],
  ["𝒽", "h"],
  ["𝒾", "i"],
  ["𝒿", "j"],
  ["𝓀", "k"],
  ["𝓁", "l"],
  ["𝓂", "m"],
  ["𝓃", "n"],
  ["𝓅", "p"],
  ["𝓆", "q"],
  ["𝓇", "r"],
  ["𝓈", "s"],
  ["𝓉", "t"],
  ["𝓊", "u"],
  ["𝓋", "v"],
  ["𝓌", "w"],
  ["𝓍", "x"],
  ["𝓎", "y"],
  ["𝓏", "z"],
  ["𝓐", "A"],
  ["𝓑", "B"],
  ["𝓒", "C"],
  ["𝓓", "D"],
  ["𝓔", "E"],
  ["𝓕", "F"],
  ["𝓖", "G"],
  ["𝓗", "H"],
  ["𝓘", "I"],
  ["𝓙", "J"],
  ["𝓚", "K"],
  ["𝓛", "L"],
  ["𝓜", "M"],
  ["𝓝", "N"],
  ["𝓞", "O"],
  ["𝓟", "P"],
  ["𝓠", "Q"],
  ["𝓡", "R"],
  ["𝓢", "S"],
  ["𝓣", "T"],
  ["𝓤", "U"],
  ["𝓥", "V"],
  ["𝓦", "W"],
  ["𝓧", "X"],
  ["𝓨", "Y"],
  ["𝓩", "Z"],
  ["𝓪", "a"],
  ["𝓫", "b"],
  ["𝓬", "c"],
  ["𝓭", "d"],
  ["𝓮", "e"],
  ["𝓯", "f"],
  ["𝓰", "g"],
  ["𝓱", "h"],
  ["𝓲", "i"],
  ["𝓳", "j"],
  ["𝓴", "k"],
  ["𝓵", "l"],
  ["𝓶", "m"],
  ["𝓷", "n"],
  ["𝓸", "o"],
  ["𝓹", "p"],
  ["𝓺", "q"],
  ["𝓻", "r"],
  ["𝓼", "s"],
  ["𝓽", "t"],
  ["𝓾", "u"],
  ["𝓿", "v"],
  ["𝔀", "w"],
  ["𝔁", "x"],
  ["𝔂", "y"],
  ["𝔃", "z"],
  ["𝔄", "A"],
  ["𝔅", "B"],
  ["𝔇", "D"],
  ["𝔈", "E"],
  ["𝔉", "F"],
  ["𝔊", "G"],
  ["𝔍", "J"],
  ["𝔎", "K"],
  ["𝔏", "L"],
  ["𝔐", "M"],
  ["𝔑", "N"],
  ["𝔒", "O"],
  ["𝔓", "P"],
  ["𝔔", "Q"],
  ["𝔖", "S"],
  ["𝔗", "T"],
  ["𝔘", "U"],
  ["𝔙", "V"],
  ["𝔚", "W"],
  ["𝔛", "X"],
  ["𝔜", "Y"],
  ["𝔞", "a"],
  ["𝔟", "b"],
  ["𝔠", "c"],
  ["𝔡", "d"],
  ["𝔢", "e"],
  ["𝔣", "f"],
  ["𝔤", "g"],
  ["𝔥", "h"],
  ["𝔦", "i"],
  ["𝔧", "j"],
  ["𝔨", "k"],
  ["𝔩", "l"],
  ["𝔪", "m"],
  ["𝔫", "n"],
  ["𝔬", "o"],
  ["𝔭", "p"],
  ["𝔮", "q"],
  ["𝔯", "r"],
  ["𝔰", "s"],
  ["𝔱", "t"],
  ["𝔲", "u"],
  ["𝔳", "v"],
  ["𝔴", "w"],
  ["𝔵", "x"],
  ["𝔶", "y"],
  ["𝔷", "z"],
  ["𝔸", "A"],
  ["𝔹", "B"],
  ["𝔻", "D"],
  ["𝔼", "E"],
  ["𝔽", "F"],
  ["𝔾", "G"],
  ["𝕀", "I"],
  ["𝕁", "J"],
  ["𝕂", "K"],
  ["𝕃", "L"],
  ["𝕄", "M"],
  ["𝕆", "O"],
  ["𝕊", "S"],
  ["𝕋", "T"],
  ["𝕌", "U"],
  ["𝕍", "V"],
  ["𝕎", "W"],
  ["𝕏", "X"],
  ["𝕐", "Y"],
  ["𝕒", "a"],
  ["𝕓", "b"],
  ["𝕔", "c"],
  ["𝕕", "d"],
  ["𝕖", "e"],
  ["𝕗", "f"],
  ["𝕘", "g"],
  ["𝕙", "h"],
  ["𝕚", "i"],
  ["𝕛", "j"],
  ["𝕜", "k"],
  ["𝕝", "l"],
  ["𝕞", "m"],
  ["𝕟", "n"],
  ["𝕠", "o"],
  ["𝕡", "p"],
  ["𝕢", "q"],
  ["𝕣", "r"],
  ["𝕤", "s"],
  ["𝕥", "t"],
  ["𝕦", "u"],
  ["𝕧", "v"],
  ["𝕨", "w"],
  ["𝕩", "x"],
  ["𝕪", "y"],
  ["𝕫", "z"],
  ["𝕬", "A"],
  ["𝕭", "B"],
  ["𝕮", "C"],
  ["𝕯", "D"],
  ["𝕰", "E"],
  ["𝕱", "F"],
  ["𝕲", "G"],
  ["𝕳", "H"],
  ["𝕴", "I"],
  ["𝕵", "J"],
  ["𝕶", "K"],
  ["𝕷", "L"],
  ["𝕸", "M"],
  ["𝕹", "N"],
  ["𝕺", "O"],
  ["𝕻", "P"],
  ["𝕼", "Q"],
  ["𝕽", "R"],
  ["𝕾", "S"],
  ["𝕿", "T"],
  ["𝖀", "U"],
  ["𝖁", "V"],
  ["𝖂", "W"],
  ["𝖃", "X"],
  ["𝖄", "Y"],
  ["𝖅", "Z"],
  ["𝖆", "a"],
  ["𝖇", "b"],
  ["𝖈", "c"],
  ["𝖉", "d"],
  ["𝖊", "e"],
  ["𝖋", "f"],
  ["𝖌", "g"],
  ["𝖍", "h"],
  ["𝖎", "i"],
  ["𝖏", "j"],
  ["𝖐", "k"],
  ["𝖑", "l"],
  ["𝖒", "m"],
  ["𝖓", "n"],
  ["𝖔", "o"],
  ["𝖕", "p"],
  ["𝖖", "q"],
  ["𝖗", "r"],
  ["𝖘", "s"],
  ["𝖙", "t"],
  ["𝖚", "u"],
  ["𝖛", "v"],
  ["𝖜", "w"],
  ["𝖝", "x"],
  ["𝖞", "y"],
  ["𝖟", "z"],
  ["𝖠", "A"],
  ["𝖡", "B"],
  ["𝖢", "C"],
  ["𝖣", "D"],
  ["𝖤", "E"],
  ["𝖥", "F"],
  ["𝖦", "G"],
  ["𝖧", "H"],
  ["𝖨", "I"],
  ["𝖩", "J"],
  ["𝖪", "K"],
  ["𝖫", "L"],
  ["𝖬", "M"],
  ["𝖭", "N"],
  ["𝖮", "O"],
  ["𝖯", "P"],
  ["𝖰", "Q"],
  ["𝖱", "R"],
  ["𝖲", "S"],
  ["𝖳", "T"],
  ["𝖴", "U"],
  ["𝖵", "V"],
  ["𝖶", "W"],
  ["𝖷", "X"],
  ["𝖸", "Y"],
  ["𝖹", "Z"],
  ["𝖺", "a"],
  ["𝖻", "b"],
  ["𝖼", "c"],
  ["𝖽", "d"],
  ["𝖾", "e"],
  ["𝖿", "f"],
  ["𝗀", "g"],
  ["𝗁", "h"],
  ["𝗂", "i"],
  ["𝗃", "j"],
  ["𝗄", "k"],
  ["𝗅", "l"],
  ["𝗆", "m"],
  ["𝗇", "n"],
  ["𝗈", "o"],
  ["𝗉", "p"],
  ["𝗊", "q"],
  ["𝗋", "r"],
  ["𝗌", "s"],
  ["𝗍", "t"],
  ["𝗎", "u"],
  ["𝗏", "v"],
  ["𝗐", "w"],
  ["𝗑", "x"],
  ["𝗒", "y"],
  ["𝗓", "z"],
  ["𝗔", "A"],
  ["𝗕", "B"],
  ["𝗖", "C"],
  ["𝗗", "D"],
  ["𝗘", "E"],
  ["𝗙", "F"],
  ["𝗚", "G"],
  ["𝗛", "H"],
  ["𝗜", "I"],
  ["𝗝", "J"],
  ["𝗞", "K"],
  ["𝗟", "L"],
  ["𝗠", "M"],
  ["𝗡", "N"],
  ["𝗢", "O"],
  ["𝗣", "P"],
  ["𝗤", "Q"],
  ["𝗥", "R"],
  ["𝗦", "S"],
  ["𝗧", "T"],
  ["𝗨", "U"],
  ["𝗩", "V"],
  ["𝗪", "W"],
  ["𝗫", "X"],
  ["𝗬", "Y"],
  ["𝗭", "Z"],
  ["𝗮", "a"],
  ["𝗯", "b"],
  ["𝗰", "c"],
  ["𝗱", "d"],
  ["𝗲", "e"],
  ["𝗳", "f"],
  ["𝗴", "g"],
  ["𝗵", "h"],
  ["𝗶", "i"],
  ["𝗷", "j"],
  ["𝗸", "k"],
  ["𝗹", "l"],
  ["𝗺", "m"],
  ["𝗻", "n"],
  ["𝗼", "o"],
  ["𝗽", "p"],
  ["𝗾", "q"],
  ["𝗿", "r"],
  ["𝘀", "s"],
  ["𝘁", "t"],
  ["𝘂", "u"],
  ["𝘃", "v"],
  ["𝘄", "w"],
  ["𝘅", "x"],
  ["𝘆", "y"],
  ["𝘇", "z"],
  ["𝘈", "A"],
  ["𝘉", "B"],
  ["𝘊", "C"],
  ["𝘋", "D"],
  ["𝘌", "E"],
  ["𝘍", "F"],
  ["𝘎", "G"],
  ["𝘏", "H"],
  ["𝘐", "I"],
  ["𝘑", "J"],
  ["𝘒", "K"],
  ["𝘓", "L"],
  ["𝘔", "M"],
  ["𝘕", "N"],
  ["𝘖", "O"],
  ["𝘗", "P"],
  ["𝘘", "Q"],
  ["𝘙", "R"],
  ["𝘚", "S"],
  ["𝘛", "T"],
  ["𝘜", "U"],
  ["𝘝", "V"],
  ["𝘞", "W"],
  ["𝘟", "X"],
  ["𝘠", "Y"],
  ["𝘡", "Z"],
  ["𝘢", "a"],
  ["𝘣", "b"],
  ["𝘤", "c"],
  ["𝘥", "d"],
  ["𝘦", "e"],
  ["𝘧", "f"],
  ["𝘨", "g"],
  ["𝘩", "h"],
  ["𝘪", "i"],
  ["𝘫", "j"],
  ["𝘬", "k"],
  ["𝘭", "l"],
  ["𝘮", "m"],
  ["𝘯", "n"],
  ["𝘰", "o"],
  ["𝘱", "p"],
  ["𝘲", "q"],
  ["𝘳", "r"],
  ["𝘴", "s"],
  ["𝘵", "t"],
  ["𝘶", "u"],
  ["𝘷", "v"],
  ["𝘸", "w"],
  ["𝘹", "x"],
  ["𝘺", "y"],
  ["𝘻", "z"],
  ["𝘼", "A"],
  ["𝘽", "B"],
  ["𝘾", "C"],
  ["𝘿", "D"],
  ["𝙀", "E"],
  ["𝙁", "F"],
  ["𝙂", "G"],
  ["𝙃", "H"],
  ["𝙄", "I"],
  ["𝙅", "J"],
  ["𝙆", "K"],
  ["𝙇", "L"],
  ["𝙈", "M"],
  ["𝙉", "N"],
  ["𝙊", "O"],
  ["𝙋", "P"],
  ["𝙌", "Q"],
  ["𝙍", "R"],
  ["𝙎", "S"],
  ["𝙏", "T"],
  ["𝙐", "U"],
  ["𝙑", "V"],
  ["𝙒", "W"],
  ["𝙓", "X"],
  ["𝙔", "Y"],
  ["𝙕", "Z"],
  ["𝙖", "a"],
  ["𝙗", "b"],
  ["𝙘", "c"],
  ["𝙙", "d"],
  ["𝙚", "e"],
  ["𝙛", "f"],
  ["𝙜", "g"],
  ["𝙝", "h"],
  ["𝙞", "i"],
  ["𝙟", "j"],
  ["𝙠", "k"],
  ["𝙡", "l"],
  ["𝙢", "m"],
  ["𝙣", "n"],
  ["𝙤", "o"],
  ["𝙥", "p"],
  ["𝙦", "q"],
  ["𝙧", "r"],
  ["𝙨", "s"],
  ["𝙩", "t"],
  ["𝙪", "u"],
  ["𝙫", "v"],
  ["𝙬", "w"],
  ["𝙭", "x"],
  ["𝙮", "y"],
  ["𝙯", "z"],
  ["𝙰", "A"],
  ["𝙱", "B"],
  ["𝙲", "C"],
  ["𝙳", "D"],
  ["𝙴", "E"],
  ["𝙵", "F"],
  ["𝙶", "G"],
  ["𝙷", "H"],
  ["𝙸", "I"],
  ["𝙹", "J"],
  ["𝙺", "K"],
  ["𝙻", "L"],
  ["𝙼", "M"],
  ["𝙽", "N"],
  ["𝙾", "O"],
  ["𝙿", "P"],
  ["𝚀", "Q"],
  ["𝚁", "R"],
  ["𝚂", "S"],
  ["𝚃", "T"],
  ["𝚄", "U"],
  ["𝚅", "V"],
  ["𝚆", "W"],
  ["𝚇", "X"],
  ["𝚈", "Y"],
  ["𝚉", "Z"],
  ["𝚊", "a"],
  ["𝚋", "b"],
  ["𝚌", "c"],
  ["𝚍", "d"],
  ["𝚎", "e"],
  ["𝚏", "f"],
  ["𝚐", "g"],
  ["𝚑", "h"],
  ["𝚒", "i"],
  ["𝚓", "j"],
  ["𝚔", "k"],
  ["𝚕", "l"],
  ["𝚖", "m"],
  ["𝚗", "n"],
  ["𝚘", "o"],
  ["𝚙", "p"],
  ["𝚚", "q"],
  ["𝚛", "r"],
  ["𝚜", "s"],
  ["𝚝", "t"],
  ["𝚞", "u"],
  ["𝚟", "v"],
  ["𝚠", "w"],
  ["𝚡", "x"],
  ["𝚢", "y"],
  ["𝚣", "z"],
  // Dotless letters
  ["𝚤", "l"],
  ["𝚥", "j"],
  // Greek
  ["𝛢", "A"],
  ["𝛣", "B"],
  ["𝛤", "G"],
  ["𝛥", "D"],
  ["𝛦", "E"],
  ["𝛧", "Z"],
  ["𝛨", "I"],
  ["𝛩", "TH"],
  ["𝛪", "I"],
  ["𝛫", "K"],
  ["𝛬", "L"],
  ["𝛭", "M"],
  ["𝛮", "N"],
  ["𝛯", "KS"],
  ["𝛰", "O"],
  ["𝛱", "P"],
  ["𝛲", "R"],
  ["𝛳", "TH"],
  ["𝛴", "S"],
  ["𝛵", "T"],
  ["𝛶", "Y"],
  ["𝛷", "F"],
  ["𝛸", "x"],
  ["𝛹", "PS"],
  ["𝛺", "O"],
  ["𝛻", "D"],
  ["𝛼", "a"],
  ["𝛽", "b"],
  ["𝛾", "g"],
  ["𝛿", "d"],
  ["𝜀", "e"],
  ["𝜁", "z"],
  ["𝜂", "i"],
  ["𝜃", "th"],
  ["𝜄", "i"],
  ["𝜅", "k"],
  ["𝜆", "l"],
  ["𝜇", "m"],
  ["𝜈", "n"],
  ["𝜉", "ks"],
  ["𝜊", "o"],
  ["𝜋", "p"],
  ["𝜌", "r"],
  ["𝜍", "s"],
  ["𝜎", "s"],
  ["𝜏", "t"],
  ["𝜐", "y"],
  ["𝜑", "f"],
  ["𝜒", "x"],
  ["𝜓", "ps"],
  ["𝜔", "o"],
  ["𝜕", "d"],
  ["𝜖", "E"],
  ["𝜗", "TH"],
  ["𝜘", "K"],
  ["𝜙", "f"],
  ["𝜚", "r"],
  ["𝜛", "p"],
  ["𝜜", "A"],
  ["𝜝", "V"],
  ["𝜞", "G"],
  ["𝜟", "D"],
  ["𝜠", "E"],
  ["𝜡", "Z"],
  ["𝜢", "I"],
  ["𝜣", "TH"],
  ["𝜤", "I"],
  ["𝜥", "K"],
  ["𝜦", "L"],
  ["𝜧", "M"],
  ["𝜨", "N"],
  ["𝜩", "KS"],
  ["𝜪", "O"],
  ["𝜫", "P"],
  ["𝜬", "S"],
  ["𝜭", "TH"],
  ["𝜮", "S"],
  ["𝜯", "T"],
  ["𝜰", "Y"],
  ["𝜱", "F"],
  ["𝜲", "X"],
  ["𝜳", "PS"],
  ["𝜴", "O"],
  ["𝜵", "D"],
  ["𝜶", "a"],
  ["𝜷", "v"],
  ["𝜸", "g"],
  ["𝜹", "d"],
  ["𝜺", "e"],
  ["𝜻", "z"],
  ["𝜼", "i"],
  ["𝜽", "th"],
  ["𝜾", "i"],
  ["𝜿", "k"],
  ["𝝀", "l"],
  ["𝝁", "m"],
  ["𝝂", "n"],
  ["𝝃", "ks"],
  ["𝝄", "o"],
  ["𝝅", "p"],
  ["𝝆", "r"],
  ["𝝇", "s"],
  ["𝝈", "s"],
  ["𝝉", "t"],
  ["𝝊", "y"],
  ["𝝋", "f"],
  ["𝝌", "x"],
  ["𝝍", "ps"],
  ["𝝎", "o"],
  ["𝝏", "a"],
  ["𝝐", "e"],
  ["𝝑", "i"],
  ["𝝒", "k"],
  ["𝝓", "f"],
  ["𝝔", "r"],
  ["𝝕", "p"],
  ["𝝖", "A"],
  ["𝝗", "B"],
  ["𝝘", "G"],
  ["𝝙", "D"],
  ["𝝚", "E"],
  ["𝝛", "Z"],
  ["𝝜", "I"],
  ["𝝝", "TH"],
  ["𝝞", "I"],
  ["𝝟", "K"],
  ["𝝠", "L"],
  ["𝝡", "M"],
  ["𝝢", "N"],
  ["𝝣", "KS"],
  ["𝝤", "O"],
  ["𝝥", "P"],
  ["𝝦", "R"],
  ["𝝧", "TH"],
  ["𝝨", "S"],
  ["𝝩", "T"],
  ["𝝪", "Y"],
  ["𝝫", "F"],
  ["𝝬", "X"],
  ["𝝭", "PS"],
  ["𝝮", "O"],
  ["𝝯", "D"],
  ["𝝰", "a"],
  ["𝝱", "v"],
  ["𝝲", "g"],
  ["𝝳", "d"],
  ["𝝴", "e"],
  ["𝝵", "z"],
  ["𝝶", "i"],
  ["𝝷", "th"],
  ["𝝸", "i"],
  ["𝝹", "k"],
  ["𝝺", "l"],
  ["𝝻", "m"],
  ["𝝼", "n"],
  ["𝝽", "ks"],
  ["𝝾", "o"],
  ["𝝿", "p"],
  ["𝞀", "r"],
  ["𝞁", "s"],
  ["𝞂", "s"],
  ["𝞃", "t"],
  ["𝞄", "y"],
  ["𝞅", "f"],
  ["𝞆", "x"],
  ["𝞇", "ps"],
  ["𝞈", "o"],
  ["𝞉", "a"],
  ["𝞊", "e"],
  ["𝞋", "i"],
  ["𝞌", "k"],
  ["𝞍", "f"],
  ["𝞎", "r"],
  ["𝞏", "p"],
  ["𝞐", "A"],
  ["𝞑", "V"],
  ["𝞒", "G"],
  ["𝞓", "D"],
  ["𝞔", "E"],
  ["𝞕", "Z"],
  ["𝞖", "I"],
  ["𝞗", "TH"],
  ["𝞘", "I"],
  ["𝞙", "K"],
  ["𝞚", "L"],
  ["𝞛", "M"],
  ["𝞜", "N"],
  ["𝞝", "KS"],
  ["𝞞", "O"],
  ["𝞟", "P"],
  ["𝞠", "S"],
  ["𝞡", "TH"],
  ["𝞢", "S"],
  ["𝞣", "T"],
  ["𝞤", "Y"],
  ["𝞥", "F"],
  ["𝞦", "X"],
  ["𝞧", "PS"],
  ["𝞨", "O"],
  ["𝞩", "D"],
  ["𝞪", "av"],
  ["𝞫", "g"],
  ["𝞬", "d"],
  ["𝞭", "e"],
  ["𝞮", "z"],
  ["𝞯", "i"],
  ["𝞰", "i"],
  ["𝞱", "th"],
  ["𝞲", "i"],
  ["𝞳", "k"],
  ["𝞴", "l"],
  ["𝞵", "m"],
  ["𝞶", "n"],
  ["𝞷", "ks"],
  ["𝞸", "o"],
  ["𝞹", "p"],
  ["𝞺", "r"],
  ["𝞻", "s"],
  ["𝞼", "s"],
  ["𝞽", "t"],
  ["𝞾", "y"],
  ["𝞿", "f"],
  ["𝟀", "x"],
  ["𝟁", "ps"],
  ["𝟂", "o"],
  ["𝟃", "a"],
  ["𝟄", "e"],
  ["𝟅", "i"],
  ["𝟆", "k"],
  ["𝟇", "f"],
  ["𝟈", "r"],
  ["𝟉", "p"],
  ["𝟊", "F"],
  ["𝟋", "f"],
  ["⒜", "(a)"],
  ["⒝", "(b)"],
  ["⒞", "(c)"],
  ["⒟", "(d)"],
  ["⒠", "(e)"],
  ["⒡", "(f)"],
  ["⒢", "(g)"],
  ["⒣", "(h)"],
  ["⒤", "(i)"],
  ["⒥", "(j)"],
  ["⒦", "(k)"],
  ["⒧", "(l)"],
  ["⒨", "(m)"],
  ["⒩", "(n)"],
  ["⒪", "(o)"],
  ["⒫", "(p)"],
  ["⒬", "(q)"],
  ["⒭", "(r)"],
  ["⒮", "(s)"],
  ["⒯", "(t)"],
  ["⒰", "(u)"],
  ["⒱", "(v)"],
  ["⒲", "(w)"],
  ["⒳", "(x)"],
  ["⒴", "(y)"],
  ["⒵", "(z)"],
  ["Ⓐ", "(A)"],
  ["Ⓑ", "(B)"],
  ["Ⓒ", "(C)"],
  ["Ⓓ", "(D)"],
  ["Ⓔ", "(E)"],
  ["Ⓕ", "(F)"],
  ["Ⓖ", "(G)"],
  ["Ⓗ", "(H)"],
  ["Ⓘ", "(I)"],
  ["Ⓙ", "(J)"],
  ["Ⓚ", "(K)"],
  ["Ⓛ", "(L)"],
  ["Ⓝ", "(N)"],
  ["Ⓞ", "(O)"],
  ["Ⓟ", "(P)"],
  ["Ⓠ", "(Q)"],
  ["Ⓡ", "(R)"],
  ["Ⓢ", "(S)"],
  ["Ⓣ", "(T)"],
  ["Ⓤ", "(U)"],
  ["Ⓥ", "(V)"],
  ["Ⓦ", "(W)"],
  ["Ⓧ", "(X)"],
  ["Ⓨ", "(Y)"],
  ["Ⓩ", "(Z)"],
  ["ⓐ", "(a)"],
  ["ⓑ", "(b)"],
  ["ⓒ", "(c)"],
  ["ⓓ", "(d)"],
  ["ⓔ", "(e)"],
  ["ⓕ", "(f)"],
  ["ⓖ", "(g)"],
  ["ⓗ", "(h)"],
  ["ⓘ", "(i)"],
  ["ⓙ", "(j)"],
  ["ⓚ", "(k)"],
  ["ⓛ", "(l)"],
  ["ⓜ", "(m)"],
  ["ⓝ", "(n)"],
  ["ⓞ", "(o)"],
  ["ⓟ", "(p)"],
  ["ⓠ", "(q)"],
  ["ⓡ", "(r)"],
  ["ⓢ", "(s)"],
  ["ⓣ", "(t)"],
  ["ⓤ", "(u)"],
  ["ⓥ", "(v)"],
  ["ⓦ", "(w)"],
  ["ⓧ", "(x)"],
  ["ⓨ", "(y)"],
  ["ⓩ", "(z)"],
  // Maltese
  ["Ċ", "C"],
  ["ċ", "c"],
  ["Ġ", "G"],
  ["ġ", "g"],
  ["Ħ", "H"],
  ["ħ", "h"],
  ["Ż", "Z"],
  ["ż", "z"],
  // Numbers
  ["𝟎", "0"],
  ["𝟏", "1"],
  ["𝟐", "2"],
  ["𝟑", "3"],
  ["𝟒", "4"],
  ["𝟓", "5"],
  ["𝟔", "6"],
  ["𝟕", "7"],
  ["𝟖", "8"],
  ["𝟗", "9"],
  ["𝟘", "0"],
  ["𝟙", "1"],
  ["𝟚", "2"],
  ["𝟛", "3"],
  ["𝟜", "4"],
  ["𝟝", "5"],
  ["𝟞", "6"],
  ["𝟟", "7"],
  ["𝟠", "8"],
  ["𝟡", "9"],
  ["𝟢", "0"],
  ["𝟣", "1"],
  ["𝟤", "2"],
  ["𝟥", "3"],
  ["𝟦", "4"],
  ["𝟧", "5"],
  ["𝟨", "6"],
  ["𝟩", "7"],
  ["𝟪", "8"],
  ["𝟫", "9"],
  ["𝟬", "0"],
  ["𝟭", "1"],
  ["𝟮", "2"],
  ["𝟯", "3"],
  ["𝟰", "4"],
  ["𝟱", "5"],
  ["𝟲", "6"],
  ["𝟳", "7"],
  ["𝟴", "8"],
  ["𝟵", "9"],
  ["𝟶", "0"],
  ["𝟷", "1"],
  ["𝟸", "2"],
  ["𝟹", "3"],
  ["𝟺", "4"],
  ["𝟻", "5"],
  ["𝟼", "6"],
  ["𝟽", "7"],
  ["𝟾", "8"],
  ["𝟿", "9"],
  ["①", "1"],
  ["②", "2"],
  ["③", "3"],
  ["④", "4"],
  ["⑤", "5"],
  ["⑥", "6"],
  ["⑦", "7"],
  ["⑧", "8"],
  ["⑨", "9"],
  ["⑩", "10"],
  ["⑪", "11"],
  ["⑫", "12"],
  ["⑬", "13"],
  ["⑭", "14"],
  ["⑮", "15"],
  ["⑯", "16"],
  ["⑰", "17"],
  ["⑱", "18"],
  ["⑲", "19"],
  ["⑳", "20"],
  ["⑴", "1"],
  ["⑵", "2"],
  ["⑶", "3"],
  ["⑷", "4"],
  ["⑸", "5"],
  ["⑹", "6"],
  ["⑺", "7"],
  ["⑻", "8"],
  ["⑼", "9"],
  ["⑽", "10"],
  ["⑾", "11"],
  ["⑿", "12"],
  ["⒀", "13"],
  ["⒁", "14"],
  ["⒂", "15"],
  ["⒃", "16"],
  ["⒄", "17"],
  ["⒅", "18"],
  ["⒆", "19"],
  ["⒇", "20"],
  ["⒈", "1."],
  ["⒉", "2."],
  ["⒊", "3."],
  ["⒋", "4."],
  ["⒌", "5."],
  ["⒍", "6."],
  ["⒎", "7."],
  ["⒏", "8."],
  ["⒐", "9."],
  ["⒑", "10."],
  ["⒒", "11."],
  ["⒓", "12."],
  ["⒔", "13."],
  ["⒕", "14."],
  ["⒖", "15."],
  ["⒗", "16."],
  ["⒘", "17."],
  ["⒙", "18."],
  ["⒚", "19."],
  ["⒛", "20."],
  ["⓪", "0"],
  ["⓫", "11"],
  ["⓬", "12"],
  ["⓭", "13"],
  ["⓮", "14"],
  ["⓯", "15"],
  ["⓰", "16"],
  ["⓱", "17"],
  ["⓲", "18"],
  ["⓳", "19"],
  ["⓴", "20"],
  ["⓵", "1"],
  ["⓶", "2"],
  ["⓷", "3"],
  ["⓸", "4"],
  ["⓹", "5"],
  ["⓺", "6"],
  ["⓻", "7"],
  ["⓼", "8"],
  ["⓽", "9"],
  ["⓾", "10"],
  ["⓿", "0"],
  // Punctuation
  ["🙰", "&"],
  ["🙱", "&"],
  ["🙲", "&"],
  ["🙳", "&"],
  ["🙴", "&"],
  ["🙵", "&"],
  ["🙶", '"'],
  ["🙷", '"'],
  ["🙸", '"'],
  ["‽", "?!"],
  ["🙹", "?!"],
  ["🙺", "?!"],
  ["🙻", "?!"],
  ["🙼", "/"],
  ["🙽", "\\"],
  // Alchemy
  ["🜇", "AR"],
  ["🜈", "V"],
  ["🜉", "V"],
  ["🜆", "VR"],
  ["🜅", "VF"],
  ["🜩", "2"],
  ["🜪", "5"],
  ["🝡", "f"],
  ["🝢", "W"],
  ["🝣", "U"],
  ["🝧", "V"],
  ["🝨", "T"],
  ["🝪", "V"],
  ["🝫", "MB"],
  ["🝬", "VB"],
  ["🝲", "3B"],
  ["🝳", "3B"],
  // Emojis
  ["💯", "100"],
  ["🔙", "BACK"],
  ["🔚", "END"],
  ["🔛", "ON!"],
  ["🔜", "SOON"],
  ["🔝", "TOP"],
  ["🔞", "18"],
  ["🔤", "abc"],
  ["🔠", "ABCD"],
  ["🔡", "abcd"],
  ["🔢", "1234"],
  ["🔣", "T&@%"],
  ["#️⃣", "#"],
  ["*️⃣", "*"],
  ["0️⃣", "0"],
  ["1️⃣", "1"],
  ["2️⃣", "2"],
  ["3️⃣", "3"],
  ["4️⃣", "4"],
  ["5️⃣", "5"],
  ["6️⃣", "6"],
  ["7️⃣", "7"],
  ["8️⃣", "8"],
  ["9️⃣", "9"],
  ["🔟", "10"],
  ["🅰️", "A"],
  ["🅱️", "B"],
  ["🆎", "AB"],
  ["🆑", "CL"],
  ["🅾️", "O"],
  ["🅿", "P"],
  ["🆘", "SOS"],
  ["🅲", "C"],
  ["🅳", "D"],
  ["🅴", "E"],
  ["🅵", "F"],
  ["🅶", "G"],
  ["🅷", "H"],
  ["🅸", "I"],
  ["🅹", "J"],
  ["🅺", "K"],
  ["🅻", "L"],
  ["🅼", "M"],
  ["🅽", "N"],
  ["🆀", "Q"],
  ["🆁", "R"],
  ["🆂", "S"],
  ["🆃", "T"],
  ["🆄", "U"],
  ["🆅", "V"],
  ["🆆", "W"],
  ["🆇", "X"],
  ["🆈", "Y"],
  ["🆉", "Z"],
  // Dashes not covered by Dash_Punctuation category
  ["−", "-"],
  // U+2212 Minus Sign (Mathematical Operators category)
  ["⁓", "-"]
  // U+2053 Swung Dash (Other_Punctuation category)
], builtinReplacements = new Map(replacements), danishNorwegianReplacements = [
  ["æ", "ae"],
  ["Æ", "Ae"],
  ["ø", "oe"],
  ["Ø", "Oe"],
  ["å", "aa"],
  ["Å", "Aa"]
], localeReplacements = {
  // Swedish
  sv: [
    ["ä", "a"],
    ["Ä", "A"],
    ["ö", "o"],
    ["Ö", "O"],
    ["å", "a"],
    ["Å", "A"]
  ],
  // Danish
  da: danishNorwegianReplacements,
  // Norwegian Bokmål
  nb: danishNorwegianReplacements,
  // German
  de: [
    ["ä", "ae"],
    ["Ä", "Ae"],
    ["ö", "oe"],
    ["Ö", "Oe"],
    ["ü", "ue"],
    ["Ü", "Ue"],
    ["ß", "ss"],
    ["ẞ", "Ss"]
  ],
  // Turkish
  tr: [
    ["â", "a"],
    ["Â", "A"],
    ["ö", "o"],
    ["Ö", "O"],
    ["ü", "u"],
    ["Ü", "U"]
  ],
  // Hungarian
  hu: [
    ["ű", "u"],
    ["Ű", "U"],
    ["ö", "o"],
    ["Ö", "O"],
    ["ü", "u"],
    ["Ü", "U"],
    ["á", "a"],
    ["Á", "A"],
    ["é", "e"],
    ["É", "E"],
    ["í", "i"],
    ["Í", "I"],
    ["ó", "o"],
    ["Ó", "O"],
    ["ú", "u"],
    ["Ú", "U"]
  ],
  // Serbian
  sr: [
    ["ђ", "dj"],
    ["Ђ", "Dj"],
    ["џ", "dz"],
    ["Џ", "Dz"],
    ["љ", "lj"],
    ["Љ", "Lj"],
    ["њ", "nj"],
    ["Њ", "Nj"],
    ["ћ", "c"],
    ["Ћ", "C"],
    ["ч", "ch"],
    ["Ч", "Ch"],
    ["ш", "sh"],
    ["Ш", "Sh"],
    ["ж", "zh"],
    ["Ж", "Zh"]
  ]
};
for (const n of Object.keys(localeReplacements))
  localeReplacements[n] = new Map(localeReplacements[n]);
const doCustomReplacements = (n, t) => {
  for (const [g, d] of t)
    n = n.replaceAll(g, d);
  return n;
}, getLocaleReplacements = (n) => {
  if (!n)
    return;
  const t = n.toLowerCase().replace(/^no(-|$)/, "nb$1");
  return localeReplacements[t] || localeReplacements[t.split("-")[0]] || void 0;
};
function transliterate(n, t) {
  if (typeof n != "string")
    throw new TypeError(`Expected a string, got \`${typeof n}\``);
  t = {
    customReplacements: [],
    ...t
  };
  const g = getLocaleReplacements(t.locale);
  let d = builtinReplacements;
  const k = t.customReplacements.length > 0 || t.customReplacements.size > 0;
  if (g || k) {
    if (d = new Map(builtinReplacements), g)
      for (const [H, AA] of g)
        d.set(H, AA);
    for (const [H, AA] of t.customReplacements)
      d.set(H, AA);
  }
  return n = n.normalize(), n = doCustomReplacements(n, d), n = n.normalize("NFD").replaceAll(new RegExp("\\p{Diacritic}", "gu"), "").normalize(), n = n.replaceAll(new RegExp("\\p{Dash_Punctuation}", "gu"), "-"), n;
}
const overridableReplacements = [
  ["&", " and "],
  ["🦄", " unicorn "],
  ["♥", " love "]
], decamelize = (n) => n.replaceAll(/([A-Z]{2,})(\d+)/g, "$1 $2").replaceAll(/([a-z\d]+)([A-Z]{2,})/g, "$1 $2").replaceAll(/([a-z\d])([A-Z])/g, "$1 $2").replaceAll(/([A-Z]+)([A-Z][a-rt-z\d]+)/g, "$1 $2"), removeMootSeparators = (n, t) => {
  const g = escapeStringRegexp$1(t);
  return n.replaceAll(new RegExp(`(?:${g}){2,}`, "g"), t).replaceAll(new RegExp(`^(?:${g})|(?:${g})$`, "g"), "");
}, buildPatternSlug = (n) => {
  let t = String.raw`a-z\d`;
  if (t += n.lowercase ? "" : "A-Z", n.transliterate === !1 && (t += String.raw`\p{L}\p{N}`), n.preserveCharacters.length > 0)
    for (const d of n.preserveCharacters) {
      if (d === n.separator)
        throw new Error(`The separator character \`${n.separator}\` cannot be included in preserved characters: ${n.preserveCharacters}`);
      t += escapeStringRegexp$1(d);
    }
  const g = n.transliterate ? "g" : "gu";
  return new RegExp(`[^${t}]+`, g);
};
function slugify(n, t) {
  if (typeof n != "string")
    throw new TypeError(`Expected a string, got \`${typeof n}\``);
  t = {
    separator: "-",
    lowercase: !0,
    decamelize: !0,
    customReplacements: [],
    preserveLeadingUnderscore: !1,
    preserveTrailingDash: !1,
    preserveCharacters: [],
    transliterate: !0,
    ...t
  };
  const g = t.preserveLeadingUnderscore && n.startsWith("_"), d = t.preserveTrailingDash && n.endsWith("-");
  if (t.transliterate) {
    const H = new Map([
      ...overridableReplacements,
      ...t.customReplacements
    ]);
    n = transliterate(n, { customReplacements: H, locale: t.locale });
  } else if (t.customReplacements.length > 0)
    for (const [H, AA] of t.customReplacements)
      n = n.replaceAll(H, AA);
  t.decamelize && (n = decamelize(n));
  const k = buildPatternSlug(t);
  return t.lowercase && (n = t.locale ? n.toLocaleLowerCase(t.locale) : n.toLowerCase()), n = n.replaceAll(/([a-zA-Z\d]+)['\u2019]([ts])(\s|$)/g, "$1$2$3"), n = n.replace(k, t.separator), n = n.replaceAll("\\", ""), t.separator && (n = removeMootSeparators(n, t.separator)), g && (n = `_${n}`), d && (n = `${n}-`), n;
}
var last_1, hasRequiredLast;
function requireLast() {
  if (hasRequiredLast) return last_1;
  hasRequiredLast = 1;
  function n(t) {
    var g = t == null ? 0 : t.length;
    return g ? t[g - 1] : void 0;
  }
  return last_1 = n, last_1;
}
var _baseSlice, hasRequired_baseSlice;
function require_baseSlice() {
  if (hasRequired_baseSlice) return _baseSlice;
  hasRequired_baseSlice = 1;
  function n(t, g, d) {
    var k = -1, H = t.length;
    g < 0 && (g = -g > H ? 0 : H + g), d = d > H ? H : d, d < 0 && (d += H), H = g > d ? 0 : d - g >>> 0, g >>>= 0;
    for (var AA = Array(H); ++k < H; )
      AA[k] = t[k + g];
    return AA;
  }
  return _baseSlice = n, _baseSlice;
}
var _parent, hasRequired_parent;
function require_parent() {
  if (hasRequired_parent) return _parent;
  hasRequired_parent = 1;
  var n = require_baseGet(), t = require_baseSlice();
  function g(d, k) {
    return k.length < 2 ? d : n(d, t(k, 0, -1));
  }
  return _parent = g, _parent;
}
var _baseUnset, hasRequired_baseUnset;
function require_baseUnset() {
  if (hasRequired_baseUnset) return _baseUnset;
  hasRequired_baseUnset = 1;
  var n = require_castPath(), t = requireLast(), g = require_parent(), d = require_toKey();
  function k(H, AA) {
    return AA = n(AA, H), H = g(H, AA), H == null || delete H[d(t(AA))];
  }
  return _baseUnset = k, _baseUnset;
}
var _customOmitClone, hasRequired_customOmitClone;
function require_customOmitClone() {
  if (hasRequired_customOmitClone) return _customOmitClone;
  hasRequired_customOmitClone = 1;
  var n = requireIsPlainObject();
  function t(g) {
    return n(g) ? void 0 : g;
  }
  return _customOmitClone = t, _customOmitClone;
}
var _isFlattenable, hasRequired_isFlattenable;
function require_isFlattenable() {
  if (hasRequired_isFlattenable) return _isFlattenable;
  hasRequired_isFlattenable = 1;
  var n = require_Symbol(), t = requireIsArguments(), g = requireIsArray(), d = n ? n.isConcatSpreadable : void 0;
  function k(H) {
    return g(H) || t(H) || !!(d && H && H[d]);
  }
  return _isFlattenable = k, _isFlattenable;
}
var _baseFlatten, hasRequired_baseFlatten;
function require_baseFlatten() {
  if (hasRequired_baseFlatten) return _baseFlatten;
  hasRequired_baseFlatten = 1;
  var n = require_arrayPush(), t = require_isFlattenable();
  function g(d, k, H, AA, gA) {
    var IA = -1, CA = d.length;
    for (H || (H = t), gA || (gA = []); ++IA < CA; ) {
      var BA = d[IA];
      k > 0 && H(BA) ? k > 1 ? g(BA, k - 1, H, AA, gA) : n(gA, BA) : AA || (gA[gA.length] = BA);
    }
    return gA;
  }
  return _baseFlatten = g, _baseFlatten;
}
var flatten_1, hasRequiredFlatten;
function requireFlatten() {
  if (hasRequiredFlatten) return flatten_1;
  hasRequiredFlatten = 1;
  var n = require_baseFlatten();
  function t(g) {
    var d = g == null ? 0 : g.length;
    return d ? n(g, 1) : [];
  }
  return flatten_1 = t, flatten_1;
}
var _flatRest, hasRequired_flatRest;
function require_flatRest() {
  if (hasRequired_flatRest) return _flatRest;
  hasRequired_flatRest = 1;
  var n = requireFlatten(), t = require_overRest(), g = require_setToString();
  function d(k) {
    return g(t(k, void 0, n), k + "");
  }
  return _flatRest = d, _flatRest;
}
var omit_1, hasRequiredOmit;
function requireOmit() {
  if (hasRequiredOmit) return omit_1;
  hasRequiredOmit = 1;
  var n = require_arrayMap(), t = require_baseClone(), g = require_baseUnset(), d = require_castPath(), k = require_copyObject(), H = require_customOmitClone(), AA = require_flatRest(), gA = require_getAllKeysIn(), IA = 1, CA = 2, BA = 4, eA = AA(function(iA, QA) {
    var tA = {};
    if (iA == null)
      return tA;
    var oA = !1;
    QA = n(QA, function(aA) {
      return aA = d(aA, iA), oA || (oA = aA.length > 1), aA;
    }), k(iA, gA(iA), tA), oA && (tA = t(tA, IA | CA | BA, H));
    for (var EA = QA.length; EA--; )
      g(tA, QA[EA]);
    return tA;
  });
  return omit_1 = eA, omit_1;
}
var omitExports = requireOmit();
const omit$1 = /* @__PURE__ */ getDefaultExportFromCjs$2(omitExports);
function escapeStringRegexp(n) {
  if (typeof n != "string")
    throw new TypeError("Expected a string");
  return n.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const convert = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(n) {
    if (n == null)
      return ok$2;
    if (typeof n == "function")
      return castFactory$1(n);
    if (typeof n == "object")
      return Array.isArray(n) ? anyFactory$1(n) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        propertiesFactory(
          /** @type {Props} */
          n
        )
      );
    if (typeof n == "string")
      return typeFactory(n);
    throw new Error("Expected function, string, or object as test");
  })
);
function anyFactory$1(n) {
  const t = [];
  let g = -1;
  for (; ++g < n.length; )
    t[g] = convert(n[g]);
  return castFactory$1(d);
  function d(...k) {
    let H = -1;
    for (; ++H < t.length; )
      if (t[H].apply(this, k)) return !0;
    return !1;
  }
}
function propertiesFactory(n) {
  const t = (
    /** @type {Record<string, unknown>} */
    n
  );
  return castFactory$1(g);
  function g(d) {
    const k = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      d
    );
    let H;
    for (H in n)
      if (k[H] !== t[H]) return !1;
    return !0;
  }
}
function typeFactory(n) {
  return castFactory$1(t);
  function t(g) {
    return g && g.type === n;
  }
}
function castFactory$1(n) {
  return t;
  function t(g, d, k) {
    return !!(looksLikeANode(g) && n.call(
      this,
      g,
      typeof d == "number" ? d : void 0,
      k || void 0
    ));
  }
}
function ok$2() {
  return !0;
}
function looksLikeANode(n) {
  return n !== null && typeof n == "object" && "type" in n;
}
function color$4(n) {
  return n;
}
const empty$1 = [], CONTINUE = !0, EXIT = !1, SKIP$3 = "skip";
function visitParents(n, t, g, d) {
  let k;
  typeof t == "function" && typeof g != "function" ? (d = g, g = t) : k = t;
  const H = convert(k), AA = d ? -1 : 1;
  gA(n, void 0, [])();
  function gA(IA, CA, BA) {
    const eA = (
      /** @type {Record<string, unknown>} */
      IA && typeof IA == "object" ? IA : {}
    );
    if (typeof eA.type == "string") {
      const QA = (
        // `hast`
        typeof eA.tagName == "string" ? eA.tagName : (
          // `xast`
          typeof eA.name == "string" ? eA.name : void 0
        )
      );
      Object.defineProperty(iA, "name", {
        value: "node (" + (IA.type + (QA ? "<" + QA + ">" : "")) + ")"
      });
    }
    return iA;
    function iA() {
      let QA = empty$1, tA, oA, EA;
      if ((!t || H(IA, CA, BA[BA.length - 1] || void 0)) && (QA = toResult(g(IA, BA)), QA[0] === EXIT))
        return QA;
      if ("children" in IA && IA.children) {
        const aA = (
          /** @type {UnistParent} */
          IA
        );
        if (aA.children && QA[0] !== SKIP$3)
          for (oA = (d ? aA.children.length : -1) + AA, EA = BA.concat(aA); oA > -1 && oA < aA.children.length; ) {
            const nA = aA.children[oA];
            if (tA = gA(nA, oA, EA)(), tA[0] === EXIT)
              return tA;
            oA = typeof tA[1] == "number" ? tA[1] : oA + AA;
          }
      }
      return QA;
    }
  }
}
function toResult(n) {
  return Array.isArray(n) ? n : typeof n == "number" ? [CONTINUE, n] : n == null ? empty$1 : [n];
}
function findAndReplace(n, t, g) {
  const k = convert((g || {}).ignore || []), H = toPairs(t);
  let AA = -1;
  for (; ++AA < H.length; )
    visitParents(n, "text", gA);
  function gA(CA, BA) {
    let eA = -1, iA;
    for (; ++eA < BA.length; ) {
      const QA = BA[eA], tA = iA ? iA.children : void 0;
      if (k(
        QA,
        tA ? tA.indexOf(QA) : void 0,
        iA
      ))
        return;
      iA = QA;
    }
    if (iA)
      return IA(CA, BA);
  }
  function IA(CA, BA) {
    const eA = BA[BA.length - 1], iA = H[AA][0], QA = H[AA][1];
    let tA = 0;
    const EA = eA.children.indexOf(CA);
    let aA = !1, nA = [];
    iA.lastIndex = 0;
    let lA = iA.exec(CA.value);
    for (; lA; ) {
      const cA = lA.index, sA = {
        index: lA.index,
        input: lA.input,
        stack: [...BA, CA]
      };
      let rA = QA(...lA, sA);
      if (typeof rA == "string" && (rA = rA.length > 0 ? { type: "text", value: rA } : void 0), rA === !1 ? iA.lastIndex = cA + 1 : (tA !== cA && nA.push({
        type: "text",
        value: CA.value.slice(tA, cA)
      }), Array.isArray(rA) ? nA.push(...rA) : rA && nA.push(rA), tA = cA + lA[0].length, aA = !0), !iA.global)
        break;
      lA = iA.exec(CA.value);
    }
    return aA ? (tA < CA.value.length && nA.push({ type: "text", value: CA.value.slice(tA) }), eA.children.splice(EA, 1, ...nA)) : nA = [CA], EA + nA.length;
  }
}
function toPairs(n) {
  const t = [];
  if (!Array.isArray(n))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const g = !n[0] || Array.isArray(n[0]) ? n : [n];
  let d = -1;
  for (; ++d < g.length; ) {
    const k = g[d];
    t.push([toExpression(k[0]), toFunction(k[1])]);
  }
  return t;
}
function toExpression(n) {
  return typeof n == "string" ? new RegExp(escapeStringRegexp(n), "g") : n;
}
function toFunction(n) {
  return typeof n == "function" ? n : function() {
    return n;
  };
}
var propTypes$1 = { exports: {} };
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var n = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
  function d(H) {
    if (H == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(H);
  }
  function k() {
    try {
      if (!Object.assign)
        return !1;
      var H = new String("abc");
      if (H[5] = "de", Object.getOwnPropertyNames(H)[0] === "5")
        return !1;
      for (var AA = {}, gA = 0; gA < 10; gA++)
        AA["_" + String.fromCharCode(gA)] = gA;
      var IA = Object.getOwnPropertyNames(AA).map(function(BA) {
        return AA[BA];
      });
      if (IA.join("") !== "0123456789")
        return !1;
      var CA = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(BA) {
        CA[BA] = BA;
      }), Object.keys(Object.assign({}, CA)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = k() ? Object.assign : function(H, AA) {
    for (var gA, IA = d(H), CA, BA = 1; BA < arguments.length; BA++) {
      gA = Object(arguments[BA]);
      for (var eA in gA)
        t.call(gA, eA) && (IA[eA] = gA[eA]);
      if (n) {
        CA = n(gA);
        for (var iA = 0; iA < CA.length; iA++)
          g.call(gA, CA[iA]) && (IA[CA[iA]] = gA[CA[iA]]);
      }
    }
    return IA;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = n, ReactPropTypesSecret_1;
}
var has$4, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has$4 = Function.call.bind(Object.prototype.hasOwnProperty)), has$4;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var n = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ requireReactPropTypesSecret(), g = {}, d = /* @__PURE__ */ requireHas();
    n = function(H) {
      var AA = "Warning: " + H;
      typeof console < "u" && console.error(AA);
      try {
        throw new Error(AA);
      } catch {
      }
    };
  }
  function k(H, AA, gA, IA, CA) {
    if (process.env.NODE_ENV !== "production") {
      for (var BA in H)
        if (d(H, BA)) {
          var eA;
          try {
            if (typeof H[BA] != "function") {
              var iA = Error(
                (IA || "React class") + ": " + gA + " type `" + BA + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof H[BA] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw iA.name = "Invariant Violation", iA;
            }
            eA = H[BA](AA, BA, IA, gA, null, t);
          } catch (tA) {
            eA = tA;
          }
          if (eA && !(eA instanceof Error) && n(
            (IA || "React class") + ": type specification of " + gA + " `" + BA + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof eA + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), eA instanceof Error && !(eA.message in g)) {
            g[eA.message] = !0;
            var QA = CA ? CA() : "";
            n(
              "Failed " + gA + " type: " + eA.message + (QA ?? "")
            );
          }
        }
    }
  }
  return k.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (g = {});
  }, checkPropTypes_1 = k, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var n = requireReactIs$1(), t = requireObjectAssign(), g = /* @__PURE__ */ requireReactPropTypesSecret(), d = /* @__PURE__ */ requireHas(), k = /* @__PURE__ */ requireCheckPropTypes(), H = function() {
  };
  process.env.NODE_ENV !== "production" && (H = function(gA) {
    var IA = "Warning: " + gA;
    typeof console < "u" && console.error(IA);
    try {
      throw new Error(IA);
    } catch {
    }
  });
  function AA() {
    return null;
  }
  return factoryWithTypeCheckers = function(gA, IA) {
    var CA = typeof Symbol == "function" && Symbol.iterator, BA = "@@iterator";
    function eA(NA) {
      var zA = NA && (CA && NA[CA] || NA[BA]);
      if (typeof zA == "function")
        return zA;
    }
    var iA = "<<anonymous>>", QA = {
      array: aA("array"),
      bigint: aA("bigint"),
      bool: aA("boolean"),
      func: aA("function"),
      number: aA("number"),
      object: aA("object"),
      string: aA("string"),
      symbol: aA("symbol"),
      any: nA(),
      arrayOf: lA,
      element: cA(),
      elementType: sA(),
      instanceOf: rA,
      node: GA(),
      objectOf: hA,
      oneOf: uA,
      oneOfType: dA,
      shape: wA,
      exact: bA
    };
    function tA(NA, zA) {
      return NA === zA ? NA !== 0 || 1 / NA === 1 / zA : NA !== NA && zA !== zA;
    }
    function oA(NA, zA) {
      this.message = NA, this.data = zA && typeof zA == "object" ? zA : {}, this.stack = "";
    }
    oA.prototype = Error.prototype;
    function EA(NA) {
      if (process.env.NODE_ENV !== "production")
        var zA = {}, XA = 0;
      function fA(Cg, Ig, gg, og, eg, kA, YA) {
        if (og = og || iA, kA = kA || gg, YA !== g) {
          if (IA) {
            var RA = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw RA.name = "Invariant Violation", RA;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var FA = og + ":" + gg;
            !zA[FA] && // Avoid spamming the console because they are often not actionable except for lib authors
            XA < 3 && (H(
              "You are manually calling a React.PropTypes validation function for the `" + kA + "` prop on `" + og + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), zA[FA] = !0, XA++);
          }
        }
        return Ig[gg] == null ? Cg ? Ig[gg] === null ? new oA("The " + eg + " `" + kA + "` is marked as required " + ("in `" + og + "`, but its value is `null`.")) : new oA("The " + eg + " `" + kA + "` is marked as required in " + ("`" + og + "`, but its value is `undefined`.")) : null : NA(Ig, gg, og, eg, kA);
      }
      var vA = fA.bind(null, !1);
      return vA.isRequired = fA.bind(null, !0), vA;
    }
    function aA(NA) {
      function zA(XA, fA, vA, Cg, Ig, gg) {
        var og = XA[fA], eg = MA(og);
        if (eg !== NA) {
          var kA = LA(og);
          return new oA(
            "Invalid " + Cg + " `" + Ig + "` of type " + ("`" + kA + "` supplied to `" + vA + "`, expected ") + ("`" + NA + "`."),
            { expectedType: NA }
          );
        }
        return null;
      }
      return EA(zA);
    }
    function nA() {
      return EA(AA);
    }
    function lA(NA) {
      function zA(XA, fA, vA, Cg, Ig) {
        if (typeof NA != "function")
          return new oA("Property `" + Ig + "` of component `" + vA + "` has invalid PropType notation inside arrayOf.");
        var gg = XA[fA];
        if (!Array.isArray(gg)) {
          var og = MA(gg);
          return new oA("Invalid " + Cg + " `" + Ig + "` of type " + ("`" + og + "` supplied to `" + vA + "`, expected an array."));
        }
        for (var eg = 0; eg < gg.length; eg++) {
          var kA = NA(gg, eg, vA, Cg, Ig + "[" + eg + "]", g);
          if (kA instanceof Error)
            return kA;
        }
        return null;
      }
      return EA(zA);
    }
    function cA() {
      function NA(zA, XA, fA, vA, Cg) {
        var Ig = zA[XA];
        if (!gA(Ig)) {
          var gg = MA(Ig);
          return new oA("Invalid " + vA + " `" + Cg + "` of type " + ("`" + gg + "` supplied to `" + fA + "`, expected a single ReactElement."));
        }
        return null;
      }
      return EA(NA);
    }
    function sA() {
      function NA(zA, XA, fA, vA, Cg) {
        var Ig = zA[XA];
        if (!n.isValidElementType(Ig)) {
          var gg = MA(Ig);
          return new oA("Invalid " + vA + " `" + Cg + "` of type " + ("`" + gg + "` supplied to `" + fA + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return EA(NA);
    }
    function rA(NA) {
      function zA(XA, fA, vA, Cg, Ig) {
        if (!(XA[fA] instanceof NA)) {
          var gg = NA.name || iA, og = TA(XA[fA]);
          return new oA("Invalid " + Cg + " `" + Ig + "` of type " + ("`" + og + "` supplied to `" + vA + "`, expected ") + ("instance of `" + gg + "`."));
        }
        return null;
      }
      return EA(zA);
    }
    function uA(NA) {
      if (!Array.isArray(NA))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? H(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : H("Invalid argument supplied to oneOf, expected an array.")), AA;
      function zA(XA, fA, vA, Cg, Ig) {
        for (var gg = XA[fA], og = 0; og < NA.length; og++)
          if (tA(gg, NA[og]))
            return null;
        var eg = JSON.stringify(NA, function(YA, RA) {
          var FA = LA(RA);
          return FA === "symbol" ? String(RA) : RA;
        });
        return new oA("Invalid " + Cg + " `" + Ig + "` of value `" + String(gg) + "` " + ("supplied to `" + vA + "`, expected one of " + eg + "."));
      }
      return EA(zA);
    }
    function hA(NA) {
      function zA(XA, fA, vA, Cg, Ig) {
        if (typeof NA != "function")
          return new oA("Property `" + Ig + "` of component `" + vA + "` has invalid PropType notation inside objectOf.");
        var gg = XA[fA], og = MA(gg);
        if (og !== "object")
          return new oA("Invalid " + Cg + " `" + Ig + "` of type " + ("`" + og + "` supplied to `" + vA + "`, expected an object."));
        for (var eg in gg)
          if (d(gg, eg)) {
            var kA = NA(gg, eg, vA, Cg, Ig + "." + eg, g);
            if (kA instanceof Error)
              return kA;
          }
        return null;
      }
      return EA(zA);
    }
    function dA(NA) {
      if (!Array.isArray(NA))
        return process.env.NODE_ENV !== "production" && H("Invalid argument supplied to oneOfType, expected an instance of array."), AA;
      for (var zA = 0; zA < NA.length; zA++) {
        var XA = NA[zA];
        if (typeof XA != "function")
          return H(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + xA(XA) + " at index " + zA + "."
          ), AA;
      }
      function fA(vA, Cg, Ig, gg, og) {
        for (var eg = [], kA = 0; kA < NA.length; kA++) {
          var YA = NA[kA], RA = YA(vA, Cg, Ig, gg, og, g);
          if (RA == null)
            return null;
          RA.data && d(RA.data, "expectedType") && eg.push(RA.data.expectedType);
        }
        var FA = eg.length > 0 ? ", expected one of type [" + eg.join(", ") + "]" : "";
        return new oA("Invalid " + gg + " `" + og + "` supplied to " + ("`" + Ig + "`" + FA + "."));
      }
      return EA(fA);
    }
    function GA() {
      function NA(zA, XA, fA, vA, Cg) {
        return yA(zA[XA]) ? null : new oA("Invalid " + vA + " `" + Cg + "` supplied to " + ("`" + fA + "`, expected a ReactNode."));
      }
      return EA(NA);
    }
    function DA(NA, zA, XA, fA, vA) {
      return new oA(
        (NA || "React class") + ": " + zA + " type `" + XA + "." + fA + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + vA + "`."
      );
    }
    function wA(NA) {
      function zA(XA, fA, vA, Cg, Ig) {
        var gg = XA[fA], og = MA(gg);
        if (og !== "object")
          return new oA("Invalid " + Cg + " `" + Ig + "` of type `" + og + "` " + ("supplied to `" + vA + "`, expected `object`."));
        for (var eg in NA) {
          var kA = NA[eg];
          if (typeof kA != "function")
            return DA(vA, Cg, Ig, eg, LA(kA));
          var YA = kA(gg, eg, vA, Cg, Ig + "." + eg, g);
          if (YA)
            return YA;
        }
        return null;
      }
      return EA(zA);
    }
    function bA(NA) {
      function zA(XA, fA, vA, Cg, Ig) {
        var gg = XA[fA], og = MA(gg);
        if (og !== "object")
          return new oA("Invalid " + Cg + " `" + Ig + "` of type `" + og + "` " + ("supplied to `" + vA + "`, expected `object`."));
        var eg = t({}, XA[fA], NA);
        for (var kA in eg) {
          var YA = NA[kA];
          if (d(NA, kA) && typeof YA != "function")
            return DA(vA, Cg, Ig, kA, LA(YA));
          if (!YA)
            return new oA(
              "Invalid " + Cg + " `" + Ig + "` key `" + kA + "` supplied to `" + vA + "`.\nBad object: " + JSON.stringify(XA[fA], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(NA), null, "  ")
            );
          var RA = YA(gg, kA, vA, Cg, Ig + "." + kA, g);
          if (RA)
            return RA;
        }
        return null;
      }
      return EA(zA);
    }
    function yA(NA) {
      switch (typeof NA) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !NA;
        case "object":
          if (Array.isArray(NA))
            return NA.every(yA);
          if (NA === null || gA(NA))
            return !0;
          var zA = eA(NA);
          if (zA) {
            var XA = zA.call(NA), fA;
            if (zA !== NA.entries) {
              for (; !(fA = XA.next()).done; )
                if (!yA(fA.value))
                  return !1;
            } else
              for (; !(fA = XA.next()).done; ) {
                var vA = fA.value;
                if (vA && !yA(vA[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function pA(NA, zA) {
      return NA === "symbol" ? !0 : zA ? zA["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && zA instanceof Symbol : !1;
    }
    function MA(NA) {
      var zA = typeof NA;
      return Array.isArray(NA) ? "array" : NA instanceof RegExp ? "object" : pA(zA, NA) ? "symbol" : zA;
    }
    function LA(NA) {
      if (typeof NA > "u" || NA === null)
        return "" + NA;
      var zA = MA(NA);
      if (zA === "object") {
        if (NA instanceof Date)
          return "date";
        if (NA instanceof RegExp)
          return "regexp";
      }
      return zA;
    }
    function xA(NA) {
      var zA = LA(NA);
      switch (zA) {
        case "array":
        case "object":
          return "an " + zA;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + zA;
        default:
          return zA;
      }
    }
    function TA(NA) {
      return !NA.constructor || !NA.constructor.name ? iA : NA.constructor.name;
    }
    return QA.checkPropTypes = k, QA.resetWarningCache = k.resetWarningCache, QA.PropTypes = QA, QA;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var n = /* @__PURE__ */ requireReactPropTypesSecret();
  function t() {
  }
  function g() {
  }
  return g.resetWarningCache = t, factoryWithThrowingShims = function() {
    function d(AA, gA, IA, CA, BA, eA) {
      if (eA !== n) {
        var iA = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw iA.name = "Invariant Violation", iA;
      }
    }
    d.isRequired = d;
    function k() {
      return d;
    }
    var H = {
      array: d,
      bigint: d,
      bool: d,
      func: d,
      number: d,
      object: d,
      string: d,
      symbol: d,
      any: d,
      arrayOf: k,
      element: d,
      elementType: d,
      instanceOf: k,
      node: d,
      objectOf: k,
      oneOf: k,
      oneOfType: k,
      shape: k,
      exact: k,
      checkPropTypes: g,
      resetWarningCache: t
    };
    return H.PropTypes = H, H;
  }, factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes$1.exports;
  if (hasRequiredPropTypes = 1, process.env.NODE_ENV !== "production") {
    var n = requireReactIs$1(), t = !0;
    propTypes$1.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(n.isElement, t);
  } else
    propTypes$1.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  return propTypes$1.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs$2(propTypesExports);
function _extends$A() {
  return _extends$A = Object.assign || function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$A.apply(this, arguments);
}
function _objectWithoutProperties$o(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$o(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$o(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
var Check$1 = forwardRef(function(n, t) {
  var g = n.color, d = g === void 0 ? "currentColor" : g, k = n.size, H = k === void 0 ? 24 : k, AA = _objectWithoutProperties$o(n, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$A({
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    width: H,
    height: H,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: d,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, AA), /* @__PURE__ */ React__default.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }));
});
Check$1.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Check$1.displayName = "Check";
function _extends$z() {
  return _extends$z = Object.assign || function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$z.apply(this, arguments);
}
function _objectWithoutProperties$n(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$n(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$n(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
var ChevronLeft = forwardRef(function(n, t) {
  var g = n.color, d = g === void 0 ? "currentColor" : g, k = n.size, H = k === void 0 ? 24 : k, AA = _objectWithoutProperties$n(n, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$z({
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    width: H,
    height: H,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: d,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, AA), /* @__PURE__ */ React__default.createElement("polyline", {
    points: "15 18 9 12 15 6"
  }));
});
ChevronLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronLeft.displayName = "ChevronLeft";
function _extends$y() {
  return _extends$y = Object.assign || function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$y.apply(this, arguments);
}
function _objectWithoutProperties$m(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$m(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$m(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
var Copy = forwardRef(function(n, t) {
  var g = n.color, d = g === void 0 ? "currentColor" : g, k = n.size, H = k === void 0 ? 24 : k, AA = _objectWithoutProperties$m(n, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$y({
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    width: H,
    height: H,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: d,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, AA), /* @__PURE__ */ React__default.createElement("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
  }));
});
Copy.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Copy.displayName = "Copy";
function _extends$x() {
  return _extends$x = Object.assign || function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$x.apply(this, arguments);
}
function _objectWithoutProperties$l(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$l(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$l(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
var HelpCircle = forwardRef(function(n, t) {
  var g = n.color, d = g === void 0 ? "currentColor" : g, k = n.size, H = k === void 0 ? 24 : k, AA = _objectWithoutProperties$l(n, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$x({
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    width: H,
    height: H,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: d,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, AA), /* @__PURE__ */ React__default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
  }), /* @__PURE__ */ React__default.createElement("line", {
    x1: "12",
    y1: "17",
    x2: "12.01",
    y2: "17"
  }));
});
HelpCircle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
HelpCircle.displayName = "HelpCircle";
function _extends$w() {
  return _extends$w = Object.assign || function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$w.apply(this, arguments);
}
function _objectWithoutProperties$k(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$k(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$k(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
var Link2 = forwardRef(function(n, t) {
  var g = n.color, d = g === void 0 ? "currentColor" : g, k = n.size, H = k === void 0 ? 24 : k, AA = _objectWithoutProperties$k(n, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$w({
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    width: H,
    height: H,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: d,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, AA), /* @__PURE__ */ React__default.createElement("path", {
    d: "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
  }), /* @__PURE__ */ React__default.createElement("line", {
    x1: "8",
    y1: "12",
    x2: "16",
    y2: "12"
  }));
});
Link2.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Link2.displayName = "Link2";
function ok$1() {
}
function unreachable() {
}
function parse$a(n) {
  const t = [], g = String(n || "");
  let d = g.indexOf(","), k = 0, H = !1;
  for (; !H; ) {
    d === -1 && (d = g.length, H = !0);
    const AA = g.slice(k, d).trim();
    (AA || !H) && t.push(AA), k = d + 1, d = g.indexOf(",", k);
  }
  return t;
}
function stringify$5(n, t) {
  const g = {};
  return (n[n.length - 1] === "" ? [...n, ""] : n).join(
    (g.padRight ? " " : "") + "," + (g.padLeft === !1 ? "" : " ")
  ).trim();
}
const nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, emptyOptions$7 = {};
function name(n, t) {
  return (emptyOptions$7.jsx ? nameReJsx : nameRe).test(n);
}
const re$3 = /[ \t\n\f\r]/g;
function whitespace(n) {
  return typeof n == "object" ? n.type === "text" ? empty(n.value) : !1 : empty(n);
}
function empty(n) {
  return n.replace(re$3, "") === "";
}
let Schema$1 = class {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, g, d) {
    this.normal = g, this.property = t, d && (this.space = d);
  }
};
Schema$1.prototype.normal = {};
Schema$1.prototype.property = {};
Schema$1.prototype.space = void 0;
function merge$7(n, t) {
  const g = {}, d = {};
  for (const k of n)
    Object.assign(g, k.property), Object.assign(d, k.normal);
  return new Schema$1(g, d, t);
}
function normalize$5(n) {
  return n.toLowerCase();
}
let Info$3 = class {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, g) {
    this.attribute = g, this.property = t;
  }
};
Info$3.prototype.attribute = "";
Info$3.prototype.booleanish = !1;
Info$3.prototype.boolean = !1;
Info$3.prototype.commaOrSpaceSeparated = !1;
Info$3.prototype.commaSeparated = !1;
Info$3.prototype.defined = !1;
Info$3.prototype.mustUseProperty = !1;
Info$3.prototype.number = !1;
Info$3.prototype.overloadedBoolean = !1;
Info$3.prototype.property = "";
Info$3.prototype.spaceSeparated = !1;
Info$3.prototype.space = void 0;
let powers$2 = 0;
const boolean$1 = increment$2(), booleanish$1 = increment$2(), overloadedBoolean$1 = increment$2(), number$8 = increment$2(), spaceSeparated$1 = increment$2(), commaSeparated$1 = increment$2(), commaOrSpaceSeparated$1 = increment$2();
function increment$2() {
  return 2 ** ++powers$2;
}
const types$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: boolean$1,
  booleanish: booleanish$1,
  commaOrSpaceSeparated: commaOrSpaceSeparated$1,
  commaSeparated: commaSeparated$1,
  number: number$8,
  overloadedBoolean: overloadedBoolean$1,
  spaceSeparated: spaceSeparated$1
}, Symbol.toStringTag, { value: "Module" })), checks$1 = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(types$3)
);
let DefinedInfo$1 = class extends Info$3 {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, g, d, k) {
    let H = -1;
    if (super(t, g), mark$2(this, "space", k), typeof d == "number")
      for (; ++H < checks$1.length; ) {
        const AA = checks$1[H];
        mark$2(this, checks$1[H], (d & types$3[AA]) === types$3[AA]);
      }
  }
};
DefinedInfo$1.prototype.defined = !0;
function mark$2(n, t, g) {
  g && (n[t] = g);
}
function create$4(n) {
  const t = {}, g = {};
  for (const [d, k] of Object.entries(n.properties)) {
    const H = new DefinedInfo$1(
      d,
      n.transform(n.attributes || {}, d),
      k,
      n.space
    );
    n.mustUseProperty && n.mustUseProperty.includes(d) && (H.mustUseProperty = !0), t[d] = H, g[normalize$5(d)] = d, g[normalize$5(H.attribute)] = d;
  }
  return new Schema$1(t, g, n.space);
}
const aria$3 = create$4({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish$1,
    ariaAutoComplete: null,
    ariaBusy: booleanish$1,
    ariaChecked: booleanish$1,
    ariaColCount: number$8,
    ariaColIndex: number$8,
    ariaColSpan: number$8,
    ariaControls: spaceSeparated$1,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated$1,
    ariaDetails: null,
    ariaDisabled: booleanish$1,
    ariaDropEffect: spaceSeparated$1,
    ariaErrorMessage: null,
    ariaExpanded: booleanish$1,
    ariaFlowTo: spaceSeparated$1,
    ariaGrabbed: booleanish$1,
    ariaHasPopup: null,
    ariaHidden: booleanish$1,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated$1,
    ariaLevel: number$8,
    ariaLive: null,
    ariaModal: booleanish$1,
    ariaMultiLine: booleanish$1,
    ariaMultiSelectable: booleanish$1,
    ariaOrientation: null,
    ariaOwns: spaceSeparated$1,
    ariaPlaceholder: null,
    ariaPosInSet: number$8,
    ariaPressed: booleanish$1,
    ariaReadOnly: booleanish$1,
    ariaRelevant: null,
    ariaRequired: booleanish$1,
    ariaRoleDescription: spaceSeparated$1,
    ariaRowCount: number$8,
    ariaRowIndex: number$8,
    ariaRowSpan: number$8,
    ariaSelected: booleanish$1,
    ariaSetSize: number$8,
    ariaSort: null,
    ariaValueMax: number$8,
    ariaValueMin: number$8,
    ariaValueNow: number$8,
    ariaValueText: null,
    role: null
  },
  transform(n, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function caseSensitiveTransform$1(n, t) {
  return t in n ? n[t] : t;
}
function caseInsensitiveTransform$1(n, t) {
  return caseSensitiveTransform$1(n, t.toLowerCase());
}
const html$6 = create$4({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated$1,
    acceptCharset: spaceSeparated$1,
    accessKey: spaceSeparated$1,
    action: null,
    allow: null,
    allowFullScreen: boolean$1,
    allowPaymentRequest: boolean$1,
    allowUserMedia: boolean$1,
    alt: null,
    as: null,
    async: boolean$1,
    autoCapitalize: null,
    autoComplete: spaceSeparated$1,
    autoFocus: boolean$1,
    autoPlay: boolean$1,
    blocking: spaceSeparated$1,
    capture: null,
    charSet: null,
    checked: boolean$1,
    cite: null,
    className: spaceSeparated$1,
    cols: number$8,
    colSpan: null,
    content: null,
    contentEditable: booleanish$1,
    controls: boolean$1,
    controlsList: spaceSeparated$1,
    coords: number$8 | commaSeparated$1,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean$1,
    defer: boolean$1,
    dir: null,
    dirName: null,
    disabled: boolean$1,
    download: overloadedBoolean$1,
    draggable: booleanish$1,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean$1,
    formTarget: null,
    headers: spaceSeparated$1,
    height: number$8,
    hidden: overloadedBoolean$1,
    high: number$8,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated$1,
    httpEquiv: spaceSeparated$1,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean$1,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean$1,
    itemId: null,
    itemProp: spaceSeparated$1,
    itemRef: spaceSeparated$1,
    itemScope: boolean$1,
    itemType: spaceSeparated$1,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean$1,
    low: number$8,
    manifest: null,
    max: null,
    maxLength: number$8,
    media: null,
    method: null,
    min: null,
    minLength: number$8,
    multiple: boolean$1,
    muted: boolean$1,
    name: null,
    nonce: null,
    noModule: boolean$1,
    noValidate: boolean$1,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean$1,
    optimum: number$8,
    pattern: null,
    ping: spaceSeparated$1,
    placeholder: null,
    playsInline: boolean$1,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean$1,
    referrerPolicy: null,
    rel: spaceSeparated$1,
    required: boolean$1,
    reversed: boolean$1,
    rows: number$8,
    rowSpan: number$8,
    sandbox: spaceSeparated$1,
    scope: null,
    scoped: boolean$1,
    seamless: boolean$1,
    selected: boolean$1,
    shadowRootClonable: boolean$1,
    shadowRootDelegatesFocus: boolean$1,
    shadowRootMode: null,
    shape: null,
    size: number$8,
    sizes: null,
    slot: null,
    span: number$8,
    spellCheck: booleanish$1,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number$8,
    step: null,
    style: null,
    tabIndex: number$8,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean$1,
    useMap: null,
    value: booleanish$1,
    width: number$8,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated$1,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number$8,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number$8,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: boolean$1,
    // Lists. Use CSS to reduce space between items instead
    declare: boolean$1,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number$8,
    // `<img>` and `<object>`
    leftMargin: number$8,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number$8,
    // `<body>`
    marginWidth: number$8,
    // `<body>`
    noResize: boolean$1,
    // `<frame>`
    noHref: boolean$1,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean$1,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean$1,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number$8,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish$1,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number$8,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number$8,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean$1,
    disableRemotePlayback: boolean$1,
    prefix: null,
    property: null,
    results: number$8,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: caseInsensitiveTransform$1
}), svg$3 = create$4({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: commaOrSpaceSeparated$1,
    accentHeight: number$8,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number$8,
    amplitude: number$8,
    arabicForm: null,
    ascent: number$8,
    attributeName: null,
    attributeType: null,
    azimuth: number$8,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number$8,
    by: null,
    calcMode: null,
    capHeight: number$8,
    className: spaceSeparated$1,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number$8,
    diffuseConstant: number$8,
    direction: null,
    display: null,
    dur: null,
    divisor: number$8,
    dominantBaseline: null,
    download: boolean$1,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number$8,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number$8,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number$8,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated$1,
    g2: commaSeparated$1,
    glyphName: commaSeparated$1,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number$8,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number$8,
    horizOriginX: number$8,
    horizOriginY: number$8,
    id: null,
    ideographic: number$8,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number$8,
    k: number$8,
    k1: number$8,
    k2: number$8,
    k3: number$8,
    k4: number$8,
    kernelMatrix: commaOrSpaceSeparated$1,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number$8,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number$8,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number$8,
    overlineThickness: number$8,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number$8,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated$1,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number$8,
    pointsAtY: number$8,
    pointsAtZ: number$8,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated$1,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated$1,
    rev: commaOrSpaceSeparated$1,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated$1,
    requiredFeatures: commaOrSpaceSeparated$1,
    requiredFonts: commaOrSpaceSeparated$1,
    requiredFormats: commaOrSpaceSeparated$1,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number$8,
    specularExponent: number$8,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number$8,
    strikethroughThickness: number$8,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated$1,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number$8,
    strokeOpacity: number$8,
    strokeWidth: null,
    style: null,
    surfaceScale: number$8,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated$1,
    tabIndex: number$8,
    tableValues: null,
    target: null,
    targetX: number$8,
    targetY: number$8,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated$1,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number$8,
    underlineThickness: number$8,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number$8,
    values: null,
    vAlphabetic: number$8,
    vMathematical: number$8,
    vectorEffect: null,
    vHanging: number$8,
    vIdeographic: number$8,
    version: null,
    vertAdvY: number$8,
    vertOriginX: number$8,
    vertOriginY: number$8,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number$8,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: caseSensitiveTransform$1
}), xlink$2 = create$4({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(n, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), xmlns$3 = create$4({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: caseInsensitiveTransform$1
}), xml$2 = create$4({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(n, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), hastToReact = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, cap$2 = /[A-Z]/g, dash$2 = /-[a-z]/g, valid$1 = /^data[-\w.:]+$/i;
function find$4(n, t) {
  const g = normalize$5(t);
  let d = t, k = Info$3;
  if (g in n.normal)
    return n.property[n.normal[g]];
  if (g.length > 4 && g.slice(0, 4) === "data" && valid$1.test(t)) {
    if (t.charAt(4) === "-") {
      const H = t.slice(5).replace(dash$2, camelcase$1);
      d = "data" + H.charAt(0).toUpperCase() + H.slice(1);
    } else {
      const H = t.slice(4);
      if (!dash$2.test(H)) {
        let AA = H.replace(cap$2, kebab$1);
        AA.charAt(0) !== "-" && (AA = "-" + AA), t = "data" + AA;
      }
    }
    k = DefinedInfo$1;
  }
  return new k(d, t);
}
function kebab$1(n) {
  return "-" + n.toLowerCase();
}
function camelcase$1(n) {
  return n.charAt(1).toUpperCase();
}
const html$5 = merge$7([aria$3, html$6, xlink$2, xmlns$3, xml$2], "html"), svg$2 = merge$7([aria$3, svg$3, xlink$2, xmlns$3, xml$2], "svg");
function parse$9(n) {
  const t = String(n || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function stringify$4(n) {
  return n.join(" ").trim();
}
var cjs$2 = {}, cjs$1, hasRequiredCjs$2;
function requireCjs$2() {
  if (hasRequiredCjs$2) return cjs$1;
  hasRequiredCjs$2 = 1;
  var n = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, g = /^\s*/, d = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, k = /^:\s*/, H = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, AA = /^[;\s]*/, gA = /^\s+|\s+$/g, IA = `
`, CA = "/", BA = "*", eA = "", iA = "comment", QA = "declaration";
  function tA(EA, aA) {
    if (typeof EA != "string")
      throw new TypeError("First argument must be a string");
    if (!EA) return [];
    aA = aA || {};
    var nA = 1, lA = 1;
    function cA(yA) {
      var pA = yA.match(t);
      pA && (nA += pA.length);
      var MA = yA.lastIndexOf(IA);
      lA = ~MA ? yA.length - MA : lA + yA.length;
    }
    function sA() {
      var yA = { line: nA, column: lA };
      return function(pA) {
        return pA.position = new rA(yA), dA(), pA;
      };
    }
    function rA(yA) {
      this.start = yA, this.end = { line: nA, column: lA }, this.source = aA.source;
    }
    rA.prototype.content = EA;
    function uA(yA) {
      var pA = new Error(
        aA.source + ":" + nA + ":" + lA + ": " + yA
      );
      if (pA.reason = yA, pA.filename = aA.source, pA.line = nA, pA.column = lA, pA.source = EA, !aA.silent) throw pA;
    }
    function hA(yA) {
      var pA = yA.exec(EA);
      if (pA) {
        var MA = pA[0];
        return cA(MA), EA = EA.slice(MA.length), pA;
      }
    }
    function dA() {
      hA(g);
    }
    function GA(yA) {
      var pA;
      for (yA = yA || []; pA = DA(); )
        pA !== !1 && yA.push(pA);
      return yA;
    }
    function DA() {
      var yA = sA();
      if (!(CA != EA.charAt(0) || BA != EA.charAt(1))) {
        for (var pA = 2; eA != EA.charAt(pA) && (BA != EA.charAt(pA) || CA != EA.charAt(pA + 1)); )
          ++pA;
        if (pA += 2, eA === EA.charAt(pA - 1))
          return uA("End of comment missing");
        var MA = EA.slice(2, pA - 2);
        return lA += 2, cA(MA), EA = EA.slice(pA), lA += 2, yA({
          type: iA,
          comment: MA
        });
      }
    }
    function wA() {
      var yA = sA(), pA = hA(d);
      if (pA) {
        if (DA(), !hA(k)) return uA("property missing ':'");
        var MA = hA(H), LA = yA({
          type: QA,
          property: oA(pA[0].replace(n, eA)),
          value: MA ? oA(MA[0].replace(n, eA)) : eA
        });
        return hA(AA), LA;
      }
    }
    function bA() {
      var yA = [];
      GA(yA);
      for (var pA; pA = wA(); )
        pA !== !1 && (yA.push(pA), GA(yA));
      return yA;
    }
    return dA(), bA();
  }
  function oA(EA) {
    return EA ? EA.replace(gA, eA) : eA;
  }
  return cjs$1 = tA, cjs$1;
}
var hasRequiredCjs$1;
function requireCjs$1() {
  if (hasRequiredCjs$1) return cjs$2;
  hasRequiredCjs$1 = 1;
  var n = cjs$2 && cjs$2.__importDefault || function(d) {
    return d && d.__esModule ? d : { default: d };
  };
  Object.defineProperty(cjs$2, "__esModule", { value: !0 }), cjs$2.default = g;
  const t = n(requireCjs$2());
  function g(d, k) {
    let H = null;
    if (!d || typeof d != "string")
      return H;
    const AA = (0, t.default)(d), gA = typeof k == "function";
    return AA.forEach((IA) => {
      if (IA.type !== "declaration")
        return;
      const { property: CA, value: BA } = IA;
      gA ? k(CA, BA, IA) : BA && (H = H || {}, H[CA] = BA);
    }), H;
  }
  return cjs$2;
}
var utilities = {}, hasRequiredUtilities;
function requireUtilities() {
  if (hasRequiredUtilities) return utilities;
  hasRequiredUtilities = 1, Object.defineProperty(utilities, "__esModule", { value: !0 }), utilities.camelCase = void 0;
  var n = /^--[a-zA-Z0-9_-]+$/, t = /-([a-z])/g, g = /^[^-]+$/, d = /^-(webkit|moz|ms|o|khtml)-/, k = /^-(ms)-/, H = function(CA) {
    return !CA || g.test(CA) || n.test(CA);
  }, AA = function(CA, BA) {
    return BA.toUpperCase();
  }, gA = function(CA, BA) {
    return "".concat(BA, "-");
  }, IA = function(CA, BA) {
    return BA === void 0 && (BA = {}), H(CA) ? CA : (CA = CA.toLowerCase(), BA.reactCompat ? CA = CA.replace(k, gA) : CA = CA.replace(d, gA), CA.replace(t, AA));
  };
  return utilities.camelCase = IA, utilities;
}
var cjs, hasRequiredCjs;
function requireCjs() {
  if (hasRequiredCjs) return cjs;
  hasRequiredCjs = 1;
  var n = cjs && cjs.__importDefault || function(k) {
    return k && k.__esModule ? k : { default: k };
  }, t = n(requireCjs$1()), g = requireUtilities();
  function d(k, H) {
    var AA = {};
    return !k || typeof k != "string" || (0, t.default)(k, function(gA, IA) {
      gA && IA && (AA[(0, g.camelCase)(gA, H)] = IA);
    }), AA;
  }
  return d.default = d, cjs = d, cjs;
}
var cjsExports = requireCjs();
const styleToJs = /* @__PURE__ */ getDefaultExportFromCjs$2(cjsExports), pointEnd = point$b("end"), pointStart = point$b("start");
function point$b(n) {
  return t;
  function t(g) {
    const d = g && g.position && g.position[n] || {};
    if (typeof d.line == "number" && d.line > 0 && typeof d.column == "number" && d.column > 0)
      return {
        line: d.line,
        column: d.column,
        offset: typeof d.offset == "number" && d.offset > -1 ? d.offset : void 0
      };
  }
}
function position$4(n) {
  const t = pointStart(n), g = pointEnd(n);
  if (t && g)
    return { start: t, end: g };
}
function stringifyPosition(n) {
  return !n || typeof n != "object" ? "" : "position" in n || "type" in n ? position$3(n.position) : "start" in n || "end" in n ? position$3(n) : "line" in n || "column" in n ? point$a(n) : "";
}
function point$a(n) {
  return index$4(n && n.line) + ":" + index$4(n && n.column);
}
function position$3(n) {
  return point$a(n && n.start) + "-" + point$a(n && n.end);
}
function index$4(n) {
  return n && typeof n == "number" ? n : 1;
}
class VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, g, d) {
    super(), typeof g == "string" && (d = g, g = void 0);
    let k = "", H = {}, AA = !1;
    if (g && ("line" in g && "column" in g ? H = { place: g } : "start" in g && "end" in g ? H = { place: g } : "type" in g ? H = {
      ancestors: [g],
      place: g.position
    } : H = { ...g }), typeof t == "string" ? k = t : !H.cause && t && (AA = !0, k = t.message, H.cause = t), !H.ruleId && !H.source && typeof d == "string") {
      const IA = d.indexOf(":");
      IA === -1 ? H.ruleId = d : (H.source = d.slice(0, IA), H.ruleId = d.slice(IA + 1));
    }
    if (!H.place && H.ancestors && H.ancestors) {
      const IA = H.ancestors[H.ancestors.length - 1];
      IA && (H.place = IA.position);
    }
    const gA = H.place && "start" in H.place ? H.place.start : H.place;
    this.ancestors = H.ancestors || void 0, this.cause = H.cause || void 0, this.column = gA ? gA.column : void 0, this.fatal = void 0, this.file = "", this.message = k, this.line = gA ? gA.line : void 0, this.name = stringifyPosition(H.place) || "1:1", this.place = H.place || void 0, this.reason = this.message, this.ruleId = H.ruleId || void 0, this.source = H.source || void 0, this.stack = AA && H.cause && typeof H.cause.stack == "string" ? H.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
VFileMessage.prototype.file = "";
VFileMessage.prototype.name = "";
VFileMessage.prototype.reason = "";
VFileMessage.prototype.message = "";
VFileMessage.prototype.stack = "";
VFileMessage.prototype.column = void 0;
VFileMessage.prototype.line = void 0;
VFileMessage.prototype.ancestors = void 0;
VFileMessage.prototype.cause = void 0;
VFileMessage.prototype.fatal = void 0;
VFileMessage.prototype.place = void 0;
VFileMessage.prototype.ruleId = void 0;
VFileMessage.prototype.source = void 0;
const own$8 = {}.hasOwnProperty, emptyMap = /* @__PURE__ */ new Map(), cap$1 = /[A-Z]/g, tableElements = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), tableCellElement = /* @__PURE__ */ new Set(["td", "th"]), docs = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function toJsxRuntime(n, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const g = t.filePath || void 0;
  let d;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    d = developmentCreate(g, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    d = productionCreate(g, t.jsx, t.jsxs);
  }
  const k = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: d,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: g,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? svg$2 : html$5,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, H = one$8(k, n, void 0);
  return H && typeof H != "string" ? H : k.create(
    n,
    k.Fragment,
    { children: H || void 0 },
    void 0
  );
}
function one$8(n, t, g) {
  if (t.type === "element")
    return element$8(n, t, g);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return mdxExpression(n, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return mdxJsxElement(n, t, g);
  if (t.type === "mdxjsEsm")
    return mdxEsm(n, t);
  if (t.type === "root")
    return root$8(n, t, g);
  if (t.type === "text")
    return text$c(n, t);
}
function element$8(n, t, g) {
  const d = n.schema;
  let k = d;
  t.tagName.toLowerCase() === "svg" && d.space === "html" && (k = svg$2, n.schema = k), n.ancestors.push(t);
  const H = findComponentFromName(n, t.tagName, !1), AA = createElementProps(n, t);
  let gA = createChildren$1(n, t);
  return tableElements.has(t.tagName) && (gA = gA.filter(function(IA) {
    return typeof IA == "string" ? !whitespace(IA) : !0;
  })), addNode(n, AA, H, t), addChildren(AA, gA), n.ancestors.pop(), n.schema = d, n.create(t, H, AA, g);
}
function mdxExpression(n, t) {
  if (t.data && t.data.estree && n.evaluater) {
    const d = t.data.estree.body[0];
    return d.type, /** @type {Child | undefined} */
    n.evaluater.evaluateExpression(d.expression);
  }
  crashEstree(n, t.position);
}
function mdxEsm(n, t) {
  if (t.data && t.data.estree && n.evaluater)
    return (
      /** @type {Child | undefined} */
      n.evaluater.evaluateProgram(t.data.estree)
    );
  crashEstree(n, t.position);
}
function mdxJsxElement(n, t, g) {
  const d = n.schema;
  let k = d;
  t.name === "svg" && d.space === "html" && (k = svg$2, n.schema = k), n.ancestors.push(t);
  const H = t.name === null ? n.Fragment : findComponentFromName(n, t.name, !0), AA = createJsxElementProps(n, t), gA = createChildren$1(n, t);
  return addNode(n, AA, H, t), addChildren(AA, gA), n.ancestors.pop(), n.schema = d, n.create(t, H, AA, g);
}
function root$8(n, t, g) {
  const d = {};
  return addChildren(d, createChildren$1(n, t)), n.create(t, n.Fragment, d, g);
}
function text$c(n, t) {
  return t.value;
}
function addNode(n, t, g, d) {
  typeof g != "string" && g !== n.Fragment && n.passNode && (t.node = d);
}
function addChildren(n, t) {
  if (t.length > 0) {
    const g = t.length > 1 ? t : t[0];
    g && (n.children = g);
  }
}
function productionCreate(n, t, g) {
  return d;
  function d(k, H, AA, gA) {
    const CA = Array.isArray(AA.children) ? g : t;
    return gA ? CA(H, AA, gA) : CA(H, AA);
  }
}
function developmentCreate(n, t) {
  return g;
  function g(d, k, H, AA) {
    const gA = Array.isArray(H.children), IA = pointStart(d);
    return t(
      k,
      H,
      AA,
      gA,
      {
        columnNumber: IA ? IA.column - 1 : void 0,
        fileName: n,
        lineNumber: IA ? IA.line : void 0
      },
      void 0
    );
  }
}
function createElementProps(n, t) {
  const g = {};
  let d, k;
  for (k in t.properties)
    if (k !== "children" && own$8.call(t.properties, k)) {
      const H = createProperty$1(n, k, t.properties[k]);
      if (H) {
        const [AA, gA] = H;
        n.tableCellAlignToStyle && AA === "align" && typeof gA == "string" && tableCellElement.has(t.tagName) ? d = gA : g[AA] = gA;
      }
    }
  if (d) {
    const H = (
      /** @type {Style} */
      g.style || (g.style = {})
    );
    H[n.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = d;
  }
  return g;
}
function createJsxElementProps(n, t) {
  const g = {};
  for (const d of t.attributes)
    if (d.type === "mdxJsxExpressionAttribute")
      if (d.data && d.data.estree && n.evaluater) {
        const H = d.data.estree.body[0];
        H.type;
        const AA = H.expression;
        AA.type;
        const gA = AA.properties[0];
        gA.type, Object.assign(
          g,
          n.evaluater.evaluateExpression(gA.argument)
        );
      } else
        crashEstree(n, t.position);
    else {
      const k = d.name;
      let H;
      if (d.value && typeof d.value == "object")
        if (d.value.data && d.value.data.estree && n.evaluater) {
          const gA = d.value.data.estree.body[0];
          gA.type, H = n.evaluater.evaluateExpression(gA.expression);
        } else
          crashEstree(n, t.position);
      else
        H = d.value === null ? !0 : d.value;
      g[k] = /** @type {Props[keyof Props]} */
      H;
    }
  return g;
}
function createChildren$1(n, t) {
  const g = [];
  let d = -1;
  const k = n.passKeys ? /* @__PURE__ */ new Map() : emptyMap;
  for (; ++d < t.children.length; ) {
    const H = t.children[d];
    let AA;
    if (n.passKeys) {
      const IA = H.type === "element" ? H.tagName : H.type === "mdxJsxFlowElement" || H.type === "mdxJsxTextElement" ? H.name : void 0;
      if (IA) {
        const CA = k.get(IA) || 0;
        AA = IA + "-" + CA, k.set(IA, CA + 1);
      }
    }
    const gA = one$8(n, H, AA);
    gA !== void 0 && g.push(gA);
  }
  return g;
}
function createProperty$1(n, t, g) {
  const d = find$4(n.schema, t);
  if (!(g == null || typeof g == "number" && Number.isNaN(g))) {
    if (Array.isArray(g) && (g = d.commaSeparated ? stringify$5(g) : stringify$4(g)), d.property === "style") {
      let k = typeof g == "object" ? g : parseStyle(n, String(g));
      return n.stylePropertyNameCase === "css" && (k = transformStylesToCssCasing(k)), ["style", k];
    }
    return [
      n.elementAttributeNameCase === "react" && d.space ? hastToReact[d.property] || d.property : d.attribute,
      g
    ];
  }
}
function parseStyle(n, t) {
  try {
    return styleToJs(t, { reactCompat: !0 });
  } catch (g) {
    if (n.ignoreInvalidStyle)
      return {};
    const d = (
      /** @type {Error} */
      g
    ), k = new VFileMessage("Cannot parse `style` attribute", {
      ancestors: n.ancestors,
      cause: d,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw k.file = n.filePath || void 0, k.url = docs + "#cannot-parse-style-attribute", k;
  }
}
function findComponentFromName(n, t, g) {
  let d;
  if (!g)
    d = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const k = t.split(".");
    let H = -1, AA;
    for (; ++H < k.length; ) {
      const gA = name(k[H]) ? { type: "Identifier", name: k[H] } : { type: "Literal", value: k[H] };
      AA = AA ? {
        type: "MemberExpression",
        object: AA,
        property: gA,
        computed: !!(H && gA.type === "Literal"),
        optional: !1
      } : gA;
    }
    d = AA;
  } else
    d = name(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (d.type === "Literal") {
    const k = (
      /** @type {string | number} */
      d.value
    );
    return own$8.call(n.components, k) ? n.components[k] : k;
  }
  if (n.evaluater)
    return n.evaluater.evaluateExpression(d);
  crashEstree(n);
}
function crashEstree(n, t) {
  const g = new VFileMessage(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: n.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw g.file = n.filePath || void 0, g.url = docs + "#cannot-handle-mdx-estrees-without-createevaluater", g;
}
function transformStylesToCssCasing(n) {
  const t = {};
  let g;
  for (g in n)
    own$8.call(n, g) && (t[transformStyleToCssCasing(g)] = n[g]);
  return t;
}
function transformStyleToCssCasing(n) {
  let t = n.replace(cap$1, toDash);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function toDash(n) {
  return "-" + n.toLowerCase();
}
const urlAttributes = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, emptyOptions$6 = {};
function toString$6(n, t) {
  const g = emptyOptions$6, d = typeof g.includeImageAlt == "boolean" ? g.includeImageAlt : !0, k = typeof g.includeHtml == "boolean" ? g.includeHtml : !0;
  return one$7(n, d, k);
}
function one$7(n, t, g) {
  if (node(n)) {
    if ("value" in n)
      return n.type === "html" && !g ? "" : n.value;
    if (t && "alt" in n && n.alt)
      return n.alt;
    if ("children" in n)
      return all$5(n.children, t, g);
  }
  return Array.isArray(n) ? all$5(n, t, g) : "";
}
function all$5(n, t, g) {
  const d = [];
  let k = -1;
  for (; ++k < n.length; )
    d[k] = one$7(n[k], t, g);
  return d.join("");
}
function node(n) {
  return !!(n && typeof n == "object");
}
const element$7 = document.createElement("i");
function decodeNamedCharacterReference(n) {
  const t = "&" + n + ";";
  element$7.innerHTML = t;
  const g = element$7.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    g.charCodeAt(g.length - 1) === 59 && n !== "semi" || g === t ? !1 : g
  );
}
function splice$1(n, t, g, d) {
  const k = n.length;
  let H = 0, AA;
  if (t < 0 ? t = -t > k ? 0 : k + t : t = t > k ? k : t, g = g > 0 ? g : 0, d.length < 1e4)
    AA = Array.from(d), AA.unshift(t, g), n.splice(...AA);
  else
    for (g && n.splice(t, g); H < d.length; )
      AA = d.slice(H, H + 1e4), AA.unshift(t, 0), n.splice(...AA), H += 1e4, t += 1e4;
}
function push$1(n, t) {
  return n.length > 0 ? (splice$1(n, n.length, 0, t), n) : t;
}
const hasOwnProperty$e = {}.hasOwnProperty;
function combineExtensions(n) {
  const t = {};
  let g = -1;
  for (; ++g < n.length; )
    syntaxExtension(t, n[g]);
  return t;
}
function syntaxExtension(n, t) {
  let g;
  for (g in t) {
    const k = (hasOwnProperty$e.call(n, g) ? n[g] : void 0) || (n[g] = {}), H = t[g];
    let AA;
    if (H)
      for (AA in H) {
        hasOwnProperty$e.call(k, AA) || (k[AA] = []);
        const gA = H[AA];
        constructs(
          // @ts-expect-error Looks like a list.
          k[AA],
          Array.isArray(gA) ? gA : gA ? [gA] : []
        );
      }
  }
}
function constructs(n, t) {
  let g = -1;
  const d = [];
  for (; ++g < t.length; )
    (t[g].add === "after" ? n : d).push(t[g]);
  splice$1(n, 0, 0, d);
}
function decodeNumericCharacterReference(n, t) {
  const g = Number.parseInt(n, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    g < 9 || g === 11 || g > 13 && g < 32 || // Control character (DEL) of C0, and C1 controls.
    g > 126 && g < 160 || // Lone high surrogates and low surrogates.
    g > 55295 && g < 57344 || // Noncharacters.
    g > 64975 && g < 65008 || /* eslint-disable no-bitwise */
    (g & 65535) === 65535 || (g & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    g > 1114111 ? "�" : String.fromCodePoint(g)
  );
}
function normalizeIdentifier(n) {
  return n.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const asciiAlpha = regexCheck(/[A-Za-z]/), asciiAlphanumeric = regexCheck(/[\dA-Za-z]/), asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function asciiControl(n) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    n !== null && (n < 32 || n === 127)
  );
}
const asciiDigit = regexCheck(/\d/), asciiHexDigit = regexCheck(/[\dA-Fa-f]/), asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
function markdownLineEnding(n) {
  return n !== null && n < -2;
}
function markdownLineEndingOrSpace(n) {
  return n !== null && (n < 0 || n === 32);
}
function markdownSpace(n) {
  return n === -2 || n === -1 || n === 32;
}
const unicodePunctuation = regexCheck(new RegExp("\\p{P}|\\p{S}", "u")), unicodeWhitespace = regexCheck(/\s/);
function regexCheck(n) {
  return t;
  function t(g) {
    return g !== null && g > -1 && n.test(String.fromCharCode(g));
  }
}
function normalizeUri(n) {
  const t = [];
  let g = -1, d = 0, k = 0;
  for (; ++g < n.length; ) {
    const H = n.charCodeAt(g);
    let AA = "";
    if (H === 37 && asciiAlphanumeric(n.charCodeAt(g + 1)) && asciiAlphanumeric(n.charCodeAt(g + 2)))
      k = 2;
    else if (H < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(H)) || (AA = String.fromCharCode(H));
    else if (H > 55295 && H < 57344) {
      const gA = n.charCodeAt(g + 1);
      H < 56320 && gA > 56319 && gA < 57344 ? (AA = String.fromCharCode(H, gA), k = 1) : AA = "�";
    } else
      AA = String.fromCharCode(H);
    AA && (t.push(n.slice(d, g), encodeURIComponent(AA)), d = g + k + 1, AA = ""), k && (g += k, k = 0);
  }
  return t.join("") + n.slice(d);
}
function factorySpace(n, t, g, d) {
  const k = d ? d - 1 : Number.POSITIVE_INFINITY;
  let H = 0;
  return AA;
  function AA(IA) {
    return markdownSpace(IA) ? (n.enter(g), gA(IA)) : t(IA);
  }
  function gA(IA) {
    return markdownSpace(IA) && H++ < k ? (n.consume(IA), gA) : (n.exit(g), t(IA));
  }
}
const content$2 = {
  tokenize: initializeContent
};
function initializeContent(n) {
  const t = n.attempt(this.parser.constructs.contentInitial, d, k);
  let g;
  return t;
  function d(gA) {
    if (gA === null) {
      n.consume(gA);
      return;
    }
    return n.enter("lineEnding"), n.consume(gA), n.exit("lineEnding"), factorySpace(n, t, "linePrefix");
  }
  function k(gA) {
    return n.enter("paragraph"), H(gA);
  }
  function H(gA) {
    const IA = n.enter("chunkText", {
      contentType: "text",
      previous: g
    });
    return g && (g.next = IA), g = IA, AA(gA);
  }
  function AA(gA) {
    if (gA === null) {
      n.exit("chunkText"), n.exit("paragraph"), n.consume(gA);
      return;
    }
    return markdownLineEnding(gA) ? (n.consume(gA), n.exit("chunkText"), H) : (n.consume(gA), AA);
  }
}
const document$2 = {
  tokenize: initializeDocument
}, containerConstruct = {
  tokenize: tokenizeContainer
};
function initializeDocument(n) {
  const t = this, g = [];
  let d = 0, k, H, AA;
  return gA;
  function gA(lA) {
    if (d < g.length) {
      const cA = g[d];
      return t.containerState = cA[1], n.attempt(cA[0].continuation, IA, CA)(lA);
    }
    return CA(lA);
  }
  function IA(lA) {
    if (d++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, k && nA();
      const cA = t.events.length;
      let sA = cA, rA;
      for (; sA--; )
        if (t.events[sA][0] === "exit" && t.events[sA][1].type === "chunkFlow") {
          rA = t.events[sA][1].end;
          break;
        }
      aA(d);
      let uA = cA;
      for (; uA < t.events.length; )
        t.events[uA][1].end = {
          ...rA
        }, uA++;
      return splice$1(t.events, sA + 1, 0, t.events.slice(cA)), t.events.length = uA, CA(lA);
    }
    return gA(lA);
  }
  function CA(lA) {
    if (d === g.length) {
      if (!k)
        return iA(lA);
      if (k.currentConstruct && k.currentConstruct.concrete)
        return tA(lA);
      t.interrupt = !!(k.currentConstruct && !k._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, n.check(containerConstruct, BA, eA)(lA);
  }
  function BA(lA) {
    return k && nA(), aA(d), iA(lA);
  }
  function eA(lA) {
    return t.parser.lazy[t.now().line] = d !== g.length, AA = t.now().offset, tA(lA);
  }
  function iA(lA) {
    return t.containerState = {}, n.attempt(containerConstruct, QA, tA)(lA);
  }
  function QA(lA) {
    return d++, g.push([t.currentConstruct, t.containerState]), iA(lA);
  }
  function tA(lA) {
    if (lA === null) {
      k && nA(), aA(0), n.consume(lA);
      return;
    }
    return k = k || t.parser.flow(t.now()), n.enter("chunkFlow", {
      _tokenizer: k,
      contentType: "flow",
      previous: H
    }), oA(lA);
  }
  function oA(lA) {
    if (lA === null) {
      EA(n.exit("chunkFlow"), !0), aA(0), n.consume(lA);
      return;
    }
    return markdownLineEnding(lA) ? (n.consume(lA), EA(n.exit("chunkFlow")), d = 0, t.interrupt = void 0, gA) : (n.consume(lA), oA);
  }
  function EA(lA, cA) {
    const sA = t.sliceStream(lA);
    if (cA && sA.push(null), lA.previous = H, H && (H.next = lA), H = lA, k.defineSkip(lA.start), k.write(sA), t.parser.lazy[lA.start.line]) {
      let rA = k.events.length;
      for (; rA--; )
        if (
          // The token starts before the line ending…
          k.events[rA][1].start.offset < AA && // …and either is not ended yet…
          (!k.events[rA][1].end || // …or ends after it.
          k.events[rA][1].end.offset > AA)
        )
          return;
      const uA = t.events.length;
      let hA = uA, dA, GA;
      for (; hA--; )
        if (t.events[hA][0] === "exit" && t.events[hA][1].type === "chunkFlow") {
          if (dA) {
            GA = t.events[hA][1].end;
            break;
          }
          dA = !0;
        }
      for (aA(d), rA = uA; rA < t.events.length; )
        t.events[rA][1].end = {
          ...GA
        }, rA++;
      splice$1(t.events, hA + 1, 0, t.events.slice(uA)), t.events.length = rA;
    }
  }
  function aA(lA) {
    let cA = g.length;
    for (; cA-- > lA; ) {
      const sA = g[cA];
      t.containerState = sA[1], sA[0].exit.call(t, n);
    }
    g.length = lA;
  }
  function nA() {
    k.write([null]), H = void 0, k = void 0, t.containerState._closeFlow = void 0;
  }
}
function tokenizeContainer(n, t, g) {
  return factorySpace(n, n.attempt(this.parser.constructs.document, t, g), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function classifyCharacter(n) {
  if (n === null || markdownLineEndingOrSpace(n) || unicodeWhitespace(n))
    return 1;
  if (unicodePunctuation(n))
    return 2;
}
function resolveAll(n, t, g) {
  const d = [];
  let k = -1;
  for (; ++k < n.length; ) {
    const H = n[k].resolveAll;
    H && !d.includes(H) && (t = H(t, g), d.push(H));
  }
  return t;
}
const attention = {
  name: "attention",
  resolveAll: resolveAllAttention,
  tokenize: tokenizeAttention
};
function resolveAllAttention(n, t) {
  let g = -1, d, k, H, AA, gA, IA, CA, BA;
  for (; ++g < n.length; )
    if (n[g][0] === "enter" && n[g][1].type === "attentionSequence" && n[g][1]._close) {
      for (d = g; d--; )
        if (n[d][0] === "exit" && n[d][1].type === "attentionSequence" && n[d][1]._open && // If the markers are the same:
        t.sliceSerialize(n[d][1]).charCodeAt(0) === t.sliceSerialize(n[g][1]).charCodeAt(0)) {
          if ((n[d][1]._close || n[g][1]._open) && (n[g][1].end.offset - n[g][1].start.offset) % 3 && !((n[d][1].end.offset - n[d][1].start.offset + n[g][1].end.offset - n[g][1].start.offset) % 3))
            continue;
          IA = n[d][1].end.offset - n[d][1].start.offset > 1 && n[g][1].end.offset - n[g][1].start.offset > 1 ? 2 : 1;
          const eA = {
            ...n[d][1].end
          }, iA = {
            ...n[g][1].start
          };
          movePoint(eA, -IA), movePoint(iA, IA), AA = {
            type: IA > 1 ? "strongSequence" : "emphasisSequence",
            start: eA,
            end: {
              ...n[d][1].end
            }
          }, gA = {
            type: IA > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...n[g][1].start
            },
            end: iA
          }, H = {
            type: IA > 1 ? "strongText" : "emphasisText",
            start: {
              ...n[d][1].end
            },
            end: {
              ...n[g][1].start
            }
          }, k = {
            type: IA > 1 ? "strong" : "emphasis",
            start: {
              ...AA.start
            },
            end: {
              ...gA.end
            }
          }, n[d][1].end = {
            ...AA.start
          }, n[g][1].start = {
            ...gA.end
          }, CA = [], n[d][1].end.offset - n[d][1].start.offset && (CA = push$1(CA, [["enter", n[d][1], t], ["exit", n[d][1], t]])), CA = push$1(CA, [["enter", k, t], ["enter", AA, t], ["exit", AA, t], ["enter", H, t]]), CA = push$1(CA, resolveAll(t.parser.constructs.insideSpan.null, n.slice(d + 1, g), t)), CA = push$1(CA, [["exit", H, t], ["enter", gA, t], ["exit", gA, t], ["exit", k, t]]), n[g][1].end.offset - n[g][1].start.offset ? (BA = 2, CA = push$1(CA, [["enter", n[g][1], t], ["exit", n[g][1], t]])) : BA = 0, splice$1(n, d - 1, g - d + 3, CA), g = d + CA.length - BA - 2;
          break;
        }
    }
  for (g = -1; ++g < n.length; )
    n[g][1].type === "attentionSequence" && (n[g][1].type = "data");
  return n;
}
function tokenizeAttention(n, t) {
  const g = this.parser.constructs.attentionMarkers.null, d = this.previous, k = classifyCharacter(d);
  let H;
  return AA;
  function AA(IA) {
    return H = IA, n.enter("attentionSequence"), gA(IA);
  }
  function gA(IA) {
    if (IA === H)
      return n.consume(IA), gA;
    const CA = n.exit("attentionSequence"), BA = classifyCharacter(IA), eA = !BA || BA === 2 && k || g.includes(IA), iA = !k || k === 2 && BA || g.includes(d);
    return CA._open = !!(H === 42 ? eA : eA && (k || !iA)), CA._close = !!(H === 42 ? iA : iA && (BA || !eA)), t(IA);
  }
}
function movePoint(n, t) {
  n.column += t, n.offset += t, n._bufferIndex += t;
}
const autolink = {
  name: "autolink",
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(n, t, g) {
  let d = 0;
  return k;
  function k(QA) {
    return n.enter("autolink"), n.enter("autolinkMarker"), n.consume(QA), n.exit("autolinkMarker"), n.enter("autolinkProtocol"), H;
  }
  function H(QA) {
    return asciiAlpha(QA) ? (n.consume(QA), AA) : QA === 64 ? g(QA) : CA(QA);
  }
  function AA(QA) {
    return QA === 43 || QA === 45 || QA === 46 || asciiAlphanumeric(QA) ? (d = 1, gA(QA)) : CA(QA);
  }
  function gA(QA) {
    return QA === 58 ? (n.consume(QA), d = 0, IA) : (QA === 43 || QA === 45 || QA === 46 || asciiAlphanumeric(QA)) && d++ < 32 ? (n.consume(QA), gA) : (d = 0, CA(QA));
  }
  function IA(QA) {
    return QA === 62 ? (n.exit("autolinkProtocol"), n.enter("autolinkMarker"), n.consume(QA), n.exit("autolinkMarker"), n.exit("autolink"), t) : QA === null || QA === 32 || QA === 60 || asciiControl(QA) ? g(QA) : (n.consume(QA), IA);
  }
  function CA(QA) {
    return QA === 64 ? (n.consume(QA), BA) : asciiAtext(QA) ? (n.consume(QA), CA) : g(QA);
  }
  function BA(QA) {
    return asciiAlphanumeric(QA) ? eA(QA) : g(QA);
  }
  function eA(QA) {
    return QA === 46 ? (n.consume(QA), d = 0, BA) : QA === 62 ? (n.exit("autolinkProtocol").type = "autolinkEmail", n.enter("autolinkMarker"), n.consume(QA), n.exit("autolinkMarker"), n.exit("autolink"), t) : iA(QA);
  }
  function iA(QA) {
    if ((QA === 45 || asciiAlphanumeric(QA)) && d++ < 63) {
      const tA = QA === 45 ? iA : eA;
      return n.consume(QA), tA;
    }
    return g(QA);
  }
}
const blankLine = {
  partial: !0,
  tokenize: tokenizeBlankLine
};
function tokenizeBlankLine(n, t, g) {
  return d;
  function d(H) {
    return markdownSpace(H) ? factorySpace(n, k, "linePrefix")(H) : k(H);
  }
  function k(H) {
    return H === null || markdownLineEnding(H) ? t(H) : g(H);
  }
}
const blockQuote = {
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit: exit$2,
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart
};
function tokenizeBlockQuoteStart(n, t, g) {
  const d = this;
  return k;
  function k(AA) {
    if (AA === 62) {
      const gA = d.containerState;
      return gA.open || (n.enter("blockQuote", {
        _container: !0
      }), gA.open = !0), n.enter("blockQuotePrefix"), n.enter("blockQuoteMarker"), n.consume(AA), n.exit("blockQuoteMarker"), H;
    }
    return g(AA);
  }
  function H(AA) {
    return markdownSpace(AA) ? (n.enter("blockQuotePrefixWhitespace"), n.consume(AA), n.exit("blockQuotePrefixWhitespace"), n.exit("blockQuotePrefix"), t) : (n.exit("blockQuotePrefix"), t(AA));
  }
}
function tokenizeBlockQuoteContinuation(n, t, g) {
  const d = this;
  return k;
  function k(AA) {
    return markdownSpace(AA) ? factorySpace(n, H, "linePrefix", d.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(AA) : H(AA);
  }
  function H(AA) {
    return n.attempt(blockQuote, t, g)(AA);
  }
}
function exit$2(n) {
  n.exit("blockQuote");
}
const characterEscape = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(n, t, g) {
  return d;
  function d(H) {
    return n.enter("characterEscape"), n.enter("escapeMarker"), n.consume(H), n.exit("escapeMarker"), k;
  }
  function k(H) {
    return asciiPunctuation(H) ? (n.enter("characterEscapeValue"), n.consume(H), n.exit("characterEscapeValue"), n.exit("characterEscape"), t) : g(H);
  }
}
const characterReference = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(n, t, g) {
  const d = this;
  let k = 0, H, AA;
  return gA;
  function gA(eA) {
    return n.enter("characterReference"), n.enter("characterReferenceMarker"), n.consume(eA), n.exit("characterReferenceMarker"), IA;
  }
  function IA(eA) {
    return eA === 35 ? (n.enter("characterReferenceMarkerNumeric"), n.consume(eA), n.exit("characterReferenceMarkerNumeric"), CA) : (n.enter("characterReferenceValue"), H = 31, AA = asciiAlphanumeric, BA(eA));
  }
  function CA(eA) {
    return eA === 88 || eA === 120 ? (n.enter("characterReferenceMarkerHexadecimal"), n.consume(eA), n.exit("characterReferenceMarkerHexadecimal"), n.enter("characterReferenceValue"), H = 6, AA = asciiHexDigit, BA) : (n.enter("characterReferenceValue"), H = 7, AA = asciiDigit, BA(eA));
  }
  function BA(eA) {
    if (eA === 59 && k) {
      const iA = n.exit("characterReferenceValue");
      return AA === asciiAlphanumeric && !decodeNamedCharacterReference(d.sliceSerialize(iA)) ? g(eA) : (n.enter("characterReferenceMarker"), n.consume(eA), n.exit("characterReferenceMarker"), n.exit("characterReference"), t);
    }
    return AA(eA) && k++ < H ? (n.consume(eA), BA) : g(eA);
  }
}
const nonLazyContinuation$1 = {
  partial: !0,
  tokenize: tokenizeNonLazyContinuation$1
}, codeFenced = {
  concrete: !0,
  name: "codeFenced",
  tokenize: tokenizeCodeFenced
};
function tokenizeCodeFenced(n, t, g) {
  const d = this, k = {
    partial: !0,
    tokenize: sA
  };
  let H = 0, AA = 0, gA;
  return IA;
  function IA(rA) {
    return CA(rA);
  }
  function CA(rA) {
    const uA = d.events[d.events.length - 1];
    return H = uA && uA[1].type === "linePrefix" ? uA[2].sliceSerialize(uA[1], !0).length : 0, gA = rA, n.enter("codeFenced"), n.enter("codeFencedFence"), n.enter("codeFencedFenceSequence"), BA(rA);
  }
  function BA(rA) {
    return rA === gA ? (AA++, n.consume(rA), BA) : AA < 3 ? g(rA) : (n.exit("codeFencedFenceSequence"), markdownSpace(rA) ? factorySpace(n, eA, "whitespace")(rA) : eA(rA));
  }
  function eA(rA) {
    return rA === null || markdownLineEnding(rA) ? (n.exit("codeFencedFence"), d.interrupt ? t(rA) : n.check(nonLazyContinuation$1, oA, cA)(rA)) : (n.enter("codeFencedFenceInfo"), n.enter("chunkString", {
      contentType: "string"
    }), iA(rA));
  }
  function iA(rA) {
    return rA === null || markdownLineEnding(rA) ? (n.exit("chunkString"), n.exit("codeFencedFenceInfo"), eA(rA)) : markdownSpace(rA) ? (n.exit("chunkString"), n.exit("codeFencedFenceInfo"), factorySpace(n, QA, "whitespace")(rA)) : rA === 96 && rA === gA ? g(rA) : (n.consume(rA), iA);
  }
  function QA(rA) {
    return rA === null || markdownLineEnding(rA) ? eA(rA) : (n.enter("codeFencedFenceMeta"), n.enter("chunkString", {
      contentType: "string"
    }), tA(rA));
  }
  function tA(rA) {
    return rA === null || markdownLineEnding(rA) ? (n.exit("chunkString"), n.exit("codeFencedFenceMeta"), eA(rA)) : rA === 96 && rA === gA ? g(rA) : (n.consume(rA), tA);
  }
  function oA(rA) {
    return n.attempt(k, cA, EA)(rA);
  }
  function EA(rA) {
    return n.enter("lineEnding"), n.consume(rA), n.exit("lineEnding"), aA;
  }
  function aA(rA) {
    return H > 0 && markdownSpace(rA) ? factorySpace(n, nA, "linePrefix", H + 1)(rA) : nA(rA);
  }
  function nA(rA) {
    return rA === null || markdownLineEnding(rA) ? n.check(nonLazyContinuation$1, oA, cA)(rA) : (n.enter("codeFlowValue"), lA(rA));
  }
  function lA(rA) {
    return rA === null || markdownLineEnding(rA) ? (n.exit("codeFlowValue"), nA(rA)) : (n.consume(rA), lA);
  }
  function cA(rA) {
    return n.exit("codeFenced"), t(rA);
  }
  function sA(rA, uA, hA) {
    let dA = 0;
    return GA;
    function GA(pA) {
      return rA.enter("lineEnding"), rA.consume(pA), rA.exit("lineEnding"), DA;
    }
    function DA(pA) {
      return rA.enter("codeFencedFence"), markdownSpace(pA) ? factorySpace(rA, wA, "linePrefix", d.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(pA) : wA(pA);
    }
    function wA(pA) {
      return pA === gA ? (rA.enter("codeFencedFenceSequence"), bA(pA)) : hA(pA);
    }
    function bA(pA) {
      return pA === gA ? (dA++, rA.consume(pA), bA) : dA >= AA ? (rA.exit("codeFencedFenceSequence"), markdownSpace(pA) ? factorySpace(rA, yA, "whitespace")(pA) : yA(pA)) : hA(pA);
    }
    function yA(pA) {
      return pA === null || markdownLineEnding(pA) ? (rA.exit("codeFencedFence"), uA(pA)) : hA(pA);
    }
  }
}
function tokenizeNonLazyContinuation$1(n, t, g) {
  const d = this;
  return k;
  function k(AA) {
    return AA === null ? g(AA) : (n.enter("lineEnding"), n.consume(AA), n.exit("lineEnding"), H);
  }
  function H(AA) {
    return d.parser.lazy[d.now().line] ? g(AA) : t(AA);
  }
}
const codeIndented = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented
}, furtherStart = {
  partial: !0,
  tokenize: tokenizeFurtherStart
};
function tokenizeCodeIndented(n, t, g) {
  const d = this;
  return k;
  function k(CA) {
    return n.enter("codeIndented"), factorySpace(n, H, "linePrefix", 5)(CA);
  }
  function H(CA) {
    const BA = d.events[d.events.length - 1];
    return BA && BA[1].type === "linePrefix" && BA[2].sliceSerialize(BA[1], !0).length >= 4 ? AA(CA) : g(CA);
  }
  function AA(CA) {
    return CA === null ? IA(CA) : markdownLineEnding(CA) ? n.attempt(furtherStart, AA, IA)(CA) : (n.enter("codeFlowValue"), gA(CA));
  }
  function gA(CA) {
    return CA === null || markdownLineEnding(CA) ? (n.exit("codeFlowValue"), AA(CA)) : (n.consume(CA), gA);
  }
  function IA(CA) {
    return n.exit("codeIndented"), t(CA);
  }
}
function tokenizeFurtherStart(n, t, g) {
  const d = this;
  return k;
  function k(AA) {
    return d.parser.lazy[d.now().line] ? g(AA) : markdownLineEnding(AA) ? (n.enter("lineEnding"), n.consume(AA), n.exit("lineEnding"), k) : factorySpace(n, H, "linePrefix", 5)(AA);
  }
  function H(AA) {
    const gA = d.events[d.events.length - 1];
    return gA && gA[1].type === "linePrefix" && gA[2].sliceSerialize(gA[1], !0).length >= 4 ? t(AA) : markdownLineEnding(AA) ? k(AA) : g(AA);
  }
}
const codeText = {
  name: "codeText",
  previous: previous$3,
  resolve: resolveCodeText,
  tokenize: tokenizeCodeText
};
function resolveCodeText(n) {
  let t = n.length - 4, g = 3, d, k;
  if ((n[g][1].type === "lineEnding" || n[g][1].type === "space") && (n[t][1].type === "lineEnding" || n[t][1].type === "space")) {
    for (d = g; ++d < t; )
      if (n[d][1].type === "codeTextData") {
        n[g][1].type = "codeTextPadding", n[t][1].type = "codeTextPadding", g += 2, t -= 2;
        break;
      }
  }
  for (d = g - 1, t++; ++d <= t; )
    k === void 0 ? d !== t && n[d][1].type !== "lineEnding" && (k = d) : (d === t || n[d][1].type === "lineEnding") && (n[k][1].type = "codeTextData", d !== k + 2 && (n[k][1].end = n[d - 1][1].end, n.splice(k + 2, d - k - 2), t -= d - k - 2, d = k + 2), k = void 0);
  return n;
}
function previous$3(n) {
  return n !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText(n, t, g) {
  let d = 0, k, H;
  return AA;
  function AA(eA) {
    return n.enter("codeText"), n.enter("codeTextSequence"), gA(eA);
  }
  function gA(eA) {
    return eA === 96 ? (n.consume(eA), d++, gA) : (n.exit("codeTextSequence"), IA(eA));
  }
  function IA(eA) {
    return eA === null ? g(eA) : eA === 32 ? (n.enter("space"), n.consume(eA), n.exit("space"), IA) : eA === 96 ? (H = n.enter("codeTextSequence"), k = 0, BA(eA)) : markdownLineEnding(eA) ? (n.enter("lineEnding"), n.consume(eA), n.exit("lineEnding"), IA) : (n.enter("codeTextData"), CA(eA));
  }
  function CA(eA) {
    return eA === null || eA === 32 || eA === 96 || markdownLineEnding(eA) ? (n.exit("codeTextData"), IA(eA)) : (n.consume(eA), CA);
  }
  function BA(eA) {
    return eA === 96 ? (n.consume(eA), k++, BA) : k === d ? (n.exit("codeTextSequence"), n.exit("codeText"), t(eA)) : (H.type = "codeTextData", CA(eA));
  }
}
class SpliceBuffer {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, g) {
    const d = g ?? Number.POSITIVE_INFINITY;
    return d < this.left.length ? this.left.slice(t, d) : t > this.left.length ? this.right.slice(this.right.length - d + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - d + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, g, d) {
    const k = g || 0;
    this.setCursor(Math.trunc(t));
    const H = this.right.splice(this.right.length - k, Number.POSITIVE_INFINITY);
    return d && chunkedPush(this.left, d), H.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), chunkedPush(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), chunkedPush(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const g = this.left.splice(t, Number.POSITIVE_INFINITY);
        chunkedPush(this.right, g.reverse());
      } else {
        const g = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        chunkedPush(this.left, g.reverse());
      }
  }
}
function chunkedPush(n, t) {
  let g = 0;
  if (t.length < 1e4)
    n.push(...t);
  else
    for (; g < t.length; )
      n.push(...t.slice(g, g + 1e4)), g += 1e4;
}
function subtokenize(n) {
  const t = {};
  let g = -1, d, k, H, AA, gA, IA, CA;
  const BA = new SpliceBuffer(n);
  for (; ++g < BA.length; ) {
    for (; g in t; )
      g = t[g];
    if (d = BA.get(g), g && d[1].type === "chunkFlow" && BA.get(g - 1)[1].type === "listItemPrefix" && (IA = d[1]._tokenizer.events, H = 0, H < IA.length && IA[H][1].type === "lineEndingBlank" && (H += 2), H < IA.length && IA[H][1].type === "content"))
      for (; ++H < IA.length && IA[H][1].type !== "content"; )
        IA[H][1].type === "chunkText" && (IA[H][1]._isInFirstContentOfListItem = !0, H++);
    if (d[0] === "enter")
      d[1].contentType && (Object.assign(t, subcontent(BA, g)), g = t[g], CA = !0);
    else if (d[1]._container) {
      for (H = g, k = void 0; H--; )
        if (AA = BA.get(H), AA[1].type === "lineEnding" || AA[1].type === "lineEndingBlank")
          AA[0] === "enter" && (k && (BA.get(k)[1].type = "lineEndingBlank"), AA[1].type = "lineEnding", k = H);
        else if (!(AA[1].type === "linePrefix" || AA[1].type === "listItemIndent")) break;
      k && (d[1].end = {
        ...BA.get(k)[1].start
      }, gA = BA.slice(k, g), gA.unshift(d), BA.splice(k, g - k + 1, gA));
    }
  }
  return splice$1(n, 0, Number.POSITIVE_INFINITY, BA.slice(0)), !CA;
}
function subcontent(n, t) {
  const g = n.get(t)[1], d = n.get(t)[2];
  let k = t - 1;
  const H = [];
  let AA = g._tokenizer;
  AA || (AA = d.parser[g.contentType](g.start), g._contentTypeTextTrailing && (AA._contentTypeTextTrailing = !0));
  const gA = AA.events, IA = [], CA = {};
  let BA, eA, iA = -1, QA = g, tA = 0, oA = 0;
  const EA = [oA];
  for (; QA; ) {
    for (; n.get(++k)[1] !== QA; )
      ;
    H.push(k), QA._tokenizer || (BA = d.sliceStream(QA), QA.next || BA.push(null), eA && AA.defineSkip(QA.start), QA._isInFirstContentOfListItem && (AA._gfmTasklistFirstContentOfListItem = !0), AA.write(BA), QA._isInFirstContentOfListItem && (AA._gfmTasklistFirstContentOfListItem = void 0)), eA = QA, QA = QA.next;
  }
  for (QA = g; ++iA < gA.length; )
    // Find a void token that includes a break.
    gA[iA][0] === "exit" && gA[iA - 1][0] === "enter" && gA[iA][1].type === gA[iA - 1][1].type && gA[iA][1].start.line !== gA[iA][1].end.line && (oA = iA + 1, EA.push(oA), QA._tokenizer = void 0, QA.previous = void 0, QA = QA.next);
  for (AA.events = [], QA ? (QA._tokenizer = void 0, QA.previous = void 0) : EA.pop(), iA = EA.length; iA--; ) {
    const aA = gA.slice(EA[iA], EA[iA + 1]), nA = H.pop();
    IA.push([nA, nA + aA.length - 1]), n.splice(nA, 2, aA);
  }
  for (IA.reverse(), iA = -1; ++iA < IA.length; )
    CA[tA + IA[iA][0]] = tA + IA[iA][1], tA += IA[iA][1] - IA[iA][0] - 1;
  return CA;
}
const content$1 = {
  resolve: resolveContent,
  tokenize: tokenizeContent
}, continuationConstruct = {
  partial: !0,
  tokenize: tokenizeContinuation
};
function resolveContent(n) {
  return subtokenize(n), n;
}
function tokenizeContent(n, t) {
  let g;
  return d;
  function d(gA) {
    return n.enter("content"), g = n.enter("chunkContent", {
      contentType: "content"
    }), k(gA);
  }
  function k(gA) {
    return gA === null ? H(gA) : markdownLineEnding(gA) ? n.check(continuationConstruct, AA, H)(gA) : (n.consume(gA), k);
  }
  function H(gA) {
    return n.exit("chunkContent"), n.exit("content"), t(gA);
  }
  function AA(gA) {
    return n.consume(gA), n.exit("chunkContent"), g.next = n.enter("chunkContent", {
      contentType: "content",
      previous: g
    }), g = g.next, k;
  }
}
function tokenizeContinuation(n, t, g) {
  const d = this;
  return k;
  function k(AA) {
    return n.exit("chunkContent"), n.enter("lineEnding"), n.consume(AA), n.exit("lineEnding"), factorySpace(n, H, "linePrefix");
  }
  function H(AA) {
    if (AA === null || markdownLineEnding(AA))
      return g(AA);
    const gA = d.events[d.events.length - 1];
    return !d.parser.constructs.disable.null.includes("codeIndented") && gA && gA[1].type === "linePrefix" && gA[2].sliceSerialize(gA[1], !0).length >= 4 ? t(AA) : n.interrupt(d.parser.constructs.flow, g, t)(AA);
  }
}
function factoryDestination(n, t, g, d, k, H, AA, gA, IA) {
  const CA = IA || Number.POSITIVE_INFINITY;
  let BA = 0;
  return eA;
  function eA(aA) {
    return aA === 60 ? (n.enter(d), n.enter(k), n.enter(H), n.consume(aA), n.exit(H), iA) : aA === null || aA === 32 || aA === 41 || asciiControl(aA) ? g(aA) : (n.enter(d), n.enter(AA), n.enter(gA), n.enter("chunkString", {
      contentType: "string"
    }), oA(aA));
  }
  function iA(aA) {
    return aA === 62 ? (n.enter(H), n.consume(aA), n.exit(H), n.exit(k), n.exit(d), t) : (n.enter(gA), n.enter("chunkString", {
      contentType: "string"
    }), QA(aA));
  }
  function QA(aA) {
    return aA === 62 ? (n.exit("chunkString"), n.exit(gA), iA(aA)) : aA === null || aA === 60 || markdownLineEnding(aA) ? g(aA) : (n.consume(aA), aA === 92 ? tA : QA);
  }
  function tA(aA) {
    return aA === 60 || aA === 62 || aA === 92 ? (n.consume(aA), QA) : QA(aA);
  }
  function oA(aA) {
    return !BA && (aA === null || aA === 41 || markdownLineEndingOrSpace(aA)) ? (n.exit("chunkString"), n.exit(gA), n.exit(AA), n.exit(d), t(aA)) : BA < CA && aA === 40 ? (n.consume(aA), BA++, oA) : aA === 41 ? (n.consume(aA), BA--, oA) : aA === null || aA === 32 || aA === 40 || asciiControl(aA) ? g(aA) : (n.consume(aA), aA === 92 ? EA : oA);
  }
  function EA(aA) {
    return aA === 40 || aA === 41 || aA === 92 ? (n.consume(aA), oA) : oA(aA);
  }
}
function factoryLabel$1(n, t, g, d, k, H) {
  const AA = this;
  let gA = 0, IA;
  return CA;
  function CA(QA) {
    return n.enter(d), n.enter(k), n.consume(QA), n.exit(k), n.enter(H), BA;
  }
  function BA(QA) {
    return gA > 999 || QA === null || QA === 91 || QA === 93 && !IA || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    QA === 94 && !gA && "_hiddenFootnoteSupport" in AA.parser.constructs ? g(QA) : QA === 93 ? (n.exit(H), n.enter(k), n.consume(QA), n.exit(k), n.exit(d), t) : markdownLineEnding(QA) ? (n.enter("lineEnding"), n.consume(QA), n.exit("lineEnding"), BA) : (n.enter("chunkString", {
      contentType: "string"
    }), eA(QA));
  }
  function eA(QA) {
    return QA === null || QA === 91 || QA === 93 || markdownLineEnding(QA) || gA++ > 999 ? (n.exit("chunkString"), BA(QA)) : (n.consume(QA), IA || (IA = !markdownSpace(QA)), QA === 92 ? iA : eA);
  }
  function iA(QA) {
    return QA === 91 || QA === 92 || QA === 93 ? (n.consume(QA), gA++, eA) : eA(QA);
  }
}
function factoryTitle(n, t, g, d, k, H) {
  let AA;
  return gA;
  function gA(iA) {
    return iA === 34 || iA === 39 || iA === 40 ? (n.enter(d), n.enter(k), n.consume(iA), n.exit(k), AA = iA === 40 ? 41 : iA, IA) : g(iA);
  }
  function IA(iA) {
    return iA === AA ? (n.enter(k), n.consume(iA), n.exit(k), n.exit(d), t) : (n.enter(H), CA(iA));
  }
  function CA(iA) {
    return iA === AA ? (n.exit(H), IA(AA)) : iA === null ? g(iA) : markdownLineEnding(iA) ? (n.enter("lineEnding"), n.consume(iA), n.exit("lineEnding"), factorySpace(n, CA, "linePrefix")) : (n.enter("chunkString", {
      contentType: "string"
    }), BA(iA));
  }
  function BA(iA) {
    return iA === AA || iA === null || markdownLineEnding(iA) ? (n.exit("chunkString"), CA(iA)) : (n.consume(iA), iA === 92 ? eA : BA);
  }
  function eA(iA) {
    return iA === AA || iA === 92 ? (n.consume(iA), BA) : BA(iA);
  }
}
function factoryWhitespace(n, t) {
  let g;
  return d;
  function d(k) {
    return markdownLineEnding(k) ? (n.enter("lineEnding"), n.consume(k), n.exit("lineEnding"), g = !0, d) : markdownSpace(k) ? factorySpace(n, d, g ? "linePrefix" : "lineSuffix")(k) : t(k);
  }
}
const definition$3 = {
  name: "definition",
  tokenize: tokenizeDefinition
}, titleBefore = {
  partial: !0,
  tokenize: tokenizeTitleBefore
};
function tokenizeDefinition(n, t, g) {
  const d = this;
  let k;
  return H;
  function H(QA) {
    return n.enter("definition"), AA(QA);
  }
  function AA(QA) {
    return factoryLabel$1.call(
      d,
      n,
      gA,
      // Note: we don’t need to reset the way `markdown-rs` does.
      g,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(QA);
  }
  function gA(QA) {
    return k = normalizeIdentifier(d.sliceSerialize(d.events[d.events.length - 1][1]).slice(1, -1)), QA === 58 ? (n.enter("definitionMarker"), n.consume(QA), n.exit("definitionMarker"), IA) : g(QA);
  }
  function IA(QA) {
    return markdownLineEndingOrSpace(QA) ? factoryWhitespace(n, CA)(QA) : CA(QA);
  }
  function CA(QA) {
    return factoryDestination(
      n,
      BA,
      // Note: we don’t need to reset the way `markdown-rs` does.
      g,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(QA);
  }
  function BA(QA) {
    return n.attempt(titleBefore, eA, eA)(QA);
  }
  function eA(QA) {
    return markdownSpace(QA) ? factorySpace(n, iA, "whitespace")(QA) : iA(QA);
  }
  function iA(QA) {
    return QA === null || markdownLineEnding(QA) ? (n.exit("definition"), d.parser.defined.push(k), t(QA)) : g(QA);
  }
}
function tokenizeTitleBefore(n, t, g) {
  return d;
  function d(gA) {
    return markdownLineEndingOrSpace(gA) ? factoryWhitespace(n, k)(gA) : g(gA);
  }
  function k(gA) {
    return factoryTitle(n, H, g, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(gA);
  }
  function H(gA) {
    return markdownSpace(gA) ? factorySpace(n, AA, "whitespace")(gA) : AA(gA);
  }
  function AA(gA) {
    return gA === null || markdownLineEnding(gA) ? t(gA) : g(gA);
  }
}
const hardBreakEscape = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(n, t, g) {
  return d;
  function d(H) {
    return n.enter("hardBreakEscape"), n.consume(H), k;
  }
  function k(H) {
    return markdownLineEnding(H) ? (n.exit("hardBreakEscape"), t(H)) : g(H);
  }
}
const headingAtx = {
  name: "headingAtx",
  resolve: resolveHeadingAtx,
  tokenize: tokenizeHeadingAtx
};
function resolveHeadingAtx(n, t) {
  let g = n.length - 2, d = 3, k, H;
  return n[d][1].type === "whitespace" && (d += 2), g - 2 > d && n[g][1].type === "whitespace" && (g -= 2), n[g][1].type === "atxHeadingSequence" && (d === g - 1 || g - 4 > d && n[g - 2][1].type === "whitespace") && (g -= d + 1 === g ? 2 : 4), g > d && (k = {
    type: "atxHeadingText",
    start: n[d][1].start,
    end: n[g][1].end
  }, H = {
    type: "chunkText",
    start: n[d][1].start,
    end: n[g][1].end,
    contentType: "text"
  }, splice$1(n, d, g - d + 1, [["enter", k, t], ["enter", H, t], ["exit", H, t], ["exit", k, t]])), n;
}
function tokenizeHeadingAtx(n, t, g) {
  let d = 0;
  return k;
  function k(BA) {
    return n.enter("atxHeading"), H(BA);
  }
  function H(BA) {
    return n.enter("atxHeadingSequence"), AA(BA);
  }
  function AA(BA) {
    return BA === 35 && d++ < 6 ? (n.consume(BA), AA) : BA === null || markdownLineEndingOrSpace(BA) ? (n.exit("atxHeadingSequence"), gA(BA)) : g(BA);
  }
  function gA(BA) {
    return BA === 35 ? (n.enter("atxHeadingSequence"), IA(BA)) : BA === null || markdownLineEnding(BA) ? (n.exit("atxHeading"), t(BA)) : markdownSpace(BA) ? factorySpace(n, gA, "whitespace")(BA) : (n.enter("atxHeadingText"), CA(BA));
  }
  function IA(BA) {
    return BA === 35 ? (n.consume(BA), IA) : (n.exit("atxHeadingSequence"), gA(BA));
  }
  function CA(BA) {
    return BA === null || BA === 35 || markdownLineEndingOrSpace(BA) ? (n.exit("atxHeadingText"), gA(BA)) : (n.consume(BA), CA);
  }
}
const htmlBlockNames = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], htmlRawNames = ["pre", "script", "style", "textarea"], htmlFlow = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: resolveToHtmlFlow,
  tokenize: tokenizeHtmlFlow
}, blankLineBefore = {
  partial: !0,
  tokenize: tokenizeBlankLineBefore
}, nonLazyContinuationStart = {
  partial: !0,
  tokenize: tokenizeNonLazyContinuationStart
};
function resolveToHtmlFlow(n) {
  let t = n.length;
  for (; t-- && !(n[t][0] === "enter" && n[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && n[t - 2][1].type === "linePrefix" && (n[t][1].start = n[t - 2][1].start, n[t + 1][1].start = n[t - 2][1].start, n.splice(t - 2, 2)), n;
}
function tokenizeHtmlFlow(n, t, g) {
  const d = this;
  let k, H, AA, gA, IA;
  return CA;
  function CA(fA) {
    return BA(fA);
  }
  function BA(fA) {
    return n.enter("htmlFlow"), n.enter("htmlFlowData"), n.consume(fA), eA;
  }
  function eA(fA) {
    return fA === 33 ? (n.consume(fA), iA) : fA === 47 ? (n.consume(fA), H = !0, oA) : fA === 63 ? (n.consume(fA), k = 3, d.interrupt ? t : NA) : asciiAlpha(fA) ? (n.consume(fA), AA = String.fromCharCode(fA), EA) : g(fA);
  }
  function iA(fA) {
    return fA === 45 ? (n.consume(fA), k = 2, QA) : fA === 91 ? (n.consume(fA), k = 5, gA = 0, tA) : asciiAlpha(fA) ? (n.consume(fA), k = 4, d.interrupt ? t : NA) : g(fA);
  }
  function QA(fA) {
    return fA === 45 ? (n.consume(fA), d.interrupt ? t : NA) : g(fA);
  }
  function tA(fA) {
    const vA = "CDATA[";
    return fA === vA.charCodeAt(gA++) ? (n.consume(fA), gA === vA.length ? d.interrupt ? t : wA : tA) : g(fA);
  }
  function oA(fA) {
    return asciiAlpha(fA) ? (n.consume(fA), AA = String.fromCharCode(fA), EA) : g(fA);
  }
  function EA(fA) {
    if (fA === null || fA === 47 || fA === 62 || markdownLineEndingOrSpace(fA)) {
      const vA = fA === 47, Cg = AA.toLowerCase();
      return !vA && !H && htmlRawNames.includes(Cg) ? (k = 1, d.interrupt ? t(fA) : wA(fA)) : htmlBlockNames.includes(AA.toLowerCase()) ? (k = 6, vA ? (n.consume(fA), aA) : d.interrupt ? t(fA) : wA(fA)) : (k = 7, d.interrupt && !d.parser.lazy[d.now().line] ? g(fA) : H ? nA(fA) : lA(fA));
    }
    return fA === 45 || asciiAlphanumeric(fA) ? (n.consume(fA), AA += String.fromCharCode(fA), EA) : g(fA);
  }
  function aA(fA) {
    return fA === 62 ? (n.consume(fA), d.interrupt ? t : wA) : g(fA);
  }
  function nA(fA) {
    return markdownSpace(fA) ? (n.consume(fA), nA) : GA(fA);
  }
  function lA(fA) {
    return fA === 47 ? (n.consume(fA), GA) : fA === 58 || fA === 95 || asciiAlpha(fA) ? (n.consume(fA), cA) : markdownSpace(fA) ? (n.consume(fA), lA) : GA(fA);
  }
  function cA(fA) {
    return fA === 45 || fA === 46 || fA === 58 || fA === 95 || asciiAlphanumeric(fA) ? (n.consume(fA), cA) : sA(fA);
  }
  function sA(fA) {
    return fA === 61 ? (n.consume(fA), rA) : markdownSpace(fA) ? (n.consume(fA), sA) : lA(fA);
  }
  function rA(fA) {
    return fA === null || fA === 60 || fA === 61 || fA === 62 || fA === 96 ? g(fA) : fA === 34 || fA === 39 ? (n.consume(fA), IA = fA, uA) : markdownSpace(fA) ? (n.consume(fA), rA) : hA(fA);
  }
  function uA(fA) {
    return fA === IA ? (n.consume(fA), IA = null, dA) : fA === null || markdownLineEnding(fA) ? g(fA) : (n.consume(fA), uA);
  }
  function hA(fA) {
    return fA === null || fA === 34 || fA === 39 || fA === 47 || fA === 60 || fA === 61 || fA === 62 || fA === 96 || markdownLineEndingOrSpace(fA) ? sA(fA) : (n.consume(fA), hA);
  }
  function dA(fA) {
    return fA === 47 || fA === 62 || markdownSpace(fA) ? lA(fA) : g(fA);
  }
  function GA(fA) {
    return fA === 62 ? (n.consume(fA), DA) : g(fA);
  }
  function DA(fA) {
    return fA === null || markdownLineEnding(fA) ? wA(fA) : markdownSpace(fA) ? (n.consume(fA), DA) : g(fA);
  }
  function wA(fA) {
    return fA === 45 && k === 2 ? (n.consume(fA), MA) : fA === 60 && k === 1 ? (n.consume(fA), LA) : fA === 62 && k === 4 ? (n.consume(fA), zA) : fA === 63 && k === 3 ? (n.consume(fA), NA) : fA === 93 && k === 5 ? (n.consume(fA), TA) : markdownLineEnding(fA) && (k === 6 || k === 7) ? (n.exit("htmlFlowData"), n.check(blankLineBefore, XA, bA)(fA)) : fA === null || markdownLineEnding(fA) ? (n.exit("htmlFlowData"), bA(fA)) : (n.consume(fA), wA);
  }
  function bA(fA) {
    return n.check(nonLazyContinuationStart, yA, XA)(fA);
  }
  function yA(fA) {
    return n.enter("lineEnding"), n.consume(fA), n.exit("lineEnding"), pA;
  }
  function pA(fA) {
    return fA === null || markdownLineEnding(fA) ? bA(fA) : (n.enter("htmlFlowData"), wA(fA));
  }
  function MA(fA) {
    return fA === 45 ? (n.consume(fA), NA) : wA(fA);
  }
  function LA(fA) {
    return fA === 47 ? (n.consume(fA), AA = "", xA) : wA(fA);
  }
  function xA(fA) {
    if (fA === 62) {
      const vA = AA.toLowerCase();
      return htmlRawNames.includes(vA) ? (n.consume(fA), zA) : wA(fA);
    }
    return asciiAlpha(fA) && AA.length < 8 ? (n.consume(fA), AA += String.fromCharCode(fA), xA) : wA(fA);
  }
  function TA(fA) {
    return fA === 93 ? (n.consume(fA), NA) : wA(fA);
  }
  function NA(fA) {
    return fA === 62 ? (n.consume(fA), zA) : fA === 45 && k === 2 ? (n.consume(fA), NA) : wA(fA);
  }
  function zA(fA) {
    return fA === null || markdownLineEnding(fA) ? (n.exit("htmlFlowData"), XA(fA)) : (n.consume(fA), zA);
  }
  function XA(fA) {
    return n.exit("htmlFlow"), t(fA);
  }
}
function tokenizeNonLazyContinuationStart(n, t, g) {
  const d = this;
  return k;
  function k(AA) {
    return markdownLineEnding(AA) ? (n.enter("lineEnding"), n.consume(AA), n.exit("lineEnding"), H) : g(AA);
  }
  function H(AA) {
    return d.parser.lazy[d.now().line] ? g(AA) : t(AA);
  }
}
function tokenizeBlankLineBefore(n, t, g) {
  return d;
  function d(k) {
    return n.enter("lineEnding"), n.consume(k), n.exit("lineEnding"), n.attempt(blankLine, t, g);
  }
}
const htmlText = {
  name: "htmlText",
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(n, t, g) {
  const d = this;
  let k, H, AA;
  return gA;
  function gA(NA) {
    return n.enter("htmlText"), n.enter("htmlTextData"), n.consume(NA), IA;
  }
  function IA(NA) {
    return NA === 33 ? (n.consume(NA), CA) : NA === 47 ? (n.consume(NA), sA) : NA === 63 ? (n.consume(NA), lA) : asciiAlpha(NA) ? (n.consume(NA), hA) : g(NA);
  }
  function CA(NA) {
    return NA === 45 ? (n.consume(NA), BA) : NA === 91 ? (n.consume(NA), H = 0, tA) : asciiAlpha(NA) ? (n.consume(NA), nA) : g(NA);
  }
  function BA(NA) {
    return NA === 45 ? (n.consume(NA), QA) : g(NA);
  }
  function eA(NA) {
    return NA === null ? g(NA) : NA === 45 ? (n.consume(NA), iA) : markdownLineEnding(NA) ? (AA = eA, LA(NA)) : (n.consume(NA), eA);
  }
  function iA(NA) {
    return NA === 45 ? (n.consume(NA), QA) : eA(NA);
  }
  function QA(NA) {
    return NA === 62 ? MA(NA) : NA === 45 ? iA(NA) : eA(NA);
  }
  function tA(NA) {
    const zA = "CDATA[";
    return NA === zA.charCodeAt(H++) ? (n.consume(NA), H === zA.length ? oA : tA) : g(NA);
  }
  function oA(NA) {
    return NA === null ? g(NA) : NA === 93 ? (n.consume(NA), EA) : markdownLineEnding(NA) ? (AA = oA, LA(NA)) : (n.consume(NA), oA);
  }
  function EA(NA) {
    return NA === 93 ? (n.consume(NA), aA) : oA(NA);
  }
  function aA(NA) {
    return NA === 62 ? MA(NA) : NA === 93 ? (n.consume(NA), aA) : oA(NA);
  }
  function nA(NA) {
    return NA === null || NA === 62 ? MA(NA) : markdownLineEnding(NA) ? (AA = nA, LA(NA)) : (n.consume(NA), nA);
  }
  function lA(NA) {
    return NA === null ? g(NA) : NA === 63 ? (n.consume(NA), cA) : markdownLineEnding(NA) ? (AA = lA, LA(NA)) : (n.consume(NA), lA);
  }
  function cA(NA) {
    return NA === 62 ? MA(NA) : lA(NA);
  }
  function sA(NA) {
    return asciiAlpha(NA) ? (n.consume(NA), rA) : g(NA);
  }
  function rA(NA) {
    return NA === 45 || asciiAlphanumeric(NA) ? (n.consume(NA), rA) : uA(NA);
  }
  function uA(NA) {
    return markdownLineEnding(NA) ? (AA = uA, LA(NA)) : markdownSpace(NA) ? (n.consume(NA), uA) : MA(NA);
  }
  function hA(NA) {
    return NA === 45 || asciiAlphanumeric(NA) ? (n.consume(NA), hA) : NA === 47 || NA === 62 || markdownLineEndingOrSpace(NA) ? dA(NA) : g(NA);
  }
  function dA(NA) {
    return NA === 47 ? (n.consume(NA), MA) : NA === 58 || NA === 95 || asciiAlpha(NA) ? (n.consume(NA), GA) : markdownLineEnding(NA) ? (AA = dA, LA(NA)) : markdownSpace(NA) ? (n.consume(NA), dA) : MA(NA);
  }
  function GA(NA) {
    return NA === 45 || NA === 46 || NA === 58 || NA === 95 || asciiAlphanumeric(NA) ? (n.consume(NA), GA) : DA(NA);
  }
  function DA(NA) {
    return NA === 61 ? (n.consume(NA), wA) : markdownLineEnding(NA) ? (AA = DA, LA(NA)) : markdownSpace(NA) ? (n.consume(NA), DA) : dA(NA);
  }
  function wA(NA) {
    return NA === null || NA === 60 || NA === 61 || NA === 62 || NA === 96 ? g(NA) : NA === 34 || NA === 39 ? (n.consume(NA), k = NA, bA) : markdownLineEnding(NA) ? (AA = wA, LA(NA)) : markdownSpace(NA) ? (n.consume(NA), wA) : (n.consume(NA), yA);
  }
  function bA(NA) {
    return NA === k ? (n.consume(NA), k = void 0, pA) : NA === null ? g(NA) : markdownLineEnding(NA) ? (AA = bA, LA(NA)) : (n.consume(NA), bA);
  }
  function yA(NA) {
    return NA === null || NA === 34 || NA === 39 || NA === 60 || NA === 61 || NA === 96 ? g(NA) : NA === 47 || NA === 62 || markdownLineEndingOrSpace(NA) ? dA(NA) : (n.consume(NA), yA);
  }
  function pA(NA) {
    return NA === 47 || NA === 62 || markdownLineEndingOrSpace(NA) ? dA(NA) : g(NA);
  }
  function MA(NA) {
    return NA === 62 ? (n.consume(NA), n.exit("htmlTextData"), n.exit("htmlText"), t) : g(NA);
  }
  function LA(NA) {
    return n.exit("htmlTextData"), n.enter("lineEnding"), n.consume(NA), n.exit("lineEnding"), xA;
  }
  function xA(NA) {
    return markdownSpace(NA) ? factorySpace(n, TA, "linePrefix", d.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(NA) : TA(NA);
  }
  function TA(NA) {
    return n.enter("htmlTextData"), AA(NA);
  }
}
const labelEnd = {
  name: "labelEnd",
  resolveAll: resolveAllLabelEnd,
  resolveTo: resolveToLabelEnd,
  tokenize: tokenizeLabelEnd
}, resourceConstruct = {
  tokenize: tokenizeResource
}, referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
}, referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};
function resolveAllLabelEnd(n) {
  let t = -1;
  const g = [];
  for (; ++t < n.length; ) {
    const d = n[t][1];
    if (g.push(n[t]), d.type === "labelImage" || d.type === "labelLink" || d.type === "labelEnd") {
      const k = d.type === "labelImage" ? 4 : 2;
      d.type = "data", t += k;
    }
  }
  return n.length !== g.length && splice$1(n, 0, n.length, g), n;
}
function resolveToLabelEnd(n, t) {
  let g = n.length, d = 0, k, H, AA, gA;
  for (; g--; )
    if (k = n[g][1], H) {
      if (k.type === "link" || k.type === "labelLink" && k._inactive)
        break;
      n[g][0] === "enter" && k.type === "labelLink" && (k._inactive = !0);
    } else if (AA) {
      if (n[g][0] === "enter" && (k.type === "labelImage" || k.type === "labelLink") && !k._balanced && (H = g, k.type !== "labelLink")) {
        d = 2;
        break;
      }
    } else k.type === "labelEnd" && (AA = g);
  const IA = {
    type: n[H][1].type === "labelLink" ? "link" : "image",
    start: {
      ...n[H][1].start
    },
    end: {
      ...n[n.length - 1][1].end
    }
  }, CA = {
    type: "label",
    start: {
      ...n[H][1].start
    },
    end: {
      ...n[AA][1].end
    }
  }, BA = {
    type: "labelText",
    start: {
      ...n[H + d + 2][1].end
    },
    end: {
      ...n[AA - 2][1].start
    }
  };
  return gA = [["enter", IA, t], ["enter", CA, t]], gA = push$1(gA, n.slice(H + 1, H + d + 3)), gA = push$1(gA, [["enter", BA, t]]), gA = push$1(gA, resolveAll(t.parser.constructs.insideSpan.null, n.slice(H + d + 4, AA - 3), t)), gA = push$1(gA, [["exit", BA, t], n[AA - 2], n[AA - 1], ["exit", CA, t]]), gA = push$1(gA, n.slice(AA + 1)), gA = push$1(gA, [["exit", IA, t]]), splice$1(n, H, n.length, gA), n;
}
function tokenizeLabelEnd(n, t, g) {
  const d = this;
  let k = d.events.length, H, AA;
  for (; k--; )
    if ((d.events[k][1].type === "labelImage" || d.events[k][1].type === "labelLink") && !d.events[k][1]._balanced) {
      H = d.events[k][1];
      break;
    }
  return gA;
  function gA(iA) {
    return H ? H._inactive ? eA(iA) : (AA = d.parser.defined.includes(normalizeIdentifier(d.sliceSerialize({
      start: H.end,
      end: d.now()
    }))), n.enter("labelEnd"), n.enter("labelMarker"), n.consume(iA), n.exit("labelMarker"), n.exit("labelEnd"), IA) : g(iA);
  }
  function IA(iA) {
    return iA === 40 ? n.attempt(resourceConstruct, BA, AA ? BA : eA)(iA) : iA === 91 ? n.attempt(referenceFullConstruct, BA, AA ? CA : eA)(iA) : AA ? BA(iA) : eA(iA);
  }
  function CA(iA) {
    return n.attempt(referenceCollapsedConstruct, BA, eA)(iA);
  }
  function BA(iA) {
    return t(iA);
  }
  function eA(iA) {
    return H._balanced = !0, g(iA);
  }
}
function tokenizeResource(n, t, g) {
  return d;
  function d(eA) {
    return n.enter("resource"), n.enter("resourceMarker"), n.consume(eA), n.exit("resourceMarker"), k;
  }
  function k(eA) {
    return markdownLineEndingOrSpace(eA) ? factoryWhitespace(n, H)(eA) : H(eA);
  }
  function H(eA) {
    return eA === 41 ? BA(eA) : factoryDestination(n, AA, gA, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(eA);
  }
  function AA(eA) {
    return markdownLineEndingOrSpace(eA) ? factoryWhitespace(n, IA)(eA) : BA(eA);
  }
  function gA(eA) {
    return g(eA);
  }
  function IA(eA) {
    return eA === 34 || eA === 39 || eA === 40 ? factoryTitle(n, CA, g, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(eA) : BA(eA);
  }
  function CA(eA) {
    return markdownLineEndingOrSpace(eA) ? factoryWhitespace(n, BA)(eA) : BA(eA);
  }
  function BA(eA) {
    return eA === 41 ? (n.enter("resourceMarker"), n.consume(eA), n.exit("resourceMarker"), n.exit("resource"), t) : g(eA);
  }
}
function tokenizeReferenceFull(n, t, g) {
  const d = this;
  return k;
  function k(gA) {
    return factoryLabel$1.call(d, n, H, AA, "reference", "referenceMarker", "referenceString")(gA);
  }
  function H(gA) {
    return d.parser.defined.includes(normalizeIdentifier(d.sliceSerialize(d.events[d.events.length - 1][1]).slice(1, -1))) ? t(gA) : g(gA);
  }
  function AA(gA) {
    return g(gA);
  }
}
function tokenizeReferenceCollapsed(n, t, g) {
  return d;
  function d(H) {
    return n.enter("reference"), n.enter("referenceMarker"), n.consume(H), n.exit("referenceMarker"), k;
  }
  function k(H) {
    return H === 93 ? (n.enter("referenceMarker"), n.consume(H), n.exit("referenceMarker"), n.exit("reference"), t) : g(H);
  }
}
const labelStartImage = {
  name: "labelStartImage",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartImage
};
function tokenizeLabelStartImage(n, t, g) {
  const d = this;
  return k;
  function k(gA) {
    return n.enter("labelImage"), n.enter("labelImageMarker"), n.consume(gA), n.exit("labelImageMarker"), H;
  }
  function H(gA) {
    return gA === 91 ? (n.enter("labelMarker"), n.consume(gA), n.exit("labelMarker"), n.exit("labelImage"), AA) : g(gA);
  }
  function AA(gA) {
    return gA === 94 && "_hiddenFootnoteSupport" in d.parser.constructs ? g(gA) : t(gA);
  }
}
const labelStartLink = {
  name: "labelStartLink",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartLink
};
function tokenizeLabelStartLink(n, t, g) {
  const d = this;
  return k;
  function k(AA) {
    return n.enter("labelLink"), n.enter("labelMarker"), n.consume(AA), n.exit("labelMarker"), n.exit("labelLink"), H;
  }
  function H(AA) {
    return AA === 94 && "_hiddenFootnoteSupport" in d.parser.constructs ? g(AA) : t(AA);
  }
}
const lineEnding = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(n, t) {
  return g;
  function g(d) {
    return n.enter("lineEnding"), n.consume(d), n.exit("lineEnding"), factorySpace(n, t, "linePrefix");
  }
}
const thematicBreak$2 = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(n, t, g) {
  let d = 0, k;
  return H;
  function H(CA) {
    return n.enter("thematicBreak"), AA(CA);
  }
  function AA(CA) {
    return k = CA, gA(CA);
  }
  function gA(CA) {
    return CA === k ? (n.enter("thematicBreakSequence"), IA(CA)) : d >= 3 && (CA === null || markdownLineEnding(CA)) ? (n.exit("thematicBreak"), t(CA)) : g(CA);
  }
  function IA(CA) {
    return CA === k ? (n.consume(CA), d++, IA) : (n.exit("thematicBreakSequence"), markdownSpace(CA) ? factorySpace(n, gA, "whitespace")(CA) : gA(CA));
  }
}
const list$2 = {
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd,
  name: "list",
  tokenize: tokenizeListStart
}, listItemPrefixWhitespaceConstruct = {
  partial: !0,
  tokenize: tokenizeListItemPrefixWhitespace
}, indentConstruct = {
  partial: !0,
  tokenize: tokenizeIndent$1
};
function tokenizeListStart(n, t, g) {
  const d = this, k = d.events[d.events.length - 1];
  let H = k && k[1].type === "linePrefix" ? k[2].sliceSerialize(k[1], !0).length : 0, AA = 0;
  return gA;
  function gA(QA) {
    const tA = d.containerState.type || (QA === 42 || QA === 43 || QA === 45 ? "listUnordered" : "listOrdered");
    if (tA === "listUnordered" ? !d.containerState.marker || QA === d.containerState.marker : asciiDigit(QA)) {
      if (d.containerState.type || (d.containerState.type = tA, n.enter(tA, {
        _container: !0
      })), tA === "listUnordered")
        return n.enter("listItemPrefix"), QA === 42 || QA === 45 ? n.check(thematicBreak$2, g, CA)(QA) : CA(QA);
      if (!d.interrupt || QA === 49)
        return n.enter("listItemPrefix"), n.enter("listItemValue"), IA(QA);
    }
    return g(QA);
  }
  function IA(QA) {
    return asciiDigit(QA) && ++AA < 10 ? (n.consume(QA), IA) : (!d.interrupt || AA < 2) && (d.containerState.marker ? QA === d.containerState.marker : QA === 41 || QA === 46) ? (n.exit("listItemValue"), CA(QA)) : g(QA);
  }
  function CA(QA) {
    return n.enter("listItemMarker"), n.consume(QA), n.exit("listItemMarker"), d.containerState.marker = d.containerState.marker || QA, n.check(
      blankLine,
      // Can’t be empty when interrupting.
      d.interrupt ? g : BA,
      n.attempt(listItemPrefixWhitespaceConstruct, iA, eA)
    );
  }
  function BA(QA) {
    return d.containerState.initialBlankLine = !0, H++, iA(QA);
  }
  function eA(QA) {
    return markdownSpace(QA) ? (n.enter("listItemPrefixWhitespace"), n.consume(QA), n.exit("listItemPrefixWhitespace"), iA) : g(QA);
  }
  function iA(QA) {
    return d.containerState.size = H + d.sliceSerialize(n.exit("listItemPrefix"), !0).length, t(QA);
  }
}
function tokenizeListContinuation(n, t, g) {
  const d = this;
  return d.containerState._closeFlow = void 0, n.check(blankLine, k, H);
  function k(gA) {
    return d.containerState.furtherBlankLines = d.containerState.furtherBlankLines || d.containerState.initialBlankLine, factorySpace(n, t, "listItemIndent", d.containerState.size + 1)(gA);
  }
  function H(gA) {
    return d.containerState.furtherBlankLines || !markdownSpace(gA) ? (d.containerState.furtherBlankLines = void 0, d.containerState.initialBlankLine = void 0, AA(gA)) : (d.containerState.furtherBlankLines = void 0, d.containerState.initialBlankLine = void 0, n.attempt(indentConstruct, t, AA)(gA));
  }
  function AA(gA) {
    return d.containerState._closeFlow = !0, d.interrupt = void 0, factorySpace(n, n.attempt(list$2, t, g), "linePrefix", d.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(gA);
  }
}
function tokenizeIndent$1(n, t, g) {
  const d = this;
  return factorySpace(n, k, "listItemIndent", d.containerState.size + 1);
  function k(H) {
    const AA = d.events[d.events.length - 1];
    return AA && AA[1].type === "listItemIndent" && AA[2].sliceSerialize(AA[1], !0).length === d.containerState.size ? t(H) : g(H);
  }
}
function tokenizeListEnd(n) {
  n.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(n, t, g) {
  const d = this;
  return factorySpace(n, k, "listItemPrefixWhitespace", d.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function k(H) {
    const AA = d.events[d.events.length - 1];
    return !markdownSpace(H) && AA && AA[1].type === "listItemPrefixWhitespace" ? t(H) : g(H);
  }
}
const setextUnderline = {
  name: "setextUnderline",
  resolveTo: resolveToSetextUnderline,
  tokenize: tokenizeSetextUnderline
};
function resolveToSetextUnderline(n, t) {
  let g = n.length, d, k, H;
  for (; g--; )
    if (n[g][0] === "enter") {
      if (n[g][1].type === "content") {
        d = g;
        break;
      }
      n[g][1].type === "paragraph" && (k = g);
    } else
      n[g][1].type === "content" && n.splice(g, 1), !H && n[g][1].type === "definition" && (H = g);
  const AA = {
    type: "setextHeading",
    start: {
      ...n[d][1].start
    },
    end: {
      ...n[n.length - 1][1].end
    }
  };
  return n[k][1].type = "setextHeadingText", H ? (n.splice(k, 0, ["enter", AA, t]), n.splice(H + 1, 0, ["exit", n[d][1], t]), n[d][1].end = {
    ...n[H][1].end
  }) : n[d][1] = AA, n.push(["exit", AA, t]), n;
}
function tokenizeSetextUnderline(n, t, g) {
  const d = this;
  let k;
  return H;
  function H(CA) {
    let BA = d.events.length, eA;
    for (; BA--; )
      if (d.events[BA][1].type !== "lineEnding" && d.events[BA][1].type !== "linePrefix" && d.events[BA][1].type !== "content") {
        eA = d.events[BA][1].type === "paragraph";
        break;
      }
    return !d.parser.lazy[d.now().line] && (d.interrupt || eA) ? (n.enter("setextHeadingLine"), k = CA, AA(CA)) : g(CA);
  }
  function AA(CA) {
    return n.enter("setextHeadingLineSequence"), gA(CA);
  }
  function gA(CA) {
    return CA === k ? (n.consume(CA), gA) : (n.exit("setextHeadingLineSequence"), markdownSpace(CA) ? factorySpace(n, IA, "lineSuffix")(CA) : IA(CA));
  }
  function IA(CA) {
    return CA === null || markdownLineEnding(CA) ? (n.exit("setextHeadingLine"), t(CA)) : g(CA);
  }
}
const flow$1 = {
  tokenize: initializeFlow
};
function initializeFlow(n) {
  const t = this, g = n.attempt(
    // Try to parse a blank line.
    blankLine,
    d,
    // Try to parse initial flow (essentially, only code).
    n.attempt(this.parser.constructs.flowInitial, k, factorySpace(n, n.attempt(this.parser.constructs.flow, k, n.attempt(content$1, k)), "linePrefix"))
  );
  return g;
  function d(H) {
    if (H === null) {
      n.consume(H);
      return;
    }
    return n.enter("lineEndingBlank"), n.consume(H), n.exit("lineEndingBlank"), t.currentConstruct = void 0, g;
  }
  function k(H) {
    if (H === null) {
      n.consume(H);
      return;
    }
    return n.enter("lineEnding"), n.consume(H), n.exit("lineEnding"), t.currentConstruct = void 0, g;
  }
}
const resolver = {
  resolveAll: createResolver()
}, string$1 = initializeFactory("string"), text$b = initializeFactory("text");
function initializeFactory(n) {
  return {
    resolveAll: createResolver(n === "text" ? resolveAllLineSuffixes : void 0),
    tokenize: t
  };
  function t(g) {
    const d = this, k = this.parser.constructs[n], H = g.attempt(k, AA, gA);
    return AA;
    function AA(BA) {
      return CA(BA) ? H(BA) : gA(BA);
    }
    function gA(BA) {
      if (BA === null) {
        g.consume(BA);
        return;
      }
      return g.enter("data"), g.consume(BA), IA;
    }
    function IA(BA) {
      return CA(BA) ? (g.exit("data"), H(BA)) : (g.consume(BA), IA);
    }
    function CA(BA) {
      if (BA === null)
        return !0;
      const eA = k[BA];
      let iA = -1;
      if (eA)
        for (; ++iA < eA.length; ) {
          const QA = eA[iA];
          if (!QA.previous || QA.previous.call(d, d.previous))
            return !0;
        }
      return !1;
    }
  }
}
function createResolver(n) {
  return t;
  function t(g, d) {
    let k = -1, H;
    for (; ++k <= g.length; )
      H === void 0 ? g[k] && g[k][1].type === "data" && (H = k, k++) : (!g[k] || g[k][1].type !== "data") && (k !== H + 2 && (g[H][1].end = g[k - 1][1].end, g.splice(H + 2, k - H - 2), k = H + 2), H = void 0);
    return n ? n(g, d) : g;
  }
}
function resolveAllLineSuffixes(n, t) {
  let g = 0;
  for (; ++g <= n.length; )
    if ((g === n.length || n[g][1].type === "lineEnding") && n[g - 1][1].type === "data") {
      const d = n[g - 1][1], k = t.sliceStream(d);
      let H = k.length, AA = -1, gA = 0, IA;
      for (; H--; ) {
        const CA = k[H];
        if (typeof CA == "string") {
          for (AA = CA.length; CA.charCodeAt(AA - 1) === 32; )
            gA++, AA--;
          if (AA) break;
          AA = -1;
        } else if (CA === -2)
          IA = !0, gA++;
        else if (CA !== -1) {
          H++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && g === n.length && (gA = 0), gA) {
        const CA = {
          type: g === n.length || IA || gA < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: H ? AA : d.start._bufferIndex + AA,
            _index: d.start._index + H,
            line: d.end.line,
            column: d.end.column - gA,
            offset: d.end.offset - gA
          },
          end: {
            ...d.end
          }
        };
        d.end = {
          ...CA.start
        }, d.start.offset === d.end.offset ? Object.assign(d, CA) : (n.splice(g, 0, ["enter", CA, t], ["exit", CA, t]), g += 2);
      }
      g++;
    }
  return n;
}
const document$1 = {
  42: list$2,
  43: list$2,
  45: list$2,
  48: list$2,
  49: list$2,
  50: list$2,
  51: list$2,
  52: list$2,
  53: list$2,
  54: list$2,
  55: list$2,
  56: list$2,
  57: list$2,
  62: blockQuote
}, contentInitial = {
  91: definition$3
}, flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  32: codeIndented
}, flow = {
  35: headingAtx,
  42: thematicBreak$2,
  45: [setextUnderline, thematicBreak$2],
  60: htmlFlow,
  61: setextUnderline,
  95: thematicBreak$2,
  96: codeFenced,
  126: codeFenced
}, string = {
  38: characterReference,
  92: characterEscape
}, text$a = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  33: labelStartImage,
  38: characterReference,
  42: attention,
  60: [autolink, htmlText],
  91: labelStartLink,
  92: [hardBreakEscape, characterEscape],
  93: labelEnd,
  95: attention,
  96: codeText
}, insideSpan = {
  null: [attention, resolver]
}, attentionMarkers = {
  null: [42, 95]
}, disable = {
  null: []
}, defaultConstructs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers,
  contentInitial,
  disable,
  document: document$1,
  flow,
  flowInitial,
  insideSpan,
  string,
  text: text$a
}, Symbol.toStringTag, { value: "Module" }));
function createTokenizer(n, t, g) {
  let d = {
    _bufferIndex: -1,
    _index: 0,
    line: g && g.line || 1,
    column: g && g.column || 1,
    offset: g && g.offset || 0
  };
  const k = {}, H = [];
  let AA = [], gA = [];
  const IA = {
    attempt: uA(sA),
    check: uA(rA),
    consume: nA,
    enter: lA,
    exit: cA,
    interrupt: uA(rA, {
      interrupt: !0
    })
  }, CA = {
    code: null,
    containerState: {},
    defineSkip: oA,
    events: [],
    now: tA,
    parser: n,
    previous: null,
    sliceSerialize: iA,
    sliceStream: QA,
    write: eA
  };
  let BA = t.tokenize.call(CA, IA);
  return t.resolveAll && H.push(t), CA;
  function eA(DA) {
    return AA = push$1(AA, DA), EA(), AA[AA.length - 1] !== null ? [] : (hA(t, 0), CA.events = resolveAll(H, CA.events, CA), CA.events);
  }
  function iA(DA, wA) {
    return serializeChunks(QA(DA), wA);
  }
  function QA(DA) {
    return sliceChunks(AA, DA);
  }
  function tA() {
    const {
      _bufferIndex: DA,
      _index: wA,
      line: bA,
      column: yA,
      offset: pA
    } = d;
    return {
      _bufferIndex: DA,
      _index: wA,
      line: bA,
      column: yA,
      offset: pA
    };
  }
  function oA(DA) {
    k[DA.line] = DA.column, GA();
  }
  function EA() {
    let DA;
    for (; d._index < AA.length; ) {
      const wA = AA[d._index];
      if (typeof wA == "string")
        for (DA = d._index, d._bufferIndex < 0 && (d._bufferIndex = 0); d._index === DA && d._bufferIndex < wA.length; )
          aA(wA.charCodeAt(d._bufferIndex));
      else
        aA(wA);
    }
  }
  function aA(DA) {
    BA = BA(DA);
  }
  function nA(DA) {
    markdownLineEnding(DA) ? (d.line++, d.column = 1, d.offset += DA === -3 ? 2 : 1, GA()) : DA !== -1 && (d.column++, d.offset++), d._bufferIndex < 0 ? d._index++ : (d._bufferIndex++, d._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    AA[d._index].length && (d._bufferIndex = -1, d._index++)), CA.previous = DA;
  }
  function lA(DA, wA) {
    const bA = wA || {};
    return bA.type = DA, bA.start = tA(), CA.events.push(["enter", bA, CA]), gA.push(bA), bA;
  }
  function cA(DA) {
    const wA = gA.pop();
    return wA.end = tA(), CA.events.push(["exit", wA, CA]), wA;
  }
  function sA(DA, wA) {
    hA(DA, wA.from);
  }
  function rA(DA, wA) {
    wA.restore();
  }
  function uA(DA, wA) {
    return bA;
    function bA(yA, pA, MA) {
      let LA, xA, TA, NA;
      return Array.isArray(yA) ? (
        /* c8 ignore next 1 */
        XA(yA)
      ) : "tokenize" in yA ? (
        // Looks like a construct.
        XA([
          /** @type {Construct} */
          yA
        ])
      ) : zA(yA);
      function zA(Ig) {
        return gg;
        function gg(og) {
          const eg = og !== null && Ig[og], kA = og !== null && Ig.null, YA = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(eg) ? eg : eg ? [eg] : [],
            ...Array.isArray(kA) ? kA : kA ? [kA] : []
          ];
          return XA(YA)(og);
        }
      }
      function XA(Ig) {
        return LA = Ig, xA = 0, Ig.length === 0 ? MA : fA(Ig[xA]);
      }
      function fA(Ig) {
        return gg;
        function gg(og) {
          return NA = dA(), TA = Ig, Ig.partial || (CA.currentConstruct = Ig), Ig.name && CA.parser.constructs.disable.null.includes(Ig.name) ? Cg() : Ig.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            wA ? Object.assign(Object.create(CA), wA) : CA,
            IA,
            vA,
            Cg
          )(og);
        }
      }
      function vA(Ig) {
        return DA(TA, NA), pA;
      }
      function Cg(Ig) {
        return NA.restore(), ++xA < LA.length ? fA(LA[xA]) : MA;
      }
    }
  }
  function hA(DA, wA) {
    DA.resolveAll && !H.includes(DA) && H.push(DA), DA.resolve && splice$1(CA.events, wA, CA.events.length - wA, DA.resolve(CA.events.slice(wA), CA)), DA.resolveTo && (CA.events = DA.resolveTo(CA.events, CA));
  }
  function dA() {
    const DA = tA(), wA = CA.previous, bA = CA.currentConstruct, yA = CA.events.length, pA = Array.from(gA);
    return {
      from: yA,
      restore: MA
    };
    function MA() {
      d = DA, CA.previous = wA, CA.currentConstruct = bA, CA.events.length = yA, gA = pA, GA();
    }
  }
  function GA() {
    d.line in k && d.column < 2 && (d.column = k[d.line], d.offset += k[d.line] - 1);
  }
}
function sliceChunks(n, t) {
  const g = t.start._index, d = t.start._bufferIndex, k = t.end._index, H = t.end._bufferIndex;
  let AA;
  if (g === k)
    AA = [n[g].slice(d, H)];
  else {
    if (AA = n.slice(g, k), d > -1) {
      const gA = AA[0];
      typeof gA == "string" ? AA[0] = gA.slice(d) : AA.shift();
    }
    H > 0 && AA.push(n[k].slice(0, H));
  }
  return AA;
}
function serializeChunks(n, t) {
  let g = -1;
  const d = [];
  let k;
  for (; ++g < n.length; ) {
    const H = n[g];
    let AA;
    if (typeof H == "string")
      AA = H;
    else switch (H) {
      case -5: {
        AA = "\r";
        break;
      }
      case -4: {
        AA = `
`;
        break;
      }
      case -3: {
        AA = `\r
`;
        break;
      }
      case -2: {
        AA = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && k) continue;
        AA = " ";
        break;
      }
      default:
        AA = String.fromCharCode(H);
    }
    k = H === -2, d.push(AA);
  }
  return d.join("");
}
function parse$8(n) {
  const d = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      combineExtensions([defaultConstructs, ...(n || {}).extensions || []])
    ),
    content: k(content$2),
    defined: [],
    document: k(document$2),
    flow: k(flow$1),
    lazy: {},
    string: k(string$1),
    text: k(text$b)
  };
  return d;
  function k(H) {
    return AA;
    function AA(gA) {
      return createTokenizer(d, H, gA);
    }
  }
}
function postprocess(n) {
  for (; !subtokenize(n); )
    ;
  return n;
}
const search$1 = /[\0\t\n\r]/g;
function preprocess() {
  let n = 1, t = "", g = !0, d;
  return k;
  function k(H, AA, gA) {
    const IA = [];
    let CA, BA, eA, iA, QA;
    for (H = t + (typeof H == "string" ? H.toString() : new TextDecoder(AA || void 0).decode(H)), eA = 0, t = "", g && (H.charCodeAt(0) === 65279 && eA++, g = void 0); eA < H.length; ) {
      if (search$1.lastIndex = eA, CA = search$1.exec(H), iA = CA && CA.index !== void 0 ? CA.index : H.length, QA = H.charCodeAt(iA), !CA) {
        t = H.slice(eA);
        break;
      }
      if (QA === 10 && eA === iA && d)
        IA.push(-3), d = void 0;
      else
        switch (d && (IA.push(-5), d = void 0), eA < iA && (IA.push(H.slice(eA, iA)), n += iA - eA), QA) {
          case 0: {
            IA.push(65533), n++;
            break;
          }
          case 9: {
            for (BA = Math.ceil(n / 4) * 4, IA.push(-2); n++ < BA; ) IA.push(-1);
            break;
          }
          case 10: {
            IA.push(-4), n = 1;
            break;
          }
          default:
            d = !0, n = 1;
        }
      eA = iA + 1;
    }
    return gA && (d && IA.push(-5), t && IA.push(t), IA.push(null)), IA;
  }
}
const characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function decodeString(n) {
  return n.replace(characterEscapeOrReference, decode);
}
function decode(n, t, g) {
  if (t)
    return t;
  if (g.charCodeAt(0) === 35) {
    const k = g.charCodeAt(1), H = k === 120 || k === 88;
    return decodeNumericCharacterReference(g.slice(H ? 2 : 1), H ? 16 : 10);
  }
  return decodeNamedCharacterReference(g) || n;
}
const own$7 = {}.hasOwnProperty;
function fromMarkdown(n, t, g) {
  return typeof t != "string" && (g = t, t = void 0), compiler(g)(postprocess(parse$8(g).document().write(preprocess()(n, t, !0))));
}
function compiler(n) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: H(_A),
      autolinkProtocol: dA,
      autolinkEmail: dA,
      atxHeading: H(JA),
      blockQuote: H(kA),
      characterEscape: dA,
      characterReference: dA,
      codeFenced: H(YA),
      codeFencedFenceInfo: AA,
      codeFencedFenceMeta: AA,
      codeIndented: H(YA, AA),
      codeText: H(RA, AA),
      codeTextData: dA,
      data: dA,
      codeFlowValue: dA,
      definition: H(FA),
      definitionDestinationString: AA,
      definitionLabelString: AA,
      definitionTitleString: AA,
      emphasis: H(mA),
      hardBreakEscape: H(VA),
      hardBreakTrailing: H(VA),
      htmlFlow: H(HA, AA),
      htmlFlowData: dA,
      htmlText: H(HA, AA),
      htmlTextData: dA,
      image: H(jA),
      label: AA,
      link: H(_A),
      listItem: H(rg),
      listItemValue: iA,
      listOrdered: H($A, eA),
      listUnordered: H($A),
      paragraph: H(wg),
      reference: fA,
      referenceString: AA,
      resourceDestinationString: AA,
      resourceTitleString: AA,
      setextHeading: H(JA),
      strong: H(Dg),
      thematicBreak: H(ig)
    },
    exit: {
      atxHeading: IA(),
      atxHeadingSequence: sA,
      autolink: IA(),
      autolinkEmail: eg,
      autolinkProtocol: og,
      blockQuote: IA(),
      characterEscapeValue: GA,
      characterReferenceMarkerHexadecimal: Cg,
      characterReferenceMarkerNumeric: Cg,
      characterReferenceValue: Ig,
      characterReference: gg,
      codeFenced: IA(EA),
      codeFencedFence: oA,
      codeFencedFenceInfo: QA,
      codeFencedFenceMeta: tA,
      codeFlowValue: GA,
      codeIndented: IA(aA),
      codeText: IA(pA),
      codeTextData: GA,
      data: GA,
      definition: IA(),
      definitionDestinationString: cA,
      definitionLabelString: nA,
      definitionTitleString: lA,
      emphasis: IA(),
      hardBreakEscape: IA(wA),
      hardBreakTrailing: IA(wA),
      htmlFlow: IA(bA),
      htmlFlowData: GA,
      htmlText: IA(yA),
      htmlTextData: GA,
      image: IA(LA),
      label: TA,
      labelText: xA,
      lineEnding: DA,
      link: IA(MA),
      listItem: IA(),
      listOrdered: IA(),
      listUnordered: IA(),
      paragraph: IA(),
      referenceString: vA,
      resourceDestinationString: NA,
      resourceTitleString: zA,
      resource: XA,
      setextHeading: IA(hA),
      setextHeadingLineSequence: uA,
      setextHeadingText: rA,
      strong: IA(),
      thematicBreak: IA()
    }
  };
  configure(t, (n || {}).mdastExtensions || []);
  const g = {};
  return d;
  function d(ZA) {
    let KA = {
      type: "root",
      children: []
    };
    const PA = {
      stack: [KA],
      tokenStack: [],
      config: t,
      enter: gA,
      exit: CA,
      buffer: AA,
      resume: BA,
      data: g
    }, ag = [];
    let Gg = -1;
    for (; ++Gg < ZA.length; )
      if (ZA[Gg][1].type === "listOrdered" || ZA[Gg][1].type === "listUnordered")
        if (ZA[Gg][0] === "enter")
          ag.push(Gg);
        else {
          const bg = ag.pop();
          Gg = k(ZA, bg, Gg);
        }
    for (Gg = -1; ++Gg < ZA.length; ) {
      const bg = t[ZA[Gg][0]];
      own$7.call(bg, ZA[Gg][1].type) && bg[ZA[Gg][1].type].call(Object.assign({
        sliceSerialize: ZA[Gg][2].sliceSerialize
      }, PA), ZA[Gg][1]);
    }
    if (PA.tokenStack.length > 0) {
      const bg = PA.tokenStack[PA.tokenStack.length - 1];
      (bg[1] || defaultOnError).call(PA, void 0, bg[0]);
    }
    for (KA.position = {
      start: point$9(ZA.length > 0 ? ZA[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: point$9(ZA.length > 0 ? ZA[ZA.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Gg = -1; ++Gg < t.transforms.length; )
      KA = t.transforms[Gg](KA) || KA;
    return KA;
  }
  function k(ZA, KA, PA) {
    let ag = KA - 1, Gg = -1, bg = !1, yg, hg, tg, Eg;
    for (; ++ag <= PA; ) {
      const cg = ZA[ag];
      switch (cg[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          cg[0] === "enter" ? Gg++ : Gg--, Eg = void 0;
          break;
        }
        case "lineEndingBlank": {
          cg[0] === "enter" && (yg && !Eg && !Gg && !tg && (tg = ag), Eg = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Eg = void 0;
      }
      if (!Gg && cg[0] === "enter" && cg[1].type === "listItemPrefix" || Gg === -1 && cg[0] === "exit" && (cg[1].type === "listUnordered" || cg[1].type === "listOrdered")) {
        if (yg) {
          let sg = ag;
          for (hg = void 0; sg--; ) {
            const ug = ZA[sg];
            if (ug[1].type === "lineEnding" || ug[1].type === "lineEndingBlank") {
              if (ug[0] === "exit") continue;
              hg && (ZA[hg][1].type = "lineEndingBlank", bg = !0), ug[1].type = "lineEnding", hg = sg;
            } else if (!(ug[1].type === "linePrefix" || ug[1].type === "blockQuotePrefix" || ug[1].type === "blockQuotePrefixWhitespace" || ug[1].type === "blockQuoteMarker" || ug[1].type === "listItemIndent")) break;
          }
          tg && (!hg || tg < hg) && (yg._spread = !0), yg.end = Object.assign({}, hg ? ZA[hg][1].start : cg[1].end), ZA.splice(hg || ag, 0, ["exit", yg, cg[2]]), ag++, PA++;
        }
        if (cg[1].type === "listItemPrefix") {
          const sg = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, cg[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          yg = sg, ZA.splice(ag, 0, ["enter", sg, cg[2]]), ag++, PA++, tg = void 0, Eg = !0;
        }
      }
    }
    return ZA[KA][1]._spread = bg, PA;
  }
  function H(ZA, KA) {
    return PA;
    function PA(ag) {
      gA.call(this, ZA(ag), ag), KA && KA.call(this, ag);
    }
  }
  function AA() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function gA(ZA, KA, PA) {
    this.stack[this.stack.length - 1].children.push(ZA), this.stack.push(ZA), this.tokenStack.push([KA, PA || void 0]), ZA.position = {
      start: point$9(KA.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function IA(ZA) {
    return KA;
    function KA(PA) {
      ZA && ZA.call(this, PA), CA.call(this, PA);
    }
  }
  function CA(ZA, KA) {
    const PA = this.stack.pop(), ag = this.tokenStack.pop();
    if (ag)
      ag[0].type !== ZA.type && (KA ? KA.call(this, ZA, ag[0]) : (ag[1] || defaultOnError).call(this, ZA, ag[0]));
    else throw new Error("Cannot close `" + ZA.type + "` (" + stringifyPosition({
      start: ZA.start,
      end: ZA.end
    }) + "): it’s not open");
    PA.position.end = point$9(ZA.end);
  }
  function BA() {
    return toString$6(this.stack.pop());
  }
  function eA() {
    this.data.expectingFirstListItemValue = !0;
  }
  function iA(ZA) {
    if (this.data.expectingFirstListItemValue) {
      const KA = this.stack[this.stack.length - 2];
      KA.start = Number.parseInt(this.sliceSerialize(ZA), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function QA() {
    const ZA = this.resume(), KA = this.stack[this.stack.length - 1];
    KA.lang = ZA;
  }
  function tA() {
    const ZA = this.resume(), KA = this.stack[this.stack.length - 1];
    KA.meta = ZA;
  }
  function oA() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function EA() {
    const ZA = this.resume(), KA = this.stack[this.stack.length - 1];
    KA.value = ZA.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function aA() {
    const ZA = this.resume(), KA = this.stack[this.stack.length - 1];
    KA.value = ZA.replace(/(\r?\n|\r)$/g, "");
  }
  function nA(ZA) {
    const KA = this.resume(), PA = this.stack[this.stack.length - 1];
    PA.label = KA, PA.identifier = normalizeIdentifier(this.sliceSerialize(ZA)).toLowerCase();
  }
  function lA() {
    const ZA = this.resume(), KA = this.stack[this.stack.length - 1];
    KA.title = ZA;
  }
  function cA() {
    const ZA = this.resume(), KA = this.stack[this.stack.length - 1];
    KA.url = ZA;
  }
  function sA(ZA) {
    const KA = this.stack[this.stack.length - 1];
    if (!KA.depth) {
      const PA = this.sliceSerialize(ZA).length;
      KA.depth = PA;
    }
  }
  function rA() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function uA(ZA) {
    const KA = this.stack[this.stack.length - 1];
    KA.depth = this.sliceSerialize(ZA).codePointAt(0) === 61 ? 1 : 2;
  }
  function hA() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function dA(ZA) {
    const PA = this.stack[this.stack.length - 1].children;
    let ag = PA[PA.length - 1];
    (!ag || ag.type !== "text") && (ag = kg(), ag.position = {
      start: point$9(ZA.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, PA.push(ag)), this.stack.push(ag);
  }
  function GA(ZA) {
    const KA = this.stack.pop();
    KA.value += this.sliceSerialize(ZA), KA.position.end = point$9(ZA.end);
  }
  function DA(ZA) {
    const KA = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const PA = KA.children[KA.children.length - 1];
      PA.position.end = point$9(ZA.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(KA.type) && (dA.call(this, ZA), GA.call(this, ZA));
  }
  function wA() {
    this.data.atHardBreak = !0;
  }
  function bA() {
    const ZA = this.resume(), KA = this.stack[this.stack.length - 1];
    KA.value = ZA;
  }
  function yA() {
    const ZA = this.resume(), KA = this.stack[this.stack.length - 1];
    KA.value = ZA;
  }
  function pA() {
    const ZA = this.resume(), KA = this.stack[this.stack.length - 1];
    KA.value = ZA;
  }
  function MA() {
    const ZA = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const KA = this.data.referenceType || "shortcut";
      ZA.type += "Reference", ZA.referenceType = KA, delete ZA.url, delete ZA.title;
    } else
      delete ZA.identifier, delete ZA.label;
    this.data.referenceType = void 0;
  }
  function LA() {
    const ZA = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const KA = this.data.referenceType || "shortcut";
      ZA.type += "Reference", ZA.referenceType = KA, delete ZA.url, delete ZA.title;
    } else
      delete ZA.identifier, delete ZA.label;
    this.data.referenceType = void 0;
  }
  function xA(ZA) {
    const KA = this.sliceSerialize(ZA), PA = this.stack[this.stack.length - 2];
    PA.label = decodeString(KA), PA.identifier = normalizeIdentifier(KA).toLowerCase();
  }
  function TA() {
    const ZA = this.stack[this.stack.length - 1], KA = this.resume(), PA = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, PA.type === "link") {
      const ag = ZA.children;
      PA.children = ag;
    } else
      PA.alt = KA;
  }
  function NA() {
    const ZA = this.resume(), KA = this.stack[this.stack.length - 1];
    KA.url = ZA;
  }
  function zA() {
    const ZA = this.resume(), KA = this.stack[this.stack.length - 1];
    KA.title = ZA;
  }
  function XA() {
    this.data.inReference = void 0;
  }
  function fA() {
    this.data.referenceType = "collapsed";
  }
  function vA(ZA) {
    const KA = this.resume(), PA = this.stack[this.stack.length - 1];
    PA.label = KA, PA.identifier = normalizeIdentifier(this.sliceSerialize(ZA)).toLowerCase(), this.data.referenceType = "full";
  }
  function Cg(ZA) {
    this.data.characterReferenceType = ZA.type;
  }
  function Ig(ZA) {
    const KA = this.sliceSerialize(ZA), PA = this.data.characterReferenceType;
    let ag;
    PA ? (ag = decodeNumericCharacterReference(KA, PA === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : ag = decodeNamedCharacterReference(KA);
    const Gg = this.stack[this.stack.length - 1];
    Gg.value += ag;
  }
  function gg(ZA) {
    const KA = this.stack.pop();
    KA.position.end = point$9(ZA.end);
  }
  function og(ZA) {
    GA.call(this, ZA);
    const KA = this.stack[this.stack.length - 1];
    KA.url = this.sliceSerialize(ZA);
  }
  function eg(ZA) {
    GA.call(this, ZA);
    const KA = this.stack[this.stack.length - 1];
    KA.url = "mailto:" + this.sliceSerialize(ZA);
  }
  function kA() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function YA() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function RA() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function FA() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function mA() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function JA() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function VA() {
    return {
      type: "break"
    };
  }
  function HA() {
    return {
      type: "html",
      value: ""
    };
  }
  function jA() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function _A() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function $A(ZA) {
    return {
      type: "list",
      ordered: ZA.type === "listOrdered",
      start: null,
      spread: ZA._spread,
      children: []
    };
  }
  function rg(ZA) {
    return {
      type: "listItem",
      spread: ZA._spread,
      checked: null,
      children: []
    };
  }
  function wg() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Dg() {
    return {
      type: "strong",
      children: []
    };
  }
  function kg() {
    return {
      type: "text",
      value: ""
    };
  }
  function ig() {
    return {
      type: "thematicBreak"
    };
  }
}
function point$9(n) {
  return {
    line: n.line,
    column: n.column,
    offset: n.offset
  };
}
function configure(n, t) {
  let g = -1;
  for (; ++g < t.length; ) {
    const d = t[g];
    Array.isArray(d) ? configure(n, d) : extension$1(n, d);
  }
}
function extension$1(n, t) {
  let g;
  for (g in t)
    if (own$7.call(t, g))
      switch (g) {
        case "canContainEols": {
          const d = t[g];
          d && n[g].push(...d);
          break;
        }
        case "transforms": {
          const d = t[g];
          d && n[g].push(...d);
          break;
        }
        case "enter":
        case "exit": {
          const d = t[g];
          d && Object.assign(n[g], d);
          break;
        }
      }
}
function defaultOnError(n, t) {
  throw n ? new Error("Cannot close `" + n.type + "` (" + stringifyPosition({
    start: n.start,
    end: n.end
  }) + "): a different token (`" + t.type + "`, " + stringifyPosition({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + stringifyPosition({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function remarkParse(n) {
  const t = this;
  t.parser = g;
  function g(d) {
    return fromMarkdown(d, {
      ...t.data("settings"),
      ...n,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function blockquote$1(n, t) {
  const g = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: n.wrap(n.all(t), !0)
  };
  return n.patch(t, g), n.applyData(t, g);
}
function hardBreak$1(n, t) {
  const g = { type: "element", tagName: "br", properties: {}, children: [] };
  return n.patch(t, g), [n.applyData(t, g), { type: "text", value: `
` }];
}
function code$3(n, t) {
  const g = t.value ? t.value + `
` : "", d = {};
  t.lang && (d.className = ["language-" + t.lang]);
  let k = {
    type: "element",
    tagName: "code",
    properties: d,
    children: [{ type: "text", value: g }]
  };
  return t.meta && (k.data = { meta: t.meta }), n.patch(t, k), k = n.applyData(t, k), k = { type: "element", tagName: "pre", properties: {}, children: [k] }, n.patch(t, k), k;
}
function strikethrough(n, t) {
  const g = {
    type: "element",
    tagName: "del",
    properties: {},
    children: n.all(t)
  };
  return n.patch(t, g), n.applyData(t, g);
}
function emphasis$1(n, t) {
  const g = {
    type: "element",
    tagName: "em",
    properties: {},
    children: n.all(t)
  };
  return n.patch(t, g), n.applyData(t, g);
}
function footnoteReference$1(n, t) {
  const g = typeof n.options.clobberPrefix == "string" ? n.options.clobberPrefix : "user-content-", d = String(t.identifier).toUpperCase(), k = normalizeUri(d.toLowerCase()), H = n.footnoteOrder.indexOf(d);
  let AA, gA = n.footnoteCounts.get(d);
  gA === void 0 ? (gA = 0, n.footnoteOrder.push(d), AA = n.footnoteOrder.length) : AA = H + 1, gA += 1, n.footnoteCounts.set(d, gA);
  const IA = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + g + "fn-" + k,
      id: g + "fnref-" + k + (gA > 1 ? "-" + gA : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(AA) }]
  };
  n.patch(t, IA);
  const CA = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [IA]
  };
  return n.patch(t, CA), n.applyData(t, CA);
}
function heading$1(n, t) {
  const g = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: n.all(t)
  };
  return n.patch(t, g), n.applyData(t, g);
}
function html$4(n, t) {
  if (n.options.allowDangerousHtml) {
    const g = { type: "raw", value: t.value };
    return n.patch(t, g), n.applyData(t, g);
  }
}
function revert(n, t) {
  const g = t.referenceType;
  let d = "]";
  if (g === "collapsed" ? d += "[]" : g === "full" && (d += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + d }];
  const k = n.all(t), H = k[0];
  H && H.type === "text" ? H.value = "[" + H.value : k.unshift({ type: "text", value: "[" });
  const AA = k[k.length - 1];
  return AA && AA.type === "text" ? AA.value += d : k.push({ type: "text", value: d }), k;
}
function imageReference$1(n, t) {
  const g = String(t.identifier).toUpperCase(), d = n.definitionById.get(g);
  if (!d)
    return revert(n, t);
  const k = { src: normalizeUri(d.url || ""), alt: t.alt };
  d.title !== null && d.title !== void 0 && (k.title = d.title);
  const H = { type: "element", tagName: "img", properties: k, children: [] };
  return n.patch(t, H), n.applyData(t, H);
}
function image$3(n, t) {
  const g = { src: normalizeUri(t.url) };
  t.alt !== null && t.alt !== void 0 && (g.alt = t.alt), t.title !== null && t.title !== void 0 && (g.title = t.title);
  const d = { type: "element", tagName: "img", properties: g, children: [] };
  return n.patch(t, d), n.applyData(t, d);
}
function inlineCode$1(n, t) {
  const g = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  n.patch(t, g);
  const d = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [g]
  };
  return n.patch(t, d), n.applyData(t, d);
}
function linkReference$1(n, t) {
  const g = String(t.identifier).toUpperCase(), d = n.definitionById.get(g);
  if (!d)
    return revert(n, t);
  const k = { href: normalizeUri(d.url || "") };
  d.title !== null && d.title !== void 0 && (k.title = d.title);
  const H = {
    type: "element",
    tagName: "a",
    properties: k,
    children: n.all(t)
  };
  return n.patch(t, H), n.applyData(t, H);
}
function link$3(n, t) {
  const g = { href: normalizeUri(t.url) };
  t.title !== null && t.title !== void 0 && (g.title = t.title);
  const d = {
    type: "element",
    tagName: "a",
    properties: g,
    children: n.all(t)
  };
  return n.patch(t, d), n.applyData(t, d);
}
function listItem$1(n, t, g) {
  const d = n.all(t), k = g ? listLoose(g) : listItemLoose(t), H = {}, AA = [];
  if (typeof t.checked == "boolean") {
    const BA = d[0];
    let eA;
    BA && BA.type === "element" && BA.tagName === "p" ? eA = BA : (eA = { type: "element", tagName: "p", properties: {}, children: [] }, d.unshift(eA)), eA.children.length > 0 && eA.children.unshift({ type: "text", value: " " }), eA.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), H.className = ["task-list-item"];
  }
  let gA = -1;
  for (; ++gA < d.length; ) {
    const BA = d[gA];
    (k || gA !== 0 || BA.type !== "element" || BA.tagName !== "p") && AA.push({ type: "text", value: `
` }), BA.type === "element" && BA.tagName === "p" && !k ? AA.push(...BA.children) : AA.push(BA);
  }
  const IA = d[d.length - 1];
  IA && (k || IA.type !== "element" || IA.tagName !== "p") && AA.push({ type: "text", value: `
` });
  const CA = { type: "element", tagName: "li", properties: H, children: AA };
  return n.patch(t, CA), n.applyData(t, CA);
}
function listLoose(n) {
  let t = !1;
  if (n.type === "list") {
    t = n.spread || !1;
    const g = n.children;
    let d = -1;
    for (; !t && ++d < g.length; )
      t = listItemLoose(g[d]);
  }
  return t;
}
function listItemLoose(n) {
  const t = n.spread;
  return t ?? n.children.length > 1;
}
function list$1(n, t) {
  const g = {}, d = n.all(t);
  let k = -1;
  for (typeof t.start == "number" && t.start !== 1 && (g.start = t.start); ++k < d.length; ) {
    const AA = d[k];
    if (AA.type === "element" && AA.tagName === "li" && AA.properties && Array.isArray(AA.properties.className) && AA.properties.className.includes("task-list-item")) {
      g.className = ["contains-task-list"];
      break;
    }
  }
  const H = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: g,
    children: n.wrap(d, !0)
  };
  return n.patch(t, H), n.applyData(t, H);
}
function paragraph$1(n, t) {
  const g = {
    type: "element",
    tagName: "p",
    properties: {},
    children: n.all(t)
  };
  return n.patch(t, g), n.applyData(t, g);
}
function root$7(n, t) {
  const g = { type: "root", children: n.wrap(n.all(t)) };
  return n.patch(t, g), n.applyData(t, g);
}
function strong$1(n, t) {
  const g = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: n.all(t)
  };
  return n.patch(t, g), n.applyData(t, g);
}
function table(n, t) {
  const g = n.all(t), d = g.shift(), k = [];
  if (d) {
    const AA = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: n.wrap([d], !0)
    };
    n.patch(t.children[0], AA), k.push(AA);
  }
  if (g.length > 0) {
    const AA = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: n.wrap(g, !0)
    }, gA = pointStart(t.children[1]), IA = pointEnd(t.children[t.children.length - 1]);
    gA && IA && (AA.position = { start: gA, end: IA }), k.push(AA);
  }
  const H = {
    type: "element",
    tagName: "table",
    properties: {},
    children: n.wrap(k, !0)
  };
  return n.patch(t, H), n.applyData(t, H);
}
function tableRow(n, t, g) {
  const d = g ? g.children : void 0, H = (d ? d.indexOf(t) : 1) === 0 ? "th" : "td", AA = g && g.type === "table" ? g.align : void 0, gA = AA ? AA.length : t.children.length;
  let IA = -1;
  const CA = [];
  for (; ++IA < gA; ) {
    const eA = t.children[IA], iA = {}, QA = AA ? AA[IA] : void 0;
    QA && (iA.align = QA);
    let tA = { type: "element", tagName: H, properties: iA, children: [] };
    eA && (tA.children = n.all(eA), n.patch(eA, tA), tA = n.applyData(eA, tA)), CA.push(tA);
  }
  const BA = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: n.wrap(CA, !0)
  };
  return n.patch(t, BA), n.applyData(t, BA);
}
function tableCell(n, t) {
  const g = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: n.all(t)
  };
  return n.patch(t, g), n.applyData(t, g);
}
const tab = 9, space = 32;
function trimLines(n) {
  const t = String(n), g = /\r?\n|\r/g;
  let d = g.exec(t), k = 0;
  const H = [];
  for (; d; )
    H.push(
      trimLine(t.slice(k, d.index), k > 0, !0),
      d[0]
    ), k = d.index + d[0].length, d = g.exec(t);
  return H.push(trimLine(t.slice(k), k > 0, !1)), H.join("");
}
function trimLine(n, t, g) {
  let d = 0, k = n.length;
  if (t) {
    let H = n.codePointAt(d);
    for (; H === tab || H === space; )
      d++, H = n.codePointAt(d);
  }
  if (g) {
    let H = n.codePointAt(k - 1);
    for (; H === tab || H === space; )
      k--, H = n.codePointAt(k - 1);
  }
  return k > d ? n.slice(d, k) : "";
}
function text$9(n, t) {
  const g = { type: "text", value: trimLines(String(t.value)) };
  return n.patch(t, g), n.applyData(t, g);
}
function thematicBreak$1(n, t) {
  const g = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return n.patch(t, g), n.applyData(t, g);
}
const handlers = {
  blockquote: blockquote$1,
  break: hardBreak$1,
  code: code$3,
  delete: strikethrough,
  emphasis: emphasis$1,
  footnoteReference: footnoteReference$1,
  heading: heading$1,
  html: html$4,
  imageReference: imageReference$1,
  image: image$3,
  inlineCode: inlineCode$1,
  linkReference: linkReference$1,
  link: link$3,
  listItem: listItem$1,
  list: list$1,
  paragraph: paragraph$1,
  // @ts-expect-error: root is different, but hard to type.
  root: root$7,
  strong: strong$1,
  table,
  tableCell,
  tableRow,
  text: text$9,
  thematicBreak: thematicBreak$1,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};
function ignore() {
}
const VOID = -1, PRIMITIVE = 0, ARRAY = 1, OBJECT = 2, DATE$2 = 3, REGEXP = 4, MAP = 5, SET = 6, ERROR = 7, BIGINT = 8, env = typeof self == "object" ? self : globalThis, deserializer = (n, t) => {
  const g = (k, H) => (n.set(H, k), k), d = (k) => {
    if (n.has(k))
      return n.get(k);
    const [H, AA] = t[k];
    switch (H) {
      case PRIMITIVE:
      case VOID:
        return g(AA, k);
      case ARRAY: {
        const gA = g([], k);
        for (const IA of AA)
          gA.push(d(IA));
        return gA;
      }
      case OBJECT: {
        const gA = g({}, k);
        for (const [IA, CA] of AA)
          gA[d(IA)] = d(CA);
        return gA;
      }
      case DATE$2:
        return g(new Date(AA), k);
      case REGEXP: {
        const { source: gA, flags: IA } = AA;
        return g(new RegExp(gA, IA), k);
      }
      case MAP: {
        const gA = g(/* @__PURE__ */ new Map(), k);
        for (const [IA, CA] of AA)
          gA.set(d(IA), d(CA));
        return gA;
      }
      case SET: {
        const gA = g(/* @__PURE__ */ new Set(), k);
        for (const IA of AA)
          gA.add(d(IA));
        return gA;
      }
      case ERROR: {
        const { name: gA, message: IA } = AA;
        return g(new env[gA](IA), k);
      }
      case BIGINT:
        return g(BigInt(AA), k);
      case "BigInt":
        return g(Object(BigInt(AA)), k);
      case "ArrayBuffer":
        return g(new Uint8Array(AA).buffer, AA);
      case "DataView": {
        const { buffer: gA } = new Uint8Array(AA);
        return g(new DataView(gA), AA);
      }
    }
    return g(new env[H](AA), k);
  };
  return d;
}, deserialize = (n) => deserializer(/* @__PURE__ */ new Map(), n)(0), EMPTY = "", { toString: toString$5 } = {}, { keys: keys$5 } = Object, typeOf = (n) => {
  const t = typeof n;
  if (t !== "object" || !n)
    return [PRIMITIVE, t];
  const g = toString$5.call(n).slice(8, -1);
  switch (g) {
    case "Array":
      return [ARRAY, EMPTY];
    case "Object":
      return [OBJECT, EMPTY];
    case "Date":
      return [DATE$2, EMPTY];
    case "RegExp":
      return [REGEXP, EMPTY];
    case "Map":
      return [MAP, EMPTY];
    case "Set":
      return [SET, EMPTY];
    case "DataView":
      return [ARRAY, g];
  }
  return g.includes("Array") ? [ARRAY, g] : g.includes("Error") ? [ERROR, g] : [OBJECT, g];
}, shouldSkip = ([n, t]) => n === PRIMITIVE && (t === "function" || t === "symbol"), serializer = (n, t, g, d) => {
  const k = (AA, gA) => {
    const IA = d.push(AA) - 1;
    return g.set(gA, IA), IA;
  }, H = (AA) => {
    if (g.has(AA))
      return g.get(AA);
    let [gA, IA] = typeOf(AA);
    switch (gA) {
      case PRIMITIVE: {
        let BA = AA;
        switch (IA) {
          case "bigint":
            gA = BIGINT, BA = AA.toString();
            break;
          case "function":
          case "symbol":
            if (n)
              throw new TypeError("unable to serialize " + IA);
            BA = null;
            break;
          case "undefined":
            return k([VOID], AA);
        }
        return k([gA, BA], AA);
      }
      case ARRAY: {
        if (IA) {
          let iA = AA;
          return IA === "DataView" ? iA = new Uint8Array(AA.buffer) : IA === "ArrayBuffer" && (iA = new Uint8Array(AA)), k([IA, [...iA]], AA);
        }
        const BA = [], eA = k([gA, BA], AA);
        for (const iA of AA)
          BA.push(H(iA));
        return eA;
      }
      case OBJECT: {
        if (IA)
          switch (IA) {
            case "BigInt":
              return k([IA, AA.toString()], AA);
            case "Boolean":
            case "Number":
            case "String":
              return k([IA, AA.valueOf()], AA);
          }
        if (t && "toJSON" in AA)
          return H(AA.toJSON());
        const BA = [], eA = k([gA, BA], AA);
        for (const iA of keys$5(AA))
          (n || !shouldSkip(typeOf(AA[iA]))) && BA.push([H(iA), H(AA[iA])]);
        return eA;
      }
      case DATE$2:
        return k([gA, AA.toISOString()], AA);
      case REGEXP: {
        const { source: BA, flags: eA } = AA;
        return k([gA, { source: BA, flags: eA }], AA);
      }
      case MAP: {
        const BA = [], eA = k([gA, BA], AA);
        for (const [iA, QA] of AA)
          (n || !(shouldSkip(typeOf(iA)) || shouldSkip(typeOf(QA)))) && BA.push([H(iA), H(QA)]);
        return eA;
      }
      case SET: {
        const BA = [], eA = k([gA, BA], AA);
        for (const iA of AA)
          (n || !shouldSkip(typeOf(iA))) && BA.push(H(iA));
        return eA;
      }
    }
    const { message: CA } = AA;
    return k([gA, { name: IA, message: CA }], AA);
  };
  return H;
}, serialize$1 = (n, { json: t, lossy: g } = {}) => {
  const d = [];
  return serializer(!(t || g), !!t, /* @__PURE__ */ new Map(), d)(n), d;
}, structuredClone$1 = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (n, t) => t && ("json" in t || "lossy" in t) ? deserialize(serialize$1(n, t)) : structuredClone(n)
) : (n, t) => deserialize(serialize$1(n, t));
function defaultFootnoteBackContent(n, t) {
  const g = [{ type: "text", value: "↩" }];
  return t > 1 && g.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), g;
}
function defaultFootnoteBackLabel(n, t) {
  return "Back to reference " + (n + 1) + (t > 1 ? "-" + t : "");
}
function footer(n) {
  const t = typeof n.options.clobberPrefix == "string" ? n.options.clobberPrefix : "user-content-", g = n.options.footnoteBackContent || defaultFootnoteBackContent, d = n.options.footnoteBackLabel || defaultFootnoteBackLabel, k = n.options.footnoteLabel || "Footnotes", H = n.options.footnoteLabelTagName || "h2", AA = n.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, gA = [];
  let IA = -1;
  for (; ++IA < n.footnoteOrder.length; ) {
    const CA = n.footnoteById.get(
      n.footnoteOrder[IA]
    );
    if (!CA)
      continue;
    const BA = n.all(CA), eA = String(CA.identifier).toUpperCase(), iA = normalizeUri(eA.toLowerCase());
    let QA = 0;
    const tA = [], oA = n.footnoteCounts.get(eA);
    for (; oA !== void 0 && ++QA <= oA; ) {
      tA.length > 0 && tA.push({ type: "text", value: " " });
      let nA = typeof g == "string" ? g : g(IA, QA);
      typeof nA == "string" && (nA = { type: "text", value: nA }), tA.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + iA + (QA > 1 ? "-" + QA : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof d == "string" ? d : d(IA, QA),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(nA) ? nA : [nA]
      });
    }
    const EA = BA[BA.length - 1];
    if (EA && EA.type === "element" && EA.tagName === "p") {
      const nA = EA.children[EA.children.length - 1];
      nA && nA.type === "text" ? nA.value += " " : EA.children.push({ type: "text", value: " " }), EA.children.push(...tA);
    } else
      BA.push(...tA);
    const aA = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + iA },
      children: n.wrap(BA, !0)
    };
    n.patch(CA, aA), gA.push(aA);
  }
  if (gA.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: H,
          properties: {
            ...structuredClone$1(AA),
            id: "footnote-label"
          },
          children: [{ type: "text", value: k }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: n.wrap(gA, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
function visit$1(n, t, g, d) {
  let k, H, AA;
  typeof t == "function" && typeof g != "function" ? (H = void 0, AA = t, k = g) : (H = t, AA = g, k = d), visitParents(n, H, gA, k);
  function gA(IA, CA) {
    const BA = CA[CA.length - 1], eA = BA ? BA.children.indexOf(IA) : void 0;
    return AA(IA, eA, BA);
  }
}
const own$6 = {}.hasOwnProperty, emptyOptions$5 = {};
function createState(n, t) {
  const g = t || emptyOptions$5, d = /* @__PURE__ */ new Map(), k = /* @__PURE__ */ new Map(), H = /* @__PURE__ */ new Map(), AA = { ...handlers, ...g.handlers }, gA = {
    all: CA,
    applyData,
    definitionById: d,
    footnoteById: k,
    footnoteCounts: H,
    footnoteOrder: [],
    handlers: AA,
    one: IA,
    options: g,
    patch: patch$3,
    wrap: wrap$2
  };
  return visit$1(n, function(BA) {
    if (BA.type === "definition" || BA.type === "footnoteDefinition") {
      const eA = BA.type === "definition" ? d : k, iA = String(BA.identifier).toUpperCase();
      eA.has(iA) || eA.set(iA, BA);
    }
  }), gA;
  function IA(BA, eA) {
    const iA = BA.type, QA = gA.handlers[iA];
    if (own$6.call(gA.handlers, iA) && QA)
      return QA(gA, BA, eA);
    if (gA.options.passThrough && gA.options.passThrough.includes(iA)) {
      if ("children" in BA) {
        const { children: oA, ...EA } = BA, aA = structuredClone$1(EA);
        return aA.children = gA.all(BA), aA;
      }
      return structuredClone$1(BA);
    }
    return (gA.options.unknownHandler || defaultUnknownHandler)(gA, BA, eA);
  }
  function CA(BA) {
    const eA = [];
    if ("children" in BA) {
      const iA = BA.children;
      let QA = -1;
      for (; ++QA < iA.length; ) {
        const tA = gA.one(iA[QA], BA);
        if (tA) {
          if (QA && iA[QA - 1].type === "break" && (!Array.isArray(tA) && tA.type === "text" && (tA.value = trimMarkdownSpaceStart(tA.value)), !Array.isArray(tA) && tA.type === "element")) {
            const oA = tA.children[0];
            oA && oA.type === "text" && (oA.value = trimMarkdownSpaceStart(oA.value));
          }
          Array.isArray(tA) ? eA.push(...tA) : eA.push(tA);
        }
      }
    }
    return eA;
  }
}
function patch$3(n, t) {
  n.position && (t.position = position$4(n));
}
function applyData(n, t) {
  let g = t;
  if (n && n.data) {
    const d = n.data.hName, k = n.data.hChildren, H = n.data.hProperties;
    if (typeof d == "string")
      if (g.type === "element")
        g.tagName = d;
      else {
        const AA = "children" in g ? g.children : [g];
        g = { type: "element", tagName: d, properties: {}, children: AA };
      }
    g.type === "element" && H && Object.assign(g.properties, structuredClone$1(H)), "children" in g && g.children && k !== null && k !== void 0 && (g.children = k);
  }
  return g;
}
function defaultUnknownHandler(n, t) {
  const g = t.data || {}, d = "value" in t && !(own$6.call(g, "hProperties") || own$6.call(g, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: n.all(t)
  };
  return n.patch(t, d), n.applyData(t, d);
}
function wrap$2(n, t) {
  const g = [];
  let d = -1;
  for (t && g.push({ type: "text", value: `
` }); ++d < n.length; )
    d && g.push({ type: "text", value: `
` }), g.push(n[d]);
  return t && n.length > 0 && g.push({ type: "text", value: `
` }), g;
}
function trimMarkdownSpaceStart(n) {
  let t = 0, g = n.charCodeAt(t);
  for (; g === 9 || g === 32; )
    t++, g = n.charCodeAt(t);
  return n.slice(t);
}
function toHast(n, t) {
  const g = createState(n, t), d = g.one(n, void 0), k = footer(g), H = Array.isArray(d) ? { type: "root", children: d } : d || { type: "root", children: [] };
  return k && H.children.push({ type: "text", value: `
` }, k), H;
}
function remarkRehype(n, t) {
  return n && "run" in n ? async function(g, d) {
    const k = (
      /** @type {HastRoot} */
      toHast(g, { file: d, ...t })
    );
    await n.run(k, d);
  } : function(g, d) {
    return (
      /** @type {HastRoot} */
      toHast(g, { file: d, ...n || t })
    );
  };
}
function bail(n) {
  if (n)
    throw n;
}
var extend$5, hasRequiredExtend;
function requireExtend() {
  if (hasRequiredExtend) return extend$5;
  hasRequiredExtend = 1;
  var n = Object.prototype.hasOwnProperty, t = Object.prototype.toString, g = Object.defineProperty, d = Object.getOwnPropertyDescriptor, k = function(CA) {
    return typeof Array.isArray == "function" ? Array.isArray(CA) : t.call(CA) === "[object Array]";
  }, H = function(CA) {
    if (!CA || t.call(CA) !== "[object Object]")
      return !1;
    var BA = n.call(CA, "constructor"), eA = CA.constructor && CA.constructor.prototype && n.call(CA.constructor.prototype, "isPrototypeOf");
    if (CA.constructor && !BA && !eA)
      return !1;
    var iA;
    for (iA in CA)
      ;
    return typeof iA > "u" || n.call(CA, iA);
  }, AA = function(CA, BA) {
    g && BA.name === "__proto__" ? g(CA, BA.name, {
      enumerable: !0,
      configurable: !0,
      value: BA.newValue,
      writable: !0
    }) : CA[BA.name] = BA.newValue;
  }, gA = function(CA, BA) {
    if (BA === "__proto__")
      if (n.call(CA, BA)) {
        if (d)
          return d(CA, BA).value;
      } else return;
    return CA[BA];
  };
  return extend$5 = function IA() {
    var CA, BA, eA, iA, QA, tA, oA = arguments[0], EA = 1, aA = arguments.length, nA = !1;
    for (typeof oA == "boolean" && (nA = oA, oA = arguments[1] || {}, EA = 2), (oA == null || typeof oA != "object" && typeof oA != "function") && (oA = {}); EA < aA; ++EA)
      if (CA = arguments[EA], CA != null)
        for (BA in CA)
          eA = gA(oA, BA), iA = gA(CA, BA), oA !== iA && (nA && iA && (H(iA) || (QA = k(iA))) ? (QA ? (QA = !1, tA = eA && k(eA) ? eA : []) : tA = eA && H(eA) ? eA : {}, AA(oA, { name: BA, newValue: IA(nA, tA, iA) })) : typeof iA < "u" && AA(oA, { name: BA, newValue: iA }));
    return oA;
  }, extend$5;
}
var extendExports = requireExtend();
const extend$4 = /* @__PURE__ */ getDefaultExportFromCjs$2(extendExports);
function isPlainObject$3(n) {
  if (typeof n != "object" || n === null)
    return !1;
  const t = Object.getPrototypeOf(n);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in n) && !(Symbol.iterator in n);
}
function trough() {
  const n = [], t = { run: g, use: d };
  return t;
  function g(...k) {
    let H = -1;
    const AA = k.pop();
    if (typeof AA != "function")
      throw new TypeError("Expected function as last argument, not " + AA);
    gA(null, ...k);
    function gA(IA, ...CA) {
      const BA = n[++H];
      let eA = -1;
      if (IA) {
        AA(IA);
        return;
      }
      for (; ++eA < k.length; )
        (CA[eA] === null || CA[eA] === void 0) && (CA[eA] = k[eA]);
      k = CA, BA ? wrap$1(BA, gA)(...CA) : AA(null, ...CA);
    }
  }
  function d(k) {
    if (typeof k != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + k
      );
    return n.push(k), t;
  }
}
function wrap$1(n, t) {
  let g;
  return d;
  function d(...AA) {
    const gA = n.length > AA.length;
    let IA;
    gA && AA.push(k);
    try {
      IA = n.apply(this, AA);
    } catch (CA) {
      const BA = (
        /** @type {Error} */
        CA
      );
      if (gA && g)
        throw BA;
      return k(BA);
    }
    gA || (IA && IA.then && typeof IA.then == "function" ? IA.then(H, k) : IA instanceof Error ? k(IA) : H(IA));
  }
  function k(AA, ...gA) {
    g || (g = !0, t(AA, ...gA));
  }
  function H(AA) {
    k(null, AA);
  }
}
const minpath = { basename, dirname, extname, join: join$2, sep: "/" };
function basename(n, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  assertPath$1(n);
  let g = 0, d = -1, k = n.length, H;
  if (t === void 0 || t.length === 0 || t.length > n.length) {
    for (; k--; )
      if (n.codePointAt(k) === 47) {
        if (H) {
          g = k + 1;
          break;
        }
      } else d < 0 && (H = !0, d = k + 1);
    return d < 0 ? "" : n.slice(g, d);
  }
  if (t === n)
    return "";
  let AA = -1, gA = t.length - 1;
  for (; k--; )
    if (n.codePointAt(k) === 47) {
      if (H) {
        g = k + 1;
        break;
      }
    } else
      AA < 0 && (H = !0, AA = k + 1), gA > -1 && (n.codePointAt(k) === t.codePointAt(gA--) ? gA < 0 && (d = k) : (gA = -1, d = AA));
  return g === d ? d = AA : d < 0 && (d = n.length), n.slice(g, d);
}
function dirname(n) {
  if (assertPath$1(n), n.length === 0)
    return ".";
  let t = -1, g = n.length, d;
  for (; --g; )
    if (n.codePointAt(g) === 47) {
      if (d) {
        t = g;
        break;
      }
    } else d || (d = !0);
  return t < 0 ? n.codePointAt(0) === 47 ? "/" : "." : t === 1 && n.codePointAt(0) === 47 ? "//" : n.slice(0, t);
}
function extname(n) {
  assertPath$1(n);
  let t = n.length, g = -1, d = 0, k = -1, H = 0, AA;
  for (; t--; ) {
    const gA = n.codePointAt(t);
    if (gA === 47) {
      if (AA) {
        d = t + 1;
        break;
      }
      continue;
    }
    g < 0 && (AA = !0, g = t + 1), gA === 46 ? k < 0 ? k = t : H !== 1 && (H = 1) : k > -1 && (H = -1);
  }
  return k < 0 || g < 0 || // We saw a non-dot character immediately before the dot.
  H === 0 || // The (right-most) trimmed path component is exactly `..`.
  H === 1 && k === g - 1 && k === d + 1 ? "" : n.slice(k, g);
}
function join$2(...n) {
  let t = -1, g;
  for (; ++t < n.length; )
    assertPath$1(n[t]), n[t] && (g = g === void 0 ? n[t] : g + "/" + n[t]);
  return g === void 0 ? "." : normalize$4(g);
}
function normalize$4(n) {
  assertPath$1(n);
  const t = n.codePointAt(0) === 47;
  let g = normalizeString(n, !t);
  return g.length === 0 && !t && (g = "."), g.length > 0 && n.codePointAt(n.length - 1) === 47 && (g += "/"), t ? "/" + g : g;
}
function normalizeString(n, t) {
  let g = "", d = 0, k = -1, H = 0, AA = -1, gA, IA;
  for (; ++AA <= n.length; ) {
    if (AA < n.length)
      gA = n.codePointAt(AA);
    else {
      if (gA === 47)
        break;
      gA = 47;
    }
    if (gA === 47) {
      if (!(k === AA - 1 || H === 1)) if (k !== AA - 1 && H === 2) {
        if (g.length < 2 || d !== 2 || g.codePointAt(g.length - 1) !== 46 || g.codePointAt(g.length - 2) !== 46) {
          if (g.length > 2) {
            if (IA = g.lastIndexOf("/"), IA !== g.length - 1) {
              IA < 0 ? (g = "", d = 0) : (g = g.slice(0, IA), d = g.length - 1 - g.lastIndexOf("/")), k = AA, H = 0;
              continue;
            }
          } else if (g.length > 0) {
            g = "", d = 0, k = AA, H = 0;
            continue;
          }
        }
        t && (g = g.length > 0 ? g + "/.." : "..", d = 2);
      } else
        g.length > 0 ? g += "/" + n.slice(k + 1, AA) : g = n.slice(k + 1, AA), d = AA - k - 1;
      k = AA, H = 0;
    } else gA === 46 && H > -1 ? H++ : H = -1;
  }
  return g;
}
function assertPath$1(n) {
  if (typeof n != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(n)
    );
}
const minproc = { cwd };
function cwd() {
  return "/";
}
function isUrl(n) {
  return !!(n !== null && typeof n == "object" && "href" in n && n.href && "protocol" in n && n.protocol && // @ts-expect-error: indexing is fine.
  n.auth === void 0);
}
function urlToPath(n) {
  if (typeof n == "string")
    n = new URL(n);
  else if (!isUrl(n)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + n + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (n.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return getPathFromURLPosix(n);
}
function getPathFromURLPosix(n) {
  if (n.hostname !== "") {
    const d = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw d.code = "ERR_INVALID_FILE_URL_HOST", d;
  }
  const t = n.pathname;
  let g = -1;
  for (; ++g < t.length; )
    if (t.codePointAt(g) === 37 && t.codePointAt(g + 1) === 50) {
      const d = t.codePointAt(g + 2);
      if (d === 70 || d === 102) {
        const k = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw k.code = "ERR_INVALID_FILE_URL_PATH", k;
      }
    }
  return decodeURIComponent(t);
}
const order = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let g;
    t ? isUrl(t) ? g = { path: t } : typeof t == "string" || isUint8Array$1(t) ? g = { value: t } : g = t : g = {}, this.cwd = "cwd" in g ? "" : minproc.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let d = -1;
    for (; ++d < order.length; ) {
      const H = order[d];
      H in g && g[H] !== void 0 && g[H] !== null && (this[H] = H === "history" ? [...g[H]] : g[H]);
    }
    let k;
    for (k in g)
      order.includes(k) || (this[k] = g[k]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? minpath.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    assertNonEmpty(t, "basename"), assertPart(t, "basename"), this.path = minpath.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? minpath.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    assertPath(this.basename, "dirname"), this.path = minpath.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? minpath.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (assertPart(t, "extname"), assertPath(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = minpath.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    isUrl(t) && (t = urlToPath(t)), assertNonEmpty(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? minpath.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    assertNonEmpty(t, "stem"), assertPart(t, "stem"), this.path = minpath.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, g, d) {
    const k = this.message(t, g, d);
    throw k.fatal = !0, k;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, g, d) {
    const k = this.message(t, g, d);
    return k.fatal = void 0, k;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, g, d) {
    const k = new VFileMessage(
      // @ts-expect-error: the overloads are fine.
      t,
      g,
      d
    );
    return this.path && (k.name = this.path + ":" + k.name, k.file = this.path), k.fatal = !1, this.messages.push(k), k;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function assertPart(n, t) {
  if (n && n.includes(minpath.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + minpath.sep + "`"
    );
}
function assertNonEmpty(n, t) {
  if (!n)
    throw new Error("`" + t + "` cannot be empty");
}
function assertPath(n, t) {
  if (!n)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function isUint8Array$1(n) {
  return !!(n && typeof n == "object" && "byteLength" in n && "byteOffset" in n);
}
const CallableInstance = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(n) {
    const d = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), k = d[n], H = function() {
      return k.apply(H, arguments);
    };
    return Object.setPrototypeOf(H, d), H;
  })
), own$5 = {}.hasOwnProperty;
class Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = trough();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Processor()
    );
    let g = -1;
    for (; ++g < this.attachers.length; ) {
      const d = this.attachers[g];
      t.use(...d);
    }
    return t.data(extend$4(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, g) {
    return typeof t == "string" ? arguments.length === 2 ? (assertUnfrozen("data", this.frozen), this.namespace[t] = g, this) : own$5.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (assertUnfrozen("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [g, ...d] = this.attachers[this.freezeIndex];
      if (d[0] === !1)
        continue;
      d[0] === !0 && (d[0] = void 0);
      const k = g.call(t, ...d);
      typeof k == "function" && this.transformers.use(k);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const g = vfile(t), d = this.parser || this.Parser;
    return assertParser("parse", d), d(String(g), g);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, g) {
    const d = this;
    return this.freeze(), assertParser("process", this.parser || this.Parser), assertCompiler("process", this.compiler || this.Compiler), g ? k(void 0, g) : new Promise(k);
    function k(H, AA) {
      const gA = vfile(t), IA = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        d.parse(gA)
      );
      d.run(IA, gA, function(BA, eA, iA) {
        if (BA || !eA || !iA)
          return CA(BA);
        const QA = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          eA
        ), tA = d.stringify(QA, iA);
        looksLikeAValue(tA) ? iA.value = tA : iA.result = tA, CA(
          BA,
          /** @type {VFileWithOutput<CompileResult>} */
          iA
        );
      });
      function CA(BA, eA) {
        BA || !eA ? AA(BA) : H ? H(eA) : g(void 0, eA);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let g = !1, d;
    return this.freeze(), assertParser("processSync", this.parser || this.Parser), assertCompiler("processSync", this.compiler || this.Compiler), this.process(t, k), assertDone("processSync", "process", g), d;
    function k(H, AA) {
      g = !0, bail(H), d = AA;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, g, d) {
    assertNode(t), this.freeze();
    const k = this.transformers;
    return !d && typeof g == "function" && (d = g, g = void 0), d ? H(void 0, d) : new Promise(H);
    function H(AA, gA) {
      const IA = vfile(g);
      k.run(t, IA, CA);
      function CA(BA, eA, iA) {
        const QA = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          eA || t
        );
        BA ? gA(BA) : AA ? AA(QA) : d(void 0, QA, iA);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, g) {
    let d = !1, k;
    return this.run(t, g, H), assertDone("runSync", "run", d), k;
    function H(AA, gA) {
      bail(AA), k = gA, d = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, g) {
    this.freeze();
    const d = vfile(g), k = this.compiler || this.Compiler;
    return assertCompiler("stringify", k), assertNode(t), k(t, d);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...g) {
    const d = this.attachers, k = this.namespace;
    if (assertUnfrozen("use", this.frozen), t != null) if (typeof t == "function")
      IA(t, g);
    else if (typeof t == "object")
      Array.isArray(t) ? gA(t) : AA(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function H(CA) {
      if (typeof CA == "function")
        IA(CA, []);
      else if (typeof CA == "object")
        if (Array.isArray(CA)) {
          const [BA, ...eA] = (
            /** @type {PluginTuple<Array<unknown>>} */
            CA
          );
          IA(BA, eA);
        } else
          AA(CA);
      else
        throw new TypeError("Expected usable value, not `" + CA + "`");
    }
    function AA(CA) {
      if (!("plugins" in CA) && !("settings" in CA))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      gA(CA.plugins), CA.settings && (k.settings = extend$4(!0, k.settings, CA.settings));
    }
    function gA(CA) {
      let BA = -1;
      if (CA != null) if (Array.isArray(CA))
        for (; ++BA < CA.length; ) {
          const eA = CA[BA];
          H(eA);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + CA + "`");
    }
    function IA(CA, BA) {
      let eA = -1, iA = -1;
      for (; ++eA < d.length; )
        if (d[eA][0] === CA) {
          iA = eA;
          break;
        }
      if (iA === -1)
        d.push([CA, ...BA]);
      else if (BA.length > 0) {
        let [QA, ...tA] = BA;
        const oA = d[iA][1];
        isPlainObject$3(oA) && isPlainObject$3(QA) && (QA = extend$4(!0, oA, QA)), d[iA] = [CA, QA, ...tA];
      }
    }
  }
}
const unified = new Processor().freeze();
function assertParser(n, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + n + "` without `parser`");
}
function assertCompiler(n, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + n + "` without `compiler`");
}
function assertUnfrozen(n, t) {
  if (t)
    throw new Error(
      "Cannot call `" + n + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function assertNode(n) {
  if (!isPlainObject$3(n) || typeof n.type != "string")
    throw new TypeError("Expected node, got `" + n + "`");
}
function assertDone(n, t, g) {
  if (!g)
    throw new Error(
      "`" + n + "` finished async. Use `" + t + "` instead"
    );
}
function vfile(n) {
  return looksLikeAVFile(n) ? n : new VFile(n);
}
function looksLikeAVFile(n) {
  return !!(n && typeof n == "object" && "message" in n && "messages" in n);
}
function looksLikeAValue(n) {
  return typeof n == "string" || isUint8Array(n);
}
function isUint8Array(n) {
  return !!(n && typeof n == "object" && "byteLength" in n && "byteOffset" in n);
}
const changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", emptyPlugins = [], emptyRemarkRehypeOptions = { allowDangerousHtml: !0 }, safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i, deprecations$1 = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Markdown$2(n) {
  const t = createProcessor(n), g = createFile(n);
  return post$1(t.runSync(t.parse(g), g), n);
}
function createProcessor(n) {
  const t = n.rehypePlugins || emptyPlugins, g = n.remarkPlugins || emptyPlugins, d = n.remarkRehypeOptions ? { ...n.remarkRehypeOptions, ...emptyRemarkRehypeOptions } : emptyRemarkRehypeOptions;
  return unified().use(remarkParse).use(g).use(remarkRehype, d).use(t);
}
function createFile(n) {
  const t = n.children || "", g = new VFile();
  return typeof t == "string" && (g.value = t), g;
}
function post$1(n, t) {
  const g = t.allowedElements, d = t.allowElement, k = t.components, H = t.disallowedElements, AA = t.skipHtml, gA = t.unwrapDisallowed, IA = t.urlTransform || defaultUrlTransform;
  for (const BA of deprecations$1)
    Object.hasOwn(t, BA.from) && ("" + BA.from + (BA.to ? "use `" + BA.to + "` instead" : "remove it") + changelog + BA.id, void 0);
  return visit$1(n, CA), toJsxRuntime(n, {
    Fragment: jsxRuntimeExports.Fragment,
    components: k,
    ignoreInvalidStyle: !0,
    jsx: jsxRuntimeExports.jsx,
    jsxs: jsxRuntimeExports.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function CA(BA, eA, iA) {
    if (BA.type === "raw" && iA && typeof eA == "number")
      return AA ? iA.children.splice(eA, 1) : iA.children[eA] = { type: "text", value: BA.value }, eA;
    if (BA.type === "element") {
      let QA;
      for (QA in urlAttributes)
        if (Object.hasOwn(urlAttributes, QA) && Object.hasOwn(BA.properties, QA)) {
          const tA = BA.properties[QA], oA = urlAttributes[QA];
          (oA === null || oA.includes(BA.tagName)) && (BA.properties[QA] = IA(String(tA || ""), QA, BA));
        }
    }
    if (BA.type === "element") {
      let QA = g ? !g.includes(BA.tagName) : H ? H.includes(BA.tagName) : !1;
      if (!QA && d && typeof eA == "number" && (QA = !d(BA, eA, iA)), QA && iA && typeof eA == "number")
        return gA && BA.children ? iA.children.splice(eA, 1, ...BA.children) : iA.children.splice(eA, 1), eA;
    }
  }
}
function defaultUrlTransform(n) {
  const t = n.indexOf(":"), g = n.indexOf("?"), d = n.indexOf("#"), k = n.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    k !== -1 && t > k || g !== -1 && t > g || d !== -1 && t > d || // It is a protocol, it should be allowed.
    safeProtocol.test(n.slice(0, t)) ? n : ""
  );
}
const search = /[#.]/g;
function parseSelector$1(n, t) {
  const g = n || "", d = {};
  let k = 0, H, AA;
  for (; k < g.length; ) {
    search.lastIndex = k;
    const gA = search.exec(g), IA = g.slice(k, gA ? gA.index : g.length);
    IA && (H ? H === "#" ? d.id = IA : Array.isArray(d.className) ? d.className.push(IA) : d.className = [IA] : AA = IA, k += IA.length), gA && (H = gA[0], k++);
  }
  return {
    type: "element",
    // @ts-expect-error: tag name is parsed.
    tagName: AA || t || "div",
    properties: d,
    children: []
  };
}
function createH(n, t, g) {
  const d = g ? createAdjustMap(g) : void 0;
  function k(H, AA, ...gA) {
    let IA;
    if (H == null) {
      IA = { type: "root", children: [] };
      const CA = (
        /** @type {Child} */
        AA
      );
      gA.unshift(CA);
    } else {
      IA = parseSelector$1(H, t);
      const CA = IA.tagName.toLowerCase(), BA = d ? d.get(CA) : void 0;
      if (IA.tagName = BA || CA, isChild(AA))
        gA.unshift(AA);
      else
        for (const [eA, iA] of Object.entries(AA))
          addProperty(n, IA.properties, eA, iA);
    }
    for (const CA of gA)
      addChild(IA.children, CA);
    return IA.type === "element" && IA.tagName === "template" && (IA.content = { type: "root", children: IA.children }, IA.children = []), IA;
  }
  return k;
}
function isChild(n) {
  if (n === null || typeof n != "object" || Array.isArray(n))
    return !0;
  if (typeof n.type != "string") return !1;
  const t = (
    /** @type {Record<string, unknown>} */
    n
  ), g = Object.keys(n);
  for (const d of g) {
    const k = t[d];
    if (k && typeof k == "object") {
      if (!Array.isArray(k)) return !0;
      const H = (
        /** @type {ReadonlyArray<unknown>} */
        k
      );
      for (const AA of H)
        if (typeof AA != "number" && typeof AA != "string")
          return !0;
    }
  }
  return !!("children" in n && Array.isArray(n.children));
}
function addProperty(n, t, g, d) {
  const k = find$4(n, g);
  let H;
  if (d != null) {
    if (typeof d == "number") {
      if (Number.isNaN(d)) return;
      H = d;
    } else typeof d == "boolean" ? H = d : typeof d == "string" ? k.spaceSeparated ? H = parse$9(d) : k.commaSeparated ? H = parse$a(d) : k.commaOrSpaceSeparated ? H = parse$9(parse$a(d).join(" ")) : H = parsePrimitive(k, k.property, d) : Array.isArray(d) ? H = [...d] : H = k.property === "style" ? style$1(d) : String(d);
    if (Array.isArray(H)) {
      const AA = [];
      for (const gA of H)
        AA.push(
          /** @type {number | string} */
          parsePrimitive(k, k.property, gA)
        );
      H = AA;
    }
    k.property === "className" && Array.isArray(t.className) && (H = t.className.concat(
      /** @type {Array<number | string> | number | string} */
      H
    )), t[k.property] = H;
  }
}
function addChild(n, t) {
  if (t != null) if (typeof t == "number" || typeof t == "string")
    n.push({ type: "text", value: String(t) });
  else if (Array.isArray(t))
    for (const g of t)
      addChild(n, g);
  else if (typeof t == "object" && "type" in t)
    t.type === "root" ? addChild(n, t.children) : n.push(t);
  else
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function parsePrimitive(n, t, g) {
  if (typeof g == "string") {
    if (n.number && g && !Number.isNaN(Number(g)))
      return Number(g);
    if ((n.boolean || n.overloadedBoolean) && (g === "" || normalize$5(g) === normalize$5(t)))
      return !0;
  }
  return g;
}
function style$1(n) {
  const t = [];
  for (const [g, d] of Object.entries(n))
    t.push([g, d].join(": "));
  return t.join("; ");
}
function createAdjustMap(n) {
  const t = /* @__PURE__ */ new Map();
  for (const g of n)
    t.set(g.toLowerCase(), g);
  return t;
}
const svgCaseSensitiveTagNames = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], h$1 = createH(html$5, "div"), s$1 = createH(svg$2, "g", svgCaseSensitiveTagNames), webNamespaces = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function fromDom(n, t) {
  return transform$4(n, {}) || { type: "root", children: [] };
}
function transform$4(n, t) {
  const g = one$6(n, t);
  return g && t.afterTransform && t.afterTransform(n, g), g;
}
function one$6(n, t) {
  switch (n.nodeType) {
    case 1:
      return element$6(
        /** @type {Element} */
        n,
        t
      );
    // Ignore: Attr (2).
    case 3:
      return text$8(
        /** @type {Text} */
        n
      );
    // Ignore: CDATA (4).
    // Removed: Entity reference (5)
    // Removed: Entity (6)
    // Ignore: Processing instruction (7).
    case 8:
      return comment$2(
        /** @type {Comment} */
        n
      );
    case 9:
      return root$6(
        /** @type {Document} */
        n,
        t
      );
    case 10:
      return doctype$2();
    case 11:
      return root$6(
        /** @type {DocumentFragment} */
        n,
        t
      );
    default:
      return;
  }
}
function root$6(n, t) {
  return { type: "root", children: all$4(n, t) };
}
function doctype$2() {
  return { type: "doctype" };
}
function text$8(n) {
  return { type: "text", value: n.nodeValue || "" };
}
function comment$2(n) {
  return { type: "comment", value: n.nodeValue || "" };
}
function element$6(n, t) {
  const g = n.namespaceURI, d = g === webNamespaces.svg ? s$1 : h$1, k = g === webNamespaces.html ? n.tagName.toLowerCase() : n.tagName, H = (
    // @ts-expect-error: DOM types are wrong, content can exist.
    g === webNamespaces.html && k === "template" ? n.content : n
  ), AA = n.getAttributeNames(), gA = {};
  let IA = -1;
  for (; ++IA < AA.length; )
    gA[AA[IA]] = n.getAttribute(AA[IA]) || "";
  return d(k, gA, all$4(H, t));
}
function all$4(n, t) {
  const g = n.childNodes, d = [];
  let k = -1;
  for (; ++k < g.length; ) {
    const H = transform$4(g[k], t);
    H !== void 0 && d.push(H);
  }
  return d;
}
new DOMParser();
function fromHtmlIsomorphic(n, t) {
  const g = parseFragment(n);
  return (
    /** @type {Root} */
    fromDom(g)
  );
}
function parseFragment(n) {
  const t = document.createElement("template");
  return t.innerHTML = n, t.content;
}
const findAfter = (
  // Note: overloads like this are needed to support optional generics.
  /**
   * @type {(
   *   (<Kind extends UnistParent, Check extends Test>(parent: Kind, index: Child<Kind> | number, test: Check) => Matches<Child<Kind>, Check> | undefined) &
   *   (<Kind extends UnistParent>(parent: Kind, index: Child<Kind> | number, test?: null | undefined) => Child<Kind> | undefined)
   * )}
   */
  /**
   * @param {UnistParent} parent
   * @param {UnistNode | number} index
   * @param {Test} [test]
   * @returns {UnistNode | undefined}
   */
  (function(n, t, g) {
    const d = convert(g);
    if (!n || !n.type || !n.children)
      throw new Error("Expected parent node");
    if (typeof t == "number") {
      if (t < 0 || t === Number.POSITIVE_INFINITY)
        throw new Error("Expected positive finite number as index");
    } else if (t = n.children.indexOf(t), t < 0)
      throw new Error("Expected child node or index");
    for (; ++t < n.children.length; )
      if (d(n.children[t], t, n))
        return n.children[t];
  })
), convertElement = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends TestFunction>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & Predicate<Condition, Element>) &
   *   (<Condition extends string>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & {tagName: Condition}) &
   *   ((test?: null | undefined) => (element?: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test | null | undefined} [test]
   * @returns {Check}
   */
  (function(n) {
    if (n == null)
      return element$5;
    if (typeof n == "string")
      return tagNameFactory(n);
    if (typeof n == "object")
      return anyFactory(n);
    if (typeof n == "function")
      return castFactory(n);
    throw new Error("Expected function, string, or array as `test`");
  })
);
function anyFactory(n) {
  const t = [];
  let g = -1;
  for (; ++g < n.length; )
    t[g] = convertElement(n[g]);
  return castFactory(d);
  function d(...k) {
    let H = -1;
    for (; ++H < t.length; )
      if (t[H].apply(this, k)) return !0;
    return !1;
  }
}
function tagNameFactory(n) {
  return castFactory(t);
  function t(g) {
    return g.tagName === n;
  }
}
function castFactory(n) {
  return t;
  function t(g, d, k) {
    return !!(looksLikeAnElement(g) && n.call(
      this,
      g,
      typeof d == "number" ? d : void 0,
      k || void 0
    ));
  }
}
function element$5(n) {
  return !!(n && typeof n == "object" && "type" in n && n.type === "element" && "tagName" in n && typeof n.tagName == "string");
}
function looksLikeAnElement(n) {
  return n !== null && typeof n == "object" && "type" in n && "tagName" in n;
}
const searchLineFeeds = /\n/g, searchTabOrSpaces = /[\t ]+/g, br$1 = convertElement("br"), cell$1 = convertElement(isCell), p = convertElement("p"), row = convertElement("tr"), notRendered = convertElement([
  // List from: <https://html.spec.whatwg.org/multipage/rendering.html#hidden-elements>
  "datalist",
  "head",
  "noembed",
  "noframes",
  "noscript",
  // Act as if we support scripting.
  "rp",
  "script",
  "style",
  "template",
  "title",
  // Hidden attribute.
  hidden,
  // From: <https://html.spec.whatwg.org/multipage/rendering.html#flow-content-3>
  closedDialog
]), blockOrCaption = convertElement([
  "address",
  // Flow content
  "article",
  // Sections and headings
  "aside",
  // Sections and headings
  "blockquote",
  // Flow content
  "body",
  // Page
  "caption",
  // `table-caption`
  "center",
  // Flow content (legacy)
  "dd",
  // Lists
  "dialog",
  // Flow content
  "dir",
  // Lists (legacy)
  "dl",
  // Lists
  "dt",
  // Lists
  "div",
  // Flow content
  "figure",
  // Flow content
  "figcaption",
  // Flow content
  "footer",
  // Flow content
  "form,",
  // Flow content
  "h1",
  // Sections and headings
  "h2",
  // Sections and headings
  "h3",
  // Sections and headings
  "h4",
  // Sections and headings
  "h5",
  // Sections and headings
  "h6",
  // Sections and headings
  "header",
  // Flow content
  "hgroup",
  // Sections and headings
  "hr",
  // Flow content
  "html",
  // Page
  "legend",
  // Flow content
  "li",
  // Lists (as `display: list-item`)
  "listing",
  // Flow content (legacy)
  "main",
  // Flow content
  "menu",
  // Lists
  "nav",
  // Sections and headings
  "ol",
  // Lists
  "p",
  // Flow content
  "plaintext",
  // Flow content (legacy)
  "pre",
  // Flow content
  "section",
  // Sections and headings
  "ul",
  // Lists
  "xmp"
  // Flow content (legacy)
]);
function toText(n, t) {
  const g = t || {}, d = "children" in n ? n.children : [], k = blockOrCaption(n), H = inferWhitespace(n, {
    whitespace: g.whitespace || "normal"
  }), AA = [];
  (n.type === "text" || n.type === "comment") && AA.push(
    ...collectText(n, {
      breakBefore: !0,
      breakAfter: !0
    })
  );
  let gA = -1;
  for (; ++gA < d.length; )
    AA.push(
      ...renderedTextCollection(
        d[gA],
        // @ts-expect-error: `tree` is a parent if we’re here.
        n,
        {
          whitespace: H,
          breakBefore: gA ? void 0 : k,
          breakAfter: gA < d.length - 1 ? br$1(d[gA + 1]) : k
        }
      )
    );
  const IA = [];
  let CA;
  for (gA = -1; ++gA < AA.length; ) {
    const BA = AA[gA];
    typeof BA == "number" ? CA !== void 0 && BA > CA && (CA = BA) : BA && (CA !== void 0 && CA > -1 && IA.push(`
`.repeat(CA) || " "), CA = -1, IA.push(BA));
  }
  return IA.join("");
}
function renderedTextCollection(n, t, g) {
  return n.type === "element" ? collectElement(n, t, g) : n.type === "text" ? g.whitespace === "normal" ? collectText(n, g) : collectPreText(n) : [];
}
function collectElement(n, t, g) {
  const d = inferWhitespace(n, g), k = n.children || [];
  let H = -1, AA = [];
  if (notRendered(n))
    return AA;
  let gA, IA;
  for (br$1(n) || row(n) && // @ts-expect-error: something up with types of parents.
  findAfter(t, n, row) ? IA = `
` : p(n) ? (gA = 2, IA = 2) : blockOrCaption(n) && (gA = 1, IA = 1); ++H < k.length; )
    AA = AA.concat(
      renderedTextCollection(k[H], n, {
        whitespace: d,
        breakBefore: H ? void 0 : gA,
        breakAfter: H < k.length - 1 ? br$1(k[H + 1]) : IA
      })
    );
  return cell$1(n) && // @ts-expect-error: something up with types of parents.
  findAfter(t, n, cell$1) && AA.push("	"), gA && AA.unshift(gA), IA && AA.push(IA), AA;
}
function collectText(n, t) {
  const g = String(n.value), d = [], k = [];
  let H = 0;
  for (; H <= g.length; ) {
    searchLineFeeds.lastIndex = H;
    const IA = searchLineFeeds.exec(g), CA = IA && "index" in IA ? IA.index : g.length;
    d.push(
      // Any sequence of collapsible spaces and tabs immediately preceding or
      // following a segment break is removed.
      trimAndCollapseSpacesAndTabs(
        // […] ignoring bidi formatting characters (characters with the
        // Bidi_Control property [UAX9]: ALM, LTR, RTL, LRE-RLO, LRI-PDI) as if
        // they were not there.
        g.slice(H, CA).replace(/[\u061C\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, ""),
        H === 0 ? t.breakBefore : !0,
        CA === g.length ? t.breakAfter : !0
      )
    ), H = CA + 1;
  }
  let AA = -1, gA;
  for (; ++AA < d.length; )
    d[AA].charCodeAt(d[AA].length - 1) === 8203 || AA < d.length - 1 && d[AA + 1].charCodeAt(0) === 8203 ? (k.push(d[AA]), gA = void 0) : d[AA] ? (typeof gA == "number" && k.push(gA), k.push(d[AA]), gA = 0) : (AA === 0 || AA === d.length - 1) && k.push(0);
  return k;
}
function collectPreText(n) {
  return [String(n.value)];
}
function trimAndCollapseSpacesAndTabs(n, t, g) {
  const d = [];
  let k = 0, H;
  for (; k < n.length; ) {
    searchTabOrSpaces.lastIndex = k;
    const AA = searchTabOrSpaces.exec(n);
    H = AA ? AA.index : n.length, !k && !H && AA && !t && d.push(""), k !== H && d.push(n.slice(k, H)), k = AA ? H + AA[0].length : H;
  }
  return k !== H && !g && d.push(""), d.join(" ");
}
function inferWhitespace(n, t) {
  if (n.type === "element") {
    const g = n.properties || {};
    switch (n.tagName) {
      case "listing":
      case "plaintext":
      case "xmp":
        return "pre";
      case "nobr":
        return "nowrap";
      case "pre":
        return g.wrap ? "pre-wrap" : "pre";
      case "td":
      case "th":
        return g.noWrap ? "nowrap" : t.whitespace;
      case "textarea":
        return "pre-wrap";
    }
  }
  return t.whitespace;
}
function hidden(n) {
  return !!(n.properties || {}).hidden;
}
function isCell(n) {
  return n.tagName === "td" || n.tagName === "th";
}
function closedDialog(n) {
  return n.tagName === "dialog" && !(n.properties || {}).open;
}
class SourceLocation {
  // The + prefix indicates that these fields aren't writeable
  // Lexer holding the input string.
  // Start offset, zero-based inclusive.
  // End offset, zero-based exclusive.
  constructor(t, g, d) {
    this.lexer = void 0, this.start = void 0, this.end = void 0, this.lexer = t, this.start = g, this.end = d;
  }
  /**
   * Merges two `SourceLocation`s from location providers, given they are
   * provided in order of appearance.
   * - Returns the first one's location if only the first is provided.
   * - Returns a merged range of the first and the last if both are provided
   *   and their lexers match.
   * - Otherwise, returns null.
   */
  static range(t, g) {
    return g ? !t || !t.loc || !g.loc || t.loc.lexer !== g.loc.lexer ? null : new SourceLocation(t.loc.lexer, t.loc.start, g.loc.end) : t && t.loc;
  }
}
class Token {
  // don't expand the token
  // used in \noexpand
  constructor(t, g) {
    this.text = void 0, this.loc = void 0, this.noexpand = void 0, this.treatAsRelax = void 0, this.text = t, this.loc = g;
  }
  /**
   * Given a pair of tokens (this and endToken), compute a `Token` encompassing
   * the whole input range enclosed by these two.
   */
  range(t, g) {
    return new Token(g, SourceLocation.range(this, t));
  }
}
class ParseError {
  // Error start position based on passed-in Token or ParseNode.
  // Length of affected text based on passed-in Token or ParseNode.
  // The underlying error message without any context added.
  constructor(t, g) {
    this.name = void 0, this.position = void 0, this.length = void 0, this.rawMessage = void 0;
    var d = "KaTeX parse error: " + t, k, H, AA = g && g.loc;
    if (AA && AA.start <= AA.end) {
      var gA = AA.lexer.input;
      k = AA.start, H = AA.end, k === gA.length ? d += " at end of input: " : d += " at position " + (k + 1) + ": ";
      var IA = gA.slice(k, H).replace(/[^]/g, "$&̲"), CA;
      k > 15 ? CA = "…" + gA.slice(k - 15, k) : CA = gA.slice(0, k);
      var BA;
      H + 15 < gA.length ? BA = gA.slice(H, H + 15) + "…" : BA = gA.slice(H), d += CA + IA + BA;
    }
    var eA = new Error(d);
    return eA.name = "ParseError", eA.__proto__ = ParseError.prototype, eA.position = k, k != null && H != null && (eA.length = H - k), eA.rawMessage = t, eA;
  }
}
ParseError.prototype.__proto__ = Error.prototype;
var deflt = function n(t, g) {
  return t === void 0 ? g : t;
}, uppercase = /([A-Z])/g, hyphenate = function n(t) {
  return t.replace(uppercase, "-$1").toLowerCase();
}, ESCAPE_LOOKUP = {
  "&": "&amp;",
  ">": "&gt;",
  "<": "&lt;",
  '"': "&quot;",
  "'": "&#x27;"
}, ESCAPE_REGEX = /[&><"']/g;
function escape$2(n) {
  return String(n).replace(ESCAPE_REGEX, (t) => ESCAPE_LOOKUP[t]);
}
var getBaseElem = function n(t) {
  return t.type === "ordgroup" || t.type === "color" ? t.body.length === 1 ? n(t.body[0]) : t : t.type === "font" ? n(t.body) : t;
}, isCharacterBox = function n(t) {
  var g = getBaseElem(t);
  return g.type === "mathord" || g.type === "textord" || g.type === "atom";
}, assert$2 = function n(t) {
  if (!t)
    throw new Error("Expected non-null, but got " + String(t));
  return t;
}, protocolFromUrl = function n(t) {
  var g = /^[\x00-\x20]*([^\\/#?]*?)(:|&#0*58|&#x0*3a|&colon)/i.exec(t);
  return g ? g[2] !== ":" || !/^[a-zA-Z][a-zA-Z0-9+\-.]*$/.test(g[1]) ? null : g[1].toLowerCase() : "_relative";
}, utils$2 = {
  deflt,
  escape: escape$2,
  hyphenate,
  getBaseElem,
  isCharacterBox,
  protocolFromUrl
}, SETTINGS_SCHEMA = {
  displayMode: {
    type: "boolean",
    description: "Render math in display mode, which puts the math in display style (so \\int and \\sum are large, for example), and centers the math on the page on its own line.",
    cli: "-d, --display-mode"
  },
  output: {
    type: {
      enum: ["htmlAndMathml", "html", "mathml"]
    },
    description: "Determines the markup language of the output.",
    cli: "-F, --format <type>"
  },
  leqno: {
    type: "boolean",
    description: "Render display math in leqno style (left-justified tags)."
  },
  fleqn: {
    type: "boolean",
    description: "Render display math flush left."
  },
  throwOnError: {
    type: "boolean",
    default: !0,
    cli: "-t, --no-throw-on-error",
    cliDescription: "Render errors (in the color given by --error-color) instead of throwing a ParseError exception when encountering an error."
  },
  errorColor: {
    type: "string",
    default: "#cc0000",
    cli: "-c, --error-color <color>",
    cliDescription: "A color string given in the format 'rgb' or 'rrggbb' (no #). This option determines the color of errors rendered by the -t option.",
    cliProcessor: (n) => "#" + n
  },
  macros: {
    type: "object",
    cli: "-m, --macro <def>",
    cliDescription: "Define custom macro of the form '\\foo:expansion' (use multiple -m arguments for multiple macros).",
    cliDefault: [],
    cliProcessor: (n, t) => (t.push(n), t)
  },
  minRuleThickness: {
    type: "number",
    description: "Specifies a minimum thickness, in ems, for fraction lines, `\\sqrt` top lines, `{array}` vertical lines, `\\hline`, `\\hdashline`, `\\underline`, `\\overline`, and the borders of `\\fbox`, `\\boxed`, and `\\fcolorbox`.",
    processor: (n) => Math.max(0, n),
    cli: "--min-rule-thickness <size>",
    cliProcessor: parseFloat
  },
  colorIsTextColor: {
    type: "boolean",
    description: "Makes \\color behave like LaTeX's 2-argument \\textcolor, instead of LaTeX's one-argument \\color mode change.",
    cli: "-b, --color-is-text-color"
  },
  strict: {
    type: [{
      enum: ["warn", "ignore", "error"]
    }, "boolean", "function"],
    description: "Turn on strict / LaTeX faithfulness mode, which throws an error if the input uses features that are not supported by LaTeX.",
    cli: "-S, --strict",
    cliDefault: !1
  },
  trust: {
    type: ["boolean", "function"],
    description: "Trust the input, enabling all HTML features such as \\url.",
    cli: "-T, --trust"
  },
  maxSize: {
    type: "number",
    default: 1 / 0,
    description: "If non-zero, all user-specified sizes, e.g. in \\rule{500em}{500em}, will be capped to maxSize ems. Otherwise, elements and spaces can be arbitrarily large",
    processor: (n) => Math.max(0, n),
    cli: "-s, --max-size <n>",
    cliProcessor: parseInt
  },
  maxExpand: {
    type: "number",
    default: 1e3,
    description: "Limit the number of macro expansions to the specified number, to prevent e.g. infinite macro loops. If set to Infinity, the macro expander will try to fully expand as in LaTeX.",
    processor: (n) => Math.max(0, n),
    cli: "-e, --max-expand <n>",
    cliProcessor: (n) => n === "Infinity" ? 1 / 0 : parseInt(n)
  },
  globalGroup: {
    type: "boolean",
    cli: !1
  }
};
function getDefaultValue(n) {
  if (n.default)
    return n.default;
  var t = n.type, g = Array.isArray(t) ? t[0] : t;
  if (typeof g != "string")
    return g.enum[0];
  switch (g) {
    case "boolean":
      return !1;
    case "string":
      return "";
    case "number":
      return 0;
    case "object":
      return {};
  }
}
class Settings {
  constructor(t) {
    this.displayMode = void 0, this.output = void 0, this.leqno = void 0, this.fleqn = void 0, this.throwOnError = void 0, this.errorColor = void 0, this.macros = void 0, this.minRuleThickness = void 0, this.colorIsTextColor = void 0, this.strict = void 0, this.trust = void 0, this.maxSize = void 0, this.maxExpand = void 0, this.globalGroup = void 0, t = t || {};
    for (var g in SETTINGS_SCHEMA)
      if (SETTINGS_SCHEMA.hasOwnProperty(g)) {
        var d = SETTINGS_SCHEMA[g];
        this[g] = t[g] !== void 0 ? d.processor ? d.processor(t[g]) : t[g] : getDefaultValue(d);
      }
  }
  /**
   * Report nonstrict (non-LaTeX-compatible) input.
   * Can safely not be called if `this.strict` is false in JavaScript.
   */
  reportNonstrict(t, g, d) {
    var k = this.strict;
    if (typeof k == "function" && (k = k(t, g, d)), !(!k || k === "ignore")) {
      if (k === !0 || k === "error")
        throw new ParseError("LaTeX-incompatible input and strict mode is set to 'error': " + (g + " [" + t + "]"), d);
      k === "warn" ? typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (g + " [" + t + "]")) : typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + k + "': " + g + " [" + t + "]"));
    }
  }
  /**
   * Check whether to apply strict (LaTeX-adhering) behavior for unusual
   * input (like `\\`).  Unlike `nonstrict`, will not throw an error;
   * instead, "error" translates to a return value of `true`, while "ignore"
   * translates to a return value of `false`.  May still print a warning:
   * "warn" prints a warning and returns `false`.
   * This is for the second category of `errorCode`s listed in the README.
   */
  useStrictBehavior(t, g, d) {
    var k = this.strict;
    if (typeof k == "function")
      try {
        k = k(t, g, d);
      } catch {
        k = "error";
      }
    return !k || k === "ignore" ? !1 : k === !0 || k === "error" ? !0 : k === "warn" ? (typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (g + " [" + t + "]")), !1) : (typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + k + "': " + g + " [" + t + "]")), !1);
  }
  /**
   * Check whether to test potentially dangerous input, and return
   * `true` (trusted) or `false` (untrusted).  The sole argument `context`
   * should be an object with `command` field specifying the relevant LaTeX
   * command (as a string starting with `\`), and any other arguments, etc.
   * If `context` has a `url` field, a `protocol` field will automatically
   * get added by this function (changing the specified object).
   */
  isTrusted(t) {
    if (t.url && !t.protocol) {
      var g = utils$2.protocolFromUrl(t.url);
      if (g == null)
        return !1;
      t.protocol = g;
    }
    var d = typeof this.trust == "function" ? this.trust(t) : this.trust;
    return !!d;
  }
}
class Style {
  constructor(t, g, d) {
    this.id = void 0, this.size = void 0, this.cramped = void 0, this.id = t, this.size = g, this.cramped = d;
  }
  /**
   * Get the style of a superscript given a base in the current style.
   */
  sup() {
    return styles$1[sup[this.id]];
  }
  /**
   * Get the style of a subscript given a base in the current style.
   */
  sub() {
    return styles$1[sub[this.id]];
  }
  /**
   * Get the style of a fraction numerator given the fraction in the current
   * style.
   */
  fracNum() {
    return styles$1[fracNum[this.id]];
  }
  /**
   * Get the style of a fraction denominator given the fraction in the current
   * style.
   */
  fracDen() {
    return styles$1[fracDen[this.id]];
  }
  /**
   * Get the cramped version of a style (in particular, cramping a cramped style
   * doesn't change the style).
   */
  cramp() {
    return styles$1[cramp[this.id]];
  }
  /**
   * Get a text or display version of this style.
   */
  text() {
    return styles$1[text$1$1[this.id]];
  }
  /**
   * Return true if this style is tightly spaced (scriptstyle/scriptscriptstyle)
   */
  isTight() {
    return this.size >= 2;
  }
}
var D$3 = 0, Dc = 1, T$1 = 2, Tc = 3, S = 4, Sc = 5, SS = 6, SSc = 7, styles$1 = [new Style(D$3, 0, !1), new Style(Dc, 0, !0), new Style(T$1, 1, !1), new Style(Tc, 1, !0), new Style(S, 2, !1), new Style(Sc, 2, !0), new Style(SS, 3, !1), new Style(SSc, 3, !0)], sup = [S, Sc, S, Sc, SS, SSc, SS, SSc], sub = [Sc, Sc, Sc, Sc, SSc, SSc, SSc, SSc], fracNum = [T$1, Tc, S, Sc, SS, SSc, SS, SSc], fracDen = [Tc, Tc, Sc, Sc, SSc, SSc, SSc, SSc], cramp = [Dc, Dc, Tc, Tc, Sc, Sc, SSc, SSc], text$1$1 = [D$3, Dc, T$1, Tc, T$1, Tc, T$1, Tc], Style$1 = {
  DISPLAY: styles$1[D$3],
  TEXT: styles$1[T$1],
  SCRIPT: styles$1[S],
  SCRIPTSCRIPT: styles$1[SS]
}, scriptData = [{
  // Latin characters beyond the Latin-1 characters we have metrics for.
  // Needed for Czech, Hungarian and Turkish text, for example.
  name: "latin",
  blocks: [
    [256, 591],
    // Latin Extended-A and Latin Extended-B
    [768, 879]
    // Combining Diacritical marks
  ]
}, {
  // The Cyrillic script used by Russian and related languages.
  // A Cyrillic subset used to be supported as explicitly defined
  // symbols in symbols.js
  name: "cyrillic",
  blocks: [[1024, 1279]]
}, {
  // Armenian
  name: "armenian",
  blocks: [[1328, 1423]]
}, {
  // The Brahmic scripts of South and Southeast Asia
  // Devanagari (0900–097F)
  // Bengali (0980–09FF)
  // Gurmukhi (0A00–0A7F)
  // Gujarati (0A80–0AFF)
  // Oriya (0B00–0B7F)
  // Tamil (0B80–0BFF)
  // Telugu (0C00–0C7F)
  // Kannada (0C80–0CFF)
  // Malayalam (0D00–0D7F)
  // Sinhala (0D80–0DFF)
  // Thai (0E00–0E7F)
  // Lao (0E80–0EFF)
  // Tibetan (0F00–0FFF)
  // Myanmar (1000–109F)
  name: "brahmic",
  blocks: [[2304, 4255]]
}, {
  name: "georgian",
  blocks: [[4256, 4351]]
}, {
  // Chinese and Japanese.
  // The "k" in cjk is for Korean, but we've separated Korean out
  name: "cjk",
  blocks: [
    [12288, 12543],
    // CJK symbols and punctuation, Hiragana, Katakana
    [19968, 40879],
    // CJK ideograms
    [65280, 65376]
    // Fullwidth punctuation
    // TODO: add halfwidth Katakana and Romanji glyphs
  ]
}, {
  // Korean
  name: "hangul",
  blocks: [[44032, 55215]]
}];
function scriptFromCodepoint(n) {
  for (var t = 0; t < scriptData.length; t++)
    for (var g = scriptData[t], d = 0; d < g.blocks.length; d++) {
      var k = g.blocks[d];
      if (n >= k[0] && n <= k[1])
        return g.name;
    }
  return null;
}
var allBlocks = [];
scriptData.forEach((n) => n.blocks.forEach((t) => allBlocks.push(...t)));
function supportedCodepoint(n) {
  for (var t = 0; t < allBlocks.length; t += 2)
    if (n >= allBlocks[t] && n <= allBlocks[t + 1])
      return !0;
  return !1;
}
var hLinePad = 80, sqrtMain = function n(t, g) {
  return "M95," + (622 + t + g) + `
c-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14
c0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54
c44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10
s173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429
c69,-144,104.5,-217.7,106.5,-221
l` + t / 2.075 + " -" + t + `
c5.3,-9.3,12,-14,20,-14
H400000v` + (40 + t) + `H845.2724
s-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7
c-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47z
M` + (834 + t) + " " + g + "h400000v" + (40 + t) + "h-400000z";
}, sqrtSize1 = function n(t, g) {
  return "M263," + (601 + t + g) + `c0.7,0,18,39.7,52,119
c34,79.3,68.167,158.7,102.5,238c34.3,79.3,51.8,119.3,52.5,120
c340,-704.7,510.7,-1060.3,512,-1067
l` + t / 2.084 + " -" + t + `
c4.7,-7.3,11,-11,19,-11
H40000v` + (40 + t) + `H1012.3
s-271.3,567,-271.3,567c-38.7,80.7,-84,175,-136,283c-52,108,-89.167,185.3,-111.5,232
c-22.3,46.7,-33.8,70.3,-34.5,71c-4.7,4.7,-12.3,7,-23,7s-12,-1,-12,-1
s-109,-253,-109,-253c-72.7,-168,-109.3,-252,-110,-252c-10.7,8,-22,16.7,-34,26
c-22,17.3,-33.3,26,-34,26s-26,-26,-26,-26s76,-59,76,-59s76,-60,76,-60z
M` + (1001 + t) + " " + g + "h400000v" + (40 + t) + "h-400000z";
}, sqrtSize2 = function n(t, g) {
  return "M983 " + (10 + t + g) + `
l` + t / 3.13 + " -" + t + `
c4,-6.7,10,-10,18,-10 H400000v` + (40 + t) + `
H1013.1s-83.4,268,-264.1,840c-180.7,572,-277,876.3,-289,913c-4.7,4.7,-12.7,7,-24,7
s-12,0,-12,0c-1.3,-3.3,-3.7,-11.7,-7,-25c-35.3,-125.3,-106.7,-373.3,-214,-744
c-10,12,-21,25,-33,39s-32,39,-32,39c-6,-5.3,-15,-14,-27,-26s25,-30,25,-30
c26.7,-32.7,52,-63,76,-91s52,-60,52,-60s208,722,208,722
c56,-175.3,126.3,-397.3,211,-666c84.7,-268.7,153.8,-488.2,207.5,-658.5
c53.7,-170.3,84.5,-266.8,92.5,-289.5z
M` + (1001 + t) + " " + g + "h400000v" + (40 + t) + "h-400000z";
}, sqrtSize3 = function n(t, g) {
  return "M424," + (2398 + t + g) + `
c-1.3,-0.7,-38.5,-172,-111.5,-514c-73,-342,-109.8,-513.3,-110.5,-514
c0,-2,-10.7,14.3,-32,49c-4.7,7.3,-9.8,15.7,-15.5,25c-5.7,9.3,-9.8,16,-12.5,20
s-5,7,-5,7c-4,-3.3,-8.3,-7.7,-13,-13s-13,-13,-13,-13s76,-122,76,-122s77,-121,77,-121
s209,968,209,968c0,-2,84.7,-361.7,254,-1079c169.3,-717.3,254.7,-1077.7,256,-1081
l` + t / 4.223 + " -" + t + `c4,-6.7,10,-10,18,-10 H400000
v` + (40 + t) + `H1014.6
s-87.3,378.7,-272.6,1166c-185.3,787.3,-279.3,1182.3,-282,1185
c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2z M` + (1001 + t) + " " + g + `
h400000v` + (40 + t) + "h-400000z";
}, sqrtSize4 = function n(t, g) {
  return "M473," + (2713 + t + g) + `
c339.3,-1799.3,509.3,-2700,510,-2702 l` + t / 5.298 + " -" + t + `
c3.3,-7.3,9.3,-11,18,-11 H400000v` + (40 + t) + `H1017.7
s-90.5,478,-276.2,1466c-185.7,988,-279.5,1483,-281.5,1485c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2c0,-1.3,-5.3,-32,-16,-92c-50.7,-293.3,-119.7,-693.3,-207,-1200
c0,-1.3,-5.3,8.7,-16,30c-10.7,21.3,-21.3,42.7,-32,64s-16,33,-16,33s-26,-26,-26,-26
s76,-153,76,-153s77,-151,77,-151c0.7,0.7,35.7,202,105,604c67.3,400.7,102,602.7,104,
606zM` + (1001 + t) + " " + g + "h400000v" + (40 + t) + "H1017.7z";
}, phasePath = function n(t) {
  var g = t / 2;
  return "M400000 " + t + " H0 L" + g + " 0 l65 45 L145 " + (t - 80) + " H400000z";
}, sqrtTall = function n(t, g, d) {
  var k = d - 54 - g - t;
  return "M702 " + (t + g) + "H400000" + (40 + t) + `
H742v` + k + `l-4 4-4 4c-.667.7 -2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1
h-12l-28-84c-16.667-52-96.667 -294.333-240-727l-212 -643 -85 170
c-4-3.333-8.333-7.667-13 -13l-13-13l77-155 77-156c66 199.333 139 419.667
219 661 l218 661zM702 ` + g + "H400000v" + (40 + t) + "H742z";
}, sqrtPath = function n(t, g, d) {
  g = 1e3 * g;
  var k = "";
  switch (t) {
    case "sqrtMain":
      k = sqrtMain(g, hLinePad);
      break;
    case "sqrtSize1":
      k = sqrtSize1(g, hLinePad);
      break;
    case "sqrtSize2":
      k = sqrtSize2(g, hLinePad);
      break;
    case "sqrtSize3":
      k = sqrtSize3(g, hLinePad);
      break;
    case "sqrtSize4":
      k = sqrtSize4(g, hLinePad);
      break;
    case "sqrtTall":
      k = sqrtTall(g, hLinePad, d);
  }
  return k;
}, innerPath = function n(t, g) {
  switch (t) {
    case "⎜":
      return "M291 0 H417 V" + g + " H291z M291 0 H417 V" + g + " H291z";
    case "∣":
      return "M145 0 H188 V" + g + " H145z M145 0 H188 V" + g + " H145z";
    case "∥":
      return "M145 0 H188 V" + g + " H145z M145 0 H188 V" + g + " H145z" + ("M367 0 H410 V" + g + " H367z M367 0 H410 V" + g + " H367z");
    case "⎟":
      return "M457 0 H583 V" + g + " H457z M457 0 H583 V" + g + " H457z";
    case "⎢":
      return "M319 0 H403 V" + g + " H319z M319 0 H403 V" + g + " H319z";
    case "⎥":
      return "M263 0 H347 V" + g + " H263z M263 0 H347 V" + g + " H263z";
    case "⎪":
      return "M384 0 H504 V" + g + " H384z M384 0 H504 V" + g + " H384z";
    case "⏐":
      return "M312 0 H355 V" + g + " H312z M312 0 H355 V" + g + " H312z";
    case "‖":
      return "M257 0 H300 V" + g + " H257z M257 0 H300 V" + g + " H257z" + ("M478 0 H521 V" + g + " H478z M478 0 H521 V" + g + " H478z");
    default:
      return "";
  }
}, path$6 = {
  // The doubleleftarrow geometry is from glyph U+21D0 in the font KaTeX Main
  doubleleftarrow: `M262 157
l10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3
 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28
 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5
c2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5
 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87
-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7
-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z
m8 0v40h399730v-40zm0 194v40h399730v-40z`,
  // doublerightarrow is from glyph U+21D2 in font KaTeX Main
  doublerightarrow: `M399738 392l
-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5
 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88
-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68
-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18
-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782
c-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3
-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z`,
  // leftarrow is from glyph U+2190 in font KaTeX Main
  leftarrow: `M400000 241H110l3-3c68.7-52.7 113.7-120
 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8
-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247
c-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208
 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3
 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202
 l-3-3h399890zM100 241v40h399900v-40z`,
  // overbrace is from glyphs U+23A9/23A8/23A7 in font KaTeX_Size4-Regular
  leftbrace: `M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117
-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7
 5-6 9-10 13-.7 1-7.3 1-20 1H6z`,
  leftbraceunder: `M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13
 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688
 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7
-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z`,
  // overgroup is from the MnSymbol package (public domain)
  leftgroup: `M400000 80
H435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0
 435 0h399565z`,
  leftgroupunder: `M400000 262
H435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219
 435 219h399565z`,
  // Harpoons are from glyph U+21BD in font KaTeX Main
  leftharpoon: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3
-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5
-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7
-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z`,
  leftharpoonplus: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5
 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3
-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7
-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z
m0 0v40h400000v-40z`,
  leftharpoondown: `M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333
 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5
 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667
-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z`,
  leftharpoondownplus: `M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12
 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7
-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0
v40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z`,
  // hook is from glyph U+21A9 in font KaTeX Main
  lefthook: `M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5
-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3
-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21
 71.5 23h399859zM103 281v-40h399897v40z`,
  leftlinesegment: `M40 281 V428 H0 V94 H40 V241 H400000 v40z
M40 281 V428 H0 V94 H40 V241 H400000 v40z`,
  leftmapsto: `M40 281 V448H0V74H40V241H400000v40z
M40 281 V448H0V74H40V241H400000v40z`,
  // tofrom is from glyph U+21C4 in font KaTeX AMS Regular
  leftToFrom: `M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23
-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8
c28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3
 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z`,
  longequal: `M0 50 h400000 v40H0z m0 194h40000v40H0z
M0 50 h400000 v40H0z m0 194h40000v40H0z`,
  midbrace: `M200428 334
c-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14
-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7
 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11
 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z`,
  midbraceunder: `M199572 214
c100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14
 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3
 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0
-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z`,
  oiintSize1: `M512.6 71.6c272.6 0 320.3 106.8 320.3 178.2 0 70.8-47.7 177.6
-320.3 177.6S193.1 320.6 193.1 249.8c0-71.4 46.9-178.2 319.5-178.2z
m368.1 178.2c0-86.4-60.9-215.4-368.1-215.4-306.4 0-367.3 129-367.3 215.4 0 85.8
60.9 214.8 367.3 214.8 307.2 0 368.1-129 368.1-214.8z`,
  oiintSize2: `M757.8 100.1c384.7 0 451.1 137.6 451.1 230 0 91.3-66.4 228.8
-451.1 228.8-386.3 0-452.7-137.5-452.7-228.8 0-92.4 66.4-230 452.7-230z
m502.4 230c0-111.2-82.4-277.2-502.4-277.2s-504 166-504 277.2
c0 110 84 276 504 276s502.4-166 502.4-276z`,
  oiiintSize1: `M681.4 71.6c408.9 0 480.5 106.8 480.5 178.2 0 70.8-71.6 177.6
-480.5 177.6S202.1 320.6 202.1 249.8c0-71.4 70.5-178.2 479.3-178.2z
m525.8 178.2c0-86.4-86.8-215.4-525.7-215.4-437.9 0-524.7 129-524.7 215.4 0
85.8 86.8 214.8 524.7 214.8 438.9 0 525.7-129 525.7-214.8z`,
  oiiintSize2: `M1021.2 53c603.6 0 707.8 165.8 707.8 277.2 0 110-104.2 275.8
-707.8 275.8-606 0-710.2-165.8-710.2-275.8C311 218.8 415.2 53 1021.2 53z
m770.4 277.1c0-131.2-126.4-327.6-770.5-327.6S248.4 198.9 248.4 330.1
c0 130 128.8 326.4 772.7 326.4s770.5-196.4 770.5-326.4z`,
  rightarrow: `M0 241v40h399891c-47.3 35.3-84 78-110 128
-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20
 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7
 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85
-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
 151.7 139 205zm0 0v40h399900v-40z`,
  rightbrace: `M400000 542l
-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5
s-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1
c124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z`,
  rightbraceunder: `M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3
 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237
-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z`,
  rightgroup: `M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0
 3-1 3-3v-38c-76-158-257-219-435-219H0z`,
  rightgroupunder: `M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18
 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z`,
  rightharpoon: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3
-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2
-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58
 69.2 92 94.5zm0 0v40h399900v-40z`,
  rightharpoonplus: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11
-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7
 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z
m0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z`,
  rightharpoondown: `M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8
 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5
-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95
-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z`,
  rightharpoondownplus: `M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8
 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3
 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3
-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z
m0-194v40h400000v-40zm0 0v40h400000v-40z`,
  righthook: `M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3
 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0
-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21
 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z`,
  rightlinesegment: `M399960 241 V94 h40 V428 h-40 V281 H0 v-40z
M399960 241 V94 h40 V428 h-40 V281 H0 v-40z`,
  rightToFrom: `M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23
 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32
-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142
-167z M100 147v40h399900v-40zM0 341v40h399900v-40z`,
  // twoheadleftarrow is from glyph U+219E in font KaTeX AMS Regular
  twoheadleftarrow: `M0 167c68 40
 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69
-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3
-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19
-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101
 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z`,
  twoheadrightarrow: `M400000 167
c-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3
 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42
 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333
-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70
 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z`,
  // tilde1 is a modified version of a glyph from the MnSymbol package
  tilde1: `M200 55.538c-77 0-168 73.953-177 73.953-3 0-7
-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0
 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0
 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128
-68.267.847-113-73.952-191-73.952z`,
  // ditto tilde2, tilde3, & tilde4
  tilde2: `M344 55.266c-142 0-300.638 81.316-311.5 86.418
-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9
 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114
c1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751
 181.476 676 181.476c-149 0-189-126.21-332-126.21z`,
  tilde3: `M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457
-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0
 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697
 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696
 -338 0-409-156.573-744-156.573z`,
  tilde4: `M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345
-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409
 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9
 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409
 -175.236-744-175.236z`,
  // vec is from glyph U+20D7 in font KaTeX Main
  vec: `M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5
3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11
10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63
-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1
-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59
H213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359
c-16-25.333-24-45-24-59z`,
  // widehat1 is a modified version of a glyph from the MnSymbol package
  widehat1: `M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22
c-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z`,
  // ditto widehat2, widehat3, & widehat4
  widehat2: `M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  widehat3: `M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  widehat4: `M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  // widecheck paths are all inverted versions of widehat
  widecheck1: `M529,159h5l519,-115c5,-1,9,-5,9,-10c0,-1,-1,-2,-1,-3l-4,-22c-1,
-5,-5,-9,-11,-9h-2l-512,92l-513,-92h-2c-5,0,-9,4,-11,9l-5,22c-1,6,2,12,8,13z`,
  widecheck2: `M1181,220h2l1171,-176c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,153l-1167,-153h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  widecheck3: `M1181,280h2l1171,-236c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,213l-1167,-213h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  widecheck4: `M1181,340h2l1171,-296c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,273l-1167,-273h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  // The next ten paths support reaction arrows from the mhchem package.
  // Arrows for \ce{<-->} are offset from xAxis by 0.22ex, per mhchem in LaTeX
  // baraboveleftarrow is mostly from glyph U+2190 in font KaTeX Main
  baraboveleftarrow: `M400000 620h-399890l3 -3c68.7 -52.7 113.7 -120 135 -202
c4 -14.7 6 -23 6 -25c0 -7.3 -7 -11 -21 -11c-8 0 -13.2 0.8 -15.5 2.5
c-2.3 1.7 -4.2 5.8 -5.5 12.5c-1.3 4.7 -2.7 10.3 -4 17c-12 48.7 -34.8 92 -68.5 130
s-74.2 66.3 -121.5 85c-10 4 -16 7.7 -18 11c0 8.7 6 14.3 18 17c47.3 18.7 87.8 47
121.5 85s56.5 81.3 68.5 130c0.7 2 1.3 5 2 9s1.2 6.7 1.5 8c0.3 1.3 1 3.3 2 6
s2.2 4.5 3.5 5.5c1.3 1 3.3 1.8 6 2.5s6 1 10 1c14 0 21 -3.7 21 -11
c0 -2 -2 -10.3 -6 -25c-20 -79.3 -65 -146.7 -135 -202l-3 -3h399890z
M100 620v40h399900v-40z M0 241v40h399900v-40zM0 241v40h399900v-40z`,
  // rightarrowabovebar is mostly from glyph U+2192, KaTeX Main
  rightarrowabovebar: `M0 241v40h399891c-47.3 35.3-84 78-110 128-16.7 32
-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20 11 8 0
13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7 39
-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85-40.5
-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
151.7 139 205zm96 379h399894v40H0zm0 0h399904v40H0z`,
  // The short left harpoon has 0.5em (i.e. 500 units) kern on the left end.
  // Ref from mhchem.sty: \rlap{\raisebox{-.22ex}{$\kern0.5em
  baraboveshortleftharpoon: `M507,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17
c2,0.7,5,1,9,1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21
c-32,-87.3,-82.7,-157.7,-152,-211c0,0,-3,-3,-3,-3l399351,0l0,-40
c-398570,0,-399437,0,-399437,0z M593 435 v40 H399500 v-40z
M0 281 v-40 H399908 v40z M0 281 v-40 H399908 v40z`,
  rightharpoonaboveshortbar: `M0,241 l0,40c399126,0,399993,0,399993,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M0 241 v40 H399908 v-40z M0 475 v-40 H399500 v40z M0 475 v-40 H399500 v40z`,
  shortbaraboveleftharpoon: `M7,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17c2,0.7,5,1,9,
1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21c-32,-87.3,-82.7,-157.7,
-152,-211c0,0,-3,-3,-3,-3l399907,0l0,-40c-399126,0,-399993,0,-399993,0z
M93 435 v40 H400000 v-40z M500 241 v40 H400000 v-40z M500 241 v40 H400000 v-40z`,
  shortrightharpoonabovebar: `M53,241l0,40c398570,0,399437,0,399437,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M500 241 v40 H399408 v-40z M500 435 v40 H400000 v-40z`
}, tallDelim = function n(t, g) {
  switch (t) {
    case "lbrack":
      return "M403 1759 V84 H666 V0 H319 V1759 v" + g + ` v1759 h347 v-84
H403z M403 1759 V0 H319 V1759 v` + g + " v1759 h84z";
    case "rbrack":
      return "M347 1759 V0 H0 V84 H263 V1759 v" + g + ` v1759 H0 v84 H347z
M347 1759 V0 H263 V1759 v` + g + " v1759 h84z";
    case "vert":
      return "M145 15 v585 v" + g + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -g + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` + g + " v585 h43z";
    case "doublevert":
      return "M145 15 v585 v" + g + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -g + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` + g + ` v585 h43z
M367 15 v585 v` + g + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -g + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M410 15 H367 v585 v` + g + " v585 h43z";
    case "lfloor":
      return "M319 602 V0 H403 V602 v" + g + ` v1715 h263 v84 H319z
MM319 602 V0 H403 V602 v` + g + " v1715 H319z";
    case "rfloor":
      return "M319 602 V0 H403 V602 v" + g + ` v1799 H0 v-84 H319z
MM319 602 V0 H403 V602 v` + g + " v1715 H319z";
    case "lceil":
      return "M403 1759 V84 H666 V0 H319 V1759 v" + g + ` v602 h84z
M403 1759 V0 H319 V1759 v` + g + " v602 h84z";
    case "rceil":
      return "M347 1759 V0 H0 V84 H263 V1759 v" + g + ` v602 h84z
M347 1759 V0 h-84 V1759 v` + g + " v602 h84z";
    case "lparen":
      return `M863,9c0,-2,-2,-5,-6,-9c0,0,-17,0,-17,0c-12.7,0,-19.3,0.3,-20,1
c-5.3,5.3,-10.3,11,-15,17c-242.7,294.7,-395.3,682,-458,1162c-21.3,163.3,-33.3,349,
-36,557 l0,` + (g + 84) + `c0.2,6,0,26,0,60c2,159.3,10,310.7,24,454c53.3,528,210,
949.7,470,1265c4.7,6,9.7,11.7,15,17c0.7,0.7,7,1,19,1c0,0,18,0,18,0c4,-4,6,-7,6,-9
c0,-2.7,-3.3,-8.7,-10,-18c-135.3,-192.7,-235.5,-414.3,-300.5,-665c-65,-250.7,-102.5,
-544.7,-112.5,-882c-2,-104,-3,-167,-3,-189
l0,-` + (g + 92) + `c0,-162.7,5.7,-314,17,-454c20.7,-272,63.7,-513,129,-723c65.3,
-210,155.3,-396.3,270,-559c6.7,-9.3,10,-15.3,10,-18z`;
    case "rparen":
      return `M76,0c-16.7,0,-25,3,-25,9c0,2,2,6.3,6,13c21.3,28.7,42.3,60.3,
63,95c96.7,156.7,172.8,332.5,228.5,527.5c55.7,195,92.8,416.5,111.5,664.5
c11.3,139.3,17,290.7,17,454c0,28,1.7,43,3.3,45l0,` + (g + 9) + `
c-3,4,-3.3,16.7,-3.3,38c0,162,-5.7,313.7,-17,455c-18.7,248,-55.8,469.3,-111.5,664
c-55.7,194.7,-131.8,370.3,-228.5,527c-20.7,34.7,-41.7,66.3,-63,95c-2,3.3,-4,7,-6,11
c0,7.3,5.7,11,17,11c0,0,11,0,11,0c9.3,0,14.3,-0.3,15,-1c5.3,-5.3,10.3,-11,15,-17
c242.7,-294.7,395.3,-681.7,458,-1161c21.3,-164.7,33.3,-350.7,36,-558
l0,-` + (g + 144) + `c-2,-159.3,-10,-310.7,-24,-454c-53.3,-528,-210,-949.7,
-470,-1265c-4.7,-6,-9.7,-11.7,-15,-17c-0.7,-0.7,-6.7,-1,-18,-1z`;
    default:
      throw new Error("Unknown stretchy delimiter.");
  }
};
class DocumentFragment {
  // Never used; needed for satisfying interface.
  constructor(t) {
    this.children = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, this.children = t, this.classes = [], this.height = 0, this.depth = 0, this.maxFontSize = 0, this.style = {};
  }
  hasClass(t) {
    return this.classes.includes(t);
  }
  /** Convert the fragment into a node. */
  toNode() {
    for (var t = document.createDocumentFragment(), g = 0; g < this.children.length; g++)
      t.appendChild(this.children[g].toNode());
    return t;
  }
  /** Convert the fragment into HTML markup. */
  toMarkup() {
    for (var t = "", g = 0; g < this.children.length; g++)
      t += this.children[g].toMarkup();
    return t;
  }
  /**
   * Converts the math node into a string, similar to innerText. Applies to
   * MathDomNode's only.
   */
  toText() {
    var t = (g) => g.toText();
    return this.children.map(t).join("");
  }
}
var fontMetricsData = {
  "AMS-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.68889, 0, 0, 0.72222],
    66: [0, 0.68889, 0, 0, 0.66667],
    67: [0, 0.68889, 0, 0, 0.72222],
    68: [0, 0.68889, 0, 0, 0.72222],
    69: [0, 0.68889, 0, 0, 0.66667],
    70: [0, 0.68889, 0, 0, 0.61111],
    71: [0, 0.68889, 0, 0, 0.77778],
    72: [0, 0.68889, 0, 0, 0.77778],
    73: [0, 0.68889, 0, 0, 0.38889],
    74: [0.16667, 0.68889, 0, 0, 0.5],
    75: [0, 0.68889, 0, 0, 0.77778],
    76: [0, 0.68889, 0, 0, 0.66667],
    77: [0, 0.68889, 0, 0, 0.94445],
    78: [0, 0.68889, 0, 0, 0.72222],
    79: [0.16667, 0.68889, 0, 0, 0.77778],
    80: [0, 0.68889, 0, 0, 0.61111],
    81: [0.16667, 0.68889, 0, 0, 0.77778],
    82: [0, 0.68889, 0, 0, 0.72222],
    83: [0, 0.68889, 0, 0, 0.55556],
    84: [0, 0.68889, 0, 0, 0.66667],
    85: [0, 0.68889, 0, 0, 0.72222],
    86: [0, 0.68889, 0, 0, 0.72222],
    87: [0, 0.68889, 0, 0, 1],
    88: [0, 0.68889, 0, 0, 0.72222],
    89: [0, 0.68889, 0, 0, 0.72222],
    90: [0, 0.68889, 0, 0, 0.66667],
    107: [0, 0.68889, 0, 0, 0.55556],
    160: [0, 0, 0, 0, 0.25],
    165: [0, 0.675, 0.025, 0, 0.75],
    174: [0.15559, 0.69224, 0, 0, 0.94666],
    240: [0, 0.68889, 0, 0, 0.55556],
    295: [0, 0.68889, 0, 0, 0.54028],
    710: [0, 0.825, 0, 0, 2.33334],
    732: [0, 0.9, 0, 0, 2.33334],
    770: [0, 0.825, 0, 0, 2.33334],
    771: [0, 0.9, 0, 0, 2.33334],
    989: [0.08167, 0.58167, 0, 0, 0.77778],
    1008: [0, 0.43056, 0.04028, 0, 0.66667],
    8245: [0, 0.54986, 0, 0, 0.275],
    8463: [0, 0.68889, 0, 0, 0.54028],
    8487: [0, 0.68889, 0, 0, 0.72222],
    8498: [0, 0.68889, 0, 0, 0.55556],
    8502: [0, 0.68889, 0, 0, 0.66667],
    8503: [0, 0.68889, 0, 0, 0.44445],
    8504: [0, 0.68889, 0, 0, 0.66667],
    8513: [0, 0.68889, 0, 0, 0.63889],
    8592: [-0.03598, 0.46402, 0, 0, 0.5],
    8594: [-0.03598, 0.46402, 0, 0, 0.5],
    8602: [-0.13313, 0.36687, 0, 0, 1],
    8603: [-0.13313, 0.36687, 0, 0, 1],
    8606: [0.01354, 0.52239, 0, 0, 1],
    8608: [0.01354, 0.52239, 0, 0, 1],
    8610: [0.01354, 0.52239, 0, 0, 1.11111],
    8611: [0.01354, 0.52239, 0, 0, 1.11111],
    8619: [0, 0.54986, 0, 0, 1],
    8620: [0, 0.54986, 0, 0, 1],
    8621: [-0.13313, 0.37788, 0, 0, 1.38889],
    8622: [-0.13313, 0.36687, 0, 0, 1],
    8624: [0, 0.69224, 0, 0, 0.5],
    8625: [0, 0.69224, 0, 0, 0.5],
    8630: [0, 0.43056, 0, 0, 1],
    8631: [0, 0.43056, 0, 0, 1],
    8634: [0.08198, 0.58198, 0, 0, 0.77778],
    8635: [0.08198, 0.58198, 0, 0, 0.77778],
    8638: [0.19444, 0.69224, 0, 0, 0.41667],
    8639: [0.19444, 0.69224, 0, 0, 0.41667],
    8642: [0.19444, 0.69224, 0, 0, 0.41667],
    8643: [0.19444, 0.69224, 0, 0, 0.41667],
    8644: [0.1808, 0.675, 0, 0, 1],
    8646: [0.1808, 0.675, 0, 0, 1],
    8647: [0.1808, 0.675, 0, 0, 1],
    8648: [0.19444, 0.69224, 0, 0, 0.83334],
    8649: [0.1808, 0.675, 0, 0, 1],
    8650: [0.19444, 0.69224, 0, 0, 0.83334],
    8651: [0.01354, 0.52239, 0, 0, 1],
    8652: [0.01354, 0.52239, 0, 0, 1],
    8653: [-0.13313, 0.36687, 0, 0, 1],
    8654: [-0.13313, 0.36687, 0, 0, 1],
    8655: [-0.13313, 0.36687, 0, 0, 1],
    8666: [0.13667, 0.63667, 0, 0, 1],
    8667: [0.13667, 0.63667, 0, 0, 1],
    8669: [-0.13313, 0.37788, 0, 0, 1],
    8672: [-0.064, 0.437, 0, 0, 1.334],
    8674: [-0.064, 0.437, 0, 0, 1.334],
    8705: [0, 0.825, 0, 0, 0.5],
    8708: [0, 0.68889, 0, 0, 0.55556],
    8709: [0.08167, 0.58167, 0, 0, 0.77778],
    8717: [0, 0.43056, 0, 0, 0.42917],
    8722: [-0.03598, 0.46402, 0, 0, 0.5],
    8724: [0.08198, 0.69224, 0, 0, 0.77778],
    8726: [0.08167, 0.58167, 0, 0, 0.77778],
    8733: [0, 0.69224, 0, 0, 0.77778],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8737: [0, 0.69224, 0, 0, 0.72222],
    8738: [0.03517, 0.52239, 0, 0, 0.72222],
    8739: [0.08167, 0.58167, 0, 0, 0.22222],
    8740: [0.25142, 0.74111, 0, 0, 0.27778],
    8741: [0.08167, 0.58167, 0, 0, 0.38889],
    8742: [0.25142, 0.74111, 0, 0, 0.5],
    8756: [0, 0.69224, 0, 0, 0.66667],
    8757: [0, 0.69224, 0, 0, 0.66667],
    8764: [-0.13313, 0.36687, 0, 0, 0.77778],
    8765: [-0.13313, 0.37788, 0, 0, 0.77778],
    8769: [-0.13313, 0.36687, 0, 0, 0.77778],
    8770: [-0.03625, 0.46375, 0, 0, 0.77778],
    8774: [0.30274, 0.79383, 0, 0, 0.77778],
    8776: [-0.01688, 0.48312, 0, 0, 0.77778],
    8778: [0.08167, 0.58167, 0, 0, 0.77778],
    8782: [0.06062, 0.54986, 0, 0, 0.77778],
    8783: [0.06062, 0.54986, 0, 0, 0.77778],
    8785: [0.08198, 0.58198, 0, 0, 0.77778],
    8786: [0.08198, 0.58198, 0, 0, 0.77778],
    8787: [0.08198, 0.58198, 0, 0, 0.77778],
    8790: [0, 0.69224, 0, 0, 0.77778],
    8791: [0.22958, 0.72958, 0, 0, 0.77778],
    8796: [0.08198, 0.91667, 0, 0, 0.77778],
    8806: [0.25583, 0.75583, 0, 0, 0.77778],
    8807: [0.25583, 0.75583, 0, 0, 0.77778],
    8808: [0.25142, 0.75726, 0, 0, 0.77778],
    8809: [0.25142, 0.75726, 0, 0, 0.77778],
    8812: [0.25583, 0.75583, 0, 0, 0.5],
    8814: [0.20576, 0.70576, 0, 0, 0.77778],
    8815: [0.20576, 0.70576, 0, 0, 0.77778],
    8816: [0.30274, 0.79383, 0, 0, 0.77778],
    8817: [0.30274, 0.79383, 0, 0, 0.77778],
    8818: [0.22958, 0.72958, 0, 0, 0.77778],
    8819: [0.22958, 0.72958, 0, 0, 0.77778],
    8822: [0.1808, 0.675, 0, 0, 0.77778],
    8823: [0.1808, 0.675, 0, 0, 0.77778],
    8828: [0.13667, 0.63667, 0, 0, 0.77778],
    8829: [0.13667, 0.63667, 0, 0, 0.77778],
    8830: [0.22958, 0.72958, 0, 0, 0.77778],
    8831: [0.22958, 0.72958, 0, 0, 0.77778],
    8832: [0.20576, 0.70576, 0, 0, 0.77778],
    8833: [0.20576, 0.70576, 0, 0, 0.77778],
    8840: [0.30274, 0.79383, 0, 0, 0.77778],
    8841: [0.30274, 0.79383, 0, 0, 0.77778],
    8842: [0.13597, 0.63597, 0, 0, 0.77778],
    8843: [0.13597, 0.63597, 0, 0, 0.77778],
    8847: [0.03517, 0.54986, 0, 0, 0.77778],
    8848: [0.03517, 0.54986, 0, 0, 0.77778],
    8858: [0.08198, 0.58198, 0, 0, 0.77778],
    8859: [0.08198, 0.58198, 0, 0, 0.77778],
    8861: [0.08198, 0.58198, 0, 0, 0.77778],
    8862: [0, 0.675, 0, 0, 0.77778],
    8863: [0, 0.675, 0, 0, 0.77778],
    8864: [0, 0.675, 0, 0, 0.77778],
    8865: [0, 0.675, 0, 0, 0.77778],
    8872: [0, 0.69224, 0, 0, 0.61111],
    8873: [0, 0.69224, 0, 0, 0.72222],
    8874: [0, 0.69224, 0, 0, 0.88889],
    8876: [0, 0.68889, 0, 0, 0.61111],
    8877: [0, 0.68889, 0, 0, 0.61111],
    8878: [0, 0.68889, 0, 0, 0.72222],
    8879: [0, 0.68889, 0, 0, 0.72222],
    8882: [0.03517, 0.54986, 0, 0, 0.77778],
    8883: [0.03517, 0.54986, 0, 0, 0.77778],
    8884: [0.13667, 0.63667, 0, 0, 0.77778],
    8885: [0.13667, 0.63667, 0, 0, 0.77778],
    8888: [0, 0.54986, 0, 0, 1.11111],
    8890: [0.19444, 0.43056, 0, 0, 0.55556],
    8891: [0.19444, 0.69224, 0, 0, 0.61111],
    8892: [0.19444, 0.69224, 0, 0, 0.61111],
    8901: [0, 0.54986, 0, 0, 0.27778],
    8903: [0.08167, 0.58167, 0, 0, 0.77778],
    8905: [0.08167, 0.58167, 0, 0, 0.77778],
    8906: [0.08167, 0.58167, 0, 0, 0.77778],
    8907: [0, 0.69224, 0, 0, 0.77778],
    8908: [0, 0.69224, 0, 0, 0.77778],
    8909: [-0.03598, 0.46402, 0, 0, 0.77778],
    8910: [0, 0.54986, 0, 0, 0.76042],
    8911: [0, 0.54986, 0, 0, 0.76042],
    8912: [0.03517, 0.54986, 0, 0, 0.77778],
    8913: [0.03517, 0.54986, 0, 0, 0.77778],
    8914: [0, 0.54986, 0, 0, 0.66667],
    8915: [0, 0.54986, 0, 0, 0.66667],
    8916: [0, 0.69224, 0, 0, 0.66667],
    8918: [0.0391, 0.5391, 0, 0, 0.77778],
    8919: [0.0391, 0.5391, 0, 0, 0.77778],
    8920: [0.03517, 0.54986, 0, 0, 1.33334],
    8921: [0.03517, 0.54986, 0, 0, 1.33334],
    8922: [0.38569, 0.88569, 0, 0, 0.77778],
    8923: [0.38569, 0.88569, 0, 0, 0.77778],
    8926: [0.13667, 0.63667, 0, 0, 0.77778],
    8927: [0.13667, 0.63667, 0, 0, 0.77778],
    8928: [0.30274, 0.79383, 0, 0, 0.77778],
    8929: [0.30274, 0.79383, 0, 0, 0.77778],
    8934: [0.23222, 0.74111, 0, 0, 0.77778],
    8935: [0.23222, 0.74111, 0, 0, 0.77778],
    8936: [0.23222, 0.74111, 0, 0, 0.77778],
    8937: [0.23222, 0.74111, 0, 0, 0.77778],
    8938: [0.20576, 0.70576, 0, 0, 0.77778],
    8939: [0.20576, 0.70576, 0, 0, 0.77778],
    8940: [0.30274, 0.79383, 0, 0, 0.77778],
    8941: [0.30274, 0.79383, 0, 0, 0.77778],
    8994: [0.19444, 0.69224, 0, 0, 0.77778],
    8995: [0.19444, 0.69224, 0, 0, 0.77778],
    9416: [0.15559, 0.69224, 0, 0, 0.90222],
    9484: [0, 0.69224, 0, 0, 0.5],
    9488: [0, 0.69224, 0, 0, 0.5],
    9492: [0, 0.37788, 0, 0, 0.5],
    9496: [0, 0.37788, 0, 0, 0.5],
    9585: [0.19444, 0.68889, 0, 0, 0.88889],
    9586: [0.19444, 0.74111, 0, 0, 0.88889],
    9632: [0, 0.675, 0, 0, 0.77778],
    9633: [0, 0.675, 0, 0, 0.77778],
    9650: [0, 0.54986, 0, 0, 0.72222],
    9651: [0, 0.54986, 0, 0, 0.72222],
    9654: [0.03517, 0.54986, 0, 0, 0.77778],
    9660: [0, 0.54986, 0, 0, 0.72222],
    9661: [0, 0.54986, 0, 0, 0.72222],
    9664: [0.03517, 0.54986, 0, 0, 0.77778],
    9674: [0.11111, 0.69224, 0, 0, 0.66667],
    9733: [0.19444, 0.69224, 0, 0, 0.94445],
    10003: [0, 0.69224, 0, 0, 0.83334],
    10016: [0, 0.69224, 0, 0, 0.83334],
    10731: [0.11111, 0.69224, 0, 0, 0.66667],
    10846: [0.19444, 0.75583, 0, 0, 0.61111],
    10877: [0.13667, 0.63667, 0, 0, 0.77778],
    10878: [0.13667, 0.63667, 0, 0, 0.77778],
    10885: [0.25583, 0.75583, 0, 0, 0.77778],
    10886: [0.25583, 0.75583, 0, 0, 0.77778],
    10887: [0.13597, 0.63597, 0, 0, 0.77778],
    10888: [0.13597, 0.63597, 0, 0, 0.77778],
    10889: [0.26167, 0.75726, 0, 0, 0.77778],
    10890: [0.26167, 0.75726, 0, 0, 0.77778],
    10891: [0.48256, 0.98256, 0, 0, 0.77778],
    10892: [0.48256, 0.98256, 0, 0, 0.77778],
    10901: [0.13667, 0.63667, 0, 0, 0.77778],
    10902: [0.13667, 0.63667, 0, 0, 0.77778],
    10933: [0.25142, 0.75726, 0, 0, 0.77778],
    10934: [0.25142, 0.75726, 0, 0, 0.77778],
    10935: [0.26167, 0.75726, 0, 0, 0.77778],
    10936: [0.26167, 0.75726, 0, 0, 0.77778],
    10937: [0.26167, 0.75726, 0, 0, 0.77778],
    10938: [0.26167, 0.75726, 0, 0, 0.77778],
    10949: [0.25583, 0.75583, 0, 0, 0.77778],
    10950: [0.25583, 0.75583, 0, 0, 0.77778],
    10955: [0.28481, 0.79383, 0, 0, 0.77778],
    10956: [0.28481, 0.79383, 0, 0, 0.77778],
    57350: [0.08167, 0.58167, 0, 0, 0.22222],
    57351: [0.08167, 0.58167, 0, 0, 0.38889],
    57352: [0.08167, 0.58167, 0, 0, 0.77778],
    57353: [0, 0.43056, 0.04028, 0, 0.66667],
    57356: [0.25142, 0.75726, 0, 0, 0.77778],
    57357: [0.25142, 0.75726, 0, 0, 0.77778],
    57358: [0.41951, 0.91951, 0, 0, 0.77778],
    57359: [0.30274, 0.79383, 0, 0, 0.77778],
    57360: [0.30274, 0.79383, 0, 0, 0.77778],
    57361: [0.41951, 0.91951, 0, 0, 0.77778],
    57366: [0.25142, 0.75726, 0, 0, 0.77778],
    57367: [0.25142, 0.75726, 0, 0, 0.77778],
    57368: [0.25142, 0.75726, 0, 0, 0.77778],
    57369: [0.25142, 0.75726, 0, 0, 0.77778],
    57370: [0.13597, 0.63597, 0, 0, 0.77778],
    57371: [0.13597, 0.63597, 0, 0, 0.77778]
  },
  "Caligraphic-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.68333, 0, 0.19445, 0.79847],
    66: [0, 0.68333, 0.03041, 0.13889, 0.65681],
    67: [0, 0.68333, 0.05834, 0.13889, 0.52653],
    68: [0, 0.68333, 0.02778, 0.08334, 0.77139],
    69: [0, 0.68333, 0.08944, 0.11111, 0.52778],
    70: [0, 0.68333, 0.09931, 0.11111, 0.71875],
    71: [0.09722, 0.68333, 0.0593, 0.11111, 0.59487],
    72: [0, 0.68333, 965e-5, 0.11111, 0.84452],
    73: [0, 0.68333, 0.07382, 0, 0.54452],
    74: [0.09722, 0.68333, 0.18472, 0.16667, 0.67778],
    75: [0, 0.68333, 0.01445, 0.05556, 0.76195],
    76: [0, 0.68333, 0, 0.13889, 0.68972],
    77: [0, 0.68333, 0, 0.13889, 1.2009],
    78: [0, 0.68333, 0.14736, 0.08334, 0.82049],
    79: [0, 0.68333, 0.02778, 0.11111, 0.79611],
    80: [0, 0.68333, 0.08222, 0.08334, 0.69556],
    81: [0.09722, 0.68333, 0, 0.11111, 0.81667],
    82: [0, 0.68333, 0, 0.08334, 0.8475],
    83: [0, 0.68333, 0.075, 0.13889, 0.60556],
    84: [0, 0.68333, 0.25417, 0, 0.54464],
    85: [0, 0.68333, 0.09931, 0.08334, 0.62583],
    86: [0, 0.68333, 0.08222, 0, 0.61278],
    87: [0, 0.68333, 0.08222, 0.08334, 0.98778],
    88: [0, 0.68333, 0.14643, 0.13889, 0.7133],
    89: [0.09722, 0.68333, 0.08222, 0.08334, 0.66834],
    90: [0, 0.68333, 0.07944, 0.13889, 0.72473],
    160: [0, 0, 0, 0, 0.25]
  },
  "Fraktur-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69141, 0, 0, 0.29574],
    34: [0, 0.69141, 0, 0, 0.21471],
    38: [0, 0.69141, 0, 0, 0.73786],
    39: [0, 0.69141, 0, 0, 0.21201],
    40: [0.24982, 0.74947, 0, 0, 0.38865],
    41: [0.24982, 0.74947, 0, 0, 0.38865],
    42: [0, 0.62119, 0, 0, 0.27764],
    43: [0.08319, 0.58283, 0, 0, 0.75623],
    44: [0, 0.10803, 0, 0, 0.27764],
    45: [0.08319, 0.58283, 0, 0, 0.75623],
    46: [0, 0.10803, 0, 0, 0.27764],
    47: [0.24982, 0.74947, 0, 0, 0.50181],
    48: [0, 0.47534, 0, 0, 0.50181],
    49: [0, 0.47534, 0, 0, 0.50181],
    50: [0, 0.47534, 0, 0, 0.50181],
    51: [0.18906, 0.47534, 0, 0, 0.50181],
    52: [0.18906, 0.47534, 0, 0, 0.50181],
    53: [0.18906, 0.47534, 0, 0, 0.50181],
    54: [0, 0.69141, 0, 0, 0.50181],
    55: [0.18906, 0.47534, 0, 0, 0.50181],
    56: [0, 0.69141, 0, 0, 0.50181],
    57: [0.18906, 0.47534, 0, 0, 0.50181],
    58: [0, 0.47534, 0, 0, 0.21606],
    59: [0.12604, 0.47534, 0, 0, 0.21606],
    61: [-0.13099, 0.36866, 0, 0, 0.75623],
    63: [0, 0.69141, 0, 0, 0.36245],
    65: [0, 0.69141, 0, 0, 0.7176],
    66: [0, 0.69141, 0, 0, 0.88397],
    67: [0, 0.69141, 0, 0, 0.61254],
    68: [0, 0.69141, 0, 0, 0.83158],
    69: [0, 0.69141, 0, 0, 0.66278],
    70: [0.12604, 0.69141, 0, 0, 0.61119],
    71: [0, 0.69141, 0, 0, 0.78539],
    72: [0.06302, 0.69141, 0, 0, 0.7203],
    73: [0, 0.69141, 0, 0, 0.55448],
    74: [0.12604, 0.69141, 0, 0, 0.55231],
    75: [0, 0.69141, 0, 0, 0.66845],
    76: [0, 0.69141, 0, 0, 0.66602],
    77: [0, 0.69141, 0, 0, 1.04953],
    78: [0, 0.69141, 0, 0, 0.83212],
    79: [0, 0.69141, 0, 0, 0.82699],
    80: [0.18906, 0.69141, 0, 0, 0.82753],
    81: [0.03781, 0.69141, 0, 0, 0.82699],
    82: [0, 0.69141, 0, 0, 0.82807],
    83: [0, 0.69141, 0, 0, 0.82861],
    84: [0, 0.69141, 0, 0, 0.66899],
    85: [0, 0.69141, 0, 0, 0.64576],
    86: [0, 0.69141, 0, 0, 0.83131],
    87: [0, 0.69141, 0, 0, 1.04602],
    88: [0, 0.69141, 0, 0, 0.71922],
    89: [0.18906, 0.69141, 0, 0, 0.83293],
    90: [0.12604, 0.69141, 0, 0, 0.60201],
    91: [0.24982, 0.74947, 0, 0, 0.27764],
    93: [0.24982, 0.74947, 0, 0, 0.27764],
    94: [0, 0.69141, 0, 0, 0.49965],
    97: [0, 0.47534, 0, 0, 0.50046],
    98: [0, 0.69141, 0, 0, 0.51315],
    99: [0, 0.47534, 0, 0, 0.38946],
    100: [0, 0.62119, 0, 0, 0.49857],
    101: [0, 0.47534, 0, 0, 0.40053],
    102: [0.18906, 0.69141, 0, 0, 0.32626],
    103: [0.18906, 0.47534, 0, 0, 0.5037],
    104: [0.18906, 0.69141, 0, 0, 0.52126],
    105: [0, 0.69141, 0, 0, 0.27899],
    106: [0, 0.69141, 0, 0, 0.28088],
    107: [0, 0.69141, 0, 0, 0.38946],
    108: [0, 0.69141, 0, 0, 0.27953],
    109: [0, 0.47534, 0, 0, 0.76676],
    110: [0, 0.47534, 0, 0, 0.52666],
    111: [0, 0.47534, 0, 0, 0.48885],
    112: [0.18906, 0.52396, 0, 0, 0.50046],
    113: [0.18906, 0.47534, 0, 0, 0.48912],
    114: [0, 0.47534, 0, 0, 0.38919],
    115: [0, 0.47534, 0, 0, 0.44266],
    116: [0, 0.62119, 0, 0, 0.33301],
    117: [0, 0.47534, 0, 0, 0.5172],
    118: [0, 0.52396, 0, 0, 0.5118],
    119: [0, 0.52396, 0, 0, 0.77351],
    120: [0.18906, 0.47534, 0, 0, 0.38865],
    121: [0.18906, 0.47534, 0, 0, 0.49884],
    122: [0.18906, 0.47534, 0, 0, 0.39054],
    160: [0, 0, 0, 0, 0.25],
    8216: [0, 0.69141, 0, 0, 0.21471],
    8217: [0, 0.69141, 0, 0, 0.21471],
    58112: [0, 0.62119, 0, 0, 0.49749],
    58113: [0, 0.62119, 0, 0, 0.4983],
    58114: [0.18906, 0.69141, 0, 0, 0.33328],
    58115: [0.18906, 0.69141, 0, 0, 0.32923],
    58116: [0.18906, 0.47534, 0, 0, 0.50343],
    58117: [0, 0.69141, 0, 0, 0.33301],
    58118: [0, 0.62119, 0, 0, 0.33409],
    58119: [0, 0.47534, 0, 0, 0.50073]
  },
  "Main-Bold": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.35],
    34: [0, 0.69444, 0, 0, 0.60278],
    35: [0.19444, 0.69444, 0, 0, 0.95833],
    36: [0.05556, 0.75, 0, 0, 0.575],
    37: [0.05556, 0.75, 0, 0, 0.95833],
    38: [0, 0.69444, 0, 0, 0.89444],
    39: [0, 0.69444, 0, 0, 0.31944],
    40: [0.25, 0.75, 0, 0, 0.44722],
    41: [0.25, 0.75, 0, 0, 0.44722],
    42: [0, 0.75, 0, 0, 0.575],
    43: [0.13333, 0.63333, 0, 0, 0.89444],
    44: [0.19444, 0.15556, 0, 0, 0.31944],
    45: [0, 0.44444, 0, 0, 0.38333],
    46: [0, 0.15556, 0, 0, 0.31944],
    47: [0.25, 0.75, 0, 0, 0.575],
    48: [0, 0.64444, 0, 0, 0.575],
    49: [0, 0.64444, 0, 0, 0.575],
    50: [0, 0.64444, 0, 0, 0.575],
    51: [0, 0.64444, 0, 0, 0.575],
    52: [0, 0.64444, 0, 0, 0.575],
    53: [0, 0.64444, 0, 0, 0.575],
    54: [0, 0.64444, 0, 0, 0.575],
    55: [0, 0.64444, 0, 0, 0.575],
    56: [0, 0.64444, 0, 0, 0.575],
    57: [0, 0.64444, 0, 0, 0.575],
    58: [0, 0.44444, 0, 0, 0.31944],
    59: [0.19444, 0.44444, 0, 0, 0.31944],
    60: [0.08556, 0.58556, 0, 0, 0.89444],
    61: [-0.10889, 0.39111, 0, 0, 0.89444],
    62: [0.08556, 0.58556, 0, 0, 0.89444],
    63: [0, 0.69444, 0, 0, 0.54305],
    64: [0, 0.69444, 0, 0, 0.89444],
    65: [0, 0.68611, 0, 0, 0.86944],
    66: [0, 0.68611, 0, 0, 0.81805],
    67: [0, 0.68611, 0, 0, 0.83055],
    68: [0, 0.68611, 0, 0, 0.88194],
    69: [0, 0.68611, 0, 0, 0.75555],
    70: [0, 0.68611, 0, 0, 0.72361],
    71: [0, 0.68611, 0, 0, 0.90416],
    72: [0, 0.68611, 0, 0, 0.9],
    73: [0, 0.68611, 0, 0, 0.43611],
    74: [0, 0.68611, 0, 0, 0.59444],
    75: [0, 0.68611, 0, 0, 0.90138],
    76: [0, 0.68611, 0, 0, 0.69166],
    77: [0, 0.68611, 0, 0, 1.09166],
    78: [0, 0.68611, 0, 0, 0.9],
    79: [0, 0.68611, 0, 0, 0.86388],
    80: [0, 0.68611, 0, 0, 0.78611],
    81: [0.19444, 0.68611, 0, 0, 0.86388],
    82: [0, 0.68611, 0, 0, 0.8625],
    83: [0, 0.68611, 0, 0, 0.63889],
    84: [0, 0.68611, 0, 0, 0.8],
    85: [0, 0.68611, 0, 0, 0.88472],
    86: [0, 0.68611, 0.01597, 0, 0.86944],
    87: [0, 0.68611, 0.01597, 0, 1.18888],
    88: [0, 0.68611, 0, 0, 0.86944],
    89: [0, 0.68611, 0.02875, 0, 0.86944],
    90: [0, 0.68611, 0, 0, 0.70277],
    91: [0.25, 0.75, 0, 0, 0.31944],
    92: [0.25, 0.75, 0, 0, 0.575],
    93: [0.25, 0.75, 0, 0, 0.31944],
    94: [0, 0.69444, 0, 0, 0.575],
    95: [0.31, 0.13444, 0.03194, 0, 0.575],
    97: [0, 0.44444, 0, 0, 0.55902],
    98: [0, 0.69444, 0, 0, 0.63889],
    99: [0, 0.44444, 0, 0, 0.51111],
    100: [0, 0.69444, 0, 0, 0.63889],
    101: [0, 0.44444, 0, 0, 0.52708],
    102: [0, 0.69444, 0.10903, 0, 0.35139],
    103: [0.19444, 0.44444, 0.01597, 0, 0.575],
    104: [0, 0.69444, 0, 0, 0.63889],
    105: [0, 0.69444, 0, 0, 0.31944],
    106: [0.19444, 0.69444, 0, 0, 0.35139],
    107: [0, 0.69444, 0, 0, 0.60694],
    108: [0, 0.69444, 0, 0, 0.31944],
    109: [0, 0.44444, 0, 0, 0.95833],
    110: [0, 0.44444, 0, 0, 0.63889],
    111: [0, 0.44444, 0, 0, 0.575],
    112: [0.19444, 0.44444, 0, 0, 0.63889],
    113: [0.19444, 0.44444, 0, 0, 0.60694],
    114: [0, 0.44444, 0, 0, 0.47361],
    115: [0, 0.44444, 0, 0, 0.45361],
    116: [0, 0.63492, 0, 0, 0.44722],
    117: [0, 0.44444, 0, 0, 0.63889],
    118: [0, 0.44444, 0.01597, 0, 0.60694],
    119: [0, 0.44444, 0.01597, 0, 0.83055],
    120: [0, 0.44444, 0, 0, 0.60694],
    121: [0.19444, 0.44444, 0.01597, 0, 0.60694],
    122: [0, 0.44444, 0, 0, 0.51111],
    123: [0.25, 0.75, 0, 0, 0.575],
    124: [0.25, 0.75, 0, 0, 0.31944],
    125: [0.25, 0.75, 0, 0, 0.575],
    126: [0.35, 0.34444, 0, 0, 0.575],
    160: [0, 0, 0, 0, 0.25],
    163: [0, 0.69444, 0, 0, 0.86853],
    168: [0, 0.69444, 0, 0, 0.575],
    172: [0, 0.44444, 0, 0, 0.76666],
    176: [0, 0.69444, 0, 0, 0.86944],
    177: [0.13333, 0.63333, 0, 0, 0.89444],
    184: [0.17014, 0, 0, 0, 0.51111],
    198: [0, 0.68611, 0, 0, 1.04166],
    215: [0.13333, 0.63333, 0, 0, 0.89444],
    216: [0.04861, 0.73472, 0, 0, 0.89444],
    223: [0, 0.69444, 0, 0, 0.59722],
    230: [0, 0.44444, 0, 0, 0.83055],
    247: [0.13333, 0.63333, 0, 0, 0.89444],
    248: [0.09722, 0.54167, 0, 0, 0.575],
    305: [0, 0.44444, 0, 0, 0.31944],
    338: [0, 0.68611, 0, 0, 1.16944],
    339: [0, 0.44444, 0, 0, 0.89444],
    567: [0.19444, 0.44444, 0, 0, 0.35139],
    710: [0, 0.69444, 0, 0, 0.575],
    711: [0, 0.63194, 0, 0, 0.575],
    713: [0, 0.59611, 0, 0, 0.575],
    714: [0, 0.69444, 0, 0, 0.575],
    715: [0, 0.69444, 0, 0, 0.575],
    728: [0, 0.69444, 0, 0, 0.575],
    729: [0, 0.69444, 0, 0, 0.31944],
    730: [0, 0.69444, 0, 0, 0.86944],
    732: [0, 0.69444, 0, 0, 0.575],
    733: [0, 0.69444, 0, 0, 0.575],
    915: [0, 0.68611, 0, 0, 0.69166],
    916: [0, 0.68611, 0, 0, 0.95833],
    920: [0, 0.68611, 0, 0, 0.89444],
    923: [0, 0.68611, 0, 0, 0.80555],
    926: [0, 0.68611, 0, 0, 0.76666],
    928: [0, 0.68611, 0, 0, 0.9],
    931: [0, 0.68611, 0, 0, 0.83055],
    933: [0, 0.68611, 0, 0, 0.89444],
    934: [0, 0.68611, 0, 0, 0.83055],
    936: [0, 0.68611, 0, 0, 0.89444],
    937: [0, 0.68611, 0, 0, 0.83055],
    8211: [0, 0.44444, 0.03194, 0, 0.575],
    8212: [0, 0.44444, 0.03194, 0, 1.14999],
    8216: [0, 0.69444, 0, 0, 0.31944],
    8217: [0, 0.69444, 0, 0, 0.31944],
    8220: [0, 0.69444, 0, 0, 0.60278],
    8221: [0, 0.69444, 0, 0, 0.60278],
    8224: [0.19444, 0.69444, 0, 0, 0.51111],
    8225: [0.19444, 0.69444, 0, 0, 0.51111],
    8242: [0, 0.55556, 0, 0, 0.34444],
    8407: [0, 0.72444, 0.15486, 0, 0.575],
    8463: [0, 0.69444, 0, 0, 0.66759],
    8465: [0, 0.69444, 0, 0, 0.83055],
    8467: [0, 0.69444, 0, 0, 0.47361],
    8472: [0.19444, 0.44444, 0, 0, 0.74027],
    8476: [0, 0.69444, 0, 0, 0.83055],
    8501: [0, 0.69444, 0, 0, 0.70277],
    8592: [-0.10889, 0.39111, 0, 0, 1.14999],
    8593: [0.19444, 0.69444, 0, 0, 0.575],
    8594: [-0.10889, 0.39111, 0, 0, 1.14999],
    8595: [0.19444, 0.69444, 0, 0, 0.575],
    8596: [-0.10889, 0.39111, 0, 0, 1.14999],
    8597: [0.25, 0.75, 0, 0, 0.575],
    8598: [0.19444, 0.69444, 0, 0, 1.14999],
    8599: [0.19444, 0.69444, 0, 0, 1.14999],
    8600: [0.19444, 0.69444, 0, 0, 1.14999],
    8601: [0.19444, 0.69444, 0, 0, 1.14999],
    8636: [-0.10889, 0.39111, 0, 0, 1.14999],
    8637: [-0.10889, 0.39111, 0, 0, 1.14999],
    8640: [-0.10889, 0.39111, 0, 0, 1.14999],
    8641: [-0.10889, 0.39111, 0, 0, 1.14999],
    8656: [-0.10889, 0.39111, 0, 0, 1.14999],
    8657: [0.19444, 0.69444, 0, 0, 0.70277],
    8658: [-0.10889, 0.39111, 0, 0, 1.14999],
    8659: [0.19444, 0.69444, 0, 0, 0.70277],
    8660: [-0.10889, 0.39111, 0, 0, 1.14999],
    8661: [0.25, 0.75, 0, 0, 0.70277],
    8704: [0, 0.69444, 0, 0, 0.63889],
    8706: [0, 0.69444, 0.06389, 0, 0.62847],
    8707: [0, 0.69444, 0, 0, 0.63889],
    8709: [0.05556, 0.75, 0, 0, 0.575],
    8711: [0, 0.68611, 0, 0, 0.95833],
    8712: [0.08556, 0.58556, 0, 0, 0.76666],
    8715: [0.08556, 0.58556, 0, 0, 0.76666],
    8722: [0.13333, 0.63333, 0, 0, 0.89444],
    8723: [0.13333, 0.63333, 0, 0, 0.89444],
    8725: [0.25, 0.75, 0, 0, 0.575],
    8726: [0.25, 0.75, 0, 0, 0.575],
    8727: [-0.02778, 0.47222, 0, 0, 0.575],
    8728: [-0.02639, 0.47361, 0, 0, 0.575],
    8729: [-0.02639, 0.47361, 0, 0, 0.575],
    8730: [0.18, 0.82, 0, 0, 0.95833],
    8733: [0, 0.44444, 0, 0, 0.89444],
    8734: [0, 0.44444, 0, 0, 1.14999],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8739: [0.25, 0.75, 0, 0, 0.31944],
    8741: [0.25, 0.75, 0, 0, 0.575],
    8743: [0, 0.55556, 0, 0, 0.76666],
    8744: [0, 0.55556, 0, 0, 0.76666],
    8745: [0, 0.55556, 0, 0, 0.76666],
    8746: [0, 0.55556, 0, 0, 0.76666],
    8747: [0.19444, 0.69444, 0.12778, 0, 0.56875],
    8764: [-0.10889, 0.39111, 0, 0, 0.89444],
    8768: [0.19444, 0.69444, 0, 0, 0.31944],
    8771: [222e-5, 0.50222, 0, 0, 0.89444],
    8773: [0.027, 0.638, 0, 0, 0.894],
    8776: [0.02444, 0.52444, 0, 0, 0.89444],
    8781: [222e-5, 0.50222, 0, 0, 0.89444],
    8801: [222e-5, 0.50222, 0, 0, 0.89444],
    8804: [0.19667, 0.69667, 0, 0, 0.89444],
    8805: [0.19667, 0.69667, 0, 0, 0.89444],
    8810: [0.08556, 0.58556, 0, 0, 1.14999],
    8811: [0.08556, 0.58556, 0, 0, 1.14999],
    8826: [0.08556, 0.58556, 0, 0, 0.89444],
    8827: [0.08556, 0.58556, 0, 0, 0.89444],
    8834: [0.08556, 0.58556, 0, 0, 0.89444],
    8835: [0.08556, 0.58556, 0, 0, 0.89444],
    8838: [0.19667, 0.69667, 0, 0, 0.89444],
    8839: [0.19667, 0.69667, 0, 0, 0.89444],
    8846: [0, 0.55556, 0, 0, 0.76666],
    8849: [0.19667, 0.69667, 0, 0, 0.89444],
    8850: [0.19667, 0.69667, 0, 0, 0.89444],
    8851: [0, 0.55556, 0, 0, 0.76666],
    8852: [0, 0.55556, 0, 0, 0.76666],
    8853: [0.13333, 0.63333, 0, 0, 0.89444],
    8854: [0.13333, 0.63333, 0, 0, 0.89444],
    8855: [0.13333, 0.63333, 0, 0, 0.89444],
    8856: [0.13333, 0.63333, 0, 0, 0.89444],
    8857: [0.13333, 0.63333, 0, 0, 0.89444],
    8866: [0, 0.69444, 0, 0, 0.70277],
    8867: [0, 0.69444, 0, 0, 0.70277],
    8868: [0, 0.69444, 0, 0, 0.89444],
    8869: [0, 0.69444, 0, 0, 0.89444],
    8900: [-0.02639, 0.47361, 0, 0, 0.575],
    8901: [-0.02639, 0.47361, 0, 0, 0.31944],
    8902: [-0.02778, 0.47222, 0, 0, 0.575],
    8968: [0.25, 0.75, 0, 0, 0.51111],
    8969: [0.25, 0.75, 0, 0, 0.51111],
    8970: [0.25, 0.75, 0, 0, 0.51111],
    8971: [0.25, 0.75, 0, 0, 0.51111],
    8994: [-0.13889, 0.36111, 0, 0, 1.14999],
    8995: [-0.13889, 0.36111, 0, 0, 1.14999],
    9651: [0.19444, 0.69444, 0, 0, 1.02222],
    9657: [-0.02778, 0.47222, 0, 0, 0.575],
    9661: [0.19444, 0.69444, 0, 0, 1.02222],
    9667: [-0.02778, 0.47222, 0, 0, 0.575],
    9711: [0.19444, 0.69444, 0, 0, 1.14999],
    9824: [0.12963, 0.69444, 0, 0, 0.89444],
    9825: [0.12963, 0.69444, 0, 0, 0.89444],
    9826: [0.12963, 0.69444, 0, 0, 0.89444],
    9827: [0.12963, 0.69444, 0, 0, 0.89444],
    9837: [0, 0.75, 0, 0, 0.44722],
    9838: [0.19444, 0.69444, 0, 0, 0.44722],
    9839: [0.19444, 0.69444, 0, 0, 0.44722],
    10216: [0.25, 0.75, 0, 0, 0.44722],
    10217: [0.25, 0.75, 0, 0, 0.44722],
    10815: [0, 0.68611, 0, 0, 0.9],
    10927: [0.19667, 0.69667, 0, 0, 0.89444],
    10928: [0.19667, 0.69667, 0, 0, 0.89444],
    57376: [0.19444, 0.69444, 0, 0, 0]
  },
  "Main-BoldItalic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.11417, 0, 0.38611],
    34: [0, 0.69444, 0.07939, 0, 0.62055],
    35: [0.19444, 0.69444, 0.06833, 0, 0.94444],
    37: [0.05556, 0.75, 0.12861, 0, 0.94444],
    38: [0, 0.69444, 0.08528, 0, 0.88555],
    39: [0, 0.69444, 0.12945, 0, 0.35555],
    40: [0.25, 0.75, 0.15806, 0, 0.47333],
    41: [0.25, 0.75, 0.03306, 0, 0.47333],
    42: [0, 0.75, 0.14333, 0, 0.59111],
    43: [0.10333, 0.60333, 0.03306, 0, 0.88555],
    44: [0.19444, 0.14722, 0, 0, 0.35555],
    45: [0, 0.44444, 0.02611, 0, 0.41444],
    46: [0, 0.14722, 0, 0, 0.35555],
    47: [0.25, 0.75, 0.15806, 0, 0.59111],
    48: [0, 0.64444, 0.13167, 0, 0.59111],
    49: [0, 0.64444, 0.13167, 0, 0.59111],
    50: [0, 0.64444, 0.13167, 0, 0.59111],
    51: [0, 0.64444, 0.13167, 0, 0.59111],
    52: [0.19444, 0.64444, 0.13167, 0, 0.59111],
    53: [0, 0.64444, 0.13167, 0, 0.59111],
    54: [0, 0.64444, 0.13167, 0, 0.59111],
    55: [0.19444, 0.64444, 0.13167, 0, 0.59111],
    56: [0, 0.64444, 0.13167, 0, 0.59111],
    57: [0, 0.64444, 0.13167, 0, 0.59111],
    58: [0, 0.44444, 0.06695, 0, 0.35555],
    59: [0.19444, 0.44444, 0.06695, 0, 0.35555],
    61: [-0.10889, 0.39111, 0.06833, 0, 0.88555],
    63: [0, 0.69444, 0.11472, 0, 0.59111],
    64: [0, 0.69444, 0.09208, 0, 0.88555],
    65: [0, 0.68611, 0, 0, 0.86555],
    66: [0, 0.68611, 0.0992, 0, 0.81666],
    67: [0, 0.68611, 0.14208, 0, 0.82666],
    68: [0, 0.68611, 0.09062, 0, 0.87555],
    69: [0, 0.68611, 0.11431, 0, 0.75666],
    70: [0, 0.68611, 0.12903, 0, 0.72722],
    71: [0, 0.68611, 0.07347, 0, 0.89527],
    72: [0, 0.68611, 0.17208, 0, 0.8961],
    73: [0, 0.68611, 0.15681, 0, 0.47166],
    74: [0, 0.68611, 0.145, 0, 0.61055],
    75: [0, 0.68611, 0.14208, 0, 0.89499],
    76: [0, 0.68611, 0, 0, 0.69777],
    77: [0, 0.68611, 0.17208, 0, 1.07277],
    78: [0, 0.68611, 0.17208, 0, 0.8961],
    79: [0, 0.68611, 0.09062, 0, 0.85499],
    80: [0, 0.68611, 0.0992, 0, 0.78721],
    81: [0.19444, 0.68611, 0.09062, 0, 0.85499],
    82: [0, 0.68611, 0.02559, 0, 0.85944],
    83: [0, 0.68611, 0.11264, 0, 0.64999],
    84: [0, 0.68611, 0.12903, 0, 0.7961],
    85: [0, 0.68611, 0.17208, 0, 0.88083],
    86: [0, 0.68611, 0.18625, 0, 0.86555],
    87: [0, 0.68611, 0.18625, 0, 1.15999],
    88: [0, 0.68611, 0.15681, 0, 0.86555],
    89: [0, 0.68611, 0.19803, 0, 0.86555],
    90: [0, 0.68611, 0.14208, 0, 0.70888],
    91: [0.25, 0.75, 0.1875, 0, 0.35611],
    93: [0.25, 0.75, 0.09972, 0, 0.35611],
    94: [0, 0.69444, 0.06709, 0, 0.59111],
    95: [0.31, 0.13444, 0.09811, 0, 0.59111],
    97: [0, 0.44444, 0.09426, 0, 0.59111],
    98: [0, 0.69444, 0.07861, 0, 0.53222],
    99: [0, 0.44444, 0.05222, 0, 0.53222],
    100: [0, 0.69444, 0.10861, 0, 0.59111],
    101: [0, 0.44444, 0.085, 0, 0.53222],
    102: [0.19444, 0.69444, 0.21778, 0, 0.4],
    103: [0.19444, 0.44444, 0.105, 0, 0.53222],
    104: [0, 0.69444, 0.09426, 0, 0.59111],
    105: [0, 0.69326, 0.11387, 0, 0.35555],
    106: [0.19444, 0.69326, 0.1672, 0, 0.35555],
    107: [0, 0.69444, 0.11111, 0, 0.53222],
    108: [0, 0.69444, 0.10861, 0, 0.29666],
    109: [0, 0.44444, 0.09426, 0, 0.94444],
    110: [0, 0.44444, 0.09426, 0, 0.64999],
    111: [0, 0.44444, 0.07861, 0, 0.59111],
    112: [0.19444, 0.44444, 0.07861, 0, 0.59111],
    113: [0.19444, 0.44444, 0.105, 0, 0.53222],
    114: [0, 0.44444, 0.11111, 0, 0.50167],
    115: [0, 0.44444, 0.08167, 0, 0.48694],
    116: [0, 0.63492, 0.09639, 0, 0.385],
    117: [0, 0.44444, 0.09426, 0, 0.62055],
    118: [0, 0.44444, 0.11111, 0, 0.53222],
    119: [0, 0.44444, 0.11111, 0, 0.76777],
    120: [0, 0.44444, 0.12583, 0, 0.56055],
    121: [0.19444, 0.44444, 0.105, 0, 0.56166],
    122: [0, 0.44444, 0.13889, 0, 0.49055],
    126: [0.35, 0.34444, 0.11472, 0, 0.59111],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.69444, 0.11473, 0, 0.59111],
    176: [0, 0.69444, 0, 0, 0.94888],
    184: [0.17014, 0, 0, 0, 0.53222],
    198: [0, 0.68611, 0.11431, 0, 1.02277],
    216: [0.04861, 0.73472, 0.09062, 0, 0.88555],
    223: [0.19444, 0.69444, 0.09736, 0, 0.665],
    230: [0, 0.44444, 0.085, 0, 0.82666],
    248: [0.09722, 0.54167, 0.09458, 0, 0.59111],
    305: [0, 0.44444, 0.09426, 0, 0.35555],
    338: [0, 0.68611, 0.11431, 0, 1.14054],
    339: [0, 0.44444, 0.085, 0, 0.82666],
    567: [0.19444, 0.44444, 0.04611, 0, 0.385],
    710: [0, 0.69444, 0.06709, 0, 0.59111],
    711: [0, 0.63194, 0.08271, 0, 0.59111],
    713: [0, 0.59444, 0.10444, 0, 0.59111],
    714: [0, 0.69444, 0.08528, 0, 0.59111],
    715: [0, 0.69444, 0, 0, 0.59111],
    728: [0, 0.69444, 0.10333, 0, 0.59111],
    729: [0, 0.69444, 0.12945, 0, 0.35555],
    730: [0, 0.69444, 0, 0, 0.94888],
    732: [0, 0.69444, 0.11472, 0, 0.59111],
    733: [0, 0.69444, 0.11472, 0, 0.59111],
    915: [0, 0.68611, 0.12903, 0, 0.69777],
    916: [0, 0.68611, 0, 0, 0.94444],
    920: [0, 0.68611, 0.09062, 0, 0.88555],
    923: [0, 0.68611, 0, 0, 0.80666],
    926: [0, 0.68611, 0.15092, 0, 0.76777],
    928: [0, 0.68611, 0.17208, 0, 0.8961],
    931: [0, 0.68611, 0.11431, 0, 0.82666],
    933: [0, 0.68611, 0.10778, 0, 0.88555],
    934: [0, 0.68611, 0.05632, 0, 0.82666],
    936: [0, 0.68611, 0.10778, 0, 0.88555],
    937: [0, 0.68611, 0.0992, 0, 0.82666],
    8211: [0, 0.44444, 0.09811, 0, 0.59111],
    8212: [0, 0.44444, 0.09811, 0, 1.18221],
    8216: [0, 0.69444, 0.12945, 0, 0.35555],
    8217: [0, 0.69444, 0.12945, 0, 0.35555],
    8220: [0, 0.69444, 0.16772, 0, 0.62055],
    8221: [0, 0.69444, 0.07939, 0, 0.62055]
  },
  "Main-Italic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.12417, 0, 0.30667],
    34: [0, 0.69444, 0.06961, 0, 0.51444],
    35: [0.19444, 0.69444, 0.06616, 0, 0.81777],
    37: [0.05556, 0.75, 0.13639, 0, 0.81777],
    38: [0, 0.69444, 0.09694, 0, 0.76666],
    39: [0, 0.69444, 0.12417, 0, 0.30667],
    40: [0.25, 0.75, 0.16194, 0, 0.40889],
    41: [0.25, 0.75, 0.03694, 0, 0.40889],
    42: [0, 0.75, 0.14917, 0, 0.51111],
    43: [0.05667, 0.56167, 0.03694, 0, 0.76666],
    44: [0.19444, 0.10556, 0, 0, 0.30667],
    45: [0, 0.43056, 0.02826, 0, 0.35778],
    46: [0, 0.10556, 0, 0, 0.30667],
    47: [0.25, 0.75, 0.16194, 0, 0.51111],
    48: [0, 0.64444, 0.13556, 0, 0.51111],
    49: [0, 0.64444, 0.13556, 0, 0.51111],
    50: [0, 0.64444, 0.13556, 0, 0.51111],
    51: [0, 0.64444, 0.13556, 0, 0.51111],
    52: [0.19444, 0.64444, 0.13556, 0, 0.51111],
    53: [0, 0.64444, 0.13556, 0, 0.51111],
    54: [0, 0.64444, 0.13556, 0, 0.51111],
    55: [0.19444, 0.64444, 0.13556, 0, 0.51111],
    56: [0, 0.64444, 0.13556, 0, 0.51111],
    57: [0, 0.64444, 0.13556, 0, 0.51111],
    58: [0, 0.43056, 0.0582, 0, 0.30667],
    59: [0.19444, 0.43056, 0.0582, 0, 0.30667],
    61: [-0.13313, 0.36687, 0.06616, 0, 0.76666],
    63: [0, 0.69444, 0.1225, 0, 0.51111],
    64: [0, 0.69444, 0.09597, 0, 0.76666],
    65: [0, 0.68333, 0, 0, 0.74333],
    66: [0, 0.68333, 0.10257, 0, 0.70389],
    67: [0, 0.68333, 0.14528, 0, 0.71555],
    68: [0, 0.68333, 0.09403, 0, 0.755],
    69: [0, 0.68333, 0.12028, 0, 0.67833],
    70: [0, 0.68333, 0.13305, 0, 0.65277],
    71: [0, 0.68333, 0.08722, 0, 0.77361],
    72: [0, 0.68333, 0.16389, 0, 0.74333],
    73: [0, 0.68333, 0.15806, 0, 0.38555],
    74: [0, 0.68333, 0.14028, 0, 0.525],
    75: [0, 0.68333, 0.14528, 0, 0.76888],
    76: [0, 0.68333, 0, 0, 0.62722],
    77: [0, 0.68333, 0.16389, 0, 0.89666],
    78: [0, 0.68333, 0.16389, 0, 0.74333],
    79: [0, 0.68333, 0.09403, 0, 0.76666],
    80: [0, 0.68333, 0.10257, 0, 0.67833],
    81: [0.19444, 0.68333, 0.09403, 0, 0.76666],
    82: [0, 0.68333, 0.03868, 0, 0.72944],
    83: [0, 0.68333, 0.11972, 0, 0.56222],
    84: [0, 0.68333, 0.13305, 0, 0.71555],
    85: [0, 0.68333, 0.16389, 0, 0.74333],
    86: [0, 0.68333, 0.18361, 0, 0.74333],
    87: [0, 0.68333, 0.18361, 0, 0.99888],
    88: [0, 0.68333, 0.15806, 0, 0.74333],
    89: [0, 0.68333, 0.19383, 0, 0.74333],
    90: [0, 0.68333, 0.14528, 0, 0.61333],
    91: [0.25, 0.75, 0.1875, 0, 0.30667],
    93: [0.25, 0.75, 0.10528, 0, 0.30667],
    94: [0, 0.69444, 0.06646, 0, 0.51111],
    95: [0.31, 0.12056, 0.09208, 0, 0.51111],
    97: [0, 0.43056, 0.07671, 0, 0.51111],
    98: [0, 0.69444, 0.06312, 0, 0.46],
    99: [0, 0.43056, 0.05653, 0, 0.46],
    100: [0, 0.69444, 0.10333, 0, 0.51111],
    101: [0, 0.43056, 0.07514, 0, 0.46],
    102: [0.19444, 0.69444, 0.21194, 0, 0.30667],
    103: [0.19444, 0.43056, 0.08847, 0, 0.46],
    104: [0, 0.69444, 0.07671, 0, 0.51111],
    105: [0, 0.65536, 0.1019, 0, 0.30667],
    106: [0.19444, 0.65536, 0.14467, 0, 0.30667],
    107: [0, 0.69444, 0.10764, 0, 0.46],
    108: [0, 0.69444, 0.10333, 0, 0.25555],
    109: [0, 0.43056, 0.07671, 0, 0.81777],
    110: [0, 0.43056, 0.07671, 0, 0.56222],
    111: [0, 0.43056, 0.06312, 0, 0.51111],
    112: [0.19444, 0.43056, 0.06312, 0, 0.51111],
    113: [0.19444, 0.43056, 0.08847, 0, 0.46],
    114: [0, 0.43056, 0.10764, 0, 0.42166],
    115: [0, 0.43056, 0.08208, 0, 0.40889],
    116: [0, 0.61508, 0.09486, 0, 0.33222],
    117: [0, 0.43056, 0.07671, 0, 0.53666],
    118: [0, 0.43056, 0.10764, 0, 0.46],
    119: [0, 0.43056, 0.10764, 0, 0.66444],
    120: [0, 0.43056, 0.12042, 0, 0.46389],
    121: [0.19444, 0.43056, 0.08847, 0, 0.48555],
    122: [0, 0.43056, 0.12292, 0, 0.40889],
    126: [0.35, 0.31786, 0.11585, 0, 0.51111],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.66786, 0.10474, 0, 0.51111],
    176: [0, 0.69444, 0, 0, 0.83129],
    184: [0.17014, 0, 0, 0, 0.46],
    198: [0, 0.68333, 0.12028, 0, 0.88277],
    216: [0.04861, 0.73194, 0.09403, 0, 0.76666],
    223: [0.19444, 0.69444, 0.10514, 0, 0.53666],
    230: [0, 0.43056, 0.07514, 0, 0.71555],
    248: [0.09722, 0.52778, 0.09194, 0, 0.51111],
    338: [0, 0.68333, 0.12028, 0, 0.98499],
    339: [0, 0.43056, 0.07514, 0, 0.71555],
    710: [0, 0.69444, 0.06646, 0, 0.51111],
    711: [0, 0.62847, 0.08295, 0, 0.51111],
    713: [0, 0.56167, 0.10333, 0, 0.51111],
    714: [0, 0.69444, 0.09694, 0, 0.51111],
    715: [0, 0.69444, 0, 0, 0.51111],
    728: [0, 0.69444, 0.10806, 0, 0.51111],
    729: [0, 0.66786, 0.11752, 0, 0.30667],
    730: [0, 0.69444, 0, 0, 0.83129],
    732: [0, 0.66786, 0.11585, 0, 0.51111],
    733: [0, 0.69444, 0.1225, 0, 0.51111],
    915: [0, 0.68333, 0.13305, 0, 0.62722],
    916: [0, 0.68333, 0, 0, 0.81777],
    920: [0, 0.68333, 0.09403, 0, 0.76666],
    923: [0, 0.68333, 0, 0, 0.69222],
    926: [0, 0.68333, 0.15294, 0, 0.66444],
    928: [0, 0.68333, 0.16389, 0, 0.74333],
    931: [0, 0.68333, 0.12028, 0, 0.71555],
    933: [0, 0.68333, 0.11111, 0, 0.76666],
    934: [0, 0.68333, 0.05986, 0, 0.71555],
    936: [0, 0.68333, 0.11111, 0, 0.76666],
    937: [0, 0.68333, 0.10257, 0, 0.71555],
    8211: [0, 0.43056, 0.09208, 0, 0.51111],
    8212: [0, 0.43056, 0.09208, 0, 1.02222],
    8216: [0, 0.69444, 0.12417, 0, 0.30667],
    8217: [0, 0.69444, 0.12417, 0, 0.30667],
    8220: [0, 0.69444, 0.1685, 0, 0.51444],
    8221: [0, 0.69444, 0.06961, 0, 0.51444],
    8463: [0, 0.68889, 0, 0, 0.54028]
  },
  "Main-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.27778],
    34: [0, 0.69444, 0, 0, 0.5],
    35: [0.19444, 0.69444, 0, 0, 0.83334],
    36: [0.05556, 0.75, 0, 0, 0.5],
    37: [0.05556, 0.75, 0, 0, 0.83334],
    38: [0, 0.69444, 0, 0, 0.77778],
    39: [0, 0.69444, 0, 0, 0.27778],
    40: [0.25, 0.75, 0, 0, 0.38889],
    41: [0.25, 0.75, 0, 0, 0.38889],
    42: [0, 0.75, 0, 0, 0.5],
    43: [0.08333, 0.58333, 0, 0, 0.77778],
    44: [0.19444, 0.10556, 0, 0, 0.27778],
    45: [0, 0.43056, 0, 0, 0.33333],
    46: [0, 0.10556, 0, 0, 0.27778],
    47: [0.25, 0.75, 0, 0, 0.5],
    48: [0, 0.64444, 0, 0, 0.5],
    49: [0, 0.64444, 0, 0, 0.5],
    50: [0, 0.64444, 0, 0, 0.5],
    51: [0, 0.64444, 0, 0, 0.5],
    52: [0, 0.64444, 0, 0, 0.5],
    53: [0, 0.64444, 0, 0, 0.5],
    54: [0, 0.64444, 0, 0, 0.5],
    55: [0, 0.64444, 0, 0, 0.5],
    56: [0, 0.64444, 0, 0, 0.5],
    57: [0, 0.64444, 0, 0, 0.5],
    58: [0, 0.43056, 0, 0, 0.27778],
    59: [0.19444, 0.43056, 0, 0, 0.27778],
    60: [0.0391, 0.5391, 0, 0, 0.77778],
    61: [-0.13313, 0.36687, 0, 0, 0.77778],
    62: [0.0391, 0.5391, 0, 0, 0.77778],
    63: [0, 0.69444, 0, 0, 0.47222],
    64: [0, 0.69444, 0, 0, 0.77778],
    65: [0, 0.68333, 0, 0, 0.75],
    66: [0, 0.68333, 0, 0, 0.70834],
    67: [0, 0.68333, 0, 0, 0.72222],
    68: [0, 0.68333, 0, 0, 0.76389],
    69: [0, 0.68333, 0, 0, 0.68056],
    70: [0, 0.68333, 0, 0, 0.65278],
    71: [0, 0.68333, 0, 0, 0.78472],
    72: [0, 0.68333, 0, 0, 0.75],
    73: [0, 0.68333, 0, 0, 0.36111],
    74: [0, 0.68333, 0, 0, 0.51389],
    75: [0, 0.68333, 0, 0, 0.77778],
    76: [0, 0.68333, 0, 0, 0.625],
    77: [0, 0.68333, 0, 0, 0.91667],
    78: [0, 0.68333, 0, 0, 0.75],
    79: [0, 0.68333, 0, 0, 0.77778],
    80: [0, 0.68333, 0, 0, 0.68056],
    81: [0.19444, 0.68333, 0, 0, 0.77778],
    82: [0, 0.68333, 0, 0, 0.73611],
    83: [0, 0.68333, 0, 0, 0.55556],
    84: [0, 0.68333, 0, 0, 0.72222],
    85: [0, 0.68333, 0, 0, 0.75],
    86: [0, 0.68333, 0.01389, 0, 0.75],
    87: [0, 0.68333, 0.01389, 0, 1.02778],
    88: [0, 0.68333, 0, 0, 0.75],
    89: [0, 0.68333, 0.025, 0, 0.75],
    90: [0, 0.68333, 0, 0, 0.61111],
    91: [0.25, 0.75, 0, 0, 0.27778],
    92: [0.25, 0.75, 0, 0, 0.5],
    93: [0.25, 0.75, 0, 0, 0.27778],
    94: [0, 0.69444, 0, 0, 0.5],
    95: [0.31, 0.12056, 0.02778, 0, 0.5],
    97: [0, 0.43056, 0, 0, 0.5],
    98: [0, 0.69444, 0, 0, 0.55556],
    99: [0, 0.43056, 0, 0, 0.44445],
    100: [0, 0.69444, 0, 0, 0.55556],
    101: [0, 0.43056, 0, 0, 0.44445],
    102: [0, 0.69444, 0.07778, 0, 0.30556],
    103: [0.19444, 0.43056, 0.01389, 0, 0.5],
    104: [0, 0.69444, 0, 0, 0.55556],
    105: [0, 0.66786, 0, 0, 0.27778],
    106: [0.19444, 0.66786, 0, 0, 0.30556],
    107: [0, 0.69444, 0, 0, 0.52778],
    108: [0, 0.69444, 0, 0, 0.27778],
    109: [0, 0.43056, 0, 0, 0.83334],
    110: [0, 0.43056, 0, 0, 0.55556],
    111: [0, 0.43056, 0, 0, 0.5],
    112: [0.19444, 0.43056, 0, 0, 0.55556],
    113: [0.19444, 0.43056, 0, 0, 0.52778],
    114: [0, 0.43056, 0, 0, 0.39167],
    115: [0, 0.43056, 0, 0, 0.39445],
    116: [0, 0.61508, 0, 0, 0.38889],
    117: [0, 0.43056, 0, 0, 0.55556],
    118: [0, 0.43056, 0.01389, 0, 0.52778],
    119: [0, 0.43056, 0.01389, 0, 0.72222],
    120: [0, 0.43056, 0, 0, 0.52778],
    121: [0.19444, 0.43056, 0.01389, 0, 0.52778],
    122: [0, 0.43056, 0, 0, 0.44445],
    123: [0.25, 0.75, 0, 0, 0.5],
    124: [0.25, 0.75, 0, 0, 0.27778],
    125: [0.25, 0.75, 0, 0, 0.5],
    126: [0.35, 0.31786, 0, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    163: [0, 0.69444, 0, 0, 0.76909],
    167: [0.19444, 0.69444, 0, 0, 0.44445],
    168: [0, 0.66786, 0, 0, 0.5],
    172: [0, 0.43056, 0, 0, 0.66667],
    176: [0, 0.69444, 0, 0, 0.75],
    177: [0.08333, 0.58333, 0, 0, 0.77778],
    182: [0.19444, 0.69444, 0, 0, 0.61111],
    184: [0.17014, 0, 0, 0, 0.44445],
    198: [0, 0.68333, 0, 0, 0.90278],
    215: [0.08333, 0.58333, 0, 0, 0.77778],
    216: [0.04861, 0.73194, 0, 0, 0.77778],
    223: [0, 0.69444, 0, 0, 0.5],
    230: [0, 0.43056, 0, 0, 0.72222],
    247: [0.08333, 0.58333, 0, 0, 0.77778],
    248: [0.09722, 0.52778, 0, 0, 0.5],
    305: [0, 0.43056, 0, 0, 0.27778],
    338: [0, 0.68333, 0, 0, 1.01389],
    339: [0, 0.43056, 0, 0, 0.77778],
    567: [0.19444, 0.43056, 0, 0, 0.30556],
    710: [0, 0.69444, 0, 0, 0.5],
    711: [0, 0.62847, 0, 0, 0.5],
    713: [0, 0.56778, 0, 0, 0.5],
    714: [0, 0.69444, 0, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0, 0, 0.5],
    729: [0, 0.66786, 0, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.75],
    732: [0, 0.66786, 0, 0, 0.5],
    733: [0, 0.69444, 0, 0, 0.5],
    915: [0, 0.68333, 0, 0, 0.625],
    916: [0, 0.68333, 0, 0, 0.83334],
    920: [0, 0.68333, 0, 0, 0.77778],
    923: [0, 0.68333, 0, 0, 0.69445],
    926: [0, 0.68333, 0, 0, 0.66667],
    928: [0, 0.68333, 0, 0, 0.75],
    931: [0, 0.68333, 0, 0, 0.72222],
    933: [0, 0.68333, 0, 0, 0.77778],
    934: [0, 0.68333, 0, 0, 0.72222],
    936: [0, 0.68333, 0, 0, 0.77778],
    937: [0, 0.68333, 0, 0, 0.72222],
    8211: [0, 0.43056, 0.02778, 0, 0.5],
    8212: [0, 0.43056, 0.02778, 0, 1],
    8216: [0, 0.69444, 0, 0, 0.27778],
    8217: [0, 0.69444, 0, 0, 0.27778],
    8220: [0, 0.69444, 0, 0, 0.5],
    8221: [0, 0.69444, 0, 0, 0.5],
    8224: [0.19444, 0.69444, 0, 0, 0.44445],
    8225: [0.19444, 0.69444, 0, 0, 0.44445],
    8230: [0, 0.123, 0, 0, 1.172],
    8242: [0, 0.55556, 0, 0, 0.275],
    8407: [0, 0.71444, 0.15382, 0, 0.5],
    8463: [0, 0.68889, 0, 0, 0.54028],
    8465: [0, 0.69444, 0, 0, 0.72222],
    8467: [0, 0.69444, 0, 0.11111, 0.41667],
    8472: [0.19444, 0.43056, 0, 0.11111, 0.63646],
    8476: [0, 0.69444, 0, 0, 0.72222],
    8501: [0, 0.69444, 0, 0, 0.61111],
    8592: [-0.13313, 0.36687, 0, 0, 1],
    8593: [0.19444, 0.69444, 0, 0, 0.5],
    8594: [-0.13313, 0.36687, 0, 0, 1],
    8595: [0.19444, 0.69444, 0, 0, 0.5],
    8596: [-0.13313, 0.36687, 0, 0, 1],
    8597: [0.25, 0.75, 0, 0, 0.5],
    8598: [0.19444, 0.69444, 0, 0, 1],
    8599: [0.19444, 0.69444, 0, 0, 1],
    8600: [0.19444, 0.69444, 0, 0, 1],
    8601: [0.19444, 0.69444, 0, 0, 1],
    8614: [0.011, 0.511, 0, 0, 1],
    8617: [0.011, 0.511, 0, 0, 1.126],
    8618: [0.011, 0.511, 0, 0, 1.126],
    8636: [-0.13313, 0.36687, 0, 0, 1],
    8637: [-0.13313, 0.36687, 0, 0, 1],
    8640: [-0.13313, 0.36687, 0, 0, 1],
    8641: [-0.13313, 0.36687, 0, 0, 1],
    8652: [0.011, 0.671, 0, 0, 1],
    8656: [-0.13313, 0.36687, 0, 0, 1],
    8657: [0.19444, 0.69444, 0, 0, 0.61111],
    8658: [-0.13313, 0.36687, 0, 0, 1],
    8659: [0.19444, 0.69444, 0, 0, 0.61111],
    8660: [-0.13313, 0.36687, 0, 0, 1],
    8661: [0.25, 0.75, 0, 0, 0.61111],
    8704: [0, 0.69444, 0, 0, 0.55556],
    8706: [0, 0.69444, 0.05556, 0.08334, 0.5309],
    8707: [0, 0.69444, 0, 0, 0.55556],
    8709: [0.05556, 0.75, 0, 0, 0.5],
    8711: [0, 0.68333, 0, 0, 0.83334],
    8712: [0.0391, 0.5391, 0, 0, 0.66667],
    8715: [0.0391, 0.5391, 0, 0, 0.66667],
    8722: [0.08333, 0.58333, 0, 0, 0.77778],
    8723: [0.08333, 0.58333, 0, 0, 0.77778],
    8725: [0.25, 0.75, 0, 0, 0.5],
    8726: [0.25, 0.75, 0, 0, 0.5],
    8727: [-0.03472, 0.46528, 0, 0, 0.5],
    8728: [-0.05555, 0.44445, 0, 0, 0.5],
    8729: [-0.05555, 0.44445, 0, 0, 0.5],
    8730: [0.2, 0.8, 0, 0, 0.83334],
    8733: [0, 0.43056, 0, 0, 0.77778],
    8734: [0, 0.43056, 0, 0, 1],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8739: [0.25, 0.75, 0, 0, 0.27778],
    8741: [0.25, 0.75, 0, 0, 0.5],
    8743: [0, 0.55556, 0, 0, 0.66667],
    8744: [0, 0.55556, 0, 0, 0.66667],
    8745: [0, 0.55556, 0, 0, 0.66667],
    8746: [0, 0.55556, 0, 0, 0.66667],
    8747: [0.19444, 0.69444, 0.11111, 0, 0.41667],
    8764: [-0.13313, 0.36687, 0, 0, 0.77778],
    8768: [0.19444, 0.69444, 0, 0, 0.27778],
    8771: [-0.03625, 0.46375, 0, 0, 0.77778],
    8773: [-0.022, 0.589, 0, 0, 0.778],
    8776: [-0.01688, 0.48312, 0, 0, 0.77778],
    8781: [-0.03625, 0.46375, 0, 0, 0.77778],
    8784: [-0.133, 0.673, 0, 0, 0.778],
    8801: [-0.03625, 0.46375, 0, 0, 0.77778],
    8804: [0.13597, 0.63597, 0, 0, 0.77778],
    8805: [0.13597, 0.63597, 0, 0, 0.77778],
    8810: [0.0391, 0.5391, 0, 0, 1],
    8811: [0.0391, 0.5391, 0, 0, 1],
    8826: [0.0391, 0.5391, 0, 0, 0.77778],
    8827: [0.0391, 0.5391, 0, 0, 0.77778],
    8834: [0.0391, 0.5391, 0, 0, 0.77778],
    8835: [0.0391, 0.5391, 0, 0, 0.77778],
    8838: [0.13597, 0.63597, 0, 0, 0.77778],
    8839: [0.13597, 0.63597, 0, 0, 0.77778],
    8846: [0, 0.55556, 0, 0, 0.66667],
    8849: [0.13597, 0.63597, 0, 0, 0.77778],
    8850: [0.13597, 0.63597, 0, 0, 0.77778],
    8851: [0, 0.55556, 0, 0, 0.66667],
    8852: [0, 0.55556, 0, 0, 0.66667],
    8853: [0.08333, 0.58333, 0, 0, 0.77778],
    8854: [0.08333, 0.58333, 0, 0, 0.77778],
    8855: [0.08333, 0.58333, 0, 0, 0.77778],
    8856: [0.08333, 0.58333, 0, 0, 0.77778],
    8857: [0.08333, 0.58333, 0, 0, 0.77778],
    8866: [0, 0.69444, 0, 0, 0.61111],
    8867: [0, 0.69444, 0, 0, 0.61111],
    8868: [0, 0.69444, 0, 0, 0.77778],
    8869: [0, 0.69444, 0, 0, 0.77778],
    8872: [0.249, 0.75, 0, 0, 0.867],
    8900: [-0.05555, 0.44445, 0, 0, 0.5],
    8901: [-0.05555, 0.44445, 0, 0, 0.27778],
    8902: [-0.03472, 0.46528, 0, 0, 0.5],
    8904: [5e-3, 0.505, 0, 0, 0.9],
    8942: [0.03, 0.903, 0, 0, 0.278],
    8943: [-0.19, 0.313, 0, 0, 1.172],
    8945: [-0.1, 0.823, 0, 0, 1.282],
    8968: [0.25, 0.75, 0, 0, 0.44445],
    8969: [0.25, 0.75, 0, 0, 0.44445],
    8970: [0.25, 0.75, 0, 0, 0.44445],
    8971: [0.25, 0.75, 0, 0, 0.44445],
    8994: [-0.14236, 0.35764, 0, 0, 1],
    8995: [-0.14236, 0.35764, 0, 0, 1],
    9136: [0.244, 0.744, 0, 0, 0.412],
    9137: [0.244, 0.745, 0, 0, 0.412],
    9651: [0.19444, 0.69444, 0, 0, 0.88889],
    9657: [-0.03472, 0.46528, 0, 0, 0.5],
    9661: [0.19444, 0.69444, 0, 0, 0.88889],
    9667: [-0.03472, 0.46528, 0, 0, 0.5],
    9711: [0.19444, 0.69444, 0, 0, 1],
    9824: [0.12963, 0.69444, 0, 0, 0.77778],
    9825: [0.12963, 0.69444, 0, 0, 0.77778],
    9826: [0.12963, 0.69444, 0, 0, 0.77778],
    9827: [0.12963, 0.69444, 0, 0, 0.77778],
    9837: [0, 0.75, 0, 0, 0.38889],
    9838: [0.19444, 0.69444, 0, 0, 0.38889],
    9839: [0.19444, 0.69444, 0, 0, 0.38889],
    10216: [0.25, 0.75, 0, 0, 0.38889],
    10217: [0.25, 0.75, 0, 0, 0.38889],
    10222: [0.244, 0.744, 0, 0, 0.412],
    10223: [0.244, 0.745, 0, 0, 0.412],
    10229: [0.011, 0.511, 0, 0, 1.609],
    10230: [0.011, 0.511, 0, 0, 1.638],
    10231: [0.011, 0.511, 0, 0, 1.859],
    10232: [0.024, 0.525, 0, 0, 1.609],
    10233: [0.024, 0.525, 0, 0, 1.638],
    10234: [0.024, 0.525, 0, 0, 1.858],
    10236: [0.011, 0.511, 0, 0, 1.638],
    10815: [0, 0.68333, 0, 0, 0.75],
    10927: [0.13597, 0.63597, 0, 0, 0.77778],
    10928: [0.13597, 0.63597, 0, 0, 0.77778],
    57376: [0.19444, 0.69444, 0, 0, 0]
  },
  "Math-BoldItalic": {
    32: [0, 0, 0, 0, 0.25],
    48: [0, 0.44444, 0, 0, 0.575],
    49: [0, 0.44444, 0, 0, 0.575],
    50: [0, 0.44444, 0, 0, 0.575],
    51: [0.19444, 0.44444, 0, 0, 0.575],
    52: [0.19444, 0.44444, 0, 0, 0.575],
    53: [0.19444, 0.44444, 0, 0, 0.575],
    54: [0, 0.64444, 0, 0, 0.575],
    55: [0.19444, 0.44444, 0, 0, 0.575],
    56: [0, 0.64444, 0, 0, 0.575],
    57: [0.19444, 0.44444, 0, 0, 0.575],
    65: [0, 0.68611, 0, 0, 0.86944],
    66: [0, 0.68611, 0.04835, 0, 0.8664],
    67: [0, 0.68611, 0.06979, 0, 0.81694],
    68: [0, 0.68611, 0.03194, 0, 0.93812],
    69: [0, 0.68611, 0.05451, 0, 0.81007],
    70: [0, 0.68611, 0.15972, 0, 0.68889],
    71: [0, 0.68611, 0, 0, 0.88673],
    72: [0, 0.68611, 0.08229, 0, 0.98229],
    73: [0, 0.68611, 0.07778, 0, 0.51111],
    74: [0, 0.68611, 0.10069, 0, 0.63125],
    75: [0, 0.68611, 0.06979, 0, 0.97118],
    76: [0, 0.68611, 0, 0, 0.75555],
    77: [0, 0.68611, 0.11424, 0, 1.14201],
    78: [0, 0.68611, 0.11424, 0, 0.95034],
    79: [0, 0.68611, 0.03194, 0, 0.83666],
    80: [0, 0.68611, 0.15972, 0, 0.72309],
    81: [0.19444, 0.68611, 0, 0, 0.86861],
    82: [0, 0.68611, 421e-5, 0, 0.87235],
    83: [0, 0.68611, 0.05382, 0, 0.69271],
    84: [0, 0.68611, 0.15972, 0, 0.63663],
    85: [0, 0.68611, 0.11424, 0, 0.80027],
    86: [0, 0.68611, 0.25555, 0, 0.67778],
    87: [0, 0.68611, 0.15972, 0, 1.09305],
    88: [0, 0.68611, 0.07778, 0, 0.94722],
    89: [0, 0.68611, 0.25555, 0, 0.67458],
    90: [0, 0.68611, 0.06979, 0, 0.77257],
    97: [0, 0.44444, 0, 0, 0.63287],
    98: [0, 0.69444, 0, 0, 0.52083],
    99: [0, 0.44444, 0, 0, 0.51342],
    100: [0, 0.69444, 0, 0, 0.60972],
    101: [0, 0.44444, 0, 0, 0.55361],
    102: [0.19444, 0.69444, 0.11042, 0, 0.56806],
    103: [0.19444, 0.44444, 0.03704, 0, 0.5449],
    104: [0, 0.69444, 0, 0, 0.66759],
    105: [0, 0.69326, 0, 0, 0.4048],
    106: [0.19444, 0.69326, 0.0622, 0, 0.47083],
    107: [0, 0.69444, 0.01852, 0, 0.6037],
    108: [0, 0.69444, 88e-4, 0, 0.34815],
    109: [0, 0.44444, 0, 0, 1.0324],
    110: [0, 0.44444, 0, 0, 0.71296],
    111: [0, 0.44444, 0, 0, 0.58472],
    112: [0.19444, 0.44444, 0, 0, 0.60092],
    113: [0.19444, 0.44444, 0.03704, 0, 0.54213],
    114: [0, 0.44444, 0.03194, 0, 0.5287],
    115: [0, 0.44444, 0, 0, 0.53125],
    116: [0, 0.63492, 0, 0, 0.41528],
    117: [0, 0.44444, 0, 0, 0.68102],
    118: [0, 0.44444, 0.03704, 0, 0.56666],
    119: [0, 0.44444, 0.02778, 0, 0.83148],
    120: [0, 0.44444, 0, 0, 0.65903],
    121: [0.19444, 0.44444, 0.03704, 0, 0.59028],
    122: [0, 0.44444, 0.04213, 0, 0.55509],
    160: [0, 0, 0, 0, 0.25],
    915: [0, 0.68611, 0.15972, 0, 0.65694],
    916: [0, 0.68611, 0, 0, 0.95833],
    920: [0, 0.68611, 0.03194, 0, 0.86722],
    923: [0, 0.68611, 0, 0, 0.80555],
    926: [0, 0.68611, 0.07458, 0, 0.84125],
    928: [0, 0.68611, 0.08229, 0, 0.98229],
    931: [0, 0.68611, 0.05451, 0, 0.88507],
    933: [0, 0.68611, 0.15972, 0, 0.67083],
    934: [0, 0.68611, 0, 0, 0.76666],
    936: [0, 0.68611, 0.11653, 0, 0.71402],
    937: [0, 0.68611, 0.04835, 0, 0.8789],
    945: [0, 0.44444, 0, 0, 0.76064],
    946: [0.19444, 0.69444, 0.03403, 0, 0.65972],
    947: [0.19444, 0.44444, 0.06389, 0, 0.59003],
    948: [0, 0.69444, 0.03819, 0, 0.52222],
    949: [0, 0.44444, 0, 0, 0.52882],
    950: [0.19444, 0.69444, 0.06215, 0, 0.50833],
    951: [0.19444, 0.44444, 0.03704, 0, 0.6],
    952: [0, 0.69444, 0.03194, 0, 0.5618],
    953: [0, 0.44444, 0, 0, 0.41204],
    954: [0, 0.44444, 0, 0, 0.66759],
    955: [0, 0.69444, 0, 0, 0.67083],
    956: [0.19444, 0.44444, 0, 0, 0.70787],
    957: [0, 0.44444, 0.06898, 0, 0.57685],
    958: [0.19444, 0.69444, 0.03021, 0, 0.50833],
    959: [0, 0.44444, 0, 0, 0.58472],
    960: [0, 0.44444, 0.03704, 0, 0.68241],
    961: [0.19444, 0.44444, 0, 0, 0.6118],
    962: [0.09722, 0.44444, 0.07917, 0, 0.42361],
    963: [0, 0.44444, 0.03704, 0, 0.68588],
    964: [0, 0.44444, 0.13472, 0, 0.52083],
    965: [0, 0.44444, 0.03704, 0, 0.63055],
    966: [0.19444, 0.44444, 0, 0, 0.74722],
    967: [0.19444, 0.44444, 0, 0, 0.71805],
    968: [0.19444, 0.69444, 0.03704, 0, 0.75833],
    969: [0, 0.44444, 0.03704, 0, 0.71782],
    977: [0, 0.69444, 0, 0, 0.69155],
    981: [0.19444, 0.69444, 0, 0, 0.7125],
    982: [0, 0.44444, 0.03194, 0, 0.975],
    1009: [0.19444, 0.44444, 0, 0, 0.6118],
    1013: [0, 0.44444, 0, 0, 0.48333],
    57649: [0, 0.44444, 0, 0, 0.39352],
    57911: [0.19444, 0.44444, 0, 0, 0.43889]
  },
  "Math-Italic": {
    32: [0, 0, 0, 0, 0.25],
    48: [0, 0.43056, 0, 0, 0.5],
    49: [0, 0.43056, 0, 0, 0.5],
    50: [0, 0.43056, 0, 0, 0.5],
    51: [0.19444, 0.43056, 0, 0, 0.5],
    52: [0.19444, 0.43056, 0, 0, 0.5],
    53: [0.19444, 0.43056, 0, 0, 0.5],
    54: [0, 0.64444, 0, 0, 0.5],
    55: [0.19444, 0.43056, 0, 0, 0.5],
    56: [0, 0.64444, 0, 0, 0.5],
    57: [0.19444, 0.43056, 0, 0, 0.5],
    65: [0, 0.68333, 0, 0.13889, 0.75],
    66: [0, 0.68333, 0.05017, 0.08334, 0.75851],
    67: [0, 0.68333, 0.07153, 0.08334, 0.71472],
    68: [0, 0.68333, 0.02778, 0.05556, 0.82792],
    69: [0, 0.68333, 0.05764, 0.08334, 0.7382],
    70: [0, 0.68333, 0.13889, 0.08334, 0.64306],
    71: [0, 0.68333, 0, 0.08334, 0.78625],
    72: [0, 0.68333, 0.08125, 0.05556, 0.83125],
    73: [0, 0.68333, 0.07847, 0.11111, 0.43958],
    74: [0, 0.68333, 0.09618, 0.16667, 0.55451],
    75: [0, 0.68333, 0.07153, 0.05556, 0.84931],
    76: [0, 0.68333, 0, 0.02778, 0.68056],
    77: [0, 0.68333, 0.10903, 0.08334, 0.97014],
    78: [0, 0.68333, 0.10903, 0.08334, 0.80347],
    79: [0, 0.68333, 0.02778, 0.08334, 0.76278],
    80: [0, 0.68333, 0.13889, 0.08334, 0.64201],
    81: [0.19444, 0.68333, 0, 0.08334, 0.79056],
    82: [0, 0.68333, 773e-5, 0.08334, 0.75929],
    83: [0, 0.68333, 0.05764, 0.08334, 0.6132],
    84: [0, 0.68333, 0.13889, 0.08334, 0.58438],
    85: [0, 0.68333, 0.10903, 0.02778, 0.68278],
    86: [0, 0.68333, 0.22222, 0, 0.58333],
    87: [0, 0.68333, 0.13889, 0, 0.94445],
    88: [0, 0.68333, 0.07847, 0.08334, 0.82847],
    89: [0, 0.68333, 0.22222, 0, 0.58056],
    90: [0, 0.68333, 0.07153, 0.08334, 0.68264],
    97: [0, 0.43056, 0, 0, 0.52859],
    98: [0, 0.69444, 0, 0, 0.42917],
    99: [0, 0.43056, 0, 0.05556, 0.43276],
    100: [0, 0.69444, 0, 0.16667, 0.52049],
    101: [0, 0.43056, 0, 0.05556, 0.46563],
    102: [0.19444, 0.69444, 0.10764, 0.16667, 0.48959],
    103: [0.19444, 0.43056, 0.03588, 0.02778, 0.47697],
    104: [0, 0.69444, 0, 0, 0.57616],
    105: [0, 0.65952, 0, 0, 0.34451],
    106: [0.19444, 0.65952, 0.05724, 0, 0.41181],
    107: [0, 0.69444, 0.03148, 0, 0.5206],
    108: [0, 0.69444, 0.01968, 0.08334, 0.29838],
    109: [0, 0.43056, 0, 0, 0.87801],
    110: [0, 0.43056, 0, 0, 0.60023],
    111: [0, 0.43056, 0, 0.05556, 0.48472],
    112: [0.19444, 0.43056, 0, 0.08334, 0.50313],
    113: [0.19444, 0.43056, 0.03588, 0.08334, 0.44641],
    114: [0, 0.43056, 0.02778, 0.05556, 0.45116],
    115: [0, 0.43056, 0, 0.05556, 0.46875],
    116: [0, 0.61508, 0, 0.08334, 0.36111],
    117: [0, 0.43056, 0, 0.02778, 0.57246],
    118: [0, 0.43056, 0.03588, 0.02778, 0.48472],
    119: [0, 0.43056, 0.02691, 0.08334, 0.71592],
    120: [0, 0.43056, 0, 0.02778, 0.57153],
    121: [0.19444, 0.43056, 0.03588, 0.05556, 0.49028],
    122: [0, 0.43056, 0.04398, 0.05556, 0.46505],
    160: [0, 0, 0, 0, 0.25],
    915: [0, 0.68333, 0.13889, 0.08334, 0.61528],
    916: [0, 0.68333, 0, 0.16667, 0.83334],
    920: [0, 0.68333, 0.02778, 0.08334, 0.76278],
    923: [0, 0.68333, 0, 0.16667, 0.69445],
    926: [0, 0.68333, 0.07569, 0.08334, 0.74236],
    928: [0, 0.68333, 0.08125, 0.05556, 0.83125],
    931: [0, 0.68333, 0.05764, 0.08334, 0.77986],
    933: [0, 0.68333, 0.13889, 0.05556, 0.58333],
    934: [0, 0.68333, 0, 0.08334, 0.66667],
    936: [0, 0.68333, 0.11, 0.05556, 0.61222],
    937: [0, 0.68333, 0.05017, 0.08334, 0.7724],
    945: [0, 0.43056, 37e-4, 0.02778, 0.6397],
    946: [0.19444, 0.69444, 0.05278, 0.08334, 0.56563],
    947: [0.19444, 0.43056, 0.05556, 0, 0.51773],
    948: [0, 0.69444, 0.03785, 0.05556, 0.44444],
    949: [0, 0.43056, 0, 0.08334, 0.46632],
    950: [0.19444, 0.69444, 0.07378, 0.08334, 0.4375],
    951: [0.19444, 0.43056, 0.03588, 0.05556, 0.49653],
    952: [0, 0.69444, 0.02778, 0.08334, 0.46944],
    953: [0, 0.43056, 0, 0.05556, 0.35394],
    954: [0, 0.43056, 0, 0, 0.57616],
    955: [0, 0.69444, 0, 0, 0.58334],
    956: [0.19444, 0.43056, 0, 0.02778, 0.60255],
    957: [0, 0.43056, 0.06366, 0.02778, 0.49398],
    958: [0.19444, 0.69444, 0.04601, 0.11111, 0.4375],
    959: [0, 0.43056, 0, 0.05556, 0.48472],
    960: [0, 0.43056, 0.03588, 0, 0.57003],
    961: [0.19444, 0.43056, 0, 0.08334, 0.51702],
    962: [0.09722, 0.43056, 0.07986, 0.08334, 0.36285],
    963: [0, 0.43056, 0.03588, 0, 0.57141],
    964: [0, 0.43056, 0.1132, 0.02778, 0.43715],
    965: [0, 0.43056, 0.03588, 0.02778, 0.54028],
    966: [0.19444, 0.43056, 0, 0.08334, 0.65417],
    967: [0.19444, 0.43056, 0, 0.05556, 0.62569],
    968: [0.19444, 0.69444, 0.03588, 0.11111, 0.65139],
    969: [0, 0.43056, 0.03588, 0, 0.62245],
    977: [0, 0.69444, 0, 0.08334, 0.59144],
    981: [0.19444, 0.69444, 0, 0.08334, 0.59583],
    982: [0, 0.43056, 0.02778, 0, 0.82813],
    1009: [0.19444, 0.43056, 0, 0.08334, 0.51702],
    1013: [0, 0.43056, 0, 0.05556, 0.4059],
    57649: [0, 0.43056, 0, 0.02778, 0.32246],
    57911: [0.19444, 0.43056, 0, 0.08334, 0.38403]
  },
  "SansSerif-Bold": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.36667],
    34: [0, 0.69444, 0, 0, 0.55834],
    35: [0.19444, 0.69444, 0, 0, 0.91667],
    36: [0.05556, 0.75, 0, 0, 0.55],
    37: [0.05556, 0.75, 0, 0, 1.02912],
    38: [0, 0.69444, 0, 0, 0.83056],
    39: [0, 0.69444, 0, 0, 0.30556],
    40: [0.25, 0.75, 0, 0, 0.42778],
    41: [0.25, 0.75, 0, 0, 0.42778],
    42: [0, 0.75, 0, 0, 0.55],
    43: [0.11667, 0.61667, 0, 0, 0.85556],
    44: [0.10556, 0.13056, 0, 0, 0.30556],
    45: [0, 0.45833, 0, 0, 0.36667],
    46: [0, 0.13056, 0, 0, 0.30556],
    47: [0.25, 0.75, 0, 0, 0.55],
    48: [0, 0.69444, 0, 0, 0.55],
    49: [0, 0.69444, 0, 0, 0.55],
    50: [0, 0.69444, 0, 0, 0.55],
    51: [0, 0.69444, 0, 0, 0.55],
    52: [0, 0.69444, 0, 0, 0.55],
    53: [0, 0.69444, 0, 0, 0.55],
    54: [0, 0.69444, 0, 0, 0.55],
    55: [0, 0.69444, 0, 0, 0.55],
    56: [0, 0.69444, 0, 0, 0.55],
    57: [0, 0.69444, 0, 0, 0.55],
    58: [0, 0.45833, 0, 0, 0.30556],
    59: [0.10556, 0.45833, 0, 0, 0.30556],
    61: [-0.09375, 0.40625, 0, 0, 0.85556],
    63: [0, 0.69444, 0, 0, 0.51945],
    64: [0, 0.69444, 0, 0, 0.73334],
    65: [0, 0.69444, 0, 0, 0.73334],
    66: [0, 0.69444, 0, 0, 0.73334],
    67: [0, 0.69444, 0, 0, 0.70278],
    68: [0, 0.69444, 0, 0, 0.79445],
    69: [0, 0.69444, 0, 0, 0.64167],
    70: [0, 0.69444, 0, 0, 0.61111],
    71: [0, 0.69444, 0, 0, 0.73334],
    72: [0, 0.69444, 0, 0, 0.79445],
    73: [0, 0.69444, 0, 0, 0.33056],
    74: [0, 0.69444, 0, 0, 0.51945],
    75: [0, 0.69444, 0, 0, 0.76389],
    76: [0, 0.69444, 0, 0, 0.58056],
    77: [0, 0.69444, 0, 0, 0.97778],
    78: [0, 0.69444, 0, 0, 0.79445],
    79: [0, 0.69444, 0, 0, 0.79445],
    80: [0, 0.69444, 0, 0, 0.70278],
    81: [0.10556, 0.69444, 0, 0, 0.79445],
    82: [0, 0.69444, 0, 0, 0.70278],
    83: [0, 0.69444, 0, 0, 0.61111],
    84: [0, 0.69444, 0, 0, 0.73334],
    85: [0, 0.69444, 0, 0, 0.76389],
    86: [0, 0.69444, 0.01528, 0, 0.73334],
    87: [0, 0.69444, 0.01528, 0, 1.03889],
    88: [0, 0.69444, 0, 0, 0.73334],
    89: [0, 0.69444, 0.0275, 0, 0.73334],
    90: [0, 0.69444, 0, 0, 0.67223],
    91: [0.25, 0.75, 0, 0, 0.34306],
    93: [0.25, 0.75, 0, 0, 0.34306],
    94: [0, 0.69444, 0, 0, 0.55],
    95: [0.35, 0.10833, 0.03056, 0, 0.55],
    97: [0, 0.45833, 0, 0, 0.525],
    98: [0, 0.69444, 0, 0, 0.56111],
    99: [0, 0.45833, 0, 0, 0.48889],
    100: [0, 0.69444, 0, 0, 0.56111],
    101: [0, 0.45833, 0, 0, 0.51111],
    102: [0, 0.69444, 0.07639, 0, 0.33611],
    103: [0.19444, 0.45833, 0.01528, 0, 0.55],
    104: [0, 0.69444, 0, 0, 0.56111],
    105: [0, 0.69444, 0, 0, 0.25556],
    106: [0.19444, 0.69444, 0, 0, 0.28611],
    107: [0, 0.69444, 0, 0, 0.53056],
    108: [0, 0.69444, 0, 0, 0.25556],
    109: [0, 0.45833, 0, 0, 0.86667],
    110: [0, 0.45833, 0, 0, 0.56111],
    111: [0, 0.45833, 0, 0, 0.55],
    112: [0.19444, 0.45833, 0, 0, 0.56111],
    113: [0.19444, 0.45833, 0, 0, 0.56111],
    114: [0, 0.45833, 0.01528, 0, 0.37222],
    115: [0, 0.45833, 0, 0, 0.42167],
    116: [0, 0.58929, 0, 0, 0.40417],
    117: [0, 0.45833, 0, 0, 0.56111],
    118: [0, 0.45833, 0.01528, 0, 0.5],
    119: [0, 0.45833, 0.01528, 0, 0.74445],
    120: [0, 0.45833, 0, 0, 0.5],
    121: [0.19444, 0.45833, 0.01528, 0, 0.5],
    122: [0, 0.45833, 0, 0, 0.47639],
    126: [0.35, 0.34444, 0, 0, 0.55],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.69444, 0, 0, 0.55],
    176: [0, 0.69444, 0, 0, 0.73334],
    180: [0, 0.69444, 0, 0, 0.55],
    184: [0.17014, 0, 0, 0, 0.48889],
    305: [0, 0.45833, 0, 0, 0.25556],
    567: [0.19444, 0.45833, 0, 0, 0.28611],
    710: [0, 0.69444, 0, 0, 0.55],
    711: [0, 0.63542, 0, 0, 0.55],
    713: [0, 0.63778, 0, 0, 0.55],
    728: [0, 0.69444, 0, 0, 0.55],
    729: [0, 0.69444, 0, 0, 0.30556],
    730: [0, 0.69444, 0, 0, 0.73334],
    732: [0, 0.69444, 0, 0, 0.55],
    733: [0, 0.69444, 0, 0, 0.55],
    915: [0, 0.69444, 0, 0, 0.58056],
    916: [0, 0.69444, 0, 0, 0.91667],
    920: [0, 0.69444, 0, 0, 0.85556],
    923: [0, 0.69444, 0, 0, 0.67223],
    926: [0, 0.69444, 0, 0, 0.73334],
    928: [0, 0.69444, 0, 0, 0.79445],
    931: [0, 0.69444, 0, 0, 0.79445],
    933: [0, 0.69444, 0, 0, 0.85556],
    934: [0, 0.69444, 0, 0, 0.79445],
    936: [0, 0.69444, 0, 0, 0.85556],
    937: [0, 0.69444, 0, 0, 0.79445],
    8211: [0, 0.45833, 0.03056, 0, 0.55],
    8212: [0, 0.45833, 0.03056, 0, 1.10001],
    8216: [0, 0.69444, 0, 0, 0.30556],
    8217: [0, 0.69444, 0, 0, 0.30556],
    8220: [0, 0.69444, 0, 0, 0.55834],
    8221: [0, 0.69444, 0, 0, 0.55834]
  },
  "SansSerif-Italic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.05733, 0, 0.31945],
    34: [0, 0.69444, 316e-5, 0, 0.5],
    35: [0.19444, 0.69444, 0.05087, 0, 0.83334],
    36: [0.05556, 0.75, 0.11156, 0, 0.5],
    37: [0.05556, 0.75, 0.03126, 0, 0.83334],
    38: [0, 0.69444, 0.03058, 0, 0.75834],
    39: [0, 0.69444, 0.07816, 0, 0.27778],
    40: [0.25, 0.75, 0.13164, 0, 0.38889],
    41: [0.25, 0.75, 0.02536, 0, 0.38889],
    42: [0, 0.75, 0.11775, 0, 0.5],
    43: [0.08333, 0.58333, 0.02536, 0, 0.77778],
    44: [0.125, 0.08333, 0, 0, 0.27778],
    45: [0, 0.44444, 0.01946, 0, 0.33333],
    46: [0, 0.08333, 0, 0, 0.27778],
    47: [0.25, 0.75, 0.13164, 0, 0.5],
    48: [0, 0.65556, 0.11156, 0, 0.5],
    49: [0, 0.65556, 0.11156, 0, 0.5],
    50: [0, 0.65556, 0.11156, 0, 0.5],
    51: [0, 0.65556, 0.11156, 0, 0.5],
    52: [0, 0.65556, 0.11156, 0, 0.5],
    53: [0, 0.65556, 0.11156, 0, 0.5],
    54: [0, 0.65556, 0.11156, 0, 0.5],
    55: [0, 0.65556, 0.11156, 0, 0.5],
    56: [0, 0.65556, 0.11156, 0, 0.5],
    57: [0, 0.65556, 0.11156, 0, 0.5],
    58: [0, 0.44444, 0.02502, 0, 0.27778],
    59: [0.125, 0.44444, 0.02502, 0, 0.27778],
    61: [-0.13, 0.37, 0.05087, 0, 0.77778],
    63: [0, 0.69444, 0.11809, 0, 0.47222],
    64: [0, 0.69444, 0.07555, 0, 0.66667],
    65: [0, 0.69444, 0, 0, 0.66667],
    66: [0, 0.69444, 0.08293, 0, 0.66667],
    67: [0, 0.69444, 0.11983, 0, 0.63889],
    68: [0, 0.69444, 0.07555, 0, 0.72223],
    69: [0, 0.69444, 0.11983, 0, 0.59722],
    70: [0, 0.69444, 0.13372, 0, 0.56945],
    71: [0, 0.69444, 0.11983, 0, 0.66667],
    72: [0, 0.69444, 0.08094, 0, 0.70834],
    73: [0, 0.69444, 0.13372, 0, 0.27778],
    74: [0, 0.69444, 0.08094, 0, 0.47222],
    75: [0, 0.69444, 0.11983, 0, 0.69445],
    76: [0, 0.69444, 0, 0, 0.54167],
    77: [0, 0.69444, 0.08094, 0, 0.875],
    78: [0, 0.69444, 0.08094, 0, 0.70834],
    79: [0, 0.69444, 0.07555, 0, 0.73611],
    80: [0, 0.69444, 0.08293, 0, 0.63889],
    81: [0.125, 0.69444, 0.07555, 0, 0.73611],
    82: [0, 0.69444, 0.08293, 0, 0.64584],
    83: [0, 0.69444, 0.09205, 0, 0.55556],
    84: [0, 0.69444, 0.13372, 0, 0.68056],
    85: [0, 0.69444, 0.08094, 0, 0.6875],
    86: [0, 0.69444, 0.1615, 0, 0.66667],
    87: [0, 0.69444, 0.1615, 0, 0.94445],
    88: [0, 0.69444, 0.13372, 0, 0.66667],
    89: [0, 0.69444, 0.17261, 0, 0.66667],
    90: [0, 0.69444, 0.11983, 0, 0.61111],
    91: [0.25, 0.75, 0.15942, 0, 0.28889],
    93: [0.25, 0.75, 0.08719, 0, 0.28889],
    94: [0, 0.69444, 0.0799, 0, 0.5],
    95: [0.35, 0.09444, 0.08616, 0, 0.5],
    97: [0, 0.44444, 981e-5, 0, 0.48056],
    98: [0, 0.69444, 0.03057, 0, 0.51667],
    99: [0, 0.44444, 0.08336, 0, 0.44445],
    100: [0, 0.69444, 0.09483, 0, 0.51667],
    101: [0, 0.44444, 0.06778, 0, 0.44445],
    102: [0, 0.69444, 0.21705, 0, 0.30556],
    103: [0.19444, 0.44444, 0.10836, 0, 0.5],
    104: [0, 0.69444, 0.01778, 0, 0.51667],
    105: [0, 0.67937, 0.09718, 0, 0.23889],
    106: [0.19444, 0.67937, 0.09162, 0, 0.26667],
    107: [0, 0.69444, 0.08336, 0, 0.48889],
    108: [0, 0.69444, 0.09483, 0, 0.23889],
    109: [0, 0.44444, 0.01778, 0, 0.79445],
    110: [0, 0.44444, 0.01778, 0, 0.51667],
    111: [0, 0.44444, 0.06613, 0, 0.5],
    112: [0.19444, 0.44444, 0.0389, 0, 0.51667],
    113: [0.19444, 0.44444, 0.04169, 0, 0.51667],
    114: [0, 0.44444, 0.10836, 0, 0.34167],
    115: [0, 0.44444, 0.0778, 0, 0.38333],
    116: [0, 0.57143, 0.07225, 0, 0.36111],
    117: [0, 0.44444, 0.04169, 0, 0.51667],
    118: [0, 0.44444, 0.10836, 0, 0.46111],
    119: [0, 0.44444, 0.10836, 0, 0.68334],
    120: [0, 0.44444, 0.09169, 0, 0.46111],
    121: [0.19444, 0.44444, 0.10836, 0, 0.46111],
    122: [0, 0.44444, 0.08752, 0, 0.43472],
    126: [0.35, 0.32659, 0.08826, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.67937, 0.06385, 0, 0.5],
    176: [0, 0.69444, 0, 0, 0.73752],
    184: [0.17014, 0, 0, 0, 0.44445],
    305: [0, 0.44444, 0.04169, 0, 0.23889],
    567: [0.19444, 0.44444, 0.04169, 0, 0.26667],
    710: [0, 0.69444, 0.0799, 0, 0.5],
    711: [0, 0.63194, 0.08432, 0, 0.5],
    713: [0, 0.60889, 0.08776, 0, 0.5],
    714: [0, 0.69444, 0.09205, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0.09483, 0, 0.5],
    729: [0, 0.67937, 0.07774, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.73752],
    732: [0, 0.67659, 0.08826, 0, 0.5],
    733: [0, 0.69444, 0.09205, 0, 0.5],
    915: [0, 0.69444, 0.13372, 0, 0.54167],
    916: [0, 0.69444, 0, 0, 0.83334],
    920: [0, 0.69444, 0.07555, 0, 0.77778],
    923: [0, 0.69444, 0, 0, 0.61111],
    926: [0, 0.69444, 0.12816, 0, 0.66667],
    928: [0, 0.69444, 0.08094, 0, 0.70834],
    931: [0, 0.69444, 0.11983, 0, 0.72222],
    933: [0, 0.69444, 0.09031, 0, 0.77778],
    934: [0, 0.69444, 0.04603, 0, 0.72222],
    936: [0, 0.69444, 0.09031, 0, 0.77778],
    937: [0, 0.69444, 0.08293, 0, 0.72222],
    8211: [0, 0.44444, 0.08616, 0, 0.5],
    8212: [0, 0.44444, 0.08616, 0, 1],
    8216: [0, 0.69444, 0.07816, 0, 0.27778],
    8217: [0, 0.69444, 0.07816, 0, 0.27778],
    8220: [0, 0.69444, 0.14205, 0, 0.5],
    8221: [0, 0.69444, 316e-5, 0, 0.5]
  },
  "SansSerif-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.31945],
    34: [0, 0.69444, 0, 0, 0.5],
    35: [0.19444, 0.69444, 0, 0, 0.83334],
    36: [0.05556, 0.75, 0, 0, 0.5],
    37: [0.05556, 0.75, 0, 0, 0.83334],
    38: [0, 0.69444, 0, 0, 0.75834],
    39: [0, 0.69444, 0, 0, 0.27778],
    40: [0.25, 0.75, 0, 0, 0.38889],
    41: [0.25, 0.75, 0, 0, 0.38889],
    42: [0, 0.75, 0, 0, 0.5],
    43: [0.08333, 0.58333, 0, 0, 0.77778],
    44: [0.125, 0.08333, 0, 0, 0.27778],
    45: [0, 0.44444, 0, 0, 0.33333],
    46: [0, 0.08333, 0, 0, 0.27778],
    47: [0.25, 0.75, 0, 0, 0.5],
    48: [0, 0.65556, 0, 0, 0.5],
    49: [0, 0.65556, 0, 0, 0.5],
    50: [0, 0.65556, 0, 0, 0.5],
    51: [0, 0.65556, 0, 0, 0.5],
    52: [0, 0.65556, 0, 0, 0.5],
    53: [0, 0.65556, 0, 0, 0.5],
    54: [0, 0.65556, 0, 0, 0.5],
    55: [0, 0.65556, 0, 0, 0.5],
    56: [0, 0.65556, 0, 0, 0.5],
    57: [0, 0.65556, 0, 0, 0.5],
    58: [0, 0.44444, 0, 0, 0.27778],
    59: [0.125, 0.44444, 0, 0, 0.27778],
    61: [-0.13, 0.37, 0, 0, 0.77778],
    63: [0, 0.69444, 0, 0, 0.47222],
    64: [0, 0.69444, 0, 0, 0.66667],
    65: [0, 0.69444, 0, 0, 0.66667],
    66: [0, 0.69444, 0, 0, 0.66667],
    67: [0, 0.69444, 0, 0, 0.63889],
    68: [0, 0.69444, 0, 0, 0.72223],
    69: [0, 0.69444, 0, 0, 0.59722],
    70: [0, 0.69444, 0, 0, 0.56945],
    71: [0, 0.69444, 0, 0, 0.66667],
    72: [0, 0.69444, 0, 0, 0.70834],
    73: [0, 0.69444, 0, 0, 0.27778],
    74: [0, 0.69444, 0, 0, 0.47222],
    75: [0, 0.69444, 0, 0, 0.69445],
    76: [0, 0.69444, 0, 0, 0.54167],
    77: [0, 0.69444, 0, 0, 0.875],
    78: [0, 0.69444, 0, 0, 0.70834],
    79: [0, 0.69444, 0, 0, 0.73611],
    80: [0, 0.69444, 0, 0, 0.63889],
    81: [0.125, 0.69444, 0, 0, 0.73611],
    82: [0, 0.69444, 0, 0, 0.64584],
    83: [0, 0.69444, 0, 0, 0.55556],
    84: [0, 0.69444, 0, 0, 0.68056],
    85: [0, 0.69444, 0, 0, 0.6875],
    86: [0, 0.69444, 0.01389, 0, 0.66667],
    87: [0, 0.69444, 0.01389, 0, 0.94445],
    88: [0, 0.69444, 0, 0, 0.66667],
    89: [0, 0.69444, 0.025, 0, 0.66667],
    90: [0, 0.69444, 0, 0, 0.61111],
    91: [0.25, 0.75, 0, 0, 0.28889],
    93: [0.25, 0.75, 0, 0, 0.28889],
    94: [0, 0.69444, 0, 0, 0.5],
    95: [0.35, 0.09444, 0.02778, 0, 0.5],
    97: [0, 0.44444, 0, 0, 0.48056],
    98: [0, 0.69444, 0, 0, 0.51667],
    99: [0, 0.44444, 0, 0, 0.44445],
    100: [0, 0.69444, 0, 0, 0.51667],
    101: [0, 0.44444, 0, 0, 0.44445],
    102: [0, 0.69444, 0.06944, 0, 0.30556],
    103: [0.19444, 0.44444, 0.01389, 0, 0.5],
    104: [0, 0.69444, 0, 0, 0.51667],
    105: [0, 0.67937, 0, 0, 0.23889],
    106: [0.19444, 0.67937, 0, 0, 0.26667],
    107: [0, 0.69444, 0, 0, 0.48889],
    108: [0, 0.69444, 0, 0, 0.23889],
    109: [0, 0.44444, 0, 0, 0.79445],
    110: [0, 0.44444, 0, 0, 0.51667],
    111: [0, 0.44444, 0, 0, 0.5],
    112: [0.19444, 0.44444, 0, 0, 0.51667],
    113: [0.19444, 0.44444, 0, 0, 0.51667],
    114: [0, 0.44444, 0.01389, 0, 0.34167],
    115: [0, 0.44444, 0, 0, 0.38333],
    116: [0, 0.57143, 0, 0, 0.36111],
    117: [0, 0.44444, 0, 0, 0.51667],
    118: [0, 0.44444, 0.01389, 0, 0.46111],
    119: [0, 0.44444, 0.01389, 0, 0.68334],
    120: [0, 0.44444, 0, 0, 0.46111],
    121: [0.19444, 0.44444, 0.01389, 0, 0.46111],
    122: [0, 0.44444, 0, 0, 0.43472],
    126: [0.35, 0.32659, 0, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.67937, 0, 0, 0.5],
    176: [0, 0.69444, 0, 0, 0.66667],
    184: [0.17014, 0, 0, 0, 0.44445],
    305: [0, 0.44444, 0, 0, 0.23889],
    567: [0.19444, 0.44444, 0, 0, 0.26667],
    710: [0, 0.69444, 0, 0, 0.5],
    711: [0, 0.63194, 0, 0, 0.5],
    713: [0, 0.60889, 0, 0, 0.5],
    714: [0, 0.69444, 0, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0, 0, 0.5],
    729: [0, 0.67937, 0, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.66667],
    732: [0, 0.67659, 0, 0, 0.5],
    733: [0, 0.69444, 0, 0, 0.5],
    915: [0, 0.69444, 0, 0, 0.54167],
    916: [0, 0.69444, 0, 0, 0.83334],
    920: [0, 0.69444, 0, 0, 0.77778],
    923: [0, 0.69444, 0, 0, 0.61111],
    926: [0, 0.69444, 0, 0, 0.66667],
    928: [0, 0.69444, 0, 0, 0.70834],
    931: [0, 0.69444, 0, 0, 0.72222],
    933: [0, 0.69444, 0, 0, 0.77778],
    934: [0, 0.69444, 0, 0, 0.72222],
    936: [0, 0.69444, 0, 0, 0.77778],
    937: [0, 0.69444, 0, 0, 0.72222],
    8211: [0, 0.44444, 0.02778, 0, 0.5],
    8212: [0, 0.44444, 0.02778, 0, 1],
    8216: [0, 0.69444, 0, 0, 0.27778],
    8217: [0, 0.69444, 0, 0, 0.27778],
    8220: [0, 0.69444, 0, 0, 0.5],
    8221: [0, 0.69444, 0, 0, 0.5]
  },
  "Script-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.7, 0.22925, 0, 0.80253],
    66: [0, 0.7, 0.04087, 0, 0.90757],
    67: [0, 0.7, 0.1689, 0, 0.66619],
    68: [0, 0.7, 0.09371, 0, 0.77443],
    69: [0, 0.7, 0.18583, 0, 0.56162],
    70: [0, 0.7, 0.13634, 0, 0.89544],
    71: [0, 0.7, 0.17322, 0, 0.60961],
    72: [0, 0.7, 0.29694, 0, 0.96919],
    73: [0, 0.7, 0.19189, 0, 0.80907],
    74: [0.27778, 0.7, 0.19189, 0, 1.05159],
    75: [0, 0.7, 0.31259, 0, 0.91364],
    76: [0, 0.7, 0.19189, 0, 0.87373],
    77: [0, 0.7, 0.15981, 0, 1.08031],
    78: [0, 0.7, 0.3525, 0, 0.9015],
    79: [0, 0.7, 0.08078, 0, 0.73787],
    80: [0, 0.7, 0.08078, 0, 1.01262],
    81: [0, 0.7, 0.03305, 0, 0.88282],
    82: [0, 0.7, 0.06259, 0, 0.85],
    83: [0, 0.7, 0.19189, 0, 0.86767],
    84: [0, 0.7, 0.29087, 0, 0.74697],
    85: [0, 0.7, 0.25815, 0, 0.79996],
    86: [0, 0.7, 0.27523, 0, 0.62204],
    87: [0, 0.7, 0.27523, 0, 0.80532],
    88: [0, 0.7, 0.26006, 0, 0.94445],
    89: [0, 0.7, 0.2939, 0, 0.70961],
    90: [0, 0.7, 0.24037, 0, 0.8212],
    160: [0, 0, 0, 0, 0.25]
  },
  "Size1-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.35001, 0.85, 0, 0, 0.45834],
    41: [0.35001, 0.85, 0, 0, 0.45834],
    47: [0.35001, 0.85, 0, 0, 0.57778],
    91: [0.35001, 0.85, 0, 0, 0.41667],
    92: [0.35001, 0.85, 0, 0, 0.57778],
    93: [0.35001, 0.85, 0, 0, 0.41667],
    123: [0.35001, 0.85, 0, 0, 0.58334],
    125: [0.35001, 0.85, 0, 0, 0.58334],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.72222, 0, 0, 0.55556],
    732: [0, 0.72222, 0, 0, 0.55556],
    770: [0, 0.72222, 0, 0, 0.55556],
    771: [0, 0.72222, 0, 0, 0.55556],
    8214: [-99e-5, 0.601, 0, 0, 0.77778],
    8593: [1e-5, 0.6, 0, 0, 0.66667],
    8595: [1e-5, 0.6, 0, 0, 0.66667],
    8657: [1e-5, 0.6, 0, 0, 0.77778],
    8659: [1e-5, 0.6, 0, 0, 0.77778],
    8719: [0.25001, 0.75, 0, 0, 0.94445],
    8720: [0.25001, 0.75, 0, 0, 0.94445],
    8721: [0.25001, 0.75, 0, 0, 1.05556],
    8730: [0.35001, 0.85, 0, 0, 1],
    8739: [-599e-5, 0.606, 0, 0, 0.33333],
    8741: [-599e-5, 0.606, 0, 0, 0.55556],
    8747: [0.30612, 0.805, 0.19445, 0, 0.47222],
    8748: [0.306, 0.805, 0.19445, 0, 0.47222],
    8749: [0.306, 0.805, 0.19445, 0, 0.47222],
    8750: [0.30612, 0.805, 0.19445, 0, 0.47222],
    8896: [0.25001, 0.75, 0, 0, 0.83334],
    8897: [0.25001, 0.75, 0, 0, 0.83334],
    8898: [0.25001, 0.75, 0, 0, 0.83334],
    8899: [0.25001, 0.75, 0, 0, 0.83334],
    8968: [0.35001, 0.85, 0, 0, 0.47222],
    8969: [0.35001, 0.85, 0, 0, 0.47222],
    8970: [0.35001, 0.85, 0, 0, 0.47222],
    8971: [0.35001, 0.85, 0, 0, 0.47222],
    9168: [-99e-5, 0.601, 0, 0, 0.66667],
    10216: [0.35001, 0.85, 0, 0, 0.47222],
    10217: [0.35001, 0.85, 0, 0, 0.47222],
    10752: [0.25001, 0.75, 0, 0, 1.11111],
    10753: [0.25001, 0.75, 0, 0, 1.11111],
    10754: [0.25001, 0.75, 0, 0, 1.11111],
    10756: [0.25001, 0.75, 0, 0, 0.83334],
    10758: [0.25001, 0.75, 0, 0, 0.83334]
  },
  "Size2-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.65002, 1.15, 0, 0, 0.59722],
    41: [0.65002, 1.15, 0, 0, 0.59722],
    47: [0.65002, 1.15, 0, 0, 0.81111],
    91: [0.65002, 1.15, 0, 0, 0.47222],
    92: [0.65002, 1.15, 0, 0, 0.81111],
    93: [0.65002, 1.15, 0, 0, 0.47222],
    123: [0.65002, 1.15, 0, 0, 0.66667],
    125: [0.65002, 1.15, 0, 0, 0.66667],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.75, 0, 0, 1],
    732: [0, 0.75, 0, 0, 1],
    770: [0, 0.75, 0, 0, 1],
    771: [0, 0.75, 0, 0, 1],
    8719: [0.55001, 1.05, 0, 0, 1.27778],
    8720: [0.55001, 1.05, 0, 0, 1.27778],
    8721: [0.55001, 1.05, 0, 0, 1.44445],
    8730: [0.65002, 1.15, 0, 0, 1],
    8747: [0.86225, 1.36, 0.44445, 0, 0.55556],
    8748: [0.862, 1.36, 0.44445, 0, 0.55556],
    8749: [0.862, 1.36, 0.44445, 0, 0.55556],
    8750: [0.86225, 1.36, 0.44445, 0, 0.55556],
    8896: [0.55001, 1.05, 0, 0, 1.11111],
    8897: [0.55001, 1.05, 0, 0, 1.11111],
    8898: [0.55001, 1.05, 0, 0, 1.11111],
    8899: [0.55001, 1.05, 0, 0, 1.11111],
    8968: [0.65002, 1.15, 0, 0, 0.52778],
    8969: [0.65002, 1.15, 0, 0, 0.52778],
    8970: [0.65002, 1.15, 0, 0, 0.52778],
    8971: [0.65002, 1.15, 0, 0, 0.52778],
    10216: [0.65002, 1.15, 0, 0, 0.61111],
    10217: [0.65002, 1.15, 0, 0, 0.61111],
    10752: [0.55001, 1.05, 0, 0, 1.51112],
    10753: [0.55001, 1.05, 0, 0, 1.51112],
    10754: [0.55001, 1.05, 0, 0, 1.51112],
    10756: [0.55001, 1.05, 0, 0, 1.11111],
    10758: [0.55001, 1.05, 0, 0, 1.11111]
  },
  "Size3-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.95003, 1.45, 0, 0, 0.73611],
    41: [0.95003, 1.45, 0, 0, 0.73611],
    47: [0.95003, 1.45, 0, 0, 1.04445],
    91: [0.95003, 1.45, 0, 0, 0.52778],
    92: [0.95003, 1.45, 0, 0, 1.04445],
    93: [0.95003, 1.45, 0, 0, 0.52778],
    123: [0.95003, 1.45, 0, 0, 0.75],
    125: [0.95003, 1.45, 0, 0, 0.75],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.75, 0, 0, 1.44445],
    732: [0, 0.75, 0, 0, 1.44445],
    770: [0, 0.75, 0, 0, 1.44445],
    771: [0, 0.75, 0, 0, 1.44445],
    8730: [0.95003, 1.45, 0, 0, 1],
    8968: [0.95003, 1.45, 0, 0, 0.58334],
    8969: [0.95003, 1.45, 0, 0, 0.58334],
    8970: [0.95003, 1.45, 0, 0, 0.58334],
    8971: [0.95003, 1.45, 0, 0, 0.58334],
    10216: [0.95003, 1.45, 0, 0, 0.75],
    10217: [0.95003, 1.45, 0, 0, 0.75]
  },
  "Size4-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [1.25003, 1.75, 0, 0, 0.79167],
    41: [1.25003, 1.75, 0, 0, 0.79167],
    47: [1.25003, 1.75, 0, 0, 1.27778],
    91: [1.25003, 1.75, 0, 0, 0.58334],
    92: [1.25003, 1.75, 0, 0, 1.27778],
    93: [1.25003, 1.75, 0, 0, 0.58334],
    123: [1.25003, 1.75, 0, 0, 0.80556],
    125: [1.25003, 1.75, 0, 0, 0.80556],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.825, 0, 0, 1.8889],
    732: [0, 0.825, 0, 0, 1.8889],
    770: [0, 0.825, 0, 0, 1.8889],
    771: [0, 0.825, 0, 0, 1.8889],
    8730: [1.25003, 1.75, 0, 0, 1],
    8968: [1.25003, 1.75, 0, 0, 0.63889],
    8969: [1.25003, 1.75, 0, 0, 0.63889],
    8970: [1.25003, 1.75, 0, 0, 0.63889],
    8971: [1.25003, 1.75, 0, 0, 0.63889],
    9115: [0.64502, 1.155, 0, 0, 0.875],
    9116: [1e-5, 0.6, 0, 0, 0.875],
    9117: [0.64502, 1.155, 0, 0, 0.875],
    9118: [0.64502, 1.155, 0, 0, 0.875],
    9119: [1e-5, 0.6, 0, 0, 0.875],
    9120: [0.64502, 1.155, 0, 0, 0.875],
    9121: [0.64502, 1.155, 0, 0, 0.66667],
    9122: [-99e-5, 0.601, 0, 0, 0.66667],
    9123: [0.64502, 1.155, 0, 0, 0.66667],
    9124: [0.64502, 1.155, 0, 0, 0.66667],
    9125: [-99e-5, 0.601, 0, 0, 0.66667],
    9126: [0.64502, 1.155, 0, 0, 0.66667],
    9127: [1e-5, 0.9, 0, 0, 0.88889],
    9128: [0.65002, 1.15, 0, 0, 0.88889],
    9129: [0.90001, 0, 0, 0, 0.88889],
    9130: [0, 0.3, 0, 0, 0.88889],
    9131: [1e-5, 0.9, 0, 0, 0.88889],
    9132: [0.65002, 1.15, 0, 0, 0.88889],
    9133: [0.90001, 0, 0, 0, 0.88889],
    9143: [0.88502, 0.915, 0, 0, 1.05556],
    10216: [1.25003, 1.75, 0, 0, 0.80556],
    10217: [1.25003, 1.75, 0, 0, 0.80556],
    57344: [-499e-5, 0.605, 0, 0, 1.05556],
    57345: [-499e-5, 0.605, 0, 0, 1.05556],
    57680: [0, 0.12, 0, 0, 0.45],
    57681: [0, 0.12, 0, 0, 0.45],
    57682: [0, 0.12, 0, 0, 0.45],
    57683: [0, 0.12, 0, 0, 0.45]
  },
  "Typewriter-Regular": {
    32: [0, 0, 0, 0, 0.525],
    33: [0, 0.61111, 0, 0, 0.525],
    34: [0, 0.61111, 0, 0, 0.525],
    35: [0, 0.61111, 0, 0, 0.525],
    36: [0.08333, 0.69444, 0, 0, 0.525],
    37: [0.08333, 0.69444, 0, 0, 0.525],
    38: [0, 0.61111, 0, 0, 0.525],
    39: [0, 0.61111, 0, 0, 0.525],
    40: [0.08333, 0.69444, 0, 0, 0.525],
    41: [0.08333, 0.69444, 0, 0, 0.525],
    42: [0, 0.52083, 0, 0, 0.525],
    43: [-0.08056, 0.53055, 0, 0, 0.525],
    44: [0.13889, 0.125, 0, 0, 0.525],
    45: [-0.08056, 0.53055, 0, 0, 0.525],
    46: [0, 0.125, 0, 0, 0.525],
    47: [0.08333, 0.69444, 0, 0, 0.525],
    48: [0, 0.61111, 0, 0, 0.525],
    49: [0, 0.61111, 0, 0, 0.525],
    50: [0, 0.61111, 0, 0, 0.525],
    51: [0, 0.61111, 0, 0, 0.525],
    52: [0, 0.61111, 0, 0, 0.525],
    53: [0, 0.61111, 0, 0, 0.525],
    54: [0, 0.61111, 0, 0, 0.525],
    55: [0, 0.61111, 0, 0, 0.525],
    56: [0, 0.61111, 0, 0, 0.525],
    57: [0, 0.61111, 0, 0, 0.525],
    58: [0, 0.43056, 0, 0, 0.525],
    59: [0.13889, 0.43056, 0, 0, 0.525],
    60: [-0.05556, 0.55556, 0, 0, 0.525],
    61: [-0.19549, 0.41562, 0, 0, 0.525],
    62: [-0.05556, 0.55556, 0, 0, 0.525],
    63: [0, 0.61111, 0, 0, 0.525],
    64: [0, 0.61111, 0, 0, 0.525],
    65: [0, 0.61111, 0, 0, 0.525],
    66: [0, 0.61111, 0, 0, 0.525],
    67: [0, 0.61111, 0, 0, 0.525],
    68: [0, 0.61111, 0, 0, 0.525],
    69: [0, 0.61111, 0, 0, 0.525],
    70: [0, 0.61111, 0, 0, 0.525],
    71: [0, 0.61111, 0, 0, 0.525],
    72: [0, 0.61111, 0, 0, 0.525],
    73: [0, 0.61111, 0, 0, 0.525],
    74: [0, 0.61111, 0, 0, 0.525],
    75: [0, 0.61111, 0, 0, 0.525],
    76: [0, 0.61111, 0, 0, 0.525],
    77: [0, 0.61111, 0, 0, 0.525],
    78: [0, 0.61111, 0, 0, 0.525],
    79: [0, 0.61111, 0, 0, 0.525],
    80: [0, 0.61111, 0, 0, 0.525],
    81: [0.13889, 0.61111, 0, 0, 0.525],
    82: [0, 0.61111, 0, 0, 0.525],
    83: [0, 0.61111, 0, 0, 0.525],
    84: [0, 0.61111, 0, 0, 0.525],
    85: [0, 0.61111, 0, 0, 0.525],
    86: [0, 0.61111, 0, 0, 0.525],
    87: [0, 0.61111, 0, 0, 0.525],
    88: [0, 0.61111, 0, 0, 0.525],
    89: [0, 0.61111, 0, 0, 0.525],
    90: [0, 0.61111, 0, 0, 0.525],
    91: [0.08333, 0.69444, 0, 0, 0.525],
    92: [0.08333, 0.69444, 0, 0, 0.525],
    93: [0.08333, 0.69444, 0, 0, 0.525],
    94: [0, 0.61111, 0, 0, 0.525],
    95: [0.09514, 0, 0, 0, 0.525],
    96: [0, 0.61111, 0, 0, 0.525],
    97: [0, 0.43056, 0, 0, 0.525],
    98: [0, 0.61111, 0, 0, 0.525],
    99: [0, 0.43056, 0, 0, 0.525],
    100: [0, 0.61111, 0, 0, 0.525],
    101: [0, 0.43056, 0, 0, 0.525],
    102: [0, 0.61111, 0, 0, 0.525],
    103: [0.22222, 0.43056, 0, 0, 0.525],
    104: [0, 0.61111, 0, 0, 0.525],
    105: [0, 0.61111, 0, 0, 0.525],
    106: [0.22222, 0.61111, 0, 0, 0.525],
    107: [0, 0.61111, 0, 0, 0.525],
    108: [0, 0.61111, 0, 0, 0.525],
    109: [0, 0.43056, 0, 0, 0.525],
    110: [0, 0.43056, 0, 0, 0.525],
    111: [0, 0.43056, 0, 0, 0.525],
    112: [0.22222, 0.43056, 0, 0, 0.525],
    113: [0.22222, 0.43056, 0, 0, 0.525],
    114: [0, 0.43056, 0, 0, 0.525],
    115: [0, 0.43056, 0, 0, 0.525],
    116: [0, 0.55358, 0, 0, 0.525],
    117: [0, 0.43056, 0, 0, 0.525],
    118: [0, 0.43056, 0, 0, 0.525],
    119: [0, 0.43056, 0, 0, 0.525],
    120: [0, 0.43056, 0, 0, 0.525],
    121: [0.22222, 0.43056, 0, 0, 0.525],
    122: [0, 0.43056, 0, 0, 0.525],
    123: [0.08333, 0.69444, 0, 0, 0.525],
    124: [0.08333, 0.69444, 0, 0, 0.525],
    125: [0.08333, 0.69444, 0, 0, 0.525],
    126: [0, 0.61111, 0, 0, 0.525],
    127: [0, 0.61111, 0, 0, 0.525],
    160: [0, 0, 0, 0, 0.525],
    176: [0, 0.61111, 0, 0, 0.525],
    184: [0.19445, 0, 0, 0, 0.525],
    305: [0, 0.43056, 0, 0, 0.525],
    567: [0.22222, 0.43056, 0, 0, 0.525],
    711: [0, 0.56597, 0, 0, 0.525],
    713: [0, 0.56555, 0, 0, 0.525],
    714: [0, 0.61111, 0, 0, 0.525],
    715: [0, 0.61111, 0, 0, 0.525],
    728: [0, 0.61111, 0, 0, 0.525],
    730: [0, 0.61111, 0, 0, 0.525],
    770: [0, 0.61111, 0, 0, 0.525],
    771: [0, 0.61111, 0, 0, 0.525],
    776: [0, 0.61111, 0, 0, 0.525],
    915: [0, 0.61111, 0, 0, 0.525],
    916: [0, 0.61111, 0, 0, 0.525],
    920: [0, 0.61111, 0, 0, 0.525],
    923: [0, 0.61111, 0, 0, 0.525],
    926: [0, 0.61111, 0, 0, 0.525],
    928: [0, 0.61111, 0, 0, 0.525],
    931: [0, 0.61111, 0, 0, 0.525],
    933: [0, 0.61111, 0, 0, 0.525],
    934: [0, 0.61111, 0, 0, 0.525],
    936: [0, 0.61111, 0, 0, 0.525],
    937: [0, 0.61111, 0, 0, 0.525],
    8216: [0, 0.61111, 0, 0, 0.525],
    8217: [0, 0.61111, 0, 0, 0.525],
    8242: [0, 0.61111, 0, 0, 0.525],
    9251: [0.11111, 0.21944, 0, 0, 0.525]
  }
}, sigmasAndXis = {
  slant: [0.25, 0.25, 0.25],
  // sigma1
  space: [0, 0, 0],
  // sigma2
  stretch: [0, 0, 0],
  // sigma3
  shrink: [0, 0, 0],
  // sigma4
  xHeight: [0.431, 0.431, 0.431],
  // sigma5
  quad: [1, 1.171, 1.472],
  // sigma6
  extraSpace: [0, 0, 0],
  // sigma7
  num1: [0.677, 0.732, 0.925],
  // sigma8
  num2: [0.394, 0.384, 0.387],
  // sigma9
  num3: [0.444, 0.471, 0.504],
  // sigma10
  denom1: [0.686, 0.752, 1.025],
  // sigma11
  denom2: [0.345, 0.344, 0.532],
  // sigma12
  sup1: [0.413, 0.503, 0.504],
  // sigma13
  sup2: [0.363, 0.431, 0.404],
  // sigma14
  sup3: [0.289, 0.286, 0.294],
  // sigma15
  sub1: [0.15, 0.143, 0.2],
  // sigma16
  sub2: [0.247, 0.286, 0.4],
  // sigma17
  supDrop: [0.386, 0.353, 0.494],
  // sigma18
  subDrop: [0.05, 0.071, 0.1],
  // sigma19
  delim1: [2.39, 1.7, 1.98],
  // sigma20
  delim2: [1.01, 1.157, 1.42],
  // sigma21
  axisHeight: [0.25, 0.25, 0.25],
  // sigma22
  // These font metrics are extracted from TeX by using tftopl on cmex10.tfm;
  // they correspond to the font parameters of the extension fonts (family 3).
  // See the TeXbook, page 441. In AMSTeX, the extension fonts scale; to
  // match cmex7, we'd use cmex7.tfm values for script and scriptscript
  // values.
  defaultRuleThickness: [0.04, 0.049, 0.049],
  // xi8; cmex7: 0.049
  bigOpSpacing1: [0.111, 0.111, 0.111],
  // xi9
  bigOpSpacing2: [0.166, 0.166, 0.166],
  // xi10
  bigOpSpacing3: [0.2, 0.2, 0.2],
  // xi11
  bigOpSpacing4: [0.6, 0.611, 0.611],
  // xi12; cmex7: 0.611
  bigOpSpacing5: [0.1, 0.143, 0.143],
  // xi13; cmex7: 0.143
  // The \sqrt rule width is taken from the height of the surd character.
  // Since we use the same font at all sizes, this thickness doesn't scale.
  sqrtRuleThickness: [0.04, 0.04, 0.04],
  // This value determines how large a pt is, for metrics which are defined
  // in terms of pts.
  // This value is also used in katex.scss; if you change it make sure the
  // values match.
  ptPerEm: [10, 10, 10],
  // The space between adjacent `|` columns in an array definition. From
  // `\showthe\doublerulesep` in LaTeX. Equals 2.0 / ptPerEm.
  doubleRuleSep: [0.2, 0.2, 0.2],
  // The width of separator lines in {array} environments. From
  // `\showthe\arrayrulewidth` in LaTeX. Equals 0.4 / ptPerEm.
  arrayRuleWidth: [0.04, 0.04, 0.04],
  // Two values from LaTeX source2e:
  fboxsep: [0.3, 0.3, 0.3],
  //        3 pt / ptPerEm
  fboxrule: [0.04, 0.04, 0.04]
  // 0.4 pt / ptPerEm
}, extraCharacterMap = {
  // Latin-1
  Å: "A",
  Ð: "D",
  Þ: "o",
  å: "a",
  ð: "d",
  þ: "o",
  // Cyrillic
  А: "A",
  Б: "B",
  В: "B",
  Г: "F",
  Д: "A",
  Е: "E",
  Ж: "K",
  З: "3",
  И: "N",
  Й: "N",
  К: "K",
  Л: "N",
  М: "M",
  Н: "H",
  О: "O",
  П: "N",
  Р: "P",
  С: "C",
  Т: "T",
  У: "y",
  Ф: "O",
  Х: "X",
  Ц: "U",
  Ч: "h",
  Ш: "W",
  Щ: "W",
  Ъ: "B",
  Ы: "X",
  Ь: "B",
  Э: "3",
  Ю: "X",
  Я: "R",
  а: "a",
  б: "b",
  в: "a",
  г: "r",
  д: "y",
  е: "e",
  ж: "m",
  з: "e",
  и: "n",
  й: "n",
  к: "n",
  л: "n",
  м: "m",
  н: "n",
  о: "o",
  п: "n",
  р: "p",
  с: "c",
  т: "o",
  у: "y",
  ф: "b",
  х: "x",
  ц: "n",
  ч: "n",
  ш: "w",
  щ: "w",
  ъ: "a",
  ы: "m",
  ь: "a",
  э: "e",
  ю: "m",
  я: "r"
};
function setFontMetrics(n, t) {
  fontMetricsData[n] = t;
}
function getCharacterMetrics(n, t, g) {
  if (!fontMetricsData[t])
    throw new Error("Font metrics not found for font: " + t + ".");
  var d = n.charCodeAt(0), k = fontMetricsData[t][d];
  if (!k && n[0] in extraCharacterMap && (d = extraCharacterMap[n[0]].charCodeAt(0), k = fontMetricsData[t][d]), !k && g === "text" && supportedCodepoint(d) && (k = fontMetricsData[t][77]), k)
    return {
      depth: k[0],
      height: k[1],
      italic: k[2],
      skew: k[3],
      width: k[4]
    };
}
var fontMetricsBySizeIndex = {};
function getGlobalMetrics(n) {
  var t;
  if (n >= 5 ? t = 0 : n >= 3 ? t = 1 : t = 2, !fontMetricsBySizeIndex[t]) {
    var g = fontMetricsBySizeIndex[t] = {
      cssEmPerMu: sigmasAndXis.quad[t] / 18
    };
    for (var d in sigmasAndXis)
      sigmasAndXis.hasOwnProperty(d) && (g[d] = sigmasAndXis[d][t]);
  }
  return fontMetricsBySizeIndex[t];
}
var sizeStyleMap = [
  // Each element contains [textsize, scriptsize, scriptscriptsize].
  // The size mappings are taken from TeX with \normalsize=10pt.
  [1, 1, 1],
  // size1: [5, 5, 5]              \tiny
  [2, 1, 1],
  // size2: [6, 5, 5]
  [3, 1, 1],
  // size3: [7, 5, 5]              \scriptsize
  [4, 2, 1],
  // size4: [8, 6, 5]              \footnotesize
  [5, 2, 1],
  // size5: [9, 6, 5]              \small
  [6, 3, 1],
  // size6: [10, 7, 5]             \normalsize
  [7, 4, 2],
  // size7: [12, 8, 6]             \large
  [8, 6, 3],
  // size8: [14.4, 10, 7]          \Large
  [9, 7, 6],
  // size9: [17.28, 12, 10]        \LARGE
  [10, 8, 7],
  // size10: [20.74, 14.4, 12]     \huge
  [11, 10, 9]
  // size11: [24.88, 20.74, 17.28] \HUGE
], sizeMultipliers = [
  // fontMetrics.js:getGlobalMetrics also uses size indexes, so if
  // you change size indexes, change that function.
  0.5,
  0.6,
  0.7,
  0.8,
  0.9,
  1,
  1.2,
  1.44,
  1.728,
  2.074,
  2.488
], sizeAtStyle = function n(t, g) {
  return g.size < 2 ? t : sizeStyleMap[t - 1][g.size - 1];
};
class Options {
  // A font family applies to a group of fonts (i.e. SansSerif), while a font
  // represents a specific font (i.e. SansSerif Bold).
  // See: https://tex.stackexchange.com/questions/22350/difference-between-textrm-and-mathrm
  /**
   * The base size index.
   */
  constructor(t) {
    this.style = void 0, this.color = void 0, this.size = void 0, this.textSize = void 0, this.phantom = void 0, this.font = void 0, this.fontFamily = void 0, this.fontWeight = void 0, this.fontShape = void 0, this.sizeMultiplier = void 0, this.maxSize = void 0, this.minRuleThickness = void 0, this._fontMetrics = void 0, this.style = t.style, this.color = t.color, this.size = t.size || Options.BASESIZE, this.textSize = t.textSize || this.size, this.phantom = !!t.phantom, this.font = t.font || "", this.fontFamily = t.fontFamily || "", this.fontWeight = t.fontWeight || "", this.fontShape = t.fontShape || "", this.sizeMultiplier = sizeMultipliers[this.size - 1], this.maxSize = t.maxSize, this.minRuleThickness = t.minRuleThickness, this._fontMetrics = void 0;
  }
  /**
   * Returns a new options object with the same properties as "this".  Properties
   * from "extension" will be copied to the new options object.
   */
  extend(t) {
    var g = {
      style: this.style,
      size: this.size,
      textSize: this.textSize,
      color: this.color,
      phantom: this.phantom,
      font: this.font,
      fontFamily: this.fontFamily,
      fontWeight: this.fontWeight,
      fontShape: this.fontShape,
      maxSize: this.maxSize,
      minRuleThickness: this.minRuleThickness
    };
    for (var d in t)
      t.hasOwnProperty(d) && (g[d] = t[d]);
    return new Options(g);
  }
  /**
   * Return an options object with the given style. If `this.style === style`,
   * returns `this`.
   */
  havingStyle(t) {
    return this.style === t ? this : this.extend({
      style: t,
      size: sizeAtStyle(this.textSize, t)
    });
  }
  /**
   * Return an options object with a cramped version of the current style. If
   * the current style is cramped, returns `this`.
   */
  havingCrampedStyle() {
    return this.havingStyle(this.style.cramp());
  }
  /**
   * Return an options object with the given size and in at least `\textstyle`.
   * Returns `this` if appropriate.
   */
  havingSize(t) {
    return this.size === t && this.textSize === t ? this : this.extend({
      style: this.style.text(),
      size: t,
      textSize: t,
      sizeMultiplier: sizeMultipliers[t - 1]
    });
  }
  /**
   * Like `this.havingSize(BASESIZE).havingStyle(style)`. If `style` is omitted,
   * changes to at least `\textstyle`.
   */
  havingBaseStyle(t) {
    t = t || this.style.text();
    var g = sizeAtStyle(Options.BASESIZE, t);
    return this.size === g && this.textSize === Options.BASESIZE && this.style === t ? this : this.extend({
      style: t,
      size: g
    });
  }
  /**
   * Remove the effect of sizing changes such as \Huge.
   * Keep the effect of the current style, such as \scriptstyle.
   */
  havingBaseSizing() {
    var t;
    switch (this.style.id) {
      case 4:
      case 5:
        t = 3;
        break;
      case 6:
      case 7:
        t = 1;
        break;
      default:
        t = 6;
    }
    return this.extend({
      style: this.style.text(),
      size: t
    });
  }
  /**
   * Create a new options object with the given color.
   */
  withColor(t) {
    return this.extend({
      color: t
    });
  }
  /**
   * Create a new options object with "phantom" set to true.
   */
  withPhantom() {
    return this.extend({
      phantom: !0
    });
  }
  /**
   * Creates a new options object with the given math font or old text font.
   * @type {[type]}
   */
  withFont(t) {
    return this.extend({
      font: t
    });
  }
  /**
   * Create a new options objects with the given fontFamily.
   */
  withTextFontFamily(t) {
    return this.extend({
      fontFamily: t,
      font: ""
    });
  }
  /**
   * Creates a new options object with the given font weight
   */
  withTextFontWeight(t) {
    return this.extend({
      fontWeight: t,
      font: ""
    });
  }
  /**
   * Creates a new options object with the given font weight
   */
  withTextFontShape(t) {
    return this.extend({
      fontShape: t,
      font: ""
    });
  }
  /**
   * Return the CSS sizing classes required to switch from enclosing options
   * `oldOptions` to `this`. Returns an array of classes.
   */
  sizingClasses(t) {
    return t.size !== this.size ? ["sizing", "reset-size" + t.size, "size" + this.size] : [];
  }
  /**
   * Return the CSS sizing classes required to switch to the base size. Like
   * `this.havingSize(BASESIZE).sizingClasses(this)`.
   */
  baseSizingClasses() {
    return this.size !== Options.BASESIZE ? ["sizing", "reset-size" + this.size, "size" + Options.BASESIZE] : [];
  }
  /**
   * Return the font metrics for this size.
   */
  fontMetrics() {
    return this._fontMetrics || (this._fontMetrics = getGlobalMetrics(this.size)), this._fontMetrics;
  }
  /**
   * Gets the CSS color of the current options object
   */
  getColor() {
    return this.phantom ? "transparent" : this.color;
  }
}
Options.BASESIZE = 6;
var ptPerUnit = {
  // https://en.wikibooks.org/wiki/LaTeX/Lengths and
  // https://tex.stackexchange.com/a/8263
  pt: 1,
  // TeX point
  mm: 7227 / 2540,
  // millimeter
  cm: 7227 / 254,
  // centimeter
  in: 72.27,
  // inch
  bp: 803 / 800,
  // big (PostScript) points
  pc: 12,
  // pica
  dd: 1238 / 1157,
  // didot
  cc: 14856 / 1157,
  // cicero (12 didot)
  nd: 685 / 642,
  // new didot
  nc: 1370 / 107,
  // new cicero (12 new didot)
  sp: 1 / 65536,
  // scaled point (TeX's internal smallest unit)
  // https://tex.stackexchange.com/a/41371
  px: 803 / 800
  // \pdfpxdimen defaults to 1 bp in pdfTeX and LuaTeX
}, relativeUnit = {
  ex: !0,
  em: !0,
  mu: !0
}, validUnit = function n(t) {
  return typeof t != "string" && (t = t.unit), t in ptPerUnit || t in relativeUnit || t === "ex";
}, calculateSize = function n(t, g) {
  var d;
  if (t.unit in ptPerUnit)
    d = ptPerUnit[t.unit] / g.fontMetrics().ptPerEm / g.sizeMultiplier;
  else if (t.unit === "mu")
    d = g.fontMetrics().cssEmPerMu;
  else {
    var k;
    if (g.style.isTight() ? k = g.havingStyle(g.style.text()) : k = g, t.unit === "ex")
      d = k.fontMetrics().xHeight;
    else if (t.unit === "em")
      d = k.fontMetrics().quad;
    else
      throw new ParseError("Invalid unit: '" + t.unit + "'");
    k !== g && (d *= k.sizeMultiplier / g.sizeMultiplier);
  }
  return Math.min(t.number * d, g.maxSize);
}, makeEm = function n(t) {
  return +t.toFixed(4) + "em";
}, createClass = function n(t) {
  return t.filter((g) => g).join(" ");
}, initNode = function n(t, g, d) {
  if (this.classes = t || [], this.attributes = {}, this.height = 0, this.depth = 0, this.maxFontSize = 0, this.style = d || {}, g) {
    g.style.isTight() && this.classes.push("mtight");
    var k = g.getColor();
    k && (this.style.color = k);
  }
}, toNode = function n(t) {
  var g = document.createElement(t);
  g.className = createClass(this.classes);
  for (var d in this.style)
    this.style.hasOwnProperty(d) && (g.style[d] = this.style[d]);
  for (var k in this.attributes)
    this.attributes.hasOwnProperty(k) && g.setAttribute(k, this.attributes[k]);
  for (var H = 0; H < this.children.length; H++)
    g.appendChild(this.children[H].toNode());
  return g;
}, invalidAttributeNameRegex = /[\s"'>/=\x00-\x1f]/, toMarkup = function n(t) {
  var g = "<" + t;
  this.classes.length && (g += ' class="' + utils$2.escape(createClass(this.classes)) + '"');
  var d = "";
  for (var k in this.style)
    this.style.hasOwnProperty(k) && (d += utils$2.hyphenate(k) + ":" + this.style[k] + ";");
  d && (g += ' style="' + utils$2.escape(d) + '"');
  for (var H in this.attributes)
    if (this.attributes.hasOwnProperty(H)) {
      if (invalidAttributeNameRegex.test(H))
        throw new ParseError("Invalid attribute name '" + H + "'");
      g += " " + H + '="' + utils$2.escape(this.attributes[H]) + '"';
    }
  g += ">";
  for (var AA = 0; AA < this.children.length; AA++)
    g += this.children[AA].toMarkup();
  return g += "</" + t + ">", g;
};
class Span {
  constructor(t, g, d, k) {
    this.children = void 0, this.attributes = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.width = void 0, this.maxFontSize = void 0, this.style = void 0, initNode.call(this, t, d, k), this.children = g || [];
  }
  /**
   * Sets an arbitrary attribute on the span. Warning: use this wisely. Not
   * all browsers support attributes the same, and having too many custom
   * attributes is probably bad.
   */
  setAttribute(t, g) {
    this.attributes[t] = g;
  }
  hasClass(t) {
    return this.classes.includes(t);
  }
  toNode() {
    return toNode.call(this, "span");
  }
  toMarkup() {
    return toMarkup.call(this, "span");
  }
}
class Anchor {
  constructor(t, g, d, k) {
    this.children = void 0, this.attributes = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, initNode.call(this, g, k), this.children = d || [], this.setAttribute("href", t);
  }
  setAttribute(t, g) {
    this.attributes[t] = g;
  }
  hasClass(t) {
    return this.classes.includes(t);
  }
  toNode() {
    return toNode.call(this, "a");
  }
  toMarkup() {
    return toMarkup.call(this, "a");
  }
}
class Img {
  constructor(t, g, d) {
    this.src = void 0, this.alt = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, this.alt = g, this.src = t, this.classes = ["mord"], this.style = d;
  }
  hasClass(t) {
    return this.classes.includes(t);
  }
  toNode() {
    var t = document.createElement("img");
    t.src = this.src, t.alt = this.alt, t.className = "mord";
    for (var g in this.style)
      this.style.hasOwnProperty(g) && (t.style[g] = this.style[g]);
    return t;
  }
  toMarkup() {
    var t = '<img src="' + utils$2.escape(this.src) + '"' + (' alt="' + utils$2.escape(this.alt) + '"'), g = "";
    for (var d in this.style)
      this.style.hasOwnProperty(d) && (g += utils$2.hyphenate(d) + ":" + this.style[d] + ";");
    return g && (t += ' style="' + utils$2.escape(g) + '"'), t += "'/>", t;
  }
}
var iCombinations = {
  î: "ı̂",
  ï: "ı̈",
  í: "ı́",
  // 'ī': '\u0131\u0304', // enable when we add Extended Latin
  ì: "ı̀"
};
class SymbolNode {
  constructor(t, g, d, k, H, AA, gA, IA) {
    this.text = void 0, this.height = void 0, this.depth = void 0, this.italic = void 0, this.skew = void 0, this.width = void 0, this.maxFontSize = void 0, this.classes = void 0, this.style = void 0, this.text = t, this.height = g || 0, this.depth = d || 0, this.italic = k || 0, this.skew = H || 0, this.width = AA || 0, this.classes = gA || [], this.style = IA || {}, this.maxFontSize = 0;
    var CA = scriptFromCodepoint(this.text.charCodeAt(0));
    CA && this.classes.push(CA + "_fallback"), /[îïíì]/.test(this.text) && (this.text = iCombinations[this.text]);
  }
  hasClass(t) {
    return this.classes.includes(t);
  }
  /**
   * Creates a text node or span from a symbol node. Note that a span is only
   * created if it is needed.
   */
  toNode() {
    var t = document.createTextNode(this.text), g = null;
    this.italic > 0 && (g = document.createElement("span"), g.style.marginRight = makeEm(this.italic)), this.classes.length > 0 && (g = g || document.createElement("span"), g.className = createClass(this.classes));
    for (var d in this.style)
      this.style.hasOwnProperty(d) && (g = g || document.createElement("span"), g.style[d] = this.style[d]);
    return g ? (g.appendChild(t), g) : t;
  }
  /**
   * Creates markup for a symbol node.
   */
  toMarkup() {
    var t = !1, g = "<span";
    this.classes.length && (t = !0, g += ' class="', g += utils$2.escape(createClass(this.classes)), g += '"');
    var d = "";
    this.italic > 0 && (d += "margin-right:" + this.italic + "em;");
    for (var k in this.style)
      this.style.hasOwnProperty(k) && (d += utils$2.hyphenate(k) + ":" + this.style[k] + ";");
    d && (t = !0, g += ' style="' + utils$2.escape(d) + '"');
    var H = utils$2.escape(this.text);
    return t ? (g += ">", g += H, g += "</span>", g) : H;
  }
}
class SvgNode {
  constructor(t, g) {
    this.children = void 0, this.attributes = void 0, this.children = t || [], this.attributes = g || {};
  }
  toNode() {
    var t = "http://www.w3.org/2000/svg", g = document.createElementNS(t, "svg");
    for (var d in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, d) && g.setAttribute(d, this.attributes[d]);
    for (var k = 0; k < this.children.length; k++)
      g.appendChild(this.children[k].toNode());
    return g;
  }
  toMarkup() {
    var t = '<svg xmlns="http://www.w3.org/2000/svg"';
    for (var g in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, g) && (t += " " + g + '="' + utils$2.escape(this.attributes[g]) + '"');
    t += ">";
    for (var d = 0; d < this.children.length; d++)
      t += this.children[d].toMarkup();
    return t += "</svg>", t;
  }
}
class PathNode {
  constructor(t, g) {
    this.pathName = void 0, this.alternate = void 0, this.pathName = t, this.alternate = g;
  }
  toNode() {
    var t = "http://www.w3.org/2000/svg", g = document.createElementNS(t, "path");
    return this.alternate ? g.setAttribute("d", this.alternate) : g.setAttribute("d", path$6[this.pathName]), g;
  }
  toMarkup() {
    return this.alternate ? '<path d="' + utils$2.escape(this.alternate) + '"/>' : '<path d="' + utils$2.escape(path$6[this.pathName]) + '"/>';
  }
}
class LineNode {
  constructor(t) {
    this.attributes = void 0, this.attributes = t || {};
  }
  toNode() {
    var t = "http://www.w3.org/2000/svg", g = document.createElementNS(t, "line");
    for (var d in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, d) && g.setAttribute(d, this.attributes[d]);
    return g;
  }
  toMarkup() {
    var t = "<line";
    for (var g in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, g) && (t += " " + g + '="' + utils$2.escape(this.attributes[g]) + '"');
    return t += "/>", t;
  }
}
function assertSymbolDomNode(n) {
  if (n instanceof SymbolNode)
    return n;
  throw new Error("Expected symbolNode but got " + String(n) + ".");
}
function assertSpan(n) {
  if (n instanceof Span)
    return n;
  throw new Error("Expected span<HtmlDomNode> but got " + String(n) + ".");
}
var ATOMS = {
  bin: 1,
  close: 1,
  inner: 1,
  open: 1,
  punct: 1,
  rel: 1
}, NON_ATOMS = {
  "accent-token": 1,
  mathord: 1,
  "op-token": 1,
  spacing: 1,
  textord: 1
}, symbols$4 = {
  math: {},
  text: {}
};
function defineSymbol(n, t, g, d, k, H) {
  symbols$4[n][k] = {
    font: t,
    group: g,
    replace: d
  }, H && d && (symbols$4[n][d] = symbols$4[n][k]);
}
var math$1 = "math", text$7 = "text", main$3 = "main", ams = "ams", accent = "accent-token", bin$2 = "bin", close = "close", inner = "inner", mathord = "mathord", op = "op-token", open = "open", punct = "punct", rel = "rel", spacing = "spacing", textord = "textord";
defineSymbol(math$1, main$3, rel, "≡", "\\equiv", !0);
defineSymbol(math$1, main$3, rel, "≺", "\\prec", !0);
defineSymbol(math$1, main$3, rel, "≻", "\\succ", !0);
defineSymbol(math$1, main$3, rel, "∼", "\\sim", !0);
defineSymbol(math$1, main$3, rel, "⊥", "\\perp");
defineSymbol(math$1, main$3, rel, "⪯", "\\preceq", !0);
defineSymbol(math$1, main$3, rel, "⪰", "\\succeq", !0);
defineSymbol(math$1, main$3, rel, "≃", "\\simeq", !0);
defineSymbol(math$1, main$3, rel, "∣", "\\mid", !0);
defineSymbol(math$1, main$3, rel, "≪", "\\ll", !0);
defineSymbol(math$1, main$3, rel, "≫", "\\gg", !0);
defineSymbol(math$1, main$3, rel, "≍", "\\asymp", !0);
defineSymbol(math$1, main$3, rel, "∥", "\\parallel");
defineSymbol(math$1, main$3, rel, "⋈", "\\bowtie", !0);
defineSymbol(math$1, main$3, rel, "⌣", "\\smile", !0);
defineSymbol(math$1, main$3, rel, "⊑", "\\sqsubseteq", !0);
defineSymbol(math$1, main$3, rel, "⊒", "\\sqsupseteq", !0);
defineSymbol(math$1, main$3, rel, "≐", "\\doteq", !0);
defineSymbol(math$1, main$3, rel, "⌢", "\\frown", !0);
defineSymbol(math$1, main$3, rel, "∋", "\\ni", !0);
defineSymbol(math$1, main$3, rel, "∝", "\\propto", !0);
defineSymbol(math$1, main$3, rel, "⊢", "\\vdash", !0);
defineSymbol(math$1, main$3, rel, "⊣", "\\dashv", !0);
defineSymbol(math$1, main$3, rel, "∋", "\\owns");
defineSymbol(math$1, main$3, punct, ".", "\\ldotp");
defineSymbol(math$1, main$3, punct, "⋅", "\\cdotp");
defineSymbol(math$1, main$3, textord, "#", "\\#");
defineSymbol(text$7, main$3, textord, "#", "\\#");
defineSymbol(math$1, main$3, textord, "&", "\\&");
defineSymbol(text$7, main$3, textord, "&", "\\&");
defineSymbol(math$1, main$3, textord, "ℵ", "\\aleph", !0);
defineSymbol(math$1, main$3, textord, "∀", "\\forall", !0);
defineSymbol(math$1, main$3, textord, "ℏ", "\\hbar", !0);
defineSymbol(math$1, main$3, textord, "∃", "\\exists", !0);
defineSymbol(math$1, main$3, textord, "∇", "\\nabla", !0);
defineSymbol(math$1, main$3, textord, "♭", "\\flat", !0);
defineSymbol(math$1, main$3, textord, "ℓ", "\\ell", !0);
defineSymbol(math$1, main$3, textord, "♮", "\\natural", !0);
defineSymbol(math$1, main$3, textord, "♣", "\\clubsuit", !0);
defineSymbol(math$1, main$3, textord, "℘", "\\wp", !0);
defineSymbol(math$1, main$3, textord, "♯", "\\sharp", !0);
defineSymbol(math$1, main$3, textord, "♢", "\\diamondsuit", !0);
defineSymbol(math$1, main$3, textord, "ℜ", "\\Re", !0);
defineSymbol(math$1, main$3, textord, "♡", "\\heartsuit", !0);
defineSymbol(math$1, main$3, textord, "ℑ", "\\Im", !0);
defineSymbol(math$1, main$3, textord, "♠", "\\spadesuit", !0);
defineSymbol(math$1, main$3, textord, "§", "\\S", !0);
defineSymbol(text$7, main$3, textord, "§", "\\S");
defineSymbol(math$1, main$3, textord, "¶", "\\P", !0);
defineSymbol(text$7, main$3, textord, "¶", "\\P");
defineSymbol(math$1, main$3, textord, "†", "\\dag");
defineSymbol(text$7, main$3, textord, "†", "\\dag");
defineSymbol(text$7, main$3, textord, "†", "\\textdagger");
defineSymbol(math$1, main$3, textord, "‡", "\\ddag");
defineSymbol(text$7, main$3, textord, "‡", "\\ddag");
defineSymbol(text$7, main$3, textord, "‡", "\\textdaggerdbl");
defineSymbol(math$1, main$3, close, "⎱", "\\rmoustache", !0);
defineSymbol(math$1, main$3, open, "⎰", "\\lmoustache", !0);
defineSymbol(math$1, main$3, close, "⟯", "\\rgroup", !0);
defineSymbol(math$1, main$3, open, "⟮", "\\lgroup", !0);
defineSymbol(math$1, main$3, bin$2, "∓", "\\mp", !0);
defineSymbol(math$1, main$3, bin$2, "⊖", "\\ominus", !0);
defineSymbol(math$1, main$3, bin$2, "⊎", "\\uplus", !0);
defineSymbol(math$1, main$3, bin$2, "⊓", "\\sqcap", !0);
defineSymbol(math$1, main$3, bin$2, "∗", "\\ast");
defineSymbol(math$1, main$3, bin$2, "⊔", "\\sqcup", !0);
defineSymbol(math$1, main$3, bin$2, "◯", "\\bigcirc", !0);
defineSymbol(math$1, main$3, bin$2, "∙", "\\bullet", !0);
defineSymbol(math$1, main$3, bin$2, "‡", "\\ddagger");
defineSymbol(math$1, main$3, bin$2, "≀", "\\wr", !0);
defineSymbol(math$1, main$3, bin$2, "⨿", "\\amalg");
defineSymbol(math$1, main$3, bin$2, "&", "\\And");
defineSymbol(math$1, main$3, rel, "⟵", "\\longleftarrow", !0);
defineSymbol(math$1, main$3, rel, "⇐", "\\Leftarrow", !0);
defineSymbol(math$1, main$3, rel, "⟸", "\\Longleftarrow", !0);
defineSymbol(math$1, main$3, rel, "⟶", "\\longrightarrow", !0);
defineSymbol(math$1, main$3, rel, "⇒", "\\Rightarrow", !0);
defineSymbol(math$1, main$3, rel, "⟹", "\\Longrightarrow", !0);
defineSymbol(math$1, main$3, rel, "↔", "\\leftrightarrow", !0);
defineSymbol(math$1, main$3, rel, "⟷", "\\longleftrightarrow", !0);
defineSymbol(math$1, main$3, rel, "⇔", "\\Leftrightarrow", !0);
defineSymbol(math$1, main$3, rel, "⟺", "\\Longleftrightarrow", !0);
defineSymbol(math$1, main$3, rel, "↦", "\\mapsto", !0);
defineSymbol(math$1, main$3, rel, "⟼", "\\longmapsto", !0);
defineSymbol(math$1, main$3, rel, "↗", "\\nearrow", !0);
defineSymbol(math$1, main$3, rel, "↩", "\\hookleftarrow", !0);
defineSymbol(math$1, main$3, rel, "↪", "\\hookrightarrow", !0);
defineSymbol(math$1, main$3, rel, "↘", "\\searrow", !0);
defineSymbol(math$1, main$3, rel, "↼", "\\leftharpoonup", !0);
defineSymbol(math$1, main$3, rel, "⇀", "\\rightharpoonup", !0);
defineSymbol(math$1, main$3, rel, "↙", "\\swarrow", !0);
defineSymbol(math$1, main$3, rel, "↽", "\\leftharpoondown", !0);
defineSymbol(math$1, main$3, rel, "⇁", "\\rightharpoondown", !0);
defineSymbol(math$1, main$3, rel, "↖", "\\nwarrow", !0);
defineSymbol(math$1, main$3, rel, "⇌", "\\rightleftharpoons", !0);
defineSymbol(math$1, ams, rel, "≮", "\\nless", !0);
defineSymbol(math$1, ams, rel, "", "\\@nleqslant");
defineSymbol(math$1, ams, rel, "", "\\@nleqq");
defineSymbol(math$1, ams, rel, "⪇", "\\lneq", !0);
defineSymbol(math$1, ams, rel, "≨", "\\lneqq", !0);
defineSymbol(math$1, ams, rel, "", "\\@lvertneqq");
defineSymbol(math$1, ams, rel, "⋦", "\\lnsim", !0);
defineSymbol(math$1, ams, rel, "⪉", "\\lnapprox", !0);
defineSymbol(math$1, ams, rel, "⊀", "\\nprec", !0);
defineSymbol(math$1, ams, rel, "⋠", "\\npreceq", !0);
defineSymbol(math$1, ams, rel, "⋨", "\\precnsim", !0);
defineSymbol(math$1, ams, rel, "⪹", "\\precnapprox", !0);
defineSymbol(math$1, ams, rel, "≁", "\\nsim", !0);
defineSymbol(math$1, ams, rel, "", "\\@nshortmid");
defineSymbol(math$1, ams, rel, "∤", "\\nmid", !0);
defineSymbol(math$1, ams, rel, "⊬", "\\nvdash", !0);
defineSymbol(math$1, ams, rel, "⊭", "\\nvDash", !0);
defineSymbol(math$1, ams, rel, "⋪", "\\ntriangleleft");
defineSymbol(math$1, ams, rel, "⋬", "\\ntrianglelefteq", !0);
defineSymbol(math$1, ams, rel, "⊊", "\\subsetneq", !0);
defineSymbol(math$1, ams, rel, "", "\\@varsubsetneq");
defineSymbol(math$1, ams, rel, "⫋", "\\subsetneqq", !0);
defineSymbol(math$1, ams, rel, "", "\\@varsubsetneqq");
defineSymbol(math$1, ams, rel, "≯", "\\ngtr", !0);
defineSymbol(math$1, ams, rel, "", "\\@ngeqslant");
defineSymbol(math$1, ams, rel, "", "\\@ngeqq");
defineSymbol(math$1, ams, rel, "⪈", "\\gneq", !0);
defineSymbol(math$1, ams, rel, "≩", "\\gneqq", !0);
defineSymbol(math$1, ams, rel, "", "\\@gvertneqq");
defineSymbol(math$1, ams, rel, "⋧", "\\gnsim", !0);
defineSymbol(math$1, ams, rel, "⪊", "\\gnapprox", !0);
defineSymbol(math$1, ams, rel, "⊁", "\\nsucc", !0);
defineSymbol(math$1, ams, rel, "⋡", "\\nsucceq", !0);
defineSymbol(math$1, ams, rel, "⋩", "\\succnsim", !0);
defineSymbol(math$1, ams, rel, "⪺", "\\succnapprox", !0);
defineSymbol(math$1, ams, rel, "≆", "\\ncong", !0);
defineSymbol(math$1, ams, rel, "", "\\@nshortparallel");
defineSymbol(math$1, ams, rel, "∦", "\\nparallel", !0);
defineSymbol(math$1, ams, rel, "⊯", "\\nVDash", !0);
defineSymbol(math$1, ams, rel, "⋫", "\\ntriangleright");
defineSymbol(math$1, ams, rel, "⋭", "\\ntrianglerighteq", !0);
defineSymbol(math$1, ams, rel, "", "\\@nsupseteqq");
defineSymbol(math$1, ams, rel, "⊋", "\\supsetneq", !0);
defineSymbol(math$1, ams, rel, "", "\\@varsupsetneq");
defineSymbol(math$1, ams, rel, "⫌", "\\supsetneqq", !0);
defineSymbol(math$1, ams, rel, "", "\\@varsupsetneqq");
defineSymbol(math$1, ams, rel, "⊮", "\\nVdash", !0);
defineSymbol(math$1, ams, rel, "⪵", "\\precneqq", !0);
defineSymbol(math$1, ams, rel, "⪶", "\\succneqq", !0);
defineSymbol(math$1, ams, rel, "", "\\@nsubseteqq");
defineSymbol(math$1, ams, bin$2, "⊴", "\\unlhd");
defineSymbol(math$1, ams, bin$2, "⊵", "\\unrhd");
defineSymbol(math$1, ams, rel, "↚", "\\nleftarrow", !0);
defineSymbol(math$1, ams, rel, "↛", "\\nrightarrow", !0);
defineSymbol(math$1, ams, rel, "⇍", "\\nLeftarrow", !0);
defineSymbol(math$1, ams, rel, "⇏", "\\nRightarrow", !0);
defineSymbol(math$1, ams, rel, "↮", "\\nleftrightarrow", !0);
defineSymbol(math$1, ams, rel, "⇎", "\\nLeftrightarrow", !0);
defineSymbol(math$1, ams, rel, "△", "\\vartriangle");
defineSymbol(math$1, ams, textord, "ℏ", "\\hslash");
defineSymbol(math$1, ams, textord, "▽", "\\triangledown");
defineSymbol(math$1, ams, textord, "◊", "\\lozenge");
defineSymbol(math$1, ams, textord, "Ⓢ", "\\circledS");
defineSymbol(math$1, ams, textord, "®", "\\circledR");
defineSymbol(text$7, ams, textord, "®", "\\circledR");
defineSymbol(math$1, ams, textord, "∡", "\\measuredangle", !0);
defineSymbol(math$1, ams, textord, "∄", "\\nexists");
defineSymbol(math$1, ams, textord, "℧", "\\mho");
defineSymbol(math$1, ams, textord, "Ⅎ", "\\Finv", !0);
defineSymbol(math$1, ams, textord, "⅁", "\\Game", !0);
defineSymbol(math$1, ams, textord, "‵", "\\backprime");
defineSymbol(math$1, ams, textord, "▲", "\\blacktriangle");
defineSymbol(math$1, ams, textord, "▼", "\\blacktriangledown");
defineSymbol(math$1, ams, textord, "■", "\\blacksquare");
defineSymbol(math$1, ams, textord, "⧫", "\\blacklozenge");
defineSymbol(math$1, ams, textord, "★", "\\bigstar");
defineSymbol(math$1, ams, textord, "∢", "\\sphericalangle", !0);
defineSymbol(math$1, ams, textord, "∁", "\\complement", !0);
defineSymbol(math$1, ams, textord, "ð", "\\eth", !0);
defineSymbol(text$7, main$3, textord, "ð", "ð");
defineSymbol(math$1, ams, textord, "╱", "\\diagup");
defineSymbol(math$1, ams, textord, "╲", "\\diagdown");
defineSymbol(math$1, ams, textord, "□", "\\square");
defineSymbol(math$1, ams, textord, "□", "\\Box");
defineSymbol(math$1, ams, textord, "◊", "\\Diamond");
defineSymbol(math$1, ams, textord, "¥", "\\yen", !0);
defineSymbol(text$7, ams, textord, "¥", "\\yen", !0);
defineSymbol(math$1, ams, textord, "✓", "\\checkmark", !0);
defineSymbol(text$7, ams, textord, "✓", "\\checkmark");
defineSymbol(math$1, ams, textord, "ℶ", "\\beth", !0);
defineSymbol(math$1, ams, textord, "ℸ", "\\daleth", !0);
defineSymbol(math$1, ams, textord, "ℷ", "\\gimel", !0);
defineSymbol(math$1, ams, textord, "ϝ", "\\digamma", !0);
defineSymbol(math$1, ams, textord, "ϰ", "\\varkappa");
defineSymbol(math$1, ams, open, "┌", "\\@ulcorner", !0);
defineSymbol(math$1, ams, close, "┐", "\\@urcorner", !0);
defineSymbol(math$1, ams, open, "└", "\\@llcorner", !0);
defineSymbol(math$1, ams, close, "┘", "\\@lrcorner", !0);
defineSymbol(math$1, ams, rel, "≦", "\\leqq", !0);
defineSymbol(math$1, ams, rel, "⩽", "\\leqslant", !0);
defineSymbol(math$1, ams, rel, "⪕", "\\eqslantless", !0);
defineSymbol(math$1, ams, rel, "≲", "\\lesssim", !0);
defineSymbol(math$1, ams, rel, "⪅", "\\lessapprox", !0);
defineSymbol(math$1, ams, rel, "≊", "\\approxeq", !0);
defineSymbol(math$1, ams, bin$2, "⋖", "\\lessdot");
defineSymbol(math$1, ams, rel, "⋘", "\\lll", !0);
defineSymbol(math$1, ams, rel, "≶", "\\lessgtr", !0);
defineSymbol(math$1, ams, rel, "⋚", "\\lesseqgtr", !0);
defineSymbol(math$1, ams, rel, "⪋", "\\lesseqqgtr", !0);
defineSymbol(math$1, ams, rel, "≑", "\\doteqdot");
defineSymbol(math$1, ams, rel, "≓", "\\risingdotseq", !0);
defineSymbol(math$1, ams, rel, "≒", "\\fallingdotseq", !0);
defineSymbol(math$1, ams, rel, "∽", "\\backsim", !0);
defineSymbol(math$1, ams, rel, "⋍", "\\backsimeq", !0);
defineSymbol(math$1, ams, rel, "⫅", "\\subseteqq", !0);
defineSymbol(math$1, ams, rel, "⋐", "\\Subset", !0);
defineSymbol(math$1, ams, rel, "⊏", "\\sqsubset", !0);
defineSymbol(math$1, ams, rel, "≼", "\\preccurlyeq", !0);
defineSymbol(math$1, ams, rel, "⋞", "\\curlyeqprec", !0);
defineSymbol(math$1, ams, rel, "≾", "\\precsim", !0);
defineSymbol(math$1, ams, rel, "⪷", "\\precapprox", !0);
defineSymbol(math$1, ams, rel, "⊲", "\\vartriangleleft");
defineSymbol(math$1, ams, rel, "⊴", "\\trianglelefteq");
defineSymbol(math$1, ams, rel, "⊨", "\\vDash", !0);
defineSymbol(math$1, ams, rel, "⊪", "\\Vvdash", !0);
defineSymbol(math$1, ams, rel, "⌣", "\\smallsmile");
defineSymbol(math$1, ams, rel, "⌢", "\\smallfrown");
defineSymbol(math$1, ams, rel, "≏", "\\bumpeq", !0);
defineSymbol(math$1, ams, rel, "≎", "\\Bumpeq", !0);
defineSymbol(math$1, ams, rel, "≧", "\\geqq", !0);
defineSymbol(math$1, ams, rel, "⩾", "\\geqslant", !0);
defineSymbol(math$1, ams, rel, "⪖", "\\eqslantgtr", !0);
defineSymbol(math$1, ams, rel, "≳", "\\gtrsim", !0);
defineSymbol(math$1, ams, rel, "⪆", "\\gtrapprox", !0);
defineSymbol(math$1, ams, bin$2, "⋗", "\\gtrdot");
defineSymbol(math$1, ams, rel, "⋙", "\\ggg", !0);
defineSymbol(math$1, ams, rel, "≷", "\\gtrless", !0);
defineSymbol(math$1, ams, rel, "⋛", "\\gtreqless", !0);
defineSymbol(math$1, ams, rel, "⪌", "\\gtreqqless", !0);
defineSymbol(math$1, ams, rel, "≖", "\\eqcirc", !0);
defineSymbol(math$1, ams, rel, "≗", "\\circeq", !0);
defineSymbol(math$1, ams, rel, "≜", "\\triangleq", !0);
defineSymbol(math$1, ams, rel, "∼", "\\thicksim");
defineSymbol(math$1, ams, rel, "≈", "\\thickapprox");
defineSymbol(math$1, ams, rel, "⫆", "\\supseteqq", !0);
defineSymbol(math$1, ams, rel, "⋑", "\\Supset", !0);
defineSymbol(math$1, ams, rel, "⊐", "\\sqsupset", !0);
defineSymbol(math$1, ams, rel, "≽", "\\succcurlyeq", !0);
defineSymbol(math$1, ams, rel, "⋟", "\\curlyeqsucc", !0);
defineSymbol(math$1, ams, rel, "≿", "\\succsim", !0);
defineSymbol(math$1, ams, rel, "⪸", "\\succapprox", !0);
defineSymbol(math$1, ams, rel, "⊳", "\\vartriangleright");
defineSymbol(math$1, ams, rel, "⊵", "\\trianglerighteq");
defineSymbol(math$1, ams, rel, "⊩", "\\Vdash", !0);
defineSymbol(math$1, ams, rel, "∣", "\\shortmid");
defineSymbol(math$1, ams, rel, "∥", "\\shortparallel");
defineSymbol(math$1, ams, rel, "≬", "\\between", !0);
defineSymbol(math$1, ams, rel, "⋔", "\\pitchfork", !0);
defineSymbol(math$1, ams, rel, "∝", "\\varpropto");
defineSymbol(math$1, ams, rel, "◀", "\\blacktriangleleft");
defineSymbol(math$1, ams, rel, "∴", "\\therefore", !0);
defineSymbol(math$1, ams, rel, "∍", "\\backepsilon");
defineSymbol(math$1, ams, rel, "▶", "\\blacktriangleright");
defineSymbol(math$1, ams, rel, "∵", "\\because", !0);
defineSymbol(math$1, ams, rel, "⋘", "\\llless");
defineSymbol(math$1, ams, rel, "⋙", "\\gggtr");
defineSymbol(math$1, ams, bin$2, "⊲", "\\lhd");
defineSymbol(math$1, ams, bin$2, "⊳", "\\rhd");
defineSymbol(math$1, ams, rel, "≂", "\\eqsim", !0);
defineSymbol(math$1, main$3, rel, "⋈", "\\Join");
defineSymbol(math$1, ams, rel, "≑", "\\Doteq", !0);
defineSymbol(math$1, ams, bin$2, "∔", "\\dotplus", !0);
defineSymbol(math$1, ams, bin$2, "∖", "\\smallsetminus");
defineSymbol(math$1, ams, bin$2, "⋒", "\\Cap", !0);
defineSymbol(math$1, ams, bin$2, "⋓", "\\Cup", !0);
defineSymbol(math$1, ams, bin$2, "⩞", "\\doublebarwedge", !0);
defineSymbol(math$1, ams, bin$2, "⊟", "\\boxminus", !0);
defineSymbol(math$1, ams, bin$2, "⊞", "\\boxplus", !0);
defineSymbol(math$1, ams, bin$2, "⋇", "\\divideontimes", !0);
defineSymbol(math$1, ams, bin$2, "⋉", "\\ltimes", !0);
defineSymbol(math$1, ams, bin$2, "⋊", "\\rtimes", !0);
defineSymbol(math$1, ams, bin$2, "⋋", "\\leftthreetimes", !0);
defineSymbol(math$1, ams, bin$2, "⋌", "\\rightthreetimes", !0);
defineSymbol(math$1, ams, bin$2, "⋏", "\\curlywedge", !0);
defineSymbol(math$1, ams, bin$2, "⋎", "\\curlyvee", !0);
defineSymbol(math$1, ams, bin$2, "⊝", "\\circleddash", !0);
defineSymbol(math$1, ams, bin$2, "⊛", "\\circledast", !0);
defineSymbol(math$1, ams, bin$2, "⋅", "\\centerdot");
defineSymbol(math$1, ams, bin$2, "⊺", "\\intercal", !0);
defineSymbol(math$1, ams, bin$2, "⋒", "\\doublecap");
defineSymbol(math$1, ams, bin$2, "⋓", "\\doublecup");
defineSymbol(math$1, ams, bin$2, "⊠", "\\boxtimes", !0);
defineSymbol(math$1, ams, rel, "⇢", "\\dashrightarrow", !0);
defineSymbol(math$1, ams, rel, "⇠", "\\dashleftarrow", !0);
defineSymbol(math$1, ams, rel, "⇇", "\\leftleftarrows", !0);
defineSymbol(math$1, ams, rel, "⇆", "\\leftrightarrows", !0);
defineSymbol(math$1, ams, rel, "⇚", "\\Lleftarrow", !0);
defineSymbol(math$1, ams, rel, "↞", "\\twoheadleftarrow", !0);
defineSymbol(math$1, ams, rel, "↢", "\\leftarrowtail", !0);
defineSymbol(math$1, ams, rel, "↫", "\\looparrowleft", !0);
defineSymbol(math$1, ams, rel, "⇋", "\\leftrightharpoons", !0);
defineSymbol(math$1, ams, rel, "↶", "\\curvearrowleft", !0);
defineSymbol(math$1, ams, rel, "↺", "\\circlearrowleft", !0);
defineSymbol(math$1, ams, rel, "↰", "\\Lsh", !0);
defineSymbol(math$1, ams, rel, "⇈", "\\upuparrows", !0);
defineSymbol(math$1, ams, rel, "↿", "\\upharpoonleft", !0);
defineSymbol(math$1, ams, rel, "⇃", "\\downharpoonleft", !0);
defineSymbol(math$1, main$3, rel, "⊶", "\\origof", !0);
defineSymbol(math$1, main$3, rel, "⊷", "\\imageof", !0);
defineSymbol(math$1, ams, rel, "⊸", "\\multimap", !0);
defineSymbol(math$1, ams, rel, "↭", "\\leftrightsquigarrow", !0);
defineSymbol(math$1, ams, rel, "⇉", "\\rightrightarrows", !0);
defineSymbol(math$1, ams, rel, "⇄", "\\rightleftarrows", !0);
defineSymbol(math$1, ams, rel, "↠", "\\twoheadrightarrow", !0);
defineSymbol(math$1, ams, rel, "↣", "\\rightarrowtail", !0);
defineSymbol(math$1, ams, rel, "↬", "\\looparrowright", !0);
defineSymbol(math$1, ams, rel, "↷", "\\curvearrowright", !0);
defineSymbol(math$1, ams, rel, "↻", "\\circlearrowright", !0);
defineSymbol(math$1, ams, rel, "↱", "\\Rsh", !0);
defineSymbol(math$1, ams, rel, "⇊", "\\downdownarrows", !0);
defineSymbol(math$1, ams, rel, "↾", "\\upharpoonright", !0);
defineSymbol(math$1, ams, rel, "⇂", "\\downharpoonright", !0);
defineSymbol(math$1, ams, rel, "⇝", "\\rightsquigarrow", !0);
defineSymbol(math$1, ams, rel, "⇝", "\\leadsto");
defineSymbol(math$1, ams, rel, "⇛", "\\Rrightarrow", !0);
defineSymbol(math$1, ams, rel, "↾", "\\restriction");
defineSymbol(math$1, main$3, textord, "‘", "`");
defineSymbol(math$1, main$3, textord, "$", "\\$");
defineSymbol(text$7, main$3, textord, "$", "\\$");
defineSymbol(text$7, main$3, textord, "$", "\\textdollar");
defineSymbol(math$1, main$3, textord, "%", "\\%");
defineSymbol(text$7, main$3, textord, "%", "\\%");
defineSymbol(math$1, main$3, textord, "_", "\\_");
defineSymbol(text$7, main$3, textord, "_", "\\_");
defineSymbol(text$7, main$3, textord, "_", "\\textunderscore");
defineSymbol(math$1, main$3, textord, "∠", "\\angle", !0);
defineSymbol(math$1, main$3, textord, "∞", "\\infty", !0);
defineSymbol(math$1, main$3, textord, "′", "\\prime");
defineSymbol(math$1, main$3, textord, "△", "\\triangle");
defineSymbol(math$1, main$3, textord, "Γ", "\\Gamma", !0);
defineSymbol(math$1, main$3, textord, "Δ", "\\Delta", !0);
defineSymbol(math$1, main$3, textord, "Θ", "\\Theta", !0);
defineSymbol(math$1, main$3, textord, "Λ", "\\Lambda", !0);
defineSymbol(math$1, main$3, textord, "Ξ", "\\Xi", !0);
defineSymbol(math$1, main$3, textord, "Π", "\\Pi", !0);
defineSymbol(math$1, main$3, textord, "Σ", "\\Sigma", !0);
defineSymbol(math$1, main$3, textord, "Υ", "\\Upsilon", !0);
defineSymbol(math$1, main$3, textord, "Φ", "\\Phi", !0);
defineSymbol(math$1, main$3, textord, "Ψ", "\\Psi", !0);
defineSymbol(math$1, main$3, textord, "Ω", "\\Omega", !0);
defineSymbol(math$1, main$3, textord, "A", "Α");
defineSymbol(math$1, main$3, textord, "B", "Β");
defineSymbol(math$1, main$3, textord, "E", "Ε");
defineSymbol(math$1, main$3, textord, "Z", "Ζ");
defineSymbol(math$1, main$3, textord, "H", "Η");
defineSymbol(math$1, main$3, textord, "I", "Ι");
defineSymbol(math$1, main$3, textord, "K", "Κ");
defineSymbol(math$1, main$3, textord, "M", "Μ");
defineSymbol(math$1, main$3, textord, "N", "Ν");
defineSymbol(math$1, main$3, textord, "O", "Ο");
defineSymbol(math$1, main$3, textord, "P", "Ρ");
defineSymbol(math$1, main$3, textord, "T", "Τ");
defineSymbol(math$1, main$3, textord, "X", "Χ");
defineSymbol(math$1, main$3, textord, "¬", "\\neg", !0);
defineSymbol(math$1, main$3, textord, "¬", "\\lnot");
defineSymbol(math$1, main$3, textord, "⊤", "\\top");
defineSymbol(math$1, main$3, textord, "⊥", "\\bot");
defineSymbol(math$1, main$3, textord, "∅", "\\emptyset");
defineSymbol(math$1, ams, textord, "∅", "\\varnothing");
defineSymbol(math$1, main$3, mathord, "α", "\\alpha", !0);
defineSymbol(math$1, main$3, mathord, "β", "\\beta", !0);
defineSymbol(math$1, main$3, mathord, "γ", "\\gamma", !0);
defineSymbol(math$1, main$3, mathord, "δ", "\\delta", !0);
defineSymbol(math$1, main$3, mathord, "ϵ", "\\epsilon", !0);
defineSymbol(math$1, main$3, mathord, "ζ", "\\zeta", !0);
defineSymbol(math$1, main$3, mathord, "η", "\\eta", !0);
defineSymbol(math$1, main$3, mathord, "θ", "\\theta", !0);
defineSymbol(math$1, main$3, mathord, "ι", "\\iota", !0);
defineSymbol(math$1, main$3, mathord, "κ", "\\kappa", !0);
defineSymbol(math$1, main$3, mathord, "λ", "\\lambda", !0);
defineSymbol(math$1, main$3, mathord, "μ", "\\mu", !0);
defineSymbol(math$1, main$3, mathord, "ν", "\\nu", !0);
defineSymbol(math$1, main$3, mathord, "ξ", "\\xi", !0);
defineSymbol(math$1, main$3, mathord, "ο", "\\omicron", !0);
defineSymbol(math$1, main$3, mathord, "π", "\\pi", !0);
defineSymbol(math$1, main$3, mathord, "ρ", "\\rho", !0);
defineSymbol(math$1, main$3, mathord, "σ", "\\sigma", !0);
defineSymbol(math$1, main$3, mathord, "τ", "\\tau", !0);
defineSymbol(math$1, main$3, mathord, "υ", "\\upsilon", !0);
defineSymbol(math$1, main$3, mathord, "ϕ", "\\phi", !0);
defineSymbol(math$1, main$3, mathord, "χ", "\\chi", !0);
defineSymbol(math$1, main$3, mathord, "ψ", "\\psi", !0);
defineSymbol(math$1, main$3, mathord, "ω", "\\omega", !0);
defineSymbol(math$1, main$3, mathord, "ε", "\\varepsilon", !0);
defineSymbol(math$1, main$3, mathord, "ϑ", "\\vartheta", !0);
defineSymbol(math$1, main$3, mathord, "ϖ", "\\varpi", !0);
defineSymbol(math$1, main$3, mathord, "ϱ", "\\varrho", !0);
defineSymbol(math$1, main$3, mathord, "ς", "\\varsigma", !0);
defineSymbol(math$1, main$3, mathord, "φ", "\\varphi", !0);
defineSymbol(math$1, main$3, bin$2, "∗", "*", !0);
defineSymbol(math$1, main$3, bin$2, "+", "+");
defineSymbol(math$1, main$3, bin$2, "−", "-", !0);
defineSymbol(math$1, main$3, bin$2, "⋅", "\\cdot", !0);
defineSymbol(math$1, main$3, bin$2, "∘", "\\circ", !0);
defineSymbol(math$1, main$3, bin$2, "÷", "\\div", !0);
defineSymbol(math$1, main$3, bin$2, "±", "\\pm", !0);
defineSymbol(math$1, main$3, bin$2, "×", "\\times", !0);
defineSymbol(math$1, main$3, bin$2, "∩", "\\cap", !0);
defineSymbol(math$1, main$3, bin$2, "∪", "\\cup", !0);
defineSymbol(math$1, main$3, bin$2, "∖", "\\setminus", !0);
defineSymbol(math$1, main$3, bin$2, "∧", "\\land");
defineSymbol(math$1, main$3, bin$2, "∨", "\\lor");
defineSymbol(math$1, main$3, bin$2, "∧", "\\wedge", !0);
defineSymbol(math$1, main$3, bin$2, "∨", "\\vee", !0);
defineSymbol(math$1, main$3, textord, "√", "\\surd");
defineSymbol(math$1, main$3, open, "⟨", "\\langle", !0);
defineSymbol(math$1, main$3, open, "∣", "\\lvert");
defineSymbol(math$1, main$3, open, "∥", "\\lVert");
defineSymbol(math$1, main$3, close, "?", "?");
defineSymbol(math$1, main$3, close, "!", "!");
defineSymbol(math$1, main$3, close, "⟩", "\\rangle", !0);
defineSymbol(math$1, main$3, close, "∣", "\\rvert");
defineSymbol(math$1, main$3, close, "∥", "\\rVert");
defineSymbol(math$1, main$3, rel, "=", "=");
defineSymbol(math$1, main$3, rel, ":", ":");
defineSymbol(math$1, main$3, rel, "≈", "\\approx", !0);
defineSymbol(math$1, main$3, rel, "≅", "\\cong", !0);
defineSymbol(math$1, main$3, rel, "≥", "\\ge");
defineSymbol(math$1, main$3, rel, "≥", "\\geq", !0);
defineSymbol(math$1, main$3, rel, "←", "\\gets");
defineSymbol(math$1, main$3, rel, ">", "\\gt", !0);
defineSymbol(math$1, main$3, rel, "∈", "\\in", !0);
defineSymbol(math$1, main$3, rel, "", "\\@not");
defineSymbol(math$1, main$3, rel, "⊂", "\\subset", !0);
defineSymbol(math$1, main$3, rel, "⊃", "\\supset", !0);
defineSymbol(math$1, main$3, rel, "⊆", "\\subseteq", !0);
defineSymbol(math$1, main$3, rel, "⊇", "\\supseteq", !0);
defineSymbol(math$1, ams, rel, "⊈", "\\nsubseteq", !0);
defineSymbol(math$1, ams, rel, "⊉", "\\nsupseteq", !0);
defineSymbol(math$1, main$3, rel, "⊨", "\\models");
defineSymbol(math$1, main$3, rel, "←", "\\leftarrow", !0);
defineSymbol(math$1, main$3, rel, "≤", "\\le");
defineSymbol(math$1, main$3, rel, "≤", "\\leq", !0);
defineSymbol(math$1, main$3, rel, "<", "\\lt", !0);
defineSymbol(math$1, main$3, rel, "→", "\\rightarrow", !0);
defineSymbol(math$1, main$3, rel, "→", "\\to");
defineSymbol(math$1, ams, rel, "≱", "\\ngeq", !0);
defineSymbol(math$1, ams, rel, "≰", "\\nleq", !0);
defineSymbol(math$1, main$3, spacing, " ", "\\ ");
defineSymbol(math$1, main$3, spacing, " ", "\\space");
defineSymbol(math$1, main$3, spacing, " ", "\\nobreakspace");
defineSymbol(text$7, main$3, spacing, " ", "\\ ");
defineSymbol(text$7, main$3, spacing, " ", " ");
defineSymbol(text$7, main$3, spacing, " ", "\\space");
defineSymbol(text$7, main$3, spacing, " ", "\\nobreakspace");
defineSymbol(math$1, main$3, spacing, null, "\\nobreak");
defineSymbol(math$1, main$3, spacing, null, "\\allowbreak");
defineSymbol(math$1, main$3, punct, ",", ",");
defineSymbol(math$1, main$3, punct, ";", ";");
defineSymbol(math$1, ams, bin$2, "⊼", "\\barwedge", !0);
defineSymbol(math$1, ams, bin$2, "⊻", "\\veebar", !0);
defineSymbol(math$1, main$3, bin$2, "⊙", "\\odot", !0);
defineSymbol(math$1, main$3, bin$2, "⊕", "\\oplus", !0);
defineSymbol(math$1, main$3, bin$2, "⊗", "\\otimes", !0);
defineSymbol(math$1, main$3, textord, "∂", "\\partial", !0);
defineSymbol(math$1, main$3, bin$2, "⊘", "\\oslash", !0);
defineSymbol(math$1, ams, bin$2, "⊚", "\\circledcirc", !0);
defineSymbol(math$1, ams, bin$2, "⊡", "\\boxdot", !0);
defineSymbol(math$1, main$3, bin$2, "△", "\\bigtriangleup");
defineSymbol(math$1, main$3, bin$2, "▽", "\\bigtriangledown");
defineSymbol(math$1, main$3, bin$2, "†", "\\dagger");
defineSymbol(math$1, main$3, bin$2, "⋄", "\\diamond");
defineSymbol(math$1, main$3, bin$2, "⋆", "\\star");
defineSymbol(math$1, main$3, bin$2, "◃", "\\triangleleft");
defineSymbol(math$1, main$3, bin$2, "▹", "\\triangleright");
defineSymbol(math$1, main$3, open, "{", "\\{");
defineSymbol(text$7, main$3, textord, "{", "\\{");
defineSymbol(text$7, main$3, textord, "{", "\\textbraceleft");
defineSymbol(math$1, main$3, close, "}", "\\}");
defineSymbol(text$7, main$3, textord, "}", "\\}");
defineSymbol(text$7, main$3, textord, "}", "\\textbraceright");
defineSymbol(math$1, main$3, open, "{", "\\lbrace");
defineSymbol(math$1, main$3, close, "}", "\\rbrace");
defineSymbol(math$1, main$3, open, "[", "\\lbrack", !0);
defineSymbol(text$7, main$3, textord, "[", "\\lbrack", !0);
defineSymbol(math$1, main$3, close, "]", "\\rbrack", !0);
defineSymbol(text$7, main$3, textord, "]", "\\rbrack", !0);
defineSymbol(math$1, main$3, open, "(", "\\lparen", !0);
defineSymbol(math$1, main$3, close, ")", "\\rparen", !0);
defineSymbol(text$7, main$3, textord, "<", "\\textless", !0);
defineSymbol(text$7, main$3, textord, ">", "\\textgreater", !0);
defineSymbol(math$1, main$3, open, "⌊", "\\lfloor", !0);
defineSymbol(math$1, main$3, close, "⌋", "\\rfloor", !0);
defineSymbol(math$1, main$3, open, "⌈", "\\lceil", !0);
defineSymbol(math$1, main$3, close, "⌉", "\\rceil", !0);
defineSymbol(math$1, main$3, textord, "\\", "\\backslash");
defineSymbol(math$1, main$3, textord, "∣", "|");
defineSymbol(math$1, main$3, textord, "∣", "\\vert");
defineSymbol(text$7, main$3, textord, "|", "\\textbar", !0);
defineSymbol(math$1, main$3, textord, "∥", "\\|");
defineSymbol(math$1, main$3, textord, "∥", "\\Vert");
defineSymbol(text$7, main$3, textord, "∥", "\\textbardbl");
defineSymbol(text$7, main$3, textord, "~", "\\textasciitilde");
defineSymbol(text$7, main$3, textord, "\\", "\\textbackslash");
defineSymbol(text$7, main$3, textord, "^", "\\textasciicircum");
defineSymbol(math$1, main$3, rel, "↑", "\\uparrow", !0);
defineSymbol(math$1, main$3, rel, "⇑", "\\Uparrow", !0);
defineSymbol(math$1, main$3, rel, "↓", "\\downarrow", !0);
defineSymbol(math$1, main$3, rel, "⇓", "\\Downarrow", !0);
defineSymbol(math$1, main$3, rel, "↕", "\\updownarrow", !0);
defineSymbol(math$1, main$3, rel, "⇕", "\\Updownarrow", !0);
defineSymbol(math$1, main$3, op, "∐", "\\coprod");
defineSymbol(math$1, main$3, op, "⋁", "\\bigvee");
defineSymbol(math$1, main$3, op, "⋀", "\\bigwedge");
defineSymbol(math$1, main$3, op, "⨄", "\\biguplus");
defineSymbol(math$1, main$3, op, "⋂", "\\bigcap");
defineSymbol(math$1, main$3, op, "⋃", "\\bigcup");
defineSymbol(math$1, main$3, op, "∫", "\\int");
defineSymbol(math$1, main$3, op, "∫", "\\intop");
defineSymbol(math$1, main$3, op, "∬", "\\iint");
defineSymbol(math$1, main$3, op, "∭", "\\iiint");
defineSymbol(math$1, main$3, op, "∏", "\\prod");
defineSymbol(math$1, main$3, op, "∑", "\\sum");
defineSymbol(math$1, main$3, op, "⨂", "\\bigotimes");
defineSymbol(math$1, main$3, op, "⨁", "\\bigoplus");
defineSymbol(math$1, main$3, op, "⨀", "\\bigodot");
defineSymbol(math$1, main$3, op, "∮", "\\oint");
defineSymbol(math$1, main$3, op, "∯", "\\oiint");
defineSymbol(math$1, main$3, op, "∰", "\\oiiint");
defineSymbol(math$1, main$3, op, "⨆", "\\bigsqcup");
defineSymbol(math$1, main$3, op, "∫", "\\smallint");
defineSymbol(text$7, main$3, inner, "…", "\\textellipsis");
defineSymbol(math$1, main$3, inner, "…", "\\mathellipsis");
defineSymbol(text$7, main$3, inner, "…", "\\ldots", !0);
defineSymbol(math$1, main$3, inner, "…", "\\ldots", !0);
defineSymbol(math$1, main$3, inner, "⋯", "\\@cdots", !0);
defineSymbol(math$1, main$3, inner, "⋱", "\\ddots", !0);
defineSymbol(math$1, main$3, textord, "⋮", "\\varvdots");
defineSymbol(text$7, main$3, textord, "⋮", "\\varvdots");
defineSymbol(math$1, main$3, accent, "ˊ", "\\acute");
defineSymbol(math$1, main$3, accent, "ˋ", "\\grave");
defineSymbol(math$1, main$3, accent, "¨", "\\ddot");
defineSymbol(math$1, main$3, accent, "~", "\\tilde");
defineSymbol(math$1, main$3, accent, "ˉ", "\\bar");
defineSymbol(math$1, main$3, accent, "˘", "\\breve");
defineSymbol(math$1, main$3, accent, "ˇ", "\\check");
defineSymbol(math$1, main$3, accent, "^", "\\hat");
defineSymbol(math$1, main$3, accent, "⃗", "\\vec");
defineSymbol(math$1, main$3, accent, "˙", "\\dot");
defineSymbol(math$1, main$3, accent, "˚", "\\mathring");
defineSymbol(math$1, main$3, mathord, "", "\\@imath");
defineSymbol(math$1, main$3, mathord, "", "\\@jmath");
defineSymbol(math$1, main$3, textord, "ı", "ı");
defineSymbol(math$1, main$3, textord, "ȷ", "ȷ");
defineSymbol(text$7, main$3, textord, "ı", "\\i", !0);
defineSymbol(text$7, main$3, textord, "ȷ", "\\j", !0);
defineSymbol(text$7, main$3, textord, "ß", "\\ss", !0);
defineSymbol(text$7, main$3, textord, "æ", "\\ae", !0);
defineSymbol(text$7, main$3, textord, "œ", "\\oe", !0);
defineSymbol(text$7, main$3, textord, "ø", "\\o", !0);
defineSymbol(text$7, main$3, textord, "Æ", "\\AE", !0);
defineSymbol(text$7, main$3, textord, "Œ", "\\OE", !0);
defineSymbol(text$7, main$3, textord, "Ø", "\\O", !0);
defineSymbol(text$7, main$3, accent, "ˊ", "\\'");
defineSymbol(text$7, main$3, accent, "ˋ", "\\`");
defineSymbol(text$7, main$3, accent, "ˆ", "\\^");
defineSymbol(text$7, main$3, accent, "˜", "\\~");
defineSymbol(text$7, main$3, accent, "ˉ", "\\=");
defineSymbol(text$7, main$3, accent, "˘", "\\u");
defineSymbol(text$7, main$3, accent, "˙", "\\.");
defineSymbol(text$7, main$3, accent, "¸", "\\c");
defineSymbol(text$7, main$3, accent, "˚", "\\r");
defineSymbol(text$7, main$3, accent, "ˇ", "\\v");
defineSymbol(text$7, main$3, accent, "¨", '\\"');
defineSymbol(text$7, main$3, accent, "˝", "\\H");
defineSymbol(text$7, main$3, accent, "◯", "\\textcircled");
var ligatures = {
  "--": !0,
  "---": !0,
  "``": !0,
  "''": !0
};
defineSymbol(text$7, main$3, textord, "–", "--", !0);
defineSymbol(text$7, main$3, textord, "–", "\\textendash");
defineSymbol(text$7, main$3, textord, "—", "---", !0);
defineSymbol(text$7, main$3, textord, "—", "\\textemdash");
defineSymbol(text$7, main$3, textord, "‘", "`", !0);
defineSymbol(text$7, main$3, textord, "‘", "\\textquoteleft");
defineSymbol(text$7, main$3, textord, "’", "'", !0);
defineSymbol(text$7, main$3, textord, "’", "\\textquoteright");
defineSymbol(text$7, main$3, textord, "“", "``", !0);
defineSymbol(text$7, main$3, textord, "“", "\\textquotedblleft");
defineSymbol(text$7, main$3, textord, "”", "''", !0);
defineSymbol(text$7, main$3, textord, "”", "\\textquotedblright");
defineSymbol(math$1, main$3, textord, "°", "\\degree", !0);
defineSymbol(text$7, main$3, textord, "°", "\\degree");
defineSymbol(text$7, main$3, textord, "°", "\\textdegree", !0);
defineSymbol(math$1, main$3, textord, "£", "\\pounds");
defineSymbol(math$1, main$3, textord, "£", "\\mathsterling", !0);
defineSymbol(text$7, main$3, textord, "£", "\\pounds");
defineSymbol(text$7, main$3, textord, "£", "\\textsterling", !0);
defineSymbol(math$1, ams, textord, "✠", "\\maltese");
defineSymbol(text$7, ams, textord, "✠", "\\maltese");
var mathTextSymbols = '0123456789/@."';
for (var i$1 = 0; i$1 < mathTextSymbols.length; i$1++) {
  var ch$1 = mathTextSymbols.charAt(i$1);
  defineSymbol(math$1, main$3, textord, ch$1, ch$1);
}
var textSymbols = '0123456789!@*()-=+";:?/.,';
for (var _i = 0; _i < textSymbols.length; _i++) {
  var _ch = textSymbols.charAt(_i);
  defineSymbol(text$7, main$3, textord, _ch, _ch);
}
var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
for (var _i2 = 0; _i2 < letters.length; _i2++) {
  var _ch2 = letters.charAt(_i2);
  defineSymbol(math$1, main$3, mathord, _ch2, _ch2), defineSymbol(text$7, main$3, textord, _ch2, _ch2);
}
defineSymbol(math$1, ams, textord, "C", "ℂ");
defineSymbol(text$7, ams, textord, "C", "ℂ");
defineSymbol(math$1, ams, textord, "H", "ℍ");
defineSymbol(text$7, ams, textord, "H", "ℍ");
defineSymbol(math$1, ams, textord, "N", "ℕ");
defineSymbol(text$7, ams, textord, "N", "ℕ");
defineSymbol(math$1, ams, textord, "P", "ℙ");
defineSymbol(text$7, ams, textord, "P", "ℙ");
defineSymbol(math$1, ams, textord, "Q", "ℚ");
defineSymbol(text$7, ams, textord, "Q", "ℚ");
defineSymbol(math$1, ams, textord, "R", "ℝ");
defineSymbol(text$7, ams, textord, "R", "ℝ");
defineSymbol(math$1, ams, textord, "Z", "ℤ");
defineSymbol(text$7, ams, textord, "Z", "ℤ");
defineSymbol(math$1, main$3, mathord, "h", "ℎ");
defineSymbol(text$7, main$3, mathord, "h", "ℎ");
var wideChar = "";
for (var _i3 = 0; _i3 < letters.length; _i3++) {
  var _ch3 = letters.charAt(_i3);
  wideChar = String.fromCharCode(55349, 56320 + _i3), defineSymbol(math$1, main$3, mathord, _ch3, wideChar), defineSymbol(text$7, main$3, textord, _ch3, wideChar), wideChar = String.fromCharCode(55349, 56372 + _i3), defineSymbol(math$1, main$3, mathord, _ch3, wideChar), defineSymbol(text$7, main$3, textord, _ch3, wideChar), wideChar = String.fromCharCode(55349, 56424 + _i3), defineSymbol(math$1, main$3, mathord, _ch3, wideChar), defineSymbol(text$7, main$3, textord, _ch3, wideChar), wideChar = String.fromCharCode(55349, 56580 + _i3), defineSymbol(math$1, main$3, mathord, _ch3, wideChar), defineSymbol(text$7, main$3, textord, _ch3, wideChar), wideChar = String.fromCharCode(55349, 56684 + _i3), defineSymbol(math$1, main$3, mathord, _ch3, wideChar), defineSymbol(text$7, main$3, textord, _ch3, wideChar), wideChar = String.fromCharCode(55349, 56736 + _i3), defineSymbol(math$1, main$3, mathord, _ch3, wideChar), defineSymbol(text$7, main$3, textord, _ch3, wideChar), wideChar = String.fromCharCode(55349, 56788 + _i3), defineSymbol(math$1, main$3, mathord, _ch3, wideChar), defineSymbol(text$7, main$3, textord, _ch3, wideChar), wideChar = String.fromCharCode(55349, 56840 + _i3), defineSymbol(math$1, main$3, mathord, _ch3, wideChar), defineSymbol(text$7, main$3, textord, _ch3, wideChar), wideChar = String.fromCharCode(55349, 56944 + _i3), defineSymbol(math$1, main$3, mathord, _ch3, wideChar), defineSymbol(text$7, main$3, textord, _ch3, wideChar), _i3 < 26 && (wideChar = String.fromCharCode(55349, 56632 + _i3), defineSymbol(math$1, main$3, mathord, _ch3, wideChar), defineSymbol(text$7, main$3, textord, _ch3, wideChar), wideChar = String.fromCharCode(55349, 56476 + _i3), defineSymbol(math$1, main$3, mathord, _ch3, wideChar), defineSymbol(text$7, main$3, textord, _ch3, wideChar));
}
wideChar = "𝕜";
defineSymbol(math$1, main$3, mathord, "k", wideChar);
defineSymbol(text$7, main$3, textord, "k", wideChar);
for (var _i4 = 0; _i4 < 10; _i4++) {
  var _ch4 = _i4.toString();
  wideChar = String.fromCharCode(55349, 57294 + _i4), defineSymbol(math$1, main$3, mathord, _ch4, wideChar), defineSymbol(text$7, main$3, textord, _ch4, wideChar), wideChar = String.fromCharCode(55349, 57314 + _i4), defineSymbol(math$1, main$3, mathord, _ch4, wideChar), defineSymbol(text$7, main$3, textord, _ch4, wideChar), wideChar = String.fromCharCode(55349, 57324 + _i4), defineSymbol(math$1, main$3, mathord, _ch4, wideChar), defineSymbol(text$7, main$3, textord, _ch4, wideChar), wideChar = String.fromCharCode(55349, 57334 + _i4), defineSymbol(math$1, main$3, mathord, _ch4, wideChar), defineSymbol(text$7, main$3, textord, _ch4, wideChar);
}
var extraLatin = "ÐÞþ";
for (var _i5 = 0; _i5 < extraLatin.length; _i5++) {
  var _ch5 = extraLatin.charAt(_i5);
  defineSymbol(math$1, main$3, mathord, _ch5, _ch5), defineSymbol(text$7, main$3, textord, _ch5, _ch5);
}
var wideLatinLetterData = [
  ["mathbf", "textbf", "Main-Bold"],
  // A-Z bold upright
  ["mathbf", "textbf", "Main-Bold"],
  // a-z bold upright
  ["mathnormal", "textit", "Math-Italic"],
  // A-Z italic
  ["mathnormal", "textit", "Math-Italic"],
  // a-z italic
  ["boldsymbol", "boldsymbol", "Main-BoldItalic"],
  // A-Z bold italic
  ["boldsymbol", "boldsymbol", "Main-BoldItalic"],
  // a-z bold italic
  // Map fancy A-Z letters to script, not calligraphic.
  // This aligns with unicode-math and math fonts (except Cambria Math).
  ["mathscr", "textscr", "Script-Regular"],
  // A-Z script
  ["", "", ""],
  // a-z script.  No font
  ["", "", ""],
  // A-Z bold script. No font
  ["", "", ""],
  // a-z bold script. No font
  ["mathfrak", "textfrak", "Fraktur-Regular"],
  // A-Z Fraktur
  ["mathfrak", "textfrak", "Fraktur-Regular"],
  // a-z Fraktur
  ["mathbb", "textbb", "AMS-Regular"],
  // A-Z double-struck
  ["mathbb", "textbb", "AMS-Regular"],
  // k double-struck
  // Note that we are using a bold font, but font metrics for regular Fraktur.
  ["mathboldfrak", "textboldfrak", "Fraktur-Regular"],
  // A-Z bold Fraktur
  ["mathboldfrak", "textboldfrak", "Fraktur-Regular"],
  // a-z bold Fraktur
  ["mathsf", "textsf", "SansSerif-Regular"],
  // A-Z sans-serif
  ["mathsf", "textsf", "SansSerif-Regular"],
  // a-z sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // A-Z bold sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // a-z bold sans-serif
  ["mathitsf", "textitsf", "SansSerif-Italic"],
  // A-Z italic sans-serif
  ["mathitsf", "textitsf", "SansSerif-Italic"],
  // a-z italic sans-serif
  ["", "", ""],
  // A-Z bold italic sans. No font
  ["", "", ""],
  // a-z bold italic sans. No font
  ["mathtt", "texttt", "Typewriter-Regular"],
  // A-Z monospace
  ["mathtt", "texttt", "Typewriter-Regular"]
  // a-z monospace
], wideNumeralData = [
  ["mathbf", "textbf", "Main-Bold"],
  // 0-9 bold
  ["", "", ""],
  // 0-9 double-struck. No KaTeX font.
  ["mathsf", "textsf", "SansSerif-Regular"],
  // 0-9 sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // 0-9 bold sans-serif
  ["mathtt", "texttt", "Typewriter-Regular"]
  // 0-9 monospace
], wideCharacterFont = function n(t, g) {
  var d = t.charCodeAt(0), k = t.charCodeAt(1), H = (d - 55296) * 1024 + (k - 56320) + 65536, AA = g === "math" ? 0 : 1;
  if (119808 <= H && H < 120484) {
    var gA = Math.floor((H - 119808) / 26);
    return [wideLatinLetterData[gA][2], wideLatinLetterData[gA][AA]];
  } else if (120782 <= H && H <= 120831) {
    var IA = Math.floor((H - 120782) / 10);
    return [wideNumeralData[IA][2], wideNumeralData[IA][AA]];
  } else {
    if (H === 120485 || H === 120486)
      return [wideLatinLetterData[0][2], wideLatinLetterData[0][AA]];
    if (120486 < H && H < 120782)
      return ["", ""];
    throw new ParseError("Unsupported character: " + t);
  }
}, lookupSymbol = function n(t, g, d) {
  return symbols$4[d][t] && symbols$4[d][t].replace && (t = symbols$4[d][t].replace), {
    value: t,
    metrics: getCharacterMetrics(t, g, d)
  };
}, makeSymbol = function n(t, g, d, k, H) {
  var AA = lookupSymbol(t, g, d), gA = AA.metrics;
  t = AA.value;
  var IA;
  if (gA) {
    var CA = gA.italic;
    (d === "text" || k && k.font === "mathit") && (CA = 0), IA = new SymbolNode(t, gA.height, gA.depth, CA, gA.skew, gA.width, H);
  } else
    typeof console < "u" && console.warn("No character metrics " + ("for '" + t + "' in style '" + g + "' and mode '" + d + "'")), IA = new SymbolNode(t, 0, 0, 0, 0, 0, H);
  if (k) {
    IA.maxFontSize = k.sizeMultiplier, k.style.isTight() && IA.classes.push("mtight");
    var BA = k.getColor();
    BA && (IA.style.color = BA);
  }
  return IA;
}, mathsym = function n(t, g, d, k) {
  return k === void 0 && (k = []), d.font === "boldsymbol" && lookupSymbol(t, "Main-Bold", g).metrics ? makeSymbol(t, "Main-Bold", g, d, k.concat(["mathbf"])) : t === "\\" || symbols$4[g][t].font === "main" ? makeSymbol(t, "Main-Regular", g, d, k) : makeSymbol(t, "AMS-Regular", g, d, k.concat(["amsrm"]));
}, boldsymbol = function n(t, g, d, k, H) {
  return H !== "textord" && lookupSymbol(t, "Math-BoldItalic", g).metrics ? {
    fontName: "Math-BoldItalic",
    fontClass: "boldsymbol"
  } : {
    fontName: "Main-Bold",
    fontClass: "mathbf"
  };
}, makeOrd = function n(t, g, d) {
  var k = t.mode, H = t.text, AA = ["mord"], gA = k === "math" || k === "text" && g.font, IA = gA ? g.font : g.fontFamily, CA = "", BA = "";
  if (H.charCodeAt(0) === 55349 && ([CA, BA] = wideCharacterFont(H, k)), CA.length > 0)
    return makeSymbol(H, CA, k, g, AA.concat(BA));
  if (IA) {
    var eA, iA;
    if (IA === "boldsymbol") {
      var QA = boldsymbol(H, k, g, AA, d);
      eA = QA.fontName, iA = [QA.fontClass];
    } else gA ? (eA = fontMap[IA].fontName, iA = [IA]) : (eA = retrieveTextFontName(IA, g.fontWeight, g.fontShape), iA = [IA, g.fontWeight, g.fontShape]);
    if (lookupSymbol(H, eA, k).metrics)
      return makeSymbol(H, eA, k, g, AA.concat(iA));
    if (ligatures.hasOwnProperty(H) && eA.slice(0, 10) === "Typewriter") {
      for (var tA = [], oA = 0; oA < H.length; oA++)
        tA.push(makeSymbol(H[oA], eA, k, g, AA.concat(iA)));
      return makeFragment(tA);
    }
  }
  if (d === "mathord")
    return makeSymbol(H, "Math-Italic", k, g, AA.concat(["mathnormal"]));
  if (d === "textord") {
    var EA = symbols$4[k][H] && symbols$4[k][H].font;
    if (EA === "ams") {
      var aA = retrieveTextFontName("amsrm", g.fontWeight, g.fontShape);
      return makeSymbol(H, aA, k, g, AA.concat("amsrm", g.fontWeight, g.fontShape));
    } else if (EA === "main" || !EA) {
      var nA = retrieveTextFontName("textrm", g.fontWeight, g.fontShape);
      return makeSymbol(H, nA, k, g, AA.concat(g.fontWeight, g.fontShape));
    } else {
      var lA = retrieveTextFontName(EA, g.fontWeight, g.fontShape);
      return makeSymbol(H, lA, k, g, AA.concat(lA, g.fontWeight, g.fontShape));
    }
  } else
    throw new Error("unexpected type: " + d + " in makeOrd");
}, canCombine = (n, t) => {
  if (createClass(n.classes) !== createClass(t.classes) || n.skew !== t.skew || n.maxFontSize !== t.maxFontSize)
    return !1;
  if (n.classes.length === 1) {
    var g = n.classes[0];
    if (g === "mbin" || g === "mord")
      return !1;
  }
  for (var d in n.style)
    if (n.style.hasOwnProperty(d) && n.style[d] !== t.style[d])
      return !1;
  for (var k in t.style)
    if (t.style.hasOwnProperty(k) && n.style[k] !== t.style[k])
      return !1;
  return !0;
}, tryCombineChars = (n) => {
  for (var t = 0; t < n.length - 1; t++) {
    var g = n[t], d = n[t + 1];
    g instanceof SymbolNode && d instanceof SymbolNode && canCombine(g, d) && (g.text += d.text, g.height = Math.max(g.height, d.height), g.depth = Math.max(g.depth, d.depth), g.italic = d.italic, n.splice(t + 1, 1), t--);
  }
  return n;
}, sizeElementFromChildren = function n(t) {
  for (var g = 0, d = 0, k = 0, H = 0; H < t.children.length; H++) {
    var AA = t.children[H];
    AA.height > g && (g = AA.height), AA.depth > d && (d = AA.depth), AA.maxFontSize > k && (k = AA.maxFontSize);
  }
  t.height = g, t.depth = d, t.maxFontSize = k;
}, makeSpan$2 = function n(t, g, d, k) {
  var H = new Span(t, g, d, k);
  return sizeElementFromChildren(H), H;
}, makeSvgSpan = (n, t, g, d) => new Span(n, t, g, d), makeLineSpan = function n(t, g, d) {
  var k = makeSpan$2([t], [], g);
  return k.height = Math.max(d || g.fontMetrics().defaultRuleThickness, g.minRuleThickness), k.style.borderBottomWidth = makeEm(k.height), k.maxFontSize = 1, k;
}, makeAnchor = function n(t, g, d, k) {
  var H = new Anchor(t, g, d, k);
  return sizeElementFromChildren(H), H;
}, makeFragment = function n(t) {
  var g = new DocumentFragment(t);
  return sizeElementFromChildren(g), g;
}, wrapFragment = function n(t, g) {
  return t instanceof DocumentFragment ? makeSpan$2([], [t], g) : t;
}, getVListChildrenAndDepth = function n(t) {
  if (t.positionType === "individualShift") {
    for (var g = t.children, d = [g[0]], k = -g[0].shift - g[0].elem.depth, H = k, AA = 1; AA < g.length; AA++) {
      var gA = -g[AA].shift - H - g[AA].elem.depth, IA = gA - (g[AA - 1].elem.height + g[AA - 1].elem.depth);
      H = H + gA, d.push({
        type: "kern",
        size: IA
      }), d.push(g[AA]);
    }
    return {
      children: d,
      depth: k
    };
  }
  var CA;
  if (t.positionType === "top") {
    for (var BA = t.positionData, eA = 0; eA < t.children.length; eA++) {
      var iA = t.children[eA];
      BA -= iA.type === "kern" ? iA.size : iA.elem.height + iA.elem.depth;
    }
    CA = BA;
  } else if (t.positionType === "bottom")
    CA = -t.positionData;
  else {
    var QA = t.children[0];
    if (QA.type !== "elem")
      throw new Error('First child must have type "elem".');
    if (t.positionType === "shift")
      CA = -QA.elem.depth - t.positionData;
    else if (t.positionType === "firstBaseline")
      CA = -QA.elem.depth;
    else
      throw new Error("Invalid positionType " + t.positionType + ".");
  }
  return {
    children: t.children,
    depth: CA
  };
}, makeVList = function n(t, g) {
  for (var {
    children: d,
    depth: k
  } = getVListChildrenAndDepth(t), H = 0, AA = 0; AA < d.length; AA++) {
    var gA = d[AA];
    if (gA.type === "elem") {
      var IA = gA.elem;
      H = Math.max(H, IA.maxFontSize, IA.height);
    }
  }
  H += 2;
  var CA = makeSpan$2(["pstrut"], []);
  CA.style.height = makeEm(H);
  for (var BA = [], eA = k, iA = k, QA = k, tA = 0; tA < d.length; tA++) {
    var oA = d[tA];
    if (oA.type === "kern")
      QA += oA.size;
    else {
      var EA = oA.elem, aA = oA.wrapperClasses || [], nA = oA.wrapperStyle || {}, lA = makeSpan$2(aA, [CA, EA], void 0, nA);
      lA.style.top = makeEm(-H - QA - EA.depth), oA.marginLeft && (lA.style.marginLeft = oA.marginLeft), oA.marginRight && (lA.style.marginRight = oA.marginRight), BA.push(lA), QA += EA.height + EA.depth;
    }
    eA = Math.min(eA, QA), iA = Math.max(iA, QA);
  }
  var cA = makeSpan$2(["vlist"], BA);
  cA.style.height = makeEm(iA);
  var sA;
  if (eA < 0) {
    var rA = makeSpan$2([], []), uA = makeSpan$2(["vlist"], [rA]);
    uA.style.height = makeEm(-eA);
    var hA = makeSpan$2(["vlist-s"], [new SymbolNode("​")]);
    sA = [makeSpan$2(["vlist-r"], [cA, hA]), makeSpan$2(["vlist-r"], [uA])];
  } else
    sA = [makeSpan$2(["vlist-r"], [cA])];
  var dA = makeSpan$2(["vlist-t"], sA);
  return sA.length === 2 && dA.classes.push("vlist-t2"), dA.height = iA, dA.depth = -eA, dA;
}, makeGlue = (n, t) => {
  var g = makeSpan$2(["mspace"], [], t), d = calculateSize(n, t);
  return g.style.marginRight = makeEm(d), g;
}, retrieveTextFontName = function n(t, g, d) {
  var k = "";
  switch (t) {
    case "amsrm":
      k = "AMS";
      break;
    case "textrm":
      k = "Main";
      break;
    case "textsf":
      k = "SansSerif";
      break;
    case "texttt":
      k = "Typewriter";
      break;
    default:
      k = t;
  }
  var H;
  return g === "textbf" && d === "textit" ? H = "BoldItalic" : g === "textbf" ? H = "Bold" : g === "textit" ? H = "Italic" : H = "Regular", k + "-" + H;
}, fontMap = {
  // styles
  mathbf: {
    variant: "bold",
    fontName: "Main-Bold"
  },
  mathrm: {
    variant: "normal",
    fontName: "Main-Regular"
  },
  textit: {
    variant: "italic",
    fontName: "Main-Italic"
  },
  mathit: {
    variant: "italic",
    fontName: "Main-Italic"
  },
  mathnormal: {
    variant: "italic",
    fontName: "Math-Italic"
  },
  mathsfit: {
    variant: "sans-serif-italic",
    fontName: "SansSerif-Italic"
  },
  // "boldsymbol" is missing because they require the use of multiple fonts:
  // Math-BoldItalic and Main-Bold.  This is handled by a special case in
  // makeOrd which ends up calling boldsymbol.
  // families
  mathbb: {
    variant: "double-struck",
    fontName: "AMS-Regular"
  },
  mathcal: {
    variant: "script",
    fontName: "Caligraphic-Regular"
  },
  mathfrak: {
    variant: "fraktur",
    fontName: "Fraktur-Regular"
  },
  mathscr: {
    variant: "script",
    fontName: "Script-Regular"
  },
  mathsf: {
    variant: "sans-serif",
    fontName: "SansSerif-Regular"
  },
  mathtt: {
    variant: "monospace",
    fontName: "Typewriter-Regular"
  }
}, svgData = {
  //   path, width, height
  vec: ["vec", 0.471, 0.714],
  // values from the font glyph
  oiintSize1: ["oiintSize1", 0.957, 0.499],
  // oval to overlay the integrand
  oiintSize2: ["oiintSize2", 1.472, 0.659],
  oiiintSize1: ["oiiintSize1", 1.304, 0.499],
  oiiintSize2: ["oiiintSize2", 1.98, 0.659]
}, staticSvg = function n(t, g) {
  var [d, k, H] = svgData[t], AA = new PathNode(d), gA = new SvgNode([AA], {
    width: makeEm(k),
    height: makeEm(H),
    // Override CSS rule `.katex svg { width: 100% }`
    style: "width:" + makeEm(k),
    viewBox: "0 0 " + 1e3 * k + " " + 1e3 * H,
    preserveAspectRatio: "xMinYMin"
  }), IA = makeSvgSpan(["overlay"], [gA], g);
  return IA.height = H, IA.style.height = makeEm(H), IA.style.width = makeEm(k), IA;
}, buildCommon = {
  fontMap,
  makeSymbol,
  mathsym,
  makeSpan: makeSpan$2,
  makeSvgSpan,
  makeLineSpan,
  makeAnchor,
  makeFragment,
  wrapFragment,
  makeVList,
  makeOrd,
  makeGlue,
  staticSvg,
  svgData,
  tryCombineChars
}, thinspace = {
  number: 3,
  unit: "mu"
}, mediumspace = {
  number: 4,
  unit: "mu"
}, thickspace = {
  number: 5,
  unit: "mu"
}, spacings = {
  mord: {
    mop: thinspace,
    mbin: mediumspace,
    mrel: thickspace,
    minner: thinspace
  },
  mop: {
    mord: thinspace,
    mop: thinspace,
    mrel: thickspace,
    minner: thinspace
  },
  mbin: {
    mord: mediumspace,
    mop: mediumspace,
    mopen: mediumspace,
    minner: mediumspace
  },
  mrel: {
    mord: thickspace,
    mop: thickspace,
    mopen: thickspace,
    minner: thickspace
  },
  mopen: {},
  mclose: {
    mop: thinspace,
    mbin: mediumspace,
    mrel: thickspace,
    minner: thinspace
  },
  mpunct: {
    mord: thinspace,
    mop: thinspace,
    mrel: thickspace,
    mopen: thinspace,
    mclose: thinspace,
    mpunct: thinspace,
    minner: thinspace
  },
  minner: {
    mord: thinspace,
    mop: thinspace,
    mbin: mediumspace,
    mrel: thickspace,
    mopen: thinspace,
    mpunct: thinspace,
    minner: thinspace
  }
}, tightSpacings = {
  mord: {
    mop: thinspace
  },
  mop: {
    mord: thinspace,
    mop: thinspace
  },
  mbin: {},
  mrel: {},
  mopen: {},
  mclose: {
    mop: thinspace
  },
  mpunct: {},
  minner: {
    mop: thinspace
  }
}, _functions = {}, _htmlGroupBuilders = {}, _mathmlGroupBuilders = {};
function defineFunction(n) {
  for (var {
    type: t,
    names: g,
    props: d,
    handler: k,
    htmlBuilder: H,
    mathmlBuilder: AA
  } = n, gA = {
    type: t,
    numArgs: d.numArgs,
    argTypes: d.argTypes,
    allowedInArgument: !!d.allowedInArgument,
    allowedInText: !!d.allowedInText,
    allowedInMath: d.allowedInMath === void 0 ? !0 : d.allowedInMath,
    numOptionalArgs: d.numOptionalArgs || 0,
    infix: !!d.infix,
    primitive: !!d.primitive,
    handler: k
  }, IA = 0; IA < g.length; ++IA)
    _functions[g[IA]] = gA;
  t && (H && (_htmlGroupBuilders[t] = H), AA && (_mathmlGroupBuilders[t] = AA));
}
function defineFunctionBuilders(n) {
  var {
    type: t,
    htmlBuilder: g,
    mathmlBuilder: d
  } = n;
  defineFunction({
    type: t,
    names: [],
    props: {
      numArgs: 0
    },
    handler() {
      throw new Error("Should never be called.");
    },
    htmlBuilder: g,
    mathmlBuilder: d
  });
}
var normalizeArgument = function n(t) {
  return t.type === "ordgroup" && t.body.length === 1 ? t.body[0] : t;
}, ordargument = function n(t) {
  return t.type === "ordgroup" ? t.body : [t];
}, makeSpan$1 = buildCommon.makeSpan, binLeftCanceller = ["leftmost", "mbin", "mopen", "mrel", "mop", "mpunct"], binRightCanceller = ["rightmost", "mrel", "mclose", "mpunct"], styleMap$1 = {
  display: Style$1.DISPLAY,
  text: Style$1.TEXT,
  script: Style$1.SCRIPT,
  scriptscript: Style$1.SCRIPTSCRIPT
}, DomEnum = {
  mord: "mord",
  mop: "mop",
  mbin: "mbin",
  mrel: "mrel",
  mopen: "mopen",
  mclose: "mclose",
  mpunct: "mpunct",
  minner: "minner"
}, buildExpression$1 = function n(t, g, d, k) {
  k === void 0 && (k = [null, null]);
  for (var H = [], AA = 0; AA < t.length; AA++) {
    var gA = buildGroup$1(t[AA], g);
    if (gA instanceof DocumentFragment) {
      var IA = gA.children;
      H.push(...IA);
    } else
      H.push(gA);
  }
  if (buildCommon.tryCombineChars(H), !d)
    return H;
  var CA = g;
  if (t.length === 1) {
    var BA = t[0];
    BA.type === "sizing" ? CA = g.havingSize(BA.size) : BA.type === "styling" && (CA = g.havingStyle(styleMap$1[BA.style]));
  }
  var eA = makeSpan$1([k[0] || "leftmost"], [], g), iA = makeSpan$1([k[1] || "rightmost"], [], g), QA = d === "root";
  return traverseNonSpaceNodes(H, (tA, oA) => {
    var EA = oA.classes[0], aA = tA.classes[0];
    EA === "mbin" && binRightCanceller.includes(aA) ? oA.classes[0] = "mord" : aA === "mbin" && binLeftCanceller.includes(EA) && (tA.classes[0] = "mord");
  }, {
    node: eA
  }, iA, QA), traverseNonSpaceNodes(H, (tA, oA) => {
    var EA = getTypeOfDomTree(oA), aA = getTypeOfDomTree(tA), nA = EA && aA ? tA.hasClass("mtight") ? tightSpacings[EA][aA] : spacings[EA][aA] : null;
    if (nA)
      return buildCommon.makeGlue(nA, CA);
  }, {
    node: eA
  }, iA, QA), H;
}, traverseNonSpaceNodes = function n(t, g, d, k, H) {
  k && t.push(k);
  for (var AA = 0; AA < t.length; AA++) {
    var gA = t[AA], IA = checkPartialGroup(gA);
    if (IA) {
      n(IA.children, g, d, null, H);
      continue;
    }
    var CA = !gA.hasClass("mspace");
    if (CA) {
      var BA = g(gA, d.node);
      BA && (d.insertAfter ? d.insertAfter(BA) : (t.unshift(BA), AA++));
    }
    CA ? d.node = gA : H && gA.hasClass("newline") && (d.node = makeSpan$1(["leftmost"])), d.insertAfter = /* @__PURE__ */ ((eA) => (iA) => {
      t.splice(eA + 1, 0, iA), AA++;
    })(AA);
  }
  k && t.pop();
}, checkPartialGroup = function n(t) {
  return t instanceof DocumentFragment || t instanceof Anchor || t instanceof Span && t.hasClass("enclosing") ? t : null;
}, getOutermostNode = function n(t, g) {
  var d = checkPartialGroup(t);
  if (d) {
    var k = d.children;
    if (k.length) {
      if (g === "right")
        return n(k[k.length - 1], "right");
      if (g === "left")
        return n(k[0], "left");
    }
  }
  return t;
}, getTypeOfDomTree = function n(t, g) {
  return t ? (g && (t = getOutermostNode(t, g)), DomEnum[t.classes[0]] || null) : null;
}, makeNullDelimiter = function n(t, g) {
  var d = ["nulldelimiter"].concat(t.baseSizingClasses());
  return makeSpan$1(g.concat(d));
}, buildGroup$1 = function n(t, g, d) {
  if (!t)
    return makeSpan$1();
  if (_htmlGroupBuilders[t.type]) {
    var k = _htmlGroupBuilders[t.type](t, g);
    if (d && g.size !== d.size) {
      k = makeSpan$1(g.sizingClasses(d), [k], g);
      var H = g.sizeMultiplier / d.sizeMultiplier;
      k.height *= H, k.depth *= H;
    }
    return k;
  } else
    throw new ParseError("Got group of unknown type: '" + t.type + "'");
};
function buildHTMLUnbreakable(n, t) {
  var g = makeSpan$1(["base"], n, t), d = makeSpan$1(["strut"]);
  return d.style.height = makeEm(g.height + g.depth), g.depth && (d.style.verticalAlign = makeEm(-g.depth)), g.children.unshift(d), g;
}
function buildHTML(n, t) {
  var g = null;
  n.length === 1 && n[0].type === "tag" && (g = n[0].tag, n = n[0].body);
  var d = buildExpression$1(n, t, "root"), k;
  d.length === 2 && d[1].hasClass("tag") && (k = d.pop());
  for (var H = [], AA = [], gA = 0; gA < d.length; gA++)
    if (AA.push(d[gA]), d[gA].hasClass("mbin") || d[gA].hasClass("mrel") || d[gA].hasClass("allowbreak")) {
      for (var IA = !1; gA < d.length - 1 && d[gA + 1].hasClass("mspace") && !d[gA + 1].hasClass("newline"); )
        gA++, AA.push(d[gA]), d[gA].hasClass("nobreak") && (IA = !0);
      IA || (H.push(buildHTMLUnbreakable(AA, t)), AA = []);
    } else d[gA].hasClass("newline") && (AA.pop(), AA.length > 0 && (H.push(buildHTMLUnbreakable(AA, t)), AA = []), H.push(d[gA]));
  AA.length > 0 && H.push(buildHTMLUnbreakable(AA, t));
  var CA;
  g ? (CA = buildHTMLUnbreakable(buildExpression$1(g, t, !0)), CA.classes = ["tag"], H.push(CA)) : k && H.push(k);
  var BA = makeSpan$1(["katex-html"], H);
  if (BA.setAttribute("aria-hidden", "true"), CA) {
    var eA = CA.children[0];
    eA.style.height = makeEm(BA.height + BA.depth), BA.depth && (eA.style.verticalAlign = makeEm(-BA.depth));
  }
  return BA;
}
function newDocumentFragment(n) {
  return new DocumentFragment(n);
}
class MathNode {
  constructor(t, g, d) {
    this.type = void 0, this.attributes = void 0, this.children = void 0, this.classes = void 0, this.type = t, this.attributes = {}, this.children = g || [], this.classes = d || [];
  }
  /**
   * Sets an attribute on a MathML node. MathML depends on attributes to convey a
   * semantic content, so this is used heavily.
   */
  setAttribute(t, g) {
    this.attributes[t] = g;
  }
  /**
   * Gets an attribute on a MathML node.
   */
  getAttribute(t) {
    return this.attributes[t];
  }
  /**
   * Converts the math node into a MathML-namespaced DOM element.
   */
  toNode() {
    var t = document.createElementNS("http://www.w3.org/1998/Math/MathML", this.type);
    for (var g in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, g) && t.setAttribute(g, this.attributes[g]);
    this.classes.length > 0 && (t.className = createClass(this.classes));
    for (var d = 0; d < this.children.length; d++)
      if (this.children[d] instanceof TextNode && this.children[d + 1] instanceof TextNode) {
        for (var k = this.children[d].toText() + this.children[++d].toText(); this.children[d + 1] instanceof TextNode; )
          k += this.children[++d].toText();
        t.appendChild(new TextNode(k).toNode());
      } else
        t.appendChild(this.children[d].toNode());
    return t;
  }
  /**
   * Converts the math node into an HTML markup string.
   */
  toMarkup() {
    var t = "<" + this.type;
    for (var g in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, g) && (t += " " + g + '="', t += utils$2.escape(this.attributes[g]), t += '"');
    this.classes.length > 0 && (t += ' class ="' + utils$2.escape(createClass(this.classes)) + '"'), t += ">";
    for (var d = 0; d < this.children.length; d++)
      t += this.children[d].toMarkup();
    return t += "</" + this.type + ">", t;
  }
  /**
   * Converts the math node into a string, similar to innerText, but escaped.
   */
  toText() {
    return this.children.map((t) => t.toText()).join("");
  }
}
class TextNode {
  constructor(t) {
    this.text = void 0, this.text = t;
  }
  /**
   * Converts the text node into a DOM text node.
   */
  toNode() {
    return document.createTextNode(this.text);
  }
  /**
   * Converts the text node into escaped HTML markup
   * (representing the text itself).
   */
  toMarkup() {
    return utils$2.escape(this.toText());
  }
  /**
   * Converts the text node into a string
   * (representing the text itself).
   */
  toText() {
    return this.text;
  }
}
class SpaceNode {
  /**
   * Create a Space node with width given in CSS ems.
   */
  constructor(t) {
    this.width = void 0, this.character = void 0, this.width = t, t >= 0.05555 && t <= 0.05556 ? this.character = " " : t >= 0.1666 && t <= 0.1667 ? this.character = " " : t >= 0.2222 && t <= 0.2223 ? this.character = " " : t >= 0.2777 && t <= 0.2778 ? this.character = "  " : t >= -0.05556 && t <= -0.05555 ? this.character = " ⁣" : t >= -0.1667 && t <= -0.1666 ? this.character = " ⁣" : t >= -0.2223 && t <= -0.2222 ? this.character = " ⁣" : t >= -0.2778 && t <= -0.2777 ? this.character = " ⁣" : this.character = null;
  }
  /**
   * Converts the math node into a MathML-namespaced DOM element.
   */
  toNode() {
    if (this.character)
      return document.createTextNode(this.character);
    var t = document.createElementNS("http://www.w3.org/1998/Math/MathML", "mspace");
    return t.setAttribute("width", makeEm(this.width)), t;
  }
  /**
   * Converts the math node into an HTML markup string.
   */
  toMarkup() {
    return this.character ? "<mtext>" + this.character + "</mtext>" : '<mspace width="' + makeEm(this.width) + '"/>';
  }
  /**
   * Converts the math node into a string, similar to innerText.
   */
  toText() {
    return this.character ? this.character : " ";
  }
}
var mathMLTree = {
  MathNode,
  TextNode,
  SpaceNode,
  newDocumentFragment
}, makeText = function n(t, g, d) {
  return symbols$4[g][t] && symbols$4[g][t].replace && t.charCodeAt(0) !== 55349 && !(ligatures.hasOwnProperty(t) && d && (d.fontFamily && d.fontFamily.slice(4, 6) === "tt" || d.font && d.font.slice(4, 6) === "tt")) && (t = symbols$4[g][t].replace), new mathMLTree.TextNode(t);
}, makeRow = function n(t) {
  return t.length === 1 ? t[0] : new mathMLTree.MathNode("mrow", t);
}, getVariant = function n(t, g) {
  if (g.fontFamily === "texttt")
    return "monospace";
  if (g.fontFamily === "textsf")
    return g.fontShape === "textit" && g.fontWeight === "textbf" ? "sans-serif-bold-italic" : g.fontShape === "textit" ? "sans-serif-italic" : g.fontWeight === "textbf" ? "bold-sans-serif" : "sans-serif";
  if (g.fontShape === "textit" && g.fontWeight === "textbf")
    return "bold-italic";
  if (g.fontShape === "textit")
    return "italic";
  if (g.fontWeight === "textbf")
    return "bold";
  var d = g.font;
  if (!d || d === "mathnormal")
    return null;
  var k = t.mode;
  if (d === "mathit")
    return "italic";
  if (d === "boldsymbol")
    return t.type === "textord" ? "bold" : "bold-italic";
  if (d === "mathbf")
    return "bold";
  if (d === "mathbb")
    return "double-struck";
  if (d === "mathsfit")
    return "sans-serif-italic";
  if (d === "mathfrak")
    return "fraktur";
  if (d === "mathscr" || d === "mathcal")
    return "script";
  if (d === "mathsf")
    return "sans-serif";
  if (d === "mathtt")
    return "monospace";
  var H = t.text;
  if (["\\imath", "\\jmath"].includes(H))
    return null;
  symbols$4[k][H] && symbols$4[k][H].replace && (H = symbols$4[k][H].replace);
  var AA = buildCommon.fontMap[d].fontName;
  return getCharacterMetrics(H, AA, k) ? buildCommon.fontMap[d].variant : null;
};
function isNumberPunctuation(n) {
  if (!n)
    return !1;
  if (n.type === "mi" && n.children.length === 1) {
    var t = n.children[0];
    return t instanceof TextNode && t.text === ".";
  } else if (n.type === "mo" && n.children.length === 1 && n.getAttribute("separator") === "true" && n.getAttribute("lspace") === "0em" && n.getAttribute("rspace") === "0em") {
    var g = n.children[0];
    return g instanceof TextNode && g.text === ",";
  } else
    return !1;
}
var buildExpression = function n(t, g, d) {
  if (t.length === 1) {
    var k = buildGroup(t[0], g);
    return d && k instanceof MathNode && k.type === "mo" && (k.setAttribute("lspace", "0em"), k.setAttribute("rspace", "0em")), [k];
  }
  for (var H = [], AA, gA = 0; gA < t.length; gA++) {
    var IA = buildGroup(t[gA], g);
    if (IA instanceof MathNode && AA instanceof MathNode) {
      if (IA.type === "mtext" && AA.type === "mtext" && IA.getAttribute("mathvariant") === AA.getAttribute("mathvariant")) {
        AA.children.push(...IA.children);
        continue;
      } else if (IA.type === "mn" && AA.type === "mn") {
        AA.children.push(...IA.children);
        continue;
      } else if (isNumberPunctuation(IA) && AA.type === "mn") {
        AA.children.push(...IA.children);
        continue;
      } else if (IA.type === "mn" && isNumberPunctuation(AA))
        IA.children = [...AA.children, ...IA.children], H.pop();
      else if ((IA.type === "msup" || IA.type === "msub") && IA.children.length >= 1 && (AA.type === "mn" || isNumberPunctuation(AA))) {
        var CA = IA.children[0];
        CA instanceof MathNode && CA.type === "mn" && (CA.children = [...AA.children, ...CA.children], H.pop());
      } else if (AA.type === "mi" && AA.children.length === 1) {
        var BA = AA.children[0];
        if (BA instanceof TextNode && BA.text === "̸" && (IA.type === "mo" || IA.type === "mi" || IA.type === "mn")) {
          var eA = IA.children[0];
          eA instanceof TextNode && eA.text.length > 0 && (eA.text = eA.text.slice(0, 1) + "̸" + eA.text.slice(1), H.pop());
        }
      }
    }
    H.push(IA), AA = IA;
  }
  return H;
}, buildExpressionRow = function n(t, g, d) {
  return makeRow(buildExpression(t, g, d));
}, buildGroup = function n(t, g) {
  if (!t)
    return new mathMLTree.MathNode("mrow");
  if (_mathmlGroupBuilders[t.type]) {
    var d = _mathmlGroupBuilders[t.type](t, g);
    return d;
  } else
    throw new ParseError("Got group of unknown type: '" + t.type + "'");
};
function buildMathML(n, t, g, d, k) {
  var H = buildExpression(n, g), AA;
  H.length === 1 && H[0] instanceof MathNode && ["mrow", "mtable"].includes(H[0].type) ? AA = H[0] : AA = new mathMLTree.MathNode("mrow", H);
  var gA = new mathMLTree.MathNode("annotation", [new mathMLTree.TextNode(t)]);
  gA.setAttribute("encoding", "application/x-tex");
  var IA = new mathMLTree.MathNode("semantics", [AA, gA]), CA = new mathMLTree.MathNode("math", [IA]);
  CA.setAttribute("xmlns", "http://www.w3.org/1998/Math/MathML"), d && CA.setAttribute("display", "block");
  var BA = k ? "katex" : "katex-mathml";
  return buildCommon.makeSpan([BA], [CA]);
}
var optionsFromSettings = function n(t) {
  return new Options({
    style: t.displayMode ? Style$1.DISPLAY : Style$1.TEXT,
    maxSize: t.maxSize,
    minRuleThickness: t.minRuleThickness
  });
}, displayWrap = function n(t, g) {
  if (g.displayMode) {
    var d = ["katex-display"];
    g.leqno && d.push("leqno"), g.fleqn && d.push("fleqn"), t = buildCommon.makeSpan(d, [t]);
  }
  return t;
}, buildTree = function n(t, g, d) {
  var k = optionsFromSettings(d), H;
  if (d.output === "mathml")
    return buildMathML(t, g, k, d.displayMode, !0);
  if (d.output === "html") {
    var AA = buildHTML(t, k);
    H = buildCommon.makeSpan(["katex"], [AA]);
  } else {
    var gA = buildMathML(t, g, k, d.displayMode, !1), IA = buildHTML(t, k);
    H = buildCommon.makeSpan(["katex"], [gA, IA]);
  }
  return displayWrap(H, d);
}, buildHTMLTree = function n(t, g, d) {
  var k = optionsFromSettings(d), H = buildHTML(t, k), AA = buildCommon.makeSpan(["katex"], [H]);
  return displayWrap(AA, d);
}, stretchyCodePoint = {
  widehat: "^",
  widecheck: "ˇ",
  widetilde: "~",
  utilde: "~",
  overleftarrow: "←",
  underleftarrow: "←",
  xleftarrow: "←",
  overrightarrow: "→",
  underrightarrow: "→",
  xrightarrow: "→",
  underbrace: "⏟",
  overbrace: "⏞",
  overgroup: "⏠",
  undergroup: "⏡",
  overleftrightarrow: "↔",
  underleftrightarrow: "↔",
  xleftrightarrow: "↔",
  Overrightarrow: "⇒",
  xRightarrow: "⇒",
  overleftharpoon: "↼",
  xleftharpoonup: "↼",
  overrightharpoon: "⇀",
  xrightharpoonup: "⇀",
  xLeftarrow: "⇐",
  xLeftrightarrow: "⇔",
  xhookleftarrow: "↩",
  xhookrightarrow: "↪",
  xmapsto: "↦",
  xrightharpoondown: "⇁",
  xleftharpoondown: "↽",
  xrightleftharpoons: "⇌",
  xleftrightharpoons: "⇋",
  xtwoheadleftarrow: "↞",
  xtwoheadrightarrow: "↠",
  xlongequal: "=",
  xtofrom: "⇄",
  xrightleftarrows: "⇄",
  xrightequilibrium: "⇌",
  // Not a perfect match.
  xleftequilibrium: "⇋",
  // None better available.
  "\\cdrightarrow": "→",
  "\\cdleftarrow": "←",
  "\\cdlongequal": "="
}, mathMLnode = function n(t) {
  var g = new mathMLTree.MathNode("mo", [new mathMLTree.TextNode(stretchyCodePoint[t.replace(/^\\/, "")])]);
  return g.setAttribute("stretchy", "true"), g;
}, katexImagesData = {
  //   path(s), minWidth, height, align
  overrightarrow: [["rightarrow"], 0.888, 522, "xMaxYMin"],
  overleftarrow: [["leftarrow"], 0.888, 522, "xMinYMin"],
  underrightarrow: [["rightarrow"], 0.888, 522, "xMaxYMin"],
  underleftarrow: [["leftarrow"], 0.888, 522, "xMinYMin"],
  xrightarrow: [["rightarrow"], 1.469, 522, "xMaxYMin"],
  "\\cdrightarrow": [["rightarrow"], 3, 522, "xMaxYMin"],
  // CD minwwidth2.5pc
  xleftarrow: [["leftarrow"], 1.469, 522, "xMinYMin"],
  "\\cdleftarrow": [["leftarrow"], 3, 522, "xMinYMin"],
  Overrightarrow: [["doublerightarrow"], 0.888, 560, "xMaxYMin"],
  xRightarrow: [["doublerightarrow"], 1.526, 560, "xMaxYMin"],
  xLeftarrow: [["doubleleftarrow"], 1.526, 560, "xMinYMin"],
  overleftharpoon: [["leftharpoon"], 0.888, 522, "xMinYMin"],
  xleftharpoonup: [["leftharpoon"], 0.888, 522, "xMinYMin"],
  xleftharpoondown: [["leftharpoondown"], 0.888, 522, "xMinYMin"],
  overrightharpoon: [["rightharpoon"], 0.888, 522, "xMaxYMin"],
  xrightharpoonup: [["rightharpoon"], 0.888, 522, "xMaxYMin"],
  xrightharpoondown: [["rightharpoondown"], 0.888, 522, "xMaxYMin"],
  xlongequal: [["longequal"], 0.888, 334, "xMinYMin"],
  "\\cdlongequal": [["longequal"], 3, 334, "xMinYMin"],
  xtwoheadleftarrow: [["twoheadleftarrow"], 0.888, 334, "xMinYMin"],
  xtwoheadrightarrow: [["twoheadrightarrow"], 0.888, 334, "xMaxYMin"],
  overleftrightarrow: [["leftarrow", "rightarrow"], 0.888, 522],
  overbrace: [["leftbrace", "midbrace", "rightbrace"], 1.6, 548],
  underbrace: [["leftbraceunder", "midbraceunder", "rightbraceunder"], 1.6, 548],
  underleftrightarrow: [["leftarrow", "rightarrow"], 0.888, 522],
  xleftrightarrow: [["leftarrow", "rightarrow"], 1.75, 522],
  xLeftrightarrow: [["doubleleftarrow", "doublerightarrow"], 1.75, 560],
  xrightleftharpoons: [["leftharpoondownplus", "rightharpoonplus"], 1.75, 716],
  xleftrightharpoons: [["leftharpoonplus", "rightharpoondownplus"], 1.75, 716],
  xhookleftarrow: [["leftarrow", "righthook"], 1.08, 522],
  xhookrightarrow: [["lefthook", "rightarrow"], 1.08, 522],
  overlinesegment: [["leftlinesegment", "rightlinesegment"], 0.888, 522],
  underlinesegment: [["leftlinesegment", "rightlinesegment"], 0.888, 522],
  overgroup: [["leftgroup", "rightgroup"], 0.888, 342],
  undergroup: [["leftgroupunder", "rightgroupunder"], 0.888, 342],
  xmapsto: [["leftmapsto", "rightarrow"], 1.5, 522],
  xtofrom: [["leftToFrom", "rightToFrom"], 1.75, 528],
  // The next three arrows are from the mhchem package.
  // In mhchem.sty, min-length is 2.0em. But these arrows might appear in the
  // document as \xrightarrow or \xrightleftharpoons. Those have
  // min-length = 1.75em, so we set min-length on these next three to match.
  xrightleftarrows: [["baraboveleftarrow", "rightarrowabovebar"], 1.75, 901],
  xrightequilibrium: [["baraboveshortleftharpoon", "rightharpoonaboveshortbar"], 1.75, 716],
  xleftequilibrium: [["shortbaraboveleftharpoon", "shortrightharpoonabovebar"], 1.75, 716]
}, groupLength = function n(t) {
  return t.type === "ordgroup" ? t.body.length : 1;
}, svgSpan = function n(t, g) {
  function d() {
    var gA = 4e5, IA = t.label.slice(1);
    if (["widehat", "widecheck", "widetilde", "utilde"].includes(IA)) {
      var CA = t, BA = groupLength(CA.base), eA, iA, QA;
      if (BA > 5)
        IA === "widehat" || IA === "widecheck" ? (eA = 420, gA = 2364, QA = 0.42, iA = IA + "4") : (eA = 312, gA = 2340, QA = 0.34, iA = "tilde4");
      else {
        var tA = [1, 1, 2, 2, 3, 3][BA];
        IA === "widehat" || IA === "widecheck" ? (gA = [0, 1062, 2364, 2364, 2364][tA], eA = [0, 239, 300, 360, 420][tA], QA = [0, 0.24, 0.3, 0.3, 0.36, 0.42][tA], iA = IA + tA) : (gA = [0, 600, 1033, 2339, 2340][tA], eA = [0, 260, 286, 306, 312][tA], QA = [0, 0.26, 0.286, 0.3, 0.306, 0.34][tA], iA = "tilde" + tA);
      }
      var oA = new PathNode(iA), EA = new SvgNode([oA], {
        width: "100%",
        height: makeEm(QA),
        viewBox: "0 0 " + gA + " " + eA,
        preserveAspectRatio: "none"
      });
      return {
        span: buildCommon.makeSvgSpan([], [EA], g),
        minWidth: 0,
        height: QA
      };
    } else {
      var aA = [], nA = katexImagesData[IA], [lA, cA, sA] = nA, rA = sA / 1e3, uA = lA.length, hA, dA;
      if (uA === 1) {
        var GA = nA[3];
        hA = ["hide-tail"], dA = [GA];
      } else if (uA === 2)
        hA = ["halfarrow-left", "halfarrow-right"], dA = ["xMinYMin", "xMaxYMin"];
      else if (uA === 3)
        hA = ["brace-left", "brace-center", "brace-right"], dA = ["xMinYMin", "xMidYMin", "xMaxYMin"];
      else
        throw new Error(`Correct katexImagesData or update code here to support
                    ` + uA + " children.");
      for (var DA = 0; DA < uA; DA++) {
        var wA = new PathNode(lA[DA]), bA = new SvgNode([wA], {
          width: "400em",
          height: makeEm(rA),
          viewBox: "0 0 " + gA + " " + sA,
          preserveAspectRatio: dA[DA] + " slice"
        }), yA = buildCommon.makeSvgSpan([hA[DA]], [bA], g);
        if (uA === 1)
          return {
            span: yA,
            minWidth: cA,
            height: rA
          };
        yA.style.height = makeEm(rA), aA.push(yA);
      }
      return {
        span: buildCommon.makeSpan(["stretchy"], aA, g),
        minWidth: cA,
        height: rA
      };
    }
  }
  var {
    span: k,
    minWidth: H,
    height: AA
  } = d();
  return k.height = AA, k.style.height = makeEm(AA), H > 0 && (k.style.minWidth = makeEm(H)), k;
}, encloseSpan = function n(t, g, d, k, H) {
  var AA, gA = t.height + t.depth + d + k;
  if (/fbox|color|angl/.test(g)) {
    if (AA = buildCommon.makeSpan(["stretchy", g], [], H), g === "fbox") {
      var IA = H.color && H.getColor();
      IA && (AA.style.borderColor = IA);
    }
  } else {
    var CA = [];
    /^[bx]cancel$/.test(g) && CA.push(new LineNode({
      x1: "0",
      y1: "0",
      x2: "100%",
      y2: "100%",
      "stroke-width": "0.046em"
    })), /^x?cancel$/.test(g) && CA.push(new LineNode({
      x1: "0",
      y1: "100%",
      x2: "100%",
      y2: "0",
      "stroke-width": "0.046em"
    }));
    var BA = new SvgNode(CA, {
      width: "100%",
      height: makeEm(gA)
    });
    AA = buildCommon.makeSvgSpan([], [BA], H);
  }
  return AA.height = gA, AA.style.height = makeEm(gA), AA;
}, stretchy = {
  encloseSpan,
  mathMLnode,
  svgSpan
};
function assertNodeType(n, t) {
  if (!n || n.type !== t)
    throw new Error("Expected node of type " + t + ", but got " + (n ? "node of type " + n.type : String(n)));
  return n;
}
function assertSymbolNodeType(n) {
  var t = checkSymbolNodeType(n);
  if (!t)
    throw new Error("Expected node of symbol group type, but got " + (n ? "node of type " + n.type : String(n)));
  return t;
}
function checkSymbolNodeType(n) {
  return n && (n.type === "atom" || NON_ATOMS.hasOwnProperty(n.type)) ? n : null;
}
var htmlBuilder$a = (n, t) => {
  var g, d, k;
  n && n.type === "supsub" ? (d = assertNodeType(n.base, "accent"), g = d.base, n.base = g, k = assertSpan(buildGroup$1(n, t)), n.base = d) : (d = assertNodeType(n, "accent"), g = d.base);
  var H = buildGroup$1(g, t.havingCrampedStyle()), AA = d.isShifty && utils$2.isCharacterBox(g), gA = 0;
  if (AA) {
    var IA = utils$2.getBaseElem(g), CA = buildGroup$1(IA, t.havingCrampedStyle());
    gA = assertSymbolDomNode(CA).skew;
  }
  var BA = d.label === "\\c", eA = BA ? H.height + H.depth : Math.min(H.height, t.fontMetrics().xHeight), iA;
  if (d.isStretchy)
    iA = stretchy.svgSpan(d, t), iA = buildCommon.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: H
      }, {
        type: "elem",
        elem: iA,
        wrapperClasses: ["svg-align"],
        wrapperStyle: gA > 0 ? {
          width: "calc(100% - " + makeEm(2 * gA) + ")",
          marginLeft: makeEm(2 * gA)
        } : void 0
      }]
    }, t);
  else {
    var QA, tA;
    d.label === "\\vec" ? (QA = buildCommon.staticSvg("vec", t), tA = buildCommon.svgData.vec[1]) : (QA = buildCommon.makeOrd({
      mode: d.mode,
      text: d.label
    }, t, "textord"), QA = assertSymbolDomNode(QA), QA.italic = 0, tA = QA.width, BA && (eA += QA.depth)), iA = buildCommon.makeSpan(["accent-body"], [QA]);
    var oA = d.label === "\\textcircled";
    oA && (iA.classes.push("accent-full"), eA = H.height);
    var EA = gA;
    oA || (EA -= tA / 2), iA.style.left = makeEm(EA), d.label === "\\textcircled" && (iA.style.top = ".2em"), iA = buildCommon.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: H
      }, {
        type: "kern",
        size: -eA
      }, {
        type: "elem",
        elem: iA
      }]
    }, t);
  }
  var aA = buildCommon.makeSpan(["mord", "accent"], [iA], t);
  return k ? (k.children[0] = aA, k.height = Math.max(aA.height, k.height), k.classes[0] = "mord", k) : aA;
}, mathmlBuilder$9 = (n, t) => {
  var g = n.isStretchy ? stretchy.mathMLnode(n.label) : new mathMLTree.MathNode("mo", [makeText(n.label, n.mode)]), d = new mathMLTree.MathNode("mover", [buildGroup(n.base, t), g]);
  return d.setAttribute("accent", "true"), d;
}, NON_STRETCHY_ACCENT_REGEX = new RegExp(["\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve", "\\check", "\\hat", "\\vec", "\\dot", "\\mathring"].map((n) => "\\" + n).join("|"));
defineFunction({
  type: "accent",
  names: ["\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve", "\\check", "\\hat", "\\vec", "\\dot", "\\mathring", "\\widecheck", "\\widehat", "\\widetilde", "\\overrightarrow", "\\overleftarrow", "\\Overrightarrow", "\\overleftrightarrow", "\\overgroup", "\\overlinesegment", "\\overleftharpoon", "\\overrightharpoon"],
  props: {
    numArgs: 1
  },
  handler: (n, t) => {
    var g = normalizeArgument(t[0]), d = !NON_STRETCHY_ACCENT_REGEX.test(n.funcName), k = !d || n.funcName === "\\widehat" || n.funcName === "\\widetilde" || n.funcName === "\\widecheck";
    return {
      type: "accent",
      mode: n.parser.mode,
      label: n.funcName,
      isStretchy: d,
      isShifty: k,
      base: g
    };
  },
  htmlBuilder: htmlBuilder$a,
  mathmlBuilder: mathmlBuilder$9
});
defineFunction({
  type: "accent",
  names: ["\\'", "\\`", "\\^", "\\~", "\\=", "\\u", "\\.", '\\"', "\\c", "\\r", "\\H", "\\v", "\\textcircled"],
  props: {
    numArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    // unless in strict mode
    argTypes: ["primitive"]
  },
  handler: (n, t) => {
    var g = t[0], d = n.parser.mode;
    return d === "math" && (n.parser.settings.reportNonstrict("mathVsTextAccents", "LaTeX's accent " + n.funcName + " works only in text mode"), d = "text"), {
      type: "accent",
      mode: d,
      label: n.funcName,
      isStretchy: !1,
      isShifty: !0,
      base: g
    };
  },
  htmlBuilder: htmlBuilder$a,
  mathmlBuilder: mathmlBuilder$9
});
defineFunction({
  type: "accentUnder",
  names: ["\\underleftarrow", "\\underrightarrow", "\\underleftrightarrow", "\\undergroup", "\\underlinesegment", "\\utilde"],
  props: {
    numArgs: 1
  },
  handler: (n, t) => {
    var {
      parser: g,
      funcName: d
    } = n, k = t[0];
    return {
      type: "accentUnder",
      mode: g.mode,
      label: d,
      base: k
    };
  },
  htmlBuilder: (n, t) => {
    var g = buildGroup$1(n.base, t), d = stretchy.svgSpan(n, t), k = n.label === "\\utilde" ? 0.12 : 0, H = buildCommon.makeVList({
      positionType: "top",
      positionData: g.height,
      children: [{
        type: "elem",
        elem: d,
        wrapperClasses: ["svg-align"]
      }, {
        type: "kern",
        size: k
      }, {
        type: "elem",
        elem: g
      }]
    }, t);
    return buildCommon.makeSpan(["mord", "accentunder"], [H], t);
  },
  mathmlBuilder: (n, t) => {
    var g = stretchy.mathMLnode(n.label), d = new mathMLTree.MathNode("munder", [buildGroup(n.base, t), g]);
    return d.setAttribute("accentunder", "true"), d;
  }
});
var paddedNode = (n) => {
  var t = new mathMLTree.MathNode("mpadded", n ? [n] : []);
  return t.setAttribute("width", "+0.6em"), t.setAttribute("lspace", "0.3em"), t;
};
defineFunction({
  type: "xArrow",
  names: [
    "\\xleftarrow",
    "\\xrightarrow",
    "\\xLeftarrow",
    "\\xRightarrow",
    "\\xleftrightarrow",
    "\\xLeftrightarrow",
    "\\xhookleftarrow",
    "\\xhookrightarrow",
    "\\xmapsto",
    "\\xrightharpoondown",
    "\\xrightharpoonup",
    "\\xleftharpoondown",
    "\\xleftharpoonup",
    "\\xrightleftharpoons",
    "\\xleftrightharpoons",
    "\\xlongequal",
    "\\xtwoheadrightarrow",
    "\\xtwoheadleftarrow",
    "\\xtofrom",
    // The next 3 functions are here to support the mhchem extension.
    // Direct use of these functions is discouraged and may break someday.
    "\\xrightleftarrows",
    "\\xrightequilibrium",
    "\\xleftequilibrium",
    // The next 3 functions are here only to support the {CD} environment.
    "\\\\cdrightarrow",
    "\\\\cdleftarrow",
    "\\\\cdlongequal"
  ],
  props: {
    numArgs: 1,
    numOptionalArgs: 1
  },
  handler(n, t, g) {
    var {
      parser: d,
      funcName: k
    } = n;
    return {
      type: "xArrow",
      mode: d.mode,
      label: k,
      body: t[0],
      below: g[0]
    };
  },
  // Flow is unable to correctly infer the type of `group`, even though it's
  // unambiguously determined from the passed-in `type` above.
  htmlBuilder(n, t) {
    var g = t.style, d = t.havingStyle(g.sup()), k = buildCommon.wrapFragment(buildGroup$1(n.body, d, t), t), H = n.label.slice(0, 2) === "\\x" ? "x" : "cd";
    k.classes.push(H + "-arrow-pad");
    var AA;
    n.below && (d = t.havingStyle(g.sub()), AA = buildCommon.wrapFragment(buildGroup$1(n.below, d, t), t), AA.classes.push(H + "-arrow-pad"));
    var gA = stretchy.svgSpan(n, t), IA = -t.fontMetrics().axisHeight + 0.5 * gA.height, CA = -t.fontMetrics().axisHeight - 0.5 * gA.height - 0.111;
    (k.depth > 0.25 || n.label === "\\xleftequilibrium") && (CA -= k.depth);
    var BA;
    if (AA) {
      var eA = -t.fontMetrics().axisHeight + AA.height + 0.5 * gA.height + 0.111;
      BA = buildCommon.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: k,
          shift: CA
        }, {
          type: "elem",
          elem: gA,
          shift: IA
        }, {
          type: "elem",
          elem: AA,
          shift: eA
        }]
      }, t);
    } else
      BA = buildCommon.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: k,
          shift: CA
        }, {
          type: "elem",
          elem: gA,
          shift: IA
        }]
      }, t);
    return BA.children[0].children[0].children[1].classes.push("svg-align"), buildCommon.makeSpan(["mrel", "x-arrow"], [BA], t);
  },
  mathmlBuilder(n, t) {
    var g = stretchy.mathMLnode(n.label);
    g.setAttribute("minsize", n.label.charAt(0) === "x" ? "1.75em" : "3.0em");
    var d;
    if (n.body) {
      var k = paddedNode(buildGroup(n.body, t));
      if (n.below) {
        var H = paddedNode(buildGroup(n.below, t));
        d = new mathMLTree.MathNode("munderover", [g, H, k]);
      } else
        d = new mathMLTree.MathNode("mover", [g, k]);
    } else if (n.below) {
      var AA = paddedNode(buildGroup(n.below, t));
      d = new mathMLTree.MathNode("munder", [g, AA]);
    } else
      d = paddedNode(), d = new mathMLTree.MathNode("mover", [g, d]);
    return d;
  }
});
var makeSpan = buildCommon.makeSpan;
function htmlBuilder$9(n, t) {
  var g = buildExpression$1(n.body, t, !0);
  return makeSpan([n.mclass], g, t);
}
function mathmlBuilder$8(n, t) {
  var g, d = buildExpression(n.body, t);
  return n.mclass === "minner" ? g = new mathMLTree.MathNode("mpadded", d) : n.mclass === "mord" ? n.isCharacterBox ? (g = d[0], g.type = "mi") : g = new mathMLTree.MathNode("mi", d) : (n.isCharacterBox ? (g = d[0], g.type = "mo") : g = new mathMLTree.MathNode("mo", d), n.mclass === "mbin" ? (g.attributes.lspace = "0.22em", g.attributes.rspace = "0.22em") : n.mclass === "mpunct" ? (g.attributes.lspace = "0em", g.attributes.rspace = "0.17em") : n.mclass === "mopen" || n.mclass === "mclose" ? (g.attributes.lspace = "0em", g.attributes.rspace = "0em") : n.mclass === "minner" && (g.attributes.lspace = "0.0556em", g.attributes.width = "+0.1111em")), g;
}
defineFunction({
  type: "mclass",
  names: ["\\mathord", "\\mathbin", "\\mathrel", "\\mathopen", "\\mathclose", "\\mathpunct", "\\mathinner"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler(n, t) {
    var {
      parser: g,
      funcName: d
    } = n, k = t[0];
    return {
      type: "mclass",
      mode: g.mode,
      mclass: "m" + d.slice(5),
      // TODO(kevinb): don't prefix with 'm'
      body: ordargument(k),
      isCharacterBox: utils$2.isCharacterBox(k)
    };
  },
  htmlBuilder: htmlBuilder$9,
  mathmlBuilder: mathmlBuilder$8
});
var binrelClass = (n) => {
  var t = n.type === "ordgroup" && n.body.length ? n.body[0] : n;
  return t.type === "atom" && (t.family === "bin" || t.family === "rel") ? "m" + t.family : "mord";
};
defineFunction({
  type: "mclass",
  names: ["\\@binrel"],
  props: {
    numArgs: 2
  },
  handler(n, t) {
    var {
      parser: g
    } = n;
    return {
      type: "mclass",
      mode: g.mode,
      mclass: binrelClass(t[0]),
      body: ordargument(t[1]),
      isCharacterBox: utils$2.isCharacterBox(t[1])
    };
  }
});
defineFunction({
  type: "mclass",
  names: ["\\stackrel", "\\overset", "\\underset"],
  props: {
    numArgs: 2
  },
  handler(n, t) {
    var {
      parser: g,
      funcName: d
    } = n, k = t[1], H = t[0], AA;
    d !== "\\stackrel" ? AA = binrelClass(k) : AA = "mrel";
    var gA = {
      type: "op",
      mode: k.mode,
      limits: !0,
      alwaysHandleSupSub: !0,
      parentIsSupSub: !1,
      symbol: !1,
      suppressBaseShift: d !== "\\stackrel",
      body: ordargument(k)
    }, IA = {
      type: "supsub",
      mode: H.mode,
      base: gA,
      sup: d === "\\underset" ? null : H,
      sub: d === "\\underset" ? H : null
    };
    return {
      type: "mclass",
      mode: g.mode,
      mclass: AA,
      body: [IA],
      isCharacterBox: utils$2.isCharacterBox(IA)
    };
  },
  htmlBuilder: htmlBuilder$9,
  mathmlBuilder: mathmlBuilder$8
});
defineFunction({
  type: "pmb",
  names: ["\\pmb"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(n, t) {
    var {
      parser: g
    } = n;
    return {
      type: "pmb",
      mode: g.mode,
      mclass: binrelClass(t[0]),
      body: ordargument(t[0])
    };
  },
  htmlBuilder(n, t) {
    var g = buildExpression$1(n.body, t, !0), d = buildCommon.makeSpan([n.mclass], g, t);
    return d.style.textShadow = "0.02em 0.01em 0.04px", d;
  },
  mathmlBuilder(n, t) {
    var g = buildExpression(n.body, t), d = new mathMLTree.MathNode("mstyle", g);
    return d.setAttribute("style", "text-shadow: 0.02em 0.01em 0.04px"), d;
  }
});
var cdArrowFunctionName = {
  ">": "\\\\cdrightarrow",
  "<": "\\\\cdleftarrow",
  "=": "\\\\cdlongequal",
  A: "\\uparrow",
  V: "\\downarrow",
  "|": "\\Vert",
  ".": "no arrow"
}, newCell = () => ({
  type: "styling",
  body: [],
  mode: "math",
  style: "display"
}), isStartOfArrow = (n) => n.type === "textord" && n.text === "@", isLabelEnd = (n, t) => (n.type === "mathord" || n.type === "atom") && n.text === t;
function cdArrow(n, t, g) {
  var d = cdArrowFunctionName[n];
  switch (d) {
    case "\\\\cdrightarrow":
    case "\\\\cdleftarrow":
      return g.callFunction(d, [t[0]], [t[1]]);
    case "\\uparrow":
    case "\\downarrow": {
      var k = g.callFunction("\\\\cdleft", [t[0]], []), H = {
        type: "atom",
        text: d,
        mode: "math",
        family: "rel"
      }, AA = g.callFunction("\\Big", [H], []), gA = g.callFunction("\\\\cdright", [t[1]], []), IA = {
        type: "ordgroup",
        mode: "math",
        body: [k, AA, gA]
      };
      return g.callFunction("\\\\cdparent", [IA], []);
    }
    case "\\\\cdlongequal":
      return g.callFunction("\\\\cdlongequal", [], []);
    case "\\Vert": {
      var CA = {
        type: "textord",
        text: "\\Vert",
        mode: "math"
      };
      return g.callFunction("\\Big", [CA], []);
    }
    default:
      return {
        type: "textord",
        text: " ",
        mode: "math"
      };
  }
}
function parseCD(n) {
  var t = [];
  for (n.gullet.beginGroup(), n.gullet.macros.set("\\cr", "\\\\\\relax"), n.gullet.beginGroup(); ; ) {
    t.push(n.parseExpression(!1, "\\\\")), n.gullet.endGroup(), n.gullet.beginGroup();
    var g = n.fetch().text;
    if (g === "&" || g === "\\\\")
      n.consume();
    else if (g === "\\end") {
      t[t.length - 1].length === 0 && t.pop();
      break;
    } else
      throw new ParseError("Expected \\\\ or \\cr or \\end", n.nextToken);
  }
  for (var d = [], k = [d], H = 0; H < t.length; H++) {
    for (var AA = t[H], gA = newCell(), IA = 0; IA < AA.length; IA++)
      if (!isStartOfArrow(AA[IA]))
        gA.body.push(AA[IA]);
      else {
        d.push(gA), IA += 1;
        var CA = assertSymbolNodeType(AA[IA]).text, BA = new Array(2);
        if (BA[0] = {
          type: "ordgroup",
          mode: "math",
          body: []
        }, BA[1] = {
          type: "ordgroup",
          mode: "math",
          body: []
        }, !("=|.".indexOf(CA) > -1)) if ("<>AV".indexOf(CA) > -1)
          for (var eA = 0; eA < 2; eA++) {
            for (var iA = !0, QA = IA + 1; QA < AA.length; QA++) {
              if (isLabelEnd(AA[QA], CA)) {
                iA = !1, IA = QA;
                break;
              }
              if (isStartOfArrow(AA[QA]))
                throw new ParseError("Missing a " + CA + " character to complete a CD arrow.", AA[QA]);
              BA[eA].body.push(AA[QA]);
            }
            if (iA)
              throw new ParseError("Missing a " + CA + " character to complete a CD arrow.", AA[IA]);
          }
        else
          throw new ParseError('Expected one of "<>AV=|." after @', AA[IA]);
        var tA = cdArrow(CA, BA, n), oA = {
          type: "styling",
          body: [tA],
          mode: "math",
          style: "display"
          // CD is always displaystyle.
        };
        d.push(oA), gA = newCell();
      }
    H % 2 === 0 ? d.push(gA) : d.shift(), d = [], k.push(d);
  }
  n.gullet.endGroup(), n.gullet.endGroup();
  var EA = new Array(k[0].length).fill({
    type: "align",
    align: "c",
    pregap: 0.25,
    // CD package sets \enskip between columns.
    postgap: 0.25
    // So pre and post each get half an \enskip, i.e. 0.25em.
  });
  return {
    type: "array",
    mode: "math",
    body: k,
    arraystretch: 1,
    addJot: !0,
    rowGaps: [null],
    cols: EA,
    colSeparationType: "CD",
    hLinesBeforeRow: new Array(k.length + 1).fill([])
  };
}
defineFunction({
  type: "cdlabel",
  names: ["\\\\cdleft", "\\\\cdright"],
  props: {
    numArgs: 1
  },
  handler(n, t) {
    var {
      parser: g,
      funcName: d
    } = n;
    return {
      type: "cdlabel",
      mode: g.mode,
      side: d.slice(4),
      label: t[0]
    };
  },
  htmlBuilder(n, t) {
    var g = t.havingStyle(t.style.sup()), d = buildCommon.wrapFragment(buildGroup$1(n.label, g, t), t);
    return d.classes.push("cd-label-" + n.side), d.style.bottom = makeEm(0.8 - d.depth), d.height = 0, d.depth = 0, d;
  },
  mathmlBuilder(n, t) {
    var g = new mathMLTree.MathNode("mrow", [buildGroup(n.label, t)]);
    return g = new mathMLTree.MathNode("mpadded", [g]), g.setAttribute("width", "0"), n.side === "left" && g.setAttribute("lspace", "-1width"), g.setAttribute("voffset", "0.7em"), g = new mathMLTree.MathNode("mstyle", [g]), g.setAttribute("displaystyle", "false"), g.setAttribute("scriptlevel", "1"), g;
  }
});
defineFunction({
  type: "cdlabelparent",
  names: ["\\\\cdparent"],
  props: {
    numArgs: 1
  },
  handler(n, t) {
    var {
      parser: g
    } = n;
    return {
      type: "cdlabelparent",
      mode: g.mode,
      fragment: t[0]
    };
  },
  htmlBuilder(n, t) {
    var g = buildCommon.wrapFragment(buildGroup$1(n.fragment, t), t);
    return g.classes.push("cd-vert-arrow"), g;
  },
  mathmlBuilder(n, t) {
    return new mathMLTree.MathNode("mrow", [buildGroup(n.fragment, t)]);
  }
});
defineFunction({
  type: "textord",
  names: ["\\@char"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(n, t) {
    for (var {
      parser: g
    } = n, d = assertNodeType(t[0], "ordgroup"), k = d.body, H = "", AA = 0; AA < k.length; AA++) {
      var gA = assertNodeType(k[AA], "textord");
      H += gA.text;
    }
    var IA = parseInt(H), CA;
    if (isNaN(IA))
      throw new ParseError("\\@char has non-numeric argument " + H);
    if (IA < 0 || IA >= 1114111)
      throw new ParseError("\\@char with invalid code point " + H);
    return IA <= 65535 ? CA = String.fromCharCode(IA) : (IA -= 65536, CA = String.fromCharCode((IA >> 10) + 55296, (IA & 1023) + 56320)), {
      type: "textord",
      mode: g.mode,
      text: CA
    };
  }
});
var htmlBuilder$8 = (n, t) => {
  var g = buildExpression$1(n.body, t.withColor(n.color), !1);
  return buildCommon.makeFragment(g);
}, mathmlBuilder$7 = (n, t) => {
  var g = buildExpression(n.body, t.withColor(n.color)), d = new mathMLTree.MathNode("mstyle", g);
  return d.setAttribute("mathcolor", n.color), d;
};
defineFunction({
  type: "color",
  names: ["\\textcolor"],
  props: {
    numArgs: 2,
    allowedInText: !0,
    argTypes: ["color", "original"]
  },
  handler(n, t) {
    var {
      parser: g
    } = n, d = assertNodeType(t[0], "color-token").color, k = t[1];
    return {
      type: "color",
      mode: g.mode,
      color: d,
      body: ordargument(k)
    };
  },
  htmlBuilder: htmlBuilder$8,
  mathmlBuilder: mathmlBuilder$7
});
defineFunction({
  type: "color",
  names: ["\\color"],
  props: {
    numArgs: 1,
    allowedInText: !0,
    argTypes: ["color"]
  },
  handler(n, t) {
    var {
      parser: g,
      breakOnTokenText: d
    } = n, k = assertNodeType(t[0], "color-token").color;
    g.gullet.macros.set("\\current@color", k);
    var H = g.parseExpression(!0, d);
    return {
      type: "color",
      mode: g.mode,
      color: k,
      body: H
    };
  },
  htmlBuilder: htmlBuilder$8,
  mathmlBuilder: mathmlBuilder$7
});
defineFunction({
  type: "cr",
  names: ["\\\\"],
  props: {
    numArgs: 0,
    numOptionalArgs: 0,
    allowedInText: !0
  },
  handler(n, t, g) {
    var {
      parser: d
    } = n, k = d.gullet.future().text === "[" ? d.parseSizeGroup(!0) : null, H = !d.settings.displayMode || !d.settings.useStrictBehavior("newLineInDisplayMode", "In LaTeX, \\\\ or \\newline does nothing in display mode");
    return {
      type: "cr",
      mode: d.mode,
      newLine: H,
      size: k && assertNodeType(k, "size").value
    };
  },
  // The following builders are called only at the top level,
  // not within tabular/array environments.
  htmlBuilder(n, t) {
    var g = buildCommon.makeSpan(["mspace"], [], t);
    return n.newLine && (g.classes.push("newline"), n.size && (g.style.marginTop = makeEm(calculateSize(n.size, t)))), g;
  },
  mathmlBuilder(n, t) {
    var g = new mathMLTree.MathNode("mspace");
    return n.newLine && (g.setAttribute("linebreak", "newline"), n.size && g.setAttribute("height", makeEm(calculateSize(n.size, t)))), g;
  }
});
var globalMap = {
  "\\global": "\\global",
  "\\long": "\\\\globallong",
  "\\\\globallong": "\\\\globallong",
  "\\def": "\\gdef",
  "\\gdef": "\\gdef",
  "\\edef": "\\xdef",
  "\\xdef": "\\xdef",
  "\\let": "\\\\globallet",
  "\\futurelet": "\\\\globalfuture"
}, checkControlSequence = (n) => {
  var t = n.text;
  if (/^(?:[\\{}$&#^_]|EOF)$/.test(t))
    throw new ParseError("Expected a control sequence", n);
  return t;
}, getRHS = (n) => {
  var t = n.gullet.popToken();
  return t.text === "=" && (t = n.gullet.popToken(), t.text === " " && (t = n.gullet.popToken())), t;
}, letCommand = (n, t, g, d) => {
  var k = n.gullet.macros.get(g.text);
  k == null && (g.noexpand = !0, k = {
    tokens: [g],
    numArgs: 0,
    // reproduce the same behavior in expansion
    unexpandable: !n.gullet.isExpandable(g.text)
  }), n.gullet.macros.set(t, k, d);
};
defineFunction({
  type: "internal",
  names: [
    "\\global",
    "\\long",
    "\\\\globallong"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(n) {
    var {
      parser: t,
      funcName: g
    } = n;
    t.consumeSpaces();
    var d = t.fetch();
    if (globalMap[d.text])
      return (g === "\\global" || g === "\\\\globallong") && (d.text = globalMap[d.text]), assertNodeType(t.parseFunction(), "internal");
    throw new ParseError("Invalid token after macro prefix", d);
  }
});
defineFunction({
  type: "internal",
  names: ["\\def", "\\gdef", "\\edef", "\\xdef"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(n) {
    var {
      parser: t,
      funcName: g
    } = n, d = t.gullet.popToken(), k = d.text;
    if (/^(?:[\\{}$&#^_]|EOF)$/.test(k))
      throw new ParseError("Expected a control sequence", d);
    for (var H = 0, AA, gA = [[]]; t.gullet.future().text !== "{"; )
      if (d = t.gullet.popToken(), d.text === "#") {
        if (t.gullet.future().text === "{") {
          AA = t.gullet.future(), gA[H].push("{");
          break;
        }
        if (d = t.gullet.popToken(), !/^[1-9]$/.test(d.text))
          throw new ParseError('Invalid argument number "' + d.text + '"');
        if (parseInt(d.text) !== H + 1)
          throw new ParseError('Argument number "' + d.text + '" out of order');
        H++, gA.push([]);
      } else {
        if (d.text === "EOF")
          throw new ParseError("Expected a macro definition");
        gA[H].push(d.text);
      }
    var {
      tokens: IA
    } = t.gullet.consumeArg();
    return AA && IA.unshift(AA), (g === "\\edef" || g === "\\xdef") && (IA = t.gullet.expandTokens(IA), IA.reverse()), t.gullet.macros.set(k, {
      tokens: IA,
      numArgs: H,
      delimiters: gA
    }, g === globalMap[g]), {
      type: "internal",
      mode: t.mode
    };
  }
});
defineFunction({
  type: "internal",
  names: [
    "\\let",
    "\\\\globallet"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(n) {
    var {
      parser: t,
      funcName: g
    } = n, d = checkControlSequence(t.gullet.popToken());
    t.gullet.consumeSpaces();
    var k = getRHS(t);
    return letCommand(t, d, k, g === "\\\\globallet"), {
      type: "internal",
      mode: t.mode
    };
  }
});
defineFunction({
  type: "internal",
  names: [
    "\\futurelet",
    "\\\\globalfuture"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(n) {
    var {
      parser: t,
      funcName: g
    } = n, d = checkControlSequence(t.gullet.popToken()), k = t.gullet.popToken(), H = t.gullet.popToken();
    return letCommand(t, d, H, g === "\\\\globalfuture"), t.gullet.pushToken(H), t.gullet.pushToken(k), {
      type: "internal",
      mode: t.mode
    };
  }
});
var getMetrics = function n(t, g, d) {
  var k = symbols$4.math[t] && symbols$4.math[t].replace, H = getCharacterMetrics(k || t, g, d);
  if (!H)
    throw new Error("Unsupported symbol " + t + " and font size " + g + ".");
  return H;
}, styleWrap = function n(t, g, d, k) {
  var H = d.havingBaseStyle(g), AA = buildCommon.makeSpan(k.concat(H.sizingClasses(d)), [t], d), gA = H.sizeMultiplier / d.sizeMultiplier;
  return AA.height *= gA, AA.depth *= gA, AA.maxFontSize = H.sizeMultiplier, AA;
}, centerSpan = function n(t, g, d) {
  var k = g.havingBaseStyle(d), H = (1 - g.sizeMultiplier / k.sizeMultiplier) * g.fontMetrics().axisHeight;
  t.classes.push("delimcenter"), t.style.top = makeEm(H), t.height -= H, t.depth += H;
}, makeSmallDelim = function n(t, g, d, k, H, AA) {
  var gA = buildCommon.makeSymbol(t, "Main-Regular", H, k), IA = styleWrap(gA, g, k, AA);
  return d && centerSpan(IA, k, g), IA;
}, mathrmSize = function n(t, g, d, k) {
  return buildCommon.makeSymbol(t, "Size" + g + "-Regular", d, k);
}, makeLargeDelim = function n(t, g, d, k, H, AA) {
  var gA = mathrmSize(t, g, H, k), IA = styleWrap(buildCommon.makeSpan(["delimsizing", "size" + g], [gA], k), Style$1.TEXT, k, AA);
  return d && centerSpan(IA, k, Style$1.TEXT), IA;
}, makeGlyphSpan = function n(t, g, d) {
  var k;
  g === "Size1-Regular" ? k = "delim-size1" : k = "delim-size4";
  var H = buildCommon.makeSpan(["delimsizinginner", k], [buildCommon.makeSpan([], [buildCommon.makeSymbol(t, g, d)])]);
  return {
    type: "elem",
    elem: H
  };
}, makeInner = function n(t, g, d) {
  var k = fontMetricsData["Size4-Regular"][t.charCodeAt(0)] ? fontMetricsData["Size4-Regular"][t.charCodeAt(0)][4] : fontMetricsData["Size1-Regular"][t.charCodeAt(0)][4], H = new PathNode("inner", innerPath(t, Math.round(1e3 * g))), AA = new SvgNode([H], {
    width: makeEm(k),
    height: makeEm(g),
    // Override CSS rule `.katex svg { width: 100% }`
    style: "width:" + makeEm(k),
    viewBox: "0 0 " + 1e3 * k + " " + Math.round(1e3 * g),
    preserveAspectRatio: "xMinYMin"
  }), gA = buildCommon.makeSvgSpan([], [AA], d);
  return gA.height = g, gA.style.height = makeEm(g), gA.style.width = makeEm(k), {
    type: "elem",
    elem: gA
  };
}, lapInEms = 8e-3, lap = {
  type: "kern",
  size: -1 * lapInEms
}, verts = ["|", "\\lvert", "\\rvert", "\\vert"], doubleVerts = ["\\|", "\\lVert", "\\rVert", "\\Vert"], makeStackedDelim = function n(t, g, d, k, H, AA) {
  var gA, IA, CA, BA, eA = "", iA = 0;
  gA = CA = BA = t, IA = null;
  var QA = "Size1-Regular";
  t === "\\uparrow" ? CA = BA = "⏐" : t === "\\Uparrow" ? CA = BA = "‖" : t === "\\downarrow" ? gA = CA = "⏐" : t === "\\Downarrow" ? gA = CA = "‖" : t === "\\updownarrow" ? (gA = "\\uparrow", CA = "⏐", BA = "\\downarrow") : t === "\\Updownarrow" ? (gA = "\\Uparrow", CA = "‖", BA = "\\Downarrow") : verts.includes(t) ? (CA = "∣", eA = "vert", iA = 333) : doubleVerts.includes(t) ? (CA = "∥", eA = "doublevert", iA = 556) : t === "[" || t === "\\lbrack" ? (gA = "⎡", CA = "⎢", BA = "⎣", QA = "Size4-Regular", eA = "lbrack", iA = 667) : t === "]" || t === "\\rbrack" ? (gA = "⎤", CA = "⎥", BA = "⎦", QA = "Size4-Regular", eA = "rbrack", iA = 667) : t === "\\lfloor" || t === "⌊" ? (CA = gA = "⎢", BA = "⎣", QA = "Size4-Regular", eA = "lfloor", iA = 667) : t === "\\lceil" || t === "⌈" ? (gA = "⎡", CA = BA = "⎢", QA = "Size4-Regular", eA = "lceil", iA = 667) : t === "\\rfloor" || t === "⌋" ? (CA = gA = "⎥", BA = "⎦", QA = "Size4-Regular", eA = "rfloor", iA = 667) : t === "\\rceil" || t === "⌉" ? (gA = "⎤", CA = BA = "⎥", QA = "Size4-Regular", eA = "rceil", iA = 667) : t === "(" || t === "\\lparen" ? (gA = "⎛", CA = "⎜", BA = "⎝", QA = "Size4-Regular", eA = "lparen", iA = 875) : t === ")" || t === "\\rparen" ? (gA = "⎞", CA = "⎟", BA = "⎠", QA = "Size4-Regular", eA = "rparen", iA = 875) : t === "\\{" || t === "\\lbrace" ? (gA = "⎧", IA = "⎨", BA = "⎩", CA = "⎪", QA = "Size4-Regular") : t === "\\}" || t === "\\rbrace" ? (gA = "⎫", IA = "⎬", BA = "⎭", CA = "⎪", QA = "Size4-Regular") : t === "\\lgroup" || t === "⟮" ? (gA = "⎧", BA = "⎩", CA = "⎪", QA = "Size4-Regular") : t === "\\rgroup" || t === "⟯" ? (gA = "⎫", BA = "⎭", CA = "⎪", QA = "Size4-Regular") : t === "\\lmoustache" || t === "⎰" ? (gA = "⎧", BA = "⎭", CA = "⎪", QA = "Size4-Regular") : (t === "\\rmoustache" || t === "⎱") && (gA = "⎫", BA = "⎩", CA = "⎪", QA = "Size4-Regular");
  var tA = getMetrics(gA, QA, H), oA = tA.height + tA.depth, EA = getMetrics(CA, QA, H), aA = EA.height + EA.depth, nA = getMetrics(BA, QA, H), lA = nA.height + nA.depth, cA = 0, sA = 1;
  if (IA !== null) {
    var rA = getMetrics(IA, QA, H);
    cA = rA.height + rA.depth, sA = 2;
  }
  var uA = oA + lA + cA, hA = Math.max(0, Math.ceil((g - uA) / (sA * aA))), dA = uA + hA * sA * aA, GA = k.fontMetrics().axisHeight;
  d && (GA *= k.sizeMultiplier);
  var DA = dA / 2 - GA, wA = [];
  if (eA.length > 0) {
    var bA = dA - oA - lA, yA = Math.round(dA * 1e3), pA = tallDelim(eA, Math.round(bA * 1e3)), MA = new PathNode(eA, pA), LA = (iA / 1e3).toFixed(3) + "em", xA = (yA / 1e3).toFixed(3) + "em", TA = new SvgNode([MA], {
      width: LA,
      height: xA,
      viewBox: "0 0 " + iA + " " + yA
    }), NA = buildCommon.makeSvgSpan([], [TA], k);
    NA.height = yA / 1e3, NA.style.width = LA, NA.style.height = xA, wA.push({
      type: "elem",
      elem: NA
    });
  } else {
    if (wA.push(makeGlyphSpan(BA, QA, H)), wA.push(lap), IA === null) {
      var zA = dA - oA - lA + 2 * lapInEms;
      wA.push(makeInner(CA, zA, k));
    } else {
      var XA = (dA - oA - lA - cA) / 2 + 2 * lapInEms;
      wA.push(makeInner(CA, XA, k)), wA.push(lap), wA.push(makeGlyphSpan(IA, QA, H)), wA.push(lap), wA.push(makeInner(CA, XA, k));
    }
    wA.push(lap), wA.push(makeGlyphSpan(gA, QA, H));
  }
  var fA = k.havingBaseStyle(Style$1.TEXT), vA = buildCommon.makeVList({
    positionType: "bottom",
    positionData: DA,
    children: wA
  }, fA);
  return styleWrap(buildCommon.makeSpan(["delimsizing", "mult"], [vA], fA), Style$1.TEXT, k, AA);
}, vbPad = 80, emPad = 0.08, sqrtSvg = function n(t, g, d, k, H) {
  var AA = sqrtPath(t, k, d), gA = new PathNode(t, AA), IA = new SvgNode([gA], {
    // Note: 1000:1 ratio of viewBox to document em width.
    width: "400em",
    height: makeEm(g),
    viewBox: "0 0 400000 " + d,
    preserveAspectRatio: "xMinYMin slice"
  });
  return buildCommon.makeSvgSpan(["hide-tail"], [IA], H);
}, makeSqrtImage = function n(t, g) {
  var d = g.havingBaseSizing(), k = traverseSequence("\\surd", t * d.sizeMultiplier, stackLargeDelimiterSequence, d), H = d.sizeMultiplier, AA = Math.max(0, g.minRuleThickness - g.fontMetrics().sqrtRuleThickness), gA, IA = 0, CA = 0, BA = 0, eA;
  return k.type === "small" ? (BA = 1e3 + 1e3 * AA + vbPad, t < 1 ? H = 1 : t < 1.4 && (H = 0.7), IA = (1 + AA + emPad) / H, CA = (1 + AA) / H, gA = sqrtSvg("sqrtMain", IA, BA, AA, g), gA.style.minWidth = "0.853em", eA = 0.833 / H) : k.type === "large" ? (BA = (1e3 + vbPad) * sizeToMaxHeight[k.size], CA = (sizeToMaxHeight[k.size] + AA) / H, IA = (sizeToMaxHeight[k.size] + AA + emPad) / H, gA = sqrtSvg("sqrtSize" + k.size, IA, BA, AA, g), gA.style.minWidth = "1.02em", eA = 1 / H) : (IA = t + AA + emPad, CA = t + AA, BA = Math.floor(1e3 * t + AA) + vbPad, gA = sqrtSvg("sqrtTall", IA, BA, AA, g), gA.style.minWidth = "0.742em", eA = 1.056), gA.height = CA, gA.style.height = makeEm(IA), {
    span: gA,
    advanceWidth: eA,
    // Calculate the actual line width.
    // This actually should depend on the chosen font -- e.g. \boldmath
    // should use the thicker surd symbols from e.g. KaTeX_Main-Bold, and
    // have thicker rules.
    ruleWidth: (g.fontMetrics().sqrtRuleThickness + AA) * H
  };
}, stackLargeDelimiters = ["(", "\\lparen", ")", "\\rparen", "[", "\\lbrack", "]", "\\rbrack", "\\{", "\\lbrace", "\\}", "\\rbrace", "\\lfloor", "\\rfloor", "⌊", "⌋", "\\lceil", "\\rceil", "⌈", "⌉", "\\surd"], stackAlwaysDelimiters = ["\\uparrow", "\\downarrow", "\\updownarrow", "\\Uparrow", "\\Downarrow", "\\Updownarrow", "|", "\\|", "\\vert", "\\Vert", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lgroup", "\\rgroup", "⟮", "⟯", "\\lmoustache", "\\rmoustache", "⎰", "⎱"], stackNeverDelimiters = ["<", ">", "\\langle", "\\rangle", "/", "\\backslash", "\\lt", "\\gt"], sizeToMaxHeight = [0, 1.2, 1.8, 2.4, 3], makeSizedDelim = function n(t, g, d, k, H) {
  if (t === "<" || t === "\\lt" || t === "⟨" ? t = "\\langle" : (t === ">" || t === "\\gt" || t === "⟩") && (t = "\\rangle"), stackLargeDelimiters.includes(t) || stackNeverDelimiters.includes(t))
    return makeLargeDelim(t, g, !1, d, k, H);
  if (stackAlwaysDelimiters.includes(t))
    return makeStackedDelim(t, sizeToMaxHeight[g], !1, d, k, H);
  throw new ParseError("Illegal delimiter: '" + t + "'");
}, stackNeverDelimiterSequence = [{
  type: "small",
  style: Style$1.SCRIPTSCRIPT
}, {
  type: "small",
  style: Style$1.SCRIPT
}, {
  type: "small",
  style: Style$1.TEXT
}, {
  type: "large",
  size: 1
}, {
  type: "large",
  size: 2
}, {
  type: "large",
  size: 3
}, {
  type: "large",
  size: 4
}], stackAlwaysDelimiterSequence = [{
  type: "small",
  style: Style$1.SCRIPTSCRIPT
}, {
  type: "small",
  style: Style$1.SCRIPT
}, {
  type: "small",
  style: Style$1.TEXT
}, {
  type: "stack"
}], stackLargeDelimiterSequence = [{
  type: "small",
  style: Style$1.SCRIPTSCRIPT
}, {
  type: "small",
  style: Style$1.SCRIPT
}, {
  type: "small",
  style: Style$1.TEXT
}, {
  type: "large",
  size: 1
}, {
  type: "large",
  size: 2
}, {
  type: "large",
  size: 3
}, {
  type: "large",
  size: 4
}, {
  type: "stack"
}], delimTypeToFont = function n(t) {
  if (t.type === "small")
    return "Main-Regular";
  if (t.type === "large")
    return "Size" + t.size + "-Regular";
  if (t.type === "stack")
    return "Size4-Regular";
  throw new Error("Add support for delim type '" + t.type + "' here.");
}, traverseSequence = function n(t, g, d, k) {
  for (var H = Math.min(2, 3 - k.style.size), AA = H; AA < d.length && d[AA].type !== "stack"; AA++) {
    var gA = getMetrics(t, delimTypeToFont(d[AA]), "math"), IA = gA.height + gA.depth;
    if (d[AA].type === "small") {
      var CA = k.havingBaseStyle(d[AA].style);
      IA *= CA.sizeMultiplier;
    }
    if (IA > g)
      return d[AA];
  }
  return d[d.length - 1];
}, makeCustomSizedDelim = function n(t, g, d, k, H, AA) {
  t === "<" || t === "\\lt" || t === "⟨" ? t = "\\langle" : (t === ">" || t === "\\gt" || t === "⟩") && (t = "\\rangle");
  var gA;
  stackNeverDelimiters.includes(t) ? gA = stackNeverDelimiterSequence : stackLargeDelimiters.includes(t) ? gA = stackLargeDelimiterSequence : gA = stackAlwaysDelimiterSequence;
  var IA = traverseSequence(t, g, gA, k);
  return IA.type === "small" ? makeSmallDelim(t, IA.style, d, k, H, AA) : IA.type === "large" ? makeLargeDelim(t, IA.size, d, k, H, AA) : makeStackedDelim(t, g, d, k, H, AA);
}, makeLeftRightDelim = function n(t, g, d, k, H, AA) {
  var gA = k.fontMetrics().axisHeight * k.sizeMultiplier, IA = 901, CA = 5 / k.fontMetrics().ptPerEm, BA = Math.max(g - gA, d + gA), eA = Math.max(
    // In real TeX, calculations are done using integral values which are
    // 65536 per pt, or 655360 per em. So, the division here truncates in
    // TeX but doesn't here, producing different results. If we wanted to
    // exactly match TeX's calculation, we could do
    //   Math.floor(655360 * maxDistFromAxis / 500) *
    //    delimiterFactor / 655360
    // (To see the difference, compare
    //    x^{x^{\left(\rule{0.1em}{0.68em}\right)}}
    // in TeX and KaTeX)
    BA / 500 * IA,
    2 * BA - CA
  );
  return makeCustomSizedDelim(t, eA, !0, k, H, AA);
}, delimiter = {
  sqrtImage: makeSqrtImage,
  sizedDelim: makeSizedDelim,
  sizeToMaxHeight,
  customSizedDelim: makeCustomSizedDelim,
  leftRightDelim: makeLeftRightDelim
}, delimiterSizes = {
  "\\bigl": {
    mclass: "mopen",
    size: 1
  },
  "\\Bigl": {
    mclass: "mopen",
    size: 2
  },
  "\\biggl": {
    mclass: "mopen",
    size: 3
  },
  "\\Biggl": {
    mclass: "mopen",
    size: 4
  },
  "\\bigr": {
    mclass: "mclose",
    size: 1
  },
  "\\Bigr": {
    mclass: "mclose",
    size: 2
  },
  "\\biggr": {
    mclass: "mclose",
    size: 3
  },
  "\\Biggr": {
    mclass: "mclose",
    size: 4
  },
  "\\bigm": {
    mclass: "mrel",
    size: 1
  },
  "\\Bigm": {
    mclass: "mrel",
    size: 2
  },
  "\\biggm": {
    mclass: "mrel",
    size: 3
  },
  "\\Biggm": {
    mclass: "mrel",
    size: 4
  },
  "\\big": {
    mclass: "mord",
    size: 1
  },
  "\\Big": {
    mclass: "mord",
    size: 2
  },
  "\\bigg": {
    mclass: "mord",
    size: 3
  },
  "\\Bigg": {
    mclass: "mord",
    size: 4
  }
}, delimiters = ["(", "\\lparen", ")", "\\rparen", "[", "\\lbrack", "]", "\\rbrack", "\\{", "\\lbrace", "\\}", "\\rbrace", "\\lfloor", "\\rfloor", "⌊", "⌋", "\\lceil", "\\rceil", "⌈", "⌉", "<", ">", "\\langle", "⟨", "\\rangle", "⟩", "\\lt", "\\gt", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lgroup", "\\rgroup", "⟮", "⟯", "\\lmoustache", "\\rmoustache", "⎰", "⎱", "/", "\\backslash", "|", "\\vert", "\\|", "\\Vert", "\\uparrow", "\\Uparrow", "\\downarrow", "\\Downarrow", "\\updownarrow", "\\Updownarrow", "."];
function checkDelimiter(n, t) {
  var g = checkSymbolNodeType(n);
  if (g && delimiters.includes(g.text))
    return g;
  throw g ? new ParseError("Invalid delimiter '" + g.text + "' after '" + t.funcName + "'", n) : new ParseError("Invalid delimiter type '" + n.type + "'", n);
}
defineFunction({
  type: "delimsizing",
  names: ["\\bigl", "\\Bigl", "\\biggl", "\\Biggl", "\\bigr", "\\Bigr", "\\biggr", "\\Biggr", "\\bigm", "\\Bigm", "\\biggm", "\\Biggm", "\\big", "\\Big", "\\bigg", "\\Bigg"],
  props: {
    numArgs: 1,
    argTypes: ["primitive"]
  },
  handler: (n, t) => {
    var g = checkDelimiter(t[0], n);
    return {
      type: "delimsizing",
      mode: n.parser.mode,
      size: delimiterSizes[n.funcName].size,
      mclass: delimiterSizes[n.funcName].mclass,
      delim: g.text
    };
  },
  htmlBuilder: (n, t) => n.delim === "." ? buildCommon.makeSpan([n.mclass]) : delimiter.sizedDelim(n.delim, n.size, t, n.mode, [n.mclass]),
  mathmlBuilder: (n) => {
    var t = [];
    n.delim !== "." && t.push(makeText(n.delim, n.mode));
    var g = new mathMLTree.MathNode("mo", t);
    n.mclass === "mopen" || n.mclass === "mclose" ? g.setAttribute("fence", "true") : g.setAttribute("fence", "false"), g.setAttribute("stretchy", "true");
    var d = makeEm(delimiter.sizeToMaxHeight[n.size]);
    return g.setAttribute("minsize", d), g.setAttribute("maxsize", d), g;
  }
});
function assertParsed(n) {
  if (!n.body)
    throw new Error("Bug: The leftright ParseNode wasn't fully parsed.");
}
defineFunction({
  type: "leftright-right",
  names: ["\\right"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (n, t) => {
    var g = n.parser.gullet.macros.get("\\current@color");
    if (g && typeof g != "string")
      throw new ParseError("\\current@color set to non-string in \\right");
    return {
      type: "leftright-right",
      mode: n.parser.mode,
      delim: checkDelimiter(t[0], n).text,
      color: g
      // undefined if not set via \color
    };
  }
});
defineFunction({
  type: "leftright",
  names: ["\\left"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (n, t) => {
    var g = checkDelimiter(t[0], n), d = n.parser;
    ++d.leftrightDepth;
    var k = d.parseExpression(!1);
    --d.leftrightDepth, d.expect("\\right", !1);
    var H = assertNodeType(d.parseFunction(), "leftright-right");
    return {
      type: "leftright",
      mode: d.mode,
      body: k,
      left: g.text,
      right: H.delim,
      rightColor: H.color
    };
  },
  htmlBuilder: (n, t) => {
    assertParsed(n);
    for (var g = buildExpression$1(n.body, t, !0, ["mopen", "mclose"]), d = 0, k = 0, H = !1, AA = 0; AA < g.length; AA++)
      g[AA].isMiddle ? H = !0 : (d = Math.max(g[AA].height, d), k = Math.max(g[AA].depth, k));
    d *= t.sizeMultiplier, k *= t.sizeMultiplier;
    var gA;
    if (n.left === "." ? gA = makeNullDelimiter(t, ["mopen"]) : gA = delimiter.leftRightDelim(n.left, d, k, t, n.mode, ["mopen"]), g.unshift(gA), H)
      for (var IA = 1; IA < g.length; IA++) {
        var CA = g[IA], BA = CA.isMiddle;
        BA && (g[IA] = delimiter.leftRightDelim(BA.delim, d, k, BA.options, n.mode, []));
      }
    var eA;
    if (n.right === ".")
      eA = makeNullDelimiter(t, ["mclose"]);
    else {
      var iA = n.rightColor ? t.withColor(n.rightColor) : t;
      eA = delimiter.leftRightDelim(n.right, d, k, iA, n.mode, ["mclose"]);
    }
    return g.push(eA), buildCommon.makeSpan(["minner"], g, t);
  },
  mathmlBuilder: (n, t) => {
    assertParsed(n);
    var g = buildExpression(n.body, t);
    if (n.left !== ".") {
      var d = new mathMLTree.MathNode("mo", [makeText(n.left, n.mode)]);
      d.setAttribute("fence", "true"), g.unshift(d);
    }
    if (n.right !== ".") {
      var k = new mathMLTree.MathNode("mo", [makeText(n.right, n.mode)]);
      k.setAttribute("fence", "true"), n.rightColor && k.setAttribute("mathcolor", n.rightColor), g.push(k);
    }
    return makeRow(g);
  }
});
defineFunction({
  type: "middle",
  names: ["\\middle"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (n, t) => {
    var g = checkDelimiter(t[0], n);
    if (!n.parser.leftrightDepth)
      throw new ParseError("\\middle without preceding \\left", g);
    return {
      type: "middle",
      mode: n.parser.mode,
      delim: g.text
    };
  },
  htmlBuilder: (n, t) => {
    var g;
    if (n.delim === ".")
      g = makeNullDelimiter(t, []);
    else {
      g = delimiter.sizedDelim(n.delim, 1, t, n.mode, []);
      var d = {
        delim: n.delim,
        options: t
      };
      g.isMiddle = d;
    }
    return g;
  },
  mathmlBuilder: (n, t) => {
    var g = n.delim === "\\vert" || n.delim === "|" ? makeText("|", "text") : makeText(n.delim, n.mode), d = new mathMLTree.MathNode("mo", [g]);
    return d.setAttribute("fence", "true"), d.setAttribute("lspace", "0.05em"), d.setAttribute("rspace", "0.05em"), d;
  }
});
var htmlBuilder$7 = (n, t) => {
  var g = buildCommon.wrapFragment(buildGroup$1(n.body, t), t), d = n.label.slice(1), k = t.sizeMultiplier, H, AA = 0, gA = utils$2.isCharacterBox(n.body);
  if (d === "sout")
    H = buildCommon.makeSpan(["stretchy", "sout"]), H.height = t.fontMetrics().defaultRuleThickness / k, AA = -0.5 * t.fontMetrics().xHeight;
  else if (d === "phase") {
    var IA = calculateSize({
      number: 0.6,
      unit: "pt"
    }, t), CA = calculateSize({
      number: 0.35,
      unit: "ex"
    }, t), BA = t.havingBaseSizing();
    k = k / BA.sizeMultiplier;
    var eA = g.height + g.depth + IA + CA;
    g.style.paddingLeft = makeEm(eA / 2 + IA);
    var iA = Math.floor(1e3 * eA * k), QA = phasePath(iA), tA = new SvgNode([new PathNode("phase", QA)], {
      width: "400em",
      height: makeEm(iA / 1e3),
      viewBox: "0 0 400000 " + iA,
      preserveAspectRatio: "xMinYMin slice"
    });
    H = buildCommon.makeSvgSpan(["hide-tail"], [tA], t), H.style.height = makeEm(eA), AA = g.depth + IA + CA;
  } else {
    /cancel/.test(d) ? gA || g.classes.push("cancel-pad") : d === "angl" ? g.classes.push("anglpad") : g.classes.push("boxpad");
    var oA = 0, EA = 0, aA = 0;
    /box/.test(d) ? (aA = Math.max(
      t.fontMetrics().fboxrule,
      // default
      t.minRuleThickness
      // User override.
    ), oA = t.fontMetrics().fboxsep + (d === "colorbox" ? 0 : aA), EA = oA) : d === "angl" ? (aA = Math.max(t.fontMetrics().defaultRuleThickness, t.minRuleThickness), oA = 4 * aA, EA = Math.max(0, 0.25 - g.depth)) : (oA = gA ? 0.2 : 0, EA = oA), H = stretchy.encloseSpan(g, d, oA, EA, t), /fbox|boxed|fcolorbox/.test(d) ? (H.style.borderStyle = "solid", H.style.borderWidth = makeEm(aA)) : d === "angl" && aA !== 0.049 && (H.style.borderTopWidth = makeEm(aA), H.style.borderRightWidth = makeEm(aA)), AA = g.depth + EA, n.backgroundColor && (H.style.backgroundColor = n.backgroundColor, n.borderColor && (H.style.borderColor = n.borderColor));
  }
  var nA;
  if (n.backgroundColor)
    nA = buildCommon.makeVList({
      positionType: "individualShift",
      children: [
        // Put the color background behind inner;
        {
          type: "elem",
          elem: H,
          shift: AA
        },
        {
          type: "elem",
          elem: g,
          shift: 0
        }
      ]
    }, t);
  else {
    var lA = /cancel|phase/.test(d) ? ["svg-align"] : [];
    nA = buildCommon.makeVList({
      positionType: "individualShift",
      children: [
        // Write the \cancel stroke on top of inner.
        {
          type: "elem",
          elem: g,
          shift: 0
        },
        {
          type: "elem",
          elem: H,
          shift: AA,
          wrapperClasses: lA
        }
      ]
    }, t);
  }
  return /cancel/.test(d) && (nA.height = g.height, nA.depth = g.depth), /cancel/.test(d) && !gA ? buildCommon.makeSpan(["mord", "cancel-lap"], [nA], t) : buildCommon.makeSpan(["mord"], [nA], t);
}, mathmlBuilder$6 = (n, t) => {
  var g = 0, d = new mathMLTree.MathNode(n.label.indexOf("colorbox") > -1 ? "mpadded" : "menclose", [buildGroup(n.body, t)]);
  switch (n.label) {
    case "\\cancel":
      d.setAttribute("notation", "updiagonalstrike");
      break;
    case "\\bcancel":
      d.setAttribute("notation", "downdiagonalstrike");
      break;
    case "\\phase":
      d.setAttribute("notation", "phasorangle");
      break;
    case "\\sout":
      d.setAttribute("notation", "horizontalstrike");
      break;
    case "\\fbox":
      d.setAttribute("notation", "box");
      break;
    case "\\angl":
      d.setAttribute("notation", "actuarial");
      break;
    case "\\fcolorbox":
    case "\\colorbox":
      if (g = t.fontMetrics().fboxsep * t.fontMetrics().ptPerEm, d.setAttribute("width", "+" + 2 * g + "pt"), d.setAttribute("height", "+" + 2 * g + "pt"), d.setAttribute("lspace", g + "pt"), d.setAttribute("voffset", g + "pt"), n.label === "\\fcolorbox") {
        var k = Math.max(
          t.fontMetrics().fboxrule,
          // default
          t.minRuleThickness
          // user override
        );
        d.setAttribute("style", "border: " + k + "em solid " + String(n.borderColor));
      }
      break;
    case "\\xcancel":
      d.setAttribute("notation", "updiagonalstrike downdiagonalstrike");
      break;
  }
  return n.backgroundColor && d.setAttribute("mathbackground", n.backgroundColor), d;
};
defineFunction({
  type: "enclose",
  names: ["\\colorbox"],
  props: {
    numArgs: 2,
    allowedInText: !0,
    argTypes: ["color", "text"]
  },
  handler(n, t, g) {
    var {
      parser: d,
      funcName: k
    } = n, H = assertNodeType(t[0], "color-token").color, AA = t[1];
    return {
      type: "enclose",
      mode: d.mode,
      label: k,
      backgroundColor: H,
      body: AA
    };
  },
  htmlBuilder: htmlBuilder$7,
  mathmlBuilder: mathmlBuilder$6
});
defineFunction({
  type: "enclose",
  names: ["\\fcolorbox"],
  props: {
    numArgs: 3,
    allowedInText: !0,
    argTypes: ["color", "color", "text"]
  },
  handler(n, t, g) {
    var {
      parser: d,
      funcName: k
    } = n, H = assertNodeType(t[0], "color-token").color, AA = assertNodeType(t[1], "color-token").color, gA = t[2];
    return {
      type: "enclose",
      mode: d.mode,
      label: k,
      backgroundColor: AA,
      borderColor: H,
      body: gA
    };
  },
  htmlBuilder: htmlBuilder$7,
  mathmlBuilder: mathmlBuilder$6
});
defineFunction({
  type: "enclose",
  names: ["\\fbox"],
  props: {
    numArgs: 1,
    argTypes: ["hbox"],
    allowedInText: !0
  },
  handler(n, t) {
    var {
      parser: g
    } = n;
    return {
      type: "enclose",
      mode: g.mode,
      label: "\\fbox",
      body: t[0]
    };
  }
});
defineFunction({
  type: "enclose",
  names: ["\\cancel", "\\bcancel", "\\xcancel", "\\sout", "\\phase"],
  props: {
    numArgs: 1
  },
  handler(n, t) {
    var {
      parser: g,
      funcName: d
    } = n, k = t[0];
    return {
      type: "enclose",
      mode: g.mode,
      label: d,
      body: k
    };
  },
  htmlBuilder: htmlBuilder$7,
  mathmlBuilder: mathmlBuilder$6
});
defineFunction({
  type: "enclose",
  names: ["\\angl"],
  props: {
    numArgs: 1,
    argTypes: ["hbox"],
    allowedInText: !1
  },
  handler(n, t) {
    var {
      parser: g
    } = n;
    return {
      type: "enclose",
      mode: g.mode,
      label: "\\angl",
      body: t[0]
    };
  }
});
var _environments = {};
function defineEnvironment(n) {
  for (var {
    type: t,
    names: g,
    props: d,
    handler: k,
    htmlBuilder: H,
    mathmlBuilder: AA
  } = n, gA = {
    type: t,
    numArgs: d.numArgs || 0,
    allowedInText: !1,
    numOptionalArgs: 0,
    handler: k
  }, IA = 0; IA < g.length; ++IA)
    _environments[g[IA]] = gA;
  H && (_htmlGroupBuilders[t] = H), AA && (_mathmlGroupBuilders[t] = AA);
}
var _macros = {};
function defineMacro(n, t) {
  _macros[n] = t;
}
function getHLines(n) {
  var t = [];
  n.consumeSpaces();
  var g = n.fetch().text;
  for (g === "\\relax" && (n.consume(), n.consumeSpaces(), g = n.fetch().text); g === "\\hline" || g === "\\hdashline"; )
    n.consume(), t.push(g === "\\hdashline"), n.consumeSpaces(), g = n.fetch().text;
  return t;
}
var validateAmsEnvironmentContext = (n) => {
  var t = n.parser.settings;
  if (!t.displayMode)
    throw new ParseError("{" + n.envName + "} can be used only in display mode.");
};
function getAutoTag(n) {
  if (n.indexOf("ed") === -1)
    return n.indexOf("*") === -1;
}
function parseArray$1(n, t, g) {
  var {
    hskipBeforeAndAfter: d,
    addJot: k,
    cols: H,
    arraystretch: AA,
    colSeparationType: gA,
    autoTag: IA,
    singleRow: CA,
    emptySingleRow: BA,
    maxNumCols: eA,
    leqno: iA
  } = t;
  if (n.gullet.beginGroup(), CA || n.gullet.macros.set("\\cr", "\\\\\\relax"), !AA) {
    var QA = n.gullet.expandMacroAsText("\\arraystretch");
    if (QA == null)
      AA = 1;
    else if (AA = parseFloat(QA), !AA || AA < 0)
      throw new ParseError("Invalid \\arraystretch: " + QA);
  }
  n.gullet.beginGroup();
  var tA = [], oA = [tA], EA = [], aA = [], nA = IA != null ? [] : void 0;
  function lA() {
    IA && n.gullet.macros.set("\\@eqnsw", "1", !0);
  }
  function cA() {
    nA && (n.gullet.macros.get("\\df@tag") ? (nA.push(n.subparse([new Token("\\df@tag")])), n.gullet.macros.set("\\df@tag", void 0, !0)) : nA.push(!!IA && n.gullet.macros.get("\\@eqnsw") === "1"));
  }
  for (lA(), aA.push(getHLines(n)); ; ) {
    var sA = n.parseExpression(!1, CA ? "\\end" : "\\\\");
    n.gullet.endGroup(), n.gullet.beginGroup(), sA = {
      type: "ordgroup",
      mode: n.mode,
      body: sA
    }, g && (sA = {
      type: "styling",
      mode: n.mode,
      style: g,
      body: [sA]
    }), tA.push(sA);
    var rA = n.fetch().text;
    if (rA === "&") {
      if (eA && tA.length === eA) {
        if (CA || gA)
          throw new ParseError("Too many tab characters: &", n.nextToken);
        n.settings.reportNonstrict("textEnv", "Too few columns specified in the {array} column argument.");
      }
      n.consume();
    } else if (rA === "\\end") {
      cA(), tA.length === 1 && sA.type === "styling" && sA.body[0].body.length === 0 && (oA.length > 1 || !BA) && oA.pop(), aA.length < oA.length + 1 && aA.push([]);
      break;
    } else if (rA === "\\\\") {
      n.consume();
      var uA = void 0;
      n.gullet.future().text !== " " && (uA = n.parseSizeGroup(!0)), EA.push(uA ? uA.value : null), cA(), aA.push(getHLines(n)), tA = [], oA.push(tA), lA();
    } else
      throw new ParseError("Expected & or \\\\ or \\cr or \\end", n.nextToken);
  }
  return n.gullet.endGroup(), n.gullet.endGroup(), {
    type: "array",
    mode: n.mode,
    addJot: k,
    arraystretch: AA,
    body: oA,
    cols: H,
    rowGaps: EA,
    hskipBeforeAndAfter: d,
    hLinesBeforeRow: aA,
    colSeparationType: gA,
    tags: nA,
    leqno: iA
  };
}
function dCellStyle(n) {
  return n.slice(0, 1) === "d" ? "display" : "text";
}
var htmlBuilder$6 = function n(t, g) {
  var d, k, H = t.body.length, AA = t.hLinesBeforeRow, gA = 0, IA = new Array(H), CA = [], BA = Math.max(
    // From LaTeX \showthe\arrayrulewidth. Equals 0.04 em.
    g.fontMetrics().arrayRuleWidth,
    g.minRuleThickness
    // User override.
  ), eA = 1 / g.fontMetrics().ptPerEm, iA = 5 * eA;
  if (t.colSeparationType && t.colSeparationType === "small") {
    var QA = g.havingStyle(Style$1.SCRIPT).sizeMultiplier;
    iA = 0.2778 * (QA / g.sizeMultiplier);
  }
  var tA = t.colSeparationType === "CD" ? calculateSize({
    number: 3,
    unit: "ex"
  }, g) : 12 * eA, oA = 3 * eA, EA = t.arraystretch * tA, aA = 0.7 * EA, nA = 0.3 * EA, lA = 0;
  function cA(jA) {
    for (var _A = 0; _A < jA.length; ++_A)
      _A > 0 && (lA += 0.25), CA.push({
        pos: lA,
        isDashed: jA[_A]
      });
  }
  for (cA(AA[0]), d = 0; d < t.body.length; ++d) {
    var sA = t.body[d], rA = aA, uA = nA;
    gA < sA.length && (gA = sA.length);
    var hA = new Array(sA.length);
    for (k = 0; k < sA.length; ++k) {
      var dA = buildGroup$1(sA[k], g);
      uA < dA.depth && (uA = dA.depth), rA < dA.height && (rA = dA.height), hA[k] = dA;
    }
    var GA = t.rowGaps[d], DA = 0;
    GA && (DA = calculateSize(GA, g), DA > 0 && (DA += nA, uA < DA && (uA = DA), DA = 0)), t.addJot && (uA += oA), hA.height = rA, hA.depth = uA, lA += rA, hA.pos = lA, lA += uA + DA, IA[d] = hA, cA(AA[d + 1]);
  }
  var wA = lA / 2 + g.fontMetrics().axisHeight, bA = t.cols || [], yA = [], pA, MA, LA = [];
  if (t.tags && t.tags.some((jA) => jA))
    for (d = 0; d < H; ++d) {
      var xA = IA[d], TA = xA.pos - wA, NA = t.tags[d], zA = void 0;
      NA === !0 ? zA = buildCommon.makeSpan(["eqn-num"], [], g) : NA === !1 ? zA = buildCommon.makeSpan([], [], g) : zA = buildCommon.makeSpan([], buildExpression$1(NA, g, !0), g), zA.depth = xA.depth, zA.height = xA.height, LA.push({
        type: "elem",
        elem: zA,
        shift: TA
      });
    }
  for (
    k = 0, MA = 0;
    // Continue while either there are more columns or more column
    // descriptions, so trailing separators don't get lost.
    k < gA || MA < bA.length;
    ++k, ++MA
  ) {
    for (var XA = bA[MA] || {}, fA = !0; XA.type === "separator"; ) {
      if (fA || (pA = buildCommon.makeSpan(["arraycolsep"], []), pA.style.width = makeEm(g.fontMetrics().doubleRuleSep), yA.push(pA)), XA.separator === "|" || XA.separator === ":") {
        var vA = XA.separator === "|" ? "solid" : "dashed", Cg = buildCommon.makeSpan(["vertical-separator"], [], g);
        Cg.style.height = makeEm(lA), Cg.style.borderRightWidth = makeEm(BA), Cg.style.borderRightStyle = vA, Cg.style.margin = "0 " + makeEm(-BA / 2);
        var Ig = lA - wA;
        Ig && (Cg.style.verticalAlign = makeEm(-Ig)), yA.push(Cg);
      } else
        throw new ParseError("Invalid separator type: " + XA.separator);
      MA++, XA = bA[MA] || {}, fA = !1;
    }
    if (!(k >= gA)) {
      var gg = void 0;
      (k > 0 || t.hskipBeforeAndAfter) && (gg = utils$2.deflt(XA.pregap, iA), gg !== 0 && (pA = buildCommon.makeSpan(["arraycolsep"], []), pA.style.width = makeEm(gg), yA.push(pA)));
      var og = [];
      for (d = 0; d < H; ++d) {
        var eg = IA[d], kA = eg[k];
        if (kA) {
          var YA = eg.pos - wA;
          kA.depth = eg.depth, kA.height = eg.height, og.push({
            type: "elem",
            elem: kA,
            shift: YA
          });
        }
      }
      og = buildCommon.makeVList({
        positionType: "individualShift",
        children: og
      }, g), og = buildCommon.makeSpan(["col-align-" + (XA.align || "c")], [og]), yA.push(og), (k < gA - 1 || t.hskipBeforeAndAfter) && (gg = utils$2.deflt(XA.postgap, iA), gg !== 0 && (pA = buildCommon.makeSpan(["arraycolsep"], []), pA.style.width = makeEm(gg), yA.push(pA)));
    }
  }
  if (IA = buildCommon.makeSpan(["mtable"], yA), CA.length > 0) {
    for (var RA = buildCommon.makeLineSpan("hline", g, BA), FA = buildCommon.makeLineSpan("hdashline", g, BA), mA = [{
      type: "elem",
      elem: IA,
      shift: 0
    }]; CA.length > 0; ) {
      var JA = CA.pop(), VA = JA.pos - wA;
      JA.isDashed ? mA.push({
        type: "elem",
        elem: FA,
        shift: VA
      }) : mA.push({
        type: "elem",
        elem: RA,
        shift: VA
      });
    }
    IA = buildCommon.makeVList({
      positionType: "individualShift",
      children: mA
    }, g);
  }
  if (LA.length === 0)
    return buildCommon.makeSpan(["mord"], [IA], g);
  var HA = buildCommon.makeVList({
    positionType: "individualShift",
    children: LA
  }, g);
  return HA = buildCommon.makeSpan(["tag"], [HA], g), buildCommon.makeFragment([IA, HA]);
}, alignMap = {
  c: "center ",
  l: "left ",
  r: "right "
}, mathmlBuilder$5 = function n(t, g) {
  for (var d = [], k = new mathMLTree.MathNode("mtd", [], ["mtr-glue"]), H = new mathMLTree.MathNode("mtd", [], ["mml-eqn-num"]), AA = 0; AA < t.body.length; AA++) {
    for (var gA = t.body[AA], IA = [], CA = 0; CA < gA.length; CA++)
      IA.push(new mathMLTree.MathNode("mtd", [buildGroup(gA[CA], g)]));
    t.tags && t.tags[AA] && (IA.unshift(k), IA.push(k), t.leqno ? IA.unshift(H) : IA.push(H)), d.push(new mathMLTree.MathNode("mtr", IA));
  }
  var BA = new mathMLTree.MathNode("mtable", d), eA = t.arraystretch === 0.5 ? 0.1 : 0.16 + t.arraystretch - 1 + (t.addJot ? 0.09 : 0);
  BA.setAttribute("rowspacing", makeEm(eA));
  var iA = "", QA = "";
  if (t.cols && t.cols.length > 0) {
    var tA = t.cols, oA = "", EA = !1, aA = 0, nA = tA.length;
    tA[0].type === "separator" && (iA += "top ", aA = 1), tA[tA.length - 1].type === "separator" && (iA += "bottom ", nA -= 1);
    for (var lA = aA; lA < nA; lA++)
      tA[lA].type === "align" ? (QA += alignMap[tA[lA].align], EA && (oA += "none "), EA = !0) : tA[lA].type === "separator" && EA && (oA += tA[lA].separator === "|" ? "solid " : "dashed ", EA = !1);
    BA.setAttribute("columnalign", QA.trim()), /[sd]/.test(oA) && BA.setAttribute("columnlines", oA.trim());
  }
  if (t.colSeparationType === "align") {
    for (var cA = t.cols || [], sA = "", rA = 1; rA < cA.length; rA++)
      sA += rA % 2 ? "0em " : "1em ";
    BA.setAttribute("columnspacing", sA.trim());
  } else t.colSeparationType === "alignat" || t.colSeparationType === "gather" ? BA.setAttribute("columnspacing", "0em") : t.colSeparationType === "small" ? BA.setAttribute("columnspacing", "0.2778em") : t.colSeparationType === "CD" ? BA.setAttribute("columnspacing", "0.5em") : BA.setAttribute("columnspacing", "1em");
  var uA = "", hA = t.hLinesBeforeRow;
  iA += hA[0].length > 0 ? "left " : "", iA += hA[hA.length - 1].length > 0 ? "right " : "";
  for (var dA = 1; dA < hA.length - 1; dA++)
    uA += hA[dA].length === 0 ? "none " : hA[dA][0] ? "dashed " : "solid ";
  return /[sd]/.test(uA) && BA.setAttribute("rowlines", uA.trim()), iA !== "" && (BA = new mathMLTree.MathNode("menclose", [BA]), BA.setAttribute("notation", iA.trim())), t.arraystretch && t.arraystretch < 1 && (BA = new mathMLTree.MathNode("mstyle", [BA]), BA.setAttribute("scriptlevel", "1")), BA;
}, alignedHandler = function n(t, g) {
  t.envName.indexOf("ed") === -1 && validateAmsEnvironmentContext(t);
  var d = [], k = t.envName.indexOf("at") > -1 ? "alignat" : "align", H = t.envName === "split", AA = parseArray$1(t.parser, {
    cols: d,
    addJot: !0,
    autoTag: H ? void 0 : getAutoTag(t.envName),
    emptySingleRow: !0,
    colSeparationType: k,
    maxNumCols: H ? 2 : void 0,
    leqno: t.parser.settings.leqno
  }, "display"), gA, IA = 0, CA = {
    type: "ordgroup",
    mode: t.mode,
    body: []
  };
  if (g[0] && g[0].type === "ordgroup") {
    for (var BA = "", eA = 0; eA < g[0].body.length; eA++) {
      var iA = assertNodeType(g[0].body[eA], "textord");
      BA += iA.text;
    }
    gA = Number(BA), IA = gA * 2;
  }
  var QA = !IA;
  AA.body.forEach(function(aA) {
    for (var nA = 1; nA < aA.length; nA += 2) {
      var lA = assertNodeType(aA[nA], "styling"), cA = assertNodeType(lA.body[0], "ordgroup");
      cA.body.unshift(CA);
    }
    if (QA)
      IA < aA.length && (IA = aA.length);
    else {
      var sA = aA.length / 2;
      if (gA < sA)
        throw new ParseError("Too many math in a row: " + ("expected " + gA + ", but got " + sA), aA[0]);
    }
  });
  for (var tA = 0; tA < IA; ++tA) {
    var oA = "r", EA = 0;
    tA % 2 === 1 ? oA = "l" : tA > 0 && QA && (EA = 1), d[tA] = {
      type: "align",
      align: oA,
      pregap: EA,
      postgap: 0
    };
  }
  return AA.colSeparationType = QA ? "align" : "alignat", AA;
};
defineEnvironment({
  type: "array",
  names: ["array", "darray"],
  props: {
    numArgs: 1
  },
  handler(n, t) {
    var g = checkSymbolNodeType(t[0]), d = g ? [t[0]] : assertNodeType(t[0], "ordgroup").body, k = d.map(function(AA) {
      var gA = assertSymbolNodeType(AA), IA = gA.text;
      if ("lcr".indexOf(IA) !== -1)
        return {
          type: "align",
          align: IA
        };
      if (IA === "|")
        return {
          type: "separator",
          separator: "|"
        };
      if (IA === ":")
        return {
          type: "separator",
          separator: ":"
        };
      throw new ParseError("Unknown column alignment: " + IA, AA);
    }), H = {
      cols: k,
      hskipBeforeAndAfter: !0,
      // \@preamble in lttab.dtx
      maxNumCols: k.length
    };
    return parseArray$1(n.parser, H, dCellStyle(n.envName));
  },
  htmlBuilder: htmlBuilder$6,
  mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
  type: "array",
  names: ["matrix", "pmatrix", "bmatrix", "Bmatrix", "vmatrix", "Vmatrix", "matrix*", "pmatrix*", "bmatrix*", "Bmatrix*", "vmatrix*", "Vmatrix*"],
  props: {
    numArgs: 0
  },
  handler(n) {
    var t = {
      matrix: null,
      pmatrix: ["(", ")"],
      bmatrix: ["[", "]"],
      Bmatrix: ["\\{", "\\}"],
      vmatrix: ["|", "|"],
      Vmatrix: ["\\Vert", "\\Vert"]
    }[n.envName.replace("*", "")], g = "c", d = {
      hskipBeforeAndAfter: !1,
      cols: [{
        type: "align",
        align: g
      }]
    };
    if (n.envName.charAt(n.envName.length - 1) === "*") {
      var k = n.parser;
      if (k.consumeSpaces(), k.fetch().text === "[") {
        if (k.consume(), k.consumeSpaces(), g = k.fetch().text, "lcr".indexOf(g) === -1)
          throw new ParseError("Expected l or c or r", k.nextToken);
        k.consume(), k.consumeSpaces(), k.expect("]"), k.consume(), d.cols = [{
          type: "align",
          align: g
        }];
      }
    }
    var H = parseArray$1(n.parser, d, dCellStyle(n.envName)), AA = Math.max(0, ...H.body.map((gA) => gA.length));
    return H.cols = new Array(AA).fill({
      type: "align",
      align: g
    }), t ? {
      type: "leftright",
      mode: n.mode,
      body: [H],
      left: t[0],
      right: t[1],
      rightColor: void 0
      // \right uninfluenced by \color in array
    } : H;
  },
  htmlBuilder: htmlBuilder$6,
  mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
  type: "array",
  names: ["smallmatrix"],
  props: {
    numArgs: 0
  },
  handler(n) {
    var t = {
      arraystretch: 0.5
    }, g = parseArray$1(n.parser, t, "script");
    return g.colSeparationType = "small", g;
  },
  htmlBuilder: htmlBuilder$6,
  mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
  type: "array",
  names: ["subarray"],
  props: {
    numArgs: 1
  },
  handler(n, t) {
    var g = checkSymbolNodeType(t[0]), d = g ? [t[0]] : assertNodeType(t[0], "ordgroup").body, k = d.map(function(AA) {
      var gA = assertSymbolNodeType(AA), IA = gA.text;
      if ("lc".indexOf(IA) !== -1)
        return {
          type: "align",
          align: IA
        };
      throw new ParseError("Unknown column alignment: " + IA, AA);
    });
    if (k.length > 1)
      throw new ParseError("{subarray} can contain only one column");
    var H = {
      cols: k,
      hskipBeforeAndAfter: !1,
      arraystretch: 0.5
    };
    if (H = parseArray$1(n.parser, H, "script"), H.body.length > 0 && H.body[0].length > 1)
      throw new ParseError("{subarray} can contain only one column");
    return H;
  },
  htmlBuilder: htmlBuilder$6,
  mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
  type: "array",
  names: ["cases", "dcases", "rcases", "drcases"],
  props: {
    numArgs: 0
  },
  handler(n) {
    var t = {
      arraystretch: 1.2,
      cols: [{
        type: "align",
        align: "l",
        pregap: 0,
        // TODO(kevinb) get the current style.
        // For now we use the metrics for TEXT style which is what we were
        // doing before.  Before attempting to get the current style we
        // should look at TeX's behavior especially for \over and matrices.
        postgap: 1
        /* 1em quad */
      }, {
        type: "align",
        align: "l",
        pregap: 0,
        postgap: 0
      }]
    }, g = parseArray$1(n.parser, t, dCellStyle(n.envName));
    return {
      type: "leftright",
      mode: n.mode,
      body: [g],
      left: n.envName.indexOf("r") > -1 ? "." : "\\{",
      right: n.envName.indexOf("r") > -1 ? "\\}" : ".",
      rightColor: void 0
    };
  },
  htmlBuilder: htmlBuilder$6,
  mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
  type: "array",
  names: ["align", "align*", "aligned", "split"],
  props: {
    numArgs: 0
  },
  handler: alignedHandler,
  htmlBuilder: htmlBuilder$6,
  mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
  type: "array",
  names: ["gathered", "gather", "gather*"],
  props: {
    numArgs: 0
  },
  handler(n) {
    ["gather", "gather*"].includes(n.envName) && validateAmsEnvironmentContext(n);
    var t = {
      cols: [{
        type: "align",
        align: "c"
      }],
      addJot: !0,
      colSeparationType: "gather",
      autoTag: getAutoTag(n.envName),
      emptySingleRow: !0,
      leqno: n.parser.settings.leqno
    };
    return parseArray$1(n.parser, t, "display");
  },
  htmlBuilder: htmlBuilder$6,
  mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
  type: "array",
  names: ["alignat", "alignat*", "alignedat"],
  props: {
    numArgs: 1
  },
  handler: alignedHandler,
  htmlBuilder: htmlBuilder$6,
  mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
  type: "array",
  names: ["equation", "equation*"],
  props: {
    numArgs: 0
  },
  handler(n) {
    validateAmsEnvironmentContext(n);
    var t = {
      autoTag: getAutoTag(n.envName),
      emptySingleRow: !0,
      singleRow: !0,
      maxNumCols: 1,
      leqno: n.parser.settings.leqno
    };
    return parseArray$1(n.parser, t, "display");
  },
  htmlBuilder: htmlBuilder$6,
  mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
  type: "array",
  names: ["CD"],
  props: {
    numArgs: 0
  },
  handler(n) {
    return validateAmsEnvironmentContext(n), parseCD(n.parser);
  },
  htmlBuilder: htmlBuilder$6,
  mathmlBuilder: mathmlBuilder$5
});
defineMacro("\\nonumber", "\\gdef\\@eqnsw{0}");
defineMacro("\\notag", "\\nonumber");
defineFunction({
  type: "text",
  // Doesn't matter what this is.
  names: ["\\hline", "\\hdashline"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !0
  },
  handler(n, t) {
    throw new ParseError(n.funcName + " valid only within array environment");
  }
});
var environments = _environments;
defineFunction({
  type: "environment",
  names: ["\\begin", "\\end"],
  props: {
    numArgs: 1,
    argTypes: ["text"]
  },
  handler(n, t) {
    var {
      parser: g,
      funcName: d
    } = n, k = t[0];
    if (k.type !== "ordgroup")
      throw new ParseError("Invalid environment name", k);
    for (var H = "", AA = 0; AA < k.body.length; ++AA)
      H += assertNodeType(k.body[AA], "textord").text;
    if (d === "\\begin") {
      if (!environments.hasOwnProperty(H))
        throw new ParseError("No such environment: " + H, k);
      var gA = environments[H], {
        args: IA,
        optArgs: CA
      } = g.parseArguments("\\begin{" + H + "}", gA), BA = {
        mode: g.mode,
        envName: H,
        parser: g
      }, eA = gA.handler(BA, IA, CA);
      g.expect("\\end", !1);
      var iA = g.nextToken, QA = assertNodeType(g.parseFunction(), "environment");
      if (QA.name !== H)
        throw new ParseError("Mismatch: \\begin{" + H + "} matched by \\end{" + QA.name + "}", iA);
      return eA;
    }
    return {
      type: "environment",
      mode: g.mode,
      name: H,
      nameGroup: k
    };
  }
});
var htmlBuilder$5 = (n, t) => {
  var g = n.font, d = t.withFont(g);
  return buildGroup$1(n.body, d);
}, mathmlBuilder$4 = (n, t) => {
  var g = n.font, d = t.withFont(g);
  return buildGroup(n.body, d);
}, fontAliases = {
  "\\Bbb": "\\mathbb",
  "\\bold": "\\mathbf",
  "\\frak": "\\mathfrak",
  "\\bm": "\\boldsymbol"
};
defineFunction({
  type: "font",
  names: [
    // styles, except \boldsymbol defined below
    "\\mathrm",
    "\\mathit",
    "\\mathbf",
    "\\mathnormal",
    "\\mathsfit",
    // families
    "\\mathbb",
    "\\mathcal",
    "\\mathfrak",
    "\\mathscr",
    "\\mathsf",
    "\\mathtt",
    // aliases, except \bm defined below
    "\\Bbb",
    "\\bold",
    "\\frak"
  ],
  props: {
    numArgs: 1,
    allowedInArgument: !0
  },
  handler: (n, t) => {
    var {
      parser: g,
      funcName: d
    } = n, k = normalizeArgument(t[0]), H = d;
    return H in fontAliases && (H = fontAliases[H]), {
      type: "font",
      mode: g.mode,
      font: H.slice(1),
      body: k
    };
  },
  htmlBuilder: htmlBuilder$5,
  mathmlBuilder: mathmlBuilder$4
});
defineFunction({
  type: "mclass",
  names: ["\\boldsymbol", "\\bm"],
  props: {
    numArgs: 1
  },
  handler: (n, t) => {
    var {
      parser: g
    } = n, d = t[0], k = utils$2.isCharacterBox(d);
    return {
      type: "mclass",
      mode: g.mode,
      mclass: binrelClass(d),
      body: [{
        type: "font",
        mode: g.mode,
        font: "boldsymbol",
        body: d
      }],
      isCharacterBox: k
    };
  }
});
defineFunction({
  type: "font",
  names: ["\\rm", "\\sf", "\\tt", "\\bf", "\\it", "\\cal"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler: (n, t) => {
    var {
      parser: g,
      funcName: d,
      breakOnTokenText: k
    } = n, {
      mode: H
    } = g, AA = g.parseExpression(!0, k), gA = "math" + d.slice(1);
    return {
      type: "font",
      mode: H,
      font: gA,
      body: {
        type: "ordgroup",
        mode: g.mode,
        body: AA
      }
    };
  },
  htmlBuilder: htmlBuilder$5,
  mathmlBuilder: mathmlBuilder$4
});
var adjustStyle = (n, t) => {
  var g = t;
  return n === "display" ? g = g.id >= Style$1.SCRIPT.id ? g.text() : Style$1.DISPLAY : n === "text" && g.size === Style$1.DISPLAY.size ? g = Style$1.TEXT : n === "script" ? g = Style$1.SCRIPT : n === "scriptscript" && (g = Style$1.SCRIPTSCRIPT), g;
}, htmlBuilder$4 = (n, t) => {
  var g = adjustStyle(n.size, t.style), d = g.fracNum(), k = g.fracDen(), H;
  H = t.havingStyle(d);
  var AA = buildGroup$1(n.numer, H, t);
  if (n.continued) {
    var gA = 8.5 / t.fontMetrics().ptPerEm, IA = 3.5 / t.fontMetrics().ptPerEm;
    AA.height = AA.height < gA ? gA : AA.height, AA.depth = AA.depth < IA ? IA : AA.depth;
  }
  H = t.havingStyle(k);
  var CA = buildGroup$1(n.denom, H, t), BA, eA, iA;
  n.hasBarLine ? (n.barSize ? (eA = calculateSize(n.barSize, t), BA = buildCommon.makeLineSpan("frac-line", t, eA)) : BA = buildCommon.makeLineSpan("frac-line", t), eA = BA.height, iA = BA.height) : (BA = null, eA = 0, iA = t.fontMetrics().defaultRuleThickness);
  var QA, tA, oA;
  g.size === Style$1.DISPLAY.size || n.size === "display" ? (QA = t.fontMetrics().num1, eA > 0 ? tA = 3 * iA : tA = 7 * iA, oA = t.fontMetrics().denom1) : (eA > 0 ? (QA = t.fontMetrics().num2, tA = iA) : (QA = t.fontMetrics().num3, tA = 3 * iA), oA = t.fontMetrics().denom2);
  var EA;
  if (BA) {
    var nA = t.fontMetrics().axisHeight;
    QA - AA.depth - (nA + 0.5 * eA) < tA && (QA += tA - (QA - AA.depth - (nA + 0.5 * eA))), nA - 0.5 * eA - (CA.height - oA) < tA && (oA += tA - (nA - 0.5 * eA - (CA.height - oA)));
    var lA = -(nA - 0.5 * eA);
    EA = buildCommon.makeVList({
      positionType: "individualShift",
      children: [{
        type: "elem",
        elem: CA,
        shift: oA
      }, {
        type: "elem",
        elem: BA,
        shift: lA
      }, {
        type: "elem",
        elem: AA,
        shift: -QA
      }]
    }, t);
  } else {
    var aA = QA - AA.depth - (CA.height - oA);
    aA < tA && (QA += 0.5 * (tA - aA), oA += 0.5 * (tA - aA)), EA = buildCommon.makeVList({
      positionType: "individualShift",
      children: [{
        type: "elem",
        elem: CA,
        shift: oA
      }, {
        type: "elem",
        elem: AA,
        shift: -QA
      }]
    }, t);
  }
  H = t.havingStyle(g), EA.height *= H.sizeMultiplier / t.sizeMultiplier, EA.depth *= H.sizeMultiplier / t.sizeMultiplier;
  var cA;
  g.size === Style$1.DISPLAY.size ? cA = t.fontMetrics().delim1 : g.size === Style$1.SCRIPTSCRIPT.size ? cA = t.havingStyle(Style$1.SCRIPT).fontMetrics().delim2 : cA = t.fontMetrics().delim2;
  var sA, rA;
  return n.leftDelim == null ? sA = makeNullDelimiter(t, ["mopen"]) : sA = delimiter.customSizedDelim(n.leftDelim, cA, !0, t.havingStyle(g), n.mode, ["mopen"]), n.continued ? rA = buildCommon.makeSpan([]) : n.rightDelim == null ? rA = makeNullDelimiter(t, ["mclose"]) : rA = delimiter.customSizedDelim(n.rightDelim, cA, !0, t.havingStyle(g), n.mode, ["mclose"]), buildCommon.makeSpan(["mord"].concat(H.sizingClasses(t)), [sA, buildCommon.makeSpan(["mfrac"], [EA]), rA], t);
}, mathmlBuilder$3 = (n, t) => {
  var g = new mathMLTree.MathNode("mfrac", [buildGroup(n.numer, t), buildGroup(n.denom, t)]);
  if (!n.hasBarLine)
    g.setAttribute("linethickness", "0px");
  else if (n.barSize) {
    var d = calculateSize(n.barSize, t);
    g.setAttribute("linethickness", makeEm(d));
  }
  var k = adjustStyle(n.size, t.style);
  if (k.size !== t.style.size) {
    g = new mathMLTree.MathNode("mstyle", [g]);
    var H = k.size === Style$1.DISPLAY.size ? "true" : "false";
    g.setAttribute("displaystyle", H), g.setAttribute("scriptlevel", "0");
  }
  if (n.leftDelim != null || n.rightDelim != null) {
    var AA = [];
    if (n.leftDelim != null) {
      var gA = new mathMLTree.MathNode("mo", [new mathMLTree.TextNode(n.leftDelim.replace("\\", ""))]);
      gA.setAttribute("fence", "true"), AA.push(gA);
    }
    if (AA.push(g), n.rightDelim != null) {
      var IA = new mathMLTree.MathNode("mo", [new mathMLTree.TextNode(n.rightDelim.replace("\\", ""))]);
      IA.setAttribute("fence", "true"), AA.push(IA);
    }
    return makeRow(AA);
  }
  return g;
};
defineFunction({
  type: "genfrac",
  names: [
    "\\dfrac",
    "\\frac",
    "\\tfrac",
    "\\dbinom",
    "\\binom",
    "\\tbinom",
    "\\\\atopfrac",
    // can’t be entered directly
    "\\\\bracefrac",
    "\\\\brackfrac"
    // ditto
  ],
  props: {
    numArgs: 2,
    allowedInArgument: !0
  },
  handler: (n, t) => {
    var {
      parser: g,
      funcName: d
    } = n, k = t[0], H = t[1], AA, gA = null, IA = null, CA = "auto";
    switch (d) {
      case "\\dfrac":
      case "\\frac":
      case "\\tfrac":
        AA = !0;
        break;
      case "\\\\atopfrac":
        AA = !1;
        break;
      case "\\dbinom":
      case "\\binom":
      case "\\tbinom":
        AA = !1, gA = "(", IA = ")";
        break;
      case "\\\\bracefrac":
        AA = !1, gA = "\\{", IA = "\\}";
        break;
      case "\\\\brackfrac":
        AA = !1, gA = "[", IA = "]";
        break;
      default:
        throw new Error("Unrecognized genfrac command");
    }
    switch (d) {
      case "\\dfrac":
      case "\\dbinom":
        CA = "display";
        break;
      case "\\tfrac":
      case "\\tbinom":
        CA = "text";
        break;
    }
    return {
      type: "genfrac",
      mode: g.mode,
      continued: !1,
      numer: k,
      denom: H,
      hasBarLine: AA,
      leftDelim: gA,
      rightDelim: IA,
      size: CA,
      barSize: null
    };
  },
  htmlBuilder: htmlBuilder$4,
  mathmlBuilder: mathmlBuilder$3
});
defineFunction({
  type: "genfrac",
  names: ["\\cfrac"],
  props: {
    numArgs: 2
  },
  handler: (n, t) => {
    var {
      parser: g,
      funcName: d
    } = n, k = t[0], H = t[1];
    return {
      type: "genfrac",
      mode: g.mode,
      continued: !0,
      numer: k,
      denom: H,
      hasBarLine: !0,
      leftDelim: null,
      rightDelim: null,
      size: "display",
      barSize: null
    };
  }
});
defineFunction({
  type: "infix",
  names: ["\\over", "\\choose", "\\atop", "\\brace", "\\brack"],
  props: {
    numArgs: 0,
    infix: !0
  },
  handler(n) {
    var {
      parser: t,
      funcName: g,
      token: d
    } = n, k;
    switch (g) {
      case "\\over":
        k = "\\frac";
        break;
      case "\\choose":
        k = "\\binom";
        break;
      case "\\atop":
        k = "\\\\atopfrac";
        break;
      case "\\brace":
        k = "\\\\bracefrac";
        break;
      case "\\brack":
        k = "\\\\brackfrac";
        break;
      default:
        throw new Error("Unrecognized infix genfrac command");
    }
    return {
      type: "infix",
      mode: t.mode,
      replaceWith: k,
      token: d
    };
  }
});
var stylArray = ["display", "text", "script", "scriptscript"], delimFromValue = function n(t) {
  var g = null;
  return t.length > 0 && (g = t, g = g === "." ? null : g), g;
};
defineFunction({
  type: "genfrac",
  names: ["\\genfrac"],
  props: {
    numArgs: 6,
    allowedInArgument: !0,
    argTypes: ["math", "math", "size", "text", "math", "math"]
  },
  handler(n, t) {
    var {
      parser: g
    } = n, d = t[4], k = t[5], H = normalizeArgument(t[0]), AA = H.type === "atom" && H.family === "open" ? delimFromValue(H.text) : null, gA = normalizeArgument(t[1]), IA = gA.type === "atom" && gA.family === "close" ? delimFromValue(gA.text) : null, CA = assertNodeType(t[2], "size"), BA, eA = null;
    CA.isBlank ? BA = !0 : (eA = CA.value, BA = eA.number > 0);
    var iA = "auto", QA = t[3];
    if (QA.type === "ordgroup") {
      if (QA.body.length > 0) {
        var tA = assertNodeType(QA.body[0], "textord");
        iA = stylArray[Number(tA.text)];
      }
    } else
      QA = assertNodeType(QA, "textord"), iA = stylArray[Number(QA.text)];
    return {
      type: "genfrac",
      mode: g.mode,
      numer: d,
      denom: k,
      continued: !1,
      hasBarLine: BA,
      barSize: eA,
      leftDelim: AA,
      rightDelim: IA,
      size: iA
    };
  },
  htmlBuilder: htmlBuilder$4,
  mathmlBuilder: mathmlBuilder$3
});
defineFunction({
  type: "infix",
  names: ["\\above"],
  props: {
    numArgs: 1,
    argTypes: ["size"],
    infix: !0
  },
  handler(n, t) {
    var {
      parser: g,
      funcName: d,
      token: k
    } = n;
    return {
      type: "infix",
      mode: g.mode,
      replaceWith: "\\\\abovefrac",
      size: assertNodeType(t[0], "size").value,
      token: k
    };
  }
});
defineFunction({
  type: "genfrac",
  names: ["\\\\abovefrac"],
  props: {
    numArgs: 3,
    argTypes: ["math", "size", "math"]
  },
  handler: (n, t) => {
    var {
      parser: g,
      funcName: d
    } = n, k = t[0], H = assert$2(assertNodeType(t[1], "infix").size), AA = t[2], gA = H.number > 0;
    return {
      type: "genfrac",
      mode: g.mode,
      numer: k,
      denom: AA,
      continued: !1,
      hasBarLine: gA,
      barSize: H,
      leftDelim: null,
      rightDelim: null,
      size: "auto"
    };
  },
  htmlBuilder: htmlBuilder$4,
  mathmlBuilder: mathmlBuilder$3
});
var htmlBuilder$3 = (n, t) => {
  var g = t.style, d, k;
  n.type === "supsub" ? (d = n.sup ? buildGroup$1(n.sup, t.havingStyle(g.sup()), t) : buildGroup$1(n.sub, t.havingStyle(g.sub()), t), k = assertNodeType(n.base, "horizBrace")) : k = assertNodeType(n, "horizBrace");
  var H = buildGroup$1(k.base, t.havingBaseStyle(Style$1.DISPLAY)), AA = stretchy.svgSpan(k, t), gA;
  if (k.isOver ? (gA = buildCommon.makeVList({
    positionType: "firstBaseline",
    children: [{
      type: "elem",
      elem: H
    }, {
      type: "kern",
      size: 0.1
    }, {
      type: "elem",
      elem: AA
    }]
  }, t), gA.children[0].children[0].children[1].classes.push("svg-align")) : (gA = buildCommon.makeVList({
    positionType: "bottom",
    positionData: H.depth + 0.1 + AA.height,
    children: [{
      type: "elem",
      elem: AA
    }, {
      type: "kern",
      size: 0.1
    }, {
      type: "elem",
      elem: H
    }]
  }, t), gA.children[0].children[0].children[0].classes.push("svg-align")), d) {
    var IA = buildCommon.makeSpan(["mord", k.isOver ? "mover" : "munder"], [gA], t);
    k.isOver ? gA = buildCommon.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: IA
      }, {
        type: "kern",
        size: 0.2
      }, {
        type: "elem",
        elem: d
      }]
    }, t) : gA = buildCommon.makeVList({
      positionType: "bottom",
      positionData: IA.depth + 0.2 + d.height + d.depth,
      children: [{
        type: "elem",
        elem: d
      }, {
        type: "kern",
        size: 0.2
      }, {
        type: "elem",
        elem: IA
      }]
    }, t);
  }
  return buildCommon.makeSpan(["mord", k.isOver ? "mover" : "munder"], [gA], t);
}, mathmlBuilder$2 = (n, t) => {
  var g = stretchy.mathMLnode(n.label);
  return new mathMLTree.MathNode(n.isOver ? "mover" : "munder", [buildGroup(n.base, t), g]);
};
defineFunction({
  type: "horizBrace",
  names: ["\\overbrace", "\\underbrace"],
  props: {
    numArgs: 1
  },
  handler(n, t) {
    var {
      parser: g,
      funcName: d
    } = n;
    return {
      type: "horizBrace",
      mode: g.mode,
      label: d,
      isOver: /^\\over/.test(d),
      base: t[0]
    };
  },
  htmlBuilder: htmlBuilder$3,
  mathmlBuilder: mathmlBuilder$2
});
defineFunction({
  type: "href",
  names: ["\\href"],
  props: {
    numArgs: 2,
    argTypes: ["url", "original"],
    allowedInText: !0
  },
  handler: (n, t) => {
    var {
      parser: g
    } = n, d = t[1], k = assertNodeType(t[0], "url").url;
    return g.settings.isTrusted({
      command: "\\href",
      url: k
    }) ? {
      type: "href",
      mode: g.mode,
      href: k,
      body: ordargument(d)
    } : g.formatUnsupportedCmd("\\href");
  },
  htmlBuilder: (n, t) => {
    var g = buildExpression$1(n.body, t, !1);
    return buildCommon.makeAnchor(n.href, [], g, t);
  },
  mathmlBuilder: (n, t) => {
    var g = buildExpressionRow(n.body, t);
    return g instanceof MathNode || (g = new MathNode("mrow", [g])), g.setAttribute("href", n.href), g;
  }
});
defineFunction({
  type: "href",
  names: ["\\url"],
  props: {
    numArgs: 1,
    argTypes: ["url"],
    allowedInText: !0
  },
  handler: (n, t) => {
    var {
      parser: g
    } = n, d = assertNodeType(t[0], "url").url;
    if (!g.settings.isTrusted({
      command: "\\url",
      url: d
    }))
      return g.formatUnsupportedCmd("\\url");
    for (var k = [], H = 0; H < d.length; H++) {
      var AA = d[H];
      AA === "~" && (AA = "\\textasciitilde"), k.push({
        type: "textord",
        mode: "text",
        text: AA
      });
    }
    var gA = {
      type: "text",
      mode: g.mode,
      font: "\\texttt",
      body: k
    };
    return {
      type: "href",
      mode: g.mode,
      href: d,
      body: ordargument(gA)
    };
  }
});
defineFunction({
  type: "hbox",
  names: ["\\hbox"],
  props: {
    numArgs: 1,
    argTypes: ["text"],
    allowedInText: !0,
    primitive: !0
  },
  handler(n, t) {
    var {
      parser: g
    } = n;
    return {
      type: "hbox",
      mode: g.mode,
      body: ordargument(t[0])
    };
  },
  htmlBuilder(n, t) {
    var g = buildExpression$1(n.body, t, !1);
    return buildCommon.makeFragment(g);
  },
  mathmlBuilder(n, t) {
    return new mathMLTree.MathNode("mrow", buildExpression(n.body, t));
  }
});
defineFunction({
  type: "html",
  names: ["\\htmlClass", "\\htmlId", "\\htmlStyle", "\\htmlData"],
  props: {
    numArgs: 2,
    argTypes: ["raw", "original"],
    allowedInText: !0
  },
  handler: (n, t) => {
    var {
      parser: g,
      funcName: d,
      token: k
    } = n, H = assertNodeType(t[0], "raw").string, AA = t[1];
    g.settings.strict && g.settings.reportNonstrict("htmlExtension", "HTML extension is disabled on strict mode");
    var gA, IA = {};
    switch (d) {
      case "\\htmlClass":
        IA.class = H, gA = {
          command: "\\htmlClass",
          class: H
        };
        break;
      case "\\htmlId":
        IA.id = H, gA = {
          command: "\\htmlId",
          id: H
        };
        break;
      case "\\htmlStyle":
        IA.style = H, gA = {
          command: "\\htmlStyle",
          style: H
        };
        break;
      case "\\htmlData": {
        for (var CA = H.split(","), BA = 0; BA < CA.length; BA++) {
          var eA = CA[BA].split("=");
          if (eA.length !== 2)
            throw new ParseError("Error parsing key-value for \\htmlData");
          IA["data-" + eA[0].trim()] = eA[1].trim();
        }
        gA = {
          command: "\\htmlData",
          attributes: IA
        };
        break;
      }
      default:
        throw new Error("Unrecognized html command");
    }
    return g.settings.isTrusted(gA) ? {
      type: "html",
      mode: g.mode,
      attributes: IA,
      body: ordargument(AA)
    } : g.formatUnsupportedCmd(d);
  },
  htmlBuilder: (n, t) => {
    var g = buildExpression$1(n.body, t, !1), d = ["enclosing"];
    n.attributes.class && d.push(...n.attributes.class.trim().split(/\s+/));
    var k = buildCommon.makeSpan(d, g, t);
    for (var H in n.attributes)
      H !== "class" && n.attributes.hasOwnProperty(H) && k.setAttribute(H, n.attributes[H]);
    return k;
  },
  mathmlBuilder: (n, t) => buildExpressionRow(n.body, t)
});
defineFunction({
  type: "htmlmathml",
  names: ["\\html@mathml"],
  props: {
    numArgs: 2,
    allowedInText: !0
  },
  handler: (n, t) => {
    var {
      parser: g
    } = n;
    return {
      type: "htmlmathml",
      mode: g.mode,
      html: ordargument(t[0]),
      mathml: ordargument(t[1])
    };
  },
  htmlBuilder: (n, t) => {
    var g = buildExpression$1(n.html, t, !1);
    return buildCommon.makeFragment(g);
  },
  mathmlBuilder: (n, t) => buildExpressionRow(n.mathml, t)
});
var sizeData = function n(t) {
  if (/^[-+]? *(\d+(\.\d*)?|\.\d+)$/.test(t))
    return {
      number: +t,
      unit: "bp"
    };
  var g = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(t);
  if (!g)
    throw new ParseError("Invalid size: '" + t + "' in \\includegraphics");
  var d = {
    number: +(g[1] + g[2]),
    // sign + magnitude, cast to number
    unit: g[3]
  };
  if (!validUnit(d))
    throw new ParseError("Invalid unit: '" + d.unit + "' in \\includegraphics.");
  return d;
};
defineFunction({
  type: "includegraphics",
  names: ["\\includegraphics"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1,
    argTypes: ["raw", "url"],
    allowedInText: !1
  },
  handler: (n, t, g) => {
    var {
      parser: d
    } = n, k = {
      number: 0,
      unit: "em"
    }, H = {
      number: 0.9,
      unit: "em"
    }, AA = {
      number: 0,
      unit: "em"
    }, gA = "";
    if (g[0])
      for (var IA = assertNodeType(g[0], "raw").string, CA = IA.split(","), BA = 0; BA < CA.length; BA++) {
        var eA = CA[BA].split("=");
        if (eA.length === 2) {
          var iA = eA[1].trim();
          switch (eA[0].trim()) {
            case "alt":
              gA = iA;
              break;
            case "width":
              k = sizeData(iA);
              break;
            case "height":
              H = sizeData(iA);
              break;
            case "totalheight":
              AA = sizeData(iA);
              break;
            default:
              throw new ParseError("Invalid key: '" + eA[0] + "' in \\includegraphics.");
          }
        }
      }
    var QA = assertNodeType(t[0], "url").url;
    return gA === "" && (gA = QA, gA = gA.replace(/^.*[\\/]/, ""), gA = gA.substring(0, gA.lastIndexOf("."))), d.settings.isTrusted({
      command: "\\includegraphics",
      url: QA
    }) ? {
      type: "includegraphics",
      mode: d.mode,
      alt: gA,
      width: k,
      height: H,
      totalheight: AA,
      src: QA
    } : d.formatUnsupportedCmd("\\includegraphics");
  },
  htmlBuilder: (n, t) => {
    var g = calculateSize(n.height, t), d = 0;
    n.totalheight.number > 0 && (d = calculateSize(n.totalheight, t) - g);
    var k = 0;
    n.width.number > 0 && (k = calculateSize(n.width, t));
    var H = {
      height: makeEm(g + d)
    };
    k > 0 && (H.width = makeEm(k)), d > 0 && (H.verticalAlign = makeEm(-d));
    var AA = new Img(n.src, n.alt, H);
    return AA.height = g, AA.depth = d, AA;
  },
  mathmlBuilder: (n, t) => {
    var g = new mathMLTree.MathNode("mglyph", []);
    g.setAttribute("alt", n.alt);
    var d = calculateSize(n.height, t), k = 0;
    if (n.totalheight.number > 0 && (k = calculateSize(n.totalheight, t) - d, g.setAttribute("valign", makeEm(-k))), g.setAttribute("height", makeEm(d + k)), n.width.number > 0) {
      var H = calculateSize(n.width, t);
      g.setAttribute("width", makeEm(H));
    }
    return g.setAttribute("src", n.src), g;
  }
});
defineFunction({
  type: "kern",
  names: ["\\kern", "\\mkern", "\\hskip", "\\mskip"],
  props: {
    numArgs: 1,
    argTypes: ["size"],
    primitive: !0,
    allowedInText: !0
  },
  handler(n, t) {
    var {
      parser: g,
      funcName: d
    } = n, k = assertNodeType(t[0], "size");
    if (g.settings.strict) {
      var H = d[1] === "m", AA = k.value.unit === "mu";
      H ? (AA || g.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + d + " supports only mu units, " + ("not " + k.value.unit + " units")), g.mode !== "math" && g.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + d + " works only in math mode")) : AA && g.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + d + " doesn't support mu units");
    }
    return {
      type: "kern",
      mode: g.mode,
      dimension: k.value
    };
  },
  htmlBuilder(n, t) {
    return buildCommon.makeGlue(n.dimension, t);
  },
  mathmlBuilder(n, t) {
    var g = calculateSize(n.dimension, t);
    return new mathMLTree.SpaceNode(g);
  }
});
defineFunction({
  type: "lap",
  names: ["\\mathllap", "\\mathrlap", "\\mathclap"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (n, t) => {
    var {
      parser: g,
      funcName: d
    } = n, k = t[0];
    return {
      type: "lap",
      mode: g.mode,
      alignment: d.slice(5),
      body: k
    };
  },
  htmlBuilder: (n, t) => {
    var g;
    n.alignment === "clap" ? (g = buildCommon.makeSpan([], [buildGroup$1(n.body, t)]), g = buildCommon.makeSpan(["inner"], [g], t)) : g = buildCommon.makeSpan(["inner"], [buildGroup$1(n.body, t)]);
    var d = buildCommon.makeSpan(["fix"], []), k = buildCommon.makeSpan([n.alignment], [g, d], t), H = buildCommon.makeSpan(["strut"]);
    return H.style.height = makeEm(k.height + k.depth), k.depth && (H.style.verticalAlign = makeEm(-k.depth)), k.children.unshift(H), k = buildCommon.makeSpan(["thinbox"], [k], t), buildCommon.makeSpan(["mord", "vbox"], [k], t);
  },
  mathmlBuilder: (n, t) => {
    var g = new mathMLTree.MathNode("mpadded", [buildGroup(n.body, t)]);
    if (n.alignment !== "rlap") {
      var d = n.alignment === "llap" ? "-1" : "-0.5";
      g.setAttribute("lspace", d + "width");
    }
    return g.setAttribute("width", "0px"), g;
  }
});
defineFunction({
  type: "styling",
  names: ["\\(", "$"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1
  },
  handler(n, t) {
    var {
      funcName: g,
      parser: d
    } = n, k = d.mode;
    d.switchMode("math");
    var H = g === "\\(" ? "\\)" : "$", AA = d.parseExpression(!1, H);
    return d.expect(H), d.switchMode(k), {
      type: "styling",
      mode: d.mode,
      style: "text",
      body: AA
    };
  }
});
defineFunction({
  type: "text",
  // Doesn't matter what this is.
  names: ["\\)", "\\]"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1
  },
  handler(n, t) {
    throw new ParseError("Mismatched " + n.funcName);
  }
});
var chooseMathStyle = (n, t) => {
  switch (t.style.size) {
    case Style$1.DISPLAY.size:
      return n.display;
    case Style$1.TEXT.size:
      return n.text;
    case Style$1.SCRIPT.size:
      return n.script;
    case Style$1.SCRIPTSCRIPT.size:
      return n.scriptscript;
    default:
      return n.text;
  }
};
defineFunction({
  type: "mathchoice",
  names: ["\\mathchoice"],
  props: {
    numArgs: 4,
    primitive: !0
  },
  handler: (n, t) => {
    var {
      parser: g
    } = n;
    return {
      type: "mathchoice",
      mode: g.mode,
      display: ordargument(t[0]),
      text: ordargument(t[1]),
      script: ordargument(t[2]),
      scriptscript: ordargument(t[3])
    };
  },
  htmlBuilder: (n, t) => {
    var g = chooseMathStyle(n, t), d = buildExpression$1(g, t, !1);
    return buildCommon.makeFragment(d);
  },
  mathmlBuilder: (n, t) => {
    var g = chooseMathStyle(n, t);
    return buildExpressionRow(g, t);
  }
});
var assembleSupSub = (n, t, g, d, k, H, AA) => {
  n = buildCommon.makeSpan([], [n]);
  var gA = g && utils$2.isCharacterBox(g), IA, CA;
  if (t) {
    var BA = buildGroup$1(t, d.havingStyle(k.sup()), d);
    CA = {
      elem: BA,
      kern: Math.max(d.fontMetrics().bigOpSpacing1, d.fontMetrics().bigOpSpacing3 - BA.depth)
    };
  }
  if (g) {
    var eA = buildGroup$1(g, d.havingStyle(k.sub()), d);
    IA = {
      elem: eA,
      kern: Math.max(d.fontMetrics().bigOpSpacing2, d.fontMetrics().bigOpSpacing4 - eA.height)
    };
  }
  var iA;
  if (CA && IA) {
    var QA = d.fontMetrics().bigOpSpacing5 + IA.elem.height + IA.elem.depth + IA.kern + n.depth + AA;
    iA = buildCommon.makeVList({
      positionType: "bottom",
      positionData: QA,
      children: [{
        type: "kern",
        size: d.fontMetrics().bigOpSpacing5
      }, {
        type: "elem",
        elem: IA.elem,
        marginLeft: makeEm(-H)
      }, {
        type: "kern",
        size: IA.kern
      }, {
        type: "elem",
        elem: n
      }, {
        type: "kern",
        size: CA.kern
      }, {
        type: "elem",
        elem: CA.elem,
        marginLeft: makeEm(H)
      }, {
        type: "kern",
        size: d.fontMetrics().bigOpSpacing5
      }]
    }, d);
  } else if (IA) {
    var tA = n.height - AA;
    iA = buildCommon.makeVList({
      positionType: "top",
      positionData: tA,
      children: [{
        type: "kern",
        size: d.fontMetrics().bigOpSpacing5
      }, {
        type: "elem",
        elem: IA.elem,
        marginLeft: makeEm(-H)
      }, {
        type: "kern",
        size: IA.kern
      }, {
        type: "elem",
        elem: n
      }]
    }, d);
  } else if (CA) {
    var oA = n.depth + AA;
    iA = buildCommon.makeVList({
      positionType: "bottom",
      positionData: oA,
      children: [{
        type: "elem",
        elem: n
      }, {
        type: "kern",
        size: CA.kern
      }, {
        type: "elem",
        elem: CA.elem,
        marginLeft: makeEm(H)
      }, {
        type: "kern",
        size: d.fontMetrics().bigOpSpacing5
      }]
    }, d);
  } else
    return n;
  var EA = [iA];
  if (IA && H !== 0 && !gA) {
    var aA = buildCommon.makeSpan(["mspace"], [], d);
    aA.style.marginRight = makeEm(H), EA.unshift(aA);
  }
  return buildCommon.makeSpan(["mop", "op-limits"], EA, d);
}, noSuccessor = ["\\smallint"], htmlBuilder$2 = (n, t) => {
  var g, d, k = !1, H;
  n.type === "supsub" ? (g = n.sup, d = n.sub, H = assertNodeType(n.base, "op"), k = !0) : H = assertNodeType(n, "op");
  var AA = t.style, gA = !1;
  AA.size === Style$1.DISPLAY.size && H.symbol && !noSuccessor.includes(H.name) && (gA = !0);
  var IA;
  if (H.symbol) {
    var CA = gA ? "Size2-Regular" : "Size1-Regular", BA = "";
    if ((H.name === "\\oiint" || H.name === "\\oiiint") && (BA = H.name.slice(1), H.name = BA === "oiint" ? "\\iint" : "\\iiint"), IA = buildCommon.makeSymbol(H.name, CA, "math", t, ["mop", "op-symbol", gA ? "large-op" : "small-op"]), BA.length > 0) {
      var eA = IA.italic, iA = buildCommon.staticSvg(BA + "Size" + (gA ? "2" : "1"), t);
      IA = buildCommon.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: IA,
          shift: 0
        }, {
          type: "elem",
          elem: iA,
          shift: gA ? 0.08 : 0
        }]
      }, t), H.name = "\\" + BA, IA.classes.unshift("mop"), IA.italic = eA;
    }
  } else if (H.body) {
    var QA = buildExpression$1(H.body, t, !0);
    QA.length === 1 && QA[0] instanceof SymbolNode ? (IA = QA[0], IA.classes[0] = "mop") : IA = buildCommon.makeSpan(["mop"], QA, t);
  } else {
    for (var tA = [], oA = 1; oA < H.name.length; oA++)
      tA.push(buildCommon.mathsym(H.name[oA], H.mode, t));
    IA = buildCommon.makeSpan(["mop"], tA, t);
  }
  var EA = 0, aA = 0;
  return (IA instanceof SymbolNode || H.name === "\\oiint" || H.name === "\\oiiint") && !H.suppressBaseShift && (EA = (IA.height - IA.depth) / 2 - t.fontMetrics().axisHeight, aA = IA.italic), k ? assembleSupSub(IA, g, d, t, AA, aA, EA) : (EA && (IA.style.position = "relative", IA.style.top = makeEm(EA)), IA);
}, mathmlBuilder$1 = (n, t) => {
  var g;
  if (n.symbol)
    g = new MathNode("mo", [makeText(n.name, n.mode)]), noSuccessor.includes(n.name) && g.setAttribute("largeop", "false");
  else if (n.body)
    g = new MathNode("mo", buildExpression(n.body, t));
  else {
    g = new MathNode("mi", [new TextNode(n.name.slice(1))]);
    var d = new MathNode("mo", [makeText("⁡", "text")]);
    n.parentIsSupSub ? g = new MathNode("mrow", [g, d]) : g = newDocumentFragment([g, d]);
  }
  return g;
}, singleCharBigOps = {
  "∏": "\\prod",
  "∐": "\\coprod",
  "∑": "\\sum",
  "⋀": "\\bigwedge",
  "⋁": "\\bigvee",
  "⋂": "\\bigcap",
  "⋃": "\\bigcup",
  "⨀": "\\bigodot",
  "⨁": "\\bigoplus",
  "⨂": "\\bigotimes",
  "⨄": "\\biguplus",
  "⨆": "\\bigsqcup"
};
defineFunction({
  type: "op",
  names: ["\\coprod", "\\bigvee", "\\bigwedge", "\\biguplus", "\\bigcap", "\\bigcup", "\\intop", "\\prod", "\\sum", "\\bigotimes", "\\bigoplus", "\\bigodot", "\\bigsqcup", "\\smallint", "∏", "∐", "∑", "⋀", "⋁", "⋂", "⋃", "⨀", "⨁", "⨂", "⨄", "⨆"],
  props: {
    numArgs: 0
  },
  handler: (n, t) => {
    var {
      parser: g,
      funcName: d
    } = n, k = d;
    return k.length === 1 && (k = singleCharBigOps[k]), {
      type: "op",
      mode: g.mode,
      limits: !0,
      parentIsSupSub: !1,
      symbol: !0,
      name: k
    };
  },
  htmlBuilder: htmlBuilder$2,
  mathmlBuilder: mathmlBuilder$1
});
defineFunction({
  type: "op",
  names: ["\\mathop"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (n, t) => {
    var {
      parser: g
    } = n, d = t[0];
    return {
      type: "op",
      mode: g.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      body: ordargument(d)
    };
  },
  htmlBuilder: htmlBuilder$2,
  mathmlBuilder: mathmlBuilder$1
});
var singleCharIntegrals = {
  "∫": "\\int",
  "∬": "\\iint",
  "∭": "\\iiint",
  "∮": "\\oint",
  "∯": "\\oiint",
  "∰": "\\oiiint"
};
defineFunction({
  type: "op",
  names: ["\\arcsin", "\\arccos", "\\arctan", "\\arctg", "\\arcctg", "\\arg", "\\ch", "\\cos", "\\cosec", "\\cosh", "\\cot", "\\cotg", "\\coth", "\\csc", "\\ctg", "\\cth", "\\deg", "\\dim", "\\exp", "\\hom", "\\ker", "\\lg", "\\ln", "\\log", "\\sec", "\\sin", "\\sinh", "\\sh", "\\tan", "\\tanh", "\\tg", "\\th"],
  props: {
    numArgs: 0
  },
  handler(n) {
    var {
      parser: t,
      funcName: g
    } = n;
    return {
      type: "op",
      mode: t.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      name: g
    };
  },
  htmlBuilder: htmlBuilder$2,
  mathmlBuilder: mathmlBuilder$1
});
defineFunction({
  type: "op",
  names: ["\\det", "\\gcd", "\\inf", "\\lim", "\\max", "\\min", "\\Pr", "\\sup"],
  props: {
    numArgs: 0
  },
  handler(n) {
    var {
      parser: t,
      funcName: g
    } = n;
    return {
      type: "op",
      mode: t.mode,
      limits: !0,
      parentIsSupSub: !1,
      symbol: !1,
      name: g
    };
  },
  htmlBuilder: htmlBuilder$2,
  mathmlBuilder: mathmlBuilder$1
});
defineFunction({
  type: "op",
  names: ["\\int", "\\iint", "\\iiint", "\\oint", "\\oiint", "\\oiiint", "∫", "∬", "∭", "∮", "∯", "∰"],
  props: {
    numArgs: 0
  },
  handler(n) {
    var {
      parser: t,
      funcName: g
    } = n, d = g;
    return d.length === 1 && (d = singleCharIntegrals[d]), {
      type: "op",
      mode: t.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !0,
      name: d
    };
  },
  htmlBuilder: htmlBuilder$2,
  mathmlBuilder: mathmlBuilder$1
});
var htmlBuilder$1 = (n, t) => {
  var g, d, k = !1, H;
  n.type === "supsub" ? (g = n.sup, d = n.sub, H = assertNodeType(n.base, "operatorname"), k = !0) : H = assertNodeType(n, "operatorname");
  var AA;
  if (H.body.length > 0) {
    for (var gA = H.body.map((eA) => {
      var iA = eA.text;
      return typeof iA == "string" ? {
        type: "textord",
        mode: eA.mode,
        text: iA
      } : eA;
    }), IA = buildExpression$1(gA, t.withFont("mathrm"), !0), CA = 0; CA < IA.length; CA++) {
      var BA = IA[CA];
      BA instanceof SymbolNode && (BA.text = BA.text.replace(/\u2212/, "-").replace(/\u2217/, "*"));
    }
    AA = buildCommon.makeSpan(["mop"], IA, t);
  } else
    AA = buildCommon.makeSpan(["mop"], [], t);
  return k ? assembleSupSub(AA, g, d, t, t.style, 0, 0) : AA;
}, mathmlBuilder = (n, t) => {
  for (var g = buildExpression(n.body, t.withFont("mathrm")), d = !0, k = 0; k < g.length; k++) {
    var H = g[k];
    if (!(H instanceof mathMLTree.SpaceNode)) if (H instanceof mathMLTree.MathNode)
      switch (H.type) {
        case "mi":
        case "mn":
        case "ms":
        case "mspace":
        case "mtext":
          break;
        // Do nothing yet.
        case "mo": {
          var AA = H.children[0];
          H.children.length === 1 && AA instanceof mathMLTree.TextNode ? AA.text = AA.text.replace(/\u2212/, "-").replace(/\u2217/, "*") : d = !1;
          break;
        }
        default:
          d = !1;
      }
    else
      d = !1;
  }
  if (d) {
    var gA = g.map((BA) => BA.toText()).join("");
    g = [new mathMLTree.TextNode(gA)];
  }
  var IA = new mathMLTree.MathNode("mi", g);
  IA.setAttribute("mathvariant", "normal");
  var CA = new mathMLTree.MathNode("mo", [makeText("⁡", "text")]);
  return n.parentIsSupSub ? new mathMLTree.MathNode("mrow", [IA, CA]) : mathMLTree.newDocumentFragment([IA, CA]);
};
defineFunction({
  type: "operatorname",
  names: ["\\operatorname@", "\\operatornamewithlimits"],
  props: {
    numArgs: 1
  },
  handler: (n, t) => {
    var {
      parser: g,
      funcName: d
    } = n, k = t[0];
    return {
      type: "operatorname",
      mode: g.mode,
      body: ordargument(k),
      alwaysHandleSupSub: d === "\\operatornamewithlimits",
      limits: !1,
      parentIsSupSub: !1
    };
  },
  htmlBuilder: htmlBuilder$1,
  mathmlBuilder
});
defineMacro("\\operatorname", "\\@ifstar\\operatornamewithlimits\\operatorname@");
defineFunctionBuilders({
  type: "ordgroup",
  htmlBuilder(n, t) {
    return n.semisimple ? buildCommon.makeFragment(buildExpression$1(n.body, t, !1)) : buildCommon.makeSpan(["mord"], buildExpression$1(n.body, t, !0), t);
  },
  mathmlBuilder(n, t) {
    return buildExpressionRow(n.body, t, !0);
  }
});
defineFunction({
  type: "overline",
  names: ["\\overline"],
  props: {
    numArgs: 1
  },
  handler(n, t) {
    var {
      parser: g
    } = n, d = t[0];
    return {
      type: "overline",
      mode: g.mode,
      body: d
    };
  },
  htmlBuilder(n, t) {
    var g = buildGroup$1(n.body, t.havingCrampedStyle()), d = buildCommon.makeLineSpan("overline-line", t), k = t.fontMetrics().defaultRuleThickness, H = buildCommon.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: g
      }, {
        type: "kern",
        size: 3 * k
      }, {
        type: "elem",
        elem: d
      }, {
        type: "kern",
        size: k
      }]
    }, t);
    return buildCommon.makeSpan(["mord", "overline"], [H], t);
  },
  mathmlBuilder(n, t) {
    var g = new mathMLTree.MathNode("mo", [new mathMLTree.TextNode("‾")]);
    g.setAttribute("stretchy", "true");
    var d = new mathMLTree.MathNode("mover", [buildGroup(n.body, t), g]);
    return d.setAttribute("accent", "true"), d;
  }
});
defineFunction({
  type: "phantom",
  names: ["\\phantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (n, t) => {
    var {
      parser: g
    } = n, d = t[0];
    return {
      type: "phantom",
      mode: g.mode,
      body: ordargument(d)
    };
  },
  htmlBuilder: (n, t) => {
    var g = buildExpression$1(n.body, t.withPhantom(), !1);
    return buildCommon.makeFragment(g);
  },
  mathmlBuilder: (n, t) => {
    var g = buildExpression(n.body, t);
    return new mathMLTree.MathNode("mphantom", g);
  }
});
defineFunction({
  type: "hphantom",
  names: ["\\hphantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (n, t) => {
    var {
      parser: g
    } = n, d = t[0];
    return {
      type: "hphantom",
      mode: g.mode,
      body: d
    };
  },
  htmlBuilder: (n, t) => {
    var g = buildCommon.makeSpan([], [buildGroup$1(n.body, t.withPhantom())]);
    if (g.height = 0, g.depth = 0, g.children)
      for (var d = 0; d < g.children.length; d++)
        g.children[d].height = 0, g.children[d].depth = 0;
    return g = buildCommon.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: g
      }]
    }, t), buildCommon.makeSpan(["mord"], [g], t);
  },
  mathmlBuilder: (n, t) => {
    var g = buildExpression(ordargument(n.body), t), d = new mathMLTree.MathNode("mphantom", g), k = new mathMLTree.MathNode("mpadded", [d]);
    return k.setAttribute("height", "0px"), k.setAttribute("depth", "0px"), k;
  }
});
defineFunction({
  type: "vphantom",
  names: ["\\vphantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (n, t) => {
    var {
      parser: g
    } = n, d = t[0];
    return {
      type: "vphantom",
      mode: g.mode,
      body: d
    };
  },
  htmlBuilder: (n, t) => {
    var g = buildCommon.makeSpan(["inner"], [buildGroup$1(n.body, t.withPhantom())]), d = buildCommon.makeSpan(["fix"], []);
    return buildCommon.makeSpan(["mord", "rlap"], [g, d], t);
  },
  mathmlBuilder: (n, t) => {
    var g = buildExpression(ordargument(n.body), t), d = new mathMLTree.MathNode("mphantom", g), k = new mathMLTree.MathNode("mpadded", [d]);
    return k.setAttribute("width", "0px"), k;
  }
});
defineFunction({
  type: "raisebox",
  names: ["\\raisebox"],
  props: {
    numArgs: 2,
    argTypes: ["size", "hbox"],
    allowedInText: !0
  },
  handler(n, t) {
    var {
      parser: g
    } = n, d = assertNodeType(t[0], "size").value, k = t[1];
    return {
      type: "raisebox",
      mode: g.mode,
      dy: d,
      body: k
    };
  },
  htmlBuilder(n, t) {
    var g = buildGroup$1(n.body, t), d = calculateSize(n.dy, t);
    return buildCommon.makeVList({
      positionType: "shift",
      positionData: -d,
      children: [{
        type: "elem",
        elem: g
      }]
    }, t);
  },
  mathmlBuilder(n, t) {
    var g = new mathMLTree.MathNode("mpadded", [buildGroup(n.body, t)]), d = n.dy.number + n.dy.unit;
    return g.setAttribute("voffset", d), g;
  }
});
defineFunction({
  type: "internal",
  names: ["\\relax"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInArgument: !0
  },
  handler(n) {
    var {
      parser: t
    } = n;
    return {
      type: "internal",
      mode: t.mode
    };
  }
});
defineFunction({
  type: "rule",
  names: ["\\rule"],
  props: {
    numArgs: 2,
    numOptionalArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    argTypes: ["size", "size", "size"]
  },
  handler(n, t, g) {
    var {
      parser: d
    } = n, k = g[0], H = assertNodeType(t[0], "size"), AA = assertNodeType(t[1], "size");
    return {
      type: "rule",
      mode: d.mode,
      shift: k && assertNodeType(k, "size").value,
      width: H.value,
      height: AA.value
    };
  },
  htmlBuilder(n, t) {
    var g = buildCommon.makeSpan(["mord", "rule"], [], t), d = calculateSize(n.width, t), k = calculateSize(n.height, t), H = n.shift ? calculateSize(n.shift, t) : 0;
    return g.style.borderRightWidth = makeEm(d), g.style.borderTopWidth = makeEm(k), g.style.bottom = makeEm(H), g.width = d, g.height = k + H, g.depth = -H, g.maxFontSize = k * 1.125 * t.sizeMultiplier, g;
  },
  mathmlBuilder(n, t) {
    var g = calculateSize(n.width, t), d = calculateSize(n.height, t), k = n.shift ? calculateSize(n.shift, t) : 0, H = t.color && t.getColor() || "black", AA = new mathMLTree.MathNode("mspace");
    AA.setAttribute("mathbackground", H), AA.setAttribute("width", makeEm(g)), AA.setAttribute("height", makeEm(d));
    var gA = new mathMLTree.MathNode("mpadded", [AA]);
    return k >= 0 ? gA.setAttribute("height", makeEm(k)) : (gA.setAttribute("height", makeEm(k)), gA.setAttribute("depth", makeEm(-k))), gA.setAttribute("voffset", makeEm(k)), gA;
  }
});
function sizingGroup(n, t, g) {
  for (var d = buildExpression$1(n, t, !1), k = t.sizeMultiplier / g.sizeMultiplier, H = 0; H < d.length; H++) {
    var AA = d[H].classes.indexOf("sizing");
    AA < 0 ? Array.prototype.push.apply(d[H].classes, t.sizingClasses(g)) : d[H].classes[AA + 1] === "reset-size" + t.size && (d[H].classes[AA + 1] = "reset-size" + g.size), d[H].height *= k, d[H].depth *= k;
  }
  return buildCommon.makeFragment(d);
}
var sizeFuncs = ["\\tiny", "\\sixptsize", "\\scriptsize", "\\footnotesize", "\\small", "\\normalsize", "\\large", "\\Large", "\\LARGE", "\\huge", "\\Huge"], htmlBuilder = (n, t) => {
  var g = t.havingSize(n.size);
  return sizingGroup(n.body, g, t);
};
defineFunction({
  type: "sizing",
  names: sizeFuncs,
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler: (n, t) => {
    var {
      breakOnTokenText: g,
      funcName: d,
      parser: k
    } = n, H = k.parseExpression(!1, g);
    return {
      type: "sizing",
      mode: k.mode,
      // Figure out what size to use based on the list of functions above
      size: sizeFuncs.indexOf(d) + 1,
      body: H
    };
  },
  htmlBuilder,
  mathmlBuilder: (n, t) => {
    var g = t.havingSize(n.size), d = buildExpression(n.body, g), k = new mathMLTree.MathNode("mstyle", d);
    return k.setAttribute("mathsize", makeEm(g.sizeMultiplier)), k;
  }
});
defineFunction({
  type: "smash",
  names: ["\\smash"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1,
    allowedInText: !0
  },
  handler: (n, t, g) => {
    var {
      parser: d
    } = n, k = !1, H = !1, AA = g[0] && assertNodeType(g[0], "ordgroup");
    if (AA)
      for (var gA = "", IA = 0; IA < AA.body.length; ++IA) {
        var CA = AA.body[IA];
        if (gA = CA.text, gA === "t")
          k = !0;
        else if (gA === "b")
          H = !0;
        else {
          k = !1, H = !1;
          break;
        }
      }
    else
      k = !0, H = !0;
    var BA = t[0];
    return {
      type: "smash",
      mode: d.mode,
      body: BA,
      smashHeight: k,
      smashDepth: H
    };
  },
  htmlBuilder: (n, t) => {
    var g = buildCommon.makeSpan([], [buildGroup$1(n.body, t)]);
    if (!n.smashHeight && !n.smashDepth)
      return g;
    if (n.smashHeight && (g.height = 0, g.children))
      for (var d = 0; d < g.children.length; d++)
        g.children[d].height = 0;
    if (n.smashDepth && (g.depth = 0, g.children))
      for (var k = 0; k < g.children.length; k++)
        g.children[k].depth = 0;
    var H = buildCommon.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: g
      }]
    }, t);
    return buildCommon.makeSpan(["mord"], [H], t);
  },
  mathmlBuilder: (n, t) => {
    var g = new mathMLTree.MathNode("mpadded", [buildGroup(n.body, t)]);
    return n.smashHeight && g.setAttribute("height", "0px"), n.smashDepth && g.setAttribute("depth", "0px"), g;
  }
});
defineFunction({
  type: "sqrt",
  names: ["\\sqrt"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1
  },
  handler(n, t, g) {
    var {
      parser: d
    } = n, k = g[0], H = t[0];
    return {
      type: "sqrt",
      mode: d.mode,
      body: H,
      index: k
    };
  },
  htmlBuilder(n, t) {
    var g = buildGroup$1(n.body, t.havingCrampedStyle());
    g.height === 0 && (g.height = t.fontMetrics().xHeight), g = buildCommon.wrapFragment(g, t);
    var d = t.fontMetrics(), k = d.defaultRuleThickness, H = k;
    t.style.id < Style$1.TEXT.id && (H = t.fontMetrics().xHeight);
    var AA = k + H / 4, gA = g.height + g.depth + AA + k, {
      span: IA,
      ruleWidth: CA,
      advanceWidth: BA
    } = delimiter.sqrtImage(gA, t), eA = IA.height - CA;
    eA > g.height + g.depth + AA && (AA = (AA + eA - g.height - g.depth) / 2);
    var iA = IA.height - g.height - AA - CA;
    g.style.paddingLeft = makeEm(BA);
    var QA = buildCommon.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: g,
        wrapperClasses: ["svg-align"]
      }, {
        type: "kern",
        size: -(g.height + iA)
      }, {
        type: "elem",
        elem: IA
      }, {
        type: "kern",
        size: CA
      }]
    }, t);
    if (n.index) {
      var tA = t.havingStyle(Style$1.SCRIPTSCRIPT), oA = buildGroup$1(n.index, tA, t), EA = 0.6 * (QA.height - QA.depth), aA = buildCommon.makeVList({
        positionType: "shift",
        positionData: -EA,
        children: [{
          type: "elem",
          elem: oA
        }]
      }, t), nA = buildCommon.makeSpan(["root"], [aA]);
      return buildCommon.makeSpan(["mord", "sqrt"], [nA, QA], t);
    } else
      return buildCommon.makeSpan(["mord", "sqrt"], [QA], t);
  },
  mathmlBuilder(n, t) {
    var {
      body: g,
      index: d
    } = n;
    return d ? new mathMLTree.MathNode("mroot", [buildGroup(g, t), buildGroup(d, t)]) : new mathMLTree.MathNode("msqrt", [buildGroup(g, t)]);
  }
});
var styleMap = {
  display: Style$1.DISPLAY,
  text: Style$1.TEXT,
  script: Style$1.SCRIPT,
  scriptscript: Style$1.SCRIPTSCRIPT
};
defineFunction({
  type: "styling",
  names: ["\\displaystyle", "\\textstyle", "\\scriptstyle", "\\scriptscriptstyle"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(n, t) {
    var {
      breakOnTokenText: g,
      funcName: d,
      parser: k
    } = n, H = k.parseExpression(!0, g), AA = d.slice(1, d.length - 5);
    return {
      type: "styling",
      mode: k.mode,
      // Figure out what style to use by pulling out the style from
      // the function name
      style: AA,
      body: H
    };
  },
  htmlBuilder(n, t) {
    var g = styleMap[n.style], d = t.havingStyle(g).withFont("");
    return sizingGroup(n.body, d, t);
  },
  mathmlBuilder(n, t) {
    var g = styleMap[n.style], d = t.havingStyle(g), k = buildExpression(n.body, d), H = new mathMLTree.MathNode("mstyle", k), AA = {
      display: ["0", "true"],
      text: ["0", "false"],
      script: ["1", "false"],
      scriptscript: ["2", "false"]
    }, gA = AA[n.style];
    return H.setAttribute("scriptlevel", gA[0]), H.setAttribute("displaystyle", gA[1]), H;
  }
});
var htmlBuilderDelegate = function n(t, g) {
  var d = t.base;
  if (d)
    if (d.type === "op") {
      var k = d.limits && (g.style.size === Style$1.DISPLAY.size || d.alwaysHandleSupSub);
      return k ? htmlBuilder$2 : null;
    } else if (d.type === "operatorname") {
      var H = d.alwaysHandleSupSub && (g.style.size === Style$1.DISPLAY.size || d.limits);
      return H ? htmlBuilder$1 : null;
    } else {
      if (d.type === "accent")
        return utils$2.isCharacterBox(d.base) ? htmlBuilder$a : null;
      if (d.type === "horizBrace") {
        var AA = !t.sub;
        return AA === d.isOver ? htmlBuilder$3 : null;
      } else
        return null;
    }
  else return null;
};
defineFunctionBuilders({
  type: "supsub",
  htmlBuilder(n, t) {
    var g = htmlBuilderDelegate(n, t);
    if (g)
      return g(n, t);
    var {
      base: d,
      sup: k,
      sub: H
    } = n, AA = buildGroup$1(d, t), gA, IA, CA = t.fontMetrics(), BA = 0, eA = 0, iA = d && utils$2.isCharacterBox(d);
    if (k) {
      var QA = t.havingStyle(t.style.sup());
      gA = buildGroup$1(k, QA, t), iA || (BA = AA.height - QA.fontMetrics().supDrop * QA.sizeMultiplier / t.sizeMultiplier);
    }
    if (H) {
      var tA = t.havingStyle(t.style.sub());
      IA = buildGroup$1(H, tA, t), iA || (eA = AA.depth + tA.fontMetrics().subDrop * tA.sizeMultiplier / t.sizeMultiplier);
    }
    var oA;
    t.style === Style$1.DISPLAY ? oA = CA.sup1 : t.style.cramped ? oA = CA.sup3 : oA = CA.sup2;
    var EA = t.sizeMultiplier, aA = makeEm(0.5 / CA.ptPerEm / EA), nA = null;
    if (IA) {
      var lA = n.base && n.base.type === "op" && n.base.name && (n.base.name === "\\oiint" || n.base.name === "\\oiiint");
      (AA instanceof SymbolNode || lA) && (nA = makeEm(-AA.italic));
    }
    var cA;
    if (gA && IA) {
      BA = Math.max(BA, oA, gA.depth + 0.25 * CA.xHeight), eA = Math.max(eA, CA.sub2);
      var sA = CA.defaultRuleThickness, rA = 4 * sA;
      if (BA - gA.depth - (IA.height - eA) < rA) {
        eA = rA - (BA - gA.depth) + IA.height;
        var uA = 0.8 * CA.xHeight - (BA - gA.depth);
        uA > 0 && (BA += uA, eA -= uA);
      }
      var hA = [{
        type: "elem",
        elem: IA,
        shift: eA,
        marginRight: aA,
        marginLeft: nA
      }, {
        type: "elem",
        elem: gA,
        shift: -BA,
        marginRight: aA
      }];
      cA = buildCommon.makeVList({
        positionType: "individualShift",
        children: hA
      }, t);
    } else if (IA) {
      eA = Math.max(eA, CA.sub1, IA.height - 0.8 * CA.xHeight);
      var dA = [{
        type: "elem",
        elem: IA,
        marginLeft: nA,
        marginRight: aA
      }];
      cA = buildCommon.makeVList({
        positionType: "shift",
        positionData: eA,
        children: dA
      }, t);
    } else if (gA)
      BA = Math.max(BA, oA, gA.depth + 0.25 * CA.xHeight), cA = buildCommon.makeVList({
        positionType: "shift",
        positionData: -BA,
        children: [{
          type: "elem",
          elem: gA,
          marginRight: aA
        }]
      }, t);
    else
      throw new Error("supsub must have either sup or sub.");
    var GA = getTypeOfDomTree(AA, "right") || "mord";
    return buildCommon.makeSpan([GA], [AA, buildCommon.makeSpan(["msupsub"], [cA])], t);
  },
  mathmlBuilder(n, t) {
    var g = !1, d, k;
    n.base && n.base.type === "horizBrace" && (k = !!n.sup, k === n.base.isOver && (g = !0, d = n.base.isOver)), n.base && (n.base.type === "op" || n.base.type === "operatorname") && (n.base.parentIsSupSub = !0);
    var H = [buildGroup(n.base, t)];
    n.sub && H.push(buildGroup(n.sub, t)), n.sup && H.push(buildGroup(n.sup, t));
    var AA;
    if (g)
      AA = d ? "mover" : "munder";
    else if (n.sub)
      if (n.sup) {
        var CA = n.base;
        CA && CA.type === "op" && CA.limits && t.style === Style$1.DISPLAY || CA && CA.type === "operatorname" && CA.alwaysHandleSupSub && (t.style === Style$1.DISPLAY || CA.limits) ? AA = "munderover" : AA = "msubsup";
      } else {
        var IA = n.base;
        IA && IA.type === "op" && IA.limits && (t.style === Style$1.DISPLAY || IA.alwaysHandleSupSub) || IA && IA.type === "operatorname" && IA.alwaysHandleSupSub && (IA.limits || t.style === Style$1.DISPLAY) ? AA = "munder" : AA = "msub";
      }
    else {
      var gA = n.base;
      gA && gA.type === "op" && gA.limits && (t.style === Style$1.DISPLAY || gA.alwaysHandleSupSub) || gA && gA.type === "operatorname" && gA.alwaysHandleSupSub && (gA.limits || t.style === Style$1.DISPLAY) ? AA = "mover" : AA = "msup";
    }
    return new mathMLTree.MathNode(AA, H);
  }
});
defineFunctionBuilders({
  type: "atom",
  htmlBuilder(n, t) {
    return buildCommon.mathsym(n.text, n.mode, t, ["m" + n.family]);
  },
  mathmlBuilder(n, t) {
    var g = new mathMLTree.MathNode("mo", [makeText(n.text, n.mode)]);
    if (n.family === "bin") {
      var d = getVariant(n, t);
      d === "bold-italic" && g.setAttribute("mathvariant", d);
    } else n.family === "punct" ? g.setAttribute("separator", "true") : (n.family === "open" || n.family === "close") && g.setAttribute("stretchy", "false");
    return g;
  }
});
var defaultVariant = {
  mi: "italic",
  mn: "normal",
  mtext: "normal"
};
defineFunctionBuilders({
  type: "mathord",
  htmlBuilder(n, t) {
    return buildCommon.makeOrd(n, t, "mathord");
  },
  mathmlBuilder(n, t) {
    var g = new mathMLTree.MathNode("mi", [makeText(n.text, n.mode, t)]), d = getVariant(n, t) || "italic";
    return d !== defaultVariant[g.type] && g.setAttribute("mathvariant", d), g;
  }
});
defineFunctionBuilders({
  type: "textord",
  htmlBuilder(n, t) {
    return buildCommon.makeOrd(n, t, "textord");
  },
  mathmlBuilder(n, t) {
    var g = makeText(n.text, n.mode, t), d = getVariant(n, t) || "normal", k;
    return n.mode === "text" ? k = new mathMLTree.MathNode("mtext", [g]) : /[0-9]/.test(n.text) ? k = new mathMLTree.MathNode("mn", [g]) : n.text === "\\prime" ? k = new mathMLTree.MathNode("mo", [g]) : k = new mathMLTree.MathNode("mi", [g]), d !== defaultVariant[k.type] && k.setAttribute("mathvariant", d), k;
  }
});
var cssSpace = {
  "\\nobreak": "nobreak",
  "\\allowbreak": "allowbreak"
}, regularSpace = {
  " ": {},
  "\\ ": {},
  "~": {
    className: "nobreak"
  },
  "\\space": {},
  "\\nobreakspace": {
    className: "nobreak"
  }
};
defineFunctionBuilders({
  type: "spacing",
  htmlBuilder(n, t) {
    if (regularSpace.hasOwnProperty(n.text)) {
      var g = regularSpace[n.text].className || "";
      if (n.mode === "text") {
        var d = buildCommon.makeOrd(n, t, "textord");
        return d.classes.push(g), d;
      } else
        return buildCommon.makeSpan(["mspace", g], [buildCommon.mathsym(n.text, n.mode, t)], t);
    } else {
      if (cssSpace.hasOwnProperty(n.text))
        return buildCommon.makeSpan(["mspace", cssSpace[n.text]], [], t);
      throw new ParseError('Unknown type of space "' + n.text + '"');
    }
  },
  mathmlBuilder(n, t) {
    var g;
    if (regularSpace.hasOwnProperty(n.text))
      g = new mathMLTree.MathNode("mtext", [new mathMLTree.TextNode(" ")]);
    else {
      if (cssSpace.hasOwnProperty(n.text))
        return new mathMLTree.MathNode("mspace");
      throw new ParseError('Unknown type of space "' + n.text + '"');
    }
    return g;
  }
});
var pad$3 = () => {
  var n = new mathMLTree.MathNode("mtd", []);
  return n.setAttribute("width", "50%"), n;
};
defineFunctionBuilders({
  type: "tag",
  mathmlBuilder(n, t) {
    var g = new mathMLTree.MathNode("mtable", [new mathMLTree.MathNode("mtr", [pad$3(), new mathMLTree.MathNode("mtd", [buildExpressionRow(n.body, t)]), pad$3(), new mathMLTree.MathNode("mtd", [buildExpressionRow(n.tag, t)])])]);
    return g.setAttribute("width", "100%"), g;
  }
});
var textFontFamilies = {
  "\\text": void 0,
  "\\textrm": "textrm",
  "\\textsf": "textsf",
  "\\texttt": "texttt",
  "\\textnormal": "textrm"
}, textFontWeights = {
  "\\textbf": "textbf",
  "\\textmd": "textmd"
}, textFontShapes = {
  "\\textit": "textit",
  "\\textup": "textup"
}, optionsWithFont = (n, t) => {
  var g = n.font;
  if (g) {
    if (textFontFamilies[g])
      return t.withTextFontFamily(textFontFamilies[g]);
    if (textFontWeights[g])
      return t.withTextFontWeight(textFontWeights[g]);
    if (g === "\\emph")
      return t.fontShape === "textit" ? t.withTextFontShape("textup") : t.withTextFontShape("textit");
  } else return t;
  return t.withTextFontShape(textFontShapes[g]);
};
defineFunction({
  type: "text",
  names: [
    // Font families
    "\\text",
    "\\textrm",
    "\\textsf",
    "\\texttt",
    "\\textnormal",
    // Font weights
    "\\textbf",
    "\\textmd",
    // Font Shapes
    "\\textit",
    "\\textup",
    "\\emph"
  ],
  props: {
    numArgs: 1,
    argTypes: ["text"],
    allowedInArgument: !0,
    allowedInText: !0
  },
  handler(n, t) {
    var {
      parser: g,
      funcName: d
    } = n, k = t[0];
    return {
      type: "text",
      mode: g.mode,
      body: ordargument(k),
      font: d
    };
  },
  htmlBuilder(n, t) {
    var g = optionsWithFont(n, t), d = buildExpression$1(n.body, g, !0);
    return buildCommon.makeSpan(["mord", "text"], d, g);
  },
  mathmlBuilder(n, t) {
    var g = optionsWithFont(n, t);
    return buildExpressionRow(n.body, g);
  }
});
defineFunction({
  type: "underline",
  names: ["\\underline"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(n, t) {
    var {
      parser: g
    } = n;
    return {
      type: "underline",
      mode: g.mode,
      body: t[0]
    };
  },
  htmlBuilder(n, t) {
    var g = buildGroup$1(n.body, t), d = buildCommon.makeLineSpan("underline-line", t), k = t.fontMetrics().defaultRuleThickness, H = buildCommon.makeVList({
      positionType: "top",
      positionData: g.height,
      children: [{
        type: "kern",
        size: k
      }, {
        type: "elem",
        elem: d
      }, {
        type: "kern",
        size: 3 * k
      }, {
        type: "elem",
        elem: g
      }]
    }, t);
    return buildCommon.makeSpan(["mord", "underline"], [H], t);
  },
  mathmlBuilder(n, t) {
    var g = new mathMLTree.MathNode("mo", [new mathMLTree.TextNode("‾")]);
    g.setAttribute("stretchy", "true");
    var d = new mathMLTree.MathNode("munder", [buildGroup(n.body, t), g]);
    return d.setAttribute("accentunder", "true"), d;
  }
});
defineFunction({
  type: "vcenter",
  names: ["\\vcenter"],
  props: {
    numArgs: 1,
    argTypes: ["original"],
    // In LaTeX, \vcenter can act only on a box.
    allowedInText: !1
  },
  handler(n, t) {
    var {
      parser: g
    } = n;
    return {
      type: "vcenter",
      mode: g.mode,
      body: t[0]
    };
  },
  htmlBuilder(n, t) {
    var g = buildGroup$1(n.body, t), d = t.fontMetrics().axisHeight, k = 0.5 * (g.height - d - (g.depth + d));
    return buildCommon.makeVList({
      positionType: "shift",
      positionData: k,
      children: [{
        type: "elem",
        elem: g
      }]
    }, t);
  },
  mathmlBuilder(n, t) {
    return new mathMLTree.MathNode("mpadded", [buildGroup(n.body, t)], ["vcenter"]);
  }
});
defineFunction({
  type: "verb",
  names: ["\\verb"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(n, t, g) {
    throw new ParseError("\\verb ended by end of line instead of matching delimiter");
  },
  htmlBuilder(n, t) {
    for (var g = makeVerb(n), d = [], k = t.havingStyle(t.style.text()), H = 0; H < g.length; H++) {
      var AA = g[H];
      AA === "~" && (AA = "\\textasciitilde"), d.push(buildCommon.makeSymbol(AA, "Typewriter-Regular", n.mode, k, ["mord", "texttt"]));
    }
    return buildCommon.makeSpan(["mord", "text"].concat(k.sizingClasses(t)), buildCommon.tryCombineChars(d), k);
  },
  mathmlBuilder(n, t) {
    var g = new mathMLTree.TextNode(makeVerb(n)), d = new mathMLTree.MathNode("mtext", [g]);
    return d.setAttribute("mathvariant", "monospace"), d;
  }
});
var makeVerb = (n) => n.body.replace(/ /g, n.star ? "␣" : " "), functions = _functions, spaceRegexString = `[ \r
	]`, controlWordRegexString = "\\\\[a-zA-Z@]+", controlSymbolRegexString = "\\\\[^\uD800-\uDFFF]", controlWordWhitespaceRegexString = "(" + controlWordRegexString + ")" + spaceRegexString + "*", controlSpaceRegexString = `\\\\(
|[ \r	]+
?)[ \r	]*`, combiningDiacriticalMarkString = "[̀-ͯ]", combiningDiacriticalMarksEndRegex = new RegExp(combiningDiacriticalMarkString + "+$"), tokenRegexString = "(" + spaceRegexString + "+)|" + // whitespace
(controlSpaceRegexString + "|") + // \whitespace
"([!-\\[\\]-‧‪-퟿豈-￿]" + // single codepoint
(combiningDiacriticalMarkString + "*") + // ...plus accents
"|[\uD800-\uDBFF][\uDC00-\uDFFF]" + // surrogate pair
(combiningDiacriticalMarkString + "*") + // ...plus accents
"|\\\\verb\\*([^]).*?\\4|\\\\verb([^*a-zA-Z]).*?\\5" + // \verb unstarred
("|" + controlWordWhitespaceRegexString) + // \macroName + spaces
("|" + controlSymbolRegexString + ")");
class Lexer {
  // Category codes. The lexer only supports comment characters (14) for now.
  // MacroExpander additionally distinguishes active (13).
  constructor(t, g) {
    this.input = void 0, this.settings = void 0, this.tokenRegex = void 0, this.catcodes = void 0, this.input = t, this.settings = g, this.tokenRegex = new RegExp(tokenRegexString, "g"), this.catcodes = {
      "%": 14,
      // comment character
      "~": 13
      // active character
    };
  }
  setCatcode(t, g) {
    this.catcodes[t] = g;
  }
  /**
   * This function lexes a single token.
   */
  lex() {
    var t = this.input, g = this.tokenRegex.lastIndex;
    if (g === t.length)
      return new Token("EOF", new SourceLocation(this, g, g));
    var d = this.tokenRegex.exec(t);
    if (d === null || d.index !== g)
      throw new ParseError("Unexpected character: '" + t[g] + "'", new Token(t[g], new SourceLocation(this, g, g + 1)));
    var k = d[6] || d[3] || (d[2] ? "\\ " : " ");
    if (this.catcodes[k] === 14) {
      var H = t.indexOf(`
`, this.tokenRegex.lastIndex);
      return H === -1 ? (this.tokenRegex.lastIndex = t.length, this.settings.reportNonstrict("commentAtEnd", "% comment has no terminating newline; LaTeX would fail because of commenting the end of math mode (e.g. $)")) : this.tokenRegex.lastIndex = H + 1, this.lex();
    }
    return new Token(k, new SourceLocation(this, g, this.tokenRegex.lastIndex));
  }
}
class Namespace {
  /**
   * Both arguments are optional.  The first argument is an object of
   * built-in mappings which never change.  The second argument is an object
   * of initial (global-level) mappings, which will constantly change
   * according to any global/top-level `set`s done.
   */
  constructor(t, g) {
    t === void 0 && (t = {}), g === void 0 && (g = {}), this.current = void 0, this.builtins = void 0, this.undefStack = void 0, this.current = g, this.builtins = t, this.undefStack = [];
  }
  /**
   * Start a new nested group, affecting future local `set`s.
   */
  beginGroup() {
    this.undefStack.push({});
  }
  /**
   * End current nested group, restoring values before the group began.
   */
  endGroup() {
    if (this.undefStack.length === 0)
      throw new ParseError("Unbalanced namespace destruction: attempt to pop global namespace; please report this as a bug");
    var t = this.undefStack.pop();
    for (var g in t)
      t.hasOwnProperty(g) && (t[g] == null ? delete this.current[g] : this.current[g] = t[g]);
  }
  /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */
  endGroups() {
    for (; this.undefStack.length > 0; )
      this.endGroup();
  }
  /**
   * Detect whether `name` has a definition.  Equivalent to
   * `get(name) != null`.
   */
  has(t) {
    return this.current.hasOwnProperty(t) || this.builtins.hasOwnProperty(t);
  }
  /**
   * Get the current value of a name, or `undefined` if there is no value.
   *
   * Note: Do not use `if (namespace.get(...))` to detect whether a macro
   * is defined, as the definition may be the empty string which evaluates
   * to `false` in JavaScript.  Use `if (namespace.get(...) != null)` or
   * `if (namespace.has(...))`.
   */
  get(t) {
    return this.current.hasOwnProperty(t) ? this.current[t] : this.builtins[t];
  }
  /**
   * Set the current value of a name, and optionally set it globally too.
   * Local set() sets the current value and (when appropriate) adds an undo
   * operation to the undo stack.  Global set() may change the undo
   * operation at every level, so takes time linear in their number.
   * A value of undefined means to delete existing definitions.
   */
  set(t, g, d) {
    if (d === void 0 && (d = !1), d) {
      for (var k = 0; k < this.undefStack.length; k++)
        delete this.undefStack[k][t];
      this.undefStack.length > 0 && (this.undefStack[this.undefStack.length - 1][t] = g);
    } else {
      var H = this.undefStack[this.undefStack.length - 1];
      H && !H.hasOwnProperty(t) && (H[t] = this.current[t]);
    }
    g == null ? delete this.current[t] : this.current[t] = g;
  }
}
var macros = _macros;
defineMacro("\\noexpand", function(n) {
  var t = n.popToken();
  return n.isExpandable(t.text) && (t.noexpand = !0, t.treatAsRelax = !0), {
    tokens: [t],
    numArgs: 0
  };
});
defineMacro("\\expandafter", function(n) {
  var t = n.popToken();
  return n.expandOnce(!0), {
    tokens: [t],
    numArgs: 0
  };
});
defineMacro("\\@firstoftwo", function(n) {
  var t = n.consumeArgs(2);
  return {
    tokens: t[0],
    numArgs: 0
  };
});
defineMacro("\\@secondoftwo", function(n) {
  var t = n.consumeArgs(2);
  return {
    tokens: t[1],
    numArgs: 0
  };
});
defineMacro("\\@ifnextchar", function(n) {
  var t = n.consumeArgs(3);
  n.consumeSpaces();
  var g = n.future();
  return t[0].length === 1 && t[0][0].text === g.text ? {
    tokens: t[1],
    numArgs: 0
  } : {
    tokens: t[2],
    numArgs: 0
  };
});
defineMacro("\\@ifstar", "\\@ifnextchar *{\\@firstoftwo{#1}}");
defineMacro("\\TextOrMath", function(n) {
  var t = n.consumeArgs(2);
  return n.mode === "text" ? {
    tokens: t[0],
    numArgs: 0
  } : {
    tokens: t[1],
    numArgs: 0
  };
});
var digitToNumber = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  a: 10,
  A: 10,
  b: 11,
  B: 11,
  c: 12,
  C: 12,
  d: 13,
  D: 13,
  e: 14,
  E: 14,
  f: 15,
  F: 15
};
defineMacro("\\char", function(n) {
  var t = n.popToken(), g, d = "";
  if (t.text === "'")
    g = 8, t = n.popToken();
  else if (t.text === '"')
    g = 16, t = n.popToken();
  else if (t.text === "`")
    if (t = n.popToken(), t.text[0] === "\\")
      d = t.text.charCodeAt(1);
    else {
      if (t.text === "EOF")
        throw new ParseError("\\char` missing argument");
      d = t.text.charCodeAt(0);
    }
  else
    g = 10;
  if (g) {
    if (d = digitToNumber[t.text], d == null || d >= g)
      throw new ParseError("Invalid base-" + g + " digit " + t.text);
    for (var k; (k = digitToNumber[n.future().text]) != null && k < g; )
      d *= g, d += k, n.popToken();
  }
  return "\\@char{" + d + "}";
});
var newcommand = (n, t, g, d) => {
  var k = n.consumeArg().tokens;
  if (k.length !== 1)
    throw new ParseError("\\newcommand's first argument must be a macro name");
  var H = k[0].text, AA = n.isDefined(H);
  if (AA && !t)
    throw new ParseError("\\newcommand{" + H + "} attempting to redefine " + (H + "; use \\renewcommand"));
  if (!AA && !g)
    throw new ParseError("\\renewcommand{" + H + "} when command " + H + " does not yet exist; use \\newcommand");
  var gA = 0;
  if (k = n.consumeArg().tokens, k.length === 1 && k[0].text === "[") {
    for (var IA = "", CA = n.expandNextToken(); CA.text !== "]" && CA.text !== "EOF"; )
      IA += CA.text, CA = n.expandNextToken();
    if (!IA.match(/^\s*[0-9]+\s*$/))
      throw new ParseError("Invalid number of arguments: " + IA);
    gA = parseInt(IA), k = n.consumeArg().tokens;
  }
  return AA && d || n.macros.set(H, {
    tokens: k,
    numArgs: gA
  }), "";
};
defineMacro("\\newcommand", (n) => newcommand(n, !1, !0, !1));
defineMacro("\\renewcommand", (n) => newcommand(n, !0, !1, !1));
defineMacro("\\providecommand", (n) => newcommand(n, !0, !0, !0));
defineMacro("\\message", (n) => {
  var t = n.consumeArgs(1)[0];
  return console.log(t.reverse().map((g) => g.text).join("")), "";
});
defineMacro("\\errmessage", (n) => {
  var t = n.consumeArgs(1)[0];
  return console.error(t.reverse().map((g) => g.text).join("")), "";
});
defineMacro("\\show", (n) => {
  var t = n.popToken(), g = t.text;
  return console.log(t, n.macros.get(g), functions[g], symbols$4.math[g], symbols$4.text[g]), "";
});
defineMacro("\\bgroup", "{");
defineMacro("\\egroup", "}");
defineMacro("~", "\\nobreakspace");
defineMacro("\\lq", "`");
defineMacro("\\rq", "'");
defineMacro("\\aa", "\\r a");
defineMacro("\\AA", "\\r A");
defineMacro("\\textcopyright", "\\html@mathml{\\textcircled{c}}{\\char`©}");
defineMacro("\\copyright", "\\TextOrMath{\\textcopyright}{\\text{\\textcopyright}}");
defineMacro("\\textregistered", "\\html@mathml{\\textcircled{\\scriptsize R}}{\\char`®}");
defineMacro("ℬ", "\\mathscr{B}");
defineMacro("ℰ", "\\mathscr{E}");
defineMacro("ℱ", "\\mathscr{F}");
defineMacro("ℋ", "\\mathscr{H}");
defineMacro("ℐ", "\\mathscr{I}");
defineMacro("ℒ", "\\mathscr{L}");
defineMacro("ℳ", "\\mathscr{M}");
defineMacro("ℛ", "\\mathscr{R}");
defineMacro("ℭ", "\\mathfrak{C}");
defineMacro("ℌ", "\\mathfrak{H}");
defineMacro("ℨ", "\\mathfrak{Z}");
defineMacro("\\Bbbk", "\\Bbb{k}");
defineMacro("·", "\\cdotp");
defineMacro("\\llap", "\\mathllap{\\textrm{#1}}");
defineMacro("\\rlap", "\\mathrlap{\\textrm{#1}}");
defineMacro("\\clap", "\\mathclap{\\textrm{#1}}");
defineMacro("\\mathstrut", "\\vphantom{(}");
defineMacro("\\underbar", "\\underline{\\text{#1}}");
defineMacro("\\not", '\\html@mathml{\\mathrel{\\mathrlap\\@not}}{\\char"338}');
defineMacro("\\neq", "\\html@mathml{\\mathrel{\\not=}}{\\mathrel{\\char`≠}}");
defineMacro("\\ne", "\\neq");
defineMacro("≠", "\\neq");
defineMacro("\\notin", "\\html@mathml{\\mathrel{{\\in}\\mathllap{/\\mskip1mu}}}{\\mathrel{\\char`∉}}");
defineMacro("∉", "\\notin");
defineMacro("≘", "\\html@mathml{\\mathrel{=\\kern{-1em}\\raisebox{0.4em}{$\\scriptsize\\frown$}}}{\\mathrel{\\char`≘}}");
defineMacro("≙", "\\html@mathml{\\stackrel{\\tiny\\wedge}{=}}{\\mathrel{\\char`≘}}");
defineMacro("≚", "\\html@mathml{\\stackrel{\\tiny\\vee}{=}}{\\mathrel{\\char`≚}}");
defineMacro("≛", "\\html@mathml{\\stackrel{\\scriptsize\\star}{=}}{\\mathrel{\\char`≛}}");
defineMacro("≝", "\\html@mathml{\\stackrel{\\tiny\\mathrm{def}}{=}}{\\mathrel{\\char`≝}}");
defineMacro("≞", "\\html@mathml{\\stackrel{\\tiny\\mathrm{m}}{=}}{\\mathrel{\\char`≞}}");
defineMacro("≟", "\\html@mathml{\\stackrel{\\tiny?}{=}}{\\mathrel{\\char`≟}}");
defineMacro("⟂", "\\perp");
defineMacro("‼", "\\mathclose{!\\mkern-0.8mu!}");
defineMacro("∌", "\\notni");
defineMacro("⌜", "\\ulcorner");
defineMacro("⌝", "\\urcorner");
defineMacro("⌞", "\\llcorner");
defineMacro("⌟", "\\lrcorner");
defineMacro("©", "\\copyright");
defineMacro("®", "\\textregistered");
defineMacro("️", "\\textregistered");
defineMacro("\\ulcorner", '\\html@mathml{\\@ulcorner}{\\mathop{\\char"231c}}');
defineMacro("\\urcorner", '\\html@mathml{\\@urcorner}{\\mathop{\\char"231d}}');
defineMacro("\\llcorner", '\\html@mathml{\\@llcorner}{\\mathop{\\char"231e}}');
defineMacro("\\lrcorner", '\\html@mathml{\\@lrcorner}{\\mathop{\\char"231f}}');
defineMacro("\\vdots", "{\\varvdots\\rule{0pt}{15pt}}");
defineMacro("⋮", "\\vdots");
defineMacro("\\varGamma", "\\mathit{\\Gamma}");
defineMacro("\\varDelta", "\\mathit{\\Delta}");
defineMacro("\\varTheta", "\\mathit{\\Theta}");
defineMacro("\\varLambda", "\\mathit{\\Lambda}");
defineMacro("\\varXi", "\\mathit{\\Xi}");
defineMacro("\\varPi", "\\mathit{\\Pi}");
defineMacro("\\varSigma", "\\mathit{\\Sigma}");
defineMacro("\\varUpsilon", "\\mathit{\\Upsilon}");
defineMacro("\\varPhi", "\\mathit{\\Phi}");
defineMacro("\\varPsi", "\\mathit{\\Psi}");
defineMacro("\\varOmega", "\\mathit{\\Omega}");
defineMacro("\\substack", "\\begin{subarray}{c}#1\\end{subarray}");
defineMacro("\\colon", "\\nobreak\\mskip2mu\\mathpunct{}\\mathchoice{\\mkern-3mu}{\\mkern-3mu}{}{}{:}\\mskip6mu\\relax");
defineMacro("\\boxed", "\\fbox{$\\displaystyle{#1}$}");
defineMacro("\\iff", "\\DOTSB\\;\\Longleftrightarrow\\;");
defineMacro("\\implies", "\\DOTSB\\;\\Longrightarrow\\;");
defineMacro("\\impliedby", "\\DOTSB\\;\\Longleftarrow\\;");
defineMacro("\\dddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ...}}{#1}}");
defineMacro("\\ddddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ....}}{#1}}");
var dotsByToken = {
  ",": "\\dotsc",
  "\\not": "\\dotsb",
  // \keybin@ checks for the following:
  "+": "\\dotsb",
  "=": "\\dotsb",
  "<": "\\dotsb",
  ">": "\\dotsb",
  "-": "\\dotsb",
  "*": "\\dotsb",
  ":": "\\dotsb",
  // Symbols whose definition starts with \DOTSB:
  "\\DOTSB": "\\dotsb",
  "\\coprod": "\\dotsb",
  "\\bigvee": "\\dotsb",
  "\\bigwedge": "\\dotsb",
  "\\biguplus": "\\dotsb",
  "\\bigcap": "\\dotsb",
  "\\bigcup": "\\dotsb",
  "\\prod": "\\dotsb",
  "\\sum": "\\dotsb",
  "\\bigotimes": "\\dotsb",
  "\\bigoplus": "\\dotsb",
  "\\bigodot": "\\dotsb",
  "\\bigsqcup": "\\dotsb",
  "\\And": "\\dotsb",
  "\\longrightarrow": "\\dotsb",
  "\\Longrightarrow": "\\dotsb",
  "\\longleftarrow": "\\dotsb",
  "\\Longleftarrow": "\\dotsb",
  "\\longleftrightarrow": "\\dotsb",
  "\\Longleftrightarrow": "\\dotsb",
  "\\mapsto": "\\dotsb",
  "\\longmapsto": "\\dotsb",
  "\\hookrightarrow": "\\dotsb",
  "\\doteq": "\\dotsb",
  // Symbols whose definition starts with \mathbin:
  "\\mathbin": "\\dotsb",
  // Symbols whose definition starts with \mathrel:
  "\\mathrel": "\\dotsb",
  "\\relbar": "\\dotsb",
  "\\Relbar": "\\dotsb",
  "\\xrightarrow": "\\dotsb",
  "\\xleftarrow": "\\dotsb",
  // Symbols whose definition starts with \DOTSI:
  "\\DOTSI": "\\dotsi",
  "\\int": "\\dotsi",
  "\\oint": "\\dotsi",
  "\\iint": "\\dotsi",
  "\\iiint": "\\dotsi",
  "\\iiiint": "\\dotsi",
  "\\idotsint": "\\dotsi",
  // Symbols whose definition starts with \DOTSX:
  "\\DOTSX": "\\dotsx"
};
defineMacro("\\dots", function(n) {
  var t = "\\dotso", g = n.expandAfterFuture().text;
  return g in dotsByToken ? t = dotsByToken[g] : (g.slice(0, 4) === "\\not" || g in symbols$4.math && ["bin", "rel"].includes(symbols$4.math[g].group)) && (t = "\\dotsb"), t;
});
var spaceAfterDots = {
  // \rightdelim@ checks for the following:
  ")": !0,
  "]": !0,
  "\\rbrack": !0,
  "\\}": !0,
  "\\rbrace": !0,
  "\\rangle": !0,
  "\\rceil": !0,
  "\\rfloor": !0,
  "\\rgroup": !0,
  "\\rmoustache": !0,
  "\\right": !0,
  "\\bigr": !0,
  "\\biggr": !0,
  "\\Bigr": !0,
  "\\Biggr": !0,
  // \extra@ also tests for the following:
  $: !0,
  // \extrap@ checks for the following:
  ";": !0,
  ".": !0,
  ",": !0
};
defineMacro("\\dotso", function(n) {
  var t = n.future().text;
  return t in spaceAfterDots ? "\\ldots\\," : "\\ldots";
});
defineMacro("\\dotsc", function(n) {
  var t = n.future().text;
  return t in spaceAfterDots && t !== "," ? "\\ldots\\," : "\\ldots";
});
defineMacro("\\cdots", function(n) {
  var t = n.future().text;
  return t in spaceAfterDots ? "\\@cdots\\," : "\\@cdots";
});
defineMacro("\\dotsb", "\\cdots");
defineMacro("\\dotsm", "\\cdots");
defineMacro("\\dotsi", "\\!\\cdots");
defineMacro("\\dotsx", "\\ldots\\,");
defineMacro("\\DOTSI", "\\relax");
defineMacro("\\DOTSB", "\\relax");
defineMacro("\\DOTSX", "\\relax");
defineMacro("\\tmspace", "\\TextOrMath{\\kern#1#3}{\\mskip#1#2}\\relax");
defineMacro("\\,", "\\tmspace+{3mu}{.1667em}");
defineMacro("\\thinspace", "\\,");
defineMacro("\\>", "\\mskip{4mu}");
defineMacro("\\:", "\\tmspace+{4mu}{.2222em}");
defineMacro("\\medspace", "\\:");
defineMacro("\\;", "\\tmspace+{5mu}{.2777em}");
defineMacro("\\thickspace", "\\;");
defineMacro("\\!", "\\tmspace-{3mu}{.1667em}");
defineMacro("\\negthinspace", "\\!");
defineMacro("\\negmedspace", "\\tmspace-{4mu}{.2222em}");
defineMacro("\\negthickspace", "\\tmspace-{5mu}{.277em}");
defineMacro("\\enspace", "\\kern.5em ");
defineMacro("\\enskip", "\\hskip.5em\\relax");
defineMacro("\\quad", "\\hskip1em\\relax");
defineMacro("\\qquad", "\\hskip2em\\relax");
defineMacro("\\tag", "\\@ifstar\\tag@literal\\tag@paren");
defineMacro("\\tag@paren", "\\tag@literal{({#1})}");
defineMacro("\\tag@literal", (n) => {
  if (n.macros.get("\\df@tag"))
    throw new ParseError("Multiple \\tag");
  return "\\gdef\\df@tag{\\text{#1}}";
});
defineMacro("\\bmod", "\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}\\mathbin{\\rm mod}\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}");
defineMacro("\\pod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern8mu}{\\mkern8mu}{\\mkern8mu}(#1)");
defineMacro("\\pmod", "\\pod{{\\rm mod}\\mkern6mu#1}");
defineMacro("\\mod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern12mu}{\\mkern12mu}{\\mkern12mu}{\\rm mod}\\,\\,#1");
defineMacro("\\newline", "\\\\\\relax");
defineMacro("\\TeX", "\\textrm{\\html@mathml{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}{TeX}}");
var latexRaiseA = makeEm(fontMetricsData["Main-Regular"][84][1] - 0.7 * fontMetricsData["Main-Regular"][65][1]);
defineMacro("\\LaTeX", "\\textrm{\\html@mathml{" + ("L\\kern-.36em\\raisebox{" + latexRaiseA + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{LaTeX}}");
defineMacro("\\KaTeX", "\\textrm{\\html@mathml{" + ("K\\kern-.17em\\raisebox{" + latexRaiseA + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{KaTeX}}");
defineMacro("\\hspace", "\\@ifstar\\@hspacer\\@hspace");
defineMacro("\\@hspace", "\\hskip #1\\relax");
defineMacro("\\@hspacer", "\\rule{0pt}{0pt}\\hskip #1\\relax");
defineMacro("\\ordinarycolon", ":");
defineMacro("\\vcentcolon", "\\mathrel{\\mathop\\ordinarycolon}");
defineMacro("\\dblcolon", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon}}{\\mathop{\\char"2237}}');
defineMacro("\\coloneqq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2254}}');
defineMacro("\\Coloneqq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2237\\char"3d}}');
defineMacro("\\coloneq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"3a\\char"2212}}');
defineMacro("\\Coloneq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"2237\\char"2212}}');
defineMacro("\\eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2255}}');
defineMacro("\\Eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"3d\\char"2237}}');
defineMacro("\\eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2239}}');
defineMacro("\\Eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"2212\\char"2237}}');
defineMacro("\\colonapprox", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"3a\\char"2248}}');
defineMacro("\\Colonapprox", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"2237\\char"2248}}');
defineMacro("\\colonsim", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"3a\\char"223c}}');
defineMacro("\\Colonsim", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"2237\\char"223c}}');
defineMacro("∷", "\\dblcolon");
defineMacro("∹", "\\eqcolon");
defineMacro("≔", "\\coloneqq");
defineMacro("≕", "\\eqqcolon");
defineMacro("⩴", "\\Coloneqq");
defineMacro("\\ratio", "\\vcentcolon");
defineMacro("\\coloncolon", "\\dblcolon");
defineMacro("\\colonequals", "\\coloneqq");
defineMacro("\\coloncolonequals", "\\Coloneqq");
defineMacro("\\equalscolon", "\\eqqcolon");
defineMacro("\\equalscoloncolon", "\\Eqqcolon");
defineMacro("\\colonminus", "\\coloneq");
defineMacro("\\coloncolonminus", "\\Coloneq");
defineMacro("\\minuscolon", "\\eqcolon");
defineMacro("\\minuscoloncolon", "\\Eqcolon");
defineMacro("\\coloncolonapprox", "\\Colonapprox");
defineMacro("\\coloncolonsim", "\\Colonsim");
defineMacro("\\simcolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
defineMacro("\\simcoloncolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon}");
defineMacro("\\approxcolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
defineMacro("\\approxcoloncolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon}");
defineMacro("\\notni", "\\html@mathml{\\not\\ni}{\\mathrel{\\char`∌}}");
defineMacro("\\limsup", "\\DOTSB\\operatorname*{lim\\,sup}");
defineMacro("\\liminf", "\\DOTSB\\operatorname*{lim\\,inf}");
defineMacro("\\injlim", "\\DOTSB\\operatorname*{inj\\,lim}");
defineMacro("\\projlim", "\\DOTSB\\operatorname*{proj\\,lim}");
defineMacro("\\varlimsup", "\\DOTSB\\operatorname*{\\overline{lim}}");
defineMacro("\\varliminf", "\\DOTSB\\operatorname*{\\underline{lim}}");
defineMacro("\\varinjlim", "\\DOTSB\\operatorname*{\\underrightarrow{lim}}");
defineMacro("\\varprojlim", "\\DOTSB\\operatorname*{\\underleftarrow{lim}}");
defineMacro("\\gvertneqq", "\\html@mathml{\\@gvertneqq}{≩}");
defineMacro("\\lvertneqq", "\\html@mathml{\\@lvertneqq}{≨}");
defineMacro("\\ngeqq", "\\html@mathml{\\@ngeqq}{≱}");
defineMacro("\\ngeqslant", "\\html@mathml{\\@ngeqslant}{≱}");
defineMacro("\\nleqq", "\\html@mathml{\\@nleqq}{≰}");
defineMacro("\\nleqslant", "\\html@mathml{\\@nleqslant}{≰}");
defineMacro("\\nshortmid", "\\html@mathml{\\@nshortmid}{∤}");
defineMacro("\\nshortparallel", "\\html@mathml{\\@nshortparallel}{∦}");
defineMacro("\\nsubseteqq", "\\html@mathml{\\@nsubseteqq}{⊈}");
defineMacro("\\nsupseteqq", "\\html@mathml{\\@nsupseteqq}{⊉}");
defineMacro("\\varsubsetneq", "\\html@mathml{\\@varsubsetneq}{⊊}");
defineMacro("\\varsubsetneqq", "\\html@mathml{\\@varsubsetneqq}{⫋}");
defineMacro("\\varsupsetneq", "\\html@mathml{\\@varsupsetneq}{⊋}");
defineMacro("\\varsupsetneqq", "\\html@mathml{\\@varsupsetneqq}{⫌}");
defineMacro("\\imath", "\\html@mathml{\\@imath}{ı}");
defineMacro("\\jmath", "\\html@mathml{\\@jmath}{ȷ}");
defineMacro("\\llbracket", "\\html@mathml{\\mathopen{[\\mkern-3.2mu[}}{\\mathopen{\\char`⟦}}");
defineMacro("\\rrbracket", "\\html@mathml{\\mathclose{]\\mkern-3.2mu]}}{\\mathclose{\\char`⟧}}");
defineMacro("⟦", "\\llbracket");
defineMacro("⟧", "\\rrbracket");
defineMacro("\\lBrace", "\\html@mathml{\\mathopen{\\{\\mkern-3.2mu[}}{\\mathopen{\\char`⦃}}");
defineMacro("\\rBrace", "\\html@mathml{\\mathclose{]\\mkern-3.2mu\\}}}{\\mathclose{\\char`⦄}}");
defineMacro("⦃", "\\lBrace");
defineMacro("⦄", "\\rBrace");
defineMacro("\\minuso", "\\mathbin{\\html@mathml{{\\mathrlap{\\mathchoice{\\kern{0.145em}}{\\kern{0.145em}}{\\kern{0.1015em}}{\\kern{0.0725em}}\\circ}{-}}}{\\char`⦵}}");
defineMacro("⦵", "\\minuso");
defineMacro("\\darr", "\\downarrow");
defineMacro("\\dArr", "\\Downarrow");
defineMacro("\\Darr", "\\Downarrow");
defineMacro("\\lang", "\\langle");
defineMacro("\\rang", "\\rangle");
defineMacro("\\uarr", "\\uparrow");
defineMacro("\\uArr", "\\Uparrow");
defineMacro("\\Uarr", "\\Uparrow");
defineMacro("\\N", "\\mathbb{N}");
defineMacro("\\R", "\\mathbb{R}");
defineMacro("\\Z", "\\mathbb{Z}");
defineMacro("\\alef", "\\aleph");
defineMacro("\\alefsym", "\\aleph");
defineMacro("\\Alpha", "\\mathrm{A}");
defineMacro("\\Beta", "\\mathrm{B}");
defineMacro("\\bull", "\\bullet");
defineMacro("\\Chi", "\\mathrm{X}");
defineMacro("\\clubs", "\\clubsuit");
defineMacro("\\cnums", "\\mathbb{C}");
defineMacro("\\Complex", "\\mathbb{C}");
defineMacro("\\Dagger", "\\ddagger");
defineMacro("\\diamonds", "\\diamondsuit");
defineMacro("\\empty", "\\emptyset");
defineMacro("\\Epsilon", "\\mathrm{E}");
defineMacro("\\Eta", "\\mathrm{H}");
defineMacro("\\exist", "\\exists");
defineMacro("\\harr", "\\leftrightarrow");
defineMacro("\\hArr", "\\Leftrightarrow");
defineMacro("\\Harr", "\\Leftrightarrow");
defineMacro("\\hearts", "\\heartsuit");
defineMacro("\\image", "\\Im");
defineMacro("\\infin", "\\infty");
defineMacro("\\Iota", "\\mathrm{I}");
defineMacro("\\isin", "\\in");
defineMacro("\\Kappa", "\\mathrm{K}");
defineMacro("\\larr", "\\leftarrow");
defineMacro("\\lArr", "\\Leftarrow");
defineMacro("\\Larr", "\\Leftarrow");
defineMacro("\\lrarr", "\\leftrightarrow");
defineMacro("\\lrArr", "\\Leftrightarrow");
defineMacro("\\Lrarr", "\\Leftrightarrow");
defineMacro("\\Mu", "\\mathrm{M}");
defineMacro("\\natnums", "\\mathbb{N}");
defineMacro("\\Nu", "\\mathrm{N}");
defineMacro("\\Omicron", "\\mathrm{O}");
defineMacro("\\plusmn", "\\pm");
defineMacro("\\rarr", "\\rightarrow");
defineMacro("\\rArr", "\\Rightarrow");
defineMacro("\\Rarr", "\\Rightarrow");
defineMacro("\\real", "\\Re");
defineMacro("\\reals", "\\mathbb{R}");
defineMacro("\\Reals", "\\mathbb{R}");
defineMacro("\\Rho", "\\mathrm{P}");
defineMacro("\\sdot", "\\cdot");
defineMacro("\\sect", "\\S");
defineMacro("\\spades", "\\spadesuit");
defineMacro("\\sub", "\\subset");
defineMacro("\\sube", "\\subseteq");
defineMacro("\\supe", "\\supseteq");
defineMacro("\\Tau", "\\mathrm{T}");
defineMacro("\\thetasym", "\\vartheta");
defineMacro("\\weierp", "\\wp");
defineMacro("\\Zeta", "\\mathrm{Z}");
defineMacro("\\argmin", "\\DOTSB\\operatorname*{arg\\,min}");
defineMacro("\\argmax", "\\DOTSB\\operatorname*{arg\\,max}");
defineMacro("\\plim", "\\DOTSB\\mathop{\\operatorname{plim}}\\limits");
defineMacro("\\bra", "\\mathinner{\\langle{#1}|}");
defineMacro("\\ket", "\\mathinner{|{#1}\\rangle}");
defineMacro("\\braket", "\\mathinner{\\langle{#1}\\rangle}");
defineMacro("\\Bra", "\\left\\langle#1\\right|");
defineMacro("\\Ket", "\\left|#1\\right\\rangle");
var braketHelper = (n) => (t) => {
  var g = t.consumeArg().tokens, d = t.consumeArg().tokens, k = t.consumeArg().tokens, H = t.consumeArg().tokens, AA = t.macros.get("|"), gA = t.macros.get("\\|");
  t.macros.beginGroup();
  var IA = (eA) => (iA) => {
    n && (iA.macros.set("|", AA), k.length && iA.macros.set("\\|", gA));
    var QA = eA;
    if (!eA && k.length) {
      var tA = iA.future();
      tA.text === "|" && (iA.popToken(), QA = !0);
    }
    return {
      tokens: QA ? k : d,
      numArgs: 0
    };
  };
  t.macros.set("|", IA(!1)), k.length && t.macros.set("\\|", IA(!0));
  var CA = t.consumeArg().tokens, BA = t.expandTokens([
    ...H,
    ...CA,
    ...g
    // reversed
  ]);
  return t.macros.endGroup(), {
    tokens: BA.reverse(),
    numArgs: 0
  };
};
defineMacro("\\bra@ket", braketHelper(!1));
defineMacro("\\bra@set", braketHelper(!0));
defineMacro("\\Braket", "\\bra@ket{\\left\\langle}{\\,\\middle\\vert\\,}{\\,\\middle\\vert\\,}{\\right\\rangle}");
defineMacro("\\Set", "\\bra@set{\\left\\{\\:}{\\;\\middle\\vert\\;}{\\;\\middle\\Vert\\;}{\\:\\right\\}}");
defineMacro("\\set", "\\bra@set{\\{\\,}{\\mid}{}{\\,\\}}");
defineMacro("\\angln", "{\\angl n}");
defineMacro("\\blue", "\\textcolor{##6495ed}{#1}");
defineMacro("\\orange", "\\textcolor{##ffa500}{#1}");
defineMacro("\\pink", "\\textcolor{##ff00af}{#1}");
defineMacro("\\red", "\\textcolor{##df0030}{#1}");
defineMacro("\\green", "\\textcolor{##28ae7b}{#1}");
defineMacro("\\gray", "\\textcolor{gray}{#1}");
defineMacro("\\purple", "\\textcolor{##9d38bd}{#1}");
defineMacro("\\blueA", "\\textcolor{##ccfaff}{#1}");
defineMacro("\\blueB", "\\textcolor{##80f6ff}{#1}");
defineMacro("\\blueC", "\\textcolor{##63d9ea}{#1}");
defineMacro("\\blueD", "\\textcolor{##11accd}{#1}");
defineMacro("\\blueE", "\\textcolor{##0c7f99}{#1}");
defineMacro("\\tealA", "\\textcolor{##94fff5}{#1}");
defineMacro("\\tealB", "\\textcolor{##26edd5}{#1}");
defineMacro("\\tealC", "\\textcolor{##01d1c1}{#1}");
defineMacro("\\tealD", "\\textcolor{##01a995}{#1}");
defineMacro("\\tealE", "\\textcolor{##208170}{#1}");
defineMacro("\\greenA", "\\textcolor{##b6ffb0}{#1}");
defineMacro("\\greenB", "\\textcolor{##8af281}{#1}");
defineMacro("\\greenC", "\\textcolor{##74cf70}{#1}");
defineMacro("\\greenD", "\\textcolor{##1fab54}{#1}");
defineMacro("\\greenE", "\\textcolor{##0d923f}{#1}");
defineMacro("\\goldA", "\\textcolor{##ffd0a9}{#1}");
defineMacro("\\goldB", "\\textcolor{##ffbb71}{#1}");
defineMacro("\\goldC", "\\textcolor{##ff9c39}{#1}");
defineMacro("\\goldD", "\\textcolor{##e07d10}{#1}");
defineMacro("\\goldE", "\\textcolor{##a75a05}{#1}");
defineMacro("\\redA", "\\textcolor{##fca9a9}{#1}");
defineMacro("\\redB", "\\textcolor{##ff8482}{#1}");
defineMacro("\\redC", "\\textcolor{##f9685d}{#1}");
defineMacro("\\redD", "\\textcolor{##e84d39}{#1}");
defineMacro("\\redE", "\\textcolor{##bc2612}{#1}");
defineMacro("\\maroonA", "\\textcolor{##ffbde0}{#1}");
defineMacro("\\maroonB", "\\textcolor{##ff92c6}{#1}");
defineMacro("\\maroonC", "\\textcolor{##ed5fa6}{#1}");
defineMacro("\\maroonD", "\\textcolor{##ca337c}{#1}");
defineMacro("\\maroonE", "\\textcolor{##9e034e}{#1}");
defineMacro("\\purpleA", "\\textcolor{##ddd7ff}{#1}");
defineMacro("\\purpleB", "\\textcolor{##c6b9fc}{#1}");
defineMacro("\\purpleC", "\\textcolor{##aa87ff}{#1}");
defineMacro("\\purpleD", "\\textcolor{##7854ab}{#1}");
defineMacro("\\purpleE", "\\textcolor{##543b78}{#1}");
defineMacro("\\mintA", "\\textcolor{##f5f9e8}{#1}");
defineMacro("\\mintB", "\\textcolor{##edf2df}{#1}");
defineMacro("\\mintC", "\\textcolor{##e0e5cc}{#1}");
defineMacro("\\grayA", "\\textcolor{##f6f7f7}{#1}");
defineMacro("\\grayB", "\\textcolor{##f0f1f2}{#1}");
defineMacro("\\grayC", "\\textcolor{##e3e5e6}{#1}");
defineMacro("\\grayD", "\\textcolor{##d6d8da}{#1}");
defineMacro("\\grayE", "\\textcolor{##babec2}{#1}");
defineMacro("\\grayF", "\\textcolor{##888d93}{#1}");
defineMacro("\\grayG", "\\textcolor{##626569}{#1}");
defineMacro("\\grayH", "\\textcolor{##3b3e40}{#1}");
defineMacro("\\grayI", "\\textcolor{##21242c}{#1}");
defineMacro("\\kaBlue", "\\textcolor{##314453}{#1}");
defineMacro("\\kaGreen", "\\textcolor{##71B307}{#1}");
var implicitCommands = {
  "^": !0,
  // Parser.js
  _: !0,
  // Parser.js
  "\\limits": !0,
  // Parser.js
  "\\nolimits": !0
  // Parser.js
};
class MacroExpander {
  constructor(t, g, d) {
    this.settings = void 0, this.expansionCount = void 0, this.lexer = void 0, this.macros = void 0, this.stack = void 0, this.mode = void 0, this.settings = g, this.expansionCount = 0, this.feed(t), this.macros = new Namespace(macros, g.macros), this.mode = d, this.stack = [];
  }
  /**
   * Feed a new input string to the same MacroExpander
   * (with existing macros etc.).
   */
  feed(t) {
    this.lexer = new Lexer(t, this.settings);
  }
  /**
   * Switches between "text" and "math" modes.
   */
  switchMode(t) {
    this.mode = t;
  }
  /**
   * Start a new group nesting within all namespaces.
   */
  beginGroup() {
    this.macros.beginGroup();
  }
  /**
   * End current group nesting within all namespaces.
   */
  endGroup() {
    this.macros.endGroup();
  }
  /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */
  endGroups() {
    this.macros.endGroups();
  }
  /**
   * Returns the topmost token on the stack, without expanding it.
   * Similar in behavior to TeX's `\futurelet`.
   */
  future() {
    return this.stack.length === 0 && this.pushToken(this.lexer.lex()), this.stack[this.stack.length - 1];
  }
  /**
   * Remove and return the next unexpanded token.
   */
  popToken() {
    return this.future(), this.stack.pop();
  }
  /**
   * Add a given token to the token stack.  In particular, this get be used
   * to put back a token returned from one of the other methods.
   */
  pushToken(t) {
    this.stack.push(t);
  }
  /**
   * Append an array of tokens to the token stack.
   */
  pushTokens(t) {
    this.stack.push(...t);
  }
  /**
   * Find an macro argument without expanding tokens and append the array of
   * tokens to the token stack. Uses Token as a container for the result.
   */
  scanArgument(t) {
    var g, d, k;
    if (t) {
      if (this.consumeSpaces(), this.future().text !== "[")
        return null;
      g = this.popToken(), {
        tokens: k,
        end: d
      } = this.consumeArg(["]"]);
    } else
      ({
        tokens: k,
        start: g,
        end: d
      } = this.consumeArg());
    return this.pushToken(new Token("EOF", d.loc)), this.pushTokens(k), new Token("", SourceLocation.range(g, d));
  }
  /**
   * Consume all following space tokens, without expansion.
   */
  consumeSpaces() {
    for (; ; ) {
      var t = this.future();
      if (t.text === " ")
        this.stack.pop();
      else
        break;
    }
  }
  /**
   * Consume an argument from the token stream, and return the resulting array
   * of tokens and start/end token.
   */
  consumeArg(t) {
    var g = [], d = t && t.length > 0;
    d || this.consumeSpaces();
    var k = this.future(), H, AA = 0, gA = 0;
    do {
      if (H = this.popToken(), g.push(H), H.text === "{")
        ++AA;
      else if (H.text === "}") {
        if (--AA, AA === -1)
          throw new ParseError("Extra }", H);
      } else if (H.text === "EOF")
        throw new ParseError("Unexpected end of input in a macro argument, expected '" + (t && d ? t[gA] : "}") + "'", H);
      if (t && d)
        if ((AA === 0 || AA === 1 && t[gA] === "{") && H.text === t[gA]) {
          if (++gA, gA === t.length) {
            g.splice(-gA, gA);
            break;
          }
        } else
          gA = 0;
    } while (AA !== 0 || d);
    return k.text === "{" && g[g.length - 1].text === "}" && (g.pop(), g.shift()), g.reverse(), {
      tokens: g,
      start: k,
      end: H
    };
  }
  /**
   * Consume the specified number of (delimited) arguments from the token
   * stream and return the resulting array of arguments.
   */
  consumeArgs(t, g) {
    if (g) {
      if (g.length !== t + 1)
        throw new ParseError("The length of delimiters doesn't match the number of args!");
      for (var d = g[0], k = 0; k < d.length; k++) {
        var H = this.popToken();
        if (d[k] !== H.text)
          throw new ParseError("Use of the macro doesn't match its definition", H);
      }
    }
    for (var AA = [], gA = 0; gA < t; gA++)
      AA.push(this.consumeArg(g && g[gA + 1]).tokens);
    return AA;
  }
  /**
   * Increment `expansionCount` by the specified amount.
   * Throw an error if it exceeds `maxExpand`.
   */
  countExpansion(t) {
    if (this.expansionCount += t, this.expansionCount > this.settings.maxExpand)
      throw new ParseError("Too many expansions: infinite loop or need to increase maxExpand setting");
  }
  /**
   * Expand the next token only once if possible.
   *
   * If the token is expanded, the resulting tokens will be pushed onto
   * the stack in reverse order, and the number of such tokens will be
   * returned.  This number might be zero or positive.
   *
   * If not, the return value is `false`, and the next token remains at the
   * top of the stack.
   *
   * In either case, the next token will be on the top of the stack,
   * or the stack will be empty (in case of empty expansion
   * and no other tokens).
   *
   * Used to implement `expandAfterFuture` and `expandNextToken`.
   *
   * If expandableOnly, only expandable tokens are expanded and
   * an undefined control sequence results in an error.
   */
  expandOnce(t) {
    var g = this.popToken(), d = g.text, k = g.noexpand ? null : this._getExpansion(d);
    if (k == null || t && k.unexpandable) {
      if (t && k == null && d[0] === "\\" && !this.isDefined(d))
        throw new ParseError("Undefined control sequence: " + d);
      return this.pushToken(g), !1;
    }
    this.countExpansion(1);
    var H = k.tokens, AA = this.consumeArgs(k.numArgs, k.delimiters);
    if (k.numArgs) {
      H = H.slice();
      for (var gA = H.length - 1; gA >= 0; --gA) {
        var IA = H[gA];
        if (IA.text === "#") {
          if (gA === 0)
            throw new ParseError("Incomplete placeholder at end of macro body", IA);
          if (IA = H[--gA], IA.text === "#")
            H.splice(gA + 1, 1);
          else if (/^[1-9]$/.test(IA.text))
            H.splice(gA, 2, ...AA[+IA.text - 1]);
          else
            throw new ParseError("Not a valid argument number", IA);
        }
      }
    }
    return this.pushTokens(H), H.length;
  }
  /**
   * Expand the next token only once (if possible), and return the resulting
   * top token on the stack (without removing anything from the stack).
   * Similar in behavior to TeX's `\expandafter\futurelet`.
   * Equivalent to expandOnce() followed by future().
   */
  expandAfterFuture() {
    return this.expandOnce(), this.future();
  }
  /**
   * Recursively expand first token, then return first non-expandable token.
   */
  expandNextToken() {
    for (; ; )
      if (this.expandOnce() === !1) {
        var t = this.stack.pop();
        return t.treatAsRelax && (t.text = "\\relax"), t;
      }
    throw new Error();
  }
  /**
   * Fully expand the given macro name and return the resulting list of
   * tokens, or return `undefined` if no such macro is defined.
   */
  expandMacro(t) {
    return this.macros.has(t) ? this.expandTokens([new Token(t)]) : void 0;
  }
  /**
   * Fully expand the given token stream and return the resulting list of
   * tokens.  Note that the input tokens are in reverse order, but the
   * output tokens are in forward order.
   */
  expandTokens(t) {
    var g = [], d = this.stack.length;
    for (this.pushTokens(t); this.stack.length > d; )
      if (this.expandOnce(!0) === !1) {
        var k = this.stack.pop();
        k.treatAsRelax && (k.noexpand = !1, k.treatAsRelax = !1), g.push(k);
      }
    return this.countExpansion(g.length), g;
  }
  /**
   * Fully expand the given macro name and return the result as a string,
   * or return `undefined` if no such macro is defined.
   */
  expandMacroAsText(t) {
    var g = this.expandMacro(t);
    return g && g.map((d) => d.text).join("");
  }
  /**
   * Returns the expanded macro as a reversed array of tokens and a macro
   * argument count.  Or returns `null` if no such macro.
   */
  _getExpansion(t) {
    var g = this.macros.get(t);
    if (g == null)
      return g;
    if (t.length === 1) {
      var d = this.lexer.catcodes[t];
      if (d != null && d !== 13)
        return;
    }
    var k = typeof g == "function" ? g(this) : g;
    if (typeof k == "string") {
      var H = 0;
      if (k.indexOf("#") !== -1)
        for (var AA = k.replace(/##/g, ""); AA.indexOf("#" + (H + 1)) !== -1; )
          ++H;
      for (var gA = new Lexer(k, this.settings), IA = [], CA = gA.lex(); CA.text !== "EOF"; )
        IA.push(CA), CA = gA.lex();
      IA.reverse();
      var BA = {
        tokens: IA,
        numArgs: H
      };
      return BA;
    }
    return k;
  }
  /**
   * Determine whether a command is currently "defined" (has some
   * functionality), meaning that it's a macro (in the current group),
   * a function, a symbol, or one of the special commands listed in
   * `implicitCommands`.
   */
  isDefined(t) {
    return this.macros.has(t) || functions.hasOwnProperty(t) || symbols$4.math.hasOwnProperty(t) || symbols$4.text.hasOwnProperty(t) || implicitCommands.hasOwnProperty(t);
  }
  /**
   * Determine whether a command is expandable.
   */
  isExpandable(t) {
    var g = this.macros.get(t);
    return g != null ? typeof g == "string" || typeof g == "function" || !g.unexpandable : functions.hasOwnProperty(t) && !functions[t].primitive;
  }
}
var unicodeSubRegEx = /^[₊₋₌₍₎₀₁₂₃₄₅₆₇₈₉ₐₑₕᵢⱼₖₗₘₙₒₚᵣₛₜᵤᵥₓᵦᵧᵨᵩᵪ]/, uSubsAndSups = Object.freeze({
  "₊": "+",
  "₋": "-",
  "₌": "=",
  "₍": "(",
  "₎": ")",
  "₀": "0",
  "₁": "1",
  "₂": "2",
  "₃": "3",
  "₄": "4",
  "₅": "5",
  "₆": "6",
  "₇": "7",
  "₈": "8",
  "₉": "9",
  "ₐ": "a",
  "ₑ": "e",
  "ₕ": "h",
  "ᵢ": "i",
  "ⱼ": "j",
  "ₖ": "k",
  "ₗ": "l",
  "ₘ": "m",
  "ₙ": "n",
  "ₒ": "o",
  "ₚ": "p",
  "ᵣ": "r",
  "ₛ": "s",
  "ₜ": "t",
  "ᵤ": "u",
  "ᵥ": "v",
  "ₓ": "x",
  "ᵦ": "β",
  "ᵧ": "γ",
  "ᵨ": "ρ",
  "ᵩ": "ϕ",
  "ᵪ": "χ",
  "⁺": "+",
  "⁻": "-",
  "⁼": "=",
  "⁽": "(",
  "⁾": ")",
  "⁰": "0",
  "¹": "1",
  "²": "2",
  "³": "3",
  "⁴": "4",
  "⁵": "5",
  "⁶": "6",
  "⁷": "7",
  "⁸": "8",
  "⁹": "9",
  "ᴬ": "A",
  "ᴮ": "B",
  "ᴰ": "D",
  "ᴱ": "E",
  "ᴳ": "G",
  "ᴴ": "H",
  "ᴵ": "I",
  "ᴶ": "J",
  "ᴷ": "K",
  "ᴸ": "L",
  "ᴹ": "M",
  "ᴺ": "N",
  "ᴼ": "O",
  "ᴾ": "P",
  "ᴿ": "R",
  "ᵀ": "T",
  "ᵁ": "U",
  "ⱽ": "V",
  "ᵂ": "W",
  "ᵃ": "a",
  "ᵇ": "b",
  "ᶜ": "c",
  "ᵈ": "d",
  "ᵉ": "e",
  "ᶠ": "f",
  "ᵍ": "g",
  ʰ: "h",
  "ⁱ": "i",
  ʲ: "j",
  "ᵏ": "k",
  ˡ: "l",
  "ᵐ": "m",
  ⁿ: "n",
  "ᵒ": "o",
  "ᵖ": "p",
  ʳ: "r",
  ˢ: "s",
  "ᵗ": "t",
  "ᵘ": "u",
  "ᵛ": "v",
  ʷ: "w",
  ˣ: "x",
  ʸ: "y",
  "ᶻ": "z",
  "ᵝ": "β",
  "ᵞ": "γ",
  "ᵟ": "δ",
  "ᵠ": "ϕ",
  "ᵡ": "χ",
  "ᶿ": "θ"
}), unicodeAccents = {
  "́": {
    text: "\\'",
    math: "\\acute"
  },
  "̀": {
    text: "\\`",
    math: "\\grave"
  },
  "̈": {
    text: '\\"',
    math: "\\ddot"
  },
  "̃": {
    text: "\\~",
    math: "\\tilde"
  },
  "̄": {
    text: "\\=",
    math: "\\bar"
  },
  "̆": {
    text: "\\u",
    math: "\\breve"
  },
  "̌": {
    text: "\\v",
    math: "\\check"
  },
  "̂": {
    text: "\\^",
    math: "\\hat"
  },
  "̇": {
    text: "\\.",
    math: "\\dot"
  },
  "̊": {
    text: "\\r",
    math: "\\mathring"
  },
  "̋": {
    text: "\\H"
  },
  "̧": {
    text: "\\c"
  }
}, unicodeSymbols = {
  á: "á",
  à: "à",
  ä: "ä",
  ǟ: "ǟ",
  ã: "ã",
  ā: "ā",
  ă: "ă",
  ắ: "ắ",
  ằ: "ằ",
  ẵ: "ẵ",
  ǎ: "ǎ",
  â: "â",
  ấ: "ấ",
  ầ: "ầ",
  ẫ: "ẫ",
  ȧ: "ȧ",
  ǡ: "ǡ",
  å: "å",
  ǻ: "ǻ",
  ḃ: "ḃ",
  ć: "ć",
  ḉ: "ḉ",
  č: "č",
  ĉ: "ĉ",
  ċ: "ċ",
  ç: "ç",
  ď: "ď",
  ḋ: "ḋ",
  ḑ: "ḑ",
  é: "é",
  è: "è",
  ë: "ë",
  ẽ: "ẽ",
  ē: "ē",
  ḗ: "ḗ",
  ḕ: "ḕ",
  ĕ: "ĕ",
  ḝ: "ḝ",
  ě: "ě",
  ê: "ê",
  ế: "ế",
  ề: "ề",
  ễ: "ễ",
  ė: "ė",
  ȩ: "ȩ",
  ḟ: "ḟ",
  ǵ: "ǵ",
  ḡ: "ḡ",
  ğ: "ğ",
  ǧ: "ǧ",
  ĝ: "ĝ",
  ġ: "ġ",
  ģ: "ģ",
  ḧ: "ḧ",
  ȟ: "ȟ",
  ĥ: "ĥ",
  ḣ: "ḣ",
  ḩ: "ḩ",
  í: "í",
  ì: "ì",
  ï: "ï",
  ḯ: "ḯ",
  ĩ: "ĩ",
  ī: "ī",
  ĭ: "ĭ",
  ǐ: "ǐ",
  î: "î",
  ǰ: "ǰ",
  ĵ: "ĵ",
  ḱ: "ḱ",
  ǩ: "ǩ",
  ķ: "ķ",
  ĺ: "ĺ",
  ľ: "ľ",
  ļ: "ļ",
  ḿ: "ḿ",
  ṁ: "ṁ",
  ń: "ń",
  ǹ: "ǹ",
  ñ: "ñ",
  ň: "ň",
  ṅ: "ṅ",
  ņ: "ņ",
  ó: "ó",
  ò: "ò",
  ö: "ö",
  ȫ: "ȫ",
  õ: "õ",
  ṍ: "ṍ",
  ṏ: "ṏ",
  ȭ: "ȭ",
  ō: "ō",
  ṓ: "ṓ",
  ṑ: "ṑ",
  ŏ: "ŏ",
  ǒ: "ǒ",
  ô: "ô",
  ố: "ố",
  ồ: "ồ",
  ỗ: "ỗ",
  ȯ: "ȯ",
  ȱ: "ȱ",
  ő: "ő",
  ṕ: "ṕ",
  ṗ: "ṗ",
  ŕ: "ŕ",
  ř: "ř",
  ṙ: "ṙ",
  ŗ: "ŗ",
  ś: "ś",
  ṥ: "ṥ",
  š: "š",
  ṧ: "ṧ",
  ŝ: "ŝ",
  ṡ: "ṡ",
  ş: "ş",
  ẗ: "ẗ",
  ť: "ť",
  ṫ: "ṫ",
  ţ: "ţ",
  ú: "ú",
  ù: "ù",
  ü: "ü",
  ǘ: "ǘ",
  ǜ: "ǜ",
  ǖ: "ǖ",
  ǚ: "ǚ",
  ũ: "ũ",
  ṹ: "ṹ",
  ū: "ū",
  ṻ: "ṻ",
  ŭ: "ŭ",
  ǔ: "ǔ",
  û: "û",
  ů: "ů",
  ű: "ű",
  ṽ: "ṽ",
  ẃ: "ẃ",
  ẁ: "ẁ",
  ẅ: "ẅ",
  ŵ: "ŵ",
  ẇ: "ẇ",
  ẘ: "ẘ",
  ẍ: "ẍ",
  ẋ: "ẋ",
  ý: "ý",
  ỳ: "ỳ",
  ÿ: "ÿ",
  ỹ: "ỹ",
  ȳ: "ȳ",
  ŷ: "ŷ",
  ẏ: "ẏ",
  ẙ: "ẙ",
  ź: "ź",
  ž: "ž",
  ẑ: "ẑ",
  ż: "ż",
  Á: "Á",
  À: "À",
  Ä: "Ä",
  Ǟ: "Ǟ",
  Ã: "Ã",
  Ā: "Ā",
  Ă: "Ă",
  Ắ: "Ắ",
  Ằ: "Ằ",
  Ẵ: "Ẵ",
  Ǎ: "Ǎ",
  Â: "Â",
  Ấ: "Ấ",
  Ầ: "Ầ",
  Ẫ: "Ẫ",
  Ȧ: "Ȧ",
  Ǡ: "Ǡ",
  Å: "Å",
  Ǻ: "Ǻ",
  Ḃ: "Ḃ",
  Ć: "Ć",
  Ḉ: "Ḉ",
  Č: "Č",
  Ĉ: "Ĉ",
  Ċ: "Ċ",
  Ç: "Ç",
  Ď: "Ď",
  Ḋ: "Ḋ",
  Ḑ: "Ḑ",
  É: "É",
  È: "È",
  Ë: "Ë",
  Ẽ: "Ẽ",
  Ē: "Ē",
  Ḗ: "Ḗ",
  Ḕ: "Ḕ",
  Ĕ: "Ĕ",
  Ḝ: "Ḝ",
  Ě: "Ě",
  Ê: "Ê",
  Ế: "Ế",
  Ề: "Ề",
  Ễ: "Ễ",
  Ė: "Ė",
  Ȩ: "Ȩ",
  Ḟ: "Ḟ",
  Ǵ: "Ǵ",
  Ḡ: "Ḡ",
  Ğ: "Ğ",
  Ǧ: "Ǧ",
  Ĝ: "Ĝ",
  Ġ: "Ġ",
  Ģ: "Ģ",
  Ḧ: "Ḧ",
  Ȟ: "Ȟ",
  Ĥ: "Ĥ",
  Ḣ: "Ḣ",
  Ḩ: "Ḩ",
  Í: "Í",
  Ì: "Ì",
  Ï: "Ï",
  Ḯ: "Ḯ",
  Ĩ: "Ĩ",
  Ī: "Ī",
  Ĭ: "Ĭ",
  Ǐ: "Ǐ",
  Î: "Î",
  İ: "İ",
  Ĵ: "Ĵ",
  Ḱ: "Ḱ",
  Ǩ: "Ǩ",
  Ķ: "Ķ",
  Ĺ: "Ĺ",
  Ľ: "Ľ",
  Ļ: "Ļ",
  Ḿ: "Ḿ",
  Ṁ: "Ṁ",
  Ń: "Ń",
  Ǹ: "Ǹ",
  Ñ: "Ñ",
  Ň: "Ň",
  Ṅ: "Ṅ",
  Ņ: "Ņ",
  Ó: "Ó",
  Ò: "Ò",
  Ö: "Ö",
  Ȫ: "Ȫ",
  Õ: "Õ",
  Ṍ: "Ṍ",
  Ṏ: "Ṏ",
  Ȭ: "Ȭ",
  Ō: "Ō",
  Ṓ: "Ṓ",
  Ṑ: "Ṑ",
  Ŏ: "Ŏ",
  Ǒ: "Ǒ",
  Ô: "Ô",
  Ố: "Ố",
  Ồ: "Ồ",
  Ỗ: "Ỗ",
  Ȯ: "Ȯ",
  Ȱ: "Ȱ",
  Ő: "Ő",
  Ṕ: "Ṕ",
  Ṗ: "Ṗ",
  Ŕ: "Ŕ",
  Ř: "Ř",
  Ṙ: "Ṙ",
  Ŗ: "Ŗ",
  Ś: "Ś",
  Ṥ: "Ṥ",
  Š: "Š",
  Ṧ: "Ṧ",
  Ŝ: "Ŝ",
  Ṡ: "Ṡ",
  Ş: "Ş",
  Ť: "Ť",
  Ṫ: "Ṫ",
  Ţ: "Ţ",
  Ú: "Ú",
  Ù: "Ù",
  Ü: "Ü",
  Ǘ: "Ǘ",
  Ǜ: "Ǜ",
  Ǖ: "Ǖ",
  Ǚ: "Ǚ",
  Ũ: "Ũ",
  Ṹ: "Ṹ",
  Ū: "Ū",
  Ṻ: "Ṻ",
  Ŭ: "Ŭ",
  Ǔ: "Ǔ",
  Û: "Û",
  Ů: "Ů",
  Ű: "Ű",
  Ṽ: "Ṽ",
  Ẃ: "Ẃ",
  Ẁ: "Ẁ",
  Ẅ: "Ẅ",
  Ŵ: "Ŵ",
  Ẇ: "Ẇ",
  Ẍ: "Ẍ",
  Ẋ: "Ẋ",
  Ý: "Ý",
  Ỳ: "Ỳ",
  Ÿ: "Ÿ",
  Ỹ: "Ỹ",
  Ȳ: "Ȳ",
  Ŷ: "Ŷ",
  Ẏ: "Ẏ",
  Ź: "Ź",
  Ž: "Ž",
  Ẑ: "Ẑ",
  Ż: "Ż",
  ά: "ά",
  ὰ: "ὰ",
  ᾱ: "ᾱ",
  ᾰ: "ᾰ",
  έ: "έ",
  ὲ: "ὲ",
  ή: "ή",
  ὴ: "ὴ",
  ί: "ί",
  ὶ: "ὶ",
  ϊ: "ϊ",
  ΐ: "ΐ",
  ῒ: "ῒ",
  ῑ: "ῑ",
  ῐ: "ῐ",
  ό: "ό",
  ὸ: "ὸ",
  ύ: "ύ",
  ὺ: "ὺ",
  ϋ: "ϋ",
  ΰ: "ΰ",
  ῢ: "ῢ",
  ῡ: "ῡ",
  ῠ: "ῠ",
  ώ: "ώ",
  ὼ: "ὼ",
  Ύ: "Ύ",
  Ὺ: "Ὺ",
  Ϋ: "Ϋ",
  Ῡ: "Ῡ",
  Ῠ: "Ῠ",
  Ώ: "Ώ",
  Ὼ: "Ὼ"
};
let Parser$1 = class _I {
  constructor(t, g) {
    this.mode = void 0, this.gullet = void 0, this.settings = void 0, this.leftrightDepth = void 0, this.nextToken = void 0, this.mode = "math", this.gullet = new MacroExpander(t, g, this.mode), this.settings = g, this.leftrightDepth = 0;
  }
  /**
   * Checks a result to make sure it has the right type, and throws an
   * appropriate error otherwise.
   */
  expect(t, g) {
    if (g === void 0 && (g = !0), this.fetch().text !== t)
      throw new ParseError("Expected '" + t + "', got '" + this.fetch().text + "'", this.fetch());
    g && this.consume();
  }
  /**
   * Discards the current lookahead token, considering it consumed.
   */
  consume() {
    this.nextToken = null;
  }
  /**
   * Return the current lookahead token, or if there isn't one (at the
   * beginning, or if the previous lookahead token was consume()d),
   * fetch the next token as the new lookahead token and return it.
   */
  fetch() {
    return this.nextToken == null && (this.nextToken = this.gullet.expandNextToken()), this.nextToken;
  }
  /**
   * Switches between "text" and "math" modes.
   */
  switchMode(t) {
    this.mode = t, this.gullet.switchMode(t);
  }
  /**
   * Main parsing function, which parses an entire input.
   */
  parse() {
    this.settings.globalGroup || this.gullet.beginGroup(), this.settings.colorIsTextColor && this.gullet.macros.set("\\color", "\\textcolor");
    try {
      var t = this.parseExpression(!1);
      return this.expect("EOF"), this.settings.globalGroup || this.gullet.endGroup(), t;
    } finally {
      this.gullet.endGroups();
    }
  }
  /**
   * Fully parse a separate sequence of tokens as a separate job.
   * Tokens should be specified in reverse order, as in a MacroDefinition.
   */
  subparse(t) {
    var g = this.nextToken;
    this.consume(), this.gullet.pushToken(new Token("}")), this.gullet.pushTokens(t);
    var d = this.parseExpression(!1);
    return this.expect("}"), this.nextToken = g, d;
  }
  /**
   * Parses an "expression", which is a list of atoms.
   *
   * `breakOnInfix`: Should the parsing stop when we hit infix nodes? This
   *                 happens when functions have higher precedence han infix
   *                 nodes in implicit parses.
   *
   * `breakOnTokenText`: The text of the token that the expression should end
   *                     with, or `null` if something else should end the
   *                     expression.
   */
  parseExpression(t, g) {
    for (var d = []; ; ) {
      this.mode === "math" && this.consumeSpaces();
      var k = this.fetch();
      if (_I.endOfExpression.indexOf(k.text) !== -1 || g && k.text === g || t && functions[k.text] && functions[k.text].infix)
        break;
      var H = this.parseAtom(g);
      if (H) {
        if (H.type === "internal")
          continue;
      } else break;
      d.push(H);
    }
    return this.mode === "text" && this.formLigatures(d), this.handleInfixNodes(d);
  }
  /**
   * Rewrites infix operators such as \over with corresponding commands such
   * as \frac.
   *
   * There can only be one infix operator per group.  If there's more than one
   * then the expression is ambiguous.  This can be resolved by adding {}.
   */
  handleInfixNodes(t) {
    for (var g = -1, d, k = 0; k < t.length; k++)
      if (t[k].type === "infix") {
        if (g !== -1)
          throw new ParseError("only one infix operator per group", t[k].token);
        g = k, d = t[k].replaceWith;
      }
    if (g !== -1 && d) {
      var H, AA, gA = t.slice(0, g), IA = t.slice(g + 1);
      gA.length === 1 && gA[0].type === "ordgroup" ? H = gA[0] : H = {
        type: "ordgroup",
        mode: this.mode,
        body: gA
      }, IA.length === 1 && IA[0].type === "ordgroup" ? AA = IA[0] : AA = {
        type: "ordgroup",
        mode: this.mode,
        body: IA
      };
      var CA;
      return d === "\\\\abovefrac" ? CA = this.callFunction(d, [H, t[g], AA], []) : CA = this.callFunction(d, [H, AA], []), [CA];
    } else
      return t;
  }
  /**
   * Handle a subscript or superscript with nice errors.
   */
  handleSupSubscript(t) {
    var g = this.fetch(), d = g.text;
    this.consume(), this.consumeSpaces();
    var k;
    do {
      var H;
      k = this.parseGroup(t);
    } while (((H = k) == null ? void 0 : H.type) === "internal");
    if (!k)
      throw new ParseError("Expected group after '" + d + "'", g);
    return k;
  }
  /**
   * Converts the textual input of an unsupported command into a text node
   * contained within a color node whose color is determined by errorColor
   */
  formatUnsupportedCmd(t) {
    for (var g = [], d = 0; d < t.length; d++)
      g.push({
        type: "textord",
        mode: "text",
        text: t[d]
      });
    var k = {
      type: "text",
      mode: this.mode,
      body: g
    }, H = {
      type: "color",
      mode: this.mode,
      color: this.settings.errorColor,
      body: [k]
    };
    return H;
  }
  /**
   * Parses a group with optional super/subscripts.
   */
  parseAtom(t) {
    var g = this.parseGroup("atom", t);
    if (g?.type === "internal" || this.mode === "text")
      return g;
    for (var d, k; ; ) {
      this.consumeSpaces();
      var H = this.fetch();
      if (H.text === "\\limits" || H.text === "\\nolimits") {
        if (g && g.type === "op") {
          var AA = H.text === "\\limits";
          g.limits = AA, g.alwaysHandleSupSub = !0;
        } else if (g && g.type === "operatorname")
          g.alwaysHandleSupSub && (g.limits = H.text === "\\limits");
        else
          throw new ParseError("Limit controls must follow a math operator", H);
        this.consume();
      } else if (H.text === "^") {
        if (d)
          throw new ParseError("Double superscript", H);
        d = this.handleSupSubscript("superscript");
      } else if (H.text === "_") {
        if (k)
          throw new ParseError("Double subscript", H);
        k = this.handleSupSubscript("subscript");
      } else if (H.text === "'") {
        if (d)
          throw new ParseError("Double superscript", H);
        var gA = {
          type: "textord",
          mode: this.mode,
          text: "\\prime"
        }, IA = [gA];
        for (this.consume(); this.fetch().text === "'"; )
          IA.push(gA), this.consume();
        this.fetch().text === "^" && IA.push(this.handleSupSubscript("superscript")), d = {
          type: "ordgroup",
          mode: this.mode,
          body: IA
        };
      } else if (uSubsAndSups[H.text]) {
        var CA = unicodeSubRegEx.test(H.text), BA = [];
        for (BA.push(new Token(uSubsAndSups[H.text])), this.consume(); ; ) {
          var eA = this.fetch().text;
          if (!uSubsAndSups[eA] || unicodeSubRegEx.test(eA) !== CA)
            break;
          BA.unshift(new Token(uSubsAndSups[eA])), this.consume();
        }
        var iA = this.subparse(BA);
        CA ? k = {
          type: "ordgroup",
          mode: "math",
          body: iA
        } : d = {
          type: "ordgroup",
          mode: "math",
          body: iA
        };
      } else
        break;
    }
    return d || k ? {
      type: "supsub",
      mode: this.mode,
      base: g,
      sup: d,
      sub: k
    } : g;
  }
  /**
   * Parses an entire function, including its base and all of its arguments.
   */
  parseFunction(t, g) {
    var d = this.fetch(), k = d.text, H = functions[k];
    if (!H)
      return null;
    if (this.consume(), g && g !== "atom" && !H.allowedInArgument)
      throw new ParseError("Got function '" + k + "' with no arguments" + (g ? " as " + g : ""), d);
    if (this.mode === "text" && !H.allowedInText)
      throw new ParseError("Can't use function '" + k + "' in text mode", d);
    if (this.mode === "math" && H.allowedInMath === !1)
      throw new ParseError("Can't use function '" + k + "' in math mode", d);
    var {
      args: AA,
      optArgs: gA
    } = this.parseArguments(k, H);
    return this.callFunction(k, AA, gA, d, t);
  }
  /**
   * Call a function handler with a suitable context and arguments.
   */
  callFunction(t, g, d, k, H) {
    var AA = {
      funcName: t,
      parser: this,
      token: k,
      breakOnTokenText: H
    }, gA = functions[t];
    if (gA && gA.handler)
      return gA.handler(AA, g, d);
    throw new ParseError("No function handler for " + t);
  }
  /**
   * Parses the arguments of a function or environment
   */
  parseArguments(t, g) {
    var d = g.numArgs + g.numOptionalArgs;
    if (d === 0)
      return {
        args: [],
        optArgs: []
      };
    for (var k = [], H = [], AA = 0; AA < d; AA++) {
      var gA = g.argTypes && g.argTypes[AA], IA = AA < g.numOptionalArgs;
      (g.primitive && gA == null || // \sqrt expands into primitive if optional argument doesn't exist
      g.type === "sqrt" && AA === 1 && H[0] == null) && (gA = "primitive");
      var CA = this.parseGroupOfType("argument to '" + t + "'", gA, IA);
      if (IA)
        H.push(CA);
      else if (CA != null)
        k.push(CA);
      else
        throw new ParseError("Null argument, please report this as a bug");
    }
    return {
      args: k,
      optArgs: H
    };
  }
  /**
   * Parses a group when the mode is changing.
   */
  parseGroupOfType(t, g, d) {
    switch (g) {
      case "color":
        return this.parseColorGroup(d);
      case "size":
        return this.parseSizeGroup(d);
      case "url":
        return this.parseUrlGroup(d);
      case "math":
      case "text":
        return this.parseArgumentGroup(d, g);
      case "hbox": {
        var k = this.parseArgumentGroup(d, "text");
        return k != null ? {
          type: "styling",
          mode: k.mode,
          body: [k],
          style: "text"
          // simulate \textstyle
        } : null;
      }
      case "raw": {
        var H = this.parseStringGroup("raw", d);
        return H != null ? {
          type: "raw",
          mode: "text",
          string: H.text
        } : null;
      }
      case "primitive": {
        if (d)
          throw new ParseError("A primitive argument cannot be optional");
        var AA = this.parseGroup(t);
        if (AA == null)
          throw new ParseError("Expected group as " + t, this.fetch());
        return AA;
      }
      case "original":
      case null:
      case void 0:
        return this.parseArgumentGroup(d);
      default:
        throw new ParseError("Unknown group type as " + t, this.fetch());
    }
  }
  /**
   * Discard any space tokens, fetching the next non-space token.
   */
  consumeSpaces() {
    for (; this.fetch().text === " "; )
      this.consume();
  }
  /**
   * Parses a group, essentially returning the string formed by the
   * brace-enclosed tokens plus some position information.
   */
  parseStringGroup(t, g) {
    var d = this.gullet.scanArgument(g);
    if (d == null)
      return null;
    for (var k = "", H; (H = this.fetch()).text !== "EOF"; )
      k += H.text, this.consume();
    return this.consume(), d.text = k, d;
  }
  /**
   * Parses a regex-delimited group: the largest sequence of tokens
   * whose concatenated strings match `regex`. Returns the string
   * formed by the tokens plus some position information.
   */
  parseRegexGroup(t, g) {
    for (var d = this.fetch(), k = d, H = "", AA; (AA = this.fetch()).text !== "EOF" && t.test(H + AA.text); )
      k = AA, H += k.text, this.consume();
    if (H === "")
      throw new ParseError("Invalid " + g + ": '" + d.text + "'", d);
    return d.range(k, H);
  }
  /**
   * Parses a color description.
   */
  parseColorGroup(t) {
    var g = this.parseStringGroup("color", t);
    if (g == null)
      return null;
    var d = /^(#[a-f0-9]{3,4}|#[a-f0-9]{6}|#[a-f0-9]{8}|[a-f0-9]{6}|[a-z]+)$/i.exec(g.text);
    if (!d)
      throw new ParseError("Invalid color: '" + g.text + "'", g);
    var k = d[0];
    return /^[0-9a-f]{6}$/i.test(k) && (k = "#" + k), {
      type: "color-token",
      mode: this.mode,
      color: k
    };
  }
  /**
   * Parses a size specification, consisting of magnitude and unit.
   */
  parseSizeGroup(t) {
    var g, d = !1;
    if (this.gullet.consumeSpaces(), !t && this.gullet.future().text !== "{" ? g = this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/, "size") : g = this.parseStringGroup("size", t), !g)
      return null;
    !t && g.text.length === 0 && (g.text = "0pt", d = !0);
    var k = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(g.text);
    if (!k)
      throw new ParseError("Invalid size: '" + g.text + "'", g);
    var H = {
      number: +(k[1] + k[2]),
      // sign + magnitude, cast to number
      unit: k[3]
    };
    if (!validUnit(H))
      throw new ParseError("Invalid unit: '" + H.unit + "'", g);
    return {
      type: "size",
      mode: this.mode,
      value: H,
      isBlank: d
    };
  }
  /**
   * Parses an URL, checking escaped letters and allowed protocols,
   * and setting the catcode of % as an active character (as in \hyperref).
   */
  parseUrlGroup(t) {
    this.gullet.lexer.setCatcode("%", 13), this.gullet.lexer.setCatcode("~", 12);
    var g = this.parseStringGroup("url", t);
    if (this.gullet.lexer.setCatcode("%", 14), this.gullet.lexer.setCatcode("~", 13), g == null)
      return null;
    var d = g.text.replace(/\\([#$%&~_^{}])/g, "$1");
    return {
      type: "url",
      mode: this.mode,
      url: d
    };
  }
  /**
   * Parses an argument with the mode specified.
   */
  parseArgumentGroup(t, g) {
    var d = this.gullet.scanArgument(t);
    if (d == null)
      return null;
    var k = this.mode;
    g && this.switchMode(g), this.gullet.beginGroup();
    var H = this.parseExpression(!1, "EOF");
    this.expect("EOF"), this.gullet.endGroup();
    var AA = {
      type: "ordgroup",
      mode: this.mode,
      loc: d.loc,
      body: H
    };
    return g && this.switchMode(k), AA;
  }
  /**
   * Parses an ordinary group, which is either a single nucleus (like "x")
   * or an expression in braces (like "{x+y}") or an implicit group, a group
   * that starts at the current position, and ends right before a higher explicit
   * group ends, or at EOF.
   */
  parseGroup(t, g) {
    var d = this.fetch(), k = d.text, H;
    if (k === "{" || k === "\\begingroup") {
      this.consume();
      var AA = k === "{" ? "}" : "\\endgroup";
      this.gullet.beginGroup();
      var gA = this.parseExpression(!1, AA), IA = this.fetch();
      this.expect(AA), this.gullet.endGroup(), H = {
        type: "ordgroup",
        mode: this.mode,
        loc: SourceLocation.range(d, IA),
        body: gA,
        // A group formed by \begingroup...\endgroup is a semi-simple group
        // which doesn't affect spacing in math mode, i.e., is transparent.
        // https://tex.stackexchange.com/questions/1930/when-should-one-
        // use-begingroup-instead-of-bgroup
        semisimple: k === "\\begingroup" || void 0
      };
    } else if (H = this.parseFunction(g, t) || this.parseSymbol(), H == null && k[0] === "\\" && !implicitCommands.hasOwnProperty(k)) {
      if (this.settings.throwOnError)
        throw new ParseError("Undefined control sequence: " + k, d);
      H = this.formatUnsupportedCmd(k), this.consume();
    }
    return H;
  }
  /**
   * Form ligature-like combinations of characters for text mode.
   * This includes inputs like "--", "---", "``" and "''".
   * The result will simply replace multiple textord nodes with a single
   * character in each value by a single textord node having multiple
   * characters in its value.  The representation is still ASCII source.
   * The group will be modified in place.
   */
  formLigatures(t) {
    for (var g = t.length - 1, d = 0; d < g; ++d) {
      var k = t[d], H = k.text;
      H === "-" && t[d + 1].text === "-" && (d + 1 < g && t[d + 2].text === "-" ? (t.splice(d, 3, {
        type: "textord",
        mode: "text",
        loc: SourceLocation.range(k, t[d + 2]),
        text: "---"
      }), g -= 2) : (t.splice(d, 2, {
        type: "textord",
        mode: "text",
        loc: SourceLocation.range(k, t[d + 1]),
        text: "--"
      }), g -= 1)), (H === "'" || H === "`") && t[d + 1].text === H && (t.splice(d, 2, {
        type: "textord",
        mode: "text",
        loc: SourceLocation.range(k, t[d + 1]),
        text: H + H
      }), g -= 1);
    }
  }
  /**
   * Parse a single symbol out of the string. Here, we handle single character
   * symbols and special functions like \verb.
   */
  parseSymbol() {
    var t = this.fetch(), g = t.text;
    if (/^\\verb[^a-zA-Z]/.test(g)) {
      this.consume();
      var d = g.slice(5), k = d.charAt(0) === "*";
      if (k && (d = d.slice(1)), d.length < 2 || d.charAt(0) !== d.slice(-1))
        throw new ParseError(`\\verb assertion failed --
                    please report what input caused this bug`);
      return d = d.slice(1, -1), {
        type: "verb",
        mode: "text",
        body: d,
        star: k
      };
    }
    unicodeSymbols.hasOwnProperty(g[0]) && !symbols$4[this.mode][g[0]] && (this.settings.strict && this.mode === "math" && this.settings.reportNonstrict("unicodeTextInMathMode", 'Accented Unicode text character "' + g[0] + '" used in math mode', t), g = unicodeSymbols[g[0]] + g.slice(1));
    var H = combiningDiacriticalMarksEndRegex.exec(g);
    H && (g = g.substring(0, H.index), g === "i" ? g = "ı" : g === "j" && (g = "ȷ"));
    var AA;
    if (symbols$4[this.mode][g]) {
      this.settings.strict && this.mode === "math" && extraLatin.indexOf(g) >= 0 && this.settings.reportNonstrict("unicodeTextInMathMode", 'Latin-1/Unicode text character "' + g[0] + '" used in math mode', t);
      var gA = symbols$4[this.mode][g].group, IA = SourceLocation.range(t), CA;
      if (ATOMS.hasOwnProperty(gA)) {
        var BA = gA;
        CA = {
          type: "atom",
          mode: this.mode,
          family: BA,
          loc: IA,
          text: g
        };
      } else
        CA = {
          type: gA,
          mode: this.mode,
          loc: IA,
          text: g
        };
      AA = CA;
    } else if (g.charCodeAt(0) >= 128)
      this.settings.strict && (supportedCodepoint(g.charCodeAt(0)) ? this.mode === "math" && this.settings.reportNonstrict("unicodeTextInMathMode", 'Unicode text character "' + g[0] + '" used in math mode', t) : this.settings.reportNonstrict("unknownSymbol", 'Unrecognized Unicode character "' + g[0] + '"' + (" (" + g.charCodeAt(0) + ")"), t)), AA = {
        type: "textord",
        mode: "text",
        loc: SourceLocation.range(t),
        text: g
      };
    else
      return null;
    if (this.consume(), H)
      for (var eA = 0; eA < H[0].length; eA++) {
        var iA = H[0][eA];
        if (!unicodeAccents[iA])
          throw new ParseError("Unknown accent ' " + iA + "'", t);
        var QA = unicodeAccents[iA][this.mode] || unicodeAccents[iA].text;
        if (!QA)
          throw new ParseError("Accent " + iA + " unsupported in " + this.mode + " mode", t);
        AA = {
          type: "accent",
          mode: this.mode,
          loc: SourceLocation.range(t),
          label: QA,
          isStretchy: !1,
          isShifty: !0,
          // $FlowFixMe
          base: AA
        };
      }
    return AA;
  }
};
Parser$1.endOfExpression = ["}", "\\endgroup", "\\end", "\\right", "&"];
var parseTree = function n(t, g) {
  if (!(typeof t == "string" || t instanceof String))
    throw new TypeError("KaTeX can only parse string typed expression");
  var d = new Parser$1(t, g);
  delete d.gullet.macros.current["\\df@tag"];
  var k = d.parse();
  if (delete d.gullet.macros.current["\\current@color"], delete d.gullet.macros.current["\\color"], d.gullet.macros.get("\\df@tag")) {
    if (!g.displayMode)
      throw new ParseError("\\tag works only in display equations");
    k = [{
      type: "tag",
      mode: "text",
      body: k,
      tag: d.subparse([new Token("\\df@tag")])
    }];
  }
  return k;
}, render$1 = function n(t, g, d) {
  g.textContent = "";
  var k = renderToDomTree(t, d).toNode();
  g.appendChild(k);
};
typeof document < "u" && document.compatMode !== "CSS1Compat" && (typeof console < "u" && console.warn("Warning: KaTeX doesn't work in quirks mode. Make sure your website has a suitable doctype."), render$1 = function() {
  throw new ParseError("KaTeX doesn't work in quirks mode.");
});
var renderToString = function n(t, g) {
  var d = renderToDomTree(t, g).toMarkup();
  return d;
}, generateParseTree = function n(t, g) {
  var d = new Settings(g);
  return parseTree(t, d);
}, renderError = function n(t, g, d) {
  if (d.throwOnError || !(t instanceof ParseError))
    throw t;
  var k = buildCommon.makeSpan(["katex-error"], [new SymbolNode(g)]);
  return k.setAttribute("title", t.toString()), k.setAttribute("style", "color:" + d.errorColor), k;
}, renderToDomTree = function n(t, g) {
  var d = new Settings(g);
  try {
    var k = parseTree(t, d);
    return buildTree(k, t, d);
  } catch (H) {
    return renderError(H, t, d);
  }
}, renderToHTMLTree = function n(t, g) {
  var d = new Settings(g);
  try {
    var k = parseTree(t, d);
    return buildHTMLTree(k, t, d);
  } catch (H) {
    return renderError(H, t, d);
  }
}, version$5 = "0.16.25", __domTree = {
  Span,
  Anchor,
  SymbolNode,
  SvgNode,
  PathNode,
  LineNode
}, katex = {
  /**
   * Current KaTeX version
   */
  version: version$5,
  /**
   * Renders the given LaTeX into an HTML+MathML combination, and adds
   * it as a child to the specified DOM node.
   */
  render: render$1,
  /**
   * Renders the given LaTeX into an HTML+MathML combination string,
   * for sending to the client.
   */
  renderToString,
  /**
   * KaTeX error, usually during parsing.
   */
  ParseError,
  /**
   * The schema of Settings
   */
  SETTINGS_SCHEMA,
  /**
   * Parses the given LaTeX into KaTeX's internal parse tree structure,
   * without rendering to HTML or MathML.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __parse: generateParseTree,
  /**
   * Renders the given LaTeX into an HTML+MathML internal DOM tree
   * representation, without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __renderToDomTree: renderToDomTree,
  /**
   * Renders the given LaTeX into an HTML internal DOM tree representation,
   * without MathML and without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __renderToHTMLTree: renderToHTMLTree,
  /**
   * extends internal font metrics object with a new object
   * each key in the new object represents a font name
  */
  __setFontMetrics: setFontMetrics,
  /**
   * adds a new symbol to builtin symbols table
   */
  __defineSymbol: defineSymbol,
  /**
   * adds a new function to builtin function list,
   * which directly produce parse tree elements
   * and have their own html/mathml builders
   */
  __defineFunction: defineFunction,
  /**
   * adds a new macro to builtin macro list
   */
  __defineMacro: defineMacro,
  /**
   * Expose the dom tree node types, which can be useful for type checking nodes.
   *
   * NOTE: These methods are not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __domTree
};
const emptyOptions$4 = {}, emptyClasses = [];
function rehypeKatex(n) {
  const t = n || emptyOptions$4;
  return function(g, d) {
    visitParents(g, "element", function(k, H) {
      const AA = Array.isArray(k.properties.className) ? k.properties.className : emptyClasses, gA = AA.includes("language-math"), IA = AA.includes("math-display"), CA = AA.includes("math-inline");
      let BA = IA;
      if (!gA && !IA && !CA)
        return;
      let eA = H[H.length - 1], iA = k;
      if (k.tagName === "code" && gA && eA && eA.type === "element" && eA.tagName === "pre" && (iA = eA, eA = H[H.length - 2], BA = !0), !eA) return;
      const QA = toText(iA, { whitespace: "pre" });
      let tA;
      try {
        tA = katex.renderToString(QA, {
          ...t,
          displayMode: BA,
          throwOnError: !0
        });
      } catch (EA) {
        const aA = (
          /** @type {Error} */
          EA
        ), nA = aA.name.toLowerCase();
        d.message("Could not render math with KaTeX", {
          ancestors: [...H, k],
          cause: aA,
          place: k.position,
          ruleId: nA,
          source: "rehype-katex"
        });
        try {
          tA = katex.renderToString(QA, {
            ...t,
            displayMode: BA,
            strict: "ignore",
            throwOnError: !1
          });
        } catch {
          tA = [
            {
              type: "element",
              tagName: "span",
              properties: {
                className: ["katex-error"],
                style: "color:" + (t.errorColor || "#cc0000"),
                title: String(EA)
              },
              children: [{ type: "text", value: QA }]
            }
          ];
        }
      }
      typeof tA == "string" && (tA = /** @type {Array<ElementContent>} */
      fromHtmlIsomorphic(tA).children);
      const oA = eA.children.indexOf(iA);
      return eA.children.splice(oA, 1, ...tA), SKIP$3;
    });
  };
}
function location$1(n) {
  const t = String(n), g = [];
  return { toOffset: k, toPoint: d };
  function d(H) {
    if (typeof H == "number" && H > -1 && H <= t.length) {
      let AA = 0;
      for (; ; ) {
        let gA = g[AA];
        if (gA === void 0) {
          const IA = next(t, g[AA - 1]);
          gA = IA === -1 ? t.length + 1 : IA + 1, g[AA] = gA;
        }
        if (gA > H)
          return {
            line: AA + 1,
            column: H - (AA > 0 ? g[AA - 1] : 0) + 1,
            offset: H
          };
        AA++;
      }
    }
  }
  function k(H) {
    if (H && typeof H.line == "number" && typeof H.column == "number" && !Number.isNaN(H.line) && !Number.isNaN(H.column)) {
      for (; g.length < H.line; ) {
        const gA = g[g.length - 1], IA = next(t, gA), CA = IA === -1 ? t.length + 1 : IA + 1;
        if (gA === CA) break;
        g.push(CA);
      }
      const AA = (H.line > 1 ? g[H.line - 2] : 0) + H.column - 1;
      if (AA < g[H.line - 1]) return AA;
    }
  }
}
function next(n, t) {
  const g = n.indexOf("\r", t), d = n.indexOf(`
`, t);
  return d === -1 ? g : g === -1 || g + 1 === d ? d : g < d ? g : d;
}
const own$4 = {}.hasOwnProperty, proto$3 = Object.prototype;
function fromParse5(n, t) {
  const g = t || {};
  return one$5(
    {
      file: g.file || void 0,
      location: !1,
      schema: g.space === "svg" ? svg$2 : html$5,
      verbose: g.verbose || !1
    },
    n
  );
}
function one$5(n, t) {
  let g;
  switch (t.nodeName) {
    case "#comment": {
      const d = (
        /** @type {DefaultTreeAdapterMap['commentNode']} */
        t
      );
      return g = { type: "comment", value: d.data }, patch$2(n, d, g), g;
    }
    case "#document":
    case "#document-fragment": {
      const d = (
        /** @type {DefaultTreeAdapterMap['document'] | DefaultTreeAdapterMap['documentFragment']} */
        t
      ), k = "mode" in d ? d.mode === "quirks" || d.mode === "limited-quirks" : !1;
      if (g = {
        type: "root",
        children: all$3(n, t.childNodes),
        data: { quirksMode: k }
      }, n.file && n.location) {
        const H = String(n.file), AA = location$1(H), gA = AA.toPoint(0), IA = AA.toPoint(H.length);
        g.position = { start: gA, end: IA };
      }
      return g;
    }
    case "#documentType": {
      const d = (
        /** @type {DefaultTreeAdapterMap['documentType']} */
        t
      );
      return g = { type: "doctype" }, patch$2(n, d, g), g;
    }
    case "#text": {
      const d = (
        /** @type {DefaultTreeAdapterMap['textNode']} */
        t
      );
      return g = { type: "text", value: d.value }, patch$2(n, d, g), g;
    }
    // Element.
    default:
      return g = element$4(
        n,
        /** @type {DefaultTreeAdapterMap['element']} */
        t
      ), g;
  }
}
function all$3(n, t) {
  let g = -1;
  const d = [];
  for (; ++g < t.length; ) {
    const k = (
      /** @type {RootContent} */
      one$5(n, t[g])
    );
    d.push(k);
  }
  return d;
}
function element$4(n, t) {
  const g = n.schema;
  n.schema = t.namespaceURI === webNamespaces.svg ? svg$2 : html$5;
  let d = -1;
  const k = {};
  for (; ++d < t.attrs.length; ) {
    const gA = t.attrs[d], IA = (gA.prefix ? gA.prefix + ":" : "") + gA.name;
    own$4.call(proto$3, IA) || (k[IA] = gA.value);
  }
  const AA = (n.schema.space === "svg" ? s$1 : h$1)(t.tagName, k, all$3(n, t.childNodes));
  if (patch$2(n, t, AA), AA.tagName === "template") {
    const gA = (
      /** @type {DefaultTreeAdapterMap['template']} */
      t
    ), IA = gA.sourceCodeLocation, CA = IA && IA.startTag && position$2(IA.startTag), BA = IA && IA.endTag && position$2(IA.endTag), eA = (
      /** @type {Root} */
      one$5(n, gA.content)
    );
    CA && BA && n.file && (eA.position = { start: CA.end, end: BA.start }), AA.content = eA;
  }
  return n.schema = g, AA;
}
function patch$2(n, t, g) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && n.file) {
    const d = createLocation(n, g, t.sourceCodeLocation);
    d && (n.location = !0, g.position = d);
  }
}
function createLocation(n, t, g) {
  const d = position$2(g);
  if (t.type === "element") {
    const k = t.children[t.children.length - 1];
    if (d && !g.endTag && k && k.position && k.position.end && (d.end = Object.assign({}, k.position.end)), n.verbose) {
      const H = {};
      let AA;
      if (g.attrs)
        for (AA in g.attrs)
          own$4.call(g.attrs, AA) && (H[find$4(n.schema, AA).property] = position$2(
            g.attrs[AA]
          ));
      g.startTag;
      const gA = position$2(g.startTag), IA = g.endTag ? position$2(g.endTag) : void 0, CA = { opening: gA };
      IA && (CA.closing = IA), CA.properties = H, t.data = { position: CA };
    }
  }
  return d;
}
function position$2(n) {
  const t = point$8({
    line: n.startLine,
    column: n.startCol,
    offset: n.startOffset
  }), g = point$8({
    line: n.endLine,
    column: n.endCol,
    offset: n.endOffset
  });
  return t || g ? { start: t, end: g } : void 0;
}
function point$8(n) {
  return n.line && n.column ? n : void 0;
}
class Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, g, d) {
    this.property = t, this.normal = g, d && (this.space = d);
  }
}
Schema.prototype.property = {};
Schema.prototype.normal = {};
Schema.prototype.space = null;
function merge$6(n, t) {
  const g = {}, d = {};
  let k = -1;
  for (; ++k < n.length; )
    Object.assign(g, n[k].property), Object.assign(d, n[k].normal);
  return new Schema(g, d, t);
}
function normalize$3(n) {
  return n.toLowerCase();
}
let Info$2 = class {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, g) {
    this.property = t, this.attribute = g;
  }
};
Info$2.prototype.space = null;
Info$2.prototype.boolean = !1;
Info$2.prototype.booleanish = !1;
Info$2.prototype.overloadedBoolean = !1;
Info$2.prototype.number = !1;
Info$2.prototype.commaSeparated = !1;
Info$2.prototype.spaceSeparated = !1;
Info$2.prototype.commaOrSpaceSeparated = !1;
Info$2.prototype.mustUseProperty = !1;
Info$2.prototype.defined = !1;
let powers$1 = 0;
const boolean = increment$1(), booleanish = increment$1(), overloadedBoolean = increment$1(), number$7 = increment$1(), spaceSeparated = increment$1(), commaSeparated = increment$1(), commaOrSpaceSeparated = increment$1();
function increment$1() {
  return 2 ** ++powers$1;
}
const types$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean,
  booleanish,
  commaOrSpaceSeparated,
  commaSeparated,
  number: number$7,
  overloadedBoolean,
  spaceSeparated
}, Symbol.toStringTag, { value: "Module" })), checks = Object.keys(types$2);
class DefinedInfo extends Info$2 {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, g, d, k) {
    let H = -1;
    if (super(t, g), mark$1(this, "space", k), typeof d == "number")
      for (; ++H < checks.length; ) {
        const AA = checks[H];
        mark$1(this, checks[H], (d & types$2[AA]) === types$2[AA]);
      }
  }
}
DefinedInfo.prototype.defined = !0;
function mark$1(n, t, g) {
  g && (n[t] = g);
}
const own$3 = {}.hasOwnProperty;
function create$3(n) {
  const t = {}, g = {};
  let d;
  for (d in n.properties)
    if (own$3.call(n.properties, d)) {
      const k = n.properties[d], H = new DefinedInfo(
        d,
        n.transform(n.attributes || {}, d),
        k,
        n.space
      );
      n.mustUseProperty && n.mustUseProperty.includes(d) && (H.mustUseProperty = !0), t[d] = H, g[normalize$3(d)] = d, g[normalize$3(H.attribute)] = d;
    }
  return new Schema(t, g, n.space);
}
const xlink$1 = create$3({
  space: "xlink",
  transform(n, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), xml$1 = create$3({
  space: "xml",
  transform(n, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function caseSensitiveTransform(n, t) {
  return t in n ? n[t] : t;
}
function caseInsensitiveTransform(n, t) {
  return caseSensitiveTransform(n, t.toLowerCase());
}
const xmlns$2 = create$3({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: caseInsensitiveTransform,
  properties: { xmlns: null, xmlnsXLink: null }
}), aria$2 = create$3({
  transform(n, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number$7,
    ariaColIndex: number$7,
    ariaColSpan: number$7,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number$7,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number$7,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number$7,
    ariaRowIndex: number$7,
    ariaRowSpan: number$7,
    ariaSelected: booleanish,
    ariaSetSize: number$7,
    ariaSort: null,
    ariaValueMax: number$7,
    ariaValueMin: number$7,
    ariaValueNow: number$7,
    ariaValueText: null,
    role: null
  }
}), html$3 = create$3({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    blocking: spaceSeparated,
    capture: null,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number$7,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number$7 | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number$7,
    hidden: boolean,
    high: number$7,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number$7,
    manifest: null,
    max: null,
    maxLength: number$7,
    media: null,
    method: null,
    min: null,
    minLength: number$7,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number$7,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number$7,
    rowSpan: number$7,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shadowRootClonable: boolean,
    shadowRootDelegatesFocus: boolean,
    shadowRootMode: null,
    shape: null,
    size: number$7,
    sizes: null,
    slot: null,
    span: number$7,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number$7,
    step: null,
    style: null,
    tabIndex: number$7,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number$7,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number$7,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number$7,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: boolean,
    // Lists. Use CSS to reduce space between items instead
    declare: boolean,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number$7,
    // `<img>` and `<object>`
    leftMargin: number$7,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number$7,
    // `<body>`
    marginWidth: number$7,
    // `<body>`
    noResize: boolean,
    // `<frame>`
    noHref: boolean,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number$7,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number$7,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number$7,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number$7,
    security: null,
    unselectable: null
  }
}), svg$1 = create$3({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number$7,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number$7,
    amplitude: number$7,
    arabicForm: null,
    ascent: number$7,
    attributeName: null,
    attributeType: null,
    azimuth: number$7,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number$7,
    by: null,
    calcMode: null,
    capHeight: number$7,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number$7,
    diffuseConstant: number$7,
    direction: null,
    display: null,
    dur: null,
    divisor: number$7,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number$7,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number$7,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number$7,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number$7,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number$7,
    horizOriginX: number$7,
    horizOriginY: number$7,
    id: null,
    ideographic: number$7,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number$7,
    k: number$7,
    k1: number$7,
    k2: number$7,
    k3: number$7,
    k4: number$7,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number$7,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number$7,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number$7,
    overlineThickness: number$7,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number$7,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number$7,
    pointsAtY: number$7,
    pointsAtZ: number$7,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number$7,
    specularExponent: number$7,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number$7,
    strikethroughThickness: number$7,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number$7,
    strokeOpacity: number$7,
    strokeWidth: null,
    style: null,
    surfaceScale: number$7,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number$7,
    tableValues: null,
    target: null,
    targetX: number$7,
    targetY: number$7,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number$7,
    underlineThickness: number$7,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number$7,
    values: null,
    vAlphabetic: number$7,
    vMathematical: number$7,
    vectorEffect: null,
    vHanging: number$7,
    vIdeographic: number$7,
    version: null,
    vertAdvY: number$7,
    vertOriginX: number$7,
    vertOriginY: number$7,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number$7,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), valid = /^data[-\w.:]+$/i, dash$1 = /-[a-z]/g, cap = /[A-Z]/g;
function find$3(n, t) {
  const g = normalize$3(t);
  let d = t, k = Info$2;
  if (g in n.normal)
    return n.property[n.normal[g]];
  if (g.length > 4 && g.slice(0, 4) === "data" && valid.test(t)) {
    if (t.charAt(4) === "-") {
      const H = t.slice(5).replace(dash$1, camelcase);
      d = "data" + H.charAt(0).toUpperCase() + H.slice(1);
    } else {
      const H = t.slice(4);
      if (!dash$1.test(H)) {
        let AA = H.replace(cap, kebab);
        AA.charAt(0) !== "-" && (AA = "-" + AA), t = "data" + AA;
      }
    }
    k = DefinedInfo;
  }
  return new k(d, t);
}
function kebab(n) {
  return "-" + n.toLowerCase();
}
function camelcase(n) {
  return n.charAt(1).toUpperCase();
}
const html$2 = merge$6([xml$1, xlink$1, xmlns$2, aria$2, html$3], "html"), svg = merge$6([xml$1, xlink$1, xmlns$2, aria$2, svg$1], "svg"), own$2 = {}.hasOwnProperty;
function zwitch(n, t) {
  const g = t || {};
  function d(k, ...H) {
    let AA = d.invalid;
    const gA = d.handlers;
    if (k && own$2.call(k, n)) {
      const IA = String(k[n]);
      AA = own$2.call(gA, IA) ? gA[IA] : d.unknown;
    }
    if (AA)
      return AA.call(this, k, ...H);
  }
  return d.handlers = g.handlers || {}, d.invalid = g.invalid, d.unknown = g.unknown, d;
}
const emptyOptions$3 = {}, own$1 = {}.hasOwnProperty, one$4 = zwitch("type", { handlers: { root: root$5, element: element$3, text: text$6, comment: comment$1, doctype: doctype$1 } });
function toParse5(n, t) {
  const d = (t || emptyOptions$3).space;
  return one$4(n, d === "svg" ? svg : html$2);
}
function root$5(n, t) {
  const g = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (n.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return g.childNodes = all$2(n.children, g, t), patch$1(n, g), g;
}
function fragment(n, t) {
  const g = { nodeName: "#document-fragment", childNodes: [] };
  return g.childNodes = all$2(n.children, g, t), patch$1(n, g), g;
}
function doctype$1(n) {
  const t = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    parentNode: null
  };
  return patch$1(n, t), t;
}
function text$6(n) {
  const t = {
    nodeName: "#text",
    value: n.value,
    parentNode: null
  };
  return patch$1(n, t), t;
}
function comment$1(n) {
  const t = {
    nodeName: "#comment",
    data: n.value,
    parentNode: null
  };
  return patch$1(n, t), t;
}
function element$3(n, t) {
  const g = t;
  let d = g;
  n.type === "element" && n.tagName.toLowerCase() === "svg" && g.space === "html" && (d = svg);
  const k = [];
  let H;
  if (n.properties) {
    for (H in n.properties)
      if (H !== "children" && own$1.call(n.properties, H)) {
        const IA = createProperty(
          d,
          H,
          n.properties[H]
        );
        IA && k.push(IA);
      }
  }
  const AA = d.space, gA = {
    nodeName: n.tagName,
    tagName: n.tagName,
    attrs: k,
    // @ts-expect-error: `parse5` types are wrong.
    namespaceURI: webNamespaces[AA],
    childNodes: [],
    parentNode: null
  };
  return gA.childNodes = all$2(n.children, gA, d), patch$1(n, gA), n.tagName === "template" && n.content && (gA.content = fragment(n.content, d)), gA;
}
function createProperty(n, t, g) {
  const d = find$3(n, t);
  if (g === !1 || g === null || g === void 0 || typeof g == "number" && Number.isNaN(g) || !g && d.boolean)
    return;
  Array.isArray(g) && (g = d.commaSeparated ? stringify$5(g) : stringify$4(g));
  const k = {
    name: d.attribute,
    value: g === !0 ? "" : String(g)
  };
  if (d.space && d.space !== "html" && d.space !== "svg") {
    const H = k.name.indexOf(":");
    H < 0 ? k.prefix = "" : (k.name = k.name.slice(H + 1), k.prefix = d.attribute.slice(0, H)), k.namespace = webNamespaces[d.space];
  }
  return k;
}
function all$2(n, t, g) {
  let d = -1;
  const k = [];
  if (n)
    for (; ++d < n.length; ) {
      const H = one$4(n[d], g);
      H.parentNode = t, k.push(H);
    }
  return k;
}
function patch$1(n, t) {
  const g = n.position;
  g && g.start && g.end && (g.start.offset, g.end.offset, t.sourceCodeLocation = {
    startLine: g.start.line,
    startCol: g.start.column,
    startOffset: g.start.offset,
    endLine: g.end.line,
    endCol: g.end.column,
    endOffset: g.end.offset
  });
}
const htmlVoidElements = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], UNDEFINED_CODE_POINTS = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), REPLACEMENT_CHARACTER = "�";
var CODE_POINTS;
(function(n) {
  n[n.EOF = -1] = "EOF", n[n.NULL = 0] = "NULL", n[n.TABULATION = 9] = "TABULATION", n[n.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", n[n.LINE_FEED = 10] = "LINE_FEED", n[n.FORM_FEED = 12] = "FORM_FEED", n[n.SPACE = 32] = "SPACE", n[n.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", n[n.QUOTATION_MARK = 34] = "QUOTATION_MARK", n[n.AMPERSAND = 38] = "AMPERSAND", n[n.APOSTROPHE = 39] = "APOSTROPHE", n[n.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", n[n.SOLIDUS = 47] = "SOLIDUS", n[n.DIGIT_0 = 48] = "DIGIT_0", n[n.DIGIT_9 = 57] = "DIGIT_9", n[n.SEMICOLON = 59] = "SEMICOLON", n[n.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", n[n.EQUALS_SIGN = 61] = "EQUALS_SIGN", n[n.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", n[n.QUESTION_MARK = 63] = "QUESTION_MARK", n[n.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", n[n.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", n[n.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", n[n.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", n[n.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", n[n.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(CODE_POINTS || (CODE_POINTS = {}));
const SEQUENCES = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function isSurrogate(n) {
  return n >= 55296 && n <= 57343;
}
function isSurrogatePair(n) {
  return n >= 56320 && n <= 57343;
}
function getSurrogatePairCodePoint(n, t) {
  return (n - 55296) * 1024 + 9216 + t;
}
function isControlCodePoint(n) {
  return n !== 32 && n !== 10 && n !== 13 && n !== 9 && n !== 12 && n >= 1 && n <= 31 || n >= 127 && n <= 159;
}
function isUndefinedCodePoint(n) {
  return n >= 64976 && n <= 65007 || UNDEFINED_CODE_POINTS.has(n);
}
var ERR;
(function(n) {
  n.controlCharacterInInputStream = "control-character-in-input-stream", n.noncharacterInInputStream = "noncharacter-in-input-stream", n.surrogateInInputStream = "surrogate-in-input-stream", n.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", n.endTagWithAttributes = "end-tag-with-attributes", n.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", n.unexpectedSolidusInTag = "unexpected-solidus-in-tag", n.unexpectedNullCharacter = "unexpected-null-character", n.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", n.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", n.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", n.missingEndTagName = "missing-end-tag-name", n.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", n.unknownNamedCharacterReference = "unknown-named-character-reference", n.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", n.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", n.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", n.eofBeforeTagName = "eof-before-tag-name", n.eofInTag = "eof-in-tag", n.missingAttributeValue = "missing-attribute-value", n.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", n.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", n.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", n.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", n.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", n.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", n.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", n.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", n.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", n.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", n.cdataInHtmlContent = "cdata-in-html-content", n.incorrectlyOpenedComment = "incorrectly-opened-comment", n.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", n.eofInDoctype = "eof-in-doctype", n.nestedComment = "nested-comment", n.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", n.eofInComment = "eof-in-comment", n.incorrectlyClosedComment = "incorrectly-closed-comment", n.eofInCdata = "eof-in-cdata", n.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", n.nullCharacterReference = "null-character-reference", n.surrogateCharacterReference = "surrogate-character-reference", n.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", n.controlCharacterReference = "control-character-reference", n.noncharacterCharacterReference = "noncharacter-character-reference", n.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", n.missingDoctypeName = "missing-doctype-name", n.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", n.duplicateAttribute = "duplicate-attribute", n.nonConformingDoctype = "non-conforming-doctype", n.missingDoctype = "missing-doctype", n.misplacedDoctype = "misplaced-doctype", n.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", n.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", n.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", n.openElementsLeftAfterEof = "open-elements-left-after-eof", n.abandonedHeadElementChild = "abandoned-head-element-child", n.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", n.nestedNoscriptInHead = "nested-noscript-in-head", n.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(ERR || (ERR = {}));
const DEFAULT_BUFFER_WATERLINE = 65536;
class Preprocessor {
  constructor(t) {
    this.handler = t, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = DEFAULT_BUFFER_WATERLINE, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(t, g) {
    const { line: d, col: k, offset: H } = this, AA = k + g, gA = H + g;
    return {
      code: t,
      startLine: d,
      endLine: d,
      startCol: AA,
      endCol: AA,
      startOffset: gA,
      endOffset: gA
    };
  }
  _err(t) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(t, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.html.length - 1) {
      const g = this.html.charCodeAt(this.pos + 1);
      if (isSurrogatePair(g))
        return this.pos++, this._addGap(), getSurrogatePairCodePoint(t, g);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, CODE_POINTS.EOF;
    return this._err(ERR.surrogateInInputStream), t;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(t, g) {
    this.html.length > 0 ? this.html += t : this.html = t, this.endOfChunkHit = !1, this.lastChunkWritten = g;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(t, g) {
    if (this.pos + t.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (g)
      return this.html.startsWith(t, this.pos);
    for (let d = 0; d < t.length; d++)
      if ((this.html.charCodeAt(this.pos + d) | 32) !== t.charCodeAt(d))
        return !1;
    return !0;
  }
  peek(t) {
    const g = this.pos + t;
    if (g >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, CODE_POINTS.EOF;
    const d = this.html.charCodeAt(g);
    return d === CODE_POINTS.CARRIAGE_RETURN ? CODE_POINTS.LINE_FEED : d;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, CODE_POINTS.EOF;
    let t = this.html.charCodeAt(this.pos);
    return t === CODE_POINTS.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, CODE_POINTS.LINE_FEED) : t === CODE_POINTS.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, isSurrogate(t) && (t = this._processSurrogate(t)), this.handler.onParseError === null || t > 31 && t < 127 || t === CODE_POINTS.LINE_FEED || t === CODE_POINTS.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    isControlCodePoint(t) ? this._err(ERR.controlCharacterInInputStream) : isUndefinedCodePoint(t) && this._err(ERR.noncharacterInInputStream);
  }
  retreat(t) {
    for (this.pos -= t; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var TokenType;
(function(n) {
  n[n.CHARACTER = 0] = "CHARACTER", n[n.NULL_CHARACTER = 1] = "NULL_CHARACTER", n[n.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", n[n.START_TAG = 3] = "START_TAG", n[n.END_TAG = 4] = "END_TAG", n[n.COMMENT = 5] = "COMMENT", n[n.DOCTYPE = 6] = "DOCTYPE", n[n.EOF = 7] = "EOF", n[n.HIBERNATION = 8] = "HIBERNATION";
})(TokenType || (TokenType = {}));
function getTokenAttr(n, t) {
  for (let g = n.attrs.length - 1; g >= 0; g--)
    if (n.attrs[g].name === t)
      return n.attrs[g].value;
  return null;
}
const htmlDecodeTree = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ 'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((n) => n.charCodeAt(0))
), decodeMap = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
function replaceCodePoint(n) {
  var t;
  return n >= 55296 && n <= 57343 || n > 1114111 ? 65533 : (t = decodeMap.get(n)) !== null && t !== void 0 ? t : n;
}
var CharCodes;
(function(n) {
  n[n.NUM = 35] = "NUM", n[n.SEMI = 59] = "SEMI", n[n.EQUALS = 61] = "EQUALS", n[n.ZERO = 48] = "ZERO", n[n.NINE = 57] = "NINE", n[n.LOWER_A = 97] = "LOWER_A", n[n.LOWER_F = 102] = "LOWER_F", n[n.LOWER_X = 120] = "LOWER_X", n[n.LOWER_Z = 122] = "LOWER_Z", n[n.UPPER_A = 65] = "UPPER_A", n[n.UPPER_F = 70] = "UPPER_F", n[n.UPPER_Z = 90] = "UPPER_Z";
})(CharCodes || (CharCodes = {}));
const TO_LOWER_BIT = 32;
var BinTrieFlags;
(function(n) {
  n[n.VALUE_LENGTH = 49152] = "VALUE_LENGTH", n[n.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", n[n.JUMP_TABLE = 127] = "JUMP_TABLE";
})(BinTrieFlags || (BinTrieFlags = {}));
function isNumber$5(n) {
  return n >= CharCodes.ZERO && n <= CharCodes.NINE;
}
function isHexadecimalCharacter(n) {
  return n >= CharCodes.UPPER_A && n <= CharCodes.UPPER_F || n >= CharCodes.LOWER_A && n <= CharCodes.LOWER_F;
}
function isAsciiAlphaNumeric$1(n) {
  return n >= CharCodes.UPPER_A && n <= CharCodes.UPPER_Z || n >= CharCodes.LOWER_A && n <= CharCodes.LOWER_Z || isNumber$5(n);
}
function isEntityInAttributeInvalidEnd(n) {
  return n === CharCodes.EQUALS || isAsciiAlphaNumeric$1(n);
}
var EntityDecoderState;
(function(n) {
  n[n.EntityStart = 0] = "EntityStart", n[n.NumericStart = 1] = "NumericStart", n[n.NumericDecimal = 2] = "NumericDecimal", n[n.NumericHex = 3] = "NumericHex", n[n.NamedEntity = 4] = "NamedEntity";
})(EntityDecoderState || (EntityDecoderState = {}));
var DecodingMode;
(function(n) {
  n[n.Legacy = 0] = "Legacy", n[n.Strict = 1] = "Strict", n[n.Attribute = 2] = "Attribute";
})(DecodingMode || (DecodingMode = {}));
class EntityDecoder {
  constructor(t, g, d) {
    this.decodeTree = t, this.emitCodePoint = g, this.errors = d, this.state = EntityDecoderState.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = DecodingMode.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = EntityDecoderState.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, g) {
    switch (this.state) {
      case EntityDecoderState.EntityStart:
        return t.charCodeAt(g) === CharCodes.NUM ? (this.state = EntityDecoderState.NumericStart, this.consumed += 1, this.stateNumericStart(t, g + 1)) : (this.state = EntityDecoderState.NamedEntity, this.stateNamedEntity(t, g));
      case EntityDecoderState.NumericStart:
        return this.stateNumericStart(t, g);
      case EntityDecoderState.NumericDecimal:
        return this.stateNumericDecimal(t, g);
      case EntityDecoderState.NumericHex:
        return this.stateNumericHex(t, g);
      case EntityDecoderState.NamedEntity:
        return this.stateNamedEntity(t, g);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, g) {
    return g >= t.length ? -1 : (t.charCodeAt(g) | TO_LOWER_BIT) === CharCodes.LOWER_X ? (this.state = EntityDecoderState.NumericHex, this.consumed += 1, this.stateNumericHex(t, g + 1)) : (this.state = EntityDecoderState.NumericDecimal, this.stateNumericDecimal(t, g));
  }
  addToNumericResult(t, g, d, k) {
    if (g !== d) {
      const H = d - g;
      this.result = this.result * Math.pow(k, H) + Number.parseInt(t.substr(g, H), k), this.consumed += H;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, g) {
    const d = g;
    for (; g < t.length; ) {
      const k = t.charCodeAt(g);
      if (isNumber$5(k) || isHexadecimalCharacter(k))
        g += 1;
      else
        return this.addToNumericResult(t, d, g, 16), this.emitNumericEntity(k, 3);
    }
    return this.addToNumericResult(t, d, g, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, g) {
    const d = g;
    for (; g < t.length; ) {
      const k = t.charCodeAt(g);
      if (isNumber$5(k))
        g += 1;
      else
        return this.addToNumericResult(t, d, g, 10), this.emitNumericEntity(k, 2);
    }
    return this.addToNumericResult(t, d, g, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, g) {
    var d;
    if (this.consumed <= g)
      return (d = this.errors) === null || d === void 0 || d.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === CharCodes.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === DecodingMode.Strict)
      return 0;
    return this.emitCodePoint(replaceCodePoint(this.result), this.consumed), this.errors && (t !== CharCodes.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, g) {
    const { decodeTree: d } = this;
    let k = d[this.treeIndex], H = (k & BinTrieFlags.VALUE_LENGTH) >> 14;
    for (; g < t.length; g++, this.excess++) {
      const AA = t.charCodeAt(g);
      if (this.treeIndex = determineBranch(d, k, this.treeIndex + Math.max(1, H), AA), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
        (H === 0 || // And there should be no invalid characters.
        isEntityInAttributeInvalidEnd(AA)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (k = d[this.treeIndex], H = (k & BinTrieFlags.VALUE_LENGTH) >> 14, H !== 0) {
        if (AA === CharCodes.SEMI)
          return this.emitNamedEntityData(this.treeIndex, H, this.consumed + this.excess);
        this.decodeMode !== DecodingMode.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: g, decodeTree: d } = this, k = (d[g] & BinTrieFlags.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(g, k, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, g, d) {
    const { decodeTree: k } = this;
    return this.emitCodePoint(g === 1 ? k[t] & ~BinTrieFlags.VALUE_LENGTH : k[t + 1], d), g === 3 && this.emitCodePoint(k[t + 2], d), d;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case EntityDecoderState.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case EntityDecoderState.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case EntityDecoderState.NumericHex:
        return this.emitNumericEntity(0, 3);
      case EntityDecoderState.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case EntityDecoderState.EntityStart:
        return 0;
    }
  }
}
function determineBranch(n, t, g, d) {
  const k = (t & BinTrieFlags.BRANCH_LENGTH) >> 7, H = t & BinTrieFlags.JUMP_TABLE;
  if (k === 0)
    return H !== 0 && d === H ? g : -1;
  if (H) {
    const IA = d - H;
    return IA < 0 || IA >= k ? -1 : n[g + IA] - 1;
  }
  let AA = g, gA = AA + k - 1;
  for (; AA <= gA; ) {
    const IA = AA + gA >>> 1, CA = n[IA];
    if (CA < d)
      AA = IA + 1;
    else if (CA > d)
      gA = IA - 1;
    else
      return n[IA + k];
  }
  return -1;
}
var NS;
(function(n) {
  n.HTML = "http://www.w3.org/1999/xhtml", n.MATHML = "http://www.w3.org/1998/Math/MathML", n.SVG = "http://www.w3.org/2000/svg", n.XLINK = "http://www.w3.org/1999/xlink", n.XML = "http://www.w3.org/XML/1998/namespace", n.XMLNS = "http://www.w3.org/2000/xmlns/";
})(NS || (NS = {}));
var ATTRS;
(function(n) {
  n.TYPE = "type", n.ACTION = "action", n.ENCODING = "encoding", n.PROMPT = "prompt", n.NAME = "name", n.COLOR = "color", n.FACE = "face", n.SIZE = "size";
})(ATTRS || (ATTRS = {}));
var DOCUMENT_MODE;
(function(n) {
  n.NO_QUIRKS = "no-quirks", n.QUIRKS = "quirks", n.LIMITED_QUIRKS = "limited-quirks";
})(DOCUMENT_MODE || (DOCUMENT_MODE = {}));
var TAG_NAMES;
(function(n) {
  n.A = "a", n.ADDRESS = "address", n.ANNOTATION_XML = "annotation-xml", n.APPLET = "applet", n.AREA = "area", n.ARTICLE = "article", n.ASIDE = "aside", n.B = "b", n.BASE = "base", n.BASEFONT = "basefont", n.BGSOUND = "bgsound", n.BIG = "big", n.BLOCKQUOTE = "blockquote", n.BODY = "body", n.BR = "br", n.BUTTON = "button", n.CAPTION = "caption", n.CENTER = "center", n.CODE = "code", n.COL = "col", n.COLGROUP = "colgroup", n.DD = "dd", n.DESC = "desc", n.DETAILS = "details", n.DIALOG = "dialog", n.DIR = "dir", n.DIV = "div", n.DL = "dl", n.DT = "dt", n.EM = "em", n.EMBED = "embed", n.FIELDSET = "fieldset", n.FIGCAPTION = "figcaption", n.FIGURE = "figure", n.FONT = "font", n.FOOTER = "footer", n.FOREIGN_OBJECT = "foreignObject", n.FORM = "form", n.FRAME = "frame", n.FRAMESET = "frameset", n.H1 = "h1", n.H2 = "h2", n.H3 = "h3", n.H4 = "h4", n.H5 = "h5", n.H6 = "h6", n.HEAD = "head", n.HEADER = "header", n.HGROUP = "hgroup", n.HR = "hr", n.HTML = "html", n.I = "i", n.IMG = "img", n.IMAGE = "image", n.INPUT = "input", n.IFRAME = "iframe", n.KEYGEN = "keygen", n.LABEL = "label", n.LI = "li", n.LINK = "link", n.LISTING = "listing", n.MAIN = "main", n.MALIGNMARK = "malignmark", n.MARQUEE = "marquee", n.MATH = "math", n.MENU = "menu", n.META = "meta", n.MGLYPH = "mglyph", n.MI = "mi", n.MO = "mo", n.MN = "mn", n.MS = "ms", n.MTEXT = "mtext", n.NAV = "nav", n.NOBR = "nobr", n.NOFRAMES = "noframes", n.NOEMBED = "noembed", n.NOSCRIPT = "noscript", n.OBJECT = "object", n.OL = "ol", n.OPTGROUP = "optgroup", n.OPTION = "option", n.P = "p", n.PARAM = "param", n.PLAINTEXT = "plaintext", n.PRE = "pre", n.RB = "rb", n.RP = "rp", n.RT = "rt", n.RTC = "rtc", n.RUBY = "ruby", n.S = "s", n.SCRIPT = "script", n.SEARCH = "search", n.SECTION = "section", n.SELECT = "select", n.SOURCE = "source", n.SMALL = "small", n.SPAN = "span", n.STRIKE = "strike", n.STRONG = "strong", n.STYLE = "style", n.SUB = "sub", n.SUMMARY = "summary", n.SUP = "sup", n.TABLE = "table", n.TBODY = "tbody", n.TEMPLATE = "template", n.TEXTAREA = "textarea", n.TFOOT = "tfoot", n.TD = "td", n.TH = "th", n.THEAD = "thead", n.TITLE = "title", n.TR = "tr", n.TRACK = "track", n.TT = "tt", n.U = "u", n.UL = "ul", n.SVG = "svg", n.VAR = "var", n.WBR = "wbr", n.XMP = "xmp";
})(TAG_NAMES || (TAG_NAMES = {}));
var TAG_ID;
(function(n) {
  n[n.UNKNOWN = 0] = "UNKNOWN", n[n.A = 1] = "A", n[n.ADDRESS = 2] = "ADDRESS", n[n.ANNOTATION_XML = 3] = "ANNOTATION_XML", n[n.APPLET = 4] = "APPLET", n[n.AREA = 5] = "AREA", n[n.ARTICLE = 6] = "ARTICLE", n[n.ASIDE = 7] = "ASIDE", n[n.B = 8] = "B", n[n.BASE = 9] = "BASE", n[n.BASEFONT = 10] = "BASEFONT", n[n.BGSOUND = 11] = "BGSOUND", n[n.BIG = 12] = "BIG", n[n.BLOCKQUOTE = 13] = "BLOCKQUOTE", n[n.BODY = 14] = "BODY", n[n.BR = 15] = "BR", n[n.BUTTON = 16] = "BUTTON", n[n.CAPTION = 17] = "CAPTION", n[n.CENTER = 18] = "CENTER", n[n.CODE = 19] = "CODE", n[n.COL = 20] = "COL", n[n.COLGROUP = 21] = "COLGROUP", n[n.DD = 22] = "DD", n[n.DESC = 23] = "DESC", n[n.DETAILS = 24] = "DETAILS", n[n.DIALOG = 25] = "DIALOG", n[n.DIR = 26] = "DIR", n[n.DIV = 27] = "DIV", n[n.DL = 28] = "DL", n[n.DT = 29] = "DT", n[n.EM = 30] = "EM", n[n.EMBED = 31] = "EMBED", n[n.FIELDSET = 32] = "FIELDSET", n[n.FIGCAPTION = 33] = "FIGCAPTION", n[n.FIGURE = 34] = "FIGURE", n[n.FONT = 35] = "FONT", n[n.FOOTER = 36] = "FOOTER", n[n.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", n[n.FORM = 38] = "FORM", n[n.FRAME = 39] = "FRAME", n[n.FRAMESET = 40] = "FRAMESET", n[n.H1 = 41] = "H1", n[n.H2 = 42] = "H2", n[n.H3 = 43] = "H3", n[n.H4 = 44] = "H4", n[n.H5 = 45] = "H5", n[n.H6 = 46] = "H6", n[n.HEAD = 47] = "HEAD", n[n.HEADER = 48] = "HEADER", n[n.HGROUP = 49] = "HGROUP", n[n.HR = 50] = "HR", n[n.HTML = 51] = "HTML", n[n.I = 52] = "I", n[n.IMG = 53] = "IMG", n[n.IMAGE = 54] = "IMAGE", n[n.INPUT = 55] = "INPUT", n[n.IFRAME = 56] = "IFRAME", n[n.KEYGEN = 57] = "KEYGEN", n[n.LABEL = 58] = "LABEL", n[n.LI = 59] = "LI", n[n.LINK = 60] = "LINK", n[n.LISTING = 61] = "LISTING", n[n.MAIN = 62] = "MAIN", n[n.MALIGNMARK = 63] = "MALIGNMARK", n[n.MARQUEE = 64] = "MARQUEE", n[n.MATH = 65] = "MATH", n[n.MENU = 66] = "MENU", n[n.META = 67] = "META", n[n.MGLYPH = 68] = "MGLYPH", n[n.MI = 69] = "MI", n[n.MO = 70] = "MO", n[n.MN = 71] = "MN", n[n.MS = 72] = "MS", n[n.MTEXT = 73] = "MTEXT", n[n.NAV = 74] = "NAV", n[n.NOBR = 75] = "NOBR", n[n.NOFRAMES = 76] = "NOFRAMES", n[n.NOEMBED = 77] = "NOEMBED", n[n.NOSCRIPT = 78] = "NOSCRIPT", n[n.OBJECT = 79] = "OBJECT", n[n.OL = 80] = "OL", n[n.OPTGROUP = 81] = "OPTGROUP", n[n.OPTION = 82] = "OPTION", n[n.P = 83] = "P", n[n.PARAM = 84] = "PARAM", n[n.PLAINTEXT = 85] = "PLAINTEXT", n[n.PRE = 86] = "PRE", n[n.RB = 87] = "RB", n[n.RP = 88] = "RP", n[n.RT = 89] = "RT", n[n.RTC = 90] = "RTC", n[n.RUBY = 91] = "RUBY", n[n.S = 92] = "S", n[n.SCRIPT = 93] = "SCRIPT", n[n.SEARCH = 94] = "SEARCH", n[n.SECTION = 95] = "SECTION", n[n.SELECT = 96] = "SELECT", n[n.SOURCE = 97] = "SOURCE", n[n.SMALL = 98] = "SMALL", n[n.SPAN = 99] = "SPAN", n[n.STRIKE = 100] = "STRIKE", n[n.STRONG = 101] = "STRONG", n[n.STYLE = 102] = "STYLE", n[n.SUB = 103] = "SUB", n[n.SUMMARY = 104] = "SUMMARY", n[n.SUP = 105] = "SUP", n[n.TABLE = 106] = "TABLE", n[n.TBODY = 107] = "TBODY", n[n.TEMPLATE = 108] = "TEMPLATE", n[n.TEXTAREA = 109] = "TEXTAREA", n[n.TFOOT = 110] = "TFOOT", n[n.TD = 111] = "TD", n[n.TH = 112] = "TH", n[n.THEAD = 113] = "THEAD", n[n.TITLE = 114] = "TITLE", n[n.TR = 115] = "TR", n[n.TRACK = 116] = "TRACK", n[n.TT = 117] = "TT", n[n.U = 118] = "U", n[n.UL = 119] = "UL", n[n.SVG = 120] = "SVG", n[n.VAR = 121] = "VAR", n[n.WBR = 122] = "WBR", n[n.XMP = 123] = "XMP";
})(TAG_ID || (TAG_ID = {}));
const TAG_NAME_TO_ID = /* @__PURE__ */ new Map([
  [TAG_NAMES.A, TAG_ID.A],
  [TAG_NAMES.ADDRESS, TAG_ID.ADDRESS],
  [TAG_NAMES.ANNOTATION_XML, TAG_ID.ANNOTATION_XML],
  [TAG_NAMES.APPLET, TAG_ID.APPLET],
  [TAG_NAMES.AREA, TAG_ID.AREA],
  [TAG_NAMES.ARTICLE, TAG_ID.ARTICLE],
  [TAG_NAMES.ASIDE, TAG_ID.ASIDE],
  [TAG_NAMES.B, TAG_ID.B],
  [TAG_NAMES.BASE, TAG_ID.BASE],
  [TAG_NAMES.BASEFONT, TAG_ID.BASEFONT],
  [TAG_NAMES.BGSOUND, TAG_ID.BGSOUND],
  [TAG_NAMES.BIG, TAG_ID.BIG],
  [TAG_NAMES.BLOCKQUOTE, TAG_ID.BLOCKQUOTE],
  [TAG_NAMES.BODY, TAG_ID.BODY],
  [TAG_NAMES.BR, TAG_ID.BR],
  [TAG_NAMES.BUTTON, TAG_ID.BUTTON],
  [TAG_NAMES.CAPTION, TAG_ID.CAPTION],
  [TAG_NAMES.CENTER, TAG_ID.CENTER],
  [TAG_NAMES.CODE, TAG_ID.CODE],
  [TAG_NAMES.COL, TAG_ID.COL],
  [TAG_NAMES.COLGROUP, TAG_ID.COLGROUP],
  [TAG_NAMES.DD, TAG_ID.DD],
  [TAG_NAMES.DESC, TAG_ID.DESC],
  [TAG_NAMES.DETAILS, TAG_ID.DETAILS],
  [TAG_NAMES.DIALOG, TAG_ID.DIALOG],
  [TAG_NAMES.DIR, TAG_ID.DIR],
  [TAG_NAMES.DIV, TAG_ID.DIV],
  [TAG_NAMES.DL, TAG_ID.DL],
  [TAG_NAMES.DT, TAG_ID.DT],
  [TAG_NAMES.EM, TAG_ID.EM],
  [TAG_NAMES.EMBED, TAG_ID.EMBED],
  [TAG_NAMES.FIELDSET, TAG_ID.FIELDSET],
  [TAG_NAMES.FIGCAPTION, TAG_ID.FIGCAPTION],
  [TAG_NAMES.FIGURE, TAG_ID.FIGURE],
  [TAG_NAMES.FONT, TAG_ID.FONT],
  [TAG_NAMES.FOOTER, TAG_ID.FOOTER],
  [TAG_NAMES.FOREIGN_OBJECT, TAG_ID.FOREIGN_OBJECT],
  [TAG_NAMES.FORM, TAG_ID.FORM],
  [TAG_NAMES.FRAME, TAG_ID.FRAME],
  [TAG_NAMES.FRAMESET, TAG_ID.FRAMESET],
  [TAG_NAMES.H1, TAG_ID.H1],
  [TAG_NAMES.H2, TAG_ID.H2],
  [TAG_NAMES.H3, TAG_ID.H3],
  [TAG_NAMES.H4, TAG_ID.H4],
  [TAG_NAMES.H5, TAG_ID.H5],
  [TAG_NAMES.H6, TAG_ID.H6],
  [TAG_NAMES.HEAD, TAG_ID.HEAD],
  [TAG_NAMES.HEADER, TAG_ID.HEADER],
  [TAG_NAMES.HGROUP, TAG_ID.HGROUP],
  [TAG_NAMES.HR, TAG_ID.HR],
  [TAG_NAMES.HTML, TAG_ID.HTML],
  [TAG_NAMES.I, TAG_ID.I],
  [TAG_NAMES.IMG, TAG_ID.IMG],
  [TAG_NAMES.IMAGE, TAG_ID.IMAGE],
  [TAG_NAMES.INPUT, TAG_ID.INPUT],
  [TAG_NAMES.IFRAME, TAG_ID.IFRAME],
  [TAG_NAMES.KEYGEN, TAG_ID.KEYGEN],
  [TAG_NAMES.LABEL, TAG_ID.LABEL],
  [TAG_NAMES.LI, TAG_ID.LI],
  [TAG_NAMES.LINK, TAG_ID.LINK],
  [TAG_NAMES.LISTING, TAG_ID.LISTING],
  [TAG_NAMES.MAIN, TAG_ID.MAIN],
  [TAG_NAMES.MALIGNMARK, TAG_ID.MALIGNMARK],
  [TAG_NAMES.MARQUEE, TAG_ID.MARQUEE],
  [TAG_NAMES.MATH, TAG_ID.MATH],
  [TAG_NAMES.MENU, TAG_ID.MENU],
  [TAG_NAMES.META, TAG_ID.META],
  [TAG_NAMES.MGLYPH, TAG_ID.MGLYPH],
  [TAG_NAMES.MI, TAG_ID.MI],
  [TAG_NAMES.MO, TAG_ID.MO],
  [TAG_NAMES.MN, TAG_ID.MN],
  [TAG_NAMES.MS, TAG_ID.MS],
  [TAG_NAMES.MTEXT, TAG_ID.MTEXT],
  [TAG_NAMES.NAV, TAG_ID.NAV],
  [TAG_NAMES.NOBR, TAG_ID.NOBR],
  [TAG_NAMES.NOFRAMES, TAG_ID.NOFRAMES],
  [TAG_NAMES.NOEMBED, TAG_ID.NOEMBED],
  [TAG_NAMES.NOSCRIPT, TAG_ID.NOSCRIPT],
  [TAG_NAMES.OBJECT, TAG_ID.OBJECT],
  [TAG_NAMES.OL, TAG_ID.OL],
  [TAG_NAMES.OPTGROUP, TAG_ID.OPTGROUP],
  [TAG_NAMES.OPTION, TAG_ID.OPTION],
  [TAG_NAMES.P, TAG_ID.P],
  [TAG_NAMES.PARAM, TAG_ID.PARAM],
  [TAG_NAMES.PLAINTEXT, TAG_ID.PLAINTEXT],
  [TAG_NAMES.PRE, TAG_ID.PRE],
  [TAG_NAMES.RB, TAG_ID.RB],
  [TAG_NAMES.RP, TAG_ID.RP],
  [TAG_NAMES.RT, TAG_ID.RT],
  [TAG_NAMES.RTC, TAG_ID.RTC],
  [TAG_NAMES.RUBY, TAG_ID.RUBY],
  [TAG_NAMES.S, TAG_ID.S],
  [TAG_NAMES.SCRIPT, TAG_ID.SCRIPT],
  [TAG_NAMES.SEARCH, TAG_ID.SEARCH],
  [TAG_NAMES.SECTION, TAG_ID.SECTION],
  [TAG_NAMES.SELECT, TAG_ID.SELECT],
  [TAG_NAMES.SOURCE, TAG_ID.SOURCE],
  [TAG_NAMES.SMALL, TAG_ID.SMALL],
  [TAG_NAMES.SPAN, TAG_ID.SPAN],
  [TAG_NAMES.STRIKE, TAG_ID.STRIKE],
  [TAG_NAMES.STRONG, TAG_ID.STRONG],
  [TAG_NAMES.STYLE, TAG_ID.STYLE],
  [TAG_NAMES.SUB, TAG_ID.SUB],
  [TAG_NAMES.SUMMARY, TAG_ID.SUMMARY],
  [TAG_NAMES.SUP, TAG_ID.SUP],
  [TAG_NAMES.TABLE, TAG_ID.TABLE],
  [TAG_NAMES.TBODY, TAG_ID.TBODY],
  [TAG_NAMES.TEMPLATE, TAG_ID.TEMPLATE],
  [TAG_NAMES.TEXTAREA, TAG_ID.TEXTAREA],
  [TAG_NAMES.TFOOT, TAG_ID.TFOOT],
  [TAG_NAMES.TD, TAG_ID.TD],
  [TAG_NAMES.TH, TAG_ID.TH],
  [TAG_NAMES.THEAD, TAG_ID.THEAD],
  [TAG_NAMES.TITLE, TAG_ID.TITLE],
  [TAG_NAMES.TR, TAG_ID.TR],
  [TAG_NAMES.TRACK, TAG_ID.TRACK],
  [TAG_NAMES.TT, TAG_ID.TT],
  [TAG_NAMES.U, TAG_ID.U],
  [TAG_NAMES.UL, TAG_ID.UL],
  [TAG_NAMES.SVG, TAG_ID.SVG],
  [TAG_NAMES.VAR, TAG_ID.VAR],
  [TAG_NAMES.WBR, TAG_ID.WBR],
  [TAG_NAMES.XMP, TAG_ID.XMP]
]);
function getTagID(n) {
  var t;
  return (t = TAG_NAME_TO_ID.get(n)) !== null && t !== void 0 ? t : TAG_ID.UNKNOWN;
}
const $$3 = TAG_ID, SPECIAL_ELEMENTS = {
  [NS.HTML]: /* @__PURE__ */ new Set([
    $$3.ADDRESS,
    $$3.APPLET,
    $$3.AREA,
    $$3.ARTICLE,
    $$3.ASIDE,
    $$3.BASE,
    $$3.BASEFONT,
    $$3.BGSOUND,
    $$3.BLOCKQUOTE,
    $$3.BODY,
    $$3.BR,
    $$3.BUTTON,
    $$3.CAPTION,
    $$3.CENTER,
    $$3.COL,
    $$3.COLGROUP,
    $$3.DD,
    $$3.DETAILS,
    $$3.DIR,
    $$3.DIV,
    $$3.DL,
    $$3.DT,
    $$3.EMBED,
    $$3.FIELDSET,
    $$3.FIGCAPTION,
    $$3.FIGURE,
    $$3.FOOTER,
    $$3.FORM,
    $$3.FRAME,
    $$3.FRAMESET,
    $$3.H1,
    $$3.H2,
    $$3.H3,
    $$3.H4,
    $$3.H5,
    $$3.H6,
    $$3.HEAD,
    $$3.HEADER,
    $$3.HGROUP,
    $$3.HR,
    $$3.HTML,
    $$3.IFRAME,
    $$3.IMG,
    $$3.INPUT,
    $$3.LI,
    $$3.LINK,
    $$3.LISTING,
    $$3.MAIN,
    $$3.MARQUEE,
    $$3.MENU,
    $$3.META,
    $$3.NAV,
    $$3.NOEMBED,
    $$3.NOFRAMES,
    $$3.NOSCRIPT,
    $$3.OBJECT,
    $$3.OL,
    $$3.P,
    $$3.PARAM,
    $$3.PLAINTEXT,
    $$3.PRE,
    $$3.SCRIPT,
    $$3.SECTION,
    $$3.SELECT,
    $$3.SOURCE,
    $$3.STYLE,
    $$3.SUMMARY,
    $$3.TABLE,
    $$3.TBODY,
    $$3.TD,
    $$3.TEMPLATE,
    $$3.TEXTAREA,
    $$3.TFOOT,
    $$3.TH,
    $$3.THEAD,
    $$3.TITLE,
    $$3.TR,
    $$3.TRACK,
    $$3.UL,
    $$3.WBR,
    $$3.XMP
  ]),
  [NS.MATHML]: /* @__PURE__ */ new Set([$$3.MI, $$3.MO, $$3.MN, $$3.MS, $$3.MTEXT, $$3.ANNOTATION_XML]),
  [NS.SVG]: /* @__PURE__ */ new Set([$$3.TITLE, $$3.FOREIGN_OBJECT, $$3.DESC]),
  [NS.XLINK]: /* @__PURE__ */ new Set(),
  [NS.XML]: /* @__PURE__ */ new Set(),
  [NS.XMLNS]: /* @__PURE__ */ new Set()
}, NUMBERED_HEADERS = /* @__PURE__ */ new Set([$$3.H1, $$3.H2, $$3.H3, $$3.H4, $$3.H5, $$3.H6]);
TAG_NAMES.STYLE, TAG_NAMES.SCRIPT, TAG_NAMES.XMP, TAG_NAMES.IFRAME, TAG_NAMES.NOEMBED, TAG_NAMES.NOFRAMES, TAG_NAMES.PLAINTEXT;
var State;
(function(n) {
  n[n.DATA = 0] = "DATA", n[n.RCDATA = 1] = "RCDATA", n[n.RAWTEXT = 2] = "RAWTEXT", n[n.SCRIPT_DATA = 3] = "SCRIPT_DATA", n[n.PLAINTEXT = 4] = "PLAINTEXT", n[n.TAG_OPEN = 5] = "TAG_OPEN", n[n.END_TAG_OPEN = 6] = "END_TAG_OPEN", n[n.TAG_NAME = 7] = "TAG_NAME", n[n.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", n[n.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", n[n.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", n[n.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", n[n.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", n[n.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", n[n.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", n[n.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", n[n.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", n[n.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", n[n.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", n[n.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", n[n.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", n[n.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", n[n.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", n[n.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", n[n.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", n[n.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", n[n.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", n[n.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", n[n.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", n[n.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", n[n.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", n[n.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", n[n.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", n[n.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", n[n.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", n[n.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", n[n.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", n[n.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", n[n.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", n[n.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", n[n.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", n[n.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", n[n.COMMENT_START = 42] = "COMMENT_START", n[n.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", n[n.COMMENT = 44] = "COMMENT", n[n.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", n[n.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", n[n.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", n[n.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", n[n.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", n[n.COMMENT_END = 50] = "COMMENT_END", n[n.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", n[n.DOCTYPE = 52] = "DOCTYPE", n[n.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", n[n.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", n[n.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", n[n.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", n[n.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", n[n.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", n[n.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", n[n.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", n[n.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", n[n.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", n[n.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", n[n.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", n[n.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", n[n.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", n[n.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", n[n.CDATA_SECTION = 68] = "CDATA_SECTION", n[n.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", n[n.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", n[n.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", n[n.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(State || (State = {}));
const TokenizerMode = {
  DATA: State.DATA,
  RCDATA: State.RCDATA,
  RAWTEXT: State.RAWTEXT,
  SCRIPT_DATA: State.SCRIPT_DATA,
  PLAINTEXT: State.PLAINTEXT,
  CDATA_SECTION: State.CDATA_SECTION
};
function isAsciiDigit(n) {
  return n >= CODE_POINTS.DIGIT_0 && n <= CODE_POINTS.DIGIT_9;
}
function isAsciiUpper(n) {
  return n >= CODE_POINTS.LATIN_CAPITAL_A && n <= CODE_POINTS.LATIN_CAPITAL_Z;
}
function isAsciiLower(n) {
  return n >= CODE_POINTS.LATIN_SMALL_A && n <= CODE_POINTS.LATIN_SMALL_Z;
}
function isAsciiLetter(n) {
  return isAsciiLower(n) || isAsciiUpper(n);
}
function isAsciiAlphaNumeric(n) {
  return isAsciiLetter(n) || isAsciiDigit(n);
}
function toAsciiLower(n) {
  return n + 32;
}
function isWhitespace(n) {
  return n === CODE_POINTS.SPACE || n === CODE_POINTS.LINE_FEED || n === CODE_POINTS.TABULATION || n === CODE_POINTS.FORM_FEED;
}
function isScriptDataDoubleEscapeSequenceEnd(n) {
  return isWhitespace(n) || n === CODE_POINTS.SOLIDUS || n === CODE_POINTS.GREATER_THAN_SIGN;
}
function getErrorForNumericCharacterReference(n) {
  return n === CODE_POINTS.NULL ? ERR.nullCharacterReference : n > 1114111 ? ERR.characterReferenceOutsideUnicodeRange : isSurrogate(n) ? ERR.surrogateCharacterReference : isUndefinedCodePoint(n) ? ERR.noncharacterCharacterReference : isControlCodePoint(n) || n === CODE_POINTS.CARRIAGE_RETURN ? ERR.controlCharacterReference : null;
}
class Tokenizer {
  constructor(t, g) {
    this.options = t, this.handler = g, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = State.DATA, this.returnState = State.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new Preprocessor(g), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new EntityDecoder(htmlDecodeTree, (d, k) => {
      this.preprocessor.pos = this.entityStartPos + k - 1, this._flushCodePointConsumedAsCharacterReference(d);
    }, g.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(ERR.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (d) => {
        this._err(ERR.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + d);
      },
      validateNumericCharacterReference: (d) => {
        const k = getErrorForNumericCharacterReference(d);
        k && this._err(k, 1);
      }
    } : void 0);
  }
  //Errors
  _err(t, g = 0) {
    var d, k;
    (k = (d = this.handler).onParseError) === null || k === void 0 || k.call(d, this.preprocessor.getError(t, g));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(t) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - t,
      startOffset: this.preprocessor.offset - t,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const t = this._consume();
        this._ensureHibernation() || this._callState(t);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(t) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || t?.());
  }
  write(t, g, d) {
    this.active = !0, this.preprocessor.write(t, g), this._runParsingLoop(), this.paused || d?.();
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(t) {
    this.consumedAfterSnapshot += t;
    for (let g = 0; g < t; g++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(t, g) {
    return this.preprocessor.startsWith(t, g) ? (this._advanceBy(t.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: TokenType.START_TAG,
      tagName: "",
      tagID: TAG_ID.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: TokenType.END_TAG,
      tagName: "",
      tagID: TAG_ID.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(t) {
    this.currentToken = {
      type: TokenType.COMMENT,
      data: "",
      location: this.getCurrentLocation(t)
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: TokenType.DOCTYPE,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(t, g) {
    this.currentCharacterToken = {
      type: t,
      chars: g,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var t, g;
    const d = this.currentToken;
    if (getTokenAttr(d, this.currentAttr.name) === null) {
      if (d.attrs.push(this.currentAttr), d.location && this.currentLocation) {
        const k = (t = (g = d.location).attrs) !== null && t !== void 0 ? t : g.attrs = /* @__PURE__ */ Object.create(null);
        k[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(ERR.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(t) {
    this._emitCurrentCharacterToken(t.location), this.currentToken = null, t.location && (t.location.endLine = this.preprocessor.line, t.location.endCol = this.preprocessor.col + 1, t.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const t = this.currentToken;
    this.prepareToken(t), t.tagID = getTagID(t.tagName), t.type === TokenType.START_TAG ? (this.lastStartTagName = t.tagName, this.handler.onStartTag(t)) : (t.attrs.length > 0 && this._err(ERR.endTagWithAttributes), t.selfClosing && this._err(ERR.endTagWithTrailingSolidus), this.handler.onEndTag(t)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(t) {
    this.prepareToken(t), this.handler.onComment(t), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(t) {
    this.prepareToken(t), this.handler.onDoctype(t), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(t) {
    if (this.currentCharacterToken) {
      switch (t && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = t.startLine, this.currentCharacterToken.location.endCol = t.startCol, this.currentCharacterToken.location.endOffset = t.startOffset), this.currentCharacterToken.type) {
        case TokenType.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case TokenType.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case TokenType.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const t = this.getCurrentLocation(0);
    t && (t.endLine = t.startLine, t.endCol = t.startCol, t.endOffset = t.startOffset), this._emitCurrentCharacterToken(t), this.handler.onEof({ type: TokenType.EOF, location: t }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, g) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === t) {
        this.currentCharacterToken.chars += g;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(t, g);
  }
  _emitCodePoint(t) {
    const g = isWhitespace(t) ? TokenType.WHITESPACE_CHARACTER : t === CODE_POINTS.NULL ? TokenType.NULL_CHARACTER : TokenType.CHARACTER;
    this._appendCharToCurrentCharacterToken(g, String.fromCodePoint(t));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(TokenType.CHARACTER, t);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = State.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? DecodingMode.Attribute : DecodingMode.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === State.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === State.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === State.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(t) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(t) : this._emitCodePoint(t);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(t) {
    switch (this.state) {
      case State.DATA: {
        this._stateData(t);
        break;
      }
      case State.RCDATA: {
        this._stateRcdata(t);
        break;
      }
      case State.RAWTEXT: {
        this._stateRawtext(t);
        break;
      }
      case State.SCRIPT_DATA: {
        this._stateScriptData(t);
        break;
      }
      case State.PLAINTEXT: {
        this._statePlaintext(t);
        break;
      }
      case State.TAG_OPEN: {
        this._stateTagOpen(t);
        break;
      }
      case State.END_TAG_OPEN: {
        this._stateEndTagOpen(t);
        break;
      }
      case State.TAG_NAME: {
        this._stateTagName(t);
        break;
      }
      case State.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(t);
        break;
      }
      case State.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(t);
        break;
      }
      case State.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(t);
        break;
      }
      case State.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(t);
        break;
      }
      case State.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(t);
        break;
      }
      case State.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(t);
        break;
      }
      case State.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(t);
        break;
      }
      case State.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(t);
        break;
      }
      case State.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(t);
        break;
      }
      case State.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(t);
        break;
      }
      case State.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(t);
        break;
      }
      case State.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(t);
        break;
      }
      case State.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(t);
        break;
      }
      case State.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(t);
        break;
      }
      case State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(t);
        break;
      }
      case State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(t);
        break;
      }
      case State.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(t);
        break;
      }
      case State.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(t);
        break;
      }
      case State.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(t);
        break;
      }
      case State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(t);
        break;
      }
      case State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(t);
        break;
      }
      case State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(t);
        break;
      }
      case State.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(t);
        break;
      }
      case State.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(t);
        break;
      }
      case State.ATTRIBUTE_NAME: {
        this._stateAttributeName(t);
        break;
      }
      case State.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(t);
        break;
      }
      case State.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(t);
        break;
      }
      case State.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(t);
        break;
      }
      case State.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(t);
        break;
      }
      case State.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(t);
        break;
      }
      case State.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(t);
        break;
      }
      case State.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(t);
        break;
      }
      case State.BOGUS_COMMENT: {
        this._stateBogusComment(t);
        break;
      }
      case State.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(t);
        break;
      }
      case State.COMMENT_START: {
        this._stateCommentStart(t);
        break;
      }
      case State.COMMENT_START_DASH: {
        this._stateCommentStartDash(t);
        break;
      }
      case State.COMMENT: {
        this._stateComment(t);
        break;
      }
      case State.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(t);
        break;
      }
      case State.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(t);
        break;
      }
      case State.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(t);
        break;
      }
      case State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(t);
        break;
      }
      case State.COMMENT_END_DASH: {
        this._stateCommentEndDash(t);
        break;
      }
      case State.COMMENT_END: {
        this._stateCommentEnd(t);
        break;
      }
      case State.COMMENT_END_BANG: {
        this._stateCommentEndBang(t);
        break;
      }
      case State.DOCTYPE: {
        this._stateDoctype(t);
        break;
      }
      case State.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(t);
        break;
      }
      case State.DOCTYPE_NAME: {
        this._stateDoctypeName(t);
        break;
      }
      case State.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(t);
        break;
      }
      case State.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(t);
        break;
      }
      case State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(t);
        break;
      }
      case State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(t);
        break;
      }
      case State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(t);
        break;
      }
      case State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(t);
        break;
      }
      case State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(t);
        break;
      }
      case State.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(t);
        break;
      }
      case State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(t);
        break;
      }
      case State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(t);
        break;
      }
      case State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(t);
        break;
      }
      case State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(t);
        break;
      }
      case State.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(t);
        break;
      }
      case State.CDATA_SECTION: {
        this._stateCdataSection(t);
        break;
      }
      case State.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(t);
        break;
      }
      case State.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(t);
        break;
      }
      case State.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case State.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(t);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(t) {
    switch (t) {
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State.TAG_OPEN;
        break;
      }
      case CODE_POINTS.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitCodePoint(t);
        break;
      }
      case CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(t) {
    switch (t) {
      case CODE_POINTS.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(t) {
    switch (t) {
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(t) {
    switch (t) {
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(t) {
    switch (t) {
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(t) {
    if (isAsciiLetter(t))
      this._createStartTagToken(), this.state = State.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case CODE_POINTS.EXCLAMATION_MARK: {
          this.state = State.MARKUP_DECLARATION_OPEN;
          break;
        }
        case CODE_POINTS.SOLIDUS: {
          this.state = State.END_TAG_OPEN;
          break;
        }
        case CODE_POINTS.QUESTION_MARK: {
          this._err(ERR.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = State.BOGUS_COMMENT, this._stateBogusComment(t);
          break;
        }
        case CODE_POINTS.EOF: {
          this._err(ERR.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(ERR.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = State.DATA, this._stateData(t);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(t) {
    if (isAsciiLetter(t))
      this._createEndTagToken(), this.state = State.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(ERR.missingEndTagName), this.state = State.DATA;
          break;
        }
        case CODE_POINTS.EOF: {
          this._err(ERR.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(ERR.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = State.BOGUS_COMMENT, this._stateBogusComment(t);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this.state = State.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case CODE_POINTS.SOLIDUS: {
        this.state = State.SELF_CLOSING_START_TAG;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State.DATA, this.emitCurrentTagToken();
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), g.tagName += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        g.tagName += String.fromCodePoint(isAsciiUpper(t) ? toAsciiLower(t) : t);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(t) {
    t === CODE_POINTS.SOLIDUS ? this.state = State.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = State.RCDATA, this._stateRcdata(t));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(t) {
    isAsciiLetter(t) ? (this.state = State.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(t)) : (this._emitChars("</"), this.state = State.RCDATA, this._stateRcdata(t));
  }
  handleSpecialEndTag(t) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const g = this.currentToken;
    switch (g.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = State.BEFORE_ATTRIBUTE_NAME, !1;
      case CODE_POINTS.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = State.SELF_CLOSING_START_TAG, !1;
      case CODE_POINTS.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = State.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = State.RCDATA, this._stateRcdata(t));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(t) {
    t === CODE_POINTS.SOLIDUS ? this.state = State.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = State.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(t) {
    isAsciiLetter(t) ? (this.state = State.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(t)) : (this._emitChars("</"), this.state = State.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = State.RAWTEXT, this._stateRawtext(t));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(t) {
    switch (t) {
      case CODE_POINTS.SOLIDUS: {
        this.state = State.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case CODE_POINTS.EXCLAMATION_MARK: {
        this.state = State.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = State.SCRIPT_DATA, this._stateScriptData(t);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(t) {
    isAsciiLetter(t) ? (this.state = State.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(t)) : (this._emitChars("</"), this.state = State.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = State.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(t) {
    t === CODE_POINTS.HYPHEN_MINUS ? (this.state = State.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = State.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(t) {
    t === CODE_POINTS.HYPHEN_MINUS ? (this.state = State.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = State.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(t) {
    switch (t) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(t) {
    switch (t) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.state = State.SCRIPT_DATA_ESCAPED, this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = State.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(t) {
    switch (t) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.state = State.SCRIPT_DATA_ESCAPED, this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = State.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(t) {
    t === CODE_POINTS.SOLIDUS ? this.state = State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : isAsciiLetter(t) ? (this._emitChars("<"), this.state = State.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(t)) : (this._emitChars("<"), this.state = State.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(t) {
    isAsciiLetter(t) ? (this.state = State.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(t)) : (this._emitChars("</"), this.state = State.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = State.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(t) {
    if (this.preprocessor.startsWith(SEQUENCES.SCRIPT, !1) && isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek(SEQUENCES.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let g = 0; g < SEQUENCES.SCRIPT.length; g++)
        this._emitCodePoint(this._consume());
      this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = State.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(t) {
    switch (t) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(t) {
    switch (t) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(t) {
    switch (t) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(REPLACEMENT_CHARACTER);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(t) {
    t === CODE_POINTS.SOLIDUS ? (this.state = State.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(t) {
    if (this.preprocessor.startsWith(SEQUENCES.SCRIPT, !1) && isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek(SEQUENCES.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let g = 0; g < SEQUENCES.SCRIPT.length; g++)
        this._emitCodePoint(this._consume());
      this.state = State.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(t) {
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.SOLIDUS:
      case CODE_POINTS.GREATER_THAN_SIGN:
      case CODE_POINTS.EOF: {
        this.state = State.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case CODE_POINTS.EQUALS_SIGN: {
        this._err(ERR.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = State.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = State.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(t) {
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
      case CODE_POINTS.SOLIDUS:
      case CODE_POINTS.GREATER_THAN_SIGN:
      case CODE_POINTS.EOF: {
        this._leaveAttrName(), this.state = State.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case CODE_POINTS.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = State.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case CODE_POINTS.QUOTATION_MARK:
      case CODE_POINTS.APOSTROPHE:
      case CODE_POINTS.LESS_THAN_SIGN: {
        this._err(ERR.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(t);
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.currentAttr.name += REPLACEMENT_CHARACTER;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(isAsciiUpper(t) ? toAsciiLower(t) : t);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(t) {
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.SOLIDUS: {
        this.state = State.SELF_CLOSING_START_TAG;
        break;
      }
      case CODE_POINTS.EQUALS_SIGN: {
        this.state = State.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State.DATA, this.emitCurrentTagToken();
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = State.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(t) {
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.QUOTATION_MARK: {
        this.state = State.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        this.state = State.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.missingAttributeValue), this.state = State.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = State.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(t);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(t) {
    switch (t) {
      case CODE_POINTS.QUOTATION_MARK: {
        this.state = State.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case CODE_POINTS.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.currentAttr.value += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(t) {
    switch (t) {
      case CODE_POINTS.APOSTROPHE: {
        this.state = State.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case CODE_POINTS.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.currentAttr.value += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(t) {
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this._leaveAttrValue(), this.state = State.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case CODE_POINTS.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = State.DATA, this.emitCurrentTagToken();
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), this.currentAttr.value += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.QUOTATION_MARK:
      case CODE_POINTS.APOSTROPHE:
      case CODE_POINTS.LESS_THAN_SIGN:
      case CODE_POINTS.EQUALS_SIGN:
      case CODE_POINTS.GRAVE_ACCENT: {
        this._err(ERR.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(t);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(t) {
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this._leaveAttrValue(), this.state = State.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case CODE_POINTS.SOLIDUS: {
        this._leaveAttrValue(), this.state = State.SELF_CLOSING_START_TAG;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = State.DATA, this.emitCurrentTagToken();
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingWhitespaceBetweenAttributes), this.state = State.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(t) {
    switch (t) {
      case CODE_POINTS.GREATER_THAN_SIGN: {
        const g = this.currentToken;
        g.selfClosing = !0, this.state = State.DATA, this.emitCurrentTagToken();
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.unexpectedSolidusInTag), this.state = State.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State.DATA, this.emitCurrentComment(g);
        break;
      }
      case CODE_POINTS.EOF: {
        this.emitCurrentComment(g), this._emitEOFToken();
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), g.data += REPLACEMENT_CHARACTER;
        break;
      }
      default:
        g.data += String.fromCodePoint(t);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(t) {
    this._consumeSequenceIfMatch(SEQUENCES.DASH_DASH, !0) ? (this._createCommentToken(SEQUENCES.DASH_DASH.length + 1), this.state = State.COMMENT_START) : this._consumeSequenceIfMatch(SEQUENCES.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(SEQUENCES.DOCTYPE.length + 1), this.state = State.DOCTYPE) : this._consumeSequenceIfMatch(SEQUENCES.CDATA_START, !0) ? this.inForeignNode ? this.state = State.CDATA_SECTION : (this._err(ERR.cdataInHtmlContent), this._createCommentToken(SEQUENCES.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = State.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(ERR.incorrectlyOpenedComment), this._createCommentToken(2), this.state = State.BOGUS_COMMENT, this._stateBogusComment(t));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(t) {
    switch (t) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State.COMMENT_START_DASH;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.abruptClosingOfEmptyComment), this.state = State.DATA;
        const g = this.currentToken;
        this.emitCurrentComment(g);
        break;
      }
      default:
        this.state = State.COMMENT, this._stateComment(t);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State.COMMENT_END;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.abruptClosingOfEmptyComment), this.state = State.DATA, this.emitCurrentComment(g);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInComment), this.emitCurrentComment(g), this._emitEOFToken();
        break;
      }
      default:
        g.data += "-", this.state = State.COMMENT, this._stateComment(t);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State.COMMENT_END_DASH;
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        g.data += "<", this.state = State.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), g.data += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInComment), this.emitCurrentComment(g), this._emitEOFToken();
        break;
      }
      default:
        g.data += String.fromCodePoint(t);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.EXCLAMATION_MARK: {
        g.data += "!", this.state = State.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case CODE_POINTS.LESS_THAN_SIGN: {
        g.data += "<";
        break;
      }
      default:
        this.state = State.COMMENT, this._stateComment(t);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(t) {
    t === CODE_POINTS.HYPHEN_MINUS ? this.state = State.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = State.COMMENT, this._stateComment(t));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(t) {
    t === CODE_POINTS.HYPHEN_MINUS ? this.state = State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = State.COMMENT_END_DASH, this._stateCommentEndDash(t));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(t) {
    t !== CODE_POINTS.GREATER_THAN_SIGN && t !== CODE_POINTS.EOF && this._err(ERR.nestedComment), this.state = State.COMMENT_END, this._stateCommentEnd(t);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.HYPHEN_MINUS: {
        this.state = State.COMMENT_END;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInComment), this.emitCurrentComment(g), this._emitEOFToken();
        break;
      }
      default:
        g.data += "-", this.state = State.COMMENT, this._stateComment(t);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State.DATA, this.emitCurrentComment(g);
        break;
      }
      case CODE_POINTS.EXCLAMATION_MARK: {
        this.state = State.COMMENT_END_BANG;
        break;
      }
      case CODE_POINTS.HYPHEN_MINUS: {
        g.data += "-";
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInComment), this.emitCurrentComment(g), this._emitEOFToken();
        break;
      }
      default:
        g.data += "--", this.state = State.COMMENT, this._stateComment(t);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.HYPHEN_MINUS: {
        g.data += "--!", this.state = State.COMMENT_END_DASH;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.incorrectlyClosedComment), this.state = State.DATA, this.emitCurrentComment(g);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInComment), this.emitCurrentComment(g), this._emitEOFToken();
        break;
      }
      default:
        g.data += "--!", this.state = State.COMMENT, this._stateComment(t);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(t) {
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this.state = State.BEFORE_DOCTYPE_NAME;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), this._createDoctypeToken(null);
        const g = this.currentToken;
        g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingWhitespaceBeforeDoctypeName), this.state = State.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(t) {
    if (isAsciiUpper(t))
      this._createDoctypeToken(String.fromCharCode(toAsciiLower(t))), this.state = State.DOCTYPE_NAME;
    else
      switch (t) {
        case CODE_POINTS.SPACE:
        case CODE_POINTS.LINE_FEED:
        case CODE_POINTS.TABULATION:
        case CODE_POINTS.FORM_FEED:
          break;
        case CODE_POINTS.NULL: {
          this._err(ERR.unexpectedNullCharacter), this._createDoctypeToken(REPLACEMENT_CHARACTER), this.state = State.DOCTYPE_NAME;
          break;
        }
        case CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(ERR.missingDoctypeName), this._createDoctypeToken(null);
          const g = this.currentToken;
          g.forceQuirks = !0, this.emitCurrentDoctype(g), this.state = State.DATA;
          break;
        }
        case CODE_POINTS.EOF: {
          this._err(ERR.eofInDoctype), this._createDoctypeToken(null);
          const g = this.currentToken;
          g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(t)), this.state = State.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this.state = State.AFTER_DOCTYPE_NAME;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State.DATA, this.emitCurrentDoctype(g);
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), g.name += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        g.name += String.fromCodePoint(isAsciiUpper(t) ? toAsciiLower(t) : t);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State.DATA, this.emitCurrentDoctype(g);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(SEQUENCES.PUBLIC, !1) ? this.state = State.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(SEQUENCES.SYSTEM, !1) ? this.state = State.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(ERR.invalidCharacterSequenceAfterDoctypeName), g.forceQuirks = !0, this.state = State.BOGUS_DOCTYPE, this._stateBogusDoctype(t));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this.state = State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case CODE_POINTS.QUOTATION_MARK: {
        this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword), g.publicId = "", this.state = State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword), g.publicId = "", this.state = State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.missingDoctypePublicIdentifier), g.forceQuirks = !0, this.state = State.DATA, this.emitCurrentDoctype(g);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier), g.forceQuirks = !0, this.state = State.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.QUOTATION_MARK: {
        g.publicId = "", this.state = State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        g.publicId = "", this.state = State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.missingDoctypePublicIdentifier), g.forceQuirks = !0, this.state = State.DATA, this.emitCurrentDoctype(g);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier), g.forceQuirks = !0, this.state = State.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.QUOTATION_MARK: {
        this.state = State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), g.publicId += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.abruptDoctypePublicIdentifier), g.forceQuirks = !0, this.emitCurrentDoctype(g), this.state = State.DATA;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        g.publicId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.APOSTROPHE: {
        this.state = State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), g.publicId += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.abruptDoctypePublicIdentifier), g.forceQuirks = !0, this.emitCurrentDoctype(g), this.state = State.DATA;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        g.publicId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this.state = State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State.DATA, this.emitCurrentDoctype(g);
        break;
      }
      case CODE_POINTS.QUOTATION_MARK: {
        this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), g.systemId = "", this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), g.systemId = "", this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier), g.forceQuirks = !0, this.state = State.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(g), this.state = State.DATA;
        break;
      }
      case CODE_POINTS.QUOTATION_MARK: {
        g.systemId = "", this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        g.systemId = "", this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier), g.forceQuirks = !0, this.state = State.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED: {
        this.state = State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case CODE_POINTS.QUOTATION_MARK: {
        this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword), g.systemId = "", this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword), g.systemId = "", this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.missingDoctypeSystemIdentifier), g.forceQuirks = !0, this.state = State.DATA, this.emitCurrentDoctype(g);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier), g.forceQuirks = !0, this.state = State.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.QUOTATION_MARK: {
        g.systemId = "", this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case CODE_POINTS.APOSTROPHE: {
        g.systemId = "", this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.missingDoctypeSystemIdentifier), g.forceQuirks = !0, this.state = State.DATA, this.emitCurrentDoctype(g);
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier), g.forceQuirks = !0, this.state = State.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.QUOTATION_MARK: {
        this.state = State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), g.systemId += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.abruptDoctypeSystemIdentifier), g.forceQuirks = !0, this.emitCurrentDoctype(g), this.state = State.DATA;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        g.systemId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.APOSTROPHE: {
        this.state = State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter), g.systemId += REPLACEMENT_CHARACTER;
        break;
      }
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(ERR.abruptDoctypeSystemIdentifier), g.forceQuirks = !0, this.emitCurrentDoctype(g), this.state = State.DATA;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        g.systemId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.SPACE:
      case CODE_POINTS.LINE_FEED:
      case CODE_POINTS.TABULATION:
      case CODE_POINTS.FORM_FEED:
        break;
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(g), this.state = State.DATA;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInDoctype), g.forceQuirks = !0, this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
      default:
        this._err(ERR.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = State.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(t) {
    const g = this.currentToken;
    switch (t) {
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(g), this.state = State.DATA;
        break;
      }
      case CODE_POINTS.NULL: {
        this._err(ERR.unexpectedNullCharacter);
        break;
      }
      case CODE_POINTS.EOF: {
        this.emitCurrentDoctype(g), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(t) {
    switch (t) {
      case CODE_POINTS.RIGHT_SQUARE_BRACKET: {
        this.state = State.CDATA_SECTION_BRACKET;
        break;
      }
      case CODE_POINTS.EOF: {
        this._err(ERR.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(t) {
    t === CODE_POINTS.RIGHT_SQUARE_BRACKET ? this.state = State.CDATA_SECTION_END : (this._emitChars("]"), this.state = State.CDATA_SECTION, this._stateCdataSection(t));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(t) {
    switch (t) {
      case CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = State.DATA;
        break;
      }
      case CODE_POINTS.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = State.CDATA_SECTION, this._stateCdataSection(t);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let t = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (t < 0)
      if (this.preprocessor.lastChunkWritten)
        t = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    t === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(CODE_POINTS.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && isAsciiAlphaNumeric(this.preprocessor.peek(1)) ? State.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(t) {
    isAsciiAlphaNumeric(t) ? this._flushCodePointConsumedAsCharacterReference(t) : (t === CODE_POINTS.SEMICOLON && this._err(ERR.unknownNamedCharacterReference), this.state = this.returnState, this._callState(t));
  }
}
const IMPLICIT_END_TAG_REQUIRED = /* @__PURE__ */ new Set([TAG_ID.DD, TAG_ID.DT, TAG_ID.LI, TAG_ID.OPTGROUP, TAG_ID.OPTION, TAG_ID.P, TAG_ID.RB, TAG_ID.RP, TAG_ID.RT, TAG_ID.RTC]), IMPLICIT_END_TAG_REQUIRED_THOROUGHLY = /* @__PURE__ */ new Set([
  ...IMPLICIT_END_TAG_REQUIRED,
  TAG_ID.CAPTION,
  TAG_ID.COLGROUP,
  TAG_ID.TBODY,
  TAG_ID.TD,
  TAG_ID.TFOOT,
  TAG_ID.TH,
  TAG_ID.THEAD,
  TAG_ID.TR
]), SCOPING_ELEMENTS_HTML = /* @__PURE__ */ new Set([
  TAG_ID.APPLET,
  TAG_ID.CAPTION,
  TAG_ID.HTML,
  TAG_ID.MARQUEE,
  TAG_ID.OBJECT,
  TAG_ID.TABLE,
  TAG_ID.TD,
  TAG_ID.TEMPLATE,
  TAG_ID.TH
]), SCOPING_ELEMENTS_HTML_LIST = /* @__PURE__ */ new Set([...SCOPING_ELEMENTS_HTML, TAG_ID.OL, TAG_ID.UL]), SCOPING_ELEMENTS_HTML_BUTTON = /* @__PURE__ */ new Set([...SCOPING_ELEMENTS_HTML, TAG_ID.BUTTON]), SCOPING_ELEMENTS_MATHML = /* @__PURE__ */ new Set([TAG_ID.ANNOTATION_XML, TAG_ID.MI, TAG_ID.MN, TAG_ID.MO, TAG_ID.MS, TAG_ID.MTEXT]), SCOPING_ELEMENTS_SVG = /* @__PURE__ */ new Set([TAG_ID.DESC, TAG_ID.FOREIGN_OBJECT, TAG_ID.TITLE]), TABLE_ROW_CONTEXT = /* @__PURE__ */ new Set([TAG_ID.TR, TAG_ID.TEMPLATE, TAG_ID.HTML]), TABLE_BODY_CONTEXT = /* @__PURE__ */ new Set([TAG_ID.TBODY, TAG_ID.TFOOT, TAG_ID.THEAD, TAG_ID.TEMPLATE, TAG_ID.HTML]), TABLE_CONTEXT = /* @__PURE__ */ new Set([TAG_ID.TABLE, TAG_ID.TEMPLATE, TAG_ID.HTML]), TABLE_CELLS = /* @__PURE__ */ new Set([TAG_ID.TD, TAG_ID.TH]);
class OpenElementStack {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(t, g, d) {
    this.treeAdapter = g, this.handler = d, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = TAG_ID.UNKNOWN, this.current = t;
  }
  //Index of element
  _indexOf(t) {
    return this.items.lastIndexOf(t, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === TAG_ID.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(t, g) {
    this.stackTop++, this.items[this.stackTop] = t, this.current = t, this.tagIDs[this.stackTop] = g, this.currentTagId = g, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(t, g, !0);
  }
  pop() {
    const t = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !0);
  }
  replace(t, g) {
    const d = this._indexOf(t);
    this.items[d] = g, d === this.stackTop && (this.current = g);
  }
  insertAfter(t, g, d) {
    const k = this._indexOf(t) + 1;
    this.items.splice(k, 0, g), this.tagIDs.splice(k, 0, d), this.stackTop++, k === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, k === this.stackTop);
  }
  popUntilTagNamePopped(t) {
    let g = this.stackTop + 1;
    do
      g = this.tagIDs.lastIndexOf(t, g - 1);
    while (g > 0 && this.treeAdapter.getNamespaceURI(this.items[g]) !== NS.HTML);
    this.shortenToLength(Math.max(g, 0));
  }
  shortenToLength(t) {
    for (; this.stackTop >= t; ) {
      const g = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(g, this.stackTop < t);
    }
  }
  popUntilElementPopped(t) {
    const g = this._indexOf(t);
    this.shortenToLength(Math.max(g, 0));
  }
  popUntilPopped(t, g) {
    const d = this._indexOfTagNames(t, g);
    this.shortenToLength(Math.max(d, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(NUMBERED_HEADERS, NS.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(TABLE_CELLS, NS.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(t, g) {
    for (let d = this.stackTop; d >= 0; d--)
      if (t.has(this.tagIDs[d]) && this.treeAdapter.getNamespaceURI(this.items[d]) === g)
        return d;
    return -1;
  }
  clearBackTo(t, g) {
    const d = this._indexOfTagNames(t, g);
    this.shortenToLength(d + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(TABLE_CONTEXT, NS.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(TABLE_BODY_CONTEXT, NS.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(TABLE_ROW_CONTEXT, NS.HTML);
  }
  remove(t) {
    const g = this._indexOf(t);
    g >= 0 && (g === this.stackTop ? this.pop() : (this.items.splice(g, 1), this.tagIDs.splice(g, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === TAG_ID.BODY ? this.items[1] : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    const g = this._indexOf(t) - 1;
    return g >= 0 ? this.items[g] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === TAG_ID.HTML;
  }
  //Element in scope
  hasInDynamicScope(t, g) {
    for (let d = this.stackTop; d >= 0; d--) {
      const k = this.tagIDs[d];
      switch (this.treeAdapter.getNamespaceURI(this.items[d])) {
        case NS.HTML: {
          if (k === t)
            return !0;
          if (g.has(k))
            return !1;
          break;
        }
        case NS.SVG: {
          if (SCOPING_ELEMENTS_SVG.has(k))
            return !1;
          break;
        }
        case NS.MATHML: {
          if (SCOPING_ELEMENTS_MATHML.has(k))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(t) {
    return this.hasInDynamicScope(t, SCOPING_ELEMENTS_HTML);
  }
  hasInListItemScope(t) {
    return this.hasInDynamicScope(t, SCOPING_ELEMENTS_HTML_LIST);
  }
  hasInButtonScope(t) {
    return this.hasInDynamicScope(t, SCOPING_ELEMENTS_HTML_BUTTON);
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const g = this.tagIDs[t];
      switch (this.treeAdapter.getNamespaceURI(this.items[t])) {
        case NS.HTML: {
          if (NUMBERED_HEADERS.has(g))
            return !0;
          if (SCOPING_ELEMENTS_HTML.has(g))
            return !1;
          break;
        }
        case NS.SVG: {
          if (SCOPING_ELEMENTS_SVG.has(g))
            return !1;
          break;
        }
        case NS.MATHML: {
          if (SCOPING_ELEMENTS_MATHML.has(g))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let g = this.stackTop; g >= 0; g--)
      if (this.treeAdapter.getNamespaceURI(this.items[g]) === NS.HTML)
        switch (this.tagIDs[g]) {
          case t:
            return !0;
          case TAG_ID.TABLE:
          case TAG_ID.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === NS.HTML)
        switch (this.tagIDs[t]) {
          case TAG_ID.TBODY:
          case TAG_ID.THEAD:
          case TAG_ID.TFOOT:
            return !0;
          case TAG_ID.TABLE:
          case TAG_ID.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(t) {
    for (let g = this.stackTop; g >= 0; g--)
      if (this.treeAdapter.getNamespaceURI(this.items[g]) === NS.HTML)
        switch (this.tagIDs[g]) {
          case t:
            return !0;
          case TAG_ID.OPTION:
          case TAG_ID.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && IMPLICIT_END_TAG_REQUIRED.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== t && IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId); )
      this.pop();
  }
}
const NOAH_ARK_CAPACITY = 3;
var EntryType;
(function(n) {
  n[n.Marker = 0] = "Marker", n[n.Element = 1] = "Element";
})(EntryType || (EntryType = {}));
const MARKER = { type: EntryType.Marker };
class FormattingElementList {
  constructor(t) {
    this.treeAdapter = t, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t, g) {
    const d = [], k = g.length, H = this.treeAdapter.getTagName(t), AA = this.treeAdapter.getNamespaceURI(t);
    for (let gA = 0; gA < this.entries.length; gA++) {
      const IA = this.entries[gA];
      if (IA.type === EntryType.Marker)
        break;
      const { element: CA } = IA;
      if (this.treeAdapter.getTagName(CA) === H && this.treeAdapter.getNamespaceURI(CA) === AA) {
        const BA = this.treeAdapter.getAttrList(CA);
        BA.length === k && d.push({ idx: gA, attrs: BA });
      }
    }
    return d;
  }
  _ensureNoahArkCondition(t) {
    if (this.entries.length < NOAH_ARK_CAPACITY)
      return;
    const g = this.treeAdapter.getAttrList(t), d = this._getNoahArkConditionCandidates(t, g);
    if (d.length < NOAH_ARK_CAPACITY)
      return;
    const k = new Map(g.map((AA) => [AA.name, AA.value]));
    let H = 0;
    for (let AA = 0; AA < d.length; AA++) {
      const gA = d[AA];
      gA.attrs.every((IA) => k.get(IA.name) === IA.value) && (H += 1, H >= NOAH_ARK_CAPACITY && this.entries.splice(gA.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(MARKER);
  }
  pushElement(t, g) {
    this._ensureNoahArkCondition(t), this.entries.unshift({
      type: EntryType.Element,
      element: t,
      token: g
    });
  }
  insertElementAfterBookmark(t, g) {
    const d = this.entries.indexOf(this.bookmark);
    this.entries.splice(d, 0, {
      type: EntryType.Element,
      element: t,
      token: g
    });
  }
  removeEntry(t) {
    const g = this.entries.indexOf(t);
    g !== -1 && this.entries.splice(g, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const t = this.entries.indexOf(MARKER);
    t === -1 ? this.entries.length = 0 : this.entries.splice(0, t + 1);
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    const g = this.entries.find((d) => d.type === EntryType.Marker || this.treeAdapter.getTagName(d.element) === t);
    return g && g.type === EntryType.Element ? g : null;
  }
  getElementEntry(t) {
    return this.entries.find((g) => g.type === EntryType.Element && g.element === t);
  }
}
const defaultTreeAdapter = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: DOCUMENT_MODE.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(n, t, g) {
    return {
      nodeName: n,
      tagName: n,
      attrs: g,
      namespaceURI: t,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(n) {
    return {
      nodeName: "#comment",
      data: n,
      parentNode: null
    };
  },
  createTextNode(n) {
    return {
      nodeName: "#text",
      value: n,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(n, t) {
    n.childNodes.push(t), t.parentNode = n;
  },
  insertBefore(n, t, g) {
    const d = n.childNodes.indexOf(g);
    n.childNodes.splice(d, 0, t), t.parentNode = n;
  },
  setTemplateContent(n, t) {
    n.content = t;
  },
  getTemplateContent(n) {
    return n.content;
  },
  setDocumentType(n, t, g, d) {
    const k = n.childNodes.find((H) => H.nodeName === "#documentType");
    if (k)
      k.name = t, k.publicId = g, k.systemId = d;
    else {
      const H = {
        nodeName: "#documentType",
        name: t,
        publicId: g,
        systemId: d,
        parentNode: null
      };
      defaultTreeAdapter.appendChild(n, H);
    }
  },
  setDocumentMode(n, t) {
    n.mode = t;
  },
  getDocumentMode(n) {
    return n.mode;
  },
  detachNode(n) {
    if (n.parentNode) {
      const t = n.parentNode.childNodes.indexOf(n);
      n.parentNode.childNodes.splice(t, 1), n.parentNode = null;
    }
  },
  insertText(n, t) {
    if (n.childNodes.length > 0) {
      const g = n.childNodes[n.childNodes.length - 1];
      if (defaultTreeAdapter.isTextNode(g)) {
        g.value += t;
        return;
      }
    }
    defaultTreeAdapter.appendChild(n, defaultTreeAdapter.createTextNode(t));
  },
  insertTextBefore(n, t, g) {
    const d = n.childNodes[n.childNodes.indexOf(g) - 1];
    d && defaultTreeAdapter.isTextNode(d) ? d.value += t : defaultTreeAdapter.insertBefore(n, defaultTreeAdapter.createTextNode(t), g);
  },
  adoptAttributes(n, t) {
    const g = new Set(n.attrs.map((d) => d.name));
    for (let d = 0; d < t.length; d++)
      g.has(t[d].name) || n.attrs.push(t[d]);
  },
  //Tree traversing
  getFirstChild(n) {
    return n.childNodes[0];
  },
  getChildNodes(n) {
    return n.childNodes;
  },
  getParentNode(n) {
    return n.parentNode;
  },
  getAttrList(n) {
    return n.attrs;
  },
  //Node data
  getTagName(n) {
    return n.tagName;
  },
  getNamespaceURI(n) {
    return n.namespaceURI;
  },
  getTextNodeContent(n) {
    return n.value;
  },
  getCommentNodeContent(n) {
    return n.data;
  },
  getDocumentTypeNodeName(n) {
    return n.name;
  },
  getDocumentTypeNodePublicId(n) {
    return n.publicId;
  },
  getDocumentTypeNodeSystemId(n) {
    return n.systemId;
  },
  //Node types
  isTextNode(n) {
    return n.nodeName === "#text";
  },
  isCommentNode(n) {
    return n.nodeName === "#comment";
  },
  isDocumentTypeNode(n) {
    return n.nodeName === "#documentType";
  },
  isElementNode(n) {
    return Object.prototype.hasOwnProperty.call(n, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(n, t) {
    n.sourceCodeLocation = t;
  },
  getNodeSourceCodeLocation(n) {
    return n.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(n, t) {
    n.sourceCodeLocation = { ...n.sourceCodeLocation, ...t };
  }
}, VALID_DOCTYPE_NAME = "html", VALID_SYSTEM_ID = "about:legacy-compat", QUIRKS_MODE_SYSTEM_ID = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
  ...QUIRKS_MODE_PUBLIC_ID_PREFIXES,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], QUIRKS_MODE_PUBLIC_IDS = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
  ...LIMITED_QUIRKS_PUBLIC_ID_PREFIXES,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function hasPrefix(n, t) {
  return t.some((g) => n.startsWith(g));
}
function isConforming(n) {
  return n.name === VALID_DOCTYPE_NAME && n.publicId === null && (n.systemId === null || n.systemId === VALID_SYSTEM_ID);
}
function getDocumentMode(n) {
  if (n.name !== VALID_DOCTYPE_NAME)
    return DOCUMENT_MODE.QUIRKS;
  const { systemId: t } = n;
  if (t && t.toLowerCase() === QUIRKS_MODE_SYSTEM_ID)
    return DOCUMENT_MODE.QUIRKS;
  let { publicId: g } = n;
  if (g !== null) {
    if (g = g.toLowerCase(), QUIRKS_MODE_PUBLIC_IDS.has(g))
      return DOCUMENT_MODE.QUIRKS;
    let d = t === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;
    if (hasPrefix(g, d))
      return DOCUMENT_MODE.QUIRKS;
    if (d = t === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES, hasPrefix(g, d))
      return DOCUMENT_MODE.LIMITED_QUIRKS;
  }
  return DOCUMENT_MODE.NO_QUIRKS;
}
const MIME_TYPES = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, DEFINITION_URL_ATTR = "definitionurl", ADJUSTED_DEFINITION_URL_ATTR = "definitionURL", SVG_ATTRS_ADJUSTMENT_MAP = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((n) => [n.toLowerCase(), n])), XML_ATTRS_ADJUSTMENT_MAP = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: NS.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: NS.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: NS.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: NS.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: NS.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: NS.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: NS.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: NS.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: NS.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: NS.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: NS.XMLNS }]
]), SVG_TAG_NAMES_ADJUSTMENT_MAP = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((n) => [n.toLowerCase(), n])), EXITS_FOREIGN_CONTENT = /* @__PURE__ */ new Set([
  TAG_ID.B,
  TAG_ID.BIG,
  TAG_ID.BLOCKQUOTE,
  TAG_ID.BODY,
  TAG_ID.BR,
  TAG_ID.CENTER,
  TAG_ID.CODE,
  TAG_ID.DD,
  TAG_ID.DIV,
  TAG_ID.DL,
  TAG_ID.DT,
  TAG_ID.EM,
  TAG_ID.EMBED,
  TAG_ID.H1,
  TAG_ID.H2,
  TAG_ID.H3,
  TAG_ID.H4,
  TAG_ID.H5,
  TAG_ID.H6,
  TAG_ID.HEAD,
  TAG_ID.HR,
  TAG_ID.I,
  TAG_ID.IMG,
  TAG_ID.LI,
  TAG_ID.LISTING,
  TAG_ID.MENU,
  TAG_ID.META,
  TAG_ID.NOBR,
  TAG_ID.OL,
  TAG_ID.P,
  TAG_ID.PRE,
  TAG_ID.RUBY,
  TAG_ID.S,
  TAG_ID.SMALL,
  TAG_ID.SPAN,
  TAG_ID.STRONG,
  TAG_ID.STRIKE,
  TAG_ID.SUB,
  TAG_ID.SUP,
  TAG_ID.TABLE,
  TAG_ID.TT,
  TAG_ID.U,
  TAG_ID.UL,
  TAG_ID.VAR
]);
function causesExit(n) {
  const t = n.tagID;
  return t === TAG_ID.FONT && n.attrs.some(({ name: d }) => d === ATTRS.COLOR || d === ATTRS.SIZE || d === ATTRS.FACE) || EXITS_FOREIGN_CONTENT.has(t);
}
function adjustTokenMathMLAttrs(n) {
  for (let t = 0; t < n.attrs.length; t++)
    if (n.attrs[t].name === DEFINITION_URL_ATTR) {
      n.attrs[t].name = ADJUSTED_DEFINITION_URL_ATTR;
      break;
    }
}
function adjustTokenSVGAttrs(n) {
  for (let t = 0; t < n.attrs.length; t++) {
    const g = SVG_ATTRS_ADJUSTMENT_MAP.get(n.attrs[t].name);
    g != null && (n.attrs[t].name = g);
  }
}
function adjustTokenXMLAttrs(n) {
  for (let t = 0; t < n.attrs.length; t++) {
    const g = XML_ATTRS_ADJUSTMENT_MAP.get(n.attrs[t].name);
    g && (n.attrs[t].prefix = g.prefix, n.attrs[t].name = g.name, n.attrs[t].namespace = g.namespace);
  }
}
function adjustTokenSVGTagName(n) {
  const t = SVG_TAG_NAMES_ADJUSTMENT_MAP.get(n.tagName);
  t != null && (n.tagName = t, n.tagID = getTagID(n.tagName));
}
function isMathMLTextIntegrationPoint(n, t) {
  return t === NS.MATHML && (n === TAG_ID.MI || n === TAG_ID.MO || n === TAG_ID.MN || n === TAG_ID.MS || n === TAG_ID.MTEXT);
}
function isHtmlIntegrationPoint(n, t, g) {
  if (t === NS.MATHML && n === TAG_ID.ANNOTATION_XML) {
    for (let d = 0; d < g.length; d++)
      if (g[d].name === ATTRS.ENCODING) {
        const k = g[d].value.toLowerCase();
        return k === MIME_TYPES.TEXT_HTML || k === MIME_TYPES.APPLICATION_XML;
      }
  }
  return t === NS.SVG && (n === TAG_ID.FOREIGN_OBJECT || n === TAG_ID.DESC || n === TAG_ID.TITLE);
}
function isIntegrationPoint(n, t, g, d) {
  return (!d || d === NS.HTML) && isHtmlIntegrationPoint(n, t, g) || (!d || d === NS.MATHML) && isMathMLTextIntegrationPoint(n, t);
}
const HIDDEN_INPUT_TYPE = "hidden", AA_OUTER_LOOP_ITER = 8, AA_INNER_LOOP_ITER = 3;
var InsertionMode;
(function(n) {
  n[n.INITIAL = 0] = "INITIAL", n[n.BEFORE_HTML = 1] = "BEFORE_HTML", n[n.BEFORE_HEAD = 2] = "BEFORE_HEAD", n[n.IN_HEAD = 3] = "IN_HEAD", n[n.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", n[n.AFTER_HEAD = 5] = "AFTER_HEAD", n[n.IN_BODY = 6] = "IN_BODY", n[n.TEXT = 7] = "TEXT", n[n.IN_TABLE = 8] = "IN_TABLE", n[n.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", n[n.IN_CAPTION = 10] = "IN_CAPTION", n[n.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", n[n.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", n[n.IN_ROW = 13] = "IN_ROW", n[n.IN_CELL = 14] = "IN_CELL", n[n.IN_SELECT = 15] = "IN_SELECT", n[n.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", n[n.IN_TEMPLATE = 17] = "IN_TEMPLATE", n[n.AFTER_BODY = 18] = "AFTER_BODY", n[n.IN_FRAMESET = 19] = "IN_FRAMESET", n[n.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", n[n.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", n[n.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(InsertionMode || (InsertionMode = {}));
const BASE_LOC = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, TABLE_STRUCTURE_TAGS = /* @__PURE__ */ new Set([TAG_ID.TABLE, TAG_ID.TBODY, TAG_ID.TFOOT, TAG_ID.THEAD, TAG_ID.TR]), defaultParserOptions = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: defaultTreeAdapter,
  onParseError: null
};
class Parser {
  constructor(t, g, d = null, k = null) {
    this.fragmentContext = d, this.scriptHandler = k, this.currentToken = null, this.stopped = !1, this.insertionMode = InsertionMode.INITIAL, this.originalInsertionMode = InsertionMode.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...defaultParserOptions,
      ...t
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = g ?? this.treeAdapter.createDocument(), this.tokenizer = new Tokenizer(this.options, this), this.activeFormattingElements = new FormattingElementList(this.treeAdapter), this.fragmentContextID = d ? getTagID(this.treeAdapter.getTagName(d)) : TAG_ID.UNKNOWN, this._setContextModes(d ?? this.document, this.fragmentContextID), this.openElements = new OpenElementStack(this.document, this.treeAdapter, this);
  }
  // API
  static parse(t, g) {
    const d = new this(g);
    return d.tokenizer.write(t, !0), d.document;
  }
  static getFragmentParser(t, g) {
    const d = {
      ...defaultParserOptions,
      ...g
    };
    t ?? (t = d.treeAdapter.createElement(TAG_NAMES.TEMPLATE, NS.HTML, []));
    const k = d.treeAdapter.createElement("documentmock", NS.HTML, []), H = new this(d, k, t);
    return H.fragmentContextID === TAG_ID.TEMPLATE && H.tmplInsertionModeStack.unshift(InsertionMode.IN_TEMPLATE), H._initTokenizerForFragmentParsing(), H._insertFakeRootElement(), H._resetInsertionMode(), H._findFormInFragmentContext(), H;
  }
  getFragment() {
    const t = this.treeAdapter.getFirstChild(this.document), g = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(t, g), g;
  }
  //Errors
  /** @internal */
  _err(t, g, d) {
    var k;
    if (!this.onParseError)
      return;
    const H = (k = t.location) !== null && k !== void 0 ? k : BASE_LOC, AA = {
      code: g,
      startLine: H.startLine,
      startCol: H.startCol,
      startOffset: H.startOffset,
      endLine: d ? H.startLine : H.endLine,
      endCol: d ? H.startCol : H.endCol,
      endOffset: d ? H.startOffset : H.endOffset
    };
    this.onParseError(AA);
  }
  //Stack events
  /** @internal */
  onItemPush(t, g, d) {
    var k, H;
    (H = (k = this.treeAdapter).onItemPush) === null || H === void 0 || H.call(k, t), d && this.openElements.stackTop > 0 && this._setContextModes(t, g);
  }
  /** @internal */
  onItemPop(t, g) {
    var d, k;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(t, this.currentToken), (k = (d = this.treeAdapter).onItemPop) === null || k === void 0 || k.call(d, t, this.openElements.current), g) {
      let H, AA;
      this.openElements.stackTop === 0 && this.fragmentContext ? (H = this.fragmentContext, AA = this.fragmentContextID) : { current: H, currentTagId: AA } = this.openElements, this._setContextModes(H, AA);
    }
  }
  _setContextModes(t, g) {
    const d = t === this.document || t && this.treeAdapter.getNamespaceURI(t) === NS.HTML;
    this.currentNotInHTML = !d, this.tokenizer.inForeignNode = !d && t !== void 0 && g !== void 0 && !this._isIntegrationPoint(g, t);
  }
  /** @protected */
  _switchToTextParsing(t, g) {
    this._insertElement(t, NS.HTML), this.tokenizer.state = g, this.originalInsertionMode = this.insertionMode, this.insertionMode = InsertionMode.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = InsertionMode.TEXT, this.originalInsertionMode = InsertionMode.IN_BODY, this.tokenizer.state = TokenizerMode.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    for (; t; ) {
      if (this.treeAdapter.getTagName(t) === TAG_NAMES.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== NS.HTML))
      switch (this.fragmentContextID) {
        case TAG_ID.TITLE:
        case TAG_ID.TEXTAREA: {
          this.tokenizer.state = TokenizerMode.RCDATA;
          break;
        }
        case TAG_ID.STYLE:
        case TAG_ID.XMP:
        case TAG_ID.IFRAME:
        case TAG_ID.NOEMBED:
        case TAG_ID.NOFRAMES:
        case TAG_ID.NOSCRIPT: {
          this.tokenizer.state = TokenizerMode.RAWTEXT;
          break;
        }
        case TAG_ID.SCRIPT: {
          this.tokenizer.state = TokenizerMode.SCRIPT_DATA;
          break;
        }
        case TAG_ID.PLAINTEXT: {
          this.tokenizer.state = TokenizerMode.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(t) {
    const g = t.name || "", d = t.publicId || "", k = t.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, g, d, k), t.location) {
      const AA = this.treeAdapter.getChildNodes(this.document).find((gA) => this.treeAdapter.isDocumentTypeNode(gA));
      AA && this.treeAdapter.setNodeSourceCodeLocation(AA, t.location);
    }
  }
  /** @protected */
  _attachElementToTree(t, g) {
    if (this.options.sourceCodeLocationInfo) {
      const d = g && {
        ...g,
        startTag: g
      };
      this.treeAdapter.setNodeSourceCodeLocation(t, d);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const d = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(d ?? this.document, t);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(t, g) {
    const d = this.treeAdapter.createElement(t.tagName, g, t.attrs);
    this._attachElementToTree(d, t.location);
  }
  /** @protected */
  _insertElement(t, g) {
    const d = this.treeAdapter.createElement(t.tagName, g, t.attrs);
    this._attachElementToTree(d, t.location), this.openElements.push(d, t.tagID);
  }
  /** @protected */
  _insertFakeElement(t, g) {
    const d = this.treeAdapter.createElement(t, NS.HTML, []);
    this._attachElementToTree(d, null), this.openElements.push(d, g);
  }
  /** @protected */
  _insertTemplate(t) {
    const g = this.treeAdapter.createElement(t.tagName, NS.HTML, t.attrs), d = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(g, d), this._attachElementToTree(g, t.location), this.openElements.push(g, t.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(d, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(TAG_NAMES.HTML, NS.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(t, null), this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t, TAG_ID.HTML);
  }
  /** @protected */
  _appendCommentNode(t, g) {
    const d = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(g, d), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(d, t.location);
  }
  /** @protected */
  _insertCharacters(t) {
    let g, d;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: g, beforeElement: d } = this._findFosterParentingLocation(), d ? this.treeAdapter.insertTextBefore(g, t.chars, d) : this.treeAdapter.insertText(g, t.chars)) : (g = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(g, t.chars)), !t.location)
      return;
    const k = this.treeAdapter.getChildNodes(g), H = d ? k.lastIndexOf(d) : k.length, AA = k[H - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(AA)) {
      const { endLine: IA, endCol: CA, endOffset: BA } = t.location;
      this.treeAdapter.updateNodeSourceCodeLocation(AA, { endLine: IA, endCol: CA, endOffset: BA });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(AA, t.location);
  }
  /** @protected */
  _adoptNodes(t, g) {
    for (let d = this.treeAdapter.getFirstChild(t); d; d = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(d), this.treeAdapter.appendChild(g, d);
  }
  /** @protected */
  _setEndLocation(t, g) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && g.location) {
      const d = g.location, k = this.treeAdapter.getTagName(t), H = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        g.type === TokenType.END_TAG && k === g.tagName ? {
          endTag: { ...d },
          endLine: d.endLine,
          endCol: d.endCol,
          endOffset: d.endOffset
        } : {
          endLine: d.startLine,
          endCol: d.startCol,
          endOffset: d.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(t, H);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(t) {
    if (!this.currentNotInHTML)
      return !1;
    let g, d;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (g = this.fragmentContext, d = this.fragmentContextID) : { current: g, currentTagId: d } = this.openElements, t.tagID === TAG_ID.SVG && this.treeAdapter.getTagName(g) === TAG_NAMES.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(g) === NS.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (t.tagID === TAG_ID.MGLYPH || t.tagID === TAG_ID.MALIGNMARK) && d !== void 0 && !this._isIntegrationPoint(d, g, NS.HTML)
    );
  }
  /** @protected */
  _processToken(t) {
    switch (t.type) {
      case TokenType.CHARACTER: {
        this.onCharacter(t);
        break;
      }
      case TokenType.NULL_CHARACTER: {
        this.onNullCharacter(t);
        break;
      }
      case TokenType.COMMENT: {
        this.onComment(t);
        break;
      }
      case TokenType.DOCTYPE: {
        this.onDoctype(t);
        break;
      }
      case TokenType.START_TAG: {
        this._processStartTag(t);
        break;
      }
      case TokenType.END_TAG: {
        this.onEndTag(t);
        break;
      }
      case TokenType.EOF: {
        this.onEof(t);
        break;
      }
      case TokenType.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(t);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(t, g, d) {
    const k = this.treeAdapter.getNamespaceURI(g), H = this.treeAdapter.getAttrList(g);
    return isIntegrationPoint(t, k, H, d);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.entries.length;
    if (t) {
      const g = this.activeFormattingElements.entries.findIndex((k) => k.type === EntryType.Marker || this.openElements.contains(k.element)), d = g === -1 ? t - 1 : g - 1;
      for (let k = d; k >= 0; k--) {
        const H = this.activeFormattingElements.entries[k];
        this._insertElement(H.token, this.treeAdapter.getNamespaceURI(H.element)), H.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = InsertionMode.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(TAG_ID.P), this.openElements.popUntilTagNamePopped(TAG_ID.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop; t >= 0; t--)
      switch (t === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[t]) {
        case TAG_ID.TR: {
          this.insertionMode = InsertionMode.IN_ROW;
          return;
        }
        case TAG_ID.TBODY:
        case TAG_ID.THEAD:
        case TAG_ID.TFOOT: {
          this.insertionMode = InsertionMode.IN_TABLE_BODY;
          return;
        }
        case TAG_ID.CAPTION: {
          this.insertionMode = InsertionMode.IN_CAPTION;
          return;
        }
        case TAG_ID.COLGROUP: {
          this.insertionMode = InsertionMode.IN_COLUMN_GROUP;
          return;
        }
        case TAG_ID.TABLE: {
          this.insertionMode = InsertionMode.IN_TABLE;
          return;
        }
        case TAG_ID.BODY: {
          this.insertionMode = InsertionMode.IN_BODY;
          return;
        }
        case TAG_ID.FRAMESET: {
          this.insertionMode = InsertionMode.IN_FRAMESET;
          return;
        }
        case TAG_ID.SELECT: {
          this._resetInsertionModeForSelect(t);
          return;
        }
        case TAG_ID.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case TAG_ID.HTML: {
          this.insertionMode = this.headElement ? InsertionMode.AFTER_HEAD : InsertionMode.BEFORE_HEAD;
          return;
        }
        case TAG_ID.TD:
        case TAG_ID.TH: {
          if (t > 0) {
            this.insertionMode = InsertionMode.IN_CELL;
            return;
          }
          break;
        }
        case TAG_ID.HEAD: {
          if (t > 0) {
            this.insertionMode = InsertionMode.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = InsertionMode.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let g = t - 1; g > 0; g--) {
        const d = this.openElements.tagIDs[g];
        if (d === TAG_ID.TEMPLATE)
          break;
        if (d === TAG_ID.TABLE) {
          this.insertionMode = InsertionMode.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = InsertionMode.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(t) {
    return TABLE_STRUCTURE_TAGS.has(t);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      const g = this.openElements.items[t];
      switch (this.openElements.tagIDs[t]) {
        case TAG_ID.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(g) === NS.HTML)
            return { parent: this.treeAdapter.getTemplateContent(g), beforeElement: null };
          break;
        }
        case TAG_ID.TABLE: {
          const d = this.treeAdapter.getParentNode(g);
          return d ? { parent: d, beforeElement: g } : { parent: this.openElements.items[t - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(t) {
    const g = this._findFosterParentingLocation();
    g.beforeElement ? this.treeAdapter.insertBefore(g.parent, t, g.beforeElement) : this.treeAdapter.appendChild(g.parent, t);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(t, g) {
    const d = this.treeAdapter.getNamespaceURI(t);
    return SPECIAL_ELEMENTS[d].has(g);
  }
  /** @internal */
  onCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      characterInForeignContent(this, t);
      return;
    }
    switch (this.insertionMode) {
      case InsertionMode.INITIAL: {
        tokenInInitialMode(this, t);
        break;
      }
      case InsertionMode.BEFORE_HTML: {
        tokenBeforeHtml(this, t);
        break;
      }
      case InsertionMode.BEFORE_HEAD: {
        tokenBeforeHead(this, t);
        break;
      }
      case InsertionMode.IN_HEAD: {
        tokenInHead(this, t);
        break;
      }
      case InsertionMode.IN_HEAD_NO_SCRIPT: {
        tokenInHeadNoScript(this, t);
        break;
      }
      case InsertionMode.AFTER_HEAD: {
        tokenAfterHead(this, t);
        break;
      }
      case InsertionMode.IN_BODY:
      case InsertionMode.IN_CAPTION:
      case InsertionMode.IN_CELL:
      case InsertionMode.IN_TEMPLATE: {
        characterInBody(this, t);
        break;
      }
      case InsertionMode.TEXT:
      case InsertionMode.IN_SELECT:
      case InsertionMode.IN_SELECT_IN_TABLE: {
        this._insertCharacters(t);
        break;
      }
      case InsertionMode.IN_TABLE:
      case InsertionMode.IN_TABLE_BODY:
      case InsertionMode.IN_ROW: {
        characterInTable(this, t);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        characterInTableText(this, t);
        break;
      }
      case InsertionMode.IN_COLUMN_GROUP: {
        tokenInColumnGroup(this, t);
        break;
      }
      case InsertionMode.AFTER_BODY: {
        tokenAfterBody(this, t);
        break;
      }
      case InsertionMode.AFTER_AFTER_BODY: {
        tokenAfterAfterBody(this, t);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      nullCharacterInForeignContent(this, t);
      return;
    }
    switch (this.insertionMode) {
      case InsertionMode.INITIAL: {
        tokenInInitialMode(this, t);
        break;
      }
      case InsertionMode.BEFORE_HTML: {
        tokenBeforeHtml(this, t);
        break;
      }
      case InsertionMode.BEFORE_HEAD: {
        tokenBeforeHead(this, t);
        break;
      }
      case InsertionMode.IN_HEAD: {
        tokenInHead(this, t);
        break;
      }
      case InsertionMode.IN_HEAD_NO_SCRIPT: {
        tokenInHeadNoScript(this, t);
        break;
      }
      case InsertionMode.AFTER_HEAD: {
        tokenAfterHead(this, t);
        break;
      }
      case InsertionMode.TEXT: {
        this._insertCharacters(t);
        break;
      }
      case InsertionMode.IN_TABLE:
      case InsertionMode.IN_TABLE_BODY:
      case InsertionMode.IN_ROW: {
        characterInTable(this, t);
        break;
      }
      case InsertionMode.IN_COLUMN_GROUP: {
        tokenInColumnGroup(this, t);
        break;
      }
      case InsertionMode.AFTER_BODY: {
        tokenAfterBody(this, t);
        break;
      }
      case InsertionMode.AFTER_AFTER_BODY: {
        tokenAfterAfterBody(this, t);
        break;
      }
    }
  }
  /** @internal */
  onComment(t) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      appendComment(this, t);
      return;
    }
    switch (this.insertionMode) {
      case InsertionMode.INITIAL:
      case InsertionMode.BEFORE_HTML:
      case InsertionMode.BEFORE_HEAD:
      case InsertionMode.IN_HEAD:
      case InsertionMode.IN_HEAD_NO_SCRIPT:
      case InsertionMode.AFTER_HEAD:
      case InsertionMode.IN_BODY:
      case InsertionMode.IN_TABLE:
      case InsertionMode.IN_CAPTION:
      case InsertionMode.IN_COLUMN_GROUP:
      case InsertionMode.IN_TABLE_BODY:
      case InsertionMode.IN_ROW:
      case InsertionMode.IN_CELL:
      case InsertionMode.IN_SELECT:
      case InsertionMode.IN_SELECT_IN_TABLE:
      case InsertionMode.IN_TEMPLATE:
      case InsertionMode.IN_FRAMESET:
      case InsertionMode.AFTER_FRAMESET: {
        appendComment(this, t);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        tokenInTableText(this, t);
        break;
      }
      case InsertionMode.AFTER_BODY: {
        appendCommentToRootHtmlElement(this, t);
        break;
      }
      case InsertionMode.AFTER_AFTER_BODY:
      case InsertionMode.AFTER_AFTER_FRAMESET: {
        appendCommentToDocument(this, t);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(t) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case InsertionMode.INITIAL: {
        doctypeInInitialMode(this, t);
        break;
      }
      case InsertionMode.BEFORE_HEAD:
      case InsertionMode.IN_HEAD:
      case InsertionMode.IN_HEAD_NO_SCRIPT:
      case InsertionMode.AFTER_HEAD: {
        this._err(t, ERR.misplacedDoctype);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        tokenInTableText(this, t);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this._processStartTag(t), t.selfClosing && !t.ackSelfClosing && this._err(t, ERR.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(t) {
    this.shouldProcessStartTagTokenInForeignContent(t) ? startTagInForeignContent(this, t) : this._startTagOutsideForeignContent(t);
  }
  /** @protected */
  _startTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case InsertionMode.INITIAL: {
        tokenInInitialMode(this, t);
        break;
      }
      case InsertionMode.BEFORE_HTML: {
        startTagBeforeHtml(this, t);
        break;
      }
      case InsertionMode.BEFORE_HEAD: {
        startTagBeforeHead(this, t);
        break;
      }
      case InsertionMode.IN_HEAD: {
        startTagInHead(this, t);
        break;
      }
      case InsertionMode.IN_HEAD_NO_SCRIPT: {
        startTagInHeadNoScript(this, t);
        break;
      }
      case InsertionMode.AFTER_HEAD: {
        startTagAfterHead(this, t);
        break;
      }
      case InsertionMode.IN_BODY: {
        startTagInBody(this, t);
        break;
      }
      case InsertionMode.IN_TABLE: {
        startTagInTable(this, t);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        tokenInTableText(this, t);
        break;
      }
      case InsertionMode.IN_CAPTION: {
        startTagInCaption(this, t);
        break;
      }
      case InsertionMode.IN_COLUMN_GROUP: {
        startTagInColumnGroup(this, t);
        break;
      }
      case InsertionMode.IN_TABLE_BODY: {
        startTagInTableBody(this, t);
        break;
      }
      case InsertionMode.IN_ROW: {
        startTagInRow(this, t);
        break;
      }
      case InsertionMode.IN_CELL: {
        startTagInCell(this, t);
        break;
      }
      case InsertionMode.IN_SELECT: {
        startTagInSelect(this, t);
        break;
      }
      case InsertionMode.IN_SELECT_IN_TABLE: {
        startTagInSelectInTable(this, t);
        break;
      }
      case InsertionMode.IN_TEMPLATE: {
        startTagInTemplate(this, t);
        break;
      }
      case InsertionMode.AFTER_BODY: {
        startTagAfterBody(this, t);
        break;
      }
      case InsertionMode.IN_FRAMESET: {
        startTagInFrameset(this, t);
        break;
      }
      case InsertionMode.AFTER_FRAMESET: {
        startTagAfterFrameset(this, t);
        break;
      }
      case InsertionMode.AFTER_AFTER_BODY: {
        startTagAfterAfterBody(this, t);
        break;
      }
      case InsertionMode.AFTER_AFTER_FRAMESET: {
        startTagAfterAfterFrameset(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this.currentNotInHTML ? endTagInForeignContent(this, t) : this._endTagOutsideForeignContent(t);
  }
  /** @protected */
  _endTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case InsertionMode.INITIAL: {
        tokenInInitialMode(this, t);
        break;
      }
      case InsertionMode.BEFORE_HTML: {
        endTagBeforeHtml(this, t);
        break;
      }
      case InsertionMode.BEFORE_HEAD: {
        endTagBeforeHead(this, t);
        break;
      }
      case InsertionMode.IN_HEAD: {
        endTagInHead(this, t);
        break;
      }
      case InsertionMode.IN_HEAD_NO_SCRIPT: {
        endTagInHeadNoScript(this, t);
        break;
      }
      case InsertionMode.AFTER_HEAD: {
        endTagAfterHead(this, t);
        break;
      }
      case InsertionMode.IN_BODY: {
        endTagInBody(this, t);
        break;
      }
      case InsertionMode.TEXT: {
        endTagInText(this, t);
        break;
      }
      case InsertionMode.IN_TABLE: {
        endTagInTable(this, t);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        tokenInTableText(this, t);
        break;
      }
      case InsertionMode.IN_CAPTION: {
        endTagInCaption(this, t);
        break;
      }
      case InsertionMode.IN_COLUMN_GROUP: {
        endTagInColumnGroup(this, t);
        break;
      }
      case InsertionMode.IN_TABLE_BODY: {
        endTagInTableBody(this, t);
        break;
      }
      case InsertionMode.IN_ROW: {
        endTagInRow(this, t);
        break;
      }
      case InsertionMode.IN_CELL: {
        endTagInCell(this, t);
        break;
      }
      case InsertionMode.IN_SELECT: {
        endTagInSelect(this, t);
        break;
      }
      case InsertionMode.IN_SELECT_IN_TABLE: {
        endTagInSelectInTable(this, t);
        break;
      }
      case InsertionMode.IN_TEMPLATE: {
        endTagInTemplate(this, t);
        break;
      }
      case InsertionMode.AFTER_BODY: {
        endTagAfterBody(this, t);
        break;
      }
      case InsertionMode.IN_FRAMESET: {
        endTagInFrameset(this, t);
        break;
      }
      case InsertionMode.AFTER_FRAMESET: {
        endTagAfterFrameset(this, t);
        break;
      }
      case InsertionMode.AFTER_AFTER_BODY: {
        tokenAfterAfterBody(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEof(t) {
    switch (this.insertionMode) {
      case InsertionMode.INITIAL: {
        tokenInInitialMode(this, t);
        break;
      }
      case InsertionMode.BEFORE_HTML: {
        tokenBeforeHtml(this, t);
        break;
      }
      case InsertionMode.BEFORE_HEAD: {
        tokenBeforeHead(this, t);
        break;
      }
      case InsertionMode.IN_HEAD: {
        tokenInHead(this, t);
        break;
      }
      case InsertionMode.IN_HEAD_NO_SCRIPT: {
        tokenInHeadNoScript(this, t);
        break;
      }
      case InsertionMode.AFTER_HEAD: {
        tokenAfterHead(this, t);
        break;
      }
      case InsertionMode.IN_BODY:
      case InsertionMode.IN_TABLE:
      case InsertionMode.IN_CAPTION:
      case InsertionMode.IN_COLUMN_GROUP:
      case InsertionMode.IN_TABLE_BODY:
      case InsertionMode.IN_ROW:
      case InsertionMode.IN_CELL:
      case InsertionMode.IN_SELECT:
      case InsertionMode.IN_SELECT_IN_TABLE: {
        eofInBody(this, t);
        break;
      }
      case InsertionMode.TEXT: {
        eofInText(this, t);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        tokenInTableText(this, t);
        break;
      }
      case InsertionMode.IN_TEMPLATE: {
        eofInTemplate(this, t);
        break;
      }
      case InsertionMode.AFTER_BODY:
      case InsertionMode.IN_FRAMESET:
      case InsertionMode.AFTER_FRAMESET:
      case InsertionMode.AFTER_AFTER_BODY:
      case InsertionMode.AFTER_AFTER_FRAMESET: {
        stopParsing(this, t);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(t) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, t.chars.charCodeAt(0) === CODE_POINTS.LINE_FEED)) {
      if (t.chars.length === 1)
        return;
      t.chars = t.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(t);
      return;
    }
    switch (this.insertionMode) {
      case InsertionMode.IN_HEAD:
      case InsertionMode.IN_HEAD_NO_SCRIPT:
      case InsertionMode.AFTER_HEAD:
      case InsertionMode.TEXT:
      case InsertionMode.IN_COLUMN_GROUP:
      case InsertionMode.IN_SELECT:
      case InsertionMode.IN_SELECT_IN_TABLE:
      case InsertionMode.IN_FRAMESET:
      case InsertionMode.AFTER_FRAMESET: {
        this._insertCharacters(t);
        break;
      }
      case InsertionMode.IN_BODY:
      case InsertionMode.IN_CAPTION:
      case InsertionMode.IN_CELL:
      case InsertionMode.IN_TEMPLATE:
      case InsertionMode.AFTER_BODY:
      case InsertionMode.AFTER_AFTER_BODY:
      case InsertionMode.AFTER_AFTER_FRAMESET: {
        whitespaceCharacterInBody(this, t);
        break;
      }
      case InsertionMode.IN_TABLE:
      case InsertionMode.IN_TABLE_BODY:
      case InsertionMode.IN_ROW: {
        characterInTable(this, t);
        break;
      }
      case InsertionMode.IN_TABLE_TEXT: {
        whitespaceCharacterInTableText(this, t);
        break;
      }
    }
  }
}
function aaObtainFormattingElementEntry(n, t) {
  let g = n.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return g ? n.openElements.contains(g.element) ? n.openElements.hasInScope(t.tagID) || (g = null) : (n.activeFormattingElements.removeEntry(g), g = null) : genericEndTagInBody(n, t), g;
}
function aaObtainFurthestBlock(n, t) {
  let g = null, d = n.openElements.stackTop;
  for (; d >= 0; d--) {
    const k = n.openElements.items[d];
    if (k === t.element)
      break;
    n._isSpecialElement(k, n.openElements.tagIDs[d]) && (g = k);
  }
  return g || (n.openElements.shortenToLength(Math.max(d, 0)), n.activeFormattingElements.removeEntry(t)), g;
}
function aaInnerLoop(n, t, g) {
  let d = t, k = n.openElements.getCommonAncestor(t);
  for (let H = 0, AA = k; AA !== g; H++, AA = k) {
    k = n.openElements.getCommonAncestor(AA);
    const gA = n.activeFormattingElements.getElementEntry(AA), IA = gA && H >= AA_INNER_LOOP_ITER;
    !gA || IA ? (IA && n.activeFormattingElements.removeEntry(gA), n.openElements.remove(AA)) : (AA = aaRecreateElementFromEntry(n, gA), d === t && (n.activeFormattingElements.bookmark = gA), n.treeAdapter.detachNode(d), n.treeAdapter.appendChild(AA, d), d = AA);
  }
  return d;
}
function aaRecreateElementFromEntry(n, t) {
  const g = n.treeAdapter.getNamespaceURI(t.element), d = n.treeAdapter.createElement(t.token.tagName, g, t.token.attrs);
  return n.openElements.replace(t.element, d), t.element = d, d;
}
function aaInsertLastNodeInCommonAncestor(n, t, g) {
  const d = n.treeAdapter.getTagName(t), k = getTagID(d);
  if (n._isElementCausesFosterParenting(k))
    n._fosterParentElement(g);
  else {
    const H = n.treeAdapter.getNamespaceURI(t);
    k === TAG_ID.TEMPLATE && H === NS.HTML && (t = n.treeAdapter.getTemplateContent(t)), n.treeAdapter.appendChild(t, g);
  }
}
function aaReplaceFormattingElement(n, t, g) {
  const d = n.treeAdapter.getNamespaceURI(g.element), { token: k } = g, H = n.treeAdapter.createElement(k.tagName, d, k.attrs);
  n._adoptNodes(t, H), n.treeAdapter.appendChild(t, H), n.activeFormattingElements.insertElementAfterBookmark(H, k), n.activeFormattingElements.removeEntry(g), n.openElements.remove(g.element), n.openElements.insertAfter(t, H, k.tagID);
}
function callAdoptionAgency(n, t) {
  for (let g = 0; g < AA_OUTER_LOOP_ITER; g++) {
    const d = aaObtainFormattingElementEntry(n, t);
    if (!d)
      break;
    const k = aaObtainFurthestBlock(n, d);
    if (!k)
      break;
    n.activeFormattingElements.bookmark = d;
    const H = aaInnerLoop(n, k, d.element), AA = n.openElements.getCommonAncestor(d.element);
    n.treeAdapter.detachNode(H), AA && aaInsertLastNodeInCommonAncestor(n, AA, H), aaReplaceFormattingElement(n, k, d);
  }
}
function appendComment(n, t) {
  n._appendCommentNode(t, n.openElements.currentTmplContentOrNode);
}
function appendCommentToRootHtmlElement(n, t) {
  n._appendCommentNode(t, n.openElements.items[0]);
}
function appendCommentToDocument(n, t) {
  n._appendCommentNode(t, n.document);
}
function stopParsing(n, t) {
  if (n.stopped = !0, t.location) {
    const g = n.fragmentContext ? 0 : 2;
    for (let d = n.openElements.stackTop; d >= g; d--)
      n._setEndLocation(n.openElements.items[d], t);
    if (!n.fragmentContext && n.openElements.stackTop >= 0) {
      const d = n.openElements.items[0], k = n.treeAdapter.getNodeSourceCodeLocation(d);
      if (k && !k.endTag && (n._setEndLocation(d, t), n.openElements.stackTop >= 1)) {
        const H = n.openElements.items[1], AA = n.treeAdapter.getNodeSourceCodeLocation(H);
        AA && !AA.endTag && n._setEndLocation(H, t);
      }
    }
  }
}
function doctypeInInitialMode(n, t) {
  n._setDocumentType(t);
  const g = t.forceQuirks ? DOCUMENT_MODE.QUIRKS : getDocumentMode(t);
  isConforming(t) || n._err(t, ERR.nonConformingDoctype), n.treeAdapter.setDocumentMode(n.document, g), n.insertionMode = InsertionMode.BEFORE_HTML;
}
function tokenInInitialMode(n, t) {
  n._err(t, ERR.missingDoctype, !0), n.treeAdapter.setDocumentMode(n.document, DOCUMENT_MODE.QUIRKS), n.insertionMode = InsertionMode.BEFORE_HTML, n._processToken(t);
}
function startTagBeforeHtml(n, t) {
  t.tagID === TAG_ID.HTML ? (n._insertElement(t, NS.HTML), n.insertionMode = InsertionMode.BEFORE_HEAD) : tokenBeforeHtml(n, t);
}
function endTagBeforeHtml(n, t) {
  const g = t.tagID;
  (g === TAG_ID.HTML || g === TAG_ID.HEAD || g === TAG_ID.BODY || g === TAG_ID.BR) && tokenBeforeHtml(n, t);
}
function tokenBeforeHtml(n, t) {
  n._insertFakeRootElement(), n.insertionMode = InsertionMode.BEFORE_HEAD, n._processToken(t);
}
function startTagBeforeHead(n, t) {
  switch (t.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(n, t);
      break;
    }
    case TAG_ID.HEAD: {
      n._insertElement(t, NS.HTML), n.headElement = n.openElements.current, n.insertionMode = InsertionMode.IN_HEAD;
      break;
    }
    default:
      tokenBeforeHead(n, t);
  }
}
function endTagBeforeHead(n, t) {
  const g = t.tagID;
  g === TAG_ID.HEAD || g === TAG_ID.BODY || g === TAG_ID.HTML || g === TAG_ID.BR ? tokenBeforeHead(n, t) : n._err(t, ERR.endTagWithoutMatchingOpenElement);
}
function tokenBeforeHead(n, t) {
  n._insertFakeElement(TAG_NAMES.HEAD, TAG_ID.HEAD), n.headElement = n.openElements.current, n.insertionMode = InsertionMode.IN_HEAD, n._processToken(t);
}
function startTagInHead(n, t) {
  switch (t.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(n, t);
      break;
    }
    case TAG_ID.BASE:
    case TAG_ID.BASEFONT:
    case TAG_ID.BGSOUND:
    case TAG_ID.LINK:
    case TAG_ID.META: {
      n._appendElement(t, NS.HTML), t.ackSelfClosing = !0;
      break;
    }
    case TAG_ID.TITLE: {
      n._switchToTextParsing(t, TokenizerMode.RCDATA);
      break;
    }
    case TAG_ID.NOSCRIPT: {
      n.options.scriptingEnabled ? n._switchToTextParsing(t, TokenizerMode.RAWTEXT) : (n._insertElement(t, NS.HTML), n.insertionMode = InsertionMode.IN_HEAD_NO_SCRIPT);
      break;
    }
    case TAG_ID.NOFRAMES:
    case TAG_ID.STYLE: {
      n._switchToTextParsing(t, TokenizerMode.RAWTEXT);
      break;
    }
    case TAG_ID.SCRIPT: {
      n._switchToTextParsing(t, TokenizerMode.SCRIPT_DATA);
      break;
    }
    case TAG_ID.TEMPLATE: {
      n._insertTemplate(t), n.activeFormattingElements.insertMarker(), n.framesetOk = !1, n.insertionMode = InsertionMode.IN_TEMPLATE, n.tmplInsertionModeStack.unshift(InsertionMode.IN_TEMPLATE);
      break;
    }
    case TAG_ID.HEAD: {
      n._err(t, ERR.misplacedStartTagForHeadElement);
      break;
    }
    default:
      tokenInHead(n, t);
  }
}
function endTagInHead(n, t) {
  switch (t.tagID) {
    case TAG_ID.HEAD: {
      n.openElements.pop(), n.insertionMode = InsertionMode.AFTER_HEAD;
      break;
    }
    case TAG_ID.BODY:
    case TAG_ID.BR:
    case TAG_ID.HTML: {
      tokenInHead(n, t);
      break;
    }
    case TAG_ID.TEMPLATE: {
      templateEndTagInHead(n, t);
      break;
    }
    default:
      n._err(t, ERR.endTagWithoutMatchingOpenElement);
  }
}
function templateEndTagInHead(n, t) {
  n.openElements.tmplCount > 0 ? (n.openElements.generateImpliedEndTagsThoroughly(), n.openElements.currentTagId !== TAG_ID.TEMPLATE && n._err(t, ERR.closingOfElementWithOpenChildElements), n.openElements.popUntilTagNamePopped(TAG_ID.TEMPLATE), n.activeFormattingElements.clearToLastMarker(), n.tmplInsertionModeStack.shift(), n._resetInsertionMode()) : n._err(t, ERR.endTagWithoutMatchingOpenElement);
}
function tokenInHead(n, t) {
  n.openElements.pop(), n.insertionMode = InsertionMode.AFTER_HEAD, n._processToken(t);
}
function startTagInHeadNoScript(n, t) {
  switch (t.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(n, t);
      break;
    }
    case TAG_ID.BASEFONT:
    case TAG_ID.BGSOUND:
    case TAG_ID.HEAD:
    case TAG_ID.LINK:
    case TAG_ID.META:
    case TAG_ID.NOFRAMES:
    case TAG_ID.STYLE: {
      startTagInHead(n, t);
      break;
    }
    case TAG_ID.NOSCRIPT: {
      n._err(t, ERR.nestedNoscriptInHead);
      break;
    }
    default:
      tokenInHeadNoScript(n, t);
  }
}
function endTagInHeadNoScript(n, t) {
  switch (t.tagID) {
    case TAG_ID.NOSCRIPT: {
      n.openElements.pop(), n.insertionMode = InsertionMode.IN_HEAD;
      break;
    }
    case TAG_ID.BR: {
      tokenInHeadNoScript(n, t);
      break;
    }
    default:
      n._err(t, ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenInHeadNoScript(n, t) {
  const g = t.type === TokenType.EOF ? ERR.openElementsLeftAfterEof : ERR.disallowedContentInNoscriptInHead;
  n._err(t, g), n.openElements.pop(), n.insertionMode = InsertionMode.IN_HEAD, n._processToken(t);
}
function startTagAfterHead(n, t) {
  switch (t.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(n, t);
      break;
    }
    case TAG_ID.BODY: {
      n._insertElement(t, NS.HTML), n.framesetOk = !1, n.insertionMode = InsertionMode.IN_BODY;
      break;
    }
    case TAG_ID.FRAMESET: {
      n._insertElement(t, NS.HTML), n.insertionMode = InsertionMode.IN_FRAMESET;
      break;
    }
    case TAG_ID.BASE:
    case TAG_ID.BASEFONT:
    case TAG_ID.BGSOUND:
    case TAG_ID.LINK:
    case TAG_ID.META:
    case TAG_ID.NOFRAMES:
    case TAG_ID.SCRIPT:
    case TAG_ID.STYLE:
    case TAG_ID.TEMPLATE:
    case TAG_ID.TITLE: {
      n._err(t, ERR.abandonedHeadElementChild), n.openElements.push(n.headElement, TAG_ID.HEAD), startTagInHead(n, t), n.openElements.remove(n.headElement);
      break;
    }
    case TAG_ID.HEAD: {
      n._err(t, ERR.misplacedStartTagForHeadElement);
      break;
    }
    default:
      tokenAfterHead(n, t);
  }
}
function endTagAfterHead(n, t) {
  switch (t.tagID) {
    case TAG_ID.BODY:
    case TAG_ID.HTML:
    case TAG_ID.BR: {
      tokenAfterHead(n, t);
      break;
    }
    case TAG_ID.TEMPLATE: {
      templateEndTagInHead(n, t);
      break;
    }
    default:
      n._err(t, ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenAfterHead(n, t) {
  n._insertFakeElement(TAG_NAMES.BODY, TAG_ID.BODY), n.insertionMode = InsertionMode.IN_BODY, modeInBody(n, t);
}
function modeInBody(n, t) {
  switch (t.type) {
    case TokenType.CHARACTER: {
      characterInBody(n, t);
      break;
    }
    case TokenType.WHITESPACE_CHARACTER: {
      whitespaceCharacterInBody(n, t);
      break;
    }
    case TokenType.COMMENT: {
      appendComment(n, t);
      break;
    }
    case TokenType.START_TAG: {
      startTagInBody(n, t);
      break;
    }
    case TokenType.END_TAG: {
      endTagInBody(n, t);
      break;
    }
    case TokenType.EOF: {
      eofInBody(n, t);
      break;
    }
  }
}
function whitespaceCharacterInBody(n, t) {
  n._reconstructActiveFormattingElements(), n._insertCharacters(t);
}
function characterInBody(n, t) {
  n._reconstructActiveFormattingElements(), n._insertCharacters(t), n.framesetOk = !1;
}
function htmlStartTagInBody(n, t) {
  n.openElements.tmplCount === 0 && n.treeAdapter.adoptAttributes(n.openElements.items[0], t.attrs);
}
function bodyStartTagInBody(n, t) {
  const g = n.openElements.tryPeekProperlyNestedBodyElement();
  g && n.openElements.tmplCount === 0 && (n.framesetOk = !1, n.treeAdapter.adoptAttributes(g, t.attrs));
}
function framesetStartTagInBody(n, t) {
  const g = n.openElements.tryPeekProperlyNestedBodyElement();
  n.framesetOk && g && (n.treeAdapter.detachNode(g), n.openElements.popAllUpToHtmlElement(), n._insertElement(t, NS.HTML), n.insertionMode = InsertionMode.IN_FRAMESET);
}
function addressStartTagInBody(n, t) {
  n.openElements.hasInButtonScope(TAG_ID.P) && n._closePElement(), n._insertElement(t, NS.HTML);
}
function numberedHeaderStartTagInBody(n, t) {
  n.openElements.hasInButtonScope(TAG_ID.P) && n._closePElement(), n.openElements.currentTagId !== void 0 && NUMBERED_HEADERS.has(n.openElements.currentTagId) && n.openElements.pop(), n._insertElement(t, NS.HTML);
}
function preStartTagInBody(n, t) {
  n.openElements.hasInButtonScope(TAG_ID.P) && n._closePElement(), n._insertElement(t, NS.HTML), n.skipNextNewLine = !0, n.framesetOk = !1;
}
function formStartTagInBody(n, t) {
  const g = n.openElements.tmplCount > 0;
  (!n.formElement || g) && (n.openElements.hasInButtonScope(TAG_ID.P) && n._closePElement(), n._insertElement(t, NS.HTML), g || (n.formElement = n.openElements.current));
}
function listItemStartTagInBody(n, t) {
  n.framesetOk = !1;
  const g = t.tagID;
  for (let d = n.openElements.stackTop; d >= 0; d--) {
    const k = n.openElements.tagIDs[d];
    if (g === TAG_ID.LI && k === TAG_ID.LI || (g === TAG_ID.DD || g === TAG_ID.DT) && (k === TAG_ID.DD || k === TAG_ID.DT)) {
      n.openElements.generateImpliedEndTagsWithExclusion(k), n.openElements.popUntilTagNamePopped(k);
      break;
    }
    if (k !== TAG_ID.ADDRESS && k !== TAG_ID.DIV && k !== TAG_ID.P && n._isSpecialElement(n.openElements.items[d], k))
      break;
  }
  n.openElements.hasInButtonScope(TAG_ID.P) && n._closePElement(), n._insertElement(t, NS.HTML);
}
function plaintextStartTagInBody(n, t) {
  n.openElements.hasInButtonScope(TAG_ID.P) && n._closePElement(), n._insertElement(t, NS.HTML), n.tokenizer.state = TokenizerMode.PLAINTEXT;
}
function buttonStartTagInBody(n, t) {
  n.openElements.hasInScope(TAG_ID.BUTTON) && (n.openElements.generateImpliedEndTags(), n.openElements.popUntilTagNamePopped(TAG_ID.BUTTON)), n._reconstructActiveFormattingElements(), n._insertElement(t, NS.HTML), n.framesetOk = !1;
}
function aStartTagInBody(n, t) {
  const g = n.activeFormattingElements.getElementEntryInScopeWithTagName(TAG_NAMES.A);
  g && (callAdoptionAgency(n, t), n.openElements.remove(g.element), n.activeFormattingElements.removeEntry(g)), n._reconstructActiveFormattingElements(), n._insertElement(t, NS.HTML), n.activeFormattingElements.pushElement(n.openElements.current, t);
}
function bStartTagInBody(n, t) {
  n._reconstructActiveFormattingElements(), n._insertElement(t, NS.HTML), n.activeFormattingElements.pushElement(n.openElements.current, t);
}
function nobrStartTagInBody(n, t) {
  n._reconstructActiveFormattingElements(), n.openElements.hasInScope(TAG_ID.NOBR) && (callAdoptionAgency(n, t), n._reconstructActiveFormattingElements()), n._insertElement(t, NS.HTML), n.activeFormattingElements.pushElement(n.openElements.current, t);
}
function appletStartTagInBody(n, t) {
  n._reconstructActiveFormattingElements(), n._insertElement(t, NS.HTML), n.activeFormattingElements.insertMarker(), n.framesetOk = !1;
}
function tableStartTagInBody(n, t) {
  n.treeAdapter.getDocumentMode(n.document) !== DOCUMENT_MODE.QUIRKS && n.openElements.hasInButtonScope(TAG_ID.P) && n._closePElement(), n._insertElement(t, NS.HTML), n.framesetOk = !1, n.insertionMode = InsertionMode.IN_TABLE;
}
function areaStartTagInBody(n, t) {
  n._reconstructActiveFormattingElements(), n._appendElement(t, NS.HTML), n.framesetOk = !1, t.ackSelfClosing = !0;
}
function isHiddenInput(n) {
  const t = getTokenAttr(n, ATTRS.TYPE);
  return t != null && t.toLowerCase() === HIDDEN_INPUT_TYPE;
}
function inputStartTagInBody(n, t) {
  n._reconstructActiveFormattingElements(), n._appendElement(t, NS.HTML), isHiddenInput(t) || (n.framesetOk = !1), t.ackSelfClosing = !0;
}
function paramStartTagInBody(n, t) {
  n._appendElement(t, NS.HTML), t.ackSelfClosing = !0;
}
function hrStartTagInBody(n, t) {
  n.openElements.hasInButtonScope(TAG_ID.P) && n._closePElement(), n._appendElement(t, NS.HTML), n.framesetOk = !1, t.ackSelfClosing = !0;
}
function imageStartTagInBody(n, t) {
  t.tagName = TAG_NAMES.IMG, t.tagID = TAG_ID.IMG, areaStartTagInBody(n, t);
}
function textareaStartTagInBody(n, t) {
  n._insertElement(t, NS.HTML), n.skipNextNewLine = !0, n.tokenizer.state = TokenizerMode.RCDATA, n.originalInsertionMode = n.insertionMode, n.framesetOk = !1, n.insertionMode = InsertionMode.TEXT;
}
function xmpStartTagInBody(n, t) {
  n.openElements.hasInButtonScope(TAG_ID.P) && n._closePElement(), n._reconstructActiveFormattingElements(), n.framesetOk = !1, n._switchToTextParsing(t, TokenizerMode.RAWTEXT);
}
function iframeStartTagInBody(n, t) {
  n.framesetOk = !1, n._switchToTextParsing(t, TokenizerMode.RAWTEXT);
}
function rawTextStartTagInBody(n, t) {
  n._switchToTextParsing(t, TokenizerMode.RAWTEXT);
}
function selectStartTagInBody(n, t) {
  n._reconstructActiveFormattingElements(), n._insertElement(t, NS.HTML), n.framesetOk = !1, n.insertionMode = n.insertionMode === InsertionMode.IN_TABLE || n.insertionMode === InsertionMode.IN_CAPTION || n.insertionMode === InsertionMode.IN_TABLE_BODY || n.insertionMode === InsertionMode.IN_ROW || n.insertionMode === InsertionMode.IN_CELL ? InsertionMode.IN_SELECT_IN_TABLE : InsertionMode.IN_SELECT;
}
function optgroupStartTagInBody(n, t) {
  n.openElements.currentTagId === TAG_ID.OPTION && n.openElements.pop(), n._reconstructActiveFormattingElements(), n._insertElement(t, NS.HTML);
}
function rbStartTagInBody(n, t) {
  n.openElements.hasInScope(TAG_ID.RUBY) && n.openElements.generateImpliedEndTags(), n._insertElement(t, NS.HTML);
}
function rtStartTagInBody(n, t) {
  n.openElements.hasInScope(TAG_ID.RUBY) && n.openElements.generateImpliedEndTagsWithExclusion(TAG_ID.RTC), n._insertElement(t, NS.HTML);
}
function mathStartTagInBody(n, t) {
  n._reconstructActiveFormattingElements(), adjustTokenMathMLAttrs(t), adjustTokenXMLAttrs(t), t.selfClosing ? n._appendElement(t, NS.MATHML) : n._insertElement(t, NS.MATHML), t.ackSelfClosing = !0;
}
function svgStartTagInBody(n, t) {
  n._reconstructActiveFormattingElements(), adjustTokenSVGAttrs(t), adjustTokenXMLAttrs(t), t.selfClosing ? n._appendElement(t, NS.SVG) : n._insertElement(t, NS.SVG), t.ackSelfClosing = !0;
}
function genericStartTagInBody(n, t) {
  n._reconstructActiveFormattingElements(), n._insertElement(t, NS.HTML);
}
function startTagInBody(n, t) {
  switch (t.tagID) {
    case TAG_ID.I:
    case TAG_ID.S:
    case TAG_ID.B:
    case TAG_ID.U:
    case TAG_ID.EM:
    case TAG_ID.TT:
    case TAG_ID.BIG:
    case TAG_ID.CODE:
    case TAG_ID.FONT:
    case TAG_ID.SMALL:
    case TAG_ID.STRIKE:
    case TAG_ID.STRONG: {
      bStartTagInBody(n, t);
      break;
    }
    case TAG_ID.A: {
      aStartTagInBody(n, t);
      break;
    }
    case TAG_ID.H1:
    case TAG_ID.H2:
    case TAG_ID.H3:
    case TAG_ID.H4:
    case TAG_ID.H5:
    case TAG_ID.H6: {
      numberedHeaderStartTagInBody(n, t);
      break;
    }
    case TAG_ID.P:
    case TAG_ID.DL:
    case TAG_ID.OL:
    case TAG_ID.UL:
    case TAG_ID.DIV:
    case TAG_ID.DIR:
    case TAG_ID.NAV:
    case TAG_ID.MAIN:
    case TAG_ID.MENU:
    case TAG_ID.ASIDE:
    case TAG_ID.CENTER:
    case TAG_ID.FIGURE:
    case TAG_ID.FOOTER:
    case TAG_ID.HEADER:
    case TAG_ID.HGROUP:
    case TAG_ID.DIALOG:
    case TAG_ID.DETAILS:
    case TAG_ID.ADDRESS:
    case TAG_ID.ARTICLE:
    case TAG_ID.SEARCH:
    case TAG_ID.SECTION:
    case TAG_ID.SUMMARY:
    case TAG_ID.FIELDSET:
    case TAG_ID.BLOCKQUOTE:
    case TAG_ID.FIGCAPTION: {
      addressStartTagInBody(n, t);
      break;
    }
    case TAG_ID.LI:
    case TAG_ID.DD:
    case TAG_ID.DT: {
      listItemStartTagInBody(n, t);
      break;
    }
    case TAG_ID.BR:
    case TAG_ID.IMG:
    case TAG_ID.WBR:
    case TAG_ID.AREA:
    case TAG_ID.EMBED:
    case TAG_ID.KEYGEN: {
      areaStartTagInBody(n, t);
      break;
    }
    case TAG_ID.HR: {
      hrStartTagInBody(n, t);
      break;
    }
    case TAG_ID.RB:
    case TAG_ID.RTC: {
      rbStartTagInBody(n, t);
      break;
    }
    case TAG_ID.RT:
    case TAG_ID.RP: {
      rtStartTagInBody(n, t);
      break;
    }
    case TAG_ID.PRE:
    case TAG_ID.LISTING: {
      preStartTagInBody(n, t);
      break;
    }
    case TAG_ID.XMP: {
      xmpStartTagInBody(n, t);
      break;
    }
    case TAG_ID.SVG: {
      svgStartTagInBody(n, t);
      break;
    }
    case TAG_ID.HTML: {
      htmlStartTagInBody(n, t);
      break;
    }
    case TAG_ID.BASE:
    case TAG_ID.LINK:
    case TAG_ID.META:
    case TAG_ID.STYLE:
    case TAG_ID.TITLE:
    case TAG_ID.SCRIPT:
    case TAG_ID.BGSOUND:
    case TAG_ID.BASEFONT:
    case TAG_ID.TEMPLATE: {
      startTagInHead(n, t);
      break;
    }
    case TAG_ID.BODY: {
      bodyStartTagInBody(n, t);
      break;
    }
    case TAG_ID.FORM: {
      formStartTagInBody(n, t);
      break;
    }
    case TAG_ID.NOBR: {
      nobrStartTagInBody(n, t);
      break;
    }
    case TAG_ID.MATH: {
      mathStartTagInBody(n, t);
      break;
    }
    case TAG_ID.TABLE: {
      tableStartTagInBody(n, t);
      break;
    }
    case TAG_ID.INPUT: {
      inputStartTagInBody(n, t);
      break;
    }
    case TAG_ID.PARAM:
    case TAG_ID.TRACK:
    case TAG_ID.SOURCE: {
      paramStartTagInBody(n, t);
      break;
    }
    case TAG_ID.IMAGE: {
      imageStartTagInBody(n, t);
      break;
    }
    case TAG_ID.BUTTON: {
      buttonStartTagInBody(n, t);
      break;
    }
    case TAG_ID.APPLET:
    case TAG_ID.OBJECT:
    case TAG_ID.MARQUEE: {
      appletStartTagInBody(n, t);
      break;
    }
    case TAG_ID.IFRAME: {
      iframeStartTagInBody(n, t);
      break;
    }
    case TAG_ID.SELECT: {
      selectStartTagInBody(n, t);
      break;
    }
    case TAG_ID.OPTION:
    case TAG_ID.OPTGROUP: {
      optgroupStartTagInBody(n, t);
      break;
    }
    case TAG_ID.NOEMBED:
    case TAG_ID.NOFRAMES: {
      rawTextStartTagInBody(n, t);
      break;
    }
    case TAG_ID.FRAMESET: {
      framesetStartTagInBody(n, t);
      break;
    }
    case TAG_ID.TEXTAREA: {
      textareaStartTagInBody(n, t);
      break;
    }
    case TAG_ID.NOSCRIPT: {
      n.options.scriptingEnabled ? rawTextStartTagInBody(n, t) : genericStartTagInBody(n, t);
      break;
    }
    case TAG_ID.PLAINTEXT: {
      plaintextStartTagInBody(n, t);
      break;
    }
    case TAG_ID.COL:
    case TAG_ID.TH:
    case TAG_ID.TD:
    case TAG_ID.TR:
    case TAG_ID.HEAD:
    case TAG_ID.FRAME:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
    case TAG_ID.CAPTION:
    case TAG_ID.COLGROUP:
      break;
    default:
      genericStartTagInBody(n, t);
  }
}
function bodyEndTagInBody(n, t) {
  if (n.openElements.hasInScope(TAG_ID.BODY) && (n.insertionMode = InsertionMode.AFTER_BODY, n.options.sourceCodeLocationInfo)) {
    const g = n.openElements.tryPeekProperlyNestedBodyElement();
    g && n._setEndLocation(g, t);
  }
}
function htmlEndTagInBody(n, t) {
  n.openElements.hasInScope(TAG_ID.BODY) && (n.insertionMode = InsertionMode.AFTER_BODY, endTagAfterBody(n, t));
}
function addressEndTagInBody(n, t) {
  const g = t.tagID;
  n.openElements.hasInScope(g) && (n.openElements.generateImpliedEndTags(), n.openElements.popUntilTagNamePopped(g));
}
function formEndTagInBody(n) {
  const t = n.openElements.tmplCount > 0, { formElement: g } = n;
  t || (n.formElement = null), (g || t) && n.openElements.hasInScope(TAG_ID.FORM) && (n.openElements.generateImpliedEndTags(), t ? n.openElements.popUntilTagNamePopped(TAG_ID.FORM) : g && n.openElements.remove(g));
}
function pEndTagInBody(n) {
  n.openElements.hasInButtonScope(TAG_ID.P) || n._insertFakeElement(TAG_NAMES.P, TAG_ID.P), n._closePElement();
}
function liEndTagInBody(n) {
  n.openElements.hasInListItemScope(TAG_ID.LI) && (n.openElements.generateImpliedEndTagsWithExclusion(TAG_ID.LI), n.openElements.popUntilTagNamePopped(TAG_ID.LI));
}
function ddEndTagInBody(n, t) {
  const g = t.tagID;
  n.openElements.hasInScope(g) && (n.openElements.generateImpliedEndTagsWithExclusion(g), n.openElements.popUntilTagNamePopped(g));
}
function numberedHeaderEndTagInBody(n) {
  n.openElements.hasNumberedHeaderInScope() && (n.openElements.generateImpliedEndTags(), n.openElements.popUntilNumberedHeaderPopped());
}
function appletEndTagInBody(n, t) {
  const g = t.tagID;
  n.openElements.hasInScope(g) && (n.openElements.generateImpliedEndTags(), n.openElements.popUntilTagNamePopped(g), n.activeFormattingElements.clearToLastMarker());
}
function brEndTagInBody(n) {
  n._reconstructActiveFormattingElements(), n._insertFakeElement(TAG_NAMES.BR, TAG_ID.BR), n.openElements.pop(), n.framesetOk = !1;
}
function genericEndTagInBody(n, t) {
  const g = t.tagName, d = t.tagID;
  for (let k = n.openElements.stackTop; k > 0; k--) {
    const H = n.openElements.items[k], AA = n.openElements.tagIDs[k];
    if (d === AA && (d !== TAG_ID.UNKNOWN || n.treeAdapter.getTagName(H) === g)) {
      n.openElements.generateImpliedEndTagsWithExclusion(d), n.openElements.stackTop >= k && n.openElements.shortenToLength(k);
      break;
    }
    if (n._isSpecialElement(H, AA))
      break;
  }
}
function endTagInBody(n, t) {
  switch (t.tagID) {
    case TAG_ID.A:
    case TAG_ID.B:
    case TAG_ID.I:
    case TAG_ID.S:
    case TAG_ID.U:
    case TAG_ID.EM:
    case TAG_ID.TT:
    case TAG_ID.BIG:
    case TAG_ID.CODE:
    case TAG_ID.FONT:
    case TAG_ID.NOBR:
    case TAG_ID.SMALL:
    case TAG_ID.STRIKE:
    case TAG_ID.STRONG: {
      callAdoptionAgency(n, t);
      break;
    }
    case TAG_ID.P: {
      pEndTagInBody(n);
      break;
    }
    case TAG_ID.DL:
    case TAG_ID.UL:
    case TAG_ID.OL:
    case TAG_ID.DIR:
    case TAG_ID.DIV:
    case TAG_ID.NAV:
    case TAG_ID.PRE:
    case TAG_ID.MAIN:
    case TAG_ID.MENU:
    case TAG_ID.ASIDE:
    case TAG_ID.BUTTON:
    case TAG_ID.CENTER:
    case TAG_ID.FIGURE:
    case TAG_ID.FOOTER:
    case TAG_ID.HEADER:
    case TAG_ID.HGROUP:
    case TAG_ID.DIALOG:
    case TAG_ID.ADDRESS:
    case TAG_ID.ARTICLE:
    case TAG_ID.DETAILS:
    case TAG_ID.SEARCH:
    case TAG_ID.SECTION:
    case TAG_ID.SUMMARY:
    case TAG_ID.LISTING:
    case TAG_ID.FIELDSET:
    case TAG_ID.BLOCKQUOTE:
    case TAG_ID.FIGCAPTION: {
      addressEndTagInBody(n, t);
      break;
    }
    case TAG_ID.LI: {
      liEndTagInBody(n);
      break;
    }
    case TAG_ID.DD:
    case TAG_ID.DT: {
      ddEndTagInBody(n, t);
      break;
    }
    case TAG_ID.H1:
    case TAG_ID.H2:
    case TAG_ID.H3:
    case TAG_ID.H4:
    case TAG_ID.H5:
    case TAG_ID.H6: {
      numberedHeaderEndTagInBody(n);
      break;
    }
    case TAG_ID.BR: {
      brEndTagInBody(n);
      break;
    }
    case TAG_ID.BODY: {
      bodyEndTagInBody(n, t);
      break;
    }
    case TAG_ID.HTML: {
      htmlEndTagInBody(n, t);
      break;
    }
    case TAG_ID.FORM: {
      formEndTagInBody(n);
      break;
    }
    case TAG_ID.APPLET:
    case TAG_ID.OBJECT:
    case TAG_ID.MARQUEE: {
      appletEndTagInBody(n, t);
      break;
    }
    case TAG_ID.TEMPLATE: {
      templateEndTagInHead(n, t);
      break;
    }
    default:
      genericEndTagInBody(n, t);
  }
}
function eofInBody(n, t) {
  n.tmplInsertionModeStack.length > 0 ? eofInTemplate(n, t) : stopParsing(n, t);
}
function endTagInText(n, t) {
  var g;
  t.tagID === TAG_ID.SCRIPT && ((g = n.scriptHandler) === null || g === void 0 || g.call(n, n.openElements.current)), n.openElements.pop(), n.insertionMode = n.originalInsertionMode;
}
function eofInText(n, t) {
  n._err(t, ERR.eofInElementThatCanContainOnlyText), n.openElements.pop(), n.insertionMode = n.originalInsertionMode, n.onEof(t);
}
function characterInTable(n, t) {
  if (n.openElements.currentTagId !== void 0 && TABLE_STRUCTURE_TAGS.has(n.openElements.currentTagId))
    switch (n.pendingCharacterTokens.length = 0, n.hasNonWhitespacePendingCharacterToken = !1, n.originalInsertionMode = n.insertionMode, n.insertionMode = InsertionMode.IN_TABLE_TEXT, t.type) {
      case TokenType.CHARACTER: {
        characterInTableText(n, t);
        break;
      }
      case TokenType.WHITESPACE_CHARACTER: {
        whitespaceCharacterInTableText(n, t);
        break;
      }
    }
  else
    tokenInTable(n, t);
}
function captionStartTagInTable(n, t) {
  n.openElements.clearBackToTableContext(), n.activeFormattingElements.insertMarker(), n._insertElement(t, NS.HTML), n.insertionMode = InsertionMode.IN_CAPTION;
}
function colgroupStartTagInTable(n, t) {
  n.openElements.clearBackToTableContext(), n._insertElement(t, NS.HTML), n.insertionMode = InsertionMode.IN_COLUMN_GROUP;
}
function colStartTagInTable(n, t) {
  n.openElements.clearBackToTableContext(), n._insertFakeElement(TAG_NAMES.COLGROUP, TAG_ID.COLGROUP), n.insertionMode = InsertionMode.IN_COLUMN_GROUP, startTagInColumnGroup(n, t);
}
function tbodyStartTagInTable(n, t) {
  n.openElements.clearBackToTableContext(), n._insertElement(t, NS.HTML), n.insertionMode = InsertionMode.IN_TABLE_BODY;
}
function tdStartTagInTable(n, t) {
  n.openElements.clearBackToTableContext(), n._insertFakeElement(TAG_NAMES.TBODY, TAG_ID.TBODY), n.insertionMode = InsertionMode.IN_TABLE_BODY, startTagInTableBody(n, t);
}
function tableStartTagInTable(n, t) {
  n.openElements.hasInTableScope(TAG_ID.TABLE) && (n.openElements.popUntilTagNamePopped(TAG_ID.TABLE), n._resetInsertionMode(), n._processStartTag(t));
}
function inputStartTagInTable(n, t) {
  isHiddenInput(t) ? n._appendElement(t, NS.HTML) : tokenInTable(n, t), t.ackSelfClosing = !0;
}
function formStartTagInTable(n, t) {
  !n.formElement && n.openElements.tmplCount === 0 && (n._insertElement(t, NS.HTML), n.formElement = n.openElements.current, n.openElements.pop());
}
function startTagInTable(n, t) {
  switch (t.tagID) {
    case TAG_ID.TD:
    case TAG_ID.TH:
    case TAG_ID.TR: {
      tdStartTagInTable(n, t);
      break;
    }
    case TAG_ID.STYLE:
    case TAG_ID.SCRIPT:
    case TAG_ID.TEMPLATE: {
      startTagInHead(n, t);
      break;
    }
    case TAG_ID.COL: {
      colStartTagInTable(n, t);
      break;
    }
    case TAG_ID.FORM: {
      formStartTagInTable(n, t);
      break;
    }
    case TAG_ID.TABLE: {
      tableStartTagInTable(n, t);
      break;
    }
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD: {
      tbodyStartTagInTable(n, t);
      break;
    }
    case TAG_ID.INPUT: {
      inputStartTagInTable(n, t);
      break;
    }
    case TAG_ID.CAPTION: {
      captionStartTagInTable(n, t);
      break;
    }
    case TAG_ID.COLGROUP: {
      colgroupStartTagInTable(n, t);
      break;
    }
    default:
      tokenInTable(n, t);
  }
}
function endTagInTable(n, t) {
  switch (t.tagID) {
    case TAG_ID.TABLE: {
      n.openElements.hasInTableScope(TAG_ID.TABLE) && (n.openElements.popUntilTagNamePopped(TAG_ID.TABLE), n._resetInsertionMode());
      break;
    }
    case TAG_ID.TEMPLATE: {
      templateEndTagInHead(n, t);
      break;
    }
    case TAG_ID.BODY:
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
    case TAG_ID.TBODY:
    case TAG_ID.TD:
    case TAG_ID.TFOOT:
    case TAG_ID.TH:
    case TAG_ID.THEAD:
    case TAG_ID.TR:
      break;
    default:
      tokenInTable(n, t);
  }
}
function tokenInTable(n, t) {
  const g = n.fosterParentingEnabled;
  n.fosterParentingEnabled = !0, modeInBody(n, t), n.fosterParentingEnabled = g;
}
function whitespaceCharacterInTableText(n, t) {
  n.pendingCharacterTokens.push(t);
}
function characterInTableText(n, t) {
  n.pendingCharacterTokens.push(t), n.hasNonWhitespacePendingCharacterToken = !0;
}
function tokenInTableText(n, t) {
  let g = 0;
  if (n.hasNonWhitespacePendingCharacterToken)
    for (; g < n.pendingCharacterTokens.length; g++)
      tokenInTable(n, n.pendingCharacterTokens[g]);
  else
    for (; g < n.pendingCharacterTokens.length; g++)
      n._insertCharacters(n.pendingCharacterTokens[g]);
  n.insertionMode = n.originalInsertionMode, n._processToken(t);
}
const TABLE_VOID_ELEMENTS = /* @__PURE__ */ new Set([TAG_ID.CAPTION, TAG_ID.COL, TAG_ID.COLGROUP, TAG_ID.TBODY, TAG_ID.TD, TAG_ID.TFOOT, TAG_ID.TH, TAG_ID.THEAD, TAG_ID.TR]);
function startTagInCaption(n, t) {
  const g = t.tagID;
  TABLE_VOID_ELEMENTS.has(g) ? n.openElements.hasInTableScope(TAG_ID.CAPTION) && (n.openElements.generateImpliedEndTags(), n.openElements.popUntilTagNamePopped(TAG_ID.CAPTION), n.activeFormattingElements.clearToLastMarker(), n.insertionMode = InsertionMode.IN_TABLE, startTagInTable(n, t)) : startTagInBody(n, t);
}
function endTagInCaption(n, t) {
  const g = t.tagID;
  switch (g) {
    case TAG_ID.CAPTION:
    case TAG_ID.TABLE: {
      n.openElements.hasInTableScope(TAG_ID.CAPTION) && (n.openElements.generateImpliedEndTags(), n.openElements.popUntilTagNamePopped(TAG_ID.CAPTION), n.activeFormattingElements.clearToLastMarker(), n.insertionMode = InsertionMode.IN_TABLE, g === TAG_ID.TABLE && endTagInTable(n, t));
      break;
    }
    case TAG_ID.BODY:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
    case TAG_ID.TBODY:
    case TAG_ID.TD:
    case TAG_ID.TFOOT:
    case TAG_ID.TH:
    case TAG_ID.THEAD:
    case TAG_ID.TR:
      break;
    default:
      endTagInBody(n, t);
  }
}
function startTagInColumnGroup(n, t) {
  switch (t.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(n, t);
      break;
    }
    case TAG_ID.COL: {
      n._appendElement(t, NS.HTML), t.ackSelfClosing = !0;
      break;
    }
    case TAG_ID.TEMPLATE: {
      startTagInHead(n, t);
      break;
    }
    default:
      tokenInColumnGroup(n, t);
  }
}
function endTagInColumnGroup(n, t) {
  switch (t.tagID) {
    case TAG_ID.COLGROUP: {
      n.openElements.currentTagId === TAG_ID.COLGROUP && (n.openElements.pop(), n.insertionMode = InsertionMode.IN_TABLE);
      break;
    }
    case TAG_ID.TEMPLATE: {
      templateEndTagInHead(n, t);
      break;
    }
    case TAG_ID.COL:
      break;
    default:
      tokenInColumnGroup(n, t);
  }
}
function tokenInColumnGroup(n, t) {
  n.openElements.currentTagId === TAG_ID.COLGROUP && (n.openElements.pop(), n.insertionMode = InsertionMode.IN_TABLE, n._processToken(t));
}
function startTagInTableBody(n, t) {
  switch (t.tagID) {
    case TAG_ID.TR: {
      n.openElements.clearBackToTableBodyContext(), n._insertElement(t, NS.HTML), n.insertionMode = InsertionMode.IN_ROW;
      break;
    }
    case TAG_ID.TH:
    case TAG_ID.TD: {
      n.openElements.clearBackToTableBodyContext(), n._insertFakeElement(TAG_NAMES.TR, TAG_ID.TR), n.insertionMode = InsertionMode.IN_ROW, startTagInRow(n, t);
      break;
    }
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD: {
      n.openElements.hasTableBodyContextInTableScope() && (n.openElements.clearBackToTableBodyContext(), n.openElements.pop(), n.insertionMode = InsertionMode.IN_TABLE, startTagInTable(n, t));
      break;
    }
    default:
      startTagInTable(n, t);
  }
}
function endTagInTableBody(n, t) {
  const g = t.tagID;
  switch (t.tagID) {
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD: {
      n.openElements.hasInTableScope(g) && (n.openElements.clearBackToTableBodyContext(), n.openElements.pop(), n.insertionMode = InsertionMode.IN_TABLE);
      break;
    }
    case TAG_ID.TABLE: {
      n.openElements.hasTableBodyContextInTableScope() && (n.openElements.clearBackToTableBodyContext(), n.openElements.pop(), n.insertionMode = InsertionMode.IN_TABLE, endTagInTable(n, t));
      break;
    }
    case TAG_ID.BODY:
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
    case TAG_ID.TD:
    case TAG_ID.TH:
    case TAG_ID.TR:
      break;
    default:
      endTagInTable(n, t);
  }
}
function startTagInRow(n, t) {
  switch (t.tagID) {
    case TAG_ID.TH:
    case TAG_ID.TD: {
      n.openElements.clearBackToTableRowContext(), n._insertElement(t, NS.HTML), n.insertionMode = InsertionMode.IN_CELL, n.activeFormattingElements.insertMarker();
      break;
    }
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
    case TAG_ID.TR: {
      n.openElements.hasInTableScope(TAG_ID.TR) && (n.openElements.clearBackToTableRowContext(), n.openElements.pop(), n.insertionMode = InsertionMode.IN_TABLE_BODY, startTagInTableBody(n, t));
      break;
    }
    default:
      startTagInTable(n, t);
  }
}
function endTagInRow(n, t) {
  switch (t.tagID) {
    case TAG_ID.TR: {
      n.openElements.hasInTableScope(TAG_ID.TR) && (n.openElements.clearBackToTableRowContext(), n.openElements.pop(), n.insertionMode = InsertionMode.IN_TABLE_BODY);
      break;
    }
    case TAG_ID.TABLE: {
      n.openElements.hasInTableScope(TAG_ID.TR) && (n.openElements.clearBackToTableRowContext(), n.openElements.pop(), n.insertionMode = InsertionMode.IN_TABLE_BODY, endTagInTableBody(n, t));
      break;
    }
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD: {
      (n.openElements.hasInTableScope(t.tagID) || n.openElements.hasInTableScope(TAG_ID.TR)) && (n.openElements.clearBackToTableRowContext(), n.openElements.pop(), n.insertionMode = InsertionMode.IN_TABLE_BODY, endTagInTableBody(n, t));
      break;
    }
    case TAG_ID.BODY:
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
    case TAG_ID.TD:
    case TAG_ID.TH:
      break;
    default:
      endTagInTable(n, t);
  }
}
function startTagInCell(n, t) {
  const g = t.tagID;
  TABLE_VOID_ELEMENTS.has(g) ? (n.openElements.hasInTableScope(TAG_ID.TD) || n.openElements.hasInTableScope(TAG_ID.TH)) && (n._closeTableCell(), startTagInRow(n, t)) : startTagInBody(n, t);
}
function endTagInCell(n, t) {
  const g = t.tagID;
  switch (g) {
    case TAG_ID.TD:
    case TAG_ID.TH: {
      n.openElements.hasInTableScope(g) && (n.openElements.generateImpliedEndTags(), n.openElements.popUntilTagNamePopped(g), n.activeFormattingElements.clearToLastMarker(), n.insertionMode = InsertionMode.IN_ROW);
      break;
    }
    case TAG_ID.TABLE:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD:
    case TAG_ID.TR: {
      n.openElements.hasInTableScope(g) && (n._closeTableCell(), endTagInRow(n, t));
      break;
    }
    case TAG_ID.BODY:
    case TAG_ID.CAPTION:
    case TAG_ID.COL:
    case TAG_ID.COLGROUP:
    case TAG_ID.HTML:
      break;
    default:
      endTagInBody(n, t);
  }
}
function startTagInSelect(n, t) {
  switch (t.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(n, t);
      break;
    }
    case TAG_ID.OPTION: {
      n.openElements.currentTagId === TAG_ID.OPTION && n.openElements.pop(), n._insertElement(t, NS.HTML);
      break;
    }
    case TAG_ID.OPTGROUP: {
      n.openElements.currentTagId === TAG_ID.OPTION && n.openElements.pop(), n.openElements.currentTagId === TAG_ID.OPTGROUP && n.openElements.pop(), n._insertElement(t, NS.HTML);
      break;
    }
    case TAG_ID.HR: {
      n.openElements.currentTagId === TAG_ID.OPTION && n.openElements.pop(), n.openElements.currentTagId === TAG_ID.OPTGROUP && n.openElements.pop(), n._appendElement(t, NS.HTML), t.ackSelfClosing = !0;
      break;
    }
    case TAG_ID.INPUT:
    case TAG_ID.KEYGEN:
    case TAG_ID.TEXTAREA:
    case TAG_ID.SELECT: {
      n.openElements.hasInSelectScope(TAG_ID.SELECT) && (n.openElements.popUntilTagNamePopped(TAG_ID.SELECT), n._resetInsertionMode(), t.tagID !== TAG_ID.SELECT && n._processStartTag(t));
      break;
    }
    case TAG_ID.SCRIPT:
    case TAG_ID.TEMPLATE: {
      startTagInHead(n, t);
      break;
    }
  }
}
function endTagInSelect(n, t) {
  switch (t.tagID) {
    case TAG_ID.OPTGROUP: {
      n.openElements.stackTop > 0 && n.openElements.currentTagId === TAG_ID.OPTION && n.openElements.tagIDs[n.openElements.stackTop - 1] === TAG_ID.OPTGROUP && n.openElements.pop(), n.openElements.currentTagId === TAG_ID.OPTGROUP && n.openElements.pop();
      break;
    }
    case TAG_ID.OPTION: {
      n.openElements.currentTagId === TAG_ID.OPTION && n.openElements.pop();
      break;
    }
    case TAG_ID.SELECT: {
      n.openElements.hasInSelectScope(TAG_ID.SELECT) && (n.openElements.popUntilTagNamePopped(TAG_ID.SELECT), n._resetInsertionMode());
      break;
    }
    case TAG_ID.TEMPLATE: {
      templateEndTagInHead(n, t);
      break;
    }
  }
}
function startTagInSelectInTable(n, t) {
  const g = t.tagID;
  g === TAG_ID.CAPTION || g === TAG_ID.TABLE || g === TAG_ID.TBODY || g === TAG_ID.TFOOT || g === TAG_ID.THEAD || g === TAG_ID.TR || g === TAG_ID.TD || g === TAG_ID.TH ? (n.openElements.popUntilTagNamePopped(TAG_ID.SELECT), n._resetInsertionMode(), n._processStartTag(t)) : startTagInSelect(n, t);
}
function endTagInSelectInTable(n, t) {
  const g = t.tagID;
  g === TAG_ID.CAPTION || g === TAG_ID.TABLE || g === TAG_ID.TBODY || g === TAG_ID.TFOOT || g === TAG_ID.THEAD || g === TAG_ID.TR || g === TAG_ID.TD || g === TAG_ID.TH ? n.openElements.hasInTableScope(g) && (n.openElements.popUntilTagNamePopped(TAG_ID.SELECT), n._resetInsertionMode(), n.onEndTag(t)) : endTagInSelect(n, t);
}
function startTagInTemplate(n, t) {
  switch (t.tagID) {
    // First, handle tags that can start without a mode change
    case TAG_ID.BASE:
    case TAG_ID.BASEFONT:
    case TAG_ID.BGSOUND:
    case TAG_ID.LINK:
    case TAG_ID.META:
    case TAG_ID.NOFRAMES:
    case TAG_ID.SCRIPT:
    case TAG_ID.STYLE:
    case TAG_ID.TEMPLATE:
    case TAG_ID.TITLE: {
      startTagInHead(n, t);
      break;
    }
    // Re-process the token in the appropriate mode
    case TAG_ID.CAPTION:
    case TAG_ID.COLGROUP:
    case TAG_ID.TBODY:
    case TAG_ID.TFOOT:
    case TAG_ID.THEAD: {
      n.tmplInsertionModeStack[0] = InsertionMode.IN_TABLE, n.insertionMode = InsertionMode.IN_TABLE, startTagInTable(n, t);
      break;
    }
    case TAG_ID.COL: {
      n.tmplInsertionModeStack[0] = InsertionMode.IN_COLUMN_GROUP, n.insertionMode = InsertionMode.IN_COLUMN_GROUP, startTagInColumnGroup(n, t);
      break;
    }
    case TAG_ID.TR: {
      n.tmplInsertionModeStack[0] = InsertionMode.IN_TABLE_BODY, n.insertionMode = InsertionMode.IN_TABLE_BODY, startTagInTableBody(n, t);
      break;
    }
    case TAG_ID.TD:
    case TAG_ID.TH: {
      n.tmplInsertionModeStack[0] = InsertionMode.IN_ROW, n.insertionMode = InsertionMode.IN_ROW, startTagInRow(n, t);
      break;
    }
    default:
      n.tmplInsertionModeStack[0] = InsertionMode.IN_BODY, n.insertionMode = InsertionMode.IN_BODY, startTagInBody(n, t);
  }
}
function endTagInTemplate(n, t) {
  t.tagID === TAG_ID.TEMPLATE && templateEndTagInHead(n, t);
}
function eofInTemplate(n, t) {
  n.openElements.tmplCount > 0 ? (n.openElements.popUntilTagNamePopped(TAG_ID.TEMPLATE), n.activeFormattingElements.clearToLastMarker(), n.tmplInsertionModeStack.shift(), n._resetInsertionMode(), n.onEof(t)) : stopParsing(n, t);
}
function startTagAfterBody(n, t) {
  t.tagID === TAG_ID.HTML ? startTagInBody(n, t) : tokenAfterBody(n, t);
}
function endTagAfterBody(n, t) {
  var g;
  if (t.tagID === TAG_ID.HTML) {
    if (n.fragmentContext || (n.insertionMode = InsertionMode.AFTER_AFTER_BODY), n.options.sourceCodeLocationInfo && n.openElements.tagIDs[0] === TAG_ID.HTML) {
      n._setEndLocation(n.openElements.items[0], t);
      const d = n.openElements.items[1];
      d && !(!((g = n.treeAdapter.getNodeSourceCodeLocation(d)) === null || g === void 0) && g.endTag) && n._setEndLocation(d, t);
    }
  } else
    tokenAfterBody(n, t);
}
function tokenAfterBody(n, t) {
  n.insertionMode = InsertionMode.IN_BODY, modeInBody(n, t);
}
function startTagInFrameset(n, t) {
  switch (t.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(n, t);
      break;
    }
    case TAG_ID.FRAMESET: {
      n._insertElement(t, NS.HTML);
      break;
    }
    case TAG_ID.FRAME: {
      n._appendElement(t, NS.HTML), t.ackSelfClosing = !0;
      break;
    }
    case TAG_ID.NOFRAMES: {
      startTagInHead(n, t);
      break;
    }
  }
}
function endTagInFrameset(n, t) {
  t.tagID === TAG_ID.FRAMESET && !n.openElements.isRootHtmlElementCurrent() && (n.openElements.pop(), !n.fragmentContext && n.openElements.currentTagId !== TAG_ID.FRAMESET && (n.insertionMode = InsertionMode.AFTER_FRAMESET));
}
function startTagAfterFrameset(n, t) {
  switch (t.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(n, t);
      break;
    }
    case TAG_ID.NOFRAMES: {
      startTagInHead(n, t);
      break;
    }
  }
}
function endTagAfterFrameset(n, t) {
  t.tagID === TAG_ID.HTML && (n.insertionMode = InsertionMode.AFTER_AFTER_FRAMESET);
}
function startTagAfterAfterBody(n, t) {
  t.tagID === TAG_ID.HTML ? startTagInBody(n, t) : tokenAfterAfterBody(n, t);
}
function tokenAfterAfterBody(n, t) {
  n.insertionMode = InsertionMode.IN_BODY, modeInBody(n, t);
}
function startTagAfterAfterFrameset(n, t) {
  switch (t.tagID) {
    case TAG_ID.HTML: {
      startTagInBody(n, t);
      break;
    }
    case TAG_ID.NOFRAMES: {
      startTagInHead(n, t);
      break;
    }
  }
}
function nullCharacterInForeignContent(n, t) {
  t.chars = REPLACEMENT_CHARACTER, n._insertCharacters(t);
}
function characterInForeignContent(n, t) {
  n._insertCharacters(t), n.framesetOk = !1;
}
function popUntilHtmlOrIntegrationPoint(n) {
  for (; n.treeAdapter.getNamespaceURI(n.openElements.current) !== NS.HTML && n.openElements.currentTagId !== void 0 && !n._isIntegrationPoint(n.openElements.currentTagId, n.openElements.current); )
    n.openElements.pop();
}
function startTagInForeignContent(n, t) {
  if (causesExit(t))
    popUntilHtmlOrIntegrationPoint(n), n._startTagOutsideForeignContent(t);
  else {
    const g = n._getAdjustedCurrentElement(), d = n.treeAdapter.getNamespaceURI(g);
    d === NS.MATHML ? adjustTokenMathMLAttrs(t) : d === NS.SVG && (adjustTokenSVGTagName(t), adjustTokenSVGAttrs(t)), adjustTokenXMLAttrs(t), t.selfClosing ? n._appendElement(t, d) : n._insertElement(t, d), t.ackSelfClosing = !0;
  }
}
function endTagInForeignContent(n, t) {
  if (t.tagID === TAG_ID.P || t.tagID === TAG_ID.BR) {
    popUntilHtmlOrIntegrationPoint(n), n._endTagOutsideForeignContent(t);
    return;
  }
  for (let g = n.openElements.stackTop; g > 0; g--) {
    const d = n.openElements.items[g];
    if (n.treeAdapter.getNamespaceURI(d) === NS.HTML) {
      n._endTagOutsideForeignContent(t);
      break;
    }
    const k = n.treeAdapter.getTagName(d);
    if (k.toLowerCase() === t.tagName) {
      t.tagName = k, n.openElements.shortenToLength(g);
      break;
    }
  }
}
TAG_NAMES.AREA, TAG_NAMES.BASE, TAG_NAMES.BASEFONT, TAG_NAMES.BGSOUND, TAG_NAMES.BR, TAG_NAMES.COL, TAG_NAMES.EMBED, TAG_NAMES.FRAME, TAG_NAMES.HR, TAG_NAMES.IMG, TAG_NAMES.INPUT, TAG_NAMES.KEYGEN, TAG_NAMES.LINK, TAG_NAMES.META, TAG_NAMES.PARAM, TAG_NAMES.SOURCE, TAG_NAMES.TRACK, TAG_NAMES.WBR;
const gfmTagfilterExpression = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi, knownMdxNames = /* @__PURE__ */ new Set([
  "mdxFlowExpression",
  "mdxJsxFlowElement",
  "mdxJsxTextElement",
  "mdxTextExpression",
  "mdxjsEsm"
]), parseOptions = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 };
function raw(n, t) {
  const g = documentMode(n), d = zwitch("type", {
    handlers: { root: root$4, element: element$2, text: text$5, comment, doctype, raw: handleRaw },
    unknown
  }), k = {
    parser: g ? new Parser(parseOptions) : Parser.getFragmentParser(void 0, parseOptions),
    handle(gA) {
      d(gA, k);
    },
    stitches: !1,
    options: t || {}
  };
  d(n, k), resetTokenizer(k, pointStart());
  const H = g ? k.parser.document : k.parser.getFragment(), AA = fromParse5(H, {
    // To do: support `space`?
    file: k.options.file
  });
  return k.stitches && visit$1(AA, "comment", function(gA, IA, CA) {
    const BA = (
      /** @type {Stitch} */
      /** @type {unknown} */
      gA
    );
    if (BA.value.stitch && CA && IA !== void 0) {
      const eA = CA.children;
      return eA[IA] = BA.value.stitch, IA;
    }
  }), AA.type === "root" && AA.children.length === 1 && AA.children[0].type === n.type ? AA.children[0] : AA;
}
function all$1(n, t) {
  let g = -1;
  if (n)
    for (; ++g < n.length; )
      t.handle(n[g]);
}
function root$4(n, t) {
  all$1(n.children, t);
}
function element$2(n, t) {
  startTag(n, t), all$1(n.children, t), endTag(n, t);
}
function text$5(n, t) {
  t.parser.tokenizer.state > 4 && (t.parser.tokenizer.state = 0);
  const g = {
    type: TokenType.CHARACTER,
    chars: n.value,
    location: createParse5Location(n)
  };
  resetTokenizer(t, pointStart(n)), t.parser.currentToken = g, t.parser._processToken(t.parser.currentToken);
}
function doctype(n, t) {
  const g = {
    type: TokenType.DOCTYPE,
    name: "html",
    forceQuirks: !1,
    publicId: "",
    systemId: "",
    location: createParse5Location(n)
  };
  resetTokenizer(t, pointStart(n)), t.parser.currentToken = g, t.parser._processToken(t.parser.currentToken);
}
function stitch$1(n, t) {
  t.stitches = !0;
  const g = cloneWithoutChildren(n);
  if ("children" in n && "children" in g) {
    const d = (
      /** @type {Root} */
      raw({ type: "root", children: n.children }, t.options)
    );
    g.children = d.children;
  }
  comment({ type: "comment", value: { stitch: g } }, t);
}
function comment(n, t) {
  const g = n.value, d = {
    type: TokenType.COMMENT,
    data: g,
    location: createParse5Location(n)
  };
  resetTokenizer(t, pointStart(n)), t.parser.currentToken = d, t.parser._processToken(t.parser.currentToken);
}
function handleRaw(n, t) {
  if (t.parser.tokenizer.preprocessor.html = "", t.parser.tokenizer.preprocessor.pos = -1, t.parser.tokenizer.preprocessor.lastGapPos = -2, t.parser.tokenizer.preprocessor.gapStack = [], t.parser.tokenizer.preprocessor.skipNextNewLine = !1, t.parser.tokenizer.preprocessor.lastChunkWritten = !1, t.parser.tokenizer.preprocessor.endOfChunkHit = !1, t.parser.tokenizer.preprocessor.isEol = !1, setPoint(t, pointStart(n)), t.parser.tokenizer.write(
    t.options.tagfilter ? n.value.replace(gfmTagfilterExpression, "&lt;$1$2") : n.value,
    !1
  ), t.parser.tokenizer._runParsingLoop(), t.parser.tokenizer.state === 72 || // @ts-expect-error: removed.
  t.parser.tokenizer.state === 78) {
    t.parser.tokenizer.preprocessor.lastChunkWritten = !0;
    const g = t.parser.tokenizer._consume();
    t.parser.tokenizer._callState(g);
  }
}
function unknown(n, t) {
  const g = (
    /** @type {Nodes} */
    n
  );
  if (t.options.passThrough && t.options.passThrough.includes(g.type))
    stitch$1(g, t);
  else {
    let d = "";
    throw knownMdxNames.has(g.type) && (d = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax"), new Error("Cannot compile `" + g.type + "` node" + d);
  }
}
function resetTokenizer(n, t) {
  setPoint(n, t);
  const g = n.parser.tokenizer.currentCharacterToken;
  g && g.location && (g.location.endLine = n.parser.tokenizer.preprocessor.line, g.location.endCol = n.parser.tokenizer.preprocessor.col + 1, g.location.endOffset = n.parser.tokenizer.preprocessor.offset + 1, n.parser.currentToken = g, n.parser._processToken(n.parser.currentToken)), n.parser.tokenizer.paused = !1, n.parser.tokenizer.inLoop = !1, n.parser.tokenizer.active = !1, n.parser.tokenizer.returnState = TokenizerMode.DATA, n.parser.tokenizer.charRefCode = -1, n.parser.tokenizer.consumedAfterSnapshot = -1, n.parser.tokenizer.currentLocation = null, n.parser.tokenizer.currentCharacterToken = null, n.parser.tokenizer.currentToken = null, n.parser.tokenizer.currentAttr = { name: "", value: "" };
}
function setPoint(n, t) {
  if (t && t.offset !== void 0) {
    const g = {
      startLine: t.line,
      startCol: t.column,
      startOffset: t.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    n.parser.tokenizer.preprocessor.lineStartPos = -t.column + 1, n.parser.tokenizer.preprocessor.droppedBufferSize = t.offset, n.parser.tokenizer.preprocessor.line = t.line, n.parser.tokenizer.currentLocation = g;
  }
}
function startTag(n, t) {
  const g = n.tagName.toLowerCase();
  if (t.parser.tokenizer.state === TokenizerMode.PLAINTEXT) return;
  resetTokenizer(t, pointStart(n));
  const d = t.parser.openElements.current;
  let k = "namespaceURI" in d ? d.namespaceURI : webNamespaces.html;
  k === webNamespaces.html && g === "svg" && (k = webNamespaces.svg);
  const H = toParse5(
    // Shallow clone to not delve into `children`: we only need the attributes.
    { ...n, children: [] },
    { space: k === webNamespaces.svg ? "svg" : "html" }
  ), AA = {
    type: TokenType.START_TAG,
    tagName: g,
    tagID: getTagID(g),
    // We always send start and end tags.
    selfClosing: !1,
    ackSelfClosing: !1,
    // Always element.
    /* c8 ignore next */
    attrs: "attrs" in H ? H.attrs : [],
    location: createParse5Location(n)
  };
  t.parser.currentToken = AA, t.parser._processToken(t.parser.currentToken), t.parser.tokenizer.lastStartTagName = g;
}
function endTag(n, t) {
  const g = n.tagName.toLowerCase();
  if (!t.parser.tokenizer.inForeignNode && htmlVoidElements.includes(g) || t.parser.tokenizer.state === TokenizerMode.PLAINTEXT) return;
  resetTokenizer(t, pointEnd(n));
  const d = {
    type: TokenType.END_TAG,
    tagName: g,
    tagID: getTagID(g),
    selfClosing: !1,
    ackSelfClosing: !1,
    attrs: [],
    location: createParse5Location(n)
  };
  t.parser.currentToken = d, t.parser._processToken(t.parser.currentToken), // Current element is closed.
  g === t.parser.tokenizer.lastStartTagName && // `<textarea>` and `<title>`
  (t.parser.tokenizer.state === TokenizerMode.RCDATA || // `<iframe>`, `<noembed>`, `<noframes>`, `<style>`, `<xmp>`
  t.parser.tokenizer.state === TokenizerMode.RAWTEXT || // `<script>`
  t.parser.tokenizer.state === TokenizerMode.SCRIPT_DATA) && (t.parser.tokenizer.state = TokenizerMode.DATA);
}
function documentMode(n) {
  const t = n.type === "root" ? n.children[0] : n;
  return !!(t && (t.type === "doctype" || t.type === "element" && t.tagName.toLowerCase() === "html"));
}
function createParse5Location(n) {
  const t = pointStart(n) || {
    line: void 0,
    column: void 0,
    offset: void 0
  }, g = pointEnd(n) || {
    line: void 0,
    column: void 0,
    offset: void 0
  };
  return {
    startLine: t.line,
    startCol: t.column,
    startOffset: t.offset,
    endLine: g.line,
    endCol: g.column,
    endOffset: g.offset
  };
}
function cloneWithoutChildren(n) {
  return "children" in n ? structuredClone$1({ ...n, children: [] }) : structuredClone$1(n);
}
function rehypeRaw(n) {
  return function(t, g) {
    return (
      /** @type {Root} */
      raw(t, { ...n, file: g })
    );
  };
}
function ccount(n, t) {
  const g = String(n);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let d = 0, k = g.indexOf(t);
  for (; k !== -1; )
    d++, k = g.indexOf(t, k + t.length);
  return d;
}
const characterEntitiesLegacy = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], characterReferenceInvalid = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
function isDecimal$1(n) {
  const t = typeof n == "string" ? n.charCodeAt(0) : n;
  return t >= 48 && t <= 57;
}
function isHexadecimal$1(n) {
  const t = typeof n == "string" ? n.charCodeAt(0) : n;
  return t >= 97 && t <= 102 || t >= 65 && t <= 70 || t >= 48 && t <= 57;
}
function isAlphabetical$1(n) {
  const t = typeof n == "string" ? n.charCodeAt(0) : n;
  return t >= 97 && t <= 122 || t >= 65 && t <= 90;
}
function isAlphanumerical$1(n) {
  return isAlphabetical$1(n) || isDecimal$1(n);
}
const messages = [
  "",
  /* 1: Non terminated (named) */
  "Named character references must be terminated by a semicolon",
  /* 2: Non terminated (numeric) */
  "Numeric character references must be terminated by a semicolon",
  /* 3: Empty (named) */
  "Named character references cannot be empty",
  /* 4: Empty (numeric) */
  "Numeric character references cannot be empty",
  /* 5: Unknown (named) */
  "Named character references must be known",
  /* 6: Disallowed (numeric) */
  "Numeric character references cannot be disallowed",
  /* 7: Prohibited (numeric) */
  "Numeric character references cannot be outside the permissible Unicode range"
];
function parseEntities(n, t) {
  const g = t || {}, d = typeof g.additional == "string" ? g.additional.charCodeAt(0) : g.additional, k = [];
  let H = 0, AA = -1, gA = "", IA, CA;
  g.position && ("start" in g.position || "indent" in g.position ? (CA = g.position.indent, IA = g.position.start) : IA = g.position);
  let BA = (IA ? IA.line : 0) || 1, eA = (IA ? IA.column : 0) || 1, iA = tA(), QA;
  for (H--; ++H <= n.length; )
    if (QA === 10 && (eA = (CA ? CA[AA] : 0) || 1), QA = n.charCodeAt(H), QA === 38) {
      const aA = n.charCodeAt(H + 1);
      if (aA === 9 || aA === 10 || aA === 12 || aA === 32 || aA === 38 || aA === 60 || Number.isNaN(aA) || d && aA === d) {
        gA += String.fromCharCode(QA), eA++;
        continue;
      }
      const nA = H + 1;
      let lA = nA, cA = nA, sA;
      if (aA === 35) {
        cA = ++lA;
        const bA = n.charCodeAt(cA);
        bA === 88 || bA === 120 ? (sA = "hexadecimal", cA = ++lA) : sA = "decimal";
      } else
        sA = "named";
      let rA = "", uA = "", hA = "";
      const dA = sA === "named" ? isAlphanumerical$1 : sA === "decimal" ? isDecimal$1 : isHexadecimal$1;
      for (cA--; ++cA <= n.length; ) {
        const bA = n.charCodeAt(cA);
        if (!dA(bA))
          break;
        hA += String.fromCharCode(bA), sA === "named" && characterEntitiesLegacy.includes(hA) && (rA = hA, uA = decodeNamedCharacterReference(hA));
      }
      let GA = n.charCodeAt(cA) === 59;
      if (GA) {
        cA++;
        const bA = sA === "named" ? decodeNamedCharacterReference(hA) : !1;
        bA && (rA = hA, uA = bA);
      }
      let DA = 1 + cA - nA, wA = "";
      if (!(!GA && g.nonTerminated === !1)) if (!hA)
        sA !== "named" && oA(4, DA);
      else if (sA === "named") {
        if (GA && !uA)
          oA(5, 1);
        else if (rA !== hA && (cA = lA + rA.length, DA = 1 + cA - lA, GA = !1), !GA) {
          const bA = rA ? 1 : 3;
          if (g.attribute) {
            const yA = n.charCodeAt(cA);
            yA === 61 ? (oA(bA, DA), uA = "") : isAlphanumerical$1(yA) ? uA = "" : oA(bA, DA);
          } else
            oA(bA, DA);
        }
        wA = uA;
      } else {
        GA || oA(2, DA);
        let bA = Number.parseInt(
          hA,
          sA === "hexadecimal" ? 16 : 10
        );
        if (prohibited(bA))
          oA(7, DA), wA = "�";
        else if (bA in characterReferenceInvalid)
          oA(6, DA), wA = characterReferenceInvalid[bA];
        else {
          let yA = "";
          disallowed(bA) && oA(6, DA), bA > 65535 && (bA -= 65536, yA += String.fromCharCode(
            bA >>> 10 | 55296
          ), bA = 56320 | bA & 1023), wA = yA + String.fromCharCode(bA);
        }
      }
      if (wA) {
        EA(), iA = tA(), H = cA - 1, eA += cA - nA + 1, k.push(wA);
        const bA = tA();
        bA.offset++, g.reference && g.reference.call(
          g.referenceContext || void 0,
          wA,
          { start: iA, end: bA },
          n.slice(nA - 1, cA)
        ), iA = bA;
      } else
        hA = n.slice(nA - 1, cA), gA += hA, eA += hA.length, H = cA - 1;
    } else
      QA === 10 && (BA++, AA++, eA = 0), Number.isNaN(QA) ? EA() : (gA += String.fromCharCode(QA), eA++);
  return k.join("");
  function tA() {
    return {
      line: BA,
      column: eA,
      offset: H + ((IA ? IA.offset : 0) || 0)
    };
  }
  function oA(aA, nA) {
    let lA;
    g.warning && (lA = tA(), lA.column += nA, lA.offset += nA, g.warning.call(
      g.warningContext || void 0,
      messages[aA],
      lA,
      aA
    ));
  }
  function EA() {
    gA && (k.push(gA), g.text && g.text.call(g.textContext || void 0, gA, {
      start: iA,
      end: tA()
    }), gA = "");
  }
}
function prohibited(n) {
  return n >= 55296 && n <= 57343 || n > 1114111;
}
function disallowed(n) {
  return n >= 1 && n <= 8 || n === 11 || n >= 13 && n <= 31 || n >= 127 && n <= 159 || n >= 64976 && n <= 65007 || (n & 65535) === 65535 || (n & 65535) === 65534;
}
const defaultSubsetRegex = /["&'<>`]/g, surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, controlCharactersRegex = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g, subsetToRegexCache = /* @__PURE__ */ new WeakMap();
function core$2(n, t) {
  if (n = n.replace(
    t.subset ? charactersToExpressionCached(t.subset) : defaultSubsetRegex,
    d
  ), t.subset || t.escapeOnly)
    return n;
  return n.replace(surrogatePairsRegex, g).replace(controlCharactersRegex, d);
  function g(k, H, AA) {
    return t.format(
      (k.charCodeAt(0) - 55296) * 1024 + k.charCodeAt(1) - 56320 + 65536,
      AA.charCodeAt(H + 2),
      t
    );
  }
  function d(k, H, AA) {
    return t.format(
      k.charCodeAt(0),
      AA.charCodeAt(H + 1),
      t
    );
  }
}
function charactersToExpressionCached(n) {
  let t = subsetToRegexCache.get(n);
  return t || (t = charactersToExpression(n), subsetToRegexCache.set(n, t)), t;
}
function charactersToExpression(n) {
  const t = [];
  let g = -1;
  for (; ++g < n.length; )
    t.push(n[g].replace(regexEscapeRegex, "\\$&"));
  return new RegExp("(?:" + t.join("|") + ")", "g");
}
function formatBasic(n) {
  return "&#x" + n.toString(16).toUpperCase() + ";";
}
function stringifyEntitiesLight(n, t) {
  return core$2(n, Object.assign({ format: formatBasic }, t));
}
const own = {}.hasOwnProperty, emptyOptions$2 = {}, shortcut = /^[^\t\n\r "#'.<=>`}]+$/, unquoted = /^[^\t\n\r "'<=>`}]+$/;
function directiveFromMarkdown() {
  return {
    canContainEols: ["textDirective"],
    enter: {
      directiveContainer: enterContainer,
      directiveContainerAttributes: enterAttributes,
      directiveContainerLabel: enterContainerLabel,
      directiveLeaf: enterLeaf,
      directiveLeafAttributes: enterAttributes,
      directiveText: enterText,
      directiveTextAttributes: enterAttributes
    },
    exit: {
      directiveContainer: exit$1,
      directiveContainerAttributeClassValue: exitAttributeClassValue,
      directiveContainerAttributeIdValue: exitAttributeIdValue,
      directiveContainerAttributeName: exitAttributeName,
      directiveContainerAttributeValue: exitAttributeValue,
      directiveContainerAttributes: exitAttributes,
      directiveContainerLabel: exitContainerLabel,
      directiveContainerName: exitName,
      directiveLeaf: exit$1,
      directiveLeafAttributeClassValue: exitAttributeClassValue,
      directiveLeafAttributeIdValue: exitAttributeIdValue,
      directiveLeafAttributeName: exitAttributeName,
      directiveLeafAttributeValue: exitAttributeValue,
      directiveLeafAttributes: exitAttributes,
      directiveLeafName: exitName,
      directiveText: exit$1,
      directiveTextAttributeClassValue: exitAttributeClassValue,
      directiveTextAttributeIdValue: exitAttributeIdValue,
      directiveTextAttributeName: exitAttributeName,
      directiveTextAttributeValue: exitAttributeValue,
      directiveTextAttributes: exitAttributes,
      directiveTextName: exitName
    }
  };
}
function directiveToMarkdown(n) {
  const t = emptyOptions$2;
  if (t.quote !== '"' && t.quote !== "'" && t.quote !== null && t.quote !== void 0)
    throw new Error(
      "Invalid quote `" + t.quote + "`, expected `'` or `\"`"
    );
  return g.peek = peekDirective, {
    handlers: {
      containerDirective: g,
      leafDirective: g,
      textDirective: g
    },
    unsafe: [
      {
        character: "\r",
        inConstruct: ["leafDirectiveLabel", "containerDirectiveLabel"]
      },
      {
        character: `
`,
        inConstruct: ["leafDirectiveLabel", "containerDirectiveLabel"]
      },
      {
        before: "[^:]",
        character: ":",
        after: "[A-Za-z]",
        inConstruct: ["phrasing"]
      },
      { atBreak: !0, character: ":", after: ":" }
    ]
  };
  function g(H, AA, gA, IA) {
    const CA = gA.createTracker(IA), BA = fence(H), eA = gA.enter(H.type);
    let iA = CA.move(BA + (H.name || "")), QA;
    if (H.type === "containerDirective") {
      const tA = (H.children || [])[0];
      QA = inlineDirectiveLabel(tA) ? tA : void 0;
    } else
      QA = H;
    if (QA && QA.children && QA.children.length > 0) {
      const tA = gA.enter("label"), oA = `${H.type}Label`, EA = gA.enter(oA);
      iA += CA.move("["), iA += CA.move(
        gA.containerPhrasing(QA, {
          ...CA.current(),
          before: iA,
          after: "]"
        })
      ), iA += CA.move("]"), EA(), tA();
    }
    if (iA += CA.move(d(H, gA)), H.type === "containerDirective") {
      const tA = (H.children || [])[0];
      let oA = H;
      inlineDirectiveLabel(tA) && (oA = Object.assign({}, H, { children: H.children.slice(1) })), oA && oA.children && oA.children.length > 0 && (iA += CA.move(`
`), iA += CA.move(gA.containerFlow(oA, CA.current()))), iA += CA.move(`
` + BA);
    }
    return eA(), iA;
  }
  function d(H, AA) {
    const gA = H.attributes || {}, IA = [];
    let CA, BA, eA, iA;
    for (iA in gA)
      if (own.call(gA, iA) && gA[iA] !== void 0 && gA[iA] !== null) {
        const QA = String(gA[iA]);
        if (iA === "id")
          eA = t.preferShortcut !== !1 && shortcut.test(QA) ? "#" + QA : k("id", QA, H, AA);
        else if (iA === "class") {
          const tA = QA.split(/[\t\n\r ]+/g), oA = [], EA = [];
          let aA = -1;
          for (; ++aA < tA.length; )
            (t.preferShortcut !== !1 && shortcut.test(tA[aA]) ? EA : oA).push(tA[aA]);
          CA = oA.length > 0 ? k("class", oA.join(" "), H, AA) : "", BA = EA.length > 0 ? "." + EA.join(".") : "";
        } else
          IA.push(k(iA, QA, H, AA));
      }
    return CA && IA.unshift(CA), BA && IA.unshift(BA), eA && IA.unshift(eA), IA.length > 0 ? "{" + IA.join(" ") + "}" : "";
  }
  function k(H, AA, gA, IA) {
    if (t.collapseEmptyAttributes !== !1 && !AA) return H;
    if (t.preferUnquoted && unquoted.test(AA))
      return H + "=" + AA;
    const CA = t.quote || IA.options.quote || '"', BA = CA === '"' ? "'" : '"', eA = t.quoteSmart && ccount(AA, CA) > ccount(AA, BA) ? BA : CA, iA = gA.type === "textDirective" ? [eA] : [eA, `
`, "\r"];
    return H + "=" + eA + stringifyEntitiesLight(AA, { subset: iA }) + eA;
  }
}
function enterContainer(n) {
  enter.call(this, "containerDirective", n);
}
function enterLeaf(n) {
  enter.call(this, "leafDirective", n);
}
function enterText(n) {
  enter.call(this, "textDirective", n);
}
function enter(n, t) {
  this.enter({ type: n, name: "", attributes: {}, children: [] }, t);
}
function exitName(n) {
  const t = this.stack[this.stack.length - 1];
  t.type === "containerDirective" || t.type === "leafDirective" || t.type, t.name = this.sliceSerialize(n);
}
function enterContainerLabel(n) {
  this.enter(
    { type: "paragraph", data: { directiveLabel: !0 }, children: [] },
    n
  );
}
function exitContainerLabel(n) {
  this.exit(n);
}
function enterAttributes() {
  this.data.directiveAttributes = [], this.buffer();
}
function exitAttributeIdValue(n) {
  this.data.directiveAttributes.push([
    "id",
    parseEntities(this.sliceSerialize(n), { attribute: !0 })
  ]);
}
function exitAttributeClassValue(n) {
  this.data.directiveAttributes.push([
    "class",
    parseEntities(this.sliceSerialize(n), { attribute: !0 })
  ]);
}
function exitAttributeValue(n) {
  const t = this.data.directiveAttributes;
  t[t.length - 1][1] = parseEntities(this.sliceSerialize(n), {
    attribute: !0
  });
}
function exitAttributeName(n) {
  this.data.directiveAttributes.push([this.sliceSerialize(n), ""]);
}
function exitAttributes() {
  const n = this.data.directiveAttributes, t = {};
  let g = -1;
  for (; ++g < n.length; ) {
    const k = n[g];
    k[0] === "class" && t.class ? t.class += " " + k[1] : t[k[0]] = k[1];
  }
  this.data.directiveAttributes = void 0, this.resume();
  const d = this.stack[this.stack.length - 1];
  d.type === "containerDirective" || d.type === "leafDirective" || d.type, d.attributes = t;
}
function exit$1(n) {
  this.exit(n);
}
function peekDirective() {
  return ":";
}
function inlineDirectiveLabel(n) {
  return !!(n && n.type === "paragraph" && n.data && n.data.directiveLabel);
}
function fence(n) {
  let t = 0;
  return n.type === "containerDirective" ? (visitParents(n, function(g, d) {
    if (g.type === "containerDirective") {
      let k = d.length, H = 0;
      for (; k--; )
        d[k].type === "containerDirective" && H++;
      H > t && (t = H);
    }
  }), t += 3) : n.type === "leafDirective" ? t = 2 : t = 1, ":".repeat(t);
}
function factoryAttributes(n, t, g, d, k, H, AA, gA, IA, CA, BA, eA, iA, QA, tA) {
  let oA, EA;
  return aA;
  function aA(pA) {
    return n.enter(d), n.enter(k), n.consume(pA), n.exit(k), nA;
  }
  function nA(pA) {
    return pA === 35 ? (oA = AA, lA(pA)) : pA === 46 ? (oA = gA, lA(pA)) : tA && markdownSpace(pA) ? factorySpace(n, nA, "whitespace")(pA) : !tA && markdownLineEndingOrSpace(pA) ? factoryWhitespace(n, nA)(pA) : pA === null || markdownLineEnding(pA) || unicodeWhitespace(pA) || unicodePunctuation(pA) && pA !== 45 && pA !== 95 ? yA(pA) : (n.enter(H), n.enter(IA), n.consume(pA), rA);
  }
  function lA(pA) {
    const MA = (
      /** @type {TokenType} */
      oA + "Marker"
    );
    return n.enter(H), n.enter(oA), n.enter(MA), n.consume(pA), n.exit(MA), cA;
  }
  function cA(pA) {
    if (pA === null || pA === 34 || pA === 35 || pA === 39 || pA === 46 || pA === 60 || pA === 61 || pA === 62 || pA === 96 || pA === 125 || markdownLineEndingOrSpace(pA))
      return g(pA);
    const MA = (
      /** @type {TokenType} */
      oA + "Value"
    );
    return n.enter(MA), n.consume(pA), sA;
  }
  function sA(pA) {
    if (pA === null || pA === 34 || pA === 39 || pA === 60 || pA === 61 || pA === 62 || pA === 96)
      return g(pA);
    if (pA === 35 || pA === 46 || pA === 125 || markdownLineEndingOrSpace(pA)) {
      const MA = (
        /** @type {TokenType} */
        oA + "Value"
      );
      return n.exit(MA), n.exit(oA), n.exit(H), nA(pA);
    }
    return n.consume(pA), sA;
  }
  function rA(pA) {
    return pA === null || markdownLineEnding(pA) || unicodeWhitespace(pA) || unicodePunctuation(pA) && pA !== 45 && pA !== 46 && pA !== 58 && pA !== 95 ? (n.exit(IA), tA && markdownSpace(pA) ? factorySpace(n, uA, "whitespace")(pA) : !tA && markdownLineEndingOrSpace(pA) ? factoryWhitespace(n, uA)(pA) : uA(pA)) : (n.consume(pA), rA);
  }
  function uA(pA) {
    return pA === 61 ? (n.enter(CA), n.consume(pA), n.exit(CA), hA) : (n.exit(H), nA(pA));
  }
  function hA(pA) {
    return pA === null || pA === 60 || pA === 61 || pA === 62 || pA === 96 || pA === 125 || tA && markdownLineEnding(pA) ? g(pA) : pA === 34 || pA === 39 ? (n.enter(BA), n.enter(iA), n.consume(pA), n.exit(iA), EA = pA, GA) : tA && markdownSpace(pA) ? factorySpace(n, hA, "whitespace")(pA) : !tA && markdownLineEndingOrSpace(pA) ? factoryWhitespace(n, hA)(pA) : (n.enter(eA), n.enter(QA), n.consume(pA), EA = void 0, dA);
  }
  function dA(pA) {
    return pA === null || pA === 34 || pA === 39 || pA === 60 || pA === 61 || pA === 62 || pA === 96 ? g(pA) : pA === 125 || markdownLineEndingOrSpace(pA) ? (n.exit(QA), n.exit(eA), n.exit(H), nA(pA)) : (n.consume(pA), dA);
  }
  function GA(pA) {
    return pA === EA ? (n.enter(iA), n.consume(pA), n.exit(iA), n.exit(BA), n.exit(H), bA) : (n.enter(eA), DA(pA));
  }
  function DA(pA) {
    return pA === EA ? (n.exit(eA), GA(pA)) : pA === null ? g(pA) : markdownLineEnding(pA) ? tA ? g(pA) : factoryWhitespace(n, DA)(pA) : (n.enter(QA), n.consume(pA), wA);
  }
  function wA(pA) {
    return pA === EA || pA === null || markdownLineEnding(pA) ? (n.exit(QA), DA(pA)) : (n.consume(pA), wA);
  }
  function bA(pA) {
    return pA === 125 || markdownLineEndingOrSpace(pA) ? nA(pA) : yA(pA);
  }
  function yA(pA) {
    return pA === 125 ? (n.enter(k), n.consume(pA), n.exit(k), n.exit(d), t) : g(pA);
  }
}
function factoryLabel(n, t, g, d, k, H, AA) {
  let gA = 0, IA = 0, CA;
  return BA;
  function BA(EA) {
    return n.enter(d), n.enter(k), n.consume(EA), n.exit(k), eA;
  }
  function eA(EA) {
    return EA === 93 ? (n.enter(k), n.consume(EA), n.exit(k), n.exit(d), t) : (n.enter(H), iA(EA));
  }
  function iA(EA) {
    if (EA === 93 && !IA)
      return oA(EA);
    const aA = n.enter("chunkText", {
      _contentTypeTextTrailing: !0,
      contentType: "text",
      previous: CA
    });
    return CA && (CA.next = aA), CA = aA, QA(EA);
  }
  function QA(EA) {
    return EA === null || gA > 999 || EA === 91 && ++IA > 32 ? g(EA) : EA === 93 && !IA-- ? (n.exit("chunkText"), oA(EA)) : markdownLineEnding(EA) ? AA ? g(EA) : (n.consume(EA), n.exit("chunkText"), iA) : (n.consume(EA), EA === 92 ? tA : QA);
  }
  function tA(EA) {
    return EA === 91 || EA === 92 || EA === 93 ? (n.consume(EA), gA++, QA) : QA(EA);
  }
  function oA(EA) {
    return n.exit(H), n.enter(k), n.consume(EA), n.exit(k), n.exit(d), t;
  }
}
function factoryName(n, t, g, d) {
  const k = this;
  return H;
  function H(gA) {
    return gA === null || markdownLineEnding(gA) || unicodePunctuation(gA) || unicodeWhitespace(gA) ? g(gA) : (n.enter(d), n.consume(gA), AA);
  }
  function AA(gA) {
    return gA === null || markdownLineEnding(gA) || unicodeWhitespace(gA) || unicodePunctuation(gA) && gA !== 45 && gA !== 95 ? (n.exit(d), k.previous === 45 || k.previous === 95 ? g(gA) : t(gA)) : (n.consume(gA), AA);
  }
}
const directiveContainer = {
  tokenize: tokenizeDirectiveContainer,
  concrete: !0
}, label$4 = {
  tokenize: tokenizeLabel$2,
  partial: !0
}, attributes$2 = {
  tokenize: tokenizeAttributes$2,
  partial: !0
}, nonLazyLine = {
  tokenize: tokenizeNonLazyLine,
  partial: !0
};
function tokenizeDirectiveContainer(n, t, g) {
  const d = this, k = d.events[d.events.length - 1], H = k && k[1].type === "linePrefix" ? k[2].sliceSerialize(k[1], !0).length : 0;
  let AA = 0, gA;
  return IA;
  function IA(dA) {
    return n.enter("directiveContainer"), n.enter("directiveContainerFence"), n.enter("directiveContainerSequence"), CA(dA);
  }
  function CA(dA) {
    return dA === 58 ? (n.consume(dA), AA++, CA) : AA < 3 ? g(dA) : (n.exit("directiveContainerSequence"), factoryName.call(d, n, BA, g, "directiveContainerName")(dA));
  }
  function BA(dA) {
    return dA === 91 ? n.attempt(label$4, eA, eA)(dA) : eA(dA);
  }
  function eA(dA) {
    return dA === 123 ? n.attempt(attributes$2, iA, iA)(dA) : iA(dA);
  }
  function iA(dA) {
    return factorySpace(n, QA, "whitespace")(dA);
  }
  function QA(dA) {
    return n.exit("directiveContainerFence"), dA === null ? uA(dA) : markdownLineEnding(dA) ? d.interrupt ? t(dA) : n.attempt(nonLazyLine, tA, uA)(dA) : g(dA);
  }
  function tA(dA) {
    return dA === null ? uA(dA) : markdownLineEnding(dA) ? n.check(nonLazyLine, lA, uA)(dA) : (n.enter("directiveContainerContent"), oA(dA));
  }
  function oA(dA) {
    return n.attempt({
      tokenize: hA,
      partial: !0
    }, rA, H ? factorySpace(n, EA, "linePrefix", H + 1) : EA)(dA);
  }
  function EA(dA) {
    return dA === null ? rA(dA) : markdownLineEnding(dA) ? n.check(nonLazyLine, nA, rA)(dA) : nA(dA);
  }
  function aA(dA) {
    if (dA === null) {
      const GA = n.exit("chunkDocument");
      return d.parser.lazy[GA.start.line] = !1, rA(dA);
    }
    return markdownLineEnding(dA) ? n.check(nonLazyLine, cA, sA)(dA) : (n.consume(dA), aA);
  }
  function nA(dA) {
    const GA = n.enter("chunkDocument", {
      contentType: "document",
      previous: gA
    });
    return gA && (gA.next = GA), gA = GA, aA(dA);
  }
  function lA(dA) {
    return n.enter("directiveContainerContent"), oA(dA);
  }
  function cA(dA) {
    n.consume(dA);
    const GA = n.exit("chunkDocument");
    return d.parser.lazy[GA.start.line] = !1, oA;
  }
  function sA(dA) {
    const GA = n.exit("chunkDocument");
    return d.parser.lazy[GA.start.line] = !1, rA(dA);
  }
  function rA(dA) {
    return n.exit("directiveContainerContent"), uA(dA);
  }
  function uA(dA) {
    return n.exit("directiveContainer"), t(dA);
  }
  function hA(dA, GA, DA) {
    let wA = 0;
    return factorySpace(dA, bA, "linePrefix", d.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    function bA(MA) {
      return dA.enter("directiveContainerFence"), dA.enter("directiveContainerSequence"), yA(MA);
    }
    function yA(MA) {
      return MA === 58 ? (dA.consume(MA), wA++, yA) : wA < AA ? DA(MA) : (dA.exit("directiveContainerSequence"), factorySpace(dA, pA, "whitespace")(MA));
    }
    function pA(MA) {
      return MA === null || markdownLineEnding(MA) ? (dA.exit("directiveContainerFence"), GA(MA)) : DA(MA);
    }
  }
}
function tokenizeLabel$2(n, t, g) {
  return factoryLabel(n, t, g, "directiveContainerLabel", "directiveContainerLabelMarker", "directiveContainerLabelString", !0);
}
function tokenizeAttributes$2(n, t, g) {
  return factoryAttributes(n, t, g, "directiveContainerAttributes", "directiveContainerAttributesMarker", "directiveContainerAttribute", "directiveContainerAttributeId", "directiveContainerAttributeClass", "directiveContainerAttributeName", "directiveContainerAttributeInitializerMarker", "directiveContainerAttributeValueLiteral", "directiveContainerAttributeValue", "directiveContainerAttributeValueMarker", "directiveContainerAttributeValueData", !0);
}
function tokenizeNonLazyLine(n, t, g) {
  const d = this;
  return k;
  function k(AA) {
    return n.enter("lineEnding"), n.consume(AA), n.exit("lineEnding"), H;
  }
  function H(AA) {
    return d.parser.lazy[d.now().line] ? g(AA) : t(AA);
  }
}
const directiveLeaf = {
  tokenize: tokenizeDirectiveLeaf
}, label$3 = {
  tokenize: tokenizeLabel$1,
  partial: !0
}, attributes$1 = {
  tokenize: tokenizeAttributes$1,
  partial: !0
};
function tokenizeDirectiveLeaf(n, t, g) {
  const d = this;
  return k;
  function k(BA) {
    return n.enter("directiveLeaf"), n.enter("directiveLeafSequence"), n.consume(BA), H;
  }
  function H(BA) {
    return BA === 58 ? (n.consume(BA), n.exit("directiveLeafSequence"), factoryName.call(d, n, AA, g, "directiveLeafName")) : g(BA);
  }
  function AA(BA) {
    return BA === 91 ? n.attempt(label$3, gA, gA)(BA) : gA(BA);
  }
  function gA(BA) {
    return BA === 123 ? n.attempt(attributes$1, IA, IA)(BA) : IA(BA);
  }
  function IA(BA) {
    return factorySpace(n, CA, "whitespace")(BA);
  }
  function CA(BA) {
    return BA === null || markdownLineEnding(BA) ? (n.exit("directiveLeaf"), t(BA)) : g(BA);
  }
}
function tokenizeLabel$1(n, t, g) {
  return factoryLabel(n, t, g, "directiveLeafLabel", "directiveLeafLabelMarker", "directiveLeafLabelString", !0);
}
function tokenizeAttributes$1(n, t, g) {
  return factoryAttributes(n, t, g, "directiveLeafAttributes", "directiveLeafAttributesMarker", "directiveLeafAttribute", "directiveLeafAttributeId", "directiveLeafAttributeClass", "directiveLeafAttributeName", "directiveLeafAttributeInitializerMarker", "directiveLeafAttributeValueLiteral", "directiveLeafAttributeValue", "directiveLeafAttributeValueMarker", "directiveLeafAttributeValueData", !0);
}
const directiveText = {
  tokenize: tokenizeDirectiveText,
  previous: previous$2
}, label$2 = {
  tokenize: tokenizeLabel,
  partial: !0
}, attributes = {
  tokenize: tokenizeAttributes,
  partial: !0
};
function previous$2(n) {
  return n !== 58 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeDirectiveText(n, t, g) {
  const d = this;
  return k;
  function k(IA) {
    return n.enter("directiveText"), n.enter("directiveTextMarker"), n.consume(IA), n.exit("directiveTextMarker"), factoryName.call(d, n, H, g, "directiveTextName");
  }
  function H(IA) {
    return IA === 58 ? g(IA) : IA === 91 ? n.attempt(label$2, AA, AA)(IA) : AA(IA);
  }
  function AA(IA) {
    return IA === 123 ? n.attempt(attributes, gA, gA)(IA) : gA(IA);
  }
  function gA(IA) {
    return n.exit("directiveText"), t(IA);
  }
}
function tokenizeLabel(n, t, g) {
  return factoryLabel(n, t, g, "directiveTextLabel", "directiveTextLabelMarker", "directiveTextLabelString");
}
function tokenizeAttributes(n, t, g) {
  return factoryAttributes(n, t, g, "directiveTextAttributes", "directiveTextAttributesMarker", "directiveTextAttribute", "directiveTextAttributeId", "directiveTextAttributeClass", "directiveTextAttributeName", "directiveTextAttributeInitializerMarker", "directiveTextAttributeValueLiteral", "directiveTextAttributeValue", "directiveTextAttributeValueMarker", "directiveTextAttributeValueData");
}
function directive() {
  return {
    text: {
      58: directiveText
    },
    flow: {
      58: [directiveContainer, directiveLeaf]
    }
  };
}
function remarkDirective() {
  const t = /** @type {Processor<Root>} */ this.data(), g = t.micromarkExtensions || (t.micromarkExtensions = []), d = t.fromMarkdownExtensions || (t.fromMarkdownExtensions = []), k = t.toMarkdownExtensions || (t.toMarkdownExtensions = []);
  g.push(directive()), d.push(directiveFromMarkdown()), k.push(directiveToMarkdown());
}
var dist$2 = { exports: {} }, hasRequiredDist$1;
function requireDist$1() {
  return hasRequiredDist$1 || (hasRequiredDist$1 = 1, (function(n, t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    const g = [
      "Int8Array",
      "Uint8Array",
      "Uint8ClampedArray",
      "Int16Array",
      "Uint16Array",
      "Int32Array",
      "Uint32Array",
      "Float32Array",
      "Float64Array",
      "BigInt64Array",
      "BigUint64Array"
    ];
    function d(rA) {
      return g.includes(rA);
    }
    const k = [
      "Function",
      "Generator",
      "AsyncGenerator",
      "GeneratorFunction",
      "AsyncGeneratorFunction",
      "AsyncFunction",
      "Observable",
      "Array",
      "Buffer",
      "Blob",
      "Object",
      "RegExp",
      "Date",
      "Error",
      "Map",
      "Set",
      "WeakMap",
      "WeakSet",
      "ArrayBuffer",
      "SharedArrayBuffer",
      "DataView",
      "Promise",
      "URL",
      "FormData",
      "URLSearchParams",
      "HTMLElement",
      ...g
    ];
    function H(rA) {
      return k.includes(rA);
    }
    const AA = [
      "null",
      "undefined",
      "string",
      "number",
      "bigint",
      "boolean",
      "symbol"
    ];
    function gA(rA) {
      return AA.includes(rA);
    }
    function IA(rA) {
      return (uA) => typeof uA === rA;
    }
    const { toString: CA } = Object.prototype, BA = (rA) => {
      const uA = CA.call(rA).slice(8, -1);
      if (/HTML\w+Element/.test(uA) && iA.domElement(rA))
        return "HTMLElement";
      if (H(uA))
        return uA;
    }, eA = (rA) => (uA) => BA(uA) === rA;
    function iA(rA) {
      if (rA === null)
        return "null";
      switch (typeof rA) {
        case "undefined":
          return "undefined";
        case "string":
          return "string";
        case "number":
          return "number";
        case "boolean":
          return "boolean";
        case "function":
          return "Function";
        case "bigint":
          return "bigint";
        case "symbol":
          return "symbol";
      }
      if (iA.observable(rA))
        return "Observable";
      if (iA.array(rA))
        return "Array";
      if (iA.buffer(rA))
        return "Buffer";
      const uA = BA(rA);
      if (uA)
        return uA;
      if (rA instanceof String || rA instanceof Boolean || rA instanceof Number)
        throw new TypeError("Please don't use object wrappers for primitive types");
      return "Object";
    }
    iA.undefined = IA("undefined"), iA.string = IA("string");
    const QA = IA("number");
    iA.number = (rA) => QA(rA) && !iA.nan(rA), iA.bigint = IA("bigint"), iA.function_ = IA("function"), iA.null_ = (rA) => rA === null, iA.class_ = (rA) => iA.function_(rA) && rA.toString().startsWith("class "), iA.boolean = (rA) => rA === !0 || rA === !1, iA.symbol = IA("symbol"), iA.numericString = (rA) => iA.string(rA) && !iA.emptyStringOrWhitespace(rA) && !Number.isNaN(Number(rA)), iA.array = (rA, uA) => Array.isArray(rA) ? iA.function_(uA) ? rA.every(uA) : !0 : !1, iA.buffer = (rA) => {
      var uA, hA, dA, GA;
      return (GA = (dA = (hA = (uA = rA) === null || uA === void 0 ? void 0 : uA.constructor) === null || hA === void 0 ? void 0 : hA.isBuffer) === null || dA === void 0 ? void 0 : dA.call(hA, rA)) !== null && GA !== void 0 ? GA : !1;
    }, iA.blob = (rA) => eA("Blob")(rA), iA.nullOrUndefined = (rA) => iA.null_(rA) || iA.undefined(rA), iA.object = (rA) => !iA.null_(rA) && (typeof rA == "object" || iA.function_(rA)), iA.iterable = (rA) => {
      var uA;
      return iA.function_((uA = rA) === null || uA === void 0 ? void 0 : uA[Symbol.iterator]);
    }, iA.asyncIterable = (rA) => {
      var uA;
      return iA.function_((uA = rA) === null || uA === void 0 ? void 0 : uA[Symbol.asyncIterator]);
    }, iA.generator = (rA) => {
      var uA, hA;
      return iA.iterable(rA) && iA.function_((uA = rA) === null || uA === void 0 ? void 0 : uA.next) && iA.function_((hA = rA) === null || hA === void 0 ? void 0 : hA.throw);
    }, iA.asyncGenerator = (rA) => iA.asyncIterable(rA) && iA.function_(rA.next) && iA.function_(rA.throw), iA.nativePromise = (rA) => eA("Promise")(rA);
    const tA = (rA) => {
      var uA, hA;
      return iA.function_((uA = rA) === null || uA === void 0 ? void 0 : uA.then) && iA.function_((hA = rA) === null || hA === void 0 ? void 0 : hA.catch);
    };
    iA.promise = (rA) => iA.nativePromise(rA) || tA(rA), iA.generatorFunction = eA("GeneratorFunction"), iA.asyncGeneratorFunction = (rA) => BA(rA) === "AsyncGeneratorFunction", iA.asyncFunction = (rA) => BA(rA) === "AsyncFunction", iA.boundFunction = (rA) => iA.function_(rA) && !rA.hasOwnProperty("prototype"), iA.regExp = eA("RegExp"), iA.date = eA("Date"), iA.error = eA("Error"), iA.map = (rA) => eA("Map")(rA), iA.set = (rA) => eA("Set")(rA), iA.weakMap = (rA) => eA("WeakMap")(rA), iA.weakSet = (rA) => eA("WeakSet")(rA), iA.int8Array = eA("Int8Array"), iA.uint8Array = eA("Uint8Array"), iA.uint8ClampedArray = eA("Uint8ClampedArray"), iA.int16Array = eA("Int16Array"), iA.uint16Array = eA("Uint16Array"), iA.int32Array = eA("Int32Array"), iA.uint32Array = eA("Uint32Array"), iA.float32Array = eA("Float32Array"), iA.float64Array = eA("Float64Array"), iA.bigInt64Array = eA("BigInt64Array"), iA.bigUint64Array = eA("BigUint64Array"), iA.arrayBuffer = eA("ArrayBuffer"), iA.sharedArrayBuffer = eA("SharedArrayBuffer"), iA.dataView = eA("DataView"), iA.enumCase = (rA, uA) => Object.values(uA).includes(rA), iA.directInstanceOf = (rA, uA) => Object.getPrototypeOf(rA) === uA.prototype, iA.urlInstance = (rA) => eA("URL")(rA), iA.urlString = (rA) => {
      if (!iA.string(rA))
        return !1;
      try {
        return new URL(rA), !0;
      } catch {
        return !1;
      }
    }, iA.truthy = (rA) => !!rA, iA.falsy = (rA) => !rA, iA.nan = (rA) => Number.isNaN(rA), iA.primitive = (rA) => iA.null_(rA) || gA(typeof rA), iA.integer = (rA) => Number.isInteger(rA), iA.safeInteger = (rA) => Number.isSafeInteger(rA), iA.plainObject = (rA) => {
      if (CA.call(rA) !== "[object Object]")
        return !1;
      const uA = Object.getPrototypeOf(rA);
      return uA === null || uA === Object.getPrototypeOf({});
    }, iA.typedArray = (rA) => d(BA(rA));
    const oA = (rA) => iA.safeInteger(rA) && rA >= 0;
    iA.arrayLike = (rA) => !iA.nullOrUndefined(rA) && !iA.function_(rA) && oA(rA.length), iA.inRange = (rA, uA) => {
      if (iA.number(uA))
        return rA >= Math.min(0, uA) && rA <= Math.max(uA, 0);
      if (iA.array(uA) && uA.length === 2)
        return rA >= Math.min(...uA) && rA <= Math.max(...uA);
      throw new TypeError(`Invalid range: ${JSON.stringify(uA)}`);
    };
    const EA = 1, aA = [
      "innerHTML",
      "ownerDocument",
      "style",
      "attributes",
      "nodeValue"
    ];
    iA.domElement = (rA) => iA.object(rA) && rA.nodeType === EA && iA.string(rA.nodeName) && !iA.plainObject(rA) && aA.every((uA) => uA in rA), iA.observable = (rA) => {
      var uA, hA, dA, GA;
      return rA ? rA === ((hA = (uA = rA)[Symbol.observable]) === null || hA === void 0 ? void 0 : hA.call(uA)) || rA === ((GA = (dA = rA)["@@observable"]) === null || GA === void 0 ? void 0 : GA.call(dA)) : !1;
    }, iA.nodeStream = (rA) => iA.object(rA) && iA.function_(rA.pipe) && !iA.observable(rA), iA.infinite = (rA) => rA === 1 / 0 || rA === -1 / 0;
    const nA = (rA) => (uA) => iA.integer(uA) && Math.abs(uA % 2) === rA;
    iA.evenInteger = nA(0), iA.oddInteger = nA(1), iA.emptyArray = (rA) => iA.array(rA) && rA.length === 0, iA.nonEmptyArray = (rA) => iA.array(rA) && rA.length > 0, iA.emptyString = (rA) => iA.string(rA) && rA.length === 0;
    const lA = (rA) => iA.string(rA) && !/\S/.test(rA);
    iA.emptyStringOrWhitespace = (rA) => iA.emptyString(rA) || lA(rA), iA.nonEmptyString = (rA) => iA.string(rA) && rA.length > 0, iA.nonEmptyStringAndNotWhitespace = (rA) => iA.string(rA) && !iA.emptyStringOrWhitespace(rA), iA.emptyObject = (rA) => iA.object(rA) && !iA.map(rA) && !iA.set(rA) && Object.keys(rA).length === 0, iA.nonEmptyObject = (rA) => iA.object(rA) && !iA.map(rA) && !iA.set(rA) && Object.keys(rA).length > 0, iA.emptySet = (rA) => iA.set(rA) && rA.size === 0, iA.nonEmptySet = (rA) => iA.set(rA) && rA.size > 0, iA.emptyMap = (rA) => iA.map(rA) && rA.size === 0, iA.nonEmptyMap = (rA) => iA.map(rA) && rA.size > 0, iA.propertyKey = (rA) => iA.any([iA.string, iA.number, iA.symbol], rA), iA.formData = (rA) => eA("FormData")(rA), iA.urlSearchParams = (rA) => eA("URLSearchParams")(rA);
    const cA = (rA, uA, hA) => {
      if (!iA.function_(uA))
        throw new TypeError(`Invalid predicate: ${JSON.stringify(uA)}`);
      if (hA.length === 0)
        throw new TypeError("Invalid number of values");
      return rA.call(hA, uA);
    };
    iA.any = (rA, ...uA) => (iA.array(rA) ? rA : [rA]).some((dA) => cA(Array.prototype.some, dA, uA)), iA.all = (rA, ...uA) => cA(Array.prototype.every, rA, uA);
    const sA = (rA, uA, hA, dA = {}) => {
      if (!rA) {
        const { multipleValues: GA } = dA, DA = GA ? `received values of types ${[
          ...new Set(hA.map((wA) => `\`${iA(wA)}\``))
        ].join(", ")}` : `received value of type \`${iA(hA)}\``;
        throw new TypeError(`Expected value which is \`${uA}\`, ${DA}.`);
      }
    };
    t.assert = {
      // Unknowns.
      undefined: (rA) => sA(iA.undefined(rA), "undefined", rA),
      string: (rA) => sA(iA.string(rA), "string", rA),
      number: (rA) => sA(iA.number(rA), "number", rA),
      bigint: (rA) => sA(iA.bigint(rA), "bigint", rA),
      // eslint-disable-next-line @typescript-eslint/ban-types
      function_: (rA) => sA(iA.function_(rA), "Function", rA),
      null_: (rA) => sA(iA.null_(rA), "null", rA),
      class_: (rA) => sA(iA.class_(rA), "Class", rA),
      boolean: (rA) => sA(iA.boolean(rA), "boolean", rA),
      symbol: (rA) => sA(iA.symbol(rA), "symbol", rA),
      numericString: (rA) => sA(iA.numericString(rA), "string with a number", rA),
      array: (rA, uA) => {
        sA(iA.array(rA), "Array", rA), uA && rA.forEach(uA);
      },
      buffer: (rA) => sA(iA.buffer(rA), "Buffer", rA),
      blob: (rA) => sA(iA.blob(rA), "Blob", rA),
      nullOrUndefined: (rA) => sA(iA.nullOrUndefined(rA), "null or undefined", rA),
      object: (rA) => sA(iA.object(rA), "Object", rA),
      iterable: (rA) => sA(iA.iterable(rA), "Iterable", rA),
      asyncIterable: (rA) => sA(iA.asyncIterable(rA), "AsyncIterable", rA),
      generator: (rA) => sA(iA.generator(rA), "Generator", rA),
      asyncGenerator: (rA) => sA(iA.asyncGenerator(rA), "AsyncGenerator", rA),
      nativePromise: (rA) => sA(iA.nativePromise(rA), "native Promise", rA),
      promise: (rA) => sA(iA.promise(rA), "Promise", rA),
      generatorFunction: (rA) => sA(iA.generatorFunction(rA), "GeneratorFunction", rA),
      asyncGeneratorFunction: (rA) => sA(iA.asyncGeneratorFunction(rA), "AsyncGeneratorFunction", rA),
      // eslint-disable-next-line @typescript-eslint/ban-types
      asyncFunction: (rA) => sA(iA.asyncFunction(rA), "AsyncFunction", rA),
      // eslint-disable-next-line @typescript-eslint/ban-types
      boundFunction: (rA) => sA(iA.boundFunction(rA), "Function", rA),
      regExp: (rA) => sA(iA.regExp(rA), "RegExp", rA),
      date: (rA) => sA(iA.date(rA), "Date", rA),
      error: (rA) => sA(iA.error(rA), "Error", rA),
      map: (rA) => sA(iA.map(rA), "Map", rA),
      set: (rA) => sA(iA.set(rA), "Set", rA),
      weakMap: (rA) => sA(iA.weakMap(rA), "WeakMap", rA),
      weakSet: (rA) => sA(iA.weakSet(rA), "WeakSet", rA),
      int8Array: (rA) => sA(iA.int8Array(rA), "Int8Array", rA),
      uint8Array: (rA) => sA(iA.uint8Array(rA), "Uint8Array", rA),
      uint8ClampedArray: (rA) => sA(iA.uint8ClampedArray(rA), "Uint8ClampedArray", rA),
      int16Array: (rA) => sA(iA.int16Array(rA), "Int16Array", rA),
      uint16Array: (rA) => sA(iA.uint16Array(rA), "Uint16Array", rA),
      int32Array: (rA) => sA(iA.int32Array(rA), "Int32Array", rA),
      uint32Array: (rA) => sA(iA.uint32Array(rA), "Uint32Array", rA),
      float32Array: (rA) => sA(iA.float32Array(rA), "Float32Array", rA),
      float64Array: (rA) => sA(iA.float64Array(rA), "Float64Array", rA),
      bigInt64Array: (rA) => sA(iA.bigInt64Array(rA), "BigInt64Array", rA),
      bigUint64Array: (rA) => sA(iA.bigUint64Array(rA), "BigUint64Array", rA),
      arrayBuffer: (rA) => sA(iA.arrayBuffer(rA), "ArrayBuffer", rA),
      sharedArrayBuffer: (rA) => sA(iA.sharedArrayBuffer(rA), "SharedArrayBuffer", rA),
      dataView: (rA) => sA(iA.dataView(rA), "DataView", rA),
      enumCase: (rA, uA) => sA(iA.enumCase(rA, uA), "EnumCase", rA),
      urlInstance: (rA) => sA(iA.urlInstance(rA), "URL", rA),
      urlString: (rA) => sA(iA.urlString(rA), "string with a URL", rA),
      truthy: (rA) => sA(iA.truthy(rA), "truthy", rA),
      falsy: (rA) => sA(iA.falsy(rA), "falsy", rA),
      nan: (rA) => sA(iA.nan(rA), "NaN", rA),
      primitive: (rA) => sA(iA.primitive(rA), "primitive", rA),
      integer: (rA) => sA(iA.integer(rA), "integer", rA),
      safeInteger: (rA) => sA(iA.safeInteger(rA), "integer", rA),
      plainObject: (rA) => sA(iA.plainObject(rA), "plain object", rA),
      typedArray: (rA) => sA(iA.typedArray(rA), "TypedArray", rA),
      arrayLike: (rA) => sA(iA.arrayLike(rA), "array-like", rA),
      domElement: (rA) => sA(iA.domElement(rA), "HTMLElement", rA),
      observable: (rA) => sA(iA.observable(rA), "Observable", rA),
      nodeStream: (rA) => sA(iA.nodeStream(rA), "Node.js Stream", rA),
      infinite: (rA) => sA(iA.infinite(rA), "infinite number", rA),
      emptyArray: (rA) => sA(iA.emptyArray(rA), "empty array", rA),
      nonEmptyArray: (rA) => sA(iA.nonEmptyArray(rA), "non-empty array", rA),
      emptyString: (rA) => sA(iA.emptyString(rA), "empty string", rA),
      emptyStringOrWhitespace: (rA) => sA(iA.emptyStringOrWhitespace(rA), "empty string or whitespace", rA),
      nonEmptyString: (rA) => sA(iA.nonEmptyString(rA), "non-empty string", rA),
      nonEmptyStringAndNotWhitespace: (rA) => sA(iA.nonEmptyStringAndNotWhitespace(rA), "non-empty string and not whitespace", rA),
      emptyObject: (rA) => sA(iA.emptyObject(rA), "empty object", rA),
      nonEmptyObject: (rA) => sA(iA.nonEmptyObject(rA), "non-empty object", rA),
      emptySet: (rA) => sA(iA.emptySet(rA), "empty set", rA),
      nonEmptySet: (rA) => sA(iA.nonEmptySet(rA), "non-empty set", rA),
      emptyMap: (rA) => sA(iA.emptyMap(rA), "empty map", rA),
      nonEmptyMap: (rA) => sA(iA.nonEmptyMap(rA), "non-empty map", rA),
      propertyKey: (rA) => sA(iA.propertyKey(rA), "PropertyKey", rA),
      formData: (rA) => sA(iA.formData(rA), "FormData", rA),
      urlSearchParams: (rA) => sA(iA.urlSearchParams(rA), "URLSearchParams", rA),
      // Numbers.
      evenInteger: (rA) => sA(iA.evenInteger(rA), "even integer", rA),
      oddInteger: (rA) => sA(iA.oddInteger(rA), "odd integer", rA),
      // Two arguments.
      directInstanceOf: (rA, uA) => sA(iA.directInstanceOf(rA, uA), "T", rA),
      inRange: (rA, uA) => sA(iA.inRange(rA, uA), "in range", rA),
      // Variadic functions.
      any: (rA, ...uA) => sA(iA.any(rA, ...uA), "predicate returns truthy for any value", uA, { multipleValues: !0 }),
      all: (rA, ...uA) => sA(iA.all(rA, ...uA), "predicate returns truthy for all values", uA, { multipleValues: !0 })
    }, Object.defineProperties(iA, {
      class: {
        value: iA.class_
      },
      function: {
        value: iA.function_
      },
      null: {
        value: iA.null_
      }
    }), Object.defineProperties(t.assert, {
      class: {
        value: t.assert.class_
      },
      function: {
        value: t.assert.function_
      },
      null: {
        value: t.assert.null_
      }
    }), t.default = iA, n.exports = iA, n.exports.default = iA, n.exports.assert = t.assert;
  })(dist$2, dist$2.exports)), dist$2.exports;
}
var distExports$1 = /* @__PURE__ */ requireDist$1();
const grinning = { keywords: ["face", "smile", "happy", "joy", ":D", "grin"], char: "😀", fitzpatrick_scale: !1, category: "people" }, grimacing = { keywords: ["face", "grimace", "teeth"], char: "😬", fitzpatrick_scale: !1, category: "people" }, grin = { keywords: ["face", "happy", "smile", "joy", "kawaii"], char: "😁", fitzpatrick_scale: !1, category: "people" }, joy = { keywords: ["face", "cry", "tears", "weep", "happy", "happytears", "haha"], char: "😂", fitzpatrick_scale: !1, category: "people" }, rofl = { keywords: ["face", "rolling", "floor", "laughing", "lol", "haha"], char: "🤣", fitzpatrick_scale: !1, category: "people" }, partying = { keywords: ["face", "celebration", "woohoo"], char: "🥳", fitzpatrick_scale: !1, category: "people" }, smiley = { keywords: ["face", "happy", "joy", "haha", ":D", ":)", "smile", "funny"], char: "😃", fitzpatrick_scale: !1, category: "people" }, smile = { keywords: ["face", "happy", "joy", "funny", "haha", "laugh", "like", ":D", ":)"], char: "😄", fitzpatrick_scale: !1, category: "people" }, sweat_smile = { keywords: ["face", "hot", "happy", "laugh", "sweat", "smile", "relief"], char: "😅", fitzpatrick_scale: !1, category: "people" }, laughing = { keywords: ["happy", "joy", "lol", "satisfied", "haha", "face", "glad", "XD", "laugh"], char: "😆", fitzpatrick_scale: !1, category: "people" }, innocent = { keywords: ["face", "angel", "heaven", "halo"], char: "😇", fitzpatrick_scale: !1, category: "people" }, wink = { keywords: ["face", "happy", "mischievous", "secret", ";)", "smile", "eye"], char: "😉", fitzpatrick_scale: !1, category: "people" }, blush = { keywords: ["face", "smile", "happy", "flushed", "crush", "embarrassed", "shy", "joy"], char: "😊", fitzpatrick_scale: !1, category: "people" }, slightly_smiling_face = { keywords: ["face", "smile"], char: "🙂", fitzpatrick_scale: !1, category: "people" }, upside_down_face = { keywords: ["face", "flipped", "silly", "smile"], char: "🙃", fitzpatrick_scale: !1, category: "people" }, relaxed = { keywords: ["face", "blush", "massage", "happiness"], char: "☺️", fitzpatrick_scale: !1, category: "people" }, yum = { keywords: ["happy", "joy", "tongue", "smile", "face", "silly", "yummy", "nom", "delicious", "savouring"], char: "😋", fitzpatrick_scale: !1, category: "people" }, relieved = { keywords: ["face", "relaxed", "phew", "massage", "happiness"], char: "😌", fitzpatrick_scale: !1, category: "people" }, heart_eyes = { keywords: ["face", "love", "like", "affection", "valentines", "infatuation", "crush", "heart"], char: "😍", fitzpatrick_scale: !1, category: "people" }, smiling_face_with_three_hearts = { keywords: ["face", "love", "like", "affection", "valentines", "infatuation", "crush", "hearts", "adore"], char: "🥰", fitzpatrick_scale: !1, category: "people" }, kissing_heart = { keywords: ["face", "love", "like", "affection", "valentines", "infatuation", "kiss"], char: "😘", fitzpatrick_scale: !1, category: "people" }, kissing = { keywords: ["love", "like", "face", "3", "valentines", "infatuation", "kiss"], char: "😗", fitzpatrick_scale: !1, category: "people" }, kissing_smiling_eyes = { keywords: ["face", "affection", "valentines", "infatuation", "kiss"], char: "😙", fitzpatrick_scale: !1, category: "people" }, kissing_closed_eyes = { keywords: ["face", "love", "like", "affection", "valentines", "infatuation", "kiss"], char: "😚", fitzpatrick_scale: !1, category: "people" }, stuck_out_tongue_winking_eye = { keywords: ["face", "prank", "childish", "playful", "mischievous", "smile", "wink", "tongue"], char: "😜", fitzpatrick_scale: !1, category: "people" }, zany = { keywords: ["face", "goofy", "crazy"], char: "🤪", fitzpatrick_scale: !1, category: "people" }, raised_eyebrow = { keywords: ["face", "distrust", "scepticism", "disapproval", "disbelief", "surprise"], char: "🤨", fitzpatrick_scale: !1, category: "people" }, monocle = { keywords: ["face", "stuffy", "wealthy"], char: "🧐", fitzpatrick_scale: !1, category: "people" }, stuck_out_tongue_closed_eyes = { keywords: ["face", "prank", "playful", "mischievous", "smile", "tongue"], char: "😝", fitzpatrick_scale: !1, category: "people" }, stuck_out_tongue = { keywords: ["face", "prank", "childish", "playful", "mischievous", "smile", "tongue"], char: "😛", fitzpatrick_scale: !1, category: "people" }, money_mouth_face = { keywords: ["face", "rich", "dollar", "money"], char: "🤑", fitzpatrick_scale: !1, category: "people" }, nerd_face = { keywords: ["face", "nerdy", "geek", "dork"], char: "🤓", fitzpatrick_scale: !1, category: "people" }, sunglasses = { keywords: ["face", "cool", "smile", "summer", "beach", "sunglass"], char: "😎", fitzpatrick_scale: !1, category: "people" }, star_struck = { keywords: ["face", "smile", "starry", "eyes", "grinning"], char: "🤩", fitzpatrick_scale: !1, category: "people" }, clown_face = { keywords: ["face"], char: "🤡", fitzpatrick_scale: !1, category: "people" }, cowboy_hat_face = { keywords: ["face", "cowgirl", "hat"], char: "🤠", fitzpatrick_scale: !1, category: "people" }, hugs = { keywords: ["face", "smile", "hug"], char: "🤗", fitzpatrick_scale: !1, category: "people" }, smirk = { keywords: ["face", "smile", "mean", "prank", "smug", "sarcasm"], char: "😏", fitzpatrick_scale: !1, category: "people" }, no_mouth = { keywords: ["face", "hellokitty"], char: "😶", fitzpatrick_scale: !1, category: "people" }, neutral_face = { keywords: ["indifference", "meh", ":|", "neutral"], char: "😐", fitzpatrick_scale: !1, category: "people" }, expressionless = { keywords: ["face", "indifferent", "-_-", "meh", "deadpan"], char: "😑", fitzpatrick_scale: !1, category: "people" }, unamused = { keywords: ["indifference", "bored", "straight face", "serious", "sarcasm", "unimpressed", "skeptical", "dubious", "side_eye"], char: "😒", fitzpatrick_scale: !1, category: "people" }, roll_eyes = { keywords: ["face", "eyeroll", "frustrated"], char: "🙄", fitzpatrick_scale: !1, category: "people" }, thinking = { keywords: ["face", "hmmm", "think", "consider"], char: "🤔", fitzpatrick_scale: !1, category: "people" }, lying_face = { keywords: ["face", "lie", "pinocchio"], char: "🤥", fitzpatrick_scale: !1, category: "people" }, hand_over_mouth = { keywords: ["face", "whoops", "shock", "surprise"], char: "🤭", fitzpatrick_scale: !1, category: "people" }, shushing = { keywords: ["face", "quiet", "shhh"], char: "🤫", fitzpatrick_scale: !1, category: "people" }, symbols_over_mouth = { keywords: ["face", "swearing", "cursing", "cussing", "profanity", "expletive"], char: "🤬", fitzpatrick_scale: !1, category: "people" }, exploding_head = { keywords: ["face", "shocked", "mind", "blown"], char: "🤯", fitzpatrick_scale: !1, category: "people" }, flushed = { keywords: ["face", "blush", "shy", "flattered"], char: "😳", fitzpatrick_scale: !1, category: "people" }, disappointed = { keywords: ["face", "sad", "upset", "depressed", ":("], char: "😞", fitzpatrick_scale: !1, category: "people" }, worried = { keywords: ["face", "concern", "nervous", ":("], char: "😟", fitzpatrick_scale: !1, category: "people" }, angry = { keywords: ["mad", "face", "annoyed", "frustrated"], char: "😠", fitzpatrick_scale: !1, category: "people" }, rage = { keywords: ["angry", "mad", "hate", "despise"], char: "😡", fitzpatrick_scale: !1, category: "people" }, pensive = { keywords: ["face", "sad", "depressed", "upset"], char: "😔", fitzpatrick_scale: !1, category: "people" }, confused = { keywords: ["face", "indifference", "huh", "weird", "hmmm", ":/"], char: "😕", fitzpatrick_scale: !1, category: "people" }, slightly_frowning_face = { keywords: ["face", "frowning", "disappointed", "sad", "upset"], char: "🙁", fitzpatrick_scale: !1, category: "people" }, frowning_face = { keywords: ["face", "sad", "upset", "frown"], char: "☹", fitzpatrick_scale: !1, category: "people" }, persevere = { keywords: ["face", "sick", "no", "upset", "oops"], char: "😣", fitzpatrick_scale: !1, category: "people" }, confounded = { keywords: ["face", "confused", "sick", "unwell", "oops", ":S"], char: "😖", fitzpatrick_scale: !1, category: "people" }, tired_face = { keywords: ["sick", "whine", "upset", "frustrated"], char: "😫", fitzpatrick_scale: !1, category: "people" }, weary = { keywords: ["face", "tired", "sleepy", "sad", "frustrated", "upset"], char: "😩", fitzpatrick_scale: !1, category: "people" }, pleading = { keywords: ["face", "begging", "mercy"], char: "🥺", fitzpatrick_scale: !1, category: "people" }, triumph = { keywords: ["face", "gas", "phew", "proud", "pride"], char: "😤", fitzpatrick_scale: !1, category: "people" }, open_mouth = { keywords: ["face", "surprise", "impressed", "wow", "whoa", ":O"], char: "😮", fitzpatrick_scale: !1, category: "people" }, scream = { keywords: ["face", "munch", "scared", "omg"], char: "😱", fitzpatrick_scale: !1, category: "people" }, fearful = { keywords: ["face", "scared", "terrified", "nervous", "oops", "huh"], char: "😨", fitzpatrick_scale: !1, category: "people" }, cold_sweat = { keywords: ["face", "nervous", "sweat"], char: "😰", fitzpatrick_scale: !1, category: "people" }, hushed = { keywords: ["face", "woo", "shh"], char: "😯", fitzpatrick_scale: !1, category: "people" }, frowning = { keywords: ["face", "aw", "what"], char: "😦", fitzpatrick_scale: !1, category: "people" }, anguished = { keywords: ["face", "stunned", "nervous"], char: "😧", fitzpatrick_scale: !1, category: "people" }, cry = { keywords: ["face", "tears", "sad", "depressed", "upset", ":'("], char: "😢", fitzpatrick_scale: !1, category: "people" }, disappointed_relieved = { keywords: ["face", "phew", "sweat", "nervous"], char: "😥", fitzpatrick_scale: !1, category: "people" }, drooling_face = { keywords: ["face"], char: "🤤", fitzpatrick_scale: !1, category: "people" }, sleepy = { keywords: ["face", "tired", "rest", "nap"], char: "😪", fitzpatrick_scale: !1, category: "people" }, sweat = { keywords: ["face", "hot", "sad", "tired", "exercise"], char: "😓", fitzpatrick_scale: !1, category: "people" }, hot = { keywords: ["face", "feverish", "heat", "red", "sweating"], char: "🥵", fitzpatrick_scale: !1, category: "people" }, cold = { keywords: ["face", "blue", "freezing", "frozen", "frostbite", "icicles"], char: "🥶", fitzpatrick_scale: !1, category: "people" }, sob = { keywords: ["face", "cry", "tears", "sad", "upset", "depressed"], char: "😭", fitzpatrick_scale: !1, category: "people" }, dizzy_face = { keywords: ["spent", "unconscious", "xox", "dizzy"], char: "😵", fitzpatrick_scale: !1, category: "people" }, astonished = { keywords: ["face", "xox", "surprised", "poisoned"], char: "😲", fitzpatrick_scale: !1, category: "people" }, zipper_mouth_face = { keywords: ["face", "sealed", "zipper", "secret"], char: "🤐", fitzpatrick_scale: !1, category: "people" }, nauseated_face = { keywords: ["face", "vomit", "gross", "green", "sick", "throw up", "ill"], char: "🤢", fitzpatrick_scale: !1, category: "people" }, sneezing_face = { keywords: ["face", "gesundheit", "sneeze", "sick", "allergy"], char: "🤧", fitzpatrick_scale: !1, category: "people" }, vomiting = { keywords: ["face", "sick"], char: "🤮", fitzpatrick_scale: !1, category: "people" }, mask = { keywords: ["face", "sick", "ill", "disease"], char: "😷", fitzpatrick_scale: !1, category: "people" }, face_with_thermometer = { keywords: ["sick", "temperature", "thermometer", "cold", "fever"], char: "🤒", fitzpatrick_scale: !1, category: "people" }, face_with_head_bandage = { keywords: ["injured", "clumsy", "bandage", "hurt"], char: "🤕", fitzpatrick_scale: !1, category: "people" }, woozy = { keywords: ["face", "dizzy", "intoxicated", "tipsy", "wavy"], char: "🥴", fitzpatrick_scale: !1, category: "people" }, sleeping = { keywords: ["face", "tired", "sleepy", "night", "zzz"], char: "😴", fitzpatrick_scale: !1, category: "people" }, zzz = { keywords: ["sleepy", "tired", "dream"], char: "💤", fitzpatrick_scale: !1, category: "people" }, poop = { keywords: ["hankey", "shitface", "fail", "turd", "shit"], char: "💩", fitzpatrick_scale: !1, category: "people" }, smiling_imp = { keywords: ["devil", "horns"], char: "😈", fitzpatrick_scale: !1, category: "people" }, imp = { keywords: ["devil", "angry", "horns"], char: "👿", fitzpatrick_scale: !1, category: "people" }, japanese_ogre = { keywords: ["monster", "red", "mask", "halloween", "scary", "creepy", "devil", "demon", "japanese", "ogre"], char: "👹", fitzpatrick_scale: !1, category: "people" }, japanese_goblin = { keywords: ["red", "evil", "mask", "monster", "scary", "creepy", "japanese", "goblin"], char: "👺", fitzpatrick_scale: !1, category: "people" }, skull = { keywords: ["dead", "skeleton", "creepy", "death"], char: "💀", fitzpatrick_scale: !1, category: "people" }, ghost = { keywords: ["halloween", "spooky", "scary"], char: "👻", fitzpatrick_scale: !1, category: "people" }, alien = { keywords: ["UFO", "paul", "weird", "outer_space"], char: "👽", fitzpatrick_scale: !1, category: "people" }, robot = { keywords: ["computer", "machine", "bot"], char: "🤖", fitzpatrick_scale: !1, category: "people" }, smiley_cat = { keywords: ["animal", "cats", "happy", "smile"], char: "😺", fitzpatrick_scale: !1, category: "people" }, smile_cat = { keywords: ["animal", "cats", "smile"], char: "😸", fitzpatrick_scale: !1, category: "people" }, joy_cat = { keywords: ["animal", "cats", "haha", "happy", "tears"], char: "😹", fitzpatrick_scale: !1, category: "people" }, heart_eyes_cat = { keywords: ["animal", "love", "like", "affection", "cats", "valentines", "heart"], char: "😻", fitzpatrick_scale: !1, category: "people" }, smirk_cat = { keywords: ["animal", "cats", "smirk"], char: "😼", fitzpatrick_scale: !1, category: "people" }, kissing_cat = { keywords: ["animal", "cats", "kiss"], char: "😽", fitzpatrick_scale: !1, category: "people" }, scream_cat = { keywords: ["animal", "cats", "munch", "scared", "scream"], char: "🙀", fitzpatrick_scale: !1, category: "people" }, crying_cat_face = { keywords: ["animal", "tears", "weep", "sad", "cats", "upset", "cry"], char: "😿", fitzpatrick_scale: !1, category: "people" }, pouting_cat = { keywords: ["animal", "cats"], char: "😾", fitzpatrick_scale: !1, category: "people" }, palms_up = { keywords: ["hands", "gesture", "cupped", "prayer"], char: "🤲", fitzpatrick_scale: !0, category: "people" }, raised_hands = { keywords: ["gesture", "hooray", "yea", "celebration", "hands"], char: "🙌", fitzpatrick_scale: !0, category: "people" }, clap = { keywords: ["hands", "praise", "applause", "congrats", "yay"], char: "👏", fitzpatrick_scale: !0, category: "people" }, wave = { keywords: ["hands", "gesture", "goodbye", "solong", "farewell", "hello", "hi", "palm"], char: "👋", fitzpatrick_scale: !0, category: "people" }, call_me_hand = { keywords: ["hands", "gesture"], char: "🤙", fitzpatrick_scale: !0, category: "people" }, facepunch = { keywords: ["angry", "violence", "fist", "hit", "attack", "hand"], char: "👊", fitzpatrick_scale: !0, category: "people" }, fist = { keywords: ["fingers", "hand", "grasp"], char: "✊", fitzpatrick_scale: !0, category: "people" }, fist_left = { keywords: ["hand", "fistbump"], char: "🤛", fitzpatrick_scale: !0, category: "people" }, fist_right = { keywords: ["hand", "fistbump"], char: "🤜", fitzpatrick_scale: !0, category: "people" }, v$1 = { keywords: ["fingers", "ohyeah", "hand", "peace", "victory", "two"], char: "✌", fitzpatrick_scale: !0, category: "people" }, ok_hand = { keywords: ["fingers", "limbs", "perfect", "ok", "okay"], char: "👌", fitzpatrick_scale: !0, category: "people" }, raised_hand = { keywords: ["fingers", "stop", "highfive", "palm", "ban"], char: "✋", fitzpatrick_scale: !0, category: "people" }, raised_back_of_hand = { keywords: ["fingers", "raised", "backhand"], char: "🤚", fitzpatrick_scale: !0, category: "people" }, open_hands = { keywords: ["fingers", "butterfly", "hands", "open"], char: "👐", fitzpatrick_scale: !0, category: "people" }, muscle = { keywords: ["arm", "flex", "hand", "summer", "strong", "biceps"], char: "💪", fitzpatrick_scale: !0, category: "people" }, pray = { keywords: ["please", "hope", "wish", "namaste", "highfive"], char: "🙏", fitzpatrick_scale: !0, category: "people" }, foot = { keywords: ["kick", "stomp"], char: "🦶", fitzpatrick_scale: !0, category: "people" }, leg = { keywords: ["kick", "limb"], char: "🦵", fitzpatrick_scale: !0, category: "people" }, handshake = { keywords: ["agreement", "shake"], char: "🤝", fitzpatrick_scale: !1, category: "people" }, point_up = { keywords: ["hand", "fingers", "direction", "up"], char: "☝", fitzpatrick_scale: !0, category: "people" }, point_up_2 = { keywords: ["fingers", "hand", "direction", "up"], char: "👆", fitzpatrick_scale: !0, category: "people" }, point_down = { keywords: ["fingers", "hand", "direction", "down"], char: "👇", fitzpatrick_scale: !0, category: "people" }, point_left = { keywords: ["direction", "fingers", "hand", "left"], char: "👈", fitzpatrick_scale: !0, category: "people" }, point_right = { keywords: ["fingers", "hand", "direction", "right"], char: "👉", fitzpatrick_scale: !0, category: "people" }, fu = { keywords: ["hand", "fingers", "rude", "middle", "flipping"], char: "🖕", fitzpatrick_scale: !0, category: "people" }, raised_hand_with_fingers_splayed = { keywords: ["hand", "fingers", "palm"], char: "🖐", fitzpatrick_scale: !0, category: "people" }, love_you = { keywords: ["hand", "fingers", "gesture"], char: "🤟", fitzpatrick_scale: !0, category: "people" }, metal = { keywords: ["hand", "fingers", "evil_eye", "sign_of_horns", "rock_on"], char: "🤘", fitzpatrick_scale: !0, category: "people" }, crossed_fingers = { keywords: ["good", "lucky"], char: "🤞", fitzpatrick_scale: !0, category: "people" }, vulcan_salute = { keywords: ["hand", "fingers", "spock", "star trek"], char: "🖖", fitzpatrick_scale: !0, category: "people" }, writing_hand = { keywords: ["lower_left_ballpoint_pen", "stationery", "write", "compose"], char: "✍", fitzpatrick_scale: !0, category: "people" }, selfie = { keywords: ["camera", "phone"], char: "🤳", fitzpatrick_scale: !0, category: "people" }, nail_care = { keywords: ["beauty", "manicure", "finger", "fashion", "nail"], char: "💅", fitzpatrick_scale: !0, category: "people" }, lips = { keywords: ["mouth", "kiss"], char: "👄", fitzpatrick_scale: !1, category: "people" }, tooth = { keywords: ["teeth", "dentist"], char: "🦷", fitzpatrick_scale: !1, category: "people" }, tongue = { keywords: ["mouth", "playful"], char: "👅", fitzpatrick_scale: !1, category: "people" }, ear = { keywords: ["face", "hear", "sound", "listen"], char: "👂", fitzpatrick_scale: !0, category: "people" }, nose = { keywords: ["smell", "sniff"], char: "👃", fitzpatrick_scale: !0, category: "people" }, eye = { keywords: ["face", "look", "see", "watch", "stare"], char: "👁", fitzpatrick_scale: !1, category: "people" }, eyes = { keywords: ["look", "watch", "stalk", "peek", "see"], char: "👀", fitzpatrick_scale: !1, category: "people" }, brain = { keywords: ["smart", "intelligent"], char: "🧠", fitzpatrick_scale: !1, category: "people" }, bust_in_silhouette = { keywords: ["user", "person", "human"], char: "👤", fitzpatrick_scale: !1, category: "people" }, busts_in_silhouette = { keywords: ["user", "person", "human", "group", "team"], char: "👥", fitzpatrick_scale: !1, category: "people" }, speaking_head = { keywords: ["user", "person", "human", "sing", "say", "talk"], char: "🗣", fitzpatrick_scale: !1, category: "people" }, baby = { keywords: ["child", "boy", "girl", "toddler"], char: "👶", fitzpatrick_scale: !0, category: "people" }, child = { keywords: ["gender-neutral", "young"], char: "🧒", fitzpatrick_scale: !0, category: "people" }, boy = { keywords: ["man", "male", "guy", "teenager"], char: "👦", fitzpatrick_scale: !0, category: "people" }, girl = { keywords: ["female", "woman", "teenager"], char: "👧", fitzpatrick_scale: !0, category: "people" }, adult = { keywords: ["gender-neutral", "person"], char: "🧑", fitzpatrick_scale: !0, category: "people" }, man = { keywords: ["mustache", "father", "dad", "guy", "classy", "sir", "moustache"], char: "👨", fitzpatrick_scale: !0, category: "people" }, woman = { keywords: ["female", "girls", "lady"], char: "👩", fitzpatrick_scale: !0, category: "people" }, blonde_woman = { keywords: ["woman", "female", "girl", "blonde", "person"], char: "👱‍♀️", fitzpatrick_scale: !0, category: "people" }, blonde_man = { keywords: ["man", "male", "boy", "blonde", "guy", "person"], char: "👱", fitzpatrick_scale: !0, category: "people" }, bearded_person = { keywords: ["person", "bewhiskered"], char: "🧔", fitzpatrick_scale: !0, category: "people" }, older_adult = { keywords: ["human", "elder", "senior", "gender-neutral"], char: "🧓", fitzpatrick_scale: !0, category: "people" }, older_man = { keywords: ["human", "male", "men", "old", "elder", "senior"], char: "👴", fitzpatrick_scale: !0, category: "people" }, older_woman = { keywords: ["human", "female", "women", "lady", "old", "elder", "senior"], char: "👵", fitzpatrick_scale: !0, category: "people" }, man_with_gua_pi_mao = { keywords: ["male", "boy", "chinese"], char: "👲", fitzpatrick_scale: !0, category: "people" }, woman_with_headscarf = { keywords: ["female", "hijab", "mantilla", "tichel"], char: "🧕", fitzpatrick_scale: !0, category: "people" }, woman_with_turban = { keywords: ["female", "indian", "hinduism", "arabs", "woman"], char: "👳‍♀️", fitzpatrick_scale: !0, category: "people" }, man_with_turban = { keywords: ["male", "indian", "hinduism", "arabs"], char: "👳", fitzpatrick_scale: !0, category: "people" }, policewoman = { keywords: ["woman", "police", "law", "legal", "enforcement", "arrest", "911", "female"], char: "👮‍♀️", fitzpatrick_scale: !0, category: "people" }, policeman = { keywords: ["man", "police", "law", "legal", "enforcement", "arrest", "911"], char: "👮", fitzpatrick_scale: !0, category: "people" }, construction_worker_woman = { keywords: ["female", "human", "wip", "build", "construction", "worker", "labor", "woman"], char: "👷‍♀️", fitzpatrick_scale: !0, category: "people" }, construction_worker_man = { keywords: ["male", "human", "wip", "guy", "build", "construction", "worker", "labor"], char: "👷", fitzpatrick_scale: !0, category: "people" }, guardswoman = { keywords: ["uk", "gb", "british", "female", "royal", "woman"], char: "💂‍♀️", fitzpatrick_scale: !0, category: "people" }, guardsman = { keywords: ["uk", "gb", "british", "male", "guy", "royal"], char: "💂", fitzpatrick_scale: !0, category: "people" }, female_detective = { keywords: ["human", "spy", "detective", "female", "woman"], char: "🕵️‍♀️", fitzpatrick_scale: !0, category: "people" }, male_detective = { keywords: ["human", "spy", "detective"], char: "🕵", fitzpatrick_scale: !0, category: "people" }, woman_health_worker = { keywords: ["doctor", "nurse", "therapist", "healthcare", "woman", "human"], char: "👩‍⚕️", fitzpatrick_scale: !0, category: "people" }, man_health_worker = { keywords: ["doctor", "nurse", "therapist", "healthcare", "man", "human"], char: "👨‍⚕️", fitzpatrick_scale: !0, category: "people" }, woman_farmer = { keywords: ["rancher", "gardener", "woman", "human"], char: "👩‍🌾", fitzpatrick_scale: !0, category: "people" }, man_farmer = { keywords: ["rancher", "gardener", "man", "human"], char: "👨‍🌾", fitzpatrick_scale: !0, category: "people" }, woman_cook = { keywords: ["chef", "woman", "human"], char: "👩‍🍳", fitzpatrick_scale: !0, category: "people" }, man_cook = { keywords: ["chef", "man", "human"], char: "👨‍🍳", fitzpatrick_scale: !0, category: "people" }, woman_student = { keywords: ["graduate", "woman", "human"], char: "👩‍🎓", fitzpatrick_scale: !0, category: "people" }, man_student = { keywords: ["graduate", "man", "human"], char: "👨‍🎓", fitzpatrick_scale: !0, category: "people" }, woman_singer = { keywords: ["rockstar", "entertainer", "woman", "human"], char: "👩‍🎤", fitzpatrick_scale: !0, category: "people" }, man_singer = { keywords: ["rockstar", "entertainer", "man", "human"], char: "👨‍🎤", fitzpatrick_scale: !0, category: "people" }, woman_teacher = { keywords: ["instructor", "professor", "woman", "human"], char: "👩‍🏫", fitzpatrick_scale: !0, category: "people" }, man_teacher = { keywords: ["instructor", "professor", "man", "human"], char: "👨‍🏫", fitzpatrick_scale: !0, category: "people" }, woman_factory_worker = { keywords: ["assembly", "industrial", "woman", "human"], char: "👩‍🏭", fitzpatrick_scale: !0, category: "people" }, man_factory_worker = { keywords: ["assembly", "industrial", "man", "human"], char: "👨‍🏭", fitzpatrick_scale: !0, category: "people" }, woman_technologist = { keywords: ["coder", "developer", "engineer", "programmer", "software", "woman", "human", "laptop", "computer"], char: "👩‍💻", fitzpatrick_scale: !0, category: "people" }, man_technologist = { keywords: ["coder", "developer", "engineer", "programmer", "software", "man", "human", "laptop", "computer"], char: "👨‍💻", fitzpatrick_scale: !0, category: "people" }, woman_office_worker = { keywords: ["business", "manager", "woman", "human"], char: "👩‍💼", fitzpatrick_scale: !0, category: "people" }, man_office_worker = { keywords: ["business", "manager", "man", "human"], char: "👨‍💼", fitzpatrick_scale: !0, category: "people" }, woman_mechanic = { keywords: ["plumber", "woman", "human", "wrench"], char: "👩‍🔧", fitzpatrick_scale: !0, category: "people" }, man_mechanic = { keywords: ["plumber", "man", "human", "wrench"], char: "👨‍🔧", fitzpatrick_scale: !0, category: "people" }, woman_scientist = { keywords: ["biologist", "chemist", "engineer", "physicist", "woman", "human"], char: "👩‍🔬", fitzpatrick_scale: !0, category: "people" }, man_scientist = { keywords: ["biologist", "chemist", "engineer", "physicist", "man", "human"], char: "👨‍🔬", fitzpatrick_scale: !0, category: "people" }, woman_artist = { keywords: ["painter", "woman", "human"], char: "👩‍🎨", fitzpatrick_scale: !0, category: "people" }, man_artist = { keywords: ["painter", "man", "human"], char: "👨‍🎨", fitzpatrick_scale: !0, category: "people" }, woman_firefighter = { keywords: ["fireman", "woman", "human"], char: "👩‍🚒", fitzpatrick_scale: !0, category: "people" }, man_firefighter = { keywords: ["fireman", "man", "human"], char: "👨‍🚒", fitzpatrick_scale: !0, category: "people" }, woman_pilot = { keywords: ["aviator", "plane", "woman", "human"], char: "👩‍✈️", fitzpatrick_scale: !0, category: "people" }, man_pilot = { keywords: ["aviator", "plane", "man", "human"], char: "👨‍✈️", fitzpatrick_scale: !0, category: "people" }, woman_astronaut = { keywords: ["space", "rocket", "woman", "human"], char: "👩‍🚀", fitzpatrick_scale: !0, category: "people" }, man_astronaut = { keywords: ["space", "rocket", "man", "human"], char: "👨‍🚀", fitzpatrick_scale: !0, category: "people" }, woman_judge = { keywords: ["justice", "court", "woman", "human"], char: "👩‍⚖️", fitzpatrick_scale: !0, category: "people" }, man_judge = { keywords: ["justice", "court", "man", "human"], char: "👨‍⚖️", fitzpatrick_scale: !0, category: "people" }, woman_superhero = { keywords: ["woman", "female", "good", "heroine", "superpowers"], char: "🦸‍♀️", fitzpatrick_scale: !0, category: "people" }, man_superhero = { keywords: ["man", "male", "good", "hero", "superpowers"], char: "🦸‍♂️", fitzpatrick_scale: !0, category: "people" }, woman_supervillain = { keywords: ["woman", "female", "evil", "bad", "criminal", "heroine", "superpowers"], char: "🦹‍♀️", fitzpatrick_scale: !0, category: "people" }, man_supervillain = { keywords: ["man", "male", "evil", "bad", "criminal", "hero", "superpowers"], char: "🦹‍♂️", fitzpatrick_scale: !0, category: "people" }, mrs_claus = { keywords: ["woman", "female", "xmas", "mother christmas"], char: "🤶", fitzpatrick_scale: !0, category: "people" }, santa = { keywords: ["festival", "man", "male", "xmas", "father christmas"], char: "🎅", fitzpatrick_scale: !0, category: "people" }, sorceress = { keywords: ["woman", "female", "mage", "witch"], char: "🧙‍♀️", fitzpatrick_scale: !0, category: "people" }, wizard = { keywords: ["man", "male", "mage", "sorcerer"], char: "🧙‍♂️", fitzpatrick_scale: !0, category: "people" }, woman_elf = { keywords: ["woman", "female"], char: "🧝‍♀️", fitzpatrick_scale: !0, category: "people" }, man_elf = { keywords: ["man", "male"], char: "🧝‍♂️", fitzpatrick_scale: !0, category: "people" }, woman_vampire = { keywords: ["woman", "female"], char: "🧛‍♀️", fitzpatrick_scale: !0, category: "people" }, man_vampire = { keywords: ["man", "male", "dracula"], char: "🧛‍♂️", fitzpatrick_scale: !0, category: "people" }, woman_zombie = { keywords: ["woman", "female", "undead", "walking dead"], char: "🧟‍♀️", fitzpatrick_scale: !1, category: "people" }, man_zombie = { keywords: ["man", "male", "dracula", "undead", "walking dead"], char: "🧟‍♂️", fitzpatrick_scale: !1, category: "people" }, woman_genie = { keywords: ["woman", "female"], char: "🧞‍♀️", fitzpatrick_scale: !1, category: "people" }, man_genie = { keywords: ["man", "male"], char: "🧞‍♂️", fitzpatrick_scale: !1, category: "people" }, mermaid = { keywords: ["woman", "female", "merwoman", "ariel"], char: "🧜‍♀️", fitzpatrick_scale: !0, category: "people" }, merman = { keywords: ["man", "male", "triton"], char: "🧜‍♂️", fitzpatrick_scale: !0, category: "people" }, woman_fairy = { keywords: ["woman", "female"], char: "🧚‍♀️", fitzpatrick_scale: !0, category: "people" }, man_fairy = { keywords: ["man", "male"], char: "🧚‍♂️", fitzpatrick_scale: !0, category: "people" }, angel = { keywords: ["heaven", "wings", "halo"], char: "👼", fitzpatrick_scale: !0, category: "people" }, pregnant_woman = { keywords: ["baby"], char: "🤰", fitzpatrick_scale: !0, category: "people" }, breastfeeding = { keywords: ["nursing", "baby"], char: "🤱", fitzpatrick_scale: !0, category: "people" }, princess = { keywords: ["girl", "woman", "female", "blond", "crown", "royal", "queen"], char: "👸", fitzpatrick_scale: !0, category: "people" }, prince = { keywords: ["boy", "man", "male", "crown", "royal", "king"], char: "🤴", fitzpatrick_scale: !0, category: "people" }, bride_with_veil = { keywords: ["couple", "marriage", "wedding", "woman", "bride"], char: "👰", fitzpatrick_scale: !0, category: "people" }, man_in_tuxedo = { keywords: ["couple", "marriage", "wedding", "groom"], char: "🤵", fitzpatrick_scale: !0, category: "people" }, running_woman = { keywords: ["woman", "walking", "exercise", "race", "running", "female"], char: "🏃‍♀️", fitzpatrick_scale: !0, category: "people" }, running_man = { keywords: ["man", "walking", "exercise", "race", "running"], char: "🏃", fitzpatrick_scale: !0, category: "people" }, walking_woman = { keywords: ["human", "feet", "steps", "woman", "female"], char: "🚶‍♀️", fitzpatrick_scale: !0, category: "people" }, walking_man = { keywords: ["human", "feet", "steps"], char: "🚶", fitzpatrick_scale: !0, category: "people" }, dancer = { keywords: ["female", "girl", "woman", "fun"], char: "💃", fitzpatrick_scale: !0, category: "people" }, man_dancing = { keywords: ["male", "boy", "fun", "dancer"], char: "🕺", fitzpatrick_scale: !0, category: "people" }, dancing_women = { keywords: ["female", "bunny", "women", "girls"], char: "👯", fitzpatrick_scale: !1, category: "people" }, dancing_men = { keywords: ["male", "bunny", "men", "boys"], char: "👯‍♂️", fitzpatrick_scale: !1, category: "people" }, couple = { keywords: ["pair", "people", "human", "love", "date", "dating", "like", "affection", "valentines", "marriage"], char: "👫", fitzpatrick_scale: !1, category: "people" }, two_men_holding_hands = { keywords: ["pair", "couple", "love", "like", "bromance", "friendship", "people", "human"], char: "👬", fitzpatrick_scale: !1, category: "people" }, two_women_holding_hands = { keywords: ["pair", "friendship", "couple", "love", "like", "female", "people", "human"], char: "👭", fitzpatrick_scale: !1, category: "people" }, bowing_woman = { keywords: ["woman", "female", "girl"], char: "🙇‍♀️", fitzpatrick_scale: !0, category: "people" }, bowing_man = { keywords: ["man", "male", "boy"], char: "🙇", fitzpatrick_scale: !0, category: "people" }, man_facepalming = { keywords: ["man", "male", "boy", "disbelief"], char: "🤦‍♂️", fitzpatrick_scale: !0, category: "people" }, woman_facepalming = { keywords: ["woman", "female", "girl", "disbelief"], char: "🤦‍♀️", fitzpatrick_scale: !0, category: "people" }, woman_shrugging = { keywords: ["woman", "female", "girl", "confused", "indifferent", "doubt"], char: "🤷", fitzpatrick_scale: !0, category: "people" }, man_shrugging = { keywords: ["man", "male", "boy", "confused", "indifferent", "doubt"], char: "🤷‍♂️", fitzpatrick_scale: !0, category: "people" }, tipping_hand_woman = { keywords: ["female", "girl", "woman", "human", "information"], char: "💁", fitzpatrick_scale: !0, category: "people" }, tipping_hand_man = { keywords: ["male", "boy", "man", "human", "information"], char: "💁‍♂️", fitzpatrick_scale: !0, category: "people" }, no_good_woman = { keywords: ["female", "girl", "woman", "nope"], char: "🙅", fitzpatrick_scale: !0, category: "people" }, no_good_man = { keywords: ["male", "boy", "man", "nope"], char: "🙅‍♂️", fitzpatrick_scale: !0, category: "people" }, ok_woman = { keywords: ["women", "girl", "female", "pink", "human", "woman"], char: "🙆", fitzpatrick_scale: !0, category: "people" }, ok_man = { keywords: ["men", "boy", "male", "blue", "human", "man"], char: "🙆‍♂️", fitzpatrick_scale: !0, category: "people" }, raising_hand_woman = { keywords: ["female", "girl", "woman"], char: "🙋", fitzpatrick_scale: !0, category: "people" }, raising_hand_man = { keywords: ["male", "boy", "man"], char: "🙋‍♂️", fitzpatrick_scale: !0, category: "people" }, pouting_woman = { keywords: ["female", "girl", "woman"], char: "🙎", fitzpatrick_scale: !0, category: "people" }, pouting_man = { keywords: ["male", "boy", "man"], char: "🙎‍♂️", fitzpatrick_scale: !0, category: "people" }, frowning_woman = { keywords: ["female", "girl", "woman", "sad", "depressed", "discouraged", "unhappy"], char: "🙍", fitzpatrick_scale: !0, category: "people" }, frowning_man = { keywords: ["male", "boy", "man", "sad", "depressed", "discouraged", "unhappy"], char: "🙍‍♂️", fitzpatrick_scale: !0, category: "people" }, haircut_woman = { keywords: ["female", "girl", "woman"], char: "💇", fitzpatrick_scale: !0, category: "people" }, haircut_man = { keywords: ["male", "boy", "man"], char: "💇‍♂️", fitzpatrick_scale: !0, category: "people" }, massage_woman = { keywords: ["female", "girl", "woman", "head"], char: "💆", fitzpatrick_scale: !0, category: "people" }, massage_man = { keywords: ["male", "boy", "man", "head"], char: "💆‍♂️", fitzpatrick_scale: !0, category: "people" }, woman_in_steamy_room = { keywords: ["female", "woman", "spa", "steamroom", "sauna"], char: "🧖‍♀️", fitzpatrick_scale: !0, category: "people" }, man_in_steamy_room = { keywords: ["male", "man", "spa", "steamroom", "sauna"], char: "🧖‍♂️", fitzpatrick_scale: !0, category: "people" }, couple_with_heart_woman_man = { keywords: ["pair", "love", "like", "affection", "human", "dating", "valentines", "marriage"], char: "💑", fitzpatrick_scale: !1, category: "people" }, couple_with_heart_woman_woman = { keywords: ["pair", "love", "like", "affection", "human", "dating", "valentines", "marriage"], char: "👩‍❤️‍👩", fitzpatrick_scale: !1, category: "people" }, couple_with_heart_man_man = { keywords: ["pair", "love", "like", "affection", "human", "dating", "valentines", "marriage"], char: "👨‍❤️‍👨", fitzpatrick_scale: !1, category: "people" }, couplekiss_man_woman = { keywords: ["pair", "valentines", "love", "like", "dating", "marriage"], char: "💏", fitzpatrick_scale: !1, category: "people" }, couplekiss_woman_woman = { keywords: ["pair", "valentines", "love", "like", "dating", "marriage"], char: "👩‍❤️‍💋‍👩", fitzpatrick_scale: !1, category: "people" }, couplekiss_man_man = { keywords: ["pair", "valentines", "love", "like", "dating", "marriage"], char: "👨‍❤️‍💋‍👨", fitzpatrick_scale: !1, category: "people" }, family_man_woman_boy = { keywords: ["home", "parents", "child", "mom", "dad", "father", "mother", "people", "human"], char: "👪", fitzpatrick_scale: !1, category: "people" }, family_man_woman_girl = { keywords: ["home", "parents", "people", "human", "child"], char: "👨‍👩‍👧", fitzpatrick_scale: !1, category: "people" }, family_man_woman_girl_boy = { keywords: ["home", "parents", "people", "human", "children"], char: "👨‍👩‍👧‍👦", fitzpatrick_scale: !1, category: "people" }, family_man_woman_boy_boy = { keywords: ["home", "parents", "people", "human", "children"], char: "👨‍👩‍👦‍👦", fitzpatrick_scale: !1, category: "people" }, family_man_woman_girl_girl = { keywords: ["home", "parents", "people", "human", "children"], char: "👨‍👩‍👧‍👧", fitzpatrick_scale: !1, category: "people" }, family_woman_woman_boy = { keywords: ["home", "parents", "people", "human", "children"], char: "👩‍👩‍👦", fitzpatrick_scale: !1, category: "people" }, family_woman_woman_girl = { keywords: ["home", "parents", "people", "human", "children"], char: "👩‍👩‍👧", fitzpatrick_scale: !1, category: "people" }, family_woman_woman_girl_boy = { keywords: ["home", "parents", "people", "human", "children"], char: "👩‍👩‍👧‍👦", fitzpatrick_scale: !1, category: "people" }, family_woman_woman_boy_boy = { keywords: ["home", "parents", "people", "human", "children"], char: "👩‍👩‍👦‍👦", fitzpatrick_scale: !1, category: "people" }, family_woman_woman_girl_girl = { keywords: ["home", "parents", "people", "human", "children"], char: "👩‍👩‍👧‍👧", fitzpatrick_scale: !1, category: "people" }, family_man_man_boy = { keywords: ["home", "parents", "people", "human", "children"], char: "👨‍👨‍👦", fitzpatrick_scale: !1, category: "people" }, family_man_man_girl = { keywords: ["home", "parents", "people", "human", "children"], char: "👨‍👨‍👧", fitzpatrick_scale: !1, category: "people" }, family_man_man_girl_boy = { keywords: ["home", "parents", "people", "human", "children"], char: "👨‍👨‍👧‍👦", fitzpatrick_scale: !1, category: "people" }, family_man_man_boy_boy = { keywords: ["home", "parents", "people", "human", "children"], char: "👨‍👨‍👦‍👦", fitzpatrick_scale: !1, category: "people" }, family_man_man_girl_girl = { keywords: ["home", "parents", "people", "human", "children"], char: "👨‍👨‍👧‍👧", fitzpatrick_scale: !1, category: "people" }, family_woman_boy = { keywords: ["home", "parent", "people", "human", "child"], char: "👩‍👦", fitzpatrick_scale: !1, category: "people" }, family_woman_girl = { keywords: ["home", "parent", "people", "human", "child"], char: "👩‍👧", fitzpatrick_scale: !1, category: "people" }, family_woman_girl_boy = { keywords: ["home", "parent", "people", "human", "children"], char: "👩‍👧‍👦", fitzpatrick_scale: !1, category: "people" }, family_woman_boy_boy = { keywords: ["home", "parent", "people", "human", "children"], char: "👩‍👦‍👦", fitzpatrick_scale: !1, category: "people" }, family_woman_girl_girl = { keywords: ["home", "parent", "people", "human", "children"], char: "👩‍👧‍👧", fitzpatrick_scale: !1, category: "people" }, family_man_boy = { keywords: ["home", "parent", "people", "human", "child"], char: "👨‍👦", fitzpatrick_scale: !1, category: "people" }, family_man_girl = { keywords: ["home", "parent", "people", "human", "child"], char: "👨‍👧", fitzpatrick_scale: !1, category: "people" }, family_man_girl_boy = { keywords: ["home", "parent", "people", "human", "children"], char: "👨‍👧‍👦", fitzpatrick_scale: !1, category: "people" }, family_man_boy_boy = { keywords: ["home", "parent", "people", "human", "children"], char: "👨‍👦‍👦", fitzpatrick_scale: !1, category: "people" }, family_man_girl_girl = { keywords: ["home", "parent", "people", "human", "children"], char: "👨‍👧‍👧", fitzpatrick_scale: !1, category: "people" }, yarn = { keywords: ["ball", "crochet", "knit"], char: "🧶", fitzpatrick_scale: !1, category: "people" }, thread = { keywords: ["needle", "sewing", "spool", "string"], char: "🧵", fitzpatrick_scale: !1, category: "people" }, coat = { keywords: ["jacket"], char: "🧥", fitzpatrick_scale: !1, category: "people" }, labcoat = { keywords: ["doctor", "experiment", "scientist", "chemist"], char: "🥼", fitzpatrick_scale: !1, category: "people" }, womans_clothes = { keywords: ["fashion", "shopping_bags", "female"], char: "👚", fitzpatrick_scale: !1, category: "people" }, tshirt = { keywords: ["fashion", "cloth", "casual", "shirt", "tee"], char: "👕", fitzpatrick_scale: !1, category: "people" }, jeans = { keywords: ["fashion", "shopping"], char: "👖", fitzpatrick_scale: !1, category: "people" }, necktie = { keywords: ["shirt", "suitup", "formal", "fashion", "cloth", "business"], char: "👔", fitzpatrick_scale: !1, category: "people" }, dress = { keywords: ["clothes", "fashion", "shopping"], char: "👗", fitzpatrick_scale: !1, category: "people" }, bikini = { keywords: ["swimming", "female", "woman", "girl", "fashion", "beach", "summer"], char: "👙", fitzpatrick_scale: !1, category: "people" }, kimono = { keywords: ["dress", "fashion", "women", "female", "japanese"], char: "👘", fitzpatrick_scale: !1, category: "people" }, lipstick = { keywords: ["female", "girl", "fashion", "woman"], char: "💄", fitzpatrick_scale: !1, category: "people" }, kiss = { keywords: ["face", "lips", "love", "like", "affection", "valentines"], char: "💋", fitzpatrick_scale: !1, category: "people" }, footprints = { keywords: ["feet", "tracking", "walking", "beach"], char: "👣", fitzpatrick_scale: !1, category: "people" }, flat_shoe = { keywords: ["ballet", "slip-on", "slipper"], char: "🥿", fitzpatrick_scale: !1, category: "people" }, high_heel = { keywords: ["fashion", "shoes", "female", "pumps", "stiletto"], char: "👠", fitzpatrick_scale: !1, category: "people" }, sandal = { keywords: ["shoes", "fashion", "flip flops"], char: "👡", fitzpatrick_scale: !1, category: "people" }, boot = { keywords: ["shoes", "fashion"], char: "👢", fitzpatrick_scale: !1, category: "people" }, mans_shoe = { keywords: ["fashion", "male"], char: "👞", fitzpatrick_scale: !1, category: "people" }, athletic_shoe = { keywords: ["shoes", "sports", "sneakers"], char: "👟", fitzpatrick_scale: !1, category: "people" }, hiking_boot = { keywords: ["backpacking", "camping", "hiking"], char: "🥾", fitzpatrick_scale: !1, category: "people" }, socks = { keywords: ["stockings", "clothes"], char: "🧦", fitzpatrick_scale: !1, category: "people" }, gloves = { keywords: ["hands", "winter", "clothes"], char: "🧤", fitzpatrick_scale: !1, category: "people" }, scarf = { keywords: ["neck", "winter", "clothes"], char: "🧣", fitzpatrick_scale: !1, category: "people" }, womans_hat = { keywords: ["fashion", "accessories", "female", "lady", "spring"], char: "👒", fitzpatrick_scale: !1, category: "people" }, tophat = { keywords: ["magic", "gentleman", "classy", "circus"], char: "🎩", fitzpatrick_scale: !1, category: "people" }, billed_hat = { keywords: ["cap", "baseball"], char: "🧢", fitzpatrick_scale: !1, category: "people" }, rescue_worker_helmet = { keywords: ["construction", "build"], char: "⛑", fitzpatrick_scale: !1, category: "people" }, mortar_board = { keywords: ["school", "college", "degree", "university", "graduation", "cap", "hat", "legal", "learn", "education"], char: "🎓", fitzpatrick_scale: !1, category: "people" }, crown = { keywords: ["king", "kod", "leader", "royalty", "lord"], char: "👑", fitzpatrick_scale: !1, category: "people" }, school_satchel = { keywords: ["student", "education", "bag", "backpack"], char: "🎒", fitzpatrick_scale: !1, category: "people" }, luggage = { keywords: ["packing", "travel"], char: "🧳", fitzpatrick_scale: !1, category: "people" }, pouch = { keywords: ["bag", "accessories", "shopping"], char: "👝", fitzpatrick_scale: !1, category: "people" }, purse = { keywords: ["fashion", "accessories", "money", "sales", "shopping"], char: "👛", fitzpatrick_scale: !1, category: "people" }, handbag = { keywords: ["fashion", "accessory", "accessories", "shopping"], char: "👜", fitzpatrick_scale: !1, category: "people" }, briefcase = { keywords: ["business", "documents", "work", "law", "legal", "job", "career"], char: "💼", fitzpatrick_scale: !1, category: "people" }, eyeglasses = { keywords: ["fashion", "accessories", "eyesight", "nerdy", "dork", "geek"], char: "👓", fitzpatrick_scale: !1, category: "people" }, dark_sunglasses = { keywords: ["face", "cool", "accessories"], char: "🕶", fitzpatrick_scale: !1, category: "people" }, goggles = { keywords: ["eyes", "protection", "safety"], char: "🥽", fitzpatrick_scale: !1, category: "people" }, ring = { keywords: ["wedding", "propose", "marriage", "valentines", "diamond", "fashion", "jewelry", "gem", "engagement"], char: "💍", fitzpatrick_scale: !1, category: "people" }, closed_umbrella = { keywords: ["weather", "rain", "drizzle"], char: "🌂", fitzpatrick_scale: !1, category: "people" }, dog = { keywords: ["animal", "friend", "nature", "woof", "puppy", "pet", "faithful"], char: "🐶", fitzpatrick_scale: !1, category: "animals_and_nature" }, cat = { keywords: ["animal", "meow", "nature", "pet", "kitten"], char: "🐱", fitzpatrick_scale: !1, category: "animals_and_nature" }, mouse = { keywords: ["animal", "nature", "cheese_wedge", "rodent"], char: "🐭", fitzpatrick_scale: !1, category: "animals_and_nature" }, hamster = { keywords: ["animal", "nature"], char: "🐹", fitzpatrick_scale: !1, category: "animals_and_nature" }, rabbit = { keywords: ["animal", "nature", "pet", "spring", "magic", "bunny"], char: "🐰", fitzpatrick_scale: !1, category: "animals_and_nature" }, fox_face = { keywords: ["animal", "nature", "face"], char: "🦊", fitzpatrick_scale: !1, category: "animals_and_nature" }, bear = { keywords: ["animal", "nature", "wild"], char: "🐻", fitzpatrick_scale: !1, category: "animals_and_nature" }, panda_face = { keywords: ["animal", "nature", "panda"], char: "🐼", fitzpatrick_scale: !1, category: "animals_and_nature" }, koala = { keywords: ["animal", "nature"], char: "🐨", fitzpatrick_scale: !1, category: "animals_and_nature" }, tiger = { keywords: ["animal", "cat", "danger", "wild", "nature", "roar"], char: "🐯", fitzpatrick_scale: !1, category: "animals_and_nature" }, lion = { keywords: ["animal", "nature"], char: "🦁", fitzpatrick_scale: !1, category: "animals_and_nature" }, cow = { keywords: ["beef", "ox", "animal", "nature", "moo", "milk"], char: "🐮", fitzpatrick_scale: !1, category: "animals_and_nature" }, pig = { keywords: ["animal", "oink", "nature"], char: "🐷", fitzpatrick_scale: !1, category: "animals_and_nature" }, pig_nose = { keywords: ["animal", "oink"], char: "🐽", fitzpatrick_scale: !1, category: "animals_and_nature" }, frog = { keywords: ["animal", "nature", "croak", "toad"], char: "🐸", fitzpatrick_scale: !1, category: "animals_and_nature" }, squid = { keywords: ["animal", "nature", "ocean", "sea"], char: "🦑", fitzpatrick_scale: !1, category: "animals_and_nature" }, octopus = { keywords: ["animal", "creature", "ocean", "sea", "nature", "beach"], char: "🐙", fitzpatrick_scale: !1, category: "animals_and_nature" }, shrimp = { keywords: ["animal", "ocean", "nature", "seafood"], char: "🦐", fitzpatrick_scale: !1, category: "animals_and_nature" }, monkey_face = { keywords: ["animal", "nature", "circus"], char: "🐵", fitzpatrick_scale: !1, category: "animals_and_nature" }, gorilla = { keywords: ["animal", "nature", "circus"], char: "🦍", fitzpatrick_scale: !1, category: "animals_and_nature" }, see_no_evil = { keywords: ["monkey", "animal", "nature", "haha"], char: "🙈", fitzpatrick_scale: !1, category: "animals_and_nature" }, hear_no_evil = { keywords: ["animal", "monkey", "nature"], char: "🙉", fitzpatrick_scale: !1, category: "animals_and_nature" }, speak_no_evil = { keywords: ["monkey", "animal", "nature", "omg"], char: "🙊", fitzpatrick_scale: !1, category: "animals_and_nature" }, monkey = { keywords: ["animal", "nature", "banana", "circus"], char: "🐒", fitzpatrick_scale: !1, category: "animals_and_nature" }, chicken = { keywords: ["animal", "cluck", "nature", "bird"], char: "🐔", fitzpatrick_scale: !1, category: "animals_and_nature" }, penguin = { keywords: ["animal", "nature"], char: "🐧", fitzpatrick_scale: !1, category: "animals_and_nature" }, bird = { keywords: ["animal", "nature", "fly", "tweet", "spring"], char: "🐦", fitzpatrick_scale: !1, category: "animals_and_nature" }, baby_chick = { keywords: ["animal", "chicken", "bird"], char: "🐤", fitzpatrick_scale: !1, category: "animals_and_nature" }, hatching_chick = { keywords: ["animal", "chicken", "egg", "born", "baby", "bird"], char: "🐣", fitzpatrick_scale: !1, category: "animals_and_nature" }, hatched_chick = { keywords: ["animal", "chicken", "baby", "bird"], char: "🐥", fitzpatrick_scale: !1, category: "animals_and_nature" }, duck = { keywords: ["animal", "nature", "bird", "mallard"], char: "🦆", fitzpatrick_scale: !1, category: "animals_and_nature" }, eagle = { keywords: ["animal", "nature", "bird"], char: "🦅", fitzpatrick_scale: !1, category: "animals_and_nature" }, owl = { keywords: ["animal", "nature", "bird", "hoot"], char: "🦉", fitzpatrick_scale: !1, category: "animals_and_nature" }, bat = { keywords: ["animal", "nature", "blind", "vampire"], char: "🦇", fitzpatrick_scale: !1, category: "animals_and_nature" }, wolf = { keywords: ["animal", "nature", "wild"], char: "🐺", fitzpatrick_scale: !1, category: "animals_and_nature" }, boar = { keywords: ["animal", "nature"], char: "🐗", fitzpatrick_scale: !1, category: "animals_and_nature" }, horse = { keywords: ["animal", "brown", "nature"], char: "🐴", fitzpatrick_scale: !1, category: "animals_and_nature" }, unicorn = { keywords: ["animal", "nature", "mystical"], char: "🦄", fitzpatrick_scale: !1, category: "animals_and_nature" }, honeybee = { keywords: ["animal", "insect", "nature", "bug", "spring", "honey"], char: "🐝", fitzpatrick_scale: !1, category: "animals_and_nature" }, bug = { keywords: ["animal", "insect", "nature", "worm"], char: "🐛", fitzpatrick_scale: !1, category: "animals_and_nature" }, butterfly = { keywords: ["animal", "insect", "nature", "caterpillar"], char: "🦋", fitzpatrick_scale: !1, category: "animals_and_nature" }, snail = { keywords: ["slow", "animal", "shell"], char: "🐌", fitzpatrick_scale: !1, category: "animals_and_nature" }, beetle = { keywords: ["animal", "insect", "nature", "ladybug"], char: "🐞", fitzpatrick_scale: !1, category: "animals_and_nature" }, ant = { keywords: ["animal", "insect", "nature", "bug"], char: "🐜", fitzpatrick_scale: !1, category: "animals_and_nature" }, grasshopper = { keywords: ["animal", "cricket", "chirp"], char: "🦗", fitzpatrick_scale: !1, category: "animals_and_nature" }, spider = { keywords: ["animal", "arachnid"], char: "🕷", fitzpatrick_scale: !1, category: "animals_and_nature" }, scorpion = { keywords: ["animal", "arachnid"], char: "🦂", fitzpatrick_scale: !1, category: "animals_and_nature" }, crab = { keywords: ["animal", "crustacean"], char: "🦀", fitzpatrick_scale: !1, category: "animals_and_nature" }, snake = { keywords: ["animal", "evil", "nature", "hiss", "python"], char: "🐍", fitzpatrick_scale: !1, category: "animals_and_nature" }, lizard = { keywords: ["animal", "nature", "reptile"], char: "🦎", fitzpatrick_scale: !1, category: "animals_and_nature" }, sauropod = { keywords: ["animal", "nature", "dinosaur", "brachiosaurus", "brontosaurus", "diplodocus", "extinct"], char: "🦕", fitzpatrick_scale: !1, category: "animals_and_nature" }, turtle = { keywords: ["animal", "slow", "nature", "tortoise"], char: "🐢", fitzpatrick_scale: !1, category: "animals_and_nature" }, tropical_fish = { keywords: ["animal", "swim", "ocean", "beach", "nemo"], char: "🐠", fitzpatrick_scale: !1, category: "animals_and_nature" }, fish = { keywords: ["animal", "food", "nature"], char: "🐟", fitzpatrick_scale: !1, category: "animals_and_nature" }, blowfish = { keywords: ["animal", "nature", "food", "sea", "ocean"], char: "🐡", fitzpatrick_scale: !1, category: "animals_and_nature" }, dolphin = { keywords: ["animal", "nature", "fish", "sea", "ocean", "flipper", "fins", "beach"], char: "🐬", fitzpatrick_scale: !1, category: "animals_and_nature" }, shark = { keywords: ["animal", "nature", "fish", "sea", "ocean", "jaws", "fins", "beach"], char: "🦈", fitzpatrick_scale: !1, category: "animals_and_nature" }, whale = { keywords: ["animal", "nature", "sea", "ocean"], char: "🐳", fitzpatrick_scale: !1, category: "animals_and_nature" }, whale2 = { keywords: ["animal", "nature", "sea", "ocean"], char: "🐋", fitzpatrick_scale: !1, category: "animals_and_nature" }, crocodile = { keywords: ["animal", "nature", "reptile", "lizard", "alligator"], char: "🐊", fitzpatrick_scale: !1, category: "animals_and_nature" }, leopard = { keywords: ["animal", "nature"], char: "🐆", fitzpatrick_scale: !1, category: "animals_and_nature" }, zebra = { keywords: ["animal", "nature", "stripes", "safari"], char: "🦓", fitzpatrick_scale: !1, category: "animals_and_nature" }, tiger2 = { keywords: ["animal", "nature", "roar"], char: "🐅", fitzpatrick_scale: !1, category: "animals_and_nature" }, water_buffalo = { keywords: ["animal", "nature", "ox", "cow"], char: "🐃", fitzpatrick_scale: !1, category: "animals_and_nature" }, ox = { keywords: ["animal", "cow", "beef"], char: "🐂", fitzpatrick_scale: !1, category: "animals_and_nature" }, cow2 = { keywords: ["beef", "ox", "animal", "nature", "moo", "milk"], char: "🐄", fitzpatrick_scale: !1, category: "animals_and_nature" }, deer = { keywords: ["animal", "nature", "horns", "venison"], char: "🦌", fitzpatrick_scale: !1, category: "animals_and_nature" }, dromedary_camel = { keywords: ["animal", "hot", "desert", "hump"], char: "🐪", fitzpatrick_scale: !1, category: "animals_and_nature" }, camel = { keywords: ["animal", "nature", "hot", "desert", "hump"], char: "🐫", fitzpatrick_scale: !1, category: "animals_and_nature" }, giraffe = { keywords: ["animal", "nature", "spots", "safari"], char: "🦒", fitzpatrick_scale: !1, category: "animals_and_nature" }, elephant = { keywords: ["animal", "nature", "nose", "th", "circus"], char: "🐘", fitzpatrick_scale: !1, category: "animals_and_nature" }, rhinoceros = { keywords: ["animal", "nature", "horn"], char: "🦏", fitzpatrick_scale: !1, category: "animals_and_nature" }, goat = { keywords: ["animal", "nature"], char: "🐐", fitzpatrick_scale: !1, category: "animals_and_nature" }, ram = { keywords: ["animal", "sheep", "nature"], char: "🐏", fitzpatrick_scale: !1, category: "animals_and_nature" }, sheep = { keywords: ["animal", "nature", "wool", "shipit"], char: "🐑", fitzpatrick_scale: !1, category: "animals_and_nature" }, racehorse = { keywords: ["animal", "gamble", "luck"], char: "🐎", fitzpatrick_scale: !1, category: "animals_and_nature" }, pig2 = { keywords: ["animal", "nature"], char: "🐖", fitzpatrick_scale: !1, category: "animals_and_nature" }, rat = { keywords: ["animal", "mouse", "rodent"], char: "🐀", fitzpatrick_scale: !1, category: "animals_and_nature" }, mouse2 = { keywords: ["animal", "nature", "rodent"], char: "🐁", fitzpatrick_scale: !1, category: "animals_and_nature" }, rooster = { keywords: ["animal", "nature", "chicken"], char: "🐓", fitzpatrick_scale: !1, category: "animals_and_nature" }, turkey = { keywords: ["animal", "bird"], char: "🦃", fitzpatrick_scale: !1, category: "animals_and_nature" }, dove = { keywords: ["animal", "bird"], char: "🕊", fitzpatrick_scale: !1, category: "animals_and_nature" }, dog2 = { keywords: ["animal", "nature", "friend", "doge", "pet", "faithful"], char: "🐕", fitzpatrick_scale: !1, category: "animals_and_nature" }, poodle = { keywords: ["dog", "animal", "101", "nature", "pet"], char: "🐩", fitzpatrick_scale: !1, category: "animals_and_nature" }, cat2 = { keywords: ["animal", "meow", "pet", "cats"], char: "🐈", fitzpatrick_scale: !1, category: "animals_and_nature" }, rabbit2 = { keywords: ["animal", "nature", "pet", "magic", "spring"], char: "🐇", fitzpatrick_scale: !1, category: "animals_and_nature" }, chipmunk = { keywords: ["animal", "nature", "rodent", "squirrel"], char: "🐿", fitzpatrick_scale: !1, category: "animals_and_nature" }, hedgehog = { keywords: ["animal", "nature", "spiny"], char: "🦔", fitzpatrick_scale: !1, category: "animals_and_nature" }, raccoon = { keywords: ["animal", "nature"], char: "🦝", fitzpatrick_scale: !1, category: "animals_and_nature" }, llama = { keywords: ["animal", "nature", "alpaca"], char: "🦙", fitzpatrick_scale: !1, category: "animals_and_nature" }, hippopotamus = { keywords: ["animal", "nature"], char: "🦛", fitzpatrick_scale: !1, category: "animals_and_nature" }, kangaroo = { keywords: ["animal", "nature", "australia", "joey", "hop", "marsupial"], char: "🦘", fitzpatrick_scale: !1, category: "animals_and_nature" }, badger = { keywords: ["animal", "nature", "honey"], char: "🦡", fitzpatrick_scale: !1, category: "animals_and_nature" }, swan = { keywords: ["animal", "nature", "bird"], char: "🦢", fitzpatrick_scale: !1, category: "animals_and_nature" }, peacock = { keywords: ["animal", "nature", "peahen", "bird"], char: "🦚", fitzpatrick_scale: !1, category: "animals_and_nature" }, parrot = { keywords: ["animal", "nature", "bird", "pirate", "talk"], char: "🦜", fitzpatrick_scale: !1, category: "animals_and_nature" }, lobster = { keywords: ["animal", "nature", "bisque", "claws", "seafood"], char: "🦞", fitzpatrick_scale: !1, category: "animals_and_nature" }, mosquito = { keywords: ["animal", "nature", "insect", "malaria"], char: "🦟", fitzpatrick_scale: !1, category: "animals_and_nature" }, paw_prints = { keywords: ["animal", "tracking", "footprints", "dog", "cat", "pet", "feet"], char: "🐾", fitzpatrick_scale: !1, category: "animals_and_nature" }, dragon = { keywords: ["animal", "myth", "nature", "chinese", "green"], char: "🐉", fitzpatrick_scale: !1, category: "animals_and_nature" }, dragon_face = { keywords: ["animal", "myth", "nature", "chinese", "green"], char: "🐲", fitzpatrick_scale: !1, category: "animals_and_nature" }, cactus = { keywords: ["vegetable", "plant", "nature"], char: "🌵", fitzpatrick_scale: !1, category: "animals_and_nature" }, christmas_tree = { keywords: ["festival", "vacation", "december", "xmas", "celebration"], char: "🎄", fitzpatrick_scale: !1, category: "animals_and_nature" }, evergreen_tree = { keywords: ["plant", "nature"], char: "🌲", fitzpatrick_scale: !1, category: "animals_and_nature" }, deciduous_tree = { keywords: ["plant", "nature"], char: "🌳", fitzpatrick_scale: !1, category: "animals_and_nature" }, palm_tree = { keywords: ["plant", "vegetable", "nature", "summer", "beach", "mojito", "tropical"], char: "🌴", fitzpatrick_scale: !1, category: "animals_and_nature" }, seedling = { keywords: ["plant", "nature", "grass", "lawn", "spring"], char: "🌱", fitzpatrick_scale: !1, category: "animals_and_nature" }, herb = { keywords: ["vegetable", "plant", "medicine", "weed", "grass", "lawn"], char: "🌿", fitzpatrick_scale: !1, category: "animals_and_nature" }, shamrock = { keywords: ["vegetable", "plant", "nature", "irish", "clover"], char: "☘", fitzpatrick_scale: !1, category: "animals_and_nature" }, four_leaf_clover = { keywords: ["vegetable", "plant", "nature", "lucky", "irish"], char: "🍀", fitzpatrick_scale: !1, category: "animals_and_nature" }, bamboo = { keywords: ["plant", "nature", "vegetable", "panda", "pine_decoration"], char: "🎍", fitzpatrick_scale: !1, category: "animals_and_nature" }, tanabata_tree = { keywords: ["plant", "nature", "branch", "summer"], char: "🎋", fitzpatrick_scale: !1, category: "animals_and_nature" }, leaves = { keywords: ["nature", "plant", "tree", "vegetable", "grass", "lawn", "spring"], char: "🍃", fitzpatrick_scale: !1, category: "animals_and_nature" }, fallen_leaf = { keywords: ["nature", "plant", "vegetable", "leaves"], char: "🍂", fitzpatrick_scale: !1, category: "animals_and_nature" }, maple_leaf = { keywords: ["nature", "plant", "vegetable", "ca", "fall"], char: "🍁", fitzpatrick_scale: !1, category: "animals_and_nature" }, ear_of_rice = { keywords: ["nature", "plant"], char: "🌾", fitzpatrick_scale: !1, category: "animals_and_nature" }, hibiscus = { keywords: ["plant", "vegetable", "flowers", "beach"], char: "🌺", fitzpatrick_scale: !1, category: "animals_and_nature" }, sunflower = { keywords: ["nature", "plant", "fall"], char: "🌻", fitzpatrick_scale: !1, category: "animals_and_nature" }, rose = { keywords: ["flowers", "valentines", "love", "spring"], char: "🌹", fitzpatrick_scale: !1, category: "animals_and_nature" }, wilted_flower = { keywords: ["plant", "nature", "flower"], char: "🥀", fitzpatrick_scale: !1, category: "animals_and_nature" }, tulip = { keywords: ["flowers", "plant", "nature", "summer", "spring"], char: "🌷", fitzpatrick_scale: !1, category: "animals_and_nature" }, blossom = { keywords: ["nature", "flowers", "yellow"], char: "🌼", fitzpatrick_scale: !1, category: "animals_and_nature" }, cherry_blossom = { keywords: ["nature", "plant", "spring", "flower"], char: "🌸", fitzpatrick_scale: !1, category: "animals_and_nature" }, bouquet = { keywords: ["flowers", "nature", "spring"], char: "💐", fitzpatrick_scale: !1, category: "animals_and_nature" }, mushroom = { keywords: ["plant", "vegetable"], char: "🍄", fitzpatrick_scale: !1, category: "animals_and_nature" }, chestnut = { keywords: ["food", "squirrel"], char: "🌰", fitzpatrick_scale: !1, category: "animals_and_nature" }, jack_o_lantern = { keywords: ["halloween", "light", "pumpkin", "creepy", "fall"], char: "🎃", fitzpatrick_scale: !1, category: "animals_and_nature" }, shell = { keywords: ["nature", "sea", "beach"], char: "🐚", fitzpatrick_scale: !1, category: "animals_and_nature" }, spider_web = { keywords: ["animal", "insect", "arachnid", "silk"], char: "🕸", fitzpatrick_scale: !1, category: "animals_and_nature" }, earth_americas = { keywords: ["globe", "world", "USA", "international"], char: "🌎", fitzpatrick_scale: !1, category: "animals_and_nature" }, earth_africa = { keywords: ["globe", "world", "international"], char: "🌍", fitzpatrick_scale: !1, category: "animals_and_nature" }, earth_asia = { keywords: ["globe", "world", "east", "international"], char: "🌏", fitzpatrick_scale: !1, category: "animals_and_nature" }, full_moon = { keywords: ["nature", "yellow", "twilight", "planet", "space", "night", "evening", "sleep"], char: "🌕", fitzpatrick_scale: !1, category: "animals_and_nature" }, waning_gibbous_moon = { keywords: ["nature", "twilight", "planet", "space", "night", "evening", "sleep", "waxing_gibbous_moon"], char: "🌖", fitzpatrick_scale: !1, category: "animals_and_nature" }, last_quarter_moon = { keywords: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"], char: "🌗", fitzpatrick_scale: !1, category: "animals_and_nature" }, waning_crescent_moon = { keywords: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"], char: "🌘", fitzpatrick_scale: !1, category: "animals_and_nature" }, new_moon = { keywords: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"], char: "🌑", fitzpatrick_scale: !1, category: "animals_and_nature" }, waxing_crescent_moon = { keywords: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"], char: "🌒", fitzpatrick_scale: !1, category: "animals_and_nature" }, first_quarter_moon = { keywords: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"], char: "🌓", fitzpatrick_scale: !1, category: "animals_and_nature" }, waxing_gibbous_moon = { keywords: ["nature", "night", "sky", "gray", "twilight", "planet", "space", "evening", "sleep"], char: "🌔", fitzpatrick_scale: !1, category: "animals_and_nature" }, new_moon_with_face = { keywords: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"], char: "🌚", fitzpatrick_scale: !1, category: "animals_and_nature" }, full_moon_with_face = { keywords: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"], char: "🌝", fitzpatrick_scale: !1, category: "animals_and_nature" }, first_quarter_moon_with_face = { keywords: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"], char: "🌛", fitzpatrick_scale: !1, category: "animals_and_nature" }, last_quarter_moon_with_face = { keywords: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"], char: "🌜", fitzpatrick_scale: !1, category: "animals_and_nature" }, sun_with_face = { keywords: ["nature", "morning", "sky"], char: "🌞", fitzpatrick_scale: !1, category: "animals_and_nature" }, crescent_moon = { keywords: ["night", "sleep", "sky", "evening", "magic"], char: "🌙", fitzpatrick_scale: !1, category: "animals_and_nature" }, star = { keywords: ["night", "yellow"], char: "⭐", fitzpatrick_scale: !1, category: "animals_and_nature" }, star2 = { keywords: ["night", "sparkle", "awesome", "good", "magic"], char: "🌟", fitzpatrick_scale: !1, category: "animals_and_nature" }, dizzy = { keywords: ["star", "sparkle", "shoot", "magic"], char: "💫", fitzpatrick_scale: !1, category: "animals_and_nature" }, sparkles = { keywords: ["stars", "shine", "shiny", "cool", "awesome", "good", "magic"], char: "✨", fitzpatrick_scale: !1, category: "animals_and_nature" }, comet = { keywords: ["space"], char: "☄", fitzpatrick_scale: !1, category: "animals_and_nature" }, sunny = { keywords: ["weather", "nature", "brightness", "summer", "beach", "spring"], char: "☀️", fitzpatrick_scale: !1, category: "animals_and_nature" }, sun_behind_small_cloud = { keywords: ["weather"], char: "🌤", fitzpatrick_scale: !1, category: "animals_and_nature" }, partly_sunny = { keywords: ["weather", "nature", "cloudy", "morning", "fall", "spring"], char: "⛅", fitzpatrick_scale: !1, category: "animals_and_nature" }, sun_behind_large_cloud = { keywords: ["weather"], char: "🌥", fitzpatrick_scale: !1, category: "animals_and_nature" }, sun_behind_rain_cloud = { keywords: ["weather"], char: "🌦", fitzpatrick_scale: !1, category: "animals_and_nature" }, cloud$1 = { keywords: ["weather", "sky"], char: "☁️", fitzpatrick_scale: !1, category: "animals_and_nature" }, cloud_with_rain = { keywords: ["weather"], char: "🌧", fitzpatrick_scale: !1, category: "animals_and_nature" }, cloud_with_lightning_and_rain = { keywords: ["weather", "lightning"], char: "⛈", fitzpatrick_scale: !1, category: "animals_and_nature" }, cloud_with_lightning = { keywords: ["weather", "thunder"], char: "🌩", fitzpatrick_scale: !1, category: "animals_and_nature" }, zap = { keywords: ["thunder", "weather", "lightning bolt", "fast"], char: "⚡", fitzpatrick_scale: !1, category: "animals_and_nature" }, fire = { keywords: ["hot", "cook", "flame"], char: "🔥", fitzpatrick_scale: !1, category: "animals_and_nature" }, boom = { keywords: ["bomb", "explode", "explosion", "collision", "blown"], char: "💥", fitzpatrick_scale: !1, category: "animals_and_nature" }, snowflake = { keywords: ["winter", "season", "cold", "weather", "christmas", "xmas"], char: "❄️", fitzpatrick_scale: !1, category: "animals_and_nature" }, cloud_with_snow = { keywords: ["weather"], char: "🌨", fitzpatrick_scale: !1, category: "animals_and_nature" }, snowman = { keywords: ["winter", "season", "cold", "weather", "christmas", "xmas", "frozen", "without_snow"], char: "⛄", fitzpatrick_scale: !1, category: "animals_and_nature" }, snowman_with_snow = { keywords: ["winter", "season", "cold", "weather", "christmas", "xmas", "frozen"], char: "☃", fitzpatrick_scale: !1, category: "animals_and_nature" }, wind_face = { keywords: ["gust", "air"], char: "🌬", fitzpatrick_scale: !1, category: "animals_and_nature" }, dash = { keywords: ["wind", "air", "fast", "shoo", "fart", "smoke", "puff"], char: "💨", fitzpatrick_scale: !1, category: "animals_and_nature" }, tornado = { keywords: ["weather", "cyclone", "twister"], char: "🌪", fitzpatrick_scale: !1, category: "animals_and_nature" }, fog = { keywords: ["weather"], char: "🌫", fitzpatrick_scale: !1, category: "animals_and_nature" }, open_umbrella = { keywords: ["weather", "spring"], char: "☂", fitzpatrick_scale: !1, category: "animals_and_nature" }, umbrella = { keywords: ["rainy", "weather", "spring"], char: "☔", fitzpatrick_scale: !1, category: "animals_and_nature" }, droplet = { keywords: ["water", "drip", "faucet", "spring"], char: "💧", fitzpatrick_scale: !1, category: "animals_and_nature" }, sweat_drops = { keywords: ["water", "drip", "oops"], char: "💦", fitzpatrick_scale: !1, category: "animals_and_nature" }, ocean = { keywords: ["sea", "water", "wave", "nature", "tsunami", "disaster"], char: "🌊", fitzpatrick_scale: !1, category: "animals_and_nature" }, green_apple = { keywords: ["fruit", "nature"], char: "🍏", fitzpatrick_scale: !1, category: "food_and_drink" }, apple = { keywords: ["fruit", "mac", "school"], char: "🍎", fitzpatrick_scale: !1, category: "food_and_drink" }, pear = { keywords: ["fruit", "nature", "food"], char: "🍐", fitzpatrick_scale: !1, category: "food_and_drink" }, tangerine = { keywords: ["food", "fruit", "nature", "orange"], char: "🍊", fitzpatrick_scale: !1, category: "food_and_drink" }, lemon = { keywords: ["fruit", "nature"], char: "🍋", fitzpatrick_scale: !1, category: "food_and_drink" }, banana = { keywords: ["fruit", "food", "monkey"], char: "🍌", fitzpatrick_scale: !1, category: "food_and_drink" }, watermelon = { keywords: ["fruit", "food", "picnic", "summer"], char: "🍉", fitzpatrick_scale: !1, category: "food_and_drink" }, grapes = { keywords: ["fruit", "food", "wine"], char: "🍇", fitzpatrick_scale: !1, category: "food_and_drink" }, strawberry = { keywords: ["fruit", "food", "nature"], char: "🍓", fitzpatrick_scale: !1, category: "food_and_drink" }, melon = { keywords: ["fruit", "nature", "food"], char: "🍈", fitzpatrick_scale: !1, category: "food_and_drink" }, cherries = { keywords: ["food", "fruit"], char: "🍒", fitzpatrick_scale: !1, category: "food_and_drink" }, peach = { keywords: ["fruit", "nature", "food"], char: "🍑", fitzpatrick_scale: !1, category: "food_and_drink" }, pineapple = { keywords: ["fruit", "nature", "food"], char: "🍍", fitzpatrick_scale: !1, category: "food_and_drink" }, coconut = { keywords: ["fruit", "nature", "food", "palm"], char: "🥥", fitzpatrick_scale: !1, category: "food_and_drink" }, kiwi_fruit = { keywords: ["fruit", "food"], char: "🥝", fitzpatrick_scale: !1, category: "food_and_drink" }, mango = { keywords: ["fruit", "food", "tropical"], char: "🥭", fitzpatrick_scale: !1, category: "food_and_drink" }, avocado = { keywords: ["fruit", "food"], char: "🥑", fitzpatrick_scale: !1, category: "food_and_drink" }, broccoli = { keywords: ["fruit", "food", "vegetable"], char: "🥦", fitzpatrick_scale: !1, category: "food_and_drink" }, tomato = { keywords: ["fruit", "vegetable", "nature", "food"], char: "🍅", fitzpatrick_scale: !1, category: "food_and_drink" }, eggplant = { keywords: ["vegetable", "nature", "food", "aubergine"], char: "🍆", fitzpatrick_scale: !1, category: "food_and_drink" }, cucumber = { keywords: ["fruit", "food", "pickle"], char: "🥒", fitzpatrick_scale: !1, category: "food_and_drink" }, carrot = { keywords: ["vegetable", "food", "orange"], char: "🥕", fitzpatrick_scale: !1, category: "food_and_drink" }, hot_pepper = { keywords: ["food", "spicy", "chilli", "chili"], char: "🌶", fitzpatrick_scale: !1, category: "food_and_drink" }, potato = { keywords: ["food", "tuber", "vegatable", "starch"], char: "🥔", fitzpatrick_scale: !1, category: "food_and_drink" }, corn = { keywords: ["food", "vegetable", "plant"], char: "🌽", fitzpatrick_scale: !1, category: "food_and_drink" }, leafy_greens = { keywords: ["food", "vegetable", "plant", "bok choy", "cabbage", "kale", "lettuce"], char: "🥬", fitzpatrick_scale: !1, category: "food_and_drink" }, sweet_potato = { keywords: ["food", "nature"], char: "🍠", fitzpatrick_scale: !1, category: "food_and_drink" }, peanuts = { keywords: ["food", "nut"], char: "🥜", fitzpatrick_scale: !1, category: "food_and_drink" }, honey_pot = { keywords: ["bees", "sweet", "kitchen"], char: "🍯", fitzpatrick_scale: !1, category: "food_and_drink" }, croissant = { keywords: ["food", "bread", "french"], char: "🥐", fitzpatrick_scale: !1, category: "food_and_drink" }, bread = { keywords: ["food", "wheat", "breakfast", "toast"], char: "🍞", fitzpatrick_scale: !1, category: "food_and_drink" }, baguette_bread = { keywords: ["food", "bread", "french"], char: "🥖", fitzpatrick_scale: !1, category: "food_and_drink" }, bagel = { keywords: ["food", "bread", "bakery", "schmear"], char: "🥯", fitzpatrick_scale: !1, category: "food_and_drink" }, pretzel = { keywords: ["food", "bread", "twisted"], char: "🥨", fitzpatrick_scale: !1, category: "food_and_drink" }, cheese = { keywords: ["food", "chadder"], char: "🧀", fitzpatrick_scale: !1, category: "food_and_drink" }, egg = { keywords: ["food", "chicken", "breakfast"], char: "🥚", fitzpatrick_scale: !1, category: "food_and_drink" }, bacon = { keywords: ["food", "breakfast", "pork", "pig", "meat"], char: "🥓", fitzpatrick_scale: !1, category: "food_and_drink" }, steak = { keywords: ["food", "cow", "meat", "cut", "chop", "lambchop", "porkchop"], char: "🥩", fitzpatrick_scale: !1, category: "food_and_drink" }, pancakes = { keywords: ["food", "breakfast", "flapjacks", "hotcakes"], char: "🥞", fitzpatrick_scale: !1, category: "food_and_drink" }, poultry_leg = { keywords: ["food", "meat", "drumstick", "bird", "chicken", "turkey"], char: "🍗", fitzpatrick_scale: !1, category: "food_and_drink" }, meat_on_bone = { keywords: ["good", "food", "drumstick"], char: "🍖", fitzpatrick_scale: !1, category: "food_and_drink" }, bone = { keywords: ["skeleton"], char: "🦴", fitzpatrick_scale: !1, category: "food_and_drink" }, fried_shrimp = { keywords: ["food", "animal", "appetizer", "summer"], char: "🍤", fitzpatrick_scale: !1, category: "food_and_drink" }, fried_egg = { keywords: ["food", "breakfast", "kitchen", "egg"], char: "🍳", fitzpatrick_scale: !1, category: "food_and_drink" }, hamburger = { keywords: ["meat", "fast food", "beef", "cheeseburger", "mcdonalds", "burger king"], char: "🍔", fitzpatrick_scale: !1, category: "food_and_drink" }, fries = { keywords: ["chips", "snack", "fast food"], char: "🍟", fitzpatrick_scale: !1, category: "food_and_drink" }, stuffed_flatbread = { keywords: ["food", "flatbread", "stuffed", "gyro"], char: "🥙", fitzpatrick_scale: !1, category: "food_and_drink" }, hotdog = { keywords: ["food", "frankfurter"], char: "🌭", fitzpatrick_scale: !1, category: "food_and_drink" }, pizza = { keywords: ["food", "party"], char: "🍕", fitzpatrick_scale: !1, category: "food_and_drink" }, sandwich = { keywords: ["food", "lunch", "bread"], char: "🥪", fitzpatrick_scale: !1, category: "food_and_drink" }, canned_food = { keywords: ["food", "soup"], char: "🥫", fitzpatrick_scale: !1, category: "food_and_drink" }, spaghetti = { keywords: ["food", "italian", "noodle"], char: "🍝", fitzpatrick_scale: !1, category: "food_and_drink" }, taco = { keywords: ["food", "mexican"], char: "🌮", fitzpatrick_scale: !1, category: "food_and_drink" }, burrito = { keywords: ["food", "mexican"], char: "🌯", fitzpatrick_scale: !1, category: "food_and_drink" }, green_salad = { keywords: ["food", "healthy", "lettuce"], char: "🥗", fitzpatrick_scale: !1, category: "food_and_drink" }, shallow_pan_of_food = { keywords: ["food", "cooking", "casserole", "paella"], char: "🥘", fitzpatrick_scale: !1, category: "food_and_drink" }, ramen = { keywords: ["food", "japanese", "noodle", "chopsticks"], char: "🍜", fitzpatrick_scale: !1, category: "food_and_drink" }, stew = { keywords: ["food", "meat", "soup"], char: "🍲", fitzpatrick_scale: !1, category: "food_and_drink" }, fish_cake = { keywords: ["food", "japan", "sea", "beach", "narutomaki", "pink", "swirl", "kamaboko", "surimi", "ramen"], char: "🍥", fitzpatrick_scale: !1, category: "food_and_drink" }, fortune_cookie = { keywords: ["food", "prophecy"], char: "🥠", fitzpatrick_scale: !1, category: "food_and_drink" }, sushi = { keywords: ["food", "fish", "japanese", "rice"], char: "🍣", fitzpatrick_scale: !1, category: "food_and_drink" }, bento = { keywords: ["food", "japanese", "box"], char: "🍱", fitzpatrick_scale: !1, category: "food_and_drink" }, curry = { keywords: ["food", "spicy", "hot", "indian"], char: "🍛", fitzpatrick_scale: !1, category: "food_and_drink" }, rice_ball = { keywords: ["food", "japanese"], char: "🍙", fitzpatrick_scale: !1, category: "food_and_drink" }, rice = { keywords: ["food", "china", "asian"], char: "🍚", fitzpatrick_scale: !1, category: "food_and_drink" }, rice_cracker = { keywords: ["food", "japanese"], char: "🍘", fitzpatrick_scale: !1, category: "food_and_drink" }, oden = { keywords: ["food", "japanese"], char: "🍢", fitzpatrick_scale: !1, category: "food_and_drink" }, dango = { keywords: ["food", "dessert", "sweet", "japanese", "barbecue", "meat"], char: "🍡", fitzpatrick_scale: !1, category: "food_and_drink" }, shaved_ice = { keywords: ["hot", "dessert", "summer"], char: "🍧", fitzpatrick_scale: !1, category: "food_and_drink" }, ice_cream = { keywords: ["food", "hot", "dessert"], char: "🍨", fitzpatrick_scale: !1, category: "food_and_drink" }, icecream = { keywords: ["food", "hot", "dessert", "summer"], char: "🍦", fitzpatrick_scale: !1, category: "food_and_drink" }, pie = { keywords: ["food", "dessert", "pastry"], char: "🥧", fitzpatrick_scale: !1, category: "food_and_drink" }, cake = { keywords: ["food", "dessert"], char: "🍰", fitzpatrick_scale: !1, category: "food_and_drink" }, cupcake = { keywords: ["food", "dessert", "bakery", "sweet"], char: "🧁", fitzpatrick_scale: !1, category: "food_and_drink" }, moon_cake = { keywords: ["food", "autumn"], char: "🥮", fitzpatrick_scale: !1, category: "food_and_drink" }, birthday = { keywords: ["food", "dessert", "cake"], char: "🎂", fitzpatrick_scale: !1, category: "food_and_drink" }, custard = { keywords: ["dessert", "food"], char: "🍮", fitzpatrick_scale: !1, category: "food_and_drink" }, candy = { keywords: ["snack", "dessert", "sweet", "lolly"], char: "🍬", fitzpatrick_scale: !1, category: "food_and_drink" }, lollipop = { keywords: ["food", "snack", "candy", "sweet"], char: "🍭", fitzpatrick_scale: !1, category: "food_and_drink" }, chocolate_bar = { keywords: ["food", "snack", "dessert", "sweet"], char: "🍫", fitzpatrick_scale: !1, category: "food_and_drink" }, popcorn = { keywords: ["food", "movie theater", "films", "snack"], char: "🍿", fitzpatrick_scale: !1, category: "food_and_drink" }, dumpling = { keywords: ["food", "empanada", "pierogi", "potsticker"], char: "🥟", fitzpatrick_scale: !1, category: "food_and_drink" }, doughnut = { keywords: ["food", "dessert", "snack", "sweet", "donut"], char: "🍩", fitzpatrick_scale: !1, category: "food_and_drink" }, cookie = { keywords: ["food", "snack", "oreo", "chocolate", "sweet", "dessert"], char: "🍪", fitzpatrick_scale: !1, category: "food_and_drink" }, milk_glass = { keywords: ["beverage", "drink", "cow"], char: "🥛", fitzpatrick_scale: !1, category: "food_and_drink" }, beer = { keywords: ["relax", "beverage", "drink", "drunk", "party", "pub", "summer", "alcohol", "booze"], char: "🍺", fitzpatrick_scale: !1, category: "food_and_drink" }, beers = { keywords: ["relax", "beverage", "drink", "drunk", "party", "pub", "summer", "alcohol", "booze"], char: "🍻", fitzpatrick_scale: !1, category: "food_and_drink" }, clinking_glasses = { keywords: ["beverage", "drink", "party", "alcohol", "celebrate", "cheers", "wine", "champagne", "toast"], char: "🥂", fitzpatrick_scale: !1, category: "food_and_drink" }, wine_glass = { keywords: ["drink", "beverage", "drunk", "alcohol", "booze"], char: "🍷", fitzpatrick_scale: !1, category: "food_and_drink" }, tumbler_glass = { keywords: ["drink", "beverage", "drunk", "alcohol", "liquor", "booze", "bourbon", "scotch", "whisky", "glass", "shot"], char: "🥃", fitzpatrick_scale: !1, category: "food_and_drink" }, cocktail = { keywords: ["drink", "drunk", "alcohol", "beverage", "booze", "mojito"], char: "🍸", fitzpatrick_scale: !1, category: "food_and_drink" }, tropical_drink = { keywords: ["beverage", "cocktail", "summer", "beach", "alcohol", "booze", "mojito"], char: "🍹", fitzpatrick_scale: !1, category: "food_and_drink" }, champagne = { keywords: ["drink", "wine", "bottle", "celebration"], char: "🍾", fitzpatrick_scale: !1, category: "food_and_drink" }, sake = { keywords: ["wine", "drink", "drunk", "beverage", "japanese", "alcohol", "booze"], char: "🍶", fitzpatrick_scale: !1, category: "food_and_drink" }, tea = { keywords: ["drink", "bowl", "breakfast", "green", "british"], char: "🍵", fitzpatrick_scale: !1, category: "food_and_drink" }, cup_with_straw = { keywords: ["drink", "soda"], char: "🥤", fitzpatrick_scale: !1, category: "food_and_drink" }, coffee = { keywords: ["beverage", "caffeine", "latte", "espresso"], char: "☕", fitzpatrick_scale: !1, category: "food_and_drink" }, baby_bottle = { keywords: ["food", "container", "milk"], char: "🍼", fitzpatrick_scale: !1, category: "food_and_drink" }, salt = { keywords: ["condiment", "shaker"], char: "🧂", fitzpatrick_scale: !1, category: "food_and_drink" }, spoon = { keywords: ["cutlery", "kitchen", "tableware"], char: "🥄", fitzpatrick_scale: !1, category: "food_and_drink" }, fork_and_knife = { keywords: ["cutlery", "kitchen"], char: "🍴", fitzpatrick_scale: !1, category: "food_and_drink" }, plate_with_cutlery = { keywords: ["food", "eat", "meal", "lunch", "dinner", "restaurant"], char: "🍽", fitzpatrick_scale: !1, category: "food_and_drink" }, bowl_with_spoon = { keywords: ["food", "breakfast", "cereal", "oatmeal", "porridge"], char: "🥣", fitzpatrick_scale: !1, category: "food_and_drink" }, takeout_box = { keywords: ["food", "leftovers"], char: "🥡", fitzpatrick_scale: !1, category: "food_and_drink" }, chopsticks = { keywords: ["food"], char: "🥢", fitzpatrick_scale: !1, category: "food_and_drink" }, soccer = { keywords: ["sports", "football"], char: "⚽", fitzpatrick_scale: !1, category: "activity" }, basketball = { keywords: ["sports", "balls", "NBA"], char: "🏀", fitzpatrick_scale: !1, category: "activity" }, football = { keywords: ["sports", "balls", "NFL"], char: "🏈", fitzpatrick_scale: !1, category: "activity" }, baseball = { keywords: ["sports", "balls"], char: "⚾", fitzpatrick_scale: !1, category: "activity" }, softball = { keywords: ["sports", "balls"], char: "🥎", fitzpatrick_scale: !1, category: "activity" }, tennis = { keywords: ["sports", "balls", "green"], char: "🎾", fitzpatrick_scale: !1, category: "activity" }, volleyball = { keywords: ["sports", "balls"], char: "🏐", fitzpatrick_scale: !1, category: "activity" }, rugby_football = { keywords: ["sports", "team"], char: "🏉", fitzpatrick_scale: !1, category: "activity" }, flying_disc = { keywords: ["sports", "frisbee", "ultimate"], char: "🥏", fitzpatrick_scale: !1, category: "activity" }, golf = { keywords: ["sports", "business", "flag", "hole", "summer"], char: "⛳", fitzpatrick_scale: !1, category: "activity" }, golfing_woman = { keywords: ["sports", "business", "woman", "female"], char: "🏌️‍♀️", fitzpatrick_scale: !1, category: "activity" }, golfing_man = { keywords: ["sports", "business"], char: "🏌", fitzpatrick_scale: !0, category: "activity" }, ping_pong = { keywords: ["sports", "pingpong"], char: "🏓", fitzpatrick_scale: !1, category: "activity" }, badminton = { keywords: ["sports"], char: "🏸", fitzpatrick_scale: !1, category: "activity" }, goal_net = { keywords: ["sports"], char: "🥅", fitzpatrick_scale: !1, category: "activity" }, ice_hockey = { keywords: ["sports"], char: "🏒", fitzpatrick_scale: !1, category: "activity" }, field_hockey = { keywords: ["sports"], char: "🏑", fitzpatrick_scale: !1, category: "activity" }, lacrosse = { keywords: ["sports", "ball", "stick"], char: "🥍", fitzpatrick_scale: !1, category: "activity" }, cricket = { keywords: ["sports"], char: "🏏", fitzpatrick_scale: !1, category: "activity" }, ski = { keywords: ["sports", "winter", "cold", "snow"], char: "🎿", fitzpatrick_scale: !1, category: "activity" }, skier = { keywords: ["sports", "winter", "snow"], char: "⛷", fitzpatrick_scale: !1, category: "activity" }, snowboarder = { keywords: ["sports", "winter"], char: "🏂", fitzpatrick_scale: !0, category: "activity" }, person_fencing = { keywords: ["sports", "fencing", "sword"], char: "🤺", fitzpatrick_scale: !1, category: "activity" }, women_wrestling = { keywords: ["sports", "wrestlers"], char: "🤼‍♀️", fitzpatrick_scale: !1, category: "activity" }, men_wrestling = { keywords: ["sports", "wrestlers"], char: "🤼‍♂️", fitzpatrick_scale: !1, category: "activity" }, woman_cartwheeling = { keywords: ["gymnastics"], char: "🤸‍♀️", fitzpatrick_scale: !0, category: "activity" }, man_cartwheeling = { keywords: ["gymnastics"], char: "🤸‍♂️", fitzpatrick_scale: !0, category: "activity" }, woman_playing_handball = { keywords: ["sports"], char: "🤾‍♀️", fitzpatrick_scale: !0, category: "activity" }, man_playing_handball = { keywords: ["sports"], char: "🤾‍♂️", fitzpatrick_scale: !0, category: "activity" }, ice_skate = { keywords: ["sports"], char: "⛸", fitzpatrick_scale: !1, category: "activity" }, curling_stone = { keywords: ["sports"], char: "🥌", fitzpatrick_scale: !1, category: "activity" }, skateboard = { keywords: ["board"], char: "🛹", fitzpatrick_scale: !1, category: "activity" }, sled = { keywords: ["sleigh", "luge", "toboggan"], char: "🛷", fitzpatrick_scale: !1, category: "activity" }, bow_and_arrow = { keywords: ["sports"], char: "🏹", fitzpatrick_scale: !1, category: "activity" }, fishing_pole_and_fish = { keywords: ["food", "hobby", "summer"], char: "🎣", fitzpatrick_scale: !1, category: "activity" }, boxing_glove = { keywords: ["sports", "fighting"], char: "🥊", fitzpatrick_scale: !1, category: "activity" }, martial_arts_uniform = { keywords: ["judo", "karate", "taekwondo"], char: "🥋", fitzpatrick_scale: !1, category: "activity" }, rowing_woman = { keywords: ["sports", "hobby", "water", "ship", "woman", "female"], char: "🚣‍♀️", fitzpatrick_scale: !0, category: "activity" }, rowing_man = { keywords: ["sports", "hobby", "water", "ship"], char: "🚣", fitzpatrick_scale: !0, category: "activity" }, climbing_woman = { keywords: ["sports", "hobby", "woman", "female", "rock"], char: "🧗‍♀️", fitzpatrick_scale: !0, category: "activity" }, climbing_man = { keywords: ["sports", "hobby", "man", "male", "rock"], char: "🧗‍♂️", fitzpatrick_scale: !0, category: "activity" }, swimming_woman = { keywords: ["sports", "exercise", "human", "athlete", "water", "summer", "woman", "female"], char: "🏊‍♀️", fitzpatrick_scale: !0, category: "activity" }, swimming_man = { keywords: ["sports", "exercise", "human", "athlete", "water", "summer"], char: "🏊", fitzpatrick_scale: !0, category: "activity" }, woman_playing_water_polo = { keywords: ["sports", "pool"], char: "🤽‍♀️", fitzpatrick_scale: !0, category: "activity" }, man_playing_water_polo = { keywords: ["sports", "pool"], char: "🤽‍♂️", fitzpatrick_scale: !0, category: "activity" }, woman_in_lotus_position = { keywords: ["woman", "female", "meditation", "yoga", "serenity", "zen", "mindfulness"], char: "🧘‍♀️", fitzpatrick_scale: !0, category: "activity" }, man_in_lotus_position = { keywords: ["man", "male", "meditation", "yoga", "serenity", "zen", "mindfulness"], char: "🧘‍♂️", fitzpatrick_scale: !0, category: "activity" }, surfing_woman = { keywords: ["sports", "ocean", "sea", "summer", "beach", "woman", "female"], char: "🏄‍♀️", fitzpatrick_scale: !0, category: "activity" }, surfing_man = { keywords: ["sports", "ocean", "sea", "summer", "beach"], char: "🏄", fitzpatrick_scale: !0, category: "activity" }, bath = { keywords: ["clean", "shower", "bathroom"], char: "🛀", fitzpatrick_scale: !0, category: "activity" }, basketball_woman = { keywords: ["sports", "human", "woman", "female"], char: "⛹️‍♀️", fitzpatrick_scale: !0, category: "activity" }, basketball_man = { keywords: ["sports", "human"], char: "⛹", fitzpatrick_scale: !0, category: "activity" }, weight_lifting_woman = { keywords: ["sports", "training", "exercise", "woman", "female"], char: "🏋️‍♀️", fitzpatrick_scale: !0, category: "activity" }, weight_lifting_man = { keywords: ["sports", "training", "exercise"], char: "🏋", fitzpatrick_scale: !0, category: "activity" }, biking_woman = { keywords: ["sports", "bike", "exercise", "hipster", "woman", "female"], char: "🚴‍♀️", fitzpatrick_scale: !0, category: "activity" }, biking_man = { keywords: ["sports", "bike", "exercise", "hipster"], char: "🚴", fitzpatrick_scale: !0, category: "activity" }, mountain_biking_woman = { keywords: ["transportation", "sports", "human", "race", "bike", "woman", "female"], char: "🚵‍♀️", fitzpatrick_scale: !0, category: "activity" }, mountain_biking_man = { keywords: ["transportation", "sports", "human", "race", "bike"], char: "🚵", fitzpatrick_scale: !0, category: "activity" }, horse_racing = { keywords: ["animal", "betting", "competition", "gambling", "luck"], char: "🏇", fitzpatrick_scale: !0, category: "activity" }, business_suit_levitating = { keywords: ["suit", "business", "levitate", "hover", "jump"], char: "🕴", fitzpatrick_scale: !0, category: "activity" }, trophy = { keywords: ["win", "award", "contest", "place", "ftw", "ceremony"], char: "🏆", fitzpatrick_scale: !1, category: "activity" }, running_shirt_with_sash = { keywords: ["play", "pageant"], char: "🎽", fitzpatrick_scale: !1, category: "activity" }, medal_sports = { keywords: ["award", "winning"], char: "🏅", fitzpatrick_scale: !1, category: "activity" }, medal_military = { keywords: ["award", "winning", "army"], char: "🎖", fitzpatrick_scale: !1, category: "activity" }, reminder_ribbon = { keywords: ["sports", "cause", "support", "awareness"], char: "🎗", fitzpatrick_scale: !1, category: "activity" }, rosette = { keywords: ["flower", "decoration", "military"], char: "🏵", fitzpatrick_scale: !1, category: "activity" }, ticket = { keywords: ["event", "concert", "pass"], char: "🎫", fitzpatrick_scale: !1, category: "activity" }, tickets = { keywords: ["sports", "concert", "entrance"], char: "🎟", fitzpatrick_scale: !1, category: "activity" }, performing_arts = { keywords: ["acting", "theater", "drama"], char: "🎭", fitzpatrick_scale: !1, category: "activity" }, art = { keywords: ["design", "paint", "draw", "colors"], char: "🎨", fitzpatrick_scale: !1, category: "activity" }, circus_tent = { keywords: ["festival", "carnival", "party"], char: "🎪", fitzpatrick_scale: !1, category: "activity" }, woman_juggling = { keywords: ["juggle", "balance", "skill", "multitask"], char: "🤹‍♀️", fitzpatrick_scale: !0, category: "activity" }, man_juggling = { keywords: ["juggle", "balance", "skill", "multitask"], char: "🤹‍♂️", fitzpatrick_scale: !0, category: "activity" }, microphone = { keywords: ["sound", "music", "PA", "sing", "talkshow"], char: "🎤", fitzpatrick_scale: !1, category: "activity" }, headphones = { keywords: ["music", "score", "gadgets"], char: "🎧", fitzpatrick_scale: !1, category: "activity" }, musical_score = { keywords: ["treble", "clef", "compose"], char: "🎼", fitzpatrick_scale: !1, category: "activity" }, musical_keyboard = { keywords: ["piano", "instrument", "compose"], char: "🎹", fitzpatrick_scale: !1, category: "activity" }, drum = { keywords: ["music", "instrument", "drumsticks", "snare"], char: "🥁", fitzpatrick_scale: !1, category: "activity" }, saxophone = { keywords: ["music", "instrument", "jazz", "blues"], char: "🎷", fitzpatrick_scale: !1, category: "activity" }, trumpet = { keywords: ["music", "brass"], char: "🎺", fitzpatrick_scale: !1, category: "activity" }, guitar = { keywords: ["music", "instrument"], char: "🎸", fitzpatrick_scale: !1, category: "activity" }, violin = { keywords: ["music", "instrument", "orchestra", "symphony"], char: "🎻", fitzpatrick_scale: !1, category: "activity" }, clapper = { keywords: ["movie", "film", "record"], char: "🎬", fitzpatrick_scale: !1, category: "activity" }, video_game = { keywords: ["play", "console", "PS4", "controller"], char: "🎮", fitzpatrick_scale: !1, category: "activity" }, space_invader = { keywords: ["game", "arcade", "play"], char: "👾", fitzpatrick_scale: !1, category: "activity" }, dart = { keywords: ["game", "play", "bar", "target", "bullseye"], char: "🎯", fitzpatrick_scale: !1, category: "activity" }, game_die = { keywords: ["dice", "random", "tabletop", "play", "luck"], char: "🎲", fitzpatrick_scale: !1, category: "activity" }, chess_pawn = { keywords: ["expendable"], char: "♟", fitzpatrick_scale: !1, category: "activity" }, slot_machine = { keywords: ["bet", "gamble", "vegas", "fruit machine", "luck", "casino"], char: "🎰", fitzpatrick_scale: !1, category: "activity" }, jigsaw = { keywords: ["interlocking", "puzzle", "piece"], char: "🧩", fitzpatrick_scale: !1, category: "activity" }, bowling = { keywords: ["sports", "fun", "play"], char: "🎳", fitzpatrick_scale: !1, category: "activity" }, red_car = { keywords: ["red", "transportation", "vehicle"], char: "🚗", fitzpatrick_scale: !1, category: "travel_and_places" }, taxi = { keywords: ["uber", "vehicle", "cars", "transportation"], char: "🚕", fitzpatrick_scale: !1, category: "travel_and_places" }, blue_car = { keywords: ["transportation", "vehicle"], char: "🚙", fitzpatrick_scale: !1, category: "travel_and_places" }, bus = { keywords: ["car", "vehicle", "transportation"], char: "🚌", fitzpatrick_scale: !1, category: "travel_and_places" }, trolleybus = { keywords: ["bart", "transportation", "vehicle"], char: "🚎", fitzpatrick_scale: !1, category: "travel_and_places" }, racing_car = { keywords: ["sports", "race", "fast", "formula", "f1"], char: "🏎", fitzpatrick_scale: !1, category: "travel_and_places" }, police_car = { keywords: ["vehicle", "cars", "transportation", "law", "legal", "enforcement"], char: "🚓", fitzpatrick_scale: !1, category: "travel_and_places" }, ambulance = { keywords: ["health", "911", "hospital"], char: "🚑", fitzpatrick_scale: !1, category: "travel_and_places" }, fire_engine = { keywords: ["transportation", "cars", "vehicle"], char: "🚒", fitzpatrick_scale: !1, category: "travel_and_places" }, minibus = { keywords: ["vehicle", "car", "transportation"], char: "🚐", fitzpatrick_scale: !1, category: "travel_and_places" }, truck = { keywords: ["cars", "transportation"], char: "🚚", fitzpatrick_scale: !1, category: "travel_and_places" }, articulated_lorry = { keywords: ["vehicle", "cars", "transportation", "express"], char: "🚛", fitzpatrick_scale: !1, category: "travel_and_places" }, tractor = { keywords: ["vehicle", "car", "farming", "agriculture"], char: "🚜", fitzpatrick_scale: !1, category: "travel_and_places" }, kick_scooter = { keywords: ["vehicle", "kick", "razor"], char: "🛴", fitzpatrick_scale: !1, category: "travel_and_places" }, motorcycle = { keywords: ["race", "sports", "fast"], char: "🏍", fitzpatrick_scale: !1, category: "travel_and_places" }, bike = { keywords: ["sports", "bicycle", "exercise", "hipster"], char: "🚲", fitzpatrick_scale: !1, category: "travel_and_places" }, motor_scooter = { keywords: ["vehicle", "vespa", "sasha"], char: "🛵", fitzpatrick_scale: !1, category: "travel_and_places" }, rotating_light = { keywords: ["police", "ambulance", "911", "emergency", "alert", "error", "pinged", "law", "legal"], char: "🚨", fitzpatrick_scale: !1, category: "travel_and_places" }, oncoming_police_car = { keywords: ["vehicle", "law", "legal", "enforcement", "911"], char: "🚔", fitzpatrick_scale: !1, category: "travel_and_places" }, oncoming_bus = { keywords: ["vehicle", "transportation"], char: "🚍", fitzpatrick_scale: !1, category: "travel_and_places" }, oncoming_automobile = { keywords: ["car", "vehicle", "transportation"], char: "🚘", fitzpatrick_scale: !1, category: "travel_and_places" }, oncoming_taxi = { keywords: ["vehicle", "cars", "uber"], char: "🚖", fitzpatrick_scale: !1, category: "travel_and_places" }, aerial_tramway = { keywords: ["transportation", "vehicle", "ski"], char: "🚡", fitzpatrick_scale: !1, category: "travel_and_places" }, mountain_cableway = { keywords: ["transportation", "vehicle", "ski"], char: "🚠", fitzpatrick_scale: !1, category: "travel_and_places" }, suspension_railway = { keywords: ["vehicle", "transportation"], char: "🚟", fitzpatrick_scale: !1, category: "travel_and_places" }, railway_car = { keywords: ["transportation", "vehicle"], char: "🚃", fitzpatrick_scale: !1, category: "travel_and_places" }, train = { keywords: ["transportation", "vehicle", "carriage", "public", "travel"], char: "🚋", fitzpatrick_scale: !1, category: "travel_and_places" }, monorail = { keywords: ["transportation", "vehicle"], char: "🚝", fitzpatrick_scale: !1, category: "travel_and_places" }, bullettrain_side = { keywords: ["transportation", "vehicle"], char: "🚄", fitzpatrick_scale: !1, category: "travel_and_places" }, bullettrain_front = { keywords: ["transportation", "vehicle", "speed", "fast", "public", "travel"], char: "🚅", fitzpatrick_scale: !1, category: "travel_and_places" }, light_rail = { keywords: ["transportation", "vehicle"], char: "🚈", fitzpatrick_scale: !1, category: "travel_and_places" }, mountain_railway = { keywords: ["transportation", "vehicle"], char: "🚞", fitzpatrick_scale: !1, category: "travel_and_places" }, steam_locomotive = { keywords: ["transportation", "vehicle", "train"], char: "🚂", fitzpatrick_scale: !1, category: "travel_and_places" }, train2 = { keywords: ["transportation", "vehicle"], char: "🚆", fitzpatrick_scale: !1, category: "travel_and_places" }, metro = { keywords: ["transportation", "blue-square", "mrt", "underground", "tube"], char: "🚇", fitzpatrick_scale: !1, category: "travel_and_places" }, tram = { keywords: ["transportation", "vehicle"], char: "🚊", fitzpatrick_scale: !1, category: "travel_and_places" }, station = { keywords: ["transportation", "vehicle", "public"], char: "🚉", fitzpatrick_scale: !1, category: "travel_and_places" }, flying_saucer = { keywords: ["transportation", "vehicle", "ufo"], char: "🛸", fitzpatrick_scale: !1, category: "travel_and_places" }, helicopter = { keywords: ["transportation", "vehicle", "fly"], char: "🚁", fitzpatrick_scale: !1, category: "travel_and_places" }, small_airplane = { keywords: ["flight", "transportation", "fly", "vehicle"], char: "🛩", fitzpatrick_scale: !1, category: "travel_and_places" }, airplane = { keywords: ["vehicle", "transportation", "flight", "fly"], char: "✈️", fitzpatrick_scale: !1, category: "travel_and_places" }, flight_departure = { keywords: ["airport", "flight", "landing"], char: "🛫", fitzpatrick_scale: !1, category: "travel_and_places" }, flight_arrival = { keywords: ["airport", "flight", "boarding"], char: "🛬", fitzpatrick_scale: !1, category: "travel_and_places" }, sailboat = { keywords: ["ship", "summer", "transportation", "water", "sailing"], char: "⛵", fitzpatrick_scale: !1, category: "travel_and_places" }, motor_boat = { keywords: ["ship"], char: "🛥", fitzpatrick_scale: !1, category: "travel_and_places" }, speedboat = { keywords: ["ship", "transportation", "vehicle", "summer"], char: "🚤", fitzpatrick_scale: !1, category: "travel_and_places" }, ferry = { keywords: ["boat", "ship", "yacht"], char: "⛴", fitzpatrick_scale: !1, category: "travel_and_places" }, passenger_ship = { keywords: ["yacht", "cruise", "ferry"], char: "🛳", fitzpatrick_scale: !1, category: "travel_and_places" }, rocket = { keywords: ["launch", "ship", "staffmode", "NASA", "outer space", "outer_space", "fly"], char: "🚀", fitzpatrick_scale: !1, category: "travel_and_places" }, artificial_satellite = { keywords: ["communication", "gps", "orbit", "spaceflight", "NASA", "ISS"], char: "🛰", fitzpatrick_scale: !1, category: "travel_and_places" }, seat = { keywords: ["sit", "airplane", "transport", "bus", "flight", "fly"], char: "💺", fitzpatrick_scale: !1, category: "travel_and_places" }, canoe = { keywords: ["boat", "paddle", "water", "ship"], char: "🛶", fitzpatrick_scale: !1, category: "travel_and_places" }, anchor = { keywords: ["ship", "ferry", "sea", "boat"], char: "⚓", fitzpatrick_scale: !1, category: "travel_and_places" }, construction = { keywords: ["wip", "progress", "caution", "warning"], char: "🚧", fitzpatrick_scale: !1, category: "travel_and_places" }, fuelpump = { keywords: ["gas station", "petroleum"], char: "⛽", fitzpatrick_scale: !1, category: "travel_and_places" }, busstop = { keywords: ["transportation", "wait"], char: "🚏", fitzpatrick_scale: !1, category: "travel_and_places" }, vertical_traffic_light = { keywords: ["transportation", "driving"], char: "🚦", fitzpatrick_scale: !1, category: "travel_and_places" }, traffic_light = { keywords: ["transportation", "signal"], char: "🚥", fitzpatrick_scale: !1, category: "travel_and_places" }, checkered_flag = { keywords: ["contest", "finishline", "race", "gokart"], char: "🏁", fitzpatrick_scale: !1, category: "travel_and_places" }, ship = { keywords: ["transportation", "titanic", "deploy"], char: "🚢", fitzpatrick_scale: !1, category: "travel_and_places" }, ferris_wheel = { keywords: ["photo", "carnival", "londoneye"], char: "🎡", fitzpatrick_scale: !1, category: "travel_and_places" }, roller_coaster = { keywords: ["carnival", "playground", "photo", "fun"], char: "🎢", fitzpatrick_scale: !1, category: "travel_and_places" }, carousel_horse = { keywords: ["photo", "carnival"], char: "🎠", fitzpatrick_scale: !1, category: "travel_and_places" }, building_construction = { keywords: ["wip", "working", "progress"], char: "🏗", fitzpatrick_scale: !1, category: "travel_and_places" }, foggy = { keywords: ["photo", "mountain"], char: "🌁", fitzpatrick_scale: !1, category: "travel_and_places" }, tokyo_tower = { keywords: ["photo", "japanese"], char: "🗼", fitzpatrick_scale: !1, category: "travel_and_places" }, factory$1 = { keywords: ["building", "industry", "pollution", "smoke"], char: "🏭", fitzpatrick_scale: !1, category: "travel_and_places" }, fountain = { keywords: ["photo", "summer", "water", "fresh"], char: "⛲", fitzpatrick_scale: !1, category: "travel_and_places" }, rice_scene = { keywords: ["photo", "japan", "asia", "tsukimi"], char: "🎑", fitzpatrick_scale: !1, category: "travel_and_places" }, mountain = { keywords: ["photo", "nature", "environment"], char: "⛰", fitzpatrick_scale: !1, category: "travel_and_places" }, mountain_snow = { keywords: ["photo", "nature", "environment", "winter", "cold"], char: "🏔", fitzpatrick_scale: !1, category: "travel_and_places" }, mount_fuji = { keywords: ["photo", "mountain", "nature", "japanese"], char: "🗻", fitzpatrick_scale: !1, category: "travel_and_places" }, volcano = { keywords: ["photo", "nature", "disaster"], char: "🌋", fitzpatrick_scale: !1, category: "travel_and_places" }, japan = { keywords: ["nation", "country", "japanese", "asia"], char: "🗾", fitzpatrick_scale: !1, category: "travel_and_places" }, camping = { keywords: ["photo", "outdoors", "tent"], char: "🏕", fitzpatrick_scale: !1, category: "travel_and_places" }, tent = { keywords: ["photo", "camping", "outdoors"], char: "⛺", fitzpatrick_scale: !1, category: "travel_and_places" }, national_park = { keywords: ["photo", "environment", "nature"], char: "🏞", fitzpatrick_scale: !1, category: "travel_and_places" }, motorway = { keywords: ["road", "cupertino", "interstate", "highway"], char: "🛣", fitzpatrick_scale: !1, category: "travel_and_places" }, railway_track = { keywords: ["train", "transportation"], char: "🛤", fitzpatrick_scale: !1, category: "travel_and_places" }, sunrise = { keywords: ["morning", "view", "vacation", "photo"], char: "🌅", fitzpatrick_scale: !1, category: "travel_and_places" }, sunrise_over_mountains = { keywords: ["view", "vacation", "photo"], char: "🌄", fitzpatrick_scale: !1, category: "travel_and_places" }, desert = { keywords: ["photo", "warm", "saharah"], char: "🏜", fitzpatrick_scale: !1, category: "travel_and_places" }, beach_umbrella = { keywords: ["weather", "summer", "sunny", "sand", "mojito"], char: "🏖", fitzpatrick_scale: !1, category: "travel_and_places" }, desert_island = { keywords: ["photo", "tropical", "mojito"], char: "🏝", fitzpatrick_scale: !1, category: "travel_and_places" }, city_sunrise = { keywords: ["photo", "good morning", "dawn"], char: "🌇", fitzpatrick_scale: !1, category: "travel_and_places" }, city_sunset = { keywords: ["photo", "evening", "sky", "buildings"], char: "🌆", fitzpatrick_scale: !1, category: "travel_and_places" }, cityscape = { keywords: ["photo", "night life", "urban"], char: "🏙", fitzpatrick_scale: !1, category: "travel_and_places" }, night_with_stars = { keywords: ["evening", "city", "downtown"], char: "🌃", fitzpatrick_scale: !1, category: "travel_and_places" }, bridge_at_night = { keywords: ["photo", "sanfrancisco"], char: "🌉", fitzpatrick_scale: !1, category: "travel_and_places" }, milky_way = { keywords: ["photo", "space", "stars"], char: "🌌", fitzpatrick_scale: !1, category: "travel_and_places" }, stars = { keywords: ["night", "photo"], char: "🌠", fitzpatrick_scale: !1, category: "travel_and_places" }, sparkler = { keywords: ["stars", "night", "shine"], char: "🎇", fitzpatrick_scale: !1, category: "travel_and_places" }, fireworks = { keywords: ["photo", "festival", "carnival", "congratulations"], char: "🎆", fitzpatrick_scale: !1, category: "travel_and_places" }, rainbow = { keywords: ["nature", "happy", "unicorn_face", "photo", "sky", "spring"], char: "🌈", fitzpatrick_scale: !1, category: "travel_and_places" }, houses = { keywords: ["buildings", "photo"], char: "🏘", fitzpatrick_scale: !1, category: "travel_and_places" }, european_castle = { keywords: ["building", "royalty", "history"], char: "🏰", fitzpatrick_scale: !1, category: "travel_and_places" }, japanese_castle = { keywords: ["photo", "building"], char: "🏯", fitzpatrick_scale: !1, category: "travel_and_places" }, stadium = { keywords: ["photo", "place", "sports", "concert", "venue"], char: "🏟", fitzpatrick_scale: !1, category: "travel_and_places" }, statue_of_liberty = { keywords: ["american", "newyork"], char: "🗽", fitzpatrick_scale: !1, category: "travel_and_places" }, house = { keywords: ["building", "home"], char: "🏠", fitzpatrick_scale: !1, category: "travel_and_places" }, house_with_garden = { keywords: ["home", "plant", "nature"], char: "🏡", fitzpatrick_scale: !1, category: "travel_and_places" }, derelict_house = { keywords: ["abandon", "evict", "broken", "building"], char: "🏚", fitzpatrick_scale: !1, category: "travel_and_places" }, office = { keywords: ["building", "bureau", "work"], char: "🏢", fitzpatrick_scale: !1, category: "travel_and_places" }, department_store = { keywords: ["building", "shopping", "mall"], char: "🏬", fitzpatrick_scale: !1, category: "travel_and_places" }, post_office = { keywords: ["building", "envelope", "communication"], char: "🏣", fitzpatrick_scale: !1, category: "travel_and_places" }, european_post_office = { keywords: ["building", "email"], char: "🏤", fitzpatrick_scale: !1, category: "travel_and_places" }, hospital = { keywords: ["building", "health", "surgery", "doctor"], char: "🏥", fitzpatrick_scale: !1, category: "travel_and_places" }, bank = { keywords: ["building", "money", "sales", "cash", "business", "enterprise"], char: "🏦", fitzpatrick_scale: !1, category: "travel_and_places" }, hotel = { keywords: ["building", "accomodation", "checkin"], char: "🏨", fitzpatrick_scale: !1, category: "travel_and_places" }, convenience_store = { keywords: ["building", "shopping", "groceries"], char: "🏪", fitzpatrick_scale: !1, category: "travel_and_places" }, school = { keywords: ["building", "student", "education", "learn", "teach"], char: "🏫", fitzpatrick_scale: !1, category: "travel_and_places" }, love_hotel = { keywords: ["like", "affection", "dating"], char: "🏩", fitzpatrick_scale: !1, category: "travel_and_places" }, wedding = { keywords: ["love", "like", "affection", "couple", "marriage", "bride", "groom"], char: "💒", fitzpatrick_scale: !1, category: "travel_and_places" }, classical_building = { keywords: ["art", "culture", "history"], char: "🏛", fitzpatrick_scale: !1, category: "travel_and_places" }, church = { keywords: ["building", "religion", "christ"], char: "⛪", fitzpatrick_scale: !1, category: "travel_and_places" }, mosque = { keywords: ["islam", "worship", "minaret"], char: "🕌", fitzpatrick_scale: !1, category: "travel_and_places" }, synagogue = { keywords: ["judaism", "worship", "temple", "jewish"], char: "🕍", fitzpatrick_scale: !1, category: "travel_and_places" }, kaaba = { keywords: ["mecca", "mosque", "islam"], char: "🕋", fitzpatrick_scale: !1, category: "travel_and_places" }, shinto_shrine = { keywords: ["temple", "japan", "kyoto"], char: "⛩", fitzpatrick_scale: !1, category: "travel_and_places" }, watch = { keywords: ["time", "accessories"], char: "⌚", fitzpatrick_scale: !1, category: "objects" }, iphone = { keywords: ["technology", "apple", "gadgets", "dial"], char: "📱", fitzpatrick_scale: !1, category: "objects" }, calling = { keywords: ["iphone", "incoming"], char: "📲", fitzpatrick_scale: !1, category: "objects" }, computer = { keywords: ["technology", "laptop", "screen", "display", "monitor"], char: "💻", fitzpatrick_scale: !1, category: "objects" }, keyboard = { keywords: ["technology", "computer", "type", "input", "text"], char: "⌨", fitzpatrick_scale: !1, category: "objects" }, desktop_computer = { keywords: ["technology", "computing", "screen"], char: "🖥", fitzpatrick_scale: !1, category: "objects" }, printer = { keywords: ["paper", "ink"], char: "🖨", fitzpatrick_scale: !1, category: "objects" }, computer_mouse = { keywords: ["click"], char: "🖱", fitzpatrick_scale: !1, category: "objects" }, trackball = { keywords: ["technology", "trackpad"], char: "🖲", fitzpatrick_scale: !1, category: "objects" }, joystick = { keywords: ["game", "play"], char: "🕹", fitzpatrick_scale: !1, category: "objects" }, clamp$2 = { keywords: ["tool"], char: "🗜", fitzpatrick_scale: !1, category: "objects" }, minidisc = { keywords: ["technology", "record", "data", "disk", "90s"], char: "💽", fitzpatrick_scale: !1, category: "objects" }, floppy_disk = { keywords: ["oldschool", "technology", "save", "90s", "80s"], char: "💾", fitzpatrick_scale: !1, category: "objects" }, cd = { keywords: ["technology", "dvd", "disk", "disc", "90s"], char: "💿", fitzpatrick_scale: !1, category: "objects" }, dvd = { keywords: ["cd", "disk", "disc"], char: "📀", fitzpatrick_scale: !1, category: "objects" }, vhs = { keywords: ["record", "video", "oldschool", "90s", "80s"], char: "📼", fitzpatrick_scale: !1, category: "objects" }, camera = { keywords: ["gadgets", "photography"], char: "📷", fitzpatrick_scale: !1, category: "objects" }, camera_flash = { keywords: ["photography", "gadgets"], char: "📸", fitzpatrick_scale: !1, category: "objects" }, video_camera = { keywords: ["film", "record"], char: "📹", fitzpatrick_scale: !1, category: "objects" }, movie_camera = { keywords: ["film", "record"], char: "🎥", fitzpatrick_scale: !1, category: "objects" }, film_projector = { keywords: ["video", "tape", "record", "movie"], char: "📽", fitzpatrick_scale: !1, category: "objects" }, film_strip = { keywords: ["movie"], char: "🎞", fitzpatrick_scale: !1, category: "objects" }, telephone_receiver = { keywords: ["technology", "communication", "dial"], char: "📞", fitzpatrick_scale: !1, category: "objects" }, phone = { keywords: ["technology", "communication", "dial", "telephone"], char: "☎️", fitzpatrick_scale: !1, category: "objects" }, pager = { keywords: ["bbcall", "oldschool", "90s"], char: "📟", fitzpatrick_scale: !1, category: "objects" }, fax = { keywords: ["communication", "technology"], char: "📠", fitzpatrick_scale: !1, category: "objects" }, tv = { keywords: ["technology", "program", "oldschool", "show", "television"], char: "📺", fitzpatrick_scale: !1, category: "objects" }, radio$1 = { keywords: ["communication", "music", "podcast", "program"], char: "📻", fitzpatrick_scale: !1, category: "objects" }, studio_microphone = { keywords: ["sing", "recording", "artist", "talkshow"], char: "🎙", fitzpatrick_scale: !1, category: "objects" }, level_slider = { keywords: ["scale"], char: "🎚", fitzpatrick_scale: !1, category: "objects" }, control_knobs = { keywords: ["dial"], char: "🎛", fitzpatrick_scale: !1, category: "objects" }, compass = { keywords: ["magnetic", "navigation", "orienteering"], char: "🧭", fitzpatrick_scale: !1, category: "objects" }, stopwatch = { keywords: ["time", "deadline"], char: "⏱", fitzpatrick_scale: !1, category: "objects" }, timer_clock = { keywords: ["alarm"], char: "⏲", fitzpatrick_scale: !1, category: "objects" }, alarm_clock = { keywords: ["time", "wake"], char: "⏰", fitzpatrick_scale: !1, category: "objects" }, mantelpiece_clock = { keywords: ["time"], char: "🕰", fitzpatrick_scale: !1, category: "objects" }, hourglass_flowing_sand = { keywords: ["oldschool", "time", "countdown"], char: "⏳", fitzpatrick_scale: !1, category: "objects" }, hourglass = { keywords: ["time", "clock", "oldschool", "limit", "exam", "quiz", "test"], char: "⌛", fitzpatrick_scale: !1, category: "objects" }, satellite = { keywords: ["communication", "future", "radio", "space"], char: "📡", fitzpatrick_scale: !1, category: "objects" }, battery = { keywords: ["power", "energy", "sustain"], char: "🔋", fitzpatrick_scale: !1, category: "objects" }, electric_plug = { keywords: ["charger", "power"], char: "🔌", fitzpatrick_scale: !1, category: "objects" }, bulb = { keywords: ["light", "electricity", "idea"], char: "💡", fitzpatrick_scale: !1, category: "objects" }, flashlight = { keywords: ["dark", "camping", "sight", "night"], char: "🔦", fitzpatrick_scale: !1, category: "objects" }, candle = { keywords: ["fire", "wax"], char: "🕯", fitzpatrick_scale: !1, category: "objects" }, fire_extinguisher = { keywords: ["quench"], char: "🧯", fitzpatrick_scale: !1, category: "objects" }, wastebasket = { keywords: ["bin", "trash", "rubbish", "garbage", "toss"], char: "🗑", fitzpatrick_scale: !1, category: "objects" }, oil_drum = { keywords: ["barrell"], char: "🛢", fitzpatrick_scale: !1, category: "objects" }, money_with_wings = { keywords: ["dollar", "bills", "payment", "sale"], char: "💸", fitzpatrick_scale: !1, category: "objects" }, dollar = { keywords: ["money", "sales", "bill", "currency"], char: "💵", fitzpatrick_scale: !1, category: "objects" }, yen$1 = { keywords: ["money", "sales", "japanese", "dollar", "currency"], char: "💴", fitzpatrick_scale: !1, category: "objects" }, euro = { keywords: ["money", "sales", "dollar", "currency"], char: "💶", fitzpatrick_scale: !1, category: "objects" }, pound$1 = { keywords: ["british", "sterling", "money", "sales", "bills", "uk", "england", "currency"], char: "💷", fitzpatrick_scale: !1, category: "objects" }, moneybag = { keywords: ["dollar", "payment", "coins", "sale"], char: "💰", fitzpatrick_scale: !1, category: "objects" }, credit_card = { keywords: ["money", "sales", "dollar", "bill", "payment", "shopping"], char: "💳", fitzpatrick_scale: !1, category: "objects" }, gem = { keywords: ["blue", "ruby", "diamond", "jewelry"], char: "💎", fitzpatrick_scale: !1, category: "objects" }, balance_scale = { keywords: ["law", "fairness", "weight"], char: "⚖", fitzpatrick_scale: !1, category: "objects" }, toolbox = { keywords: ["tools", "diy", "fix", "maintainer", "mechanic"], char: "🧰", fitzpatrick_scale: !1, category: "objects" }, wrench = { keywords: ["tools", "diy", "ikea", "fix", "maintainer"], char: "🔧", fitzpatrick_scale: !1, category: "objects" }, hammer = { keywords: ["tools", "build", "create"], char: "🔨", fitzpatrick_scale: !1, category: "objects" }, hammer_and_pick = { keywords: ["tools", "build", "create"], char: "⚒", fitzpatrick_scale: !1, category: "objects" }, hammer_and_wrench = { keywords: ["tools", "build", "create"], char: "🛠", fitzpatrick_scale: !1, category: "objects" }, pick$4 = { keywords: ["tools", "dig"], char: "⛏", fitzpatrick_scale: !1, category: "objects" }, nut_and_bolt = { keywords: ["handy", "tools", "fix"], char: "🔩", fitzpatrick_scale: !1, category: "objects" }, gear = { keywords: ["cog"], char: "⚙", fitzpatrick_scale: !1, category: "objects" }, brick = { keywords: ["bricks"], char: "🧱", fitzpatrick_scale: !1, category: "objects" }, chains = { keywords: ["lock", "arrest"], char: "⛓", fitzpatrick_scale: !1, category: "objects" }, magnet = { keywords: ["attraction", "magnetic"], char: "🧲", fitzpatrick_scale: !1, category: "objects" }, gun = { keywords: ["violence", "weapon", "pistol", "revolver"], char: "🔫", fitzpatrick_scale: !1, category: "objects" }, bomb = { keywords: ["boom", "explode", "explosion", "terrorism"], char: "💣", fitzpatrick_scale: !1, category: "objects" }, firecracker = { keywords: ["dynamite", "boom", "explode", "explosion", "explosive"], char: "🧨", fitzpatrick_scale: !1, category: "objects" }, hocho = { keywords: ["knife", "blade", "cutlery", "kitchen", "weapon"], char: "🔪", fitzpatrick_scale: !1, category: "objects" }, dagger = { keywords: ["weapon"], char: "🗡", fitzpatrick_scale: !1, category: "objects" }, crossed_swords = { keywords: ["weapon"], char: "⚔", fitzpatrick_scale: !1, category: "objects" }, shield = { keywords: ["protection", "security"], char: "🛡", fitzpatrick_scale: !1, category: "objects" }, smoking = { keywords: ["kills", "tobacco", "cigarette", "joint", "smoke"], char: "🚬", fitzpatrick_scale: !1, category: "objects" }, skull_and_crossbones = { keywords: ["poison", "danger", "deadly", "scary", "death", "pirate", "evil"], char: "☠", fitzpatrick_scale: !1, category: "objects" }, coffin = { keywords: ["vampire", "dead", "die", "death", "rip", "graveyard", "cemetery", "casket", "funeral", "box"], char: "⚰", fitzpatrick_scale: !1, category: "objects" }, funeral_urn = { keywords: ["dead", "die", "death", "rip", "ashes"], char: "⚱", fitzpatrick_scale: !1, category: "objects" }, amphora = { keywords: ["vase", "jar"], char: "🏺", fitzpatrick_scale: !1, category: "objects" }, crystal_ball = { keywords: ["disco", "party", "magic", "circus", "fortune_teller"], char: "🔮", fitzpatrick_scale: !1, category: "objects" }, prayer_beads = { keywords: ["dhikr", "religious"], char: "📿", fitzpatrick_scale: !1, category: "objects" }, nazar_amulet = { keywords: ["bead", "charm"], char: "🧿", fitzpatrick_scale: !1, category: "objects" }, barber = { keywords: ["hair", "salon", "style"], char: "💈", fitzpatrick_scale: !1, category: "objects" }, alembic = { keywords: ["distilling", "science", "experiment", "chemistry"], char: "⚗", fitzpatrick_scale: !1, category: "objects" }, telescope = { keywords: ["stars", "space", "zoom", "science", "astronomy"], char: "🔭", fitzpatrick_scale: !1, category: "objects" }, microscope = { keywords: ["laboratory", "experiment", "zoomin", "science", "study"], char: "🔬", fitzpatrick_scale: !1, category: "objects" }, hole = { keywords: ["embarrassing"], char: "🕳", fitzpatrick_scale: !1, category: "objects" }, pill = { keywords: ["health", "medicine", "doctor", "pharmacy", "drug"], char: "💊", fitzpatrick_scale: !1, category: "objects" }, syringe = { keywords: ["health", "hospital", "drugs", "blood", "medicine", "needle", "doctor", "nurse"], char: "💉", fitzpatrick_scale: !1, category: "objects" }, dna = { keywords: ["biologist", "genetics", "life"], char: "🧬", fitzpatrick_scale: !1, category: "objects" }, microbe = { keywords: ["amoeba", "bacteria", "germs"], char: "🦠", fitzpatrick_scale: !1, category: "objects" }, petri_dish = { keywords: ["bacteria", "biology", "culture", "lab"], char: "🧫", fitzpatrick_scale: !1, category: "objects" }, test_tube = { keywords: ["chemistry", "experiment", "lab", "science"], char: "🧪", fitzpatrick_scale: !1, category: "objects" }, thermometer = { keywords: ["weather", "temperature", "hot", "cold"], char: "🌡", fitzpatrick_scale: !1, category: "objects" }, broom = { keywords: ["cleaning", "sweeping", "witch"], char: "🧹", fitzpatrick_scale: !1, category: "objects" }, basket = { keywords: ["laundry"], char: "🧺", fitzpatrick_scale: !1, category: "objects" }, toilet_paper = { keywords: ["roll"], char: "🧻", fitzpatrick_scale: !1, category: "objects" }, label$1 = { keywords: ["sale", "tag"], char: "🏷", fitzpatrick_scale: !1, category: "objects" }, bookmark = { keywords: ["favorite", "label", "save"], char: "🔖", fitzpatrick_scale: !1, category: "objects" }, toilet = { keywords: ["restroom", "wc", "washroom", "bathroom", "potty"], char: "🚽", fitzpatrick_scale: !1, category: "objects" }, shower = { keywords: ["clean", "water", "bathroom"], char: "🚿", fitzpatrick_scale: !1, category: "objects" }, bathtub = { keywords: ["clean", "shower", "bathroom"], char: "🛁", fitzpatrick_scale: !1, category: "objects" }, soap = { keywords: ["bar", "bathing", "cleaning", "lather"], char: "🧼", fitzpatrick_scale: !1, category: "objects" }, sponge = { keywords: ["absorbing", "cleaning", "porous"], char: "🧽", fitzpatrick_scale: !1, category: "objects" }, lotion_bottle = { keywords: ["moisturizer", "sunscreen"], char: "🧴", fitzpatrick_scale: !1, category: "objects" }, key$2 = { keywords: ["lock", "door", "password"], char: "🔑", fitzpatrick_scale: !1, category: "objects" }, old_key = { keywords: ["lock", "door", "password"], char: "🗝", fitzpatrick_scale: !1, category: "objects" }, couch_and_lamp = { keywords: ["read", "chill"], char: "🛋", fitzpatrick_scale: !1, category: "objects" }, sleeping_bed = { keywords: ["bed", "rest"], char: "🛌", fitzpatrick_scale: !0, category: "objects" }, bed = { keywords: ["sleep", "rest"], char: "🛏", fitzpatrick_scale: !1, category: "objects" }, door = { keywords: ["house", "entry", "exit"], char: "🚪", fitzpatrick_scale: !1, category: "objects" }, bellhop_bell = { keywords: ["service"], char: "🛎", fitzpatrick_scale: !1, category: "objects" }, teddy_bear = { keywords: ["plush", "stuffed"], char: "🧸", fitzpatrick_scale: !1, category: "objects" }, framed_picture = { keywords: ["photography"], char: "🖼", fitzpatrick_scale: !1, category: "objects" }, world_map = { keywords: ["location", "direction"], char: "🗺", fitzpatrick_scale: !1, category: "objects" }, parasol_on_ground = { keywords: ["weather", "summer"], char: "⛱", fitzpatrick_scale: !1, category: "objects" }, moyai = { keywords: ["rock", "easter island", "moai"], char: "🗿", fitzpatrick_scale: !1, category: "objects" }, shopping = { keywords: ["mall", "buy", "purchase"], char: "🛍", fitzpatrick_scale: !1, category: "objects" }, shopping_cart = { keywords: ["trolley"], char: "🛒", fitzpatrick_scale: !1, category: "objects" }, balloon = { keywords: ["party", "celebration", "birthday", "circus"], char: "🎈", fitzpatrick_scale: !1, category: "objects" }, flags = { keywords: ["fish", "japanese", "koinobori", "carp", "banner"], char: "🎏", fitzpatrick_scale: !1, category: "objects" }, ribbon = { keywords: ["decoration", "pink", "girl", "bowtie"], char: "🎀", fitzpatrick_scale: !1, category: "objects" }, gift = { keywords: ["present", "birthday", "christmas", "xmas"], char: "🎁", fitzpatrick_scale: !1, category: "objects" }, confetti_ball = { keywords: ["festival", "party", "birthday", "circus"], char: "🎊", fitzpatrick_scale: !1, category: "objects" }, tada = { keywords: ["party", "congratulations", "birthday", "magic", "circus", "celebration"], char: "🎉", fitzpatrick_scale: !1, category: "objects" }, dolls = { keywords: ["japanese", "toy", "kimono"], char: "🎎", fitzpatrick_scale: !1, category: "objects" }, wind_chime = { keywords: ["nature", "ding", "spring", "bell"], char: "🎐", fitzpatrick_scale: !1, category: "objects" }, crossed_flags = { keywords: ["japanese", "nation", "country", "border"], char: "🎌", fitzpatrick_scale: !1, category: "objects" }, izakaya_lantern = { keywords: ["light", "paper", "halloween", "spooky"], char: "🏮", fitzpatrick_scale: !1, category: "objects" }, red_envelope = { keywords: ["gift"], char: "🧧", fitzpatrick_scale: !1, category: "objects" }, email = { keywords: ["letter", "postal", "inbox", "communication"], char: "✉️", fitzpatrick_scale: !1, category: "objects" }, envelope_with_arrow = { keywords: ["email", "communication"], char: "📩", fitzpatrick_scale: !1, category: "objects" }, incoming_envelope = { keywords: ["email", "inbox"], char: "📨", fitzpatrick_scale: !1, category: "objects" }, love_letter = { keywords: ["email", "like", "affection", "envelope", "valentines"], char: "💌", fitzpatrick_scale: !1, category: "objects" }, postbox = { keywords: ["email", "letter", "envelope"], char: "📮", fitzpatrick_scale: !1, category: "objects" }, mailbox_closed = { keywords: ["email", "communication", "inbox"], char: "📪", fitzpatrick_scale: !1, category: "objects" }, mailbox = { keywords: ["email", "inbox", "communication"], char: "📫", fitzpatrick_scale: !1, category: "objects" }, mailbox_with_mail = { keywords: ["email", "inbox", "communication"], char: "📬", fitzpatrick_scale: !1, category: "objects" }, mailbox_with_no_mail = { keywords: ["email", "inbox"], char: "📭", fitzpatrick_scale: !1, category: "objects" }, postal_horn = { keywords: ["instrument", "music"], char: "📯", fitzpatrick_scale: !1, category: "objects" }, inbox_tray = { keywords: ["email", "documents"], char: "📥", fitzpatrick_scale: !1, category: "objects" }, outbox_tray = { keywords: ["inbox", "email"], char: "📤", fitzpatrick_scale: !1, category: "objects" }, scroll = { keywords: ["documents", "ancient", "history", "paper"], char: "📜", fitzpatrick_scale: !1, category: "objects" }, page_with_curl = { keywords: ["documents", "office", "paper"], char: "📃", fitzpatrick_scale: !1, category: "objects" }, bookmark_tabs = { keywords: ["favorite", "save", "order", "tidy"], char: "📑", fitzpatrick_scale: !1, category: "objects" }, receipt = { keywords: ["accounting", "expenses"], char: "🧾", fitzpatrick_scale: !1, category: "objects" }, bar_chart = { keywords: ["graph", "presentation", "stats"], char: "📊", fitzpatrick_scale: !1, category: "objects" }, chart_with_upwards_trend = { keywords: ["graph", "presentation", "stats", "recovery", "business", "economics", "money", "sales", "good", "success"], char: "📈", fitzpatrick_scale: !1, category: "objects" }, chart_with_downwards_trend = { keywords: ["graph", "presentation", "stats", "recession", "business", "economics", "money", "sales", "bad", "failure"], char: "📉", fitzpatrick_scale: !1, category: "objects" }, page_facing_up = { keywords: ["documents", "office", "paper", "information"], char: "📄", fitzpatrick_scale: !1, category: "objects" }, date$2 = { keywords: ["calendar", "schedule"], char: "📅", fitzpatrick_scale: !1, category: "objects" }, calendar$2 = { keywords: ["schedule", "date", "planning"], char: "📆", fitzpatrick_scale: !1, category: "objects" }, spiral_calendar = { keywords: ["date", "schedule", "planning"], char: "🗓", fitzpatrick_scale: !1, category: "objects" }, card_index = { keywords: ["business", "stationery"], char: "📇", fitzpatrick_scale: !1, category: "objects" }, card_file_box = { keywords: ["business", "stationery"], char: "🗃", fitzpatrick_scale: !1, category: "objects" }, ballot_box = { keywords: ["election", "vote"], char: "🗳", fitzpatrick_scale: !1, category: "objects" }, file_cabinet = { keywords: ["filing", "organizing"], char: "🗄", fitzpatrick_scale: !1, category: "objects" }, clipboard = { keywords: ["stationery", "documents"], char: "📋", fitzpatrick_scale: !1, category: "objects" }, spiral_notepad = { keywords: ["memo", "stationery"], char: "🗒", fitzpatrick_scale: !1, category: "objects" }, file_folder = { keywords: ["documents", "business", "office"], char: "📁", fitzpatrick_scale: !1, category: "objects" }, open_file_folder = { keywords: ["documents", "load"], char: "📂", fitzpatrick_scale: !1, category: "objects" }, card_index_dividers = { keywords: ["organizing", "business", "stationery"], char: "🗂", fitzpatrick_scale: !1, category: "objects" }, newspaper_roll = { keywords: ["press", "headline"], char: "🗞", fitzpatrick_scale: !1, category: "objects" }, newspaper = { keywords: ["press", "headline"], char: "📰", fitzpatrick_scale: !1, category: "objects" }, notebook = { keywords: ["stationery", "record", "notes", "paper", "study"], char: "📓", fitzpatrick_scale: !1, category: "objects" }, closed_book = { keywords: ["read", "library", "knowledge", "textbook", "learn"], char: "📕", fitzpatrick_scale: !1, category: "objects" }, green_book = { keywords: ["read", "library", "knowledge", "study"], char: "📗", fitzpatrick_scale: !1, category: "objects" }, blue_book = { keywords: ["read", "library", "knowledge", "learn", "study"], char: "📘", fitzpatrick_scale: !1, category: "objects" }, orange_book = { keywords: ["read", "library", "knowledge", "textbook", "study"], char: "📙", fitzpatrick_scale: !1, category: "objects" }, notebook_with_decorative_cover = { keywords: ["classroom", "notes", "record", "paper", "study"], char: "📔", fitzpatrick_scale: !1, category: "objects" }, ledger = { keywords: ["notes", "paper"], char: "📒", fitzpatrick_scale: !1, category: "objects" }, books = { keywords: ["literature", "library", "study"], char: "📚", fitzpatrick_scale: !1, category: "objects" }, open_book = { keywords: ["book", "read", "library", "knowledge", "literature", "learn", "study"], char: "📖", fitzpatrick_scale: !1, category: "objects" }, safety_pin = { keywords: ["diaper"], char: "🧷", fitzpatrick_scale: !1, category: "objects" }, link$2 = { keywords: ["rings", "url"], char: "🔗", fitzpatrick_scale: !1, category: "objects" }, paperclip = { keywords: ["documents", "stationery"], char: "📎", fitzpatrick_scale: !1, category: "objects" }, paperclips = { keywords: ["documents", "stationery"], char: "🖇", fitzpatrick_scale: !1, category: "objects" }, scissors = { keywords: ["stationery", "cut"], char: "✂️", fitzpatrick_scale: !1, category: "objects" }, triangular_ruler = { keywords: ["stationery", "math", "architect", "sketch"], char: "📐", fitzpatrick_scale: !1, category: "objects" }, straight_ruler = { keywords: ["stationery", "calculate", "length", "math", "school", "drawing", "architect", "sketch"], char: "📏", fitzpatrick_scale: !1, category: "objects" }, abacus = { keywords: ["calculation"], char: "🧮", fitzpatrick_scale: !1, category: "objects" }, pushpin = { keywords: ["stationery", "mark", "here"], char: "📌", fitzpatrick_scale: !1, category: "objects" }, round_pushpin = { keywords: ["stationery", "location", "map", "here"], char: "📍", fitzpatrick_scale: !1, category: "objects" }, triangular_flag_on_post = { keywords: ["mark", "milestone", "place"], char: "🚩", fitzpatrick_scale: !1, category: "objects" }, white_flag = { keywords: ["losing", "loser", "lost", "surrender", "give up", "fail"], char: "🏳", fitzpatrick_scale: !1, category: "objects" }, black_flag = { keywords: ["pirate"], char: "🏴", fitzpatrick_scale: !1, category: "objects" }, rainbow_flag = { keywords: ["flag", "rainbow", "pride", "gay", "lgbt", "glbt", "queer", "homosexual", "lesbian", "bisexual", "transgender"], char: "🏳️‍🌈", fitzpatrick_scale: !1, category: "objects" }, closed_lock_with_key = { keywords: ["security", "privacy"], char: "🔐", fitzpatrick_scale: !1, category: "objects" }, lock = { keywords: ["security", "password", "padlock"], char: "🔒", fitzpatrick_scale: !1, category: "objects" }, unlock = { keywords: ["privacy", "security"], char: "🔓", fitzpatrick_scale: !1, category: "objects" }, lock_with_ink_pen = { keywords: ["security", "secret"], char: "🔏", fitzpatrick_scale: !1, category: "objects" }, pen = { keywords: ["stationery", "writing", "write"], char: "🖊", fitzpatrick_scale: !1, category: "objects" }, fountain_pen = { keywords: ["stationery", "writing", "write"], char: "🖋", fitzpatrick_scale: !1, category: "objects" }, black_nib = { keywords: ["pen", "stationery", "writing", "write"], char: "✒️", fitzpatrick_scale: !1, category: "objects" }, memo = { keywords: ["write", "documents", "stationery", "pencil", "paper", "writing", "legal", "exam", "quiz", "test", "study", "compose"], char: "📝", fitzpatrick_scale: !1, category: "objects" }, pencil2 = { keywords: ["stationery", "write", "paper", "writing", "school", "study"], char: "✏️", fitzpatrick_scale: !1, category: "objects" }, crayon = { keywords: ["drawing", "creativity"], char: "🖍", fitzpatrick_scale: !1, category: "objects" }, paintbrush = { keywords: ["drawing", "creativity", "art"], char: "🖌", fitzpatrick_scale: !1, category: "objects" }, mag = { keywords: ["search", "zoom", "find", "detective"], char: "🔍", fitzpatrick_scale: !1, category: "objects" }, mag_right = { keywords: ["search", "zoom", "find", "detective"], char: "🔎", fitzpatrick_scale: !1, category: "objects" }, heart = { keywords: ["love", "like", "valentines"], char: "❤️", fitzpatrick_scale: !1, category: "symbols" }, orange_heart = { keywords: ["love", "like", "affection", "valentines"], char: "🧡", fitzpatrick_scale: !1, category: "symbols" }, yellow_heart = { keywords: ["love", "like", "affection", "valentines"], char: "💛", fitzpatrick_scale: !1, category: "symbols" }, green_heart = { keywords: ["love", "like", "affection", "valentines"], char: "💚", fitzpatrick_scale: !1, category: "symbols" }, blue_heart = { keywords: ["love", "like", "affection", "valentines"], char: "💙", fitzpatrick_scale: !1, category: "symbols" }, purple_heart = { keywords: ["love", "like", "affection", "valentines"], char: "💜", fitzpatrick_scale: !1, category: "symbols" }, black_heart = { keywords: ["evil"], char: "🖤", fitzpatrick_scale: !1, category: "symbols" }, broken_heart = { keywords: ["sad", "sorry", "break", "heart", "heartbreak"], char: "💔", fitzpatrick_scale: !1, category: "symbols" }, heavy_heart_exclamation = { keywords: ["decoration", "love"], char: "❣", fitzpatrick_scale: !1, category: "symbols" }, two_hearts = { keywords: ["love", "like", "affection", "valentines", "heart"], char: "💕", fitzpatrick_scale: !1, category: "symbols" }, revolving_hearts = { keywords: ["love", "like", "affection", "valentines"], char: "💞", fitzpatrick_scale: !1, category: "symbols" }, heartbeat = { keywords: ["love", "like", "affection", "valentines", "pink", "heart"], char: "💓", fitzpatrick_scale: !1, category: "symbols" }, heartpulse = { keywords: ["like", "love", "affection", "valentines", "pink"], char: "💗", fitzpatrick_scale: !1, category: "symbols" }, sparkling_heart = { keywords: ["love", "like", "affection", "valentines"], char: "💖", fitzpatrick_scale: !1, category: "symbols" }, cupid = { keywords: ["love", "like", "heart", "affection", "valentines"], char: "💘", fitzpatrick_scale: !1, category: "symbols" }, gift_heart = { keywords: ["love", "valentines"], char: "💝", fitzpatrick_scale: !1, category: "symbols" }, heart_decoration = { keywords: ["purple-square", "love", "like"], char: "💟", fitzpatrick_scale: !1, category: "symbols" }, peace_symbol = { keywords: ["hippie"], char: "☮", fitzpatrick_scale: !1, category: "symbols" }, latin_cross = { keywords: ["christianity"], char: "✝", fitzpatrick_scale: !1, category: "symbols" }, star_and_crescent = { keywords: ["islam"], char: "☪", fitzpatrick_scale: !1, category: "symbols" }, om = { keywords: ["hinduism", "buddhism", "sikhism", "jainism"], char: "🕉", fitzpatrick_scale: !1, category: "symbols" }, wheel_of_dharma = { keywords: ["hinduism", "buddhism", "sikhism", "jainism"], char: "☸", fitzpatrick_scale: !1, category: "symbols" }, star_of_david = { keywords: ["judaism"], char: "✡", fitzpatrick_scale: !1, category: "symbols" }, six_pointed_star = { keywords: ["purple-square", "religion", "jewish", "hexagram"], char: "🔯", fitzpatrick_scale: !1, category: "symbols" }, menorah = { keywords: ["hanukkah", "candles", "jewish"], char: "🕎", fitzpatrick_scale: !1, category: "symbols" }, yin_yang = { keywords: ["balance"], char: "☯", fitzpatrick_scale: !1, category: "symbols" }, orthodox_cross = { keywords: ["suppedaneum", "religion"], char: "☦", fitzpatrick_scale: !1, category: "symbols" }, place_of_worship = { keywords: ["religion", "church", "temple", "prayer"], char: "🛐", fitzpatrick_scale: !1, category: "symbols" }, ophiuchus = { keywords: ["sign", "purple-square", "constellation", "astrology"], char: "⛎", fitzpatrick_scale: !1, category: "symbols" }, aries = { keywords: ["sign", "purple-square", "zodiac", "astrology"], char: "♈", fitzpatrick_scale: !1, category: "symbols" }, taurus = { keywords: ["purple-square", "sign", "zodiac", "astrology"], char: "♉", fitzpatrick_scale: !1, category: "symbols" }, gemini = { keywords: ["sign", "zodiac", "purple-square", "astrology"], char: "♊", fitzpatrick_scale: !1, category: "symbols" }, cancer = { keywords: ["sign", "zodiac", "purple-square", "astrology"], char: "♋", fitzpatrick_scale: !1, category: "symbols" }, leo = { keywords: ["sign", "purple-square", "zodiac", "astrology"], char: "♌", fitzpatrick_scale: !1, category: "symbols" }, virgo = { keywords: ["sign", "zodiac", "purple-square", "astrology"], char: "♍", fitzpatrick_scale: !1, category: "symbols" }, libra = { keywords: ["sign", "purple-square", "zodiac", "astrology"], char: "♎", fitzpatrick_scale: !1, category: "symbols" }, scorpius = { keywords: ["sign", "zodiac", "purple-square", "astrology", "scorpio"], char: "♏", fitzpatrick_scale: !1, category: "symbols" }, sagittarius = { keywords: ["sign", "zodiac", "purple-square", "astrology"], char: "♐", fitzpatrick_scale: !1, category: "symbols" }, capricorn = { keywords: ["sign", "zodiac", "purple-square", "astrology"], char: "♑", fitzpatrick_scale: !1, category: "symbols" }, aquarius = { keywords: ["sign", "purple-square", "zodiac", "astrology"], char: "♒", fitzpatrick_scale: !1, category: "symbols" }, pisces = { keywords: ["purple-square", "sign", "zodiac", "astrology"], char: "♓", fitzpatrick_scale: !1, category: "symbols" }, id$1 = { keywords: ["purple-square", "words"], char: "🆔", fitzpatrick_scale: !1, category: "symbols" }, atom_symbol = { keywords: ["science", "physics", "chemistry"], char: "⚛", fitzpatrick_scale: !1, category: "symbols" }, u7a7a = { keywords: ["kanji", "japanese", "chinese", "empty", "sky", "blue-square"], char: "🈳", fitzpatrick_scale: !1, category: "symbols" }, u5272 = { keywords: ["cut", "divide", "chinese", "kanji", "pink-square"], char: "🈹", fitzpatrick_scale: !1, category: "symbols" }, radioactive = { keywords: ["nuclear", "danger"], char: "☢", fitzpatrick_scale: !1, category: "symbols" }, biohazard = { keywords: ["danger"], char: "☣", fitzpatrick_scale: !1, category: "symbols" }, mobile_phone_off = { keywords: ["mute", "orange-square", "silence", "quiet"], char: "📴", fitzpatrick_scale: !1, category: "symbols" }, vibration_mode = { keywords: ["orange-square", "phone"], char: "📳", fitzpatrick_scale: !1, category: "symbols" }, u6709 = { keywords: ["orange-square", "chinese", "have", "kanji"], char: "🈶", fitzpatrick_scale: !1, category: "symbols" }, u7121 = { keywords: ["nothing", "chinese", "kanji", "japanese", "orange-square"], char: "🈚", fitzpatrick_scale: !1, category: "symbols" }, u7533 = { keywords: ["chinese", "japanese", "kanji", "orange-square"], char: "🈸", fitzpatrick_scale: !1, category: "symbols" }, u55b6 = { keywords: ["japanese", "opening hours", "orange-square"], char: "🈺", fitzpatrick_scale: !1, category: "symbols" }, u6708 = { keywords: ["chinese", "month", "moon", "japanese", "orange-square", "kanji"], char: "🈷️", fitzpatrick_scale: !1, category: "symbols" }, eight_pointed_black_star = { keywords: ["orange-square", "shape", "polygon"], char: "✴️", fitzpatrick_scale: !1, category: "symbols" }, vs = { keywords: ["words", "orange-square"], char: "🆚", fitzpatrick_scale: !1, category: "symbols" }, accept = { keywords: ["ok", "good", "chinese", "kanji", "agree", "yes", "orange-circle"], char: "🉑", fitzpatrick_scale: !1, category: "symbols" }, white_flower = { keywords: ["japanese", "spring"], char: "💮", fitzpatrick_scale: !1, category: "symbols" }, ideograph_advantage = { keywords: ["chinese", "kanji", "obtain", "get", "circle"], char: "🉐", fitzpatrick_scale: !1, category: "symbols" }, secret = { keywords: ["privacy", "chinese", "sshh", "kanji", "red-circle"], char: "㊙️", fitzpatrick_scale: !1, category: "symbols" }, congratulations = { keywords: ["chinese", "kanji", "japanese", "red-circle"], char: "㊗️", fitzpatrick_scale: !1, category: "symbols" }, u5408 = { keywords: ["japanese", "chinese", "join", "kanji", "red-square"], char: "🈴", fitzpatrick_scale: !1, category: "symbols" }, u6e80 = { keywords: ["full", "chinese", "japanese", "red-square", "kanji"], char: "🈵", fitzpatrick_scale: !1, category: "symbols" }, u7981 = { keywords: ["kanji", "japanese", "chinese", "forbidden", "limit", "restricted", "red-square"], char: "🈲", fitzpatrick_scale: !1, category: "symbols" }, a$3 = { keywords: ["red-square", "alphabet", "letter"], char: "🅰️", fitzpatrick_scale: !1, category: "symbols" }, b$2 = { keywords: ["red-square", "alphabet", "letter"], char: "🅱️", fitzpatrick_scale: !1, category: "symbols" }, ab = { keywords: ["red-square", "alphabet"], char: "🆎", fitzpatrick_scale: !1, category: "symbols" }, cl = { keywords: ["alphabet", "words", "red-square"], char: "🆑", fitzpatrick_scale: !1, category: "symbols" }, o2 = { keywords: ["alphabet", "red-square", "letter"], char: "🅾️", fitzpatrick_scale: !1, category: "symbols" }, sos = { keywords: ["help", "red-square", "words", "emergency", "911"], char: "🆘", fitzpatrick_scale: !1, category: "symbols" }, no_entry = { keywords: ["limit", "security", "privacy", "bad", "denied", "stop", "circle"], char: "⛔", fitzpatrick_scale: !1, category: "symbols" }, name_badge = { keywords: ["fire", "forbid"], char: "📛", fitzpatrick_scale: !1, category: "symbols" }, no_entry_sign = { keywords: ["forbid", "stop", "limit", "denied", "disallow", "circle"], char: "🚫", fitzpatrick_scale: !1, category: "symbols" }, x$5 = { keywords: ["no", "delete", "remove", "cancel", "red"], char: "❌", fitzpatrick_scale: !1, category: "symbols" }, o = { keywords: ["circle", "round"], char: "⭕", fitzpatrick_scale: !1, category: "symbols" }, stop_sign = { keywords: ["stop"], char: "🛑", fitzpatrick_scale: !1, category: "symbols" }, anger = { keywords: ["angry", "mad"], char: "💢", fitzpatrick_scale: !1, category: "symbols" }, hotsprings = { keywords: ["bath", "warm", "relax"], char: "♨️", fitzpatrick_scale: !1, category: "symbols" }, no_pedestrians = { keywords: ["rules", "crossing", "walking", "circle"], char: "🚷", fitzpatrick_scale: !1, category: "symbols" }, do_not_litter = { keywords: ["trash", "bin", "garbage", "circle"], char: "🚯", fitzpatrick_scale: !1, category: "symbols" }, no_bicycles = { keywords: ["cyclist", "prohibited", "circle"], char: "🚳", fitzpatrick_scale: !1, category: "symbols" }, underage = { keywords: ["18", "drink", "pub", "night", "minor", "circle"], char: "🔞", fitzpatrick_scale: !1, category: "symbols" }, no_mobile_phones = { keywords: ["iphone", "mute", "circle"], char: "📵", fitzpatrick_scale: !1, category: "symbols" }, exclamation = { keywords: ["heavy_exclamation_mark", "danger", "surprise", "punctuation", "wow", "warning"], char: "❗", fitzpatrick_scale: !1, category: "symbols" }, grey_exclamation = { keywords: ["surprise", "punctuation", "gray", "wow", "warning"], char: "❕", fitzpatrick_scale: !1, category: "symbols" }, question = { keywords: ["doubt", "confused"], char: "❓", fitzpatrick_scale: !1, category: "symbols" }, grey_question = { keywords: ["doubts", "gray", "huh", "confused"], char: "❔", fitzpatrick_scale: !1, category: "symbols" }, bangbang = { keywords: ["exclamation", "surprise"], char: "‼️", fitzpatrick_scale: !1, category: "symbols" }, interrobang = { keywords: ["wat", "punctuation", "surprise"], char: "⁉️", fitzpatrick_scale: !1, category: "symbols" }, low_brightness = { keywords: ["sun", "afternoon", "warm", "summer"], char: "🔅", fitzpatrick_scale: !1, category: "symbols" }, high_brightness = { keywords: ["sun", "light"], char: "🔆", fitzpatrick_scale: !1, category: "symbols" }, trident = { keywords: ["weapon", "spear"], char: "🔱", fitzpatrick_scale: !1, category: "symbols" }, fleur_de_lis = { keywords: ["decorative", "scout"], char: "⚜", fitzpatrick_scale: !1, category: "symbols" }, part_alternation_mark = { keywords: ["graph", "presentation", "stats", "business", "economics", "bad"], char: "〽️", fitzpatrick_scale: !1, category: "symbols" }, warning$1 = { keywords: ["exclamation", "wip", "alert", "error", "problem", "issue"], char: "⚠️", fitzpatrick_scale: !1, category: "symbols" }, children_crossing = { keywords: ["school", "warning", "danger", "sign", "driving", "yellow-diamond"], char: "🚸", fitzpatrick_scale: !1, category: "symbols" }, beginner = { keywords: ["badge", "shield"], char: "🔰", fitzpatrick_scale: !1, category: "symbols" }, recycle = { keywords: ["arrow", "environment", "garbage", "trash"], char: "♻️", fitzpatrick_scale: !1, category: "symbols" }, u6307 = { keywords: ["chinese", "point", "green-square", "kanji"], char: "🈯", fitzpatrick_scale: !1, category: "symbols" }, chart = { keywords: ["green-square", "graph", "presentation", "stats"], char: "💹", fitzpatrick_scale: !1, category: "symbols" }, sparkle = { keywords: ["stars", "green-square", "awesome", "good", "fireworks"], char: "❇️", fitzpatrick_scale: !1, category: "symbols" }, eight_spoked_asterisk = { keywords: ["star", "sparkle", "green-square"], char: "✳️", fitzpatrick_scale: !1, category: "symbols" }, negative_squared_cross_mark = { keywords: ["x", "green-square", "no", "deny"], char: "❎", fitzpatrick_scale: !1, category: "symbols" }, white_check_mark = { keywords: ["green-square", "ok", "agree", "vote", "election", "answer", "tick"], char: "✅", fitzpatrick_scale: !1, category: "symbols" }, diamond_shape_with_a_dot_inside = { keywords: ["jewel", "blue", "gem", "crystal", "fancy"], char: "💠", fitzpatrick_scale: !1, category: "symbols" }, cyclone = { keywords: ["weather", "swirl", "blue", "cloud", "vortex", "spiral", "whirlpool", "spin", "tornado", "hurricane", "typhoon"], char: "🌀", fitzpatrick_scale: !1, category: "symbols" }, loop$1 = { keywords: ["tape", "cassette"], char: "➿", fitzpatrick_scale: !1, category: "symbols" }, globe_with_meridians = { keywords: ["earth", "international", "world", "internet", "interweb", "i18n"], char: "🌐", fitzpatrick_scale: !1, category: "symbols" }, m$4 = { keywords: ["alphabet", "blue-circle", "letter"], char: "Ⓜ️", fitzpatrick_scale: !1, category: "symbols" }, atm = { keywords: ["money", "sales", "cash", "blue-square", "payment", "bank"], char: "🏧", fitzpatrick_scale: !1, category: "symbols" }, sa$1 = { keywords: ["japanese", "blue-square", "katakana"], char: "🈂️", fitzpatrick_scale: !1, category: "symbols" }, passport_control = { keywords: ["custom", "blue-square"], char: "🛂", fitzpatrick_scale: !1, category: "symbols" }, customs = { keywords: ["passport", "border", "blue-square"], char: "🛃", fitzpatrick_scale: !1, category: "symbols" }, baggage_claim = { keywords: ["blue-square", "airport", "transport"], char: "🛄", fitzpatrick_scale: !1, category: "symbols" }, left_luggage = { keywords: ["blue-square", "travel"], char: "🛅", fitzpatrick_scale: !1, category: "symbols" }, wheelchair = { keywords: ["blue-square", "disabled", "a11y", "accessibility"], char: "♿", fitzpatrick_scale: !1, category: "symbols" }, no_smoking = { keywords: ["cigarette", "blue-square", "smell", "smoke"], char: "🚭", fitzpatrick_scale: !1, category: "symbols" }, wc = { keywords: ["toilet", "restroom", "blue-square"], char: "🚾", fitzpatrick_scale: !1, category: "symbols" }, parking = { keywords: ["cars", "blue-square", "alphabet", "letter"], char: "🅿️", fitzpatrick_scale: !1, category: "symbols" }, potable_water = { keywords: ["blue-square", "liquid", "restroom", "cleaning", "faucet"], char: "🚰", fitzpatrick_scale: !1, category: "symbols" }, mens = { keywords: ["toilet", "restroom", "wc", "blue-square", "gender", "male"], char: "🚹", fitzpatrick_scale: !1, category: "symbols" }, womens = { keywords: ["purple-square", "woman", "female", "toilet", "loo", "restroom", "gender"], char: "🚺", fitzpatrick_scale: !1, category: "symbols" }, baby_symbol = { keywords: ["orange-square", "child"], char: "🚼", fitzpatrick_scale: !1, category: "symbols" }, restroom = { keywords: ["blue-square", "toilet", "refresh", "wc", "gender"], char: "🚻", fitzpatrick_scale: !1, category: "symbols" }, put_litter_in_its_place = { keywords: ["blue-square", "sign", "human", "info"], char: "🚮", fitzpatrick_scale: !1, category: "symbols" }, cinema = { keywords: ["blue-square", "record", "film", "movie", "curtain", "stage", "theater"], char: "🎦", fitzpatrick_scale: !1, category: "symbols" }, signal_strength = { keywords: ["blue-square", "reception", "phone", "internet", "connection", "wifi", "bluetooth", "bars"], char: "📶", fitzpatrick_scale: !1, category: "symbols" }, koko = { keywords: ["blue-square", "here", "katakana", "japanese", "destination"], char: "🈁", fitzpatrick_scale: !1, category: "symbols" }, ng = { keywords: ["blue-square", "words", "shape", "icon"], char: "🆖", fitzpatrick_scale: !1, category: "symbols" }, ok = { keywords: ["good", "agree", "yes", "blue-square"], char: "🆗", fitzpatrick_scale: !1, category: "symbols" }, up = { keywords: ["blue-square", "above", "high"], char: "🆙", fitzpatrick_scale: !1, category: "symbols" }, cool = { keywords: ["words", "blue-square"], char: "🆒", fitzpatrick_scale: !1, category: "symbols" }, free = { keywords: ["blue-square", "words"], char: "🆓", fitzpatrick_scale: !1, category: "symbols" }, zero$5 = { keywords: ["0", "numbers", "blue-square", "null"], char: "0️⃣", fitzpatrick_scale: !1, category: "symbols" }, one$3 = { keywords: ["blue-square", "numbers", "1"], char: "1️⃣", fitzpatrick_scale: !1, category: "symbols" }, two = { keywords: ["numbers", "2", "prime", "blue-square"], char: "2️⃣", fitzpatrick_scale: !1, category: "symbols" }, three = { keywords: ["3", "numbers", "prime", "blue-square"], char: "3️⃣", fitzpatrick_scale: !1, category: "symbols" }, four = { keywords: ["4", "numbers", "blue-square"], char: "4️⃣", fitzpatrick_scale: !1, category: "symbols" }, five = { keywords: ["5", "numbers", "blue-square", "prime"], char: "5️⃣", fitzpatrick_scale: !1, category: "symbols" }, six = { keywords: ["6", "numbers", "blue-square"], char: "6️⃣", fitzpatrick_scale: !1, category: "symbols" }, seven = { keywords: ["7", "numbers", "blue-square", "prime"], char: "7️⃣", fitzpatrick_scale: !1, category: "symbols" }, eight = { keywords: ["8", "blue-square", "numbers"], char: "8️⃣", fitzpatrick_scale: !1, category: "symbols" }, nine = { keywords: ["blue-square", "numbers", "9"], char: "9️⃣", fitzpatrick_scale: !1, category: "symbols" }, keycap_ten = { keywords: ["numbers", "10", "blue-square"], char: "🔟", fitzpatrick_scale: !1, category: "symbols" }, asterisk = { keywords: ["star", "keycap"], char: "*⃣", fitzpatrick_scale: !1, category: "symbols" }, eject_button = { keywords: ["blue-square"], char: "⏏️", fitzpatrick_scale: !1, category: "symbols" }, arrow_forward = { keywords: ["blue-square", "right", "direction", "play"], char: "▶️", fitzpatrick_scale: !1, category: "symbols" }, pause_button = { keywords: ["pause", "blue-square"], char: "⏸", fitzpatrick_scale: !1, category: "symbols" }, next_track_button = { keywords: ["forward", "next", "blue-square"], char: "⏭", fitzpatrick_scale: !1, category: "symbols" }, stop_button = { keywords: ["blue-square"], char: "⏹", fitzpatrick_scale: !1, category: "symbols" }, record_button = { keywords: ["blue-square"], char: "⏺", fitzpatrick_scale: !1, category: "symbols" }, play_or_pause_button = { keywords: ["blue-square", "play", "pause"], char: "⏯", fitzpatrick_scale: !1, category: "symbols" }, previous_track_button = { keywords: ["backward"], char: "⏮", fitzpatrick_scale: !1, category: "symbols" }, fast_forward = { keywords: ["blue-square", "play", "speed", "continue"], char: "⏩", fitzpatrick_scale: !1, category: "symbols" }, rewind = { keywords: ["play", "blue-square"], char: "⏪", fitzpatrick_scale: !1, category: "symbols" }, twisted_rightwards_arrows = { keywords: ["blue-square", "shuffle", "music", "random"], char: "🔀", fitzpatrick_scale: !1, category: "symbols" }, repeat$1 = { keywords: ["loop", "record"], char: "🔁", fitzpatrick_scale: !1, category: "symbols" }, repeat_one = { keywords: ["blue-square", "loop"], char: "🔂", fitzpatrick_scale: !1, category: "symbols" }, arrow_backward = { keywords: ["blue-square", "left", "direction"], char: "◀️", fitzpatrick_scale: !1, category: "symbols" }, arrow_up_small = { keywords: ["blue-square", "triangle", "direction", "point", "forward", "top"], char: "🔼", fitzpatrick_scale: !1, category: "symbols" }, arrow_down_small = { keywords: ["blue-square", "direction", "bottom"], char: "🔽", fitzpatrick_scale: !1, category: "symbols" }, arrow_double_up = { keywords: ["blue-square", "direction", "top"], char: "⏫", fitzpatrick_scale: !1, category: "symbols" }, arrow_double_down = { keywords: ["blue-square", "direction", "bottom"], char: "⏬", fitzpatrick_scale: !1, category: "symbols" }, arrow_right = { keywords: ["blue-square", "next"], char: "➡️", fitzpatrick_scale: !1, category: "symbols" }, arrow_left = { keywords: ["blue-square", "previous", "back"], char: "⬅️", fitzpatrick_scale: !1, category: "symbols" }, arrow_up = { keywords: ["blue-square", "continue", "top", "direction"], char: "⬆️", fitzpatrick_scale: !1, category: "symbols" }, arrow_down = { keywords: ["blue-square", "direction", "bottom"], char: "⬇️", fitzpatrick_scale: !1, category: "symbols" }, arrow_upper_right = { keywords: ["blue-square", "point", "direction", "diagonal", "northeast"], char: "↗️", fitzpatrick_scale: !1, category: "symbols" }, arrow_lower_right = { keywords: ["blue-square", "direction", "diagonal", "southeast"], char: "↘️", fitzpatrick_scale: !1, category: "symbols" }, arrow_lower_left = { keywords: ["blue-square", "direction", "diagonal", "southwest"], char: "↙️", fitzpatrick_scale: !1, category: "symbols" }, arrow_upper_left = { keywords: ["blue-square", "point", "direction", "diagonal", "northwest"], char: "↖️", fitzpatrick_scale: !1, category: "symbols" }, arrow_up_down = { keywords: ["blue-square", "direction", "way", "vertical"], char: "↕️", fitzpatrick_scale: !1, category: "symbols" }, left_right_arrow = { keywords: ["shape", "direction", "horizontal", "sideways"], char: "↔️", fitzpatrick_scale: !1, category: "symbols" }, arrows_counterclockwise = { keywords: ["blue-square", "sync", "cycle"], char: "🔄", fitzpatrick_scale: !1, category: "symbols" }, arrow_right_hook = { keywords: ["blue-square", "return", "rotate", "direction"], char: "↪️", fitzpatrick_scale: !1, category: "symbols" }, leftwards_arrow_with_hook = { keywords: ["back", "return", "blue-square", "undo", "enter"], char: "↩️", fitzpatrick_scale: !1, category: "symbols" }, arrow_heading_up = { keywords: ["blue-square", "direction", "top"], char: "⤴️", fitzpatrick_scale: !1, category: "symbols" }, arrow_heading_down = { keywords: ["blue-square", "direction", "bottom"], char: "⤵️", fitzpatrick_scale: !1, category: "symbols" }, hash$1 = { keywords: ["symbol", "blue-square", "twitter"], char: "#️⃣", fitzpatrick_scale: !1, category: "symbols" }, information_source = { keywords: ["blue-square", "alphabet", "letter"], char: "ℹ️", fitzpatrick_scale: !1, category: "symbols" }, abc = { keywords: ["blue-square", "alphabet"], char: "🔤", fitzpatrick_scale: !1, category: "symbols" }, abcd = { keywords: ["blue-square", "alphabet"], char: "🔡", fitzpatrick_scale: !1, category: "symbols" }, capital_abcd = { keywords: ["alphabet", "words", "blue-square"], char: "🔠", fitzpatrick_scale: !1, category: "symbols" }, symbols$3 = { keywords: ["blue-square", "music", "note", "ampersand", "percent", "glyphs", "characters"], char: "🔣", fitzpatrick_scale: !1, category: "symbols" }, musical_note = { keywords: ["score", "tone", "sound"], char: "🎵", fitzpatrick_scale: !1, category: "symbols" }, notes = { keywords: ["music", "score"], char: "🎶", fitzpatrick_scale: !1, category: "symbols" }, wavy_dash = { keywords: ["draw", "line", "moustache", "mustache", "squiggle", "scribble"], char: "〰️", fitzpatrick_scale: !1, category: "symbols" }, curly_loop = { keywords: ["scribble", "draw", "shape", "squiggle"], char: "➰", fitzpatrick_scale: !1, category: "symbols" }, heavy_check_mark = { keywords: ["ok", "nike", "answer", "yes", "tick"], char: "✔️", fitzpatrick_scale: !1, category: "symbols" }, arrows_clockwise = { keywords: ["sync", "cycle", "round", "repeat"], char: "🔃", fitzpatrick_scale: !1, category: "symbols" }, heavy_plus_sign = { keywords: ["math", "calculation", "addition", "more", "increase"], char: "➕", fitzpatrick_scale: !1, category: "symbols" }, heavy_minus_sign = { keywords: ["math", "calculation", "subtract", "less"], char: "➖", fitzpatrick_scale: !1, category: "symbols" }, heavy_division_sign = { keywords: ["divide", "math", "calculation"], char: "➗", fitzpatrick_scale: !1, category: "symbols" }, heavy_multiplication_x = { keywords: ["math", "calculation"], char: "✖️", fitzpatrick_scale: !1, category: "symbols" }, infinity = { keywords: ["forever"], char: "♾", fitzpatrick_scale: !1, category: "symbols" }, heavy_dollar_sign = { keywords: ["money", "sales", "payment", "currency", "buck"], char: "💲", fitzpatrick_scale: !1, category: "symbols" }, currency_exchange = { keywords: ["money", "sales", "dollar", "travel"], char: "💱", fitzpatrick_scale: !1, category: "symbols" }, copyright = { keywords: ["ip", "license", "circle", "law", "legal"], char: "©️", fitzpatrick_scale: !1, category: "symbols" }, registered = { keywords: ["alphabet", "circle"], char: "®️", fitzpatrick_scale: !1, category: "symbols" }, tm = { keywords: ["trademark", "brand", "law", "legal"], char: "™️", fitzpatrick_scale: !1, category: "symbols" }, end = { keywords: ["words", "arrow"], char: "🔚", fitzpatrick_scale: !1, category: "symbols" }, back = { keywords: ["arrow", "words", "return"], char: "🔙", fitzpatrick_scale: !1, category: "symbols" }, on$1 = { keywords: ["arrow", "words"], char: "🔛", fitzpatrick_scale: !1, category: "symbols" }, top = { keywords: ["words", "blue-square"], char: "🔝", fitzpatrick_scale: !1, category: "symbols" }, soon = { keywords: ["arrow", "words"], char: "🔜", fitzpatrick_scale: !1, category: "symbols" }, ballot_box_with_check = { keywords: ["ok", "agree", "confirm", "black-square", "vote", "election", "yes", "tick"], char: "☑️", fitzpatrick_scale: !1, category: "symbols" }, radio_button = { keywords: ["input", "old", "music", "circle"], char: "🔘", fitzpatrick_scale: !1, category: "symbols" }, white_circle = { keywords: ["shape", "round"], char: "⚪", fitzpatrick_scale: !1, category: "symbols" }, black_circle = { keywords: ["shape", "button", "round"], char: "⚫", fitzpatrick_scale: !1, category: "symbols" }, red_circle = { keywords: ["shape", "error", "danger"], char: "🔴", fitzpatrick_scale: !1, category: "symbols" }, large_blue_circle = { keywords: ["shape", "icon", "button"], char: "🔵", fitzpatrick_scale: !1, category: "symbols" }, small_orange_diamond = { keywords: ["shape", "jewel", "gem"], char: "🔸", fitzpatrick_scale: !1, category: "symbols" }, small_blue_diamond = { keywords: ["shape", "jewel", "gem"], char: "🔹", fitzpatrick_scale: !1, category: "symbols" }, large_orange_diamond = { keywords: ["shape", "jewel", "gem"], char: "🔶", fitzpatrick_scale: !1, category: "symbols" }, large_blue_diamond = { keywords: ["shape", "jewel", "gem"], char: "🔷", fitzpatrick_scale: !1, category: "symbols" }, small_red_triangle = { keywords: ["shape", "direction", "up", "top"], char: "🔺", fitzpatrick_scale: !1, category: "symbols" }, black_small_square = { keywords: ["shape", "icon"], char: "▪️", fitzpatrick_scale: !1, category: "symbols" }, white_small_square = { keywords: ["shape", "icon"], char: "▫️", fitzpatrick_scale: !1, category: "symbols" }, black_large_square = { keywords: ["shape", "icon", "button"], char: "⬛", fitzpatrick_scale: !1, category: "symbols" }, white_large_square = { keywords: ["shape", "icon", "stone", "button"], char: "⬜", fitzpatrick_scale: !1, category: "symbols" }, small_red_triangle_down = { keywords: ["shape", "direction", "bottom"], char: "🔻", fitzpatrick_scale: !1, category: "symbols" }, black_medium_square = { keywords: ["shape", "button", "icon"], char: "◼️", fitzpatrick_scale: !1, category: "symbols" }, white_medium_square = { keywords: ["shape", "stone", "icon"], char: "◻️", fitzpatrick_scale: !1, category: "symbols" }, black_medium_small_square = { keywords: ["icon", "shape", "button"], char: "◾", fitzpatrick_scale: !1, category: "symbols" }, white_medium_small_square = { keywords: ["shape", "stone", "icon", "button"], char: "◽", fitzpatrick_scale: !1, category: "symbols" }, black_square_button = { keywords: ["shape", "input", "frame"], char: "🔲", fitzpatrick_scale: !1, category: "symbols" }, white_square_button = { keywords: ["shape", "input"], char: "🔳", fitzpatrick_scale: !1, category: "symbols" }, speaker = { keywords: ["sound", "volume", "silence", "broadcast"], char: "🔈", fitzpatrick_scale: !1, category: "symbols" }, sound = { keywords: ["volume", "speaker", "broadcast"], char: "🔉", fitzpatrick_scale: !1, category: "symbols" }, loud_sound = { keywords: ["volume", "noise", "noisy", "speaker", "broadcast"], char: "🔊", fitzpatrick_scale: !1, category: "symbols" }, mute = { keywords: ["sound", "volume", "silence", "quiet"], char: "🔇", fitzpatrick_scale: !1, category: "symbols" }, mega = { keywords: ["sound", "speaker", "volume"], char: "📣", fitzpatrick_scale: !1, category: "symbols" }, loudspeaker = { keywords: ["volume", "sound"], char: "📢", fitzpatrick_scale: !1, category: "symbols" }, bell = { keywords: ["sound", "notification", "christmas", "xmas", "chime"], char: "🔔", fitzpatrick_scale: !1, category: "symbols" }, no_bell = { keywords: ["sound", "volume", "mute", "quiet", "silent"], char: "🔕", fitzpatrick_scale: !1, category: "symbols" }, black_joker = { keywords: ["poker", "cards", "game", "play", "magic"], char: "🃏", fitzpatrick_scale: !1, category: "symbols" }, mahjong = { keywords: ["game", "play", "chinese", "kanji"], char: "🀄", fitzpatrick_scale: !1, category: "symbols" }, spades = { keywords: ["poker", "cards", "suits", "magic"], char: "♠️", fitzpatrick_scale: !1, category: "symbols" }, clubs = { keywords: ["poker", "cards", "magic", "suits"], char: "♣️", fitzpatrick_scale: !1, category: "symbols" }, hearts = { keywords: ["poker", "cards", "magic", "suits"], char: "♥️", fitzpatrick_scale: !1, category: "symbols" }, diamonds = { keywords: ["poker", "cards", "magic", "suits"], char: "♦️", fitzpatrick_scale: !1, category: "symbols" }, flower_playing_cards = { keywords: ["game", "sunset", "red"], char: "🎴", fitzpatrick_scale: !1, category: "symbols" }, thought_balloon = { keywords: ["bubble", "cloud", "speech", "thinking", "dream"], char: "💭", fitzpatrick_scale: !1, category: "symbols" }, right_anger_bubble = { keywords: ["caption", "speech", "thinking", "mad"], char: "🗯", fitzpatrick_scale: !1, category: "symbols" }, speech_balloon = { keywords: ["bubble", "words", "message", "talk", "chatting"], char: "💬", fitzpatrick_scale: !1, category: "symbols" }, left_speech_bubble = { keywords: ["words", "message", "talk", "chatting"], char: "🗨", fitzpatrick_scale: !1, category: "symbols" }, clock1 = { keywords: ["time", "late", "early", "schedule"], char: "🕐", fitzpatrick_scale: !1, category: "symbols" }, clock2 = { keywords: ["time", "late", "early", "schedule"], char: "🕑", fitzpatrick_scale: !1, category: "symbols" }, clock3 = { keywords: ["time", "late", "early", "schedule"], char: "🕒", fitzpatrick_scale: !1, category: "symbols" }, clock4 = { keywords: ["time", "late", "early", "schedule"], char: "🕓", fitzpatrick_scale: !1, category: "symbols" }, clock5 = { keywords: ["time", "late", "early", "schedule"], char: "🕔", fitzpatrick_scale: !1, category: "symbols" }, clock6 = { keywords: ["time", "late", "early", "schedule", "dawn", "dusk"], char: "🕕", fitzpatrick_scale: !1, category: "symbols" }, clock7 = { keywords: ["time", "late", "early", "schedule"], char: "🕖", fitzpatrick_scale: !1, category: "symbols" }, clock8 = { keywords: ["time", "late", "early", "schedule"], char: "🕗", fitzpatrick_scale: !1, category: "symbols" }, clock9 = { keywords: ["time", "late", "early", "schedule"], char: "🕘", fitzpatrick_scale: !1, category: "symbols" }, clock10 = { keywords: ["time", "late", "early", "schedule"], char: "🕙", fitzpatrick_scale: !1, category: "symbols" }, clock11 = { keywords: ["time", "late", "early", "schedule"], char: "🕚", fitzpatrick_scale: !1, category: "symbols" }, clock12 = { keywords: ["time", "noon", "midnight", "midday", "late", "early", "schedule"], char: "🕛", fitzpatrick_scale: !1, category: "symbols" }, clock130 = { keywords: ["time", "late", "early", "schedule"], char: "🕜", fitzpatrick_scale: !1, category: "symbols" }, clock230 = { keywords: ["time", "late", "early", "schedule"], char: "🕝", fitzpatrick_scale: !1, category: "symbols" }, clock330 = { keywords: ["time", "late", "early", "schedule"], char: "🕞", fitzpatrick_scale: !1, category: "symbols" }, clock430 = { keywords: ["time", "late", "early", "schedule"], char: "🕟", fitzpatrick_scale: !1, category: "symbols" }, clock530 = { keywords: ["time", "late", "early", "schedule"], char: "🕠", fitzpatrick_scale: !1, category: "symbols" }, clock630 = { keywords: ["time", "late", "early", "schedule"], char: "🕡", fitzpatrick_scale: !1, category: "symbols" }, clock730 = { keywords: ["time", "late", "early", "schedule"], char: "🕢", fitzpatrick_scale: !1, category: "symbols" }, clock830 = { keywords: ["time", "late", "early", "schedule"], char: "🕣", fitzpatrick_scale: !1, category: "symbols" }, clock930 = { keywords: ["time", "late", "early", "schedule"], char: "🕤", fitzpatrick_scale: !1, category: "symbols" }, clock1030 = { keywords: ["time", "late", "early", "schedule"], char: "🕥", fitzpatrick_scale: !1, category: "symbols" }, clock1130 = { keywords: ["time", "late", "early", "schedule"], char: "🕦", fitzpatrick_scale: !1, category: "symbols" }, clock1230 = { keywords: ["time", "late", "early", "schedule"], char: "🕧", fitzpatrick_scale: !1, category: "symbols" }, afghanistan = { keywords: ["af", "flag", "nation", "country", "banner"], char: "🇦🇫", fitzpatrick_scale: !1, category: "flags" }, aland_islands = { keywords: ["Åland", "islands", "flag", "nation", "country", "banner"], char: "🇦🇽", fitzpatrick_scale: !1, category: "flags" }, albania = { keywords: ["al", "flag", "nation", "country", "banner"], char: "🇦🇱", fitzpatrick_scale: !1, category: "flags" }, algeria = { keywords: ["dz", "flag", "nation", "country", "banner"], char: "🇩🇿", fitzpatrick_scale: !1, category: "flags" }, american_samoa = { keywords: ["american", "ws", "flag", "nation", "country", "banner"], char: "🇦🇸", fitzpatrick_scale: !1, category: "flags" }, andorra = { keywords: ["ad", "flag", "nation", "country", "banner"], char: "🇦🇩", fitzpatrick_scale: !1, category: "flags" }, angola = { keywords: ["ao", "flag", "nation", "country", "banner"], char: "🇦🇴", fitzpatrick_scale: !1, category: "flags" }, anguilla = { keywords: ["ai", "flag", "nation", "country", "banner"], char: "🇦🇮", fitzpatrick_scale: !1, category: "flags" }, antarctica = { keywords: ["aq", "flag", "nation", "country", "banner"], char: "🇦🇶", fitzpatrick_scale: !1, category: "flags" }, antigua_barbuda = { keywords: ["antigua", "barbuda", "flag", "nation", "country", "banner"], char: "🇦🇬", fitzpatrick_scale: !1, category: "flags" }, argentina = { keywords: ["ar", "flag", "nation", "country", "banner"], char: "🇦🇷", fitzpatrick_scale: !1, category: "flags" }, armenia = { keywords: ["am", "flag", "nation", "country", "banner"], char: "🇦🇲", fitzpatrick_scale: !1, category: "flags" }, aruba = { keywords: ["aw", "flag", "nation", "country", "banner"], char: "🇦🇼", fitzpatrick_scale: !1, category: "flags" }, australia = { keywords: ["au", "flag", "nation", "country", "banner"], char: "🇦🇺", fitzpatrick_scale: !1, category: "flags" }, austria = { keywords: ["at", "flag", "nation", "country", "banner"], char: "🇦🇹", fitzpatrick_scale: !1, category: "flags" }, azerbaijan = { keywords: ["az", "flag", "nation", "country", "banner"], char: "🇦🇿", fitzpatrick_scale: !1, category: "flags" }, bahamas = { keywords: ["bs", "flag", "nation", "country", "banner"], char: "🇧🇸", fitzpatrick_scale: !1, category: "flags" }, bahrain = { keywords: ["bh", "flag", "nation", "country", "banner"], char: "🇧🇭", fitzpatrick_scale: !1, category: "flags" }, bangladesh = { keywords: ["bd", "flag", "nation", "country", "banner"], char: "🇧🇩", fitzpatrick_scale: !1, category: "flags" }, barbados = { keywords: ["bb", "flag", "nation", "country", "banner"], char: "🇧🇧", fitzpatrick_scale: !1, category: "flags" }, belarus = { keywords: ["by", "flag", "nation", "country", "banner"], char: "🇧🇾", fitzpatrick_scale: !1, category: "flags" }, belgium = { keywords: ["be", "flag", "nation", "country", "banner"], char: "🇧🇪", fitzpatrick_scale: !1, category: "flags" }, belize = { keywords: ["bz", "flag", "nation", "country", "banner"], char: "🇧🇿", fitzpatrick_scale: !1, category: "flags" }, benin = { keywords: ["bj", "flag", "nation", "country", "banner"], char: "🇧🇯", fitzpatrick_scale: !1, category: "flags" }, bermuda = { keywords: ["bm", "flag", "nation", "country", "banner"], char: "🇧🇲", fitzpatrick_scale: !1, category: "flags" }, bhutan = { keywords: ["bt", "flag", "nation", "country", "banner"], char: "🇧🇹", fitzpatrick_scale: !1, category: "flags" }, bolivia = { keywords: ["bo", "flag", "nation", "country", "banner"], char: "🇧🇴", fitzpatrick_scale: !1, category: "flags" }, caribbean_netherlands = { keywords: ["bonaire", "flag", "nation", "country", "banner"], char: "🇧🇶", fitzpatrick_scale: !1, category: "flags" }, bosnia_herzegovina = { keywords: ["bosnia", "herzegovina", "flag", "nation", "country", "banner"], char: "🇧🇦", fitzpatrick_scale: !1, category: "flags" }, botswana = { keywords: ["bw", "flag", "nation", "country", "banner"], char: "🇧🇼", fitzpatrick_scale: !1, category: "flags" }, brazil = { keywords: ["br", "flag", "nation", "country", "banner"], char: "🇧🇷", fitzpatrick_scale: !1, category: "flags" }, british_indian_ocean_territory = { keywords: ["british", "indian", "ocean", "territory", "flag", "nation", "country", "banner"], char: "🇮🇴", fitzpatrick_scale: !1, category: "flags" }, british_virgin_islands = { keywords: ["british", "virgin", "islands", "bvi", "flag", "nation", "country", "banner"], char: "🇻🇬", fitzpatrick_scale: !1, category: "flags" }, brunei = { keywords: ["bn", "darussalam", "flag", "nation", "country", "banner"], char: "🇧🇳", fitzpatrick_scale: !1, category: "flags" }, bulgaria = { keywords: ["bg", "flag", "nation", "country", "banner"], char: "🇧🇬", fitzpatrick_scale: !1, category: "flags" }, burkina_faso = { keywords: ["burkina", "faso", "flag", "nation", "country", "banner"], char: "🇧🇫", fitzpatrick_scale: !1, category: "flags" }, burundi = { keywords: ["bi", "flag", "nation", "country", "banner"], char: "🇧🇮", fitzpatrick_scale: !1, category: "flags" }, cape_verde = { keywords: ["cabo", "verde", "flag", "nation", "country", "banner"], char: "🇨🇻", fitzpatrick_scale: !1, category: "flags" }, cambodia = { keywords: ["kh", "flag", "nation", "country", "banner"], char: "🇰🇭", fitzpatrick_scale: !1, category: "flags" }, cameroon = { keywords: ["cm", "flag", "nation", "country", "banner"], char: "🇨🇲", fitzpatrick_scale: !1, category: "flags" }, canada = { keywords: ["ca", "flag", "nation", "country", "banner"], char: "🇨🇦", fitzpatrick_scale: !1, category: "flags" }, canary_islands = { keywords: ["canary", "islands", "flag", "nation", "country", "banner"], char: "🇮🇨", fitzpatrick_scale: !1, category: "flags" }, cayman_islands = { keywords: ["cayman", "islands", "flag", "nation", "country", "banner"], char: "🇰🇾", fitzpatrick_scale: !1, category: "flags" }, central_african_republic = { keywords: ["central", "african", "republic", "flag", "nation", "country", "banner"], char: "🇨🇫", fitzpatrick_scale: !1, category: "flags" }, chad = { keywords: ["td", "flag", "nation", "country", "banner"], char: "🇹🇩", fitzpatrick_scale: !1, category: "flags" }, chile = { keywords: ["flag", "nation", "country", "banner"], char: "🇨🇱", fitzpatrick_scale: !1, category: "flags" }, cn = { keywords: ["china", "chinese", "prc", "flag", "country", "nation", "banner"], char: "🇨🇳", fitzpatrick_scale: !1, category: "flags" }, christmas_island = { keywords: ["christmas", "island", "flag", "nation", "country", "banner"], char: "🇨🇽", fitzpatrick_scale: !1, category: "flags" }, cocos_islands = { keywords: ["cocos", "keeling", "islands", "flag", "nation", "country", "banner"], char: "🇨🇨", fitzpatrick_scale: !1, category: "flags" }, colombia = { keywords: ["co", "flag", "nation", "country", "banner"], char: "🇨🇴", fitzpatrick_scale: !1, category: "flags" }, comoros = { keywords: ["km", "flag", "nation", "country", "banner"], char: "🇰🇲", fitzpatrick_scale: !1, category: "flags" }, congo_brazzaville = { keywords: ["congo", "flag", "nation", "country", "banner"], char: "🇨🇬", fitzpatrick_scale: !1, category: "flags" }, congo_kinshasa = { keywords: ["congo", "democratic", "republic", "flag", "nation", "country", "banner"], char: "🇨🇩", fitzpatrick_scale: !1, category: "flags" }, cook_islands = { keywords: ["cook", "islands", "flag", "nation", "country", "banner"], char: "🇨🇰", fitzpatrick_scale: !1, category: "flags" }, costa_rica = { keywords: ["costa", "rica", "flag", "nation", "country", "banner"], char: "🇨🇷", fitzpatrick_scale: !1, category: "flags" }, croatia = { keywords: ["hr", "flag", "nation", "country", "banner"], char: "🇭🇷", fitzpatrick_scale: !1, category: "flags" }, cuba = { keywords: ["cu", "flag", "nation", "country", "banner"], char: "🇨🇺", fitzpatrick_scale: !1, category: "flags" }, curacao = { keywords: ["curaçao", "flag", "nation", "country", "banner"], char: "🇨🇼", fitzpatrick_scale: !1, category: "flags" }, cyprus = { keywords: ["cy", "flag", "nation", "country", "banner"], char: "🇨🇾", fitzpatrick_scale: !1, category: "flags" }, czech_republic = { keywords: ["cz", "flag", "nation", "country", "banner"], char: "🇨🇿", fitzpatrick_scale: !1, category: "flags" }, denmark = { keywords: ["dk", "flag", "nation", "country", "banner"], char: "🇩🇰", fitzpatrick_scale: !1, category: "flags" }, djibouti = { keywords: ["dj", "flag", "nation", "country", "banner"], char: "🇩🇯", fitzpatrick_scale: !1, category: "flags" }, dominica = { keywords: ["dm", "flag", "nation", "country", "banner"], char: "🇩🇲", fitzpatrick_scale: !1, category: "flags" }, dominican_republic = { keywords: ["dominican", "republic", "flag", "nation", "country", "banner"], char: "🇩🇴", fitzpatrick_scale: !1, category: "flags" }, ecuador = { keywords: ["ec", "flag", "nation", "country", "banner"], char: "🇪🇨", fitzpatrick_scale: !1, category: "flags" }, egypt = { keywords: ["eg", "flag", "nation", "country", "banner"], char: "🇪🇬", fitzpatrick_scale: !1, category: "flags" }, el_salvador = { keywords: ["el", "salvador", "flag", "nation", "country", "banner"], char: "🇸🇻", fitzpatrick_scale: !1, category: "flags" }, equatorial_guinea = { keywords: ["equatorial", "gn", "flag", "nation", "country", "banner"], char: "🇬🇶", fitzpatrick_scale: !1, category: "flags" }, eritrea = { keywords: ["er", "flag", "nation", "country", "banner"], char: "🇪🇷", fitzpatrick_scale: !1, category: "flags" }, estonia = { keywords: ["ee", "flag", "nation", "country", "banner"], char: "🇪🇪", fitzpatrick_scale: !1, category: "flags" }, ethiopia = { keywords: ["et", "flag", "nation", "country", "banner"], char: "🇪🇹", fitzpatrick_scale: !1, category: "flags" }, eu = { keywords: ["european", "union", "flag", "banner"], char: "🇪🇺", fitzpatrick_scale: !1, category: "flags" }, falkland_islands = { keywords: ["falkland", "islands", "malvinas", "flag", "nation", "country", "banner"], char: "🇫🇰", fitzpatrick_scale: !1, category: "flags" }, faroe_islands = { keywords: ["faroe", "islands", "flag", "nation", "country", "banner"], char: "🇫🇴", fitzpatrick_scale: !1, category: "flags" }, fiji = { keywords: ["fj", "flag", "nation", "country", "banner"], char: "🇫🇯", fitzpatrick_scale: !1, category: "flags" }, finland = { keywords: ["fi", "flag", "nation", "country", "banner"], char: "🇫🇮", fitzpatrick_scale: !1, category: "flags" }, fr = { keywords: ["banner", "flag", "nation", "france", "french", "country"], char: "🇫🇷", fitzpatrick_scale: !1, category: "flags" }, french_guiana = { keywords: ["french", "guiana", "flag", "nation", "country", "banner"], char: "🇬🇫", fitzpatrick_scale: !1, category: "flags" }, french_polynesia = { keywords: ["french", "polynesia", "flag", "nation", "country", "banner"], char: "🇵🇫", fitzpatrick_scale: !1, category: "flags" }, french_southern_territories = { keywords: ["french", "southern", "territories", "flag", "nation", "country", "banner"], char: "🇹🇫", fitzpatrick_scale: !1, category: "flags" }, gabon = { keywords: ["ga", "flag", "nation", "country", "banner"], char: "🇬🇦", fitzpatrick_scale: !1, category: "flags" }, gambia = { keywords: ["gm", "flag", "nation", "country", "banner"], char: "🇬🇲", fitzpatrick_scale: !1, category: "flags" }, georgia = { keywords: ["ge", "flag", "nation", "country", "banner"], char: "🇬🇪", fitzpatrick_scale: !1, category: "flags" }, de$1 = { keywords: ["german", "nation", "flag", "country", "banner"], char: "🇩🇪", fitzpatrick_scale: !1, category: "flags" }, ghana = { keywords: ["gh", "flag", "nation", "country", "banner"], char: "🇬🇭", fitzpatrick_scale: !1, category: "flags" }, gibraltar = { keywords: ["gi", "flag", "nation", "country", "banner"], char: "🇬🇮", fitzpatrick_scale: !1, category: "flags" }, greece = { keywords: ["gr", "flag", "nation", "country", "banner"], char: "🇬🇷", fitzpatrick_scale: !1, category: "flags" }, greenland = { keywords: ["gl", "flag", "nation", "country", "banner"], char: "🇬🇱", fitzpatrick_scale: !1, category: "flags" }, grenada = { keywords: ["gd", "flag", "nation", "country", "banner"], char: "🇬🇩", fitzpatrick_scale: !1, category: "flags" }, guadeloupe = { keywords: ["gp", "flag", "nation", "country", "banner"], char: "🇬🇵", fitzpatrick_scale: !1, category: "flags" }, guam = { keywords: ["gu", "flag", "nation", "country", "banner"], char: "🇬🇺", fitzpatrick_scale: !1, category: "flags" }, guatemala = { keywords: ["gt", "flag", "nation", "country", "banner"], char: "🇬🇹", fitzpatrick_scale: !1, category: "flags" }, guernsey = { keywords: ["gg", "flag", "nation", "country", "banner"], char: "🇬🇬", fitzpatrick_scale: !1, category: "flags" }, guinea = { keywords: ["gn", "flag", "nation", "country", "banner"], char: "🇬🇳", fitzpatrick_scale: !1, category: "flags" }, guinea_bissau = { keywords: ["gw", "bissau", "flag", "nation", "country", "banner"], char: "🇬🇼", fitzpatrick_scale: !1, category: "flags" }, guyana = { keywords: ["gy", "flag", "nation", "country", "banner"], char: "🇬🇾", fitzpatrick_scale: !1, category: "flags" }, haiti = { keywords: ["ht", "flag", "nation", "country", "banner"], char: "🇭🇹", fitzpatrick_scale: !1, category: "flags" }, honduras = { keywords: ["hn", "flag", "nation", "country", "banner"], char: "🇭🇳", fitzpatrick_scale: !1, category: "flags" }, hong_kong = { keywords: ["hong", "kong", "flag", "nation", "country", "banner"], char: "🇭🇰", fitzpatrick_scale: !1, category: "flags" }, hungary = { keywords: ["hu", "flag", "nation", "country", "banner"], char: "🇭🇺", fitzpatrick_scale: !1, category: "flags" }, iceland = { keywords: ["is", "flag", "nation", "country", "banner"], char: "🇮🇸", fitzpatrick_scale: !1, category: "flags" }, india = { keywords: ["in", "flag", "nation", "country", "banner"], char: "🇮🇳", fitzpatrick_scale: !1, category: "flags" }, indonesia = { keywords: ["flag", "nation", "country", "banner"], char: "🇮🇩", fitzpatrick_scale: !1, category: "flags" }, iran = { keywords: ["iran,", "islamic", "republic", "flag", "nation", "country", "banner"], char: "🇮🇷", fitzpatrick_scale: !1, category: "flags" }, iraq = { keywords: ["iq", "flag", "nation", "country", "banner"], char: "🇮🇶", fitzpatrick_scale: !1, category: "flags" }, ireland = { keywords: ["ie", "flag", "nation", "country", "banner"], char: "🇮🇪", fitzpatrick_scale: !1, category: "flags" }, isle_of_man = { keywords: ["isle", "man", "flag", "nation", "country", "banner"], char: "🇮🇲", fitzpatrick_scale: !1, category: "flags" }, israel = { keywords: ["il", "flag", "nation", "country", "banner"], char: "🇮🇱", fitzpatrick_scale: !1, category: "flags" }, it = { keywords: ["italy", "flag", "nation", "country", "banner"], char: "🇮🇹", fitzpatrick_scale: !1, category: "flags" }, cote_divoire = { keywords: ["ivory", "coast", "flag", "nation", "country", "banner"], char: "🇨🇮", fitzpatrick_scale: !1, category: "flags" }, jamaica = { keywords: ["jm", "flag", "nation", "country", "banner"], char: "🇯🇲", fitzpatrick_scale: !1, category: "flags" }, jp = { keywords: ["japanese", "nation", "flag", "country", "banner"], char: "🇯🇵", fitzpatrick_scale: !1, category: "flags" }, jersey = { keywords: ["je", "flag", "nation", "country", "banner"], char: "🇯🇪", fitzpatrick_scale: !1, category: "flags" }, jordan = { keywords: ["jo", "flag", "nation", "country", "banner"], char: "🇯🇴", fitzpatrick_scale: !1, category: "flags" }, kazakhstan = { keywords: ["kz", "flag", "nation", "country", "banner"], char: "🇰🇿", fitzpatrick_scale: !1, category: "flags" }, kenya = { keywords: ["ke", "flag", "nation", "country", "banner"], char: "🇰🇪", fitzpatrick_scale: !1, category: "flags" }, kiribati = { keywords: ["ki", "flag", "nation", "country", "banner"], char: "🇰🇮", fitzpatrick_scale: !1, category: "flags" }, kosovo = { keywords: ["xk", "flag", "nation", "country", "banner"], char: "🇽🇰", fitzpatrick_scale: !1, category: "flags" }, kuwait = { keywords: ["kw", "flag", "nation", "country", "banner"], char: "🇰🇼", fitzpatrick_scale: !1, category: "flags" }, kyrgyzstan = { keywords: ["kg", "flag", "nation", "country", "banner"], char: "🇰🇬", fitzpatrick_scale: !1, category: "flags" }, laos = { keywords: ["lao", "democratic", "republic", "flag", "nation", "country", "banner"], char: "🇱🇦", fitzpatrick_scale: !1, category: "flags" }, latvia = { keywords: ["lv", "flag", "nation", "country", "banner"], char: "🇱🇻", fitzpatrick_scale: !1, category: "flags" }, lebanon = { keywords: ["lb", "flag", "nation", "country", "banner"], char: "🇱🇧", fitzpatrick_scale: !1, category: "flags" }, lesotho = { keywords: ["ls", "flag", "nation", "country", "banner"], char: "🇱🇸", fitzpatrick_scale: !1, category: "flags" }, liberia = { keywords: ["lr", "flag", "nation", "country", "banner"], char: "🇱🇷", fitzpatrick_scale: !1, category: "flags" }, libya = { keywords: ["ly", "flag", "nation", "country", "banner"], char: "🇱🇾", fitzpatrick_scale: !1, category: "flags" }, liechtenstein = { keywords: ["li", "flag", "nation", "country", "banner"], char: "🇱🇮", fitzpatrick_scale: !1, category: "flags" }, lithuania = { keywords: ["lt", "flag", "nation", "country", "banner"], char: "🇱🇹", fitzpatrick_scale: !1, category: "flags" }, luxembourg = { keywords: ["lu", "flag", "nation", "country", "banner"], char: "🇱🇺", fitzpatrick_scale: !1, category: "flags" }, macau = { keywords: ["macao", "flag", "nation", "country", "banner"], char: "🇲🇴", fitzpatrick_scale: !1, category: "flags" }, macedonia = { keywords: ["macedonia,", "flag", "nation", "country", "banner"], char: "🇲🇰", fitzpatrick_scale: !1, category: "flags" }, madagascar = { keywords: ["mg", "flag", "nation", "country", "banner"], char: "🇲🇬", fitzpatrick_scale: !1, category: "flags" }, malawi = { keywords: ["mw", "flag", "nation", "country", "banner"], char: "🇲🇼", fitzpatrick_scale: !1, category: "flags" }, malaysia = { keywords: ["my", "flag", "nation", "country", "banner"], char: "🇲🇾", fitzpatrick_scale: !1, category: "flags" }, maldives = { keywords: ["mv", "flag", "nation", "country", "banner"], char: "🇲🇻", fitzpatrick_scale: !1, category: "flags" }, mali = { keywords: ["ml", "flag", "nation", "country", "banner"], char: "🇲🇱", fitzpatrick_scale: !1, category: "flags" }, malta = { keywords: ["mt", "flag", "nation", "country", "banner"], char: "🇲🇹", fitzpatrick_scale: !1, category: "flags" }, marshall_islands = { keywords: ["marshall", "islands", "flag", "nation", "country", "banner"], char: "🇲🇭", fitzpatrick_scale: !1, category: "flags" }, martinique = { keywords: ["mq", "flag", "nation", "country", "banner"], char: "🇲🇶", fitzpatrick_scale: !1, category: "flags" }, mauritania = { keywords: ["mr", "flag", "nation", "country", "banner"], char: "🇲🇷", fitzpatrick_scale: !1, category: "flags" }, mauritius = { keywords: ["mu", "flag", "nation", "country", "banner"], char: "🇲🇺", fitzpatrick_scale: !1, category: "flags" }, mayotte = { keywords: ["yt", "flag", "nation", "country", "banner"], char: "🇾🇹", fitzpatrick_scale: !1, category: "flags" }, mexico = { keywords: ["mx", "flag", "nation", "country", "banner"], char: "🇲🇽", fitzpatrick_scale: !1, category: "flags" }, micronesia = { keywords: ["micronesia,", "federated", "states", "flag", "nation", "country", "banner"], char: "🇫🇲", fitzpatrick_scale: !1, category: "flags" }, moldova = { keywords: ["moldova,", "republic", "flag", "nation", "country", "banner"], char: "🇲🇩", fitzpatrick_scale: !1, category: "flags" }, monaco = { keywords: ["mc", "flag", "nation", "country", "banner"], char: "🇲🇨", fitzpatrick_scale: !1, category: "flags" }, mongolia = { keywords: ["mn", "flag", "nation", "country", "banner"], char: "🇲🇳", fitzpatrick_scale: !1, category: "flags" }, montenegro = { keywords: ["me", "flag", "nation", "country", "banner"], char: "🇲🇪", fitzpatrick_scale: !1, category: "flags" }, montserrat = { keywords: ["ms", "flag", "nation", "country", "banner"], char: "🇲🇸", fitzpatrick_scale: !1, category: "flags" }, morocco = { keywords: ["ma", "flag", "nation", "country", "banner"], char: "🇲🇦", fitzpatrick_scale: !1, category: "flags" }, mozambique = { keywords: ["mz", "flag", "nation", "country", "banner"], char: "🇲🇿", fitzpatrick_scale: !1, category: "flags" }, myanmar = { keywords: ["mm", "flag", "nation", "country", "banner"], char: "🇲🇲", fitzpatrick_scale: !1, category: "flags" }, namibia = { keywords: ["na", "flag", "nation", "country", "banner"], char: "🇳🇦", fitzpatrick_scale: !1, category: "flags" }, nauru = { keywords: ["nr", "flag", "nation", "country", "banner"], char: "🇳🇷", fitzpatrick_scale: !1, category: "flags" }, nepal = { keywords: ["np", "flag", "nation", "country", "banner"], char: "🇳🇵", fitzpatrick_scale: !1, category: "flags" }, netherlands = { keywords: ["nl", "flag", "nation", "country", "banner"], char: "🇳🇱", fitzpatrick_scale: !1, category: "flags" }, new_caledonia = { keywords: ["new", "caledonia", "flag", "nation", "country", "banner"], char: "🇳🇨", fitzpatrick_scale: !1, category: "flags" }, new_zealand = { keywords: ["new", "zealand", "flag", "nation", "country", "banner"], char: "🇳🇿", fitzpatrick_scale: !1, category: "flags" }, nicaragua = { keywords: ["ni", "flag", "nation", "country", "banner"], char: "🇳🇮", fitzpatrick_scale: !1, category: "flags" }, niger = { keywords: ["ne", "flag", "nation", "country", "banner"], char: "🇳🇪", fitzpatrick_scale: !1, category: "flags" }, nigeria = { keywords: ["flag", "nation", "country", "banner"], char: "🇳🇬", fitzpatrick_scale: !1, category: "flags" }, niue = { keywords: ["nu", "flag", "nation", "country", "banner"], char: "🇳🇺", fitzpatrick_scale: !1, category: "flags" }, norfolk_island = { keywords: ["norfolk", "island", "flag", "nation", "country", "banner"], char: "🇳🇫", fitzpatrick_scale: !1, category: "flags" }, northern_mariana_islands = { keywords: ["northern", "mariana", "islands", "flag", "nation", "country", "banner"], char: "🇲🇵", fitzpatrick_scale: !1, category: "flags" }, north_korea = { keywords: ["north", "korea", "nation", "flag", "country", "banner"], char: "🇰🇵", fitzpatrick_scale: !1, category: "flags" }, norway = { keywords: ["no", "flag", "nation", "country", "banner"], char: "🇳🇴", fitzpatrick_scale: !1, category: "flags" }, oman = { keywords: ["om_symbol", "flag", "nation", "country", "banner"], char: "🇴🇲", fitzpatrick_scale: !1, category: "flags" }, pakistan = { keywords: ["pk", "flag", "nation", "country", "banner"], char: "🇵🇰", fitzpatrick_scale: !1, category: "flags" }, palau = { keywords: ["pw", "flag", "nation", "country", "banner"], char: "🇵🇼", fitzpatrick_scale: !1, category: "flags" }, palestinian_territories = { keywords: ["palestine", "palestinian", "territories", "flag", "nation", "country", "banner"], char: "🇵🇸", fitzpatrick_scale: !1, category: "flags" }, panama = { keywords: ["pa", "flag", "nation", "country", "banner"], char: "🇵🇦", fitzpatrick_scale: !1, category: "flags" }, papua_new_guinea = { keywords: ["papua", "new", "guinea", "flag", "nation", "country", "banner"], char: "🇵🇬", fitzpatrick_scale: !1, category: "flags" }, paraguay = { keywords: ["py", "flag", "nation", "country", "banner"], char: "🇵🇾", fitzpatrick_scale: !1, category: "flags" }, peru = { keywords: ["pe", "flag", "nation", "country", "banner"], char: "🇵🇪", fitzpatrick_scale: !1, category: "flags" }, philippines = { keywords: ["ph", "flag", "nation", "country", "banner"], char: "🇵🇭", fitzpatrick_scale: !1, category: "flags" }, pitcairn_islands = { keywords: ["pitcairn", "flag", "nation", "country", "banner"], char: "🇵🇳", fitzpatrick_scale: !1, category: "flags" }, poland = { keywords: ["pl", "flag", "nation", "country", "banner"], char: "🇵🇱", fitzpatrick_scale: !1, category: "flags" }, portugal = { keywords: ["pt", "flag", "nation", "country", "banner"], char: "🇵🇹", fitzpatrick_scale: !1, category: "flags" }, puerto_rico = { keywords: ["puerto", "rico", "flag", "nation", "country", "banner"], char: "🇵🇷", fitzpatrick_scale: !1, category: "flags" }, qatar = { keywords: ["qa", "flag", "nation", "country", "banner"], char: "🇶🇦", fitzpatrick_scale: !1, category: "flags" }, reunion = { keywords: ["réunion", "flag", "nation", "country", "banner"], char: "🇷🇪", fitzpatrick_scale: !1, category: "flags" }, romania = { keywords: ["ro", "flag", "nation", "country", "banner"], char: "🇷🇴", fitzpatrick_scale: !1, category: "flags" }, ru = { keywords: ["russian", "federation", "flag", "nation", "country", "banner"], char: "🇷🇺", fitzpatrick_scale: !1, category: "flags" }, rwanda = { keywords: ["rw", "flag", "nation", "country", "banner"], char: "🇷🇼", fitzpatrick_scale: !1, category: "flags" }, st_barthelemy = { keywords: ["saint", "barthélemy", "flag", "nation", "country", "banner"], char: "🇧🇱", fitzpatrick_scale: !1, category: "flags" }, st_helena = { keywords: ["saint", "helena", "ascension", "tristan", "cunha", "flag", "nation", "country", "banner"], char: "🇸🇭", fitzpatrick_scale: !1, category: "flags" }, st_kitts_nevis = { keywords: ["saint", "kitts", "nevis", "flag", "nation", "country", "banner"], char: "🇰🇳", fitzpatrick_scale: !1, category: "flags" }, st_lucia = { keywords: ["saint", "lucia", "flag", "nation", "country", "banner"], char: "🇱🇨", fitzpatrick_scale: !1, category: "flags" }, st_pierre_miquelon = { keywords: ["saint", "pierre", "miquelon", "flag", "nation", "country", "banner"], char: "🇵🇲", fitzpatrick_scale: !1, category: "flags" }, st_vincent_grenadines = { keywords: ["saint", "vincent", "grenadines", "flag", "nation", "country", "banner"], char: "🇻🇨", fitzpatrick_scale: !1, category: "flags" }, samoa = { keywords: ["ws", "flag", "nation", "country", "banner"], char: "🇼🇸", fitzpatrick_scale: !1, category: "flags" }, san_marino = { keywords: ["san", "marino", "flag", "nation", "country", "banner"], char: "🇸🇲", fitzpatrick_scale: !1, category: "flags" }, sao_tome_principe = { keywords: ["sao", "tome", "principe", "flag", "nation", "country", "banner"], char: "🇸🇹", fitzpatrick_scale: !1, category: "flags" }, saudi_arabia = { keywords: ["flag", "nation", "country", "banner"], char: "🇸🇦", fitzpatrick_scale: !1, category: "flags" }, senegal = { keywords: ["sn", "flag", "nation", "country", "banner"], char: "🇸🇳", fitzpatrick_scale: !1, category: "flags" }, serbia = { keywords: ["rs", "flag", "nation", "country", "banner"], char: "🇷🇸", fitzpatrick_scale: !1, category: "flags" }, seychelles = { keywords: ["sc", "flag", "nation", "country", "banner"], char: "🇸🇨", fitzpatrick_scale: !1, category: "flags" }, sierra_leone = { keywords: ["sierra", "leone", "flag", "nation", "country", "banner"], char: "🇸🇱", fitzpatrick_scale: !1, category: "flags" }, singapore = { keywords: ["sg", "flag", "nation", "country", "banner"], char: "🇸🇬", fitzpatrick_scale: !1, category: "flags" }, sint_maarten = { keywords: ["sint", "maarten", "dutch", "flag", "nation", "country", "banner"], char: "🇸🇽", fitzpatrick_scale: !1, category: "flags" }, slovakia = { keywords: ["sk", "flag", "nation", "country", "banner"], char: "🇸🇰", fitzpatrick_scale: !1, category: "flags" }, slovenia = { keywords: ["si", "flag", "nation", "country", "banner"], char: "🇸🇮", fitzpatrick_scale: !1, category: "flags" }, solomon_islands = { keywords: ["solomon", "islands", "flag", "nation", "country", "banner"], char: "🇸🇧", fitzpatrick_scale: !1, category: "flags" }, somalia = { keywords: ["so", "flag", "nation", "country", "banner"], char: "🇸🇴", fitzpatrick_scale: !1, category: "flags" }, south_africa = { keywords: ["south", "africa", "flag", "nation", "country", "banner"], char: "🇿🇦", fitzpatrick_scale: !1, category: "flags" }, south_georgia_south_sandwich_islands = { keywords: ["south", "georgia", "sandwich", "islands", "flag", "nation", "country", "banner"], char: "🇬🇸", fitzpatrick_scale: !1, category: "flags" }, kr = { keywords: ["south", "korea", "nation", "flag", "country", "banner"], char: "🇰🇷", fitzpatrick_scale: !1, category: "flags" }, south_sudan = { keywords: ["south", "sd", "flag", "nation", "country", "banner"], char: "🇸🇸", fitzpatrick_scale: !1, category: "flags" }, es = { keywords: ["spain", "flag", "nation", "country", "banner"], char: "🇪🇸", fitzpatrick_scale: !1, category: "flags" }, sri_lanka = { keywords: ["sri", "lanka", "flag", "nation", "country", "banner"], char: "🇱🇰", fitzpatrick_scale: !1, category: "flags" }, sudan = { keywords: ["sd", "flag", "nation", "country", "banner"], char: "🇸🇩", fitzpatrick_scale: !1, category: "flags" }, suriname = { keywords: ["sr", "flag", "nation", "country", "banner"], char: "🇸🇷", fitzpatrick_scale: !1, category: "flags" }, swaziland = { keywords: ["sz", "flag", "nation", "country", "banner"], char: "🇸🇿", fitzpatrick_scale: !1, category: "flags" }, sweden = { keywords: ["se", "flag", "nation", "country", "banner"], char: "🇸🇪", fitzpatrick_scale: !1, category: "flags" }, switzerland = { keywords: ["ch", "flag", "nation", "country", "banner"], char: "🇨🇭", fitzpatrick_scale: !1, category: "flags" }, syria = { keywords: ["syrian", "arab", "republic", "flag", "nation", "country", "banner"], char: "🇸🇾", fitzpatrick_scale: !1, category: "flags" }, taiwan = { keywords: ["tw", "flag", "nation", "country", "banner"], char: "🇹🇼", fitzpatrick_scale: !1, category: "flags" }, tajikistan = { keywords: ["tj", "flag", "nation", "country", "banner"], char: "🇹🇯", fitzpatrick_scale: !1, category: "flags" }, tanzania = { keywords: ["tanzania,", "united", "republic", "flag", "nation", "country", "banner"], char: "🇹🇿", fitzpatrick_scale: !1, category: "flags" }, thailand = { keywords: ["th", "flag", "nation", "country", "banner"], char: "🇹🇭", fitzpatrick_scale: !1, category: "flags" }, timor_leste = { keywords: ["timor", "leste", "flag", "nation", "country", "banner"], char: "🇹🇱", fitzpatrick_scale: !1, category: "flags" }, togo = { keywords: ["tg", "flag", "nation", "country", "banner"], char: "🇹🇬", fitzpatrick_scale: !1, category: "flags" }, tokelau = { keywords: ["tk", "flag", "nation", "country", "banner"], char: "🇹🇰", fitzpatrick_scale: !1, category: "flags" }, tonga = { keywords: ["to", "flag", "nation", "country", "banner"], char: "🇹🇴", fitzpatrick_scale: !1, category: "flags" }, trinidad_tobago = { keywords: ["trinidad", "tobago", "flag", "nation", "country", "banner"], char: "🇹🇹", fitzpatrick_scale: !1, category: "flags" }, tunisia = { keywords: ["tn", "flag", "nation", "country", "banner"], char: "🇹🇳", fitzpatrick_scale: !1, category: "flags" }, tr$1 = { keywords: ["turkey", "flag", "nation", "country", "banner"], char: "🇹🇷", fitzpatrick_scale: !1, category: "flags" }, turkmenistan = { keywords: ["flag", "nation", "country", "banner"], char: "🇹🇲", fitzpatrick_scale: !1, category: "flags" }, turks_caicos_islands = { keywords: ["turks", "caicos", "islands", "flag", "nation", "country", "banner"], char: "🇹🇨", fitzpatrick_scale: !1, category: "flags" }, tuvalu = { keywords: ["flag", "nation", "country", "banner"], char: "🇹🇻", fitzpatrick_scale: !1, category: "flags" }, uganda = { keywords: ["ug", "flag", "nation", "country", "banner"], char: "🇺🇬", fitzpatrick_scale: !1, category: "flags" }, ukraine = { keywords: ["ua", "flag", "nation", "country", "banner"], char: "🇺🇦", fitzpatrick_scale: !1, category: "flags" }, united_arab_emirates = { keywords: ["united", "arab", "emirates", "flag", "nation", "country", "banner"], char: "🇦🇪", fitzpatrick_scale: !1, category: "flags" }, uk = { keywords: ["united", "kingdom", "great", "britain", "northern", "ireland", "flag", "nation", "country", "banner", "british", "UK", "english", "england", "union jack"], char: "🇬🇧", fitzpatrick_scale: !1, category: "flags" }, england = { keywords: ["flag", "english"], char: "🏴󠁧󠁢󠁥󠁮󠁧󠁿", fitzpatrick_scale: !1, category: "flags" }, scotland = { keywords: ["flag", "scottish"], char: "🏴󠁧󠁢󠁳󠁣󠁴󠁿", fitzpatrick_scale: !1, category: "flags" }, wales = { keywords: ["flag", "welsh"], char: "🏴󠁧󠁢󠁷󠁬󠁳󠁿", fitzpatrick_scale: !1, category: "flags" }, us = { keywords: ["united", "states", "america", "flag", "nation", "country", "banner"], char: "🇺🇸", fitzpatrick_scale: !1, category: "flags" }, us_virgin_islands = { keywords: ["virgin", "islands", "us", "flag", "nation", "country", "banner"], char: "🇻🇮", fitzpatrick_scale: !1, category: "flags" }, uruguay = { keywords: ["uy", "flag", "nation", "country", "banner"], char: "🇺🇾", fitzpatrick_scale: !1, category: "flags" }, uzbekistan = { keywords: ["uz", "flag", "nation", "country", "banner"], char: "🇺🇿", fitzpatrick_scale: !1, category: "flags" }, vanuatu = { keywords: ["vu", "flag", "nation", "country", "banner"], char: "🇻🇺", fitzpatrick_scale: !1, category: "flags" }, vatican_city = { keywords: ["vatican", "city", "flag", "nation", "country", "banner"], char: "🇻🇦", fitzpatrick_scale: !1, category: "flags" }, venezuela = { keywords: ["ve", "bolivarian", "republic", "flag", "nation", "country", "banner"], char: "🇻🇪", fitzpatrick_scale: !1, category: "flags" }, vietnam = { keywords: ["viet", "nam", "flag", "nation", "country", "banner"], char: "🇻🇳", fitzpatrick_scale: !1, category: "flags" }, wallis_futuna = { keywords: ["wallis", "futuna", "flag", "nation", "country", "banner"], char: "🇼🇫", fitzpatrick_scale: !1, category: "flags" }, western_sahara = { keywords: ["western", "sahara", "flag", "nation", "country", "banner"], char: "🇪🇭", fitzpatrick_scale: !1, category: "flags" }, yemen = { keywords: ["ye", "flag", "nation", "country", "banner"], char: "🇾🇪", fitzpatrick_scale: !1, category: "flags" }, zambia = { keywords: ["zm", "flag", "nation", "country", "banner"], char: "🇿🇲", fitzpatrick_scale: !1, category: "flags" }, zimbabwe = { keywords: ["zw", "flag", "nation", "country", "banner"], char: "🇿🇼", fitzpatrick_scale: !1, category: "flags" }, united_nations = { keywords: ["un", "flag", "banner"], char: "🇺🇳", fitzpatrick_scale: !1, category: "flags" }, pirate_flag = { keywords: ["skull", "crossbones", "flag", "banner"], char: "🏴‍☠️", fitzpatrick_scale: !1, category: "flags" }, require$$0$3 = {
  100: { keywords: ["score", "perfect", "numbers", "century", "exam", "quiz", "test", "pass", "hundred"], char: "💯", fitzpatrick_scale: !1, category: "symbols" },
  1234: { keywords: ["numbers", "blue-square"], char: "🔢", fitzpatrick_scale: !1, category: "symbols" },
  grinning,
  grimacing,
  grin,
  joy,
  rofl,
  partying,
  smiley,
  smile,
  sweat_smile,
  laughing,
  innocent,
  wink,
  blush,
  slightly_smiling_face,
  upside_down_face,
  relaxed,
  yum,
  relieved,
  heart_eyes,
  smiling_face_with_three_hearts,
  kissing_heart,
  kissing,
  kissing_smiling_eyes,
  kissing_closed_eyes,
  stuck_out_tongue_winking_eye,
  zany,
  raised_eyebrow,
  monocle,
  stuck_out_tongue_closed_eyes,
  stuck_out_tongue,
  money_mouth_face,
  nerd_face,
  sunglasses,
  star_struck,
  clown_face,
  cowboy_hat_face,
  hugs,
  smirk,
  no_mouth,
  neutral_face,
  expressionless,
  unamused,
  roll_eyes,
  thinking,
  lying_face,
  hand_over_mouth,
  shushing,
  symbols_over_mouth,
  exploding_head,
  flushed,
  disappointed,
  worried,
  angry,
  rage,
  pensive,
  confused,
  slightly_frowning_face,
  frowning_face,
  persevere,
  confounded,
  tired_face,
  weary,
  pleading,
  triumph,
  open_mouth,
  scream,
  fearful,
  cold_sweat,
  hushed,
  frowning,
  anguished,
  cry,
  disappointed_relieved,
  drooling_face,
  sleepy,
  sweat,
  hot,
  cold,
  sob,
  dizzy_face,
  astonished,
  zipper_mouth_face,
  nauseated_face,
  sneezing_face,
  vomiting,
  mask,
  face_with_thermometer,
  face_with_head_bandage,
  woozy,
  sleeping,
  zzz,
  poop,
  smiling_imp,
  imp,
  japanese_ogre,
  japanese_goblin,
  skull,
  ghost,
  alien,
  robot,
  smiley_cat,
  smile_cat,
  joy_cat,
  heart_eyes_cat,
  smirk_cat,
  kissing_cat,
  scream_cat,
  crying_cat_face,
  pouting_cat,
  palms_up,
  raised_hands,
  clap,
  wave,
  call_me_hand,
  "+1": { keywords: ["thumbsup", "yes", "awesome", "good", "agree", "accept", "cool", "hand", "like"], char: "👍", fitzpatrick_scale: !0, category: "people" },
  "-1": { keywords: ["thumbsdown", "no", "dislike", "hand"], char: "👎", fitzpatrick_scale: !0, category: "people" },
  facepunch,
  fist,
  fist_left,
  fist_right,
  v: v$1,
  ok_hand,
  raised_hand,
  raised_back_of_hand,
  open_hands,
  muscle,
  pray,
  foot,
  leg,
  handshake,
  point_up,
  point_up_2,
  point_down,
  point_left,
  point_right,
  fu,
  raised_hand_with_fingers_splayed,
  love_you,
  metal,
  crossed_fingers,
  vulcan_salute,
  writing_hand,
  selfie,
  nail_care,
  lips,
  tooth,
  tongue,
  ear,
  nose,
  eye,
  eyes,
  brain,
  bust_in_silhouette,
  busts_in_silhouette,
  speaking_head,
  baby,
  child,
  boy,
  girl,
  adult,
  man,
  woman,
  blonde_woman,
  blonde_man,
  bearded_person,
  older_adult,
  older_man,
  older_woman,
  man_with_gua_pi_mao,
  woman_with_headscarf,
  woman_with_turban,
  man_with_turban,
  policewoman,
  policeman,
  construction_worker_woman,
  construction_worker_man,
  guardswoman,
  guardsman,
  female_detective,
  male_detective,
  woman_health_worker,
  man_health_worker,
  woman_farmer,
  man_farmer,
  woman_cook,
  man_cook,
  woman_student,
  man_student,
  woman_singer,
  man_singer,
  woman_teacher,
  man_teacher,
  woman_factory_worker,
  man_factory_worker,
  woman_technologist,
  man_technologist,
  woman_office_worker,
  man_office_worker,
  woman_mechanic,
  man_mechanic,
  woman_scientist,
  man_scientist,
  woman_artist,
  man_artist,
  woman_firefighter,
  man_firefighter,
  woman_pilot,
  man_pilot,
  woman_astronaut,
  man_astronaut,
  woman_judge,
  man_judge,
  woman_superhero,
  man_superhero,
  woman_supervillain,
  man_supervillain,
  mrs_claus,
  santa,
  sorceress,
  wizard,
  woman_elf,
  man_elf,
  woman_vampire,
  man_vampire,
  woman_zombie,
  man_zombie,
  woman_genie,
  man_genie,
  mermaid,
  merman,
  woman_fairy,
  man_fairy,
  angel,
  pregnant_woman,
  breastfeeding,
  princess,
  prince,
  bride_with_veil,
  man_in_tuxedo,
  running_woman,
  running_man,
  walking_woman,
  walking_man,
  dancer,
  man_dancing,
  dancing_women,
  dancing_men,
  couple,
  two_men_holding_hands,
  two_women_holding_hands,
  bowing_woman,
  bowing_man,
  man_facepalming,
  woman_facepalming,
  woman_shrugging,
  man_shrugging,
  tipping_hand_woman,
  tipping_hand_man,
  no_good_woman,
  no_good_man,
  ok_woman,
  ok_man,
  raising_hand_woman,
  raising_hand_man,
  pouting_woman,
  pouting_man,
  frowning_woman,
  frowning_man,
  haircut_woman,
  haircut_man,
  massage_woman,
  massage_man,
  woman_in_steamy_room,
  man_in_steamy_room,
  couple_with_heart_woman_man,
  couple_with_heart_woman_woman,
  couple_with_heart_man_man,
  couplekiss_man_woman,
  couplekiss_woman_woman,
  couplekiss_man_man,
  family_man_woman_boy,
  family_man_woman_girl,
  family_man_woman_girl_boy,
  family_man_woman_boy_boy,
  family_man_woman_girl_girl,
  family_woman_woman_boy,
  family_woman_woman_girl,
  family_woman_woman_girl_boy,
  family_woman_woman_boy_boy,
  family_woman_woman_girl_girl,
  family_man_man_boy,
  family_man_man_girl,
  family_man_man_girl_boy,
  family_man_man_boy_boy,
  family_man_man_girl_girl,
  family_woman_boy,
  family_woman_girl,
  family_woman_girl_boy,
  family_woman_boy_boy,
  family_woman_girl_girl,
  family_man_boy,
  family_man_girl,
  family_man_girl_boy,
  family_man_boy_boy,
  family_man_girl_girl,
  yarn,
  thread,
  coat,
  labcoat,
  womans_clothes,
  tshirt,
  jeans,
  necktie,
  dress,
  bikini,
  kimono,
  lipstick,
  kiss,
  footprints,
  flat_shoe,
  high_heel,
  sandal,
  boot,
  mans_shoe,
  athletic_shoe,
  hiking_boot,
  socks,
  gloves,
  scarf,
  womans_hat,
  tophat,
  billed_hat,
  rescue_worker_helmet,
  mortar_board,
  crown,
  school_satchel,
  luggage,
  pouch,
  purse,
  handbag,
  briefcase,
  eyeglasses,
  dark_sunglasses,
  goggles,
  ring,
  closed_umbrella,
  dog,
  cat,
  mouse,
  hamster,
  rabbit,
  fox_face,
  bear,
  panda_face,
  koala,
  tiger,
  lion,
  cow,
  pig,
  pig_nose,
  frog,
  squid,
  octopus,
  shrimp,
  monkey_face,
  gorilla,
  see_no_evil,
  hear_no_evil,
  speak_no_evil,
  monkey,
  chicken,
  penguin,
  bird,
  baby_chick,
  hatching_chick,
  hatched_chick,
  duck,
  eagle,
  owl,
  bat,
  wolf,
  boar,
  horse,
  unicorn,
  honeybee,
  bug,
  butterfly,
  snail,
  beetle,
  ant,
  grasshopper,
  spider,
  scorpion,
  crab,
  snake,
  lizard,
  "t-rex": { keywords: ["animal", "nature", "dinosaur", "tyrannosaurus", "extinct"], char: "🦖", fitzpatrick_scale: !1, category: "animals_and_nature" },
  sauropod,
  turtle,
  tropical_fish,
  fish,
  blowfish,
  dolphin,
  shark,
  whale,
  whale2,
  crocodile,
  leopard,
  zebra,
  tiger2,
  water_buffalo,
  ox,
  cow2,
  deer,
  dromedary_camel,
  camel,
  giraffe,
  elephant,
  rhinoceros,
  goat,
  ram,
  sheep,
  racehorse,
  pig2,
  rat,
  mouse2,
  rooster,
  turkey,
  dove,
  dog2,
  poodle,
  cat2,
  rabbit2,
  chipmunk,
  hedgehog,
  raccoon,
  llama,
  hippopotamus,
  kangaroo,
  badger,
  swan,
  peacock,
  parrot,
  lobster,
  mosquito,
  paw_prints,
  dragon,
  dragon_face,
  cactus,
  christmas_tree,
  evergreen_tree,
  deciduous_tree,
  palm_tree,
  seedling,
  herb,
  shamrock,
  four_leaf_clover,
  bamboo,
  tanabata_tree,
  leaves,
  fallen_leaf,
  maple_leaf,
  ear_of_rice,
  hibiscus,
  sunflower,
  rose,
  wilted_flower,
  tulip,
  blossom,
  cherry_blossom,
  bouquet,
  mushroom,
  chestnut,
  jack_o_lantern,
  shell,
  spider_web,
  earth_americas,
  earth_africa,
  earth_asia,
  full_moon,
  waning_gibbous_moon,
  last_quarter_moon,
  waning_crescent_moon,
  new_moon,
  waxing_crescent_moon,
  first_quarter_moon,
  waxing_gibbous_moon,
  new_moon_with_face,
  full_moon_with_face,
  first_quarter_moon_with_face,
  last_quarter_moon_with_face,
  sun_with_face,
  crescent_moon,
  star,
  star2,
  dizzy,
  sparkles,
  comet,
  sunny,
  sun_behind_small_cloud,
  partly_sunny,
  sun_behind_large_cloud,
  sun_behind_rain_cloud,
  cloud: cloud$1,
  cloud_with_rain,
  cloud_with_lightning_and_rain,
  cloud_with_lightning,
  zap,
  fire,
  boom,
  snowflake,
  cloud_with_snow,
  snowman,
  snowman_with_snow,
  wind_face,
  dash,
  tornado,
  fog,
  open_umbrella,
  umbrella,
  droplet,
  sweat_drops,
  ocean,
  green_apple,
  apple,
  pear,
  tangerine,
  lemon,
  banana,
  watermelon,
  grapes,
  strawberry,
  melon,
  cherries,
  peach,
  pineapple,
  coconut,
  kiwi_fruit,
  mango,
  avocado,
  broccoli,
  tomato,
  eggplant,
  cucumber,
  carrot,
  hot_pepper,
  potato,
  corn,
  leafy_greens,
  sweet_potato,
  peanuts,
  honey_pot,
  croissant,
  bread,
  baguette_bread,
  bagel,
  pretzel,
  cheese,
  egg,
  bacon,
  steak,
  pancakes,
  poultry_leg,
  meat_on_bone,
  bone,
  fried_shrimp,
  fried_egg,
  hamburger,
  fries,
  stuffed_flatbread,
  hotdog,
  pizza,
  sandwich,
  canned_food,
  spaghetti,
  taco,
  burrito,
  green_salad,
  shallow_pan_of_food,
  ramen,
  stew,
  fish_cake,
  fortune_cookie,
  sushi,
  bento,
  curry,
  rice_ball,
  rice,
  rice_cracker,
  oden,
  dango,
  shaved_ice,
  ice_cream,
  icecream,
  pie,
  cake,
  cupcake,
  moon_cake,
  birthday,
  custard,
  candy,
  lollipop,
  chocolate_bar,
  popcorn,
  dumpling,
  doughnut,
  cookie,
  milk_glass,
  beer,
  beers,
  clinking_glasses,
  wine_glass,
  tumbler_glass,
  cocktail,
  tropical_drink,
  champagne,
  sake,
  tea,
  cup_with_straw,
  coffee,
  baby_bottle,
  salt,
  spoon,
  fork_and_knife,
  plate_with_cutlery,
  bowl_with_spoon,
  takeout_box,
  chopsticks,
  soccer,
  basketball,
  football,
  baseball,
  softball,
  tennis,
  volleyball,
  rugby_football,
  flying_disc,
  "8ball": { keywords: ["pool", "hobby", "game", "luck", "magic"], char: "🎱", fitzpatrick_scale: !1, category: "activity" },
  golf,
  golfing_woman,
  golfing_man,
  ping_pong,
  badminton,
  goal_net,
  ice_hockey,
  field_hockey,
  lacrosse,
  cricket,
  ski,
  skier,
  snowboarder,
  person_fencing,
  women_wrestling,
  men_wrestling,
  woman_cartwheeling,
  man_cartwheeling,
  woman_playing_handball,
  man_playing_handball,
  ice_skate,
  curling_stone,
  skateboard,
  sled,
  bow_and_arrow,
  fishing_pole_and_fish,
  boxing_glove,
  martial_arts_uniform,
  rowing_woman,
  rowing_man,
  climbing_woman,
  climbing_man,
  swimming_woman,
  swimming_man,
  woman_playing_water_polo,
  man_playing_water_polo,
  woman_in_lotus_position,
  man_in_lotus_position,
  surfing_woman,
  surfing_man,
  bath,
  basketball_woman,
  basketball_man,
  weight_lifting_woman,
  weight_lifting_man,
  biking_woman,
  biking_man,
  mountain_biking_woman,
  mountain_biking_man,
  horse_racing,
  business_suit_levitating,
  trophy,
  running_shirt_with_sash,
  medal_sports,
  medal_military,
  "1st_place_medal": { keywords: ["award", "winning", "first"], char: "🥇", fitzpatrick_scale: !1, category: "activity" },
  "2nd_place_medal": { keywords: ["award", "second"], char: "🥈", fitzpatrick_scale: !1, category: "activity" },
  "3rd_place_medal": { keywords: ["award", "third"], char: "🥉", fitzpatrick_scale: !1, category: "activity" },
  reminder_ribbon,
  rosette,
  ticket,
  tickets,
  performing_arts,
  art,
  circus_tent,
  woman_juggling,
  man_juggling,
  microphone,
  headphones,
  musical_score,
  musical_keyboard,
  drum,
  saxophone,
  trumpet,
  guitar,
  violin,
  clapper,
  video_game,
  space_invader,
  dart,
  game_die,
  chess_pawn,
  slot_machine,
  jigsaw,
  bowling,
  red_car,
  taxi,
  blue_car,
  bus,
  trolleybus,
  racing_car,
  police_car,
  ambulance,
  fire_engine,
  minibus,
  truck,
  articulated_lorry,
  tractor,
  kick_scooter,
  motorcycle,
  bike,
  motor_scooter,
  rotating_light,
  oncoming_police_car,
  oncoming_bus,
  oncoming_automobile,
  oncoming_taxi,
  aerial_tramway,
  mountain_cableway,
  suspension_railway,
  railway_car,
  train,
  monorail,
  bullettrain_side,
  bullettrain_front,
  light_rail,
  mountain_railway,
  steam_locomotive,
  train2,
  metro,
  tram,
  station,
  flying_saucer,
  helicopter,
  small_airplane,
  airplane,
  flight_departure,
  flight_arrival,
  sailboat,
  motor_boat,
  speedboat,
  ferry,
  passenger_ship,
  rocket,
  artificial_satellite,
  seat,
  canoe,
  anchor,
  construction,
  fuelpump,
  busstop,
  vertical_traffic_light,
  traffic_light,
  checkered_flag,
  ship,
  ferris_wheel,
  roller_coaster,
  carousel_horse,
  building_construction,
  foggy,
  tokyo_tower,
  factory: factory$1,
  fountain,
  rice_scene,
  mountain,
  mountain_snow,
  mount_fuji,
  volcano,
  japan,
  camping,
  tent,
  national_park,
  motorway,
  railway_track,
  sunrise,
  sunrise_over_mountains,
  desert,
  beach_umbrella,
  desert_island,
  city_sunrise,
  city_sunset,
  cityscape,
  night_with_stars,
  bridge_at_night,
  milky_way,
  stars,
  sparkler,
  fireworks,
  rainbow,
  houses,
  european_castle,
  japanese_castle,
  stadium,
  statue_of_liberty,
  house,
  house_with_garden,
  derelict_house,
  office,
  department_store,
  post_office,
  european_post_office,
  hospital,
  bank,
  hotel,
  convenience_store,
  school,
  love_hotel,
  wedding,
  classical_building,
  church,
  mosque,
  synagogue,
  kaaba,
  shinto_shrine,
  watch,
  iphone,
  calling,
  computer,
  keyboard,
  desktop_computer,
  printer,
  computer_mouse,
  trackball,
  joystick,
  clamp: clamp$2,
  minidisc,
  floppy_disk,
  cd,
  dvd,
  vhs,
  camera,
  camera_flash,
  video_camera,
  movie_camera,
  film_projector,
  film_strip,
  telephone_receiver,
  phone,
  pager,
  fax,
  tv,
  radio: radio$1,
  studio_microphone,
  level_slider,
  control_knobs,
  compass,
  stopwatch,
  timer_clock,
  alarm_clock,
  mantelpiece_clock,
  hourglass_flowing_sand,
  hourglass,
  satellite,
  battery,
  electric_plug,
  bulb,
  flashlight,
  candle,
  fire_extinguisher,
  wastebasket,
  oil_drum,
  money_with_wings,
  dollar,
  yen: yen$1,
  euro,
  pound: pound$1,
  moneybag,
  credit_card,
  gem,
  balance_scale,
  toolbox,
  wrench,
  hammer,
  hammer_and_pick,
  hammer_and_wrench,
  pick: pick$4,
  nut_and_bolt,
  gear,
  brick,
  chains,
  magnet,
  gun,
  bomb,
  firecracker,
  hocho,
  dagger,
  crossed_swords,
  shield,
  smoking,
  skull_and_crossbones,
  coffin,
  funeral_urn,
  amphora,
  crystal_ball,
  prayer_beads,
  nazar_amulet,
  barber,
  alembic,
  telescope,
  microscope,
  hole,
  pill,
  syringe,
  dna,
  microbe,
  petri_dish,
  test_tube,
  thermometer,
  broom,
  basket,
  toilet_paper,
  label: label$1,
  bookmark,
  toilet,
  shower,
  bathtub,
  soap,
  sponge,
  lotion_bottle,
  key: key$2,
  old_key,
  couch_and_lamp,
  sleeping_bed,
  bed,
  door,
  bellhop_bell,
  teddy_bear,
  framed_picture,
  world_map,
  parasol_on_ground,
  moyai,
  shopping,
  shopping_cart,
  balloon,
  flags,
  ribbon,
  gift,
  confetti_ball,
  tada,
  dolls,
  wind_chime,
  crossed_flags,
  izakaya_lantern,
  red_envelope,
  email,
  envelope_with_arrow,
  incoming_envelope,
  "e-mail": { keywords: ["communication", "inbox"], char: "📧", fitzpatrick_scale: !1, category: "objects" },
  love_letter,
  postbox,
  mailbox_closed,
  mailbox,
  mailbox_with_mail,
  mailbox_with_no_mail,
  package: { keywords: ["mail", "gift", "cardboard", "box", "moving"], char: "📦", fitzpatrick_scale: !1, category: "objects" },
  postal_horn,
  inbox_tray,
  outbox_tray,
  scroll,
  page_with_curl,
  bookmark_tabs,
  receipt,
  bar_chart,
  chart_with_upwards_trend,
  chart_with_downwards_trend,
  page_facing_up,
  date: date$2,
  calendar: calendar$2,
  spiral_calendar,
  card_index,
  card_file_box,
  ballot_box,
  file_cabinet,
  clipboard,
  spiral_notepad,
  file_folder,
  open_file_folder,
  card_index_dividers,
  newspaper_roll,
  newspaper,
  notebook,
  closed_book,
  green_book,
  blue_book,
  orange_book,
  notebook_with_decorative_cover,
  ledger,
  books,
  open_book,
  safety_pin,
  link: link$2,
  paperclip,
  paperclips,
  scissors,
  triangular_ruler,
  straight_ruler,
  abacus,
  pushpin,
  round_pushpin,
  triangular_flag_on_post,
  white_flag,
  black_flag,
  rainbow_flag,
  closed_lock_with_key,
  lock,
  unlock,
  lock_with_ink_pen,
  pen,
  fountain_pen,
  black_nib,
  memo,
  pencil2,
  crayon,
  paintbrush,
  mag,
  mag_right,
  heart,
  orange_heart,
  yellow_heart,
  green_heart,
  blue_heart,
  purple_heart,
  black_heart,
  broken_heart,
  heavy_heart_exclamation,
  two_hearts,
  revolving_hearts,
  heartbeat,
  heartpulse,
  sparkling_heart,
  cupid,
  gift_heart,
  heart_decoration,
  peace_symbol,
  latin_cross,
  star_and_crescent,
  om,
  wheel_of_dharma,
  star_of_david,
  six_pointed_star,
  menorah,
  yin_yang,
  orthodox_cross,
  place_of_worship,
  ophiuchus,
  aries,
  taurus,
  gemini,
  cancer,
  leo,
  virgo,
  libra,
  scorpius,
  sagittarius,
  capricorn,
  aquarius,
  pisces,
  id: id$1,
  atom_symbol,
  u7a7a,
  u5272,
  radioactive,
  biohazard,
  mobile_phone_off,
  vibration_mode,
  u6709,
  u7121,
  u7533,
  u55b6,
  u6708,
  eight_pointed_black_star,
  vs,
  accept,
  white_flower,
  ideograph_advantage,
  secret,
  congratulations,
  u5408,
  u6e80,
  u7981,
  a: a$3,
  b: b$2,
  ab,
  cl,
  o2,
  sos,
  no_entry,
  name_badge,
  no_entry_sign,
  x: x$5,
  o,
  stop_sign,
  anger,
  hotsprings,
  no_pedestrians,
  do_not_litter,
  no_bicycles,
  "non-potable_water": { keywords: ["drink", "faucet", "tap", "circle"], char: "🚱", fitzpatrick_scale: !1, category: "symbols" },
  underage,
  no_mobile_phones,
  exclamation,
  grey_exclamation,
  question,
  grey_question,
  bangbang,
  interrobang,
  low_brightness,
  high_brightness,
  trident,
  fleur_de_lis,
  part_alternation_mark,
  warning: warning$1,
  children_crossing,
  beginner,
  recycle,
  u6307,
  chart,
  sparkle,
  eight_spoked_asterisk,
  negative_squared_cross_mark,
  white_check_mark,
  diamond_shape_with_a_dot_inside,
  cyclone,
  loop: loop$1,
  globe_with_meridians,
  m: m$4,
  atm,
  sa: sa$1,
  passport_control,
  customs,
  baggage_claim,
  left_luggage,
  wheelchair,
  no_smoking,
  wc,
  parking,
  potable_water,
  mens,
  womens,
  baby_symbol,
  restroom,
  put_litter_in_its_place,
  cinema,
  signal_strength,
  koko,
  ng,
  ok,
  up,
  cool,
  new: { keywords: ["blue-square", "words", "start"], char: "🆕", fitzpatrick_scale: !1, category: "symbols" },
  free,
  zero: zero$5,
  one: one$3,
  two,
  three,
  four,
  five,
  six,
  seven,
  eight,
  nine,
  keycap_ten,
  asterisk,
  eject_button,
  arrow_forward,
  pause_button,
  next_track_button,
  stop_button,
  record_button,
  play_or_pause_button,
  previous_track_button,
  fast_forward,
  rewind,
  twisted_rightwards_arrows,
  repeat: repeat$1,
  repeat_one,
  arrow_backward,
  arrow_up_small,
  arrow_down_small,
  arrow_double_up,
  arrow_double_down,
  arrow_right,
  arrow_left,
  arrow_up,
  arrow_down,
  arrow_upper_right,
  arrow_lower_right,
  arrow_lower_left,
  arrow_upper_left,
  arrow_up_down,
  left_right_arrow,
  arrows_counterclockwise,
  arrow_right_hook,
  leftwards_arrow_with_hook,
  arrow_heading_up,
  arrow_heading_down,
  hash: hash$1,
  information_source,
  abc,
  abcd,
  capital_abcd,
  symbols: symbols$3,
  musical_note,
  notes,
  wavy_dash,
  curly_loop,
  heavy_check_mark,
  arrows_clockwise,
  heavy_plus_sign,
  heavy_minus_sign,
  heavy_division_sign,
  heavy_multiplication_x,
  infinity,
  heavy_dollar_sign,
  currency_exchange,
  copyright,
  registered,
  tm,
  end,
  back,
  on: on$1,
  top,
  soon,
  ballot_box_with_check,
  radio_button,
  white_circle,
  black_circle,
  red_circle,
  large_blue_circle,
  small_orange_diamond,
  small_blue_diamond,
  large_orange_diamond,
  large_blue_diamond,
  small_red_triangle,
  black_small_square,
  white_small_square,
  black_large_square,
  white_large_square,
  small_red_triangle_down,
  black_medium_square,
  white_medium_square,
  black_medium_small_square,
  white_medium_small_square,
  black_square_button,
  white_square_button,
  speaker,
  sound,
  loud_sound,
  mute,
  mega,
  loudspeaker,
  bell,
  no_bell,
  black_joker,
  mahjong,
  spades,
  clubs,
  hearts,
  diamonds,
  flower_playing_cards,
  thought_balloon,
  right_anger_bubble,
  speech_balloon,
  left_speech_bubble,
  clock1,
  clock2,
  clock3,
  clock4,
  clock5,
  clock6,
  clock7,
  clock8,
  clock9,
  clock10,
  clock11,
  clock12,
  clock130,
  clock230,
  clock330,
  clock430,
  clock530,
  clock630,
  clock730,
  clock830,
  clock930,
  clock1030,
  clock1130,
  clock1230,
  afghanistan,
  aland_islands,
  albania,
  algeria,
  american_samoa,
  andorra,
  angola,
  anguilla,
  antarctica,
  antigua_barbuda,
  argentina,
  armenia,
  aruba,
  australia,
  austria,
  azerbaijan,
  bahamas,
  bahrain,
  bangladesh,
  barbados,
  belarus,
  belgium,
  belize,
  benin,
  bermuda,
  bhutan,
  bolivia,
  caribbean_netherlands,
  bosnia_herzegovina,
  botswana,
  brazil,
  british_indian_ocean_territory,
  british_virgin_islands,
  brunei,
  bulgaria,
  burkina_faso,
  burundi,
  cape_verde,
  cambodia,
  cameroon,
  canada,
  canary_islands,
  cayman_islands,
  central_african_republic,
  chad,
  chile,
  cn,
  christmas_island,
  cocos_islands,
  colombia,
  comoros,
  congo_brazzaville,
  congo_kinshasa,
  cook_islands,
  costa_rica,
  croatia,
  cuba,
  curacao,
  cyprus,
  czech_republic,
  denmark,
  djibouti,
  dominica,
  dominican_republic,
  ecuador,
  egypt,
  el_salvador,
  equatorial_guinea,
  eritrea,
  estonia,
  ethiopia,
  eu,
  falkland_islands,
  faroe_islands,
  fiji,
  finland,
  fr,
  french_guiana,
  french_polynesia,
  french_southern_territories,
  gabon,
  gambia,
  georgia,
  de: de$1,
  ghana,
  gibraltar,
  greece,
  greenland,
  grenada,
  guadeloupe,
  guam,
  guatemala,
  guernsey,
  guinea,
  guinea_bissau,
  guyana,
  haiti,
  honduras,
  hong_kong,
  hungary,
  iceland,
  india,
  indonesia,
  iran,
  iraq,
  ireland,
  isle_of_man,
  israel,
  it,
  cote_divoire,
  jamaica,
  jp,
  jersey,
  jordan,
  kazakhstan,
  kenya,
  kiribati,
  kosovo,
  kuwait,
  kyrgyzstan,
  laos,
  latvia,
  lebanon,
  lesotho,
  liberia,
  libya,
  liechtenstein,
  lithuania,
  luxembourg,
  macau,
  macedonia,
  madagascar,
  malawi,
  malaysia,
  maldives,
  mali,
  malta,
  marshall_islands,
  martinique,
  mauritania,
  mauritius,
  mayotte,
  mexico,
  micronesia,
  moldova,
  monaco,
  mongolia,
  montenegro,
  montserrat,
  morocco,
  mozambique,
  myanmar,
  namibia,
  nauru,
  nepal,
  netherlands,
  new_caledonia,
  new_zealand,
  nicaragua,
  niger,
  nigeria,
  niue,
  norfolk_island,
  northern_mariana_islands,
  north_korea,
  norway,
  oman,
  pakistan,
  palau,
  palestinian_territories,
  panama,
  papua_new_guinea,
  paraguay,
  peru,
  philippines,
  pitcairn_islands,
  poland,
  portugal,
  puerto_rico,
  qatar,
  reunion,
  romania,
  ru,
  rwanda,
  st_barthelemy,
  st_helena,
  st_kitts_nevis,
  st_lucia,
  st_pierre_miquelon,
  st_vincent_grenadines,
  samoa,
  san_marino,
  sao_tome_principe,
  saudi_arabia,
  senegal,
  serbia,
  seychelles,
  sierra_leone,
  singapore,
  sint_maarten,
  slovakia,
  slovenia,
  solomon_islands,
  somalia,
  south_africa,
  south_georgia_south_sandwich_islands,
  kr,
  south_sudan,
  es,
  sri_lanka,
  sudan,
  suriname,
  swaziland,
  sweden,
  switzerland,
  syria,
  taiwan,
  tajikistan,
  tanzania,
  thailand,
  timor_leste,
  togo,
  tokelau,
  tonga,
  trinidad_tobago,
  tunisia,
  tr: tr$1,
  turkmenistan,
  turks_caicos_islands,
  tuvalu,
  uganda,
  ukraine,
  united_arab_emirates,
  uk,
  england,
  scotland,
  wales,
  us,
  us_virgin_islands,
  uruguay,
  uzbekistan,
  vanuatu,
  vatican_city,
  venezuela,
  vietnam,
  wallis_futuna,
  western_sahara,
  yemen,
  zambia,
  zimbabwe,
  united_nations,
  pirate_flag
}, require$$1$2 = /* @__PURE__ */ JSON.parse('["grinning","smiley","smile","grin","laughing","sweat_smile","joy","rofl","relaxed","blush","innocent","slightly_smiling_face","upside_down_face","wink","relieved","heart_eyes","smiling_face_with_three_hearts","kissing_heart","kissing","kissing_smiling_eyes","kissing_closed_eyes","yum","stuck_out_tongue","stuck_out_tongue_closed_eyes","stuck_out_tongue_winking_eye","zany","raised_eyebrow","monocle","nerd_face","sunglasses","star_struck","partying","smirk","unamused","disappointed","pensive","worried","confused","slightly_frowning_face","frowning_face","persevere","confounded","tired_face","weary","pleading","cry","sob","triumph","angry","rage","symbols_over_mouth","exploding_head","flushed","hot","cold","scream","fearful","cold_sweat","disappointed_relieved","sweat","hugs","thinking","hand_over_mouth","shushing","lying_face","no_mouth","neutral_face","expressionless","grimacing","roll_eyes","hushed","frowning","anguished","open_mouth","astonished","sleeping","drooling_face","sleepy","dizzy_face","zipper_mouth_face","woozy","nauseated_face","vomiting","sneezing_face","mask","face_with_thermometer","face_with_head_bandage","money_mouth_face","cowboy_hat_face","smiling_imp","imp","japanese_ogre","japanese_goblin","clown_face","poop","ghost","skull","skull_and_crossbones","alien","space_invader","robot","jack_o_lantern","smiley_cat","smile_cat","joy_cat","heart_eyes_cat","smirk_cat","kissing_cat","scream_cat","crying_cat_face","pouting_cat","palms_up","open_hands","raised_hands","clap","handshake","+1","-1","facepunch","fist","fist_left","fist_right","crossed_fingers","v","love_you","metal","ok_hand","point_left","point_right","point_up","point_down","point_up_2","raised_hand","raised_back_of_hand","raised_hand_with_fingers_splayed","vulcan_salute","wave","call_me_hand","muscle","fu","writing_hand","pray","foot","leg","ring","lipstick","kiss","lips","tooth","tongue","ear","nose","footprints","eye","eyes","brain","speaking_head","bust_in_silhouette","busts_in_silhouette","baby","girl","child","boy","woman","adult","man","blonde_woman","blonde_man","bearded_person","older_woman","older_adult","older_man","man_with_gua_pi_mao","woman_with_headscarf","woman_with_turban","man_with_turban","policewoman","policeman","construction_worker_woman","construction_worker_man","guardswoman","guardsman","female_detective","male_detective","woman_health_worker","man_health_worker","woman_farmer","man_farmer","woman_cook","man_cook","woman_student","man_student","woman_singer","man_singer","woman_teacher","man_teacher","woman_factory_worker","man_factory_worker","woman_technologist","man_technologist","woman_office_worker","man_office_worker","woman_mechanic","man_mechanic","woman_scientist","man_scientist","woman_artist","man_artist","woman_firefighter","man_firefighter","woman_pilot","man_pilot","woman_astronaut","man_astronaut","woman_judge","man_judge","bride_with_veil","man_in_tuxedo","princess","prince","woman_superhero","man_superhero","woman_supervillain","man_supervillain","mrs_claus","santa","sorceress","wizard","woman_elf","man_elf","woman_vampire","man_vampire","woman_zombie","man_zombie","woman_genie","man_genie","mermaid","merman","woman_fairy","man_fairy","angel","pregnant_woman","breastfeeding","bowing_woman","bowing_man","tipping_hand_woman","tipping_hand_man","no_good_woman","no_good_man","ok_woman","ok_man","raising_hand_woman","raising_hand_man","woman_facepalming","man_facepalming","woman_shrugging","man_shrugging","pouting_woman","pouting_man","frowning_woman","frowning_man","haircut_woman","haircut_man","massage_woman","massage_man","woman_in_steamy_room","man_in_steamy_room","nail_care","selfie","dancer","man_dancing","dancing_women","dancing_men","business_suit_levitating","walking_woman","walking_man","running_woman","running_man","couple","two_women_holding_hands","two_men_holding_hands","couple_with_heart_woman_man","couple_with_heart_woman_woman","couple_with_heart_man_man","couplekiss_man_woman","couplekiss_woman_woman","couplekiss_man_man","family_man_woman_boy","family_man_woman_girl","family_man_woman_girl_boy","family_man_woman_boy_boy","family_man_woman_girl_girl","family_woman_woman_boy","family_woman_woman_girl","family_woman_woman_girl_boy","family_woman_woman_boy_boy","family_woman_woman_girl_girl","family_man_man_boy","family_man_man_girl","family_man_man_girl_boy","family_man_man_boy_boy","family_man_man_girl_girl","family_woman_boy","family_woman_girl","family_woman_girl_boy","family_woman_boy_boy","family_woman_girl_girl","family_man_boy","family_man_girl","family_man_girl_boy","family_man_boy_boy","family_man_girl_girl","yarn","thread","coat","labcoat","womans_clothes","tshirt","jeans","necktie","dress","bikini","kimono","flat_shoe","high_heel","sandal","boot","mans_shoe","athletic_shoe","hiking_boot","socks","gloves","scarf","tophat","billed_hat","womans_hat","mortar_board","rescue_worker_helmet","crown","pouch","purse","handbag","briefcase","school_satchel","luggage","eyeglasses","dark_sunglasses","goggles","closed_umbrella","dog","cat","mouse","hamster","rabbit","fox_face","bear","panda_face","koala","tiger","lion","cow","pig","pig_nose","frog","monkey_face","see_no_evil","hear_no_evil","speak_no_evil","monkey","chicken","penguin","bird","baby_chick","hatching_chick","hatched_chick","duck","eagle","owl","bat","wolf","boar","horse","unicorn","honeybee","bug","butterfly","snail","shell","beetle","ant","mosquito","grasshopper","spider","spider_web","scorpion","turtle","snake","lizard","t-rex","sauropod","octopus","squid","shrimp","lobster","crab","blowfish","tropical_fish","fish","dolphin","whale","whale2","shark","crocodile","tiger2","leopard","zebra","gorilla","elephant","hippopotamus","rhinoceros","dromedary_camel","giraffe","kangaroo","camel","water_buffalo","ox","cow2","racehorse","pig2","ram","sheep","llama","goat","deer","dog2","poodle","cat2","rooster","turkey","peacock","parrot","swan","dove","rabbit2","raccoon","badger","rat","mouse2","chipmunk","hedgehog","paw_prints","dragon","dragon_face","cactus","christmas_tree","evergreen_tree","deciduous_tree","palm_tree","seedling","herb","shamrock","four_leaf_clover","bamboo","tanabata_tree","leaves","fallen_leaf","maple_leaf","ear_of_rice","hibiscus","sunflower","rose","wilted_flower","tulip","blossom","cherry_blossom","bouquet","mushroom","earth_americas","earth_africa","earth_asia","full_moon","waning_gibbous_moon","last_quarter_moon","waning_crescent_moon","new_moon","waxing_crescent_moon","first_quarter_moon","waxing_gibbous_moon","new_moon_with_face","full_moon_with_face","first_quarter_moon_with_face","last_quarter_moon_with_face","sun_with_face","crescent_moon","star","star2","dizzy","sparkles","comet","sunny","sun_behind_small_cloud","partly_sunny","sun_behind_large_cloud","sun_behind_rain_cloud","cloud","cloud_with_rain","cloud_with_lightning_and_rain","cloud_with_lightning","zap","fire","boom","snowflake","cloud_with_snow","snowman","snowman_with_snow","wind_face","dash","tornado","fog","open_umbrella","umbrella","droplet","sweat_drops","ocean","green_apple","apple","pear","tangerine","lemon","banana","watermelon","grapes","strawberry","melon","cherries","peach","mango","pineapple","coconut","kiwi_fruit","tomato","eggplant","avocado","broccoli","leafy_greens","cucumber","hot_pepper","corn","carrot","potato","sweet_potato","croissant","bagel","bread","baguette_bread","pretzel","cheese","egg","fried_egg","pancakes","bacon","steak","poultry_leg","meat_on_bone","bone","hotdog","hamburger","fries","pizza","sandwich","stuffed_flatbread","taco","burrito","green_salad","shallow_pan_of_food","canned_food","spaghetti","ramen","stew","curry","sushi","bento","fried_shrimp","rice_ball","rice","rice_cracker","fish_cake","fortune_cookie","moon_cake","oden","dango","shaved_ice","ice_cream","icecream","pie","cupcake","cake","birthday","custard","lollipop","candy","chocolate_bar","popcorn","doughnut","dumpling","cookie","chestnut","peanuts","honey_pot","milk_glass","baby_bottle","coffee","tea","cup_with_straw","sake","beer","beers","clinking_glasses","wine_glass","tumbler_glass","cocktail","tropical_drink","champagne","spoon","fork_and_knife","plate_with_cutlery","bowl_with_spoon","takeout_box","chopsticks","salt","soccer","basketball","football","baseball","softball","tennis","volleyball","rugby_football","flying_disc","8ball","golf","golfing_woman","golfing_man","ping_pong","badminton","goal_net","ice_hockey","field_hockey","lacrosse","cricket","ski","skier","snowboarder","person_fencing","women_wrestling","men_wrestling","woman_cartwheeling","man_cartwheeling","woman_playing_handball","man_playing_handball","ice_skate","curling_stone","skateboard","sled","bow_and_arrow","fishing_pole_and_fish","boxing_glove","martial_arts_uniform","rowing_woman","rowing_man","climbing_woman","climbing_man","swimming_woman","swimming_man","woman_playing_water_polo","man_playing_water_polo","woman_in_lotus_position","man_in_lotus_position","surfing_woman","surfing_man","basketball_woman","basketball_man","weight_lifting_woman","weight_lifting_man","biking_woman","biking_man","mountain_biking_woman","mountain_biking_man","horse_racing","trophy","running_shirt_with_sash","medal_sports","medal_military","1st_place_medal","2nd_place_medal","3rd_place_medal","reminder_ribbon","rosette","ticket","tickets","performing_arts","art","circus_tent","woman_juggling","man_juggling","microphone","headphones","musical_score","musical_keyboard","drum","saxophone","trumpet","guitar","violin","clapper","video_game","dart","game_die","chess_pawn","slot_machine","jigsaw","bowling","red_car","taxi","blue_car","bus","trolleybus","racing_car","police_car","ambulance","fire_engine","minibus","truck","articulated_lorry","tractor","kick_scooter","motorcycle","bike","motor_scooter","rotating_light","oncoming_police_car","oncoming_bus","oncoming_automobile","oncoming_taxi","aerial_tramway","mountain_cableway","suspension_railway","railway_car","train","monorail","bullettrain_side","bullettrain_front","light_rail","mountain_railway","steam_locomotive","train2","metro","tram","station","flying_saucer","helicopter","small_airplane","airplane","flight_departure","flight_arrival","sailboat","motor_boat","speedboat","ferry","passenger_ship","rocket","artificial_satellite","seat","canoe","anchor","construction","fuelpump","busstop","vertical_traffic_light","traffic_light","ship","ferris_wheel","roller_coaster","carousel_horse","building_construction","foggy","tokyo_tower","factory","fountain","rice_scene","mountain","mountain_snow","mount_fuji","volcano","japan","camping","tent","national_park","motorway","railway_track","sunrise","sunrise_over_mountains","desert","beach_umbrella","desert_island","city_sunrise","city_sunset","cityscape","night_with_stars","bridge_at_night","milky_way","stars","sparkler","fireworks","rainbow","houses","european_castle","japanese_castle","stadium","statue_of_liberty","house","house_with_garden","derelict_house","office","department_store","post_office","european_post_office","hospital","bank","hotel","convenience_store","school","love_hotel","wedding","classical_building","church","mosque","synagogue","kaaba","shinto_shrine","watch","iphone","calling","computer","keyboard","desktop_computer","printer","computer_mouse","trackball","joystick","clamp","minidisc","floppy_disk","cd","dvd","vhs","camera","camera_flash","video_camera","movie_camera","film_projector","film_strip","telephone_receiver","phone","pager","fax","tv","radio","studio_microphone","level_slider","control_knobs","compass","stopwatch","timer_clock","alarm_clock","mantelpiece_clock","hourglass_flowing_sand","hourglass","satellite","battery","electric_plug","bulb","flashlight","candle","fire_extinguisher","wastebasket","oil_drum","money_with_wings","dollar","yen","euro","pound","moneybag","credit_card","gem","balance_scale","toolbox","wrench","hammer","hammer_and_pick","hammer_and_wrench","pick","nut_and_bolt","gear","brick","chains","magnet","gun","bomb","firecracker","hocho","dagger","crossed_swords","shield","smoking","coffin","funeral_urn","amphora","crystal_ball","prayer_beads","nazar_amulet","barber","alembic","telescope","microscope","hole","pill","syringe","dna","microbe","petri_dish","test_tube","thermometer","broom","basket","toilet_paper","label","bookmark","toilet","shower","bathtub","bath","soap","sponge","lotion_bottle","key","old_key","couch_and_lamp","sleeping_bed","bed","door","bellhop_bell","teddy_bear","framed_picture","world_map","parasol_on_ground","moyai","shopping","shopping_cart","balloon","flags","ribbon","gift","confetti_ball","tada","dolls","wind_chime","crossed_flags","izakaya_lantern","red_envelope","email","envelope_with_arrow","incoming_envelope","e-mail","love_letter","postbox","mailbox_closed","mailbox","mailbox_with_mail","mailbox_with_no_mail","package","postal_horn","inbox_tray","outbox_tray","scroll","page_with_curl","bookmark_tabs","receipt","bar_chart","chart_with_upwards_trend","chart_with_downwards_trend","page_facing_up","date","calendar","spiral_calendar","card_index","card_file_box","ballot_box","file_cabinet","clipboard","spiral_notepad","file_folder","open_file_folder","card_index_dividers","newspaper_roll","newspaper","notebook","closed_book","green_book","blue_book","orange_book","notebook_with_decorative_cover","ledger","books","open_book","safety_pin","link","paperclip","paperclips","scissors","triangular_ruler","straight_ruler","abacus","pushpin","round_pushpin","closed_lock_with_key","lock","unlock","lock_with_ink_pen","pen","fountain_pen","black_nib","memo","pencil2","crayon","paintbrush","mag","mag_right","heart","orange_heart","yellow_heart","green_heart","blue_heart","purple_heart","black_heart","broken_heart","heavy_heart_exclamation","two_hearts","revolving_hearts","heartbeat","heartpulse","sparkling_heart","cupid","gift_heart","heart_decoration","peace_symbol","latin_cross","star_and_crescent","om","wheel_of_dharma","star_of_david","six_pointed_star","menorah","yin_yang","orthodox_cross","place_of_worship","ophiuchus","aries","taurus","gemini","cancer","leo","virgo","libra","scorpius","sagittarius","capricorn","aquarius","pisces","id","atom_symbol","u7a7a","u5272","radioactive","biohazard","mobile_phone_off","vibration_mode","u6709","u7121","u7533","u55b6","u6708","eight_pointed_black_star","vs","accept","white_flower","ideograph_advantage","secret","congratulations","u5408","u6e80","u7981","a","b","ab","cl","o2","sos","no_entry","name_badge","no_entry_sign","x","o","stop_sign","anger","hotsprings","no_pedestrians","do_not_litter","no_bicycles","non-potable_water","underage","no_mobile_phones","exclamation","grey_exclamation","question","grey_question","bangbang","interrobang","100","low_brightness","high_brightness","trident","fleur_de_lis","part_alternation_mark","warning","children_crossing","beginner","recycle","u6307","chart","sparkle","eight_spoked_asterisk","negative_squared_cross_mark","white_check_mark","diamond_shape_with_a_dot_inside","cyclone","loop","globe_with_meridians","m","atm","zzz","sa","passport_control","customs","baggage_claim","left_luggage","wheelchair","no_smoking","wc","parking","potable_water","mens","womens","baby_symbol","restroom","put_litter_in_its_place","cinema","signal_strength","koko","ng","ok","up","cool","new","free","zero","one","two","three","four","five","six","seven","eight","nine","keycap_ten","asterisk","1234","eject_button","arrow_forward","pause_button","next_track_button","stop_button","record_button","play_or_pause_button","previous_track_button","fast_forward","rewind","twisted_rightwards_arrows","repeat","repeat_one","arrow_backward","arrow_up_small","arrow_down_small","arrow_double_up","arrow_double_down","arrow_right","arrow_left","arrow_up","arrow_down","arrow_upper_right","arrow_lower_right","arrow_lower_left","arrow_upper_left","arrow_up_down","left_right_arrow","arrows_counterclockwise","arrow_right_hook","leftwards_arrow_with_hook","arrow_heading_up","arrow_heading_down","hash","information_source","abc","abcd","capital_abcd","symbols","musical_note","notes","wavy_dash","curly_loop","heavy_check_mark","arrows_clockwise","heavy_plus_sign","heavy_minus_sign","heavy_division_sign","heavy_multiplication_x","infinity","heavy_dollar_sign","currency_exchange","copyright","registered","tm","end","back","on","top","soon","ballot_box_with_check","radio_button","white_circle","black_circle","red_circle","large_blue_circle","small_orange_diamond","small_blue_diamond","large_orange_diamond","large_blue_diamond","small_red_triangle","black_small_square","white_small_square","black_large_square","white_large_square","small_red_triangle_down","black_medium_square","white_medium_square","black_medium_small_square","white_medium_small_square","black_square_button","white_square_button","speaker","sound","loud_sound","mute","mega","loudspeaker","bell","no_bell","black_joker","mahjong","spades","clubs","hearts","diamonds","flower_playing_cards","thought_balloon","right_anger_bubble","speech_balloon","left_speech_bubble","clock1","clock2","clock3","clock4","clock5","clock6","clock7","clock8","clock9","clock10","clock11","clock12","clock130","clock230","clock330","clock430","clock530","clock630","clock730","clock830","clock930","clock1030","clock1130","clock1230","white_flag","black_flag","pirate_flag","checkered_flag","triangular_flag_on_post","rainbow_flag","united_nations","afghanistan","aland_islands","albania","algeria","american_samoa","andorra","angola","anguilla","antarctica","antigua_barbuda","argentina","armenia","aruba","australia","austria","azerbaijan","bahamas","bahrain","bangladesh","barbados","belarus","belgium","belize","benin","bermuda","bhutan","bolivia","caribbean_netherlands","bosnia_herzegovina","botswana","brazil","british_indian_ocean_territory","british_virgin_islands","brunei","bulgaria","burkina_faso","burundi","cape_verde","cambodia","cameroon","canada","canary_islands","cayman_islands","central_african_republic","chad","chile","cn","christmas_island","cocos_islands","colombia","comoros","congo_brazzaville","congo_kinshasa","cook_islands","costa_rica","croatia","cuba","curacao","cyprus","czech_republic","denmark","djibouti","dominica","dominican_republic","ecuador","egypt","el_salvador","equatorial_guinea","eritrea","estonia","ethiopia","eu","falkland_islands","faroe_islands","fiji","finland","fr","french_guiana","french_polynesia","french_southern_territories","gabon","gambia","georgia","de","ghana","gibraltar","greece","greenland","grenada","guadeloupe","guam","guatemala","guernsey","guinea","guinea_bissau","guyana","haiti","honduras","hong_kong","hungary","iceland","india","indonesia","iran","iraq","ireland","isle_of_man","israel","it","cote_divoire","jamaica","jp","jersey","jordan","kazakhstan","kenya","kiribati","kosovo","kuwait","kyrgyzstan","laos","latvia","lebanon","lesotho","liberia","libya","liechtenstein","lithuania","luxembourg","macau","macedonia","madagascar","malawi","malaysia","maldives","mali","malta","marshall_islands","martinique","mauritania","mauritius","mayotte","mexico","micronesia","moldova","monaco","mongolia","montenegro","montserrat","morocco","mozambique","myanmar","namibia","nauru","nepal","netherlands","new_caledonia","new_zealand","nicaragua","niger","nigeria","niue","norfolk_island","northern_mariana_islands","north_korea","norway","oman","pakistan","palau","palestinian_territories","panama","papua_new_guinea","paraguay","peru","philippines","pitcairn_islands","poland","portugal","puerto_rico","qatar","reunion","romania","ru","rwanda","st_barthelemy","st_helena","st_kitts_nevis","st_lucia","st_pierre_miquelon","st_vincent_grenadines","samoa","san_marino","sao_tome_principe","saudi_arabia","senegal","serbia","seychelles","sierra_leone","singapore","sint_maarten","slovakia","slovenia","solomon_islands","somalia","south_africa","south_georgia_south_sandwich_islands","kr","south_sudan","es","sri_lanka","sudan","suriname","swaziland","sweden","switzerland","syria","taiwan","tajikistan","tanzania","thailand","timor_leste","togo","tokelau","tonga","trinidad_tobago","tunisia","tr","turkmenistan","turks_caicos_islands","tuvalu","uganda","ukraine","united_arab_emirates","uk","england","scotland","wales","us","us_virgin_islands","uruguay","uzbekistan","vanuatu","vatican_city","venezuela","vietnam","wallis_futuna","western_sahara","yemen","zambia","zimbabwe"]');
var emojilib$1, hasRequiredEmojilib;
function requireEmojilib() {
  return hasRequiredEmojilib || (hasRequiredEmojilib = 1, emojilib$1 = {
    lib: require$$0$3,
    ordered: require$$1$2,
    fitzpatrick_scale_modifiers: ["🏻", "🏼", "🏽", "🏾", "🏿"]
  }), emojilib$1;
}
var emojilibExports = requireEmojilib();
const emojilib = /* @__PURE__ */ getDefaultExportFromCjs$2(emojilibExports);
var charRegex$1, hasRequiredCharRegex;
function requireCharRegex() {
  return hasRequiredCharRegex || (hasRequiredCharRegex = 1, charRegex$1 = () => {
    const n = "\\ud800-\\udfff", AA = "\\u0300-\\u036f" + "\\ufe20-\\ufe2f" + "\\u20d0-\\u20ff" + "\\u1ab0-\\u1aff" + "\\u1dc0-\\u1dff", gA = "\\ufe0e\\ufe0f", IA = "\\uD83D\\uDC69\\uD83C\\uDFFB\\u200D\\uD83C\\uDF93", CA = `[${n}]`, BA = `[${AA}]`, eA = "\\ud83c[\\udffb-\\udfff]", iA = `(?:${BA}|${eA})`, QA = `[^${n}]`, tA = "(?:\\uD83C[\\uDDE6-\\uDDFF]){2}", oA = "[\\ud800-\\udbff][\\udc00-\\udfff]", EA = "\\u200d", aA = "(?:\\ud83c\\udff4\\udb40\\udc67\\udb40\\udc62\\udb40(?:\\udc65|\\udc73|\\udc77)\\udb40(?:\\udc6e|\\udc63|\\udc6c)\\udb40(?:\\udc67|\\udc74|\\udc73)\\udb40\\udc7f)", nA = `[${IA}]`, lA = `${iA}?`, cA = `[${gA}]?`, sA = `(?:${EA}(?:${[QA, tA, oA].join("|")})${cA + lA})*`, rA = cA + lA + sA, hA = `(?:${[`${QA}${BA}?`, BA, tA, oA, CA, nA].join("|")})`;
    return new RegExp(`${aA}|${eA}(?=${eA})|${hA + rA}`, "g");
  }), charRegex$1;
}
var charRegexExports = requireCharRegex();
const charRegex = /* @__PURE__ */ getDefaultExportFromCjs$2(charRegexExports);
charRegex();
var NON_SPACING_MARK = "️", nonSpacingRegex = new RegExp(NON_SPACING_MARK, "g");
function normalizeCode(n) {
  return n.replace(nonSpacingRegex, "");
}
function normalizeName(n) {
  return /:.+:/.test(n) ? n.slice(1, -1) : n;
}
var emojiData = Object.entries(emojilib.lib).map(
  ([n, { char: t }]) => [n, t]
), emojiCodesByName = new Map(emojiData), emojiNamesByCode = new Map(
  emojiData.map(([n, t]) => [normalizeCode(t), n])
), get$8 = (n) => (distExports$1.assert.string(n), emojiCodesByName.get(normalizeName(n))), has$3 = (n) => (distExports$1.assert.string(n), emojiCodesByName.has(normalizeName(n)) || emojiNamesByCode.has(normalizeCode(n)));
const emoticon = [
  {
    description: "angry face",
    emoji: "😠",
    emoticons: [">:(", ">:[", ">:-(", ">:-[", ">=(", ">=[", ">=-(", ">=-["],
    name: "angry",
    tags: ["mad", "annoyed"]
  },
  {
    description: "smiling face with smiling eyes",
    emoji: "😊",
    emoticons: [
      ':")',
      ':"]',
      ':"D',
      ':-")',
      ':-"]',
      ':-"D',
      '=")',
      '="]',
      '="D',
      '=-")',
      '=-"]',
      '=-"D'
    ],
    name: "blush",
    tags: ["proud"]
  },
  {
    description: "broken heart",
    emoji: "💔",
    emoticons: ["<\\3", "</3"],
    name: "broken_heart",
    tags: []
  },
  {
    description: "confused face",
    emoji: "😕",
    emoticons: [":/", ":\\", ":-/", ":-\\", "=/", "=\\", "=-/", "=-\\"],
    name: "confused",
    tags: []
  },
  {
    description: "crying face",
    emoji: "😢",
    emoticons: [
      ":,(",
      ":,[",
      ":,|",
      ":,-(",
      ":,-[",
      ":,-|",
      ":'(",
      ":'[",
      ":'|",
      ":'-(",
      ":'-[",
      ":'-|",
      "=,(",
      "=,[",
      "=,|",
      "=,-(",
      "=,-[",
      "=,-|",
      "='(",
      "='[",
      "='|",
      "='-(",
      "='-[",
      "='-|",
      "T-T"
    ],
    name: "cry",
    tags: ["sad", "tear"]
  },
  {
    description: "frowning face with open mouth",
    emoji: "😦",
    emoticons: [":(", ":[", ":-(", ":-[", "=(", "=[", "=-(", "=-["],
    name: "frowning",
    tags: []
  },
  {
    description: "red heart",
    emoji: "❤️",
    emoticons: ["<3"],
    name: "heart",
    tags: ["love"]
  },
  {
    description: "angry face with horns",
    emoji: "👿",
    emoticons: ["]:(", "]:[", "]:-(", "]:-[", "]=(", "]=[", "]=-(", "]=-["],
    name: "imp",
    tags: ["angry", "devil", "evil", "horns"]
  },
  {
    description: "smiling face with halo",
    emoji: "😇",
    emoticons: [
      "o:)",
      "o:]",
      "o:D",
      "o:-)",
      "o:-]",
      "o:-D",
      "o=)",
      "o=]",
      "o=D",
      "o=-)",
      "o=-]",
      "o=-D",
      "O:)",
      "O:]",
      "O:D",
      "O:-)",
      "O:-]",
      "O:-D",
      "O=)",
      "O=]",
      "O=D",
      "O=-)",
      "O=-]",
      "O=-D",
      "0:)",
      "0:]",
      "0:D",
      "0:-)",
      "0:-]",
      "0:-D",
      "0=)",
      "0=]",
      "0=D",
      "0=-)",
      "0=-]",
      "0=-D"
    ],
    name: "innocent",
    tags: ["angel"]
  },
  {
    description: "face with tears of joy",
    emoji: "😂",
    emoticons: [
      ":,)",
      ":,]",
      ":,D",
      ":,-)",
      ":,-]",
      ":,-D",
      ":')",
      ":']",
      ":'D",
      ":'-)",
      ":'-]",
      ":'-D",
      "=,)",
      "=,]",
      "=,D",
      "=,-)",
      "=,-]",
      "=,-D",
      "=')",
      "=']",
      "='D",
      "='-)",
      "='-]",
      "='-D"
    ],
    name: "joy",
    tags: ["tears"]
  },
  {
    description: "kissing face",
    emoji: "😗",
    emoticons: [":*", ":-*", "=*", "=-*"],
    name: "kissing",
    tags: []
  },
  {
    description: "grinning squinting face",
    emoji: "😆",
    emoticons: [
      "x)",
      "x]",
      "xD",
      "x-)",
      "x-]",
      "x-D",
      "X)",
      "X]",
      "X-)",
      "X-]",
      "X-D"
    ],
    name: "laughing",
    tags: ["happy", "haha"]
  },
  {
    description: "man",
    emoji: "👨",
    emoticons: [
      ":3",
      ":-3",
      "=3",
      "=-3",
      ";3",
      ";-3",
      "x3",
      "x-3",
      "X3",
      "X-3"
    ],
    name: "man",
    tags: ["mustache", "father", "dad"]
  },
  {
    description: "neutral face",
    emoji: "😐",
    emoticons: [":|", ":-|", "=|", "=-|"],
    name: "neutral_face",
    tags: ["meh"]
  },
  {
    description: "face without mouth",
    emoji: "😶",
    emoticons: [":-"],
    name: "no_mouth",
    tags: ["mute", "silence"]
  },
  {
    description: "face with open mouth",
    emoji: "😮",
    emoticons: [
      ":o",
      ":O",
      ":0",
      ":-o",
      ":-O",
      ":-0",
      "=o",
      "=O",
      "=0",
      "=-o",
      "=-O",
      "=-0"
    ],
    name: "open_mouth",
    tags: ["surprise", "impressed", "wow"]
  },
  {
    description: "enraged face",
    emoji: "😡",
    emoticons: [":@", ":-@", "=@", "=-@"],
    name: "rage",
    tags: ["angry"]
  },
  {
    description: "grinning face with smiling eyes",
    emoji: "😄",
    emoticons: [":D", ":-D", "=D", "=-D"],
    name: "smile",
    tags: ["happy", "joy", "laugh", "pleased"]
  },
  {
    description: "grinning face with big eyes",
    emoji: "😃",
    emoticons: [":)", ":]", ":-)", ":-]", "=)", "=]", "=-)", "=-]"],
    name: "smiley",
    tags: ["happy", "joy", "haha"]
  },
  {
    description: "smiling face with horns",
    emoji: "😈",
    emoticons: [
      "]:)",
      "]:]",
      "]:D",
      "]:-)",
      "]:-]",
      "]:-D",
      "]=)",
      "]=]",
      "]=D",
      "]=-)",
      "]=-]",
      "]=-D"
    ],
    name: "smiling_imp",
    tags: ["devil", "evil", "horns"]
  },
  {
    description: "loudly crying face",
    emoji: "😭",
    emoticons: [
      ":,'(",
      ":,'[",
      ":,'-(",
      ":,'-[",
      ":',(",
      ":',[",
      ":',-(",
      ":',-[",
      "=,'(",
      "=,'[",
      "=,'-(",
      "=,'-[",
      "=',(",
      "=',[",
      "=',-(",
      "=',-["
    ],
    name: "sob",
    tags: ["sad", "cry", "bawling"]
  },
  {
    description: "face with tongue",
    emoji: "😛",
    emoticons: [
      ":p",
      ":P",
      ":d",
      ":-p",
      ":-P",
      ":-d",
      "=p",
      "=P",
      "=d",
      "=-p",
      "=-P",
      "=-d"
    ],
    name: "stuck_out_tongue",
    tags: []
  },
  {
    description: "squinting face with tongue",
    emoji: "😝",
    emoticons: ["xP", "x-p", "x-P", "x-d", "Xp", "Xd", "X-p", "X-P", "X-d"],
    name: "stuck_out_tongue_closed_eyes",
    tags: ["prank"]
  },
  {
    description: "winking face with tongue",
    emoji: "😜",
    emoticons: [";p", ";P", ";d", ";-p", ";-P", ";-d"],
    name: "stuck_out_tongue_winking_eye",
    tags: ["prank", "silly"]
  },
  {
    description: "smiling face with sunglasses",
    emoji: "😎",
    emoticons: [
      "8)",
      "8]",
      "8D",
      "8-)",
      "8-]",
      "8-D",
      "B)",
      "B]",
      "B-)",
      "B-]",
      "B-D"
    ],
    name: "sunglasses",
    tags: ["cool"]
  },
  {
    description: "downcast face with sweat",
    emoji: "😓",
    emoticons: [
      ",:(",
      ",:[",
      ",:-(",
      ",:-[",
      ",=(",
      ",=[",
      ",=-(",
      ",=-[",
      "':(",
      "':[",
      "':-(",
      "':-[",
      "'=(",
      "'=[",
      "'=-(",
      "'=-["
    ],
    name: "sweat",
    tags: []
  },
  {
    description: "grinning face with sweat",
    emoji: "😅",
    emoticons: [
      ",:)",
      ",:]",
      ",:D",
      ",:-)",
      ",:-]",
      ",:-D",
      ",=)",
      ",=]",
      ",=D",
      ",=-)",
      ",=-]",
      ",=-D",
      "':)",
      "':]",
      "':D",
      "':-)",
      "':-]",
      "':-D",
      "'=)",
      "'=]",
      "'=D",
      "'=-)",
      "'=-]",
      "'=-D"
    ],
    name: "sweat_smile",
    tags: ["hot"]
  },
  {
    description: "unamused face",
    emoji: "😒",
    emoticons: [
      ":$",
      ":s",
      ":z",
      ":S",
      ":Z",
      ":-$",
      ":-s",
      ":-z",
      ":-S",
      ":-Z",
      "=$",
      "=s",
      "=z",
      "=S",
      "=Z",
      "=-$",
      "=-s",
      "=-z",
      "=-S",
      "=-Z"
    ],
    name: "unamused",
    tags: ["meh"]
  },
  {
    description: "winking face",
    emoji: "😉",
    emoticons: [";)", ";]", ";D", ";-)", ";-]", ";-D"],
    name: "wink",
    tags: ["flirt"]
  }
], RE_EMOJI = /:\+1:|:-1:|:[\w-]+:/g, RE_SHORT = /(^|\s)[@$|*'",;.=:\-)([\]\\/<>038BOopPsSdDxXzZ]{2,5}/g, RE_PUNCT = /(?:_|-(?!1))/g, DEFAULT_SETTINGS = {
  padSpaceAfter: !1,
  emoticon: !1,
  accessible: !1
}, plugin = (n) => {
  const t = Object.assign({}, DEFAULT_SETTINGS, n), g = !!t.padSpaceAfter, d = !!t.emoticon, k = !!t.accessible;
  function H(BA, eA) {
    return {
      type: "text",
      value: BA,
      data: {
        hName: "span",
        hProperties: {
          role: "img",
          ariaLabel: eA
        },
        hChildren: [{ type: "text", value: BA }]
      }
    };
  }
  function AA(BA) {
    const eA = emoticon.find((cA) => cA.emoticons.includes(BA)), iA = emoticon.find((cA) => cA.emoticons.includes(BA.slice(0, -1))), QA = emoticon.find((cA) => cA.emoticons.includes(BA.slice(1))), tA = emoticon.find((cA) => cA.emoticons.includes(BA.slice(1, -1))), oA = eA || iA || QA || tA;
    if (!oA)
      return !1;
    const EA = !(eA || QA) && (tA || iA) ? BA.slice(-1) : "", aA = !(eA || iA) && (tA || QA) ? BA.slice(0, 1) : "", nA = g ? " " : "", lA = aA + oA.emoji + nA + EA;
    return k ? H(lA, oA.name + " emoticon") : lA;
  }
  function gA(BA) {
    let eA = get$8(BA);
    if (typeof eA > "u")
      return !1;
    if (g && (eA = eA + " "), k) {
      const iA = BA.slice(1, -1).replace(RE_PUNCT, " ") + " emoji";
      return H(eA, iA);
    }
    return eA;
  }
  const IA = [[RE_EMOJI, gA]];
  d && IA.push([RE_SHORT, AA]);
  function CA(BA) {
    findAndReplace(BA, IA);
  }
  return CA;
}, inConstruct = "phrasing", notInConstruct = ["autolink", "link", "image", "label"];
function gfmAutolinkLiteralFromMarkdown() {
  return {
    transforms: [transformGfmAutolinkLiterals],
    enter: {
      literalAutolink: enterLiteralAutolink,
      literalAutolinkEmail: enterLiteralAutolinkValue,
      literalAutolinkHttp: enterLiteralAutolinkValue,
      literalAutolinkWww: enterLiteralAutolinkValue
    },
    exit: {
      literalAutolink: exitLiteralAutolink,
      literalAutolinkEmail: exitLiteralAutolinkEmail,
      literalAutolinkHttp: exitLiteralAutolinkHttp,
      literalAutolinkWww: exitLiteralAutolinkWww
    }
  };
}
function gfmAutolinkLiteralToMarkdown() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct,
        notInConstruct
      }
    ]
  };
}
function enterLiteralAutolink(n) {
  this.enter({ type: "link", title: null, url: "", children: [] }, n);
}
function enterLiteralAutolinkValue(n) {
  this.config.enter.autolinkProtocol.call(this, n);
}
function exitLiteralAutolinkHttp(n) {
  this.config.exit.autolinkProtocol.call(this, n);
}
function exitLiteralAutolinkWww(n) {
  this.config.exit.data.call(this, n);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(n);
}
function exitLiteralAutolinkEmail(n) {
  this.config.exit.autolinkEmail.call(this, n);
}
function exitLiteralAutolink(n) {
  this.exit(n);
}
function transformGfmAutolinkLiterals(n) {
  findAndReplace(
    n,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), findEmail]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function findUrl(n, t, g, d, k) {
  let H = "";
  if (!previous$1(k) || (/^w/i.test(t) && (g = t + g, t = "", H = "http://"), !isCorrectDomain(g)))
    return !1;
  const AA = splitUrl(g + d);
  if (!AA[0]) return !1;
  const gA = {
    type: "link",
    title: null,
    url: H + t + AA[0],
    children: [{ type: "text", value: t + AA[0] }]
  };
  return AA[1] ? [gA, { type: "text", value: AA[1] }] : gA;
}
function findEmail(n, t, g, d) {
  return (
    // Not an expected previous character.
    !previous$1(d, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(g) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + g,
      children: [{ type: "text", value: t + "@" + g }]
    }
  );
}
function isCorrectDomain(n) {
  const t = n.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function splitUrl(n) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(n);
  if (!t)
    return [n, void 0];
  n = n.slice(0, t.index);
  let g = t[0], d = g.indexOf(")");
  const k = ccount(n, "(");
  let H = ccount(n, ")");
  for (; d !== -1 && k > H; )
    n += g.slice(0, d + 1), g = g.slice(d + 1), d = g.indexOf(")"), H++;
  return [n, g];
}
function previous$1(n, t) {
  const g = n.input.charCodeAt(n.index - 1);
  return (n.index === 0 || unicodeWhitespace(g) || unicodePunctuation(g)) && // If it’s an email, the previous character should not be a slash.
  (!t || g !== 47);
}
footnoteReference.peek = footnoteReferencePeek;
function enterFootnoteCallString() {
  this.buffer();
}
function enterFootnoteCall(n) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, n);
}
function enterFootnoteDefinitionLabelString() {
  this.buffer();
}
function enterFootnoteDefinition(n) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    n
  );
}
function exitFootnoteCallString(n) {
  const t = this.resume(), g = this.stack[this.stack.length - 1];
  g.type, g.identifier = normalizeIdentifier(
    this.sliceSerialize(n)
  ).toLowerCase(), g.label = t;
}
function exitFootnoteCall(n) {
  this.exit(n);
}
function exitFootnoteDefinitionLabelString(n) {
  const t = this.resume(), g = this.stack[this.stack.length - 1];
  g.type, g.identifier = normalizeIdentifier(
    this.sliceSerialize(n)
  ).toLowerCase(), g.label = t;
}
function exitFootnoteDefinition(n) {
  this.exit(n);
}
function footnoteReferencePeek() {
  return "[";
}
function footnoteReference(n, t, g, d) {
  const k = g.createTracker(d);
  let H = k.move("[^");
  const AA = g.enter("footnoteReference"), gA = g.enter("reference");
  return H += k.move(
    g.safe(g.associationId(n), { after: "]", before: H })
  ), gA(), AA(), H += k.move("]"), H;
}
function gfmFootnoteFromMarkdown() {
  return {
    enter: {
      gfmFootnoteCallString: enterFootnoteCallString,
      gfmFootnoteCall: enterFootnoteCall,
      gfmFootnoteDefinitionLabelString: enterFootnoteDefinitionLabelString,
      gfmFootnoteDefinition: enterFootnoteDefinition
    },
    exit: {
      gfmFootnoteCallString: exitFootnoteCallString,
      gfmFootnoteCall: exitFootnoteCall,
      gfmFootnoteDefinitionLabelString: exitFootnoteDefinitionLabelString,
      gfmFootnoteDefinition: exitFootnoteDefinition
    }
  };
}
function gfmFootnoteToMarkdown(n) {
  let t = !1;
  return n && n.firstLineBlank && (t = !0), {
    handlers: { footnoteDefinition: g, footnoteReference },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function g(d, k, H, AA) {
    const gA = H.createTracker(AA);
    let IA = gA.move("[^");
    const CA = H.enter("footnoteDefinition"), BA = H.enter("label");
    return IA += gA.move(
      H.safe(H.associationId(d), { before: IA, after: "]" })
    ), BA(), IA += gA.move("]:"), d.children && d.children.length > 0 && (gA.shift(4), IA += gA.move(
      (t ? `
` : " ") + H.indentLines(
        H.containerFlow(d, gA.current()),
        t ? mapAll : mapExceptFirst
      )
    )), CA(), IA;
  }
}
function mapExceptFirst(n, t, g) {
  return t === 0 ? n : mapAll(n, t, g);
}
function mapAll(n, t, g) {
  return (g ? "" : "    ") + n;
}
const constructsWithoutStrikethrough = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
handleDelete.peek = peekDelete;
function gfmStrikethroughFromMarkdown() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: enterStrikethrough },
    exit: { strikethrough: exitStrikethrough }
  };
}
function gfmStrikethroughToMarkdown() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: constructsWithoutStrikethrough
      }
    ],
    handlers: { delete: handleDelete }
  };
}
function enterStrikethrough(n) {
  this.enter({ type: "delete", children: [] }, n);
}
function exitStrikethrough(n) {
  this.exit(n);
}
function handleDelete(n, t, g, d) {
  const k = g.createTracker(d), H = g.enter("strikethrough");
  let AA = k.move("~~");
  return AA += g.containerPhrasing(n, {
    ...k.current(),
    before: AA,
    after: "~"
  }), AA += k.move("~~"), H(), AA;
}
function peekDelete() {
  return "~";
}
function defaultStringLength(n) {
  return n.length;
}
function markdownTable(n, t) {
  const g = t || {}, d = (g.align || []).concat(), k = g.stringLength || defaultStringLength, H = [], AA = [], gA = [], IA = [];
  let CA = 0, BA = -1;
  for (; ++BA < n.length; ) {
    const oA = [], EA = [];
    let aA = -1;
    for (n[BA].length > CA && (CA = n[BA].length); ++aA < n[BA].length; ) {
      const nA = serialize(n[BA][aA]);
      if (g.alignDelimiters !== !1) {
        const lA = k(nA);
        EA[aA] = lA, (IA[aA] === void 0 || lA > IA[aA]) && (IA[aA] = lA);
      }
      oA.push(nA);
    }
    AA[BA] = oA, gA[BA] = EA;
  }
  let eA = -1;
  if (typeof d == "object" && "length" in d)
    for (; ++eA < CA; )
      H[eA] = toAlignment(d[eA]);
  else {
    const oA = toAlignment(d);
    for (; ++eA < CA; )
      H[eA] = oA;
  }
  eA = -1;
  const iA = [], QA = [];
  for (; ++eA < CA; ) {
    const oA = H[eA];
    let EA = "", aA = "";
    oA === 99 ? (EA = ":", aA = ":") : oA === 108 ? EA = ":" : oA === 114 && (aA = ":");
    let nA = g.alignDelimiters === !1 ? 1 : Math.max(
      1,
      IA[eA] - EA.length - aA.length
    );
    const lA = EA + "-".repeat(nA) + aA;
    g.alignDelimiters !== !1 && (nA = EA.length + nA + aA.length, nA > IA[eA] && (IA[eA] = nA), QA[eA] = nA), iA[eA] = lA;
  }
  AA.splice(1, 0, iA), gA.splice(1, 0, QA), BA = -1;
  const tA = [];
  for (; ++BA < AA.length; ) {
    const oA = AA[BA], EA = gA[BA];
    eA = -1;
    const aA = [];
    for (; ++eA < CA; ) {
      const nA = oA[eA] || "";
      let lA = "", cA = "";
      if (g.alignDelimiters !== !1) {
        const sA = IA[eA] - (EA[eA] || 0), rA = H[eA];
        rA === 114 ? lA = " ".repeat(sA) : rA === 99 ? sA % 2 ? (lA = " ".repeat(sA / 2 + 0.5), cA = " ".repeat(sA / 2 - 0.5)) : (lA = " ".repeat(sA / 2), cA = lA) : cA = " ".repeat(sA);
      }
      g.delimiterStart !== !1 && !eA && aA.push("|"), g.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(g.alignDelimiters === !1 && nA === "") && (g.delimiterStart !== !1 || eA) && aA.push(" "), g.alignDelimiters !== !1 && aA.push(lA), aA.push(nA), g.alignDelimiters !== !1 && aA.push(cA), g.padding !== !1 && aA.push(" "), (g.delimiterEnd !== !1 || eA !== CA - 1) && aA.push("|");
    }
    tA.push(
      g.delimiterEnd === !1 ? aA.join("").replace(/ +$/, "") : aA.join("")
    );
  }
  return tA.join(`
`);
}
function serialize(n) {
  return n == null ? "" : String(n);
}
function toAlignment(n) {
  const t = typeof n == "string" ? n.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function blockquote(n, t, g, d) {
  const k = g.enter("blockquote"), H = g.createTracker(d);
  H.move("> "), H.shift(2);
  const AA = g.indentLines(
    g.containerFlow(n, H.current()),
    map$5
  );
  return k(), AA;
}
function map$5(n, t, g) {
  return ">" + (g ? "" : " ") + n;
}
function patternInScope(n, t) {
  return listInScope(n, t.inConstruct, !0) && !listInScope(n, t.notInConstruct, !1);
}
function listInScope(n, t, g) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return g;
  let d = -1;
  for (; ++d < t.length; )
    if (n.includes(t[d]))
      return !0;
  return !1;
}
function hardBreak(n, t, g, d) {
  let k = -1;
  for (; ++k < g.unsafe.length; )
    if (g.unsafe[k].character === `
` && patternInScope(g.stack, g.unsafe[k]))
      return /[ \t]/.test(d.before) ? "" : " ";
  return `\\
`;
}
function longestStreak(n, t) {
  const g = String(n);
  let d = g.indexOf(t), k = d, H = 0, AA = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; d !== -1; )
    d === k ? ++H > AA && (AA = H) : H = 1, k = d + t.length, d = g.indexOf(t, k);
  return AA;
}
function formatCodeAsIndented(n, t) {
  return !!(t.options.fences === !1 && n.value && // If there’s no info…
  !n.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(n.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(n.value));
}
function checkFence(n) {
  const t = n.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function code$2(n, t, g, d) {
  const k = checkFence(g), H = n.value || "", AA = k === "`" ? "GraveAccent" : "Tilde";
  if (formatCodeAsIndented(n, g)) {
    const eA = g.enter("codeIndented"), iA = g.indentLines(H, map$4);
    return eA(), iA;
  }
  const gA = g.createTracker(d), IA = k.repeat(Math.max(longestStreak(H, k) + 1, 3)), CA = g.enter("codeFenced");
  let BA = gA.move(IA);
  if (n.lang) {
    const eA = g.enter(`codeFencedLang${AA}`);
    BA += gA.move(
      g.safe(n.lang, {
        before: BA,
        after: " ",
        encode: ["`"],
        ...gA.current()
      })
    ), eA();
  }
  if (n.lang && n.meta) {
    const eA = g.enter(`codeFencedMeta${AA}`);
    BA += gA.move(" "), BA += gA.move(
      g.safe(n.meta, {
        before: BA,
        after: `
`,
        encode: ["`"],
        ...gA.current()
      })
    ), eA();
  }
  return BA += gA.move(`
`), H && (BA += gA.move(H + `
`)), BA += gA.move(IA), CA(), BA;
}
function map$4(n, t, g) {
  return (g ? "" : "    ") + n;
}
function checkQuote(n) {
  const t = n.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function definition$2(n, t, g, d) {
  const k = checkQuote(g), H = k === '"' ? "Quote" : "Apostrophe", AA = g.enter("definition");
  let gA = g.enter("label");
  const IA = g.createTracker(d);
  let CA = IA.move("[");
  return CA += IA.move(
    g.safe(g.associationId(n), {
      before: CA,
      after: "]",
      ...IA.current()
    })
  ), CA += IA.move("]: "), gA(), // If there’s no url, or…
  !n.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(n.url) ? (gA = g.enter("destinationLiteral"), CA += IA.move("<"), CA += IA.move(
    g.safe(n.url, { before: CA, after: ">", ...IA.current() })
  ), CA += IA.move(">")) : (gA = g.enter("destinationRaw"), CA += IA.move(
    g.safe(n.url, {
      before: CA,
      after: n.title ? " " : `
`,
      ...IA.current()
    })
  )), gA(), n.title && (gA = g.enter(`title${H}`), CA += IA.move(" " + k), CA += IA.move(
    g.safe(n.title, {
      before: CA,
      after: k,
      ...IA.current()
    })
  ), CA += IA.move(k), gA()), AA(), CA;
}
function checkEmphasis(n) {
  const t = n.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
function encodeCharacterReference(n) {
  return "&#x" + n.toString(16).toUpperCase() + ";";
}
function encodeInfo(n, t, g) {
  const d = classifyCharacter(n), k = classifyCharacter(t);
  return d === void 0 ? k === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    g === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : k === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : d === 1 ? k === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : k === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : k === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : k === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
emphasis.peek = emphasisPeek;
function emphasis(n, t, g, d) {
  const k = checkEmphasis(g), H = g.enter("emphasis"), AA = g.createTracker(d), gA = AA.move(k);
  let IA = AA.move(
    g.containerPhrasing(n, {
      after: k,
      before: gA,
      ...AA.current()
    })
  );
  const CA = IA.charCodeAt(0), BA = encodeInfo(
    d.before.charCodeAt(d.before.length - 1),
    CA,
    k
  );
  BA.inside && (IA = encodeCharacterReference(CA) + IA.slice(1));
  const eA = IA.charCodeAt(IA.length - 1), iA = encodeInfo(d.after.charCodeAt(0), eA, k);
  iA.inside && (IA = IA.slice(0, -1) + encodeCharacterReference(eA));
  const QA = AA.move(k);
  return H(), g.attentionEncodeSurroundingInfo = {
    after: iA.outside,
    before: BA.outside
  }, gA + IA + QA;
}
function emphasisPeek(n, t, g) {
  return g.options.emphasis || "*";
}
function formatHeadingAsSetext(n, t) {
  let g = !1;
  return visit$1(n, function(d) {
    if ("value" in d && /\r?\n|\r/.test(d.value) || d.type === "break")
      return g = !0, EXIT;
  }), !!((!n.depth || n.depth < 3) && toString$6(n) && (t.options.setext || g));
}
function heading(n, t, g, d) {
  const k = Math.max(Math.min(6, n.depth || 1), 1), H = g.createTracker(d);
  if (formatHeadingAsSetext(n, g)) {
    const BA = g.enter("headingSetext"), eA = g.enter("phrasing"), iA = g.containerPhrasing(n, {
      ...H.current(),
      before: `
`,
      after: `
`
    });
    return eA(), BA(), iA + `
` + (k === 1 ? "=" : "-").repeat(
      // The whole size…
      iA.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(iA.lastIndexOf("\r"), iA.lastIndexOf(`
`)) + 1)
    );
  }
  const AA = "#".repeat(k), gA = g.enter("headingAtx"), IA = g.enter("phrasing");
  H.move(AA + " ");
  let CA = g.containerPhrasing(n, {
    before: "# ",
    after: `
`,
    ...H.current()
  });
  return /^[\t ]/.test(CA) && (CA = encodeCharacterReference(CA.charCodeAt(0)) + CA.slice(1)), CA = CA ? AA + " " + CA : AA, g.options.closeAtx && (CA += " " + AA), IA(), gA(), CA;
}
html$1.peek = htmlPeek;
function html$1(n) {
  return n.value || "";
}
function htmlPeek() {
  return "<";
}
image$2.peek = imagePeek;
function image$2(n, t, g, d) {
  const k = checkQuote(g), H = k === '"' ? "Quote" : "Apostrophe", AA = g.enter("image");
  let gA = g.enter("label");
  const IA = g.createTracker(d);
  let CA = IA.move("![");
  return CA += IA.move(
    g.safe(n.alt, { before: CA, after: "]", ...IA.current() })
  ), CA += IA.move("]("), gA(), // If there’s no url but there is a title…
  !n.url && n.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(n.url) ? (gA = g.enter("destinationLiteral"), CA += IA.move("<"), CA += IA.move(
    g.safe(n.url, { before: CA, after: ">", ...IA.current() })
  ), CA += IA.move(">")) : (gA = g.enter("destinationRaw"), CA += IA.move(
    g.safe(n.url, {
      before: CA,
      after: n.title ? " " : ")",
      ...IA.current()
    })
  )), gA(), n.title && (gA = g.enter(`title${H}`), CA += IA.move(" " + k), CA += IA.move(
    g.safe(n.title, {
      before: CA,
      after: k,
      ...IA.current()
    })
  ), CA += IA.move(k), gA()), CA += IA.move(")"), AA(), CA;
}
function imagePeek() {
  return "!";
}
imageReference.peek = imageReferencePeek;
function imageReference(n, t, g, d) {
  const k = n.referenceType, H = g.enter("imageReference");
  let AA = g.enter("label");
  const gA = g.createTracker(d);
  let IA = gA.move("![");
  const CA = g.safe(n.alt, {
    before: IA,
    after: "]",
    ...gA.current()
  });
  IA += gA.move(CA + "]["), AA();
  const BA = g.stack;
  g.stack = [], AA = g.enter("reference");
  const eA = g.safe(g.associationId(n), {
    before: IA,
    after: "]",
    ...gA.current()
  });
  return AA(), g.stack = BA, H(), k === "full" || !CA || CA !== eA ? IA += gA.move(eA + "]") : k === "shortcut" ? IA = IA.slice(0, -1) : IA += gA.move("]"), IA;
}
function imageReferencePeek() {
  return "!";
}
inlineCode.peek = inlineCodePeek;
function inlineCode(n, t, g) {
  let d = n.value || "", k = "`", H = -1;
  for (; new RegExp("(^|[^`])" + k + "([^`]|$)").test(d); )
    k += "`";
  for (/[^ \r\n]/.test(d) && (/^[ \r\n]/.test(d) && /[ \r\n]$/.test(d) || /^`|`$/.test(d)) && (d = " " + d + " "); ++H < g.unsafe.length; ) {
    const AA = g.unsafe[H], gA = g.compilePattern(AA);
    let IA;
    if (AA.atBreak)
      for (; IA = gA.exec(d); ) {
        let CA = IA.index;
        d.charCodeAt(CA) === 10 && d.charCodeAt(CA - 1) === 13 && CA--, d = d.slice(0, CA) + " " + d.slice(IA.index + 1);
      }
  }
  return k + d + k;
}
function inlineCodePeek() {
  return "`";
}
function formatLinkAsAutolink(n, t) {
  const g = toString$6(n);
  return !!(!t.options.resourceLink && // If there’s a url…
  n.url && // And there’s a no title…
  !n.title && // And the content of `node` is a single text node…
  n.children && n.children.length === 1 && n.children[0].type === "text" && // And if the url is the same as the content…
  (g === n.url || "mailto:" + g === n.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(n.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(n.url));
}
link$1.peek = linkPeek;
function link$1(n, t, g, d) {
  const k = checkQuote(g), H = k === '"' ? "Quote" : "Apostrophe", AA = g.createTracker(d);
  let gA, IA;
  if (formatLinkAsAutolink(n, g)) {
    const BA = g.stack;
    g.stack = [], gA = g.enter("autolink");
    let eA = AA.move("<");
    return eA += AA.move(
      g.containerPhrasing(n, {
        before: eA,
        after: ">",
        ...AA.current()
      })
    ), eA += AA.move(">"), gA(), g.stack = BA, eA;
  }
  gA = g.enter("link"), IA = g.enter("label");
  let CA = AA.move("[");
  return CA += AA.move(
    g.containerPhrasing(n, {
      before: CA,
      after: "](",
      ...AA.current()
    })
  ), CA += AA.move("]("), IA(), // If there’s no url but there is a title…
  !n.url && n.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(n.url) ? (IA = g.enter("destinationLiteral"), CA += AA.move("<"), CA += AA.move(
    g.safe(n.url, { before: CA, after: ">", ...AA.current() })
  ), CA += AA.move(">")) : (IA = g.enter("destinationRaw"), CA += AA.move(
    g.safe(n.url, {
      before: CA,
      after: n.title ? " " : ")",
      ...AA.current()
    })
  )), IA(), n.title && (IA = g.enter(`title${H}`), CA += AA.move(" " + k), CA += AA.move(
    g.safe(n.title, {
      before: CA,
      after: k,
      ...AA.current()
    })
  ), CA += AA.move(k), IA()), CA += AA.move(")"), gA(), CA;
}
function linkPeek(n, t, g) {
  return formatLinkAsAutolink(n, g) ? "<" : "[";
}
linkReference.peek = linkReferencePeek;
function linkReference(n, t, g, d) {
  const k = n.referenceType, H = g.enter("linkReference");
  let AA = g.enter("label");
  const gA = g.createTracker(d);
  let IA = gA.move("[");
  const CA = g.containerPhrasing(n, {
    before: IA,
    after: "]",
    ...gA.current()
  });
  IA += gA.move(CA + "]["), AA();
  const BA = g.stack;
  g.stack = [], AA = g.enter("reference");
  const eA = g.safe(g.associationId(n), {
    before: IA,
    after: "]",
    ...gA.current()
  });
  return AA(), g.stack = BA, H(), k === "full" || !CA || CA !== eA ? IA += gA.move(eA + "]") : k === "shortcut" ? IA = IA.slice(0, -1) : IA += gA.move("]"), IA;
}
function linkReferencePeek() {
  return "[";
}
function checkBullet(n) {
  const t = n.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function checkBulletOther(n) {
  const t = checkBullet(n), g = n.options.bulletOther;
  if (!g)
    return t === "*" ? "-" : "*";
  if (g !== "*" && g !== "+" && g !== "-")
    throw new Error(
      "Cannot serialize items with `" + g + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (g === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + g + "`) to be different"
    );
  return g;
}
function checkBulletOrdered(n) {
  const t = n.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function checkRule(n) {
  const t = n.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function list(n, t, g, d) {
  const k = g.enter("list"), H = g.bulletCurrent;
  let AA = n.ordered ? checkBulletOrdered(g) : checkBullet(g);
  const gA = n.ordered ? AA === "." ? ")" : "." : checkBulletOther(g);
  let IA = t && g.bulletLastUsed ? AA === g.bulletLastUsed : !1;
  if (!n.ordered) {
    const BA = n.children ? n.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (AA === "*" || AA === "-") && // Empty first list item:
      BA && (!BA.children || !BA.children[0]) && // Directly in two other list items:
      g.stack[g.stack.length - 1] === "list" && g.stack[g.stack.length - 2] === "listItem" && g.stack[g.stack.length - 3] === "list" && g.stack[g.stack.length - 4] === "listItem" && // That are each the first child.
      g.indexStack[g.indexStack.length - 1] === 0 && g.indexStack[g.indexStack.length - 2] === 0 && g.indexStack[g.indexStack.length - 3] === 0 && (IA = !0), checkRule(g) === AA && BA
    ) {
      let eA = -1;
      for (; ++eA < n.children.length; ) {
        const iA = n.children[eA];
        if (iA && iA.type === "listItem" && iA.children && iA.children[0] && iA.children[0].type === "thematicBreak") {
          IA = !0;
          break;
        }
      }
    }
  }
  IA && (AA = gA), g.bulletCurrent = AA;
  const CA = g.containerFlow(n, d);
  return g.bulletLastUsed = AA, g.bulletCurrent = H, k(), CA;
}
function checkListItemIndent(n) {
  const t = n.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function listItem(n, t, g, d) {
  const k = checkListItemIndent(g);
  let H = g.bulletCurrent || checkBullet(g);
  t && t.type === "list" && t.ordered && (H = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (g.options.incrementListMarker === !1 ? 0 : t.children.indexOf(n)) + H);
  let AA = H.length + 1;
  (k === "tab" || k === "mixed" && (t && t.type === "list" && t.spread || n.spread)) && (AA = Math.ceil(AA / 4) * 4);
  const gA = g.createTracker(d);
  gA.move(H + " ".repeat(AA - H.length)), gA.shift(AA);
  const IA = g.enter("listItem"), CA = g.indentLines(
    g.containerFlow(n, gA.current()),
    BA
  );
  return IA(), CA;
  function BA(eA, iA, QA) {
    return iA ? (QA ? "" : " ".repeat(AA)) + eA : (QA ? H : H + " ".repeat(AA - H.length)) + eA;
  }
}
function paragraph(n, t, g, d) {
  const k = g.enter("paragraph"), H = g.enter("phrasing"), AA = g.containerPhrasing(n, d);
  return H(), k(), AA;
}
const phrasing = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  convert([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function root$3(n, t, g, d) {
  return (n.children.some(function(AA) {
    return phrasing(AA);
  }) ? g.containerPhrasing : g.containerFlow).call(g, n, d);
}
function checkStrong(n) {
  const t = n.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
strong.peek = strongPeek;
function strong(n, t, g, d) {
  const k = checkStrong(g), H = g.enter("strong"), AA = g.createTracker(d), gA = AA.move(k + k);
  let IA = AA.move(
    g.containerPhrasing(n, {
      after: k,
      before: gA,
      ...AA.current()
    })
  );
  const CA = IA.charCodeAt(0), BA = encodeInfo(
    d.before.charCodeAt(d.before.length - 1),
    CA,
    k
  );
  BA.inside && (IA = encodeCharacterReference(CA) + IA.slice(1));
  const eA = IA.charCodeAt(IA.length - 1), iA = encodeInfo(d.after.charCodeAt(0), eA, k);
  iA.inside && (IA = IA.slice(0, -1) + encodeCharacterReference(eA));
  const QA = AA.move(k + k);
  return H(), g.attentionEncodeSurroundingInfo = {
    after: iA.outside,
    before: BA.outside
  }, gA + IA + QA;
}
function strongPeek(n, t, g) {
  return g.options.strong || "*";
}
function text$4(n, t, g, d) {
  return g.safe(n.value, d);
}
function checkRuleRepetition(n) {
  const t = n.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function thematicBreak(n, t, g) {
  const d = (checkRule(g) + (g.options.ruleSpaces ? " " : "")).repeat(checkRuleRepetition(g));
  return g.options.ruleSpaces ? d.slice(0, -1) : d;
}
const handle = {
  blockquote,
  break: hardBreak,
  code: code$2,
  definition: definition$2,
  emphasis,
  hardBreak,
  heading,
  html: html$1,
  image: image$2,
  imageReference,
  inlineCode,
  link: link$1,
  linkReference,
  list,
  listItem,
  paragraph,
  root: root$3,
  strong,
  text: text$4,
  thematicBreak
};
function gfmTableFromMarkdown() {
  return {
    enter: {
      table: enterTable,
      tableData: enterCell,
      tableHeader: enterCell,
      tableRow: enterRow
    },
    exit: {
      codeText: exitCodeText,
      table: exitTable,
      tableData: exit,
      tableHeader: exit,
      tableRow: exit
    }
  };
}
function enterTable(n) {
  const t = n._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(g) {
        return g === "none" ? null : g;
      }),
      children: []
    },
    n
  ), this.data.inTable = !0;
}
function exitTable(n) {
  this.exit(n), this.data.inTable = void 0;
}
function enterRow(n) {
  this.enter({ type: "tableRow", children: [] }, n);
}
function exit(n) {
  this.exit(n);
}
function enterCell(n) {
  this.enter({ type: "tableCell", children: [] }, n);
}
function exitCodeText(n) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, replace$2));
  const g = this.stack[this.stack.length - 1];
  g.type, g.value = t, this.exit(n);
}
function replace$2(n, t) {
  return t === "|" ? t : n;
}
function gfmTableToMarkdown(n) {
  const t = n || {}, g = t.tableCellPadding, d = t.tablePipeAlign, k = t.stringLength, H = g ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: iA,
      table: AA,
      tableCell: IA,
      tableRow: gA
    }
  };
  function AA(QA, tA, oA, EA) {
    return CA(BA(QA, oA, EA), QA.align);
  }
  function gA(QA, tA, oA, EA) {
    const aA = eA(QA, oA, EA), nA = CA([aA]);
    return nA.slice(0, nA.indexOf(`
`));
  }
  function IA(QA, tA, oA, EA) {
    const aA = oA.enter("tableCell"), nA = oA.enter("phrasing"), lA = oA.containerPhrasing(QA, {
      ...EA,
      before: H,
      after: H
    });
    return nA(), aA(), lA;
  }
  function CA(QA, tA) {
    return markdownTable(QA, {
      align: tA,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: d,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: g,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: k
    });
  }
  function BA(QA, tA, oA) {
    const EA = QA.children;
    let aA = -1;
    const nA = [], lA = tA.enter("table");
    for (; ++aA < EA.length; )
      nA[aA] = eA(EA[aA], tA, oA);
    return lA(), nA;
  }
  function eA(QA, tA, oA) {
    const EA = QA.children;
    let aA = -1;
    const nA = [], lA = tA.enter("tableRow");
    for (; ++aA < EA.length; )
      nA[aA] = IA(EA[aA], QA, tA, oA);
    return lA(), nA;
  }
  function iA(QA, tA, oA) {
    let EA = handle.inlineCode(QA, tA, oA);
    return oA.stack.includes("tableCell") && (EA = EA.replace(/\|/g, "\\$&")), EA;
  }
}
function gfmTaskListItemFromMarkdown() {
  return {
    exit: {
      taskListCheckValueChecked: exitCheck,
      taskListCheckValueUnchecked: exitCheck,
      paragraph: exitParagraphWithTaskListItem
    }
  };
}
function gfmTaskListItemToMarkdown() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: listItemWithTaskListItem }
  };
}
function exitCheck(n) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = n.type === "taskListCheckValueChecked";
}
function exitParagraphWithTaskListItem(n) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const g = this.stack[this.stack.length - 1];
    g.type;
    const d = g.children[0];
    if (d && d.type === "text") {
      const k = t.children;
      let H = -1, AA;
      for (; ++H < k.length; ) {
        const gA = k[H];
        if (gA.type === "paragraph") {
          AA = gA;
          break;
        }
      }
      AA === g && (d.value = d.value.slice(1), d.value.length === 0 ? g.children.shift() : g.position && d.position && typeof d.position.start.offset == "number" && (d.position.start.column++, d.position.start.offset++, g.position.start = Object.assign({}, d.position.start)));
    }
  }
  this.exit(n);
}
function listItemWithTaskListItem(n, t, g, d) {
  const k = n.children[0], H = typeof n.checked == "boolean" && k && k.type === "paragraph", AA = "[" + (n.checked ? "x" : " ") + "] ", gA = g.createTracker(d);
  H && gA.move(AA);
  let IA = handle.listItem(n, t, g, {
    ...d,
    ...gA.current()
  });
  return H && (IA = IA.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, CA)), IA;
  function CA(BA) {
    return BA + AA;
  }
}
function gfmFromMarkdown() {
  return [
    gfmAutolinkLiteralFromMarkdown(),
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown(),
    gfmTableFromMarkdown(),
    gfmTaskListItemFromMarkdown()
  ];
}
function gfmToMarkdown(n) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown(),
      gfmFootnoteToMarkdown(n),
      gfmStrikethroughToMarkdown(),
      gfmTableToMarkdown(n),
      gfmTaskListItemToMarkdown()
    ]
  };
}
const wwwPrefix = {
  tokenize: tokenizeWwwPrefix,
  partial: !0
}, domain$3 = {
  tokenize: tokenizeDomain,
  partial: !0
}, path$5 = {
  tokenize: tokenizePath,
  partial: !0
}, trail$3 = {
  tokenize: tokenizeTrail,
  partial: !0
}, emailDomainDotTrail = {
  tokenize: tokenizeEmailDomainDotTrail,
  partial: !0
}, wwwAutolink = {
  name: "wwwAutolink",
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
}, protocolAutolink = {
  name: "protocolAutolink",
  tokenize: tokenizeProtocolAutolink,
  previous: previousProtocol
}, emailAutolink = {
  name: "emailAutolink",
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
}, text$3 = {};
function gfmAutolinkLiteral() {
  return {
    text: text$3
  };
}
let code$1 = 48;
for (; code$1 < 123; )
  text$3[code$1] = emailAutolink, code$1++, code$1 === 58 ? code$1 = 65 : code$1 === 91 && (code$1 = 97);
text$3[43] = emailAutolink;
text$3[45] = emailAutolink;
text$3[46] = emailAutolink;
text$3[95] = emailAutolink;
text$3[72] = [emailAutolink, protocolAutolink];
text$3[104] = [emailAutolink, protocolAutolink];
text$3[87] = [emailAutolink, wwwAutolink];
text$3[119] = [emailAutolink, wwwAutolink];
function tokenizeEmailAutolink(n, t, g) {
  const d = this;
  let k, H;
  return AA;
  function AA(eA) {
    return !gfmAtext(eA) || !previousEmail.call(d, d.previous) || previousUnbalanced(d.events) ? g(eA) : (n.enter("literalAutolink"), n.enter("literalAutolinkEmail"), gA(eA));
  }
  function gA(eA) {
    return gfmAtext(eA) ? (n.consume(eA), gA) : eA === 64 ? (n.consume(eA), IA) : g(eA);
  }
  function IA(eA) {
    return eA === 46 ? n.check(emailDomainDotTrail, BA, CA)(eA) : eA === 45 || eA === 95 || asciiAlphanumeric(eA) ? (H = !0, n.consume(eA), IA) : BA(eA);
  }
  function CA(eA) {
    return n.consume(eA), k = !0, IA;
  }
  function BA(eA) {
    return H && k && asciiAlpha(d.previous) ? (n.exit("literalAutolinkEmail"), n.exit("literalAutolink"), t(eA)) : g(eA);
  }
}
function tokenizeWwwAutolink(n, t, g) {
  const d = this;
  return k;
  function k(AA) {
    return AA !== 87 && AA !== 119 || !previousWww.call(d, d.previous) || previousUnbalanced(d.events) ? g(AA) : (n.enter("literalAutolink"), n.enter("literalAutolinkWww"), n.check(wwwPrefix, n.attempt(domain$3, n.attempt(path$5, H), g), g)(AA));
  }
  function H(AA) {
    return n.exit("literalAutolinkWww"), n.exit("literalAutolink"), t(AA);
  }
}
function tokenizeProtocolAutolink(n, t, g) {
  const d = this;
  let k = "", H = !1;
  return AA;
  function AA(eA) {
    return (eA === 72 || eA === 104) && previousProtocol.call(d, d.previous) && !previousUnbalanced(d.events) ? (n.enter("literalAutolink"), n.enter("literalAutolinkHttp"), k += String.fromCodePoint(eA), n.consume(eA), gA) : g(eA);
  }
  function gA(eA) {
    if (asciiAlpha(eA) && k.length < 5)
      return k += String.fromCodePoint(eA), n.consume(eA), gA;
    if (eA === 58) {
      const iA = k.toLowerCase();
      if (iA === "http" || iA === "https")
        return n.consume(eA), IA;
    }
    return g(eA);
  }
  function IA(eA) {
    return eA === 47 ? (n.consume(eA), H ? CA : (H = !0, IA)) : g(eA);
  }
  function CA(eA) {
    return eA === null || asciiControl(eA) || markdownLineEndingOrSpace(eA) || unicodeWhitespace(eA) || unicodePunctuation(eA) ? g(eA) : n.attempt(domain$3, n.attempt(path$5, BA), g)(eA);
  }
  function BA(eA) {
    return n.exit("literalAutolinkHttp"), n.exit("literalAutolink"), t(eA);
  }
}
function tokenizeWwwPrefix(n, t, g) {
  let d = 0;
  return k;
  function k(AA) {
    return (AA === 87 || AA === 119) && d < 3 ? (d++, n.consume(AA), k) : AA === 46 && d === 3 ? (n.consume(AA), H) : g(AA);
  }
  function H(AA) {
    return AA === null ? g(AA) : t(AA);
  }
}
function tokenizeDomain(n, t, g) {
  let d, k, H;
  return AA;
  function AA(CA) {
    return CA === 46 || CA === 95 ? n.check(trail$3, IA, gA)(CA) : CA === null || markdownLineEndingOrSpace(CA) || unicodeWhitespace(CA) || CA !== 45 && unicodePunctuation(CA) ? IA(CA) : (H = !0, n.consume(CA), AA);
  }
  function gA(CA) {
    return CA === 95 ? d = !0 : (k = d, d = void 0), n.consume(CA), AA;
  }
  function IA(CA) {
    return k || d || !H ? g(CA) : t(CA);
  }
}
function tokenizePath(n, t) {
  let g = 0, d = 0;
  return k;
  function k(AA) {
    return AA === 40 ? (g++, n.consume(AA), k) : AA === 41 && d < g ? H(AA) : AA === 33 || AA === 34 || AA === 38 || AA === 39 || AA === 41 || AA === 42 || AA === 44 || AA === 46 || AA === 58 || AA === 59 || AA === 60 || AA === 63 || AA === 93 || AA === 95 || AA === 126 ? n.check(trail$3, t, H)(AA) : AA === null || markdownLineEndingOrSpace(AA) || unicodeWhitespace(AA) ? t(AA) : (n.consume(AA), k);
  }
  function H(AA) {
    return AA === 41 && d++, n.consume(AA), k;
  }
}
function tokenizeTrail(n, t, g) {
  return d;
  function d(gA) {
    return gA === 33 || gA === 34 || gA === 39 || gA === 41 || gA === 42 || gA === 44 || gA === 46 || gA === 58 || gA === 59 || gA === 63 || gA === 95 || gA === 126 ? (n.consume(gA), d) : gA === 38 ? (n.consume(gA), H) : gA === 93 ? (n.consume(gA), k) : (
      // `<` is an end.
      gA === 60 || // So is whitespace.
      gA === null || markdownLineEndingOrSpace(gA) || unicodeWhitespace(gA) ? t(gA) : g(gA)
    );
  }
  function k(gA) {
    return gA === null || gA === 40 || gA === 91 || markdownLineEndingOrSpace(gA) || unicodeWhitespace(gA) ? t(gA) : d(gA);
  }
  function H(gA) {
    return asciiAlpha(gA) ? AA(gA) : g(gA);
  }
  function AA(gA) {
    return gA === 59 ? (n.consume(gA), d) : asciiAlpha(gA) ? (n.consume(gA), AA) : g(gA);
  }
}
function tokenizeEmailDomainDotTrail(n, t, g) {
  return d;
  function d(H) {
    return n.consume(H), k;
  }
  function k(H) {
    return asciiAlphanumeric(H) ? g(H) : t(H);
  }
}
function previousWww(n) {
  return n === null || n === 40 || n === 42 || n === 95 || n === 91 || n === 93 || n === 126 || markdownLineEndingOrSpace(n);
}
function previousProtocol(n) {
  return !asciiAlpha(n);
}
function previousEmail(n) {
  return !(n === 47 || gfmAtext(n));
}
function gfmAtext(n) {
  return n === 43 || n === 45 || n === 46 || n === 95 || asciiAlphanumeric(n);
}
function previousUnbalanced(n) {
  let t = n.length, g = !1;
  for (; t--; ) {
    const d = n[t][1];
    if ((d.type === "labelLink" || d.type === "labelImage") && !d._balanced) {
      g = !0;
      break;
    }
    if (d._gfmAutolinkLiteralWalkedInto) {
      g = !1;
      break;
    }
  }
  return n.length > 0 && !g && (n[n.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), g;
}
const indent = {
  tokenize: tokenizeIndent,
  partial: !0
};
function gfmFootnote() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: tokenizeGfmFootnoteCall
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  };
}
function tokenizePotentialGfmFootnoteCall(n, t, g) {
  const d = this;
  let k = d.events.length;
  const H = d.parser.gfmFootnotes || (d.parser.gfmFootnotes = []);
  let AA;
  for (; k--; ) {
    const IA = d.events[k][1];
    if (IA.type === "labelImage") {
      AA = IA;
      break;
    }
    if (IA.type === "gfmFootnoteCall" || IA.type === "labelLink" || IA.type === "label" || IA.type === "image" || IA.type === "link")
      break;
  }
  return gA;
  function gA(IA) {
    if (!AA || !AA._balanced)
      return g(IA);
    const CA = normalizeIdentifier(d.sliceSerialize({
      start: AA.end,
      end: d.now()
    }));
    return CA.codePointAt(0) !== 94 || !H.includes(CA.slice(1)) ? g(IA) : (n.enter("gfmFootnoteCallLabelMarker"), n.consume(IA), n.exit("gfmFootnoteCallLabelMarker"), t(IA));
  }
}
function resolveToPotentialGfmFootnoteCall(n, t) {
  let g = n.length;
  for (; g--; )
    if (n[g][1].type === "labelImage" && n[g][0] === "enter") {
      n[g][1];
      break;
    }
  n[g + 1][1].type = "data", n[g + 3][1].type = "gfmFootnoteCallLabelMarker";
  const d = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, n[g + 3][1].start),
    end: Object.assign({}, n[n.length - 1][1].end)
  }, k = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, n[g + 3][1].end),
    end: Object.assign({}, n[g + 3][1].end)
  };
  k.end.column++, k.end.offset++, k.end._bufferIndex++;
  const H = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, k.end),
    end: Object.assign({}, n[n.length - 1][1].start)
  }, AA = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, H.start),
    end: Object.assign({}, H.end)
  }, gA = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    n[g + 1],
    n[g + 2],
    ["enter", d, t],
    // The `[`
    n[g + 3],
    n[g + 4],
    // The `^`.
    ["enter", k, t],
    ["exit", k, t],
    // Everything in between.
    ["enter", H, t],
    ["enter", AA, t],
    ["exit", AA, t],
    ["exit", H, t],
    // The ending (`]`, properly parsed and labelled).
    n[n.length - 2],
    n[n.length - 1],
    ["exit", d, t]
  ];
  return n.splice(g, n.length - g + 1, ...gA), n;
}
function tokenizeGfmFootnoteCall(n, t, g) {
  const d = this, k = d.parser.gfmFootnotes || (d.parser.gfmFootnotes = []);
  let H = 0, AA;
  return gA;
  function gA(eA) {
    return n.enter("gfmFootnoteCall"), n.enter("gfmFootnoteCallLabelMarker"), n.consume(eA), n.exit("gfmFootnoteCallLabelMarker"), IA;
  }
  function IA(eA) {
    return eA !== 94 ? g(eA) : (n.enter("gfmFootnoteCallMarker"), n.consume(eA), n.exit("gfmFootnoteCallMarker"), n.enter("gfmFootnoteCallString"), n.enter("chunkString").contentType = "string", CA);
  }
  function CA(eA) {
    if (
      // Too long.
      H > 999 || // Closing brace with nothing.
      eA === 93 && !AA || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      eA === null || eA === 91 || markdownLineEndingOrSpace(eA)
    )
      return g(eA);
    if (eA === 93) {
      n.exit("chunkString");
      const iA = n.exit("gfmFootnoteCallString");
      return k.includes(normalizeIdentifier(d.sliceSerialize(iA))) ? (n.enter("gfmFootnoteCallLabelMarker"), n.consume(eA), n.exit("gfmFootnoteCallLabelMarker"), n.exit("gfmFootnoteCall"), t) : g(eA);
    }
    return markdownLineEndingOrSpace(eA) || (AA = !0), H++, n.consume(eA), eA === 92 ? BA : CA;
  }
  function BA(eA) {
    return eA === 91 || eA === 92 || eA === 93 ? (n.consume(eA), H++, CA) : CA(eA);
  }
}
function tokenizeDefinitionStart(n, t, g) {
  const d = this, k = d.parser.gfmFootnotes || (d.parser.gfmFootnotes = []);
  let H, AA = 0, gA;
  return IA;
  function IA(tA) {
    return n.enter("gfmFootnoteDefinition")._container = !0, n.enter("gfmFootnoteDefinitionLabel"), n.enter("gfmFootnoteDefinitionLabelMarker"), n.consume(tA), n.exit("gfmFootnoteDefinitionLabelMarker"), CA;
  }
  function CA(tA) {
    return tA === 94 ? (n.enter("gfmFootnoteDefinitionMarker"), n.consume(tA), n.exit("gfmFootnoteDefinitionMarker"), n.enter("gfmFootnoteDefinitionLabelString"), n.enter("chunkString").contentType = "string", BA) : g(tA);
  }
  function BA(tA) {
    if (
      // Too long.
      AA > 999 || // Closing brace with nothing.
      tA === 93 && !gA || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      tA === null || tA === 91 || markdownLineEndingOrSpace(tA)
    )
      return g(tA);
    if (tA === 93) {
      n.exit("chunkString");
      const oA = n.exit("gfmFootnoteDefinitionLabelString");
      return H = normalizeIdentifier(d.sliceSerialize(oA)), n.enter("gfmFootnoteDefinitionLabelMarker"), n.consume(tA), n.exit("gfmFootnoteDefinitionLabelMarker"), n.exit("gfmFootnoteDefinitionLabel"), iA;
    }
    return markdownLineEndingOrSpace(tA) || (gA = !0), AA++, n.consume(tA), tA === 92 ? eA : BA;
  }
  function eA(tA) {
    return tA === 91 || tA === 92 || tA === 93 ? (n.consume(tA), AA++, BA) : BA(tA);
  }
  function iA(tA) {
    return tA === 58 ? (n.enter("definitionMarker"), n.consume(tA), n.exit("definitionMarker"), k.includes(H) || k.push(H), factorySpace(n, QA, "gfmFootnoteDefinitionWhitespace")) : g(tA);
  }
  function QA(tA) {
    return t(tA);
  }
}
function tokenizeDefinitionContinuation(n, t, g) {
  return n.check(blankLine, t, n.attempt(indent, t, g));
}
function gfmFootnoteDefinitionEnd(n) {
  n.exit("gfmFootnoteDefinition");
}
function tokenizeIndent(n, t, g) {
  const d = this;
  return factorySpace(n, k, "gfmFootnoteDefinitionIndent", 5);
  function k(H) {
    const AA = d.events[d.events.length - 1];
    return AA && AA[1].type === "gfmFootnoteDefinitionIndent" && AA[2].sliceSerialize(AA[1], !0).length === 4 ? t(H) : g(H);
  }
}
function gfmStrikethrough(n) {
  let g = (n || {}).singleTilde;
  const d = {
    name: "strikethrough",
    tokenize: H,
    resolveAll: k
  };
  return g == null && (g = !0), {
    text: {
      126: d
    },
    insideSpan: {
      null: [d]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function k(AA, gA) {
    let IA = -1;
    for (; ++IA < AA.length; )
      if (AA[IA][0] === "enter" && AA[IA][1].type === "strikethroughSequenceTemporary" && AA[IA][1]._close) {
        let CA = IA;
        for (; CA--; )
          if (AA[CA][0] === "exit" && AA[CA][1].type === "strikethroughSequenceTemporary" && AA[CA][1]._open && // If the sizes are the same:
          AA[IA][1].end.offset - AA[IA][1].start.offset === AA[CA][1].end.offset - AA[CA][1].start.offset) {
            AA[IA][1].type = "strikethroughSequence", AA[CA][1].type = "strikethroughSequence";
            const BA = {
              type: "strikethrough",
              start: Object.assign({}, AA[CA][1].start),
              end: Object.assign({}, AA[IA][1].end)
            }, eA = {
              type: "strikethroughText",
              start: Object.assign({}, AA[CA][1].end),
              end: Object.assign({}, AA[IA][1].start)
            }, iA = [["enter", BA, gA], ["enter", AA[CA][1], gA], ["exit", AA[CA][1], gA], ["enter", eA, gA]], QA = gA.parser.constructs.insideSpan.null;
            QA && splice$1(iA, iA.length, 0, resolveAll(QA, AA.slice(CA + 1, IA), gA)), splice$1(iA, iA.length, 0, [["exit", eA, gA], ["enter", AA[IA][1], gA], ["exit", AA[IA][1], gA], ["exit", BA, gA]]), splice$1(AA, CA - 1, IA - CA + 3, iA), IA = CA + iA.length - 2;
            break;
          }
      }
    for (IA = -1; ++IA < AA.length; )
      AA[IA][1].type === "strikethroughSequenceTemporary" && (AA[IA][1].type = "data");
    return AA;
  }
  function H(AA, gA, IA) {
    const CA = this.previous, BA = this.events;
    let eA = 0;
    return iA;
    function iA(tA) {
      return CA === 126 && BA[BA.length - 1][1].type !== "characterEscape" ? IA(tA) : (AA.enter("strikethroughSequenceTemporary"), QA(tA));
    }
    function QA(tA) {
      const oA = classifyCharacter(CA);
      if (tA === 126)
        return eA > 1 ? IA(tA) : (AA.consume(tA), eA++, QA);
      if (eA < 2 && !g) return IA(tA);
      const EA = AA.exit("strikethroughSequenceTemporary"), aA = classifyCharacter(tA);
      return EA._open = !aA || aA === 2 && !!oA, EA._close = !oA || oA === 2 && !!aA, gA(tA);
    }
  }
}
class EditMap {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, g, d) {
    addImplementation(this, t, g, d);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(H, AA) {
      return H[0] - AA[0];
    }), this.map.length === 0)
      return;
    let g = this.map.length;
    const d = [];
    for (; g > 0; )
      g -= 1, d.push(t.slice(this.map[g][0] + this.map[g][1]), this.map[g][2]), t.length = this.map[g][0];
    d.push(t.slice()), t.length = 0;
    let k = d.pop();
    for (; k; ) {
      for (const H of k)
        t.push(H);
      k = d.pop();
    }
    this.map.length = 0;
  }
}
function addImplementation(n, t, g, d) {
  let k = 0;
  if (!(g === 0 && d.length === 0)) {
    for (; k < n.map.length; ) {
      if (n.map[k][0] === t) {
        n.map[k][1] += g, n.map[k][2].push(...d);
        return;
      }
      k += 1;
    }
    n.map.push([t, g, d]);
  }
}
function gfmTableAlign(n, t) {
  let g = !1;
  const d = [];
  for (; t < n.length; ) {
    const k = n[t];
    if (g) {
      if (k[0] === "enter")
        k[1].type === "tableContent" && d.push(n[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (k[1].type === "tableContent") {
        if (n[t - 1][1].type === "tableDelimiterMarker") {
          const H = d.length - 1;
          d[H] = d[H] === "left" ? "center" : "right";
        }
      } else if (k[1].type === "tableDelimiterRow")
        break;
    } else k[0] === "enter" && k[1].type === "tableDelimiterRow" && (g = !0);
    t += 1;
  }
  return d;
}
function gfmTable() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: tokenizeTable,
        resolveAll: resolveTable
      }
    }
  };
}
function tokenizeTable(n, t, g) {
  const d = this;
  let k = 0, H = 0, AA;
  return gA;
  function gA(GA) {
    let DA = d.events.length - 1;
    for (; DA > -1; ) {
      const yA = d.events[DA][1].type;
      if (yA === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      yA === "linePrefix") DA--;
      else break;
    }
    const wA = DA > -1 ? d.events[DA][1].type : null, bA = wA === "tableHead" || wA === "tableRow" ? rA : IA;
    return bA === rA && d.parser.lazy[d.now().line] ? g(GA) : bA(GA);
  }
  function IA(GA) {
    return n.enter("tableHead"), n.enter("tableRow"), CA(GA);
  }
  function CA(GA) {
    return GA === 124 || (AA = !0, H += 1), BA(GA);
  }
  function BA(GA) {
    return GA === null ? g(GA) : markdownLineEnding(GA) ? H > 1 ? (H = 0, d.interrupt = !0, n.exit("tableRow"), n.enter("lineEnding"), n.consume(GA), n.exit("lineEnding"), QA) : g(GA) : markdownSpace(GA) ? factorySpace(n, BA, "whitespace")(GA) : (H += 1, AA && (AA = !1, k += 1), GA === 124 ? (n.enter("tableCellDivider"), n.consume(GA), n.exit("tableCellDivider"), AA = !0, BA) : (n.enter("data"), eA(GA)));
  }
  function eA(GA) {
    return GA === null || GA === 124 || markdownLineEndingOrSpace(GA) ? (n.exit("data"), BA(GA)) : (n.consume(GA), GA === 92 ? iA : eA);
  }
  function iA(GA) {
    return GA === 92 || GA === 124 ? (n.consume(GA), eA) : eA(GA);
  }
  function QA(GA) {
    return d.interrupt = !1, d.parser.lazy[d.now().line] ? g(GA) : (n.enter("tableDelimiterRow"), AA = !1, markdownSpace(GA) ? factorySpace(n, tA, "linePrefix", d.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(GA) : tA(GA));
  }
  function tA(GA) {
    return GA === 45 || GA === 58 ? EA(GA) : GA === 124 ? (AA = !0, n.enter("tableCellDivider"), n.consume(GA), n.exit("tableCellDivider"), oA) : sA(GA);
  }
  function oA(GA) {
    return markdownSpace(GA) ? factorySpace(n, EA, "whitespace")(GA) : EA(GA);
  }
  function EA(GA) {
    return GA === 58 ? (H += 1, AA = !0, n.enter("tableDelimiterMarker"), n.consume(GA), n.exit("tableDelimiterMarker"), aA) : GA === 45 ? (H += 1, aA(GA)) : GA === null || markdownLineEnding(GA) ? cA(GA) : sA(GA);
  }
  function aA(GA) {
    return GA === 45 ? (n.enter("tableDelimiterFiller"), nA(GA)) : sA(GA);
  }
  function nA(GA) {
    return GA === 45 ? (n.consume(GA), nA) : GA === 58 ? (AA = !0, n.exit("tableDelimiterFiller"), n.enter("tableDelimiterMarker"), n.consume(GA), n.exit("tableDelimiterMarker"), lA) : (n.exit("tableDelimiterFiller"), lA(GA));
  }
  function lA(GA) {
    return markdownSpace(GA) ? factorySpace(n, cA, "whitespace")(GA) : cA(GA);
  }
  function cA(GA) {
    return GA === 124 ? tA(GA) : GA === null || markdownLineEnding(GA) ? !AA || k !== H ? sA(GA) : (n.exit("tableDelimiterRow"), n.exit("tableHead"), t(GA)) : sA(GA);
  }
  function sA(GA) {
    return g(GA);
  }
  function rA(GA) {
    return n.enter("tableRow"), uA(GA);
  }
  function uA(GA) {
    return GA === 124 ? (n.enter("tableCellDivider"), n.consume(GA), n.exit("tableCellDivider"), uA) : GA === null || markdownLineEnding(GA) ? (n.exit("tableRow"), t(GA)) : markdownSpace(GA) ? factorySpace(n, uA, "whitespace")(GA) : (n.enter("data"), hA(GA));
  }
  function hA(GA) {
    return GA === null || GA === 124 || markdownLineEndingOrSpace(GA) ? (n.exit("data"), uA(GA)) : (n.consume(GA), GA === 92 ? dA : hA);
  }
  function dA(GA) {
    return GA === 92 || GA === 124 ? (n.consume(GA), hA) : hA(GA);
  }
}
function resolveTable(n, t) {
  let g = -1, d = !0, k = 0, H = [0, 0, 0, 0], AA = [0, 0, 0, 0], gA = !1, IA = 0, CA, BA, eA;
  const iA = new EditMap();
  for (; ++g < n.length; ) {
    const QA = n[g], tA = QA[1];
    QA[0] === "enter" ? tA.type === "tableHead" ? (gA = !1, IA !== 0 && (flushTableEnd(iA, t, IA, CA, BA), BA = void 0, IA = 0), CA = {
      type: "table",
      start: Object.assign({}, tA.start),
      // Note: correct end is set later.
      end: Object.assign({}, tA.end)
    }, iA.add(g, 0, [["enter", CA, t]])) : tA.type === "tableRow" || tA.type === "tableDelimiterRow" ? (d = !0, eA = void 0, H = [0, 0, 0, 0], AA = [0, g + 1, 0, 0], gA && (gA = !1, BA = {
      type: "tableBody",
      start: Object.assign({}, tA.start),
      // Note: correct end is set later.
      end: Object.assign({}, tA.end)
    }, iA.add(g, 0, [["enter", BA, t]])), k = tA.type === "tableDelimiterRow" ? 2 : BA ? 3 : 1) : k && (tA.type === "data" || tA.type === "tableDelimiterMarker" || tA.type === "tableDelimiterFiller") ? (d = !1, AA[2] === 0 && (H[1] !== 0 && (AA[0] = AA[1], eA = flushCell(iA, t, H, k, void 0, eA), H = [0, 0, 0, 0]), AA[2] = g)) : tA.type === "tableCellDivider" && (d ? d = !1 : (H[1] !== 0 && (AA[0] = AA[1], eA = flushCell(iA, t, H, k, void 0, eA)), H = AA, AA = [H[1], g, 0, 0])) : tA.type === "tableHead" ? (gA = !0, IA = g) : tA.type === "tableRow" || tA.type === "tableDelimiterRow" ? (IA = g, H[1] !== 0 ? (AA[0] = AA[1], eA = flushCell(iA, t, H, k, g, eA)) : AA[1] !== 0 && (eA = flushCell(iA, t, AA, k, g, eA)), k = 0) : k && (tA.type === "data" || tA.type === "tableDelimiterMarker" || tA.type === "tableDelimiterFiller") && (AA[3] = g);
  }
  for (IA !== 0 && flushTableEnd(iA, t, IA, CA, BA), iA.consume(t.events), g = -1; ++g < t.events.length; ) {
    const QA = t.events[g];
    QA[0] === "enter" && QA[1].type === "table" && (QA[1]._align = gfmTableAlign(t.events, g));
  }
  return n;
}
function flushCell(n, t, g, d, k, H) {
  const AA = d === 1 ? "tableHeader" : d === 2 ? "tableDelimiter" : "tableData", gA = "tableContent";
  g[0] !== 0 && (H.end = Object.assign({}, getPoint(t.events, g[0])), n.add(g[0], 0, [["exit", H, t]]));
  const IA = getPoint(t.events, g[1]);
  if (H = {
    type: AA,
    start: Object.assign({}, IA),
    // Note: correct end is set later.
    end: Object.assign({}, IA)
  }, n.add(g[1], 0, [["enter", H, t]]), g[2] !== 0) {
    const CA = getPoint(t.events, g[2]), BA = getPoint(t.events, g[3]), eA = {
      type: gA,
      start: Object.assign({}, CA),
      end: Object.assign({}, BA)
    };
    if (n.add(g[2], 0, [["enter", eA, t]]), d !== 2) {
      const iA = t.events[g[2]], QA = t.events[g[3]];
      if (iA[1].end = Object.assign({}, QA[1].end), iA[1].type = "chunkText", iA[1].contentType = "text", g[3] > g[2] + 1) {
        const tA = g[2] + 1, oA = g[3] - g[2] - 1;
        n.add(tA, oA, []);
      }
    }
    n.add(g[3] + 1, 0, [["exit", eA, t]]);
  }
  return k !== void 0 && (H.end = Object.assign({}, getPoint(t.events, k)), n.add(k, 0, [["exit", H, t]]), H = void 0), H;
}
function flushTableEnd(n, t, g, d, k) {
  const H = [], AA = getPoint(t.events, g);
  k && (k.end = Object.assign({}, AA), H.push(["exit", k, t])), d.end = Object.assign({}, AA), H.push(["exit", d, t]), n.add(g + 1, 0, H);
}
function getPoint(n, t) {
  const g = n[t], d = g[0] === "enter" ? "start" : "end";
  return g[1][d];
}
const tasklistCheck = {
  name: "tasklistCheck",
  tokenize: tokenizeTasklistCheck
};
function gfmTaskListItem() {
  return {
    text: {
      91: tasklistCheck
    }
  };
}
function tokenizeTasklistCheck(n, t, g) {
  const d = this;
  return k;
  function k(IA) {
    return (
      // Exit if there’s stuff before.
      d.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !d._gfmTasklistFirstContentOfListItem ? g(IA) : (n.enter("taskListCheck"), n.enter("taskListCheckMarker"), n.consume(IA), n.exit("taskListCheckMarker"), H)
    );
  }
  function H(IA) {
    return markdownLineEndingOrSpace(IA) ? (n.enter("taskListCheckValueUnchecked"), n.consume(IA), n.exit("taskListCheckValueUnchecked"), AA) : IA === 88 || IA === 120 ? (n.enter("taskListCheckValueChecked"), n.consume(IA), n.exit("taskListCheckValueChecked"), AA) : g(IA);
  }
  function AA(IA) {
    return IA === 93 ? (n.enter("taskListCheckMarker"), n.consume(IA), n.exit("taskListCheckMarker"), n.exit("taskListCheck"), gA) : g(IA);
  }
  function gA(IA) {
    return markdownLineEnding(IA) ? t(IA) : markdownSpace(IA) ? n.check({
      tokenize: spaceThenNonSpace
    }, t, g)(IA) : g(IA);
  }
}
function spaceThenNonSpace(n, t, g) {
  return factorySpace(n, d, "whitespace");
  function d(k) {
    return k === null ? g(k) : t(k);
  }
}
function gfm(n) {
  return combineExtensions([
    gfmAutolinkLiteral(),
    gfmFootnote(),
    gfmStrikethrough(n),
    gfmTable(),
    gfmTaskListItem()
  ]);
}
const emptyOptions$1 = {};
function remarkGfm(n) {
  const t = (
    /** @type {Processor<Root>} */
    this
  ), g = n || emptyOptions$1, d = t.data(), k = d.micromarkExtensions || (d.micromarkExtensions = []), H = d.fromMarkdownExtensions || (d.fromMarkdownExtensions = []), AA = d.toMarkdownExtensions || (d.toMarkdownExtensions = []);
  k.push(gfm(g)), H.push(gfmFromMarkdown()), AA.push(gfmToMarkdown(g));
}
function mathFromMarkdown() {
  return {
    enter: {
      mathFlow: n,
      mathFlowFenceMeta: t,
      mathText: H
    },
    exit: {
      mathFlow: k,
      mathFlowFence: d,
      mathFlowFenceMeta: g,
      mathFlowValue: gA,
      mathText: AA,
      mathTextData: gA
    }
  };
  function n(IA) {
    const CA = {
      type: "element",
      tagName: "code",
      properties: { className: ["language-math", "math-display"] },
      children: []
    };
    this.enter(
      {
        type: "math",
        meta: null,
        value: "",
        data: { hName: "pre", hChildren: [CA] }
      },
      IA
    );
  }
  function t() {
    this.buffer();
  }
  function g() {
    const IA = this.resume(), CA = this.stack[this.stack.length - 1];
    CA.type, CA.meta = IA;
  }
  function d() {
    this.data.mathFlowInside || (this.buffer(), this.data.mathFlowInside = !0);
  }
  function k(IA) {
    const CA = this.resume().replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), BA = this.stack[this.stack.length - 1];
    BA.type, this.exit(IA), BA.value = CA;
    const eA = (
      /** @type {HastElement} */
      BA.data.hChildren[0]
    );
    eA.type, eA.tagName, eA.children.push({ type: "text", value: CA }), this.data.mathFlowInside = void 0;
  }
  function H(IA) {
    this.enter(
      {
        type: "inlineMath",
        value: "",
        data: {
          hName: "code",
          hProperties: { className: ["language-math", "math-inline"] },
          hChildren: []
        }
      },
      IA
    ), this.buffer();
  }
  function AA(IA) {
    const CA = this.resume(), BA = this.stack[this.stack.length - 1];
    BA.type, this.exit(IA), BA.value = CA, /** @type {Array<HastElementContent>} */
    // @ts-expect-error: we defined it in `enterMathFlow`.
    BA.data.hChildren.push({ type: "text", value: CA });
  }
  function gA(IA) {
    this.config.enter.data.call(this, IA), this.config.exit.data.call(this, IA);
  }
}
function mathToMarkdown(n) {
  let t = (n || {}).singleDollarTextMath;
  return t == null && (t = !0), d.peek = k, {
    unsafe: [
      { character: "\r", inConstruct: "mathFlowMeta" },
      { character: `
`, inConstruct: "mathFlowMeta" },
      {
        character: "$",
        after: t ? void 0 : "\\$",
        inConstruct: "phrasing"
      },
      { character: "$", inConstruct: "mathFlowMeta" },
      { atBreak: !0, character: "$", after: "\\$" }
    ],
    handlers: { math: g, inlineMath: d }
  };
  function g(H, AA, gA, IA) {
    const CA = H.value || "", BA = gA.createTracker(IA), eA = "$".repeat(Math.max(longestStreak(CA, "$") + 1, 2)), iA = gA.enter("mathFlow");
    let QA = BA.move(eA);
    if (H.meta) {
      const tA = gA.enter("mathFlowMeta");
      QA += BA.move(
        gA.safe(H.meta, {
          after: `
`,
          before: QA,
          encode: ["$"],
          ...BA.current()
        })
      ), tA();
    }
    return QA += BA.move(`
`), CA && (QA += BA.move(CA + `
`)), QA += BA.move(eA), iA(), QA;
  }
  function d(H, AA, gA) {
    let IA = H.value || "", CA = 1;
    for (t || CA++; new RegExp("(^|[^$])" + "\\$".repeat(CA) + "([^$]|$)").test(IA); )
      CA++;
    const BA = "$".repeat(CA);
    // Contains non-space.
    /[^ \r\n]/.test(IA) && // Starts with space and ends with space.
    (/^[ \r\n]/.test(IA) && /[ \r\n]$/.test(IA) || // Starts or ends with dollar.
    /^\$|\$$/.test(IA)) && (IA = " " + IA + " ");
    let eA = -1;
    for (; ++eA < gA.unsafe.length; ) {
      const iA = gA.unsafe[eA];
      if (!iA.atBreak) continue;
      const QA = gA.compilePattern(iA);
      let tA;
      for (; tA = QA.exec(IA); ) {
        let oA = tA.index;
        IA.codePointAt(oA) === 10 && IA.codePointAt(oA - 1) === 13 && oA--, IA = IA.slice(0, oA) + " " + IA.slice(tA.index + 1);
      }
    }
    return BA + IA + BA;
  }
  function k() {
    return "$";
  }
}
const mathFlow = {
  tokenize: tokenizeMathFenced,
  concrete: !0,
  name: "mathFlow"
}, nonLazyContinuation = {
  tokenize: tokenizeNonLazyContinuation,
  partial: !0
};
function tokenizeMathFenced(n, t, g) {
  const d = this, k = d.events[d.events.length - 1], H = k && k[1].type === "linePrefix" ? k[2].sliceSerialize(k[1], !0).length : 0;
  let AA = 0;
  return gA;
  function gA(nA) {
    return n.enter("mathFlow"), n.enter("mathFlowFence"), n.enter("mathFlowFenceSequence"), IA(nA);
  }
  function IA(nA) {
    return nA === 36 ? (n.consume(nA), AA++, IA) : AA < 2 ? g(nA) : (n.exit("mathFlowFenceSequence"), factorySpace(n, CA, "whitespace")(nA));
  }
  function CA(nA) {
    return nA === null || markdownLineEnding(nA) ? eA(nA) : (n.enter("mathFlowFenceMeta"), n.enter("chunkString", {
      contentType: "string"
    }), BA(nA));
  }
  function BA(nA) {
    return nA === null || markdownLineEnding(nA) ? (n.exit("chunkString"), n.exit("mathFlowFenceMeta"), eA(nA)) : nA === 36 ? g(nA) : (n.consume(nA), BA);
  }
  function eA(nA) {
    return n.exit("mathFlowFence"), d.interrupt ? t(nA) : n.attempt(nonLazyContinuation, iA, EA)(nA);
  }
  function iA(nA) {
    return n.attempt({
      tokenize: aA,
      partial: !0
    }, EA, QA)(nA);
  }
  function QA(nA) {
    return (H ? factorySpace(n, tA, "linePrefix", H + 1) : tA)(nA);
  }
  function tA(nA) {
    return nA === null ? EA(nA) : markdownLineEnding(nA) ? n.attempt(nonLazyContinuation, iA, EA)(nA) : (n.enter("mathFlowValue"), oA(nA));
  }
  function oA(nA) {
    return nA === null || markdownLineEnding(nA) ? (n.exit("mathFlowValue"), tA(nA)) : (n.consume(nA), oA);
  }
  function EA(nA) {
    return n.exit("mathFlow"), t(nA);
  }
  function aA(nA, lA, cA) {
    let sA = 0;
    return factorySpace(nA, rA, "linePrefix", d.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    function rA(dA) {
      return nA.enter("mathFlowFence"), nA.enter("mathFlowFenceSequence"), uA(dA);
    }
    function uA(dA) {
      return dA === 36 ? (sA++, nA.consume(dA), uA) : sA < AA ? cA(dA) : (nA.exit("mathFlowFenceSequence"), factorySpace(nA, hA, "whitespace")(dA));
    }
    function hA(dA) {
      return dA === null || markdownLineEnding(dA) ? (nA.exit("mathFlowFence"), lA(dA)) : cA(dA);
    }
  }
}
function tokenizeNonLazyContinuation(n, t, g) {
  const d = this;
  return k;
  function k(AA) {
    return AA === null ? t(AA) : (n.enter("lineEnding"), n.consume(AA), n.exit("lineEnding"), H);
  }
  function H(AA) {
    return d.parser.lazy[d.now().line] ? g(AA) : t(AA);
  }
}
function mathText(n) {
  let g = (n || {}).singleDollarTextMath;
  return g == null && (g = !0), {
    tokenize: d,
    resolve: resolveMathText,
    previous,
    name: "mathText"
  };
  function d(k, H, AA) {
    let gA = 0, IA, CA;
    return BA;
    function BA(oA) {
      return k.enter("mathText"), k.enter("mathTextSequence"), eA(oA);
    }
    function eA(oA) {
      return oA === 36 ? (k.consume(oA), gA++, eA) : gA < 2 && !g ? AA(oA) : (k.exit("mathTextSequence"), iA(oA));
    }
    function iA(oA) {
      return oA === null ? AA(oA) : oA === 36 ? (CA = k.enter("mathTextSequence"), IA = 0, tA(oA)) : oA === 32 ? (k.enter("space"), k.consume(oA), k.exit("space"), iA) : markdownLineEnding(oA) ? (k.enter("lineEnding"), k.consume(oA), k.exit("lineEnding"), iA) : (k.enter("mathTextData"), QA(oA));
    }
    function QA(oA) {
      return oA === null || oA === 32 || oA === 36 || markdownLineEnding(oA) ? (k.exit("mathTextData"), iA(oA)) : (k.consume(oA), QA);
    }
    function tA(oA) {
      return oA === 36 ? (k.consume(oA), IA++, tA) : IA === gA ? (k.exit("mathTextSequence"), k.exit("mathText"), H(oA)) : (CA.type = "mathTextData", QA(oA));
    }
  }
}
function resolveMathText(n) {
  let t = n.length - 4, g = 3, d, k;
  if ((n[g][1].type === "lineEnding" || n[g][1].type === "space") && (n[t][1].type === "lineEnding" || n[t][1].type === "space")) {
    for (d = g; ++d < t; )
      if (n[d][1].type === "mathTextData") {
        n[t][1].type = "mathTextPadding", n[g][1].type = "mathTextPadding", g += 2, t -= 2;
        break;
      }
  }
  for (d = g - 1, t++; ++d <= t; )
    k === void 0 ? d !== t && n[d][1].type !== "lineEnding" && (k = d) : (d === t || n[d][1].type === "lineEnding") && (n[k][1].type = "mathTextData", d !== k + 2 && (n[k][1].end = n[d - 1][1].end, n.splice(k + 2, d - k - 2), t -= d - k - 2, d = k + 2), k = void 0);
  return n;
}
function previous(n) {
  return n !== 36 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function math(n) {
  return {
    flow: {
      36: mathFlow
    },
    text: {
      36: mathText(n)
    }
  };
}
const emptyOptions = {};
function remarkMath(n) {
  const t = (
    /** @type {Processor} */
    this
  ), g = n || emptyOptions, d = t.data(), k = d.micromarkExtensions || (d.micromarkExtensions = []), H = d.fromMarkdownExtensions || (d.fromMarkdownExtensions = []), AA = d.toMarkdownExtensions || (d.toMarkdownExtensions = []);
  k.push(math(g)), H.push(mathFromMarkdown()), AA.push(mathToMarkdown(g));
}
const streamlitLogo = "data:image/svg+xml,%3csvg%20width='301'%20height='165'%20viewBox='0%200%20301%20165'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M150.731%20101.547L98.1387%2073.7471L6.84674%2025.4969C6.7634%2025.4136%206.59674%2025.4136%206.51341%2025.4136C3.18007%2023.8303%20-0.236608%2027.1636%201.0134%2030.497L47.5302%20149.139L47.5385%20149.164C47.5885%20149.281%2047.6302%20149.397%2047.6802%20149.514C49.5885%20153.939%2053.7552%20156.672%2058.2886%20157.747C58.6719%20157.831%2058.9461%20157.906%2059.4064%20157.998C59.8645%20158.1%2060.5052%20158.239%2061.0552%20158.281C61.1469%20158.289%2061.2302%20158.289%2061.3219%20158.297H61.3886C61.4552%20158.306%2061.5219%20158.306%2061.5886%20158.314H61.6802C61.7386%20158.322%2061.8052%20158.322%2061.8636%20158.322H61.9719C62.0386%20158.331%2062.1052%20158.331%2062.1719%20158.331V158.331C121.084%20164.754%20180.519%20164.754%20239.431%20158.331V158.331C240.139%20158.331%20240.831%20158.297%20241.497%20158.231C241.714%20158.206%20241.922%20158.181%20242.131%20158.156C242.156%20158.147%20242.189%20158.147%20242.214%20158.139C242.356%20158.122%20242.497%20158.097%20242.639%20158.072C242.847%20158.047%20243.056%20158.006%20243.264%20157.964C243.681%20157.872%20243.87%20157.806%20244.436%20157.611C245.001%20157.417%20245.94%20157.077%20246.527%20156.794C247.115%20156.511%20247.522%20156.239%20248.014%20155.931C248.622%20155.547%20249.201%20155.155%20249.788%20154.715C250.041%20154.521%20250.214%20154.397%20250.397%20154.222L250.297%20154.164L150.731%20101.547Z'%20fill='%23FF4B4B'/%3e%3cpath%20d='M294.766%2025.4981H294.683L203.357%2073.7483L254.124%20149.357L300.524%2030.4981V30.3315C301.691%2026.8314%20298.108%2023.6648%20294.766%2025.4981'%20fill='%237D353B'/%3e%3cpath%20d='M155.598%202.55572C153.264%20-0.852624%20148.181%20-0.852624%20145.931%202.55572L98.1389%2073.7477L150.731%20101.548L250.398%20154.222C251.024%20153.609%20251.526%20153.012%20252.056%20152.381C252.806%20151.456%20253.506%20150.465%20254.123%20149.356L203.356%2073.7477L155.598%202.55572Z'%20fill='%23BD4043'/%3e%3c/svg%3e", IsDialogContext = createContext(!1);
IsDialogContext.displayName = "IsDialogContext";
const IsSidebarContext = createContext(!1);
IsSidebarContext.displayName = "IsSidebarContext";
function _objectWithoutPropertiesLoose$j(n, t) {
  if (n == null) return {};
  var g = {};
  for (var d in n) if ({}.hasOwnProperty.call(n, d)) {
    if (t.indexOf(d) !== -1) continue;
    g[d] = n[d];
  }
  return g;
}
function _objectWithoutProperties$j(n, t) {
  if (n == null) return {};
  var g, d, k = _objectWithoutPropertiesLoose$j(n, t);
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (d = 0; d < H.length; d++) g = H[d], t.indexOf(g) === -1 && {}.propertyIsEnumerable.call(n, g) && (k[g] = n[g]);
  }
  return k;
}
function _arrayLikeToArray$h(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = Array(t); g < t; g++) d[g] = n[g];
  return d;
}
function _arrayWithoutHoles$2(n) {
  if (Array.isArray(n)) return _arrayLikeToArray$h(n);
}
function _iterableToArray$2(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function _unsupportedIterableToArray$h(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$h(n, t);
    var g = {}.toString.call(n).slice(8, -1);
    return g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set" ? Array.from(n) : g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g) ? _arrayLikeToArray$h(n, t) : void 0;
  }
}
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toConsumableArray$2(n) {
  return _arrayWithoutHoles$2(n) || _iterableToArray$2(n) || _unsupportedIterableToArray$h(n) || _nonIterableSpread$2();
}
function _typeof$e(n) {
  "@babel/helpers - typeof";
  return _typeof$e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$e(n);
}
function toPrimitive$2(n, t) {
  if (_typeof$e(n) != "object" || !n) return n;
  var g = n[Symbol.toPrimitive];
  if (g !== void 0) {
    var d = g.call(n, t);
    if (_typeof$e(d) != "object") return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(n);
}
function toPropertyKey$2(n) {
  var t = toPrimitive$2(n, "string");
  return _typeof$e(t) == "symbol" ? t : t + "";
}
function _defineProperty$q(n, t, g) {
  return (t = toPropertyKey$2(t)) in n ? Object.defineProperty(n, t, {
    value: g,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[t] = g, n;
}
function ownKeys$o(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$m(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$o(Object(g), !0).forEach(function(d) {
      _defineProperty$q(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$o(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function powerSetPermutations(n) {
  var t = n.length;
  if (t === 0 || t === 1) return n;
  if (t === 2)
    return [n[0], n[1], "".concat(n[0], ".").concat(n[1]), "".concat(n[1], ".").concat(n[0])];
  if (t === 3)
    return [n[0], n[1], n[2], "".concat(n[0], ".").concat(n[1]), "".concat(n[0], ".").concat(n[2]), "".concat(n[1], ".").concat(n[0]), "".concat(n[1], ".").concat(n[2]), "".concat(n[2], ".").concat(n[0]), "".concat(n[2], ".").concat(n[1]), "".concat(n[0], ".").concat(n[1], ".").concat(n[2]), "".concat(n[0], ".").concat(n[2], ".").concat(n[1]), "".concat(n[1], ".").concat(n[0], ".").concat(n[2]), "".concat(n[1], ".").concat(n[2], ".").concat(n[0]), "".concat(n[2], ".").concat(n[0], ".").concat(n[1]), "".concat(n[2], ".").concat(n[1], ".").concat(n[0])];
  if (t >= 4)
    return [n[0], n[1], n[2], n[3], "".concat(n[0], ".").concat(n[1]), "".concat(n[0], ".").concat(n[2]), "".concat(n[0], ".").concat(n[3]), "".concat(n[1], ".").concat(n[0]), "".concat(n[1], ".").concat(n[2]), "".concat(n[1], ".").concat(n[3]), "".concat(n[2], ".").concat(n[0]), "".concat(n[2], ".").concat(n[1]), "".concat(n[2], ".").concat(n[3]), "".concat(n[3], ".").concat(n[0]), "".concat(n[3], ".").concat(n[1]), "".concat(n[3], ".").concat(n[2]), "".concat(n[0], ".").concat(n[1], ".").concat(n[2]), "".concat(n[0], ".").concat(n[1], ".").concat(n[3]), "".concat(n[0], ".").concat(n[2], ".").concat(n[1]), "".concat(n[0], ".").concat(n[2], ".").concat(n[3]), "".concat(n[0], ".").concat(n[3], ".").concat(n[1]), "".concat(n[0], ".").concat(n[3], ".").concat(n[2]), "".concat(n[1], ".").concat(n[0], ".").concat(n[2]), "".concat(n[1], ".").concat(n[0], ".").concat(n[3]), "".concat(n[1], ".").concat(n[2], ".").concat(n[0]), "".concat(n[1], ".").concat(n[2], ".").concat(n[3]), "".concat(n[1], ".").concat(n[3], ".").concat(n[0]), "".concat(n[1], ".").concat(n[3], ".").concat(n[2]), "".concat(n[2], ".").concat(n[0], ".").concat(n[1]), "".concat(n[2], ".").concat(n[0], ".").concat(n[3]), "".concat(n[2], ".").concat(n[1], ".").concat(n[0]), "".concat(n[2], ".").concat(n[1], ".").concat(n[3]), "".concat(n[2], ".").concat(n[3], ".").concat(n[0]), "".concat(n[2], ".").concat(n[3], ".").concat(n[1]), "".concat(n[3], ".").concat(n[0], ".").concat(n[1]), "".concat(n[3], ".").concat(n[0], ".").concat(n[2]), "".concat(n[3], ".").concat(n[1], ".").concat(n[0]), "".concat(n[3], ".").concat(n[1], ".").concat(n[2]), "".concat(n[3], ".").concat(n[2], ".").concat(n[0]), "".concat(n[3], ".").concat(n[2], ".").concat(n[1]), "".concat(n[0], ".").concat(n[1], ".").concat(n[2], ".").concat(n[3]), "".concat(n[0], ".").concat(n[1], ".").concat(n[3], ".").concat(n[2]), "".concat(n[0], ".").concat(n[2], ".").concat(n[1], ".").concat(n[3]), "".concat(n[0], ".").concat(n[2], ".").concat(n[3], ".").concat(n[1]), "".concat(n[0], ".").concat(n[3], ".").concat(n[1], ".").concat(n[2]), "".concat(n[0], ".").concat(n[3], ".").concat(n[2], ".").concat(n[1]), "".concat(n[1], ".").concat(n[0], ".").concat(n[2], ".").concat(n[3]), "".concat(n[1], ".").concat(n[0], ".").concat(n[3], ".").concat(n[2]), "".concat(n[1], ".").concat(n[2], ".").concat(n[0], ".").concat(n[3]), "".concat(n[1], ".").concat(n[2], ".").concat(n[3], ".").concat(n[0]), "".concat(n[1], ".").concat(n[3], ".").concat(n[0], ".").concat(n[2]), "".concat(n[1], ".").concat(n[3], ".").concat(n[2], ".").concat(n[0]), "".concat(n[2], ".").concat(n[0], ".").concat(n[1], ".").concat(n[3]), "".concat(n[2], ".").concat(n[0], ".").concat(n[3], ".").concat(n[1]), "".concat(n[2], ".").concat(n[1], ".").concat(n[0], ".").concat(n[3]), "".concat(n[2], ".").concat(n[1], ".").concat(n[3], ".").concat(n[0]), "".concat(n[2], ".").concat(n[3], ".").concat(n[0], ".").concat(n[1]), "".concat(n[2], ".").concat(n[3], ".").concat(n[1], ".").concat(n[0]), "".concat(n[3], ".").concat(n[0], ".").concat(n[1], ".").concat(n[2]), "".concat(n[3], ".").concat(n[0], ".").concat(n[2], ".").concat(n[1]), "".concat(n[3], ".").concat(n[1], ".").concat(n[0], ".").concat(n[2]), "".concat(n[3], ".").concat(n[1], ".").concat(n[2], ".").concat(n[0]), "".concat(n[3], ".").concat(n[2], ".").concat(n[0], ".").concat(n[1]), "".concat(n[3], ".").concat(n[2], ".").concat(n[1], ".").concat(n[0])];
}
var classNameCombinations = {};
function getClassNameCombinations(n) {
  if (n.length === 0 || n.length === 1) return n;
  var t = n.join(".");
  return classNameCombinations[t] || (classNameCombinations[t] = powerSetPermutations(n)), classNameCombinations[t];
}
function createStyleObject(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, g = arguments.length > 2 ? arguments[2] : void 0, d = n.filter(function(H) {
    return H !== "token";
  }), k = getClassNameCombinations(d);
  return k.reduce(function(H, AA) {
    return _objectSpread$m(_objectSpread$m({}, H), g[AA]);
  }, t);
}
function createClassNameString(n) {
  return n.join(" ");
}
function createChildren(n, t) {
  var g = 0;
  return function(d) {
    return g += 1, d.map(function(k, H) {
      return createElement({
        node: k,
        stylesheet: n,
        useInlineStyles: t,
        key: "code-segment-".concat(g, "-").concat(H)
      });
    });
  };
}
function createElement(n) {
  var t = n.node, g = n.stylesheet, d = n.style, k = d === void 0 ? {} : d, H = n.useInlineStyles, AA = n.key, gA = t.properties, IA = t.type, CA = t.tagName, BA = t.value;
  if (IA === "text")
    return BA;
  if (CA) {
    var eA = createChildren(g, H), iA;
    if (!H)
      iA = _objectSpread$m(_objectSpread$m({}, gA), {}, {
        className: createClassNameString(gA.className)
      });
    else {
      var QA = Object.keys(g).reduce(function(aA, nA) {
        return nA.split(".").forEach(function(lA) {
          aA.includes(lA) || aA.push(lA);
        }), aA;
      }, []), tA = gA.className && gA.className.includes("token") ? ["token"] : [], oA = gA.className && tA.concat(gA.className.filter(function(aA) {
        return !QA.includes(aA);
      }));
      iA = _objectSpread$m(_objectSpread$m({}, gA), {}, {
        className: createClassNameString(oA) || void 0,
        style: createStyleObject(gA.className, Object.assign({}, gA.style, k), g)
      });
    }
    var EA = eA(t.children);
    return /* @__PURE__ */ React__default.createElement(CA, _extends$M({
      key: AA
    }, iA), EA);
  }
}
const checkForListedLanguage = (function(n, t) {
  var g = n.listLanguages();
  return g.indexOf(t) !== -1;
});
var _excluded$m = ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "wrapLongLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"];
function ownKeys$n(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$l(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$n(Object(g), !0).forEach(function(d) {
      _defineProperty$q(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$n(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
var newLineRegex = /\n/g;
function getNewLines(n) {
  return n.match(newLineRegex);
}
function getAllLineNumbers(n) {
  var t = n.lines, g = n.startingLineNumber, d = n.style;
  return t.map(function(k, H) {
    var AA = H + g;
    return /* @__PURE__ */ React__default.createElement("span", {
      key: "line-".concat(H),
      className: "react-syntax-highlighter-line-number",
      style: typeof d == "function" ? d(AA) : d
    }, "".concat(AA, `
`));
  });
}
function AllLineNumbers(n) {
  var t = n.codeString, g = n.codeStyle, d = n.containerStyle, k = d === void 0 ? {
    float: "left",
    paddingRight: "10px"
  } : d, H = n.numberStyle, AA = H === void 0 ? {} : H, gA = n.startingLineNumber;
  return /* @__PURE__ */ React__default.createElement("code", {
    style: Object.assign({}, g, k)
  }, getAllLineNumbers({
    lines: t.replace(/\n$/, "").split(`
`),
    style: AA,
    startingLineNumber: gA
  }));
}
function getEmWidthOfNumber(n) {
  return "".concat(n.toString().length, ".25em");
}
function getInlineLineNumber(n, t) {
  return {
    type: "element",
    tagName: "span",
    properties: {
      key: "line-number--".concat(n),
      className: ["comment", "linenumber", "react-syntax-highlighter-line-number"],
      style: t
    },
    children: [{
      type: "text",
      value: n
    }]
  };
}
function assembleLineNumberStyles(n, t, g) {
  var d = {
    display: "inline-block",
    minWidth: getEmWidthOfNumber(g),
    paddingRight: "1em",
    textAlign: "right",
    userSelect: "none"
  }, k = typeof n == "function" ? n(t) : n, H = _objectSpread$l(_objectSpread$l({}, d), k);
  return H;
}
function createLineElement(n) {
  var t = n.children, g = n.lineNumber, d = n.lineNumberStyle, k = n.largestLineNumber, H = n.showInlineLineNumbers, AA = n.lineProps, gA = AA === void 0 ? {} : AA, IA = n.className, CA = IA === void 0 ? [] : IA, BA = n.showLineNumbers, eA = n.wrapLongLines, iA = n.wrapLines, QA = iA === void 0 ? !1 : iA, tA = QA ? _objectSpread$l({}, typeof gA == "function" ? gA(g) : gA) : {};
  if (tA.className = tA.className ? [].concat(_toConsumableArray$2(tA.className.trim().split(/\s+/)), _toConsumableArray$2(CA)) : CA, g && H) {
    var oA = assembleLineNumberStyles(d, g, k);
    t.unshift(getInlineLineNumber(g, oA));
  }
  return eA & BA && (tA.style = _objectSpread$l({
    display: "flex"
  }, tA.style)), {
    type: "element",
    tagName: "span",
    properties: tA,
    children: t
  };
}
function flattenCodeTree(n) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], d = 0; d < n.length; d++) {
    var k = n[d];
    if (k.type === "text")
      g.push(createLineElement({
        children: [k],
        className: _toConsumableArray$2(new Set(t))
      }));
    else if (k.children) {
      var H = t.concat(k.properties.className);
      flattenCodeTree(k.children, H).forEach(function(AA) {
        return g.push(AA);
      });
    }
  }
  return g;
}
function processLines(n, t, g, d, k, H, AA, gA, IA) {
  var CA, BA = flattenCodeTree(n.value), eA = [], iA = -1, QA = 0;
  function tA(sA, rA) {
    var uA = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return createLineElement({
      children: sA,
      lineNumber: rA,
      lineNumberStyle: gA,
      largestLineNumber: AA,
      showInlineLineNumbers: k,
      lineProps: g,
      className: uA,
      showLineNumbers: d,
      wrapLongLines: IA,
      wrapLines: t
    });
  }
  function oA(sA, rA) {
    if (d && rA && k) {
      var uA = assembleLineNumberStyles(gA, rA, AA);
      sA.unshift(getInlineLineNumber(rA, uA));
    }
    return sA;
  }
  function EA(sA, rA) {
    var uA = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return t || uA.length > 0 ? tA(sA, rA, uA) : oA(sA, rA);
  }
  for (var aA = function() {
    var rA = BA[QA], uA = rA.children[0].value, hA = getNewLines(uA);
    if (hA) {
      var dA = uA.split(`
`);
      dA.forEach(function(GA, DA) {
        var wA = d && eA.length + H, bA = {
          type: "text",
          value: "".concat(GA, `
`)
        };
        if (DA === 0) {
          var yA = BA.slice(iA + 1, QA).concat(createLineElement({
            children: [bA],
            className: rA.properties.className
          })), pA = EA(yA, wA);
          eA.push(pA);
        } else if (DA === dA.length - 1) {
          var MA = BA[QA + 1] && BA[QA + 1].children && BA[QA + 1].children[0], LA = {
            type: "text",
            value: "".concat(GA)
          };
          if (MA) {
            var xA = createLineElement({
              children: [LA],
              className: rA.properties.className
            });
            BA.splice(QA + 1, 0, xA);
          } else {
            var TA = [LA], NA = EA(TA, wA, rA.properties.className);
            eA.push(NA);
          }
        } else {
          var zA = [bA], XA = EA(zA, wA, rA.properties.className);
          eA.push(XA);
        }
      }), iA = QA;
    }
    QA++;
  }; QA < BA.length; )
    aA();
  if (iA !== BA.length - 1) {
    var nA = BA.slice(iA + 1, BA.length);
    if (nA && nA.length) {
      var lA = d && eA.length + H, cA = EA(nA, lA);
      eA.push(cA);
    }
  }
  return t ? eA : (CA = []).concat.apply(CA, eA);
}
function defaultRenderer(n) {
  var t = n.rows, g = n.stylesheet, d = n.useInlineStyles;
  return t.map(function(k, H) {
    return createElement({
      node: k,
      stylesheet: g,
      useInlineStyles: d,
      key: "code-segment-".concat(H)
    });
  });
}
function isHighlightJs(n) {
  return n && typeof n.highlightAuto < "u";
}
function getCodeTree(n) {
  var t = n.astGenerator, g = n.language, d = n.code, k = n.defaultCodeValue;
  if (isHighlightJs(t)) {
    var H = checkForListedLanguage(t, g);
    return g === "text" ? {
      value: k,
      language: "text"
    } : H ? t.highlight(g, d) : t.highlightAuto(d);
  }
  try {
    return g && g !== "text" ? {
      value: t.highlight(d, g)
    } : {
      value: k
    };
  } catch {
    return {
      value: k
    };
  }
}
function highlight(n, t) {
  return function(d) {
    var k, H, AA = d.language, gA = d.children, IA = d.style, CA = IA === void 0 ? t : IA, BA = d.customStyle, eA = BA === void 0 ? {} : BA, iA = d.codeTagProps, QA = iA === void 0 ? {
      className: AA ? "language-".concat(AA) : void 0,
      style: _objectSpread$l(_objectSpread$l({}, CA['code[class*="language-"]']), CA['code[class*="language-'.concat(AA, '"]')])
    } : iA, tA = d.useInlineStyles, oA = tA === void 0 ? !0 : tA, EA = d.showLineNumbers, aA = EA === void 0 ? !1 : EA, nA = d.showInlineLineNumbers, lA = nA === void 0 ? !0 : nA, cA = d.startingLineNumber, sA = cA === void 0 ? 1 : cA, rA = d.lineNumberContainerStyle, uA = d.lineNumberStyle, hA = uA === void 0 ? {} : uA, dA = d.wrapLines, GA = d.wrapLongLines, DA = GA === void 0 ? !1 : GA, wA = d.lineProps, bA = wA === void 0 ? {} : wA, yA = d.renderer, pA = d.PreTag, MA = pA === void 0 ? "pre" : pA, LA = d.CodeTag, xA = LA === void 0 ? "code" : LA, TA = d.code, NA = TA === void 0 ? (Array.isArray(gA) ? gA[0] : gA) || "" : TA, zA = d.astGenerator, XA = _objectWithoutProperties$j(d, _excluded$m);
    zA = zA || n;
    var fA = aA ? /* @__PURE__ */ React__default.createElement(AllLineNumbers, {
      containerStyle: rA,
      codeStyle: QA.style || {},
      numberStyle: hA,
      startingLineNumber: sA,
      codeString: NA
    }) : null, vA = CA.hljs || CA['pre[class*="language-"]'] || {
      backgroundColor: "#fff"
    }, Cg = isHighlightJs(zA) ? "hljs" : "prismjs", Ig = oA ? Object.assign({}, XA, {
      style: Object.assign({}, vA, eA)
    }) : Object.assign({}, XA, {
      className: XA.className ? "".concat(Cg, " ").concat(XA.className) : Cg,
      style: Object.assign({}, eA)
    });
    if (DA ? QA.style = _objectSpread$l({
      whiteSpace: "pre-wrap"
    }, QA.style) : QA.style = _objectSpread$l({
      whiteSpace: "pre"
    }, QA.style), !zA)
      return /* @__PURE__ */ React__default.createElement(MA, Ig, fA, /* @__PURE__ */ React__default.createElement(xA, QA, NA));
    (dA === void 0 && yA || DA) && (dA = !0), yA = yA || defaultRenderer;
    var gg = [{
      type: "text",
      value: NA
    }], og = getCodeTree({
      astGenerator: zA,
      language: AA,
      code: NA,
      defaultCodeValue: gg
    });
    og.language === null && (og.value = gg);
    var eg = (k = (H = NA.match(/\n/g)) === null || H === void 0 ? void 0 : H.length) !== null && k !== void 0 ? k : 0, kA = sA + eg, YA = processLines(og, dA, bA, aA, lA, sA, kA, hA, DA);
    return /* @__PURE__ */ React__default.createElement(MA, Ig, /* @__PURE__ */ React__default.createElement(xA, QA, !lA && fA, yA({
      rows: YA,
      stylesheet: CA,
      useInlineStyles: oA
    })));
  };
}
function _assertThisInitialized$b(n) {
  if (n === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _setPrototypeOf$b(n, t) {
  return _setPrototypeOf$b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, d) {
    return g.__proto__ = d, g;
  }, _setPrototypeOf$b(n, t);
}
const supportedLanguages = ["abap", "abnf", "actionscript", "ada", "agda", "al", "antlr4", "apacheconf", "apex", "apl", "applescript", "aql", "arduino", "arff", "asciidoc", "asm6502", "asmatmel", "aspnet", "autohotkey", "autoit", "avisynth", "avro-idl", "bash", "basic", "batch", "bbcode", "bicep", "birb", "bison", "bnf", "brainfuck", "brightscript", "bro", "bsl", "c", "cfscript", "chaiscript", "cil", "clike", "clojure", "cmake", "cobol", "coffeescript", "concurnas", "coq", "cpp", "crystal", "csharp", "cshtml", "csp", "css-extras", "css", "csv", "cypher", "d", "dart", "dataweave", "dax", "dhall", "diff", "django", "dns-zone-file", "docker", "dot", "ebnf", "editorconfig", "eiffel", "ejs", "elixir", "elm", "erb", "erlang", "etlua", "excel-formula", "factor", "false", "firestore-security-rules", "flow", "fortran", "fsharp", "ftl", "gap", "gcode", "gdscript", "gedcom", "gherkin", "git", "glsl", "gml", "gn", "go-module", "go", "graphql", "groovy", "haml", "handlebars", "haskell", "haxe", "hcl", "hlsl", "hoon", "hpkp", "hsts", "http", "ichigojam", "icon", "icu-message-format", "idris", "iecst", "ignore", "inform7", "ini", "io", "j", "java", "javadoc", "javadoclike", "javascript", "javastacktrace", "jexl", "jolie", "jq", "js-extras", "js-templates", "jsdoc", "json", "json5", "jsonp", "jsstacktrace", "jsx", "julia", "keepalived", "keyman", "kotlin", "kumir", "kusto", "latex", "latte", "less", "lilypond", "liquid", "lisp", "livescript", "llvm", "log", "lolcode", "lua", "magma", "makefile", "markdown", "markup-templating", "markup", "matlab", "maxscript", "mel", "mermaid", "mizar", "mongodb", "monkey", "moonscript", "n1ql", "n4js", "nand2tetris-hdl", "naniscript", "nasm", "neon", "nevod", "nginx", "nim", "nix", "nsis", "objectivec", "ocaml", "opencl", "openqasm", "oz", "parigp", "parser", "pascal", "pascaligo", "pcaxis", "peoplecode", "perl", "php-extras", "php", "phpdoc", "plsql", "powerquery", "powershell", "processing", "prolog", "promql", "properties", "protobuf", "psl", "pug", "puppet", "pure", "purebasic", "purescript", "python", "q", "qml", "qore", "qsharp", "r", "racket", "reason", "regex", "rego", "renpy", "rest", "rip", "roboconf", "robotframework", "ruby", "rust", "sas", "sass", "scala", "scheme", "scss", "shell-session", "smali", "smalltalk", "smarty", "sml", "solidity", "solution-file", "soy", "sparql", "splunk-spl", "sqf", "sql", "squirrel", "stan", "stylus", "swift", "systemd", "t4-cs", "t4-templating", "t4-vb", "tap", "tcl", "textile", "toml", "tremor", "tsx", "tt2", "turtle", "twig", "typescript", "typoscript", "unrealscript", "uorazor", "uri", "v", "vala", "vbnet", "velocity", "verilog", "vhdl", "vim", "visual-basic", "warpscript", "wasm", "web-idl", "wiki", "wolfram", "wren", "xeora", "xml-doc", "xojo", "xquery", "yaml", "yang", "zig"];
var immutable, hasRequiredImmutable;
function requireImmutable() {
  if (hasRequiredImmutable) return immutable;
  hasRequiredImmutable = 1, immutable = t;
  var n = Object.prototype.hasOwnProperty;
  function t() {
    for (var g = {}, d = 0; d < arguments.length; d++) {
      var k = arguments[d];
      for (var H in k)
        n.call(k, H) && (g[H] = k[H]);
    }
    return g;
  }
  return immutable;
}
var schema, hasRequiredSchema;
function requireSchema() {
  if (hasRequiredSchema) return schema;
  hasRequiredSchema = 1, schema = t;
  var n = t.prototype;
  n.space = null, n.normal = {}, n.property = {};
  function t(g, d, k) {
    this.property = g, this.normal = d, k && (this.space = k);
  }
  return schema;
}
var merge_1, hasRequiredMerge;
function requireMerge() {
  if (hasRequiredMerge) return merge_1;
  hasRequiredMerge = 1;
  var n = requireImmutable(), t = requireSchema();
  merge_1 = g;
  function g(d) {
    for (var k = d.length, H = [], AA = [], gA = -1, IA, CA; ++gA < k; )
      IA = d[gA], H.push(IA.property), AA.push(IA.normal), CA = IA.space;
    return new t(
      n.apply(null, H),
      n.apply(null, AA),
      CA
    );
  }
  return merge_1;
}
var normalize_1, hasRequiredNormalize;
function requireNormalize() {
  if (hasRequiredNormalize) return normalize_1;
  hasRequiredNormalize = 1, normalize_1 = n;
  function n(t) {
    return t.toLowerCase();
  }
  return normalize_1;
}
var info$1, hasRequiredInfo;
function requireInfo() {
  if (hasRequiredInfo) return info$1;
  hasRequiredInfo = 1, info$1 = t;
  var n = t.prototype;
  n.space = null, n.attribute = null, n.property = null, n.boolean = !1, n.booleanish = !1, n.overloadedBoolean = !1, n.number = !1, n.commaSeparated = !1, n.spaceSeparated = !1, n.commaOrSpaceSeparated = !1, n.mustUseProperty = !1, n.defined = !1;
  function t(g, d) {
    this.property = g, this.attribute = d;
  }
  return info$1;
}
var types$1 = {}, hasRequiredTypes$1;
function requireTypes$1() {
  if (hasRequiredTypes$1) return types$1;
  hasRequiredTypes$1 = 1;
  var n = 0;
  types$1.boolean = t(), types$1.booleanish = t(), types$1.overloadedBoolean = t(), types$1.number = t(), types$1.spaceSeparated = t(), types$1.commaSeparated = t(), types$1.commaOrSpaceSeparated = t();
  function t() {
    return Math.pow(2, ++n);
  }
  return types$1;
}
var definedInfo, hasRequiredDefinedInfo;
function requireDefinedInfo() {
  if (hasRequiredDefinedInfo) return definedInfo;
  hasRequiredDefinedInfo = 1;
  var n = requireInfo(), t = requireTypes$1();
  definedInfo = k, k.prototype = new n(), k.prototype.defined = !0;
  var g = [
    "boolean",
    "booleanish",
    "overloadedBoolean",
    "number",
    "commaSeparated",
    "spaceSeparated",
    "commaOrSpaceSeparated"
  ], d = g.length;
  function k(AA, gA, IA, CA) {
    var BA = -1, eA;
    for (H(this, "space", CA), n.call(this, AA, gA); ++BA < d; )
      eA = g[BA], H(this, eA, (IA & t[eA]) === t[eA]);
  }
  function H(AA, gA, IA) {
    IA && (AA[gA] = IA);
  }
  return definedInfo;
}
var create_1, hasRequiredCreate;
function requireCreate() {
  if (hasRequiredCreate) return create_1;
  hasRequiredCreate = 1;
  var n = requireNormalize(), t = requireSchema(), g = requireDefinedInfo();
  create_1 = d;
  function d(k) {
    var H = k.space, AA = k.mustUseProperty || [], gA = k.attributes || {}, IA = k.properties, CA = k.transform, BA = {}, eA = {}, iA, QA;
    for (iA in IA)
      QA = new g(
        iA,
        CA(gA, iA),
        IA[iA],
        H
      ), AA.indexOf(iA) !== -1 && (QA.mustUseProperty = !0), BA[iA] = QA, eA[n(iA)] = iA, eA[n(QA.attribute)] = iA;
    return new t(BA, eA, H);
  }
  return create_1;
}
var xlink, hasRequiredXlink;
function requireXlink() {
  if (hasRequiredXlink) return xlink;
  hasRequiredXlink = 1;
  var n = requireCreate();
  xlink = n({
    space: "xlink",
    transform: t,
    properties: {
      xLinkActuate: null,
      xLinkArcRole: null,
      xLinkHref: null,
      xLinkRole: null,
      xLinkShow: null,
      xLinkTitle: null,
      xLinkType: null
    }
  });
  function t(g, d) {
    return "xlink:" + d.slice(5).toLowerCase();
  }
  return xlink;
}
var xml, hasRequiredXml;
function requireXml() {
  if (hasRequiredXml) return xml;
  hasRequiredXml = 1;
  var n = requireCreate();
  xml = n({
    space: "xml",
    transform: t,
    properties: {
      xmlLang: null,
      xmlBase: null,
      xmlSpace: null
    }
  });
  function t(g, d) {
    return "xml:" + d.slice(3).toLowerCase();
  }
  return xml;
}
var caseSensitiveTransform_1, hasRequiredCaseSensitiveTransform;
function requireCaseSensitiveTransform() {
  if (hasRequiredCaseSensitiveTransform) return caseSensitiveTransform_1;
  hasRequiredCaseSensitiveTransform = 1, caseSensitiveTransform_1 = n;
  function n(t, g) {
    return g in t ? t[g] : g;
  }
  return caseSensitiveTransform_1;
}
var caseInsensitiveTransform_1, hasRequiredCaseInsensitiveTransform;
function requireCaseInsensitiveTransform() {
  if (hasRequiredCaseInsensitiveTransform) return caseInsensitiveTransform_1;
  hasRequiredCaseInsensitiveTransform = 1;
  var n = requireCaseSensitiveTransform();
  caseInsensitiveTransform_1 = t;
  function t(g, d) {
    return n(g, d.toLowerCase());
  }
  return caseInsensitiveTransform_1;
}
var xmlns$1, hasRequiredXmlns;
function requireXmlns() {
  if (hasRequiredXmlns) return xmlns$1;
  hasRequiredXmlns = 1;
  var n = requireCreate(), t = requireCaseInsensitiveTransform();
  return xmlns$1 = n({
    space: "xmlns",
    attributes: {
      xmlnsxlink: "xmlns:xlink"
    },
    transform: t,
    properties: {
      xmlns: null,
      xmlnsXLink: null
    }
  }), xmlns$1;
}
var aria$1, hasRequiredAria;
function requireAria() {
  if (hasRequiredAria) return aria$1;
  hasRequiredAria = 1;
  var n = requireTypes$1(), t = requireCreate(), g = n.booleanish, d = n.number, k = n.spaceSeparated;
  aria$1 = t({
    transform: H,
    properties: {
      ariaActiveDescendant: null,
      ariaAtomic: g,
      ariaAutoComplete: null,
      ariaBusy: g,
      ariaChecked: g,
      ariaColCount: d,
      ariaColIndex: d,
      ariaColSpan: d,
      ariaControls: k,
      ariaCurrent: null,
      ariaDescribedBy: k,
      ariaDetails: null,
      ariaDisabled: g,
      ariaDropEffect: k,
      ariaErrorMessage: null,
      ariaExpanded: g,
      ariaFlowTo: k,
      ariaGrabbed: g,
      ariaHasPopup: null,
      ariaHidden: g,
      ariaInvalid: null,
      ariaKeyShortcuts: null,
      ariaLabel: null,
      ariaLabelledBy: k,
      ariaLevel: d,
      ariaLive: null,
      ariaModal: g,
      ariaMultiLine: g,
      ariaMultiSelectable: g,
      ariaOrientation: null,
      ariaOwns: k,
      ariaPlaceholder: null,
      ariaPosInSet: d,
      ariaPressed: g,
      ariaReadOnly: g,
      ariaRelevant: null,
      ariaRequired: g,
      ariaRoleDescription: k,
      ariaRowCount: d,
      ariaRowIndex: d,
      ariaRowSpan: d,
      ariaSelected: g,
      ariaSetSize: d,
      ariaSort: null,
      ariaValueMax: d,
      ariaValueMin: d,
      ariaValueNow: d,
      ariaValueText: null,
      role: null
    }
  });
  function H(AA, gA) {
    return gA === "role" ? gA : "aria-" + gA.slice(4).toLowerCase();
  }
  return aria$1;
}
var html, hasRequiredHtml$2;
function requireHtml$2() {
  if (hasRequiredHtml$2) return html;
  hasRequiredHtml$2 = 1;
  var n = requireTypes$1(), t = requireCreate(), g = requireCaseInsensitiveTransform(), d = n.boolean, k = n.overloadedBoolean, H = n.booleanish, AA = n.number, gA = n.spaceSeparated, IA = n.commaSeparated;
  return html = t({
    space: "html",
    attributes: {
      acceptcharset: "accept-charset",
      classname: "class",
      htmlfor: "for",
      httpequiv: "http-equiv"
    },
    transform: g,
    mustUseProperty: ["checked", "multiple", "muted", "selected"],
    properties: {
      // Standard Properties.
      abbr: null,
      accept: IA,
      acceptCharset: gA,
      accessKey: gA,
      action: null,
      allow: null,
      allowFullScreen: d,
      allowPaymentRequest: d,
      allowUserMedia: d,
      alt: null,
      as: null,
      async: d,
      autoCapitalize: null,
      autoComplete: gA,
      autoFocus: d,
      autoPlay: d,
      capture: d,
      charSet: null,
      checked: d,
      cite: null,
      className: gA,
      cols: AA,
      colSpan: null,
      content: null,
      contentEditable: H,
      controls: d,
      controlsList: gA,
      coords: AA | IA,
      crossOrigin: null,
      data: null,
      dateTime: null,
      decoding: null,
      default: d,
      defer: d,
      dir: null,
      dirName: null,
      disabled: d,
      download: k,
      draggable: H,
      encType: null,
      enterKeyHint: null,
      form: null,
      formAction: null,
      formEncType: null,
      formMethod: null,
      formNoValidate: d,
      formTarget: null,
      headers: gA,
      height: AA,
      hidden: d,
      high: AA,
      href: null,
      hrefLang: null,
      htmlFor: gA,
      httpEquiv: gA,
      id: null,
      imageSizes: null,
      imageSrcSet: IA,
      inputMode: null,
      integrity: null,
      is: null,
      isMap: d,
      itemId: null,
      itemProp: gA,
      itemRef: gA,
      itemScope: d,
      itemType: gA,
      kind: null,
      label: null,
      lang: null,
      language: null,
      list: null,
      loading: null,
      loop: d,
      low: AA,
      manifest: null,
      max: null,
      maxLength: AA,
      media: null,
      method: null,
      min: null,
      minLength: AA,
      multiple: d,
      muted: d,
      name: null,
      nonce: null,
      noModule: d,
      noValidate: d,
      onAbort: null,
      onAfterPrint: null,
      onAuxClick: null,
      onBeforePrint: null,
      onBeforeUnload: null,
      onBlur: null,
      onCancel: null,
      onCanPlay: null,
      onCanPlayThrough: null,
      onChange: null,
      onClick: null,
      onClose: null,
      onContextMenu: null,
      onCopy: null,
      onCueChange: null,
      onCut: null,
      onDblClick: null,
      onDrag: null,
      onDragEnd: null,
      onDragEnter: null,
      onDragExit: null,
      onDragLeave: null,
      onDragOver: null,
      onDragStart: null,
      onDrop: null,
      onDurationChange: null,
      onEmptied: null,
      onEnded: null,
      onError: null,
      onFocus: null,
      onFormData: null,
      onHashChange: null,
      onInput: null,
      onInvalid: null,
      onKeyDown: null,
      onKeyPress: null,
      onKeyUp: null,
      onLanguageChange: null,
      onLoad: null,
      onLoadedData: null,
      onLoadedMetadata: null,
      onLoadEnd: null,
      onLoadStart: null,
      onMessage: null,
      onMessageError: null,
      onMouseDown: null,
      onMouseEnter: null,
      onMouseLeave: null,
      onMouseMove: null,
      onMouseOut: null,
      onMouseOver: null,
      onMouseUp: null,
      onOffline: null,
      onOnline: null,
      onPageHide: null,
      onPageShow: null,
      onPaste: null,
      onPause: null,
      onPlay: null,
      onPlaying: null,
      onPopState: null,
      onProgress: null,
      onRateChange: null,
      onRejectionHandled: null,
      onReset: null,
      onResize: null,
      onScroll: null,
      onSecurityPolicyViolation: null,
      onSeeked: null,
      onSeeking: null,
      onSelect: null,
      onSlotChange: null,
      onStalled: null,
      onStorage: null,
      onSubmit: null,
      onSuspend: null,
      onTimeUpdate: null,
      onToggle: null,
      onUnhandledRejection: null,
      onUnload: null,
      onVolumeChange: null,
      onWaiting: null,
      onWheel: null,
      open: d,
      optimum: AA,
      pattern: null,
      ping: gA,
      placeholder: null,
      playsInline: d,
      poster: null,
      preload: null,
      readOnly: d,
      referrerPolicy: null,
      rel: gA,
      required: d,
      reversed: d,
      rows: AA,
      rowSpan: AA,
      sandbox: gA,
      scope: null,
      scoped: d,
      seamless: d,
      selected: d,
      shape: null,
      size: AA,
      sizes: null,
      slot: null,
      span: AA,
      spellCheck: H,
      src: null,
      srcDoc: null,
      srcLang: null,
      srcSet: IA,
      start: AA,
      step: null,
      style: null,
      tabIndex: AA,
      target: null,
      title: null,
      translate: null,
      type: null,
      typeMustMatch: d,
      useMap: null,
      value: H,
      width: AA,
      wrap: null,
      // Legacy.
      // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
      align: null,
      // Several. Use CSS `text-align` instead,
      aLink: null,
      // `<body>`. Use CSS `a:active {color}` instead
      archive: gA,
      // `<object>`. List of URIs to archives
      axis: null,
      // `<td>` and `<th>`. Use `scope` on `<th>`
      background: null,
      // `<body>`. Use CSS `background-image` instead
      bgColor: null,
      // `<body>` and table elements. Use CSS `background-color` instead
      border: AA,
      // `<table>`. Use CSS `border-width` instead,
      borderColor: null,
      // `<table>`. Use CSS `border-color` instead,
      bottomMargin: AA,
      // `<body>`
      cellPadding: null,
      // `<table>`
      cellSpacing: null,
      // `<table>`
      char: null,
      // Several table elements. When `align=char`, sets the character to align on
      charOff: null,
      // Several table elements. When `char`, offsets the alignment
      classId: null,
      // `<object>`
      clear: null,
      // `<br>`. Use CSS `clear` instead
      code: null,
      // `<object>`
      codeBase: null,
      // `<object>`
      codeType: null,
      // `<object>`
      color: null,
      // `<font>` and `<hr>`. Use CSS instead
      compact: d,
      // Lists. Use CSS to reduce space between items instead
      declare: d,
      // `<object>`
      event: null,
      // `<script>`
      face: null,
      // `<font>`. Use CSS instead
      frame: null,
      // `<table>`
      frameBorder: null,
      // `<iframe>`. Use CSS `border` instead
      hSpace: AA,
      // `<img>` and `<object>`
      leftMargin: AA,
      // `<body>`
      link: null,
      // `<body>`. Use CSS `a:link {color: *}` instead
      longDesc: null,
      // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
      lowSrc: null,
      // `<img>`. Use a `<picture>`
      marginHeight: AA,
      // `<body>`
      marginWidth: AA,
      // `<body>`
      noResize: d,
      // `<frame>`
      noHref: d,
      // `<area>`. Use no href instead of an explicit `nohref`
      noShade: d,
      // `<hr>`. Use background-color and height instead of borders
      noWrap: d,
      // `<td>` and `<th>`
      object: null,
      // `<applet>`
      profile: null,
      // `<head>`
      prompt: null,
      // `<isindex>`
      rev: null,
      // `<link>`
      rightMargin: AA,
      // `<body>`
      rules: null,
      // `<table>`
      scheme: null,
      // `<meta>`
      scrolling: H,
      // `<frame>`. Use overflow in the child context
      standby: null,
      // `<object>`
      summary: null,
      // `<table>`
      text: null,
      // `<body>`. Use CSS `color` instead
      topMargin: AA,
      // `<body>`
      valueType: null,
      // `<param>`
      version: null,
      // `<html>`. Use a doctype.
      vAlign: null,
      // Several. Use CSS `vertical-align` instead
      vLink: null,
      // `<body>`. Use CSS `a:visited {color}` instead
      vSpace: AA,
      // `<img>` and `<object>`
      // Non-standard Properties.
      allowTransparency: null,
      autoCorrect: null,
      autoSave: null,
      disablePictureInPicture: d,
      disableRemotePlayback: d,
      prefix: null,
      property: null,
      results: AA,
      security: null,
      unselectable: null
    }
  }), html;
}
var html_1$1, hasRequiredHtml$1;
function requireHtml$1() {
  if (hasRequiredHtml$1) return html_1$1;
  hasRequiredHtml$1 = 1;
  var n = requireMerge(), t = requireXlink(), g = requireXml(), d = requireXmlns(), k = requireAria(), H = requireHtml$2();
  return html_1$1 = n([g, t, d, k, H]), html_1$1;
}
var find_1, hasRequiredFind;
function requireFind() {
  if (hasRequiredFind) return find_1;
  hasRequiredFind = 1;
  var n = requireNormalize(), t = requireDefinedInfo(), g = requireInfo(), d = "data";
  find_1 = gA;
  var k = /^data[-\w.:]+$/i, H = /-[a-z]/g, AA = /[A-Z]/g;
  function gA(iA, QA) {
    var tA = n(QA), oA = QA, EA = g;
    return tA in iA.normal ? iA.property[iA.normal[tA]] : (tA.length > 4 && tA.slice(0, 4) === d && k.test(QA) && (QA.charAt(4) === "-" ? oA = IA(QA) : QA = CA(QA), EA = t), new EA(oA, QA));
  }
  function IA(iA) {
    var QA = iA.slice(5).replace(H, eA);
    return d + QA.charAt(0).toUpperCase() + QA.slice(1);
  }
  function CA(iA) {
    var QA = iA.slice(4);
    return H.test(QA) ? iA : (QA = QA.replace(AA, BA), QA.charAt(0) !== "-" && (QA = "-" + QA), d + QA);
  }
  function BA(iA) {
    return "-" + iA.toLowerCase();
  }
  function eA(iA) {
    return iA.charAt(1).toUpperCase();
  }
  return find_1;
}
var hastUtilParseSelector, hasRequiredHastUtilParseSelector;
function requireHastUtilParseSelector() {
  if (hasRequiredHastUtilParseSelector) return hastUtilParseSelector;
  hasRequiredHastUtilParseSelector = 1, hastUtilParseSelector = t;
  var n = /[#.]/g;
  function t(g, d) {
    for (var k = g || "", H = d || "div", AA = {}, gA = 0, IA, CA, BA; gA < k.length; )
      n.lastIndex = gA, BA = n.exec(k), IA = k.slice(gA, BA ? BA.index : k.length), IA && (CA ? CA === "#" ? AA.id = IA : AA.className ? AA.className.push(IA) : AA.className = [IA] : H = IA, gA += IA.length), BA && (CA = BA[0], gA++);
    return { type: "element", tagName: H, properties: AA, children: [] };
  }
  return hastUtilParseSelector;
}
var spaceSeparatedTokens = {}, hasRequiredSpaceSeparatedTokens;
function requireSpaceSeparatedTokens() {
  if (hasRequiredSpaceSeparatedTokens) return spaceSeparatedTokens;
  hasRequiredSpaceSeparatedTokens = 1, spaceSeparatedTokens.parse = d, spaceSeparatedTokens.stringify = k;
  var n = "", t = " ", g = /[ \t\n\r\f]+/g;
  function d(H) {
    var AA = String(H || n).trim();
    return AA === n ? [] : AA.split(g);
  }
  function k(H) {
    return H.join(t).trim();
  }
  return spaceSeparatedTokens;
}
var commaSeparatedTokens = {}, hasRequiredCommaSeparatedTokens;
function requireCommaSeparatedTokens() {
  if (hasRequiredCommaSeparatedTokens) return commaSeparatedTokens;
  hasRequiredCommaSeparatedTokens = 1, commaSeparatedTokens.parse = d, commaSeparatedTokens.stringify = k;
  var n = ",", t = " ", g = "";
  function d(H) {
    for (var AA = [], gA = String(H || g), IA = gA.indexOf(n), CA = 0, BA = !1, eA; !BA; )
      IA === -1 && (IA = gA.length, BA = !0), eA = gA.slice(CA, IA).trim(), (eA || !BA) && AA.push(eA), CA = IA + 1, IA = gA.indexOf(n, CA);
    return AA;
  }
  function k(H, AA) {
    var gA = AA || {}, IA = gA.padLeft === !1 ? g : t, CA = gA.padRight ? t : g;
    return H[H.length - 1] === g && (H = H.concat(g)), H.join(CA + n + IA).trim();
  }
  return commaSeparatedTokens;
}
var factory_1, hasRequiredFactory;
function requireFactory() {
  if (hasRequiredFactory) return factory_1;
  hasRequiredFactory = 1;
  var n = requireFind(), t = requireNormalize(), g = requireHastUtilParseSelector(), d = requireSpaceSeparatedTokens().parse, k = requireCommaSeparatedTokens().parse;
  factory_1 = AA;
  var H = {}.hasOwnProperty;
  function AA(tA, oA, EA) {
    var aA = EA ? QA(EA) : null;
    return nA;
    function nA(cA, sA) {
      var rA = g(cA, oA), uA = Array.prototype.slice.call(arguments, 2), hA = rA.tagName.toLowerCase(), dA;
      if (rA.tagName = aA && H.call(aA, hA) ? aA[hA] : hA, sA && gA(sA, rA) && (uA.unshift(sA), sA = null), sA)
        for (dA in sA)
          lA(rA.properties, dA, sA[dA]);
      return CA(rA.children, uA), rA.tagName === "template" && (rA.content = { type: "root", children: rA.children }, rA.children = []), rA;
    }
    function lA(cA, sA, rA) {
      var uA, hA, dA;
      rA == null || rA !== rA || (uA = n(tA, sA), hA = uA.property, dA = rA, typeof dA == "string" && (uA.spaceSeparated ? dA = d(dA) : uA.commaSeparated ? dA = k(dA) : uA.commaOrSpaceSeparated && (dA = d(k(dA).join(" ")))), hA === "style" && typeof rA != "string" && (dA = iA(dA)), hA === "className" && cA.className && (dA = cA.className.concat(dA)), cA[hA] = BA(uA, hA, dA));
    }
  }
  function gA(tA, oA) {
    return typeof tA == "string" || "length" in tA || IA(oA.tagName, tA);
  }
  function IA(tA, oA) {
    var EA = oA.type;
    return tA === "input" || !EA || typeof EA != "string" ? !1 : typeof oA.children == "object" && "length" in oA.children ? !0 : (EA = EA.toLowerCase(), tA === "button" ? EA !== "menu" && EA !== "submit" && EA !== "reset" && EA !== "button" : "value" in oA);
  }
  function CA(tA, oA) {
    var EA, aA;
    if (typeof oA == "string" || typeof oA == "number") {
      tA.push({ type: "text", value: String(oA) });
      return;
    }
    if (typeof oA == "object" && "length" in oA) {
      for (EA = -1, aA = oA.length; ++EA < aA; )
        CA(tA, oA[EA]);
      return;
    }
    if (typeof oA != "object" || !("type" in oA))
      throw new Error("Expected node, nodes, or string, got `" + oA + "`");
    tA.push(oA);
  }
  function BA(tA, oA, EA) {
    var aA, nA, lA;
    if (typeof EA != "object" || !("length" in EA))
      return eA(tA, oA, EA);
    for (nA = EA.length, aA = -1, lA = []; ++aA < nA; )
      lA[aA] = eA(tA, oA, EA[aA]);
    return lA;
  }
  function eA(tA, oA, EA) {
    var aA = EA;
    return tA.number || tA.positiveNumber ? !isNaN(aA) && aA !== "" && (aA = Number(aA)) : (tA.boolean || tA.overloadedBoolean) && typeof aA == "string" && (aA === "" || t(EA) === t(oA)) && (aA = !0), aA;
  }
  function iA(tA) {
    var oA = [], EA;
    for (EA in tA)
      oA.push([EA, tA[EA]].join(": "));
    return oA.join("; ");
  }
  function QA(tA) {
    for (var oA = tA.length, EA = -1, aA = {}, nA; ++EA < oA; )
      nA = tA[EA], aA[nA.toLowerCase()] = nA;
    return aA;
  }
  return factory_1;
}
var html_1, hasRequiredHtml;
function requireHtml() {
  if (hasRequiredHtml) return html_1;
  hasRequiredHtml = 1;
  var n = requireHtml$1(), t = requireFactory(), g = t(n, "div");
  return g.displayName = "html", html_1 = g, html_1;
}
var hastscript, hasRequiredHastscript;
function requireHastscript() {
  return hasRequiredHastscript || (hasRequiredHastscript = 1, hastscript = requireHtml()), hastscript;
}
const AElig = "Æ", AMP = "&", Aacute = "Á", Acirc = "Â", Agrave = "À", Aring = "Å", Atilde = "Ã", Auml = "Ä", COPY = "©", Ccedil = "Ç", ETH = "Ð", Eacute = "É", Ecirc = "Ê", Egrave = "È", Euml = "Ë", GT$1 = ">", Iacute = "Í", Icirc = "Î", Igrave = "Ì", Iuml = "Ï", LT = "<", Ntilde = "Ñ", Oacute = "Ó", Ocirc = "Ô", Ograve = "Ò", Oslash = "Ø", Otilde = "Õ", Ouml = "Ö", QUOT = '"', REG = "®", THORN = "Þ", Uacute = "Ú", Ucirc = "Û", Ugrave = "Ù", Uuml = "Ü", Yacute = "Ý", aacute = "á", acirc = "â", acute = "´", aelig = "æ", agrave = "à", amp = "&", aring = "å", atilde = "ã", auml = "ä", brvbar = "¦", ccedil = "ç", cedil = "¸", cent = "¢", copy$3 = "©", curren = "¤", deg = "°", divide$1 = "÷", eacute = "é", ecirc = "ê", egrave = "è", eth = "ð", euml = "ë", frac12 = "½", frac14 = "¼", frac34 = "¾", gt$1 = ">", iacute = "í", icirc = "î", iexcl = "¡", igrave = "ì", iquest = "¿", iuml = "ï", laquo = "«", lt$1 = "<", macr = "¯", micro = "µ", middot = "·", nbsp = " ", not = "¬", ntilde = "ñ", oacute = "ó", ocirc = "ô", ograve = "ò", ordf = "ª", ordm = "º", oslash = "ø", otilde = "õ", ouml = "ö", para = "¶", plusmn = "±", pound = "£", quot = '"', raquo = "»", reg$1 = "®", sect = "§", shy = "­", sup1 = "¹", sup2 = "²", sup3 = "³", szlig = "ß", thorn = "þ", times = "×", uacute = "ú", ucirc = "û", ugrave = "ù", uml = "¨", uuml = "ü", yacute = "ý", yen = "¥", yuml = "ÿ", require$$0$2 = {
  AElig,
  AMP,
  Aacute,
  Acirc,
  Agrave,
  Aring,
  Atilde,
  Auml,
  COPY,
  Ccedil,
  ETH,
  Eacute,
  Ecirc,
  Egrave,
  Euml,
  GT: GT$1,
  Iacute,
  Icirc,
  Igrave,
  Iuml,
  LT,
  Ntilde,
  Oacute,
  Ocirc,
  Ograve,
  Oslash,
  Otilde,
  Ouml,
  QUOT,
  REG,
  THORN,
  Uacute,
  Ucirc,
  Ugrave,
  Uuml,
  Yacute,
  aacute,
  acirc,
  acute,
  aelig,
  agrave,
  amp,
  aring,
  atilde,
  auml,
  brvbar,
  ccedil,
  cedil,
  cent,
  copy: copy$3,
  curren,
  deg,
  divide: divide$1,
  eacute,
  ecirc,
  egrave,
  eth,
  euml,
  frac12,
  frac14,
  frac34,
  gt: gt$1,
  iacute,
  icirc,
  iexcl,
  igrave,
  iquest,
  iuml,
  laquo,
  lt: lt$1,
  macr,
  micro,
  middot,
  nbsp,
  not,
  ntilde,
  oacute,
  ocirc,
  ograve,
  ordf,
  ordm,
  oslash,
  otilde,
  ouml,
  para,
  plusmn,
  pound,
  quot,
  raquo,
  reg: reg$1,
  sect,
  shy,
  sup1,
  sup2,
  sup3,
  szlig,
  thorn,
  times,
  uacute,
  ucirc,
  ugrave,
  uml,
  uuml,
  yacute,
  yen,
  yuml
}, require$$1$1 = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
var isDecimal, hasRequiredIsDecimal;
function requireIsDecimal() {
  if (hasRequiredIsDecimal) return isDecimal;
  hasRequiredIsDecimal = 1, isDecimal = n;
  function n(t) {
    var g = typeof t == "string" ? t.charCodeAt(0) : t;
    return g >= 48 && g <= 57;
  }
  return isDecimal;
}
var isHexadecimal, hasRequiredIsHexadecimal;
function requireIsHexadecimal() {
  if (hasRequiredIsHexadecimal) return isHexadecimal;
  hasRequiredIsHexadecimal = 1, isHexadecimal = n;
  function n(t) {
    var g = typeof t == "string" ? t.charCodeAt(0) : t;
    return g >= 97 && g <= 102 || g >= 65 && g <= 70 || g >= 48 && g <= 57;
  }
  return isHexadecimal;
}
var isAlphabetical, hasRequiredIsAlphabetical;
function requireIsAlphabetical() {
  if (hasRequiredIsAlphabetical) return isAlphabetical;
  hasRequiredIsAlphabetical = 1, isAlphabetical = n;
  function n(t) {
    var g = typeof t == "string" ? t.charCodeAt(0) : t;
    return g >= 97 && g <= 122 || g >= 65 && g <= 90;
  }
  return isAlphabetical;
}
var isAlphanumerical, hasRequiredIsAlphanumerical;
function requireIsAlphanumerical() {
  if (hasRequiredIsAlphanumerical) return isAlphanumerical;
  hasRequiredIsAlphanumerical = 1;
  var n = requireIsAlphabetical(), t = requireIsDecimal();
  isAlphanumerical = g;
  function g(d) {
    return n(d) || t(d);
  }
  return isAlphanumerical;
}
var decodeEntity_browser, hasRequiredDecodeEntity_browser;
function requireDecodeEntity_browser() {
  if (hasRequiredDecodeEntity_browser) return decodeEntity_browser;
  hasRequiredDecodeEntity_browser = 1;
  var n, t = 59;
  decodeEntity_browser = g;
  function g(d) {
    var k = "&" + d + ";", H;
    return n = n || document.createElement("i"), n.innerHTML = k, H = n.textContent, H.charCodeAt(H.length - 1) === t && d !== "semi" || H === k ? !1 : H;
  }
  return decodeEntity_browser;
}
var parseEntities_1, hasRequiredParseEntities;
function requireParseEntities() {
  if (hasRequiredParseEntities) return parseEntities_1;
  hasRequiredParseEntities = 1;
  var n = require$$0$2, t = require$$1$1, g = requireIsDecimal(), d = requireIsHexadecimal(), k = requireIsAlphanumerical(), H = requireDecodeEntity_browser();
  parseEntities_1 = TA;
  var AA = {}.hasOwnProperty, gA = String.fromCharCode, IA = Function.prototype, CA = {
    warning: null,
    reference: null,
    text: null,
    warningContext: null,
    referenceContext: null,
    textContext: null,
    position: {},
    additional: null,
    attribute: !1,
    nonTerminated: !0
  }, BA = 9, eA = 10, iA = 12, QA = 32, tA = 38, oA = 59, EA = 60, aA = 61, nA = 35, lA = 88, cA = 120, sA = 65533, rA = "named", uA = "hexadecimal", hA = "decimal", dA = {};
  dA[uA] = 16, dA[hA] = 10;
  var GA = {};
  GA[rA] = k, GA[hA] = g, GA[uA] = d;
  var DA = 1, wA = 2, bA = 3, yA = 4, pA = 5, MA = 6, LA = 7, xA = {};
  xA[DA] = "Named character references must be terminated by a semicolon", xA[wA] = "Numeric character references must be terminated by a semicolon", xA[bA] = "Named character references cannot be empty", xA[yA] = "Numeric character references cannot be empty", xA[pA] = "Named character references must be known", xA[MA] = "Numeric character references cannot be disallowed", xA[LA] = "Numeric character references cannot be outside the permissible Unicode range";
  function TA(fA, vA) {
    var Cg = {}, Ig, gg;
    vA || (vA = {});
    for (gg in CA)
      Ig = vA[gg], Cg[gg] = Ig ?? CA[gg];
    return (Cg.position.indent || Cg.position.start) && (Cg.indent = Cg.position.indent || [], Cg.position = Cg.position.start), NA(fA, Cg);
  }
  function NA(fA, vA) {
    var Cg = vA.additional, Ig = vA.nonTerminated, gg = vA.text, og = vA.reference, eg = vA.warning, kA = vA.textContext, YA = vA.referenceContext, RA = vA.warningContext, FA = vA.position, mA = vA.indent || [], JA = fA.length, VA = 0, HA = -1, jA = FA.column || 1, _A = FA.line || 1, $A = "", rg = [], wg, Dg, kg, ig, ZA, KA, PA, ag, Gg, bg, yg, hg, tg, Eg, cg, sg, ug, Mg, Rg;
    for (typeof Cg == "string" && (Cg = Cg.charCodeAt(0)), sg = Jg(), ag = eg ? Hg : IA, VA--, JA++; ++VA < JA; )
      if (ZA === eA && (jA = mA[HA] || 1), ZA = fA.charCodeAt(VA), ZA === tA) {
        if (PA = fA.charCodeAt(VA + 1), PA === BA || PA === eA || PA === iA || PA === QA || PA === tA || PA === EA || PA !== PA || Cg && PA === Cg) {
          $A += gA(ZA), jA++;
          continue;
        }
        for (tg = VA + 1, hg = tg, Rg = tg, PA === nA ? (Rg = ++hg, PA = fA.charCodeAt(Rg), PA === lA || PA === cA ? (Eg = uA, Rg = ++hg) : Eg = hA) : Eg = rA, wg = "", yg = "", ig = "", cg = GA[Eg], Rg--; ++Rg < JA && (PA = fA.charCodeAt(Rg), !!cg(PA)); )
          ig += gA(PA), Eg === rA && AA.call(n, ig) && (wg = ig, yg = n[ig]);
        kg = fA.charCodeAt(Rg) === oA, kg && (Rg++, Dg = Eg === rA ? H(ig) : !1, Dg && (wg = ig, yg = Dg)), Mg = 1 + Rg - tg, !kg && !Ig || (ig ? Eg === rA ? (kg && !yg ? ag(pA, 1) : (wg !== ig && (Rg = hg + wg.length, Mg = 1 + Rg - hg, kg = !1), kg || (Gg = wg ? DA : bA, vA.attribute ? (PA = fA.charCodeAt(Rg), PA === aA ? (ag(Gg, Mg), yg = null) : k(PA) ? yg = null : ag(Gg, Mg)) : ag(Gg, Mg))), KA = yg) : (kg || ag(wA, Mg), KA = parseInt(ig, dA[Eg]), zA(KA) ? (ag(LA, Mg), KA = gA(sA)) : KA in t ? (ag(MA, Mg), KA = t[KA]) : (bg = "", XA(KA) && ag(MA, Mg), KA > 65535 && (KA -= 65536, bg += gA(KA >>> 10 | 55296), KA = 56320 | KA & 1023), KA = bg + gA(KA))) : Eg !== rA && ag(yA, Mg)), KA ? (mg(), sg = Jg(), VA = Rg - 1, jA += Rg - tg + 1, rg.push(KA), ug = Jg(), ug.offset++, og && og.call(
          YA,
          KA,
          { start: sg, end: ug },
          fA.slice(tg - 1, Rg)
        ), sg = ug) : (ig = fA.slice(tg - 1, Rg), $A += ig, jA += ig.length, VA = Rg - 1);
      } else
        ZA === 10 && (_A++, HA++, jA = 0), ZA === ZA ? ($A += gA(ZA), jA++) : mg();
    return rg.join("");
    function Jg() {
      return {
        line: _A,
        column: jA,
        offset: VA + (FA.offset || 0)
      };
    }
    function Hg(Og, Kg) {
      var vg = Jg();
      vg.column += Kg, vg.offset += Kg, eg.call(RA, xA[Og], vg, Og);
    }
    function mg() {
      $A && (rg.push($A), gg && gg.call(kA, $A, { start: sg, end: Jg() }), $A = "");
    }
  }
  function zA(fA) {
    return fA >= 55296 && fA <= 57343 || fA > 1114111;
  }
  function XA(fA) {
    return fA >= 1 && fA <= 8 || fA === 11 || fA >= 13 && fA <= 31 || fA >= 127 && fA <= 159 || fA >= 64976 && fA <= 65007 || (fA & 65535) === 65535 || (fA & 65535) === 65534;
  }
  return parseEntities_1;
}
var prismCore = { exports: {} }, hasRequiredPrismCore;
function requirePrismCore() {
  return hasRequiredPrismCore || (hasRequiredPrismCore = 1, (function(n) {
    var t = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {};
    var g = (function(d) {
      var k = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, H = 0, AA = {}, gA = {
        /**
         * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
         * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
         * additional languages or plugins yourself.
         *
         * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
         *
         * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
         * empty Prism object into the global scope before loading the Prism script like this:
         *
         * ```js
         * window.Prism = window.Prism || {};
         * Prism.manual = true;
         * // add a new <script> to load Prism's script
         * ```
         *
         * @default false
         * @type {boolean}
         * @memberof Prism
         * @public
         */
        manual: d.Prism && d.Prism.manual,
        /**
         * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
         * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
         * own worker, you don't want it to do this.
         *
         * By setting this value to `true`, Prism will not add its own listeners to the worker.
         *
         * You obviously have to change this value before Prism executes. To do this, you can add an
         * empty Prism object into the global scope before loading the Prism script like this:
         *
         * ```js
         * window.Prism = window.Prism || {};
         * Prism.disableWorkerMessageHandler = true;
         * // Load Prism's script
         * ```
         *
         * @default false
         * @type {boolean}
         * @memberof Prism
         * @public
         */
        disableWorkerMessageHandler: d.Prism && d.Prism.disableWorkerMessageHandler,
        /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */
        util: {
          encode: function nA(lA) {
            return lA instanceof IA ? new IA(lA.type, nA(lA.content), lA.alias) : Array.isArray(lA) ? lA.map(nA) : lA.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
          },
          /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */
          type: function(nA) {
            return Object.prototype.toString.call(nA).slice(8, -1);
          },
          /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */
          objId: function(nA) {
            return nA.__id || Object.defineProperty(nA, "__id", { value: ++H }), nA.__id;
          },
          /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */
          clone: function nA(lA, cA) {
            cA = cA || {};
            var sA, rA;
            switch (gA.util.type(lA)) {
              case "Object":
                if (rA = gA.util.objId(lA), cA[rA])
                  return cA[rA];
                sA = /** @type {Record<string, any>} */
                {}, cA[rA] = sA;
                for (var uA in lA)
                  lA.hasOwnProperty(uA) && (sA[uA] = nA(lA[uA], cA));
                return (
                  /** @type {any} */
                  sA
                );
              case "Array":
                return rA = gA.util.objId(lA), cA[rA] ? cA[rA] : (sA = [], cA[rA] = sA, /** @type {Array} */
                /** @type {any} */
                lA.forEach(function(hA, dA) {
                  sA[dA] = nA(hA, cA);
                }), /** @type {any} */
                sA);
              default:
                return lA;
            }
          },
          /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */
          getLanguage: function(nA) {
            for (; nA; ) {
              var lA = k.exec(nA.className);
              if (lA)
                return lA[1].toLowerCase();
              nA = nA.parentElement;
            }
            return "none";
          },
          /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */
          setLanguage: function(nA, lA) {
            nA.className = nA.className.replace(RegExp(k, "gi"), ""), nA.classList.add("language-" + lA);
          },
          /**
           * Returns the script element that is currently executing.
           *
           * This does __not__ work for line script element.
           *
           * @returns {HTMLScriptElement | null}
           */
          currentScript: function() {
            if (typeof document > "u")
              return null;
            if ("currentScript" in document)
              return (
                /** @type {any} */
                document.currentScript
              );
            try {
              throw new Error();
            } catch (sA) {
              var nA = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(sA.stack) || [])[1];
              if (nA) {
                var lA = document.getElementsByTagName("script");
                for (var cA in lA)
                  if (lA[cA].src == nA)
                    return lA[cA];
              }
              return null;
            }
          },
          /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */
          isActive: function(nA, lA, cA) {
            for (var sA = "no-" + lA; nA; ) {
              var rA = nA.classList;
              if (rA.contains(lA))
                return !0;
              if (rA.contains(sA))
                return !1;
              nA = nA.parentElement;
            }
            return !!cA;
          }
        },
        /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */
        languages: {
          /**
           * The grammar for plain, unformatted text.
           */
          plain: AA,
          plaintext: AA,
          text: AA,
          txt: AA,
          /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */
          extend: function(nA, lA) {
            var cA = gA.util.clone(gA.languages[nA]);
            for (var sA in lA)
              cA[sA] = lA[sA];
            return cA;
          },
          /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */
          insertBefore: function(nA, lA, cA, sA) {
            sA = sA || /** @type {any} */
            gA.languages;
            var rA = sA[nA], uA = {};
            for (var hA in rA)
              if (rA.hasOwnProperty(hA)) {
                if (hA == lA)
                  for (var dA in cA)
                    cA.hasOwnProperty(dA) && (uA[dA] = cA[dA]);
                cA.hasOwnProperty(hA) || (uA[hA] = rA[hA]);
              }
            var GA = sA[nA];
            return sA[nA] = uA, gA.languages.DFS(gA.languages, function(DA, wA) {
              wA === GA && DA != nA && (this[DA] = uA);
            }), uA;
          },
          // Traverse a language definition with Depth First Search
          DFS: function nA(lA, cA, sA, rA) {
            rA = rA || {};
            var uA = gA.util.objId;
            for (var hA in lA)
              if (lA.hasOwnProperty(hA)) {
                cA.call(lA, hA, lA[hA], sA || hA);
                var dA = lA[hA], GA = gA.util.type(dA);
                GA === "Object" && !rA[uA(dA)] ? (rA[uA(dA)] = !0, nA(dA, cA, null, rA)) : GA === "Array" && !rA[uA(dA)] && (rA[uA(dA)] = !0, nA(dA, cA, hA, rA));
              }
          }
        },
        plugins: {},
        /**
         * This is the most high-level function in Prism’s API.
         * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
         * each one of them.
         *
         * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
         *
         * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
         * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
         * @memberof Prism
         * @public
         */
        highlightAll: function(nA, lA) {
          gA.highlightAllUnder(document, nA, lA);
        },
        /**
         * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
         * {@link Prism.highlightElement} on each one of them.
         *
         * The following hooks will be run:
         * 1. `before-highlightall`
         * 2. `before-all-elements-highlight`
         * 3. All hooks of {@link Prism.highlightElement} for each element.
         *
         * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
         * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
         * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
         * @memberof Prism
         * @public
         */
        highlightAllUnder: function(nA, lA, cA) {
          var sA = {
            callback: cA,
            container: nA,
            selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
          };
          gA.hooks.run("before-highlightall", sA), sA.elements = Array.prototype.slice.apply(sA.container.querySelectorAll(sA.selector)), gA.hooks.run("before-all-elements-highlight", sA);
          for (var rA = 0, uA; uA = sA.elements[rA++]; )
            gA.highlightElement(uA, lA === !0, sA.callback);
        },
        /**
         * Highlights the code inside a single element.
         *
         * The following hooks will be run:
         * 1. `before-sanity-check`
         * 2. `before-highlight`
         * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
         * 4. `before-insert`
         * 5. `after-highlight`
         * 6. `complete`
         *
         * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
         * the element's language.
         *
         * @param {Element} element The element containing the code.
         * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
         * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
         * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
         * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
         *
         * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
         * asynchronous highlighting to work. You can build your own bundle on the
         * [Download page](https://prismjs.com/download.html).
         * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
         * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
         * @memberof Prism
         * @public
         */
        highlightElement: function(nA, lA, cA) {
          var sA = gA.util.getLanguage(nA), rA = gA.languages[sA];
          gA.util.setLanguage(nA, sA);
          var uA = nA.parentElement;
          uA && uA.nodeName.toLowerCase() === "pre" && gA.util.setLanguage(uA, sA);
          var hA = nA.textContent, dA = {
            element: nA,
            language: sA,
            grammar: rA,
            code: hA
          };
          function GA(wA) {
            dA.highlightedCode = wA, gA.hooks.run("before-insert", dA), dA.element.innerHTML = dA.highlightedCode, gA.hooks.run("after-highlight", dA), gA.hooks.run("complete", dA), cA && cA.call(dA.element);
          }
          if (gA.hooks.run("before-sanity-check", dA), uA = dA.element.parentElement, uA && uA.nodeName.toLowerCase() === "pre" && !uA.hasAttribute("tabindex") && uA.setAttribute("tabindex", "0"), !dA.code) {
            gA.hooks.run("complete", dA), cA && cA.call(dA.element);
            return;
          }
          if (gA.hooks.run("before-highlight", dA), !dA.grammar) {
            GA(gA.util.encode(dA.code));
            return;
          }
          if (lA && d.Worker) {
            var DA = new Worker(gA.filename);
            DA.onmessage = function(wA) {
              GA(wA.data);
            }, DA.postMessage(JSON.stringify({
              language: dA.language,
              code: dA.code,
              immediateClose: !0
            }));
          } else
            GA(gA.highlight(dA.code, dA.grammar, dA.language));
        },
        /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */
        highlight: function(nA, lA, cA) {
          var sA = {
            code: nA,
            grammar: lA,
            language: cA
          };
          if (gA.hooks.run("before-tokenize", sA), !sA.grammar)
            throw new Error('The language "' + sA.language + '" has no grammar.');
          return sA.tokens = gA.tokenize(sA.code, sA.grammar), gA.hooks.run("after-tokenize", sA), IA.stringify(gA.util.encode(sA.tokens), sA.language);
        },
        /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */
        tokenize: function(nA, lA) {
          var cA = lA.rest;
          if (cA) {
            for (var sA in cA)
              lA[sA] = cA[sA];
            delete lA.rest;
          }
          var rA = new eA();
          return iA(rA, rA.head, nA), BA(nA, rA, lA, rA.head, 0), tA(rA);
        },
        /**
         * @namespace
         * @memberof Prism
         * @public
         */
        hooks: {
          all: {},
          /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */
          add: function(nA, lA) {
            var cA = gA.hooks.all;
            cA[nA] = cA[nA] || [], cA[nA].push(lA);
          },
          /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */
          run: function(nA, lA) {
            var cA = gA.hooks.all[nA];
            if (!(!cA || !cA.length))
              for (var sA = 0, rA; rA = cA[sA++]; )
                rA(lA);
          }
        },
        Token: IA
      };
      d.Prism = gA;
      function IA(nA, lA, cA, sA) {
        this.type = nA, this.content = lA, this.alias = cA, this.length = (sA || "").length | 0;
      }
      IA.stringify = function nA(lA, cA) {
        if (typeof lA == "string")
          return lA;
        if (Array.isArray(lA)) {
          var sA = "";
          return lA.forEach(function(GA) {
            sA += nA(GA, cA);
          }), sA;
        }
        var rA = {
          type: lA.type,
          content: nA(lA.content, cA),
          tag: "span",
          classes: ["token", lA.type],
          attributes: {},
          language: cA
        }, uA = lA.alias;
        uA && (Array.isArray(uA) ? Array.prototype.push.apply(rA.classes, uA) : rA.classes.push(uA)), gA.hooks.run("wrap", rA);
        var hA = "";
        for (var dA in rA.attributes)
          hA += " " + dA + '="' + (rA.attributes[dA] || "").replace(/"/g, "&quot;") + '"';
        return "<" + rA.tag + ' class="' + rA.classes.join(" ") + '"' + hA + ">" + rA.content + "</" + rA.tag + ">";
      };
      function CA(nA, lA, cA, sA) {
        nA.lastIndex = lA;
        var rA = nA.exec(cA);
        if (rA && sA && rA[1]) {
          var uA = rA[1].length;
          rA.index += uA, rA[0] = rA[0].slice(uA);
        }
        return rA;
      }
      function BA(nA, lA, cA, sA, rA, uA) {
        for (var hA in cA)
          if (!(!cA.hasOwnProperty(hA) || !cA[hA])) {
            var dA = cA[hA];
            dA = Array.isArray(dA) ? dA : [dA];
            for (var GA = 0; GA < dA.length; ++GA) {
              if (uA && uA.cause == hA + "," + GA)
                return;
              var DA = dA[GA], wA = DA.inside, bA = !!DA.lookbehind, yA = !!DA.greedy, pA = DA.alias;
              if (yA && !DA.pattern.global) {
                var MA = DA.pattern.toString().match(/[imsuy]*$/)[0];
                DA.pattern = RegExp(DA.pattern.source, MA + "g");
              }
              for (var LA = DA.pattern || DA, xA = sA.next, TA = rA; xA !== lA.tail && !(uA && TA >= uA.reach); TA += xA.value.length, xA = xA.next) {
                var NA = xA.value;
                if (lA.length > nA.length)
                  return;
                if (!(NA instanceof IA)) {
                  var zA = 1, XA;
                  if (yA) {
                    if (XA = CA(LA, TA, nA, bA), !XA || XA.index >= nA.length)
                      break;
                    var Ig = XA.index, fA = XA.index + XA[0].length, vA = TA;
                    for (vA += xA.value.length; Ig >= vA; )
                      xA = xA.next, vA += xA.value.length;
                    if (vA -= xA.value.length, TA = vA, xA.value instanceof IA)
                      continue;
                    for (var Cg = xA; Cg !== lA.tail && (vA < fA || typeof Cg.value == "string"); Cg = Cg.next)
                      zA++, vA += Cg.value.length;
                    zA--, NA = nA.slice(TA, vA), XA.index -= TA;
                  } else if (XA = CA(LA, 0, NA, bA), !XA)
                    continue;
                  var Ig = XA.index, gg = XA[0], og = NA.slice(0, Ig), eg = NA.slice(Ig + gg.length), kA = TA + NA.length;
                  uA && kA > uA.reach && (uA.reach = kA);
                  var YA = xA.prev;
                  og && (YA = iA(lA, YA, og), TA += og.length), QA(lA, YA, zA);
                  var RA = new IA(hA, wA ? gA.tokenize(gg, wA) : gg, pA, gg);
                  if (xA = iA(lA, YA, RA), eg && iA(lA, xA, eg), zA > 1) {
                    var FA = {
                      cause: hA + "," + GA,
                      reach: kA
                    };
                    BA(nA, lA, cA, xA.prev, TA, FA), uA && FA.reach > uA.reach && (uA.reach = FA.reach);
                  }
                }
              }
            }
          }
      }
      function eA() {
        var nA = { value: null, prev: null, next: null }, lA = { value: null, prev: nA, next: null };
        nA.next = lA, this.head = nA, this.tail = lA, this.length = 0;
      }
      function iA(nA, lA, cA) {
        var sA = lA.next, rA = { value: cA, prev: lA, next: sA };
        return lA.next = rA, sA.prev = rA, nA.length++, rA;
      }
      function QA(nA, lA, cA) {
        for (var sA = lA.next, rA = 0; rA < cA && sA !== nA.tail; rA++)
          sA = sA.next;
        lA.next = sA, sA.prev = lA, nA.length -= rA;
      }
      function tA(nA) {
        for (var lA = [], cA = nA.head.next; cA !== nA.tail; )
          lA.push(cA.value), cA = cA.next;
        return lA;
      }
      if (!d.document)
        return d.addEventListener && (gA.disableWorkerMessageHandler || d.addEventListener("message", function(nA) {
          var lA = JSON.parse(nA.data), cA = lA.language, sA = lA.code, rA = lA.immediateClose;
          d.postMessage(gA.highlight(sA, gA.languages[cA], cA)), rA && d.close();
        }, !1)), gA;
      var oA = gA.util.currentScript();
      oA && (gA.filename = oA.src, oA.hasAttribute("data-manual") && (gA.manual = !0));
      function EA() {
        gA.manual || gA.highlightAll();
      }
      if (!gA.manual) {
        var aA = document.readyState;
        aA === "loading" || aA === "interactive" && oA && oA.defer ? document.addEventListener("DOMContentLoaded", EA) : window.requestAnimationFrame ? window.requestAnimationFrame(EA) : window.setTimeout(EA, 16);
      }
      return gA;
    })(t);
    n.exports && (n.exports = g), typeof commonjsGlobal$2 < "u" && (commonjsGlobal$2.Prism = g);
  })(prismCore)), prismCore.exports;
}
var markup_1, hasRequiredMarkup;
function requireMarkup() {
  if (hasRequiredMarkup) return markup_1;
  hasRequiredMarkup = 1, markup_1 = n, n.displayName = "markup", n.aliases = ["html", "mathml", "svg", "xml", "ssml", "atom", "rss"];
  function n(t) {
    t.languages.markup = {
      comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: !0
      },
      prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: !0
      },
      doctype: {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: !0,
        inside: {
          "internal-subset": {
            pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
            lookbehind: !0,
            greedy: !0,
            inside: null
            // see below
          },
          string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: !0
          },
          punctuation: /^<!|>$|[[\]]/,
          "doctype-tag": /^DOCTYPE/i,
          name: /[^\s<>'"]+/
        }
      },
      cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: !0
      },
      tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: !0,
        inside: {
          tag: {
            pattern: /^<\/?[^\s>\/]+/,
            inside: {
              punctuation: /^<\/?/,
              namespace: /^[^\s>\/:]+:/
            }
          },
          "special-attr": [],
          "attr-value": {
            pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
            inside: {
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          },
          punctuation: /\/?>/,
          "attr-name": {
            pattern: /[^\s>\/]+/,
            inside: {
              namespace: /^[^\s>\/:]+:/
            }
          }
        }
      },
      entity: [
        {
          pattern: /&[\da-z]{1,8};/i,
          alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
      ]
    }, t.languages.markup.tag.inside["attr-value"].inside.entity = t.languages.markup.entity, t.languages.markup.doctype.inside["internal-subset"].inside = t.languages.markup, t.hooks.add("wrap", function(g) {
      g.type === "entity" && (g.attributes.title = g.content.value.replace(/&amp;/, "&"));
    }), Object.defineProperty(t.languages.markup.tag, "addInlined", {
      /**
       * Adds an inlined language to markup.
       *
       * An example of an inlined language is CSS with `<style>` tags.
       *
       * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
       * case insensitive.
       * @param {string} lang The language key.
       * @example
       * addInlined('style', 'css');
       */
      value: function(d, k) {
        var H = {};
        H["language-" + k] = {
          pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
          lookbehind: !0,
          inside: t.languages[k]
        }, H.cdata = /^<!\[CDATA\[|\]\]>$/i;
        var AA = {
          "included-cdata": {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            inside: H
          }
        };
        AA["language-" + k] = {
          pattern: /[\s\S]+/,
          inside: t.languages[k]
        };
        var gA = {};
        gA[d] = {
          pattern: RegExp(
            /(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(
              /__/g,
              function() {
                return d;
              }
            ),
            "i"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: AA
        }, t.languages.insertBefore("markup", "cdata", gA);
      }
    }), Object.defineProperty(t.languages.markup.tag, "addAttribute", {
      /**
       * Adds an pattern to highlight languages embedded in HTML attributes.
       *
       * An example of an inlined language is CSS with `style` attributes.
       *
       * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
       * case insensitive.
       * @param {string} lang The language key.
       * @example
       * addAttribute('style', 'css');
       */
      value: function(g, d) {
        t.languages.markup.tag.inside["special-attr"].push({
          pattern: RegExp(
            /(^|["'\s])/.source + "(?:" + g + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
            "i"
          ),
          lookbehind: !0,
          inside: {
            "attr-name": /^[^\s=]+/,
            "attr-value": {
              pattern: /=[\s\S]+/,
              inside: {
                value: {
                  pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                  lookbehind: !0,
                  alias: [d, "language-" + d],
                  inside: t.languages[d]
                },
                punctuation: [
                  {
                    pattern: /^=/,
                    alias: "attr-equals"
                  },
                  /"|'/
                ]
              }
            }
          }
        });
      }
    }), t.languages.html = t.languages.markup, t.languages.mathml = t.languages.markup, t.languages.svg = t.languages.markup, t.languages.xml = t.languages.extend("markup", {}), t.languages.ssml = t.languages.xml, t.languages.atom = t.languages.xml, t.languages.rss = t.languages.xml;
  }
  return markup_1;
}
var css_1, hasRequiredCss;
function requireCss() {
  if (hasRequiredCss) return css_1;
  hasRequiredCss = 1, css_1 = n, n.displayName = "css", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
      g.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
          pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
          inside: {
            rule: /^@[\w-]+/,
            "selector-function-argument": {
              pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
              lookbehind: !0,
              alias: "selector"
            },
            keyword: {
              pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
              lookbehind: !0
            }
            // See rest below
          }
        },
        url: {
          // https://drafts.csswg.org/css-values-3/#urls
          pattern: RegExp(
            "\\burl\\((?:" + d.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)",
            "i"
          ),
          greedy: !0,
          inside: {
            function: /^url/i,
            punctuation: /^\(|\)$/,
            string: {
              pattern: RegExp("^" + d.source + "$"),
              alias: "url"
            }
          }
        },
        selector: {
          pattern: RegExp(
            `(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + d.source + ")*(?=\\s*\\{)"
          ),
          lookbehind: !0
        },
        string: {
          pattern: d,
          greedy: !0
        },
        property: {
          pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
          lookbehind: !0
        },
        important: /!important\b/i,
        function: {
          pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
          lookbehind: !0
        },
        punctuation: /[(){};:,]/
      }, g.languages.css.atrule.inside.rest = g.languages.css;
      var k = g.languages.markup;
      k && (k.tag.addInlined("style", "css"), k.tag.addAttribute("style", "css"));
    })(t);
  }
  return css_1;
}
var clike_1, hasRequiredClike;
function requireClike() {
  if (hasRequiredClike) return clike_1;
  hasRequiredClike = 1, clike_1 = n, n.displayName = "clike", n.aliases = [];
  function n(t) {
    t.languages.clike = {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: !0,
        inside: {
          punctuation: /[.\\]/
        }
      },
      keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
      boolean: /\b(?:false|true)\b/,
      function: /\b\w+(?=\()/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
      punctuation: /[{}[\];(),.:]/
    };
  }
  return clike_1;
}
var javascript_1, hasRequiredJavascript;
function requireJavascript() {
  if (hasRequiredJavascript) return javascript_1;
  hasRequiredJavascript = 1, javascript_1 = n, n.displayName = "javascript", n.aliases = ["js"];
  function n(t) {
    t.languages.javascript = t.languages.extend("clike", {
      "class-name": [
        t.languages.clike["class-name"],
        {
          pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
          lookbehind: !0
        }
      ],
      keyword: [
        {
          pattern: /((?:^|\})\s*)catch\b/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
          lookbehind: !0
        }
      ],
      // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
      function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
      number: {
        pattern: RegExp(
          /(^|[^\w$])/.source + "(?:" + // constant
          (/NaN|Infinity/.source + "|" + // binary integer
          /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
          /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
          /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
          /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
          /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
        ),
        lookbehind: !0
      },
      operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    }), t.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, t.languages.insertBefore("javascript", "keyword", {
      regex: {
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          "regex-source": {
            pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
            lookbehind: !0,
            alias: "language-regex",
            inside: t.languages.regex
          },
          "regex-delimiter": /^\/|\/$/,
          "regex-flags": /^[a-z]+$/
        }
      },
      // This must be declared before keyword because we use "function" inside the look-forward
      "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
      },
      parameter: [
        {
          pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
          lookbehind: !0,
          inside: t.languages.javascript
        },
        {
          pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
          lookbehind: !0,
          inside: t.languages.javascript
        },
        {
          pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
          lookbehind: !0,
          inside: t.languages.javascript
        },
        {
          pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
          lookbehind: !0,
          inside: t.languages.javascript
        }
      ],
      constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    }), t.languages.insertBefore("javascript", "string", {
      hashbang: {
        pattern: /^#!.*/,
        greedy: !0,
        alias: "comment"
      },
      "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: !0,
        inside: {
          "template-punctuation": {
            pattern: /^`|`$/,
            alias: "string"
          },
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              },
              rest: t.languages.javascript
            }
          },
          string: /[\s\S]+/
        }
      },
      "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      }
    }), t.languages.insertBefore("javascript", "operator", {
      "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: !0,
        alias: "property"
      }
    }), t.languages.markup && (t.languages.markup.tag.addInlined("script", "javascript"), t.languages.markup.tag.addAttribute(
      /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
      "javascript"
    )), t.languages.js = t.languages.javascript;
  }
  return javascript_1;
}
var core$1, hasRequiredCore;
function requireCore() {
  if (hasRequiredCore) return core$1;
  hasRequiredCore = 1;
  var n = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof commonjsGlobal$2 == "object" ? commonjsGlobal$2 : {}, t = sA();
  n.Prism = { manual: !0, disableWorkerMessageHandler: !0 };
  var g = requireHastscript(), d = requireParseEntities(), k = requirePrismCore(), H = requireMarkup(), AA = requireCss(), gA = requireClike(), IA = requireJavascript();
  t();
  var CA = {}.hasOwnProperty;
  function BA() {
  }
  BA.prototype = k;
  var eA = new BA();
  core$1 = eA, eA.highlight = tA, eA.register = iA, eA.alias = QA, eA.registered = oA, eA.listLanguages = EA, iA(H), iA(AA), iA(gA), iA(IA), eA.util.encode = lA, eA.Token.stringify = aA;
  function iA(rA) {
    if (typeof rA != "function" || !rA.displayName)
      throw new Error("Expected `function` for `grammar`, got `" + rA + "`");
    eA.languages[rA.displayName] === void 0 && rA(eA);
  }
  function QA(rA, uA) {
    var hA = eA.languages, dA = rA, GA, DA, wA, bA;
    uA && (dA = {}, dA[rA] = uA);
    for (GA in dA)
      for (DA = dA[GA], DA = typeof DA == "string" ? [DA] : DA, wA = DA.length, bA = -1; ++bA < wA; )
        hA[DA[bA]] = hA[GA];
  }
  function tA(rA, uA) {
    var hA = k.highlight, dA;
    if (typeof rA != "string")
      throw new Error("Expected `string` for `value`, got `" + rA + "`");
    if (eA.util.type(uA) === "Object")
      dA = uA, uA = null;
    else {
      if (typeof uA != "string")
        throw new Error("Expected `string` for `name`, got `" + uA + "`");
      if (CA.call(eA.languages, uA))
        dA = eA.languages[uA];
      else
        throw new Error("Unknown language: `" + uA + "` is not registered");
    }
    return hA.call(this, rA, dA, uA);
  }
  function oA(rA) {
    if (typeof rA != "string")
      throw new Error("Expected `string` for `language`, got `" + rA + "`");
    return CA.call(eA.languages, rA);
  }
  function EA() {
    var rA = eA.languages, uA = [], hA;
    for (hA in rA)
      CA.call(rA, hA) && typeof rA[hA] == "object" && uA.push(hA);
    return uA;
  }
  function aA(rA, uA, hA) {
    var dA;
    return typeof rA == "string" ? { type: "text", value: rA } : eA.util.type(rA) === "Array" ? nA(rA, uA) : (dA = {
      type: rA.type,
      content: eA.Token.stringify(rA.content, uA, hA),
      tag: "span",
      classes: ["token", rA.type],
      attributes: {},
      language: uA,
      parent: hA
    }, rA.alias && (dA.classes = dA.classes.concat(rA.alias)), eA.hooks.run("wrap", dA), g(
      dA.tag + "." + dA.classes.join("."),
      cA(dA.attributes),
      dA.content
    ));
  }
  function nA(rA, uA) {
    for (var hA = [], dA = rA.length, GA = -1, DA; ++GA < dA; )
      DA = rA[GA], DA !== "" && DA !== null && DA !== void 0 && hA.push(DA);
    for (GA = -1, dA = hA.length; ++GA < dA; )
      DA = hA[GA], hA[GA] = eA.Token.stringify(DA, uA, hA);
    return hA;
  }
  function lA(rA) {
    return rA;
  }
  function cA(rA) {
    var uA;
    for (uA in rA)
      rA[uA] = d(rA[uA]);
    return rA;
  }
  function sA() {
    var rA = "Prism" in n, uA = rA ? n.Prism : void 0;
    return hA;
    function hA() {
      rA ? n.Prism = uA : delete n.Prism, rA = void 0, uA = void 0;
    }
  }
  return core$1;
}
const defaultStyle$1 = {
  'code[class*="language-"]': {
    color: "black",
    background: "none",
    textShadow: "0 1px white",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: "1em",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none"
  },
  'pre[class*="language-"]': {
    color: "black",
    background: "#f5f2f0",
    textShadow: "0 1px white",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: "1em",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    padding: "1em",
    margin: ".5em 0",
    overflow: "auto"
  },
  'pre[class*="language-"]::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"] ::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"]::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"] ::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"]::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"] ::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"]::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"] ::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  ':not(pre) > code[class*="language-"]': {
    background: "#f5f2f0",
    padding: ".1em",
    borderRadius: ".3em",
    whiteSpace: "normal"
  },
  comment: {
    color: "slategray"
  },
  prolog: {
    color: "slategray"
  },
  doctype: {
    color: "slategray"
  },
  cdata: {
    color: "slategray"
  },
  punctuation: {
    color: "#999"
  },
  namespace: {
    Opacity: ".7"
  },
  property: {
    color: "#905"
  },
  tag: {
    color: "#905"
  },
  boolean: {
    color: "#905"
  },
  number: {
    color: "#905"
  },
  constant: {
    color: "#905"
  },
  symbol: {
    color: "#905"
  },
  deleted: {
    color: "#905"
  },
  selector: {
    color: "#690"
  },
  "attr-name": {
    color: "#690"
  },
  string: {
    color: "#690"
  },
  char: {
    color: "#690"
  },
  builtin: {
    color: "#690"
  },
  inserted: {
    color: "#690"
  },
  operator: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  entity: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)",
    cursor: "help"
  },
  url: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  ".language-css .token.string": {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  ".style .token.string": {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  atrule: {
    color: "#07a"
  },
  "attr-value": {
    color: "#07a"
  },
  keyword: {
    color: "#07a"
  },
  function: {
    color: "#DD4A68"
  },
  "class-name": {
    color: "#DD4A68"
  },
  regex: {
    color: "#e90"
  },
  important: {
    color: "#e90",
    fontWeight: "bold"
  },
  variable: {
    color: "#e90"
  },
  bold: {
    fontWeight: "bold"
  },
  italic: {
    fontStyle: "italic"
  }
};
var abap_1, hasRequiredAbap;
function requireAbap() {
  if (hasRequiredAbap) return abap_1;
  hasRequiredAbap = 1, abap_1 = n, n.displayName = "abap", n.aliases = [];
  function n(t) {
    t.languages.abap = {
      comment: /^\*.*/m,
      string: /(`|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      "string-template": {
        pattern: /([|}])(?:\\.|[^\\|{\r\n])*(?=[|{])/,
        lookbehind: !0,
        alias: "string"
      },
      /* End Of Line comments should not interfere with strings when the
      quote character occurs within them. We assume a string being highlighted
      inside an EOL comment is more acceptable than the opposite.
      */
      "eol-comment": {
        pattern: /(^|\s)".*/m,
        lookbehind: !0,
        alias: "comment"
      },
      keyword: {
        pattern: /(\s|\.|^)(?:SCIENTIFIC_WITH_LEADING_ZERO|SCALE_PRESERVING_SCIENTIFIC|RMC_COMMUNICATION_FAILURE|END-ENHANCEMENT-SECTION|MULTIPLY-CORRESPONDING|SUBTRACT-CORRESPONDING|VERIFICATION-MESSAGE|DIVIDE-CORRESPONDING|ENHANCEMENT-SECTION|CURRENCY_CONVERSION|RMC_SYSTEM_FAILURE|START-OF-SELECTION|MOVE-CORRESPONDING|RMC_INVALID_STATUS|CUSTOMER-FUNCTION|END-OF-DEFINITION|ENHANCEMENT-POINT|SYSTEM-EXCEPTIONS|ADD-CORRESPONDING|SCALE_PRESERVING|SELECTION-SCREEN|CURSOR-SELECTION|END-OF-SELECTION|LOAD-OF-PROGRAM|SCROLL-BOUNDARY|SELECTION-TABLE|EXCEPTION-TABLE|IMPLEMENTATIONS|PARAMETER-TABLE|RIGHT-JUSTIFIED|UNIT_CONVERSION|AUTHORITY-CHECK|LIST-PROCESSING|SIGN_AS_POSTFIX|COL_BACKGROUND|IMPLEMENTATION|INTERFACE-POOL|TRANSFORMATION|IDENTIFICATION|ENDENHANCEMENT|LINE-SELECTION|INITIALIZATION|LEFT-JUSTIFIED|SELECT-OPTIONS|SELECTION-SETS|COMMUNICATION|CORRESPONDING|DECIMAL_SHIFT|PRINT-CONTROL|VALUE-REQUEST|CHAIN-REQUEST|FUNCTION-POOL|FIELD-SYMBOLS|FUNCTIONALITY|INVERTED-DATE|SELECTION-SET|CLASS-METHODS|OUTPUT-LENGTH|CLASS-CODING|COL_NEGATIVE|ERRORMESSAGE|FIELD-GROUPS|HELP-REQUEST|NO-EXTENSION|NO-TOPOFPAGE|REDEFINITION|DISPLAY-MODE|ENDINTERFACE|EXIT-COMMAND|FIELD-SYMBOL|NO-SCROLLING|SHORTDUMP-ID|ACCESSPOLICY|CLASS-EVENTS|COL_POSITIVE|DECLARATIONS|ENHANCEMENTS|FILTER-TABLE|SWITCHSTATES|SYNTAX-CHECK|TRANSPORTING|ASYNCHRONOUS|SYNTAX-TRACE|TOKENIZATION|USER-COMMAND|WITH-HEADING|ABAP-SOURCE|BREAK-POINT|CHAIN-INPUT|COMPRESSION|FIXED-POINT|NEW-SECTION|NON-UNICODE|OCCURRENCES|RESPONSIBLE|SYSTEM-CALL|TRACE-TABLE|ABBREVIATED|CHAR-TO-HEX|END-OF-FILE|ENDFUNCTION|ENVIRONMENT|ASSOCIATION|COL_HEADING|EDITOR-CALL|END-OF-PAGE|ENGINEERING|IMPLEMENTED|INTENSIFIED|RADIOBUTTON|SYSTEM-EXIT|TOP-OF-PAGE|TRANSACTION|APPLICATION|CONCATENATE|DESTINATION|ENHANCEMENT|IMMEDIATELY|NO-GROUPING|PRECOMPILED|REPLACEMENT|TITLE-LINES|ACTIVATION|BYTE-ORDER|CLASS-POOL|CONNECTION|CONVERSION|DEFINITION|DEPARTMENT|EXPIRATION|INHERITING|MESSAGE-ID|NO-HEADING|PERFORMING|QUEUE-ONLY|RIGHTSPACE|SCIENTIFIC|STATUSINFO|STRUCTURES|SYNCPOINTS|WITH-TITLE|ATTRIBUTES|BOUNDARIES|CLASS-DATA|COL_NORMAL|DD\/MM\/YYYY|DESCENDING|INTERFACES|LINE-COUNT|MM\/DD\/YYYY|NON-UNIQUE|PRESERVING|SELECTIONS|STATEMENTS|SUBROUTINE|TRUNCATION|TYPE-POOLS|ARITHMETIC|BACKGROUND|ENDPROVIDE|EXCEPTIONS|IDENTIFIER|INDEX-LINE|OBLIGATORY|PARAMETERS|PERCENTAGE|PUSHBUTTON|RESOLUTION|COMPONENTS|DEALLOCATE|DISCONNECT|DUPLICATES|FIRST-LINE|HEAD-LINES|NO-DISPLAY|OCCURRENCE|RESPECTING|RETURNCODE|SUBMATCHES|TRACE-FILE|ASCENDING|BYPASSING|ENDMODULE|EXCEPTION|EXCLUDING|EXPORTING|INCREMENT|MATCHCODE|PARAMETER|PARTIALLY|PREFERRED|REFERENCE|REPLACING|RETURNING|SELECTION|SEPARATED|SPECIFIED|STATEMENT|TIMESTAMP|TYPE-POOL|ACCEPTING|APPENDAGE|ASSIGNING|COL_GROUP|COMPARING|CONSTANTS|DANGEROUS|IMPORTING|INSTANCES|LEFTSPACE|LOG-POINT|QUICKINFO|READ-ONLY|SCROLLING|SQLSCRIPT|STEP-LOOP|TOP-LINES|TRANSLATE|APPENDING|AUTHORITY|CHARACTER|COMPONENT|CONDITION|DIRECTORY|DUPLICATE|MESSAGING|RECEIVING|SUBSCREEN|ACCORDING|COL_TOTAL|END-LINES|ENDMETHOD|ENDSELECT|EXPANDING|EXTENSION|INCLUDING|INFOTYPES|INTERFACE|INTERVALS|LINE-SIZE|PF-STATUS|PROCEDURE|PROTECTED|REQUESTED|RESUMABLE|RIGHTPLUS|SAP-SPOOL|SECONDARY|STRUCTURE|SUBSTRING|TABLEVIEW|NUMOFCHAR|ADJACENT|ANALYSIS|ASSIGNED|BACKWARD|CHANNELS|CHECKBOX|CONTINUE|CRITICAL|DATAINFO|DD\/MM\/YY|DURATION|ENCODING|ENDCLASS|FUNCTION|LEFTPLUS|LINEFEED|MM\/DD\/YY|OVERFLOW|RECEIVED|SKIPPING|SORTABLE|STANDARD|SUBTRACT|SUPPRESS|TABSTRIP|TITLEBAR|TRUNCATE|UNASSIGN|WHENEVER|ANALYZER|COALESCE|COMMENTS|CONDENSE|DECIMALS|DEFERRED|ENDWHILE|EXPLICIT|KEYWORDS|MESSAGES|POSITION|PRIORITY|RECEIVER|RENAMING|TIMEZONE|TRAILING|ALLOCATE|CENTERED|CIRCULAR|CONTROLS|CURRENCY|DELETING|DESCRIBE|DISTANCE|ENDCATCH|EXPONENT|EXTENDED|GENERATE|IGNORING|INCLUDES|INTERNAL|MAJOR-ID|MODIFIER|NEW-LINE|OPTIONAL|PROPERTY|ROLLBACK|STARTING|SUPPLIED|ABSTRACT|CHANGING|CONTEXTS|CREATING|CUSTOMER|DATABASE|DAYLIGHT|DEFINING|DISTINCT|DIVISION|ENABLING|ENDCHAIN|ESCAPING|HARMLESS|IMPLICIT|INACTIVE|LANGUAGE|MINOR-ID|MULTIPLY|NEW-PAGE|NO-TITLE|POS_HIGH|SEPARATE|TEXTPOOL|TRANSFER|SELECTOR|DBMAXLEN|ITERATOR|ARCHIVE|BIT-XOR|BYTE-CO|COLLECT|COMMENT|CURRENT|DEFAULT|DISPLAY|ENDFORM|EXTRACT|LEADING|LISTBOX|LOCATOR|MEMBERS|METHODS|NESTING|POS_LOW|PROCESS|PROVIDE|RAISING|RESERVE|SECONDS|SUMMARY|VISIBLE|BETWEEN|BIT-AND|BYTE-CS|CLEANUP|COMPUTE|CONTROL|CONVERT|DATASET|ENDCASE|FORWARD|HEADERS|HOTSPOT|INCLUDE|INVERSE|KEEPING|NO-ZERO|OBJECTS|OVERLAY|PADDING|PATTERN|PROGRAM|REFRESH|SECTION|SUMMING|TESTING|VERSION|WINDOWS|WITHOUT|BIT-NOT|BYTE-CA|BYTE-NA|CASTING|CONTEXT|COUNTRY|DYNAMIC|ENABLED|ENDLOOP|EXECUTE|FRIENDS|HANDLER|HEADING|INITIAL|\*-INPUT|LOGFILE|MAXIMUM|MINIMUM|NO-GAPS|NO-SIGN|PRAGMAS|PRIMARY|PRIVATE|REDUCED|REPLACE|REQUEST|RESULTS|UNICODE|WARNING|ALIASES|BYTE-CN|BYTE-NS|CALLING|COL_KEY|COLUMNS|CONNECT|ENDEXEC|ENTRIES|EXCLUDE|FILTERS|FURTHER|HELP-ID|LOGICAL|MAPPING|MESSAGE|NAMETAB|OPTIONS|PACKAGE|PERFORM|RECEIVE|STATICS|VARYING|BINDING|CHARLEN|GREATER|XSTRLEN|ACCEPT|APPEND|DETAIL|ELSEIF|ENDING|ENDTRY|FORMAT|FRAMES|GIVING|HASHED|HEADER|IMPORT|INSERT|MARGIN|MODULE|NATIVE|OBJECT|OFFSET|REMOTE|RESUME|SAVING|SIMPLE|SUBMIT|TABBED|TOKENS|UNIQUE|UNPACK|UPDATE|WINDOW|YELLOW|ACTUAL|ASPECT|CENTER|CURSOR|DELETE|DIALOG|DIVIDE|DURING|ERRORS|EVENTS|EXTEND|FILTER|HANDLE|HAVING|IGNORE|LITTLE|MEMORY|NO-GAP|OCCURS|OPTION|PERSON|PLACES|PUBLIC|REDUCE|REPORT|RESULT|SINGLE|SORTED|SWITCH|SYNTAX|TARGET|VALUES|WRITER|ASSERT|BLOCKS|BOUNDS|BUFFER|CHANGE|COLUMN|COMMIT|CONCAT|COPIES|CREATE|DDMMYY|DEFINE|ENDIAN|ESCAPE|EXPAND|KERNEL|LAYOUT|LEGACY|LEVELS|MMDDYY|NUMBER|OUTPUT|RANGES|READER|RETURN|SCREEN|SEARCH|SELECT|SHARED|SOURCE|STABLE|STATIC|SUBKEY|SUFFIX|TABLES|UNWIND|YYMMDD|ASSIGN|BACKUP|BEFORE|BINARY|BIT-OR|BLANKS|CLIENT|CODING|COMMON|DEMAND|DYNPRO|EXCEPT|EXISTS|EXPORT|FIELDS|GLOBAL|GROUPS|LENGTH|LOCALE|MEDIUM|METHOD|MODIFY|NESTED|OTHERS|REJECT|SCROLL|SUPPLY|SYMBOL|ENDFOR|STRLEN|ALIGN|BEGIN|BOUND|ENDAT|ENTRY|EVENT|FINAL|FLUSH|GRANT|INNER|SHORT|USING|WRITE|AFTER|BLACK|BLOCK|CLOCK|COLOR|COUNT|DUMMY|EMPTY|ENDDO|ENDON|GREEN|INDEX|INOUT|LEAVE|LEVEL|LINES|MODIF|ORDER|OUTER|RANGE|RESET|RETRY|RIGHT|SMART|SPLIT|STYLE|TABLE|THROW|UNDER|UNTIL|UPPER|UTF-8|WHERE|ALIAS|BLANK|CLEAR|CLOSE|EXACT|FETCH|FIRST|FOUND|GROUP|LLANG|LOCAL|OTHER|REGEX|SPOOL|TITLE|TYPES|VALID|WHILE|ALPHA|BOXED|CATCH|CHAIN|CHECK|CLASS|COVER|ENDIF|EQUIV|FIELD|FLOOR|FRAME|INPUT|LOWER|MATCH|NODES|PAGES|PRINT|RAISE|ROUND|SHIFT|SPACE|SPOTS|STAMP|STATE|TASKS|TIMES|TRMAC|ULINE|UNION|VALUE|WIDTH|EQUAL|LOG10|TRUNC|BLOB|CASE|CEIL|CLOB|COND|EXIT|FILE|GAPS|HOLD|INCL|INTO|KEEP|KEYS|LAST|LINE|LONG|LPAD|MAIL|MODE|OPEN|PINK|READ|ROWS|TEST|THEN|ZERO|AREA|BACK|BADI|BYTE|CAST|EDIT|EXEC|FAIL|FIND|FKEQ|FONT|FREE|GKEQ|HIDE|INIT|ITNO|LATE|LOOP|MAIN|MARK|MOVE|NEXT|NULL|RISK|ROLE|UNIT|WAIT|ZONE|BASE|CALL|CODE|DATA|DATE|FKGE|GKGE|HIGH|KIND|LEFT|LIST|MASK|MESH|NAME|NODE|PACK|PAGE|POOL|SEND|SIGN|SIZE|SOME|STOP|TASK|TEXT|TIME|USER|VARY|WITH|WORD|BLUE|CONV|COPY|DEEP|ELSE|FORM|FROM|HINT|ICON|JOIN|LIKE|LOAD|ONLY|PART|SCAN|SKIP|SORT|TYPE|UNIX|VIEW|WHEN|WORK|ACOS|ASIN|ATAN|COSH|EACH|FRAC|LESS|RTTI|SINH|SQRT|TANH|AVG|BIT|DIV|ISO|LET|OUT|PAD|SQL|ALL|CI_|CPI|END|LOB|LPI|MAX|MIN|NEW|OLE|RUN|SET|\?TO|YES|ABS|ADD|AND|BIG|FOR|HDB|JOB|LOW|NOT|SAP|TRY|VIA|XML|ANY|GET|IDS|KEY|MOD|OFF|PUT|RAW|RED|REF|SUM|TAB|XSD|CNT|COS|EXP|LOG|SIN|TAN|XOR|AT|CO|CP|DO|GT|ID|IF|NS|OR|BT|CA|CS|GE|NA|NB|EQ|IN|LT|NE|NO|OF|ON|PF|TO|AS|BY|CN|IS|LE|NP|UP|E|I|M|O|Z|C|X)\b/i,
        lookbehind: !0
      },
      /* Numbers can be only integers. Decimal or Hex appear only as strings */
      number: /\b\d+\b/,
      /* Operators must always be surrounded by whitespace, they cannot be put
      adjacent to operands.
      */
      operator: {
        pattern: /(\s)(?:\*\*?|<[=>]?|>=?|\?=|[-+\/=])(?=\s)/,
        lookbehind: !0
      },
      "string-operator": {
        pattern: /(\s)&&?(?=\s)/,
        lookbehind: !0,
        /* The official editor highlights */
        alias: "keyword"
      },
      "token-operator": [
        {
          /* Special operators used to access structure components, class methods/attributes, etc. */
          pattern: /(\w)(?:->?|=>|[~|{}])(?=\w)/,
          lookbehind: !0,
          alias: "punctuation"
        },
        {
          /* Special tokens used do delimit string templates */
          pattern: /[|{}]/,
          alias: "punctuation"
        }
      ],
      punctuation: /[,.:()]/
    };
  }
  return abap_1;
}
var abnf_1, hasRequiredAbnf;
function requireAbnf() {
  if (hasRequiredAbnf) return abnf_1;
  hasRequiredAbnf = 1, abnf_1 = n, n.displayName = "abnf", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = "(?:ALPHA|BIT|CHAR|CR|CRLF|CTL|DIGIT|DQUOTE|HEXDIG|HTAB|LF|LWSP|OCTET|SP|VCHAR|WSP)";
      g.languages.abnf = {
        comment: /;.*/,
        string: {
          pattern: /(?:%[is])?"[^"\n\r]*"/,
          greedy: !0,
          inside: {
            punctuation: /^%[is]/
          }
        },
        range: {
          pattern: /%(?:b[01]+-[01]+|d\d+-\d+|x[A-F\d]+-[A-F\d]+)/i,
          alias: "number"
        },
        terminal: {
          pattern: /%(?:b[01]+(?:\.[01]+)*|d\d+(?:\.\d+)*|x[A-F\d]+(?:\.[A-F\d]+)*)/i,
          alias: "number"
        },
        repetition: {
          pattern: /(^|[^\w-])(?:\d*\*\d*|\d+)/,
          lookbehind: !0,
          alias: "operator"
        },
        definition: {
          pattern: /(^[ \t]*)(?:[a-z][\w-]*|<[^<>\r\n]*>)(?=\s*=)/m,
          lookbehind: !0,
          alias: "keyword",
          inside: {
            punctuation: /<|>/
          }
        },
        "core-rule": {
          pattern: RegExp(
            "(?:(^|[^<\\w-])" + d + "|<" + d + ">)(?![\\w-])",
            "i"
          ),
          lookbehind: !0,
          alias: ["rule", "constant"],
          inside: {
            punctuation: /<|>/
          }
        },
        rule: {
          pattern: /(^|[^<\w-])[a-z][\w-]*|<[^<>\r\n]*>/i,
          lookbehind: !0,
          inside: {
            punctuation: /<|>/
          }
        },
        operator: /=\/?|\//,
        punctuation: /[()\[\]]/
      };
    })(t);
  }
  return abnf_1;
}
var actionscript_1, hasRequiredActionscript;
function requireActionscript() {
  if (hasRequiredActionscript) return actionscript_1;
  hasRequiredActionscript = 1, actionscript_1 = n, n.displayName = "actionscript", n.aliases = [];
  function n(t) {
    t.languages.actionscript = t.languages.extend("javascript", {
      keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
      operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
    }), t.languages.actionscript["class-name"].alias = "function", delete t.languages.actionscript.parameter, delete t.languages.actionscript["literal-property"], t.languages.markup && t.languages.insertBefore("actionscript", "string", {
      xml: {
        pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
        lookbehind: !0,
        inside: t.languages.markup
      }
    });
  }
  return actionscript_1;
}
var ada_1, hasRequiredAda;
function requireAda() {
  if (hasRequiredAda) return ada_1;
  hasRequiredAda = 1, ada_1 = n, n.displayName = "ada", n.aliases = [];
  function n(t) {
    t.languages.ada = {
      comment: /--.*/,
      string: /"(?:""|[^"\r\f\n])*"/,
      number: [
        {
          pattern: /\b\d(?:_?\d)*#[\dA-F](?:_?[\dA-F])*(?:\.[\dA-F](?:_?[\dA-F])*)?#(?:E[+-]?\d(?:_?\d)*)?/i
        },
        {
          pattern: /\b\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:E[+-]?\d(?:_?\d)*)?\b/i
        }
      ],
      "attr-name": /\b'\w+/,
      keyword: /\b(?:abort|abs|abstract|accept|access|aliased|all|and|array|at|begin|body|case|constant|declare|delay|delta|digits|do|else|elsif|end|entry|exception|exit|for|function|generic|goto|if|in|interface|is|limited|loop|mod|new|not|null|of|others|out|overriding|package|pragma|private|procedure|protected|raise|range|record|rem|renames|requeue|return|reverse|select|separate|some|subtype|synchronized|tagged|task|terminate|then|type|until|use|when|while|with|xor)\b/i,
      boolean: /\b(?:false|true)\b/i,
      operator: /<[=>]?|>=?|=>?|:=|\/=?|\*\*?|[&+-]/,
      punctuation: /\.\.?|[,;():]/,
      char: /'.'/,
      variable: /\b[a-z](?:\w)*\b/i
    };
  }
  return ada_1;
}
var agda_1, hasRequiredAgda;
function requireAgda() {
  if (hasRequiredAgda) return agda_1;
  hasRequiredAgda = 1, agda_1 = n, n.displayName = "agda", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.agda = {
        comment: /\{-[\s\S]*?(?:-\}|$)|--.*/,
        string: {
          pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
          greedy: !0
        },
        punctuation: /[(){}⦃⦄.;@]/,
        "class-name": {
          pattern: /((?:data|record) +)\S+/,
          lookbehind: !0
        },
        function: {
          pattern: /(^[ \t]*)(?!\s)[^:\r\n]+(?=:)/m,
          lookbehind: !0
        },
        operator: {
          pattern: /(^\s*|\s)(?:[=|:∀→λ\\?_]|->)(?=\s)/,
          lookbehind: !0
        },
        keyword: /\b(?:Set|abstract|constructor|data|eta-equality|field|forall|hiding|import|in|inductive|infix|infixl|infixr|instance|let|macro|module|mutual|no-eta-equality|open|overlap|pattern|postulate|primitive|private|public|quote|quoteContext|quoteGoal|quoteTerm|record|renaming|rewrite|syntax|tactic|unquote|unquoteDecl|unquoteDef|using|variable|where|with)\b/
      };
    })(t);
  }
  return agda_1;
}
var al_1, hasRequiredAl;
function requireAl() {
  if (hasRequiredAl) return al_1;
  hasRequiredAl = 1, al_1 = n, n.displayName = "al", n.aliases = [];
  function n(t) {
    t.languages.al = {
      comment: /\/\/.*|\/\*[\s\S]*?\*\//,
      string: {
        pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
        greedy: !0
      },
      function: {
        pattern: /(\b(?:event|procedure|trigger)\s+|(?:^|[^.])\.\s*)[a-z_]\w*(?=\s*\()/i,
        lookbehind: !0
      },
      keyword: [
        // keywords
        /\b(?:array|asserterror|begin|break|case|do|downto|else|end|event|exit|for|foreach|function|if|implements|in|indataset|interface|internal|local|of|procedure|program|protected|repeat|runonclient|securityfiltering|suppressdispose|temporary|then|to|trigger|until|var|while|with|withevents)\b/i,
        // objects and metadata that are used like keywords
        /\b(?:action|actions|addafter|addbefore|addfirst|addlast|area|assembly|chartpart|codeunit|column|controladdin|cuegroup|customizes|dataitem|dataset|dotnet|elements|enum|enumextension|extends|field|fieldattribute|fieldelement|fieldgroup|fieldgroups|fields|filter|fixed|grid|group|key|keys|label|labels|layout|modify|moveafter|movebefore|movefirst|movelast|page|pagecustomization|pageextension|part|profile|query|repeater|report|requestpage|schema|separator|systempart|table|tableelement|tableextension|textattribute|textelement|type|usercontrol|value|xmlport)\b/i
      ],
      number: /\b(?:0x[\da-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)(?:F|LL?|U(?:LL?)?)?\b/i,
      boolean: /\b(?:false|true)\b/i,
      variable: /\b(?:Curr(?:FieldNo|Page|Report)|x?Rec|RequestOptionsPage)\b/,
      "class-name": /\b(?:automation|biginteger|bigtext|blob|boolean|byte|char|clienttype|code|completiontriggererrorlevel|connectiontype|database|dataclassification|datascope|date|dateformula|datetime|decimal|defaultlayout|dialog|dictionary|dotnetassembly|dotnettypedeclaration|duration|errorinfo|errortype|executioncontext|executionmode|fieldclass|fieldref|fieldtype|file|filterpagebuilder|guid|httpclient|httpcontent|httpheaders|httprequestmessage|httpresponsemessage|instream|integer|joker|jsonarray|jsonobject|jsontoken|jsonvalue|keyref|list|moduledependencyinfo|moduleinfo|none|notification|notificationscope|objecttype|option|outstream|pageresult|record|recordid|recordref|reportformat|securityfilter|sessionsettings|tableconnectiontype|tablefilter|testaction|testfield|testfilterfield|testpage|testpermissions|testrequestpage|text|textbuilder|textconst|textencoding|time|transactionmodel|transactiontype|variant|verbosity|version|view|views|webserviceactioncontext|webserviceactionresultcode|xmlattribute|xmlattributecollection|xmlcdata|xmlcomment|xmldeclaration|xmldocument|xmldocumenttype|xmlelement|xmlnamespacemanager|xmlnametable|xmlnode|xmlnodelist|xmlprocessinginstruction|xmlreadoptions|xmltext|xmlwriteoptions)\b/i,
      operator: /\.\.|:[=:]|[-+*/]=?|<>|[<>]=?|=|\b(?:and|div|mod|not|or|xor)\b/i,
      punctuation: /[()\[\]{}:.;,]/
    };
  }
  return al_1;
}
var antlr4_1, hasRequiredAntlr4;
function requireAntlr4() {
  if (hasRequiredAntlr4) return antlr4_1;
  hasRequiredAntlr4 = 1, antlr4_1 = n, n.displayName = "antlr4", n.aliases = ["g4"];
  function n(t) {
    t.languages.antlr4 = {
      comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
      string: {
        pattern: /'(?:\\.|[^\\'\r\n])*'/,
        greedy: !0
      },
      "character-class": {
        pattern: /\[(?:\\.|[^\\\]\r\n])*\]/,
        greedy: !0,
        alias: "regex",
        inside: {
          range: {
            pattern: /([^[]|(?:^|[^\\])(?:\\\\)*\\\[)-(?!\])/,
            lookbehind: !0,
            alias: "punctuation"
          },
          escape: /\\(?:u(?:[a-fA-F\d]{4}|\{[a-fA-F\d]+\})|[pP]\{[=\w-]+\}|[^\r\nupP])/,
          punctuation: /[\[\]]/
        }
      },
      action: {
        pattern: /\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\}/,
        greedy: !0,
        inside: {
          content: {
            // this might be C, C++, Python, Java, C#, or any other language ANTLR4 compiles to
            pattern: /(\{)[\s\S]+(?=\})/,
            lookbehind: !0
          },
          punctuation: /[{}]/
        }
      },
      command: {
        pattern: /(->\s*(?!\s))(?:\s*(?:,\s*)?\b[a-z]\w*(?:\s*\([^()\r\n]*\))?)+(?=\s*;)/i,
        lookbehind: !0,
        inside: {
          function: /\b\w+(?=\s*(?:[,(]|$))/,
          punctuation: /[,()]/
        }
      },
      annotation: {
        pattern: /@\w+(?:::\w+)*/,
        alias: "keyword"
      },
      label: {
        pattern: /#[ \t]*\w+/,
        alias: "punctuation"
      },
      keyword: /\b(?:catch|channels|finally|fragment|grammar|import|lexer|locals|mode|options|parser|returns|throws|tokens)\b/,
      definition: [
        {
          pattern: /\b[a-z]\w*(?=\s*:)/,
          alias: ["rule", "class-name"]
        },
        {
          pattern: /\b[A-Z]\w*(?=\s*:)/,
          alias: ["token", "constant"]
        }
      ],
      constant: /\b[A-Z][A-Z_]*\b/,
      operator: /\.\.|->|[|~]|[*+?]\??/,
      punctuation: /[;:()=]/
    }, t.languages.g4 = t.languages.antlr4;
  }
  return antlr4_1;
}
var apacheconf_1, hasRequiredApacheconf;
function requireApacheconf() {
  if (hasRequiredApacheconf) return apacheconf_1;
  hasRequiredApacheconf = 1, apacheconf_1 = n, n.displayName = "apacheconf", n.aliases = [];
  function n(t) {
    t.languages.apacheconf = {
      comment: /#.*/,
      "directive-inline": {
        pattern: /(^[\t ]*)\b(?:AcceptFilter|AcceptPathInfo|AccessFileName|Action|Add(?:Alt|AltByEncoding|AltByType|Charset|DefaultCharset|Description|Encoding|Handler|Icon|IconByEncoding|IconByType|InputFilter|Language|ModuleInfo|OutputFilter|OutputFilterByType|Type)|Alias|AliasMatch|Allow(?:CONNECT|EncodedSlashes|Methods|Override|OverrideList)?|Anonymous(?:_LogEmail|_MustGiveEmail|_NoUserID|_VerifyEmail)?|AsyncRequestWorkerFactor|Auth(?:BasicAuthoritative|BasicFake|BasicProvider|BasicUseDigestAlgorithm|DBDUserPWQuery|DBDUserRealmQuery|DBMGroupFile|DBMType|DBMUserFile|Digest(?:Algorithm|Domain|NonceLifetime|Provider|Qop|ShmemSize)|Form(?:Authoritative|Body|DisableNoStore|FakeBasicAuth|Location|LoginRequiredLocation|LoginSuccessLocation|LogoutLocation|Method|Mimetype|Password|Provider|SitePassphrase|Size|Username)|GroupFile|LDAP(?:AuthorizePrefix|BindAuthoritative|BindDN|BindPassword|CharsetConfig|CompareAsUser|CompareDNOnServer|DereferenceAliases|GroupAttribute|GroupAttributeIsDN|InitialBindAsUser|InitialBindPattern|MaxSubGroupDepth|RemoteUserAttribute|RemoteUserIsDN|SearchAsUser|SubGroupAttribute|SubGroupClass|Url)|Merging|Name|nCache(?:Context|Enable|ProvideFor|SOCache|Timeout)|nzFcgiCheckAuthnProvider|nzFcgiDefineProvider|Type|UserFile|zDBDLoginToReferer|zDBDQuery|zDBDRedirectQuery|zDBMType|zSendForbiddenOnFailure)|BalancerGrowth|BalancerInherit|BalancerMember|BalancerPersist|BrowserMatch|BrowserMatchNoCase|BufferedLogs|BufferSize|Cache(?:DefaultExpire|DetailHeader|DirLength|DirLevels|Disable|Enable|File|Header|IgnoreCacheControl|IgnoreHeaders|IgnoreNoLastMod|IgnoreQueryString|IgnoreURLSessionIdentifiers|KeyBaseURL|LastModifiedFactor|Lock|LockMaxAge|LockPath|MaxExpire|MaxFileSize|MinExpire|MinFileSize|NegotiatedDocs|QuickHandler|ReadSize|ReadTime|Root|Socache(?:MaxSize|MaxTime|MinTime|ReadSize|ReadTime)?|StaleOnError|StoreExpired|StoreNoStore|StorePrivate)|CGIDScriptTimeout|CGIMapExtension|CharsetDefault|CharsetOptions|CharsetSourceEnc|CheckCaseOnly|CheckSpelling|ChrootDir|ContentDigest|CookieDomain|CookieExpires|CookieName|CookieStyle|CookieTracking|CoreDumpDirectory|CustomLog|Dav|DavDepthInfinity|DavGenericLockDB|DavLockDB|DavMinTimeout|DBDExptime|DBDInitSQL|DBDKeep|DBDMax|DBDMin|DBDParams|DBDPersist|DBDPrepareSQL|DBDriver|DefaultIcon|DefaultLanguage|DefaultRuntimeDir|DefaultType|Define|Deflate(?:BufferSize|CompressionLevel|FilterNote|InflateLimitRequestBody|InflateRatio(?:Burst|Limit)|MemLevel|WindowSize)|Deny|DirectoryCheckHandler|DirectoryIndex|DirectoryIndexRedirect|DirectorySlash|DocumentRoot|DTracePrivileges|DumpIOInput|DumpIOOutput|EnableExceptionHook|EnableMMAP|EnableSendfile|Error|ErrorDocument|ErrorLog|ErrorLogFormat|Example|ExpiresActive|ExpiresByType|ExpiresDefault|ExtendedStatus|ExtFilterDefine|ExtFilterOptions|FallbackResource|FileETag|FilterChain|FilterDeclare|FilterProtocol|FilterProvider|FilterTrace|ForceLanguagePriority|ForceType|ForensicLog|GprofDir|GracefulShutdownTimeout|Group|Header|HeaderName|Heartbeat(?:Address|Listen|MaxServers|Storage)|HostnameLookups|IdentityCheck|IdentityCheckTimeout|ImapBase|ImapDefault|ImapMenu|Include|IncludeOptional|Index(?:HeadInsert|Ignore|IgnoreReset|Options|OrderDefault|StyleSheet)|InputSed|ISAPI(?:AppendLogToErrors|AppendLogToQuery|CacheFile|FakeAsync|LogNotSupported|ReadAheadBuffer)|KeepAlive|KeepAliveTimeout|KeptBodySize|LanguagePriority|LDAP(?:CacheEntries|CacheTTL|ConnectionPoolTTL|ConnectionTimeout|LibraryDebug|OpCacheEntries|OpCacheTTL|ReferralHopLimit|Referrals|Retries|RetryDelay|SharedCacheFile|SharedCacheSize|Timeout|TrustedClientCert|TrustedGlobalCert|TrustedMode|VerifyServerCert)|Limit(?:InternalRecursion|Request(?:Body|Fields|FieldSize|Line)|XMLRequestBody)|Listen|ListenBackLog|LoadFile|LoadModule|LogFormat|LogLevel|LogMessage|LuaAuthzProvider|LuaCodeCache|Lua(?:Hook(?:AccessChecker|AuthChecker|CheckUserID|Fixups|InsertFilter|Log|MapToStorage|TranslateName|TypeChecker)|Inherit|InputFilter|MapHandler|OutputFilter|PackageCPath|PackagePath|QuickHandler|Root|Scope)|Max(?:ConnectionsPerChild|KeepAliveRequests|MemFree|RangeOverlaps|RangeReversals|Ranges|RequestWorkers|SpareServers|SpareThreads|Threads)|MergeTrailers|MetaDir|MetaFiles|MetaSuffix|MimeMagicFile|MinSpareServers|MinSpareThreads|MMapFile|ModemStandard|ModMimeUsePathInfo|MultiviewsMatch|Mutex|NameVirtualHost|NoProxy|NWSSLTrustedCerts|NWSSLUpgradeable|Options|Order|OutputSed|PassEnv|PidFile|PrivilegesMode|Protocol|ProtocolEcho|Proxy(?:AddHeaders|BadHeader|Block|Domain|ErrorOverride|ExpressDBMFile|ExpressDBMType|ExpressEnable|FtpDirCharset|FtpEscapeWildcards|FtpListOnWildcard|HTML(?:BufSize|CharsetOut|DocType|Enable|Events|Extended|Fixups|Interp|Links|Meta|StripComments|URLMap)|IOBufferSize|MaxForwards|Pass(?:Inherit|InterpolateEnv|Match|Reverse|ReverseCookieDomain|ReverseCookiePath)?|PreserveHost|ReceiveBufferSize|Remote|RemoteMatch|Requests|SCGIInternalRedirect|SCGISendfile|Set|SourceAddress|Status|Timeout|Via)|ReadmeName|ReceiveBufferSize|Redirect|RedirectMatch|RedirectPermanent|RedirectTemp|ReflectorHeader|RemoteIP(?:Header|InternalProxy|InternalProxyList|ProxiesHeader|TrustedProxy|TrustedProxyList)|RemoveCharset|RemoveEncoding|RemoveHandler|RemoveInputFilter|RemoveLanguage|RemoveOutputFilter|RemoveType|RequestHeader|RequestReadTimeout|Require|Rewrite(?:Base|Cond|Engine|Map|Options|Rule)|RLimitCPU|RLimitMEM|RLimitNPROC|Satisfy|ScoreBoardFile|Script(?:Alias|AliasMatch|InterpreterSource|Log|LogBuffer|LogLength|Sock)?|SecureListen|SeeRequestTail|SendBufferSize|Server(?:Admin|Alias|Limit|Name|Path|Root|Signature|Tokens)|Session(?:Cookie(?:Name|Name2|Remove)|Crypto(?:Cipher|Driver|Passphrase|PassphraseFile)|DBD(?:CookieName|CookieName2|CookieRemove|DeleteLabel|InsertLabel|PerUser|SelectLabel|UpdateLabel)|Env|Exclude|Header|Include|MaxAge)?|SetEnv|SetEnvIf|SetEnvIfExpr|SetEnvIfNoCase|SetHandler|SetInputFilter|SetOutputFilter|SSIEndTag|SSIErrorMsg|SSIETag|SSILastModified|SSILegacyExprParser|SSIStartTag|SSITimeFormat|SSIUndefinedEcho|SSL(?:CACertificateFile|CACertificatePath|CADNRequestFile|CADNRequestPath|CARevocationCheck|CARevocationFile|CARevocationPath|CertificateChainFile|CertificateFile|CertificateKeyFile|CipherSuite|Compression|CryptoDevice|Engine|FIPS|HonorCipherOrder|InsecureRenegotiation|OCSP(?:DefaultResponder|Enable|OverrideResponder|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|UseRequestNonce)|OpenSSLConfCmd|Options|PassPhraseDialog|Protocol|Proxy(?:CACertificateFile|CACertificatePath|CARevocation(?:Check|File|Path)|CheckPeer(?:CN|Expire|Name)|CipherSuite|Engine|MachineCertificate(?:ChainFile|File|Path)|Protocol|Verify|VerifyDepth)|RandomSeed|RenegBufferSize|Require|RequireSSL|Session(?:Cache|CacheTimeout|TicketKeyFile|Tickets)|SRPUnknownUserSeed|SRPVerifierFile|Stapling(?:Cache|ErrorCacheTimeout|FakeTryLater|ForceURL|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|ReturnResponderErrors|StandardCacheTimeout)|StrictSNIVHostCheck|UserName|UseStapling|VerifyClient|VerifyDepth)|StartServers|StartThreads|Substitute|Suexec|SuexecUserGroup|ThreadLimit|ThreadsPerChild|ThreadStackSize|TimeOut|TraceEnable|TransferLog|TypesConfig|UnDefine|UndefMacro|UnsetEnv|Use|UseCanonicalName|UseCanonicalPhysicalPort|User|UserDir|VHostCGIMode|VHostCGIPrivs|VHostGroup|VHostPrivs|VHostSecure|VHostUser|Virtual(?:DocumentRoot|ScriptAlias)(?:IP)?|WatchdogInterval|XBitHack|xml2EncAlias|xml2EncDefault|xml2StartParse)\b/im,
        lookbehind: !0,
        alias: "property"
      },
      "directive-block": {
        pattern: /<\/?\b(?:Auth[nz]ProviderAlias|Directory|DirectoryMatch|Else|ElseIf|Files|FilesMatch|If|IfDefine|IfModule|IfVersion|Limit|LimitExcept|Location|LocationMatch|Macro|Proxy|Require(?:All|Any|None)|VirtualHost)\b.*>/i,
        inside: {
          "directive-block": {
            pattern: /^<\/?\w+/,
            inside: {
              punctuation: /^<\/?/
            },
            alias: "tag"
          },
          "directive-block-parameter": {
            pattern: /.*[^>]/,
            inside: {
              punctuation: /:/,
              string: {
                pattern: /("|').*\1/,
                inside: {
                  variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
                }
              }
            },
            alias: "attr-value"
          },
          punctuation: />/
        },
        alias: "tag"
      },
      "directive-flags": {
        pattern: /\[(?:[\w=],?)+\]/,
        alias: "keyword"
      },
      string: {
        pattern: /("|').*\1/,
        inside: {
          variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
        }
      },
      variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/,
      regex: /\^?.*\$|\^.*\$?/
    };
  }
  return apacheconf_1;
}
var sql_1, hasRequiredSql;
function requireSql() {
  if (hasRequiredSql) return sql_1;
  hasRequiredSql = 1, sql_1 = n, n.displayName = "sql", n.aliases = [];
  function n(t) {
    t.languages.sql = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: !0
      },
      variable: [
        {
          pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
          greedy: !0
        },
        /@[\w.$]+/
      ],
      string: {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: !0,
        lookbehind: !0
      },
      identifier: {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: !0,
        lookbehind: !0,
        inside: {
          punctuation: /^`|`$/
        }
      },
      function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
      // Should we highlight user defined functions too?
      keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
      boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
      number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
      operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
      punctuation: /[;[\]()`,.]/
    };
  }
  return sql_1;
}
var apex_1, hasRequiredApex;
function requireApex() {
  if (hasRequiredApex) return apex_1;
  hasRequiredApex = 1;
  var n = requireSql();
  apex_1 = t, t.displayName = "apex", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      var k = /\b(?:(?:after|before)(?=\s+[a-z])|abstract|activate|and|any|array|as|asc|autonomous|begin|bigdecimal|blob|boolean|break|bulk|by|byte|case|cast|catch|char|class|collect|commit|const|continue|currency|date|datetime|decimal|default|delete|desc|do|double|else|end|enum|exception|exit|export|extends|final|finally|float|for|from|get(?=\s*[{};])|global|goto|group|having|hint|if|implements|import|in|inner|insert|instanceof|int|integer|interface|into|join|like|limit|list|long|loop|map|merge|new|not|null|nulls|number|object|of|on|or|outer|override|package|parallel|pragma|private|protected|public|retrieve|return|rollback|select|set|short|sObject|sort|static|string|super|switch|synchronized|system|testmethod|then|this|throw|time|transaction|transient|trigger|try|undelete|update|upsert|using|virtual|void|webservice|when|where|while|(?:inherited|with|without)\s+sharing)\b/i, H = /\b(?:(?=[a-z_]\w*\s*[<\[])|(?!<keyword>))[A-Z_]\w*(?:\s*\.\s*[A-Z_]\w*)*\b(?:\s*(?:\[\s*\]|<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>))*/.source.replace(
        /<keyword>/g,
        function() {
          return k.source;
        }
      );
      function AA(IA) {
        return RegExp(
          IA.replace(/<CLASS-NAME>/g, function() {
            return H;
          }),
          "i"
        );
      }
      var gA = {
        keyword: k,
        punctuation: /[()\[\]{};,:.<>]/
      };
      d.languages.apex = {
        comment: d.languages.clike.comment,
        string: d.languages.clike.string,
        sql: {
          pattern: /((?:[=,({:]|\breturn)\s*)\[[^\[\]]*\]/i,
          lookbehind: !0,
          greedy: !0,
          alias: "language-sql",
          inside: d.languages.sql
        },
        annotation: {
          pattern: /@\w+\b/,
          alias: "punctuation"
        },
        "class-name": [
          {
            pattern: AA(
              /(\b(?:class|enum|extends|implements|instanceof|interface|new|trigger\s+\w+\s+on)\s+)<CLASS-NAME>/.source
            ),
            lookbehind: !0,
            inside: gA
          },
          {
            // cast
            pattern: AA(
              /(\(\s*)<CLASS-NAME>(?=\s*\)\s*[\w(])/.source
            ),
            lookbehind: !0,
            inside: gA
          },
          {
            // variable/parameter declaration and return types
            pattern: AA(/<CLASS-NAME>(?=\s*\w+\s*[;=,(){:])/.source),
            inside: gA
          }
        ],
        trigger: {
          pattern: /(\btrigger\s+)\w+\b/i,
          lookbehind: !0,
          alias: "class-name"
        },
        keyword: k,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/i,
        number: /(?:\B\.\d+|\b\d+(?:\.\d+|L)?)\b/i,
        operator: /[!=](?:==?)?|\?\.?|&&|\|\||--|\+\+|[-+*/^&|]=?|:|<<?=?|>{1,3}=?/,
        punctuation: /[()\[\]{};,.]/
      };
    })(g);
  }
  return apex_1;
}
var apl_1, hasRequiredApl;
function requireApl() {
  if (hasRequiredApl) return apl_1;
  hasRequiredApl = 1, apl_1 = n, n.displayName = "apl", n.aliases = [];
  function n(t) {
    t.languages.apl = {
      comment: /(?:⍝|#[! ]).*$/m,
      string: {
        pattern: /'(?:[^'\r\n]|'')*'/,
        greedy: !0
      },
      number: /¯?(?:\d*\.?\b\d+(?:e[+¯]?\d+)?|¯|∞)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+)?|¯|∞))?/i,
      statement: /:[A-Z][a-z][A-Za-z]*\b/,
      "system-function": {
        pattern: /⎕[A-Z]+/i,
        alias: "function"
      },
      constant: /[⍬⌾#⎕⍞]/,
      function: /[-+×÷⌈⌊∣|⍳⍸?*⍟○!⌹<≤=>≥≠≡≢∊⍷∪∩~∨∧⍱⍲⍴,⍪⌽⊖⍉↑↓⊂⊃⊆⊇⌷⍋⍒⊤⊥⍕⍎⊣⊢⍁⍂≈⍯↗¤→]/,
      "monadic-operator": {
        pattern: /[\\\/⌿⍀¨⍨⌶&∥]/,
        alias: "operator"
      },
      "dyadic-operator": {
        pattern: /[.⍣⍠⍤∘⌸@⌺⍥]/,
        alias: "operator"
      },
      assignment: {
        pattern: /←/,
        alias: "keyword"
      },
      punctuation: /[\[;\]()◇⋄]/,
      dfn: {
        pattern: /[{}⍺⍵⍶⍹∇⍫:]/,
        alias: "builtin"
      }
    };
  }
  return apl_1;
}
var applescript_1, hasRequiredApplescript;
function requireApplescript() {
  if (hasRequiredApplescript) return applescript_1;
  hasRequiredApplescript = 1, applescript_1 = n, n.displayName = "applescript", n.aliases = [];
  function n(t) {
    t.languages.applescript = {
      comment: [
        // Allow one level of nesting
        /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
        /--.+/,
        /#.+/
      ],
      string: /"(?:\\.|[^"\\\r\n])*"/,
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?\b/i,
      operator: [
        /[&=≠≤≥*+\-\/÷^]|[<>]=?/,
        /\b(?:(?:begin|end|start)s? with|(?:contains?|(?:does not|doesn't) contain)|(?:is|isn't|is not) (?:contained by|in)|(?:(?:is|isn't|is not) )?(?:greater|less) than(?: or equal)?(?: to)?|(?:comes|(?:does not|doesn't) come) (?:after|before)|(?:is|isn't|is not) equal(?: to)?|(?:(?:does not|doesn't) equal|equal to|equals|is not|isn't)|(?:a )?(?:ref(?: to)?|reference to)|(?:and|as|div|mod|not|or))\b/
      ],
      keyword: /\b(?:about|above|after|against|apart from|around|aside from|at|back|before|beginning|behind|below|beneath|beside|between|but|by|considering|continue|copy|does|eighth|else|end|equal|error|every|exit|false|fifth|first|for|fourth|from|front|get|given|global|if|ignoring|in|instead of|into|is|it|its|last|local|me|middle|my|ninth|of|on|onto|out of|over|prop|property|put|repeat|return|returning|second|set|seventh|since|sixth|some|tell|tenth|that|the|then|third|through|thru|timeout|times|to|transaction|true|try|until|where|while|whose|with|without)\b/,
      "class-name": /\b(?:POSIX file|RGB color|alias|application|boolean|centimeters|centimetres|class|constant|cubic centimeters|cubic centimetres|cubic feet|cubic inches|cubic meters|cubic metres|cubic yards|date|degrees Celsius|degrees Fahrenheit|degrees Kelvin|feet|file|gallons|grams|inches|integer|kilograms|kilometers|kilometres|list|liters|litres|meters|metres|miles|number|ounces|pounds|quarts|real|record|reference|script|square feet|square kilometers|square kilometres|square meters|square metres|square miles|square yards|text|yards)\b/,
      punctuation: /[{}():,¬«»《》]/
    };
  }
  return applescript_1;
}
var aql_1, hasRequiredAql;
function requireAql() {
  if (hasRequiredAql) return aql_1;
  hasRequiredAql = 1, aql_1 = n, n.displayName = "aql", n.aliases = [];
  function n(t) {
    t.languages.aql = {
      comment: /\/\/.*|\/\*[\s\S]*?\*\//,
      property: {
        pattern: /([{,]\s*)(?:(?!\d)\w+|(["'´`])(?:(?!\2)[^\\\r\n]|\\.)*\2)(?=\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
        greedy: !0
      },
      identifier: {
        pattern: /([´`])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
        greedy: !0
      },
      variable: /@@?\w+/,
      keyword: [
        {
          pattern: /(\bWITH\s+)COUNT(?=\s+INTO\b)/i,
          lookbehind: !0
        },
        /\b(?:AGGREGATE|ALL|AND|ANY|ASC|COLLECT|DESC|DISTINCT|FILTER|FOR|GRAPH|IN|INBOUND|INSERT|INTO|K_PATHS|K_SHORTEST_PATHS|LET|LIKE|LIMIT|NONE|NOT|NULL|OR|OUTBOUND|REMOVE|REPLACE|RETURN|SHORTEST_PATH|SORT|UPDATE|UPSERT|WINDOW|WITH)\b/i,
        // pseudo keywords get a lookbehind to avoid false positives
        {
          pattern: /(^|[^\w.[])(?:KEEP|PRUNE|SEARCH|TO)\b/i,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\w.[])(?:CURRENT|NEW|OLD)\b/,
          lookbehind: !0
        },
        {
          pattern: /\bOPTIONS(?=\s*\{)/i
        }
      ],
      function: /\b(?!\d)\w+(?=\s*\()/,
      boolean: /\b(?:false|true)\b/i,
      range: {
        pattern: /\.\./,
        alias: "operator"
      },
      number: [
        /\b0b[01]+/i,
        /\b0x[0-9a-f]+/i,
        /(?:\B\.\d+|\b(?:0|[1-9]\d*)(?:\.\d+)?)(?:e[+-]?\d+)?/i
      ],
      operator: /\*{2,}|[=!]~|[!=<>]=?|&&|\|\||[-+*/%]/,
      punctuation: /::|[?.:,;()[\]{}]/
    };
  }
  return aql_1;
}
var c_1, hasRequiredC;
function requireC() {
  if (hasRequiredC) return c_1;
  hasRequiredC = 1, c_1 = n, n.displayName = "c", n.aliases = [];
  function n(t) {
    t.languages.c = t.languages.extend("clike", {
      comment: {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: !0
      },
      string: {
        // https://en.cppreference.com/w/c/language/string_literal
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: !0
      },
      keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
      operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
    }), t.languages.insertBefore("c", "string", {
      char: {
        // https://en.cppreference.com/w/c/language/character_constant
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: !0
      }
    }), t.languages.insertBefore("c", "string", {
      macro: {
        // allow for multiline macro definitions
        // spaces after the # character compile fine with gcc
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: !0,
        greedy: !0,
        alias: "property",
        inside: {
          string: [
            {
              // highlight the path of the include statement as a string
              pattern: /^(#\s*include\s*)<[^>]+>/,
              lookbehind: !0
            },
            t.languages.c.string
          ],
          char: t.languages.c.char,
          comment: t.languages.c.comment,
          "macro-name": [
            {
              pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
              lookbehind: !0
            },
            {
              pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
              lookbehind: !0,
              alias: "function"
            }
          ],
          // highlight macro directives as keywords
          directive: {
            pattern: /^(#\s*)[a-z]+/,
            lookbehind: !0,
            alias: "keyword"
          },
          "directive-hash": /^#/,
          punctuation: /##|\\(?=[\r\n])/,
          expression: {
            pattern: /\S[\s\S]*/,
            inside: t.languages.c
          }
        }
      }
    }), t.languages.insertBefore("c", "function", {
      // highlight predefined macros as constants
      constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
    }), delete t.languages.c.boolean;
  }
  return c_1;
}
var cpp_1, hasRequiredCpp;
function requireCpp() {
  if (hasRequiredCpp) return cpp_1;
  hasRequiredCpp = 1;
  var n = requireC();
  cpp_1 = t, t.displayName = "cpp", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      var k = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, H = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(
        /<keyword>/g,
        function() {
          return k.source;
        }
      );
      d.languages.cpp = d.languages.extend("c", {
        "class-name": [
          {
            pattern: RegExp(
              /(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(
                /<keyword>/g,
                function() {
                  return k.source;
                }
              )
            ),
            lookbehind: !0
          },
          // This is intended to capture the class name of method implementations like:
          //   void foo::bar() const {}
          // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
          // it starts with an uppercase letter. This approximation should give decent results.
          /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
          // This will capture the class name before destructors like:
          //   Foo::~Foo() {}
          /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
          // This also intends to capture the class name of method implementations but here the class has template
          // parameters, so it can't be a namespace (until C++ adds generic namespaces).
          /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
        ],
        keyword: k,
        number: {
          pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
          greedy: !0
        },
        operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
        boolean: /\b(?:false|true)\b/
      }), d.languages.insertBefore("cpp", "string", {
        module: {
          // https://en.cppreference.com/w/cpp/language/modules
          pattern: RegExp(
            /(\b(?:import|module)\s+)/.source + "(?:" + // header-name
            /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + // module name or partition or both
            /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(
              /<mod-name>/g,
              function() {
                return H;
              }
            ) + ")"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            string: /^[<"][\s\S]+/,
            operator: /:/,
            punctuation: /\./
          }
        },
        "raw-string": {
          pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
          alias: "string",
          greedy: !0
        }
      }), d.languages.insertBefore("cpp", "keyword", {
        "generic-function": {
          pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
          inside: {
            function: /^\w+/,
            generic: {
              pattern: /<[\s\S]+/,
              alias: "class-name",
              inside: d.languages.cpp
            }
          }
        }
      }), d.languages.insertBefore("cpp", "operator", {
        "double-colon": {
          pattern: /::/,
          alias: "punctuation"
        }
      }), d.languages.insertBefore("cpp", "class-name", {
        // the base clause is an optional list of parent classes
        // https://en.cppreference.com/w/cpp/language/class
        "base-clause": {
          pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
          lookbehind: !0,
          greedy: !0,
          inside: d.languages.extend("cpp", {})
        }
      }), d.languages.insertBefore(
        "inside",
        "double-colon",
        {
          // All untokenized words that are not namespaces should be class names
          "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
        },
        d.languages.cpp["base-clause"]
      );
    })(g);
  }
  return cpp_1;
}
var arduino_1, hasRequiredArduino;
function requireArduino() {
  if (hasRequiredArduino) return arduino_1;
  hasRequiredArduino = 1;
  var n = requireCpp();
  arduino_1 = t, t.displayName = "arduino", t.aliases = ["ino"];
  function t(g) {
    g.register(n), g.languages.arduino = g.languages.extend("cpp", {
      keyword: /\b(?:String|array|bool|boolean|break|byte|case|catch|continue|default|do|double|else|finally|for|function|goto|if|in|instanceof|int|integer|long|loop|new|null|return|setup|string|switch|throw|try|void|while|word)\b/,
      constant: /\b(?:ANALOG_MESSAGE|DEFAULT|DIGITAL_MESSAGE|EXTERNAL|FIRMATA_STRING|HIGH|INPUT|INPUT_PULLUP|INTERNAL|INTERNAL1V1|INTERNAL2V56|LED_BUILTIN|LOW|OUTPUT|REPORT_ANALOG|REPORT_DIGITAL|SET_PIN_MODE|SYSEX_START|SYSTEM_RESET)\b/,
      builtin: /\b(?:Audio|BSSID|Bridge|Client|Console|EEPROM|Esplora|EsploraTFT|Ethernet|EthernetClient|EthernetServer|EthernetUDP|File|FileIO|FileSystem|Firmata|GPRS|GSM|GSMBand|GSMClient|GSMModem|GSMPIN|GSMScanner|GSMServer|GSMVoiceCall|GSM_SMS|HttpClient|IPAddress|IRread|Keyboard|KeyboardController|LiquidCrystal|LiquidCrystal_I2C|Mailbox|Mouse|MouseController|PImage|Process|RSSI|RobotControl|RobotMotor|SD|SPI|SSID|Scheduler|Serial|Server|Servo|SoftwareSerial|Stepper|Stream|TFT|Task|USBHost|WiFi|WiFiClient|WiFiServer|WiFiUDP|Wire|YunClient|YunServer|abs|addParameter|analogRead|analogReadResolution|analogReference|analogWrite|analogWriteResolution|answerCall|attach|attachGPRS|attachInterrupt|attached|autoscroll|available|background|beep|begin|beginPacket|beginSD|beginSMS|beginSpeaker|beginTFT|beginTransmission|beginWrite|bit|bitClear|bitRead|bitSet|bitWrite|blink|blinkVersion|buffer|changePIN|checkPIN|checkPUK|checkReg|circle|cityNameRead|cityNameWrite|clear|clearScreen|click|close|compassRead|config|connect|connected|constrain|cos|countryNameRead|countryNameWrite|createChar|cursor|debugPrint|delay|delayMicroseconds|detach|detachInterrupt|digitalRead|digitalWrite|disconnect|display|displayLogos|drawBMP|drawCompass|encryptionType|end|endPacket|endSMS|endTransmission|endWrite|exists|exitValue|fill|find|findUntil|flush|gatewayIP|get|getAsynchronously|getBand|getButton|getCurrentCarrier|getIMEI|getKey|getModifiers|getOemKey|getPINUsed|getResult|getSignalStrength|getSocket|getVoiceCallStatus|getXChange|getYChange|hangCall|height|highByte|home|image|interrupts|isActionDone|isDirectory|isListening|isPIN|isPressed|isValid|keyPressed|keyReleased|keyboardRead|knobRead|leftToRight|line|lineFollowConfig|listen|listenOnLocalhost|loadImage|localIP|lowByte|macAddress|maintain|map|max|messageAvailable|micros|millis|min|mkdir|motorsStop|motorsWrite|mouseDragged|mouseMoved|mousePressed|mouseReleased|move|noAutoscroll|noBlink|noBuffer|noCursor|noDisplay|noFill|noInterrupts|noListenOnLocalhost|noStroke|noTone|onReceive|onRequest|open|openNextFile|overflow|parseCommand|parseFloat|parseInt|parsePacket|pauseMode|peek|pinMode|playFile|playMelody|point|pointTo|position|pow|prepare|press|print|printFirmwareVersion|printVersion|println|process|processInput|pulseIn|put|random|randomSeed|read|readAccelerometer|readBlue|readButton|readBytes|readBytesUntil|readGreen|readJoystickButton|readJoystickSwitch|readJoystickX|readJoystickY|readLightSensor|readMessage|readMicrophone|readNetworks|readRed|readSlider|readString|readStringUntil|readTemperature|ready|rect|release|releaseAll|remoteIP|remoteNumber|remotePort|remove|requestFrom|retrieveCallingNumber|rewindDirectory|rightToLeft|rmdir|robotNameRead|robotNameWrite|run|runAsynchronously|runShellCommand|runShellCommandAsynchronously|running|scanNetworks|scrollDisplayLeft|scrollDisplayRight|seek|sendAnalog|sendDigitalPortPair|sendDigitalPorts|sendString|sendSysex|serialEvent|setBand|setBitOrder|setClockDivider|setCursor|setDNS|setDataMode|setFirmwareVersion|setMode|setPINUsed|setSpeed|setTextSize|setTimeout|shiftIn|shiftOut|shutdown|sin|size|sqrt|startLoop|step|stop|stroke|subnetMask|switchPIN|tan|tempoWrite|text|tone|transfer|tuneWrite|turn|updateIR|userNameRead|userNameWrite|voiceCall|waitContinue|width|write|writeBlue|writeGreen|writeJSON|writeMessage|writeMicroseconds|writeRGB|writeRed|yield)\b/
    }), g.languages.ino = g.languages.arduino;
  }
  return arduino_1;
}
var arff_1, hasRequiredArff;
function requireArff() {
  if (hasRequiredArff) return arff_1;
  hasRequiredArff = 1, arff_1 = n, n.displayName = "arff", n.aliases = [];
  function n(t) {
    t.languages.arff = {
      comment: /%.*/,
      string: {
        pattern: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      keyword: /@(?:attribute|data|end|relation)\b/i,
      number: /\b\d+(?:\.\d+)?\b/,
      punctuation: /[{},]/
    };
  }
  return arff_1;
}
var asciidoc_1, hasRequiredAsciidoc;
function requireAsciidoc() {
  if (hasRequiredAsciidoc) return asciidoc_1;
  hasRequiredAsciidoc = 1, asciidoc_1 = n, n.displayName = "asciidoc", n.aliases = ["adoc"];
  function n(t) {
    (function(g) {
      var d = {
        pattern: /(^[ \t]*)\[(?!\[)(?:(["'$`])(?:(?!\2)[^\\]|\\.)*\2|\[(?:[^\[\]\\]|\\.)*\]|[^\[\]\\"'$`]|\\.)*\]/m,
        lookbehind: !0,
        inside: {
          quoted: {
            pattern: /([$`])(?:(?!\1)[^\\]|\\.)*\1/,
            inside: {
              punctuation: /^[$`]|[$`]$/
            }
          },
          interpreted: {
            pattern: /'(?:[^'\\]|\\.)*'/,
            inside: {
              punctuation: /^'|'$/
              // See rest below
            }
          },
          string: /"(?:[^"\\]|\\.)*"/,
          variable: /\w+(?==)/,
          punctuation: /^\[|\]$|,/,
          operator: /=/,
          // The negative look-ahead prevents blank matches
          "attr-value": /(?!^\s+$).+/
        }
      }, k = g.languages.asciidoc = {
        "comment-block": {
          pattern: /^(\/{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1/m,
          alias: "comment"
        },
        table: {
          pattern: /^\|={3,}(?:(?:\r?\n|\r(?!\n)).*)*?(?:\r?\n|\r)\|={3,}$/m,
          inside: {
            specifiers: {
              pattern: /(?:(?:(?:\d+(?:\.\d+)?|\.\d+)[+*](?:[<^>](?:\.[<^>])?|\.[<^>])?|[<^>](?:\.[<^>])?|\.[<^>])[a-z]*|[a-z]+)(?=\|)/,
              alias: "attr-value"
            },
            punctuation: {
              pattern: /(^|[^\\])[|!]=*/,
              lookbehind: !0
            }
            // See rest below
          }
        },
        "passthrough-block": {
          pattern: /^(\+{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
          inside: {
            punctuation: /^\++|\++$/
            // See rest below
          }
        },
        // Literal blocks and listing blocks
        "literal-block": {
          pattern: /^(-{4,}|\.{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
          inside: {
            punctuation: /^(?:-+|\.+)|(?:-+|\.+)$/
            // See rest below
          }
        },
        // Sidebar blocks, quote blocks, example blocks and open blocks
        "other-block": {
          pattern: /^(--|\*{4,}|_{4,}|={4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
          inside: {
            punctuation: /^(?:-+|\*+|_+|=+)|(?:-+|\*+|_+|=+)$/
            // See rest below
          }
        },
        // list-punctuation and list-label must appear before indented-block
        "list-punctuation": {
          pattern: /(^[ \t]*)(?:-|\*{1,5}|\.{1,5}|(?:[a-z]|\d+)\.|[xvi]+\))(?= )/im,
          lookbehind: !0,
          alias: "punctuation"
        },
        "list-label": {
          pattern: /(^[ \t]*)[a-z\d].+(?::{2,4}|;;)(?=\s)/im,
          lookbehind: !0,
          alias: "symbol"
        },
        "indented-block": {
          pattern: /((\r?\n|\r)\2)([ \t]+)\S.*(?:(?:\r?\n|\r)\3.+)*(?=\2{2}|$)/,
          lookbehind: !0
        },
        comment: /^\/\/.*/m,
        title: {
          pattern: /^.+(?:\r?\n|\r)(?:={3,}|-{3,}|~{3,}|\^{3,}|\+{3,})$|^={1,5} .+|^\.(?![\s.]).*/m,
          alias: "important",
          inside: {
            punctuation: /^(?:\.|=+)|(?:=+|-+|~+|\^+|\++)$/
            // See rest below
          }
        },
        "attribute-entry": {
          pattern: /^:[^:\r\n]+:(?: .*?(?: \+(?:\r?\n|\r).*?)*)?$/m,
          alias: "tag"
        },
        attributes: d,
        hr: {
          pattern: /^'{3,}$/m,
          alias: "punctuation"
        },
        "page-break": {
          pattern: /^<{3,}$/m,
          alias: "punctuation"
        },
        admonition: {
          pattern: /^(?:CAUTION|IMPORTANT|NOTE|TIP|WARNING):/m,
          alias: "keyword"
        },
        callout: [
          {
            pattern: /(^[ \t]*)<?\d*>/m,
            lookbehind: !0,
            alias: "symbol"
          },
          {
            pattern: /<\d+>/,
            alias: "symbol"
          }
        ],
        macro: {
          pattern: /\b[a-z\d][a-z\d-]*::?(?:[^\s\[\]]*\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
          inside: {
            function: /^[a-z\d-]+(?=:)/,
            punctuation: /^::?/,
            attributes: {
              pattern: /(?:\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
              inside: d.inside
            }
          }
        },
        inline: {
          /*
          The initial look-behind prevents the highlighting of escaped quoted text.
          Quoted text can be multi-line but cannot span an empty line.
          All quoted text can have attributes before [foobar, 'foobar', baz="bar"].
          First, we handle the constrained quotes.
          Those must be bounded by non-word chars and cannot have spaces between the delimiter and the first char.
          They are, in order: _emphasis_, ``double quotes'', `single quotes', `monospace`, 'emphasis', *strong*, +monospace+ and #unquoted#
          Then we handle the unconstrained quotes.
          Those do not have the restrictions of the constrained quotes.
          They are, in order: __emphasis__, **strong**, ++monospace++, +++passthrough+++, ##unquoted##, $$passthrough$$, ~subscript~, ^superscript^, {attribute-reference}, [[anchor]], [[[bibliography anchor]]], <<xref>>, (((indexes))) and ((indexes))
          */
          pattern: /(^|[^\\])(?:(?:\B\[(?:[^\]\\"']|(["'])(?:(?!\2)[^\\]|\\.)*\2|\\.)*\])?(?:\b_(?!\s)(?: _|[^_\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: _|[^_\\\r\n]|\\.)+)*_\b|\B``(?!\s).+?(?:(?:\r?\n|\r).+?)*''\B|\B`(?!\s)(?:[^`'\s]|\s+\S)+['`]\B|\B(['*+#])(?!\s)(?: \3|(?!\3)[^\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: \3|(?!\3)[^\\\r\n]|\\.)+)*\3\B)|(?:\[(?:[^\]\\"']|(["'])(?:(?!\4)[^\\]|\\.)*\4|\\.)*\])?(?:(__|\*\*|\+\+\+?|##|\$\$|[~^]).+?(?:(?:\r?\n|\r).+?)*\5|\{[^}\r\n]+\}|\[\[\[?.+?(?:(?:\r?\n|\r).+?)*\]?\]\]|<<.+?(?:(?:\r?\n|\r).+?)*>>|\(\(\(?.+?(?:(?:\r?\n|\r).+?)*\)?\)\)))/m,
          lookbehind: !0,
          inside: {
            attributes: d,
            url: {
              pattern: /^(?:\[\[\[?.+?\]?\]\]|<<.+?>>)$/,
              inside: {
                punctuation: /^(?:\[\[\[?|<<)|(?:\]\]\]?|>>)$/
              }
            },
            "attribute-ref": {
              pattern: /^\{.+\}$/,
              inside: {
                variable: {
                  pattern: /(^\{)[a-z\d,+_-]+/,
                  lookbehind: !0
                },
                operator: /^[=?!#%@$]|!(?=[:}])/,
                punctuation: /^\{|\}$|::?/
              }
            },
            italic: {
              pattern: /^(['_])[\s\S]+\1$/,
              inside: {
                punctuation: /^(?:''?|__?)|(?:''?|__?)$/
              }
            },
            bold: {
              pattern: /^\*[\s\S]+\*$/,
              inside: {
                punctuation: /^\*\*?|\*\*?$/
              }
            },
            punctuation: /^(?:``?|\+{1,3}|##?|\$\$|[~^]|\(\(\(?)|(?:''?|\+{1,3}|##?|\$\$|[~^`]|\)?\)\))$/
          }
        },
        replacement: {
          pattern: /\((?:C|R|TM)\)/,
          alias: "builtin"
        },
        entity: /&#?[\da-z]{1,8};/i,
        "line-continuation": {
          pattern: /(^| )\+$/m,
          lookbehind: !0,
          alias: "punctuation"
        }
      };
      function H(AA) {
        AA = AA.split(" ");
        for (var gA = {}, IA = 0, CA = AA.length; IA < CA; IA++)
          gA[AA[IA]] = k[AA[IA]];
        return gA;
      }
      d.inside.interpreted.inside.rest = H(
        "macro inline replacement entity"
      ), k["passthrough-block"].inside.rest = H("macro"), k["literal-block"].inside.rest = H("callout"), k.table.inside.rest = H(
        "comment-block passthrough-block literal-block other-block list-punctuation indented-block comment title attribute-entry attributes hr page-break admonition list-label callout macro inline replacement entity line-continuation"
      ), k["other-block"].inside.rest = H(
        "table list-punctuation indented-block comment attribute-entry attributes hr page-break admonition list-label macro inline replacement entity line-continuation"
      ), k.title.inside.rest = H(
        "macro inline replacement entity"
      ), g.hooks.add("wrap", function(AA) {
        AA.type === "entity" && (AA.attributes.title = AA.content.value.replace(/&amp;/, "&"));
      }), g.languages.adoc = g.languages.asciidoc;
    })(t);
  }
  return asciidoc_1;
}
var asm6502_1, hasRequiredAsm6502;
function requireAsm6502() {
  if (hasRequiredAsm6502) return asm6502_1;
  hasRequiredAsm6502 = 1, asm6502_1 = n, n.displayName = "asm6502", n.aliases = [];
  function n(t) {
    t.languages.asm6502 = {
      comment: /;.*/,
      directive: {
        pattern: /\.\w+(?= )/,
        alias: "property"
      },
      string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      "op-code": {
        pattern: /\b(?:ADC|AND|ASL|BCC|BCS|BEQ|BIT|BMI|BNE|BPL|BRK|BVC|BVS|CLC|CLD|CLI|CLV|CMP|CPX|CPY|DEC|DEX|DEY|EOR|INC|INX|INY|JMP|JSR|LDA|LDX|LDY|LSR|NOP|ORA|PHA|PHP|PLA|PLP|ROL|ROR|RTI|RTS|SBC|SEC|SED|SEI|STA|STX|STY|TAX|TAY|TSX|TXA|TXS|TYA|adc|and|asl|bcc|bcs|beq|bit|bmi|bne|bpl|brk|bvc|bvs|clc|cld|cli|clv|cmp|cpx|cpy|dec|dex|dey|eor|inc|inx|iny|jmp|jsr|lda|ldx|ldy|lsr|nop|ora|pha|php|pla|plp|rol|ror|rti|rts|sbc|sec|sed|sei|sta|stx|sty|tax|tay|tsx|txa|txs|tya)\b/,
        alias: "keyword"
      },
      "hex-number": {
        pattern: /#?\$[\da-f]{1,4}\b/i,
        alias: "number"
      },
      "binary-number": {
        pattern: /#?%[01]+\b/,
        alias: "number"
      },
      "decimal-number": {
        pattern: /#?\b\d+\b/,
        alias: "number"
      },
      register: {
        pattern: /\b[xya]\b/i,
        alias: "variable"
      },
      punctuation: /[(),:]/
    };
  }
  return asm6502_1;
}
var asmatmel_1, hasRequiredAsmatmel;
function requireAsmatmel() {
  if (hasRequiredAsmatmel) return asmatmel_1;
  hasRequiredAsmatmel = 1, asmatmel_1 = n, n.displayName = "asmatmel", n.aliases = [];
  function n(t) {
    t.languages.asmatmel = {
      comment: {
        pattern: /;.*/,
        greedy: !0
      },
      string: {
        pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      constant: /\b(?:PORT[A-Z]|DDR[A-Z]|(?:DD|P)[A-Z](?:\d|[0-2]\d|3[01]))\b/,
      directive: {
        pattern: /\.\w+(?= )/,
        alias: "property"
      },
      "r-register": {
        pattern: /\br(?:\d|[12]\d|3[01])\b/,
        alias: "variable"
      },
      "op-code": {
        pattern: /\b(?:ADC|ADD|ADIW|AND|ANDI|ASR|BCLR|BLD|BRBC|BRBS|BRCC|BRCS|BREAK|BREQ|BRGE|BRHC|BRHS|BRID|BRIE|BRLO|BRLT|BRMI|BRNE|BRPL|BRSH|BRTC|BRTS|BRVC|BRVS|BSET|BST|CALL|CBI|CBR|CLC|CLH|CLI|CLN|CLR|CLS|CLT|CLV|CLZ|COM|CP|CPC|CPI|CPSE|DEC|DES|EICALL|EIJMP|ELPM|EOR|FMUL|FMULS|FMULSU|ICALL|IJMP|IN|INC|JMP|LAC|LAS|LAT|LD|LD[A-Za-z0-9]|LPM|LSL|LSR|MOV|MOVW|MUL|MULS|MULSU|NEG|NOP|OR|ORI|OUT|POP|PUSH|RCALL|RET|RETI|RJMP|ROL|ROR|SBC|SBCI|SBI|SBIC|SBIS|SBIW|SBR|SBRC|SBRS|SEC|SEH|SEI|SEN|SER|SES|SET|SEV|SEZ|SLEEP|SPM|ST|ST[A-Z0-9]|SUB|SUBI|SWAP|TST|WDR|XCH|adc|add|adiw|and|andi|asr|bclr|bld|brbc|brbs|brcc|brcs|break|breq|brge|brhc|brhs|brid|brie|brlo|brlt|brmi|brne|brpl|brsh|brtc|brts|brvc|brvs|bset|bst|call|cbi|cbr|clc|clh|cli|cln|clr|cls|clt|clv|clz|com|cp|cpc|cpi|cpse|dec|des|eicall|eijmp|elpm|eor|fmul|fmuls|fmulsu|icall|ijmp|in|inc|jmp|lac|las|lat|ld|ld[a-z0-9]|lpm|lsl|lsr|mov|movw|mul|muls|mulsu|neg|nop|or|ori|out|pop|push|rcall|ret|reti|rjmp|rol|ror|sbc|sbci|sbi|sbic|sbis|sbiw|sbr|sbrc|sbrs|sec|seh|sei|sen|ser|ses|set|sev|sez|sleep|spm|st|st[a-zA-Z0-9]|sub|subi|swap|tst|wdr|xch)\b/,
        alias: "keyword"
      },
      "hex-number": {
        pattern: /#?\$[\da-f]{2,4}\b/i,
        alias: "number"
      },
      "binary-number": {
        pattern: /#?%[01]+\b/,
        alias: "number"
      },
      "decimal-number": {
        pattern: /#?\b\d+\b/,
        alias: "number"
      },
      register: {
        pattern: /\b[acznvshtixy]\b/i,
        alias: "variable"
      },
      operator: />>=?|<<=?|&&?|\|\|?|[-+*/%&|^!=<>?]=?/,
      punctuation: /[(),:]/
    };
  }
  return asmatmel_1;
}
var csharp_1, hasRequiredCsharp;
function requireCsharp() {
  if (hasRequiredCsharp) return csharp_1;
  hasRequiredCsharp = 1, csharp_1 = n, n.displayName = "csharp", n.aliases = ["dotnet", "cs"];
  function n(t) {
    (function(g) {
      function d(zA, XA) {
        return zA.replace(/<<(\d+)>>/g, function(fA, vA) {
          return "(?:" + XA[+vA] + ")";
        });
      }
      function k(zA, XA, fA) {
        return RegExp(d(zA, XA), "");
      }
      function H(zA, XA) {
        for (var fA = 0; fA < XA; fA++)
          zA = zA.replace(/<<self>>/g, function() {
            return "(?:" + zA + ")";
          });
        return zA.replace(/<<self>>/g, "[^\\s\\S]");
      }
      var AA = {
        // keywords which represent a return or variable type
        type: "bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void",
        // keywords which are used to declare a type
        typeDeclaration: "class enum interface record struct",
        // contextual keywords
        // ("var" and "dynamic" are missing because they are used like types)
        contextual: "add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)",
        // all other keywords
        other: "abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield"
      };
      function gA(zA) {
        return "\\b(?:" + zA.trim().replace(/ /g, "|") + ")\\b";
      }
      var IA = gA(
        AA.typeDeclaration
      ), CA = RegExp(
        gA(
          AA.type + " " + AA.typeDeclaration + " " + AA.contextual + " " + AA.other
        )
      ), BA = gA(
        AA.typeDeclaration + " " + AA.contextual + " " + AA.other
      ), eA = gA(
        AA.type + " " + AA.typeDeclaration + " " + AA.other
      ), iA = H(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2), QA = H(/\((?:[^()]|<<self>>)*\)/.source, 2), tA = /@?\b[A-Za-z_]\w*\b/.source, oA = d(/<<0>>(?:\s*<<1>>)?/.source, [tA, iA]), EA = d(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [
        BA,
        oA
      ]), aA = /\[\s*(?:,\s*)*\]/.source, nA = d(
        /<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source,
        [EA, aA]
      ), lA = d(
        /[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source,
        [iA, QA, aA]
      ), cA = d(/\(<<0>>+(?:,<<0>>+)+\)/.source, [lA]), sA = d(
        /(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source,
        [cA, EA, aA]
      ), rA = {
        keyword: CA,
        punctuation: /[<>()?,.:[\]]/
      }, uA = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source, hA = /"(?:\\.|[^\\"\r\n])*"/.source, dA = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
      g.languages.csharp = g.languages.extend("clike", {
        string: [
          {
            pattern: k(/(^|[^$\\])<<0>>/.source, [dA]),
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: k(/(^|[^@$\\])<<0>>/.source, [hA]),
            lookbehind: !0,
            greedy: !0
          }
        ],
        "class-name": [
          {
            // Using static
            // using static System.Math;
            pattern: k(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [
              EA
            ]),
            lookbehind: !0,
            inside: rA
          },
          {
            // Using alias (type)
            // using Project = PC.MyCompany.Project;
            pattern: k(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [
              tA,
              sA
            ]),
            lookbehind: !0,
            inside: rA
          },
          {
            // Using alias (alias)
            // using Project = PC.MyCompany.Project;
            pattern: k(/(\busing\s+)<<0>>(?=\s*=)/.source, [tA]),
            lookbehind: !0
          },
          {
            // Type declarations
            // class Foo<A, B>
            // interface Foo<out A, B>
            pattern: k(/(\b<<0>>\s+)<<1>>/.source, [
              IA,
              oA
            ]),
            lookbehind: !0,
            inside: rA
          },
          {
            // Single catch exception declaration
            // catch(Foo)
            // (things like catch(Foo e) is covered by variable declaration)
            pattern: k(/(\bcatch\s*\(\s*)<<0>>/.source, [EA]),
            lookbehind: !0,
            inside: rA
          },
          {
            // Name of the type parameter of generic constraints
            // where Foo : class
            pattern: k(/(\bwhere\s+)<<0>>/.source, [tA]),
            lookbehind: !0
          },
          {
            // Casts and checks via as and is.
            // as Foo<A>, is Bar<B>
            // (things like if(a is Foo b) is covered by variable declaration)
            pattern: k(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [
              nA
            ]),
            lookbehind: !0,
            inside: rA
          },
          {
            // Variable, field and parameter declaration
            // (Foo bar, Bar baz, Foo[,,] bay, Foo<Bar, FooBar<Bar>> bax)
            pattern: k(
              /\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source,
              [sA, eA, tA]
            ),
            inside: rA
          }
        ],
        keyword: CA,
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#literals
        number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
        operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
        punctuation: /\?\.?|::|[{}[\];(),.:]/
      }), g.languages.insertBefore("csharp", "number", {
        range: {
          pattern: /\.\./,
          alias: "operator"
        }
      }), g.languages.insertBefore("csharp", "punctuation", {
        "named-parameter": {
          pattern: k(/([(,]\s*)<<0>>(?=\s*:)/.source, [tA]),
          lookbehind: !0,
          alias: "punctuation"
        }
      }), g.languages.insertBefore("csharp", "class-name", {
        namespace: {
          // namespace Foo.Bar {}
          // using Foo.Bar;
          pattern: k(
            /(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source,
            [tA]
          ),
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        },
        "type-expression": {
          // default(Foo), typeof(Foo<Bar>), sizeof(int)
          pattern: k(
            /(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source,
            [QA]
          ),
          lookbehind: !0,
          alias: "class-name",
          inside: rA
        },
        "return-type": {
          // Foo<Bar> ForBar(); Foo IFoo.Bar() => 0
          // int this[int index] => 0; T IReadOnlyList<T>.this[int index] => this[index];
          // int Foo => 0; int Foo { get; set } = 0;
          pattern: k(
            /<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source,
            [sA, EA]
          ),
          inside: rA,
          alias: "class-name"
        },
        "constructor-invocation": {
          // new List<Foo<Bar[]>> { }
          pattern: k(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [sA]),
          lookbehind: !0,
          inside: rA,
          alias: "class-name"
        },
        /*'explicit-implementation': {
        // int IFoo<Foo>.Bar => 0; void IFoo<Foo<Foo>>.Foo<T>();
        pattern: replace(/\b<<0>>(?=\.<<1>>)/, className, methodOrPropertyDeclaration),
        inside: classNameInside,
        alias: 'class-name'
        },*/
        "generic-method": {
          // foo<Bar>()
          pattern: k(/<<0>>\s*<<1>>(?=\s*\()/.source, [tA, iA]),
          inside: {
            function: k(/^<<0>>/.source, [tA]),
            generic: {
              pattern: RegExp(iA),
              alias: "class-name",
              inside: rA
            }
          }
        },
        "type-list": {
          // The list of types inherited or of generic constraints
          // class Foo<F> : Bar, IList<FooBar>
          // where F : Bar, IList<int>
          pattern: k(
            /\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source,
            [
              IA,
              oA,
              tA,
              sA,
              CA.source,
              QA,
              /\bnew\s*\(\s*\)/.source
            ]
          ),
          lookbehind: !0,
          inside: {
            "record-arguments": {
              pattern: k(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [
                oA,
                QA
              ]),
              lookbehind: !0,
              greedy: !0,
              inside: g.languages.csharp
            },
            keyword: CA,
            "class-name": {
              pattern: RegExp(sA),
              greedy: !0,
              inside: rA
            },
            punctuation: /[,()]/
          }
        },
        preprocessor: {
          pattern: /(^[\t ]*)#.*/m,
          lookbehind: !0,
          alias: "property",
          inside: {
            // highlight preprocessor directives as keywords
            directive: {
              pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
              lookbehind: !0,
              alias: "keyword"
            }
          }
        }
      });
      var GA = hA + "|" + uA, DA = d(
        /\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source,
        [GA]
      ), wA = H(
        d(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
          DA
        ]),
        2
      ), bA = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source, yA = d(/<<0>>(?:\s*\(<<1>>*\))?/.source, [
        EA,
        wA
      ]);
      g.languages.insertBefore("csharp", "class-name", {
        attribute: {
          // Attributes
          // [Foo], [Foo(1), Bar(2, Prop = "foo")], [return: Foo(1), Bar(2)], [assembly: Foo(Bar)]
          pattern: k(
            /((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source,
            [bA, yA]
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            target: {
              pattern: k(/^<<0>>(?=\s*:)/.source, [bA]),
              alias: "keyword"
            },
            "attribute-arguments": {
              pattern: k(/\(<<0>>*\)/.source, [wA]),
              inside: g.languages.csharp
            },
            "class-name": {
              pattern: RegExp(EA),
              inside: {
                punctuation: /\./
              }
            },
            punctuation: /[:,]/
          }
        }
      });
      var pA = /:[^}\r\n]+/.source, MA = H(
        d(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
          DA
        ]),
        2
      ), LA = d(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
        MA,
        pA
      ]), xA = H(
        d(
          /[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source,
          [GA]
        ),
        2
      ), TA = d(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
        xA,
        pA
      ]);
      function NA(zA, XA) {
        return {
          interpolation: {
            pattern: k(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [zA]),
            lookbehind: !0,
            inside: {
              "format-string": {
                pattern: k(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [
                  XA,
                  pA
                ]),
                lookbehind: !0,
                inside: {
                  punctuation: /^:/
                }
              },
              punctuation: /^\{|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                alias: "language-csharp",
                inside: g.languages.csharp
              }
            }
          },
          string: /[\s\S]+/
        };
      }
      g.languages.insertBefore("csharp", "string", {
        "interpolation-string": [
          {
            pattern: k(
              /(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source,
              [LA]
            ),
            lookbehind: !0,
            greedy: !0,
            inside: NA(LA, MA)
          },
          {
            pattern: k(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [
              TA
            ]),
            lookbehind: !0,
            greedy: !0,
            inside: NA(TA, xA)
          }
        ],
        char: {
          pattern: RegExp(uA),
          greedy: !0
        }
      }), g.languages.dotnet = g.languages.cs = g.languages.csharp;
    })(t);
  }
  return csharp_1;
}
var aspnet_1, hasRequiredAspnet;
function requireAspnet() {
  if (hasRequiredAspnet) return aspnet_1;
  hasRequiredAspnet = 1;
  var n = requireCsharp();
  aspnet_1 = t, t.displayName = "aspnet", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.aspnet = g.languages.extend("markup", {
      "page-directive": {
        pattern: /<%\s*@.*%>/,
        alias: "tag",
        inside: {
          "page-directive": {
            pattern: /<%\s*@\s*(?:Assembly|Control|Implements|Import|Master(?:Type)?|OutputCache|Page|PreviousPageType|Reference|Register)?|%>/i,
            alias: "tag"
          },
          rest: g.languages.markup.tag.inside
        }
      },
      directive: {
        pattern: /<%.*%>/,
        alias: "tag",
        inside: {
          directive: {
            pattern: /<%\s*?[$=%#:]{0,2}|%>/,
            alias: "tag"
          },
          rest: g.languages.csharp
        }
      }
    }), g.languages.aspnet.tag.pattern = /<(?!%)\/?[^\s>\/]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/, g.languages.insertBefore(
      "inside",
      "punctuation",
      {
        directive: g.languages.aspnet.directive
      },
      g.languages.aspnet.tag.inside["attr-value"]
    ), g.languages.insertBefore("aspnet", "comment", {
      "asp-comment": {
        pattern: /<%--[\s\S]*?--%>/,
        alias: ["asp", "comment"]
      }
    }), g.languages.insertBefore(
      "aspnet",
      g.languages.javascript ? "script" : "tag",
      {
        "asp-script": {
          pattern: /(<script(?=.*runat=['"]?server\b)[^>]*>)[\s\S]*?(?=<\/script>)/i,
          lookbehind: !0,
          alias: ["asp", "script"],
          inside: g.languages.csharp || {}
        }
      }
    );
  }
  return aspnet_1;
}
var autohotkey_1, hasRequiredAutohotkey;
function requireAutohotkey() {
  if (hasRequiredAutohotkey) return autohotkey_1;
  hasRequiredAutohotkey = 1, autohotkey_1 = n, n.displayName = "autohotkey", n.aliases = [];
  function n(t) {
    t.languages.autohotkey = {
      comment: [
        {
          pattern: /(^|\s);.*/,
          lookbehind: !0
        },
        {
          pattern: /(^[\t ]*)\/\*(?:[\r\n](?![ \t]*\*\/)|[^\r\n])*(?:[\r\n][ \t]*\*\/)?/m,
          lookbehind: !0,
          greedy: !0
        }
      ],
      tag: {
        // labels
        pattern: /^([ \t]*)[^\s,`":]+(?=:[ \t]*$)/m,
        lookbehind: !0
      },
      string: /"(?:[^"\n\r]|"")*"/,
      variable: /%\w+%/,
      number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
      operator: /\?|\/\/?=?|:=|\|[=|]?|&[=&]?|\+[=+]?|-[=-]?|\*[=*]?|<(?:<=?|>|=)?|>>?=?|[.^!=~]=?|\b(?:AND|NOT|OR)\b/,
      boolean: /\b(?:false|true)\b/,
      selector: /\b(?:AutoTrim|BlockInput|Break|Click|ClipWait|Continue|Control|ControlClick|ControlFocus|ControlGet|ControlGetFocus|ControlGetPos|ControlGetText|ControlMove|ControlSend|ControlSendRaw|ControlSetText|CoordMode|Critical|DetectHiddenText|DetectHiddenWindows|Drive|DriveGet|DriveSpaceFree|EnvAdd|EnvDiv|EnvGet|EnvMult|EnvSet|EnvSub|EnvUpdate|Exit|ExitApp|FileAppend|FileCopy|FileCopyDir|FileCreateDir|FileCreateShortcut|FileDelete|FileEncoding|FileGetAttrib|FileGetShortcut|FileGetSize|FileGetTime|FileGetVersion|FileInstall|FileMove|FileMoveDir|FileRead|FileReadLine|FileRecycle|FileRecycleEmpty|FileRemoveDir|FileSelectFile|FileSelectFolder|FileSetAttrib|FileSetTime|FormatTime|GetKeyState|Gosub|Goto|GroupActivate|GroupAdd|GroupClose|GroupDeactivate|Gui|GuiControl|GuiControlGet|Hotkey|ImageSearch|IniDelete|IniRead|IniWrite|Input|InputBox|KeyWait|ListHotkeys|ListLines|ListVars|Loop|Menu|MouseClick|MouseClickDrag|MouseGetPos|MouseMove|MsgBox|OnExit|OutputDebug|Pause|PixelGetColor|PixelSearch|PostMessage|Process|Progress|Random|RegDelete|RegRead|RegWrite|Reload|Repeat|Return|Run|RunAs|RunWait|Send|SendEvent|SendInput|SendMessage|SendMode|SendPlay|SendRaw|SetBatchLines|SetCapslockState|SetControlDelay|SetDefaultMouseSpeed|SetEnv|SetFormat|SetKeyDelay|SetMouseDelay|SetNumlockState|SetRegView|SetScrollLockState|SetStoreCapslockMode|SetTimer|SetTitleMatchMode|SetWinDelay|SetWorkingDir|Shutdown|Sleep|Sort|SoundBeep|SoundGet|SoundGetWaveVolume|SoundPlay|SoundSet|SoundSetWaveVolume|SplashImage|SplashTextOff|SplashTextOn|SplitPath|StatusBarGetText|StatusBarWait|StringCaseSense|StringGetPos|StringLeft|StringLen|StringLower|StringMid|StringReplace|StringRight|StringSplit|StringTrimLeft|StringTrimRight|StringUpper|Suspend|SysGet|Thread|ToolTip|Transform|TrayTip|URLDownloadToFile|WinActivate|WinActivateBottom|WinClose|WinGet|WinGetActiveStats|WinGetActiveTitle|WinGetClass|WinGetPos|WinGetText|WinGetTitle|WinHide|WinKill|WinMaximize|WinMenuSelectItem|WinMinimize|WinMinimizeAll|WinMinimizeAllUndo|WinMove|WinRestore|WinSet|WinSetTitle|WinShow|WinWait|WinWaitActive|WinWaitClose|WinWaitNotActive)\b/i,
      constant: /\b(?:a_ahkpath|a_ahkversion|a_appdata|a_appdatacommon|a_autotrim|a_batchlines|a_caretx|a_carety|a_computername|a_controldelay|a_cursor|a_dd|a_ddd|a_dddd|a_defaultmousespeed|a_desktop|a_desktopcommon|a_detecthiddentext|a_detecthiddenwindows|a_endchar|a_eventinfo|a_exitreason|a_fileencoding|a_formatfloat|a_formatinteger|a_gui|a_guicontrol|a_guicontrolevent|a_guievent|a_guiheight|a_guiwidth|a_guix|a_guiy|a_hour|a_iconfile|a_iconhidden|a_iconnumber|a_icontip|a_index|a_ipaddress1|a_ipaddress2|a_ipaddress3|a_ipaddress4|a_is64bitos|a_isadmin|a_iscompiled|a_iscritical|a_ispaused|a_issuspended|a_isunicode|a_keydelay|a_language|a_lasterror|a_linefile|a_linenumber|a_loopfield|a_loopfileattrib|a_loopfiledir|a_loopfileext|a_loopfilefullpath|a_loopfilelongpath|a_loopfilename|a_loopfileshortname|a_loopfileshortpath|a_loopfilesize|a_loopfilesizekb|a_loopfilesizemb|a_loopfiletimeaccessed|a_loopfiletimecreated|a_loopfiletimemodified|a_loopreadline|a_loopregkey|a_loopregname|a_loopregsubkey|a_loopregtimemodified|a_loopregtype|a_mday|a_min|a_mm|a_mmm|a_mmmm|a_mon|a_mousedelay|a_msec|a_mydocuments|a_now|a_nowutc|a_numbatchlines|a_ostype|a_osversion|a_priorhotkey|a_priorkey|a_programfiles|a_programs|a_programscommon|a_ptrsize|a_regview|a_screendpi|a_screenheight|a_screenwidth|a_scriptdir|a_scriptfullpath|a_scripthwnd|a_scriptname|a_sec|a_space|a_startmenu|a_startmenucommon|a_startup|a_startupcommon|a_stringcasesense|a_tab|a_temp|a_thisfunc|a_thishotkey|a_thislabel|a_thismenu|a_thismenuitem|a_thismenuitempos|a_tickcount|a_timeidle|a_timeidlephysical|a_timesincepriorhotkey|a_timesincethishotkey|a_titlematchmode|a_titlematchmodespeed|a_username|a_wday|a_windelay|a_windir|a_workingdir|a_yday|a_year|a_yweek|a_yyyy|clipboard|clipboardall|comspec|errorlevel|programfiles)\b/i,
      builtin: /\b(?:abs|acos|asc|asin|atan|ceil|chr|class|comobjactive|comobjarray|comobjconnect|comobjcreate|comobjerror|comobjflags|comobjget|comobjquery|comobjtype|comobjvalue|cos|dllcall|exp|fileexist|Fileopen|floor|format|il_add|il_create|il_destroy|instr|isfunc|islabel|IsObject|ln|log|ltrim|lv_add|lv_delete|lv_deletecol|lv_getcount|lv_getnext|lv_gettext|lv_insert|lv_insertcol|lv_modify|lv_modifycol|lv_setimagelist|mod|numget|numput|onmessage|regexmatch|regexreplace|registercallback|round|rtrim|sb_seticon|sb_setparts|sb_settext|sin|sqrt|strlen|strreplace|strsplit|substr|tan|tv_add|tv_delete|tv_get|tv_getchild|tv_getcount|tv_getnext|tv_getparent|tv_getprev|tv_getselection|tv_gettext|tv_modify|varsetcapacity|winactive|winexist|__Call|__Get|__New|__Set)\b/i,
      symbol: /\b(?:alt|altdown|altup|appskey|backspace|browser_back|browser_favorites|browser_forward|browser_home|browser_refresh|browser_search|browser_stop|bs|capslock|ctrl|ctrlbreak|ctrldown|ctrlup|del|delete|down|end|enter|esc|escape|f1|f10|f11|f12|f13|f14|f15|f16|f17|f18|f19|f2|f20|f21|f22|f23|f24|f3|f4|f5|f6|f7|f8|f9|home|ins|insert|joy1|joy10|joy11|joy12|joy13|joy14|joy15|joy16|joy17|joy18|joy19|joy2|joy20|joy21|joy22|joy23|joy24|joy25|joy26|joy27|joy28|joy29|joy3|joy30|joy31|joy32|joy4|joy5|joy6|joy7|joy8|joy9|joyaxes|joybuttons|joyinfo|joyname|joypov|joyr|joyu|joyv|joyx|joyy|joyz|lalt|launch_app1|launch_app2|launch_mail|launch_media|lbutton|lcontrol|lctrl|left|lshift|lwin|lwindown|lwinup|mbutton|media_next|media_play_pause|media_prev|media_stop|numlock|numpad0|numpad1|numpad2|numpad3|numpad4|numpad5|numpad6|numpad7|numpad8|numpad9|numpadadd|numpadclear|numpaddel|numpaddiv|numpaddot|numpaddown|numpadend|numpadenter|numpadhome|numpadins|numpadleft|numpadmult|numpadpgdn|numpadpgup|numpadright|numpadsub|numpadup|pgdn|pgup|printscreen|ralt|rbutton|rcontrol|rctrl|right|rshift|rwin|rwindown|rwinup|scrolllock|shift|shiftdown|shiftup|space|tab|up|volume_down|volume_mute|volume_up|wheeldown|wheelleft|wheelright|wheelup|xbutton1|xbutton2)\b/i,
      important: /#\b(?:AllowSameLineComments|ClipboardTimeout|CommentFlag|DerefChar|ErrorStdOut|EscapeChar|HotkeyInterval|HotkeyModifierTimeout|Hotstring|If|IfTimeout|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Include|IncludeAgain|InputLevel|InstallKeybdHook|InstallMouseHook|KeyHistory|MaxHotkeysPerInterval|MaxMem|MaxThreads|MaxThreadsBuffer|MaxThreadsPerHotkey|MenuMaskKey|NoEnv|NoTrayIcon|Persistent|SingleInstance|UseHook|Warn|WinActivateForce)\b/i,
      keyword: /\b(?:Abort|AboveNormal|Add|ahk_class|ahk_exe|ahk_group|ahk_id|ahk_pid|All|Alnum|Alpha|AltSubmit|AltTab|AltTabAndMenu|AltTabMenu|AltTabMenuDismiss|AlwaysOnTop|AutoSize|Background|BackgroundTrans|BelowNormal|between|BitAnd|BitNot|BitOr|BitShiftLeft|BitShiftRight|BitXOr|Bold|Border|Button|ByRef|Catch|Checkbox|Checked|CheckedGray|Choose|ChooseString|Close|Color|ComboBox|Contains|ControlList|Count|Date|DateTime|Days|DDL|Default|DeleteAll|Delimiter|Deref|Destroy|Digit|Disable|Disabled|DropDownList|Edit|Eject|Else|Enable|Enabled|Error|Exist|Expand|ExStyle|FileSystem|Finally|First|Flash|Float|FloatFast|Focus|Font|for|global|Grid|Group|GroupBox|GuiClose|GuiContextMenu|GuiDropFiles|GuiEscape|GuiSize|Hdr|Hidden|Hide|High|HKCC|HKCR|HKCU|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_LOCAL_MACHINE|HKEY_USERS|HKLM|HKU|Hours|HScroll|Icon|IconSmall|ID|IDLast|If|IfEqual|IfExist|IfGreater|IfGreaterOrEqual|IfInString|IfLess|IfLessOrEqual|IfMsgBox|IfNotEqual|IfNotExist|IfNotInString|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Ignore|ImageList|in|Integer|IntegerFast|Interrupt|is|italic|Join|Label|LastFound|LastFoundExist|Limit|Lines|List|ListBox|ListView|local|Lock|Logoff|Low|Lower|Lowercase|MainWindow|Margin|Maximize|MaximizeBox|MaxSize|Minimize|MinimizeBox|MinMax|MinSize|Minutes|MonthCal|Mouse|Move|Multi|NA|No|NoActivate|NoDefault|NoHide|NoIcon|NoMainWindow|norm|Normal|NoSort|NoSortHdr|NoStandard|Not|NoTab|NoTimers|Number|Off|Ok|On|OwnDialogs|Owner|Parse|Password|Picture|Pixel|Pos|Pow|Priority|ProcessName|Radio|Range|Read|ReadOnly|Realtime|Redraw|Region|REG_BINARY|REG_DWORD|REG_EXPAND_SZ|REG_MULTI_SZ|REG_SZ|Relative|Rename|Report|Resize|Restore|Retry|RGB|Screen|Seconds|Section|Serial|SetLabel|ShiftAltTab|Show|Single|Slider|SortDesc|Standard|static|Status|StatusBar|StatusCD|strike|Style|Submit|SysMenu|Tab2|TabStop|Text|Theme|Throw|Tile|ToggleCheck|ToggleEnable|ToolWindow|Top|Topmost|TransColor|Transparent|Tray|TreeView|Try|TryAgain|Type|UnCheck|underline|Unicode|Unlock|Until|UpDown|Upper|Uppercase|UseErrorLevel|Vis|VisFirst|Visible|VScroll|Wait|WaitClose|WantCtrlA|WantF2|WantReturn|While|Wrap|Xdigit|xm|xp|xs|Yes|ym|yp|ys)\b/i,
      function: /[^(); \t,\n+*\-=?>:\\\/<&%\[\]]+(?=\()/,
      punctuation: /[{}[\]():,]/
    };
  }
  return autohotkey_1;
}
var autoit_1, hasRequiredAutoit;
function requireAutoit() {
  if (hasRequiredAutoit) return autoit_1;
  hasRequiredAutoit = 1, autoit_1 = n, n.displayName = "autoit", n.aliases = [];
  function n(t) {
    t.languages.autoit = {
      comment: [
        /;.*/,
        {
          // The multi-line comments delimiters can actually be commented out with ";"
          pattern: /(^[\t ]*)#(?:comments-start|cs)[\s\S]*?^[ \t]*#(?:ce|comments-end)/m,
          lookbehind: !0
        }
      ],
      url: {
        pattern: /(^[\t ]*#include\s+)(?:<[^\r\n>]+>|"[^\r\n"]+")/m,
        lookbehind: !0
      },
      string: {
        pattern: /(["'])(?:\1\1|(?!\1)[^\r\n])*\1/,
        greedy: !0,
        inside: {
          variable: /([%$@])\w+\1/
        }
      },
      directive: {
        pattern: /(^[\t ]*)#[\w-]+/m,
        lookbehind: !0,
        alias: "keyword"
      },
      function: /\b\w+(?=\()/,
      // Variables and macros
      variable: /[$@]\w+/,
      keyword: /\b(?:Case|Const|Continue(?:Case|Loop)|Default|Dim|Do|Else(?:If)?|End(?:Func|If|Select|Switch|With)|Enum|Exit(?:Loop)?|For|Func|Global|If|In|Local|Next|Null|ReDim|Select|Static|Step|Switch|Then|To|Until|Volatile|WEnd|While|With)\b/i,
      number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
      boolean: /\b(?:False|True)\b/i,
      operator: /<[=>]?|[-+*\/=&>]=?|[?^]|\b(?:And|Not|Or)\b/i,
      punctuation: /[\[\]().,:]/
    };
  }
  return autoit_1;
}
var avisynth_1, hasRequiredAvisynth;
function requireAvisynth() {
  if (hasRequiredAvisynth) return avisynth_1;
  hasRequiredAvisynth = 1, avisynth_1 = n, n.displayName = "avisynth", n.aliases = ["avs"];
  function n(t) {
    (function(g) {
      function d(BA, eA) {
        return BA.replace(/<<(\d+)>>/g, function(iA, QA) {
          return eA[+QA];
        });
      }
      function k(BA, eA, iA) {
        return RegExp(d(BA, eA), iA);
      }
      var H = /bool|clip|float|int|string|val/.source, AA = [
        // bools
        /is(?:bool|clip|float|int|string)|defined|(?:(?:internal)?function|var)?exists?/.source,
        // control
        /apply|assert|default|eval|import|nop|select|undefined/.source,
        // global
        /opt_(?:allowfloataudio|avipadscanlines|dwchannelmask|enable_(?:b64a|planartopackedrgb|v210|y3_10_10|y3_10_16)|usewaveextensible|vdubplanarhack)|set(?:cachemode|maxcpu|memorymax|planarlegacyalignment|workingdir)/.source,
        // conv
        /hex(?:value)?|value/.source,
        // numeric
        /abs|ceil|continued(?:denominator|numerator)?|exp|floor|fmod|frac|log(?:10)?|max|min|muldiv|pi|pow|rand|round|sign|spline|sqrt/.source,
        // trig
        /a?sinh?|a?cosh?|a?tan[2h]?/.source,
        // bit
        /(?:bit(?:and|not|x?or|[lr]?shift[aslu]?|sh[lr]|sa[lr]|[lr]rotatel?|ro[rl]|te?st|set(?:count)?|cl(?:ea)?r|ch(?:an)?ge?))/.source,
        // runtime
        /average(?:[bgr]|chroma[uv]|luma)|(?:[rgb]|chroma[uv]|luma|rgb|[yuv](?=difference(?:fromprevious|tonext)))difference(?:fromprevious|tonext)?|[yuvrgb]plane(?:median|min|max|minmaxdifference)/.source,
        // script
        /getprocessinfo|logmsg|script(?:dir(?:utf8)?|file(?:utf8)?|name(?:utf8)?)|setlogparams/.source,
        // string
        /chr|(?:fill|find|left|mid|replace|rev|right)str|format|[lu]case|ord|str(?:cmpi?|fromutf8|len|toutf8)|time|trim(?:all|left|right)/.source,
        // version
        /isversionorgreater|version(?:number|string)/.source,
        // helper
        /buildpixeltype|colorspacenametopixeltype/.source,
        // avsplus
        /addautoloaddir|on(?:cpu|cuda)|prefetch|setfiltermtmode/.source
      ].join("|"), gA = [
        // content
        /has(?:audio|video)/.source,
        // resolution
        /height|width/.source,
        // framerate
        /frame(?:count|rate)|framerate(?:denominator|numerator)/.source,
        // interlacing
        /getparity|is(?:field|frame)based/.source,
        // color format
        /bitspercomponent|componentsize|hasalpha|is(?:planar(?:rgba?)?|interleaved|rgb(?:24|32|48|64)?|y(?:8|u(?:va?|y2))?|yv(?:12|16|24|411)|420|422|444|packedrgb)|numcomponents|pixeltype/.source,
        // audio
        /audio(?:bits|channels|duration|length(?:[fs]|hi|lo)?|rate)|isaudio(?:float|int)/.source
      ].join("|"), IA = [
        // source
        /avi(?:file)?source|directshowsource|image(?:reader|source|sourceanim)|opendmlsource|segmented(?:avisource|directshowsource)|wavsource/.source,
        // color
        /coloryuv|convertbacktoyuy2|convertto(?:RGB(?:24|32|48|64)|(?:planar)?RGBA?|Y8?|YV(?:12|16|24|411)|YUVA?(?:411|420|422|444)|YUY2)|fixluminance|gr[ae]yscale|invert|levels|limiter|mergea?rgb|merge(?:chroma|luma)|rgbadjust|show(?:alpha|blue|green|red)|swapuv|tweak|[uv]toy8?|ytouv/.source,
        // overlay
        /(?:colorkey|reset)mask|layer|mask(?:hs)?|merge|overlay|subtract/.source,
        // geometry
        /addborders|(?:bicubic|bilinear|blackman|gauss|lanczos4|lanczos|point|sinc|spline(?:16|36|64))resize|crop(?:bottom)?|flip(?:horizontal|vertical)|(?:horizontal|vertical)?reduceby2|letterbox|skewrows|turn(?:180|left|right)/.source,
        // pixel
        /blur|fixbrokenchromaupsampling|generalconvolution|(?:spatial|temporal)soften|sharpen/.source,
        // timeline
        /trim|(?:un)?alignedsplice|(?:assume|assumescaled|change|convert)FPS|(?:delete|duplicate)frame|dissolve|fade(?:in|io|out)[02]?|freezeframe|interleave|loop|reverse|select(?:even|odd|(?:range)?every)/.source,
        // interlace
        /assume[bt]ff|assume(?:field|frame)based|bob|complementparity|doubleweave|peculiarblend|pulldown|separate(?:columns|fields|rows)|swapfields|weave(?:columns|rows)?/.source,
        // audio
        /amplify(?:db)?|assumesamplerate|audiodub(?:ex)?|audiotrim|convertaudioto(?:(?:8|16|24|32)bit|float)|converttomono|delayaudio|ensurevbrmp3sync|get(?:left|right)?channel|kill(?:audio|video)|mergechannels|mixaudio|monotostereo|normalize|resampleaudio|ssrc|supereq|timestretch/.source,
        // conditional
        /animate|applyrange|conditional(?:filter|reader|select)|frameevaluate|scriptclip|tcp(?:server|source)|writefile(?:end|if|start)?/.source,
        // export
        /imagewriter/.source,
        // debug
        /blackness|blankclip|colorbars(?:hd)?|compare|dumpfiltergraph|echo|histogram|info|messageclip|preroll|setgraphanalysis|show(?:framenumber|smpte|time)|showfiveversions|stack(?:horizontal|vertical)|subtitle|tone|version/.source
      ].join("|"), CA = [AA, gA, IA].join("|");
      g.languages.avisynth = {
        comment: [
          {
            // Matches [* *] nestable block comments, but only supports 1 level of nested comments
            // /\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|<self>)*\*\]/
            pattern: /(^|[^\\])\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|\[\*(?:[^\[*]|\[(?!\*)|\*(?!\]))*\*\])*\*\]/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // Matches /* */ block comments
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // Matches # comments
            pattern: /(^|[^\\$])#.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        // Handle before strings because optional arguments are surrounded by double quotes
        argument: {
          pattern: k(/\b(?:<<0>>)\s+("?)\w+\1/.source, [H], "i"),
          inside: {
            keyword: /^\w+/
          }
        },
        // Optional argument assignment
        "argument-label": {
          pattern: /([,(][\s\\]*)\w+\s*=(?!=)/,
          lookbehind: !0,
          inside: {
            "argument-name": {
              pattern: /^\w+/,
              alias: "punctuation"
            },
            punctuation: /=$/
          }
        },
        string: [
          {
            // triple double-quoted
            pattern: /"""[\s\S]*?"""/,
            greedy: !0
          },
          {
            // single double-quoted
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: !0,
            inside: {
              constant: {
                // These *are* case-sensitive!
                pattern: /\b(?:DEFAULT_MT_MODE|(?:MAINSCRIPT|PROGRAM|SCRIPT)DIR|(?:MACHINE|USER)_(?:CLASSIC|PLUS)_PLUGINS)\b/
              }
            }
          }
        ],
        // The special "last" variable that takes the value of the last implicitly returned clip
        variable: /\b(?:last)\b/i,
        boolean: /\b(?:false|no|true|yes)\b/i,
        keyword: /\b(?:catch|else|for|function|global|if|return|try|while|__END__)\b/i,
        constant: /\bMT_(?:MULTI_INSTANCE|NICE_FILTER|SERIALIZED|SPECIAL_MT)\b/,
        // AviSynth's internal functions, filters, and properties
        "builtin-function": {
          pattern: k(/\b(?:<<0>>)\b/.source, [CA], "i"),
          alias: "function"
        },
        "type-cast": {
          pattern: k(/\b(?:<<0>>)(?=\s*\()/.source, [H], "i"),
          alias: "keyword"
        },
        // External/user-defined filters
        function: {
          pattern: /\b[a-z_]\w*(?=\s*\()|(\.)[a-z_]\w*\b/i,
          lookbehind: !0
        },
        // Matches a \ as the first or last character on a line
        "line-continuation": {
          pattern: /(^[ \t]*)\\|\\(?=[ \t]*$)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        number: /\B\$(?:[\da-f]{6}|[\da-f]{8})\b|(?:(?:\b|\B-)\d+(?:\.\d*)?\b|\B\.\d+\b)/i,
        operator: /\+\+?|[!=<>]=?|&&|\|\||[?:*/%-]/,
        punctuation: /[{}\[\]();,.]/
      }, g.languages.avs = g.languages.avisynth;
    })(t);
  }
  return avisynth_1;
}
var avroIdl_1, hasRequiredAvroIdl;
function requireAvroIdl() {
  if (hasRequiredAvroIdl) return avroIdl_1;
  hasRequiredAvroIdl = 1, avroIdl_1 = n, n.displayName = "avroIdl", n.aliases = [];
  function n(t) {
    t.languages["avro-idl"] = {
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])"(?:[^\r\n"\\]|\\.)*"/,
        lookbehind: !0,
        greedy: !0
      },
      annotation: {
        pattern: /@(?:[$\w.-]|`[^\r\n`]+`)+/,
        greedy: !0,
        alias: "function"
      },
      "function-identifier": {
        pattern: /`[^\r\n`]+`(?=\s*\()/,
        greedy: !0,
        alias: "function"
      },
      identifier: {
        pattern: /`[^\r\n`]+`/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:enum|error|protocol|record|throws)\b\s+)[$\w]+/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /\b(?:array|boolean|bytes|date|decimal|double|enum|error|false|fixed|float|idl|import|int|local_timestamp_ms|long|map|null|oneway|protocol|record|schema|string|throws|time_ms|timestamp_ms|true|union|uuid|void)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: [
        {
          pattern: /(^|[^\w.])-?(?:(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|0x(?:[a-f0-9]+(?:\.[a-f0-9]*)?|\.[a-f0-9]+)(?:p[+-]?\d+)?)[dfl]?(?![\w.])/i,
          lookbehind: !0
        },
        /-?\b(?:Infinity|NaN)\b/
      ],
      operator: /=/,
      punctuation: /[()\[\]{}<>.:,;-]/
    }, t.languages.avdl = t.languages["avro-idl"];
  }
  return avroIdl_1;
}
var bash_1, hasRequiredBash;
function requireBash() {
  if (hasRequiredBash) return bash_1;
  hasRequiredBash = 1, bash_1 = n, n.displayName = "bash", n.aliases = ["shell"];
  function n(t) {
    (function(g) {
      var d = "\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b", k = {
        pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
        lookbehind: !0,
        alias: "punctuation",
        // this looks reasonably well in all themes
        inside: null
        // see below
      }, H = {
        bash: k,
        environment: {
          pattern: RegExp("\\$" + d),
          alias: "constant"
        },
        variable: [
          // [0]: Arithmetic Environment
          {
            pattern: /\$?\(\([\s\S]+?\)\)/,
            greedy: !0,
            inside: {
              // If there is a $ sign at the beginning highlight $(( and )) as variable
              variable: [
                {
                  pattern: /(^\$\(\([\s\S]+)\)\)/,
                  lookbehind: !0
                },
                /^\$\(\(/
              ],
              number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
              // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
              operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
              // If there is no $ sign at the beginning highlight (( and )) as punctuation
              punctuation: /\(\(?|\)\)?|,|;/
            }
          },
          // [1]: Command Substitution
          {
            pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
            greedy: !0,
            inside: {
              variable: /^\$\(|^`|\)$|`$/
            }
          },
          // [2]: Brace expansion
          {
            pattern: /\$\{[^}]+\}/,
            greedy: !0,
            inside: {
              operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
              punctuation: /[\[\]]/,
              environment: {
                pattern: RegExp("(\\{)" + d),
                lookbehind: !0,
                alias: "constant"
              }
            }
          },
          /\$(?:\w+|[#?*!@$])/
        ],
        // Escape sequences from echo and printf's manuals, and escaped quotes.
        entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
      };
      g.languages.bash = {
        shebang: {
          pattern: /^#!\s*\/.*/,
          alias: "important"
        },
        comment: {
          pattern: /(^|[^"{\\$])#.*/,
          lookbehind: !0
        },
        "function-name": [
          // a) function foo {
          // b) foo() {
          // c) function foo() {
          // but not “foo {”
          {
            // a) and c)
            pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
            lookbehind: !0,
            alias: "function"
          },
          {
            // b)
            pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
            alias: "function"
          }
        ],
        // Highlight variable names as variables in for and select beginnings.
        "for-or-select": {
          pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
          alias: "variable",
          lookbehind: !0
        },
        // Highlight variable names as variables in the left-hand part
        // of assignments (“=” and “+=”).
        "assign-left": {
          pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
          inside: {
            environment: {
              pattern: RegExp("(^|[\\s;|&]|[<>]\\()" + d),
              lookbehind: !0,
              alias: "constant"
            }
          },
          alias: "variable",
          lookbehind: !0
        },
        string: [
          // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
          {
            pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
            lookbehind: !0,
            greedy: !0,
            inside: H
          },
          // Here-document with quotes around the tag
          // → No expansion (so no “inside”).
          {
            pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
            lookbehind: !0,
            greedy: !0,
            inside: {
              bash: k
            }
          },
          // “Normal” string
          {
            // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
            pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
            lookbehind: !0,
            greedy: !0,
            inside: H
          },
          {
            // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
            pattern: /(^|[^$\\])'[^']*'/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
            pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
            greedy: !0,
            inside: {
              entity: H.entity
            }
          }
        ],
        environment: {
          pattern: RegExp("\\$?" + d),
          alias: "constant"
        },
        variable: H.variable,
        function: {
          pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        keyword: {
          pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
        builtin: {
          pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
          lookbehind: !0,
          // Alias added to make those easier to distinguish from strings.
          alias: "class-name"
        },
        boolean: {
          pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        "file-descriptor": {
          pattern: /\B&\d\b/,
          alias: "important"
        },
        operator: {
          // Lots of redirections here, but not just that.
          pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
          inside: {
            "file-descriptor": {
              pattern: /^\d/,
              alias: "important"
            }
          }
        },
        punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
        number: {
          pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
          lookbehind: !0
        }
      }, k.inside = g.languages.bash;
      for (var AA = [
        "comment",
        "function-name",
        "for-or-select",
        "assign-left",
        "string",
        "environment",
        "function",
        "keyword",
        "builtin",
        "boolean",
        "file-descriptor",
        "operator",
        "punctuation",
        "number"
      ], gA = H.variable[1].inside, IA = 0; IA < AA.length; IA++)
        gA[AA[IA]] = g.languages.bash[AA[IA]];
      g.languages.shell = g.languages.bash;
    })(t);
  }
  return bash_1;
}
var basic_1, hasRequiredBasic;
function requireBasic() {
  if (hasRequiredBasic) return basic_1;
  hasRequiredBasic = 1, basic_1 = n, n.displayName = "basic", n.aliases = [];
  function n(t) {
    t.languages.basic = {
      comment: {
        pattern: /(?:!|REM\b).+/i,
        inside: {
          keyword: /^REM/i
        }
      },
      string: {
        pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
        greedy: !0
      },
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
      keyword: /\b(?:AS|BEEP|BLOAD|BSAVE|CALL(?: ABSOLUTE)?|CASE|CHAIN|CHDIR|CLEAR|CLOSE|CLS|COM|COMMON|CONST|DATA|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DIM|DO|DOUBLE|ELSE|ELSEIF|END|ENVIRON|ERASE|ERROR|EXIT|FIELD|FILES|FOR|FUNCTION|GET|GOSUB|GOTO|IF|INPUT|INTEGER|IOCTL|KEY|KILL|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|MKDIR|NAME|NEXT|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPTION BASE|OUT|POKE|PUT|READ|REDIM|REM|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SELECT CASE|SHARED|SHELL|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|SUB|SWAP|SYSTEM|THEN|TIMER|TO|TROFF|TRON|TYPE|UNLOCK|UNTIL|USING|VIEW PRINT|WAIT|WEND|WHILE|WRITE)(?:\$|\b)/i,
      function: /\b(?:ABS|ACCESS|ACOS|ANGLE|AREA|ARITHMETIC|ARRAY|ASIN|ASK|AT|ATN|BASE|BEGIN|BREAK|CAUSE|CEIL|CHR|CLIP|COLLATE|COLOR|CON|COS|COSH|COT|CSC|DATE|DATUM|DEBUG|DECIMAL|DEF|DEG|DEGREES|DELETE|DET|DEVICE|DISPLAY|DOT|ELAPSED|EPS|ERASABLE|EXLINE|EXP|EXTERNAL|EXTYPE|FILETYPE|FIXED|FP|GO|GRAPH|HANDLER|IDN|IMAGE|IN|INT|INTERNAL|IP|IS|KEYED|LBOUND|LCASE|LEFT|LEN|LENGTH|LET|LINE|LINES|LOG|LOG10|LOG2|LTRIM|MARGIN|MAT|MAX|MAXNUM|MID|MIN|MISSING|MOD|NATIVE|NUL|NUMERIC|OF|OPTION|ORD|ORGANIZATION|OUTIN|OUTPUT|PI|POINT|POINTER|POINTS|POS|PRINT|PROGRAM|PROMPT|RAD|RADIANS|RANDOMIZE|RECORD|RECSIZE|RECTYPE|RELATIVE|REMAINDER|REPEAT|REST|RETRY|REWRITE|RIGHT|RND|ROUND|RTRIM|SAME|SEC|SELECT|SEQUENTIAL|SET|SETTER|SGN|SIN|SINH|SIZE|SKIP|SQR|STANDARD|STATUS|STR|STREAM|STYLE|TAB|TAN|TANH|TEMPLATE|TEXT|THERE|TIME|TIMEOUT|TRACE|TRANSFORM|TRUNCATE|UBOUND|UCASE|USE|VAL|VARIABLE|VIEWPORT|WHEN|WINDOW|WITH|ZER|ZONEWIDTH)(?:\$|\b)/i,
      operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:AND|EQV|IMP|NOT|OR|XOR)\b/i,
      punctuation: /[,;:()]/
    };
  }
  return basic_1;
}
var batch_1, hasRequiredBatch;
function requireBatch() {
  if (hasRequiredBatch) return batch_1;
  hasRequiredBatch = 1, batch_1 = n, n.displayName = "batch", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /%%?[~:\w]+%?|!\S+!/, k = {
        pattern: /\/[a-z?]+(?=[ :]|$):?|-[a-z]\b|--[a-z-]+\b/im,
        alias: "attr-name",
        inside: {
          punctuation: /:/
        }
      }, H = /"(?:[\\"]"|[^"])*"(?!")/, AA = /(?:\b|-)\d+\b/;
      g.languages.batch = {
        comment: [
          /^::.*/m,
          {
            pattern: /((?:^|[&(])[ \t]*)rem\b(?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
            lookbehind: !0
          }
        ],
        label: {
          pattern: /^:.*/m,
          alias: "property"
        },
        command: [
          {
            // FOR command
            pattern: /((?:^|[&(])[ \t]*)for(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* \S+ in \([^)]+\) do/im,
            lookbehind: !0,
            inside: {
              keyword: /\b(?:do|in)\b|^for\b/i,
              string: H,
              parameter: k,
              variable: d,
              number: AA,
              punctuation: /[()',]/
            }
          },
          {
            // IF command
            pattern: /((?:^|[&(])[ \t]*)if(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:not )?(?:cmdextversion \d+|defined \w+|errorlevel \d+|exist \S+|(?:"[^"]*"|(?!")(?:(?!==)\S)+)?(?:==| (?:equ|geq|gtr|leq|lss|neq) )(?:"[^"]*"|[^\s"]\S*))/im,
            lookbehind: !0,
            inside: {
              keyword: /\b(?:cmdextversion|defined|errorlevel|exist|not)\b|^if\b/i,
              string: H,
              parameter: k,
              variable: d,
              number: AA,
              operator: /\^|==|\b(?:equ|geq|gtr|leq|lss|neq)\b/i
            }
          },
          {
            // ELSE command
            pattern: /((?:^|[&()])[ \t]*)else\b/im,
            lookbehind: !0,
            inside: {
              keyword: /^else\b/i
            }
          },
          {
            // SET command
            pattern: /((?:^|[&(])[ \t]*)set(?: \/[a-z](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
            lookbehind: !0,
            inside: {
              keyword: /^set\b/i,
              string: H,
              parameter: k,
              variable: [d, /\w+(?=(?:[*\/%+\-&^|]|<<|>>)?=)/],
              number: AA,
              operator: /[*\/%+\-&^|]=?|<<=?|>>=?|[!~_=]/,
              punctuation: /[()',]/
            }
          },
          {
            // Other commands
            pattern: /((?:^|[&(])[ \t]*@?)\w+\b(?:"(?:[\\"]"|[^"])*"(?!")|[^"^&)\r\n]|\^(?:\r\n|[\s\S]))*/m,
            lookbehind: !0,
            inside: {
              keyword: /^\w+\b/,
              string: H,
              parameter: k,
              label: {
                pattern: /(^\s*):\S+/m,
                lookbehind: !0,
                alias: "property"
              },
              variable: d,
              number: AA,
              operator: /\^/
            }
          }
        ],
        operator: /[&@]/,
        punctuation: /[()']/
      };
    })(t);
  }
  return batch_1;
}
var bbcode_1, hasRequiredBbcode;
function requireBbcode() {
  if (hasRequiredBbcode) return bbcode_1;
  hasRequiredBbcode = 1, bbcode_1 = n, n.displayName = "bbcode", n.aliases = ["shortcode"];
  function n(t) {
    t.languages.bbcode = {
      tag: {
        pattern: /\[\/?[^\s=\]]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))?(?:\s+[^\s=\]]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))*\s*\]/,
        inside: {
          tag: {
            pattern: /^\[\/?[^\s=\]]+/,
            inside: {
              punctuation: /^\[\/?/
            }
          },
          "attr-value": {
            pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+)/,
            inside: {
              punctuation: [
                /^=/,
                {
                  pattern: /^(\s*)["']|["']$/,
                  lookbehind: !0
                }
              ]
            }
          },
          punctuation: /\]/,
          "attr-name": /[^\s=\]]+/
        }
      }
    }, t.languages.shortcode = t.languages.bbcode;
  }
  return bbcode_1;
}
var bicep_1, hasRequiredBicep;
function requireBicep() {
  if (hasRequiredBicep) return bicep_1;
  hasRequiredBicep = 1, bicep_1 = n, n.displayName = "bicep", n.aliases = [];
  function n(t) {
    t.languages.bicep = {
      comment: [
        {
          // multiline comments eg /* ASDF */
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          // singleline comments eg // ASDF
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      property: [
        {
          pattern: /([\r\n][ \t]*)[a-z_]\w*(?=[ \t]*:)/i,
          lookbehind: !0
        },
        {
          pattern: /([\r\n][ \t]*)'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'(?=[ \t]*:)/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: [
        {
          pattern: /'''[^'][\s\S]*?'''/,
          greedy: !0
        },
        {
          pattern: /(^|[^\\'])'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      "interpolated-string": {
        pattern: /(^|[^\\'])'(?:\\.|\$(?:(?!\{)|\{[^{}\r\n]*\})|[^'\\\r\n$])*'/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\$\{[^{}\r\n]*\}/,
            inside: {
              expression: {
                pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                lookbehind: !0
              },
              punctuation: /^\$\{|\}$/
            }
          },
          string: /[\s\S]+/
        }
      },
      datatype: {
        pattern: /(\b(?:output|param)\b[ \t]+\w+[ \t]+)\w+\b/,
        lookbehind: !0,
        alias: "class-name"
      },
      boolean: /\b(?:false|true)\b/,
      // https://github.com/Azure/bicep/blob/114a3251b4e6e30082a58729f19a8cc4e374ffa6/src/textmate/bicep.tmlanguage#L184
      keyword: /\b(?:existing|for|if|in|module|null|output|param|resource|targetScope|var)\b/,
      decorator: /@\w+\b/,
      function: /\b[a-z_]\w*(?=[ \t]*\()/i,
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
      operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.bicep["interpolated-string"].inside.interpolation.inside.expression.inside = t.languages.bicep;
  }
  return bicep_1;
}
var birb_1, hasRequiredBirb;
function requireBirb() {
  if (hasRequiredBirb) return birb_1;
  hasRequiredBirb = 1, birb_1 = n, n.displayName = "birb", n.aliases = [];
  function n(t) {
    t.languages.birb = t.languages.extend("clike", {
      string: {
        pattern: /r?("|')(?:\\.|(?!\1)[^\\])*\1/,
        greedy: !0
      },
      "class-name": [
        /\b[A-Z](?:[\d_]*[a-zA-Z]\w*)?\b/,
        // matches variable and function return types (parameters as well).
        /\b(?:[A-Z]\w*|(?!(?:var|void)\b)[a-z]\w*)(?=\s+\w+\s*[;,=()])/
      ],
      keyword: /\b(?:assert|break|case|class|const|default|else|enum|final|follows|for|grab|if|nest|new|next|noSeeb|return|static|switch|throw|var|void|while)\b/,
      operator: /\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?|:/,
      variable: /\b[a-z_]\w*\b/
    }), t.languages.insertBefore("birb", "function", {
      metadata: {
        pattern: /<\w+>/,
        greedy: !0,
        alias: "symbol"
      }
    });
  }
  return birb_1;
}
var bison_1, hasRequiredBison;
function requireBison() {
  if (hasRequiredBison) return bison_1;
  hasRequiredBison = 1;
  var n = requireC();
  bison_1 = t, t.displayName = "bison", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.bison = g.languages.extend("c", {}), g.languages.insertBefore("bison", "comment", {
      bison: {
        // This should match all the beginning of the file
        // including the prologue(s), the bison declarations and
        // the grammar rules.
        pattern: /^(?:[^%]|%(?!%))*%%[\s\S]*?%%/,
        inside: {
          c: {
            // Allow for one level of nested braces
            pattern: /%\{[\s\S]*?%\}|\{(?:\{[^}]*\}|[^{}])*\}/,
            inside: {
              delimiter: {
                pattern: /^%?\{|%?\}$/,
                alias: "punctuation"
              },
              "bison-variable": {
                pattern: /[$@](?:<[^\s>]+>)?[\w$]+/,
                alias: "variable",
                inside: {
                  punctuation: /<|>/
                }
              },
              rest: g.languages.c
            }
          },
          comment: g.languages.c.comment,
          string: g.languages.c.string,
          property: /\S+(?=:)/,
          keyword: /%\w+/,
          number: {
            pattern: /(^|[^@])\b(?:0x[\da-f]+|\d+)/i,
            lookbehind: !0
          },
          punctuation: /%[%?]|[|:;\[\]<>]/
        }
      }
    });
  }
  return bison_1;
}
var bnf_1, hasRequiredBnf;
function requireBnf() {
  if (hasRequiredBnf) return bnf_1;
  hasRequiredBnf = 1, bnf_1 = n, n.displayName = "bnf", n.aliases = ["rbnf"];
  function n(t) {
    t.languages.bnf = {
      string: {
        pattern: /"[^\r\n"]*"|'[^\r\n']*'/
      },
      definition: {
        pattern: /<[^<>\r\n\t]+>(?=\s*::=)/,
        alias: ["rule", "keyword"],
        inside: {
          punctuation: /^<|>$/
        }
      },
      rule: {
        pattern: /<[^<>\r\n\t]+>/,
        inside: {
          punctuation: /^<|>$/
        }
      },
      operator: /::=|[|()[\]{}*+?]|\.{3}/
    }, t.languages.rbnf = t.languages.bnf;
  }
  return bnf_1;
}
var brainfuck_1, hasRequiredBrainfuck;
function requireBrainfuck() {
  if (hasRequiredBrainfuck) return brainfuck_1;
  hasRequiredBrainfuck = 1, brainfuck_1 = n, n.displayName = "brainfuck", n.aliases = [];
  function n(t) {
    t.languages.brainfuck = {
      pointer: {
        pattern: /<|>/,
        alias: "keyword"
      },
      increment: {
        pattern: /\+/,
        alias: "inserted"
      },
      decrement: {
        pattern: /-/,
        alias: "deleted"
      },
      branching: {
        pattern: /\[|\]/,
        alias: "important"
      },
      operator: /[.,]/,
      comment: /\S+/
    };
  }
  return brainfuck_1;
}
var brightscript_1, hasRequiredBrightscript;
function requireBrightscript() {
  if (hasRequiredBrightscript) return brightscript_1;
  hasRequiredBrightscript = 1, brightscript_1 = n, n.displayName = "brightscript", n.aliases = [];
  function n(t) {
    t.languages.brightscript = {
      comment: /(?:\brem|').*/i,
      "directive-statement": {
        pattern: /(^[\t ]*)#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if).*/im,
        lookbehind: !0,
        alias: "property",
        inside: {
          "error-message": {
            pattern: /(^#error).+/,
            lookbehind: !0
          },
          directive: {
            pattern: /^#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if)/,
            alias: "keyword"
          },
          expression: {
            pattern: /[\s\S]+/,
            inside: null
            // see below
          }
        }
      },
      property: {
        pattern: /([\r\n{,][\t ]*)(?:(?!\d)\w+|"(?:[^"\r\n]|"")*"(?!"))(?=[ \t]*:)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"\r\n]|"")*"(?!")/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\bAs[\t ]+)\w+/i,
        lookbehind: !0
      },
      keyword: /\b(?:As|Dim|Each|Else|Elseif|End|Exit|For|Function|Goto|If|In|Print|Return|Step|Stop|Sub|Then|To|While)\b/i,
      boolean: /\b(?:false|true)\b/i,
      function: /\b(?!\d)\w+(?=[\t ]*\()/,
      number: /(?:\b\d+(?:\.\d+)?(?:[ed][+-]\d+)?|&h[a-f\d]+)\b[%&!#]?/i,
      operator: /--|\+\+|>>=?|<<=?|<>|[-+*/\\<>]=?|[:^=?]|\b(?:and|mod|not|or)\b/i,
      punctuation: /[.,;()[\]{}]/,
      constant: /\b(?:LINE_NUM)\b/i
    }, t.languages.brightscript["directive-statement"].inside.expression.inside = t.languages.brightscript;
  }
  return brightscript_1;
}
var bro_1, hasRequiredBro;
function requireBro() {
  if (hasRequiredBro) return bro_1;
  hasRequiredBro = 1, bro_1 = n, n.displayName = "bro", n.aliases = [];
  function n(t) {
    t.languages.bro = {
      comment: {
        pattern: /(^|[^\\$])#.*/,
        lookbehind: !0,
        inside: {
          italic: /\b(?:FIXME|TODO|XXX)\b/
        }
      },
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      boolean: /\b[TF]\b/,
      function: {
        pattern: /(\b(?:event|function|hook)[ \t]+)\w+(?:::\w+)?/,
        lookbehind: !0
      },
      builtin: /(?:@(?:load(?:-(?:plugin|sigs))?|unload|prefixes|ifn?def|else|(?:end)?if|DIR|FILENAME))|(?:&?(?:add_func|create_expire|default|delete_func|encrypt|error_handler|expire_func|group|log|mergeable|optional|persistent|priority|raw_output|read_expire|redef|rotate_interval|rotate_size|synchronized|type_column|write_expire))/,
      constant: {
        pattern: /(\bconst[ \t]+)\w+/i,
        lookbehind: !0
      },
      keyword: /\b(?:add|addr|alarm|any|bool|break|const|continue|count|delete|double|else|enum|event|export|file|for|function|global|hook|if|in|int|interval|local|module|next|of|opaque|pattern|port|print|record|return|schedule|set|string|subnet|table|time|timeout|using|vector|when)\b/,
      operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&|\|\|?|\?|\*|\/|~|\^|%/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      punctuation: /[{}[\];(),.:]/
    };
  }
  return bro_1;
}
var bsl_1, hasRequiredBsl;
function requireBsl() {
  if (hasRequiredBsl) return bsl_1;
  hasRequiredBsl = 1, bsl_1 = n, n.displayName = "bsl", n.aliases = [];
  function n(t) {
    t.languages.bsl = {
      comment: /\/\/.*/,
      string: [
        // Строки
        // Strings
        {
          pattern: /"(?:[^"]|"")*"(?!")/,
          greedy: !0
        },
        // Дата и время
        // Date & time
        {
          pattern: /'(?:[^'\r\n\\]|\\.)*'/
        }
      ],
      keyword: [
        {
          // RU
          pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:пока|для|новый|прервать|попытка|исключение|вызватьисключение|иначе|конецпопытки|неопределено|функция|перем|возврат|конецфункции|если|иначеесли|процедура|конецпроцедуры|тогда|знач|экспорт|конецесли|из|каждого|истина|ложь|по|цикл|конеццикла|выполнить)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
          lookbehind: !0
        },
        {
          // EN
          pattern: /\b(?:break|do|each|else|elseif|enddo|endfunction|endif|endprocedure|endtry|except|execute|export|false|for|function|if|in|new|null|procedure|raise|return|then|to|true|try|undefined|val|var|while)\b/i
        }
      ],
      number: {
        pattern: /(^(?=\d)|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:\d+(?:\.\d*)?|\.\d+)(?:E[+-]?\d+)?/i,
        lookbehind: !0
      },
      operator: [
        /[<>+\-*/]=?|[%=]/,
        // RU
        {
          pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:и|или|не)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
          lookbehind: !0
        },
        // EN
        {
          pattern: /\b(?:and|not|or)\b/i
        }
      ],
      punctuation: /\(\.|\.\)|[()\[\]:;,.]/,
      directive: [
        // Теги препроцессора вида &Клиент, &Сервер, ...
        // Preprocessor tags of the type &Client, &Server, ...
        {
          pattern: /^([ \t]*)&.*/m,
          lookbehind: !0,
          greedy: !0,
          alias: "important"
        },
        // Инструкции препроцессора вида:
        // #Если Сервер Тогда
        // ...
        // #КонецЕсли
        // Preprocessor instructions of the form:
        // #If Server Then
        // ...
        // #EndIf
        {
          pattern: /^([ \t]*)#.*/gm,
          lookbehind: !0,
          greedy: !0,
          alias: "important"
        }
      ]
    }, t.languages.oscript = t.languages.bsl;
  }
  return bsl_1;
}
var cfscript_1, hasRequiredCfscript;
function requireCfscript() {
  if (hasRequiredCfscript) return cfscript_1;
  hasRequiredCfscript = 1, cfscript_1 = n, n.displayName = "cfscript", n.aliases = [];
  function n(t) {
    t.languages.cfscript = t.languages.extend("clike", {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          inside: {
            annotation: {
              pattern: /(?:^|[^.])@[\w\.]+/,
              alias: "punctuation"
            }
          }
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      keyword: /\b(?:abstract|break|catch|component|continue|default|do|else|extends|final|finally|for|function|if|in|include|package|private|property|public|remote|required|rethrow|return|static|switch|throw|try|var|while|xml)\b(?!\s*=)/,
      operator: [
        /\+\+|--|&&|\|\||::|=>|[!=]==|<=?|>=?|[-+*/%&|^!=<>]=?|\?(?:\.|:)?|[?:]/,
        /\b(?:and|contains|eq|equal|eqv|gt|gte|imp|is|lt|lte|mod|not|or|xor)\b/
      ],
      scope: {
        pattern: /\b(?:application|arguments|cgi|client|cookie|local|session|super|this|variables)\b/,
        alias: "global"
      },
      type: {
        pattern: /\b(?:any|array|binary|boolean|date|guid|numeric|query|string|struct|uuid|void|xml)\b/,
        alias: "builtin"
      }
    }), t.languages.insertBefore("cfscript", "keyword", {
      // This must be declared before keyword because we use "function" inside the lookahead
      "function-variable": {
        pattern: /[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
      }
    }), delete t.languages.cfscript["class-name"], t.languages.cfc = t.languages.cfscript;
  }
  return cfscript_1;
}
var chaiscript_1, hasRequiredChaiscript;
function requireChaiscript() {
  if (hasRequiredChaiscript) return chaiscript_1;
  hasRequiredChaiscript = 1;
  var n = requireCpp();
  chaiscript_1 = t, t.displayName = "chaiscript", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.chaiscript = g.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": [
        {
          // e.g. class Rectangle { ... }
          pattern: /(\bclass\s+)\w+/,
          lookbehind: !0
        },
        {
          // e.g. attr Rectangle::height, def Rectangle::area() { ... }
          pattern: /(\b(?:attr|def)\s+)\w+(?=\s*::)/,
          lookbehind: !0
        }
      ],
      keyword: /\b(?:attr|auto|break|case|catch|class|continue|def|default|else|finally|for|fun|global|if|return|switch|this|try|var|while)\b/,
      number: [g.languages.cpp.number, /\b(?:Infinity|NaN)\b/],
      operator: />>=?|<<=?|\|\||&&|:[:=]?|--|\+\+|[=!<>+\-*/%|&^]=?|[?~]|`[^`\r\n]{1,4}`/
    }), g.languages.insertBefore("chaiscript", "operator", {
      "parameter-type": {
        // e.g. def foo(int x, Vector y) {...}
        pattern: /([,(]\s*)\w+(?=\s+\w)/,
        lookbehind: !0,
        alias: "class-name"
      }
    }), g.languages.insertBefore("chaiscript", "string", {
      "string-interpolation": {
        pattern: /(^|[^\\])"(?:[^"$\\]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*"/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/,
            lookbehind: !0,
            inside: {
              "interpolation-expression": {
                pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                lookbehind: !0,
                inside: g.languages.chaiscript
              },
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              }
            }
          },
          string: /[\s\S]+/
        }
      }
    });
  }
  return chaiscript_1;
}
var cil_1, hasRequiredCil;
function requireCil() {
  if (hasRequiredCil) return cil_1;
  hasRequiredCil = 1, cil_1 = n, n.displayName = "cil", n.aliases = [];
  function n(t) {
    t.languages.cil = {
      comment: /\/\/.*/,
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      directive: {
        pattern: /(^|\W)\.[a-z]+(?=\s)/,
        lookbehind: !0,
        alias: "class-name"
      },
      // Actually an assembly reference
      variable: /\[[\w\.]+\]/,
      keyword: /\b(?:abstract|ansi|assembly|auto|autochar|beforefieldinit|bool|bstr|byvalstr|catch|char|cil|class|currency|date|decimal|default|enum|error|explicit|extends|extern|famandassem|family|famorassem|final(?:ly)?|float32|float64|hidebysig|u?int(?:8|16|32|64)?|iant|idispatch|implements|import|initonly|instance|interface|iunknown|literal|lpstr|lpstruct|lptstr|lpwstr|managed|method|native(?:Type)?|nested|newslot|object(?:ref)?|pinvokeimpl|private|privatescope|public|reqsecobj|rtspecialname|runtime|sealed|sequential|serializable|specialname|static|string|struct|syschar|tbstr|unicode|unmanagedexp|unsigned|value(?:type)?|variant|virtual|void)\b/,
      function: /\b(?:(?:constrained|no|readonly|tail|unaligned|volatile)\.)?(?:conv\.(?:[iu][1248]?|ovf\.[iu][1248]?(?:\.un)?|r\.un|r4|r8)|ldc\.(?:i4(?:\.\d+|\.[mM]1|\.s)?|i8|r4|r8)|ldelem(?:\.[iu][1248]?|\.r[48]|\.ref|a)?|ldind\.(?:[iu][1248]?|r[48]|ref)|stelem\.?(?:i[1248]?|r[48]|ref)?|stind\.(?:i[1248]?|r[48]|ref)?|end(?:fault|filter|finally)|ldarg(?:\.[0-3s]|a(?:\.s)?)?|ldloc(?:\.\d+|\.s)?|sub(?:\.ovf(?:\.un)?)?|mul(?:\.ovf(?:\.un)?)?|add(?:\.ovf(?:\.un)?)?|stloc(?:\.[0-3s])?|refany(?:type|val)|blt(?:\.un)?(?:\.s)?|ble(?:\.un)?(?:\.s)?|bgt(?:\.un)?(?:\.s)?|bge(?:\.un)?(?:\.s)?|unbox(?:\.any)?|init(?:blk|obj)|call(?:i|virt)?|brfalse(?:\.s)?|bne\.un(?:\.s)?|ldloca(?:\.s)?|brzero(?:\.s)?|brtrue(?:\.s)?|brnull(?:\.s)?|brinst(?:\.s)?|starg(?:\.s)?|leave(?:\.s)?|shr(?:\.un)?|rem(?:\.un)?|div(?:\.un)?|clt(?:\.un)?|alignment|castclass|ldvirtftn|beq(?:\.s)?|ckfinite|ldsflda|ldtoken|localloc|mkrefany|rethrow|cgt\.un|arglist|switch|stsfld|sizeof|newobj|newarr|ldsfld|ldnull|ldflda|isinst|throw|stobj|stfld|ldstr|ldobj|ldlen|ldftn|ldfld|cpobj|cpblk|break|br\.s|xor|shl|ret|pop|not|nop|neg|jmp|dup|cgt|ceq|box|and|or|br)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /\b-?(?:0x[0-9a-f]+|\d+)(?:\.[0-9a-f]+)?\b/i,
      punctuation: /[{}[\];(),:=]|IL_[0-9A-Za-z]+/
    };
  }
  return cil_1;
}
var clojure_1, hasRequiredClojure;
function requireClojure() {
  if (hasRequiredClojure) return clojure_1;
  hasRequiredClojure = 1, clojure_1 = n, n.displayName = "clojure", n.aliases = [];
  function n(t) {
    t.languages.clojure = {
      comment: {
        pattern: /;.*/,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"\\]|\\.)*"/,
        greedy: !0
      },
      char: /\\\w+/,
      symbol: {
        pattern: /(^|[\s()\[\]{},])::?[\w*+!?'<>=/.-]+/,
        lookbehind: !0
      },
      keyword: {
        pattern: /(\()(?:-|->|->>|\.|\.\.|\*|\/|\+|<|<=|=|==|>|>=|accessor|agent|agent-errors|aget|alength|all-ns|alter|and|append-child|apply|array-map|aset|aset-boolean|aset-byte|aset-char|aset-double|aset-float|aset-int|aset-long|aset-short|assert|assoc|await|await-for|bean|binding|bit-and|bit-not|bit-or|bit-shift-left|bit-shift-right|bit-xor|boolean|branch\?|butlast|byte|cast|char|children|class|clear-agent-errors|comment|commute|comp|comparator|complement|concat|cond|conj|cons|constantly|construct-proxy|contains\?|count|create-ns|create-struct|cycle|dec|declare|def|def-|definline|definterface|defmacro|defmethod|defmulti|defn|defn-|defonce|defproject|defprotocol|defrecord|defstruct|deftype|deref|difference|disj|dissoc|distinct|do|doall|doc|dorun|doseq|dosync|dotimes|doto|double|down|drop|drop-while|edit|end\?|ensure|eval|every\?|false\?|ffirst|file-seq|filter|find|find-doc|find-ns|find-var|first|float|flush|fn|fnseq|for|frest|gensym|get|get-proxy-class|hash-map|hash-set|identical\?|identity|if|if-let|if-not|import|in-ns|inc|index|insert-child|insert-left|insert-right|inspect-table|inspect-tree|instance\?|int|interleave|intersection|into|into-array|iterate|join|key|keys|keyword|keyword\?|last|lazy-cat|lazy-cons|left|lefts|let|line-seq|list|list\*|load|load-file|locking|long|loop|macroexpand|macroexpand-1|make-array|make-node|map|map-invert|map\?|mapcat|max|max-key|memfn|merge|merge-with|meta|min|min-key|monitor-enter|name|namespace|neg\?|new|newline|next|nil\?|node|not|not-any\?|not-every\?|not=|ns|ns-imports|ns-interns|ns-map|ns-name|ns-publics|ns-refers|ns-resolve|ns-unmap|nth|nthrest|or|parse|partial|path|peek|pop|pos\?|pr|pr-str|print|print-str|println|println-str|prn|prn-str|project|proxy|proxy-mappings|quot|quote|rand|rand-int|range|re-find|re-groups|re-matcher|re-matches|re-pattern|re-seq|read|read-line|recur|reduce|ref|ref-set|refer|rem|remove|remove-method|remove-ns|rename|rename-keys|repeat|replace|replicate|resolve|rest|resultset-seq|reverse|rfirst|right|rights|root|rrest|rseq|second|select|select-keys|send|send-off|seq|seq-zip|seq\?|set|set!|short|slurp|some|sort|sort-by|sorted-map|sorted-map-by|sorted-set|special-symbol\?|split-at|split-with|str|string\?|struct|struct-map|subs|subvec|symbol|symbol\?|sync|take|take-nth|take-while|test|throw|time|to-array|to-array-2d|tree-seq|true\?|try|union|up|update-proxy|val|vals|var|var-get|var-set|var\?|vector|vector-zip|vector\?|when|when-first|when-let|when-not|with-local-vars|with-meta|with-open|with-out-str|xml-seq|xml-zip|zero\?|zipmap|zipper)(?=[\s)]|$)/,
        lookbehind: !0
      },
      boolean: /\b(?:false|nil|true)\b/,
      number: {
        pattern: /(^|[^\w$@])(?:\d+(?:[/.]\d+)?(?:e[+-]?\d+)?|0x[a-f0-9]+|[1-9]\d?r[a-z0-9]+)[lmn]?(?![\w$@])/i,
        lookbehind: !0
      },
      function: {
        pattern: /((?:^|[^'])\()[\w*+!?'<>=/.-]+(?=[\s)]|$)/,
        lookbehind: !0
      },
      operator: /[#@^`~]/,
      punctuation: /[{}\[\](),]/
    };
  }
  return clojure_1;
}
var cmake_1, hasRequiredCmake;
function requireCmake() {
  if (hasRequiredCmake) return cmake_1;
  hasRequiredCmake = 1, cmake_1 = n, n.displayName = "cmake", n.aliases = [];
  function n(t) {
    t.languages.cmake = {
      comment: /#.*/,
      string: {
        pattern: /"(?:[^\\"]|\\.)*"/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\$\{(?:[^{}$]|\$\{[^{}$]*\})*\}/,
            inside: {
              punctuation: /\$\{|\}/,
              variable: /\w+/
            }
          }
        }
      },
      variable: /\b(?:CMAKE_\w+|\w+_(?:(?:BINARY|SOURCE)_DIR|DESCRIPTION|HOMEPAGE_URL|ROOT|VERSION(?:_MAJOR|_MINOR|_PATCH|_TWEAK)?)|(?:ANDROID|APPLE|BORLAND|BUILD_SHARED_LIBS|CACHE|CPACK_(?:ABSOLUTE_DESTINATION_FILES|COMPONENT_INCLUDE_TOPLEVEL_DIRECTORY|ERROR_ON_ABSOLUTE_INSTALL_DESTINATION|INCLUDE_TOPLEVEL_DIRECTORY|INSTALL_DEFAULT_DIRECTORY_PERMISSIONS|INSTALL_SCRIPT|PACKAGING_INSTALL_PREFIX|SET_DESTDIR|WARN_ON_ABSOLUTE_INSTALL_DESTINATION)|CTEST_(?:BINARY_DIRECTORY|BUILD_COMMAND|BUILD_NAME|BZR_COMMAND|BZR_UPDATE_OPTIONS|CHANGE_ID|CHECKOUT_COMMAND|CONFIGURATION_TYPE|CONFIGURE_COMMAND|COVERAGE_COMMAND|COVERAGE_EXTRA_FLAGS|CURL_OPTIONS|CUSTOM_(?:COVERAGE_EXCLUDE|ERROR_EXCEPTION|ERROR_MATCH|ERROR_POST_CONTEXT|ERROR_PRE_CONTEXT|MAXIMUM_FAILED_TEST_OUTPUT_SIZE|MAXIMUM_NUMBER_OF_(?:ERRORS|WARNINGS)|MAXIMUM_PASSED_TEST_OUTPUT_SIZE|MEMCHECK_IGNORE|POST_MEMCHECK|POST_TEST|PRE_MEMCHECK|PRE_TEST|TESTS_IGNORE|WARNING_EXCEPTION|WARNING_MATCH)|CVS_CHECKOUT|CVS_COMMAND|CVS_UPDATE_OPTIONS|DROP_LOCATION|DROP_METHOD|DROP_SITE|DROP_SITE_CDASH|DROP_SITE_PASSWORD|DROP_SITE_USER|EXTRA_COVERAGE_GLOB|GIT_COMMAND|GIT_INIT_SUBMODULES|GIT_UPDATE_CUSTOM|GIT_UPDATE_OPTIONS|HG_COMMAND|HG_UPDATE_OPTIONS|LABELS_FOR_SUBPROJECTS|MEMORYCHECK_(?:COMMAND|COMMAND_OPTIONS|SANITIZER_OPTIONS|SUPPRESSIONS_FILE|TYPE)|NIGHTLY_START_TIME|P4_CLIENT|P4_COMMAND|P4_OPTIONS|P4_UPDATE_OPTIONS|RUN_CURRENT_SCRIPT|SCP_COMMAND|SITE|SOURCE_DIRECTORY|SUBMIT_URL|SVN_COMMAND|SVN_OPTIONS|SVN_UPDATE_OPTIONS|TEST_LOAD|TEST_TIMEOUT|TRIGGER_SITE|UPDATE_COMMAND|UPDATE_OPTIONS|UPDATE_VERSION_ONLY|USE_LAUNCHERS)|CYGWIN|ENV|EXECUTABLE_OUTPUT_PATH|GHS-MULTI|IOS|LIBRARY_OUTPUT_PATH|MINGW|MSVC(?:10|11|12|14|60|70|71|80|90|_IDE|_TOOLSET_VERSION|_VERSION)?|MSYS|PROJECT_(?:BINARY_DIR|DESCRIPTION|HOMEPAGE_URL|NAME|SOURCE_DIR|VERSION|VERSION_(?:MAJOR|MINOR|PATCH|TWEAK))|UNIX|WIN32|WINCE|WINDOWS_PHONE|WINDOWS_STORE|XCODE|XCODE_VERSION))\b/,
      property: /\b(?:cxx_\w+|(?:ARCHIVE_OUTPUT_(?:DIRECTORY|NAME)|COMPILE_DEFINITIONS|COMPILE_PDB_NAME|COMPILE_PDB_OUTPUT_DIRECTORY|EXCLUDE_FROM_DEFAULT_BUILD|IMPORTED_(?:IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_LANGUAGES|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|NO_SONAME|OBJECTS|SONAME)|INTERPROCEDURAL_OPTIMIZATION|LIBRARY_OUTPUT_DIRECTORY|LIBRARY_OUTPUT_NAME|LINK_FLAGS|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|MAP_IMPORTED_CONFIG|OSX_ARCHITECTURES|OUTPUT_NAME|PDB_NAME|PDB_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_NAME|STATIC_LIBRARY_FLAGS|VS_CSHARP|VS_DOTNET_REFERENCEPROP|VS_DOTNET_REFERENCE|VS_GLOBAL_SECTION_POST|VS_GLOBAL_SECTION_PRE|VS_GLOBAL|XCODE_ATTRIBUTE)_\w+|\w+_(?:CLANG_TIDY|COMPILER_LAUNCHER|CPPCHECK|CPPLINT|INCLUDE_WHAT_YOU_USE|OUTPUT_NAME|POSTFIX|VISIBILITY_PRESET)|ABSTRACT|ADDITIONAL_MAKE_CLEAN_FILES|ADVANCED|ALIASED_TARGET|ALLOW_DUPLICATE_CUSTOM_TARGETS|ANDROID_(?:ANT_ADDITIONAL_OPTIONS|API|API_MIN|ARCH|ASSETS_DIRECTORIES|GUI|JAR_DEPENDENCIES|NATIVE_LIB_DEPENDENCIES|NATIVE_LIB_DIRECTORIES|PROCESS_MAX|PROGUARD|PROGUARD_CONFIG_PATH|SECURE_PROPS_PATH|SKIP_ANT_STEP|STL_TYPE)|ARCHIVE_OUTPUT_DIRECTORY|ATTACHED_FILES|ATTACHED_FILES_ON_FAIL|AUTOGEN_(?:BUILD_DIR|ORIGIN_DEPENDS|PARALLEL|SOURCE_GROUP|TARGETS_FOLDER|TARGET_DEPENDS)|AUTOMOC|AUTOMOC_(?:COMPILER_PREDEFINES|DEPEND_FILTERS|EXECUTABLE|MACRO_NAMES|MOC_OPTIONS|SOURCE_GROUP|TARGETS_FOLDER)|AUTORCC|AUTORCC_EXECUTABLE|AUTORCC_OPTIONS|AUTORCC_SOURCE_GROUP|AUTOUIC|AUTOUIC_EXECUTABLE|AUTOUIC_OPTIONS|AUTOUIC_SEARCH_PATHS|BINARY_DIR|BUILDSYSTEM_TARGETS|BUILD_RPATH|BUILD_RPATH_USE_ORIGIN|BUILD_WITH_INSTALL_NAME_DIR|BUILD_WITH_INSTALL_RPATH|BUNDLE|BUNDLE_EXTENSION|CACHE_VARIABLES|CLEAN_NO_CUSTOM|COMMON_LANGUAGE_RUNTIME|COMPATIBLE_INTERFACE_(?:BOOL|NUMBER_MAX|NUMBER_MIN|STRING)|COMPILE_(?:DEFINITIONS|FEATURES|FLAGS|OPTIONS|PDB_NAME|PDB_OUTPUT_DIRECTORY)|COST|CPACK_DESKTOP_SHORTCUTS|CPACK_NEVER_OVERWRITE|CPACK_PERMANENT|CPACK_STARTUP_SHORTCUTS|CPACK_START_MENU_SHORTCUTS|CPACK_WIX_ACL|CROSSCOMPILING_EMULATOR|CUDA_EXTENSIONS|CUDA_PTX_COMPILATION|CUDA_RESOLVE_DEVICE_SYMBOLS|CUDA_SEPARABLE_COMPILATION|CUDA_STANDARD|CUDA_STANDARD_REQUIRED|CXX_EXTENSIONS|CXX_STANDARD|CXX_STANDARD_REQUIRED|C_EXTENSIONS|C_STANDARD|C_STANDARD_REQUIRED|DEBUG_CONFIGURATIONS|DEFINE_SYMBOL|DEFINITIONS|DEPENDS|DEPLOYMENT_ADDITIONAL_FILES|DEPLOYMENT_REMOTE_DIRECTORY|DISABLED|DISABLED_FEATURES|ECLIPSE_EXTRA_CPROJECT_CONTENTS|ECLIPSE_EXTRA_NATURES|ENABLED_FEATURES|ENABLED_LANGUAGES|ENABLE_EXPORTS|ENVIRONMENT|EXCLUDE_FROM_ALL|EXCLUDE_FROM_DEFAULT_BUILD|EXPORT_NAME|EXPORT_PROPERTIES|EXTERNAL_OBJECT|EchoString|FAIL_REGULAR_EXPRESSION|FIND_LIBRARY_USE_LIB32_PATHS|FIND_LIBRARY_USE_LIB64_PATHS|FIND_LIBRARY_USE_LIBX32_PATHS|FIND_LIBRARY_USE_OPENBSD_VERSIONING|FIXTURES_CLEANUP|FIXTURES_REQUIRED|FIXTURES_SETUP|FOLDER|FRAMEWORK|Fortran_FORMAT|Fortran_MODULE_DIRECTORY|GENERATED|GENERATOR_FILE_NAME|GENERATOR_IS_MULTI_CONFIG|GHS_INTEGRITY_APP|GHS_NO_SOURCE_GROUP_FILE|GLOBAL_DEPENDS_DEBUG_MODE|GLOBAL_DEPENDS_NO_CYCLES|GNUtoMS|HAS_CXX|HEADER_FILE_ONLY|HELPSTRING|IMPLICIT_DEPENDS_INCLUDE_TRANSFORM|IMPORTED|IMPORTED_(?:COMMON_LANGUAGE_RUNTIME|CONFIGURATIONS|GLOBAL|IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_(?:LANGUAGES|LIBRARIES|MULTIPLICITY)|LOCATION|NO_SONAME|OBJECTS|SONAME)|IMPORT_PREFIX|IMPORT_SUFFIX|INCLUDE_DIRECTORIES|INCLUDE_REGULAR_EXPRESSION|INSTALL_NAME_DIR|INSTALL_RPATH|INSTALL_RPATH_USE_LINK_PATH|INTERFACE_(?:AUTOUIC_OPTIONS|COMPILE_DEFINITIONS|COMPILE_FEATURES|COMPILE_OPTIONS|INCLUDE_DIRECTORIES|LINK_DEPENDS|LINK_DIRECTORIES|LINK_LIBRARIES|LINK_OPTIONS|POSITION_INDEPENDENT_CODE|SOURCES|SYSTEM_INCLUDE_DIRECTORIES)|INTERPROCEDURAL_OPTIMIZATION|IN_TRY_COMPILE|IOS_INSTALL_COMBINED|JOB_POOLS|JOB_POOL_COMPILE|JOB_POOL_LINK|KEEP_EXTENSION|LABELS|LANGUAGE|LIBRARY_OUTPUT_DIRECTORY|LINKER_LANGUAGE|LINK_(?:DEPENDS|DEPENDS_NO_SHARED|DIRECTORIES|FLAGS|INTERFACE_LIBRARIES|INTERFACE_MULTIPLICITY|LIBRARIES|OPTIONS|SEARCH_END_STATIC|SEARCH_START_STATIC|WHAT_YOU_USE)|LISTFILE_STACK|LOCATION|MACOSX_BUNDLE|MACOSX_BUNDLE_INFO_PLIST|MACOSX_FRAMEWORK_INFO_PLIST|MACOSX_PACKAGE_LOCATION|MACOSX_RPATH|MACROS|MANUALLY_ADDED_DEPENDENCIES|MEASUREMENT|MODIFIED|NAME|NO_SONAME|NO_SYSTEM_FROM_IMPORTED|OBJECT_DEPENDS|OBJECT_OUTPUTS|OSX_ARCHITECTURES|OUTPUT_NAME|PACKAGES_FOUND|PACKAGES_NOT_FOUND|PARENT_DIRECTORY|PASS_REGULAR_EXPRESSION|PDB_NAME|PDB_OUTPUT_DIRECTORY|POSITION_INDEPENDENT_CODE|POST_INSTALL_SCRIPT|PREDEFINED_TARGETS_FOLDER|PREFIX|PRE_INSTALL_SCRIPT|PRIVATE_HEADER|PROCESSORS|PROCESSOR_AFFINITY|PROJECT_LABEL|PUBLIC_HEADER|REPORT_UNDEFINED_PROPERTIES|REQUIRED_FILES|RESOURCE|RESOURCE_LOCK|RULE_LAUNCH_COMPILE|RULE_LAUNCH_CUSTOM|RULE_LAUNCH_LINK|RULE_MESSAGES|RUNTIME_OUTPUT_DIRECTORY|RUN_SERIAL|SKIP_AUTOGEN|SKIP_AUTOMOC|SKIP_AUTORCC|SKIP_AUTOUIC|SKIP_BUILD_RPATH|SKIP_RETURN_CODE|SOURCES|SOURCE_DIR|SOVERSION|STATIC_LIBRARY_FLAGS|STATIC_LIBRARY_OPTIONS|STRINGS|SUBDIRECTORIES|SUFFIX|SYMBOLIC|TARGET_ARCHIVES_MAY_BE_SHARED_LIBS|TARGET_MESSAGES|TARGET_SUPPORTS_SHARED_LIBS|TESTS|TEST_INCLUDE_FILE|TEST_INCLUDE_FILES|TIMEOUT|TIMEOUT_AFTER_MATCH|TYPE|USE_FOLDERS|VALUE|VARIABLES|VERSION|VISIBILITY_INLINES_HIDDEN|VS_(?:CONFIGURATION_TYPE|COPY_TO_OUT_DIR|DEBUGGER_(?:COMMAND|COMMAND_ARGUMENTS|ENVIRONMENT|WORKING_DIRECTORY)|DEPLOYMENT_CONTENT|DEPLOYMENT_LOCATION|DOTNET_REFERENCES|DOTNET_REFERENCES_COPY_LOCAL|GLOBAL_KEYWORD|GLOBAL_PROJECT_TYPES|GLOBAL_ROOTNAMESPACE|INCLUDE_IN_VSIX|IOT_STARTUP_TASK|KEYWORD|RESOURCE_GENERATOR|SCC_AUXPATH|SCC_LOCALPATH|SCC_PROJECTNAME|SCC_PROVIDER|SDK_REFERENCES|SHADER_(?:DISABLE_OPTIMIZATIONS|ENABLE_DEBUG|ENTRYPOINT|FLAGS|MODEL|OBJECT_FILE_NAME|OUTPUT_HEADER_FILE|TYPE|VARIABLE_NAME)|STARTUP_PROJECT|TOOL_OVERRIDE|USER_PROPS|WINRT_COMPONENT|WINRT_EXTENSIONS|WINRT_REFERENCES|XAML_TYPE)|WILL_FAIL|WIN32_EXECUTABLE|WINDOWS_EXPORT_ALL_SYMBOLS|WORKING_DIRECTORY|WRAP_EXCLUDE|XCODE_(?:EMIT_EFFECTIVE_PLATFORM_NAME|EXPLICIT_FILE_TYPE|FILE_ATTRIBUTES|LAST_KNOWN_FILE_TYPE|PRODUCT_TYPE|SCHEME_(?:ADDRESS_SANITIZER|ADDRESS_SANITIZER_USE_AFTER_RETURN|ARGUMENTS|DISABLE_MAIN_THREAD_CHECKER|DYNAMIC_LIBRARY_LOADS|DYNAMIC_LINKER_API_USAGE|ENVIRONMENT|EXECUTABLE|GUARD_MALLOC|MAIN_THREAD_CHECKER_STOP|MALLOC_GUARD_EDGES|MALLOC_SCRIBBLE|MALLOC_STACK|THREAD_SANITIZER(?:_STOP)?|UNDEFINED_BEHAVIOUR_SANITIZER(?:_STOP)?|ZOMBIE_OBJECTS))|XCTEST)\b/,
      keyword: /\b(?:add_compile_definitions|add_compile_options|add_custom_command|add_custom_target|add_definitions|add_dependencies|add_executable|add_library|add_link_options|add_subdirectory|add_test|aux_source_directory|break|build_command|build_name|cmake_host_system_information|cmake_minimum_required|cmake_parse_arguments|cmake_policy|configure_file|continue|create_test_sourcelist|ctest_build|ctest_configure|ctest_coverage|ctest_empty_binary_directory|ctest_memcheck|ctest_read_custom_files|ctest_run_script|ctest_sleep|ctest_start|ctest_submit|ctest_test|ctest_update|ctest_upload|define_property|else|elseif|enable_language|enable_testing|endforeach|endfunction|endif|endmacro|endwhile|exec_program|execute_process|export|export_library_dependencies|file|find_file|find_library|find_package|find_path|find_program|fltk_wrap_ui|foreach|function|get_cmake_property|get_directory_property|get_filename_component|get_property|get_source_file_property|get_target_property|get_test_property|if|include|include_directories|include_external_msproject|include_guard|include_regular_expression|install|install_files|install_programs|install_targets|link_directories|link_libraries|list|load_cache|load_command|macro|make_directory|mark_as_advanced|math|message|option|output_required_files|project|qt_wrap_cpp|qt_wrap_ui|remove|remove_definitions|return|separate_arguments|set|set_directory_properties|set_property|set_source_files_properties|set_target_properties|set_tests_properties|site_name|source_group|string|subdir_depends|subdirs|target_compile_definitions|target_compile_features|target_compile_options|target_include_directories|target_link_directories|target_link_libraries|target_link_options|target_sources|try_compile|try_run|unset|use_mangled_mesa|utility_source|variable_requires|variable_watch|while|write_file)(?=\s*\()\b/,
      boolean: /\b(?:FALSE|OFF|ON|TRUE)\b/,
      namespace: /\b(?:INTERFACE|PRIVATE|PROPERTIES|PUBLIC|SHARED|STATIC|TARGET_OBJECTS)\b/,
      operator: /\b(?:AND|DEFINED|EQUAL|GREATER|LESS|MATCHES|NOT|OR|STREQUAL|STRGREATER|STRLESS|VERSION_EQUAL|VERSION_GREATER|VERSION_LESS)\b/,
      inserted: {
        pattern: /\b\w+::\w+\b/,
        alias: "class-name"
      },
      number: /\b\d+(?:\.\d+)*\b/,
      function: /\b[a-z_]\w*(?=\s*\()\b/i,
      punctuation: /[()>}]|\$[<{]/
    };
  }
  return cmake_1;
}
var cobol_1, hasRequiredCobol;
function requireCobol() {
  if (hasRequiredCobol) return cobol_1;
  hasRequiredCobol = 1, cobol_1 = n, n.displayName = "cobol", n.aliases = [];
  function n(t) {
    t.languages.cobol = {
      comment: {
        pattern: /\*>.*|(^[ \t]*)\*.*/m,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /[xzgn]?(?:"(?:[^\r\n"]|"")*"(?!")|'(?:[^\r\n']|'')*'(?!'))/i,
        greedy: !0
      },
      level: {
        pattern: /(^[ \t]*)\d+\b/m,
        lookbehind: !0,
        greedy: !0,
        alias: "number"
      },
      "class-name": {
        // https://github.com/antlr/grammars-v4/blob/42edd5b687d183b5fa679e858a82297bd27141e7/cobol85/Cobol85.g4#L1015
        pattern: /(\bpic(?:ture)?\s+)(?:(?:[-\w$/,:*+<>]|\.(?!\s|$))(?:\(\d+\))?)+/i,
        lookbehind: !0,
        inside: {
          number: {
            pattern: /(\()\d+/,
            lookbehind: !0
          },
          punctuation: /[()]/
        }
      },
      keyword: {
        pattern: /(^|[^\w-])(?:ABORT|ACCEPT|ACCESS|ADD|ADDRESS|ADVANCING|AFTER|ALIGNED|ALL|ALPHABET|ALPHABETIC|ALPHABETIC-LOWER|ALPHABETIC-UPPER|ALPHANUMERIC|ALPHANUMERIC-EDITED|ALSO|ALTER|ALTERNATE|ANY|ARE|AREA|AREAS|AS|ASCENDING|ASCII|ASSIGN|ASSOCIATED-DATA|ASSOCIATED-DATA-LENGTH|AT|ATTRIBUTE|AUTHOR|AUTO|AUTO-SKIP|BACKGROUND-COLOR|BACKGROUND-COLOUR|BASIS|BEEP|BEFORE|BEGINNING|BELL|BINARY|BIT|BLANK|BLINK|BLOCK|BOTTOM|BOUNDS|BY|BYFUNCTION|BYTITLE|CALL|CANCEL|CAPABLE|CCSVERSION|CD|CF|CH|CHAINING|CHANGED|CHANNEL|CHARACTER|CHARACTERS|CLASS|CLASS-ID|CLOCK-UNITS|CLOSE|CLOSE-DISPOSITION|COBOL|CODE|CODE-SET|COL|COLLATING|COLUMN|COM-REG|COMMA|COMMITMENT|COMMON|COMMUNICATION|COMP|COMP-1|COMP-2|COMP-3|COMP-4|COMP-5|COMPUTATIONAL|COMPUTATIONAL-1|COMPUTATIONAL-2|COMPUTATIONAL-3|COMPUTATIONAL-4|COMPUTATIONAL-5|COMPUTE|CONFIGURATION|CONTAINS|CONTENT|CONTINUE|CONTROL|CONTROL-POINT|CONTROLS|CONVENTION|CONVERTING|COPY|CORR|CORRESPONDING|COUNT|CRUNCH|CURRENCY|CURSOR|DATA|DATA-BASE|DATE|DATE-COMPILED|DATE-WRITTEN|DAY|DAY-OF-WEEK|DBCS|DE|DEBUG-CONTENTS|DEBUG-ITEM|DEBUG-LINE|DEBUG-NAME|DEBUG-SUB-1|DEBUG-SUB-2|DEBUG-SUB-3|DEBUGGING|DECIMAL-POINT|DECLARATIVES|DEFAULT|DEFAULT-DISPLAY|DEFINITION|DELETE|DELIMITED|DELIMITER|DEPENDING|DESCENDING|DESTINATION|DETAIL|DFHRESP|DFHVALUE|DISABLE|DISK|DISPLAY|DISPLAY-1|DIVIDE|DIVISION|DONTCARE|DOUBLE|DOWN|DUPLICATES|DYNAMIC|EBCDIC|EGCS|EGI|ELSE|EMI|EMPTY-CHECK|ENABLE|END|END-ACCEPT|END-ADD|END-CALL|END-COMPUTE|END-DELETE|END-DIVIDE|END-EVALUATE|END-IF|END-MULTIPLY|END-OF-PAGE|END-PERFORM|END-READ|END-RECEIVE|END-RETURN|END-REWRITE|END-SEARCH|END-START|END-STRING|END-SUBTRACT|END-UNSTRING|END-WRITE|ENDING|ENTER|ENTRY|ENTRY-PROCEDURE|ENVIRONMENT|EOL|EOP|EOS|ERASE|ERROR|ESCAPE|ESI|EVALUATE|EVENT|EVERY|EXCEPTION|EXCLUSIVE|EXHIBIT|EXIT|EXPORT|EXTEND|EXTENDED|EXTERNAL|FD|FILE|FILE-CONTROL|FILLER|FINAL|FIRST|FOOTING|FOR|FOREGROUND-COLOR|FOREGROUND-COLOUR|FROM|FULL|FUNCTION|FUNCTION-POINTER|FUNCTIONNAME|GENERATE|GIVING|GLOBAL|GO|GOBACK|GRID|GROUP|HEADING|HIGH-VALUE|HIGH-VALUES|HIGHLIGHT|I-O|I-O-CONTROL|ID|IDENTIFICATION|IF|IMPLICIT|IMPORT|IN|INDEX|INDEXED|INDICATE|INITIAL|INITIALIZE|INITIATE|INPUT|INPUT-OUTPUT|INSPECT|INSTALLATION|INTEGER|INTO|INVALID|INVOKE|IS|JUST|JUSTIFIED|KANJI|KEPT|KEY|KEYBOARD|LABEL|LANGUAGE|LAST|LB|LD|LEADING|LEFT|LEFTLINE|LENGTH|LENGTH-CHECK|LIBACCESS|LIBPARAMETER|LIBRARY|LIMIT|LIMITS|LINAGE|LINAGE-COUNTER|LINE|LINE-COUNTER|LINES|LINKAGE|LIST|LOCAL|LOCAL-STORAGE|LOCK|LONG-DATE|LONG-TIME|LOW-VALUE|LOW-VALUES|LOWER|LOWLIGHT|MEMORY|MERGE|MESSAGE|MMDDYYYY|MODE|MODULES|MORE-LABELS|MOVE|MULTIPLE|MULTIPLY|NAMED|NATIONAL|NATIONAL-EDITED|NATIVE|NEGATIVE|NETWORK|NEXT|NO|NO-ECHO|NULL|NULLS|NUMBER|NUMERIC|NUMERIC-DATE|NUMERIC-EDITED|NUMERIC-TIME|OBJECT-COMPUTER|OCCURS|ODT|OF|OFF|OMITTED|ON|OPEN|OPTIONAL|ORDER|ORDERLY|ORGANIZATION|OTHER|OUTPUT|OVERFLOW|OVERLINE|OWN|PACKED-DECIMAL|PADDING|PAGE|PAGE-COUNTER|PASSWORD|PERFORM|PF|PH|PIC|PICTURE|PLUS|POINTER|PORT|POSITION|POSITIVE|PRINTER|PRINTING|PRIVATE|PROCEDURE|PROCEDURE-POINTER|PROCEDURES|PROCEED|PROCESS|PROGRAM|PROGRAM-ID|PROGRAM-LIBRARY|PROMPT|PURGE|QUEUE|QUOTE|QUOTES|RANDOM|RD|READ|READER|REAL|RECEIVE|RECEIVED|RECORD|RECORDING|RECORDS|RECURSIVE|REDEFINES|REEL|REF|REFERENCE|REFERENCES|RELATIVE|RELEASE|REMAINDER|REMARKS|REMOTE|REMOVAL|REMOVE|RENAMES|REPLACE|REPLACING|REPORT|REPORTING|REPORTS|REQUIRED|RERUN|RESERVE|RESET|RETURN|RETURN-CODE|RETURNING|REVERSE-VIDEO|REVERSED|REWIND|REWRITE|RF|RH|RIGHT|ROUNDED|RUN|SAME|SAVE|SCREEN|SD|SEARCH|SECTION|SECURE|SECURITY|SEGMENT|SEGMENT-LIMIT|SELECT|SEND|SENTENCE|SEPARATE|SEQUENCE|SEQUENTIAL|SET|SHARED|SHAREDBYALL|SHAREDBYRUNUNIT|SHARING|SHIFT-IN|SHIFT-OUT|SHORT-DATE|SIGN|SIZE|SORT|SORT-CONTROL|SORT-CORE-SIZE|SORT-FILE-SIZE|SORT-MERGE|SORT-MESSAGE|SORT-MODE-SIZE|SORT-RETURN|SOURCE|SOURCE-COMPUTER|SPACE|SPACES|SPECIAL-NAMES|STANDARD|STANDARD-1|STANDARD-2|START|STATUS|STOP|STRING|SUB-QUEUE-1|SUB-QUEUE-2|SUB-QUEUE-3|SUBTRACT|SUM|SUPPRESS|SYMBOL|SYMBOLIC|SYNC|SYNCHRONIZED|TABLE|TALLY|TALLYING|TAPE|TASK|TERMINAL|TERMINATE|TEST|TEXT|THEN|THREAD|THREAD-LOCAL|THROUGH|THRU|TIME|TIMER|TIMES|TITLE|TO|TODAYS-DATE|TODAYS-NAME|TOP|TRAILING|TRUNCATED|TYPE|TYPEDEF|UNDERLINE|UNIT|UNSTRING|UNTIL|UP|UPON|USAGE|USE|USING|VALUE|VALUES|VARYING|VIRTUAL|WAIT|WHEN|WHEN-COMPILED|WITH|WORDS|WORKING-STORAGE|WRITE|YEAR|YYYYDDD|YYYYMMDD|ZERO-FILL|ZEROES|ZEROS)(?![\w-])/i,
        lookbehind: !0
      },
      boolean: {
        pattern: /(^|[^\w-])(?:false|true)(?![\w-])/i,
        lookbehind: !0
      },
      number: {
        pattern: /(^|[^\w-])(?:[+-]?(?:(?:\d+(?:[.,]\d+)?|[.,]\d+)(?:e[+-]?\d+)?|zero))(?![\w-])/i,
        lookbehind: !0
      },
      operator: [
        /<>|[<>]=?|[=+*/&]/,
        {
          pattern: /(^|[^\w-])(?:-|and|equal|greater|less|not|or|than)(?![\w-])/i,
          lookbehind: !0
        }
      ],
      punctuation: /[.:,()]/
    };
  }
  return cobol_1;
}
var coffeescript_1, hasRequiredCoffeescript;
function requireCoffeescript() {
  if (hasRequiredCoffeescript) return coffeescript_1;
  hasRequiredCoffeescript = 1, coffeescript_1 = n, n.displayName = "coffeescript", n.aliases = ["coffee"];
  function n(t) {
    (function(g) {
      var d = /#(?!\{).+/, k = {
        pattern: /#\{[^}]+\}/,
        alias: "variable"
      };
      g.languages.coffeescript = g.languages.extend("javascript", {
        comment: d,
        string: [
          // Strings are multiline
          {
            pattern: /'(?:\\[\s\S]|[^\\'])*'/,
            greedy: !0
          },
          {
            // Strings are multiline
            pattern: /"(?:\\[\s\S]|[^\\"])*"/,
            greedy: !0,
            inside: {
              interpolation: k
            }
          }
        ],
        keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
        "class-member": {
          pattern: /@(?!\d)\w+/,
          alias: "variable"
        }
      }), g.languages.insertBefore("coffeescript", "comment", {
        "multiline-comment": {
          pattern: /###[\s\S]+?###/,
          alias: "comment"
        },
        // Block regexp can contain comments and interpolation
        "block-regex": {
          pattern: /\/{3}[\s\S]*?\/{3}/,
          alias: "regex",
          inside: {
            comment: d,
            interpolation: k
          }
        }
      }), g.languages.insertBefore("coffeescript", "string", {
        "inline-javascript": {
          pattern: /`(?:\\[\s\S]|[^\\`])*`/,
          inside: {
            delimiter: {
              pattern: /^`|`$/,
              alias: "punctuation"
            },
            script: {
              pattern: /[\s\S]+/,
              alias: "language-javascript",
              inside: g.languages.javascript
            }
          }
        },
        // Block strings
        "multiline-string": [
          {
            pattern: /'''[\s\S]*?'''/,
            greedy: !0,
            alias: "string"
          },
          {
            pattern: /"""[\s\S]*?"""/,
            greedy: !0,
            alias: "string",
            inside: {
              interpolation: k
            }
          }
        ]
      }), g.languages.insertBefore("coffeescript", "keyword", {
        // Object property
        property: /(?!\d)\w+(?=\s*:(?!:))/
      }), delete g.languages.coffeescript["template-string"], g.languages.coffee = g.languages.coffeescript;
    })(t);
  }
  return coffeescript_1;
}
var concurnas_1, hasRequiredConcurnas;
function requireConcurnas() {
  if (hasRequiredConcurnas) return concurnas_1;
  hasRequiredConcurnas = 1, concurnas_1 = n, n.displayName = "concurnas", n.aliases = ["conc"];
  function n(t) {
    t.languages.concurnas = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*)/,
        lookbehind: !0,
        greedy: !0
      },
      langext: {
        pattern: /\b\w+\s*\|\|[\s\S]+?\|\|/,
        greedy: !0,
        inside: {
          "class-name": /^\w+/,
          string: {
            pattern: /(^\s*\|\|)[\s\S]+(?=\|\|$)/,
            lookbehind: !0
          },
          punctuation: /\|\|/
        }
      },
      function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/,
        lookbehind: !0
      },
      keyword: /\b(?:abstract|actor|also|annotation|assert|async|await|bool|boolean|break|byte|case|catch|changed|char|class|closed|constant|continue|def|default|del|double|elif|else|enum|every|extends|false|finally|float|for|from|global|gpudef|gpukernel|if|import|in|init|inject|int|lambda|local|long|loop|match|new|nodefault|null|of|onchange|open|out|override|package|parfor|parforsync|post|pre|private|protected|provide|provider|public|return|shared|short|single|size_t|sizeof|super|sync|this|throw|trait|trans|transient|true|try|typedef|unchecked|using|val|var|void|while|with)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /\b0b[01][01_]*L?\b|\b0x(?:[\da-f_]*\.)?[\da-f_p+-]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfls]?/i,
      punctuation: /[{}[\];(),.:]/,
      operator: /<==|>==|=>|->|<-|<>|&==|&<>|\?:?|\.\?|\+\+|--|[-+*/=<>]=?|[!^~]|\b(?:and|as|band|bor|bxor|comp|is|isnot|mod|or)\b=?/,
      annotation: {
        pattern: /@(?:\w+:)?(?:\w+|\[[^\]]+\])?/,
        alias: "builtin"
      }
    }, t.languages.insertBefore("concurnas", "langext", {
      "regex-literal": {
        pattern: /\br("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
            lookbehind: !0,
            inside: t.languages.concurnas
          },
          regex: /[\s\S]+/
        }
      },
      "string-literal": {
        pattern: /(?:\B|\bs)("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
            lookbehind: !0,
            inside: t.languages.concurnas
          },
          string: /[\s\S]+/
        }
      }
    }), t.languages.conc = t.languages.concurnas;
  }
  return concurnas_1;
}
var coq_1, hasRequiredCoq;
function requireCoq() {
  if (hasRequiredCoq) return coq_1;
  hasRequiredCoq = 1, coq_1 = n, n.displayName = "coq", n.aliases = [];
  function n(t) {
    (function(g) {
      for (var d = /\(\*(?:[^(*]|\((?!\*)|\*(?!\))|<self>)*\*\)/.source, k = 0; k < 2; k++)
        d = d.replace(/<self>/g, function() {
          return d;
        });
      d = d.replace(/<self>/g, "[]"), g.languages.coq = {
        comment: RegExp(d),
        string: {
          pattern: /"(?:[^"]|"")*"(?!")/,
          greedy: !0
        },
        attribute: [
          {
            pattern: RegExp(
              /#\[(?:[^\[\]("]|"(?:[^"]|"")*"(?!")|\((?!\*)|<comment>)*\]/.source.replace(
                /<comment>/g,
                function() {
                  return d;
                }
              )
            ),
            greedy: !0,
            alias: "attr-name",
            inside: {
              comment: RegExp(d),
              string: {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: !0
              },
              operator: /=/,
              punctuation: /^#\[|\]$|[,()]/
            }
          },
          {
            pattern: /\b(?:Cumulative|Global|Local|Monomorphic|NonCumulative|Polymorphic|Private|Program)\b/,
            alias: "attr-name"
          }
        ],
        keyword: /\b(?:Abort|About|Add|Admit|Admitted|All|Arguments|As|Assumptions|Axiom|Axioms|Back|BackTo|Backtrace|BinOp|BinOpSpec|BinRel|Bind|Blacklist|Canonical|Case|Cd|Check|Class|Classes|Close|CoFixpoint|CoInductive|Coercion|Coercions|Collection|Combined|Compute|Conjecture|Conjectures|Constant|Constants|Constraint|Constructors|Context|Corollary|Create|CstOp|Custom|Cut|Debug|Declare|Defined|Definition|Delimit|Dependencies|Dependent|Derive|Diffs|Drop|Elimination|End|Entry|Equality|Eval|Example|Existential|Existentials|Existing|Export|Extern|Extraction|Fact|Fail|Field|File|Firstorder|Fixpoint|Flags|Focus|From|Funclass|Function|Functional|GC|Generalizable|Goal|Grab|Grammar|Graph|Guarded|Haskell|Heap|Hide|Hint|HintDb|Hints|Hypotheses|Hypothesis|IF|Identity|Immediate|Implicit|Implicits|Import|Include|Induction|Inductive|Infix|Info|Initial|InjTyp|Inline|Inspect|Instance|Instances|Intro|Intros|Inversion|Inversion_clear|JSON|Language|Left|Lemma|Let|Lia|Libraries|Library|Load|LoadPath|Locate|Ltac|Ltac2|ML|Match|Method|Minimality|Module|Modules|Morphism|Next|NoInline|Notation|Number|OCaml|Obligation|Obligations|Opaque|Open|Optimize|Parameter|Parameters|Parametric|Path|Paths|Prenex|Preterm|Primitive|Print|Profile|Projections|Proof|Prop|PropBinOp|PropOp|PropUOp|Property|Proposition|Pwd|Qed|Quit|Rec|Record|Recursive|Redirect|Reduction|Register|Relation|Remark|Remove|Require|Reserved|Reset|Resolve|Restart|Rewrite|Right|Ring|Rings|SProp|Saturate|Save|Scheme|Scope|Scopes|Search|SearchHead|SearchPattern|SearchRewrite|Section|Separate|Set|Setoid|Show|Signatures|Solve|Solver|Sort|Sortclass|Sorted|Spec|Step|Strategies|Strategy|String|Structure|SubClass|Subgraph|SuchThat|Tactic|Term|TestCompile|Theorem|Time|Timeout|To|Transparent|Type|Typeclasses|Types|Typing|UnOp|UnOpSpec|Undelimit|Undo|Unfocus|Unfocused|Unfold|Universe|Universes|Unshelve|Variable|Variables|Variant|Verbose|View|Visibility|Zify|_|apply|as|at|by|cofix|else|end|exists|exists2|fix|for|forall|fun|if|in|let|match|measure|move|removed|return|struct|then|using|wf|where|with)\b/,
        number: /\b(?:0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]+)?(?:p[+-]?\d[\d_]*)?|\d[\d_]*(?:\.[\d_]+)?(?:e[+-]?\d[\d_]*)?)\b/i,
        punct: {
          pattern: /@\{|\{\||\[=|:>/,
          alias: "punctuation"
        },
        operator: /\/\\|\\\/|\.{2,3}|:{1,2}=|\*\*|[-=]>|<(?:->?|[+:=>]|<:)|>(?:=|->)|\|[-|]?|[-!%&*+/<=>?@^~']/,
        punctuation: /\.\(|`\(|@\{|`\{|\{\||\[=|:>|[:.,;(){}\[\]]/
      };
    })(t);
  }
  return coq_1;
}
var ruby_1, hasRequiredRuby;
function requireRuby() {
  if (hasRequiredRuby) return ruby_1;
  hasRequiredRuby = 1, ruby_1 = n, n.displayName = "ruby", n.aliases = ["rb"];
  function n(t) {
    (function(g) {
      g.languages.ruby = g.languages.extend("clike", {
        comment: {
          pattern: /#.*|^=begin\s[\s\S]*?^=end/m,
          greedy: !0
        },
        "class-name": {
          pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/,
          lookbehind: !0,
          inside: {
            punctuation: /[.\\]/
          }
        },
        keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/,
        operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/,
        punctuation: /[(){}[\].,;]/
      }), g.languages.insertBefore("ruby", "operator", {
        "double-colon": {
          pattern: /::/,
          alias: "punctuation"
        }
      });
      var d = {
        pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/,
        lookbehind: !0,
        inside: {
          content: {
            pattern: /^(#\{)[\s\S]+(?=\}$)/,
            lookbehind: !0,
            inside: g.languages.ruby
          },
          delimiter: {
            pattern: /^#\{|\}$/,
            alias: "punctuation"
          }
        }
      };
      delete g.languages.ruby.function;
      var k = "(?:" + [
        /([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
        /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source,
        /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source,
        /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source,
        /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source
      ].join("|") + ")", H = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
      g.languages.insertBefore("ruby", "keyword", {
        "regex-literal": [
          {
            pattern: RegExp(
              /%r/.source + k + /[egimnosux]{0,6}/.source
            ),
            greedy: !0,
            inside: {
              interpolation: d,
              regex: /[\s\S]+/
            }
          },
          {
            pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
            lookbehind: !0,
            greedy: !0,
            inside: {
              interpolation: d,
              regex: /[\s\S]+/
            }
          }
        ],
        variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
        symbol: [
          {
            pattern: RegExp(/(^|[^:]):/.source + H),
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: RegExp(
              /([\r\n{(,][ \t]*)/.source + H + /(?=:(?!:))/.source
            ),
            lookbehind: !0,
            greedy: !0
          }
        ],
        "method-definition": {
          pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/,
          lookbehind: !0,
          inside: {
            function: /\b\w+$/,
            keyword: /^self\b/,
            "class-name": /^\w+/,
            punctuation: /\./
          }
        }
      }), g.languages.insertBefore("ruby", "string", {
        "string-literal": [
          {
            pattern: RegExp(/%[qQiIwWs]?/.source + k),
            greedy: !0,
            inside: {
              interpolation: d,
              string: /[\s\S]+/
            }
          },
          {
            pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
            greedy: !0,
            inside: {
              interpolation: d,
              string: /[\s\S]+/
            }
          },
          {
            pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
            alias: "heredoc-string",
            greedy: !0,
            inside: {
              delimiter: {
                pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i,
                inside: {
                  symbol: /\b\w+/,
                  punctuation: /^<<[-~]?/
                }
              },
              interpolation: d,
              string: /[\s\S]+/
            }
          },
          {
            pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
            alias: "heredoc-string",
            greedy: !0,
            inside: {
              delimiter: {
                pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i,
                inside: {
                  symbol: /\b\w+/,
                  punctuation: /^<<[-~]?'|'$/
                }
              },
              string: /[\s\S]+/
            }
          }
        ],
        "command-literal": [
          {
            pattern: RegExp(/%x/.source + k),
            greedy: !0,
            inside: {
              interpolation: d,
              command: {
                pattern: /[\s\S]+/,
                alias: "string"
              }
            }
          },
          {
            pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/,
            greedy: !0,
            inside: {
              interpolation: d,
              command: {
                pattern: /[\s\S]+/,
                alias: "string"
              }
            }
          }
        ]
      }), delete g.languages.ruby.string, g.languages.insertBefore("ruby", "number", {
        builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/,
        constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/
      }), g.languages.rb = g.languages.ruby;
    })(t);
  }
  return ruby_1;
}
var crystal_1, hasRequiredCrystal;
function requireCrystal() {
  if (hasRequiredCrystal) return crystal_1;
  hasRequiredCrystal = 1;
  var n = requireRuby();
  crystal_1 = t, t.displayName = "crystal", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      d.languages.crystal = d.languages.extend("ruby", {
        keyword: [
          /\b(?:__DIR__|__END_LINE__|__FILE__|__LINE__|abstract|alias|annotation|as|asm|begin|break|case|class|def|do|else|elsif|end|ensure|enum|extend|for|fun|if|ifdef|include|instance_sizeof|lib|macro|module|next|of|out|pointerof|private|protected|ptr|require|rescue|return|select|self|sizeof|struct|super|then|type|typeof|undef|uninitialized|union|unless|until|when|while|with|yield)\b/,
          {
            pattern: /(\.\s*)(?:is_a|responds_to)\?/,
            lookbehind: !0
          }
        ],
        number: /\b(?:0b[01_]*[01]|0o[0-7_]*[0-7]|0x[\da-fA-F_]*[\da-fA-F]|(?:\d(?:[\d_]*\d)?)(?:\.[\d_]*\d)?(?:[eE][+-]?[\d_]*\d)?)(?:_(?:[uif](?:8|16|32|64))?)?\b/,
        operator: [/->/, d.languages.ruby.operator],
        punctuation: /[(){}[\].,;\\]/
      }), d.languages.insertBefore("crystal", "string-literal", {
        attribute: {
          pattern: /@\[.*?\]/,
          inside: {
            delimiter: {
              pattern: /^@\[|\]$/,
              alias: "punctuation"
            },
            attribute: {
              pattern: /^(\s*)\w+/,
              lookbehind: !0,
              alias: "class-name"
            },
            args: {
              pattern: /\S(?:[\s\S]*\S)?/,
              inside: d.languages.crystal
            }
          }
        },
        expansion: {
          pattern: /\{(?:\{.*?\}|%.*?%)\}/,
          inside: {
            content: {
              pattern: /^(\{.)[\s\S]+(?=.\}$)/,
              lookbehind: !0,
              inside: d.languages.crystal
            },
            delimiter: {
              pattern: /^\{[\{%]|[\}%]\}$/,
              alias: "operator"
            }
          }
        },
        char: {
          pattern: /'(?:[^\\\r\n]{1,2}|\\(?:.|u(?:[A-Fa-f0-9]{1,4}|\{[A-Fa-f0-9]{1,6}\})))'/,
          greedy: !0
        }
      });
    })(g);
  }
  return crystal_1;
}
var cshtml_1, hasRequiredCshtml;
function requireCshtml() {
  if (hasRequiredCshtml) return cshtml_1;
  hasRequiredCshtml = 1;
  var n = requireCsharp();
  cshtml_1 = t, t.displayName = "cshtml", t.aliases = ["razor"];
  function t(g) {
    g.register(n), (function(d) {
      var k = /\/(?![/*])|\/\/.*[\r\n]|\/\*[^*]*(?:\*(?!\/)[^*]*)*\*\//.source, H = /@(?!")|"(?:[^\r\n\\"]|\\.)*"|@"(?:[^\\"]|""|\\[\s\S])*"(?!")/.source + "|" + /'(?:(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'|(?=[^\\](?!')))/.source;
      function AA(EA, aA) {
        for (var nA = 0; nA < aA; nA++)
          EA = EA.replace(/<self>/g, function() {
            return "(?:" + EA + ")";
          });
        return EA.replace(/<self>/g, "[^\\s\\S]").replace(/<str>/g, "(?:" + H + ")").replace(/<comment>/g, "(?:" + k + ")");
      }
      var gA = AA(/\((?:[^()'"@/]|<str>|<comment>|<self>)*\)/.source, 2), IA = AA(/\[(?:[^\[\]'"@/]|<str>|<comment>|<self>)*\]/.source, 2), CA = AA(/\{(?:[^{}'"@/]|<str>|<comment>|<self>)*\}/.source, 2), BA = AA(/<(?:[^<>'"@/]|<str>|<comment>|<self>)*>/.source, 2), eA = /(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?/.source, iA = /(?!\d)[^\s>\/=$<%]+/.source + eA + /\s*\/?>/.source, QA = /\B@?/.source + "(?:" + /<([a-zA-Z][\w:]*)/.source + eA + /\s*>/.source + "(?:" + (/[^<]/.source + "|" + // all tags that are not the start tag
      // eslint-disable-next-line regexp/strict
      /<\/?(?!\1\b)/.source + iA + "|" + // nested start tag
      AA(
        // eslint-disable-next-line regexp/strict
        /<\1/.source + eA + /\s*>/.source + "(?:" + (/[^<]/.source + "|" + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + iA + "|<self>") + ")*" + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source,
        2
      )) + ")*" + // eslint-disable-next-line regexp/strict
      /<\/\1\s*>/.source + "|" + /</.source + iA + ")";
      d.languages.cshtml = d.languages.extend("markup", {});
      var tA = d.languages.insertBefore(
        "csharp",
        "string",
        {
          html: {
            pattern: RegExp(QA),
            greedy: !0,
            inside: d.languages.cshtml
          }
        },
        {
          csharp: d.languages.extend("csharp", {})
        }
      ), oA = {
        pattern: /\S[\s\S]*/,
        alias: "language-csharp",
        inside: tA
      };
      d.languages.insertBefore("cshtml", "prolog", {
        "razor-comment": {
          pattern: /@\*[\s\S]*?\*@/,
          greedy: !0,
          alias: "comment"
        },
        block: {
          pattern: RegExp(
            /(^|[^@])@/.source + "(?:" + [
              // @{ ... }
              CA,
              // @code{ ... }
              /(?:code|functions)\s*/.source + CA,
              // @for (...) { ... }
              /(?:for|foreach|lock|switch|using|while)\s*/.source + gA + /\s*/.source + CA,
              // @do { ... } while (...);
              /do\s*/.source + CA + /\s*while\s*/.source + gA + /(?:\s*;)?/.source,
              // @try { ... } catch (...) { ... } finally { ... }
              /try\s*/.source + CA + /\s*catch\s*/.source + gA + /\s*/.source + CA + /\s*finally\s*/.source + CA,
              // @if (...) {...} else if (...) {...} else {...}
              /if\s*/.source + gA + /\s*/.source + CA + "(?:" + /\s*else/.source + "(?:" + /\s+if\s*/.source + gA + ")?" + /\s*/.source + CA + ")*"
            ].join("|") + ")"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            keyword: /^@\w*/,
            csharp: oA
          }
        },
        directive: {
          pattern: /^([ \t]*)@(?:addTagHelper|attribute|implements|inherits|inject|layout|model|namespace|page|preservewhitespace|removeTagHelper|section|tagHelperPrefix|using)(?=\s).*/m,
          lookbehind: !0,
          greedy: !0,
          inside: {
            keyword: /^@\w+/,
            csharp: oA
          }
        },
        value: {
          pattern: RegExp(
            /(^|[^@])@/.source + /(?:await\b\s*)?/.source + "(?:" + /\w+\b/.source + "|" + gA + ")(?:" + /[?!]?\.\w+\b/.source + "|" + gA + "|" + IA + "|" + BA + gA + ")*"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "variable",
          inside: {
            keyword: /^@/,
            csharp: oA
          }
        },
        "delegate-operator": {
          pattern: /(^|[^@])@(?=<)/,
          lookbehind: !0,
          alias: "operator"
        }
      }), d.languages.razor = d.languages.cshtml;
    })(g);
  }
  return cshtml_1;
}
var csp_1, hasRequiredCsp;
function requireCsp() {
  if (hasRequiredCsp) return csp_1;
  hasRequiredCsp = 1, csp_1 = n, n.displayName = "csp", n.aliases = [];
  function n(t) {
    (function(g) {
      function d(k) {
        return RegExp(
          /([ \t])/.source + "(?:" + k + ")" + /(?=[\s;]|$)/.source,
          "i"
        );
      }
      g.languages.csp = {
        directive: {
          pattern: /(^|[\s;])(?:base-uri|block-all-mixed-content|(?:child|connect|default|font|frame|img|manifest|media|object|prefetch|script|style|worker)-src|disown-opener|form-action|frame-(?:ancestors|options)|input-protection(?:-(?:clip|selectors))?|navigate-to|plugin-types|policy-uri|referrer|reflected-xss|report-(?:to|uri)|require-sri-for|sandbox|(?:script|style)-src-(?:attr|elem)|upgrade-insecure-requests)(?=[\s;]|$)/i,
          lookbehind: !0,
          alias: "property"
        },
        scheme: {
          pattern: d(/[a-z][a-z0-9.+-]*:/.source),
          lookbehind: !0
        },
        none: {
          pattern: d(/'none'/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        nonce: {
          pattern: d(/'nonce-[-+/\w=]+'/.source),
          lookbehind: !0,
          alias: "number"
        },
        hash: {
          pattern: d(/'sha(?:256|384|512)-[-+/\w=]+'/.source),
          lookbehind: !0,
          alias: "number"
        },
        host: {
          pattern: d(
            /[a-z][a-z0-9.+-]*:\/\/[^\s;,']*/.source + "|" + /\*[^\s;,']*/.source + "|" + /[a-z0-9-]+(?:\.[a-z0-9-]+)+(?::[\d*]+)?(?:\/[^\s;,']*)?/.source
          ),
          lookbehind: !0,
          alias: "url",
          inside: {
            important: /\*/
          }
        },
        keyword: [
          {
            pattern: d(/'unsafe-[a-z-]+'/.source),
            lookbehind: !0,
            alias: "unsafe"
          },
          {
            pattern: d(/'[a-z-]+'/.source),
            lookbehind: !0,
            alias: "safe"
          }
        ],
        punctuation: /;/
      };
    })(t);
  }
  return csp_1;
}
var cssExtras_1, hasRequiredCssExtras;
function requireCssExtras() {
  if (hasRequiredCssExtras) return cssExtras_1;
  hasRequiredCssExtras = 1, cssExtras_1 = n, n.displayName = "cssExtras", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, k;
      g.languages.css.selector = {
        pattern: g.languages.css.selector.pattern,
        lookbehind: !0,
        inside: k = {
          "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
          "pseudo-class": /:[-\w]+/,
          class: /\.[-\w]+/,
          id: /#[-\w]+/,
          attribute: {
            pattern: RegExp(`\\[(?:[^[\\]"']|` + d.source + ")*\\]"),
            greedy: !0,
            inside: {
              punctuation: /^\[|\]$/,
              "case-sensitivity": {
                pattern: /(\s)[si]$/i,
                lookbehind: !0,
                alias: "keyword"
              },
              namespace: {
                pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                lookbehind: !0,
                inside: {
                  punctuation: /\|$/
                }
              },
              "attr-name": {
                pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                lookbehind: !0
              },
              "attr-value": [
                d,
                {
                  pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                  lookbehind: !0
                }
              ],
              operator: /[|~*^$]?=/
            }
          },
          "n-th": [
            {
              pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
              lookbehind: !0,
              inside: {
                number: /[\dn]+/,
                operator: /[+-]/
              }
            },
            {
              pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
              lookbehind: !0
            }
          ],
          combinator: />|\+|~|\|\|/,
          // the `tag` token has been existed and removed.
          // because we can't find a perfect tokenize to match it.
          // if you want to add it, please read https://github.com/PrismJS/prism/pull/2373 first.
          punctuation: /[(),]/
        }
      }, g.languages.css.atrule.inside["selector-function-argument"].inside = k, g.languages.insertBefore("css", "property", {
        variable: {
          pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
          lookbehind: !0
        }
      });
      var H = {
        pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
        lookbehind: !0
      }, AA = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: !0
      };
      g.languages.insertBefore("css", "function", {
        operator: {
          pattern: /(\s)[+\-*\/](?=\s)/,
          lookbehind: !0
        },
        // CAREFUL!
        // Previewers and Inline color use hexcode and color.
        hexcode: {
          pattern: /\B#[\da-f]{3,8}\b/i,
          alias: "color"
        },
        color: [
          {
            pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
            lookbehind: !0
          },
          {
            pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
            inside: {
              unit: H,
              number: AA,
              function: /[\w-]+(?=\()/,
              punctuation: /[(),]/
            }
          }
        ],
        // it's important that there is no boundary assertion after the hex digits
        entity: /\\[\da-f]{1,8}/i,
        unit: H,
        number: AA
      });
    })(t);
  }
  return cssExtras_1;
}
var csv_1, hasRequiredCsv;
function requireCsv() {
  if (hasRequiredCsv) return csv_1;
  hasRequiredCsv = 1, csv_1 = n, n.displayName = "csv", n.aliases = [];
  function n(t) {
    t.languages.csv = {
      value: /[^\r\n,"]+|"(?:[^"]|"")*"(?!")/,
      punctuation: /,/
    };
  }
  return csv_1;
}
var cypher_1, hasRequiredCypher;
function requireCypher() {
  if (hasRequiredCypher) return cypher_1;
  hasRequiredCypher = 1, cypher_1 = n, n.displayName = "cypher", n.aliases = [];
  function n(t) {
    t.languages.cypher = {
      // https://neo4j.com/docs/cypher-manual/current/syntax/comments/
      comment: /\/\/.*/,
      string: {
        pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/,
        greedy: !0
      },
      "class-name": {
        pattern: /(:\s*)(?:\w+|`(?:[^`\\\r\n])*`)(?=\s*[{):])/,
        lookbehind: !0,
        greedy: !0
      },
      relationship: {
        pattern: /(-\[\s*(?:\w+\s*|`(?:[^`\\\r\n])*`\s*)?:\s*|\|\s*:\s*)(?:\w+|`(?:[^`\\\r\n])*`)/,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      identifier: {
        pattern: /`(?:[^`\\\r\n])*`/,
        greedy: !0
      },
      variable: /\$\w+/,
      // https://neo4j.com/docs/cypher-manual/current/syntax/reserved/
      keyword: /\b(?:ADD|ALL|AND|AS|ASC|ASCENDING|ASSERT|BY|CALL|CASE|COMMIT|CONSTRAINT|CONTAINS|CREATE|CSV|DELETE|DESC|DESCENDING|DETACH|DISTINCT|DO|DROP|ELSE|END|ENDS|EXISTS|FOR|FOREACH|IN|INDEX|IS|JOIN|KEY|LIMIT|LOAD|MANDATORY|MATCH|MERGE|NODE|NOT|OF|ON|OPTIONAL|OR|ORDER(?=\s+BY)|PERIODIC|REMOVE|REQUIRE|RETURN|SCALAR|SCAN|SET|SKIP|START|STARTS|THEN|UNION|UNIQUE|UNWIND|USING|WHEN|WHERE|WITH|XOR|YIELD)\b/i,
      function: /\b\w+\b(?=\s*\()/,
      boolean: /\b(?:false|null|true)\b/i,
      number: /\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)\b/,
      // https://neo4j.com/docs/cypher-manual/current/syntax/operators/
      operator: /:|<--?|--?>?|<>|=~?|[<>]=?|[+*/%^|]|\.\.\.?/,
      punctuation: /[()[\]{},;.]/
    };
  }
  return cypher_1;
}
var d_1, hasRequiredD;
function requireD() {
  if (hasRequiredD) return d_1;
  hasRequiredD = 1, d_1 = n, n.displayName = "d", n.aliases = [];
  function n(t) {
    t.languages.d = t.languages.extend("clike", {
      comment: [
        {
          // Shebang
          pattern: /^\s*#!.+/,
          greedy: !0
        },
        {
          pattern: RegExp(
            /(^|[^\\])/.source + "(?:" + [
              // /+ comment +/
              // Allow one level of nesting
              /\/\+(?:\/\+(?:[^+]|\+(?!\/))*\+\/|(?!\/\+)[\s\S])*?\+\//.source,
              // // comment
              /\/\/.*/.source,
              // /* comment */
              /\/\*[\s\S]*?\*\//.source
            ].join("|") + ")"
          ),
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: [
        {
          pattern: RegExp(
            [
              // r"", x""
              /\b[rx]"(?:\\[\s\S]|[^\\"])*"[cwd]?/.source,
              // q"[]", q"()", q"<>", q"{}"
              /\bq"(?:\[[\s\S]*?\]|\([\s\S]*?\)|<[\s\S]*?>|\{[\s\S]*?\})"/.source,
              // q"IDENT
              // ...
              // IDENT"
              /\bq"((?!\d)\w+)$[\s\S]*?^\1"/.source,
              // q"//", q"||", etc.
              // eslint-disable-next-line regexp/strict
              /\bq"(.)[\s\S]*?\2"/.source,
              // eslint-disable-next-line regexp/strict
              /(["`])(?:\\[\s\S]|(?!\3)[^\\])*\3[cwd]?/.source
            ].join("|"),
            "m"
          ),
          greedy: !0
        },
        {
          pattern: /\bq\{(?:\{[^{}]*\}|[^{}])*\}/,
          greedy: !0,
          alias: "token-string"
        }
      ],
      // In order: $, keywords and special tokens, globally defined symbols
      keyword: /\$|\b(?:__(?:(?:DATE|EOF|FILE|FUNCTION|LINE|MODULE|PRETTY_FUNCTION|TIMESTAMP|TIME|VENDOR|VERSION)__|gshared|parameters|traits|vector)|abstract|alias|align|asm|assert|auto|body|bool|break|byte|case|cast|catch|cdouble|cent|cfloat|char|class|const|continue|creal|dchar|debug|default|delegate|delete|deprecated|do|double|dstring|else|enum|export|extern|false|final|finally|float|for|foreach|foreach_reverse|function|goto|idouble|if|ifloat|immutable|import|inout|int|interface|invariant|ireal|lazy|long|macro|mixin|module|new|nothrow|null|out|override|package|pragma|private|protected|ptrdiff_t|public|pure|real|ref|return|scope|shared|short|size_t|static|string|struct|super|switch|synchronized|template|this|throw|true|try|typedef|typeid|typeof|ubyte|ucent|uint|ulong|union|unittest|ushort|version|void|volatile|wchar|while|with|wstring)\b/,
      number: [
        // The lookbehind and the negative look-ahead try to prevent bad highlighting of the .. operator
        // Hexadecimal numbers must be handled separately to avoid problems with exponent "e"
        /\b0x\.?[a-f\d_]+(?:(?!\.\.)\.[a-f\d_]*)?(?:p[+-]?[a-f\d_]+)?[ulfi]{0,4}/i,
        {
          pattern: /((?:\.\.)?)(?:\b0b\.?|\b|\.)\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:e[+-]?\d[\d_]*)?[ulfi]{0,4}/i,
          lookbehind: !0
        }
      ],
      operator: /\|[|=]?|&[&=]?|\+[+=]?|-[-=]?|\.?\.\.|=[>=]?|!(?:i[ns]\b|<>?=?|>=?|=)?|\bi[ns]\b|(?:<[<>]?|>>?>?|\^\^|[*\/%^~])=?/
    }), t.languages.insertBefore("d", "string", {
      // Characters
      // 'a', '\\', '\n', '\xFF', '\377', '\uFFFF', '\U0010FFFF', '\quot'
      char: /'(?:\\(?:\W|\w+)|[^\\])'/
    }), t.languages.insertBefore("d", "keyword", {
      property: /\B@\w*/
    }), t.languages.insertBefore("d", "function", {
      register: {
        // Iasm registers
        pattern: /\b(?:[ABCD][LHX]|E?(?:BP|DI|SI|SP)|[BS]PL|[ECSDGF]S|CR[0234]|[DS]IL|DR[012367]|E[ABCD]X|X?MM[0-7]|R(?:1[0-5]|[89])[BWD]?|R[ABCD]X|R[BS]P|R[DS]I|TR[3-7]|XMM(?:1[0-5]|[89])|YMM(?:1[0-5]|\d))\b|\bST(?:\([0-7]\)|\b)/,
        alias: "variable"
      }
    });
  }
  return d_1;
}
var dart_1, hasRequiredDart;
function requireDart() {
  if (hasRequiredDart) return dart_1;
  hasRequiredDart = 1, dart_1 = n, n.displayName = "dart", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = [
        /\b(?:async|sync|yield)\*/,
        /\b(?:abstract|assert|async|await|break|case|catch|class|const|continue|covariant|default|deferred|do|dynamic|else|enum|export|extends|extension|external|factory|final|finally|for|get|hide|if|implements|import|in|interface|library|mixin|new|null|on|operator|part|rethrow|return|set|show|static|super|switch|sync|this|throw|try|typedef|var|void|while|with|yield)\b/
      ], k = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, H = {
        pattern: RegExp(k + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
        lookbehind: !0,
        inside: {
          namespace: {
            pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
            inside: {
              punctuation: /\./
            }
          }
        }
      };
      g.languages.dart = g.languages.extend("clike", {
        "class-name": [
          H,
          {
            // variables and parameters
            // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
            pattern: RegExp(
              k + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source
            ),
            lookbehind: !0,
            inside: H.inside
          }
        ],
        keyword: d,
        operator: /\bis!|\b(?:as|is)\b|\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?/
      }), g.languages.insertBefore("dart", "string", {
        "string-literal": {
          pattern: /r?(?:("""|''')[\s\S]*?\1|(["'])(?:\\.|(?!\2)[^\\\r\n])*\2(?!\2))/,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
              lookbehind: !0,
              inside: {
                punctuation: /^\$\{?|\}$/,
                expression: {
                  pattern: /[\s\S]+/,
                  inside: g.languages.dart
                }
              }
            },
            string: /[\s\S]+/
          }
        },
        string: void 0
      }), g.languages.insertBefore("dart", "class-name", {
        metadata: {
          pattern: /@\w+/,
          alias: "function"
        }
      }), g.languages.insertBefore("dart", "class-name", {
        generics: {
          pattern: /<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<[\w\s,.&?]*>)*>)*>)*>/,
          inside: {
            "class-name": H,
            keyword: d,
            punctuation: /[<>(),.:]/,
            operator: /[?&|]/
          }
        }
      });
    })(t);
  }
  return dart_1;
}
var dataweave_1, hasRequiredDataweave;
function requireDataweave() {
  if (hasRequiredDataweave) return dataweave_1;
  hasRequiredDataweave = 1, dataweave_1 = n, n.displayName = "dataweave", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.dataweave = {
        url: /\b[A-Za-z]+:\/\/[\w/:.?=&-]+|\burn:[\w:.?=&-]+/,
        property: {
          pattern: /(?:\b\w+#)?(?:"(?:\\.|[^\\"\r\n])*"|\b\w+)(?=\s*[:@])/,
          greedy: !0
        },
        string: {
          pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
          greedy: !0
        },
        "mime-type": /\b(?:application|audio|image|multipart|text|video)\/[\w+-]+/,
        date: {
          pattern: /\|[\w:+-]+\|/,
          greedy: !0
        },
        comment: [
          {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        regex: {
          pattern: /\/(?:[^\\\/\r\n]|\\[^\r\n])+\//,
          greedy: !0
        },
        keyword: /\b(?:and|as|at|case|do|else|fun|if|input|is|match|not|ns|null|or|output|type|unless|update|using|var)\b/,
        function: /\b[A-Z_]\w*(?=\s*\()/i,
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        punctuation: /[{}[\];(),.:@]/,
        operator: /<<|>>|->|[<>~=]=?|!=|--?-?|\+\+?|!|\?/,
        boolean: /\b(?:false|true)\b/
      };
    })(t);
  }
  return dataweave_1;
}
var dax_1, hasRequiredDax;
function requireDax() {
  if (hasRequiredDax) return dax_1;
  hasRequiredDax = 1, dax_1 = n, n.displayName = "dax", n.aliases = [];
  function n(t) {
    t.languages.dax = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/).*)/,
        lookbehind: !0
      },
      "data-field": {
        pattern: /'(?:[^']|'')*'(?!')(?:\[[ \w\xA0-\uFFFF]+\])?|\w+\[[ \w\xA0-\uFFFF]+\]/,
        alias: "symbol"
      },
      measure: {
        pattern: /\[[ \w\xA0-\uFFFF]+\]/,
        alias: "constant"
      },
      string: {
        pattern: /"(?:[^"]|"")*"(?!")/,
        greedy: !0
      },
      function: /\b(?:ABS|ACOS|ACOSH|ACOT|ACOTH|ADDCOLUMNS|ADDMISSINGITEMS|ALL|ALLCROSSFILTERED|ALLEXCEPT|ALLNOBLANKROW|ALLSELECTED|AND|APPROXIMATEDISTINCTCOUNT|ASIN|ASINH|ATAN|ATANH|AVERAGE|AVERAGEA|AVERAGEX|BETA\.DIST|BETA\.INV|BLANK|CALCULATE|CALCULATETABLE|CALENDAR|CALENDARAUTO|CEILING|CHISQ\.DIST|CHISQ\.DIST\.RT|CHISQ\.INV|CHISQ\.INV\.RT|CLOSINGBALANCEMONTH|CLOSINGBALANCEQUARTER|CLOSINGBALANCEYEAR|COALESCE|COMBIN|COMBINA|COMBINEVALUES|CONCATENATE|CONCATENATEX|CONFIDENCE\.NORM|CONFIDENCE\.T|CONTAINS|CONTAINSROW|CONTAINSSTRING|CONTAINSSTRINGEXACT|CONVERT|COS|COSH|COT|COTH|COUNT|COUNTA|COUNTAX|COUNTBLANK|COUNTROWS|COUNTX|CROSSFILTER|CROSSJOIN|CURRENCY|CURRENTGROUP|CUSTOMDATA|DATATABLE|DATE|DATEADD|DATEDIFF|DATESBETWEEN|DATESINPERIOD|DATESMTD|DATESQTD|DATESYTD|DATEVALUE|DAY|DEGREES|DETAILROWS|DISTINCT|DISTINCTCOUNT|DISTINCTCOUNTNOBLANK|DIVIDE|EARLIER|EARLIEST|EDATE|ENDOFMONTH|ENDOFQUARTER|ENDOFYEAR|EOMONTH|ERROR|EVEN|EXACT|EXCEPT|EXP|EXPON\.DIST|FACT|FALSE|FILTER|FILTERS|FIND|FIRSTDATE|FIRSTNONBLANK|FIRSTNONBLANKVALUE|FIXED|FLOOR|FORMAT|GCD|GENERATE|GENERATEALL|GENERATESERIES|GEOMEAN|GEOMEANX|GROUPBY|HASONEFILTER|HASONEVALUE|HOUR|IF|IF\.EAGER|IFERROR|IGNORE|INT|INTERSECT|ISBLANK|ISCROSSFILTERED|ISEMPTY|ISERROR|ISEVEN|ISFILTERED|ISINSCOPE|ISLOGICAL|ISNONTEXT|ISNUMBER|ISO\.CEILING|ISODD|ISONORAFTER|ISSELECTEDMEASURE|ISSUBTOTAL|ISTEXT|KEEPFILTERS|KEYWORDMATCH|LASTDATE|LASTNONBLANK|LASTNONBLANKVALUE|LCM|LEFT|LEN|LN|LOG|LOG10|LOOKUPVALUE|LOWER|MAX|MAXA|MAXX|MEDIAN|MEDIANX|MID|MIN|MINA|MINUTE|MINX|MOD|MONTH|MROUND|NATURALINNERJOIN|NATURALLEFTOUTERJOIN|NEXTDAY|NEXTMONTH|NEXTQUARTER|NEXTYEAR|NONVISUAL|NORM\.DIST|NORM\.INV|NORM\.S\.DIST|NORM\.S\.INV|NOT|NOW|ODD|OPENINGBALANCEMONTH|OPENINGBALANCEQUARTER|OPENINGBALANCEYEAR|OR|PARALLELPERIOD|PATH|PATHCONTAINS|PATHITEM|PATHITEMREVERSE|PATHLENGTH|PERCENTILE\.EXC|PERCENTILE\.INC|PERCENTILEX\.EXC|PERCENTILEX\.INC|PERMUT|PI|POISSON\.DIST|POWER|PREVIOUSDAY|PREVIOUSMONTH|PREVIOUSQUARTER|PREVIOUSYEAR|PRODUCT|PRODUCTX|QUARTER|QUOTIENT|RADIANS|RAND|RANDBETWEEN|RANK\.EQ|RANKX|RELATED|RELATEDTABLE|REMOVEFILTERS|REPLACE|REPT|RIGHT|ROLLUP|ROLLUPADDISSUBTOTAL|ROLLUPGROUP|ROLLUPISSUBTOTAL|ROUND|ROUNDDOWN|ROUNDUP|ROW|SAMEPERIODLASTYEAR|SAMPLE|SEARCH|SECOND|SELECTCOLUMNS|SELECTEDMEASURE|SELECTEDMEASUREFORMATSTRING|SELECTEDMEASURENAME|SELECTEDVALUE|SIGN|SIN|SINH|SQRT|SQRTPI|STARTOFMONTH|STARTOFQUARTER|STARTOFYEAR|STDEV\.P|STDEV\.S|STDEVX\.P|STDEVX\.S|SUBSTITUTE|SUBSTITUTEWITHINDEX|SUM|SUMMARIZE|SUMMARIZECOLUMNS|SUMX|SWITCH|T\.DIST|T\.DIST\.2T|T\.DIST\.RT|T\.INV|T\.INV\.2T|TAN|TANH|TIME|TIMEVALUE|TODAY|TOPN|TOPNPERLEVEL|TOPNSKIP|TOTALMTD|TOTALQTD|TOTALYTD|TREATAS|TRIM|TRUE|TRUNC|UNICHAR|UNICODE|UNION|UPPER|USERELATIONSHIP|USERNAME|USEROBJECTID|USERPRINCIPALNAME|UTCNOW|UTCTODAY|VALUE|VALUES|VAR\.P|VAR\.S|VARX\.P|VARX\.S|WEEKDAY|WEEKNUM|XIRR|XNPV|YEAR|YEARFRAC)(?=\s*\()/i,
      keyword: /\b(?:DEFINE|EVALUATE|MEASURE|ORDER\s+BY|RETURN|VAR|START\s+AT|ASC|DESC)\b/i,
      boolean: {
        pattern: /\b(?:FALSE|NULL|TRUE)\b/i,
        alias: "constant"
      },
      number: /\b\d+(?:\.\d*)?|\B\.\d+\b/,
      operator: /:=|[-+*\/=^]|&&?|\|\||<(?:=>?|<|>)?|>[>=]?|\b(?:IN|NOT)\b/i,
      punctuation: /[;\[\](){}`,.]/
    };
  }
  return dax_1;
}
var dhall_1, hasRequiredDhall;
function requireDhall() {
  if (hasRequiredDhall) return dhall_1;
  hasRequiredDhall = 1, dhall_1 = n, n.displayName = "dhall", n.aliases = [];
  function n(t) {
    t.languages.dhall = {
      // Multi-line comments can be nested. E.g. {- foo {- bar -} -}
      // The multi-line pattern is essentially this:
      //   \{-(?:[^-{]|-(?!\})|\{(?!-)|<SELF>)*-\}
      comment: /--.*|\{-(?:[^-{]|-(?!\})|\{(?!-)|\{-(?:[^-{]|-(?!\})|\{(?!-))*-\})*-\}/,
      string: {
        pattern: /"(?:[^"\\]|\\.)*"|''(?:[^']|'(?!')|'''|''\$\{)*''(?!'|\$)/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\$\{[^{}]*\}/,
            inside: {
              expression: {
                pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                lookbehind: !0,
                alias: "language-dhall",
                inside: null
                // see blow
              },
              punctuation: /\$\{|\}/
            }
          }
        }
      },
      label: {
        pattern: /`[^`]*`/,
        greedy: !0
      },
      url: {
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L596
        pattern: /\bhttps?:\/\/[\w.:%!$&'*+;=@~-]+(?:\/[\w.:%!$&'*+;=@~-]*)*(?:\?[/?\w.:%!$&'*+;=@~-]*)?/,
        greedy: !0
      },
      env: {
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L661
        pattern: /\benv:(?:(?!\d)\w+|"(?:[^"\\=]|\\.)*")/,
        greedy: !0,
        inside: {
          function: /^env/,
          operator: /^:/,
          variable: /[\s\S]+/
        }
      },
      hash: {
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L725
        pattern: /\bsha256:[\da-fA-F]{64}\b/,
        inside: {
          function: /sha256/,
          operator: /:/,
          number: /[\da-fA-F]{64}/
        }
      },
      // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L359
      keyword: /\b(?:as|assert|else|forall|if|in|let|merge|missing|then|toMap|using|with)\b|\u2200/,
      builtin: /\b(?:None|Some)\b/,
      boolean: /\b(?:False|True)\b/,
      number: /\bNaN\b|-?\bInfinity\b|[+-]?\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/,
      operator: /\/\\|\/\/\\\\|&&|\|\||===|[!=]=|\/\/|->|\+\+|::|[+*#@=:?<>|\\\u2227\u2a53\u2261\u2afd\u03bb\u2192]/,
      punctuation: /\.\.|[{}\[\](),./]/,
      // we'll just assume that every capital word left is a type name
      "class-name": /\b[A-Z]\w*\b/
    }, t.languages.dhall.string.inside.interpolation.inside.expression.inside = t.languages.dhall;
  }
  return dhall_1;
}
var diff_1, hasRequiredDiff;
function requireDiff() {
  if (hasRequiredDiff) return diff_1;
  hasRequiredDiff = 1, diff_1 = n, n.displayName = "diff", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.diff = {
        coord: [
          // Match all kinds of coord lines (prefixed by "+++", "---" or "***").
          /^(?:\*{3}|-{3}|\+{3}).*$/m,
          // Match "@@ ... @@" coord lines in unified diff.
          /^@@.*@@$/m,
          // Match coord lines in normal diff (starts with a number).
          /^\d.*$/m
        ]
        // deleted, inserted, unchanged, diff
      };
      var d = {
        "deleted-sign": "-",
        "deleted-arrow": "<",
        "inserted-sign": "+",
        "inserted-arrow": ">",
        unchanged: " ",
        diff: "!"
      };
      Object.keys(d).forEach(function(k) {
        var H = d[k], AA = [];
        /^\w+$/.test(k) || AA.push(/\w+/.exec(k)[0]), k === "diff" && AA.push("bold"), g.languages.diff[k] = {
          pattern: RegExp(
            "^(?:[" + H + `].*(?:\r
?|
|(?![\\s\\S])))+`,
            "m"
          ),
          alias: AA,
          inside: {
            line: {
              pattern: /(.)(?=[\s\S]).*(?:\r\n?|\n)?/,
              lookbehind: !0
            },
            prefix: {
              pattern: /[\s\S]/,
              alias: /\w+/.exec(k)[0]
            }
          }
        };
      }), Object.defineProperty(g.languages.diff, "PREFIXES", {
        value: d
      });
    })(t);
  }
  return diff_1;
}
var markupTemplating_1, hasRequiredMarkupTemplating;
function requireMarkupTemplating() {
  if (hasRequiredMarkupTemplating) return markupTemplating_1;
  hasRequiredMarkupTemplating = 1, markupTemplating_1 = n, n.displayName = "markupTemplating", n.aliases = [];
  function n(t) {
    (function(g) {
      function d(k, H) {
        return "___" + k.toUpperCase() + H + "___";
      }
      Object.defineProperties(g.languages["markup-templating"] = {}, {
        buildPlaceholders: {
          /**
           * Tokenize all inline templating expressions matching `placeholderPattern`.
           *
           * If `replaceFilter` is provided, only matches of `placeholderPattern` for which `replaceFilter` returns
           * `true` will be replaced.
           *
           * @param {object} env The environment of the `before-tokenize` hook.
           * @param {string} language The language id.
           * @param {RegExp} placeholderPattern The matches of this pattern will be replaced by placeholders.
           * @param {(match: string) => boolean} [replaceFilter]
           */
          value: function(k, H, AA, gA) {
            if (k.language === H) {
              var IA = k.tokenStack = [];
              k.code = k.code.replace(AA, function(CA) {
                if (typeof gA == "function" && !gA(CA))
                  return CA;
                for (var BA = IA.length, eA; k.code.indexOf(eA = d(H, BA)) !== -1; )
                  ++BA;
                return IA[BA] = CA, eA;
              }), k.grammar = g.languages.markup;
            }
          }
        },
        tokenizePlaceholders: {
          /**
           * Replace placeholders with proper tokens after tokenizing.
           *
           * @param {object} env The environment of the `after-tokenize` hook.
           * @param {string} language The language id.
           */
          value: function(k, H) {
            if (k.language !== H || !k.tokenStack)
              return;
            k.grammar = g.languages[H];
            var AA = 0, gA = Object.keys(k.tokenStack);
            function IA(CA) {
              for (var BA = 0; BA < CA.length && !(AA >= gA.length); BA++) {
                var eA = CA[BA];
                if (typeof eA == "string" || eA.content && typeof eA.content == "string") {
                  var iA = gA[AA], QA = k.tokenStack[iA], tA = typeof eA == "string" ? eA : eA.content, oA = d(H, iA), EA = tA.indexOf(oA);
                  if (EA > -1) {
                    ++AA;
                    var aA = tA.substring(0, EA), nA = new g.Token(
                      H,
                      g.tokenize(QA, k.grammar),
                      "language-" + H,
                      QA
                    ), lA = tA.substring(EA + oA.length), cA = [];
                    aA && cA.push.apply(cA, IA([aA])), cA.push(nA), lA && cA.push.apply(cA, IA([lA])), typeof eA == "string" ? CA.splice.apply(CA, [BA, 1].concat(cA)) : eA.content = cA;
                  }
                } else eA.content && IA(eA.content);
              }
              return CA;
            }
            IA(k.tokens);
          }
        }
      });
    })(t);
  }
  return markupTemplating_1;
}
var django_1, hasRequiredDjango;
function requireDjango() {
  if (hasRequiredDjango) return django_1;
  hasRequiredDjango = 1;
  var n = requireMarkupTemplating();
  django_1 = t, t.displayName = "django", t.aliases = ["jinja2"];
  function t(g) {
    g.register(n), (function(d) {
      d.languages.django = {
        comment: /^\{#[\s\S]*?#\}$/,
        tag: {
          pattern: /(^\{%[+-]?\s*)\w+/,
          lookbehind: !0,
          alias: "keyword"
        },
        delimiter: {
          pattern: /^\{[{%][+-]?|[+-]?[}%]\}$/,
          alias: "punctuation"
        },
        string: {
          pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
          greedy: !0
        },
        filter: {
          pattern: /(\|)\w+/,
          lookbehind: !0,
          alias: "function"
        },
        test: {
          pattern: /(\bis\s+(?:not\s+)?)(?!not\b)\w+/,
          lookbehind: !0,
          alias: "function"
        },
        function: /\b[a-z_]\w+(?=\s*\()/i,
        keyword: /\b(?:and|as|by|else|for|if|import|in|is|loop|not|or|recursive|with|without)\b/,
        operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        number: /\b\d+(?:\.\d+)?\b/,
        boolean: /[Ff]alse|[Nn]one|[Tt]rue/,
        variable: /\b\w+\b/,
        punctuation: /[{}[\](),.:;]/
      };
      var k = /\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}|\{#[\s\S]*?#\}/g, H = d.languages["markup-templating"];
      d.hooks.add("before-tokenize", function(AA) {
        H.buildPlaceholders(AA, "django", k);
      }), d.hooks.add("after-tokenize", function(AA) {
        H.tokenizePlaceholders(AA, "django");
      }), d.languages.jinja2 = d.languages.django, d.hooks.add("before-tokenize", function(AA) {
        H.buildPlaceholders(AA, "jinja2", k);
      }), d.hooks.add("after-tokenize", function(AA) {
        H.tokenizePlaceholders(AA, "jinja2");
      });
    })(g);
  }
  return django_1;
}
var dnsZoneFile_1, hasRequiredDnsZoneFile;
function requireDnsZoneFile() {
  if (hasRequiredDnsZoneFile) return dnsZoneFile_1;
  hasRequiredDnsZoneFile = 1, dnsZoneFile_1 = n, n.displayName = "dnsZoneFile", n.aliases = [];
  function n(t) {
    t.languages["dns-zone-file"] = {
      comment: /;.*/,
      string: {
        pattern: /"(?:\\.|[^"\\\r\n])*"/,
        greedy: !0
      },
      variable: [
        {
          pattern: /(^\$ORIGIN[ \t]+)\S+/m,
          lookbehind: !0
        },
        {
          pattern: /(^|\s)@(?=\s|$)/,
          lookbehind: !0
        }
      ],
      keyword: /^\$(?:INCLUDE|ORIGIN|TTL)(?=\s|$)/m,
      class: {
        // https://tools.ietf.org/html/rfc1035#page-13
        pattern: /(^|\s)(?:CH|CS|HS|IN)(?=\s|$)/,
        lookbehind: !0,
        alias: "keyword"
      },
      type: {
        // https://en.wikipedia.org/wiki/List_of_DNS_record_types
        pattern: /(^|\s)(?:A|A6|AAAA|AFSDB|APL|ATMA|CAA|CDNSKEY|CDS|CERT|CNAME|DHCID|DLV|DNAME|DNSKEY|DS|EID|GID|GPOS|HINFO|HIP|IPSECKEY|ISDN|KEY|KX|LOC|MAILA|MAILB|MB|MD|MF|MG|MINFO|MR|MX|NAPTR|NB|NBSTAT|NIMLOC|NINFO|NS|NSAP|NSAP-PTR|NSEC|NSEC3|NSEC3PARAM|NULL|NXT|OPENPGPKEY|PTR|PX|RKEY|RP|RRSIG|RT|SIG|SINK|SMIMEA|SOA|SPF|SRV|SSHFP|TA|TKEY|TLSA|TSIG|TXT|UID|UINFO|UNSPEC|URI|WKS|X25)(?=\s|$)/,
        lookbehind: !0,
        alias: "keyword"
      },
      punctuation: /[()]/
    }, t.languages["dns-zone"] = t.languages["dns-zone-file"];
  }
  return dnsZoneFile_1;
}
var docker_1, hasRequiredDocker;
function requireDocker() {
  if (hasRequiredDocker) return docker_1;
  hasRequiredDocker = 1, docker_1 = n, n.displayName = "docker", n.aliases = ["dockerfile"];
  function n(t) {
    (function(g) {
      var d = /\\[\r\n](?:\s|\\[\r\n]|#.*(?!.))*(?![\s#]|\\[\r\n])/.source, k = /(?:[ \t]+(?![ \t])(?:<SP_BS>)?|<SP_BS>)/.source.replace(
        /<SP_BS>/g,
        function() {
          return d;
        }
      ), H = /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"|'(?:[^'\\\r\n]|\\(?:\r\n|[\s\S]))*'/.source, AA = /--[\w-]+=(?:<STR>|(?!["'])(?:[^\s\\]|\\.)+)/.source.replace(
        /<STR>/g,
        function() {
          return H;
        }
      ), gA = {
        pattern: RegExp(H),
        greedy: !0
      }, IA = {
        pattern: /(^[ \t]*)#.*/m,
        lookbehind: !0,
        greedy: !0
      };
      function CA(BA, eA) {
        return BA = BA.replace(/<OPT>/g, function() {
          return AA;
        }).replace(/<SP>/g, function() {
          return k;
        }), RegExp(BA, eA);
      }
      g.languages.docker = {
        instruction: {
          pattern: /(^[ \t]*)(?:ADD|ARG|CMD|COPY|ENTRYPOINT|ENV|EXPOSE|FROM|HEALTHCHECK|LABEL|MAINTAINER|ONBUILD|RUN|SHELL|STOPSIGNAL|USER|VOLUME|WORKDIR)(?=\s)(?:\\.|[^\r\n\\])*(?:\\$(?:\s|#.*$)*(?![\s#])(?:\\.|[^\r\n\\])*)*/im,
          lookbehind: !0,
          greedy: !0,
          inside: {
            options: {
              pattern: CA(
                /(^(?:ONBUILD<SP>)?\w+<SP>)<OPT>(?:<SP><OPT>)*/.source,
                "i"
              ),
              lookbehind: !0,
              greedy: !0,
              inside: {
                property: {
                  pattern: /(^|\s)--[\w-]+/,
                  lookbehind: !0
                },
                string: [
                  gA,
                  {
                    pattern: /(=)(?!["'])(?:[^\s\\]|\\.)+/,
                    lookbehind: !0
                  }
                ],
                operator: /\\$/m,
                punctuation: /=/
              }
            },
            keyword: [
              {
                // https://docs.docker.com/engine/reference/builder/#healthcheck
                pattern: CA(
                  /(^(?:ONBUILD<SP>)?HEALTHCHECK<SP>(?:<OPT><SP>)*)(?:CMD|NONE)\b/.source,
                  "i"
                ),
                lookbehind: !0,
                greedy: !0
              },
              {
                // https://docs.docker.com/engine/reference/builder/#from
                pattern: CA(
                  /(^(?:ONBUILD<SP>)?FROM<SP>(?:<OPT><SP>)*(?!--)[^ \t\\]+<SP>)AS/.source,
                  "i"
                ),
                lookbehind: !0,
                greedy: !0
              },
              {
                // https://docs.docker.com/engine/reference/builder/#onbuild
                pattern: CA(/(^ONBUILD<SP>)\w+/.source, "i"),
                lookbehind: !0,
                greedy: !0
              },
              {
                pattern: /^\w+/,
                greedy: !0
              }
            ],
            comment: IA,
            string: gA,
            variable: /\$(?:\w+|\{[^{}"'\\]*\})/,
            operator: /\\$/m
          }
        },
        comment: IA
      }, g.languages.dockerfile = g.languages.docker;
    })(t);
  }
  return docker_1;
}
var dot_1, hasRequiredDot;
function requireDot() {
  if (hasRequiredDot) return dot_1;
  hasRequiredDot = 1, dot_1 = n, n.displayName = "dot", n.aliases = ["gv"];
  function n(t) {
    (function(g) {
      var d = "(?:" + [
        // an identifier
        /[a-zA-Z_\x80-\uFFFF][\w\x80-\uFFFF]*/.source,
        // a number
        /-?(?:\.\d+|\d+(?:\.\d*)?)/.source,
        // a double-quoted string
        /"[^"\\]*(?:\\[\s\S][^"\\]*)*"/.source,
        // HTML-like string
        /<(?:[^<>]|(?!<!--)<(?:[^<>"']|"[^"]*"|'[^']*')+>|<!--(?:[^-]|-(?!->))*-->)*>/.source
      ].join("|") + ")", k = {
        markup: {
          pattern: /(^<)[\s\S]+(?=>$)/,
          lookbehind: !0,
          alias: ["language-markup", "language-html", "language-xml"],
          inside: g.languages.markup
        }
      };
      function H(AA, gA) {
        return RegExp(
          AA.replace(/<ID>/g, function() {
            return d;
          }),
          gA
        );
      }
      g.languages.dot = {
        comment: {
          pattern: /\/\/.*|\/\*[\s\S]*?\*\/|^#.*/m,
          greedy: !0
        },
        "graph-name": {
          pattern: H(
            /(\b(?:digraph|graph|subgraph)[ \t\r\n]+)<ID>/.source,
            "i"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "class-name",
          inside: k
        },
        "attr-value": {
          pattern: H(/(=[ \t\r\n]*)<ID>/.source),
          lookbehind: !0,
          greedy: !0,
          inside: k
        },
        "attr-name": {
          pattern: H(/([\[;, \t\r\n])<ID>(?=[ \t\r\n]*=)/.source),
          lookbehind: !0,
          greedy: !0,
          inside: k
        },
        keyword: /\b(?:digraph|edge|graph|node|strict|subgraph)\b/i,
        "compass-point": {
          pattern: /(:[ \t\r\n]*)(?:[ewc_]|[ns][ew]?)(?![\w\x80-\uFFFF])/,
          lookbehind: !0,
          alias: "builtin"
        },
        node: {
          pattern: H(/(^|[^-.\w\x80-\uFFFF\\])<ID>/.source),
          lookbehind: !0,
          greedy: !0,
          inside: k
        },
        operator: /[=:]|-[->]/,
        punctuation: /[\[\]{};,]/
      }, g.languages.gv = g.languages.dot;
    })(t);
  }
  return dot_1;
}
var ebnf_1, hasRequiredEbnf;
function requireEbnf() {
  if (hasRequiredEbnf) return ebnf_1;
  hasRequiredEbnf = 1, ebnf_1 = n, n.displayName = "ebnf", n.aliases = [];
  function n(t) {
    t.languages.ebnf = {
      comment: /\(\*[\s\S]*?\*\)/,
      string: {
        pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
        greedy: !0
      },
      special: {
        pattern: /\?[^?\r\n]*\?/,
        greedy: !0,
        alias: "class-name"
      },
      definition: {
        pattern: /^([\t ]*)[a-z]\w*(?:[ \t]+[a-z]\w*)*(?=\s*=)/im,
        lookbehind: !0,
        alias: ["rule", "keyword"]
      },
      rule: /\b[a-z]\w*(?:[ \t]+[a-z]\w*)*\b/i,
      punctuation: /\([:/]|[:/]\)|[.,;()[\]{}]/,
      operator: /[-=|*/!]/
    };
  }
  return ebnf_1;
}
var editorconfig_1, hasRequiredEditorconfig;
function requireEditorconfig() {
  if (hasRequiredEditorconfig) return editorconfig_1;
  hasRequiredEditorconfig = 1, editorconfig_1 = n, n.displayName = "editorconfig", n.aliases = [];
  function n(t) {
    t.languages.editorconfig = {
      // https://editorconfig-specification.readthedocs.io
      comment: /[;#].*/,
      section: {
        pattern: /(^[ \t]*)\[.+\]/m,
        lookbehind: !0,
        alias: "selector",
        inside: {
          regex: /\\\\[\[\]{},!?.*]/,
          // Escape special characters with '\\'
          operator: /[!?]|\.\.|\*{1,2}/,
          punctuation: /[\[\]{},]/
        }
      },
      key: {
        pattern: /(^[ \t]*)[^\s=]+(?=[ \t]*=)/m,
        lookbehind: !0,
        alias: "attr-name"
      },
      value: {
        pattern: /=.*/,
        alias: "attr-value",
        inside: {
          punctuation: /^=/
        }
      }
    };
  }
  return editorconfig_1;
}
var eiffel_1, hasRequiredEiffel;
function requireEiffel() {
  if (hasRequiredEiffel) return eiffel_1;
  hasRequiredEiffel = 1, eiffel_1 = n, n.displayName = "eiffel", n.aliases = [];
  function n(t) {
    t.languages.eiffel = {
      comment: /--.*/,
      string: [
        // Aligned-verbatim-strings
        {
          pattern: /"([^[]*)\[[\s\S]*?\]\1"/,
          greedy: !0
        },
        // Non-aligned-verbatim-strings
        {
          pattern: /"([^{]*)\{[\s\S]*?\}\1"/,
          greedy: !0
        },
        // Single-line string
        {
          pattern: /"(?:%(?:(?!\n)\s)*\n\s*%|%\S|[^%"\r\n])*"/,
          greedy: !0
        }
      ],
      // normal char | special char | char code
      char: /'(?:%.|[^%'\r\n])+'/,
      keyword: /\b(?:across|agent|alias|all|and|as|assign|attached|attribute|check|class|convert|create|Current|debug|deferred|detachable|do|else|elseif|end|ensure|expanded|export|external|feature|from|frozen|if|implies|inherit|inspect|invariant|like|local|loop|not|note|obsolete|old|once|or|Precursor|redefine|rename|require|rescue|Result|retry|select|separate|some|then|undefine|until|variant|Void|when|xor)\b/i,
      boolean: /\b(?:False|True)\b/i,
      // Convention: class-names are always all upper-case characters
      "class-name": /\b[A-Z][\dA-Z_]*\b/,
      number: [
        // hexa | octal | bin
        /\b0[xcb][\da-f](?:_*[\da-f])*\b/i,
        // Decimal
        /(?:\b\d(?:_*\d)*)?\.(?:(?:\d(?:_*\d)*)?e[+-]?)?\d(?:_*\d)*\b|\b\d(?:_*\d)*\b\.?/i
      ],
      punctuation: /:=|<<|>>|\(\||\|\)|->|\.(?=\w)|[{}[\];(),:?]/,
      operator: /\\\\|\|\.\.\||\.\.|\/[~\/=]?|[><]=?|[-+*^=~]/
    };
  }
  return eiffel_1;
}
var ejs_1, hasRequiredEjs;
function requireEjs() {
  if (hasRequiredEjs) return ejs_1;
  hasRequiredEjs = 1;
  var n = requireMarkupTemplating();
  ejs_1 = t, t.displayName = "ejs", t.aliases = ["eta"];
  function t(g) {
    g.register(n), (function(d) {
      d.languages.ejs = {
        delimiter: {
          pattern: /^<%[-_=]?|[-_]?%>$/,
          alias: "punctuation"
        },
        comment: /^#[\s\S]*/,
        "language-javascript": {
          pattern: /[\s\S]+/,
          inside: d.languages.javascript
        }
      }, d.hooks.add("before-tokenize", function(k) {
        var H = /<%(?!%)[\s\S]+?%>/g;
        d.languages["markup-templating"].buildPlaceholders(
          k,
          "ejs",
          H
        );
      }), d.hooks.add("after-tokenize", function(k) {
        d.languages["markup-templating"].tokenizePlaceholders(k, "ejs");
      }), d.languages.eta = d.languages.ejs;
    })(g);
  }
  return ejs_1;
}
var elixir_1, hasRequiredElixir;
function requireElixir() {
  if (hasRequiredElixir) return elixir_1;
  hasRequiredElixir = 1, elixir_1 = n, n.displayName = "elixir", n.aliases = [];
  function n(t) {
    t.languages.elixir = {
      doc: {
        pattern: /@(?:doc|moduledoc)\s+(?:("""|''')[\s\S]*?\1|("|')(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2)/,
        inside: {
          attribute: /^@\w+/,
          string: /['"][\s\S]+/
        }
      },
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      // ~r"""foo""" (multi-line), ~r'''foo''' (multi-line), ~r/foo/, ~r|foo|, ~r"foo", ~r'foo', ~r(foo), ~r[foo], ~r{foo}, ~r<foo>
      regex: {
        pattern: /~[rR](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|[^\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[uismxfr]*/,
        greedy: !0
      },
      string: [
        {
          // ~s"""foo""" (multi-line), ~s'''foo''' (multi-line), ~s/foo/, ~s|foo|, ~s"foo", ~s'foo', ~s(foo), ~s[foo], ~s{foo} (with interpolation care), ~s<foo>
          pattern: /~[cCsSwW](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|#\{[^}]+\}|#(?!\{)|[^#\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[csa]?/,
          greedy: !0,
          inside: {
            // See interpolation below
          }
        },
        {
          pattern: /("""|''')[\s\S]*?\1/,
          greedy: !0,
          inside: {
            // See interpolation below
          }
        },
        {
          // Multi-line strings are allowed
          pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
          greedy: !0,
          inside: {
            // See interpolation below
          }
        }
      ],
      atom: {
        // Look-behind prevents bad highlighting of the :: operator
        pattern: /(^|[^:]):\w+/,
        lookbehind: !0,
        alias: "symbol"
      },
      module: {
        pattern: /\b[A-Z]\w*\b/,
        alias: "class-name"
      },
      // Look-ahead prevents bad highlighting of the :: operator
      "attr-name": /\b\w+\??:(?!:)/,
      argument: {
        // Look-behind prevents bad highlighting of the && operator
        pattern: /(^|[^&])&\d+/,
        lookbehind: !0,
        alias: "variable"
      },
      attribute: {
        pattern: /@\w+/,
        alias: "variable"
      },
      function: /\b[_a-zA-Z]\w*[?!]?(?:(?=\s*(?:\.\s*)?\()|(?=\/\d))/,
      number: /\b(?:0[box][a-f\d_]+|\d[\d_]*)(?:\.[\d_]+)?(?:e[+-]?[\d_]+)?\b/i,
      keyword: /\b(?:after|alias|and|case|catch|cond|def(?:callback|delegate|exception|impl|macro|module|n|np|p|protocol|struct)?|do|else|end|fn|for|if|import|not|or|quote|raise|require|rescue|try|unless|unquote|use|when)\b/,
      boolean: /\b(?:false|nil|true)\b/,
      operator: [
        /\bin\b|&&?|\|[|>]?|\\\\|::|\.\.\.?|\+\+?|-[->]?|<[-=>]|>=|!==?|\B!|=(?:==?|[>~])?|[*\/^]/,
        {
          // We don't want to match <<
          pattern: /([^<])<(?!<)/,
          lookbehind: !0
        },
        {
          // We don't want to match >>
          pattern: /([^>])>(?!>)/,
          lookbehind: !0
        }
      ],
      punctuation: /<<|>>|[.,%\[\]{}()]/
    }, t.languages.elixir.string.forEach(function(g) {
      g.inside = {
        interpolation: {
          pattern: /#\{[^}]+\}/,
          inside: {
            delimiter: {
              pattern: /^#\{|\}$/,
              alias: "punctuation"
            },
            rest: t.languages.elixir
          }
        }
      };
    });
  }
  return elixir_1;
}
var elm_1, hasRequiredElm;
function requireElm() {
  if (hasRequiredElm) return elm_1;
  hasRequiredElm = 1, elm_1 = n, n.displayName = "elm", n.aliases = [];
  function n(t) {
    t.languages.elm = {
      comment: /--.*|\{-[\s\S]*?-\}/,
      char: {
        pattern: /'(?:[^\\'\r\n]|\\(?:[abfnrtv\\']|\d+|x[0-9a-fA-F]+|u\{[0-9a-fA-F]+\}))'/,
        greedy: !0
      },
      string: [
        {
          // Multiline strings are wrapped in triple ". Quotes may appear unescaped.
          pattern: /"""[\s\S]*?"""/,
          greedy: !0
        },
        {
          pattern: /"(?:[^\\"\r\n]|\\.)*"/,
          greedy: !0
        }
      ],
      "import-statement": {
        // The imported or hidden names are not included in this import
        // statement. This is because we want to highlight those exactly like
        // we do for the names in the program.
        pattern: /(^[\t ]*)import\s+[A-Z]\w*(?:\.[A-Z]\w*)*(?:\s+as\s+(?:[A-Z]\w*)(?:\.[A-Z]\w*)*)?(?:\s+exposing\s+)?/m,
        lookbehind: !0,
        inside: {
          keyword: /\b(?:as|exposing|import)\b/
        }
      },
      keyword: /\b(?:alias|as|case|else|exposing|if|in|infixl|infixr|let|module|of|then|type)\b/,
      // These are builtin variables only. Constructors are highlighted later as a constant.
      builtin: /\b(?:abs|acos|always|asin|atan|atan2|ceiling|clamp|compare|cos|curry|degrees|e|flip|floor|fromPolar|identity|isInfinite|isNaN|logBase|max|min|negate|never|not|pi|radians|rem|round|sin|sqrt|tan|toFloat|toPolar|toString|truncate|turns|uncurry|xor)\b/,
      // decimal integers and floating point numbers | hexadecimal integers
      number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[0-9a-f]+)\b/i,
      // Most of this is needed because of the meaning of a single '.'.
      // If it stands alone freely, it is the function composition.
      // It may also be a separator between a module name and an identifier => no
      // operator. If it comes together with other special characters it is an
      // operator too.
      // Valid operator characters in 0.18: +-/*=.$<>:&|^?%#@~!
      // Ref: https://groups.google.com/forum/#!msg/elm-dev/0AHSnDdkSkQ/E0SVU70JEQAJ
      operator: /\s\.\s|[+\-/*=.$<>:&|^?%#@~!]{2,}|[+\-/*=$<>:&|^?%#@~!]/,
      // In Elm, nearly everything is a variable, do not highlight these.
      hvariable: /\b(?:[A-Z]\w*\.)*[a-z]\w*\b/,
      constant: /\b(?:[A-Z]\w*\.)*[A-Z]\w*\b/,
      punctuation: /[{}[\]|(),.:]/
    };
  }
  return elm_1;
}
var erb_1, hasRequiredErb;
function requireErb() {
  if (hasRequiredErb) return erb_1;
  hasRequiredErb = 1;
  var n = requireRuby(), t = requireMarkupTemplating();
  erb_1 = g, g.displayName = "erb", g.aliases = [];
  function g(d) {
    d.register(n), d.register(t), (function(k) {
      k.languages.erb = {
        delimiter: {
          pattern: /^(\s*)<%=?|%>(?=\s*$)/,
          lookbehind: !0,
          alias: "punctuation"
        },
        ruby: {
          pattern: /\s*\S[\s\S]*/,
          alias: "language-ruby",
          inside: k.languages.ruby
        }
      }, k.hooks.add("before-tokenize", function(H) {
        var AA = /<%=?(?:[^\r\n]|[\r\n](?!=begin)|[\r\n]=begin\s(?:[^\r\n]|[\r\n](?!=end))*[\r\n]=end)+?%>/g;
        k.languages["markup-templating"].buildPlaceholders(
          H,
          "erb",
          AA
        );
      }), k.hooks.add("after-tokenize", function(H) {
        k.languages["markup-templating"].tokenizePlaceholders(H, "erb");
      });
    })(d);
  }
  return erb_1;
}
var erlang_1, hasRequiredErlang;
function requireErlang() {
  if (hasRequiredErlang) return erlang_1;
  hasRequiredErlang = 1, erlang_1 = n, n.displayName = "erlang", n.aliases = [];
  function n(t) {
    t.languages.erlang = {
      comment: /%.+/,
      string: {
        pattern: /"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      "quoted-function": {
        pattern: /'(?:\\.|[^\\'\r\n])+'(?=\()/,
        alias: "function"
      },
      "quoted-atom": {
        pattern: /'(?:\\.|[^\\'\r\n])+'/,
        alias: "atom"
      },
      boolean: /\b(?:false|true)\b/,
      keyword: /\b(?:after|case|catch|end|fun|if|of|receive|try|when)\b/,
      number: [
        /\$\\?./,
        /\b\d+#[a-z0-9]+/i,
        /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i
      ],
      function: /\b[a-z][\w@]*(?=\()/,
      variable: {
        // Look-behind is used to prevent wrong highlighting of atoms containing "@"
        pattern: /(^|[^@])(?:\b|\?)[A-Z_][\w@]*/,
        lookbehind: !0
      },
      operator: [
        /[=\/<>:]=|=[:\/]=|\+\+?|--?|[=*\/!]|\b(?:and|andalso|band|bnot|bor|bsl|bsr|bxor|div|not|or|orelse|rem|xor)\b/,
        {
          // We don't want to match <<
          pattern: /(^|[^<])<(?!<)/,
          lookbehind: !0
        },
        {
          // We don't want to match >>
          pattern: /(^|[^>])>(?!>)/,
          lookbehind: !0
        }
      ],
      atom: /\b[a-z][\w@]*/,
      punctuation: /[()[\]{}:;,.#|]|<<|>>/
    };
  }
  return erlang_1;
}
var lua_1, hasRequiredLua;
function requireLua() {
  if (hasRequiredLua) return lua_1;
  hasRequiredLua = 1, lua_1 = n, n.displayName = "lua", n.aliases = [];
  function n(t) {
    t.languages.lua = {
      comment: /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,
      // \z may be used to skip the following space
      string: {
        pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,
        greedy: !0
      },
      number: /\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,
      keyword: /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,
      function: /(?!\d)\w+(?=\s*(?:[({]))/,
      operator: [
        /[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/,
        {
          // Match ".." but don't break "..."
          pattern: /(^|[^.])\.\.(?!\.)/,
          lookbehind: !0
        }
      ],
      punctuation: /[\[\](){},;]|\.+|:+/
    };
  }
  return lua_1;
}
var etlua_1, hasRequiredEtlua;
function requireEtlua() {
  if (hasRequiredEtlua) return etlua_1;
  hasRequiredEtlua = 1;
  var n = requireLua(), t = requireMarkupTemplating();
  etlua_1 = g, g.displayName = "etlua", g.aliases = [];
  function g(d) {
    d.register(n), d.register(t), (function(k) {
      k.languages.etlua = {
        delimiter: {
          pattern: /^<%[-=]?|-?%>$/,
          alias: "punctuation"
        },
        "language-lua": {
          pattern: /[\s\S]+/,
          inside: k.languages.lua
        }
      }, k.hooks.add("before-tokenize", function(H) {
        var AA = /<%[\s\S]+?%>/g;
        k.languages["markup-templating"].buildPlaceholders(
          H,
          "etlua",
          AA
        );
      }), k.hooks.add("after-tokenize", function(H) {
        k.languages["markup-templating"].tokenizePlaceholders(H, "etlua");
      });
    })(d);
  }
  return etlua_1;
}
var excelFormula_1, hasRequiredExcelFormula;
function requireExcelFormula() {
  if (hasRequiredExcelFormula) return excelFormula_1;
  hasRequiredExcelFormula = 1, excelFormula_1 = n, n.displayName = "excelFormula", n.aliases = [];
  function n(t) {
    t.languages["excel-formula"] = {
      comment: {
        pattern: /(\bN\(\s*)"(?:[^"]|"")*"(?=\s*\))/i,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"]|"")*"(?!")/,
        greedy: !0
      },
      reference: {
        // https://www.ablebits.com/office-addins-blog/2015/12/08/excel-reference-another-sheet-workbook/
        // Sales!B2
        // 'Winter sales'!B2
        // [Sales.xlsx]Jan!B2:B5
        // D:\Reports\[Sales.xlsx]Jan!B2:B5
        // '[Sales.xlsx]Jan sales'!B2:B5
        // 'D:\Reports\[Sales.xlsx]Jan sales'!B2:B5
        pattern: /(?:'[^']*'|(?:[^\s()[\]{}<>*?"';,$&]*\[[^^\s()[\]{}<>*?"']+\])?\w+)!/,
        greedy: !0,
        alias: "string",
        inside: {
          operator: /!$/,
          punctuation: /'/,
          sheet: {
            pattern: /[^[\]]+$/,
            alias: "function"
          },
          file: {
            pattern: /\[[^[\]]+\]$/,
            inside: {
              punctuation: /[[\]]/
            }
          },
          path: /[\s\S]+/
        }
      },
      "function-name": {
        pattern: /\b[A-Z]\w*(?=\()/i,
        alias: "keyword"
      },
      range: {
        pattern: /\$?\b(?:[A-Z]+\$?\d+:\$?[A-Z]+\$?\d+|[A-Z]+:\$?[A-Z]+|\d+:\$?\d+)\b/i,
        alias: "property",
        inside: {
          operator: /:/,
          cell: /\$?[A-Z]+\$?\d+/i,
          column: /\$?[A-Z]+/i,
          row: /\$?\d+/
        }
      },
      cell: {
        // Excel is case insensitive, so the string "foo1" could be either a variable or a cell.
        // To combat this, we match cells case insensitive, if the contain at least one "$", and case sensitive otherwise.
        pattern: /\b[A-Z]+\d+\b|\$[A-Za-z]+\$?\d+\b|\b[A-Za-z]+\$\d+\b/,
        alias: "property"
      },
      number: /(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?\b/i,
      boolean: /\b(?:FALSE|TRUE)\b/i,
      operator: /[-+*/^%=&,]|<[=>]?|>=?/,
      punctuation: /[[\]();{}|]/
    }, t.languages.xlsx = t.languages.xls = t.languages["excel-formula"];
  }
  return excelFormula_1;
}
var factor_1, hasRequiredFactor;
function requireFactor() {
  if (hasRequiredFactor) return factor_1;
  hasRequiredFactor = 1, factor_1 = n, n.displayName = "factor", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = {
        function: /\b(?:BUGS?|FIX(?:MES?)?|NOTES?|TODOS?|XX+|HACKS?|WARN(?:ING)?|\?{2,}|!{2,})\b/
      }, k = {
        number: /\\[^\s']|%\w/
      }, H = {
        comment: [
          {
            // ! single-line exclamation point comments with whitespace after/around the !
            pattern: /(^|\s)(?:! .*|!$)/,
            lookbehind: !0,
            inside: d
          },
          /* from basis/multiline: */
          {
            // /* comment */, /* comment*/
            pattern: /(^|\s)\/\*\s[\s\S]*?\*\/(?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            inside: d
          },
          {
            // ![[ comment ]] , ![===[ comment]===]
            pattern: /(^|\s)!\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            inside: d
          }
        ],
        number: [
          {
            // basic base 10 integers 9, -9
            pattern: /(^|\s)[+-]?\d+(?=\s|$)/,
            lookbehind: !0
          },
          {
            // base prefix integers 0b010 0o70 0xad 0d10 0XAD -0xa9
            pattern: /(^|\s)[+-]?0(?:b[01]+|o[0-7]+|d\d+|x[\dA-F]+)(?=\s|$)/i,
            lookbehind: !0
          },
          {
            // fractional ratios 1/5 -1/5 and the literal float approximations 1/5. -1/5.
            pattern: /(^|\s)[+-]?\d+\/\d+\.?(?=\s|$)/,
            lookbehind: !0
          },
          {
            // positive mixed numbers 23+1/5 +23+1/5
            pattern: /(^|\s)\+?\d+\+\d+\/\d+(?=\s|$)/,
            lookbehind: !0
          },
          {
            // negative mixed numbers -23-1/5
            pattern: /(^|\s)-\d+-\d+\/\d+(?=\s|$)/,
            lookbehind: !0
          },
          {
            // basic decimal floats -0.01 0. .0 .1 -.1 -1. -12.13 +12.13
            // and scientific notation with base 10 exponents 3e4 3e-4 .3e-4
            pattern: /(^|\s)[+-]?(?:\d*\.\d+|\d+\.\d*|\d+)(?:e[+-]?\d+)?(?=\s|$)/i,
            lookbehind: !0
          },
          {
            // NAN literal syntax NAN: 80000deadbeef, NAN: a
            pattern: /(^|\s)NAN:\s+[\da-fA-F]+(?=\s|$)/,
            lookbehind: !0
          },
          {
            /*
            base prefix floats 0x1.0p3 (8.0) 0b1.010p2 (5.0) 0x1.p1 0b1.11111111p11111...
            "The normalized hex form ±0x1.MMMMMMMMMMMMM[pP]±EEEE allows any floating-point number to be specified precisely.
            The values of MMMMMMMMMMMMM and EEEE map directly to the mantissa and exponent fields of the binary IEEE 754 representation."
            <https://docs.factorcode.org/content/article-syntax-floats.html>
            */
            pattern: /(^|\s)[+-]?0(?:b1\.[01]*|o1\.[0-7]*|d1\.\d*|x1\.[\dA-F]*)p\d+(?=\s|$)/i,
            lookbehind: !0
          }
        ],
        // R/ regexp?\/\\/
        regexp: {
          pattern: /(^|\s)R\/\s(?:\\\S|[^\\/])*\/(?:[idmsr]*|[idmsr]+-[idmsr]+)(?=\s|$)/,
          lookbehind: !0,
          alias: "number",
          inside: {
            variable: /\\\S/,
            keyword: /[+?*\[\]^$(){}.|]/,
            operator: {
              pattern: /(\/)[idmsr]+(?:-[idmsr]+)?/,
              lookbehind: !0
            }
          }
        },
        boolean: {
          pattern: /(^|\s)[tf](?=\s|$)/,
          lookbehind: !0
        },
        // SBUF" asd", URL" ://...", P" /etc/"
        "custom-string": {
          pattern: /(^|\s)[A-Z0-9\-]+"\s(?:\\\S|[^"\\])*"/,
          lookbehind: !0,
          greedy: !0,
          alias: "string",
          inside: {
            number: /\\\S|%\w|\//
          }
        },
        "multiline-string": [
          {
            // STRING: name \n content \n ; -> CONSTANT: name "content" (symbol)
            pattern: /(^|\s)STRING:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*;(?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            alias: "string",
            inside: {
              number: k.number,
              // trailing semicolon on its own line
              "semicolon-or-setlocal": {
                pattern: /([\r\n][ \t]*);(?=\s|$)/,
                lookbehind: !0,
                alias: "function"
              }
            }
          },
          {
            // HEREDOC: marker \n content \n marker ; -> "content" (immediate)
            pattern: /(^|\s)HEREDOC:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*\S+(?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            alias: "string",
            inside: k
          },
          {
            // [[ string ]], [==[ string]==]
            pattern: /(^|\s)\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            alias: "string",
            inside: k
          }
        ],
        "special-using": {
          pattern: /(^|\s)USING:(?:\s\S+)*(?=\s+;(?:\s|$))/,
          lookbehind: !0,
          alias: "function",
          inside: {
            // this is essentially a regex for vocab names, which i don't want to specify
            // but the USING: gets picked up as a vocab name
            string: {
              pattern: /(\s)[^:\s]+/,
              lookbehind: !0
            }
          }
        },
        /* this description of stack effect literal syntax is not complete and not as specific as theoretically possible
        trying to do better is more work and regex-computation-time than it's worth though.
        - we'd like to have the "delimiter" parts of the stack effect [ (, --, and ) ] be a different (less-important or comment-like) colour to the stack effect contents
        - we'd like if nested stack effects were treated as such rather than just appearing flat (with `inside`)
        - we'd like if the following variable name conventions were recognised specifically:
        special row variables = ..a b..
        type and stack effect annotations end with a colon = ( quot: ( a: ( -- ) -- b ) -- x ), ( x: number -- )
        word throws unconditional error = *
        any other word-like variable name = a ? q' etc
        https://docs.factorcode.org/content/article-effects.html
        these are pretty complicated to highlight properly without a real parser, and therefore out of scope
        the old pattern, which may be later useful, was: (^|\s)(?:call|execute|eval)?\((?:\s+[^"\r\n\t ]\S*)*?\s+--(?:\s+[^"\n\t ]\S*)*?\s+\)(?=\s|$)
        */
        // current solution is not great
        "stack-effect-delimiter": [
          {
            // opening parenthesis
            pattern: /(^|\s)(?:call|eval|execute)?\((?=\s)/,
            lookbehind: !0,
            alias: "operator"
          },
          {
            // middle --
            pattern: /(\s)--(?=\s)/,
            lookbehind: !0,
            alias: "operator"
          },
          {
            // closing parenthesis
            pattern: /(\s)\)(?=\s|$)/,
            lookbehind: !0,
            alias: "operator"
          }
        ],
        combinators: {
          pattern: null,
          lookbehind: !0,
          alias: "keyword"
        },
        "kernel-builtin": {
          pattern: null,
          lookbehind: !0,
          alias: "variable"
        },
        "sequences-builtin": {
          pattern: null,
          lookbehind: !0,
          alias: "variable"
        },
        "math-builtin": {
          pattern: null,
          lookbehind: !0,
          alias: "variable"
        },
        "constructor-word": {
          // <array> but not <=>
          pattern: /(^|\s)<(?!=+>|-+>)\S+>(?=\s|$)/,
          lookbehind: !0,
          alias: "keyword"
        },
        "other-builtin-syntax": {
          pattern: null,
          lookbehind: !0,
          alias: "operator"
        },
        /*
        full list of supported word naming conventions: (the convention appears outside of the [brackets])
        set-[x]
        change-[x]
        with-[x]
        new-[x]
        >[string]
        [base]>
        [string]>[number]
        +[symbol]+
        [boolean-word]?
        ?[of]
        [slot-reader]>>
        >>[slot-setter]
        [slot-writer]<<
        ([implementation-detail])
        [mutater]!
        [variant]*
        [prettyprint].
        $[help-markup]
        <constructors>, SYNTAX:, etc are supported by their own patterns.
        `with` and `new` from `kernel` are their own builtins.
        see <https://docs.factorcode.org/content/article-conventions.html>
        */
        "conventionally-named-word": {
          pattern: /(^|\s)(?!")(?:(?:change|new|set|with)-\S+|\$\S+|>[^>\s]+|[^:>\s]+>|[^>\s]+>[^>\s]+|\+[^+\s]+\+|[^?\s]+\?|\?[^?\s]+|[^>\s]+>>|>>[^>\s]+|[^<\s]+<<|\([^()\s]+\)|[^!\s]+!|[^*\s]\S*\*|[^.\s]\S*\.)(?=\s|$)/,
          lookbehind: !0,
          alias: "keyword"
        },
        "colon-syntax": {
          pattern: /(^|\s)(?:[A-Z0-9\-]+#?)?:{1,2}\s+(?:;\S+|(?!;)\S+)(?=\s|$)/,
          lookbehind: !0,
          greedy: !0,
          alias: "function"
        },
        "semicolon-or-setlocal": {
          pattern: /(\s)(?:;|:>)(?=\s|$)/,
          lookbehind: !0,
          alias: "function"
        },
        // do not highlight leading } or trailing X{ at the begin/end of the file as it's invalid syntax
        "curly-brace-literal-delimiter": [
          {
            // opening
            pattern: /(^|\s)[a-z]*\{(?=\s)/i,
            lookbehind: !0,
            alias: "operator"
          },
          {
            // closing
            pattern: /(\s)\}(?=\s|$)/,
            lookbehind: !0,
            alias: "operator"
          }
        ],
        // do not highlight leading ] or trailing [ at the begin/end of the file as it's invalid syntax
        "quotation-delimiter": [
          {
            // opening
            pattern: /(^|\s)\[(?=\s)/,
            lookbehind: !0,
            alias: "operator"
          },
          {
            // closing
            pattern: /(\s)\](?=\s|$)/,
            lookbehind: !0,
            alias: "operator"
          }
        ],
        "normal-word": {
          pattern: /(^|\s)[^"\s]\S*(?=\s|$)/,
          lookbehind: !0
        },
        /*
        basic first-class string "a"
        with escaped double-quote "a\""
        escaped backslash "\\"
        and general escapes since Factor has so many "\N"
        syntax that works in the reference implementation that isn't fully
        supported because it's an implementation detail:
        "string 1""string 2" -> 2 strings (works anyway)
        "string"5 -> string, 5
        "string"[ ] -> string, quotation
        { "a"} -> array<string>
        the rest of those examples all properly recognise the string, but not
        the other object (number, quotation, etc)
        this is fine for a regex-only implementation.
        */
        string: {
          pattern: /"(?:\\\S|[^"\\])*"/,
          greedy: !0,
          inside: k
        }
      }, AA = function(BA) {
        return (BA + "").replace(/([.?*+\^$\[\]\\(){}|\-])/g, "\\$1");
      }, gA = function(BA) {
        return new RegExp("(^|\\s)(?:" + BA.map(AA).join("|") + ")(?=\\s|$)");
      }, IA = {
        "kernel-builtin": [
          "or",
          "2nipd",
          "4drop",
          "tuck",
          "wrapper",
          "nip",
          "wrapper?",
          "callstack>array",
          "die",
          "dupd",
          "callstack",
          "callstack?",
          "3dup",
          "hashcode",
          "pick",
          "4nip",
          "build",
          ">boolean",
          "nipd",
          "clone",
          "5nip",
          "eq?",
          "?",
          "=",
          "swapd",
          "2over",
          "clear",
          "2dup",
          "get-retainstack",
          "not",
          "tuple?",
          "dup",
          "3nipd",
          "call",
          "-rotd",
          "object",
          "drop",
          "assert=",
          "assert?",
          "-rot",
          "execute",
          "boa",
          "get-callstack",
          "curried?",
          "3drop",
          "pickd",
          "overd",
          "over",
          "roll",
          "3nip",
          "swap",
          "and",
          "2nip",
          "rotd",
          "throw",
          "(clone)",
          "hashcode*",
          "spin",
          "reach",
          "4dup",
          "equal?",
          "get-datastack",
          "assert",
          "2drop",
          "<wrapper>",
          "boolean?",
          "identity-hashcode",
          "identity-tuple?",
          "null",
          "composed?",
          "new",
          "5drop",
          "rot",
          "-roll",
          "xor",
          "identity-tuple",
          "boolean"
        ],
        "other-builtin-syntax": [
          // syntax
          "=======",
          "recursive",
          "flushable",
          ">>",
          "<<<<<<",
          "M\\",
          "B",
          "PRIVATE>",
          "\\",
          "======",
          "final",
          "inline",
          "delimiter",
          "deprecated",
          "<PRIVATE",
          ">>>>>>",
          "<<<<<<<",
          "parse-complex",
          "malformed-complex",
          "read-only",
          ">>>>>>>",
          "call-next-method",
          "<<",
          "foldable",
          // literals
          "$",
          "$[",
          "${"
        ],
        "sequences-builtin": [
          "member-eq?",
          "mismatch",
          "append",
          "assert-sequence=",
          "longer",
          "repetition",
          "clone-like",
          "3sequence",
          "assert-sequence?",
          "last-index-from",
          "reversed",
          "index-from",
          "cut*",
          "pad-tail",
          "join-as",
          "remove-eq!",
          "concat-as",
          "but-last",
          "snip",
          "nths",
          "nth",
          "sequence",
          "longest",
          "slice?",
          "<slice>",
          "remove-nth",
          "tail-slice",
          "empty?",
          "tail*",
          "member?",
          "virtual-sequence?",
          "set-length",
          "drop-prefix",
          "iota",
          "unclip",
          "bounds-error?",
          "unclip-last-slice",
          "non-negative-integer-expected",
          "non-negative-integer-expected?",
          "midpoint@",
          "longer?",
          "?set-nth",
          "?first",
          "rest-slice",
          "prepend-as",
          "prepend",
          "fourth",
          "sift",
          "subseq-start",
          "new-sequence",
          "?last",
          "like",
          "first4",
          "1sequence",
          "reverse",
          "slice",
          "virtual@",
          "repetition?",
          "set-last",
          "index",
          "4sequence",
          "max-length",
          "set-second",
          "immutable-sequence",
          "first2",
          "first3",
          "supremum",
          "unclip-slice",
          "suffix!",
          "insert-nth",
          "tail",
          "3append",
          "short",
          "suffix",
          "concat",
          "flip",
          "immutable?",
          "reverse!",
          "2sequence",
          "sum",
          "delete-all",
          "indices",
          "snip-slice",
          "<iota>",
          "check-slice",
          "sequence?",
          "head",
          "append-as",
          "halves",
          "sequence=",
          "collapse-slice",
          "?second",
          "slice-error?",
          "product",
          "bounds-check?",
          "bounds-check",
          "immutable",
          "virtual-exemplar",
          "harvest",
          "remove",
          "pad-head",
          "last",
          "set-fourth",
          "cartesian-product",
          "remove-eq",
          "shorten",
          "shorter",
          "reversed?",
          "shorter?",
          "shortest",
          "head-slice",
          "pop*",
          "tail-slice*",
          "but-last-slice",
          "iota?",
          "append!",
          "cut-slice",
          "new-resizable",
          "head-slice*",
          "sequence-hashcode",
          "pop",
          "set-nth",
          "?nth",
          "second",
          "join",
          "immutable-sequence?",
          "<reversed>",
          "3append-as",
          "virtual-sequence",
          "subseq?",
          "remove-nth!",
          "length",
          "last-index",
          "lengthen",
          "assert-sequence",
          "copy",
          "move",
          "third",
          "first",
          "tail?",
          "set-first",
          "prefix",
          "bounds-error",
          "<repetition>",
          "exchange",
          "surround",
          "cut",
          "min-length",
          "set-third",
          "push-all",
          "head?",
          "subseq-start-from",
          "delete-slice",
          "rest",
          "sum-lengths",
          "head*",
          "infimum",
          "remove!",
          "glue",
          "slice-error",
          "subseq",
          "push",
          "replace-slice",
          "subseq-as",
          "unclip-last"
        ],
        "math-builtin": [
          "number=",
          "next-power-of-2",
          "?1+",
          "fp-special?",
          "imaginary-part",
          "float>bits",
          "number?",
          "fp-infinity?",
          "bignum?",
          "fp-snan?",
          "denominator",
          "gcd",
          "*",
          "+",
          "fp-bitwise=",
          "-",
          "u>=",
          "/",
          ">=",
          "bitand",
          "power-of-2?",
          "log2-expects-positive",
          "neg?",
          "<",
          "log2",
          ">",
          "integer?",
          "number",
          "bits>double",
          "2/",
          "zero?",
          "bits>float",
          "float?",
          "shift",
          "ratio?",
          "rect>",
          "even?",
          "ratio",
          "fp-sign",
          "bitnot",
          ">fixnum",
          "complex?",
          "/i",
          "integer>fixnum",
          "/f",
          "sgn",
          ">bignum",
          "next-float",
          "u<",
          "u>",
          "mod",
          "recip",
          "rational",
          ">float",
          "2^",
          "integer",
          "fixnum?",
          "neg",
          "fixnum",
          "sq",
          "bignum",
          ">rect",
          "bit?",
          "fp-qnan?",
          "simple-gcd",
          "complex",
          "<fp-nan>",
          "real",
          ">fraction",
          "double>bits",
          "bitor",
          "rem",
          "fp-nan-payload",
          "real-part",
          "log2-expects-positive?",
          "prev-float",
          "align",
          "unordered?",
          "float",
          "fp-nan?",
          "abs",
          "bitxor",
          "integer>fixnum-strict",
          "u<=",
          "odd?",
          "<=",
          "/mod",
          ">integer",
          "real?",
          "rational?",
          "numerator"
        ]
        // that's all for now
      };
      Object.keys(IA).forEach(function(BA) {
        H[BA].pattern = gA(IA[BA]);
      });
      var CA = [
        // kernel
        "2bi",
        "while",
        "2tri",
        "bi*",
        "4dip",
        "both?",
        "same?",
        "tri@",
        "curry",
        "prepose",
        "3bi",
        "?if",
        "tri*",
        "2keep",
        "3keep",
        "curried",
        "2keepd",
        "when",
        "2bi*",
        "2tri*",
        "4keep",
        "bi@",
        "keepdd",
        "do",
        "unless*",
        "tri-curry",
        "if*",
        "loop",
        "bi-curry*",
        "when*",
        "2bi@",
        "2tri@",
        "with",
        "2with",
        "either?",
        "bi",
        "until",
        "3dip",
        "3curry",
        "tri-curry*",
        "tri-curry@",
        "bi-curry",
        "keepd",
        "compose",
        "2dip",
        "if",
        "3tri",
        "unless",
        "tuple",
        "keep",
        "2curry",
        "tri",
        "most",
        "while*",
        "dip",
        "composed",
        "bi-curry@",
        // sequences
        "find-last-from",
        "trim-head-slice",
        "map-as",
        "each-from",
        "none?",
        "trim-tail",
        "partition",
        "if-empty",
        "accumulate*",
        "reject!",
        "find-from",
        "accumulate-as",
        "collector-for-as",
        "reject",
        "map",
        "map-sum",
        "accumulate!",
        "2each-from",
        "follow",
        "supremum-by",
        "map!",
        "unless-empty",
        "collector",
        "padding",
        "reduce-index",
        "replicate-as",
        "infimum-by",
        "trim-tail-slice",
        "count",
        "find-index",
        "filter",
        "accumulate*!",
        "reject-as",
        "map-integers",
        "map-find",
        "reduce",
        "selector",
        "interleave",
        "2map",
        "filter-as",
        "binary-reduce",
        "map-index-as",
        "find",
        "produce",
        "filter!",
        "replicate",
        "cartesian-map",
        "cartesian-each",
        "find-index-from",
        "map-find-last",
        "3map-as",
        "3map",
        "find-last",
        "selector-as",
        "2map-as",
        "2map-reduce",
        "accumulate",
        "each",
        "each-index",
        "accumulate*-as",
        "when-empty",
        "all?",
        "collector-as",
        "push-either",
        "new-like",
        "collector-for",
        "2selector",
        "push-if",
        "2all?",
        "map-reduce",
        "3each",
        "any?",
        "trim-slice",
        "2reduce",
        "change-nth",
        "produce-as",
        "2each",
        "trim",
        "trim-head",
        "cartesian-find",
        "map-index",
        // math
        "if-zero",
        "each-integer",
        "unless-zero",
        "(find-integer)",
        "when-zero",
        "find-last-integer",
        "(all-integers?)",
        "times",
        "(each-integer)",
        "find-integer",
        "all-integers?",
        // math.combinators
        "unless-negative",
        "if-positive",
        "when-positive",
        "when-negative",
        "unless-positive",
        "if-negative",
        // combinators
        "case",
        "2cleave",
        "cond>quot",
        "case>quot",
        "3cleave",
        "wrong-values",
        "to-fixed-point",
        "alist>quot",
        "cond",
        "cleave",
        "call-effect",
        "recursive-hashcode",
        "spread",
        "deep-spread>quot",
        // combinators.short-circuit
        "2||",
        "0||",
        "n||",
        "0&&",
        "2&&",
        "3||",
        "1||",
        "1&&",
        "n&&",
        "3&&",
        // combinators.smart
        "smart-unless*",
        "keep-inputs",
        "reduce-outputs",
        "smart-when*",
        "cleave>array",
        "smart-with",
        "smart-apply",
        "smart-if",
        "inputs/outputs",
        "output>sequence-n",
        "map-outputs",
        "map-reduce-outputs",
        "dropping",
        "output>array",
        "smart-map-reduce",
        "smart-2map-reduce",
        "output>array-n",
        "nullary",
        "input<sequence",
        "append-outputs",
        "drop-inputs",
        "inputs",
        "smart-2reduce",
        "drop-outputs",
        "smart-reduce",
        "preserving",
        "smart-when",
        "outputs",
        "append-outputs-as",
        "smart-unless",
        "smart-if*",
        "sum-outputs",
        "input<sequence-unsafe",
        "output>sequence"
        // tafn
      ];
      H.combinators.pattern = gA(CA), g.languages.factor = H;
    })(t);
  }
  return factor_1;
}
var _false, hasRequired_false;
function require_false() {
  if (hasRequired_false) return _false;
  hasRequired_false = 1, _false = n, n.displayName = "$false", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.false = {
        comment: {
          pattern: /\{[^}]*\}/
        },
        string: {
          pattern: /"[^"]*"/,
          greedy: !0
        },
        "character-code": {
          pattern: /'(?:[^\r]|\r\n?)/,
          alias: "number"
        },
        "assembler-code": {
          pattern: /\d+`/,
          alias: "important"
        },
        number: /\d+/,
        operator: /[-!#$%&'*+,./:;=>?@\\^_`|~ßø]/,
        punctuation: /\[|\]/,
        variable: /[a-z]/,
        "non-standard": {
          pattern: /[()<BDO®]/,
          alias: "bold"
        }
      };
    })(t);
  }
  return _false;
}
var firestoreSecurityRules_1, hasRequiredFirestoreSecurityRules;
function requireFirestoreSecurityRules() {
  if (hasRequiredFirestoreSecurityRules) return firestoreSecurityRules_1;
  hasRequiredFirestoreSecurityRules = 1, firestoreSecurityRules_1 = n, n.displayName = "firestoreSecurityRules", n.aliases = [];
  function n(t) {
    t.languages["firestore-security-rules"] = t.languages.extend(
      "clike",
      {
        comment: /\/\/.*/,
        keyword: /\b(?:allow|function|if|match|null|return|rules_version|service)\b/,
        operator: /&&|\|\||[<>!=]=?|[-+*/%]|\b(?:in|is)\b/
      }
    ), delete t.languages["firestore-security-rules"]["class-name"], t.languages.insertBefore("firestore-security-rules", "keyword", {
      path: {
        pattern: /(^|[\s(),])(?:\/(?:[\w\xA0-\uFFFF]+|\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)))+/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          variable: {
            pattern: /\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)/,
            inside: {
              operator: /=/,
              keyword: /\*\*/,
              punctuation: /[.$(){}]/
            }
          },
          punctuation: /\//
        }
      },
      method: {
        // to make the pattern shorter, the actual method names are omitted
        pattern: /(\ballow\s+)[a-z]+(?:\s*,\s*[a-z]+)*(?=\s*[:;])/,
        lookbehind: !0,
        alias: "builtin",
        inside: {
          punctuation: /,/
        }
      }
    });
  }
  return firestoreSecurityRules_1;
}
var flow_1, hasRequiredFlow;
function requireFlow() {
  if (hasRequiredFlow) return flow_1;
  hasRequiredFlow = 1, flow_1 = n, n.displayName = "flow", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.flow = g.languages.extend("javascript", {}), g.languages.insertBefore("flow", "keyword", {
        type: [
          {
            pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|any|mixed|null|void)\b/,
            alias: "tag"
          }
        ]
      }), g.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete g.languages.flow.parameter, g.languages.insertBefore("flow", "operator", {
        "flow-punctuation": {
          pattern: /\{\||\|\}/,
          alias: "punctuation"
        }
      }), Array.isArray(g.languages.flow.keyword) || (g.languages.flow.keyword = [g.languages.flow.keyword]), g.languages.flow.keyword.unshift(
        {
          pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
          lookbehind: !0
        }
      );
    })(t);
  }
  return flow_1;
}
var fortran_1, hasRequiredFortran;
function requireFortran() {
  if (hasRequiredFortran) return fortran_1;
  hasRequiredFortran = 1, fortran_1 = n, n.displayName = "fortran", n.aliases = [];
  function n(t) {
    t.languages.fortran = {
      "quoted-number": {
        pattern: /[BOZ](['"])[A-F0-9]+\1/i,
        alias: "number"
      },
      string: {
        pattern: /(?:\b\w+_)?(['"])(?:\1\1|&(?:\r\n?|\n)(?:[ \t]*!.*(?:\r\n?|\n)|(?![ \t]*!))|(?!\1).)*(?:\1|&)/,
        inside: {
          comment: {
            pattern: /(&(?:\r\n?|\n)\s*)!.*/,
            lookbehind: !0
          }
        }
      },
      comment: {
        pattern: /!.*/,
        greedy: !0
      },
      boolean: /\.(?:FALSE|TRUE)\.(?:_\w+)?/i,
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[ED][+-]?\d+)?(?:_\w+)?/i,
      keyword: [
        // Types
        /\b(?:CHARACTER|COMPLEX|DOUBLE ?PRECISION|INTEGER|LOGICAL|REAL)\b/i,
        // END statements
        /\b(?:END ?)?(?:BLOCK ?DATA|DO|FILE|FORALL|FUNCTION|IF|INTERFACE|MODULE(?! PROCEDURE)|PROGRAM|SELECT|SUBROUTINE|TYPE|WHERE)\b/i,
        // Statements
        /\b(?:ALLOCATABLE|ALLOCATE|BACKSPACE|CALL|CASE|CLOSE|COMMON|CONTAINS|CONTINUE|CYCLE|DATA|DEALLOCATE|DIMENSION|DO|END|EQUIVALENCE|EXIT|EXTERNAL|FORMAT|GO ?TO|IMPLICIT(?: NONE)?|INQUIRE|INTENT|INTRINSIC|MODULE PROCEDURE|NAMELIST|NULLIFY|OPEN|OPTIONAL|PARAMETER|POINTER|PRINT|PRIVATE|PUBLIC|READ|RETURN|REWIND|SAVE|SELECT|STOP|TARGET|WHILE|WRITE)\b/i,
        // Others
        /\b(?:ASSIGNMENT|DEFAULT|ELEMENTAL|ELSE|ELSEIF|ELSEWHERE|ENTRY|IN|INCLUDE|INOUT|KIND|NULL|ONLY|OPERATOR|OUT|PURE|RECURSIVE|RESULT|SEQUENCE|STAT|THEN|USE)\b/i
      ],
      operator: [
        /\*\*|\/\/|=>|[=\/]=|[<>]=?|::|[+\-*=%]|\.[A-Z]+\./i,
        {
          // Use lookbehind to prevent confusion with (/ /)
          pattern: /(^|(?!\().)\/(?!\))/,
          lookbehind: !0
        }
      ],
      punctuation: /\(\/|\/\)|[(),;:&]/
    };
  }
  return fortran_1;
}
var fsharp_1, hasRequiredFsharp;
function requireFsharp() {
  if (hasRequiredFsharp) return fsharp_1;
  hasRequiredFsharp = 1, fsharp_1 = n, n.displayName = "fsharp", n.aliases = [];
  function n(t) {
    t.languages.fsharp = t.languages.extend("clike", {
      comment: [
        {
          pattern: /(^|[^\\])\(\*(?!\))[\s\S]*?\*\)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(?:"""[\s\S]*?"""|@"(?:""|[^"])*"|"(?:\\[\s\S]|[^\\"])*")B?/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:exception|inherit|interface|new|of|type)\s+|\w\s*:\s*|\s:\??>\s*)[.\w]+\b(?:\s*(?:->|\*)\s*[.\w]+\b)*(?!\s*[:.])/,
        lookbehind: !0,
        inside: {
          operator: /->|\*/,
          punctuation: /\./
        }
      },
      keyword: /\b(?:let|return|use|yield)(?:!\B|\b)|\b(?:abstract|and|as|asr|assert|atomic|base|begin|break|checked|class|component|const|constraint|constructor|continue|default|delegate|do|done|downcast|downto|eager|elif|else|end|event|exception|extern|external|false|finally|fixed|for|fun|function|functor|global|if|in|include|inherit|inline|interface|internal|land|lazy|lor|lsl|lsr|lxor|match|member|method|mixin|mod|module|mutable|namespace|new|not|null|object|of|open|or|override|parallel|private|process|protected|public|pure|rec|sealed|select|sig|static|struct|tailcall|then|to|trait|true|try|type|upcast|val|virtual|void|volatile|when|while|with)\b/,
      number: [
        /\b0x[\da-fA-F]+(?:LF|lf|un)?\b/,
        /\b0b[01]+(?:uy|y)?\b/,
        /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[fm]|e[+-]?\d+)?\b/i,
        /\b\d+(?:[IlLsy]|UL|u[lsy]?)?\b/
      ],
      operator: /([<>~&^])\1\1|([*.:<>&])\2|<-|->|[!=:]=|<?\|{1,3}>?|\??(?:<=|>=|<>|[-+*/%=<>])\??|[!?^&]|~[+~-]|:>|:\?>?/
    }), t.languages.insertBefore("fsharp", "keyword", {
      preprocessor: {
        pattern: /(^[\t ]*)#.*/m,
        lookbehind: !0,
        alias: "property",
        inside: {
          directive: {
            pattern: /(^#)\b(?:else|endif|if|light|line|nowarn)\b/,
            lookbehind: !0,
            alias: "keyword"
          }
        }
      }
    }), t.languages.insertBefore("fsharp", "punctuation", {
      "computation-expression": {
        pattern: /\b[_a-z]\w*(?=\s*\{)/i,
        alias: "keyword"
      }
    }), t.languages.insertBefore("fsharp", "string", {
      annotation: {
        pattern: /\[<.+?>\]/,
        greedy: !0,
        inside: {
          punctuation: /^\[<|>\]$/,
          "class-name": {
            pattern: /^\w+$|(^|;\s*)[A-Z]\w*(?=\()/,
            lookbehind: !0
          },
          "annotation-content": {
            pattern: /[\s\S]+/,
            inside: t.languages.fsharp
          }
        }
      },
      char: {
        pattern: /'(?:[^\\']|\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8}))'B?/,
        greedy: !0
      }
    });
  }
  return fsharp_1;
}
var ftl_1, hasRequiredFtl;
function requireFtl() {
  if (hasRequiredFtl) return ftl_1;
  hasRequiredFtl = 1;
  var n = requireMarkupTemplating();
  ftl_1 = t, t.displayName = "ftl", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      for (var k = /[^<()"']|\((?:<expr>)*\)|<(?!#--)|<#--(?:[^-]|-(?!->))*-->|"(?:[^\\"]|\\.)*"|'(?:[^\\']|\\.)*'/.source, H = 0; H < 2; H++)
        k = k.replace(/<expr>/g, function() {
          return k;
        });
      k = k.replace(/<expr>/g, /[^\s\S]/.source);
      var AA = {
        comment: /<#--[\s\S]*?-->/,
        string: [
          {
            // raw string
            pattern: /\br("|')(?:(?!\1)[^\\]|\\.)*\1/,
            greedy: !0
          },
          {
            pattern: RegExp(
              /("|')(?:(?!\1|\$\{)[^\\]|\\.|\$\{(?:(?!\})(?:<expr>))*\})*\1/.source.replace(
                /<expr>/g,
                function() {
                  return k;
                }
              )
            ),
            greedy: !0,
            inside: {
              interpolation: {
                pattern: RegExp(
                  /((?:^|[^\\])(?:\\\\)*)\$\{(?:(?!\})(?:<expr>))*\}/.source.replace(
                    /<expr>/g,
                    function() {
                      return k;
                    }
                  )
                ),
                lookbehind: !0,
                inside: {
                  "interpolation-punctuation": {
                    pattern: /^\$\{|\}$/,
                    alias: "punctuation"
                  },
                  rest: null
                }
              }
            }
          }
        ],
        keyword: /\b(?:as)\b/,
        boolean: /\b(?:false|true)\b/,
        "builtin-function": {
          pattern: /((?:^|[^?])\?\s*)\w+/,
          lookbehind: !0,
          alias: "function"
        },
        function: /\b\w+(?=\s*\()/,
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /\.\.[<*!]?|->|--|\+\+|&&|\|\||\?{1,2}|[-+*/%!=<>]=?|\b(?:gt|gte|lt|lte)\b/,
        punctuation: /[,;.:()[\]{}]/
      };
      AA.string[1].inside.interpolation.inside.rest = AA, d.languages.ftl = {
        "ftl-comment": {
          // the pattern is shortened to be more efficient
          pattern: /^<#--[\s\S]*/,
          alias: "comment"
        },
        "ftl-directive": {
          pattern: /^<[\s\S]+>$/,
          inside: {
            directive: {
              pattern: /(^<\/?)[#@][a-z]\w*/i,
              lookbehind: !0,
              alias: "keyword"
            },
            punctuation: /^<\/?|\/?>$/,
            content: {
              pattern: /\s*\S[\s\S]*/,
              alias: "ftl",
              inside: AA
            }
          }
        },
        "ftl-interpolation": {
          pattern: /^\$\{[\s\S]*\}$/,
          inside: {
            punctuation: /^\$\{|\}$/,
            content: {
              pattern: /\s*\S[\s\S]*/,
              alias: "ftl",
              inside: AA
            }
          }
        }
      }, d.hooks.add("before-tokenize", function(gA) {
        var IA = RegExp(
          /<#--[\s\S]*?-->|<\/?[#@][a-zA-Z](?:<expr>)*?>|\$\{(?:<expr>)*?\}/.source.replace(
            /<expr>/g,
            function() {
              return k;
            }
          ),
          "gi"
        );
        d.languages["markup-templating"].buildPlaceholders(
          gA,
          "ftl",
          IA
        );
      }), d.hooks.add("after-tokenize", function(gA) {
        d.languages["markup-templating"].tokenizePlaceholders(gA, "ftl");
      });
    })(g);
  }
  return ftl_1;
}
var gap_1, hasRequiredGap;
function requireGap() {
  if (hasRequiredGap) return gap_1;
  hasRequiredGap = 1, gap_1 = n, n.displayName = "gap", n.aliases = [];
  function n(t) {
    t.languages.gap = {
      shell: {
        pattern: /^gap>[\s\S]*?(?=^gap>|$(?![\s\S]))/m,
        greedy: !0,
        inside: {
          gap: {
            pattern: /^(gap>).+(?:(?:\r(?:\n|(?!\n))|\n)>.*)*/,
            lookbehind: !0,
            inside: null
            // see below
          },
          punctuation: /^gap>/
        }
      },
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\'"])(?:'(?:[^\r\n\\']|\\.){1,10}'|"(?:[^\r\n\\"]|\\.)*"(?!")|"""[\s\S]*?""")/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          continuation: {
            pattern: /([\r\n])>/,
            lookbehind: !0,
            alias: "punctuation"
          }
        }
      },
      keyword: /\b(?:Assert|Info|IsBound|QUIT|TryNextMethod|Unbind|and|atomic|break|continue|do|elif|else|end|fi|for|function|if|in|local|mod|not|od|or|quit|readonly|readwrite|rec|repeat|return|then|until|while)\b/,
      boolean: /\b(?:false|true)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: {
        pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
        lookbehind: !0
      },
      continuation: {
        pattern: /([\r\n])>/,
        lookbehind: !0,
        alias: "punctuation"
      },
      operator: /->|[-+*/^~=!]|<>|[<>]=?|:=|\.\./,
      punctuation: /[()[\]{},;.:]/
    }, t.languages.gap.shell.inside.gap.inside = t.languages.gap;
  }
  return gap_1;
}
var gcode_1, hasRequiredGcode;
function requireGcode() {
  if (hasRequiredGcode) return gcode_1;
  hasRequiredGcode = 1, gcode_1 = n, n.displayName = "gcode", n.aliases = [];
  function n(t) {
    t.languages.gcode = {
      comment: /;.*|\B\(.*?\)\B/,
      string: {
        pattern: /"(?:""|[^"])*"/,
        greedy: !0
      },
      keyword: /\b[GM]\d+(?:\.\d+)?\b/,
      property: /\b[A-Z]/,
      checksum: {
        pattern: /(\*)\d+/,
        lookbehind: !0,
        alias: "number"
      },
      // T0:0:0
      punctuation: /[:*]/
    };
  }
  return gcode_1;
}
var gdscript_1, hasRequiredGdscript;
function requireGdscript() {
  if (hasRequiredGdscript) return gdscript_1;
  hasRequiredGdscript = 1, gdscript_1 = n, n.displayName = "gdscript", n.aliases = [];
  function n(t) {
    t.languages.gdscript = {
      comment: /#.*/,
      string: {
        pattern: /@?(?:("|')(?:(?!\1)[^\n\\]|\\[\s\S])*\1(?!"|')|"""(?:[^\\]|\\[\s\S])*?""")/,
        greedy: !0
      },
      "class-name": {
        // class_name Foo, extends Bar, class InnerClass
        // export(int) var baz, export(int, 0) var i
        // as Node
        // const FOO: int = 9, var bar: bool = true
        // func add(reference: Item, amount: int) -> Item:
        pattern: /(^(?:class|class_name|extends)[ \t]+|^export\([ \t]*|\bas[ \t]+|(?:\b(?:const|var)[ \t]|[,(])[ \t]*\w+[ \t]*:[ \t]*|->[ \t]*)[a-zA-Z_]\w*/m,
        lookbehind: !0
      },
      keyword: /\b(?:and|as|assert|break|breakpoint|class|class_name|const|continue|elif|else|enum|export|extends|for|func|if|in|is|master|mastersync|match|not|null|onready|or|pass|preload|puppet|puppetsync|remote|remotesync|return|self|setget|signal|static|tool|var|while|yield)\b/,
      function: /\b[a-z_]\w*(?=[ \t]*\()/i,
      variable: /\$\w+/,
      number: [
        /\b0b[01_]+\b|\b0x[\da-fA-F_]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.[\d_]+)(?:e[+-]?[\d_]+)?\b/,
        /\b(?:INF|NAN|PI|TAU)\b/
      ],
      constant: /\b[A-Z][A-Z_\d]*\b/,
      boolean: /\b(?:false|true)\b/,
      operator: /->|:=|&&|\|\||<<|>>|[-+*/%&|!<>=]=?|[~^]/,
      punctuation: /[.:,;()[\]{}]/
    };
  }
  return gdscript_1;
}
var gedcom_1, hasRequiredGedcom;
function requireGedcom() {
  if (hasRequiredGedcom) return gedcom_1;
  hasRequiredGedcom = 1, gedcom_1 = n, n.displayName = "gedcom", n.aliases = [];
  function n(t) {
    t.languages.gedcom = {
      "line-value": {
        // Preceded by level, optional pointer, and tag
        pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?\w+ ).+/m,
        lookbehind: !0,
        inside: {
          pointer: {
            pattern: /^@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@$/,
            alias: "variable"
          }
        }
      },
      tag: {
        // Preceded by level and optional pointer
        pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?)\w+/m,
        lookbehind: !0,
        alias: "string"
      },
      level: {
        pattern: /(^[\t ]*)\d+/m,
        lookbehind: !0,
        alias: "number"
      },
      pointer: {
        pattern: /@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@/,
        alias: "variable"
      }
    };
  }
  return gedcom_1;
}
var gherkin_1, hasRequiredGherkin;
function requireGherkin() {
  if (hasRequiredGherkin) return gherkin_1;
  hasRequiredGherkin = 1, gherkin_1 = n, n.displayName = "gherkin", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /(?:\r?\n|\r)[ \t]*\|.+\|(?:(?!\|).)*/.source;
      g.languages.gherkin = {
        pystring: {
          pattern: /("""|''')[\s\S]+?\1/,
          alias: "string"
        },
        comment: {
          pattern: /(^[ \t]*)#.*/m,
          lookbehind: !0
        },
        tag: {
          pattern: /(^[ \t]*)@\S*/m,
          lookbehind: !0
        },
        feature: {
          pattern: /((?:^|\r?\n|\r)[ \t]*)(?:Ability|Ahoy matey!|Arwedd|Aspekt|Besigheid Behoefte|Business Need|Caracteristica|Característica|Egenskab|Egenskap|Eiginleiki|Feature|Fīča|Fitur|Fonctionnalité|Fonksyonalite|Funcionalidade|Funcionalitat|Functionalitate|Funcţionalitate|Funcționalitate|Functionaliteit|Fungsi|Funkcia|Funkcija|Funkcionalitāte|Funkcionalnost|Funkcja|Funksie|Funktionalität|Funktionalitéit|Funzionalità|Hwaet|Hwæt|Jellemző|Karakteristik|Lastnost|Mak|Mogucnost|laH|Mogućnost|Moznosti|Možnosti|OH HAI|Omadus|Ominaisuus|Osobina|Özellik|Potrzeba biznesowa|perbogh|poQbogh malja'|Požadavek|Požiadavka|Pretty much|Qap|Qu'meH 'ut|Savybė|Tính năng|Trajto|Vermoë|Vlastnosť|Właściwość|Značilnost|Δυνατότητα|Λειτουργία|Могућност|Мөмкинлек|Особина|Свойство|Үзенчәлеклелек|Функционал|Функционалност|Функция|Функціонал|תכונה|خاصية|خصوصیت|صلاحیت|کاروبار کی ضرورت|وِیژگی|रूप लेख|ਖਾਸੀਅਤ|ਨਕਸ਼ ਨੁਹਾਰ|ਮੁਹਾਂਦਰਾ|గుణము|ಹೆಚ್ಚಳ|ความต้องการทางธุรกิจ|ความสามารถ|โครงหลัก|기능|フィーチャ|功能|機能):(?:[^:\r\n]+(?:\r?\n|\r|$))*/,
          lookbehind: !0,
          inside: {
            important: {
              pattern: /(:)[^\r\n]+/,
              lookbehind: !0
            },
            keyword: /[^:\r\n]+:/
          }
        },
        scenario: {
          pattern: /(^[ \t]*)(?:Abstract Scenario|Abstrakt Scenario|Achtergrond|Aer|Ær|Agtergrond|All y'all|Antecedentes|Antecedents|Atburðarás|Atburðarásir|Awww, look mate|B4|Background|Baggrund|Bakgrund|Bakgrunn|Bakgrunnur|Beispiele|Beispiller|Bối cảnh|Cefndir|Cenario|Cenário|Cenario de Fundo|Cenário de Fundo|Cenarios|Cenários|Contesto|Context|Contexte|Contexto|Conto|Contoh|Contone|Dæmi|Dasar|Dead men tell no tales|Delineacao do Cenario|Delineação do Cenário|Dis is what went down|Dữ liệu|Dyagram Senaryo|Dyagram senaryo|Egzanp|Ejemplos|Eksempler|Ekzemploj|Enghreifftiau|Esbozo do escenario|Escenari|Escenario|Esempi|Esquema de l'escenari|Esquema del escenario|Esquema do Cenario|Esquema do Cenário|EXAMPLZ|Examples|Exempel|Exemple|Exemples|Exemplos|First off|Fono|Forgatókönyv|Forgatókönyv vázlat|Fundo|Geçmiş|Grundlage|Hannergrond|ghantoH|Háttér|Heave to|Istorik|Juhtumid|Keadaan|Khung kịch bản|Khung tình huống|Kịch bản|Koncept|Konsep skenario|Kontèks|Kontekst|Kontekstas|Konteksts|Kontext|Konturo de la scenaro|Latar Belakang|lut chovnatlh|lut|lutmey|Lýsing Atburðarásar|Lýsing Dæma|MISHUN SRSLY|MISHUN|Menggariskan Senario|mo'|Náčrt Scenára|Náčrt Scénáře|Náčrt Scenáru|Oris scenarija|Örnekler|Osnova|Osnova Scenára|Osnova scénáře|Osnutek|Ozadje|Paraugs|Pavyzdžiai|Példák|Piemēri|Plan du scénario|Plan du Scénario|Plan Senaryo|Plan senaryo|Plang vum Szenario|Pozadí|Pozadie|Pozadina|Príklady|Příklady|Primer|Primeri|Primjeri|Przykłady|Raamstsenaarium|Reckon it's like|Rerefons|Scenár|Scénář|Scenarie|Scenarij|Scenarijai|Scenarijaus šablonas|Scenariji|Scenārijs|Scenārijs pēc parauga|Scenarijus|Scenario|Scénario|Scenario Amlinellol|Scenario Outline|Scenario Template|Scenariomal|Scenariomall|Scenarios|Scenariu|Scenariusz|Scenaro|Schema dello scenario|Se ðe|Se the|Se þe|Senario|Senaryo Deskripsyon|Senaryo deskripsyon|Senaryo|Senaryo taslağı|Shiver me timbers|Situācija|Situai|Situasie Uiteensetting|Situasie|Skenario konsep|Skenario|Skica|Structura scenariu|Structură scenariu|Struktura scenarija|Stsenaarium|Swa hwaer swa|Swa|Swa hwær swa|Szablon scenariusza|Szenario|Szenariogrundriss|Tapaukset|Tapaus|Tapausaihio|Taust|Tausta|Template Keadaan|Template Senario|Template Situai|The thing of it is|Tình huống|Variantai|Voorbeelde|Voorbeelden|Wharrimean is|Yo-ho-ho|You'll wanna|Założenia|Παραδείγματα|Περιγραφή Σεναρίου|Σενάρια|Σενάριο|Υπόβαθρο|Кереш|Контекст|Концепт|Мисаллар|Мисоллар|Основа|Передумова|Позадина|Предистория|Предыстория|Приклади|Пример|Примери|Примеры|Рамка на сценарий|Скица|Структура сценарија|Структура сценария|Структура сценарію|Сценарий|Сценарий структураси|Сценарийның төзелеше|Сценарији|Сценарио|Сценарій|Тарих|Үрнәкләр|דוגמאות|רקע|תבנית תרחיש|תרחיש|الخلفية|الگوی سناریو|امثلة|پس منظر|زمینه|سناریو|سيناريو|سيناريو مخطط|مثالیں|منظر نامے کا خاکہ|منظرنامہ|نمونه ها|उदाहरण|परिदृश्य|परिदृश्य रूपरेखा|पृष्ठभूमि|ਉਦਾਹਰਨਾਂ|ਪਟਕਥਾ|ਪਟਕਥਾ ਢਾਂਚਾ|ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ|ਪਿਛੋਕੜ|ఉదాహరణలు|కథనం|నేపథ్యం|సన్నివేశం|ಉದಾಹರಣೆಗಳು|ಕಥಾಸಾರಾಂಶ|ವಿವರಣೆ|ಹಿನ್ನೆಲೆ|โครงสร้างของเหตุการณ์|ชุดของตัวอย่าง|ชุดของเหตุการณ์|แนวคิด|สรุปเหตุการณ์|เหตุการณ์|배경|시나리오|시나리오 개요|예|サンプル|シナリオ|シナリオアウトライン|シナリオテンプレ|シナリオテンプレート|テンプレ|例|例子|剧本|剧本大纲|劇本|劇本大綱|场景|场景大纲|場景|場景大綱|背景):[^:\r\n]*/m,
          lookbehind: !0,
          inside: {
            important: {
              pattern: /(:)[^\r\n]*/,
              lookbehind: !0
            },
            keyword: /[^:\r\n]+:/
          }
        },
        "table-body": {
          // Look-behind is used to skip the table head, which has the same format as any table row
          pattern: RegExp("(" + d + ")(?:" + d + ")+"),
          lookbehind: !0,
          inside: {
            outline: {
              pattern: /<[^>]+>/,
              alias: "variable"
            },
            td: {
              pattern: /\s*[^\s|][^|]*/,
              alias: "string"
            },
            punctuation: /\|/
          }
        },
        "table-head": {
          pattern: RegExp(d),
          inside: {
            th: {
              pattern: /\s*[^\s|][^|]*/,
              alias: "variable"
            },
            punctuation: /\|/
          }
        },
        atrule: {
          pattern: /(^[ \t]+)(?:'a|'ach|'ej|7|a|A také|A taktiež|A tiež|A zároveň|Aber|Ac|Adott|Akkor|Ak|Aleshores|Ale|Ali|Allora|Alors|Als|Ama|Amennyiben|Amikor|Ampak|an|AN|Ananging|And y'all|And|Angenommen|Anrhegedig a|An|Apabila|Atès|Atesa|Atunci|Avast!|Aye|A|awer|Bagi|Banjur|Bet|Biết|Blimey!|Buh|But at the end of the day I reckon|But y'all|But|BUT|Cal|Când|Cand|Cando|Ce|Cuando|Če|Ða ðe|Ða|Dadas|Dada|Dados|Dado|DaH ghu' bejlu'|dann|Dann|Dano|Dan|Dar|Dat fiind|Data|Date fiind|Date|Dati fiind|Dati|Daţi fiind|Dați fiind|DEN|Dato|De|Den youse gotta|Dengan|Diberi|Diyelim ki|Donada|Donat|Donitaĵo|Do|Dun|Duota|Ðurh|Eeldades|Ef|Eğer ki|Entao|Então|Entón|E|En|Entonces|Epi|És|Etant donnée|Etant donné|Et|Étant données|Étant donnée|Étant donné|Etant données|Etant donnés|Étant donnés|Fakat|Gangway!|Gdy|Gegeben seien|Gegeben sei|Gegeven|Gegewe|ghu' noblu'|Gitt|Given y'all|Given|Givet|Givun|Ha|Cho|I CAN HAZ|In|Ir|It's just unbelievable|I|Ja|Jeśli|Jeżeli|Kad|Kada|Kadar|Kai|Kaj|Když|Keď|Kemudian|Ketika|Khi|Kiedy|Ko|Kuid|Kui|Kun|Lan|latlh|Le sa a|Let go and haul|Le|Lè sa a|Lè|Logo|Lorsqu'<|Lorsque|mä|Maar|Mais|Mając|Ma|Majd|Maka|Manawa|Mas|Men|Menawa|Mutta|Nalika|Nalikaning|Nanging|Når|När|Nato|Nhưng|Niin|Njuk|O zaman|Och|Og|Oletetaan|Ond|Onda|Oraz|Pak|Pero|Però|Podano|Pokiaľ|Pokud|Potem|Potom|Privzeto|Pryd|Quan|Quand|Quando|qaSDI'|Så|Sed|Se|Siis|Sipoze ke|Sipoze Ke|Sipoze|Si|Şi|Și|Soit|Stel|Tada|Tad|Takrat|Tak|Tapi|Ter|Tetapi|Tha the|Tha|Then y'all|Then|Thì|Thurh|Toda|Too right|Un|Und|ugeholl|Và|vaj|Vendar|Ve|wann|Wanneer|WEN|Wenn|When y'all|When|Wtedy|Wun|Y'know|Yeah nah|Yna|Youse know like when|Youse know when youse got|Y|Za predpokladu|Za předpokladu|Zadan|Zadani|Zadano|Zadate|Zadato|Zakładając|Zaradi|Zatati|Þa þe|Þa|Þá|Þegar|Þurh|Αλλά|Δεδομένου|Και|Όταν|Τότε|А також|Агар|Але|Али|Аммо|А|Әгәр|Әйтик|Әмма|Бирок|Ва|Вә|Дадено|Дано|Допустим|Если|Задате|Задати|Задато|И|І|К тому же|Када|Кад|Когато|Когда|Коли|Ләкин|Лекин|Нәтиҗәдә|Нехай|Но|Онда|Припустимо, що|Припустимо|Пусть|Также|Та|Тогда|Тоді|То|Унда|Һәм|Якщо|אבל|אזי|אז|בהינתן|וגם|כאשר|آنگاه|اذاً|اگر|اما|اور|با فرض|بالفرض|بفرض|پھر|تب|ثم|جب|عندما|فرض کیا|لكن|لیکن|متى|هنگامی|و|अगर|और|कदा|किन्तु|चूंकि|जब|तथा|तदा|तब|परन्तु|पर|यदि|ਅਤੇ|ਜਦੋਂ|ਜਿਵੇਂ ਕਿ|ਜੇਕਰ|ਤਦ|ਪਰ|అప్పుడు|ఈ పరిస్థితిలో|కాని|చెప్పబడినది|మరియు|ಆದರೆ|ನಂತರ|ನೀಡಿದ|ಮತ್ತು|ಸ್ಥಿತಿಯನ್ನು|กำหนดให้|ดังนั้น|แต่|เมื่อ|และ|그러면<|그리고<|단<|만약<|만일<|먼저<|조건<|하지만<|かつ<|しかし<|ただし<|ならば<|もし<|並且<|但し<|但是<|假如<|假定<|假設<|假设<|前提<|同时<|同時<|并且<|当<|當<|而且<|那么<|那麼<)(?=[ \t])/m,
          lookbehind: !0
        },
        string: {
          pattern: /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/,
          inside: {
            outline: {
              pattern: /<[^>]+>/,
              alias: "variable"
            }
          }
        },
        outline: {
          pattern: /<[^>]+>/,
          alias: "variable"
        }
      };
    })(t);
  }
  return gherkin_1;
}
var git_1, hasRequiredGit;
function requireGit() {
  if (hasRequiredGit) return git_1;
  hasRequiredGit = 1, git_1 = n, n.displayName = "git", n.aliases = [];
  function n(t) {
    t.languages.git = {
      /*
       * A simple one line comment like in a git status command
       * For instance:
       * $ git status
       * # On branch infinite-scroll
       * # Your branch and 'origin/sharedBranches/frontendTeam/infinite-scroll' have diverged,
       * # and have 1 and 2 different commits each, respectively.
       * nothing to commit (working directory clean)
       */
      comment: /^#.*/m,
      /*
       * Regexp to match the changed lines in a git diff output. Check the example below.
       */
      deleted: /^[-–].*/m,
      inserted: /^\+.*/m,
      /*
       * a string (double and simple quote)
       */
      string: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      /*
       * a git command. It starts with a random prompt finishing by a $, then "git" then some other parameters
       * For instance:
       * $ git add file.txt
       */
      command: {
        pattern: /^.*\$ git .*$/m,
        inside: {
          /*
           * A git command can contain a parameter starting by a single or a double dash followed by a string
           * For instance:
           * $ git diff --cached
           * $ git log -p
           */
          parameter: /\s--?\w+/
        }
      },
      /*
       * Coordinates displayed in a git diff command
       * For instance:
       * $ git diff
       * diff --git file.txt file.txt
       * index 6214953..1d54a52 100644
       * --- file.txt
       * +++ file.txt
       * @@ -1 +1,2 @@
       * -Here's my tetx file
       * +Here's my text file
       * +And this is the second line
       */
      coord: /^@@.*@@$/m,
      /*
       * Match a "commit [SHA1]" line in a git log output.
       * For instance:
       * $ git log
       * commit a11a14ef7e26f2ca62d4b35eac455ce636d0dc09
       * Author: lgiraudel
       * Date:   Mon Feb 17 11:18:34 2014 +0100
       *
       *     Add of a new line
       */
      "commit-sha1": /^commit \w{40}$/m
    };
  }
  return git_1;
}
var glsl_1, hasRequiredGlsl;
function requireGlsl() {
  if (hasRequiredGlsl) return glsl_1;
  hasRequiredGlsl = 1;
  var n = requireC();
  glsl_1 = t, t.displayName = "glsl", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.glsl = g.languages.extend("c", {
      keyword: /\b(?:active|asm|atomic_uint|attribute|[ibdu]?vec[234]|bool|break|buffer|case|cast|centroid|class|coherent|common|const|continue|d?mat[234](?:x[234])?|default|discard|do|double|else|enum|extern|external|false|filter|fixed|flat|float|for|fvec[234]|goto|half|highp|hvec[234]|[iu]?sampler2DMS(?:Array)?|[iu]?sampler2DRect|[iu]?samplerBuffer|[iu]?samplerCube|[iu]?samplerCubeArray|[iu]?sampler[123]D|[iu]?sampler[12]DArray|[iu]?image2DMS(?:Array)?|[iu]?image2DRect|[iu]?imageBuffer|[iu]?imageCube|[iu]?imageCubeArray|[iu]?image[123]D|[iu]?image[12]DArray|if|in|inline|inout|input|int|interface|invariant|layout|long|lowp|mediump|namespace|noinline|noperspective|out|output|partition|patch|precise|precision|public|readonly|resource|restrict|return|sample|sampler[12]DArrayShadow|sampler[12]DShadow|sampler2DRectShadow|sampler3DRect|samplerCubeArrayShadow|samplerCubeShadow|shared|short|sizeof|smooth|static|struct|subroutine|superp|switch|template|this|true|typedef|uint|uniform|union|unsigned|using|varying|void|volatile|while|writeonly)\b/
    });
  }
  return glsl_1;
}
var gml_1, hasRequiredGml;
function requireGml() {
  if (hasRequiredGml) return gml_1;
  hasRequiredGml = 1, gml_1 = n, n.displayName = "gml", n.aliases = [];
  function n(t) {
    t.languages.gamemakerlanguage = t.languages.gml = t.languages.extend("clike", {
      keyword: /\b(?:break|case|continue|default|do|else|enum|exit|for|globalvar|if|repeat|return|switch|until|var|while)\b/,
      number: /(?:\b0x[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ulf]{0,4}/i,
      operator: /--|\+\+|[-+%/=]=?|!=|\*\*?=?|<[<=>]?|>[=>]?|&&?|\^\^?|\|\|?|~|\b(?:and|at|not|or|with|xor)\b/,
      constant: /\b(?:GM_build_date|GM_version|action_(?:continue|restart|reverse|stop)|all|gamespeed_(?:fps|microseconds)|global|local|noone|other|pi|pointer_(?:invalid|null)|self|timezone_(?:local|utc)|undefined|ev_(?:create|destroy|step|alarm|keyboard|mouse|collision|other|draw|draw_(?:begin|end|post|pre)|keypress|keyrelease|trigger|(?:left|middle|no|right)_button|(?:left|middle|right)_press|(?:left|middle|right)_release|mouse_(?:enter|leave|wheel_down|wheel_up)|global_(?:left|middle|right)_button|global_(?:left|middle|right)_press|global_(?:left|middle|right)_release|joystick(?:1|2)_(?:button1|button2|button3|button4|button5|button6|button7|button8|down|left|right|up)|outside|boundary|game_start|game_end|room_start|room_end|no_more_lives|animation_end|end_of_path|no_more_health|user\d|gui|gui_begin|gui_end|step_(?:begin|end|normal))|vk_(?:alt|anykey|backspace|control|delete|down|end|enter|escape|home|insert|left|nokey|pagedown|pageup|pause|printscreen|return|right|shift|space|tab|up|f\d|numpad\d|add|decimal|divide|lalt|lcontrol|lshift|multiply|ralt|rcontrol|rshift|subtract)|achievement_(?:filter_(?:all_players|favorites_only|friends_only)|friends_info|info|leaderboard_info|our_info|pic_loaded|show_(?:achievement|bank|friend_picker|leaderboard|profile|purchase_prompt|ui)|type_challenge|type_score_challenge)|asset_(?:font|object|path|room|script|shader|sound|sprite|tiles|timeline|unknown)|audio_(?:3d|falloff_(?:exponent_distance|exponent_distance_clamped|inverse_distance|inverse_distance_clamped|linear_distance|linear_distance_clamped|none)|mono|new_system|old_system|stereo)|bm_(?:add|complex|dest_alpha|dest_color|dest_colour|inv_dest_alpha|inv_dest_color|inv_dest_colour|inv_src_alpha|inv_src_color|inv_src_colour|max|normal|one|src_alpha|src_alpha_sat|src_color|src_colour|subtract|zero)|browser_(?:chrome|firefox|ie|ie_mobile|not_a_browser|opera|safari|safari_mobile|tizen|unknown|windows_store)|buffer_(?:bool|f16|f32|f64|fast|fixed|generalerror|grow|invalidtype|network|outofbounds|outofspace|s16|s32|s8|seek_end|seek_relative|seek_start|string|text|u16|u32|u64|u8|vbuffer|wrap)|c_(?:aqua|black|blue|dkgray|fuchsia|gray|green|lime|ltgray|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow)|cmpfunc_(?:always|equal|greater|greaterequal|less|lessequal|never|notequal)|cr_(?:appstart|arrow|beam|cross|default|drag|handpoint|hourglass|none|size_all|size_nesw|size_ns|size_nwse|size_we|uparrow)|cull_(?:clockwise|counterclockwise|noculling)|device_(?:emulator|tablet)|device_ios_(?:ipad|ipad_retina|iphone|iphone5|iphone6|iphone6plus|iphone_retina|unknown)|display_(?:landscape|landscape_flipped|portrait|portrait_flipped)|dll_(?:cdecl|cdel|stdcall)|ds_type_(?:grid|list|map|priority|queue|stack)|ef_(?:cloud|ellipse|explosion|firework|flare|rain|ring|smoke|smokeup|snow|spark|star)|fa_(?:archive|bottom|center|directory|hidden|left|middle|readonly|right|sysfile|top|volumeid)|fb_login_(?:default|fallback_to_webview|forcing_safari|forcing_webview|no_fallback_to_webview|use_system_account)|iap_(?:available|canceled|ev_consume|ev_product|ev_purchase|ev_restore|ev_storeload|failed|purchased|refunded|status_available|status_loading|status_processing|status_restoring|status_unavailable|status_uninitialised|storeload_failed|storeload_ok|unavailable)|leaderboard_type_(?:number|time_mins_secs)|lighttype_(?:dir|point)|matrix_(?:projection|view|world)|mb_(?:any|left|middle|none|right)|network_(?:config_(?:connect_timeout|disable_reliable_udp|enable_reliable_udp|use_non_blocking_socket)|socket_(?:bluetooth|tcp|udp)|type_(?:connect|data|disconnect|non_blocking_connect))|of_challenge_(?:lose|tie|win)|os_(?:android|ios|linux|macosx|ps3|ps4|psvita|unknown|uwp|win32|win8native|windows|winphone|xboxone)|phy_debug_render_(?:aabb|collision_pairs|coms|core_shapes|joints|obb|shapes)|phy_joint_(?:anchor_1_x|anchor_1_y|anchor_2_x|anchor_2_y|angle|angle_limits|damping_ratio|frequency|length_1|length_2|lower_angle_limit|max_force|max_length|max_motor_force|max_motor_torque|max_torque|motor_force|motor_speed|motor_torque|reaction_force_x|reaction_force_y|reaction_torque|speed|translation|upper_angle_limit)|phy_particle_data_flag_(?:category|color|colour|position|typeflags|velocity)|phy_particle_flag_(?:colormixing|colourmixing|elastic|powder|spring|tensile|viscous|wall|water|zombie)|phy_particle_group_flag_(?:rigid|solid)|pr_(?:linelist|linestrip|pointlist|trianglefan|trianglelist|trianglestrip)|ps_(?:distr|shape)_(?:diamond|ellipse|gaussian|invgaussian|line|linear|rectangle)|pt_shape_(?:circle|cloud|disk|explosion|flare|line|pixel|ring|smoke|snow|spark|sphere|square|star)|ty_(?:real|string)|gp_(?:face\d|axislh|axislv|axisrh|axisrv|padd|padl|padr|padu|select|shoulderl|shoulderlb|shoulderr|shoulderrb|start|stickl|stickr)|lb_disp_(?:none|numeric|time_ms|time_sec)|lb_sort_(?:ascending|descending|none)|ov_(?:achievements|community|friends|gamegroup|players|settings)|ugc_(?:filetype_(?:community|microtrans)|list_(?:Favorited|Followed|Published|Subscribed|UsedOrPlayed|VotedDown|VotedOn|VotedUp|WillVoteLater)|match_(?:AllGuides|Artwork|Collections|ControllerBindings|IntegratedGuides|Items|Items_Mtx|Items_ReadyToUse|Screenshots|UsableInGame|Videos|WebGuides)|query_(?:AcceptedForGameRankedByAcceptanceDate|CreatedByFriendsRankedByPublicationDate|FavoritedByFriendsRankedByPublicationDate|NotYetRated)|query_RankedBy(?:NumTimesReported|PublicationDate|TextSearch|TotalVotesAsc|Trend|Vote|VotesUp)|result_success|sortorder_CreationOrder(?:Asc|Desc)|sortorder_(?:ForModeration|LastUpdatedDesc|SubscriptionDateDesc|TitleAsc|VoteScoreDesc)|visibility_(?:friends_only|private|public))|vertex_usage_(?:binormal|blendindices|blendweight|color|colour|depth|fog|normal|position|psize|sample|tangent|texcoord|textcoord)|vertex_type_(?:float\d|color|colour|ubyte4)|input_type|layerelementtype_(?:background|instance|oldtilemap|particlesystem|sprite|tile|tilemap|undefined)|se_(?:chorus|compressor|echo|equalizer|flanger|gargle|none|reverb)|text_type|tile_(?:flip|index_mask|mirror|rotate)|(?:obj|rm|scr|spr)\w+)\b/,
      variable: /\b(?:alarm|application_surface|async_load|background_(?:alpha|blend|color|colour|foreground|height|hspeed|htiled|index|showcolor|showcolour|visible|vspeed|vtiled|width|x|xscale|y|yscale)|bbox_(?:bottom|left|right|top)|browser_(?:height|width)|caption_(?:health|lives|score)|current_(?:day|hour|minute|month|second|time|weekday|year)|cursor_sprite|debug_mode|delta_time|direction|display_aa|error_(?:last|occurred)|event_(?:action|number|object|type)|fps|fps_real|friction|game_(?:display|project|save)_(?:id|name)|gamemaker_(?:pro|registered|version)|gravity|gravity_direction|(?:h|v)speed|health|iap_data|id|image_(?:alpha|angle|blend|depth|index|number|speed|xscale|yscale)|instance_(?:count|id)|keyboard_(?:key|lastchar|lastkey|string)|layer|lives|mask_index|mouse_(?:button|lastbutton|x|y)|object_index|os_(?:browser|device|type|version)|path_(?:endaction|index|orientation|position|positionprevious|scale|speed)|persistent|phy_(?:rotation|(?:col_normal|collision|com|linear_velocity|position|speed)_(?:x|y)|angular_(?:damping|velocity)|position_(?:x|y)previous|speed|linear_damping|bullet|fixed_rotation|active|mass|inertia|dynamic|kinematic|sleeping|collision_points)|pointer_(?:invalid|null)|room|room_(?:caption|first|height|last|persistent|speed|width)|score|secure_mode|show_(?:health|lives|score)|solid|speed|sprite_(?:height|index|width|xoffset|yoffset)|temp_directory|timeline_(?:index|loop|position|running|speed)|transition_(?:color|kind|steps)|undefined|view_(?:angle|current|enabled|(?:h|v)(?:border|speed)|(?:h|w|x|y)port|(?:h|w|x|y)view|object|surface_id|visible)|visible|webgl_enabled|working_directory|(?:x|y)(?:previous|start)|x|y|argument(?:_relitive|_count|\d)|argument|global|local|other|self)\b/
    });
  }
  return gml_1;
}
var gn_1, hasRequiredGn;
function requireGn() {
  if (hasRequiredGn) return gn_1;
  hasRequiredGn = 1, gn_1 = n, n.displayName = "gn", n.aliases = ["gni"];
  function n(t) {
    t.languages.gn = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      "string-literal": {
        pattern: /(^|[^\\"])"(?:[^\r\n"\\]|\\.)*"/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[\s\S]*?\}|[a-zA-Z_]\w*|0x[a-fA-F0-9]{2})/,
            lookbehind: !0,
            inside: {
              number: /^\$0x[\s\S]{2}$/,
              variable: /^\$\w+$/,
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              },
              expression: {
                pattern: /[\s\S]+/,
                inside: null
                // see below
              }
            }
          },
          string: /[\s\S]+/
        }
      },
      keyword: /\b(?:else|if)\b/,
      boolean: /\b(?:false|true)\b/,
      "builtin-function": {
        // a few functions get special highlighting to improve readability
        pattern: /\b(?:assert|defined|foreach|import|pool|print|template|tool|toolchain)(?=\s*\()/i,
        alias: "keyword"
      },
      function: /\b[a-z_]\w*(?=\s*\()/i,
      constant: /\b(?:current_cpu|current_os|current_toolchain|default_toolchain|host_cpu|host_os|root_build_dir|root_gen_dir|root_out_dir|target_cpu|target_gen_dir|target_os|target_out_dir)\b/,
      number: /-?\b\d+\b/,
      operator: /[-+!=<>]=?|&&|\|\|/,
      punctuation: /[(){}[\],.]/
    }, t.languages.gn["string-literal"].inside.interpolation.inside.expression.inside = t.languages.gn, t.languages.gni = t.languages.gn;
  }
  return gn_1;
}
var goModule_1, hasRequiredGoModule;
function requireGoModule() {
  if (hasRequiredGoModule) return goModule_1;
  hasRequiredGoModule = 1, goModule_1 = n, n.displayName = "goModule", n.aliases = [];
  function n(t) {
    t.languages["go-mod"] = t.languages["go-module"] = {
      comment: {
        pattern: /\/\/.*/,
        greedy: !0
      },
      version: {
        pattern: /(^|[\s()[\],])v\d+\.\d+\.\d+(?:[+-][-+.\w]*)?(?![^\s()[\],])/,
        lookbehind: !0,
        alias: "number"
      },
      "go-version": {
        pattern: /((?:^|\s)go\s+)\d+(?:\.\d+){1,2}/,
        lookbehind: !0,
        alias: "number"
      },
      keyword: {
        pattern: /^([ \t]*)(?:exclude|go|module|replace|require|retract)\b/m,
        lookbehind: !0
      },
      operator: /=>/,
      punctuation: /[()[\],]/
    };
  }
  return goModule_1;
}
var go_1, hasRequiredGo;
function requireGo() {
  if (hasRequiredGo) return go_1;
  hasRequiredGo = 1, go_1 = n, n.displayName = "go", n.aliases = [];
  function n(t) {
    t.languages.go = t.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
      boolean: /\b(?:_|false|iota|nil|true)\b/,
      number: [
        // binary and octal integers
        /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
        // hexadecimal integers and floats
        /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        // decimal integers and floats
        /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
      ],
      operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
      builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
    }), t.languages.insertBefore("go", "string", {
      char: {
        pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
        greedy: !0
      }
    }), delete t.languages.go["class-name"];
  }
  return go_1;
}
var graphql_1, hasRequiredGraphql;
function requireGraphql() {
  if (hasRequiredGraphql) return graphql_1;
  hasRequiredGraphql = 1, graphql_1 = n, n.displayName = "graphql", n.aliases = [];
  function n(t) {
    t.languages.graphql = {
      comment: /#.*/,
      description: {
        pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
        greedy: !0,
        alias: "string",
        inside: {
          "language-markdown": {
            pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
            lookbehind: !0,
            inside: t.languages.markdown
          }
        }
      },
      string: {
        pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      boolean: /\b(?:false|true)\b/,
      variable: /\$[a-z_]\w*/i,
      directive: {
        pattern: /@[a-z_]\w*/i,
        alias: "function"
      },
      "attr-name": {
        pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
        greedy: !0
      },
      "atom-input": {
        pattern: /\b[A-Z]\w*Input\b/,
        alias: "class-name"
      },
      scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
      constant: /\b[A-Z][A-Z_\d]*\b/,
      "class-name": {
        pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
        lookbehind: !0
      },
      fragment: {
        pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
        lookbehind: !0,
        alias: "function"
      },
      "definition-mutation": {
        pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
        lookbehind: !0,
        alias: "function"
      },
      "definition-query": {
        pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
        lookbehind: !0,
        alias: "function"
      },
      keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
      operator: /[!=|&]|\.{3}/,
      "property-query": /\w+(?=\s*\()/,
      object: /\w+(?=\s*\{)/,
      punctuation: /[!(){}\[\]:=,]/,
      property: /\w+/
    }, t.hooks.add("after-tokenize", function(d) {
      if (d.language !== "graphql")
        return;
      var k = d.tokens.filter(function(aA) {
        return typeof aA != "string" && aA.type !== "comment" && aA.type !== "scalar";
      }), H = 0;
      function AA(aA) {
        return k[H + aA];
      }
      function gA(aA, nA) {
        nA = nA || 0;
        for (var lA = 0; lA < aA.length; lA++) {
          var cA = AA(lA + nA);
          if (!cA || cA.type !== aA[lA])
            return !1;
        }
        return !0;
      }
      function IA(aA, nA) {
        for (var lA = 1, cA = H; cA < k.length; cA++) {
          var sA = k[cA], rA = sA.content;
          if (sA.type === "punctuation" && typeof rA == "string") {
            if (aA.test(rA))
              lA++;
            else if (nA.test(rA) && (lA--, lA === 0))
              return cA;
          }
        }
        return -1;
      }
      function CA(aA, nA) {
        var lA = aA.alias;
        lA ? Array.isArray(lA) || (aA.alias = lA = [lA]) : aA.alias = lA = [], lA.push(nA);
      }
      for (; H < k.length; ) {
        var BA = k[H++];
        if (BA.type === "keyword" && BA.content === "mutation") {
          var eA = [];
          if (gA(["definition-mutation", "punctuation"]) && AA(1).content === "(") {
            H += 2;
            var iA = IA(/^\($/, /^\)$/);
            if (iA === -1)
              continue;
            for (; H < iA; H++) {
              var QA = AA(0);
              QA.type === "variable" && (CA(QA, "variable-input"), eA.push(QA.content));
            }
            H = iA + 1;
          }
          if (gA(["punctuation", "property-query"]) && AA(0).content === "{" && (H++, CA(AA(0), "property-mutation"), eA.length > 0)) {
            var tA = IA(/^\{$/, /^\}$/);
            if (tA === -1)
              continue;
            for (var oA = H; oA < tA; oA++) {
              var EA = k[oA];
              EA.type === "variable" && eA.indexOf(EA.content) >= 0 && CA(EA, "variable-input");
            }
          }
        }
      }
    });
  }
  return graphql_1;
}
var groovy_1, hasRequiredGroovy;
function requireGroovy() {
  if (hasRequiredGroovy) return groovy_1;
  hasRequiredGroovy = 1, groovy_1 = n, n.displayName = "groovy", n.aliases = [];
  function n(t) {
    t.languages.groovy = t.languages.extend("clike", {
      string: [
        {
          // https://groovy-lang.org/syntax.html#_dollar_slashy_string
          pattern: /("""|''')(?:[^\\]|\\[\s\S])*?\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
          greedy: !0
        },
        {
          // TODO: Slash strings (e.g. /foo/) can contain line breaks but this will cause a lot of trouble with
          // simple division (see JS regex), so find a fix maybe?
          pattern: /(["'/])(?:\\.|(?!\1)[^\\\r\n])*\1/,
          greedy: !0
        }
      ],
      keyword: /\b(?:abstract|as|assert|boolean|break|byte|case|catch|char|class|const|continue|def|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|in|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,
      number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
      operator: {
        pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
        lookbehind: !0
      },
      punctuation: /\.+|[{}[\];(),:$]/
    }), t.languages.insertBefore("groovy", "string", {
      shebang: {
        pattern: /#!.+/,
        alias: "comment"
      }
    }), t.languages.insertBefore("groovy", "punctuation", {
      "spock-block": /\b(?:and|cleanup|expect|given|setup|then|when|where):/
    }), t.languages.insertBefore("groovy", "function", {
      annotation: {
        pattern: /(^|[^.])@\w+/,
        lookbehind: !0,
        alias: "punctuation"
      }
    }), t.hooks.add("wrap", function(g) {
      if (g.language === "groovy" && g.type === "string") {
        var d = g.content.value[0];
        if (d != "'") {
          var k = /([^\\])(?:\$(?:\{.*?\}|[\w.]+))/;
          d === "$" && (k = /([^\$])(?:\$(?:\{.*?\}|[\w.]+))/), g.content.value = g.content.value.replace(/&lt;/g, "<").replace(/&amp;/g, "&"), g.content = t.highlight(g.content.value, {
            expression: {
              pattern: k,
              lookbehind: !0,
              inside: t.languages.groovy
            }
          }), g.classes.push(d === "/" ? "regex" : "gstring");
        }
      }
    });
  }
  return groovy_1;
}
var haml_1, hasRequiredHaml;
function requireHaml() {
  if (hasRequiredHaml) return haml_1;
  hasRequiredHaml = 1;
  var n = requireRuby();
  haml_1 = t, t.displayName = "haml", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      d.languages.haml = {
        // Multiline stuff should appear before the rest
        "multiline-comment": {
          pattern: /((?:^|\r?\n|\r)([\t ]*))(?:\/|-#).*(?:(?:\r?\n|\r)\2[\t ].+)*/,
          lookbehind: !0,
          alias: "comment"
        },
        "multiline-code": [
          {
            pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*,[\t ]*(?:(?:\r?\n|\r)\2[\t ].*,[\t ]*)*(?:(?:\r?\n|\r)\2[\t ].+)/,
            lookbehind: !0,
            inside: d.languages.ruby
          },
          {
            pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*\|[\t ]*(?:(?:\r?\n|\r)\2[\t ].*\|[\t ]*)*/,
            lookbehind: !0,
            inside: d.languages.ruby
          }
        ],
        // See at the end of the file for known filters
        filter: {
          pattern: /((?:^|\r?\n|\r)([\t ]*)):[\w-]+(?:(?:\r?\n|\r)(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/,
          lookbehind: !0,
          inside: {
            "filter-name": {
              pattern: /^:[\w-]+/,
              alias: "symbol"
            }
          }
        },
        markup: {
          pattern: /((?:^|\r?\n|\r)[\t ]*)<.+/,
          lookbehind: !0,
          inside: d.languages.markup
        },
        doctype: {
          pattern: /((?:^|\r?\n|\r)[\t ]*)!!!(?: .+)?/,
          lookbehind: !0
        },
        tag: {
          // Allows for one nested group of braces
          pattern: /((?:^|\r?\n|\r)[\t ]*)[%.#][\w\-#.]*[\w\-](?:\([^)]+\)|\{(?:\{[^}]+\}|[^{}])+\}|\[[^\]]+\])*[\/<>]*/,
          lookbehind: !0,
          inside: {
            attributes: [
              {
                // Lookbehind tries to prevent interpolations from breaking it all
                // Allows for one nested group of braces
                pattern: /(^|[^#])\{(?:\{[^}]+\}|[^{}])+\}/,
                lookbehind: !0,
                inside: d.languages.ruby
              },
              {
                pattern: /\([^)]+\)/,
                inside: {
                  "attr-value": {
                    pattern: /(=\s*)(?:"(?:\\.|[^\\"\r\n])*"|[^)\s]+)/,
                    lookbehind: !0
                  },
                  "attr-name": /[\w:-]+(?=\s*!?=|\s*[,)])/,
                  punctuation: /[=(),]/
                }
              },
              {
                pattern: /\[[^\]]+\]/,
                inside: d.languages.ruby
              }
            ],
            punctuation: /[<>]/
          }
        },
        code: {
          pattern: /((?:^|\r?\n|\r)[\t ]*(?:[~-]|[&!]?=)).+/,
          lookbehind: !0,
          inside: d.languages.ruby
        },
        // Interpolations in plain text
        interpolation: {
          pattern: /#\{[^}]+\}/,
          inside: {
            delimiter: {
              pattern: /^#\{|\}$/,
              alias: "punctuation"
            },
            ruby: {
              pattern: /[\s\S]+/,
              inside: d.languages.ruby
            }
          }
        },
        punctuation: {
          pattern: /((?:^|\r?\n|\r)[\t ]*)[~=\-&!]+/,
          lookbehind: !0
        }
      };
      for (var k = "((?:^|\\r?\\n|\\r)([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r)(?:\\2[\\t ].+|\\s*?(?=\\r?\\n|\\r)))+", H = [
        "css",
        {
          filter: "coffee",
          language: "coffeescript"
        },
        "erb",
        "javascript",
        "less",
        "markdown",
        "ruby",
        "scss",
        "textile"
      ], AA = {}, gA = 0, IA = H.length; gA < IA; gA++) {
        var CA = H[gA];
        CA = typeof CA == "string" ? {
          filter: CA,
          language: CA
        } : CA, d.languages[CA.language] && (AA["filter-" + CA.filter] = {
          pattern: RegExp(
            k.replace("{{filter_name}}", function() {
              return CA.filter;
            })
          ),
          lookbehind: !0,
          inside: {
            "filter-name": {
              pattern: /^:[\w-]+/,
              alias: "symbol"
            },
            text: {
              pattern: /[\s\S]+/,
              alias: [CA.language, "language-" + CA.language],
              inside: d.languages[CA.language]
            }
          }
        });
      }
      d.languages.insertBefore("haml", "filter", AA);
    })(g);
  }
  return haml_1;
}
var handlebars_1, hasRequiredHandlebars;
function requireHandlebars() {
  if (hasRequiredHandlebars) return handlebars_1;
  hasRequiredHandlebars = 1;
  var n = requireMarkupTemplating();
  handlebars_1 = t, t.displayName = "handlebars", t.aliases = ["hbs"];
  function t(g) {
    g.register(n), (function(d) {
      d.languages.handlebars = {
        comment: /\{\{![\s\S]*?\}\}/,
        delimiter: {
          pattern: /^\{\{\{?|\}\}\}?$/,
          alias: "punctuation"
        },
        string: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][+-]?\d+)?/,
        boolean: /\b(?:false|true)\b/,
        block: {
          pattern: /^(\s*(?:~\s*)?)[#\/]\S+?(?=\s*(?:~\s*)?$|\s)/,
          lookbehind: !0,
          alias: "keyword"
        },
        brackets: {
          pattern: /\[[^\]]+\]/,
          inside: {
            punctuation: /\[|\]/,
            variable: /[\s\S]+/
          }
        },
        punctuation: /[!"#%&':()*+,.\/;<=>@\[\\\]^`{|}~]/,
        variable: /[^!"#%&'()*+,\/;<=>@\[\\\]^`{|}~\s]+/
      }, d.hooks.add("before-tokenize", function(k) {
        var H = /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/g;
        d.languages["markup-templating"].buildPlaceholders(
          k,
          "handlebars",
          H
        );
      }), d.hooks.add("after-tokenize", function(k) {
        d.languages["markup-templating"].tokenizePlaceholders(
          k,
          "handlebars"
        );
      }), d.languages.hbs = d.languages.handlebars;
    })(g);
  }
  return handlebars_1;
}
var haskell_1, hasRequiredHaskell;
function requireHaskell() {
  if (hasRequiredHaskell) return haskell_1;
  hasRequiredHaskell = 1, haskell_1 = n, n.displayName = "haskell", n.aliases = ["hs"];
  function n(t) {
    t.languages.haskell = {
      comment: {
        pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\\/])(?:--(?:(?=.)[^-!#$%*+=?&@|~.:<>^\\\/].*|$)|\{-[\s\S]*?-\})/m,
        lookbehind: !0
      },
      char: {
        pattern: /'(?:[^\\']|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|ACK|BEL|BS|CAN|CR|DC1|DC2|DC3|DC4|DEL|DLE|EM|ENQ|EOT|ESC|ETB|ETX|FF|FS|GS|HT|LF|NAK|NUL|RS|SI|SO|SOH|SP|STX|SUB|SYN|US|VT|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
        alias: "string"
      },
      string: {
        pattern: /"(?:[^\\"]|\\(?:\S|\s+\\))*"/,
        greedy: !0
      },
      keyword: /\b(?:case|class|data|deriving|do|else|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b/,
      "import-statement": {
        // The imported or hidden names are not included in this import
        // statement. This is because we want to highlight those exactly like
        // we do for the names in the program.
        pattern: /(^[\t ]*)import\s+(?:qualified\s+)?(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*(?:\s+as\s+(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
        lookbehind: !0,
        inside: {
          keyword: /\b(?:as|hiding|import|qualified)\b/,
          punctuation: /\./
        }
      },
      // These are builtin variables only. Constructors are highlighted later as a constant.
      builtin: /\b(?:abs|acos|acosh|all|and|any|appendFile|approxRational|asTypeOf|asin|asinh|atan|atan2|atanh|basicIORun|break|catch|ceiling|chr|compare|concat|concatMap|const|cos|cosh|curry|cycle|decodeFloat|denominator|digitToInt|div|divMod|drop|dropWhile|either|elem|encodeFloat|enumFrom|enumFromThen|enumFromThenTo|enumFromTo|error|even|exp|exponent|fail|filter|flip|floatDigits|floatRadix|floatRange|floor|fmap|foldl|foldl1|foldr|foldr1|fromDouble|fromEnum|fromInt|fromInteger|fromIntegral|fromRational|fst|gcd|getChar|getContents|getLine|group|head|id|inRange|index|init|intToDigit|interact|ioError|isAlpha|isAlphaNum|isAscii|isControl|isDenormalized|isDigit|isHexDigit|isIEEE|isInfinite|isLower|isNaN|isNegativeZero|isOctDigit|isPrint|isSpace|isUpper|iterate|last|lcm|length|lex|lexDigits|lexLitChar|lines|log|logBase|lookup|map|mapM|mapM_|max|maxBound|maximum|maybe|min|minBound|minimum|mod|negate|not|notElem|null|numerator|odd|or|ord|otherwise|pack|pi|pred|primExitWith|print|product|properFraction|putChar|putStr|putStrLn|quot|quotRem|range|rangeSize|read|readDec|readFile|readFloat|readHex|readIO|readInt|readList|readLitChar|readLn|readOct|readParen|readSigned|reads|readsPrec|realToFrac|recip|rem|repeat|replicate|return|reverse|round|scaleFloat|scanl|scanl1|scanr|scanr1|seq|sequence|sequence_|show|showChar|showInt|showList|showLitChar|showParen|showSigned|showString|shows|showsPrec|significand|signum|sin|sinh|snd|sort|span|splitAt|sqrt|subtract|succ|sum|tail|take|takeWhile|tan|tanh|threadToIOResult|toEnum|toInt|toInteger|toLower|toRational|toUpper|truncate|uncurry|undefined|unlines|until|unwords|unzip|unzip3|userError|words|writeFile|zip|zip3|zipWith|zipWith3)\b/,
      // decimal integers and floating point numbers | octal integers | hexadecimal integers
      number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
      operator: [
        {
          // infix operator
          pattern: /`(?:[A-Z][\w']*\.)*[_a-z][\w']*`/,
          greedy: !0
        },
        {
          // function composition
          pattern: /(\s)\.(?=\s)/,
          lookbehind: !0
        },
        // Most of this is needed because of the meaning of a single '.'.
        // If it stands alone freely, it is the function composition.
        // It may also be a separator between a module name and an identifier => no
        // operator. If it comes together with other special characters it is an
        // operator too.
        //
        // This regex means: /[-!#$%*+=?&@|~.:<>^\\\/]+/ without /\./.
        /[-!#$%*+=?&@|~:<>^\\\/][-!#$%*+=?&@|~.:<>^\\\/]*|\.[-!#$%*+=?&@|~.:<>^\\\/]+/
      ],
      // In Haskell, nearly everything is a variable, do not highlight these.
      hvariable: {
        pattern: /\b(?:[A-Z][\w']*\.)*[_a-z][\w']*/,
        inside: {
          punctuation: /\./
        }
      },
      constant: {
        pattern: /\b(?:[A-Z][\w']*\.)*[A-Z][\w']*/,
        inside: {
          punctuation: /\./
        }
      },
      punctuation: /[{}[\];(),.:]/
    }, t.languages.hs = t.languages.haskell;
  }
  return haskell_1;
}
var haxe_1, hasRequiredHaxe;
function requireHaxe() {
  if (hasRequiredHaxe) return haxe_1;
  hasRequiredHaxe = 1, haxe_1 = n, n.displayName = "haxe", n.aliases = [];
  function n(t) {
    t.languages.haxe = t.languages.extend("clike", {
      string: {
        // Strings can be multi-line
        pattern: /"(?:[^"\\]|\\[\s\S])*"/,
        greedy: !0
      },
      "class-name": [
        {
          pattern: /(\b(?:abstract|class|enum|extends|implements|interface|new|typedef)\s+)[A-Z_]\w*/,
          lookbehind: !0
        },
        // based on naming convention
        /\b[A-Z]\w*/
      ],
      // The final look-ahead prevents highlighting of keywords if expressions such as "haxe.macro.Expr"
      keyword: /\bthis\b|\b(?:abstract|as|break|case|cast|catch|class|continue|default|do|dynamic|else|enum|extends|extern|final|for|from|function|if|implements|import|in|inline|interface|macro|new|null|operator|overload|override|package|private|public|return|static|super|switch|throw|to|try|typedef|untyped|using|var|while)(?!\.)\b/,
      function: {
        pattern: /\b[a-z_]\w*(?=\s*(?:<[^<>]*>\s*)?\()/i,
        greedy: !0
      },
      operator: /\.{3}|\+\+|--|&&|\|\||->|=>|(?:<<?|>{1,3}|[-+*/%!=&|^])=?|[?:~]/
    }), t.languages.insertBefore("haxe", "string", {
      "string-interpolation": {
        pattern: /'(?:[^'\\]|\\[\s\S])*'/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /(^|[^\\])\$(?:\w+|\{[^{}]+\})/,
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^\$\{?|\}$/,
                alias: "punctuation"
              },
              expression: {
                pattern: /[\s\S]+/,
                inside: t.languages.haxe
              }
            }
          },
          string: /[\s\S]+/
        }
      }
    }), t.languages.insertBefore("haxe", "class-name", {
      regex: {
        pattern: /~\/(?:[^\/\\\r\n]|\\.)+\/[a-z]*/,
        greedy: !0,
        inside: {
          "regex-flags": /\b[a-z]+$/,
          "regex-source": {
            pattern: /^(~\/)[\s\S]+(?=\/$)/,
            lookbehind: !0,
            alias: "language-regex",
            inside: t.languages.regex
          },
          "regex-delimiter": /^~\/|\/$/
        }
      }
    }), t.languages.insertBefore("haxe", "keyword", {
      preprocessor: {
        pattern: /#(?:else|elseif|end|if)\b.*/,
        alias: "property"
      },
      metadata: {
        pattern: /@:?[\w.]+/,
        alias: "symbol"
      },
      reification: {
        pattern: /\$(?:\w+|(?=\{))/,
        alias: "important"
      }
    });
  }
  return haxe_1;
}
var hcl_1, hasRequiredHcl;
function requireHcl() {
  if (hasRequiredHcl) return hcl_1;
  hasRequiredHcl = 1, hcl_1 = n, n.displayName = "hcl", n.aliases = [];
  function n(t) {
    t.languages.hcl = {
      comment: /(?:\/\/|#).*|\/\*[\s\S]*?(?:\*\/|$)/,
      heredoc: {
        pattern: /<<-?(\w+\b)[\s\S]*?^[ \t]*\1/m,
        greedy: !0,
        alias: "string"
      },
      keyword: [
        {
          pattern: /(?:data|resource)\s+(?:"(?:\\[\s\S]|[^\\"])*")(?=\s+"[\w-]+"\s+\{)/i,
          inside: {
            type: {
              pattern: /(resource|data|\s+)(?:"(?:\\[\s\S]|[^\\"])*")/i,
              lookbehind: !0,
              alias: "variable"
            }
          }
        },
        {
          pattern: /(?:backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+(?=\{)/i,
          inside: {
            type: {
              pattern: /(backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+/i,
              lookbehind: !0,
              alias: "variable"
            }
          }
        },
        /[\w-]+(?=\s+\{)/
      ],
      property: [/[-\w\.]+(?=\s*=(?!=))/, /"(?:\\[\s\S]|[^\\"])+"(?=\s*[:=])/],
      string: {
        pattern: /"(?:[^\\$"]|\\[\s\S]|\$(?:(?=")|\$+(?!\$)|[^"${])|\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\})*"/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /(^|[^$])\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\}/,
            lookbehind: !0,
            inside: {
              type: {
                pattern: /(\b(?:count|data|local|module|path|self|terraform|var)\b\.)[\w\*]+/i,
                lookbehind: !0,
                alias: "variable"
              },
              keyword: /\b(?:count|data|local|module|path|self|terraform|var)\b/i,
              function: /\w+(?=\()/,
              string: {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                greedy: !0
              },
              number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
              punctuation: /[!\$#%&'()*+,.\/;<=>@\[\\\]^`{|}~?:]/
            }
          }
        }
      },
      number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
      boolean: /\b(?:false|true)\b/i,
      punctuation: /[=\[\]{}]/
    };
  }
  return hcl_1;
}
var hlsl_1, hasRequiredHlsl;
function requireHlsl() {
  if (hasRequiredHlsl) return hlsl_1;
  hasRequiredHlsl = 1;
  var n = requireC();
  hlsl_1 = t, t.displayName = "hlsl", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.hlsl = g.languages.extend("c", {
      // Regarding keywords and class names:
      // The list of all keywords was split into 'keyword' and 'class-name' tokens based on whether they are capitalized.
      // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-keywords
      // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-reserved-words
      "class-name": [
        g.languages.c["class-name"],
        /\b(?:AppendStructuredBuffer|BlendState|Buffer|ByteAddressBuffer|CompileShader|ComputeShader|ConsumeStructuredBuffer|DepthStencilState|DepthStencilView|DomainShader|GeometryShader|Hullshader|InputPatch|LineStream|OutputPatch|PixelShader|PointStream|RWBuffer|RWByteAddressBuffer|RWStructuredBuffer|RWTexture(?:1D|1DArray|2D|2DArray|3D)|RasterizerState|RenderTargetView|SamplerComparisonState|SamplerState|StructuredBuffer|Texture(?:1D|1DArray|2D|2DArray|2DMS|2DMSArray|3D|Cube|CubeArray)|TriangleStream|VertexShader)\b/
      ],
      keyword: [
        // HLSL keyword
        /\b(?:asm|asm_fragment|auto|break|case|catch|cbuffer|centroid|char|class|column_major|compile|compile_fragment|const|const_cast|continue|default|delete|discard|do|dynamic_cast|else|enum|explicit|export|extern|for|friend|fxgroup|goto|groupshared|if|in|inline|inout|interface|line|lineadj|linear|long|matrix|mutable|namespace|new|nointerpolation|noperspective|operator|out|packoffset|pass|pixelfragment|point|precise|private|protected|public|register|reinterpret_cast|return|row_major|sample|sampler|shared|short|signed|sizeof|snorm|stateblock|stateblock_state|static|static_cast|string|struct|switch|tbuffer|technique|technique10|technique11|template|texture|this|throw|triangle|triangleadj|try|typedef|typename|uniform|union|unorm|unsigned|using|vector|vertexfragment|virtual|void|volatile|while)\b/,
        // scalar, vector, and matrix types
        /\b(?:bool|double|dword|float|half|int|min(?:10float|12int|16(?:float|int|uint))|uint)(?:[1-4](?:x[1-4])?)?\b/
      ],
      // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-grammar#floating-point-numbers
      number: /(?:(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?|\b0x[\da-fA-F]+)[fFhHlLuU]?\b/,
      boolean: /\b(?:false|true)\b/
    });
  }
  return hlsl_1;
}
var hoon_1, hasRequiredHoon;
function requireHoon() {
  if (hasRequiredHoon) return hoon_1;
  hasRequiredHoon = 1, hoon_1 = n, n.displayName = "hoon", n.aliases = [];
  function n(t) {
    t.languages.hoon = {
      comment: {
        pattern: /::.*/,
        greedy: !0
      },
      string: {
        pattern: /"[^"]*"|'[^']*'/,
        greedy: !0
      },
      constant: /%(?:\.[ny]|[\w-]+)/,
      "class-name": /@(?:[a-z0-9-]*[a-z0-9])?|\*/i,
      function: /(?:\+[-+] {2})?(?:[a-z](?:[a-z0-9-]*[a-z0-9])?)/,
      keyword: /\.[\^\+\*=\?]|![><:\.=\?!]|=[>|:,\.\-\^<+;/~\*\?]|\?[>|:\.\-\^<\+&~=@!]|\|[\$_%:\.\-\^~\*=@\?]|\+[|\$\+\*]|:[_\-\^\+~\*]|%[_:\.\-\^\+~\*=]|\^[|:\.\-\+&~\*=\?]|\$[|_%:<>\-\^&~@=\?]|;[:<\+;\/~\*=]|~[>|\$_%<\+\/&=\?!]|--|==/
    };
  }
  return hoon_1;
}
var hpkp_1, hasRequiredHpkp;
function requireHpkp() {
  if (hasRequiredHpkp) return hpkp_1;
  hasRequiredHpkp = 1, hpkp_1 = n, n.displayName = "hpkp", n.aliases = [];
  function n(t) {
    t.languages.hpkp = {
      directive: {
        pattern: /\b(?:includeSubDomains|max-age|pin-sha256|preload|report-to|report-uri|strict)(?=[\s;=]|$)/i,
        alias: "property"
      },
      operator: /=/,
      punctuation: /;/
    };
  }
  return hpkp_1;
}
var hsts_1, hasRequiredHsts;
function requireHsts() {
  if (hasRequiredHsts) return hsts_1;
  hasRequiredHsts = 1, hsts_1 = n, n.displayName = "hsts", n.aliases = [];
  function n(t) {
    t.languages.hsts = {
      directive: {
        pattern: /\b(?:includeSubDomains|max-age|preload)(?=[\s;=]|$)/i,
        alias: "property"
      },
      operator: /=/,
      punctuation: /;/
    };
  }
  return hsts_1;
}
var http_1, hasRequiredHttp;
function requireHttp() {
  if (hasRequiredHttp) return http_1;
  hasRequiredHttp = 1, http_1 = n, n.displayName = "http", n.aliases = [];
  function n(t) {
    (function(g) {
      function d(eA) {
        return RegExp("(^(?:" + eA + "):[ 	]*(?![ 	]))[^]+", "i");
      }
      g.languages.http = {
        "request-line": {
          pattern: /^(?:CONNECT|DELETE|GET|HEAD|OPTIONS|PATCH|POST|PRI|PUT|SEARCH|TRACE)\s(?:https?:\/\/|\/)\S*\sHTTP\/[\d.]+/m,
          inside: {
            // HTTP Method
            method: {
              pattern: /^[A-Z]+\b/,
              alias: "property"
            },
            // Request Target e.g. http://example.com, /path/to/file
            "request-target": {
              pattern: /^(\s)(?:https?:\/\/|\/)\S*(?=\s)/,
              lookbehind: !0,
              alias: "url",
              inside: g.languages.uri
            },
            // HTTP Version
            "http-version": {
              pattern: /^(\s)HTTP\/[\d.]+/,
              lookbehind: !0,
              alias: "property"
            }
          }
        },
        "response-status": {
          pattern: /^HTTP\/[\d.]+ \d+ .+/m,
          inside: {
            // HTTP Version
            "http-version": {
              pattern: /^HTTP\/[\d.]+/,
              alias: "property"
            },
            // Status Code
            "status-code": {
              pattern: /^(\s)\d+(?=\s)/,
              lookbehind: !0,
              alias: "number"
            },
            // Reason Phrase
            "reason-phrase": {
              pattern: /^(\s).+/,
              lookbehind: !0,
              alias: "string"
            }
          }
        },
        header: {
          pattern: /^[\w-]+:.+(?:(?:\r\n?|\n)[ \t].+)*/m,
          inside: {
            "header-value": [
              {
                pattern: d(/Content-Security-Policy/.source),
                lookbehind: !0,
                alias: ["csp", "languages-csp"],
                inside: g.languages.csp
              },
              {
                pattern: d(/Public-Key-Pins(?:-Report-Only)?/.source),
                lookbehind: !0,
                alias: ["hpkp", "languages-hpkp"],
                inside: g.languages.hpkp
              },
              {
                pattern: d(/Strict-Transport-Security/.source),
                lookbehind: !0,
                alias: ["hsts", "languages-hsts"],
                inside: g.languages.hsts
              },
              {
                pattern: d(/[^:]+/.source),
                lookbehind: !0
              }
            ],
            "header-name": {
              pattern: /^[^:]+/,
              alias: "keyword"
            },
            punctuation: /^:/
          }
        }
      };
      var k = g.languages, H = {
        "application/javascript": k.javascript,
        "application/json": k.json || k.javascript,
        "application/xml": k.xml,
        "text/xml": k.xml,
        "text/html": k.html,
        "text/css": k.css,
        "text/plain": k.plain
      }, AA = {
        "application/json": !0,
        "application/xml": !0
      };
      function gA(eA) {
        var iA = eA.replace(/^[a-z]+\//, ""), QA = "\\w+/(?:[\\w.-]+\\+)+" + iA + "(?![+\\w.-])";
        return "(?:" + eA + "|" + QA + ")";
      }
      var IA;
      for (var CA in H)
        if (H[CA]) {
          IA = IA || {};
          var BA = AA[CA] ? gA(CA) : CA;
          IA[CA.replace(/\//g, "-")] = {
            pattern: RegExp(
              "(" + /content-type:\s*/.source + BA + /(?:(?:\r\n?|\n)[\w-].*)*(?:\r(?:\n|(?!\n))|\n)/.source + ")" + // This is a little interesting:
              // The HTTP format spec required 1 empty line before the body to make everything unambiguous.
              // However, when writing code by hand (e.g. to display on a website) people can forget about this,
              // so we want to be liberal here. We will allow the empty line to be omitted if the first line of
              // the body does not start with a [\w-] character (as headers do).
              /[^ \t\w-][\s\S]*/.source,
              "i"
            ),
            lookbehind: !0,
            inside: H[CA]
          };
        }
      IA && g.languages.insertBefore("http", "header", IA);
    })(t);
  }
  return http_1;
}
var ichigojam_1, hasRequiredIchigojam;
function requireIchigojam() {
  if (hasRequiredIchigojam) return ichigojam_1;
  hasRequiredIchigojam = 1, ichigojam_1 = n, n.displayName = "ichigojam", n.aliases = [];
  function n(t) {
    t.languages.ichigojam = {
      comment: /(?:\B'|REM)(?:[^\n\r]*)/i,
      string: {
        pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
        greedy: !0
      },
      number: /\B#[0-9A-F]+|\B`[01]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
      keyword: /\b(?:BEEP|BPS|CASE|CLEAR|CLK|CLO|CLP|CLS|CLT|CLV|CONT|COPY|ELSE|END|FILE|FILES|FOR|GOSUB|GOTO|GSB|IF|INPUT|KBD|LED|LET|LIST|LOAD|LOCATE|LRUN|NEW|NEXT|OUT|PLAY|POKE|PRINT|PWM|REM|RENUM|RESET|RETURN|RIGHT|RTN|RUN|SAVE|SCROLL|SLEEP|SRND|STEP|STOP|SUB|TEMPO|THEN|TO|UART|VIDEO|WAIT)(?:\$|\b)/i,
      function: /\b(?:ABS|ANA|ASC|BIN|BTN|DEC|END|FREE|HELP|HEX|I2CR|I2CW|IN|INKEY|LEN|LINE|PEEK|RND|SCR|SOUND|STR|TICK|USR|VER|VPEEK|ZER)(?:\$|\b)/i,
      label: /(?:\B@\S+)/,
      operator: /<[=>]?|>=?|\|\||&&|[+\-*\/=|&^~!]|\b(?:AND|NOT|OR)\b/i,
      punctuation: /[\[,;:()\]]/
    };
  }
  return ichigojam_1;
}
var icon_1, hasRequiredIcon;
function requireIcon() {
  if (hasRequiredIcon) return icon_1;
  hasRequiredIcon = 1, icon_1 = n, n.displayName = "icon", n.aliases = [];
  function n(t) {
    t.languages.icon = {
      comment: /#.*/,
      string: {
        pattern: /(["'])(?:(?!\1)[^\\\r\n_]|\\.|_(?!\1)(?:\r\n|[\s\S]))*\1/,
        greedy: !0
      },
      number: /\b(?:\d+r[a-z\d]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b|\.\d+\b/i,
      "builtin-keyword": {
        pattern: /&(?:allocated|ascii|clock|collections|cset|current|date|dateline|digits|dump|e|error(?:number|text|value)?|errout|fail|features|file|host|input|lcase|letters|level|line|main|null|output|phi|pi|pos|progname|random|regions|source|storage|subject|time|trace|ucase|version)\b/,
        alias: "variable"
      },
      directive: {
        pattern: /\$\w+/,
        alias: "builtin"
      },
      keyword: /\b(?:break|by|case|create|default|do|else|end|every|fail|global|if|initial|invocable|link|local|next|not|of|procedure|record|repeat|return|static|suspend|then|to|until|while)\b/,
      function: /\b(?!\d)\w+(?=\s*[({]|\s*!\s*\[)/,
      operator: /[+-]:(?!=)|(?:[\/?@^%&]|\+\+?|--?|==?=?|~==?=?|\*\*?|\|\|\|?|<(?:->?|<?=?)|>>?=?)(?::=)?|:(?:=:?)?|[!.\\|~]/,
      punctuation: /[\[\](){},;]/
    };
  }
  return icon_1;
}
var icuMessageFormat_1, hasRequiredIcuMessageFormat;
function requireIcuMessageFormat() {
  if (hasRequiredIcuMessageFormat) return icuMessageFormat_1;
  hasRequiredIcuMessageFormat = 1, icuMessageFormat_1 = n, n.displayName = "icuMessageFormat", n.aliases = [];
  function n(t) {
    (function(g) {
      function d(CA, BA) {
        return BA <= 0 ? /[]/.source : CA.replace(/<SELF>/g, function() {
          return d(CA, BA - 1);
        });
      }
      var k = /'[{}:=,](?:[^']|'')*'(?!')/, H = {
        pattern: /''/,
        greedy: !0,
        alias: "operator"
      }, AA = {
        pattern: k,
        greedy: !0,
        inside: {
          escape: H
        }
      }, gA = d(
        /\{(?:[^{}']|'(?![{},'])|''|<STR>|<SELF>)*\}/.source.replace(
          /<STR>/g,
          function() {
            return k.source;
          }
        ),
        8
      ), IA = {
        pattern: RegExp(gA),
        inside: {
          message: {
            pattern: /^(\{)[\s\S]+(?=\}$)/,
            lookbehind: !0,
            inside: null
            // see below
          },
          "message-delimiter": {
            pattern: /./,
            alias: "punctuation"
          }
        }
      };
      g.languages["icu-message-format"] = {
        argument: {
          pattern: RegExp(gA),
          greedy: !0,
          inside: {
            content: {
              pattern: /^(\{)[\s\S]+(?=\}$)/,
              lookbehind: !0,
              inside: {
                "argument-name": {
                  pattern: /^(\s*)[^{}:=,\s]+/,
                  lookbehind: !0
                },
                "choice-style": {
                  // https://unicode-org.github.io/icu-docs/apidoc/released/icu4c/classicu_1_1ChoiceFormat.html#details
                  pattern: /^(\s*,\s*choice\s*,\s*)\S(?:[\s\S]*\S)?/,
                  lookbehind: !0,
                  inside: {
                    punctuation: /\|/,
                    range: {
                      pattern: /^(\s*)[+-]?(?:\d+(?:\.\d*)?|\u221e)\s*[<#\u2264]/,
                      lookbehind: !0,
                      inside: {
                        operator: /[<#\u2264]/,
                        number: /\S+/
                      }
                    },
                    rest: null
                    // see below
                  }
                },
                "plural-style": {
                  // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/PluralFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                  pattern: /^(\s*,\s*(?:plural|selectordinal)\s*,\s*)\S(?:[\s\S]*\S)?/,
                  lookbehind: !0,
                  inside: {
                    offset: /^offset:\s*\d+/,
                    "nested-message": IA,
                    selector: {
                      pattern: /=\d+|[^{}:=,\s]+/,
                      inside: {
                        keyword: /^(?:few|many|one|other|two|zero)$/
                      }
                    }
                  }
                },
                "select-style": {
                  // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/SelectFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                  pattern: /^(\s*,\s*select\s*,\s*)\S(?:[\s\S]*\S)?/,
                  lookbehind: !0,
                  inside: {
                    "nested-message": IA,
                    selector: {
                      pattern: /[^{}:=,\s]+/,
                      inside: {
                        keyword: /^other$/
                      }
                    }
                  }
                },
                keyword: /\b(?:choice|plural|select|selectordinal)\b/,
                "arg-type": {
                  pattern: /\b(?:date|duration|number|ordinal|spellout|time)\b/,
                  alias: "keyword"
                },
                "arg-skeleton": {
                  pattern: /(,\s*)::[^{}:=,\s]+/,
                  lookbehind: !0
                },
                "arg-style": {
                  pattern: /(,\s*)(?:currency|full|integer|long|medium|percent|short)(?=\s*$)/,
                  lookbehind: !0
                },
                "arg-style-text": {
                  pattern: RegExp(
                    /(^\s*,\s*(?=\S))/.source + d(/(?:[^{}']|'[^']*'|\{(?:<SELF>)?\})+/.source, 8) + "$"
                  ),
                  lookbehind: !0,
                  alias: "string"
                },
                punctuation: /,/
              }
            },
            "argument-delimiter": {
              pattern: /./,
              alias: "operator"
            }
          }
        },
        escape: H,
        string: AA
      }, IA.inside.message.inside = g.languages["icu-message-format"], g.languages["icu-message-format"].argument.inside.content.inside["choice-style"].inside.rest = g.languages["icu-message-format"];
    })(t);
  }
  return icuMessageFormat_1;
}
var idris_1, hasRequiredIdris;
function requireIdris() {
  if (hasRequiredIdris) return idris_1;
  hasRequiredIdris = 1;
  var n = requireHaskell();
  idris_1 = t, t.displayName = "idris", t.aliases = ["idr"];
  function t(g) {
    g.register(n), g.languages.idris = g.languages.extend("haskell", {
      comment: {
        pattern: /(?:(?:--|\|\|\|).*$|\{-[\s\S]*?-\})/m
      },
      keyword: /\b(?:Type|case|class|codata|constructor|corecord|data|do|dsl|else|export|if|implementation|implicit|import|impossible|in|infix|infixl|infixr|instance|interface|let|module|mutual|namespace|of|parameters|partial|postulate|private|proof|public|quoteGoal|record|rewrite|syntax|then|total|using|where|with)\b/,
      builtin: void 0
    }), g.languages.insertBefore("idris", "keyword", {
      "import-statement": {
        pattern: /(^\s*import\s+)(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*/m,
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      }
    }), g.languages.idr = g.languages.idris;
  }
  return idris_1;
}
var iecst_1, hasRequiredIecst;
function requireIecst() {
  if (hasRequiredIecst) return iecst_1;
  hasRequiredIecst = 1, iecst_1 = n, n.displayName = "iecst", n.aliases = [];
  function n(t) {
    t.languages.iecst = {
      comment: [
        {
          pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\(\*[\s\S]*?(?:\*\)|$)|\{[\s\S]*?(?:\}|$))/,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      keyword: [
        /\b(?:END_)?(?:PROGRAM|CONFIGURATION|INTERFACE|FUNCTION_BLOCK|FUNCTION|ACTION|TRANSITION|TYPE|STRUCT|(?:INITIAL_)?STEP|NAMESPACE|LIBRARY|CHANNEL|FOLDER|RESOURCE|VAR_(?:ACCESS|CONFIG|EXTERNAL|GLOBAL|INPUT|IN_OUT|OUTPUT|TEMP)|VAR|METHOD|PROPERTY)\b/i,
        /\b(?:AT|BY|(?:END_)?(?:CASE|FOR|IF|REPEAT|WHILE)|CONSTANT|CONTINUE|DO|ELSE|ELSIF|EXIT|EXTENDS|FROM|GET|GOTO|IMPLEMENTS|JMP|NON_RETAIN|OF|PRIVATE|PROTECTED|PUBLIC|RETAIN|RETURN|SET|TASK|THEN|TO|UNTIL|USING|WITH|__CATCH|__ENDTRY|__FINALLY|__TRY)\b/
      ],
      "class-name": /\b(?:ANY|ARRAY|BOOL|BYTE|U?(?:D|L|S)?INT|(?:D|L)?WORD|DATE(?:_AND_TIME)?|DT|L?REAL|POINTER|STRING|TIME(?:_OF_DAY)?|TOD)\b/,
      address: {
        pattern: /%[IQM][XBWDL][\d.]*|%[IQ][\d.]*/,
        alias: "symbol"
      },
      number: /\b(?:16#[\da-f]+|2#[01_]+|0x[\da-f]+)\b|\b(?:D|DT|T|TOD)#[\d_shmd:]*|\b[A-Z]*#[\d.,_]*|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      boolean: /\b(?:FALSE|NULL|TRUE)\b/,
      operator: /S?R?:?=>?|&&?|\*\*?|<[=>]?|>=?|[-:^/+#]|\b(?:AND|EQ|EXPT|GE|GT|LE|LT|MOD|NE|NOT|OR|XOR)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      punctuation: /[()[\].,;]/
    };
  }
  return iecst_1;
}
var ignore_1, hasRequiredIgnore;
function requireIgnore() {
  if (hasRequiredIgnore) return ignore_1;
  hasRequiredIgnore = 1, ignore_1 = n, n.displayName = "ignore", n.aliases = ["gitignore", "hgignore", "npmignore"];
  function n(t) {
    (function(g) {
      g.languages.ignore = {
        // https://git-scm.com/docs/gitignore
        comment: /^#.*/m,
        entry: {
          pattern: /\S(?:.*(?:(?:\\ )|\S))?/,
          alias: "string",
          inside: {
            operator: /^!|\*\*?|\?/,
            regex: {
              pattern: /(^|[^\\])\[[^\[\]]*\]/,
              lookbehind: !0
            },
            punctuation: /\//
          }
        }
      }, g.languages.gitignore = g.languages.ignore, g.languages.hgignore = g.languages.ignore, g.languages.npmignore = g.languages.ignore;
    })(t);
  }
  return ignore_1;
}
var inform7_1, hasRequiredInform7;
function requireInform7() {
  if (hasRequiredInform7) return inform7_1;
  hasRequiredInform7 = 1, inform7_1 = n, n.displayName = "inform7", n.aliases = [];
  function n(t) {
    t.languages.inform7 = {
      string: {
        pattern: /"[^"]*"/,
        inside: {
          substitution: {
            pattern: /\[[^\[\]]+\]/,
            inside: {
              delimiter: {
                pattern: /\[|\]/,
                alias: "punctuation"
              }
              // See rest below
            }
          }
        }
      },
      comment: {
        pattern: /\[[^\[\]]+\]/,
        greedy: !0
      },
      title: {
        pattern: /^[ \t]*(?:book|chapter|part(?! of)|section|table|volume)\b.+/im,
        alias: "important"
      },
      number: {
        pattern: /(^|[^-])(?:\b\d+(?:\.\d+)?(?:\^\d+)?(?:(?!\d)\w+)?|\b(?:eight|eleven|five|four|nine|one|seven|six|ten|three|twelve|two))\b(?!-)/i,
        lookbehind: !0
      },
      verb: {
        pattern: /(^|[^-])\b(?:answering|applying to|are|asking|attacking|be(?:ing)?|burning|buying|called|carries|carry(?! out)|carrying|climbing|closing|conceal(?:ing|s)?|consulting|contain(?:ing|s)?|cutting|drinking|dropping|eating|enclos(?:es?|ing)|entering|examining|exiting|getting|giving|going|ha(?:s|ve|ving)|hold(?:ing|s)?|impl(?:ies|y)|incorporat(?:es?|ing)|inserting|is|jumping|kissing|listening|locking|looking|mean(?:ing|s)?|opening|provid(?:es?|ing)|pulling|pushing|putting|relat(?:es?|ing)|removing|searching|see(?:ing|s)?|setting|showing|singing|sleeping|smelling|squeezing|support(?:ing|s)?|swearing|switching|taking|tasting|telling|thinking|throwing|touching|turning|tying|unlock(?:ing|s)?|var(?:ies|y|ying)|waiting|waking|waving|wear(?:ing|s)?)\b(?!-)/i,
        lookbehind: !0,
        alias: "operator"
      },
      keyword: {
        pattern: /(^|[^-])\b(?:after|before|carry out|check|continue the action|definition(?= *:)|do nothing|else|end (?:if|the story|unless)|every turn|if|include|instead(?: of)?|let|move|no|now|otherwise|repeat|report|resume the story|rule for|running through|say(?:ing)?|stop the action|test|try(?:ing)?|understand|unless|use|when|while|yes)\b(?!-)/i,
        lookbehind: !0
      },
      property: {
        pattern: /(^|[^-])\b(?:adjacent(?! to)|carried|closed|concealed|contained|dark|described|edible|empty|enclosed|enterable|even|female|fixed in place|full|handled|held|improper-named|incorporated|inedible|invisible|lighted|lit|lock(?:able|ed)|male|marked for listing|mentioned|negative|neuter|non-(?:empty|full|recurring)|odd|opaque|open(?:able)?|plural-named|portable|positive|privately-named|proper-named|provided|publically-named|pushable between rooms|recurring|related|rubbing|scenery|seen|singular-named|supported|swinging|switch(?:able|ed(?: off| on)?)|touch(?:able|ed)|transparent|unconcealed|undescribed|unlit|unlocked|unmarked for listing|unmentioned|unopenable|untouchable|unvisited|variable|visible|visited|wearable|worn)\b(?!-)/i,
        lookbehind: !0,
        alias: "symbol"
      },
      position: {
        pattern: /(^|[^-])\b(?:above|adjacent to|back side of|below|between|down|east|everywhere|front side|here|in|inside(?: from)?|north(?:east|west)?|nowhere|on(?: top of)?|other side|outside(?: from)?|parts? of|regionally in|south(?:east|west)?|through|up|west|within)\b(?!-)/i,
        lookbehind: !0,
        alias: "keyword"
      },
      type: {
        pattern: /(^|[^-])\b(?:actions?|activit(?:ies|y)|actors?|animals?|backdrops?|containers?|devices?|directions?|doors?|holders?|kinds?|lists?|m[ae]n|nobody|nothing|nouns?|numbers?|objects?|people|persons?|player(?:'s holdall)?|regions?|relations?|rooms?|rule(?:book)?s?|scenes?|someone|something|supporters?|tables?|texts?|things?|time|vehicles?|wom[ae]n)\b(?!-)/i,
        lookbehind: !0,
        alias: "variable"
      },
      punctuation: /[.,:;(){}]/
    }, t.languages.inform7.string.inside.substitution.inside.rest = t.languages.inform7, t.languages.inform7.string.inside.substitution.inside.rest.text = {
      pattern: /\S(?:\s*\S)*/,
      alias: "comment"
    };
  }
  return inform7_1;
}
var ini_1, hasRequiredIni;
function requireIni() {
  if (hasRequiredIni) return ini_1;
  hasRequiredIni = 1, ini_1 = n, n.displayName = "ini", n.aliases = [];
  function n(t) {
    t.languages.ini = {
      /**
       * The component mimics the behavior of the Win32 API parser.
       *
       * @see {@link https://github.com/PrismJS/prism/issues/2775#issuecomment-787477723}
       */
      comment: {
        pattern: /(^[ \f\t\v]*)[#;][^\n\r]*/m,
        lookbehind: !0
      },
      section: {
        pattern: /(^[ \f\t\v]*)\[[^\n\r\]]*\]?/m,
        lookbehind: !0,
        inside: {
          "section-name": {
            pattern: /(^\[[ \f\t\v]*)[^ \f\t\v\]]+(?:[ \f\t\v]+[^ \f\t\v\]]+)*/,
            lookbehind: !0,
            alias: "selector"
          },
          punctuation: /\[|\]/
        }
      },
      key: {
        pattern: /(^[ \f\t\v]*)[^ \f\n\r\t\v=]+(?:[ \f\t\v]+[^ \f\n\r\t\v=]+)*(?=[ \f\t\v]*=)/m,
        lookbehind: !0,
        alias: "attr-name"
      },
      value: {
        pattern: /(=[ \f\t\v]*)[^ \f\n\r\t\v]+(?:[ \f\t\v]+[^ \f\n\r\t\v]+)*/,
        lookbehind: !0,
        alias: "attr-value",
        inside: {
          "inner-value": {
            pattern: /^("|').+(?=\1$)/,
            lookbehind: !0
          }
        }
      },
      punctuation: /=/
    };
  }
  return ini_1;
}
var io_1, hasRequiredIo;
function requireIo() {
  if (hasRequiredIo) return io_1;
  hasRequiredIo = 1, io_1 = n, n.displayName = "io", n.aliases = [];
  function n(t) {
    t.languages.io = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*|#.*)/,
        lookbehind: !0,
        greedy: !0
      },
      "triple-quoted-string": {
        pattern: /"""(?:\\[\s\S]|(?!""")[^\\])*"""/,
        greedy: !0,
        alias: "string"
      },
      string: {
        pattern: /"(?:\\.|[^\\\r\n"])*"/,
        greedy: !0
      },
      keyword: /\b(?:activate|activeCoroCount|asString|block|break|call|catch|clone|collectGarbage|compileString|continue|do|doFile|doMessage|doString|else|elseif|exit|for|foreach|forward|getEnvironmentVariable|getSlot|hasSlot|if|ifFalse|ifNil|ifNilEval|ifTrue|isActive|isNil|isResumable|list|message|method|parent|pass|pause|perform|performWithArgList|print|println|proto|raise|raiseResumable|removeSlot|resend|resume|schedulerSleepSeconds|self|sender|setSchedulerSleepSeconds|setSlot|shallowCopy|slotNames|super|system|then|thisBlock|thisContext|try|type|uniqueId|updateSlot|wait|while|write|yield)\b/,
      builtin: /\b(?:Array|AudioDevice|AudioMixer|BigNum|Block|Box|Buffer|CFunction|CGI|Color|Curses|DBM|DNSResolver|DOConnection|DOProxy|DOServer|Date|Directory|Duration|DynLib|Error|Exception|FFT|File|Fnmatch|Font|Future|GL|GLE|GLScissor|GLU|GLUCylinder|GLUQuadric|GLUSphere|GLUT|Host|Image|Importer|LinkList|List|Lobby|Locals|MD5|MP3Decoder|MP3Encoder|Map|Message|Movie|Notification|Number|Object|OpenGL|Point|Protos|Random|Regex|SGML|SGMLElement|SGMLParser|SQLite|Sequence|Server|ShowMessage|SleepyCat|SleepyCatCursor|Socket|SocketManager|Sound|Soup|Store|String|Tree|UDPSender|UPDReceiver|URL|User|Warning|WeakLink)\b/,
      boolean: /\b(?:false|nil|true)\b/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?/i,
      operator: /[=!*/%+\-^&|]=|>>?=?|<<?=?|:?:?=|\+\+?|--?|\*\*?|\/\/?|%|\|\|?|&&?|\b(?:and|not|or|return)\b|@@?|\?\??|\.\./,
      punctuation: /[{}[\];(),.:]/
    };
  }
  return io_1;
}
var j_1, hasRequiredJ;
function requireJ() {
  if (hasRequiredJ) return j_1;
  hasRequiredJ = 1, j_1 = n, n.displayName = "j", n.aliases = [];
  function n(t) {
    t.languages.j = {
      comment: {
        pattern: /\bNB\..*/,
        greedy: !0
      },
      string: {
        pattern: /'(?:''|[^'\r\n])*'/,
        greedy: !0
      },
      keyword: /\b(?:(?:CR|LF|adverb|conjunction|def|define|dyad|monad|noun|verb)\b|(?:assert|break|case|catch[dt]?|continue|do|else|elseif|end|fcase|for|for_\w+|goto_\w+|if|label_\w+|return|select|throw|try|while|whilst)\.)/,
      verb: {
        // Negative look-ahead prevents bad highlighting
        // of ^: ;. =. =: !. !:
        pattern: /(?!\^:|;\.|[=!][.:])(?:\{(?:\.|::?)?|p(?:\.\.?|:)|[=!\]]|[<>+*\-%$|,#][.:]?|[?^]\.?|[;\[]:?|[~}"i][.:]|[ACeEIjLor]\.|(?:[_\/\\qsux]|_?\d):)/,
        alias: "keyword"
      },
      number: /\b_?(?:(?!\d:)\d+(?:\.\d+)?(?:(?:ad|ar|[ejpx])_?\d+(?:\.\d+)?)*(?:b_?[\da-z]+(?:\.[\da-z]+)?)?|_\b(?!\.))/,
      adverb: {
        pattern: /[~}]|[\/\\]\.?|[bfM]\.|t[.:]/,
        alias: "builtin"
      },
      operator: /[=a][.:]|_\./,
      conjunction: {
        pattern: /&(?:\.:?|:)?|[.:@][.:]?|[!D][.:]|[;dHT]\.|`:?|[\^LS]:|"/,
        alias: "variable"
      },
      punctuation: /[()]/
    };
  }
  return j_1;
}
var java_1, hasRequiredJava;
function requireJava() {
  if (hasRequiredJava) return java_1;
  hasRequiredJava = 1, java_1 = n, n.displayName = "java", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, k = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, H = {
        pattern: RegExp(k + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
        lookbehind: !0,
        inside: {
          namespace: {
            pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /\./
        }
      };
      g.languages.java = g.languages.extend("clike", {
        string: {
          pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
          lookbehind: !0,
          greedy: !0
        },
        "class-name": [
          H,
          {
            // variables and parameters
            // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
            pattern: RegExp(
              k + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source
            ),
            lookbehind: !0,
            inside: H.inside
          }
        ],
        keyword: d,
        function: [
          g.languages.clike.function,
          {
            pattern: /(::\s*)[a-z_]\w*/,
            lookbehind: !0
          }
        ],
        number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
        operator: {
          pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
          lookbehind: !0
        }
      }), g.languages.insertBefore("java", "string", {
        "triple-quoted-string": {
          // http://openjdk.java.net/jeps/355#Description
          pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
          greedy: !0,
          alias: "string"
        },
        char: {
          pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
          greedy: !0
        }
      }), g.languages.insertBefore("java", "class-name", {
        annotation: {
          pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
          lookbehind: !0,
          alias: "punctuation"
        },
        generics: {
          pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
          inside: {
            "class-name": H,
            keyword: d,
            punctuation: /[<>(),.:]/,
            operator: /[?&|]/
          }
        },
        namespace: {
          pattern: RegExp(
            /(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(
              /<keyword>/g,
              function() {
                return d.source;
              }
            )
          ),
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        }
      });
    })(t);
  }
  return java_1;
}
var javadoclike_1, hasRequiredJavadoclike;
function requireJavadoclike() {
  if (hasRequiredJavadoclike) return javadoclike_1;
  hasRequiredJavadoclike = 1, javadoclike_1 = n, n.displayName = "javadoclike", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = g.languages.javadoclike = {
        parameter: {
          pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
          lookbehind: !0
        },
        keyword: {
          // keywords are the first word in a line preceded be an `@` or surrounded by curly braces.
          // @word, {@word}
          pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
          lookbehind: !0
        },
        punctuation: /[{}]/
      };
      function k(AA, gA) {
        var IA = "doc-comment", CA = g.languages[AA];
        if (CA) {
          var BA = CA[IA];
          if (!BA) {
            var eA = {};
            eA[IA] = {
              pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
              lookbehind: !0,
              alias: "comment"
            }, CA = g.languages.insertBefore(AA, "comment", eA), BA = CA[IA];
          }
          if (BA instanceof RegExp && (BA = CA[IA] = {
            pattern: BA
          }), Array.isArray(BA))
            for (var iA = 0, QA = BA.length; iA < QA; iA++)
              BA[iA] instanceof RegExp && (BA[iA] = {
                pattern: BA[iA]
              }), gA(BA[iA]);
          else
            gA(BA);
        }
      }
      function H(AA, gA) {
        typeof AA == "string" && (AA = [AA]), AA.forEach(function(IA) {
          k(IA, function(CA) {
            CA.inside || (CA.inside = {}), CA.inside.rest = gA;
          });
        });
      }
      Object.defineProperty(d, "addSupport", {
        value: H
      }), d.addSupport(["java", "javascript", "php"], d);
    })(t);
  }
  return javadoclike_1;
}
var javadoc_1, hasRequiredJavadoc;
function requireJavadoc() {
  if (hasRequiredJavadoc) return javadoc_1;
  hasRequiredJavadoc = 1;
  var n = requireJava(), t = requireJavadoclike();
  javadoc_1 = g, g.displayName = "javadoc", g.aliases = [];
  function g(d) {
    d.register(n), d.register(t), (function(k) {
      var H = /(^(?:[\t ]*(?:\*\s*)*))[^*\s].*$/m, AA = /#\s*\w+(?:\s*\([^()]*\))?/.source, gA = /(?:\b[a-zA-Z]\w+\s*\.\s*)*\b[A-Z]\w*(?:\s*<mem>)?|<mem>/.source.replace(
        /<mem>/g,
        function() {
          return AA;
        }
      );
      k.languages.javadoc = k.languages.extend("javadoclike", {}), k.languages.insertBefore("javadoc", "keyword", {
        reference: {
          pattern: RegExp(
            /(@(?:exception|link|linkplain|see|throws|value)\s+(?:\*\s*)?)/.source + "(?:" + gA + ")"
          ),
          lookbehind: !0,
          inside: {
            function: {
              pattern: /(#\s*)\w+(?=\s*\()/,
              lookbehind: !0
            },
            field: {
              pattern: /(#\s*)\w+/,
              lookbehind: !0
            },
            namespace: {
              pattern: /\b(?:[a-z]\w*\s*\.\s*)+/,
              inside: {
                punctuation: /\./
              }
            },
            "class-name": /\b[A-Z]\w*/,
            keyword: k.languages.java.keyword,
            punctuation: /[#()[\],.]/
          }
        },
        "class-name": {
          // @param <T> the first generic type parameter
          pattern: /(@param\s+)<[A-Z]\w*>/,
          lookbehind: !0,
          inside: {
            punctuation: /[.<>]/
          }
        },
        "code-section": [
          {
            pattern: /(\{@code\s+(?!\s))(?:[^\s{}]|\s+(?![\s}])|\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\})+(?=\s*\})/,
            lookbehind: !0,
            inside: {
              code: {
                // there can't be any HTML inside of {@code} tags
                pattern: H,
                lookbehind: !0,
                inside: k.languages.java,
                alias: "language-java"
              }
            }
          },
          {
            pattern: /(<(code|pre|tt)>(?!<code>)\s*)\S(?:\S|\s+\S)*?(?=\s*<\/\2>)/,
            lookbehind: !0,
            inside: {
              line: {
                pattern: H,
                lookbehind: !0,
                inside: {
                  // highlight HTML tags and entities
                  tag: k.languages.markup.tag,
                  entity: k.languages.markup.entity,
                  code: {
                    // everything else is Java code
                    pattern: /.+/,
                    inside: k.languages.java,
                    alias: "language-java"
                  }
                }
              }
            }
          }
        ],
        tag: k.languages.markup.tag,
        entity: k.languages.markup.entity
      }), k.languages.javadoclike.addSupport("java", k.languages.javadoc);
    })(d);
  }
  return javadoc_1;
}
var javastacktrace_1, hasRequiredJavastacktrace;
function requireJavastacktrace() {
  if (hasRequiredJavastacktrace) return javastacktrace_1;
  hasRequiredJavastacktrace = 1, javastacktrace_1 = n, n.displayName = "javastacktrace", n.aliases = [];
  function n(t) {
    t.languages.javastacktrace = {
      // java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
      // Caused by: java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
      // Caused by: com.example.myproject.MyProjectServletException
      // Caused by: MidLevelException: LowLevelException
      // Suppressed: Resource$CloseFailException: Resource ID = 0
      summary: {
        pattern: /^([\t ]*)(?:(?:Caused by:|Suppressed:|Exception in thread "[^"]*")[\t ]+)?[\w$.]+(?::.*)?$/m,
        lookbehind: !0,
        inside: {
          keyword: {
            pattern: /^([\t ]*)(?:(?:Caused by|Suppressed)(?=:)|Exception in thread)/m,
            lookbehind: !0
          },
          // the current thread if the summary starts with 'Exception in thread'
          string: {
            pattern: /^(\s*)"[^"]*"/,
            lookbehind: !0
          },
          exceptions: {
            pattern: /^(:?\s*)[\w$.]+(?=:|$)/,
            lookbehind: !0,
            inside: {
              "class-name": /[\w$]+$/,
              namespace: /\b[a-z]\w*\b/,
              punctuation: /\./
            }
          },
          message: {
            pattern: /(:\s*)\S.*/,
            lookbehind: !0,
            alias: "string"
          },
          punctuation: /:/
        }
      },
      // at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1166)
      // at org.hsqldb.jdbc.Util.throwError(Unknown Source) here could be some notes
      // at java.base/java.lang.Class.forName0(Native Method)
      // at Util.<init>(Unknown Source)
      // at com.foo.loader/foo@9.0/com.foo.Main.run(Main.java:101)
      // at com.foo.loader//com.foo.bar.App.run(App.java:12)
      // at acme@2.1/org.acme.Lib.test(Lib.java:80)
      // at MyClass.mash(MyClass.java:9)
      //
      // More information:
      // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/StackTraceElement.html#toString()
      //
      // A valid Java module name is defined as:
      //   "A module name consists of one or more Java identifiers (§3.8) separated by "." tokens."
      // https://docs.oracle.com/javase/specs/jls/se9/html/jls-6.html#jls-ModuleName
      //
      // A Java module version is defined by this class:
      // https://docs.oracle.com/javase/9/docs/api/java/lang/module/ModuleDescriptor.Version.html
      // This is the implementation of the `parse` method in JDK13:
      // https://github.com/matcdac/jdk/blob/2305df71d1b7710266ae0956d73927a225132c0f/src/java.base/share/classes/java/lang/module/ModuleDescriptor.java#L1108
      // However, to keep this simple, a version will be matched by the pattern /@[\w$.+-]*/.
      "stack-frame": {
        pattern: /^([\t ]*)at (?:[\w$./]|@[\w$.+-]*\/)+(?:<init>)?\([^()]*\)/m,
        lookbehind: !0,
        inside: {
          keyword: {
            pattern: /^(\s*)at(?= )/,
            lookbehind: !0
          },
          source: [
            // (Main.java:15)
            // (Main.scala:15)
            {
              pattern: /(\()\w+\.\w+:\d+(?=\))/,
              lookbehind: !0,
              inside: {
                file: /^\w+\.\w+/,
                punctuation: /:/,
                "line-number": {
                  pattern: /\b\d+\b/,
                  alias: "number"
                }
              }
            },
            // (Unknown Source)
            // (Native Method)
            // (...something...)
            {
              pattern: /(\()[^()]*(?=\))/,
              lookbehind: !0,
              inside: {
                keyword: /^(?:Native Method|Unknown Source)$/
              }
            }
          ],
          "class-name": /[\w$]+(?=\.(?:<init>|[\w$]+)\()/,
          function: /(?:<init>|[\w$]+)(?=\()/,
          "class-loader": {
            pattern: /(\s)[a-z]\w*(?:\.[a-z]\w*)*(?=\/[\w@$.]*\/)/,
            lookbehind: !0,
            alias: "namespace",
            inside: {
              punctuation: /\./
            }
          },
          module: {
            pattern: /([\s/])[a-z]\w*(?:\.[a-z]\w*)*(?:@[\w$.+-]*)?(?=\/)/,
            lookbehind: !0,
            inside: {
              version: {
                pattern: /(@)[\s\S]+/,
                lookbehind: !0,
                alias: "number"
              },
              punctuation: /[@.]/
            }
          },
          namespace: {
            pattern: /(?:\b[a-z]\w*\.)+/,
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /[()/.]/
        }
      },
      // ... 32 more
      // ... 32 common frames omitted
      more: {
        pattern: /^([\t ]*)\.{3} \d+ [a-z]+(?: [a-z]+)*/m,
        lookbehind: !0,
        inside: {
          punctuation: /\.{3}/,
          number: /\d+/,
          keyword: /\b[a-z]+(?: [a-z]+)*\b/
        }
      }
    };
  }
  return javastacktrace_1;
}
var jexl_1, hasRequiredJexl;
function requireJexl() {
  if (hasRequiredJexl) return jexl_1;
  hasRequiredJexl = 1, jexl_1 = n, n.displayName = "jexl", n.aliases = [];
  function n(t) {
    t.languages.jexl = {
      string: /(["'])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
      transform: {
        pattern: /(\|\s*)[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*/,
        alias: "function",
        lookbehind: !0
      },
      function: /[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*\s*(?=\()/,
      number: /\b\d+(?:\.\d+)?\b|\B\.\d+\b/,
      operator: /[<>!]=?|-|\+|&&|==|\|\|?|\/\/?|[?:*^%]/,
      boolean: /\b(?:false|true)\b/,
      keyword: /\bin\b/,
      punctuation: /[{}[\](),.]/
    };
  }
  return jexl_1;
}
var jolie_1, hasRequiredJolie;
function requireJolie() {
  if (hasRequiredJolie) return jolie_1;
  hasRequiredJolie = 1, jolie_1 = n, n.displayName = "jolie", n.aliases = [];
  function n(t) {
    t.languages.jolie = t.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])"(?:\\[\s\S]|[^"\\])*"/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": {
        pattern: /((?:\b(?:as|courier|embed|in|inputPort|outputPort|service)\b|@)[ \t]*)\w+/,
        lookbehind: !0
      },
      keyword: /\b(?:as|cH|comp|concurrent|constants|courier|cset|csets|default|define|else|embed|embedded|execution|exit|extender|for|foreach|forward|from|global|if|import|in|include|init|inputPort|install|instanceof|interface|is_defined|linkIn|linkOut|main|new|nullProcess|outputPort|over|private|provide|public|scope|sequential|service|single|spawn|synchronized|this|throw|throws|type|undef|until|while|with)\b/,
      function: /\b[a-z_]\w*(?=[ \t]*[@(])/i,
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?l?/i,
      operator: /-[-=>]?|\+[+=]?|<[<=]?|[>=*!]=?|&&|\|\||[?\/%^@|]/,
      punctuation: /[()[\]{},;.:]/,
      builtin: /\b(?:Byte|any|bool|char|double|enum|float|int|length|long|ranges|regex|string|undefined|void)\b/
    }), t.languages.insertBefore("jolie", "keyword", {
      aggregates: {
        pattern: /(\bAggregates\s*:\s*)(?:\w+(?:\s+with\s+\w+)?\s*,\s*)*\w+(?:\s+with\s+\w+)?/,
        lookbehind: !0,
        inside: {
          keyword: /\bwith\b/,
          "class-name": /\w+/,
          punctuation: /,/
        }
      },
      redirects: {
        pattern: /(\bRedirects\s*:\s*)(?:\w+\s*=>\s*\w+\s*,\s*)*(?:\w+\s*=>\s*\w+)/,
        lookbehind: !0,
        inside: {
          punctuation: /,/,
          "class-name": /\w+/,
          operator: /=>/
        }
      },
      property: {
        pattern: /\b(?:Aggregates|[Ii]nterfaces|Java|Javascript|Jolie|[Ll]ocation|OneWay|[Pp]rotocol|Redirects|RequestResponse)\b(?=[ \t]*:)/
      }
    });
  }
  return jolie_1;
}
var jq_1, hasRequiredJq;
function requireJq() {
  if (hasRequiredJq) return jq_1;
  hasRequiredJq = 1, jq_1 = n, n.displayName = "jq", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /\\\((?:[^()]|\([^()]*\))*\)/.source, k = RegExp(
        /(^|[^\\])"(?:[^"\r\n\\]|\\[^\r\n(]|__)*"/.source.replace(
          /__/g,
          function() {
            return d;
          }
        )
      ), H = {
        interpolation: {
          pattern: RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + d),
          lookbehind: !0,
          inside: {
            content: {
              pattern: /^(\\\()[\s\S]+(?=\)$)/,
              lookbehind: !0,
              inside: null
              // see below
            },
            punctuation: /^\\\(|\)$/
          }
        }
      }, AA = g.languages.jq = {
        comment: /#.*/,
        property: {
          pattern: RegExp(k.source + /(?=\s*:(?!:))/.source),
          lookbehind: !0,
          greedy: !0,
          inside: H
        },
        string: {
          pattern: k,
          lookbehind: !0,
          greedy: !0,
          inside: H
        },
        function: {
          pattern: /(\bdef\s+)[a-z_]\w+/i,
          lookbehind: !0
        },
        variable: /\B\$\w+/,
        "property-literal": {
          pattern: /\b[a-z_]\w*(?=\s*:(?!:))/i,
          alias: "property"
        },
        keyword: /\b(?:as|break|catch|def|elif|else|end|foreach|if|import|include|label|module|modulemeta|null|reduce|then|try|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /(?:\b\d+\.|\B\.)?\b\d+(?:[eE][+-]?\d+)?\b/,
        operator: [
          {
            pattern: /\|=?/,
            alias: "pipe"
          },
          /\.\.|[!=<>]?=|\?\/\/|\/\/=?|[-+*/%]=?|[<>?]|\b(?:and|not|or)\b/
        ],
        "c-style-function": {
          pattern: /\b[a-z_]\w*(?=\s*\()/i,
          alias: "function"
        },
        punctuation: /::|[()\[\]{},:;]|\.(?=\s*[\[\w$])/,
        dot: {
          pattern: /\./,
          alias: "important"
        }
      };
      H.interpolation.inside.content.inside = AA;
    })(t);
  }
  return jq_1;
}
var jsExtras_1, hasRequiredJsExtras;
function requireJsExtras() {
  if (hasRequiredJsExtras) return jsExtras_1;
  hasRequiredJsExtras = 1, jsExtras_1 = n, n.displayName = "jsExtras", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.insertBefore("javascript", "function-variable", {
        "method-variable": {
          pattern: RegExp(
            "(\\.\\s*)" + g.languages.javascript["function-variable"].pattern.source
          ),
          lookbehind: !0,
          alias: ["function-variable", "method", "function", "property-access"]
        }
      }), g.languages.insertBefore("javascript", "function", {
        method: {
          pattern: RegExp(
            "(\\.\\s*)" + g.languages.javascript.function.source
          ),
          lookbehind: !0,
          alias: ["function", "property-access"]
        }
      }), g.languages.insertBefore("javascript", "constant", {
        "known-class-name": [
          {
            // standard built-ins
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
            pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
            alias: "class-name"
          },
          {
            // errors
            pattern: /\b(?:[A-Z]\w*)Error\b/,
            alias: "class-name"
          }
        ]
      });
      function d(CA, BA) {
        return RegExp(
          CA.replace(/<ID>/g, function() {
            return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
          }),
          BA
        );
      }
      g.languages.insertBefore("javascript", "keyword", {
        imports: {
          // https://tc39.es/ecma262/#sec-imports
          pattern: d(
            /(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source
          ),
          lookbehind: !0,
          inside: g.languages.javascript
        },
        exports: {
          // https://tc39.es/ecma262/#sec-exports
          pattern: d(
            /(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source
          ),
          lookbehind: !0,
          inside: g.languages.javascript
        }
      }), g.languages.javascript.keyword.unshift(
        {
          pattern: /\b(?:as|default|export|from|import)\b/,
          alias: "module"
        },
        {
          pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
          alias: "control-flow"
        },
        {
          pattern: /\bnull\b/,
          alias: ["null", "nil"]
        },
        {
          pattern: /\bundefined\b/,
          alias: "nil"
        }
      ), g.languages.insertBefore("javascript", "operator", {
        spread: {
          pattern: /\.{3}/,
          alias: "operator"
        },
        arrow: {
          pattern: /=>/,
          alias: "operator"
        }
      }), g.languages.insertBefore("javascript", "punctuation", {
        "property-access": {
          pattern: d(/(\.\s*)#?<ID>/.source),
          lookbehind: !0
        },
        "maybe-class-name": {
          pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
          lookbehind: !0
        },
        dom: {
          // this contains only a few commonly used DOM variables
          pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
          alias: "variable"
        },
        console: {
          pattern: /\bconsole(?=\s*\.)/,
          alias: "class-name"
        }
      });
      for (var k = [
        "function",
        "function-variable",
        "method",
        "method-variable",
        "property-access"
      ], H = 0; H < k.length; H++) {
        var AA = k[H], gA = g.languages.javascript[AA];
        g.util.type(gA) === "RegExp" && (gA = g.languages.javascript[AA] = {
          pattern: gA
        });
        var IA = gA.inside || {};
        gA.inside = IA, IA["maybe-class-name"] = /^[A-Z][\s\S]*/;
      }
    })(t);
  }
  return jsExtras_1;
}
var jsTemplates_1, hasRequiredJsTemplates;
function requireJsTemplates() {
  if (hasRequiredJsTemplates) return jsTemplates_1;
  hasRequiredJsTemplates = 1, jsTemplates_1 = n, n.displayName = "jsTemplates", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = g.languages.javascript["template-string"], k = d.pattern.source, H = d.inside.interpolation, AA = H.inside["interpolation-punctuation"], gA = H.pattern.source;
      function IA(oA, EA) {
        if (g.languages[oA])
          return {
            pattern: RegExp("((?:" + EA + ")\\s*)" + k),
            lookbehind: !0,
            greedy: !0,
            inside: {
              "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
              },
              "embedded-code": {
                pattern: /[\s\S]+/,
                alias: oA
              }
            }
          };
      }
      g.languages.javascript["template-string"] = [
        // styled-jsx:
        //   css`a { color: #25F; }`
        // styled-components:
        //   styled.h1`color: red;`
        IA(
          "css",
          /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source
        ),
        // html`<p></p>`
        // div.innerHTML = `<p></p>`
        IA("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
        // svg`<path fill="#fff" d="M55.37 ..."/>`
        IA("svg", /\bsvg/.source),
        // md`# h1`, markdown`## h2`
        IA("markdown", /\b(?:markdown|md)/.source),
        // gql`...`, graphql`...`, graphql.experimental`...`
        IA(
          "graphql",
          /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source
        ),
        // sql`...`
        IA("sql", /\bsql/.source),
        // vanilla template string
        d
      ].filter(Boolean);
      function CA(oA, EA) {
        return "___" + EA.toUpperCase() + "_" + oA + "___";
      }
      function BA(oA, EA, aA) {
        var nA = {
          code: oA,
          grammar: EA,
          language: aA
        };
        return g.hooks.run("before-tokenize", nA), nA.tokens = g.tokenize(nA.code, nA.grammar), g.hooks.run("after-tokenize", nA), nA.tokens;
      }
      function eA(oA) {
        var EA = {};
        EA["interpolation-punctuation"] = AA;
        var aA = g.tokenize(oA, EA);
        if (aA.length === 3) {
          var nA = [1, 1];
          nA.push.apply(
            nA,
            BA(aA[1], g.languages.javascript, "javascript")
          ), aA.splice.apply(aA, nA);
        }
        return new g.Token(
          "interpolation",
          aA,
          H.alias,
          oA
        );
      }
      function iA(oA, EA, aA) {
        var nA = g.tokenize(oA, {
          interpolation: {
            pattern: RegExp(gA),
            lookbehind: !0
          }
        }), lA = 0, cA = {}, sA = nA.map(function(dA) {
          if (typeof dA == "string")
            return dA;
          for (var GA = dA.content, DA; oA.indexOf(
            DA = CA(lA++, aA)
          ) !== -1; )
            ;
          return cA[DA] = GA, DA;
        }).join(""), rA = BA(sA, EA, aA), uA = Object.keys(cA);
        lA = 0;
        function hA(dA) {
          for (var GA = 0; GA < dA.length; GA++) {
            if (lA >= uA.length)
              return;
            var DA = dA[GA];
            if (typeof DA == "string" || typeof DA.content == "string") {
              var wA = uA[lA], bA = typeof DA == "string" ? DA : (
                /** @type {string} */
                DA.content
              ), yA = bA.indexOf(wA);
              if (yA !== -1) {
                ++lA;
                var pA = bA.substring(0, yA), MA = eA(
                  cA[wA]
                ), LA = bA.substring(yA + wA.length), xA = [];
                if (pA && xA.push(pA), xA.push(MA), LA) {
                  var TA = [LA];
                  hA(TA), xA.push.apply(xA, TA);
                }
                typeof DA == "string" ? (dA.splice.apply(dA, [GA, 1].concat(xA)), GA += xA.length - 1) : DA.content = xA;
              }
            } else {
              var NA = DA.content;
              Array.isArray(NA) ? hA(NA) : hA([NA]);
            }
          }
        }
        return hA(rA), new g.Token(
          aA,
          rA,
          "language-" + aA,
          oA
        );
      }
      var QA = {
        javascript: !0,
        js: !0,
        typescript: !0,
        ts: !0,
        jsx: !0,
        tsx: !0
      };
      g.hooks.add("after-tokenize", function(oA) {
        if (!(oA.language in QA))
          return;
        function EA(aA) {
          for (var nA = 0, lA = aA.length; nA < lA; nA++) {
            var cA = aA[nA];
            if (typeof cA != "string") {
              var sA = cA.content;
              if (!Array.isArray(sA)) {
                typeof sA != "string" && EA([sA]);
                continue;
              }
              if (cA.type === "template-string") {
                var rA = sA[1];
                if (sA.length === 3 && typeof rA != "string" && rA.type === "embedded-code") {
                  var uA = tA(rA), hA = rA.alias, dA = Array.isArray(hA) ? hA[0] : hA, GA = g.languages[dA];
                  if (!GA)
                    continue;
                  sA[1] = iA(uA, GA, dA);
                }
              } else
                EA(sA);
            }
          }
        }
        EA(oA.tokens);
      });
      function tA(oA) {
        return typeof oA == "string" ? oA : Array.isArray(oA) ? oA.map(tA).join("") : tA(oA.content);
      }
    })(t);
  }
  return jsTemplates_1;
}
var typescript_1, hasRequiredTypescript;
function requireTypescript() {
  if (hasRequiredTypescript) return typescript_1;
  hasRequiredTypescript = 1, typescript_1 = n, n.displayName = "typescript", n.aliases = ["ts"];
  function n(t) {
    (function(g) {
      g.languages.typescript = g.languages.extend("javascript", {
        "class-name": {
          pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
      }), g.languages.typescript.keyword.push(
        /\b(?:abstract|declare|is|keyof|readonly|require)\b/,
        // keywords that have to be followed by an identifier
        /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
        // This is for `import type *, {}`
        /\btype\b(?=\s*(?:[\{*]|$))/
      ), delete g.languages.typescript.parameter, delete g.languages.typescript["literal-property"];
      var d = g.languages.extend("typescript", {});
      delete d["class-name"], g.languages.typescript["class-name"].inside = d, g.languages.insertBefore("typescript", "function", {
        decorator: {
          pattern: /@[$\w\xA0-\uFFFF]+/,
          inside: {
            at: {
              pattern: /^@/,
              alias: "operator"
            },
            function: /^[\s\S]+/
          }
        },
        "generic-function": {
          // e.g. foo<T extends "bar" | "baz">( ...
          pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
          greedy: !0,
          inside: {
            function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
            generic: {
              pattern: /<[\s\S]+/,
              // everything after the first <
              alias: "class-name",
              inside: d
            }
          }
        }
      }), g.languages.ts = g.languages.typescript;
    })(t);
  }
  return typescript_1;
}
var jsdoc_1, hasRequiredJsdoc;
function requireJsdoc() {
  if (hasRequiredJsdoc) return jsdoc_1;
  hasRequiredJsdoc = 1;
  var n = requireJavadoclike(), t = requireTypescript();
  jsdoc_1 = g, g.displayName = "jsdoc", g.aliases = [];
  function g(d) {
    d.register(n), d.register(t), (function(k) {
      var H = k.languages.javascript, AA = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, gA = "(@(?:arg|argument|param|property)\\s+(?:" + AA + "\\s+)?)";
      k.languages.jsdoc = k.languages.extend("javadoclike", {
        parameter: {
          // @param {string} foo - foo bar
          pattern: RegExp(
            gA + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source
          ),
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        }
      }), k.languages.insertBefore("jsdoc", "keyword", {
        "optional-parameter": {
          // @param {string} [baz.foo="bar"] foo bar
          pattern: RegExp(
            gA + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source
          ),
          lookbehind: !0,
          inside: {
            parameter: {
              pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
              lookbehind: !0,
              inside: {
                punctuation: /\./
              }
            },
            code: {
              pattern: /(=)[\s\S]*(?=\]$)/,
              lookbehind: !0,
              inside: H,
              alias: "language-javascript"
            },
            punctuation: /[=[\]]/
          }
        },
        "class-name": [
          {
            pattern: RegExp(
              /(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(
                /<TYPE>/g,
                function() {
                  return AA;
                }
              )
            ),
            lookbehind: !0,
            inside: {
              punctuation: /\./
            }
          },
          {
            pattern: RegExp("(@[a-z]+\\s+)" + AA),
            lookbehind: !0,
            inside: {
              string: H.string,
              number: H.number,
              boolean: H.boolean,
              keyword: k.languages.typescript.keyword,
              operator: /=>|\.\.\.|[&|?:*]/,
              punctuation: /[.,;=<>{}()[\]]/
            }
          }
        ],
        example: {
          pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
          lookbehind: !0,
          inside: {
            code: {
              pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
              lookbehind: !0,
              inside: H,
              alias: "language-javascript"
            }
          }
        }
      }), k.languages.javadoclike.addSupport("javascript", k.languages.jsdoc);
    })(d);
  }
  return jsdoc_1;
}
var json_1, hasRequiredJson;
function requireJson() {
  if (hasRequiredJson) return json_1;
  hasRequiredJson = 1, json_1 = n, n.displayName = "json", n.aliases = ["webmanifest"];
  function n(t) {
    t.languages.json = {
      property: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: !0
      },
      number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      punctuation: /[{}[\],]/,
      operator: /:/,
      boolean: /\b(?:false|true)\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword"
      }
    }, t.languages.webmanifest = t.languages.json;
  }
  return json_1;
}
var json5_1, hasRequiredJson5;
function requireJson5() {
  if (hasRequiredJson5) return json5_1;
  hasRequiredJson5 = 1;
  var n = requireJson();
  json5_1 = t, t.displayName = "json5", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      var k = /("|')(?:\\(?:\r\n?|\n|.)|(?!\1)[^\\\r\n])*\1/;
      d.languages.json5 = d.languages.extend("json", {
        property: [
          {
            pattern: RegExp(k.source + "(?=\\s*:)"),
            greedy: !0
          },
          {
            pattern: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/,
            alias: "unquoted"
          }
        ],
        string: {
          pattern: k,
          greedy: !0
        },
        number: /[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/
      });
    })(g);
  }
  return json5_1;
}
var jsonp_1, hasRequiredJsonp;
function requireJsonp() {
  if (hasRequiredJsonp) return jsonp_1;
  hasRequiredJsonp = 1;
  var n = requireJson();
  jsonp_1 = t, t.displayName = "jsonp", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.jsonp = g.languages.extend("json", {
      punctuation: /[{}[\]();,.]/
    }), g.languages.insertBefore("jsonp", "punctuation", {
      function: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*\()/
    });
  }
  return jsonp_1;
}
var jsstacktrace_1, hasRequiredJsstacktrace;
function requireJsstacktrace() {
  if (hasRequiredJsstacktrace) return jsstacktrace_1;
  hasRequiredJsstacktrace = 1, jsstacktrace_1 = n, n.displayName = "jsstacktrace", n.aliases = [];
  function n(t) {
    t.languages.jsstacktrace = {
      "error-message": {
        pattern: /^\S.*/m,
        alias: "string"
      },
      "stack-frame": {
        pattern: /(^[ \t]+)at[ \t].*/m,
        lookbehind: !0,
        inside: {
          "not-my-code": {
            pattern: /^at[ \t]+(?!\s)(?:node\.js|<unknown>|.*(?:node_modules|\(<anonymous>\)|\(<unknown>|<anonymous>$|\(internal\/|\(node\.js)).*/m,
            alias: "comment"
          },
          filename: {
            pattern: /(\bat\s+(?!\s)|\()(?:[a-zA-Z]:)?[^():]+(?=:)/,
            lookbehind: !0,
            alias: "url"
          },
          function: {
            pattern: /(\bat\s+(?:new\s+)?)(?!\s)[_$a-zA-Z\xA0-\uFFFF<][.$\w\xA0-\uFFFF<>]*/,
            lookbehind: !0,
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /[()]/,
          keyword: /\b(?:at|new)\b/,
          alias: {
            pattern: /\[(?:as\s+)?(?!\s)[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\]/,
            alias: "variable"
          },
          "line-number": {
            pattern: /:\d+(?::\d+)?\b/,
            alias: "number",
            inside: {
              punctuation: /:/
            }
          }
        }
      }
    };
  }
  return jsstacktrace_1;
}
var jsx_1, hasRequiredJsx;
function requireJsx() {
  if (hasRequiredJsx) return jsx_1;
  hasRequiredJsx = 1, jsx_1 = n, n.displayName = "jsx", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = g.util.clone(g.languages.javascript), k = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, H = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, AA = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
      function gA(BA, eA) {
        return BA = BA.replace(/<S>/g, function() {
          return k;
        }).replace(/<BRACES>/g, function() {
          return H;
        }).replace(/<SPREAD>/g, function() {
          return AA;
        }), RegExp(BA, eA);
      }
      AA = gA(AA).source, g.languages.jsx = g.languages.extend("markup", d), g.languages.jsx.tag.pattern = gA(
        /<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source
      ), g.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, g.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, g.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, g.languages.jsx.tag.inside.comment = d.comment, g.languages.insertBefore(
        "inside",
        "attr-name",
        {
          spread: {
            pattern: gA(/<SPREAD>/.source),
            inside: g.languages.jsx
          }
        },
        g.languages.jsx.tag
      ), g.languages.insertBefore(
        "inside",
        "special-attr",
        {
          script: {
            // Allow for two levels of nesting
            pattern: gA(/=<BRACES>/.source),
            alias: "language-javascript",
            inside: {
              "script-punctuation": {
                pattern: /^=(?=\{)/,
                alias: "punctuation"
              },
              rest: g.languages.jsx
            }
          }
        },
        g.languages.jsx.tag
      );
      var IA = function(BA) {
        return BA ? typeof BA == "string" ? BA : typeof BA.content == "string" ? BA.content : BA.content.map(IA).join("") : "";
      }, CA = function(BA) {
        for (var eA = [], iA = 0; iA < BA.length; iA++) {
          var QA = BA[iA], tA = !1;
          if (typeof QA != "string" && (QA.type === "tag" && QA.content[0] && QA.content[0].type === "tag" ? QA.content[0].content[0].content === "</" ? eA.length > 0 && eA[eA.length - 1].tagName === IA(QA.content[0].content[1]) && eA.pop() : QA.content[QA.content.length - 1].content === "/>" || eA.push({
            tagName: IA(QA.content[0].content[1]),
            openedBraces: 0
          }) : eA.length > 0 && QA.type === "punctuation" && QA.content === "{" ? eA[eA.length - 1].openedBraces++ : eA.length > 0 && eA[eA.length - 1].openedBraces > 0 && QA.type === "punctuation" && QA.content === "}" ? eA[eA.length - 1].openedBraces-- : tA = !0), (tA || typeof QA == "string") && eA.length > 0 && eA[eA.length - 1].openedBraces === 0) {
            var oA = IA(QA);
            iA < BA.length - 1 && (typeof BA[iA + 1] == "string" || BA[iA + 1].type === "plain-text") && (oA += IA(BA[iA + 1]), BA.splice(iA + 1, 1)), iA > 0 && (typeof BA[iA - 1] == "string" || BA[iA - 1].type === "plain-text") && (oA = IA(BA[iA - 1]) + oA, BA.splice(iA - 1, 1), iA--), BA[iA] = new g.Token(
              "plain-text",
              oA,
              null,
              oA
            );
          }
          QA.content && typeof QA.content != "string" && CA(QA.content);
        }
      };
      g.hooks.add("after-tokenize", function(BA) {
        BA.language !== "jsx" && BA.language !== "tsx" || CA(BA.tokens);
      });
    })(t);
  }
  return jsx_1;
}
var julia_1, hasRequiredJulia;
function requireJulia() {
  if (hasRequiredJulia) return julia_1;
  hasRequiredJulia = 1, julia_1 = n, n.displayName = "julia", n.aliases = [];
  function n(t) {
    t.languages.julia = {
      comment: {
        // support one level of nested comments
        // https://github.com/JuliaLang/julia/pull/6128
        pattern: /(^|[^\\])(?:#=(?:[^#=]|=(?!#)|#(?!=)|#=(?:[^#=]|=(?!#)|#(?!=))*=#)*=#|#.*)/,
        lookbehind: !0
      },
      regex: {
        // https://docs.julialang.org/en/v1/manual/strings/#Regular-Expressions-1
        pattern: /r"(?:\\.|[^"\\\r\n])*"[imsx]{0,4}/,
        greedy: !0
      },
      string: {
        // https://docs.julialang.org/en/v1/manual/strings/#String-Basics-1
        // https://docs.julialang.org/en/v1/manual/strings/#non-standard-string-literals-1
        // https://docs.julialang.org/en/v1/manual/running-external-programs/#Running-External-Programs-1
        pattern: /"""[\s\S]+?"""|(?:\b\w+)?"(?:\\.|[^"\\\r\n])*"|`(?:[^\\`\r\n]|\\.)*`/,
        greedy: !0
      },
      char: {
        // https://docs.julialang.org/en/v1/manual/strings/#man-characters-1
        pattern: /(^|[^\w'])'(?:\\[^\r\n][^'\r\n]*|[^\\\r\n])'/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /\b(?:abstract|baremodule|begin|bitstype|break|catch|ccall|const|continue|do|else|elseif|end|export|finally|for|function|global|if|immutable|import|importall|in|let|local|macro|module|print|println|quote|return|struct|try|type|typealias|using|while)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /(?:\b(?=\d)|\B(?=\.))(?:0[box])?(?:[\da-f]+(?:_[\da-f]+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[efp][+-]?\d+(?:_\d+)*)?j?/i,
      // https://docs.julialang.org/en/v1/manual/mathematical-operations/
      // https://docs.julialang.org/en/v1/manual/mathematical-operations/#Operator-Precedence-and-Associativity-1
      operator: /&&|\|\||[-+*^%÷⊻&$\\]=?|\/[\/=]?|!=?=?|\|[=>]?|<(?:<=?|[=:|])?|>(?:=|>>?=?)?|==?=?|[~≠≤≥'√∛]/,
      punctuation: /::?|[{}[\]();,.?]/,
      // https://docs.julialang.org/en/v1/base/numbers/#Base.im
      constant: /\b(?:(?:Inf|NaN)(?:16|32|64)?|im|pi)\b|[πℯ]/
    };
  }
  return julia_1;
}
var keepalived_1, hasRequiredKeepalived;
function requireKeepalived() {
  if (hasRequiredKeepalived) return keepalived_1;
  hasRequiredKeepalived = 1, keepalived_1 = n, n.displayName = "keepalived", n.aliases = [];
  function n(t) {
    t.languages.keepalived = {
      comment: {
        pattern: /[#!].*/,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/,
        lookbehind: !0,
        greedy: !0
      },
      // support IPv4, IPv6, subnet mask
      ip: {
        pattern: RegExp(
          /\b(?:(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){5}:(?:[\da-f]{1,4}:)?[\da-f]{1,4}|(?:[\da-f]{1,4}:){4}:(?:[\da-f]{1,4}:){0,2}[\da-f]{1,4}|(?:[\da-f]{1,4}:){3}:(?:[\da-f]{1,4}:){0,3}[\da-f]{1,4}|(?:[\da-f]{1,4}:){2}:(?:[\da-f]{1,4}:){0,4}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}<ipv4>|(?:[\da-f]{1,4}:){0,5}:<ipv4>|::(?:[\da-f]{1,4}:){0,5}<ipv4>|[\da-f]{1,4}::(?:[\da-f]{1,4}:){0,5}[\da-f]{1,4}|::(?:[\da-f]{1,4}:){0,6}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:)(?:\/\d{1,3})?|<ipv4>(?:\/\d{1,2})?)\b/.source.replace(
            /<ipv4>/g,
            function() {
              return /(?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d))/.source;
            }
          ),
          "i"
        ),
        alias: "number"
      },
      // support *nix / Windows, directory / file
      path: {
        pattern: /(\s)\/(?:[^\/\s]+\/)*[^\/\s]*|\b[a-zA-Z]:\\(?:[^\\\s]+\\)*[^\\\s]*/,
        lookbehind: !0,
        alias: "string"
      },
      variable: /\$\{?\w+\}?/,
      email: {
        pattern: /[\w-]+@[\w-]+(?:\.[\w-]{2,3}){1,2}/,
        alias: "string"
      },
      "conditional-configuration": {
        pattern: /@\^?[\w-]+/,
        alias: "variable"
      },
      operator: /=/,
      property: /\b(?:BFD_CHECK|DNS_CHECK|FILE_CHECK|HTTP_GET|MISC_CHECK|NAME|PING_CHECK|SCRIPTS|SMTP_CHECK|SSL|SSL_GET|TCP_CHECK|UDP_CHECK|accept|advert_int|alpha|auth_pass|auth_type|authentication|bfd_cpu_affinity|bfd_instance|bfd_no_swap|bfd_priority|bfd_process_name|bfd_rlimit_rttime|bfd_rt_priority|bind_if|bind_port|bindto|ca|certificate|check_unicast_src|checker|checker_cpu_affinity|checker_log_all_failures|checker_no_swap|checker_priority|checker_rlimit_rttime|checker_rt_priority|child_wait_time|connect_ip|connect_port|connect_timeout|dbus_service_name|debug|default_interface|delay|delay_before_retry|delay_loop|digest|dont_track_primary|dynamic|dynamic_interfaces|enable_(?:dbus|script_security|sni|snmp_checker|snmp_rfc|snmp_rfcv2|snmp_rfcv3|snmp_vrrp|traps)|end|fall|fast_recovery|file|flag-[123]|fork_delay|full_command|fwmark|garp_group|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|global_defs|global_tracking|gna_interval|group|ha_suspend|hashed|helo_name|higher_prio_send_advert|hoplimit|http_protocol|hysteresis|idle_tx|include|inhibit_on_failure|init_fail|init_file|instance|interface|interfaces|interval|ip_family|ipvs_process_name|keepalived.conf|kernel_rx_buf_size|key|linkbeat_interfaces|linkbeat_use_polling|log_all_failures|log_unknown_vrids|lower_prio_no_advert|lthreshold|lvs_flush|lvs_flush_onstop|lvs_method|lvs_netlink_cmd_rcv_bufs|lvs_netlink_cmd_rcv_bufs_force|lvs_netlink_monitor_rcv_bufs|lvs_netlink_monitor_rcv_bufs_force|lvs_notify_fifo|lvs_notify_fifo_script|lvs_sched|lvs_sync_daemon|max_auto_priority|max_hops|mcast_src_ip|mh-fallback|mh-port|min_auto_priority_delay|min_rx|min_tx|misc_dynamic|misc_path|misc_timeout|multiplier|name|namespace_with_ipsets|native_ipv6|neighbor_ip|net_namespace|net_namespace_ipvs|nftables|nftables_counters|nftables_ifindex|nftables_priority|no_accept|no_checker_emails|no_email_faults|nopreempt|notification_email|notification_email_from|notify|notify_backup|notify_deleted|notify_down|notify_fault|notify_fifo|notify_fifo_script|notify_master|notify_master_rx_lower_pri|notify_priority_changes|notify_stop|notify_up|old_unicast_checksum|omega|ops|param_match|passive|password|path|persistence_engine|persistence_granularity|persistence_timeout|preempt|preempt_delay|priority|process|process_monitor_rcv_bufs|process_monitor_rcv_bufs_force|process_name|process_names|promote_secondaries|protocol|proxy_arp|proxy_arp_pvlan|quorum|quorum_down|quorum_max|quorum_up|random_seed|real_server|regex|regex_max_offset|regex_min_offset|regex_no_match|regex_options|regex_stack|reload_repeat|reload_time_file|require_reply|retry|rise|router_id|rs_init_notifies|script|script_user|sh-fallback|sh-port|shutdown_script|shutdown_script_timeout|skip_check_adv_addr|smtp_alert|smtp_alert_checker|smtp_alert_vrrp|smtp_connect_timeout|smtp_helo_name|smtp_server|snmp_socket|sorry_server|sorry_server_inhibit|sorry_server_lvs_method|source_ip|start|startup_script|startup_script_timeout|state|static_ipaddress|static_routes|static_rules|status_code|step|strict_mode|sync_group_tracking_weight|terminate_delay|timeout|track_bfd|track_file|track_group|track_interface|track_process|track_script|track_src_ip|ttl|type|umask|unicast_peer|unicast_src_ip|unicast_ttl|url|use_ipvlan|use_pid_dir|use_vmac|user|uthreshold|val[123]|version|virtual_ipaddress|virtual_ipaddress_excluded|virtual_router_id|virtual_routes|virtual_rules|virtual_server|virtual_server_group|virtualhost|vmac_xmit_base|vrrp|vrrp_(?:check_unicast_src|cpu_affinity|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|gna_interval|higher_prio_send_advert|instance|ipsets|iptables|lower_prio_no_advert|mcast_group4|mcast_group6|min_garp|netlink_cmd_rcv_bufs|netlink_cmd_rcv_bufs_force|netlink_monitor_rcv_bufs|netlink_monitor_rcv_bufs_force|no_swap|notify_fifo|notify_fifo_script|notify_priority_changes|priority|process_name|rlimit_rttime|rt_priority|rx_bufs_multiplier|rx_bufs_policy|script|skip_check_adv_addr|startup_delay|strict|sync_group|track_process|version)|warmup|weight)\b/,
      constant: /\b(?:A|AAAA|AH|BACKUP|CNAME|DR|MASTER|MX|NAT|NS|PASS|SCTP|SOA|TCP|TUN|TXT|UDP|dh|fo|lblc|lblcr|lc|mh|nq|ovf|rr|sed|sh|wlc|wrr)\b/,
      number: {
        pattern: /(^|[^\w.-])-?\d+(?:\.\d+)?/,
        lookbehind: !0
      },
      boolean: /\b(?:false|no|off|on|true|yes)\b/,
      punctuation: /[\{\}]/
    };
  }
  return keepalived_1;
}
var keyman_1, hasRequiredKeyman;
function requireKeyman() {
  if (hasRequiredKeyman) return keyman_1;
  hasRequiredKeyman = 1, keyman_1 = n, n.displayName = "keyman", n.aliases = [];
  function n(t) {
    t.languages.keyman = {
      comment: {
        pattern: /\bc .*/i,
        greedy: !0
      },
      string: {
        pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
        greedy: !0
      },
      "virtual-key": {
        pattern: /\[\s*(?:(?:ALT|CAPS|CTRL|LALT|LCTRL|NCAPS|RALT|RCTRL|SHIFT)\s+)*(?:[TKU]_[\w?]+|[A-E]\d\d?|"[^"\r\n]*"|'[^'\r\n]*')\s*\]/i,
        greedy: !0,
        alias: "function"
        // alias for styles
      },
      // https://help.keyman.com/developer/language/guide/headers
      "header-keyword": {
        pattern: /&\w+/,
        alias: "bold"
        // alias for styles
      },
      "header-statement": {
        pattern: /\b(?:bitmap|bitmaps|caps always off|caps on only|copyright|hotkey|language|layout|message|name|shift frees caps|version)\b/i,
        alias: "bold"
        // alias for styles
      },
      "rule-keyword": {
        pattern: /\b(?:any|baselayout|beep|call|context|deadkey|dk|if|index|layer|notany|nul|outs|platform|reset|return|save|set|store|use)\b/i,
        alias: "keyword"
      },
      "structural-keyword": {
        pattern: /\b(?:ansi|begin|group|match|nomatch|unicode|using keys)\b/i,
        alias: "keyword"
      },
      "compile-target": {
        pattern: /\$(?:keyman|keymanonly|keymanweb|kmfl|weaver):/i,
        alias: "property"
      },
      // U+####, x###, d### characters and numbers
      number: /\b(?:U\+[\dA-F]+|d\d+|x[\da-f]+|\d+)\b/i,
      operator: /[+>\\$]|\.\./,
      punctuation: /[()=,]/
    };
  }
  return keyman_1;
}
var kotlin_1, hasRequiredKotlin;
function requireKotlin() {
  if (hasRequiredKotlin) return kotlin_1;
  hasRequiredKotlin = 1, kotlin_1 = n, n.displayName = "kotlin", n.aliases = ["kt", "kts"];
  function n(t) {
    (function(g) {
      g.languages.kotlin = g.languages.extend("clike", {
        keyword: {
          // The lookbehind prevents wrong highlighting of e.g. kotlin.properties.get
          pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
          lookbehind: !0
        },
        function: [
          {
            pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
            greedy: !0
          },
          {
            pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
        operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
      }), delete g.languages.kotlin["class-name"];
      var d = {
        "interpolation-punctuation": {
          pattern: /^\$\{?|\}$/,
          alias: "punctuation"
        },
        expression: {
          pattern: /[\s\S]+/,
          inside: g.languages.kotlin
        }
      };
      g.languages.insertBefore("kotlin", "string", {
        // https://kotlinlang.org/spec/expressions.html#string-interpolation-expressions
        "string-literal": [
          {
            pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
            alias: "multiline",
            inside: {
              interpolation: {
                pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                inside: d
              },
              string: /[\s\S]+/
            }
          },
          {
            pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
            alias: "singleline",
            inside: {
              interpolation: {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                lookbehind: !0,
                inside: d
              },
              string: /[\s\S]+/
            }
          }
        ],
        char: {
          // https://kotlinlang.org/spec/expressions.html#character-literals
          pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
          greedy: !0
        }
      }), delete g.languages.kotlin.string, g.languages.insertBefore("kotlin", "keyword", {
        annotation: {
          pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
          alias: "builtin"
        }
      }), g.languages.insertBefore("kotlin", "function", {
        label: {
          pattern: /\b\w+@|@\w+\b/,
          alias: "symbol"
        }
      }), g.languages.kt = g.languages.kotlin, g.languages.kts = g.languages.kotlin;
    })(t);
  }
  return kotlin_1;
}
var kumir_1, hasRequiredKumir;
function requireKumir() {
  if (hasRequiredKumir) return kumir_1;
  hasRequiredKumir = 1, kumir_1 = n, n.displayName = "kumir", n.aliases = ["kum"];
  function n(t) {
    (function(g) {
      var d = /\s\x00-\x1f\x22-\x2f\x3a-\x3f\x5b-\x5e\x60\x7b-\x7e/.source;
      function k(H, AA) {
        return RegExp(H.replace(/<nonId>/g, d), AA);
      }
      g.languages.kumir = {
        comment: {
          pattern: /\|.*/
        },
        prolog: {
          pattern: /#.*/,
          greedy: !0
        },
        string: {
          pattern: /"[^\n\r"]*"|'[^\n\r']*'/,
          greedy: !0
        },
        boolean: {
          pattern: k(/(^|[<nonId>])(?:да|нет)(?=[<nonId>]|$)/.source),
          lookbehind: !0
        },
        "operator-word": {
          pattern: k(/(^|[<nonId>])(?:и|или|не)(?=[<nonId>]|$)/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        "system-variable": {
          pattern: k(/(^|[<nonId>])знач(?=[<nonId>]|$)/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        type: [
          {
            pattern: k(
              /(^|[<nonId>])(?:вещ|лит|лог|сим|цел)(?:\x20*таб)?(?=[<nonId>]|$)/.source
            ),
            lookbehind: !0,
            alias: "builtin"
          },
          {
            pattern: k(
              /(^|[<nonId>])(?:компл|сканкод|файл|цвет)(?=[<nonId>]|$)/.source
            ),
            lookbehind: !0,
            alias: "important"
          }
        ],
        /**
         * Should be performed after searching for type names because of "таб".
         * "таб" is a reserved word, but never used without a preceding type name.
         * "НАЗНАЧИТЬ", "Фввод", and "Фвывод" are not reserved words.
         */
        keyword: {
          pattern: k(
            /(^|[<nonId>])(?:алг|арг(?:\x20*рез)?|ввод|ВКЛЮЧИТЬ|вс[её]|выбор|вывод|выход|дано|для|до|дс|если|иначе|исп|использовать|кон(?:(?:\x20+|_)исп)?|кц(?:(?:\x20+|_)при)?|надо|нач|нс|нц|от|пауза|пока|при|раза?|рез|стоп|таб|то|утв|шаг)(?=[<nonId>]|$)/.source
          ),
          lookbehind: !0
        },
        /** Should be performed after searching for reserved words. */
        name: {
          // eslint-disable-next-line regexp/no-super-linear-backtracking
          pattern: k(
            /(^|[<nonId>])[^\d<nonId>][^<nonId>]*(?:\x20+[^<nonId>]+)*(?=[<nonId>]|$)/.source
          ),
          lookbehind: !0
        },
        /** Should be performed after searching for names. */
        number: {
          pattern: k(
            /(^|[<nonId>])(?:\B\$[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?=[<nonId>]|$)/.source,
            "i"
          ),
          lookbehind: !0
        },
        /** Should be performed after searching for words. */
        punctuation: /:=|[(),:;\[\]]/,
        /**
         * Should be performed after searching for
         * - numeric constants (because of "+" and "-");
         * - punctuation marks (because of ":=" and "=").
         */
        "operator-char": {
          pattern: /\*\*?|<[=>]?|>=?|[-+/=]/,
          alias: "operator"
        }
      }, g.languages.kum = g.languages.kumir;
    })(t);
  }
  return kumir_1;
}
var kusto_1, hasRequiredKusto;
function requireKusto() {
  if (hasRequiredKusto) return kusto_1;
  hasRequiredKusto = 1, kusto_1 = n, n.displayName = "kusto", n.aliases = [];
  function n(t) {
    t.languages.kusto = {
      comment: {
        pattern: /\/\/.*/,
        greedy: !0
      },
      string: {
        pattern: /```[\s\S]*?```|[hH]?(?:"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\.)*'|@(?:"[^\r\n"]*"|'[^\r\n']*'))/,
        greedy: !0
      },
      verb: {
        pattern: /(\|\s*)[a-z][\w-]*/i,
        lookbehind: !0,
        alias: "keyword"
      },
      command: {
        pattern: /\.[a-z][a-z\d-]*\b/,
        alias: "keyword"
      },
      "class-name": /\b(?:bool|datetime|decimal|dynamic|guid|int|long|real|string|timespan)\b/,
      keyword: /\b(?:access|alias|and|anti|as|asc|auto|between|by|(?:contains|(?:ends|starts)with|has(?:perfix|suffix)?)(?:_cs)?|database|declare|desc|external|from|fullouter|has_all|in|ingestion|inline|inner|innerunique|into|(?:left|right)(?:anti(?:semi)?|inner|outer|semi)?|let|like|local|not|of|on|or|pattern|print|query_parameters|range|restrict|schema|set|step|table|tables|to|view|where|with|matches\s+regex|nulls\s+(?:first|last))(?![\w-])/,
      boolean: /\b(?:false|null|true)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/,
      datetime: [
        {
          // RFC 822 + RFC 850
          pattern: /\b(?:(?:Fri|Friday|Mon|Monday|Sat|Saturday|Sun|Sunday|Thu|Thursday|Tue|Tuesday|Wed|Wednesday)\s*,\s*)?\d{1,2}(?:\s+|-)(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)(?:\s+|-)\d{2}\s+\d{2}:\d{2}(?::\d{2})?(?:\s*(?:\b(?:[A-Z]|(?:[ECMT][DS]|GM|U)T)|[+-]\d{4}))?\b/,
          alias: "number"
        },
        {
          // ISO 8601
          pattern: /[+-]?\b(?:\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)?|\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)Z?/,
          alias: "number"
        }
      ],
      number: /\b(?:0x[0-9A-Fa-f]+|\d+(?:\.\d+)?(?:[Ee][+-]?\d+)?)(?:(?:min|sec|[mnµ]s|[dhms]|microsecond|tick)\b)?|[+-]?\binf\b/,
      operator: /=>|[!=]~|[!=<>]=?|[-+*/%|]|\.\./,
      punctuation: /[()\[\]{},;.:]/
    };
  }
  return kusto_1;
}
var latex_1, hasRequiredLatex;
function requireLatex() {
  if (hasRequiredLatex) return latex_1;
  hasRequiredLatex = 1, latex_1 = n, n.displayName = "latex", n.aliases = ["tex", "context"];
  function n(t) {
    (function(g) {
      var d = /\\(?:[^a-z()[\]]|[a-z*]+)/i, k = {
        "equation-command": {
          pattern: d,
          alias: "regex"
        }
      };
      g.languages.latex = {
        comment: /%.*/,
        // the verbatim environment prints whitespace to the document
        cdata: {
          pattern: /(\\begin\{((?:lstlisting|verbatim)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
          lookbehind: !0
        },
        /*
         * equations can be between $$ $$ or $ $ or \( \) or \[ \]
         * (all are multiline)
         */
        equation: [
          {
            pattern: /\$\$(?:\\[\s\S]|[^\\$])+\$\$|\$(?:\\[\s\S]|[^\\$])+\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
            inside: k,
            alias: "string"
          },
          {
            pattern: /(\\begin\{((?:align|eqnarray|equation|gather|math|multline)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
            lookbehind: !0,
            inside: k,
            alias: "string"
          }
        ],
        /*
         * arguments which are keywords or references are highlighted
         * as keywords
         */
        keyword: {
          pattern: /(\\(?:begin|cite|documentclass|end|label|ref|usepackage)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
          lookbehind: !0
        },
        url: {
          pattern: /(\\url\{)[^}]+(?=\})/,
          lookbehind: !0
        },
        /*
         * section or chapter headlines are highlighted as bold so that
         * they stand out more
         */
        headline: {
          pattern: /(\\(?:chapter|frametitle|paragraph|part|section|subparagraph|subsection|subsubparagraph|subsubsection|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
          lookbehind: !0,
          alias: "class-name"
        },
        function: {
          pattern: d,
          alias: "selector"
        },
        punctuation: /[[\]{}&]/
      }, g.languages.tex = g.languages.latex, g.languages.context = g.languages.latex;
    })(t);
  }
  return latex_1;
}
var php_1, hasRequiredPhp;
function requirePhp() {
  if (hasRequiredPhp) return php_1;
  hasRequiredPhp = 1;
  var n = requireMarkupTemplating();
  php_1 = t, t.displayName = "php", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      var k = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/, H = [
        {
          pattern: /\b(?:false|true)\b/i,
          alias: "boolean"
        },
        {
          pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
          greedy: !0,
          lookbehind: !0
        },
        {
          pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
          greedy: !0,
          lookbehind: !0
        },
        /\b(?:null)\b/i,
        /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/
      ], AA = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i, gA = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/, IA = /[{}\[\](),:;]/;
      d.languages.php = {
        delimiter: {
          pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
          alias: "important"
        },
        comment: k,
        variable: /\$+(?:\w+\b|(?=\{))/,
        package: {
          pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
          lookbehind: !0,
          inside: {
            punctuation: /\\/
          }
        },
        "class-name-definition": {
          pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
          lookbehind: !0,
          alias: "class-name"
        },
        "function-definition": {
          pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
          lookbehind: !0,
          alias: "function"
        },
        keyword: [
          {
            pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i,
            alias: "type-casting",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i,
            alias: "type-hint",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string|void)\b/i,
            alias: "return-type",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i,
            alias: "type-declaration",
            greedy: !0
          },
          {
            pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i,
            alias: "type-declaration",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /\b(?:parent|self|static)(?=\s*::)/i,
            alias: "static-context",
            greedy: !0
          },
          {
            // yield from
            pattern: /(\byield\s+)from\b/i,
            lookbehind: !0
          },
          // `class` is always a keyword unlike other keywords
          /\bclass\b/i,
          {
            // https://www.php.net/manual/en/reserved.keywords.php
            //
            // keywords cannot be preceded by "->"
            // the complex lookbehind means `(?<!(?:->|::)\s*)`
            pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|new|or|parent|print|private|protected|public|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i,
            lookbehind: !0
          }
        ],
        "argument-name": {
          pattern: /([(,]\s+)\b[a-z_]\w*(?=\s*:(?!:))/i,
          lookbehind: !0
        },
        "class-name": [
          {
            pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
            greedy: !0
          },
          {
            pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
            alias: "class-name-fully-qualified",
            greedy: !0,
            lookbehind: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
            alias: "class-name-fully-qualified",
            greedy: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
            alias: "class-name-fully-qualified",
            greedy: !0,
            lookbehind: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /\b[a-z_]\w*(?=\s*\$)/i,
            alias: "type-declaration",
            greedy: !0
          },
          {
            pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
            alias: ["class-name-fully-qualified", "type-declaration"],
            greedy: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /\b[a-z_]\w*(?=\s*::)/i,
            alias: "static-context",
            greedy: !0
          },
          {
            pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
            alias: ["class-name-fully-qualified", "static-context"],
            greedy: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
            alias: "type-hint",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
            alias: ["class-name-fully-qualified", "type-hint"],
            greedy: !0,
            lookbehind: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
            alias: "return-type",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
            alias: ["class-name-fully-qualified", "return-type"],
            greedy: !0,
            lookbehind: !0,
            inside: {
              punctuation: /\\/
            }
          }
        ],
        constant: H,
        function: {
          pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
          lookbehind: !0,
          inside: {
            punctuation: /\\/
          }
        },
        property: {
          pattern: /(->\s*)\w+/,
          lookbehind: !0
        },
        number: AA,
        operator: gA,
        punctuation: IA
      };
      var CA = {
        pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
        lookbehind: !0,
        inside: d.languages.php
      }, BA = [
        {
          pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
          alias: "nowdoc-string",
          greedy: !0,
          inside: {
            delimiter: {
              pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
              alias: "symbol",
              inside: {
                punctuation: /^<<<'?|[';]$/
              }
            }
          }
        },
        {
          pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
          alias: "heredoc-string",
          greedy: !0,
          inside: {
            delimiter: {
              pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
              alias: "symbol",
              inside: {
                punctuation: /^<<<"?|[";]$/
              }
            },
            interpolation: CA
          }
        },
        {
          pattern: /`(?:\\[\s\S]|[^\\`])*`/,
          alias: "backtick-quoted-string",
          greedy: !0
        },
        {
          pattern: /'(?:\\[\s\S]|[^\\'])*'/,
          alias: "single-quoted-string",
          greedy: !0
        },
        {
          pattern: /"(?:\\[\s\S]|[^\\"])*"/,
          alias: "double-quoted-string",
          greedy: !0,
          inside: {
            interpolation: CA
          }
        }
      ];
      d.languages.insertBefore("php", "variable", {
        string: BA,
        attribute: {
          pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
          greedy: !0,
          inside: {
            "attribute-content": {
              pattern: /^(#\[)[\s\S]+(?=\]$)/,
              lookbehind: !0,
              // inside can appear subset of php
              inside: {
                comment: k,
                string: BA,
                "attribute-class-name": [
                  {
                    pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                    alias: "class-name",
                    greedy: !0,
                    lookbehind: !0
                  },
                  {
                    pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                    alias: ["class-name", "class-name-fully-qualified"],
                    greedy: !0,
                    lookbehind: !0,
                    inside: {
                      punctuation: /\\/
                    }
                  }
                ],
                constant: H,
                number: AA,
                operator: gA,
                punctuation: IA
              }
            },
            delimiter: {
              pattern: /^#\[|\]$/,
              alias: "punctuation"
            }
          }
        }
      }), d.hooks.add("before-tokenize", function(eA) {
        if (/<\?/.test(eA.code)) {
          var iA = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g;
          d.languages["markup-templating"].buildPlaceholders(
            eA,
            "php",
            iA
          );
        }
      }), d.hooks.add("after-tokenize", function(eA) {
        d.languages["markup-templating"].tokenizePlaceholders(eA, "php");
      });
    })(g);
  }
  return php_1;
}
var latte_1, hasRequiredLatte;
function requireLatte() {
  if (hasRequiredLatte) return latte_1;
  hasRequiredLatte = 1;
  var n = requireMarkupTemplating(), t = requirePhp();
  latte_1 = g, g.displayName = "latte", g.aliases = [];
  function g(d) {
    d.register(n), d.register(t), (function(k) {
      k.languages.latte = {
        comment: /^\{\*[\s\S]*/,
        "latte-tag": {
          // https://latte.nette.org/en/tags
          pattern: /(^\{(?:\/(?=[a-z]))?)(?:[=_]|[a-z]\w*\b(?!\())/i,
          lookbehind: !0,
          alias: "important"
        },
        delimiter: {
          pattern: /^\{\/?|\}$/,
          alias: "punctuation"
        },
        php: {
          pattern: /\S(?:[\s\S]*\S)?/,
          alias: "language-php",
          inside: k.languages.php
        }
      };
      var H = k.languages.extend("markup", {});
      k.languages.insertBefore(
        "inside",
        "attr-value",
        {
          "n-attr": {
            pattern: /n:[\w-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+))?/,
            inside: {
              "attr-name": {
                pattern: /^[^\s=]+/,
                alias: "important"
              },
              "attr-value": {
                pattern: /=[\s\S]+/,
                inside: {
                  punctuation: [
                    /^=/,
                    {
                      pattern: /^(\s*)["']|["']$/,
                      lookbehind: !0
                    }
                  ],
                  php: {
                    pattern: /\S(?:[\s\S]*\S)?/,
                    inside: k.languages.php
                  }
                }
              }
            }
          }
        },
        H.tag
      ), k.hooks.add("before-tokenize", function(AA) {
        if (AA.language === "latte") {
          var gA = /\{\*[\s\S]*?\*\}|\{[^'"\s{}*](?:[^"'/{}]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|\/\*(?:[^*]|\*(?!\/))*\*\/)*\}/g;
          k.languages["markup-templating"].buildPlaceholders(
            AA,
            "latte",
            gA
          ), AA.grammar = H;
        }
      }), k.hooks.add("after-tokenize", function(AA) {
        k.languages["markup-templating"].tokenizePlaceholders(AA, "latte");
      });
    })(d);
  }
  return latte_1;
}
var less_1, hasRequiredLess;
function requireLess() {
  if (hasRequiredLess) return less_1;
  hasRequiredLess = 1, less_1 = n, n.displayName = "less", n.aliases = [];
  function n(t) {
    t.languages.less = t.languages.extend("css", {
      comment: [
        /\/\*[\s\S]*?\*\//,
        {
          pattern: /(^|[^\\])\/\/.*/,
          lookbehind: !0
        }
      ],
      atrule: {
        pattern: /@[\w-](?:\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};\s]|\s+(?!\s))*?(?=\s*\{)/,
        inside: {
          punctuation: /[:()]/
        }
      },
      // selectors and mixins are considered the same
      selector: {
        pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};@\s]|\s+(?!\s))*?(?=\s*\{)/,
        inside: {
          // mixin parameters
          variable: /@+[\w-]+/
        }
      },
      property: /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/,
      operator: /[+\-*\/]/
    }), t.languages.insertBefore("less", "property", {
      variable: [
        // Variable declaration (the colon must be consumed!)
        {
          pattern: /@[\w-]+\s*:/,
          inside: {
            punctuation: /:/
          }
        },
        // Variable usage
        /@@?[\w-]+/
      ],
      "mixin-usage": {
        pattern: /([{;]\s*)[.#](?!\d)[\w-].*?(?=[(;])/,
        lookbehind: !0,
        alias: "function"
      }
    });
  }
  return less_1;
}
var scheme_1, hasRequiredScheme;
function requireScheme() {
  if (hasRequiredScheme) return scheme_1;
  hasRequiredScheme = 1, scheme_1 = n, n.displayName = "scheme", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.scheme = {
        // this supports "normal" single-line comments:
        //   ; comment
        // and (potentially nested) multiline comments:
        //   #| comment #| nested |# still comment |#
        // (only 1 level of nesting is supported)
        comment: /;.*|#;\s*(?:\((?:[^()]|\([^()]*\))*\)|\[(?:[^\[\]]|\[[^\[\]]*\])*\])|#\|(?:[^#|]|#(?!\|)|\|(?!#)|#\|(?:[^#|]|#(?!\|)|\|(?!#))*\|#)*\|#/,
        string: {
          pattern: /"(?:[^"\\]|\\.)*"/,
          greedy: !0
        },
        symbol: {
          pattern: /'[^()\[\]#'\s]+/,
          greedy: !0
        },
        char: {
          pattern: /#\\(?:[ux][a-fA-F\d]+\b|[-a-zA-Z]+\b|[\uD800-\uDBFF][\uDC00-\uDFFF]|\S)/,
          greedy: !0
        },
        "lambda-parameter": [
          // https://www.cs.cmu.edu/Groups/AI/html/r4rs/r4rs_6.html#SEC30
          {
            pattern: /((?:^|[^'`#])[(\[]lambda\s+)(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)/,
            lookbehind: !0
          },
          {
            pattern: /((?:^|[^'`#])[(\[]lambda\s+[(\[])[^()\[\]']+/,
            lookbehind: !0
          }
        ],
        keyword: {
          pattern: /((?:^|[^'`#])[(\[])(?:begin|case(?:-lambda)?|cond(?:-expand)?|define(?:-library|-macro|-record-type|-syntax|-values)?|defmacro|delay(?:-force)?|do|else|except|export|guard|if|import|include(?:-ci|-library-declarations)?|lambda|let(?:rec)?(?:-syntax|-values|\*)?|let\*-values|only|parameterize|prefix|(?:quasi-?)?quote|rename|set!|syntax-(?:case|rules)|unless|unquote(?:-splicing)?|when)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        builtin: {
          // all functions of the base library of R7RS plus some of built-ins of R5Rs
          pattern: /((?:^|[^'`#])[(\[])(?:abs|and|append|apply|assoc|ass[qv]|binary-port\?|boolean=?\?|bytevector(?:-append|-copy|-copy!|-length|-u8-ref|-u8-set!|\?)?|caar|cadr|call-with-(?:current-continuation|port|values)|call\/cc|car|cdar|cddr|cdr|ceiling|char(?:->integer|-ready\?|\?|<\?|<=\?|=\?|>\?|>=\?)|close-(?:input-port|output-port|port)|complex\?|cons|current-(?:error|input|output)-port|denominator|dynamic-wind|eof-object\??|eq\?|equal\?|eqv\?|error|error-object(?:-irritants|-message|\?)|eval|even\?|exact(?:-integer-sqrt|-integer\?|\?)?|expt|features|file-error\?|floor(?:-quotient|-remainder|\/)?|flush-output-port|for-each|gcd|get-output-(?:bytevector|string)|inexact\??|input-port(?:-open\?|\?)|integer(?:->char|\?)|lcm|length|list(?:->string|->vector|-copy|-ref|-set!|-tail|\?)?|make-(?:bytevector|list|parameter|string|vector)|map|max|member|memq|memv|min|modulo|negative\?|newline|not|null\?|number(?:->string|\?)|numerator|odd\?|open-(?:input|output)-(?:bytevector|string)|or|output-port(?:-open\?|\?)|pair\?|peek-char|peek-u8|port\?|positive\?|procedure\?|quotient|raise|raise-continuable|rational\?|rationalize|read-(?:bytevector|bytevector!|char|error\?|line|string|u8)|real\?|remainder|reverse|round|set-c[ad]r!|square|string(?:->list|->number|->symbol|->utf8|->vector|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?|<\?|<=\?|=\?|>\?|>=\?)?|substring|symbol(?:->string|\?|=\?)|syntax-error|textual-port\?|truncate(?:-quotient|-remainder|\/)?|u8-ready\?|utf8->string|values|vector(?:->list|->string|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?)?|with-exception-handler|write-(?:bytevector|char|string|u8)|zero\?)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        operator: {
          pattern: /((?:^|[^'`#])[(\[])(?:[-+*%/]|[<>]=?|=>?)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        number: {
          // The number pattern from [the R7RS spec](https://small.r7rs.org/attachment/r7rs.pdf).
          //
          // <number>      := <num 2>|<num 8>|<num 10>|<num 16>
          // <num R>       := <prefix R><complex R>
          // <complex R>   := <real R>(?:@<real R>|<imaginary R>)?|<imaginary R>
          // <imaginary R> := [+-](?:<ureal R>|(?:inf|nan)\.0)?i
          // <real R>      := [+-]?<ureal R>|[+-](?:inf|nan)\.0
          // <ureal R>     := <uint R>(?:\/<uint R>)?
          //                | <decimal R>
          //
          // <decimal 10>  := (?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?
          // <uint R>      := <digit R>+
          // <prefix R>    := <radix R>(?:#[ei])?|(?:#[ei])?<radix R>
          // <radix 2>     := #b
          // <radix 8>     := #o
          // <radix 10>    := (?:#d)?
          // <radix 16>    := #x
          // <digit 2>     := [01]
          // <digit 8>     := [0-7]
          // <digit 10>    := \d
          // <digit 16>    := [0-9a-f]
          //
          // The problem with this grammar is that the resulting regex is way to complex, so we simplify by grouping all
          // non-decimal bases together. This results in a decimal (dec) and combined binary, octal, and hexadecimal (box)
          // pattern:
          pattern: RegExp(
            d({
              "<ureal dec>": /\d+(?:\/\d+)|(?:\d+(?:\.\d*)?|\.\d+)(?:[esfdl][+-]?\d+)?/.source,
              "<real dec>": /[+-]?<ureal dec>|[+-](?:inf|nan)\.0/.source,
              "<imaginary dec>": /[+-](?:<ureal dec>|(?:inf|nan)\.0)?i/.source,
              "<complex dec>": /<real dec>(?:@<real dec>|<imaginary dec>)?|<imaginary dec>/.source,
              "<num dec>": /(?:#d(?:#[ei])?|#[ei](?:#d)?)?<complex dec>/.source,
              "<ureal box>": /[0-9a-f]+(?:\/[0-9a-f]+)?/.source,
              "<real box>": /[+-]?<ureal box>|[+-](?:inf|nan)\.0/.source,
              "<imaginary box>": /[+-](?:<ureal box>|(?:inf|nan)\.0)?i/.source,
              "<complex box>": /<real box>(?:@<real box>|<imaginary box>)?|<imaginary box>/.source,
              "<num box>": /#[box](?:#[ei])?|(?:#[ei])?#[box]<complex box>/.source,
              "<number>": /(^|[()\[\]\s])(?:<num dec>|<num box>)(?=[()\[\]\s]|$)/.source
            }),
            "i"
          ),
          lookbehind: !0
        },
        boolean: {
          pattern: /(^|[()\[\]\s])#(?:[ft]|false|true)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        function: {
          pattern: /((?:^|[^'`#])[(\[])(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        identifier: {
          pattern: /(^|[()\[\]\s])\|(?:[^\\|]|\\.)*\|(?=[()\[\]\s]|$)/,
          lookbehind: !0,
          greedy: !0
        },
        punctuation: /[()\[\]']/
      };
      function d(k) {
        for (var H in k)
          k[H] = k[H].replace(/<[\w\s]+>/g, function(AA) {
            return "(?:" + k[AA].trim() + ")";
          });
        return k[H];
      }
    })(t);
  }
  return scheme_1;
}
var lilypond_1, hasRequiredLilypond;
function requireLilypond() {
  if (hasRequiredLilypond) return lilypond_1;
  hasRequiredLilypond = 1;
  var n = requireScheme();
  lilypond_1 = t, t.displayName = "lilypond", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      for (var k = /\((?:[^();"#\\]|\\[\s\S]|;.*(?!.)|"(?:[^"\\]|\\.)*"|#(?:\{(?:(?!#\})[\s\S])*#\}|[^{])|<expr>)*\)/.source, H = 5, AA = 0; AA < H; AA++)
        k = k.replace(/<expr>/g, function() {
          return k;
        });
      k = k.replace(/<expr>/g, /[^\s\S]/.source);
      var gA = d.languages.lilypond = {
        comment: /%(?:(?!\{).*|\{[\s\S]*?%\})/,
        "embedded-scheme": {
          pattern: RegExp(
            /(^|[=\s])#(?:"(?:[^"\\]|\\.)*"|[^\s()"]*(?:[^\s()]|<expr>))/.source.replace(
              /<expr>/g,
              function() {
                return k;
              }
            ),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            scheme: {
              pattern: /^(#)[\s\S]+$/,
              lookbehind: !0,
              alias: "language-scheme",
              inside: {
                "embedded-lilypond": {
                  pattern: /#\{[\s\S]*?#\}/,
                  greedy: !0,
                  inside: {
                    punctuation: /^#\{|#\}$/,
                    lilypond: {
                      pattern: /[\s\S]+/,
                      alias: "language-lilypond",
                      inside: null
                      // see below
                    }
                  }
                },
                rest: d.languages.scheme
              }
            },
            punctuation: /#/
          }
        },
        string: {
          pattern: /"(?:[^"\\]|\\.)*"/,
          greedy: !0
        },
        "class-name": {
          pattern: /(\\new\s+)[\w-]+/,
          lookbehind: !0
        },
        keyword: {
          pattern: /\\[a-z][-\w]*/i,
          inside: {
            punctuation: /^\\/
          }
        },
        operator: /[=|]|<<|>>/,
        punctuation: {
          pattern: /(^|[a-z\d])(?:'+|,+|[_^]?-[_^]?(?:[-+^!>._]|(?=\d))|[_^]\.?|[.!])|[{}()[\]<>^~]|\\[()[\]<>\\!]|--|__/,
          lookbehind: !0
        },
        number: /\b\d+(?:\/\d+)?\b/
      };
      gA["embedded-scheme"].inside.scheme.inside["embedded-lilypond"].inside.lilypond.inside = gA, d.languages.ly = gA;
    })(g);
  }
  return lilypond_1;
}
var liquid_1, hasRequiredLiquid;
function requireLiquid() {
  if (hasRequiredLiquid) return liquid_1;
  hasRequiredLiquid = 1;
  var n = requireMarkupTemplating();
  liquid_1 = t, t.displayName = "liquid", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.liquid = {
      comment: {
        pattern: /(^\{%\s*comment\s*%\})[\s\S]+(?=\{%\s*endcomment\s*%\}$)/,
        lookbehind: !0
      },
      delimiter: {
        pattern: /^\{(?:\{\{|[%\{])-?|-?(?:\}\}|[%\}])\}$/,
        alias: "punctuation"
      },
      string: {
        pattern: /"[^"]*"|'[^']*'/,
        greedy: !0
      },
      keyword: /\b(?:as|assign|break|(?:end)?(?:capture|case|comment|for|form|if|paginate|raw|style|tablerow|unless)|continue|cycle|decrement|echo|else|elsif|in|include|increment|limit|liquid|offset|range|render|reversed|section|when|with)\b/,
      object: /\b(?:address|all_country_option_tags|article|block|blog|cart|checkout|collection|color|country|country_option_tags|currency|current_page|current_tags|customer|customer_address|date|discount_allocation|discount_application|external_video|filter|filter_value|font|forloop|fulfillment|generic_file|gift_card|group|handle|image|line_item|link|linklist|localization|location|measurement|media|metafield|model|model_source|order|page|page_description|page_image|page_title|part|policy|product|product_option|recommendations|request|robots|routes|rule|script|search|selling_plan|selling_plan_allocation|selling_plan_group|shipping_method|shop|shop_locale|sitemap|store_availability|tax_line|template|theme|transaction|unit_price_measurement|user_agent|variant|video|video_source)\b/,
      function: [
        {
          pattern: /(\|\s*)\w+/,
          lookbehind: !0,
          alias: "filter"
        },
        {
          // array functions
          pattern: /(\.\s*)(?:first|last|size)/,
          lookbehind: !0
        }
      ],
      boolean: /\b(?:false|nil|true)\b/,
      range: {
        pattern: /\.\./,
        alias: "operator"
      },
      // https://github.com/Shopify/liquid/blob/698f5e0d967423e013f6169d9111bd969bd78337/lib/liquid/lexer.rb#L21
      number: /\b\d+(?:\.\d+)?\b/,
      operator: /[!=]=|<>|[<>]=?|[|?:=-]|\b(?:and|contains(?=\s)|or)\b/,
      punctuation: /[.,\[\]()]/,
      empty: {
        pattern: /\bempty\b/,
        alias: "keyword"
      }
    }, g.hooks.add("before-tokenize", function(d) {
      var k = /\{%\s*comment\s*%\}[\s\S]*?\{%\s*endcomment\s*%\}|\{(?:%[\s\S]*?%|\{\{[\s\S]*?\}\}|\{[\s\S]*?\})\}/g, H = !1;
      g.languages["markup-templating"].buildPlaceholders(
        d,
        "liquid",
        k,
        function(AA) {
          var gA = /^\{%-?\s*(\w+)/.exec(AA);
          if (gA) {
            var IA = gA[1];
            if (IA === "raw" && !H)
              return H = !0, !0;
            if (IA === "endraw")
              return H = !1, !0;
          }
          return !H;
        }
      );
    }), g.hooks.add("after-tokenize", function(d) {
      g.languages["markup-templating"].tokenizePlaceholders(d, "liquid");
    });
  }
  return liquid_1;
}
var lisp_1, hasRequiredLisp;
function requireLisp() {
  if (hasRequiredLisp) return lisp_1;
  hasRequiredLisp = 1, lisp_1 = n, n.displayName = "lisp", n.aliases = [];
  function n(t) {
    (function(g) {
      function d(oA) {
        return RegExp(/(\()/.source + "(?:" + oA + ")" + /(?=[\s\)])/.source);
      }
      function k(oA) {
        return RegExp(
          /([\s([])/.source + "(?:" + oA + ")" + /(?=[\s)])/.source
        );
      }
      var H = /(?!\d)[-+*/~!@$%^=<>{}\w]+/.source, AA = "&" + H, gA = "(\\()", IA = "(?=\\))", CA = "(?=\\s)", BA = /(?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\))*\))*\))*/.source, eA = {
        // Three or four semicolons are considered a heading.
        // See https://www.gnu.org/software/emacs/manual/html_node/elisp/Comment-Tips.html
        heading: {
          pattern: /;;;.*/,
          alias: ["comment", "title"]
        },
        comment: /;.*/,
        string: {
          pattern: /"(?:[^"\\]|\\.)*"/,
          greedy: !0,
          inside: {
            argument: /[-A-Z]+(?=[.,\s])/,
            symbol: RegExp("`" + H + "'")
          }
        },
        "quoted-symbol": {
          pattern: RegExp("#?'" + H),
          alias: ["variable", "symbol"]
        },
        "lisp-property": {
          pattern: RegExp(":" + H),
          alias: "property"
        },
        splice: {
          pattern: RegExp(",@?" + H),
          alias: ["symbol", "variable"]
        },
        keyword: [
          {
            pattern: RegExp(
              gA + "(?:and|(?:cl-)?letf|cl-loop|cond|cons|error|if|(?:lexical-)?let\\*?|message|not|null|or|provide|require|setq|unless|use-package|when|while)" + CA
            ),
            lookbehind: !0
          },
          {
            pattern: RegExp(
              gA + "(?:append|by|collect|concat|do|finally|for|in|return)" + CA
            ),
            lookbehind: !0
          }
        ],
        declare: {
          pattern: d(/declare/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        interactive: {
          pattern: d(/interactive/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        boolean: {
          pattern: k(/nil|t/.source),
          lookbehind: !0
        },
        number: {
          pattern: k(/[-+]?\d+(?:\.\d*)?/.source),
          lookbehind: !0
        },
        defvar: {
          pattern: RegExp(gA + "def(?:const|custom|group|var)\\s+" + H),
          lookbehind: !0,
          inside: {
            keyword: /^def[a-z]+/,
            variable: RegExp(H)
          }
        },
        defun: {
          pattern: RegExp(
            gA + /(?:cl-)?(?:defmacro|defun\*?)\s+/.source + H + /\s+\(/.source + BA + /\)/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            keyword: /^(?:cl-)?def\S+/,
            // See below, this property needs to be defined later so that it can
            // reference the language object.
            arguments: null,
            function: {
              pattern: RegExp("(^\\s)" + H),
              lookbehind: !0
            },
            punctuation: /[()]/
          }
        },
        lambda: {
          pattern: RegExp(
            gA + "lambda\\s+\\(\\s*(?:&?" + H + "(?:\\s+&?" + H + ")*\\s*)?\\)"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            keyword: /^lambda/,
            // See below, this property needs to be defined later so that it can
            // reference the language object.
            arguments: null,
            punctuation: /[()]/
          }
        },
        car: {
          pattern: RegExp(gA + H),
          lookbehind: !0
        },
        punctuation: [
          // open paren, brackets, and close paren
          /(?:['`,]?\(|[)\[\]])/,
          // cons
          {
            pattern: /(\s)\.(?=\s)/,
            lookbehind: !0
          }
        ]
      }, iA = {
        "lisp-marker": RegExp(AA),
        varform: {
          pattern: RegExp(
            /\(/.source + H + /\s+(?=\S)/.source + BA + /\)/.source
          ),
          inside: eA
        },
        argument: {
          pattern: RegExp(/(^|[\s(])/.source + H),
          lookbehind: !0,
          alias: "variable"
        },
        rest: eA
      }, QA = "\\S+(?:\\s+\\S+)*", tA = {
        pattern: RegExp(gA + BA + IA),
        lookbehind: !0,
        inside: {
          "rest-vars": {
            pattern: RegExp("&(?:body|rest)\\s+" + QA),
            inside: iA
          },
          "other-marker-vars": {
            pattern: RegExp("&(?:aux|optional)\\s+" + QA),
            inside: iA
          },
          keys: {
            pattern: RegExp("&key\\s+" + QA + "(?:\\s+&allow-other-keys)?"),
            inside: iA
          },
          argument: {
            pattern: RegExp(H),
            alias: "variable"
          },
          punctuation: /[()]/
        }
      };
      eA.lambda.inside.arguments = tA, eA.defun.inside.arguments = g.util.clone(tA), eA.defun.inside.arguments.inside.sublist = tA, g.languages.lisp = eA, g.languages.elisp = eA, g.languages.emacs = eA, g.languages["emacs-lisp"] = eA;
    })(t);
  }
  return lisp_1;
}
var livescript_1, hasRequiredLivescript;
function requireLivescript() {
  if (hasRequiredLivescript) return livescript_1;
  hasRequiredLivescript = 1, livescript_1 = n, n.displayName = "livescript", n.aliases = [];
  function n(t) {
    t.languages.livescript = {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\\])#.*/,
          lookbehind: !0
        }
      ],
      "interpolated-string": {
        /* Look-behind and look-ahead prevents wrong behavior of the greedy pattern
         * forcing it to match """-quoted string when it would otherwise match "-quoted first. */
        pattern: /(^|[^"])("""|")(?:\\[\s\S]|(?!\2)[^\\])*\2(?!")/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          variable: {
            pattern: /(^|[^\\])#[a-z_](?:-?[a-z]|[\d_])*/m,
            lookbehind: !0
          },
          interpolation: {
            pattern: /(^|[^\\])#\{[^}]+\}/m,
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^#\{|\}$/,
                alias: "variable"
              }
              // See rest below
            }
          },
          string: /[\s\S]+/
        }
      },
      string: [
        {
          pattern: /('''|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
          greedy: !0
        },
        {
          pattern: /<\[[\s\S]*?\]>/,
          greedy: !0
        },
        /\\[^\s,;\])}]+/
      ],
      regex: [
        {
          pattern: /\/\/(?:\[[^\r\n\]]*\]|\\.|(?!\/\/)[^\\\[])+\/\/[gimyu]{0,5}/,
          greedy: !0,
          inside: {
            comment: {
              pattern: /(^|[^\\])#.*/,
              lookbehind: !0
            }
          }
        },
        {
          pattern: /\/(?:\[[^\r\n\]]*\]|\\.|[^/\\\r\n\[])+\/[gimyu]{0,5}/,
          greedy: !0
        }
      ],
      keyword: {
        pattern: /(^|(?!-).)\b(?:break|case|catch|class|const|continue|default|do|else|extends|fallthrough|finally|for(?: ever)?|function|if|implements|it|let|loop|new|null|otherwise|own|return|super|switch|that|then|this|throw|try|unless|until|var|void|when|while|yield)(?!-)\b/m,
        lookbehind: !0
      },
      "keyword-operator": {
        pattern: /(^|[^-])\b(?:(?:delete|require|typeof)!|(?:and|by|delete|export|from|import(?: all)?|in|instanceof|is(?: not|nt)?|not|of|or|til|to|typeof|with|xor)(?!-)\b)/m,
        lookbehind: !0,
        alias: "operator"
      },
      boolean: {
        pattern: /(^|[^-])\b(?:false|no|off|on|true|yes)(?!-)\b/m,
        lookbehind: !0
      },
      argument: {
        // Don't match .&. nor &&
        pattern: /(^|(?!\.&\.)[^&])&(?!&)\d*/m,
        lookbehind: !0,
        alias: "variable"
      },
      number: /\b(?:\d+~[\da-z]+|\d[\d_]*(?:\.\d[\d_]*)?(?:[a-z]\w*)?)/i,
      identifier: /[a-z_](?:-?[a-z]|[\d_])*/i,
      operator: [
        // Spaced .
        {
          pattern: /( )\.(?= )/,
          lookbehind: !0
        },
        // Full list, in order:
        // .= .~ .. ...
        // .&. .^. .<<. .>>. .>>>.
        // := :: ::=
        // &&
        // || |>
        // < << <<< <<<<
        // <- <-- <-! <--!
        // <~ <~~ <~! <~~!
        // <| <= <?
        // > >> >= >?
        // - -- -> -->
        // + ++
        // @ @@
        // % %%
        // * **
        // ! != !~=
        // !~> !~~>
        // !-> !-->
        // ~ ~> ~~> ~=
        // = ==
        // ^ ^^
        // / ?
        /\.(?:[=~]|\.\.?)|\.(?:[&|^]|<<|>>>?)\.|:(?:=|:=?)|&&|\|[|>]|<(?:<<?<?|--?!?|~~?!?|[|=?])?|>[>=?]?|-(?:->?|>)?|\+\+?|@@?|%%?|\*\*?|!(?:~?=|--?>|~?~>)?|~(?:~?>|=)?|==?|\^\^?|[\/?]/
      ],
      punctuation: /[(){}\[\]|.,:;`]/
    }, t.languages.livescript["interpolated-string"].inside.interpolation.inside.rest = t.languages.livescript;
  }
  return livescript_1;
}
var llvm_1, hasRequiredLlvm;
function requireLlvm() {
  if (hasRequiredLlvm) return llvm_1;
  hasRequiredLlvm = 1, llvm_1 = n, n.displayName = "llvm", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.llvm = {
        comment: /;.*/,
        string: {
          pattern: /"[^"]*"/,
          greedy: !0
        },
        boolean: /\b(?:false|true)\b/,
        variable: /[%@!#](?:(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+|\d+)/i,
        label: /(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+:/i,
        type: {
          pattern: /\b(?:double|float|fp128|half|i[1-9]\d*|label|metadata|ppc_fp128|token|void|x86_fp80|x86_mmx)\b/,
          alias: "class-name"
        },
        keyword: /\b[a-z_][a-z_0-9]*\b/,
        number: /[+-]?\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-Fa-f]+\b|\b0xK[\dA-Fa-f]{20}\b|\b0x[ML][\dA-Fa-f]{32}\b|\b0xH[\dA-Fa-f]{4}\b/,
        punctuation: /[{}[\];(),.!*=<>]/
      };
    })(t);
  }
  return llvm_1;
}
var log_1, hasRequiredLog;
function requireLog() {
  if (hasRequiredLog) return log_1;
  hasRequiredLog = 1, log_1 = n, n.displayName = "log", n.aliases = [];
  function n(t) {
    t.languages.log = {
      string: {
        // Single-quoted strings must not be confused with plain text. E.g. Can't isn't Susan's Chris' toy
        pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?![st] | \w)(?:[^'\\\r\n]|\\.)*'/,
        greedy: !0
      },
      exception: {
        pattern: /(^|[^\w.])[a-z][\w.]*(?:Error|Exception):.*(?:(?:\r\n?|\n)[ \t]*(?:at[ \t].+|\.{3}.*|Caused by:.*))+(?:(?:\r\n?|\n)[ \t]*\.\.\. .*)?/,
        lookbehind: !0,
        greedy: !0,
        alias: ["javastacktrace", "language-javastacktrace"],
        inside: t.languages.javastacktrace || {
          keyword: /\bat\b/,
          function: /[a-z_][\w$]*(?=\()/,
          punctuation: /[.:()]/
        }
      },
      level: [
        {
          pattern: /\b(?:ALERT|CRIT|CRITICAL|EMERG|EMERGENCY|ERR|ERROR|FAILURE|FATAL|SEVERE)\b/,
          alias: ["error", "important"]
        },
        {
          pattern: /\b(?:WARN|WARNING|WRN)\b/,
          alias: ["warning", "important"]
        },
        {
          pattern: /\b(?:DISPLAY|INF|INFO|NOTICE|STATUS)\b/,
          alias: ["info", "keyword"]
        },
        {
          pattern: /\b(?:DBG|DEBUG|FINE)\b/,
          alias: ["debug", "keyword"]
        },
        {
          pattern: /\b(?:FINER|FINEST|TRACE|TRC|VERBOSE|VRB)\b/,
          alias: ["trace", "comment"]
        }
      ],
      property: {
        pattern: /((?:^|[\]|])[ \t]*)[a-z_](?:[\w-]|\b\/\b)*(?:[. ]\(?\w(?:[\w-]|\b\/\b)*\)?)*:(?=\s)/im,
        lookbehind: !0
      },
      separator: {
        pattern: /(^|[^-+])-{3,}|={3,}|\*{3,}|- - /m,
        lookbehind: !0,
        alias: "comment"
      },
      url: /\b(?:file|ftp|https?):\/\/[^\s|,;'"]*[^\s|,;'">.]/,
      email: {
        pattern: /(^|\s)[-\w+.]+@[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)+(?=\s)/,
        lookbehind: !0,
        alias: "url"
      },
      "ip-address": {
        pattern: /\b(?:\d{1,3}(?:\.\d{1,3}){3})\b/,
        alias: "constant"
      },
      "mac-address": {
        pattern: /\b[a-f0-9]{2}(?::[a-f0-9]{2}){5}\b/i,
        alias: "constant"
      },
      domain: {
        pattern: /(^|\s)[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)*\.[a-z][a-z0-9-]+(?=\s)/,
        lookbehind: !0,
        alias: "constant"
      },
      uuid: {
        pattern: /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i,
        alias: "constant"
      },
      hash: {
        pattern: /\b(?:[a-f0-9]{32}){1,2}\b/i,
        alias: "constant"
      },
      "file-path": {
        pattern: /\b[a-z]:[\\/][^\s|,;:(){}\[\]"']+|(^|[\s:\[\](>|])\.{0,2}\/\w[^\s|,;:(){}\[\]"']*/i,
        lookbehind: !0,
        greedy: !0,
        alias: "string"
      },
      date: {
        pattern: RegExp(
          /\b\d{4}[-/]\d{2}[-/]\d{2}(?:T(?=\d{1,2}:)|(?=\s\d{1,2}:))/.source + "|" + /\b\d{1,4}[-/ ](?:\d{1,2}|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)[-/ ]\d{2,4}T?\b/.source + "|" + /\b(?:(?:Fri|Mon|Sat|Sun|Thu|Tue|Wed)(?:\s{1,2}(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep))?|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)\s{1,2}\d{1,2}\b/.source,
          "i"
        ),
        alias: "number"
      },
      time: {
        pattern: /\b\d{1,2}:\d{1,2}:\d{1,2}(?:[.,:]\d+)?(?:\s?[+-]\d{2}:?\d{2}|Z)?\b/,
        alias: "number"
      },
      boolean: /\b(?:false|null|true)\b/i,
      number: {
        pattern: /(^|[^.\w])(?:0x[a-f0-9]+|0o[0-7]+|0b[01]+|v?\d[\da-f]*(?:\.\d+)*(?:e[+-]?\d+)?[a-z]{0,3}\b)\b(?!\.\w)/i,
        lookbehind: !0
      },
      operator: /[;:?<=>~/@!$%&+\-|^(){}*#]/,
      punctuation: /[\[\].,]/
    };
  }
  return log_1;
}
var lolcode_1, hasRequiredLolcode;
function requireLolcode() {
  if (hasRequiredLolcode) return lolcode_1;
  hasRequiredLolcode = 1, lolcode_1 = n, n.displayName = "lolcode", n.aliases = [];
  function n(t) {
    t.languages.lolcode = {
      comment: [/\bOBTW\s[\s\S]*?\sTLDR\b/, /\bBTW.+/],
      string: {
        pattern: /"(?::.|[^":])*"/,
        inside: {
          variable: /:\{[^}]+\}/,
          symbol: [/:\([a-f\d]+\)/i, /:\[[^\]]+\]/, /:[)>o":]/]
        },
        greedy: !0
      },
      number: /(?:\B-)?(?:\b\d+(?:\.\d*)?|\B\.\d+)/,
      symbol: {
        pattern: /(^|\s)(?:A )?(?:BUKKIT|NOOB|NUMBAR|NUMBR|TROOF|YARN)(?=\s|,|$)/,
        lookbehind: !0,
        inside: {
          keyword: /A(?=\s)/
        }
      },
      label: {
        pattern: /((?:^|\s)(?:IM IN YR|IM OUTTA YR) )[a-zA-Z]\w*/,
        lookbehind: !0,
        alias: "string"
      },
      function: {
        pattern: /((?:^|\s)(?:HOW IZ I|I IZ|IZ) )[a-zA-Z]\w*/,
        lookbehind: !0
      },
      keyword: [
        {
          pattern: /(^|\s)(?:AN|FOUND YR|GIMMEH|GTFO|HAI|HAS A|HOW IZ I|I HAS A|I IZ|IF U SAY SO|IM IN YR|IM OUTTA YR|IS NOW(?: A)?|ITZ(?: A)?|IZ|KTHX|KTHXBYE|LIEK(?: A)?|MAEK|MEBBE|MKAY|NERFIN|NO WAI|O HAI IM|O RLY\?|OIC|OMG|OMGWTF|R|SMOOSH|SRS|TIL|UPPIN|VISIBLE|WILE|WTF\?|YA RLY|YR)(?=\s|,|$)/,
          lookbehind: !0
        },
        /'Z(?=\s|,|$)/
      ],
      boolean: {
        pattern: /(^|\s)(?:FAIL|WIN)(?=\s|,|$)/,
        lookbehind: !0
      },
      variable: {
        pattern: /(^|\s)IT(?=\s|,|$)/,
        lookbehind: !0
      },
      operator: {
        pattern: /(^|\s)(?:NOT|BOTH SAEM|DIFFRINT|(?:ALL|ANY|BIGGR|BOTH|DIFF|EITHER|MOD|PRODUKT|QUOSHUNT|SMALLR|SUM|WON) OF)(?=\s|,|$)/,
        lookbehind: !0
      },
      punctuation: /\.{3}|…|,|!/
    };
  }
  return lolcode_1;
}
var magma_1, hasRequiredMagma;
function requireMagma() {
  if (hasRequiredMagma) return magma_1;
  hasRequiredMagma = 1, magma_1 = n, n.displayName = "magma", n.aliases = [];
  function n(t) {
    t.languages.magma = {
      output: {
        pattern: /^(>.*(?:\r(?:\n|(?!\n))|\n))(?!>)(?:.+|(?:\r(?:\n|(?!\n))|\n)(?!>).*)(?:(?:\r(?:\n|(?!\n))|\n)(?!>).*)*/m,
        lookbehind: !0,
        greedy: !0
      },
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\"])"(?:[^\r\n\\"]|\\.)*"/,
        lookbehind: !0,
        greedy: !0
      },
      // http://magma.maths.usyd.edu.au/magma/handbook/text/82
      keyword: /\b(?:_|adj|and|assert|assert2|assert3|assigned|break|by|case|cat|catch|clear|cmpeq|cmpne|continue|declare|default|delete|diff|div|do|elif|else|end|eq|error|eval|exists|exit|for|forall|forward|fprintf|freeze|function|ge|gt|if|iload|import|in|intrinsic|is|join|le|load|local|lt|meet|mod|ne|not|notadj|notin|notsubset|or|print|printf|procedure|quit|random|read|readi|repeat|require|requirege|requirerange|restore|return|save|sdiff|select|subset|then|time|to|try|until|vprint|vprintf|vtime|when|where|while|xor)\b/,
      boolean: /\b(?:false|true)\b/,
      generator: {
        pattern: /\b[a-z_]\w*(?=\s*<)/i,
        alias: "class-name"
      },
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: {
        pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
        lookbehind: !0
      },
      operator: /->|[-+*/^~!|#=]|:=|\.\./,
      punctuation: /[()[\]{}<>,;.:]/
    };
  }
  return magma_1;
}
var makefile_1, hasRequiredMakefile;
function requireMakefile() {
  if (hasRequiredMakefile) return makefile_1;
  hasRequiredMakefile = 1, makefile_1 = n, n.displayName = "makefile", n.aliases = [];
  function n(t) {
    t.languages.makefile = {
      comment: {
        pattern: /(^|[^\\])#(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/,
        lookbehind: !0
      },
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      "builtin-target": {
        pattern: /\.[A-Z][^:#=\s]+(?=\s*:(?!=))/,
        alias: "builtin"
      },
      target: {
        pattern: /^(?:[^:=\s]|[ \t]+(?![\s:]))+(?=\s*:(?!=))/m,
        alias: "symbol",
        inside: {
          variable: /\$+(?:(?!\$)[^(){}:#=\s]+|(?=[({]))/
        }
      },
      variable: /\$+(?:(?!\$)[^(){}:#=\s]+|\([@*%<^+?][DF]\)|(?=[({]))/,
      // Directives
      keyword: /-include\b|\b(?:define|else|endef|endif|export|ifn?def|ifn?eq|include|override|private|sinclude|undefine|unexport|vpath)\b/,
      function: {
        pattern: /(\()(?:abspath|addsuffix|and|basename|call|dir|error|eval|file|filter(?:-out)?|findstring|firstword|flavor|foreach|guile|if|info|join|lastword|load|notdir|or|origin|patsubst|realpath|shell|sort|strip|subst|suffix|value|warning|wildcard|word(?:list|s)?)(?=[ \t])/,
        lookbehind: !0
      },
      operator: /(?:::|[?:+!])?=|[|@]/,
      punctuation: /[:;(){}]/
    };
  }
  return makefile_1;
}
var markdown_1, hasRequiredMarkdown;
function requireMarkdown() {
  if (hasRequiredMarkdown) return markdown_1;
  hasRequiredMarkdown = 1, markdown_1 = n, n.displayName = "markdown", n.aliases = ["md"];
  function n(t) {
    (function(g) {
      var d = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
      function k(iA) {
        return iA = iA.replace(/<inner>/g, function() {
          return d;
        }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + iA + ")");
      }
      var H = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, AA = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(
        /__/g,
        function() {
          return H;
        }
      ), gA = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
      g.languages.markdown = g.languages.extend("markup", {}), g.languages.insertBefore("markdown", "prolog", {
        "front-matter-block": {
          pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            punctuation: /^---|---$/,
            "front-matter": {
              pattern: /\S+(?:\s+\S+)*/,
              alias: ["yaml", "language-yaml"],
              inside: g.languages.yaml
            }
          }
        },
        blockquote: {
          // > ...
          pattern: /^>(?:[\t ]*>)*/m,
          alias: "punctuation"
        },
        table: {
          pattern: RegExp(
            "^" + AA + gA + "(?:" + AA + ")*",
            "m"
          ),
          inside: {
            "table-data-rows": {
              pattern: RegExp(
                "^(" + AA + gA + ")(?:" + AA + ")*$"
              ),
              lookbehind: !0,
              inside: {
                "table-data": {
                  pattern: RegExp(H),
                  inside: g.languages.markdown
                },
                punctuation: /\|/
              }
            },
            "table-line": {
              pattern: RegExp("^(" + AA + ")" + gA + "$"),
              lookbehind: !0,
              inside: {
                punctuation: /\||:?-{3,}:?/
              }
            },
            "table-header-row": {
              pattern: RegExp("^" + AA + "$"),
              inside: {
                "table-header": {
                  pattern: RegExp(H),
                  alias: "important",
                  inside: g.languages.markdown
                },
                punctuation: /\|/
              }
            }
          }
        },
        code: [
          {
            // Prefixed by 4 spaces or 1 tab and preceded by an empty line
            pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
            lookbehind: !0,
            alias: "keyword"
          },
          {
            // ```optional language
            // code block
            // ```
            pattern: /^```[\s\S]*?^```$/m,
            greedy: !0,
            inside: {
              "code-block": {
                pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                lookbehind: !0
              },
              "code-language": {
                pattern: /^(```).+/,
                lookbehind: !0
              },
              punctuation: /```/
            }
          }
        ],
        title: [
          {
            // title 1
            // =======
            // title 2
            // -------
            pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
            alias: "important",
            inside: {
              punctuation: /==+$|--+$/
            }
          },
          {
            // # title 1
            // ###### title 6
            pattern: /(^\s*)#.+/m,
            lookbehind: !0,
            alias: "important",
            inside: {
              punctuation: /^#+|#+$/
            }
          }
        ],
        hr: {
          // ***
          // ---
          // * * *
          // -----------
          pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        list: {
          // * item
          // + item
          // - item
          // 1. item
          pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        "url-reference": {
          // [id]: http://example.com "Optional title"
          // [id]: http://example.com 'Optional title'
          // [id]: http://example.com (Optional title)
          // [id]: <http://example.com> "Optional title"
          pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
          inside: {
            variable: {
              pattern: /^(!?\[)[^\]]+/,
              lookbehind: !0
            },
            string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
            punctuation: /^[\[\]!:]|[<>]/
          },
          alias: "url"
        },
        bold: {
          // **strong**
          // __strong__
          // allow one nested instance of italic text using the same delimiter
          pattern: k(
            /\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^..)[\s\S]+(?=..$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /\*\*|__/
          }
        },
        italic: {
          // *em*
          // _em_
          // allow one nested instance of bold text using the same delimiter
          pattern: k(
            /\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^.)[\s\S]+(?=.$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /[*_]/
          }
        },
        strike: {
          // ~~strike through~~
          // ~strike~
          // eslint-disable-next-line regexp/strict
          pattern: k(/(~~?)(?:(?!~)<inner>)+\2/.source),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^~~?)[\s\S]+(?=\1$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /~~?/
          }
        },
        "code-snippet": {
          // `code`
          // ``code``
          pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
          lookbehind: !0,
          greedy: !0,
          alias: ["code", "keyword"]
        },
        url: {
          // [example](http://example.com "Optional title")
          // [example][id]
          // [example] [id]
          pattern: k(
            /!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            operator: /^!/,
            content: {
              pattern: /(^\[)[^\]]+(?=\])/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            variable: {
              pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
              lookbehind: !0
            },
            url: {
              pattern: /(^\]\()[^\s)]+/,
              lookbehind: !0
            },
            string: {
              pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
              lookbehind: !0
            }
          }
        }
      }), ["url", "bold", "italic", "strike"].forEach(function(iA) {
        ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(QA) {
          iA !== QA && (g.languages.markdown[iA].inside.content.inside[QA] = g.languages.markdown[QA]);
        });
      }), g.hooks.add("after-tokenize", function(iA) {
        if (iA.language !== "markdown" && iA.language !== "md")
          return;
        function QA(tA) {
          if (!(!tA || typeof tA == "string"))
            for (var oA = 0, EA = tA.length; oA < EA; oA++) {
              var aA = tA[oA];
              if (aA.type !== "code") {
                QA(aA.content);
                continue;
              }
              var nA = aA.content[1], lA = aA.content[3];
              if (nA && lA && nA.type === "code-language" && lA.type === "code-block" && typeof nA.content == "string") {
                var cA = nA.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
                cA = (/[a-z][\w-]*/i.exec(cA) || [""])[0].toLowerCase();
                var sA = "language-" + cA;
                lA.alias ? typeof lA.alias == "string" ? lA.alias = [lA.alias, sA] : lA.alias.push(sA) : lA.alias = [sA];
              }
            }
        }
        QA(iA.tokens);
      }), g.hooks.add("wrap", function(iA) {
        if (iA.type === "code-block") {
          for (var QA = "", tA = 0, oA = iA.classes.length; tA < oA; tA++) {
            var EA = iA.classes[tA], aA = /language-(.+)/.exec(EA);
            if (aA) {
              QA = aA[1];
              break;
            }
          }
          var nA = g.languages[QA];
          if (nA)
            iA.content = g.highlight(
              eA(iA.content.value),
              nA,
              QA
            );
          else if (QA && QA !== "none" && g.plugins.autoloader) {
            var lA = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
            iA.attributes.id = lA, g.plugins.autoloader.loadLanguages(QA, function() {
              var cA = document.getElementById(lA);
              cA && (cA.innerHTML = g.highlight(
                cA.textContent,
                g.languages[QA],
                QA
              ));
            });
          }
        }
      });
      var IA = RegExp(g.languages.markup.tag.pattern.source, "gi"), CA = {
        amp: "&",
        lt: "<",
        gt: ">",
        quot: '"'
      }, BA = String.fromCodePoint || String.fromCharCode;
      function eA(iA) {
        var QA = iA.replace(IA, "");
        return QA = QA.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(tA, oA) {
          if (oA = oA.toLowerCase(), oA[0] === "#") {
            var EA;
            return oA[1] === "x" ? EA = parseInt(oA.slice(2), 16) : EA = Number(oA.slice(1)), BA(EA);
          } else {
            var aA = CA[oA];
            return aA || tA;
          }
        }), QA;
      }
      g.languages.md = g.languages.markdown;
    })(t);
  }
  return markdown_1;
}
var matlab_1, hasRequiredMatlab;
function requireMatlab() {
  if (hasRequiredMatlab) return matlab_1;
  hasRequiredMatlab = 1, matlab_1 = n, n.displayName = "matlab", n.aliases = [];
  function n(t) {
    t.languages.matlab = {
      comment: [/%\{[\s\S]*?\}%/, /%.+/],
      string: {
        pattern: /\B'(?:''|[^'\r\n])*'/,
        greedy: !0
      },
      // FIXME We could handle imaginary numbers as a whole
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
      keyword: /\b(?:NaN|break|case|catch|continue|else|elseif|end|for|function|if|inf|otherwise|parfor|pause|pi|return|switch|try|while)\b/,
      function: /\b(?!\d)\w+(?=\s*\()/,
      operator: /\.?[*^\/\\']|[+\-:@]|[<>=~]=?|&&?|\|\|?/,
      punctuation: /\.{3}|[.,;\[\](){}!]/
    };
  }
  return matlab_1;
}
var maxscript_1, hasRequiredMaxscript;
function requireMaxscript() {
  if (hasRequiredMaxscript) return maxscript_1;
  hasRequiredMaxscript = 1, maxscript_1 = n, n.displayName = "maxscript", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /\b(?:about|and|animate|as|at|attributes|by|case|catch|collect|continue|coordsys|do|else|exit|fn|for|from|function|global|if|in|local|macroscript|mapped|max|not|of|off|on|or|parameters|persistent|plugin|rcmenu|return|rollout|set|struct|then|throw|to|tool|try|undo|utility|when|where|while|with)\b/i;
      g.languages.maxscript = {
        comment: {
          pattern: /\/\*[\s\S]*?(?:\*\/|$)|--.*/,
          greedy: !0
        },
        string: {
          pattern: /(^|[^"\\@])(?:"(?:[^"\\]|\\[\s\S])*"|@"[^"]*")/,
          lookbehind: !0,
          greedy: !0
        },
        path: {
          pattern: /\$(?:[\w/\\.*?]|'[^']*')*/,
          greedy: !0,
          alias: "string"
        },
        "function-call": {
          pattern: RegExp(
            "((?:" + // start of line
            (/^/.source + "|" + // operators and other language constructs
            /[;=<>+\-*/^({\[]/.source + "|" + // keywords as part of statements
            /\b(?:and|by|case|catch|collect|do|else|if|in|not|or|return|then|to|try|where|while|with)\b/.source) + ")[ 	]*)(?!" + d.source + ")" + /[a-z_]\w*\b/.source + "(?=[ 	]*(?:" + // variable
            ("(?!" + d.source + ")" + /[a-z_]/.source + "|" + // number
            /\d|-\.?\d/.source + "|" + // other expressions or literals
            /[({'"$@#?]/.source) + "))",
            "im"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "function"
        },
        "function-definition": {
          pattern: /(\b(?:fn|function)\s+)\w+\b/i,
          lookbehind: !0,
          alias: "function"
        },
        argument: {
          pattern: /\b[a-z_]\w*(?=:)/i,
          alias: "attr-name"
        },
        keyword: d,
        boolean: /\b(?:false|true)\b/,
        time: {
          pattern: /(^|[^\w.])(?:(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?[msft])+|\d+:\d+(?:\.\d*)?)(?![\w.:])/,
          lookbehind: !0,
          alias: "number"
        },
        number: [
          {
            pattern: /(^|[^\w.])(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?|0x[a-fA-F0-9]+)(?![\w.:])/,
            lookbehind: !0
          },
          /\b(?:e|pi)\b/
        ],
        constant: /\b(?:dontcollect|ok|silentValue|undefined|unsupplied)\b/,
        color: {
          pattern: /\b(?:black|blue|brown|gray|green|orange|red|white|yellow)\b/i,
          alias: "constant"
        },
        operator: /[-+*/<>=!]=?|[&^?]|#(?!\()/,
        punctuation: /[()\[\]{}.:,;]|#(?=\()|\\$/m
      };
    })(t);
  }
  return maxscript_1;
}
var mel_1, hasRequiredMel;
function requireMel() {
  if (hasRequiredMel) return mel_1;
  hasRequiredMel = 1, mel_1 = n, n.displayName = "mel", n.aliases = [];
  function n(t) {
    t.languages.mel = {
      comment: /\/\/.*/,
      code: {
        pattern: /`(?:\\.|[^\\`\r\n])*`/,
        greedy: !0,
        alias: "italic",
        inside: {
          delimiter: {
            pattern: /^`|`$/,
            alias: "punctuation"
          }
          // See rest below
        }
      },
      string: {
        pattern: /"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      variable: /\$\w+/,
      number: /\b0x[\da-fA-F]+\b|\b\d+(?:\.\d*)?|\B\.\d+/,
      flag: {
        pattern: /-[^\d\W]\w*/,
        alias: "operator"
      },
      keyword: /\b(?:break|case|continue|default|do|else|float|for|global|if|in|int|matrix|proc|return|string|switch|vector|while)\b/,
      function: /\b\w+(?=\()|\b(?:CBG|HfAddAttractorToAS|HfAssignAS|HfBuildEqualMap|HfBuildFurFiles|HfBuildFurImages|HfCancelAFR|HfConnectASToHF|HfCreateAttractor|HfDeleteAS|HfEditAS|HfPerformCreateAS|HfRemoveAttractorFromAS|HfSelectAttached|HfSelectAttractors|HfUnAssignAS|Mayatomr|about|abs|addAttr|addAttributeEditorNodeHelp|addDynamic|addNewShelfTab|addPP|addPanelCategory|addPrefixToName|advanceToNextDrivenKey|affectedNet|affects|aimConstraint|air|alias|aliasAttr|align|alignCtx|alignCurve|alignSurface|allViewFit|ambientLight|angle|angleBetween|animCone|animCurveEditor|animDisplay|animView|annotate|appendStringArray|applicationName|applyAttrPreset|applyTake|arcLenDimContext|arcLengthDimension|arclen|arrayMapper|art3dPaintCtx|artAttrCtx|artAttrPaintVertexCtx|artAttrSkinPaintCtx|artAttrTool|artBuildPaintMenu|artFluidAttrCtx|artPuttyCtx|artSelectCtx|artSetPaintCtx|artUserPaintCtx|assignCommand|assignInputDevice|assignViewportFactories|attachCurve|attachDeviceAttr|attachSurface|attrColorSliderGrp|attrCompatibility|attrControlGrp|attrEnumOptionMenu|attrEnumOptionMenuGrp|attrFieldGrp|attrFieldSliderGrp|attrNavigationControlGrp|attrPresetEditWin|attributeExists|attributeInfo|attributeMenu|attributeQuery|autoKeyframe|autoPlace|bakeClip|bakeFluidShading|bakePartialHistory|bakeResults|bakeSimulation|basename|basenameEx|batchRender|bessel|bevel|bevelPlus|binMembership|bindSkin|blend2|blendShape|blendShapeEditor|blendShapePanel|blendTwoAttr|blindDataType|boneLattice|boundary|boxDollyCtx|boxZoomCtx|bufferCurve|buildBookmarkMenu|buildKeyframeMenu|button|buttonManip|cacheFile|cacheFileCombine|cacheFileMerge|cacheFileTrack|camera|cameraView|canCreateManip|canvas|capitalizeString|catch|catchQuiet|ceil|changeSubdivComponentDisplayLevel|changeSubdivRegion|channelBox|character|characterMap|characterOutlineEditor|characterize|chdir|checkBox|checkBoxGrp|checkDefaultRenderGlobals|choice|circle|circularFillet|clamp|clear|clearCache|clip|clipEditor|clipEditorCurrentTimeCtx|clipSchedule|clipSchedulerOutliner|clipTrimBefore|closeCurve|closeSurface|cluster|cmdFileOutput|cmdScrollFieldExecuter|cmdScrollFieldReporter|cmdShell|coarsenSubdivSelectionList|collision|color|colorAtPoint|colorEditor|colorIndex|colorIndexSliderGrp|colorSliderButtonGrp|colorSliderGrp|columnLayout|commandEcho|commandLine|commandPort|compactHairSystem|componentEditor|compositingInterop|computePolysetVolume|condition|cone|confirmDialog|connectAttr|connectControl|connectDynamic|connectJoint|connectionInfo|constrain|constrainValue|constructionHistory|container|containsMultibyte|contextInfo|control|convertFromOldLayers|convertIffToPsd|convertLightmap|convertSolidTx|convertTessellation|convertUnit|copyArray|copyFlexor|copyKey|copySkinWeights|cos|cpButton|cpCache|cpClothSet|cpCollision|cpConstraint|cpConvClothToMesh|cpForces|cpGetSolverAttr|cpPanel|cpProperty|cpRigidCollisionFilter|cpSeam|cpSetEdit|cpSetSolverAttr|cpSolver|cpSolverTypes|cpTool|cpUpdateClothUVs|createDisplayLayer|createDrawCtx|createEditor|createLayeredPsdFile|createMotionField|createNewShelf|createNode|createRenderLayer|createSubdivRegion|cross|crossProduct|ctxAbort|ctxCompletion|ctxEditMode|ctxTraverse|currentCtx|currentTime|currentTimeCtx|currentUnit|curve|curveAddPtCtx|curveCVCtx|curveEPCtx|curveEditorCtx|curveIntersect|curveMoveEPCtx|curveOnSurface|curveSketchCtx|cutKey|cycleCheck|cylinder|dagPose|date|defaultLightListCheckBox|defaultNavigation|defineDataServer|defineVirtualDevice|deformer|deg_to_rad|delete|deleteAttr|deleteShadingGroupsAndMaterials|deleteShelfTab|deleteUI|deleteUnusedBrushes|delrandstr|detachCurve|detachDeviceAttr|detachSurface|deviceEditor|devicePanel|dgInfo|dgdirty|dgeval|dgtimer|dimWhen|directKeyCtx|directionalLight|dirmap|dirname|disable|disconnectAttr|disconnectJoint|diskCache|displacementToPoly|displayAffected|displayColor|displayCull|displayLevelOfDetail|displayPref|displayRGBColor|displaySmoothness|displayStats|displayString|displaySurface|distanceDimContext|distanceDimension|doBlur|dolly|dollyCtx|dopeSheetEditor|dot|dotProduct|doubleProfileBirailSurface|drag|dragAttrContext|draggerContext|dropoffLocator|duplicate|duplicateCurve|duplicateSurface|dynCache|dynControl|dynExport|dynExpression|dynGlobals|dynPaintEditor|dynParticleCtx|dynPref|dynRelEdPanel|dynRelEditor|dynamicLoad|editAttrLimits|editDisplayLayerGlobals|editDisplayLayerMembers|editRenderLayerAdjustment|editRenderLayerGlobals|editRenderLayerMembers|editor|editorTemplate|effector|emit|emitter|enableDevice|encodeString|endString|endsWith|env|equivalent|equivalentTol|erf|error|eval|evalDeferred|evalEcho|event|exactWorldBoundingBox|exclusiveLightCheckBox|exec|executeForEachObject|exists|exp|expression|expressionEditorListen|extendCurve|extendSurface|extrude|fcheck|fclose|feof|fflush|fgetline|fgetword|file|fileBrowserDialog|fileDialog|fileExtension|fileInfo|filetest|filletCurve|filter|filterCurve|filterExpand|filterStudioImport|findAllIntersections|findAnimCurves|findKeyframe|findMenuItem|findRelatedSkinCluster|finder|firstParentOf|fitBspline|flexor|floatEq|floatField|floatFieldGrp|floatScrollBar|floatSlider|floatSlider2|floatSliderButtonGrp|floatSliderGrp|floor|flow|fluidCacheInfo|fluidEmitter|fluidVoxelInfo|flushUndo|fmod|fontDialog|fopen|formLayout|format|fprint|frameLayout|fread|freeFormFillet|frewind|fromNativePath|fwrite|gamma|gauss|geometryConstraint|getApplicationVersionAsFloat|getAttr|getClassification|getDefaultBrush|getFileList|getFluidAttr|getInputDeviceRange|getMayaPanelTypes|getModifiers|getPanel|getParticleAttr|getPluginResource|getenv|getpid|glRender|glRenderEditor|globalStitch|gmatch|goal|gotoBindPose|grabColor|gradientControl|gradientControlNoAttr|graphDollyCtx|graphSelectContext|graphTrackCtx|gravity|grid|gridLayout|group|groupObjectsByName|hardenPointCurve|hardware|hardwareRenderPanel|headsUpDisplay|headsUpMessage|help|helpLine|hermite|hide|hilite|hitTest|hotBox|hotkey|hotkeyCheck|hsv_to_rgb|hudButton|hudSlider|hudSliderButton|hwReflectionMap|hwRender|hwRenderLoad|hyperGraph|hyperPanel|hyperShade|hypot|iconTextButton|iconTextCheckBox|iconTextRadioButton|iconTextRadioCollection|iconTextScrollList|iconTextStaticLabel|ikHandle|ikHandleCtx|ikHandleDisplayScale|ikSolver|ikSplineHandleCtx|ikSystem|ikSystemInfo|ikfkDisplayMethod|illustratorCurves|image|imfPlugins|inheritTransform|insertJoint|insertJointCtx|insertKeyCtx|insertKnotCurve|insertKnotSurface|instance|instanceable|instancer|intField|intFieldGrp|intScrollBar|intSlider|intSliderGrp|interToUI|internalVar|intersect|iprEngine|isAnimCurve|isConnected|isDirty|isParentOf|isSameObject|isTrue|isValidObjectName|isValidString|isValidUiName|isolateSelect|itemFilter|itemFilterAttr|itemFilterRender|itemFilterType|joint|jointCluster|jointCtx|jointDisplayScale|jointLattice|keyTangent|keyframe|keyframeOutliner|keyframeRegionCurrentTimeCtx|keyframeRegionDirectKeyCtx|keyframeRegionDollyCtx|keyframeRegionInsertKeyCtx|keyframeRegionMoveKeyCtx|keyframeRegionScaleKeyCtx|keyframeRegionSelectKeyCtx|keyframeRegionSetKeyCtx|keyframeRegionTrackCtx|keyframeStats|lassoContext|lattice|latticeDeformKeyCtx|launch|launchImageEditor|layerButton|layeredShaderPort|layeredTexturePort|layout|layoutDialog|lightList|lightListEditor|lightListPanel|lightlink|lineIntersection|linearPrecision|linstep|listAnimatable|listAttr|listCameras|listConnections|listDeviceAttachments|listHistory|listInputDeviceAxes|listInputDeviceButtons|listInputDevices|listMenuAnnotation|listNodeTypes|listPanelCategories|listRelatives|listSets|listTransforms|listUnselected|listerEditor|loadFluid|loadNewShelf|loadPlugin|loadPluginLanguageResources|loadPrefObjects|localizedPanelLabel|lockNode|loft|log|longNameOf|lookThru|ls|lsThroughFilter|lsType|lsUI|mag|makeIdentity|makeLive|makePaintable|makeRoll|makeSingleSurface|makeTubeOn|makebot|manipMoveContext|manipMoveLimitsCtx|manipOptions|manipRotateContext|manipRotateLimitsCtx|manipScaleContext|manipScaleLimitsCtx|marker|match|max|memory|menu|menuBarLayout|menuEditor|menuItem|menuItemToShelf|menuSet|menuSetPref|messageLine|min|minimizeApp|mirrorJoint|modelCurrentTimeCtx|modelEditor|modelPanel|mouse|movIn|movOut|move|moveIKtoFK|moveKeyCtx|moveVertexAlongDirection|multiProfileBirailSurface|mute|nParticle|nameCommand|nameField|namespace|namespaceInfo|newPanelItems|newton|nodeCast|nodeIconButton|nodeOutliner|nodePreset|nodeType|noise|nonLinear|normalConstraint|normalize|nurbsBoolean|nurbsCopyUVSet|nurbsCube|nurbsEditUV|nurbsPlane|nurbsSelect|nurbsSquare|nurbsToPoly|nurbsToPolygonsPref|nurbsToSubdiv|nurbsToSubdivPref|nurbsUVSet|nurbsViewDirectionVector|objExists|objectCenter|objectLayer|objectType|objectTypeUI|obsoleteProc|oceanNurbsPreviewPlane|offsetCurve|offsetCurveOnSurface|offsetSurface|openGLExtension|openMayaPref|optionMenu|optionMenuGrp|optionVar|orbit|orbitCtx|orientConstraint|outlinerEditor|outlinerPanel|overrideModifier|paintEffectsDisplay|pairBlend|palettePort|paneLayout|panel|panelConfiguration|panelHistory|paramDimContext|paramDimension|paramLocator|parent|parentConstraint|particle|particleExists|particleInstancer|particleRenderInfo|partition|pasteKey|pathAnimation|pause|pclose|percent|performanceOptions|pfxstrokes|pickWalk|picture|pixelMove|planarSrf|plane|play|playbackOptions|playblast|plugAttr|plugNode|pluginInfo|pluginResourceUtil|pointConstraint|pointCurveConstraint|pointLight|pointMatrixMult|pointOnCurve|pointOnSurface|pointPosition|poleVectorConstraint|polyAppend|polyAppendFacetCtx|polyAppendVertex|polyAutoProjection|polyAverageNormal|polyAverageVertex|polyBevel|polyBlendColor|polyBlindData|polyBoolOp|polyBridgeEdge|polyCacheMonitor|polyCheck|polyChipOff|polyClipboard|polyCloseBorder|polyCollapseEdge|polyCollapseFacet|polyColorBlindData|polyColorDel|polyColorPerVertex|polyColorSet|polyCompare|polyCone|polyCopyUV|polyCrease|polyCreaseCtx|polyCreateFacet|polyCreateFacetCtx|polyCube|polyCut|polyCutCtx|polyCylinder|polyCylindricalProjection|polyDelEdge|polyDelFacet|polyDelVertex|polyDuplicateAndConnect|polyDuplicateEdge|polyEditUV|polyEditUVShell|polyEvaluate|polyExtrudeEdge|polyExtrudeFacet|polyExtrudeVertex|polyFlipEdge|polyFlipUV|polyForceUV|polyGeoSampler|polyHelix|polyInfo|polyInstallAction|polyLayoutUV|polyListComponentConversion|polyMapCut|polyMapDel|polyMapSew|polyMapSewMove|polyMergeEdge|polyMergeEdgeCtx|polyMergeFacet|polyMergeFacetCtx|polyMergeUV|polyMergeVertex|polyMirrorFace|polyMoveEdge|polyMoveFacet|polyMoveFacetUV|polyMoveUV|polyMoveVertex|polyNormal|polyNormalPerVertex|polyNormalizeUV|polyOptUvs|polyOptions|polyOutput|polyPipe|polyPlanarProjection|polyPlane|polyPlatonicSolid|polyPoke|polyPrimitive|polyPrism|polyProjection|polyPyramid|polyQuad|polyQueryBlindData|polyReduce|polySelect|polySelectConstraint|polySelectConstraintMonitor|polySelectCtx|polySelectEditCtx|polySeparate|polySetToFaceNormal|polySewEdge|polyShortestPathCtx|polySmooth|polySoftEdge|polySphere|polySphericalProjection|polySplit|polySplitCtx|polySplitEdge|polySplitRing|polySplitVertex|polyStraightenUVBorder|polySubdivideEdge|polySubdivideFacet|polyToSubdiv|polyTorus|polyTransfer|polyTriangulate|polyUVSet|polyUnite|polyWedgeFace|popen|popupMenu|pose|pow|preloadRefEd|print|progressBar|progressWindow|projFileViewer|projectCurve|projectTangent|projectionContext|projectionManip|promptDialog|propModCtx|propMove|psdChannelOutliner|psdEditTextureFile|psdExport|psdTextureFile|putenv|pwd|python|querySubdiv|quit|rad_to_deg|radial|radioButton|radioButtonGrp|radioCollection|radioMenuItemCollection|rampColorPort|rand|randomizeFollicles|randstate|rangeControl|readTake|rebuildCurve|rebuildSurface|recordAttr|recordDevice|redo|reference|referenceEdit|referenceQuery|refineSubdivSelectionList|refresh|refreshAE|registerPluginResource|rehash|reloadImage|removeJoint|removeMultiInstance|removePanelCategory|rename|renameAttr|renameSelectionList|renameUI|render|renderGlobalsNode|renderInfo|renderLayerButton|renderLayerParent|renderLayerPostProcess|renderLayerUnparent|renderManip|renderPartition|renderQualityNode|renderSettings|renderThumbnailUpdate|renderWindowEditor|renderWindowSelectContext|renderer|reorder|reorderDeformers|requires|reroot|resampleFluid|resetAE|resetPfxToPolyCamera|resetTool|resolutionNode|retarget|reverseCurve|reverseSurface|revolve|rgb_to_hsv|rigidBody|rigidSolver|roll|rollCtx|rootOf|rot|rotate|rotationInterpolation|roundConstantRadius|rowColumnLayout|rowLayout|runTimeCommand|runup|sampleImage|saveAllShelves|saveAttrPreset|saveFluid|saveImage|saveInitialState|saveMenu|savePrefObjects|savePrefs|saveShelf|saveToolSettings|scale|scaleBrushBrightness|scaleComponents|scaleConstraint|scaleKey|scaleKeyCtx|sceneEditor|sceneUIReplacement|scmh|scriptCtx|scriptEditorInfo|scriptJob|scriptNode|scriptTable|scriptToShelf|scriptedPanel|scriptedPanelType|scrollField|scrollLayout|sculpt|searchPathArray|seed|selLoadSettings|select|selectContext|selectCurveCV|selectKey|selectKeyCtx|selectKeyframeRegionCtx|selectMode|selectPref|selectPriority|selectType|selectedNodes|selectionConnection|separator|setAttr|setAttrEnumResource|setAttrMapping|setAttrNiceNameResource|setConstraintRestPosition|setDefaultShadingGroup|setDrivenKeyframe|setDynamic|setEditCtx|setEditor|setFluidAttr|setFocus|setInfinity|setInputDeviceMapping|setKeyCtx|setKeyPath|setKeyframe|setKeyframeBlendshapeTargetWts|setMenuMode|setNodeNiceNameResource|setNodeTypeFlag|setParent|setParticleAttr|setPfxToPolyCamera|setPluginResource|setProject|setStampDensity|setStartupMessage|setState|setToolTo|setUITemplate|setXformManip|sets|shadingConnection|shadingGeometryRelCtx|shadingLightRelCtx|shadingNetworkCompare|shadingNode|shapeCompare|shelfButton|shelfLayout|shelfTabLayout|shellField|shortNameOf|showHelp|showHidden|showManipCtx|showSelectionInTitle|showShadingGroupAttrEditor|showWindow|sign|simplify|sin|singleProfileBirailSurface|size|sizeBytes|skinCluster|skinPercent|smoothCurve|smoothTangentSurface|smoothstep|snap2to2|snapKey|snapMode|snapTogetherCtx|snapshot|soft|softMod|softModCtx|sort|sound|soundControl|source|spaceLocator|sphere|sphrand|spotLight|spotLightPreviewPort|spreadSheetEditor|spring|sqrt|squareSurface|srtContext|stackTrace|startString|startsWith|stitchAndExplodeShell|stitchSurface|stitchSurfacePoints|strcmp|stringArrayCatenate|stringArrayContains|stringArrayCount|stringArrayInsertAtIndex|stringArrayIntersector|stringArrayRemove|stringArrayRemoveAtIndex|stringArrayRemoveDuplicates|stringArrayRemoveExact|stringArrayToString|stringToStringArray|strip|stripPrefixFromName|stroke|subdAutoProjection|subdCleanTopology|subdCollapse|subdDuplicateAndConnect|subdEditUV|subdListComponentConversion|subdMapCut|subdMapSewMove|subdMatchTopology|subdMirror|subdToBlind|subdToPoly|subdTransferUVsToCache|subdiv|subdivCrease|subdivDisplaySmoothness|substitute|substituteAllString|substituteGeometry|substring|surface|surfaceSampler|surfaceShaderList|swatchDisplayPort|switchTable|symbolButton|symbolCheckBox|sysFile|system|tabLayout|tan|tangentConstraint|texLatticeDeformContext|texManipContext|texMoveContext|texMoveUVShellContext|texRotateContext|texScaleContext|texSelectContext|texSelectShortestPathCtx|texSmudgeUVContext|texWinToolCtx|text|textCurves|textField|textFieldButtonGrp|textFieldGrp|textManip|textScrollList|textToShelf|textureDisplacePlane|textureHairColor|texturePlacementContext|textureWindow|threadCount|threePointArcCtx|timeControl|timePort|timerX|toNativePath|toggle|toggleAxis|toggleWindowVisibility|tokenize|tokenizeList|tolerance|tolower|toolButton|toolCollection|toolDropped|toolHasOptions|toolPropertyWindow|torus|toupper|trace|track|trackCtx|transferAttributes|transformCompare|transformLimits|translator|trim|trunc|truncateFluidCache|truncateHairCache|tumble|tumbleCtx|turbulence|twoPointArcCtx|uiRes|uiTemplate|unassignInputDevice|undo|undoInfo|ungroup|uniform|unit|unloadPlugin|untangleUV|untitledFileName|untrim|upAxis|updateAE|userCtx|uvLink|uvSnapshot|validateShelfName|vectorize|view2dToolCtx|viewCamera|viewClipPlane|viewFit|viewHeadOn|viewLookAt|viewManip|viewPlace|viewSet|visor|volumeAxis|vortex|waitCursor|warning|webBrowser|webBrowserPrefs|whatIs|window|windowPref|wire|wireContext|workspace|wrinkle|wrinkleContext|writeTake|xbmLangPathList|xform)\b/,
      operator: [
        /\+[+=]?|-[-=]?|&&|\|\||[<>]=|[*\/!=]=?|[%^]/,
        {
          // We don't want to match <<
          pattern: /(^|[^<])<(?!<)/,
          lookbehind: !0
        },
        {
          // We don't want to match >>
          pattern: /(^|[^>])>(?!>)/,
          lookbehind: !0
        }
      ],
      punctuation: /<<|>>|[.,:;?\[\](){}]/
    }, t.languages.mel.code.inside.rest = t.languages.mel;
  }
  return mel_1;
}
var mermaid_1, hasRequiredMermaid;
function requireMermaid() {
  if (hasRequiredMermaid) return mermaid_1;
  hasRequiredMermaid = 1, mermaid_1 = n, n.displayName = "mermaid", n.aliases = [];
  function n(t) {
    t.languages.mermaid = {
      comment: {
        pattern: /%%.*/,
        greedy: !0
      },
      style: {
        pattern: /^([ \t]*(?:classDef|linkStyle|style)[ \t]+[\w$-]+[ \t]+)\w.*[^\s;]/m,
        lookbehind: !0,
        inside: {
          property: /\b\w[\w-]*(?=[ \t]*:)/,
          operator: /:/,
          punctuation: /,/
        }
      },
      "inter-arrow-label": {
        pattern: /([^<>ox.=-])(?:-[-.]|==)(?![<>ox.=-])[ \t]*(?:"[^"\r\n]*"|[^\s".=-](?:[^\r\n.=-]*[^\s.=-])?)[ \t]*(?:\.+->?|--+[->]|==+[=>])(?![<>ox.=-])/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          arrow: {
            pattern: /(?:\.+->?|--+[->]|==+[=>])$/,
            alias: "operator"
          },
          label: {
            pattern: /^([\s\S]{2}[ \t]*)\S(?:[\s\S]*\S)?/,
            lookbehind: !0,
            alias: "property"
          },
          "arrow-head": {
            pattern: /^\S+/,
            alias: ["arrow", "operator"]
          }
        }
      },
      arrow: [
        // This might look complex but it really isn't.
        // There are many possible arrows (see tests) and it's impossible to fit all of them into one pattern. The
        // problem is that we only have one lookbehind per pattern. However, we cannot disallow too many arrow
        // characters in the one lookbehind because that would create too many false negatives. So we have to split the
        // arrows into different patterns.
        {
          // ER diagram
          pattern: /(^|[^{}|o.-])[|}][|o](?:--|\.\.)[|o][|{](?![{}|o.-])/,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // flow chart
          // (?:==+|--+|-\.*-)
          pattern: /(^|[^<>ox.=-])(?:[<ox](?:==+|--+|-\.*-)[>ox]?|(?:==+|--+|-\.*-)[>ox]|===+|---+|-\.+-)(?![<>ox.=-])/,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // sequence diagram
          pattern: /(^|[^<>()x-])(?:--?(?:>>|[x>)])(?![<>()x])|(?:<<|[x<(])--?(?!-))/,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // class diagram
          pattern: /(^|[^<>|*o.-])(?:[*o]--|--[*o]|<\|?(?:--|\.\.)|(?:--|\.\.)\|?>|--|\.\.)(?![<>|*o.-])/,
          lookbehind: !0,
          alias: "operator"
        }
      ],
      label: {
        pattern: /(^|[^|<])\|(?:[^\r\n"|]|"[^"\r\n]*")+\|/,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      text: {
        pattern: /(?:[(\[{]+|\b>)(?:[^\r\n"()\[\]{}]|"[^"\r\n]*")+(?:[)\]}]+|>)/,
        alias: "string"
      },
      string: {
        pattern: /"[^"\r\n]*"/,
        greedy: !0
      },
      annotation: {
        pattern: /<<(?:abstract|choice|enumeration|fork|interface|join|service)>>|\[\[(?:choice|fork|join)\]\]/i,
        alias: "important"
      },
      keyword: [
        // This language has both case-sensitive and case-insensitive keywords
        {
          pattern: /(^[ \t]*)(?:action|callback|class|classDef|classDiagram|click|direction|erDiagram|flowchart|gantt|gitGraph|graph|journey|link|linkStyle|pie|requirementDiagram|sequenceDiagram|stateDiagram|stateDiagram-v2|style|subgraph)(?![\w$-])/m,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^[ \t]*)(?:activate|alt|and|as|autonumber|deactivate|else|end(?:[ \t]+note)?|loop|opt|par|participant|rect|state|note[ \t]+(?:over|(?:left|right)[ \t]+of))(?![\w$-])/im,
          lookbehind: !0,
          greedy: !0
        }
      ],
      entity: /#[a-z0-9]+;/,
      operator: {
        pattern: /(\w[ \t]*)&(?=[ \t]*\w)|:::|:/,
        lookbehind: !0
      },
      punctuation: /[(){};]/
    };
  }
  return mermaid_1;
}
var mizar_1, hasRequiredMizar;
function requireMizar() {
  if (hasRequiredMizar) return mizar_1;
  hasRequiredMizar = 1, mizar_1 = n, n.displayName = "mizar", n.aliases = [];
  function n(t) {
    t.languages.mizar = {
      comment: /::.+/,
      keyword: /@proof\b|\b(?:according|aggregate|all|and|antonym|are|as|associativity|assume|asymmetry|attr|be|begin|being|by|canceled|case|cases|clusters?|coherence|commutativity|compatibility|connectedness|consider|consistency|constructors|contradiction|correctness|def|deffunc|define|definitions?|defpred|do|does|end|environ|equals|ex|exactly|existence|for|from|func|given|hence|hereby|holds|idempotence|identity|iff?|implies|involutiveness|irreflexivity|is|it|let|means|mode|non|not|notations?|now|of|or|otherwise|over|per|pred|prefix|projectivity|proof|provided|qua|reconsider|redefine|reduce|reducibility|reflexivity|registrations?|requirements|reserve|sch|schemes?|section|selector|set|sethood|st|struct|such|suppose|symmetry|synonym|take|that|the|then|theorems?|thesis|thus|to|transitivity|uniqueness|vocabular(?:ies|y)|when|where|with|wrt)\b/,
      parameter: {
        pattern: /\$(?:10|\d)/,
        alias: "variable"
      },
      variable: /\b\w+(?=:)/,
      number: /(?:\b|-)\d+\b/,
      operator: /\.\.\.|->|&|\.?=/,
      punctuation: /\(#|#\)|[,:;\[\](){}]/
    };
  }
  return mizar_1;
}
var mongodb_1, hasRequiredMongodb;
function requireMongodb() {
  if (hasRequiredMongodb) return mongodb_1;
  hasRequiredMongodb = 1, mongodb_1 = n, n.displayName = "mongodb", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = [
        // query and projection
        "$eq",
        "$gt",
        "$gte",
        "$in",
        "$lt",
        "$lte",
        "$ne",
        "$nin",
        "$and",
        "$not",
        "$nor",
        "$or",
        "$exists",
        "$type",
        "$expr",
        "$jsonSchema",
        "$mod",
        "$regex",
        "$text",
        "$where",
        "$geoIntersects",
        "$geoWithin",
        "$near",
        "$nearSphere",
        "$all",
        "$elemMatch",
        "$size",
        "$bitsAllClear",
        "$bitsAllSet",
        "$bitsAnyClear",
        "$bitsAnySet",
        "$comment",
        "$elemMatch",
        "$meta",
        "$slice",
        // update
        "$currentDate",
        "$inc",
        "$min",
        "$max",
        "$mul",
        "$rename",
        "$set",
        "$setOnInsert",
        "$unset",
        "$addToSet",
        "$pop",
        "$pull",
        "$push",
        "$pullAll",
        "$each",
        "$position",
        "$slice",
        "$sort",
        "$bit",
        // aggregation pipeline stages
        "$addFields",
        "$bucket",
        "$bucketAuto",
        "$collStats",
        "$count",
        "$currentOp",
        "$facet",
        "$geoNear",
        "$graphLookup",
        "$group",
        "$indexStats",
        "$limit",
        "$listLocalSessions",
        "$listSessions",
        "$lookup",
        "$match",
        "$merge",
        "$out",
        "$planCacheStats",
        "$project",
        "$redact",
        "$replaceRoot",
        "$replaceWith",
        "$sample",
        "$set",
        "$skip",
        "$sort",
        "$sortByCount",
        "$unionWith",
        "$unset",
        "$unwind",
        "$setWindowFields",
        // aggregation pipeline operators
        "$abs",
        "$accumulator",
        "$acos",
        "$acosh",
        "$add",
        "$addToSet",
        "$allElementsTrue",
        "$and",
        "$anyElementTrue",
        "$arrayElemAt",
        "$arrayToObject",
        "$asin",
        "$asinh",
        "$atan",
        "$atan2",
        "$atanh",
        "$avg",
        "$binarySize",
        "$bsonSize",
        "$ceil",
        "$cmp",
        "$concat",
        "$concatArrays",
        "$cond",
        "$convert",
        "$cos",
        "$dateFromParts",
        "$dateToParts",
        "$dateFromString",
        "$dateToString",
        "$dayOfMonth",
        "$dayOfWeek",
        "$dayOfYear",
        "$degreesToRadians",
        "$divide",
        "$eq",
        "$exp",
        "$filter",
        "$first",
        "$floor",
        "$function",
        "$gt",
        "$gte",
        "$hour",
        "$ifNull",
        "$in",
        "$indexOfArray",
        "$indexOfBytes",
        "$indexOfCP",
        "$isArray",
        "$isNumber",
        "$isoDayOfWeek",
        "$isoWeek",
        "$isoWeekYear",
        "$last",
        "$last",
        "$let",
        "$literal",
        "$ln",
        "$log",
        "$log10",
        "$lt",
        "$lte",
        "$ltrim",
        "$map",
        "$max",
        "$mergeObjects",
        "$meta",
        "$min",
        "$millisecond",
        "$minute",
        "$mod",
        "$month",
        "$multiply",
        "$ne",
        "$not",
        "$objectToArray",
        "$or",
        "$pow",
        "$push",
        "$radiansToDegrees",
        "$range",
        "$reduce",
        "$regexFind",
        "$regexFindAll",
        "$regexMatch",
        "$replaceOne",
        "$replaceAll",
        "$reverseArray",
        "$round",
        "$rtrim",
        "$second",
        "$setDifference",
        "$setEquals",
        "$setIntersection",
        "$setIsSubset",
        "$setUnion",
        "$size",
        "$sin",
        "$slice",
        "$split",
        "$sqrt",
        "$stdDevPop",
        "$stdDevSamp",
        "$strcasecmp",
        "$strLenBytes",
        "$strLenCP",
        "$substr",
        "$substrBytes",
        "$substrCP",
        "$subtract",
        "$sum",
        "$switch",
        "$tan",
        "$toBool",
        "$toDate",
        "$toDecimal",
        "$toDouble",
        "$toInt",
        "$toLong",
        "$toObjectId",
        "$toString",
        "$toLower",
        "$toUpper",
        "$trim",
        "$trunc",
        "$type",
        "$week",
        "$year",
        "$zip",
        "$count",
        "$dateAdd",
        "$dateDiff",
        "$dateSubtract",
        "$dateTrunc",
        "$getField",
        "$rand",
        "$sampleRate",
        "$setField",
        "$unsetField",
        // aggregation pipeline query modifiers
        "$comment",
        "$explain",
        "$hint",
        "$max",
        "$maxTimeMS",
        "$min",
        "$orderby",
        "$query",
        "$returnKey",
        "$showDiskLoc",
        "$natural"
      ], k = [
        "ObjectId",
        "Code",
        "BinData",
        "DBRef",
        "Timestamp",
        "NumberLong",
        "NumberDecimal",
        "MaxKey",
        "MinKey",
        "RegExp",
        "ISODate",
        "UUID"
      ];
      d = d.map(function(AA) {
        return AA.replace("$", "\\$");
      });
      var H = "(?:" + d.join("|") + ")\\b";
      g.languages.mongodb = g.languages.extend("javascript", {}), g.languages.insertBefore("mongodb", "string", {
        property: {
          pattern: /(?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)(?=\s*:)/,
          greedy: !0,
          inside: {
            keyword: RegExp(`^(['"])?` + H + "(?:\\1)?$")
          }
        }
      }), g.languages.mongodb.string.inside = {
        url: {
          // url pattern
          pattern: /https?:\/\/[-\w@:%.+~#=]{1,256}\.[a-z0-9()]{1,6}\b[-\w()@:%+.~#?&/=]*/i,
          greedy: !0
        },
        entity: {
          // ipv4
          pattern: /\b(?:(?:[01]?\d\d?|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d\d?|2[0-4]\d|25[0-5])\b/,
          greedy: !0
        }
      }, g.languages.insertBefore("mongodb", "constant", {
        builtin: {
          pattern: RegExp("\\b(?:" + k.join("|") + ")\\b"),
          alias: "keyword"
        }
      });
    })(t);
  }
  return mongodb_1;
}
var monkey_1, hasRequiredMonkey;
function requireMonkey() {
  if (hasRequiredMonkey) return monkey_1;
  hasRequiredMonkey = 1, monkey_1 = n, n.displayName = "monkey", n.aliases = [];
  function n(t) {
    t.languages.monkey = {
      comment: {
        pattern: /^#Rem\s[\s\S]*?^#End|'.+/im,
        greedy: !0
      },
      string: {
        pattern: /"[^"\r\n]*"/,
        greedy: !0
      },
      preprocessor: {
        pattern: /(^[ \t]*)#.+/m,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      function: /\b\w+(?=\()/,
      "type-char": {
        pattern: /\b[?%#$]/,
        alias: "class-name"
      },
      number: {
        pattern: /((?:\.\.)?)(?:(?:\b|\B-\.?|\B\.)\d+(?:(?!\.\.)\.\d*)?|\$[\da-f]+)/i,
        lookbehind: !0
      },
      keyword: /\b(?:Abstract|Array|Bool|Case|Catch|Class|Const|Continue|Default|Eachin|Else|ElseIf|End|EndIf|Exit|Extends|Extern|False|Field|Final|Float|For|Forever|Function|Global|If|Implements|Import|Inline|Int|Interface|Local|Method|Module|New|Next|Null|Object|Private|Property|Public|Repeat|Return|Select|Self|Step|Strict|String|Super|Then|Throw|To|True|Try|Until|Void|Wend|While)\b/i,
      operator: /\.\.|<[=>]?|>=?|:?=|(?:[+\-*\/&~|]|\b(?:Mod|Shl|Shr)\b)=?|\b(?:And|Not|Or)\b/i,
      punctuation: /[.,:;()\[\]]/
    };
  }
  return monkey_1;
}
var moonscript_1, hasRequiredMoonscript;
function requireMoonscript() {
  if (hasRequiredMoonscript) return moonscript_1;
  hasRequiredMoonscript = 1, moonscript_1 = n, n.displayName = "moonscript", n.aliases = ["moon"];
  function n(t) {
    t.languages.moonscript = {
      comment: /--.*/,
      string: [
        {
          pattern: /'[^']*'|\[(=*)\[[\s\S]*?\]\1\]/,
          greedy: !0
        },
        {
          pattern: /"[^"]*"/,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /#\{[^{}]*\}/,
              inside: {
                moonscript: {
                  pattern: /(^#\{)[\s\S]+(?=\})/,
                  lookbehind: !0,
                  inside: null
                  // see beow
                },
                "interpolation-punctuation": {
                  pattern: /#\{|\}/,
                  alias: "punctuation"
                }
              }
            }
          }
        }
      ],
      "class-name": [
        {
          pattern: /(\b(?:class|extends)[ \t]+)\w+/,
          lookbehind: !0
        },
        // class-like names start with a capital letter
        /\b[A-Z]\w*/
      ],
      keyword: /\b(?:class|continue|do|else|elseif|export|extends|for|from|if|import|in|local|nil|return|self|super|switch|then|unless|using|when|while|with)\b/,
      variable: /@@?\w*/,
      property: {
        pattern: /\b(?!\d)\w+(?=:)|(:)(?!\d)\w+/,
        lookbehind: !0
      },
      function: {
        pattern: /\b(?:_G|_VERSION|assert|collectgarbage|coroutine\.(?:create|resume|running|status|wrap|yield)|debug\.(?:debug|getfenv|gethook|getinfo|getlocal|getmetatable|getregistry|getupvalue|setfenv|sethook|setlocal|setmetatable|setupvalue|traceback)|dofile|error|getfenv|getmetatable|io\.(?:close|flush|input|lines|open|output|popen|read|stderr|stdin|stdout|tmpfile|type|write)|ipairs|load|loadfile|loadstring|math\.(?:abs|acos|asin|atan|atan2|ceil|cos|cosh|deg|exp|floor|fmod|frexp|ldexp|log|log10|max|min|modf|pi|pow|rad|random|randomseed|sin|sinh|sqrt|tan|tanh)|module|next|os\.(?:clock|date|difftime|execute|exit|getenv|remove|rename|setlocale|time|tmpname)|package\.(?:cpath|loaded|loadlib|path|preload|seeall)|pairs|pcall|print|rawequal|rawget|rawset|require|select|setfenv|setmetatable|string\.(?:byte|char|dump|find|format|gmatch|gsub|len|lower|match|rep|reverse|sub|upper)|table\.(?:concat|insert|maxn|remove|sort)|tonumber|tostring|type|unpack|xpcall)\b/,
        inside: {
          punctuation: /\./
        }
      },
      boolean: /\b(?:false|true)\b/,
      number: /(?:\B\.\d+|\b\d+\.\d+|\b\d+(?=[eE]))(?:[eE][-+]?\d+)?\b|\b(?:0x[a-fA-F\d]+|\d+)(?:U?LL)?\b/,
      operator: /\.{3}|[-=]>|~=|(?:[-+*/%<>!=]|\.\.)=?|[:#^]|\b(?:and|or)\b=?|\b(?:not)\b/,
      punctuation: /[.,()[\]{}\\]/
    }, t.languages.moonscript.string[1].inside.interpolation.inside.moonscript.inside = t.languages.moonscript, t.languages.moon = t.languages.moonscript;
  }
  return moonscript_1;
}
var n1ql_1, hasRequiredN1ql;
function requireN1ql() {
  if (hasRequiredN1ql) return n1ql_1;
  hasRequiredN1ql = 1, n1ql_1 = n, n.displayName = "n1ql", n.aliases = [];
  function n(t) {
    t.languages.n1ql = {
      comment: {
        pattern: /\/\*[\s\S]*?(?:$|\*\/)|--.*/,
        greedy: !0
      },
      string: {
        pattern: /(["'])(?:\\[\s\S]|(?!\1)[^\\]|\1\1)*\1/,
        greedy: !0
      },
      identifier: {
        pattern: /`(?:\\[\s\S]|[^\\`]|``)*`/,
        greedy: !0
      },
      parameter: /\$[\w.]+/,
      // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html#n1ql-reserved-words
      keyword: /\b(?:ADVISE|ALL|ALTER|ANALYZE|AS|ASC|AT|BEGIN|BINARY|BOOLEAN|BREAK|BUCKET|BUILD|BY|CALL|CAST|CLUSTER|COLLATE|COLLECTION|COMMIT|COMMITTED|CONNECT|CONTINUE|CORRELATE|CORRELATED|COVER|CREATE|CURRENT|DATABASE|DATASET|DATASTORE|DECLARE|DECREMENT|DELETE|DERIVED|DESC|DESCRIBE|DISTINCT|DO|DROP|EACH|ELEMENT|EXCEPT|EXCLUDE|EXECUTE|EXPLAIN|FETCH|FILTER|FLATTEN|FLUSH|FOLLOWING|FOR|FORCE|FROM|FTS|FUNCTION|GOLANG|GRANT|GROUP|GROUPS|GSI|HASH|HAVING|IF|IGNORE|ILIKE|INCLUDE|INCREMENT|INDEX|INFER|INLINE|INNER|INSERT|INTERSECT|INTO|IS|ISOLATION|JAVASCRIPT|JOIN|KEY|KEYS|KEYSPACE|KNOWN|LANGUAGE|LAST|LEFT|LET|LETTING|LEVEL|LIMIT|LSM|MAP|MAPPING|MATCHED|MATERIALIZED|MERGE|MINUS|MISSING|NAMESPACE|NEST|NL|NO|NTH_VALUE|NULL|NULLS|NUMBER|OBJECT|OFFSET|ON|OPTION|OPTIONS|ORDER|OTHERS|OUTER|OVER|PARSE|PARTITION|PASSWORD|PATH|POOL|PRECEDING|PREPARE|PRIMARY|PRIVATE|PRIVILEGE|PROBE|PROCEDURE|PUBLIC|RANGE|RAW|REALM|REDUCE|RENAME|RESPECT|RETURN|RETURNING|REVOKE|RIGHT|ROLE|ROLLBACK|ROW|ROWS|SATISFIES|SAVEPOINT|SCHEMA|SCOPE|SELECT|SELF|SEMI|SET|SHOW|SOME|START|STATISTICS|STRING|SYSTEM|TIES|TO|TRAN|TRANSACTION|TRIGGER|TRUNCATE|UNBOUNDED|UNDER|UNION|UNIQUE|UNKNOWN|UNNEST|UNSET|UPDATE|UPSERT|USE|USER|USING|VALIDATE|VALUE|VALUES|VIA|VIEW|WHERE|WHILE|WINDOW|WITH|WORK|XOR)\b/i,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      boolean: /\b(?:FALSE|TRUE)\b/i,
      number: /(?:\b\d+\.|\B\.)\d+e[+\-]?\d+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
      operator: /[-+*\/%]|!=|==?|\|\||<[>=]?|>=?|\b(?:AND|ANY|ARRAY|BETWEEN|CASE|ELSE|END|EVERY|EXISTS|FIRST|IN|LIKE|NOT|OR|THEN|VALUED|WHEN|WITHIN)\b/i,
      punctuation: /[;[\](),.{}:]/
    };
  }
  return n1ql_1;
}
var n4js_1, hasRequiredN4js;
function requireN4js() {
  if (hasRequiredN4js) return n4js_1;
  hasRequiredN4js = 1, n4js_1 = n, n.displayName = "n4js", n.aliases = ["n4jsd"];
  function n(t) {
    t.languages.n4js = t.languages.extend("javascript", {
      // Keywords from N4JS language spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html
      keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
    }), t.languages.insertBefore("n4js", "constant", {
      // Annotations in N4JS spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html#_annotations
      annotation: {
        pattern: /@+\w+/,
        alias: "operator"
      }
    }), t.languages.n4jsd = t.languages.n4js;
  }
  return n4js_1;
}
var nand2tetrisHdl_1, hasRequiredNand2tetrisHdl;
function requireNand2tetrisHdl() {
  if (hasRequiredNand2tetrisHdl) return nand2tetrisHdl_1;
  hasRequiredNand2tetrisHdl = 1, nand2tetrisHdl_1 = n, n.displayName = "nand2tetrisHdl", n.aliases = [];
  function n(t) {
    t.languages["nand2tetris-hdl"] = {
      comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
      keyword: /\b(?:BUILTIN|CHIP|CLOCKED|IN|OUT|PARTS)\b/,
      boolean: /\b(?:false|true)\b/,
      function: /\b[A-Za-z][A-Za-z0-9]*(?=\()/,
      number: /\b\d+\b/,
      operator: /=|\.\./,
      punctuation: /[{}[\];(),:]/
    };
  }
  return nand2tetrisHdl_1;
}
var naniscript_1, hasRequiredNaniscript;
function requireNaniscript() {
  if (hasRequiredNaniscript) return naniscript_1;
  hasRequiredNaniscript = 1, naniscript_1 = n, n.displayName = "naniscript", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /\{[^\r\n\[\]{}]*\}/, k = {
        "quoted-string": {
          pattern: /"(?:[^"\\]|\\.)*"/,
          alias: "operator"
        },
        "command-param-id": {
          pattern: /(\s)\w+:/,
          lookbehind: !0,
          alias: "property"
        },
        "command-param-value": [
          {
            pattern: d,
            alias: "selector"
          },
          {
            pattern: /([\t ])\S+/,
            lookbehind: !0,
            greedy: !0,
            alias: "operator"
          },
          {
            pattern: /\S(?:.*\S)?/,
            alias: "operator"
          }
        ]
      };
      g.languages.naniscript = {
        // ; ...
        comment: {
          pattern: /^([\t ]*);.*/m,
          lookbehind: !0
        },
        // > ...
        // Define is a control line starting with '>' followed by a word, a space and a text.
        define: {
          pattern: /^>.+/m,
          alias: "tag",
          inside: {
            value: {
              pattern: /(^>\w+[\t ]+)(?!\s)[^{}\r\n]+/,
              lookbehind: !0,
              alias: "operator"
            },
            key: {
              pattern: /(^>)\w+/,
              lookbehind: !0
            }
          }
        },
        // # ...
        label: {
          pattern: /^([\t ]*)#[\t ]*\w+[\t ]*$/m,
          lookbehind: !0,
          alias: "regex"
        },
        command: {
          pattern: /^([\t ]*)@\w+(?=[\t ]|$).*/m,
          lookbehind: !0,
          alias: "function",
          inside: {
            "command-name": /^@\w+/,
            expression: {
              pattern: d,
              greedy: !0,
              alias: "selector"
            },
            "command-params": {
              pattern: /\s*\S[\s\S]*/,
              inside: k
            }
          }
        },
        // Generic is any line that doesn't start with operators: ;>#@
        "generic-text": {
          pattern: /(^[ \t]*)[^#@>;\s].*/m,
          lookbehind: !0,
          alias: "punctuation",
          inside: {
            // \{ ... \} ... \[ ... \] ... \"
            "escaped-char": /\\[{}\[\]"]/,
            expression: {
              pattern: d,
              greedy: !0,
              alias: "selector"
            },
            "inline-command": {
              pattern: /\[[\t ]*\w[^\r\n\[\]]*\]/,
              greedy: !0,
              alias: "function",
              inside: {
                "command-params": {
                  pattern: /(^\[[\t ]*\w+\b)[\s\S]+(?=\]$)/,
                  lookbehind: !0,
                  inside: k
                },
                "command-param-name": {
                  pattern: /^(\[[\t ]*)\w+/,
                  lookbehind: !0,
                  alias: "name"
                },
                "start-stop-char": /[\[\]]/
              }
            }
          }
        }
      }, g.languages.nani = g.languages.naniscript, g.hooks.add("after-tokenize", function(gA) {
        var IA = gA.tokens;
        IA.forEach(function(CA) {
          if (typeof CA != "string" && CA.type === "generic-text") {
            var BA = AA(CA);
            H(BA) || (CA.type = "bad-line", CA.content = BA);
          }
        });
      });
      function H(gA) {
        for (var IA = "[]{}", CA = [], BA = 0; BA < gA.length; BA++) {
          var eA = gA[BA], iA = IA.indexOf(eA);
          if (iA !== -1) {
            if (iA % 2 === 0)
              CA.push(iA + 1);
            else if (CA.pop() !== iA)
              return !1;
          }
        }
        return CA.length === 0;
      }
      function AA(gA) {
        return typeof gA == "string" ? gA : Array.isArray(gA) ? gA.map(AA).join("") : AA(gA.content);
      }
    })(t);
  }
  return naniscript_1;
}
var nasm_1, hasRequiredNasm;
function requireNasm() {
  if (hasRequiredNasm) return nasm_1;
  hasRequiredNasm = 1, nasm_1 = n, n.displayName = "nasm", n.aliases = [];
  function n(t) {
    t.languages.nasm = {
      comment: /;.*$/m,
      string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      label: {
        pattern: /(^\s*)[A-Za-z._?$][\w.?$@~#]*:/m,
        lookbehind: !0,
        alias: "function"
      },
      keyword: [
        /\[?BITS (?:16|32|64)\]?/,
        {
          pattern: /(^\s*)section\s*[a-z.]+:?/im,
          lookbehind: !0
        },
        /(?:extern|global)[^;\r\n]*/i,
        /(?:CPU|DEFAULT|FLOAT).*$/m
      ],
      register: {
        pattern: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s)\b/i,
        alias: "variable"
      },
      number: /(?:\b|(?=\$))(?:0[hx](?:\.[\da-f]+|[\da-f]+(?:\.[\da-f]+)?)(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
      operator: /[\[\]*+\-\/%<>=&|$!]/
    };
  }
  return nasm_1;
}
var neon_1, hasRequiredNeon;
function requireNeon() {
  if (hasRequiredNeon) return neon_1;
  hasRequiredNeon = 1, neon_1 = n, n.displayName = "neon", n.aliases = [];
  function n(t) {
    t.languages.neon = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      datetime: {
        pattern: /(^|[[{(=:,\s])\d\d\d\d-\d\d?-\d\d?(?:(?:[Tt]| +)\d\d?:\d\d:\d\d(?:\.\d*)? *(?:Z|[-+]\d\d?(?::?\d\d)?)?)?(?=$|[\]}),\s])/,
        lookbehind: !0,
        alias: "number"
      },
      key: {
        pattern: /(^|[[{(,\s])[^,:=[\]{}()'"\s]+(?=\s*:(?:$|[\]}),\s])|\s*=)/,
        lookbehind: !0,
        alias: "atrule"
      },
      number: {
        pattern: /(^|[[{(=:,\s])[+-]?(?:0x[\da-fA-F]+|0o[0-7]+|0b[01]+|(?:\d+(?:\.\d*)?|\.?\d+)(?:[eE][+-]?\d+)?)(?=$|[\]}),:=\s])/,
        lookbehind: !0
      },
      boolean: {
        pattern: /(^|[[{(=:,\s])(?:false|no|true|yes)(?=$|[\]}),:=\s])/i,
        lookbehind: !0
      },
      null: {
        pattern: /(^|[[{(=:,\s])(?:null)(?=$|[\]}),:=\s])/i,
        lookbehind: !0,
        alias: "keyword"
      },
      string: {
        pattern: /(^|[[{(=:,\s])(?:('''|""")\r?\n(?:(?:[^\r\n]|\r?\n(?![\t ]*\2))*\r?\n)?[\t ]*\2|'[^'\r\n]*'|"(?:\\.|[^\\"\r\n])*")/,
        lookbehind: !0,
        greedy: !0
      },
      literal: {
        pattern: /(^|[[{(=:,\s])(?:[^#"',:=[\]{}()\s`-]|[:-][^"',=[\]{}()\s])(?:[^,:=\]})(\s]|:(?![\s,\]})]|$)|[ \t]+[^#,:=\]})(\s])*/,
        lookbehind: !0,
        alias: "string"
      },
      punctuation: /[,:=[\]{}()-]/
    };
  }
  return neon_1;
}
var nevod_1, hasRequiredNevod;
function requireNevod() {
  if (hasRequiredNevod) return nevod_1;
  hasRequiredNevod = 1, nevod_1 = n, n.displayName = "nevod", n.aliases = [];
  function n(t) {
    t.languages.nevod = {
      comment: /\/\/.*|(?:\/\*[\s\S]*?(?:\*\/|$))/,
      string: {
        pattern: /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))!?\*?/,
        greedy: !0,
        inside: {
          "string-attrs": /!$|!\*$|\*$/
        }
      },
      namespace: {
        pattern: /(@namespace\s+)[a-zA-Z0-9\-.]+(?=\s*\{)/,
        lookbehind: !0
      },
      pattern: {
        pattern: /(@pattern\s+)?#?[a-zA-Z0-9\-.]+(?:\s*\(\s*(?:~\s*)?[a-zA-Z0-9\-.]+\s*(?:,\s*(?:~\s*)?[a-zA-Z0-9\-.]*)*\))?(?=\s*=)/,
        lookbehind: !0,
        inside: {
          "pattern-name": {
            pattern: /^#?[a-zA-Z0-9\-.]+/,
            alias: "class-name"
          },
          fields: {
            pattern: /\(.*\)/,
            inside: {
              "field-name": {
                pattern: /[a-zA-Z0-9\-.]+/,
                alias: "variable"
              },
              punctuation: /[,()]/,
              operator: {
                pattern: /~/,
                alias: "field-hidden-mark"
              }
            }
          }
        }
      },
      search: {
        pattern: /(@search\s+|#)[a-zA-Z0-9\-.]+(?:\.\*)?(?=\s*;)/,
        alias: "function",
        lookbehind: !0
      },
      keyword: /@(?:having|inside|namespace|outside|pattern|require|search|where)\b/,
      "standard-pattern": {
        pattern: /\b(?:Alpha|AlphaNum|Any|Blank|End|LineBreak|Num|NumAlpha|Punct|Space|Start|Symbol|Word|WordBreak)\b(?:\([a-zA-Z0-9\-.,\s+]*\))?/,
        inside: {
          "standard-pattern-name": {
            pattern: /^[a-zA-Z0-9\-.]+/,
            alias: "builtin"
          },
          quantifier: {
            pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
            alias: "number"
          },
          "standard-pattern-attr": {
            pattern: /[a-zA-Z0-9\-.]+/,
            alias: "builtin"
          },
          punctuation: /[,()]/
        }
      },
      quantifier: {
        pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
        alias: "number"
      },
      operator: [
        {
          pattern: /=/,
          alias: "pattern-def"
        },
        {
          pattern: /&/,
          alias: "conjunction"
        },
        {
          pattern: /~/,
          alias: "exception"
        },
        {
          pattern: /\?/,
          alias: "optionality"
        },
        {
          pattern: /[[\]]/,
          alias: "repetition"
        },
        {
          pattern: /[{}]/,
          alias: "variation"
        },
        {
          pattern: /[+_]/,
          alias: "sequence"
        },
        {
          pattern: /\.{2,3}/,
          alias: "span"
        }
      ],
      "field-capture": [
        {
          pattern: /([a-zA-Z0-9\-.]+\s*\()\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+(?:\s*,\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+)*(?=\s*\))/,
          lookbehind: !0,
          inside: {
            "field-name": {
              pattern: /[a-zA-Z0-9\-.]+/,
              alias: "variable"
            },
            colon: /:/
          }
        },
        {
          pattern: /[a-zA-Z0-9\-.]+\s*:/,
          inside: {
            "field-name": {
              pattern: /[a-zA-Z0-9\-.]+/,
              alias: "variable"
            },
            colon: /:/
          }
        }
      ],
      punctuation: /[:;,()]/,
      name: /[a-zA-Z0-9\-.]+/
    };
  }
  return nevod_1;
}
var nginx_1, hasRequiredNginx;
function requireNginx() {
  if (hasRequiredNginx) return nginx_1;
  hasRequiredNginx = 1, nginx_1 = n, n.displayName = "nginx", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /\$(?:\w[a-z\d]*(?:_[^\x00-\x1F\s"'\\()$]*)?|\{[^}\s"'\\]+\})/i;
      g.languages.nginx = {
        comment: {
          pattern: /(^|[\s{};])#.*/,
          lookbehind: !0,
          greedy: !0
        },
        directive: {
          pattern: /(^|\s)\w(?:[^;{}"'\\\s]|\\.|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|\s+(?:#.*(?!.)|(?![#\s])))*?(?=\s*[;{])/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            string: {
              pattern: /((?:^|[^\\])(?:\\\\)*)(?:"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')/,
              lookbehind: !0,
              greedy: !0,
              inside: {
                escape: {
                  pattern: /\\["'\\nrt]/,
                  alias: "entity"
                },
                variable: d
              }
            },
            comment: {
              pattern: /(\s)#.*/,
              lookbehind: !0,
              greedy: !0
            },
            keyword: {
              pattern: /^\S+/,
              greedy: !0
            },
            // other patterns
            boolean: {
              pattern: /(\s)(?:off|on)(?!\S)/,
              lookbehind: !0
            },
            number: {
              pattern: /(\s)\d+[a-z]*(?!\S)/i,
              lookbehind: !0
            },
            variable: d
          }
        },
        punctuation: /[{};]/
      };
    })(t);
  }
  return nginx_1;
}
var nim_1, hasRequiredNim;
function requireNim() {
  if (hasRequiredNim) return nim_1;
  hasRequiredNim = 1, nim_1 = n, n.displayName = "nim", n.aliases = [];
  function n(t) {
    t.languages.nim = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        // Double-quoted strings can be prefixed by an identifier (Generalized raw string literals)
        pattern: /(?:\b(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+)?(?:"""[\s\S]*?"""(?!")|"(?:\\[\s\S]|""|[^"\\])*")/,
        greedy: !0
      },
      char: {
        // Character literals are handled specifically to prevent issues with numeric type suffixes
        pattern: /'(?:\\(?:\d+|x[\da-fA-F]{0,2}|.)|[^'])'/,
        greedy: !0
      },
      function: {
        pattern: /(?:(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+|`[^`\r\n]+`)\*?(?:\[[^\]]+\])?(?=\s*\()/,
        greedy: !0,
        inside: {
          operator: /\*$/
        }
      },
      // We don't want to highlight operators (and anything really) inside backticks
      identifier: {
        pattern: /`[^`\r\n]+`/,
        greedy: !0,
        inside: {
          punctuation: /`/
        }
      },
      // The negative look ahead prevents wrong highlighting of the .. operator
      number: /\b(?:0[xXoObB][\da-fA-F_]+|\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:[eE][+-]?\d[\d_]*)?)(?:'?[iuf]\d*)?/,
      keyword: /\b(?:addr|as|asm|atomic|bind|block|break|case|cast|concept|const|continue|converter|defer|discard|distinct|do|elif|else|end|enum|except|export|finally|for|from|func|generic|if|import|include|interface|iterator|let|macro|method|mixin|nil|object|out|proc|ptr|raise|ref|return|static|template|try|tuple|type|using|var|when|while|with|without|yield)\b/,
      operator: {
        // Look behind and look ahead prevent wrong highlighting of punctuations [. .] {. .} (. .)
        // but allow the slice operator .. to take precedence over them
        // One can define his own operators in Nim so all combination of operators might be an operator.
        pattern: /(^|[({\[](?=\.\.)|(?![({\[]\.).)(?:(?:[=+\-*\/<>@$~&%|!?^:\\]|\.\.|\.(?![)}\]]))+|\b(?:and|div|in|is|isnot|mod|not|notin|of|or|shl|shr|xor)\b)/m,
        lookbehind: !0
      },
      punctuation: /[({\[]\.|\.[)}\]]|[`(){}\[\],:]/
    };
  }
  return nim_1;
}
var nix_1, hasRequiredNix;
function requireNix() {
  if (hasRequiredNix) return nix_1;
  hasRequiredNix = 1, nix_1 = n, n.displayName = "nix", n.aliases = [];
  function n(t) {
    t.languages.nix = {
      comment: {
        pattern: /\/\*[\s\S]*?\*\/|#.*/,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"\\]|\\[\s\S])*"|''(?:(?!'')[\s\S]|''(?:'|\\|\$\{))*''/,
        greedy: !0,
        inside: {
          interpolation: {
            // The lookbehind ensures the ${} is not preceded by \ or ''
            pattern: /(^|(?:^|(?!'').)[^\\])\$\{(?:[^{}]|\{[^}]*\})*\}/,
            lookbehind: !0,
            inside: null
            // see below
          }
        }
      },
      url: [
        /\b(?:[a-z]{3,7}:\/\/)[\w\-+%~\/.:#=?&]+/,
        {
          pattern: /([^\/])(?:[\w\-+%~.:#=?&]*(?!\/\/)[\w\-+%~\/.:#=?&])?(?!\/\/)\/[\w\-+%~\/.:#=?&]*/,
          lookbehind: !0
        }
      ],
      antiquotation: {
        pattern: /\$(?=\{)/,
        alias: "important"
      },
      number: /\b\d+\b/,
      keyword: /\b(?:assert|builtins|else|if|in|inherit|let|null|or|then|with)\b/,
      function: /\b(?:abort|add|all|any|attrNames|attrValues|baseNameOf|compareVersions|concatLists|currentSystem|deepSeq|derivation|dirOf|div|elem(?:At)?|fetch(?:Tarball|url)|filter(?:Source)?|fromJSON|genList|getAttr|getEnv|hasAttr|hashString|head|import|intersectAttrs|is(?:Attrs|Bool|Function|Int|List|Null|String)|length|lessThan|listToAttrs|map|mul|parseDrvName|pathExists|read(?:Dir|File)|removeAttrs|replaceStrings|seq|sort|stringLength|sub(?:string)?|tail|throw|to(?:File|JSON|Path|String|XML)|trace|typeOf)\b|\bfoldl'\B/,
      boolean: /\b(?:false|true)\b/,
      operator: /[=!<>]=?|\+\+?|\|\||&&|\/\/|->?|[?@]/,
      punctuation: /[{}()[\].,:;]/
    }, t.languages.nix.string.inside.interpolation.inside = t.languages.nix;
  }
  return nix_1;
}
var nsis_1, hasRequiredNsis;
function requireNsis() {
  if (hasRequiredNsis) return nsis_1;
  hasRequiredNsis = 1, nsis_1 = n, n.displayName = "nsis", n.aliases = [];
  function n(t) {
    t.languages.nsis = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|[#;].*)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      keyword: {
        pattern: /(^[\t ]*)(?:Abort|Add(?:BrandingImage|Size)|AdvSplash|Allow(?:RootDirInstall|SkipFiles)|AutoCloseWindow|BG(?:Font|Gradient|Image)|Banner|BrandingText|BringToFront|CRCCheck|Call(?:InstDLL)?|Caption|ChangeUI|CheckBitmap|ClearErrors|CompletedText|ComponentText|CopyFiles|Create(?:Directory|Font|ShortCut)|Delete(?:INISec|INIStr|RegKey|RegValue)?|Detail(?:Print|sButtonText)|Dialer|Dir(?:Text|Var|Verify)|EnableWindow|Enum(?:RegKey|RegValue)|Exch|Exec(?:Shell(?:Wait)?|Wait)?|ExpandEnvStrings|File(?:BufSize|Close|ErrorText|Open|Read|ReadByte|ReadUTF16LE|ReadWord|Seek|Write|WriteByte|WriteUTF16LE|WriteWord)?|Find(?:Close|First|Next|Window)|FlushINI|Get(?:CurInstType|CurrentAddress|DLLVersion(?:Local)?|DlgItem|ErrorLevel|FileTime(?:Local)?|FullPathName|Function(?:Address|End)?|InstDirError|LabelAddress|TempFileName)|Goto|HideWindow|Icon|If(?:Abort|Errors|FileExists|RebootFlag|Silent)|InitPluginsDir|InstProgressFlags|Inst(?:Type(?:GetText|SetText)?)|Install(?:ButtonText|Colors|Dir(?:RegKey)?)|Int(?:64|Ptr)?CmpU?|Int(?:64)?Fmt|Int(?:Ptr)?Op|IsWindow|Lang(?:DLL|String)|License(?:BkColor|Data|ForceSelection|LangString|Text)|LoadLanguageFile|LockWindow|Log(?:Set|Text)|Manifest(?:DPIAware|SupportedOS)|Math|MessageBox|MiscButtonText|NSISdl|Name|Nop|OutFile|PE(?:DllCharacteristics|SubsysVer)|Page(?:Callbacks)?|Pop|Push|Quit|RMDir|Read(?:EnvStr|INIStr|RegDWORD|RegStr)|Reboot|RegDLL|Rename|RequestExecutionLevel|ReserveFile|Return|SearchPath|Section(?:End|GetFlags|GetInstTypes|GetSize|GetText|Group|In|SetFlags|SetInstTypes|SetSize|SetText)?|SendMessage|Set(?:AutoClose|BrandingImage|Compress|Compressor(?:DictSize)?|CtlColors|CurInstType|DatablockOptimize|DateSave|Details(?:Print|View)|ErrorLevel|Errors|FileAttributes|Font|OutPath|Overwrite|PluginUnload|RebootFlag|RegView|ShellVarContext|Silent)|Show(?:InstDetails|UninstDetails|Window)|Silent(?:Install|UnInstall)|Sleep|SpaceTexts|Splash|StartMenu|Str(?:CmpS?|Cpy|Len)|SubCaption|System|UnRegDLL|Unicode|UninstPage|Uninstall(?:ButtonText|Caption|Icon|SubCaption|Text)|UserInfo|VI(?:AddVersionKey|FileVersion|ProductVersion)|VPatch|Var|WindowIcon|Write(?:INIStr|Reg(?:Bin|DWORD|ExpandStr|MultiStr|None|Str)|Uninstaller)|XPStyle|ns(?:Dialogs|Exec))\b/m,
        lookbehind: !0
      },
      property: /\b(?:ARCHIVE|FILE_(?:ATTRIBUTE_ARCHIVE|ATTRIBUTE_NORMAL|ATTRIBUTE_OFFLINE|ATTRIBUTE_READONLY|ATTRIBUTE_SYSTEM|ATTRIBUTE_TEMPORARY)|HK(?:(?:CR|CU|LM)(?:32|64)?|DD|PD|U)|HKEY_(?:CLASSES_ROOT|CURRENT_CONFIG|CURRENT_USER|DYN_DATA|LOCAL_MACHINE|PERFORMANCE_DATA|USERS)|ID(?:ABORT|CANCEL|IGNORE|NO|OK|RETRY|YES)|MB_(?:ABORTRETRYIGNORE|DEFBUTTON1|DEFBUTTON2|DEFBUTTON3|DEFBUTTON4|ICONEXCLAMATION|ICONINFORMATION|ICONQUESTION|ICONSTOP|OK|OKCANCEL|RETRYCANCEL|RIGHT|RTLREADING|SETFOREGROUND|TOPMOST|USERICON|YESNO)|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY|admin|all|auto|both|colored|false|force|hide|highest|lastused|leave|listonly|none|normal|notset|off|on|open|print|show|silent|silentlog|smooth|textonly|true|user)\b/,
      constant: /\$\{[!\w\.:\^-]+\}|\$\([!\w\.:\^-]+\)/,
      variable: /\$\w[\w\.]*/,
      number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
      operator: /--?|\+\+?|<=?|>=?|==?=?|&&?|\|\|?|[?*\/~^%]/,
      punctuation: /[{}[\];(),.:]/,
      important: {
        pattern: /(^[\t ]*)!(?:addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|pragma|searchparse|searchreplace|system|tempfile|undef|verbose|warning)\b/im,
        lookbehind: !0
      }
    };
  }
  return nsis_1;
}
var objectivec_1, hasRequiredObjectivec;
function requireObjectivec() {
  if (hasRequiredObjectivec) return objectivec_1;
  hasRequiredObjectivec = 1;
  var n = requireC();
  objectivec_1 = t, t.displayName = "objectivec", t.aliases = ["objc"];
  function t(g) {
    g.register(n), g.languages.objectivec = g.languages.extend("c", {
      string: {
        pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: !0
      },
      keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
      operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
    }), delete g.languages.objectivec["class-name"], g.languages.objc = g.languages.objectivec;
  }
  return objectivec_1;
}
var ocaml_1, hasRequiredOcaml;
function requireOcaml() {
  if (hasRequiredOcaml) return ocaml_1;
  hasRequiredOcaml = 1, ocaml_1 = n, n.displayName = "ocaml", n.aliases = [];
  function n(t) {
    t.languages.ocaml = {
      comment: {
        pattern: /\(\*[\s\S]*?\*\)/,
        greedy: !0
      },
      char: {
        pattern: /'(?:[^\\\r\n']|\\(?:.|[ox]?[0-9a-f]{1,3}))'/i,
        greedy: !0
      },
      string: [
        {
          pattern: /"(?:\\(?:[\s\S]|\r\n)|[^\\\r\n"])*"/,
          greedy: !0
        },
        {
          pattern: /\{([a-z_]*)\|[\s\S]*?\|\1\}/,
          greedy: !0
        }
      ],
      number: [
        // binary and octal
        /\b(?:0b[01][01_]*|0o[0-7][0-7_]*)\b/i,
        // hexadecimal
        /\b0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]*)?(?:p[+-]?\d[\d_]*)?(?!\w)/i,
        // decimal
        /\b\d[\d_]*(?:\.[\d_]*)?(?:e[+-]?\d[\d_]*)?(?!\w)/i
      ],
      directive: {
        pattern: /\B#\w+/,
        alias: "property"
      },
      label: {
        pattern: /\B~\w+/,
        alias: "property"
      },
      "type-variable": {
        pattern: /\B'\w+/,
        alias: "function"
      },
      variant: {
        pattern: /`\w+/,
        alias: "symbol"
      },
      // For the list of keywords and operators,
      // see: http://caml.inria.fr/pub/docs/manual-ocaml/lex.html#sec84
      keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|nonrec|object|of|open|private|rec|sig|struct|then|to|try|type|val|value|virtual|when|where|while|with)\b/,
      boolean: /\b(?:false|true)\b/,
      "operator-like-punctuation": {
        pattern: /\[[<>|]|[>|]\]|\{<|>\}/,
        alias: "punctuation"
      },
      // Custom operators are allowed
      operator: /\.[.~]|:[=>]|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lsl|lsr|lxor|mod|or)\b/,
      punctuation: /;;|::|[(){}\[\].,:;#]|\b_\b/
    };
  }
  return ocaml_1;
}
var opencl_1, hasRequiredOpencl;
function requireOpencl() {
  if (hasRequiredOpencl) return opencl_1;
  hasRequiredOpencl = 1;
  var n = requireC();
  opencl_1 = t, t.displayName = "opencl", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      d.languages.opencl = d.languages.extend("c", {
        // Extracted from the official specs (2.0) and http://streamcomputing.eu/downloads/?opencl.lang (opencl-keywords, opencl-types) and http://sourceforge.net/tracker/?func=detail&aid=2957794&group_id=95717&atid=612384 (Words2, partly Words3)
        keyword: /\b(?:(?:__)?(?:constant|global|kernel|local|private|read_only|read_write|write_only)|__attribute__|auto|(?:bool|u?(?:char|int|long|short)|half|quad)(?:2|3|4|8|16)?|break|case|complex|const|continue|(?:double|float)(?:16(?:x(?:1|2|4|8|16))?|1x(?:1|2|4|8|16)|2(?:x(?:1|2|4|8|16))?|3|4(?:x(?:1|2|4|8|16))?|8(?:x(?:1|2|4|8|16))?)?|default|do|else|enum|extern|for|goto|if|imaginary|inline|packed|pipe|register|restrict|return|signed|sizeof|static|struct|switch|typedef|uniform|union|unsigned|void|volatile|while)\b/,
        // Extracted from http://streamcomputing.eu/downloads/?opencl.lang (opencl-const)
        // Math Constants: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/mathConstants.html
        // Macros and Limits: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/macroLimits.html
        number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[fuhl]{0,4}/i,
        boolean: /\b(?:false|true)\b/,
        "constant-opencl-kernel": {
          pattern: /\b(?:CHAR_(?:BIT|MAX|MIN)|CLK_(?:ADDRESS_(?:CLAMP(?:_TO_EDGE)?|NONE|REPEAT)|FILTER_(?:LINEAR|NEAREST)|(?:GLOBAL|LOCAL)_MEM_FENCE|NORMALIZED_COORDS_(?:FALSE|TRUE))|CL_(?:BGRA|(?:HALF_)?FLOAT|INTENSITY|LUMINANCE|A?R?G?B?[Ax]?|(?:(?:UN)?SIGNED|[US]NORM)_(?:INT(?:8|16|32))|UNORM_(?:INT_101010|SHORT_(?:555|565)))|(?:DBL|FLT|HALF)_(?:DIG|EPSILON|(?:MAX|MIN)(?:(?:_10)?_EXP)?|MANT_DIG)|FLT_RADIX|HUGE_VALF?|(?:INT|LONG|SCHAR|SHRT)_(?:MAX|MIN)|INFINITY|MAXFLOAT|M_(?:[12]_PI|2_SQRTPI|E|LN(?:2|10)|LOG(?:2|10)E?|PI(?:_[24])?|SQRT(?:1_2|2))(?:_F|_H)?|NAN|(?:UCHAR|UINT|ULONG|USHRT)_MAX)\b/,
          alias: "constant"
        }
      }), d.languages.insertBefore("opencl", "class-name", {
        // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/scalarDataTypes.html
        // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/otherDataTypes.html
        "builtin-type": {
          pattern: /\b(?:_cl_(?:command_queue|context|device_id|event|kernel|mem|platform_id|program|sampler)|cl_(?:image_format|mem_fence_flags)|clk_event_t|event_t|image(?:1d_(?:array_|buffer_)?t|2d_(?:array_(?:depth_|msaa_depth_|msaa_)?|depth_|msaa_depth_|msaa_)?t|3d_t)|intptr_t|ndrange_t|ptrdiff_t|queue_t|reserve_id_t|sampler_t|size_t|uintptr_t)\b/,
          alias: "keyword"
        }
      });
      var k = {
        // Extracted from http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-types and opencl-host)
        "type-opencl-host": {
          pattern: /\b(?:cl_(?:GLenum|GLint|GLuin|addressing_mode|bitfield|bool|buffer_create_type|build_status|channel_(?:order|type)|(?:u?(?:char|int|long|short)|double|float)(?:2|3|4|8|16)?|command_(?:queue(?:_info|_properties)?|type)|context(?:_info|_properties)?|device_(?:exec_capabilities|fp_config|id|info|local_mem_type|mem_cache_type|type)|(?:event|sampler)(?:_info)?|filter_mode|half|image_info|kernel(?:_info|_work_group_info)?|map_flags|mem(?:_flags|_info|_object_type)?|platform_(?:id|info)|profiling_info|program(?:_build_info|_info)?))\b/,
          alias: "keyword"
        },
        "boolean-opencl-host": {
          pattern: /\bCL_(?:FALSE|TRUE)\b/,
          alias: "boolean"
        },
        // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-const)
        "constant-opencl-host": {
          pattern: /\bCL_(?:A|ABGR|ADDRESS_(?:CLAMP(?:_TO_EDGE)?|MIRRORED_REPEAT|NONE|REPEAT)|ARGB|BGRA|BLOCKING|BUFFER_CREATE_TYPE_REGION|BUILD_(?:ERROR|IN_PROGRESS|NONE|PROGRAM_FAILURE|SUCCESS)|COMMAND_(?:ACQUIRE_GL_OBJECTS|BARRIER|COPY_(?:BUFFER(?:_RECT|_TO_IMAGE)?|IMAGE(?:_TO_BUFFER)?)|FILL_(?:BUFFER|IMAGE)|MAP(?:_BUFFER|_IMAGE)|MARKER|MIGRATE(?:_SVM)?_MEM_OBJECTS|NATIVE_KERNEL|NDRANGE_KERNEL|READ_(?:BUFFER(?:_RECT)?|IMAGE)|RELEASE_GL_OBJECTS|SVM_(?:FREE|MAP|MEMCPY|MEMFILL|UNMAP)|TASK|UNMAP_MEM_OBJECT|USER|WRITE_(?:BUFFER(?:_RECT)?|IMAGE))|COMPILER_NOT_AVAILABLE|COMPILE_PROGRAM_FAILURE|COMPLETE|CONTEXT_(?:DEVICES|INTEROP_USER_SYNC|NUM_DEVICES|PLATFORM|PROPERTIES|REFERENCE_COUNT)|DEPTH(?:_STENCIL)?|DEVICE_(?:ADDRESS_BITS|AFFINITY_DOMAIN_(?:L[1-4]_CACHE|NEXT_PARTITIONABLE|NUMA)|AVAILABLE|BUILT_IN_KERNELS|COMPILER_AVAILABLE|DOUBLE_FP_CONFIG|ENDIAN_LITTLE|ERROR_CORRECTION_SUPPORT|EXECUTION_CAPABILITIES|EXTENSIONS|GLOBAL_(?:MEM_(?:CACHELINE_SIZE|CACHE_SIZE|CACHE_TYPE|SIZE)|VARIABLE_PREFERRED_TOTAL_SIZE)|HOST_UNIFIED_MEMORY|IL_VERSION|IMAGE(?:2D_MAX_(?:HEIGHT|WIDTH)|3D_MAX_(?:DEPTH|HEIGHT|WIDTH)|_BASE_ADDRESS_ALIGNMENT|_MAX_ARRAY_SIZE|_MAX_BUFFER_SIZE|_PITCH_ALIGNMENT|_SUPPORT)|LINKER_AVAILABLE|LOCAL_MEM_SIZE|LOCAL_MEM_TYPE|MAX_(?:CLOCK_FREQUENCY|COMPUTE_UNITS|CONSTANT_ARGS|CONSTANT_BUFFER_SIZE|GLOBAL_VARIABLE_SIZE|MEM_ALLOC_SIZE|NUM_SUB_GROUPS|ON_DEVICE_(?:EVENTS|QUEUES)|PARAMETER_SIZE|PIPE_ARGS|READ_IMAGE_ARGS|READ_WRITE_IMAGE_ARGS|SAMPLERS|WORK_GROUP_SIZE|WORK_ITEM_DIMENSIONS|WORK_ITEM_SIZES|WRITE_IMAGE_ARGS)|MEM_BASE_ADDR_ALIGN|MIN_DATA_TYPE_ALIGN_SIZE|NAME|NATIVE_VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT)|NOT_(?:AVAILABLE|FOUND)|OPENCL_C_VERSION|PARENT_DEVICE|PARTITION_(?:AFFINITY_DOMAIN|BY_AFFINITY_DOMAIN|BY_COUNTS|BY_COUNTS_LIST_END|EQUALLY|FAILED|MAX_SUB_DEVICES|PROPERTIES|TYPE)|PIPE_MAX_(?:ACTIVE_RESERVATIONS|PACKET_SIZE)|PLATFORM|PREFERRED_(?:GLOBAL_ATOMIC_ALIGNMENT|INTEROP_USER_SYNC|LOCAL_ATOMIC_ALIGNMENT|PLATFORM_ATOMIC_ALIGNMENT|VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT))|PRINTF_BUFFER_SIZE|PROFILE|PROFILING_TIMER_RESOLUTION|QUEUE_(?:ON_(?:DEVICE_(?:MAX_SIZE|PREFERRED_SIZE|PROPERTIES)|HOST_PROPERTIES)|PROPERTIES)|REFERENCE_COUNT|SINGLE_FP_CONFIG|SUB_GROUP_INDEPENDENT_FORWARD_PROGRESS|SVM_(?:ATOMICS|CAPABILITIES|COARSE_GRAIN_BUFFER|FINE_GRAIN_BUFFER|FINE_GRAIN_SYSTEM)|TYPE(?:_ACCELERATOR|_ALL|_CPU|_CUSTOM|_DEFAULT|_GPU)?|VENDOR(?:_ID)?|VERSION)|DRIVER_VERSION|EVENT_(?:COMMAND_(?:EXECUTION_STATUS|QUEUE|TYPE)|CONTEXT|REFERENCE_COUNT)|EXEC_(?:KERNEL|NATIVE_KERNEL|STATUS_ERROR_FOR_EVENTS_IN_WAIT_LIST)|FILTER_(?:LINEAR|NEAREST)|FLOAT|FP_(?:CORRECTLY_ROUNDED_DIVIDE_SQRT|DENORM|FMA|INF_NAN|ROUND_TO_INF|ROUND_TO_NEAREST|ROUND_TO_ZERO|SOFT_FLOAT)|GLOBAL|HALF_FLOAT|IMAGE_(?:ARRAY_SIZE|BUFFER|DEPTH|ELEMENT_SIZE|FORMAT|FORMAT_MISMATCH|FORMAT_NOT_SUPPORTED|HEIGHT|NUM_MIP_LEVELS|NUM_SAMPLES|ROW_PITCH|SLICE_PITCH|WIDTH)|INTENSITY|INVALID_(?:ARG_INDEX|ARG_SIZE|ARG_VALUE|BINARY|BUFFER_SIZE|BUILD_OPTIONS|COMMAND_QUEUE|COMPILER_OPTIONS|CONTEXT|DEVICE|DEVICE_PARTITION_COUNT|DEVICE_QUEUE|DEVICE_TYPE|EVENT|EVENT_WAIT_LIST|GLOBAL_OFFSET|GLOBAL_WORK_SIZE|GL_OBJECT|HOST_PTR|IMAGE_DESCRIPTOR|IMAGE_FORMAT_DESCRIPTOR|IMAGE_SIZE|KERNEL|KERNEL_ARGS|KERNEL_DEFINITION|KERNEL_NAME|LINKER_OPTIONS|MEM_OBJECT|MIP_LEVEL|OPERATION|PIPE_SIZE|PLATFORM|PROGRAM|PROGRAM_EXECUTABLE|PROPERTY|QUEUE_PROPERTIES|SAMPLER|VALUE|WORK_DIMENSION|WORK_GROUP_SIZE|WORK_ITEM_SIZE)|KERNEL_(?:ARG_(?:ACCESS_(?:NONE|QUALIFIER|READ_ONLY|READ_WRITE|WRITE_ONLY)|ADDRESS_(?:CONSTANT|GLOBAL|LOCAL|PRIVATE|QUALIFIER)|INFO_NOT_AVAILABLE|NAME|TYPE_(?:CONST|NAME|NONE|PIPE|QUALIFIER|RESTRICT|VOLATILE))|ATTRIBUTES|COMPILE_NUM_SUB_GROUPS|COMPILE_WORK_GROUP_SIZE|CONTEXT|EXEC_INFO_SVM_FINE_GRAIN_SYSTEM|EXEC_INFO_SVM_PTRS|FUNCTION_NAME|GLOBAL_WORK_SIZE|LOCAL_MEM_SIZE|LOCAL_SIZE_FOR_SUB_GROUP_COUNT|MAX_NUM_SUB_GROUPS|MAX_SUB_GROUP_SIZE_FOR_NDRANGE|NUM_ARGS|PREFERRED_WORK_GROUP_SIZE_MULTIPLE|PRIVATE_MEM_SIZE|PROGRAM|REFERENCE_COUNT|SUB_GROUP_COUNT_FOR_NDRANGE|WORK_GROUP_SIZE)|LINKER_NOT_AVAILABLE|LINK_PROGRAM_FAILURE|LOCAL|LUMINANCE|MAP_(?:FAILURE|READ|WRITE|WRITE_INVALIDATE_REGION)|MEM_(?:ALLOC_HOST_PTR|ASSOCIATED_MEMOBJECT|CONTEXT|COPY_HOST_PTR|COPY_OVERLAP|FLAGS|HOST_NO_ACCESS|HOST_PTR|HOST_READ_ONLY|HOST_WRITE_ONLY|KERNEL_READ_AND_WRITE|MAP_COUNT|OBJECT_(?:ALLOCATION_FAILURE|BUFFER|IMAGE1D|IMAGE1D_ARRAY|IMAGE1D_BUFFER|IMAGE2D|IMAGE2D_ARRAY|IMAGE3D|PIPE)|OFFSET|READ_ONLY|READ_WRITE|REFERENCE_COUNT|SIZE|SVM_ATOMICS|SVM_FINE_GRAIN_BUFFER|TYPE|USES_SVM_POINTER|USE_HOST_PTR|WRITE_ONLY)|MIGRATE_MEM_OBJECT_(?:CONTENT_UNDEFINED|HOST)|MISALIGNED_SUB_BUFFER_OFFSET|NONE|NON_BLOCKING|OUT_OF_(?:HOST_MEMORY|RESOURCES)|PIPE_(?:MAX_PACKETS|PACKET_SIZE)|PLATFORM_(?:EXTENSIONS|HOST_TIMER_RESOLUTION|NAME|PROFILE|VENDOR|VERSION)|PROFILING_(?:COMMAND_(?:COMPLETE|END|QUEUED|START|SUBMIT)|INFO_NOT_AVAILABLE)|PROGRAM_(?:BINARIES|BINARY_SIZES|BINARY_TYPE(?:_COMPILED_OBJECT|_EXECUTABLE|_LIBRARY|_NONE)?|BUILD_(?:GLOBAL_VARIABLE_TOTAL_SIZE|LOG|OPTIONS|STATUS)|CONTEXT|DEVICES|IL|KERNEL_NAMES|NUM_DEVICES|NUM_KERNELS|REFERENCE_COUNT|SOURCE)|QUEUED|QUEUE_(?:CONTEXT|DEVICE|DEVICE_DEFAULT|ON_DEVICE|ON_DEVICE_DEFAULT|OUT_OF_ORDER_EXEC_MODE_ENABLE|PROFILING_ENABLE|PROPERTIES|REFERENCE_COUNT|SIZE)|R|RA|READ_(?:ONLY|WRITE)_CACHE|RG|RGB|RGBA|RGBx|RGx|RUNNING|Rx|SAMPLER_(?:ADDRESSING_MODE|CONTEXT|FILTER_MODE|LOD_MAX|LOD_MIN|MIP_FILTER_MODE|NORMALIZED_COORDS|REFERENCE_COUNT)|(?:UN)?SIGNED_INT(?:8|16|32)|SNORM_INT(?:8|16)|SUBMITTED|SUCCESS|UNORM_INT(?:8|16|24|_101010|_101010_2)|UNORM_SHORT_(?:555|565)|VERSION_(?:1_0|1_1|1_2|2_0|2_1)|sBGRA|sRGB|sRGBA|sRGBx)\b/,
          alias: "constant"
        },
        // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-host)
        "function-opencl-host": {
          pattern: /\bcl(?:BuildProgram|CloneKernel|CompileProgram|Create(?:Buffer|CommandQueue(?:WithProperties)?|Context|ContextFromType|Image|Image2D|Image3D|Kernel|KernelsInProgram|Pipe|ProgramWith(?:Binary|BuiltInKernels|IL|Source)|Sampler|SamplerWithProperties|SubBuffer|SubDevices|UserEvent)|Enqueue(?:(?:Barrier|Marker)(?:WithWaitList)?|Copy(?:Buffer(?:Rect|ToImage)?|Image(?:ToBuffer)?)|(?:Fill|Map)(?:Buffer|Image)|MigrateMemObjects|NDRangeKernel|NativeKernel|(?:Read|Write)(?:Buffer(?:Rect)?|Image)|SVM(?:Free|Map|MemFill|Memcpy|MigrateMem|Unmap)|Task|UnmapMemObject|WaitForEvents)|Finish|Flush|Get(?:CommandQueueInfo|ContextInfo|Device(?:AndHostTimer|IDs|Info)|Event(?:Profiling)?Info|ExtensionFunctionAddress(?:ForPlatform)?|HostTimer|ImageInfo|Kernel(?:ArgInfo|Info|SubGroupInfo|WorkGroupInfo)|MemObjectInfo|PipeInfo|Platform(?:IDs|Info)|Program(?:Build)?Info|SamplerInfo|SupportedImageFormats)|LinkProgram|(?:Release|Retain)(?:CommandQueue|Context|Device|Event|Kernel|MemObject|Program|Sampler)|SVM(?:Alloc|Free)|Set(?:CommandQueueProperty|DefaultDeviceCommandQueue|EventCallback|Kernel|Kernel(?:Arg(?:SVMPointer)?|ExecInfo)|MemObjectDestructorCallback|UserEventStatus)|Unload(?:Platform)?Compiler|WaitForEvents)\b/,
          alias: "function"
        }
      };
      d.languages.insertBefore("c", "keyword", k), d.languages.cpp && (k["type-opencl-host-cpp"] = {
        pattern: /\b(?:Buffer|BufferGL|BufferRenderGL|CommandQueue|Context|Device|DeviceCommandQueue|EnqueueArgs|Event|Image|Image1D|Image1DArray|Image1DBuffer|Image2D|Image2DArray|Image2DGL|Image3D|Image3DGL|ImageFormat|ImageGL|Kernel|KernelFunctor|LocalSpaceArg|Memory|NDRange|Pipe|Platform|Program|SVMAllocator|SVMTraitAtomic|SVMTraitCoarse|SVMTraitFine|SVMTraitReadOnly|SVMTraitReadWrite|SVMTraitWriteOnly|Sampler|UserEvent)\b/,
        alias: "keyword"
      }, d.languages.insertBefore("cpp", "keyword", k));
    })(g);
  }
  return opencl_1;
}
var openqasm_1, hasRequiredOpenqasm;
function requireOpenqasm() {
  if (hasRequiredOpenqasm) return openqasm_1;
  hasRequiredOpenqasm = 1, openqasm_1 = n, n.displayName = "openqasm", n.aliases = ["qasm"];
  function n(t) {
    t.languages.openqasm = {
      comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
      string: {
        pattern: /"[^"\r\n\t]*"|'[^'\r\n\t]*'/,
        greedy: !0
      },
      keyword: /\b(?:CX|OPENQASM|U|barrier|boxas|boxto|break|const|continue|ctrl|def|defcal|defcalgrammar|delay|else|end|for|gate|gphase|if|in|include|inv|kernel|lengthof|let|measure|pow|reset|return|rotary|stretchinf|while)\b|#pragma\b/,
      "class-name": /\b(?:angle|bit|bool|creg|fixed|float|int|length|qreg|qubit|stretch|uint)\b/,
      function: /\b(?:cos|exp|ln|popcount|rotl|rotr|sin|sqrt|tan)\b(?=\s*\()/,
      constant: /\b(?:euler|pi|tau)\b|π|𝜏|ℇ/,
      number: {
        pattern: /(^|[^.\w$])(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?(?:dt|ns|us|µs|ms|s)?/i,
        lookbehind: !0
      },
      operator: /->|>>=?|<<=?|&&|\|\||\+\+|--|[!=<>&|~^+\-*/%]=?|@/,
      punctuation: /[(){}\[\];,:.]/
    }, t.languages.qasm = t.languages.openqasm;
  }
  return openqasm_1;
}
var oz_1, hasRequiredOz;
function requireOz() {
  if (hasRequiredOz) return oz_1;
  hasRequiredOz = 1, oz_1 = n, n.displayName = "oz", n.aliases = [];
  function n(t) {
    t.languages.oz = {
      comment: {
        pattern: /\/\*[\s\S]*?\*\/|%.*/,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"\\]|\\[\s\S])*"/,
        greedy: !0
      },
      atom: {
        pattern: /'(?:[^'\\]|\\[\s\S])*'/,
        greedy: !0,
        alias: "builtin"
      },
      keyword: /\$|\[\]|\b(?:_|at|attr|case|catch|choice|class|cond|declare|define|dis|else(?:case|if)?|end|export|fail|false|feat|finally|from|fun|functor|if|import|in|local|lock|meth|nil|not|of|or|prepare|proc|prop|raise|require|self|skip|then|thread|true|try|unit)\b/,
      function: [
        /\b[a-z][A-Za-z\d]*(?=\()/,
        {
          pattern: /(\{)[A-Z][A-Za-z\d]*\b/,
          lookbehind: !0
        }
      ],
      number: /\b(?:0[bx][\da-f]+|\d+(?:\.\d*)?(?:e~?\d+)?)\b|&(?:[^\\]|\\(?:\d{3}|.))/i,
      variable: /`(?:[^`\\]|\\.)+`/,
      "attr-name": /\b\w+(?=[ \t]*:(?![:=]))/,
      operator: /:(?:=|::?)|<[-:=]?|=(?:=|<?:?)|>=?:?|\\=:?|!!?|[|#+\-*\/,~^@]|\b(?:andthen|div|mod|orelse)\b/,
      punctuation: /[\[\](){}.:;?]/
    };
  }
  return oz_1;
}
var parigp_1, hasRequiredParigp;
function requireParigp() {
  if (hasRequiredParigp) return parigp_1;
  hasRequiredParigp = 1, parigp_1 = n, n.displayName = "parigp", n.aliases = [];
  function n(t) {
    t.languages.parigp = {
      comment: /\/\*[\s\S]*?\*\/|\\\\.*/,
      string: {
        pattern: /"(?:[^"\\\r\n]|\\.)*"/,
        greedy: !0
      },
      // PARI/GP does not care about white spaces at all
      // so let's process the keywords to build an appropriate regexp
      // (e.g. "b *r *e *a *k", etc.)
      keyword: (function() {
        var g = [
          "breakpoint",
          "break",
          "dbg_down",
          "dbg_err",
          "dbg_up",
          "dbg_x",
          "forcomposite",
          "fordiv",
          "forell",
          "forpart",
          "forprime",
          "forstep",
          "forsubgroup",
          "forvec",
          "for",
          "iferr",
          "if",
          "local",
          "my",
          "next",
          "return",
          "until",
          "while"
        ];
        return g = g.map(function(d) {
          return d.split("").join(" *");
        }).join("|"), RegExp("\\b(?:" + g + ")\\b");
      })(),
      function: /\b\w(?:[\w ]*\w)?(?= *\()/,
      number: {
        // The lookbehind and the negative lookahead prevent from breaking the .. operator
        pattern: /((?:\. *\. *)?)(?:\b\d(?: *\d)*(?: *(?!\. *\.)\.(?: *\d)*)?|\. *\d(?: *\d)*)(?: *e *(?:[+-] *)?\d(?: *\d)*)?/i,
        lookbehind: !0
      },
      operator: /\. *\.|[*\/!](?: *=)?|%(?: *=|(?: *#)?(?: *')*)?|\+(?: *[+=])?|-(?: *[-=>])?|<(?: *>|(?: *<)?(?: *=)?)?|>(?: *>)?(?: *=)?|=(?: *=){0,2}|\\(?: *\/)?(?: *=)?|&(?: *&)?|\| *\||['#~^]/,
      punctuation: /[\[\]{}().,:;|]/
    };
  }
  return parigp_1;
}
var parser_1, hasRequiredParser;
function requireParser() {
  if (hasRequiredParser) return parser_1;
  hasRequiredParser = 1, parser_1 = n, n.displayName = "parser", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = g.languages.parser = g.languages.extend("markup", {
        keyword: {
          pattern: /(^|[^^])(?:\^(?:case|eval|for|if|switch|throw)\b|@(?:BASE|CLASS|GET(?:_DEFAULT)?|OPTIONS|SET_DEFAULT|USE)\b)/,
          lookbehind: !0
        },
        variable: {
          pattern: /(^|[^^])\B\$(?:\w+|(?=[.{]))(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
          lookbehind: !0,
          inside: {
            punctuation: /\.|:+/
          }
        },
        function: {
          pattern: /(^|[^^])\B[@^]\w+(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
          lookbehind: !0,
          inside: {
            keyword: {
              pattern: /(^@)(?:GET_|SET_)/,
              lookbehind: !0
            },
            punctuation: /\.|:+/
          }
        },
        escape: {
          pattern: /\^(?:[$^;@()\[\]{}"':]|#[a-f\d]*)/i,
          alias: "builtin"
        },
        punctuation: /[\[\](){};]/
      });
      d = g.languages.insertBefore("parser", "keyword", {
        "parser-comment": {
          pattern: /(\s)#.*/,
          lookbehind: !0,
          alias: "comment"
        },
        expression: {
          // Allow for 3 levels of depth
          pattern: /(^|[^^])\((?:[^()]|\((?:[^()]|\((?:[^()])*\))*\))*\)/,
          greedy: !0,
          lookbehind: !0,
          inside: {
            string: {
              pattern: /(^|[^^])(["'])(?:(?!\2)[^^]|\^[\s\S])*\2/,
              lookbehind: !0
            },
            keyword: d.keyword,
            variable: d.variable,
            function: d.function,
            boolean: /\b(?:false|true)\b/,
            number: /\b(?:0x[a-f\d]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?)\b/i,
            escape: d.escape,
            operator: /[~+*\/\\%]|!(?:\|\|?|=)?|&&?|\|\|?|==|<[<=]?|>[>=]?|-[fd]?|\b(?:def|eq|ge|gt|in|is|le|lt|ne)\b/,
            punctuation: d.punctuation
          }
        }
      }), g.languages.insertBefore(
        "inside",
        "punctuation",
        {
          expression: d.expression,
          keyword: d.keyword,
          variable: d.variable,
          function: d.function,
          escape: d.escape,
          "parser-punctuation": {
            pattern: d.punctuation,
            alias: "punctuation"
          }
        },
        d.tag.inside["attr-value"]
      );
    })(t);
  }
  return parser_1;
}
var pascal_1, hasRequiredPascal;
function requirePascal() {
  if (hasRequiredPascal) return pascal_1;
  hasRequiredPascal = 1, pascal_1 = n, n.displayName = "pascal", n.aliases = ["objectpascal"];
  function n(t) {
    t.languages.pascal = {
      directive: {
        pattern: /\{\$[\s\S]*?\}/,
        greedy: !0,
        alias: ["marco", "property"]
      },
      comment: {
        pattern: /\(\*[\s\S]*?\*\)|\{[\s\S]*?\}|\/\/.*/,
        greedy: !0
      },
      string: {
        pattern: /(?:'(?:''|[^'\r\n])*'(?!')|#[&$%]?[a-f\d]+)+|\^[a-z]/i,
        greedy: !0
      },
      asm: {
        pattern: /(\basm\b)[\s\S]+?(?=\bend\s*[;[])/i,
        lookbehind: !0,
        greedy: !0,
        inside: null
        // see below
      },
      keyword: [
        {
          // Turbo Pascal
          pattern: /(^|[^&])\b(?:absolute|array|asm|begin|case|const|constructor|destructor|do|downto|else|end|file|for|function|goto|if|implementation|inherited|inline|interface|label|nil|object|of|operator|packed|procedure|program|record|reintroduce|repeat|self|set|string|then|to|type|unit|until|uses|var|while|with)\b/i,
          lookbehind: !0
        },
        {
          // Free Pascal
          pattern: /(^|[^&])\b(?:dispose|exit|false|new|true)\b/i,
          lookbehind: !0
        },
        {
          // Object Pascal
          pattern: /(^|[^&])\b(?:class|dispinterface|except|exports|finalization|finally|initialization|inline|library|on|out|packed|property|raise|resourcestring|threadvar|try)\b/i,
          lookbehind: !0
        },
        {
          // Modifiers
          pattern: /(^|[^&])\b(?:absolute|abstract|alias|assembler|bitpacked|break|cdecl|continue|cppdecl|cvar|default|deprecated|dynamic|enumerator|experimental|export|external|far|far16|forward|generic|helper|implements|index|interrupt|iochecks|local|message|name|near|nodefault|noreturn|nostackframe|oldfpccall|otherwise|overload|override|pascal|platform|private|protected|public|published|read|register|reintroduce|result|safecall|saveregisters|softfloat|specialize|static|stdcall|stored|strict|unaligned|unimplemented|varargs|virtual|write)\b/i,
          lookbehind: !0
        }
      ],
      number: [
        // Hexadecimal, octal and binary
        /(?:[&%]\d+|\$[a-f\d]+)/i,
        // Decimal
        /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?/i
      ],
      operator: [
        /\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=]/,
        {
          pattern: /(^|[^&])\b(?:and|as|div|exclude|in|include|is|mod|not|or|shl|shr|xor)\b/,
          lookbehind: !0
        }
      ],
      punctuation: /\(\.|\.\)|[()\[\]:;,.]/
    }, t.languages.pascal.asm.inside = t.languages.extend("pascal", {
      asm: void 0,
      keyword: void 0,
      operator: void 0
    }), t.languages.objectpascal = t.languages.pascal;
  }
  return pascal_1;
}
var pascaligo_1, hasRequiredPascaligo;
function requirePascaligo() {
  if (hasRequiredPascaligo) return pascaligo_1;
  hasRequiredPascaligo = 1, pascaligo_1 = n, n.displayName = "pascaligo", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\)/.source, k = /(?:\b\w+(?:<braces>)?|<braces>)/.source.replace(
        /<braces>/g,
        function() {
          return d;
        }
      ), H = g.languages.pascaligo = {
        comment: /\(\*[\s\S]+?\*\)|\/\/.*/,
        string: {
          pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1|\^[a-z]/i,
          greedy: !0
        },
        "class-name": [
          {
            pattern: RegExp(
              /(\btype\s+\w+\s+is\s+)<type>/.source.replace(
                /<type>/g,
                function() {
                  return k;
                }
              ),
              "i"
            ),
            lookbehind: !0,
            inside: null
            // see below
          },
          {
            pattern: RegExp(
              /<type>(?=\s+is\b)/.source.replace(/<type>/g, function() {
                return k;
              }),
              "i"
            ),
            inside: null
            // see below
          },
          {
            pattern: RegExp(
              /(:\s*)<type>/.source.replace(/<type>/g, function() {
                return k;
              })
            ),
            lookbehind: !0,
            inside: null
            // see below
          }
        ],
        keyword: {
          pattern: /(^|[^&])\b(?:begin|block|case|const|else|end|fail|for|from|function|if|is|nil|of|remove|return|skip|then|type|var|while|with)\b/i,
          lookbehind: !0
        },
        boolean: {
          pattern: /(^|[^&])\b(?:False|True)\b/i,
          lookbehind: !0
        },
        builtin: {
          pattern: /(^|[^&])\b(?:bool|int|list|map|nat|record|string|unit)\b/i,
          lookbehind: !0
        },
        function: /\b\w+(?=\s*\()/,
        number: [
          // Hexadecimal, octal and binary
          /%[01]+|&[0-7]+|\$[a-f\d]+/i,
          // Decimal
          /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?(?:mtz|n)?/i
        ],
        operator: /->|=\/=|\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=|]|\b(?:and|mod|or)\b/,
        punctuation: /\(\.|\.\)|[()\[\]:;,.{}]/
      }, AA = [
        "comment",
        "keyword",
        "builtin",
        "operator",
        "punctuation"
      ].reduce(function(gA, IA) {
        return gA[IA] = H[IA], gA;
      }, {});
      H["class-name"].forEach(function(gA) {
        gA.inside = AA;
      });
    })(t);
  }
  return pascaligo_1;
}
var pcaxis_1, hasRequiredPcaxis;
function requirePcaxis() {
  if (hasRequiredPcaxis) return pcaxis_1;
  hasRequiredPcaxis = 1, pcaxis_1 = n, n.displayName = "pcaxis", n.aliases = ["px"];
  function n(t) {
    t.languages.pcaxis = {
      string: /"[^"]*"/,
      keyword: {
        pattern: /((?:^|;)\s*)[-A-Z\d]+(?:\s*\[[-\w]+\])?(?:\s*\("[^"]*"(?:,\s*"[^"]*")*\))?(?=\s*=)/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          keyword: /^[-A-Z\d]+/,
          language: {
            pattern: /^(\s*)\[[-\w]+\]/,
            lookbehind: !0,
            inside: {
              punctuation: /^\[|\]$/,
              property: /[-\w]+/
            }
          },
          "sub-key": {
            pattern: /^(\s*)\S[\s\S]*/,
            lookbehind: !0,
            inside: {
              parameter: {
                pattern: /"[^"]*"/,
                alias: "property"
              },
              punctuation: /^\(|\)$|,/
            }
          }
        }
      },
      operator: /=/,
      tlist: {
        pattern: /TLIST\s*\(\s*\w+(?:(?:\s*,\s*"[^"]*")+|\s*,\s*"[^"]*"-"[^"]*")?\s*\)/,
        greedy: !0,
        inside: {
          function: /^TLIST/,
          property: {
            pattern: /^(\s*\(\s*)\w+/,
            lookbehind: !0
          },
          string: /"[^"]*"/,
          punctuation: /[(),]/,
          operator: /-/
        }
      },
      punctuation: /[;,]/,
      number: {
        pattern: /(^|\s)\d+(?:\.\d+)?(?!\S)/,
        lookbehind: !0
      },
      boolean: /NO|YES/
    }, t.languages.px = t.languages.pcaxis;
  }
  return pcaxis_1;
}
var peoplecode_1, hasRequiredPeoplecode;
function requirePeoplecode() {
  if (hasRequiredPeoplecode) return peoplecode_1;
  hasRequiredPeoplecode = 1, peoplecode_1 = n, n.displayName = "peoplecode", n.aliases = ["pcode"];
  function n(t) {
    t.languages.peoplecode = {
      comment: RegExp(
        [
          // C-style multiline comments
          /\/\*[\s\S]*?\*\//.source,
          // REM comments
          /\bREM[^;]*;/.source,
          // Nested <* *> comments
          /<\*(?:[^<*]|\*(?!>)|<(?!\*)|<\*(?:(?!\*>)[\s\S])*\*>)*\*>/.source,
          // /+ +/ comments
          /\/\+[\s\S]*?\+\//.source
        ].join("|")
      ),
      string: {
        pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
        greedy: !0
      },
      variable: /%\w+/,
      "function-definition": {
        pattern: /((?:^|[^\w-])(?:function|method)\s+)\w+/i,
        lookbehind: !0,
        alias: "function"
      },
      "class-name": {
        pattern: /((?:^|[^-\w])(?:as|catch|class|component|create|extends|global|implements|instance|local|of|property|returns)\s+)\w+(?::\w+)*/i,
        lookbehind: !0,
        inside: {
          punctuation: /:/
        }
      },
      keyword: /\b(?:abstract|alias|as|catch|class|component|constant|create|declare|else|end-(?:class|evaluate|for|function|get|if|method|set|try|while)|evaluate|extends|for|function|get|global|if|implements|import|instance|library|local|method|null|of|out|peopleCode|private|program|property|protected|readonly|ref|repeat|returns?|set|step|then|throw|to|try|until|value|when(?:-other)?|while)\b/i,
      "operator-keyword": {
        pattern: /\b(?:and|not|or)\b/i,
        alias: "operator"
      },
      function: /[_a-z]\w*(?=\s*\()/i,
      boolean: /\b(?:false|true)\b/i,
      number: /\b\d+(?:\.\d+)?\b/,
      operator: /<>|[<>]=?|!=|\*\*|[-+*/|=@]/,
      punctuation: /[:.;,()[\]]/
    }, t.languages.pcode = t.languages.peoplecode;
  }
  return peoplecode_1;
}
var perl_1, hasRequiredPerl;
function requirePerl() {
  if (hasRequiredPerl) return perl_1;
  hasRequiredPerl = 1, perl_1 = n, n.displayName = "perl", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /(?:\((?:[^()\\]|\\[\s\S])*\)|\{(?:[^{}\\]|\\[\s\S])*\}|\[(?:[^[\]\\]|\\[\s\S])*\]|<(?:[^<>\\]|\\[\s\S])*>)/.source;
      g.languages.perl = {
        comment: [
          {
            // POD
            pattern: /(^\s*)=\w[\s\S]*?=cut.*/m,
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: /(^|[^\\$])#.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        // TODO Could be nice to handle Heredoc too.
        string: [
          {
            pattern: RegExp(
              /\b(?:q|qq|qw|qx)(?![a-zA-Z0-9])\s*/.source + "(?:" + [
                // q/.../
                /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                // q a...a
                // eslint-disable-next-line regexp/strict
                /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                // q(...)
                // q{...}
                // q[...]
                // q<...>
                d
              ].join("|") + ")"
            ),
            greedy: !0
          },
          // "...", `...`
          {
            pattern: /("|`)(?:(?!\1)[^\\]|\\[\s\S])*\1/,
            greedy: !0
          },
          // '...'
          // FIXME Multi-line single-quoted strings are not supported as they would break variables containing '
          {
            pattern: /'(?:[^'\\\r\n]|\\.)*'/,
            greedy: !0
          }
        ],
        regex: [
          {
            pattern: RegExp(
              /\b(?:m|qr)(?![a-zA-Z0-9])\s*/.source + "(?:" + [
                // m/.../
                /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                // m a...a
                // eslint-disable-next-line regexp/strict
                /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                // m(...)
                // m{...}
                // m[...]
                // m<...>
                d
              ].join("|") + ")" + /[msixpodualngc]*/.source
            ),
            greedy: !0
          },
          // The lookbehinds prevent -s from breaking
          {
            pattern: RegExp(
              /(^|[^-])\b(?:s|tr|y)(?![a-zA-Z0-9])\s*/.source + "(?:" + [
                // s/.../.../
                // eslint-disable-next-line regexp/strict
                /([^a-zA-Z0-9\s{(\[<])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                // s a...a...a
                // eslint-disable-next-line regexp/strict
                /([a-zA-Z0-9])(?:(?!\3)[^\\]|\\[\s\S])*\3(?:(?!\3)[^\\]|\\[\s\S])*\3/.source,
                // s(...)(...)
                // s{...}{...}
                // s[...][...]
                // s<...><...>
                // s(...)[...]
                d + /\s*/.source + d
              ].join("|") + ")" + /[msixpodualngcer]*/.source
            ),
            lookbehind: !0,
            greedy: !0
          },
          // /.../
          // The look-ahead tries to prevent two divisions on
          // the same line from being highlighted as regex.
          // This does not support multi-line regex.
          {
            pattern: /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|x|xor)\b))/,
            greedy: !0
          }
        ],
        // FIXME Not sure about the handling of ::, ', and #
        variable: [
          // ${^POSTMATCH}
          /[&*$@%]\{\^[A-Z]+\}/,
          // $^V
          /[&*$@%]\^[A-Z_]/,
          // ${...}
          /[&*$@%]#?(?=\{)/,
          // $foo
          /[&*$@%]#?(?:(?:::)*'?(?!\d)[\w$]+(?![\w$]))+(?:::)*/,
          // $1
          /[&*$@%]\d+/,
          // $_, @_, %!
          // The negative lookahead prevents from breaking the %= operator
          /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/
        ],
        filehandle: {
          // <>, <FOO>, _
          pattern: /<(?![<=])\S*?>|\b_\b/,
          alias: "symbol"
        },
        "v-string": {
          // v1.2, 1.2.3
          pattern: /v\d+(?:\.\d+)*|\d+(?:\.\d+){2,}/,
          alias: "string"
        },
        function: {
          pattern: /(\bsub[ \t]+)\w+/,
          lookbehind: !0
        },
        keyword: /\b(?:any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|return|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
        number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)\b/,
        operator: /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|xor)\b/,
        punctuation: /[{}[\];(),:]/
      };
    })(t);
  }
  return perl_1;
}
var phpExtras_1, hasRequiredPhpExtras;
function requirePhpExtras() {
  if (hasRequiredPhpExtras) return phpExtras_1;
  hasRequiredPhpExtras = 1;
  var n = requirePhp();
  phpExtras_1 = t, t.displayName = "phpExtras", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.insertBefore("php", "variable", {
      this: {
        pattern: /\$this\b/,
        alias: "keyword"
      },
      global: /\$(?:GLOBALS|HTTP_RAW_POST_DATA|_(?:COOKIE|ENV|FILES|GET|POST|REQUEST|SERVER|SESSION)|argc|argv|http_response_header|php_errormsg)\b/,
      scope: {
        pattern: /\b[\w\\]+::/,
        inside: {
          keyword: /\b(?:parent|self|static)\b/,
          punctuation: /::|\\/
        }
      }
    });
  }
  return phpExtras_1;
}
var phpdoc_1, hasRequiredPhpdoc;
function requirePhpdoc() {
  if (hasRequiredPhpdoc) return phpdoc_1;
  hasRequiredPhpdoc = 1;
  var n = requirePhp(), t = requireJavadoclike();
  phpdoc_1 = g, g.displayName = "phpdoc", g.aliases = [];
  function g(d) {
    d.register(n), d.register(t), (function(k) {
      var H = /(?:\b[a-zA-Z]\w*|[|\\[\]])+/.source;
      k.languages.phpdoc = k.languages.extend("javadoclike", {
        parameter: {
          pattern: RegExp(
            "(@(?:global|param|property(?:-read|-write)?|var)\\s+(?:" + H + "\\s+)?)\\$\\w+"
          ),
          lookbehind: !0
        }
      }), k.languages.insertBefore("phpdoc", "keyword", {
        "class-name": [
          {
            pattern: RegExp(
              "(@(?:global|package|param|property(?:-read|-write)?|return|subpackage|throws|var)\\s+)" + H
            ),
            lookbehind: !0,
            inside: {
              keyword: /\b(?:array|bool|boolean|callback|double|false|float|int|integer|mixed|null|object|resource|self|string|true|void)\b/,
              punctuation: /[|\\[\]()]/
            }
          }
        ]
      }), k.languages.javadoclike.addSupport("php", k.languages.phpdoc);
    })(d);
  }
  return phpdoc_1;
}
var plsql_1, hasRequiredPlsql;
function requirePlsql() {
  if (hasRequiredPlsql) return plsql_1;
  hasRequiredPlsql = 1;
  var n = requireSql();
  plsql_1 = t, t.displayName = "plsql", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.plsql = g.languages.extend("sql", {
      comment: {
        pattern: /\/\*[\s\S]*?\*\/|--.*/,
        greedy: !0
      },
      // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-reserved-words-keywords.html
      keyword: /\b(?:A|ACCESSIBLE|ADD|AGENT|AGGREGATE|ALL|ALTER|AND|ANY|ARRAY|AS|ASC|AT|ATTRIBUTE|AUTHID|AVG|BEGIN|BETWEEN|BFILE_BASE|BINARY|BLOB_BASE|BLOCK|BODY|BOTH|BOUND|BULK|BY|BYTE|C|CALL|CALLING|CASCADE|CASE|CHAR|CHARACTER|CHARSET|CHARSETFORM|CHARSETID|CHAR_BASE|CHECK|CLOB_BASE|CLONE|CLOSE|CLUSTER|CLUSTERS|COLAUTH|COLLECT|COLUMNS|COMMENT|COMMIT|COMMITTED|COMPILED|COMPRESS|CONNECT|CONSTANT|CONSTRUCTOR|CONTEXT|CONTINUE|CONVERT|COUNT|CRASH|CREATE|CREDENTIAL|CURRENT|CURSOR|CUSTOMDATUM|DANGLING|DATA|DATE|DATE_BASE|DAY|DECLARE|DEFAULT|DEFINE|DELETE|DESC|DETERMINISTIC|DIRECTORY|DISTINCT|DOUBLE|DROP|DURATION|ELEMENT|ELSE|ELSIF|EMPTY|END|ESCAPE|EXCEPT|EXCEPTION|EXCEPTIONS|EXCLUSIVE|EXECUTE|EXISTS|EXIT|EXTERNAL|FETCH|FINAL|FIRST|FIXED|FLOAT|FOR|FORALL|FORCE|FROM|FUNCTION|GENERAL|GOTO|GRANT|GROUP|HASH|HAVING|HEAP|HIDDEN|HOUR|IDENTIFIED|IF|IMMEDIATE|IMMUTABLE|IN|INCLUDING|INDEX|INDEXES|INDICATOR|INDICES|INFINITE|INSERT|INSTANTIABLE|INT|INTERFACE|INTERSECT|INTERVAL|INTO|INVALIDATE|IS|ISOLATION|JAVA|LANGUAGE|LARGE|LEADING|LENGTH|LEVEL|LIBRARY|LIKE|LIKE2|LIKE4|LIKEC|LIMIT|LIMITED|LOCAL|LOCK|LONG|LOOP|MAP|MAX|MAXLEN|MEMBER|MERGE|MIN|MINUS|MINUTE|MOD|MODE|MODIFY|MONTH|MULTISET|MUTABLE|NAME|NAN|NATIONAL|NATIVE|NCHAR|NEW|NOCOMPRESS|NOCOPY|NOT|NOWAIT|NULL|NUMBER_BASE|OBJECT|OCICOLL|OCIDATE|OCIDATETIME|OCIDURATION|OCIINTERVAL|OCILOBLOCATOR|OCINUMBER|OCIRAW|OCIREF|OCIREFCURSOR|OCIROWID|OCISTRING|OCITYPE|OF|OLD|ON|ONLY|OPAQUE|OPEN|OPERATOR|OPTION|OR|ORACLE|ORADATA|ORDER|ORGANIZATION|ORLANY|ORLVARY|OTHERS|OUT|OVERLAPS|OVERRIDING|PACKAGE|PARALLEL_ENABLE|PARAMETER|PARAMETERS|PARENT|PARTITION|PASCAL|PERSISTABLE|PIPE|PIPELINED|PLUGGABLE|POLYMORPHIC|PRAGMA|PRECISION|PRIOR|PRIVATE|PROCEDURE|PUBLIC|RAISE|RANGE|RAW|READ|RECORD|REF|REFERENCE|RELIES_ON|REM|REMAINDER|RENAME|RESOURCE|RESULT|RESULT_CACHE|RETURN|RETURNING|REVERSE|REVOKE|ROLLBACK|ROW|SAMPLE|SAVE|SAVEPOINT|SB1|SB2|SB4|SECOND|SEGMENT|SELECT|SELF|SEPARATE|SEQUENCE|SERIALIZABLE|SET|SHARE|SHORT|SIZE|SIZE_T|SOME|SPARSE|SQL|SQLCODE|SQLDATA|SQLNAME|SQLSTATE|STANDARD|START|STATIC|STDDEV|STORED|STRING|STRUCT|STYLE|SUBMULTISET|SUBPARTITION|SUBSTITUTABLE|SUBTYPE|SUM|SYNONYM|TABAUTH|TABLE|TDO|THE|THEN|TIME|TIMESTAMP|TIMEZONE_ABBR|TIMEZONE_HOUR|TIMEZONE_MINUTE|TIMEZONE_REGION|TO|TRAILING|TRANSACTION|TRANSACTIONAL|TRUSTED|TYPE|UB1|UB2|UB4|UNDER|UNION|UNIQUE|UNPLUG|UNSIGNED|UNTRUSTED|UPDATE|USE|USING|VALIST|VALUE|VALUES|VARIABLE|VARIANCE|VARRAY|VARYING|VIEW|VIEWS|VOID|WHEN|WHERE|WHILE|WITH|WORK|WRAPPED|WRITE|YEAR|ZONE)\b/i,
      // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-language-fundamentals.html#GUID-96A42F7C-7A71-4B90-8255-CA9C8BD9722E
      operator: /:=?|=>|[<>^~!]=|\.\.|\|\||\*\*|[-+*/%<>=@]/
    }), g.languages.insertBefore("plsql", "operator", {
      label: {
        pattern: /<<\s*\w+\s*>>/,
        alias: "symbol"
      }
    });
  }
  return plsql_1;
}
var powerquery_1, hasRequiredPowerquery;
function requirePowerquery() {
  if (hasRequiredPowerquery) return powerquery_1;
  hasRequiredPowerquery = 1, powerquery_1 = n, n.displayName = "powerquery", n.aliases = [];
  function n(t) {
    t.languages.powerquery = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: !0,
        greedy: !0
      },
      "quoted-identifier": {
        pattern: /#"(?:[^"\r\n]|"")*"(?!")/,
        greedy: !0
      },
      string: {
        pattern: /(?:#!)?"(?:[^"\r\n]|"")*"(?!")/,
        greedy: !0
      },
      constant: [
        /\bDay\.(?:Friday|Monday|Saturday|Sunday|Thursday|Tuesday|Wednesday)\b/,
        /\bTraceLevel\.(?:Critical|Error|Information|Verbose|Warning)\b/,
        /\bOccurrence\.(?:All|First|Last)\b/,
        /\bOrder\.(?:Ascending|Descending)\b/,
        /\bRoundingMode\.(?:AwayFromZero|Down|ToEven|TowardZero|Up)\b/,
        /\bMissingField\.(?:Error|Ignore|UseNull)\b/,
        /\bQuoteStyle\.(?:Csv|None)\b/,
        /\bJoinKind\.(?:FullOuter|Inner|LeftAnti|LeftOuter|RightAnti|RightOuter)\b/,
        /\bGroupKind\.(?:Global|Local)\b/,
        /\bExtraValues\.(?:Error|Ignore|List)\b/,
        /\bJoinAlgorithm\.(?:Dynamic|LeftHash|LeftIndex|PairwiseHash|RightHash|RightIndex|SortMerge)\b/,
        /\bJoinSide\.(?:Left|Right)\b/,
        /\bPrecision\.(?:Decimal|Double)\b/,
        /\bRelativePosition\.From(?:End|Start)\b/,
        /\bTextEncoding\.(?:Ascii|BigEndianUnicode|Unicode|Utf16|Utf8|Windows)\b/,
        /\b(?:Any|Binary|Date|DateTime|DateTimeZone|Duration|Function|Int16|Int32|Int64|Int8|List|Logical|None|Number|Record|Table|Text|Time)\.Type\b/,
        /\bnull\b/
      ],
      boolean: /\b(?:false|true)\b/,
      keyword: /\b(?:and|as|each|else|error|if|in|is|let|meta|not|nullable|optional|or|otherwise|section|shared|then|try|type)\b|#(?:binary|date|datetime|datetimezone|duration|infinity|nan|sections|shared|table|time)\b/,
      function: {
        pattern: /(^|[^#\w.])[a-z_][\w.]*(?=\s*\()/i,
        lookbehind: !0
      },
      "data-type": {
        pattern: /\b(?:any|anynonnull|binary|date|datetime|datetimezone|duration|function|list|logical|none|number|record|table|text|time)\b/,
        alias: "class-name"
      },
      number: {
        pattern: /\b0x[\da-f]+\b|(?:[+-]?(?:\b\d+\.)?\b\d+|[+-]\.\d+|(^|[^.])\B\.\d+)(?:e[+-]?\d+)?\b/i,
        lookbehind: !0
      },
      operator: /[-+*\/&?@^]|<(?:=>?|>)?|>=?|=>?|\.\.\.?/,
      punctuation: /[,;\[\](){}]/
    }, t.languages.pq = t.languages.powerquery, t.languages.mscript = t.languages.powerquery;
  }
  return powerquery_1;
}
var powershell_1, hasRequiredPowershell;
function requirePowershell() {
  if (hasRequiredPowershell) return powershell_1;
  hasRequiredPowershell = 1, powershell_1 = n, n.displayName = "powershell", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = g.languages.powershell = {
        comment: [
          {
            pattern: /(^|[^`])<#[\s\S]*?#>/,
            lookbehind: !0
          },
          {
            pattern: /(^|[^`])#.*/,
            lookbehind: !0
          }
        ],
        string: [
          {
            pattern: /"(?:`[\s\S]|[^`"])*"/,
            greedy: !0,
            inside: null
            // see below
          },
          {
            pattern: /'(?:[^']|'')*'/,
            greedy: !0
          }
        ],
        // Matches name spaces as well as casts, attribute decorators. Force starting with letter to avoid matching array indices
        // Supports two levels of nested brackets (e.g. `[OutputType([System.Collections.Generic.List[int]])]`)
        namespace: /\[[a-z](?:\[(?:\[[^\]]*\]|[^\[\]])*\]|[^\[\]])*\]/i,
        boolean: /\$(?:false|true)\b/i,
        variable: /\$\w+\b/,
        // Cmdlets and aliases. Aliases should come last, otherwise "write" gets preferred over "write-host" for example
        // Get-Command | ?{ $_.ModuleName -match "Microsoft.PowerShell.(Util|Core|Management)" }
        // Get-Alias | ?{ $_.ReferencedCommand.Module.Name -match "Microsoft.PowerShell.(Util|Core|Management)" }
        function: [
          /\b(?:Add|Approve|Assert|Backup|Block|Checkpoint|Clear|Close|Compare|Complete|Compress|Confirm|Connect|Convert|ConvertFrom|ConvertTo|Copy|Debug|Deny|Disable|Disconnect|Dismount|Edit|Enable|Enter|Exit|Expand|Export|Find|ForEach|Format|Get|Grant|Group|Hide|Import|Initialize|Install|Invoke|Join|Limit|Lock|Measure|Merge|Move|New|Open|Optimize|Out|Ping|Pop|Protect|Publish|Push|Read|Receive|Redo|Register|Remove|Rename|Repair|Request|Reset|Resize|Resolve|Restart|Restore|Resume|Revoke|Save|Search|Select|Send|Set|Show|Skip|Sort|Split|Start|Step|Stop|Submit|Suspend|Switch|Sync|Tee|Test|Trace|Unblock|Undo|Uninstall|Unlock|Unprotect|Unpublish|Unregister|Update|Use|Wait|Watch|Where|Write)-[a-z]+\b/i,
          /\b(?:ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i
        ],
        // per http://technet.microsoft.com/en-us/library/hh847744.aspx
        keyword: /\b(?:Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
        operator: {
          pattern: /(^|\W)(?:!|-(?:b?(?:and|x?or)|as|(?:Not)?(?:Contains|In|Like|Match)|eq|ge|gt|is(?:Not)?|Join|le|lt|ne|not|Replace|sh[lr])\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
          lookbehind: !0
        },
        punctuation: /[|{}[\];(),.]/
      };
      d.string[0].inside = {
        function: {
          // Allow for one level of nesting
          pattern: /(^|[^`])\$\((?:\$\([^\r\n()]*\)|(?!\$\()[^\r\n)])*\)/,
          lookbehind: !0,
          inside: d
        },
        boolean: d.boolean,
        variable: d.variable
      };
    })(t);
  }
  return powershell_1;
}
var processing_1, hasRequiredProcessing;
function requireProcessing() {
  if (hasRequiredProcessing) return processing_1;
  hasRequiredProcessing = 1, processing_1 = n, n.displayName = "processing", n.aliases = [];
  function n(t) {
    t.languages.processing = t.languages.extend("clike", {
      keyword: /\b(?:break|case|catch|class|continue|default|else|extends|final|for|if|implements|import|new|null|private|public|return|static|super|switch|this|try|void|while)\b/,
      // Spaces are allowed between function name and parenthesis
      function: /\b\w+(?=\s*\()/,
      operator: /<[<=]?|>[>=]?|&&?|\|\|?|[%?]|[!=+\-*\/]=?/
    }), t.languages.insertBefore("processing", "number", {
      // Special case: XML is a type
      constant: /\b(?!XML\b)[A-Z][A-Z\d_]+\b/,
      type: {
        pattern: /\b(?:boolean|byte|char|color|double|float|int|[A-Z]\w*)\b/,
        alias: "class-name"
      }
    });
  }
  return processing_1;
}
var prolog_1, hasRequiredProlog;
function requireProlog() {
  if (hasRequiredProlog) return prolog_1;
  hasRequiredProlog = 1, prolog_1 = n, n.displayName = "prolog", n.aliases = [];
  function n(t) {
    t.languages.prolog = {
      // Syntax depends on the implementation
      comment: {
        pattern: /\/\*[\s\S]*?\*\/|%.*/,
        greedy: !0
      },
      // Depending on the implementation, strings may allow escaped newlines and quote-escape
      string: {
        pattern: /(["'])(?:\1\1|\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1(?!\1)/,
        greedy: !0
      },
      builtin: /\b(?:fx|fy|xf[xy]?|yfx?)\b/,
      // FIXME: Should we list all null-ary predicates (not followed by a parenthesis) like halt, trace, etc.?
      function: /\b[a-z]\w*(?:(?=\()|\/\d+)/,
      number: /\b\d+(?:\.\d*)?/,
      // Custom operators are allowed
      operator: /[:\\=><\-?*@\/;+^|!$.]+|\b(?:is|mod|not|xor)\b/,
      punctuation: /[(){}\[\],]/
    };
  }
  return prolog_1;
}
var promql_1, hasRequiredPromql;
function requirePromql() {
  if (hasRequiredPromql) return promql_1;
  hasRequiredPromql = 1, promql_1 = n, n.displayName = "promql", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = [
        "sum",
        "min",
        "max",
        "avg",
        "group",
        "stddev",
        "stdvar",
        "count",
        "count_values",
        "bottomk",
        "topk",
        "quantile"
      ], k = [
        "on",
        "ignoring",
        "group_right",
        "group_left",
        "by",
        "without"
      ], H = ["offset"], AA = d.concat(k, H);
      g.languages.promql = {
        comment: {
          pattern: /(^[ \t]*)#.*/m,
          lookbehind: !0
        },
        "vector-match": {
          // Match the comma-separated label lists inside vector matching:
          pattern: new RegExp(
            "((?:" + k.join("|") + ")\\s*)\\([^)]*\\)"
          ),
          lookbehind: !0,
          inside: {
            "label-key": {
              pattern: /\b[^,]+\b/,
              alias: "attr-name"
            },
            punctuation: /[(),]/
          }
        },
        "context-labels": {
          pattern: /\{[^{}]*\}/,
          inside: {
            "label-key": {
              pattern: /\b[a-z_]\w*(?=\s*(?:=|![=~]))/,
              alias: "attr-name"
            },
            "label-value": {
              pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
              greedy: !0,
              alias: "attr-value"
            },
            punctuation: /\{|\}|=~?|![=~]|,/
          }
        },
        "context-range": [
          {
            pattern: /\[[\w\s:]+\]/,
            // [1m]
            inside: {
              punctuation: /\[|\]|:/,
              "range-duration": {
                pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                alias: "number"
              }
            }
          },
          {
            pattern: /(\boffset\s+)\w+/,
            // offset 1m
            lookbehind: !0,
            inside: {
              "range-duration": {
                pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                alias: "number"
              }
            }
          }
        ],
        keyword: new RegExp("\\b(?:" + AA.join("|") + ")\\b", "i"),
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: /[-+]?(?:(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[-+]?\d+)?\b|\b(?:0x[0-9a-f]+|nan|inf)\b)/i,
        operator: /[\^*/%+-]|==|!=|<=|<|>=|>|\b(?:and|or|unless)\b/i,
        punctuation: /[{};()`,.[\]]/
      };
    })(t);
  }
  return promql_1;
}
var properties_1, hasRequiredProperties;
function requireProperties() {
  if (hasRequiredProperties) return properties_1;
  hasRequiredProperties = 1, properties_1 = n, n.displayName = "properties", n.aliases = [];
  function n(t) {
    t.languages.properties = {
      comment: /^[ \t]*[#!].*$/m,
      "attr-value": {
        pattern: /(^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?: *[=:] *(?! )| ))(?:\\(?:\r\n|[\s\S])|[^\\\r\n])+/m,
        lookbehind: !0
      },
      "attr-name": /^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?= *[=:]| )/m,
      punctuation: /[=:]/
    };
  }
  return properties_1;
}
var protobuf_1, hasRequiredProtobuf;
function requireProtobuf() {
  if (hasRequiredProtobuf) return protobuf_1;
  hasRequiredProtobuf = 1, protobuf_1 = n, n.displayName = "protobuf", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /\b(?:bool|bytes|double|s?fixed(?:32|64)|float|[su]?int(?:32|64)|string)\b/;
      g.languages.protobuf = g.languages.extend("clike", {
        "class-name": [
          {
            pattern: /(\b(?:enum|extend|message|service)\s+)[A-Za-z_]\w*(?=\s*\{)/,
            lookbehind: !0
          },
          {
            pattern: /(\b(?:rpc\s+\w+|returns)\s*\(\s*(?:stream\s+)?)\.?[A-Za-z_]\w*(?:\.[A-Za-z_]\w*)*(?=\s*\))/,
            lookbehind: !0
          }
        ],
        keyword: /\b(?:enum|extend|extensions|import|message|oneof|option|optional|package|public|repeated|required|reserved|returns|rpc(?=\s+\w)|service|stream|syntax|to)\b(?!\s*=\s*\d)/,
        function: /\b[a-z_]\w*(?=\s*\()/i
      }), g.languages.insertBefore("protobuf", "operator", {
        map: {
          pattern: /\bmap<\s*[\w.]+\s*,\s*[\w.]+\s*>(?=\s+[a-z_]\w*\s*[=;])/i,
          alias: "class-name",
          inside: {
            punctuation: /[<>.,]/,
            builtin: d
          }
        },
        builtin: d,
        "positional-class-name": {
          pattern: /(?:\b|\B\.)[a-z_]\w*(?:\.[a-z_]\w*)*(?=\s+[a-z_]\w*\s*[=;])/i,
          alias: "class-name",
          inside: {
            punctuation: /\./
          }
        },
        annotation: {
          pattern: /(\[\s*)[a-z_]\w*(?=\s*=)/i,
          lookbehind: !0
        }
      });
    })(t);
  }
  return protobuf_1;
}
var psl_1, hasRequiredPsl;
function requirePsl() {
  if (hasRequiredPsl) return psl_1;
  hasRequiredPsl = 1, psl_1 = n, n.displayName = "psl", n.aliases = [];
  function n(t) {
    t.languages.psl = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        pattern: /"(?:\\.|[^\\"])*"/,
        greedy: !0,
        inside: {
          symbol: /\\[ntrbA-Z"\\]/
        }
      },
      "heredoc-string": {
        pattern: /<<<([a-zA-Z_]\w*)[\r\n](?:.*[\r\n])*?\1\b/,
        alias: "string",
        greedy: !0
      },
      keyword: /\b(?:__multi|__single|case|default|do|else|elsif|exit|export|for|foreach|function|if|last|line|local|next|requires|return|switch|until|while|word)\b/,
      constant: /\b(?:ALARM|CHART_ADD_GRAPH|CHART_DELETE_GRAPH|CHART_DESTROY|CHART_LOAD|CHART_PRINT|EOF|OFFLINE|OK|PSL_PROF_LOG|R_CHECK_HORIZ|R_CHECK_VERT|R_CLICKER|R_COLUMN|R_FRAME|R_ICON|R_LABEL|R_LABEL_CENTER|R_LIST_MULTIPLE|R_LIST_MULTIPLE_ND|R_LIST_SINGLE|R_LIST_SINGLE_ND|R_MENU|R_POPUP|R_POPUP_SCROLLED|R_RADIO_HORIZ|R_RADIO_VERT|R_ROW|R_SCALE_HORIZ|R_SCALE_VERT|R_SEP_HORIZ|R_SEP_VERT|R_SPINNER|R_TEXT_FIELD|R_TEXT_FIELD_LABEL|R_TOGGLE|TRIM_LEADING|TRIM_LEADING_AND_TRAILING|TRIM_REDUNDANT|TRIM_TRAILING|VOID|WARN)\b/,
      boolean: /\b(?:FALSE|False|NO|No|TRUE|True|YES|Yes|false|no|true|yes)\b/,
      variable: /\b(?:PslDebug|errno|exit_status)\b/,
      builtin: {
        pattern: /\b(?:PslExecute|PslFunctionCall|PslFunctionExists|PslSetOptions|_snmp_debug|acos|add_diary|annotate|annotate_get|ascii_to_ebcdic|asctime|asin|atan|atexit|batch_set|blackout|cat|ceil|chan_exists|change_state|close|code_cvt|cond_signal|cond_wait|console_type|convert_base|convert_date|convert_locale_date|cos|cosh|create|date|dcget_text|destroy|destroy_lock|dget_text|difference|dump_hist|ebcdic_to_ascii|encrypt|event_archive|event_catalog_get|event_check|event_query|event_range_manage|event_range_query|event_report|event_schedule|event_trigger|event_trigger2|execute|exists|exp|fabs|file|floor|fmod|fopen|fseek|ftell|full_discovery|get|get_chan_info|get_ranges|get_text|get_vars|getenv|gethostinfo|getpid|getpname|grep|history|history_get_retention|in_transition|index|int|internal|intersection|is_var|isnumber|join|kill|length|lines|lock|lock_info|log|log10|loge|matchline|msg_check|msg_get_format|msg_get_severity|msg_printf|msg_sprintf|ntharg|nthargf|nthline|nthlinef|num_bytes|num_consoles|pconfig|popen|poplines|pow|print|printf|proc_exists|process|random|read|readln|refresh_parameters|remote_check|remote_close|remote_event_query|remote_event_trigger|remote_file_send|remote_open|remove|replace|rindex|sec_check_priv|sec_store_get|sec_store_set|set|set_alarm_ranges|set_locale|share|sin|sinh|sleep|snmp_agent_config|snmp_agent_start|snmp_agent_stop|snmp_close|snmp_config|snmp_get|snmp_get_next|snmp_h_get|snmp_h_get_next|snmp_h_set|snmp_open|snmp_set|snmp_trap_ignore|snmp_trap_listen|snmp_trap_raise_std_trap|snmp_trap_receive|snmp_trap_register_im|snmp_trap_send|snmp_walk|sopen|sort|splitline|sprintf|sqrt|srandom|str_repeat|strcasecmp|subset|substr|system|tail|tan|tanh|text_domain|time|tmpnam|tolower|toupper|trace_psl_process|trim|union|unique|unlock|unset|va_arg|va_start|write)\b/,
        alias: "builtin-function"
      },
      "foreach-variable": {
        pattern: /(\bforeach\s+(?:(?:\w+\b|"(?:\\.|[^\\"])*")\s+){0,2})[_a-zA-Z]\w*(?=\s*\()/,
        lookbehind: !0,
        greedy: !0
      },
      function: /\b[_a-z]\w*\b(?=\s*\()/i,
      number: /\b(?:0x[0-9a-f]+|\d+(?:\.\d+)?)\b/i,
      operator: /--|\+\+|&&=?|\|\|=?|<<=?|>>=?|[=!]~|[-+*/%&|^!=<>]=?|\.|[:?]/,
      punctuation: /[(){}\[\];,]/
    };
  }
  return psl_1;
}
var pug_1, hasRequiredPug;
function requirePug() {
  if (hasRequiredPug) return pug_1;
  hasRequiredPug = 1, pug_1 = n, n.displayName = "pug", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.pug = {
        // Multiline stuff should appear before the rest
        // This handles both single-line and multi-line comments
        comment: {
          pattern: /(^([\t ]*))\/\/.*(?:(?:\r?\n|\r)\2[\t ].+)*/m,
          lookbehind: !0
        },
        // All the tag-related part is in lookbehind
        // so that it can be highlighted by the "tag" pattern
        "multiline-script": {
          pattern: /(^([\t ]*)script\b.*\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
          lookbehind: !0,
          inside: g.languages.javascript
        },
        // See at the end of the file for known filters
        filter: {
          pattern: /(^([\t ]*)):.+(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
          lookbehind: !0,
          inside: {
            "filter-name": {
              pattern: /^:[\w-]+/,
              alias: "variable"
            },
            text: /\S[\s\S]*/
          }
        },
        "multiline-plain-text": {
          pattern: /(^([\t ]*)[\w\-#.]+\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
          lookbehind: !0
        },
        markup: {
          pattern: /(^[\t ]*)<.+/m,
          lookbehind: !0,
          inside: g.languages.markup
        },
        doctype: {
          pattern: /((?:^|\n)[\t ]*)doctype(?: .+)?/,
          lookbehind: !0
        },
        // This handle all conditional and loop keywords
        "flow-control": {
          pattern: /(^[\t ]*)(?:case|default|each|else|if|unless|when|while)\b(?: .+)?/m,
          lookbehind: !0,
          inside: {
            each: {
              pattern: /^each .+? in\b/,
              inside: {
                keyword: /\b(?:each|in)\b/,
                punctuation: /,/
              }
            },
            branch: {
              pattern: /^(?:case|default|else|if|unless|when|while)\b/,
              alias: "keyword"
            },
            rest: g.languages.javascript
          }
        },
        keyword: {
          pattern: /(^[\t ]*)(?:append|block|extends|include|prepend)\b.+/m,
          lookbehind: !0
        },
        mixin: [
          // Declaration
          {
            pattern: /(^[\t ]*)mixin .+/m,
            lookbehind: !0,
            inside: {
              keyword: /^mixin/,
              function: /\w+(?=\s*\(|\s*$)/,
              punctuation: /[(),.]/
            }
          },
          // Usage
          {
            pattern: /(^[\t ]*)\+.+/m,
            lookbehind: !0,
            inside: {
              name: {
                pattern: /^\+\w+/,
                alias: "function"
              },
              rest: g.languages.javascript
            }
          }
        ],
        script: {
          pattern: /(^[\t ]*script(?:(?:&[^(]+)?\([^)]+\))*[\t ]).+/m,
          lookbehind: !0,
          inside: g.languages.javascript
        },
        "plain-text": {
          pattern: /(^[\t ]*(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?[\t ]).+/m,
          lookbehind: !0
        },
        tag: {
          pattern: /(^[\t ]*)(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?:?/m,
          lookbehind: !0,
          inside: {
            attributes: [
              {
                pattern: /&[^(]+\([^)]+\)/,
                inside: g.languages.javascript
              },
              {
                pattern: /\([^)]+\)/,
                inside: {
                  "attr-value": {
                    pattern: /(=\s*(?!\s))(?:\{[^}]*\}|[^,)\r\n]+)/,
                    lookbehind: !0,
                    inside: g.languages.javascript
                  },
                  "attr-name": /[\w-]+(?=\s*!?=|\s*[,)])/,
                  punctuation: /[!=(),]+/
                }
              }
            ],
            punctuation: /:/,
            "attr-id": /#[\w\-]+/,
            "attr-class": /\.[\w\-]+/
          }
        },
        code: [
          {
            pattern: /(^[\t ]*(?:-|!?=)).+/m,
            lookbehind: !0,
            inside: g.languages.javascript
          }
        ],
        punctuation: /[.\-!=|]+/
      };
      for (var d = /(^([\t ]*)):<filter_name>(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/.source, k = [
        {
          filter: "atpl",
          language: "twig"
        },
        {
          filter: "coffee",
          language: "coffeescript"
        },
        "ejs",
        "handlebars",
        "less",
        "livescript",
        "markdown",
        {
          filter: "sass",
          language: "scss"
        },
        "stylus"
      ], H = {}, AA = 0, gA = k.length; AA < gA; AA++) {
        var IA = k[AA];
        IA = typeof IA == "string" ? {
          filter: IA,
          language: IA
        } : IA, g.languages[IA.language] && (H["filter-" + IA.filter] = {
          pattern: RegExp(
            d.replace("<filter_name>", function() {
              return IA.filter;
            }),
            "m"
          ),
          lookbehind: !0,
          inside: {
            "filter-name": {
              pattern: /^:[\w-]+/,
              alias: "variable"
            },
            text: {
              pattern: /\S[\s\S]*/,
              alias: [IA.language, "language-" + IA.language],
              inside: g.languages[IA.language]
            }
          }
        });
      }
      g.languages.insertBefore("pug", "filter", H);
    })(t);
  }
  return pug_1;
}
var puppet_1, hasRequiredPuppet;
function requirePuppet() {
  if (hasRequiredPuppet) return puppet_1;
  hasRequiredPuppet = 1, puppet_1 = n, n.displayName = "puppet", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.puppet = {
        heredoc: [
          // Matches the content of a quoted heredoc string (subject to interpolation)
          {
            pattern: /(@\("([^"\r\n\/):]+)"(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
            lookbehind: !0,
            alias: "string",
            inside: {
              // Matches the end tag
              punctuation: /(?=\S).*\S(?= *$)/
              // See interpolation below
            }
          },
          // Matches the content of an unquoted heredoc string (no interpolation)
          {
            pattern: /(@\(([^"\r\n\/):]+)(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
            lookbehind: !0,
            greedy: !0,
            alias: "string",
            inside: {
              // Matches the end tag
              punctuation: /(?=\S).*\S(?= *$)/
            }
          },
          // Matches the start tag of heredoc strings
          {
            pattern: /@\("?(?:[^"\r\n\/):]+)"?(?:\/[nrts$uL]*)?\)/,
            alias: "string",
            inside: {
              punctuation: {
                pattern: /(\().+?(?=\))/,
                lookbehind: !0
              }
            }
          }
        ],
        "multiline-comment": {
          pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
          lookbehind: !0,
          greedy: !0,
          alias: "comment"
        },
        regex: {
          // Must be prefixed with the keyword "node" or a non-word char
          pattern: /((?:\bnode\s+|[~=\(\[\{,]\s*|[=+]>\s*|^\s*))\/(?:[^\/\\]|\\[\s\S])+\/(?:[imx]+\b|\B)/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            // Extended regexes must have the x flag. They can contain single-line comments.
            "extended-regex": {
              pattern: /^\/(?:[^\/\\]|\\[\s\S])+\/[im]*x[im]*$/,
              inside: {
                comment: /#.*/
              }
            }
          }
        },
        comment: {
          pattern: /(^|[^\\])#.*/,
          lookbehind: !0,
          greedy: !0
        },
        string: {
          // Allow for one nested level of double quotes inside interpolation
          pattern: /(["'])(?:\$\{(?:[^'"}]|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}|\$(?!\{)|(?!\1)[^\\$]|\\[\s\S])*\1/,
          greedy: !0,
          inside: {
            "double-quoted": {
              pattern: /^"[\s\S]*"$/,
              inside: {
                // See interpolation below
              }
            }
          }
        },
        variable: {
          pattern: /\$(?:::)?\w+(?:::\w+)*/,
          inside: {
            punctuation: /::/
          }
        },
        "attr-name": /(?:\b\w+|\*)(?=\s*=>)/,
        function: [
          {
            pattern: /(\.)(?!\d)\w+/,
            lookbehind: !0
          },
          /\b(?:contain|debug|err|fail|include|info|notice|realize|require|tag|warning)\b|\b(?!\d)\w+(?=\()/
        ],
        number: /\b(?:0x[a-f\d]+|\d+(?:\.\d+)?(?:e-?\d+)?)\b/i,
        boolean: /\b(?:false|true)\b/,
        // Includes words reserved for future use
        keyword: /\b(?:application|attr|case|class|consumes|default|define|else|elsif|function|if|import|inherits|node|private|produces|type|undef|unless)\b/,
        datatype: {
          pattern: /\b(?:Any|Array|Boolean|Callable|Catalogentry|Class|Collection|Data|Default|Enum|Float|Hash|Integer|NotUndef|Numeric|Optional|Pattern|Regexp|Resource|Runtime|Scalar|String|Struct|Tuple|Type|Undef|Variant)\b/,
          alias: "symbol"
        },
        operator: /=[=~>]?|![=~]?|<(?:<\|?|[=~|-])?|>[>=]?|->?|~>|\|>?>?|[*\/%+?]|\b(?:and|in|or)\b/,
        punctuation: /[\[\]{}().,;]|:+/
      };
      var d = [
        {
          // Allow for one nested level of braces inside interpolation
          pattern: /(^|[^\\])\$\{(?:[^'"{}]|\{[^}]*\}|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}/,
          lookbehind: !0,
          inside: {
            "short-variable": {
              // Negative look-ahead prevent wrong highlighting of functions
              pattern: /(^\$\{)(?!\w+\()(?:::)?\w+(?:::\w+)*/,
              lookbehind: !0,
              alias: "variable",
              inside: {
                punctuation: /::/
              }
            },
            delimiter: {
              pattern: /^\$/,
              alias: "variable"
            },
            rest: g.languages.puppet
          }
        },
        {
          pattern: /(^|[^\\])\$(?:::)?\w+(?:::\w+)*/,
          lookbehind: !0,
          alias: "variable",
          inside: {
            punctuation: /::/
          }
        }
      ];
      g.languages.puppet.heredoc[0].inside.interpolation = d, g.languages.puppet.string.inside["double-quoted"].inside.interpolation = d;
    })(t);
  }
  return puppet_1;
}
var pure_1, hasRequiredPure;
function requirePure() {
  if (hasRequiredPure) return pure_1;
  hasRequiredPure = 1, pure_1 = n, n.displayName = "pure", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.pure = {
        comment: [
          {
            pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
            lookbehind: !0
          },
          {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0
          },
          /#!.+/
        ],
        "inline-lang": {
          pattern: /%<[\s\S]+?%>/,
          greedy: !0,
          inside: {
            lang: {
              pattern: /(^%< *)-\*-.+?-\*-/,
              lookbehind: !0,
              alias: "comment"
            },
            delimiter: {
              pattern: /^%<.*|%>$/,
              alias: "punctuation"
            }
          }
        },
        string: {
          pattern: /"(?:\\.|[^"\\\r\n])*"/,
          greedy: !0
        },
        number: {
          // The look-behind prevents wrong highlighting of the .. operator
          pattern: /((?:\.\.)?)(?:\b(?:inf|nan)\b|\b0x[\da-f]+|(?:\b(?:0b)?\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?L?)/i,
          lookbehind: !0
        },
        keyword: /\b(?:NULL|ans|break|bt|case|catch|cd|clear|const|def|del|dump|else|end|exit|extern|false|force|help|if|infix[lr]?|interface|let|ls|mem|namespace|nonfix|of|otherwise|outfix|override|postfix|prefix|private|public|pwd|quit|run|save|show|stats|then|throw|trace|true|type|underride|using|when|with)\b/,
        function: /\b(?:abs|add_(?:addr|constdef|(?:fundef|interface|macdef|typedef)(?:_at)?|vardef)|all|any|applp?|arity|bigintp?|blob(?:_crc|_size|p)?|boolp?|byte_c?string(?:_pointer)?|byte_(?:matrix|pointer)|calloc|cat|catmap|ceil|char[ps]?|check_ptrtag|chr|clear_sentry|clearsym|closurep?|cmatrixp?|cols?|colcat(?:map)?|colmap|colrev|colvector(?:p|seq)?|complex(?:_float_(?:matrix|pointer)|_matrix(?:_view)?|_pointer|p)?|conj|cookedp?|cst|cstring(?:_(?:dup|list|vector))?|curry3?|cyclen?|del_(?:constdef|fundef|interface|macdef|typedef|vardef)|delete|diag(?:mat)?|dim|dmatrixp?|do|double(?:_matrix(?:_view)?|_pointer|p)?|dowith3?|drop|dropwhile|eval(?:cmd)?|exactp|filter|fix|fixity|flip|float(?:_matrix|_pointer)|floor|fold[lr]1?|frac|free|funp?|functionp?|gcd|get(?:_(?:byte|constdef|double|float|fundef|int(?:64)?|interface(?:_typedef)?|long|macdef|pointer|ptrtag|sentry|short|string|typedef|vardef))?|globsym|hash|head|id|im|imatrixp?|index|inexactp|infp|init|insert|int(?:_matrix(?:_view)?|_pointer|p)?|int64_(?:matrix|pointer)|integerp?|iteraten?|iterwhile|join|keys?|lambdap?|last(?:err(?:pos)?)?|lcd|list[2p]?|listmap|make_ptrtag|malloc|map|matcat|matrixp?|max|member|min|nanp|nargs|nmatrixp?|null|numberp?|ord|pack(?:ed)?|pointer(?:_cast|_tag|_type|p)?|pow|pred|ptrtag|put(?:_(?:byte|double|float|int(?:64)?|long|pointer|short|string))?|rationalp?|re|realp?|realloc|recordp?|redim|reduce(?:_with)?|refp?|repeatn?|reverse|rlistp?|round|rows?|rowcat(?:map)?|rowmap|rowrev|rowvector(?:p|seq)?|same|scan[lr]1?|sentry|sgn|short_(?:matrix|pointer)|slice|smatrixp?|sort|split|str|strcat|stream|stride|string(?:_(?:dup|list|vector)|p)?|subdiag(?:mat)?|submat|subseq2?|substr|succ|supdiag(?:mat)?|symbolp?|tail|take|takewhile|thunkp?|transpose|trunc|tuplep?|typep|ubyte|uint(?:64)?|ulong|uncurry3?|unref|unzip3?|update|ushort|vals?|varp?|vector(?:p|seq)?|void|zip3?|zipwith3?)\b/,
        special: {
          pattern: /\b__[a-z]+__\b/i,
          alias: "builtin"
        },
        // Any combination of operator chars can be an operator
        // eslint-disable-next-line no-misleading-character-class
        operator: /(?:[!"#$%&'*+,\-.\/:<=>?@\\^`|~\u00a1-\u00bf\u00d7-\u00f7\u20d0-\u2bff]|\b_+\b)+|\b(?:and|div|mod|not|or)\b/,
        // FIXME: How can we prevent | and , to be highlighted as operator when they are used alone?
        punctuation: /[(){}\[\];,|]/
      };
      var d = [
        "c",
        {
          lang: "c++",
          alias: "cpp"
        },
        "fortran"
      ], k = /%< *-\*- *<lang>\d* *-\*-[\s\S]+?%>/.source;
      d.forEach(function(H) {
        var AA = H;
        if (typeof H != "string" && (AA = H.alias, H = H.lang), g.languages[AA]) {
          var gA = {};
          gA["inline-lang-" + AA] = {
            pattern: RegExp(
              k.replace(
                "<lang>",
                H.replace(/([.+*?\/\\(){}\[\]])/g, "\\$1")
              ),
              "i"
            ),
            inside: g.util.clone(g.languages.pure["inline-lang"].inside)
          }, gA["inline-lang-" + AA].inside.rest = g.util.clone(
            g.languages[AA]
          ), g.languages.insertBefore("pure", "inline-lang", gA);
        }
      }), g.languages.c && (g.languages.pure["inline-lang"].inside.rest = g.util.clone(
        g.languages.c
      ));
    })(t);
  }
  return pure_1;
}
var purebasic_1, hasRequiredPurebasic;
function requirePurebasic() {
  if (hasRequiredPurebasic) return purebasic_1;
  hasRequiredPurebasic = 1, purebasic_1 = n, n.displayName = "purebasic", n.aliases = [];
  function n(t) {
    t.languages.purebasic = t.languages.extend("clike", {
      comment: /;.*/,
      keyword: /\b(?:align|and|as|break|calldebugger|case|compilercase|compilerdefault|compilerelse|compilerelseif|compilerendif|compilerendselect|compilererror|compilerif|compilerselect|continue|data|datasection|debug|debuglevel|declare|declarec|declarecdll|declaredll|declaremodule|default|define|dim|disableasm|disabledebugger|disableexplicit|else|elseif|enableasm|enabledebugger|enableexplicit|end|enddatasection|enddeclaremodule|endenumeration|endif|endimport|endinterface|endmacro|endmodule|endprocedure|endselect|endstructure|endstructureunion|endwith|enumeration|extends|fakereturn|for|foreach|forever|global|gosub|goto|if|import|importc|includebinary|includefile|includepath|interface|macro|module|newlist|newmap|next|not|or|procedure|procedurec|procedurecdll|proceduredll|procedurereturn|protected|prototype|prototypec|read|redim|repeat|restore|return|runtime|select|shared|static|step|structure|structureunion|swap|threaded|to|until|wend|while|with|xincludefile|xor)\b/i,
      function: /\b\w+(?:\.\w+)?\s*(?=\()/,
      number: /(?:\$[\da-f]+|\b-?(?:\d+(?:\.\d+)?|\.\d+)(?:e[+-]?\d+)?)\b/i,
      operator: /(?:@\*?|\?|\*)\w+|-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*/@]/
    }), t.languages.insertBefore("purebasic", "keyword", {
      tag: /#\w+\$?/,
      asm: {
        pattern: /(^[\t ]*)!.*/m,
        lookbehind: !0,
        alias: "tag",
        inside: {
          comment: /;.*/,
          string: {
            pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: !0
          },
          // Anonymous label references, i.e.: jmp @b
          "label-reference-anonymous": {
            pattern: /(!\s*j[a-z]+\s+)@[fb]/i,
            lookbehind: !0,
            alias: "fasm-label"
          },
          // Named label reference, i.e.: jne label1
          "label-reference-addressed": {
            pattern: /(!\s*j[a-z]+\s+)[A-Z._?$@][\w.?$@~#]*/i,
            lookbehind: !0,
            alias: "fasm-label"
          },
          keyword: [
            /\b(?:extern|global)\b[^;\r\n]*/i,
            /\b(?:CPU|DEFAULT|FLOAT)\b.*/
          ],
          function: {
            pattern: /^([\t ]*!\s*)[\da-z]+(?=\s|$)/im,
            lookbehind: !0
          },
          "function-inline": {
            pattern: /(:\s*)[\da-z]+(?=\s)/i,
            lookbehind: !0,
            alias: "function"
          },
          label: {
            pattern: /^([\t ]*!\s*)[A-Za-z._?$@][\w.?$@~#]*(?=:)/m,
            lookbehind: !0,
            alias: "fasm-label"
          },
          register: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s|mm\d+)\b/i,
          number: /(?:\b|-|(?=\$))(?:0[hx](?:[\da-f]*\.)?[\da-f]+(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
          operator: /[\[\]*+\-/%<>=&|$!,.:]/
        }
      }
    }), delete t.languages.purebasic["class-name"], delete t.languages.purebasic.boolean, t.languages.pbfasm = t.languages.purebasic;
  }
  return purebasic_1;
}
var purescript_1, hasRequiredPurescript;
function requirePurescript() {
  if (hasRequiredPurescript) return purescript_1;
  hasRequiredPurescript = 1;
  var n = requireHaskell();
  purescript_1 = t, t.displayName = "purescript", t.aliases = ["purs"];
  function t(g) {
    g.register(n), g.languages.purescript = g.languages.extend("haskell", {
      keyword: /\b(?:ado|case|class|data|derive|do|else|forall|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b|∀/,
      "import-statement": {
        // The imported or hidden names are not included in this import
        // statement. This is because we want to highlight those exactly like
        // we do for the names in the program.
        pattern: /(^[\t ]*)import\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*(?:\s+as\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
        lookbehind: !0,
        inside: {
          keyword: /\b(?:as|hiding|import)\b/,
          punctuation: /\./
        }
      },
      // These are builtin functions only. Constructors are highlighted later as a constant.
      builtin: /\b(?:absurd|add|ap|append|apply|between|bind|bottom|clamp|compare|comparing|compose|conj|const|degree|discard|disj|div|eq|flap|flip|gcd|identity|ifM|join|lcm|liftA1|liftM1|map|max|mempty|min|mod|mul|negate|not|notEq|one|otherwise|recip|show|sub|top|unit|unless|unlessM|void|when|whenM|zero)\b/,
      operator: [
        // Infix operators
        g.languages.haskell.operator[0],
        // ASCII operators
        g.languages.haskell.operator[2],
        // All UTF16 Unicode operator symbols
        // This regex is equivalent to /(?=[\x80-\uFFFF])[\p{gc=Math_Symbol}\p{gc=Currency_Symbol}\p{Modifier_Symbol}\p{Other_Symbol}]/u
        // See https://github.com/PrismJS/prism/issues/3006 for more details.
        /[\xa2-\xa6\xa8\xa9\xac\xae-\xb1\xb4\xb8\xd7\xf7\u02c2-\u02c5\u02d2-\u02df\u02e5-\u02eb\u02ed\u02ef-\u02ff\u0375\u0384\u0385\u03f6\u0482\u058d-\u058f\u0606-\u0608\u060b\u060e\u060f\u06de\u06e9\u06fd\u06fe\u07f6\u07fe\u07ff\u09f2\u09f3\u09fa\u09fb\u0af1\u0b70\u0bf3-\u0bfa\u0c7f\u0d4f\u0d79\u0e3f\u0f01-\u0f03\u0f13\u0f15-\u0f17\u0f1a-\u0f1f\u0f34\u0f36\u0f38\u0fbe-\u0fc5\u0fc7-\u0fcc\u0fce\u0fcf\u0fd5-\u0fd8\u109e\u109f\u1390-\u1399\u166d\u17db\u1940\u19de-\u19ff\u1b61-\u1b6a\u1b74-\u1b7c\u1fbd\u1fbf-\u1fc1\u1fcd-\u1fcf\u1fdd-\u1fdf\u1fed-\u1fef\u1ffd\u1ffe\u2044\u2052\u207a-\u207c\u208a-\u208c\u20a0-\u20bf\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211e-\u2123\u2125\u2127\u2129\u212e\u213a\u213b\u2140-\u2144\u214a-\u214d\u214f\u218a\u218b\u2190-\u2307\u230c-\u2328\u232b-\u2426\u2440-\u244a\u249c-\u24e9\u2500-\u2767\u2794-\u27c4\u27c7-\u27e5\u27f0-\u2982\u2999-\u29d7\u29dc-\u29fb\u29fe-\u2b73\u2b76-\u2b95\u2b97-\u2bff\u2ce5-\u2cea\u2e50\u2e51\u2e80-\u2e99\u2e9b-\u2ef3\u2f00-\u2fd5\u2ff0-\u2ffb\u3004\u3012\u3013\u3020\u3036\u3037\u303e\u303f\u309b\u309c\u3190\u3191\u3196-\u319f\u31c0-\u31e3\u3200-\u321e\u322a-\u3247\u3250\u3260-\u327f\u328a-\u32b0\u32c0-\u33ff\u4dc0-\u4dff\ua490-\ua4c6\ua700-\ua716\ua720\ua721\ua789\ua78a\ua828-\ua82b\ua836-\ua839\uaa77-\uaa79\uab5b\uab6a\uab6b\ufb29\ufbb2-\ufbc1\ufdfc\ufdfd\ufe62\ufe64-\ufe66\ufe69\uff04\uff0b\uff1c-\uff1e\uff3e\uff40\uff5c\uff5e\uffe0-\uffe6\uffe8-\uffee\ufffc\ufffd]/
      ]
    }), g.languages.purs = g.languages.purescript;
  }
  return purescript_1;
}
var python_1, hasRequiredPython;
function requirePython() {
  if (hasRequiredPython) return python_1;
  hasRequiredPython = 1, python_1 = n, n.displayName = "python", n.aliases = ["py"];
  function n(t) {
    t.languages.python = {
      comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: !0,
        greedy: !0
      },
      "string-interpolation": {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: !0,
        inside: {
          interpolation: {
            // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
            pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
            lookbehind: !0,
            inside: {
              "format-spec": {
                pattern: /(:)[^:(){}]+(?=\}$)/,
                lookbehind: !0
              },
              "conversion-option": {
                pattern: /![sra](?=[:}]$)/,
                alias: "punctuation"
              },
              rest: null
            }
          },
          string: /[\s\S]+/
        }
      },
      "triple-quoted-string": {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: !0,
        alias: "string"
      },
      string: {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: !0
      },
      function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: !0
      },
      "class-name": {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: !0
      },
      decorator: {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: !0,
        alias: ["annotation", "punctuation"],
        inside: {
          punctuation: /\./
        }
      },
      keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
      builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
      boolean: /\b(?:False|None|True)\b/,
      number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
      operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.python["string-interpolation"].inside.interpolation.inside.rest = t.languages.python, t.languages.py = t.languages.python;
  }
  return python_1;
}
var q_1, hasRequiredQ;
function requireQ() {
  if (hasRequiredQ) return q_1;
  hasRequiredQ = 1, q_1 = n, n.displayName = "q", n.aliases = [];
  function n(t) {
    t.languages.q = {
      string: /"(?:\\.|[^"\\\r\n])*"/,
      comment: [
        // From http://code.kx.com/wiki/Reference/Slash:
        // When / is following a space (or a right parenthesis, bracket, or brace), it is ignored with the rest of the line.
        {
          pattern: /([\t )\]}])\/.*/,
          lookbehind: !0,
          greedy: !0
        },
        // From http://code.kx.com/wiki/Reference/Slash:
        // A line which has / as its first character and contains at least one other non-whitespace character is a whole-line comment and is ignored entirely.
        // A / on a line by itself begins a multiline comment which is terminated by the next \ on a line by itself.
        // If a / is not matched by a \, the multiline comment is unterminated and continues to end of file.
        // The / and \ must be the first char on the line, but may be followed by any amount of whitespace.
        {
          pattern: /(^|\r?\n|\r)\/[\t ]*(?:(?:\r?\n|\r)(?:.*(?:\r?\n|\r(?!\n)))*?(?:\\(?=[\t ]*(?:\r?\n|\r))|$)|\S.*)/,
          lookbehind: !0,
          greedy: !0
        },
        // From http://code.kx.com/wiki/Reference/Slash:
        // A \ on a line by itself with no preceding matching / will comment to end of file.
        {
          pattern: /^\\[\t ]*(?:\r?\n|\r)[\s\S]+/m,
          greedy: !0
        },
        {
          pattern: /^#!.+/m,
          greedy: !0
        }
      ],
      symbol: /`(?::\S+|[\w.]*)/,
      datetime: {
        pattern: /0N[mdzuvt]|0W[dtz]|\d{4}\.\d\d(?:m|\.\d\d(?:T(?:\d\d(?::\d\d(?::\d\d(?:[.:]\d\d\d)?)?)?)?)?[dz]?)|\d\d:\d\d(?::\d\d(?:[.:]\d\d\d)?)?[uvt]?/,
        alias: "number"
      },
      // The negative look-ahead prevents bad highlighting
      // of verbs 0: and 1:
      number: /\b(?![01]:)(?:0N[hje]?|0W[hj]?|0[wn]|0x[\da-fA-F]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?[hjfeb]?)/,
      keyword: /\\\w+\b|\b(?:abs|acos|aj0?|all|and|any|asc|asin|asof|atan|attr|avgs?|binr?|by|ceiling|cols|cor|cos|count|cov|cross|csv|cut|delete|deltas|desc|dev|differ|distinct|div|do|dsave|ej|enlist|eval|except|exec|exit|exp|fby|fills|first|fkeys|flip|floor|from|get|getenv|group|gtime|hclose|hcount|hdel|hopen|hsym|iasc|identity|idesc|if|ij|in|insert|inter|inv|keys?|last|like|list|ljf?|load|log|lower|lsq|ltime|ltrim|mavg|maxs?|mcount|md5|mdev|med|meta|mins?|mmax|mmin|mmu|mod|msum|neg|next|not|null|or|over|parse|peach|pj|plist|prds?|prev|prior|rand|rank|ratios|raze|read0|read1|reciprocal|reval|reverse|rload|rotate|rsave|rtrim|save|scan|scov|sdev|select|set|setenv|show|signum|sin|sqrt|ssr?|string|sublist|sums?|sv|svar|system|tables|tan|til|trim|txf|type|uj|ungroup|union|update|upper|upsert|value|var|views?|vs|wavg|where|while|within|wj1?|wsum|ww|xasc|xbar|xcols?|xdesc|xexp|xgroup|xkey|xlog|xprev|xrank)\b/,
      adverb: {
        pattern: /['\/\\]:?|\beach\b/,
        alias: "function"
      },
      verb: {
        pattern: /(?:\B\.\B|\b[01]:|<[=>]?|>=?|[:+\-*%,!?~=|$&#@^]):?|\b_\b:?/,
        alias: "operator"
      },
      punctuation: /[(){}\[\];.]/
    };
  }
  return q_1;
}
var qml_1, hasRequiredQml;
function requireQml() {
  if (hasRequiredQml) return qml_1;
  hasRequiredQml = 1, qml_1 = n, n.displayName = "qml", n.aliases = [];
  function n(t) {
    (function(g) {
      for (var d = /"(?:\\.|[^\\"\r\n])*"|'(?:\\.|[^\\'\r\n])*'/.source, k = /\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))*\*\//.source, H = /(?:[^\\()[\]{}"'/]|<string>|\/(?![*/])|<comment>|\(<expr>*\)|\[<expr>*\]|\{<expr>*\}|\\[\s\S])/.source.replace(/<string>/g, function() {
        return d;
      }).replace(/<comment>/g, function() {
        return k;
      }), AA = 0; AA < 2; AA++)
        H = H.replace(/<expr>/g, function() {
          return H;
        });
      H = H.replace(/<expr>/g, "[^\\s\\S]"), g.languages.qml = {
        comment: {
          pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
          greedy: !0
        },
        "javascript-function": {
          pattern: RegExp(
            /((?:^|;)[ \t]*)function\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*\(<js>*\)\s*\{<js>*\}/.source.replace(
              /<js>/g,
              function() {
                return H;
              }
            ),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "language-javascript",
          inside: g.languages.javascript
        },
        "class-name": {
          pattern: /((?:^|[:;])[ \t]*)(?!\d)\w+(?=[ \t]*\{|[ \t]+on\b)/m,
          lookbehind: !0
        },
        property: [
          {
            pattern: /((?:^|[;{])[ \t]*)(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
            lookbehind: !0
          },
          {
            pattern: /((?:^|[;{])[ \t]*)property[ \t]+(?!\d)\w+(?:\.\w+)*[ \t]+(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
            lookbehind: !0,
            inside: {
              keyword: /^property/,
              property: /\w+(?:\.\w+)*/
            }
          }
        ],
        "javascript-expression": {
          pattern: RegExp(
            /(:[ \t]*)(?![\s;}[])(?:(?!$|[;}])<js>)+/.source.replace(
              /<js>/g,
              function() {
                return H;
              }
            ),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "language-javascript",
          inside: g.languages.javascript
        },
        string: {
          pattern: /"(?:\\.|[^\\"\r\n])*"/,
          greedy: !0
        },
        keyword: /\b(?:as|import|on)\b/,
        punctuation: /[{}[\]:;,]/
      };
    })(t);
  }
  return qml_1;
}
var qore_1, hasRequiredQore;
function requireQore() {
  if (hasRequiredQore) return qore_1;
  hasRequiredQore = 1, qore_1 = n, n.displayName = "qore", n.aliases = [];
  function n(t) {
    t.languages.qore = t.languages.extend("clike", {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:\/\/|#).*)/,
        lookbehind: !0
      },
      // Overridden to allow unescaped multi-line strings
      string: {
        pattern: /("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
        greedy: !0
      },
      keyword: /\b(?:abstract|any|assert|binary|bool|boolean|break|byte|case|catch|char|class|code|const|continue|data|default|do|double|else|enum|extends|final|finally|float|for|goto|hash|if|implements|import|inherits|instanceof|int|interface|long|my|native|new|nothing|null|object|our|own|private|reference|rethrow|return|short|soft(?:bool|date|float|int|list|number|string)|static|strictfp|string|sub|super|switch|synchronized|this|throw|throws|transient|try|void|volatile|while)\b/,
      boolean: /\b(?:false|true)\b/i,
      function: /\$?\b(?!\d)\w+(?=\()/,
      number: /\b(?:0b[01]+|0x(?:[\da-f]*\.)?[\da-fp\-]+|(?:\d+(?:\.\d+)?|\.\d+)(?:e\d+)?[df]|(?:\d+(?:\.\d+)?|\.\d+))\b/i,
      operator: {
        pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|[!=](?:==?|~)?|>>?=?|<(?:=>?|<=?)?|&[&=]?|\|[|=]?|[*\/%^]=?|[~?])/,
        lookbehind: !0
      },
      variable: /\$(?!\d)\w+\b/
    });
  }
  return qore_1;
}
var qsharp_1, hasRequiredQsharp;
function requireQsharp() {
  if (hasRequiredQsharp) return qsharp_1;
  hasRequiredQsharp = 1, qsharp_1 = n, n.displayName = "qsharp", n.aliases = ["qs"];
  function n(t) {
    (function(g) {
      function d(tA, oA) {
        return tA.replace(/<<(\d+)>>/g, function(EA, aA) {
          return "(?:" + oA[+aA] + ")";
        });
      }
      function k(tA, oA, EA) {
        return RegExp(d(tA, oA), "");
      }
      function H(tA, oA) {
        for (var EA = 0; EA < oA; EA++)
          tA = tA.replace(/<<self>>/g, function() {
            return "(?:" + tA + ")";
          });
        return tA.replace(/<<self>>/g, "[^\\s\\S]");
      }
      var AA = {
        // keywords which represent a return or variable type
        type: "Adj BigInt Bool Ctl Double false Int One Pauli PauliI PauliX PauliY PauliZ Qubit Range Result String true Unit Zero",
        // all other keywords
        other: "Adjoint adjoint apply as auto body borrow borrowing Controlled controlled distribute elif else fail fixup for function if in internal intrinsic invert is let mutable namespace new newtype open operation repeat return self set until use using while within"
      };
      function gA(tA) {
        return "\\b(?:" + tA.trim().replace(/ /g, "|") + ")\\b";
      }
      var IA = RegExp(
        gA(AA.type + " " + AA.other)
      ), CA = /\b[A-Za-z_]\w*\b/.source, BA = d(/<<0>>(?:\s*\.\s*<<0>>)*/.source, [CA]), eA = {
        keyword: IA,
        punctuation: /[<>()?,.:[\]]/
      }, iA = /"(?:\\.|[^\\"])*"/.source;
      g.languages.qsharp = g.languages.extend("clike", {
        comment: /\/\/.*/,
        string: [
          {
            pattern: k(/(^|[^$\\])<<0>>/.source, [iA]),
            lookbehind: !0,
            greedy: !0
          }
        ],
        "class-name": [
          {
            // open Microsoft.Quantum.Canon;
            // open Microsoft.Quantum.Canon as CN;
            pattern: k(/(\b(?:as|open)\s+)<<0>>(?=\s*(?:;|as\b))/.source, [
              BA
            ]),
            lookbehind: !0,
            inside: eA
          },
          {
            // namespace Quantum.App1;
            pattern: k(/(\bnamespace\s+)<<0>>(?=\s*\{)/.source, [BA]),
            lookbehind: !0,
            inside: eA
          }
        ],
        keyword: IA,
        number: /(?:\b0(?:x[\da-f]+|b[01]+|o[0-7]+)|(?:\B\.\d+|\b\d+(?:\.\d*)?)(?:e[-+]?\d+)?)l?\b/i,
        operator: /\band=|\bor=|\band\b|\bnot\b|\bor\b|<[-=]|[-=]>|>>>=?|<<<=?|\^\^\^=?|\|\|\|=?|&&&=?|w\/=?|~~~|[*\/+\-^=!%]=?/,
        punctuation: /::|[{}[\];(),.:]/
      }), g.languages.insertBefore("qsharp", "number", {
        range: {
          pattern: /\.\./,
          alias: "operator"
        }
      });
      var QA = H(
        d(/\{(?:[^"{}]|<<0>>|<<self>>)*\}/.source, [iA]),
        2
      );
      g.languages.insertBefore("qsharp", "string", {
        "interpolation-string": {
          pattern: k(/\$"(?:\\.|<<0>>|[^\\"{])*"/.source, [QA]),
          greedy: !0,
          inside: {
            interpolation: {
              pattern: k(/((?:^|[^\\])(?:\\\\)*)<<0>>/.source, [
                QA
              ]),
              lookbehind: !0,
              inside: {
                punctuation: /^\{|\}$/,
                expression: {
                  pattern: /[\s\S]+/,
                  alias: "language-qsharp",
                  inside: g.languages.qsharp
                }
              }
            },
            string: /[\s\S]+/
          }
        }
      });
    })(t), t.languages.qs = t.languages.qsharp;
  }
  return qsharp_1;
}
var r_1, hasRequiredR;
function requireR() {
  if (hasRequiredR) return r_1;
  hasRequiredR = 1, r_1 = n, n.displayName = "r", n.aliases = [];
  function n(t) {
    t.languages.r = {
      comment: /#.*/,
      string: {
        pattern: /(['"])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      "percent-operator": {
        // Includes user-defined operators
        // and %%, %*%, %/%, %in%, %o%, %x%
        pattern: /%[^%\s]*%/,
        alias: "operator"
      },
      boolean: /\b(?:FALSE|TRUE)\b/,
      ellipsis: /\.\.(?:\.|\d+)/,
      number: [
        /\b(?:Inf|NaN)\b/,
        /(?:\b0x[\dA-Fa-f]+(?:\.\d*)?|\b\d+(?:\.\d*)?|\B\.\d+)(?:[EePp][+-]?\d+)?[iL]?/
      ],
      keyword: /\b(?:NA|NA_character_|NA_complex_|NA_integer_|NA_real_|NULL|break|else|for|function|if|in|next|repeat|while)\b/,
      operator: /->?>?|<(?:=|<?-)?|[>=!]=?|::?|&&?|\|\|?|[+*\/^$@~]/,
      punctuation: /[(){}\[\],;]/
    };
  }
  return r_1;
}
var racket_1, hasRequiredRacket;
function requireRacket() {
  if (hasRequiredRacket) return racket_1;
  hasRequiredRacket = 1;
  var n = requireScheme();
  racket_1 = t, t.displayName = "racket", t.aliases = ["rkt"];
  function t(g) {
    g.register(n), g.languages.racket = g.languages.extend("scheme", {
      "lambda-parameter": {
        // the racket lambda syntax is a lot more complex, so we won't even attempt to capture it.
        // this will just prevent false positives of the `function` pattern
        pattern: /([(\[]lambda\s+[(\[])[^()\[\]'\s]+/,
        lookbehind: !0
      }
    }), g.languages.insertBefore("racket", "string", {
      lang: {
        pattern: /^#lang.+/m,
        greedy: !0,
        alias: "keyword"
      }
    }), g.languages.rkt = g.languages.racket;
  }
  return racket_1;
}
var reason_1, hasRequiredReason;
function requireReason() {
  if (hasRequiredReason) return reason_1;
  hasRequiredReason = 1, reason_1 = n, n.displayName = "reason", n.aliases = [];
  function n(t) {
    t.languages.reason = t.languages.extend("clike", {
      string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
        greedy: !0
      },
      // 'class-name' must be matched *after* 'constructor' defined below
      "class-name": /\b[A-Z]\w*/,
      keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
      operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
    }), t.languages.insertBefore("reason", "class-name", {
      char: {
        pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
        greedy: !0
      },
      // Negative look-ahead prevents from matching things like String.capitalize
      constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
      label: {
        pattern: /\b[a-z]\w*(?=::)/,
        alias: "symbol"
      }
    }), delete t.languages.reason.function;
  }
  return reason_1;
}
var regex_1, hasRequiredRegex;
function requireRegex() {
  if (hasRequiredRegex) return regex_1;
  hasRequiredRegex = 1, regex_1 = n, n.displayName = "regex", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = {
        pattern: /\\[\\(){}[\]^$+*?|.]/,
        alias: "escape"
      }, k = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, H = {
        pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
        alias: "class-name"
      }, AA = {
        pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
        alias: "class-name"
      }, gA = "(?:[^\\\\-]|" + k.source + ")", IA = RegExp(gA + "-" + gA), CA = {
        pattern: /(<|')[^<>']+(?=[>']$)/,
        lookbehind: !0,
        alias: "variable"
      };
      g.languages.regex = {
        "char-class": {
          pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
          lookbehind: !0,
          inside: {
            "char-class-negation": {
              pattern: /(^\[)\^/,
              lookbehind: !0,
              alias: "operator"
            },
            "char-class-punctuation": {
              pattern: /^\[|\]$/,
              alias: "punctuation"
            },
            range: {
              pattern: IA,
              inside: {
                escape: k,
                "range-punctuation": {
                  pattern: /-/,
                  alias: "operator"
                }
              }
            },
            "special-escape": d,
            "char-set": AA,
            escape: k
          }
        },
        "special-escape": d,
        "char-set": H,
        backreference: [
          {
            // a backreference which is not an octal escape
            pattern: /\\(?![123][0-7]{2})[1-9]/,
            alias: "keyword"
          },
          {
            pattern: /\\k<[^<>']+>/,
            alias: "keyword",
            inside: {
              "group-name": CA
            }
          }
        ],
        anchor: {
          pattern: /[$^]|\\[ABbGZz]/,
          alias: "function"
        },
        escape: k,
        group: [
          {
            // https://docs.oracle.com/javase/10/docs/api/java/util/regex/Pattern.html
            // https://docs.microsoft.com/en-us/dotnet/standard/base-types/regular-expression-language-quick-reference?view=netframework-4.7.2#grouping-constructs
            // (), (?<name>), (?'name'), (?>), (?:), (?=), (?!), (?<=), (?<!), (?is-m), (?i-m:)
            pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
            alias: "punctuation",
            inside: {
              "group-name": CA
            }
          },
          {
            pattern: /\)/,
            alias: "punctuation"
          }
        ],
        quantifier: {
          pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
          alias: "number"
        },
        alternation: {
          pattern: /\|/,
          alias: "keyword"
        }
      };
    })(t);
  }
  return regex_1;
}
var rego_1, hasRequiredRego;
function requireRego() {
  if (hasRequiredRego) return rego_1;
  hasRequiredRego = 1, rego_1 = n, n.displayName = "rego", n.aliases = [];
  function n(t) {
    t.languages.rego = {
      comment: /#.*/,
      property: {
        pattern: /(^|[^\\.])(?:"(?:\\.|[^\\"\r\n])*"|`[^`]*`|\b[a-z_]\w*\b)(?=\s*:(?!=))/i,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"|`[^`]*`/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /\b(?:as|default|else|import|not|null|package|set(?=\s*\()|some|with)\b/,
      boolean: /\b(?:false|true)\b/,
      function: {
        pattern: /\b[a-z_]\w*\b(?:\s*\.\s*\b[a-z_]\w*\b)*(?=\s*\()/i,
        inside: {
          namespace: /\b\w+\b(?=\s*\.)/,
          punctuation: /\./
        }
      },
      number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      operator: /[-+*/%|&]|[<>:=]=?|!=|\b_\b/,
      punctuation: /[,;.\[\]{}()]/
    };
  }
  return rego_1;
}
var renpy_1, hasRequiredRenpy;
function requireRenpy() {
  if (hasRequiredRenpy) return renpy_1;
  hasRequiredRenpy = 1, renpy_1 = n, n.displayName = "renpy", n.aliases = ["rpy"];
  function n(t) {
    t.languages.renpy = {
      comment: {
        pattern: /(^|[^\\])#.+/,
        lookbehind: !0
      },
      string: {
        pattern: /("""|''')[\s\S]+?\1|("|')(?:\\.|(?!\2)[^\\])*\2|(?:^#?(?:(?:[0-9a-fA-F]){3}|[0-9a-fA-F]{6})$)/m,
        greedy: !0
      },
      function: /\b[a-z_]\w*(?=\()/i,
      property: /\b(?:Update|UpdateVersion|action|activate_sound|adv_nvl_transition|after_load_transition|align|alpha|alt|anchor|antialias|area|auto|background|bar_invert|bar_resizing|bar_vertical|black_color|bold|bottom_bar|bottom_gutter|bottom_margin|bottom_padding|box_reverse|box_wrap|can_update|caret|child|color|crop|default_afm_enable|default_afm_time|default_fullscreen|default_text_cps|developer|directory_name|drag_handle|drag_joined|drag_name|drag_raise|draggable|dragged|drop_shadow|drop_shadow_color|droppable|dropped|easein|easeout|edgescroll|end_game_transition|end_splash_transition|enter_replay_transition|enter_sound|enter_transition|enter_yesno_transition|executable_name|exit_replay_transition|exit_sound|exit_transition|exit_yesno_transition|fadein|fadeout|first_indent|first_spacing|fit_first|focus|focus_mask|font|foreground|game_main_transition|get_installed_packages|google_play_key|google_play_salt|ground|has_music|has_sound|has_voice|height|help|hinting|hover|hover_background|hover_color|hover_sound|hovered|hyperlink_functions|idle|idle_color|image_style|include_update|insensitive|insensitive_background|insensitive_color|inside|intra_transition|italic|justify|kerning|keyboard_focus|language|layer_clipping|layers|layout|left_bar|left_gutter|left_margin|left_padding|length|line_leading|line_overlap_split|line_spacing|linear|main_game_transition|main_menu_music|maximum|min_width|minimum|minwidth|modal|mouse|mousewheel|name|narrator_menu|newline_indent|nvl_adv_transition|offset|order_reverse|outlines|overlay_functions|pos|position|prefix|radius|range|rest_indent|right_bar|right_gutter|right_margin|right_padding|rotate|rotate_pad|ruby_style|sample_sound|save_directory|say_attribute_transition|screen_height|screen_width|scrollbars|selected_hover|selected_hover_color|selected_idle|selected_idle_color|selected_insensitive|show_side_image|show_two_window|side_spacing|side_xpos|side_ypos|size|size_group|slow_cps|slow_cps_multiplier|spacing|strikethrough|subpixel|text_align|text_style|text_xpos|text_y_fudge|text_ypos|thumb|thumb_offset|thumb_shadow|thumbnail_height|thumbnail_width|time|top_bar|top_gutter|top_margin|top_padding|translations|underline|unscrollable|update|value|version|version_name|version_tuple|vertical|width|window_hide_transition|window_icon|window_left_padding|window_show_transition|window_title|windows_icon|xadjustment|xalign|xanchor|xanchoraround|xaround|xcenter|xfill|xinitial|xmargin|xmaximum|xminimum|xoffset|xofsset|xpadding|xpos|xsize|xzoom|yadjustment|yalign|yanchor|yanchoraround|yaround|ycenter|yfill|yinitial|ymargin|ymaximum|yminimum|yoffset|ypadding|ypos|ysize|ysizexysize|yzoom|zoom|zorder)\b/,
      tag: /\b(?:bar|block|button|buttoscreenn|drag|draggroup|fixed|frame|grid|[hv]box|hotbar|hotspot|image|imagebutton|imagemap|input|key|label|menu|mm_menu_frame|mousearea|nvl|parallel|screen|self|side|tag|text|textbutton|timer|vbar|viewport|window)\b|\$/,
      keyword: /\b(?:None|add|adjustment|alignaround|allow|angle|animation|around|as|assert|behind|box_layout|break|build|cache|call|center|changed|child_size|choice|circles|class|clear|clicked|clipping|clockwise|config|contains|continue|corner1|corner2|counterclockwise|def|default|define|del|delay|disabled|disabled_text|dissolve|elif|else|event|except|exclude|exec|expression|fade|finally|for|from|function|global|gm_root|has|hide|id|if|import|in|init|is|jump|knot|lambda|left|less_rounded|mm_root|movie|music|null|on|onlayer|pass|pause|persistent|play|print|python|queue|raise|random|renpy|repeat|return|right|rounded_window|scene|scope|set|show|slow|slow_abortable|slow_done|sound|stop|store|style|style_group|substitute|suffix|theme|transform|transform_anchor|transpose|try|ui|unhovered|updater|use|voice|while|widget|widget_hover|widget_selected|widget_text|yield)\b/,
      boolean: /\b(?:[Ff]alse|[Tt]rue)\b/,
      number: /(?:\b(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?)|\B\.\d+)(?:e[+-]?\d+)?j?/i,
      operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:and|at|not|or|with)\b/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.rpy = t.languages.renpy;
  }
  return renpy_1;
}
var rest_1, hasRequiredRest;
function requireRest() {
  if (hasRequiredRest) return rest_1;
  hasRequiredRest = 1, rest_1 = n, n.displayName = "rest", n.aliases = [];
  function n(t) {
    t.languages.rest = {
      table: [
        {
          pattern: /(^[\t ]*)(?:\+[=-]+)+\+(?:\r?\n|\r)(?:\1[+|].+[+|](?:\r?\n|\r))+\1(?:\+[=-]+)+\+/m,
          lookbehind: !0,
          inside: {
            punctuation: /\||(?:\+[=-]+)+\+/
          }
        },
        {
          pattern: /(^[\t ]*)=+ [ =]*=(?:(?:\r?\n|\r)\1.+)+(?:\r?\n|\r)\1=+ [ =]*=(?=(?:\r?\n|\r){2}|\s*$)/m,
          lookbehind: !0,
          inside: {
            punctuation: /[=-]+/
          }
        }
      ],
      // Directive-like patterns
      "substitution-def": {
        pattern: /(^[\t ]*\.\. )\|(?:[^|\s](?:[^|]*[^|\s])?)\| [^:]+::/m,
        lookbehind: !0,
        inside: {
          substitution: {
            pattern: /^\|(?:[^|\s]|[^|\s][^|]*[^|\s])\|/,
            alias: "attr-value",
            inside: {
              punctuation: /^\||\|$/
            }
          },
          directive: {
            pattern: /( )(?! )[^:]+::/,
            lookbehind: !0,
            alias: "function",
            inside: {
              punctuation: /::$/
            }
          }
        }
      },
      "link-target": [
        {
          pattern: /(^[\t ]*\.\. )\[[^\]]+\]/m,
          lookbehind: !0,
          alias: "string",
          inside: {
            punctuation: /^\[|\]$/
          }
        },
        {
          pattern: /(^[\t ]*\.\. )_(?:`[^`]+`|(?:[^:\\]|\\.)+):/m,
          lookbehind: !0,
          alias: "string",
          inside: {
            punctuation: /^_|:$/
          }
        }
      ],
      directive: {
        pattern: /(^[\t ]*\.\. )[^:]+::/m,
        lookbehind: !0,
        alias: "function",
        inside: {
          punctuation: /::$/
        }
      },
      comment: {
        // The two alternatives try to prevent highlighting of blank comments
        pattern: /(^[\t ]*\.\.)(?:(?: .+)?(?:(?:\r?\n|\r).+)+| .+)(?=(?:\r?\n|\r){2}|$)/m,
        lookbehind: !0
      },
      title: [
        // Overlined and underlined
        {
          pattern: /^(([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+)(?:\r?\n|\r).+(?:\r?\n|\r)\1$/m,
          inside: {
            punctuation: /^[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+|[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
            important: /.+/
          }
        },
        // Underlined only
        {
          pattern: /(^|(?:\r?\n|\r){2}).+(?:\r?\n|\r)([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+(?=\r?\n|\r|$)/,
          lookbehind: !0,
          inside: {
            punctuation: /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
            important: /.+/
          }
        }
      ],
      hr: {
        pattern: /((?:\r?\n|\r){2})([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2{3,}(?=(?:\r?\n|\r){2})/,
        lookbehind: !0,
        alias: "punctuation"
      },
      field: {
        pattern: /(^[\t ]*):[^:\r\n]+:(?= )/m,
        lookbehind: !0,
        alias: "attr-name"
      },
      "command-line-option": {
        pattern: /(^[\t ]*)(?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?(?:, (?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?)*(?=(?:\r?\n|\r)? {2,}\S)/im,
        lookbehind: !0,
        alias: "symbol"
      },
      "literal-block": {
        pattern: /::(?:\r?\n|\r){2}([ \t]+)(?![ \t]).+(?:(?:\r?\n|\r)\1.+)*/,
        inside: {
          "literal-block-punctuation": {
            pattern: /^::/,
            alias: "punctuation"
          }
        }
      },
      "quoted-literal-block": {
        pattern: /::(?:\r?\n|\r){2}([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]).*(?:(?:\r?\n|\r)\1.*)*/,
        inside: {
          "literal-block-punctuation": {
            pattern: /^(?:::|([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\1*)/m,
            alias: "punctuation"
          }
        }
      },
      "list-bullet": {
        pattern: /(^[\t ]*)(?:[*+\-•‣⁃]|\(?(?:\d+|[a-z]|[ivxdclm]+)\)|(?:\d+|[a-z]|[ivxdclm]+)\.)(?= )/im,
        lookbehind: !0,
        alias: "punctuation"
      },
      "doctest-block": {
        pattern: /(^[\t ]*)>>> .+(?:(?:\r?\n|\r).+)*/m,
        lookbehind: !0,
        inside: {
          punctuation: /^>>>/
        }
      },
      inline: [
        {
          pattern: /(^|[\s\-:\/'"<(\[{])(?::[^:]+:`.*?`|`.*?`:[^:]+:|(\*\*?|``?|\|)(?!\s)(?:(?!\2).)*\S\2(?=[\s\-.,:;!?\\\/'")\]}]|$))/m,
          lookbehind: !0,
          inside: {
            bold: {
              pattern: /(^\*\*).+(?=\*\*$)/,
              lookbehind: !0
            },
            italic: {
              pattern: /(^\*).+(?=\*$)/,
              lookbehind: !0
            },
            "inline-literal": {
              pattern: /(^``).+(?=``$)/,
              lookbehind: !0,
              alias: "symbol"
            },
            role: {
              pattern: /^:[^:]+:|:[^:]+:$/,
              alias: "function",
              inside: {
                punctuation: /^:|:$/
              }
            },
            "interpreted-text": {
              pattern: /(^`).+(?=`$)/,
              lookbehind: !0,
              alias: "attr-value"
            },
            substitution: {
              pattern: /(^\|).+(?=\|$)/,
              lookbehind: !0,
              alias: "attr-value"
            },
            punctuation: /\*\*?|``?|\|/
          }
        }
      ],
      link: [
        {
          pattern: /\[[^\[\]]+\]_(?=[\s\-.,:;!?\\\/'")\]}]|$)/,
          alias: "string",
          inside: {
            punctuation: /^\[|\]_$/
          }
        },
        {
          pattern: /(?:\b[a-z\d]+(?:[_.:+][a-z\d]+)*_?_|`[^`]+`_?_|_`[^`]+`)(?=[\s\-.,:;!?\\\/'")\]}]|$)/i,
          alias: "string",
          inside: {
            punctuation: /^_?`|`$|`?_?_$/
          }
        }
      ],
      // Line block start,
      // quote attribution,
      // explicit markup start,
      // and anonymous hyperlink target shortcut (__)
      punctuation: {
        pattern: /(^[\t ]*)(?:\|(?= |$)|(?:---?|—|\.\.|__)(?= )|\.\.$)/m,
        lookbehind: !0
      }
    };
  }
  return rest_1;
}
var rip_1, hasRequiredRip;
function requireRip() {
  if (hasRequiredRip) return rip_1;
  hasRequiredRip = 1, rip_1 = n, n.displayName = "rip", n.aliases = [];
  function n(t) {
    t.languages.rip = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      char: {
        pattern: /\B`[^\s`'",.:;#\/\\()<>\[\]{}]\b/,
        greedy: !0
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      regex: {
        pattern: /(^|[^/])\/(?!\/)(?:\[[^\n\r\]]*\]|\\.|[^/\\\r\n\[])+\/(?=\s*(?:$|[\r\n,.;})]))/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /(?:=>|->)|\b(?:case|catch|class|else|exit|finally|if|raise|return|switch|try)\b/,
      builtin: /@|\bSystem\b/,
      boolean: /\b(?:false|true)\b/,
      date: /\b\d{4}-\d{2}-\d{2}\b/,
      time: /\b\d{2}:\d{2}:\d{2}\b/,
      datetime: /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\b/,
      symbol: /:[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/,
      number: /[+-]?\b(?:\d+\.\d+|\d+)\b/,
      punctuation: /(?:\.{2,3})|[`,.:;=\/\\()<>\[\]{}]/,
      reference: /[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/
    };
  }
  return rip_1;
}
var roboconf_1, hasRequiredRoboconf;
function requireRoboconf() {
  if (hasRequiredRoboconf) return roboconf_1;
  hasRequiredRoboconf = 1, roboconf_1 = n, n.displayName = "roboconf", n.aliases = [];
  function n(t) {
    t.languages.roboconf = {
      comment: /#.*/,
      keyword: {
        pattern: /(^|\s)(?:(?:external|import)\b|(?:facet|instance of)(?=[ \t]+[\w-]+[ \t]*\{))/,
        lookbehind: !0
      },
      component: {
        pattern: /[\w-]+(?=[ \t]*\{)/,
        alias: "variable"
      },
      property: /[\w.-]+(?=[ \t]*:)/,
      value: {
        pattern: /(=[ \t]*(?![ \t]))[^,;]+/,
        lookbehind: !0,
        alias: "attr-value"
      },
      optional: {
        pattern: /\(optional\)/,
        alias: "builtin"
      },
      wildcard: {
        pattern: /(\.)\*/,
        lookbehind: !0,
        alias: "operator"
      },
      punctuation: /[{},.;:=]/
    };
  }
  return roboconf_1;
}
var robotframework_1, hasRequiredRobotframework;
function requireRobotframework() {
  if (hasRequiredRobotframework) return robotframework_1;
  hasRequiredRobotframework = 1, robotframework_1 = n, n.displayName = "robotframework", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = {
        pattern: /(^[ \t]*| {2}|\t)#.*/m,
        lookbehind: !0,
        greedy: !0
      }, k = {
        pattern: /((?:^|[^\\])(?:\\{2})*)[$@&%]\{(?:[^{}\r\n]|\{[^{}\r\n]*\})*\}/,
        lookbehind: !0,
        inside: {
          punctuation: /^[$@&%]\{|\}$/
        }
      };
      function H(CA, BA) {
        var eA = {};
        eA["section-header"] = {
          pattern: /^ ?\*{3}.+?\*{3}/,
          alias: "keyword"
        };
        for (var iA in BA)
          eA[iA] = BA[iA];
        return eA.tag = {
          pattern: /([\r\n](?: {2}|\t)[ \t]*)\[[-\w]+\]/,
          lookbehind: !0,
          inside: {
            punctuation: /\[|\]/
          }
        }, eA.variable = k, eA.comment = d, {
          pattern: RegExp(
            /^ ?\*{3}[ \t]*<name>[ \t]*\*{3}(?:.|[\r\n](?!\*{3}))*/.source.replace(
              /<name>/g,
              function() {
                return CA;
              }
            ),
            "im"
          ),
          alias: "section",
          inside: eA
        };
      }
      var AA = {
        pattern: /(\[Documentation\](?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
        lookbehind: !0,
        alias: "string"
      }, gA = {
        pattern: /([\r\n] ?)(?!#)(?:\S(?:[ \t]\S)*)+/,
        lookbehind: !0,
        alias: "function",
        inside: {
          variable: k
        }
      }, IA = {
        pattern: /([\r\n](?: {2}|\t)[ \t]*)(?!\[|\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
        lookbehind: !0,
        inside: {
          variable: k
        }
      };
      g.languages.robotframework = {
        settings: H("Settings", {
          documentation: {
            pattern: /([\r\n] ?Documentation(?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
            lookbehind: !0,
            alias: "string"
          },
          property: {
            pattern: /([\r\n] ?)(?!\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: !0
          }
        }),
        variables: H("Variables"),
        "test-cases": H("Test Cases", {
          "test-name": gA,
          documentation: AA,
          property: IA
        }),
        keywords: H("Keywords", {
          "keyword-name": gA,
          documentation: AA,
          property: IA
        }),
        tasks: H("Tasks", {
          "task-name": gA,
          documentation: AA,
          property: IA
        }),
        comment: d
      }, g.languages.robot = g.languages.robotframework;
    })(t);
  }
  return robotframework_1;
}
var rust_1, hasRequiredRust;
function requireRust() {
  if (hasRequiredRust) return rust_1;
  hasRequiredRust = 1, rust_1 = n, n.displayName = "rust", n.aliases = [];
  function n(t) {
    (function(g) {
      for (var d = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, k = 0; k < 2; k++)
        d = d.replace(/<self>/g, function() {
          return d;
        });
      d = d.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
      }), g.languages.rust = {
        comment: [
          {
            pattern: RegExp(/(^|[^\\])/.source + d),
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        string: {
          pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
          greedy: !0
        },
        char: {
          pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
          greedy: !0
        },
        attribute: {
          pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
          greedy: !0,
          alias: "attr-name",
          inside: {
            string: null
            // see below
          }
        },
        // Closure params should not be confused with bitwise OR |
        "closure-params": {
          pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            "closure-punctuation": {
              pattern: /^\||\|$/,
              alias: "punctuation"
            },
            rest: null
            // see below
          }
        },
        "lifetime-annotation": {
          pattern: /'\w+/,
          alias: "symbol"
        },
        "fragment-specifier": {
          pattern: /(\$\w+:)[a-z]+/,
          lookbehind: !0,
          alias: "punctuation"
        },
        variable: /\$\w+/,
        "function-definition": {
          pattern: /(\bfn\s+)\w+/,
          lookbehind: !0,
          alias: "function"
        },
        "type-definition": {
          pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
          lookbehind: !0,
          alias: "class-name"
        },
        "module-declaration": [
          {
            pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
            lookbehind: !0,
            alias: "namespace"
          },
          {
            pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
            lookbehind: !0,
            alias: "namespace",
            inside: {
              punctuation: /::/
            }
          }
        ],
        keyword: [
          // https://github.com/rust-lang/reference/blob/master/src/keywords.md
          /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
          // primitives and str
          // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
          /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
        // and Rust's naming conventions recommend snake_case anyway.
        // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
        function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        macro: {
          pattern: /\b\w+!/,
          alias: "property"
        },
        constant: /\b[A-Z_][A-Z_\d]+\b/,
        "class-name": /\b[A-Z]\w*\b/,
        namespace: {
          pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
          inside: {
            punctuation: /::/
          }
        },
        // Hex, oct, bin, dec numbers with visual separators and type suffix
        number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        boolean: /\b(?:false|true)\b/,
        punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
      }, g.languages.rust["closure-params"].inside.rest = g.languages.rust, g.languages.rust.attribute.inside.string = g.languages.rust.string;
    })(t);
  }
  return rust_1;
}
var sas_1, hasRequiredSas;
function requireSas() {
  if (hasRequiredSas) return sas_1;
  hasRequiredSas = 1, sas_1 = n, n.displayName = "sas", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))/.source, k = /\b(?:\d[\da-f]*x|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i, H = {
        pattern: RegExp(d + "[bx]"),
        alias: "number"
      }, AA = {
        pattern: /&[a-z_]\w*/i
      }, gA = {
        pattern: /((?:^|\s|=|\())%(?:ABORT|BY|CMS|COPY|DISPLAY|DO|ELSE|END|EVAL|GLOBAL|GO|GOTO|IF|INC|INCLUDE|INDEX|INPUT|KTRIM|LENGTH|LET|LIST|LOCAL|PUT|QKTRIM|QSCAN|QSUBSTR|QSYSFUNC|QUPCASE|RETURN|RUN|SCAN|SUBSTR|SUPERQ|SYMDEL|SYMEXIST|SYMGLOBL|SYMLOCAL|SYSCALL|SYSEVALF|SYSEXEC|SYSFUNC|SYSGET|SYSRPUT|THEN|TO|TSO|UNQUOTE|UNTIL|UPCASE|WHILE|WINDOW)\b/i,
        lookbehind: !0,
        alias: "keyword"
      }, IA = {
        pattern: /(^|\s)(?:proc\s+\w+|data(?!=)|quit|run)\b/i,
        alias: "keyword",
        lookbehind: !0
      }, CA = [
        /\/\*[\s\S]*?\*\//,
        {
          pattern: /(^[ \t]*|;\s*)\*[^;]*;/m,
          lookbehind: !0
        }
      ], BA = {
        pattern: RegExp(d),
        greedy: !0
      }, eA = /[$%@.(){}\[\];,\\]/, iA = {
        pattern: /%?\b\w+(?=\()/,
        alias: "keyword"
      }, QA = {
        function: iA,
        "arg-value": {
          pattern: /(=\s*)[A-Z\.]+/i,
          lookbehind: !0
        },
        operator: /=/,
        "macro-variable": AA,
        arg: {
          pattern: /[A-Z]+/i,
          alias: "keyword"
        },
        number: k,
        "numeric-constant": H,
        punctuation: eA,
        string: BA
      }, tA = {
        pattern: /\b(?:format|put)\b=?[\w'$.]+/i,
        inside: {
          keyword: /^(?:format|put)(?==)/i,
          equals: /=/,
          format: {
            pattern: /(?:\w|\$\d)+\.\d?/,
            alias: "number"
          }
        }
      }, oA = {
        pattern: /\b(?:format|put)\s+[\w']+(?:\s+[$.\w]+)+(?=;)/i,
        inside: {
          keyword: /^(?:format|put)/i,
          format: {
            pattern: /[\w$]+\.\d?/,
            alias: "number"
          }
        }
      }, EA = {
        pattern: /((?:^|\s)=?)(?:catname|checkpoint execute_always|dm|endsas|filename|footnote|%include|libname|%list|lock|missing|options|page|resetline|%run|sasfile|skip|sysecho|title\d?)\b/i,
        lookbehind: !0,
        alias: "keyword"
      }, aA = {
        pattern: /(^|\s)(?:submit(?:\s+(?:load|norun|parseonly))?|endsubmit)\b/i,
        lookbehind: !0,
        alias: "keyword"
      }, nA = /aStore|accessControl|aggregation|audio|autotune|bayesianNetClassifier|bioMedImage|boolRule|builtins|cardinality|cdm|clustering|conditionalRandomFields|configuration|copula|countreg|dataDiscovery|dataPreprocess|dataSciencePilot|dataStep|decisionTree|deduplication|deepLearn|deepNeural|deepRnn|ds2|ecm|entityRes|espCluster|explainModel|factmac|fastKnn|fcmpact|fedSql|freqTab|gVarCluster|gam|gleam|graphSemiSupLearn|hiddenMarkovModel|hyperGroup|ica|image|iml|kernalPca|langModel|ldaTopic|loadStreams|mbc|mixed|mlTools|modelPublishing|network|neuralNet|nmf|nonParametricBayes|nonlinear|optNetwork|optimization|panel|pca|percentile|phreg|pls|qkb|qlim|quantreg|recommend|regression|reinforcementLearn|robustPca|ruleMining|sampling|sandwich|sccasl|search(?:Analytics)?|sentimentAnalysis|sequence|session(?:Prop)?|severity|simSystem|simple|smartData|sparkEmbeddedProcess|sparseML|spatialreg|spc|stabilityMonitoring|svDataDescription|svm|table|text(?:Filters|Frequency|Mining|Parse|Rule(?:Develop|Score)|Topic|Util)|timeData|transpose|tsInfo|tsReconcile|uniTimeSeries|varReduce/.source, lA = {
        pattern: RegExp(
          /(^|\s)(?:action\s+)?(?:<act>)\.[a-z]+\b[^;]+/.source.replace(
            /<act>/g,
            function() {
              return nA;
            }
          ),
          "i"
        ),
        lookbehind: !0,
        inside: {
          keyword: RegExp(
            /(?:<act>)\.[a-z]+\b/.source.replace(/<act>/g, function() {
              return nA;
            }),
            "i"
          ),
          action: {
            pattern: /(?:action)/i,
            alias: "keyword"
          },
          comment: CA,
          function: iA,
          "arg-value": QA["arg-value"],
          operator: QA.operator,
          argument: QA.arg,
          number: k,
          "numeric-constant": H,
          punctuation: eA,
          string: BA
        }
      }, cA = {
        pattern: /((?:^|\s)=?)(?:after|analysis|and|array|barchart|barwidth|begingraph|by|call|cas|cbarline|cfill|class(?:lev)?|close|column|computed?|contains|continue|data(?==)|define|delete|describe|document|do\s+over|do|dol|drop|dul|else|end(?:comp|source)?|entryTitle|eval(?:uate)?|exec(?:ute)?|exit|file(?:name)?|fill(?:attrs)?|flist|fnc|function(?:list)?|global|goto|group(?:by)?|headline|headskip|histogram|if|infile|keep|keylabel|keyword|label|layout|leave|legendlabel|length|libname|loadactionset|merge|midpoints|_?null_|name|noobs|nowd|ods|options|or|otherwise|out(?:put)?|over(?:lay)?|plot|print|put|raise|ranexp|rannor|rbreak|retain|return|select|session|sessref|set|source|statgraph|sum|summarize|table|temp|terminate|then\s+do|then|title\d?|to|var|when|where|xaxisopts|y2axisopts|yaxisopts)\b/i,
        lookbehind: !0
      };
      g.languages.sas = {
        datalines: {
          pattern: /^([ \t]*)(?:cards|(?:data)?lines);[\s\S]+?^[ \t]*;/im,
          lookbehind: !0,
          alias: "string",
          inside: {
            keyword: {
              pattern: /^(?:cards|(?:data)?lines)/i
            },
            punctuation: /;/
          }
        },
        "proc-sql": {
          pattern: /(^proc\s+(?:fed)?sql(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
          lookbehind: !0,
          inside: {
            sql: {
              pattern: RegExp(
                /^[ \t]*(?:select|alter\s+table|(?:create|describe|drop)\s+(?:index|table(?:\s+constraints)?|view)|create\s+unique\s+index|insert\s+into|update)(?:<str>|[^;"'])+;/.source.replace(
                  /<str>/g,
                  function() {
                    return d;
                  }
                ),
                "im"
              ),
              alias: "language-sql",
              inside: g.languages.sql
            },
            "global-statements": EA,
            "sql-statements": {
              pattern: /(^|\s)(?:disconnect\s+from|begin|commit|exec(?:ute)?|reset|rollback|validate)\b/i,
              lookbehind: !0,
              alias: "keyword"
            },
            number: k,
            "numeric-constant": H,
            punctuation: eA,
            string: BA
          }
        },
        "proc-groovy": {
          pattern: /(^proc\s+groovy(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
          lookbehind: !0,
          inside: {
            comment: CA,
            groovy: {
              pattern: RegExp(
                /(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(
                  /<str>/g,
                  function() {
                    return d;
                  }
                ),
                "im"
              ),
              lookbehind: !0,
              alias: "language-groovy",
              inside: g.languages.groovy
            },
            keyword: cA,
            "submit-statement": aA,
            "global-statements": EA,
            number: k,
            "numeric-constant": H,
            punctuation: eA,
            string: BA
          }
        },
        "proc-lua": {
          pattern: /(^proc\s+lua(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
          lookbehind: !0,
          inside: {
            comment: CA,
            lua: {
              pattern: RegExp(
                /(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(
                  /<str>/g,
                  function() {
                    return d;
                  }
                ),
                "im"
              ),
              lookbehind: !0,
              alias: "language-lua",
              inside: g.languages.lua
            },
            keyword: cA,
            "submit-statement": aA,
            "global-statements": EA,
            number: k,
            "numeric-constant": H,
            punctuation: eA,
            string: BA
          }
        },
        "proc-cas": {
          pattern: /(^proc\s+cas(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|quit|data);|(?![\s\S]))/im,
          lookbehind: !0,
          inside: {
            comment: CA,
            "statement-var": {
              pattern: /((?:^|\s)=?)saveresult\s[^;]+/im,
              lookbehind: !0,
              inside: {
                statement: {
                  pattern: /^saveresult\s+\S+/i,
                  inside: {
                    keyword: /^(?:saveresult)/i
                  }
                },
                rest: QA
              }
            },
            "cas-actions": lA,
            statement: {
              pattern: /((?:^|\s)=?)(?:default|(?:un)?set|on|output|upload)[^;]+/im,
              lookbehind: !0,
              inside: QA
            },
            step: IA,
            keyword: cA,
            function: iA,
            format: tA,
            altformat: oA,
            "global-statements": EA,
            number: k,
            "numeric-constant": H,
            punctuation: eA,
            string: BA
          }
        },
        "proc-args": {
          pattern: RegExp(
            /(^proc\s+\w+\s+)(?!\s)(?:[^;"']|<str>)+;/.source.replace(
              /<str>/g,
              function() {
                return d;
              }
            ),
            "im"
          ),
          lookbehind: !0,
          inside: QA
        },
        /*Special keywords within macros*/
        "macro-keyword": gA,
        "macro-variable": AA,
        "macro-string-functions": {
          pattern: /((?:^|\s|=))%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)\(.*?(?:[^%]\))/i,
          lookbehind: !0,
          inside: {
            function: {
              pattern: /%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)/i,
              alias: "keyword"
            },
            "macro-keyword": gA,
            "macro-variable": AA,
            "escaped-char": {
              pattern: /%['"()<>=¬^~;,#]/
            },
            punctuation: eA
          }
        },
        "macro-declaration": {
          pattern: /^%macro[^;]+(?=;)/im,
          inside: {
            keyword: /%macro/i
          }
        },
        "macro-end": {
          pattern: /^%mend[^;]+(?=;)/im,
          inside: {
            keyword: /%mend/i
          }
        },
        /*%_zscore(headcir, _lhc, _mhc, _shc, headcz, headcpct, _Fheadcz); */
        macro: {
          pattern: /%_\w+(?=\()/,
          alias: "keyword"
        },
        input: {
          pattern: /\binput\s[-\w\s/*.$&]+;/i,
          inside: {
            input: {
              alias: "keyword",
              pattern: /^input/i
            },
            comment: CA,
            number: k,
            "numeric-constant": H
          }
        },
        "options-args": {
          pattern: /(^options)[-'"|/\\<>*+=:()\w\s]*(?=;)/im,
          lookbehind: !0,
          inside: QA
        },
        "cas-actions": lA,
        comment: CA,
        function: iA,
        format: tA,
        altformat: oA,
        "numeric-constant": H,
        datetime: {
          // '1jan2013'd, '9:25:19pm't, '18jan2003:9:27:05am'dt
          pattern: RegExp(d + "(?:dt?|t)"),
          alias: "number"
        },
        string: BA,
        step: IA,
        keyword: cA,
        // In SAS Studio syntax highlighting, these operators are styled like keywords
        "operator-keyword": {
          pattern: /\b(?:eq|ge|gt|in|le|lt|ne|not)\b/i,
          alias: "operator"
        },
        // Decimal (1.2e23), hexadecimal (0c1x)
        number: k,
        operator: /\*\*?|\|\|?|!!?|¦¦?|<[>=]?|>[<=]?|[-+\/=&]|[~¬^]=?/,
        punctuation: eA
      };
    })(t);
  }
  return sas_1;
}
var sass_1, hasRequiredSass;
function requireSass() {
  if (hasRequiredSass) return sass_1;
  hasRequiredSass = 1, sass_1 = n, n.displayName = "sass", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.sass = g.languages.extend("css", {
        // Sass comments don't need to be closed, only indented
        comment: {
          pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t].+)*/m,
          lookbehind: !0,
          greedy: !0
        }
      }), g.languages.insertBefore("sass", "atrule", {
        // We want to consume the whole line
        "atrule-line": {
          // Includes support for = and + shortcuts
          pattern: /^(?:[ \t]*)[@+=].+/m,
          greedy: !0,
          inside: {
            atrule: /(?:@[\w-]+|[+=])/
          }
        }
      }), delete g.languages.sass.atrule;
      var d = /\$[-\w]+|#\{\$[-\w]+\}/, k = [
        /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|not|or)\b/,
        {
          pattern: /(\s)-(?=\s)/,
          lookbehind: !0
        }
      ];
      g.languages.insertBefore("sass", "property", {
        // We want to consume the whole line
        "variable-line": {
          pattern: /^[ \t]*\$.+/m,
          greedy: !0,
          inside: {
            punctuation: /:/,
            variable: d,
            operator: k
          }
        },
        // We want to consume the whole line
        "property-line": {
          pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s].*)/m,
          greedy: !0,
          inside: {
            property: [
              /[^:\s]+(?=\s*:)/,
              {
                pattern: /(:)[^:\s]+/,
                lookbehind: !0
              }
            ],
            punctuation: /:/,
            variable: d,
            operator: k,
            important: g.languages.sass.important
          }
        }
      }), delete g.languages.sass.property, delete g.languages.sass.important, g.languages.insertBefore("sass", "punctuation", {
        selector: {
          pattern: /^([ \t]*)\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*)*/m,
          lookbehind: !0,
          greedy: !0
        }
      });
    })(t);
  }
  return sass_1;
}
var scala_1, hasRequiredScala;
function requireScala() {
  if (hasRequiredScala) return scala_1;
  hasRequiredScala = 1;
  var n = requireJava();
  scala_1 = t, t.displayName = "scala", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.scala = g.languages.extend("java", {
      "triple-quoted-string": {
        pattern: /"""[\s\S]*?"""/,
        greedy: !0,
        alias: "string"
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      keyword: /<-|=>|\b(?:abstract|case|catch|class|def|do|else|extends|final|finally|for|forSome|if|implicit|import|lazy|match|new|null|object|override|package|private|protected|return|sealed|self|super|this|throw|trait|try|type|val|var|while|with|yield)\b/,
      number: /\b0x(?:[\da-f]*\.)?[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e\d+)?[dfl]?/i,
      builtin: /\b(?:Any|AnyRef|AnyVal|Boolean|Byte|Char|Double|Float|Int|Long|Nothing|Short|String|Unit)\b/,
      symbol: /'[^\d\s\\]\w*/
    }), g.languages.insertBefore("scala", "triple-quoted-string", {
      "string-interpolation": {
        pattern: /\b[a-z]\w*(?:"""(?:[^$]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*?"""|"(?:[^$"\r\n]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*")/i,
        greedy: !0,
        inside: {
          id: {
            pattern: /^\w+/,
            greedy: !0,
            alias: "function"
          },
          escape: {
            pattern: /\\\$"|\$[$"]/,
            greedy: !0,
            alias: "symbol"
          },
          interpolation: {
            pattern: /\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
            greedy: !0,
            inside: {
              punctuation: /^\$\{?|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                inside: g.languages.scala
              }
            }
          },
          string: /[\s\S]+/
        }
      }
    }), delete g.languages.scala["class-name"], delete g.languages.scala.function;
  }
  return scala_1;
}
var scss_1, hasRequiredScss;
function requireScss() {
  if (hasRequiredScss) return scss_1;
  hasRequiredScss = 1, scss_1 = n, n.displayName = "scss", n.aliases = [];
  function n(t) {
    t.languages.scss = t.languages.extend("css", {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: !0
      },
      atrule: {
        pattern: /@[\w-](?:\([^()]+\)|[^()\s]|\s+(?!\s))*?(?=\s+[{;])/,
        inside: {
          rule: /@[\w-]+/
          // See rest below
        }
      },
      // url, compassified
      url: /(?:[-a-z]+-)?url(?=\()/i,
      // CSS selector regex is not appropriate for Sass
      // since there can be lot more things (var, @ directive, nesting..)
      // a selector must start at the end of a property or after a brace (end of other rules or nesting)
      // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
      // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
      // can "pass" as a selector- e.g: proper#{$erty})
      // this one was hard to do, so please be careful if you edit this one :)
      selector: {
        // Initial look-ahead is used to prevent matching of blank selectors
        pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()\s]|\s+(?!\s)|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}][^:{}]*[:{][^}]))/,
        inside: {
          parent: {
            pattern: /&/,
            alias: "important"
          },
          placeholder: /%[-\w]+/,
          variable: /\$[-\w]+|#\{\$[-\w]+\}/
        }
      },
      property: {
        pattern: /(?:[-\w]|\$[-\w]|#\{\$[-\w]+\})+(?=\s*:)/,
        inside: {
          variable: /\$[-\w]+|#\{\$[-\w]+\}/
        }
      }
    }), t.languages.insertBefore("scss", "atrule", {
      keyword: [
        /@(?:content|debug|each|else(?: if)?|extend|for|forward|function|if|import|include|mixin|return|use|warn|while)\b/i,
        {
          pattern: /( )(?:from|through)(?= )/,
          lookbehind: !0
        }
      ]
    }), t.languages.insertBefore("scss", "important", {
      // var and interpolated vars
      variable: /\$[-\w]+|#\{\$[-\w]+\}/
    }), t.languages.insertBefore("scss", "function", {
      "module-modifier": {
        pattern: /\b(?:as|hide|show|with)\b/i,
        alias: "keyword"
      },
      placeholder: {
        pattern: /%[-\w]+/,
        alias: "selector"
      },
      statement: {
        pattern: /\B!(?:default|optional)\b/i,
        alias: "keyword"
      },
      boolean: /\b(?:false|true)\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword"
      },
      operator: {
        pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|not|or)(?=\s)/,
        lookbehind: !0
      }
    }), t.languages.scss.atrule.inside.rest = t.languages.scss;
  }
  return scss_1;
}
var shellSession_1, hasRequiredShellSession;
function requireShellSession() {
  if (hasRequiredShellSession) return shellSession_1;
  hasRequiredShellSession = 1;
  var n = requireBash();
  shellSession_1 = t, t.displayName = "shellSession", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      var k = [
        // normal string
        /"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/.source,
        /'[^']*'/.source,
        /\$'(?:[^'\\]|\\[\s\S])*'/.source,
        // here doc
        // 2 capturing groups
        /<<-?\s*(["']?)(\w+)\1\s[\s\S]*?[\r\n]\2/.source
      ].join("|");
      d.languages["shell-session"] = {
        command: {
          pattern: RegExp(
            // user info
            /^/.source + "(?:" + // <user> ":" ( <path> )?
            (/[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+(?::[^\0-\x1F$#%*?"<>:;|]+)?/.source + "|" + // <path>
            // Since the path pattern is quite general, we will require it to start with a special character to
            // prevent false positives.
            /[/~.][^\0-\x1F$#%*?"<>@:;|]*/.source) + ")?" + // shell symbol
            /[$#%](?=\s)/.source + // bash command
            /(?:[^\\\r\n \t'"<$]|[ \t](?:(?!#)|#.*$)|\\(?:[^\r]|\r\n?)|\$(?!')|<(?!<)|<<str>>)+/.source.replace(
              /<<str>>/g,
              function() {
                return k;
              }
            ),
            "m"
          ),
          greedy: !0,
          inside: {
            info: {
              // foo@bar:~/files$ exit
              // foo@bar$ exit
              // ~/files$ exit
              pattern: /^[^#$%]+/,
              alias: "punctuation",
              inside: {
                user: /^[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+/,
                punctuation: /:/,
                path: /[\s\S]+/
              }
            },
            bash: {
              pattern: /(^[$#%]\s*)\S[\s\S]*/,
              lookbehind: !0,
              alias: "language-bash",
              inside: d.languages.bash
            },
            "shell-symbol": {
              pattern: /^[$#%]/,
              alias: "important"
            }
          }
        },
        output: /.(?:.*(?:[\r\n]|.$))*/
      }, d.languages["sh-session"] = d.languages.shellsession = d.languages["shell-session"];
    })(g);
  }
  return shellSession_1;
}
var smali_1, hasRequiredSmali;
function requireSmali() {
  if (hasRequiredSmali) return smali_1;
  hasRequiredSmali = 1, smali_1 = n, n.displayName = "smali", n.aliases = [];
  function n(t) {
    t.languages.smali = {
      comment: /#.*/,
      string: {
        pattern: /"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\(?:.|u[\da-fA-F]{4}))'/,
        greedy: !0
      },
      "class-name": {
        pattern: /(^|[^L])L(?:(?:\w+|`[^`\r\n]*`)\/)*(?:[\w$]+|`[^`\r\n]*`)(?=\s*;)/,
        lookbehind: !0,
        inside: {
          "class-name": {
            pattern: /(^L|\/)(?:[\w$]+|`[^`\r\n]*`)$/,
            lookbehind: !0
          },
          namespace: {
            pattern: /^(L)(?:(?:\w+|`[^`\r\n]*`)\/)+/,
            lookbehind: !0,
            inside: {
              punctuation: /\//
            }
          },
          builtin: /^L/
        }
      },
      builtin: [
        {
          // Reference: https://github.com/JesusFreke/smali/wiki/TypesMethodsAndFields#types
          pattern: /([();\[])[BCDFIJSVZ]+/,
          lookbehind: !0
        },
        {
          // e.g. .field mWifiOnUid:I
          pattern: /([\w$>]:)[BCDFIJSVZ]/,
          lookbehind: !0
        }
      ],
      keyword: [
        {
          pattern: /(\.end\s+)[\w-]+/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\w.-])\.(?!\d)[\w-]+/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\w.-])(?:abstract|annotation|bridge|constructor|enum|final|interface|private|protected|public|runtime|static|synthetic|system|transient)(?![\w.-])/,
          lookbehind: !0
        }
      ],
      function: {
        pattern: /(^|[^\w.-])(?:\w+|<[\w$-]+>)(?=\()/,
        lookbehind: !0
      },
      field: {
        pattern: /[\w$]+(?=:)/,
        alias: "variable"
      },
      register: {
        pattern: /(^|[^\w.-])[vp]\d(?![\w.-])/,
        lookbehind: !0,
        alias: "variable"
      },
      boolean: {
        pattern: /(^|[^\w.-])(?:false|true)(?![\w.-])/,
        lookbehind: !0
      },
      number: {
        pattern: /(^|[^/\w.-])-?(?:NAN|INFINITY|0x(?:[\dA-F]+(?:\.[\dA-F]*)?|\.[\dA-F]+)(?:p[+-]?[\dA-F]+)?|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)[dflst]?(?![\w.-])/i,
        lookbehind: !0
      },
      label: {
        pattern: /(:)\w+/,
        lookbehind: !0,
        alias: "property"
      },
      operator: /->|\.\.|[\[=]/,
      punctuation: /[{}(),;:]/
    };
  }
  return smali_1;
}
var smalltalk_1, hasRequiredSmalltalk;
function requireSmalltalk() {
  if (hasRequiredSmalltalk) return smalltalk_1;
  hasRequiredSmalltalk = 1, smalltalk_1 = n, n.displayName = "smalltalk", n.aliases = [];
  function n(t) {
    t.languages.smalltalk = {
      comment: {
        pattern: /"(?:""|[^"])*"/,
        greedy: !0
      },
      char: {
        pattern: /\$./,
        greedy: !0
      },
      string: {
        pattern: /'(?:''|[^'])*'/,
        greedy: !0
      },
      symbol: /#[\da-z]+|#(?:-|([+\/\\*~<>=@%|&?!])\1?)|#(?=\()/i,
      "block-arguments": {
        pattern: /(\[\s*):[^\[|]*\|/,
        lookbehind: !0,
        inside: {
          variable: /:[\da-z]+/i,
          punctuation: /\|/
        }
      },
      "temporary-variables": {
        pattern: /\|[^|]+\|/,
        inside: {
          variable: /[\da-z]+/i,
          punctuation: /\|/
        }
      },
      keyword: /\b(?:new|nil|self|super)\b/,
      boolean: /\b(?:false|true)\b/,
      number: [
        /\d+r-?[\dA-Z]+(?:\.[\dA-Z]+)?(?:e-?\d+)?/,
        /\b\d+(?:\.\d+)?(?:e-?\d+)?/
      ],
      operator: /[<=]=?|:=|~[~=]|\/\/?|\\\\|>[>=]?|[!^+\-*&|,@]/,
      punctuation: /[.;:?\[\](){}]/
    };
  }
  return smalltalk_1;
}
var smarty_1, hasRequiredSmarty;
function requireSmarty() {
  if (hasRequiredSmarty) return smarty_1;
  hasRequiredSmarty = 1;
  var n = requireMarkupTemplating();
  smarty_1 = t, t.displayName = "smarty", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      d.languages.smarty = {
        comment: {
          pattern: /^\{\*[\s\S]*?\*\}/,
          greedy: !0
        },
        "embedded-php": {
          pattern: /^\{php\}[\s\S]*?\{\/php\}/,
          greedy: !0,
          inside: {
            smarty: {
              pattern: /^\{php\}|\{\/php\}$/,
              inside: null
              // see below
            },
            php: {
              pattern: /[\s\S]+/,
              alias: "language-php",
              inside: d.languages.php
            }
          }
        },
        string: [
          {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: !0,
            inside: {
              interpolation: {
                pattern: /\{[^{}]*\}|`[^`]*`/,
                inside: {
                  "interpolation-punctuation": {
                    pattern: /^[{`]|[`}]$/,
                    alias: "punctuation"
                  },
                  expression: {
                    pattern: /[\s\S]+/,
                    inside: null
                    // see below
                  }
                }
              },
              variable: /\$\w+/
            }
          },
          {
            pattern: /'(?:\\.|[^'\\\r\n])*'/,
            greedy: !0
          }
        ],
        keyword: {
          pattern: /(^\{\/?)[a-z_]\w*\b(?!\()/i,
          lookbehind: !0,
          greedy: !0
        },
        delimiter: {
          pattern: /^\{\/?|\}$/,
          greedy: !0,
          alias: "punctuation"
        },
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        variable: [
          /\$(?!\d)\w+/,
          /#(?!\d)\w+#/,
          {
            pattern: /(\.|->|\w\s*=)(?!\d)\w+\b(?!\()/,
            lookbehind: !0
          },
          {
            pattern: /(\[)(?!\d)\w+(?=\])/,
            lookbehind: !0
          }
        ],
        function: {
          pattern: /(\|\s*)@?[a-z_]\w*|\b[a-z_]\w*(?=\()/i,
          lookbehind: !0
        },
        "attr-name": /\b[a-z_]\w*(?=\s*=)/i,
        boolean: /\b(?:false|no|off|on|true|yes)\b/,
        punctuation: /[\[\](){}.,:`]|->/,
        operator: [
          /[+\-*\/%]|==?=?|[!<>]=?|&&|\|\|?/,
          /\bis\s+(?:not\s+)?(?:div|even|odd)(?:\s+by)?\b/,
          /\b(?:and|eq|gt?e|gt|lt?e|lt|mod|neq?|not|or)\b/
        ]
      }, d.languages.smarty["embedded-php"].inside.smarty.inside = d.languages.smarty, d.languages.smarty.string[0].inside.interpolation.inside.expression.inside = d.languages.smarty;
      var k = /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/, H = RegExp(
        // comments
        /\{\*[\s\S]*?\*\}/.source + "|" + // php tags
        /\{php\}[\s\S]*?\{\/php\}/.source + "|" + // smarty blocks
        /\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>)*\})*\})*\}/.source.replace(
          /<str>/g,
          function() {
            return k.source;
          }
        ),
        "g"
      );
      d.hooks.add("before-tokenize", function(AA) {
        var gA = "{literal}", IA = "{/literal}", CA = !1;
        d.languages["markup-templating"].buildPlaceholders(
          AA,
          "smarty",
          H,
          function(BA) {
            return BA === IA && (CA = !1), CA ? !1 : (BA === gA && (CA = !0), !0);
          }
        );
      }), d.hooks.add("after-tokenize", function(AA) {
        d.languages["markup-templating"].tokenizePlaceholders(AA, "smarty");
      });
    })(g);
  }
  return smarty_1;
}
var sml_1, hasRequiredSml;
function requireSml() {
  if (hasRequiredSml) return sml_1;
  hasRequiredSml = 1, sml_1 = n, n.displayName = "sml", n.aliases = ["smlnj"];
  function n(t) {
    (function(g) {
      var d = /\b(?:abstype|and|andalso|as|case|datatype|do|else|end|eqtype|exception|fn|fun|functor|handle|if|in|include|infix|infixr|let|local|nonfix|of|op|open|orelse|raise|rec|sharing|sig|signature|struct|structure|then|type|val|where|while|with|withtype)\b/i;
      g.languages.sml = {
        // allow one level of nesting
        comment: /\(\*(?:[^*(]|\*(?!\))|\((?!\*)|\(\*(?:[^*(]|\*(?!\))|\((?!\*))*\*\))*\*\)/,
        string: {
          pattern: /#?"(?:[^"\\]|\\.)*"/,
          greedy: !0
        },
        "class-name": [
          {
            // This is only an approximation since the real grammar is context-free
            //
            // Why the main loop so complex?
            // The main loop is approximately the same as /(?:\s*(?:[*,]|->)\s*<TERMINAL>)*/ which is, obviously, a lot
            // simpler. The difference is that if a comma is the last iteration of the loop, then the terminal must be
            // followed by a long identifier.
            pattern: RegExp(
              /((?:^|[^:]):\s*)<TERMINAL>(?:\s*(?:(?:\*|->)\s*<TERMINAL>|,\s*<TERMINAL>(?:(?=<NOT-LAST>)|(?!<NOT-LAST>)\s+<LONG-ID>)))*/.source.replace(/<NOT-LAST>/g, function() {
                return /\s*(?:[*,]|->)/.source;
              }).replace(/<TERMINAL>/g, function() {
                return /(?:'[\w']*|<LONG-ID>|\((?:[^()]|\([^()]*\))*\)|\{(?:[^{}]|\{[^{}]*\})*\})(?:\s+<LONG-ID>)*/.source;
              }).replace(/<LONG-ID>/g, function() {
                return /(?!<KEYWORD>)[a-z\d_][\w'.]*/.source;
              }).replace(/<KEYWORD>/g, function() {
                return d.source;
              }),
              "i"
            ),
            lookbehind: !0,
            greedy: !0,
            inside: null
            // see below
          },
          {
            pattern: /((?:^|[^\w'])(?:datatype|exception|functor|signature|structure|type)\s+)[a-z_][\w'.]*/i,
            lookbehind: !0
          }
        ],
        function: {
          pattern: /((?:^|[^\w'])fun\s+)[a-z_][\w'.]*/i,
          lookbehind: !0
        },
        keyword: d,
        variable: {
          pattern: /(^|[^\w'])'[\w']*/,
          lookbehind: !0
        },
        number: /~?\b(?:\d+(?:\.\d+)?(?:e~?\d+)?|0x[\da-f]+)\b/i,
        word: {
          pattern: /\b0w(?:\d+|x[\da-f]+)\b/i,
          alias: "constant"
        },
        boolean: /\b(?:false|true)\b/i,
        operator: /\.\.\.|:[>=:]|=>?|->|[<>]=?|[!+\-*/^#|@~]/,
        punctuation: /[(){}\[\].:,;]/
      }, g.languages.sml["class-name"][0].inside = g.languages.sml, g.languages.smlnj = g.languages.sml;
    })(t);
  }
  return sml_1;
}
var solidity_1, hasRequiredSolidity;
function requireSolidity() {
  if (hasRequiredSolidity) return solidity_1;
  hasRequiredSolidity = 1, solidity_1 = n, n.displayName = "solidity", n.aliases = ["sol"];
  function n(t) {
    t.languages.solidity = t.languages.extend("clike", {
      "class-name": {
        pattern: /(\b(?:contract|enum|interface|library|new|struct|using)\s+)(?!\d)[\w$]+/,
        lookbehind: !0
      },
      keyword: /\b(?:_|anonymous|as|assembly|assert|break|calldata|case|constant|constructor|continue|contract|default|delete|do|else|emit|enum|event|external|for|from|function|if|import|indexed|inherited|interface|internal|is|let|library|mapping|memory|modifier|new|payable|pragma|private|public|pure|require|returns?|revert|selfdestruct|solidity|storage|struct|suicide|switch|this|throw|using|var|view|while)\b/,
      operator: /=>|->|:=|=:|\*\*|\+\+|--|\|\||&&|<<=?|>>=?|[-+*/%^&|<>!=]=?|[~?]/
    }), t.languages.insertBefore("solidity", "keyword", {
      builtin: /\b(?:address|bool|byte|u?int(?:8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?|string|bytes(?:[1-9]|[12]\d|3[0-2])?)\b/
    }), t.languages.insertBefore("solidity", "number", {
      version: {
        pattern: /([<>]=?|\^)\d+\.\d+\.\d+\b/,
        lookbehind: !0,
        alias: "number"
      }
    }), t.languages.sol = t.languages.solidity;
  }
  return solidity_1;
}
var solutionFile_1, hasRequiredSolutionFile;
function requireSolutionFile() {
  if (hasRequiredSolutionFile) return solutionFile_1;
  hasRequiredSolutionFile = 1, solutionFile_1 = n, n.displayName = "solutionFile", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = {
        // https://en.wikipedia.org/wiki/Universally_unique_identifier#Format
        pattern: /\{[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}\}/i,
        alias: "constant",
        inside: {
          punctuation: /[{}]/
        }
      };
      g.languages["solution-file"] = {
        comment: {
          pattern: /#.*/,
          greedy: !0
        },
        string: {
          pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
          greedy: !0,
          inside: {
            guid: d
          }
        },
        object: {
          // Foo
          //   Bar("abs") = 9
          //   EndBar
          //   Prop = TRUE
          // EndFoo
          pattern: /^([ \t]*)(?:([A-Z]\w*)\b(?=.*(?:\r\n?|\n)(?:\1[ \t].*(?:\r\n?|\n))*\1End\2(?=[ \t]*$))|End[A-Z]\w*(?=[ \t]*$))/m,
          lookbehind: !0,
          greedy: !0,
          alias: "keyword"
        },
        property: {
          pattern: /^([ \t]*)(?!\s)[^\r\n"#=()]*[^\s"#=()](?=\s*=)/m,
          lookbehind: !0,
          inside: {
            guid: d
          }
        },
        guid: d,
        number: /\b\d+(?:\.\d+)*\b/,
        boolean: /\b(?:FALSE|TRUE)\b/,
        operator: /=/,
        punctuation: /[(),]/
      }, g.languages.sln = g.languages["solution-file"];
    })(t);
  }
  return solutionFile_1;
}
var soy_1, hasRequiredSoy;
function requireSoy() {
  if (hasRequiredSoy) return soy_1;
  hasRequiredSoy = 1;
  var n = requireMarkupTemplating();
  soy_1 = t, t.displayName = "soy", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      var k = /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, H = /\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-F]+\b/;
      d.languages.soy = {
        comment: [
          /\/\*[\s\S]*?\*\//,
          {
            pattern: /(\s)\/\/.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        "command-arg": {
          pattern: /(\{+\/?\s*(?:alias|call|delcall|delpackage|deltemplate|namespace|template)\s+)\.?[\w.]+/,
          lookbehind: !0,
          alias: "string",
          inside: {
            punctuation: /\./
          }
        },
        parameter: {
          pattern: /(\{+\/?\s*@?param\??\s+)\.?[\w.]+/,
          lookbehind: !0,
          alias: "variable"
        },
        keyword: [
          {
            pattern: /(\{+\/?[^\S\r\n]*)(?:\\[nrt]|alias|call|case|css|default|delcall|delpackage|deltemplate|else(?:if)?|fallbackmsg|for(?:each)?|if(?:empty)?|lb|let|literal|msg|namespace|nil|@?param\??|rb|sp|switch|template|xid)/,
            lookbehind: !0
          },
          /\b(?:any|as|attributes|bool|css|float|html|in|int|js|list|map|null|number|string|uri)\b/
        ],
        delimiter: {
          pattern: /^\{+\/?|\/?\}+$/,
          alias: "punctuation"
        },
        property: /\w+(?==)/,
        variable: {
          pattern: /\$[^\W\d]\w*(?:\??(?:\.\w+|\[[^\]]+\]))*/,
          inside: {
            string: {
              pattern: k,
              greedy: !0
            },
            number: H,
            punctuation: /[\[\].?]/
          }
        },
        string: {
          pattern: k,
          greedy: !0
        },
        function: [
          /\w+(?=\()/,
          {
            pattern: /(\|[^\S\r\n]*)\w+/,
            lookbehind: !0
          }
        ],
        boolean: /\b(?:false|true)\b/,
        number: H,
        operator: /\?:?|<=?|>=?|==?|!=|[+*/%-]|\b(?:and|not|or)\b/,
        punctuation: /[{}()\[\]|.,:]/
      }, d.hooks.add("before-tokenize", function(AA) {
        var gA = /\{\{.+?\}\}|\{.+?\}|\s\/\/.*|\/\*[\s\S]*?\*\//g, IA = "{literal}", CA = "{/literal}", BA = !1;
        d.languages["markup-templating"].buildPlaceholders(
          AA,
          "soy",
          gA,
          function(eA) {
            return eA === CA && (BA = !1), BA ? !1 : (eA === IA && (BA = !0), !0);
          }
        );
      }), d.hooks.add("after-tokenize", function(AA) {
        d.languages["markup-templating"].tokenizePlaceholders(AA, "soy");
      });
    })(g);
  }
  return soy_1;
}
var turtle_1, hasRequiredTurtle;
function requireTurtle() {
  if (hasRequiredTurtle) return turtle_1;
  hasRequiredTurtle = 1, turtle_1 = n, n.displayName = "turtle", n.aliases = [];
  function n(t) {
    t.languages.turtle = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      "multiline-string": {
        pattern: /"""(?:(?:""?)?(?:[^"\\]|\\.))*"""|'''(?:(?:''?)?(?:[^'\\]|\\.))*'''/,
        greedy: !0,
        alias: "string",
        inside: {
          comment: /#.*/
        }
      },
      string: {
        pattern: /"(?:[^\\"\r\n]|\\.)*"|'(?:[^\\'\r\n]|\\.)*'/,
        greedy: !0
      },
      url: {
        pattern: /<(?:[^\x00-\x20<>"{}|^`\\]|\\(?:u[\da-fA-F]{4}|U[\da-fA-F]{8}))*>/,
        greedy: !0,
        inside: {
          punctuation: /[<>]/
        }
      },
      function: {
        pattern: /(?:(?![-.\d\xB7])[-.\w\xB7\xC0-\uFFFD]+)?:(?:(?![-.])(?:[-.:\w\xC0-\uFFFD]|%[\da-f]{2}|\\.)+)?/i,
        inside: {
          "local-name": {
            pattern: /([^:]*:)[\s\S]+/,
            lookbehind: !0
          },
          prefix: {
            pattern: /[\s\S]+/,
            inside: {
              punctuation: /:/
            }
          }
        }
      },
      number: /[+-]?\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
      punctuation: /[{}.,;()[\]]|\^\^/,
      boolean: /\b(?:false|true)\b/,
      keyword: [/(?:\ba|@prefix|@base)\b|=/, /\b(?:base|graph|prefix)\b/i],
      tag: {
        pattern: /@[a-z]+(?:-[a-z\d]+)*/i,
        inside: {
          punctuation: /@/
        }
      }
    }, t.languages.trig = t.languages.turtle;
  }
  return turtle_1;
}
var sparql_1, hasRequiredSparql;
function requireSparql() {
  if (hasRequiredSparql) return sparql_1;
  hasRequiredSparql = 1;
  var n = requireTurtle();
  sparql_1 = t, t.displayName = "sparql", t.aliases = ["rq"];
  function t(g) {
    g.register(n), g.languages.sparql = g.languages.extend("turtle", {
      boolean: /\b(?:false|true)\b/i,
      variable: {
        pattern: /[?$]\w+/,
        greedy: !0
      }
    }), g.languages.insertBefore("sparql", "punctuation", {
      keyword: [
        /\b(?:A|ADD|ALL|AS|ASC|ASK|BNODE|BY|CLEAR|CONSTRUCT|COPY|CREATE|DATA|DEFAULT|DELETE|DESC|DESCRIBE|DISTINCT|DROP|EXISTS|FILTER|FROM|GROUP|HAVING|INSERT|INTO|LIMIT|LOAD|MINUS|MOVE|NAMED|NOT|NOW|OFFSET|OPTIONAL|ORDER|RAND|REDUCED|SELECT|SEPARATOR|SERVICE|SILENT|STRUUID|UNION|USING|UUID|VALUES|WHERE)\b/i,
        /\b(?:ABS|AVG|BIND|BOUND|CEIL|COALESCE|CONCAT|CONTAINS|COUNT|DATATYPE|DAY|ENCODE_FOR_URI|FLOOR|GROUP_CONCAT|HOURS|IF|IRI|isBLANK|isIRI|isLITERAL|isNUMERIC|isURI|LANG|LANGMATCHES|LCASE|MAX|MD5|MIN|MINUTES|MONTH|REGEX|REPLACE|ROUND|sameTerm|SAMPLE|SECONDS|SHA1|SHA256|SHA384|SHA512|STR|STRAFTER|STRBEFORE|STRDT|STRENDS|STRLANG|STRLEN|STRSTARTS|SUBSTR|SUM|TIMEZONE|TZ|UCASE|URI|YEAR)\b(?=\s*\()/i,
        /\b(?:BASE|GRAPH|PREFIX)\b/i
      ]
    }), g.languages.rq = g.languages.sparql;
  }
  return sparql_1;
}
var splunkSpl_1, hasRequiredSplunkSpl;
function requireSplunkSpl() {
  if (hasRequiredSplunkSpl) return splunkSpl_1;
  hasRequiredSplunkSpl = 1, splunkSpl_1 = n, n.displayName = "splunkSpl", n.aliases = [];
  function n(t) {
    t.languages["splunk-spl"] = {
      comment: /`comment\("(?:\\.|[^\\"])*"\)`/,
      string: {
        pattern: /"(?:\\.|[^\\"])*"/,
        greedy: !0
      },
      // https://docs.splunk.com/Documentation/Splunk/7.3.0/SearchReference/ListOfSearchCommands
      keyword: /\b(?:abstract|accum|addcoltotals|addinfo|addtotals|analyzefields|anomalies|anomalousvalue|anomalydetection|append|appendcols|appendcsv|appendlookup|appendpipe|arules|associate|audit|autoregress|bin|bucket|bucketdir|chart|cluster|cofilter|collect|concurrency|contingency|convert|correlate|datamodel|dbinspect|dedup|delete|delta|diff|erex|eval|eventcount|eventstats|extract|fieldformat|fields|fieldsummary|filldown|fillnull|findtypes|folderize|foreach|format|from|gauge|gentimes|geom|geomfilter|geostats|head|highlight|history|iconify|input|inputcsv|inputlookup|iplocation|join|kmeans|kv|kvform|loadjob|localize|localop|lookup|makecontinuous|makemv|makeresults|map|mcollect|metadata|metasearch|meventcollect|mstats|multikv|multisearch|mvcombine|mvexpand|nomv|outlier|outputcsv|outputlookup|outputtext|overlap|pivot|predict|rangemap|rare|regex|relevancy|reltime|rename|replace|rest|return|reverse|rex|rtorder|run|savedsearch|script|scrub|search|searchtxn|selfjoin|sendemail|set|setfields|sichart|sirare|sistats|sitimechart|sitop|sort|spath|stats|strcat|streamstats|table|tags|tail|timechart|timewrap|top|transaction|transpose|trendline|tscollect|tstats|typeahead|typelearner|typer|union|uniq|untable|where|x11|xmlkv|xmlunescape|xpath|xyseries)\b/i,
      "operator-word": {
        pattern: /\b(?:and|as|by|not|or|xor)\b/i,
        alias: "operator"
      },
      function: /\b\w+(?=\s*\()/,
      property: /\b\w+(?=\s*=(?!=))/,
      date: {
        // MM/DD/YYYY(:HH:MM:SS)?
        pattern: /\b\d{1,2}\/\d{1,2}\/\d{1,4}(?:(?::\d{1,2}){3})?\b/,
        alias: "number"
      },
      number: /\b\d+(?:\.\d+)?\b/,
      boolean: /\b(?:f|false|t|true)\b/i,
      operator: /[<>=]=?|[-+*/%|]/,
      punctuation: /[()[\],]/
    };
  }
  return splunkSpl_1;
}
var sqf_1, hasRequiredSqf;
function requireSqf() {
  if (hasRequiredSqf) return sqf_1;
  hasRequiredSqf = 1, sqf_1 = n, n.displayName = "sqf", n.aliases = [];
  function n(t) {
    t.languages.sqf = t.languages.extend("clike", {
      string: {
        pattern: /"(?:(?:"")?[^"])*"(?!")|'(?:[^'])*'/,
        greedy: !0
      },
      keyword: /\b(?:breakOut|breakTo|call|case|catch|default|do|echo|else|execFSM|execVM|exitWith|for|forEach|forEachMember|forEachMemberAgent|forEachMemberTeam|from|goto|if|nil|preprocessFile|preprocessFileLineNumbers|private|scopeName|spawn|step|switch|then|throw|to|try|while|with)\b/i,
      boolean: /\b(?:false|true)\b/i,
      function: /\b(?:abs|accTime|acos|action|actionIDs|actionKeys|actionKeysImages|actionKeysNames|actionKeysNamesArray|actionName|actionParams|activateAddons|activatedAddons|activateKey|add3DENConnection|add3DENEventHandler|add3DENLayer|addAction|addBackpack|addBackpackCargo|addBackpackCargoGlobal|addBackpackGlobal|addCamShake|addCuratorAddons|addCuratorCameraArea|addCuratorEditableObjects|addCuratorEditingArea|addCuratorPoints|addEditorObject|addEventHandler|addForce|addForceGeneratorRTD|addGoggles|addGroupIcon|addHandgunItem|addHeadgear|addItem|addItemCargo|addItemCargoGlobal|addItemPool|addItemToBackpack|addItemToUniform|addItemToVest|addLiveStats|addMagazine|addMagazineAmmoCargo|addMagazineCargo|addMagazineCargoGlobal|addMagazineGlobal|addMagazinePool|addMagazines|addMagazineTurret|addMenu|addMenuItem|addMissionEventHandler|addMPEventHandler|addMusicEventHandler|addOwnedMine|addPlayerScores|addPrimaryWeaponItem|addPublicVariableEventHandler|addRating|addResources|addScore|addScoreSide|addSecondaryWeaponItem|addSwitchableUnit|addTeamMember|addToRemainsCollector|addTorque|addUniform|addVehicle|addVest|addWaypoint|addWeapon|addWeaponCargo|addWeaponCargoGlobal|addWeaponGlobal|addWeaponItem|addWeaponPool|addWeaponTurret|admin|agent|agents|AGLToASL|aimedAtTarget|aimPos|airDensityCurveRTD|airDensityRTD|airplaneThrottle|airportSide|AISFinishHeal|alive|all3DENEntities|allAirports|allControls|allCurators|allCutLayers|allDead|allDeadMen|allDisplays|allGroups|allMapMarkers|allMines|allMissionObjects|allow3DMode|allowCrewInImmobile|allowCuratorLogicIgnoreAreas|allowDamage|allowDammage|allowFileOperations|allowFleeing|allowGetIn|allowSprint|allPlayers|allSimpleObjects|allSites|allTurrets|allUnits|allUnitsUAV|allVariables|ammo|ammoOnPylon|animate|animateBay|animateDoor|animatePylon|animateSource|animationNames|animationPhase|animationSourcePhase|animationState|append|apply|armoryPoints|arrayIntersect|asin|ASLToAGL|ASLToATL|assert|assignAsCargo|assignAsCargoIndex|assignAsCommander|assignAsDriver|assignAsGunner|assignAsTurret|assignCurator|assignedCargo|assignedCommander|assignedDriver|assignedGunner|assignedItems|assignedTarget|assignedTeam|assignedVehicle|assignedVehicleRole|assignItem|assignTeam|assignToAirport|atan|atan2|atg|ATLToASL|attachedObject|attachedObjects|attachedTo|attachObject|attachTo|attackEnabled|backpack|backpackCargo|backpackContainer|backpackItems|backpackMagazines|backpackSpaceFor|behaviour|benchmark|binocular|blufor|boundingBox|boundingBoxReal|boundingCenter|briefingName|buildingExit|buildingPos|buldozer_EnableRoadDiag|buldozer_IsEnabledRoadDiag|buldozer_LoadNewRoads|buldozer_reloadOperMap|buttonAction|buttonSetAction|cadetMode|callExtension|camCommand|camCommit|camCommitPrepared|camCommitted|camConstuctionSetParams|camCreate|camDestroy|cameraEffect|cameraEffectEnableHUD|cameraInterest|cameraOn|cameraView|campaignConfigFile|camPreload|camPreloaded|camPrepareBank|camPrepareDir|camPrepareDive|camPrepareFocus|camPrepareFov|camPrepareFovRange|camPreparePos|camPrepareRelPos|camPrepareTarget|camSetBank|camSetDir|camSetDive|camSetFocus|camSetFov|camSetFovRange|camSetPos|camSetRelPos|camSetTarget|camTarget|camUseNVG|canAdd|canAddItemToBackpack|canAddItemToUniform|canAddItemToVest|cancelSimpleTaskDestination|canFire|canMove|canSlingLoad|canStand|canSuspend|canTriggerDynamicSimulation|canUnloadInCombat|canVehicleCargo|captive|captiveNum|cbChecked|cbSetChecked|ceil|channelEnabled|cheatsEnabled|checkAIFeature|checkVisibility|civilian|className|clear3DENAttribute|clear3DENInventory|clearAllItemsFromBackpack|clearBackpackCargo|clearBackpackCargoGlobal|clearForcesRTD|clearGroupIcons|clearItemCargo|clearItemCargoGlobal|clearItemPool|clearMagazineCargo|clearMagazineCargoGlobal|clearMagazinePool|clearOverlay|clearRadio|clearVehicleInit|clearWeaponCargo|clearWeaponCargoGlobal|clearWeaponPool|clientOwner|closeDialog|closeDisplay|closeOverlay|collapseObjectTree|collect3DENHistory|collectiveRTD|combatMode|commandArtilleryFire|commandChat|commander|commandFire|commandFollow|commandFSM|commandGetOut|commandingMenu|commandMove|commandRadio|commandStop|commandSuppressiveFire|commandTarget|commandWatch|comment|commitOverlay|compile|compileFinal|completedFSM|composeText|configClasses|configFile|configHierarchy|configName|configNull|configProperties|configSourceAddonList|configSourceMod|configSourceModList|confirmSensorTarget|connectTerminalToUAV|controlNull|controlsGroupCtrl|copyFromClipboard|copyToClipboard|copyWaypoints|cos|count|countEnemy|countFriendly|countSide|countType|countUnknown|create3DENComposition|create3DENEntity|createAgent|createCenter|createDialog|createDiaryLink|createDiaryRecord|createDiarySubject|createDisplay|createGearDialog|createGroup|createGuardedPoint|createLocation|createMarker|createMarkerLocal|createMenu|createMine|createMissionDisplay|createMPCampaignDisplay|createSimpleObject|createSimpleTask|createSite|createSoundSource|createTask|createTeam|createTrigger|createUnit|createVehicle|createVehicleCrew|createVehicleLocal|crew|ctAddHeader|ctAddRow|ctClear|ctCurSel|ctData|ctFindHeaderRows|ctFindRowHeader|ctHeaderControls|ctHeaderCount|ctRemoveHeaders|ctRemoveRows|ctrlActivate|ctrlAddEventHandler|ctrlAngle|ctrlAutoScrollDelay|ctrlAutoScrollRewind|ctrlAutoScrollSpeed|ctrlChecked|ctrlClassName|ctrlCommit|ctrlCommitted|ctrlCreate|ctrlDelete|ctrlEnable|ctrlEnabled|ctrlFade|ctrlHTMLLoaded|ctrlIDC|ctrlIDD|ctrlMapAnimAdd|ctrlMapAnimClear|ctrlMapAnimCommit|ctrlMapAnimDone|ctrlMapCursor|ctrlMapMouseOver|ctrlMapScale|ctrlMapScreenToWorld|ctrlMapWorldToScreen|ctrlModel|ctrlModelDirAndUp|ctrlModelScale|ctrlParent|ctrlParentControlsGroup|ctrlPosition|ctrlRemoveAllEventHandlers|ctrlRemoveEventHandler|ctrlScale|ctrlSetActiveColor|ctrlSetAngle|ctrlSetAutoScrollDelay|ctrlSetAutoScrollRewind|ctrlSetAutoScrollSpeed|ctrlSetBackgroundColor|ctrlSetChecked|ctrlSetDisabledColor|ctrlSetEventHandler|ctrlSetFade|ctrlSetFocus|ctrlSetFont|ctrlSetFontH1|ctrlSetFontH1B|ctrlSetFontH2|ctrlSetFontH2B|ctrlSetFontH3|ctrlSetFontH3B|ctrlSetFontH4|ctrlSetFontH4B|ctrlSetFontH5|ctrlSetFontH5B|ctrlSetFontH6|ctrlSetFontH6B|ctrlSetFontHeight|ctrlSetFontHeightH1|ctrlSetFontHeightH2|ctrlSetFontHeightH3|ctrlSetFontHeightH4|ctrlSetFontHeightH5|ctrlSetFontHeightH6|ctrlSetFontHeightSecondary|ctrlSetFontP|ctrlSetFontPB|ctrlSetFontSecondary|ctrlSetForegroundColor|ctrlSetModel|ctrlSetModelDirAndUp|ctrlSetModelScale|ctrlSetPixelPrecision|ctrlSetPosition|ctrlSetScale|ctrlSetStructuredText|ctrlSetText|ctrlSetTextColor|ctrlSetTextColorSecondary|ctrlSetTextSecondary|ctrlSetTooltip|ctrlSetTooltipColorBox|ctrlSetTooltipColorShade|ctrlSetTooltipColorText|ctrlShow|ctrlShown|ctrlText|ctrlTextHeight|ctrlTextSecondary|ctrlTextWidth|ctrlType|ctrlVisible|ctRowControls|ctRowCount|ctSetCurSel|ctSetData|ctSetHeaderTemplate|ctSetRowTemplate|ctSetValue|ctValue|curatorAddons|curatorCamera|curatorCameraArea|curatorCameraAreaCeiling|curatorCoef|curatorEditableObjects|curatorEditingArea|curatorEditingAreaType|curatorMouseOver|curatorPoints|curatorRegisteredObjects|curatorSelected|curatorWaypointCost|current3DENOperation|currentChannel|currentCommand|currentMagazine|currentMagazineDetail|currentMagazineDetailTurret|currentMagazineTurret|currentMuzzle|currentNamespace|currentTask|currentTasks|currentThrowable|currentVisionMode|currentWaypoint|currentWeapon|currentWeaponMode|currentWeaponTurret|currentZeroing|cursorObject|cursorTarget|customChat|customRadio|cutFadeOut|cutObj|cutRsc|cutText|damage|date|dateToNumber|daytime|deActivateKey|debriefingText|debugFSM|debugLog|deg|delete3DENEntities|deleteAt|deleteCenter|deleteCollection|deleteEditorObject|deleteGroup|deleteGroupWhenEmpty|deleteIdentity|deleteLocation|deleteMarker|deleteMarkerLocal|deleteRange|deleteResources|deleteSite|deleteStatus|deleteTeam|deleteVehicle|deleteVehicleCrew|deleteWaypoint|detach|detectedMines|diag_activeMissionFSMs|diag_activeScripts|diag_activeSQFScripts|diag_activeSQSScripts|diag_captureFrame|diag_captureFrameToFile|diag_captureSlowFrame|diag_codePerformance|diag_drawMode|diag_dynamicSimulationEnd|diag_enable|diag_enabled|diag_fps|diag_fpsMin|diag_frameNo|diag_lightNewLoad|diag_list|diag_log|diag_logSlowFrame|diag_mergeConfigFile|diag_recordTurretLimits|diag_setLightNew|diag_tickTime|diag_toggle|dialog|diarySubjectExists|didJIP|didJIPOwner|difficulty|difficultyEnabled|difficultyEnabledRTD|difficultyOption|direction|directSay|disableAI|disableCollisionWith|disableConversation|disableDebriefingStats|disableMapIndicators|disableNVGEquipment|disableRemoteSensors|disableSerialization|disableTIEquipment|disableUAVConnectability|disableUserInput|displayAddEventHandler|displayCtrl|displayNull|displayParent|displayRemoveAllEventHandlers|displayRemoveEventHandler|displaySetEventHandler|dissolveTeam|distance|distance2D|distanceSqr|distributionRegion|do3DENAction|doArtilleryFire|doFire|doFollow|doFSM|doGetOut|doMove|doorPhase|doStop|doSuppressiveFire|doTarget|doWatch|drawArrow|drawEllipse|drawIcon|drawIcon3D|drawLine|drawLine3D|drawLink|drawLocation|drawPolygon|drawRectangle|drawTriangle|driver|drop|dynamicSimulationDistance|dynamicSimulationDistanceCoef|dynamicSimulationEnabled|dynamicSimulationSystemEnabled|east|edit3DENMissionAttributes|editObject|editorSetEventHandler|effectiveCommander|emptyPositions|enableAI|enableAIFeature|enableAimPrecision|enableAttack|enableAudioFeature|enableAutoStartUpRTD|enableAutoTrimRTD|enableCamShake|enableCaustics|enableChannel|enableCollisionWith|enableCopilot|enableDebriefingStats|enableDiagLegend|enableDynamicSimulation|enableDynamicSimulationSystem|enableEndDialog|enableEngineArtillery|enableEnvironment|enableFatigue|enableGunLights|enableInfoPanelComponent|enableIRLasers|enableMimics|enablePersonTurret|enableRadio|enableReload|enableRopeAttach|enableSatNormalOnDetail|enableSaving|enableSentences|enableSimulation|enableSimulationGlobal|enableStamina|enableStressDamage|enableTeamSwitch|enableTraffic|enableUAVConnectability|enableUAVWaypoints|enableVehicleCargo|enableVehicleSensor|enableWeaponDisassembly|endl|endLoadingScreen|endMission|engineOn|enginesIsOnRTD|enginesPowerRTD|enginesRpmRTD|enginesTorqueRTD|entities|environmentEnabled|estimatedEndServerTime|estimatedTimeLeft|evalObjectArgument|everyBackpack|everyContainer|exec|execEditorScript|exp|expectedDestination|exportJIPMessages|eyeDirection|eyePos|face|faction|fadeMusic|fadeRadio|fadeSound|fadeSpeech|failMission|fillWeaponsFromPool|find|findCover|findDisplay|findEditorObject|findEmptyPosition|findEmptyPositionReady|findIf|findNearestEnemy|finishMissionInit|finite|fire|fireAtTarget|firstBackpack|flag|flagAnimationPhase|flagOwner|flagSide|flagTexture|fleeing|floor|flyInHeight|flyInHeightASL|fog|fogForecast|fogParams|forceAddUniform|forceAtPositionRTD|forcedMap|forceEnd|forceFlagTexture|forceFollowRoad|forceGeneratorRTD|forceMap|forceRespawn|forceSpeed|forceWalk|forceWeaponFire|forceWeatherChange|forgetTarget|format|formation|formationDirection|formationLeader|formationMembers|formationPosition|formationTask|formatText|formLeader|freeLook|fromEditor|fuel|fullCrew|gearIDCAmmoCount|gearSlotAmmoCount|gearSlotData|get3DENActionState|get3DENAttribute|get3DENCamera|get3DENConnections|get3DENEntity|get3DENEntityID|get3DENGrid|get3DENIconsVisible|get3DENLayerEntities|get3DENLinesVisible|get3DENMissionAttribute|get3DENMouseOver|get3DENSelected|getAimingCoef|getAllEnvSoundControllers|getAllHitPointsDamage|getAllOwnedMines|getAllSoundControllers|getAmmoCargo|getAnimAimPrecision|getAnimSpeedCoef|getArray|getArtilleryAmmo|getArtilleryComputerSettings|getArtilleryETA|getAssignedCuratorLogic|getAssignedCuratorUnit|getBackpackCargo|getBleedingRemaining|getBurningValue|getCameraViewDirection|getCargoIndex|getCenterOfMass|getClientState|getClientStateNumber|getCompatiblePylonMagazines|getConnectedUAV|getContainerMaxLoad|getCursorObjectParams|getCustomAimCoef|getDammage|getDescription|getDir|getDirVisual|getDLCAssetsUsage|getDLCAssetsUsageByName|getDLCs|getDLCUsageTime|getEditorCamera|getEditorMode|getEditorObjectScope|getElevationOffset|getEngineTargetRpmRTD|getEnvSoundController|getFatigue|getFieldManualStartPage|getForcedFlagTexture|getFriend|getFSMVariable|getFuelCargo|getGroupIcon|getGroupIconParams|getGroupIcons|getHideFrom|getHit|getHitIndex|getHitPointDamage|getItemCargo|getMagazineCargo|getMarkerColor|getMarkerPos|getMarkerSize|getMarkerType|getMass|getMissionConfig|getMissionConfigValue|getMissionDLCs|getMissionLayerEntities|getMissionLayers|getModelInfo|getMousePosition|getMusicPlayedTime|getNumber|getObjectArgument|getObjectChildren|getObjectDLC|getObjectMaterials|getObjectProxy|getObjectTextures|getObjectType|getObjectViewDistance|getOxygenRemaining|getPersonUsedDLCs|getPilotCameraDirection|getPilotCameraPosition|getPilotCameraRotation|getPilotCameraTarget|getPlateNumber|getPlayerChannel|getPlayerScores|getPlayerUID|getPlayerUIDOld|getPos|getPosASL|getPosASLVisual|getPosASLW|getPosATL|getPosATLVisual|getPosVisual|getPosWorld|getPylonMagazines|getRelDir|getRelPos|getRemoteSensorsDisabled|getRepairCargo|getResolution|getRotorBrakeRTD|getShadowDistance|getShotParents|getSlingLoad|getSoundController|getSoundControllerResult|getSpeed|getStamina|getStatValue|getSuppression|getTerrainGrid|getTerrainHeightASL|getText|getTotalDLCUsageTime|getTrimOffsetRTD|getUnitLoadout|getUnitTrait|getUserMFDText|getUserMFDValue|getVariable|getVehicleCargo|getWeaponCargo|getWeaponSway|getWingsOrientationRTD|getWingsPositionRTD|getWPPos|glanceAt|globalChat|globalRadio|goggles|group|groupChat|groupFromNetId|groupIconSelectable|groupIconsVisible|groupId|groupOwner|groupRadio|groupSelectedUnits|groupSelectUnit|grpNull|gunner|gusts|halt|handgunItems|handgunMagazine|handgunWeapon|handsHit|hasInterface|hasPilotCamera|hasWeapon|hcAllGroups|hcGroupParams|hcLeader|hcRemoveAllGroups|hcRemoveGroup|hcSelected|hcSelectGroup|hcSetGroup|hcShowBar|hcShownBar|headgear|hideBody|hideObject|hideObjectGlobal|hideSelection|hint|hintC|hintCadet|hintSilent|hmd|hostMission|htmlLoad|HUDMovementLevels|humidity|image|importAllGroups|importance|in|inArea|inAreaArray|incapacitatedState|independent|inflame|inflamed|infoPanel|infoPanelComponentEnabled|infoPanelComponents|infoPanels|inGameUISetEventHandler|inheritsFrom|initAmbientLife|inPolygon|inputAction|inRangeOfArtillery|insertEditorObject|intersect|is3DEN|is3DENMultiplayer|isAbleToBreathe|isAgent|isAimPrecisionEnabled|isArray|isAutoHoverOn|isAutonomous|isAutoStartUpEnabledRTD|isAutotest|isAutoTrimOnRTD|isBleeding|isBurning|isClass|isCollisionLightOn|isCopilotEnabled|isDamageAllowed|isDedicated|isDLCAvailable|isEngineOn|isEqualTo|isEqualType|isEqualTypeAll|isEqualTypeAny|isEqualTypeArray|isEqualTypeParams|isFilePatchingEnabled|isFlashlightOn|isFlatEmpty|isForcedWalk|isFormationLeader|isGroupDeletedWhenEmpty|isHidden|isInRemainsCollector|isInstructorFigureEnabled|isIRLaserOn|isKeyActive|isKindOf|isLaserOn|isLightOn|isLocalized|isManualFire|isMarkedForCollection|isMultiplayer|isMultiplayerSolo|isNil|isNull|isNumber|isObjectHidden|isObjectRTD|isOnRoad|isPipEnabled|isPlayer|isRealTime|isRemoteExecuted|isRemoteExecutedJIP|isServer|isShowing3DIcons|isSimpleObject|isSprintAllowed|isStaminaEnabled|isSteamMission|isStreamFriendlyUIEnabled|isStressDamageEnabled|isText|isTouchingGround|isTurnedOut|isTutHintsEnabled|isUAVConnectable|isUAVConnected|isUIContext|isUniformAllowed|isVehicleCargo|isVehicleRadarOn|isVehicleSensorEnabled|isWalking|isWeaponDeployed|isWeaponRested|itemCargo|items|itemsWithMagazines|join|joinAs|joinAsSilent|joinSilent|joinString|kbAddDatabase|kbAddDatabaseTargets|kbAddTopic|kbHasTopic|kbReact|kbRemoveTopic|kbTell|kbWasSaid|keyImage|keyName|knowsAbout|land|landAt|landResult|language|laserTarget|lbAdd|lbClear|lbColor|lbColorRight|lbCurSel|lbData|lbDelete|lbIsSelected|lbPicture|lbPictureRight|lbSelection|lbSetColor|lbSetColorRight|lbSetCurSel|lbSetData|lbSetPicture|lbSetPictureColor|lbSetPictureColorDisabled|lbSetPictureColorSelected|lbSetPictureRight|lbSetPictureRightColor|lbSetPictureRightColorDisabled|lbSetPictureRightColorSelected|lbSetSelectColor|lbSetSelectColorRight|lbSetSelected|lbSetText|lbSetTextRight|lbSetTooltip|lbSetValue|lbSize|lbSort|lbSortByValue|lbText|lbTextRight|lbValue|leader|leaderboardDeInit|leaderboardGetRows|leaderboardInit|leaderboardRequestRowsFriends|leaderboardRequestRowsGlobal|leaderboardRequestRowsGlobalAroundUser|leaderboardsRequestUploadScore|leaderboardsRequestUploadScoreKeepBest|leaderboardState|leaveVehicle|libraryCredits|libraryDisclaimers|lifeState|lightAttachObject|lightDetachObject|lightIsOn|lightnings|limitSpeed|linearConversion|lineBreak|lineIntersects|lineIntersectsObjs|lineIntersectsSurfaces|lineIntersectsWith|linkItem|list|listObjects|listRemoteTargets|listVehicleSensors|ln|lnbAddArray|lnbAddColumn|lnbAddRow|lnbClear|lnbColor|lnbColorRight|lnbCurSelRow|lnbData|lnbDeleteColumn|lnbDeleteRow|lnbGetColumnsPosition|lnbPicture|lnbPictureRight|lnbSetColor|lnbSetColorRight|lnbSetColumnsPos|lnbSetCurSelRow|lnbSetData|lnbSetPicture|lnbSetPictureColor|lnbSetPictureColorRight|lnbSetPictureColorSelected|lnbSetPictureColorSelectedRight|lnbSetPictureRight|lnbSetText|lnbSetTextRight|lnbSetValue|lnbSize|lnbSort|lnbSortByValue|lnbText|lnbTextRight|lnbValue|load|loadAbs|loadBackpack|loadFile|loadGame|loadIdentity|loadMagazine|loadOverlay|loadStatus|loadUniform|loadVest|local|localize|locationNull|locationPosition|lock|lockCameraTo|lockCargo|lockDriver|locked|lockedCargo|lockedDriver|lockedTurret|lockIdentity|lockTurret|lockWP|log|logEntities|logNetwork|logNetworkTerminate|lookAt|lookAtPos|magazineCargo|magazines|magazinesAllTurrets|magazinesAmmo|magazinesAmmoCargo|magazinesAmmoFull|magazinesDetail|magazinesDetailBackpack|magazinesDetailUniform|magazinesDetailVest|magazinesTurret|magazineTurretAmmo|mapAnimAdd|mapAnimClear|mapAnimCommit|mapAnimDone|mapCenterOnCamera|mapGridPosition|markAsFinishedOnSteam|markerAlpha|markerBrush|markerColor|markerDir|markerPos|markerShape|markerSize|markerText|markerType|max|members|menuAction|menuAdd|menuChecked|menuClear|menuCollapse|menuData|menuDelete|menuEnable|menuEnabled|menuExpand|menuHover|menuPicture|menuSetAction|menuSetCheck|menuSetData|menuSetPicture|menuSetValue|menuShortcut|menuShortcutText|menuSize|menuSort|menuText|menuURL|menuValue|min|mineActive|mineDetectedBy|missionConfigFile|missionDifficulty|missionName|missionNamespace|missionStart|missionVersion|modelToWorld|modelToWorldVisual|modelToWorldVisualWorld|modelToWorldWorld|modParams|moonIntensity|moonPhase|morale|move|move3DENCamera|moveInAny|moveInCargo|moveInCommander|moveInDriver|moveInGunner|moveInTurret|moveObjectToEnd|moveOut|moveTime|moveTo|moveToCompleted|moveToFailed|musicVolume|name|nameSound|nearEntities|nearestBuilding|nearestLocation|nearestLocations|nearestLocationWithDubbing|nearestObject|nearestObjects|nearestTerrainObjects|nearObjects|nearObjectsReady|nearRoads|nearSupplies|nearTargets|needReload|netId|netObjNull|newOverlay|nextMenuItemIndex|nextWeatherChange|nMenuItems|numberOfEnginesRTD|numberToDate|objectCurators|objectFromNetId|objectParent|objNull|objStatus|onBriefingGear|onBriefingGroup|onBriefingNotes|onBriefingPlan|onBriefingTeamSwitch|onCommandModeChanged|onDoubleClick|onEachFrame|onGroupIconClick|onGroupIconOverEnter|onGroupIconOverLeave|onHCGroupSelectionChanged|onMapSingleClick|onPlayerConnected|onPlayerDisconnected|onPreloadFinished|onPreloadStarted|onShowNewObject|onTeamSwitch|openCuratorInterface|openDLCPage|openDSInterface|openMap|openSteamApp|openYoutubeVideo|opfor|orderGetIn|overcast|overcastForecast|owner|param|params|parseNumber|parseSimpleArray|parseText|parsingNamespace|particlesQuality|pi|pickWeaponPool|pitch|pixelGrid|pixelGridBase|pixelGridNoUIScale|pixelH|pixelW|playableSlotsNumber|playableUnits|playAction|playActionNow|player|playerRespawnTime|playerSide|playersNumber|playGesture|playMission|playMove|playMoveNow|playMusic|playScriptedMission|playSound|playSound3D|position|positionCameraToWorld|posScreenToWorld|posWorldToScreen|ppEffectAdjust|ppEffectCommit|ppEffectCommitted|ppEffectCreate|ppEffectDestroy|ppEffectEnable|ppEffectEnabled|ppEffectForceInNVG|precision|preloadCamera|preloadObject|preloadSound|preloadTitleObj|preloadTitleRsc|primaryWeapon|primaryWeaponItems|primaryWeaponMagazine|priority|processDiaryLink|processInitCommands|productVersion|profileName|profileNamespace|profileNameSteam|progressLoadingScreen|progressPosition|progressSetPosition|publicVariable|publicVariableClient|publicVariableServer|pushBack|pushBackUnique|putWeaponPool|queryItemsPool|queryMagazinePool|queryWeaponPool|rad|radioChannelAdd|radioChannelCreate|radioChannelRemove|radioChannelSetCallSign|radioChannelSetLabel|radioVolume|rain|rainbow|random|rank|rankId|rating|rectangular|registeredTasks|registerTask|reload|reloadEnabled|remoteControl|remoteExec|remoteExecCall|remoteExecutedOwner|remove3DENConnection|remove3DENEventHandler|remove3DENLayer|removeAction|removeAll3DENEventHandlers|removeAllActions|removeAllAssignedItems|removeAllContainers|removeAllCuratorAddons|removeAllCuratorCameraAreas|removeAllCuratorEditingAreas|removeAllEventHandlers|removeAllHandgunItems|removeAllItems|removeAllItemsWithMagazines|removeAllMissionEventHandlers|removeAllMPEventHandlers|removeAllMusicEventHandlers|removeAllOwnedMines|removeAllPrimaryWeaponItems|removeAllWeapons|removeBackpack|removeBackpackGlobal|removeCuratorAddons|removeCuratorCameraArea|removeCuratorEditableObjects|removeCuratorEditingArea|removeDrawIcon|removeDrawLinks|removeEventHandler|removeFromRemainsCollector|removeGoggles|removeGroupIcon|removeHandgunItem|removeHeadgear|removeItem|removeItemFromBackpack|removeItemFromUniform|removeItemFromVest|removeItems|removeMagazine|removeMagazineGlobal|removeMagazines|removeMagazinesTurret|removeMagazineTurret|removeMenuItem|removeMissionEventHandler|removeMPEventHandler|removeMusicEventHandler|removeOwnedMine|removePrimaryWeaponItem|removeSecondaryWeaponItem|removeSimpleTask|removeSwitchableUnit|removeTeamMember|removeUniform|removeVest|removeWeapon|removeWeaponAttachmentCargo|removeWeaponCargo|removeWeaponGlobal|removeWeaponTurret|reportRemoteTarget|requiredVersion|resetCamShake|resetSubgroupDirection|resistance|resize|resources|respawnVehicle|restartEditorCamera|reveal|revealMine|reverse|reversedMouseY|roadAt|roadsConnectedTo|roleDescription|ropeAttachedObjects|ropeAttachedTo|ropeAttachEnabled|ropeAttachTo|ropeCreate|ropeCut|ropeDestroy|ropeDetach|ropeEndPosition|ropeLength|ropes|ropeUnwind|ropeUnwound|rotorsForcesRTD|rotorsRpmRTD|round|runInitScript|safeZoneH|safeZoneW|safeZoneWAbs|safeZoneX|safeZoneXAbs|safeZoneY|save3DENInventory|saveGame|saveIdentity|saveJoysticks|saveOverlay|saveProfileNamespace|saveStatus|saveVar|savingEnabled|say|say2D|say3D|score|scoreSide|screenshot|screenToWorld|scriptDone|scriptName|scriptNull|scudState|secondaryWeapon|secondaryWeaponItems|secondaryWeaponMagazine|select|selectBestPlaces|selectDiarySubject|selectedEditorObjects|selectEditorObject|selectionNames|selectionPosition|selectLeader|selectMax|selectMin|selectNoPlayer|selectPlayer|selectRandom|selectRandomWeighted|selectWeapon|selectWeaponTurret|sendAUMessage|sendSimpleCommand|sendTask|sendTaskResult|sendUDPMessage|serverCommand|serverCommandAvailable|serverCommandExecutable|serverName|serverTime|set|set3DENAttribute|set3DENAttributes|set3DENGrid|set3DENIconsVisible|set3DENLayer|set3DENLinesVisible|set3DENLogicType|set3DENMissionAttribute|set3DENMissionAttributes|set3DENModelsVisible|set3DENObjectType|set3DENSelected|setAccTime|setActualCollectiveRTD|setAirplaneThrottle|setAirportSide|setAmmo|setAmmoCargo|setAmmoOnPylon|setAnimSpeedCoef|setAperture|setApertureNew|setArmoryPoints|setAttributes|setAutonomous|setBehaviour|setBleedingRemaining|setBrakesRTD|setCameraInterest|setCamShakeDefParams|setCamShakeParams|setCamUseTI|setCaptive|setCenterOfMass|setCollisionLight|setCombatMode|setCompassOscillation|setConvoySeparation|setCuratorCameraAreaCeiling|setCuratorCoef|setCuratorEditingAreaType|setCuratorWaypointCost|setCurrentChannel|setCurrentTask|setCurrentWaypoint|setCustomAimCoef|setCustomWeightRTD|setDamage|setDammage|setDate|setDebriefingText|setDefaultCamera|setDestination|setDetailMapBlendPars|setDir|setDirection|setDrawIcon|setDriveOnPath|setDropInterval|setDynamicSimulationDistance|setDynamicSimulationDistanceCoef|setEditorMode|setEditorObjectScope|setEffectCondition|setEngineRpmRTD|setFace|setFaceAnimation|setFatigue|setFeatureType|setFlagAnimationPhase|setFlagOwner|setFlagSide|setFlagTexture|setFog|setForceGeneratorRTD|setFormation|setFormationTask|setFormDir|setFriend|setFromEditor|setFSMVariable|setFuel|setFuelCargo|setGroupIcon|setGroupIconParams|setGroupIconsSelectable|setGroupIconsVisible|setGroupId|setGroupIdGlobal|setGroupOwner|setGusts|setHideBehind|setHit|setHitIndex|setHitPointDamage|setHorizonParallaxCoef|setHUDMovementLevels|setIdentity|setImportance|setInfoPanel|setLeader|setLightAmbient|setLightAttenuation|setLightBrightness|setLightColor|setLightDayLight|setLightFlareMaxDistance|setLightFlareSize|setLightIntensity|setLightnings|setLightUseFlare|setLocalWindParams|setMagazineTurretAmmo|setMarkerAlpha|setMarkerAlphaLocal|setMarkerBrush|setMarkerBrushLocal|setMarkerColor|setMarkerColorLocal|setMarkerDir|setMarkerDirLocal|setMarkerPos|setMarkerPosLocal|setMarkerShape|setMarkerShapeLocal|setMarkerSize|setMarkerSizeLocal|setMarkerText|setMarkerTextLocal|setMarkerType|setMarkerTypeLocal|setMass|setMimic|setMousePosition|setMusicEffect|setMusicEventHandler|setName|setNameSound|setObjectArguments|setObjectMaterial|setObjectMaterialGlobal|setObjectProxy|setObjectTexture|setObjectTextureGlobal|setObjectViewDistance|setOvercast|setOwner|setOxygenRemaining|setParticleCircle|setParticleClass|setParticleFire|setParticleParams|setParticleRandom|setPilotCameraDirection|setPilotCameraRotation|setPilotCameraTarget|setPilotLight|setPiPEffect|setPitch|setPlateNumber|setPlayable|setPlayerRespawnTime|setPos|setPosASL|setPosASL2|setPosASLW|setPosATL|setPosition|setPosWorld|setPylonLoadOut|setPylonsPriority|setRadioMsg|setRain|setRainbow|setRandomLip|setRank|setRectangular|setRepairCargo|setRotorBrakeRTD|setShadowDistance|setShotParents|setSide|setSimpleTaskAlwaysVisible|setSimpleTaskCustomData|setSimpleTaskDescription|setSimpleTaskDestination|setSimpleTaskTarget|setSimpleTaskType|setSimulWeatherLayers|setSize|setSkill|setSlingLoad|setSoundEffect|setSpeaker|setSpeech|setSpeedMode|setStamina|setStaminaScheme|setStatValue|setSuppression|setSystemOfUnits|setTargetAge|setTaskMarkerOffset|setTaskResult|setTaskState|setTerrainGrid|setText|setTimeMultiplier|setTitleEffect|setToneMapping|setToneMappingParams|setTrafficDensity|setTrafficDistance|setTrafficGap|setTrafficSpeed|setTriggerActivation|setTriggerArea|setTriggerStatements|setTriggerText|setTriggerTimeout|setTriggerType|setType|setUnconscious|setUnitAbility|setUnitLoadout|setUnitPos|setUnitPosWeak|setUnitRank|setUnitRecoilCoefficient|setUnitTrait|setUnloadInCombat|setUserActionText|setUserMFDText|setUserMFDValue|setVariable|setVectorDir|setVectorDirAndUp|setVectorUp|setVehicleAmmo|setVehicleAmmoDef|setVehicleArmor|setVehicleCargo|setVehicleId|setVehicleInit|setVehicleLock|setVehiclePosition|setVehicleRadar|setVehicleReceiveRemoteTargets|setVehicleReportOwnPosition|setVehicleReportRemoteTargets|setVehicleTIPars|setVehicleVarName|setVelocity|setVelocityModelSpace|setVelocityTransformation|setViewDistance|setVisibleIfTreeCollapsed|setWantedRpmRTD|setWaves|setWaypointBehaviour|setWaypointCombatMode|setWaypointCompletionRadius|setWaypointDescription|setWaypointForceBehaviour|setWaypointFormation|setWaypointHousePosition|setWaypointLoiterRadius|setWaypointLoiterType|setWaypointName|setWaypointPosition|setWaypointScript|setWaypointSpeed|setWaypointStatements|setWaypointTimeout|setWaypointType|setWaypointVisible|setWeaponReloadingTime|setWind|setWindDir|setWindForce|setWindStr|setWingForceScaleRTD|setWPPos|show3DIcons|showChat|showCinemaBorder|showCommandingMenu|showCompass|showCuratorCompass|showGPS|showHUD|showLegend|showMap|shownArtilleryComputer|shownChat|shownCompass|shownCuratorCompass|showNewEditorObject|shownGPS|shownHUD|shownMap|shownPad|shownRadio|shownScoretable|shownUAVFeed|shownWarrant|shownWatch|showPad|showRadio|showScoretable|showSubtitles|showUAVFeed|showWarrant|showWatch|showWaypoint|showWaypoints|side|sideAmbientLife|sideChat|sideEmpty|sideEnemy|sideFriendly|sideLogic|sideRadio|sideUnknown|simpleTasks|simulationEnabled|simulCloudDensity|simulCloudOcclusion|simulInClouds|simulWeatherSync|sin|size|sizeOf|skill|skillFinal|skipTime|sleep|sliderPosition|sliderRange|sliderSetPosition|sliderSetRange|sliderSetSpeed|sliderSpeed|slingLoadAssistantShown|soldierMagazines|someAmmo|sort|soundVolume|speaker|speed|speedMode|splitString|sqrt|squadParams|stance|startLoadingScreen|stop|stopEngineRTD|stopped|str|sunOrMoon|supportInfo|suppressFor|surfaceIsWater|surfaceNormal|surfaceType|swimInDepth|switchableUnits|switchAction|switchCamera|switchGesture|switchLight|switchMove|synchronizedObjects|synchronizedTriggers|synchronizedWaypoints|synchronizeObjectsAdd|synchronizeObjectsRemove|synchronizeTrigger|synchronizeWaypoint|systemChat|systemOfUnits|tan|targetKnowledge|targets|targetsAggregate|targetsQuery|taskAlwaysVisible|taskChildren|taskCompleted|taskCustomData|taskDescription|taskDestination|taskHint|taskMarkerOffset|taskNull|taskParent|taskResult|taskState|taskType|teamMember|teamMemberNull|teamName|teams|teamSwitch|teamSwitchEnabled|teamType|terminate|terrainIntersect|terrainIntersectASL|terrainIntersectAtASL|text|textLog|textLogFormat|tg|time|timeMultiplier|titleCut|titleFadeOut|titleObj|titleRsc|titleText|toArray|toFixed|toLower|toString|toUpper|triggerActivated|triggerActivation|triggerArea|triggerAttachedVehicle|triggerAttachObject|triggerAttachVehicle|triggerDynamicSimulation|triggerStatements|triggerText|triggerTimeout|triggerTimeoutCurrent|triggerType|turretLocal|turretOwner|turretUnit|tvAdd|tvClear|tvCollapse|tvCollapseAll|tvCount|tvCurSel|tvData|tvDelete|tvExpand|tvExpandAll|tvPicture|tvPictureRight|tvSetColor|tvSetCurSel|tvSetData|tvSetPicture|tvSetPictureColor|tvSetPictureColorDisabled|tvSetPictureColorSelected|tvSetPictureRight|tvSetPictureRightColor|tvSetPictureRightColorDisabled|tvSetPictureRightColorSelected|tvSetSelectColor|tvSetText|tvSetTooltip|tvSetValue|tvSort|tvSortByValue|tvText|tvTooltip|tvValue|type|typeName|typeOf|UAVControl|uiNamespace|uiSleep|unassignCurator|unassignItem|unassignTeam|unassignVehicle|underwater|uniform|uniformContainer|uniformItems|uniformMagazines|unitAddons|unitAimPosition|unitAimPositionVisual|unitBackpack|unitIsUAV|unitPos|unitReady|unitRecoilCoefficient|units|unitsBelowHeight|unlinkItem|unlockAchievement|unregisterTask|updateDrawIcon|updateMenuItem|updateObjectTree|useAIOperMapObstructionTest|useAISteeringComponent|useAudioTimeForMoves|userInputDisabled|vectorAdd|vectorCos|vectorCrossProduct|vectorDiff|vectorDir|vectorDirVisual|vectorDistance|vectorDistanceSqr|vectorDotProduct|vectorFromTo|vectorMagnitude|vectorMagnitudeSqr|vectorModelToWorld|vectorModelToWorldVisual|vectorMultiply|vectorNormalized|vectorUp|vectorUpVisual|vectorWorldToModel|vectorWorldToModelVisual|vehicle|vehicleCargoEnabled|vehicleChat|vehicleRadio|vehicleReceiveRemoteTargets|vehicleReportOwnPosition|vehicleReportRemoteTargets|vehicles|vehicleVarName|velocity|velocityModelSpace|verifySignature|vest|vestContainer|vestItems|vestMagazines|viewDistance|visibleCompass|visibleGPS|visibleMap|visiblePosition|visiblePositionASL|visibleScoretable|visibleWatch|waitUntil|waves|waypointAttachedObject|waypointAttachedVehicle|waypointAttachObject|waypointAttachVehicle|waypointBehaviour|waypointCombatMode|waypointCompletionRadius|waypointDescription|waypointForceBehaviour|waypointFormation|waypointHousePosition|waypointLoiterRadius|waypointLoiterType|waypointName|waypointPosition|waypoints|waypointScript|waypointsEnabledUAV|waypointShow|waypointSpeed|waypointStatements|waypointTimeout|waypointTimeoutCurrent|waypointType|waypointVisible|weaponAccessories|weaponAccessoriesCargo|weaponCargo|weaponDirection|weaponInertia|weaponLowered|weapons|weaponsItems|weaponsItemsCargo|weaponState|weaponsTurret|weightRTD|west|WFSideText|wind|windDir|windRTD|windStr|wingsForcesRTD|worldName|worldSize|worldToModel|worldToModelVisual|worldToScreen)\b/i,
      number: /(?:\$|\b0x)[\da-f]+\b|(?:\B\.\d+|\b\d+(?:\.\d+)?)(?:e[+-]?\d+)?\b/i,
      operator: /##|>>|&&|\|\||[!=<>]=?|[-+*/%#^]|\b(?:and|mod|not|or)\b/i,
      "magic-variable": {
        pattern: /\b(?:this|thisList|thisTrigger|_exception|_fnc_scriptName|_fnc_scriptNameParent|_forEachIndex|_this|_thisEventHandler|_thisFSM|_thisScript|_x)\b/i,
        alias: "keyword"
      },
      constant: /\bDIK(?:_[a-z\d]+)+\b/i
    }), t.languages.insertBefore("sqf", "string", {
      macro: {
        pattern: /(^[ \t]*)#[a-z](?:[^\r\n\\]|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: !0,
        greedy: !0,
        alias: "property",
        inside: {
          directive: {
            pattern: /#[a-z]+\b/i,
            alias: "keyword"
          },
          comment: t.languages.sqf.comment
        }
      }
    }), delete t.languages.sqf["class-name"];
  }
  return sqf_1;
}
var squirrel_1, hasRequiredSquirrel;
function requireSquirrel() {
  if (hasRequiredSquirrel) return squirrel_1;
  hasRequiredSquirrel = 1, squirrel_1 = n, n.displayName = "squirrel", n.aliases = [];
  function n(t) {
    t.languages.squirrel = t.languages.extend("clike", {
      comment: [
        t.languages.clike.comment[0],
        {
          pattern: /(^|[^\\:])(?:\/\/|#).*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(^|[^\\"'@])(?:@"(?:[^"]|"")*"(?!")|"(?:[^\\\r\n"]|\\.)*")/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:class|enum|extends|instanceof)\s+)\w+(?:\.\w+)*/,
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      },
      keyword: /\b(?:__FILE__|__LINE__|base|break|case|catch|class|clone|const|constructor|continue|default|delete|else|enum|extends|for|foreach|function|if|in|instanceof|local|null|resume|return|static|switch|this|throw|try|typeof|while|yield)\b/,
      number: /\b(?:0x[0-9a-fA-F]+|\d+(?:\.(?:\d+|[eE][+-]?\d+))?)\b/,
      operator: /\+\+|--|<=>|<[-<]|>>>?|&&?|\|\|?|[-+*/%!=<>]=?|[~^]|::?/,
      punctuation: /[(){}\[\],;.]/
    }), t.languages.insertBefore("squirrel", "string", {
      char: {
        pattern: /(^|[^\\"'])'(?:[^\\']|\\(?:[xuU][0-9a-fA-F]{0,8}|[\s\S]))'/,
        lookbehind: !0,
        greedy: !0
      }
    }), t.languages.insertBefore("squirrel", "operator", {
      "attribute-punctuation": {
        pattern: /<\/|\/>/,
        alias: "important"
      },
      lambda: {
        pattern: /@(?=\()/,
        alias: "operator"
      }
    });
  }
  return squirrel_1;
}
var stan_1, hasRequiredStan;
function requireStan() {
  if (hasRequiredStan) return stan_1;
  hasRequiredStan = 1, stan_1 = n, n.displayName = "stan", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /\b(?:algebra_solver|algebra_solver_newton|integrate_1d|integrate_ode|integrate_ode_bdf|integrate_ode_rk45|map_rect|ode_(?:adams|bdf|ckrk|rk45)(?:_tol)?|ode_adjoint_tol_ctl|reduce_sum|reduce_sum_static)\b/;
      g.languages.stan = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\/|#(?!include).*/,
        string: {
          // String literals can contain spaces and any printable ASCII characters except for " and \
          // https://mc-stan.org/docs/2_24/reference-manual/print-statements-section.html#string-literals
          pattern: /"[\x20\x21\x23-\x5B\x5D-\x7E]*"/,
          greedy: !0
        },
        directive: {
          pattern: /^([ \t]*)#include\b.*/m,
          lookbehind: !0,
          alias: "property"
        },
        "function-arg": {
          pattern: RegExp(
            "(" + d.source + /\s*\(\s*/.source + ")" + /[a-zA-Z]\w*/.source
          ),
          lookbehind: !0,
          alias: "function"
        },
        constraint: {
          pattern: /(\b(?:int|matrix|real|row_vector|vector)\s*)<[^<>]*>/,
          lookbehind: !0,
          inside: {
            expression: {
              pattern: /(=\s*)\S(?:\S|\s+(?!\s))*?(?=\s*(?:>$|,\s*\w+\s*=))/,
              lookbehind: !0,
              inside: null
              // see below
            },
            property: /\b[a-z]\w*(?=\s*=)/i,
            operator: /=/,
            punctuation: /^<|>$|,/
          }
        },
        keyword: [
          {
            pattern: /\bdata(?=\s*\{)|\b(?:functions|generated|model|parameters|quantities|transformed)\b/,
            alias: "program-block"
          },
          /\b(?:array|break|cholesky_factor_corr|cholesky_factor_cov|complex|continue|corr_matrix|cov_matrix|data|else|for|if|in|increment_log_prob|int|matrix|ordered|positive_ordered|print|real|reject|return|row_vector|simplex|target|unit_vector|vector|void|while)\b/,
          // these are functions that are known to take another function as their first argument.
          d
        ],
        function: /\b[a-z]\w*(?=\s*\()/i,
        number: /(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:E[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        boolean: /\b(?:false|true)\b/,
        operator: /<-|\.[*/]=?|\|\|?|&&|[!=<>+\-*/]=?|['^%~?:]/,
        punctuation: /[()\[\]{},;]/
      }, g.languages.stan.constraint.inside.expression.inside = g.languages.stan;
    })(t);
  }
  return stan_1;
}
var stylus_1, hasRequiredStylus;
function requireStylus() {
  if (hasRequiredStylus) return stylus_1;
  hasRequiredStylus = 1, stylus_1 = n, n.displayName = "stylus", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = {
        pattern: /(\b\d+)(?:%|[a-z]+)/,
        lookbehind: !0
      }, k = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: !0
      }, H = {
        comment: {
          pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
          lookbehind: !0
        },
        url: {
          pattern: /\burl\((["']?).*?\1\)/i,
          greedy: !0
        },
        string: {
          pattern: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
          greedy: !0
        },
        interpolation: null,
        // See below
        func: null,
        // See below
        important: /\B!(?:important|optional)\b/i,
        keyword: {
          pattern: /(^|\s+)(?:(?:else|for|if|return|unless)(?=\s|$)|@[\w-]+)/,
          lookbehind: !0
        },
        hexcode: /#[\da-f]{3,6}/i,
        color: [
          /\b(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)\b/i,
          {
            pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
            inside: {
              unit: d,
              number: k,
              function: /[\w-]+(?=\()/,
              punctuation: /[(),]/
            }
          }
        ],
        entity: /\\[\da-f]{1,8}/i,
        unit: d,
        boolean: /\b(?:false|true)\b/,
        operator: [
          // We want non-word chars around "-" because it is
          // accepted in property names.
          /~|[+!\/%<>?=]=?|[-:]=|\*[*=]?|\.{2,3}|&&|\|\||\B-\B|\b(?:and|in|is(?: a| defined| not|nt)?|not|or)\b/
        ],
        number: k,
        punctuation: /[{}()\[\];:,]/
      };
      H.interpolation = {
        pattern: /\{[^\r\n}:]+\}/,
        alias: "variable",
        inside: {
          delimiter: {
            pattern: /^\{|\}$/,
            alias: "punctuation"
          },
          rest: H
        }
      }, H.func = {
        pattern: /[\w-]+\([^)]*\).*/,
        inside: {
          function: /^[^(]+/,
          rest: H
        }
      }, g.languages.stylus = {
        "atrule-declaration": {
          pattern: /(^[ \t]*)@.+/m,
          lookbehind: !0,
          inside: {
            atrule: /^@[\w-]+/,
            rest: H
          }
        },
        "variable-declaration": {
          pattern: /(^[ \t]*)[\w$-]+\s*.?=[ \t]*(?:\{[^{}]*\}|\S.*|$)/m,
          lookbehind: !0,
          inside: {
            variable: /^\S+/,
            rest: H
          }
        },
        statement: {
          pattern: /(^[ \t]*)(?:else|for|if|return|unless)[ \t].+/m,
          lookbehind: !0,
          inside: {
            keyword: /^\S+/,
            rest: H
          }
        },
        // A property/value pair cannot end with a comma or a brace
        // It cannot have indented content unless it ended with a semicolon
        "property-declaration": {
          pattern: /((?:^|\{)([ \t]*))(?:[\w-]|\{[^}\r\n]+\})+(?:\s*:\s*|[ \t]+)(?!\s)[^{\r\n]*(?:;|[^{\r\n,]$(?!(?:\r?\n|\r)(?:\{|\2[ \t])))/m,
          lookbehind: !0,
          inside: {
            property: {
              pattern: /^[^\s:]+/,
              inside: {
                interpolation: H.interpolation
              }
            },
            rest: H
          }
        },
        // A selector can contain parentheses only as part of a pseudo-element
        // It can span multiple lines.
        // It must end with a comma or an accolade or have indented content.
        selector: {
          pattern: /(^[ \t]*)(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)(?:(?:\r?\n|\r)(?:\1(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)))*(?:,$|\{|(?=(?:\r?\n|\r)(?:\{|\1[ \t])))/m,
          lookbehind: !0,
          inside: {
            interpolation: H.interpolation,
            comment: H.comment,
            punctuation: /[{},]/
          }
        },
        func: H.func,
        string: H.string,
        comment: {
          pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
          lookbehind: !0,
          greedy: !0
        },
        interpolation: H.interpolation,
        punctuation: /[{}()\[\];:.]/
      };
    })(t);
  }
  return stylus_1;
}
var swift_1, hasRequiredSwift;
function requireSwift() {
  if (hasRequiredSwift) return swift_1;
  hasRequiredSwift = 1, swift_1 = n, n.displayName = "swift", n.aliases = [];
  function n(t) {
    t.languages.swift = {
      comment: {
        // Nested comments are supported up to 2 levels
        pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
        lookbehind: !0,
        greedy: !0
      },
      "string-literal": [
        // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
        {
          pattern: RegExp(
            /(^|[^"#])/.source + "(?:" + // single-line string
            /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + // multi-line string
            /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
              lookbehind: !0,
              inside: null
              // see below
            },
            "interpolation-punctuation": {
              pattern: /^\)|\\\($/,
              alias: "punctuation"
            },
            punctuation: /\\(?=[\r\n])/,
            string: /[\s\S]+/
          }
        },
        {
          pattern: RegExp(
            /(^|[^"#])(#+)/.source + "(?:" + // single-line string
            /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + // multi-line string
            /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
              lookbehind: !0,
              inside: null
              // see below
            },
            "interpolation-punctuation": {
              pattern: /^\)|\\#+\($/,
              alias: "punctuation"
            },
            string: /[\s\S]+/
          }
        }
      ],
      directive: {
        // directives with conditions
        pattern: RegExp(
          /#/.source + "(?:" + (/(?:elseif|if)\b/.source + "(?:[ 	]*" + // This regex is a little complex. It's equivalent to this:
          //   (?:![ \t]*)?(?:\b\w+\b(?:[ \t]*<round>)?|<round>)(?:[ \t]*(?:&&|\|\|))?
          // where <round> is a general parentheses expression.
          /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+") + "|" + /(?:else|endif)\b/.source + ")"
        ),
        alias: "property",
        inside: {
          "directive-name": /^#\w+/,
          boolean: /\b(?:false|true)\b/,
          number: /\b\d+(?:\.\d+)*\b/,
          operator: /!|&&|\|\||[<>]=?/,
          punctuation: /[(),]/
        }
      },
      literal: {
        pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
        alias: "constant"
      },
      "other-directive": {
        pattern: /#\w+\b/,
        alias: "property"
      },
      attribute: {
        pattern: /@\w+/,
        alias: "atrule"
      },
      "function-definition": {
        pattern: /(\bfunc\s+)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      label: {
        // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
        pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
        lookbehind: !0,
        alias: "important"
      },
      keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
      boolean: /\b(?:false|true)\b/,
      nil: {
        pattern: /\bnil\b/,
        alias: "constant"
      },
      "short-argument": /\$\d+\b/,
      omit: {
        pattern: /\b_\b/,
        alias: "keyword"
      },
      number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
      // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
      "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
      // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
      // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
      // This regex only supports ASCII operators.
      operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
      punctuation: /[{}[\]();,.:\\]/
    }, t.languages.swift["string-literal"].forEach(function(g) {
      g.inside.interpolation.inside = t.languages.swift;
    });
  }
  return swift_1;
}
var systemd_1, hasRequiredSystemd;
function requireSystemd() {
  if (hasRequiredSystemd) return systemd_1;
  hasRequiredSystemd = 1, systemd_1 = n, n.displayName = "systemd", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = {
        pattern: /^[;#].*/m,
        greedy: !0
      }, k = /"(?:[^\r\n"\\]|\\(?:[^\r]|\r\n?))*"(?!\S)/.source;
      g.languages.systemd = {
        comment: d,
        section: {
          pattern: /^\[[^\n\r\[\]]*\](?=[ \t]*$)/m,
          greedy: !0,
          inside: {
            punctuation: /^\[|\]$/,
            "section-name": {
              pattern: /[\s\S]+/,
              alias: "selector"
            }
          }
        },
        key: {
          pattern: /^[^\s=]+(?=[ \t]*=)/m,
          greedy: !0,
          alias: "attr-name"
        },
        value: {
          // This pattern is quite complex because of two properties:
          //  1) Quotes (strings) must be preceded by a space. Since we can't use lookbehinds, we have to "resolve"
          //     the lookbehind. You will see this in the main loop where spaces are handled separately.
          //  2) Line continuations.
          //     After line continuations, empty lines and comments are ignored so we have to consume them.
          pattern: RegExp(
            /(=[ \t]*(?!\s))/.source + // the value either starts with quotes or not
            "(?:" + k + `|(?=[^"\r
]))(?:` + (/[^\s\\]/.source + // handle spaces separately because of quotes
            '|[ 	]+(?:(?![ 	"])|' + k + ")|" + /\\[\r\n]+(?:[#;].*[\r\n]+)*(?![#;])/.source) + ")*"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "attr-value",
          inside: {
            comment: d,
            quoted: {
              pattern: RegExp(/(^|\s)/.source + k),
              lookbehind: !0,
              greedy: !0
            },
            punctuation: /\\$/m,
            boolean: {
              pattern: /^(?:false|no|off|on|true|yes)$/,
              greedy: !0
            }
          }
        },
        punctuation: /=/
      };
    })(t);
  }
  return systemd_1;
}
var t4Templating_1, hasRequiredT4Templating;
function requireT4Templating() {
  if (hasRequiredT4Templating) return t4Templating_1;
  hasRequiredT4Templating = 1, t4Templating_1 = n, n.displayName = "t4Templating", n.aliases = [];
  function n(t) {
    (function(g) {
      function d(H, AA, gA) {
        return {
          pattern: RegExp("<#" + H + "[\\s\\S]*?#>"),
          alias: "block",
          inside: {
            delimiter: {
              pattern: RegExp("^<#" + H + "|#>$"),
              alias: "important"
            },
            content: {
              pattern: /[\s\S]+/,
              inside: AA,
              alias: gA
            }
          }
        };
      }
      function k(H) {
        var AA = g.languages[H], gA = "language-" + H;
        return {
          block: {
            pattern: /<#[\s\S]+?#>/,
            inside: {
              directive: d("@", {
                "attr-value": {
                  pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/,
                  inside: {
                    punctuation: /^=|^["']|["']$/
                  }
                },
                keyword: /\b\w+(?=\s)/,
                "attr-name": /\b\w+/
              }),
              expression: d("=", AA, gA),
              "class-feature": d("\\+", AA, gA),
              standard: d("", AA, gA)
            }
          }
        };
      }
      g.languages["t4-templating"] = Object.defineProperty({}, "createT4", {
        value: k
      });
    })(t);
  }
  return t4Templating_1;
}
var t4Cs_1, hasRequiredT4Cs;
function requireT4Cs() {
  if (hasRequiredT4Cs) return t4Cs_1;
  hasRequiredT4Cs = 1;
  var n = requireT4Templating(), t = requireCsharp();
  t4Cs_1 = g, g.displayName = "t4Cs", g.aliases = [];
  function g(d) {
    d.register(n), d.register(t), d.languages.t4 = d.languages["t4-cs"] = d.languages["t4-templating"].createT4("csharp");
  }
  return t4Cs_1;
}
var vbnet_1, hasRequiredVbnet;
function requireVbnet() {
  if (hasRequiredVbnet) return vbnet_1;
  hasRequiredVbnet = 1;
  var n = requireBasic();
  vbnet_1 = t, t.displayName = "vbnet", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.vbnet = g.languages.extend("basic", {
      comment: [
        {
          pattern: /(?:!|REM\b).+/i,
          inside: {
            keyword: /^REM/i
          }
        },
        {
          pattern: /(^|[^\\:])'.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(^|[^"])"(?:""|[^"])*"(?!")/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /(?:\b(?:ADDHANDLER|ADDRESSOF|ALIAS|AND|ANDALSO|AS|BEEP|BLOAD|BOOLEAN|BSAVE|BYREF|BYTE|BYVAL|CALL(?: ABSOLUTE)?|CASE|CATCH|CBOOL|CBYTE|CCHAR|CDATE|CDBL|CDEC|CHAIN|CHAR|CHDIR|CINT|CLASS|CLEAR|CLNG|CLOSE|CLS|COBJ|COM|COMMON|CONST|CONTINUE|CSBYTE|CSHORT|CSNG|CSTR|CTYPE|CUINT|CULNG|CUSHORT|DATA|DATE|DECIMAL|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DEFAULT|DELEGATE|DIM|DIRECTCAST|DO|DOUBLE|ELSE|ELSEIF|END|ENUM|ENVIRON|ERASE|ERROR|EVENT|EXIT|FALSE|FIELD|FILES|FINALLY|FOR(?: EACH)?|FRIEND|FUNCTION|GET|GETTYPE|GETXMLNAMESPACE|GLOBAL|GOSUB|GOTO|HANDLES|IF|IMPLEMENTS|IMPORTS|IN|INHERITS|INPUT|INTEGER|INTERFACE|IOCTL|IS|ISNOT|KEY|KILL|LET|LIB|LIKE|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|ME|MKDIR|MOD|MODULE|MUSTINHERIT|MUSTOVERRIDE|MYBASE|MYCLASS|NAME|NAMESPACE|NARROWING|NEW|NEXT|NOT|NOTHING|NOTINHERITABLE|NOTOVERRIDABLE|OBJECT|OF|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPERATOR|OPTION(?: BASE)?|OPTIONAL|OR|ORELSE|OUT|OVERLOADS|OVERRIDABLE|OVERRIDES|PARAMARRAY|PARTIAL|POKE|PRIVATE|PROPERTY|PROTECTED|PUBLIC|PUT|RAISEEVENT|READ|READONLY|REDIM|REM|REMOVEHANDLER|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SBYTE|SELECT(?: CASE)?|SET|SHADOWS|SHARED|SHELL|SHORT|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|STRUCTURE|SUB|SWAP|SYNCLOCK|SYSTEM|THEN|THROW|TIMER|TO|TROFF|TRON|TRUE|TRY|TRYCAST|TYPE|TYPEOF|UINTEGER|ULONG|UNLOCK|UNTIL|USHORT|USING|VIEW PRINT|WAIT|WEND|WHEN|WHILE|WIDENING|WITH|WITHEVENTS|WRITE|WRITEONLY|XOR)|\B(?:#CONST|#ELSE|#ELSEIF|#END|#IF))(?:\$|\b)/i,
      punctuation: /[,;:(){}]/
    });
  }
  return vbnet_1;
}
var t4Vb_1, hasRequiredT4Vb;
function requireT4Vb() {
  if (hasRequiredT4Vb) return t4Vb_1;
  hasRequiredT4Vb = 1;
  var n = requireT4Templating(), t = requireVbnet();
  t4Vb_1 = g, g.displayName = "t4Vb", g.aliases = [];
  function g(d) {
    d.register(n), d.register(t), d.languages["t4-vb"] = d.languages["t4-templating"].createT4("vbnet");
  }
  return t4Vb_1;
}
var yaml_1, hasRequiredYaml;
function requireYaml() {
  if (hasRequiredYaml) return yaml_1;
  hasRequiredYaml = 1, yaml_1 = n, n.displayName = "yaml", n.aliases = ["yml"];
  function n(t) {
    (function(g) {
      var d = /[*&][^\s[\]{},]+/, k = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, H = "(?:" + k.source + "(?:[ 	]+" + d.source + ")?|" + d.source + "(?:[ 	]+" + k.source + ")?)", AA = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(
        /<PLAIN>/g,
        function() {
          return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
        }
      ), gA = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
      function IA(CA, BA) {
        BA = (BA || "").replace(/m/g, "") + "m";
        var eA = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
          return H;
        }).replace(/<<value>>/g, function() {
          return CA;
        });
        return RegExp(eA, BA);
      }
      g.languages.yaml = {
        scalar: {
          pattern: RegExp(
            /([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(
              /<<prop>>/g,
              function() {
                return H;
              }
            )
          ),
          lookbehind: !0,
          alias: "string"
        },
        comment: /#.*/,
        key: {
          pattern: RegExp(
            /((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
              return H;
            }).replace(/<<key>>/g, function() {
              return "(?:" + AA + "|" + gA + ")";
            })
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "atrule"
        },
        directive: {
          pattern: /(^[ \t]*)%.+/m,
          lookbehind: !0,
          alias: "important"
        },
        datetime: {
          pattern: IA(
            /\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source
          ),
          lookbehind: !0,
          alias: "number"
        },
        boolean: {
          pattern: IA(/false|true/.source, "i"),
          lookbehind: !0,
          alias: "important"
        },
        null: {
          pattern: IA(/null|~/.source, "i"),
          lookbehind: !0,
          alias: "important"
        },
        string: {
          pattern: IA(gA),
          lookbehind: !0,
          greedy: !0
        },
        number: {
          pattern: IA(
            /[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source,
            "i"
          ),
          lookbehind: !0
        },
        tag: k,
        important: d,
        punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
      }, g.languages.yml = g.languages.yaml;
    })(t);
  }
  return yaml_1;
}
var tap_1, hasRequiredTap;
function requireTap() {
  if (hasRequiredTap) return tap_1;
  hasRequiredTap = 1;
  var n = requireYaml();
  tap_1 = t, t.displayName = "tap", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.tap = {
      fail: /not ok[^#{\n\r]*/,
      pass: /ok[^#{\n\r]*/,
      pragma: /pragma [+-][a-z]+/,
      bailout: /bail out!.*/i,
      version: /TAP version \d+/i,
      plan: /\b\d+\.\.\d+(?: +#.*)?/,
      subtest: {
        pattern: /# Subtest(?:: .*)?/,
        greedy: !0
      },
      punctuation: /[{}]/,
      directive: /#.*/,
      yamlish: {
        pattern: /(^[ \t]*)---[\s\S]*?[\r\n][ \t]*\.\.\.$/m,
        lookbehind: !0,
        inside: g.languages.yaml,
        alias: "language-yaml"
      }
    };
  }
  return tap_1;
}
var tcl_1, hasRequiredTcl;
function requireTcl() {
  if (hasRequiredTcl) return tcl_1;
  hasRequiredTcl = 1, tcl_1 = n, n.displayName = "tcl", n.aliases = [];
  function n(t) {
    t.languages.tcl = {
      comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: !0
      },
      string: {
        pattern: /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"/,
        greedy: !0
      },
      variable: [
        {
          pattern: /(\$)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/,
          lookbehind: !0
        },
        {
          pattern: /(\$)\{[^}]+\}/,
          lookbehind: !0
        },
        {
          pattern: /(^[\t ]*set[ \t]+)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/m,
          lookbehind: !0
        }
      ],
      function: {
        pattern: /(^[\t ]*proc[ \t]+)\S+/m,
        lookbehind: !0
      },
      builtin: [
        {
          pattern: /(^[\t ]*)(?:break|class|continue|error|eval|exit|for|foreach|if|proc|return|switch|while)\b/m,
          lookbehind: !0
        },
        /\b(?:else|elseif)\b/
      ],
      scope: {
        pattern: /(^[\t ]*)(?:global|upvar|variable)\b/m,
        lookbehind: !0,
        alias: "constant"
      },
      keyword: {
        pattern: /(^[\t ]*|\[)(?:Safe_Base|Tcl|after|append|apply|array|auto_(?:execok|import|load|mkindex|qualify|reset)|automkindex_old|bgerror|binary|catch|cd|chan|clock|close|concat|dde|dict|encoding|eof|exec|expr|fblocked|fconfigure|fcopy|file(?:event|name)?|flush|gets|glob|history|http|incr|info|interp|join|lappend|lassign|lindex|linsert|list|llength|load|lrange|lrepeat|lreplace|lreverse|lsearch|lset|lsort|math(?:func|op)|memory|msgcat|namespace|open|package|parray|pid|pkg_mkIndex|platform|puts|pwd|re_syntax|read|refchan|regexp|registry|regsub|rename|scan|seek|set|socket|source|split|string|subst|tcl(?:_endOfWord|_findLibrary|startOf(?:Next|Previous)Word|test|vars|wordBreak(?:After|Before))|tell|time|tm|trace|unknown|unload|unset|update|uplevel|vwait)\b/m,
        lookbehind: !0
      },
      operator: /!=?|\*\*?|==|&&?|\|\|?|<[=<]?|>[=>]?|[-+~\/%?^]|\b(?:eq|in|ne|ni)\b/,
      punctuation: /[{}()\[\]]/
    };
  }
  return tcl_1;
}
var textile_1, hasRequiredTextile;
function requireTextile() {
  if (hasRequiredTextile) return textile_1;
  hasRequiredTextile = 1, textile_1 = n, n.displayName = "textile", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /\([^|()\n]+\)|\[[^\]\n]+\]|\{[^}\n]+\}/.source, k = /\)|\((?![^|()\n]+\))/.source;
      function H(iA, QA) {
        return RegExp(
          iA.replace(/<MOD>/g, function() {
            return "(?:" + d + ")";
          }).replace(/<PAR>/g, function() {
            return "(?:" + k + ")";
          }),
          QA || ""
        );
      }
      var AA = {
        css: {
          pattern: /\{[^{}]+\}/,
          inside: {
            rest: g.languages.css
          }
        },
        "class-id": {
          pattern: /(\()[^()]+(?=\))/,
          lookbehind: !0,
          alias: "attr-value"
        },
        lang: {
          pattern: /(\[)[^\[\]]+(?=\])/,
          lookbehind: !0,
          alias: "attr-value"
        },
        // Anything else is punctuation (the first pattern is for row/col spans inside tables)
        punctuation: /[\\\/]\d+|\S/
      }, gA = g.languages.textile = g.languages.extend("markup", {
        phrase: {
          pattern: /(^|\r|\n)\S[\s\S]*?(?=$|\r?\n\r?\n|\r\r)/,
          lookbehind: !0,
          inside: {
            // h1. Header 1
            "block-tag": {
              pattern: H(/^[a-z]\w*(?:<MOD>|<PAR>|[<>=])*\./.source),
              inside: {
                modifier: {
                  pattern: H(
                    /(^[a-z]\w*)(?:<MOD>|<PAR>|[<>=])+(?=\.)/.source
                  ),
                  lookbehind: !0,
                  inside: AA
                },
                tag: /^[a-z]\w*/,
                punctuation: /\.$/
              }
            },
            // # List item
            // * List item
            list: {
              pattern: H(/^[*#]+<MOD>*\s+\S.*/.source, "m"),
              inside: {
                modifier: {
                  pattern: H(/(^[*#]+)<MOD>+/.source),
                  lookbehind: !0,
                  inside: AA
                },
                punctuation: /^[*#]+/
              }
            },
            // | cell | cell | cell |
            table: {
              // Modifiers can be applied to the row: {color:red}.|1|2|3|
              // or the cell: |{color:red}.1|2|3|
              pattern: H(
                /^(?:(?:<MOD>|<PAR>|[<>=^~])+\.\s*)?(?:\|(?:(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.|(?!(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.))[^|]*)+\|/.source,
                "m"
              ),
              inside: {
                modifier: {
                  // Modifiers for rows after the first one are
                  // preceded by a pipe and a line feed
                  pattern: H(
                    /(^|\|(?:\r?\n|\r)?)(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+(?=\.)/.source
                  ),
                  lookbehind: !0,
                  inside: AA
                },
                punctuation: /\||^\./
              }
            },
            inline: {
              // eslint-disable-next-line regexp/no-super-linear-backtracking
              pattern: H(
                /(^|[^a-zA-Z\d])(\*\*|__|\?\?|[*_%@+\-^~])<MOD>*.+?\2(?![a-zA-Z\d])/.source
              ),
              lookbehind: !0,
              inside: {
                // Note: superscripts and subscripts are not handled specifically
                // *bold*, **bold**
                bold: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: H(/(^(\*\*?)<MOD>*).+?(?=\2)/.source),
                  lookbehind: !0
                },
                // _italic_, __italic__
                italic: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: H(/(^(__?)<MOD>*).+?(?=\2)/.source),
                  lookbehind: !0
                },
                // ??cite??
                cite: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: H(/(^\?\?<MOD>*).+?(?=\?\?)/.source),
                  lookbehind: !0,
                  alias: "string"
                },
                // @code@
                code: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: H(/(^@<MOD>*).+?(?=@)/.source),
                  lookbehind: !0,
                  alias: "keyword"
                },
                // +inserted+
                inserted: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: H(/(^\+<MOD>*).+?(?=\+)/.source),
                  lookbehind: !0
                },
                // -deleted-
                deleted: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: H(/(^-<MOD>*).+?(?=-)/.source),
                  lookbehind: !0
                },
                // %span%
                span: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: H(/(^%<MOD>*).+?(?=%)/.source),
                  lookbehind: !0
                },
                modifier: {
                  pattern: H(
                    /(^\*\*|__|\?\?|[*_%@+\-^~])<MOD>+/.source
                  ),
                  lookbehind: !0,
                  inside: AA
                },
                punctuation: /[*_%?@+\-^~]+/
              }
            },
            // [alias]http://example.com
            "link-ref": {
              pattern: /^\[[^\]]+\]\S+$/m,
              inside: {
                string: {
                  pattern: /(^\[)[^\]]+(?=\])/,
                  lookbehind: !0
                },
                url: {
                  pattern: /(^\])\S+$/,
                  lookbehind: !0
                },
                punctuation: /[\[\]]/
              }
            },
            // "text":http://example.com
            // "text":link-ref
            link: {
              // eslint-disable-next-line regexp/no-super-linear-backtracking
              pattern: H(
                /"<MOD>*[^"]+":.+?(?=[^\w/]?(?:\s|$))/.source
              ),
              inside: {
                text: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: H(/(^"<MOD>*)[^"]+(?=")/.source),
                  lookbehind: !0
                },
                modifier: {
                  pattern: H(/(^")<MOD>+/.source),
                  lookbehind: !0,
                  inside: AA
                },
                url: {
                  pattern: /(:).+/,
                  lookbehind: !0
                },
                punctuation: /[":]/
              }
            },
            // !image.jpg!
            // !image.jpg(Title)!:http://example.com
            image: {
              pattern: H(
                /!(?:<MOD>|<PAR>|[<>=])*(?![<>=])[^!\s()]+(?:\([^)]+\))?!(?::.+?(?=[^\w/]?(?:\s|$)))?/.source
              ),
              inside: {
                source: {
                  pattern: H(
                    /(^!(?:<MOD>|<PAR>|[<>=])*)(?![<>=])[^!\s()]+(?:\([^)]+\))?(?=!)/.source
                  ),
                  lookbehind: !0,
                  alias: "url"
                },
                modifier: {
                  pattern: H(/(^!)(?:<MOD>|<PAR>|[<>=])+/.source),
                  lookbehind: !0,
                  inside: AA
                },
                url: {
                  pattern: /(:).+/,
                  lookbehind: !0
                },
                punctuation: /[!:]/
              }
            },
            // Footnote[1]
            footnote: {
              pattern: /\b\[\d+\]/,
              alias: "comment",
              inside: {
                punctuation: /\[|\]/
              }
            },
            // CSS(Cascading Style Sheet)
            acronym: {
              pattern: /\b[A-Z\d]+\([^)]+\)/,
              inside: {
                comment: {
                  pattern: /(\()[^()]+(?=\))/,
                  lookbehind: !0
                },
                punctuation: /[()]/
              }
            },
            // Prism(C)
            mark: {
              pattern: /\b\((?:C|R|TM)\)/,
              alias: "comment",
              inside: {
                punctuation: /[()]/
              }
            }
          }
        }
      }), IA = gA.phrase.inside, CA = {
        inline: IA.inline,
        link: IA.link,
        image: IA.image,
        footnote: IA.footnote,
        acronym: IA.acronym,
        mark: IA.mark
      };
      gA.tag.pattern = /<\/?(?!\d)[a-z0-9]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i;
      var BA = IA.inline.inside;
      BA.bold.inside = CA, BA.italic.inside = CA, BA.inserted.inside = CA, BA.deleted.inside = CA, BA.span.inside = CA;
      var eA = IA.table.inside;
      eA.inline = CA.inline, eA.link = CA.link, eA.image = CA.image, eA.footnote = CA.footnote, eA.acronym = CA.acronym, eA.mark = CA.mark;
    })(t);
  }
  return textile_1;
}
var toml_1, hasRequiredToml;
function requireToml() {
  if (hasRequiredToml) return toml_1;
  hasRequiredToml = 1, toml_1 = n, n.displayName = "toml", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /(?:[\w-]+|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*")/.source;
      function k(H) {
        return H.replace(/__/g, function() {
          return d;
        });
      }
      g.languages.toml = {
        comment: {
          pattern: /#.*/,
          greedy: !0
        },
        table: {
          pattern: RegExp(
            k(
              /(^[\t ]*\[\s*(?:\[\s*)?)__(?:\s*\.\s*__)*(?=\s*\])/.source
            ),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "class-name"
        },
        key: {
          pattern: RegExp(
            k(/(^[\t ]*|[{,]\s*)__(?:\s*\.\s*__)*(?=\s*=)/.source),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "property"
        },
        string: {
          pattern: /"""(?:\\[\s\S]|[^\\])*?"""|'''[\s\S]*?'''|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*"/,
          greedy: !0
        },
        date: [
          {
            // Offset Date-Time, Local Date-Time, Local Date
            pattern: /\b\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?\b/i,
            alias: "number"
          },
          {
            // Local Time
            pattern: /\b\d{2}:\d{2}:\d{2}(?:\.\d+)?\b/,
            alias: "number"
          }
        ],
        number: /(?:\b0(?:x[\da-zA-Z]+(?:_[\da-zA-Z]+)*|o[0-7]+(?:_[0-7]+)*|b[10]+(?:_[10]+)*))\b|[-+]?\b\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?\b|[-+]?\b(?:inf|nan)\b/,
        boolean: /\b(?:false|true)\b/,
        punctuation: /[.,=[\]{}]/
      };
    })(t);
  }
  return toml_1;
}
var tremor_1, hasRequiredTremor;
function requireTremor() {
  if (hasRequiredTremor) return tremor_1;
  hasRequiredTremor = 1, tremor_1 = n, n.displayName = "tremor", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.tremor = {
        comment: {
          pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
          lookbehind: !0
        },
        "interpolated-string": null,
        // see below
        extractor: {
          pattern: /\b[a-z_]\w*\|(?:[^\r\n\\|]|\\(?:\r\n|[\s\S]))*\|/i,
          greedy: !0,
          inside: {
            regex: {
              pattern: /(^re)\|[\s\S]+/,
              lookbehind: !0
            },
            function: /^\w+/,
            value: /\|[\s\S]+/
          }
        },
        identifier: {
          pattern: /`[^`]*`/,
          greedy: !0
        },
        function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())\b/,
        keyword: /\b(?:args|as|by|case|config|connect|connector|const|copy|create|default|define|deploy|drop|each|emit|end|erase|event|flow|fn|for|from|group|having|insert|into|intrinsic|let|links|match|merge|mod|move|of|operator|patch|pipeline|recur|script|select|set|sliding|state|stream|to|tumbling|update|use|when|where|window|with)\b/,
        boolean: /\b(?:false|null|true)\b/i,
        number: /\b(?:0b[01_]*|0x[0-9a-fA-F_]*|\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee][+-]?[\d_]+)?)\b/,
        "pattern-punctuation": {
          pattern: /%(?=[({[])/,
          alias: "punctuation"
        },
        operator: /[-+*\/%~!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?>?=?|(?:absent|and|not|or|present|xor)\b/,
        punctuation: /::|[;\[\]()\{\},.:]/
      };
      var d = /#\{(?:[^"{}]|\{[^{}]*\}|"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*")*\}/.source;
      g.languages.tremor["interpolated-string"] = {
        pattern: RegExp(
          /(^|[^\\])/.source + '(?:"""(?:' + /[^"\\#]|\\[\s\S]|"(?!"")|#(?!\{)/.source + "|" + d + ')*"""|"(?:' + /[^"\\\r\n#]|\\(?:\r\n|[\s\S])|#(?!\{)/.source + "|" + d + ')*")'
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: RegExp(d),
            inside: {
              punctuation: /^#\{|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                inside: g.languages.tremor
              }
            }
          },
          string: /[\s\S]+/
        }
      }, g.languages.troy = g.languages.tremor, g.languages.trickle = g.languages.tremor;
    })(t);
  }
  return tremor_1;
}
var tsx_1, hasRequiredTsx;
function requireTsx() {
  if (hasRequiredTsx) return tsx_1;
  hasRequiredTsx = 1;
  var n = requireJsx(), t = requireTypescript();
  tsx_1 = g, g.displayName = "tsx", g.aliases = [];
  function g(d) {
    d.register(n), d.register(t), (function(k) {
      var H = k.util.clone(k.languages.typescript);
      k.languages.tsx = k.languages.extend("jsx", H), delete k.languages.tsx.parameter, delete k.languages.tsx["literal-property"];
      var AA = k.languages.tsx.tag;
      AA.pattern = RegExp(
        /(^|[^\w$]|(?=<\/))/.source + "(?:" + AA.pattern.source + ")",
        AA.pattern.flags
      ), AA.lookbehind = !0;
    })(d);
  }
  return tsx_1;
}
var tt2_1, hasRequiredTt2;
function requireTt2() {
  if (hasRequiredTt2) return tt2_1;
  hasRequiredTt2 = 1;
  var n = requireMarkupTemplating();
  tt2_1 = t, t.displayName = "tt2", t.aliases = [];
  function t(g) {
    g.register(n), (function(d) {
      d.languages.tt2 = d.languages.extend("clike", {
        comment: /#.*|\[%#[\s\S]*?%\]/,
        keyword: /\b(?:BLOCK|CALL|CASE|CATCH|CLEAR|DEBUG|DEFAULT|ELSE|ELSIF|END|FILTER|FINAL|FOREACH|GET|IF|IN|INCLUDE|INSERT|LAST|MACRO|META|NEXT|PERL|PROCESS|RAWPERL|RETURN|SET|STOP|SWITCH|TAGS|THROW|TRY|UNLESS|USE|WHILE|WRAPPER)\b/,
        punctuation: /[[\]{},()]/
      }), d.languages.insertBefore("tt2", "number", {
        operator: /=[>=]?|!=?|<=?|>=?|&&|\|\|?|\b(?:and|not|or)\b/,
        variable: {
          pattern: /\b[a-z]\w*(?:\s*\.\s*(?:\d+|\$?[a-z]\w*))*\b/i
        }
      }), d.languages.insertBefore("tt2", "keyword", {
        delimiter: {
          pattern: /^(?:\[%|%%)-?|-?%\]$/,
          alias: "punctuation"
        }
      }), d.languages.insertBefore("tt2", "string", {
        "single-quoted-string": {
          pattern: /'[^\\']*(?:\\[\s\S][^\\']*)*'/,
          greedy: !0,
          alias: "string"
        },
        "double-quoted-string": {
          pattern: /"[^\\"]*(?:\\[\s\S][^\\"]*)*"/,
          greedy: !0,
          alias: "string",
          inside: {
            variable: {
              pattern: /\$(?:[a-z]\w*(?:\.(?:\d+|\$?[a-z]\w*))*)/i
            }
          }
        }
      }), delete d.languages.tt2.string, d.hooks.add("before-tokenize", function(k) {
        var H = /\[%[\s\S]+?%\]/g;
        d.languages["markup-templating"].buildPlaceholders(
          k,
          "tt2",
          H
        );
      }), d.hooks.add("after-tokenize", function(k) {
        d.languages["markup-templating"].tokenizePlaceholders(k, "tt2");
      });
    })(g);
  }
  return tt2_1;
}
var twig_1, hasRequiredTwig;
function requireTwig() {
  if (hasRequiredTwig) return twig_1;
  hasRequiredTwig = 1;
  var n = requireMarkupTemplating();
  twig_1 = t, t.displayName = "twig", t.aliases = [];
  function t(g) {
    g.register(n), g.languages.twig = {
      comment: /^\{#[\s\S]*?#\}$/,
      "tag-name": {
        pattern: /(^\{%-?\s*)\w+/,
        lookbehind: !0,
        alias: "keyword"
      },
      delimiter: {
        pattern: /^\{[{%]-?|-?[%}]\}$/,
        alias: "punctuation"
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        inside: {
          punctuation: /^['"]|['"]$/
        }
      },
      keyword: /\b(?:even|if|odd)\b/,
      boolean: /\b(?:false|null|true)\b/,
      number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
      operator: [
        {
          pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
          lookbehind: !0
        },
        /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
      ],
      punctuation: /[()\[\]{}:.,]/
    }, g.hooks.add("before-tokenize", function(d) {
      if (d.language === "twig") {
        var k = /\{(?:#[\s\S]*?#|%[\s\S]*?%|\{[\s\S]*?\})\}/g;
        g.languages["markup-templating"].buildPlaceholders(d, "twig", k);
      }
    }), g.hooks.add("after-tokenize", function(d) {
      g.languages["markup-templating"].tokenizePlaceholders(d, "twig");
    });
  }
  return twig_1;
}
var typoscript_1, hasRequiredTyposcript;
function requireTyposcript() {
  if (hasRequiredTyposcript) return typoscript_1;
  hasRequiredTyposcript = 1, typoscript_1 = n, n.displayName = "typoscript", n.aliases = ["tsconfig"];
  function n(t) {
    (function(g) {
      var d = /\b(?:ACT|ACTIFSUB|CARRAY|CASE|CLEARGIF|COA|COA_INT|CONSTANTS|CONTENT|CUR|EDITPANEL|EFFECT|EXT|FILE|FLUIDTEMPLATE|FORM|FRAME|FRAMESET|GIFBUILDER|GMENU|GMENU_FOLDOUT|GMENU_LAYERS|GP|HMENU|HRULER|HTML|IENV|IFSUB|IMAGE|IMGMENU|IMGMENUITEM|IMGTEXT|IMG_RESOURCE|INCLUDE_TYPOSCRIPT|JSMENU|JSMENUITEM|LLL|LOAD_REGISTER|NO|PAGE|RECORDS|RESTORE_REGISTER|TEMPLATE|TEXT|TMENU|TMENUITEM|TMENU_LAYERS|USER|USER_INT|_GIFBUILDER|global|globalString|globalVar)\b/;
      g.languages.typoscript = {
        comment: [
          {
            // multiline comments /* */
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: !0
          },
          {
            // double-slash comments - ignored when backslashes or colon is found in front
            // also ignored whenever directly after an equal-sign, because it would probably be an url without protocol
            pattern: /(^|[^\\:= \t]|(?:^|[^= \t])[ \t]+)\/\/.*/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // hash comments - ignored when leading quote is found for hex colors in strings
            pattern: /(^|[^"'])#.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        function: [
          {
            // old include style
            pattern: /<INCLUDE_TYPOSCRIPT:\s*source\s*=\s*(?:"[^"\r\n]*"|'[^'\r\n]*')\s*>/,
            inside: {
              string: {
                pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                inside: {
                  keyword: d
                }
              },
              keyword: {
                pattern: /INCLUDE_TYPOSCRIPT/
              }
            }
          },
          {
            // new include style
            pattern: /@import\s*(?:"[^"\r\n]*"|'[^'\r\n]*')/,
            inside: {
              string: /"[^"\r\n]*"|'[^'\r\n]*'/
            }
          }
        ],
        string: {
          pattern: /^([^=]*=[< ]?)(?:(?!\]\n).)*/,
          lookbehind: !0,
          inside: {
            function: /\{\$.*\}/,
            // constants include
            keyword: d,
            number: /^\d+$/,
            punctuation: /[,|:]/
          }
        },
        keyword: d,
        number: {
          // special highlighting for indexes of arrays in tags
          pattern: /\b\d+\s*[.{=]/,
          inside: {
            operator: /[.{=]/
          }
        },
        tag: {
          pattern: /\.?[-\w\\]+\.?/,
          inside: {
            punctuation: /\./
          }
        },
        punctuation: /[{}[\];(),.:|]/,
        operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/
      }, g.languages.tsconfig = g.languages.typoscript;
    })(t);
  }
  return typoscript_1;
}
var unrealscript_1, hasRequiredUnrealscript;
function requireUnrealscript() {
  if (hasRequiredUnrealscript) return unrealscript_1;
  hasRequiredUnrealscript = 1, unrealscript_1 = n, n.displayName = "unrealscript", n.aliases = ["uc", "uscript"];
  function n(t) {
    t.languages.unrealscript = {
      comment: /\/\/.*|\/\*[\s\S]*?\*\//,
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      category: {
        pattern: /(\b(?:(?:autoexpand|hide|show)categories|var)\s*\()[^()]+(?=\))/,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      metadata: {
        pattern: /(\w\s*)<\s*\w+\s*=[^<>|=\r\n]+(?:\|\s*\w+\s*=[^<>|=\r\n]+)*>/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          property: /\b\w+(?=\s*=)/,
          operator: /=/,
          punctuation: /[<>|]/
        }
      },
      macro: {
        pattern: /`\w+/,
        alias: "property"
      },
      "class-name": {
        pattern: /(\b(?:class|enum|extends|interface|state(?:\(\))?|struct|within)\s+)\w+/,
        lookbehind: !0
      },
      keyword: /\b(?:abstract|actor|array|auto|autoexpandcategories|bool|break|byte|case|class|classgroup|client|coerce|collapsecategories|config|const|continue|default|defaultproperties|delegate|dependson|deprecated|do|dontcollapsecategories|editconst|editinlinenew|else|enum|event|exec|export|extends|final|float|for|forcescriptorder|foreach|function|goto|guid|hidecategories|hidedropdown|if|ignores|implements|inherits|input|int|interface|iterator|latent|local|material|name|native|nativereplication|noexport|nontransient|noteditinlinenew|notplaceable|operator|optional|out|pawn|perobjectconfig|perobjectlocalized|placeable|postoperator|preoperator|private|protected|reliable|replication|return|server|showcategories|simulated|singular|state|static|string|struct|structdefault|structdefaultproperties|switch|texture|transient|travel|unreliable|until|var|vector|while|within)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      boolean: /\b(?:false|true)\b/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      // https://docs.unrealengine.com/udk/Three/UnrealScriptExpressions.html
      operator: />>|<<|--|\+\+|\*\*|[-+*/~!=<>$@]=?|&&?|\|\|?|\^\^?|[?:%]|\b(?:ClockwiseFrom|Cross|Dot)\b/,
      punctuation: /[()[\]{};,.]/
    }, t.languages.uc = t.languages.uscript = t.languages.unrealscript;
  }
  return unrealscript_1;
}
var uorazor_1, hasRequiredUorazor;
function requireUorazor() {
  if (hasRequiredUorazor) return uorazor_1;
  hasRequiredUorazor = 1, uorazor_1 = n, n.displayName = "uorazor", n.aliases = [];
  function n(t) {
    t.languages.uorazor = {
      "comment-hash": {
        pattern: /#.*/,
        alias: "comment",
        greedy: !0
      },
      "comment-slash": {
        pattern: /\/\/.*/,
        alias: "comment",
        greedy: !0
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        inside: {
          punctuation: /^['"]|['"]$/
        },
        greedy: !0
      },
      "source-layers": {
        pattern: /\b(?:arms|backpack|blue|bracelet|cancel|clear|cloak|criminal|earrings|enemy|facialhair|friend|friendly|gloves|gray|grey|ground|hair|head|innerlegs|innertorso|innocent|lefthand|middletorso|murderer|neck|nonfriendly|onehandedsecondary|outerlegs|outertorso|pants|red|righthand|ring|self|shirt|shoes|talisman|waist)\b/i,
        alias: "function"
      },
      "source-commands": {
        pattern: /\b(?:alliance|attack|cast|clearall|clearignore|clearjournal|clearlist|clearsysmsg|createlist|createtimer|dclick|dclicktype|dclickvar|dress|dressconfig|drop|droprelloc|emote|getlabel|guild|gumpclose|gumpresponse|hotkey|ignore|lasttarget|lift|lifttype|menu|menuresponse|msg|org|organize|organizer|overhead|pause|poplist|potion|promptresponse|pushlist|removelist|removetimer|rename|restock|say|scav|scavenger|script|setability|setlasttarget|setskill|settimer|setvar|sysmsg|target|targetloc|targetrelloc|targettype|undress|unignore|unsetvar|useobject|useonce|useskill|usetype|virtue|wait|waitforgump|waitformenu|waitforprompt|waitforstat|waitforsysmsg|waitfortarget|walk|wfsysmsg|wft|whisper|yell)\b/,
        alias: "function"
      },
      "tag-name": {
        pattern: /(^\{%-?\s*)\w+/,
        lookbehind: !0,
        alias: "keyword"
      },
      delimiter: {
        pattern: /^\{[{%]-?|-?[%}]\}$/,
        alias: "punctuation"
      },
      function: /\b(?:atlist|close|closest|count|counter|counttype|dead|dex|diffhits|diffmana|diffstam|diffweight|find|findbuff|finddebuff|findlayer|findtype|findtypelist|followers|gumpexists|hidden|hits|hp|hue|human|humanoid|ingump|inlist|insysmessage|insysmsg|int|invul|lhandempty|list|listexists|mana|maxhits|maxhp|maxmana|maxstam|maxweight|monster|mounted|name|next|noto|paralyzed|poisoned|position|prev|previous|queued|rand|random|rhandempty|skill|stam|str|targetexists|timer|timerexists|varexist|warmode|weight)\b/,
      keyword: /\b(?:and|as|break|continue|else|elseif|endfor|endif|endwhile|for|if|loop|not|or|replay|stop|while)\b/,
      boolean: /\b(?:false|null|true)\b/,
      number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
      operator: [
        {
          pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
          lookbehind: !0
        },
        /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
      ],
      punctuation: /[()\[\]{}:.,]/
    };
  }
  return uorazor_1;
}
var uri_1, hasRequiredUri;
function requireUri() {
  if (hasRequiredUri) return uri_1;
  hasRequiredUri = 1, uri_1 = n, n.displayName = "uri", n.aliases = ["url"];
  function n(t) {
    t.languages.uri = {
      scheme: {
        pattern: /^[a-z][a-z0-9+.-]*:/im,
        greedy: !0,
        inside: {
          "scheme-delimiter": /:$/
        }
      },
      fragment: {
        pattern: /#[\w\-.~!$&'()*+,;=%:@/?]*/,
        inside: {
          "fragment-delimiter": /^#/
        }
      },
      query: {
        pattern: /\?[\w\-.~!$&'()*+,;=%:@/?]*/,
        inside: {
          "query-delimiter": {
            pattern: /^\?/,
            greedy: !0
          },
          "pair-delimiter": /[&;]/,
          pair: {
            pattern: /^[^=][\s\S]*/,
            inside: {
              key: /^[^=]+/,
              value: {
                pattern: /(^=)[\s\S]+/,
                lookbehind: !0
              }
            }
          }
        }
      },
      authority: {
        pattern: RegExp(
          /^\/\//.source + // [ userinfo "@" ]
          /(?:[\w\-.~!$&'()*+,;=%:]*@)?/.source + // host
          ("(?:" + // IP-literal
          /\[(?:[0-9a-fA-F:.]{2,48}|v[0-9a-fA-F]+\.[\w\-.~!$&'()*+,;=]+)\]/.source + "|" + // IPv4address or registered name
          /[\w\-.~!$&'()*+,;=%]*/.source + ")") + // [ ":" port ]
          /(?::\d*)?/.source,
          "m"
        ),
        inside: {
          "authority-delimiter": /^\/\//,
          "user-info-segment": {
            pattern: /^[\w\-.~!$&'()*+,;=%:]*@/,
            inside: {
              "user-info-delimiter": /@$/,
              "user-info": /^[\w\-.~!$&'()*+,;=%:]+/
            }
          },
          "port-segment": {
            pattern: /:\d*$/,
            inside: {
              "port-delimiter": /^:/,
              port: /^\d+/
            }
          },
          host: {
            pattern: /[\s\S]+/,
            inside: {
              "ip-literal": {
                pattern: /^\[[\s\S]+\]$/,
                inside: {
                  "ip-literal-delimiter": /^\[|\]$/,
                  "ipv-future": /^v[\s\S]+/,
                  "ipv6-address": /^[\s\S]+/
                }
              },
              "ipv4-address": /^(?:(?:[03-9]\d?|[12]\d{0,2})\.){3}(?:[03-9]\d?|[12]\d{0,2})$/
            }
          }
        }
      },
      path: {
        pattern: /^[\w\-.~!$&'()*+,;=%:@/]+/m,
        inside: {
          "path-separator": /\//
        }
      }
    }, t.languages.url = t.languages.uri;
  }
  return uri_1;
}
var v_1, hasRequiredV;
function requireV() {
  if (hasRequiredV) return v_1;
  hasRequiredV = 1, v_1 = n, n.displayName = "v", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = {
        pattern: /[\s\S]+/,
        inside: null
      };
      g.languages.v = g.languages.extend("clike", {
        string: {
          pattern: /r?(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
          alias: "quoted-string",
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[^{}]*\}|\w+(?:\.\w+(?:\([^\(\)]*\))?|\[[^\[\]]+\])*)/,
              lookbehind: !0,
              inside: {
                "interpolation-variable": {
                  pattern: /^\$\w[\s\S]*$/,
                  alias: "variable"
                },
                "interpolation-punctuation": {
                  pattern: /^\$\{|\}$/,
                  alias: "punctuation"
                },
                "interpolation-expression": d
              }
            }
          }
        },
        "class-name": {
          pattern: /(\b(?:enum|interface|struct|type)\s+)(?:C\.)?\w+/,
          lookbehind: !0
        },
        keyword: /(?:\b(?:__global|as|asm|assert|atomic|break|chan|const|continue|defer|else|embed|enum|fn|for|go(?:to)?|if|import|in|interface|is|lock|match|module|mut|none|or|pub|return|rlock|select|shared|sizeof|static|struct|type(?:of)?|union|unsafe)|\$(?:else|for|if)|#(?:flag|include))\b/,
        number: /\b(?:0x[a-f\d]+(?:_[a-f\d]+)*|0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?)\b/i,
        operator: /~|\?|[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\.?/,
        builtin: /\b(?:any(?:_float|_int)?|bool|byte(?:ptr)?|charptr|f(?:32|64)|i(?:8|16|64|128|nt)|rune|size_t|string|u(?:16|32|64|128)|voidptr)\b/
      }), d.inside = g.languages.v, g.languages.insertBefore("v", "string", {
        char: {
          pattern: /`(?:\\`|\\?[^`]{1,2})`/,
          // using {1,2} instead of `u` flag for compatibility
          alias: "rune"
        }
      }), g.languages.insertBefore("v", "operator", {
        attribute: {
          pattern: /(^[\t ]*)\[(?:deprecated|direct_array_access|flag|inline|live|ref_only|typedef|unsafe_fn|windows_stdcall)\]/m,
          lookbehind: !0,
          alias: "annotation",
          inside: {
            punctuation: /[\[\]]/,
            keyword: /\w+/
          }
        },
        generic: {
          pattern: /<\w+>(?=\s*[\)\{])/,
          inside: {
            punctuation: /[<>]/,
            "class-name": /\w+/
          }
        }
      }), g.languages.insertBefore("v", "function", {
        "generic-function": {
          // e.g. foo<T>( ...
          pattern: /\b\w+\s*<\w+>(?=\()/,
          inside: {
            function: /^\w+/,
            generic: {
              pattern: /<\w+>/,
              inside: g.languages.v.generic.inside
            }
          }
        }
      });
    })(t);
  }
  return v_1;
}
var vala_1, hasRequiredVala;
function requireVala() {
  if (hasRequiredVala) return vala_1;
  hasRequiredVala = 1, vala_1 = n, n.displayName = "vala", n.aliases = [];
  function n(t) {
    t.languages.vala = t.languages.extend("clike", {
      // Classes copied from prism-csharp
      "class-name": [
        {
          // (Foo bar, Bar baz)
          pattern: /\b[A-Z]\w*(?:\.\w+)*\b(?=(?:\?\s+|\*?\s+\*?)\w)/,
          inside: {
            punctuation: /\./
          }
        },
        {
          // [Foo]
          pattern: /(\[)[A-Z]\w*(?:\.\w+)*\b/,
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        },
        {
          // class Foo : Bar
          pattern: /(\b(?:class|interface)\s+[A-Z]\w*(?:\.\w+)*\s*:\s*)[A-Z]\w*(?:\.\w+)*\b/,
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        },
        {
          // class Foo
          pattern: /((?:\b(?:class|enum|interface|new|struct)\s+)|(?:catch\s+\())[A-Z]\w*(?:\.\w+)*\b/,
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        }
      ],
      keyword: /\b(?:abstract|as|assert|async|base|bool|break|case|catch|char|class|const|construct|continue|default|delegate|delete|do|double|dynamic|else|ensures|enum|errordomain|extern|finally|float|for|foreach|get|if|in|inline|int|int16|int32|int64|int8|interface|internal|is|lock|long|namespace|new|null|out|override|owned|params|private|protected|public|ref|requires|return|set|short|signal|sizeof|size_t|ssize_t|static|string|struct|switch|this|throw|throws|try|typeof|uchar|uint|uint16|uint32|uint64|uint8|ulong|unichar|unowned|ushort|using|value|var|virtual|void|volatile|weak|while|yield)\b/i,
      function: /\b\w+(?=\s*\()/,
      number: /(?:\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?:f|u?l?)?/i,
      operator: /\+\+|--|&&|\|\||<<=?|>>=?|=>|->|~|[+\-*\/%&^|=!<>]=?|\?\??|\.\.\./,
      punctuation: /[{}[\];(),.:]/,
      constant: /\b[A-Z0-9_]+\b/
    }), t.languages.insertBefore("vala", "string", {
      "raw-string": {
        pattern: /"""[\s\S]*?"""/,
        greedy: !0,
        alias: "string"
      },
      "template-string": {
        pattern: /@"[\s\S]*?"/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\$(?:\([^)]*\)|[a-zA-Z]\w*)/,
            inside: {
              delimiter: {
                pattern: /^\$\(?|\)$/,
                alias: "punctuation"
              },
              rest: t.languages.vala
            }
          },
          string: /[\s\S]+/
        }
      }
    }), t.languages.insertBefore("vala", "keyword", {
      regex: {
        pattern: /\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[imsx]{0,4}(?=\s*(?:$|[\r\n,.;})\]]))/,
        greedy: !0,
        inside: {
          "regex-source": {
            pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
            lookbehind: !0,
            alias: "language-regex",
            inside: t.languages.regex
          },
          "regex-delimiter": /^\//,
          "regex-flags": /^[a-z]+$/
        }
      }
    });
  }
  return vala_1;
}
var velocity_1, hasRequiredVelocity;
function requireVelocity() {
  if (hasRequiredVelocity) return velocity_1;
  hasRequiredVelocity = 1, velocity_1 = n, n.displayName = "velocity", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.velocity = g.languages.extend("markup", {});
      var d = {
        variable: {
          pattern: /(^|[^\\](?:\\\\)*)\$!?(?:[a-z][\w-]*(?:\([^)]*\))?(?:\.[a-z][\w-]*(?:\([^)]*\))?|\[[^\]]+\])*|\{[^}]+\})/i,
          lookbehind: !0,
          inside: {}
          // See below
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: !0
        },
        number: /\b\d+\b/,
        boolean: /\b(?:false|true)\b/,
        operator: /[=!<>]=?|[+*/%-]|&&|\|\||\.\.|\b(?:eq|g[et]|l[et]|n(?:e|ot))\b/,
        punctuation: /[(){}[\]:,.]/
      };
      d.variable.inside = {
        string: d.string,
        function: {
          pattern: /([^\w-])[a-z][\w-]*(?=\()/,
          lookbehind: !0
        },
        number: d.number,
        boolean: d.boolean,
        punctuation: d.punctuation
      }, g.languages.insertBefore("velocity", "comment", {
        unparsed: {
          pattern: /(^|[^\\])#\[\[[\s\S]*?\]\]#/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            punctuation: /^#\[\[|\]\]#$/
          }
        },
        "velocity-comment": [
          {
            pattern: /(^|[^\\])#\*[\s\S]*?\*#/,
            lookbehind: !0,
            greedy: !0,
            alias: "comment"
          },
          {
            pattern: /(^|[^\\])##.*/,
            lookbehind: !0,
            greedy: !0,
            alias: "comment"
          }
        ],
        directive: {
          pattern: /(^|[^\\](?:\\\\)*)#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})(?:\s*\((?:[^()]|\([^()]*\))*\))?/i,
          lookbehind: !0,
          inside: {
            keyword: {
              pattern: /^#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})|\bin\b/,
              inside: {
                punctuation: /[{}]/
              }
            },
            rest: d
          }
        },
        variable: d.variable
      }), g.languages.velocity.tag.inside["attr-value"].inside.rest = g.languages.velocity;
    })(t);
  }
  return velocity_1;
}
var verilog_1, hasRequiredVerilog;
function requireVerilog() {
  if (hasRequiredVerilog) return verilog_1;
  hasRequiredVerilog = 1, verilog_1 = n, n.displayName = "verilog", n.aliases = [];
  function n(t) {
    t.languages.verilog = {
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: !0
      },
      "kernel-function": {
        // support for any kernel function (ex: $display())
        pattern: /\B\$\w+\b/,
        alias: "property"
      },
      // support for user defined constants (ex: `define)
      constant: /\B`\w+\b/,
      function: /\b\w+(?=\()/,
      // support for verilog and system verilog keywords
      keyword: /\b(?:alias|and|assert|assign|assume|automatic|before|begin|bind|bins|binsof|bit|break|buf|bufif0|bufif1|byte|case|casex|casez|cell|chandle|class|clocking|cmos|config|const|constraint|context|continue|cover|covergroup|coverpoint|cross|deassign|default|defparam|design|disable|dist|do|edge|else|end|endcase|endclass|endclocking|endconfig|endfunction|endgenerate|endgroup|endinterface|endmodule|endpackage|endprimitive|endprogram|endproperty|endsequence|endspecify|endtable|endtask|enum|event|expect|export|extends|extern|final|first_match|for|force|foreach|forever|fork|forkjoin|function|generate|genvar|highz0|highz1|if|iff|ifnone|ignore_bins|illegal_bins|import|incdir|include|initial|inout|input|inside|instance|int|integer|interface|intersect|join|join_any|join_none|large|liblist|library|local|localparam|logic|longint|macromodule|matches|medium|modport|module|nand|negedge|new|nmos|nor|noshowcancelled|not|notif0|notif1|null|or|output|package|packed|parameter|pmos|posedge|primitive|priority|program|property|protected|pull0|pull1|pulldown|pullup|pulsestyle_ondetect|pulsestyle_onevent|pure|rand|randc|randcase|randsequence|rcmos|real|realtime|ref|reg|release|repeat|return|rnmos|rpmos|rtran|rtranif0|rtranif1|scalared|sequence|shortint|shortreal|showcancelled|signed|small|solve|specify|specparam|static|string|strong0|strong1|struct|super|supply0|supply1|table|tagged|task|this|throughout|time|timeprecision|timeunit|tran|tranif0|tranif1|tri|tri0|tri1|triand|trior|trireg|type|typedef|union|unique|unsigned|use|uwire|var|vectored|virtual|void|wait|wait_order|wand|weak0|weak1|while|wildcard|wire|with|within|wor|xnor|xor)\b/,
      // bold highlighting for all verilog and system verilog logic blocks
      important: /\b(?:always|always_comb|always_ff|always_latch)\b(?: *@)?/,
      // support for time ticks, vectors, and real numbers
      number: /\B##?\d+|(?:\b\d+)?'[odbh] ?[\da-fzx_?]+|\b(?:\d*[._])?\d+(?:e[-+]?\d+)?/i,
      operator: /[-+{}^~%*\/?=!<>&|]+/,
      punctuation: /[[\];(),.:]/
    };
  }
  return verilog_1;
}
var vhdl_1, hasRequiredVhdl;
function requireVhdl() {
  if (hasRequiredVhdl) return vhdl_1;
  hasRequiredVhdl = 1, vhdl_1 = n, n.displayName = "vhdl", n.aliases = [];
  function n(t) {
    t.languages.vhdl = {
      comment: /--.+/,
      // support for all logic vectors
      "vhdl-vectors": {
        pattern: /\b[oxb]"[\da-f_]+"|"[01uxzwlh-]+"/i,
        alias: "number"
      },
      // support for operator overloading included
      "quoted-function": {
        pattern: /"\S+?"(?=\()/,
        alias: "function"
      },
      string: /"(?:[^\\"\r\n]|\\(?:\r\n|[\s\S]))*"/,
      constant: /\b(?:library|use)\b/i,
      // support for predefined attributes included
      keyword: /\b(?:'active|'ascending|'base|'delayed|'driving|'driving_value|'event|'high|'image|'instance_name|'last_active|'last_event|'last_value|'left|'leftof|'length|'low|'path_name|'pos|'pred|'quiet|'range|'reverse_range|'right|'rightof|'simple_name|'stable|'succ|'transaction|'val|'value|access|after|alias|all|architecture|array|assert|attribute|begin|block|body|buffer|bus|case|component|configuration|constant|disconnect|downto|else|elsif|end|entity|exit|file|for|function|generate|generic|group|guarded|if|impure|in|inertial|inout|is|label|library|linkage|literal|loop|map|new|next|null|of|on|open|others|out|package|port|postponed|procedure|process|pure|range|record|register|reject|report|return|select|severity|shared|signal|subtype|then|to|transport|type|unaffected|units|until|use|variable|wait|when|while|with)\b/i,
      boolean: /\b(?:false|true)\b/i,
      function: /\w+(?=\()/,
      // decimal, based, physical, and exponential numbers supported
      number: /'[01uxzwlh-]'|\b(?:\d+#[\da-f_.]+#|\d[\d_.]*)(?:e[-+]?\d+)?/i,
      operator: /[<>]=?|:=|[-+*/&=]|\b(?:abs|and|mod|nand|nor|not|or|rem|rol|ror|sla|sll|sra|srl|xnor|xor)\b/i,
      punctuation: /[{}[\];(),.:]/
    };
  }
  return vhdl_1;
}
var vim_1, hasRequiredVim;
function requireVim() {
  if (hasRequiredVim) return vim_1;
  hasRequiredVim = 1, vim_1 = n, n.displayName = "vim", n.aliases = [];
  function n(t) {
    t.languages.vim = {
      string: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\r\n]|'')*'/,
      comment: /".*/,
      function: /\b\w+(?=\()/,
      keyword: /\b(?:N|Next|P|Print|X|XMLent|XMLns|ab|abbreviate|abc|abclear|abo|aboveleft|al|all|ar|arga|argadd|argd|argdelete|argdo|arge|argedit|argg|argglobal|argl|arglocal|args|argu|argument|as|ascii|b|bN|bNext|ba|bad|badd|ball|bd|bdelete|be|bel|belowright|bf|bfirst|bl|blast|bm|bmodified|bn|bnext|bo|botright|bp|bprevious|br|brea|break|breaka|breakadd|breakd|breakdel|breakl|breaklist|brewind|bro|browse|bufdo|buffer|buffers|bun|bunload|bw|bwipeout|c|cN|cNext|cNfcNfile|ca|cabbrev|cabc|cabclear|cad|caddb|caddbuffer|caddexpr|caddf|caddfile|cal|call|cat|catch|cb|cbuffer|cc|ccl|cclose|cd|ce|center|cex|cexpr|cf|cfile|cfir|cfirst|cg|cgetb|cgetbuffer|cgete|cgetexpr|cgetfile|change|changes|chd|chdir|che|checkpath|checkt|checktime|cl|cla|clast|clist|clo|close|cmapc|cmapclear|cn|cnew|cnewer|cnext|cnf|cnfile|cnorea|cnoreabbrev|co|col|colder|colo|colorscheme|comc|comclear|comp|compiler|con|conf|confirm|continue|cope|copen|copy|cp|cpf|cpfile|cprevious|cq|cquit|cr|crewind|cu|cuna|cunabbrev|cunmap|cw|cwindow|d|debugg|debuggreedy|delc|delcommand|delete|delf|delfunction|delm|delmarks|di|diffg|diffget|diffoff|diffpatch|diffpu|diffput|diffsplit|diffthis|diffu|diffupdate|dig|digraphs|display|dj|djump|dl|dlist|dr|drop|ds|dsearch|dsp|dsplit|e|earlier|echoe|echoerr|echom|echomsg|echon|edit|el|else|elsei|elseif|em|emenu|en|endf|endfo|endfor|endfun|endfunction|endif|endt|endtry|endw|endwhile|ene|enew|ex|exi|exit|exu|exusage|f|file|files|filetype|fin|fina|finally|find|fini|finish|fir|first|fix|fixdel|fo|fold|foldc|foldclose|foldd|folddoc|folddoclosed|folddoopen|foldo|foldopen|for|fu|fun|function|go|goto|gr|grep|grepa|grepadd|h|ha|hardcopy|help|helpf|helpfind|helpg|helpgrep|helpt|helptags|hid|hide|his|history|ia|iabbrev|iabc|iabclear|if|ij|ijump|il|ilist|imapc|imapclear|in|inorea|inoreabbrev|isearch|isp|isplit|iu|iuna|iunabbrev|iunmap|j|join|ju|jumps|k|kee|keepalt|keepj|keepjumps|keepmarks|l|lN|lNext|lNf|lNfile|la|lad|laddb|laddbuffer|laddexpr|laddf|laddfile|lan|language|last|later|lb|lbuffer|lc|lcd|lch|lchdir|lcl|lclose|left|lefta|leftabove|let|lex|lexpr|lf|lfile|lfir|lfirst|lg|lgetb|lgetbuffer|lgete|lgetexpr|lgetfile|lgr|lgrep|lgrepa|lgrepadd|lh|lhelpgrep|list|ll|lla|llast|lli|llist|lm|lmak|lmake|lmap|lmapc|lmapclear|ln|lne|lnew|lnewer|lnext|lnf|lnfile|lnoremap|lo|loadview|loc|lockmarks|lockv|lockvar|lol|lolder|lop|lopen|lp|lpf|lpfile|lprevious|lr|lrewind|ls|lt|ltag|lu|lunmap|lv|lvimgrep|lvimgrepa|lvimgrepadd|lw|lwindow|m|ma|mak|make|mark|marks|mat|match|menut|menutranslate|mk|mkexrc|mks|mksession|mksp|mkspell|mkv|mkvie|mkview|mkvimrc|mod|mode|move|mz|mzf|mzfile|mzscheme|n|nbkey|new|next|nmapc|nmapclear|noh|nohlsearch|norea|noreabbrev|nu|number|nun|nunmap|o|omapc|omapclear|on|only|open|opt|options|ou|ounmap|p|pc|pclose|pe|ped|pedit|perl|perld|perldo|po|pop|popu|popup|pp|ppop|pre|preserve|prev|previous|print|prof|profd|profdel|profile|promptf|promptfind|promptr|promptrepl|ps|psearch|ptN|ptNext|pta|ptag|ptf|ptfirst|ptj|ptjump|ptl|ptlast|ptn|ptnext|ptp|ptprevious|ptr|ptrewind|pts|ptselect|pu|put|pw|pwd|py|pyf|pyfile|python|q|qa|qall|quit|quita|quitall|r|read|rec|recover|red|redi|redir|redo|redr|redraw|redraws|redrawstatus|reg|registers|res|resize|ret|retab|retu|return|rew|rewind|ri|right|rightb|rightbelow|ru|rub|ruby|rubyd|rubydo|rubyf|rubyfile|runtime|rv|rviminfo|sN|sNext|sa|sal|sall|san|sandbox|sargument|sav|saveas|sb|sbN|sbNext|sba|sball|sbf|sbfirst|sbl|sblast|sbm|sbmodified|sbn|sbnext|sbp|sbprevious|sbr|sbrewind|sbuffer|scrip|scripte|scriptencoding|scriptnames|se|set|setf|setfiletype|setg|setglobal|setl|setlocal|sf|sfind|sfir|sfirst|sh|shell|sign|sil|silent|sim|simalt|sl|sla|slast|sleep|sm|smagic|smap|smapc|smapclear|sme|smenu|sn|snext|sni|sniff|sno|snomagic|snor|snoremap|snoreme|snoremenu|so|sor|sort|source|sp|spe|spelld|spelldump|spellgood|spelli|spellinfo|spellr|spellrepall|spellu|spellundo|spellw|spellwrong|split|spr|sprevious|sre|srewind|st|sta|stag|star|startg|startgreplace|startinsert|startr|startreplace|stj|stjump|stop|stopi|stopinsert|sts|stselect|sun|sunhide|sunm|sunmap|sus|suspend|sv|sview|syncbind|t|tN|tNext|ta|tab|tabN|tabNext|tabc|tabclose|tabd|tabdo|tabe|tabedit|tabf|tabfind|tabfir|tabfirst|tabl|tablast|tabm|tabmove|tabn|tabnew|tabnext|tabo|tabonly|tabp|tabprevious|tabr|tabrewind|tabs|tag|tags|tc|tcl|tcld|tcldo|tclf|tclfile|te|tearoff|tf|tfirst|th|throw|tj|tjump|tl|tlast|tm|tmenu|tn|tnext|to|topleft|tp|tprevious|tr|trewind|try|ts|tselect|tu|tunmenu|u|una|unabbreviate|undo|undoj|undojoin|undol|undolist|unh|unhide|unlet|unlo|unlockvar|unm|unmap|up|update|ve|verb|verbose|version|vert|vertical|vi|vie|view|vim|vimgrep|vimgrepa|vimgrepadd|visual|viu|viusage|vmapc|vmapclear|vne|vnew|vs|vsplit|vu|vunmap|w|wN|wNext|wa|wall|wh|while|win|winc|wincmd|windo|winp|winpos|winsize|wn|wnext|wp|wprevious|wq|wqa|wqall|write|ws|wsverb|wv|wviminfo|x|xa|xall|xit|xm|xmap|xmapc|xmapclear|xme|xmenu|xn|xnoremap|xnoreme|xnoremenu|xu|xunmap|y|yank)\b/,
      builtin: /\b(?:acd|ai|akm|aleph|allowrevins|altkeymap|ambiwidth|ambw|anti|antialias|arab|arabic|arabicshape|ari|arshape|autochdir|autocmd|autoindent|autoread|autowrite|autowriteall|aw|awa|background|backspace|backup|backupcopy|backupdir|backupext|backupskip|balloondelay|ballooneval|balloonexpr|bdir|bdlay|beval|bex|bexpr|bg|bh|bin|binary|biosk|bioskey|bk|bkc|bomb|breakat|brk|browsedir|bs|bsdir|bsk|bt|bufhidden|buflisted|buftype|casemap|ccv|cdpath|cedit|cfu|ch|charconvert|ci|cin|cindent|cink|cinkeys|cino|cinoptions|cinw|cinwords|clipboard|cmdheight|cmdwinheight|cmp|cms|columns|com|comments|commentstring|compatible|complete|completefunc|completeopt|consk|conskey|copyindent|cot|cpo|cpoptions|cpt|cscopepathcomp|cscopeprg|cscopequickfix|cscopetag|cscopetagorder|cscopeverbose|cspc|csprg|csqf|cst|csto|csverb|cuc|cul|cursorcolumn|cursorline|cwh|debug|deco|def|define|delcombine|dex|dg|dict|dictionary|diff|diffexpr|diffopt|digraph|dip|dir|directory|dy|ea|ead|eadirection|eb|ed|edcompatible|ef|efm|ei|ek|enc|encoding|endofline|eol|ep|equalalways|equalprg|errorbells|errorfile|errorformat|esckeys|et|eventignore|expandtab|exrc|fcl|fcs|fdc|fde|fdi|fdl|fdls|fdm|fdn|fdo|fdt|fen|fenc|fencs|fex|ff|ffs|fileencoding|fileencodings|fileformat|fileformats|fillchars|fk|fkmap|flp|fml|fmr|foldcolumn|foldenable|foldexpr|foldignore|foldlevel|foldlevelstart|foldmarker|foldmethod|foldminlines|foldnestmax|foldtext|formatexpr|formatlistpat|formatoptions|formatprg|fp|fs|fsync|ft|gcr|gd|gdefault|gfm|gfn|gfs|gfw|ghr|gp|grepformat|grepprg|gtl|gtt|guicursor|guifont|guifontset|guifontwide|guiheadroom|guioptions|guipty|guitablabel|guitabtooltip|helpfile|helpheight|helplang|hf|hh|hi|hidden|highlight|hk|hkmap|hkmapp|hkp|hl|hlg|hls|hlsearch|ic|icon|iconstring|ignorecase|im|imactivatekey|imak|imc|imcmdline|imd|imdisable|imi|iminsert|ims|imsearch|inc|include|includeexpr|incsearch|inde|indentexpr|indentkeys|indk|inex|inf|infercase|insertmode|invacd|invai|invakm|invallowrevins|invaltkeymap|invanti|invantialias|invar|invarab|invarabic|invarabicshape|invari|invarshape|invautochdir|invautoindent|invautoread|invautowrite|invautowriteall|invaw|invawa|invbackup|invballooneval|invbeval|invbin|invbinary|invbiosk|invbioskey|invbk|invbl|invbomb|invbuflisted|invcf|invci|invcin|invcindent|invcompatible|invconfirm|invconsk|invconskey|invcopyindent|invcp|invcscopetag|invcscopeverbose|invcst|invcsverb|invcuc|invcul|invcursorcolumn|invcursorline|invdeco|invdelcombine|invdg|invdiff|invdigraph|invdisable|invea|inveb|inved|invedcompatible|invek|invendofline|inveol|invequalalways|inverrorbells|invesckeys|invet|invex|invexpandtab|invexrc|invfen|invfk|invfkmap|invfoldenable|invgd|invgdefault|invguipty|invhid|invhidden|invhk|invhkmap|invhkmapp|invhkp|invhls|invhlsearch|invic|invicon|invignorecase|invim|invimc|invimcmdline|invimd|invincsearch|invinf|invinfercase|invinsertmode|invis|invjoinspaces|invjs|invlazyredraw|invlbr|invlinebreak|invlisp|invlist|invloadplugins|invlpl|invlz|invma|invmacatsui|invmagic|invmh|invml|invmod|invmodeline|invmodifiable|invmodified|invmore|invmousef|invmousefocus|invmousehide|invnu|invnumber|invodev|invopendevice|invpaste|invpi|invpreserveindent|invpreviewwindow|invprompt|invpvw|invreadonly|invremap|invrestorescreen|invrevins|invri|invrightleft|invrightleftcmd|invrl|invrlc|invro|invrs|invru|invruler|invsb|invsc|invscb|invscrollbind|invscs|invsecure|invsft|invshellslash|invshelltemp|invshiftround|invshortname|invshowcmd|invshowfulltag|invshowmatch|invshowmode|invsi|invsm|invsmartcase|invsmartindent|invsmarttab|invsmd|invsn|invsol|invspell|invsplitbelow|invsplitright|invspr|invsr|invssl|invsta|invstartofline|invstmp|invswapfile|invswf|invta|invtagbsearch|invtagrelative|invtagstack|invtbi|invtbidi|invtbs|invtermbidi|invterse|invtextauto|invtextmode|invtf|invtgst|invtildeop|invtimeout|invtitle|invto|invtop|invtr|invttimeout|invttybuiltin|invttyfast|invtx|invvb|invvisualbell|invwa|invwarn|invwb|invweirdinvert|invwfh|invwfw|invwildmenu|invwinfixheight|invwinfixwidth|invwiv|invwmnu|invwrap|invwrapscan|invwrite|invwriteany|invwritebackup|invws|isf|isfname|isi|isident|isk|iskeyword|isprint|joinspaces|js|key|keymap|keymodel|keywordprg|km|kmp|kp|langmap|langmenu|laststatus|lazyredraw|lbr|lcs|linebreak|lines|linespace|lisp|lispwords|listchars|loadplugins|lpl|lsp|lz|macatsui|magic|makeef|makeprg|matchpairs|matchtime|maxcombine|maxfuncdepth|maxmapdepth|maxmem|maxmempattern|maxmemtot|mco|mef|menuitems|mfd|mh|mis|mkspellmem|ml|mls|mm|mmd|mmp|mmt|modeline|modelines|modifiable|modified|more|mouse|mousef|mousefocus|mousehide|mousem|mousemodel|mouses|mouseshape|mouset|mousetime|mp|mps|msm|mzq|mzquantum|nf|noacd|noai|noakm|noallowrevins|noaltkeymap|noanti|noantialias|noar|noarab|noarabic|noarabicshape|noari|noarshape|noautochdir|noautoindent|noautoread|noautowrite|noautowriteall|noaw|noawa|nobackup|noballooneval|nobeval|nobin|nobinary|nobiosk|nobioskey|nobk|nobl|nobomb|nobuflisted|nocf|noci|nocin|nocindent|nocompatible|noconfirm|noconsk|noconskey|nocopyindent|nocp|nocscopetag|nocscopeverbose|nocst|nocsverb|nocuc|nocul|nocursorcolumn|nocursorline|nodeco|nodelcombine|nodg|nodiff|nodigraph|nodisable|noea|noeb|noed|noedcompatible|noek|noendofline|noeol|noequalalways|noerrorbells|noesckeys|noet|noex|noexpandtab|noexrc|nofen|nofk|nofkmap|nofoldenable|nogd|nogdefault|noguipty|nohid|nohidden|nohk|nohkmap|nohkmapp|nohkp|nohls|noic|noicon|noignorecase|noim|noimc|noimcmdline|noimd|noincsearch|noinf|noinfercase|noinsertmode|nois|nojoinspaces|nojs|nolazyredraw|nolbr|nolinebreak|nolisp|nolist|noloadplugins|nolpl|nolz|noma|nomacatsui|nomagic|nomh|noml|nomod|nomodeline|nomodifiable|nomodified|nomore|nomousef|nomousefocus|nomousehide|nonu|nonumber|noodev|noopendevice|nopaste|nopi|nopreserveindent|nopreviewwindow|noprompt|nopvw|noreadonly|noremap|norestorescreen|norevins|nori|norightleft|norightleftcmd|norl|norlc|noro|nors|noru|noruler|nosb|nosc|noscb|noscrollbind|noscs|nosecure|nosft|noshellslash|noshelltemp|noshiftround|noshortname|noshowcmd|noshowfulltag|noshowmatch|noshowmode|nosi|nosm|nosmartcase|nosmartindent|nosmarttab|nosmd|nosn|nosol|nospell|nosplitbelow|nosplitright|nospr|nosr|nossl|nosta|nostartofline|nostmp|noswapfile|noswf|nota|notagbsearch|notagrelative|notagstack|notbi|notbidi|notbs|notermbidi|noterse|notextauto|notextmode|notf|notgst|notildeop|notimeout|notitle|noto|notop|notr|nottimeout|nottybuiltin|nottyfast|notx|novb|novisualbell|nowa|nowarn|nowb|noweirdinvert|nowfh|nowfw|nowildmenu|nowinfixheight|nowinfixwidth|nowiv|nowmnu|nowrap|nowrapscan|nowrite|nowriteany|nowritebackup|nows|nrformats|numberwidth|nuw|odev|oft|ofu|omnifunc|opendevice|operatorfunc|opfunc|osfiletype|pa|para|paragraphs|paste|pastetoggle|patchexpr|patchmode|path|pdev|penc|pex|pexpr|pfn|ph|pheader|pi|pm|pmbcs|pmbfn|popt|preserveindent|previewheight|previewwindow|printdevice|printencoding|printexpr|printfont|printheader|printmbcharset|printmbfont|printoptions|prompt|pt|pumheight|pvh|pvw|qe|quoteescape|readonly|remap|report|restorescreen|revins|rightleft|rightleftcmd|rl|rlc|ro|rs|rtp|ruf|ruler|rulerformat|runtimepath|sbo|sc|scb|scr|scroll|scrollbind|scrolljump|scrolloff|scrollopt|scs|sect|sections|secure|sel|selection|selectmode|sessionoptions|sft|shcf|shellcmdflag|shellpipe|shellquote|shellredir|shellslash|shelltemp|shelltype|shellxquote|shiftround|shiftwidth|shm|shortmess|shortname|showbreak|showcmd|showfulltag|showmatch|showmode|showtabline|shq|si|sidescroll|sidescrolloff|siso|sj|slm|smartcase|smartindent|smarttab|smc|smd|softtabstop|sol|spc|spell|spellcapcheck|spellfile|spelllang|spellsuggest|spf|spl|splitbelow|splitright|sps|sr|srr|ss|ssl|ssop|stal|startofline|statusline|stl|stmp|su|sua|suffixes|suffixesadd|sw|swapfile|swapsync|swb|swf|switchbuf|sws|sxq|syn|synmaxcol|syntax|t_AB|t_AF|t_AL|t_CS|t_CV|t_Ce|t_Co|t_Cs|t_DL|t_EI|t_F1|t_F2|t_F3|t_F4|t_F5|t_F6|t_F7|t_F8|t_F9|t_IE|t_IS|t_K1|t_K3|t_K4|t_K5|t_K6|t_K7|t_K8|t_K9|t_KA|t_KB|t_KC|t_KD|t_KE|t_KF|t_KG|t_KH|t_KI|t_KJ|t_KK|t_KL|t_RI|t_RV|t_SI|t_Sb|t_Sf|t_WP|t_WS|t_ZH|t_ZR|t_al|t_bc|t_cd|t_ce|t_cl|t_cm|t_cs|t_da|t_db|t_dl|t_fs|t_k1|t_k2|t_k3|t_k4|t_k5|t_k6|t_k7|t_k8|t_k9|t_kB|t_kD|t_kI|t_kN|t_kP|t_kb|t_kd|t_ke|t_kh|t_kl|t_kr|t_ks|t_ku|t_le|t_mb|t_md|t_me|t_mr|t_ms|t_nd|t_op|t_se|t_so|t_sr|t_te|t_ti|t_ts|t_ue|t_us|t_ut|t_vb|t_ve|t_vi|t_vs|t_xs|tabline|tabpagemax|tabstop|tagbsearch|taglength|tagrelative|tagstack|tal|tb|tbi|tbidi|tbis|tbs|tenc|term|termbidi|termencoding|terse|textauto|textmode|textwidth|tgst|thesaurus|tildeop|timeout|timeoutlen|title|titlelen|titleold|titlestring|toolbar|toolbariconsize|top|tpm|tsl|tsr|ttimeout|ttimeoutlen|ttm|tty|ttybuiltin|ttyfast|ttym|ttymouse|ttyscroll|ttytype|tw|tx|uc|ul|undolevels|updatecount|updatetime|ut|vb|vbs|vdir|verbosefile|vfile|viewdir|viewoptions|viminfo|virtualedit|visualbell|vop|wak|warn|wb|wc|wcm|wd|weirdinvert|wfh|wfw|whichwrap|wi|wig|wildchar|wildcharm|wildignore|wildmenu|wildmode|wildoptions|wim|winaltkeys|window|winfixheight|winfixwidth|winheight|winminheight|winminwidth|winwidth|wiv|wiw|wm|wmh|wmnu|wmw|wop|wrap|wrapmargin|wrapscan|writeany|writebackup|writedelay|ww)\b/,
      number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?)\b/i,
      operator: /\|\||&&|[-+.]=?|[=!](?:[=~][#?]?)?|[<>]=?[#?]?|[*\/%?]|\b(?:is(?:not)?)\b/,
      punctuation: /[{}[\](),;:]/
    };
  }
  return vim_1;
}
var visualBasic_1, hasRequiredVisualBasic;
function requireVisualBasic() {
  if (hasRequiredVisualBasic) return visualBasic_1;
  hasRequiredVisualBasic = 1, visualBasic_1 = n, n.displayName = "visualBasic", n.aliases = [];
  function n(t) {
    t.languages["visual-basic"] = {
      comment: {
        pattern: /(?:['‘’]|REM\b)(?:[^\r\n_]|_(?:\r\n?|\n)?)*/i,
        inside: {
          keyword: /^REM/i
        }
      },
      directive: {
        pattern: /#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:\b_[ \t]*(?:\r\n?|\n)|.)+/i,
        alias: "property",
        greedy: !0
      },
      string: {
        pattern: /\$?["“”](?:["“”]{2}|[^"“”])*["“”]C?/i,
        greedy: !0
      },
      date: {
        pattern: /#[ \t]*(?:\d+([/-])\d+\1\d+(?:[ \t]+(?:\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?))?|\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?)[ \t]*#/i,
        alias: "number"
      },
      number: /(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:[FRD]|U?[ILS])?/i,
      boolean: /\b(?:False|Nothing|True)\b/i,
      keyword: /\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Currency|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|Type|TypeOf|U(?:Integer|Long|Short)|Until|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Xor)\b/i,
      operator: /[+\-*/\\^<=>&#@$%!]|\b_(?=[ \t]*[\r\n])/,
      punctuation: /[{}().,:?]/
    }, t.languages.vb = t.languages["visual-basic"], t.languages.vba = t.languages["visual-basic"];
  }
  return visualBasic_1;
}
var warpscript_1, hasRequiredWarpscript;
function requireWarpscript() {
  if (hasRequiredWarpscript) return warpscript_1;
  hasRequiredWarpscript = 1, warpscript_1 = n, n.displayName = "warpscript", n.aliases = [];
  function n(t) {
    t.languages.warpscript = {
      comment: /#.*|\/\/.*|\/\*[\s\S]*?\*\//,
      string: {
        pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'|<'(?:[^\\']|'(?!>)|\\.)*'>/,
        greedy: !0
      },
      variable: /\$\S+/,
      macro: {
        pattern: /@\S+/,
        alias: "property"
      },
      // WarpScript doesn't have any keywords, these are all functions under the control category
      // https://www.warp10.io/tags/control
      keyword: /\b(?:BREAK|CHECKMACRO|CONTINUE|CUDF|DEFINED|DEFINEDMACRO|EVAL|FAIL|FOR|FOREACH|FORSTEP|IFT|IFTE|MSGFAIL|NRETURN|RETHROW|RETURN|SWITCH|TRY|UDF|UNTIL|WHILE)\b/,
      number: /[+-]?\b(?:NaN|Infinity|\d+(?:\.\d*)?(?:[Ee][+-]?\d+)?|0x[\da-fA-F]+|0b[01]+)\b/,
      boolean: /\b(?:F|T|false|true)\b/,
      punctuation: /<%|%>|[{}[\]()]/,
      // Some operators from the "operators" category
      // https://www.warp10.io/tags/operators
      operator: /==|&&?|\|\|?|\*\*?|>>>?|<<|[<>!~]=?|[-/%^]|\+!?|\b(?:AND|NOT|OR)\b/
    };
  }
  return warpscript_1;
}
var wasm_1, hasRequiredWasm;
function requireWasm() {
  if (hasRequiredWasm) return wasm_1;
  hasRequiredWasm = 1, wasm_1 = n, n.displayName = "wasm", n.aliases = [];
  function n(t) {
    t.languages.wasm = {
      comment: [
        /\(;[\s\S]*?;\)/,
        {
          pattern: /;;.*/,
          greedy: !0
        }
      ],
      string: {
        pattern: /"(?:\\[\s\S]|[^"\\])*"/,
        greedy: !0
      },
      keyword: [
        {
          pattern: /\b(?:align|offset)=/,
          inside: {
            operator: /=/
          }
        },
        {
          pattern: /\b(?:(?:f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|neg?|nearest|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|sqrt|store(?:8|16|32)?|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))?|memory\.(?:grow|size))\b/,
          inside: {
            punctuation: /\./
          }
        },
        /\b(?:anyfunc|block|br(?:_if|_table)?|call(?:_indirect)?|data|drop|elem|else|end|export|func|get_(?:global|local)|global|if|import|local|loop|memory|module|mut|nop|offset|param|result|return|select|set_(?:global|local)|start|table|tee_local|then|type|unreachable)\b/
      ],
      variable: /\$[\w!#$%&'*+\-./:<=>?@\\^`|~]+/,
      number: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/,
      punctuation: /[()]/
    };
  }
  return wasm_1;
}
var webIdl_1, hasRequiredWebIdl;
function requireWebIdl() {
  if (hasRequiredWebIdl) return webIdl_1;
  hasRequiredWebIdl = 1, webIdl_1 = n, n.displayName = "webIdl", n.aliases = [];
  function n(t) {
    (function(g) {
      var d = /(?:\B-|\b_|\b)[A-Za-z][\w-]*(?![\w-])/.source, k = "(?:" + /\b(?:unsigned\s+)?long\s+long(?![\w-])/.source + "|" + /\b(?:unrestricted|unsigned)\s+[a-z]+(?![\w-])/.source + "|" + /(?!(?:unrestricted|unsigned)\b)/.source + d + /(?:\s*<(?:[^<>]|<[^<>]*>)*>)?/.source + ")" + /(?:\s*\?)?/.source, H = {};
      g.languages["web-idl"] = {
        comment: {
          pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
          greedy: !0
        },
        string: {
          pattern: /"[^"]*"/,
          greedy: !0
        },
        namespace: {
          pattern: RegExp(/(\bnamespace\s+)/.source + d),
          lookbehind: !0
        },
        "class-name": [
          {
            pattern: /(^|[^\w-])(?:iterable|maplike|setlike)\s*<(?:[^<>]|<[^<>]*>)*>/,
            lookbehind: !0,
            inside: H
          },
          {
            pattern: RegExp(
              /(\b(?:attribute|const|deleter|getter|optional|setter)\s+)/.source + k
            ),
            lookbehind: !0,
            inside: H
          },
          {
            // callback return type
            pattern: RegExp(
              "(" + /\bcallback\s+/.source + d + /\s*=\s*/.source + ")" + k
            ),
            lookbehind: !0,
            inside: H
          },
          {
            // typedef
            pattern: RegExp(/(\btypedef\b\s*)/.source + k),
            lookbehind: !0,
            inside: H
          },
          {
            pattern: RegExp(
              /(\b(?:callback|dictionary|enum|interface(?:\s+mixin)?)\s+)(?!(?:interface|mixin)\b)/.source + d
            ),
            lookbehind: !0
          },
          {
            // inheritance
            pattern: RegExp(/(:\s*)/.source + d),
            lookbehind: !0
          },
          // includes and implements
          RegExp(d + /(?=\s+(?:implements|includes)\b)/.source),
          {
            pattern: RegExp(/(\b(?:implements|includes)\s+)/.source + d),
            lookbehind: !0
          },
          {
            // function return type, parameter types, and dictionary members
            pattern: RegExp(
              k + "(?=" + /\s*(?:\.{3}\s*)?/.source + d + /\s*[(),;=]/.source + ")"
            ),
            inside: H
          }
        ],
        builtin: /\b(?:ArrayBuffer|BigInt64Array|BigUint64Array|ByteString|DOMString|DataView|Float32Array|Float64Array|FrozenArray|Int16Array|Int32Array|Int8Array|ObservableArray|Promise|USVString|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray)\b/,
        keyword: [
          /\b(?:async|attribute|callback|const|constructor|deleter|dictionary|enum|getter|implements|includes|inherit|interface|mixin|namespace|null|optional|or|partial|readonly|required|setter|static|stringifier|typedef|unrestricted)\b/,
          // type keywords
          /\b(?:any|bigint|boolean|byte|double|float|iterable|long|maplike|object|octet|record|sequence|setlike|short|symbol|undefined|unsigned|void)\b/
        ],
        boolean: /\b(?:false|true)\b/,
        number: {
          pattern: /(^|[^\w-])-?(?:0x[0-9a-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|NaN|Infinity)(?![\w-])/i,
          lookbehind: !0
        },
        operator: /\.{3}|[=:?<>-]/,
        punctuation: /[(){}[\].,;]/
      };
      for (var AA in g.languages["web-idl"])
        AA !== "class-name" && (H[AA] = g.languages["web-idl"][AA]);
      g.languages.webidl = g.languages["web-idl"];
    })(t);
  }
  return webIdl_1;
}
var wiki_1, hasRequiredWiki;
function requireWiki() {
  if (hasRequiredWiki) return wiki_1;
  hasRequiredWiki = 1, wiki_1 = n, n.displayName = "wiki", n.aliases = [];
  function n(t) {
    t.languages.wiki = t.languages.extend("markup", {
      "block-comment": {
        pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
        lookbehind: !0,
        alias: "comment"
      },
      heading: {
        pattern: /^(=+)[^=\r\n].*?\1/m,
        inside: {
          punctuation: /^=+|=+$/,
          important: /.+/
        }
      },
      emphasis: {
        // TODO Multi-line
        pattern: /('{2,5}).+?\1/,
        inside: {
          "bold-italic": {
            pattern: /(''''').+?(?=\1)/,
            lookbehind: !0,
            alias: ["bold", "italic"]
          },
          bold: {
            pattern: /(''')[^'](?:.*?[^'])?(?=\1)/,
            lookbehind: !0
          },
          italic: {
            pattern: /('')[^'](?:.*?[^'])?(?=\1)/,
            lookbehind: !0
          },
          punctuation: /^''+|''+$/
        }
      },
      hr: {
        pattern: /^-{4,}/m,
        alias: "punctuation"
      },
      url: [
        /ISBN +(?:97[89][ -]?)?(?:\d[ -]?){9}[\dx]\b|(?:PMID|RFC) +\d+/i,
        /\[\[.+?\]\]|\[.+?\]/
      ],
      variable: [
        /__[A-Z]+__/,
        // FIXME Nested structures should be handled
        // {{formatnum:{{#expr:{{{3}}}}}}}
        /\{{3}.+?\}{3}/,
        /\{\{.+?\}\}/
      ],
      symbol: [/^#redirect/im, /~{3,5}/],
      // Handle table attrs:
      // {|
      // ! style="text-align:left;"| Item
      // |}
      "table-tag": {
        pattern: /((?:^|[|!])[|!])[^|\r\n]+\|(?!\|)/m,
        lookbehind: !0,
        inside: {
          "table-bar": {
            pattern: /\|$/,
            alias: "punctuation"
          },
          rest: t.languages.markup.tag.inside
        }
      },
      punctuation: /^(?:\{\||\|\}|\|-|[*#:;!|])|\|\||!!/m
    }), t.languages.insertBefore("wiki", "tag", {
      // Prevent highlighting inside <nowiki>, <source> and <pre> tags
      nowiki: {
        pattern: /<(nowiki|pre|source)\b[^>]*>[\s\S]*?<\/\1>/i,
        inside: {
          tag: {
            pattern: /<(?:nowiki|pre|source)\b[^>]*>|<\/(?:nowiki|pre|source)>/i,
            inside: t.languages.markup.tag.inside
          }
        }
      }
    });
  }
  return wiki_1;
}
var wolfram_1, hasRequiredWolfram;
function requireWolfram() {
  if (hasRequiredWolfram) return wolfram_1;
  hasRequiredWolfram = 1, wolfram_1 = n, n.displayName = "wolfram", n.aliases = ["mathematica", "wl", "nb"];
  function n(t) {
    t.languages.wolfram = {
      // Allow one level of nesting - note: regex taken from applescipt
      comment: /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
      string: {
        pattern: /"(?:\\.|[^"\\\r\n])*"/,
        greedy: !0
      },
      keyword: /\b(?:Abs|AbsArg|Accuracy|Block|Do|For|Function|If|Manipulate|Module|Nest|NestList|None|Return|Switch|Table|Which|While)\b/,
      context: {
        pattern: /\b\w+`+\w*/,
        alias: "class-name"
      },
      blank: {
        pattern: /\b\w+_\b/,
        alias: "regex"
      },
      "global-variable": {
        pattern: /\$\w+/,
        alias: "variable"
      },
      boolean: /\b(?:False|True)\b/,
      number: /(?:\b(?=\d)|\B(?=\.))(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?j?\b/i,
      operator: /\/\.|;|=\.|\^=|\^:=|:=|<<|>>|<\||\|>|:>|\|->|->|<-|@@@|@@|@|\/@|=!=|===|==|=|\+|-|\^|\[\/-+%=\]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.mathematica = t.languages.wolfram, t.languages.wl = t.languages.wolfram, t.languages.nb = t.languages.wolfram;
  }
  return wolfram_1;
}
var wren_1, hasRequiredWren;
function requireWren() {
  if (hasRequiredWren) return wren_1;
  hasRequiredWren = 1, wren_1 = n, n.displayName = "wren", n.aliases = [];
  function n(t) {
    t.languages.wren = {
      // Multiline comments in Wren can have nested multiline comments
      // Comments: // and /* */
      comment: [
        {
          // support 3 levels of nesting
          // regex: \/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\/
          pattern: /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*))*\*\/)*\*\/)*\*\//,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      // Triple quoted strings are multiline but cannot have interpolation (raw strings)
      // Based on prism-python.js
      "triple-quoted-string": {
        pattern: /"""[\s\S]*?"""/,
        greedy: !0,
        alias: "string"
      },
      // see below
      "string-literal": null,
      // #!/usr/bin/env wren on the first line
      hashbang: {
        pattern: /^#!\/.+/,
        greedy: !0,
        alias: "comment"
      },
      // Attributes are special keywords to add meta data to classes
      attribute: {
        // #! attributes are stored in class properties
        // #!myvar = true
        // #attributes are not stored and dismissed at compilation
        pattern: /#!?[ \t\u3000]*\w+/,
        alias: "keyword"
      },
      "class-name": [
        {
          // class definition
          // class Meta {}
          pattern: /(\bclass\s+)\w+/,
          lookbehind: !0
        },
        // A class must always start with an uppercase.
        // File.read
        /\b[A-Z][a-z\d_]*\b/
      ],
      // A constant can be a variable, class, property or method. Just named in all uppercase letters
      constant: /\b[A-Z][A-Z\d_]*\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword"
      },
      keyword: /\b(?:as|break|class|construct|continue|else|for|foreign|if|import|in|is|return|static|super|this|var|while)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
      // Functions can be Class.method()
      function: /\b[a-z_]\w*(?=\s*[({])/i,
      operator: /<<|>>|[=!<>]=?|&&|\|\||[-+*/%~^&|?:]|\.{2,3}/,
      punctuation: /[\[\](){}.,;]/
    }, t.languages.wren["string-literal"] = {
      // A single quote string is multiline and can have interpolation (similar to JS backticks ``)
      pattern: /(^|[^\\"])"(?:[^\\"%]|\\[\s\S]|%(?!\()|%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\))*"/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          // "%(interpolation)"
          pattern: /((?:^|[^\\])(?:\\{2})*)%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\)/,
          lookbehind: !0,
          inside: {
            expression: {
              pattern: /^(%\()[\s\S]+(?=\)$)/,
              lookbehind: !0,
              inside: t.languages.wren
            },
            "interpolation-punctuation": {
              pattern: /^%\(|\)$/,
              alias: "punctuation"
            }
          }
        },
        string: /[\s\S]+/
      }
    };
  }
  return wren_1;
}
var xeora_1, hasRequiredXeora;
function requireXeora() {
  if (hasRequiredXeora) return xeora_1;
  hasRequiredXeora = 1, xeora_1 = n, n.displayName = "xeora", n.aliases = ["xeoracube"];
  function n(t) {
    (function(g) {
      g.languages.xeora = g.languages.extend("markup", {
        constant: {
          pattern: /\$(?:DomainContents|PageRenderDuration)\$/,
          inside: {
            punctuation: {
              pattern: /\$/
            }
          }
        },
        variable: {
          pattern: /\$@?(?:#+|[-+*~=^])?[\w.]+\$/,
          inside: {
            punctuation: {
              pattern: /[$.]/
            },
            operator: {
              pattern: /#+|[-+*~=^@]/
            }
          }
        },
        "function-inline": {
          pattern: /\$F:[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\$/,
          inside: {
            variable: {
              pattern: /(?:[,|])@?(?:#+|[-+*~=^])?[\w.]+/,
              inside: {
                punctuation: {
                  pattern: /[,.|]/
                },
                operator: {
                  pattern: /#+|[-+*~=^@]/
                }
              }
            },
            punctuation: {
              pattern: /\$\w:|[$:?.,|]/
            }
          },
          alias: "function"
        },
        "function-block": {
          pattern: /\$XF:\{[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\}:XF\$/,
          inside: {
            punctuation: {
              pattern: /[$:{}?.,|]/
            }
          },
          alias: "function"
        },
        "directive-inline": {
          pattern: /\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\/\w.]+\$/,
          inside: {
            punctuation: {
              pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
              inside: {
                tag: {
                  pattern: /#\d/
                }
              }
            }
          },
          alias: "function"
        },
        "directive-block-open": {
          pattern: /\$\w+:\{|\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\w.]+:\{(?:![A-Z]+)?/,
          inside: {
            punctuation: {
              pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
              inside: {
                tag: {
                  pattern: /#\d/
                }
              }
            },
            attribute: {
              pattern: /![A-Z]+$/,
              inside: {
                punctuation: {
                  pattern: /!/
                }
              },
              alias: "keyword"
            }
          },
          alias: "function"
        },
        "directive-block-separator": {
          pattern: /\}:[-\w.]+:\{/,
          inside: {
            punctuation: {
              pattern: /[:{}]/
            }
          },
          alias: "function"
        },
        "directive-block-close": {
          pattern: /\}:[-\w.]+\$/,
          inside: {
            punctuation: {
              pattern: /[:{}$]/
            }
          },
          alias: "function"
        }
      }), g.languages.insertBefore(
        "inside",
        "punctuation",
        {
          variable: g.languages.xeora["function-inline"].inside.variable
        },
        g.languages.xeora["function-block"]
      ), g.languages.xeoracube = g.languages.xeora;
    })(t);
  }
  return xeora_1;
}
var xmlDoc_1, hasRequiredXmlDoc;
function requireXmlDoc() {
  if (hasRequiredXmlDoc) return xmlDoc_1;
  hasRequiredXmlDoc = 1, xmlDoc_1 = n, n.displayName = "xmlDoc", n.aliases = [];
  function n(t) {
    (function(g) {
      function d(gA, IA) {
        g.languages[gA] && g.languages.insertBefore(gA, "comment", {
          "doc-comment": IA
        });
      }
      var k = g.languages.markup.tag, H = {
        pattern: /\/\/\/.*/,
        greedy: !0,
        alias: "comment",
        inside: {
          tag: k
        }
      }, AA = {
        pattern: /'''.*/,
        greedy: !0,
        alias: "comment",
        inside: {
          tag: k
        }
      };
      d("csharp", H), d("fsharp", H), d("vbnet", AA);
    })(t);
  }
  return xmlDoc_1;
}
var xojo_1, hasRequiredXojo;
function requireXojo() {
  if (hasRequiredXojo) return xojo_1;
  hasRequiredXojo = 1, xojo_1 = n, n.displayName = "xojo", n.aliases = [];
  function n(t) {
    t.languages.xojo = {
      comment: {
        pattern: /(?:'|\/\/|Rem\b).+/i,
        greedy: !0
      },
      string: {
        pattern: /"(?:""|[^"])*"/,
        greedy: !0
      },
      number: [/(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i, /&[bchou][a-z\d]+/i],
      directive: {
        pattern: /#(?:Else|ElseIf|Endif|If|Pragma)\b/i,
        alias: "property"
      },
      keyword: /\b(?:AddHandler|App|Array|As(?:signs)?|Auto|Boolean|Break|By(?:Ref|Val)|Byte|Call|Case|Catch|CFStringRef|CGFloat|Class|Color|Const|Continue|CString|Currency|CurrentMethodName|Declare|Delegate|Dim|Do(?:uble|wnTo)?|Each|Else(?:If)?|End|Enumeration|Event|Exception|Exit|Extends|False|Finally|For|Function|Get|GetTypeInfo|Global|GOTO|If|Implements|In|Inherits|Int(?:8|16|32|64|eger|erface)?|Lib|Loop|Me|Module|Next|Nil|Object|Optional|OSType|ParamArray|Private|Property|Protected|PString|Ptr|Raise(?:Event)?|ReDim|RemoveHandler|Return|Select(?:or)?|Self|Set|Shared|Short|Single|Soft|Static|Step|String|Sub|Super|Text|Then|To|True|Try|Ubound|UInt(?:8|16|32|64|eger)?|Until|Using|Var(?:iant)?|Wend|While|WindowPtr|WString)\b/i,
      operator: /<[=>]?|>=?|[+\-*\/\\^=]|\b(?:AddressOf|And|Ctype|IsA?|Mod|New|Not|Or|WeakAddressOf|Xor)\b/i,
      punctuation: /[.,;:()]/
    };
  }
  return xojo_1;
}
var xquery_1, hasRequiredXquery;
function requireXquery() {
  if (hasRequiredXquery) return xquery_1;
  hasRequiredXquery = 1, xquery_1 = n, n.displayName = "xquery", n.aliases = [];
  function n(t) {
    (function(g) {
      g.languages.xquery = g.languages.extend("markup", {
        "xquery-comment": {
          pattern: /\(:[\s\S]*?:\)/,
          greedy: !0,
          alias: "comment"
        },
        string: {
          pattern: /(["'])(?:\1\1|(?!\1)[\s\S])*\1/,
          greedy: !0
        },
        extension: {
          pattern: /\(#.+?#\)/,
          alias: "symbol"
        },
        variable: /\$[-\w:]+/,
        axis: {
          pattern: /(^|[^-])(?:ancestor(?:-or-self)?|attribute|child|descendant(?:-or-self)?|following(?:-sibling)?|parent|preceding(?:-sibling)?|self)(?=::)/,
          lookbehind: !0,
          alias: "operator"
        },
        "keyword-operator": {
          pattern: /(^|[^:-])\b(?:and|castable as|div|eq|except|ge|gt|idiv|instance of|intersect|is|le|lt|mod|ne|or|union)\b(?=$|[^:-])/,
          lookbehind: !0,
          alias: "operator"
        },
        keyword: {
          pattern: /(^|[^:-])\b(?:as|ascending|at|base-uri|boundary-space|case|cast as|collation|construction|copy-namespaces|declare|default|descending|else|empty (?:greatest|least)|encoding|every|external|for|function|if|import|in|inherit|lax|let|map|module|namespace|no-inherit|no-preserve|option|order(?: by|ed|ing)?|preserve|return|satisfies|schema|some|stable|strict|strip|then|to|treat as|typeswitch|unordered|validate|variable|version|where|xquery)\b(?=$|[^:-])/,
          lookbehind: !0
        },
        function: /[\w-]+(?::[\w-]+)*(?=\s*\()/,
        "xquery-element": {
          pattern: /(element\s+)[\w-]+(?::[\w-]+)*/,
          lookbehind: !0,
          alias: "tag"
        },
        "xquery-attribute": {
          pattern: /(attribute\s+)[\w-]+(?::[\w-]+)*/,
          lookbehind: !0,
          alias: "attr-name"
        },
        builtin: {
          pattern: /(^|[^:-])\b(?:attribute|comment|document|element|processing-instruction|text|xs:(?:ENTITIES|ENTITY|ID|IDREFS?|NCName|NMTOKENS?|NOTATION|Name|QName|anyAtomicType|anyType|anyURI|base64Binary|boolean|byte|date|dateTime|dayTimeDuration|decimal|double|duration|float|gDay|gMonth|gMonthDay|gYear|gYearMonth|hexBinary|int|integer|language|long|negativeInteger|nonNegativeInteger|nonPositiveInteger|normalizedString|positiveInteger|short|string|time|token|unsigned(?:Byte|Int|Long|Short)|untyped(?:Atomic)?|yearMonthDuration))\b(?=$|[^:-])/,
          lookbehind: !0
        },
        number: /\b\d+(?:\.\d+)?(?:E[+-]?\d+)?/,
        operator: [
          /[+*=?|@]|\.\.?|:=|!=|<[=<]?|>[=>]?/,
          {
            pattern: /(\s)-(?=\s)/,
            lookbehind: !0
          }
        ],
        punctuation: /[[\](){},;:/]/
      }), g.languages.xquery.tag.pattern = /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/, g.languages.xquery.tag.inside["attr-value"].pattern = /=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+)/, g.languages.xquery.tag.inside["attr-value"].inside.punctuation = /^="|"$/, g.languages.xquery.tag.inside["attr-value"].inside.expression = {
        // Allow for two levels of nesting
        pattern: /\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}/,
        inside: g.languages.xquery,
        alias: "language-xquery"
      };
      var d = function(H) {
        return typeof H == "string" ? H : typeof H.content == "string" ? H.content : H.content.map(d).join("");
      }, k = function(H) {
        for (var AA = [], gA = 0; gA < H.length; gA++) {
          var IA = H[gA], CA = !1;
          if (typeof IA != "string" && (IA.type === "tag" && IA.content[0] && IA.content[0].type === "tag" ? IA.content[0].content[0].content === "</" ? AA.length > 0 && AA[AA.length - 1].tagName === d(IA.content[0].content[1]) && AA.pop() : IA.content[IA.content.length - 1].content === "/>" || AA.push({
            tagName: d(IA.content[0].content[1]),
            openedBraces: 0
          }) : AA.length > 0 && IA.type === "punctuation" && IA.content === "{" && // Ignore `{{`
          (!H[gA + 1] || H[gA + 1].type !== "punctuation" || H[gA + 1].content !== "{") && (!H[gA - 1] || H[gA - 1].type !== "plain-text" || H[gA - 1].content !== "{") ? AA[AA.length - 1].openedBraces++ : AA.length > 0 && AA[AA.length - 1].openedBraces > 0 && IA.type === "punctuation" && IA.content === "}" ? AA[AA.length - 1].openedBraces-- : IA.type !== "comment" && (CA = !0)), (CA || typeof IA == "string") && AA.length > 0 && AA[AA.length - 1].openedBraces === 0) {
            var BA = d(IA);
            gA < H.length - 1 && (typeof H[gA + 1] == "string" || H[gA + 1].type === "plain-text") && (BA += d(H[gA + 1]), H.splice(gA + 1, 1)), gA > 0 && (typeof H[gA - 1] == "string" || H[gA - 1].type === "plain-text") && (BA = d(H[gA - 1]) + BA, H.splice(gA - 1, 1), gA--), /^\s+$/.test(BA) ? H[gA] = BA : H[gA] = new g.Token(
              "plain-text",
              BA,
              null,
              BA
            );
          }
          IA.content && typeof IA.content != "string" && k(IA.content);
        }
      };
      g.hooks.add("after-tokenize", function(H) {
        H.language === "xquery" && k(H.tokens);
      });
    })(t);
  }
  return xquery_1;
}
var yang_1, hasRequiredYang;
function requireYang() {
  if (hasRequiredYang) return yang_1;
  hasRequiredYang = 1, yang_1 = n, n.displayName = "yang", n.aliases = [];
  function n(t) {
    t.languages.yang = {
      // https://tools.ietf.org/html/rfc6020#page-34
      // http://www.yang-central.org/twiki/bin/view/Main/YangExamples
      comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
      string: {
        pattern: /"(?:[^\\"]|\\.)*"|'[^']*'/,
        greedy: !0
      },
      keyword: {
        pattern: /(^|[{};\r\n][ \t]*)[a-z_][\w.-]*/i,
        lookbehind: !0
      },
      namespace: {
        pattern: /(\s)[a-z_][\w.-]*(?=:)/i,
        lookbehind: !0
      },
      boolean: /\b(?:false|true)\b/,
      operator: /\+/,
      punctuation: /[{};:]/
    };
  }
  return yang_1;
}
var zig_1, hasRequiredZig;
function requireZig() {
  if (hasRequiredZig) return zig_1;
  hasRequiredZig = 1, zig_1 = n, n.displayName = "zig", n.aliases = [];
  function n(t) {
    (function(g) {
      function d(BA) {
        return function() {
          return BA;
        };
      }
      var k = /\b(?:align|allowzero|and|anyframe|anytype|asm|async|await|break|cancel|catch|comptime|const|continue|defer|else|enum|errdefer|error|export|extern|fn|for|if|inline|linksection|nakedcc|noalias|nosuspend|null|or|orelse|packed|promise|pub|resume|return|stdcallcc|struct|suspend|switch|test|threadlocal|try|undefined|union|unreachable|usingnamespace|var|volatile|while)\b/, H = "\\b(?!" + k.source + ")(?!\\d)\\w+\\b", AA = /align\s*\((?:[^()]|\([^()]*\))*\)/.source, gA = /(?:\?|\bpromise->|(?:\[[^[\]]*\]|\*(?!\*)|\*\*)(?:\s*<ALIGN>|\s*const\b|\s*volatile\b|\s*allowzero\b)*)/.source.replace(
        /<ALIGN>/g,
        d(AA)
      ), IA = /(?:\bpromise\b|(?:\berror\.)?<ID>(?:\.<ID>)*(?!\s+<ID>))/.source.replace(
        /<ID>/g,
        d(H)
      ), CA = "(?!\\s)(?:!?\\s*(?:" + gA + "\\s*)*" + IA + ")+";
      g.languages.zig = {
        comment: [
          {
            pattern: /\/\/[/!].*/,
            alias: "doc-comment"
          },
          /\/{2}.*/
        ],
        string: [
          {
            // "string" and c"string"
            pattern: /(^|[^\\@])c?"(?:[^"\\\r\n]|\\.)*"/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // multiline strings and c-strings
            pattern: /([\r\n])([ \t]+c?\\{2}).*(?:(?:\r\n?|\n)\2.*)*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        char: {
          // characters 'a', '\n', '\xFF', '\u{10FFFF}'
          pattern: /(^|[^\\])'(?:[^'\\\r\n]|[\uD800-\uDFFF]{2}|\\(?:.|x[a-fA-F\d]{2}|u\{[a-fA-F\d]{1,6}\}))'/,
          lookbehind: !0,
          greedy: !0
        },
        builtin: /\B@(?!\d)\w+(?=\s*\()/,
        label: {
          pattern: /(\b(?:break|continue)\s*:\s*)\w+\b|\b(?!\d)\w+\b(?=\s*:\s*(?:\{|while\b))/,
          lookbehind: !0
        },
        "class-name": [
          // const Foo = struct {};
          /\b(?!\d)\w+(?=\s*=\s*(?:(?:extern|packed)\s+)?(?:enum|struct|union)\s*[({])/,
          {
            // const x: i32 = 9;
            // var x: Bar;
            // fn foo(x: bool, y: f32) void {}
            pattern: RegExp(
              /(:\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?[=;,)])|<TYPE>(?=\s*(?:<ALIGN>\s*)?\{)/.source.replace(/<TYPE>/g, d(CA)).replace(/<ALIGN>/g, d(AA))
            ),
            lookbehind: !0,
            inside: null
            // see below
          },
          {
            // extern fn foo(x: f64) f64; (optional alignment)
            pattern: RegExp(
              /(\)\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?;)/.source.replace(/<TYPE>/g, d(CA)).replace(/<ALIGN>/g, d(AA))
            ),
            lookbehind: !0,
            inside: null
            // see below
          }
        ],
        "builtin-type": {
          pattern: /\b(?:anyerror|bool|c_u?(?:int|long|longlong|short)|c_longdouble|c_void|comptime_(?:float|int)|f(?:16|32|64|128)|[iu](?:8|16|32|64|128|size)|noreturn|type|void)\b/,
          alias: "keyword"
        },
        keyword: k,
        function: /\b(?!\d)\w+(?=\s*\()/,
        number: /\b(?:0b[01]+|0o[0-7]+|0x[a-fA-F\d]+(?:\.[a-fA-F\d]*)?(?:[pP][+-]?[a-fA-F\d]+)?|\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)\b/,
        boolean: /\b(?:false|true)\b/,
        operator: /\.[*?]|\.{2,3}|[-=]>|\*\*|\+\+|\|\||(?:<<|>>|[-+*]%|[-+*/%^&|<>!=])=?|[?~]/,
        punctuation: /[.:,;(){}[\]]/
      }, g.languages.zig["class-name"].forEach(function(BA) {
        BA.inside === null && (BA.inside = g.languages.zig);
      });
    })(t);
  }
  return zig_1;
}
var refractor_1, hasRequiredRefractor;
function requireRefractor() {
  if (hasRequiredRefractor) return refractor_1;
  hasRequiredRefractor = 1;
  var n = requireCore();
  return refractor_1 = n, n.register(requireAbap()), n.register(requireAbnf()), n.register(requireActionscript()), n.register(requireAda()), n.register(requireAgda()), n.register(requireAl()), n.register(requireAntlr4()), n.register(requireApacheconf()), n.register(requireApex()), n.register(requireApl()), n.register(requireApplescript()), n.register(requireAql()), n.register(requireArduino()), n.register(requireArff()), n.register(requireAsciidoc()), n.register(requireAsm6502()), n.register(requireAsmatmel()), n.register(requireAspnet()), n.register(requireAutohotkey()), n.register(requireAutoit()), n.register(requireAvisynth()), n.register(requireAvroIdl()), n.register(requireBash()), n.register(requireBasic()), n.register(requireBatch()), n.register(requireBbcode()), n.register(requireBicep()), n.register(requireBirb()), n.register(requireBison()), n.register(requireBnf()), n.register(requireBrainfuck()), n.register(requireBrightscript()), n.register(requireBro()), n.register(requireBsl()), n.register(requireC()), n.register(requireCfscript()), n.register(requireChaiscript()), n.register(requireCil()), n.register(requireClojure()), n.register(requireCmake()), n.register(requireCobol()), n.register(requireCoffeescript()), n.register(requireConcurnas()), n.register(requireCoq()), n.register(requireCpp()), n.register(requireCrystal()), n.register(requireCsharp()), n.register(requireCshtml()), n.register(requireCsp()), n.register(requireCssExtras()), n.register(requireCsv()), n.register(requireCypher()), n.register(requireD()), n.register(requireDart()), n.register(requireDataweave()), n.register(requireDax()), n.register(requireDhall()), n.register(requireDiff()), n.register(requireDjango()), n.register(requireDnsZoneFile()), n.register(requireDocker()), n.register(requireDot()), n.register(requireEbnf()), n.register(requireEditorconfig()), n.register(requireEiffel()), n.register(requireEjs()), n.register(requireElixir()), n.register(requireElm()), n.register(requireErb()), n.register(requireErlang()), n.register(requireEtlua()), n.register(requireExcelFormula()), n.register(requireFactor()), n.register(require_false()), n.register(requireFirestoreSecurityRules()), n.register(requireFlow()), n.register(requireFortran()), n.register(requireFsharp()), n.register(requireFtl()), n.register(requireGap()), n.register(requireGcode()), n.register(requireGdscript()), n.register(requireGedcom()), n.register(requireGherkin()), n.register(requireGit()), n.register(requireGlsl()), n.register(requireGml()), n.register(requireGn()), n.register(requireGoModule()), n.register(requireGo()), n.register(requireGraphql()), n.register(requireGroovy()), n.register(requireHaml()), n.register(requireHandlebars()), n.register(requireHaskell()), n.register(requireHaxe()), n.register(requireHcl()), n.register(requireHlsl()), n.register(requireHoon()), n.register(requireHpkp()), n.register(requireHsts()), n.register(requireHttp()), n.register(requireIchigojam()), n.register(requireIcon()), n.register(requireIcuMessageFormat()), n.register(requireIdris()), n.register(requireIecst()), n.register(requireIgnore()), n.register(requireInform7()), n.register(requireIni()), n.register(requireIo()), n.register(requireJ()), n.register(requireJava()), n.register(requireJavadoc()), n.register(requireJavadoclike()), n.register(requireJavastacktrace()), n.register(requireJexl()), n.register(requireJolie()), n.register(requireJq()), n.register(requireJsExtras()), n.register(requireJsTemplates()), n.register(requireJsdoc()), n.register(requireJson()), n.register(requireJson5()), n.register(requireJsonp()), n.register(requireJsstacktrace()), n.register(requireJsx()), n.register(requireJulia()), n.register(requireKeepalived()), n.register(requireKeyman()), n.register(requireKotlin()), n.register(requireKumir()), n.register(requireKusto()), n.register(requireLatex()), n.register(requireLatte()), n.register(requireLess()), n.register(requireLilypond()), n.register(requireLiquid()), n.register(requireLisp()), n.register(requireLivescript()), n.register(requireLlvm()), n.register(requireLog()), n.register(requireLolcode()), n.register(requireLua()), n.register(requireMagma()), n.register(requireMakefile()), n.register(requireMarkdown()), n.register(requireMarkupTemplating()), n.register(requireMatlab()), n.register(requireMaxscript()), n.register(requireMel()), n.register(requireMermaid()), n.register(requireMizar()), n.register(requireMongodb()), n.register(requireMonkey()), n.register(requireMoonscript()), n.register(requireN1ql()), n.register(requireN4js()), n.register(requireNand2tetrisHdl()), n.register(requireNaniscript()), n.register(requireNasm()), n.register(requireNeon()), n.register(requireNevod()), n.register(requireNginx()), n.register(requireNim()), n.register(requireNix()), n.register(requireNsis()), n.register(requireObjectivec()), n.register(requireOcaml()), n.register(requireOpencl()), n.register(requireOpenqasm()), n.register(requireOz()), n.register(requireParigp()), n.register(requireParser()), n.register(requirePascal()), n.register(requirePascaligo()), n.register(requirePcaxis()), n.register(requirePeoplecode()), n.register(requirePerl()), n.register(requirePhpExtras()), n.register(requirePhp()), n.register(requirePhpdoc()), n.register(requirePlsql()), n.register(requirePowerquery()), n.register(requirePowershell()), n.register(requireProcessing()), n.register(requireProlog()), n.register(requirePromql()), n.register(requireProperties()), n.register(requireProtobuf()), n.register(requirePsl()), n.register(requirePug()), n.register(requirePuppet()), n.register(requirePure()), n.register(requirePurebasic()), n.register(requirePurescript()), n.register(requirePython()), n.register(requireQ()), n.register(requireQml()), n.register(requireQore()), n.register(requireQsharp()), n.register(requireR()), n.register(requireRacket()), n.register(requireReason()), n.register(requireRegex()), n.register(requireRego()), n.register(requireRenpy()), n.register(requireRest()), n.register(requireRip()), n.register(requireRoboconf()), n.register(requireRobotframework()), n.register(requireRuby()), n.register(requireRust()), n.register(requireSas()), n.register(requireSass()), n.register(requireScala()), n.register(requireScheme()), n.register(requireScss()), n.register(requireShellSession()), n.register(requireSmali()), n.register(requireSmalltalk()), n.register(requireSmarty()), n.register(requireSml()), n.register(requireSolidity()), n.register(requireSolutionFile()), n.register(requireSoy()), n.register(requireSparql()), n.register(requireSplunkSpl()), n.register(requireSqf()), n.register(requireSql()), n.register(requireSquirrel()), n.register(requireStan()), n.register(requireStylus()), n.register(requireSwift()), n.register(requireSystemd()), n.register(requireT4Cs()), n.register(requireT4Templating()), n.register(requireT4Vb()), n.register(requireTap()), n.register(requireTcl()), n.register(requireTextile()), n.register(requireToml()), n.register(requireTremor()), n.register(requireTsx()), n.register(requireTt2()), n.register(requireTurtle()), n.register(requireTwig()), n.register(requireTypescript()), n.register(requireTyposcript()), n.register(requireUnrealscript()), n.register(requireUorazor()), n.register(requireUri()), n.register(requireV()), n.register(requireVala()), n.register(requireVbnet()), n.register(requireVelocity()), n.register(requireVerilog()), n.register(requireVhdl()), n.register(requireVim()), n.register(requireVisualBasic()), n.register(requireWarpscript()), n.register(requireWasm()), n.register(requireWebIdl()), n.register(requireWiki()), n.register(requireWolfram()), n.register(requireWren()), n.register(requireXeora()), n.register(requireXmlDoc()), n.register(requireXojo()), n.register(requireXquery()), n.register(requireYaml()), n.register(requireYang()), n.register(requireZig()), refractor_1;
}
var refractorExports = requireRefractor();
const refractor = /* @__PURE__ */ getDefaultExportFromCjs$2(refractorExports);
var highlighter = highlight(refractor, defaultStyle$1);
highlighter.supportedLanguages = supportedLanguages;
function useTimeout(n, t) {
  const g = useRef(null), d = useRef(n);
  useEffect(() => {
    d.current = n;
  }, [n]);
  const k = useCallback(() => {
    g.current && (clearTimeout(g.current), g.current = null), t !== null && (g.current = setTimeout(() => {
      d.current();
    }, t));
  }, [t]);
  useEffect(() => (k(), () => {
    g.current && (clearTimeout(g.current), g.current = null);
  }), [k]);
  const H = useCallback(() => {
    g.current && (clearTimeout(g.current), g.current = null);
  }, []), AA = useCallback(() => {
    k();
  }, [k]);
  return {
    clear: H,
    restart: AA
  };
}
const LOG$d = loglevelExports$1.getLogger("useCopyToClipboard"), useCopyToClipboard = ({
  timeout: n = 2e3
} = {}) => {
  const [t, g] = useState(!1), {
    restart: d
  } = useTimeout(useCallback(() => {
    g(!1);
  }, []), t ? n : null), k = useCallback((AA) => {
    (async () => {
      try {
        await navigator.clipboard.writeText(AA), g(!0), d();
      } catch (IA) {
        LOG$d.error("Failed to copy text to clipboard:", IA), g(!1);
      }
    })();
  }, [d]);
  return {
    isCopied: t,
    copyToClipboard: k,
    label: t ? "Copied" : "Copy to clipboard"
  };
}, codeLink = {
  // Streamline the style when inside anchors to avoid broken underline and more
  "a > &": {
    color: "inherit"
  }
}, StyledInlineCode = /* @__PURE__ */ createStyled$1("code", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz5"
} : {
  target: "e1ycw9pz5",
  label: "StyledInlineCode"
})(({
  theme: n
}) => ({
  padding: "0.2em 0.4em",
  overflowWrap: "break-word",
  whiteSpace: "pre-wrap",
  margin: 0,
  borderRadius: n.radii.md,
  background: n.colors.codeBackgroundColor,
  color: n.colors.codeTextColor,
  fontFamily: n.genericFonts.codeFont,
  // Use em here so that it works correctly within headers, captions,
  // sidebar, etc.
  fontSize: n.fontSizes.inlineCodeFontSize,
  fontWeight: n.fontWeights.code,
  ...codeLink
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), codeBlockStyle = (n, t) => ({
  background: "transparent",
  border: 0,
  color: "inherit",
  display: "inline",
  fontFamily: n.genericFonts.codeFont,
  fontSize: n.fontSizes.codeFontSize,
  fontWeight: n.fontWeights.code,
  lineHeight: "inherit",
  margin: 0,
  overflowX: "auto",
  padding: 0,
  whiteSpace: t ? "pre-wrap" : "pre",
  overflowWrap: t ? "break-word" : "normal",
  ...codeLink
}), StyledCode = /* @__PURE__ */ createStyled$1("code", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz4"
} : {
  target: "e1ycw9pz4",
  label: "StyledCode"
})(({
  theme: n,
  wrapLines: t
}) => ({
  ...codeBlockStyle(n, t)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPre = /* @__PURE__ */ createStyled$1("pre", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz3"
} : {
  target: "e1ycw9pz3",
  label: "StyledPre"
})(({
  theme: n,
  wrapLines: t
}) => ({
  height: "100%",
  background: n.colors.codeBackgroundColor,
  borderRadius: n.radii.default,
  color: n.colors.bodyText,
  fontSize: n.fontSizes.twoSm,
  fontFamily: n.genericFonts.codeFont,
  display: "block",
  // Remove browser default top margin
  margin: 0,
  // Disable auto-hiding scrollbar in legacy Edge to avoid overlap,
  // making it impossible to interact with the content
  msOverflowStyle: "scrollbar",
  // Don't allow content to break outside
  overflow: "auto",
  // Add padding around the code
  padding: n.spacing.lg,
  // Add padding to the right to account for the copy button
  paddingRight: n.iconSizes.threeXL,
  code: {
    ...codeBlockStyle(n, t)
  },
  // The token can consist of many lines, e.g. a triple-quote string, so
  // we need to make sure that the color is not overwritten.
  ".comment.linenumber": {
    color: n.colors.fadedText40,
    fontSize: n.fontSizes.twoSm,
    // Center-align number vertically, or they'll be positioned differently when
    // wrapLines=true. Even with this change, though, the position is still ~2px
    // off.
    // NOTE: The alignSelf below only apply applies when wrapLines=true, because
    // that option wraps this element in a flex container.
    alignSelf: "center",
    // Override the default token's min-width, to ensure it fits 3-digit lines
    minWidth: `${n.spacing.threeXL} !important`
  },
  ".token.comment, .token.prolog, .token.doctype, .token.cdata": {
    color: n.colors.gray70
  },
  ".token.punctuation": {
    color: n.colors.gray70
  },
  ".namespace": {
    opacity: 0.7
  },
  ".token.attr-name, .token.property, .token.variable": {
    color: n.colors.lightBlue80
  },
  ".token.boolean, .token.constant, .token.symbol": {
    color: n.colors.green70
  },
  ".token.number, .token.regex": {
    color: n.colors.blueGreen80
  },
  ".token.string, .token.char, .token.attr-value": {
    color: n.colors.green80
  },
  ".token.operator, .token.entity": {
    color: n.colors.orange90
  },
  ".token.url": {
    color: n.colors.purple80
  },
  ".token.decorator, .token.atrule": {
    color: n.colors.orange90
  },
  ".token.keyword, .token.tag": {
    color: n.colors.blue70
  },
  ".token.function, .token.class-name, .token.selector": {
    color: n.colors.blue70,
    fontWeight: n.fontWeights.codeExtraBold
  },
  ".token.important": {
    color: n.colors.red70,
    fontWeight: n.fontWeights.codeExtraBold
  },
  ".token.comment": {
    color: n.colors.gray70,
    fontStyle: "italic"
  },
  ".token.italic": {
    fontStyle: "italic"
  },
  ".token.entity": {
    cursor: "help"
  },
  /**
   * Diff syntax highlighting
   */
  ".token.deleted.line, .token.deleted.prefix": {
    color: n.colors.red70
  },
  ".token.inserted.line, .token.inserted.prefix": {
    color: n.colors.green70
  },
  ".token.unchanged.line": {
    color: n.colors.gray70
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCopyButtonContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz2"
} : {
  target: "e1ycw9pz2",
  label: "StyledCopyButtonContainer"
})(({
  theme: n
}) => ({
  opacity: 0,
  padding: `${n.spacing.sm} ${n.spacing.sm} 0 0`,
  top: 0,
  right: 0,
  position: "absolute",
  width: "100%",
  height: "100%",
  backgroundColor: n.colors.transparent,
  zIndex: n.zIndices.sidebar + 1,
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-start",
  transition: "opacity 300ms 150ms",
  pointerEvents: "none"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCodeBlock = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz1"
} : {
  target: "e1ycw9pz1",
  label: "StyledCodeBlock"
})(({
  theme: n
}) => ({
  height: "100%",
  position: "relative",
  marginLeft: n.spacing.none,
  marginRight: n.spacing.none,
  marginTop: n.spacing.none,
  marginBottom: void 0,
  "&:hover": {
    [`${StyledCopyButtonContainer}`]: {
      opacity: 1
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Db2RlQmxvY2svc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNE4rQiIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvQ29kZUJsb2NrL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCB7IENTU09iamVjdCwgVGhlbWUgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIlxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuY29uc3QgY29kZUxpbms6IENTU09iamVjdCA9IHtcbiAgLy8gU3RyZWFtbGluZSB0aGUgc3R5bGUgd2hlbiBpbnNpZGUgYW5jaG9ycyB0byBhdm9pZCBicm9rZW4gdW5kZXJsaW5lIGFuZCBtb3JlXG4gIFwiYSA+ICZcIjoge1xuICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgfSxcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZElubGluZUNvZGUgPSBzdHlsZWQuY29kZSgoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nOiBcIjAuMmVtIDAuNGVtXCIsXG4gIG92ZXJmbG93V3JhcDogXCJicmVhay13b3JkXCIsXG4gIHdoaXRlU3BhY2U6IFwicHJlLXdyYXBcIixcbiAgbWFyZ2luOiAwLFxuICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLm1kLFxuICBiYWNrZ3JvdW5kOiB0aGVtZS5jb2xvcnMuY29kZUJhY2tncm91bmRDb2xvcixcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5jb2RlVGV4dENvbG9yLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuY29kZUZvbnQsXG4gIC8vIFVzZSBlbSBoZXJlIHNvIHRoYXQgaXQgd29ya3MgY29ycmVjdGx5IHdpdGhpbiBoZWFkZXJzLCBjYXB0aW9ucyxcbiAgLy8gc2lkZWJhciwgZXRjLlxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmlubGluZUNvZGVGb250U2l6ZSxcbiAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuY29kZSxcblxuICAuLi5jb2RlTGluayxcbn0pKVxuXG50eXBlIFN0eWxlZENvZGVQcm9wcyA9IHtcbiAgd3JhcExpbmVzOiBib29sZWFuXG59XG5cbmNvbnN0IGNvZGVCbG9ja1N0eWxlID0gKFxuICB0aGVtZTogVGhlbWUsXG4gIHdyYXBMaW5lczogU3R5bGVkQ29kZVByb3BzW1wid3JhcExpbmVzXCJdXG4pOiBDU1NPYmplY3QgPT4gKHtcbiAgYmFja2dyb3VuZDogXCJ0cmFuc3BhcmVudFwiLFxuICBib3JkZXI6IDAsXG4gIGNvbG9yOiBcImluaGVyaXRcIixcbiAgZGlzcGxheTogXCJpbmxpbmVcIixcbiAgZm9udEZhbWlseTogdGhlbWUuZ2VuZXJpY0ZvbnRzLmNvZGVGb250LFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmNvZGVGb250U2l6ZSxcbiAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuY29kZSxcbiAgbGluZUhlaWdodDogXCJpbmhlcml0XCIsXG4gIG1hcmdpbjogMCxcbiAgb3ZlcmZsb3dYOiBcImF1dG9cIixcbiAgcGFkZGluZzogMCxcbiAgd2hpdGVTcGFjZTogd3JhcExpbmVzID8gXCJwcmUtd3JhcFwiIDogXCJwcmVcIixcbiAgb3ZlcmZsb3dXcmFwOiB3cmFwTGluZXMgPyBcImJyZWFrLXdvcmRcIiA6IFwibm9ybWFsXCIsXG4gIC4uLmNvZGVMaW5rLFxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvZGUgPSBzdHlsZWQuY29kZTxTdHlsZWRDb2RlUHJvcHM+KFxuICAoeyB0aGVtZSwgd3JhcExpbmVzIH0pID0+ICh7XG4gICAgLi4uY29kZUJsb2NrU3R5bGUodGhlbWUsIHdyYXBMaW5lcyksXG4gIH0pXG4pXG5cbi8qXG4gIFRoaXMgaXMgdGhlIGRlZmF1bHQgcHJpc20uanMgdGhlbWUgZm9yIEphdmFTY3JpcHQsIENTUyBhbmQgSFRNTCwgYnV0XG4gIHN0cmlwcGVkIG9mIGV2ZXJ5dGhpbmcgZXhjZXB0IGZvciB0b2tlbiBzdHlsaW5nLlxuXG4gIFNlZSBodHRwczovL3ByaXNtanMuY29tL2Rvd25sb2FkLmh0bWwjdGhlbWVzPXByaXNtJmxhbmd1YWdlcz1tYXJrdXArY3NzK2NsaWtlK2phdmFzY3JpcHRcbiovXG5leHBvcnQgY29uc3QgU3R5bGVkUHJlID0gc3R5bGVkLnByZTxTdHlsZWRDb2RlUHJvcHM+KFxuICAoeyB0aGVtZSwgd3JhcExpbmVzIH0pID0+ICh7XG4gICAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgICBiYWNrZ3JvdW5kOiB0aGVtZS5jb2xvcnMuY29kZUJhY2tncm91bmRDb2xvcixcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnR3b1NtLFxuICAgIGZvbnRGYW1pbHk6IHRoZW1lLmdlbmVyaWNGb250cy5jb2RlRm9udCxcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgLy8gUmVtb3ZlIGJyb3dzZXIgZGVmYXVsdCB0b3AgbWFyZ2luXG4gICAgbWFyZ2luOiAwLFxuICAgIC8vIERpc2FibGUgYXV0by1oaWRpbmcgc2Nyb2xsYmFyIGluIGxlZ2FjeSBFZGdlIHRvIGF2b2lkIG92ZXJsYXAsXG4gICAgLy8gbWFraW5nIGl0IGltcG9zc2libGUgdG8gaW50ZXJhY3Qgd2l0aCB0aGUgY29udGVudFxuICAgIG1zT3ZlcmZsb3dTdHlsZTogXCJzY3JvbGxiYXJcIixcblxuICAgIC8vIERvbid0IGFsbG93IGNvbnRlbnQgdG8gYnJlYWsgb3V0c2lkZVxuICAgIG92ZXJmbG93OiBcImF1dG9cIixcblxuICAgIC8vIEFkZCBwYWRkaW5nIGFyb3VuZCB0aGUgY29kZVxuICAgIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgLy8gQWRkIHBhZGRpbmcgdG8gdGhlIHJpZ2h0IHRvIGFjY291bnQgZm9yIHRoZSBjb3B5IGJ1dHRvblxuICAgIHBhZGRpbmdSaWdodDogdGhlbWUuaWNvblNpemVzLnRocmVlWEwsXG5cbiAgICBjb2RlOiB7IC4uLmNvZGVCbG9ja1N0eWxlKHRoZW1lLCB3cmFwTGluZXMpIH0sXG5cbiAgICAvLyBUaGUgdG9rZW4gY2FuIGNvbnNpc3Qgb2YgbWFueSBsaW5lcywgZS5nLiBhIHRyaXBsZS1xdW90ZSBzdHJpbmcsIHNvXG4gICAgLy8gd2UgbmVlZCB0byBtYWtlIHN1cmUgdGhhdCB0aGUgY29sb3IgaXMgbm90IG92ZXJ3cml0dGVuLlxuICAgIFwiLmNvbW1lbnQubGluZW51bWJlclwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy50d29TbSxcblxuICAgICAgLy8gQ2VudGVyLWFsaWduIG51bWJlciB2ZXJ0aWNhbGx5LCBvciB0aGV5J2xsIGJlIHBvc2l0aW9uZWQgZGlmZmVyZW50bHkgd2hlblxuICAgICAgLy8gd3JhcExpbmVzPXRydWUuIEV2ZW4gd2l0aCB0aGlzIGNoYW5nZSwgdGhvdWdoLCB0aGUgcG9zaXRpb24gaXMgc3RpbGwgfjJweFxuICAgICAgLy8gb2ZmLlxuICAgICAgLy8gTk9URTogVGhlIGFsaWduU2VsZiBiZWxvdyBvbmx5IGFwcGx5IGFwcGxpZXMgd2hlbiB3cmFwTGluZXM9dHJ1ZSwgYmVjYXVzZVxuICAgICAgLy8gdGhhdCBvcHRpb24gd3JhcHMgdGhpcyBlbGVtZW50IGluIGEgZmxleCBjb250YWluZXIuXG4gICAgICBhbGlnblNlbGY6IFwiY2VudGVyXCIsXG5cbiAgICAgIC8vIE92ZXJyaWRlIHRoZSBkZWZhdWx0IHRva2VuJ3MgbWluLXdpZHRoLCB0byBlbnN1cmUgaXQgZml0cyAzLWRpZ2l0IGxpbmVzXG4gICAgICBtaW5XaWR0aDogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhMfSAhaW1wb3J0YW50YCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uY29tbWVudCwgLnRva2VuLnByb2xvZywgLnRva2VuLmRvY3R5cGUsIC50b2tlbi5jZGF0YVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk3MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4ucHVuY3R1YXRpb25cIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NzAsXG4gICAgfSxcblxuICAgIFwiLm5hbWVzcGFjZVwiOiB7XG4gICAgICBvcGFjaXR5OiAwLjcsXG4gICAgfSxcblxuICAgIFwiLnRva2VuLmF0dHItbmFtZSwgLnRva2VuLnByb3BlcnR5LCAudG9rZW4udmFyaWFibGVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5saWdodEJsdWU4MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uYm9vbGVhbiwgLnRva2VuLmNvbnN0YW50LCAudG9rZW4uc3ltYm9sXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JlZW43MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4ubnVtYmVyLCAudG9rZW4ucmVnZXhcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ibHVlR3JlZW44MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uc3RyaW5nLCAudG9rZW4uY2hhciwgLnRva2VuLmF0dHItdmFsdWVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmVlbjgwLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi5vcGVyYXRvciwgLnRva2VuLmVudGl0eVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLm9yYW5nZTkwLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi51cmxcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wdXJwbGU4MCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uZGVjb3JhdG9yLCAudG9rZW4uYXRydWxlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMub3JhbmdlOTAsXG4gICAgfSxcblxuICAgIFwiLnRva2VuLmtleXdvcmQsIC50b2tlbi50YWdcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ibHVlNzAsXG4gICAgfSxcblxuICAgIFwiLnRva2VuLmZ1bmN0aW9uLCAudG9rZW4uY2xhc3MtbmFtZSwgLnRva2VuLnNlbGVjdG9yXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYmx1ZTcwLFxuICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuY29kZUV4dHJhQm9sZCxcbiAgICB9LFxuXG4gICAgXCIudG9rZW4uaW1wb3J0YW50XCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucmVkNzAsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlRXh0cmFCb2xkLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi5jb21tZW50XCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTcwLFxuICAgICAgZm9udFN0eWxlOiBcIml0YWxpY1wiLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi5pdGFsaWNcIjoge1xuICAgICAgZm9udFN0eWxlOiBcIml0YWxpY1wiLFxuICAgIH0sXG5cbiAgICBcIi50b2tlbi5lbnRpdHlcIjoge1xuICAgICAgY3Vyc29yOiBcImhlbHBcIixcbiAgICB9LFxuXG4gICAgLyoqXG4gICAgICogRGlmZiBzeW50YXggaGlnaGxpZ2h0aW5nXG4gICAgICovXG4gICAgXCIudG9rZW4uZGVsZXRlZC5saW5lLCAudG9rZW4uZGVsZXRlZC5wcmVmaXhcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5yZWQ3MCxcbiAgICB9LFxuICAgIFwiLnRva2VuLmluc2VydGVkLmxpbmUsIC50b2tlbi5pbnNlcnRlZC5wcmVmaXhcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmVlbjcwLFxuICAgIH0sXG4gICAgXCIudG9rZW4udW5jaGFuZ2VkLmxpbmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NzAsXG4gICAgfSxcbiAgfSlcbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvcHlCdXR0b25Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG9wYWNpdHk6IDAsXG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcuc219ICR7dGhlbWUuc3BhY2luZy5zbX0gMCAwYCxcbiAgdG9wOiAwLFxuICByaWdodDogMCxcbiAgcG9zaXRpb246IFwiYWJzb2x1dGVcIixcbiAgd2lkdGg6IFwiMTAwJVwiLFxuICBoZWlnaHQ6IFwiMTAwJVwiLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5zaWRlYmFyICsgMSxcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImZsZXgtZW5kXCIsXG4gIGFsaWduSXRlbXM6IFwiZmxleC1zdGFydFwiLFxuICB0cmFuc2l0aW9uOiBcIm9wYWNpdHkgMzAwbXMgMTUwbXNcIixcbiAgcG9pbnRlckV2ZW50czogXCJub25lXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvZGVCbG9jayA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgbWFyZ2luQm90dG9tOiB1bmRlZmluZWQsXG5cbiAgXCImOmhvdmVyXCI6IHtcbiAgICBbYCR7U3R5bGVkQ29weUJ1dHRvbkNvbnRhaW5lcn1gXToge1xuICAgICAgb3BhY2l0eTogMSxcbiAgICB9LFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDb3B5QnV0dG9uID0gc3R5bGVkLmJ1dHRvbigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb2ludGVyRXZlbnRzOiBcImF1dG9cIixcbiAgaGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMudGhyZWVYTCxcbiAgd2lkdGg6IHRoZW1lLmljb25TaXplcy50aHJlZVhMLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIGJvcmRlcjogXCJub25lXCIsXG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICB0cmFuc2Zvcm06IFwic2NhbGUoMClcIixcbiAgdG9wOiAwLFxuICByaWdodDogMCxcblxuICAvLyBTaG93IGJ1dHRvbiBvbiBjb250YWluZXIgaG92ZXJcbiAgW2Ake1N0eWxlZENvZGVCbG9ja306aG92ZXIgJmBdOiB7XG4gICAgb3BhY2l0eTogMSxcbiAgICB0cmFuc2Zvcm06IFwic2NhbGUoMSlcIixcbiAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB0cmFuc2l0aW9uOiBcIm5vbmVcIixcbiAgfSxcblxuICAvLyBTaG93IGJ1dHRvbiBvbiBpdHMgb3duIGhvdmVyL2ZvY3VzIHN0YXRlc1xuICBcIiY6aG92ZXIsICY6Zm9jdXMsICY6YWN0aXZlLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIG9wYWNpdHk6IDEsXG4gICAgdHJhbnNmb3JtOiBcInNjYWxlKDEpXCIsXG4gICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgdHJhbnNpdGlvbjogXCJub25lXCIsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5tZCxcbiAgfSxcblxuICBcIiY6aG92ZXJcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICB9LFxuXG4gIC8vIEFjY2Vzc2libGUgZm9jdXMgcmluZyB3aGVuIGtleWJvYXJkIGZvY3VzaW5nIHRoZSBidXR0b25cbiAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJveFNoYWRvdzogYDAgMCAwIDAuMnJlbSAke3RoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjV9YCxcbiAgfSxcbn0pKVxuIl19 */"), StyledCopyButton = /* @__PURE__ */ createStyled$1("button", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz0"
} : {
  target: "e1ycw9pz0",
  label: "StyledCopyButton"
})(({
  theme: n
}) => ({
  pointerEvents: "auto",
  height: n.iconSizes.threeXL,
  width: n.iconSizes.threeXL,
  padding: n.spacing.none,
  border: "none",
  backgroundColor: n.colors.transparent,
  color: n.colors.fadedText60,
  transform: "scale(0)",
  top: 0,
  right: 0,
  // Show button on container hover
  [`${StyledCodeBlock}:hover &`]: {
    opacity: 1,
    transform: "scale(1)",
    outline: "none",
    transition: "none"
  },
  // Show button on its own hover/focus states
  "&:hover, &:focus, &:active, &:focus-visible": {
    opacity: 1,
    transform: "scale(1)",
    outline: "none",
    transition: "none",
    borderRadius: n.radii.md
  },
  "&:hover": {
    color: n.colors.bodyText,
    backgroundColor: n.colors.darkenedBgMix15
  },
  "&:active": {
    color: n.colors.bodyText,
    backgroundColor: n.colors.darkenedBgMix25
  },
  // Accessible focus ring when keyboard focusing the button
  "&:focus-visible": {
    boxShadow: `0 0 0 0.2rem ${n.colors.darkenedBgMix25}`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), CopyButton = ({
  text: n
}) => {
  const t = useEmotionTheme(), g = useRef(null), {
    isCopied: d,
    copyToClipboard: k,
    label: H
  } = useCopyToClipboard(), AA = useCallback(() => {
    k(n);
  }, [k, n]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCopyButton, { "data-testid": "stCodeCopyButton", title: H, "aria-label": H, type: "button", ref: g, onClick: AA, children: d ? /* @__PURE__ */ jsxRuntimeExports.jsx(Check$1, { size: convertRemToPx(t.iconSizes.base) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Copy, { size: convertRemToPx(t.iconSizes.base) }) });
}, CopyButton$1 = memo$1(CopyButton);
function StreamlitSyntaxHighlighter$1({
  language: n,
  showLineNumbers: t,
  wrapLines: g,
  children: d
}) {
  const k = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
    ({
      rows: H,
      stylesheet: AA,
      useInlineStyles: gA
    }) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
      H.map((IA, CA) => {
        const BA = IA.children;
        if (BA) {
          const eA = BA.shift();
          eA && (IA.children = [eA, {
            children: BA,
            properties: {
              className: []
            },
            tagName: "span",
            type: "element"
          }]);
        }
        return createElement({
          node: IA,
          stylesheet: AA,
          useInlineStyles: gA,
          key: CA
        });
      })
    ),
    []
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledCodeBlock, { className: "stCode", "data-testid": "stCode", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPre, { wrapLines: g ?? !1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      highlighter,
      {
        language: n,
        PreTag: "div",
        customStyle: {
          backgroundColor: "transparent"
        },
        style: {},
        lineNumberStyle: {},
        showLineNumbers: t,
        wrapLongLines: g,
        renderer: t && g ? k : void 0,
        children: d
      }
    ) }),
    typeof d == "string" && d.trim() !== "" && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCopyButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CopyButton$1, { text: d }) })
  ] });
}
const StreamlitSyntaxHighlighter$2 = memo$1(StreamlitSyntaxHighlighter$1), StreamlitSyntaxHighlighter$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: StreamlitSyntaxHighlighter$2
}, Symbol.toStringTag, { value: "Module" })), StyledStackTrace = /* @__PURE__ */ createStyled$1("pre", process.env.NODE_ENV === "production" ? {
  target: "e1ixn3a01"
} : {
  target: "e1ixn3a01",
  label: "StyledStackTrace"
})(({
  theme: n
}) => ({
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
  color: "inherit",
  fontSize: n.fontSizes.codeFontSize,
  fontFamily: n.genericFonts.codeFont,
  fontWeight: n.fontWeights.code,
  backgroundColor: n.colors.transparent,
  overflowX: "auto",
  margin: 0,
  borderRadius: n.radii.default,
  padding: n.spacing.lg,
  border: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorName = /* @__PURE__ */ createStyled$1("strong", process.env.NODE_ENV === "production" ? {
  target: "e1ixn3a00"
} : {
  target: "e1ixn3a00",
  label: "StyledErrorName"
})(({
  theme: n
}) => ({
  fontWeight: n.fontWeights.codeBold
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function ErrorElement(n) {
  const {
    name: t,
    message: g,
    stack: d,
    width: k
  } = n, H = d ? d.split(`
`) : [];
  H.shift();
  const AA = H.map((gA) => gA.trim()).join(`
`);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AlertContainer, { kind: Kind.ERROR, width: k, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledErrorName, { children: [
      t,
      ": "
    ] }),
    g,
    d ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTrace, { "data-testid": "stErrorElementStack", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCode, { wrapLines: !1, children: AA }) }) : null
  ] });
}
const LOG$c = loglevelExports$1.getLogger("ErrorBoundary"), qI = class qI extends PureComponent {
  constructor() {
    super(...arguments), this.state = {
      error: null
    }, this.componentDidCatch = (t) => {
      LOG$c.error(`${t.name}: ${t.message}
${t.stack}`);
    };
  }
  render() {
    const {
      error: t
    } = this.state;
    return t ? t.name === "ChunkLoadError" ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorElement, { width: this.props.width, name: "Network issue", message: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      "Cannot load Streamlit frontend code. This can happen when you update Streamlit while a Streamlit app is running.",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      "To fix this, simply reload this app by pressing",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { children: "F5" }),
      ",",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { children: "Ctrl+R" }),
      ", or",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { children: "Cmd+R" }),
      ".",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      "If the error persists, try force-clearing your browser's cache as described",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://en.wikipedia.org/wiki/Wikipedia:Bypass_your_cache#Cache_clearing_and_disabling", rel: "noopener noreferrer", target: "_blank", children: "here" })
    ] }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorElement, { width: this.props.width, name: t.name, message: t.message, stack: t.stack }) : this.props.children;
  }
};
qI.getDerivedStateFromError = (t) => ({
  error: t
});
let ErrorBoundary = qI;
var PLACEMENT = {
  auto: "auto",
  topLeft: "topLeft",
  top: "top",
  topRight: "topRight",
  rightTop: "rightTop",
  right: "right",
  rightBottom: "rightBottom",
  bottomRight: "bottomRight",
  bottom: "bottom",
  bottomLeft: "bottomLeft",
  leftBottom: "leftBottom",
  left: "left",
  leftTop: "leftTop"
}, TRIGGER_TYPE = {
  click: "click",
  hover: "hover"
}, STATE_CHANGE_TYPE$1 = {
  open: "open",
  close: "close"
}, ACCESSIBILITY_TYPE = {
  none: "none",
  menu: "menu",
  tooltip: "tooltip"
}, POPOVER_MARGIN = 8, ARROW_SIZE = 6, ANIMATE_OUT_TIME = 0, ANIMATE_IN_TIME = 20, ARROW_WIDTH = Math.ceil(Math.sqrt(Math.pow(ARROW_SIZE * 2, 2) / 2));
function _typeof$d(n) {
  "@babel/helpers - typeof";
  return _typeof$d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$d(n);
}
function ownKeys$m(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$k(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$m(Object(g), !0).forEach(function(d) {
      _defineProperty$p(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$m(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _classCallCheck$i(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$a(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$i(n, t, g) {
  return t && _defineProperties$a(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$i(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$a(n, t);
}
function _setPrototypeOf$a(n, t) {
  return _setPrototypeOf$a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$a(n, t);
}
function _createSuper$a(n) {
  var t = _isNativeReflectConstruct$a();
  return function() {
    var d = _getPrototypeOf$a(n), k;
    if (t) {
      var H = _getPrototypeOf$a(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$i(this, k);
  };
}
function _possibleConstructorReturn$i(n, t) {
  if (t && (_typeof$d(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$a(n);
}
function _assertThisInitialized$a(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$a() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$a(n) {
  return _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$a(n);
}
function _defineProperty$p(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var defaultStateReducer = function n(t, g) {
  return g;
}, StatefulContainer$1 = /* @__PURE__ */ (function(n) {
  _inherits$i(g, n);
  var t = _createSuper$a(g);
  function g() {
    var d;
    _classCallCheck$i(this, g);
    for (var k = arguments.length, H = new Array(k), AA = 0; AA < k; AA++)
      H[AA] = arguments[AA];
    return d = t.call.apply(t, [this].concat(H)), _defineProperty$p(_assertThisInitialized$a(d), "state", _objectSpread$k({
      isOpen: !1
    }, d.props.initialState)), _defineProperty$p(_assertThisInitialized$a(d), "onBlur", function(gA) {
      d.props.onBlur && d.props.onBlur(gA), !(d.props.focusLock || d.props.autoFocus) && d.close();
    }), _defineProperty$p(_assertThisInitialized$a(d), "onClick", function(gA) {
      d.props.onClick && d.props.onClick(gA), d.state.isOpen ? d.close() : d.open();
    }), _defineProperty$p(_assertThisInitialized$a(d), "onClickOutside", function() {
      d.close();
    }), _defineProperty$p(_assertThisInitialized$a(d), "onEsc", function() {
      d.close();
    }), _defineProperty$p(_assertThisInitialized$a(d), "onFocus", function(gA) {
      d.props.onFocus && d.props.onFocus(gA), isFocusVisible(gA) && d.open();
    }), _defineProperty$p(_assertThisInitialized$a(d), "onMouseEnter", function(gA) {
      d.props.onMouseEnter && d.props.onMouseEnter(gA), d.open();
    }), _defineProperty$p(_assertThisInitialized$a(d), "onMouseLeave", function(gA) {
      d.props.onMouseLeave && d.props.onMouseLeave(gA), d.close();
    }), _defineProperty$p(_assertThisInitialized$a(d), "onContentClose", function() {
      d.close();
    }), _defineProperty$p(_assertThisInitialized$a(d), "renderContent", function() {
      var gA = d.props.content;
      return typeof gA == "function" ? gA({
        close: d.onContentClose
      }) : gA;
    }), d;
  }
  return _createClass$i(g, [{
    key: "open",
    value: function() {
      this.internalSetState(STATE_CHANGE_TYPE$1.open, {
        isOpen: !0
      }), this.props.onOpen && this.props.onOpen();
    }
  }, {
    key: "close",
    value: function() {
      this.internalSetState(STATE_CHANGE_TYPE$1.close, {
        isOpen: !1
      }), this.props.onClose && this.props.onClose();
    }
  }, {
    key: "internalSetState",
    value: function(k, H) {
      var AA = this.props.stateReducer;
      if (typeof AA != "function") {
        this.setState(H);
        return;
      }
      this.setState(function(gA) {
        return AA(k, H, gA);
      });
    }
    /**
     * If user passed a content render prop, we want to give them a
     * callback to close the Popover. This is useful in any case where
     * a dev wants to manually close the popover based on some action.
     *
     * One simple example is a Popover with a "Dismiss" button in it:
     * <StatefulPopover content={({close}) => <button onClick={close}>Dismiss</button>}>
     *  Click me
     * </StatefulPopover>
     */
  }, {
    key: "render",
    value: function() {
      var k = this.props, H = k.accessibilityType, AA = k.autoFocus, gA = k.animateOutTime, IA = k.dismissOnClickOutside, CA = k.dismissOnEsc, BA = k.focusLock, eA = k.ignoreBoundary, iA = k.mountNode, QA = k.onBlur, tA = k.onClick, oA = k.onFocus, EA = k.onMouseEnter, aA = k.onMouseLeave, nA = k.onMouseEnterDelay, lA = k.onMouseLeaveDelay, cA = k.overrides, sA = k.placement, rA = k.popperOptions, uA = k.renderAll, hA = k.returnFocus, dA = k.showArrow, GA = k.triggerType, DA = k.popoverMargin, wA = k.focusOptions, bA = {
        accessibilityType: H,
        animateOutTime: gA,
        autoFocus: AA,
        content: this.renderContent,
        focusLock: BA,
        ignoreBoundary: eA,
        isOpen: this.state.isOpen,
        mountNode: iA,
        onBlur: QA,
        onClick: tA,
        onFocus: oA,
        onMouseEnter: EA,
        onMouseLeave: aA,
        onMouseEnterDelay: nA,
        onMouseLeaveDelay: lA,
        overrides: cA,
        placement: sA,
        popperOptions: rA,
        renderAll: uA,
        returnFocus: hA,
        showArrow: dA,
        triggerType: GA,
        popoverMargin: DA,
        focusOptions: wA
      };
      return IA && (bA.onClickOutside = this.onClickOutside), CA && (bA.onEsc = this.onEsc), GA === TRIGGER_TYPE.hover ? (bA.onBlur = this.onBlur, bA.onFocus = this.onFocus, bA.onMouseEnter = this.onMouseEnter, bA.onMouseLeave = this.onMouseLeave) : bA.onClick = this.onClick, this.props.children(bA);
    }
  }]), g;
})(React.Component);
_defineProperty$p(StatefulContainer$1, "defaultProps", {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  ignoreBoundary: !1,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT.auto,
  popperOptions: {},
  showArrow: !1,
  triggerType: TRIGGER_TYPE.click,
  dismissOnClickOutside: !0,
  dismissOnEsc: !0,
  stateReducer: defaultStateReducer,
  popoverMargin: POPOVER_MARGIN
});
var FOCUS_GROUP = "data-focus-lock", FOCUS_DISABLED = "data-focus-lock-disabled", FOCUS_ALLOW = "data-no-focus-lock", FOCUS_AUTO = "data-autofocus-inside", FOCUS_NO_AUTOFOCUS = "data-no-autofocus";
function assignRef(n, t) {
  return typeof n == "function" ? n(t) : n && (n.current = t), n;
}
function useCallbackRef(n, t) {
  var g = useState(function() {
    return {
      // value
      value: n,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return g.value;
        },
        set current(d) {
          var k = g.value;
          k !== d && (g.value = d, g.callback(d, k));
        }
      }
    };
  })[0];
  return g.callback = t, g.facade;
}
var useIsomorphicLayoutEffect = typeof window < "u" ? React.useLayoutEffect : React.useEffect, currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(n, t) {
  var g = useCallbackRef(null, function(d) {
    return n.forEach(function(k) {
      return assignRef(k, d);
    });
  });
  return useIsomorphicLayoutEffect(function() {
    var d = currentValues.get(g);
    if (d) {
      var k = new Set(d), H = new Set(n), AA = g.current;
      k.forEach(function(gA) {
        H.has(gA) || assignRef(gA, null);
      }), H.forEach(function(gA) {
        k.has(gA) || assignRef(gA, AA);
      });
    }
    currentValues.set(g, n);
  }, [n]), g;
}
var hiddenGuard = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && PropTypes.node;
function ItoI(n) {
  return n;
}
function innerCreateMedium(n, t) {
  t === void 0 && (t = ItoI);
  var g = [], d = !1, k = {
    read: function() {
      if (d)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return g.length ? g[g.length - 1] : n;
    },
    useMedium: function(H) {
      var AA = t(H, d);
      return g.push(AA), function() {
        g = g.filter(function(gA) {
          return gA !== AA;
        });
      };
    },
    assignSyncMedium: function(H) {
      for (d = !0; g.length; ) {
        var AA = g;
        g = [], AA.forEach(H);
      }
      g = {
        push: function(gA) {
          return H(gA);
        },
        filter: function() {
          return g;
        }
      };
    },
    assignMedium: function(H) {
      d = !0;
      var AA = [];
      if (g.length) {
        var gA = g;
        g = [], gA.forEach(H), AA = g;
      }
      var IA = function() {
        var BA = AA;
        AA = [], BA.forEach(H);
      }, CA = function() {
        return Promise.resolve().then(IA);
      };
      CA(), g = {
        push: function(BA) {
          AA.push(BA), CA();
        },
        filter: function(BA) {
          return AA = AA.filter(BA), g;
        }
      };
    }
  };
  return k;
}
function createMedium(n, t) {
  return t === void 0 && (t = ItoI), innerCreateMedium(n, t);
}
function createSidecarMedium(n) {
  n === void 0 && (n = {});
  var t = innerCreateMedium(null);
  return t.options = __assign$2({ async: !0, ssr: !1 }, n), t;
}
var mediumFocus = createMedium({}, function(n) {
  var t = n.target, g = n.currentTarget;
  return {
    target: t,
    currentTarget: g
  };
}), mediumBlur = createMedium(), mediumEffect = createMedium(), mediumSidecar = createSidecarMedium({
  async: !0,
  ssr: typeof document < "u"
}), focusScope = /* @__PURE__ */ createContext(void 0), emptyArray = [], FocusLock = /* @__PURE__ */ forwardRef(function n(t, g) {
  var d, k = useState(), H = k[0], AA = k[1], gA = useRef(), IA = useRef(!1), CA = useRef(null), BA = useState({}), eA = BA[1], iA = t.children, QA = t.disabled, tA = QA === void 0 ? !1 : QA, oA = t.noFocusGuards, EA = oA === void 0 ? !1 : oA, aA = t.persistentFocus, nA = aA === void 0 ? !1 : aA, lA = t.crossFrame, cA = lA === void 0 ? !0 : lA, sA = t.autoFocus, rA = sA === void 0 ? !0 : sA, uA = t.allowTextSelection, hA = t.group, dA = t.className, GA = t.whiteList, DA = t.hasPositiveIndices, wA = t.shards, bA = wA === void 0 ? emptyArray : wA, yA = t.as, pA = yA === void 0 ? "div" : yA, MA = t.lockProps, LA = MA === void 0 ? {} : MA, xA = t.sideCar, TA = t.returnFocus, NA = TA === void 0 ? !1 : TA, zA = t.focusOptions, XA = t.onActivation, fA = t.onDeactivation, vA = useState({}), Cg = vA[0], Ig = useCallback(function(HA) {
    var jA = HA.captureFocusRestore;
    if (!CA.current) {
      var _A, $A = (_A = document) == null ? void 0 : _A.activeElement;
      CA.current = $A, $A !== document.body && (CA.current = jA($A));
    }
    gA.current && XA && XA(gA.current), IA.current = !0, eA();
  }, [XA]), gg = useCallback(function() {
    IA.current = !1, fA && fA(gA.current), eA();
  }, [fA]), og = useCallback(function(HA) {
    var jA = CA.current;
    if (jA) {
      var _A = (typeof jA == "function" ? jA() : jA) || document.body, $A = typeof NA == "function" ? NA(_A) : NA;
      if ($A) {
        var rg = typeof $A == "object" ? $A : void 0;
        CA.current = null, HA ? Promise.resolve().then(function() {
          return _A.focus(rg);
        }) : _A.focus(rg);
      }
    }
  }, [NA]), eg = useCallback(function(HA) {
    IA.current && mediumFocus.useMedium(HA);
  }, []), kA = mediumBlur.useMedium, YA = useCallback(function(HA) {
    gA.current !== HA && (gA.current = HA, AA(HA));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof uA < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), useEffect(function() {
    !gA.current && typeof pA != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var RA = _extends$M((d = {}, d[FOCUS_DISABLED] = tA && "disabled", d[FOCUS_GROUP] = hA, d), LA), FA = EA !== !0, mA = FA && EA !== "tail", JA = useMergeRefs([g, YA]), VA = useMemo$1(function() {
    return {
      observed: gA,
      shards: bA,
      enabled: !tA,
      active: IA.current
    };
  }, [tA, IA.current, bA, H]);
  return /* @__PURE__ */ React__default.createElement(Fragment, null, FA && [
    /* @__PURE__ */ React__default.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: tA ? -1 : 0,
      style: hiddenGuard
    }),
    DA ? /* @__PURE__ */ React__default.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: tA ? -1 : 1,
      style: hiddenGuard
    }) : null
  ], !tA && /* @__PURE__ */ React__default.createElement(xA, {
    id: Cg,
    sideCar: mediumSidecar,
    observed: H,
    disabled: tA,
    persistentFocus: nA,
    crossFrame: cA,
    autoFocus: rA,
    whiteList: GA,
    shards: bA,
    onActivation: Ig,
    onDeactivation: gg,
    returnFocus: og,
    focusOptions: zA,
    noFocusGuards: EA
  }), /* @__PURE__ */ React__default.createElement(pA, _extends$M({
    ref: JA
  }, RA, {
    className: dA,
    onBlur: kA,
    onFocus: eg
  }), /* @__PURE__ */ React__default.createElement(focusScope.Provider, {
    value: VA
  }, iA)), mA && /* @__PURE__ */ React__default.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: tA ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes = process.env.NODE_ENV !== "production" ? {
  children: propTypesExports.node,
  disabled: propTypesExports.bool,
  returnFocus: propTypesExports.oneOfType([propTypesExports.bool, propTypesExports.object, propTypesExports.func]),
  focusOptions: propTypesExports.object,
  noFocusGuards: propTypesExports.bool,
  hasPositiveIndices: propTypesExports.bool,
  allowTextSelection: propTypesExports.bool,
  autoFocus: propTypesExports.bool,
  persistentFocus: propTypesExports.bool,
  crossFrame: propTypesExports.bool,
  group: propTypesExports.string,
  className: propTypesExports.string,
  whiteList: propTypesExports.func,
  shards: propTypesExports.arrayOf(propTypesExports.any),
  as: propTypesExports.oneOfType([propTypesExports.string, propTypesExports.func, propTypesExports.object]),
  lockProps: propTypesExports.object,
  onActivation: propTypesExports.func,
  onDeactivation: propTypesExports.func,
  sideCar: propTypesExports.any.isRequired
} : {};
function _inheritsLoose(n, t) {
  n.prototype = Object.create(t.prototype), n.prototype.constructor = n, _setPrototypeOf$b(n, t);
}
function withSideEffect(n, t) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof n != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof t != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function g(d) {
    return d.displayName || d.name || "Component";
  }
  return function(k) {
    if (process.env.NODE_ENV !== "production" && typeof k != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var H = [], AA;
    function gA() {
      AA = n(H.map(function(CA) {
        return CA.props;
      })), t(AA);
    }
    var IA = /* @__PURE__ */ (function(CA) {
      _inheritsLoose(BA, CA);
      function BA() {
        return CA.apply(this, arguments) || this;
      }
      BA.peek = function() {
        return AA;
      };
      var eA = BA.prototype;
      return eA.componentDidMount = function() {
        H.push(this), gA();
      }, eA.componentDidUpdate = function() {
        gA();
      }, eA.componentWillUnmount = function() {
        var QA = H.indexOf(this);
        H.splice(QA, 1), gA();
      }, eA.render = function() {
        return /* @__PURE__ */ React__default.createElement(k, this.props);
      }, BA;
    })(PureComponent);
    return _defineProperty$q(IA, "displayName", "SideEffect(" + g(k) + ")"), IA;
  };
}
var toArray$3 = function(n) {
  for (var t = Array(n.length), g = 0; g < n.length; ++g)
    t[g] = n[g];
  return t;
}, asArray = function(n) {
  return Array.isArray(n) ? n : [n];
}, getFirst = function(n) {
  return Array.isArray(n) ? n[0] : n;
}, isElementHidden = function(n) {
  if (n.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var t = window.getComputedStyle(n, null);
  return !t || !t.getPropertyValue ? !1 : t.getPropertyValue("display") === "none" || t.getPropertyValue("visibility") === "hidden";
}, getParentNode = function(n) {
  return n.parentNode && n.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    n.parentNode.host
  ) : n.parentNode;
}, isTopNode = function(n) {
  return n === document || n && n.nodeType === Node.DOCUMENT_NODE;
}, isInert = function(n) {
  return n.hasAttribute("inert");
}, isVisibleUncached = function(n, t) {
  return !n || isTopNode(n) || !isElementHidden(n) && !isInert(n) && t(getParentNode(n));
}, isVisibleCached = function(n, t) {
  var g = n.get(t);
  if (g !== void 0)
    return g;
  var d = isVisibleUncached(t, isVisibleCached.bind(void 0, n));
  return n.set(t, d), d;
}, isAutoFocusAllowedUncached = function(n, t) {
  return n && !isTopNode(n) ? isAutoFocusAllowed(n) ? t(getParentNode(n)) : !1 : !0;
}, isAutoFocusAllowedCached = function(n, t) {
  var g = n.get(t);
  if (g !== void 0)
    return g;
  var d = isAutoFocusAllowedUncached(t, isAutoFocusAllowedCached.bind(void 0, n));
  return n.set(t, d), d;
}, getDataset = function(n) {
  return n.dataset;
}, isHTMLButtonElement = function(n) {
  return n.tagName === "BUTTON";
}, isHTMLInputElement = function(n) {
  return n.tagName === "INPUT";
}, isRadioElement = function(n) {
  return isHTMLInputElement(n) && n.type === "radio";
}, notHiddenInput = function(n) {
  return !((isHTMLInputElement(n) || isHTMLButtonElement(n)) && (n.type === "hidden" || n.disabled));
}, isAutoFocusAllowed = function(n) {
  var t = n.getAttribute(FOCUS_NO_AUTOFOCUS);
  return ![!0, "true", ""].includes(t);
}, isGuard = function(n) {
  var t;
  return !!(n && (!((t = getDataset(n)) === null || t === void 0) && t.focusGuard));
}, isNotAGuard = function(n) {
  return !isGuard(n);
}, isDefined = function(n) {
  return !!n;
}, tabSort = function(n, t) {
  var g = Math.max(0, n.tabIndex), d = Math.max(0, t.tabIndex), k = g - d, H = n.index - t.index;
  if (k) {
    if (!g)
      return 1;
    if (!d)
      return -1;
  }
  return k || H;
}, getTabIndex = function(n) {
  return n.tabIndex < 0 && !n.hasAttribute("tabindex") ? 0 : n.tabIndex;
}, orderByTabIndex = function(n, t, g) {
  return toArray$3(n).map(function(d, k) {
    var H = getTabIndex(d);
    return {
      node: d,
      index: k,
      tabIndex: g && H === -1 ? (d.dataset || {}).focusGuard ? 0 : -1 : H
    };
  }).filter(function(d) {
    return !t || d.tabIndex >= 0;
  }).sort(tabSort);
}, tabbables = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], queryTabbables = tabbables.join(","), queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]"), getFocusablesWithShadowDom = function(n, t) {
  return toArray$3((n.shadowRoot || n).children).reduce(function(g, d) {
    return g.concat(d.matches(t ? queryGuardTabbables : queryTabbables) ? [d] : [], getFocusablesWithShadowDom(d));
  }, []);
}, getFocusablesWithIFrame = function(n, t) {
  var g;
  return n instanceof HTMLIFrameElement && (!((g = n.contentDocument) === null || g === void 0) && g.body) ? getFocusables([n.contentDocument.body], t) : [n];
}, getFocusables = function(n, t) {
  return n.reduce(function(g, d) {
    var k, H = getFocusablesWithShadowDom(d, t), AA = (k = []).concat.apply(k, H.map(function(gA) {
      return getFocusablesWithIFrame(gA, t);
    }));
    return g.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      AA,
      // add if node is tabbable itself
      d.parentNode ? toArray$3(d.parentNode.querySelectorAll(queryTabbables)).filter(function(gA) {
        return gA === d;
      }) : []
    );
  }, []);
}, getParentAutofocusables = function(n) {
  var t = n.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
  return toArray$3(t).map(function(g) {
    return getFocusables([g]);
  }).reduce(function(g, d) {
    return g.concat(d);
  }, []);
}, filterFocusable = function(n, t) {
  return toArray$3(n).filter(function(g) {
    return isVisibleCached(t, g);
  }).filter(function(g) {
    return notHiddenInput(g);
  });
}, filterAutoFocusable = function(n, t) {
  return t === void 0 && (t = /* @__PURE__ */ new Map()), toArray$3(n).filter(function(g) {
    return isAutoFocusAllowedCached(t, g);
  });
}, getTabbableNodes = function(n, t, g) {
  return orderByTabIndex(filterFocusable(getFocusables(n, g), t), !0, g);
}, getFocusableNodes = function(n, t) {
  return orderByTabIndex(filterFocusable(getFocusables(n), t), !1);
}, parentAutofocusables = function(n, t) {
  return filterFocusable(getParentAutofocusables(n), t);
}, contains$2 = function(n, t) {
  return n.shadowRoot ? contains$2(n.shadowRoot, t) : Object.getPrototypeOf(n).contains !== void 0 && Object.getPrototypeOf(n).contains.call(n, t) ? !0 : toArray$3(n.children).some(function(g) {
    var d;
    if (g instanceof HTMLIFrameElement) {
      var k = (d = g.contentDocument) === null || d === void 0 ? void 0 : d.body;
      return k ? contains$2(k, t) : !1;
    }
    return contains$2(g, t);
  });
}, filterNested = function(n) {
  for (var t = /* @__PURE__ */ new Set(), g = n.length, d = 0; d < g; d += 1)
    for (var k = d + 1; k < g; k += 1) {
      var H = n[d].compareDocumentPosition(n[k]);
      (H & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && t.add(k), (H & Node.DOCUMENT_POSITION_CONTAINS) > 0 && t.add(d);
    }
  return n.filter(function(AA, gA) {
    return !t.has(gA);
  });
}, getTopParent = function(n) {
  return n.parentNode ? getTopParent(n.parentNode) : n;
}, getAllAffectedNodes = function(n) {
  var t = asArray(n);
  return t.filter(Boolean).reduce(function(g, d) {
    var k = d.getAttribute(FOCUS_GROUP);
    return g.push.apply(g, k ? filterNested(toArray$3(getTopParent(d).querySelectorAll("[".concat(FOCUS_GROUP, '="').concat(k, '"]:not([').concat(FOCUS_DISABLED, '="disabled"])')))) : [d]), g;
  }, []);
}, safeProbe = function(n) {
  try {
    return n();
  } catch {
    return;
  }
}, getActiveElement = function(n) {
  if (n === void 0 && (n = document), !(!n || !n.activeElement)) {
    var t = n.activeElement;
    return t.shadowRoot ? getActiveElement(t.shadowRoot) : t instanceof HTMLIFrameElement && safeProbe(function() {
      return t.contentWindow.document;
    }) ? getActiveElement(t.contentWindow.document) : t;
  }
}, focusInFrame = function(n, t) {
  return n === t;
}, focusInsideIframe = function(n, t) {
  return !!toArray$3(n.querySelectorAll("iframe")).some(function(g) {
    return focusInFrame(g, t);
  });
}, focusInside = function(n, t) {
  return t === void 0 && (t = getActiveElement(getFirst(n).ownerDocument)), !t || t.dataset && t.dataset.focusGuard ? !1 : getAllAffectedNodes(n).some(function(g) {
    return contains$2(g, t) || focusInsideIframe(g, t);
  });
}, focusIsHidden = function(n) {
  n === void 0 && (n = document);
  var t = getActiveElement(n);
  return t ? toArray$3(n.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function(g) {
    return contains$2(g, t);
  }) : !1;
}, findSelectedRadio = function(n, t) {
  return t.filter(isRadioElement).filter(function(g) {
    return g.name === n.name;
  }).filter(function(g) {
    return g.checked;
  })[0] || n;
}, correctNode = function(n, t) {
  return isRadioElement(n) && n.name ? findSelectedRadio(n, t) : n;
}, correctNodes = function(n) {
  var t = /* @__PURE__ */ new Set();
  return n.forEach(function(g) {
    return t.add(correctNode(g, n));
  }), n.filter(function(g) {
    return t.has(g);
  });
}, pickFirstFocus = function(n) {
  return n[0] && n.length > 1 ? correctNode(n[0], n) : n[0];
}, pickFocusable = function(n, t) {
  return n.indexOf(correctNode(t, n));
}, NEW_FOCUS = "NEW_FOCUS", newFocus = function(n, t, g, d, k) {
  var H = n.length, AA = n[0], gA = n[H - 1], IA = isGuard(d);
  if (!(d && n.indexOf(d) >= 0)) {
    var CA = d !== void 0 ? g.indexOf(d) : -1, BA = k ? g.indexOf(k) : CA, eA = k ? n.indexOf(k) : -1;
    if (CA === -1)
      return eA !== -1 ? eA : NEW_FOCUS;
    if (eA === -1)
      return NEW_FOCUS;
    var iA = CA - BA, QA = g.indexOf(AA), tA = g.indexOf(gA), oA = correctNodes(g), EA = d !== void 0 ? oA.indexOf(d) : -1, aA = k ? oA.indexOf(k) : EA, nA = oA.filter(function(hA) {
      return hA.tabIndex >= 0;
    }), lA = d !== void 0 ? nA.indexOf(d) : -1, cA = k ? nA.indexOf(k) : lA, sA = lA >= 0 && cA >= 0 ? (
      // old/new are tabbables, measure distance in tabbable space
      cA - lA
    ) : (
      // or else measure in focusable space
      aA - EA
    );
    if (!iA && eA >= 0 || t.length === 0)
      return eA;
    var rA = pickFocusable(n, t[0]), uA = pickFocusable(n, t[t.length - 1]);
    if (CA <= QA && IA && Math.abs(iA) > 1)
      return uA;
    if (CA >= tA && IA && Math.abs(iA) > 1)
      return rA;
    if (iA && Math.abs(sA) > 1)
      return eA;
    if (CA <= QA)
      return uA;
    if (CA > tA)
      return rA;
    if (iA)
      return Math.abs(iA) > 1 ? eA : (H + eA + iA) % H;
  }
}, findAutoFocused = function(n) {
  return function(t) {
    var g, d = (g = getDataset(t)) === null || g === void 0 ? void 0 : g.autofocus;
    return (
      // @ts-expect-error
      t.autofocus || //
      d !== void 0 && d !== "false" || //
      n.indexOf(t) >= 0
    );
  };
}, pickAutofocus = function(n, t, g) {
  var d = n.map(function(H) {
    var AA = H.node;
    return AA;
  }), k = filterAutoFocusable(d.filter(findAutoFocused(g)));
  return k && k.length ? pickFirstFocus(k) : pickFirstFocus(filterAutoFocusable(t));
}, getParents = function(n, t) {
  return t === void 0 && (t = []), t.push(n), n.parentNode && getParents(n.parentNode.host || n.parentNode, t), t;
}, getCommonParent = function(n, t) {
  for (var g = getParents(n), d = getParents(t), k = 0; k < g.length; k += 1) {
    var H = g[k];
    if (d.indexOf(H) >= 0)
      return H;
  }
  return !1;
}, getTopCommonParent = function(n, t, g) {
  var d = asArray(n), k = asArray(t), H = d[0], AA = !1;
  return k.filter(Boolean).forEach(function(gA) {
    AA = getCommonParent(AA || gA, gA) || AA, g.filter(Boolean).forEach(function(IA) {
      var CA = getCommonParent(H, IA);
      CA && (!AA || contains$2(CA, AA) ? AA = CA : AA = getCommonParent(CA, AA));
    });
  }), AA;
}, allParentAutofocusables = function(n, t) {
  return n.reduce(function(g, d) {
    return g.concat(parentAutofocusables(d, t));
  }, []);
}, reorderNodes = function(n, t) {
  var g = /* @__PURE__ */ new Map();
  return t.forEach(function(d) {
    return g.set(d.node, d);
  }), n.map(function(d) {
    return g.get(d);
  }).filter(isDefined);
}, focusSolver = function(n, t) {
  var g = getActiveElement(asArray(n).length > 0 ? document : getFirst(n).ownerDocument), d = getAllAffectedNodes(n).filter(isNotAGuard), k = getTopCommonParent(g || n, n, d), H = /* @__PURE__ */ new Map(), AA = getFocusableNodes(d, H), gA = AA.filter(function(tA) {
    var oA = tA.node;
    return isNotAGuard(oA);
  });
  if (gA[0]) {
    var IA = getFocusableNodes([k], H).map(function(tA) {
      var oA = tA.node;
      return oA;
    }), CA = reorderNodes(IA, gA), BA = CA.map(function(tA) {
      var oA = tA.node;
      return oA;
    }), eA = CA.filter(function(tA) {
      var oA = tA.tabIndex;
      return oA >= 0;
    }).map(function(tA) {
      var oA = tA.node;
      return oA;
    }), iA = newFocus(BA, eA, IA, g, t);
    if (iA === NEW_FOCUS) {
      var QA = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        pickAutofocus(AA, eA, allParentAutofocusables(d, H)) || pickAutofocus(AA, BA, allParentAutofocusables(d, H))
      );
      if (QA)
        return { node: QA };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return iA === void 0 ? iA : CA[iA];
  }
}, expandFocusableNodes = function(n) {
  var t = getAllAffectedNodes(n).filter(isNotAGuard), g = getTopCommonParent(n, n, t), d = orderByTabIndex(getFocusables([g], !0), !0, !0), k = getFocusables(t, !1);
  return d.map(function(H) {
    var AA = H.node, gA = H.index;
    return {
      node: AA,
      index: gA,
      lockItem: k.indexOf(AA) >= 0,
      guard: isGuard(AA)
    };
  });
}, focusOn = function(n, t) {
  n && ("focus" in n && n.focus(t), "contentWindow" in n && n.contentWindow && n.contentWindow.focus());
}, guardCount = 0, lockDisabled = !1, moveFocusInside = function(n, t, g) {
  g === void 0 && (g = {});
  var d = focusSolver(n, t);
  if (!lockDisabled && d) {
    if (guardCount > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), lockDisabled = !0, setTimeout(function() {
        lockDisabled = !1;
      }, 1);
      return;
    }
    guardCount++, focusOn(d.node, g.focusOptions), guardCount--;
  }
};
function weakRef(n) {
  if (!n)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return n || null;
    };
  var t = n ? new WeakRef(n) : null;
  return function() {
    return t?.deref() || null;
  };
}
var recordElementLocation = function(n) {
  if (!n)
    return null;
  for (var t = [], g = n; g && g !== document.body; )
    t.push({
      current: weakRef(g),
      parent: weakRef(g.parentElement),
      left: weakRef(g.previousElementSibling),
      right: weakRef(g.nextElementSibling)
    }), g = g.parentElement;
  return {
    element: weakRef(n),
    stack: t,
    ownerDocument: n.ownerDocument
  };
}, restoreFocusTo = function(n) {
  var t, g, d, k, H;
  if (n)
    for (var AA = n.stack, gA = n.ownerDocument, IA = /* @__PURE__ */ new Map(), CA = 0, BA = AA; CA < BA.length; CA++) {
      var eA = BA[CA], iA = (t = eA.parent) === null || t === void 0 ? void 0 : t.call(eA);
      if (iA && gA.contains(iA)) {
        for (var QA = (g = eA.left) === null || g === void 0 ? void 0 : g.call(eA), tA = eA.current(), oA = iA.contains(tA) ? tA : void 0, EA = (d = eA.right) === null || d === void 0 ? void 0 : d.call(eA), aA = getTabbableNodes([iA], IA), nA = (
          // that is element itself
          (H = (k = oA ?? QA?.nextElementSibling) !== null && k !== void 0 ? k : (
            // or somebody to the right, still close enough
            EA
          )) !== null && H !== void 0 ? H : (
            // or somebody to the left, something?
            QA
          )
        ); nA; ) {
          for (var lA = 0, cA = aA; lA < cA.length; lA++) {
            var sA = cA[lA];
            if (nA?.contains(sA.node))
              return sA.node;
          }
          nA = nA.nextElementSibling;
        }
        if (aA.length)
          return aA[0].node;
      }
    }
}, captureFocusRestore = function(n) {
  var t = recordElementLocation(n);
  return function() {
    return restoreFocusTo(t);
  };
}, getRelativeFocusable = function(n, t, g) {
  if (!n || !t)
    return console.error("no element or scope given"), {};
  var d = asArray(t);
  if (d.every(function(AA) {
    return !contains$2(AA, n);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var k = g ? getTabbableNodes(d, /* @__PURE__ */ new Map()) : getFocusableNodes(d, /* @__PURE__ */ new Map()), H = k.findIndex(function(AA) {
    var gA = AA.node;
    return gA === n;
  });
  if (H !== -1)
    return {
      prev: k[H - 1],
      next: k[H + 1],
      first: k[0],
      last: k[k.length - 1]
    };
}, getBoundary = function(n, t) {
  var g = t ? getTabbableNodes(asArray(n), /* @__PURE__ */ new Map()) : getFocusableNodes(asArray(n), /* @__PURE__ */ new Map());
  return {
    first: g[0],
    last: g[g.length - 1]
  };
}, defaultOptions$2 = function(n) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, n);
}, moveFocus = function(n, t, g) {
  t === void 0 && (t = {});
  var d = defaultOptions$2(t), k = getRelativeFocusable(n, d.scope, d.onlyTabbable);
  if (k) {
    var H = g(k, d.cycle);
    H && focusOn(H.node, d.focusOptions);
  }
}, focusNextElement = function(n, t) {
  t === void 0 && (t = {}), moveFocus(n, t, function(g, d) {
    var k = g.next, H = g.first;
    return k || d && H;
  });
}, focusPrevElement = function(n, t) {
  t === void 0 && (t = {}), moveFocus(n, t, function(g, d) {
    var k = g.prev, H = g.last;
    return k || d && H;
  });
}, pickBoundary = function(n, t, g) {
  var d, k = getBoundary(n, (d = t.onlyTabbable) !== null && d !== void 0 ? d : !0), H = k[g];
  H && focusOn(H.node, t.focusOptions);
}, focusFirstElement = function(n, t) {
  t === void 0 && (t = {}), pickBoundary(n, t, "first");
}, focusLastElement = function(n, t) {
  t === void 0 && (t = {}), pickBoundary(n, t, "last");
};
function deferAction(n) {
  setTimeout(n, 1);
}
var inlineProp = function n(t, g) {
  var d = {};
  return d[t] = g, d;
}, extractRef = function n(t) {
  return t && "current" in t ? t.current : t;
}, focusOnBody = function n() {
  return document && document.activeElement === document.body;
}, isFreeFocus = function n() {
  return focusOnBody() || focusIsHidden();
}, lastActiveTrap = null, lastActiveFocus = null, tryRestoreFocus = function n() {
  return null;
}, lastPortaledElement = null, focusWasOutsideWindow = !1, windowFocused = !1, defaultWhitelist = function n() {
  return !0;
}, focusWhitelisted = function n(t) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(t);
}, recordPortal = function n(t, g) {
  lastPortaledElement = {
    observerNode: t,
    portaledElement: g
  };
}, focusIsPortaledPair = function n(t) {
  return lastPortaledElement && lastPortaledElement.portaledElement === t;
};
function autoGuard(n, t, g, d) {
  var k = null, H = n;
  do {
    var AA = d[H];
    if (AA.guard)
      AA.node.dataset.focusAutoGuard && (k = AA);
    else if (AA.lockItem) {
      if (H !== n)
        return;
      k = null;
    } else
      break;
  } while ((H += g) !== t);
  k && (k.node.tabIndex = 0);
}
var focusWasOutside = function n(t) {
  return t ? !!focusWasOutsideWindow : focusWasOutsideWindow === "meanwhile";
}, checkInHost = function n(t, g, d) {
  return g && (g.host === t && (!g.activeElement || d.contains(g.activeElement)) || g.parentNode && n(t, g.parentNode, d));
}, withinHost = function n(t, g) {
  return g.some(function(d) {
    return checkInHost(t, d, d);
  });
}, getNodeFocusables = function n(t) {
  return getFocusableNodes(t, /* @__PURE__ */ new Map());
}, isNotFocusable = function n(t) {
  return !getNodeFocusables([t.parentNode]).some(function(g) {
    return g.node === t;
  });
}, activateTrap = function n() {
  var t = !1;
  if (lastActiveTrap) {
    var g = lastActiveTrap, d = g.observed, k = g.persistentFocus, H = g.autoFocus, AA = g.shards, gA = g.crossFrame, IA = g.focusOptions, CA = g.noFocusGuards, BA = d || lastPortaledElement && lastPortaledElement.portaledElement;
    if (focusOnBody() && lastActiveFocus && lastActiveFocus !== document.body && (!document.body.contains(lastActiveFocus) || isNotFocusable(lastActiveFocus))) {
      var eA = tryRestoreFocus();
      eA && eA.focus();
    }
    var iA = document && document.activeElement;
    if (BA) {
      var QA = [BA].concat(AA.map(extractRef).filter(Boolean)), tA = function() {
        if (!focusWasOutside(gA) || !CA || !lastActiveFocus || windowFocused)
          return !1;
        var lA = getNodeFocusables(QA), cA = lA.findIndex(function(sA) {
          var rA = sA.node;
          return rA === lastActiveFocus;
        });
        return cA === 0 || cA === lA.length - 1;
      };
      if ((!iA || focusWhitelisted(iA)) && (k || tA() || !isFreeFocus() || !lastActiveFocus && H) && (BA && !(focusInside(QA) || iA && withinHost(iA, QA) || focusIsPortaledPair(iA)) && (document && !lastActiveFocus && iA && !H ? (iA.blur && iA.blur(), document.body.focus()) : (t = moveFocusInside(QA, lastActiveFocus, {
        focusOptions: IA
      }), lastPortaledElement = {})), lastActiveFocus = document && document.activeElement, lastActiveFocus !== document.body && (tryRestoreFocus = captureFocusRestore(lastActiveFocus)), focusWasOutsideWindow = !1), document && iA !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var oA = document && document.activeElement, EA = expandFocusableNodes(QA), aA = EA.map(function(nA) {
          var lA = nA.node;
          return lA;
        }).indexOf(oA);
        aA > -1 && (EA.filter(function(nA) {
          var lA = nA.guard, cA = nA.node;
          return lA && cA.dataset.focusAutoGuard;
        }).forEach(function(nA) {
          var lA = nA.node;
          return lA.removeAttribute("tabIndex");
        }), autoGuard(aA, EA.length, 1, EA), autoGuard(aA, -1, -1, EA));
      }
    }
  }
  return t;
}, onTrap = function n(t) {
  activateTrap() && t && (t.stopPropagation(), t.preventDefault());
}, onBlur = function n() {
  return deferAction(activateTrap);
}, onFocus = function n(t) {
  var g = t.target, d = t.currentTarget;
  d.contains(g) || recordPortal(d, g);
}, FocusWatcher = function n() {
  return null;
};
process.env.NODE_ENV !== "production" && PropTypes.node.isRequired;
var onWindowFocus = function n() {
  windowFocused = !0;
}, onWindowBlur = function n() {
  windowFocused = !1, focusWasOutsideWindow = "just", deferAction(function() {
    focusWasOutsideWindow = "meanwhile";
  });
}, attachHandler = function n() {
  document.addEventListener("focusin", onTrap), document.addEventListener("focusout", onBlur), window.addEventListener("focus", onWindowFocus), window.addEventListener("blur", onWindowBlur);
}, detachHandler = function n() {
  document.removeEventListener("focusin", onTrap), document.removeEventListener("focusout", onBlur), window.removeEventListener("focus", onWindowFocus), window.removeEventListener("blur", onWindowBlur);
};
function reducePropsToState(n) {
  return n.filter(function(t) {
    var g = t.disabled;
    return !g;
  });
}
var focusLockAPI = {
  moveFocusInside,
  focusInside,
  focusNextElement,
  focusPrevElement,
  focusFirstElement,
  focusLastElement,
  captureFocusRestore
};
function handleStateChangeOnClient(n) {
  var t = n.slice(-1)[0];
  t && !lastActiveTrap && attachHandler();
  var g = lastActiveTrap, d = g && t && t.id === g.id;
  lastActiveTrap = t, g && !d && (g.onDeactivation(), n.filter(function(k) {
    var H = k.id;
    return H === g.id;
  }).length || g.returnFocus(!t)), t ? (lastActiveFocus = null, (!d || g.observed !== t.observed) && t.onActivation(focusLockAPI), activateTrap(), deferAction(activateTrap)) : (detachHandler(), lastActiveFocus = null);
}
mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function(n) {
  return n(focusLockAPI);
});
const FocusTrap = withSideEffect(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);
var FocusLockCombination = /* @__PURE__ */ forwardRef(function n(t, g) {
  return /* @__PURE__ */ React__default.createElement(FocusLock, _extends$M({
    sideCar: FocusTrap,
    ref: g
  }, t));
}), _ref = FocusLock.propTypes || {};
_ref.sideCar;
var propTypes = _objectWithoutPropertiesLoose$j(_ref, ["sideCar"]);
FocusLockCombination.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
var useFocusInside = function n(t) {
  useEffect(function() {
    var g = !0;
    return mediumEffect.useMedium(function(d) {
      var k = t && t.current;
      g && k && (d.focusInside(k) || d.moveFocusInside(k, null));
    }), function() {
      g = !1;
    };
  }, [t]);
};
function MoveFocusInside(n) {
  var t = n.disabled, g = t === void 0 ? !1 : t, d = n.className, k = n.children, H = useRef(null);
  return useFocusInside(g ? void 0 : H), /* @__PURE__ */ React__default.createElement("div", _extends$M({}, inlineProp(FOCUS_AUTO, !g), {
    ref: H,
    className: d
  }), k);
}
MoveFocusInside.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
} : {};
function ownKeys$l(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$j(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$l(Object(g), !0).forEach(function(d) {
      _defineProperty$o(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$l(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$o(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function _slicedToArray$h(n, t) {
  return _arrayWithHoles$g(n) || _iterableToArrayLimit$g(n, t) || _unsupportedIterableToArray$g(n, t) || _nonIterableRest$g();
}
function _nonIterableRest$g() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$g(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$g(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$g(n, t);
  }
}
function _arrayLikeToArray$g(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$g(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$g(n) {
  if (Array.isArray(n)) return n;
}
var OPPOSITE_POSITIONS = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right"
};
function getOppositePosition(n) {
  return OPPOSITE_POSITIONS[n];
}
function isVerticalPosition(n) {
  return n === "top" || n === "bottom";
}
function capitalize$1(n) {
  return n.charAt(0).toUpperCase() + n.slice(1);
}
function fromPopperPlacement(n) {
  var t = n.replace(/(top|bottom)-start$/, "$1Left").replace(/(top|bottom)-end$/, "$1Right").replace(/(left|right)-start$/, "$1Top").replace(/(left|right)-end$/, "$1Bottom");
  return PLACEMENT[t] || null;
}
function splitPlacement(n) {
  var t = n.match(/^([a-z]+)([A-Z][a-z]+)?/) || [];
  return t.slice(1, 3).filter(Boolean).map(function(g) {
    return g.toLowerCase();
  });
}
function getPopoverMarginStyles(n, t, g) {
  var d = splitPlacement(t), k = _slicedToArray$h(d, 1), H = k[0], AA = getOppositePosition(H);
  if (!AA)
    return null;
  var gA = "margin".concat(capitalize$1(AA));
  return _defineProperty$o({}, gA, "".concat(n + g, "px"));
}
function getStartPosition(n, t, g, d) {
  n = _objectSpread$j({}, n);
  var k = splitPlacement(t), H = _slicedToArray$h(k, 1), AA = H[0], gA = (g > 0 ? g : d) * 2;
  return isVerticalPosition(AA) ? n.top += AA === "top" ? gA : -gA : n.left += AA === "left" ? gA : -gA, "translate3d(".concat(n.left, "px, ").concat(n.top, "px, 0)");
}
function getEndPosition(n) {
  return "translate3d(".concat(n.left, "px, ").concat(n.top, "px, 0)");
}
function getArrowPositionStyles(n, t) {
  var g, d = splitPlacement(t), k = _slicedToArray$h(d, 1), H = k[0], AA = getOppositePosition(H);
  if (!AA)
    return null;
  var gA = isVerticalPosition(H) ? "left" : "top";
  return g = {}, _defineProperty$o(g, gA, "".concat(n[gA], "px")), _defineProperty$o(g, AA, "-".concat(ARROW_SIZE - 2, "px")), g;
}
function ownKeys$k(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$i(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$k(Object(g), !0).forEach(function(d) {
      _defineProperty$n(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$k(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$n(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function getBodyStyles(n) {
  var t = n.$animationDuration, g = n.$isOpen, d = n.$isAnimating, k = n.$placement, H = n.$popoverOffset, AA = n.$showArrow, gA = n.$theme, IA = n.$popoverMargin, CA = n.$isHoverTrigger;
  return _objectSpread$i(_objectSpread$i({
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: gA.colors.backgroundTertiary,
    borderTopLeftRadius: gA.borders.popoverBorderRadius,
    borderTopRightRadius: gA.borders.popoverBorderRadius,
    borderBottomRightRadius: gA.borders.popoverBorderRadius,
    borderBottomLeftRadius: gA.borders.popoverBorderRadius,
    boxShadow: gA.lighting.shadow600,
    transitionProperty: "opacity,transform",
    transitionDuration: d ? g ? "0.1s" : "".concat(t, "ms") : "0s",
    transitionTimingFunction: g ? gA.animation.easeOutCurve : gA.animation.easeInCurve,
    opacity: d && g ? 1 : 0,
    transform: d && g ? getEndPosition(H) : getStartPosition(H, k, AA ? ARROW_SIZE : 0, IA)
  }, getPopoverMarginStyles(AA ? ARROW_SIZE : 0, k, IA)), CA ? {
    animationDuration: ".1s",
    animationName: {
      "0%": {
        pointerEvents: "none"
      },
      "99%": {
        pointerEvents: "none"
      },
      "100%": {
        pointerEvents: "auto"
      }
    }
  } : {});
}
var Body$2 = styled("div", getBodyStyles);
Body$2.displayName = "Body";
Body$2.displayName = "Body";
function getArrowStyles(n) {
  var t = n.$arrowOffset, g = n.$placement, d = n.$theme;
  return _objectSpread$i({
    backgroundColor: d.colors.backgroundTertiary,
    boxShadow: d.lighting.shadow600,
    width: "".concat(ARROW_WIDTH, "px"),
    height: "".concat(ARROW_WIDTH, "px"),
    transform: "rotate(45deg)",
    position: "absolute"
  }, getArrowPositionStyles(t, g));
}
var Arrow$1 = styled("div", getArrowStyles);
Arrow$1.displayName = "Arrow";
Arrow$1.displayName = "Arrow";
function getInnerStyles(n) {
  var t = n.$theme;
  return {
    backgroundColor: t.colors.backgroundTertiary,
    borderTopLeftRadius: t.borders.popoverBorderRadius,
    borderTopRightRadius: t.borders.popoverBorderRadius,
    borderBottomRightRadius: t.borders.popoverBorderRadius,
    borderBottomLeftRadius: t.borders.popoverBorderRadius,
    color: t.colors.contentPrimary,
    position: "relative"
  };
}
var Inner$1 = styled("div", getInnerStyles);
Inner$1.displayName = "Inner";
Inner$1.displayName = "Inner";
var Padding$2 = styled("div", {
  paddingLeft: "12px",
  paddingTop: "12px",
  paddingRight: "12px",
  paddingBottom: "12px"
});
Padding$2.displayName = "Padding";
Padding$2.displayName = "Padding";
var Hidden = styled("div", {
  display: "none"
});
Hidden.displayName = "Hidden";
Hidden.displayName = "Hidden";
var baseDefaultProps$1 = {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  focusLock: !1,
  autoFocus: !0,
  returnFocus: !0,
  // Remove the `ignoreBoundary` prop in the next major version
  // and have it replaced with the TetherBehavior props overrides
  ignoreBoundary: !1,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT.auto,
  showArrow: !1,
  triggerType: TRIGGER_TYPE.click,
  renderAll: !1
};
function ownKeys$j(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$h(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$j(Object(g), !0).forEach(function(d) {
      _defineProperty$m(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$j(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _extends$v() {
  return _extends$v = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$v.apply(this, arguments);
}
function _typeof$c(n) {
  "@babel/helpers - typeof";
  return _typeof$c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$c(n);
}
function _classCallCheck$h(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$9(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$h(n, t, g) {
  return t && _defineProperties$9(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$h(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$9(n, t);
}
function _setPrototypeOf$9(n, t) {
  return _setPrototypeOf$9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$9(n, t);
}
function _createSuper$9(n) {
  var t = _isNativeReflectConstruct$9();
  return function() {
    var d = _getPrototypeOf$9(n), k;
    if (t) {
      var H = _getPrototypeOf$9(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$h(this, k);
  };
}
function _possibleConstructorReturn$h(n, t) {
  if (t && (_typeof$c(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$9(n);
}
function _assertThisInitialized$9(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$9() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$9(n) {
  return _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$9(n);
}
function _defineProperty$m(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var PopoverInner = /* @__PURE__ */ (function(n) {
  _inherits$h(g, n);
  var t = _createSuper$9(g);
  function g() {
    var d;
    _classCallCheck$h(this, g);
    for (var k = arguments.length, H = new Array(k), AA = 0; AA < k; AA++)
      H[AA] = arguments[AA];
    return d = t.call.apply(t, [this].concat(H)), _defineProperty$m(_assertThisInitialized$9(d), "animateInTimer", void 0), _defineProperty$m(_assertThisInitialized$9(d), "animateOutTimer", void 0), _defineProperty$m(_assertThisInitialized$9(d), "animateOutCompleteTimer", void 0), _defineProperty$m(_assertThisInitialized$9(d), "onMouseEnterTimer", void 0), _defineProperty$m(_assertThisInitialized$9(d), "onMouseLeaveTimer", void 0), _defineProperty$m(_assertThisInitialized$9(d), "anchorRef", /* @__PURE__ */ React.createRef()), _defineProperty$m(_assertThisInitialized$9(d), "popperRef", /* @__PURE__ */ React.createRef()), _defineProperty$m(_assertThisInitialized$9(d), "arrowRef", /* @__PURE__ */ React.createRef()), _defineProperty$m(_assertThisInitialized$9(d), "state", d.getDefaultState(d.props)), _defineProperty$m(_assertThisInitialized$9(d), "animateIn", function() {
      d.props.isOpen && d.setState({
        isAnimating: !0
      });
    }), _defineProperty$m(_assertThisInitialized$9(d), "animateOut", function() {
      d.props.isOpen || (d.setState({
        isAnimating: !0
      }), d.animateOutCompleteTimer = setTimeout(function() {
        d.setState({
          isAnimating: !1,
          // Reset to ideal placement specified in props
          placement: d.props.placement
        });
      }, d.props.animateOutTime || ANIMATE_OUT_TIME));
    }), _defineProperty$m(_assertThisInitialized$9(d), "onAnchorClick", function(gA) {
      d.props.onClick && d.props.onClick(gA);
    }), _defineProperty$m(_assertThisInitialized$9(d), "onAnchorMouseEnter", function(gA) {
      d.onMouseLeaveTimer && clearTimeout(d.onMouseLeaveTimer), d.triggerOnMouseEnterWithDelay(gA);
    }), _defineProperty$m(_assertThisInitialized$9(d), "onAnchorMouseLeave", function(gA) {
      d.onMouseEnterTimer && clearTimeout(d.onMouseEnterTimer), d.triggerOnMouseLeaveWithDelay(gA);
    }), _defineProperty$m(_assertThisInitialized$9(d), "onPopoverMouseEnter", function() {
      d.onMouseLeaveTimer && clearTimeout(d.onMouseLeaveTimer);
    }), _defineProperty$m(_assertThisInitialized$9(d), "onPopoverMouseLeave", function(gA) {
      d.triggerOnMouseLeaveWithDelay(gA);
    }), _defineProperty$m(_assertThisInitialized$9(d), "onPopperUpdate", function(gA, IA) {
      var CA = fromPopperPlacement(IA.placement) || PLACEMENT.top;
      return d.setState({
        arrowOffset: gA.arrow,
        popoverOffset: gA.popper,
        placement: CA
      }), d.animateInTimer = setTimeout(d.animateIn, ANIMATE_IN_TIME), IA;
    }), _defineProperty$m(_assertThisInitialized$9(d), "triggerOnMouseLeave", function(gA) {
      d.props.onMouseLeave && d.props.onMouseLeave(gA);
    }), _defineProperty$m(_assertThisInitialized$9(d), "triggerOnMouseEnter", function(gA) {
      d.props.onMouseEnter && d.props.onMouseEnter(gA);
    }), _defineProperty$m(_assertThisInitialized$9(d), "onDocumentClick", function(gA) {
      var IA = gA.composedPath ? gA.composedPath()[0] : gA.target, CA = d.popperRef.current, BA = d.anchorRef.current;
      !CA || CA === IA || IA instanceof Node && CA.contains(IA) || !BA || BA === IA || IA instanceof Node && BA.contains(IA) || d.props.onClickOutside && d.props.onClickOutside(gA);
    }), d;
  }
  return _createClass$h(g, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(k, H) {
      this.init(k, H), this.props.accessibilityType !== ACCESSIBILITY_TYPE.tooltip && this.props.autoFocus && !this.state.autoFocusAfterPositioning && this.popperRef.current !== null && this.popperRef.current.getBoundingClientRect().top > 0 && this.setState({
        autoFocusAfterPositioning: !0
      }), process.env.NODE_ENV !== "production" && (this.anchorRef.current || console.warn(`[baseui][Popover] ref has not been passed to the Popper's anchor element.
              See how to pass the ref to an anchor element in the Popover example
              https://baseweb.design/components/popover/#anchor-ref-handling-example`));
    }
  }, {
    key: "init",
    value: function(k, H) {
      if (this.props.isOpen !== k.isOpen || this.state.isMounted !== H.isMounted || this.state.isLayerMounted !== H.isLayerMounted) {
        if (this.props.isOpen && this.state.isLayerMounted) {
          this.clearTimers();
          return;
        }
        if (!this.props.isOpen && k.isOpen) {
          this.animateOutTimer = setTimeout(this.animateOut, 20);
          return;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearTimers();
    }
  }, {
    key: "getDefaultState",
    value: function(k) {
      return {
        isAnimating: !1,
        arrowOffset: {
          left: 0,
          top: 0
        },
        popoverOffset: {
          left: 0,
          top: 0
        },
        placement: k.placement,
        isMounted: !1,
        isLayerMounted: !1,
        autoFocusAfterPositioning: !1
      };
    }
  }, {
    key: "clearTimers",
    value: function() {
      [this.animateInTimer, this.animateOutTimer, this.animateOutCompleteTimer, this.onMouseEnterTimer, this.onMouseLeaveTimer].forEach(function(k) {
        k && clearTimeout(k);
      });
    }
  }, {
    key: "triggerOnMouseLeaveWithDelay",
    value: function(k) {
      var H = this, AA = this.props.onMouseLeaveDelay;
      if (AA) {
        this.onMouseLeaveTimer = setTimeout(function() {
          return H.triggerOnMouseLeave(k);
        }, AA);
        return;
      }
      this.triggerOnMouseLeave(k);
    }
  }, {
    key: "triggerOnMouseEnterWithDelay",
    value: function(k) {
      var H = this, AA = this.props.onMouseEnterDelay;
      if (AA) {
        this.onMouseEnterTimer = setTimeout(function() {
          return H.triggerOnMouseEnter(k);
        }, AA);
        return;
      }
      this.triggerOnMouseEnter(k);
    }
  }, {
    key: "isClickTrigger",
    value: function() {
      return this.props.triggerType === TRIGGER_TYPE.click;
    }
  }, {
    key: "isHoverTrigger",
    value: function() {
      return this.props.triggerType === TRIGGER_TYPE.hover;
    }
  }, {
    key: "isAccessibilityTypeMenu",
    value: function() {
      return this.props.accessibilityType === ACCESSIBILITY_TYPE.menu;
    }
  }, {
    key: "isAccessibilityTypeTooltip",
    value: function() {
      return this.props.accessibilityType === ACCESSIBILITY_TYPE.tooltip;
    }
  }, {
    key: "getAnchorIdAttr",
    value: function() {
      var k = this.getPopoverIdAttr();
      return k ? "".concat(k, "__anchor") : null;
    }
  }, {
    key: "getPopoverIdAttr",
    value: function() {
      return this.props.id || null;
    }
  }, {
    key: "getAnchorProps",
    value: function() {
      var k = this.props.isOpen, H = {
        ref: this.anchorRef
      }, AA = this.getPopoverIdAttr();
      if (this.isAccessibilityTypeMenu()) {
        var gA = this.isClickTrigger() ? "aria-controls" : "aria-owns";
        H[gA] = k ? AA : null, H["aria-haspopup"] = !0, H["aria-expanded"] = !!k;
      } else this.isAccessibilityTypeTooltip() && (H.id = this.getAnchorIdAttr(), H["aria-describedby"] = k ? AA : null);
      return this.isHoverTrigger() ? (H.onMouseEnter = this.onAnchorMouseEnter, H.onMouseLeave = this.onAnchorMouseLeave, H.onBlur = this.props.onBlur, H.onFocus = this.props.onFocus) : H.onClick = this.onAnchorClick, H;
    }
  }, {
    key: "getPopoverBodyProps",
    value: function() {
      var k = {}, H = this.getPopoverIdAttr();
      return this.isAccessibilityTypeMenu() ? k.id = H : this.isAccessibilityTypeTooltip() && (k.id = H, k.role = "tooltip"), this.isHoverTrigger() && (k.onMouseEnter = this.onPopoverMouseEnter, k.onMouseLeave = this.onPopoverMouseLeave), k;
    }
  }, {
    key: "getSharedProps",
    value: function() {
      var k = this.props, H = k.isOpen, AA = k.showArrow, gA = k.popoverMargin, IA = gA === void 0 ? POPOVER_MARGIN : gA, CA = this.state, BA = CA.isAnimating, eA = CA.arrowOffset, iA = CA.popoverOffset, QA = CA.placement;
      return {
        $showArrow: !!AA,
        $arrowOffset: eA,
        $popoverOffset: iA,
        $placement: QA,
        $isAnimating: BA,
        $animationDuration: this.props.animateOutTime || ANIMATE_OUT_TIME,
        $isOpen: H,
        $popoverMargin: IA,
        $isHoverTrigger: this.isHoverTrigger()
      };
    }
  }, {
    key: "getAnchorFromChildren",
    value: function() {
      var k = this.props.children, H = React.Children.toArray(k);
      return H.length !== 1 && console.error("[baseui] Exactly 1 child must be passed to Popover/Tooltip, found ".concat(H.length, " children")), H[0];
    }
  }, {
    key: "renderAnchor",
    value: function() {
      var k = this.getAnchorFromChildren();
      if (!k)
        return null;
      var H = /* @__PURE__ */ React.isValidElement(k), AA = this.getAnchorProps();
      return _typeof$c(k) === "object" && H ? /* @__PURE__ */ React.cloneElement(k, AA) : /* @__PURE__ */ React.createElement("span", _extends$v({
        key: "popover-anchor"
      }, AA), k);
    }
  }, {
    key: "renderPopover",
    value: function(k) {
      var H = this.props, AA = H.showArrow, gA = H.overrides, IA = gA === void 0 ? {} : gA, CA = IA.Arrow, BA = IA.Body, eA = IA.Inner, iA = getOverride(CA) || Arrow$1, QA = getOverride(BA) || Body$2, tA = getOverride(eA) || Inner$1, oA = this.getSharedProps(), EA = this.getPopoverBodyProps();
      return /* @__PURE__ */ React.createElement(QA, _extends$v({
        key: "popover-body",
        ref: this.popperRef,
        "data-baseweb": this.props["data-baseweb"] || "popover"
      }, EA, oA, getOverrideProps(BA)), AA ? /* @__PURE__ */ React.createElement(iA, _extends$v({
        key: "popover-arrow",
        ref: this.arrowRef
      }, oA, getOverrideProps(CA))) : null, /* @__PURE__ */ React.createElement(tA, _extends$v({}, oA, getOverrideProps(eA)), k));
    }
  }, {
    key: "renderContent",
    value: function() {
      var k = this.props.content;
      return typeof k == "function" ? k() : k;
    }
  }, {
    key: "render",
    value: function() {
      var k = this, H = this.state.isMounted && (this.props.isOpen || this.state.isAnimating), AA = [this.renderAnchor()], gA = H || this.props.renderAll ? this.renderContent() : null, IA = {
        modifiers: {
          preventOverflow: {
            enabled: !this.props.ignoreBoundary,
            padding: 0
          }
        }
      };
      return gA && (H ? AA.push(/* @__PURE__ */ React.createElement(Layer, {
        key: "new-layer",
        mountNode: this.props.mountNode,
        onEscape: this.props.onEsc,
        onDocumentClick: this.isHoverTrigger() ? void 0 : this.onDocumentClick,
        isHoverLayer: this.isHoverTrigger(),
        onMount: function() {
          return k.setState({
            isLayerMounted: !0
          });
        },
        onUnmount: function() {
          return k.setState({
            isLayerMounted: !1
          });
        }
      }, /* @__PURE__ */ React.createElement(Tether, {
        anchorRef: this.anchorRef.current,
        arrowRef: this.arrowRef.current,
        popperRef: this.popperRef.current,
        popperOptions: _objectSpread$h(_objectSpread$h({}, IA), this.props.popperOptions),
        onPopperUpdate: this.onPopperUpdate,
        placement: this.state.placement
      }, this.props.focusLock && this.props.accessibilityType !== ACCESSIBILITY_TYPE.tooltip ? /* @__PURE__ */ React.createElement(FocusLockCombination, {
        disabled: !this.props.focusLock,
        noFocusGuards: !1,
        returnFocus: !this.isHoverTrigger() && this.props.returnFocus,
        autoFocus: this.state.autoFocusAfterPositioning,
        crossFrame: !1,
        focusOptions: this.props.focusOptions
      }, this.renderPopover(gA)) : /* @__PURE__ */ React.createElement(MoveFocusInside, {
        disabled: !this.props.autoFocus || !this.state.autoFocusAfterPositioning
      }, this.renderPopover(gA))))) : AA.push(/* @__PURE__ */ React.createElement(Hidden, {
        key: "hidden-layer"
      }, gA))), AA;
    }
  }]), g;
})(React.Component);
_defineProperty$m(PopoverInner, "defaultProps", baseDefaultProps$1);
var Popover$2 = function n(t) {
  var g = t.innerRef, d = useUID();
  return /* @__PURE__ */ React.createElement(PopoverInner, _extends$v({
    id: t.id || d,
    ref: g
  }, t));
};
Popover$2.defaultProps = baseDefaultProps$1;
var _excluded$l = ["children"];
function _objectWithoutProperties$i(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$i(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$i(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function StatefulPopover(n) {
  var t = n.children, g = _objectWithoutProperties$i(n, _excluded$l);
  return /* @__PURE__ */ React.createElement(StatefulContainer$1, g, function(d) {
    return /* @__PURE__ */ React.createElement(Popover$2, d, t);
  });
}
StatefulPopover.defaultProps = {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  ignoreBoundary: !1,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT.auto,
  showArrow: !1,
  triggerType: TRIGGER_TYPE.click,
  dismissOnClickOutside: !0,
  dismissOnEsc: !0,
  stateReducer: function n(t, g) {
    return g;
  },
  popoverMargin: POPOVER_MARGIN
};
var baseDefaultProps = {
  accessibilityType: ACCESSIBILITY_TYPE.tooltip,
  focusLock: !1,
  autoFocus: !1,
  returnFocus: !1,
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  overrides: {},
  placement: PLACEMENT.auto,
  popoverMargin: 0,
  showArrow: !1,
  triggerType: TRIGGER_TYPE.hover,
  renderAll: !1
};
function _typeof$b(n) {
  "@babel/helpers - typeof";
  return _typeof$b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$b(n);
}
function ownKeys$i(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$g(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$i(Object(g), !0).forEach(function(d) {
      _defineProperty$l(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$i(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _classCallCheck$g(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$8(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$g(n, t, g) {
  return t && _defineProperties$8(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$g(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$8(n, t);
}
function _setPrototypeOf$8(n, t) {
  return _setPrototypeOf$8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$8(n, t);
}
function _createSuper$8(n) {
  var t = _isNativeReflectConstruct$8();
  return function() {
    var d = _getPrototypeOf$8(n), k;
    if (t) {
      var H = _getPrototypeOf$8(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$g(this, k);
  };
}
function _possibleConstructorReturn$g(n, t) {
  if (t && (_typeof$b(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$8(n);
}
function _assertThisInitialized$8(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$8() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$8(n) {
  return _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$8(n);
}
function _defineProperty$l(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var StatefulContainer = /* @__PURE__ */ (function(n) {
  _inherits$g(g, n);
  var t = _createSuper$8(g);
  function g() {
    return _classCallCheck$g(this, g), t.apply(this, arguments);
  }
  return _createClass$g(g, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ React.createElement(StatefulContainer$1, this.props);
    }
  }]), g;
})(React.Component);
_defineProperty$l(StatefulContainer, "defaultProps", _objectSpread$g({}, baseDefaultProps));
function ownKeys$h(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$f(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$h(Object(g), !0).forEach(function(d) {
      _defineProperty$k(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$h(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$k(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var Body$1 = styled("div", function(n) {
  return _objectSpread$f(_objectSpread$f({}, getBodyStyles(n)), {}, {
    backgroundColor: n.$theme.colors.tooltipBackground,
    borderTopLeftRadius: n.$theme.borders.radius300,
    borderTopRightRadius: n.$theme.borders.radius300,
    borderBottomRightRadius: n.$theme.borders.radius300,
    borderBottomLeftRadius: n.$theme.borders.radius300,
    boxShadow: n.$theme.lighting.shadow400,
    color: n.$theme.colors.tooltipText,
    // Reset transition property to opacity only, and static transform
    transitionProperty: "opacity",
    transform: getEndPosition(n.$popoverOffset)
  });
});
Body$1.displayName = "Body";
Body$1.displayName = "Body";
var Inner = styled("div", function(n) {
  return _objectSpread$f(_objectSpread$f(_objectSpread$f({}, getInnerStyles(n)), {}, {
    backgroundColor: n.$theme.colors.tooltipBackground,
    borderTopLeftRadius: n.$theme.borders.radius300,
    borderTopRightRadius: n.$theme.borders.radius300,
    borderBottomRightRadius: n.$theme.borders.radius300,
    borderBottomLeftRadius: n.$theme.borders.radius300,
    paddingTop: n.$theme.sizing.scale300,
    paddingBottom: n.$theme.sizing.scale300,
    paddingLeft: n.$theme.sizing.scale600,
    paddingRight: n.$theme.sizing.scale600
  }, n.$theme.typography.font150), {}, {
    color: n.$theme.colors.tooltipText
  });
});
Inner.displayName = "Inner";
Inner.displayName = "Inner";
var Arrow = styled("div", function(n) {
  return _objectSpread$f(_objectSpread$f({}, getArrowStyles(n)), {}, {
    backgroundColor: n.$theme.colors.tooltipBackground
  });
});
Arrow.displayName = "Arrow";
Arrow.displayName = "Arrow";
function _typeof$a(n) {
  "@babel/helpers - typeof";
  return _typeof$a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$a(n);
}
function ownKeys$g(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$e(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$g(Object(g), !0).forEach(function(d) {
      _defineProperty$j(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$g(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _extends$u() {
  return _extends$u = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$u.apply(this, arguments);
}
function _classCallCheck$f(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$7(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$f(n, t, g) {
  return t && _defineProperties$7(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$f(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$7(n, t);
}
function _setPrototypeOf$7(n, t) {
  return _setPrototypeOf$7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$7(n, t);
}
function _createSuper$7(n) {
  var t = _isNativeReflectConstruct$7();
  return function() {
    var d = _getPrototypeOf$7(n), k;
    if (t) {
      var H = _getPrototypeOf$7(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$f(this, k);
  };
}
function _possibleConstructorReturn$f(n, t) {
  if (t && (_typeof$a(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$7(n);
}
function _assertThisInitialized$7(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$7() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$7(n) {
  return _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$7(n);
}
function _defineProperty$j(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var Tooltip$2 = /* @__PURE__ */ (function(n) {
  _inherits$f(g, n);
  var t = _createSuper$7(g);
  function g() {
    return _classCallCheck$f(this, g), t.apply(this, arguments);
  }
  return _createClass$f(g, [{
    key: "render",
    value: function() {
      var k = mergeOverrides({
        Arrow,
        Body: Body$1,
        Inner
      }, this.props.overrides);
      return /* @__PURE__ */ React.createElement(Popover$2, _extends$u({
        autoFocus: !1,
        "data-baseweb": "tooltip"
      }, this.props, {
        overrides: k
      }));
    }
  }]), g;
})(React.Component);
_defineProperty$j(Tooltip$2, "defaultProps", _objectSpread$e({}, baseDefaultProps));
var _excluded$k = ["children"];
function _objectWithoutProperties$h(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$h(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$h(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function StatefulTooltip(n) {
  var t = n.children, g = _objectWithoutProperties$h(n, _excluded$k);
  return /* @__PURE__ */ React.createElement(StatefulContainer, g, function(d) {
    return /* @__PURE__ */ React.createElement(Tooltip$2, d, t);
  });
}
StatefulTooltip.defaultProps = StatefulContainer.defaultProps;
function _EMOTION_STRINGIFIED_CSS_ERROR__$e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledWrapper = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1gc5fo22"
} : {
  target: "e1gc5fo22",
  label: "StyledWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "87mhkc",
  styles: "display:table;table-layout:fixed;width:100%"
} : {
  name: "87mhkc",
  styles: "display:table;table-layout:fixed;width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
}), StyledEllipsizedDiv = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1gc5fo21"
} : {
  target: "e1gc5fo21",
  label: "StyledEllipsizedDiv"
})(process.env.NODE_ENV === "production" ? {
  name: "sy3zga",
  styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:table-cell"
} : {
  name: "sy3zga",
  styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:table-cell/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvVG9vbHRpcC9zdHlsZWQtY29tcG9uZW50cy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0JtQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvc2hhcmVkL1Rvb2x0aXAvc3R5bGVkLWNvbXBvbmVudHMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRXcmFwcGVyID0gc3R5bGVkLmRpdih7XG4gIGRpc3BsYXk6IFwidGFibGVcIixcbiAgdGFibGVMYXlvdXQ6IFwiZml4ZWRcIixcbiAgd2lkdGg6IFwiMTAwJVwiLFxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsbGlwc2l6ZWREaXYgPSBzdHlsZWQuZGl2KHtcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICBkaXNwbGF5OiBcInRhYmxlLWNlbGxcIixcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwQ29udGVudFdyYXBwZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJveFNpemluZzogXCJib3JkZXItYm94XCIsXG4gIGZvbnRTaXplOiBgJHt0aGVtZS5mb250U2l6ZXMuc219YCxcbiAgbWF4V2lkdGg6IGBjYWxjKCR7dGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRofSAtIDIgKiAke3RoZW1lLnNwYWNpbmcudGhyZWVYTH0pYCxcbiAgbWF4SGVpZ2h0OiB0aGVtZS5zaXplcy5tYXhUb29sdGlwSGVpZ2h0LFxuICBvdmVyZmxvdzogXCJhdXRvXCIsXG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcueHN9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuXG4gIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMuc219KWBdOiB7XG4gICAgbWF4V2lkdGg6IGBjYWxjKDEwMCUgLSAke3RoZW1lLnNwYWNpbmcudGhyZWVYTH0pYCxcbiAgfSxcbiAgaW1nOiB7XG4gICAgbWF4V2lkdGg6IFwiMTAwJVwiLFxuICB9LFxuICBcIipcIjoge1xuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gIH0sXG59KSlcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
}), StyledTooltipContentWrapper = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1gc5fo20"
} : {
  target: "e1gc5fo20",
  label: "StyledTooltipContentWrapper"
})(({
  theme: n
}) => ({
  boxSizing: "border-box",
  fontSize: `${n.fontSizes.sm}`,
  maxWidth: `calc(${n.sizes.contentMaxWidth} - 2 * ${n.spacing.threeXL})`,
  maxHeight: n.sizes.maxTooltipHeight,
  overflow: "auto",
  padding: `${n.spacing.xs} ${n.spacing.md}`,
  [`@media (max-width: ${n.breakpoints.sm})`]: {
    maxWidth: `calc(100% - ${n.spacing.threeXL})`
  },
  img: {
    maxWidth: "100%"
  },
  "*": {
    fontSize: n.fontSizes.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function useTooltipMeasurementSideEffect(n, t) {
  const {
    innerWidth: g
  } = useWindowDimensionsContext();
  useEffect(() => {
    const d = n?.parentElement;
    if (!d)
      return;
    (async () => {
      const H = () => {
        const iA = d.getBoundingClientRect();
        return iA.x !== 0 || iA.y !== 0 ? iA : null;
      };
      let AA = null, gA = 0;
      const IA = 5;
      for (; !AA && gA < IA; )
        AA = H(), AA || (gA++, await new Promise((iA) => requestAnimationFrame(iA)));
      AA || (AA = d.getBoundingClientRect());
      const CA = AA.x, BA = CA + AA.width - g, eA = d.parentElement;
      if (BA > 0 && eA) {
        const iA = new DOMMatrix(
          // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
          window.getComputedStyle(eA)?.transform
        );
        eA.style.transform = `translate3d(${iA.e - BA}px, ${iA.f}px, 0px)`;
      }
      CA < 0 && (d.style.left = `${-CA}px`);
    })();
  }, [n, t, g]);
}
var Placement = /* @__PURE__ */ ((n) => (n.AUTO = "auto", n.TOP_LEFT = "topLeft", n.TOP = "top", n.TOP_RIGHT = "topRight", n.RIGHT_TOP = "rightTop", n.RIGHT = "right", n.RIGHT_BOTTOM = "rightBottom", n.BOTTOM_RIGHT = "bottomRight", n.BOTTOM = "bottom", n.BOTTOM_LEFT = "bottomLeft", n.LEFT_BOTTOM = "leftBottom", n.LEFT = "left", n.LEFT_TOP = "leftTop", n))(Placement || {});
const generateDefaultTooltipOverrides = (n, t) => {
  const {
    colors: g,
    fontSizes: d,
    radii: k,
    fontWeights: H
  } = n;
  return {
    Body: {
      style: {
        // This is annoying, but a bunch of warnings get logged when the
        // shorthand version `borderRadius` is used here since the long
        // names are used by BaseWeb and mixing the two is apparently
        // bad :(
        borderTopLeftRadius: k.default,
        borderTopRightRadius: k.default,
        borderBottomLeftRadius: k.default,
        borderBottomRightRadius: k.default,
        paddingTop: "0 !important",
        paddingBottom: "0 !important",
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
        backgroundColor: "transparent"
      }
    },
    Inner: {
      style: {
        backgroundColor: hasLightBackgroundColor(n) ? g.bgColor : g.secondaryBg,
        color: g.bodyText,
        fontSize: d.sm,
        fontWeight: H.normal,
        // See the long comment about `borderRadius`. The same applies here
        // to `padding`.
        paddingTop: "0 !important",
        paddingBottom: "0 !important",
        paddingLeft: "0 !important",
        paddingRight: "0 !important"
      },
      // overrides prop replaces tooltip subcomponent overrides
      ...t
    }
  };
};
function Tooltip({
  content: n,
  placement: t,
  children: g,
  inline: d,
  style: k,
  onMouseEnterDelay: H,
  overrides: AA,
  containerWidth: gA,
  error: IA
}) {
  const CA = useEmotionTheme(), [BA, eA] = useState(null), [iA, QA] = useState(!1), tA = useCallback(() => {
    QA(!0);
  }, []), oA = useCallback(() => {
    QA(!1);
  }, []);
  useTooltipMeasurementSideEffect(BA, iA);
  const EA = generateDefaultTooltipOverrides(CA, AA);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StatefulTooltip, { onOpen: tA, onClose: oA, content: n ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipContentWrapper, { className: IA ? "stTooltipErrorContent" : "stTooltipContent", "data-testid": IA ? "stTooltipErrorContent" : "stTooltipContent", ref: eA, children: n }) : null, placement: PLACEMENT[t], accessibilityType: ACCESSIBILITY_TYPE.tooltip, showArrow: !1, popoverMargin: 10, onMouseEnterDelay: H, overrides: EA, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    justifyContent: d ? "flex-end" : "",
    width: gA ? "100%" : "auto",
    ...k
  }, "data-testid": IA ? "stTooltipErrorHoverTarget" : "stTooltipHoverTarget", className: IA ? "stTooltipErrorHoverTarget" : "stTooltipHoverTarget", children: g }) });
}
const Tooltip$1 = memo$1(Tooltip);
function OverflowTooltip({
  content: n,
  placement: t,
  children: g,
  inline: d,
  style: k
}) {
  const H = React__default.useRef(null), [AA, gA] = useState(!1);
  return React__default.useEffect(() => {
    const IA = H?.current ? (
      // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
      H.current.offsetWidth < H.current.scrollWidth
    ) : !1;
    IA !== AA && gA(IA);
  }, [g, AA]), /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { content: AA ? n : "", placement: t, inline: d, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEllipsizedDiv, { ref: H, style: k, children: g }) }) });
}
const StyledTooltipIconWrapper = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ewgb6652"
} : {
  target: "ewgb6652",
  label: "StyledTooltipIconWrapper"
})(({
  isLatex: n,
  theme: t
}) => ({
  display: "flex",
  alignItems: "center",
  marginTop: n ? t.spacing.md : "0",
  "& .stTooltipHoverTarget > svg": {
    stroke: t.colors.fadedText60,
    strokeWidth: 2.25
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLabelHelpWrapper = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ewgb6651"
} : {
  target: "ewgb6651",
  label: "StyledLabelHelpWrapper"
})(({
  isLatex: n
}) => ({
  display: "flex",
  visibility: "visible",
  verticalAlign: "middle",
  flexDirection: "row",
  alignItems: "center",
  ...n ? {
    justifyContent: "center"
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLabelHelpInline = /* @__PURE__ */ createStyled$1("label", process.env.NODE_ENV === "production" ? {
  target: "ewgb6650"
} : {
  target: "ewgb6650",
  label: "StyledLabelHelpInline"
})(({
  theme: n
}) => ({
  marginLeft: n.spacing.xs,
  position: "relative",
  display: "flex",
  flexDirection: "row"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function TooltipIcon({
  placement: n = Placement.AUTO,
  isLatex: t = !1,
  content: g,
  children: d,
  markdownProps: k,
  onMouseEnterDelay: H,
  containerWidth: AA = !1
}) {
  const gA = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipIconWrapper, { className: "stTooltipIcon", "data-testid": "stTooltipIcon", isLatex: t, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { content: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { style: {
    fontSize: gA.fontSizes.sm
  }, source: g, allowHTML: !1, ...k || {} }), placement: n, onMouseEnterDelay: H, inline: !0, containerWidth: AA, children: d || /* @__PURE__ */ jsxRuntimeExports.jsx(
    HelpCircle,
    {
      className: "icon",
      size: convertRemToPx(gA.iconSizes.base)
    }
  ) }) });
}
const InlineTooltipIcon = ({
  placement: n = Placement.TOP_RIGHT,
  isLatex: t = !1,
  content: g,
  children: d,
  markdownProps: k
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabelHelpInline, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { placement: n, isLatex: t, content: g, markdownProps: k, children: d }) });
var Pe = Object.defineProperty, a$2 = (n, t) => Pe(n, "name", { value: t, configurable: !0 }), P$1 = class {
  type = 3;
  name = "";
  prefix = "";
  value = "";
  suffix = "";
  modifier = 3;
  constructor(t, g, d, k, H, AA) {
    this.type = t, this.name = g, this.prefix = d, this.value = k, this.suffix = H, this.modifier = AA;
  }
  hasCustomName() {
    return this.name !== "" && typeof this.name != "number";
  }
};
a$2(P$1, "Part");
var Re = /[$_\p{ID_Start}]/u, Ee = /[$_\u200C\u200D\p{ID_Continue}]/u, v = ".*";
function Oe(n, t) {
  return (t ? /^[\x00-\xFF]*$/ : /^[\x00-\x7F]*$/).test(n);
}
a$2(Oe, "isASCII");
function D$2(n, t = !1) {
  let g = [], d = 0;
  for (; d < n.length; ) {
    let k = n[d], H = a$2(function(AA) {
      if (!t) throw new TypeError(AA);
      g.push({ type: "INVALID_CHAR", index: d, value: n[d++] });
    }, "ErrorOrInvalid");
    if (k === "*") {
      g.push({ type: "ASTERISK", index: d, value: n[d++] });
      continue;
    }
    if (k === "+" || k === "?") {
      g.push({ type: "OTHER_MODIFIER", index: d, value: n[d++] });
      continue;
    }
    if (k === "\\") {
      g.push({ type: "ESCAPED_CHAR", index: d++, value: n[d++] });
      continue;
    }
    if (k === "{") {
      g.push({ type: "OPEN", index: d, value: n[d++] });
      continue;
    }
    if (k === "}") {
      g.push({ type: "CLOSE", index: d, value: n[d++] });
      continue;
    }
    if (k === ":") {
      let AA = "", gA = d + 1;
      for (; gA < n.length; ) {
        let IA = n.substr(gA, 1);
        if (gA === d + 1 && Re.test(IA) || gA !== d + 1 && Ee.test(IA)) {
          AA += n[gA++];
          continue;
        }
        break;
      }
      if (!AA) {
        H(`Missing parameter name at ${d}`);
        continue;
      }
      g.push({ type: "NAME", index: d, value: AA }), d = gA;
      continue;
    }
    if (k === "(") {
      let AA = 1, gA = "", IA = d + 1, CA = !1;
      if (n[IA] === "?") {
        H(`Pattern cannot start with "?" at ${IA}`);
        continue;
      }
      for (; IA < n.length; ) {
        if (!Oe(n[IA], !1)) {
          H(`Invalid character '${n[IA]}' at ${IA}.`), CA = !0;
          break;
        }
        if (n[IA] === "\\") {
          gA += n[IA++] + n[IA++];
          continue;
        }
        if (n[IA] === ")") {
          if (AA--, AA === 0) {
            IA++;
            break;
          }
        } else if (n[IA] === "(" && (AA++, n[IA + 1] !== "?")) {
          H(`Capturing groups are not allowed at ${IA}`), CA = !0;
          break;
        }
        gA += n[IA++];
      }
      if (CA) continue;
      if (AA) {
        H(`Unbalanced pattern at ${d}`);
        continue;
      }
      if (!gA) {
        H(`Missing pattern at ${d}`);
        continue;
      }
      g.push({ type: "REGEX", index: d, value: gA }), d = IA;
      continue;
    }
    g.push({ type: "CHAR", index: d, value: n[d++] });
  }
  return g.push({ type: "END", index: d, value: "" }), g;
}
a$2(D$2, "lexer");
function F$1(n, t = {}) {
  let g = D$2(n);
  t.delimiter ??= "/#?", t.prefixes ??= "./";
  let d = `[^${x$4(t.delimiter)}]+?`, k = [], H = 0, AA = 0, gA = /* @__PURE__ */ new Set(), IA = a$2((nA) => {
    if (AA < g.length && g[AA].type === nA) return g[AA++].value;
  }, "tryConsume"), CA = a$2(() => IA("OTHER_MODIFIER") ?? IA("ASTERISK"), "tryConsumeModifier"), BA = a$2((nA) => {
    let lA = IA(nA);
    if (lA !== void 0) return lA;
    let { type: cA, index: sA } = g[AA];
    throw new TypeError(`Unexpected ${cA} at ${sA}, expected ${nA}`);
  }, "mustConsume"), eA = a$2(() => {
    let nA = "", lA;
    for (; lA = IA("CHAR") ?? IA("ESCAPED_CHAR"); ) nA += lA;
    return nA;
  }, "consumeText"), iA = a$2((nA) => nA, "DefaultEncodePart"), QA = t.encodePart || iA, tA = "", oA = a$2((nA) => {
    tA += nA;
  }, "appendToPendingFixedValue"), EA = a$2(() => {
    tA.length && (k.push(new P$1(3, "", "", QA(tA), "", 3)), tA = "");
  }, "maybeAddPartFromPendingFixedValue"), aA = a$2((nA, lA, cA, sA, rA) => {
    let uA = 3;
    switch (rA) {
      case "?":
        uA = 1;
        break;
      case "*":
        uA = 0;
        break;
      case "+":
        uA = 2;
        break;
    }
    if (!lA && !cA && uA === 3) {
      oA(nA);
      return;
    }
    if (EA(), !lA && !cA) {
      if (!nA) return;
      k.push(new P$1(3, "", "", QA(nA), "", uA));
      return;
    }
    let hA;
    cA ? cA === "*" ? hA = v : hA = cA : hA = d;
    let dA = 2;
    hA === d ? (dA = 1, hA = "") : hA === v && (dA = 0, hA = "");
    let GA;
    if (lA ? GA = lA : cA && (GA = H++), gA.has(GA)) throw new TypeError(`Duplicate name '${GA}'.`);
    gA.add(GA), k.push(new P$1(dA, GA, QA(nA), hA, QA(sA), uA));
  }, "addPart");
  for (; AA < g.length; ) {
    let nA = IA("CHAR"), lA = IA("NAME"), cA = IA("REGEX");
    if (!lA && !cA && (cA = IA("ASTERISK")), lA || cA) {
      let rA = nA ?? "";
      t.prefixes.indexOf(rA) === -1 && (oA(rA), rA = ""), EA();
      let uA = CA();
      aA(rA, lA, cA, "", uA);
      continue;
    }
    let sA = nA ?? IA("ESCAPED_CHAR");
    if (sA) {
      oA(sA);
      continue;
    }
    if (IA("OPEN")) {
      let rA = eA(), uA = IA("NAME"), hA = IA("REGEX");
      !uA && !hA && (hA = IA("ASTERISK"));
      let dA = eA();
      BA("CLOSE");
      let GA = CA();
      aA(rA, uA, hA, dA, GA);
      continue;
    }
    EA(), BA("END");
  }
  return k;
}
a$2(F$1, "parse");
function x$4(n) {
  return n.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
a$2(x$4, "escapeString");
function B$3(n) {
  return n && n.ignoreCase ? "ui" : "u";
}
a$2(B$3, "flags");
function q(n, t, g) {
  return W$1(F$1(n, g), t, g);
}
a$2(q, "stringToRegexp");
function T(n) {
  switch (n) {
    case 0:
      return "*";
    case 1:
      return "?";
    case 2:
      return "+";
    case 3:
      return "";
  }
}
a$2(T, "modifierToString");
function W$1(n, t, g = {}) {
  g.delimiter ??= "/#?", g.prefixes ??= "./", g.sensitive ??= !1, g.strict ??= !1, g.end ??= !0, g.start ??= !0, g.endsWith = "";
  let d = g.start ? "^" : "";
  for (let gA of n) {
    if (gA.type === 3) {
      gA.modifier === 3 ? d += x$4(gA.value) : d += `(?:${x$4(gA.value)})${T(gA.modifier)}`;
      continue;
    }
    t && t.push(gA.name);
    let IA = `[^${x$4(g.delimiter)}]+?`, CA = gA.value;
    if (gA.type === 1 ? CA = IA : gA.type === 0 && (CA = v), !gA.prefix.length && !gA.suffix.length) {
      gA.modifier === 3 || gA.modifier === 1 ? d += `(${CA})${T(gA.modifier)}` : d += `((?:${CA})${T(gA.modifier)})`;
      continue;
    }
    if (gA.modifier === 3 || gA.modifier === 1) {
      d += `(?:${x$4(gA.prefix)}(${CA})${x$4(gA.suffix)})`, d += T(gA.modifier);
      continue;
    }
    d += `(?:${x$4(gA.prefix)}`, d += `((?:${CA})(?:`, d += x$4(gA.suffix), d += x$4(gA.prefix), d += `(?:${CA}))*)${x$4(gA.suffix)})`, gA.modifier === 0 && (d += "?");
  }
  let k = `[${x$4(g.endsWith)}]|$`, H = `[${x$4(g.delimiter)}]`;
  if (g.end) return g.strict || (d += `${H}?`), g.endsWith.length ? d += `(?=${k})` : d += "$", new RegExp(d, B$3(g));
  g.strict || (d += `(?:${H}(?=${k}))?`);
  let AA = !1;
  if (n.length) {
    let gA = n[n.length - 1];
    gA.type === 3 && gA.modifier === 3 && (AA = g.delimiter.indexOf(gA) > -1);
  }
  return AA || (d += `(?=${H}|${k})`), new RegExp(d, B$3(g));
}
a$2(W$1, "partsToRegexp");
var b$1 = { delimiter: "", prefixes: "", sensitive: !0, strict: !0 }, J$1 = { delimiter: ".", prefixes: "", sensitive: !0, strict: !0 }, Q$1 = { delimiter: "/", prefixes: "/", sensitive: !0, strict: !0 };
function ee(n, t) {
  return n.length ? n[0] === "/" ? !0 : !t || n.length < 2 ? !1 : (n[0] == "\\" || n[0] == "{") && n[1] == "/" : !1;
}
a$2(ee, "isAbsolutePathname");
function te(n, t) {
  return n.startsWith(t) ? n.substring(t.length, n.length) : n;
}
a$2(te, "maybeStripPrefix");
function ke(n, t) {
  return n.endsWith(t) ? n.substr(0, n.length - t.length) : n;
}
a$2(ke, "maybeStripSuffix");
function _(n) {
  return !n || n.length < 2 ? !1 : n[0] === "[" || (n[0] === "\\" || n[0] === "{") && n[1] === "[";
}
a$2(_, "treatAsIPv6Hostname");
var re$2 = ["ftp", "file", "http", "https", "ws", "wss"];
function U$1(n) {
  if (!n) return !0;
  for (let t of re$2) if (n.test(t)) return !0;
  return !1;
}
a$2(U$1, "isSpecialScheme");
function ne(n, t) {
  if (n = te(n, "#"), t || n === "") return n;
  let g = new URL("https://example.com");
  return g.hash = n, g.hash ? g.hash.substring(1, g.hash.length) : "";
}
a$2(ne, "canonicalizeHash");
function se(n, t) {
  if (n = te(n, "?"), t || n === "") return n;
  let g = new URL("https://example.com");
  return g.search = n, g.search ? g.search.substring(1, g.search.length) : "";
}
a$2(se, "canonicalizeSearch");
function ie(n, t) {
  return t || n === "" ? n : _(n) ? K$2(n) : j(n);
}
a$2(ie, "canonicalizeHostname");
function ae(n, t) {
  if (t || n === "") return n;
  let g = new URL("https://example.com");
  return g.password = n, g.password;
}
a$2(ae, "canonicalizePassword");
function oe(n, t) {
  if (t || n === "") return n;
  let g = new URL("https://example.com");
  return g.username = n, g.username;
}
a$2(oe, "canonicalizeUsername");
function ce(n, t, g) {
  if (g || n === "") return n;
  if (t && !re$2.includes(t)) return new URL(`${t}:${n}`).pathname;
  let d = n[0] == "/";
  return n = new URL(d ? n : "/-" + n, "https://example.com").pathname, d || (n = n.substring(2, n.length)), n;
}
a$2(ce, "canonicalizePathname");
function le(n, t, g) {
  return z$1(t) === n && (n = ""), g || n === "" ? n : G$1(n);
}
a$2(le, "canonicalizePort");
function fe(n, t) {
  return n = ke(n, ":"), t || n === "" ? n : w$3(n);
}
a$2(fe, "canonicalizeProtocol");
function z$1(n) {
  switch (n) {
    case "ws":
    case "http":
      return "80";
    case "wws":
    case "https":
      return "443";
    case "ftp":
      return "21";
    default:
      return "";
  }
}
a$2(z$1, "defaultPortForProtocol");
function w$3(n) {
  if (n === "") return n;
  if (/^[-+.A-Za-z0-9]*$/.test(n)) return n.toLowerCase();
  throw new TypeError(`Invalid protocol '${n}'.`);
}
a$2(w$3, "protocolEncodeCallback");
function he(n) {
  if (n === "") return n;
  let t = new URL("https://example.com");
  return t.username = n, t.username;
}
a$2(he, "usernameEncodeCallback");
function ue(n) {
  if (n === "") return n;
  let t = new URL("https://example.com");
  return t.password = n, t.password;
}
a$2(ue, "passwordEncodeCallback");
function j(n) {
  if (n === "") return n;
  if (/[\t\n\r #%/:<>?@[\]^\\|]/g.test(n)) throw new TypeError(`Invalid hostname '${n}'`);
  let t = new URL("https://example.com");
  return t.hostname = n, t.hostname;
}
a$2(j, "hostnameEncodeCallback");
function K$2(n) {
  if (n === "") return n;
  if (/[^0-9a-fA-F[\]:]/g.test(n)) throw new TypeError(`Invalid IPv6 hostname '${n}'`);
  return n.toLowerCase();
}
a$2(K$2, "ipv6HostnameEncodeCallback");
function G$1(n) {
  if (n === "" || /^[0-9]*$/.test(n) && parseInt(n) <= 65535) return n;
  throw new TypeError(`Invalid port '${n}'.`);
}
a$2(G$1, "portEncodeCallback");
function de(n) {
  if (n === "") return n;
  let t = new URL("https://example.com");
  return t.pathname = n[0] !== "/" ? "/-" + n : n, n[0] !== "/" ? t.pathname.substring(2, t.pathname.length) : t.pathname;
}
a$2(de, "standardURLPathnameEncodeCallback");
function pe(n) {
  return n === "" ? n : new URL(`data:${n}`).pathname;
}
a$2(pe, "pathURLPathnameEncodeCallback");
function ge(n) {
  if (n === "") return n;
  let t = new URL("https://example.com");
  return t.search = n, t.search.substring(1, t.search.length);
}
a$2(ge, "searchEncodeCallback");
function me(n) {
  if (n === "") return n;
  let t = new URL("https://example.com");
  return t.hash = n, t.hash.substring(1, t.hash.length);
}
a$2(me, "hashEncodeCallback");
var C$2 = class {
  #B;
  #C = [];
  #g = {};
  #A = 0;
  #e = 1;
  #o = 0;
  #Q = 0;
  #r = 0;
  #c = 0;
  #l = !1;
  constructor(t) {
    this.#B = t;
  }
  get result() {
    return this.#g;
  }
  parse() {
    for (this.#C = D$2(this.#B, !0); this.#A < this.#C.length; this.#A += this.#e) {
      if (this.#e = 1, this.#C[this.#A].type === "END") {
        if (this.#Q === 0) {
          this.#G(), this.#E() ? this.#I(9, 1) : this.#a() ? this.#I(8, 1) : this.#I(7, 0);
          continue;
        } else if (this.#Q === 2) {
          this.#n(5);
          continue;
        }
        this.#I(10, 0);
        break;
      }
      if (this.#r > 0) if (this.#N()) this.#r -= 1;
      else continue;
      if (this.#y()) {
        this.#r += 1;
        continue;
      }
      switch (this.#Q) {
        case 0:
          this.#h() && this.#n(1);
          break;
        case 1:
          if (this.#h()) {
            this.#R();
            let t = 7, g = 1;
            this.#b() ? (t = 2, g = 3) : this.#l && (t = 2), this.#I(t, g);
          }
          break;
        case 2:
          this.#u() ? this.#n(3) : (this.#d() || this.#a() || this.#E()) && this.#n(5);
          break;
        case 3:
          this.#p() ? this.#I(4, 1) : this.#u() && this.#I(5, 1);
          break;
        case 4:
          this.#u() && this.#I(5, 1);
          break;
        case 5:
          this.#M() ? this.#c += 1 : this.#k() && (this.#c -= 1), this.#w() && !this.#c ? this.#I(6, 1) : this.#d() ? this.#I(7, 0) : this.#a() ? this.#I(8, 1) : this.#E() && this.#I(9, 1);
          break;
        case 6:
          this.#d() ? this.#I(7, 0) : this.#a() ? this.#I(8, 1) : this.#E() && this.#I(9, 1);
          break;
        case 7:
          this.#a() ? this.#I(8, 1) : this.#E() && this.#I(9, 1);
          break;
        case 8:
          this.#E() && this.#I(9, 1);
          break;
      }
    }
    this.#g.hostname !== void 0 && this.#g.port === void 0 && (this.#g.port = "");
  }
  #I(t, g) {
    switch (this.#Q) {
      case 0:
        break;
      case 1:
        this.#g.protocol = this.#t();
        break;
      case 2:
        break;
      case 3:
        this.#g.username = this.#t();
        break;
      case 4:
        this.#g.password = this.#t();
        break;
      case 5:
        this.#g.hostname = this.#t();
        break;
      case 6:
        this.#g.port = this.#t();
        break;
      case 7:
        this.#g.pathname = this.#t();
        break;
      case 8:
        this.#g.search = this.#t();
        break;
      case 9:
        this.#g.hash = this.#t();
        break;
    }
    this.#Q !== 0 && t !== 10 && ([1, 2, 3, 4].includes(this.#Q) && [6, 7, 8, 9].includes(t) && (this.#g.hostname ??= ""), [1, 2, 3, 4, 5, 6].includes(this.#Q) && [8, 9].includes(t) && (this.#g.pathname ??= this.#l ? "/" : ""), [1, 2, 3, 4, 5, 6, 7].includes(this.#Q) && t === 9 && (this.#g.search ??= "")), this.#D(t, g);
  }
  #D(t, g) {
    this.#Q = t, this.#o = this.#A + g, this.#A += g, this.#e = 0;
  }
  #G() {
    this.#A = this.#o, this.#e = 0;
  }
  #n(t) {
    this.#G(), this.#Q = t;
  }
  #s(t) {
    return t < 0 && (t = this.#C.length - t), t < this.#C.length ? this.#C[t] : this.#C[this.#C.length - 1];
  }
  #i(t, g) {
    let d = this.#s(t);
    return d.value === g && (d.type === "CHAR" || d.type === "ESCAPED_CHAR" || d.type === "INVALID_CHAR");
  }
  #h() {
    return this.#i(this.#A, ":");
  }
  #b() {
    return this.#i(this.#A + 1, "/") && this.#i(this.#A + 2, "/");
  }
  #u() {
    return this.#i(this.#A, "@");
  }
  #p() {
    return this.#i(this.#A, ":");
  }
  #w() {
    return this.#i(this.#A, ":");
  }
  #d() {
    return this.#i(this.#A, "/");
  }
  #a() {
    if (this.#i(this.#A, "?")) return !0;
    if (this.#C[this.#A].value !== "?") return !1;
    let t = this.#s(this.#A - 1);
    return t.type !== "NAME" && t.type !== "REGEX" && t.type !== "CLOSE" && t.type !== "ASTERISK";
  }
  #E() {
    return this.#i(this.#A, "#");
  }
  #y() {
    return this.#C[this.#A].type == "OPEN";
  }
  #N() {
    return this.#C[this.#A].type == "CLOSE";
  }
  #M() {
    return this.#i(this.#A, "[");
  }
  #k() {
    return this.#i(this.#A, "]");
  }
  #t() {
    let t = this.#C[this.#A], g = this.#s(this.#o).index;
    return this.#B.substring(g, t.index);
  }
  #R() {
    let t = {};
    Object.assign(t, b$1), t.encodePart = w$3;
    let g = q(this.#t(), void 0, t);
    this.#l = U$1(g);
  }
};
a$2(C$2, "Parser");
var V$1 = ["protocol", "username", "password", "hostname", "port", "pathname", "search", "hash"], O = "*";
function Se(n, t) {
  if (typeof n != "string") throw new TypeError("parameter 1 is not of type 'string'.");
  let g = new URL(n, t);
  return { protocol: g.protocol.substring(0, g.protocol.length - 1), username: g.username, password: g.password, hostname: g.hostname, port: g.port, pathname: g.pathname, search: g.search !== "" ? g.search.substring(1, g.search.length) : void 0, hash: g.hash !== "" ? g.hash.substring(1, g.hash.length) : void 0 };
}
a$2(Se, "extractValues");
function R(n, t) {
  return t ? I$1(n) : n;
}
a$2(R, "processBaseURLString");
function L$1(n, t, g) {
  let d;
  if (typeof t.baseURL == "string") try {
    d = new URL(t.baseURL), t.protocol === void 0 && (n.protocol = R(d.protocol.substring(0, d.protocol.length - 1), g)), !g && t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.username === void 0 && (n.username = R(d.username, g)), !g && t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.username === void 0 && t.password === void 0 && (n.password = R(d.password, g)), t.protocol === void 0 && t.hostname === void 0 && (n.hostname = R(d.hostname, g)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && (n.port = R(d.port, g)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.pathname === void 0 && (n.pathname = R(d.pathname, g)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.pathname === void 0 && t.search === void 0 && (n.search = R(d.search.substring(1, d.search.length), g)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.pathname === void 0 && t.search === void 0 && t.hash === void 0 && (n.hash = R(d.hash.substring(1, d.hash.length), g));
  } catch {
    throw new TypeError(`invalid baseURL '${t.baseURL}'.`);
  }
  if (typeof t.protocol == "string" && (n.protocol = fe(t.protocol, g)), typeof t.username == "string" && (n.username = oe(t.username, g)), typeof t.password == "string" && (n.password = ae(t.password, g)), typeof t.hostname == "string" && (n.hostname = ie(t.hostname, g)), typeof t.port == "string" && (n.port = le(t.port, n.protocol, g)), typeof t.pathname == "string") {
    if (n.pathname = t.pathname, d && !ee(n.pathname, g)) {
      let k = d.pathname.lastIndexOf("/");
      k >= 0 && (n.pathname = R(d.pathname.substring(0, k + 1), g) + n.pathname);
    }
    n.pathname = ce(n.pathname, n.protocol, g);
  }
  return typeof t.search == "string" && (n.search = se(t.search, g)), typeof t.hash == "string" && (n.hash = ne(t.hash, g)), n;
}
a$2(L$1, "applyInit");
function I$1(n) {
  return n.replace(/([+*?:{}()\\])/g, "\\$1");
}
a$2(I$1, "escapePatternString");
function Te(n) {
  return n.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
a$2(Te, "escapeRegexpString");
function Ae(n, t) {
  t.delimiter ??= "/#?", t.prefixes ??= "./", t.sensitive ??= !1, t.strict ??= !1, t.end ??= !0, t.start ??= !0, t.endsWith = "";
  let g = ".*", d = `[^${Te(t.delimiter)}]+?`, k = /[$_\u200C\u200D\p{ID_Continue}]/u, H = "";
  for (let AA = 0; AA < n.length; ++AA) {
    let gA = n[AA];
    if (gA.type === 3) {
      if (gA.modifier === 3) {
        H += I$1(gA.value);
        continue;
      }
      H += `{${I$1(gA.value)}}${T(gA.modifier)}`;
      continue;
    }
    let IA = gA.hasCustomName(), CA = !!gA.suffix.length || !!gA.prefix.length && (gA.prefix.length !== 1 || !t.prefixes.includes(gA.prefix)), BA = AA > 0 ? n[AA - 1] : null, eA = AA < n.length - 1 ? n[AA + 1] : null;
    if (!CA && IA && gA.type === 1 && gA.modifier === 3 && eA && !eA.prefix.length && !eA.suffix.length) if (eA.type === 3) {
      let iA = eA.value.length > 0 ? eA.value[0] : "";
      CA = k.test(iA);
    } else CA = !eA.hasCustomName();
    if (!CA && !gA.prefix.length && BA && BA.type === 3) {
      let iA = BA.value[BA.value.length - 1];
      CA = t.prefixes.includes(iA);
    }
    CA && (H += "{"), H += I$1(gA.prefix), IA && (H += `:${gA.name}`), gA.type === 2 ? H += `(${gA.value})` : gA.type === 1 ? IA || (H += `(${d})`) : gA.type === 0 && (!IA && (!BA || BA.type === 3 || BA.modifier !== 3 || CA || gA.prefix !== "") ? H += "*" : H += `(${g})`), gA.type === 1 && IA && gA.suffix.length && k.test(gA.suffix[0]) && (H += "\\"), H += I$1(gA.suffix), CA && (H += "}"), gA.modifier !== 3 && (H += T(gA.modifier));
  }
  return H;
}
a$2(Ae, "partsToPattern");
var Y$2 = class {
  #B;
  #C = {};
  #g = {};
  #A = {};
  #e = {};
  #o = !1;
  constructor(t = {}, g, d) {
    try {
      let k;
      if (typeof g == "string" ? k = g : d = g, typeof t == "string") {
        let IA = new C$2(t);
        if (IA.parse(), t = IA.result, k === void 0 && typeof t.protocol != "string") throw new TypeError("A base URL must be provided for a relative constructor string.");
        t.baseURL = k;
      } else {
        if (!t || typeof t != "object") throw new TypeError("parameter 1 is not of type 'string' and cannot convert to dictionary.");
        if (k) throw new TypeError("parameter 1 is not of type 'string'.");
      }
      typeof d > "u" && (d = { ignoreCase: !1 });
      let H = { ignoreCase: d.ignoreCase === !0 }, AA = { pathname: O, protocol: O, username: O, password: O, hostname: O, port: O, search: O, hash: O };
      this.#B = L$1(AA, t, !0), z$1(this.#B.protocol) === this.#B.port && (this.#B.port = "");
      let gA;
      for (gA of V$1) {
        if (!(gA in this.#B)) continue;
        let IA = {}, CA = this.#B[gA];
        switch (this.#g[gA] = [], gA) {
          case "protocol":
            Object.assign(IA, b$1), IA.encodePart = w$3;
            break;
          case "username":
            Object.assign(IA, b$1), IA.encodePart = he;
            break;
          case "password":
            Object.assign(IA, b$1), IA.encodePart = ue;
            break;
          case "hostname":
            Object.assign(IA, J$1), _(CA) ? IA.encodePart = K$2 : IA.encodePart = j;
            break;
          case "port":
            Object.assign(IA, b$1), IA.encodePart = G$1;
            break;
          case "pathname":
            U$1(this.#C.protocol) ? (Object.assign(IA, Q$1, H), IA.encodePart = de) : (Object.assign(IA, b$1, H), IA.encodePart = pe);
            break;
          case "search":
            Object.assign(IA, b$1, H), IA.encodePart = ge;
            break;
          case "hash":
            Object.assign(IA, b$1, H), IA.encodePart = me;
            break;
        }
        try {
          this.#e[gA] = F$1(CA, IA), this.#C[gA] = W$1(this.#e[gA], this.#g[gA], IA), this.#A[gA] = Ae(this.#e[gA], IA), this.#o = this.#o || this.#e[gA].some((BA) => BA.type === 2);
        } catch {
          throw new TypeError(`invalid ${gA} pattern '${this.#B[gA]}'.`);
        }
      }
    } catch (k) {
      throw new TypeError(`Failed to construct 'URLPattern': ${k.message}`);
    }
  }
  get [Symbol.toStringTag]() {
    return "URLPattern";
  }
  test(t = {}, g) {
    let d = { pathname: "", protocol: "", username: "", password: "", hostname: "", port: "", search: "", hash: "" };
    if (typeof t != "string" && g) throw new TypeError("parameter 1 is not of type 'string'.");
    if (typeof t > "u") return !1;
    try {
      typeof t == "object" ? d = L$1(d, t, !1) : d = L$1(d, Se(t, g), !1);
    } catch {
      return !1;
    }
    let k;
    for (k of V$1) if (!this.#C[k].exec(d[k])) return !1;
    return !0;
  }
  exec(t = {}, g) {
    let d = { pathname: "", protocol: "", username: "", password: "", hostname: "", port: "", search: "", hash: "" };
    if (typeof t != "string" && g) throw new TypeError("parameter 1 is not of type 'string'.");
    if (typeof t > "u") return;
    try {
      typeof t == "object" ? d = L$1(d, t, !1) : d = L$1(d, Se(t, g), !1);
    } catch {
      return null;
    }
    let k = {};
    g ? k.inputs = [t, g] : k.inputs = [t];
    let H;
    for (H of V$1) {
      let AA = this.#C[H].exec(d[H]);
      if (!AA) return null;
      let gA = {};
      for (let [IA, CA] of this.#g[H].entries()) if (typeof CA == "string" || typeof CA == "number") {
        let BA = AA[IA + 1];
        gA[CA] = BA;
      }
      k[H] = { input: d[H] ?? "", groups: gA };
    }
    return k;
  }
  static compareComponent(t, g, d) {
    let k = a$2((IA, CA) => {
      for (let BA of ["type", "modifier", "prefix", "value", "suffix"]) {
        if (IA[BA] < CA[BA]) return -1;
        if (IA[BA] !== CA[BA])
          return 1;
      }
      return 0;
    }, "comparePart"), H = new P$1(3, "", "", "", "", 3), AA = new P$1(0, "", "", "", "", 3), gA = a$2((IA, CA) => {
      let BA = 0;
      for (; BA < Math.min(IA.length, CA.length); ++BA) {
        let eA = k(IA[BA], CA[BA]);
        if (eA) return eA;
      }
      return IA.length === CA.length ? 0 : k(IA[BA] ?? H, CA[BA] ?? H);
    }, "comparePartList");
    return !g.#A[t] && !d.#A[t] ? 0 : g.#A[t] && !d.#A[t] ? gA(g.#e[t], [AA]) : !g.#A[t] && d.#A[t] ? gA([AA], d.#e[t]) : gA(g.#e[t], d.#e[t]);
  }
  get protocol() {
    return this.#A.protocol;
  }
  get username() {
    return this.#A.username;
  }
  get password() {
    return this.#A.password;
  }
  get hostname() {
    return this.#A.hostname;
  }
  get port() {
    return this.#A.port;
  }
  get pathname() {
    return this.#A.pathname;
  }
  get search() {
    return this.#A.search;
  }
  get hash() {
    return this.#A.hash;
  }
  get hasRegExpGroups() {
    return this.#o;
  }
};
a$2(Y$2, "URLPattern");
globalThis.URLPattern || (globalThis.URLPattern = Y$2);
function isValidOrigin(n, t) {
  let g, d, k;
  try {
    g = new URLPattern(n), d = new URLPattern({
      protocol: g.protocol,
      hostname: g.hostname
    }), k = new URL(t);
  } catch {
    return !1;
  }
  return k.hostname === "localhost" && d.test(k) ? !0 : g.test(k);
}
function getCrossOriginAttribute(n, t) {
  if (t)
    try {
      const g = new URL(t);
      return window.__streamlit?.BACKEND_BASE_URL && g.origin === new URL(window.__streamlit?.BACKEND_BASE_URL).origin ? n : void 0;
    } catch {
      return window.__streamlit?.BACKEND_BASE_URL ? n : void 0;
    }
}
const useCrossOriginAttribute = (n) => {
  const {
    libConfig: t
  } = useContext(LibContext);
  if (n)
    return getCrossOriginAttribute(t.resourceCrossOriginMode, n);
};
function convertRemToEm(n) {
  return n.replace(/rem$/, "em");
}
function sharedMarkdownStyle(n) {
  return {
    a: {
      color: n.colors.link,
      textDecoration: n.linkUnderline ? "underline" : "none"
    }
  };
}
function convertFontSizes(n, t, g) {
  if (t) {
    const d = roundFontSizeToNearestEighth(parseFloat(n) * 0.65), k = `${Math.max(d, 0.75)}rem`;
    return g ? convertRemToEm(k) : k;
  }
  return g ? convertRemToEm(n) : n;
}
function getMarkdownHeadingDefinitions(n, t, g) {
  return {
    "h1, h2, h3, h4, h5, h6": {
      fontFamily: n.genericFonts.headingFont,
      lineHeight: n.lineHeights.headings,
      margin: 0,
      color: "inherit"
    },
    h1: {
      fontSize: convertFontSizes(n.fontSizes.h1FontSize, t, g),
      fontWeight: n.fontWeights.h1FontWeight,
      padding: `${n.spacing.xl} 0 ${n.spacing.lg} 0`
    },
    "h1 b, h1 strong": {
      // Per Pull Request #9395, setting text to bold in headers
      // should NOT change its font-weight
      fontWeight: n.fontWeights.h1FontWeight
    },
    "h2, h3": {
      letterSpacing: "-0.005em"
    },
    h2: {
      fontSize: convertFontSizes(n.fontSizes.h2FontSize, t, g),
      fontWeight: n.fontWeights.h2FontWeight,
      padding: `${n.spacing.lg} 0 ${n.spacing.lg} 0`
    },
    h3: {
      fontSize: convertFontSizes(n.fontSizes.h3FontSize, t, g),
      fontWeight: n.fontWeights.h3FontWeight,
      padding: `${n.spacing.md} 0 ${n.spacing.lg} 0`
    },
    h4: {
      fontSize: convertFontSizes(n.fontSizes.h4FontSize, t, g),
      fontWeight: n.fontWeights.h4FontWeight,
      padding: `${n.spacing.sm} 0 ${n.spacing.lg} 0`
    },
    h5: {
      fontSize: convertFontSizes(n.fontSizes.h5FontSize, t, g),
      fontWeight: n.fontWeights.h5FontWeight,
      padding: `${n.spacing.xs} 0 ${n.spacing.lg} 0`
    },
    h6: {
      fontSize: convertFontSizes(n.fontSizes.h6FontSize, t, g),
      fontWeight: n.fontWeights.h6FontWeight,
      padding: `${n.spacing.twoXS} 0 ${n.spacing.lg} 0`
    }
  };
}
const StyledStreamlitMarkdown = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr5"
} : {
  target: "e1nzilvr5",
  label: "StyledStreamlitMarkdown"
})(({
  theme: n,
  isCaption: t,
  isInDialog: g,
  isLabel: d,
  inheritFont: k,
  boldLabel: H,
  largerLabel: AA,
  isToast: gA
}) => {
  const IA = d && !AA || gA || t;
  return {
    fontFamily: k ? "inherit" : n.genericFonts.bodyFont,
    fontSize: k ? "inherit" : IA ? n.fontSizes.sm : n.fontSizes.md,
    marginBottom: d ? "" : `-${n.spacing.lg}`,
    opacity: t ? 0.6 : void 0,
    color: "inherit",
    // Always respect the width of the parent container:
    maxWidth: "100%",
    // Break long words to prevent them from overflowing the container:
    overflowWrap: "break-word",
    ...sharedMarkdownStyle(n),
    ...getMarkdownHeadingDefinitions(n, g, t),
    // This is required so that long Latex formulas in `st.latex` are scrollable
    // when `help` is set (see below).
    "&:has(.katex-display)": {
      overflowX: "hidden"
    },
    p: {
      wordBreak: "break-word",
      marginBottom: d ? n.spacing.none : "",
      fontWeight: k ? "inherit" : H ? n.fontWeights.bold : "",
      marginTop: n.spacing.none,
      marginLeft: n.spacing.none,
      marginRight: n.spacing.none
    },
    img: {
      // Images in markdown should never be wider
      // than the content area.
      maxWidth: "100%",
      // In labels, widgets should never be taller than the text.
      maxHeight: d ? "1em" : void 0,
      verticalAlign: "middle",
      // Ensure that images are not distorted:
      objectFit: "scale-down"
    },
    li: {
      margin: "0.2em 0 0.2em 1.15em",
      padding: "0 0 0 0.3em"
    },
    "li.task-list-item": {
      listStyleType: "none",
      padding: "0",
      marginLeft: "0",
      "input[type='checkbox']": {
        verticalAlign: "middle",
        margin: "0 0.35em 0.1em 0"
      }
    },
    // Handles quotes:
    blockquote: {
      margin: "1em 0 1em 0",
      padding: "0 0 0 0.75em",
      borderLeft: `0.15em solid ${n.colors.borderColor}`,
      opacity: 0.6
    },
    "b, strong": {
      fontWeight: n.fontWeights.bold
    },
    // Issue #11976: Handle bolded inline code
    "b code, strong code": {
      fontWeight: n.fontWeights.codeBold
    },
    // Handles the horizontal divider:
    hr: {
      margin: "2em 0",
      padding: 0,
      // Reset Firefox's gray color:
      color: "inherit",
      backgroundColor: "transparent",
      border: "none",
      borderBottom: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
      // Set correct height and prevent the size attribute
      // to make the hr look like an input field:
      "&:not([size])": {
        height: n.sizes.borderWidth
      }
    },
    table: {
      // Add some space below the markdown tables
      marginBottom: n.spacing.lg,
      // Prevent double borders
      borderCollapse: "collapse"
    },
    tr: {
      borderTop: `${n.sizes.borderWidth} solid ${n.colors.dataframeBorderColor}`
    },
    th: {
      // TODO: check whether this should be adjusted
      // defaults to font-weight: "bold" (700)
      textAlign: "inherit"
    },
    "th, td": {
      padding: `${n.spacing.xs} ${n.spacing.md}`,
      border: `${n.sizes.borderWidth} solid ${n.colors.dataframeBorderColor}`
    },
    "span.stMarkdownColoredBackground": {
      borderRadius: n.radii.md,
      padding: `${n.spacing.threeXS} ${n.spacing.twoXS}`,
      margin: n.spacing.none,
      boxDecorationBreak: "clone"
    },
    "span.stMarkdownBadge": {
      borderRadius: n.radii.md,
      // Since we're using inline-block below, we're not using vertical padding here,
      // because inline-block already makes the element look a bit taller.
      padding: `0 ${n.spacing.twoXS}`,
      // Add a small margin to separate it a bit from other text.
      margin: `0 ${n.spacing.px}`,
      // Make badges not wrap and ellipsize them if they are too long for the
      // parent container.
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
      display: "inline-block",
      verticalAlign: "middle"
    },
    "p, ol, ul, dl, li": {
      fontSize: "inherit"
    },
    // Allow long Latex formulas that are not inline (i.e. either from `st.latex`
    // or in their own paragraph inside `st.markdown`) to scroll horizontally.
    ".katex-display": {
      overflowX: "auto",
      overflowY: "hidden"
    },
    ".katex": {
      fontWeight: n.fontWeights.normal
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLinkIcon = /* @__PURE__ */ createStyled$1("a", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr4"
} : {
  target: "e1nzilvr4",
  label: "StyledLinkIcon"
})(({
  theme: n
}) => ({
  // center icon
  lineHeight: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  svg: {
    // same color as the tooltip-icon
    stroke: n.colors.fadedText60,
    strokeWidth: 2.25
  },
  "&:hover svg": {
    stroke: n.colors.bodyText
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeadingWithActionElements = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr3"
} : {
  target: "e1nzilvr3",
  label: "StyledHeadingWithActionElements"
})(({
  theme: n
}) => ({
  "h1, h2, h3, h4, h5, h6, span": {
    scrollMarginTop: n.sizes.headerHeight
  },
  ...sharedMarkdownStyle(n),
  // break-word & pretty makes most headings break in a nicer way than break-all while still
  // preventing overflowing of the container to the side. Long headings without whitespaces or hyphens might still look weird
  wordBreak: "break-word",
  textWrap: "pretty",
  // show link-icon when hovering somewhere over the heading
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  [StyledLinkIcon]: {
    visibility: "hidden"
  },
  // we have to set the hover here so that the link icon becomes visible when hovering anywhere over the heading
  "&:hover": {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
    [StyledLinkIcon]: {
      visibility: "visible"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeadingActionElements = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr2"
} : {
  target: "e1nzilvr2",
  label: "StyledHeadingActionElements"
})(({
  theme: n
}) => ({
  marginLeft: n.spacing.sm,
  display: "inline-flex",
  gap: n.spacing.sm,
  verticalAlign: "middle",
  "& > *": {
    // remove margins of inner elements as they are wrapped in a container that applies the margin
    marginLeft: "0 !important"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderDivider = /* @__PURE__ */ createStyled$1("hr", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr1"
} : {
  target: "e1nzilvr1",
  label: "StyledHeaderDivider"
})(({
  theme: n,
  rainbow: t,
  color: g
}) => ({
  // Height needs to be !important due to globalStyles.tsx hr height override - line #170
  height: `${n.spacing.threeXS} !important`,
  marginTop: n.spacing.sm,
  marginBottom: n.spacing.none,
  border: "none",
  borderRadius: n.radii.full,
  ...t ? {
    background: g
  } : {
    backgroundColor: g
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPreWrapper = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr0"
} : {
  target: "e1nzilvr0",
  label: "StyledPreWrapper"
})(({
  theme: n
}) => ({
  // Set spacing between pre-elements inside of markdown similar to our gap spacing between elements
  marginBottom: n.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var Tags = /* @__PURE__ */ ((n) => (n.H1 = "h1", n.H2 = "h2", n.H3 = "h3", n))(Tags || {});
function rehypeSetCodeInlineProperty() {
  return (n) => {
    visit$1(n, "element", (t, g, d) => {
      t.tagName === "code" && (d && d.type === "element" && d.tagName === "pre" ? t.properties = {
        ...t.properties,
        inline: !1
      } : t.properties = {
        ...t.properties,
        inline: !0
      });
    });
  };
}
function createAnchorFromText(n) {
  if (!n)
    return "";
  const t = slugify(n);
  return t.length > 0 ? t : xxhash.h32(n, 43981).toString(16);
}
function transformLinkUri(n) {
  return n;
}
const scrollNodeIntoView = once((n) => {
  n.scrollIntoView(!0);
}), HeaderActionElements = ({
  elementId: n,
  help: t,
  hideAnchor: g
}) => {
  const d = useEmotionTheme();
  return !t && g ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeadingActionElements, { "data-testid": "stHeaderActionElements", children: [
    t && /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: t }),
    n && !g && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLinkIcon, { href: `#${n}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link2, { size: convertRemToPx(d.iconSizes.base) }) })
  ] });
}, HeadingWithActionElements = ({
  tag: n,
  anchor: t,
  help: g,
  hideAnchor: d,
  children: k,
  tagProps: H
}) => {
  const AA = useContext(IsSidebarContext), gA = useContext(IsDialogContext), [IA, CA] = useState(t), BA = useCallback((EA) => {
    if (EA === null)
      return;
    const aA = t || createAnchorFromText(EA.textContent);
    CA(aA);
    const nA = window.location.hash.slice(1);
    nA && nA === aA && scrollNodeIntoView(EA);
  }, [t]), eA = AA || gA, iA = /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderActionElements, { elementId: IA, help: g, hideAnchor: d || eA }), QA = eA ? {} : {
    ref: BA,
    id: IA
  }, tA = n, oA = /* @__PURE__ */ jsxRuntimeExports.jsxs(tA, { ...H, ...QA, children: [
    k,
    iA
  ] });
  return eA ? oA : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeadingWithActionElements, { "data-testid": "stHeadingWithActionElements", children: oA });
}, CustomHeading = ({
  node: n,
  children: t,
  ...g
}) => {
  const d = g["data-anchor"];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(HeadingWithActionElements, { tag: n.tagName, anchor: d, tagProps: g, children: t });
}, CustomCodeTag = ({
  inline: n,
  className: t,
  children: g,
  ...d
}) => {
  const k = /language-(\w+)/.exec(t || ""), H = String(g).replace(/^\n/, "").replace(/\n$/, ""), AA = k?.[1] || "";
  return n ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { className: t, ...omit$1(d, "node"), children: g }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitSyntaxHighlighter$2, { language: AA, showLineNumbers: !1, children: H });
}, CustomPreTag = ({
  children: n
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPreWrapper, { "data-testid": "stMarkdownPre", children: n }), CustomMediaTag = ({
  node: n,
  ...t
}) => {
  const g = useCrossOriginAttribute(t.src), d = n.tagName, k = {
    ...t,
    crossOrigin: g
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(d, { ...k });
}, BASE_RENDERERS = {
  pre: CustomPreTag,
  code: CustomCodeTag,
  h1: CustomHeading,
  h2: CustomHeading,
  h3: CustomHeading,
  h4: CustomHeading,
  h5: CustomHeading,
  h6: CustomHeading,
  img: CustomMediaTag,
  video: CustomMediaTag,
  audio: CustomMediaTag
};
function createColorMapping(n) {
  const {
    red: t,
    orange: g,
    yellow: d,
    green: k,
    blue: H,
    violet: AA,
    purple: gA,
    gray: IA,
    primary: CA
  } = getMarkdownTextColors(n), {
    redbg: BA,
    orangebg: eA,
    yellowbg: iA,
    greenbg: QA,
    bluebg: tA,
    violetbg: oA,
    purplebg: EA,
    graybg: aA,
    primarybg: nA
  } = getMarkdownBgColors(n);
  return new Map(Object.entries({
    red: `color: ${t}`,
    orange: `color: ${g}`,
    yellow: `color: ${d}`,
    blue: `color: ${H}`,
    green: `color: ${k}`,
    violet: `color: ${AA}`,
    gray: `color: ${IA}`,
    grey: `color: ${IA}`,
    primary: `color: ${CA}`,
    // Gradient from red, orange, yellow, green, blue, violet, purple
    rainbow: `color: transparent; background-clip: text; -webkit-background-clip: text; background-image: linear-gradient(to right,
        ${t}, ${g}, ${d}, ${k}, ${H}, ${AA}, ${gA});`,
    "red-background": `background-color: ${BA}`,
    "orange-background": `background-color: ${eA}`,
    "yellow-background": `background-color: ${iA}`,
    "blue-background": `background-color: ${tA}`,
    "green-background": `background-color: ${QA}`,
    "violet-background": `background-color: ${oA}`,
    "gray-background": `background-color: ${aA}`,
    "grey-background": `background-color: ${aA}`,
    "primary-background": `background-color: ${nA}`,
    // Gradient from red, orange, yellow, green, blue, violet, purple
    "rainbow-background": `background: linear-gradient(to right,
        ${BA}, ${eA}, ${iA}, ${QA}, ${tA}, ${oA}, ${EA});`
  }));
}
function createRemarkColoringAndSmall(n, t) {
  return () => (g) => (visit$1(g, "textDirective", (d, k, H) => {
    const AA = String(d.name);
    if (AA === "small") {
      const IA = d.data || (d.data = {});
      IA.hName = "span", IA.hProperties = IA.hProperties || {}, IA.hProperties.style = `font-size: ${n.fontSizes.sm};`;
      return;
    }
    const gA = AA.match(/^(.+)-badge$/);
    if (gA && t.has(gA[1])) {
      const IA = gA[1];
      if (IA === "rainbow")
        return;
      const CA = t.get(IA), BA = t.get(`${IA}-background`);
      if (CA && BA) {
        const eA = d.data || (d.data = {});
        eA.hName = "span", eA.hProperties = eA.hProperties || {}, eA.hProperties.className = "stMarkdownBadge", eA.hProperties.style = `${BA}; ${CA}; font-size: ${n.fontSizes.sm};`;
        return;
      }
    }
    if (t.has(AA)) {
      const IA = d.data || (d.data = {}), CA = t.get(AA);
      IA.hName = "span", IA.hProperties = IA.hProperties || {}, IA.hProperties.style = CA, IA.hProperties.className = "stMarkdownColoredText", CA && (/background-color:/.test(CA) || /background:/.test(CA)) && (IA.hProperties.className = "stMarkdownColoredBackground");
      return;
    }
    d.type = "text", d.value = `:${AA}`, d.data = {};
  }), g);
}
function createRemarkMaterialIcons(n) {
  return () => (t) => {
    function g(d, k) {
      return {
        type: "text",
        value: d,
        data: {
          hName: "span",
          hProperties: {
            role: "img",
            ariaLabel: k + " icon",
            // Prevent the icon text from being translated
            // this would break the icon display in the UI.
            // https://github.com/streamlit/streamlit/issues/10168
            translate: "no",
            // We need to use string-style CSS here so that it works
            // correctly with the rehype-raw plugin.
            style: `
            display: inline-block;
            font-family: ${n.genericFonts.iconFont};
            font-weight: ${n.fontWeights.normal};
            user-select: none;
            vertical-align: bottom;
            white-space: nowrap;
            word-wrap: normal;
            `
          },
          hChildren: [{
            type: "text",
            value: k
          }]
        }
      };
    }
    return findAndReplace(t, [[/:material_(\w+):/g, g]]), t;
  };
}
function createRemarkStreamlitLogo() {
  return () => (n) => {
    function t() {
      return {
        type: "text",
        value: "",
        data: {
          hName: "img",
          hProperties: {
            src: streamlitLogo,
            alt: "Streamlit logo",
            // We need to use string-style CSS here so that it works
            // correctly with the rehype-raw plugin.
            // The base of the Streamlit logo is curved, so move it down a bit to
            // make it look aligned with the text.
            style: "display: inline-block; user-select: none; height: 0.75em; vertical-align: baseline; margin-bottom: -0.05ex;"
          }
        }
      };
    }
    return findAndReplace(n, [[/:streamlit:/g, t]]), n;
  };
}
function createRemarkTypographicalSymbols() {
  return () => (n) => (visit$1(n, (t, g, d) => {
    if (!(d && (d.type === "link" || d.type === "linkReference")) && t.type === "text" && t.value) {
      const k = [[/(^|\s)<->(\s|$)/g, "$1↔$2"], [/(^|\s)->(\s|$)/g, "$1→$2"], [/(^|\s)<-(\s|$)/g, "$1←$2"], [/(^|\s)--(\s|$)/g, "$1—$2"], [/(^|\s)>=(\s|$)/g, "$1≥$2"], [/(^|\s)<=(\s|$)/g, "$1≤$2"], [/(^|\s)~=(\s|$)/g, "$1≈$2"]];
      let H = t.value;
      for (const [AA, gA] of k)
        H = H.replace(AA, gA);
      H !== t.value && (t.value = H);
    }
  }), n);
}
const BASE_REMARK_PLUGINS = [remarkMath, plugin, remarkGfm, remarkDirective, createRemarkStreamlitLogo(), createRemarkTypographicalSymbols()], LABEL_DISALLOWED_ELEMENTS = [
  // Restricts table elements, headings, unordered/ordered lists, task lists, horizontal rules, & blockquotes
  // Note that images are allowed but have a max height equal to the text height
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "ul",
  "ol",
  "li",
  "input",
  "hr",
  "blockquote"
], LINKS_DISALLOWED_ELEMENTS = [...LABEL_DISALLOWED_ELEMENTS, "a"];
function LinkWithTargetBlank(n) {
  const {
    href: t
  } = n;
  if (t?.startsWith("#")) {
    const {
      children: gA,
      ...IA
    } = n;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { ...omit$1(IA, "node"), children: gA });
  }
  const {
    title: g,
    children: d,
    target: k,
    rel: H,
    ...AA
  } = n;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: t, title: g, target: k || "_blank", rel: H || "noopener noreferrer", ...omit$1(AA, "node"), children: d });
}
const RenderedMarkdown = memo$1(function n({
  allowHTML: t,
  source: g,
  overrideComponents: d,
  isLabel: k,
  disableLinks: H
}) {
  const AA = useEmotionTheme(), gA = useMemo$1(() => createColorMapping(AA), [AA]), IA = useMemo$1(() => [...BASE_REMARK_PLUGINS, createRemarkColoringAndSmall(AA, gA), createRemarkMaterialIcons(AA)], [AA, gA]), CA = useMemo$1(() => {
    const QA = [rehypeKatex];
    return t && QA.push(rehypeRaw), QA.push(rehypeSetCodeInlineProperty), QA;
  }, [t]), BA = useMemo$1(() => ({
    ...BASE_RENDERERS,
    a: LinkWithTargetBlank,
    ...d || {}
  }), [d]), eA = useMemo$1(() => g.replaceAll(":material/", ":material_"), [g]), iA = useMemo$1(() => k ? H ? LINKS_DISALLOWED_ELEMENTS : LABEL_DISALLOWED_ELEMENTS : [], [k, H]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Markdown$2,
    {
      remarkPlugins: IA,
      rehypePlugins: CA,
      components: BA,
      urlTransform: transformLinkUri,
      disallowedElements: iA,
      unwrapDisallowed: !0,
      children: eA
    }
  ) });
}), StreamlitMarkdown = ({
  source: n,
  allowHTML: t,
  style: g,
  isCaption: d,
  isLabel: k,
  boldLabel: H,
  largerLabel: AA,
  disableLinks: gA,
  isToast: IA,
  inheritFont: CA
}) => {
  const BA = useContext(IsDialogContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStreamlitMarkdown, { isCaption: !!d, isInDialog: BA, isLabel: k, inheritFont: CA, boldLabel: H, largerLabel: AA, isToast: IA, style: g, "data-testid": d ? "stCaptionContainer" : "stMarkdownContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(RenderedMarkdown, { source: n, allowHTML: t, isLabel: k, disableLinks: gA }) });
}, StreamlitMarkdown$1 = memo$1(StreamlitMarkdown), StyledAlertContent = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1eexb540"
} : {
  target: "e1eexb540",
  label: "StyledAlertContent"
})(({
  theme: n
}) => ({
  display: "flex",
  gap: n.spacing.sm,
  width: "100%",
  [`${StyledEmojiIcon}, ${StyledIcon}, ${StyledMaterialIcon}`]: {
    position: "relative",
    top: "2px"
  },
  [`${StyledCodeBlock} code`]: {
    paddingRight: n.spacing.lg
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function AlertElement({
  icon: n,
  body: t,
  kind: g
}) {
  const d = useEmotionTheme(), k = {
    // Fix issue #6394 - Need to account for icon size (iconSizes.lg) + gap when icon present
    width: n ? `calc(100% - (${d.iconSizes.lg} + ${d.spacing.sm}))` : "100%"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stAlert", "data-testid": "stAlert", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertContainer, { kind: g, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAlertContent, { children: [
    n && /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: n, size: "lg", testid: "stAlertDynamicIcon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: t, allowHTML: !1, style: k })
  ] }) }) });
}
const AlertElement$1 = memo$1(AlertElement);
function getAlertElementKind(n) {
  switch (n) {
    case Alert.Format.ERROR:
      return Kind.ERROR;
    case Alert.Format.INFO:
      return Kind.INFO;
    case Alert.Format.SUCCESS:
      return Kind.SUCCESS;
    case Alert.Format.WARNING:
      return Kind.WARNING;
    default:
      throw new Error(`Unexpected alert type: ${n}`);
  }
}
const pulseAnimation = keyframes`
  0%, 100% {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
  }
`, ANIMATION_STYLES = {
  animationDuration: "750ms",
  animationName: pulseAnimation,
  animationTimingFunction: "ease-in",
  animationDirection: "normal",
  animationIterationCount: "infinite"
}, StyledSkeleton = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o4"
} : {
  target: "e1lmee1o4",
  label: "StyledSkeleton"
})(({
  theme: n
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: n.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), TitleSkeleton = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o3"
} : {
  target: "e1lmee1o3",
  label: "TitleSkeleton"
})(({
  theme: n
}) => ({
  height: n.fontSizes.fourXL,
  width: `calc(${n.sizes.contentMaxWidth} * 0.37)`,
  // Picked because it looks good.
  maxWidth: "75%",
  // Picked because it looks good.
  background: n.colors.darkenedBgMix15,
  borderRadius: n.radii.default,
  ...ANIMATION_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ParagraphSkeleton = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o2"
} : {
  target: "e1lmee1o2",
  label: "ParagraphSkeleton"
})(({
  theme: n
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: n.spacing.sm
  // Picked because it looks good.
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), TextLineSkeleton = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o1"
} : {
  target: "e1lmee1o1",
  label: "TextLineSkeleton"
})(({
  theme: n,
  width: t
}) => ({
  height: n.fontSizes.md,
  width: t,
  background: n.colors.darkenedBgMix15,
  borderRadius: n.radii.default,
  ...ANIMATION_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), SquareSkeleton = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o0"
} : {
  target: "e1lmee1o0",
  label: "SquareSkeleton"
})(({
  theme: n,
  height: t,
  width: g
}) => ({
  height: t ?? n.fontSizes.fourXL,
  width: g ?? "100%",
  background: n.colors.darkenedBgMix15,
  borderRadius: n.radii.default,
  ...ANIMATION_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Ta2VsZXRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE2RThCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Ta2VsZXRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBrZXlmcmFtZXMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIlxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuY29uc3QgcHVsc2VBbmltYXRpb24gPSBrZXlmcmFtZXNgXG4gIDAlLCAxMDAlIHtcbiAgICBvcGFjaXR5OiAwLjU7XG4gIH1cblxuICA1MCUge1xuICAgIG9wYWNpdHk6IDE7XG4gIH1cbmBcblxuY29uc3QgQU5JTUFUSU9OX1NUWUxFUyA9IHtcbiAgYW5pbWF0aW9uRHVyYXRpb246IFwiNzUwbXNcIixcbiAgYW5pbWF0aW9uTmFtZTogcHVsc2VBbmltYXRpb24sXG4gIGFuaW1hdGlvblRpbWluZ0Z1bmN0aW9uOiBcImVhc2UtaW5cIixcbiAgYW5pbWF0aW9uRGlyZWN0aW9uOiBcIm5vcm1hbFwiLFxuICBhbmltYXRpb25JdGVyYXRpb25Db3VudDogXCJpbmZpbml0ZVwiLFxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2tlbGV0b24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICBnYXA6IHRoZW1lLnNwYWNpbmcubGcsXG59KSlcblxuZXhwb3J0IGNvbnN0IFRpdGxlU2tlbGV0b24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGhlaWdodDogdGhlbWUuZm9udFNpemVzLmZvdXJYTCxcbiAgd2lkdGg6IGBjYWxjKCR7dGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRofSAqIDAuMzcpYCwgLy8gUGlja2VkIGJlY2F1c2UgaXQgbG9va3MgZ29vZC5cbiAgbWF4V2lkdGg6IFwiNzUlXCIsIC8vIFBpY2tlZCBiZWNhdXNlIGl0IGxvb2tzIGdvb2QuXG4gIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgLi4uQU5JTUFUSU9OX1NUWUxFUyxcbn0pKVxuXG5leHBvcnQgY29uc3QgUGFyYWdyYXBoU2tlbGV0b24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICBnYXA6IHRoZW1lLnNwYWNpbmcuc20sIC8vIFBpY2tlZCBiZWNhdXNlIGl0IGxvb2tzIGdvb2QuXG59KSlcblxuZXhwb3J0IGludGVyZmFjZSBUZXh0TGluZVNrZWxldG9uUHJvcHMge1xuICB3aWR0aDogc3RyaW5nXG59XG5cbmV4cG9ydCBjb25zdCBUZXh0TGluZVNrZWxldG9uID0gc3R5bGVkLmRpdjxUZXh0TGluZVNrZWxldG9uUHJvcHM+KFxuICAoeyB0aGVtZSwgd2lkdGggfSkgPT4gKHtcbiAgICBoZWlnaHQ6IHRoZW1lLmZvbnRTaXplcy5tZCxcbiAgICB3aWR0aCxcbiAgICBiYWNrZ3JvdW5kOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICAuLi5BTklNQVRJT05fU1RZTEVTLFxuICB9KVxuKVxuXG5leHBvcnQgaW50ZXJmYWNlIFNxdWFyZVNrZWxldG9uUHJvcHMge1xuICBoZWlnaHQ/OiBzdHJpbmdcbiAgd2lkdGg/OiBzdHJpbmdcbn1cblxuZXhwb3J0IGNvbnN0IFNxdWFyZVNrZWxldG9uID0gc3R5bGVkLmRpdjxTcXVhcmVTa2VsZXRvblByb3BzPihcbiAgKHsgdGhlbWUsIGhlaWdodCwgd2lkdGggfSkgPT4gKHtcbiAgICBoZWlnaHQ6IGhlaWdodCA/PyB0aGVtZS5mb250U2l6ZXMuZm91clhMLFxuICAgIHdpZHRoOiB3aWR0aCA/PyBcIjEwMCVcIixcbiAgICBiYWNrZ3JvdW5kOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICAuLi5BTklNQVRJT05fU1RZTEVTLFxuICB9KVxuKVxuIl19 */"), SHOW_DELAY_MS = 500, RawAppSkeleton = () => {
  const [n, t] = useState(!1);
  return useEffect(() => {
    const g = setTimeout(() => {
      t(!0);
    }, SHOW_DELAY_MS);
    return () => {
      clearTimeout(g);
    };
  }, []), n ? /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSkeleton, { className: "stAppSkeleton", "data-testid": "stAppSkeleton", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TitleSkeleton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ParagraphSkeleton, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "98%" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "100%" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "96%" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "65%" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SquareSkeleton, { width: "75%", height: "9rem" })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}, AppSkeleton = memo$1(RawAppSkeleton), RawSkeleton = ({
  element: n
}) => n.style == Skeleton$1.SkeletonStyle.APP ? /* @__PURE__ */ jsxRuntimeExports.jsx(AppSkeleton, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(SquareSkeleton, { className: "stSkeleton", "data-testid": "stSkeleton", height: n?.height ? n.height + "px" : void 0 }), Skeleton = memo$1(RawSkeleton), COMMUNITY_URL = "https://discuss.streamlit.io", COMPONENT_DEVELOPER_URL = "https://docs.streamlit.io/develop/concepts/custom-components", CAMERA_PERMISSION_URL = "https://docs.streamlit.io/knowledge-base/using-streamlit/enable-camera", ENABLE_PERIPHERALS_DOCS_URL = "https://docs.streamlit.io/end-users/enable-peripherals", DEFAULT_IFRAME_SANDBOX_POLICY = [
  // Allows for downloads to occur without a gesture from the user.
  // Experimental; limited browser support.
  // "allow-downloads-without-user-activation",
  // Allows the resource to submit forms. If this keyword is not used, form submission is blocked.
  "allow-forms",
  // Lets the resource open modal windows.
  "allow-modals",
  // Lets the resource lock the screen orientation.
  // "allow-orientation-lock",
  // Lets the resource use the Pointer Lock API.
  // "allow-pointer-lock",
  // Allows popups (such as window.open(), target="_blank", or showModalDialog()). If this keyword is not used, the popup will silently fail to open.
  "allow-popups",
  // Lets the sandboxed document open new windows without those windows inheriting the sandboxing. For example, this can safely sandbox an advertisement without forcing the same restrictions upon the page the ad links to.
  "allow-popups-to-escape-sandbox",
  // Lets the resource start a presentation session.
  // "allow-presentation",
  // If this token is not used, the resource is treated as being from a special origin that always fails the same-origin policy.
  // From MDN:
  // "When the embedded document has the same origin as the embedding page, it is
  // strongly discouraged to use both allow-scripts and allow-same-origin, as
  // that lets the embedded document remove the sandbox attribute — making it no
  // more secure than not using the sandbox attribute at all."
  //
  // As of December 2020, we've turned the allow-same-origin flag *on* despite
  // the fact that it basically un-sandboxes us - this was a product decision
  // after lots of back and forth: ultimately, it un-blocks a number of use-cases
  // without making Streamlit Components any less secure than they actually were,
  // since we don't sandbox a Component's Python code.
  "allow-same-origin",
  // Lets the resource run scripts (but not create popup windows).
  "allow-scripts",
  // Lets the resource request access to the parent's storage capabilities with the Storage Access API.
  // Experimental; limited browser support.
  // "allow-storage-access-by-user-activation",
  // Lets the resource navigate the top-level browsing context (the one named _top).
  // "allow-top-navigation",
  // Lets the resource navigate the top-level browsing context, but only if initiated by a user gesture.
  // "allow-top-navigation-by-user-activation",
  // Lets the resource trigger downloads.
  "allow-downloads"
].join(" "), DEFAULT_IFRAME_FEATURE_POLICY = [
  // Controls whether the current document is allowed to gather information about the acceleration of the device through the Accelerometer interface.
  "accelerometer",
  // Controls whether the current document is allowed to gather information about the amount of light in the environment around the device through the AmbientLightSensor interface.
  "ambient-light-sensor",
  // Controls whether the current document is allowed to autoplay media requested through the HTMLMediaElement interface. When this policy is disabled and there were no user gestures, the Promise returned by HTMLMediaElement.play() will reject with a DOMException. The autoplay attribute on <audio> and <video> elements will be ignored.
  "autoplay",
  // Controls whether the use of the Battery Status API is allowed. When this policy is disabled, the Promise returned by Navigator.getBattery() will reject with a NotAllowedError DOMException.
  "battery",
  // Controls whether the current document is allowed to use video input devices. When this policy is disabled, the Promise returned by getUserMedia() will reject with a NotAllowedError DOMException.
  "camera",
  // Controls whether the current document is allowed to write to the clipboard. When this policy is disabled, attempts to write to the clipboard will be rejected.
  "clipboard-write",
  // Controls whether or not the current document is permitted to use the getDisplayMedia() method to capture screen contents. When this policy is disabled, the promise returned by getDisplayMedia() will reject with a NotAllowedError if permission is not obtained to capture the display's contents.
  // "display-capture",
  // Controls whether the current document is allowed to set document.domain. When this policy is disabled, attempting to set document.domain will fail and cause a SecurityError DOMException to be be thrown.
  "document-domain",
  // Controls whether the current document is allowed to use the Encrypted Media Extensions API (EME). When this policy is disabled, the Promise returned by Navigator.requestMediaKeySystemAccess() will reject with a DOMException.
  "encrypted-media",
  // Controls whether tasks should execute in frames while they're not being rendered (e.g. if an iframe is hidden or display: none).
  // "execution-while-not-rendered",
  // Controls whether tasks should execute in frames while they're outside of the visible viewport.
  // "execution-while-out-of-viewport",
  // Controls whether the current document is allowed to use Element.requestFullScreen(). When this policy is disabled, the returned Promise rejects with a TypeError DOMException.
  "fullscreen",
  // Controls whether the current document is allowed to use the Geolocation Interface. When this policy is disabled, calls to getCurrentPosition() and watchPosition() will cause those functions' callbacks to be invoked with a PositionError code of PERMISSION_DENIED.
  "geolocation",
  // Controls whether the current document is allowed to gather information about the orientation of the device through the Gyroscope interface.
  "gyroscope",
  // Controls whether the current document is allowed to show layout animations.
  "layout-animations",
  // Controls whether the current document is allowed to display images in legacy formats.
  "legacy-image-formats",
  // Controls whether the current document is allowed to gather information about the orientation of the device through the Magnetometer interface.
  "magnetometer",
  // Controls whether the current document is allowed to use audio input devices. When this policy is disabled, the Promise returned by MediaDevices.getUserMedia() will reject with a NotAllowedError.
  "microphone",
  // Controls whether the current document is allowed to use the Web MIDI API. When this policy is disabled, the Promise returned by Navigator.requestMIDIAccess() will reject with a DOMException.
  "midi",
  // Controls the availability of mechanisms that enables the page author to take control over the behavior of spatial navigation, or to cancel it outright.
  // "navigation-override",
  // Controls whether the current document is allowed to download and display large images.
  "oversized-images",
  // Controls whether the current document is allowed to use the Payment Request API. When this policy is enabled, the PaymentRequest() constructor will throw a SecurityError DOMException.
  "payment",
  // Controls whether the current document is allowed to play a video in a Picture-in-Picture mode via the corresponding API.
  "picture-in-picture",
  // Controls whether the current document is allowed to use the Web Authentication API to retrieve already stored public-key credentials, i.e. via navigator.credentials.get({publicKey: ..., ...}).
  "publickey-credentials-get",
  // Controls whether the current document is allowed to make synchronous XMLHttpRequest requests.
  "sync-xhr",
  // Controls whether the current document is allowed to use the WebUSB API.
  "usb",
  // Controls whether the current document is allowed to use the WebVR API. When this policy is disabled, the Promise returned by Navigator.getVRDisplays() will reject with a DOMException. Keep in mind that the WebVR standard is in the process of being replaced with WebXR.
  "vr ",
  // Controls whether the current document is allowed to use Wake Lock API to indicate that device should not enter power-saving mode.
  "wake-lock",
  // Controls whether or not the current document is allowed to use the WebXR Device API to interact with a WebXR session.
  "xr-spatial-tracking"
].join("; ");
var ComponentMessageType = /* @__PURE__ */ ((n) => (n.COMPONENT_READY = "streamlit:componentReady", n.SET_COMPONENT_VALUE = "streamlit:setComponentValue", n.SET_FRAME_HEIGHT = "streamlit:setFrameHeight", n))(ComponentMessageType || {}), StreamlitMessageType = /* @__PURE__ */ ((n) => (n.RENDER = "streamlit:render", n))(StreamlitMessageType || {});
const CUSTOM_COMPONENT_API_VERSION = 1, LOG$b = loglevelExports$1.getLogger("componentUtils");
function createIframeMessageHandler(n) {
  return (t, g) => {
    if (!n.current)
      return;
    const {
      isReady: d,
      element: k,
      widgetMgr: H,
      setComponentError: AA,
      componentReadyCallback: gA,
      frameHeightCallback: IA,
      fragmentId: CA
    } = n.current, BA = d();
    switch (t) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
      case ComponentMessageType.COMPONENT_READY: {
        const {
          apiVersion: eA
        } = g;
        eA !== CUSTOM_COMPONENT_API_VERSION ? AA(new Error(`Unrecognized component API version: '${eA}'`)) : gA();
        break;
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
      case ComponentMessageType.SET_COMPONENT_VALUE:
        BA ? handleSetComponentValue(tryGetValue(g, "value"), g.dataType, {
          fromUi: !0
        }, k, H, CA) : LOG$b.warn(`Got ${t} before ${ComponentMessageType.COMPONENT_READY}!`);
        break;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
      case ComponentMessageType.SET_FRAME_HEIGHT:
        BA ? IA(tryGetValue(g, "height")) : LOG$b.warn(`Got ${t} before ${ComponentMessageType.COMPONENT_READY}!`);
        break;
      default:
        LOG$b.warn(`Unrecognized ComponentBackMsgType: ${t}`);
    }
  };
}
function parseArgs(n, t) {
  const g = JSON.parse(n), d = [];
  for (const k of t) {
    const {
      key: H
    } = k;
    switch (k.value?.toLowerCase()) {
      case "arrowdataframe":
        d.push({
          key: H,
          value: ArrowDataframe.toObject(k.arrowDataframe)
        });
        break;
      case "bytes":
        g[H] = k.bytes;
        break;
      default:
        throw new Error(`Unrecognized SpecialArg type: ${k.value}`);
    }
  }
  return [g, d];
}
function sendRenderMessage(n, t, g, d, k) {
  if (!k) {
    LOG$b.warn("Can't send ForwardMsg; missing our iframe!");
    return;
  }
  if (isNullOrUndefined$1(k.contentWindow)) {
    LOG$b.warn("Can't send ForwardMsg; iframe has no contentWindow!");
    return;
  }
  k.contentWindow.postMessage({
    type: StreamlitMessageType.RENDER,
    args: n,
    dfs: t,
    disabled: g,
    theme: {
      ...toExportedTheme(d),
      // TODO(lukasmasuch): adds backwards compatibility for the deprecated font
      // property. Should be cleaned-up at some point when we revamp custom components.
      font: d.genericFonts.bodyFont
    }
  }, "*");
}
function handleSetComponentValue(n, t, g, d, k, H) {
  if (n === void 0) {
    LOG$b.warn("handleSetComponentValue: missing 'value' prop");
    return;
  }
  switch (t) {
    case "dataframe":
      k.setArrowValue(d, n, g, H);
      break;
    case "bytes":
      k.setBytesValue(d, n, g, H);
      break;
    default:
      k.setJsonValue(d, n, g, H);
  }
}
function tryGetValue(n, t, g = void 0) {
  return Object.hasOwn(n, t) ? n[t] : g;
}
const StyledComponentIframe = /* @__PURE__ */ createStyled$1("iframe", process.env.NODE_ENV === "production" ? {
  target: "e1fjvnnc0"
} : {
  target: "e1fjvnnc0",
  label: "StyledComponentIframe"
})(({
  theme: n,
  componentReady: t
}) => ({
  colorScheme: "normal",
  border: "none",
  padding: n.spacing.none,
  margin: n.spacing.none,
  display: t ? "initial" : "none"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy93aWRnZXRzL0N1c3RvbUNvbXBvbmVudC9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQnFDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy93aWRnZXRzL0N1c3RvbUNvbXBvbmVudC9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5pbnRlcmZhY2UgU3R5bGVkQ29tcG9uZW50SWZyYW1lUHJvcHMge1xuICBjb21wb25lbnRSZWFkeTogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQ29tcG9uZW50SWZyYW1lID0gc3R5bGVkLmlmcmFtZTxTdHlsZWRDb21wb25lbnRJZnJhbWVQcm9wcz4oXG4gICh7IHRoZW1lLCBjb21wb25lbnRSZWFkeSB9KSA9PiAoe1xuICAgIGNvbG9yU2NoZW1lOiBcIm5vcm1hbFwiLFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpbjogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIGRpc3BsYXk6IGNvbXBvbmVudFJlYWR5ID8gXCJpbml0aWFsXCIgOiBcIm5vbmVcIixcbiAgfSlcbilcbiJdfQ== */"), LOG$a = loglevelExports$1.getLogger("ComponentInstance"), COMPONENT_READY_WARNING_TIME_MS = 6e4;
function getSrc(n, t, g) {
  let d;
  notNullOrUndefined(g) && g !== "" ? d = g : d = t.getComponentURL(n, "index.html");
  const k = window.__streamlit?.CUSTOM_COMPONENT_CLIENT_ID, H = new URL(window.location.href);
  return d = queryString.stringifyUrl({
    url: d,
    query: {
      streamlitUrl: H.origin + H.pathname,
      ...k && {
        __streamlit_parent_client_id: k
      }
    }
  }), d;
}
function getWarnMessage(n, t) {
  let g;
  return t && t !== "" ? g = `Your app is having trouble loading the **${n}** component.
The app is attempting to load the component from **${t}**,
and hasn't received its \`Streamlit.setComponentReady()\` message.

If this is a development build, have you started the dev server?

For more troubleshooting help, please see the [Streamlit Component docs](${COMPONENT_DEVELOPER_URL}) or visit our [forums](${COMMUNITY_URL}).` : g = `Your app is having trouble loading the **${n}** component.

If this is an installed component that works locally, the app may be having trouble accessing the component frontend assets due to network latency or proxy settings in your app deployment.

For more troubleshooting help, please see the [Streamlit Component docs](${COMPONENT_DEVELOPER_URL}) or visit our [forums](${COMMUNITY_URL}).`, g;
}
function tryParseArgs(n, t, g, d) {
  if (!d)
    try {
      return parseArgs(n, t);
    } catch (k) {
      const H = ensureError(k);
      g(H);
    }
  return [{}, []];
}
function compareDataframeArgs(n, t) {
  return n === t || n.length === t.length && n.every((g, d) => {
    const k = t[d];
    return g.key === k.key && g.value === k.value;
  });
}
function ComponentInstance(n) {
  const t = useEmotionTheme(), {
    componentRegistry: g
  } = useContext(LibContext), [d, k] = useState(), {
    disabled: H,
    element: AA,
    widgetMgr: gA,
    width: IA,
    fragmentId: CA
  } = n, {
    componentName: BA,
    jsonArgs: eA,
    specialArgs: iA,
    url: QA
  } = AA, [tA, oA] = tryParseArgs(eA, iA, k, d), EA = useMemo$1(() => getSrc(BA, g, QA), [BA, g, QA]), aA = useRef({
    args: {},
    dataframeArgs: []
  }), nA = compareDataframeArgs(aA.current.dataframeArgs, oA);
  aA.current.args = tA, aA.current.dataframeArgs = oA;
  const [lA, cA] = useState(), [sA, rA] = useState(() => isNaN(tA.height) ? void 0 : tA.height), uA = useRef(!1), hA = useRef(null), dA = useRef(), {
    clear: GA
  } = useTimeout(() => LOG$a.warn(getWarnMessage(BA, QA)), COMPONENT_READY_WARNING_TIME_MS / 4), {
    clear: DA
  } = useTimeout(() => {
    flushSync(() => {
      cA(!0);
    });
  }, COMPONENT_READY_WARNING_TIME_MS);
  if (useEffect(() => {
    g.checkSourceUrlResponse(EA, BA);
  }, [EA, BA, g]), useEffect(() => {
    lA && !uA.current && (LOG$a.error(`Client Error: Custom Component ${BA} timeout error`), g.sendTimeoutError(EA, BA));
  }, [lA, EA, BA, g]), useEffect(() => {
    uA.current && sendRenderMessage(aA.current.args, aA.current.dataframeArgs, H, t, hA.current ?? void 0);
  }, [H, sA, nA, eA, t, IA]), useEffect(() => {
    const yA = (MA) => {
      if (MA === void 0) {
        LOG$a.warn("handleSetFrameHeight: missing 'height' prop");
        return;
      }
      if (MA !== sA) {
        if (isNullOrUndefined$1(hA.current)) {
          LOG$a.warn("handleSetFrameHeight: missing our iframeRef!");
          return;
        }
        hA.current.height = MA.toString(), flushSync(() => {
          rA(MA);
        });
      }
    }, pA = () => {
      sendRenderMessage(aA.current.args, aA.current.dataframeArgs, H, t, hA.current ?? void 0), GA(), DA(), uA.current = !0, flushSync(() => {
        cA(!1);
      });
    };
    dA.current = {
      // isReady is a callback to ensure the caller receives the latest value
      isReady: () => uA.current,
      element: AA,
      widgetMgr: gA,
      setComponentError: k,
      componentReadyCallback: pA,
      frameHeightCallback: yA,
      fragmentId: CA
    };
  }, [BA, H, AA, sA, nA, lA, eA, t, gA, DA, GA, CA]), useEffect(() => {
    const yA = hA.current?.contentWindow ?? void 0;
    if (yA)
      return g.registerListener(yA, createIframeMessageHandler(dA)), () => {
        yA && g.deregisterListener(yA);
      };
  }, [g, BA]), d)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorElement, { name: d.name, message: d.message });
  const wA = !uA.current && !lA && // if height is explicitly set to 0, we don’t want to show the skeleton at all
  sA !== 0 && // Skeletons will have a default height if no frameHeight was specified
  /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: Skeleton$1.create({
    height: sA,
    style: Skeleton$1.SkeletonStyle.ELEMENT
  }) }), bA = (
    // TODO: Update to match React best practices
    !uA.current && lA ? /* @__PURE__ */ jsxRuntimeExports.jsx(AlertElement$1, { body: getWarnMessage(BA, QA), kind: Kind.WARNING }) : null
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    wA,
    bA,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CustomComponentIFrame,
      {
        IframeComponent: StyledComponentIframe,
        className: "stCustomComponentV1",
        "data-testid": "stCustomComponentV1",
        allow: DEFAULT_IFRAME_FEATURE_POLICY,
        ref: hA,
        src: EA,
        width: IA,
        height: sA ?? 0,
        scrolling: "no",
        sandbox: DEFAULT_IFRAME_SANDBOX_POLICY,
        title: BA,
        componentReady: uA.current,
        tabIndex: AA.tabIndex ?? void 0
      }
    )
  ] });
}
const ComponentInstance$1 = withCalculatedWidth(memo$1(ComponentInstance)), LOG$9 = loglevelExports$1.getLogger("ComponentRegistry");
class ComponentRegistry {
  constructor(t) {
    this.msgListeners = /* @__PURE__ */ new Map(), this.registerListener = (g, d) => {
      this.msgListeners.has(g) && LOG$9.warn("MessageEventSource registered multiple times!", g), this.msgListeners.set(g, d);
    }, this.deregisterListener = (g) => {
      this.msgListeners.delete(g) || LOG$9.warn("Could not deregister unregistered MessageEventSource!");
    }, this.checkSourceUrlResponse = (g, d) => this.endpoints.checkSourceUrlResponse(g, "Custom Component", d), this.sendTimeoutError = (g, d) => {
      this.endpoints.sendClientErrorToHost("Custom Component", "Request Timeout", "Your app is having trouble loading the component.", g, d);
    }, this.getComponentURL = (g, d) => this.endpoints.buildComponentURL(g, d), this.onMessageEvent = (g) => {
      if (isNullOrUndefined$1(g.data) || !Object.hasOwn(g.data, "isStreamlitMessage"))
        return;
      if (isNullOrUndefined$1(g.source)) {
        LOG$9.warn("Received component message with no eventSource!", g.data);
        return;
      }
      const d = this.msgListeners.get(g.source);
      if (isNullOrUndefined$1(d) || typeof d != "function") {
        LOG$9.warn("Received component message for unregistered ComponentInstance!", g.data);
        return;
      }
      const {
        type: k
      } = g.data;
      if (isNullOrUndefined$1(k)) {
        LOG$9.warn("Received Streamlit message with no type!", g.data);
        return;
      }
      d(k, g.data);
    }, this.endpoints = t, window.addEventListener("message", this.onMessageEvent);
  }
}
var ScriptRunState = /* @__PURE__ */ ((n) => (n.NOT_RUNNING = "notRunning", n.RUNNING = "running", n.RERUN_REQUESTED = "rerunRequested", n.STOP_REQUESTED = "stopRequested", n.COMPILATION_ERROR = "compilationError", n))(ScriptRunState || {});
const noOpEndpoints = {
  setStaticConfigUrl: () => {
  },
  sendClientErrorToHost: () => {
  },
  checkSourceUrlResponse: () => Promise.resolve(),
  buildComponentURL: () => "",
  buildMediaURL: () => "",
  buildDownloadUrl: () => "",
  buildFileUploadURL: () => "",
  buildAppPageURL: () => "",
  uploadFileUploaderFile: () => Promise.reject(new Error("unimplemented endpoint")),
  deleteFileAtURL: () => Promise.reject(new Error("unimplemented endpoint"))
}, LibContext = createContext({
  isFullScreen: !1,
  setFullScreen: () => {
  },
  addScriptFinishedHandler: () => {
  },
  removeScriptFinishedHandler: () => {
  },
  activeTheme: baseTheme,
  setTheme: () => {
  },
  availableThemes: [],
  addThemes: () => {
  },
  onPageChange: () => {
  },
  currentPageScriptHash: "",
  libConfig: {},
  fragmentIdsThisRun: [],
  locale: window.navigator.language,
  scriptRunState: ScriptRunState.NOT_RUNNING,
  scriptRunId: "",
  // This should be overwritten
  componentRegistry: new ComponentRegistry(noOpEndpoints)
});
LibContext.displayName = "LibContext";
var _excluded$j = ["children", "iconAttrs", "iconVerticalAlign", "iconViewBox", "size", "title"];
function ownKeys$f(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$d(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$f(Object(g), !0).forEach(function(d) {
      _defineProperty$q(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$f(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
var EmotionIconBaseBase = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = n.children, d = n.iconAttrs;
  n.iconVerticalAlign;
  var k = n.iconViewBox, H = n.size, AA = n.title, gA = _objectWithoutProperties$j(n, _excluded$j), IA = _objectSpread$d(_objectSpread$d({
    viewBox: k,
    height: n.height !== void 0 ? n.height : H,
    width: n.width !== void 0 ? n.width : H,
    "aria-hidden": AA == null ? "true" : void 0,
    focusable: "false",
    role: AA != null ? "img" : void 0
  }, d), gA);
  return /* @__PURE__ */ React.createElement("svg", _extends$M({}, IA, {
    ref: t
  }), AA && /* @__PURE__ */ React.createElement("title", {
    key: "icon-title"
  }, AA), g);
}), EmotionIconBase = /* @__PURE__ */ createStyled$1(EmotionIconBaseBase, process.env.NODE_ENV === "production" ? {
  target: "ex0cdmw0"
} : {
  target: "ex0cdmw0",
  label: "EmotionIconBase"
})("display:inline-block;vertical-align:", function(n) {
  return n.iconVerticalAlign;
}, ";overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), AccessibilityNew = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
  }));
});
AccessibilityNew.displayName = "AccessibilityNew";
var AccessibleForward = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("circle", {
    cx: 18,
    cy: 4.54,
    r: 2
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M15 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C18.42 8.5 17.44 7 15.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L8.22 10l1.92.53.65-1.53H13l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H18v5h2v-5.5c0-1.1-.9-2-2-2z"
  }));
});
AccessibleForward.displayName = "AccessibleForward";
var ArrowDownward = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
  }));
});
ArrowDownward.displayName = "ArrowDownward";
var ArrowUpward = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
  }));
});
ArrowUpward.displayName = "ArrowUpward";
var Check = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
  }));
});
Check.displayName = "Check";
var DirectionsBike = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
  }));
});
DirectionsBike.displayName = "DirectionsBike";
var DirectionsRun = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
  }));
});
DirectionsRun.displayName = "DirectionsRun";
var ExpandLess = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"
  }));
});
ExpandLess.displayName = "ExpandLess";
var ExpandMore = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M24 24H0V0h24v24z",
    opacity: 0.87
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"
  }));
});
ExpandMore.displayName = "ExpandMore";
var Face = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M10.25 13a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM15 11.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm7 .25c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zM10.66 4.12C12.06 6.44 14.6 8 17.5 8c.46 0 .91-.05 1.34-.12C17.44 5.56 14.9 4 12 4c-.46 0-.91.05-1.34.12zM4.42 9.47a8.046 8.046 0 003.66-4.44 8.046 8.046 0 00-3.66 4.44zM20 12c0-.78-.12-1.53-.33-2.24-.7.15-1.42.24-2.17.24a10 10 0 01-7.76-3.69A10.016 10.016 0 014 11.86c.01.04 0 .09 0 .14 0 4.41 3.59 8 8 8s8-3.59 8-8z"
  }));
});
Face.displayName = "Face";
var KeyboardArrowDown = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
  }));
});
KeyboardArrowDown.displayName = "KeyboardArrowDown";
var KeyboardArrowUp = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
  }));
});
KeyboardArrowUp.displayName = "KeyboardArrowUp";
var Pool = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M10 8l-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36s.78-.13 1.15-.36c.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.55 0 .78-.13 1.15-.36.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1zm12 8.5h-.02.02zm-16.65-1c.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.06.63 2.16.64v-2c-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.2-.64.37-.23.6-.36 1.15-.36zM18.67 18c-1.11 0-1.73.37-2.18.64-.37.23-.6.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36s-.78-.13-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.19-.64.37-.23.6-.36 1.15-.36.55 0 .78.13 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.19-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.72-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64v-2c-.56 0-.78-.13-1.15-.36-.45-.27-1.07-.64-2.18-.64z"
  }), /* @__PURE__ */ React.createElement("circle", {
    cx: 16.5,
    cy: 5.5,
    r: 2.5
  }));
});
Pool.displayName = "Pool";
var Rowing = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
  }));
});
Rowing.displayName = "Rowing";
var SmartToy = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zm-2 10H6V7h12v12zm-9-6c-.83 0-1.5-.67-1.5-1.5S8.17 10 9 10s1.5.67 1.5 1.5S9.83 13 9 13zm7.5-1.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zM8 15h8v2H8v-2z"
  }));
});
SmartToy.displayName = "SmartToy";
const StyledChatMessageContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq4"
} : {
  target: "eeusbqq4",
  label: "StyledChatMessageContainer"
})(({
  theme: n,
  background: t
}) => {
  const g = hasLightBackgroundColor(n);
  return {
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    gap: n.spacing.sm,
    padding: n.spacing.lg,
    paddingRight: t ? n.spacing.lg : 0,
    borderRadius: n.radii.default,
    ...t ? {
      backgroundColor: transparentize(g ? n.colors.gray20 : n.colors.gray90, 0.5)
    } : {}
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMessageContent = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq3"
} : {
  target: "eeusbqq3",
  label: "StyledMessageContent"
})(({
  theme: n
}) => ({
  color: n.colors.bodyText,
  margin: "auto",
  flexGrow: 1,
  // Ensure the size of the message has an interpreted width as
  // the amount defined by flex layout and disregard its contents
  // they will handle their overflow.
  //
  // Unintuitively, setting the min width to 0 tells the browser
  // that it can shrink past the content's width to the desired size.
  // https://makandracards.com/makandra/66994-css-flex-and-min-width
  minWidth: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAvatarBackground = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq2"
} : {
  target: "eeusbqq2",
  label: "StyledAvatarBackground"
})(({
  theme: n
}) => {
  const t = hasLightBackgroundColor(n);
  return {
    display: "flex",
    border: `${n.sizes.borderWidth} solid ${t ? n.colors.gray40 : n.colors.gray85}`,
    backgroundColor: t ? n.colors.white : n.colors.gray100,
    color: t ? n.colors.gray90 : n.colors.white,
    lineHeight: n.lineHeights.none,
    fontSize: n.fontSizes.md,
    // Ensure the avatar always respects the width/height
    flexShrink: 0,
    width: n.sizes.chatAvatarSize,
    height: n.sizes.chatAvatarSize,
    borderRadius: n.radii.default,
    alignItems: "center",
    justifyContent: "center"
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAvatarIcon = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq1"
} : {
  target: "eeusbqq1",
  label: "StyledAvatarIcon"
})(({
  theme: n,
  background: t
}) => {
  const g = hasLightBackgroundColor(n);
  return {
    display: "flex",
    width: n.sizes.chatAvatarSize,
    height: n.sizes.chatAvatarSize,
    // Ensure the avatar always respects the width/height
    flexShrink: 0,
    borderRadius: n.radii.default,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: t,
    color: g ? n.colors.white : n.colors.gray100
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAvatarImage = /* @__PURE__ */ createStyled$1("img", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq0"
} : {
  target: "eeusbqq0",
  label: "StyledAvatarImage"
})(({
  theme: n
}) => ({
  width: n.sizes.chatAvatarSize,
  height: n.sizes.chatAvatarSize,
  // Ensure the avatar always respects the width/height
  flexShrink: 0,
  borderRadius: n.radii.default,
  objectFit: "cover",
  display: "flex"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function ChatMessageAvatar(n) {
  const {
    avatar: t,
    avatarType: g,
    name: d,
    endpoints: k
  } = n, H = useEmotionTheme(), AA = useCrossOriginAttribute(t);
  if (t)
    switch (g) {
      case Block$2.ChatMessage.AvatarType.IMAGE:
        return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarImage, { src: k.buildMediaURL(t), alt: `${d} avatar`, crossOrigin: AA });
      case Block$2.ChatMessage.AvatarType.EMOJI:
        return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarBackground, { children: t });
      case Block$2.ChatMessage.AvatarType.ICON:
        if (t === "user")
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarIcon, { "data-testid": "stChatMessageAvatarUser", background: H.colors.redColor, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { content: Face, size: "lg" }) });
        if (t === "assistant")
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarIcon, { "data-testid": "stChatMessageAvatarAssistant", background: H.colors.orangeColor, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { content: SmartToy, size: "lg" }) });
        if (t.startsWith(":material"))
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarBackground, { "data-testid": "stChatMessageAvatarCustom", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: t, color: H.colors.bodyText }) });
    }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarBackground, { children: d ? d.charAt(0).toUpperCase() : "🧑‍💻" });
}
const ChatMessage = ({
  endpoints: n,
  element: t,
  children: g
}) => {
  const {
    avatar: d,
    avatarType: k,
    name: H
  } = t;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledChatMessageContainer, { className: "stChatMessage", "data-testid": "stChatMessage", background: ["user", "human"].includes(H.toLowerCase()), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChatMessageAvatar, { name: H, avatar: d, avatarType: k, endpoints: n }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMessageContent, { "data-testid": "stChatMessageContent", "aria-label": `Chat message from ${H}`, children: g })
  ] });
}, ChatMessage$1 = memo$1(ChatMessage);
var SIZE$4 = {
  default: "default",
  full: "full",
  auto: "auto"
}, SIZE_WIDTHS = {
  default: "500px",
  full: "100%",
  auto: "auto"
}, ROLE = {
  dialog: "dialog"
}, CLOSE_SOURCE = {
  closeButton: "closeButton",
  backdrop: "backdrop",
  escape: "escape"
};
function ownKeys$e(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$c(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$e(Object(g), !0).forEach(function(d) {
      _defineProperty$i(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$e(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$i(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function getSizeStyles(n) {
  var t = {
    maxWidth: "100%",
    width: null
  };
  return typeof n == "number" ? t.width = "".concat(n, "px") : SIZE$4[n] ? t.width = SIZE_WIDTHS[n] : typeof n == "string" && (t.width = n), n === SIZE$4.full && (t.alignSelf = "stretch"), t;
}
var Root$2 = styled("div", function(n) {
  var t = n.$isOpen;
  return {
    position: "fixed",
    overflow: "auto",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    pointerEvents: t ? "auto" : "none"
  };
});
Root$2.displayName = "Root";
Root$2.displayName = "Root";
var DialogContainer = styled("div", function(n) {
  var t = n.$animate, g = n.$isOpen, d = n.$isVisible, k = n.$theme, H = {
    transitionProperty: "opacity",
    transitionDuration: k.animation.timing400,
    transitionTimingFunction: k.animation.easeOutCurve
  };
  return _objectSpread$c({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "100%",
    userSelect: "none",
    pointerEvents: "auto",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    // Remove grey highlight
    WebkitTapHighlightColor: "transparent",
    opacity: d && g ? 1 : 0
  }, t ? H : null);
});
DialogContainer.displayName = "DialogContainer";
DialogContainer.displayName = "DialogContainer";
var Dialog$2 = styled("div", function(n) {
  var t = n.$animate, g = n.$isOpen, d = n.$isVisible, k = n.$size, H = n.$theme;
  return _objectSpread$c(_objectSpread$c(_objectSpread$c({
    position: "relative",
    backgroundColor: H.colors.backgroundPrimary,
    borderTopLeftRadius: H.borders.radius500,
    borderTopRightRadius: H.borders.radius500,
    borderBottomRightRadius: H.borders.radius500,
    borderBottomLeftRadius: H.borders.radius500,
    marginLeft: H.sizing.scale600,
    marginTop: H.sizing.scale600,
    marginRight: H.sizing.scale600,
    marginBottom: H.sizing.scale600
  }, getSizeStyles(k)), {}, {
    // Animation
    opacity: d && g ? 1 : 0,
    transform: d ? "translateY(0)" : "translateY(20px)"
  }, t ? {
    transitionProperty: "opacity, transform",
    transitionDuration: H.animation.timing400,
    transitionTimingFunction: H.animation.easeOutCurve
  } : null), {}, {
    // Reset interactivity properties set by container
    userSelect: "text",
    pointerEvents: g ? "all" : "none",
    // We move focus to the modal, but we don't want the blue outline style
    ":focus": {
      outline: "none"
    }
  });
});
Dialog$2.displayName = "Dialog";
Dialog$2.displayName = "Dialog";
var Close = styled("button", function(n) {
  var t, g = n.$theme, d = n.$isFocusVisible, k = g.direction === "rtl" ? "left" : "right";
  return t = {
    // Reset button styles
    background: "transparent",
    outline: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    // colors
    color: g.colors.modalCloseColor,
    transitionProperty: "color, border-color",
    transitionDuration: g.animation.timing200,
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderTopWidth: "1px",
    borderBottomWidth: "1px",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    borderTopColor: "transparent",
    borderBottomColor: "transparent",
    ":hover": {
      color: g.colors.modalCloseColorHover
    },
    ":focus": {
      outline: d ? "3px solid ".concat(g.colors.accent) : "none"
    },
    // Positioning
    position: "absolute",
    top: g.sizing.scale500
  }, _defineProperty$i(t, k, g.sizing.scale500), _defineProperty$i(t, "width", g.sizing.scale800), _defineProperty$i(t, "height", g.sizing.scale800), _defineProperty$i(t, "display", "flex"), _defineProperty$i(t, "justifyContent", "center"), _defineProperty$i(t, "alignItems", "center"), _defineProperty$i(t, "cursor", "pointer"), t;
});
Close.displayName = "Close";
Close.displayName = "Close";
var ModalHeader$1 = styled("div", function(n) {
  var t, g = n.$theme, d = g.direction === "rtl" ? "marginRight" : "marginLeft", k = g.direction === "rtl" ? "marginLeft" : "marginRight";
  return _objectSpread$c(_objectSpread$c({}, g.typography.font550), {}, (t = {
    color: g.colors.contentPrimary,
    marginTop: g.sizing.scale900,
    marginBottom: g.sizing.scale600
  }, _defineProperty$i(t, d, g.sizing.scale800), _defineProperty$i(t, k, g.sizing.scale900), t));
});
ModalHeader$1.displayName = "ModalHeader";
ModalHeader$1.displayName = "ModalHeader";
var ModalBody$2 = styled("div", function(n) {
  var t = n.$theme;
  return _objectSpread$c(_objectSpread$c({}, t.typography.font200), {}, {
    color: t.colors.contentSecondary,
    marginTop: t.sizing.scale600,
    marginLeft: t.sizing.scale800,
    marginRight: t.sizing.scale800,
    marginBottom: t.sizing.scale700
  });
});
ModalBody$2.displayName = "ModalBody";
ModalBody$2.displayName = "ModalBody";
var ModalFooter$1 = styled("div", function(n) {
  var t = n.$theme;
  return _objectSpread$c(_objectSpread$c({}, t.typography.font200), {}, {
    marginTop: t.sizing.scale700,
    marginLeft: t.sizing.scale800,
    marginRight: t.sizing.scale800,
    paddingTop: t.sizing.scale500,
    paddingBottom: t.sizing.scale500,
    textAlign: t.direction === "rtl" ? "left" : "right"
  });
});
ModalFooter$1.displayName = "ModalFooter";
ModalFooter$1.displayName = "ModalFooter";
function CloseIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    style: {
      stroke: "currentColor"
    },
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M9 1L5 5M1 9L5 5M5 5L1 1M5 5L9 9",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
}
function _typeof$9(n) {
  "@babel/helpers - typeof";
  return _typeof$9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$9(n);
}
function _extends$t() {
  return _extends$t = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$t.apply(this, arguments);
}
function _slicedToArray$g(n, t) {
  return _arrayWithHoles$f(n) || _iterableToArrayLimit$f(n, t) || _unsupportedIterableToArray$f(n, t) || _nonIterableRest$f();
}
function _nonIterableRest$f() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$f(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$f(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$f(n, t);
  }
}
function _arrayLikeToArray$f(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$f(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$f(n) {
  if (Array.isArray(n)) return n;
}
function _classCallCheck$e(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$6(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$e(n, t, g) {
  return t && _defineProperties$6(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$e(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$6(n, t);
}
function _setPrototypeOf$6(n, t) {
  return _setPrototypeOf$6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$6(n, t);
}
function _createSuper$6(n) {
  var t = _isNativeReflectConstruct$6();
  return function() {
    var d = _getPrototypeOf$6(n), k;
    if (t) {
      var H = _getPrototypeOf$6(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$e(this, k);
  };
}
function _possibleConstructorReturn$e(n, t) {
  if (t && (_typeof$9(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$6(n);
}
function _assertThisInitialized$6(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$6() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$6(n) {
  return _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$6(n);
}
function _defineProperty$h(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var Modal$1 = /* @__PURE__ */ (function(n) {
  _inherits$e(g, n);
  var t = _createSuper$6(g);
  function g() {
    var d;
    _classCallCheck$e(this, g);
    for (var k = arguments.length, H = new Array(k), AA = 0; AA < k; AA++)
      H[AA] = arguments[AA];
    return d = t.call.apply(t, [this].concat(H)), _defineProperty$h(_assertThisInitialized$6(d), "animateOutTimer", void 0), _defineProperty$h(_assertThisInitialized$6(d), "animateStartTimer", void 0), _defineProperty$h(_assertThisInitialized$6(d), "dialogContainerRef", /* @__PURE__ */ React.createRef()), _defineProperty$h(_assertThisInitialized$6(d), "lastFocus", null), _defineProperty$h(_assertThisInitialized$6(d), "lastMountNodeOverflowStyle", null), _defineProperty$h(_assertThisInitialized$6(d), "rootRef", /* @__PURE__ */ React.createRef()), _defineProperty$h(_assertThisInitialized$6(d), "state", {
      isVisible: !1,
      mounted: !1,
      isFocusVisible: !1
    }), _defineProperty$h(_assertThisInitialized$6(d), "handleFocus", function(gA) {
      isFocusVisible(gA) && d.setState({
        isFocusVisible: !0
      });
    }), _defineProperty$h(_assertThisInitialized$6(d), "handleBlur", function(gA) {
      d.state.isFocusVisible !== !1 && d.setState({
        isFocusVisible: !1
      });
    }), _defineProperty$h(_assertThisInitialized$6(d), "onEscape", function() {
      d.props.closeable && d.triggerClose(CLOSE_SOURCE.escape);
    }), _defineProperty$h(_assertThisInitialized$6(d), "onDocumentClick", function(gA) {
      gA.target && gA.target instanceof HTMLElement && gA.target.contains(d.dialogContainerRef.current) && d.onBackdropClick();
    }), _defineProperty$h(_assertThisInitialized$6(d), "onBackdropClick", function() {
      d.props.closeable && d.triggerClose(CLOSE_SOURCE.backdrop);
    }), _defineProperty$h(_assertThisInitialized$6(d), "onCloseClick", function() {
      d.triggerClose(CLOSE_SOURCE.closeButton);
    }), _defineProperty$h(_assertThisInitialized$6(d), "animateOutComplete", function() {
      d.setState({
        isVisible: !1
      });
    }), d;
  }
  return _createClass$e(g, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        mounted: !0
      }), process.env.NODE_ENV !== "production" && this.props.closable && console.warn("The property `closable` is not supported on the Modal. Did you mean `closeable`?");
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.resetMountNodeScroll(), this.clearTimers();
    }
  }, {
    key: "componentDidUpdate",
    value: function(k, H) {
      var AA = this.props.isOpen;
      // If isOpen is changing *or* we just mounted and modal should be open
      (AA !== k.isOpen || AA && this.state.mounted && !H.mounted) && (AA ? this.didOpen() : this.didClose());
    }
  }, {
    key: "disableMountNodeScroll",
    value: function() {
      var k = this.getMountNode();
      this.lastMountNodeOverflowStyle = k.style.overflow || "", k.style.overflow = "hidden";
    }
  }, {
    key: "resetMountNodeScroll",
    value: function() {
      var k = this.getMountNode(), H = this.lastMountNodeOverflowStyle;
      k && H !== null && (k.style.overflow === "hidden" && (k.style.overflow = H || ""), this.lastMountNodeOverflowStyle = null);
    }
  }, {
    key: "clearTimers",
    value: function() {
      this.animateOutTimer && clearTimeout(this.animateOutTimer), this.animateStartTimer && cancelAnimationFrame(this.animateStartTimer);
    }
  }, {
    key: "didOpen",
    value: function() {
      var k = this, H = this.rootRef.current;
      H && (H.scrollTop = 0), this.clearTimers(), this.disableMountNodeScroll(), this.animateStartTimer = requestAnimationFrame(function() {
        k.setState({
          isVisible: !0
        });
      });
    }
  }, {
    key: "didClose",
    value: function() {
      this.resetMountNodeScroll(), this.animateOutTimer = setTimeout(this.animateOutComplete, 500);
    }
  }, {
    key: "triggerClose",
    value: function(k) {
      this.props.onClose && k && this.props.onClose({
        closeSource: k
      });
    }
  }, {
    key: "getSharedProps",
    value: function() {
      var k = this.props, H = k.animate, AA = k.isOpen, gA = k.size, IA = k.role, CA = k.closeable;
      return {
        $animate: H,
        $isVisible: this.state.isVisible,
        $isOpen: !!AA,
        $size: gA,
        $role: IA,
        $closeable: !!CA,
        $isFocusVisible: this.state.isFocusVisible
      };
    }
  }, {
    key: "getMountNode",
    value: function() {
      var k = this.props.mountNode;
      return k || document.body;
    }
  }, {
    key: "getChildren",
    value: function() {
      var k = this.props.children;
      return typeof k == "function" ? k() : k;
    }
  }, {
    key: "renderModal",
    value: function() {
      var k = this, H = this.props, AA = H.overrides, gA = AA === void 0 ? {} : AA, IA = H.closeable, CA = H.role, BA = H.autoFocus, eA = H.focusLock, iA = H.returnFocus, QA = gA.Root, tA = gA.Dialog, oA = gA.DialogContainer, EA = gA.Close, aA = getOverrides(QA, Root$2), nA = _slicedToArray$g(aA, 2), lA = nA[0], cA = nA[1], sA = getOverrides(oA, DialogContainer), rA = _slicedToArray$g(sA, 2), uA = rA[0], hA = rA[1], dA = getOverrides(tA, Dialog$2), GA = _slicedToArray$g(dA, 2), DA = GA[0], wA = GA[1], bA = getOverrides(EA, Close), yA = _slicedToArray$g(bA, 2), pA = yA[0], MA = yA[1], LA = this.getSharedProps(), xA = this.getChildren();
      return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(TA) {
        return /* @__PURE__ */ React.createElement(FocusLockCombination, {
          disabled: !eA,
          crossFrame: !1,
          returnFocus: iA,
          autoFocus: BA
        }, /* @__PURE__ */ React.createElement(lA, _extends$t({
          "data-baseweb": "modal",
          ref: k.rootRef
        }, LA, cA), /* @__PURE__ */ React.createElement(
          uA,
          _extends$t({
            ref: k.dialogContainerRef
          }, LA, hA),
          /* @__PURE__ */ React.createElement(DA, _extends$t({
            tabIndex: -1,
            "aria-modal": !0,
            "aria-label": "dialog",
            role: CA
          }, LA, wA), xA, IA ? /* @__PURE__ */ React.createElement(pA, _extends$t({
            "aria-label": TA.modal.close,
            onClick: k.onCloseClick
          }, LA, MA, {
            onFocus: forkFocus(MA, k.handleFocus),
            onBlur: forkBlur(MA, k.handleBlur)
          }), /* @__PURE__ */ React.createElement(CloseIcon, null)) : null)
        )));
      });
    }
  }, {
    key: "render",
    value: function() {
      return !this.state.mounted || !this.props.isOpen && !this.state.isVisible ? null : /* @__PURE__ */ React.createElement(Layer, {
        onEscape: this.onEscape,
        onDocumentClick: this.onDocumentClick,
        mountNode: this.props.mountNode
      }, this.renderModal());
    }
  }]), g;
})(React.Component);
_defineProperty$h(Modal$1, "defaultProps", {
  animate: !0,
  autoFocus: !0,
  focusLock: !0,
  returnFocus: !0,
  closeable: !0,
  name: "dialog",
  isOpen: !1,
  overrides: {},
  role: ROLE.dialog,
  size: SIZE$4.default
});
const DynamicButtonLabel = ({
  icon: n,
  label: t,
  iconSize: g,
  useSmallerFont: d = !1
}) => {
  const k = n?.startsWith(":material"), H = k ? "0 sm 0 0" : "0 md 0 0", AA = g ?? (k ? "lg" : "base");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    n && /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: AA, margin: t ? H : "0", color: "inherit", iconValue: n }),
    t && /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: t, allowHTML: !1, isLabel: !0, largerLabel: !d, disableLinks: !0 })
  ] });
};
var BaseButtonKind = /* @__PURE__ */ ((n) => (n.PRIMARY = "primary", n.SECONDARY = "secondary", n.TERTIARY = "tertiary", n.GHOST = "ghost", n.BORDERLESS_ICON = "borderlessIcon", n.BORDERLESS_ICON_ACTIVE = "borderlessIconActive", n.MINIMAL = "minimal", n.PRIMARY_FORM_SUBMIT = "primaryFormSubmit", n.SECONDARY_FORM_SUBMIT = "secondaryFormSubmit", n.TERTIARY_FORM_SUBMIT = "tertiaryFormSubmit", n.HEADER_BUTTON = "header", n.HEADER_NO_PADDING = "headerNoPadding", n.ELEMENT_TOOLBAR = "elementToolbar", n.PILLS = "pills", n.PILLS_ACTIVE = "pillsActive", n.SEGMENTED_CONTROL = "segmented_control", n.SEGMENTED_CONTROL_ACTIVE = "segmented_controlActive", n))(BaseButtonKind || {}), BaseButtonSize = /* @__PURE__ */ ((n) => (n.XSMALL = "xsmall", n.SMALL = "small", n.MEDIUM = "medium", n.LARGE = "large", n))(BaseButtonSize || {});
function getSizeStyle(n, t) {
  switch (n) {
    case "xsmall":
      return {
        padding: `${t.spacing.twoXS} ${t.spacing.sm}`,
        fontSize: t.fontSizes.sm
      };
    case "small":
      return {
        padding: `${t.spacing.twoXS} ${t.spacing.md}`
      };
    case "large":
      return {
        padding: `${t.spacing.md} ${t.spacing.md}`
      };
    default:
      return {
        padding: `${t.spacing.xs} ${t.spacing.md}`
      };
  }
}
const StyledBaseButton = /* @__PURE__ */ createStyled$1("button", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc21"
} : {
  target: "ef3psqc21",
  label: "StyledBaseButton"
})(({
  containerWidth: n,
  size: t,
  theme: g
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: g.fontWeights.normal,
  padding: `${g.spacing.xs} ${g.spacing.md}`,
  borderRadius: g.radii.button,
  minHeight: g.sizes.minElementHeight,
  margin: g.spacing.none,
  lineHeight: g.lineHeights.base,
  textTransform: "none",
  fontSize: "inherit",
  fontFamily: "inherit",
  color: "inherit",
  width: n ? "100%" : "auto",
  cursor: "pointer",
  userSelect: "none",
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    // When focus-visible (e.g. if the button was focused via keyboard navigation)
    // we use the hover style of the respective button type (see below) and
    // additionally show a colored focus ring
    boxShadow: `0 0 0 0.2rem ${transparentize(g.colors.primary, 0.5)}`
  },
  ...getSizeStyle(t, g)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPrimaryButton = /* @__PURE__ */ createStyled$1(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc20"
} : {
  target: "ef3psqc20",
  label: "StyledPrimaryButton"
})(({
  theme: n
}) => ({
  backgroundColor: n.colors.primary,
  color: n.colors.white,
  border: `${n.sizes.borderWidth} solid ${n.colors.primary}`,
  "&:hover, &:focus-visible": {
    backgroundColor: darken(n.colors.primary, 0.15),
    borderColor: darken(n.colors.primary, 0.15)
  },
  "&:active": {
    backgroundColor: n.colors.primary,
    // Keep the border darker when clicked so that the button looks "pressed"
    borderColor: darken(n.colors.primary, 0.15)
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: n.colors.borderColor,
    backgroundColor: n.colors.transparent,
    color: n.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSecondaryButton = /* @__PURE__ */ createStyled$1(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc19"
} : {
  target: "ef3psqc19",
  label: "StyledSecondaryButton"
})(({
  theme: n
}) => ({
  backgroundColor: n.colors.lightenedBg05,
  border: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
  "&:hover, &:focus-visible": {
    backgroundColor: n.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: n.colors.darkenedBgMix25
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: n.colors.borderColor,
    backgroundColor: n.colors.transparent,
    color: n.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTertiaryButton = /* @__PURE__ */ createStyled$1(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc18"
} : {
  target: "ef3psqc18",
  label: "StyledTertiaryButton"
})(({
  theme: n
}) => ({
  padding: n.spacing.none,
  backgroundColor: n.colors.transparent,
  border: "none",
  "&:hover, &:focus-visible": {
    color: n.colors.primary
  },
  "&:hover:not(:disabled), &:focus-visible:not(:disabled)": {
    // Also make colored text have the primary color on hover. Since text color is
    // applied as an inline style we need to use !important to override it.
    // Note that we're not doing this when disabled. We should probably do that as
    // well but we don't do it anywhere else.
    "span.stMarkdownColoredText": {
      color: "inherit !important"
    }
  },
  "&:active": {
    color: darken(n.colors.primary, 0.25)
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: n.colors.transparent,
    color: n.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFtS29DIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBNb3VzZUV2ZW50LCBSZWFjdE5vZGUgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgZGFya2VuLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uS2luZCB7XG4gIFBSSU1BUlkgPSBcInByaW1hcnlcIixcbiAgU0VDT05EQVJZID0gXCJzZWNvbmRhcnlcIixcbiAgVEVSVElBUlkgPSBcInRlcnRpYXJ5XCIsXG4gIEdIT1NUID0gXCJnaG9zdFwiLFxuICBCT1JERVJMRVNTX0lDT04gPSBcImJvcmRlcmxlc3NJY29uXCIsXG4gIEJPUkRFUkxFU1NfSUNPTl9BQ1RJVkUgPSBcImJvcmRlcmxlc3NJY29uQWN0aXZlXCIsXG4gIE1JTklNQUwgPSBcIm1pbmltYWxcIixcbiAgUFJJTUFSWV9GT1JNX1NVQk1JVCA9IFwicHJpbWFyeUZvcm1TdWJtaXRcIixcbiAgU0VDT05EQVJZX0ZPUk1fU1VCTUlUID0gXCJzZWNvbmRhcnlGb3JtU3VibWl0XCIsXG4gIFRFUlRJQVJZX0ZPUk1fU1VCTUlUID0gXCJ0ZXJ0aWFyeUZvcm1TdWJtaXRcIixcbiAgSEVBREVSX0JVVFRPTiA9IFwiaGVhZGVyXCIsXG4gIEhFQURFUl9OT19QQURESU5HID0gXCJoZWFkZXJOb1BhZGRpbmdcIixcbiAgRUxFTUVOVF9UT09MQkFSID0gXCJlbGVtZW50VG9vbGJhclwiLFxuICBQSUxMUyA9IFwicGlsbHNcIixcbiAgUElMTFNfQUNUSVZFID0gXCJwaWxsc0FjdGl2ZVwiLFxuICBTRUdNRU5URURfQ09OVFJPTCA9IFwic2VnbWVudGVkX2NvbnRyb2xcIixcbiAgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFID0gXCJzZWdtZW50ZWRfY29udHJvbEFjdGl2ZVwiLFxufVxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uU2l6ZSB7XG4gIFhTTUFMTCA9IFwieHNtYWxsXCIsXG4gIFNNQUxMID0gXCJzbWFsbFwiLFxuICBNRURJVU0gPSBcIm1lZGl1bVwiLFxuICBMQVJHRSA9IFwibGFyZ2VcIixcbn1cblxuZXhwb3J0IGludGVyZmFjZSBCYXNlQnV0dG9uUHJvcHMge1xuICBraW5kOiBCYXNlQnV0dG9uS2luZFxuICBzaXplPzogQmFzZUJ1dHRvblNpemVcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnkgLS0gVE9ETzogUmVwbGFjZSAnYW55JyB3aXRoIGEgbW9yZSBzcGVjaWZpYyB0eXBlLlxuICBvbkNsaWNrPzogKGV2ZW50OiBNb3VzZUV2ZW50PEhUTUxCdXR0b25FbGVtZW50PikgPT4gYW55XG4gIGRpc2FibGVkPzogYm9vbGVhblxuICAvLyBJZiB0cnVlLCB0aGUgYnV0dG9uIHNob3VsZCB0YWtlIHVwIGNvbnRhaW5lcidzIGZ1bGwgd2lkdGhcbiAgY29udGFpbmVyV2lkdGg/OiBib29sZWFuXG4gIGNoaWxkcmVuOiBSZWFjdE5vZGVcbiAgYXV0b0ZvY3VzPzogYm9vbGVhblxuICBcImRhdGEtdGVzdGlkXCI/OiBzdHJpbmdcbiAgXCJhcmlhLWxhYmVsXCI/OiBzdHJpbmdcbn1cblxudHlwZSBSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcyA9IFJlcXVpcmVkPEJhc2VCdXR0b25Qcm9wcz5cblxuZnVuY3Rpb24gZ2V0U2l6ZVN0eWxlKHNpemU6IEJhc2VCdXR0b25TaXplLCB0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5MQVJHRTpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubWR9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgfVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQmFzZUJ1dHRvbiA9IHN0eWxlZC5idXR0b248UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KFxuICAoeyBjb250YWluZXJXaWR0aCwgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5taW5FbGVtZW50SGVpZ2h0LFxuICAgICAgbWFyZ2luOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJub25lXCIsXG4gICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgdXNlclNlbGVjdDogXCJub25lXCIsXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAgIC8vIFdoZW4gZm9jdXMtdmlzaWJsZSAoZS5nLiBpZiB0aGUgYnV0dG9uIHdhcyBmb2N1c2VkIHZpYSBrZXlib2FyZCBuYXZpZ2F0aW9uKVxuICAgICAgICAvLyB3ZSB1c2UgdGhlIGhvdmVyIHN0eWxlIG9mIHRoZSByZXNwZWN0aXZlIGJ1dHRvbiB0eXBlIChzZWUgYmVsb3cpIGFuZFxuICAgICAgICAvLyBhZGRpdGlvbmFsbHkgc2hvdyBhIGNvbG9yZWQgZm9jdXMgcmluZ1xuICAgICAgICBib3hTaGFkb3c6IGAwIDAgMCAwLjJyZW0gJHt0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC41KX1gLFxuICAgICAgfSxcbiAgICAgIC4uLmdldFNpemVTdHlsZShzaXplLCB0aGVtZSksXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLndoaXRlLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgLy8gS2VlcCB0aGUgYm9yZGVyIGRhcmtlciB3aGVuIGNsaWNrZWQgc28gdGhhdCB0aGUgYnV0dG9uIGxvb2tzIFwicHJlc3NlZFwiXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5saWdodGVuZWRCZzA1LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGVydGlhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgfSxcbiAgICBcIiY6aG92ZXI6bm90KDpkaXNhYmxlZCksICY6Zm9jdXMtdmlzaWJsZTpub3QoOmRpc2FibGVkKVwiOiB7XG4gICAgICAvLyBBbHNvIG1ha2UgY29sb3JlZCB0ZXh0IGhhdmUgdGhlIHByaW1hcnkgY29sb3Igb24gaG92ZXIuIFNpbmNlIHRleHQgY29sb3IgaXNcbiAgICAgIC8vIGFwcGxpZWQgYXMgYW4gaW5saW5lIHN0eWxlIHdlIG5lZWQgdG8gdXNlICFpbXBvcnRhbnQgdG8gb3ZlcnJpZGUgaXQuXG4gICAgICAvLyBOb3RlIHRoYXQgd2UncmUgbm90IGRvaW5nIHRoaXMgd2hlbiBkaXNhYmxlZC4gV2Ugc2hvdWxkIHByb2JhYmx5IGRvIHRoYXQgYXNcbiAgICAgIC8vIHdlbGwgYnV0IHdlIGRvbid0IGRvIGl0IGFueXdoZXJlIGVsc2UuXG4gICAgICBcInNwYW4uc3RNYXJrZG93bkNvbG9yZWRUZXh0XCI6IHtcbiAgICAgICAgY29sb3I6IFwiaW5oZXJpdCAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjI1KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEdob3N0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnR9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1pbmltYWxCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IFwibm9uZVwiLFxuICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9XG4gIHN0eWxlZChTdHlsZWRQcmltYXJ5QnV0dG9uKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUZvcm1TdWJtaXRCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZFRlcnRpYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRoLFxuXG4gICAgLy8gc2hvdyBwaWxscyB3aXRoIGxvbmcgdGV4dCBpbiBzaW5nbGUgbGluZSBhbmQgdXNlIGVsbGlwc2lzIGZvciBvdmVyZmxvd1xuICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MjAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuYmdDb2xvcixcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG5cbiAgICBcIiYgZGl2XCI6IHtcbiAgICAgIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICAgICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgfSxcbiAgICBcIiYgcFwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQnV0dG9uR3JvdXBCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSwgY29udGFpbmVyV2lkdGggfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZnVsbCxcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFBpbGxzQnV0dG9uQWN0aXZlID0gc3R5bGVkKFxuICBTdHlsZWRQaWxsc0J1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLnByaW1hcnksIDAuOSksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgYm9yZGVyUmFkaXVzOiBcIjBcIixcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgbWFyZ2luUmlnaHQ6IGAtJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH1gLCAvLyBBZGQgbmVnYXRpdmUgbWFyZ2luIHRvIG92ZXJsYXAgYm9yZGVyc1xuXG4gICAgXCImOmZpcnN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICB9LFxuICAgIFwiJjpsYXN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSwgLy8gUmVzZXQgbWFyZ2luIGZvciB0aGUgbGFzdCBjaGlsZFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgLy8gTWFrZSBzdXJlIHRoZSBmb2N1cyByaW5nIGlzbid0IGJlbG93IHRoZSBwcmV2aW91cy9uZXh0IGJ1dHRvbi5cbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIHBhZGRpbmc6IGAwICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG5cbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5ub25lLFxuXG4gICAgbWluV2lkdGg6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG4gICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5oZWFkZXJJdGVtSGVpZ2h0LFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYm94U2hhZG93OiBgMCAwIDAgMC4ycmVtICR7dHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLmdyYXk5MCwgMC44KX1gLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuLy8gVGFrZSBvdXQgcGFkZGluZyBmb3IgdGhpcyBzcGVjaWZpYyBidXR0b24sIHNvIHdlIGNhbiBlbnN1cmUgaXQncyAzMngzMnB4IGxpa2Ugb3RoZXIgYnV0dG9ucyBpbiBDb21tdW5pdHkgQ2xvdWRcbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJOb1BhZGRpbmdCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEhlYWRlckJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKCkgPT4ge1xuICByZXR1cm4ge1xuICAgIHBhZGRpbmc6IDAsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICBjb25zdCBpY29uUGFkZGluZzogUmVjb3JkPEJhc2VCdXR0b25TaXplLCBzdHJpbmc+ID0ge1xuICAgIFtCYXNlQnV0dG9uU2l6ZS5YU01BTExdOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgW0Jhc2VCdXR0b25TaXplLlNNQUxMXTogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuTUVESVVNXTogdGhlbWUuc3BhY2luZy5tZCxcbiAgICBbQmFzZUJ1dHRvblNpemUuTEFSR0VdOiB0aGVtZS5zcGFjaW5nLmxnLFxuICB9XG5cbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICAgIHBhZGRpbmc6IGljb25QYWRkaW5nW3NpemVdLFxuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuXG4gICAgLy8gS2VlcHMgdGhlIGJ1dHRvbnMgZnJvbSBzdGFja2luZyB3aGVuIGluIGNvbnRhaW5lcldpZHRoIG1vZGUuXG4gICAgLy8gVGhlc2UgYnV0dG9ucyBzaG91bGQgc3RheSB0b2dldGhlciBhbmQgbm90IHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IFwiMCAwIGZpdC1jb250ZW50XCIsXG5cbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIG1pbkhlaWdodDogXCJ1bnNldFwiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDEwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG5cbiAgICAgIC8vIEZvciBpbWFnZSBjb250ZW50XG4gICAgICBpbWc6IHtcbiAgICAgICAgb3BhY2l0eTogMC40LFxuICAgICAgfSxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFRvb2x0aXBOb3JtYWwgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE1vYmlsZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJub25lXCIsXG4gIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMuc219KWBdOiB7XG4gICAgZGlzcGxheTogXCJibG9ja1wiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFbGVtZW50VG9vbGJhckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnR3b1NtLFxuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGdhcDogdGhlbWUuc3BhY2luZy54cyxcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIG1pbkhlaWdodDogXCJ1bnNldFwiLFxuICAgIC8vIGxpbmUgaGVpZ2h0IHNob3VsZCBiZSB0aGUgc2FtZSBhcyB0aGUgaWNvbiBzaXplXG4gICAgbGluZUhlaWdodDogdGhlbWUuaWNvblNpemVzLm1kLFxuICAgIHdpZHRoOiBcImF1dG9cIixcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgICB9LFxuICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTYwLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25Hcm91cCA9IHN0eWxlZC5kaXY8eyBjb250YWluZXJXaWR0aDogYm9vbGVhbiB9PihcbiAgKHsgY29udGFpbmVyV2lkdGggfSkgPT4gKHtcbiAgICB3aWR0aDogY29udGFpbmVyV2lkdGggPyBcIjEwMCVcIiA6IFwiYXV0b1wiLFxuICB9KVxuKVxuIl19 */"), StyledGhostButton = /* @__PURE__ */ createStyled$1(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc17"
} : {
  target: "ef3psqc17",
  label: "StyledGhostButton"
})(({
  theme: n
}) => ({
  backgroundColor: n.colors.transparent,
  border: `${n.sizes.borderWidth} solid ${n.colors.transparent}`,
  "&:hover, &:focus-visible": {
    borderColor: n.colors.transparent,
    color: n.colors.primary
  },
  "&:active": {
    color: n.colors.primary,
    borderColor: n.colors.transparent,
    backgroundColor: n.colors.transparent
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: n.colors.gray30,
    borderColor: n.colors.transparent,
    color: n.colors.gray60
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMinimalButton = /* @__PURE__ */ createStyled$1(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc16"
} : {
  target: "ef3psqc16",
  label: "StyledMinimalButton"
})(({
  theme: n
}) => ({
  backgroundColor: n.colors.transparent,
  border: "none",
  boxShadow: "none",
  padding: n.spacing.none,
  "&:hover, &:active, &:focus-visible": {
    color: n.colors.primary
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    color: n.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPrimaryFormSubmitButton = /* @__PURE__ */ createStyled$1(StyledPrimaryButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc15"
} : {
  target: "ef3psqc15",
  label: "StyledPrimaryFormSubmitButton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSecondaryFormSubmitButton = /* @__PURE__ */ createStyled$1(StyledSecondaryButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc14"
} : {
  target: "ef3psqc14",
  label: "StyledSecondaryFormSubmitButton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTertiaryFormSubmitButton = /* @__PURE__ */ createStyled$1(StyledTertiaryButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc13"
} : {
  target: "ef3psqc13",
  label: "StyledTertiaryFormSubmitButton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonGroupBaseButton = /* @__PURE__ */ createStyled$1(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc12"
} : {
  target: "ef3psqc12",
  label: "StyledButtonGroupBaseButton"
})(({
  theme: n
}) => ({
  background: n.colors.bgColor,
  border: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
  fontSize: n.fontSizes.sm,
  lineHeight: n.lineHeights.base,
  fontWeight: n.fontWeights.normal,
  height: n.sizes.largeLogoHeight,
  minHeight: n.sizes.largeLogoHeight,
  maxWidth: n.sizes.contentMaxWidth,
  // show pills with long text in single line and use ellipsis for overflow
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "&:hover, &:focus-visible": {
    backgroundColor: n.colors.darkenedBgMix15
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    color: n.colors.fadedText20,
    borderColor: n.colors.borderColor,
    backgroundColor: n.colors.bgColor,
    cursor: "not-allowed"
  },
  "& div": {
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  "& p": {
    textOverflow: "ellipsis",
    overflow: "hidden"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPillsButton = /* @__PURE__ */ createStyled$1(StyledButtonGroupBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc11"
} : {
  target: "ef3psqc11",
  label: "StyledPillsButton"
})(({
  theme: n,
  containerWidth: t
}) => ({
  borderRadius: n.radii.full,
  padding: `${n.spacing.twoXS} ${n.spacing.md}`,
  // When containerWidth is true, the buttons will stretch to fill the container.
  flex: t ? "1 1 fit-content" : ""
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPillsButtonActive = /* @__PURE__ */ createStyled$1(StyledPillsButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc10"
} : {
  target: "ef3psqc10",
  label: "StyledPillsButtonActive"
})(({
  theme: n
}) => ({
  backgroundColor: transparentize(n.colors.primary, 0.9),
  borderColor: n.colors.primary,
  color: n.colors.primary,
  "&:hover, &:focus-visible": {
    backgroundColor: transparentize(n.colors.primary, 0.8),
    borderColor: n.colors.primary,
    color: n.colors.primary
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSegmentedControlButton = /* @__PURE__ */ createStyled$1(StyledButtonGroupBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc9"
} : {
  target: "ef3psqc9",
  label: "StyledSegmentedControlButton"
})(({
  theme: n,
  containerWidth: t
}) => ({
  padding: `${n.spacing.twoXS} ${n.spacing.lg}`,
  borderRadius: "0",
  // When containerWidth is true, the buttons will stretch to fill the container.
  flex: t ? "1 1 fit-content" : "",
  maxWidth: "100%",
  marginRight: `-${n.sizes.borderWidth}`,
  // Add negative margin to overlap borders
  "&:first-child": {
    borderTopLeftRadius: n.radii.button,
    borderBottomLeftRadius: n.radii.button
  },
  "&:last-child": {
    borderTopRightRadius: n.radii.button,
    borderBottomRightRadius: n.radii.button,
    marginRight: n.spacing.none
    // Reset margin for the last child
  },
  "&:focus-visible": {
    // Make sure the focus ring isn't below the previous/next button.
    zIndex: n.zIndices.priority
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSegmentedControlButtonActive = /* @__PURE__ */ createStyled$1(StyledSegmentedControlButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc8"
} : {
  target: "ef3psqc8",
  label: "StyledSegmentedControlButtonActive"
})(({
  theme: n
}) => ({
  backgroundColor: transparentize(n.colors.primary, 0.9),
  borderColor: n.colors.primary,
  color: n.colors.primary,
  zIndex: n.zIndices.priority,
  "&:hover, &:focus-visible": {
    backgroundColor: transparentize(n.colors.primary, 0.8)
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderButton = /* @__PURE__ */ createStyled$1(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc7"
} : {
  target: "ef3psqc7",
  label: "StyledHeaderButton"
})(({
  theme: n
}) => ({
  backgroundColor: n.colors.transparent,
  border: "none",
  padding: `0 ${n.spacing.sm}`,
  fontSize: n.fontSizes.sm,
  marginLeft: n.spacing.threeXS,
  marginRight: n.spacing.threeXS,
  lineHeight: n.lineHeights.none,
  minWidth: n.sizes.headerItemHeight,
  minHeight: n.sizes.headerItemHeight,
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: `0 0 0 0.2rem ${transparentize(n.colors.gray90, 0.8)}`
  },
  "&:hover": {
    backgroundColor: n.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: n.colors.darkenedBgMix25
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: n.colors.gray30,
    borderColor: n.colors.transparent,
    color: n.colors.gray60
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderNoPaddingButton = /* @__PURE__ */ createStyled$1(StyledHeaderButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc6"
} : {
  target: "ef3psqc6",
  label: "StyledHeaderNoPaddingButton"
})(() => ({
  padding: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnWTJDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBNb3VzZUV2ZW50LCBSZWFjdE5vZGUgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgZGFya2VuLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uS2luZCB7XG4gIFBSSU1BUlkgPSBcInByaW1hcnlcIixcbiAgU0VDT05EQVJZID0gXCJzZWNvbmRhcnlcIixcbiAgVEVSVElBUlkgPSBcInRlcnRpYXJ5XCIsXG4gIEdIT1NUID0gXCJnaG9zdFwiLFxuICBCT1JERVJMRVNTX0lDT04gPSBcImJvcmRlcmxlc3NJY29uXCIsXG4gIEJPUkRFUkxFU1NfSUNPTl9BQ1RJVkUgPSBcImJvcmRlcmxlc3NJY29uQWN0aXZlXCIsXG4gIE1JTklNQUwgPSBcIm1pbmltYWxcIixcbiAgUFJJTUFSWV9GT1JNX1NVQk1JVCA9IFwicHJpbWFyeUZvcm1TdWJtaXRcIixcbiAgU0VDT05EQVJZX0ZPUk1fU1VCTUlUID0gXCJzZWNvbmRhcnlGb3JtU3VibWl0XCIsXG4gIFRFUlRJQVJZX0ZPUk1fU1VCTUlUID0gXCJ0ZXJ0aWFyeUZvcm1TdWJtaXRcIixcbiAgSEVBREVSX0JVVFRPTiA9IFwiaGVhZGVyXCIsXG4gIEhFQURFUl9OT19QQURESU5HID0gXCJoZWFkZXJOb1BhZGRpbmdcIixcbiAgRUxFTUVOVF9UT09MQkFSID0gXCJlbGVtZW50VG9vbGJhclwiLFxuICBQSUxMUyA9IFwicGlsbHNcIixcbiAgUElMTFNfQUNUSVZFID0gXCJwaWxsc0FjdGl2ZVwiLFxuICBTRUdNRU5URURfQ09OVFJPTCA9IFwic2VnbWVudGVkX2NvbnRyb2xcIixcbiAgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFID0gXCJzZWdtZW50ZWRfY29udHJvbEFjdGl2ZVwiLFxufVxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uU2l6ZSB7XG4gIFhTTUFMTCA9IFwieHNtYWxsXCIsXG4gIFNNQUxMID0gXCJzbWFsbFwiLFxuICBNRURJVU0gPSBcIm1lZGl1bVwiLFxuICBMQVJHRSA9IFwibGFyZ2VcIixcbn1cblxuZXhwb3J0IGludGVyZmFjZSBCYXNlQnV0dG9uUHJvcHMge1xuICBraW5kOiBCYXNlQnV0dG9uS2luZFxuICBzaXplPzogQmFzZUJ1dHRvblNpemVcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnkgLS0gVE9ETzogUmVwbGFjZSAnYW55JyB3aXRoIGEgbW9yZSBzcGVjaWZpYyB0eXBlLlxuICBvbkNsaWNrPzogKGV2ZW50OiBNb3VzZUV2ZW50PEhUTUxCdXR0b25FbGVtZW50PikgPT4gYW55XG4gIGRpc2FibGVkPzogYm9vbGVhblxuICAvLyBJZiB0cnVlLCB0aGUgYnV0dG9uIHNob3VsZCB0YWtlIHVwIGNvbnRhaW5lcidzIGZ1bGwgd2lkdGhcbiAgY29udGFpbmVyV2lkdGg/OiBib29sZWFuXG4gIGNoaWxkcmVuOiBSZWFjdE5vZGVcbiAgYXV0b0ZvY3VzPzogYm9vbGVhblxuICBcImRhdGEtdGVzdGlkXCI/OiBzdHJpbmdcbiAgXCJhcmlhLWxhYmVsXCI/OiBzdHJpbmdcbn1cblxudHlwZSBSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcyA9IFJlcXVpcmVkPEJhc2VCdXR0b25Qcm9wcz5cblxuZnVuY3Rpb24gZ2V0U2l6ZVN0eWxlKHNpemU6IEJhc2VCdXR0b25TaXplLCB0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5MQVJHRTpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubWR9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgfVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQmFzZUJ1dHRvbiA9IHN0eWxlZC5idXR0b248UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KFxuICAoeyBjb250YWluZXJXaWR0aCwgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5taW5FbGVtZW50SGVpZ2h0LFxuICAgICAgbWFyZ2luOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJub25lXCIsXG4gICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgdXNlclNlbGVjdDogXCJub25lXCIsXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAgIC8vIFdoZW4gZm9jdXMtdmlzaWJsZSAoZS5nLiBpZiB0aGUgYnV0dG9uIHdhcyBmb2N1c2VkIHZpYSBrZXlib2FyZCBuYXZpZ2F0aW9uKVxuICAgICAgICAvLyB3ZSB1c2UgdGhlIGhvdmVyIHN0eWxlIG9mIHRoZSByZXNwZWN0aXZlIGJ1dHRvbiB0eXBlIChzZWUgYmVsb3cpIGFuZFxuICAgICAgICAvLyBhZGRpdGlvbmFsbHkgc2hvdyBhIGNvbG9yZWQgZm9jdXMgcmluZ1xuICAgICAgICBib3hTaGFkb3c6IGAwIDAgMCAwLjJyZW0gJHt0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC41KX1gLFxuICAgICAgfSxcbiAgICAgIC4uLmdldFNpemVTdHlsZShzaXplLCB0aGVtZSksXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLndoaXRlLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgLy8gS2VlcCB0aGUgYm9yZGVyIGRhcmtlciB3aGVuIGNsaWNrZWQgc28gdGhhdCB0aGUgYnV0dG9uIGxvb2tzIFwicHJlc3NlZFwiXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5saWdodGVuZWRCZzA1LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGVydGlhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgfSxcbiAgICBcIiY6aG92ZXI6bm90KDpkaXNhYmxlZCksICY6Zm9jdXMtdmlzaWJsZTpub3QoOmRpc2FibGVkKVwiOiB7XG4gICAgICAvLyBBbHNvIG1ha2UgY29sb3JlZCB0ZXh0IGhhdmUgdGhlIHByaW1hcnkgY29sb3Igb24gaG92ZXIuIFNpbmNlIHRleHQgY29sb3IgaXNcbiAgICAgIC8vIGFwcGxpZWQgYXMgYW4gaW5saW5lIHN0eWxlIHdlIG5lZWQgdG8gdXNlICFpbXBvcnRhbnQgdG8gb3ZlcnJpZGUgaXQuXG4gICAgICAvLyBOb3RlIHRoYXQgd2UncmUgbm90IGRvaW5nIHRoaXMgd2hlbiBkaXNhYmxlZC4gV2Ugc2hvdWxkIHByb2JhYmx5IGRvIHRoYXQgYXNcbiAgICAgIC8vIHdlbGwgYnV0IHdlIGRvbid0IGRvIGl0IGFueXdoZXJlIGVsc2UuXG4gICAgICBcInNwYW4uc3RNYXJrZG93bkNvbG9yZWRUZXh0XCI6IHtcbiAgICAgICAgY29sb3I6IFwiaW5oZXJpdCAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjI1KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEdob3N0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnR9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1pbmltYWxCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IFwibm9uZVwiLFxuICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9XG4gIHN0eWxlZChTdHlsZWRQcmltYXJ5QnV0dG9uKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUZvcm1TdWJtaXRCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZFRlcnRpYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRoLFxuXG4gICAgLy8gc2hvdyBwaWxscyB3aXRoIGxvbmcgdGV4dCBpbiBzaW5nbGUgbGluZSBhbmQgdXNlIGVsbGlwc2lzIGZvciBvdmVyZmxvd1xuICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MjAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuYmdDb2xvcixcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG5cbiAgICBcIiYgZGl2XCI6IHtcbiAgICAgIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICAgICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgfSxcbiAgICBcIiYgcFwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQnV0dG9uR3JvdXBCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSwgY29udGFpbmVyV2lkdGggfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZnVsbCxcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFBpbGxzQnV0dG9uQWN0aXZlID0gc3R5bGVkKFxuICBTdHlsZWRQaWxsc0J1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLnByaW1hcnksIDAuOSksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgYm9yZGVyUmFkaXVzOiBcIjBcIixcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgbWFyZ2luUmlnaHQ6IGAtJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH1gLCAvLyBBZGQgbmVnYXRpdmUgbWFyZ2luIHRvIG92ZXJsYXAgYm9yZGVyc1xuXG4gICAgXCImOmZpcnN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICB9LFxuICAgIFwiJjpsYXN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSwgLy8gUmVzZXQgbWFyZ2luIGZvciB0aGUgbGFzdCBjaGlsZFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgLy8gTWFrZSBzdXJlIHRoZSBmb2N1cyByaW5nIGlzbid0IGJlbG93IHRoZSBwcmV2aW91cy9uZXh0IGJ1dHRvbi5cbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIHBhZGRpbmc6IGAwICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG5cbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5ub25lLFxuXG4gICAgbWluV2lkdGg6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG4gICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5oZWFkZXJJdGVtSGVpZ2h0LFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYm94U2hhZG93OiBgMCAwIDAgMC4ycmVtICR7dHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLmdyYXk5MCwgMC44KX1gLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuLy8gVGFrZSBvdXQgcGFkZGluZyBmb3IgdGhpcyBzcGVjaWZpYyBidXR0b24sIHNvIHdlIGNhbiBlbnN1cmUgaXQncyAzMngzMnB4IGxpa2Ugb3RoZXIgYnV0dG9ucyBpbiBDb21tdW5pdHkgQ2xvdWRcbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJOb1BhZGRpbmdCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEhlYWRlckJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKCkgPT4ge1xuICByZXR1cm4ge1xuICAgIHBhZGRpbmc6IDAsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICBjb25zdCBpY29uUGFkZGluZzogUmVjb3JkPEJhc2VCdXR0b25TaXplLCBzdHJpbmc+ID0ge1xuICAgIFtCYXNlQnV0dG9uU2l6ZS5YU01BTExdOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgW0Jhc2VCdXR0b25TaXplLlNNQUxMXTogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuTUVESVVNXTogdGhlbWUuc3BhY2luZy5tZCxcbiAgICBbQmFzZUJ1dHRvblNpemUuTEFSR0VdOiB0aGVtZS5zcGFjaW5nLmxnLFxuICB9XG5cbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICAgIHBhZGRpbmc6IGljb25QYWRkaW5nW3NpemVdLFxuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuXG4gICAgLy8gS2VlcHMgdGhlIGJ1dHRvbnMgZnJvbSBzdGFja2luZyB3aGVuIGluIGNvbnRhaW5lcldpZHRoIG1vZGUuXG4gICAgLy8gVGhlc2UgYnV0dG9ucyBzaG91bGQgc3RheSB0b2dldGhlciBhbmQgbm90IHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IFwiMCAwIGZpdC1jb250ZW50XCIsXG5cbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIG1pbkhlaWdodDogXCJ1bnNldFwiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDEwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG5cbiAgICAgIC8vIEZvciBpbWFnZSBjb250ZW50XG4gICAgICBpbWc6IHtcbiAgICAgICAgb3BhY2l0eTogMC40LFxuICAgICAgfSxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFRvb2x0aXBOb3JtYWwgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE1vYmlsZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJub25lXCIsXG4gIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMuc219KWBdOiB7XG4gICAgZGlzcGxheTogXCJibG9ja1wiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFbGVtZW50VG9vbGJhckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnR3b1NtLFxuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGdhcDogdGhlbWUuc3BhY2luZy54cyxcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIG1pbkhlaWdodDogXCJ1bnNldFwiLFxuICAgIC8vIGxpbmUgaGVpZ2h0IHNob3VsZCBiZSB0aGUgc2FtZSBhcyB0aGUgaWNvbiBzaXplXG4gICAgbGluZUhlaWdodDogdGhlbWUuaWNvblNpemVzLm1kLFxuICAgIHdpZHRoOiBcImF1dG9cIixcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgICB9LFxuICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTYwLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25Hcm91cCA9IHN0eWxlZC5kaXY8eyBjb250YWluZXJXaWR0aDogYm9vbGVhbiB9PihcbiAgKHsgY29udGFpbmVyV2lkdGggfSkgPT4gKHtcbiAgICB3aWR0aDogY29udGFpbmVyV2lkdGggPyBcIjEwMCVcIiA6IFwiYXV0b1wiLFxuICB9KVxuKVxuIl19 */"), StyledBorderlessIconButton = /* @__PURE__ */ createStyled$1(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc5"
} : {
  target: "ef3psqc5",
  label: "StyledBorderlessIconButton"
})(({
  size: n,
  theme: t
}) => {
  const g = {
    xsmall: t.spacing.threeXS,
    small: t.spacing.twoXS,
    medium: t.spacing.md,
    large: t.spacing.lg
  };
  return {
    backgroundColor: t.colors.transparent,
    color: t.colors.fadedText60,
    padding: g[n],
    marginLeft: t.spacing.none,
    marginRight: t.spacing.none,
    // Keeps the buttons from stacking when in containerWidth mode.
    // These buttons should stay together and not stretch to fill the container.
    flex: "0 0 fit-content",
    border: "none",
    display: "flex",
    minHeight: "unset",
    "&:focus": {
      boxShadow: "none",
      outline: "none"
    },
    "&:hover": {
      color: t.colors.bodyText
    },
    "&:disabled, &:disabled:hover, &:disabled:active": {
      color: t.colors.fadedText10,
      cursor: "not-allowed",
      // For image content
      img: {
        opacity: 0.4
      }
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledBorderlessIconButtonActive = /* @__PURE__ */ createStyled$1(StyledBorderlessIconButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc4"
} : {
  target: "ef3psqc4",
  label: "StyledBorderlessIconButtonActive"
})(({
  theme: n
}) => ({
  color: n.colors.bodyText,
  "&:disabled, &:disabled:hover, &:disabled:active": {
    color: n.colors.fadedText40
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTooltipNormal = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc3"
} : {
  target: "ef3psqc3",
  label: "StyledTooltipNormal"
})(({
  theme: n
}) => ({
  display: "block",
  [`@media (max-width: ${n.breakpoints.sm})`]: {
    display: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTooltipMobile = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc2"
} : {
  target: "ef3psqc2",
  label: "StyledTooltipMobile"
})(({
  theme: n
}) => ({
  display: "none",
  [`@media (max-width: ${n.breakpoints.sm})`]: {
    display: "block"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledElementToolbarButton = /* @__PURE__ */ createStyled$1(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc1"
} : {
  target: "ef3psqc1",
  label: "StyledElementToolbarButton"
})(({
  theme: n
}) => ({
  backgroundColor: n.colors.transparent,
  border: "none",
  padding: n.spacing.twoXS,
  fontSize: n.fontSizes.twoSm,
  marginLeft: n.spacing.none,
  marginRight: n.spacing.none,
  display: "flex",
  gap: n.spacing.xs,
  alignItems: "center",
  minHeight: "unset",
  // line height should be the same as the icon size
  lineHeight: n.iconSizes.md,
  width: "auto",
  "&:focus": {
    outline: "none",
    border: "none",
    boxShadow: "none"
  },
  "&:focus-visible": {
    outline: "none",
    border: "none",
    boxShadow: "none",
    backgroundColor: n.colors.darkenedBgMix25
  },
  "&:hover": {
    backgroundColor: n.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: n.colors.darkenedBgMix25
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: n.colors.gray30,
    borderColor: n.colors.transparent,
    color: n.colors.gray60
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonGroup = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc0"
} : {
  target: "ef3psqc0",
  label: "StyledButtonGroup"
})(({
  containerWidth: n
}) => ({
  width: n ? "100%" : "auto"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function BaseButton(n) {
  const {
    kind: t,
    size: g,
    disabled: d,
    onClick: k,
    containerWidth: H,
    children: AA,
    autoFocus: gA
  } = n;
  let IA = StyledPrimaryButton;
  return t === BaseButtonKind.SECONDARY ? IA = StyledSecondaryButton : t === BaseButtonKind.TERTIARY ? IA = StyledTertiaryButton : t === BaseButtonKind.GHOST ? IA = StyledGhostButton : t === BaseButtonKind.PILLS ? IA = StyledPillsButton : t === BaseButtonKind.PILLS_ACTIVE ? IA = StyledPillsButtonActive : t === BaseButtonKind.SEGMENTED_CONTROL ? IA = StyledSegmentedControlButton : t === BaseButtonKind.SEGMENTED_CONTROL_ACTIVE ? IA = StyledSegmentedControlButtonActive : t === BaseButtonKind.BORDERLESS_ICON ? IA = StyledBorderlessIconButton : t === BaseButtonKind.BORDERLESS_ICON_ACTIVE ? IA = StyledBorderlessIconButtonActive : t === BaseButtonKind.MINIMAL ? IA = StyledMinimalButton : t === BaseButtonKind.PRIMARY_FORM_SUBMIT ? IA = StyledPrimaryFormSubmitButton : t === BaseButtonKind.SECONDARY_FORM_SUBMIT ? IA = StyledSecondaryFormSubmitButton : t === BaseButtonKind.TERTIARY_FORM_SUBMIT ? IA = StyledTertiaryFormSubmitButton : t === BaseButtonKind.HEADER_BUTTON ? IA = StyledHeaderButton : t === BaseButtonKind.HEADER_NO_PADDING ? IA = StyledHeaderNoPaddingButton : t === BaseButtonKind.ELEMENT_TOOLBAR && (IA = StyledElementToolbarButton), /* @__PURE__ */ jsxRuntimeExports.jsx(IA, { kind: t, size: g ?? BaseButtonSize.MEDIUM, containerWidth: H || !1, disabled: d || !1, onClick: k || (() => {
  }), autoFocus: gA || !1, "data-testid": n["data-testid"] ?? `stBaseButton-${t}`, "aria-label": n["aria-label"] ?? "", children: AA });
}
function BaseButtonTooltip({
  children: n,
  help: t,
  placement: g,
  containerWidth: d
}) {
  return t ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipNormal, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { content: t, placement: g || Placement.TOP, containerWidth: d, children: n }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipMobile, { children: n })
  ] }) : n;
}
const StyledModalButton = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "e18cebhv0"
} : {
  target: "e18cebhv0",
  label: "StyledModalButton"
})(({
  theme: n
}) => ({
  marginRight: n.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvTW9kYWwvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvc2hhcmVkL01vZGFsL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNb2RhbEJ1dHRvbiA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxufSkpXG4iXX0= */");
function ModalHeader({
  children: n,
  overrides: t
}) {
  const {
    genericFonts: g,
    fontSizes: d,
    spacing: k,
    fontWeights: H,
    lineHeights: AA
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader$1, { style: {
    marginTop: k.none,
    marginLeft: k.none,
    marginRight: k.none,
    marginBottom: k.none,
    paddingTop: k.twoXL,
    paddingRight: k.twoXL,
    paddingBottom: k.md,
    paddingLeft: k.twoXL,
    fontFamily: g.bodyFont,
    fontSize: d.xl,
    fontWeight: H.bold,
    margin: k.none,
    lineHeight: AA.small,
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    maxHeight: "80vh",
    flexDirection: "row",
    ...t
  }, children: n });
}
function ModalBody$1({
  children: n
}) {
  const {
    colors: t,
    fontSizes: g,
    spacing: d
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$2, { style: {
    marginTop: d.none,
    marginLeft: d.none,
    marginRight: d.none,
    marginBottom: d.none,
    paddingTop: d.md,
    paddingRight: d.twoXL,
    paddingBottom: d.twoXL,
    paddingLeft: d.twoXL,
    color: t.bodyText,
    fontSize: g.md
  }, children: n });
}
function ModalFooter({
  children: n
}) {
  const {
    spacing: t
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter$1, { style: {
    marginTop: t.none,
    marginLeft: t.none,
    marginRight: t.none,
    marginBottom: t.none,
    paddingTop: t.md,
    paddingRight: t.md,
    paddingBottom: t.md,
    paddingLeft: t.md
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: n }) });
}
const ModalButton = (n) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledModalButton, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...n }) });
function calculateModalSize(n, t, g) {
  return n === "large" ? "80rem" : n === "medium" && t && g ? `calc(${t} + ${g})` : n === "auto" ? SIZE$4.auto : SIZE$4.default;
}
function Modal(n) {
  const {
    spacing: t,
    radii: g,
    colors: d,
    sizes: k
  } = useEmotionTheme(), H = {
    Root: {
      style: {
        background: d.darkenedBgMix25
      },
      props: {
        className: "stDialog",
        "data-testid": "stDialog"
      }
    },
    DialogContainer: {
      style: {
        alignItems: "start",
        paddingTop: t.threeXL
      }
    },
    Dialog: {
      style: {
        borderBottomRightRadius: g.xxl,
        borderBottomLeftRadius: g.xxl,
        borderTopRightRadius: g.xxl,
        borderTopLeftRadius: g.xxl,
        // make sure the modal is not too small on mobile
        minWidth: k.minPopupWidth
      }
    },
    Close: {
      style: {
        top: `calc(${t.twoXL} + .375rem)`,
        // Trying to center the button on the available space.
        right: t.twoXL
      }
    }
  }, AA = calculateModalSize(n.size, k.contentMaxWidth, t.lg), gA = merge$8(H, n.overrides), IA = {
    ...n,
    size: AA
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal$1, { ...IA, overrides: gA });
}
const StyledDialogTitle = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eh5ke330"
} : {
  target: "eh5ke330",
  label: "StyledDialogTitle"
})(({
  theme: n
}) => ({
  // Add right margin to prevent overlap with close button
  marginRight: n.spacing.threeXL
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9EaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvRGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREaWFsb2dUaXRsZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgLy8gQWRkIHJpZ2h0IG1hcmdpbiB0byBwcmV2ZW50IG92ZXJsYXAgd2l0aCBjbG9zZSBidXR0b25cbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYTCxcbn0pKVxuIl19 */");
function mapDialogWidthToModalSize(n) {
  switch (n) {
    case Block$2.Dialog.DialogWidth.MEDIUM:
      return "medium";
    case Block$2.Dialog.DialogWidth.LARGE:
      return "large";
    case Block$2.Dialog.DialogWidth.SMALL:
      return "default";
    default:
      return assertNever(n), "default";
  }
}
const Dialog = ({
  element: n,
  deltaMsgReceivedAt: t,
  children: g,
  widgetMgr: d,
  fragmentId: k
}) => {
  const {
    title: H,
    dismissible: AA,
    width: gA,
    isOpen: IA,
    id: CA
  } = n, [BA, eA] = useState(!1);
  useEffect(() => {
    notNullOrUndefined(IA) && eA(IA);
  }, [IA, t]);
  const iA = useCallback(() => {
    eA(!1), CA && d && d.setTriggerValue(
      {
        id: CA,
        formId: ""
      },
      // WidgetInfo object - dialogs are not compatible with forms
      {
        fromUi: !0
      },
      k
    );
  }, [CA, d, k]), QA = useCallback((tA) => {
    if (BA && tA.key.toLowerCase() === "r" && !n.dismissible) {
      const oA = tA.target;
      if (oA && (oA.isContentEditable || oA.tagName === "INPUT" || oA.tagName === "TEXTAREA" || oA.tagName === "SELECT"))
        return;
      tA.preventDefault(), tA.stopPropagation();
    }
  }, [BA, n.dismissible]);
  return useEffect(() => {
    if (BA && !n.dismissible)
      return document.addEventListener("keydown", QA, !0), () => {
        document.removeEventListener("keydown", QA, !0);
      };
  }, [BA, n.dismissible, QA]), BA ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, closeable: AA, onClose: iA, size: mapDialogWidthToModalSize(gA), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDialogTitle, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: H, allowHTML: !1, isLabel: !0, inheritFont: !0 }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: g })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};
function DialogWithProvider(n) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IsDialogContext.Provider, { value: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog, { ...n }) });
}
const Dialog$1 = memo$1(DialogWithProvider);
function _EMOTION_STRINGIFIED_CSS_ERROR__$d() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledExpandableContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx5"
} : {
  target: "eqpbllx5",
  label: "StyledExpandableContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
}), BORDER_SIZE = 1, StyledDetails = /* @__PURE__ */ createStyled$1("details", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx4"
} : {
  target: "eqpbllx4",
  label: "StyledDetails"
})(({
  isStale: n,
  theme: t
}) => ({
  marginBottom: 0,
  marginTop: 0,
  width: "100%",
  borderStyle: "solid",
  borderWidth: t.sizes.borderWidth,
  borderColor: t.colors.borderColor,
  borderRadius: t.radii.default,
  ...n ? {
    borderColor: t.colors.borderColorLight,
    transition: `border ${STALE_TRANSITION_PARAMS}`
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSummaryHeading = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx3"
} : {
  target: "eqpbllx3",
  label: "StyledSummaryHeading"
})(process.env.NODE_ENV === "production" ? {
  name: "1x5nzr5",
  styles: "display:flex;align-items:center;flex-grow:1;min-width:0;width:100%;max-width:100%;overflow:hidden"
} : {
  name: "1x5nzr5",
  styles: "display:flex;align-items:center;flex-grow:1;min-width:0;width:100%;max-width:100%;overflow:hidden/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
}), StyledSummaryLabelWrapper = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx2"
} : {
  target: "eqpbllx2",
  label: "StyledSummaryLabelWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "xomnir",
  styles: "display:flex;width:100%;flex-grow:1;overflow:hidden"
} : {
  name: "xomnir",
  styles: "display:flex;width:100%;flex-grow:1;overflow:hidden/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
}), StyledSummary = /* @__PURE__ */ createStyled$1("summary", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx1"
} : {
  target: "eqpbllx1",
  label: "StyledSummary"
})(({
  theme: n,
  isStale: t,
  expanded: g
}) => ({
  position: "relative",
  display: "flex",
  width: "100%",
  // Prevent chevron/user icon from overlapping content by ensuring
  // children can shrink and the summary can clip excess inline overflow.
  minWidth: 0,
  overflow: "hidden",
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: `0 0 0 0.2rem ${transparentize(n.colors.primary, 0.5)}`
  },
  fontSize: "inherit",
  paddingLeft: n.spacing.md,
  paddingRight: n.spacing.md,
  paddingTop: n.spacing.twoXS,
  paddingBottom: n.spacing.twoXS,
  minHeight: `calc(${n.sizes.minElementHeight} - 2 * ${n.sizes.borderWidth})`,
  alignItems: "center",
  cursor: "pointer",
  listStyleType: "none",
  "&::-webkit-details-marker": {
    display: "none"
  },
  backgroundColor: g ? n.colors.bgMix : "transparent",
  // When expanded, only round the top corners
  borderRadius: g ? `${n.radii.default} ${n.radii.default} 0 0` : n.radii.default,
  // Animate border-radius changes when expanding/collapsing to match the animation of
  // the expander content. Use a delay when collapsing because the content first needs
  // to slide up.
  transition: g ? "border-radius 200ms cubic-bezier(0.23, 1, 0.32, 1), background-color 150ms ease" : "border-radius 200ms cubic-bezier(0.23, 1, 0.32, 1) 300ms, background-color 150ms ease",
  "&:hover, &:focus-visible": {
    backgroundColor: n.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: n.colors.darkenedBgMix25
  },
  ...t && STALE_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDetailsPanel = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx0"
} : {
  target: "eqpbllx0",
  label: "StyledDetailsPanel"
})(({
  theme: n
}) => ({
  padding: n.spacing.lg,
  borderTop: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ExpanderIcon = (n) => {
  const {
    icon: t
  } = n, g = t?.startsWith(":material"), H = {
    size: g ? "lg" : "base",
    margin: g ? "0 sm 0 0" : "0 md 0 0",
    padding: "0"
  }, AA = {
    ":material/check:": "stExpanderIconCheck",
    ":material/error:": "stExpanderIconError"
  };
  return t === "spinner" ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinnerIcon, { "data-testid": "stExpanderIconSpinner", ...H }) : t ? /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { color: "inherit", iconValue: t, testid: AA[t] || "stExpanderIcon", ...H }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}, Expander = ({
  element: n,
  isStale: t,
  children: g
}) => {
  const {
    label: d,
    expanded: k
  } = n, [H, AA] = useState(k || !1), [gA, IA] = useState(!1), CA = useRef(null), BA = useRef(null), eA = useRef(null), iA = useRef(null), QA = useRef(null);
  useEffect(() => {
    notNullOrUndefined(k) && (AA(k), CA.current && (CA.current.open = k));
  }, [d, k]);
  const tA = (sA) => {
    CA.current && (CA.current.open = sA, eA.current = null, CA.current.style.height = "", CA.current.style.overflow = "");
  }, oA = (sA, rA, uA) => {
    const hA = uA > rA;
    eA.current && (eA.current.cancel(), iA.current && (clearTimeout(iA.current), iA.current = null));
    const dA = sA.animate({
      height: [`${rA}px`, `${uA}px`]
    }, {
      duration: 500,
      easing: "cubic-bezier(0.23, 1, 0.32, 1)"
    });
    dA.addEventListener("finish", () => tA(hA)), eA.current = dA;
  }, EA = (sA) => {
    sA.preventDefault(), AA(!H);
    const rA = CA.current;
    if (!rA || !BA.current)
      return;
    rA.style.overflow = "hidden";
    const uA = rA.getBoundingClientRect().height, hA = BA.current.getBoundingClientRect().height;
    H ? oA(rA, uA, hA + 2 * BORDER_SIZE) : (rA.style.height = `${uA}px`, rA.open = !0, window.requestAnimationFrame(() => {
      oA(
        rA,
        uA,
        hA + 2 * BORDER_SIZE + 5
        // Arbitrary size of 5px
      ), iA.current = setTimeout(() => {
        if (!QA.current)
          return;
        const dA = (
          // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
          QA.current.getBoundingClientRect().height
        );
        oA(rA, uA, hA + dA + 2 * BORDER_SIZE);
      }, 100);
    }));
  }, aA = () => {
    IA(!0);
  }, nA = () => {
    IA(!1);
  }, lA = !n.icon || gA, cA = n.icon && !gA;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledExpandableContainer, { className: "stExpander", "data-testid": "stExpander", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDetails, { isStale: t, ref: CA, onMouseEnter: aA, onMouseLeave: nA, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSummary, { onClick: EA, ref: BA, isStale: t, expanded: H, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSummaryHeading, { children: [
      lA && /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { color: "inherit", iconValue: H ? ":material/keyboard_arrow_down:" : ":material/keyboard_arrow_right:", size: "lg", margin: "0 sm 0 0", padding: "0" }),
      cA && /* @__PURE__ */ jsxRuntimeExports.jsx(ExpanderIcon, { icon: n.icon }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSummaryLabelWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: d, allowHTML: !1, isLabel: !0, largerLabel: !0 }) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDetailsPanel, { "data-testid": "stExpanderDetails", ref: QA, children: g })
  ] }) });
}, Expander$1 = memo$1(Expander), StyledPopoverButtonIcon = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1pbrot50"
} : {
  target: "e1pbrot50",
  label: "StyledPopoverButtonIcon"
})(({
  theme: n
}) => ({
  marginLeft: n.spacing.threeXS,
  // This is a hacky way to offset the "padding" of the expansion svg
  // icon. Reason is that we want to use the same padding to the right side
  // as the text on the left side. The alternative would be to overwrite the
  // right padding of the button, which would also be hacky and involve slightly
  // more logic.
  // If the padding of the icon changes, this value needs to be adjusted.
  // Also, if we want to apply the same adjustment for other elements, we should
  // consider putting this into a theme variable or creating a shared styled component.
  // The SVG icon we are using seems to have an internal padding of around 25%.
  marginRight: `calc(-${n.iconSizes.lg} * 0.25)`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Popover = ({
  element: n,
  empty: t,
  children: g,
  stretchWidth: d
}) => {
  const [k, H] = useState(!1), AA = useContext(IsSidebarContext), gA = useEmotionTheme(), IA = hasLightBackgroundColor(gA), {
    width: CA,
    elementRef: BA
  } = useCalculatedDimensions();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { "data-testid": "stPopover", className: "stPopover", ref: BA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Popover$2,
    {
      triggerType: TRIGGER_TYPE.click,
      placement: PLACEMENT.bottomLeft,
      content: () => g,
      isOpen: k,
      onClickOutside: () => H(!1),
      onClick: () => k ? H(!1) : void 0,
      onEsc: () => H(!1),
      ignoreBoundary: AA,
      renderAll: !0,
      overrides: {
        Body: {
          props: {
            "data-testid": "stPopoverBody"
          },
          style: () => ({
            marginRight: gA.spacing.lg,
            marginBottom: gA.spacing.lg,
            maxHeight: "70vh",
            overflow: "auto",
            maxWidth: `calc(${gA.sizes.contentMaxWidth} - 2*${gA.spacing.lg})`,
            minWidth: d ? (
              // If width="stretch", we use the container width as minimum:
              `${Math.max(CA, 160)}px`
            ) : gA.sizes.minPopupWidth,
            [`@media (max-width: ${gA.breakpoints.sm})`]: {
              maxWidth: `calc(100% - ${gA.spacing.threeXL})`
            },
            borderTopLeftRadius: gA.radii.xl,
            borderTopRightRadius: gA.radii.xl,
            borderBottomRightRadius: gA.radii.xl,
            borderBottomLeftRadius: gA.radii.xl,
            borderLeftWidth: gA.sizes.borderWidth,
            borderRightWidth: gA.sizes.borderWidth,
            borderTopWidth: gA.sizes.borderWidth,
            borderBottomWidth: gA.sizes.borderWidth,
            paddingRight: `calc(${gA.spacing.twoXL} - ${gA.sizes.borderWidth})`,
            // 1px to account for border.
            paddingLeft: `calc(${gA.spacing.twoXL} - ${gA.sizes.borderWidth})`,
            paddingBottom: `calc(${gA.spacing.twoXL} - ${gA.sizes.borderWidth})`,
            paddingTop: `calc(${gA.spacing.twoXL} - ${gA.sizes.borderWidth})`,
            borderLeftStyle: "solid",
            borderRightStyle: "solid",
            borderTopStyle: "solid",
            borderBottomStyle: "solid",
            borderLeftColor: gA.colors.borderColor,
            borderRightColor: gA.colors.borderColor,
            borderTopColor: gA.colors.borderColor,
            borderBottomColor: gA.colors.borderColor,
            boxShadow: IA ? "0px 4px 16px rgba(0, 0, 0, 0.16)" : "0px 4px 16px rgba(0, 0, 0, 0.7)"
          })
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButtonTooltip, { help: n.help, containerWidth: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(BaseButton, { "data-testid": "stPopoverButton", kind: BaseButtonKind.SECONDARY, size: BaseButtonSize.SMALL, disabled: t || n.disabled, containerWidth: !0, onClick: () => H(!k), children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicButtonLabel, { icon: n.icon, label: n.label }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPopoverButtonIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIcon, { as: k ? ExpandLess : ExpandMore, color: "inherit", "aria-hidden": "true", size: "lg", margin: gA.spacing.none, padding: gA.spacing.none }) })
      ] }) }) })
    }
  ) });
}, Popover$1 = memo$1(Popover);
var ORIENTATION = {
  vertical: "vertical",
  horizontal: "horizontal"
}, FILL$1 = {
  fixed: "fixed",
  intrinsic: "intrinsic"
}, getTabId = function n(t, g) {
  return "tabs-".concat(t, "-tab-").concat(g);
}, getTabPanelId = function n(t, g) {
  return "tabs-".concat(t, "-tabpanel-").concat(g);
}, isHorizontal = function n(t) {
  return t === ORIENTATION.horizontal;
}, isVertical = function n(t) {
  return t === ORIENTATION.vertical;
}, isRTL = function n(t) {
  return t === "rtl";
}, isIntrinsic = function n(t) {
  return t === FILL$1.intrinsic;
}, isFixed = function n(t) {
  return t === FILL$1.fixed;
};
function ownKeys$d(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$b(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$d(Object(g), !0).forEach(function(d) {
      _defineProperty$g(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$d(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$g(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var StyledRoot$1 = styled("div", function(n) {
  n.$theme;
  var t = n.$orientation, g = t === void 0 ? ORIENTATION.horizontal : t, d = {
    // Creates a stacking context so we can use z-index on the TabHighlight
    // without affecting anything outside of this element.
    transform: "scale(1)"
  };
  return isVertical(g) && (d.display = "flex"), d;
});
StyledRoot$1.displayName = "StyledRoot";
StyledRoot$1.displayName = "StyledRoot";
var StyledTabBar = styled("div", function(n) {
  var t = n.$hasEndEnhancer, g = n.$orientation;
  return t || !isHorizontal(g) ? {
    display: "flex"
  } : {};
});
StyledTabBar.displayName = "StyledTabBar";
StyledTabBar.displayName = "StyledTabBar";
var StyledTabList = styled("div", function(n) {
  var t = n.$theme, g = n.$fill, d = g === void 0 ? FILL$1.intrinsic : g, k = n.$orientation, H = k === void 0 ? ORIENTATION.horizontal : k, AA = {
    position: "relative",
    display: "flex",
    flexWrap: "nowrap",
    flexGrow: 1
  };
  return isHorizontal(H) ? (AA.flexDirection = "row", AA.paddingBottom = "5px", AA.marginBottom = "-5px") : (AA.flexDirection = "column", isRTL(t.direction) ? (AA.paddingLeft = "5px", AA.marginLeft = "-5px") : (AA.paddingRight = "5px", AA.marginRight = "-5px")), isIntrinsic(d) && (AA["::-webkit-scrollbar"] = {
    display: "none"
  }, AA["-ms-overflow-style"] = "none", AA.scrollbarWidth = "none", isHorizontal(H) ? AA.overflowX = "scroll" : AA.overflowY = "scroll"), AA;
});
StyledTabList.displayName = "StyledTabList";
StyledTabList.displayName = "StyledTabList";
var StyledTab = styled("button", function(n) {
  var t = n.$theme, g = n.$orientation, d = g === void 0 ? ORIENTATION.horizontal : g, k = n.$fill, H = k === void 0 ? FILL$1.intrinsic : k, AA = n.$focusVisible, gA = AA === void 0 ? !1 : AA;
  n.$isActive;
  var IA = _objectSpread$b({
    cursor: "pointer",
    WebkitAppearance: "none",
    marginLeft: "0",
    marginRight: "0",
    marginTop: "0",
    marginBottom: "0",
    boxSizing: "border-box",
    display: "inline-flex",
    alignItems: "center",
    paddingLeft: t.sizing.scale600,
    paddingTop: t.sizing.scale600,
    paddingRight: t.sizing.scale600,
    paddingBottom: t.sizing.scale600,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftStyle: "none",
    borderTopStyle: "none",
    borderRightStyle: "none",
    borderBottomStyle: "none",
    color: t.colors.contentPrimary,
    background: t.colors.backgroundPrimary,
    transitionProperty: "background",
    transitionDuration: t.animation.timing200,
    transitionTimingFunction: t.animation.linearCurve,
    outline: "none",
    outlineOffset: "-3px",
    ":disabled": {
      cursor: "not-allowed",
      color: t.colors.contentStateDisabled
    },
    ":hover": {
      background: t.colors.backgroundSecondary
    },
    ":disabled:hover": {
      background: "none"
    }
  }, t.typography.LabelSmall);
  return gA && (IA.outline = "3px solid ".concat(t.colors.accent)), isFixed(H) && (IA.flexGrow = 1, IA.flexBasis = 0), isHorizontal(d) ? IA.justifyContent = "center" : IA.justifyContent = "flex-end", IA;
});
StyledTab.displayName = "StyledTab";
StyledTab.displayName = "StyledTab";
var StyledEndEnhancerContainer = styled("div", function(n) {
  var t = n.$theme, g = t.direction === "rtl" ? "marginRight" : "marginLeft";
  return _defineProperty$g({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  }, g, t.sizing.scale600);
});
StyledEndEnhancerContainer.displayName = "StyledEndEnhancerContainer";
StyledEndEnhancerContainer.displayName = "StyledEndEnhancerContainer";
var StyledArtworkContainer = styled("div", function(n) {
  var t = n.$theme;
  n.$orientation;
  var g = {
    display: "flex"
  };
  return isRTL(t.direction) ? g.marginLeft = t.sizing.scale300 : g.marginRight = t.sizing.scale300, g;
});
StyledArtworkContainer.displayName = "StyledArtworkContainer";
StyledArtworkContainer.displayName = "StyledArtworkContainer";
var StyledTabBorder = styled("div", function(n) {
  var t = n.$theme, g = n.$orientation, d = g === void 0 ? ORIENTATION.horizontal : g, k = {
    backgroundColor: t.colors.borderOpaque,
    position: "relative"
  };
  return isHorizontal(d) ? k.height = "5px" : k.width = "5px", k;
});
StyledTabBorder.displayName = "StyledTabBorder";
StyledTabBorder.displayName = "StyledTabBorder";
var StyledTabHighlight = styled("div", function(n) {
  var t = n.$theme, g = n.$orientation, d = g === void 0 ? ORIENTATION.horizontal : g, k = n.$length, H = k === void 0 ? 0 : k, AA = n.$distance, gA = AA === void 0 ? 0 : AA, IA = n.$animate, CA = IA === void 0 ? !1 : IA, BA = {
    backgroundColor: t.colors.borderSelected,
    position: "absolute",
    zIndex: 1
  };
  return isHorizontal(d) ? (BA.bottom = "0px", BA.left = "0px", BA.height = "5px", BA.width = "".concat(H, "px"), BA.transform = "translateX(".concat(gA, "px)")) : (BA.transform = "translateY(".concat(gA, "px)"), BA.width = "5px", BA.height = "".concat(H, "px"), isRTL(t.direction) ? BA.left = "0px" : BA.right = "0px"), CA && (BA.transitionProperty = "all", BA.transitionDuration = t.animation.timing400, BA.transitionTimingFunction = t.animation.easeInOutQuinticCurve), BA;
});
StyledTabHighlight.displayName = "StyledTabHighlight";
StyledTabHighlight.displayName = "StyledTabHighlight";
var StyledTabPanel = styled("div", function(n) {
  var t = n.$theme, g = n.$pad, d = g === void 0 ? !0 : g, k = {
    flexGrow: 1,
    // only used in vertical orientation
    outline: "none"
  };
  return d && (k.paddingTop = t.sizing.scale600, k.paddingRight = t.sizing.scale600, k.paddingBottom = t.sizing.scale600, k.paddingLeft = t.sizing.scale600), k;
});
StyledTabPanel.displayName = "StyledTabPanel";
StyledTabPanel.displayName = "StyledTabPanel";
var _excluded$i = ["childKey", "childIndex", "activeKey", "orientation", "activeTabRef", "updateHighlight", "parseKeyDown", "activateOnFocus", "uid", "disabled", "sharedStylingProps", "onChange"], _excluded2$4 = ["artwork", "overrides", "tabRef", "onClick", "title"], _excluded3$1 = ["childKey", "childIndex", "activeKey", "uid", "sharedStylingProps", "renderAll"];
function ownKeys$c(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$a(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$c(Object(g), !0).forEach(function(d) {
      _defineProperty$f(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$c(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$f(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function _toConsumableArray$1(n) {
  return _arrayWithoutHoles$1(n) || _iterableToArray$1(n) || _unsupportedIterableToArray$e(n) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$1(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function _arrayWithoutHoles$1(n) {
  if (Array.isArray(n)) return _arrayLikeToArray$e(n);
}
function _objectWithoutProperties$g(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$g(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$g(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _extends$s() {
  return _extends$s = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$s.apply(this, arguments);
}
function _slicedToArray$f(n, t) {
  return _arrayWithHoles$e(n) || _iterableToArrayLimit$e(n, t) || _unsupportedIterableToArray$e(n, t) || _nonIterableRest$e();
}
function _nonIterableRest$e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$e(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$e(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$e(n, t);
  }
}
function _arrayLikeToArray$e(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$e(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$e(n) {
  if (Array.isArray(n)) return n;
}
var KEYBOARD_ACTION = {
  next: "next",
  previous: "previous"
}, getLayoutParams = function n(t, g) {
  return t ? isVertical(g) ? {
    length: t.clientHeight,
    distance: t.offsetTop
  } : {
    length: t.clientWidth,
    distance: t.offsetLeft
  } : {
    length: 0,
    distance: 0
  };
}, scrollParentToCentreTarget = function n(t) {
  var g = t.parentNode.getBoundingClientRect(), d = g.x, k = g.y, H = g.width, AA = g.height, gA = t.getBoundingClientRect(), IA = gA.x, CA = gA.y, BA = gA.width, eA = gA.height, iA = {
    x: IA - d + BA / 2,
    y: CA - k + eA / 2
  }, QA = t.parentNode, tA = QA.scrollLeft, oA = QA.scrollTop, EA = {
    x: tA + iA.x - H / 2,
    y: oA + iA.y - AA / 2
  };
  t.parentNode.scroll(EA.x, EA.y);
};
function RenderEnhancer(n) {
  var t = n.Enhancer;
  return typeof t == "string" ? t : reactIsExports$1.isValidElementType(t) ? /* @__PURE__ */ React.createElement(t, null) : t;
}
function Tabs$2(n) {
  var t = n.activeKey, g = t === void 0 ? "0" : t, d = n.disabled, k = d === void 0 ? !1 : d, H = n.children, AA = n.fill, gA = AA === void 0 ? FILL$1.intrinsic : AA, IA = n.activateOnFocus, CA = IA === void 0 ? !0 : IA, BA = n.onChange, eA = n.orientation, iA = eA === void 0 ? ORIENTATION.horizontal : eA, QA = n.overrides, tA = QA === void 0 ? {} : QA, oA = n.renderAll, EA = oA === void 0 ? !1 : oA, aA = n.uid, nA = aA === void 0 ? null : aA, lA = n.endEnhancer, cA = useUID(), sA = nA || cA, rA = tA.Root, uA = tA.TabList, hA = tA.TabHighlight, dA = tA.TabBorder, GA = getOverrides(rA, StyledRoot$1), DA = _slicedToArray$f(GA, 2), wA = DA[0], bA = DA[1], yA = getOverrides(uA, StyledTabList), pA = _slicedToArray$f(yA, 2), MA = pA[0], LA = pA[1], xA = getOverrides(hA, StyledTabHighlight), TA = _slicedToArray$f(xA, 2), NA = TA[0], zA = TA[1], XA = getOverrides(dA, StyledTabBorder), fA = _slicedToArray$f(XA, 2), vA = fA[0], Cg = fA[1], Ig = getOverrides(tA.EndEnhancerContainer, StyledEndEnhancerContainer), gg = _slicedToArray$f(Ig, 2), og = gg[0], eg = gg[1], kA = React.useState(0), YA = _slicedToArray$f(kA, 2), RA = YA[0], FA = YA[1];
  React.useEffect(function() {
    FA(RA + 1);
  }, [g]);
  var mA = React.useRef(), JA = React.useState({
    length: 0,
    distance: 0
  }), VA = _slicedToArray$f(JA, 2), HA = VA[0], jA = VA[1], _A = React.useCallback(function() {
    mA.current && jA(getLayoutParams(mA.current, iA));
  }, [mA.current, iA]);
  React.useEffect(_A, [mA.current, iA]), React.useEffect(function() {
    mA.current && (isHorizontal(iA) ? (
      // @ts-expect-error todo(flow->ts) maybe parentElement?
      mA.current.parentNode.scrollWidth > // @ts-expect-error todo(flow->ts) maybe parentElement?
      mA.current.parentNode.clientWidth
    ) : (
      // @ts-expect-error todo(flow->ts) maybe parentElement?
      mA.current.parentNode.scrollHeight > // @ts-expect-error todo(flow->ts) maybe parentElement?
      mA.current.parentNode.clientHeight
    )) && (RA > 1 ? mA.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    }) : scrollParentToCentreTarget(mA.current));
  }, [mA.current]);
  var $A = {
    $orientation: iA,
    $fill: gA
  }, rg = useStyletron(), wg = _slicedToArray$f(rg, 2), Dg = wg[1], kg = React.useCallback(function(ig) {
    if (isHorizontal(iA))
      if (isRTL(Dg.direction))
        switch (ig.keyCode) {
          case 39:
            return KEYBOARD_ACTION.previous;
          case 37:
            return KEYBOARD_ACTION.next;
          default:
            return null;
        }
      else
        switch (ig.keyCode) {
          case 37:
            return KEYBOARD_ACTION.previous;
          case 39:
            return KEYBOARD_ACTION.next;
          default:
            return null;
        }
    else
      switch (ig.keyCode) {
        case 38:
          return KEYBOARD_ACTION.previous;
        case 40:
          return KEYBOARD_ACTION.next;
        default:
          return null;
      }
  }, [iA, Dg.direction]);
  return /* @__PURE__ */ React.createElement(wA, _extends$s({}, $A, bA), /* @__PURE__ */ React.createElement(StyledTabBar, {
    $hasEndEnhancer: !!lA,
    $orientation: iA
  }, /* @__PURE__ */ React.createElement(MA, _extends$s({
    "data-baseweb": "tab-list",
    role: "tablist",
    "aria-orientation": iA
  }, $A, LA), React.Children.map(H, function(ig, ZA) {
    if (ig)
      return /* @__PURE__ */ React.createElement(InternalTab, _extends$s({
        childKey: ig.key,
        childIndex: ZA,
        activeKey: g,
        orientation: iA,
        activeTabRef: mA,
        updateHighlight: _A,
        parseKeyDown: kg,
        activateOnFocus: CA,
        uid: sA,
        disabled: k,
        sharedStylingProps: $A,
        onChange: BA
      }, ig.props));
  }), /* @__PURE__ */ React.createElement(NA, _extends$s({
    "data-baseweb": "tab-highlight",
    $length: HA.length,
    $distance: HA.distance,
    $animate: RA > 1,
    "aria-hidden": "true",
    role: "presentation"
  }, $A, zA))), iA === ORIENTATION.horizontal && lA !== null && lA !== void 0 && /* @__PURE__ */ React.createElement(og, _extends$s({}, eg, {
    $orientation: iA
  }), /* @__PURE__ */ React.createElement(RenderEnhancer, {
    Enhancer: lA
  }))), /* @__PURE__ */ React.createElement(vA, _extends$s({
    "data-baseweb": "tab-border",
    "aria-hidden": "true",
    role: "presentation"
  }, $A, Cg)), React.Children.map(H, function(ig, ZA) {
    if (ig)
      return /* @__PURE__ */ React.createElement(InternalTabPanel, _extends$s({
        childKey: ig.key,
        childIndex: ZA,
        activeKey: g,
        uid: sA,
        sharedStylingProps: $A,
        renderAll: EA
      }, ig.props));
  }));
}
function InternalTab(n) {
  var t = n.childKey, g = n.childIndex, d = n.activeKey, k = n.orientation, H = n.activeTabRef, AA = n.updateHighlight, gA = n.parseKeyDown, IA = n.activateOnFocus, CA = n.uid, BA = n.disabled, eA = n.sharedStylingProps, iA = n.onChange, QA = _objectWithoutProperties$g(n, _excluded$i), tA = t || String(g), oA = tA == d, EA = QA.artwork, aA = QA.overrides, nA = aA === void 0 ? {} : aA, lA = QA.tabRef, cA = QA.onClick, sA = QA.title, rA = _objectWithoutProperties$g(QA, _excluded2$4), uA = React.useRef();
  React.useImperativeHandle(lA, function() {
    return oA ? H.current : uA.current;
  });
  var hA = React.useRef({
    length: 0,
    distance: 0
  });
  React.useEffect(function() {
    hA.current = getLayoutParams(oA ? H.current : uA.current, k);
  }), React.useEffect(function() {
    if (window.ResizeObserver) {
      var Ig = new window.ResizeObserver(function(gg) {
        if (gg[0] && gg[0].target) {
          var og = getLayoutParams(gg[0].target, k);
          (og.length !== hA.current.length || og.distance !== hA.current.distance) && AA();
        }
      });
      return Ig.observe(oA ? H.current : uA.current), function() {
        Ig.disconnect();
      };
    }
  }, [d, k]), React.useEffect(AA, [sA]);
  var dA = nA.Tab, GA = nA.ArtworkContainer, DA = getOverrides(dA, StyledTab), wA = _slicedToArray$f(DA, 2), bA = wA[0], yA = wA[1], pA = getOverrides(GA, StyledArtworkContainer), MA = _slicedToArray$f(pA, 2), LA = MA[0], xA = MA[1], TA = React.useState(!1), NA = _slicedToArray$f(TA, 2), zA = NA[0], XA = NA[1], fA = React.useCallback(function(Ig) {
    isFocusVisible(Ig) && XA(!0);
  }, []), vA = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function(Ig) {
      zA !== !1 && XA(!1);
    },
    [zA]
  ), Cg = React.useCallback(function(Ig) {
    var gg = _toConsumableArray$1(Ig.target.parentNode.childNodes).filter(function(YA) {
      return !YA.disabled && YA.getAttribute("role") === "tab";
    });
    if (gg.length !== 1) {
      var og = gg.indexOf(Ig.target), eg = gA(Ig);
      if (eg) {
        var kA;
        eg === KEYBOARD_ACTION.previous ? gg[og - 1] ? kA = gg[og - 1] : kA = gg[gg.length - 1] : eg === KEYBOARD_ACTION.next && (gg[og + 1] ? kA = gg[og + 1] : kA = gg[0]), kA && (kA.focus(), IA && kA.click()), isVertical(k) && Ig.preventDefault();
      }
    }
  });
  return /* @__PURE__ */ React.createElement(bA, _extends$s({
    "data-baseweb": "tab",
    key: tA,
    id: getTabId(CA, tA),
    role: "tab",
    onKeyDown: Cg,
    "aria-selected": oA,
    "aria-controls": getTabPanelId(CA, tA),
    tabIndex: oA ? "0" : "-1",
    ref: oA ? H : uA,
    disabled: !oA && BA,
    type: "button",
    $focusVisible: zA,
    $isActive: oA
  }, eA, rA, yA, {
    onClick: function(gg) {
      typeof iA == "function" && iA({
        activeKey: tA
      }), typeof cA == "function" && cA(gg);
    },
    onFocus: forkFocus(_objectSpread$a(_objectSpread$a({}, rA), yA), fA),
    onBlur: forkBlur(_objectSpread$a(_objectSpread$a({}, rA), yA), vA)
  }), EA ? /* @__PURE__ */ React.createElement(LA, _extends$s({
    "data-baseweb": "artwork-container"
  }, eA, xA), /* @__PURE__ */ React.createElement(EA, {
    size: 20,
    color: "contentPrimary"
  })) : null, sA || tA);
}
function InternalTabPanel(n) {
  var t = n.childKey, g = n.childIndex, d = n.activeKey, k = n.uid, H = n.sharedStylingProps, AA = n.renderAll, gA = _objectWithoutProperties$g(n, _excluded3$1), IA = t || String(g), CA = IA == d, BA = gA.overrides, eA = BA === void 0 ? {} : BA, iA = gA.children, QA = eA.TabPanel, tA = getOverrides(QA, StyledTabPanel), oA = _slicedToArray$f(tA, 2), EA = oA[0], aA = oA[1];
  return /* @__PURE__ */ React.createElement(EA, _extends$s({
    "data-baseweb": "tab-panel",
    key: IA,
    role: "tabpanel",
    id: getTabPanelId(k, IA),
    "aria-labelledby": getTabId(k, IA),
    hidden: !CA
  }, H, aA), CA || AA ? iA : null);
}
function Tab(n) {
  return null;
}
function getClassnamePrefix(n) {
  return n === Direction.HORIZONTAL ? "stHorizontalBlock" : "stVerticalBlock";
}
function shouldComponentBeEnabled(n, t) {
  return n !== "empty" || t !== ScriptRunState.RUNNING;
}
function isElementStale(n, t, g, d) {
  return t === ScriptRunState.RERUN_REQUESTED ? !0 : t === ScriptRunState.RUNNING ? d?.length ? !!(n.fragmentId && d.includes(n.fragmentId) && n.scriptRunId !== g) : n.scriptRunId !== g : !1;
}
function isComponentStale(n, t, g, d, k) {
  return !n || isElementStale(t, g, d, k);
}
function assignDividerColor(n, t) {
  const g = getDividerColors(t), d = Object.keys(g), {
    blue: k,
    green: H,
    orange: AA,
    red: gA,
    violet: IA,
    yellow: CA
  } = g, BA = {
    blue: k,
    green: H,
    orange: AA,
    red: gA,
    violet: IA,
    yellow: CA
  }, eA = Object.keys(BA);
  let iA = 0;
  Array.from(n.getElements()).forEach((QA) => {
    const tA = QA.heading?.divider;
    if (QA.type === "heading" && tA)
      if (tA === "auto") {
        const oA = eA[iA];
        QA.heading.divider = BA[oA], iA += 1, iA === eA.length && (iA = 0);
      } else d.includes(tA) && (QA.heading.divider = g[tA]);
  });
}
function convertKeyToClassName(n) {
  return n ? "st-key-" + n.trim().replace(/[^a-zA-Z0-9_-]/g, "-") : "";
}
function getKeyFromId(n) {
  if (!n || !isValidElementId(n))
    return;
  const g = n.split("-").slice(2).join("-");
  return g === "None" ? void 0 : g;
}
function backwardsCompatibleColumnGapSize(n) {
  if (n.gapConfig?.gapSize)
    return n.gapConfig.gapSize;
  if (n.gap) {
    if (n.gap === "small")
      return streamlit.GapSize.SMALL;
    if (n.gap === "medium")
      return streamlit.GapSize.MEDIUM;
    if (n.gap === "large")
      return streamlit.GapSize.LARGE;
  }
  return streamlit.GapSize.SMALL;
}
function checkFlexContainerBackwardsCompatibile(n) {
  return !!(n.flexContainer || n.vertical || n.horizontal);
}
function getActivateScrollToBottomBackwardsCompatible(n) {
  return !!((n.deltaBlock.heightConfig?.pixelHeight || // This is deprecated, but we have some integrations that
  // cache messages so we are keeping this here to make sure the
  // frontend is backwards compatible with the old messages.
  n.deltaBlock.vertical?.height) && n.children.some((g) => g instanceof BlockNode && g.deltaBlock.type === "chatMessage"));
}
function getBorderBackwardsCompatible(n) {
  return n.flexContainer?.border || n.vertical?.border || !1;
}
const StyledTabContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "esjhkag0"
} : {
  target: "esjhkag0",
  label: "StyledTabContainer"
})(({
  theme: n,
  isOverflowing: t,
  tabHeight: g,
  width: d,
  flex: k
}) => ({
  ...t ? {
    position: "relative",
    "::after": {
      content: '" "',
      position: "absolute",
      zIndex: n.zIndices.priority,
      top: 0,
      right: 0,
      pointerEvents: "none",
      backgroundImage: `linear-gradient(to right, ${transparentize(n.colors.bgColor, 1)}, ${n.colors.bgColor})`,
      width: n.spacing.lg,
      height: g
    }
  } : {},
  ...d && {
    width: d
  },
  ...k && {
    flex: k
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function Tabs(n) {
  const {
    widgetsDisabled: t,
    node: g,
    isStale: d,
    width: k,
    flex: H
  } = n, {
    fragmentIdsThisRun: AA,
    scriptRunState: gA,
    scriptRunId: IA
  } = useContext(LibContext), CA = g.deltaBlock?.tabContainer?.defaultTabIndex ?? 0;
  let BA = [];
  const [eA, iA] = useState(CA), [QA, tA] = useState(() => g.children[CA]?.deltaBlock?.tab?.label ?? "0"), oA = useRef(null), EA = useEmotionTheme(), [aA, nA] = useState(!1);
  useEffect(() => {
    BA.indexOf(QA) === -1 && (iA(CA), tA(BA[CA]));
  }, [BA]), useEffect(() => {
    if (oA.current) {
      const {
        scrollWidth: rA,
        clientWidth: uA
      } = oA.current;
      nA(rA > uA);
    }
    const sA = BA.indexOf(QA);
    sA !== -1 ? (iA(sA), tA(BA[sA])) : (iA(CA), tA(BA[CA]));
  }, [g.children.length]);
  const lA = EA.sizes.tabHeight, cA = EA.spacing.threeXS;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTabContainer, { className: "stTabs", "data-testid": "stTabs", isOverflowing: aA, tabHeight: lA, width: k, flex: H, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tabs$2,
    {
      activateOnFocus: !0,
      activeKey: eA,
      onChange: ({
        activeKey: sA
      }) => {
        iA(sA), tA(BA[sA]);
      },
      renderAll: !0,
      overrides: {
        TabHighlight: {
          style: () => ({
            backgroundColor: EA.colors.primary,
            height: cA
          })
        },
        TabBorder: {
          style: () => ({
            backgroundColor: EA.colors.borderColorLight,
            height: cA
          })
        },
        TabList: {
          props: {
            ref: oA
          },
          style: () => ({
            gap: EA.spacing.lg,
            marginBottom: `-${cA}`,
            paddingBottom: cA,
            overflowY: "hidden",
            ...d && STALE_STYLES
          })
        },
        Root: {
          style: () => ({
            // resetting transform to fix full screen wrapper
            transform: "none"
          })
        }
      },
      children: g.children.map((sA, rA) => {
        rA === 0 && (BA = []);
        const uA = isElementStale(sA, gA, IA, AA), hA = {
          ...n,
          isStale: d || uA,
          widgetsDisabled: t,
          node: sA
        };
        let dA = rA.toString();
        hA.node.deltaBlock?.tab?.label && (dA = hA.node.deltaBlock.tab.label), BA[rA] = dA;
        const GA = eA.toString() === rA.toString(), DA = rA === g.children.length - 1;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          Tab,
          {
            "data-testid": "stTab",
            title: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: dA, allowHTML: !1, isLabel: !0 }),
            disabled: !d && uA,
            overrides: {
              TabPanel: {
                style: () => ({
                  paddingLeft: EA.spacing.none,
                  paddingRight: EA.spacing.none,
                  paddingBottom: EA.spacing.none,
                  paddingTop: EA.spacing.lg
                })
              },
              Tab: {
                style: () => ({
                  height: lA,
                  whiteSpace: "nowrap",
                  paddingLeft: EA.spacing.none,
                  paddingRight: EA.spacing.none,
                  paddingTop: EA.spacing.none,
                  paddingBottom: EA.spacing.none,
                  fontSize: EA.fontSizes.sm,
                  background: "transparent",
                  color: EA.colors.bodyText,
                  ":focus": {
                    outline: "none",
                    color: EA.colors.primary,
                    background: "none"
                  },
                  ":hover": {
                    color: EA.colors.primary,
                    background: "none"
                  },
                  ...GA ? {
                    color: EA.colors.primary
                  } : {},
                  // Add minimal required padding to hide the overscroll gradient
                  // This is calculated based on the width of the gradient (spacing.lg)
                  ...aA && DA ? {
                    paddingRight: `calc(${EA.spacing.lg} * 0.6)`
                  } : {},
                  // Apply stale effect if only this specific
                  // tab is stale but not the entire tab container.
                  ...!d && uA && STALE_STYLES
                })
              }
            },
            children: n.renderTabContent(hA)
          },
          rA
        );
      })
    }
  ) });
}
const Tabs$1 = memo$1(Tabs), useRequiredContext = (n) => {
  const t = useContext(n);
  if (t == null)
    throw new Error(`useRequiredContext: ${n.displayName ?? "context"} not found`);
  return t;
};
function FormSubmitButton(n) {
  const {
    disabled: t,
    element: g,
    widgetMgr: d,
    fragmentId: k
  } = n, {
    formId: H
  } = g, {
    formsData: AA
  } = useRequiredContext(FormsContext), gA = AA.formsWithUploads.has(H);
  let IA = BaseButtonKind.SECONDARY_FORM_SUBMIT;
  return g.type === "primary" ? IA = BaseButtonKind.PRIMARY_FORM_SUBMIT : g.type === "tertiary" && (IA = BaseButtonKind.TERTIARY_FORM_SUBMIT), useEffect(() => (d.addSubmitButton(H, g), () => d.removeSubmitButton(H, g)), [d, H, g]), /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { className: "stFormSubmitButton", "data-testid": "stFormSubmitButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButtonTooltip, { help: g.help, containerWidth: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: IA, size: BaseButtonSize.SMALL, containerWidth: !0, disabled: t || gA, onClick: () => {
    d.submitForm(g.formId, k, g);
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicButtonLabel, { icon: g.icon, label: g.label }) }) }) });
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$c() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledFormSubmitContent = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10yg2by2"
} : {
  target: "e10yg2by2",
  label: "StyledFormSubmitContent"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
}), StyledForm = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10yg2by1"
} : {
  target: "e10yg2by1",
  label: "StyledForm"
})(({
  theme: n,
  border: t,
  overflow: g
}) => ({
  ...t && {
    border: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
    borderRadius: n.radii.default,
    padding: `calc(${n.spacing.lg} - ${n.sizes.borderWidth})`
  },
  width: "100%",
  height: "100%",
  overflow: g
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10yg2by0"
} : {
  target: "e10yg2by0",
  label: "StyledErrorContainer"
})(({
  theme: n
}) => ({
  marginTop: n.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function FormSubmitContent(n) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFormSubmitContent, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormSubmitButton, { ...n }) });
}
const MISSING_SUBMIT_BUTTON_WARNING = `**Missing Submit Button**

This form has no submit button, which means that user interactions will never be sent to your Streamlit app.

To create a submit button, use the \`st.form_submit_button()\` function.

For more information, refer to the [documentation for forms](https://docs.streamlit.io/develop/api-reference/execution-flow/st.form).`;
function Form(n) {
  const {
    formId: t,
    widgetMgr: g,
    hasSubmitButton: d,
    children: k,
    scriptNotRunning: H,
    clearOnSubmit: AA,
    enterToSubmit: gA,
    border: IA,
    overflow: CA
  } = n;
  useEffect(() => {
    g.setFormSubmitBehaviors(t, AA, gA);
  }, [g, t, AA, gA]);
  const [BA, eA] = useState(!1);
  d && BA ? eA(!1) : !d && !BA && H && eA(!0);
  let iA;
  return BA && (iA = /* @__PURE__ */ jsxRuntimeExports.jsx(StyledErrorContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertElement$1, { body: MISSING_SUBMIT_BUTTON_WARNING, kind: Kind.ERROR }) })), /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledForm, { className: "stForm", "data-testid": "stForm", border: IA, overflow: CA, children: [
    k,
    iA
  ] });
}
const Form$1 = memo$1(Form);
function squareStepper(n, t) {
  const g = Math.sign(t - n), d = Math.sqrt(Math.abs(t - n)), k = n + d * g;
  return g > 0 ? Math.min(t, k) : Math.max(t, k);
}
function step(n, t, g, d) {
  let k = n;
  for (let H = 0; H < d; H++)
    k = g(k, t);
  return k;
}
function useScrollAnimation(n, t, g, d) {
  const k = useRef(0), H = useCallback((gA, IA, CA = Date.now()) => {
    cancelAnimationFrame(k.current), k.current = requestAnimationFrame(() => {
      if (n) {
        const BA = n.scrollHeight - n.offsetHeight;
        let eA = step(gA, BA, squareStepper, (Date.now() - CA) / 5);
        Math.abs(BA - eA) < 1.5 && (eA = BA), n.scrollTop = eA, BA === eA ? t() : H(gA, IA + 1, CA);
      }
    });
  }, [k, t, n]), AA = useCallback(() => {
    cancelAnimationFrame(k.current), t();
  }, [t]);
  useLayoutEffect$1(() => {
    if (!(!n || !g || !d))
      return H(n.scrollTop, 1), n ? (n.addEventListener("pointerdown", AA, {
        passive: !0
      }), n.addEventListener("wheel", AA, {
        passive: !0
      }), () => {
        n.removeEventListener("pointerdown", AA), n.removeEventListener("wheel", AA), cancelAnimationFrame(k.current);
      }) : () => cancelAnimationFrame(k.current);
  }, [H, k, AA, n, g, d]);
}
function debounce$2(n, t) {
  let g = 0, d = null;
  return (...k) => {
    const H = Date.now();
    H - g > t ? (n(...k), g = H) : (d && clearTimeout(d), d = setTimeout(() => {
      n(...k), g = Date.now();
    }, Math.max(0, t - H + g)));
  };
}
const DEFAULT_DEBOUNCE_MS = 100;
function useScrollSpy(n, t, g) {
  const d = useRef(t), k = useMemo$1(() => debounce$2((AA) => {
    d.current(AA);
  }, DEFAULT_DEBOUNCE_MS), [d]), H = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
    (AA) => {
      AA.timeStampLow = Date.now(), k(AA);
    },
    [k]
  );
  useLayoutEffect$1(() => !n || !g ? () => {
  } : (n.addEventListener("scroll", H, {
    passive: !0
  }), H({
    target: n
  }), () => n.removeEventListener("scroll", H)), [H, n, g]);
}
function useStateRef(n) {
  const [t, g] = useState(n), d = useRef(n);
  return d.current = t, [t, g, d];
}
const DEFAULT_BOTTOM_THRESHOLD = 1, SCROLL_DECISION_DURATION = 34, MIN_CHECK_INTERVAL = 17;
function setImmediateInterval(n, t) {
  return n(), setInterval(n, t);
}
function isAtBottom({
  scrollHeight: n,
  offsetHeight: t,
  scrollTop: g
}) {
  return n - g - t < DEFAULT_BOTTOM_THRESHOLD;
}
function useScrollToBottom(n) {
  const t = useRef(null), [g, d, k] = useStateRef(!1), [H, AA, gA] = useStateRef(!0);
  useEffect(() => {
    d(!0);
  }, [d]);
  const IA = useRef(0), CA = useRef(0), BA = useRef(0), eA = useCallback(() => {
    IA.current = Date.now(), gA.current || d(!1), AA(!1);
  }, [IA, gA, AA, d]), iA = useCallback(({
    timeStampLow: QA
  }) => {
    const {
      current: tA
    } = t, oA = gA.current;
    if (QA <= IA.current || !tA)
      return;
    const EA = isAtBottom(tA), {
      // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
      offsetHeight: aA,
      // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
      scrollHeight: nA
    } = tA, {
      current: lA
    } = CA, {
      current: cA
    } = BA, sA = aA !== lA, rA = nA !== cA;
    if (sA && (CA.current = aA), rA && (BA.current = nA), !sA && !rA) {
      const uA = oA || EA;
      k.current !== uA && d(uA);
    } else k.current && (AA(!0), d(!0));
  }, [IA, CA, BA, gA, k, AA, d]);
  return useEffect(() => {
    if (t.current && n) {
      let QA = 0;
      const tA = setImmediateInterval(() => {
        const {
          current: oA
        } = t, EA = gA.current;
        k.current && oA ? isAtBottom(oA) ? QA = 0 : QA ? Date.now() - QA > SCROLL_DECISION_DURATION && (EA || (AA(!0), d(!0)), QA = 0) : QA = Date.now() : oA && // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
        oA.scrollHeight <= oA.offsetHeight && !k.current && d(!0);
      }, MIN_CHECK_INTERVAL);
      return () => clearInterval(tA);
    }
  }, [t, g, H, gA, k, d, AA, n]), useEffect(() => {
    const QA = t.current;
    if (QA && n) {
      const tA = () => {
        BA.current = QA.scrollHeight;
      };
      return QA.addEventListener("focus", tA, {
        capture: !0,
        passive: !0
      }), () => {
        QA.removeEventListener("focus", tA, {
          capture: !0
        });
      };
    }
  }, [t, n]), useScrollSpy(t.current, iA, n), useScrollAnimation(t.current, eA, H, n), t;
}
var lodash_debounce, hasRequiredLodash_debounce;
function requireLodash_debounce() {
  if (hasRequiredLodash_debounce) return lodash_debounce;
  hasRequiredLodash_debounce = 1;
  var n = "Expected a function", t = NaN, g = "[object Symbol]", d = /^\s+|\s+$/g, k = /^[-+]0x[0-9a-f]+$/i, H = /^0b[01]+$/i, AA = /^0o[0-7]+$/i, gA = parseInt, IA = typeof commonjsGlobal$2 == "object" && commonjsGlobal$2 && commonjsGlobal$2.Object === Object && commonjsGlobal$2, CA = typeof self == "object" && self && self.Object === Object && self, BA = IA || CA || Function("return this")(), eA = Object.prototype, iA = eA.toString, QA = Math.max, tA = Math.min, oA = function() {
    return BA.Date.now();
  };
  function EA(sA, rA, uA) {
    var hA, dA, GA, DA, wA, bA, yA = 0, pA = !1, MA = !1, LA = !0;
    if (typeof sA != "function")
      throw new TypeError(n);
    rA = cA(rA) || 0, aA(uA) && (pA = !!uA.leading, MA = "maxWait" in uA, GA = MA ? QA(cA(uA.maxWait) || 0, rA) : GA, LA = "trailing" in uA ? !!uA.trailing : LA);
    function xA(gg) {
      var og = hA, eg = dA;
      return hA = dA = void 0, yA = gg, DA = sA.apply(eg, og), DA;
    }
    function TA(gg) {
      return yA = gg, wA = setTimeout(XA, rA), pA ? xA(gg) : DA;
    }
    function NA(gg) {
      var og = gg - bA, eg = gg - yA, kA = rA - og;
      return MA ? tA(kA, GA - eg) : kA;
    }
    function zA(gg) {
      var og = gg - bA, eg = gg - yA;
      return bA === void 0 || og >= rA || og < 0 || MA && eg >= GA;
    }
    function XA() {
      var gg = oA();
      if (zA(gg))
        return fA(gg);
      wA = setTimeout(XA, NA(gg));
    }
    function fA(gg) {
      return wA = void 0, LA && hA ? xA(gg) : (hA = dA = void 0, DA);
    }
    function vA() {
      wA !== void 0 && clearTimeout(wA), yA = 0, hA = bA = dA = wA = void 0;
    }
    function Cg() {
      return wA === void 0 ? DA : fA(oA());
    }
    function Ig() {
      var gg = oA(), og = zA(gg);
      if (hA = arguments, dA = this, bA = gg, og) {
        if (wA === void 0)
          return TA(bA);
        if (MA)
          return wA = setTimeout(XA, rA), xA(bA);
      }
      return wA === void 0 && (wA = setTimeout(XA, rA)), DA;
    }
    return Ig.cancel = vA, Ig.flush = Cg, Ig;
  }
  function aA(sA) {
    var rA = typeof sA;
    return !!sA && (rA == "object" || rA == "function");
  }
  function nA(sA) {
    return !!sA && typeof sA == "object";
  }
  function lA(sA) {
    return typeof sA == "symbol" || nA(sA) && iA.call(sA) == g;
  }
  function cA(sA) {
    if (typeof sA == "number")
      return sA;
    if (lA(sA))
      return t;
    if (aA(sA)) {
      var rA = typeof sA.valueOf == "function" ? sA.valueOf() : sA;
      sA = aA(rA) ? rA + "" : rA;
    }
    if (typeof sA != "string")
      return sA === 0 ? sA : +sA;
    sA = sA.replace(d, "");
    var uA = H.test(sA);
    return uA || AA.test(sA) ? gA(sA.slice(2), uA ? 2 : 8) : k.test(sA) ? t : +sA;
  }
  return lodash_debounce = EA, lodash_debounce;
}
var lodash_debounceExports = requireLodash_debounce();
const _debounce = /* @__PURE__ */ getDefaultExportFromCjs$2(lodash_debounceExports);
function debounceRender(n, t, g) {
  class d extends Component {
    constructor() {
      super(...arguments), this.updateDebounced = _debounce(this.forceUpdate, t, g);
    }
    shouldComponentUpdate() {
      return this.updateDebounced(), !1;
    }
    componentWillUnmount() {
      this.updateDebounced.cancel();
    }
    render() {
      return React__default.createElement(n, Object.assign({}, this.props));
    }
  }
  return d.displayName = `debounceRender(${n.displayName || n.name || "Component"})`, hoistNonReactStatics(d, n);
}
const Maybe = memo$1(function n({
  children: t
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: t });
}, (n, t) => !(n.enable || t.enable));
var _castSlice, hasRequired_castSlice;
function require_castSlice() {
  if (hasRequired_castSlice) return _castSlice;
  hasRequired_castSlice = 1;
  var n = require_baseSlice();
  function t(g, d, k) {
    var H = g.length;
    return k = k === void 0 ? H : k, !d && k >= H ? g : n(g, d, k);
  }
  return _castSlice = t, _castSlice;
}
var _baseFindIndex, hasRequired_baseFindIndex;
function require_baseFindIndex() {
  if (hasRequired_baseFindIndex) return _baseFindIndex;
  hasRequired_baseFindIndex = 1;
  function n(t, g, d, k) {
    for (var H = t.length, AA = d + (k ? 1 : -1); k ? AA-- : ++AA < H; )
      if (g(t[AA], AA, t))
        return AA;
    return -1;
  }
  return _baseFindIndex = n, _baseFindIndex;
}
var _baseIsNaN, hasRequired_baseIsNaN;
function require_baseIsNaN() {
  if (hasRequired_baseIsNaN) return _baseIsNaN;
  hasRequired_baseIsNaN = 1;
  function n(t) {
    return t !== t;
  }
  return _baseIsNaN = n, _baseIsNaN;
}
var _strictIndexOf, hasRequired_strictIndexOf;
function require_strictIndexOf() {
  if (hasRequired_strictIndexOf) return _strictIndexOf;
  hasRequired_strictIndexOf = 1;
  function n(t, g, d) {
    for (var k = d - 1, H = t.length; ++k < H; )
      if (t[k] === g)
        return k;
    return -1;
  }
  return _strictIndexOf = n, _strictIndexOf;
}
var _baseIndexOf, hasRequired_baseIndexOf;
function require_baseIndexOf() {
  if (hasRequired_baseIndexOf) return _baseIndexOf;
  hasRequired_baseIndexOf = 1;
  var n = require_baseFindIndex(), t = require_baseIsNaN(), g = require_strictIndexOf();
  function d(k, H, AA) {
    return H === H ? g(k, H, AA) : n(k, t, AA);
  }
  return _baseIndexOf = d, _baseIndexOf;
}
var _charsEndIndex, hasRequired_charsEndIndex;
function require_charsEndIndex() {
  if (hasRequired_charsEndIndex) return _charsEndIndex;
  hasRequired_charsEndIndex = 1;
  var n = require_baseIndexOf();
  function t(g, d) {
    for (var k = g.length; k-- && n(d, g[k], 0) > -1; )
      ;
    return k;
  }
  return _charsEndIndex = t, _charsEndIndex;
}
var _asciiToArray, hasRequired_asciiToArray;
function require_asciiToArray() {
  if (hasRequired_asciiToArray) return _asciiToArray;
  hasRequired_asciiToArray = 1;
  function n(t) {
    return t.split("");
  }
  return _asciiToArray = n, _asciiToArray;
}
var _hasUnicode, hasRequired_hasUnicode;
function require_hasUnicode() {
  if (hasRequired_hasUnicode) return _hasUnicode;
  hasRequired_hasUnicode = 1;
  var n = "\\ud800-\\udfff", t = "\\u0300-\\u036f", g = "\\ufe20-\\ufe2f", d = "\\u20d0-\\u20ff", k = t + g + d, H = "\\ufe0e\\ufe0f", AA = "\\u200d", gA = RegExp("[" + AA + n + k + H + "]");
  function IA(CA) {
    return gA.test(CA);
  }
  return _hasUnicode = IA, _hasUnicode;
}
var _unicodeToArray, hasRequired_unicodeToArray;
function require_unicodeToArray() {
  if (hasRequired_unicodeToArray) return _unicodeToArray;
  hasRequired_unicodeToArray = 1;
  var n = "\\ud800-\\udfff", t = "\\u0300-\\u036f", g = "\\ufe20-\\ufe2f", d = "\\u20d0-\\u20ff", k = t + g + d, H = "\\ufe0e\\ufe0f", AA = "[" + n + "]", gA = "[" + k + "]", IA = "\\ud83c[\\udffb-\\udfff]", CA = "(?:" + gA + "|" + IA + ")", BA = "[^" + n + "]", eA = "(?:\\ud83c[\\udde6-\\uddff]){2}", iA = "[\\ud800-\\udbff][\\udc00-\\udfff]", QA = "\\u200d", tA = CA + "?", oA = "[" + H + "]?", EA = "(?:" + QA + "(?:" + [BA, eA, iA].join("|") + ")" + oA + tA + ")*", aA = oA + tA + EA, nA = "(?:" + [BA + gA + "?", gA, eA, iA, AA].join("|") + ")", lA = RegExp(IA + "(?=" + IA + ")|" + nA + aA, "g");
  function cA(sA) {
    return sA.match(lA) || [];
  }
  return _unicodeToArray = cA, _unicodeToArray;
}
var _stringToArray, hasRequired_stringToArray;
function require_stringToArray() {
  if (hasRequired_stringToArray) return _stringToArray;
  hasRequired_stringToArray = 1;
  var n = require_asciiToArray(), t = require_hasUnicode(), g = require_unicodeToArray();
  function d(k) {
    return t(k) ? g(k) : n(k);
  }
  return _stringToArray = d, _stringToArray;
}
var trimEnd_1, hasRequiredTrimEnd;
function requireTrimEnd() {
  if (hasRequiredTrimEnd) return trimEnd_1;
  hasRequiredTrimEnd = 1;
  var n = require_baseToString(), t = require_castSlice(), g = require_charsEndIndex(), d = require_stringToArray(), k = requireToString(), H = require_trimmedEndIndex();
  function AA(gA, IA, CA) {
    if (gA = k(gA), gA && (CA || IA === void 0))
      return gA.slice(0, H(gA) + 1);
    if (!gA || !(IA = n(IA)))
      return gA;
    var BA = d(gA), eA = g(BA, d(IA)) + 1;
    return t(BA, 0, eA).join("");
  }
  return trimEnd_1 = AA, trimEnd_1;
}
var trimEndExports = requireTrimEnd();
const trimEnd = /* @__PURE__ */ getDefaultExportFromCjs$2(trimEndExports);
var momentTimezone$2 = { exports: {} }, momentTimezone$1 = { exports: {} };
var hookCallback;
function hooks() {
  return hookCallback.apply(null, arguments);
}
function setHookCallback(n) {
  hookCallback = n;
}
function isArray$4(n) {
  return n instanceof Array || Object.prototype.toString.call(n) === "[object Array]";
}
function isObject$5(n) {
  return n != null && Object.prototype.toString.call(n) === "[object Object]";
}
function hasOwnProp(n, t) {
  return Object.prototype.hasOwnProperty.call(n, t);
}
function isObjectEmpty(n) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(n).length === 0;
  var t;
  for (t in n)
    if (hasOwnProp(n, t))
      return !1;
  return !0;
}
function isUndefined$2(n) {
  return n === void 0;
}
function isNumber$4(n) {
  return typeof n == "number" || Object.prototype.toString.call(n) === "[object Number]";
}
function isDate$3(n) {
  return n instanceof Date || Object.prototype.toString.call(n) === "[object Date]";
}
function map$3(n, t) {
  var g = [], d, k = n.length;
  for (d = 0; d < k; ++d)
    g.push(t(n[d], d));
  return g;
}
function extend$3(n, t) {
  for (var g in t)
    hasOwnProp(t, g) && (n[g] = t[g]);
  return hasOwnProp(t, "toString") && (n.toString = t.toString), hasOwnProp(t, "valueOf") && (n.valueOf = t.valueOf), n;
}
function createUTC(n, t, g, d) {
  return createLocalOrUTC(n, t, g, d, !0).utc();
}
function defaultParsingFlags() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function getParsingFlags(n) {
  return n._pf == null && (n._pf = defaultParsingFlags()), n._pf;
}
var some$1;
Array.prototype.some ? some$1 = Array.prototype.some : some$1 = function(n) {
  var t = Object(this), g = t.length >>> 0, d;
  for (d = 0; d < g; d++)
    if (d in t && n.call(this, t[d], d, t))
      return !0;
  return !1;
};
function isValid$2(n) {
  var t = null, g = !1, d = n._d && !isNaN(n._d.getTime());
  if (d && (t = getParsingFlags(n), g = some$1.call(t.parsedDateParts, function(k) {
    return k != null;
  }), d = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && g), n._strict && (d = d && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(n))
    n._isValid = d;
  else
    return d;
  return n._isValid;
}
function createInvalid(n) {
  var t = createUTC(NaN);
  return n != null ? extend$3(getParsingFlags(t), n) : getParsingFlags(t).userInvalidated = !0, t;
}
var momentProperties = hooks.momentProperties = [], updateInProgress = !1;
function copyConfig(n, t) {
  var g, d, k, H = momentProperties.length;
  if (isUndefined$2(t._isAMomentObject) || (n._isAMomentObject = t._isAMomentObject), isUndefined$2(t._i) || (n._i = t._i), isUndefined$2(t._f) || (n._f = t._f), isUndefined$2(t._l) || (n._l = t._l), isUndefined$2(t._strict) || (n._strict = t._strict), isUndefined$2(t._tzm) || (n._tzm = t._tzm), isUndefined$2(t._isUTC) || (n._isUTC = t._isUTC), isUndefined$2(t._offset) || (n._offset = t._offset), isUndefined$2(t._pf) || (n._pf = getParsingFlags(t)), isUndefined$2(t._locale) || (n._locale = t._locale), H > 0)
    for (g = 0; g < H; g++)
      d = momentProperties[g], k = t[d], isUndefined$2(k) || (n[d] = k);
  return n;
}
function Moment(n) {
  copyConfig(this, n), this._d = new Date(n._d != null ? n._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), updateInProgress === !1 && (updateInProgress = !0, hooks.updateOffset(this), updateInProgress = !1);
}
function isMoment(n) {
  return n instanceof Moment || n != null && n._isAMomentObject != null;
}
function warn$2(n) {
  hooks.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + n);
}
function deprecate(n, t) {
  var g = !0;
  return extend$3(function() {
    if (hooks.deprecationHandler != null && hooks.deprecationHandler(null, n), g) {
      var d = [], k, H, AA, gA = arguments.length;
      for (H = 0; H < gA; H++) {
        if (k = "", typeof arguments[H] == "object") {
          k += `
[` + H + "] ";
          for (AA in arguments[0])
            hasOwnProp(arguments[0], AA) && (k += AA + ": " + arguments[0][AA] + ", ");
          k = k.slice(0, -2);
        } else
          k = arguments[H];
        d.push(k);
      }
      warn$2(
        n + `
Arguments: ` + Array.prototype.slice.call(d).join("") + `
` + new Error().stack
      ), g = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var deprecations = {};
function deprecateSimple(n, t) {
  hooks.deprecationHandler != null && hooks.deprecationHandler(n, t), deprecations[n] || (warn$2(t), deprecations[n] = !0);
}
hooks.suppressDeprecationWarnings = !1;
hooks.deprecationHandler = null;
function isFunction$6(n) {
  return typeof Function < "u" && n instanceof Function || Object.prototype.toString.call(n) === "[object Function]";
}
function set$7(n) {
  var t, g;
  for (g in n)
    hasOwnProp(n, g) && (t = n[g], isFunction$6(t) ? this[g] = t : this["_" + g] = t);
  this._config = n, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function mergeConfigs(n, t) {
  var g = extend$3({}, n), d;
  for (d in t)
    hasOwnProp(t, d) && (isObject$5(n[d]) && isObject$5(t[d]) ? (g[d] = {}, extend$3(g[d], n[d]), extend$3(g[d], t[d])) : t[d] != null ? g[d] = t[d] : delete g[d]);
  for (d in n)
    hasOwnProp(n, d) && !hasOwnProp(t, d) && isObject$5(n[d]) && (g[d] = extend$3({}, g[d]));
  return g;
}
function Locale(n) {
  n != null && this.set(n);
}
var keys$4;
Object.keys ? keys$4 = Object.keys : keys$4 = function(n) {
  var t, g = [];
  for (t in n)
    hasOwnProp(n, t) && g.push(t);
  return g;
};
var defaultCalendar = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function calendar$1(n, t, g) {
  var d = this._calendar[n] || this._calendar.sameElse;
  return isFunction$6(d) ? d.call(t, g) : d;
}
function zeroFill(n, t, g) {
  var d = "" + Math.abs(n), k = t - d.length, H = n >= 0;
  return (H ? g ? "+" : "" : "-") + Math.pow(10, Math.max(0, k)).toString().substr(1) + d;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
function addFormatToken(n, t, g, d) {
  var k = d;
  typeof d == "string" && (k = function() {
    return this[d]();
  }), n && (formatTokenFunctions[n] = k), t && (formatTokenFunctions[t[0]] = function() {
    return zeroFill(k.apply(this, arguments), t[1], t[2]);
  }), g && (formatTokenFunctions[g] = function() {
    return this.localeData().ordinal(
      k.apply(this, arguments),
      n
    );
  });
}
function removeFormattingTokens(n) {
  return n.match(/\[[\s\S]/) ? n.replace(/^\[|\]$/g, "") : n.replace(/\\/g, "");
}
function makeFormatFunction(n) {
  var t = n.match(formattingTokens), g, d;
  for (g = 0, d = t.length; g < d; g++)
    formatTokenFunctions[t[g]] ? t[g] = formatTokenFunctions[t[g]] : t[g] = removeFormattingTokens(t[g]);
  return function(k) {
    var H = "", AA;
    for (AA = 0; AA < d; AA++)
      H += isFunction$6(t[AA]) ? t[AA].call(k, n) : t[AA];
    return H;
  };
}
function formatMoment(n, t) {
  return n.isValid() ? (t = expandFormat(t, n.localeData()), formatFunctions[t] = formatFunctions[t] || makeFormatFunction(t), formatFunctions[t](n)) : n.localeData().invalidDate();
}
function expandFormat(n, t) {
  var g = 5;
  function d(k) {
    return t.longDateFormat(k) || k;
  }
  for (localFormattingTokens.lastIndex = 0; g >= 0 && localFormattingTokens.test(n); )
    n = n.replace(
      localFormattingTokens,
      d
    ), localFormattingTokens.lastIndex = 0, g -= 1;
  return n;
}
var defaultLongDateFormat = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(n) {
  var t = this._longDateFormat[n], g = this._longDateFormat[n.toUpperCase()];
  return t || !g ? t : (this._longDateFormat[n] = g.match(formattingTokens).map(function(d) {
    return d === "MMMM" || d === "MM" || d === "DD" || d === "dddd" ? d.slice(1) : d;
  }).join(""), this._longDateFormat[n]);
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
  return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal$1(n) {
  return this._ordinal.replace("%d", n);
}
var defaultRelativeTime = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function relativeTime(n, t, g, d) {
  var k = this._relativeTime[g];
  return isFunction$6(k) ? k(n, t, g, d) : k.replace(/%d/i, n);
}
function pastFuture(n, t) {
  var g = this._relativeTime[n > 0 ? "future" : "past"];
  return isFunction$6(g) ? g(t) : g.replace(/%s/i, t);
}
var aliases = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function normalizeUnits(n) {
  return typeof n == "string" ? aliases[n] || aliases[n.toLowerCase()] : void 0;
}
function normalizeObjectUnits(n) {
  var t = {}, g, d;
  for (d in n)
    hasOwnProp(n, d) && (g = normalizeUnits(d), g && (t[g] = n[d]));
  return t;
}
var priorities = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function getPrioritizedUnits(n) {
  var t = [], g;
  for (g in n)
    hasOwnProp(n, g) && t.push({ unit: g, priority: priorities[g] });
  return t.sort(function(d, k) {
    return d.priority - k.priority;
  }), t;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
regexes = {};
function addRegexToken(n, t, g) {
  regexes[n] = isFunction$6(t) ? t : function(d, k) {
    return d && g ? g : t;
  };
}
function getParseRegexForToken(n, t) {
  return hasOwnProp(regexes, n) ? regexes[n](t._strict, t._locale) : new RegExp(unescapeFormat(n));
}
function unescapeFormat(n) {
  return regexEscape(
    n.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, g, d, k, H) {
        return g || d || k || H;
      }
    )
  );
}
function regexEscape(n) {
  return n.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function absFloor(n) {
  return n < 0 ? Math.ceil(n) || 0 : Math.floor(n);
}
function toInt(n) {
  var t = +n, g = 0;
  return t !== 0 && isFinite(t) && (g = absFloor(t)), g;
}
var tokens = {};
function addParseToken(n, t) {
  var g, d = t, k;
  for (typeof n == "string" && (n = [n]), isNumber$4(t) && (d = function(H, AA) {
    AA[t] = toInt(H);
  }), k = n.length, g = 0; g < k; g++)
    tokens[n[g]] = d;
}
function addWeekParseToken(n, t) {
  addParseToken(n, function(g, d, k, H) {
    k._w = k._w || {}, t(g, k._w, k, H);
  });
}
function addTimeToArrayFromToken(n, t, g) {
  t != null && hasOwnProp(tokens, n) && tokens[n](t, g._a, g, n);
}
function isLeapYear(n) {
  return n % 4 === 0 && n % 100 !== 0 || n % 400 === 0;
}
var YEAR$1 = 0, MONTH$1 = 1, DATE$1 = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK$1 = 7, WEEKDAY = 8;
addFormatToken("Y", 0, 0, function() {
  var n = this.year();
  return n <= 9999 ? zeroFill(n, 4) : "+" + n;
});
addFormatToken(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
addFormatToken(0, ["YYYY", 4], 0, "year");
addFormatToken(0, ["YYYYY", 5], 0, "year");
addFormatToken(0, ["YYYYYY", 6, !0], 0, "year");
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken(["YYYYY", "YYYYYY"], YEAR$1);
addParseToken("YYYY", function(n, t) {
  t[YEAR$1] = n.length === 2 ? hooks.parseTwoDigitYear(n) : toInt(n);
});
addParseToken("YY", function(n, t) {
  t[YEAR$1] = hooks.parseTwoDigitYear(n);
});
addParseToken("Y", function(n, t) {
  t[YEAR$1] = parseInt(n, 10);
});
function daysInYear(n) {
  return isLeapYear(n) ? 366 : 365;
}
hooks.parseTwoDigitYear = function(n) {
  return toInt(n) + (toInt(n) > 68 ? 1900 : 2e3);
};
var getSetYear = makeGetSet("FullYear", !0);
function getIsLeapYear() {
  return isLeapYear(this.year());
}
function makeGetSet(n, t) {
  return function(g) {
    return g != null ? (set$1$1(this, n, g), hooks.updateOffset(this, t), this) : get$7(this, n);
  };
}
function get$7(n, t) {
  if (!n.isValid())
    return NaN;
  var g = n._d, d = n._isUTC;
  switch (t) {
    case "Milliseconds":
      return d ? g.getUTCMilliseconds() : g.getMilliseconds();
    case "Seconds":
      return d ? g.getUTCSeconds() : g.getSeconds();
    case "Minutes":
      return d ? g.getUTCMinutes() : g.getMinutes();
    case "Hours":
      return d ? g.getUTCHours() : g.getHours();
    case "Date":
      return d ? g.getUTCDate() : g.getDate();
    case "Day":
      return d ? g.getUTCDay() : g.getDay();
    case "Month":
      return d ? g.getUTCMonth() : g.getMonth();
    case "FullYear":
      return d ? g.getUTCFullYear() : g.getFullYear();
    default:
      return NaN;
  }
}
function set$1$1(n, t, g) {
  var d, k, H, AA, gA;
  if (!(!n.isValid() || isNaN(g))) {
    switch (d = n._d, k = n._isUTC, t) {
      case "Milliseconds":
        return void (k ? d.setUTCMilliseconds(g) : d.setMilliseconds(g));
      case "Seconds":
        return void (k ? d.setUTCSeconds(g) : d.setSeconds(g));
      case "Minutes":
        return void (k ? d.setUTCMinutes(g) : d.setMinutes(g));
      case "Hours":
        return void (k ? d.setUTCHours(g) : d.setHours(g));
      case "Date":
        return void (k ? d.setUTCDate(g) : d.setDate(g));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case "FullYear":
        break;
      // See below ...
      default:
        return;
    }
    H = g, AA = n.month(), gA = n.date(), gA = gA === 29 && AA === 1 && !isLeapYear(H) ? 28 : gA, k ? d.setUTCFullYear(H, AA, gA) : d.setFullYear(H, AA, gA);
  }
}
function stringGet(n) {
  return n = normalizeUnits(n), isFunction$6(this[n]) ? this[n]() : this;
}
function stringSet(n, t) {
  if (typeof n == "object") {
    n = normalizeObjectUnits(n);
    var g = getPrioritizedUnits(n), d, k = g.length;
    for (d = 0; d < k; d++)
      this[g[d].unit](n[g[d].unit]);
  } else if (n = normalizeUnits(n), isFunction$6(this[n]))
    return this[n](t);
  return this;
}
function mod(n, t) {
  return (n % t + t) % t;
}
var indexOf;
Array.prototype.indexOf ? indexOf = Array.prototype.indexOf : indexOf = function(n) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === n)
      return t;
  return -1;
};
function daysInMonth(n, t) {
  if (isNaN(n) || isNaN(t))
    return NaN;
  var g = mod(t, 12);
  return n += (t - g) / 12, g === 1 ? isLeapYear(n) ? 29 : 28 : 31 - g % 7 % 2;
}
addFormatToken("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(n) {
  return this.localeData().monthsShort(this, n);
});
addFormatToken("MMMM", 0, 0, function(n) {
  return this.localeData().months(this, n);
});
addRegexToken("M", match1to2, match1to2NoLeadingZero);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(n, t) {
  return t.monthsShortRegex(n);
});
addRegexToken("MMMM", function(n, t) {
  return t.monthsRegex(n);
});
addParseToken(["M", "MM"], function(n, t) {
  t[MONTH$1] = toInt(n) - 1;
});
addParseToken(["MMM", "MMMM"], function(n, t, g, d) {
  var k = g._locale.monthsParse(n, d, g._strict);
  k != null ? t[MONTH$1] = k : getParsingFlags(g).invalidMonth = n;
});
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(n, t) {
  return n ? isArray$4(this._months) ? this._months[n.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(t) ? "format" : "standalone"][n.month()] : isArray$4(this._months) ? this._months : this._months.standalone;
}
function localeMonthsShort(n, t) {
  return n ? isArray$4(this._monthsShort) ? this._monthsShort[n.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(t) ? "format" : "standalone"][n.month()] : isArray$4(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function handleStrictParse(n, t, g) {
  var d, k, H, AA = n.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], d = 0; d < 12; ++d)
      H = createUTC([2e3, d]), this._shortMonthsParse[d] = this.monthsShort(
        H,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[d] = this.months(H, "").toLocaleLowerCase();
  return g ? t === "MMM" ? (k = indexOf.call(this._shortMonthsParse, AA), k !== -1 ? k : null) : (k = indexOf.call(this._longMonthsParse, AA), k !== -1 ? k : null) : t === "MMM" ? (k = indexOf.call(this._shortMonthsParse, AA), k !== -1 ? k : (k = indexOf.call(this._longMonthsParse, AA), k !== -1 ? k : null)) : (k = indexOf.call(this._longMonthsParse, AA), k !== -1 ? k : (k = indexOf.call(this._shortMonthsParse, AA), k !== -1 ? k : null));
}
function localeMonthsParse(n, t, g) {
  var d, k, H;
  if (this._monthsParseExact)
    return handleStrictParse.call(this, n, t, g);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), d = 0; d < 12; d++) {
    if (k = createUTC([2e3, d]), g && !this._longMonthsParse[d] && (this._longMonthsParse[d] = new RegExp(
      "^" + this.months(k, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[d] = new RegExp(
      "^" + this.monthsShort(k, "").replace(".", "") + "$",
      "i"
    )), !g && !this._monthsParse[d] && (H = "^" + this.months(k, "") + "|^" + this.monthsShort(k, ""), this._monthsParse[d] = new RegExp(H.replace(".", ""), "i")), g && t === "MMMM" && this._longMonthsParse[d].test(n))
      return d;
    if (g && t === "MMM" && this._shortMonthsParse[d].test(n))
      return d;
    if (!g && this._monthsParse[d].test(n))
      return d;
  }
}
function setMonth(n, t) {
  if (!n.isValid())
    return n;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = toInt(t);
    else if (t = n.localeData().monthsParse(t), !isNumber$4(t))
      return n;
  }
  var g = t, d = n.date();
  return d = d < 29 ? d : Math.min(d, daysInMonth(n.year(), g)), n._isUTC ? n._d.setUTCMonth(g, d) : n._d.setMonth(g, d), n;
}
function getSetMonth(n) {
  return n != null ? (setMonth(this, n), hooks.updateOffset(this, !0), this) : get$7(this, "Month");
}
function getDaysInMonth() {
  return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(n) {
  return this._monthsParseExact ? (hasOwnProp(this, "_monthsRegex") || computeMonthsParse.call(this), n ? this._monthsShortStrictRegex : this._monthsShortRegex) : (hasOwnProp(this, "_monthsShortRegex") || (this._monthsShortRegex = defaultMonthsShortRegex), this._monthsShortStrictRegex && n ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function monthsRegex(n) {
  return this._monthsParseExact ? (hasOwnProp(this, "_monthsRegex") || computeMonthsParse.call(this), n ? this._monthsStrictRegex : this._monthsRegex) : (hasOwnProp(this, "_monthsRegex") || (this._monthsRegex = defaultMonthsRegex), this._monthsStrictRegex && n ? this._monthsStrictRegex : this._monthsRegex);
}
function computeMonthsParse() {
  function n(IA, CA) {
    return CA.length - IA.length;
  }
  var t = [], g = [], d = [], k, H, AA, gA;
  for (k = 0; k < 12; k++)
    H = createUTC([2e3, k]), AA = regexEscape(this.monthsShort(H, "")), gA = regexEscape(this.months(H, "")), t.push(AA), g.push(gA), d.push(gA), d.push(AA);
  t.sort(n), g.sort(n), d.sort(n), this._monthsRegex = new RegExp("^(" + d.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + g.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function createDate(n, t, g, d, k, H, AA) {
  var gA;
  return n < 100 && n >= 0 ? (gA = new Date(n + 400, t, g, d, k, H, AA), isFinite(gA.getFullYear()) && gA.setFullYear(n)) : gA = new Date(n, t, g, d, k, H, AA), gA;
}
function createUTCDate(n) {
  var t, g;
  return n < 100 && n >= 0 ? (g = Array.prototype.slice.call(arguments), g[0] = n + 400, t = new Date(Date.UTC.apply(null, g)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(n)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function firstWeekOffset(n, t, g) {
  var d = 7 + t - g, k = (7 + createUTCDate(n, 0, d).getUTCDay() - t) % 7;
  return -k + d - 1;
}
function dayOfYearFromWeeks(n, t, g, d, k) {
  var H = (7 + g - d) % 7, AA = firstWeekOffset(n, d, k), gA = 1 + 7 * (t - 1) + H + AA, IA, CA;
  return gA <= 0 ? (IA = n - 1, CA = daysInYear(IA) + gA) : gA > daysInYear(n) ? (IA = n + 1, CA = gA - daysInYear(n)) : (IA = n, CA = gA), {
    year: IA,
    dayOfYear: CA
  };
}
function weekOfYear(n, t, g) {
  var d = firstWeekOffset(n.year(), t, g), k = Math.floor((n.dayOfYear() - d - 1) / 7) + 1, H, AA;
  return k < 1 ? (AA = n.year() - 1, H = k + weeksInYear(AA, t, g)) : k > weeksInYear(n.year(), t, g) ? (H = k - weeksInYear(n.year(), t, g), AA = n.year() + 1) : (AA = n.year(), H = k), {
    week: H,
    year: AA
  };
}
function weeksInYear(n, t, g) {
  var d = firstWeekOffset(n, t, g), k = firstWeekOffset(n + 1, t, g);
  return (daysInYear(n) - d + k) / 7;
}
addFormatToken("w", ["ww", 2], "wo", "week");
addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
addRegexToken("w", match1to2, match1to2NoLeadingZero);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2, match1to2NoLeadingZero);
addRegexToken("WW", match1to2, match2);
addWeekParseToken(
  ["w", "ww", "W", "WW"],
  function(n, t, g, d) {
    t[d.substr(0, 1)] = toInt(n);
  }
);
function localeWeek(n) {
  return weekOfYear(n, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function localeFirstDayOfWeek() {
  return this._week.dow;
}
function localeFirstDayOfYear() {
  return this._week.doy;
}
function getSetWeek(n) {
  var t = this.localeData().week(this);
  return n == null ? t : this.add((n - t) * 7, "d");
}
function getSetISOWeek(n) {
  var t = weekOfYear(this, 1, 4).week;
  return n == null ? t : this.add((n - t) * 7, "d");
}
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(n) {
  return this.localeData().weekdaysMin(this, n);
});
addFormatToken("ddd", 0, 0, function(n) {
  return this.localeData().weekdaysShort(this, n);
});
addFormatToken("dddd", 0, 0, function(n) {
  return this.localeData().weekdays(this, n);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(n, t) {
  return t.weekdaysMinRegex(n);
});
addRegexToken("ddd", function(n, t) {
  return t.weekdaysShortRegex(n);
});
addRegexToken("dddd", function(n, t) {
  return t.weekdaysRegex(n);
});
addWeekParseToken(["dd", "ddd", "dddd"], function(n, t, g, d) {
  var k = g._locale.weekdaysParse(n, d, g._strict);
  k != null ? t.d = k : getParsingFlags(g).invalidWeekday = n;
});
addWeekParseToken(["d", "e", "E"], function(n, t, g, d) {
  t[d] = toInt(n);
});
function parseWeekday(n, t) {
  return typeof n != "string" ? n : isNaN(n) ? (n = t.weekdaysParse(n), typeof n == "number" ? n : null) : parseInt(n, 10);
}
function parseIsoWeekday(n, t) {
  return typeof n == "string" ? t.weekdaysParse(n) % 7 || 7 : isNaN(n) ? null : n;
}
function shiftWeekdays(n, t) {
  return n.slice(t, 7).concat(n.slice(0, t));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(n, t) {
  var g = isArray$4(this._weekdays) ? this._weekdays : this._weekdays[n && n !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return n === !0 ? shiftWeekdays(g, this._week.dow) : n ? g[n.day()] : g;
}
function localeWeekdaysShort(n) {
  return n === !0 ? shiftWeekdays(this._weekdaysShort, this._week.dow) : n ? this._weekdaysShort[n.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(n) {
  return n === !0 ? shiftWeekdays(this._weekdaysMin, this._week.dow) : n ? this._weekdaysMin[n.day()] : this._weekdaysMin;
}
function handleStrictParse$1(n, t, g) {
  var d, k, H, AA = n.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], d = 0; d < 7; ++d)
      H = createUTC([2e3, 1]).day(d), this._minWeekdaysParse[d] = this.weekdaysMin(
        H,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[d] = this.weekdaysShort(
        H,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[d] = this.weekdays(H, "").toLocaleLowerCase();
  return g ? t === "dddd" ? (k = indexOf.call(this._weekdaysParse, AA), k !== -1 ? k : null) : t === "ddd" ? (k = indexOf.call(this._shortWeekdaysParse, AA), k !== -1 ? k : null) : (k = indexOf.call(this._minWeekdaysParse, AA), k !== -1 ? k : null) : t === "dddd" ? (k = indexOf.call(this._weekdaysParse, AA), k !== -1 || (k = indexOf.call(this._shortWeekdaysParse, AA), k !== -1) ? k : (k = indexOf.call(this._minWeekdaysParse, AA), k !== -1 ? k : null)) : t === "ddd" ? (k = indexOf.call(this._shortWeekdaysParse, AA), k !== -1 || (k = indexOf.call(this._weekdaysParse, AA), k !== -1) ? k : (k = indexOf.call(this._minWeekdaysParse, AA), k !== -1 ? k : null)) : (k = indexOf.call(this._minWeekdaysParse, AA), k !== -1 || (k = indexOf.call(this._weekdaysParse, AA), k !== -1) ? k : (k = indexOf.call(this._shortWeekdaysParse, AA), k !== -1 ? k : null));
}
function localeWeekdaysParse(n, t, g) {
  var d, k, H;
  if (this._weekdaysParseExact)
    return handleStrictParse$1.call(this, n, t, g);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), d = 0; d < 7; d++) {
    if (k = createUTC([2e3, 1]).day(d), g && !this._fullWeekdaysParse[d] && (this._fullWeekdaysParse[d] = new RegExp(
      "^" + this.weekdays(k, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[d] = new RegExp(
      "^" + this.weekdaysShort(k, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[d] = new RegExp(
      "^" + this.weekdaysMin(k, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[d] || (H = "^" + this.weekdays(k, "") + "|^" + this.weekdaysShort(k, "") + "|^" + this.weekdaysMin(k, ""), this._weekdaysParse[d] = new RegExp(H.replace(".", ""), "i")), g && t === "dddd" && this._fullWeekdaysParse[d].test(n))
      return d;
    if (g && t === "ddd" && this._shortWeekdaysParse[d].test(n))
      return d;
    if (g && t === "dd" && this._minWeekdaysParse[d].test(n))
      return d;
    if (!g && this._weekdaysParse[d].test(n))
      return d;
  }
}
function getSetDayOfWeek(n) {
  if (!this.isValid())
    return n != null ? this : NaN;
  var t = get$7(this, "Day");
  return n != null ? (n = parseWeekday(n, this.localeData()), this.add(n - t, "d")) : t;
}
function getSetLocaleDayOfWeek(n) {
  if (!this.isValid())
    return n != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return n == null ? t : this.add(n - t, "d");
}
function getSetISODayOfWeek(n) {
  if (!this.isValid())
    return n != null ? this : NaN;
  if (n != null) {
    var t = parseIsoWeekday(n, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function weekdaysRegex(n) {
  return this._weekdaysParseExact ? (hasOwnProp(this, "_weekdaysRegex") || computeWeekdaysParse.call(this), n ? this._weekdaysStrictRegex : this._weekdaysRegex) : (hasOwnProp(this, "_weekdaysRegex") || (this._weekdaysRegex = defaultWeekdaysRegex), this._weekdaysStrictRegex && n ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function weekdaysShortRegex(n) {
  return this._weekdaysParseExact ? (hasOwnProp(this, "_weekdaysRegex") || computeWeekdaysParse.call(this), n ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (hasOwnProp(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = defaultWeekdaysShortRegex), this._weekdaysShortStrictRegex && n ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function weekdaysMinRegex(n) {
  return this._weekdaysParseExact ? (hasOwnProp(this, "_weekdaysRegex") || computeWeekdaysParse.call(this), n ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (hasOwnProp(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = defaultWeekdaysMinRegex), this._weekdaysMinStrictRegex && n ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function computeWeekdaysParse() {
  function n(BA, eA) {
    return eA.length - BA.length;
  }
  var t = [], g = [], d = [], k = [], H, AA, gA, IA, CA;
  for (H = 0; H < 7; H++)
    AA = createUTC([2e3, 1]).day(H), gA = regexEscape(this.weekdaysMin(AA, "")), IA = regexEscape(this.weekdaysShort(AA, "")), CA = regexEscape(this.weekdays(AA, "")), t.push(gA), g.push(IA), d.push(CA), k.push(gA), k.push(IA), k.push(CA);
  t.sort(n), g.sort(n), d.sort(n), k.sort(n), this._weekdaysRegex = new RegExp("^(" + k.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + d.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + g.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function hFormat() {
  return this.hours() % 12 || 12;
}
function kFormat() {
  return this.hours() || 24;
}
addFormatToken("H", ["HH", 2], 0, "hour");
addFormatToken("h", ["hh", 2], 0, hFormat);
addFormatToken("k", ["kk", 2], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(n, t) {
  addFormatToken(n, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
meridiem("a", !0);
meridiem("A", !1);
function matchMeridiem(n, t) {
  return t._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2, match1to2HasZero);
addRegexToken("h", match1to2, match1to2NoLeadingZero);
addRegexToken("k", match1to2, match1to2NoLeadingZero);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken(["H", "HH"], HOUR);
addParseToken(["k", "kk"], function(n, t, g) {
  var d = toInt(n);
  t[HOUR] = d === 24 ? 0 : d;
});
addParseToken(["a", "A"], function(n, t, g) {
  g._isPm = g._locale.isPM(n), g._meridiem = n;
});
addParseToken(["h", "hh"], function(n, t, g) {
  t[HOUR] = toInt(n), getParsingFlags(g).bigHour = !0;
});
addParseToken("hmm", function(n, t, g) {
  var d = n.length - 2;
  t[HOUR] = toInt(n.substr(0, d)), t[MINUTE] = toInt(n.substr(d)), getParsingFlags(g).bigHour = !0;
});
addParseToken("hmmss", function(n, t, g) {
  var d = n.length - 4, k = n.length - 2;
  t[HOUR] = toInt(n.substr(0, d)), t[MINUTE] = toInt(n.substr(d, 2)), t[SECOND] = toInt(n.substr(k)), getParsingFlags(g).bigHour = !0;
});
addParseToken("Hmm", function(n, t, g) {
  var d = n.length - 2;
  t[HOUR] = toInt(n.substr(0, d)), t[MINUTE] = toInt(n.substr(d));
});
addParseToken("Hmmss", function(n, t, g) {
  var d = n.length - 4, k = n.length - 2;
  t[HOUR] = toInt(n.substr(0, d)), t[MINUTE] = toInt(n.substr(d, 2)), t[SECOND] = toInt(n.substr(k));
});
function localeIsPM(n) {
  return (n + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", !0);
function localeMeridiem(n, t, g) {
  return n > 11 ? g ? "pm" : "PM" : g ? "am" : "AM";
}
var baseConfig = {
  calendar: defaultCalendar,
  longDateFormat: defaultLongDateFormat,
  invalidDate: defaultInvalidDate,
  ordinal: defaultOrdinal,
  dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
  relativeTime: defaultRelativeTime,
  months: defaultLocaleMonths,
  monthsShort: defaultLocaleMonthsShort,
  week: defaultLocaleWeek,
  weekdays: defaultLocaleWeekdays,
  weekdaysMin: defaultLocaleWeekdaysMin,
  weekdaysShort: defaultLocaleWeekdaysShort,
  meridiemParse: defaultLocaleMeridiemParse
}, locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(n, t) {
  var g, d = Math.min(n.length, t.length);
  for (g = 0; g < d; g += 1)
    if (n[g] !== t[g])
      return g;
  return d;
}
function normalizeLocale(n) {
  return n && n.toLowerCase().replace("_", "-");
}
function chooseLocale(n) {
  for (var t = 0, g, d, k, H; t < n.length; ) {
    for (H = normalizeLocale(n[t]).split("-"), g = H.length, d = normalizeLocale(n[t + 1]), d = d ? d.split("-") : null; g > 0; ) {
      if (k = loadLocale(H.slice(0, g).join("-")), k)
        return k;
      if (d && d.length >= g && commonPrefix(H, d) >= g - 1)
        break;
      g--;
    }
    t++;
  }
  return globalLocale;
}
function isLocaleNameSane(n) {
  return !!(n && n.match("^[^/\\\\]*$"));
}
function loadLocale(n) {
  var t = null, g;
  if (locales[n] === void 0 && typeof module < "u" && module && module.exports && isLocaleNameSane(n))
    try {
      t = globalLocale._abbr, g = require, g("./locale/" + n), getSetGlobalLocale(t);
    } catch {
      locales[n] = null;
    }
  return locales[n];
}
function getSetGlobalLocale(n, t) {
  var g;
  return n && (isUndefined$2(t) ? g = getLocale(n) : g = defineLocale(n, t), g ? globalLocale = g : typeof console < "u" && console.warn && console.warn(
    "Locale " + n + " not found. Did you forget to load it?"
  )), globalLocale._abbr;
}
function defineLocale(n, t) {
  if (t !== null) {
    var g, d = baseConfig;
    if (t.abbr = n, locales[n] != null)
      deprecateSimple(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), d = locales[n]._config;
    else if (t.parentLocale != null)
      if (locales[t.parentLocale] != null)
        d = locales[t.parentLocale]._config;
      else if (g = loadLocale(t.parentLocale), g != null)
        d = g._config;
      else
        return localeFamilies[t.parentLocale] || (localeFamilies[t.parentLocale] = []), localeFamilies[t.parentLocale].push({
          name: n,
          config: t
        }), null;
    return locales[n] = new Locale(mergeConfigs(d, t)), localeFamilies[n] && localeFamilies[n].forEach(function(k) {
      defineLocale(k.name, k.config);
    }), getSetGlobalLocale(n), locales[n];
  } else
    return delete locales[n], null;
}
function updateLocale(n, t) {
  if (t != null) {
    var g, d, k = baseConfig;
    locales[n] != null && locales[n].parentLocale != null ? locales[n].set(mergeConfigs(locales[n]._config, t)) : (d = loadLocale(n), d != null && (k = d._config), t = mergeConfigs(k, t), d == null && (t.abbr = n), g = new Locale(t), g.parentLocale = locales[n], locales[n] = g), getSetGlobalLocale(n);
  } else
    locales[n] != null && (locales[n].parentLocale != null ? (locales[n] = locales[n].parentLocale, n === getSetGlobalLocale() && getSetGlobalLocale(n)) : locales[n] != null && delete locales[n]);
  return locales[n];
}
function getLocale(n) {
  var t;
  if (n && n._locale && n._locale._abbr && (n = n._locale._abbr), !n)
    return globalLocale;
  if (!isArray$4(n)) {
    if (t = loadLocale(n), t)
      return t;
    n = [n];
  }
  return chooseLocale(n);
}
function listLocales() {
  return keys$4(locales);
}
function checkOverflow(n) {
  var t, g = n._a;
  return g && getParsingFlags(n).overflow === -2 && (t = g[MONTH$1] < 0 || g[MONTH$1] > 11 ? MONTH$1 : g[DATE$1] < 1 || g[DATE$1] > daysInMonth(g[YEAR$1], g[MONTH$1]) ? DATE$1 : g[HOUR] < 0 || g[HOUR] > 24 || g[HOUR] === 24 && (g[MINUTE] !== 0 || g[SECOND] !== 0 || g[MILLISECOND] !== 0) ? HOUR : g[MINUTE] < 0 || g[MINUTE] > 59 ? MINUTE : g[SECOND] < 0 || g[SECOND] > 59 ? SECOND : g[MILLISECOND] < 0 || g[MILLISECOND] > 999 ? MILLISECOND : -1, getParsingFlags(n)._overflowDayOfYear && (t < YEAR$1 || t > DATE$1) && (t = DATE$1), getParsingFlags(n)._overflowWeeks && t === -1 && (t = WEEK$1), getParsingFlags(n)._overflowWeekday && t === -1 && (t = WEEKDAY), getParsingFlags(n).overflow = t), n;
}
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], isoTimes = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
  UT: 0,
  GMT: 0,
  EDT: -240,
  EST: -300,
  CDT: -300,
  CST: -360,
  MDT: -360,
  MST: -420,
  PDT: -420,
  PST: -480
};
function configFromISO(n) {
  var t, g, d = n._i, k = extendedIsoRegex.exec(d) || basicIsoRegex.exec(d), H, AA, gA, IA, CA = isoDates.length, BA = isoTimes.length;
  if (k) {
    for (getParsingFlags(n).iso = !0, t = 0, g = CA; t < g; t++)
      if (isoDates[t][1].exec(k[1])) {
        AA = isoDates[t][0], H = isoDates[t][2] !== !1;
        break;
      }
    if (AA == null) {
      n._isValid = !1;
      return;
    }
    if (k[3]) {
      for (t = 0, g = BA; t < g; t++)
        if (isoTimes[t][1].exec(k[3])) {
          gA = (k[2] || " ") + isoTimes[t][0];
          break;
        }
      if (gA == null) {
        n._isValid = !1;
        return;
      }
    }
    if (!H && gA != null) {
      n._isValid = !1;
      return;
    }
    if (k[4])
      if (tzRegex.exec(k[4]))
        IA = "Z";
      else {
        n._isValid = !1;
        return;
      }
    n._f = AA + (gA || "") + (IA || ""), configFromStringAndFormat(n);
  } else
    n._isValid = !1;
}
function extractFromRFC2822Strings(n, t, g, d, k, H) {
  var AA = [
    untruncateYear(n),
    defaultLocaleMonthsShort.indexOf(t),
    parseInt(g, 10),
    parseInt(d, 10),
    parseInt(k, 10)
  ];
  return H && AA.push(parseInt(H, 10)), AA;
}
function untruncateYear(n) {
  var t = parseInt(n, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function preprocessRFC2822(n) {
  return n.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(n, t, g) {
  if (n) {
    var d = defaultLocaleWeekdaysShort.indexOf(n), k = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (d !== k)
      return getParsingFlags(g).weekdayMismatch = !0, g._isValid = !1, !1;
  }
  return !0;
}
function calculateOffset(n, t, g) {
  if (n)
    return obsOffsets[n];
  if (t)
    return 0;
  var d = parseInt(g, 10), k = d % 100, H = (d - k) / 100;
  return H * 60 + k;
}
function configFromRFC2822(n) {
  var t = rfc2822.exec(preprocessRFC2822(n._i)), g;
  if (t) {
    if (g = extractFromRFC2822Strings(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !checkWeekday(t[1], g, n))
      return;
    n._a = g, n._tzm = calculateOffset(t[8], t[9], t[10]), n._d = createUTCDate.apply(null, n._a), n._d.setUTCMinutes(n._d.getUTCMinutes() - n._tzm), getParsingFlags(n).rfc2822 = !0;
  } else
    n._isValid = !1;
}
function configFromString(n) {
  var t = aspNetJsonRegex.exec(n._i);
  if (t !== null) {
    n._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (configFromISO(n), n._isValid === !1)
    delete n._isValid;
  else
    return;
  if (configFromRFC2822(n), n._isValid === !1)
    delete n._isValid;
  else
    return;
  n._strict ? n._isValid = !1 : hooks.createFromInputFallback(n);
}
hooks.createFromInputFallback = deprecate(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(n) {
    n._d = /* @__PURE__ */ new Date(n._i + (n._useUTC ? " UTC" : ""));
  }
);
function defaults$2(n, t, g) {
  return n ?? t ?? g;
}
function currentDateArray(n) {
  var t = new Date(hooks.now());
  return n._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function configFromArray(n) {
  var t, g, d = [], k, H, AA;
  if (!n._d) {
    for (k = currentDateArray(n), n._w && n._a[DATE$1] == null && n._a[MONTH$1] == null && dayOfYearFromWeekInfo(n), n._dayOfYear != null && (AA = defaults$2(n._a[YEAR$1], k[YEAR$1]), (n._dayOfYear > daysInYear(AA) || n._dayOfYear === 0) && (getParsingFlags(n)._overflowDayOfYear = !0), g = createUTCDate(AA, 0, n._dayOfYear), n._a[MONTH$1] = g.getUTCMonth(), n._a[DATE$1] = g.getUTCDate()), t = 0; t < 3 && n._a[t] == null; ++t)
      n._a[t] = d[t] = k[t];
    for (; t < 7; t++)
      n._a[t] = d[t] = n._a[t] == null ? t === 2 ? 1 : 0 : n._a[t];
    n._a[HOUR] === 24 && n._a[MINUTE] === 0 && n._a[SECOND] === 0 && n._a[MILLISECOND] === 0 && (n._nextDay = !0, n._a[HOUR] = 0), n._d = (n._useUTC ? createUTCDate : createDate).apply(
      null,
      d
    ), H = n._useUTC ? n._d.getUTCDay() : n._d.getDay(), n._tzm != null && n._d.setUTCMinutes(n._d.getUTCMinutes() - n._tzm), n._nextDay && (n._a[HOUR] = 24), n._w && typeof n._w.d < "u" && n._w.d !== H && (getParsingFlags(n).weekdayMismatch = !0);
  }
}
function dayOfYearFromWeekInfo(n) {
  var t, g, d, k, H, AA, gA, IA, CA;
  t = n._w, t.GG != null || t.W != null || t.E != null ? (H = 1, AA = 4, g = defaults$2(
    t.GG,
    n._a[YEAR$1],
    weekOfYear(createLocal(), 1, 4).year
  ), d = defaults$2(t.W, 1), k = defaults$2(t.E, 1), (k < 1 || k > 7) && (IA = !0)) : (H = n._locale._week.dow, AA = n._locale._week.doy, CA = weekOfYear(createLocal(), H, AA), g = defaults$2(t.gg, n._a[YEAR$1], CA.year), d = defaults$2(t.w, CA.week), t.d != null ? (k = t.d, (k < 0 || k > 6) && (IA = !0)) : t.e != null ? (k = t.e + H, (t.e < 0 || t.e > 6) && (IA = !0)) : k = H), d < 1 || d > weeksInYear(g, H, AA) ? getParsingFlags(n)._overflowWeeks = !0 : IA != null ? getParsingFlags(n)._overflowWeekday = !0 : (gA = dayOfYearFromWeeks(g, d, k, H, AA), n._a[YEAR$1] = gA.year, n._dayOfYear = gA.dayOfYear);
}
hooks.ISO_8601 = function() {
};
hooks.RFC_2822 = function() {
};
function configFromStringAndFormat(n) {
  if (n._f === hooks.ISO_8601) {
    configFromISO(n);
    return;
  }
  if (n._f === hooks.RFC_2822) {
    configFromRFC2822(n);
    return;
  }
  n._a = [], getParsingFlags(n).empty = !0;
  var t = "" + n._i, g, d, k, H, AA, gA = t.length, IA = 0, CA, BA;
  for (k = expandFormat(n._f, n._locale).match(formattingTokens) || [], BA = k.length, g = 0; g < BA; g++)
    H = k[g], d = (t.match(getParseRegexForToken(H, n)) || [])[0], d && (AA = t.substr(0, t.indexOf(d)), AA.length > 0 && getParsingFlags(n).unusedInput.push(AA), t = t.slice(
      t.indexOf(d) + d.length
    ), IA += d.length), formatTokenFunctions[H] ? (d ? getParsingFlags(n).empty = !1 : getParsingFlags(n).unusedTokens.push(H), addTimeToArrayFromToken(H, d, n)) : n._strict && !d && getParsingFlags(n).unusedTokens.push(H);
  getParsingFlags(n).charsLeftOver = gA - IA, t.length > 0 && getParsingFlags(n).unusedInput.push(t), n._a[HOUR] <= 12 && getParsingFlags(n).bigHour === !0 && n._a[HOUR] > 0 && (getParsingFlags(n).bigHour = void 0), getParsingFlags(n).parsedDateParts = n._a.slice(0), getParsingFlags(n).meridiem = n._meridiem, n._a[HOUR] = meridiemFixWrap(
    n._locale,
    n._a[HOUR],
    n._meridiem
  ), CA = getParsingFlags(n).era, CA !== null && (n._a[YEAR$1] = n._locale.erasConvertYear(CA, n._a[YEAR$1])), configFromArray(n), checkOverflow(n);
}
function meridiemFixWrap(n, t, g) {
  var d;
  return g == null ? t : n.meridiemHour != null ? n.meridiemHour(t, g) : (n.isPM != null && (d = n.isPM(g), d && t < 12 && (t += 12), !d && t === 12 && (t = 0)), t);
}
function configFromStringAndArray(n) {
  var t, g, d, k, H, AA, gA = !1, IA = n._f.length;
  if (IA === 0) {
    getParsingFlags(n).invalidFormat = !0, n._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (k = 0; k < IA; k++)
    H = 0, AA = !1, t = copyConfig({}, n), n._useUTC != null && (t._useUTC = n._useUTC), t._f = n._f[k], configFromStringAndFormat(t), isValid$2(t) && (AA = !0), H += getParsingFlags(t).charsLeftOver, H += getParsingFlags(t).unusedTokens.length * 10, getParsingFlags(t).score = H, gA ? H < d && (d = H, g = t) : (d == null || H < d || AA) && (d = H, g = t, AA && (gA = !0));
  extend$3(n, g || t);
}
function configFromObject(n) {
  if (!n._d) {
    var t = normalizeObjectUnits(n._i), g = t.day === void 0 ? t.date : t.day;
    n._a = map$3(
      [t.year, t.month, g, t.hour, t.minute, t.second, t.millisecond],
      function(d) {
        return d && parseInt(d, 10);
      }
    ), configFromArray(n);
  }
}
function createFromConfig(n) {
  var t = new Moment(checkOverflow(prepareConfig(n)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function prepareConfig(n) {
  var t = n._i, g = n._f;
  return n._locale = n._locale || getLocale(n._l), t === null || g === void 0 && t === "" ? createInvalid({ nullInput: !0 }) : (typeof t == "string" && (n._i = t = n._locale.preparse(t)), isMoment(t) ? new Moment(checkOverflow(t)) : (isDate$3(t) ? n._d = t : isArray$4(g) ? configFromStringAndArray(n) : g ? configFromStringAndFormat(n) : configFromInput(n), isValid$2(n) || (n._d = null), n));
}
function configFromInput(n) {
  var t = n._i;
  isUndefined$2(t) ? n._d = new Date(hooks.now()) : isDate$3(t) ? n._d = new Date(t.valueOf()) : typeof t == "string" ? configFromString(n) : isArray$4(t) ? (n._a = map$3(t.slice(0), function(g) {
    return parseInt(g, 10);
  }), configFromArray(n)) : isObject$5(t) ? configFromObject(n) : isNumber$4(t) ? n._d = new Date(t) : hooks.createFromInputFallback(n);
}
function createLocalOrUTC(n, t, g, d, k) {
  var H = {};
  return (t === !0 || t === !1) && (d = t, t = void 0), (g === !0 || g === !1) && (d = g, g = void 0), (isObject$5(n) && isObjectEmpty(n) || isArray$4(n) && n.length === 0) && (n = void 0), H._isAMomentObject = !0, H._useUTC = H._isUTC = k, H._l = g, H._i = n, H._f = t, H._strict = d, createFromConfig(H);
}
function createLocal(n, t, g, d) {
  return createLocalOrUTC(n, t, g, d, !1);
}
var prototypeMin = deprecate(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var n = createLocal.apply(null, arguments);
    return this.isValid() && n.isValid() ? n < this ? this : n : createInvalid();
  }
), prototypeMax = deprecate(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var n = createLocal.apply(null, arguments);
    return this.isValid() && n.isValid() ? n > this ? this : n : createInvalid();
  }
);
function pickBy(n, t) {
  var g, d;
  if (t.length === 1 && isArray$4(t[0]) && (t = t[0]), !t.length)
    return createLocal();
  for (g = t[0], d = 1; d < t.length; ++d)
    (!t[d].isValid() || t[d][n](g)) && (g = t[d]);
  return g;
}
function min$3() {
  var n = [].slice.call(arguments, 0);
  return pickBy("isBefore", n);
}
function max$3() {
  var n = [].slice.call(arguments, 0);
  return pickBy("isAfter", n);
}
var now$3 = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, ordering = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function isDurationValid(n) {
  var t, g = !1, d, k = ordering.length;
  for (t in n)
    if (hasOwnProp(n, t) && !(indexOf.call(ordering, t) !== -1 && (n[t] == null || !isNaN(n[t]))))
      return !1;
  for (d = 0; d < k; ++d)
    if (n[ordering[d]]) {
      if (g)
        return !1;
      parseFloat(n[ordering[d]]) !== toInt(n[ordering[d]]) && (g = !0);
    }
  return !0;
}
function isValid$1$1() {
  return this._isValid;
}
function createInvalid$1() {
  return createDuration(NaN);
}
function Duration(n) {
  var t = normalizeObjectUnits(n), g = t.year || 0, d = t.quarter || 0, k = t.month || 0, H = t.week || t.isoWeek || 0, AA = t.day || 0, gA = t.hour || 0, IA = t.minute || 0, CA = t.second || 0, BA = t.millisecond || 0;
  this._isValid = isDurationValid(t), this._milliseconds = +BA + CA * 1e3 + // 1000
  IA * 6e4 + // 1000 * 60
  gA * 1e3 * 60 * 60, this._days = +AA + H * 7, this._months = +k + d * 3 + g * 12, this._data = {}, this._locale = getLocale(), this._bubble();
}
function isDuration(n) {
  return n instanceof Duration;
}
function absRound(n) {
  return n < 0 ? Math.round(-1 * n) * -1 : Math.round(n);
}
function compareArrays(n, t, g) {
  var d = Math.min(n.length, t.length), k = Math.abs(n.length - t.length), H = 0, AA;
  for (AA = 0; AA < d; AA++)
    toInt(n[AA]) !== toInt(t[AA]) && H++;
  return H + k;
}
function offset$4(n, t) {
  addFormatToken(n, 0, 0, function() {
    var g = this.utcOffset(), d = "+";
    return g < 0 && (g = -g, d = "-"), d + zeroFill(~~(g / 60), 2) + t + zeroFill(~~g % 60, 2);
  });
}
offset$4("Z", ":");
offset$4("ZZ", "");
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken(["Z", "ZZ"], function(n, t, g) {
  g._useUTC = !0, g._tzm = offsetFromString(matchShortOffset, n);
});
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(n, t) {
  var g = (t || "").match(n), d, k, H;
  return g === null ? null : (d = g[g.length - 1] || [], k = (d + "").match(chunkOffset) || ["-", 0, 0], H = +(k[1] * 60) + toInt(k[2]), H === 0 ? 0 : k[0] === "+" ? H : -H);
}
function cloneWithOffset(n, t) {
  var g, d;
  return t._isUTC ? (g = t.clone(), d = (isMoment(n) || isDate$3(n) ? n.valueOf() : createLocal(n).valueOf()) - g.valueOf(), g._d.setTime(g._d.valueOf() + d), hooks.updateOffset(g, !1), g) : createLocal(n).local();
}
function getDateOffset(n) {
  return -Math.round(n._d.getTimezoneOffset());
}
hooks.updateOffset = function() {
};
function getSetOffset(n, t, g) {
  var d = this._offset || 0, k;
  if (!this.isValid())
    return n != null ? this : NaN;
  if (n != null) {
    if (typeof n == "string") {
      if (n = offsetFromString(matchShortOffset, n), n === null)
        return this;
    } else Math.abs(n) < 16 && !g && (n = n * 60);
    return !this._isUTC && t && (k = getDateOffset(this)), this._offset = n, this._isUTC = !0, k != null && this.add(k, "m"), d !== n && (!t || this._changeInProgress ? addSubtract(
      this,
      createDuration(n - d, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, hooks.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? d : getDateOffset(this);
}
function getSetZone(n, t) {
  return n != null ? (typeof n != "string" && (n = -n), this.utcOffset(n, t), this) : -this.utcOffset();
}
function setOffsetToUTC(n) {
  return this.utcOffset(0, n);
}
function setOffsetToLocal(n) {
  return this._isUTC && (this.utcOffset(0, n), this._isUTC = !1, n && this.subtract(getDateOffset(this), "m")), this;
}
function setOffsetToParsedOffset() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var n = offsetFromString(matchOffset, this._i);
    n != null ? this.utcOffset(n) : this.utcOffset(0, !0);
  }
  return this;
}
function hasAlignedHourOffset(n) {
  return this.isValid() ? (n = n ? createLocal(n).utcOffset() : 0, (this.utcOffset() - n) % 60 === 0) : !1;
}
function isDaylightSavingTime() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
  if (!isUndefined$2(this._isDSTShifted))
    return this._isDSTShifted;
  var n = {}, t;
  return copyConfig(n, this), n = prepareConfig(n), n._a ? (t = n._isUTC ? createUTC(n._a) : createLocal(n._a), this._isDSTShifted = this.isValid() && compareArrays(n._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function isLocal() {
  return this.isValid() ? !this._isUTC : !1;
}
function isUtcOffset() {
  return this.isValid() ? this._isUTC : !1;
}
function isUtc() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(n, t) {
  var g = n, d = null, k, H, AA;
  return isDuration(n) ? g = {
    ms: n._milliseconds,
    d: n._days,
    M: n._months
  } : isNumber$4(n) || !isNaN(+n) ? (g = {}, t ? g[t] = +n : g.milliseconds = +n) : (d = aspNetRegex.exec(n)) ? (k = d[1] === "-" ? -1 : 1, g = {
    y: 0,
    d: toInt(d[DATE$1]) * k,
    h: toInt(d[HOUR]) * k,
    m: toInt(d[MINUTE]) * k,
    s: toInt(d[SECOND]) * k,
    ms: toInt(absRound(d[MILLISECOND] * 1e3)) * k
    // the millisecond decimal point is included in the match
  }) : (d = isoRegex.exec(n)) ? (k = d[1] === "-" ? -1 : 1, g = {
    y: parseIso(d[2], k),
    M: parseIso(d[3], k),
    w: parseIso(d[4], k),
    d: parseIso(d[5], k),
    h: parseIso(d[6], k),
    m: parseIso(d[7], k),
    s: parseIso(d[8], k)
  }) : g == null ? g = {} : typeof g == "object" && ("from" in g || "to" in g) && (AA = momentsDifference(
    createLocal(g.from),
    createLocal(g.to)
  ), g = {}, g.ms = AA.milliseconds, g.M = AA.months), H = new Duration(g), isDuration(n) && hasOwnProp(n, "_locale") && (H._locale = n._locale), isDuration(n) && hasOwnProp(n, "_isValid") && (H._isValid = n._isValid), H;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(n, t) {
  var g = n && parseFloat(n.replace(",", "."));
  return (isNaN(g) ? 0 : g) * t;
}
function positiveMomentsDifference(n, t) {
  var g = {};
  return g.months = t.month() - n.month() + (t.year() - n.year()) * 12, n.clone().add(g.months, "M").isAfter(t) && --g.months, g.milliseconds = +t - +n.clone().add(g.months, "M"), g;
}
function momentsDifference(n, t) {
  var g;
  return n.isValid() && t.isValid() ? (t = cloneWithOffset(t, n), n.isBefore(t) ? g = positiveMomentsDifference(n, t) : (g = positiveMomentsDifference(t, n), g.milliseconds = -g.milliseconds, g.months = -g.months), g) : { milliseconds: 0, months: 0 };
}
function createAdder(n, t) {
  return function(g, d) {
    var k, H;
    return d !== null && !isNaN(+d) && (deprecateSimple(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), H = g, g = d, d = H), k = createDuration(g, d), addSubtract(this, k, n), this;
  };
}
function addSubtract(n, t, g, d) {
  var k = t._milliseconds, H = absRound(t._days), AA = absRound(t._months);
  n.isValid() && (d = d ?? !0, AA && setMonth(n, get$7(n, "Month") + AA * g), H && set$1$1(n, "Date", get$7(n, "Date") + H * g), k && n._d.setTime(n._d.valueOf() + k * g), d && hooks.updateOffset(n, H || AA));
}
var add$6 = createAdder(1, "add"), subtract$1 = createAdder(-1, "subtract");
function isString$3(n) {
  return typeof n == "string" || n instanceof String;
}
function isMomentInput(n) {
  return isMoment(n) || isDate$3(n) || isString$3(n) || isNumber$4(n) || isNumberOrStringArray(n) || isMomentInputObject(n) || n === null || n === void 0;
}
function isMomentInputObject(n) {
  var t = isObject$5(n) && !isObjectEmpty(n), g = !1, d = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], k, H, AA = d.length;
  for (k = 0; k < AA; k += 1)
    H = d[k], g = g || hasOwnProp(n, H);
  return t && g;
}
function isNumberOrStringArray(n) {
  var t = isArray$4(n), g = !1;
  return t && (g = n.filter(function(d) {
    return !isNumber$4(d) && isString$3(n);
  }).length === 0), t && g;
}
function isCalendarSpec(n) {
  var t = isObject$5(n) && !isObjectEmpty(n), g = !1, d = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], k, H;
  for (k = 0; k < d.length; k += 1)
    H = d[k], g = g || hasOwnProp(n, H);
  return t && g;
}
function getCalendarFormat(n, t) {
  var g = n.diff(t, "days", !0);
  return g < -6 ? "sameElse" : g < -1 ? "lastWeek" : g < 0 ? "lastDay" : g < 1 ? "sameDay" : g < 2 ? "nextDay" : g < 7 ? "nextWeek" : "sameElse";
}
function calendar$1$1(n, t) {
  arguments.length === 1 && (arguments[0] ? isMomentInput(arguments[0]) ? (n = arguments[0], t = void 0) : isCalendarSpec(arguments[0]) && (t = arguments[0], n = void 0) : (n = void 0, t = void 0));
  var g = n || createLocal(), d = cloneWithOffset(g, this).startOf("day"), k = hooks.calendarFormat(this, d) || "sameElse", H = t && (isFunction$6(t[k]) ? t[k].call(this, g) : t[k]);
  return this.format(
    H || this.localeData().calendar(k, this, createLocal(g))
  );
}
function clone() {
  return new Moment(this);
}
function isAfter(n, t) {
  var g = isMoment(n) ? n : createLocal(n);
  return this.isValid() && g.isValid() ? (t = normalizeUnits(t) || "millisecond", t === "millisecond" ? this.valueOf() > g.valueOf() : g.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function isBefore(n, t) {
  var g = isMoment(n) ? n : createLocal(n);
  return this.isValid() && g.isValid() ? (t = normalizeUnits(t) || "millisecond", t === "millisecond" ? this.valueOf() < g.valueOf() : this.clone().endOf(t).valueOf() < g.valueOf()) : !1;
}
function isBetween(n, t, g, d) {
  var k = isMoment(n) ? n : createLocal(n), H = isMoment(t) ? t : createLocal(t);
  return this.isValid() && k.isValid() && H.isValid() ? (d = d || "()", (d[0] === "(" ? this.isAfter(k, g) : !this.isBefore(k, g)) && (d[1] === ")" ? this.isBefore(H, g) : !this.isAfter(H, g))) : !1;
}
function isSame(n, t) {
  var g = isMoment(n) ? n : createLocal(n), d;
  return this.isValid() && g.isValid() ? (t = normalizeUnits(t) || "millisecond", t === "millisecond" ? this.valueOf() === g.valueOf() : (d = g.valueOf(), this.clone().startOf(t).valueOf() <= d && d <= this.clone().endOf(t).valueOf())) : !1;
}
function isSameOrAfter(n, t) {
  return this.isSame(n, t) || this.isAfter(n, t);
}
function isSameOrBefore(n, t) {
  return this.isSame(n, t) || this.isBefore(n, t);
}
function diff(n, t, g) {
  var d, k, H;
  if (!this.isValid())
    return NaN;
  if (d = cloneWithOffset(n, this), !d.isValid())
    return NaN;
  switch (k = (d.utcOffset() - this.utcOffset()) * 6e4, t = normalizeUnits(t), t) {
    case "year":
      H = monthDiff(this, d) / 12;
      break;
    case "month":
      H = monthDiff(this, d);
      break;
    case "quarter":
      H = monthDiff(this, d) / 3;
      break;
    case "second":
      H = (this - d) / 1e3;
      break;
    // 1000
    case "minute":
      H = (this - d) / 6e4;
      break;
    // 1000 * 60
    case "hour":
      H = (this - d) / 36e5;
      break;
    // 1000 * 60 * 60
    case "day":
      H = (this - d - k) / 864e5;
      break;
    // 1000 * 60 * 60 * 24, negate dst
    case "week":
      H = (this - d - k) / 6048e5;
      break;
    // 1000 * 60 * 60 * 24 * 7, negate dst
    default:
      H = this - d;
  }
  return g ? H : absFloor(H);
}
function monthDiff(n, t) {
  if (n.date() < t.date())
    return -monthDiff(t, n);
  var g = (t.year() - n.year()) * 12 + (t.month() - n.month()), d = n.clone().add(g, "months"), k, H;
  return t - d < 0 ? (k = n.clone().add(g - 1, "months"), H = (t - d) / (d - k)) : (k = n.clone().add(g + 1, "months"), H = (t - d) / (k - d)), -(g + H) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString$4() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(n) {
  if (!this.isValid())
    return null;
  var t = n !== !0, g = t ? this.clone().utc() : this;
  return g.year() < 0 || g.year() > 9999 ? formatMoment(
    g,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : isFunction$6(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(g, "Z")) : formatMoment(
    g,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function inspect() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var n = "moment", t = "", g, d, k, H;
  return this.isLocal() || (n = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), g = "[" + n + '("]', d = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", k = "-MM-DD[T]HH:mm:ss.SSS", H = t + '[")]', this.format(g + d + k + H);
}
function format$6(n) {
  n || (n = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat);
  var t = formatMoment(this, n);
  return this.localeData().postformat(t);
}
function from(n, t) {
  return this.isValid() && (isMoment(n) && n.isValid() || createLocal(n).isValid()) ? createDuration({ to: this, from: n }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function fromNow(n) {
  return this.from(createLocal(), n);
}
function to(n, t) {
  return this.isValid() && (isMoment(n) && n.isValid() || createLocal(n).isValid()) ? createDuration({ from: this, to: n }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function toNow(n) {
  return this.to(createLocal(), n);
}
function locale$3(n) {
  var t;
  return n === void 0 ? this._locale._abbr : (t = getLocale(n), t != null && (this._locale = t), this);
}
var lang = deprecate(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(n) {
    return n === void 0 ? this.localeData() : this.locale(n);
  }
);
function localeData() {
  return this._locale;
}
var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
function mod$1(n, t) {
  return (n % t + t) % t;
}
function localStartOfDate(n, t, g) {
  return n < 100 && n >= 0 ? new Date(n + 400, t, g) - MS_PER_400_YEARS : new Date(n, t, g).valueOf();
}
function utcStartOfDate(n, t, g) {
  return n < 100 && n >= 0 ? Date.UTC(n + 400, t, g) - MS_PER_400_YEARS : Date.UTC(n, t, g);
}
function startOf(n) {
  var t, g;
  if (n = normalizeUnits(n), n === void 0 || n === "millisecond" || !this.isValid())
    return this;
  switch (g = this._isUTC ? utcStartOfDate : localStartOfDate, n) {
    case "year":
      t = g(this.year(), 0, 1);
      break;
    case "quarter":
      t = g(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = g(this.year(), this.month(), 1);
      break;
    case "week":
      t = g(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = g(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = g(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= mod$1(
        t + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= mod$1(t, MS_PER_MINUTE);
      break;
    case "second":
      t = this._d.valueOf(), t -= mod$1(t, MS_PER_SECOND);
      break;
  }
  return this._d.setTime(t), hooks.updateOffset(this, !0), this;
}
function endOf(n) {
  var t, g;
  if (n = normalizeUnits(n), n === void 0 || n === "millisecond" || !this.isValid())
    return this;
  switch (g = this._isUTC ? utcStartOfDate : localStartOfDate, n) {
    case "year":
      t = g(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = g(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = g(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = g(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = g(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = g(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += MS_PER_HOUR - mod$1(
        t + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += MS_PER_MINUTE - mod$1(t, MS_PER_MINUTE) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += MS_PER_SECOND - mod$1(t, MS_PER_SECOND) - 1;
      break;
  }
  return this._d.setTime(t), hooks.updateOffset(this, !0), this;
}
function valueOf() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function unix() {
  return Math.floor(this.valueOf() / 1e3);
}
function toDate$1() {
  return new Date(this.valueOf());
}
function toArray$2() {
  var n = this;
  return [
    n.year(),
    n.month(),
    n.date(),
    n.hour(),
    n.minute(),
    n.second(),
    n.millisecond()
  ];
}
function toObject() {
  var n = this;
  return {
    years: n.year(),
    months: n.month(),
    date: n.date(),
    hours: n.hours(),
    minutes: n.minutes(),
    seconds: n.seconds(),
    milliseconds: n.milliseconds()
  };
}
function toJSON() {
  return this.isValid() ? this.toISOString() : null;
}
function isValid$2$1() {
  return isValid$2(this);
}
function parsingFlags() {
  return extend$3({}, getParsingFlags(this));
}
function invalidAt() {
  return getParsingFlags(this).overflow;
}
function creationData() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", ["y", 1], "yo", "eraYear");
addFormatToken("y", ["yy", 2], 0, "eraYear");
addFormatToken("y", ["yyy", 3], 0, "eraYear");
addFormatToken("y", ["yyyy", 4], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(n, t, g, d) {
    var k = g._locale.erasParse(n, d, g._strict);
    k ? getParsingFlags(g).era = k : getParsingFlags(g).invalidEra = n;
  }
);
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken(["y", "yy", "yyy", "yyyy"], YEAR$1);
addParseToken(["yo"], function(n, t, g, d) {
  var k;
  g._locale._eraYearOrdinalRegex && (k = n.match(g._locale._eraYearOrdinalRegex)), g._locale.eraYearOrdinalParse ? t[YEAR$1] = g._locale.eraYearOrdinalParse(n, k) : t[YEAR$1] = parseInt(n, 10);
});
function localeEras(n, t) {
  var g, d, k, H = this._eras || getLocale("en")._eras;
  for (g = 0, d = H.length; g < d; ++g) {
    switch (typeof H[g].since) {
      case "string":
        k = hooks(H[g].since).startOf("day"), H[g].since = k.valueOf();
        break;
    }
    switch (typeof H[g].until) {
      case "undefined":
        H[g].until = 1 / 0;
        break;
      case "string":
        k = hooks(H[g].until).startOf("day").valueOf(), H[g].until = k.valueOf();
        break;
    }
  }
  return H;
}
function localeErasParse(n, t, g) {
  var d, k, H = this.eras(), AA, gA, IA;
  for (n = n.toUpperCase(), d = 0, k = H.length; d < k; ++d)
    if (AA = H[d].name.toUpperCase(), gA = H[d].abbr.toUpperCase(), IA = H[d].narrow.toUpperCase(), g)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (gA === n)
            return H[d];
          break;
        case "NNNN":
          if (AA === n)
            return H[d];
          break;
        case "NNNNN":
          if (IA === n)
            return H[d];
          break;
      }
    else if ([AA, gA, IA].indexOf(n) >= 0)
      return H[d];
}
function localeErasConvertYear(n, t) {
  var g = n.since <= n.until ? 1 : -1;
  return t === void 0 ? hooks(n.since).year() : hooks(n.since).year() + (t - n.offset) * g;
}
function getEraName() {
  var n, t, g, d = this.localeData().eras();
  for (n = 0, t = d.length; n < t; ++n)
    if (g = this.clone().startOf("day").valueOf(), d[n].since <= g && g <= d[n].until || d[n].until <= g && g <= d[n].since)
      return d[n].name;
  return "";
}
function getEraNarrow() {
  var n, t, g, d = this.localeData().eras();
  for (n = 0, t = d.length; n < t; ++n)
    if (g = this.clone().startOf("day").valueOf(), d[n].since <= g && g <= d[n].until || d[n].until <= g && g <= d[n].since)
      return d[n].narrow;
  return "";
}
function getEraAbbr() {
  var n, t, g, d = this.localeData().eras();
  for (n = 0, t = d.length; n < t; ++n)
    if (g = this.clone().startOf("day").valueOf(), d[n].since <= g && g <= d[n].until || d[n].until <= g && g <= d[n].since)
      return d[n].abbr;
  return "";
}
function getEraYear() {
  var n, t, g, d, k = this.localeData().eras();
  for (n = 0, t = k.length; n < t; ++n)
    if (g = k[n].since <= k[n].until ? 1 : -1, d = this.clone().startOf("day").valueOf(), k[n].since <= d && d <= k[n].until || k[n].until <= d && d <= k[n].since)
      return (this.year() - hooks(k[n].since).year()) * g + k[n].offset;
  return this.year();
}
function erasNameRegex(n) {
  return hasOwnProp(this, "_erasNameRegex") || computeErasParse.call(this), n ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(n) {
  return hasOwnProp(this, "_erasAbbrRegex") || computeErasParse.call(this), n ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(n) {
  return hasOwnProp(this, "_erasNarrowRegex") || computeErasParse.call(this), n ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(n, t) {
  return t.erasAbbrRegex(n);
}
function matchEraName(n, t) {
  return t.erasNameRegex(n);
}
function matchEraNarrow(n, t) {
  return t.erasNarrowRegex(n);
}
function matchEraYearOrdinal(n, t) {
  return t._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
  var n = [], t = [], g = [], d = [], k, H, AA, gA, IA, CA = this.eras();
  for (k = 0, H = CA.length; k < H; ++k)
    AA = regexEscape(CA[k].name), gA = regexEscape(CA[k].abbr), IA = regexEscape(CA[k].narrow), t.push(AA), n.push(gA), g.push(IA), d.push(AA), d.push(gA), d.push(IA);
  this._erasRegex = new RegExp("^(" + d.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + g.join("|") + ")",
    "i"
  );
}
addFormatToken(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
addFormatToken(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(n, t) {
  addFormatToken(0, [n, n.length], 0, t);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(n, t, g, d) {
    t[d.substr(0, 2)] = toInt(n);
  }
);
addWeekParseToken(["gg", "GG"], function(n, t, g, d) {
  t[d] = hooks.parseTwoDigitYear(n);
});
function getSetWeekYear(n) {
  return getSetWeekYearHelper.call(
    this,
    n,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function getSetISOWeekYear(n) {
  return getSetWeekYearHelper.call(
    this,
    n,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function getISOWeeksInYear() {
  return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
  return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
  var n = this.localeData()._week;
  return weeksInYear(this.year(), n.dow, n.doy);
}
function getWeeksInWeekYear() {
  var n = this.localeData()._week;
  return weeksInYear(this.weekYear(), n.dow, n.doy);
}
function getSetWeekYearHelper(n, t, g, d, k) {
  var H;
  return n == null ? weekOfYear(this, d, k).year : (H = weeksInYear(n, d, k), t > H && (t = H), setWeekAll.call(this, n, t, g, d, k));
}
function setWeekAll(n, t, g, d, k) {
  var H = dayOfYearFromWeeks(n, t, g, d, k), AA = createUTCDate(H.year, 0, H.dayOfYear);
  return this.year(AA.getUTCFullYear()), this.month(AA.getUTCMonth()), this.date(AA.getUTCDate()), this;
}
addFormatToken("Q", 0, "Qo", "quarter");
addRegexToken("Q", match1);
addParseToken("Q", function(n, t) {
  t[MONTH$1] = (toInt(n) - 1) * 3;
});
function getSetQuarter(n) {
  return n == null ? Math.ceil((this.month() + 1) / 3) : this.month((n - 1) * 3 + this.month() % 3);
}
addFormatToken("D", ["DD", 2], "Do", "date");
addRegexToken("D", match1to2, match1to2NoLeadingZero);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(n, t) {
  return n ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
addParseToken(["D", "DD"], DATE$1);
addParseToken("Do", function(n, t) {
  t[DATE$1] = toInt(n.match(match1to2)[0]);
});
var getSetDayOfMonth = makeGetSet("Date", !0);
addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken(["DDD", "DDDD"], function(n, t, g) {
  g._dayOfYear = toInt(n);
});
function getSetDayOfYear(n) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return n == null ? t : this.add(n - t, "d");
}
addFormatToken("m", ["mm", 2], 0, "minute");
addRegexToken("m", match1to2, match1to2HasZero);
addRegexToken("mm", match1to2, match2);
addParseToken(["m", "mm"], MINUTE);
var getSetMinute = makeGetSet("Minutes", !1);
addFormatToken("s", ["ss", 2], 0, "second");
addRegexToken("s", match1to2, match1to2HasZero);
addRegexToken("ss", match1to2, match2);
addParseToken(["s", "ss"], SECOND);
var getSetSecond = makeGetSet("Seconds", !1);
addFormatToken("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
addFormatToken(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
addFormatToken(0, ["SSS", 3], 0, "millisecond");
addFormatToken(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
addFormatToken(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
addFormatToken(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
addFormatToken(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token$1, getSetMillisecond;
for (token$1 = "SSSS"; token$1.length <= 9; token$1 += "S")
  addRegexToken(token$1, matchUnsigned);
function parseMs(n, t) {
  t[MILLISECOND] = toInt(("0." + n) * 1e3);
}
for (token$1 = "S"; token$1.length <= 9; token$1 += "S")
  addParseToken(token$1, parseMs);
getSetMillisecond = makeGetSet("Milliseconds", !1);
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
function getZoneAbbr() {
  return this._isUTC ? "UTC" : "";
}
function getZoneName() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto = Moment.prototype;
proto.add = add$6;
proto.calendar = calendar$1$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format$6;
proto.from = from;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2$1;
proto.lang = lang;
proto.locale = locale$3;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract$1;
proto.toArray = toArray$2;
proto.toObject = toObject;
proto.toDate = toDate$1;
proto.toISOString = toISOString;
proto.inspect = inspect;
typeof Symbol < "u" && Symbol.for != null && (proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
proto.toJSON = toJSON;
proto.toString = toString$4;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate(
  "dates accessor is deprecated. Use date instead.",
  getSetDayOfMonth
);
proto.months = deprecate(
  "months accessor is deprecated. Use month instead",
  getSetMonth
);
proto.years = deprecate(
  "years accessor is deprecated. Use year instead",
  getSetYear
);
proto.zone = deprecate(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  getSetZone
);
proto.isDSTShifted = deprecate(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  isDaylightSavingTimeShifted
);
function createUnix(n) {
  return createLocal(n * 1e3);
}
function createInZone() {
  return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(n) {
  return n;
}
var proto$1 = Locale.prototype;
proto$1.calendar = calendar$1;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal$1;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set$7;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;
proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;
proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;
function get$1$1(n, t, g, d) {
  var k = getLocale(), H = createUTC().set(d, t);
  return k[g](H, n);
}
function listMonthsImpl(n, t, g) {
  if (isNumber$4(n) && (t = n, n = void 0), n = n || "", t != null)
    return get$1$1(n, t, g, "month");
  var d, k = [];
  for (d = 0; d < 12; d++)
    k[d] = get$1$1(n, d, g, "month");
  return k;
}
function listWeekdaysImpl(n, t, g, d) {
  typeof n == "boolean" ? (isNumber$4(t) && (g = t, t = void 0), t = t || "") : (t = n, g = t, n = !1, isNumber$4(t) && (g = t, t = void 0), t = t || "");
  var k = getLocale(), H = n ? k._week.dow : 0, AA, gA = [];
  if (g != null)
    return get$1$1(t, (g + H) % 7, d, "day");
  for (AA = 0; AA < 7; AA++)
    gA[AA] = get$1$1(t, (AA + H) % 7, d, "day");
  return gA;
}
function listMonths(n, t) {
  return listMonthsImpl(n, t, "months");
}
function listMonthsShort(n, t) {
  return listMonthsImpl(n, t, "monthsShort");
}
function listWeekdays(n, t, g) {
  return listWeekdaysImpl(n, t, g, "weekdays");
}
function listWeekdaysShort(n, t, g) {
  return listWeekdaysImpl(n, t, g, "weekdaysShort");
}
function listWeekdaysMin(n, t, g) {
  return listWeekdaysImpl(n, t, g, "weekdaysMin");
}
getSetGlobalLocale("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(n) {
    var t = n % 10, g = toInt(n % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return n + g;
  }
});
hooks.lang = deprecate(
  "moment.lang is deprecated. Use moment.locale instead.",
  getSetGlobalLocale
);
hooks.langData = deprecate(
  "moment.langData is deprecated. Use moment.localeData instead.",
  getLocale
);
var mathAbs = Math.abs;
function abs$3() {
  var n = this._data;
  return this._milliseconds = mathAbs(this._milliseconds), this._days = mathAbs(this._days), this._months = mathAbs(this._months), n.milliseconds = mathAbs(n.milliseconds), n.seconds = mathAbs(n.seconds), n.minutes = mathAbs(n.minutes), n.hours = mathAbs(n.hours), n.months = mathAbs(n.months), n.years = mathAbs(n.years), this;
}
function addSubtract$1(n, t, g, d) {
  var k = createDuration(t, g);
  return n._milliseconds += d * k._milliseconds, n._days += d * k._days, n._months += d * k._months, n._bubble();
}
function add$1$1(n, t) {
  return addSubtract$1(this, n, t, 1);
}
function subtract$1$1(n, t) {
  return addSubtract$1(this, n, t, -1);
}
function absCeil(n) {
  return n < 0 ? Math.floor(n) : Math.ceil(n);
}
function bubble() {
  var n = this._milliseconds, t = this._days, g = this._months, d = this._data, k, H, AA, gA, IA;
  return n >= 0 && t >= 0 && g >= 0 || n <= 0 && t <= 0 && g <= 0 || (n += absCeil(monthsToDays(g) + t) * 864e5, t = 0, g = 0), d.milliseconds = n % 1e3, k = absFloor(n / 1e3), d.seconds = k % 60, H = absFloor(k / 60), d.minutes = H % 60, AA = absFloor(H / 60), d.hours = AA % 24, t += absFloor(AA / 24), IA = absFloor(daysToMonths(t)), g += IA, t -= absCeil(monthsToDays(IA)), gA = absFloor(g / 12), g %= 12, d.days = t, d.months = g, d.years = gA, this;
}
function daysToMonths(n) {
  return n * 4800 / 146097;
}
function monthsToDays(n) {
  return n * 146097 / 4800;
}
function as(n) {
  if (!this.isValid())
    return NaN;
  var t, g, d = this._milliseconds;
  if (n = normalizeUnits(n), n === "month" || n === "quarter" || n === "year")
    switch (t = this._days + d / 864e5, g = this._months + daysToMonths(t), n) {
      case "month":
        return g;
      case "quarter":
        return g / 3;
      case "year":
        return g / 12;
    }
  else
    switch (t = this._days + Math.round(monthsToDays(this._months)), n) {
      case "week":
        return t / 7 + d / 6048e5;
      case "day":
        return t + d / 864e5;
      case "hour":
        return t * 24 + d / 36e5;
      case "minute":
        return t * 1440 + d / 6e4;
      case "second":
        return t * 86400 + d / 1e3;
      // Math.floor prevents floating point math errors here
      case "millisecond":
        return Math.floor(t * 864e5) + d;
      default:
        throw new Error("Unknown unit " + n);
    }
}
function makeAs(n) {
  return function() {
    return this.as(n);
  };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
function clone$1() {
  return createDuration(this);
}
function get$2$1(n) {
  return n = normalizeUnits(n), this.isValid() ? this[n + "s"]() : NaN;
}
function makeGetter(n) {
  return function() {
    return this.isValid() ? this._data[n] : NaN;
  };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
  return absFloor(this.days() / 7);
}
var round = Math.round, thresholds = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function substituteTimeAgo(n, t, g, d, k) {
  return k.relativeTime(t || 1, !!g, n, d);
}
function relativeTime$1(n, t, g, d) {
  var k = createDuration(n).abs(), H = round(k.as("s")), AA = round(k.as("m")), gA = round(k.as("h")), IA = round(k.as("d")), CA = round(k.as("M")), BA = round(k.as("w")), eA = round(k.as("y")), iA = H <= g.ss && ["s", H] || H < g.s && ["ss", H] || AA <= 1 && ["m"] || AA < g.m && ["mm", AA] || gA <= 1 && ["h"] || gA < g.h && ["hh", gA] || IA <= 1 && ["d"] || IA < g.d && ["dd", IA];
  return g.w != null && (iA = iA || BA <= 1 && ["w"] || BA < g.w && ["ww", BA]), iA = iA || CA <= 1 && ["M"] || CA < g.M && ["MM", CA] || eA <= 1 && ["y"] || ["yy", eA], iA[2] = t, iA[3] = +n > 0, iA[4] = d, substituteTimeAgo.apply(null, iA);
}
function getSetRelativeTimeRounding(n) {
  return n === void 0 ? round : typeof n == "function" ? (round = n, !0) : !1;
}
function getSetRelativeTimeThreshold(n, t) {
  return thresholds[n] === void 0 ? !1 : t === void 0 ? thresholds[n] : (thresholds[n] = t, n === "s" && (thresholds.ss = t - 1), !0);
}
function humanize(n, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var g = !1, d = thresholds, k, H;
  return typeof n == "object" && (t = n, n = !1), typeof n == "boolean" && (g = n), typeof t == "object" && (d = Object.assign({}, thresholds, t), t.s != null && t.ss == null && (d.ss = t.s - 1)), k = this.localeData(), H = relativeTime$1(this, !g, d, k), g && (H = k.pastFuture(+this, H)), k.postformat(H);
}
var abs$1$1 = Math.abs;
function sign$3(n) {
  return (n > 0) - (n < 0) || +n;
}
function toISOString$1() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = abs$1$1(this._milliseconds) / 1e3, t = abs$1$1(this._days), g = abs$1$1(this._months), d, k, H, AA, gA = this.asSeconds(), IA, CA, BA, eA;
  return gA ? (d = absFloor(n / 60), k = absFloor(d / 60), n %= 60, d %= 60, H = absFloor(g / 12), g %= 12, AA = n ? n.toFixed(3).replace(/\.?0+$/, "") : "", IA = gA < 0 ? "-" : "", CA = sign$3(this._months) !== sign$3(gA) ? "-" : "", BA = sign$3(this._days) !== sign$3(gA) ? "-" : "", eA = sign$3(this._milliseconds) !== sign$3(gA) ? "-" : "", IA + "P" + (H ? CA + H + "Y" : "") + (g ? CA + g + "M" : "") + (t ? BA + t + "D" : "") + (k || d || n ? "T" : "") + (k ? eA + k + "H" : "") + (d ? eA + d + "M" : "") + (n ? eA + AA + "S" : "")) : "P0D";
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1$1;
proto$2.abs = abs$3;
proto$2.add = add$1$1;
proto$2.subtract = subtract$1$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2$1;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale$3;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  toISOString$1
);
proto$2.lang = lang;
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(n, t, g) {
  g._d = new Date(parseFloat(n) * 1e3);
});
addParseToken("x", function(n, t, g) {
  g._d = new Date(toInt(n));
});
hooks.version = "2.30.1";
setHookCallback(createLocal);
hooks.fn = proto;
hooks.min = min$3;
hooks.max = max$3;
hooks.now = now$3;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate$3;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;
hooks.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const moment$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hooks
}, Symbol.toStringTag, { value: "Module" })), require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(moment$1);
var momentTimezone = momentTimezone$1.exports, hasRequiredMomentTimezone$1;
function requireMomentTimezone$1() {
  return hasRequiredMomentTimezone$1 || (hasRequiredMomentTimezone$1 = 1, (function(n) {
    (function(t, g) {
      n.exports ? n.exports = g(require$$0$1) : g(t.moment);
    })(momentTimezone, function(t) {
      t.version === void 0 && t.default && (t = t.default);
      var g = "0.6.0", d = {}, k = {}, H = {}, AA = {}, gA = {}, IA;
      (!t || typeof t.version != "string") && Ig("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
      var CA = t.version.split("."), BA = +CA[0], eA = +CA[1];
      (BA < 2 || BA === 2 && eA < 6) && Ig("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + t.version + ". See momentjs.com");
      function iA(FA) {
        return FA > 96 ? FA - 87 : FA > 64 ? FA - 29 : FA - 48;
      }
      function QA(FA) {
        var mA = 0, JA = FA.split("."), VA = JA[0], HA = JA[1] || "", jA = 1, _A, $A = 0, rg = 1;
        for (FA.charCodeAt(0) === 45 && (mA = 1, rg = -1), mA; mA < VA.length; mA++)
          _A = iA(VA.charCodeAt(mA)), $A = 60 * $A + _A;
        for (mA = 0; mA < HA.length; mA++)
          jA = jA / 60, _A = iA(HA.charCodeAt(mA)), $A += _A * jA;
        return $A * rg;
      }
      function tA(FA) {
        for (var mA = 0; mA < FA.length; mA++)
          FA[mA] = QA(FA[mA]);
      }
      function oA(FA, mA) {
        for (var JA = 0; JA < mA; JA++)
          FA[JA] = Math.round((FA[JA - 1] || 0) + FA[JA] * 6e4);
        FA[mA - 1] = 1 / 0;
      }
      function EA(FA, mA) {
        var JA = [], VA;
        for (VA = 0; VA < mA.length; VA++)
          JA[VA] = FA[mA[VA]];
        return JA;
      }
      function aA(FA) {
        var mA = FA.split("|"), JA = mA[2].split(" "), VA = mA[3].split(""), HA = mA[4].split(" ");
        return tA(JA), tA(VA), tA(HA), oA(HA, VA.length), {
          name: mA[0],
          abbrs: EA(mA[1].split(" "), VA),
          offsets: EA(JA, VA),
          untils: HA,
          population: mA[5] | 0
        };
      }
      function nA(FA) {
        FA && this._set(aA(FA));
      }
      function lA(FA, mA) {
        var JA = mA.length;
        if (FA < mA[0])
          return 0;
        if (JA > 1 && mA[JA - 1] === 1 / 0 && FA >= mA[JA - 2])
          return JA - 1;
        if (FA >= mA[JA - 1])
          return -1;
        for (var VA, HA = 0, jA = JA - 1; jA - HA > 1; )
          VA = Math.floor((HA + jA) / 2), mA[VA] <= FA ? HA = VA : jA = VA;
        return jA;
      }
      nA.prototype = {
        _set: function(FA) {
          this.name = FA.name, this.abbrs = FA.abbrs, this.untils = FA.untils, this.offsets = FA.offsets, this.population = FA.population;
        },
        _index: function(FA) {
          var mA = +FA, JA = this.untils, VA;
          if (VA = lA(mA, JA), VA >= 0)
            return VA;
        },
        countries: function() {
          var FA = this.name;
          return Object.keys(H).filter(function(mA) {
            return H[mA].zones.indexOf(FA) !== -1;
          });
        },
        parse: function(FA) {
          var mA = +FA, JA = this.offsets, VA = this.untils, HA = VA.length - 1, jA, _A, $A, rg;
          for (rg = 0; rg < HA; rg++)
            if (jA = JA[rg], _A = JA[rg + 1], $A = JA[rg && rg - 1], jA < _A && gg.moveAmbiguousForward ? jA = _A : jA > $A && gg.moveInvalidForward && (jA = $A), mA < VA[rg] - jA * 6e4)
              return JA[rg];
          return JA[HA];
        },
        abbr: function(FA) {
          return this.abbrs[this._index(FA)];
        },
        offset: function(FA) {
          return Ig("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(FA)];
        },
        utcOffset: function(FA) {
          return this.offsets[this._index(FA)];
        }
      };
      function cA(FA, mA) {
        this.name = FA, this.zones = mA;
      }
      function sA(FA) {
        var mA = FA.toTimeString(), JA = mA.match(/\([a-z ]+\)/i);
        JA && JA[0] ? (JA = JA[0].match(/[A-Z]/g), JA = JA ? JA.join("") : void 0) : (JA = mA.match(/[A-Z]{3,5}/g), JA = JA ? JA[0] : void 0), JA === "GMT" && (JA = void 0), this.at = +FA, this.abbr = JA, this.offset = FA.getTimezoneOffset();
      }
      function rA(FA) {
        this.zone = FA, this.offsetScore = 0, this.abbrScore = 0;
      }
      rA.prototype.scoreOffsetAt = function(FA) {
        this.offsetScore += Math.abs(this.zone.utcOffset(FA.at) - FA.offset), this.zone.abbr(FA.at).replace(/[^A-Z]/g, "") !== FA.abbr && this.abbrScore++;
      };
      function uA(FA, mA) {
        for (var JA, VA; VA = ((mA.at - FA.at) / 12e4 | 0) * 6e4; )
          JA = new sA(new Date(FA.at + VA)), JA.offset === FA.offset ? FA = JA : mA = JA;
        return FA;
      }
      function hA() {
        var FA = (/* @__PURE__ */ new Date()).getFullYear() - 2, mA = new sA(new Date(FA, 0, 1)), JA = mA.offset, VA = [mA], HA, jA, _A, $A;
        for ($A = 1; $A < 48; $A++)
          _A = new Date(FA, $A, 1).getTimezoneOffset(), _A !== JA && (jA = new sA(new Date(FA, $A, 1)), HA = uA(mA, jA), VA.push(HA), VA.push(new sA(new Date(HA.at + 6e4))), mA = jA, JA = _A);
        for ($A = 0; $A < 4; $A++)
          VA.push(new sA(new Date(FA + $A, 0, 1))), VA.push(new sA(new Date(FA + $A, 6, 1)));
        return VA;
      }
      function dA(FA, mA) {
        return FA.offsetScore !== mA.offsetScore ? FA.offsetScore - mA.offsetScore : FA.abbrScore !== mA.abbrScore ? FA.abbrScore - mA.abbrScore : FA.zone.population !== mA.zone.population ? mA.zone.population - FA.zone.population : mA.zone.name.localeCompare(FA.zone.name);
      }
      function GA(FA, mA) {
        var JA, VA;
        for (tA(mA), JA = 0; JA < mA.length; JA++)
          VA = mA[JA], gA[VA] = gA[VA] || {}, gA[VA][FA] = !0;
      }
      function DA(FA) {
        var mA = FA.length, JA = {}, VA = [], HA = {}, jA, _A, $A, rg;
        for (jA = 0; jA < mA; jA++)
          if ($A = FA[jA].offset, !HA.hasOwnProperty($A)) {
            rg = gA[$A] || {};
            for (_A in rg)
              rg.hasOwnProperty(_A) && (JA[_A] = !0);
            HA[$A] = !0;
          }
        for (jA in JA)
          JA.hasOwnProperty(jA) && VA.push(AA[jA]);
        return VA;
      }
      function wA() {
        try {
          var FA = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (FA && FA.length > 3) {
            var mA = AA[yA(FA)];
            if (mA)
              return mA;
            Ig("Moment Timezone found " + FA + " from the Intl api, but did not have that data loaded.");
          }
        } catch {
        }
        var JA = hA(), VA = JA.length, HA = DA(JA), jA = [], _A, $A, rg;
        for ($A = 0; $A < HA.length; $A++) {
          for (_A = new rA(MA(HA[$A])), rg = 0; rg < VA; rg++)
            _A.scoreOffsetAt(JA[rg]);
          jA.push(_A);
        }
        return jA.sort(dA), jA.length > 0 ? jA[0].zone.name : void 0;
      }
      function bA(FA) {
        return (!IA || FA) && (IA = wA()), IA;
      }
      function yA(FA) {
        return (FA || "").toLowerCase().replace(/\//g, "_");
      }
      function pA(FA) {
        var mA, JA, VA, HA;
        for (typeof FA == "string" && (FA = [FA]), mA = 0; mA < FA.length; mA++)
          VA = FA[mA].split("|"), JA = VA[0], HA = yA(JA), d[HA] = FA[mA], AA[HA] = JA, GA(HA, VA[2].split(" "));
      }
      function MA(FA, mA) {
        FA = yA(FA);
        var JA = d[FA], VA;
        return JA instanceof nA ? JA : typeof JA == "string" ? (JA = new nA(JA), d[FA] = JA, JA) : k[FA] && mA !== MA && (VA = MA(k[FA], MA)) ? (JA = d[FA] = new nA(), JA._set(VA), JA.name = AA[FA], JA) : null;
      }
      function LA() {
        var FA, mA = [];
        for (FA in AA)
          AA.hasOwnProperty(FA) && (d[FA] || d[k[FA]]) && AA[FA] && mA.push(AA[FA]);
        return mA.sort();
      }
      function xA() {
        return Object.keys(H);
      }
      function TA(FA) {
        var mA, JA, VA, HA;
        for (typeof FA == "string" && (FA = [FA]), mA = 0; mA < FA.length; mA++)
          JA = FA[mA].split("|"), VA = yA(JA[0]), HA = yA(JA[1]), k[VA] = HA, AA[VA] = JA[0], k[HA] = VA, AA[HA] = JA[1];
      }
      function NA(FA) {
        var mA, JA, VA, HA;
        if (!(!FA || !FA.length))
          for (mA = 0; mA < FA.length; mA++)
            HA = FA[mA].split("|"), JA = HA[0].toUpperCase(), VA = HA[1].split(" "), H[JA] = new cA(
              JA,
              VA
            );
      }
      function zA(FA) {
        return FA = FA.toUpperCase(), H[FA] || null;
      }
      function XA(FA, mA) {
        if (FA = zA(FA), !FA) return null;
        var JA = FA.zones.sort();
        return mA ? JA.map(function(VA) {
          var HA = MA(VA);
          return {
            name: VA,
            offset: HA.utcOffset(/* @__PURE__ */ new Date())
          };
        }) : JA;
      }
      function fA(FA) {
        pA(FA.zones), TA(FA.links), NA(FA.countries), gg.dataVersion = FA.version;
      }
      function vA(FA) {
        return vA.didShowError || (vA.didShowError = !0, Ig("moment.tz.zoneExists('" + FA + "') has been deprecated in favor of !moment.tz.zone('" + FA + "')")), !!MA(FA);
      }
      function Cg(FA) {
        var mA = FA._f === "X" || FA._f === "x";
        return !!(FA._a && FA._tzm === void 0 && !mA);
      }
      function Ig(FA) {
        typeof console < "u" && typeof console.error == "function" && console.error(FA);
      }
      function gg(FA) {
        var mA = Array.prototype.slice.call(arguments, 0, -1), JA = arguments[arguments.length - 1], VA = t.utc.apply(null, mA), HA;
        return !t.isMoment(FA) && Cg(VA) && (HA = MA(JA)) && VA.add(HA.parse(VA), "minutes"), VA.tz(JA), VA;
      }
      gg.version = g, gg.dataVersion = "", gg._zones = d, gg._links = k, gg._names = AA, gg._countries = H, gg.add = pA, gg.link = TA, gg.load = fA, gg.zone = MA, gg.zoneExists = vA, gg.guess = bA, gg.names = LA, gg.Zone = nA, gg.unpack = aA, gg.unpackBase60 = QA, gg.needsOffset = Cg, gg.moveInvalidForward = !0, gg.moveAmbiguousForward = !1, gg.countries = xA, gg.zonesForCountry = XA;
      var og = t.fn;
      t.tz = gg, t.defaultZone = null, t.updateOffset = function(FA, mA) {
        var JA = t.defaultZone, VA;
        if (FA._z === void 0 && (JA && Cg(FA) && !FA._isUTC && FA.isValid() && (FA._d = t.utc(FA._a)._d, FA.utc().add(JA.parse(FA), "minutes")), FA._z = JA), FA._z)
          if (VA = FA._z.utcOffset(FA), Math.abs(VA) < 16 && (VA = VA / 60), FA.utcOffset !== void 0) {
            var HA = FA._z;
            FA.utcOffset(-VA, mA), FA._z = HA;
          } else
            FA.zone(VA, mA);
      }, og.tz = function(FA, mA) {
        if (FA) {
          if (typeof FA != "string")
            throw new Error("Time zone name must be a string, got " + FA + " [" + typeof FA + "]");
          return this._z = MA(FA), this._z ? t.updateOffset(this, mA) : Ig("Moment Timezone has no data for " + FA + ". See http://momentjs.com/timezone/docs/#/data-loading/."), this;
        }
        if (this._z)
          return this._z.name;
      };
      function eg(FA) {
        return function() {
          return this._z ? this._z.abbr(this) : FA.call(this);
        };
      }
      function kA(FA) {
        return function() {
          return this._z = null, FA.apply(this, arguments);
        };
      }
      function YA(FA) {
        return function() {
          return arguments.length > 0 && (this._z = null), FA.apply(this, arguments);
        };
      }
      og.zoneName = eg(og.zoneName), og.zoneAbbr = eg(og.zoneAbbr), og.utc = kA(og.utc), og.local = kA(og.local), og.utcOffset = YA(og.utcOffset), t.tz.setDefault = function(FA) {
        return (BA < 2 || BA === 2 && eA < 9) && Ig("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + t.version + "."), t.defaultZone = FA ? MA(FA) : null, t;
      };
      var RA = t.momentProperties;
      return Object.prototype.toString.call(RA) === "[object Array]" ? (RA.push("_z"), RA.push("_a")) : RA && (RA._z = null), t;
    });
  })(momentTimezone$1)), momentTimezone$1.exports;
}
const version$4 = "2025b", zones = /* @__PURE__ */ JSON.parse('["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.i -20|01|-2sw2a.i|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Bahia_Banderas|LMT MST CST MDT CDT|71 70 60 60 50|01213121313131313131313131313131313142424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST CDT EDT|5L.4 60 50 50 40|01213132431313131313131313131313131313131312|-1UQG0 2q3C0 2tx0 wgP0 1lb0 14p0 1lb0 14o0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4","America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Coyhaique|LMT SMT -05 -04 -03|4M.g 4G.J 50 40 30|012131323232323232323434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvb.I MJbS.t fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0|","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mp0 8lz0 SN0 1cL0 pHB0 83r0 AU0 5MN0 1Rz0 38N0 Wn0 1qP0 11z0 1o10 11z0 3NA0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST MDT|7n.Q 70 60 60|01213121313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST MDT|75.E 70 60 60|01213121313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q3C0 24n0 wG10 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT MST CST MDT CDT|6F.g 70 60 60 50|012131242424242424242424242424242424242424242424242424242424242|-1UQG0 dep0 8lz0 16p0 11z0 1dd0 2gmp0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5","Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le80 1dnX0 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU.8 -83.Q -80 -90 -90|012323432323232|-54m83.Q 2d8A3.Q 1urM0 un0 bW10 nb0 7qo0 1MM0 klB0 lz0 TwN0 1bb0 uNB0 rz0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 Dc0 1iMu JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET WEST|1G.E 1S.w 20 10 0 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232323434343434343434343434356434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 CT90 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 Ap0 An0 wo0 Eo0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 BJ90 1a00 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-10|+10|-a0|0||","Etc/GMT-11|+11|-b0|0||","Etc/GMT-12|+12|-c0|0||","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Etc/GMT-7|+07|-70|0||","Etc/GMT-8|+08|-80|0||","Etc/GMT-9|+09|-90|0||","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+2|-02|20|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212124121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 oiK0 1cM0 1cM0 1fB0 1cM0 1cM0 1cM0 1fA0 1a00 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3"]'), links = ["Africa/Abidjan|Africa/Accra", "Africa/Abidjan|Africa/Bamako", "Africa/Abidjan|Africa/Banjul", "Africa/Abidjan|Africa/Conakry", "Africa/Abidjan|Africa/Dakar", "Africa/Abidjan|Africa/Freetown", "Africa/Abidjan|Africa/Lome", "Africa/Abidjan|Africa/Nouakchott", "Africa/Abidjan|Africa/Ouagadougou", "Africa/Abidjan|Africa/Timbuktu", "Africa/Abidjan|Atlantic/Reykjavik", "Africa/Abidjan|Atlantic/St_Helena", "Africa/Abidjan|Iceland", "Africa/Cairo|Egypt", "Africa/Johannesburg|Africa/Maseru", "Africa/Johannesburg|Africa/Mbabane", "Africa/Lagos|Africa/Bangui", "Africa/Lagos|Africa/Brazzaville", "Africa/Lagos|Africa/Douala", "Africa/Lagos|Africa/Kinshasa", "Africa/Lagos|Africa/Libreville", "Africa/Lagos|Africa/Luanda", "Africa/Lagos|Africa/Malabo", "Africa/Lagos|Africa/Niamey", "Africa/Lagos|Africa/Porto-Novo", "Africa/Maputo|Africa/Blantyre", "Africa/Maputo|Africa/Bujumbura", "Africa/Maputo|Africa/Gaborone", "Africa/Maputo|Africa/Harare", "Africa/Maputo|Africa/Kigali", "Africa/Maputo|Africa/Lubumbashi", "Africa/Maputo|Africa/Lusaka", "Africa/Nairobi|Africa/Addis_Ababa", "Africa/Nairobi|Africa/Asmara", "Africa/Nairobi|Africa/Asmera", "Africa/Nairobi|Africa/Dar_es_Salaam", "Africa/Nairobi|Africa/Djibouti", "Africa/Nairobi|Africa/Kampala", "Africa/Nairobi|Africa/Mogadishu", "Africa/Nairobi|Indian/Antananarivo", "Africa/Nairobi|Indian/Comoro", "Africa/Nairobi|Indian/Mayotte", "Africa/Tripoli|Libya", "America/Adak|America/Atka", "America/Adak|US/Aleutian", "America/Anchorage|US/Alaska", "America/Argentina/Buenos_Aires|America/Buenos_Aires", "America/Argentina/Catamarca|America/Argentina/ComodRivadavia", "America/Argentina/Catamarca|America/Catamarca", "America/Argentina/Cordoba|America/Cordoba", "America/Argentina/Cordoba|America/Rosario", "America/Argentina/Jujuy|America/Jujuy", "America/Argentina/Mendoza|America/Mendoza", "America/Chicago|CST6CDT", "America/Chicago|US/Central", "America/Denver|America/Shiprock", "America/Denver|MST7MDT", "America/Denver|Navajo", "America/Denver|US/Mountain", "America/Detroit|US/Michigan", "America/Edmonton|America/Yellowknife", "America/Edmonton|Canada/Mountain", "America/Fort_Wayne|America/Indiana/Indianapolis", "America/Fort_Wayne|America/Indianapolis", "America/Fort_Wayne|US/East-Indiana", "America/Godthab|America/Nuuk", "America/Halifax|Canada/Atlantic", "America/Havana|Cuba", "America/Indiana/Knox|America/Knox_IN", "America/Indiana/Knox|US/Indiana-Starke", "America/Iqaluit|America/Pangnirtung", "America/Jamaica|Jamaica", "America/Kentucky/Louisville|America/Louisville", "America/Los_Angeles|PST8PDT", "America/Los_Angeles|US/Pacific", "America/Manaus|Brazil/West", "America/Mazatlan|Mexico/BajaSur", "America/Mexico_City|Mexico/General", "America/New_York|EST5EDT", "America/New_York|US/Eastern", "America/Noronha|Brazil/DeNoronha", "America/Panama|America/Atikokan", "America/Panama|America/Cayman", "America/Panama|America/Coral_Harbour", "America/Panama|EST", "America/Phoenix|America/Creston", "America/Phoenix|MST", "America/Phoenix|US/Arizona", "America/Puerto_Rico|America/Anguilla", "America/Puerto_Rico|America/Antigua", "America/Puerto_Rico|America/Aruba", "America/Puerto_Rico|America/Blanc-Sablon", "America/Puerto_Rico|America/Curacao", "America/Puerto_Rico|America/Dominica", "America/Puerto_Rico|America/Grenada", "America/Puerto_Rico|America/Guadeloupe", "America/Puerto_Rico|America/Kralendijk", "America/Puerto_Rico|America/Lower_Princes", "America/Puerto_Rico|America/Marigot", "America/Puerto_Rico|America/Montserrat", "America/Puerto_Rico|America/Port_of_Spain", "America/Puerto_Rico|America/St_Barthelemy", "America/Puerto_Rico|America/St_Kitts", "America/Puerto_Rico|America/St_Lucia", "America/Puerto_Rico|America/St_Thomas", "America/Puerto_Rico|America/St_Vincent", "America/Puerto_Rico|America/Tortola", "America/Puerto_Rico|America/Virgin", "America/Regina|Canada/Saskatchewan", "America/Rio_Branco|America/Porto_Acre", "America/Rio_Branco|Brazil/Acre", "America/Santiago|Chile/Continental", "America/Sao_Paulo|Brazil/East", "America/St_Johns|Canada/Newfoundland", "America/Tijuana|America/Ensenada", "America/Tijuana|America/Santa_Isabel", "America/Tijuana|Mexico/BajaNorte", "America/Toronto|America/Montreal", "America/Toronto|America/Nassau", "America/Toronto|America/Nipigon", "America/Toronto|America/Thunder_Bay", "America/Toronto|Canada/Eastern", "America/Vancouver|Canada/Pacific", "America/Whitehorse|Canada/Yukon", "America/Winnipeg|America/Rainy_River", "America/Winnipeg|Canada/Central", "Asia/Ashgabat|Asia/Ashkhabad", "Asia/Bangkok|Asia/Phnom_Penh", "Asia/Bangkok|Asia/Vientiane", "Asia/Bangkok|Indian/Christmas", "Asia/Brunei|Asia/Kuching", "Asia/Dhaka|Asia/Dacca", "Asia/Dubai|Asia/Muscat", "Asia/Dubai|Indian/Mahe", "Asia/Dubai|Indian/Reunion", "Asia/Ho_Chi_Minh|Asia/Saigon", "Asia/Hong_Kong|Hongkong", "Asia/Jerusalem|Asia/Tel_Aviv", "Asia/Jerusalem|Israel", "Asia/Kathmandu|Asia/Katmandu", "Asia/Kolkata|Asia/Calcutta", "Asia/Kuala_Lumpur|Asia/Singapore", "Asia/Kuala_Lumpur|Singapore", "Asia/Macau|Asia/Macao", "Asia/Makassar|Asia/Ujung_Pandang", "Asia/Nicosia|Europe/Nicosia", "Asia/Qatar|Asia/Bahrain", "Asia/Rangoon|Asia/Yangon", "Asia/Rangoon|Indian/Cocos", "Asia/Riyadh|Antarctica/Syowa", "Asia/Riyadh|Asia/Aden", "Asia/Riyadh|Asia/Kuwait", "Asia/Seoul|ROK", "Asia/Shanghai|Asia/Chongqing", "Asia/Shanghai|Asia/Chungking", "Asia/Shanghai|Asia/Harbin", "Asia/Shanghai|PRC", "Asia/Taipei|ROC", "Asia/Tehran|Iran", "Asia/Thimphu|Asia/Thimbu", "Asia/Tokyo|Japan", "Asia/Ulaanbaatar|Asia/Choibalsan", "Asia/Ulaanbaatar|Asia/Ulan_Bator", "Asia/Urumqi|Asia/Kashgar", "Atlantic/Faroe|Atlantic/Faeroe", "Australia/Adelaide|Australia/South", "Australia/Brisbane|Australia/Queensland", "Australia/Broken_Hill|Australia/Yancowinna", "Australia/Darwin|Australia/North", "Australia/Hobart|Australia/Currie", "Australia/Hobart|Australia/Tasmania", "Australia/Lord_Howe|Australia/LHI", "Australia/Melbourne|Australia/Victoria", "Australia/Perth|Australia/West", "Australia/Sydney|Australia/ACT", "Australia/Sydney|Australia/Canberra", "Australia/Sydney|Australia/NSW", "Etc/GMT-0|Etc/GMT", "Etc/GMT-0|Etc/GMT+0", "Etc/GMT-0|Etc/GMT0", "Etc/GMT-0|Etc/Greenwich", "Etc/GMT-0|GMT", "Etc/GMT-0|GMT+0", "Etc/GMT-0|GMT-0", "Etc/GMT-0|GMT0", "Etc/GMT-0|Greenwich", "Etc/UTC|Etc/UCT", "Etc/UTC|Etc/Universal", "Etc/UTC|Etc/Zulu", "Etc/UTC|UCT", "Etc/UTC|UTC", "Etc/UTC|Universal", "Etc/UTC|Zulu", "Europe/Athens|EET", "Europe/Belgrade|Europe/Ljubljana", "Europe/Belgrade|Europe/Podgorica", "Europe/Belgrade|Europe/Sarajevo", "Europe/Belgrade|Europe/Skopje", "Europe/Belgrade|Europe/Zagreb", "Europe/Berlin|Arctic/Longyearbyen", "Europe/Berlin|Atlantic/Jan_Mayen", "Europe/Berlin|Europe/Copenhagen", "Europe/Berlin|Europe/Oslo", "Europe/Berlin|Europe/Stockholm", "Europe/Brussels|CET", "Europe/Brussels|Europe/Amsterdam", "Europe/Brussels|Europe/Luxembourg", "Europe/Brussels|MET", "Europe/Chisinau|Europe/Tiraspol", "Europe/Dublin|Eire", "Europe/Helsinki|Europe/Mariehamn", "Europe/Istanbul|Asia/Istanbul", "Europe/Istanbul|Turkey", "Europe/Kiev|Europe/Kyiv", "Europe/Kiev|Europe/Uzhgorod", "Europe/Kiev|Europe/Zaporozhye", "Europe/Lisbon|Portugal", "Europe/Lisbon|WET", "Europe/London|Europe/Belfast", "Europe/London|Europe/Guernsey", "Europe/London|Europe/Isle_of_Man", "Europe/London|Europe/Jersey", "Europe/London|GB", "Europe/London|GB-Eire", "Europe/Moscow|W-SU", "Europe/Paris|Europe/Monaco", "Europe/Prague|Europe/Bratislava", "Europe/Rome|Europe/San_Marino", "Europe/Rome|Europe/Vatican", "Europe/Warsaw|Poland", "Europe/Zurich|Europe/Busingen", "Europe/Zurich|Europe/Vaduz", "Indian/Maldives|Indian/Kerguelen", "Pacific/Auckland|Antarctica/McMurdo", "Pacific/Auckland|Antarctica/South_Pole", "Pacific/Auckland|NZ", "Pacific/Chatham|NZ-CHAT", "Pacific/Easter|Chile/EasterIsland", "Pacific/Enderbury|Pacific/Kanton", "Pacific/Guadalcanal|Pacific/Pohnpei", "Pacific/Guadalcanal|Pacific/Ponape", "Pacific/Guam|Pacific/Saipan", "Pacific/Honolulu|HST", "Pacific/Honolulu|Pacific/Johnston", "Pacific/Honolulu|US/Hawaii", "Pacific/Kwajalein|Kwajalein", "Pacific/Pago_Pago|Pacific/Midway", "Pacific/Pago_Pago|Pacific/Samoa", "Pacific/Pago_Pago|US/Samoa", "Pacific/Port_Moresby|Antarctica/DumontDUrville", "Pacific/Port_Moresby|Pacific/Chuuk", "Pacific/Port_Moresby|Pacific/Truk", "Pacific/Port_Moresby|Pacific/Yap", "Pacific/Tarawa|Pacific/Funafuti", "Pacific/Tarawa|Pacific/Majuro", "Pacific/Tarawa|Pacific/Wake", "Pacific/Tarawa|Pacific/Wallis"], countries = ["AD|Europe/Andorra", "AE|Asia/Dubai", "AF|Asia/Kabul", "AG|America/Puerto_Rico America/Antigua", "AI|America/Puerto_Rico America/Anguilla", "AL|Europe/Tirane", "AM|Asia/Yerevan", "AO|Africa/Lagos Africa/Luanda", "AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Asia/Singapore Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa", "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia", "AS|Pacific/Pago_Pago", "AT|Europe/Vienna", "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla Asia/Tokyo", "AW|America/Puerto_Rico America/Aruba", "AX|Europe/Helsinki Europe/Mariehamn", "AZ|Asia/Baku", "BA|Europe/Belgrade Europe/Sarajevo", "BB|America/Barbados", "BD|Asia/Dhaka", "BE|Europe/Brussels", "BF|Africa/Abidjan Africa/Ouagadougou", "BG|Europe/Sofia", "BH|Asia/Qatar Asia/Bahrain", "BI|Africa/Maputo Africa/Bujumbura", "BJ|Africa/Lagos Africa/Porto-Novo", "BL|America/Puerto_Rico America/St_Barthelemy", "BM|Atlantic/Bermuda", "BN|Asia/Kuching Asia/Brunei", "BO|America/La_Paz", "BQ|America/Puerto_Rico America/Kralendijk", "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco", "BS|America/Toronto America/Nassau", "BT|Asia/Thimphu", "BW|Africa/Maputo Africa/Gaborone", "BY|Europe/Minsk", "BZ|America/Belize", "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston", "CC|Asia/Yangon Indian/Cocos", "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi", "CF|Africa/Lagos Africa/Bangui", "CG|Africa/Lagos Africa/Brazzaville", "CH|Europe/Zurich", "CI|Africa/Abidjan", "CK|Pacific/Rarotonga", "CL|America/Santiago America/Coyhaique America/Punta_Arenas Pacific/Easter", "CM|Africa/Lagos Africa/Douala", "CN|Asia/Shanghai Asia/Urumqi", "CO|America/Bogota", "CR|America/Costa_Rica", "CU|America/Havana", "CV|Atlantic/Cape_Verde", "CW|America/Puerto_Rico America/Curacao", "CX|Asia/Bangkok Indian/Christmas", "CY|Asia/Nicosia Asia/Famagusta", "CZ|Europe/Prague", "DE|Europe/Zurich Europe/Berlin Europe/Busingen", "DJ|Africa/Nairobi Africa/Djibouti", "DK|Europe/Berlin Europe/Copenhagen", "DM|America/Puerto_Rico America/Dominica", "DO|America/Santo_Domingo", "DZ|Africa/Algiers", "EC|America/Guayaquil Pacific/Galapagos", "EE|Europe/Tallinn", "EG|Africa/Cairo", "EH|Africa/El_Aaiun", "ER|Africa/Nairobi Africa/Asmara", "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary", "ET|Africa/Nairobi Africa/Addis_Ababa", "FI|Europe/Helsinki", "FJ|Pacific/Fiji", "FK|Atlantic/Stanley", "FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei", "FO|Atlantic/Faroe", "FR|Europe/Paris", "GA|Africa/Lagos Africa/Libreville", "GB|Europe/London", "GD|America/Puerto_Rico America/Grenada", "GE|Asia/Tbilisi", "GF|America/Cayenne", "GG|Europe/London Europe/Guernsey", "GH|Africa/Abidjan Africa/Accra", "GI|Europe/Gibraltar", "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule", "GM|Africa/Abidjan Africa/Banjul", "GN|Africa/Abidjan Africa/Conakry", "GP|America/Puerto_Rico America/Guadeloupe", "GQ|Africa/Lagos Africa/Malabo", "GR|Europe/Athens", "GS|Atlantic/South_Georgia", "GT|America/Guatemala", "GU|Pacific/Guam", "GW|Africa/Bissau", "GY|America/Guyana", "HK|Asia/Hong_Kong", "HN|America/Tegucigalpa", "HR|Europe/Belgrade Europe/Zagreb", "HT|America/Port-au-Prince", "HU|Europe/Budapest", "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura", "IE|Europe/Dublin", "IL|Asia/Jerusalem", "IM|Europe/London Europe/Isle_of_Man", "IN|Asia/Kolkata", "IO|Indian/Chagos", "IQ|Asia/Baghdad", "IR|Asia/Tehran", "IS|Africa/Abidjan Atlantic/Reykjavik", "IT|Europe/Rome", "JE|Europe/London Europe/Jersey", "JM|America/Jamaica", "JO|Asia/Amman", "JP|Asia/Tokyo", "KE|Africa/Nairobi", "KG|Asia/Bishkek", "KH|Asia/Bangkok Asia/Phnom_Penh", "KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati", "KM|Africa/Nairobi Indian/Comoro", "KN|America/Puerto_Rico America/St_Kitts", "KP|Asia/Pyongyang", "KR|Asia/Seoul", "KW|Asia/Riyadh Asia/Kuwait", "KY|America/Panama America/Cayman", "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral", "LA|Asia/Bangkok Asia/Vientiane", "LB|Asia/Beirut", "LC|America/Puerto_Rico America/St_Lucia", "LI|Europe/Zurich Europe/Vaduz", "LK|Asia/Colombo", "LR|Africa/Monrovia", "LS|Africa/Johannesburg Africa/Maseru", "LT|Europe/Vilnius", "LU|Europe/Brussels Europe/Luxembourg", "LV|Europe/Riga", "LY|Africa/Tripoli", "MA|Africa/Casablanca", "MC|Europe/Paris Europe/Monaco", "MD|Europe/Chisinau", "ME|Europe/Belgrade Europe/Podgorica", "MF|America/Puerto_Rico America/Marigot", "MG|Africa/Nairobi Indian/Antananarivo", "MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro", "MK|Europe/Belgrade Europe/Skopje", "ML|Africa/Abidjan Africa/Bamako", "MM|Asia/Yangon", "MN|Asia/Ulaanbaatar Asia/Hovd", "MO|Asia/Macau", "MP|Pacific/Guam Pacific/Saipan", "MQ|America/Martinique", "MR|Africa/Abidjan Africa/Nouakchott", "MS|America/Puerto_Rico America/Montserrat", "MT|Europe/Malta", "MU|Indian/Mauritius", "MV|Indian/Maldives", "MW|Africa/Maputo Africa/Blantyre", "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana", "MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur", "MZ|Africa/Maputo", "NA|Africa/Windhoek", "NC|Pacific/Noumea", "NE|Africa/Lagos Africa/Niamey", "NF|Pacific/Norfolk", "NG|Africa/Lagos", "NI|America/Managua", "NL|Europe/Brussels Europe/Amsterdam", "NO|Europe/Berlin Europe/Oslo", "NP|Asia/Kathmandu", "NR|Pacific/Nauru", "NU|Pacific/Niue", "NZ|Pacific/Auckland Pacific/Chatham", "OM|Asia/Dubai Asia/Muscat", "PA|America/Panama", "PE|America/Lima", "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier", "PG|Pacific/Port_Moresby Pacific/Bougainville", "PH|Asia/Manila", "PK|Asia/Karachi", "PL|Europe/Warsaw", "PM|America/Miquelon", "PN|Pacific/Pitcairn", "PR|America/Puerto_Rico", "PS|Asia/Gaza Asia/Hebron", "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores", "PW|Pacific/Palau", "PY|America/Asuncion", "QA|Asia/Qatar", "RE|Asia/Dubai Indian/Reunion", "RO|Europe/Bucharest", "RS|Europe/Belgrade", "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr", "RW|Africa/Maputo Africa/Kigali", "SA|Asia/Riyadh", "SB|Pacific/Guadalcanal", "SC|Asia/Dubai Indian/Mahe", "SD|Africa/Khartoum", "SE|Europe/Berlin Europe/Stockholm", "SG|Asia/Singapore", "SH|Africa/Abidjan Atlantic/St_Helena", "SI|Europe/Belgrade Europe/Ljubljana", "SJ|Europe/Berlin Arctic/Longyearbyen", "SK|Europe/Prague Europe/Bratislava", "SL|Africa/Abidjan Africa/Freetown", "SM|Europe/Rome Europe/San_Marino", "SN|Africa/Abidjan Africa/Dakar", "SO|Africa/Nairobi Africa/Mogadishu", "SR|America/Paramaribo", "SS|Africa/Juba", "ST|Africa/Sao_Tome", "SV|America/El_Salvador", "SX|America/Puerto_Rico America/Lower_Princes", "SY|Asia/Damascus", "SZ|Africa/Johannesburg Africa/Mbabane", "TC|America/Grand_Turk", "TD|Africa/Ndjamena", "TF|Asia/Dubai Indian/Maldives Indian/Kerguelen", "TG|Africa/Abidjan Africa/Lome", "TH|Asia/Bangkok", "TJ|Asia/Dushanbe", "TK|Pacific/Fakaofo", "TL|Asia/Dili", "TM|Asia/Ashgabat", "TN|Africa/Tunis", "TO|Pacific/Tongatapu", "TR|Europe/Istanbul", "TT|America/Puerto_Rico America/Port_of_Spain", "TV|Pacific/Tarawa Pacific/Funafuti", "TW|Asia/Taipei", "TZ|Africa/Nairobi Africa/Dar_es_Salaam", "UA|Europe/Simferopol Europe/Kyiv", "UG|Africa/Nairobi Africa/Kampala", "UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake", "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu", "UY|America/Montevideo", "UZ|Asia/Samarkand Asia/Tashkent", "VA|Europe/Rome Europe/Vatican", "VC|America/Puerto_Rico America/St_Vincent", "VE|America/Caracas", "VG|America/Puerto_Rico America/Tortola", "VI|America/Puerto_Rico America/St_Thomas", "VN|Asia/Bangkok Asia/Ho_Chi_Minh", "VU|Pacific/Efate", "WF|Pacific/Tarawa Pacific/Wallis", "WS|Pacific/Apia", "YE|Asia/Riyadh Asia/Aden", "YT|Africa/Nairobi Indian/Mayotte", "ZA|Africa/Johannesburg", "ZM|Africa/Maputo Africa/Lusaka", "ZW|Africa/Maputo Africa/Harare"], require$$1 = {
  version: version$4,
  zones,
  links,
  countries
};
var hasRequiredMomentTimezone;
function requireMomentTimezone() {
  if (hasRequiredMomentTimezone) return momentTimezone$2.exports;
  hasRequiredMomentTimezone = 1;
  var n = momentTimezone$2.exports = requireMomentTimezone$1();
  return n.tz.load(require$$1), momentTimezone$2.exports;
}
var momentTimezoneExports = requireMomentTimezone();
const moment = /* @__PURE__ */ getDefaultExportFromCjs$2(momentTimezoneExports);
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs$1(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var enUS, hasRequiredEnUS;
function requireEnUS() {
  return hasRequiredEnUS || (hasRequiredEnUS = 1, enUS = {
    languageTag: "en-US",
    delimiters: {
      thousands: ",",
      decimal: "."
    },
    abbreviations: {
      thousand: "k",
      million: "m",
      billion: "b",
      trillion: "t"
    },
    spaceSeparated: !1,
    ordinal: function(n) {
      let t = n % 10;
      return ~~(n % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    },
    bytes: {
      binarySuffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"],
      decimalSuffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    },
    currency: {
      symbol: "$",
      position: "prefix",
      code: "USD"
    },
    currencyFormat: {
      thousandSeparated: !0,
      totalLength: 4,
      spaceSeparated: !0,
      spaceSeparatedCurrency: !0
    },
    formats: {
      fourDigits: {
        totalLength: 4,
        spaceSeparated: !0
      },
      fullWithTwoDecimals: {
        output: "currency",
        thousandSeparated: !0,
        mantissa: 2
      },
      fullWithTwoDecimalsNoCurrency: {
        thousandSeparated: !0,
        mantissa: 2
      },
      fullWithNoDecimals: {
        output: "currency",
        thousandSeparated: !0,
        mantissa: 0
      }
    }
  }), enUS;
}
var unformatting, hasRequiredUnformatting;
function requireUnformatting() {
  if (hasRequiredUnformatting) return unformatting;
  hasRequiredUnformatting = 1;
  const n = [
    { key: "ZiB", factor: Math.pow(1024, 7) },
    { key: "ZB", factor: Math.pow(1e3, 7) },
    { key: "YiB", factor: Math.pow(1024, 8) },
    { key: "YB", factor: Math.pow(1e3, 8) },
    { key: "TiB", factor: Math.pow(1024, 4) },
    { key: "TB", factor: Math.pow(1e3, 4) },
    { key: "PiB", factor: Math.pow(1024, 5) },
    { key: "PB", factor: Math.pow(1e3, 5) },
    { key: "MiB", factor: Math.pow(1024, 2) },
    { key: "MB", factor: Math.pow(1e3, 2) },
    { key: "KiB", factor: Math.pow(1024, 1) },
    { key: "KB", factor: Math.pow(1e3, 1) },
    { key: "GiB", factor: Math.pow(1024, 3) },
    { key: "GB", factor: Math.pow(1e3, 3) },
    { key: "EiB", factor: Math.pow(1024, 6) },
    { key: "EB", factor: Math.pow(1e3, 6) },
    { key: "B", factor: 1 }
  ];
  function t(IA) {
    return IA.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
  }
  function g(IA, CA, BA, eA, iA, QA, tA) {
    if (!isNaN(+IA))
      return +IA;
    let oA = "", EA = IA.replace(/(^[^(]*)\((.*)\)([^)]*$)/, "$1$2$3");
    if (EA !== IA)
      return -1 * g(EA, CA, BA, eA, iA, QA);
    for (let rA = 0; rA < n.length; rA++) {
      let uA = n[rA];
      if (oA = IA.replace(RegExp(`([0-9 ])(${uA.key})$`), "$1"), oA !== IA)
        return g(oA, CA, BA, eA, iA, QA) * uA.factor;
    }
    if (oA = IA.replace("%", ""), oA !== IA)
      return g(oA, CA, BA, eA, iA, QA) / 100;
    let aA = parseFloat(IA);
    if (isNaN(aA))
      return;
    let nA = eA(aA);
    if (nA && nA !== "." && (oA = IA.replace(new RegExp(`${t(nA)}$`), ""), oA !== IA))
      return g(oA, CA, BA, eA, iA, QA);
    let lA = {};
    Object.keys(QA).forEach((rA) => {
      lA[QA[rA]] = rA;
    });
    let cA = Object.keys(lA).sort().reverse(), sA = cA.length;
    for (let rA = 0; rA < sA; rA++) {
      let uA = cA[rA], hA = lA[uA];
      if (oA = IA.replace(uA, ""), oA !== IA) {
        let dA;
        switch (hA) {
          // eslint-disable-line default-case
          case "thousand":
            dA = Math.pow(10, 3);
            break;
          case "million":
            dA = Math.pow(10, 6);
            break;
          case "billion":
            dA = Math.pow(10, 9);
            break;
          case "trillion":
            dA = Math.pow(10, 12);
            break;
        }
        return g(oA, CA, BA, eA, iA, QA) * dA;
      }
    }
  }
  function d(IA, CA, BA) {
    let eA = IA.replace(BA, "");
    return eA = eA.replace(new RegExp(`([0-9])${t(CA.thousands)}([0-9])`, "g"), "$1$2"), eA = eA.replace(CA.decimal, "."), eA;
  }
  function k(IA, CA, BA = "", eA, iA, QA, tA) {
    if (IA === "")
      return;
    if (IA === iA)
      return 0;
    let oA = d(IA, CA, BA);
    return g(oA, CA, BA, eA, iA, QA);
  }
  function H(IA, CA) {
    if (!(IA.indexOf(":") && CA.thousands !== ":"))
      return !1;
    let eA = IA.split(":");
    if (eA.length !== 3)
      return !1;
    let iA = +eA[0], QA = +eA[1], tA = +eA[2];
    return !isNaN(iA) && !isNaN(QA) && !isNaN(tA);
  }
  function AA(IA) {
    let CA = IA.split(":"), BA = +CA[0], eA = +CA[1];
    return +CA[2] + 60 * eA + 3600 * BA;
  }
  function gA(IA, CA) {
    const BA = requireGlobalState();
    let eA = BA.currentDelimiters(), iA = BA.currentCurrency().symbol, QA = BA.currentOrdinal(), tA = BA.getZeroFormat(), oA = BA.currentAbbreviations(), EA;
    if (typeof IA == "string")
      H(IA, eA) ? EA = AA(IA) : EA = k(IA, eA, iA, QA, tA, oA);
    else if (typeof IA == "number")
      EA = IA;
    else
      return;
    if (EA !== void 0)
      return EA;
  }
  return unformatting = {
    unformat: gA
  }, unformatting;
}
var validating$1, hasRequiredValidating;
function requireValidating() {
  if (hasRequiredValidating) return validating$1;
  hasRequiredValidating = 1;
  let n = requireUnformatting();
  const t = /^[a-z]{2,3}(-[a-zA-Z]{4})?(-([A-Z]{2}|[0-9]{3}))?$/, g = [
    "currency",
    "percent",
    "byte",
    "time",
    "ordinal",
    "number"
  ], d = [
    "trillion",
    "billion",
    "million",
    "thousand"
  ], k = [
    "prefix",
    "infix",
    "postfix"
  ], H = [
    "sign",
    "parenthesis"
  ], AA = {
    type: "object",
    children: {
      thousand: {
        type: "string",
        mandatory: !0
      },
      million: {
        type: "string",
        mandatory: !0
      },
      billion: {
        type: "string",
        mandatory: !0
      },
      trillion: {
        type: "string",
        mandatory: !0
      }
    },
    mandatory: !0
  }, CA = {
    output: {
      type: "string",
      validValues: g
    },
    base: {
      type: "string",
      validValues: [
        "decimal",
        "binary",
        "general"
      ],
      restriction: (EA, aA) => aA.output === "byte",
      message: "`base` must be provided only when the output is `byte`",
      mandatory: (EA) => EA.output === "byte"
    },
    characteristic: {
      type: "number",
      restriction: (EA) => EA >= 0,
      message: "value must be positive"
    },
    prefix: "string",
    postfix: "string",
    forceAverage: {
      type: "string",
      validValues: d
    },
    average: "boolean",
    lowPrecision: {
      type: "boolean",
      restriction: (EA, aA) => aA.average === !0,
      message: "`lowPrecision` must be provided only when the option `average` is set"
    },
    currencyPosition: {
      type: "string",
      validValues: k
    },
    currencySymbol: "string",
    totalLength: {
      type: "number",
      restrictions: [
        {
          restriction: (EA) => EA >= 0,
          message: "value must be positive"
        },
        {
          restriction: (EA, aA) => !aA.exponential,
          message: "`totalLength` is incompatible with `exponential`"
        }
      ]
    },
    mantissa: {
      type: "number",
      restriction: (EA) => EA >= 0,
      message: "value must be positive"
    },
    optionalMantissa: "boolean",
    trimMantissa: "boolean",
    roundingFunction: "function",
    optionalCharacteristic: "boolean",
    thousandSeparated: "boolean",
    spaceSeparated: "boolean",
    spaceSeparatedCurrency: "boolean",
    spaceSeparatedAbbreviation: "boolean",
    abbreviations: {
      type: "object",
      children: {
        thousand: "string",
        million: "string",
        billion: "string",
        trillion: "string"
      }
    },
    negative: {
      type: "string",
      validValues: H
    },
    forceSign: "boolean",
    exponential: {
      type: "boolean"
    },
    prefixSymbol: {
      type: "boolean",
      restriction: (EA, aA) => aA.output === "percent",
      message: "`prefixSymbol` can be provided only when the output is `percent`"
    }
  }, BA = {
    languageTag: {
      type: "string",
      mandatory: !0,
      restriction: (EA) => EA.match(t),
      message: "the language tag must follow the BCP 47 specification (see https://tools.ieft.org/html/bcp47)"
    },
    delimiters: {
      type: "object",
      children: {
        thousands: "string",
        decimal: "string",
        thousandsSize: "number"
      },
      mandatory: !0
    },
    abbreviations: AA,
    spaceSeparated: "boolean",
    spaceSeparatedCurrency: "boolean",
    ordinal: {
      type: "function",
      mandatory: !0
    },
    bytes: {
      type: "object",
      children: {
        binarySuffixes: "object",
        decimalSuffixes: "object"
      }
    },
    currency: {
      type: "object",
      children: {
        symbol: "string",
        position: "string",
        code: "string"
      },
      mandatory: !0
    },
    defaults: "format",
    ordinalFormat: "format",
    byteFormat: "format",
    percentageFormat: "format",
    currencyFormat: "format",
    timeDefaults: "format",
    formats: {
      type: "object",
      children: {
        fourDigits: {
          type: "format",
          mandatory: !0
        },
        fullWithTwoDecimals: {
          type: "format",
          mandatory: !0
        },
        fullWithTwoDecimalsNoCurrency: {
          type: "format",
          mandatory: !0
        },
        fullWithNoDecimals: {
          type: "format",
          mandatory: !0
        }
      }
    }
  };
  function eA(EA, aA) {
    let nA = iA(EA), lA = tA(aA);
    return nA && lA;
  }
  function iA(EA) {
    return n.unformat(EA) !== void 0;
  }
  function QA(EA, aA, nA, lA = !1) {
    let cA = Object.keys(EA).map((sA) => {
      if (!aA[sA])
        return console.error(`${nA} Invalid key: ${sA}`), !1;
      let rA = EA[sA], uA = aA[sA];
      if (typeof uA == "string" && (uA = { type: uA }), uA.type === "format") {
        if (!QA(rA, CA, `[Validate ${sA}]`, !0))
          return !1;
      } else if (typeof rA !== uA.type)
        return console.error(`${nA} ${sA} type mismatched: "${uA.type}" expected, "${typeof rA}" provided`), !1;
      if (uA.restrictions && uA.restrictions.length) {
        let hA = uA.restrictions.length;
        for (let dA = 0; dA < hA; dA++) {
          let { restriction: GA, message: DA } = uA.restrictions[dA];
          if (!GA(rA, EA))
            return console.error(`${nA} ${sA} invalid value: ${DA}`), !1;
        }
      }
      return uA.restriction && !uA.restriction(rA, EA) ? (console.error(`${nA} ${sA} invalid value: ${uA.message}`), !1) : uA.validValues && uA.validValues.indexOf(rA) === -1 ? (console.error(`${nA} ${sA} invalid value: must be among ${JSON.stringify(uA.validValues)}, "${rA}" provided`), !1) : !(uA.children && !QA(rA, uA.children, `[Validate ${sA}]`));
    });
    return lA || cA.push(...Object.keys(aA).map((sA) => {
      let rA = aA[sA];
      if (typeof rA == "string" && (rA = { type: rA }), rA.mandatory) {
        let uA = rA.mandatory;
        if (typeof uA == "function" && (uA = uA(EA)), uA && EA[sA] === void 0)
          return console.error(`${nA} Missing mandatory key "${sA}"`), !1;
      }
      return !0;
    })), cA.reduce((sA, rA) => sA && rA, !0);
  }
  function tA(EA) {
    return QA(EA, CA, "[Validate format]");
  }
  function oA(EA) {
    return QA(EA, BA, "[Validate language]");
  }
  return validating$1 = {
    validate: eA,
    validateFormat: tA,
    validateInput: iA,
    validateLanguage: oA
  }, validating$1;
}
function parsePrefix(n, t) {
  let g = n.match(/^{([^}]*)}/);
  return g ? (t.prefix = g[1], n.slice(g[0].length)) : n;
}
function parsePostfix(n, t) {
  let g = n.match(/{([^}]*)}$/);
  return g ? (t.postfix = g[1], n.slice(0, -g[0].length)) : n;
}
function parseOutput(n, t) {
  if (n.indexOf("$") !== -1) {
    t.output = "currency";
    return;
  }
  if (n.indexOf("%") !== -1) {
    t.output = "percent";
    return;
  }
  if (n.indexOf("bd") !== -1) {
    t.output = "byte", t.base = "general";
    return;
  }
  if (n.indexOf("b") !== -1) {
    t.output = "byte", t.base = "binary";
    return;
  }
  if (n.indexOf("d") !== -1) {
    t.output = "byte", t.base = "decimal";
    return;
  }
  if (n.indexOf(":") !== -1) {
    t.output = "time";
    return;
  }
  n.indexOf("o") !== -1 && (t.output = "ordinal");
}
function parseThousandSeparated(n, t) {
  n.indexOf(",") !== -1 && (t.thousandSeparated = !0);
}
function parseSpaceSeparated(n, t) {
  n.indexOf(" ") !== -1 && (t.spaceSeparated = !0, t.spaceSeparatedCurrency = !0, (t.average || t.forceAverage) && (t.spaceSeparatedAbbreviation = !0));
}
function parseTotalLength(n, t) {
  let g = n.match(/[1-9]+[0-9]*/);
  g && (t.totalLength = +g[0]);
}
function parseCharacteristic(n, t) {
  let d = n.split(".")[0].match(/0+/);
  d && (t.characteristic = d[0].length);
}
function parseMantissa(n, t) {
  let g = n.split(".")[1];
  if (g) {
    let d = g.match(/0+/);
    d && (t.mantissa = d[0].length);
  }
}
function parseTrimMantissa(n, t) {
  const g = n.split(".")[1];
  g && (t.trimMantissa = g.indexOf("[") !== -1);
}
function parseAverage(n, t) {
  n.indexOf("a") !== -1 && (t.average = !0);
}
function parseForceAverage(n, t) {
  n.indexOf("K") !== -1 ? t.forceAverage = "thousand" : n.indexOf("M") !== -1 ? t.forceAverage = "million" : n.indexOf("B") !== -1 ? t.forceAverage = "billion" : n.indexOf("T") !== -1 && (t.forceAverage = "trillion");
}
function parseOptionalMantissa(n, t) {
  n.match(/\[\.]/) ? t.optionalMantissa = !0 : n.match(/\./) && (t.optionalMantissa = !1);
}
function parseOptionalCharacteristic(n, t) {
  if (n.indexOf(".") !== -1) {
    let g = n.split(".")[0];
    t.optionalCharacteristic = g.indexOf("0") === -1;
  }
}
function parseNegative(n, t) {
  n.match(/^\+?\([^)]*\)$/) && (t.negative = "parenthesis"), n.match(/^\+?-/) && (t.negative = "sign");
}
function parseForceSign(n, t) {
  n.match(/^\+/) && (t.forceSign = !0);
}
function parseFormat(n, t = {}) {
  return typeof n != "string" ? n : (n = parsePrefix(n, t), n = parsePostfix(n, t), parseOutput(n, t), parseTotalLength(n, t), parseCharacteristic(n, t), parseOptionalCharacteristic(n, t), parseAverage(n, t), parseForceAverage(n, t), parseMantissa(n, t), parseOptionalMantissa(n, t), parseTrimMantissa(n, t), parseThousandSeparated(n, t), parseSpaceSeparated(n, t), parseNegative(n, t), parseForceSign(n, t), t);
}
var parsing$2 = {
  parseFormat
};
var globalState$2, hasRequiredGlobalState;
function requireGlobalState() {
  if (hasRequiredGlobalState) return globalState$2;
  hasRequiredGlobalState = 1;
  const n = requireEnUS(), t = requireValidating(), g = parsing$2;
  let d = {}, k, H = {}, AA = null, gA = {};
  function IA(BA) {
    k = BA;
  }
  function CA() {
    return H[k];
  }
  return d.languages = () => Object.assign({}, H), d.currentLanguage = () => k, d.currentBytes = () => CA().bytes || {}, d.currentCurrency = () => CA().currency, d.currentAbbreviations = () => CA().abbreviations, d.currentDelimiters = () => CA().delimiters, d.currentOrdinal = () => CA().ordinal, d.currentDefaults = () => Object.assign({}, CA().defaults, gA), d.currentOrdinalDefaultFormat = () => Object.assign({}, d.currentDefaults(), CA().ordinalFormat), d.currentByteDefaultFormat = () => Object.assign({}, d.currentDefaults(), CA().byteFormat), d.currentPercentageDefaultFormat = () => Object.assign({}, d.currentDefaults(), CA().percentageFormat), d.currentCurrencyDefaultFormat = () => Object.assign({}, d.currentDefaults(), CA().currencyFormat), d.currentTimeDefaultFormat = () => Object.assign({}, d.currentDefaults(), CA().timeFormat), d.setDefaults = (BA) => {
    BA = g.parseFormat(BA), t.validateFormat(BA) && (gA = BA);
  }, d.getZeroFormat = () => AA, d.setZeroFormat = (BA) => AA = typeof BA == "string" ? BA : null, d.hasZeroFormat = () => AA !== null, d.languageData = (BA) => {
    if (BA) {
      if (H[BA])
        return H[BA];
      throw new Error(`Unknown tag "${BA}"`);
    }
    return CA();
  }, d.registerLanguage = (BA, eA = !1) => {
    if (!t.validateLanguage(BA))
      throw new Error("Invalid language data");
    H[BA.languageTag] = BA, eA && IA(BA.languageTag);
  }, d.setLanguage = (BA, eA = n.languageTag) => {
    if (!H[BA]) {
      let iA = BA.split("-")[0], QA = Object.keys(H).find((tA) => tA.split("-")[0] === iA);
      if (!H[QA]) {
        IA(eA);
        return;
      }
      IA(QA);
      return;
    }
    IA(BA);
  }, d.registerLanguage(n), k = n.languageTag, globalState$2 = d, globalState$2;
}
function commonjsRequire(n) {
  throw new Error('Could not dynamically require "' + n + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
function loadLanguagesInNode(n, t) {
  n.forEach((g) => {
    let d;
    try {
      d = commonjsRequire(`../languages/${g}`);
    } catch {
      console.error(`Unable to load "${g}". No matching language file found.`);
    }
    d && t.registerLanguage(d);
  });
}
var loading = (n) => ({
  loadLanguagesInNode: (t) => loadLanguagesInNode(t, n)
}), bignumber = { exports: {} };
(function(n) {
  (function(t) {
    var g, d = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, k = Math.ceil, H = Math.floor, AA = "[BigNumber Error] ", gA = AA + "Number primitive has more than 15 significant digits: ", IA = 1e14, CA = 14, BA = 9007199254740991, eA = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], iA = 1e7, QA = 1e9;
    function tA(rA) {
      var uA, hA, dA, GA = vA.prototype = { constructor: vA, toString: null, valueOf: null }, DA = new vA(1), wA = 20, bA = 4, yA = -7, pA = 21, MA = -1e7, LA = 1e7, xA = !1, TA = 1, NA = 0, zA = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: " ",
        // non-breaking space
        suffix: ""
      }, XA = "0123456789abcdefghijklmnopqrstuvwxyz", fA = !0;
      function vA(kA, YA) {
        var RA, FA, mA, JA, VA, HA, jA, _A, $A = this;
        if (!($A instanceof vA)) return new vA(kA, YA);
        if (YA == null) {
          if (kA && kA._isBigNumber === !0) {
            $A.s = kA.s, !kA.c || kA.e > LA ? $A.c = $A.e = null : kA.e < MA ? $A.c = [$A.e = 0] : ($A.e = kA.e, $A.c = kA.c.slice());
            return;
          }
          if ((HA = typeof kA == "number") && kA * 0 == 0) {
            if ($A.s = 1 / kA < 0 ? (kA = -kA, -1) : 1, kA === ~~kA) {
              for (JA = 0, VA = kA; VA >= 10; VA /= 10, JA++) ;
              JA > LA ? $A.c = $A.e = null : ($A.e = JA, $A.c = [kA]);
              return;
            }
            _A = String(kA);
          } else {
            if (!d.test(_A = String(kA))) return dA($A, _A, HA);
            $A.s = _A.charCodeAt(0) == 45 ? (_A = _A.slice(1), -1) : 1;
          }
          (JA = _A.indexOf(".")) > -1 && (_A = _A.replace(".", "")), (VA = _A.search(/e/i)) > 0 ? (JA < 0 && (JA = VA), JA += +_A.slice(VA + 1), _A = _A.substring(0, VA)) : JA < 0 && (JA = _A.length);
        } else {
          if (nA(YA, 2, XA.length, "Base"), YA == 10 && fA)
            return $A = new vA(kA), og($A, wA + $A.e + 1, bA);
          if (_A = String(kA), HA = typeof kA == "number") {
            if (kA * 0 != 0) return dA($A, _A, HA, YA);
            if ($A.s = 1 / kA < 0 ? (_A = _A.slice(1), -1) : 1, vA.DEBUG && _A.replace(/^0\.0*|\./, "").length > 15)
              throw Error(gA + kA);
          } else
            $A.s = _A.charCodeAt(0) === 45 ? (_A = _A.slice(1), -1) : 1;
          for (RA = XA.slice(0, YA), JA = VA = 0, jA = _A.length; VA < jA; VA++)
            if (RA.indexOf(FA = _A.charAt(VA)) < 0) {
              if (FA == ".") {
                if (VA > JA) {
                  JA = jA;
                  continue;
                }
              } else if (!mA && (_A == _A.toUpperCase() && (_A = _A.toLowerCase()) || _A == _A.toLowerCase() && (_A = _A.toUpperCase()))) {
                mA = !0, VA = -1, JA = 0;
                continue;
              }
              return dA($A, String(kA), HA, YA);
            }
          HA = !1, _A = hA(_A, YA, 10, $A.s), (JA = _A.indexOf(".")) > -1 ? _A = _A.replace(".", "") : JA = _A.length;
        }
        for (VA = 0; _A.charCodeAt(VA) === 48; VA++) ;
        for (jA = _A.length; _A.charCodeAt(--jA) === 48; ) ;
        if (_A = _A.slice(VA, ++jA)) {
          if (jA -= VA, HA && vA.DEBUG && jA > 15 && (kA > BA || kA !== H(kA)))
            throw Error(gA + $A.s * kA);
          if ((JA = JA - VA - 1) > LA)
            $A.c = $A.e = null;
          else if (JA < MA)
            $A.c = [$A.e = 0];
          else {
            if ($A.e = JA, $A.c = [], VA = (JA + 1) % CA, JA < 0 && (VA += CA), VA < jA) {
              for (VA && $A.c.push(+_A.slice(0, VA)), jA -= CA; VA < jA; )
                $A.c.push(+_A.slice(VA, VA += CA));
              VA = CA - (_A = _A.slice(VA)).length;
            } else
              VA -= jA;
            for (; VA--; _A += "0") ;
            $A.c.push(+_A);
          }
        } else
          $A.c = [$A.e = 0];
      }
      vA.clone = tA, vA.ROUND_UP = 0, vA.ROUND_DOWN = 1, vA.ROUND_CEIL = 2, vA.ROUND_FLOOR = 3, vA.ROUND_HALF_UP = 4, vA.ROUND_HALF_DOWN = 5, vA.ROUND_HALF_EVEN = 6, vA.ROUND_HALF_CEIL = 7, vA.ROUND_HALF_FLOOR = 8, vA.EUCLID = 9, vA.config = vA.set = function(kA) {
        var YA, RA;
        if (kA != null)
          if (typeof kA == "object") {
            if (kA.hasOwnProperty(YA = "DECIMAL_PLACES") && (RA = kA[YA], nA(RA, 0, QA, YA), wA = RA), kA.hasOwnProperty(YA = "ROUNDING_MODE") && (RA = kA[YA], nA(RA, 0, 8, YA), bA = RA), kA.hasOwnProperty(YA = "EXPONENTIAL_AT") && (RA = kA[YA], RA && RA.pop ? (nA(RA[0], -QA, 0, YA), nA(RA[1], 0, QA, YA), yA = RA[0], pA = RA[1]) : (nA(RA, -QA, QA, YA), yA = -(pA = RA < 0 ? -RA : RA))), kA.hasOwnProperty(YA = "RANGE"))
              if (RA = kA[YA], RA && RA.pop)
                nA(RA[0], -QA, -1, YA), nA(RA[1], 1, QA, YA), MA = RA[0], LA = RA[1];
              else if (nA(RA, -QA, QA, YA), RA)
                MA = -(LA = RA < 0 ? -RA : RA);
              else
                throw Error(AA + YA + " cannot be zero: " + RA);
            if (kA.hasOwnProperty(YA = "CRYPTO"))
              if (RA = kA[YA], RA === !!RA)
                if (RA)
                  if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                    xA = RA;
                  else
                    throw xA = !RA, Error(AA + "crypto unavailable");
                else
                  xA = RA;
              else
                throw Error(AA + YA + " not true or false: " + RA);
            if (kA.hasOwnProperty(YA = "MODULO_MODE") && (RA = kA[YA], nA(RA, 0, 9, YA), TA = RA), kA.hasOwnProperty(YA = "POW_PRECISION") && (RA = kA[YA], nA(RA, 0, QA, YA), NA = RA), kA.hasOwnProperty(YA = "FORMAT"))
              if (RA = kA[YA], typeof RA == "object") zA = RA;
              else throw Error(AA + YA + " not an object: " + RA);
            if (kA.hasOwnProperty(YA = "ALPHABET"))
              if (RA = kA[YA], typeof RA == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(RA))
                fA = RA.slice(0, 10) == "0123456789", XA = RA;
              else
                throw Error(AA + YA + " invalid: " + RA);
          } else
            throw Error(AA + "Object expected: " + kA);
        return {
          DECIMAL_PLACES: wA,
          ROUNDING_MODE: bA,
          EXPONENTIAL_AT: [yA, pA],
          RANGE: [MA, LA],
          CRYPTO: xA,
          MODULO_MODE: TA,
          POW_PRECISION: NA,
          FORMAT: zA,
          ALPHABET: XA
        };
      }, vA.isBigNumber = function(kA) {
        if (!kA || kA._isBigNumber !== !0) return !1;
        if (!vA.DEBUG) return !0;
        var YA, RA, FA = kA.c, mA = kA.e, JA = kA.s;
        A: if ({}.toString.call(FA) == "[object Array]") {
          if ((JA === 1 || JA === -1) && mA >= -QA && mA <= QA && mA === H(mA)) {
            if (FA[0] === 0) {
              if (mA === 0 && FA.length === 1) return !0;
              break A;
            }
            if (YA = (mA + 1) % CA, YA < 1 && (YA += CA), String(FA[0]).length == YA) {
              for (YA = 0; YA < FA.length; YA++)
                if (RA = FA[YA], RA < 0 || RA >= IA || RA !== H(RA)) break A;
              if (RA !== 0) return !0;
            }
          }
        } else if (FA === null && mA === null && (JA === null || JA === 1 || JA === -1))
          return !0;
        throw Error(AA + "Invalid BigNumber: " + kA);
      }, vA.maximum = vA.max = function() {
        return Ig(arguments, -1);
      }, vA.minimum = vA.min = function() {
        return Ig(arguments, 1);
      }, vA.random = (function() {
        var kA = 9007199254740992, YA = Math.random() * kA & 2097151 ? function() {
          return H(Math.random() * kA);
        } : function() {
          return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
        };
        return function(RA) {
          var FA, mA, JA, VA, HA, jA = 0, _A = [], $A = new vA(DA);
          if (RA == null ? RA = wA : nA(RA, 0, QA), VA = k(RA / CA), xA)
            if (crypto.getRandomValues) {
              for (FA = crypto.getRandomValues(new Uint32Array(VA *= 2)); jA < VA; )
                HA = FA[jA] * 131072 + (FA[jA + 1] >>> 11), HA >= 9e15 ? (mA = crypto.getRandomValues(new Uint32Array(2)), FA[jA] = mA[0], FA[jA + 1] = mA[1]) : (_A.push(HA % 1e14), jA += 2);
              jA = VA / 2;
            } else if (crypto.randomBytes) {
              for (FA = crypto.randomBytes(VA *= 7); jA < VA; )
                HA = (FA[jA] & 31) * 281474976710656 + FA[jA + 1] * 1099511627776 + FA[jA + 2] * 4294967296 + FA[jA + 3] * 16777216 + (FA[jA + 4] << 16) + (FA[jA + 5] << 8) + FA[jA + 6], HA >= 9e15 ? crypto.randomBytes(7).copy(FA, jA) : (_A.push(HA % 1e14), jA += 7);
              jA = VA / 7;
            } else
              throw xA = !1, Error(AA + "crypto unavailable");
          if (!xA)
            for (; jA < VA; )
              HA = YA(), HA < 9e15 && (_A[jA++] = HA % 1e14);
          for (VA = _A[--jA], RA %= CA, VA && RA && (HA = eA[CA - RA], _A[jA] = H(VA / HA) * HA); _A[jA] === 0; _A.pop(), jA--) ;
          if (jA < 0)
            _A = [JA = 0];
          else {
            for (JA = -1; _A[0] === 0; _A.splice(0, 1), JA -= CA) ;
            for (jA = 1, HA = _A[0]; HA >= 10; HA /= 10, jA++) ;
            jA < CA && (JA -= CA - jA);
          }
          return $A.e = JA, $A.c = _A, $A;
        };
      })(), vA.sum = function() {
        for (var kA = 1, YA = arguments, RA = new vA(YA[0]); kA < YA.length; ) RA = RA.plus(YA[kA++]);
        return RA;
      }, hA = /* @__PURE__ */ (function() {
        var kA = "0123456789";
        function YA(RA, FA, mA, JA) {
          for (var VA, HA = [0], jA, _A = 0, $A = RA.length; _A < $A; ) {
            for (jA = HA.length; jA--; HA[jA] *= FA) ;
            for (HA[0] += JA.indexOf(RA.charAt(_A++)), VA = 0; VA < HA.length; VA++)
              HA[VA] > mA - 1 && (HA[VA + 1] == null && (HA[VA + 1] = 0), HA[VA + 1] += HA[VA] / mA | 0, HA[VA] %= mA);
          }
          return HA.reverse();
        }
        return function(RA, FA, mA, JA, VA) {
          var HA, jA, _A, $A, rg, wg, Dg, kg, ig = RA.indexOf("."), ZA = wA, KA = bA;
          for (ig >= 0 && ($A = NA, NA = 0, RA = RA.replace(".", ""), kg = new vA(FA), wg = kg.pow(RA.length - ig), NA = $A, kg.c = YA(
            sA(EA(wg.c), wg.e, "0"),
            10,
            mA,
            kA
          ), kg.e = kg.c.length), Dg = YA(RA, FA, mA, VA ? (HA = XA, kA) : (HA = kA, XA)), _A = $A = Dg.length; Dg[--$A] == 0; Dg.pop()) ;
          if (!Dg[0]) return HA.charAt(0);
          if (ig < 0 ? --_A : (wg.c = Dg, wg.e = _A, wg.s = JA, wg = uA(wg, kg, ZA, KA, mA), Dg = wg.c, rg = wg.r, _A = wg.e), jA = _A + ZA + 1, ig = Dg[jA], $A = mA / 2, rg = rg || jA < 0 || Dg[jA + 1] != null, rg = KA < 4 ? (ig != null || rg) && (KA == 0 || KA == (wg.s < 0 ? 3 : 2)) : ig > $A || ig == $A && (KA == 4 || rg || KA == 6 && Dg[jA - 1] & 1 || KA == (wg.s < 0 ? 8 : 7)), jA < 1 || !Dg[0])
            RA = rg ? sA(HA.charAt(1), -ZA, HA.charAt(0)) : HA.charAt(0);
          else {
            if (Dg.length = jA, rg)
              for (--mA; ++Dg[--jA] > mA; )
                Dg[jA] = 0, jA || (++_A, Dg = [1].concat(Dg));
            for ($A = Dg.length; !Dg[--$A]; ) ;
            for (ig = 0, RA = ""; ig <= $A; RA += HA.charAt(Dg[ig++])) ;
            RA = sA(RA, _A, HA.charAt(0));
          }
          return RA;
        };
      })(), uA = /* @__PURE__ */ (function() {
        function kA(FA, mA, JA) {
          var VA, HA, jA, _A, $A = 0, rg = FA.length, wg = mA % iA, Dg = mA / iA | 0;
          for (FA = FA.slice(); rg--; )
            jA = FA[rg] % iA, _A = FA[rg] / iA | 0, VA = Dg * jA + _A * wg, HA = wg * jA + VA % iA * iA + $A, $A = (HA / JA | 0) + (VA / iA | 0) + Dg * _A, FA[rg] = HA % JA;
          return $A && (FA = [$A].concat(FA)), FA;
        }
        function YA(FA, mA, JA, VA) {
          var HA, jA;
          if (JA != VA)
            jA = JA > VA ? 1 : -1;
          else
            for (HA = jA = 0; HA < JA; HA++)
              if (FA[HA] != mA[HA]) {
                jA = FA[HA] > mA[HA] ? 1 : -1;
                break;
              }
          return jA;
        }
        function RA(FA, mA, JA, VA) {
          for (var HA = 0; JA--; )
            FA[JA] -= HA, HA = FA[JA] < mA[JA] ? 1 : 0, FA[JA] = HA * VA + FA[JA] - mA[JA];
          for (; !FA[0] && FA.length > 1; FA.splice(0, 1)) ;
        }
        return function(FA, mA, JA, VA, HA) {
          var jA, _A, $A, rg, wg, Dg, kg, ig, ZA, KA, PA, ag, Gg, bg, yg, hg, tg, Eg = FA.s == mA.s ? 1 : -1, cg = FA.c, sg = mA.c;
          if (!cg || !cg[0] || !sg || !sg[0])
            return new vA(
              // Return NaN if either NaN, or both Infinity or 0.
              !FA.s || !mA.s || (cg ? sg && cg[0] == sg[0] : !sg) ? NaN : (
                // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                cg && cg[0] == 0 || !sg ? Eg * 0 : Eg / 0
              )
            );
          for (ig = new vA(Eg), ZA = ig.c = [], _A = FA.e - mA.e, Eg = JA + _A + 1, HA || (HA = IA, _A = oA(FA.e / CA) - oA(mA.e / CA), Eg = Eg / CA | 0), $A = 0; sg[$A] == (cg[$A] || 0); $A++) ;
          if (sg[$A] > (cg[$A] || 0) && _A--, Eg < 0)
            ZA.push(1), rg = !0;
          else {
            for (bg = cg.length, hg = sg.length, $A = 0, Eg += 2, wg = H(HA / (sg[0] + 1)), wg > 1 && (sg = kA(sg, wg, HA), cg = kA(cg, wg, HA), hg = sg.length, bg = cg.length), Gg = hg, KA = cg.slice(0, hg), PA = KA.length; PA < hg; KA[PA++] = 0) ;
            tg = sg.slice(), tg = [0].concat(tg), yg = sg[0], sg[1] >= HA / 2 && yg++;
            do {
              if (wg = 0, jA = YA(sg, KA, hg, PA), jA < 0) {
                if (ag = KA[0], hg != PA && (ag = ag * HA + (KA[1] || 0)), wg = H(ag / yg), wg > 1)
                  for (wg >= HA && (wg = HA - 1), Dg = kA(sg, wg, HA), kg = Dg.length, PA = KA.length; YA(Dg, KA, kg, PA) == 1; )
                    wg--, RA(Dg, hg < kg ? tg : sg, kg, HA), kg = Dg.length, jA = 1;
                else
                  wg == 0 && (jA = wg = 1), Dg = sg.slice(), kg = Dg.length;
                if (kg < PA && (Dg = [0].concat(Dg)), RA(KA, Dg, PA, HA), PA = KA.length, jA == -1)
                  for (; YA(sg, KA, hg, PA) < 1; )
                    wg++, RA(KA, hg < PA ? tg : sg, PA, HA), PA = KA.length;
              } else jA === 0 && (wg++, KA = [0]);
              ZA[$A++] = wg, KA[0] ? KA[PA++] = cg[Gg] || 0 : (KA = [cg[Gg]], PA = 1);
            } while ((Gg++ < bg || KA[0] != null) && Eg--);
            rg = KA[0] != null, ZA[0] || ZA.splice(0, 1);
          }
          if (HA == IA) {
            for ($A = 1, Eg = ZA[0]; Eg >= 10; Eg /= 10, $A++) ;
            og(ig, JA + (ig.e = $A + _A * CA - 1) + 1, VA, rg);
          } else
            ig.e = _A, ig.r = +rg;
          return ig;
        };
      })();
      function Cg(kA, YA, RA, FA) {
        var mA, JA, VA, HA, jA;
        if (RA == null ? RA = bA : nA(RA, 0, 8), !kA.c) return kA.toString();
        if (mA = kA.c[0], VA = kA.e, YA == null)
          jA = EA(kA.c), jA = FA == 1 || FA == 2 && (VA <= yA || VA >= pA) ? cA(jA, VA) : sA(jA, VA, "0");
        else if (kA = og(new vA(kA), YA, RA), JA = kA.e, jA = EA(kA.c), HA = jA.length, FA == 1 || FA == 2 && (YA <= JA || JA <= yA)) {
          for (; HA < YA; jA += "0", HA++) ;
          jA = cA(jA, JA);
        } else if (YA -= VA, jA = sA(jA, JA, "0"), JA + 1 > HA) {
          if (--YA > 0) for (jA += "."; YA--; jA += "0") ;
        } else if (YA += JA - HA, YA > 0)
          for (JA + 1 == HA && (jA += "."); YA--; jA += "0") ;
        return kA.s < 0 && mA ? "-" + jA : jA;
      }
      function Ig(kA, YA) {
        for (var RA, FA, mA = 1, JA = new vA(kA[0]); mA < kA.length; mA++)
          FA = new vA(kA[mA]), (!FA.s || (RA = aA(JA, FA)) === YA || RA === 0 && JA.s === YA) && (JA = FA);
        return JA;
      }
      function gg(kA, YA, RA) {
        for (var FA = 1, mA = YA.length; !YA[--mA]; YA.pop()) ;
        for (mA = YA[0]; mA >= 10; mA /= 10, FA++) ;
        return (RA = FA + RA * CA - 1) > LA ? kA.c = kA.e = null : RA < MA ? kA.c = [kA.e = 0] : (kA.e = RA, kA.c = YA), kA;
      }
      dA = /* @__PURE__ */ (function() {
        var kA = /^(-?)0([xbo])(?=\w[\w.]*$)/i, YA = /^([^.]+)\.$/, RA = /^\.([^.]+)$/, FA = /^-?(Infinity|NaN)$/, mA = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(JA, VA, HA, jA) {
          var _A, $A = HA ? VA : VA.replace(mA, "");
          if (FA.test($A))
            JA.s = isNaN($A) ? null : $A < 0 ? -1 : 1;
          else {
            if (!HA && ($A = $A.replace(kA, function(rg, wg, Dg) {
              return _A = (Dg = Dg.toLowerCase()) == "x" ? 16 : Dg == "b" ? 2 : 8, !jA || jA == _A ? wg : rg;
            }), jA && (_A = jA, $A = $A.replace(YA, "$1").replace(RA, "0.$1")), VA != $A))
              return new vA($A, _A);
            if (vA.DEBUG)
              throw Error(AA + "Not a" + (jA ? " base " + jA : "") + " number: " + VA);
            JA.s = null;
          }
          JA.c = JA.e = null;
        };
      })();
      function og(kA, YA, RA, FA) {
        var mA, JA, VA, HA, jA, _A, $A, rg = kA.c, wg = eA;
        if (rg) {
          A: {
            for (mA = 1, HA = rg[0]; HA >= 10; HA /= 10, mA++) ;
            if (JA = YA - mA, JA < 0)
              JA += CA, VA = YA, jA = rg[_A = 0], $A = H(jA / wg[mA - VA - 1] % 10);
            else if (_A = k((JA + 1) / CA), _A >= rg.length)
              if (FA) {
                for (; rg.length <= _A; rg.push(0)) ;
                jA = $A = 0, mA = 1, JA %= CA, VA = JA - CA + 1;
              } else
                break A;
            else {
              for (jA = HA = rg[_A], mA = 1; HA >= 10; HA /= 10, mA++) ;
              JA %= CA, VA = JA - CA + mA, $A = VA < 0 ? 0 : H(jA / wg[mA - VA - 1] % 10);
            }
            if (FA = FA || YA < 0 || // Are there any non-zero digits after the rounding digit?
            // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
            // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
            rg[_A + 1] != null || (VA < 0 ? jA : jA % wg[mA - VA - 1]), FA = RA < 4 ? ($A || FA) && (RA == 0 || RA == (kA.s < 0 ? 3 : 2)) : $A > 5 || $A == 5 && (RA == 4 || FA || RA == 6 && // Check whether the digit to the left of the rounding digit is odd.
            (JA > 0 ? VA > 0 ? jA / wg[mA - VA] : 0 : rg[_A - 1]) % 10 & 1 || RA == (kA.s < 0 ? 8 : 7)), YA < 1 || !rg[0])
              return rg.length = 0, FA ? (YA -= kA.e + 1, rg[0] = wg[(CA - YA % CA) % CA], kA.e = -YA || 0) : rg[0] = kA.e = 0, kA;
            if (JA == 0 ? (rg.length = _A, HA = 1, _A--) : (rg.length = _A + 1, HA = wg[CA - JA], rg[_A] = VA > 0 ? H(jA / wg[mA - VA] % wg[VA]) * HA : 0), FA)
              for (; ; )
                if (_A == 0) {
                  for (JA = 1, VA = rg[0]; VA >= 10; VA /= 10, JA++) ;
                  for (VA = rg[0] += HA, HA = 1; VA >= 10; VA /= 10, HA++) ;
                  JA != HA && (kA.e++, rg[0] == IA && (rg[0] = 1));
                  break;
                } else {
                  if (rg[_A] += HA, rg[_A] != IA) break;
                  rg[_A--] = 0, HA = 1;
                }
            for (JA = rg.length; rg[--JA] === 0; rg.pop()) ;
          }
          kA.e > LA ? kA.c = kA.e = null : kA.e < MA && (kA.c = [kA.e = 0]);
        }
        return kA;
      }
      function eg(kA) {
        var YA, RA = kA.e;
        return RA === null ? kA.toString() : (YA = EA(kA.c), YA = RA <= yA || RA >= pA ? cA(YA, RA) : sA(YA, RA, "0"), kA.s < 0 ? "-" + YA : YA);
      }
      return GA.absoluteValue = GA.abs = function() {
        var kA = new vA(this);
        return kA.s < 0 && (kA.s = 1), kA;
      }, GA.comparedTo = function(kA, YA) {
        return aA(this, new vA(kA, YA));
      }, GA.decimalPlaces = GA.dp = function(kA, YA) {
        var RA, FA, mA, JA = this;
        if (kA != null)
          return nA(kA, 0, QA), YA == null ? YA = bA : nA(YA, 0, 8), og(new vA(JA), kA + JA.e + 1, YA);
        if (!(RA = JA.c)) return null;
        if (FA = ((mA = RA.length - 1) - oA(this.e / CA)) * CA, mA = RA[mA]) for (; mA % 10 == 0; mA /= 10, FA--) ;
        return FA < 0 && (FA = 0), FA;
      }, GA.dividedBy = GA.div = function(kA, YA) {
        return uA(this, new vA(kA, YA), wA, bA);
      }, GA.dividedToIntegerBy = GA.idiv = function(kA, YA) {
        return uA(this, new vA(kA, YA), 0, 1);
      }, GA.exponentiatedBy = GA.pow = function(kA, YA) {
        var RA, FA, mA, JA, VA, HA, jA, _A, $A, rg = this;
        if (kA = new vA(kA), kA.c && !kA.isInteger())
          throw Error(AA + "Exponent not an integer: " + eg(kA));
        if (YA != null && (YA = new vA(YA)), HA = kA.e > 14, !rg.c || !rg.c[0] || rg.c[0] == 1 && !rg.e && rg.c.length == 1 || !kA.c || !kA.c[0])
          return $A = new vA(Math.pow(+eg(rg), HA ? kA.s * (2 - lA(kA)) : +eg(kA))), YA ? $A.mod(YA) : $A;
        if (jA = kA.s < 0, YA) {
          if (YA.c ? !YA.c[0] : !YA.s) return new vA(NaN);
          FA = !jA && rg.isInteger() && YA.isInteger(), FA && (rg = rg.mod(YA));
        } else {
          if (kA.e > 9 && (rg.e > 0 || rg.e < -1 || (rg.e == 0 ? rg.c[0] > 1 || HA && rg.c[1] >= 24e7 : rg.c[0] < 8e13 || HA && rg.c[0] <= 9999975e7)))
            return JA = rg.s < 0 && lA(kA) ? -0 : 0, rg.e > -1 && (JA = 1 / JA), new vA(jA ? 1 / JA : JA);
          NA && (JA = k(NA / CA + 2));
        }
        for (HA ? (RA = new vA(0.5), jA && (kA.s = 1), _A = lA(kA)) : (mA = Math.abs(+eg(kA)), _A = mA % 2), $A = new vA(DA); ; ) {
          if (_A) {
            if ($A = $A.times(rg), !$A.c) break;
            JA ? $A.c.length > JA && ($A.c.length = JA) : FA && ($A = $A.mod(YA));
          }
          if (mA) {
            if (mA = H(mA / 2), mA === 0) break;
            _A = mA % 2;
          } else if (kA = kA.times(RA), og(kA, kA.e + 1, 1), kA.e > 14)
            _A = lA(kA);
          else {
            if (mA = +eg(kA), mA === 0) break;
            _A = mA % 2;
          }
          rg = rg.times(rg), JA ? rg.c && rg.c.length > JA && (rg.c.length = JA) : FA && (rg = rg.mod(YA));
        }
        return FA ? $A : (jA && ($A = DA.div($A)), YA ? $A.mod(YA) : JA ? og($A, NA, bA, VA) : $A);
      }, GA.integerValue = function(kA) {
        var YA = new vA(this);
        return kA == null ? kA = bA : nA(kA, 0, 8), og(YA, YA.e + 1, kA);
      }, GA.isEqualTo = GA.eq = function(kA, YA) {
        return aA(this, new vA(kA, YA)) === 0;
      }, GA.isFinite = function() {
        return !!this.c;
      }, GA.isGreaterThan = GA.gt = function(kA, YA) {
        return aA(this, new vA(kA, YA)) > 0;
      }, GA.isGreaterThanOrEqualTo = GA.gte = function(kA, YA) {
        return (YA = aA(this, new vA(kA, YA))) === 1 || YA === 0;
      }, GA.isInteger = function() {
        return !!this.c && oA(this.e / CA) > this.c.length - 2;
      }, GA.isLessThan = GA.lt = function(kA, YA) {
        return aA(this, new vA(kA, YA)) < 0;
      }, GA.isLessThanOrEqualTo = GA.lte = function(kA, YA) {
        return (YA = aA(this, new vA(kA, YA))) === -1 || YA === 0;
      }, GA.isNaN = function() {
        return !this.s;
      }, GA.isNegative = function() {
        return this.s < 0;
      }, GA.isPositive = function() {
        return this.s > 0;
      }, GA.isZero = function() {
        return !!this.c && this.c[0] == 0;
      }, GA.minus = function(kA, YA) {
        var RA, FA, mA, JA, VA = this, HA = VA.s;
        if (kA = new vA(kA, YA), YA = kA.s, !HA || !YA) return new vA(NaN);
        if (HA != YA)
          return kA.s = -YA, VA.plus(kA);
        var jA = VA.e / CA, _A = kA.e / CA, $A = VA.c, rg = kA.c;
        if (!jA || !_A) {
          if (!$A || !rg) return $A ? (kA.s = -YA, kA) : new vA(rg ? VA : NaN);
          if (!$A[0] || !rg[0])
            return rg[0] ? (kA.s = -YA, kA) : new vA($A[0] ? VA : (
              // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
              bA == 3 ? -0 : 0
            ));
        }
        if (jA = oA(jA), _A = oA(_A), $A = $A.slice(), HA = jA - _A) {
          for ((JA = HA < 0) ? (HA = -HA, mA = $A) : (_A = jA, mA = rg), mA.reverse(), YA = HA; YA--; mA.push(0)) ;
          mA.reverse();
        } else
          for (FA = (JA = (HA = $A.length) < (YA = rg.length)) ? HA : YA, HA = YA = 0; YA < FA; YA++)
            if ($A[YA] != rg[YA]) {
              JA = $A[YA] < rg[YA];
              break;
            }
        if (JA && (mA = $A, $A = rg, rg = mA, kA.s = -kA.s), YA = (FA = rg.length) - (RA = $A.length), YA > 0) for (; YA--; $A[RA++] = 0) ;
        for (YA = IA - 1; FA > HA; ) {
          if ($A[--FA] < rg[FA]) {
            for (RA = FA; RA && !$A[--RA]; $A[RA] = YA) ;
            --$A[RA], $A[FA] += IA;
          }
          $A[FA] -= rg[FA];
        }
        for (; $A[0] == 0; $A.splice(0, 1), --_A) ;
        return $A[0] ? gg(kA, $A, _A) : (kA.s = bA == 3 ? -1 : 1, kA.c = [kA.e = 0], kA);
      }, GA.modulo = GA.mod = function(kA, YA) {
        var RA, FA, mA = this;
        return kA = new vA(kA, YA), !mA.c || !kA.s || kA.c && !kA.c[0] ? new vA(NaN) : !kA.c || mA.c && !mA.c[0] ? new vA(mA) : (TA == 9 ? (FA = kA.s, kA.s = 1, RA = uA(mA, kA, 0, 3), kA.s = FA, RA.s *= FA) : RA = uA(mA, kA, 0, TA), kA = mA.minus(RA.times(kA)), !kA.c[0] && TA == 1 && (kA.s = mA.s), kA);
      }, GA.multipliedBy = GA.times = function(kA, YA) {
        var RA, FA, mA, JA, VA, HA, jA, _A, $A, rg, wg, Dg, kg, ig, ZA, KA = this, PA = KA.c, ag = (kA = new vA(kA, YA)).c;
        if (!PA || !ag || !PA[0] || !ag[0])
          return !KA.s || !kA.s || PA && !PA[0] && !ag || ag && !ag[0] && !PA ? kA.c = kA.e = kA.s = null : (kA.s *= KA.s, !PA || !ag ? kA.c = kA.e = null : (kA.c = [0], kA.e = 0)), kA;
        for (FA = oA(KA.e / CA) + oA(kA.e / CA), kA.s *= KA.s, jA = PA.length, rg = ag.length, jA < rg && (kg = PA, PA = ag, ag = kg, mA = jA, jA = rg, rg = mA), mA = jA + rg, kg = []; mA--; kg.push(0)) ;
        for (ig = IA, ZA = iA, mA = rg; --mA >= 0; ) {
          for (RA = 0, wg = ag[mA] % ZA, Dg = ag[mA] / ZA | 0, VA = jA, JA = mA + VA; JA > mA; )
            _A = PA[--VA] % ZA, $A = PA[VA] / ZA | 0, HA = Dg * _A + $A * wg, _A = wg * _A + HA % ZA * ZA + kg[JA] + RA, RA = (_A / ig | 0) + (HA / ZA | 0) + Dg * $A, kg[JA--] = _A % ig;
          kg[JA] = RA;
        }
        return RA ? ++FA : kg.splice(0, 1), gg(kA, kg, FA);
      }, GA.negated = function() {
        var kA = new vA(this);
        return kA.s = -kA.s || null, kA;
      }, GA.plus = function(kA, YA) {
        var RA, FA = this, mA = FA.s;
        if (kA = new vA(kA, YA), YA = kA.s, !mA || !YA) return new vA(NaN);
        if (mA != YA)
          return kA.s = -YA, FA.minus(kA);
        var JA = FA.e / CA, VA = kA.e / CA, HA = FA.c, jA = kA.c;
        if (!JA || !VA) {
          if (!HA || !jA) return new vA(mA / 0);
          if (!HA[0] || !jA[0]) return jA[0] ? kA : new vA(HA[0] ? FA : mA * 0);
        }
        if (JA = oA(JA), VA = oA(VA), HA = HA.slice(), mA = JA - VA) {
          for (mA > 0 ? (VA = JA, RA = jA) : (mA = -mA, RA = HA), RA.reverse(); mA--; RA.push(0)) ;
          RA.reverse();
        }
        for (mA = HA.length, YA = jA.length, mA - YA < 0 && (RA = jA, jA = HA, HA = RA, YA = mA), mA = 0; YA; )
          mA = (HA[--YA] = HA[YA] + jA[YA] + mA) / IA | 0, HA[YA] = IA === HA[YA] ? 0 : HA[YA] % IA;
        return mA && (HA = [mA].concat(HA), ++VA), gg(kA, HA, VA);
      }, GA.precision = GA.sd = function(kA, YA) {
        var RA, FA, mA, JA = this;
        if (kA != null && kA !== !!kA)
          return nA(kA, 1, QA), YA == null ? YA = bA : nA(YA, 0, 8), og(new vA(JA), kA, YA);
        if (!(RA = JA.c)) return null;
        if (mA = RA.length - 1, FA = mA * CA + 1, mA = RA[mA]) {
          for (; mA % 10 == 0; mA /= 10, FA--) ;
          for (mA = RA[0]; mA >= 10; mA /= 10, FA++) ;
        }
        return kA && JA.e + 1 > FA && (FA = JA.e + 1), FA;
      }, GA.shiftedBy = function(kA) {
        return nA(kA, -BA, BA), this.times("1e" + kA);
      }, GA.squareRoot = GA.sqrt = function() {
        var kA, YA, RA, FA, mA, JA = this, VA = JA.c, HA = JA.s, jA = JA.e, _A = wA + 4, $A = new vA("0.5");
        if (HA !== 1 || !VA || !VA[0])
          return new vA(!HA || HA < 0 && (!VA || VA[0]) ? NaN : VA ? JA : 1 / 0);
        if (HA = Math.sqrt(+eg(JA)), HA == 0 || HA == 1 / 0 ? (YA = EA(VA), (YA.length + jA) % 2 == 0 && (YA += "0"), HA = Math.sqrt(+YA), jA = oA((jA + 1) / 2) - (jA < 0 || jA % 2), HA == 1 / 0 ? YA = "5e" + jA : (YA = HA.toExponential(), YA = YA.slice(0, YA.indexOf("e") + 1) + jA), RA = new vA(YA)) : RA = new vA(HA + ""), RA.c[0]) {
          for (jA = RA.e, HA = jA + _A, HA < 3 && (HA = 0); ; )
            if (mA = RA, RA = $A.times(mA.plus(uA(JA, mA, _A, 1))), EA(mA.c).slice(0, HA) === (YA = EA(RA.c)).slice(0, HA))
              if (RA.e < jA && --HA, YA = YA.slice(HA - 3, HA + 1), YA == "9999" || !FA && YA == "4999") {
                if (!FA && (og(mA, mA.e + wA + 2, 0), mA.times(mA).eq(JA))) {
                  RA = mA;
                  break;
                }
                _A += 4, HA += 4, FA = 1;
              } else {
                (!+YA || !+YA.slice(1) && YA.charAt(0) == "5") && (og(RA, RA.e + wA + 2, 1), kA = !RA.times(RA).eq(JA));
                break;
              }
        }
        return og(RA, RA.e + wA + 1, bA, kA);
      }, GA.toExponential = function(kA, YA) {
        return kA != null && (nA(kA, 0, QA), kA++), Cg(this, kA, YA, 1);
      }, GA.toFixed = function(kA, YA) {
        return kA != null && (nA(kA, 0, QA), kA = kA + this.e + 1), Cg(this, kA, YA);
      }, GA.toFormat = function(kA, YA, RA) {
        var FA, mA = this;
        if (RA == null)
          kA != null && YA && typeof YA == "object" ? (RA = YA, YA = null) : kA && typeof kA == "object" ? (RA = kA, kA = YA = null) : RA = zA;
        else if (typeof RA != "object")
          throw Error(AA + "Argument not an object: " + RA);
        if (FA = mA.toFixed(kA, YA), mA.c) {
          var JA, VA = FA.split("."), HA = +RA.groupSize, jA = +RA.secondaryGroupSize, _A = RA.groupSeparator || "", $A = VA[0], rg = VA[1], wg = mA.s < 0, Dg = wg ? $A.slice(1) : $A, kg = Dg.length;
          if (jA && (JA = HA, HA = jA, jA = JA, kg -= JA), HA > 0 && kg > 0) {
            for (JA = kg % HA || HA, $A = Dg.substr(0, JA); JA < kg; JA += HA) $A += _A + Dg.substr(JA, HA);
            jA > 0 && ($A += _A + Dg.slice(JA)), wg && ($A = "-" + $A);
          }
          FA = rg ? $A + (RA.decimalSeparator || "") + ((jA = +RA.fractionGroupSize) ? rg.replace(
            new RegExp("\\d{" + jA + "}\\B", "g"),
            "$&" + (RA.fractionGroupSeparator || "")
          ) : rg) : $A;
        }
        return (RA.prefix || "") + FA + (RA.suffix || "");
      }, GA.toFraction = function(kA) {
        var YA, RA, FA, mA, JA, VA, HA, jA, _A, $A, rg, wg, Dg = this, kg = Dg.c;
        if (kA != null && (HA = new vA(kA), !HA.isInteger() && (HA.c || HA.s !== 1) || HA.lt(DA)))
          throw Error(AA + "Argument " + (HA.isInteger() ? "out of range: " : "not an integer: ") + eg(HA));
        if (!kg) return new vA(Dg);
        for (YA = new vA(DA), _A = RA = new vA(DA), FA = jA = new vA(DA), wg = EA(kg), JA = YA.e = wg.length - Dg.e - 1, YA.c[0] = eA[(VA = JA % CA) < 0 ? CA + VA : VA], kA = !kA || HA.comparedTo(YA) > 0 ? JA > 0 ? YA : _A : HA, VA = LA, LA = 1 / 0, HA = new vA(wg), jA.c[0] = 0; $A = uA(HA, YA, 0, 1), mA = RA.plus($A.times(FA)), mA.comparedTo(kA) != 1; )
          RA = FA, FA = mA, _A = jA.plus($A.times(mA = _A)), jA = mA, YA = HA.minus($A.times(mA = YA)), HA = mA;
        return mA = uA(kA.minus(RA), FA, 0, 1), jA = jA.plus(mA.times(_A)), RA = RA.plus(mA.times(FA)), jA.s = _A.s = Dg.s, JA = JA * 2, rg = uA(_A, FA, JA, bA).minus(Dg).abs().comparedTo(
          uA(jA, RA, JA, bA).minus(Dg).abs()
        ) < 1 ? [_A, FA] : [jA, RA], LA = VA, rg;
      }, GA.toNumber = function() {
        return +eg(this);
      }, GA.toPrecision = function(kA, YA) {
        return kA != null && nA(kA, 1, QA), Cg(this, kA, YA, 2);
      }, GA.toString = function(kA) {
        var YA, RA = this, FA = RA.s, mA = RA.e;
        return mA === null ? FA ? (YA = "Infinity", FA < 0 && (YA = "-" + YA)) : YA = "NaN" : (kA == null ? YA = mA <= yA || mA >= pA ? cA(EA(RA.c), mA) : sA(EA(RA.c), mA, "0") : kA === 10 && fA ? (RA = og(new vA(RA), wA + mA + 1, bA), YA = sA(EA(RA.c), RA.e, "0")) : (nA(kA, 2, XA.length, "Base"), YA = hA(sA(EA(RA.c), mA, "0"), 10, kA, FA, !0)), FA < 0 && RA.c[0] && (YA = "-" + YA)), YA;
      }, GA.valueOf = GA.toJSON = function() {
        return eg(this);
      }, GA._isBigNumber = !0, rA != null && vA.set(rA), vA;
    }
    function oA(rA) {
      var uA = rA | 0;
      return rA > 0 || rA === uA ? uA : uA - 1;
    }
    function EA(rA) {
      for (var uA, hA, dA = 1, GA = rA.length, DA = rA[0] + ""; dA < GA; ) {
        for (uA = rA[dA++] + "", hA = CA - uA.length; hA--; uA = "0" + uA) ;
        DA += uA;
      }
      for (GA = DA.length; DA.charCodeAt(--GA) === 48; ) ;
      return DA.slice(0, GA + 1 || 1);
    }
    function aA(rA, uA) {
      var hA, dA, GA = rA.c, DA = uA.c, wA = rA.s, bA = uA.s, yA = rA.e, pA = uA.e;
      if (!wA || !bA) return null;
      if (hA = GA && !GA[0], dA = DA && !DA[0], hA || dA) return hA ? dA ? 0 : -bA : wA;
      if (wA != bA) return wA;
      if (hA = wA < 0, dA = yA == pA, !GA || !DA) return dA ? 0 : !GA ^ hA ? 1 : -1;
      if (!dA) return yA > pA ^ hA ? 1 : -1;
      for (bA = (yA = GA.length) < (pA = DA.length) ? yA : pA, wA = 0; wA < bA; wA++) if (GA[wA] != DA[wA]) return GA[wA] > DA[wA] ^ hA ? 1 : -1;
      return yA == pA ? 0 : yA > pA ^ hA ? 1 : -1;
    }
    function nA(rA, uA, hA, dA) {
      if (rA < uA || rA > hA || rA !== H(rA))
        throw Error(AA + (dA || "Argument") + (typeof rA == "number" ? rA < uA || rA > hA ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(rA));
    }
    function lA(rA) {
      var uA = rA.c.length - 1;
      return oA(rA.e / CA) == uA && rA.c[uA] % 2 != 0;
    }
    function cA(rA, uA) {
      return (rA.length > 1 ? rA.charAt(0) + "." + rA.slice(1) : rA) + (uA < 0 ? "e" : "e+") + uA;
    }
    function sA(rA, uA, hA) {
      var dA, GA;
      if (uA < 0) {
        for (GA = hA + "."; ++uA; GA += hA) ;
        rA = GA + rA;
      } else if (dA = rA.length, ++uA > dA) {
        for (GA = hA, uA -= dA; --uA; GA += hA) ;
        rA += GA;
      } else uA < dA && (rA = rA.slice(0, uA) + "." + rA.slice(uA));
      return rA;
    }
    g = tA(), g.default = g.BigNumber = g, n.exports ? n.exports = g : (t || (t = typeof self < "u" && self ? self : window), t.BigNumber = g);
  })(commonjsGlobal);
})(bignumber);
var bignumberExports = bignumber.exports;
const globalState$1 = requireGlobalState(), validating = requireValidating(), parsing$1 = parsing$2, BigNumber$1 = bignumberExports, powers = {
  trillion: Math.pow(10, 12),
  billion: Math.pow(10, 9),
  million: Math.pow(10, 6),
  thousand: Math.pow(10, 3)
}, defaultOptions$1 = {
  totalLength: 0,
  characteristic: 0,
  forceAverage: !1,
  average: !1,
  mantissa: -1,
  optionalMantissa: !0,
  thousandSeparated: !1,
  spaceSeparated: !1,
  negative: "sign",
  forceSign: !1,
  roundingFunction: Math.round,
  spaceSeparatedAbbreviation: !1
}, { binarySuffixes, decimalSuffixes } = globalState$1.currentBytes(), bytes = {
  general: { scale: 1024, suffixes: decimalSuffixes },
  binary: { scale: 1024, suffixes: binarySuffixes },
  decimal: { scale: 1e3, suffixes: decimalSuffixes }
};
function format$5(n, t = {}, g) {
  if (typeof t == "string" && (t = parsing$1.parseFormat(t)), !validating.validateFormat(t))
    return "ERROR: invalid format";
  let k = t.prefix || "", H = t.postfix || "", AA = formatNumbro(n, t, g);
  return AA = insertPrefix(AA, k), AA = insertPostfix(AA, H), AA;
}
function formatNumbro(n, t, g) {
  switch (t.output) {
    case "currency":
      return t = formatOrDefault(t, globalState$1.currentCurrencyDefaultFormat()), formatCurrency(n, t, globalState$1);
    case "percent":
      return t = formatOrDefault(t, globalState$1.currentPercentageDefaultFormat()), formatPercentage(n, t, globalState$1, g);
    case "byte":
      return t = formatOrDefault(t, globalState$1.currentByteDefaultFormat()), formatByte(n, t, globalState$1, g);
    case "time":
      return t = formatOrDefault(t, globalState$1.currentTimeDefaultFormat()), formatTime$1(n);
    case "ordinal":
      return t = formatOrDefault(t, globalState$1.currentOrdinalDefaultFormat()), formatOrdinal(n, t, globalState$1);
    case "number":
    default:
      return formatNumber({
        instance: n,
        providedFormat: t
      });
  }
}
function getDecimalByteUnit(n) {
  let t = bytes.decimal;
  return getFormatByteUnits(n._value, t.suffixes, t.scale).suffix;
}
function getBinaryByteUnit(n) {
  let t = bytes.binary;
  return getFormatByteUnits(n._value, t.suffixes, t.scale).suffix;
}
function getByteUnit(n) {
  let t = bytes.general;
  return getFormatByteUnits(n._value, t.suffixes, t.scale).suffix;
}
function getFormatByteUnits(n, t, g) {
  let d = t[0], k = Math.abs(n);
  if (k >= g) {
    for (let H = 1; H < t.length; ++H) {
      let AA = Math.pow(g, H), gA = Math.pow(g, H + 1);
      if (k >= AA && k < gA) {
        d = t[H], n = n / AA;
        break;
      }
    }
    d === t[0] && (n = n / Math.pow(g, t.length - 1), d = t[t.length - 1]);
  }
  return { value: n, suffix: d };
}
function formatByte(n, t, g, d) {
  let k = t.base || "binary", H = Object.assign({}, defaultOptions$1, t);
  const { binarySuffixes: AA, decimalSuffixes: gA } = g.currentBytes();
  let CA = {
    general: { scale: 1024, suffixes: gA || decimalSuffixes, marker: "bd" },
    binary: { scale: 1024, suffixes: AA || binarySuffixes, marker: "b" },
    decimal: { scale: 1e3, suffixes: gA || decimalSuffixes, marker: "d" }
  }[k], { value: BA, suffix: eA } = getFormatByteUnits(n._value, CA.suffixes, CA.scale);
  return `${formatNumber({
    instance: d(BA),
    providedFormat: t,
    state: g,
    defaults: g.currentByteDefaultFormat()
  })}${H.spaceSeparated ? " " : ""}${eA}`;
}
function formatOrdinal(n, t, g) {
  let d = g.currentOrdinal(), k = Object.assign({}, defaultOptions$1, t), H = formatNumber({
    instance: n,
    providedFormat: t,
    state: g
  }), AA = d(n._value);
  return `${H}${k.spaceSeparated ? " " : ""}${AA}`;
}
function formatTime$1(n) {
  let t = Math.floor(n._value / 60 / 60), g = Math.floor((n._value - t * 60 * 60) / 60), d = Math.round(n._value - t * 60 * 60 - g * 60);
  return `${t}:${g < 10 ? "0" : ""}${g}:${d < 10 ? "0" : ""}${d}`;
}
function formatPercentage(n, t, g, d) {
  let k = t.prefixSymbol, H = formatNumber({
    instance: d(n._value * 100),
    providedFormat: t,
    state: g
  }), AA = Object.assign({}, defaultOptions$1, t);
  return k ? `%${AA.spaceSeparated ? " " : ""}${H}` : `${H}${AA.spaceSeparated ? " " : ""}%`;
}
function formatCurrency(n, t, g) {
  const d = g.currentCurrency();
  let k = Object.assign({}, t), H = Object.assign({}, defaultOptions$1, k), AA, gA = "", IA = !!H.totalLength || !!H.forceAverage || H.average, CA = k.currencyPosition || d.position, BA = k.currencySymbol || d.symbol;
  const eA = H.spaceSeparatedCurrency !== void 0 ? H.spaceSeparatedCurrency : H.spaceSeparated;
  k.lowPrecision === void 0 && (k.lowPrecision = !1), eA && (gA = " "), CA === "infix" && (AA = gA + BA + gA);
  let iA = formatNumber({
    instance: n,
    providedFormat: k,
    state: g,
    decimalSeparator: AA
  });
  return CA === "prefix" && (n._value < 0 && H.negative === "sign" ? iA = `-${gA}${BA}${iA.slice(1)}` : n._value > 0 && H.forceSign ? iA = `+${gA}${BA}${iA.slice(1)}` : iA = BA + gA + iA), (!CA || CA === "postfix") && (gA = !H.spaceSeparatedAbbreviation && IA ? "" : gA, iA = iA + gA + BA), iA;
}
function computeAverage({ value: n, forceAverage: t, lowPrecision: g = !0, abbreviations: d, spaceSeparated: k = !1, totalLength: H = 0, roundingFunction: AA = Math.round }) {
  let gA = "", IA = Math.abs(n), CA = -1;
  if (t && d[t] && powers[t] ? (gA = d[t], n = n / powers[t]) : IA >= powers.trillion || g && AA(IA / powers.trillion) === 1 ? (gA = d.trillion, n = n / powers.trillion) : IA < powers.trillion && IA >= powers.billion || g && AA(IA / powers.billion) === 1 ? (gA = d.billion, n = n / powers.billion) : IA < powers.billion && IA >= powers.million || g && AA(IA / powers.million) === 1 ? (gA = d.million, n = n / powers.million) : (IA < powers.million && IA >= powers.thousand || g && AA(IA / powers.thousand) === 1) && (gA = d.thousand, n = n / powers.thousand), gA && (gA = (k ? " " : "") + gA), H) {
    let eA = n < 0, iA = n.toString().split(".")[0], QA = eA ? iA.length - 1 : iA.length;
    CA = Math.max(H - QA, 0);
  }
  return { value: n, abbreviation: gA, mantissaPrecision: CA };
}
function computeExponential({ value: n, characteristicPrecision: t }) {
  let [g, d] = n.toExponential().split("e"), k = +g;
  if (!t)
    return {
      value: k,
      abbreviation: `e${d}`
    };
  let H = 1;
  return H < t && (k = k * Math.pow(10, t - H), d = +d - (t - H), d = d >= 0 ? `+${d}` : d), {
    value: k,
    abbreviation: `e${d}`
  };
}
function zeroes(n) {
  let t = "";
  for (let g = 0; g < n; g++)
    t += "0";
  return t;
}
function toFixedLarge(n, t) {
  let g = n.toString(), [d, k] = g.split("e"), [H, AA = ""] = d.split(".");
  if (+k > 0)
    g = H + AA + zeroes(k - AA.length);
  else {
    let gA = ".";
    +H < 0 ? gA = `-0${gA}` : gA = `0${gA}`;
    let IA = (zeroes(-k - 1) + Math.abs(H) + AA).substr(0, t);
    IA.length < t && (IA += zeroes(t - IA.length)), g = gA + IA;
  }
  return +k > 0 && t > 0 && (g += `.${zeroes(t)}`), g;
}
function toFixed(n, t, g = Math.round) {
  return n.toString().indexOf("e") !== -1 ? toFixedLarge(n, t) : new BigNumber$1(g(+`${n}e+${t}`) / Math.pow(10, t)).toFixed(t);
}
function setMantissaPrecision(n, t, g, d, k, H) {
  if (d === -1)
    return n;
  let AA = toFixed(t, d, H), [gA, IA = ""] = AA.toString().split(".");
  if (IA.match(/^0+$/) && (g || k))
    return gA;
  let CA = IA.match(/0+$/);
  return k && CA ? `${gA}.${IA.toString().slice(0, CA.index)}` : AA.toString();
}
function setCharacteristicPrecision(n, t, g, d) {
  let k = n, [H, AA] = k.toString().split(".");
  if (H.match(/^-?0$/) && g)
    return AA ? `${H.replace("0", "")}.${AA}` : H.replace("0", "");
  const gA = t < 0 && H.indexOf("-") === 0;
  if (gA && (H = H.slice(1), k = k.slice(1)), H.length < d) {
    let IA = d - H.length;
    for (let CA = 0; CA < IA; CA++)
      k = `0${k}`;
  }
  return gA && (k = `-${k}`), k.toString();
}
function indexesOfGroupSpaces(n, t) {
  let g = [], d = 0;
  for (let k = n; k > 0; k--)
    d === t && (g.unshift(k), d = 0), d++;
  return g;
}
function replaceDelimiters(n, t, g, d, k) {
  let H = d.currentDelimiters(), AA = H.thousands;
  k = k || H.decimal;
  let gA = H.thousandsSize || 3, IA = n.toString(), CA = IA.split(".")[0], BA = IA.split(".")[1];
  const eA = t < 0 && CA.indexOf("-") === 0;
  return g && (eA && (CA = CA.slice(1)), indexesOfGroupSpaces(CA.length, gA).forEach((QA, tA) => {
    CA = CA.slice(0, QA + tA) + AA + CA.slice(QA + tA);
  }), eA && (CA = `-${CA}`)), BA ? IA = CA + k + BA : IA = CA, IA;
}
function insertAbbreviation(n, t) {
  return n + t;
}
function insertSign(n, t, g) {
  return t === 0 ? n : +n == 0 ? n.replace("-", "") : t > 0 ? `+${n}` : g === "sign" ? n : `(${n.replace("-", "")})`;
}
function insertPrefix(n, t) {
  return t + n;
}
function insertPostfix(n, t) {
  return n + t;
}
function formatNumber({ instance: n, providedFormat: t, state: g = globalState$1, decimalSeparator: d, defaults: k = g.currentDefaults() }) {
  let H = n._value;
  if (H === 0 && g.hasZeroFormat())
    return g.getZeroFormat();
  if (!isFinite(H))
    return H.toString();
  let AA = Object.assign({}, defaultOptions$1, k, t), gA = AA.totalLength, IA = gA ? 0 : AA.characteristic, CA = AA.optionalCharacteristic, BA = AA.forceAverage, eA = AA.lowPrecision, iA = !!gA || !!BA || AA.average, QA = gA ? -1 : iA && t.mantissa === void 0 ? 0 : AA.mantissa, tA = gA ? !1 : t.optionalMantissa === void 0 ? QA === -1 : AA.optionalMantissa, oA = AA.trimMantissa, EA = AA.thousandSeparated, aA = AA.spaceSeparated, nA = AA.negative, lA = AA.forceSign, cA = AA.exponential, sA = AA.roundingFunction, rA = "";
  if (iA) {
    let hA = computeAverage({
      value: H,
      forceAverage: BA,
      lowPrecision: eA,
      abbreviations: g.currentAbbreviations(),
      spaceSeparated: aA,
      roundingFunction: sA,
      totalLength: gA
    });
    H = hA.value, rA += hA.abbreviation, gA && (QA = hA.mantissaPrecision);
  }
  if (cA) {
    let hA = computeExponential({
      value: H,
      characteristicPrecision: IA
    });
    H = hA.value, rA = hA.abbreviation + rA;
  }
  let uA = setMantissaPrecision(H.toString(), H, tA, QA, oA, sA);
  return uA = setCharacteristicPrecision(uA, H, CA, IA), uA = replaceDelimiters(uA, H, EA, g, d), (iA || cA) && (uA = insertAbbreviation(uA, rA)), (lA || H < 0) && (uA = insertSign(uA, H, nA)), uA;
}
function formatOrDefault(n, t) {
  if (!n)
    return t;
  let g = Object.keys(n);
  return g.length === 1 && g[0] === "output" ? t : n;
}
var formatting = (n) => ({
  format: (...t) => format$5(...t, n),
  getByteUnit: (...t) => getByteUnit(...t, n),
  getBinaryByteUnit: (...t) => getBinaryByteUnit(...t, n),
  getDecimalByteUnit: (...t) => getDecimalByteUnit(...t, n),
  formatOrDefault
});
const BigNumber = bignumberExports;
function add$5(n, t, g) {
  let d = new BigNumber(n._value), k = t;
  return g.isNumbro(t) && (k = t._value), k = new BigNumber(k), n._value = d.plus(k).toNumber(), n;
}
function subtract(n, t, g) {
  let d = new BigNumber(n._value), k = t;
  return g.isNumbro(t) && (k = t._value), k = new BigNumber(k), n._value = d.minus(k).toNumber(), n;
}
function multiply(n, t, g) {
  let d = new BigNumber(n._value), k = t;
  return g.isNumbro(t) && (k = t._value), k = new BigNumber(k), n._value = d.times(k).toNumber(), n;
}
function divide(n, t, g) {
  let d = new BigNumber(n._value), k = t;
  return g.isNumbro(t) && (k = t._value), k = new BigNumber(k), n._value = d.dividedBy(k).toNumber(), n;
}
function set$6(n, t, g) {
  let d = t;
  return g.isNumbro(t) && (d = t._value), n._value = d, n;
}
function difference(n, t, g) {
  let d = g(n._value);
  return subtract(d, t, g), Math.abs(d._value);
}
var manipulating = (n) => ({
  add: (t, g) => add$5(t, g, n),
  subtract: (t, g) => subtract(t, g, n),
  multiply: (t, g) => multiply(t, g, n),
  divide: (t, g) => divide(t, g, n),
  set: (t, g) => set$6(t, g, n),
  difference: (t, g) => difference(t, g, n),
  BigNumber
});
const VERSION$3 = "2.5.0", globalState = requireGlobalState(), validator$2 = requireValidating(), loader$1 = loading(numbro), unformatter = requireUnformatting();
let formatter = formatting(numbro), manipulate = manipulating(numbro);
const parsing = parsing$2;
class Numbro {
  constructor(t) {
    this._value = t;
  }
  clone() {
    return numbro(this._value);
  }
  format(t = {}) {
    return formatter.format(this, t);
  }
  formatCurrency(t) {
    return typeof t == "string" && (t = parsing.parseFormat(t)), t = formatter.formatOrDefault(t, globalState.currentCurrencyDefaultFormat()), t.output = "currency", formatter.format(this, t);
  }
  formatTime(t = {}) {
    return t.output = "time", formatter.format(this, t);
  }
  binaryByteUnits() {
    return formatter.getBinaryByteUnit(this);
  }
  decimalByteUnits() {
    return formatter.getDecimalByteUnit(this);
  }
  byteUnits() {
    return formatter.getByteUnit(this);
  }
  difference(t) {
    return manipulate.difference(this, t);
  }
  add(t) {
    return manipulate.add(this, t);
  }
  subtract(t) {
    return manipulate.subtract(this, t);
  }
  multiply(t) {
    return manipulate.multiply(this, t);
  }
  divide(t) {
    return manipulate.divide(this, t);
  }
  set(t) {
    return manipulate.set(this, normalizeInput(t));
  }
  value() {
    return this._value;
  }
  valueOf() {
    return this._value;
  }
}
function normalizeInput(n) {
  let t = n;
  return numbro.isNumbro(n) ? t = n._value : typeof n == "string" ? t = numbro.unformat(n) : isNaN(n) && (t = NaN), t;
}
function numbro(n) {
  return new Numbro(normalizeInput(n));
}
numbro.version = VERSION$3;
numbro.isNumbro = function(n) {
  return n instanceof Numbro;
};
numbro.language = globalState.currentLanguage;
numbro.registerLanguage = globalState.registerLanguage;
numbro.setLanguage = globalState.setLanguage;
numbro.languages = globalState.languages;
numbro.languageData = globalState.languageData;
numbro.zeroFormat = globalState.setZeroFormat;
numbro.defaultFormat = globalState.currentDefaults;
numbro.setDefaults = globalState.setDefaults;
numbro.defaultCurrencyFormat = globalState.currentCurrencyDefaultFormat;
numbro.validate = validator$2.validate;
numbro.loadLanguagesInNode = loader$1.loadLanguagesInNode;
numbro.unformat = unformatter.unformat;
numbro.BigNumber = manipulate.BigNumber;
var numbro_1 = numbro, numbro$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(numbro_1);
const LOG$8 = loglevelExports$1.getLogger("arrowFormatUtils"), WEEKDAY_SHORT = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"], formatMs = (n) => moment("19700101", "YYYYMMDD").add(n, "ms").format("YYYY-MM-DD HH:mm:ss.SSS"), formatSec = (n) => moment("19700101", "YYYYMMDD").add(n, "s").format("YYYY-MM-DD HH:mm:ss"), formatMin = (n) => moment("19700101", "YYYYMMDD").add(n, "m").format("YYYY-MM-DD HH:mm"), formatHours = (n) => moment("19700101", "YYYYMMDD").add(n, "h").format("YYYY-MM-DD HH:mm"), formatDay = (n) => moment("19700101", "YYYYMMDD").add(n, "d").format("YYYY-MM-DD"), formatMonth = (n) => moment("19700101", "YYYYMMDD").add(n, "M").format("YYYY-MM"), formatYear$2 = (n) => moment("19700101", "YYYYMMDD").add(n, "y").format("YYYY"), formatWeeks = (n, t) => {
  if (!t)
    throw new Error('Frequency "W" requires parameter');
  const g = WEEKDAY_SHORT.indexOf(t);
  if (g < 0)
    throw new Error(`Invalid value: ${t}. Supported values: ${JSON.stringify(WEEKDAY_SHORT)}`);
  const d = moment("19700101", "YYYYMMDD").add(n, "w").day(g - 6).format("YYYY-MM-DD"), k = moment("19700101", "YYYYMMDD").add(n, "w").day(g).format("YYYY-MM-DD");
  return `${d}/${k}`;
}, formatQuarter = (n) => moment("19700101", "YYYYMMDD").add(n, "Q").endOf("quarter").format("YYYY[Q]Q"), PERIOD_TYPE_FORMATTERS = {
  L: formatMs,
  ms: formatMs,
  S: formatSec,
  s: formatSec,
  T: formatMin,
  min: formatMin,
  H: formatHours,
  h: formatHours,
  D: formatDay,
  M: formatMonth,
  W: formatWeeks,
  Q: formatQuarter,
  Y: formatYear$2,
  A: formatYear$2
};
function convertTimestampToSeconds(n, t) {
  let g;
  if (t === TimeUnit$1.MILLISECOND)
    g = 1e3;
  else if (t === TimeUnit$1.MICROSECOND)
    g = 1e3 * 1e3;
  else if (t === TimeUnit$1.NANOSECOND)
    g = 1e3 * 1e3 * 1e3;
  else
    return Number(n);
  return typeof n == "bigint" && !Number.isSafeInteger(Number(n)) ? Number(n / BigInt(g)) : Number(n) / g;
}
function convertTimeToDate(n, t) {
  const g = convertTimestampToSeconds(
    n,
    // The default is SECOND because that is the default unit for time values in pandas.
    // Though we believe that actually always a unit is populated by arrow.
    t?.type?.unit ?? TimeUnit$1.SECOND
  );
  return moment.unix(g).utc().toDate();
}
function formatTime(n, t) {
  const g = convertTimeToDate(n, t);
  return moment(g).utc().format(g.getMilliseconds() === 0 ? "HH:mm:ss" : "HH:mm:ss.SSS");
}
function formatDate$1(n) {
  const t = "YYYY-MM-DD";
  return n instanceof Date || typeof n == "number" && Number.isFinite(n) ? moment.utc(n).format(t) : (LOG$8.warn(`Unsupported date value: ${n}`), String(n));
}
function formatDatetime(n, t) {
  if (!(n instanceof Date || typeof n == "number" && Number.isFinite(n)))
    return LOG$8.warn(`Unsupported datetime value: ${n}`), String(n);
  let g = moment.utc(n);
  const d = t?.type?.timezone;
  return d ? (moment.tz.zone(d) ? g = g.tz(d) : g = g.utcOffset(d), g.format("YYYY-MM-DD HH:mm:ssZ")) : g.format("YYYY-MM-DD HH:mm:ss");
}
function formatDuration(n, t) {
  return moment.duration(convertTimestampToSeconds(
    n,
    // The default is NANOSECOND because that is the default unit for duration in pandas.
    // Though we believe that actually always a unit is populated by arrow.
    t?.type?.unit ?? TimeUnit$1.NANOSECOND
  ), "seconds").humanize();
}
function formatDecimal$1(n, t) {
  const g = t?.type?.scale || 0;
  let d = util$2.bigNumToString(new util$2.BN(n)).padStart(g, "0");
  if (g === 0)
    return d;
  let k = "";
  d.startsWith("-") && (k = "-", d = d.slice(1));
  const H = d.slice(0, -g) || "0", AA = trimEnd(d.slice(-g), "0") || "";
  return `${k}${H}` + (AA ? `.${AA}` : "");
}
function formatPeriodFromFreq(n, t) {
  const [g, d] = t.split("-", 2), k = PERIOD_TYPE_FORMATTERS[g];
  if (!k)
    return LOG$8.warn(`Unsupported period frequency: ${t}`), String(n);
  const H = Number(n);
  if (!Number.isSafeInteger(H))
    return LOG$8.warn(`Unsupported value: ${n}. Supported values: [${Number.MIN_SAFE_INTEGER}-${Number.MAX_SAFE_INTEGER}]`), String(n);
  try {
    return k(H, d);
  } catch (AA) {
    return LOG$8.warn(`Error while formatting period value: ${AA}`), String(n);
  }
}
function formatPeriod(n, t) {
  if (isNullOrUndefined$1(t))
    return LOG$8.warn("Field information is missing"), String(n);
  const g = t.metadata.get("ARROW:extension:name"), d = t.metadata.get("ARROW:extension:metadata");
  if (isNullOrUndefined$1(g) || isNullOrUndefined$1(d))
    return LOG$8.warn("Arrow extension metadata is missing"), String(n);
  if (g !== "pandas.period")
    return LOG$8.warn(`Unsupported extension name for period type: ${g}`), String(n);
  const k = JSON.parse(d), {
    freq: H
  } = k;
  return formatPeriodFromFreq(n, H);
}
function formatObject$1(n, t) {
  return t?.type instanceof Struct ? JSON.stringify(n, (g, d) => {
    if (notNullOrUndefined(d))
      return typeof d == "bigint" ? Number(d) : d;
  }) : JSON.stringify(n, (g, d) => typeof d == "bigint" ? Number(d) : d);
}
function formatFloat(n) {
  return Number.isFinite(n) ? numbro$1(n).format("0,0.0000") : String(n);
}
function formatInterval(n, t) {
  const g = t?.metadata.get("ARROW:extension:name");
  if (g && g === "pandas.interval") {
    const d = JSON.parse(t?.metadata.get("ARROW:extension:metadata")), {
      subtype: k,
      closed: H
    } = d, AA = n.toJSON(), gA = H === "both" || H === "left" ? "[" : "(", IA = H === "both" || H === "right" ? "]" : ")", CA = format$4(AA.left, {
      // Construct a arrow type for the left interval
      type: DataFrameCellType.DATA,
      pandasType: {
        pandas_type: k,
        numpy_type: k,
        field_name: "",
        name: "",
        metadata: null
      },
      arrowField: t?.type?.children?.[0]
    }), BA = format$4(AA.right, {
      // Construct a arrow type for the right interval
      type: DataFrameCellType.DATA,
      pandasType: {
        pandas_type: k,
        numpy_type: k,
        field_name: "",
        name: "",
        metadata: null
      },
      arrowField: t?.type?.children?.[1]
    });
    return `${gA + CA}, ${BA + IA}`;
  }
  return String(n);
}
function format$4(n, t) {
  try {
    if (isNullOrUndefined$1(n))
      return "";
    if (isStringType(t))
      return String(n);
    const g = n instanceof Date || Number.isFinite(n);
    if (g && isDateType(t))
      return formatDate$1(n);
    if (typeof n == "bigint" && isTimeType(t))
      return formatTime(Number(n), t.arrowField);
    if (g && isDatetimeType(t))
      return formatDatetime(n, t.arrowField);
    if (isPeriodType(t))
      return formatPeriod(n, t.arrowField);
    if (isIntervalType(t))
      return formatInterval(n, t.arrowField);
    if (isDurationType(t))
      return formatDuration(n, t.arrowField);
    if (isDecimalType(t))
      return formatDecimal$1(n, t.arrowField);
    if (isFloatType(t) && Number.isFinite(n))
      return formatFloat(n);
    if (isObjectType(t) || isListType(t))
      return formatObject$1(n, t.arrowField);
  } catch (g) {
    return LOG$8.warn(`Unexpected error occurred while formatting value: ${g}`), String(n);
  }
  return String(n);
}
function getStyledHeaders(n) {
  const {
    numIndexColumns: t
  } = n.dimensions, g = [];
  for (let d = 0; d < n.columnNames.length; d++) {
    const k = [];
    for (let H = 0; H < n.columnNames[d].length; H++) {
      const AA = [];
      H < t ? (AA.push("blank"), AA.push("index_name"), AA.push(`level${d}`)) : (AA.push("col_heading"), AA.push(`level${d}`), AA.push(`col${H - t}`)), k.push({
        name: n.columnNames[d][H],
        cssClass: AA.join(" ")
      });
    }
    g.push(k);
  }
  return g;
}
function getStyledCell(n, t, g) {
  if (!n.styler?.cssId)
    return;
  const {
    numIndexColumns: d,
    numDataRows: k,
    numColumns: H
  } = n.dimensions;
  if (t < 0 || t >= k)
    throw new Error(`Row index is out of range: ${t}`);
  if (g < 0 || g >= H)
    throw new Error(`Column index is out of range: ${g}`);
  if (g < d) {
    const BA = ["row_heading", `level${g}`, `row${t}`].join(" ");
    return {
      cssId: `${n.styler.cssId}_level${g}_row${t}`,
      cssClass: BA,
      displayContent: void 0
    };
  }
  const gA = g - d, IA = ["data", `row${t}`, `col${gA}`].join(" "), CA = n.styler?.displayValues ? n.styler.displayValues.getCell(t, g).content : void 0;
  return {
    cssId: `${n.styler.cssId}_row${t}_col${gA}`,
    cssClass: IA,
    displayContent: CA
  };
}
const StyledTableContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1q9reml6"
} : {
  target: "e1q9reml6",
  label: "StyledTableContainer"
})(({
  theme: n
}) => ({
  fontSize: n.fontSizes.md,
  fontFamily: n.genericFonts.bodyFont,
  lineHeight: n.lineHeights.small,
  captionSide: "bottom"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTableCaption = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1q9reml5"
} : {
  target: "e1q9reml5",
  label: "StyledTableCaption"
})(({
  theme: n
}) => ({
  fontFamily: n.genericFonts.bodyFont,
  fontSize: n.fontSizes.sm,
  paddingTop: n.spacing.sm,
  paddingBottom: 0,
  color: n.colors.fadedText60,
  textAlign: "left",
  wordWrap: "break-word",
  display: "inline-block"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTableBorder = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1q9reml4"
} : {
  target: "e1q9reml4",
  label: "StyledTableBorder"
})(({
  theme: n,
  borderMode: t
}) => ({
  // Add the enclosing border on an extra wrapper around the table. This ensures that
  // when the table scrolls horizontally on small windows, it still shows a border all
  // around the table and the table doesn't look cut off.
  border: t === Arrow$2.BorderMode.ALL ? `${n.sizes.borderWidth} solid ${n.colors.dataframeBorderColor}` : "none",
  borderRadius: n.radii.default,
  overflow: "auto"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTable = /* @__PURE__ */ createStyled$1("table", process.env.NODE_ENV === "production" ? {
  target: "e1q9reml3"
} : {
  target: "e1q9reml3",
  label: "StyledTable"
})(({
  theme: n
}) => ({
  width: n.sizes.full,
  color: n.colors.bodyText,
  borderSpacing: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), styleCellFunction = (n, t = Arrow$2.BorderMode.ALL) => ({
  // Only have borders on the bottom and right of each cell.
  borderBottom: t !== Arrow$2.BorderMode.NONE ? `${n.sizes.borderWidth} solid ${n.colors.dataframeBorderColor}` : "none",
  "tbody tr:last-child &": {
    // For "all" borders, remove bottom border of last row to prevent double border with
    // table border. For "horizontal" borders, also remove bottom border of last row
    // since there's no content after it.
    borderBottom: t === Arrow$2.BorderMode.ALL || t === Arrow$2.BorderMode.HORIZONTAL ? "none" : void 0
  },
  borderRight: t === Arrow$2.BorderMode.ALL ? `${n.sizes.borderWidth} solid ${n.colors.dataframeBorderColor}` : "none",
  "&:last-child": {
    borderRight: t === Arrow$2.BorderMode.ALL ? "none" : void 0,
    // Remove right padding from last cell when no borders, so that the table aligns
    // with the rest of the page.
    paddingRight: t === Arrow$2.BorderMode.NONE ? "0" : n.spacing.xs
  },
  verticalAlign: "middle",
  padding: `${n.spacing.twoXS} ${n.spacing.xs}`,
  // Increase the space between columns when there are no vertical borders.
  "&:not(:first-of-type)": {
    paddingLeft: t === Arrow$2.BorderMode.NONE || t === Arrow$2.BorderMode.HORIZONTAL ? n.spacing.lg : n.spacing.xs
  },
  // Remove left padding from first column when no borders, so that the table aligns
  // with the rest of the page.
  "&:first-of-type": {
    paddingLeft: t === Arrow$2.BorderMode.NONE ? "0" : n.spacing.xs
  },
  fontWeight: n.fontWeights.normal
}), StyledTableCell = /* @__PURE__ */ createStyled$1("td", process.env.NODE_ENV === "production" ? {
  target: "e1q9reml2"
} : {
  target: "e1q9reml2",
  label: "StyledTableCell"
})(({
  theme: n,
  borderMode: t
}) => styleCellFunction(n, t), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTableCellHeader = /* @__PURE__ */ createStyled$1("th", process.env.NODE_ENV === "production" ? {
  target: "e1q9reml1"
} : {
  target: "e1q9reml1",
  label: "StyledTableCellHeader"
})(({
  theme: n,
  borderMode: t
}) => ({
  ...styleCellFunction(n, t),
  textAlign: "inherit",
  color: n.colors.fadedText60,
  // Remove left padding from first cell when no borders, so that the table aligns
  // with the rest of the page.
  "&:first-of-type": {
    paddingLeft: t === Arrow$2.BorderMode.NONE ? "0" : n.spacing.sm
  },
  // Increase the space between columns when there are no vertical borders.
  "&:not(:first-of-type)": {
    paddingLeft: t === Arrow$2.BorderMode.NONE || t === Arrow$2.BorderMode.HORIZONTAL ? n.spacing.lg : n.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledEmptyTableCell = /* @__PURE__ */ createStyled$1(StyledTableCell, process.env.NODE_ENV === "production" ? {
  target: "e1q9reml0"
} : {
  target: "e1q9reml0",
  label: "StyledEmptyTableCell"
})(({
  theme: n
}) => ({
  color: n.colors.gray70,
  fontStyle: "italic",
  fontSize: n.fontSizes.md,
  textAlign: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function ArrowTable(n) {
  const t = n.data, {
    cssId: g,
    cssStyles: d,
    caption: k
  } = t.styler ?? {}, {
    numHeaderRows: H,
    numDataRows: AA,
    numColumns: gA
  } = t.dimensions, IA = range$6(AA), CA = n.element.borderMode;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledTableContainer, { className: "stTable", "data-testid": "stTable", children: [
    d && /* @__PURE__ */ jsxRuntimeExports.jsx("style", { children: d }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTableBorder, { borderMode: CA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledTable, { id: g, "data-testid": "stTableStyledTable", children: [
      H > 0 && generateTableHeader(t, CA),
      /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: IA.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEmptyTableCell, { "data-testid": "stTableStyledEmptyTableCell", colSpan: gA || 1, borderMode: CA, children: "empty" }) }) : IA.map((BA) => generateTableRow(t, BA, gA, CA)) })
    ] }) }),
    k && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTableCaption, { children: k })
  ] });
}
function generateTableHeader(n, t) {
  const g = t === Arrow$2.BorderMode.NONE || t === Arrow$2.BorderMode.HORIZONTAL;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("thead", { children: getStyledHeaders(n).map((d, k) => (
    // TODO: Update to match React best practices
    // eslint-disable-next-line @eslint-react/no-array-index-key
    /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: d.map((H, AA) => {
      let gA = "inherit";
      if (g && n.dimensions.numDataRows > 0) {
        const {
          contentType: IA
        } = n.getCell(0, AA);
        gA = isNumericType(IA) ? "right" : "left";
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        StyledTableCellHeader,
        {
          className: H.cssClass,
          scope: "col",
          borderMode: t,
          style: {
            textAlign: gA
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: H.name || " ", allowHTML: !1 })
        },
        AA
      );
    }) }, k)
  )) });
}
function generateTableRow(n, t, g, d) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: range$6(g).map((k) => generateTableCell(n, t, k, d)) }, t);
}
function generateTableCell(n, t, g, d) {
  const {
    type: k,
    content: H,
    contentType: AA
  } = n.getCell(t, g), gA = getStyledCell(n, t, g);
  let IA = gA?.displayContent || format$4(H, AA), CA = !1;
  const BA = {
    textAlign: isNumericType(AA) ? "right" : "left"
  };
  switch (IA?.endsWith('<span class="pd-t"></span>') && (IA = IA.replace(/<span class="pd-t"><\/span>$/, ""), CA = !0), k) {
    // Index cells are from index columns which only exist if the DataFrame was created
    // based on a Pandas DataFrame.
    case DataFrameCellType.INDEX:
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledTableCellHeader, { scope: "row", id: gA?.cssId, className: gA?.cssClass, borderMode: d, children: [
        CA && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "pd-t" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: IA || " ", allowHTML: !1 })
      ] }, g);
    case DataFrameCellType.DATA:
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledTableCell, { id: gA?.cssId, className: gA?.cssClass, style: BA, borderMode: d, children: [
        CA && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "pd-t" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: IA || " ", allowHTML: !1 })
      ] }, g);
    default:
      throw new Error(`Cannot parse type "${k}".`);
  }
}
const ArrowTable$1 = memo$1(ArrowTable), StyledDocSummary = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn10"
} : {
  target: "ejycmjn10",
  label: "StyledDocSummary"
})(({
  theme: n
}) => ({
  "& > *": {
    marginRight: n.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocName = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn9"
} : {
  target: "ejycmjn9",
  label: "StyledDocName"
})(({
  theme: n
}) => ({
  fontWeight: n.fontWeights.codeBold
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Eb2NTdHJpbmcvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0I2QiIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvRG9jU3RyaW5nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NTdW1tYXJ5ID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgXCImID4gKlwiOiB7XG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY05hbWUgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlQm9sZCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRG9jVHlwZSA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMuY29kZVRleHRDb2xvcixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRG9jVmFsdWUgPSBzdHlsZWQuc3BhbigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NDb250YWluZXIgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuY29kZUZvbnQsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NIZWFkZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcuc219ICR7dGhlbWUuc3BhY2luZy5sZ31gLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ01peCxcbiAgYm9yZGVyQm90dG9tOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgLy8gQWRkIHJvdW5kZWQgY29ybmVycyB0byB0aGUgdG9wIG9mIHRoZSBjb250YWluZXIgdG8gcHJldmVudCB0aGUgYmFja2dyb3VuZFxuICAvLyBjb2xvciBmcm9tIGJsZWVkaW5nIGludG8gdGhlIHN1cnJvdW5kaW5nIGFyZWEuXG4gIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmNvZGVGb250U2l6ZSxcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NTdHJpbmcgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHdoaXRlU3BhY2U6IFwicHJlXCIsXG4gIG92ZXJmbG93OiBcImF1dG9cIixcbiAgbWF4SGVpZ2h0OiBcIjMwLjVyZW1cIiwgLy8gVGhlIGV4dHJhIDAuNXJlbSBpcyB0byBzaG93IGEgbGl0dGxlIG9mIHRoZSBvdmVyZmxvd2luZyBsaW5lLlxuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5jb2RlRm9udFNpemUsXG5cbiAgXCImOm5vdCg6bGFzdC1jaGlsZClcIjoge1xuICAgIGJvcmRlckJvdHRvbTogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNUYWJsZSA9IHN0eWxlZC50YWJsZSgoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogXCIxMDAlXCIsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ01peCxcbiAgdGFibGVMYXlvdXQ6IFwiZml4ZWRcIiwgLy8gRml4IHRhYmxlIHRvIGNvbnRhaW5lcidzIGJvdW5kYXJpZXMuXG4gIGJvcmRlckNvbGxhcHNlOiBcImNvbGxhcHNlXCIsXG4gIC8vIEFkZCByb3VuZGVkIGNvcm5lcnMgdG8gdGhlIGJvdHRvbSBvZiB0aGUgdGFibGUgdG8gbWF0Y2ggY29udGFpbmVyXG4gIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGJvcmRlckJvdHRvbVJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW1iZXJzUm93ID0gc3R5bGVkLnRyKCh7IHRoZW1lIH0pID0+ICh7XG4gIFwiJjpub3QoOmxhc3QtY2hpbGQpXCI6IHtcbiAgICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW1iZXJzU3VtbWFyeUNlbGwgPSBzdHlsZWQudGQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgd2lkdGg6IFwiMzAlXCIsXG4gIG92ZXJmbG93OiBcImF1dG9cIixcbiAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy5zbX0gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG5cbiAgXCImID4gKlwiOiB7XG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNEZXRhaWxzQ2VsbCA9IHN0eWxlZC50ZCgoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogXCI3MCVcIixcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcbn0pKVxuIl19 */"), StyledDocType = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn8"
} : {
  target: "ejycmjn8",
  label: "StyledDocType"
})(({
  theme: n
}) => ({
  color: n.colors.codeTextColor
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Eb2NTdHJpbmcvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNEI2QiIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvRG9jU3RyaW5nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NTdW1tYXJ5ID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgXCImID4gKlwiOiB7XG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY05hbWUgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlQm9sZCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRG9jVHlwZSA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMuY29kZVRleHRDb2xvcixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRG9jVmFsdWUgPSBzdHlsZWQuc3BhbigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NDb250YWluZXIgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuY29kZUZvbnQsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NIZWFkZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcuc219ICR7dGhlbWUuc3BhY2luZy5sZ31gLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ01peCxcbiAgYm9yZGVyQm90dG9tOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgLy8gQWRkIHJvdW5kZWQgY29ybmVycyB0byB0aGUgdG9wIG9mIHRoZSBjb250YWluZXIgdG8gcHJldmVudCB0aGUgYmFja2dyb3VuZFxuICAvLyBjb2xvciBmcm9tIGJsZWVkaW5nIGludG8gdGhlIHN1cnJvdW5kaW5nIGFyZWEuXG4gIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmNvZGVGb250U2l6ZSxcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NTdHJpbmcgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHdoaXRlU3BhY2U6IFwicHJlXCIsXG4gIG92ZXJmbG93OiBcImF1dG9cIixcbiAgbWF4SGVpZ2h0OiBcIjMwLjVyZW1cIiwgLy8gVGhlIGV4dHJhIDAuNXJlbSBpcyB0byBzaG93IGEgbGl0dGxlIG9mIHRoZSBvdmVyZmxvd2luZyBsaW5lLlxuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5jb2RlRm9udFNpemUsXG5cbiAgXCImOm5vdCg6bGFzdC1jaGlsZClcIjoge1xuICAgIGJvcmRlckJvdHRvbTogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNUYWJsZSA9IHN0eWxlZC50YWJsZSgoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogXCIxMDAlXCIsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ01peCxcbiAgdGFibGVMYXlvdXQ6IFwiZml4ZWRcIiwgLy8gRml4IHRhYmxlIHRvIGNvbnRhaW5lcidzIGJvdW5kYXJpZXMuXG4gIGJvcmRlckNvbGxhcHNlOiBcImNvbGxhcHNlXCIsXG4gIC8vIEFkZCByb3VuZGVkIGNvcm5lcnMgdG8gdGhlIGJvdHRvbSBvZiB0aGUgdGFibGUgdG8gbWF0Y2ggY29udGFpbmVyXG4gIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGJvcmRlckJvdHRvbVJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW1iZXJzUm93ID0gc3R5bGVkLnRyKCh7IHRoZW1lIH0pID0+ICh7XG4gIFwiJjpub3QoOmxhc3QtY2hpbGQpXCI6IHtcbiAgICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW1iZXJzU3VtbWFyeUNlbGwgPSBzdHlsZWQudGQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgd2lkdGg6IFwiMzAlXCIsXG4gIG92ZXJmbG93OiBcImF1dG9cIixcbiAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy5zbX0gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG5cbiAgXCImID4gKlwiOiB7XG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNEZXRhaWxzQ2VsbCA9IHN0eWxlZC50ZCgoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogXCI3MCVcIixcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcbn0pKVxuIl19 */"), StyledDocValue = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn7"
} : {
  target: "ejycmjn7",
  label: "StyledDocValue"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocContainer = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn6"
} : {
  target: "ejycmjn6",
  label: "StyledDocContainer"
})(({
  theme: n
}) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: n.radii.default,
  border: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
  fontFamily: n.genericFonts.codeFont,
  fontSize: n.fontSizes.codeFontSize,
  fontWeight: n.fontWeights.code
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocHeader = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn5"
} : {
  target: "ejycmjn5",
  label: "StyledDocHeader"
})(({
  theme: n
}) => ({
  padding: `${n.spacing.sm} ${n.spacing.lg}`,
  backgroundColor: n.colors.bgMix,
  borderBottom: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
  // Add rounded corners to the top of the container to prevent the background
  // color from bleeding into the surrounding area.
  borderTopLeftRadius: n.radii.default,
  borderTopRightRadius: n.radii.default,
  fontSize: n.fontSizes.codeFontSize,
  overflow: "auto"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocString = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn4"
} : {
  target: "ejycmjn4",
  label: "StyledDocString"
})(({
  theme: n
}) => ({
  whiteSpace: "pre",
  overflow: "auto",
  maxHeight: "30.5rem",
  // The extra 0.5rem is to show a little of the overflowing line.
  padding: `${n.spacing.sm} ${n.spacing.lg}`,
  fontSize: n.fontSizes.codeFontSize,
  "&:not(:last-child)": {
    borderBottom: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersTable = /* @__PURE__ */ createStyled$1("table", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn3"
} : {
  target: "ejycmjn3",
  label: "StyledMembersTable"
})(({
  theme: n
}) => ({
  width: "100%",
  fontSize: n.fontSizes.codeFontSize,
  backgroundColor: n.colors.bgMix,
  tableLayout: "fixed",
  // Fix table to container's boundaries.
  borderCollapse: "collapse",
  // Add rounded corners to the bottom of the table to match container
  borderBottomLeftRadius: n.radii.default,
  borderBottomRightRadius: n.radii.default
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersRow = /* @__PURE__ */ createStyled$1("tr", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn2"
} : {
  target: "ejycmjn2",
  label: "StyledMembersRow"
})(({
  theme: n
}) => ({
  "&:not(:last-child)": {
    borderBottom: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersSummaryCell = /* @__PURE__ */ createStyled$1("td", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn1"
} : {
  target: "ejycmjn1",
  label: "StyledMembersSummaryCell"
})(({
  theme: n
}) => ({
  width: "30%",
  overflow: "auto",
  padding: `${n.spacing.sm} ${n.spacing.lg}`,
  "& > *": {
    marginRight: n.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersDetailsCell = /* @__PURE__ */ createStyled$1("td", process.env.NODE_ENV === "production" ? {
  target: "ejycmjn0"
} : {
  target: "ejycmjn0",
  label: "StyledMembersDetailsCell"
})(({
  theme: n
}) => ({
  width: "70%",
  overflow: "auto",
  padding: `${n.spacing.sm} ${n.spacing.lg}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function DocString({
  element: n
}) {
  const {
    name: t,
    type: g,
    value: d,
    docString: k,
    members: H
  } = n;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDocContainer, { className: "stHelp", "data-testid": "stHelp", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDocSummary, { children: [
      t ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocName, { "data-testid": "stHelpName", children: t }) : null,
      g ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocType, { "data-testid": "stHelpType", children: g }) : null,
      d ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocValue, { "data-testid": "stHelpValue", children: d }) : null
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocString, { "data-testid": "stHelpDoc", children: k || "No docs available" }),
    H.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMembersTable, { "data-testid": "stHelpMembersTable", children: H.map((AA) => /* @__PURE__ */ jsxRuntimeExports.jsx(Member, { member: AA }, AA.name)) }) : null
  ] });
}
function Member({
  member: n
}) {
  const {
    name: t,
    type: g,
    value: d,
    docString: k
  } = n;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMembersRow, { "data-testid": "stHelpMember", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMembersSummaryCell, { children: [
      t ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocName, { "data-testid": "stHelpMemberDocName", children: t }) : null,
      g ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocType, { "data-testid": "stHelpMemberDocType", children: g }) : null
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMembersDetailsCell, { children: d ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocValue, { "data-testid": "stHelpMemberDocValue", children: d }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocValue, { "data-testid": "stHelpMemberDocString", children: k || "No docs available" }) })
  ] });
}
const DocString$1 = memo$1(DocString);
function _EMOTION_STRINGIFIED_CSS_ERROR__$b() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledStackTraceRow = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv7"
} : {
  target: "e1dl0tyv7",
  label: "StyledStackTraceRow"
})(({
  theme: n
}) => ({
  marginTop: n.spacing.sm,
  "&:first-of-type": {
    marginTop: 0
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMessageType = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv6"
} : {
  target: "e1dl0tyv6",
  label: "StyledMessageType"
})(({
  theme: n
}) => ({
  fontWeight: n.fontWeights.bold
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStackTraceTitle = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv5"
} : {
  target: "e1dl0tyv5",
  label: "StyledStackTraceTitle"
})(({
  theme: n
}) => ({
  marginBottom: n.spacing.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStackTraceContent = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv4"
} : {
  target: "e1dl0tyv4",
  label: "StyledStackTraceContent"
})(process.env.NODE_ENV === "production" ? {
  name: "1flqko7",
  styles: "display:inline-block;min-width:100%"
} : {
  name: "1flqko7",
  styles: "display:inline-block;min-width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), StyledExceptionMessage = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv3"
} : {
  target: "e1dl0tyv3",
  label: "StyledExceptionMessage"
})(process.env.NODE_ENV === "production" ? {
  name: "10s3lzp",
  styles: "word-wrap:break-word"
} : {
  name: "10s3lzp",
  styles: "word-wrap:break-word/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), StyledExceptionLinks = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv2"
} : {
  target: "e1dl0tyv2",
  label: "StyledExceptionLinks"
})(({
  theme: n
}) => ({
  fontSize: n.fontSizes.sm,
  display: "flex",
  gap: n.spacing.md,
  justifyContent: "flex-end",
  underline: !0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledExceptionCopyButton = /* @__PURE__ */ createStyled$1("button", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv1"
} : {
  target: "e1dl0tyv1",
  label: "StyledExceptionCopyButton"
})(process.env.NODE_ENV === "production" ? {
  name: "x9hjea",
  styles: "all:unset;font:inherit;text-decoration:underline"
} : {
  name: "x9hjea",
  styles: "all:unset;font:inherit;text-decoration:underline/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), StyledExceptionWrapper = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv0"
} : {
  target: "e1dl0tyv0",
  label: "StyledExceptionWrapper"
})(({
  theme: n
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: n.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
loglevelExports$1.getLogger("ExceptionElement");
function isNonEmptyString(n) {
  return notNullOrUndefined(n) && n !== "";
}
function ExceptionMessage({
  type: n,
  message: t,
  messageIsMarkdown: g
}) {
  if (g) {
    let d = t ?? "";
    return n.length !== 0 && (d = `**${n}**: ${d}`), /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: d, allowHTML: !1 });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMessageType, { children: n }),
    n.length !== 0 && ": ",
    isNonEmptyString(t) ? t : null
  ] });
}
function StackTrace({
  stackTrace: n
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTraceTitle, { children: "Traceback:" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTrace, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTraceContent, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCode, { wrapLines: !1, children: n.map((t, g) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      StyledStackTraceRow,
      {
        "data-testid": "stExceptionTraceRow",
        children: t
      },
      g
    )) }) }) })
  ] });
}
function ExceptionElement({
  element: n
}) {
  const t = `${n.type}: ${n.message}`, g = `${t}

${n.stackTrace?.join(`
`)}`, d = `https://www.google.com/search?q=${encodeURIComponent(t)}`, k = `https://chatgpt.com/?q=${encodeURIComponent(g)}`, {
    copyToClipboard: H
  } = useCopyToClipboard(), AA = useCallback(() => {
    H(g);
  }, [H, g]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stException", "data-testid": "stException", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertContainer, { kind: n.isWarning ? Kind.WARNING : Kind.ERROR, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledExceptionWrapper, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledExceptionMessage, { "data-testid": "stExceptionMessage", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ExceptionMessage, { type: n.type, message: n.message, messageIsMarkdown: n.messageIsMarkdown }) }),
    n.stackTrace && n.stackTrace.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(StackTrace, { stackTrace: n.stackTrace }) : null,
    isLocalhost() && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledExceptionLinks, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledExceptionCopyButton, { onClick: AA, children: "Copy" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: d, target: "_blank", rel: "noopener noreferrer", children: "Ask Google" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: k, target: "_blank", rel: "noopener noreferrer", children: "Ask ChatGPT" })
    ] })
  ] }) }) });
}
const ExceptionElement$1 = memo$1(ExceptionElement);
var Space_Separator = /[\u1680\u2000-\u200A\u202F\u205F\u3000]/, ID_Start = /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]/, ID_Continue = /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/, unicode = {
  Space_Separator,
  ID_Start,
  ID_Continue
}, util$1 = {
  isSpaceSeparator(n) {
    return typeof n == "string" && unicode.Space_Separator.test(n);
  },
  isIdStartChar(n) {
    return typeof n == "string" && (n >= "a" && n <= "z" || n >= "A" && n <= "Z" || n === "$" || n === "_" || unicode.ID_Start.test(n));
  },
  isIdContinueChar(n) {
    return typeof n == "string" && (n >= "a" && n <= "z" || n >= "A" && n <= "Z" || n >= "0" && n <= "9" || n === "$" || n === "_" || n === "‌" || n === "‍" || unicode.ID_Continue.test(n));
  },
  isDigit(n) {
    return typeof n == "string" && /[0-9]/.test(n);
  },
  isHexDigit(n) {
    return typeof n == "string" && /[0-9A-Fa-f]/.test(n);
  }
};
let source$3, parseState, stack$1, pos, line$3, column, token, key$1, root$2;
var parse$7 = function n(t, g) {
  source$3 = String(t), parseState = "start", stack$1 = [], pos = 0, line$3 = 1, column = 0, token = void 0, key$1 = void 0, root$2 = void 0;
  do
    token = lex$2(), parseStates[parseState]();
  while (token.type !== "eof");
  return typeof g == "function" ? internalize({ "": root$2 }, "", g) : root$2;
};
function internalize(n, t, g) {
  const d = n[t];
  if (d != null && typeof d == "object")
    if (Array.isArray(d))
      for (let k = 0; k < d.length; k++) {
        const H = String(k), AA = internalize(d, H, g);
        AA === void 0 ? delete d[H] : Object.defineProperty(d, H, {
          value: AA,
          writable: !0,
          enumerable: !0,
          configurable: !0
        });
      }
    else
      for (const k in d) {
        const H = internalize(d, k, g);
        H === void 0 ? delete d[k] : Object.defineProperty(d, k, {
          value: H,
          writable: !0,
          enumerable: !0,
          configurable: !0
        });
      }
  return g.call(n, t, d);
}
let lexState, buffer, doubleQuote, sign$2, c$2;
function lex$2() {
  for (lexState = "default", buffer = "", doubleQuote = !1, sign$2 = 1; ; ) {
    c$2 = peek$3();
    const n = lexStates[lexState]();
    if (n)
      return n;
  }
}
function peek$3() {
  if (source$3[pos])
    return String.fromCodePoint(source$3.codePointAt(pos));
}
function read$1() {
  const n = peek$3();
  return n === `
` ? (line$3++, column = 0) : n ? column += n.length : column++, n && (pos += n.length), n;
}
const lexStates = {
  default() {
    switch (c$2) {
      case "	":
      case "\v":
      case "\f":
      case " ":
      case " ":
      case "\uFEFF":
      case `
`:
      case "\r":
      case "\u2028":
      case "\u2029":
        read$1();
        return;
      case "/":
        read$1(), lexState = "comment";
        return;
      case void 0:
        return read$1(), newToken("eof");
    }
    if (util$1.isSpaceSeparator(c$2)) {
      read$1();
      return;
    }
    return lexStates[parseState]();
  },
  comment() {
    switch (c$2) {
      case "*":
        read$1(), lexState = "multiLineComment";
        return;
      case "/":
        read$1(), lexState = "singleLineComment";
        return;
    }
    throw invalidChar(read$1());
  },
  multiLineComment() {
    switch (c$2) {
      case "*":
        read$1(), lexState = "multiLineCommentAsterisk";
        return;
      case void 0:
        throw invalidChar(read$1());
    }
    read$1();
  },
  multiLineCommentAsterisk() {
    switch (c$2) {
      case "*":
        read$1();
        return;
      case "/":
        read$1(), lexState = "default";
        return;
      case void 0:
        throw invalidChar(read$1());
    }
    read$1(), lexState = "multiLineComment";
  },
  singleLineComment() {
    switch (c$2) {
      case `
`:
      case "\r":
      case "\u2028":
      case "\u2029":
        read$1(), lexState = "default";
        return;
      case void 0:
        return read$1(), newToken("eof");
    }
    read$1();
  },
  value() {
    switch (c$2) {
      case "{":
      case "[":
        return newToken("punctuator", read$1());
      case "n":
        return read$1(), literal("ull"), newToken("null", null);
      case "t":
        return read$1(), literal("rue"), newToken("boolean", !0);
      case "f":
        return read$1(), literal("alse"), newToken("boolean", !1);
      case "-":
      case "+":
        read$1() === "-" && (sign$2 = -1), lexState = "sign";
        return;
      case ".":
        buffer = read$1(), lexState = "decimalPointLeading";
        return;
      case "0":
        buffer = read$1(), lexState = "zero";
        return;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        buffer = read$1(), lexState = "decimalInteger";
        return;
      case "I":
        return read$1(), literal("nfinity"), newToken("numeric", 1 / 0);
      case "N":
        return read$1(), literal("aN"), newToken("numeric", NaN);
      case '"':
      case "'":
        doubleQuote = read$1() === '"', buffer = "", lexState = "string";
        return;
    }
    throw invalidChar(read$1());
  },
  identifierNameStartEscape() {
    if (c$2 !== "u")
      throw invalidChar(read$1());
    read$1();
    const n = unicodeEscape();
    switch (n) {
      case "$":
      case "_":
        break;
      default:
        if (!util$1.isIdStartChar(n))
          throw invalidIdentifier();
        break;
    }
    buffer += n, lexState = "identifierName";
  },
  identifierName() {
    switch (c$2) {
      case "$":
      case "_":
      case "‌":
      case "‍":
        buffer += read$1();
        return;
      case "\\":
        read$1(), lexState = "identifierNameEscape";
        return;
    }
    if (util$1.isIdContinueChar(c$2)) {
      buffer += read$1();
      return;
    }
    return newToken("identifier", buffer);
  },
  identifierNameEscape() {
    if (c$2 !== "u")
      throw invalidChar(read$1());
    read$1();
    const n = unicodeEscape();
    switch (n) {
      case "$":
      case "_":
      case "‌":
      case "‍":
        break;
      default:
        if (!util$1.isIdContinueChar(n))
          throw invalidIdentifier();
        break;
    }
    buffer += n, lexState = "identifierName";
  },
  sign() {
    switch (c$2) {
      case ".":
        buffer = read$1(), lexState = "decimalPointLeading";
        return;
      case "0":
        buffer = read$1(), lexState = "zero";
        return;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        buffer = read$1(), lexState = "decimalInteger";
        return;
      case "I":
        return read$1(), literal("nfinity"), newToken("numeric", sign$2 * (1 / 0));
      case "N":
        return read$1(), literal("aN"), newToken("numeric", NaN);
    }
    throw invalidChar(read$1());
  },
  zero() {
    switch (c$2) {
      case ".":
        buffer += read$1(), lexState = "decimalPoint";
        return;
      case "e":
      case "E":
        buffer += read$1(), lexState = "decimalExponent";
        return;
      case "x":
      case "X":
        buffer += read$1(), lexState = "hexadecimal";
        return;
    }
    return newToken("numeric", sign$2 * 0);
  },
  decimalInteger() {
    switch (c$2) {
      case ".":
        buffer += read$1(), lexState = "decimalPoint";
        return;
      case "e":
      case "E":
        buffer += read$1(), lexState = "decimalExponent";
        return;
    }
    if (util$1.isDigit(c$2)) {
      buffer += read$1();
      return;
    }
    return newToken("numeric", sign$2 * Number(buffer));
  },
  decimalPointLeading() {
    if (util$1.isDigit(c$2)) {
      buffer += read$1(), lexState = "decimalFraction";
      return;
    }
    throw invalidChar(read$1());
  },
  decimalPoint() {
    switch (c$2) {
      case "e":
      case "E":
        buffer += read$1(), lexState = "decimalExponent";
        return;
    }
    if (util$1.isDigit(c$2)) {
      buffer += read$1(), lexState = "decimalFraction";
      return;
    }
    return newToken("numeric", sign$2 * Number(buffer));
  },
  decimalFraction() {
    switch (c$2) {
      case "e":
      case "E":
        buffer += read$1(), lexState = "decimalExponent";
        return;
    }
    if (util$1.isDigit(c$2)) {
      buffer += read$1();
      return;
    }
    return newToken("numeric", sign$2 * Number(buffer));
  },
  decimalExponent() {
    switch (c$2) {
      case "+":
      case "-":
        buffer += read$1(), lexState = "decimalExponentSign";
        return;
    }
    if (util$1.isDigit(c$2)) {
      buffer += read$1(), lexState = "decimalExponentInteger";
      return;
    }
    throw invalidChar(read$1());
  },
  decimalExponentSign() {
    if (util$1.isDigit(c$2)) {
      buffer += read$1(), lexState = "decimalExponentInteger";
      return;
    }
    throw invalidChar(read$1());
  },
  decimalExponentInteger() {
    if (util$1.isDigit(c$2)) {
      buffer += read$1();
      return;
    }
    return newToken("numeric", sign$2 * Number(buffer));
  },
  hexadecimal() {
    if (util$1.isHexDigit(c$2)) {
      buffer += read$1(), lexState = "hexadecimalInteger";
      return;
    }
    throw invalidChar(read$1());
  },
  hexadecimalInteger() {
    if (util$1.isHexDigit(c$2)) {
      buffer += read$1();
      return;
    }
    return newToken("numeric", sign$2 * Number(buffer));
  },
  string() {
    switch (c$2) {
      case "\\":
        read$1(), buffer += escape$1();
        return;
      case '"':
        if (doubleQuote)
          return read$1(), newToken("string", buffer);
        buffer += read$1();
        return;
      case "'":
        if (!doubleQuote)
          return read$1(), newToken("string", buffer);
        buffer += read$1();
        return;
      case `
`:
      case "\r":
        throw invalidChar(read$1());
      case "\u2028":
      case "\u2029":
        separatorChar(c$2);
        break;
      case void 0:
        throw invalidChar(read$1());
    }
    buffer += read$1();
  },
  start() {
    switch (c$2) {
      case "{":
      case "[":
        return newToken("punctuator", read$1());
    }
    lexState = "value";
  },
  beforePropertyName() {
    switch (c$2) {
      case "$":
      case "_":
        buffer = read$1(), lexState = "identifierName";
        return;
      case "\\":
        read$1(), lexState = "identifierNameStartEscape";
        return;
      case "}":
        return newToken("punctuator", read$1());
      case '"':
      case "'":
        doubleQuote = read$1() === '"', lexState = "string";
        return;
    }
    if (util$1.isIdStartChar(c$2)) {
      buffer += read$1(), lexState = "identifierName";
      return;
    }
    throw invalidChar(read$1());
  },
  afterPropertyName() {
    if (c$2 === ":")
      return newToken("punctuator", read$1());
    throw invalidChar(read$1());
  },
  beforePropertyValue() {
    lexState = "value";
  },
  afterPropertyValue() {
    switch (c$2) {
      case ",":
      case "}":
        return newToken("punctuator", read$1());
    }
    throw invalidChar(read$1());
  },
  beforeArrayValue() {
    if (c$2 === "]")
      return newToken("punctuator", read$1());
    lexState = "value";
  },
  afterArrayValue() {
    switch (c$2) {
      case ",":
      case "]":
        return newToken("punctuator", read$1());
    }
    throw invalidChar(read$1());
  },
  end() {
    throw invalidChar(read$1());
  }
};
function newToken(n, t) {
  return {
    type: n,
    value: t,
    line: line$3,
    column
  };
}
function literal(n) {
  for (const t of n) {
    if (peek$3() !== t)
      throw invalidChar(read$1());
    read$1();
  }
}
function escape$1() {
  switch (peek$3()) {
    case "b":
      return read$1(), "\b";
    case "f":
      return read$1(), "\f";
    case "n":
      return read$1(), `
`;
    case "r":
      return read$1(), "\r";
    case "t":
      return read$1(), "	";
    case "v":
      return read$1(), "\v";
    case "0":
      if (read$1(), util$1.isDigit(peek$3()))
        throw invalidChar(read$1());
      return "\0";
    case "x":
      return read$1(), hexEscape();
    case "u":
      return read$1(), unicodeEscape();
    case `
`:
    case "\u2028":
    case "\u2029":
      return read$1(), "";
    case "\r":
      return read$1(), peek$3() === `
` && read$1(), "";
    case "1":
    case "2":
    case "3":
    case "4":
    case "5":
    case "6":
    case "7":
    case "8":
    case "9":
      throw invalidChar(read$1());
    case void 0:
      throw invalidChar(read$1());
  }
  return read$1();
}
function hexEscape() {
  let n = "", t = peek$3();
  if (!util$1.isHexDigit(t) || (n += read$1(), t = peek$3(), !util$1.isHexDigit(t)))
    throw invalidChar(read$1());
  return n += read$1(), String.fromCodePoint(parseInt(n, 16));
}
function unicodeEscape() {
  let n = "", t = 4;
  for (; t-- > 0; ) {
    const g = peek$3();
    if (!util$1.isHexDigit(g))
      throw invalidChar(read$1());
    n += read$1();
  }
  return String.fromCodePoint(parseInt(n, 16));
}
const parseStates = {
  start() {
    if (token.type === "eof")
      throw invalidEOF();
    push();
  },
  beforePropertyName() {
    switch (token.type) {
      case "identifier":
      case "string":
        key$1 = token.value, parseState = "afterPropertyName";
        return;
      case "punctuator":
        pop();
        return;
      case "eof":
        throw invalidEOF();
    }
  },
  afterPropertyName() {
    if (token.type === "eof")
      throw invalidEOF();
    parseState = "beforePropertyValue";
  },
  beforePropertyValue() {
    if (token.type === "eof")
      throw invalidEOF();
    push();
  },
  beforeArrayValue() {
    if (token.type === "eof")
      throw invalidEOF();
    if (token.type === "punctuator" && token.value === "]") {
      pop();
      return;
    }
    push();
  },
  afterPropertyValue() {
    if (token.type === "eof")
      throw invalidEOF();
    switch (token.value) {
      case ",":
        parseState = "beforePropertyName";
        return;
      case "}":
        pop();
    }
  },
  afterArrayValue() {
    if (token.type === "eof")
      throw invalidEOF();
    switch (token.value) {
      case ",":
        parseState = "beforeArrayValue";
        return;
      case "]":
        pop();
    }
  },
  end() {
  }
};
function push() {
  let n;
  switch (token.type) {
    case "punctuator":
      switch (token.value) {
        case "{":
          n = {};
          break;
        case "[":
          n = [];
          break;
      }
      break;
    case "null":
    case "boolean":
    case "numeric":
    case "string":
      n = token.value;
      break;
  }
  if (root$2 === void 0)
    root$2 = n;
  else {
    const t = stack$1[stack$1.length - 1];
    Array.isArray(t) ? t.push(n) : Object.defineProperty(t, key$1, {
      value: n,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  }
  if (n !== null && typeof n == "object")
    stack$1.push(n), Array.isArray(n) ? parseState = "beforeArrayValue" : parseState = "beforePropertyName";
  else {
    const t = stack$1[stack$1.length - 1];
    t == null ? parseState = "end" : Array.isArray(t) ? parseState = "afterArrayValue" : parseState = "afterPropertyValue";
  }
}
function pop() {
  stack$1.pop();
  const n = stack$1[stack$1.length - 1];
  n == null ? parseState = "end" : Array.isArray(n) ? parseState = "afterArrayValue" : parseState = "afterPropertyValue";
}
function invalidChar(n) {
  return syntaxError(n === void 0 ? `JSON5: invalid end of input at ${line$3}:${column}` : `JSON5: invalid character '${formatChar(n)}' at ${line$3}:${column}`);
}
function invalidEOF() {
  return syntaxError(`JSON5: invalid end of input at ${line$3}:${column}`);
}
function invalidIdentifier() {
  return column -= 5, syntaxError(`JSON5: invalid identifier character at ${line$3}:${column}`);
}
function separatorChar(n) {
  console.warn(`JSON5: '${formatChar(n)}' in strings is not valid ECMAScript; consider escaping`);
}
function formatChar(n) {
  const t = {
    "'": "\\'",
    '"': '\\"',
    "\\": "\\\\",
    "\b": "\\b",
    "\f": "\\f",
    "\n": "\\n",
    "\r": "\\r",
    "	": "\\t",
    "\v": "\\v",
    "\0": "\\0",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
  };
  if (t[n])
    return t[n];
  if (n < " ") {
    const g = n.charCodeAt(0).toString(16);
    return "\\x" + ("00" + g).substring(g.length);
  }
  return n;
}
function syntaxError(n) {
  const t = new SyntaxError(n);
  return t.lineNumber = line$3, t.columnNumber = column, t;
}
var stringify$3 = function n(t, g, d) {
  const k = [];
  let H = "", AA, gA, IA = "", CA;
  if (g != null && typeof g == "object" && !Array.isArray(g) && (d = g.space, CA = g.quote, g = g.replacer), typeof g == "function")
    gA = g;
  else if (Array.isArray(g)) {
    AA = [];
    for (const oA of g) {
      let EA;
      typeof oA == "string" ? EA = oA : (typeof oA == "number" || oA instanceof String || oA instanceof Number) && (EA = String(oA)), EA !== void 0 && AA.indexOf(EA) < 0 && AA.push(EA);
    }
  }
  return d instanceof Number ? d = Number(d) : d instanceof String && (d = String(d)), typeof d == "number" ? d > 0 && (d = Math.min(10, Math.floor(d)), IA = "          ".substr(0, d)) : typeof d == "string" && (IA = d.substr(0, 10)), BA("", { "": t });
  function BA(oA, EA) {
    let aA = EA[oA];
    switch (aA != null && (typeof aA.toJSON5 == "function" ? aA = aA.toJSON5(oA) : typeof aA.toJSON == "function" && (aA = aA.toJSON(oA))), gA && (aA = gA.call(EA, oA, aA)), aA instanceof Number ? aA = Number(aA) : aA instanceof String ? aA = String(aA) : aA instanceof Boolean && (aA = aA.valueOf()), aA) {
      case null:
        return "null";
      case !0:
        return "true";
      case !1:
        return "false";
    }
    if (typeof aA == "string")
      return eA(aA);
    if (typeof aA == "number")
      return String(aA);
    if (typeof aA == "object")
      return Array.isArray(aA) ? tA(aA) : iA(aA);
  }
  function eA(oA) {
    const EA = {
      "'": 0.1,
      '"': 0.2
    }, aA = {
      "'": "\\'",
      '"': '\\"',
      "\\": "\\\\",
      "\b": "\\b",
      "\f": "\\f",
      "\n": "\\n",
      "\r": "\\r",
      "	": "\\t",
      "\v": "\\v",
      "\0": "\\0",
      "\u2028": "\\u2028",
      "\u2029": "\\u2029"
    };
    let nA = "";
    for (let cA = 0; cA < oA.length; cA++) {
      const sA = oA[cA];
      switch (sA) {
        case "'":
        case '"':
          EA[sA]++, nA += sA;
          continue;
        case "\0":
          if (util$1.isDigit(oA[cA + 1])) {
            nA += "\\x00";
            continue;
          }
      }
      if (aA[sA]) {
        nA += aA[sA];
        continue;
      }
      if (sA < " ") {
        let rA = sA.charCodeAt(0).toString(16);
        nA += "\\x" + ("00" + rA).substring(rA.length);
        continue;
      }
      nA += sA;
    }
    const lA = CA || Object.keys(EA).reduce((cA, sA) => EA[cA] < EA[sA] ? cA : sA);
    return nA = nA.replace(new RegExp(lA, "g"), aA[lA]), lA + nA + lA;
  }
  function iA(oA) {
    if (k.indexOf(oA) >= 0)
      throw TypeError("Converting circular structure to JSON5");
    k.push(oA);
    let EA = H;
    H = H + IA;
    let aA = AA || Object.keys(oA), nA = [];
    for (const cA of aA) {
      const sA = BA(cA, oA);
      if (sA !== void 0) {
        let rA = QA(cA) + ":";
        IA !== "" && (rA += " "), rA += sA, nA.push(rA);
      }
    }
    let lA;
    if (nA.length === 0)
      lA = "{}";
    else {
      let cA;
      if (IA === "")
        cA = nA.join(","), lA = "{" + cA + "}";
      else {
        let sA = `,
` + H;
        cA = nA.join(sA), lA = `{
` + H + cA + `,
` + EA + "}";
      }
    }
    return k.pop(), H = EA, lA;
  }
  function QA(oA) {
    if (oA.length === 0)
      return eA(oA);
    const EA = String.fromCodePoint(oA.codePointAt(0));
    if (!util$1.isIdStartChar(EA))
      return eA(oA);
    for (let aA = EA.length; aA < oA.length; aA++)
      if (!util$1.isIdContinueChar(String.fromCodePoint(oA.codePointAt(aA))))
        return eA(oA);
    return oA;
  }
  function tA(oA) {
    if (k.indexOf(oA) >= 0)
      throw TypeError("Converting circular structure to JSON5");
    k.push(oA);
    let EA = H;
    H = H + IA;
    let aA = [];
    for (let lA = 0; lA < oA.length; lA++) {
      const cA = BA(String(lA), oA);
      aA.push(cA !== void 0 ? cA : "null");
    }
    let nA;
    if (aA.length === 0)
      nA = "[]";
    else if (IA === "")
      nA = "[" + aA.join(",") + "]";
    else {
      let lA = `,
` + H, cA = aA.join(lA);
      nA = `[
` + H + cA + `,
` + EA + "]";
    }
    return k.pop(), H = EA, nA;
  }
};
const JSON5 = {
  parse: parse$7,
  stringify: stringify$3
};
var lib$1 = JSON5, main$2 = { exports: {} }, main$1 = main$2.exports, hasRequiredMain;
function requireMain() {
  return hasRequiredMain || (hasRequiredMain = 1, (function(n, t) {
    (function(g, d) {
      n.exports = d(React__default);
    })(main$1, (function(g) {
      return (function(d) {
        var k = {};
        function H(AA) {
          if (k[AA]) return k[AA].exports;
          var gA = k[AA] = { i: AA, l: !1, exports: {} };
          return d[AA].call(gA.exports, gA, gA.exports, H), gA.l = !0, gA.exports;
        }
        return H.m = d, H.c = k, H.d = function(AA, gA, IA) {
          H.o(AA, gA) || Object.defineProperty(AA, gA, { enumerable: !0, get: IA });
        }, H.r = function(AA) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(AA, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(AA, "__esModule", { value: !0 });
        }, H.t = function(AA, gA) {
          if (1 & gA && (AA = H(AA)), 8 & gA || 4 & gA && typeof AA == "object" && AA && AA.__esModule) return AA;
          var IA = /* @__PURE__ */ Object.create(null);
          if (H.r(IA), Object.defineProperty(IA, "default", { enumerable: !0, value: AA }), 2 & gA && typeof AA != "string") for (var CA in AA) H.d(IA, CA, (function(BA) {
            return AA[BA];
          }).bind(null, CA));
          return IA;
        }, H.n = function(AA) {
          var gA = AA && AA.__esModule ? function() {
            return AA.default;
          } : function() {
            return AA;
          };
          return H.d(gA, "a", gA), gA;
        }, H.o = function(AA, gA) {
          return Object.prototype.hasOwnProperty.call(AA, gA);
        }, H.p = "", H(H.s = 48);
      })([function(d, k) {
        d.exports = g;
      }, function(d, k) {
        var H = d.exports = { version: "2.6.12" };
        typeof __e == "number" && (__e = H);
      }, function(d, k, H) {
        var AA = H(26)("wks"), gA = H(17), IA = H(3).Symbol, CA = typeof IA == "function";
        (d.exports = function(BA) {
          return AA[BA] || (AA[BA] = CA && IA[BA] || (CA ? IA : gA)("Symbol." + BA));
        }).store = AA;
      }, function(d, k) {
        var H = d.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
        typeof __g == "number" && (__g = H);
      }, function(d, k, H) {
        d.exports = !H(8)((function() {
          return Object.defineProperty({}, "a", { get: function() {
            return 7;
          } }).a != 7;
        }));
      }, function(d, k) {
        var H = {}.hasOwnProperty;
        d.exports = function(AA, gA) {
          return H.call(AA, gA);
        };
      }, function(d, k, H) {
        var AA = H(7), gA = H(16);
        d.exports = H(4) ? function(IA, CA, BA) {
          return AA.f(IA, CA, gA(1, BA));
        } : function(IA, CA, BA) {
          return IA[CA] = BA, IA;
        };
      }, function(d, k, H) {
        var AA = H(10), gA = H(35), IA = H(23), CA = Object.defineProperty;
        k.f = H(4) ? Object.defineProperty : function(BA, eA, iA) {
          if (AA(BA), eA = IA(eA, !0), AA(iA), gA) try {
            return CA(BA, eA, iA);
          } catch {
          }
          if ("get" in iA || "set" in iA) throw TypeError("Accessors not supported!");
          return "value" in iA && (BA[eA] = iA.value), BA;
        };
      }, function(d, k) {
        d.exports = function(H) {
          try {
            return !!H();
          } catch {
            return !0;
          }
        };
      }, function(d, k, H) {
        var AA = H(40), gA = H(22);
        d.exports = function(IA) {
          return AA(gA(IA));
        };
      }, function(d, k, H) {
        var AA = H(11);
        d.exports = function(gA) {
          if (!AA(gA)) throw TypeError(gA + " is not an object!");
          return gA;
        };
      }, function(d, k) {
        d.exports = function(H) {
          return typeof H == "object" ? H !== null : typeof H == "function";
        };
      }, function(d, k) {
        d.exports = {};
      }, function(d, k, H) {
        var AA = H(39), gA = H(27);
        d.exports = Object.keys || function(IA) {
          return AA(IA, gA);
        };
      }, function(d, k) {
        d.exports = !0;
      }, function(d, k, H) {
        var AA = H(3), gA = H(1), IA = H(53), CA = H(6), BA = H(5), eA = function(iA, QA, tA) {
          var oA, EA, aA, nA = iA & eA.F, lA = iA & eA.G, cA = iA & eA.S, sA = iA & eA.P, rA = iA & eA.B, uA = iA & eA.W, hA = lA ? gA : gA[QA] || (gA[QA] = {}), dA = hA.prototype, GA = lA ? AA : cA ? AA[QA] : (AA[QA] || {}).prototype;
          for (oA in lA && (tA = QA), tA) (EA = !nA && GA && GA[oA] !== void 0) && BA(hA, oA) || (aA = EA ? GA[oA] : tA[oA], hA[oA] = lA && typeof GA[oA] != "function" ? tA[oA] : rA && EA ? IA(aA, AA) : uA && GA[oA] == aA ? (function(DA) {
            var wA = function(bA, yA, pA) {
              if (this instanceof DA) {
                switch (arguments.length) {
                  case 0:
                    return new DA();
                  case 1:
                    return new DA(bA);
                  case 2:
                    return new DA(bA, yA);
                }
                return new DA(bA, yA, pA);
              }
              return DA.apply(this, arguments);
            };
            return wA.prototype = DA.prototype, wA;
          })(aA) : sA && typeof aA == "function" ? IA(Function.call, aA) : aA, sA && ((hA.virtual || (hA.virtual = {}))[oA] = aA, iA & eA.R && dA && !dA[oA] && CA(dA, oA, aA)));
        };
        eA.F = 1, eA.G = 2, eA.S = 4, eA.P = 8, eA.B = 16, eA.W = 32, eA.U = 64, eA.R = 128, d.exports = eA;
      }, function(d, k) {
        d.exports = function(H, AA) {
          return { enumerable: !(1 & H), configurable: !(2 & H), writable: !(4 & H), value: AA };
        };
      }, function(d, k) {
        var H = 0, AA = Math.random();
        d.exports = function(gA) {
          return "Symbol(".concat(gA === void 0 ? "" : gA, ")_", (++H + AA).toString(36));
        };
      }, function(d, k, H) {
        var AA = H(22);
        d.exports = function(gA) {
          return Object(AA(gA));
        };
      }, function(d, k) {
        k.f = {}.propertyIsEnumerable;
      }, function(d, k, H) {
        var AA = H(52)(!0);
        H(34)(String, "String", (function(gA) {
          this._t = String(gA), this._i = 0;
        }), (function() {
          var gA, IA = this._t, CA = this._i;
          return CA >= IA.length ? { value: void 0, done: !0 } : (gA = AA(IA, CA), this._i += gA.length, { value: gA, done: !1 });
        }));
      }, function(d, k) {
        var H = Math.ceil, AA = Math.floor;
        d.exports = function(gA) {
          return isNaN(gA = +gA) ? 0 : (gA > 0 ? AA : H)(gA);
        };
      }, function(d, k) {
        d.exports = function(H) {
          if (H == null) throw TypeError("Can't call method on  " + H);
          return H;
        };
      }, function(d, k, H) {
        var AA = H(11);
        d.exports = function(gA, IA) {
          if (!AA(gA)) return gA;
          var CA, BA;
          if (IA && typeof (CA = gA.toString) == "function" && !AA(BA = CA.call(gA)) || typeof (CA = gA.valueOf) == "function" && !AA(BA = CA.call(gA)) || !IA && typeof (CA = gA.toString) == "function" && !AA(BA = CA.call(gA))) return BA;
          throw TypeError("Can't convert object to primitive value");
        };
      }, function(d, k) {
        var H = {}.toString;
        d.exports = function(AA) {
          return H.call(AA).slice(8, -1);
        };
      }, function(d, k, H) {
        var AA = H(26)("keys"), gA = H(17);
        d.exports = function(IA) {
          return AA[IA] || (AA[IA] = gA(IA));
        };
      }, function(d, k, H) {
        var AA = H(1), gA = H(3), IA = gA["__core-js_shared__"] || (gA["__core-js_shared__"] = {});
        (d.exports = function(CA, BA) {
          return IA[CA] || (IA[CA] = BA !== void 0 ? BA : {});
        })("versions", []).push({ version: AA.version, mode: H(14) ? "pure" : "global", copyright: "© 2020 Denis Pushkarev (zloirock.ru)" });
      }, function(d, k) {
        d.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
      }, function(d, k, H) {
        var AA = H(7).f, gA = H(5), IA = H(2)("toStringTag");
        d.exports = function(CA, BA, eA) {
          CA && !gA(CA = eA ? CA : CA.prototype, IA) && AA(CA, IA, { configurable: !0, value: BA });
        };
      }, function(d, k, H) {
        H(62);
        for (var AA = H(3), gA = H(6), IA = H(12), CA = H(2)("toStringTag"), BA = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), eA = 0; eA < BA.length; eA++) {
          var iA = BA[eA], QA = AA[iA], tA = QA && QA.prototype;
          tA && !tA[CA] && gA(tA, CA, iA), IA[iA] = IA.Array;
        }
      }, function(d, k, H) {
        k.f = H(2);
      }, function(d, k, H) {
        var AA = H(3), gA = H(1), IA = H(14), CA = H(30), BA = H(7).f;
        d.exports = function(eA) {
          var iA = gA.Symbol || (gA.Symbol = IA ? {} : AA.Symbol || {});
          eA.charAt(0) == "_" || eA in iA || BA(iA, eA, { value: CA.f(eA) });
        };
      }, function(d, k) {
        k.f = Object.getOwnPropertySymbols;
      }, function(d, k) {
        d.exports = function(H, AA, gA) {
          return Math.min(Math.max(H, AA), gA);
        };
      }, function(d, k, H) {
        var AA = H(14), gA = H(15), IA = H(37), CA = H(6), BA = H(12), eA = H(55), iA = H(28), QA = H(61), tA = H(2)("iterator"), oA = !([].keys && "next" in [].keys()), EA = function() {
          return this;
        };
        d.exports = function(aA, nA, lA, cA, sA, rA, uA) {
          eA(lA, nA, cA);
          var hA, dA, GA, DA = function(NA) {
            if (!oA && NA in pA) return pA[NA];
            switch (NA) {
              case "keys":
              case "values":
                return function() {
                  return new lA(this, NA);
                };
            }
            return function() {
              return new lA(this, NA);
            };
          }, wA = nA + " Iterator", bA = sA == "values", yA = !1, pA = aA.prototype, MA = pA[tA] || pA["@@iterator"] || sA && pA[sA], LA = MA || DA(sA), xA = sA ? bA ? DA("entries") : LA : void 0, TA = nA == "Array" && pA.entries || MA;
          if (TA && (GA = QA(TA.call(new aA()))) !== Object.prototype && GA.next && (iA(GA, wA, !0), AA || typeof GA[tA] == "function" || CA(GA, tA, EA)), bA && MA && MA.name !== "values" && (yA = !0, LA = function() {
            return MA.call(this);
          }), AA && !uA || !oA && !yA && pA[tA] || CA(pA, tA, LA), BA[nA] = LA, BA[wA] = EA, sA) if (hA = { values: bA ? LA : DA("values"), keys: rA ? LA : DA("keys"), entries: xA }, uA) for (dA in hA) dA in pA || IA(pA, dA, hA[dA]);
          else gA(gA.P + gA.F * (oA || yA), nA, hA);
          return hA;
        };
      }, function(d, k, H) {
        d.exports = !H(4) && !H(8)((function() {
          return Object.defineProperty(H(36)("div"), "a", { get: function() {
            return 7;
          } }).a != 7;
        }));
      }, function(d, k, H) {
        var AA = H(11), gA = H(3).document, IA = AA(gA) && AA(gA.createElement);
        d.exports = function(CA) {
          return IA ? gA.createElement(CA) : {};
        };
      }, function(d, k, H) {
        d.exports = H(6);
      }, function(d, k, H) {
        var AA = H(10), gA = H(56), IA = H(27), CA = H(25)("IE_PROTO"), BA = function() {
        }, eA = function() {
          var iA, QA = H(36)("iframe"), tA = IA.length;
          for (QA.style.display = "none", H(60).appendChild(QA), QA.src = "javascript:", (iA = QA.contentWindow.document).open(), iA.write("<script>document.F=Object<\/script>"), iA.close(), eA = iA.F; tA--; ) delete eA.prototype[IA[tA]];
          return eA();
        };
        d.exports = Object.create || function(iA, QA) {
          var tA;
          return iA !== null ? (BA.prototype = AA(iA), tA = new BA(), BA.prototype = null, tA[CA] = iA) : tA = eA(), QA === void 0 ? tA : gA(tA, QA);
        };
      }, function(d, k, H) {
        var AA = H(5), gA = H(9), IA = H(57)(!1), CA = H(25)("IE_PROTO");
        d.exports = function(BA, eA) {
          var iA, QA = gA(BA), tA = 0, oA = [];
          for (iA in QA) iA != CA && AA(QA, iA) && oA.push(iA);
          for (; eA.length > tA; ) AA(QA, iA = eA[tA++]) && (~IA(oA, iA) || oA.push(iA));
          return oA;
        };
      }, function(d, k, H) {
        var AA = H(24);
        d.exports = Object("z").propertyIsEnumerable(0) ? Object : function(gA) {
          return AA(gA) == "String" ? gA.split("") : Object(gA);
        };
      }, function(d, k, H) {
        var AA = H(39), gA = H(27).concat("length", "prototype");
        k.f = Object.getOwnPropertyNames || function(IA) {
          return AA(IA, gA);
        };
      }, function(d, k, H) {
        var AA = H(24), gA = H(2)("toStringTag"), IA = AA(/* @__PURE__ */ (function() {
          return arguments;
        })()) == "Arguments";
        d.exports = function(CA) {
          var BA, eA, iA;
          return CA === void 0 ? "Undefined" : CA === null ? "Null" : typeof (eA = (function(QA, tA) {
            try {
              return QA[tA];
            } catch {
            }
          })(BA = Object(CA), gA)) == "string" ? eA : IA ? AA(BA) : (iA = AA(BA)) == "Object" && typeof BA.callee == "function" ? "Arguments" : iA;
        };
      }, function(d, k) {
        var H;
        H = /* @__PURE__ */ (function() {
          return this;
        })();
        try {
          H = H || new Function("return this")();
        } catch {
          typeof window == "object" && (H = window);
        }
        d.exports = H;
      }, function(d, k) {
        var H = /-?\d+(\.\d+)?%?/g;
        d.exports = function(AA) {
          return AA.match(H);
        };
      }, function(d, k, H) {
        Object.defineProperty(k, "__esModule", { value: !0 }), k.getBase16Theme = k.createStyling = k.invertTheme = void 0;
        var AA = EA(H(49)), gA = EA(H(76)), IA = EA(H(81)), CA = EA(H(89)), BA = EA(H(93)), eA = (function(dA) {
          if (dA && dA.__esModule) return dA;
          var GA = {};
          if (dA != null) for (var DA in dA) Object.prototype.hasOwnProperty.call(dA, DA) && (GA[DA] = dA[DA]);
          return GA.default = dA, GA;
        })(H(94)), iA = EA(H(132)), QA = EA(H(133)), tA = EA(H(138)), oA = H(139);
        function EA(dA) {
          return dA && dA.__esModule ? dA : { default: dA };
        }
        var aA = eA.default, nA = (0, CA.default)(aA), lA = (0, tA.default)(QA.default, oA.rgb2yuv, (function(dA) {
          var GA, DA = (0, IA.default)(dA, 3), wA = DA[0], bA = DA[1], yA = DA[2];
          return [(GA = wA, GA < 0.25 ? 1 : GA < 0.5 ? 0.9 - GA : 1.1 - GA), bA, yA];
        }), oA.yuv2rgb, iA.default), cA = function(dA) {
          return function(GA) {
            return { className: [GA.className, dA.className].filter(Boolean).join(" "), style: (0, gA.default)({}, GA.style || {}, dA.style || {}) };
          };
        }, sA = function(dA, GA) {
          var DA = (0, CA.default)(GA);
          for (var wA in dA) DA.indexOf(wA) === -1 && DA.push(wA);
          return DA.reduce((function(bA, yA) {
            return bA[yA] = (function(pA, MA) {
              if (pA === void 0) return MA;
              if (MA === void 0) return pA;
              var LA = pA === void 0 ? "undefined" : (0, AA.default)(pA), xA = MA === void 0 ? "undefined" : (0, AA.default)(MA);
              switch (LA) {
                case "string":
                  switch (xA) {
                    case "string":
                      return [MA, pA].filter(Boolean).join(" ");
                    case "object":
                      return cA({ className: pA, style: MA });
                    case "function":
                      return function(TA) {
                        for (var NA = arguments.length, zA = Array(NA > 1 ? NA - 1 : 0), XA = 1; XA < NA; XA++) zA[XA - 1] = arguments[XA];
                        return cA({ className: pA })(MA.apply(void 0, [TA].concat(zA)));
                      };
                  }
                case "object":
                  switch (xA) {
                    case "string":
                      return cA({ className: MA, style: pA });
                    case "object":
                      return (0, gA.default)({}, MA, pA);
                    case "function":
                      return function(TA) {
                        for (var NA = arguments.length, zA = Array(NA > 1 ? NA - 1 : 0), XA = 1; XA < NA; XA++) zA[XA - 1] = arguments[XA];
                        return cA({ style: pA })(MA.apply(void 0, [TA].concat(zA)));
                      };
                  }
                case "function":
                  switch (xA) {
                    case "string":
                      return function(TA) {
                        for (var NA = arguments.length, zA = Array(NA > 1 ? NA - 1 : 0), XA = 1; XA < NA; XA++) zA[XA - 1] = arguments[XA];
                        return pA.apply(void 0, [cA(TA)({ className: MA })].concat(zA));
                      };
                    case "object":
                      return function(TA) {
                        for (var NA = arguments.length, zA = Array(NA > 1 ? NA - 1 : 0), XA = 1; XA < NA; XA++) zA[XA - 1] = arguments[XA];
                        return pA.apply(void 0, [cA(TA)({ style: MA })].concat(zA));
                      };
                    case "function":
                      return function(TA) {
                        for (var NA = arguments.length, zA = Array(NA > 1 ? NA - 1 : 0), XA = 1; XA < NA; XA++) zA[XA - 1] = arguments[XA];
                        return pA.apply(void 0, [MA.apply(void 0, [TA].concat(zA))].concat(zA));
                      };
                  }
              }
            })(dA[yA], GA[yA]), bA;
          }), {});
        }, rA = function(dA, GA) {
          for (var DA = arguments.length, wA = Array(DA > 2 ? DA - 2 : 0), bA = 2; bA < DA; bA++) wA[bA - 2] = arguments[bA];
          if (GA === null) return dA;
          Array.isArray(GA) || (GA = [GA]);
          var yA = GA.map((function(MA) {
            return dA[MA];
          })).filter(Boolean), pA = yA.reduce((function(MA, LA) {
            return typeof LA == "string" ? MA.className = [MA.className, LA].filter(Boolean).join(" ") : (LA === void 0 ? "undefined" : (0, AA.default)(LA)) === "object" ? MA.style = (0, gA.default)({}, MA.style, LA) : typeof LA == "function" && (MA = (0, gA.default)({}, MA, LA.apply(void 0, [MA].concat(wA)))), MA;
          }), { className: "", style: {} });
          return pA.className || delete pA.className, (0, CA.default)(pA.style).length === 0 && delete pA.style, pA;
        }, uA = k.invertTheme = function(dA) {
          return (0, CA.default)(dA).reduce((function(GA, DA) {
            return GA[DA] = /^base/.test(DA) ? lA(dA[DA]) : DA === "scheme" ? dA[DA] + ":inverted" : dA[DA], GA;
          }), {});
        }, hA = (k.createStyling = (0, BA.default)((function(dA) {
          for (var GA = arguments.length, DA = Array(GA > 3 ? GA - 3 : 0), wA = 3; wA < GA; wA++) DA[wA - 3] = arguments[wA];
          var bA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, yA = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, pA = bA.defaultBase16, MA = pA === void 0 ? aA : pA, LA = bA.base16Themes, xA = LA === void 0 ? null : LA, TA = hA(yA, xA);
          TA && (yA = (0, gA.default)({}, TA, yA));
          var NA = nA.reduce((function(vA, Cg) {
            return vA[Cg] = yA[Cg] || MA[Cg], vA;
          }), {}), zA = (0, CA.default)(yA).reduce((function(vA, Cg) {
            return nA.indexOf(Cg) === -1 && (vA[Cg] = yA[Cg]), vA;
          }), {}), XA = dA(NA), fA = sA(zA, XA);
          return (0, BA.default)(rA, 2).apply(void 0, [fA].concat(DA));
        }), 3), k.getBase16Theme = function(dA, GA) {
          if (dA && dA.extend && (dA = dA.extend), typeof dA == "string") {
            var DA = dA.split(":"), wA = (0, IA.default)(DA, 2), bA = wA[0], yA = wA[1];
            dA = (GA || {})[bA] || eA[bA], yA === "inverted" && (dA = uA(dA));
          }
          return dA && dA.hasOwnProperty("base00") ? dA : void 0;
        });
      }, function(d, k, H) {
        var AA, gA = typeof Reflect == "object" ? Reflect : null, IA = gA && typeof gA.apply == "function" ? gA.apply : function(cA, sA, rA) {
          return Function.prototype.apply.call(cA, sA, rA);
        };
        AA = gA && typeof gA.ownKeys == "function" ? gA.ownKeys : Object.getOwnPropertySymbols ? function(cA) {
          return Object.getOwnPropertyNames(cA).concat(Object.getOwnPropertySymbols(cA));
        } : function(cA) {
          return Object.getOwnPropertyNames(cA);
        };
        var CA = Number.isNaN || function(cA) {
          return cA != cA;
        };
        function BA() {
          BA.init.call(this);
        }
        d.exports = BA, d.exports.once = function(cA, sA) {
          return new Promise((function(rA, uA) {
            function hA() {
              dA !== void 0 && cA.removeListener("error", dA), rA([].slice.call(arguments));
            }
            var dA;
            sA !== "error" && (dA = function(GA) {
              cA.removeListener(sA, hA), uA(GA);
            }, cA.once("error", dA)), cA.once(sA, hA);
          }));
        }, BA.EventEmitter = BA, BA.prototype._events = void 0, BA.prototype._eventsCount = 0, BA.prototype._maxListeners = void 0;
        var eA = 10;
        function iA(cA) {
          if (typeof cA != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof cA);
        }
        function QA(cA) {
          return cA._maxListeners === void 0 ? BA.defaultMaxListeners : cA._maxListeners;
        }
        function tA(cA, sA, rA, uA) {
          var hA, dA, GA, DA;
          if (iA(rA), (dA = cA._events) === void 0 ? (dA = cA._events = /* @__PURE__ */ Object.create(null), cA._eventsCount = 0) : (dA.newListener !== void 0 && (cA.emit("newListener", sA, rA.listener ? rA.listener : rA), dA = cA._events), GA = dA[sA]), GA === void 0) GA = dA[sA] = rA, ++cA._eventsCount;
          else if (typeof GA == "function" ? GA = dA[sA] = uA ? [rA, GA] : [GA, rA] : uA ? GA.unshift(rA) : GA.push(rA), (hA = QA(cA)) > 0 && GA.length > hA && !GA.warned) {
            GA.warned = !0;
            var wA = new Error("Possible EventEmitter memory leak detected. " + GA.length + " " + String(sA) + " listeners added. Use emitter.setMaxListeners() to increase limit");
            wA.name = "MaxListenersExceededWarning", wA.emitter = cA, wA.type = sA, wA.count = GA.length, DA = wA, console && console.warn && console.warn(DA);
          }
          return cA;
        }
        function oA() {
          if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
        }
        function EA(cA, sA, rA) {
          var uA = { fired: !1, wrapFn: void 0, target: cA, type: sA, listener: rA }, hA = oA.bind(uA);
          return hA.listener = rA, uA.wrapFn = hA, hA;
        }
        function aA(cA, sA, rA) {
          var uA = cA._events;
          if (uA === void 0) return [];
          var hA = uA[sA];
          return hA === void 0 ? [] : typeof hA == "function" ? rA ? [hA.listener || hA] : [hA] : rA ? (function(dA) {
            for (var GA = new Array(dA.length), DA = 0; DA < GA.length; ++DA) GA[DA] = dA[DA].listener || dA[DA];
            return GA;
          })(hA) : lA(hA, hA.length);
        }
        function nA(cA) {
          var sA = this._events;
          if (sA !== void 0) {
            var rA = sA[cA];
            if (typeof rA == "function") return 1;
            if (rA !== void 0) return rA.length;
          }
          return 0;
        }
        function lA(cA, sA) {
          for (var rA = new Array(sA), uA = 0; uA < sA; ++uA) rA[uA] = cA[uA];
          return rA;
        }
        Object.defineProperty(BA, "defaultMaxListeners", { enumerable: !0, get: function() {
          return eA;
        }, set: function(cA) {
          if (typeof cA != "number" || cA < 0 || CA(cA)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + cA + ".");
          eA = cA;
        } }), BA.init = function() {
          this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
        }, BA.prototype.setMaxListeners = function(cA) {
          if (typeof cA != "number" || cA < 0 || CA(cA)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + cA + ".");
          return this._maxListeners = cA, this;
        }, BA.prototype.getMaxListeners = function() {
          return QA(this);
        }, BA.prototype.emit = function(cA) {
          for (var sA = [], rA = 1; rA < arguments.length; rA++) sA.push(arguments[rA]);
          var uA = cA === "error", hA = this._events;
          if (hA !== void 0) uA = uA && hA.error === void 0;
          else if (!uA) return !1;
          if (uA) {
            var dA;
            if (sA.length > 0 && (dA = sA[0]), dA instanceof Error) throw dA;
            var GA = new Error("Unhandled error." + (dA ? " (" + dA.message + ")" : ""));
            throw GA.context = dA, GA;
          }
          var DA = hA[cA];
          if (DA === void 0) return !1;
          if (typeof DA == "function") IA(DA, this, sA);
          else {
            var wA = DA.length, bA = lA(DA, wA);
            for (rA = 0; rA < wA; ++rA) IA(bA[rA], this, sA);
          }
          return !0;
        }, BA.prototype.addListener = function(cA, sA) {
          return tA(this, cA, sA, !1);
        }, BA.prototype.on = BA.prototype.addListener, BA.prototype.prependListener = function(cA, sA) {
          return tA(this, cA, sA, !0);
        }, BA.prototype.once = function(cA, sA) {
          return iA(sA), this.on(cA, EA(this, cA, sA)), this;
        }, BA.prototype.prependOnceListener = function(cA, sA) {
          return iA(sA), this.prependListener(cA, EA(this, cA, sA)), this;
        }, BA.prototype.removeListener = function(cA, sA) {
          var rA, uA, hA, dA, GA;
          if (iA(sA), (uA = this._events) === void 0) return this;
          if ((rA = uA[cA]) === void 0) return this;
          if (rA === sA || rA.listener === sA) --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete uA[cA], uA.removeListener && this.emit("removeListener", cA, rA.listener || sA));
          else if (typeof rA != "function") {
            for (hA = -1, dA = rA.length - 1; dA >= 0; dA--) if (rA[dA] === sA || rA[dA].listener === sA) {
              GA = rA[dA].listener, hA = dA;
              break;
            }
            if (hA < 0) return this;
            hA === 0 ? rA.shift() : (function(DA, wA) {
              for (; wA + 1 < DA.length; wA++) DA[wA] = DA[wA + 1];
              DA.pop();
            })(rA, hA), rA.length === 1 && (uA[cA] = rA[0]), uA.removeListener !== void 0 && this.emit("removeListener", cA, GA || sA);
          }
          return this;
        }, BA.prototype.off = BA.prototype.removeListener, BA.prototype.removeAllListeners = function(cA) {
          var sA, rA, uA;
          if ((rA = this._events) === void 0) return this;
          if (rA.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : rA[cA] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete rA[cA]), this;
          if (arguments.length === 0) {
            var hA, dA = Object.keys(rA);
            for (uA = 0; uA < dA.length; ++uA) (hA = dA[uA]) !== "removeListener" && this.removeAllListeners(hA);
            return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
          }
          if (typeof (sA = rA[cA]) == "function") this.removeListener(cA, sA);
          else if (sA !== void 0) for (uA = sA.length - 1; uA >= 0; uA--) this.removeListener(cA, sA[uA]);
          return this;
        }, BA.prototype.listeners = function(cA) {
          return aA(this, cA, !0);
        }, BA.prototype.rawListeners = function(cA) {
          return aA(this, cA, !1);
        }, BA.listenerCount = function(cA, sA) {
          return typeof cA.listenerCount == "function" ? cA.listenerCount(sA) : nA.call(cA, sA);
        }, BA.prototype.listenerCount = nA, BA.prototype.eventNames = function() {
          return this._eventsCount > 0 ? AA(this._events) : [];
        };
      }, function(d, k, H) {
        d.exports.Dispatcher = H(140);
      }, function(d, k, H) {
        d.exports = H(142);
      }, function(d, k, H) {
        k.__esModule = !0;
        var AA = CA(H(50)), gA = CA(H(65)), IA = typeof gA.default == "function" && typeof AA.default == "symbol" ? function(BA) {
          return typeof BA;
        } : function(BA) {
          return BA && typeof gA.default == "function" && BA.constructor === gA.default && BA !== gA.default.prototype ? "symbol" : typeof BA;
        };
        function CA(BA) {
          return BA && BA.__esModule ? BA : { default: BA };
        }
        k.default = typeof gA.default == "function" && IA(AA.default) === "symbol" ? function(BA) {
          return BA === void 0 ? "undefined" : IA(BA);
        } : function(BA) {
          return BA && typeof gA.default == "function" && BA.constructor === gA.default && BA !== gA.default.prototype ? "symbol" : BA === void 0 ? "undefined" : IA(BA);
        };
      }, function(d, k, H) {
        d.exports = { default: H(51), __esModule: !0 };
      }, function(d, k, H) {
        H(20), H(29), d.exports = H(30).f("iterator");
      }, function(d, k, H) {
        var AA = H(21), gA = H(22);
        d.exports = function(IA) {
          return function(CA, BA) {
            var eA, iA, QA = String(gA(CA)), tA = AA(BA), oA = QA.length;
            return tA < 0 || tA >= oA ? IA ? "" : void 0 : (eA = QA.charCodeAt(tA)) < 55296 || eA > 56319 || tA + 1 === oA || (iA = QA.charCodeAt(tA + 1)) < 56320 || iA > 57343 ? IA ? QA.charAt(tA) : eA : IA ? QA.slice(tA, tA + 2) : iA - 56320 + (eA - 55296 << 10) + 65536;
          };
        };
      }, function(d, k, H) {
        var AA = H(54);
        d.exports = function(gA, IA, CA) {
          if (AA(gA), IA === void 0) return gA;
          switch (CA) {
            case 1:
              return function(BA) {
                return gA.call(IA, BA);
              };
            case 2:
              return function(BA, eA) {
                return gA.call(IA, BA, eA);
              };
            case 3:
              return function(BA, eA, iA) {
                return gA.call(IA, BA, eA, iA);
              };
          }
          return function() {
            return gA.apply(IA, arguments);
          };
        };
      }, function(d, k) {
        d.exports = function(H) {
          if (typeof H != "function") throw TypeError(H + " is not a function!");
          return H;
        };
      }, function(d, k, H) {
        var AA = H(38), gA = H(16), IA = H(28), CA = {};
        H(6)(CA, H(2)("iterator"), (function() {
          return this;
        })), d.exports = function(BA, eA, iA) {
          BA.prototype = AA(CA, { next: gA(1, iA) }), IA(BA, eA + " Iterator");
        };
      }, function(d, k, H) {
        var AA = H(7), gA = H(10), IA = H(13);
        d.exports = H(4) ? Object.defineProperties : function(CA, BA) {
          gA(CA);
          for (var eA, iA = IA(BA), QA = iA.length, tA = 0; QA > tA; ) AA.f(CA, eA = iA[tA++], BA[eA]);
          return CA;
        };
      }, function(d, k, H) {
        var AA = H(9), gA = H(58), IA = H(59);
        d.exports = function(CA) {
          return function(BA, eA, iA) {
            var QA, tA = AA(BA), oA = gA(tA.length), EA = IA(iA, oA);
            if (CA && eA != eA) {
              for (; oA > EA; ) if ((QA = tA[EA++]) != QA) return !0;
            } else for (; oA > EA; EA++) if ((CA || EA in tA) && tA[EA] === eA) return CA || EA || 0;
            return !CA && -1;
          };
        };
      }, function(d, k, H) {
        var AA = H(21), gA = Math.min;
        d.exports = function(IA) {
          return IA > 0 ? gA(AA(IA), 9007199254740991) : 0;
        };
      }, function(d, k, H) {
        var AA = H(21), gA = Math.max, IA = Math.min;
        d.exports = function(CA, BA) {
          return (CA = AA(CA)) < 0 ? gA(CA + BA, 0) : IA(CA, BA);
        };
      }, function(d, k, H) {
        var AA = H(3).document;
        d.exports = AA && AA.documentElement;
      }, function(d, k, H) {
        var AA = H(5), gA = H(18), IA = H(25)("IE_PROTO"), CA = Object.prototype;
        d.exports = Object.getPrototypeOf || function(BA) {
          return BA = gA(BA), AA(BA, IA) ? BA[IA] : typeof BA.constructor == "function" && BA instanceof BA.constructor ? BA.constructor.prototype : BA instanceof Object ? CA : null;
        };
      }, function(d, k, H) {
        var AA = H(63), gA = H(64), IA = H(12), CA = H(9);
        d.exports = H(34)(Array, "Array", (function(BA, eA) {
          this._t = CA(BA), this._i = 0, this._k = eA;
        }), (function() {
          var BA = this._t, eA = this._k, iA = this._i++;
          return !BA || iA >= BA.length ? (this._t = void 0, gA(1)) : gA(0, eA == "keys" ? iA : eA == "values" ? BA[iA] : [iA, BA[iA]]);
        }), "values"), IA.Arguments = IA.Array, AA("keys"), AA("values"), AA("entries");
      }, function(d, k) {
        d.exports = function() {
        };
      }, function(d, k) {
        d.exports = function(H, AA) {
          return { value: AA, done: !!H };
        };
      }, function(d, k, H) {
        d.exports = { default: H(66), __esModule: !0 };
      }, function(d, k, H) {
        H(67), H(73), H(74), H(75), d.exports = H(1).Symbol;
      }, function(d, k, H) {
        var AA = H(3), gA = H(5), IA = H(4), CA = H(15), BA = H(37), eA = H(68).KEY, iA = H(8), QA = H(26), tA = H(28), oA = H(17), EA = H(2), aA = H(30), nA = H(31), lA = H(69), cA = H(70), sA = H(10), rA = H(11), uA = H(18), hA = H(9), dA = H(23), GA = H(16), DA = H(38), wA = H(71), bA = H(72), yA = H(32), pA = H(7), MA = H(13), LA = bA.f, xA = pA.f, TA = wA.f, NA = AA.Symbol, zA = AA.JSON, XA = zA && zA.stringify, fA = EA("_hidden"), vA = EA("toPrimitive"), Cg = {}.propertyIsEnumerable, Ig = QA("symbol-registry"), gg = QA("symbols"), og = QA("op-symbols"), eg = Object.prototype, kA = typeof NA == "function" && !!yA.f, YA = AA.QObject, RA = !YA || !YA.prototype || !YA.prototype.findChild, FA = IA && iA((function() {
          return DA(xA({}, "a", { get: function() {
            return xA(this, "a", { value: 7 }).a;
          } })).a != 7;
        })) ? function(KA, PA, ag) {
          var Gg = LA(eg, PA);
          Gg && delete eg[PA], xA(KA, PA, ag), Gg && KA !== eg && xA(eg, PA, Gg);
        } : xA, mA = function(KA) {
          var PA = gg[KA] = DA(NA.prototype);
          return PA._k = KA, PA;
        }, JA = kA && typeof NA.iterator == "symbol" ? function(KA) {
          return typeof KA == "symbol";
        } : function(KA) {
          return KA instanceof NA;
        }, VA = function(KA, PA, ag) {
          return KA === eg && VA(og, PA, ag), sA(KA), PA = dA(PA, !0), sA(ag), gA(gg, PA) ? (ag.enumerable ? (gA(KA, fA) && KA[fA][PA] && (KA[fA][PA] = !1), ag = DA(ag, { enumerable: GA(0, !1) })) : (gA(KA, fA) || xA(KA, fA, GA(1, {})), KA[fA][PA] = !0), FA(KA, PA, ag)) : xA(KA, PA, ag);
        }, HA = function(KA, PA) {
          sA(KA);
          for (var ag, Gg = lA(PA = hA(PA)), bg = 0, yg = Gg.length; yg > bg; ) VA(KA, ag = Gg[bg++], PA[ag]);
          return KA;
        }, jA = function(KA) {
          var PA = Cg.call(this, KA = dA(KA, !0));
          return !(this === eg && gA(gg, KA) && !gA(og, KA)) && (!(PA || !gA(this, KA) || !gA(gg, KA) || gA(this, fA) && this[fA][KA]) || PA);
        }, _A = function(KA, PA) {
          if (KA = hA(KA), PA = dA(PA, !0), KA !== eg || !gA(gg, PA) || gA(og, PA)) {
            var ag = LA(KA, PA);
            return !ag || !gA(gg, PA) || gA(KA, fA) && KA[fA][PA] || (ag.enumerable = !0), ag;
          }
        }, $A = function(KA) {
          for (var PA, ag = TA(hA(KA)), Gg = [], bg = 0; ag.length > bg; ) gA(gg, PA = ag[bg++]) || PA == fA || PA == eA || Gg.push(PA);
          return Gg;
        }, rg = function(KA) {
          for (var PA, ag = KA === eg, Gg = TA(ag ? og : hA(KA)), bg = [], yg = 0; Gg.length > yg; ) !gA(gg, PA = Gg[yg++]) || ag && !gA(eg, PA) || bg.push(gg[PA]);
          return bg;
        };
        kA || (BA((NA = function() {
          if (this instanceof NA) throw TypeError("Symbol is not a constructor!");
          var KA = oA(arguments.length > 0 ? arguments[0] : void 0), PA = function(ag) {
            this === eg && PA.call(og, ag), gA(this, fA) && gA(this[fA], KA) && (this[fA][KA] = !1), FA(this, KA, GA(1, ag));
          };
          return IA && RA && FA(eg, KA, { configurable: !0, set: PA }), mA(KA);
        }).prototype, "toString", (function() {
          return this._k;
        })), bA.f = _A, pA.f = VA, H(41).f = wA.f = $A, H(19).f = jA, yA.f = rg, IA && !H(14) && BA(eg, "propertyIsEnumerable", jA, !0), aA.f = function(KA) {
          return mA(EA(KA));
        }), CA(CA.G + CA.W + CA.F * !kA, { Symbol: NA });
        for (var wg = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), Dg = 0; wg.length > Dg; ) EA(wg[Dg++]);
        for (var kg = MA(EA.store), ig = 0; kg.length > ig; ) nA(kg[ig++]);
        CA(CA.S + CA.F * !kA, "Symbol", { for: function(KA) {
          return gA(Ig, KA += "") ? Ig[KA] : Ig[KA] = NA(KA);
        }, keyFor: function(KA) {
          if (!JA(KA)) throw TypeError(KA + " is not a symbol!");
          for (var PA in Ig) if (Ig[PA] === KA) return PA;
        }, useSetter: function() {
          RA = !0;
        }, useSimple: function() {
          RA = !1;
        } }), CA(CA.S + CA.F * !kA, "Object", { create: function(KA, PA) {
          return PA === void 0 ? DA(KA) : HA(DA(KA), PA);
        }, defineProperty: VA, defineProperties: HA, getOwnPropertyDescriptor: _A, getOwnPropertyNames: $A, getOwnPropertySymbols: rg });
        var ZA = iA((function() {
          yA.f(1);
        }));
        CA(CA.S + CA.F * ZA, "Object", { getOwnPropertySymbols: function(KA) {
          return yA.f(uA(KA));
        } }), zA && CA(CA.S + CA.F * (!kA || iA((function() {
          var KA = NA();
          return XA([KA]) != "[null]" || XA({ a: KA }) != "{}" || XA(Object(KA)) != "{}";
        }))), "JSON", { stringify: function(KA) {
          for (var PA, ag, Gg = [KA], bg = 1; arguments.length > bg; ) Gg.push(arguments[bg++]);
          if (ag = PA = Gg[1], (rA(PA) || KA !== void 0) && !JA(KA)) return cA(PA) || (PA = function(yg, hg) {
            if (typeof ag == "function" && (hg = ag.call(this, yg, hg)), !JA(hg)) return hg;
          }), Gg[1] = PA, XA.apply(zA, Gg);
        } }), NA.prototype[vA] || H(6)(NA.prototype, vA, NA.prototype.valueOf), tA(NA, "Symbol"), tA(Math, "Math", !0), tA(AA.JSON, "JSON", !0);
      }, function(d, k, H) {
        var AA = H(17)("meta"), gA = H(11), IA = H(5), CA = H(7).f, BA = 0, eA = Object.isExtensible || function() {
          return !0;
        }, iA = !H(8)((function() {
          return eA(Object.preventExtensions({}));
        })), QA = function(oA) {
          CA(oA, AA, { value: { i: "O" + ++BA, w: {} } });
        }, tA = d.exports = { KEY: AA, NEED: !1, fastKey: function(oA, EA) {
          if (!gA(oA)) return typeof oA == "symbol" ? oA : (typeof oA == "string" ? "S" : "P") + oA;
          if (!IA(oA, AA)) {
            if (!eA(oA)) return "F";
            if (!EA) return "E";
            QA(oA);
          }
          return oA[AA].i;
        }, getWeak: function(oA, EA) {
          if (!IA(oA, AA)) {
            if (!eA(oA)) return !0;
            if (!EA) return !1;
            QA(oA);
          }
          return oA[AA].w;
        }, onFreeze: function(oA) {
          return iA && tA.NEED && eA(oA) && !IA(oA, AA) && QA(oA), oA;
        } };
      }, function(d, k, H) {
        var AA = H(13), gA = H(32), IA = H(19);
        d.exports = function(CA) {
          var BA = AA(CA), eA = gA.f;
          if (eA) for (var iA, QA = eA(CA), tA = IA.f, oA = 0; QA.length > oA; ) tA.call(CA, iA = QA[oA++]) && BA.push(iA);
          return BA;
        };
      }, function(d, k, H) {
        var AA = H(24);
        d.exports = Array.isArray || function(gA) {
          return AA(gA) == "Array";
        };
      }, function(d, k, H) {
        var AA = H(9), gA = H(41).f, IA = {}.toString, CA = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
        d.exports.f = function(BA) {
          return CA && IA.call(BA) == "[object Window]" ? (function(eA) {
            try {
              return gA(eA);
            } catch {
              return CA.slice();
            }
          })(BA) : gA(AA(BA));
        };
      }, function(d, k, H) {
        var AA = H(19), gA = H(16), IA = H(9), CA = H(23), BA = H(5), eA = H(35), iA = Object.getOwnPropertyDescriptor;
        k.f = H(4) ? iA : function(QA, tA) {
          if (QA = IA(QA), tA = CA(tA, !0), eA) try {
            return iA(QA, tA);
          } catch {
          }
          if (BA(QA, tA)) return gA(!AA.f.call(QA, tA), QA[tA]);
        };
      }, function(d, k) {
      }, function(d, k, H) {
        H(31)("asyncIterator");
      }, function(d, k, H) {
        H(31)("observable");
      }, function(d, k, H) {
        k.__esModule = !0;
        var AA, gA = H(77), IA = (AA = gA) && AA.__esModule ? AA : { default: AA };
        k.default = IA.default || function(CA) {
          for (var BA = 1; BA < arguments.length; BA++) {
            var eA = arguments[BA];
            for (var iA in eA) Object.prototype.hasOwnProperty.call(eA, iA) && (CA[iA] = eA[iA]);
          }
          return CA;
        };
      }, function(d, k, H) {
        d.exports = { default: H(78), __esModule: !0 };
      }, function(d, k, H) {
        H(79), d.exports = H(1).Object.assign;
      }, function(d, k, H) {
        var AA = H(15);
        AA(AA.S + AA.F, "Object", { assign: H(80) });
      }, function(d, k, H) {
        var AA = H(4), gA = H(13), IA = H(32), CA = H(19), BA = H(18), eA = H(40), iA = Object.assign;
        d.exports = !iA || H(8)((function() {
          var QA = {}, tA = {}, oA = Symbol(), EA = "abcdefghijklmnopqrst";
          return QA[oA] = 7, EA.split("").forEach((function(aA) {
            tA[aA] = aA;
          })), iA({}, QA)[oA] != 7 || Object.keys(iA({}, tA)).join("") != EA;
        })) ? function(QA, tA) {
          for (var oA = BA(QA), EA = arguments.length, aA = 1, nA = IA.f, lA = CA.f; EA > aA; ) for (var cA, sA = eA(arguments[aA++]), rA = nA ? gA(sA).concat(nA(sA)) : gA(sA), uA = rA.length, hA = 0; uA > hA; ) cA = rA[hA++], AA && !lA.call(sA, cA) || (oA[cA] = sA[cA]);
          return oA;
        } : iA;
      }, function(d, k, H) {
        k.__esModule = !0;
        var AA = IA(H(82)), gA = IA(H(85));
        function IA(CA) {
          return CA && CA.__esModule ? CA : { default: CA };
        }
        k.default = function(CA, BA) {
          if (Array.isArray(CA)) return CA;
          if ((0, AA.default)(Object(CA))) return (function(eA, iA) {
            var QA = [], tA = !0, oA = !1, EA = void 0;
            try {
              for (var aA, nA = (0, gA.default)(eA); !(tA = (aA = nA.next()).done) && (QA.push(aA.value), !iA || QA.length !== iA); tA = !0) ;
            } catch (lA) {
              oA = !0, EA = lA;
            } finally {
              try {
                !tA && nA.return && nA.return();
              } finally {
                if (oA) throw EA;
              }
            }
            return QA;
          })(CA, BA);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }, function(d, k, H) {
        d.exports = { default: H(83), __esModule: !0 };
      }, function(d, k, H) {
        H(29), H(20), d.exports = H(84);
      }, function(d, k, H) {
        var AA = H(42), gA = H(2)("iterator"), IA = H(12);
        d.exports = H(1).isIterable = function(CA) {
          var BA = Object(CA);
          return BA[gA] !== void 0 || "@@iterator" in BA || IA.hasOwnProperty(AA(BA));
        };
      }, function(d, k, H) {
        d.exports = { default: H(86), __esModule: !0 };
      }, function(d, k, H) {
        H(29), H(20), d.exports = H(87);
      }, function(d, k, H) {
        var AA = H(10), gA = H(88);
        d.exports = H(1).getIterator = function(IA) {
          var CA = gA(IA);
          if (typeof CA != "function") throw TypeError(IA + " is not iterable!");
          return AA(CA.call(IA));
        };
      }, function(d, k, H) {
        var AA = H(42), gA = H(2)("iterator"), IA = H(12);
        d.exports = H(1).getIteratorMethod = function(CA) {
          if (CA != null) return CA[gA] || CA["@@iterator"] || IA[AA(CA)];
        };
      }, function(d, k, H) {
        d.exports = { default: H(90), __esModule: !0 };
      }, function(d, k, H) {
        H(91), d.exports = H(1).Object.keys;
      }, function(d, k, H) {
        var AA = H(18), gA = H(13);
        H(92)("keys", (function() {
          return function(IA) {
            return gA(AA(IA));
          };
        }));
      }, function(d, k, H) {
        var AA = H(15), gA = H(1), IA = H(8);
        d.exports = function(CA, BA) {
          var eA = (gA.Object || {})[CA] || Object[CA], iA = {};
          iA[CA] = BA(eA), AA(AA.S + AA.F * IA((function() {
            eA(1);
          })), "Object", iA);
        };
      }, function(d, k, H) {
        (function(AA) {
          var gA = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]], IA = /^\s+|\s+$/g, CA = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, BA = /\{\n\/\* \[wrapped with (.+)\] \*/, eA = /,? & /, iA = /^[-+]0x[0-9a-f]+$/i, QA = /^0b[01]+$/i, tA = /^\[object .+?Constructor\]$/, oA = /^0o[0-7]+$/i, EA = /^(?:0|[1-9]\d*)$/, aA = parseInt, nA = typeof AA == "object" && AA && AA.Object === Object && AA, lA = typeof self == "object" && self && self.Object === Object && self, cA = nA || lA || Function("return this")();
          function sA(ig, ZA, KA) {
            switch (KA.length) {
              case 0:
                return ig.call(ZA);
              case 1:
                return ig.call(ZA, KA[0]);
              case 2:
                return ig.call(ZA, KA[0], KA[1]);
              case 3:
                return ig.call(ZA, KA[0], KA[1], KA[2]);
            }
            return ig.apply(ZA, KA);
          }
          function rA(ig, ZA) {
            return !!(ig && ig.length) && (function(KA, PA, ag) {
              if (PA != PA) return (function(yg, hg, tg, Eg) {
                for (var cg = yg.length, sg = tg + -1; ++sg < cg; ) if (hg(yg[sg], sg, yg)) return sg;
                return -1;
              })(KA, uA, ag);
              for (var Gg = ag - 1, bg = KA.length; ++Gg < bg; ) if (KA[Gg] === PA) return Gg;
              return -1;
            })(ig, ZA, 0) > -1;
          }
          function uA(ig) {
            return ig != ig;
          }
          function hA(ig, ZA) {
            for (var KA = ig.length, PA = 0; KA--; ) ig[KA] === ZA && PA++;
            return PA;
          }
          function dA(ig, ZA) {
            for (var KA = -1, PA = ig.length, ag = 0, Gg = []; ++KA < PA; ) {
              var bg = ig[KA];
              bg !== ZA && bg !== "__lodash_placeholder__" || (ig[KA] = "__lodash_placeholder__", Gg[ag++] = KA);
            }
            return Gg;
          }
          var GA, DA, wA, bA = Function.prototype, yA = Object.prototype, pA = cA["__core-js_shared__"], MA = (GA = /[^.]+$/.exec(pA && pA.keys && pA.keys.IE_PROTO || "")) ? "Symbol(src)_1." + GA : "", LA = bA.toString, xA = yA.hasOwnProperty, TA = yA.toString, NA = RegExp("^" + LA.call(xA).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), zA = Object.create, XA = Math.max, fA = Math.min, vA = (DA = mA(Object, "defineProperty"), (wA = mA.name) && wA.length > 2 ? DA : void 0);
          function Cg(ig) {
            return wg(ig) ? zA(ig) : {};
          }
          function Ig(ig) {
            return !(!wg(ig) || (function(ZA) {
              return !!MA && MA in ZA;
            })(ig)) && ((function(ZA) {
              var KA = wg(ZA) ? TA.call(ZA) : "";
              return KA == "[object Function]" || KA == "[object GeneratorFunction]";
            })(ig) || (function(ZA) {
              var KA = !1;
              if (ZA != null && typeof ZA.toString != "function") try {
                KA = !!(ZA + "");
              } catch {
              }
              return KA;
            })(ig) ? NA : tA).test((function(ZA) {
              if (ZA != null) {
                try {
                  return LA.call(ZA);
                } catch {
                }
                try {
                  return ZA + "";
                } catch {
                }
              }
              return "";
            })(ig));
          }
          function gg(ig, ZA, KA, PA) {
            for (var ag = -1, Gg = ig.length, bg = KA.length, yg = -1, hg = ZA.length, tg = XA(Gg - bg, 0), Eg = Array(hg + tg), cg = !PA; ++yg < hg; ) Eg[yg] = ZA[yg];
            for (; ++ag < bg; ) (cg || ag < Gg) && (Eg[KA[ag]] = ig[ag]);
            for (; tg--; ) Eg[yg++] = ig[ag++];
            return Eg;
          }
          function og(ig, ZA, KA, PA) {
            for (var ag = -1, Gg = ig.length, bg = -1, yg = KA.length, hg = -1, tg = ZA.length, Eg = XA(Gg - yg, 0), cg = Array(Eg + tg), sg = !PA; ++ag < Eg; ) cg[ag] = ig[ag];
            for (var ug = ag; ++hg < tg; ) cg[ug + hg] = ZA[hg];
            for (; ++bg < yg; ) (sg || ag < Gg) && (cg[ug + KA[bg]] = ig[ag++]);
            return cg;
          }
          function eg(ig) {
            return function() {
              var ZA = arguments;
              switch (ZA.length) {
                case 0:
                  return new ig();
                case 1:
                  return new ig(ZA[0]);
                case 2:
                  return new ig(ZA[0], ZA[1]);
                case 3:
                  return new ig(ZA[0], ZA[1], ZA[2]);
                case 4:
                  return new ig(ZA[0], ZA[1], ZA[2], ZA[3]);
                case 5:
                  return new ig(ZA[0], ZA[1], ZA[2], ZA[3], ZA[4]);
                case 6:
                  return new ig(ZA[0], ZA[1], ZA[2], ZA[3], ZA[4], ZA[5]);
                case 7:
                  return new ig(ZA[0], ZA[1], ZA[2], ZA[3], ZA[4], ZA[5], ZA[6]);
              }
              var KA = Cg(ig.prototype), PA = ig.apply(KA, ZA);
              return wg(PA) ? PA : KA;
            };
          }
          function kA(ig, ZA, KA, PA, ag, Gg, bg, yg, hg, tg) {
            var Eg = 128 & ZA, cg = 1 & ZA, sg = 2 & ZA, ug = 24 & ZA, Mg = 512 & ZA, Rg = sg ? void 0 : eg(ig);
            return function Jg() {
              for (var Hg = arguments.length, mg = Array(Hg), Og = Hg; Og--; ) mg[Og] = arguments[Og];
              if (ug) var Kg = FA(Jg), vg = hA(mg, Kg);
              if (PA && (mg = gg(mg, PA, ag, ug)), Gg && (mg = og(mg, Gg, bg, ug)), Hg -= vg, ug && Hg < tg) {
                var Vg = dA(mg, Kg);
                return YA(ig, ZA, kA, Jg.placeholder, KA, mg, Vg, yg, hg, tg - Hg);
              }
              var Xg = cg ? KA : this, jg = sg ? Xg[ig] : ig;
              return Hg = mg.length, yg ? mg = jA(mg, yg) : Mg && Hg > 1 && mg.reverse(), Eg && hg < Hg && (mg.length = hg), this && this !== cA && this instanceof Jg && (jg = Rg || eg(jg)), jg.apply(Xg, mg);
            };
          }
          function YA(ig, ZA, KA, PA, ag, Gg, bg, yg, hg, tg) {
            var Eg = 8 & ZA;
            ZA |= Eg ? 32 : 64, 4 & (ZA &= ~(Eg ? 64 : 32)) || (ZA &= -4);
            var cg = KA(ig, ZA, ag, Eg ? Gg : void 0, Eg ? bg : void 0, Eg ? void 0 : Gg, Eg ? void 0 : bg, yg, hg, tg);
            return cg.placeholder = PA, _A(cg, ig, ZA);
          }
          function RA(ig, ZA, KA, PA, ag, Gg, bg, yg) {
            var hg = 2 & ZA;
            if (!hg && typeof ig != "function") throw new TypeError("Expected a function");
            var tg = PA ? PA.length : 0;
            if (tg || (ZA &= -97, PA = ag = void 0), bg = bg === void 0 ? bg : XA(kg(bg), 0), yg = yg === void 0 ? yg : kg(yg), tg -= ag ? ag.length : 0, 64 & ZA) {
              var Eg = PA, cg = ag;
              PA = ag = void 0;
            }
            var sg = [ig, ZA, KA, PA, ag, Eg, cg, Gg, bg, yg];
            if (ig = sg[0], ZA = sg[1], KA = sg[2], PA = sg[3], ag = sg[4], !(yg = sg[9] = sg[9] == null ? hg ? 0 : ig.length : XA(sg[9] - tg, 0)) && 24 & ZA && (ZA &= -25), ZA && ZA != 1) ug = ZA == 8 || ZA == 16 ? (function(Mg, Rg, Jg) {
              var Hg = eg(Mg);
              return function mg() {
                for (var Og = arguments.length, Kg = Array(Og), vg = Og, Vg = FA(mg); vg--; ) Kg[vg] = arguments[vg];
                var Xg = Og < 3 && Kg[0] !== Vg && Kg[Og - 1] !== Vg ? [] : dA(Kg, Vg);
                if ((Og -= Xg.length) < Jg) return YA(Mg, Rg, kA, mg.placeholder, void 0, Kg, Xg, void 0, void 0, Jg - Og);
                var jg = this && this !== cA && this instanceof mg ? Hg : Mg;
                return sA(jg, this, Kg);
              };
            })(ig, ZA, yg) : ZA != 32 && ZA != 33 || ag.length ? kA.apply(void 0, sg) : (function(Mg, Rg, Jg, Hg) {
              var mg = 1 & Rg, Og = eg(Mg);
              return function Kg() {
                for (var vg = -1, Vg = arguments.length, Xg = -1, jg = Hg.length, gI = Array(jg + Vg), II = this && this !== cA && this instanceof Kg ? Og : Mg; ++Xg < jg; ) gI[Xg] = Hg[Xg];
                for (; Vg--; ) gI[Xg++] = arguments[++vg];
                return sA(II, mg ? Jg : this, gI);
              };
            })(ig, ZA, KA, PA);
            else var ug = (function(Mg, Rg, Jg) {
              var Hg = 1 & Rg, mg = eg(Mg);
              return function Og() {
                var Kg = this && this !== cA && this instanceof Og ? mg : Mg;
                return Kg.apply(Hg ? Jg : this, arguments);
              };
            })(ig, ZA, KA);
            return _A(ug, ig, ZA);
          }
          function FA(ig) {
            return ig.placeholder;
          }
          function mA(ig, ZA) {
            var KA = (function(PA, ag) {
              return PA?.[ag];
            })(ig, ZA);
            return Ig(KA) ? KA : void 0;
          }
          function JA(ig) {
            var ZA = ig.match(BA);
            return ZA ? ZA[1].split(eA) : [];
          }
          function VA(ig, ZA) {
            var KA = ZA.length, PA = KA - 1;
            return ZA[PA] = (KA > 1 ? "& " : "") + ZA[PA], ZA = ZA.join(KA > 2 ? ", " : " "), ig.replace(CA, `{
/* [wrapped with ` + ZA + `] */
`);
          }
          function HA(ig, ZA) {
            return !!(ZA = ZA ?? 9007199254740991) && (typeof ig == "number" || EA.test(ig)) && ig > -1 && ig % 1 == 0 && ig < ZA;
          }
          function jA(ig, ZA) {
            for (var KA = ig.length, PA = fA(ZA.length, KA), ag = (function(bg, yg) {
              var hg = -1, tg = bg.length;
              for (yg || (yg = Array(tg)); ++hg < tg; ) yg[hg] = bg[hg];
              return yg;
            })(ig); PA--; ) {
              var Gg = ZA[PA];
              ig[PA] = HA(Gg, KA) ? ag[Gg] : void 0;
            }
            return ig;
          }
          var _A = vA ? function(ig, ZA, KA) {
            var PA, ag = ZA + "";
            return vA(ig, "toString", { configurable: !0, enumerable: !1, value: (PA = VA(ag, $A(JA(ag), KA)), function() {
              return PA;
            }) });
          } : function(ig) {
            return ig;
          };
          function $A(ig, ZA) {
            return (function(KA, PA) {
              for (var ag = -1, Gg = KA ? KA.length : 0; ++ag < Gg && PA(KA[ag], ag, KA) !== !1; ) ;
            })(gA, (function(KA) {
              var PA = "_." + KA[0];
              ZA & KA[1] && !rA(ig, PA) && ig.push(PA);
            })), ig.sort();
          }
          function rg(ig, ZA, KA) {
            var PA = RA(ig, 8, void 0, void 0, void 0, void 0, void 0, ZA = KA ? void 0 : ZA);
            return PA.placeholder = rg.placeholder, PA;
          }
          function wg(ig) {
            var ZA = typeof ig;
            return !!ig && (ZA == "object" || ZA == "function");
          }
          function Dg(ig) {
            return ig ? (ig = (function(ZA) {
              if (typeof ZA == "number") return ZA;
              if ((function(ag) {
                return typeof ag == "symbol" || /* @__PURE__ */ (function(Gg) {
                  return !!Gg && typeof Gg == "object";
                })(ag) && TA.call(ag) == "[object Symbol]";
              })(ZA)) return NaN;
              if (wg(ZA)) {
                var KA = typeof ZA.valueOf == "function" ? ZA.valueOf() : ZA;
                ZA = wg(KA) ? KA + "" : KA;
              }
              if (typeof ZA != "string") return ZA === 0 ? ZA : +ZA;
              ZA = ZA.replace(IA, "");
              var PA = QA.test(ZA);
              return PA || oA.test(ZA) ? aA(ZA.slice(2), PA ? 2 : 8) : iA.test(ZA) ? NaN : +ZA;
            })(ig)) === 1 / 0 || ig === -1 / 0 ? 17976931348623157e292 * (ig < 0 ? -1 : 1) : ig == ig ? ig : 0 : ig === 0 ? ig : 0;
          }
          function kg(ig) {
            var ZA = Dg(ig), KA = ZA % 1;
            return ZA == ZA ? KA ? ZA - KA : ZA : 0;
          }
          rg.placeholder = {}, d.exports = rg;
        }).call(this, H(43));
      }, function(d, k, H) {
        function AA(og) {
          return og && og.__esModule ? og.default : og;
        }
        k.__esModule = !0;
        var gA = H(95);
        k.threezerotwofour = AA(gA);
        var IA = H(96);
        k.apathy = AA(IA);
        var CA = H(97);
        k.ashes = AA(CA);
        var BA = H(98);
        k.atelierDune = AA(BA);
        var eA = H(99);
        k.atelierForest = AA(eA);
        var iA = H(100);
        k.atelierHeath = AA(iA);
        var QA = H(101);
        k.atelierLakeside = AA(QA);
        var tA = H(102);
        k.atelierSeaside = AA(tA);
        var oA = H(103);
        k.bespin = AA(oA);
        var EA = H(104);
        k.brewer = AA(EA);
        var aA = H(105);
        k.bright = AA(aA);
        var nA = H(106);
        k.chalk = AA(nA);
        var lA = H(107);
        k.codeschool = AA(lA);
        var cA = H(108);
        k.colors = AA(cA);
        var sA = H(109);
        k.default = AA(sA);
        var rA = H(110);
        k.eighties = AA(rA);
        var uA = H(111);
        k.embers = AA(uA);
        var hA = H(112);
        k.flat = AA(hA);
        var dA = H(113);
        k.google = AA(dA);
        var GA = H(114);
        k.grayscale = AA(GA);
        var DA = H(115);
        k.greenscreen = AA(DA);
        var wA = H(116);
        k.harmonic = AA(wA);
        var bA = H(117);
        k.hopscotch = AA(bA);
        var yA = H(118);
        k.isotope = AA(yA);
        var pA = H(119);
        k.marrakesh = AA(pA);
        var MA = H(120);
        k.mocha = AA(MA);
        var LA = H(121);
        k.monokai = AA(LA);
        var xA = H(122);
        k.ocean = AA(xA);
        var TA = H(123);
        k.paraiso = AA(TA);
        var NA = H(124);
        k.pop = AA(NA);
        var zA = H(125);
        k.railscasts = AA(zA);
        var XA = H(126);
        k.shapeshifter = AA(XA);
        var fA = H(127);
        k.solarized = AA(fA);
        var vA = H(128);
        k.summerfruit = AA(vA);
        var Cg = H(129);
        k.tomorrow = AA(Cg);
        var Ig = H(130);
        k.tube = AA(Ig);
        var gg = H(131);
        k.twilight = AA(gg);
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "threezerotwofour", author: "jan t. sott (http://github.com/idleberg)", base00: "#090300", base01: "#3a3432", base02: "#4a4543", base03: "#5c5855", base04: "#807d7c", base05: "#a5a2a2", base06: "#d6d5d4", base07: "#f7f7f7", base08: "#db2d20", base09: "#e8bbd0", base0A: "#fded02", base0B: "#01a252", base0C: "#b5e4f4", base0D: "#01a0e4", base0E: "#a16a94", base0F: "#cdab53" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "apathy", author: "jannik siebert (https://github.com/janniks)", base00: "#031A16", base01: "#0B342D", base02: "#184E45", base03: "#2B685E", base04: "#5F9C92", base05: "#81B5AC", base06: "#A7CEC8", base07: "#D2E7E4", base08: "#3E9688", base09: "#3E7996", base0A: "#3E4C96", base0B: "#883E96", base0C: "#963E4C", base0D: "#96883E", base0E: "#4C963E", base0F: "#3E965B" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "ashes", author: "jannik siebert (https://github.com/janniks)", base00: "#1C2023", base01: "#393F45", base02: "#565E65", base03: "#747C84", base04: "#ADB3BA", base05: "#C7CCD1", base06: "#DFE2E5", base07: "#F3F4F5", base08: "#C7AE95", base09: "#C7C795", base0A: "#AEC795", base0B: "#95C7AE", base0C: "#95AEC7", base0D: "#AE95C7", base0E: "#C795AE", base0F: "#C79595" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "atelier dune", author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)", base00: "#20201d", base01: "#292824", base02: "#6e6b5e", base03: "#7d7a68", base04: "#999580", base05: "#a6a28c", base06: "#e8e4cf", base07: "#fefbec", base08: "#d73737", base09: "#b65611", base0A: "#cfb017", base0B: "#60ac39", base0C: "#1fad83", base0D: "#6684e1", base0E: "#b854d4", base0F: "#d43552" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "atelier forest", author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)", base00: "#1b1918", base01: "#2c2421", base02: "#68615e", base03: "#766e6b", base04: "#9c9491", base05: "#a8a19f", base06: "#e6e2e0", base07: "#f1efee", base08: "#f22c40", base09: "#df5320", base0A: "#d5911a", base0B: "#5ab738", base0C: "#00ad9c", base0D: "#407ee7", base0E: "#6666ea", base0F: "#c33ff3" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "atelier heath", author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)", base00: "#1b181b", base01: "#292329", base02: "#695d69", base03: "#776977", base04: "#9e8f9e", base05: "#ab9bab", base06: "#d8cad8", base07: "#f7f3f7", base08: "#ca402b", base09: "#a65926", base0A: "#bb8a35", base0B: "#379a37", base0C: "#159393", base0D: "#516aec", base0E: "#7b59c0", base0F: "#cc33cc" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "atelier lakeside", author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)", base00: "#161b1d", base01: "#1f292e", base02: "#516d7b", base03: "#5a7b8c", base04: "#7195a8", base05: "#7ea2b4", base06: "#c1e4f6", base07: "#ebf8ff", base08: "#d22d72", base09: "#935c25", base0A: "#8a8a0f", base0B: "#568c3b", base0C: "#2d8f6f", base0D: "#257fad", base0E: "#5d5db1", base0F: "#b72dd2" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "atelier seaside", author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)", base00: "#131513", base01: "#242924", base02: "#5e6e5e", base03: "#687d68", base04: "#809980", base05: "#8ca68c", base06: "#cfe8cf", base07: "#f0fff0", base08: "#e6193c", base09: "#87711d", base0A: "#c3c322", base0B: "#29a329", base0C: "#1999b3", base0D: "#3d62f5", base0E: "#ad2bee", base0F: "#e619c3" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "bespin", author: "jan t. sott", base00: "#28211c", base01: "#36312e", base02: "#5e5d5c", base03: "#666666", base04: "#797977", base05: "#8a8986", base06: "#9d9b97", base07: "#baae9e", base08: "#cf6a4c", base09: "#cf7d34", base0A: "#f9ee98", base0B: "#54be0d", base0C: "#afc4db", base0D: "#5ea6ea", base0E: "#9b859d", base0F: "#937121" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "brewer", author: "timothée poisot (http://github.com/tpoisot)", base00: "#0c0d0e", base01: "#2e2f30", base02: "#515253", base03: "#737475", base04: "#959697", base05: "#b7b8b9", base06: "#dadbdc", base07: "#fcfdfe", base08: "#e31a1c", base09: "#e6550d", base0A: "#dca060", base0B: "#31a354", base0C: "#80b1d3", base0D: "#3182bd", base0E: "#756bb1", base0F: "#b15928" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "bright", author: "chris kempson (http://chriskempson.com)", base00: "#000000", base01: "#303030", base02: "#505050", base03: "#b0b0b0", base04: "#d0d0d0", base05: "#e0e0e0", base06: "#f5f5f5", base07: "#ffffff", base08: "#fb0120", base09: "#fc6d24", base0A: "#fda331", base0B: "#a1c659", base0C: "#76c7b7", base0D: "#6fb3d2", base0E: "#d381c3", base0F: "#be643c" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "chalk", author: "chris kempson (http://chriskempson.com)", base00: "#151515", base01: "#202020", base02: "#303030", base03: "#505050", base04: "#b0b0b0", base05: "#d0d0d0", base06: "#e0e0e0", base07: "#f5f5f5", base08: "#fb9fb1", base09: "#eda987", base0A: "#ddb26f", base0B: "#acc267", base0C: "#12cfc0", base0D: "#6fc2ef", base0E: "#e1a3ee", base0F: "#deaf8f" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "codeschool", author: "brettof86", base00: "#232c31", base01: "#1c3657", base02: "#2a343a", base03: "#3f4944", base04: "#84898c", base05: "#9ea7a6", base06: "#a7cfa3", base07: "#b5d8f6", base08: "#2a5491", base09: "#43820d", base0A: "#a03b1e", base0B: "#237986", base0C: "#b02f30", base0D: "#484d79", base0E: "#c59820", base0F: "#c98344" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "colors", author: "mrmrs (http://clrs.cc)", base00: "#111111", base01: "#333333", base02: "#555555", base03: "#777777", base04: "#999999", base05: "#bbbbbb", base06: "#dddddd", base07: "#ffffff", base08: "#ff4136", base09: "#ff851b", base0A: "#ffdc00", base0B: "#2ecc40", base0C: "#7fdbff", base0D: "#0074d9", base0E: "#b10dc9", base0F: "#85144b" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "default", author: "chris kempson (http://chriskempson.com)", base00: "#181818", base01: "#282828", base02: "#383838", base03: "#585858", base04: "#b8b8b8", base05: "#d8d8d8", base06: "#e8e8e8", base07: "#f8f8f8", base08: "#ab4642", base09: "#dc9656", base0A: "#f7ca88", base0B: "#a1b56c", base0C: "#86c1b9", base0D: "#7cafc2", base0E: "#ba8baf", base0F: "#a16946" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "eighties", author: "chris kempson (http://chriskempson.com)", base00: "#2d2d2d", base01: "#393939", base02: "#515151", base03: "#747369", base04: "#a09f93", base05: "#d3d0c8", base06: "#e8e6df", base07: "#f2f0ec", base08: "#f2777a", base09: "#f99157", base0A: "#ffcc66", base0B: "#99cc99", base0C: "#66cccc", base0D: "#6699cc", base0E: "#cc99cc", base0F: "#d27b53" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "embers", author: "jannik siebert (https://github.com/janniks)", base00: "#16130F", base01: "#2C2620", base02: "#433B32", base03: "#5A5047", base04: "#8A8075", base05: "#A39A90", base06: "#BEB6AE", base07: "#DBD6D1", base08: "#826D57", base09: "#828257", base0A: "#6D8257", base0B: "#57826D", base0C: "#576D82", base0D: "#6D5782", base0E: "#82576D", base0F: "#825757" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "flat", author: "chris kempson (http://chriskempson.com)", base00: "#2C3E50", base01: "#34495E", base02: "#7F8C8D", base03: "#95A5A6", base04: "#BDC3C7", base05: "#e0e0e0", base06: "#f5f5f5", base07: "#ECF0F1", base08: "#E74C3C", base09: "#E67E22", base0A: "#F1C40F", base0B: "#2ECC71", base0C: "#1ABC9C", base0D: "#3498DB", base0E: "#9B59B6", base0F: "#be643c" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "google", author: "seth wright (http://sethawright.com)", base00: "#1d1f21", base01: "#282a2e", base02: "#373b41", base03: "#969896", base04: "#b4b7b4", base05: "#c5c8c6", base06: "#e0e0e0", base07: "#ffffff", base08: "#CC342B", base09: "#F96A38", base0A: "#FBA922", base0B: "#198844", base0C: "#3971ED", base0D: "#3971ED", base0E: "#A36AC7", base0F: "#3971ED" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "grayscale", author: "alexandre gavioli (https://github.com/alexx2/)", base00: "#101010", base01: "#252525", base02: "#464646", base03: "#525252", base04: "#ababab", base05: "#b9b9b9", base06: "#e3e3e3", base07: "#f7f7f7", base08: "#7c7c7c", base09: "#999999", base0A: "#a0a0a0", base0B: "#8e8e8e", base0C: "#868686", base0D: "#686868", base0E: "#747474", base0F: "#5e5e5e" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "green screen", author: "chris kempson (http://chriskempson.com)", base00: "#001100", base01: "#003300", base02: "#005500", base03: "#007700", base04: "#009900", base05: "#00bb00", base06: "#00dd00", base07: "#00ff00", base08: "#007700", base09: "#009900", base0A: "#007700", base0B: "#00bb00", base0C: "#005500", base0D: "#009900", base0E: "#00bb00", base0F: "#005500" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "harmonic16", author: "jannik siebert (https://github.com/janniks)", base00: "#0b1c2c", base01: "#223b54", base02: "#405c79", base03: "#627e99", base04: "#aabcce", base05: "#cbd6e2", base06: "#e5ebf1", base07: "#f7f9fb", base08: "#bf8b56", base09: "#bfbf56", base0A: "#8bbf56", base0B: "#56bf8b", base0C: "#568bbf", base0D: "#8b56bf", base0E: "#bf568b", base0F: "#bf5656" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "hopscotch", author: "jan t. sott", base00: "#322931", base01: "#433b42", base02: "#5c545b", base03: "#797379", base04: "#989498", base05: "#b9b5b8", base06: "#d5d3d5", base07: "#ffffff", base08: "#dd464c", base09: "#fd8b19", base0A: "#fdcc59", base0B: "#8fc13e", base0C: "#149b93", base0D: "#1290bf", base0E: "#c85e7c", base0F: "#b33508" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "isotope", author: "jan t. sott", base00: "#000000", base01: "#404040", base02: "#606060", base03: "#808080", base04: "#c0c0c0", base05: "#d0d0d0", base06: "#e0e0e0", base07: "#ffffff", base08: "#ff0000", base09: "#ff9900", base0A: "#ff0099", base0B: "#33ff00", base0C: "#00ffff", base0D: "#0066ff", base0E: "#cc00ff", base0F: "#3300ff" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "marrakesh", author: "alexandre gavioli (http://github.com/alexx2/)", base00: "#201602", base01: "#302e00", base02: "#5f5b17", base03: "#6c6823", base04: "#86813b", base05: "#948e48", base06: "#ccc37a", base07: "#faf0a5", base08: "#c35359", base09: "#b36144", base0A: "#a88339", base0B: "#18974e", base0C: "#75a738", base0D: "#477ca1", base0E: "#8868b3", base0F: "#b3588e" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "mocha", author: "chris kempson (http://chriskempson.com)", base00: "#3B3228", base01: "#534636", base02: "#645240", base03: "#7e705a", base04: "#b8afad", base05: "#d0c8c6", base06: "#e9e1dd", base07: "#f5eeeb", base08: "#cb6077", base09: "#d28b71", base0A: "#f4bc87", base0B: "#beb55b", base0C: "#7bbda4", base0D: "#8ab3b5", base0E: "#a89bb9", base0F: "#bb9584" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "monokai", author: "wimer hazenberg (http://www.monokai.nl)", base00: "#272822", base01: "#383830", base02: "#49483e", base03: "#75715e", base04: "#a59f85", base05: "#f8f8f2", base06: "#f5f4f1", base07: "#f9f8f5", base08: "#f92672", base09: "#fd971f", base0A: "#f4bf75", base0B: "#a6e22e", base0C: "#a1efe4", base0D: "#66d9ef", base0E: "#ae81ff", base0F: "#cc6633" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "ocean", author: "chris kempson (http://chriskempson.com)", base00: "#2b303b", base01: "#343d46", base02: "#4f5b66", base03: "#65737e", base04: "#a7adba", base05: "#c0c5ce", base06: "#dfe1e8", base07: "#eff1f5", base08: "#bf616a", base09: "#d08770", base0A: "#ebcb8b", base0B: "#a3be8c", base0C: "#96b5b4", base0D: "#8fa1b3", base0E: "#b48ead", base0F: "#ab7967" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "paraiso", author: "jan t. sott", base00: "#2f1e2e", base01: "#41323f", base02: "#4f424c", base03: "#776e71", base04: "#8d8687", base05: "#a39e9b", base06: "#b9b6b0", base07: "#e7e9db", base08: "#ef6155", base09: "#f99b15", base0A: "#fec418", base0B: "#48b685", base0C: "#5bc4bf", base0D: "#06b6ef", base0E: "#815ba4", base0F: "#e96ba8" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "pop", author: "chris kempson (http://chriskempson.com)", base00: "#000000", base01: "#202020", base02: "#303030", base03: "#505050", base04: "#b0b0b0", base05: "#d0d0d0", base06: "#e0e0e0", base07: "#ffffff", base08: "#eb008a", base09: "#f29333", base0A: "#f8ca12", base0B: "#37b349", base0C: "#00aabb", base0D: "#0e5a94", base0E: "#b31e8d", base0F: "#7a2d00" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "railscasts", author: "ryan bates (http://railscasts.com)", base00: "#2b2b2b", base01: "#272935", base02: "#3a4055", base03: "#5a647e", base04: "#d4cfc9", base05: "#e6e1dc", base06: "#f4f1ed", base07: "#f9f7f3", base08: "#da4939", base09: "#cc7833", base0A: "#ffc66d", base0B: "#a5c261", base0C: "#519f50", base0D: "#6d9cbe", base0E: "#b6b3eb", base0F: "#bc9458" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "shapeshifter", author: "tyler benziger (http://tybenz.com)", base00: "#000000", base01: "#040404", base02: "#102015", base03: "#343434", base04: "#555555", base05: "#ababab", base06: "#e0e0e0", base07: "#f9f9f9", base08: "#e92f2f", base09: "#e09448", base0A: "#dddd13", base0B: "#0ed839", base0C: "#23edda", base0D: "#3b48e3", base0E: "#f996e2", base0F: "#69542d" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "solarized", author: "ethan schoonover (http://ethanschoonover.com/solarized)", base00: "#002b36", base01: "#073642", base02: "#586e75", base03: "#657b83", base04: "#839496", base05: "#93a1a1", base06: "#eee8d5", base07: "#fdf6e3", base08: "#dc322f", base09: "#cb4b16", base0A: "#b58900", base0B: "#859900", base0C: "#2aa198", base0D: "#268bd2", base0E: "#6c71c4", base0F: "#d33682" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "summerfruit", author: "christopher corley (http://cscorley.github.io/)", base00: "#151515", base01: "#202020", base02: "#303030", base03: "#505050", base04: "#B0B0B0", base05: "#D0D0D0", base06: "#E0E0E0", base07: "#FFFFFF", base08: "#FF0086", base09: "#FD8900", base0A: "#ABA800", base0B: "#00C918", base0C: "#1faaaa", base0D: "#3777E6", base0E: "#AD00A1", base0F: "#cc6633" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "tomorrow", author: "chris kempson (http://chriskempson.com)", base00: "#1d1f21", base01: "#282a2e", base02: "#373b41", base03: "#969896", base04: "#b4b7b4", base05: "#c5c8c6", base06: "#e0e0e0", base07: "#ffffff", base08: "#cc6666", base09: "#de935f", base0A: "#f0c674", base0B: "#b5bd68", base0C: "#8abeb7", base0D: "#81a2be", base0E: "#b294bb", base0F: "#a3685a" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "london tube", author: "jan t. sott", base00: "#231f20", base01: "#1c3f95", base02: "#5a5758", base03: "#737171", base04: "#959ca1", base05: "#d9d8d8", base06: "#e7e7e8", base07: "#ffffff", base08: "#ee2e24", base09: "#f386a1", base0A: "#ffd204", base0B: "#00853e", base0C: "#85cebc", base0D: "#009ddc", base0E: "#98005d", base0F: "#b06110" }, d.exports = k.default;
      }, function(d, k, H) {
        k.__esModule = !0, k.default = { scheme: "twilight", author: "david hart (http://hart-dev.com)", base00: "#1e1e1e", base01: "#323537", base02: "#464b50", base03: "#5f5a60", base04: "#838184", base05: "#a7a7a7", base06: "#c3c3c3", base07: "#ffffff", base08: "#cf6a4c", base09: "#cda869", base0A: "#f9ee98", base0B: "#8f9d6a", base0C: "#afc4db", base0D: "#7587a6", base0E: "#9b859d", base0F: "#9b703f" }, d.exports = k.default;
      }, function(d, k, H) {
        var AA = H(33);
        function gA(IA) {
          var CA = Math.round(AA(IA, 0, 255)).toString(16);
          return CA.length == 1 ? "0" + CA : CA;
        }
        d.exports = function(IA) {
          var CA = IA.length === 4 ? gA(255 * IA[3]) : "";
          return "#" + gA(IA[0]) + gA(IA[1]) + gA(IA[2]) + CA;
        };
      }, function(d, k, H) {
        var AA = H(134), gA = H(135), IA = H(136), CA = H(137), BA = { "#": gA, hsl: function(iA) {
          var QA = AA(iA), tA = CA(QA);
          return QA.length === 4 && tA.push(QA[3]), tA;
        }, rgb: IA };
        function eA(iA) {
          for (var QA in BA) if (iA.indexOf(QA) === 0) return BA[QA](iA);
        }
        eA.rgb = IA, eA.hsl = AA, eA.hex = gA, d.exports = eA;
      }, function(d, k, H) {
        var AA = H(44), gA = H(33);
        function IA(CA, BA) {
          switch (CA = parseFloat(CA), BA) {
            case 0:
              return gA(CA, 0, 360);
            case 1:
            case 2:
              return gA(CA, 0, 100);
            case 3:
              return gA(CA, 0, 1);
          }
        }
        d.exports = function(CA) {
          return AA(CA).map(IA);
        };
      }, function(d, k) {
        d.exports = function(H) {
          H.length !== 4 && H.length !== 5 || (H = (function(IA) {
            for (var CA = "#", BA = 1; BA < IA.length; BA++) {
              var eA = IA.charAt(BA);
              CA += eA + eA;
            }
            return CA;
          })(H));
          var AA = [parseInt(H.substring(1, 3), 16), parseInt(H.substring(3, 5), 16), parseInt(H.substring(5, 7), 16)];
          if (H.length === 9) {
            var gA = parseFloat((parseInt(H.substring(7, 9), 16) / 255).toFixed(2));
            AA.push(gA);
          }
          return AA;
        };
      }, function(d, k, H) {
        var AA = H(44), gA = H(33);
        function IA(CA, BA) {
          return BA < 3 ? CA.indexOf("%") != -1 ? Math.round(255 * gA(parseInt(CA, 10), 0, 100) / 100) : gA(parseInt(CA, 10), 0, 255) : gA(parseFloat(CA), 0, 1);
        }
        d.exports = function(CA) {
          return AA(CA).map(IA);
        };
      }, function(d, k) {
        d.exports = function(H) {
          var AA, gA, IA, CA, BA, eA = H[0] / 360, iA = H[1] / 100, QA = H[2] / 100;
          if (iA == 0) return [BA = 255 * QA, BA, BA];
          AA = 2 * QA - (gA = QA < 0.5 ? QA * (1 + iA) : QA + iA - QA * iA), CA = [0, 0, 0];
          for (var tA = 0; tA < 3; tA++) (IA = eA + 1 / 3 * -(tA - 1)) < 0 && IA++, IA > 1 && IA--, BA = 6 * IA < 1 ? AA + 6 * (gA - AA) * IA : 2 * IA < 1 ? gA : 3 * IA < 2 ? AA + (gA - AA) * (2 / 3 - IA) * 6 : AA, CA[tA] = 255 * BA;
          return CA;
        };
      }, function(d, k, H) {
        (function(AA) {
          var gA = typeof AA == "object" && AA && AA.Object === Object && AA, IA = typeof self == "object" && self && self.Object === Object && self, CA = gA || IA || Function("return this")();
          function BA(dA, GA, DA) {
            switch (DA.length) {
              case 0:
                return dA.call(GA);
              case 1:
                return dA.call(GA, DA[0]);
              case 2:
                return dA.call(GA, DA[0], DA[1]);
              case 3:
                return dA.call(GA, DA[0], DA[1], DA[2]);
            }
            return dA.apply(GA, DA);
          }
          function eA(dA, GA) {
            for (var DA = -1, wA = GA.length, bA = dA.length; ++DA < wA; ) dA[bA + DA] = GA[DA];
            return dA;
          }
          var iA = Object.prototype, QA = iA.hasOwnProperty, tA = iA.toString, oA = CA.Symbol, EA = iA.propertyIsEnumerable, aA = oA ? oA.isConcatSpreadable : void 0, nA = Math.max;
          function lA(dA) {
            return cA(dA) || (function(GA) {
              return (function(DA) {
                return /* @__PURE__ */ (function(wA) {
                  return !!wA && typeof wA == "object";
                })(DA) && (function(wA) {
                  return wA != null && (function(bA) {
                    return typeof bA == "number" && bA > -1 && bA % 1 == 0 && bA <= 9007199254740991;
                  })(wA.length) && !(function(bA) {
                    var yA = (function(pA) {
                      var MA = typeof pA;
                      return !!pA && (MA == "object" || MA == "function");
                    })(bA) ? tA.call(bA) : "";
                    return yA == "[object Function]" || yA == "[object GeneratorFunction]";
                  })(wA);
                })(DA);
              })(GA) && QA.call(GA, "callee") && (!EA.call(GA, "callee") || tA.call(GA) == "[object Arguments]");
            })(dA) || !!(aA && dA && dA[aA]);
          }
          var cA = Array.isArray, sA, rA, uA, hA = (rA = function(dA) {
            var GA = (dA = (function(bA, yA, pA, MA, LA) {
              var xA = -1, TA = bA.length;
              for (pA || (pA = lA), LA || (LA = []); ++xA < TA; ) {
                var NA = bA[xA];
                pA(NA) ? eA(LA, NA) : LA[LA.length] = NA;
              }
              return LA;
            })(dA)).length, DA = GA;
            for (sA; DA--; ) if (typeof dA[DA] != "function") throw new TypeError("Expected a function");
            return function() {
              for (var wA = 0, bA = GA ? dA[wA].apply(this, arguments) : arguments[0]; ++wA < GA; ) bA = dA[wA].call(this, bA);
              return bA;
            };
          }, uA = nA(uA === void 0 ? rA.length - 1 : uA, 0), function() {
            for (var dA = arguments, GA = -1, DA = nA(dA.length - uA, 0), wA = Array(DA); ++GA < DA; ) wA[GA] = dA[uA + GA];
            GA = -1;
            for (var bA = Array(uA + 1); ++GA < uA; ) bA[GA] = dA[GA];
            return bA[uA] = wA, BA(rA, this, bA);
          });
          d.exports = hA;
        }).call(this, H(43));
      }, function(d, k, H) {
        Object.defineProperty(k, "__esModule", { value: !0 }), k.yuv2rgb = function(AA) {
          var gA, IA, CA, BA = AA[0], eA = AA[1], iA = AA[2];
          return gA = 1 * BA + 0 * eA + 1.13983 * iA, IA = 1 * BA + -0.39465 * eA + -0.5806 * iA, CA = 1 * BA + 2.02311 * eA + 0 * iA, gA = Math.min(Math.max(0, gA), 1), IA = Math.min(Math.max(0, IA), 1), CA = Math.min(Math.max(0, CA), 1), [255 * gA, 255 * IA, 255 * CA];
        }, k.rgb2yuv = function(AA) {
          var gA = AA[0] / 255, IA = AA[1] / 255, CA = AA[2] / 255;
          return [0.299 * gA + 0.587 * IA + 0.114 * CA, -0.14713 * gA + -0.28886 * IA + 0.436 * CA, 0.615 * gA + -0.51499 * IA + -0.10001 * CA];
        };
      }, function(d, k, H) {
        function AA(CA, BA, eA) {
          return BA in CA ? Object.defineProperty(CA, BA, { value: eA, enumerable: !0, configurable: !0, writable: !0 }) : CA[BA] = eA, CA;
        }
        var gA = H(141), IA = (function() {
          function CA() {
            AA(this, "_callbacks", void 0), AA(this, "_isDispatching", void 0), AA(this, "_isHandled", void 0), AA(this, "_isPending", void 0), AA(this, "_lastID", void 0), AA(this, "_pendingPayload", void 0), this._callbacks = {}, this._isDispatching = !1, this._isHandled = {}, this._isPending = {}, this._lastID = 1;
          }
          var BA = CA.prototype;
          return BA.register = function(eA) {
            var iA = "ID_" + this._lastID++;
            return this._callbacks[iA] = eA, iA;
          }, BA.unregister = function(eA) {
            this._callbacks[eA] || gA(!1), delete this._callbacks[eA];
          }, BA.waitFor = function(eA) {
            this._isDispatching || gA(!1);
            for (var iA = 0; iA < eA.length; iA++) {
              var QA = eA[iA];
              this._isPending[QA] ? this._isHandled[QA] || gA(!1) : (this._callbacks[QA] || gA(!1), this._invokeCallback(QA));
            }
          }, BA.dispatch = function(eA) {
            this._isDispatching && gA(!1), this._startDispatching(eA);
            try {
              for (var iA in this._callbacks) this._isPending[iA] || this._invokeCallback(iA);
            } finally {
              this._stopDispatching();
            }
          }, BA.isDispatching = function() {
            return this._isDispatching;
          }, BA._invokeCallback = function(eA) {
            this._isPending[eA] = !0, this._callbacks[eA](this._pendingPayload), this._isHandled[eA] = !0;
          }, BA._startDispatching = function(eA) {
            for (var iA in this._callbacks) this._isPending[iA] = !1, this._isHandled[iA] = !1;
            this._pendingPayload = eA, this._isDispatching = !0;
          }, BA._stopDispatching = function() {
            delete this._pendingPayload, this._isDispatching = !1;
          }, CA;
        })();
        d.exports = IA;
      }, function(d, k, H) {
        d.exports = function(AA, gA) {
          for (var IA = arguments.length, CA = new Array(IA > 2 ? IA - 2 : 0), BA = 2; BA < IA; BA++) CA[BA - 2] = arguments[BA];
          if (!AA) {
            var eA;
            if (gA === void 0) eA = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
              var iA = 0;
              (eA = new Error(gA.replace(/%s/g, (function() {
                return String(CA[iA++]);
              })))).name = "Invariant Violation";
            }
            throw eA.framesToPop = 1, eA;
          }
        };
      }, function(d, k, H) {
        function AA(UA, qA, SA) {
          return qA in UA ? Object.defineProperty(UA, qA, { value: SA, enumerable: !0, configurable: !0, writable: !0 }) : UA[qA] = SA, UA;
        }
        function gA(UA, qA) {
          var SA = Object.keys(UA);
          if (Object.getOwnPropertySymbols) {
            var WA = Object.getOwnPropertySymbols(UA);
            qA && (WA = WA.filter((function(OA) {
              return Object.getOwnPropertyDescriptor(UA, OA).enumerable;
            }))), SA.push.apply(SA, WA);
          }
          return SA;
        }
        function IA(UA) {
          for (var qA = 1; qA < arguments.length; qA++) {
            var SA = arguments[qA] != null ? arguments[qA] : {};
            qA % 2 ? gA(Object(SA), !0).forEach((function(WA) {
              AA(UA, WA, SA[WA]);
            })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(UA, Object.getOwnPropertyDescriptors(SA)) : gA(Object(SA)).forEach((function(WA) {
              Object.defineProperty(UA, WA, Object.getOwnPropertyDescriptor(SA, WA));
            }));
          }
          return UA;
        }
        function CA(UA, qA) {
          if (!(UA instanceof qA)) throw new TypeError("Cannot call a class as a function");
        }
        function BA(UA, qA) {
          for (var SA = 0; SA < qA.length; SA++) {
            var WA = qA[SA];
            WA.enumerable = WA.enumerable || !1, WA.configurable = !0, "value" in WA && (WA.writable = !0), Object.defineProperty(UA, WA.key, WA);
          }
        }
        function eA(UA, qA, SA) {
          return qA && BA(UA.prototype, qA), SA && BA(UA, SA), UA;
        }
        function iA(UA, qA) {
          return (iA = Object.setPrototypeOf || function(SA, WA) {
            return SA.__proto__ = WA, SA;
          })(UA, qA);
        }
        function QA(UA, qA) {
          if (typeof qA != "function" && qA !== null) throw new TypeError("Super expression must either be null or a function");
          UA.prototype = Object.create(qA && qA.prototype, { constructor: { value: UA, writable: !0, configurable: !0 } }), qA && iA(UA, qA);
        }
        function tA(UA) {
          return (tA = Object.setPrototypeOf ? Object.getPrototypeOf : function(qA) {
            return qA.__proto__ || Object.getPrototypeOf(qA);
          })(UA);
        }
        function oA(UA) {
          return (oA = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(qA) {
            return typeof qA;
          } : function(qA) {
            return qA && typeof Symbol == "function" && qA.constructor === Symbol && qA !== Symbol.prototype ? "symbol" : typeof qA;
          })(UA);
        }
        function EA(UA) {
          if (UA === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return UA;
        }
        function aA(UA, qA) {
          return !qA || oA(qA) !== "object" && typeof qA != "function" ? EA(UA) : qA;
        }
        function nA(UA) {
          var qA = (function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], (function() {
              }))), !0;
            } catch {
              return !1;
            }
          })();
          return function() {
            var SA, WA = tA(UA);
            if (qA) {
              var OA = tA(this).constructor;
              SA = Reflect.construct(WA, arguments, OA);
            } else SA = WA.apply(this, arguments);
            return aA(this, SA);
          };
        }
        H.r(k);
        var lA = H(0), cA = H.n(lA);
        function sA() {
          var UA = this.constructor.getDerivedStateFromProps(this.props, this.state);
          UA != null && this.setState(UA);
        }
        function rA(UA) {
          this.setState((function(qA) {
            var SA = this.constructor.getDerivedStateFromProps(UA, qA);
            return SA ?? null;
          }).bind(this));
        }
        function uA(UA, qA) {
          try {
            var SA = this.props, WA = this.state;
            this.props = UA, this.state = qA, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(SA, WA);
          } finally {
            this.props = SA, this.state = WA;
          }
        }
        function hA(UA) {
          var qA = UA.prototype;
          if (!qA || !qA.isReactComponent) throw new Error("Can only polyfill class components");
          if (typeof UA.getDerivedStateFromProps != "function" && typeof qA.getSnapshotBeforeUpdate != "function") return UA;
          var SA = null, WA = null, OA = null;
          if (typeof qA.componentWillMount == "function" ? SA = "componentWillMount" : typeof qA.UNSAFE_componentWillMount == "function" && (SA = "UNSAFE_componentWillMount"), typeof qA.componentWillReceiveProps == "function" ? WA = "componentWillReceiveProps" : typeof qA.UNSAFE_componentWillReceiveProps == "function" && (WA = "UNSAFE_componentWillReceiveProps"), typeof qA.componentWillUpdate == "function" ? OA = "componentWillUpdate" : typeof qA.UNSAFE_componentWillUpdate == "function" && (OA = "UNSAFE_componentWillUpdate"), SA !== null || WA !== null || OA !== null) {
            var Bg = UA.displayName || UA.name, dg = typeof UA.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            throw Error(`Unsafe legacy lifecycles will not be called for components using new component APIs.

` + Bg + " uses " + dg + " but also contains the following legacy lifecycles:" + (SA !== null ? `
  ` + SA : "") + (WA !== null ? `
  ` + WA : "") + (OA !== null ? `
  ` + OA : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`);
          }
          if (typeof UA.getDerivedStateFromProps == "function" && (qA.componentWillMount = sA, qA.componentWillReceiveProps = rA), typeof qA.getSnapshotBeforeUpdate == "function") {
            if (typeof qA.componentDidUpdate != "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
            qA.componentWillUpdate = uA;
            var lg = qA.componentDidUpdate;
            qA.componentDidUpdate = function(Qg, pg, Fg) {
              var Yg = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : Fg;
              lg.call(this, Qg, pg, Yg);
            };
          }
          return UA;
        }
        function dA(UA, qA) {
          if (UA == null) return {};
          var SA, WA, OA = (function(dg, lg) {
            if (dg == null) return {};
            var Qg, pg, Fg = {}, Yg = Object.keys(dg);
            for (pg = 0; pg < Yg.length; pg++) Qg = Yg[pg], lg.indexOf(Qg) >= 0 || (Fg[Qg] = dg[Qg]);
            return Fg;
          })(UA, qA);
          if (Object.getOwnPropertySymbols) {
            var Bg = Object.getOwnPropertySymbols(UA);
            for (WA = 0; WA < Bg.length; WA++) SA = Bg[WA], qA.indexOf(SA) >= 0 || Object.prototype.propertyIsEnumerable.call(UA, SA) && (OA[SA] = UA[SA]);
          }
          return OA;
        }
        function GA(UA) {
          var qA = (function(SA) {
            return {}.toString.call(SA).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
          })(UA);
          return qA === "number" && (qA = isNaN(UA) ? "nan" : (0 | UA) != UA ? "float" : "integer"), qA;
        }
        sA.__suppressDeprecationWarning = !0, rA.__suppressDeprecationWarning = !0, uA.__suppressDeprecationWarning = !0;
        var DA = { scheme: "rjv-default", author: "mac gainor", base00: "rgba(0, 0, 0, 0)", base01: "rgb(245, 245, 245)", base02: "rgb(235, 235, 235)", base03: "#93a1a1", base04: "rgba(0, 0, 0, 0.3)", base05: "#586e75", base06: "#073642", base07: "#002b36", base08: "#d33682", base09: "#cb4b16", base0A: "#dc322f", base0B: "#859900", base0C: "#6c71c4", base0D: "#586e75", base0E: "#2aa198", base0F: "#268bd2" }, wA = { scheme: "rjv-grey", author: "mac gainor", base00: "rgba(1, 1, 1, 0)", base01: "rgba(1, 1, 1, 0.1)", base02: "rgba(0, 0, 0, 0.2)", base03: "rgba(1, 1, 1, 0.3)", base04: "rgba(0, 0, 0, 0.4)", base05: "rgba(1, 1, 1, 0.5)", base06: "rgba(1, 1, 1, 0.6)", base07: "rgba(1, 1, 1, 0.7)", base08: "rgba(1, 1, 1, 0.8)", base09: "rgba(1, 1, 1, 0.8)", base0A: "rgba(1, 1, 1, 0.8)", base0B: "rgba(1, 1, 1, 0.8)", base0C: "rgba(1, 1, 1, 0.8)", base0D: "rgba(1, 1, 1, 0.8)", base0E: "rgba(1, 1, 1, 0.8)", base0F: "rgba(1, 1, 1, 0.8)" }, bA = { globalFontFamily: "monospace", globalCursor: "default", braceFontWeight: "bold", braceCursor: "pointer", ellipsisFontSize: "18px", ellipsisLineHeight: "10px", ellipsisCursor: "pointer", keyMargin: "0px 5px", keyLetterSpacing: "0.5px", keyFontStyle: "none", keyVerticalAlign: "top", keyOpacity: "0.85", keyOpacityHover: "1", keyValPaddingTop: "3px", keyValPaddingBottom: "3px", keyValPaddingRight: "5px", keyValBorderLeft: "1px solid", keyValBorderHover: "2px solid", pushedContentMarginLeft: "6px", variableValuePaddingRight: "6px", nullFontSize: "11px", nullFontWeight: "bold", nullPadding: "1px 2px", nullBorderRadius: "3px", nanFontSize: "11px", nanFontWeight: "bold", nanPadding: "1px 2px", nanBorderRadius: "3px", undefinedFontSize: "11px", undefinedPadding: "1px 2px", undefinedBorderRadius: "3px", dataTypeFontSize: "11px", dataTypeMarginRight: "4px", datatypeOpacity: "0.8", objectSizeBorderRadius: "3px", objectSizeFontStyle: "italic", objectSizeMargin: "0px 6px 0px 0px", clipboardCursor: "pointer", clipboardCheckMarginLeft: "-12px", metaDataPadding: "0px 0px 0px 10px", arrayGroupMetaPadding: "0px 0px 0px 4px", iconContainerWidth: "17px", tooltipPadding: "4px", editInputMinWidth: "130px", editInputBorderRadius: "2px", editInputPadding: "5px", editInputMarginRight: "4px", editInputFontFamily: "monospace", iconCursor: "pointer", iconFontSize: "15px", iconPaddingRight: "1px", dateValueMarginLeft: "2px", iconMarginRight: "3px", detectedRowPaddingTop: "3px", addKeyCoverBackground: "rgba(255, 255, 255, 0.3)", addKeyCoverPosition: "absolute", addKeyCoverPositionPx: "0px", addKeyModalWidth: "200px", addKeyModalMargin: "auto", addKeyModalPadding: "10px", addKeyModalRadius: "3px" }, yA = H(45), pA = function(UA) {
          var qA = (function(SA) {
            return { backgroundColor: SA.base00, ellipsisColor: SA.base09, braceColor: SA.base07, expandedIcon: SA.base0D, collapsedIcon: SA.base0E, keyColor: SA.base07, arrayKeyColor: SA.base0C, objectSize: SA.base04, copyToClipboard: SA.base0F, copyToClipboardCheck: SA.base0D, objectBorder: SA.base02, dataTypes: { boolean: SA.base0E, date: SA.base0D, float: SA.base0B, function: SA.base0D, integer: SA.base0F, string: SA.base09, nan: SA.base08, null: SA.base0A, undefined: SA.base05, regexp: SA.base0A, background: SA.base02 }, editVariable: { editIcon: SA.base0E, cancelIcon: SA.base09, removeIcon: SA.base09, addIcon: SA.base0E, checkIcon: SA.base0E, background: SA.base01, color: SA.base0A, border: SA.base07 }, addKeyModal: { background: SA.base05, border: SA.base04, color: SA.base0A, labelColor: SA.base01 }, validationFailure: { background: SA.base09, iconColor: SA.base01, fontColor: SA.base01 } };
          })(UA);
          return { "app-container": { fontFamily: bA.globalFontFamily, cursor: bA.globalCursor, backgroundColor: qA.backgroundColor, position: "relative" }, ellipsis: { display: "inline-block", color: qA.ellipsisColor, fontSize: bA.ellipsisFontSize, lineHeight: bA.ellipsisLineHeight, cursor: bA.ellipsisCursor }, "brace-row": { display: "inline-block", cursor: "pointer" }, brace: { display: "inline-block", cursor: bA.braceCursor, fontWeight: bA.braceFontWeight, color: qA.braceColor }, "expanded-icon": { color: qA.expandedIcon }, "collapsed-icon": { color: qA.collapsedIcon }, colon: { display: "inline-block", margin: bA.keyMargin, color: qA.keyColor, verticalAlign: "top" }, objectKeyVal: function(SA, WA) {
            return { style: IA({ paddingTop: bA.keyValPaddingTop, paddingRight: bA.keyValPaddingRight, paddingBottom: bA.keyValPaddingBottom, borderLeft: bA.keyValBorderLeft + " " + qA.objectBorder, ":hover": { paddingLeft: WA.paddingLeft - 1 + "px", borderLeft: bA.keyValBorderHover + " " + qA.objectBorder } }, WA) };
          }, "object-key-val-no-border": { padding: bA.keyValPadding }, "pushed-content": { marginLeft: bA.pushedContentMarginLeft }, variableValue: function(SA, WA) {
            return { style: IA({ display: "inline-block", paddingRight: bA.variableValuePaddingRight, position: "relative" }, WA) };
          }, "object-name": { display: "inline-block", color: qA.keyColor, letterSpacing: bA.keyLetterSpacing, fontStyle: bA.keyFontStyle, verticalAlign: bA.keyVerticalAlign, opacity: bA.keyOpacity, ":hover": { opacity: bA.keyOpacityHover } }, "array-key": { display: "inline-block", color: qA.arrayKeyColor, letterSpacing: bA.keyLetterSpacing, fontStyle: bA.keyFontStyle, verticalAlign: bA.keyVerticalAlign, opacity: bA.keyOpacity, ":hover": { opacity: bA.keyOpacityHover } }, "object-size": { color: qA.objectSize, borderRadius: bA.objectSizeBorderRadius, fontStyle: bA.objectSizeFontStyle, margin: bA.objectSizeMargin, cursor: "default" }, "data-type-label": { fontSize: bA.dataTypeFontSize, marginRight: bA.dataTypeMarginRight, opacity: bA.datatypeOpacity }, boolean: { display: "inline-block", color: qA.dataTypes.boolean }, date: { display: "inline-block", color: qA.dataTypes.date }, "date-value": { marginLeft: bA.dateValueMarginLeft }, float: { display: "inline-block", color: qA.dataTypes.float }, function: { display: "inline-block", color: qA.dataTypes.function, cursor: "pointer", whiteSpace: "pre-line" }, "function-value": { fontStyle: "italic" }, integer: { display: "inline-block", color: qA.dataTypes.integer }, string: { display: "inline-block", color: qA.dataTypes.string }, nan: { display: "inline-block", color: qA.dataTypes.nan, fontSize: bA.nanFontSize, fontWeight: bA.nanFontWeight, backgroundColor: qA.dataTypes.background, padding: bA.nanPadding, borderRadius: bA.nanBorderRadius }, null: { display: "inline-block", color: qA.dataTypes.null, fontSize: bA.nullFontSize, fontWeight: bA.nullFontWeight, backgroundColor: qA.dataTypes.background, padding: bA.nullPadding, borderRadius: bA.nullBorderRadius }, undefined: { display: "inline-block", color: qA.dataTypes.undefined, fontSize: bA.undefinedFontSize, padding: bA.undefinedPadding, borderRadius: bA.undefinedBorderRadius, backgroundColor: qA.dataTypes.background }, regexp: { display: "inline-block", color: qA.dataTypes.regexp }, "copy-to-clipboard": { cursor: bA.clipboardCursor }, "copy-icon": { color: qA.copyToClipboard, fontSize: bA.iconFontSize, marginRight: bA.iconMarginRight, verticalAlign: "top" }, "copy-icon-copied": { color: qA.copyToClipboardCheck, marginLeft: bA.clipboardCheckMarginLeft }, "array-group-meta-data": { display: "inline-block", padding: bA.arrayGroupMetaPadding }, "object-meta-data": { display: "inline-block", padding: bA.metaDataPadding }, "icon-container": { display: "inline-block", width: bA.iconContainerWidth }, tooltip: { padding: bA.tooltipPadding }, removeVarIcon: { verticalAlign: "top", display: "inline-block", color: qA.editVariable.removeIcon, cursor: bA.iconCursor, fontSize: bA.iconFontSize, marginRight: bA.iconMarginRight }, addVarIcon: { verticalAlign: "top", display: "inline-block", color: qA.editVariable.addIcon, cursor: bA.iconCursor, fontSize: bA.iconFontSize, marginRight: bA.iconMarginRight }, editVarIcon: { verticalAlign: "top", display: "inline-block", color: qA.editVariable.editIcon, cursor: bA.iconCursor, fontSize: bA.iconFontSize, marginRight: bA.iconMarginRight }, "edit-icon-container": { display: "inline-block", verticalAlign: "top" }, "check-icon": { display: "inline-block", cursor: bA.iconCursor, color: qA.editVariable.checkIcon, fontSize: bA.iconFontSize, paddingRight: bA.iconPaddingRight }, "cancel-icon": { display: "inline-block", cursor: bA.iconCursor, color: qA.editVariable.cancelIcon, fontSize: bA.iconFontSize, paddingRight: bA.iconPaddingRight }, "edit-input": { display: "inline-block", minWidth: bA.editInputMinWidth, borderRadius: bA.editInputBorderRadius, backgroundColor: qA.editVariable.background, color: qA.editVariable.color, padding: bA.editInputPadding, marginRight: bA.editInputMarginRight, fontFamily: bA.editInputFontFamily }, "detected-row": { paddingTop: bA.detectedRowPaddingTop }, "key-modal-request": { position: bA.addKeyCoverPosition, top: bA.addKeyCoverPositionPx, left: bA.addKeyCoverPositionPx, right: bA.addKeyCoverPositionPx, bottom: bA.addKeyCoverPositionPx, backgroundColor: bA.addKeyCoverBackground }, "key-modal": { width: bA.addKeyModalWidth, backgroundColor: qA.addKeyModal.background, marginLeft: bA.addKeyModalMargin, marginRight: bA.addKeyModalMargin, padding: bA.addKeyModalPadding, borderRadius: bA.addKeyModalRadius, marginTop: "15px", position: "relative" }, "key-modal-label": { color: qA.addKeyModal.labelColor, marginLeft: "2px", marginBottom: "5px", fontSize: "11px" }, "key-modal-input-container": { overflow: "hidden" }, "key-modal-input": { width: "100%", padding: "3px 6px", fontFamily: "monospace", color: qA.addKeyModal.color, border: "none", boxSizing: "border-box", borderRadius: "2px" }, "key-modal-cancel": { backgroundColor: qA.editVariable.removeIcon, position: "absolute", top: "0px", right: "0px", borderRadius: "0px 3px 0px 3px", cursor: "pointer" }, "key-modal-cancel-icon": { color: qA.addKeyModal.labelColor, fontSize: bA.iconFontSize, transform: "rotate(45deg)" }, "key-modal-submit": { color: qA.editVariable.addIcon, fontSize: bA.iconFontSize, position: "absolute", right: "2px", top: "3px", cursor: "pointer" }, "function-ellipsis": { display: "inline-block", color: qA.ellipsisColor, fontSize: bA.ellipsisFontSize, lineHeight: bA.ellipsisLineHeight, cursor: bA.ellipsisCursor }, "validation-failure": { float: "right", padding: "3px 6px", borderRadius: "2px", cursor: "pointer", color: qA.validationFailure.fontColor, backgroundColor: qA.validationFailure.background }, "validation-failure-label": { marginRight: "6px" }, "validation-failure-clear": { position: "relative", verticalAlign: "top", cursor: "pointer", color: qA.validationFailure.iconColor, fontSize: bA.iconFontSize, transform: "rotate(45deg)" } };
        };
        function MA(UA, qA, SA) {
          return UA || console.error("theme has not been set"), (function(WA) {
            var OA = DA;
            return WA !== !1 && WA !== "none" || (OA = wA), Object(yA.createStyling)(pA, { defaultBase16: OA })(WA);
          })(UA)(qA, SA);
        }
        var LA = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = (WA.rjvId, WA.type_name), Bg = WA.displayDataTypes, dg = WA.theme;
            return Bg ? cA.a.createElement("span", Object.assign({ className: "data-type-label" }, MA(dg, "data-type-label")), OA) : null;
          } }]), SA;
        })(cA.a.PureComponent), xA = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props;
            return cA.a.createElement("div", MA(WA.theme, "boolean"), cA.a.createElement(LA, Object.assign({ type_name: "bool" }, WA)), WA.value ? "true" : "false");
          } }]), SA;
        })(cA.a.PureComponent), TA = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props;
            return cA.a.createElement("div", MA(WA.theme, "date"), cA.a.createElement(LA, Object.assign({ type_name: "date" }, WA)), cA.a.createElement("span", Object.assign({ className: "date-value" }, MA(WA.theme, "date-value")), WA.value.toLocaleTimeString("en-us", { weekday: "short", year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })));
          } }]), SA;
        })(cA.a.PureComponent), NA = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props;
            return cA.a.createElement("div", MA(WA.theme, "float"), cA.a.createElement(LA, Object.assign({ type_name: "float" }, WA)), this.props.value);
          } }]), SA;
        })(cA.a.PureComponent);
        function zA(UA, qA) {
          (qA == null || qA > UA.length) && (qA = UA.length);
          for (var SA = 0, WA = new Array(qA); SA < qA; SA++) WA[SA] = UA[SA];
          return WA;
        }
        function XA(UA, qA) {
          if (UA) {
            if (typeof UA == "string") return zA(UA, qA);
            var SA = Object.prototype.toString.call(UA).slice(8, -1);
            return SA === "Object" && UA.constructor && (SA = UA.constructor.name), SA === "Map" || SA === "Set" ? Array.from(UA) : SA === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(SA) ? zA(UA, qA) : void 0;
          }
        }
        function fA(UA, qA) {
          var SA;
          if (typeof Symbol > "u" || UA[Symbol.iterator] == null) {
            if (Array.isArray(UA) || (SA = XA(UA)) || qA) {
              SA && (UA = SA);
              var WA = 0, OA = function() {
              };
              return { s: OA, n: function() {
                return WA >= UA.length ? { done: !0 } : { done: !1, value: UA[WA++] };
              }, e: function(Qg) {
                throw Qg;
              }, f: OA };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          var Bg, dg = !0, lg = !1;
          return { s: function() {
            SA = UA[Symbol.iterator]();
          }, n: function() {
            var Qg = SA.next();
            return dg = Qg.done, Qg;
          }, e: function(Qg) {
            lg = !0, Bg = Qg;
          }, f: function() {
            try {
              dg || SA.return == null || SA.return();
            } finally {
              if (lg) throw Bg;
            }
          } };
        }
        function vA(UA) {
          return (function(qA) {
            if (Array.isArray(qA)) return zA(qA);
          })(UA) || (function(qA) {
            if (typeof Symbol < "u" && Symbol.iterator in Object(qA)) return Array.from(qA);
          })(UA) || XA(UA) || (function() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          })();
        }
        var Cg = H(46), Ig = new (H(47)).Dispatcher(), gg = new ((function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            var WA;
            CA(this, SA);
            for (var OA = arguments.length, Bg = new Array(OA), dg = 0; dg < OA; dg++) Bg[dg] = arguments[dg];
            return (WA = qA.call.apply(qA, [this].concat(Bg))).objects = {}, WA.set = function(lg, Qg, pg, Fg) {
              WA.objects[lg] === void 0 && (WA.objects[lg] = {}), WA.objects[lg][Qg] === void 0 && (WA.objects[lg][Qg] = {}), WA.objects[lg][Qg][pg] = Fg;
            }, WA.get = function(lg, Qg, pg, Fg) {
              return WA.objects[lg] === void 0 || WA.objects[lg][Qg] === void 0 || WA.objects[lg][Qg][pg] == null ? Fg : WA.objects[lg][Qg][pg];
            }, WA.handleAction = function(lg) {
              var Qg = lg.rjvId, pg = lg.data;
              switch (lg.name) {
                case "RESET":
                  WA.emit("reset-" + Qg);
                  break;
                case "VARIABLE_UPDATED":
                  lg.data.updated_src = WA.updateSrc(Qg, pg), WA.set(Qg, "action", "variable-update", IA(IA({}, pg), {}, { type: "variable-edited" })), WA.emit("variable-update-" + Qg);
                  break;
                case "VARIABLE_REMOVED":
                  lg.data.updated_src = WA.updateSrc(Qg, pg), WA.set(Qg, "action", "variable-update", IA(IA({}, pg), {}, { type: "variable-removed" })), WA.emit("variable-update-" + Qg);
                  break;
                case "VARIABLE_ADDED":
                  lg.data.updated_src = WA.updateSrc(Qg, pg), WA.set(Qg, "action", "variable-update", IA(IA({}, pg), {}, { type: "variable-added" })), WA.emit("variable-update-" + Qg);
                  break;
                case "ADD_VARIABLE_KEY_REQUEST":
                  WA.set(Qg, "action", "new-key-request", pg), WA.emit("add-key-request-" + Qg);
              }
            }, WA.updateSrc = function(lg, Qg) {
              var pg = Qg.name, Fg = Qg.namespace, Yg = Qg.new_value, fg = (Qg.existing_value, Qg.variable_removed);
              Fg.shift();
              var Wg, Ug = WA.get(lg, "global", "src"), xg = WA.deepCopy(Ug, vA(Fg)), zg = xg, Lg = fA(Fg);
              try {
                for (Lg.s(); !(Wg = Lg.n()).done; )
                  zg = zg[Wg.value];
              } catch (Tg) {
                Lg.e(Tg);
              } finally {
                Lg.f();
              }
              return fg ? GA(zg) == "array" ? zg.splice(pg, 1) : delete zg[pg] : pg !== null ? zg[pg] = Yg : xg = Yg, WA.set(lg, "global", "src", xg), xg;
            }, WA.deepCopy = function(lg, Qg) {
              var pg, Fg = GA(lg), Yg = Qg.shift();
              return Fg == "array" ? pg = vA(lg) : Fg == "object" && (pg = IA({}, lg)), Yg !== void 0 && (pg[Yg] = WA.deepCopy(lg[Yg], Qg)), pg;
            }, WA;
          }
          return SA;
        })(Cg.EventEmitter))();
        Ig.register(gg.handleAction.bind(gg));
        var og = gg, eg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA(WA) {
            var OA;
            return CA(this, SA), (OA = qA.call(this, WA)).toggleCollapsed = function() {
              OA.setState({ collapsed: !OA.state.collapsed }, (function() {
                og.set(OA.props.rjvId, OA.props.namespace, "collapsed", OA.state.collapsed);
              }));
            }, OA.getFunctionDisplay = function(Bg) {
              var dg = EA(OA).props;
              return Bg ? cA.a.createElement("span", null, OA.props.value.toString().slice(9, -1).replace(/\{[\s\S]+/, ""), cA.a.createElement("span", { className: "function-collapsed", style: { fontWeight: "bold" } }, cA.a.createElement("span", null, "{"), cA.a.createElement("span", MA(dg.theme, "ellipsis"), "..."), cA.a.createElement("span", null, "}"))) : OA.props.value.toString().slice(9, -1);
            }, OA.state = { collapsed: og.get(WA.rjvId, WA.namespace, "collapsed", !0) }, OA;
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = this.state.collapsed;
            return cA.a.createElement("div", MA(WA.theme, "function"), cA.a.createElement(LA, Object.assign({ type_name: "function" }, WA)), cA.a.createElement("span", Object.assign({}, MA(WA.theme, "function-value"), { className: "rjv-function-container", onClick: this.toggleCollapsed }), this.getFunctionDisplay(OA)));
          } }]), SA;
        })(cA.a.PureComponent), kA = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            return cA.a.createElement("div", MA(this.props.theme, "nan"), "NaN");
          } }]), SA;
        })(cA.a.PureComponent), YA = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            return cA.a.createElement("div", MA(this.props.theme, "null"), "NULL");
          } }]), SA;
        })(cA.a.PureComponent), RA = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props;
            return cA.a.createElement("div", MA(WA.theme, "integer"), cA.a.createElement(LA, Object.assign({ type_name: "int" }, WA)), this.props.value);
          } }]), SA;
        })(cA.a.PureComponent), FA = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props;
            return cA.a.createElement("div", MA(WA.theme, "regexp"), cA.a.createElement(LA, Object.assign({ type_name: "regexp" }, WA)), this.props.value.toString());
          } }]), SA;
        })(cA.a.PureComponent), mA = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA(WA) {
            var OA;
            return CA(this, SA), (OA = qA.call(this, WA)).toggleCollapsed = function() {
              OA.setState({ collapsed: !OA.state.collapsed }, (function() {
                og.set(OA.props.rjvId, OA.props.namespace, "collapsed", OA.state.collapsed);
              }));
            }, OA.state = { collapsed: og.get(WA.rjvId, WA.namespace, "collapsed", !0) }, OA;
          }
          return eA(SA, [{ key: "render", value: function() {
            this.state.collapsed;
            var WA = this.props, OA = WA.collapseStringsAfterLength, Bg = WA.theme, dg = WA.value, lg = { style: { cursor: "default" } };
            return GA(OA) === "integer" && dg.length > OA && (lg.style.cursor = "pointer", this.state.collapsed && (dg = cA.a.createElement("span", null, dg.substring(0, OA), cA.a.createElement("span", MA(Bg, "ellipsis"), " ...")))), cA.a.createElement("div", MA(Bg, "string"), cA.a.createElement(LA, Object.assign({ type_name: "string" }, WA)), cA.a.createElement("span", Object.assign({ className: "string-value" }, lg, { onClick: this.toggleCollapsed }), '"', dg, '"'));
          } }]), SA;
        })(cA.a.PureComponent), JA = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            return cA.a.createElement("div", MA(this.props.theme, "undefined"), "undefined");
          } }]), SA;
        })(cA.a.PureComponent);
        function VA() {
          return (VA = Object.assign || function(UA) {
            for (var qA = 1; qA < arguments.length; qA++) {
              var SA = arguments[qA];
              for (var WA in SA) Object.prototype.hasOwnProperty.call(SA, WA) && (UA[WA] = SA[WA]);
            }
            return UA;
          }).apply(this, arguments);
        }
        var HA = lA.useLayoutEffect, jA = function(UA) {
          var qA = Object(lA.useRef)(UA);
          return HA((function() {
            qA.current = UA;
          })), qA;
        }, _A = function(UA, qA) {
          typeof UA != "function" ? UA.current = qA : UA(qA);
        }, $A = function(UA, qA) {
          var SA = Object(lA.useRef)();
          return Object(lA.useCallback)((function(WA) {
            UA.current = WA, SA.current && _A(SA.current, null), SA.current = qA, qA && _A(qA, WA);
          }), [qA]);
        }, rg = { "min-height": "0", "max-height": "none", height: "0", visibility: "hidden", overflow: "hidden", position: "absolute", "z-index": "-1000", top: "0", right: "0" }, wg = function(UA) {
          Object.keys(rg).forEach((function(qA) {
            UA.style.setProperty(qA, rg[qA], "important");
          }));
        }, Dg = null, kg = function() {
        }, ig = ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "boxSizing", "fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "lineHeight", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "tabSize", "textIndent", "textRendering", "textTransform", "width"], ZA = !!document.documentElement.currentStyle, KA = function(UA, qA) {
          var SA = UA.cacheMeasurements, WA = UA.maxRows, OA = UA.minRows, Bg = UA.onChange, dg = Bg === void 0 ? kg : Bg, lg = UA.onHeightChange, Qg = lg === void 0 ? kg : lg, pg = (function(Lg, Tg) {
            if (Lg == null) return {};
            var AI, BI, fI = {}, eI = Object.keys(Lg);
            for (BI = 0; BI < eI.length; BI++) AI = eI[BI], Tg.indexOf(AI) >= 0 || (fI[AI] = Lg[AI]);
            return fI;
          })(UA, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]), Fg, Yg = pg.value !== void 0, fg = Object(lA.useRef)(null), Wg = $A(fg, qA), Ug = Object(lA.useRef)(0), xg = Object(lA.useRef)(), zg = function() {
            var Lg = fg.current, Tg = SA && xg.current ? xg.current : (function(eI) {
              var SI = window.getComputedStyle(eI);
              if (SI === null) return null;
              var cI, Pg = (cI = SI, ig.reduce((function(pI, sI) {
                return pI[sI] = cI[sI], pI;
              }), {})), lI = Pg.boxSizing;
              return lI === "" ? null : (ZA && lI === "border-box" && (Pg.width = parseFloat(Pg.width) + parseFloat(Pg.borderRightWidth) + parseFloat(Pg.borderLeftWidth) + parseFloat(Pg.paddingRight) + parseFloat(Pg.paddingLeft) + "px"), { sizingStyle: Pg, paddingSize: parseFloat(Pg.paddingBottom) + parseFloat(Pg.paddingTop), borderSize: parseFloat(Pg.borderBottomWidth) + parseFloat(Pg.borderTopWidth) });
            })(Lg);
            if (Tg) {
              xg.current = Tg;
              var AI = (function(eI, SI, cI, Pg) {
                cI === void 0 && (cI = 1), Pg === void 0 && (Pg = 1 / 0), Dg || ((Dg = document.createElement("textarea")).setAttribute("tab-index", "-1"), Dg.setAttribute("aria-hidden", "true"), wg(Dg)), Dg.parentNode === null && document.body.appendChild(Dg);
                var lI = eI.paddingSize, pI = eI.borderSize, sI = eI.sizingStyle, zI = sI.boxSizing;
                Object.keys(sI).forEach((function(ZI) {
                  var uI = ZI;
                  Dg.style[uI] = sI[uI];
                })), wg(Dg), Dg.value = SI;
                var YI = (function(ZI, uI) {
                  var vI = ZI.scrollHeight;
                  return uI.sizingStyle.boxSizing === "border-box" ? vI + uI.borderSize : vI - uI.paddingSize;
                })(Dg, eI);
                Dg.value = "x";
                var LI = Dg.scrollHeight - lI, HI = LI * cI;
                zI === "border-box" && (HI = HI + lI + pI), YI = Math.max(HI, YI);
                var UI = LI * Pg;
                return zI === "border-box" && (UI = UI + lI + pI), [YI = Math.min(UI, YI), LI];
              })(Tg, Lg.value || Lg.placeholder || "x", OA, WA), BI = AI[0], fI = AI[1];
              Ug.current !== BI && (Ug.current = BI, Lg.style.setProperty("height", BI + "px", "important"), Qg(BI, { rowHeight: fI }));
            }
          };
          return Object(lA.useLayoutEffect)(zg), Fg = jA(zg), Object(lA.useLayoutEffect)((function() {
            var Lg = function(Tg) {
              Fg.current(Tg);
            };
            return window.addEventListener("resize", Lg), function() {
              window.removeEventListener("resize", Lg);
            };
          }), []), Object(lA.createElement)("textarea", VA({}, pg, { onChange: function(Lg) {
            Yg || zg(), dg(Lg);
          }, ref: Wg }));
        }, PA = Object(lA.forwardRef)(KA);
        function ag(UA) {
          UA = UA.trim();
          try {
            if ((UA = JSON.stringify(JSON.parse(UA)))[0] === "[") return Gg("array", JSON.parse(UA));
            if (UA[0] === "{") return Gg("object", JSON.parse(UA));
            if (UA.match(/\-?\d+\.\d+/) && UA.match(/\-?\d+\.\d+/)[0] === UA) return Gg("float", parseFloat(UA));
            if (UA.match(/\-?\d+e-\d+/) && UA.match(/\-?\d+e-\d+/)[0] === UA) return Gg("float", Number(UA));
            if (UA.match(/\-?\d+/) && UA.match(/\-?\d+/)[0] === UA) return Gg("integer", parseInt(UA));
            if (UA.match(/\-?\d+e\+\d+/) && UA.match(/\-?\d+e\+\d+/)[0] === UA) return Gg("integer", Number(UA));
          } catch {
          }
          switch (UA = UA.toLowerCase()) {
            case "undefined":
              return Gg("undefined", void 0);
            case "nan":
              return Gg("nan", NaN);
            case "null":
              return Gg("null", null);
            case "true":
              return Gg("boolean", !0);
            case "false":
              return Gg("boolean", !1);
            default:
              if (UA = Date.parse(UA)) return Gg("date", new Date(UA));
          }
          return Gg(!1, null);
        }
        function Gg(UA, qA) {
          return { type: UA, value: qA };
        }
        var bg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.style, Bg = dA(WA, ["style"]);
            return cA.a.createElement("span", Bg, cA.a.createElement("svg", Object.assign({}, mg(OA), { viewBox: "0 0 24 24", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), cA.a.createElement("path", { d: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,13H17V11H7" })));
          } }]), SA;
        })(cA.a.PureComponent), yg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.style, Bg = dA(WA, ["style"]);
            return cA.a.createElement("span", Bg, cA.a.createElement("svg", Object.assign({}, mg(OA), { viewBox: "0 0 24 24", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), cA.a.createElement("path", { d: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z" })));
          } }]), SA;
        })(cA.a.PureComponent), hg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.style, Bg = dA(WA, ["style"]), dg = mg(OA).style;
            return cA.a.createElement("span", Bg, cA.a.createElement("svg", { fill: dg.color, width: dg.height, height: dg.width, style: dg, viewBox: "0 0 1792 1792" }, cA.a.createElement("path", { d: "M1344 800v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h832q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z" })));
          } }]), SA;
        })(cA.a.PureComponent), tg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.style, Bg = dA(WA, ["style"]), dg = mg(OA).style;
            return cA.a.createElement("span", Bg, cA.a.createElement("svg", { fill: dg.color, width: dg.height, height: dg.width, style: dg, viewBox: "0 0 1792 1792" }, cA.a.createElement("path", { d: "M1344 800v64q0 14-9 23t-23 9h-352v352q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-352h-352q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-352q0-14 9-23t23-9h64q14 0 23 9t9 23v352h352q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z" })));
          } }]), SA;
        })(cA.a.PureComponent), Eg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.style, Bg = dA(WA, ["style"]);
            return cA.a.createElement("span", Bg, cA.a.createElement("svg", { style: IA(IA({}, mg(OA).style), {}, { paddingLeft: "2px", verticalAlign: "top" }), viewBox: "0 0 15 15", fill: "currentColor" }, cA.a.createElement("path", { d: "M0 14l6-6-6-6z" })));
          } }]), SA;
        })(cA.a.PureComponent), cg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.style, Bg = dA(WA, ["style"]);
            return cA.a.createElement("span", Bg, cA.a.createElement("svg", { style: IA(IA({}, mg(OA).style), {}, { paddingLeft: "2px", verticalAlign: "top" }), viewBox: "0 0 15 15", fill: "currentColor" }, cA.a.createElement("path", { d: "M0 5l6 6 6-6z" })));
          } }]), SA;
        })(cA.a.PureComponent), sg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.style, Bg = dA(WA, ["style"]);
            return cA.a.createElement("span", Bg, cA.a.createElement("svg", Object.assign({}, mg(OA), { viewBox: "0 0 40 40", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), cA.a.createElement("g", null, cA.a.createElement("path", { d: "m30 35h-25v-22.5h25v7.5h2.5v-12.5c0-1.4-1.1-2.5-2.5-2.5h-7.5c0-2.8-2.2-5-5-5s-5 2.2-5 5h-7.5c-1.4 0-2.5 1.1-2.5 2.5v27.5c0 1.4 1.1 2.5 2.5 2.5h25c1.4 0 2.5-1.1 2.5-2.5v-5h-2.5v5z m-20-27.5h2.5s2.5-1.1 2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5 1.3 2.5 2.5 2.5h2.5s2.5 1.1 2.5 2.5h-20c0-1.5 1.1-2.5 2.5-2.5z m-2.5 20h5v-2.5h-5v2.5z m17.5-5v-5l-10 7.5 10 7.5v-5h12.5v-5h-12.5z m-17.5 10h7.5v-2.5h-7.5v2.5z m12.5-17.5h-12.5v2.5h12.5v-2.5z m-7.5 5h-5v2.5h5v-2.5z" }))));
          } }]), SA;
        })(cA.a.PureComponent), ug = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.style, Bg = dA(WA, ["style"]);
            return cA.a.createElement("span", Bg, cA.a.createElement("svg", Object.assign({}, mg(OA), { viewBox: "0 0 40 40", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), cA.a.createElement("g", null, cA.a.createElement("path", { d: "m28.6 25q0-0.5-0.4-1l-4-4 4-4q0.4-0.5 0.4-1 0-0.6-0.4-1.1l-2-2q-0.4-0.4-1-0.4-0.6 0-1 0.4l-4.1 4.1-4-4.1q-0.4-0.4-1-0.4-0.6 0-1 0.4l-2 2q-0.5 0.5-0.5 1.1 0 0.5 0.5 1l4 4-4 4q-0.5 0.5-0.5 1 0 0.7 0.5 1.1l2 2q0.4 0.4 1 0.4 0.6 0 1-0.4l4-4.1 4.1 4.1q0.4 0.4 1 0.4 0.6 0 1-0.4l2-2q0.4-0.4 0.4-1z m8.7-5q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z" }))));
          } }]), SA;
        })(cA.a.PureComponent), Mg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.style, Bg = dA(WA, ["style"]);
            return cA.a.createElement("span", Bg, cA.a.createElement("svg", Object.assign({}, mg(OA), { viewBox: "0 0 40 40", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), cA.a.createElement("g", null, cA.a.createElement("path", { d: "m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-5.7v-5.7q0-0.6-0.4-1t-1-0.4h-2.9q-0.6 0-1 0.4t-0.4 1v5.7h-5.7q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h5.7v5.7q0 0.5 0.4 1t1 0.4h2.9q0.6 0 1-0.4t0.4-1v-5.7h5.7q0.6 0 1-0.5t0.4-1z m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z" }))));
          } }]), SA;
        })(cA.a.PureComponent), Rg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.style, Bg = dA(WA, ["style"]);
            return cA.a.createElement("span", Bg, cA.a.createElement("svg", Object.assign({}, mg(OA), { viewBox: "0 0 40 40", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), cA.a.createElement("g", null, cA.a.createElement("path", { d: "m31.6 21.6h-10v10h-3.2v-10h-10v-3.2h10v-10h3.2v10h10v3.2z" }))));
          } }]), SA;
        })(cA.a.PureComponent), Jg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.style, Bg = dA(WA, ["style"]);
            return cA.a.createElement("span", Bg, cA.a.createElement("svg", Object.assign({}, mg(OA), { viewBox: "0 0 40 40", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), cA.a.createElement("g", null, cA.a.createElement("path", { d: "m19.8 26.4l2.6-2.6-3.4-3.4-2.6 2.6v1.3h2.2v2.1h1.2z m9.8-16q-0.3-0.4-0.7 0l-7.8 7.8q-0.4 0.4 0 0.7t0.7 0l7.8-7.8q0.4-0.4 0-0.7z m1.8 13.2v4.3q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q1.4 0 2.6 0.5 0.3 0.2 0.4 0.5 0.1 0.4-0.2 0.7l-1.1 1.1q-0.3 0.3-0.7 0.1-0.5-0.1-1-0.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-2.9q0-0.2 0.2-0.4l1.4-1.5q0.3-0.3 0.8-0.1t0.4 0.6z m-2.1-16.5l6.4 6.5-15 15h-6.4v-6.5z m9.9 3l-2.1 2-6.4-6.4 2.1-2q0.6-0.7 1.5-0.7t1.5 0.7l3.4 3.4q0.6 0.6 0.6 1.5t-0.6 1.5z" }))));
          } }]), SA;
        })(cA.a.PureComponent), Hg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.style, Bg = dA(WA, ["style"]);
            return cA.a.createElement("span", Bg, cA.a.createElement("svg", Object.assign({}, mg(OA), { viewBox: "0 0 40 40", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), cA.a.createElement("g", null, cA.a.createElement("path", { d: "m31.7 16.4q0-0.6-0.4-1l-2.1-2.1q-0.4-0.4-1-0.4t-1 0.4l-9.1 9.1-5-5q-0.5-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1 0 0.6 0.4 1l8.1 8.1q0.4 0.4 1 0.4 0.6 0 1-0.4l12.2-12.1q0.4-0.4 0.4-1z m5.6 3.6q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z" }))));
          } }]), SA;
        })(cA.a.PureComponent);
        function mg(UA) {
          return UA || (UA = {}), { style: IA(IA({ verticalAlign: "middle" }, UA), {}, { color: UA.color ? UA.color : "#000000", height: "1em", width: "1em" }) };
        }
        var Og = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA(WA) {
            var OA;
            return CA(this, SA), (OA = qA.call(this, WA)).copiedTimer = null, OA.handleCopy = function() {
              var Bg = document.createElement("textarea"), dg = OA.props, lg = dg.clickCallback, Qg = dg.src, pg = dg.namespace;
              Bg.innerHTML = JSON.stringify(OA.clipboardValue(Qg), null, "  "), document.body.appendChild(Bg), Bg.select(), document.execCommand("copy"), document.body.removeChild(Bg), OA.copiedTimer = setTimeout((function() {
                OA.setState({ copied: !1 });
              }), 5500), OA.setState({ copied: !0 }, (function() {
                typeof lg == "function" && lg({ src: Qg, namespace: pg, name: pg[pg.length - 1] });
              }));
            }, OA.getClippyIcon = function() {
              var Bg = OA.props.theme;
              return OA.state.copied ? cA.a.createElement("span", null, cA.a.createElement(sg, Object.assign({ className: "copy-icon" }, MA(Bg, "copy-icon"))), cA.a.createElement("span", MA(Bg, "copy-icon-copied"), "✔")) : cA.a.createElement(sg, Object.assign({ className: "copy-icon" }, MA(Bg, "copy-icon")));
            }, OA.clipboardValue = function(Bg) {
              switch (GA(Bg)) {
                case "function":
                case "regexp":
                  return Bg.toString();
                default:
                  return Bg;
              }
            }, OA.state = { copied: !1 }, OA;
          }
          return eA(SA, [{ key: "componentWillUnmount", value: function() {
            this.copiedTimer && (clearTimeout(this.copiedTimer), this.copiedTimer = null);
          } }, { key: "render", value: function() {
            var WA = this.props, OA = (WA.src, WA.theme), Bg = WA.hidden, dg = WA.rowHovered, lg = MA(OA, "copy-to-clipboard").style, Qg = "inline";
            return Bg && (Qg = "none"), cA.a.createElement("span", { className: "copy-to-clipboard-container", title: "Copy to clipboard", style: { verticalAlign: "top", display: dg ? "inline-block" : "none" } }, cA.a.createElement("span", { style: IA(IA({}, lg), {}, { display: Qg }), onClick: this.handleCopy }, this.getClippyIcon()));
          } }]), SA;
        })(cA.a.PureComponent), Kg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA(WA) {
            var OA;
            return CA(this, SA), (OA = qA.call(this, WA)).getEditIcon = function() {
              var Bg = OA.props, dg = Bg.variable, lg = Bg.theme;
              return cA.a.createElement("div", { className: "click-to-edit", style: { verticalAlign: "top", display: OA.state.hovered ? "inline-block" : "none" } }, cA.a.createElement(Jg, Object.assign({ className: "click-to-edit-icon" }, MA(lg, "editVarIcon"), { onClick: function() {
                OA.prepopInput(dg);
              } })));
            }, OA.prepopInput = function(Bg) {
              if (OA.props.onEdit !== !1) {
                var dg = (function(Qg) {
                  var pg;
                  switch (GA(Qg)) {
                    case "undefined":
                      pg = "undefined";
                      break;
                    case "nan":
                      pg = "NaN";
                      break;
                    case "string":
                      pg = Qg;
                      break;
                    case "date":
                    case "function":
                    case "regexp":
                      pg = Qg.toString();
                      break;
                    default:
                      try {
                        pg = JSON.stringify(Qg, null, "  ");
                      } catch {
                        pg = "";
                      }
                  }
                  return pg;
                })(Bg.value), lg = ag(dg);
                OA.setState({ editMode: !0, editValue: dg, parsedInput: { type: lg.type, value: lg.value } });
              }
            }, OA.getRemoveIcon = function() {
              var Bg = OA.props, dg = Bg.variable, lg = Bg.namespace, Qg = Bg.theme, pg = Bg.rjvId;
              return cA.a.createElement("div", { className: "click-to-remove", style: { verticalAlign: "top", display: OA.state.hovered ? "inline-block" : "none" } }, cA.a.createElement(ug, Object.assign({ className: "click-to-remove-icon" }, MA(Qg, "removeVarIcon"), { onClick: function() {
                Ig.dispatch({ name: "VARIABLE_REMOVED", rjvId: pg, data: { name: dg.name, namespace: lg, existing_value: dg.value, variable_removed: !0 } });
              } })));
            }, OA.getValue = function(Bg, dg) {
              var lg = !dg && Bg.type, Qg = EA(OA).props;
              switch (lg) {
                case !1:
                  return OA.getEditInput();
                case "string":
                  return cA.a.createElement(mA, Object.assign({ value: Bg.value }, Qg));
                case "integer":
                  return cA.a.createElement(RA, Object.assign({ value: Bg.value }, Qg));
                case "float":
                  return cA.a.createElement(NA, Object.assign({ value: Bg.value }, Qg));
                case "boolean":
                  return cA.a.createElement(xA, Object.assign({ value: Bg.value }, Qg));
                case "function":
                  return cA.a.createElement(eg, Object.assign({ value: Bg.value }, Qg));
                case "null":
                  return cA.a.createElement(YA, Qg);
                case "nan":
                  return cA.a.createElement(kA, Qg);
                case "undefined":
                  return cA.a.createElement(JA, Qg);
                case "date":
                  return cA.a.createElement(TA, Object.assign({ value: Bg.value }, Qg));
                case "regexp":
                  return cA.a.createElement(FA, Object.assign({ value: Bg.value }, Qg));
                default:
                  return cA.a.createElement("div", { className: "object-value" }, JSON.stringify(Bg.value));
              }
            }, OA.getEditInput = function() {
              var Bg = OA.props.theme, dg = OA.state.editValue;
              return cA.a.createElement("div", null, cA.a.createElement(PA, Object.assign({ type: "text", inputRef: function(lg) {
                return lg && lg.focus();
              }, value: dg, className: "variable-editor", onChange: function(lg) {
                var Qg = lg.target.value, pg = ag(Qg);
                OA.setState({ editValue: Qg, parsedInput: { type: pg.type, value: pg.value } });
              }, onKeyDown: function(lg) {
                switch (lg.key) {
                  case "Escape":
                    OA.setState({ editMode: !1, editValue: "" });
                    break;
                  case "Enter":
                    (lg.ctrlKey || lg.metaKey) && OA.submitEdit(!0);
                }
                lg.stopPropagation();
              }, placeholder: "update this value", minRows: 2 }, MA(Bg, "edit-input"))), cA.a.createElement("div", MA(Bg, "edit-icon-container"), cA.a.createElement(ug, Object.assign({ className: "edit-cancel" }, MA(Bg, "cancel-icon"), { onClick: function() {
                OA.setState({ editMode: !1, editValue: "" });
              } })), cA.a.createElement(Hg, Object.assign({ className: "edit-check string-value" }, MA(Bg, "check-icon"), { onClick: function() {
                OA.submitEdit();
              } })), cA.a.createElement("div", null, OA.showDetected())));
            }, OA.submitEdit = function(Bg) {
              var dg = OA.props, lg = dg.variable, Qg = dg.namespace, pg = dg.rjvId, Fg = OA.state, Yg = Fg.editValue, fg = Fg.parsedInput, Wg = Yg;
              Bg && fg.type && (Wg = fg.value), OA.setState({ editMode: !1 }), Ig.dispatch({ name: "VARIABLE_UPDATED", rjvId: pg, data: { name: lg.name, namespace: Qg, existing_value: lg.value, new_value: Wg, variable_removed: !1 } });
            }, OA.showDetected = function() {
              var Bg = OA.props, dg = Bg.theme, lg = (Bg.variable, Bg.namespace, Bg.rjvId, OA.state.parsedInput), Qg = (lg.type, lg.value, OA.getDetectedInput());
              if (Qg) return cA.a.createElement("div", null, cA.a.createElement("div", MA(dg, "detected-row"), Qg, cA.a.createElement(Hg, { className: "edit-check detected", style: IA({ verticalAlign: "top", paddingLeft: "3px" }, MA(dg, "check-icon").style), onClick: function() {
                OA.submitEdit(!0);
              } })));
            }, OA.getDetectedInput = function() {
              var Bg = OA.state.parsedInput, dg = Bg.type, lg = Bg.value, Qg = EA(OA).props, pg = Qg.theme;
              if (dg !== !1) switch (dg.toLowerCase()) {
                case "object":
                  return cA.a.createElement("span", null, cA.a.createElement("span", { style: IA(IA({}, MA(pg, "brace").style), {}, { cursor: "default" }) }, "{"), cA.a.createElement("span", { style: IA(IA({}, MA(pg, "ellipsis").style), {}, { cursor: "default" }) }, "..."), cA.a.createElement("span", { style: IA(IA({}, MA(pg, "brace").style), {}, { cursor: "default" }) }, "}"));
                case "array":
                  return cA.a.createElement("span", null, cA.a.createElement("span", { style: IA(IA({}, MA(pg, "brace").style), {}, { cursor: "default" }) }, "["), cA.a.createElement("span", { style: IA(IA({}, MA(pg, "ellipsis").style), {}, { cursor: "default" }) }, "..."), cA.a.createElement("span", { style: IA(IA({}, MA(pg, "brace").style), {}, { cursor: "default" }) }, "]"));
                case "string":
                  return cA.a.createElement(mA, Object.assign({ value: lg }, Qg));
                case "integer":
                  return cA.a.createElement(RA, Object.assign({ value: lg }, Qg));
                case "float":
                  return cA.a.createElement(NA, Object.assign({ value: lg }, Qg));
                case "boolean":
                  return cA.a.createElement(xA, Object.assign({ value: lg }, Qg));
                case "function":
                  return cA.a.createElement(eg, Object.assign({ value: lg }, Qg));
                case "null":
                  return cA.a.createElement(YA, Qg);
                case "nan":
                  return cA.a.createElement(kA, Qg);
                case "undefined":
                  return cA.a.createElement(JA, Qg);
                case "date":
                  return cA.a.createElement(TA, Object.assign({ value: new Date(lg) }, Qg));
              }
            }, OA.state = { editMode: !1, editValue: "", hovered: !1, renameKey: !1, parsedInput: { type: !1, value: null } }, OA;
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this, OA = this.props, Bg = OA.variable, dg = OA.singleIndent, lg = OA.type, Qg = OA.theme, pg = OA.namespace, Fg = OA.indentWidth, Yg = OA.enableClipboard, fg = OA.onEdit, Wg = OA.onDelete, Ug = OA.onSelect, xg = OA.displayArrayKey, zg = OA.quotesOnKeys, Lg = this.state.editMode;
            return cA.a.createElement("div", Object.assign({}, MA(Qg, "objectKeyVal", { paddingLeft: Fg * dg }), { onMouseEnter: function() {
              return WA.setState(IA(IA({}, WA.state), {}, { hovered: !0 }));
            }, onMouseLeave: function() {
              return WA.setState(IA(IA({}, WA.state), {}, { hovered: !1 }));
            }, className: "variable-row", key: Bg.name }), lg == "array" ? xg ? cA.a.createElement("span", Object.assign({}, MA(Qg, "array-key"), { key: Bg.name + "_" + pg }), Bg.name, cA.a.createElement("div", MA(Qg, "colon"), ":")) : null : cA.a.createElement("span", null, cA.a.createElement("span", Object.assign({}, MA(Qg, "object-name"), { className: "object-key", key: Bg.name + "_" + pg }), !!zg && cA.a.createElement("span", { style: { verticalAlign: "top" } }, '"'), cA.a.createElement("span", { style: { display: "inline-block" } }, Bg.name), !!zg && cA.a.createElement("span", { style: { verticalAlign: "top" } }, '"')), cA.a.createElement("span", MA(Qg, "colon"), ":")), cA.a.createElement("div", Object.assign({ className: "variable-value", onClick: Ug === !1 && fg === !1 ? null : function(Tg) {
              var AI = vA(pg);
              (Tg.ctrlKey || Tg.metaKey) && fg !== !1 ? WA.prepopInput(Bg) : Ug !== !1 && (AI.shift(), Ug(IA(IA({}, Bg), {}, { namespace: AI })));
            } }, MA(Qg, "variableValue", { cursor: Ug === !1 ? "default" : "pointer" })), this.getValue(Bg, Lg)), Yg ? cA.a.createElement(Og, { rowHovered: this.state.hovered, hidden: Lg, src: Bg.value, clickCallback: Yg, theme: Qg, namespace: [].concat(vA(pg), [Bg.name]) }) : null, fg !== !1 && Lg == 0 ? this.getEditIcon() : null, Wg !== !1 && Lg == 0 ? this.getRemoveIcon() : null);
          } }]), SA;
        })(cA.a.PureComponent), vg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            var WA;
            CA(this, SA);
            for (var OA = arguments.length, Bg = new Array(OA), dg = 0; dg < OA; dg++) Bg[dg] = arguments[dg];
            return (WA = qA.call.apply(qA, [this].concat(Bg))).getObjectSize = function() {
              var lg = WA.props, Qg = lg.size, pg = lg.theme;
              if (lg.displayObjectSize) return cA.a.createElement("span", Object.assign({ className: "object-size" }, MA(pg, "object-size")), Qg, " item", Qg === 1 ? "" : "s");
            }, WA.getAddAttribute = function(lg) {
              var Qg = WA.props, pg = Qg.theme, Fg = Qg.namespace, Yg = Qg.name, fg = Qg.src, Wg = Qg.rjvId, Ug = Qg.depth;
              return cA.a.createElement("span", { className: "click-to-add", style: { verticalAlign: "top", display: lg ? "inline-block" : "none" } }, cA.a.createElement(Mg, Object.assign({ className: "click-to-add-icon" }, MA(pg, "addVarIcon"), { onClick: function() {
                var xg = { name: Ug > 0 ? Yg : null, namespace: Fg.splice(0, Fg.length - 1), existing_value: fg, variable_removed: !1, key_name: null };
                GA(fg) === "object" ? Ig.dispatch({ name: "ADD_VARIABLE_KEY_REQUEST", rjvId: Wg, data: xg }) : Ig.dispatch({ name: "VARIABLE_ADDED", rjvId: Wg, data: IA(IA({}, xg), {}, { new_value: [].concat(vA(fg), [null]) }) });
              } })));
            }, WA.getRemoveObject = function(lg) {
              var Qg = WA.props, pg = Qg.theme, Fg = (Qg.hover, Qg.namespace), Yg = Qg.name, fg = Qg.src, Wg = Qg.rjvId;
              if (Fg.length !== 1) return cA.a.createElement("span", { className: "click-to-remove", style: { display: lg ? "inline-block" : "none" } }, cA.a.createElement(ug, Object.assign({ className: "click-to-remove-icon" }, MA(pg, "removeVarIcon"), { onClick: function() {
                Ig.dispatch({ name: "VARIABLE_REMOVED", rjvId: Wg, data: { name: Yg, namespace: Fg.splice(0, Fg.length - 1), existing_value: fg, variable_removed: !0 } });
              } })));
            }, WA.render = function() {
              var lg = WA.props, Qg = lg.theme, pg = lg.onDelete, Fg = lg.onAdd, Yg = lg.enableClipboard, fg = lg.src, Wg = lg.namespace, Ug = lg.rowHovered;
              return cA.a.createElement("div", Object.assign({}, MA(Qg, "object-meta-data"), { className: "object-meta-data", onClick: function(xg) {
                xg.stopPropagation();
              } }), WA.getObjectSize(), Yg ? cA.a.createElement(Og, { rowHovered: Ug, clickCallback: Yg, src: fg, theme: Qg, namespace: Wg }) : null, Fg !== !1 ? WA.getAddAttribute(Ug) : null, pg !== !1 ? WA.getRemoveObject(Ug) : null);
            }, WA;
          }
          return SA;
        })(cA.a.PureComponent);
        function Vg(UA) {
          var qA = UA.parent_type, SA = UA.namespace, WA = UA.quotesOnKeys, OA = UA.theme, Bg = UA.jsvRoot, dg = UA.name, lg = UA.displayArrayKey, Qg = UA.name ? UA.name : "";
          return !Bg || dg !== !1 && dg !== null ? qA == "array" ? lg ? cA.a.createElement("span", Object.assign({}, MA(OA, "array-key"), { key: SA }), cA.a.createElement("span", { className: "array-key" }, Qg), cA.a.createElement("span", MA(OA, "colon"), ":")) : cA.a.createElement("span", null) : cA.a.createElement("span", Object.assign({}, MA(OA, "object-name"), { key: SA }), cA.a.createElement("span", { className: "object-key" }, WA && cA.a.createElement("span", { style: { verticalAlign: "top" } }, '"'), cA.a.createElement("span", null, Qg), WA && cA.a.createElement("span", { style: { verticalAlign: "top" } }, '"')), cA.a.createElement("span", MA(OA, "colon"), ":")) : cA.a.createElement("span", null);
        }
        function Xg(UA) {
          var qA = UA.theme;
          switch (UA.iconStyle) {
            case "triangle":
              return cA.a.createElement(cg, Object.assign({}, MA(qA, "expanded-icon"), { className: "expanded-icon" }));
            case "square":
              return cA.a.createElement(hg, Object.assign({}, MA(qA, "expanded-icon"), { className: "expanded-icon" }));
            default:
              return cA.a.createElement(bg, Object.assign({}, MA(qA, "expanded-icon"), { className: "expanded-icon" }));
          }
        }
        function jg(UA) {
          var qA = UA.theme;
          switch (UA.iconStyle) {
            case "triangle":
              return cA.a.createElement(Eg, Object.assign({}, MA(qA, "collapsed-icon"), { className: "collapsed-icon" }));
            case "square":
              return cA.a.createElement(tg, Object.assign({}, MA(qA, "collapsed-icon"), { className: "collapsed-icon" }));
            default:
              return cA.a.createElement(yg, Object.assign({}, MA(qA, "collapsed-icon"), { className: "collapsed-icon" }));
          }
        }
        var gI = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA(WA) {
            var OA;
            return CA(this, SA), (OA = qA.call(this, WA)).toggleCollapsed = function(Bg) {
              var dg = [];
              for (var lg in OA.state.expanded) dg.push(OA.state.expanded[lg]);
              dg[Bg] = !dg[Bg], OA.setState({ expanded: dg });
            }, OA.state = { expanded: [] }, OA;
          }
          return eA(SA, [{ key: "getExpandedIcon", value: function(WA) {
            var OA = this.props, Bg = OA.theme, dg = OA.iconStyle;
            return this.state.expanded[WA] ? cA.a.createElement(Xg, { theme: Bg, iconStyle: dg }) : cA.a.createElement(jg, { theme: Bg, iconStyle: dg });
          } }, { key: "render", value: function() {
            var WA = this, OA = this.props, Bg = OA.src, dg = OA.groupArraysAfterLength, lg = (OA.depth, OA.name), Qg = OA.theme, pg = OA.jsvRoot, Fg = OA.namespace, Yg = (OA.parent_type, dA(OA, ["src", "groupArraysAfterLength", "depth", "name", "theme", "jsvRoot", "namespace", "parent_type"])), fg = 0, Wg = 5 * this.props.indentWidth;
            pg || (fg = 5 * this.props.indentWidth);
            var Ug = dg, xg = Math.ceil(Bg.length / Ug);
            return cA.a.createElement("div", Object.assign({ className: "object-key-val" }, MA(Qg, pg ? "jsv-root" : "objectKeyVal", { paddingLeft: fg })), cA.a.createElement(Vg, this.props), cA.a.createElement("span", null, cA.a.createElement(vg, Object.assign({ size: Bg.length }, this.props))), vA(Array(xg)).map((function(zg, Lg) {
              return cA.a.createElement("div", Object.assign({ key: Lg, className: "object-key-val array-group" }, MA(Qg, "objectKeyVal", { marginLeft: 6, paddingLeft: Wg })), cA.a.createElement("span", MA(Qg, "brace-row"), cA.a.createElement("div", Object.assign({ className: "icon-container" }, MA(Qg, "icon-container"), { onClick: function(Tg) {
                WA.toggleCollapsed(Lg);
              } }), WA.getExpandedIcon(Lg)), WA.state.expanded[Lg] ? cA.a.createElement(Sg, Object.assign({ key: lg + Lg, depth: 0, name: !1, collapsed: !1, groupArraysAfterLength: Ug, index_offset: Lg * Ug, src: Bg.slice(Lg * Ug, Lg * Ug + Ug), namespace: Fg, type: "array", parent_type: "array_group", theme: Qg }, Yg)) : cA.a.createElement("span", Object.assign({}, MA(Qg, "brace"), { onClick: function(Tg) {
                WA.toggleCollapsed(Lg);
              }, className: "array-group-brace" }), "[", cA.a.createElement("div", Object.assign({}, MA(Qg, "array-group-meta-data"), { className: "array-group-meta-data" }), cA.a.createElement("span", Object.assign({ className: "object-size" }, MA(Qg, "object-size")), Lg * Ug, " - ", Lg * Ug + Ug > Bg.length ? Bg.length : Lg * Ug + Ug)), "]")));
            })));
          } }]), SA;
        })(cA.a.PureComponent), II = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA(WA) {
            var OA;
            CA(this, SA), (OA = qA.call(this, WA)).toggleCollapsed = function() {
              OA.setState({ expanded: !OA.state.expanded }, (function() {
                og.set(OA.props.rjvId, OA.props.namespace, "expanded", OA.state.expanded);
              }));
            }, OA.getObjectContent = function(dg, lg, Qg) {
              return cA.a.createElement("div", { className: "pushed-content object-container" }, cA.a.createElement("div", Object.assign({ className: "object-content" }, MA(OA.props.theme, "pushed-content")), OA.renderObjectContents(lg, Qg)));
            }, OA.getEllipsis = function() {
              return OA.state.size === 0 ? null : cA.a.createElement("div", Object.assign({}, MA(OA.props.theme, "ellipsis"), { className: "node-ellipsis", onClick: OA.toggleCollapsed }), "...");
            }, OA.getObjectMetaData = function(dg) {
              var lg = OA.props, Qg = (lg.rjvId, lg.theme, OA.state), pg = Qg.size, Fg = Qg.hovered;
              return cA.a.createElement(vg, Object.assign({ rowHovered: Fg, size: pg }, OA.props));
            }, OA.renderObjectContents = function(dg, lg) {
              var Qg, pg = OA.props, Fg = pg.depth, Yg = pg.parent_type, fg = pg.index_offset, Wg = pg.groupArraysAfterLength, Ug = pg.namespace, xg = OA.state.object_type, zg = [], Lg = Object.keys(dg || {});
              return OA.props.sortKeys && xg !== "array" && (Lg = Lg.sort()), Lg.forEach((function(Tg) {
                if (Qg = new tI(Tg, dg[Tg]), Yg === "array_group" && fg && (Qg.name = parseInt(Qg.name) + fg), dg.hasOwnProperty(Tg)) if (Qg.type === "object") zg.push(cA.a.createElement(Sg, Object.assign({ key: Qg.name, depth: Fg + 1, name: Qg.name, src: Qg.value, namespace: Ug.concat(Qg.name), parent_type: xg }, lg)));
                else if (Qg.type === "array") {
                  var AI = Sg;
                  Wg && Qg.value.length > Wg && (AI = gI), zg.push(cA.a.createElement(AI, Object.assign({ key: Qg.name, depth: Fg + 1, name: Qg.name, src: Qg.value, namespace: Ug.concat(Qg.name), type: "array", parent_type: xg }, lg)));
                } else zg.push(cA.a.createElement(Kg, Object.assign({ key: Qg.name + "_" + Ug, variable: Qg, singleIndent: 5, namespace: Ug, type: OA.props.type }, lg)));
              })), zg;
            };
            var Bg = SA.getState(WA);
            return OA.state = IA(IA({}, Bg), {}, { prevProps: {} }), OA;
          }
          return eA(SA, [{ key: "getBraceStart", value: function(WA, OA) {
            var Bg = this, dg = this.props, lg = dg.src, Qg = dg.theme, pg = dg.iconStyle;
            if (dg.parent_type === "array_group") return cA.a.createElement("span", null, cA.a.createElement("span", MA(Qg, "brace"), WA === "array" ? "[" : "{"), OA ? this.getObjectMetaData(lg) : null);
            var Fg = OA ? Xg : jg;
            return cA.a.createElement("span", null, cA.a.createElement("span", Object.assign({ onClick: function(Yg) {
              Bg.toggleCollapsed();
            } }, MA(Qg, "brace-row")), cA.a.createElement("div", Object.assign({ className: "icon-container" }, MA(Qg, "icon-container")), cA.a.createElement(Fg, { theme: Qg, iconStyle: pg })), cA.a.createElement(Vg, this.props), cA.a.createElement("span", MA(Qg, "brace"), WA === "array" ? "[" : "{")), OA ? this.getObjectMetaData(lg) : null);
          } }, { key: "render", value: function() {
            var WA = this, OA = this.props, Bg = OA.depth, dg = OA.src, lg = (OA.namespace, OA.name, OA.type, OA.parent_type), Qg = OA.theme, pg = OA.jsvRoot, Fg = OA.iconStyle, Yg = dA(OA, ["depth", "src", "namespace", "name", "type", "parent_type", "theme", "jsvRoot", "iconStyle"]), fg = this.state, Wg = fg.object_type, Ug = fg.expanded, xg = {};
            return pg || lg === "array_group" ? lg === "array_group" && (xg.borderLeft = 0, xg.display = "inline") : xg.paddingLeft = 5 * this.props.indentWidth, cA.a.createElement("div", Object.assign({ className: "object-key-val", onMouseEnter: function() {
              return WA.setState(IA(IA({}, WA.state), {}, { hovered: !0 }));
            }, onMouseLeave: function() {
              return WA.setState(IA(IA({}, WA.state), {}, { hovered: !1 }));
            } }, MA(Qg, pg ? "jsv-root" : "objectKeyVal", xg)), this.getBraceStart(Wg, Ug), Ug ? this.getObjectContent(Bg, dg, IA({ theme: Qg, iconStyle: Fg }, Yg)) : this.getEllipsis(), cA.a.createElement("span", { className: "brace-row" }, cA.a.createElement("span", { style: IA(IA({}, MA(Qg, "brace").style), {}, { paddingLeft: Ug ? "3px" : "0px" }) }, Wg === "array" ? "]" : "}"), Ug ? null : this.getObjectMetaData(dg)));
          } }], [{ key: "getDerivedStateFromProps", value: function(WA, OA) {
            var Bg = OA.prevProps;
            return WA.src !== Bg.src || WA.collapsed !== Bg.collapsed || WA.name !== Bg.name || WA.namespace !== Bg.namespace || WA.rjvId !== Bg.rjvId ? IA(IA({}, SA.getState(WA)), {}, { prevProps: WA }) : null;
          } }]), SA;
        })(cA.a.PureComponent);
        II.getState = function(UA) {
          var qA = Object.keys(UA.src).length, SA = (UA.collapsed === !1 || UA.collapsed !== !0 && UA.collapsed > UA.depth) && (!UA.shouldCollapse || UA.shouldCollapse({ name: UA.name, src: UA.src, type: GA(UA.src), namespace: UA.namespace }) === !1) && qA !== 0;
          return { expanded: og.get(UA.rjvId, UA.namespace, "expanded", SA), object_type: UA.type === "array" ? "array" : "object", parent_type: UA.type === "array" ? "array" : "object", size: qA, hovered: !1 };
        };
        var tI = function UA(qA, SA) {
          CA(this, UA), this.name = qA, this.value = SA, this.type = GA(SA);
        };
        hA(II);
        var Sg = II, Zg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            var WA;
            CA(this, SA);
            for (var OA = arguments.length, Bg = new Array(OA), dg = 0; dg < OA; dg++) Bg[dg] = arguments[dg];
            return (WA = qA.call.apply(qA, [this].concat(Bg))).render = function() {
              var lg = EA(WA).props, Qg = [lg.name], pg = Sg;
              return Array.isArray(lg.src) && lg.groupArraysAfterLength && lg.src.length > lg.groupArraysAfterLength && (pg = gI), cA.a.createElement("div", { className: "pretty-json-container object-container" }, cA.a.createElement("div", { className: "object-content" }, cA.a.createElement(pg, Object.assign({ namespace: Qg, depth: 0, jsvRoot: !0 }, lg))));
            }, WA;
          }
          return SA;
        })(cA.a.PureComponent), qg = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA(WA) {
            var OA;
            return CA(this, SA), (OA = qA.call(this, WA)).closeModal = function() {
              Ig.dispatch({ rjvId: OA.props.rjvId, name: "RESET" });
            }, OA.submit = function() {
              OA.props.submit(OA.state.input);
            }, OA.state = { input: WA.input ? WA.input : "" }, OA;
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this, OA = this.props, Bg = OA.theme, dg = OA.rjvId, lg = OA.isValid, Qg = this.state.input, pg = lg(Qg);
            return cA.a.createElement("div", Object.assign({ className: "key-modal-request" }, MA(Bg, "key-modal-request"), { onClick: this.closeModal }), cA.a.createElement("div", Object.assign({}, MA(Bg, "key-modal"), { onClick: function(Fg) {
              Fg.stopPropagation();
            } }), cA.a.createElement("div", MA(Bg, "key-modal-label"), "Key Name:"), cA.a.createElement("div", { style: { position: "relative" } }, cA.a.createElement("input", Object.assign({}, MA(Bg, "key-modal-input"), { className: "key-modal-input", ref: function(Fg) {
              return Fg && Fg.focus();
            }, spellCheck: !1, value: Qg, placeholder: "...", onChange: function(Fg) {
              WA.setState({ input: Fg.target.value });
            }, onKeyPress: function(Fg) {
              pg && Fg.key === "Enter" ? WA.submit() : Fg.key === "Escape" && WA.closeModal();
            } })), pg ? cA.a.createElement(Hg, Object.assign({}, MA(Bg, "key-modal-submit"), { className: "key-modal-submit", onClick: function(Fg) {
              return WA.submit();
            } })) : null), cA.a.createElement("span", MA(Bg, "key-modal-cancel"), cA.a.createElement(Rg, Object.assign({}, MA(Bg, "key-modal-cancel-icon"), { className: "key-modal-cancel", onClick: function() {
              Ig.dispatch({ rjvId: dg, name: "RESET" });
            } })))));
          } }]), SA;
        })(cA.a.PureComponent), $g = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            var WA;
            CA(this, SA);
            for (var OA = arguments.length, Bg = new Array(OA), dg = 0; dg < OA; dg++) Bg[dg] = arguments[dg];
            return (WA = qA.call.apply(qA, [this].concat(Bg))).isValid = function(lg) {
              var Qg = WA.props.rjvId, pg = og.get(Qg, "action", "new-key-request");
              return lg != "" && Object.keys(pg.existing_value).indexOf(lg) === -1;
            }, WA.submit = function(lg) {
              var Qg = WA.props.rjvId, pg = og.get(Qg, "action", "new-key-request");
              pg.new_value = IA({}, pg.existing_value), pg.new_value[lg] = WA.props.defaultValue, Ig.dispatch({ name: "VARIABLE_ADDED", rjvId: Qg, data: pg });
            }, WA;
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.active, Bg = WA.theme, dg = WA.rjvId;
            return OA ? cA.a.createElement(qg, { rjvId: dg, theme: Bg, isValid: this.isValid, submit: this.submit }) : null;
          } }]), SA;
        })(cA.a.PureComponent), Ag = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA() {
            return CA(this, SA), qA.apply(this, arguments);
          }
          return eA(SA, [{ key: "render", value: function() {
            var WA = this.props, OA = WA.message, Bg = WA.active, dg = WA.theme, lg = WA.rjvId;
            return Bg ? cA.a.createElement("div", Object.assign({ className: "validation-failure" }, MA(dg, "validation-failure"), { onClick: function() {
              Ig.dispatch({ rjvId: lg, name: "RESET" });
            } }), cA.a.createElement("span", MA(dg, "validation-failure-label"), OA), cA.a.createElement(Rg, MA(dg, "validation-failure-clear"))) : null;
          } }]), SA;
        })(cA.a.PureComponent), Ng = (function(UA) {
          QA(SA, UA);
          var qA = nA(SA);
          function SA(WA) {
            var OA;
            return CA(this, SA), (OA = qA.call(this, WA)).rjvId = Date.now().toString(), OA.getListeners = function() {
              return { reset: OA.resetState, "variable-update": OA.updateSrc, "add-key-request": OA.addKeyRequest };
            }, OA.updateSrc = function() {
              var Bg, dg = og.get(OA.rjvId, "action", "variable-update"), lg = dg.name, Qg = dg.namespace, pg = dg.new_value, Fg = dg.existing_value, Yg = (dg.variable_removed, dg.updated_src), fg = dg.type, Wg = OA.props, Ug = Wg.onEdit, xg = Wg.onDelete, zg = Wg.onAdd, Lg = { existing_src: OA.state.src, new_value: pg, updated_src: Yg, name: lg, namespace: Qg, existing_value: Fg };
              switch (fg) {
                case "variable-added":
                  Bg = zg(Lg);
                  break;
                case "variable-edited":
                  Bg = Ug(Lg);
                  break;
                case "variable-removed":
                  Bg = xg(Lg);
              }
              Bg !== !1 ? (og.set(OA.rjvId, "global", "src", Yg), OA.setState({ src: Yg })) : OA.setState({ validationFailure: !0 });
            }, OA.addKeyRequest = function() {
              OA.setState({ addKeyRequest: !0 });
            }, OA.resetState = function() {
              OA.setState({ validationFailure: !1, addKeyRequest: !1 });
            }, OA.state = { addKeyRequest: !1, editKeyRequest: !1, validationFailure: !1, src: SA.defaultProps.src, name: SA.defaultProps.name, theme: SA.defaultProps.theme, validationMessage: SA.defaultProps.validationMessage, prevSrc: SA.defaultProps.src, prevName: SA.defaultProps.name, prevTheme: SA.defaultProps.theme }, OA;
          }
          return eA(SA, [{ key: "componentDidMount", value: function() {
            og.set(this.rjvId, "global", "src", this.state.src);
            var WA = this.getListeners();
            for (var OA in WA) og.on(OA + "-" + this.rjvId, WA[OA]);
            this.setState({ addKeyRequest: !1, editKeyRequest: !1 });
          } }, { key: "componentDidUpdate", value: function(WA, OA) {
            OA.addKeyRequest !== !1 && this.setState({ addKeyRequest: !1 }), OA.editKeyRequest !== !1 && this.setState({ editKeyRequest: !1 }), WA.src !== this.state.src && og.set(this.rjvId, "global", "src", this.state.src);
          } }, { key: "componentWillUnmount", value: function() {
            var WA = this.getListeners();
            for (var OA in WA) og.removeListener(OA + "-" + this.rjvId, WA[OA]);
          } }, { key: "render", value: function() {
            var WA = this.state, OA = WA.validationFailure, Bg = WA.validationMessage, dg = WA.addKeyRequest, lg = WA.theme, Qg = WA.src, pg = WA.name, Fg = this.props, Yg = Fg.style, fg = Fg.defaultValue;
            return cA.a.createElement("div", { className: "react-json-view", style: IA(IA({}, MA(lg, "app-container").style), Yg) }, cA.a.createElement(Ag, { message: Bg, active: OA, theme: lg, rjvId: this.rjvId }), cA.a.createElement(Zg, Object.assign({}, this.props, { src: Qg, name: pg, theme: lg, type: GA(Qg), rjvId: this.rjvId })), cA.a.createElement($g, { active: dg, theme: lg, rjvId: this.rjvId, defaultValue: fg }));
          } }], [{ key: "getDerivedStateFromProps", value: function(WA, OA) {
            if (WA.src !== OA.prevSrc || WA.name !== OA.prevName || WA.theme !== OA.prevTheme) {
              var Bg = { src: WA.src, name: WA.name, theme: WA.theme, validationMessage: WA.validationMessage, prevSrc: WA.src, prevName: WA.name, prevTheme: WA.theme };
              return SA.validateState(Bg);
            }
            return null;
          } }]), SA;
        })(cA.a.PureComponent);
        Ng.defaultProps = { src: {}, name: "root", theme: "rjv-default", collapsed: !1, collapseStringsAfterLength: !1, shouldCollapse: !1, sortKeys: !1, quotesOnKeys: !0, groupArraysAfterLength: 100, indentWidth: 4, enableClipboard: !0, displayObjectSize: !0, displayDataTypes: !0, onEdit: !1, onDelete: !1, onAdd: !1, onSelect: !1, iconStyle: "triangle", style: {}, validationMessage: "Validation Error", defaultValue: null, displayArrayKey: !0 }, Ng.validateState = function(UA) {
          var qA = {};
          return GA(UA.theme) !== "object" || (function(SA) {
            var WA = ["base00", "base01", "base02", "base03", "base04", "base05", "base06", "base07", "base08", "base09", "base0A", "base0B", "base0C", "base0D", "base0E", "base0F"];
            if (GA(SA) === "object") {
              for (var OA = 0; OA < WA.length; OA++) if (!(WA[OA] in SA)) return !1;
              return !0;
            }
            return !1;
          })(UA.theme) || (console.error("react-json-view error:", "theme prop must be a theme name or valid base-16 theme object.", 'defaulting to "rjv-default" theme'), qA.theme = "rjv-default"), GA(UA.src) !== "object" && GA(UA.src) !== "array" && (console.error("react-json-view error:", "src property must be a valid json object"), qA.name = "ERROR", qA.src = { message: "src property must be a valid json object" }), IA(IA({}, UA), qA);
        }, hA(Ng), k.default = Ng;
      }]);
    }));
  })(main$2)), main$2.exports;
}
var mainExports = requireMain();
const ReactJson = /* @__PURE__ */ getDefaultExportFromCjs$2(mainExports), StyledJsonWrapper = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1xfr5s0"
} : {
  target: "e1xfr5s0",
  label: "StyledJsonWrapper"
})(({
  theme: n
}) => ({
  overflowY: "auto",
  ".react-json-view .copy-icon svg": {
    // Make the copy icon responsive to the root font size.
    fontSize: "1em !important",
    marginRight: `${n.spacing.threeXS} !important`,
    verticalAlign: "middle !important"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Kc29uL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCaUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0pzb24vc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNSlcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEpzb25XcmFwcGVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBvdmVyZmxvd1k6IFwiYXV0b1wiLFxuICBcIi5yZWFjdC1qc29uLXZpZXcgLmNvcHktaWNvbiBzdmdcIjoge1xuICAgIC8vIE1ha2UgdGhlIGNvcHkgaWNvbiByZXNwb25zaXZlIHRvIHRoZSByb290IGZvbnQgc2l6ZS5cbiAgICBmb250U2l6ZTogYDFlbSAhaW1wb3J0YW50YCxcbiAgICBtYXJnaW5SaWdodDogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAhaW1wb3J0YW50YCxcbiAgICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZSAhaW1wb3J0YW50XCIsXG4gIH0sXG59KSlcbiJdfQ== */");
function Json({
  element: n
}) {
  const t = useEmotionTheme(), {
    copyToClipboard: g
  } = useCopyToClipboard(), d = useCallback((AA) => {
    g(JSON.stringify(AA.src));
  }, [g]);
  let k;
  try {
    k = JSON.parse(n.body);
  } catch (AA) {
    const gA = ensureError(AA);
    try {
      k = lib$1.parse(n.body);
    } catch {
      const CA = parseInt(gA.message.replace(/[^0-9]/g, ""), 10);
      return gA.message += `
${n.body.substring(0, CA + 1)} ← here`, /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorElement, { name: "Json Parse Error", message: gA.message });
    }
  }
  const H = hasLightBackgroundColor(t) ? "rjv-default" : "monokai";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledJsonWrapper, { className: "stJson", "data-testid": "stJson", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReactJson, { src: k, collapsed: n.maxExpandDepth ?? !n.expanded, displayDataTypes: !1, displayObjectSize: !1, name: !1, theme: H, enableClipboard: d, style: {
    fontFamily: t.genericFonts.codeFont,
    fontSize: t.fontSizes.codeFontSize,
    fontWeight: t.fontWeights.code,
    backgroundColor: t.colors.bgColor,
    whiteSpace: "pre-wrap"
    // preserve whitespace
  } }) });
}
const Json$1 = memo$1(Json);
function Markdown({
  element: n
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stMarkdown", "data-testid": "stMarkdown", children: n.help ? /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledLabelHelpWrapper, { isLatex: n.elementType === Markdown$3.Type.LATEX, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { isCaption: n.isCaption, source: n.body, allowHTML: n.allowHtml }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: n.help, isLatex: n.elementType === Markdown$3.Type.LATEX })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { isCaption: n.isCaption, source: n.body, allowHTML: n.allowHtml }) });
}
const Markdown$1 = memo$1(Markdown), stringOrChar = /("(?:[^\\"]|\\.)*")|[:,]/g;
function stringify$2(n, t = {}) {
  const g = JSON.stringify(
    [1],
    void 0,
    t.indent === void 0 ? 2 : t.indent
  ).slice(2, -3), d = g === "" ? 1 / 0 : t.maxLength === void 0 ? 80 : t.maxLength;
  let { replacer: k } = t;
  return (function H(AA, gA, IA) {
    AA && typeof AA.toJSON == "function" && (AA = AA.toJSON());
    const CA = JSON.stringify(AA, k);
    if (CA === void 0)
      return CA;
    const BA = d - gA.length - IA;
    if (CA.length <= BA) {
      const eA = CA.replace(
        stringOrChar,
        (iA, QA) => QA || `${iA} `
      );
      if (eA.length <= BA)
        return eA;
    }
    if (k != null && (AA = JSON.parse(CA), k = void 0), typeof AA == "object" && AA !== null) {
      const eA = gA + g, iA = [];
      let QA = 0, tA, oA;
      if (Array.isArray(AA)) {
        tA = "[", oA = "]";
        const { length: EA } = AA;
        for (; QA < EA; QA++)
          iA.push(
            H(AA[QA], eA, QA === EA - 1 ? 0 : 1) || "null"
          );
      } else {
        tA = "{", oA = "}";
        const EA = Object.keys(AA), { length: aA } = EA;
        for (; QA < aA; QA++) {
          const nA = EA[QA], lA = `${JSON.stringify(nA)}: `, cA = H(
            AA[nA],
            eA,
            lA.length + (QA === aA - 1 ? 0 : 1)
          );
          cA !== void 0 && iA.push(lA + cA);
        }
      }
      if (iA.length > 0)
        return [tA, g + iA.join(`,
${eA}`), oA].join(
          `
${gA}`
        );
    }
    return CA;
  })(n, "", 0);
}
function accessor$2(n, t, g) {
  return n.fields = t || [], n.fname = g, n;
}
function accessorName(n) {
  return n == null ? null : n.fname;
}
function accessorFields(n) {
  return n == null ? null : n.fields;
}
function getter$3(n) {
  return n.length === 1 ? get1$2(n[0]) : getN$2(n);
}
const get1$2 = (n) => function(t) {
  return t[n];
}, getN$2 = (n) => {
  const t = n.length;
  return function(g) {
    for (let d = 0; d < t; ++d)
      g = g[n[d]];
    return g;
  };
};
function error$3(n) {
  throw Error(n);
}
function splitAccessPath$2(n) {
  const t = [], g = n.length;
  let d = null, k = 0, H = "", AA, gA, IA;
  n = n + "";
  function CA() {
    t.push(H + n.substring(AA, gA)), H = "", AA = gA + 1;
  }
  for (AA = gA = 0; gA < g; ++gA)
    if (IA = n[gA], IA === "\\")
      H += n.substring(AA, gA++), AA = gA;
    else if (IA === d)
      CA(), d = null, k = -1;
    else {
      if (d)
        continue;
      AA === k && IA === '"' || AA === k && IA === "'" ? (AA = gA + 1, d = IA) : IA === "." && !k ? gA > AA ? CA() : AA = gA + 1 : IA === "[" ? (gA > AA && CA(), k = AA = gA + 1) : IA === "]" && (k || error$3("Access path missing open bracket: " + n), k > 0 && CA(), k = 0, AA = gA + 1);
    }
  return k && error$3("Access path missing closing bracket: " + n), d && error$3("Access path missing closing quote: " + n), gA > AA && (gA++, CA()), t;
}
function field$4(n, t, g) {
  const d = splitAccessPath$2(n);
  return n = d.length === 1 ? d[0] : n, accessor$2((g && g.get || getter$3)(d), [n], t || n);
}
const id = field$4("id"), identity$8 = accessor$2((n) => n, [], "identity"), zero$4 = accessor$2(() => 0, [], "zero"), one$2 = accessor$2(() => 1, [], "one"), truthy = accessor$2(() => !0, [], "true"), falsy = accessor$2(() => !1, [], "false"), DisallowedObjectProperties = /* @__PURE__ */ new Set([...Object.getOwnPropertyNames(Object.prototype).filter((n) => typeof Object.prototype[n] == "function"), "__proto__"]);
function log$1$1(n, t, g) {
  const d = [t].concat([].slice.call(g));
  console[n].apply(console, d);
}
const None$3 = 0, Error$1$1 = 1, Warn$1 = 2, Info$1 = 3, Debug$1 = 4;
function logger$1(n, t, g = log$1$1) {
  let d = n || None$3;
  return {
    level(k) {
      return arguments.length ? (d = +k, this) : d;
    },
    error() {
      return d >= Error$1$1 && g(t || "error", "ERROR", arguments), this;
    },
    warn() {
      return d >= Warn$1 && g(t || "warn", "WARN", arguments), this;
    },
    info() {
      return d >= Info$1 && g(t || "log", "INFO", arguments), this;
    },
    debug() {
      return d >= Debug$1 && g(t || "log", "DEBUG", arguments), this;
    }
  };
}
var isArray$3 = Array.isArray;
function isObject$4(n) {
  return n === Object(n);
}
const isLegalKey$1 = (n) => n !== "__proto__";
function mergeConfig$3(...n) {
  return n.reduce((t, g) => {
    for (const d in g)
      if (d === "signals")
        t.signals = mergeNamed$1(t.signals, g.signals);
      else {
        const k = d === "legend" ? {
          layout: 1
        } : d === "style" ? !0 : null;
        writeConfig$1(t, d, g[d], k);
      }
    return t;
  }, {});
}
function writeConfig$1(n, t, g, d) {
  if (!isLegalKey$1(t)) return;
  let k, H;
  if (isObject$4(g) && !isArray$3(g)) {
    H = isObject$4(n[t]) ? n[t] : n[t] = {};
    for (k in g)
      d && (d === !0 || d[k]) ? writeConfig$1(H, k, g[k]) : isLegalKey$1(k) && (H[k] = g[k]);
  } else
    n[t] = g;
}
function mergeNamed$1(n, t) {
  if (n == null) return t;
  const g = {}, d = [];
  function k(H) {
    g[H.name] || (g[H.name] = 1, d.push(H));
  }
  return t.forEach(k), n.forEach(k), d;
}
function peek$2(n) {
  return n[n.length - 1];
}
function toNumber$1(n) {
  return n == null || n === "" ? null : +n;
}
const exp$2 = (n) => (t) => n * Math.exp(t), log$5 = (n) => (t) => Math.log(n * t), symlog$1 = (n) => (t) => Math.sign(t) * Math.log1p(Math.abs(t / n)), symexp = (n) => (t) => Math.sign(t) * Math.expm1(Math.abs(t)) * n, pow$4 = (n) => (t) => t < 0 ? -Math.pow(-t, n) : Math.pow(t, n);
function pan(n, t, g, d) {
  const k = g(n[0]), H = g(peek$2(n)), AA = (H - k) * t;
  return [d(k - AA), d(H - AA)];
}
function panLinear(n, t) {
  return pan(n, t, toNumber$1, identity$8);
}
function panLog(n, t) {
  var g = Math.sign(n[0]);
  return pan(n, t, log$5(g), exp$2(g));
}
function panPow(n, t, g) {
  return pan(n, t, pow$4(g), pow$4(1 / g));
}
function panSymlog(n, t, g) {
  return pan(n, t, symlog$1(g), symexp(g));
}
function zoom$1(n, t, g, d, k) {
  const H = d(n[0]), AA = d(peek$2(n)), gA = t != null ? d(t) : (H + AA) / 2;
  return [k(gA + (H - gA) * g), k(gA + (AA - gA) * g)];
}
function zoomLinear(n, t, g) {
  return zoom$1(n, t, g, toNumber$1, identity$8);
}
function zoomLog(n, t, g) {
  const d = Math.sign(n[0]);
  return zoom$1(n, t, g, log$5(d), exp$2(d));
}
function zoomPow(n, t, g, d) {
  return zoom$1(n, t, g, pow$4(d), pow$4(1 / d));
}
function zoomSymlog(n, t, g, d) {
  return zoom$1(n, t, g, symlog$1(d), symexp(d));
}
function quarter(n) {
  return 1 + ~~(new Date(n).getMonth() / 3);
}
function utcquarter(n) {
  return 1 + ~~(new Date(n).getUTCMonth() / 3);
}
function array$6(n) {
  return n != null ? isArray$3(n) ? n : [n] : [];
}
function clampRange(n, t, g) {
  let d = n[0], k = n[1], H;
  return k < d && (H = k, k = d, d = H), H = k - d, H >= g - t ? [t, g] : [d = Math.min(Math.max(d, t), g - H), d + H];
}
function isFunction$5(n) {
  return typeof n == "function";
}
const DESCENDING = "descending";
function compare$3(n, t, g) {
  g = g || {}, t = array$6(t) || [];
  const d = [], k = [], H = {}, AA = g.comparator || comparator$1;
  return array$6(n).forEach((gA, IA) => {
    gA != null && (d.push(t[IA] === DESCENDING ? -1 : 1), k.push(gA = isFunction$5(gA) ? gA : field$4(gA, null, g)), (accessorFields(gA) || []).forEach((CA) => H[CA] = 1));
  }), k.length === 0 ? null : accessor$2(AA(k, d), Object.keys(H));
}
const ascending$2 = (n, t) => (n < t || n == null) && t != null ? -1 : (n > t || t == null) && n != null ? 1 : (t = t instanceof Date ? +t : t, (n = n instanceof Date ? +n : n) !== n && t === t ? -1 : t !== t && n === n ? 1 : 0), comparator$1 = (n, t) => n.length === 1 ? compare1(n[0], t[0]) : compareN(n, t, n.length), compare1 = (n, t) => function(g, d) {
  return ascending$2(n(g), n(d)) * t;
}, compareN = (n, t, g) => (t.push(0), function(d, k) {
  let H, AA = 0, gA = -1;
  for (; AA === 0 && ++gA < g; )
    H = n[gA], AA = ascending$2(H(d), H(k));
  return AA * t[gA];
});
function constant$6(n) {
  return isFunction$5(n) ? n : () => n;
}
function debounce$1(n, t) {
  let g;
  return (d) => {
    g && clearTimeout(g), g = setTimeout(() => (t(d), g = null), n);
  };
}
function extend$2(n) {
  for (let t, g, d = 1, k = arguments.length; d < k; ++d) {
    t = arguments[d];
    for (g in t)
      n[g] = t[g];
  }
  return n;
}
function extent(n, t) {
  let g = 0, d, k, H, AA;
  if (n && (d = n.length))
    if (t == null) {
      for (k = n[g]; g < d && (k == null || k !== k); k = n[++g]) ;
      for (H = AA = k; g < d; ++g)
        k = n[g], k != null && (k < H && (H = k), k > AA && (AA = k));
    } else {
      for (k = t(n[g]); g < d && (k == null || k !== k); k = t(n[++g])) ;
      for (H = AA = k; g < d; ++g)
        k = t(n[g]), k != null && (k < H && (H = k), k > AA && (AA = k));
    }
  return [H, AA];
}
function extentIndex(n, t) {
  const g = n.length;
  let d = -1, k, H, AA, gA, IA;
  if (t == null) {
    for (; ++d < g; )
      if (H = n[d], H != null && H >= H) {
        k = AA = H;
        break;
      }
    if (d === g) return [-1, -1];
    for (gA = IA = d; ++d < g; )
      H = n[d], H != null && (k > H && (k = H, gA = d), AA < H && (AA = H, IA = d));
  } else {
    for (; ++d < g; )
      if (H = t(n[d], d, n), H != null && H >= H) {
        k = AA = H;
        break;
      }
    if (d === g) return [-1, -1];
    for (gA = IA = d; ++d < g; )
      H = t(n[d], d, n), H != null && (k > H && (k = H, gA = d), AA < H && (AA = H, IA = d));
  }
  return [gA, IA];
}
function has$2(n, t) {
  return Object.hasOwn(n, t);
}
const NULL = {};
function fastmap(n) {
  let t = {}, g;
  function d(H) {
    return has$2(t, H) && t[H] !== NULL;
  }
  const k = {
    size: 0,
    empty: 0,
    object: t,
    has: d,
    get(H) {
      return d(H) ? t[H] : void 0;
    },
    set(H, AA) {
      return d(H) || (++k.size, t[H] === NULL && --k.empty), t[H] = AA, this;
    },
    delete(H) {
      return d(H) && (--k.size, ++k.empty, t[H] = NULL), this;
    },
    clear() {
      k.size = k.empty = 0, k.object = t = {};
    },
    test(H) {
      return arguments.length ? (g = H, k) : g;
    },
    clean() {
      const H = {};
      let AA = 0;
      for (const gA in t) {
        const IA = t[gA];
        IA !== NULL && (!g || !g(IA)) && (H[gA] = IA, ++AA);
      }
      k.size = AA, k.empty = 0, k.object = t = H;
    }
  };
  return n && Object.keys(n).forEach((H) => {
    k.set(H, n[H]);
  }), k;
}
function flush(n, t, g, d, k, H) {
  if (!g && g !== 0) return H;
  const AA = +g;
  let gA = n[0], IA = peek$2(n), CA;
  IA < gA && (CA = gA, gA = IA, IA = CA), CA = Math.abs(t - gA);
  const BA = Math.abs(IA - t);
  return CA < BA && CA <= AA ? d : BA <= AA ? k : H;
}
function inherits$1(n, t, g) {
  const d = n.prototype = Object.create(t.prototype);
  return Object.defineProperty(d, "constructor", {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  }), extend$2(d, g);
}
function inrange(n, t, g, d) {
  let k = t[0], H = t[t.length - 1], AA;
  return k > H && (AA = k, k = H, H = AA), g = g === void 0 || g, d = d === void 0 || d, (g ? k <= n : k < n) && (d ? n <= H : n < H);
}
function isBoolean$4(n) {
  return typeof n == "boolean";
}
function isDate$2(n) {
  return Object.prototype.toString.call(n) === "[object Date]";
}
function isIterable$1(n) {
  return n && isFunction$5(n[Symbol.iterator]);
}
function isNumber$3(n) {
  return typeof n == "number";
}
function isRegExp$1(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
function isString$2(n) {
  return typeof n == "string";
}
function key(n, t, g) {
  n && (n = t ? array$6(n).map((gA) => gA.replace(/\\(.)/g, "$1")) : array$6(n));
  const d = n && n.length, k = g && g.get || getter$3, H = (gA) => k(t ? [gA] : splitAccessPath$2(gA));
  let AA;
  if (!d)
    AA = function() {
      return "";
    };
  else if (d === 1) {
    const gA = H(n[0]);
    AA = function(IA) {
      return "" + gA(IA);
    };
  } else {
    const gA = n.map(H);
    AA = function(IA) {
      let CA = "" + gA[0](IA), BA = 0;
      for (; ++BA < d; ) CA += "|" + gA[BA](IA);
      return CA;
    };
  }
  return accessor$2(AA, n, "key");
}
function lerp(n, t) {
  const g = n[0], d = peek$2(n), k = +t;
  return k ? k === 1 ? d : g + k * (d - g) : g;
}
const DEFAULT_MAX_SIZE = 1e4;
function lruCache(n) {
  n = +n || DEFAULT_MAX_SIZE;
  let t, g, d;
  const k = () => {
    t = {}, g = {}, d = 0;
  }, H = (AA, gA) => (++d > n && (g = t, t = {}, d = 1), t[AA] = gA);
  return k(), {
    clear: k,
    has: (AA) => has$2(t, AA) || has$2(g, AA),
    get: (AA) => has$2(t, AA) ? t[AA] : has$2(g, AA) ? H(AA, g[AA]) : void 0,
    set: (AA, gA) => has$2(t, AA) ? t[AA] = gA : H(AA, gA)
  };
}
function merge$5(n, t, g, d) {
  const k = t.length, H = g.length;
  if (!H) return t;
  if (!k) return g;
  const AA = d || new t.constructor(k + H);
  let gA = 0, IA = 0, CA = 0;
  for (; gA < k && IA < H; ++CA)
    AA[CA] = n(t[gA], g[IA]) > 0 ? g[IA++] : t[gA++];
  for (; gA < k; ++gA, ++CA)
    AA[CA] = t[gA];
  for (; IA < H; ++IA, ++CA)
    AA[CA] = g[IA];
  return AA;
}
function repeat(n, t) {
  let g = "";
  for (; --t >= 0; ) g += n;
  return g;
}
function pad$2(n, t, g, d) {
  const k = g || " ", H = n + "", AA = t - H.length;
  return AA <= 0 ? H : d === "left" ? repeat(k, AA) + H : d === "center" ? repeat(k, ~~(AA / 2)) + H + repeat(k, Math.ceil(AA / 2)) : H + repeat(k, AA);
}
function span(n) {
  return n && peek$2(n) - n[0] || 0;
}
function $$2(n) {
  return isArray$3(n) ? `[${n.map((t) => t === null ? "null" : $$2(t))}]` : isObject$4(n) || isString$2(n) ? (
    // Output valid JSON and JS source strings.
    // See https://github.com/judofyr/timeless/blob/master/posts/json-isnt-a-javascript-subset.md
    JSON.stringify(n).replaceAll("\u2028", "\\u2028").replaceAll("\u2029", "\\u2029")
  ) : n;
}
function toBoolean(n) {
  return n == null || n === "" ? null : !n || n === "false" || n === "0" ? !1 : !!n;
}
const defaultParser = (n) => isNumber$3(n) || isDate$2(n) ? n : Date.parse(n);
function toDate(n, t) {
  return t = t || defaultParser, n == null || n === "" ? null : t(n);
}
function toString$3(n) {
  return n == null || n === "" ? null : n + "";
}
function toSet(n) {
  const t = {}, g = n.length;
  for (let d = 0; d < g; ++d) t[n[d]] = !0;
  return t;
}
function truncate$1(n, t, g, d) {
  const k = d ?? "…", H = n + "", AA = H.length, gA = Math.max(0, t - k.length);
  return AA <= t ? H : g === "left" ? k + H.slice(AA - gA) : g === "center" ? H.slice(0, Math.ceil(gA / 2)) + k + H.slice(AA - ~~(gA / 2)) : H.slice(0, gA) + k;
}
function visitArray(n, t, g) {
  if (n)
    if (t) {
      const d = n.length;
      for (let k = 0; k < d; ++k) {
        const H = t(n[k]);
        H && g(H, k, n);
      }
    } else
      n.forEach(g);
}
var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
function objectConverter(n) {
  return new Function("d", "return {" + n.map(function(t, g) {
    return JSON.stringify(t) + ": d[" + g + '] || ""';
  }).join(",") + "}");
}
function customConverter(n, t) {
  var g = objectConverter(n);
  return function(d, k) {
    return t(g(d), k, n);
  };
}
function inferColumns(n) {
  var t = /* @__PURE__ */ Object.create(null), g = [];
  return n.forEach(function(d) {
    for (var k in d)
      k in t || g.push(t[k] = k);
  }), g;
}
function pad$1(n, t) {
  var g = n + "", d = g.length;
  return d < t ? new Array(t - d + 1).join(0) + g : g;
}
function formatYear$1(n) {
  return n < 0 ? "-" + pad$1(-n, 6) : n > 9999 ? "+" + pad$1(n, 6) : pad$1(n, 4);
}
function formatDate(n) {
  var t = n.getUTCHours(), g = n.getUTCMinutes(), d = n.getUTCSeconds(), k = n.getUTCMilliseconds();
  return isNaN(n) ? "Invalid Date" : formatYear$1(n.getUTCFullYear()) + "-" + pad$1(n.getUTCMonth() + 1, 2) + "-" + pad$1(n.getUTCDate(), 2) + (k ? "T" + pad$1(t, 2) + ":" + pad$1(g, 2) + ":" + pad$1(d, 2) + "." + pad$1(k, 3) + "Z" : d ? "T" + pad$1(t, 2) + ":" + pad$1(g, 2) + ":" + pad$1(d, 2) + "Z" : g || t ? "T" + pad$1(t, 2) + ":" + pad$1(g, 2) + "Z" : "");
}
function dsvFormat(n) {
  var t = new RegExp('["' + n + `
\r]`), g = n.charCodeAt(0);
  function d(eA, iA) {
    var QA, tA, oA = k(eA, function(EA, aA) {
      if (QA) return QA(EA, aA - 1);
      tA = EA, QA = iA ? customConverter(EA, iA) : objectConverter(EA);
    });
    return oA.columns = tA || [], oA;
  }
  function k(eA, iA) {
    var QA = [], tA = eA.length, oA = 0, EA = 0, aA, nA = tA <= 0, lA = !1;
    eA.charCodeAt(tA - 1) === NEWLINE && --tA, eA.charCodeAt(tA - 1) === RETURN && --tA;
    function cA() {
      if (nA) return EOF;
      if (lA) return lA = !1, EOL;
      var rA, uA = oA, hA;
      if (eA.charCodeAt(uA) === QUOTE) {
        for (; oA++ < tA && eA.charCodeAt(oA) !== QUOTE || eA.charCodeAt(++oA) === QUOTE; ) ;
        return (rA = oA) >= tA ? nA = !0 : (hA = eA.charCodeAt(oA++)) === NEWLINE ? lA = !0 : hA === RETURN && (lA = !0, eA.charCodeAt(oA) === NEWLINE && ++oA), eA.slice(uA + 1, rA - 1).replace(/""/g, '"');
      }
      for (; oA < tA; ) {
        if ((hA = eA.charCodeAt(rA = oA++)) === NEWLINE) lA = !0;
        else if (hA === RETURN)
          lA = !0, eA.charCodeAt(oA) === NEWLINE && ++oA;
        else if (hA !== g) continue;
        return eA.slice(uA, rA);
      }
      return nA = !0, eA.slice(uA, tA);
    }
    for (; (aA = cA()) !== EOF; ) {
      for (var sA = []; aA !== EOL && aA !== EOF; ) sA.push(aA), aA = cA();
      iA && (sA = iA(sA, EA++)) == null || QA.push(sA);
    }
    return QA;
  }
  function H(eA, iA) {
    return eA.map(function(QA) {
      return iA.map(function(tA) {
        return BA(QA[tA]);
      }).join(n);
    });
  }
  function AA(eA, iA) {
    return iA == null && (iA = inferColumns(eA)), [iA.map(BA).join(n)].concat(H(eA, iA)).join(`
`);
  }
  function gA(eA, iA) {
    return iA == null && (iA = inferColumns(eA)), H(eA, iA).join(`
`);
  }
  function IA(eA) {
    return eA.map(CA).join(`
`);
  }
  function CA(eA) {
    return eA.map(BA).join(n);
  }
  function BA(eA) {
    return eA == null ? "" : eA instanceof Date ? formatDate(eA) : t.test(eA += "") ? '"' + eA.replace(/"/g, '""') + '"' : eA;
  }
  return {
    parse: d,
    parseRows: k,
    format: AA,
    formatBody: gA,
    formatRows: IA,
    formatRow: CA,
    formatValue: BA
  };
}
function identity$7(n) {
  return n;
}
function transform$3(n) {
  if (n == null) return identity$7;
  var t, g, d = n.scale[0], k = n.scale[1], H = n.translate[0], AA = n.translate[1];
  return function(gA, IA) {
    IA || (t = g = 0);
    var CA = 2, BA = gA.length, eA = new Array(BA);
    for (eA[0] = (t += gA[0]) * d + H, eA[1] = (g += gA[1]) * k + AA; CA < BA; ) eA[CA] = gA[CA], ++CA;
    return eA;
  };
}
function reverse$2(n, t) {
  for (var g, d = n.length, k = d - t; k < --d; ) g = n[k], n[k++] = n[d], n[d] = g;
}
function feature(n, t) {
  return typeof t == "string" && (t = n.objects[t]), t.type === "GeometryCollection" ? { type: "FeatureCollection", features: t.geometries.map(function(g) {
    return feature$1(n, g);
  }) } : feature$1(n, t);
}
function feature$1(n, t) {
  var g = t.id, d = t.bbox, k = t.properties == null ? {} : t.properties, H = object$2(n, t);
  return g == null && d == null ? { type: "Feature", properties: k, geometry: H } : d == null ? { type: "Feature", id: g, properties: k, geometry: H } : { type: "Feature", id: g, bbox: d, properties: k, geometry: H };
}
function object$2(n, t) {
  var g = transform$3(n.transform), d = n.arcs;
  function k(BA, eA) {
    eA.length && eA.pop();
    for (var iA = d[BA < 0 ? ~BA : BA], QA = 0, tA = iA.length; QA < tA; ++QA)
      eA.push(g(iA[QA], QA));
    BA < 0 && reverse$2(eA, tA);
  }
  function H(BA) {
    return g(BA);
  }
  function AA(BA) {
    for (var eA = [], iA = 0, QA = BA.length; iA < QA; ++iA) k(BA[iA], eA);
    return eA.length < 2 && eA.push(eA[0]), eA;
  }
  function gA(BA) {
    for (var eA = AA(BA); eA.length < 4; ) eA.push(eA[0]);
    return eA;
  }
  function IA(BA) {
    return BA.map(gA);
  }
  function CA(BA) {
    var eA = BA.type, iA;
    switch (eA) {
      case "GeometryCollection":
        return { type: eA, geometries: BA.geometries.map(CA) };
      case "Point":
        iA = H(BA.coordinates);
        break;
      case "MultiPoint":
        iA = BA.coordinates.map(H);
        break;
      case "LineString":
        iA = AA(BA.arcs);
        break;
      case "MultiLineString":
        iA = BA.arcs.map(AA);
        break;
      case "Polygon":
        iA = IA(BA.arcs);
        break;
      case "MultiPolygon":
        iA = BA.arcs.map(IA);
        break;
      default:
        return null;
    }
    return { type: eA, coordinates: iA };
  }
  return CA(t);
}
function stitch(n, t) {
  var g = {}, d = {}, k = {}, H = [], AA = -1;
  t.forEach(function(CA, BA) {
    var eA = n.arcs[CA < 0 ? ~CA : CA], iA;
    eA.length < 3 && !eA[1][0] && !eA[1][1] && (iA = t[++AA], t[AA] = CA, t[BA] = iA);
  }), t.forEach(function(CA) {
    var BA = gA(CA), eA = BA[0], iA = BA[1], QA, tA;
    if (QA = k[eA])
      if (delete k[QA.end], QA.push(CA), QA.end = iA, tA = d[iA]) {
        delete d[tA.start];
        var oA = tA === QA ? QA : QA.concat(tA);
        d[oA.start = QA.start] = k[oA.end = tA.end] = oA;
      } else
        d[QA.start] = k[QA.end] = QA;
    else if (QA = d[iA])
      if (delete d[QA.start], QA.unshift(CA), QA.start = eA, tA = k[eA]) {
        delete k[tA.end];
        var EA = tA === QA ? QA : tA.concat(QA);
        d[EA.start = tA.start] = k[EA.end = QA.end] = EA;
      } else
        d[QA.start] = k[QA.end] = QA;
    else
      QA = [CA], d[QA.start = eA] = k[QA.end = iA] = QA;
  });
  function gA(CA) {
    var BA = n.arcs[CA < 0 ? ~CA : CA], eA = BA[0], iA;
    return n.transform ? (iA = [0, 0], BA.forEach(function(QA) {
      iA[0] += QA[0], iA[1] += QA[1];
    })) : iA = BA[BA.length - 1], CA < 0 ? [iA, eA] : [eA, iA];
  }
  function IA(CA, BA) {
    for (var eA in CA) {
      var iA = CA[eA];
      delete BA[iA.start], delete iA.start, delete iA.end, iA.forEach(function(QA) {
        g[QA < 0 ? ~QA : QA] = 1;
      }), H.push(iA);
    }
  }
  return IA(k, d), IA(d, k), t.forEach(function(CA) {
    g[CA < 0 ? ~CA : CA] || H.push([CA]);
  }), H;
}
function mesh(n) {
  return object$2(n, meshArcs.apply(this, arguments));
}
function meshArcs(n, t, g) {
  var d, k, H;
  if (arguments.length > 1) d = extractArcs(n, t, g);
  else for (k = 0, d = new Array(H = n.arcs.length); k < H; ++k) d[k] = k;
  return { type: "MultiLineString", arcs: stitch(n, d) };
}
function extractArcs(n, t, g) {
  var d = [], k = [], H;
  function AA(eA) {
    var iA = eA < 0 ? ~eA : eA;
    (k[iA] || (k[iA] = [])).push({ i: eA, g: H });
  }
  function gA(eA) {
    eA.forEach(AA);
  }
  function IA(eA) {
    eA.forEach(gA);
  }
  function CA(eA) {
    eA.forEach(IA);
  }
  function BA(eA) {
    switch (H = eA, eA.type) {
      case "GeometryCollection":
        eA.geometries.forEach(BA);
        break;
      case "LineString":
        gA(eA.arcs);
        break;
      case "MultiLineString":
      case "Polygon":
        IA(eA.arcs);
        break;
      case "MultiPolygon":
        CA(eA.arcs);
        break;
    }
  }
  return BA(t), k.forEach(g == null ? function(eA) {
    d.push(eA[0].i);
  } : function(eA) {
    g(eA[0].g, eA[eA.length - 1].g) && d.push(eA[0].i);
  }), d;
}
function ascending$1(n, t) {
  return n == null || t == null ? NaN : n < t ? -1 : n > t ? 1 : n >= t ? 0 : NaN;
}
function descending$1(n, t) {
  return n == null || t == null ? NaN : t < n ? -1 : t > n ? 1 : t >= n ? 0 : NaN;
}
function bisector(n) {
  let t, g, d;
  n.length !== 2 ? (t = ascending$1, g = (gA, IA) => ascending$1(n(gA), IA), d = (gA, IA) => n(gA) - IA) : (t = n === ascending$1 || n === descending$1 ? n : zero$3, g = n, d = n);
  function k(gA, IA, CA = 0, BA = gA.length) {
    if (CA < BA) {
      if (t(IA, IA) !== 0) return BA;
      do {
        const eA = CA + BA >>> 1;
        g(gA[eA], IA) < 0 ? CA = eA + 1 : BA = eA;
      } while (CA < BA);
    }
    return CA;
  }
  function H(gA, IA, CA = 0, BA = gA.length) {
    if (CA < BA) {
      if (t(IA, IA) !== 0) return BA;
      do {
        const eA = CA + BA >>> 1;
        g(gA[eA], IA) <= 0 ? CA = eA + 1 : BA = eA;
      } while (CA < BA);
    }
    return CA;
  }
  function AA(gA, IA, CA = 0, BA = gA.length) {
    const eA = k(gA, IA, CA, BA - 1);
    return eA > CA && d(gA[eA - 1], IA) > -d(gA[eA], IA) ? eA - 1 : eA;
  }
  return { left: k, center: AA, right: H };
}
function zero$3() {
  return 0;
}
function number$6(n) {
  return n === null ? NaN : +n;
}
function* numbers$2(n, t) {
  if (t === void 0)
    for (let g of n)
      g != null && (g = +g) >= g && (yield g);
  else {
    let g = -1;
    for (let d of n)
      (d = t(d, ++g, n)) != null && (d = +d) >= d && (yield d);
  }
}
const ascendingBisect = bisector(ascending$1), bisectRight$1 = ascendingBisect.right, bisectLeft$1 = ascendingBisect.left;
bisector(number$6).center;
function variance(n, t) {
  let g = 0, d, k = 0, H = 0;
  if (t === void 0)
    for (let AA of n)
      AA != null && (AA = +AA) >= AA && (d = AA - k, k += d / ++g, H += d * (AA - k));
  else {
    let AA = -1;
    for (let gA of n)
      (gA = t(gA, ++AA, n)) != null && (gA = +gA) >= gA && (d = gA - k, k += d / ++g, H += d * (gA - k));
  }
  if (g > 1) return H / (g - 1);
}
function deviation(n, t) {
  const g = variance(n, t);
  return g && Math.sqrt(g);
}
class Adder {
  constructor() {
    this._partials = new Float64Array(32), this._n = 0;
  }
  add(t) {
    const g = this._partials;
    let d = 0;
    for (let k = 0; k < this._n && k < 32; k++) {
      const H = g[k], AA = t + H, gA = Math.abs(t) < Math.abs(H) ? t - (AA - H) : H - (AA - t);
      gA && (g[d++] = gA), t = AA;
    }
    return g[d] = t, this._n = d + 1, this;
  }
  valueOf() {
    const t = this._partials;
    let g = this._n, d, k, H, AA = 0;
    if (g > 0) {
      for (AA = t[--g]; g > 0 && (d = AA, k = t[--g], AA = d + k, H = k - (AA - d), !H); )
        ;
      g > 0 && (H < 0 && t[g - 1] < 0 || H > 0 && t[g - 1] > 0) && (k = H * 2, d = AA + k, k == d - AA && (AA = d));
    }
    return AA;
  }
}
class InternMap extends Map {
  constructor(t, g = keyof) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: g } }), t != null) for (const [d, k] of t) this.set(d, k);
  }
  get(t) {
    return super.get(intern_get(this, t));
  }
  has(t) {
    return super.has(intern_get(this, t));
  }
  set(t, g) {
    return super.set(intern_set(this, t), g);
  }
  delete(t) {
    return super.delete(intern_delete(this, t));
  }
}
class InternSet extends Set {
  constructor(t, g = keyof) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: g } }), t != null) for (const d of t) this.add(d);
  }
  has(t) {
    return super.has(intern_get(this, t));
  }
  add(t) {
    return super.add(intern_set(this, t));
  }
  delete(t) {
    return super.delete(intern_delete(this, t));
  }
}
function intern_get({ _intern: n, _key: t }, g) {
  const d = t(g);
  return n.has(d) ? n.get(d) : g;
}
function intern_set({ _intern: n, _key: t }, g) {
  const d = t(g);
  return n.has(d) ? n.get(d) : (n.set(d, g), g);
}
function intern_delete({ _intern: n, _key: t }, g) {
  const d = t(g);
  return n.has(d) && (g = n.get(d), n.delete(d)), g;
}
function keyof(n) {
  return n !== null && typeof n == "object" ? n.valueOf() : n;
}
function permute(n, t) {
  return Array.from(t, (g) => n[g]);
}
function compareDefined(n = ascending$1) {
  if (n === ascending$1) return ascendingDefined;
  if (typeof n != "function") throw new TypeError("compare is not a function");
  return (t, g) => {
    const d = n(t, g);
    return d || d === 0 ? d : (n(g, g) === 0) - (n(t, t) === 0);
  };
}
function ascendingDefined(n, t) {
  return (n == null || !(n >= n)) - (t == null || !(t >= t)) || (n < t ? -1 : n > t ? 1 : 0);
}
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(n, t, g) {
  const d = (t - n) / Math.max(0, g), k = Math.floor(Math.log10(d)), H = d / Math.pow(10, k), AA = H >= e10 ? 10 : H >= e5 ? 5 : H >= e2 ? 2 : 1;
  let gA, IA, CA;
  return k < 0 ? (CA = Math.pow(10, -k) / AA, gA = Math.round(n * CA), IA = Math.round(t * CA), gA / CA < n && ++gA, IA / CA > t && --IA, CA = -CA) : (CA = Math.pow(10, k) * AA, gA = Math.round(n / CA), IA = Math.round(t / CA), gA * CA < n && ++gA, IA * CA > t && --IA), IA < gA && 0.5 <= g && g < 2 ? tickSpec(n, t, g * 2) : [gA, IA, CA];
}
function ticks(n, t, g) {
  if (t = +t, n = +n, g = +g, !(g > 0)) return [];
  if (n === t) return [n];
  const d = t < n, [k, H, AA] = d ? tickSpec(t, n, g) : tickSpec(n, t, g);
  if (!(H >= k)) return [];
  const gA = H - k + 1, IA = new Array(gA);
  if (d)
    if (AA < 0) for (let CA = 0; CA < gA; ++CA) IA[CA] = (H - CA) / -AA;
    else for (let CA = 0; CA < gA; ++CA) IA[CA] = (H - CA) * AA;
  else if (AA < 0) for (let CA = 0; CA < gA; ++CA) IA[CA] = (k + CA) / -AA;
  else for (let CA = 0; CA < gA; ++CA) IA[CA] = (k + CA) * AA;
  return IA;
}
function tickIncrement(n, t, g) {
  return t = +t, n = +n, g = +g, tickSpec(n, t, g)[2];
}
function tickStep(n, t, g) {
  t = +t, n = +n, g = +g;
  const d = t < n, k = d ? tickIncrement(t, n, g) : tickIncrement(n, t, g);
  return (d ? -1 : 1) * (k < 0 ? 1 / -k : k);
}
function max$2(n, t) {
  let g;
  if (t === void 0)
    for (const d of n)
      d != null && (g < d || g === void 0 && d >= d) && (g = d);
  else {
    let d = -1;
    for (let k of n)
      (k = t(k, ++d, n)) != null && (g < k || g === void 0 && k >= k) && (g = k);
  }
  return g;
}
function min$2(n, t) {
  let g;
  if (t === void 0)
    for (const d of n)
      d != null && (g > d || g === void 0 && d >= d) && (g = d);
  else {
    let d = -1;
    for (let k of n)
      (k = t(k, ++d, n)) != null && (g > k || g === void 0 && k >= k) && (g = k);
  }
  return g;
}
function quickselect(n, t, g = 0, d = 1 / 0, k) {
  if (t = Math.floor(t), g = Math.floor(Math.max(0, g)), d = Math.floor(Math.min(n.length - 1, d)), !(g <= t && t <= d)) return n;
  for (k = k === void 0 ? ascendingDefined : compareDefined(k); d > g; ) {
    if (d - g > 600) {
      const IA = d - g + 1, CA = t - g + 1, BA = Math.log(IA), eA = 0.5 * Math.exp(2 * BA / 3), iA = 0.5 * Math.sqrt(BA * eA * (IA - eA) / IA) * (CA - IA / 2 < 0 ? -1 : 1), QA = Math.max(g, Math.floor(t - CA * eA / IA + iA)), tA = Math.min(d, Math.floor(t + (IA - CA) * eA / IA + iA));
      quickselect(n, t, QA, tA, k);
    }
    const H = n[t];
    let AA = g, gA = d;
    for (swap$1(n, g, t), k(n[d], H) > 0 && swap$1(n, g, d); AA < gA; ) {
      for (swap$1(n, AA, gA), ++AA, --gA; k(n[AA], H) < 0; ) ++AA;
      for (; k(n[gA], H) > 0; ) --gA;
    }
    k(n[g], H) === 0 ? swap$1(n, g, gA) : (++gA, swap$1(n, gA, d)), gA <= t && (g = gA + 1), t <= gA && (d = gA - 1);
  }
  return n;
}
function swap$1(n, t, g) {
  const d = n[t];
  n[t] = n[g], n[g] = d;
}
function quantile$1(n, t, g) {
  if (n = Float64Array.from(numbers$2(n, g)), !(!(d = n.length) || isNaN(t = +t))) {
    if (t <= 0 || d < 2) return min$2(n);
    if (t >= 1) return max$2(n);
    var d, k = (d - 1) * t, H = Math.floor(k), AA = max$2(quickselect(n, H).subarray(0, H + 1)), gA = min$2(n.subarray(H + 1));
    return AA + (gA - AA) * (k - H);
  }
}
function quantileSorted(n, t, g = number$6) {
  if (!(!(d = n.length) || isNaN(t = +t))) {
    if (t <= 0 || d < 2) return +g(n[0], 0, n);
    if (t >= 1) return +g(n[d - 1], d - 1, n);
    var d, k = (d - 1) * t, H = Math.floor(k), AA = +g(n[H], H, n), gA = +g(n[H + 1], H + 1, n);
    return AA + (gA - AA) * (k - H);
  }
}
function mean(n, t) {
  let g = 0, d = 0;
  if (t === void 0)
    for (let k of n)
      k != null && (k = +k) >= k && (++g, d += k);
  else {
    let k = -1;
    for (let H of n)
      (H = t(H, ++k, n)) != null && (H = +H) >= H && (++g, d += H);
  }
  if (g) return d / g;
}
function median(n, t) {
  return quantile$1(n, 0.5, t);
}
function* flatten(n) {
  for (const t of n)
    yield* t;
}
function merge$4(n) {
  return Array.from(flatten(n));
}
function range$5(n, t, g) {
  n = +n, t = +t, g = (k = arguments.length) < 2 ? (t = n, n = 0, 1) : k < 3 ? 1 : +g;
  for (var d = -1, k = Math.max(0, Math.ceil((t - n) / g)) | 0, H = new Array(k); ++d < k; )
    H[d] = n + d * g;
  return H;
}
function sum$1(n, t) {
  let g = 0;
  for (let d of n)
    (d = +d) && (g += d);
  return g;
}
function intersection(n, ...t) {
  n = new InternSet(n), t = t.map(set$5);
  A: for (const g of n)
    for (const d of t)
      if (!d.has(g)) {
        n.delete(g);
        continue A;
      }
  return n;
}
function set$5(n) {
  return n instanceof InternSet ? n : new InternSet(n);
}
function union(...n) {
  const t = new InternSet();
  for (const g of n)
    for (const d of g)
      t.add(d);
  return t;
}
function formatDecimal(n) {
  return Math.abs(n = Math.round(n)) >= 1e21 ? n.toLocaleString("en").replace(/,/g, "") : n.toString(10);
}
function formatDecimalParts(n, t) {
  if ((g = (n = t ? n.toExponential(t - 1) : n.toExponential()).indexOf("e")) < 0) return null;
  var g, d = n.slice(0, g);
  return [
    d.length > 1 ? d[0] + d.slice(2) : d,
    +n.slice(g + 1)
  ];
}
function exponent(n) {
  return n = formatDecimalParts(Math.abs(n)), n ? n[1] : NaN;
}
function formatGroup(n, t) {
  return function(g, d) {
    for (var k = g.length, H = [], AA = 0, gA = n[0], IA = 0; k > 0 && gA > 0 && (IA + gA + 1 > d && (gA = Math.max(1, d - IA)), H.push(g.substring(k -= gA, k + gA)), !((IA += gA + 1) > d)); )
      gA = n[AA = (AA + 1) % n.length];
    return H.reverse().join(t);
  };
}
function formatNumerals(n) {
  return function(t) {
    return t.replace(/[0-9]/g, function(g) {
      return n[+g];
    });
  };
}
var re$1 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(n) {
  if (!(t = re$1.exec(n))) throw new Error("invalid format: " + n);
  var t;
  return new FormatSpecifier({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(n) {
  this.fill = n.fill === void 0 ? " " : n.fill + "", this.align = n.align === void 0 ? ">" : n.align + "", this.sign = n.sign === void 0 ? "-" : n.sign + "", this.symbol = n.symbol === void 0 ? "" : n.symbol + "", this.zero = !!n.zero, this.width = n.width === void 0 ? void 0 : +n.width, this.comma = !!n.comma, this.precision = n.precision === void 0 ? void 0 : +n.precision, this.trim = !!n.trim, this.type = n.type === void 0 ? "" : n.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(n) {
  A: for (var t = n.length, g = 1, d = -1, k; g < t; ++g)
    switch (n[g]) {
      case ".":
        d = k = g;
        break;
      case "0":
        d === 0 && (d = g), k = g;
        break;
      default:
        if (!+n[g]) break A;
        d > 0 && (d = 0);
        break;
    }
  return d > 0 ? n.slice(0, d) + n.slice(k + 1) : n;
}
var prefixExponent;
function formatPrefixAuto(n, t) {
  var g = formatDecimalParts(n, t);
  if (!g) return n + "";
  var d = g[0], k = g[1], H = k - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(k / 3))) * 3) + 1, AA = d.length;
  return H === AA ? d : H > AA ? d + new Array(H - AA + 1).join("0") : H > 0 ? d.slice(0, H) + "." + d.slice(H) : "0." + new Array(1 - H).join("0") + formatDecimalParts(n, Math.max(0, t + H - 1))[0];
}
function formatRounded(n, t) {
  var g = formatDecimalParts(n, t);
  if (!g) return n + "";
  var d = g[0], k = g[1];
  return k < 0 ? "0." + new Array(-k).join("0") + d : d.length > k + 1 ? d.slice(0, k + 1) + "." + d.slice(k + 1) : d + new Array(k - d.length + 2).join("0");
}
const formatTypes = {
  "%": (n, t) => (n * 100).toFixed(t),
  b: (n) => Math.round(n).toString(2),
  c: (n) => n + "",
  d: formatDecimal,
  e: (n, t) => n.toExponential(t),
  f: (n, t) => n.toFixed(t),
  g: (n, t) => n.toPrecision(t),
  o: (n) => Math.round(n).toString(8),
  p: (n, t) => formatRounded(n * 100, t),
  r: formatRounded,
  s: formatPrefixAuto,
  X: (n) => Math.round(n).toString(16).toUpperCase(),
  x: (n) => Math.round(n).toString(16)
};
function identity$6(n) {
  return n;
}
var map$2 = Array.prototype.map, prefixes$6 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$1(n) {
  var t = n.grouping === void 0 || n.thousands === void 0 ? identity$6 : formatGroup(map$2.call(n.grouping, Number), n.thousands + ""), g = n.currency === void 0 ? "" : n.currency[0] + "", d = n.currency === void 0 ? "" : n.currency[1] + "", k = n.decimal === void 0 ? "." : n.decimal + "", H = n.numerals === void 0 ? identity$6 : formatNumerals(map$2.call(n.numerals, String)), AA = n.percent === void 0 ? "%" : n.percent + "", gA = n.minus === void 0 ? "−" : n.minus + "", IA = n.nan === void 0 ? "NaN" : n.nan + "";
  function CA(eA) {
    eA = formatSpecifier(eA);
    var iA = eA.fill, QA = eA.align, tA = eA.sign, oA = eA.symbol, EA = eA.zero, aA = eA.width, nA = eA.comma, lA = eA.precision, cA = eA.trim, sA = eA.type;
    sA === "n" ? (nA = !0, sA = "g") : formatTypes[sA] || (lA === void 0 && (lA = 12), cA = !0, sA = "g"), (EA || iA === "0" && QA === "=") && (EA = !0, iA = "0", QA = "=");
    var rA = oA === "$" ? g : oA === "#" && /[boxX]/.test(sA) ? "0" + sA.toLowerCase() : "", uA = oA === "$" ? d : /[%p]/.test(sA) ? AA : "", hA = formatTypes[sA], dA = /[defgprs%]/.test(sA);
    lA = lA === void 0 ? 6 : /[gprs]/.test(sA) ? Math.max(1, Math.min(21, lA)) : Math.max(0, Math.min(20, lA));
    function GA(DA) {
      var wA = rA, bA = uA, yA, pA, MA;
      if (sA === "c")
        bA = hA(DA) + bA, DA = "";
      else {
        DA = +DA;
        var LA = DA < 0 || 1 / DA < 0;
        if (DA = isNaN(DA) ? IA : hA(Math.abs(DA), lA), cA && (DA = formatTrim(DA)), LA && +DA == 0 && tA !== "+" && (LA = !1), wA = (LA ? tA === "(" ? tA : gA : tA === "-" || tA === "(" ? "" : tA) + wA, bA = (sA === "s" ? prefixes$6[8 + prefixExponent / 3] : "") + bA + (LA && tA === "(" ? ")" : ""), dA) {
          for (yA = -1, pA = DA.length; ++yA < pA; )
            if (MA = DA.charCodeAt(yA), 48 > MA || MA > 57) {
              bA = (MA === 46 ? k + DA.slice(yA + 1) : DA.slice(yA)) + bA, DA = DA.slice(0, yA);
              break;
            }
        }
      }
      nA && !EA && (DA = t(DA, 1 / 0));
      var xA = wA.length + DA.length + bA.length, TA = xA < aA ? new Array(aA - xA + 1).join(iA) : "";
      switch (nA && EA && (DA = t(TA + DA, TA.length ? aA - bA.length : 1 / 0), TA = ""), QA) {
        case "<":
          DA = wA + DA + bA + TA;
          break;
        case "=":
          DA = wA + TA + DA + bA;
          break;
        case "^":
          DA = TA.slice(0, xA = TA.length >> 1) + wA + DA + bA + TA.slice(xA);
          break;
        default:
          DA = TA + wA + DA + bA;
          break;
      }
      return H(DA);
    }
    return GA.toString = function() {
      return eA + "";
    }, GA;
  }
  function BA(eA, iA) {
    var QA = CA((eA = formatSpecifier(eA), eA.type = "f", eA)), tA = Math.max(-8, Math.min(8, Math.floor(exponent(iA) / 3))) * 3, oA = Math.pow(10, -tA), EA = prefixes$6[8 + tA / 3];
    return function(aA) {
      return QA(oA * aA) + EA;
    };
  }
  return {
    format: CA,
    formatPrefix: BA
  };
}
var locale$2, format$3, formatPrefix;
defaultLocale$2({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$2(n) {
  return locale$2 = formatLocale$1(n), format$3 = locale$2.format, formatPrefix = locale$2.formatPrefix, locale$2;
}
function precisionFixed(n) {
  return Math.max(0, -exponent(Math.abs(n)));
}
function precisionPrefix(n, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(t) / 3))) * 3 - exponent(Math.abs(n)));
}
function precisionRound(n, t) {
  return n = Math.abs(n), t = Math.abs(t) - n, Math.max(0, exponent(t) - exponent(n)) + 1;
}
const t0$2 = /* @__PURE__ */ new Date(), t1$1 = /* @__PURE__ */ new Date();
function timeInterval$1(n, t, g, d) {
  function k(H) {
    return n(H = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+H)), H;
  }
  return k.floor = (H) => (n(H = /* @__PURE__ */ new Date(+H)), H), k.ceil = (H) => (n(H = new Date(H - 1)), t(H, 1), n(H), H), k.round = (H) => {
    const AA = k(H), gA = k.ceil(H);
    return H - AA < gA - H ? AA : gA;
  }, k.offset = (H, AA) => (t(H = /* @__PURE__ */ new Date(+H), AA == null ? 1 : Math.floor(AA)), H), k.range = (H, AA, gA) => {
    const IA = [];
    if (H = k.ceil(H), gA = gA == null ? 1 : Math.floor(gA), !(H < AA) || !(gA > 0)) return IA;
    let CA;
    do
      IA.push(CA = /* @__PURE__ */ new Date(+H)), t(H, gA), n(H);
    while (CA < H && H < AA);
    return IA;
  }, k.filter = (H) => timeInterval$1((AA) => {
    if (AA >= AA) for (; n(AA), !H(AA); ) AA.setTime(AA - 1);
  }, (AA, gA) => {
    if (AA >= AA)
      if (gA < 0) for (; ++gA <= 0; )
        for (; t(AA, -1), !H(AA); )
          ;
      else for (; --gA >= 0; )
        for (; t(AA, 1), !H(AA); )
          ;
  }), g && (k.count = (H, AA) => (t0$2.setTime(+H), t1$1.setTime(+AA), n(t0$2), n(t1$1), Math.floor(g(t0$2, t1$1))), k.every = (H) => (H = Math.floor(H), !isFinite(H) || !(H > 0) ? null : H > 1 ? k.filter(d ? (AA) => d(AA) % H === 0 : (AA) => k.count(0, AA) % H === 0) : k)), k;
}
const millisecond = timeInterval$1(() => {
}, (n, t) => {
  n.setTime(+n + t);
}, (n, t) => t - n);
millisecond.every = (n) => (n = Math.floor(n), !isFinite(n) || !(n > 0) ? null : n > 1 ? timeInterval$1((t) => {
  t.setTime(Math.floor(t / n) * n);
}, (t, g) => {
  t.setTime(+t + g * n);
}, (t, g) => (g - t) / n) : millisecond);
millisecond.range;
const durationSecond$1 = 1e3, durationMinute$1 = durationSecond$1 * 60, durationHour$1 = durationMinute$1 * 60, durationDay$1 = durationHour$1 * 24, durationWeek$1 = durationDay$1 * 7, durationMonth$1 = durationDay$1 * 30, durationYear$1 = durationDay$1 * 365, second = timeInterval$1((n) => {
  n.setTime(n - n.getMilliseconds());
}, (n, t) => {
  n.setTime(+n + t * durationSecond$1);
}, (n, t) => (t - n) / durationSecond$1, (n) => n.getUTCSeconds());
second.range;
const timeMinute = timeInterval$1((n) => {
  n.setTime(n - n.getMilliseconds() - n.getSeconds() * durationSecond$1);
}, (n, t) => {
  n.setTime(+n + t * durationMinute$1);
}, (n, t) => (t - n) / durationMinute$1, (n) => n.getMinutes());
timeMinute.range;
const utcMinute = timeInterval$1((n) => {
  n.setUTCSeconds(0, 0);
}, (n, t) => {
  n.setTime(+n + t * durationMinute$1);
}, (n, t) => (t - n) / durationMinute$1, (n) => n.getUTCMinutes());
utcMinute.range;
const timeHour = timeInterval$1((n) => {
  n.setTime(n - n.getMilliseconds() - n.getSeconds() * durationSecond$1 - n.getMinutes() * durationMinute$1);
}, (n, t) => {
  n.setTime(+n + t * durationHour$1);
}, (n, t) => (t - n) / durationHour$1, (n) => n.getHours());
timeHour.range;
const utcHour = timeInterval$1((n) => {
  n.setUTCMinutes(0, 0, 0);
}, (n, t) => {
  n.setTime(+n + t * durationHour$1);
}, (n, t) => (t - n) / durationHour$1, (n) => n.getUTCHours());
utcHour.range;
const timeDay = timeInterval$1(
  (n) => n.setHours(0, 0, 0, 0),
  (n, t) => n.setDate(n.getDate() + t),
  (n, t) => (t - n - (t.getTimezoneOffset() - n.getTimezoneOffset()) * durationMinute$1) / durationDay$1,
  (n) => n.getDate() - 1
);
timeDay.range;
const utcDay = timeInterval$1((n) => {
  n.setUTCHours(0, 0, 0, 0);
}, (n, t) => {
  n.setUTCDate(n.getUTCDate() + t);
}, (n, t) => (t - n) / durationDay$1, (n) => n.getUTCDate() - 1);
utcDay.range;
const unixDay = timeInterval$1((n) => {
  n.setUTCHours(0, 0, 0, 0);
}, (n, t) => {
  n.setUTCDate(n.getUTCDate() + t);
}, (n, t) => (t - n) / durationDay$1, (n) => Math.floor(n / durationDay$1));
unixDay.range;
function timeWeekday(n) {
  return timeInterval$1((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - n) % 7), t.setHours(0, 0, 0, 0);
  }, (t, g) => {
    t.setDate(t.getDate() + g * 7);
  }, (t, g) => (g - t - (g.getTimezoneOffset() - t.getTimezoneOffset()) * durationMinute$1) / durationWeek$1);
}
const timeSunday = timeWeekday(0), timeMonday = timeWeekday(1), timeTuesday = timeWeekday(2), timeWednesday = timeWeekday(3), timeThursday = timeWeekday(4), timeFriday = timeWeekday(5), timeSaturday = timeWeekday(6);
timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;
function utcWeekday(n) {
  return timeInterval$1((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - n) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, g) => {
    t.setUTCDate(t.getUTCDate() + g * 7);
  }, (t, g) => (g - t) / durationWeek$1);
}
const utcSunday = utcWeekday(0), utcMonday = utcWeekday(1), utcTuesday = utcWeekday(2), utcWednesday = utcWeekday(3), utcThursday = utcWeekday(4), utcFriday = utcWeekday(5), utcSaturday = utcWeekday(6);
utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;
const timeMonth = timeInterval$1((n) => {
  n.setDate(1), n.setHours(0, 0, 0, 0);
}, (n, t) => {
  n.setMonth(n.getMonth() + t);
}, (n, t) => t.getMonth() - n.getMonth() + (t.getFullYear() - n.getFullYear()) * 12, (n) => n.getMonth());
timeMonth.range;
const utcMonth = timeInterval$1((n) => {
  n.setUTCDate(1), n.setUTCHours(0, 0, 0, 0);
}, (n, t) => {
  n.setUTCMonth(n.getUTCMonth() + t);
}, (n, t) => t.getUTCMonth() - n.getUTCMonth() + (t.getUTCFullYear() - n.getUTCFullYear()) * 12, (n) => n.getUTCMonth());
utcMonth.range;
const timeYear = timeInterval$1((n) => {
  n.setMonth(0, 1), n.setHours(0, 0, 0, 0);
}, (n, t) => {
  n.setFullYear(n.getFullYear() + t);
}, (n, t) => t.getFullYear() - n.getFullYear(), (n) => n.getFullYear());
timeYear.every = (n) => !isFinite(n = Math.floor(n)) || !(n > 0) ? null : timeInterval$1((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / n) * n), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, g) => {
  t.setFullYear(t.getFullYear() + g * n);
});
timeYear.range;
const utcYear = timeInterval$1((n) => {
  n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
}, (n, t) => {
  n.setUTCFullYear(n.getUTCFullYear() + t);
}, (n, t) => t.getUTCFullYear() - n.getUTCFullYear(), (n) => n.getUTCFullYear());
utcYear.every = (n) => !isFinite(n = Math.floor(n)) || !(n > 0) ? null : timeInterval$1((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / n) * n), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, g) => {
  t.setUTCFullYear(t.getUTCFullYear() + g * n);
});
utcYear.range;
function ticker(n, t, g, d, k, H) {
  const AA = [
    [second, 1, durationSecond$1],
    [second, 5, 5 * durationSecond$1],
    [second, 15, 15 * durationSecond$1],
    [second, 30, 30 * durationSecond$1],
    [H, 1, durationMinute$1],
    [H, 5, 5 * durationMinute$1],
    [H, 15, 15 * durationMinute$1],
    [H, 30, 30 * durationMinute$1],
    [k, 1, durationHour$1],
    [k, 3, 3 * durationHour$1],
    [k, 6, 6 * durationHour$1],
    [k, 12, 12 * durationHour$1],
    [d, 1, durationDay$1],
    [d, 2, 2 * durationDay$1],
    [g, 1, durationWeek$1],
    [t, 1, durationMonth$1],
    [t, 3, 3 * durationMonth$1],
    [n, 1, durationYear$1]
  ];
  function gA(CA, BA, eA) {
    const iA = BA < CA;
    iA && ([CA, BA] = [BA, CA]);
    const QA = eA && typeof eA.range == "function" ? eA : IA(CA, BA, eA), tA = QA ? QA.range(CA, +BA + 1) : [];
    return iA ? tA.reverse() : tA;
  }
  function IA(CA, BA, eA) {
    const iA = Math.abs(BA - CA) / eA, QA = bisector(([, , EA]) => EA).right(AA, iA);
    if (QA === AA.length) return n.every(tickStep(CA / durationYear$1, BA / durationYear$1, eA));
    if (QA === 0) return millisecond.every(Math.max(tickStep(CA, BA, eA), 1));
    const [tA, oA] = AA[iA / AA[QA - 1][2] < AA[QA][2] / iA ? QA - 1 : QA];
    return tA.every(oA);
  }
  return [gA, IA];
}
const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute), [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute), YEAR = "year", QUARTER = "quarter", MONTH = "month", WEEK = "week", DATE = "date", DAY = "day", DAYOFYEAR = "dayofyear", HOURS = "hours", MINUTES = "minutes", SECONDS = "seconds", MILLISECONDS = "milliseconds", TIME_UNITS = [YEAR, QUARTER, MONTH, WEEK, DATE, DAY, DAYOFYEAR, HOURS, MINUTES, SECONDS, MILLISECONDS], UNITS = TIME_UNITS.reduce((n, t, g) => (n[t] = 1 + g, n), {});
function timeUnits(n) {
  const t = array$6(n).slice(), g = {};
  return t.length || error$3("Missing time unit."), t.forEach((k) => {
    has$2(UNITS, k) ? g[k] = 1 : error$3(`Invalid time unit: ${k}.`);
  }), (g[WEEK] || g[DAY] ? 1 : 0) + (g[QUARTER] || g[MONTH] || g[DATE] ? 1 : 0) + (g[DAYOFYEAR] ? 1 : 0) > 1 && error$3(`Incompatible time units: ${n}`), t.sort((k, H) => UNITS[k] - UNITS[H]), t;
}
const defaultSpecifiers = {
  [YEAR]: "%Y ",
  [QUARTER]: "Q%q ",
  [MONTH]: "%b ",
  [DATE]: "%d ",
  [WEEK]: "W%U ",
  [DAY]: "%a ",
  [DAYOFYEAR]: "%j ",
  [HOURS]: "%H:00",
  [MINUTES]: "00:%M",
  [SECONDS]: ":%S",
  [MILLISECONDS]: ".%L",
  [`${YEAR}-${MONTH}`]: "%Y-%m ",
  [`${YEAR}-${MONTH}-${DATE}`]: "%Y-%m-%d ",
  [`${HOURS}-${MINUTES}`]: "%H:%M"
};
function timeUnitSpecifier(n, t) {
  const g = extend$2({}, defaultSpecifiers, t), d = timeUnits(n), k = d.length;
  let H = "", AA = 0, gA, IA;
  for (AA = 0; AA < k; )
    for (gA = d.length; gA > AA; --gA)
      if (IA = d.slice(AA, gA).join("-"), g[IA] != null) {
        H += g[IA], AA = gA;
        break;
      }
  return H.trim();
}
const t0$1 = /* @__PURE__ */ new Date();
function localYear(n) {
  return t0$1.setFullYear(n), t0$1.setMonth(0), t0$1.setDate(1), t0$1.setHours(0, 0, 0, 0), t0$1;
}
function dayofyear(n) {
  return localDayOfYear(new Date(n));
}
function week(n) {
  return localWeekNum(new Date(n));
}
function localDayOfYear(n) {
  return timeDay.count(localYear(n.getFullYear()) - 1, n);
}
function localWeekNum(n) {
  return timeSunday.count(localYear(n.getFullYear()) - 1, n);
}
function localFirst(n) {
  return localYear(n).getDay();
}
function localDate$1(n, t, g, d, k, H, AA) {
  if (0 <= n && n < 100) {
    const gA = new Date(-1, t, g, d, k, H, AA);
    return gA.setFullYear(n), gA;
  }
  return new Date(n, t, g, d, k, H, AA);
}
function utcdayofyear(n) {
  return utcDayOfYear(new Date(n));
}
function utcweek(n) {
  return utcWeekNum(new Date(n));
}
function utcDayOfYear(n) {
  const t = Date.UTC(n.getUTCFullYear(), 0, 1);
  return utcDay.count(t - 1, n);
}
function utcWeekNum(n) {
  const t = Date.UTC(n.getUTCFullYear(), 0, 1);
  return utcSunday.count(t - 1, n);
}
function utcFirst(n) {
  return t0$1.setTime(Date.UTC(n, 0, 1)), t0$1.getUTCDay();
}
function utcDate$1(n, t, g, d, k, H, AA) {
  if (0 <= n && n < 100) {
    const gA = new Date(Date.UTC(-1, t, g, d, k, H, AA));
    return gA.setUTCFullYear(g.y), gA;
  }
  return new Date(Date.UTC(n, t, g, d, k, H, AA));
}
function floor(n, t, g, d, k) {
  const H = t || 1, AA = peek$2(n), gA = (aA, nA, lA) => (lA = lA || aA, getUnit(g[lA], d[lA], aA === AA && H, nA)), IA = /* @__PURE__ */ new Date(), CA = toSet(n), BA = CA[YEAR] ? gA(YEAR) : constant$6(2012), eA = CA[MONTH] ? gA(MONTH) : CA[QUARTER] ? gA(QUARTER) : zero$4, iA = CA[WEEK] && CA[DAY] ? gA(DAY, 1, WEEK + DAY) : CA[WEEK] ? gA(WEEK, 1) : CA[DAY] ? gA(DAY, 1) : CA[DATE] ? gA(DATE, 1) : CA[DAYOFYEAR] ? gA(DAYOFYEAR, 1) : one$2, QA = CA[HOURS] ? gA(HOURS) : zero$4, tA = CA[MINUTES] ? gA(MINUTES) : zero$4, oA = CA[SECONDS] ? gA(SECONDS) : zero$4, EA = CA[MILLISECONDS] ? gA(MILLISECONDS) : zero$4;
  return function(aA) {
    IA.setTime(+aA);
    const nA = BA(IA);
    return k(nA, eA(IA), iA(IA, nA), QA(IA), tA(IA), oA(IA), EA(IA));
  };
}
function getUnit(n, t, g, d) {
  const k = g <= 1 ? n : d ? (H, AA) => d + g * Math.floor((n(H, AA) - d) / g) : (H, AA) => g * Math.floor(n(H, AA) / g);
  return t ? (H, AA) => t(k(H, AA), AA) : k;
}
function weekday(n, t, g) {
  return t + n * 7 - (g + 6) % 7;
}
const localGet = {
  [YEAR]: (n) => n.getFullYear(),
  [QUARTER]: (n) => Math.floor(n.getMonth() / 3),
  [MONTH]: (n) => n.getMonth(),
  [DATE]: (n) => n.getDate(),
  [HOURS]: (n) => n.getHours(),
  [MINUTES]: (n) => n.getMinutes(),
  [SECONDS]: (n) => n.getSeconds(),
  [MILLISECONDS]: (n) => n.getMilliseconds(),
  [DAYOFYEAR]: (n) => localDayOfYear(n),
  [WEEK]: (n) => localWeekNum(n),
  [WEEK + DAY]: (n, t) => weekday(localWeekNum(n), n.getDay(), localFirst(t)),
  [DAY]: (n, t) => weekday(1, n.getDay(), localFirst(t))
}, localInv = {
  [QUARTER]: (n) => 3 * n,
  [WEEK]: (n, t) => weekday(n, 0, localFirst(t))
};
function timeFloor(n, t) {
  return floor(n, t || 1, localGet, localInv, localDate$1);
}
const utcGet = {
  [YEAR]: (n) => n.getUTCFullYear(),
  [QUARTER]: (n) => Math.floor(n.getUTCMonth() / 3),
  [MONTH]: (n) => n.getUTCMonth(),
  [DATE]: (n) => n.getUTCDate(),
  [HOURS]: (n) => n.getUTCHours(),
  [MINUTES]: (n) => n.getUTCMinutes(),
  [SECONDS]: (n) => n.getUTCSeconds(),
  [MILLISECONDS]: (n) => n.getUTCMilliseconds(),
  [DAYOFYEAR]: (n) => utcDayOfYear(n),
  [WEEK]: (n) => utcWeekNum(n),
  [DAY]: (n, t) => weekday(1, n.getUTCDay(), utcFirst(t)),
  [WEEK + DAY]: (n, t) => weekday(utcWeekNum(n), n.getUTCDay(), utcFirst(t))
}, utcInv = {
  [QUARTER]: (n) => 3 * n,
  [WEEK]: (n, t) => weekday(n, 0, utcFirst(t))
};
function utcFloor(n, t) {
  return floor(n, t || 1, utcGet, utcInv, utcDate$1);
}
const timeIntervals = {
  [YEAR]: timeYear,
  [QUARTER]: timeMonth.every(3),
  [MONTH]: timeMonth,
  [WEEK]: timeSunday,
  [DATE]: timeDay,
  [DAY]: timeDay,
  [DAYOFYEAR]: timeDay,
  [HOURS]: timeHour,
  [MINUTES]: timeMinute,
  [SECONDS]: second,
  [MILLISECONDS]: millisecond
}, utcIntervals = {
  [YEAR]: utcYear,
  [QUARTER]: utcMonth.every(3),
  [MONTH]: utcMonth,
  [WEEK]: utcSunday,
  [DATE]: utcDay,
  [DAY]: utcDay,
  [DAYOFYEAR]: utcDay,
  [HOURS]: utcHour,
  [MINUTES]: utcMinute,
  [SECONDS]: second,
  [MILLISECONDS]: millisecond
};
function timeInterval(n) {
  return timeIntervals[n];
}
function utcInterval(n) {
  return utcIntervals[n];
}
function offset$3(n, t, g) {
  return n ? n.offset(t, g) : void 0;
}
function timeOffset(n, t, g) {
  return offset$3(timeInterval(n), t, g);
}
function utcOffset(n, t, g) {
  return offset$3(utcInterval(n), t, g);
}
function sequence$1(n, t, g, d) {
  return n ? n.range(t, g, d) : void 0;
}
function timeSequence(n, t, g, d) {
  return sequence$1(timeInterval(n), t, g, d);
}
function utcSequence(n, t, g, d) {
  return sequence$1(utcInterval(n), t, g, d);
}
const durationSecond = 1e3, durationMinute = durationSecond * 60, durationHour = durationMinute * 60, durationDay = durationHour * 24, durationWeek = durationDay * 7, durationMonth = durationDay * 30, durationYear = durationDay * 365, Milli = [YEAR, MONTH, DATE, HOURS, MINUTES, SECONDS, MILLISECONDS], Seconds = Milli.slice(0, -1), Minutes = Seconds.slice(0, -1), Hours = Minutes.slice(0, -1), Day = Hours.slice(0, -1), Week = [YEAR, WEEK], Month = [YEAR, MONTH], Year = [YEAR], intervals = [[Seconds, 1, durationSecond], [Seconds, 5, 5 * durationSecond], [Seconds, 15, 15 * durationSecond], [Seconds, 30, 30 * durationSecond], [Minutes, 1, durationMinute], [Minutes, 5, 5 * durationMinute], [Minutes, 15, 15 * durationMinute], [Minutes, 30, 30 * durationMinute], [Hours, 1, durationHour], [Hours, 3, 3 * durationHour], [Hours, 6, 6 * durationHour], [Hours, 12, 12 * durationHour], [Day, 1, durationDay], [Week, 1, durationWeek], [Month, 1, durationMonth], [Month, 3, 3 * durationMonth], [Year, 1, durationYear]];
function bin$1(n) {
  const t = n.extent, g = n.maxbins || 40, d = Math.abs(span(t)) / g;
  let k = bisector((gA) => gA[2]).right(intervals, d), H, AA;
  return k === intervals.length ? (H = Year, AA = tickStep(t[0] / durationYear, t[1] / durationYear, g)) : k ? (k = intervals[d / intervals[k - 1][2] < intervals[k][2] / d ? k - 1 : k], H = k[0], AA = k[1]) : (H = Milli, AA = Math.max(tickStep(t[0], t[1], g), 1)), {
    units: H,
    step: AA
  };
}
function localDate(n) {
  if (0 <= n.y && n.y < 100) {
    var t = new Date(-1, n.m, n.d, n.H, n.M, n.S, n.L);
    return t.setFullYear(n.y), t;
  }
  return new Date(n.y, n.m, n.d, n.H, n.M, n.S, n.L);
}
function utcDate(n) {
  if (0 <= n.y && n.y < 100) {
    var t = new Date(Date.UTC(-1, n.m, n.d, n.H, n.M, n.S, n.L));
    return t.setUTCFullYear(n.y), t;
  }
  return new Date(Date.UTC(n.y, n.m, n.d, n.H, n.M, n.S, n.L));
}
function newDate(n, t, g) {
  return { y: n, m: t, d: g, H: 0, M: 0, S: 0, L: 0 };
}
function formatLocale(n) {
  var t = n.dateTime, g = n.date, d = n.time, k = n.periods, H = n.days, AA = n.shortDays, gA = n.months, IA = n.shortMonths, CA = formatRe(k), BA = formatLookup(k), eA = formatRe(H), iA = formatLookup(H), QA = formatRe(AA), tA = formatLookup(AA), oA = formatRe(gA), EA = formatLookup(gA), aA = formatRe(IA), nA = formatLookup(IA), lA = {
    a: LA,
    A: xA,
    b: TA,
    B: NA,
    c: null,
    d: formatDayOfMonth,
    e: formatDayOfMonth,
    f: formatMicroseconds,
    g: formatYearISO,
    G: formatFullYearISO,
    H: formatHour24,
    I: formatHour12,
    j: formatDayOfYear,
    L: formatMilliseconds,
    m: formatMonthNumber,
    M: formatMinutes,
    p: zA,
    q: XA,
    Q: formatUnixTimestamp,
    s: formatUnixTimestampSeconds,
    S: formatSeconds,
    u: formatWeekdayNumberMonday,
    U: formatWeekNumberSunday,
    V: formatWeekNumberISO,
    w: formatWeekdayNumberSunday,
    W: formatWeekNumberMonday,
    x: null,
    X: null,
    y: formatYear,
    Y: formatFullYear,
    Z: formatZone,
    "%": formatLiteralPercent
  }, cA = {
    a: fA,
    A: vA,
    b: Cg,
    B: Ig,
    c: null,
    d: formatUTCDayOfMonth,
    e: formatUTCDayOfMonth,
    f: formatUTCMicroseconds,
    g: formatUTCYearISO,
    G: formatUTCFullYearISO,
    H: formatUTCHour24,
    I: formatUTCHour12,
    j: formatUTCDayOfYear,
    L: formatUTCMilliseconds,
    m: formatUTCMonthNumber,
    M: formatUTCMinutes,
    p: gg,
    q: og,
    Q: formatUnixTimestamp,
    s: formatUnixTimestampSeconds,
    S: formatUTCSeconds,
    u: formatUTCWeekdayNumberMonday,
    U: formatUTCWeekNumberSunday,
    V: formatUTCWeekNumberISO,
    w: formatUTCWeekdayNumberSunday,
    W: formatUTCWeekNumberMonday,
    x: null,
    X: null,
    y: formatUTCYear,
    Y: formatUTCFullYear,
    Z: formatUTCZone,
    "%": formatLiteralPercent
  }, sA = {
    a: GA,
    A: DA,
    b: wA,
    B: bA,
    c: yA,
    d: parseDayOfMonth,
    e: parseDayOfMonth,
    f: parseMicroseconds,
    g: parseYear,
    G: parseFullYear,
    H: parseHour24,
    I: parseHour24,
    j: parseDayOfYear,
    L: parseMilliseconds,
    m: parseMonthNumber,
    M: parseMinutes,
    p: dA,
    q: parseQuarter,
    Q: parseUnixTimestamp,
    s: parseUnixTimestampSeconds,
    S: parseSeconds,
    u: parseWeekdayNumberMonday,
    U: parseWeekNumberSunday,
    V: parseWeekNumberISO,
    w: parseWeekdayNumberSunday,
    W: parseWeekNumberMonday,
    x: pA,
    X: MA,
    y: parseYear,
    Y: parseFullYear,
    Z: parseZone,
    "%": parseLiteralPercent
  };
  lA.x = rA(g, lA), lA.X = rA(d, lA), lA.c = rA(t, lA), cA.x = rA(g, cA), cA.X = rA(d, cA), cA.c = rA(t, cA);
  function rA(eg, kA) {
    return function(YA) {
      var RA = [], FA = -1, mA = 0, JA = eg.length, VA, HA, jA;
      for (YA instanceof Date || (YA = /* @__PURE__ */ new Date(+YA)); ++FA < JA; )
        eg.charCodeAt(FA) === 37 && (RA.push(eg.slice(mA, FA)), (HA = pads[VA = eg.charAt(++FA)]) != null ? VA = eg.charAt(++FA) : HA = VA === "e" ? " " : "0", (jA = kA[VA]) && (VA = jA(YA, HA)), RA.push(VA), mA = FA + 1);
      return RA.push(eg.slice(mA, FA)), RA.join("");
    };
  }
  function uA(eg, kA) {
    return function(YA) {
      var RA = newDate(1900, void 0, 1), FA = hA(RA, eg, YA += "", 0), mA, JA;
      if (FA != YA.length) return null;
      if ("Q" in RA) return new Date(RA.Q);
      if ("s" in RA) return new Date(RA.s * 1e3 + ("L" in RA ? RA.L : 0));
      if (kA && !("Z" in RA) && (RA.Z = 0), "p" in RA && (RA.H = RA.H % 12 + RA.p * 12), RA.m === void 0 && (RA.m = "q" in RA ? RA.q : 0), "V" in RA) {
        if (RA.V < 1 || RA.V > 53) return null;
        "w" in RA || (RA.w = 1), "Z" in RA ? (mA = utcDate(newDate(RA.y, 0, 1)), JA = mA.getUTCDay(), mA = JA > 4 || JA === 0 ? utcMonday.ceil(mA) : utcMonday(mA), mA = utcDay.offset(mA, (RA.V - 1) * 7), RA.y = mA.getUTCFullYear(), RA.m = mA.getUTCMonth(), RA.d = mA.getUTCDate() + (RA.w + 6) % 7) : (mA = localDate(newDate(RA.y, 0, 1)), JA = mA.getDay(), mA = JA > 4 || JA === 0 ? timeMonday.ceil(mA) : timeMonday(mA), mA = timeDay.offset(mA, (RA.V - 1) * 7), RA.y = mA.getFullYear(), RA.m = mA.getMonth(), RA.d = mA.getDate() + (RA.w + 6) % 7);
      } else ("W" in RA || "U" in RA) && ("w" in RA || (RA.w = "u" in RA ? RA.u % 7 : "W" in RA ? 1 : 0), JA = "Z" in RA ? utcDate(newDate(RA.y, 0, 1)).getUTCDay() : localDate(newDate(RA.y, 0, 1)).getDay(), RA.m = 0, RA.d = "W" in RA ? (RA.w + 6) % 7 + RA.W * 7 - (JA + 5) % 7 : RA.w + RA.U * 7 - (JA + 6) % 7);
      return "Z" in RA ? (RA.H += RA.Z / 100 | 0, RA.M += RA.Z % 100, utcDate(RA)) : localDate(RA);
    };
  }
  function hA(eg, kA, YA, RA) {
    for (var FA = 0, mA = kA.length, JA = YA.length, VA, HA; FA < mA; ) {
      if (RA >= JA) return -1;
      if (VA = kA.charCodeAt(FA++), VA === 37) {
        if (VA = kA.charAt(FA++), HA = sA[VA in pads ? kA.charAt(FA++) : VA], !HA || (RA = HA(eg, YA, RA)) < 0) return -1;
      } else if (VA != YA.charCodeAt(RA++))
        return -1;
    }
    return RA;
  }
  function dA(eg, kA, YA) {
    var RA = CA.exec(kA.slice(YA));
    return RA ? (eg.p = BA.get(RA[0].toLowerCase()), YA + RA[0].length) : -1;
  }
  function GA(eg, kA, YA) {
    var RA = QA.exec(kA.slice(YA));
    return RA ? (eg.w = tA.get(RA[0].toLowerCase()), YA + RA[0].length) : -1;
  }
  function DA(eg, kA, YA) {
    var RA = eA.exec(kA.slice(YA));
    return RA ? (eg.w = iA.get(RA[0].toLowerCase()), YA + RA[0].length) : -1;
  }
  function wA(eg, kA, YA) {
    var RA = aA.exec(kA.slice(YA));
    return RA ? (eg.m = nA.get(RA[0].toLowerCase()), YA + RA[0].length) : -1;
  }
  function bA(eg, kA, YA) {
    var RA = oA.exec(kA.slice(YA));
    return RA ? (eg.m = EA.get(RA[0].toLowerCase()), YA + RA[0].length) : -1;
  }
  function yA(eg, kA, YA) {
    return hA(eg, t, kA, YA);
  }
  function pA(eg, kA, YA) {
    return hA(eg, g, kA, YA);
  }
  function MA(eg, kA, YA) {
    return hA(eg, d, kA, YA);
  }
  function LA(eg) {
    return AA[eg.getDay()];
  }
  function xA(eg) {
    return H[eg.getDay()];
  }
  function TA(eg) {
    return IA[eg.getMonth()];
  }
  function NA(eg) {
    return gA[eg.getMonth()];
  }
  function zA(eg) {
    return k[+(eg.getHours() >= 12)];
  }
  function XA(eg) {
    return 1 + ~~(eg.getMonth() / 3);
  }
  function fA(eg) {
    return AA[eg.getUTCDay()];
  }
  function vA(eg) {
    return H[eg.getUTCDay()];
  }
  function Cg(eg) {
    return IA[eg.getUTCMonth()];
  }
  function Ig(eg) {
    return gA[eg.getUTCMonth()];
  }
  function gg(eg) {
    return k[+(eg.getUTCHours() >= 12)];
  }
  function og(eg) {
    return 1 + ~~(eg.getUTCMonth() / 3);
  }
  return {
    format: function(eg) {
      var kA = rA(eg += "", lA);
      return kA.toString = function() {
        return eg;
      }, kA;
    },
    parse: function(eg) {
      var kA = uA(eg += "", !1);
      return kA.toString = function() {
        return eg;
      }, kA;
    },
    utcFormat: function(eg) {
      var kA = rA(eg += "", cA);
      return kA.toString = function() {
        return eg;
      }, kA;
    },
    utcParse: function(eg) {
      var kA = uA(eg += "", !0);
      return kA.toString = function() {
        return eg;
      }, kA;
    }
  };
}
var pads = { "-": "", _: " ", 0: "0" }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(n, t, g) {
  var d = n < 0 ? "-" : "", k = (d ? -n : n) + "", H = k.length;
  return d + (H < g ? new Array(g - H + 1).join(t) + k : k);
}
function requote(n) {
  return n.replace(requoteRe, "\\$&");
}
function formatRe(n) {
  return new RegExp("^(?:" + n.map(requote).join("|") + ")", "i");
}
function formatLookup(n) {
  return new Map(n.map((t, g) => [t.toLowerCase(), g]));
}
function parseWeekdayNumberSunday(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 1));
  return d ? (n.w = +d[0], g + d[0].length) : -1;
}
function parseWeekdayNumberMonday(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 1));
  return d ? (n.u = +d[0], g + d[0].length) : -1;
}
function parseWeekNumberSunday(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 2));
  return d ? (n.U = +d[0], g + d[0].length) : -1;
}
function parseWeekNumberISO(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 2));
  return d ? (n.V = +d[0], g + d[0].length) : -1;
}
function parseWeekNumberMonday(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 2));
  return d ? (n.W = +d[0], g + d[0].length) : -1;
}
function parseFullYear(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 4));
  return d ? (n.y = +d[0], g + d[0].length) : -1;
}
function parseYear(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 2));
  return d ? (n.y = +d[0] + (+d[0] > 68 ? 1900 : 2e3), g + d[0].length) : -1;
}
function parseZone(n, t, g) {
  var d = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(g, g + 6));
  return d ? (n.Z = d[1] ? 0 : -(d[2] + (d[3] || "00")), g + d[0].length) : -1;
}
function parseQuarter(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 1));
  return d ? (n.q = d[0] * 3 - 3, g + d[0].length) : -1;
}
function parseMonthNumber(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 2));
  return d ? (n.m = d[0] - 1, g + d[0].length) : -1;
}
function parseDayOfMonth(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 2));
  return d ? (n.d = +d[0], g + d[0].length) : -1;
}
function parseDayOfYear(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 3));
  return d ? (n.m = 0, n.d = +d[0], g + d[0].length) : -1;
}
function parseHour24(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 2));
  return d ? (n.H = +d[0], g + d[0].length) : -1;
}
function parseMinutes(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 2));
  return d ? (n.M = +d[0], g + d[0].length) : -1;
}
function parseSeconds(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 2));
  return d ? (n.S = +d[0], g + d[0].length) : -1;
}
function parseMilliseconds(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 3));
  return d ? (n.L = +d[0], g + d[0].length) : -1;
}
function parseMicroseconds(n, t, g) {
  var d = numberRe.exec(t.slice(g, g + 6));
  return d ? (n.L = Math.floor(d[0] / 1e3), g + d[0].length) : -1;
}
function parseLiteralPercent(n, t, g) {
  var d = percentRe.exec(t.slice(g, g + 1));
  return d ? g + d[0].length : -1;
}
function parseUnixTimestamp(n, t, g) {
  var d = numberRe.exec(t.slice(g));
  return d ? (n.Q = +d[0], g + d[0].length) : -1;
}
function parseUnixTimestampSeconds(n, t, g) {
  var d = numberRe.exec(t.slice(g));
  return d ? (n.s = +d[0], g + d[0].length) : -1;
}
function formatDayOfMonth(n, t) {
  return pad(n.getDate(), t, 2);
}
function formatHour24(n, t) {
  return pad(n.getHours(), t, 2);
}
function formatHour12(n, t) {
  return pad(n.getHours() % 12 || 12, t, 2);
}
function formatDayOfYear(n, t) {
  return pad(1 + timeDay.count(timeYear(n), n), t, 3);
}
function formatMilliseconds(n, t) {
  return pad(n.getMilliseconds(), t, 3);
}
function formatMicroseconds(n, t) {
  return formatMilliseconds(n, t) + "000";
}
function formatMonthNumber(n, t) {
  return pad(n.getMonth() + 1, t, 2);
}
function formatMinutes(n, t) {
  return pad(n.getMinutes(), t, 2);
}
function formatSeconds(n, t) {
  return pad(n.getSeconds(), t, 2);
}
function formatWeekdayNumberMonday(n) {
  var t = n.getDay();
  return t === 0 ? 7 : t;
}
function formatWeekNumberSunday(n, t) {
  return pad(timeSunday.count(timeYear(n) - 1, n), t, 2);
}
function dISO(n) {
  var t = n.getDay();
  return t >= 4 || t === 0 ? timeThursday(n) : timeThursday.ceil(n);
}
function formatWeekNumberISO(n, t) {
  return n = dISO(n), pad(timeThursday.count(timeYear(n), n) + (timeYear(n).getDay() === 4), t, 2);
}
function formatWeekdayNumberSunday(n) {
  return n.getDay();
}
function formatWeekNumberMonday(n, t) {
  return pad(timeMonday.count(timeYear(n) - 1, n), t, 2);
}
function formatYear(n, t) {
  return pad(n.getFullYear() % 100, t, 2);
}
function formatYearISO(n, t) {
  return n = dISO(n), pad(n.getFullYear() % 100, t, 2);
}
function formatFullYear(n, t) {
  return pad(n.getFullYear() % 1e4, t, 4);
}
function formatFullYearISO(n, t) {
  var g = n.getDay();
  return n = g >= 4 || g === 0 ? timeThursday(n) : timeThursday.ceil(n), pad(n.getFullYear() % 1e4, t, 4);
}
function formatZone(n) {
  var t = n.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + pad(t / 60 | 0, "0", 2) + pad(t % 60, "0", 2);
}
function formatUTCDayOfMonth(n, t) {
  return pad(n.getUTCDate(), t, 2);
}
function formatUTCHour24(n, t) {
  return pad(n.getUTCHours(), t, 2);
}
function formatUTCHour12(n, t) {
  return pad(n.getUTCHours() % 12 || 12, t, 2);
}
function formatUTCDayOfYear(n, t) {
  return pad(1 + utcDay.count(utcYear(n), n), t, 3);
}
function formatUTCMilliseconds(n, t) {
  return pad(n.getUTCMilliseconds(), t, 3);
}
function formatUTCMicroseconds(n, t) {
  return formatUTCMilliseconds(n, t) + "000";
}
function formatUTCMonthNumber(n, t) {
  return pad(n.getUTCMonth() + 1, t, 2);
}
function formatUTCMinutes(n, t) {
  return pad(n.getUTCMinutes(), t, 2);
}
function formatUTCSeconds(n, t) {
  return pad(n.getUTCSeconds(), t, 2);
}
function formatUTCWeekdayNumberMonday(n) {
  var t = n.getUTCDay();
  return t === 0 ? 7 : t;
}
function formatUTCWeekNumberSunday(n, t) {
  return pad(utcSunday.count(utcYear(n) - 1, n), t, 2);
}
function UTCdISO(n) {
  var t = n.getUTCDay();
  return t >= 4 || t === 0 ? utcThursday(n) : utcThursday.ceil(n);
}
function formatUTCWeekNumberISO(n, t) {
  return n = UTCdISO(n), pad(utcThursday.count(utcYear(n), n) + (utcYear(n).getUTCDay() === 4), t, 2);
}
function formatUTCWeekdayNumberSunday(n) {
  return n.getUTCDay();
}
function formatUTCWeekNumberMonday(n, t) {
  return pad(utcMonday.count(utcYear(n) - 1, n), t, 2);
}
function formatUTCYear(n, t) {
  return pad(n.getUTCFullYear() % 100, t, 2);
}
function formatUTCYearISO(n, t) {
  return n = UTCdISO(n), pad(n.getUTCFullYear() % 100, t, 2);
}
function formatUTCFullYear(n, t) {
  return pad(n.getUTCFullYear() % 1e4, t, 4);
}
function formatUTCFullYearISO(n, t) {
  var g = n.getUTCDay();
  return n = g >= 4 || g === 0 ? utcThursday(n) : utcThursday.ceil(n), pad(n.getUTCFullYear() % 1e4, t, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(n) {
  return +n;
}
function formatUnixTimestampSeconds(n) {
  return Math.floor(+n / 1e3);
}
var locale$1, timeFormat$2, timeParse$1, utcFormat$1, utcParse$1;
defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale$1(n) {
  return locale$1 = formatLocale(n), timeFormat$2 = locale$1.format, timeParse$1 = locale$1.parse, utcFormat$1 = locale$1.utcFormat, utcParse$1 = locale$1.utcParse, locale$1;
}
function memoize$1(n) {
  const t = {};
  return (g) => t[g] || (t[g] = n(g));
}
function trimZeroes(n, t) {
  return (g) => {
    const d = n(g), k = d.indexOf(t);
    if (k < 0) return d;
    let H = rightmostDigit(d, k);
    const AA = H < d.length ? d.slice(H) : "";
    for (; --H > k; ) if (d[H] !== "0") {
      ++H;
      break;
    }
    return d.slice(0, H) + AA;
  };
}
function rightmostDigit(n, t) {
  let g = n.lastIndexOf("e"), d;
  if (g > 0) return g;
  for (g = n.length; --g > t; )
    if (d = n.charCodeAt(g), d >= 48 && d <= 57) return g + 1;
}
function numberLocale(n) {
  const t = memoize$1(n.format), g = n.formatPrefix;
  return {
    format: t,
    formatPrefix: g,
    formatFloat(d) {
      const k = formatSpecifier(d || ",");
      if (k.precision == null) {
        switch (k.precision = 12, k.type) {
          case "%":
            k.precision -= 2;
            break;
          case "e":
            k.precision -= 1;
            break;
        }
        return trimZeroes(
          t(k),
          // number format
          t(".1f")(1)[1]
          // decimal point character
        );
      } else
        return t(k);
    },
    formatSpan(d, k, H, AA) {
      AA = formatSpecifier(AA ?? ",f");
      const gA = tickStep(d, k, H), IA = Math.max(Math.abs(d), Math.abs(k));
      let CA;
      if (AA.precision == null)
        switch (AA.type) {
          case "s":
            return isNaN(CA = precisionPrefix(gA, IA)) || (AA.precision = CA), g(AA, IA);
          case "":
          case "e":
          case "g":
          case "p":
          case "r": {
            isNaN(CA = precisionRound(gA, IA)) || (AA.precision = CA - (AA.type === "e"));
            break;
          }
          case "f":
          case "%": {
            isNaN(CA = precisionFixed(gA)) || (AA.precision = CA - (AA.type === "%") * 2);
            break;
          }
        }
      return t(AA);
    }
  };
}
let defaultNumberLocale;
resetNumberFormatDefaultLocale();
function resetNumberFormatDefaultLocale() {
  return defaultNumberLocale = numberLocale({
    format: format$3,
    formatPrefix
  });
}
function numberFormatLocale(n) {
  return numberLocale(formatLocale$1(n));
}
function numberFormatDefaultLocale(n) {
  return arguments.length ? defaultNumberLocale = numberFormatLocale(n) : defaultNumberLocale;
}
function timeMultiFormat(n, t, g) {
  g = g || {}, isObject$4(g) || error$3(`Invalid time multi-format specifier: ${g}`);
  const d = t(SECONDS), k = t(MINUTES), H = t(HOURS), AA = t(DATE), gA = t(WEEK), IA = t(MONTH), CA = t(QUARTER), BA = t(YEAR), eA = n(g[MILLISECONDS] || ".%L"), iA = n(g[SECONDS] || ":%S"), QA = n(g[MINUTES] || "%I:%M"), tA = n(g[HOURS] || "%I %p"), oA = n(g[DATE] || g[DAY] || "%a %d"), EA = n(g[WEEK] || "%b %d"), aA = n(g[MONTH] || "%B"), nA = n(g[QUARTER] || "%B"), lA = n(g[YEAR] || "%Y");
  return (cA) => (d(cA) < cA ? eA : k(cA) < cA ? iA : H(cA) < cA ? QA : AA(cA) < cA ? tA : IA(cA) < cA ? gA(cA) < cA ? oA : EA : BA(cA) < cA ? CA(cA) < cA ? aA : nA : lA)(cA);
}
function timeLocale(n) {
  const t = memoize$1(n.format), g = memoize$1(n.utcFormat);
  return {
    timeFormat: (d) => isString$2(d) ? t(d) : timeMultiFormat(t, timeInterval, d),
    utcFormat: (d) => isString$2(d) ? g(d) : timeMultiFormat(g, utcInterval, d),
    timeParse: memoize$1(n.parse),
    utcParse: memoize$1(n.utcParse)
  };
}
let defaultTimeLocale;
resetTimeFormatDefaultLocale();
function resetTimeFormatDefaultLocale() {
  return defaultTimeLocale = timeLocale({
    format: timeFormat$2,
    parse: timeParse$1,
    utcFormat: utcFormat$1,
    utcParse: utcParse$1
  });
}
function timeFormatLocale(n) {
  return timeLocale(formatLocale(n));
}
function timeFormatDefaultLocale(n) {
  return arguments.length ? defaultTimeLocale = timeFormatLocale(n) : defaultTimeLocale;
}
const createLocale = (n, t) => extend$2({}, n, t);
function locale(n, t) {
  const g = n ? numberFormatLocale(n) : numberFormatDefaultLocale(), d = t ? timeFormatLocale(t) : timeFormatDefaultLocale();
  return createLocale(g, d);
}
function defaultLocale(n, t) {
  const g = arguments.length;
  return g && g !== 2 && error$3("defaultLocale expects either zero or two arguments."), g ? createLocale(numberFormatDefaultLocale(n), timeFormatDefaultLocale(t)) : createLocale(numberFormatDefaultLocale(), timeFormatDefaultLocale());
}
function resetDefaultLocale() {
  return resetNumberFormatDefaultLocale(), resetTimeFormatDefaultLocale(), defaultLocale();
}
const protocol_re = /^(data:|([A-Za-z]+:)?\/\/)/, allowed_re = /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|file|data):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i, whitespace_re = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g, fileProtocol = "file://";
function loaderFactory(n) {
  return (t) => ({
    options: t || {},
    sanitize,
    load: load$1,
    fileAccess: !1,
    file: fileLoader(),
    http: httpLoader
  });
}
async function load$1(n, t) {
  const g = await this.sanitize(n, t), d = g.href;
  return g.localFile ? this.file(d) : this.http(d, t?.http);
}
async function sanitize(n, t) {
  t = extend$2({}, this.options, t);
  const g = this.fileAccess, d = {
    href: null
  };
  let k, H, AA;
  const gA = allowed_re.test(n.replace(whitespace_re, ""));
  (n == null || typeof n != "string" || !gA) && error$3("Sanitize failure, invalid URI: " + $$2(n));
  const IA = protocol_re.test(n);
  return (AA = t.baseURL) && !IA && (!n.startsWith("/") && !AA.endsWith("/") && (n = "/" + n), n = AA + n), H = (k = n.startsWith(fileProtocol)) || t.mode === "file" || t.mode !== "http" && !IA && g, k ? n = n.slice(fileProtocol.length) : n.startsWith("//") && (t.defaultProtocol === "file" ? (n = n.slice(2), H = !0) : n = (t.defaultProtocol || "http") + ":" + n), Object.defineProperty(d, "localFile", {
    value: !!H
  }), d.href = n, t.target && (d.target = t.target + ""), t.rel && (d.rel = t.rel + ""), t.context === "image" && t.crossOrigin && (d.crossOrigin = t.crossOrigin + ""), d;
}
function fileLoader(n) {
  return fileReject;
}
async function fileReject() {
  error$3("No file system access.");
}
async function httpLoader(n, t) {
  const g = extend$2({}, this.options.http, t), d = t && t.response, k = await fetch(n, g);
  return k.ok ? isFunction$5(k[d]) ? k[d]() : k.text() : error$3(k.status + "" + k.statusText);
}
const isValid$1 = (n) => n != null && n === n, isBoolean$3 = (n) => n === "true" || n === "false" || n === !0 || n === !1, isDate$1 = (n) => !Number.isNaN(Date.parse(n)), isNumber$2 = (n) => !Number.isNaN(+n) && !(n instanceof Date), isInteger$1 = (n) => isNumber$2(n) && Number.isInteger(+n), typeParsers = {
  boolean: toBoolean,
  integer: toNumber$1,
  number: toNumber$1,
  date: toDate,
  string: toString$3,
  unknown: identity$8
}, typeTests = [isBoolean$3, isInteger$1, isNumber$2, isDate$1], typeList = ["boolean", "integer", "number", "date"];
function inferType(n, t) {
  if (!n || !n.length) return "unknown";
  const g = n.length, d = typeTests.length, k = typeTests.map((H, AA) => AA + 1);
  for (let H = 0, AA = 0, gA, IA; H < g; ++H)
    for (IA = t ? n[H][t] : n[H], gA = 0; gA < d; ++gA)
      if (k[gA] && isValid$1(IA) && !typeTests[gA](IA) && (k[gA] = 0, ++AA, AA === typeTests.length))
        return "string";
  return typeList[k.reduce((H, AA) => H === 0 ? AA : H, 0) - 1];
}
function inferTypes(n, t) {
  return t.reduce((g, d) => (g[d] = inferType(n, d), g), {});
}
function delimitedFormat(n) {
  const t = function(g, d) {
    const k = {
      delimiter: n
    };
    return dsv(g, d ? extend$2(d, k) : k);
  };
  return t.responseType = "text", t;
}
function dsv(n, t) {
  return t.header && (n = t.header.map($$2).join(t.delimiter) + `
` + n), dsvFormat(t.delimiter).parse(n + "");
}
dsv.responseType = "text";
function isBuffer$2(n) {
  return typeof Buffer == "function" && isFunction$5(Buffer.isBuffer) ? Buffer.isBuffer(n) : !1;
}
function json(n, t) {
  const g = t && t.property ? field$4(t.property) : identity$8;
  return isObject$4(n) && !isBuffer$2(n) ? parseJSON(g(n), t) : g(JSON.parse(n));
}
json.responseType = "json";
function parseJSON(n, t) {
  return !isArray$3(n) && isIterable$1(n) && (n = [...n]), t && t.copy ? JSON.parse(JSON.stringify(n)) : n;
}
const filters = {
  interior: (n, t) => n !== t,
  exterior: (n, t) => n === t
};
function topojson(n, t) {
  let g, d, k, H;
  return n = json(n, t), t && t.feature ? (g = feature, k = t.feature) : t && t.mesh ? (g = mesh, k = t.mesh, H = filters[t.filter]) : error$3("Missing TopoJSON feature or mesh parameter."), d = (d = n.objects[k]) ? g(n, d, H) : error$3("Invalid TopoJSON object: " + k), d && d.features || [d];
}
topojson.responseType = "json";
const format$2 = {
  dsv,
  csv: delimitedFormat(","),
  tsv: delimitedFormat("	"),
  json,
  topojson
};
function formats$1(n, t) {
  return arguments.length > 1 ? (format$2[n] = t, this) : has$2(format$2, n) ? format$2[n] : null;
}
function responseType(n) {
  const t = formats$1(n);
  return t && t.responseType || "text";
}
function read(n, t, g, d) {
  t = t || {};
  const k = formats$1(t.type || "json");
  return k || error$3("Unknown data format type: " + t.type), n = k(n, t), t.parse && parse$6(n, t.parse, g, d), has$2(n, "columns") && delete n.columns, n;
}
function parse$6(n, t, g, d) {
  if (!n.length) return;
  const k = timeFormatDefaultLocale();
  g = g || k.timeParse, d = d || k.utcParse;
  let H = n.columns || Object.keys(n[0]), AA, gA, IA, CA, BA, eA;
  t === "auto" && (t = inferTypes(n, H)), H = Object.keys(t);
  const iA = H.map((QA) => {
    const tA = t[QA];
    let oA, EA;
    if (tA && (tA.startsWith("date:") || tA.startsWith("utc:")))
      return oA = tA.split(/:(.+)?/, 2), EA = oA[1], (EA[0] === "'" && EA[EA.length - 1] === "'" || EA[0] === '"' && EA[EA.length - 1] === '"') && (EA = EA.slice(1, -1)), (oA[0] === "utc" ? d : g)(EA);
    if (!typeParsers[tA])
      throw Error("Illegal format pattern: " + QA + ":" + tA);
    return typeParsers[tA];
  });
  for (IA = 0, BA = n.length, eA = H.length; IA < BA; ++IA)
    for (AA = n[IA], CA = 0; CA < eA; ++CA)
      gA = H[CA], AA[gA] = iA[CA](AA[gA]);
}
const loader = loaderFactory();
function UniqueList(n) {
  const t = n || identity$8, g = [], d = {};
  return g.add = (k) => {
    const H = t(k);
    return d[H] || (d[H] = 1, g.push(k)), g;
  }, g.remove = (k) => {
    const H = t(k);
    if (d[H]) {
      d[H] = 0;
      const AA = g.indexOf(k);
      AA >= 0 && g.splice(AA, 1);
    }
    return g;
  }, g;
}
async function asyncCallback(n, t) {
  try {
    await t(n);
  } catch (g) {
    n.error(g);
  }
}
const TUPLE_ID_KEY = Symbol("vega_id");
let TUPLE_ID = 1;
function isTuple(n) {
  return !!(n && tupleid(n));
}
function tupleid(n) {
  return n[TUPLE_ID_KEY];
}
function setid(n, t) {
  return n[TUPLE_ID_KEY] = t, n;
}
function ingest$1(n) {
  const t = n === Object(n) ? n : {
    data: n
  };
  return tupleid(t) ? t : setid(t, TUPLE_ID++);
}
function derive(n) {
  return rederive(n, ingest$1({}));
}
function rederive(n, t) {
  for (const g in n) t[g] = n[g];
  return t;
}
function replace$1(n, t) {
  return setid(t, tupleid(n));
}
function stableCompare(n, t) {
  return n ? t ? (g, d) => n(g, d) || tupleid(t(g)) - tupleid(t(d)) : (g, d) => n(g, d) || tupleid(g) - tupleid(d) : null;
}
function isChangeSet(n) {
  return n && n.constructor === changeset;
}
function changeset() {
  const n = [], t = [], g = [], d = [], k = [];
  let H = null, AA = !1;
  return {
    constructor: changeset,
    insert(gA) {
      const IA = array$6(gA), CA = IA.length;
      for (let BA = 0; BA < CA; ++BA) n.push(IA[BA]);
      return this;
    },
    remove(gA) {
      const IA = isFunction$5(gA) ? d : t, CA = array$6(gA), BA = CA.length;
      for (let eA = 0; eA < BA; ++eA) IA.push(CA[eA]);
      return this;
    },
    modify(gA, IA, CA) {
      const BA = {
        field: IA,
        value: constant$6(CA)
      };
      return isFunction$5(gA) ? (BA.filter = gA, k.push(BA)) : (BA.tuple = gA, g.push(BA)), this;
    },
    encode(gA, IA) {
      return isFunction$5(gA) ? k.push({
        filter: gA,
        field: IA
      }) : g.push({
        tuple: gA,
        field: IA
      }), this;
    },
    clean(gA) {
      return H = gA, this;
    },
    reflow() {
      return AA = !0, this;
    },
    pulse(gA, IA) {
      const CA = {}, BA = {};
      let eA, iA, QA, tA, oA, EA;
      for (eA = 0, iA = IA.length; eA < iA; ++eA)
        CA[tupleid(IA[eA])] = 1;
      for (eA = 0, iA = t.length; eA < iA; ++eA)
        oA = t[eA], CA[tupleid(oA)] = -1;
      for (eA = 0, iA = d.length; eA < iA; ++eA)
        tA = d[eA], IA.forEach((nA) => {
          tA(nA) && (CA[tupleid(nA)] = -1);
        });
      for (eA = 0, iA = n.length; eA < iA; ++eA)
        oA = n[eA], EA = tupleid(oA), CA[EA] ? CA[EA] = 1 : gA.add.push(ingest$1(n[eA]));
      for (eA = 0, iA = IA.length; eA < iA; ++eA)
        oA = IA[eA], CA[tupleid(oA)] < 0 && gA.rem.push(oA);
      function aA(nA, lA, cA) {
        cA ? nA[lA] = cA(nA) : gA.encode = lA, AA || (BA[tupleid(nA)] = nA);
      }
      for (eA = 0, iA = g.length; eA < iA; ++eA)
        QA = g[eA], oA = QA.tuple, tA = QA.field, EA = CA[tupleid(oA)], EA > 0 && (aA(oA, tA, QA.value), gA.modifies(tA));
      for (eA = 0, iA = k.length; eA < iA; ++eA)
        QA = k[eA], tA = QA.filter, IA.forEach((nA) => {
          tA(nA) && CA[tupleid(nA)] > 0 && aA(nA, QA.field, QA.value);
        }), gA.modifies(QA.field);
      if (AA)
        gA.mod = t.length || d.length ? IA.filter((nA) => CA[tupleid(nA)] > 0) : IA.slice();
      else
        for (EA in BA) gA.mod.push(BA[EA]);
      return (H || H == null && (t.length || d.length)) && gA.clean(!0), gA;
    }
  };
}
const CACHE = "_:mod:_";
function Parameters() {
  Object.defineProperty(this, CACHE, {
    writable: !0,
    value: {}
  });
}
Parameters.prototype = {
  /**
   * Set a parameter value. If the parameter value changes, the parameter
   * will be recorded as modified.
   * @param {string} name - The parameter name.
   * @param {number} index - The index into an array-value parameter. Ignored if
   *   the argument is undefined, null or less than zero.
   * @param {*} value - The parameter value to set.
   * @param {boolean} [force=false] - If true, records the parameter as modified
   *   even if the value is unchanged.
   * @return {Parameters} - This parameter object.
   */
  set(n, t, g, d) {
    const k = this, H = k[n], AA = k[CACHE];
    return t != null && t >= 0 ? (H[t] !== g || d) && (H[t] = g, AA[t + ":" + n] = -1, AA[n] = -1) : (H !== g || d) && (k[n] = g, AA[n] = isArray$3(g) ? 1 + g.length : -1), k;
  },
  /**
   * Tests if one or more parameters has been modified. If invoked with no
   * arguments, returns true if any parameter value has changed. If the first
   * argument is array, returns trues if any parameter name in the array has
   * changed. Otherwise, tests if the given name and optional array index has
   * changed.
   * @param {string} name - The parameter name to test.
   * @param {number} [index=undefined] - The parameter array index to test.
   * @return {boolean} - Returns true if a queried parameter was modified.
   */
  modified(n, t) {
    const g = this[CACHE];
    if (arguments.length) {
      if (isArray$3(n)) {
        for (let d = 0; d < n.length; ++d)
          if (g[n[d]]) return !0;
        return !1;
      }
    } else {
      for (const d in g)
        if (g[d]) return !0;
      return !1;
    }
    return t != null && t >= 0 ? t + 1 < g[n] || !!g[t + ":" + n] : !!g[n];
  },
  /**
   * Clears the modification records. After calling this method,
   * all parameters are considered unmodified.
   */
  clear() {
    return this[CACHE] = {}, this;
  }
};
let OP_ID = 0;
const PULSE = "pulse", NO_PARAMS = new Parameters(), SKIP$1$1 = 1, MODIFIED = 2;
function Operator(n, t, g, d) {
  this.id = ++OP_ID, this.value = n, this.stamp = -1, this.rank = -1, this.qrank = -1, this.flags = 0, t && (this._update = t), g && this.parameters(g, d);
}
function flag(n) {
  return function(t) {
    const g = this.flags;
    return arguments.length === 0 ? !!(g & n) : (this.flags = t ? g | n : g & ~n, this);
  };
}
Operator.prototype = {
  /**
   * Returns a list of target operators dependent on this operator.
   * If this list does not exist, it is created and then returned.
   * @return {UniqueList}
   */
  targets() {
    return this._targets || (this._targets = UniqueList(id));
  },
  /**
   * Sets the value of this operator.
   * @param {*} value - the value to set.
   * @return {Number} Returns 1 if the operator value has changed
   *   according to strict equality, returns 0 otherwise.
   */
  set(n) {
    return this.value !== n ? (this.value = n, 1) : 0;
  },
  /**
   * Indicates that operator evaluation should be skipped on the next pulse.
   * This operator will still propagate incoming pulses, but its update function
   * will not be invoked. The skip flag is reset after every pulse, so calling
   * this method will affect processing of the next pulse only.
   */
  skip: flag(SKIP$1$1),
  /**
   * Indicates that this operator's value has been modified on its most recent
   * pulse. Normally modification is checked via strict equality; however, in
   * some cases it is more efficient to update the internal state of an object.
   * In those cases, the modified flag can be used to trigger propagation. Once
   * set, the modification flag persists across pulses until unset. The flag can
   * be used with the last timestamp to test if a modification is recent.
   */
  modified: flag(MODIFIED),
  /**
   * Sets the parameters for this operator. The parameter values are analyzed for
   * operator instances. If found, this operator will be added as a dependency
   * of the parameterizing operator. Operator values are dynamically marshalled
   * from each operator parameter prior to evaluation. If a parameter value is
   * an array, the array will also be searched for Operator instances. However,
   * the search does not recurse into sub-arrays or object properties.
   * @param {object} params - A hash of operator parameters.
   * @param {boolean} [react=true] - A flag indicating if this operator should
   *   automatically update (react) when parameter values change. In other words,
   *   this flag determines if the operator registers itself as a listener on
   *   any upstream operators included in the parameters.
   * @param {boolean} [initonly=false] - A flag indicating if this operator
   *   should calculate an update only upon its initial evaluation, then
   *   deregister dependencies and suppress all future update invocations.
   * @return {Operator[]} - An array of upstream dependencies.
   */
  parameters(n, t, g) {
    t = t !== !1;
    const d = this._argval = this._argval || new Parameters(), k = this._argops = this._argops || [], H = [];
    let AA, gA, IA, CA;
    const BA = (eA, iA, QA) => {
      QA instanceof Operator ? (QA !== this && (t && QA.targets().add(this), H.push(QA)), k.push({
        op: QA,
        name: eA,
        index: iA
      })) : d.set(eA, iA, QA);
    };
    for (AA in n)
      if (gA = n[AA], AA === PULSE)
        array$6(gA).forEach((eA) => {
          eA instanceof Operator ? eA !== this && (eA.targets().add(this), H.push(eA)) : error$3("Pulse parameters must be operator instances.");
        }), this.source = gA;
      else if (isArray$3(gA))
        for (d.set(AA, -1, Array(IA = gA.length)), CA = 0; CA < IA; ++CA) BA(AA, CA, gA[CA]);
      else
        BA(AA, -1, gA);
    return this.marshall().clear(), g && (k.initonly = !0), H;
  },
  /**
   * Internal method for marshalling parameter values.
   * Visits each operator dependency to pull the latest value.
   * @return {Parameters} A Parameters object to pass to the update function.
   */
  marshall(n) {
    const t = this._argval || NO_PARAMS, g = this._argops;
    let d, k, H, AA;
    if (g) {
      const gA = g.length;
      for (k = 0; k < gA; ++k)
        d = g[k], H = d.op, AA = H.modified() && H.stamp === n, t.set(d.name, d.index, H.value, AA);
      if (g.initonly) {
        for (k = 0; k < gA; ++k)
          d = g[k], d.op.targets().remove(this);
        this._argops = null, this._update = null;
      }
    }
    return t;
  },
  /**
   * Detach this operator from the dataflow.
   * Unregisters listeners on upstream dependencies.
   */
  detach() {
    const n = this._argops;
    let t, g, d, k;
    if (n)
      for (t = 0, g = n.length; t < g; ++t)
        d = n[t], k = d.op, k._targets && k._targets.remove(this);
    this.pulse = null, this.source = null;
  },
  /**
   * Delegate method to perform operator processing.
   * Subclasses can override this method to perform custom processing.
   * By default, it marshalls parameters and calls the update function
   * if that function is defined. If the update function does not
   * change the operator value then StopPropagation is returned.
   * If no update function is defined, this method does nothing.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return The output pulse or StopPropagation. A falsy return value
   *   (including undefined) will let the input pulse pass through.
   */
  evaluate(n) {
    const t = this._update;
    if (t) {
      const g = this.marshall(n.stamp), d = t.call(this, g, n);
      if (g.clear(), d !== this.value)
        this.value = d;
      else if (!this.modified())
        return n.StopPropagation;
    }
  },
  /**
   * Run this operator for the current pulse. If this operator has already
   * been run at (or after) the pulse timestamp, returns StopPropagation.
   * Internally, this method calls {@link evaluate} to perform processing.
   * If {@link evaluate} returns a falsy value, the input pulse is returned.
   * This method should NOT be overridden, instead overrride {@link evaluate}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return the output pulse for this operator (or StopPropagation)
   */
  run(n) {
    if (n.stamp < this.stamp) return n.StopPropagation;
    let t;
    return this.skip() ? (this.skip(!1), t = 0) : t = this.evaluate(n), this.pulse = t || n;
  }
};
function add$4(n, t, g, d) {
  let k = 1, H;
  return n instanceof Operator ? H = n : n && n.prototype instanceof Operator ? H = new n() : isFunction$5(n) ? H = new Operator(null, n) : (k = 0, H = new Operator(n, t)), this.rank(H), k && (d = g, g = t), g && this.connect(H, H.parameters(g, d)), this.touch(H), H;
}
function connect(n, t) {
  const g = n.rank, d = t.length;
  for (let k = 0; k < d; ++k)
    if (g < t[k].rank) {
      this.rerank(n);
      return;
    }
}
let STREAM_ID = 0;
function EventStream(n, t, g) {
  this.id = ++STREAM_ID, this.value = null, g && (this.receive = g), n && (this._filter = n), t && (this._apply = t);
}
function stream(n, t, g) {
  return new EventStream(n, t, g);
}
EventStream.prototype = {
  _filter: truthy,
  _apply: identity$8,
  targets() {
    return this._targets || (this._targets = UniqueList(id));
  },
  consume(n) {
    return arguments.length ? (this._consume = !!n, this) : !!this._consume;
  },
  receive(n) {
    if (this._filter(n)) {
      const t = this.value = this._apply(n), g = this._targets, d = g ? g.length : 0;
      for (let k = 0; k < d; ++k) g[k].receive(t);
      this._consume && (n.preventDefault(), n.stopPropagation());
    }
  },
  filter(n) {
    const t = stream(n);
    return this.targets().add(t), t;
  },
  apply(n) {
    const t = stream(null, n);
    return this.targets().add(t), t;
  },
  merge() {
    const n = stream();
    this.targets().add(n);
    for (let t = 0, g = arguments.length; t < g; ++t)
      arguments[t].targets().add(n);
    return n;
  },
  throttle(n) {
    let t = -1;
    return this.filter(() => {
      const g = Date.now();
      return g - t > n ? (t = g, 1) : 0;
    });
  },
  debounce(n) {
    const t = stream();
    return this.targets().add(stream(null, null, debounce$1(n, (g) => {
      const d = g.dataflow;
      t.receive(g), d && d.run && d.run();
    }))), t;
  },
  between(n, t) {
    let g = !1;
    return n.targets().add(stream(null, null, () => g = !0)), t.targets().add(stream(null, null, () => g = !1)), this.filter(() => g);
  },
  detach() {
    this._filter = truthy, this._targets = null;
  }
};
function events$1(n, t, g, d) {
  const k = this, H = stream(g, d), AA = function(CA) {
    CA.dataflow = k;
    try {
      H.receive(CA);
    } catch (BA) {
      k.error(BA);
    } finally {
      k.run();
    }
  };
  let gA;
  typeof n == "string" && typeof document < "u" ? gA = document.querySelectorAll(n) : gA = array$6(n);
  const IA = gA.length;
  for (let CA = 0; CA < IA; ++CA)
    gA[CA].addEventListener(t, AA);
  return H;
}
function parse$5(n, t) {
  const g = this.locale();
  return read(n, t, g.timeParse, g.utcParse);
}
function ingest(n, t, g) {
  return t = this.parse(t, g), this.pulse(n, this.changeset().insert(t));
}
async function request(n, t) {
  const g = this;
  let d = 0, k;
  try {
    k = await g.loader().load(n, {
      context: "dataflow",
      response: responseType(t && t.type)
    });
    try {
      k = g.parse(k, t);
    } catch (H) {
      d = -2, g.warn("Data ingestion failed", n, H);
    }
  } catch (H) {
    d = -1, g.warn("Loading failed", n, H);
  }
  return {
    data: k,
    status: d
  };
}
async function preload(n, t, g) {
  const d = this, k = d._pending || loadPending(d);
  k.requests += 1;
  const H = await d.request(t, g);
  return d.pulse(n, d.changeset().remove(truthy).insert(H.data || [])), k.done(), H;
}
function loadPending(n) {
  let t;
  const g = new Promise((d) => t = d);
  return g.requests = 0, g.done = () => {
    --g.requests === 0 && (n._pending = null, t(n));
  }, n._pending = g;
}
const SKIP$2 = {
  skip: !0
};
function on(n, t, g, d, k) {
  return (n instanceof Operator ? onOperator : onStream)(this, n, t, g, d, k), this;
}
function onStream(n, t, g, d, k, H) {
  const AA = extend$2({}, H, SKIP$2);
  let gA, IA;
  isFunction$5(g) || (g = constant$6(g)), d === void 0 ? gA = (CA) => n.touch(g(CA)) : isFunction$5(d) ? (IA = new Operator(null, d, k, !1), gA = (CA) => {
    IA.evaluate(CA);
    const BA = g(CA), eA = IA.value;
    isChangeSet(eA) ? n.pulse(BA, eA, H) : n.update(BA, eA, AA);
  }) : gA = (CA) => n.update(g(CA), d, AA), t.apply(gA);
}
function onOperator(n, t, g, d, k, H) {
  if (d === void 0)
    t.targets().add(g);
  else {
    const AA = H || {}, gA = new Operator(null, updater(g, d), k, !1);
    gA.modified(AA.force), gA.rank = t.rank, t.targets().add(gA), g && (gA.skip(!0), gA.value = g.value, gA.targets().add(g), n.connect(g, [gA]));
  }
}
function updater(n, t) {
  return t = isFunction$5(t) ? t : constant$6(t), n ? function(g, d) {
    const k = t(g, d);
    return n.skip() || (n.skip(k !== this.value).value = k), k;
  } : t;
}
function rank(n) {
  n.rank = ++this._rank;
}
function rerank(n) {
  const t = [n];
  let g, d, k;
  for (; t.length; )
    if (this.rank(g = t.pop()), d = g._targets)
      for (k = d.length; --k >= 0; )
        t.push(g = d[k]), g === n && error$3("Cycle detected in dataflow graph.");
}
const StopPropagation = {}, ADD = 1, REM = 2, MOD$1 = 4, ADD_REM = ADD | REM, ADD_MOD = ADD | MOD$1, ALL = ADD | REM | MOD$1, REFLOW = 8, SOURCE = 16, NO_SOURCE = 32, NO_FIELDS = 64;
function Pulse(n, t, g) {
  this.dataflow = n, this.stamp = t ?? -1, this.add = [], this.rem = [], this.mod = [], this.fields = null, this.encode = g || null;
}
function materialize(n, t) {
  const g = [];
  return visitArray(n, t, (d) => g.push(d)), g;
}
function filter$3(n, t) {
  const g = {};
  return n.visit(t, (d) => {
    g[tupleid(d)] = 1;
  }), (d) => g[tupleid(d)] ? null : d;
}
function addFilter(n, t) {
  return n ? (g, d) => n(g, d) && t(g, d) : t;
}
Pulse.prototype = {
  /**
   * Sentinel value indicating pulse propagation should stop.
   */
  StopPropagation,
  /**
   * Boolean flag indicating ADD (added) tuples.
   */
  ADD,
  /**
   * Boolean flag indicating REM (removed) tuples.
   */
  REM,
  /**
   * Boolean flag indicating MOD (modified) tuples.
   */
  MOD: MOD$1,
  /**
   * Boolean flag indicating ADD (added) and REM (removed) tuples.
   */
  ADD_REM,
  /**
   * Boolean flag indicating ADD (added) and MOD (modified) tuples.
   */
  ADD_MOD,
  /**
   * Boolean flag indicating ADD, REM and MOD tuples.
   */
  ALL,
  /**
   * Boolean flag indicating all tuples in a data source
   * except for the ADD, REM and MOD tuples.
   */
  REFLOW,
  /**
   * Boolean flag indicating a 'pass-through' to a
   * backing data source, ignoring ADD, REM and MOD tuples.
   */
  SOURCE,
  /**
   * Boolean flag indicating that source data should be
   * suppressed when creating a forked pulse.
   */
  NO_SOURCE,
  /**
   * Boolean flag indicating that field modifications should be
   * suppressed when creating a forked pulse.
   */
  NO_FIELDS,
  /**
   * Creates a new pulse based on the values of this pulse.
   * The dataflow, time stamp and field modification values are copied over.
   * By default, new empty ADD, REM and MOD arrays are created.
   * @param {number} flags - Integer of boolean flags indicating which (if any)
   *   tuple arrays should be copied to the new pulse. The supported flag values
   *   are ADD, REM and MOD. Array references are copied directly: new array
   *   instances are not created.
   * @return {Pulse} - The forked pulse instance.
   * @see init
   */
  fork(n) {
    return new Pulse(this.dataflow).init(this, n);
  },
  /**
   * Creates a copy of this pulse with new materialized array
   * instances for the ADD, REM, MOD, and SOURCE arrays.
   * The dataflow, time stamp and field modification values are copied over.
   * @return {Pulse} - The cloned pulse instance.
   * @see init
   */
  clone() {
    const n = this.fork(ALL);
    return n.add = n.add.slice(), n.rem = n.rem.slice(), n.mod = n.mod.slice(), n.source && (n.source = n.source.slice()), n.materialize(ALL | SOURCE);
  },
  /**
   * Returns a pulse that adds all tuples from a backing source. This is
   * useful for cases where operators are added to a dataflow after an
   * upstream data pipeline has already been processed, ensuring that
   * new operators can observe all tuples within a stream.
   * @return {Pulse} - A pulse instance with all source tuples included
   *   in the add array. If the current pulse already has all source
   *   tuples in its add array, it is returned directly. If the current
   *   pulse does not have a backing source, it is returned directly.
   */
  addAll() {
    let n = this;
    return !n.source || n.add === n.rem || !n.rem.length && n.source.length === n.add.length || (n = new Pulse(this.dataflow).init(this), n.add = n.source, n.rem = []), n;
  },
  /**
   * Initialize this pulse based on the values of another pulse. This method
   * is used internally by {@link fork} to initialize a new forked tuple.
   * The dataflow, time stamp and field modification values are copied over.
   * By default, new empty ADD, REM and MOD arrays are created.
   * @param {Pulse} src - The source pulse to copy from.
   * @param {number} flags - Integer of boolean flags indicating which (if any)
   *   tuple arrays should be copied to the new pulse. The supported flag values
   *   are ADD, REM and MOD. Array references are copied directly: new array
   *   instances are not created. By default, source data arrays are copied
   *   to the new pulse. Use the NO_SOURCE flag to enforce a null source.
   * @return {Pulse} - Returns this Pulse instance.
   */
  init(n, t) {
    const g = this;
    return g.stamp = n.stamp, g.encode = n.encode, n.fields && !(t & NO_FIELDS) && (g.fields = n.fields), t & ADD ? (g.addF = n.addF, g.add = n.add) : (g.addF = null, g.add = []), t & REM ? (g.remF = n.remF, g.rem = n.rem) : (g.remF = null, g.rem = []), t & MOD$1 ? (g.modF = n.modF, g.mod = n.mod) : (g.modF = null, g.mod = []), t & NO_SOURCE ? (g.srcF = null, g.source = null) : (g.srcF = n.srcF, g.source = n.source, n.cleans && (g.cleans = n.cleans)), g;
  },
  /**
   * Schedules a function to run after pulse propagation completes.
   * @param {function} func - The function to run.
   */
  runAfter(n) {
    this.dataflow.runAfter(n);
  },
  /**
   * Indicates if tuples have been added, removed or modified.
   * @param {number} [flags] - The tuple types (ADD, REM or MOD) to query.
   *   Defaults to ALL, returning true if any tuple type has changed.
   * @return {boolean} - Returns true if one or more queried tuple types have
   *   changed, false otherwise.
   */
  changed(n) {
    const t = n || ALL;
    return t & ADD && this.add.length || t & REM && this.rem.length || t & MOD$1 && this.mod.length;
  },
  /**
   * Forces a "reflow" of tuple values, such that all tuples in the backing
   * source are added to the MOD set, unless already present in the ADD set.
   * @param {boolean} [fork=false] - If true, returns a forked copy of this
   *   pulse, and invokes reflow on that derived pulse.
   * @return {Pulse} - The reflowed pulse instance.
   */
  reflow(n) {
    if (n) return this.fork(ALL).reflow();
    const t = this.add.length, g = this.source && this.source.length;
    return g && g !== t && (this.mod = this.source, t && this.filter(MOD$1, filter$3(this, ADD))), this;
  },
  /**
   * Get/set metadata to pulse requesting garbage collection
   * to reclaim currently unused resources.
   */
  clean(n) {
    return arguments.length ? (this.cleans = !!n, this) : this.cleans;
  },
  /**
   * Marks one or more data field names as modified to assist dependency
   * tracking and incremental processing by transform operators.
   * @param {string|Array<string>} _ - The field(s) to mark as modified.
   * @return {Pulse} - This pulse instance.
   */
  modifies(n) {
    const t = this.fields || (this.fields = {});
    return isArray$3(n) ? n.forEach((g) => t[g] = !0) : t[n] = !0, this;
  },
  /**
   * Checks if one or more data fields have been modified during this pulse
   * propagation timestamp.
   * @param {string|Array<string>} _ - The field(s) to check for modified.
   * @param {boolean} nomod - If true, will check the modified flag even if
   *   no mod tuples exist. If false (default), mod tuples must be present.
   * @return {boolean} - Returns true if any of the provided fields has been
   *   marked as modified, false otherwise.
   */
  modified(n, t) {
    const g = this.fields;
    return (t || this.mod.length) && g ? arguments.length ? isArray$3(n) ? n.some((d) => g[d]) : g[n] : !!g : !1;
  },
  /**
   * Adds a filter function to one more tuple sets. Filters are applied to
   * backing tuple arrays, to determine the actual set of tuples considered
   * added, removed or modified. They can be used to delay materialization of
   * a tuple set in order to avoid expensive array copies. In addition, the
   * filter functions can serve as value transformers: unlike standard predicate
   * function (which return boolean values), Pulse filters should return the
   * actual tuple value to process. If a tuple set is already filtered, the
   * new filter function will be appended into a conjuntive ('and') query.
   * @param {number} flags - Flags indicating the tuple set(s) to filter.
   * @param {function(*):object} filter - Filter function that will be applied
   *   to the tuple set array, and should return a data tuple if the value
   *   should be included in the tuple set, and falsy (or null) otherwise.
   * @return {Pulse} - Returns this pulse instance.
   */
  filter(n, t) {
    const g = this;
    return n & ADD && (g.addF = addFilter(g.addF, t)), n & REM && (g.remF = addFilter(g.remF, t)), n & MOD$1 && (g.modF = addFilter(g.modF, t)), n & SOURCE && (g.srcF = addFilter(g.srcF, t)), g;
  },
  /**
   * Materialize one or more tuple sets in this pulse. If the tuple set(s) have
   * a registered filter function, it will be applied and the tuple set(s) will
   * be replaced with materialized tuple arrays.
   * @param {number} flags - Flags indicating the tuple set(s) to materialize.
   * @return {Pulse} - Returns this pulse instance.
   */
  materialize(n) {
    n = n || ALL;
    const t = this;
    return n & ADD && t.addF && (t.add = materialize(t.add, t.addF), t.addF = null), n & REM && t.remF && (t.rem = materialize(t.rem, t.remF), t.remF = null), n & MOD$1 && t.modF && (t.mod = materialize(t.mod, t.modF), t.modF = null), n & SOURCE && t.srcF && (t.source = t.source.filter(t.srcF), t.srcF = null), t;
  },
  /**
   * Visit one or more tuple sets in this pulse.
   * @param {number} flags - Flags indicating the tuple set(s) to visit.
   *   Legal values are ADD, REM, MOD and SOURCE (if a backing data source
   *   has been set).
   * @param {function(object):*} - Visitor function invoked per-tuple.
   * @return {Pulse} - Returns this pulse instance.
   */
  visit(n, t) {
    const g = this, d = t;
    if (n & SOURCE)
      return visitArray(g.source, g.srcF, d), g;
    n & ADD && visitArray(g.add, g.addF, d), n & REM && visitArray(g.rem, g.remF, d), n & MOD$1 && visitArray(g.mod, g.modF, d);
    const k = g.source;
    if (n & REFLOW && k) {
      const H = g.add.length + g.mod.length;
      H === k.length || (H ? visitArray(k, filter$3(g, ADD_MOD), d) : visitArray(k, g.srcF, d));
    }
    return g;
  }
};
function MultiPulse(n, t, g, d) {
  const k = this;
  let H = 0;
  this.dataflow = n, this.stamp = t, this.fields = null, this.encode = d || null, this.pulses = g;
  for (const AA of g)
    if (AA.stamp === t) {
      if (AA.fields) {
        const gA = k.fields || (k.fields = {});
        for (const IA in AA.fields)
          gA[IA] = 1;
      }
      AA.changed(k.ADD) && (H |= k.ADD), AA.changed(k.REM) && (H |= k.REM), AA.changed(k.MOD) && (H |= k.MOD);
    }
  this.changes = H;
}
inherits$1(MultiPulse, Pulse, {
  /**
   * Creates a new pulse based on the values of this pulse.
   * The dataflow, time stamp and field modification values are copied over.
   * @return {Pulse}
   */
  fork(n) {
    const t = new Pulse(this.dataflow).init(this, n & this.NO_FIELDS);
    return n !== void 0 && (n & t.ADD && this.visit(t.ADD, (g) => t.add.push(g)), n & t.REM && this.visit(t.REM, (g) => t.rem.push(g)), n & t.MOD && this.visit(t.MOD, (g) => t.mod.push(g))), t;
  },
  changed(n) {
    return this.changes & n;
  },
  modified(n) {
    const t = this, g = t.fields;
    return g && t.changes & t.MOD ? isArray$3(n) ? n.some((d) => g[d]) : g[n] : 0;
  },
  filter() {
    error$3("MultiPulse does not support filtering.");
  },
  materialize() {
    error$3("MultiPulse does not support materialization.");
  },
  visit(n, t) {
    const g = this, d = g.pulses, k = d.length;
    let H = 0;
    if (n & g.SOURCE)
      for (; H < k; ++H)
        d[H].visit(n, t);
    else
      for (; H < k; ++H)
        d[H].stamp === g.stamp && d[H].visit(n, t);
    return g;
  }
});
async function evaluate(n, t, g) {
  const d = this, k = [];
  if (d._pulse) return reentrant(d);
  if (d._pending && await d._pending, t && await asyncCallback(d, t), !d._touched.length)
    return d.debug("Dataflow invoked, but nothing to do."), d;
  const H = ++d._clock;
  d._pulse = new Pulse(d, H, n), d._touched.forEach((BA) => d._enqueue(BA, !0)), d._touched = UniqueList(id);
  let AA = 0, gA, IA, CA;
  try {
    for (; d._heap.size() > 0; ) {
      if (gA = d._heap.pop(), gA.rank !== gA.qrank) {
        d._enqueue(gA, !0);
        continue;
      }
      IA = gA.run(d._getPulse(gA, n)), IA.then ? IA = await IA : IA.async && (k.push(IA.async), IA = StopPropagation), IA !== StopPropagation && gA._targets && gA._targets.forEach((BA) => d._enqueue(BA)), ++AA;
    }
  } catch (BA) {
    d._heap.clear(), CA = BA;
  }
  if (d._input = {}, d._pulse = null, d.debug(`Pulse ${H}: ${AA} operators`), CA && (d._postrun = [], d.error(CA)), d._postrun.length) {
    const BA = d._postrun.sort((eA, iA) => iA.priority - eA.priority);
    d._postrun = [];
    for (let eA = 0; eA < BA.length; ++eA)
      await asyncCallback(d, BA[eA].callback);
  }
  return g && await asyncCallback(d, g), k.length && Promise.all(k).then((BA) => d.runAsync(null, () => {
    BA.forEach((eA) => {
      try {
        eA(d);
      } catch (iA) {
        d.error(iA);
      }
    });
  })), d;
}
async function runAsync(n, t, g) {
  for (; this._running; ) await this._running;
  const d = () => this._running = null;
  return (this._running = this.evaluate(n, t, g)).then(d, d), this._running;
}
function run(n, t, g) {
  return this._pulse ? reentrant(this) : (this.evaluate(n, t, g), this);
}
function runAfter(n, t, g) {
  if (this._pulse || t)
    this._postrun.push({
      priority: g || 0,
      callback: n
    });
  else
    try {
      n(this);
    } catch (d) {
      this.error(d);
    }
}
function reentrant(n) {
  return n.error("Dataflow already running. Use runAsync() to chain invocations."), n;
}
function enqueue(n, t) {
  const g = n.stamp < this._clock;
  g && (n.stamp = this._clock), (g || t) && (n.qrank = n.rank, this._heap.push(n));
}
function getPulse(n, t) {
  const g = n.source, d = this._clock;
  return g && isArray$3(g) ? new MultiPulse(this, d, g.map((k) => k.pulse), t) : this._input[n.id] || singlePulse(this._pulse, g && g.pulse);
}
function singlePulse(n, t) {
  return t && t.stamp === n.stamp ? t : (n = n.fork(), t && t !== StopPropagation && (n.source = t.source), n);
}
const NO_OPT = {
  skip: !1,
  force: !1
};
function touch(n, t) {
  const g = t || NO_OPT;
  return this._pulse ? this._enqueue(n) : this._touched.add(n), g.skip && n.skip(!0), this;
}
function update$6(n, t, g) {
  const d = g || NO_OPT;
  return (n.set(t) || d.force) && this.touch(n, d), this;
}
function pulse(n, t, g) {
  this.touch(n, g || NO_OPT);
  const d = new Pulse(this, this._clock + (this._pulse ? 0 : 1)), k = n.pulse && n.pulse.source || [];
  return d.target = n, this._input[n.id] = t.pulse(d, k), this;
}
function Heap(n) {
  let t = [];
  return {
    clear: () => t = [],
    size: () => t.length,
    peek: () => t[0],
    push: (g) => (t.push(g), siftdown(t, 0, t.length - 1, n)),
    pop: () => {
      const g = t.pop();
      let d;
      return t.length ? (d = t[0], t[0] = g, siftup(t, 0, n)) : d = g, d;
    }
  };
}
function siftdown(n, t, g, d) {
  let k, H;
  const AA = n[g];
  for (; g > t; ) {
    if (H = g - 1 >> 1, k = n[H], d(AA, k) < 0) {
      n[g] = k, g = H;
      continue;
    }
    break;
  }
  return n[g] = AA;
}
function siftup(n, t, g) {
  const d = t, k = n.length, H = n[t];
  let AA = (t << 1) + 1, gA;
  for (; AA < k; )
    gA = AA + 1, gA < k && g(n[AA], n[gA]) >= 0 && (AA = gA), n[t] = n[AA], t = AA, AA = (t << 1) + 1;
  return n[t] = H, siftdown(n, d, t, g);
}
function Dataflow() {
  this.logger(logger$1()), this.logLevel(Error$1$1), this._clock = 0, this._rank = 0, this._locale = defaultLocale();
  try {
    this._loader = loader();
  } catch {
  }
  this._touched = UniqueList(id), this._input = {}, this._pulse = null, this._heap = Heap((n, t) => n.qrank - t.qrank), this._postrun = [];
}
function logMethod(n) {
  return function() {
    return this._log[n].apply(this, arguments);
  };
}
Dataflow.prototype = {
  /**
   * The current timestamp of this dataflow. This value reflects the
   * timestamp of the previous dataflow run. The dataflow is initialized
   * with a stamp value of 0. The initial run of the dataflow will have
   * a timestap of 1, and so on. This value will match the
   * {@link Pulse.stamp} property.
   * @return {number} - The current timestamp value.
   */
  stamp() {
    return this._clock;
  },
  /**
   * Gets or sets the loader instance to use for data file loading. A
   * loader object must provide a "load" method for loading files and a
   * "sanitize" method for checking URL/filename validity. Both methods
   * should accept a URI and options hash as arguments, and return a Promise
   * that resolves to the loaded file contents (load) or a hash containing
   * sanitized URI data with the sanitized url assigned to the "href" property
   * (sanitize).
   * @param {object} _ - The loader instance to use.
   * @return {object|Dataflow} - If no arguments are provided, returns
   *   the current loader instance. Otherwise returns this Dataflow instance.
   */
  loader(n) {
    return arguments.length ? (this._loader = n, this) : this._loader;
  },
  /**
   * Gets or sets the locale instance to use for formatting and parsing
   * string values. The locale object should be provided by the
   * vega-format library, and include methods such as format, timeFormat,
   * utcFormat, timeParse, and utcParse.
   * @param {object} _ - The locale instance to use.
   * @return {object|Dataflow} - If no arguments are provided, returns
   *   the current locale instance. Otherwise returns this Dataflow instance.
   */
  locale(n) {
    return arguments.length ? (this._locale = n, this) : this._locale;
  },
  /**
   * Get or set the logger instance used to log messages. If no arguments are
   * provided, returns the current logger instance. Otherwise, sets the logger
   * and return this Dataflow instance. Provided loggers must support the full
   * API of logger objects generated by the vega-util logger method. Note that
   * by default the log level of the new logger will be used; use the logLevel
   * method to adjust the log level as needed.
   */
  logger(n) {
    return arguments.length ? (this._log = n, this) : this._log;
  },
  /**
   * Logs an error message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit error messages.
   */
  error: logMethod("error"),
  /**
   * Logs a warning message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit warning messages.
   */
  warn: logMethod("warn"),
  /**
   * Logs a information message. By default, logged messages are written to
   * console output. The message will only be logged if the current log level is
   * high enough to permit information messages.
   */
  info: logMethod("info"),
  /**
   * Logs a debug message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit debug messages.
   */
  debug: logMethod("debug"),
  /**
   * Get or set the current log level. If an argument is provided, it
   * will be used as the new log level.
   * @param {number} [level] - Should be one of None, Warn, Info
   * @return {number} - The current log level.
   */
  logLevel: logMethod("level"),
  /**
   * Empty entry threshold for garbage cleaning. Map data structures will
   * perform cleaning once the number of empty entries exceeds this value.
   */
  cleanThreshold: 1e4,
  // OPERATOR REGISTRATION
  add: add$4,
  connect,
  rank,
  rerank,
  // OPERATOR UPDATES
  pulse,
  touch,
  update: update$6,
  changeset,
  // DATA LOADING
  ingest,
  parse: parse$5,
  preload,
  request,
  // EVENT HANDLING
  events: events$1,
  on,
  // PULSE PROPAGATION
  evaluate,
  run,
  runAsync,
  runAfter,
  _enqueue: enqueue,
  _getPulse: getPulse
};
function Transform(n, t) {
  Operator.call(this, n, null, t);
}
inherits$1(Transform, Operator, {
  /**
   * Overrides {@link Operator.evaluate} for transform operators.
   * Internally, this method calls {@link evaluate} to perform processing.
   * If {@link evaluate} returns a falsy value, the input pulse is returned.
   * This method should NOT be overridden, instead overrride {@link evaluate}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return the output pulse for this operator (or StopPropagation)
   */
  run(n) {
    if (n.stamp < this.stamp) return n.StopPropagation;
    let t;
    return this.skip() ? this.skip(!1) : t = this.evaluate(n), t = t || n, t.then ? t = t.then((g) => this.pulse = g) : t !== n.StopPropagation && (this.pulse = t), t;
  },
  /**
   * Overrides {@link Operator.evaluate} for transform operators.
   * Marshalls parameter values and then invokes {@link transform}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return {Pulse} The output pulse (or StopPropagation). A falsy return
       value (including undefined) will let the input pulse pass through.
  */
  evaluate(n) {
    const t = this.marshall(n.stamp), g = this.transform(t, n);
    return t.clear(), g;
  },
  /**
   * Process incoming pulses.
   * Subclasses should override this method to implement transforms.
   * @param {Parameters} _ - The operator parameter values.
   * @param {Pulse} pulse - The current dataflow pulse.
   * @return {Pulse} The output pulse (or StopPropagation). A falsy return
   *   value (including undefined) will let the input pulse pass through.
   */
  transform() {
  }
});
const transforms = {};
function definition$1(n) {
  const t = transform$2(n);
  return t && t.Definition || null;
}
function transform$2(n) {
  return n = n && n.toLowerCase(), has$2(transforms, n) ? transforms[n] : null;
}
function* numbers$1(n, t) {
  if (t == null)
    for (let g of n)
      g != null && g !== "" && (g = +g) >= g && (yield g);
  else {
    let g = -1;
    for (let d of n)
      d = t(d, ++g, n), d != null && d !== "" && (d = +d) >= d && (yield d);
  }
}
function quantiles(n, t, g) {
  const d = Float64Array.from(numbers$1(n, g));
  return d.sort(ascending$1), t.map((k) => quantileSorted(d, k));
}
function quartiles(n, t) {
  return quantiles(n, [0.25, 0.5, 0.75], t);
}
function estimateBandwidth(n, t) {
  const g = n.length, d = deviation(n, t), k = quartiles(n, t), H = (k[2] - k[0]) / 1.34;
  return 1.06 * (Math.min(d, H) || d || Math.abs(k[0]) || 1) * Math.pow(g, -0.2);
}
function bin(n) {
  const t = n.maxbins || 20, g = n.base || 10, d = Math.log(g), k = n.divide || [5, 2];
  let H = n.extent[0], AA = n.extent[1], gA, IA, CA, BA, eA, iA;
  const QA = n.span || AA - H || Math.abs(H) || 1;
  if (n.step)
    gA = n.step;
  else if (n.steps) {
    for (BA = QA / t, eA = 0, iA = n.steps.length; eA < iA && n.steps[eA] < BA; ++eA) ;
    gA = n.steps[Math.max(0, eA - 1)];
  } else {
    for (IA = Math.ceil(Math.log(t) / d), CA = n.minstep || 0, gA = Math.max(CA, Math.pow(g, Math.round(Math.log(QA) / d) - IA)); Math.ceil(QA / gA) > t; )
      gA *= g;
    for (eA = 0, iA = k.length; eA < iA; ++eA)
      BA = gA / k[eA], BA >= CA && QA / BA <= t && (gA = BA);
  }
  BA = Math.log(gA);
  const tA = BA >= 0 ? 0 : ~~(-BA / d) + 1, oA = Math.pow(g, -tA - 1);
  return (n.nice || n.nice === void 0) && (BA = Math.floor(H / gA + oA) * gA, H = H < BA ? BA - gA : BA, AA = Math.ceil(AA / gA) * gA), {
    start: H,
    stop: AA === H ? H + gA : AA,
    step: gA
  };
}
var random = Math.random;
function setRandom(n) {
  random = n;
}
function bootstrapCI(n, t, g, d) {
  if (!n.length) return [void 0, void 0];
  const k = Float64Array.from(numbers$1(n, d)), H = k.length, AA = t;
  let gA, IA, CA, BA;
  for (CA = 0, BA = Array(AA); CA < AA; ++CA) {
    for (gA = 0, IA = 0; IA < H; ++IA)
      gA += k[~~(random() * H)];
    BA[CA] = gA / H;
  }
  return BA.sort(ascending$1), [quantile$1(BA, g / 2), quantile$1(BA, 1 - g / 2)];
}
function dotbin(n, t, g, d) {
  d = d || ((iA) => iA);
  const k = n.length, H = new Float64Array(k);
  let AA = 0, gA = 1, IA = d(n[0]), CA = IA, BA = IA + t, eA;
  for (; gA < k; ++gA) {
    if (eA = d(n[gA]), eA >= BA) {
      for (CA = (IA + CA) / 2; AA < gA; ++AA) H[AA] = CA;
      BA = eA + t, IA = eA;
    }
    CA = eA;
  }
  for (CA = (IA + CA) / 2; AA < gA; ++AA) H[AA] = CA;
  return g ? smoothing(H, t + t / 4) : H;
}
function smoothing(n, t) {
  const g = n.length;
  let d = 0, k = 1, H, AA;
  for (; n[d] === n[k]; ) ++k;
  for (; k < g; ) {
    for (H = k + 1; n[k] === n[H]; ) ++H;
    if (n[k] - n[k - 1] < t) {
      for (AA = k + (d + H - k - k >> 1); AA < k; ) n[AA++] = n[k];
      for (; AA > k; ) n[AA--] = n[d];
    }
    d = k, k = H;
  }
  return n;
}
function lcg$2(n) {
  return function() {
    return n = (1103515245 * n + 12345) % 2147483647, n / 2147483647;
  };
}
function integer(n, t) {
  t == null && (t = n, n = 0);
  let g, d, k;
  const H = {
    min(AA) {
      return arguments.length ? (g = AA || 0, k = d - g, H) : g;
    },
    max(AA) {
      return arguments.length ? (d = AA || 0, k = d - g, H) : d;
    },
    sample() {
      return g + Math.floor(k * random());
    },
    pdf(AA) {
      return AA === Math.floor(AA) && AA >= g && AA < d ? 1 / k : 0;
    },
    cdf(AA) {
      const gA = Math.floor(AA);
      return gA < g ? 0 : gA >= d ? 1 : (gA - g + 1) / k;
    },
    icdf(AA) {
      return AA >= 0 && AA <= 1 ? g - 1 + Math.floor(AA * k) : NaN;
    }
  };
  return H.min(n).max(t);
}
const SQRT2PI = Math.sqrt(2 * Math.PI), SQRT2 = Math.SQRT2;
let nextSample = NaN;
function sampleNormal(n, t) {
  n = n || 0, t = t ?? 1;
  let g = 0, d = 0, k, H;
  if (nextSample === nextSample)
    g = nextSample, nextSample = NaN;
  else {
    do
      g = random() * 2 - 1, d = random() * 2 - 1, k = g * g + d * d;
    while (k === 0 || k > 1);
    H = Math.sqrt(-2 * Math.log(k) / k), g *= H, nextSample = d * H;
  }
  return n + g * t;
}
function densityNormal(n, t, g) {
  g = g ?? 1;
  const d = (n - (t || 0)) / g;
  return Math.exp(-0.5 * d * d) / (g * SQRT2PI);
}
function cumulativeNormal(n, t, g) {
  t = t || 0, g = g ?? 1;
  const d = (n - t) / g, k = Math.abs(d);
  let H;
  if (k > 37)
    H = 0;
  else {
    const AA = Math.exp(-k * k / 2);
    let gA;
    k < 7.07106781186547 ? (gA = 0.0352624965998911 * k + 0.700383064443688, gA = gA * k + 6.37396220353165, gA = gA * k + 33.912866078383, gA = gA * k + 112.079291497871, gA = gA * k + 221.213596169931, gA = gA * k + 220.206867912376, H = AA * gA, gA = 0.0883883476483184 * k + 1.75566716318264, gA = gA * k + 16.064177579207, gA = gA * k + 86.7807322029461, gA = gA * k + 296.564248779674, gA = gA * k + 637.333633378831, gA = gA * k + 793.826512519948, gA = gA * k + 440.413735824752, H = H / gA) : (gA = k + 0.65, gA = k + 4 / gA, gA = k + 3 / gA, gA = k + 2 / gA, gA = k + 1 / gA, H = AA / gA / 2.506628274631);
  }
  return d > 0 ? 1 - H : H;
}
function quantileNormal(n, t, g) {
  return n < 0 || n > 1 ? NaN : (t || 0) + (g ?? 1) * SQRT2 * erfinv(2 * n - 1);
}
function erfinv(n) {
  let t = -Math.log((1 - n) * (1 + n)), g;
  return t < 6.25 ? (t -= 3.125, g = -364441206401782e-35, g = -16850591381820166e-35 + g * t, g = 128584807152564e-32 + g * t, g = 11157877678025181e-33 + g * t, g = -1333171662854621e-31 + g * t, g = 20972767875968562e-33 + g * t, g = 6637638134358324e-30 + g * t, g = -4054566272975207e-29 + g * t, g = -8151934197605472e-29 + g * t, g = 26335093153082323e-28 + g * t, g = -12975133253453532e-27 + g * t, g = -5415412054294628e-26 + g * t, g = 10512122733215323e-25 + g * t, g = -4112633980346984e-24 + g * t, g = -29070369957882005e-24 + g * t, g = 42347877827932404e-23 + g * t, g = -13654692000834679e-22 + g * t, g = -13882523362786469e-21 + g * t, g = 18673420803405714e-20 + g * t, g = -740702534166267e-18 + g * t, g = -0.006033670871430149 + g * t, g = 0.24015818242558962 + g * t, g = 1.6536545626831027 + g * t) : t < 16 ? (t = Math.sqrt(t) - 3.25, g = 22137376921775787e-25, g = 9075656193888539e-23 + g * t, g = -27517406297064545e-23 + g * t, g = 18239629214389228e-24 + g * t, g = 15027403968909828e-22 + g * t, g = -4013867526981546e-21 + g * t, g = 29234449089955446e-22 + g * t, g = 12475304481671779e-21 + g * t, g = -47318229009055734e-21 + g * t, g = 6828485145957318e-20 + g * t, g = 24031110387097894e-21 + g * t, g = -3550375203628475e-19 + g * t, g = 9532893797373805e-19 + g * t, g = -0.0016882755560235047 + g * t, g = 0.002491442096107851 + g * t, g = -0.003751208507569241 + g * t, g = 0.005370914553590064 + g * t, g = 1.0052589676941592 + g * t, g = 3.0838856104922208 + g * t) : Number.isFinite(t) ? (t = Math.sqrt(t) - 5, g = -27109920616438573e-27, g = -2555641816996525e-25 + g * t, g = 15076572693500548e-25 + g * t, g = -3789465440126737e-24 + g * t, g = 761570120807834e-23 + g * t, g = -1496002662714924e-23 + g * t, g = 2914795345090108e-23 + g * t, g = -6771199775845234e-23 + g * t, g = 22900482228026655e-23 + g * t, g = -99298272942317e-20 + g * t, g = 4526062597223154e-21 + g * t, g = -1968177810553167e-20 + g * t, g = 7599527703001776e-20 + g * t, g = -21503011930044477e-20 + g * t, g = -13871931833623122e-20 + g * t, g = 1.0103004648645344 + g * t, g = 4.849906401408584 + g * t) : g = 1 / 0, g * n;
}
function gaussian(n, t) {
  let g, d;
  const k = {
    mean(H) {
      return arguments.length ? (g = H || 0, k) : g;
    },
    stdev(H) {
      return arguments.length ? (d = H ?? 1, k) : d;
    },
    sample: () => sampleNormal(g, d),
    pdf: (H) => densityNormal(H, g, d),
    cdf: (H) => cumulativeNormal(H, g, d),
    icdf: (H) => quantileNormal(H, g, d)
  };
  return k.mean(n).stdev(t);
}
function kde(n, t) {
  const g = gaussian();
  let d = 0;
  const k = {
    data(H) {
      return arguments.length ? (n = H, d = H ? H.length : 0, k.bandwidth(t)) : n;
    },
    bandwidth(H) {
      return arguments.length ? (t = H, !t && n && (t = estimateBandwidth(n)), k) : t;
    },
    sample() {
      return n[~~(random() * d)] + t * g.sample();
    },
    pdf(H) {
      let AA = 0, gA = 0;
      for (; gA < d; ++gA)
        AA += g.pdf((H - n[gA]) / t);
      return AA / t / d;
    },
    cdf(H) {
      let AA = 0, gA = 0;
      for (; gA < d; ++gA)
        AA += g.cdf((H - n[gA]) / t);
      return AA / d;
    },
    icdf() {
      throw Error("KDE icdf not supported.");
    }
  };
  return k.data(n);
}
function sampleLogNormal(n, t) {
  return n = n || 0, t = t ?? 1, Math.exp(n + sampleNormal() * t);
}
function densityLogNormal(n, t, g) {
  if (n <= 0) return 0;
  t = t || 0, g = g ?? 1;
  const d = (Math.log(n) - t) / g;
  return Math.exp(-0.5 * d * d) / (g * SQRT2PI * n);
}
function cumulativeLogNormal(n, t, g) {
  return cumulativeNormal(Math.log(n), t, g);
}
function quantileLogNormal(n, t, g) {
  return Math.exp(quantileNormal(n, t, g));
}
function lognormal(n, t) {
  let g, d;
  const k = {
    mean(H) {
      return arguments.length ? (g = H || 0, k) : g;
    },
    stdev(H) {
      return arguments.length ? (d = H ?? 1, k) : d;
    },
    sample: () => sampleLogNormal(g, d),
    pdf: (H) => densityLogNormal(H, g, d),
    cdf: (H) => cumulativeLogNormal(H, g, d),
    icdf: (H) => quantileLogNormal(H, g, d)
  };
  return k.mean(n).stdev(t);
}
function mixture$1(n, t) {
  let g = 0, d;
  function k(AA) {
    const gA = [];
    let IA = 0, CA;
    for (CA = 0; CA < g; ++CA)
      IA += gA[CA] = AA[CA] == null ? 1 : +AA[CA];
    for (CA = 0; CA < g; ++CA)
      gA[CA] /= IA;
    return gA;
  }
  const H = {
    weights(AA) {
      return arguments.length ? (d = k(t = AA || []), H) : t;
    },
    distributions(AA) {
      return arguments.length ? (AA ? (g = AA.length, n = AA) : (g = 0, n = []), H.weights(t)) : n;
    },
    sample() {
      const AA = random();
      let gA = n[g - 1], IA = d[0], CA = 0;
      for (; CA < g - 1; IA += d[++CA])
        if (AA < IA) {
          gA = n[CA];
          break;
        }
      return gA.sample();
    },
    pdf(AA) {
      let gA = 0, IA = 0;
      for (; IA < g; ++IA)
        gA += d[IA] * n[IA].pdf(AA);
      return gA;
    },
    cdf(AA) {
      let gA = 0, IA = 0;
      for (; IA < g; ++IA)
        gA += d[IA] * n[IA].cdf(AA);
      return gA;
    },
    icdf() {
      throw Error("Mixture icdf not supported.");
    }
  };
  return H.distributions(n).weights(t);
}
function sampleUniform(n, t) {
  return t == null && (t = n ?? 1, n = 0), n + (t - n) * random();
}
function densityUniform(n, t, g) {
  return g == null && (g = t ?? 1, t = 0), n >= t && n <= g ? 1 / (g - t) : 0;
}
function cumulativeUniform(n, t, g) {
  return g == null && (g = t ?? 1, t = 0), n < t ? 0 : n > g ? 1 : (n - t) / (g - t);
}
function quantileUniform(n, t, g) {
  return g == null && (g = t ?? 1, t = 0), n >= 0 && n <= 1 ? t + n * (g - t) : NaN;
}
function uniform(n, t) {
  let g, d;
  const k = {
    min(H) {
      return arguments.length ? (g = H || 0, k) : g;
    },
    max(H) {
      return arguments.length ? (d = H ?? 1, k) : d;
    },
    sample: () => sampleUniform(g, d),
    pdf: (H) => densityUniform(H, g, d),
    cdf: (H) => cumulativeUniform(H, g, d),
    icdf: (H) => quantileUniform(H, g, d)
  };
  return t == null && (t = n ?? 1, n = 0), k.min(n).max(t);
}
function constant$5(n, t, g) {
  let d = 0, k = 0;
  for (const H of n) {
    const AA = g(H);
    t(H) == null || AA == null || isNaN(AA) || (d += (AA - d) / ++k);
  }
  return {
    coef: [d],
    predict: () => d,
    rSquared: 0
  };
}
function ols(n, t, g, d) {
  const k = d - n * n, H = Math.abs(k) < 1e-24 ? 0 : (g - n * t) / k;
  return [t - H * n, H];
}
function points(n, t, g, d) {
  n = n.filter((QA) => {
    let tA = t(QA), oA = g(QA);
    return tA != null && (tA = +tA) >= tA && oA != null && (oA = +oA) >= oA;
  }), d && n.sort((QA, tA) => t(QA) - t(tA));
  const k = n.length, H = new Float64Array(k), AA = new Float64Array(k);
  let gA = 0, IA = 0, CA = 0, BA, eA, iA;
  for (iA of n)
    H[gA] = BA = +t(iA), AA[gA] = eA = +g(iA), ++gA, IA += (BA - IA) / gA, CA += (eA - CA) / gA;
  for (gA = 0; gA < k; ++gA)
    H[gA] -= IA, AA[gA] -= CA;
  return [H, AA, IA, CA];
}
function visitPoints(n, t, g, d) {
  let k = -1, H, AA;
  for (const gA of n)
    H = t(gA), AA = g(gA), H != null && (H = +H) >= H && AA != null && (AA = +AA) >= AA && d(H, AA, ++k);
}
function rSquared(n, t, g, d, k) {
  let H = 0, AA = 0;
  return visitPoints(n, t, g, (gA, IA) => {
    const CA = IA - k(gA), BA = IA - d;
    H += CA * CA, AA += BA * BA;
  }), 1 - H / AA;
}
function linear$2(n, t, g) {
  let d = 0, k = 0, H = 0, AA = 0, gA = 0;
  visitPoints(n, t, g, (BA, eA) => {
    ++gA, d += (BA - d) / gA, k += (eA - k) / gA, H += (BA * eA - H) / gA, AA += (BA * BA - AA) / gA;
  });
  const IA = ols(d, k, H, AA), CA = (BA) => IA[0] + IA[1] * BA;
  return {
    coef: IA,
    predict: CA,
    rSquared: rSquared(n, t, g, k, CA)
  };
}
function log$4(n, t, g) {
  let d = 0, k = 0, H = 0, AA = 0, gA = 0;
  visitPoints(n, t, g, (BA, eA) => {
    ++gA, BA = Math.log(BA), d += (BA - d) / gA, k += (eA - k) / gA, H += (BA * eA - H) / gA, AA += (BA * BA - AA) / gA;
  });
  const IA = ols(d, k, H, AA), CA = (BA) => IA[0] + IA[1] * Math.log(BA);
  return {
    coef: IA,
    predict: CA,
    rSquared: rSquared(n, t, g, k, CA)
  };
}
function exp$1(n, t, g) {
  const [d, k, H, AA] = points(n, t, g);
  let gA = 0, IA = 0, CA = 0, BA = 0, eA = 0, iA, QA, tA;
  visitPoints(n, t, g, (nA, lA) => {
    iA = d[eA++], QA = Math.log(lA), tA = iA * lA, gA += (lA * QA - gA) / eA, IA += (tA - IA) / eA, CA += (tA * QA - CA) / eA, BA += (iA * tA - BA) / eA;
  });
  const [oA, EA] = ols(IA / AA, gA / AA, CA / AA, BA / AA), aA = (nA) => Math.exp(oA + EA * (nA - H));
  return {
    coef: [Math.exp(oA - EA * H), EA],
    predict: aA,
    rSquared: rSquared(n, t, g, AA, aA)
  };
}
function pow$3(n, t, g) {
  let d = 0, k = 0, H = 0, AA = 0, gA = 0, IA = 0;
  visitPoints(n, t, g, (eA, iA) => {
    const QA = Math.log(eA), tA = Math.log(iA);
    ++IA, d += (QA - d) / IA, k += (tA - k) / IA, H += (QA * tA - H) / IA, AA += (QA * QA - AA) / IA, gA += (iA - gA) / IA;
  });
  const CA = ols(d, k, H, AA), BA = (eA) => CA[0] * Math.pow(eA, CA[1]);
  return CA[0] = Math.exp(CA[0]), {
    coef: CA,
    predict: BA,
    rSquared: rSquared(n, t, g, gA, BA)
  };
}
function quad(n, t, g) {
  const [d, k, H, AA] = points(n, t, g), gA = d.length;
  let IA = 0, CA = 0, BA = 0, eA = 0, iA = 0, QA, tA, oA, EA;
  for (QA = 0; QA < gA; )
    tA = d[QA], oA = k[QA++], EA = tA * tA, IA += (EA - IA) / QA, CA += (EA * tA - CA) / QA, BA += (EA * EA - BA) / QA, eA += (tA * oA - eA) / QA, iA += (EA * oA - iA) / QA;
  const aA = BA - IA * IA, nA = IA * aA - CA * CA, lA = (iA * IA - eA * CA) / nA, cA = (eA * aA - iA * CA) / nA, sA = -lA * IA, rA = (uA) => (uA = uA - H, lA * uA * uA + cA * uA + sA + AA);
  return {
    coef: [sA - cA * H + lA * H * H + AA, cA - 2 * lA * H, lA],
    predict: rA,
    rSquared: rSquared(n, t, g, AA, rA)
  };
}
function poly(n, t, g, d) {
  if (d === 0) return constant$5(n, t, g);
  if (d === 1) return linear$2(n, t, g);
  if (d === 2) return quad(n, t, g);
  const [k, H, AA, gA] = points(n, t, g), IA = k.length, CA = [], BA = [], eA = d + 1;
  let iA, QA, tA, oA, EA;
  for (iA = 0; iA < eA; ++iA) {
    for (tA = 0, oA = 0; tA < IA; ++tA)
      oA += Math.pow(k[tA], iA) * H[tA];
    for (CA.push(oA), EA = new Float64Array(eA), QA = 0; QA < eA; ++QA) {
      for (tA = 0, oA = 0; tA < IA; ++tA)
        oA += Math.pow(k[tA], iA + QA);
      EA[QA] = oA;
    }
    BA.push(EA);
  }
  BA.push(CA);
  const aA = gaussianElimination(BA), nA = (lA) => {
    lA -= AA;
    let cA = gA + aA[0] + aA[1] * lA + aA[2] * lA * lA;
    for (iA = 3; iA < eA; ++iA) cA += aA[iA] * Math.pow(lA, iA);
    return cA;
  };
  return {
    coef: uncenter(eA, aA, -AA, gA),
    predict: nA,
    rSquared: rSquared(n, t, g, gA, nA)
  };
}
function uncenter(n, t, g, d) {
  const k = Array(n);
  let H, AA, gA, IA;
  for (H = 0; H < n; ++H) k[H] = 0;
  for (H = n - 1; H >= 0; --H)
    for (gA = t[H], IA = 1, k[H] += gA, AA = 1; AA <= H; ++AA)
      IA *= (H + 1 - AA) / AA, k[H - AA] += gA * Math.pow(g, AA) * IA;
  return k[0] += d, k;
}
function gaussianElimination(n) {
  const t = n.length - 1, g = [];
  let d, k, H, AA, gA;
  for (d = 0; d < t; ++d) {
    for (AA = d, k = d + 1; k < t; ++k)
      Math.abs(n[d][k]) > Math.abs(n[d][AA]) && (AA = k);
    for (H = d; H < t + 1; ++H)
      gA = n[H][d], n[H][d] = n[H][AA], n[H][AA] = gA;
    for (k = d + 1; k < t; ++k)
      for (H = t; H >= d; H--)
        n[H][k] -= n[H][d] * n[d][k] / n[d][d];
  }
  for (k = t - 1; k >= 0; --k) {
    for (gA = 0, H = k + 1; H < t; ++H)
      gA += n[H][k] * g[H];
    g[k] = (n[t][k] - gA) / n[k][k];
  }
  return g;
}
const maxiters = 2, epsilon$6 = 1e-12;
function loess(n, t, g, d) {
  const [k, H, AA, gA] = points(n, t, g, !0), IA = k.length, CA = Math.max(2, ~~(d * IA)), BA = new Float64Array(IA), eA = new Float64Array(IA), iA = new Float64Array(IA).fill(1);
  for (let QA = -1; ++QA <= maxiters; ) {
    const tA = [0, CA - 1];
    for (let EA = 0; EA < IA; ++EA) {
      const aA = k[EA], nA = tA[0], lA = tA[1], cA = aA - k[nA] > k[lA] - aA ? nA : lA;
      let sA = 0, rA = 0, uA = 0, hA = 0, dA = 0;
      const GA = 1 / Math.abs(k[cA] - aA || 1);
      for (let bA = nA; bA <= lA; ++bA) {
        const yA = k[bA], pA = H[bA], MA = tricube(Math.abs(aA - yA) * GA) * iA[bA], LA = yA * MA;
        sA += MA, rA += LA, uA += pA * MA, hA += pA * LA, dA += yA * LA;
      }
      const [DA, wA] = ols(rA / sA, uA / sA, hA / sA, dA / sA);
      BA[EA] = DA + wA * aA, eA[EA] = Math.abs(H[EA] - BA[EA]), updateInterval(k, EA + 1, tA);
    }
    if (QA === maxiters)
      break;
    const oA = median(eA);
    if (Math.abs(oA) < epsilon$6) break;
    for (let EA = 0, aA, nA; EA < IA; ++EA)
      aA = eA[EA] / (6 * oA), iA[EA] = aA >= 1 ? epsilon$6 : (nA = 1 - aA * aA) * nA;
  }
  return output$1(k, BA, AA, gA);
}
function tricube(n) {
  return (n = 1 - n * n * n) * n * n;
}
function updateInterval(n, t, g) {
  const d = n[t];
  let k = g[0], H = g[1] + 1;
  if (!(H >= n.length))
    for (; t > k && n[H] - d <= d - n[k]; )
      g[0] = ++k, g[1] = H, ++H;
}
function output$1(n, t, g, d) {
  const k = n.length, H = [];
  let AA = 0, gA = 0, IA = [], CA;
  for (; AA < k; ++AA)
    CA = n[AA] + g, IA[0] === CA ? IA[1] += (t[AA] - IA[1]) / ++gA : (gA = 0, IA[1] += d, IA = [CA, t[AA]], H.push(IA));
  return IA[1] += d, H;
}
const MIN_RADIANS = 0.5 * Math.PI / 180;
function sampleCurve(n, t, g, d) {
  g = g || 25, d = Math.max(g, d || 200);
  const k = (oA) => [oA, n(oA)], H = t[0], AA = t[1], gA = AA - H, IA = gA / d, CA = [k(H)], BA = [];
  if (g === d) {
    for (let oA = 1; oA < d; ++oA)
      CA.push(k(H + oA / g * gA));
    return CA.push(k(AA)), CA;
  } else {
    BA.push(k(AA));
    for (let oA = g; --oA > 0; )
      BA.push(k(H + oA / g * gA));
  }
  let eA = CA[0], iA = BA[BA.length - 1];
  const QA = 1 / gA, tA = scaleY(eA[1], BA);
  for (; iA; ) {
    const oA = k((eA[0] + iA[0]) / 2);
    oA[0] - eA[0] >= IA && angleDelta(eA, oA, iA, QA, tA) > MIN_RADIANS ? BA.push(oA) : (eA = iA, CA.push(iA), BA.pop()), iA = BA[BA.length - 1];
  }
  return CA;
}
function scaleY(n, t) {
  let g = n, d = n;
  const k = t.length;
  for (let H = 0; H < k; ++H) {
    const AA = t[H][1];
    AA < g && (g = AA), AA > d && (d = AA);
  }
  return 1 / (d - g);
}
function angleDelta(n, t, g, d, k) {
  const H = Math.atan2(k * (g[1] - n[1]), d * (g[0] - n[0])), AA = Math.atan2(k * (t[1] - n[1]), d * (t[0] - n[0]));
  return Math.abs(H - AA);
}
function multikey(n) {
  return (t) => {
    const g = n.length;
    let d = 1, k = String(n[0](t));
    for (; d < g; ++d)
      k += "|" + n[d](t);
    return k;
  };
}
function groupkey(n) {
  return !n || !n.length ? function() {
    return "";
  } : n.length === 1 ? n[0] : multikey(n);
}
function measureName(n, t, g) {
  return g || n + (t ? "_" + t : "");
}
const noop$6 = () => {
}, base_op = {
  init: noop$6,
  add: noop$6,
  rem: noop$6,
  idx: 0
}, AggregateOps = {
  values: {
    init: (n) => n.cell.store = !0,
    value: (n) => n.cell.data.values(),
    idx: -1
  },
  count: {
    value: (n) => n.cell.num
  },
  __count__: {
    value: (n) => n.missing + n.valid
  },
  missing: {
    value: (n) => n.missing
  },
  valid: {
    value: (n) => n.valid
  },
  sum: {
    init: (n) => n.sum = 0,
    value: (n) => n.valid ? n.sum : void 0,
    add: (n, t) => n.sum += +t,
    rem: (n, t) => n.sum -= t
  },
  product: {
    init: (n) => n.product = 1,
    value: (n) => n.valid ? n.product : void 0,
    add: (n, t) => n.product *= t,
    rem: (n, t) => n.product /= t
  },
  mean: {
    init: (n) => n.mean = 0,
    value: (n) => n.valid ? n.mean : void 0,
    add: (n, t) => (n.mean_d = t - n.mean, n.mean += n.mean_d / n.valid),
    rem: (n, t) => (n.mean_d = t - n.mean, n.mean -= n.valid ? n.mean_d / n.valid : n.mean)
  },
  average: {
    value: (n) => n.valid ? n.mean : void 0,
    req: ["mean"],
    idx: 1
  },
  variance: {
    init: (n) => n.dev = 0,
    value: (n) => n.valid > 1 ? n.dev / (n.valid - 1) : void 0,
    add: (n, t) => n.dev += n.mean_d * (t - n.mean),
    rem: (n, t) => n.dev -= n.mean_d * (t - n.mean),
    req: ["mean"],
    idx: 1
  },
  variancep: {
    value: (n) => n.valid > 1 ? n.dev / n.valid : void 0,
    req: ["variance"],
    idx: 2
  },
  stdev: {
    value: (n) => n.valid > 1 ? Math.sqrt(n.dev / (n.valid - 1)) : void 0,
    req: ["variance"],
    idx: 2
  },
  stdevp: {
    value: (n) => n.valid > 1 ? Math.sqrt(n.dev / n.valid) : void 0,
    req: ["variance"],
    idx: 2
  },
  stderr: {
    value: (n) => n.valid > 1 ? Math.sqrt(n.dev / (n.valid * (n.valid - 1))) : void 0,
    req: ["variance"],
    idx: 2
  },
  distinct: {
    value: (n) => n.cell.data.distinct(n.get),
    req: ["values"],
    idx: 3
  },
  ci0: {
    value: (n) => n.cell.data.ci0(n.get),
    req: ["values"],
    idx: 3
  },
  ci1: {
    value: (n) => n.cell.data.ci1(n.get),
    req: ["values"],
    idx: 3
  },
  median: {
    value: (n) => n.cell.data.q2(n.get),
    req: ["values"],
    idx: 3
  },
  q1: {
    value: (n) => n.cell.data.q1(n.get),
    req: ["values"],
    idx: 3
  },
  q3: {
    value: (n) => n.cell.data.q3(n.get),
    req: ["values"],
    idx: 3
  },
  min: {
    init: (n) => n.min = void 0,
    value: (n) => n.min = Number.isNaN(n.min) ? n.cell.data.min(n.get) : n.min,
    add: (n, t) => {
      (t < n.min || n.min === void 0) && (n.min = t);
    },
    rem: (n, t) => {
      t <= n.min && (n.min = NaN);
    },
    req: ["values"],
    idx: 4
  },
  max: {
    init: (n) => n.max = void 0,
    value: (n) => n.max = Number.isNaN(n.max) ? n.cell.data.max(n.get) : n.max,
    add: (n, t) => {
      (t > n.max || n.max === void 0) && (n.max = t);
    },
    rem: (n, t) => {
      t >= n.max && (n.max = NaN);
    },
    req: ["values"],
    idx: 4
  },
  argmin: {
    init: (n) => n.argmin = void 0,
    value: (n) => n.argmin || n.cell.data.argmin(n.get),
    add: (n, t, g) => {
      t < n.min && (n.argmin = g);
    },
    rem: (n, t) => {
      t <= n.min && (n.argmin = void 0);
    },
    req: ["min", "values"],
    idx: 3
  },
  argmax: {
    init: (n) => n.argmax = void 0,
    value: (n) => n.argmax || n.cell.data.argmax(n.get),
    add: (n, t, g) => {
      t > n.max && (n.argmax = g);
    },
    rem: (n, t) => {
      t >= n.max && (n.argmax = void 0);
    },
    req: ["max", "values"],
    idx: 3
  },
  exponential: {
    init: (n, t) => {
      n.exp = 0, n.exp_r = t;
    },
    value: (n) => n.valid ? n.exp * (1 - n.exp_r) / (1 - n.exp_r ** n.valid) : void 0,
    add: (n, t) => n.exp = n.exp_r * n.exp + t,
    rem: (n, t) => n.exp = (n.exp - t / n.exp_r ** (n.valid - 1)) / n.exp_r
  },
  exponentialb: {
    value: (n) => n.valid ? n.exp * (1 - n.exp_r) : void 0,
    req: ["exponential"],
    idx: 1
  }
}, ValidAggregateOps = Object.keys(AggregateOps).filter((n) => n !== "__count__");
function measure$1(n, t) {
  return (g, d) => extend$2({
    name: n,
    aggregate_param: d,
    out: g || n
  }, base_op, t);
}
[...ValidAggregateOps, "__count__"].forEach((n) => {
  AggregateOps[n] = measure$1(n, AggregateOps[n]);
});
function createMeasure(n, t, g) {
  return AggregateOps[n](g, t);
}
function compareIndex(n, t) {
  return n.idx - t.idx;
}
function resolve(n) {
  const t = {};
  n.forEach((d) => t[d.name] = d);
  const g = (d) => {
    d.req && d.req.forEach((k) => {
      t[k] || g(t[k] = AggregateOps[k]());
    });
  };
  return n.forEach(g), Object.values(t).sort(compareIndex);
}
function init() {
  this.valid = 0, this.missing = 0, this._ops.forEach((n) => n.aggregate_param == null ? n.init(this) : n.init(this, n.aggregate_param));
}
function add$3(n, t) {
  if (n == null || n === "") {
    ++this.missing;
    return;
  }
  n === n && (++this.valid, this._ops.forEach((g) => g.add(this, n, t)));
}
function rem(n, t) {
  if (n == null || n === "") {
    --this.missing;
    return;
  }
  n === n && (--this.valid, this._ops.forEach((g) => g.rem(this, n, t)));
}
function set$4(n) {
  return this._out.forEach((t) => n[t.out] = t.value(this)), n;
}
function compileMeasures(n, t) {
  const g = t || identity$8, d = resolve(n), k = n.slice().sort(compareIndex);
  function H(AA) {
    this._ops = d, this._out = k, this.cell = AA, this.init();
  }
  return H.prototype.init = init, H.prototype.add = add$3, H.prototype.rem = rem, H.prototype.set = set$4, H.prototype.get = g, H.fields = n.map((AA) => AA.out), H;
}
function TupleStore(n) {
  this._key = n ? field$4(n) : tupleid, this.reset();
}
const prototype$1$1 = TupleStore.prototype;
prototype$1$1.reset = function() {
  this._add = [], this._rem = [], this._ext = null, this._get = null, this._q = null;
};
prototype$1$1.add = function(n) {
  this._add.push(n);
};
prototype$1$1.rem = function(n) {
  this._rem.push(n);
};
prototype$1$1.values = function() {
  if (this._get = null, this._rem.length === 0) return this._add;
  const n = this._add, t = this._rem, g = this._key, d = n.length, k = t.length, H = Array(d - k), AA = {};
  let gA, IA, CA;
  for (gA = 0; gA < k; ++gA)
    AA[g(t[gA])] = 1;
  for (gA = 0, IA = 0; gA < d; ++gA)
    AA[g(CA = n[gA])] ? AA[g(CA)] = 0 : H[IA++] = CA;
  return this._rem = [], this._add = H;
};
prototype$1$1.distinct = function(n) {
  const t = this.values(), g = {};
  let d = t.length, k = 0, H;
  for (; --d >= 0; )
    H = n(t[d]) + "", has$2(g, H) || (g[H] = 1, ++k);
  return k;
};
prototype$1$1.extent = function(n) {
  if (this._get !== n || !this._ext) {
    const t = this.values(), g = extentIndex(t, n);
    this._ext = [t[g[0]], t[g[1]]], this._get = n;
  }
  return this._ext;
};
prototype$1$1.argmin = function(n) {
  return this.extent(n)[0] || {};
};
prototype$1$1.argmax = function(n) {
  return this.extent(n)[1] || {};
};
prototype$1$1.min = function(n) {
  const t = this.extent(n)[0];
  return t != null ? n(t) : void 0;
};
prototype$1$1.max = function(n) {
  const t = this.extent(n)[1];
  return t != null ? n(t) : void 0;
};
prototype$1$1.quartile = function(n) {
  return (this._get !== n || !this._q) && (this._q = quartiles(this.values(), n), this._get = n), this._q;
};
prototype$1$1.q1 = function(n) {
  return this.quartile(n)[0];
};
prototype$1$1.q2 = function(n) {
  return this.quartile(n)[1];
};
prototype$1$1.q3 = function(n) {
  return this.quartile(n)[2];
};
prototype$1$1.ci = function(n) {
  return (this._get !== n || !this._ci) && (this._ci = bootstrapCI(this.values(), 1e3, 0.05, n), this._get = n), this._ci;
};
prototype$1$1.ci0 = function(n) {
  return this.ci(n)[0];
};
prototype$1$1.ci1 = function(n) {
  return this.ci(n)[1];
};
function Aggregate$1(n) {
  Transform.call(this, null, n), this._adds = [], this._mods = [], this._alen = 0, this._mlen = 0, this._drop = !0, this._cross = !1, this._dims = [], this._dnames = [], this._measures = [], this._countOnly = !1, this._counts = null, this._prev = null, this._inputs = null, this._outputs = null;
}
Aggregate$1.Definition = {
  type: "Aggregate",
  metadata: {
    generates: !0,
    changes: !0
  },
  params: [{
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "ops",
    type: "enum",
    array: !0,
    values: ValidAggregateOps
  }, {
    name: "aggregate_params",
    type: "number",
    null: !0,
    array: !0
  }, {
    name: "fields",
    type: "field",
    null: !0,
    array: !0
  }, {
    name: "as",
    type: "string",
    null: !0,
    array: !0
  }, {
    name: "drop",
    type: "boolean",
    default: !0
  }, {
    name: "cross",
    type: "boolean",
    default: !1
  }, {
    name: "key",
    type: "field"
  }]
};
inherits$1(Aggregate$1, Transform, {
  transform(n, t) {
    const g = this, d = t.fork(t.NO_SOURCE | t.NO_FIELDS), k = n.modified();
    return g.stamp = d.stamp, g.value && (k || t.modified(g._inputs, !0)) ? (g._prev = g.value, g.value = k ? g.init(n) : /* @__PURE__ */ Object.create(null), t.visit(t.SOURCE, (H) => g.add(H))) : (g.value = g.value || g.init(n), t.visit(t.REM, (H) => g.rem(H)), t.visit(t.ADD, (H) => g.add(H))), d.modifies(g._outputs), g._drop = n.drop !== !1, n.cross && g._dims.length > 1 && (g._drop = !1, g.cross()), t.clean() && g._drop && d.clean(!0).runAfter(() => this.clean()), g.changes(d);
  },
  cross() {
    const n = this, t = n.value, g = n._dnames, d = g.map(() => ({})), k = g.length;
    function H(gA) {
      let IA, CA, BA, eA;
      for (IA in gA)
        for (BA = gA[IA].tuple, CA = 0; CA < k; ++CA)
          d[CA][eA = BA[g[CA]]] = eA;
    }
    H(n._prev), H(t);
    function AA(gA, IA, CA) {
      const BA = g[CA], eA = d[CA++];
      for (const iA in eA) {
        const QA = gA ? gA + "|" + iA : iA;
        IA[BA] = eA[iA], CA < k ? AA(QA, IA, CA) : t[QA] || n.cell(QA, IA);
      }
    }
    AA("", {}, 0);
  },
  init(n) {
    const t = this._inputs = [], g = this._outputs = [], d = {};
    function k(nA) {
      const lA = array$6(accessorFields(nA)), cA = lA.length;
      let sA = 0, rA;
      for (; sA < cA; ++sA)
        d[rA = lA[sA]] || (d[rA] = 1, t.push(rA));
    }
    this._dims = array$6(n.groupby), this._dnames = this._dims.map((nA) => {
      const lA = accessorName(nA);
      return k(nA), g.push(lA), lA;
    }), this.cellkey = n.key ? n.key : groupkey(this._dims), this._countOnly = !0, this._counts = [], this._measures = [];
    const H = n.fields || [null], AA = n.ops || ["count"], gA = n.aggregate_params || [null], IA = n.as || [], CA = H.length, BA = {};
    let eA, iA, QA, tA, oA, EA, aA;
    for (CA !== AA.length && error$3("Unmatched number of fields and aggregate ops."), aA = 0; aA < CA; ++aA) {
      if (eA = H[aA], iA = AA[aA], QA = gA[aA] || null, eA == null && iA !== "count" && error$3("Null aggregate field specified."), oA = accessorName(eA), EA = measureName(iA, oA, IA[aA]), g.push(EA), iA === "count") {
        this._counts.push(EA);
        continue;
      }
      tA = BA[oA], tA || (k(eA), tA = BA[oA] = [], tA.field = eA, this._measures.push(tA)), iA !== "count" && (this._countOnly = !1), tA.push(createMeasure(iA, QA, EA));
    }
    return this._measures = this._measures.map((nA) => compileMeasures(nA, nA.field)), /* @__PURE__ */ Object.create(null);
  },
  // -- Cell Management -----
  cellkey: groupkey(),
  cell(n, t) {
    let g = this.value[n];
    return g ? g.num === 0 && this._drop && g.stamp < this.stamp ? (g.stamp = this.stamp, this._adds[this._alen++] = g) : g.stamp < this.stamp && (g.stamp = this.stamp, this._mods[this._mlen++] = g) : (g = this.value[n] = this.newcell(n, t), this._adds[this._alen++] = g), g;
  },
  newcell(n, t) {
    const g = {
      key: n,
      num: 0,
      agg: null,
      tuple: this.newtuple(t, this._prev && this._prev[n]),
      stamp: this.stamp,
      store: !1
    };
    if (!this._countOnly) {
      const d = this._measures, k = d.length;
      g.agg = Array(k);
      for (let H = 0; H < k; ++H)
        g.agg[H] = new d[H](g);
    }
    return g.store && (g.data = new TupleStore()), g;
  },
  newtuple(n, t) {
    const g = this._dnames, d = this._dims, k = d.length, H = {};
    for (let AA = 0; AA < k; ++AA)
      H[g[AA]] = d[AA](n);
    return t ? replace$1(t.tuple, H) : ingest$1(H);
  },
  clean() {
    const n = this.value;
    for (const t in n)
      n[t].num === 0 && delete n[t];
  },
  // -- Process Tuples -----
  add(n) {
    const t = this.cellkey(n), g = this.cell(t, n);
    if (g.num += 1, this._countOnly) return;
    g.store && g.data.add(n);
    const d = g.agg;
    for (let k = 0, H = d.length; k < H; ++k)
      d[k].add(d[k].get(n), n);
  },
  rem(n) {
    const t = this.cellkey(n), g = this.cell(t, n);
    if (g.num -= 1, this._countOnly) return;
    g.store && g.data.rem(n);
    const d = g.agg;
    for (let k = 0, H = d.length; k < H; ++k)
      d[k].rem(d[k].get(n), n);
  },
  celltuple(n) {
    const t = n.tuple, g = this._counts;
    n.store && n.data.values();
    for (let d = 0, k = g.length; d < k; ++d)
      t[g[d]] = n.num;
    if (!this._countOnly) {
      const d = n.agg;
      for (let k = 0, H = d.length; k < H; ++k)
        d[k].set(t);
    }
    return t;
  },
  changes(n) {
    const t = this._adds, g = this._mods, d = this._prev, k = this._drop, H = n.add, AA = n.rem, gA = n.mod;
    let IA, CA, BA, eA;
    if (d) for (CA in d)
      IA = d[CA], (!k || IA.num) && AA.push(IA.tuple);
    for (BA = 0, eA = this._alen; BA < eA; ++BA)
      H.push(this.celltuple(t[BA])), t[BA] = null;
    for (BA = 0, eA = this._mlen; BA < eA; ++BA)
      IA = g[BA], (IA.num === 0 && k ? AA : gA).push(this.celltuple(IA)), g[BA] = null;
    return this._alen = this._mlen = 0, this._prev = null, n;
  }
});
const EPSILON$1 = 1e-14;
function Bin(n) {
  Transform.call(this, null, n);
}
Bin.Definition = {
  type: "Bin",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "interval",
    type: "boolean",
    default: !0
  }, {
    name: "anchor",
    type: "number"
  }, {
    name: "maxbins",
    type: "number",
    default: 20
  }, {
    name: "base",
    type: "number",
    default: 10
  }, {
    name: "divide",
    type: "number",
    array: !0,
    default: [5, 2]
  }, {
    name: "extent",
    type: "number",
    array: !0,
    length: 2,
    required: !0
  }, {
    name: "span",
    type: "number"
  }, {
    name: "step",
    type: "number"
  }, {
    name: "steps",
    type: "number",
    array: !0
  }, {
    name: "minstep",
    type: "number",
    default: 0
  }, {
    name: "nice",
    type: "boolean",
    default: !0
  }, {
    name: "name",
    type: "string"
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: ["bin0", "bin1"]
  }]
};
inherits$1(Bin, Transform, {
  transform(n, t) {
    const g = n.interval !== !1, d = this._bins(n), k = d.start, H = d.step, AA = n.as || ["bin0", "bin1"], gA = AA[0], IA = AA[1];
    let CA;
    return n.modified() ? (t = t.reflow(!0), CA = t.SOURCE) : CA = t.modified(accessorFields(n.field)) ? t.ADD_MOD : t.ADD, t.visit(CA, g ? (BA) => {
      const eA = d(BA);
      BA[gA] = eA, BA[IA] = eA == null ? null : k + H * (1 + (eA - k) / H);
    } : (BA) => BA[gA] = d(BA)), t.modifies(g ? AA : gA);
  },
  _bins(n) {
    if (this.value && !n.modified())
      return this.value;
    const t = n.field, g = bin(n), d = g.step;
    let k = g.start, H = k + Math.ceil((g.stop - k) / d) * d, AA, gA;
    (AA = n.anchor) != null && (gA = AA - (k + d * Math.floor((AA - k) / d)), k += gA, H += gA);
    const IA = function(CA) {
      let BA = toNumber$1(t(CA));
      return BA == null ? null : BA < k ? -1 / 0 : BA > H ? 1 / 0 : (BA = Math.max(k, Math.min(BA, H - d)), k + d * Math.floor(EPSILON$1 + (BA - k) / d));
    };
    return IA.start = k, IA.stop = g.stop, IA.step = d, this.value = accessor$2(IA, accessorFields(t), n.name || "bin_" + accessorName(t));
  }
});
function SortedList(n, t, g) {
  const d = n;
  let k = t || [], H = g || [], AA = {}, gA = 0;
  return {
    add: (IA) => H.push(IA),
    remove: (IA) => AA[d(IA)] = ++gA,
    size: () => k.length,
    data: (IA, CA) => (gA && (k = k.filter((BA) => !AA[d(BA)]), AA = {}, gA = 0), CA && IA && k.sort(IA), H.length && (k = IA ? merge$5(IA, k, H.sort(IA)) : k.concat(H), H = []), k)
  };
}
function Collect$1(n) {
  Transform.call(this, [], n);
}
Collect$1.Definition = {
  type: "Collect",
  metadata: {
    source: !0
  },
  params: [{
    name: "sort",
    type: "compare"
  }]
};
inherits$1(Collect$1, Transform, {
  transform(n, t) {
    const g = t.fork(t.ALL), d = SortedList(tupleid, this.value, g.materialize(g.ADD).add), k = n.sort, H = t.changed() || k && (n.modified("sort") || t.modified(k.fields));
    return g.visit(g.REM, d.remove), this.modified(H), this.value = g.source = d.data(stableCompare(k), H), t.source && t.source.root && (this.value.root = t.source.root), g;
  }
});
function Compare$1(n) {
  Operator.call(this, null, update$5, n);
}
inherits$1(Compare$1, Operator);
function update$5(n) {
  return this.value && !n.modified() ? this.value : compare$3(n.fields, n.orders);
}
function CountPattern(n) {
  Transform.call(this, null, n);
}
CountPattern.Definition = {
  type: "CountPattern",
  metadata: {
    generates: !0,
    changes: !0
  },
  params: [{
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "case",
    type: "enum",
    values: ["upper", "lower", "mixed"],
    default: "mixed"
  }, {
    name: "pattern",
    type: "string",
    default: '[\\w"]+'
  }, {
    name: "stopwords",
    type: "string",
    default: ""
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: ["text", "count"]
  }]
};
function tokenize(n, t, g) {
  switch (t) {
    case "upper":
      n = n.toUpperCase();
      break;
    case "lower":
      n = n.toLowerCase();
      break;
  }
  return n.match(g);
}
inherits$1(CountPattern, Transform, {
  transform(n, t) {
    const g = (eA) => (iA) => {
      for (var QA = tokenize(gA(iA), n.case, H) || [], tA, oA = 0, EA = QA.length; oA < EA; ++oA)
        AA.test(tA = QA[oA]) || eA(tA);
    }, d = this._parameterCheck(n, t), k = this._counts, H = this._match, AA = this._stop, gA = n.field, IA = n.as || ["text", "count"], CA = g((eA) => k[eA] = 1 + (k[eA] || 0)), BA = g((eA) => k[eA] -= 1);
    return d ? t.visit(t.SOURCE, CA) : (t.visit(t.ADD, CA), t.visit(t.REM, BA)), this._finish(t, IA);
  },
  _parameterCheck(n, t) {
    let g = !1;
    return (n.modified("stopwords") || !this._stop) && (this._stop = new RegExp("^" + (n.stopwords || "") + "$", "i"), g = !0), (n.modified("pattern") || !this._match) && (this._match = new RegExp(n.pattern || "[\\w']+", "g"), g = !0), (n.modified("field") || t.modified(n.field.fields)) && (g = !0), g && (this._counts = {}), g;
  },
  _finish(n, t) {
    const g = this._counts, d = this._tuples || (this._tuples = {}), k = t[0], H = t[1], AA = n.fork(n.NO_SOURCE | n.NO_FIELDS);
    let gA, IA, CA;
    for (gA in g)
      IA = d[gA], CA = g[gA] || 0, !IA && CA ? (d[gA] = IA = ingest$1({}), IA[k] = gA, IA[H] = CA, AA.add.push(IA)) : CA === 0 ? (IA && AA.rem.push(IA), g[gA] = null, d[gA] = null) : IA[H] !== CA && (IA[H] = CA, AA.mod.push(IA));
    return AA.modifies(t);
  }
});
function Cross(n) {
  Transform.call(this, null, n);
}
Cross.Definition = {
  type: "Cross",
  metadata: {
    generates: !0
  },
  params: [{
    name: "filter",
    type: "expr"
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: ["a", "b"]
  }]
};
inherits$1(Cross, Transform, {
  transform(n, t) {
    const g = t.fork(t.NO_SOURCE), d = n.as || ["a", "b"], k = d[0], H = d[1], AA = !this.value || t.changed(t.ADD_REM) || n.modified("as") || n.modified("filter");
    let gA = this.value;
    return AA ? (gA && (g.rem = gA), gA = t.materialize(t.SOURCE).source, g.add = this.value = cross(gA, k, H, n.filter || truthy)) : g.mod = gA, g.source = this.value, g.modifies(d);
  }
});
function cross(n, t, g, d) {
  for (var k = [], H = {}, AA = n.length, gA = 0, IA, CA; gA < AA; ++gA)
    for (H[t] = CA = n[gA], IA = 0; IA < AA; ++IA)
      H[g] = n[IA], d(H) && (k.push(ingest$1(H)), H = {}, H[t] = CA);
  return k;
}
const Distributions = {
  kde,
  mixture: mixture$1,
  normal: gaussian,
  lognormal,
  uniform
}, DISTRIBUTIONS = "distributions", FUNCTION = "function", FIELD = "field";
function parse$4(n, t) {
  const g = n[FUNCTION];
  has$2(Distributions, g) || error$3("Unknown distribution function: " + g);
  const d = Distributions[g]();
  for (const k in n)
    k === FIELD ? d.data((n.from || t()).map(n[k])) : k === DISTRIBUTIONS ? d[k](n[k].map((H) => parse$4(H, t))) : typeof d[k] === FUNCTION && d[k](n[k]);
  return d;
}
function Density(n) {
  Transform.call(this, null, n);
}
const distributions = [{
  key: {
    function: "normal"
  },
  params: [{
    name: "mean",
    type: "number",
    default: 0
  }, {
    name: "stdev",
    type: "number",
    default: 1
  }]
}, {
  key: {
    function: "lognormal"
  },
  params: [{
    name: "mean",
    type: "number",
    default: 0
  }, {
    name: "stdev",
    type: "number",
    default: 1
  }]
}, {
  key: {
    function: "uniform"
  },
  params: [{
    name: "min",
    type: "number",
    default: 0
  }, {
    name: "max",
    type: "number",
    default: 1
  }]
}, {
  key: {
    function: "kde"
  },
  params: [{
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "from",
    type: "data"
  }, {
    name: "bandwidth",
    type: "number",
    default: 0
  }]
}], mixture = {
  key: {
    function: "mixture"
  },
  params: [{
    name: "distributions",
    type: "param",
    array: !0,
    params: distributions
  }, {
    name: "weights",
    type: "number",
    array: !0
  }]
};
Density.Definition = {
  type: "Density",
  metadata: {
    generates: !0
  },
  params: [{
    name: "extent",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "steps",
    type: "number"
  }, {
    name: "minsteps",
    type: "number",
    default: 25
  }, {
    name: "maxsteps",
    type: "number",
    default: 200
  }, {
    name: "method",
    type: "string",
    default: "pdf",
    values: ["pdf", "cdf"]
  }, {
    name: "distribution",
    type: "param",
    params: distributions.concat(mixture)
  }, {
    name: "as",
    type: "string",
    array: !0,
    default: ["value", "density"]
  }]
};
inherits$1(Density, Transform, {
  transform(n, t) {
    const g = t.fork(t.NO_SOURCE | t.NO_FIELDS);
    if (!this.value || t.changed() || n.modified()) {
      const d = parse$4(n.distribution, source$2(t)), k = n.steps || n.minsteps || 25, H = n.steps || n.maxsteps || 200;
      let AA = n.method || "pdf";
      AA !== "pdf" && AA !== "cdf" && error$3("Invalid density method: " + AA), !n.extent && !d.data && error$3("Missing density extent parameter."), AA = d[AA];
      const gA = n.as || ["value", "density"], IA = n.extent || extent(d.data()), CA = sampleCurve(AA, IA, k, H).map((BA) => {
        const eA = {};
        return eA[gA[0]] = BA[0], eA[gA[1]] = BA[1], ingest$1(eA);
      });
      this.value && (g.rem = this.value), this.value = g.add = g.source = CA;
    }
    return g;
  }
});
function source$2(n) {
  return () => n.materialize(n.SOURCE).source;
}
function fieldNames(n, t) {
  return n ? n.map((g, d) => t[d] || accessorName(g)) : null;
}
function partition$1$1(n, t, g) {
  const d = [], k = (eA) => eA(IA);
  let H, AA, gA, IA, CA, BA;
  if (t == null)
    d.push(n.map(g));
  else
    for (H = {}, AA = 0, gA = n.length; AA < gA; ++AA)
      IA = n[AA], CA = t.map(k), BA = H[CA], BA || (H[CA] = BA = [], BA.dims = CA, d.push(BA)), BA.push(g(IA));
  return d;
}
const Output$5 = "bin";
function DotBin(n) {
  Transform.call(this, null, n);
}
DotBin.Definition = {
  type: "DotBin",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "step",
    type: "number"
  }, {
    name: "smooth",
    type: "boolean",
    default: !1
  }, {
    name: "as",
    type: "string",
    default: Output$5
  }]
};
const autostep = (n, t) => span(extent(n, t)) / 30;
inherits$1(DotBin, Transform, {
  transform(n, t) {
    if (this.value && !(n.modified() || t.changed()))
      return t;
    const g = t.materialize(t.SOURCE).source, d = partition$1$1(t.source, n.groupby, identity$8), k = n.smooth || !1, H = n.field, AA = n.step || autostep(g, H), gA = stableCompare((tA, oA) => H(tA) - H(oA)), IA = n.as || Output$5, CA = d.length;
    let BA = 1 / 0, eA = -1 / 0, iA = 0, QA;
    for (; iA < CA; ++iA) {
      const tA = d[iA].sort(gA);
      QA = -1;
      for (const oA of dotbin(tA, AA, k, H))
        oA < BA && (BA = oA), oA > eA && (eA = oA), tA[++QA][IA] = oA;
    }
    return this.value = {
      start: BA,
      stop: eA,
      step: AA
    }, t.reflow(!0).modifies(IA);
  }
});
function Expression$1(n) {
  Operator.call(this, null, update$4, n), this.modified(!0);
}
inherits$1(Expression$1, Operator);
function update$4(n) {
  const t = n.expr;
  return this.value && !n.modified("expr") ? this.value : accessor$2((g) => t(g, n), accessorFields(t), accessorName(t));
}
function Extent(n) {
  Transform.call(this, [void 0, void 0], n);
}
Extent.Definition = {
  type: "Extent",
  metadata: {},
  params: [{
    name: "field",
    type: "field",
    required: !0
  }]
};
inherits$1(Extent, Transform, {
  transform(n, t) {
    const g = this.value, d = n.field, k = t.changed() || t.modified(d.fields) || n.modified("field");
    let H = g[0], AA = g[1];
    if ((k || H == null) && (H = 1 / 0, AA = -1 / 0), t.visit(k ? t.SOURCE : t.ADD, (gA) => {
      const IA = toNumber$1(d(gA));
      IA != null && (IA < H && (H = IA), IA > AA && (AA = IA));
    }), !Number.isFinite(H) || !Number.isFinite(AA)) {
      let gA = accessorName(d);
      gA && (gA = ` for field "${gA}"`), t.dataflow.warn(`Infinite extent${gA}: [${H}, ${AA}]`), H = AA = void 0;
    }
    this.value = [H, AA];
  }
});
function Subflow(n, t) {
  Operator.call(this, n), this.parent = t, this.count = 0;
}
inherits$1(Subflow, Operator, {
  /**
   * Routes pulses from this subflow to a target transform.
   * @param {Transform} target - A transform that receives the subflow of tuples.
   */
  connect(n) {
    return this.detachSubflow = n.detachSubflow, this.targets().add(n), n.source = this;
  },
  /**
   * Add an 'add' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being added.
   */
  add(n) {
    this.count += 1, this.value.add.push(n);
  },
  /**
   * Add a 'rem' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being removed.
   */
  rem(n) {
    this.count -= 1, this.value.rem.push(n);
  },
  /**
   * Add a 'mod' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being modified.
   */
  mod(n) {
    this.value.mod.push(n);
  },
  /**
   * Re-initialize this operator's pulse value.
   * @param {Pulse} pulse - The pulse to copy from.
   * @see Pulse.init
   */
  init(n) {
    this.value.init(n, n.NO_SOURCE);
  },
  /**
   * Evaluate this operator. This method overrides the
   * default behavior to simply return the contained pulse value.
   * @return {Pulse}
   */
  evaluate() {
    return this.value;
  }
});
function Facet$1(n) {
  Transform.call(this, {}, n), this._keys = fastmap();
  const t = this._targets = [];
  t.active = 0, t.forEach = (g) => {
    for (let d = 0, k = t.active; d < k; ++d)
      g(t[d], d, t);
  };
}
inherits$1(Facet$1, Transform, {
  activate(n) {
    this._targets[this._targets.active++] = n;
  },
  // parent argument provided by PreFacet subclass
  subflow(n, t, g, d) {
    const k = this.value;
    let H = has$2(k, n) && k[n], AA, gA;
    return H ? H.value.stamp < g.stamp && (H.init(g), this.activate(H)) : (gA = d || (gA = this._group[n]) && gA.tuple, AA = g.dataflow, H = new Subflow(g.fork(g.NO_SOURCE), this), AA.add(H).connect(t(AA, n, gA)), k[n] = H, this.activate(H)), H;
  },
  clean() {
    const n = this.value;
    let t = 0;
    for (const g in n)
      if (n[g].count === 0) {
        const d = n[g].detachSubflow;
        d && d(), delete n[g], ++t;
      }
    if (t) {
      const g = this._targets.filter((d) => d && d.count > 0);
      this.initTargets(g);
    }
  },
  initTargets(n) {
    const t = this._targets, g = t.length, d = n ? n.length : 0;
    let k = 0;
    for (; k < d; ++k)
      t[k] = n[k];
    for (; k < g && t[k] != null; ++k)
      t[k] = null;
    t.active = d;
  },
  transform(n, t) {
    const g = t.dataflow, d = n.key, k = n.subflow, H = this._keys, AA = n.modified("key"), gA = (IA) => this.subflow(IA, k, t);
    return this._group = n.group || {}, this.initTargets(), t.visit(t.REM, (IA) => {
      const CA = tupleid(IA), BA = H.get(CA);
      BA !== void 0 && (H.delete(CA), gA(BA).rem(IA));
    }), t.visit(t.ADD, (IA) => {
      const CA = d(IA);
      H.set(tupleid(IA), CA), gA(CA).add(IA);
    }), AA || t.modified(d.fields) ? t.visit(t.MOD, (IA) => {
      const CA = tupleid(IA), BA = H.get(CA), eA = d(IA);
      BA === eA ? gA(eA).mod(IA) : (H.set(CA, eA), gA(BA).rem(IA), gA(eA).add(IA));
    }) : t.changed(t.MOD) && t.visit(t.MOD, (IA) => {
      gA(H.get(tupleid(IA))).mod(IA);
    }), AA && t.visit(t.REFLOW, (IA) => {
      const CA = tupleid(IA), BA = H.get(CA), eA = d(IA);
      BA !== eA && (H.set(CA, eA), gA(BA).rem(IA), gA(eA).add(IA));
    }), t.clean() ? g.runAfter(() => {
      this.clean(), H.clean();
    }) : H.empty > g.cleanThreshold && g.runAfter(H.clean), t;
  }
});
function Field$1(n) {
  Operator.call(this, null, update$3, n);
}
inherits$1(Field$1, Operator);
function update$3(n) {
  return this.value && !n.modified() ? this.value : isArray$3(n.name) ? array$6(n.name).map((t) => field$4(t)) : field$4(n.name, n.as);
}
function Filter(n) {
  Transform.call(this, fastmap(), n);
}
Filter.Definition = {
  type: "Filter",
  metadata: {
    changes: !0
  },
  params: [{
    name: "expr",
    type: "expr",
    required: !0
  }]
};
inherits$1(Filter, Transform, {
  transform(n, t) {
    const g = t.dataflow, d = this.value, k = t.fork(), H = k.add, AA = k.rem, gA = k.mod, IA = n.expr;
    let CA = !0;
    t.visit(t.REM, (eA) => {
      const iA = tupleid(eA);
      d.has(iA) ? d.delete(iA) : AA.push(eA);
    }), t.visit(t.ADD, (eA) => {
      IA(eA, n) ? H.push(eA) : d.set(tupleid(eA), 1);
    });
    function BA(eA) {
      const iA = tupleid(eA), QA = IA(eA, n), tA = d.get(iA);
      QA && tA ? (d.delete(iA), H.push(eA)) : !QA && !tA ? (d.set(iA, 1), AA.push(eA)) : CA && QA && !tA && gA.push(eA);
    }
    return t.visit(t.MOD, BA), n.modified() && (CA = !1, t.visit(t.REFLOW, BA)), d.empty > g.cleanThreshold && g.runAfter(d.clean), k;
  }
});
function Flatten(n) {
  Transform.call(this, [], n);
}
Flatten.Definition = {
  type: "Flatten",
  metadata: {
    generates: !0
  },
  params: [{
    name: "fields",
    type: "field",
    array: !0,
    required: !0
  }, {
    name: "index",
    type: "string"
  }, {
    name: "as",
    type: "string",
    array: !0
  }]
};
inherits$1(Flatten, Transform, {
  transform(n, t) {
    const g = t.fork(t.NO_SOURCE), d = n.fields, k = fieldNames(d, n.as || []), H = n.index || null, AA = k.length;
    return g.rem = this.value, t.visit(t.SOURCE, (gA) => {
      const IA = d.map((tA) => tA(gA)), CA = IA.reduce((tA, oA) => Math.max(tA, oA.length), 0);
      let BA = 0, eA, iA, QA;
      for (; BA < CA; ++BA) {
        for (iA = derive(gA), eA = 0; eA < AA; ++eA)
          iA[k[eA]] = (QA = IA[eA][BA]) == null ? null : QA;
        H && (iA[H] = BA), g.add.push(iA);
      }
    }), this.value = g.source = g.add, H && g.modifies(H), g.modifies(k);
  }
});
function Fold(n) {
  Transform.call(this, [], n);
}
Fold.Definition = {
  type: "Fold",
  metadata: {
    generates: !0
  },
  params: [{
    name: "fields",
    type: "field",
    array: !0,
    required: !0
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: ["key", "value"]
  }]
};
inherits$1(Fold, Transform, {
  transform(n, t) {
    const g = t.fork(t.NO_SOURCE), d = n.fields, k = d.map(accessorName), H = n.as || ["key", "value"], AA = H[0], gA = H[1], IA = d.length;
    return g.rem = this.value, t.visit(t.SOURCE, (CA) => {
      for (let BA = 0, eA; BA < IA; ++BA)
        eA = derive(CA), eA[AA] = k[BA], eA[gA] = d[BA](CA), g.add.push(eA);
    }), this.value = g.source = g.add, g.modifies(H);
  }
});
function Formula(n) {
  Transform.call(this, null, n);
}
Formula.Definition = {
  type: "Formula",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "expr",
    type: "expr",
    required: !0
  }, {
    name: "as",
    type: "string",
    required: !0
  }, {
    name: "initonly",
    type: "boolean"
  }]
};
inherits$1(Formula, Transform, {
  transform(n, t) {
    const g = n.expr, d = n.as, k = n.modified(), H = n.initonly ? t.ADD : k ? t.SOURCE : t.modified(g.fields) || t.modified(d) ? t.ADD_MOD : t.ADD;
    return k && (t = t.materialize().reflow(!0)), n.initonly || t.modifies(d), t.visit(H, (AA) => AA[d] = g(AA, n));
  }
});
function Generate(n) {
  Transform.call(this, [], n);
}
inherits$1(Generate, Transform, {
  transform(n, t) {
    const g = t.fork(t.ALL), d = n.generator;
    let k = this.value, H = n.size - k.length, AA, gA, IA;
    if (H > 0) {
      for (AA = []; --H >= 0; )
        AA.push(IA = ingest$1(d(n))), k.push(IA);
      g.add = g.add.length ? g.materialize(g.ADD).add.concat(AA) : AA;
    } else
      gA = k.slice(0, -H), g.rem = g.rem.length ? g.materialize(g.REM).rem.concat(gA) : gA, k = k.slice(-H);
    return g.source = this.value = k, g;
  }
});
const Methods$1 = {
  value: "value",
  median,
  mean,
  min: min$2,
  max: max$2
}, Empty$1 = [];
function Impute(n) {
  Transform.call(this, [], n);
}
Impute.Definition = {
  type: "Impute",
  metadata: {
    changes: !0
  },
  params: [{
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "key",
    type: "field",
    required: !0
  }, {
    name: "keyvals",
    array: !0
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "method",
    type: "enum",
    default: "value",
    values: ["value", "mean", "median", "max", "min"]
  }, {
    name: "value",
    default: 0
  }]
};
function getValue$1(n) {
  var t = n.method || Methods$1.value, g;
  if (Methods$1[t] == null)
    error$3("Unrecognized imputation method: " + t);
  else return t === Methods$1.value ? (g = n.value !== void 0 ? n.value : 0, () => g) : Methods$1[t];
}
function getField$1(n) {
  const t = n.field;
  return (g) => g ? t(g) : NaN;
}
inherits$1(Impute, Transform, {
  transform(n, t) {
    var g = t.fork(t.ALL), d = getValue$1(n), k = getField$1(n), H = accessorName(n.field), AA = accessorName(n.key), gA = (n.groupby || []).map(accessorName), IA = partition$4(t.source, n.groupby, n.key, n.keyvals), CA = [], BA = this.value, eA = IA.domain.length, iA, QA, tA, oA, EA, aA, nA, lA, cA, sA;
    for (EA = 0, lA = IA.length; EA < lA; ++EA)
      for (iA = IA[EA], tA = iA.values, QA = NaN, nA = 0; nA < eA; ++nA)
        if (iA[nA] == null) {
          for (oA = IA.domain[nA], sA = {
            _impute: !0
          }, aA = 0, cA = tA.length; aA < cA; ++aA) sA[gA[aA]] = tA[aA];
          sA[AA] = oA, sA[H] = Number.isNaN(QA) ? QA = d(iA, k) : QA, CA.push(ingest$1(sA));
        }
    return CA.length && (g.add = g.materialize(g.ADD).add.concat(CA)), BA.length && (g.rem = g.materialize(g.REM).rem.concat(BA)), this.value = CA, g;
  }
});
function partition$4(n, t, g, d) {
  var k = (aA) => aA(EA), H = [], AA = d ? d.slice() : [], gA = {}, IA = {}, CA, BA, eA, iA, QA, tA, oA, EA;
  for (AA.forEach((aA, nA) => gA[aA] = nA + 1), iA = 0, oA = n.length; iA < oA; ++iA)
    EA = n[iA], tA = g(EA), QA = gA[tA] || (gA[tA] = AA.push(tA)), BA = (CA = t ? t.map(k) : Empty$1) + "", (eA = IA[BA]) || (eA = IA[BA] = [], H.push(eA), eA.values = CA), eA[QA - 1] = EA;
  return H.domain = AA, H;
}
function JoinAggregate(n) {
  Aggregate$1.call(this, n);
}
JoinAggregate.Definition = {
  type: "JoinAggregate",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "fields",
    type: "field",
    null: !0,
    array: !0
  }, {
    name: "ops",
    type: "enum",
    array: !0,
    values: ValidAggregateOps
  }, {
    name: "as",
    type: "string",
    null: !0,
    array: !0
  }, {
    name: "key",
    type: "field"
  }]
};
inherits$1(JoinAggregate, Aggregate$1, {
  transform(n, t) {
    const g = this, d = n.modified();
    let k;
    return g.value && (d || t.modified(g._inputs, !0)) ? (k = g.value = d ? g.init(n) : {}, t.visit(t.SOURCE, (H) => g.add(H))) : (k = g.value = g.value || this.init(n), t.visit(t.REM, (H) => g.rem(H)), t.visit(t.ADD, (H) => g.add(H))), g.changes(), t.visit(t.SOURCE, (H) => {
      extend$2(H, k[g.cellkey(H)].tuple);
    }), t.reflow(d).modifies(this._outputs);
  },
  changes() {
    const n = this._adds, t = this._mods;
    let g, d;
    for (g = 0, d = this._alen; g < d; ++g)
      this.celltuple(n[g]), n[g] = null;
    for (g = 0, d = this._mlen; g < d; ++g)
      this.celltuple(t[g]), t[g] = null;
    this._alen = this._mlen = 0;
  }
});
function KDE(n) {
  Transform.call(this, null, n);
}
KDE.Definition = {
  type: "KDE",
  metadata: {
    generates: !0
  },
  params: [{
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "cumulative",
    type: "boolean",
    default: !1
  }, {
    name: "counts",
    type: "boolean",
    default: !1
  }, {
    name: "bandwidth",
    type: "number",
    default: 0
  }, {
    name: "extent",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "resolve",
    type: "enum",
    values: ["shared", "independent"],
    default: "independent"
  }, {
    name: "steps",
    type: "number"
  }, {
    name: "minsteps",
    type: "number",
    default: 25
  }, {
    name: "maxsteps",
    type: "number",
    default: 200
  }, {
    name: "as",
    type: "string",
    array: !0,
    default: ["value", "density"]
  }]
};
inherits$1(KDE, Transform, {
  transform(n, t) {
    const g = t.fork(t.NO_SOURCE | t.NO_FIELDS);
    if (!this.value || t.changed() || n.modified()) {
      const d = t.materialize(t.SOURCE).source, k = partition$1$1(d, n.groupby, n.field), H = (n.groupby || []).map(accessorName), AA = n.bandwidth, gA = n.cumulative ? "cdf" : "pdf", IA = n.as || ["value", "density"], CA = [];
      let BA = n.extent, eA = n.steps || n.minsteps || 25, iA = n.steps || n.maxsteps || 200;
      gA !== "pdf" && gA !== "cdf" && error$3("Invalid density method: " + gA), n.resolve === "shared" && (BA || (BA = extent(d, n.field)), eA = iA = n.steps || iA), k.forEach((QA) => {
        const tA = kde(QA, AA)[gA], oA = n.counts ? QA.length : 1, EA = BA || extent(QA);
        sampleCurve(tA, EA, eA, iA).forEach((aA) => {
          const nA = {};
          for (let lA = 0; lA < H.length; ++lA)
            nA[H[lA]] = QA.dims[lA];
          nA[IA[0]] = aA[0], nA[IA[1]] = aA[1] * oA, CA.push(ingest$1(nA));
        });
      }), this.value && (g.rem = this.value), this.value = g.add = g.source = CA;
    }
    return g;
  }
});
function Key$1(n) {
  Operator.call(this, null, update$2, n);
}
inherits$1(Key$1, Operator);
function update$2(n) {
  return this.value && !n.modified() ? this.value : key(n.fields, n.flat);
}
function Load$1(n) {
  Transform.call(this, [], n), this._pending = null;
}
inherits$1(Load$1, Transform, {
  transform(n, t) {
    const g = t.dataflow;
    return this._pending ? output(this, t, this._pending) : stop(n) ? t.StopPropagation : n.values ? output(this, t, g.parse(n.values, n.format)) : n.async ? {
      async: g.request(n.url, n.format).then((k) => (this._pending = array$6(k.data), (H) => H.touch(this)))
    } : g.request(n.url, n.format).then((d) => output(this, t, array$6(d.data)));
  }
});
function stop(n) {
  return n.modified("async") && !(n.modified("values") || n.modified("url") || n.modified("format"));
}
function output(n, t, g) {
  g.forEach(ingest$1);
  const d = t.fork(t.NO_FIELDS & t.NO_SOURCE);
  return d.rem = n.value, n.value = d.source = d.add = g, n._pending = null, d.rem.length && d.clean(!0), d;
}
function Lookup(n) {
  Transform.call(this, {}, n);
}
Lookup.Definition = {
  type: "Lookup",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "index",
    type: "index",
    params: [{
      name: "from",
      type: "data",
      required: !0
    }, {
      name: "key",
      type: "field",
      required: !0
    }]
  }, {
    name: "values",
    type: "field",
    array: !0
  }, {
    name: "fields",
    type: "field",
    array: !0,
    required: !0
  }, {
    name: "as",
    type: "string",
    array: !0
  }, {
    name: "default",
    default: null
  }]
};
inherits$1(Lookup, Transform, {
  transform(n, t) {
    const g = n.fields, d = n.index, k = n.values, H = n.default == null ? null : n.default, AA = n.modified(), gA = g.length;
    let IA = AA ? t.SOURCE : t.ADD, CA = t, BA = n.as, eA, iA, QA;
    return k ? (iA = k.length, gA > 1 && !BA && error$3('Multi-field lookup requires explicit "as" parameter.'), BA && BA.length !== gA * iA && error$3('The "as" parameter has too few output field names.'), BA = BA || k.map(accessorName), eA = function(tA) {
      for (var oA = 0, EA = 0, aA, nA; oA < gA; ++oA)
        if (nA = d.get(g[oA](tA)), nA == null) for (aA = 0; aA < iA; ++aA, ++EA) tA[BA[EA]] = H;
        else for (aA = 0; aA < iA; ++aA, ++EA) tA[BA[EA]] = k[aA](nA);
    }) : (BA || error$3("Missing output field names."), eA = function(tA) {
      for (var oA = 0, EA; oA < gA; ++oA)
        EA = d.get(g[oA](tA)), tA[BA[oA]] = EA ?? H;
    }), AA ? CA = t.reflow(!0) : (QA = g.some((tA) => t.modified(tA.fields)), IA |= QA ? t.MOD : 0), t.visit(IA, eA), CA.modifies(BA);
  }
});
function MultiExtent$1(n) {
  Operator.call(this, null, update$1, n);
}
inherits$1(MultiExtent$1, Operator);
function update$1(n) {
  if (this.value && !n.modified())
    return this.value;
  const t = n.extents, g = t.length;
  let d = 1 / 0, k = -1 / 0, H, AA;
  for (H = 0; H < g; ++H)
    AA = t[H], AA[0] < d && (d = AA[0]), AA[1] > k && (k = AA[1]);
  return [d, k];
}
function MultiValues$1(n) {
  Operator.call(this, null, update, n);
}
inherits$1(MultiValues$1, Operator);
function update(n) {
  return this.value && !n.modified() ? this.value : n.values.reduce((t, g) => t.concat(g), []);
}
function Params$2(n) {
  Transform.call(this, null, n);
}
inherits$1(Params$2, Transform, {
  transform(n, t) {
    return this.modified(n.modified()), this.value = n, t.fork(t.NO_SOURCE | t.NO_FIELDS);
  }
});
function Pivot(n) {
  Aggregate$1.call(this, n);
}
Pivot.Definition = {
  type: "Pivot",
  metadata: {
    generates: !0,
    changes: !0
  },
  params: [{
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "value",
    type: "field",
    required: !0
  }, {
    name: "op",
    type: "enum",
    values: ValidAggregateOps,
    default: "sum"
  }, {
    name: "limit",
    type: "number",
    default: 0
  }, {
    name: "key",
    type: "field"
  }]
};
inherits$1(Pivot, Aggregate$1, {
  _transform: Aggregate$1.prototype.transform,
  transform(n, t) {
    return this._transform(aggregateParams(n, t), t);
  }
});
function aggregateParams(n, t) {
  const g = n.field, d = n.value, k = (n.op === "count" ? "__count__" : n.op) || "sum", H = accessorFields(g).concat(accessorFields(d)), AA = pivotKeys(g, n.limit || 0, t);
  return t.changed() && n.set("__pivot__", null, null, !0), {
    key: n.key,
    groupby: n.groupby,
    ops: AA.map(() => k),
    fields: AA.map((gA) => get$6(gA, g, d, H)),
    as: AA.map((gA) => gA + ""),
    modified: n.modified.bind(n)
  };
}
function get$6(n, t, g, d) {
  return accessor$2((k) => t(k) === n ? g(k) : NaN, d, n + "");
}
function pivotKeys(n, t, g) {
  const d = {}, k = [];
  return g.visit(g.SOURCE, (H) => {
    const AA = n(H);
    d[AA] || (d[AA] = 1, k.push(AA));
  }), k.sort(ascending$2), t ? k.slice(0, t) : k;
}
function PreFacet$1(n) {
  Facet$1.call(this, n);
}
inherits$1(PreFacet$1, Facet$1, {
  transform(n, t) {
    const g = n.subflow, d = n.field, k = (H) => this.subflow(tupleid(H), g, t, H);
    return (n.modified("field") || d && t.modified(accessorFields(d))) && error$3("PreFacet does not support field modification."), this.initTargets(), d ? (t.visit(t.MOD, (H) => {
      const AA = k(H);
      d(H).forEach((gA) => AA.mod(gA));
    }), t.visit(t.ADD, (H) => {
      const AA = k(H);
      d(H).forEach((gA) => AA.add(ingest$1(gA)));
    }), t.visit(t.REM, (H) => {
      const AA = k(H);
      d(H).forEach((gA) => AA.rem(gA));
    })) : (t.visit(t.MOD, (H) => k(H).mod(H)), t.visit(t.ADD, (H) => k(H).add(H)), t.visit(t.REM, (H) => k(H).rem(H))), t.clean() && t.runAfter(() => this.clean()), t;
  }
});
function Project(n) {
  Transform.call(this, null, n);
}
Project.Definition = {
  type: "Project",
  metadata: {
    generates: !0,
    changes: !0
  },
  params: [{
    name: "fields",
    type: "field",
    array: !0
  }, {
    name: "as",
    type: "string",
    null: !0,
    array: !0
  }]
};
inherits$1(Project, Transform, {
  transform(n, t) {
    const g = t.fork(t.NO_SOURCE), d = n.fields, k = fieldNames(n.fields, n.as || []), H = d ? (gA, IA) => project$1(gA, IA, d, k) : rederive;
    let AA;
    return this.value ? AA = this.value : (t = t.addAll(), AA = this.value = {}), t.visit(t.REM, (gA) => {
      const IA = tupleid(gA);
      g.rem.push(AA[IA]), AA[IA] = null;
    }), t.visit(t.ADD, (gA) => {
      const IA = H(gA, ingest$1({}));
      AA[tupleid(gA)] = IA, g.add.push(IA);
    }), t.visit(t.MOD, (gA) => {
      g.mod.push(H(gA, AA[tupleid(gA)]));
    }), g;
  }
});
function project$1(n, t, g, d) {
  for (let k = 0, H = g.length; k < H; ++k)
    t[d[k]] = g[k](n);
  return t;
}
function Proxy$2(n) {
  Transform.call(this, null, n);
}
inherits$1(Proxy$2, Transform, {
  transform(n, t) {
    return this.value = n.value, n.modified("value") ? t.fork(t.NO_SOURCE | t.NO_FIELDS) : t.StopPropagation;
  }
});
function Quantile$1(n) {
  Transform.call(this, null, n);
}
Quantile$1.Definition = {
  type: "Quantile",
  metadata: {
    generates: !0,
    changes: !0
  },
  params: [{
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "probs",
    type: "number",
    array: !0
  }, {
    name: "step",
    type: "number",
    default: 0.01
  }, {
    name: "as",
    type: "string",
    array: !0,
    default: ["prob", "value"]
  }]
};
const EPSILON$2 = 1e-14;
inherits$1(Quantile$1, Transform, {
  transform(n, t) {
    const g = t.fork(t.NO_SOURCE | t.NO_FIELDS), d = n.as || ["prob", "value"];
    if (this.value && !n.modified() && !t.changed())
      return g.source = this.value, g;
    const k = t.materialize(t.SOURCE).source, H = partition$1$1(k, n.groupby, n.field), AA = (n.groupby || []).map(accessorName), gA = [], IA = n.step || 0.01, CA = n.probs || range$5(IA / 2, 1 - EPSILON$2, IA), BA = CA.length;
    return H.forEach((eA) => {
      const iA = quantiles(eA, CA);
      for (let QA = 0; QA < BA; ++QA) {
        const tA = {};
        for (let oA = 0; oA < AA.length; ++oA)
          tA[AA[oA]] = eA.dims[oA];
        tA[d[0]] = CA[QA], tA[d[1]] = iA[QA], gA.push(ingest$1(tA));
      }
    }), this.value && (g.rem = this.value), this.value = g.add = g.source = gA, g;
  }
});
function Relay$1(n) {
  Transform.call(this, null, n);
}
inherits$1(Relay$1, Transform, {
  transform(n, t) {
    let g, d;
    return this.value ? d = this.value : (g = t = t.addAll(), d = this.value = {}), n.derive && (g = t.fork(t.NO_SOURCE), t.visit(t.REM, (k) => {
      const H = tupleid(k);
      g.rem.push(d[H]), d[H] = null;
    }), t.visit(t.ADD, (k) => {
      const H = derive(k);
      d[tupleid(k)] = H, g.add.push(H);
    }), t.visit(t.MOD, (k) => {
      const H = d[tupleid(k)];
      for (const AA in k)
        H[AA] = k[AA], g.modifies(AA);
      g.mod.push(H);
    })), g;
  }
});
function Sample(n) {
  Transform.call(this, [], n), this.count = 0;
}
Sample.Definition = {
  type: "Sample",
  metadata: {},
  params: [{
    name: "size",
    type: "number",
    default: 1e3
  }]
};
inherits$1(Sample, Transform, {
  transform(n, t) {
    const g = t.fork(t.NO_SOURCE), d = n.modified("size"), k = n.size, H = this.value.reduce((BA, eA) => (BA[tupleid(eA)] = 1, BA), {});
    let AA = this.value, gA = this.count, IA = 0;
    function CA(BA) {
      let eA, iA;
      AA.length < k ? AA.push(BA) : (iA = ~~((gA + 1) * random()), iA < AA.length && iA >= IA && (eA = AA[iA], H[tupleid(eA)] && g.rem.push(eA), AA[iA] = BA)), ++gA;
    }
    if (t.rem.length && (t.visit(t.REM, (BA) => {
      const eA = tupleid(BA);
      H[eA] && (H[eA] = -1, g.rem.push(BA)), --gA;
    }), AA = AA.filter((BA) => H[tupleid(BA)] !== -1)), (t.rem.length || d) && AA.length < k && t.source && (IA = gA = AA.length, t.visit(t.SOURCE, (BA) => {
      H[tupleid(BA)] || CA(BA);
    }), IA = -1), d && AA.length > k) {
      const BA = AA.length - k;
      for (let eA = 0; eA < BA; ++eA)
        H[tupleid(AA[eA])] = -1, g.rem.push(AA[eA]);
      AA = AA.slice(BA);
    }
    return t.mod.length && t.visit(t.MOD, (BA) => {
      H[tupleid(BA)] && g.mod.push(BA);
    }), t.add.length && t.visit(t.ADD, CA), (t.add.length || IA < 0) && (g.add = AA.filter((BA) => !H[tupleid(BA)])), this.count = gA, this.value = g.source = AA, g;
  }
});
function Sequence(n) {
  Transform.call(this, null, n);
}
Sequence.Definition = {
  type: "Sequence",
  metadata: {
    generates: !0,
    changes: !0
  },
  params: [{
    name: "start",
    type: "number",
    required: !0
  }, {
    name: "stop",
    type: "number",
    required: !0
  }, {
    name: "step",
    type: "number",
    default: 1
  }, {
    name: "as",
    type: "string",
    default: "data"
  }]
};
inherits$1(Sequence, Transform, {
  transform(n, t) {
    if (this.value && !n.modified()) return;
    const g = t.materialize().fork(t.MOD), d = n.as || "data";
    return g.rem = this.value ? t.rem.concat(this.value) : t.rem, this.value = range$5(n.start, n.stop, n.step || 1).map((k) => {
      const H = {};
      return H[d] = k, ingest$1(H);
    }), g.add = t.add.concat(this.value), g;
  }
});
function Sieve$1(n) {
  Transform.call(this, null, n), this.modified(!0);
}
inherits$1(Sieve$1, Transform, {
  transform(n, t) {
    return this.value = t.source, t.changed() ? t.fork(t.NO_SOURCE | t.NO_FIELDS) : t.StopPropagation;
  }
});
function TimeUnit(n) {
  Transform.call(this, null, n);
}
const OUTPUT = ["unit0", "unit1"];
TimeUnit.Definition = {
  type: "TimeUnit",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "interval",
    type: "boolean",
    default: !0
  }, {
    name: "units",
    type: "enum",
    values: TIME_UNITS,
    array: !0
  }, {
    name: "step",
    type: "number",
    default: 1
  }, {
    name: "maxbins",
    type: "number",
    default: 40
  }, {
    name: "extent",
    type: "date",
    array: !0
  }, {
    name: "timezone",
    type: "enum",
    default: "local",
    values: ["local", "utc"]
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: OUTPUT
  }]
};
inherits$1(TimeUnit, Transform, {
  transform(n, t) {
    const g = n.field, d = n.interval !== !1, k = n.timezone === "utc", H = this._floor(n, t), AA = (k ? utcInterval : timeInterval)(H.unit).offset, gA = n.as || OUTPUT, IA = gA[0], CA = gA[1], BA = H.step;
    let eA = H.start || 1 / 0, iA = H.stop || -1 / 0, QA = t.ADD;
    return (n.modified() || t.changed(t.REM) || t.modified(accessorFields(g))) && (t = t.reflow(!0), QA = t.SOURCE, eA = 1 / 0, iA = -1 / 0), t.visit(QA, (tA) => {
      const oA = g(tA);
      let EA, aA;
      oA == null ? (tA[IA] = null, d && (tA[CA] = null)) : (tA[IA] = EA = aA = H(oA), d && (tA[CA] = aA = AA(EA, BA)), EA < eA && (eA = EA), aA > iA && (iA = aA));
    }), H.start = eA, H.stop = iA, t.modifies(d ? gA : IA);
  },
  _floor(n, t) {
    const g = n.timezone === "utc", {
      units: d,
      step: k
    } = n.units ? {
      units: n.units,
      step: n.step || 1
    } : bin$1({
      extent: n.extent || extent(t.materialize(t.SOURCE).source, n.field),
      maxbins: n.maxbins
    }), H = timeUnits(d), AA = this.value || {}, gA = (g ? utcFloor : timeFloor)(H, k);
    return gA.unit = peek$2(H), gA.units = H, gA.step = k, gA.start = AA.start, gA.stop = AA.stop, this.value = gA;
  }
});
function TupleIndex(n) {
  Transform.call(this, fastmap(), n);
}
inherits$1(TupleIndex, Transform, {
  transform(n, t) {
    const g = t.dataflow, d = n.field, k = this.value, H = (gA) => k.set(d(gA), gA);
    let AA = !0;
    return n.modified("field") || t.modified(d.fields) ? (k.clear(), t.visit(t.SOURCE, H)) : t.changed() ? (t.visit(t.REM, (gA) => k.delete(d(gA))), t.visit(t.ADD, H)) : AA = !1, this.modified(AA), k.empty > g.cleanThreshold && g.runAfter(k.clean), t.fork();
  }
});
function Values$1(n) {
  Transform.call(this, null, n);
}
inherits$1(Values$1, Transform, {
  transform(n, t) {
    (!this.value || n.modified("field") || n.modified("sort") || t.changed() || n.sort && t.modified(n.sort.fields)) && (this.value = (n.sort ? t.source.slice().sort(stableCompare(n.sort)) : t.source).map(n.field));
  }
});
function WindowOp(n, t, g, d) {
  const k = WindowOps[n](t, g);
  return {
    init: k.init || zero$4,
    update: function(H, AA) {
      AA[d] = k.next(H);
    }
  };
}
const WindowOps = {
  row_number: function() {
    return {
      next: (n) => n.index + 1
    };
  },
  rank: function() {
    let n;
    return {
      init: () => n = 1,
      next: (t) => {
        const g = t.index, d = t.data;
        return g && t.compare(d[g - 1], d[g]) ? n = g + 1 : n;
      }
    };
  },
  dense_rank: function() {
    let n;
    return {
      init: () => n = 1,
      next: (t) => {
        const g = t.index, d = t.data;
        return g && t.compare(d[g - 1], d[g]) ? ++n : n;
      }
    };
  },
  percent_rank: function() {
    const n = WindowOps.rank(), t = n.next;
    return {
      init: n.init,
      next: (g) => (t(g) - 1) / (g.data.length - 1)
    };
  },
  cume_dist: function() {
    let n;
    return {
      init: () => n = 0,
      next: (t) => {
        const g = t.data, d = t.compare;
        let k = t.index;
        if (n < k) {
          for (; k + 1 < g.length && !d(g[k], g[k + 1]); ) ++k;
          n = k;
        }
        return (1 + n) / g.length;
      }
    };
  },
  ntile: function(n, t) {
    t = +t, t > 0 || error$3("ntile num must be greater than zero.");
    const g = WindowOps.cume_dist(), d = g.next;
    return {
      init: g.init,
      next: (k) => Math.ceil(t * d(k))
    };
  },
  lag: function(n, t) {
    return t = +t || 1, {
      next: (g) => {
        const d = g.index - t;
        return d >= 0 ? n(g.data[d]) : null;
      }
    };
  },
  lead: function(n, t) {
    return t = +t || 1, {
      next: (g) => {
        const d = g.index + t, k = g.data;
        return d < k.length ? n(k[d]) : null;
      }
    };
  },
  first_value: function(n) {
    return {
      next: (t) => n(t.data[t.i0])
    };
  },
  last_value: function(n) {
    return {
      next: (t) => n(t.data[t.i1 - 1])
    };
  },
  nth_value: function(n, t) {
    return t = +t, t > 0 || error$3("nth_value nth must be greater than zero."), {
      next: (g) => {
        const d = g.i0 + (t - 1);
        return d < g.i1 ? n(g.data[d]) : null;
      }
    };
  },
  prev_value: function(n) {
    let t;
    return {
      init: () => t = null,
      next: (g) => {
        const d = n(g.data[g.index]);
        return d != null ? t = d : t;
      }
    };
  },
  next_value: function(n) {
    let t, g;
    return {
      init: () => (t = null, g = -1),
      next: (d) => {
        const k = d.data;
        return d.index <= g ? t : (g = find$2(n, k, d.index)) < 0 ? (g = k.length, t = null) : t = n(k[g]);
      }
    };
  }
};
function find$2(n, t, g) {
  for (let d = t.length; g < d; ++g)
    if (n(t[g]) != null) return g;
  return -1;
}
const ValidWindowOps = Object.keys(WindowOps);
function WindowState(n) {
  const t = array$6(n.ops), g = array$6(n.fields), d = array$6(n.params), k = array$6(n.aggregate_params), H = array$6(n.as), AA = this.outputs = [], gA = this.windows = [], IA = {}, CA = {}, BA = [], eA = [];
  let iA = !0;
  function QA(tA) {
    array$6(accessorFields(tA)).forEach((oA) => IA[oA] = 1);
  }
  QA(n.sort), t.forEach((tA, oA) => {
    const EA = g[oA], aA = d[oA], nA = k[oA] || null, lA = accessorName(EA), cA = measureName(tA, lA, H[oA]);
    if (QA(EA), AA.push(cA), has$2(WindowOps, tA))
      gA.push(WindowOp(tA, EA, aA, cA));
    else {
      if (EA == null && tA !== "count" && error$3("Null aggregate field specified."), tA === "count") {
        BA.push(cA);
        return;
      }
      iA = !1;
      let sA = CA[lA];
      sA || (sA = CA[lA] = [], sA.field = EA, eA.push(sA)), sA.push(createMeasure(tA, nA, cA));
    }
  }), (BA.length || eA.length) && (this.cell = cell(eA, BA, iA)), this.inputs = Object.keys(IA);
}
const prototype$2 = WindowState.prototype;
prototype$2.init = function() {
  this.windows.forEach((n) => n.init()), this.cell && this.cell.init();
};
prototype$2.update = function(n, t) {
  const g = this.cell, d = this.windows, k = n.data, H = d && d.length;
  let AA;
  if (g) {
    for (AA = n.p0; AA < n.i0; ++AA) g.rem(k[AA]);
    for (AA = n.p1; AA < n.i1; ++AA) g.add(k[AA]);
    g.set(t);
  }
  for (AA = 0; AA < H; ++AA) d[AA].update(n, t);
};
function cell(n, t, g) {
  n = n.map((IA) => compileMeasures(IA, IA.field));
  const d = {
    num: 0,
    agg: null,
    store: !1,
    count: t
  };
  if (!g)
    for (var k = n.length, H = d.agg = Array(k), AA = 0; AA < k; ++AA) H[AA] = new n[AA](d);
  if (d.store)
    var gA = d.data = new TupleStore();
  return d.add = function(IA) {
    if (d.num += 1, !g) {
      gA && gA.add(IA);
      for (let CA = 0; CA < k; ++CA)
        H[CA].add(H[CA].get(IA), IA);
    }
  }, d.rem = function(IA) {
    if (d.num -= 1, !g) {
      gA && gA.rem(IA);
      for (let CA = 0; CA < k; ++CA)
        H[CA].rem(H[CA].get(IA), IA);
    }
  }, d.set = function(IA) {
    let CA, BA;
    for (gA && gA.values(), CA = 0, BA = t.length; CA < BA; ++CA) IA[t[CA]] = d.num;
    if (!g) for (CA = 0, BA = H.length; CA < BA; ++CA) H[CA].set(IA);
  }, d.init = function() {
    d.num = 0, gA && gA.reset();
    for (let IA = 0; IA < k; ++IA) H[IA].init();
  }, d;
}
function Window(n) {
  Transform.call(this, {}, n), this._mlen = 0, this._mods = [];
}
Window.Definition = {
  type: "Window",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "sort",
    type: "compare"
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "ops",
    type: "enum",
    array: !0,
    values: ValidWindowOps.concat(ValidAggregateOps)
  }, {
    name: "params",
    type: "number",
    null: !0,
    array: !0
  }, {
    name: "aggregate_params",
    type: "number",
    null: !0,
    array: !0
  }, {
    name: "fields",
    type: "field",
    null: !0,
    array: !0
  }, {
    name: "as",
    type: "string",
    null: !0,
    array: !0
  }, {
    name: "frame",
    type: "number",
    null: !0,
    array: !0,
    length: 2,
    default: [null, 0]
  }, {
    name: "ignorePeers",
    type: "boolean",
    default: !1
  }]
};
inherits$1(Window, Transform, {
  transform(n, t) {
    this.stamp = t.stamp;
    const g = n.modified(), d = stableCompare(n.sort), k = groupkey(n.groupby), H = (gA) => this.group(k(gA));
    let AA = this.state;
    (!AA || g) && (AA = this.state = new WindowState(n)), g || t.modified(AA.inputs) ? (this.value = {}, t.visit(t.SOURCE, (gA) => H(gA).add(gA))) : (t.visit(t.REM, (gA) => H(gA).remove(gA)), t.visit(t.ADD, (gA) => H(gA).add(gA)));
    for (let gA = 0, IA = this._mlen; gA < IA; ++gA)
      processPartition(this._mods[gA], AA, d, n);
    return this._mlen = 0, this._mods = [], t.reflow(g).modifies(AA.outputs);
  },
  group(n) {
    let t = this.value[n];
    return t || (t = this.value[n] = SortedList(tupleid), t.stamp = -1), t.stamp < this.stamp && (t.stamp = this.stamp, this._mods[this._mlen++] = t), t;
  }
});
function processPartition(n, t, g, d) {
  const k = d.sort, H = k && !d.ignorePeers, AA = d.frame || [null, 0], gA = n.data(g), IA = gA.length, CA = H ? bisector(k) : null, BA = {
    i0: 0,
    i1: 0,
    p0: 0,
    p1: 0,
    index: 0,
    data: gA,
    compare: k || constant$6(-1)
  };
  t.init();
  for (let eA = 0; eA < IA; ++eA)
    setWindow(BA, AA, eA, IA), H && adjustRange(BA, CA), t.update(BA, gA[eA]);
}
function setWindow(n, t, g, d) {
  n.p0 = n.i0, n.p1 = n.i1, n.i0 = t[0] == null ? 0 : Math.max(0, g - Math.abs(t[0])), n.i1 = t[1] == null ? d : Math.min(d, g + Math.abs(t[1]) + 1), n.index = g;
}
function adjustRange(n, t) {
  const g = n.i0, d = n.i1 - 1, k = n.compare, H = n.data, AA = H.length - 1;
  g > 0 && !k(H[g], H[g - 1]) && (n.i0 = t.left(H, H[g])), d < AA && !k(H[d], H[d + 1]) && (n.i1 = t.right(H, H[d]));
}
const tx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  aggregate: Aggregate$1,
  bin: Bin,
  collect: Collect$1,
  compare: Compare$1,
  countpattern: CountPattern,
  cross: Cross,
  density: Density,
  dotbin: DotBin,
  expression: Expression$1,
  extent: Extent,
  facet: Facet$1,
  field: Field$1,
  filter: Filter,
  flatten: Flatten,
  fold: Fold,
  formula: Formula,
  generate: Generate,
  impute: Impute,
  joinaggregate: JoinAggregate,
  kde: KDE,
  key: Key$1,
  load: Load$1,
  lookup: Lookup,
  multiextent: MultiExtent$1,
  multivalues: MultiValues$1,
  params: Params$2,
  pivot: Pivot,
  prefacet: PreFacet$1,
  project: Project,
  proxy: Proxy$2,
  quantile: Quantile$1,
  relay: Relay$1,
  sample: Sample,
  sequence: Sequence,
  sieve: Sieve$1,
  subflow: Subflow,
  timeunit: TimeUnit,
  tupleindex: TupleIndex,
  values: Values$1,
  window: Window
}, Symbol.toStringTag, { value: "Module" }));
function constant$4(n) {
  return function() {
    return n;
  };
}
const abs$2 = Math.abs, atan2$1 = Math.atan2, cos$2 = Math.cos, max$1 = Math.max, min$1 = Math.min, sin$2 = Math.sin, sqrt$3 = Math.sqrt, epsilon$5 = 1e-12, pi$3 = Math.PI, halfPi$2 = pi$3 / 2, tau$3 = 2 * pi$3;
function acos$1(n) {
  return n > 1 ? 0 : n < -1 ? pi$3 : Math.acos(n);
}
function asin$2(n) {
  return n >= 1 ? halfPi$2 : n <= -1 ? -halfPi$2 : Math.asin(n);
}
const pi$2 = Math.PI, tau$2 = 2 * pi$2, epsilon$4 = 1e-6, tauEpsilon = tau$2 - epsilon$4;
function append$1(n) {
  this._ += n[0];
  for (let t = 1, g = n.length; t < g; ++t)
    this._ += arguments[t] + n[t];
}
function appendRound$1(n) {
  let t = Math.floor(n);
  if (!(t >= 0)) throw new Error(`invalid digits: ${n}`);
  if (t > 15) return append$1;
  const g = 10 ** t;
  return function(d) {
    this._ += d[0];
    for (let k = 1, H = d.length; k < H; ++k)
      this._ += Math.round(arguments[k] * g) / g + d[k];
  };
}
let Path$1 = class {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? append$1 : appendRound$1(t);
  }
  moveTo(t, g) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +g}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, g) {
    this._append`L${this._x1 = +t},${this._y1 = +g}`;
  }
  quadraticCurveTo(t, g, d, k) {
    this._append`Q${+t},${+g},${this._x1 = +d},${this._y1 = +k}`;
  }
  bezierCurveTo(t, g, d, k, H, AA) {
    this._append`C${+t},${+g},${+d},${+k},${this._x1 = +H},${this._y1 = +AA}`;
  }
  arcTo(t, g, d, k, H) {
    if (t = +t, g = +g, d = +d, k = +k, H = +H, H < 0) throw new Error(`negative radius: ${H}`);
    let AA = this._x1, gA = this._y1, IA = d - t, CA = k - g, BA = AA - t, eA = gA - g, iA = BA * BA + eA * eA;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = g}`;
    else if (iA > epsilon$4) if (!(Math.abs(eA * IA - CA * BA) > epsilon$4) || !H)
      this._append`L${this._x1 = t},${this._y1 = g}`;
    else {
      let QA = d - AA, tA = k - gA, oA = IA * IA + CA * CA, EA = QA * QA + tA * tA, aA = Math.sqrt(oA), nA = Math.sqrt(iA), lA = H * Math.tan((pi$2 - Math.acos((oA + iA - EA) / (2 * aA * nA))) / 2), cA = lA / nA, sA = lA / aA;
      Math.abs(cA - 1) > epsilon$4 && this._append`L${t + cA * BA},${g + cA * eA}`, this._append`A${H},${H},0,0,${+(eA * QA > BA * tA)},${this._x1 = t + sA * IA},${this._y1 = g + sA * CA}`;
    }
  }
  arc(t, g, d, k, H, AA) {
    if (t = +t, g = +g, d = +d, AA = !!AA, d < 0) throw new Error(`negative radius: ${d}`);
    let gA = d * Math.cos(k), IA = d * Math.sin(k), CA = t + gA, BA = g + IA, eA = 1 ^ AA, iA = AA ? k - H : H - k;
    this._x1 === null ? this._append`M${CA},${BA}` : (Math.abs(this._x1 - CA) > epsilon$4 || Math.abs(this._y1 - BA) > epsilon$4) && this._append`L${CA},${BA}`, d && (iA < 0 && (iA = iA % tau$2 + tau$2), iA > tauEpsilon ? this._append`A${d},${d},0,1,${eA},${t - gA},${g - IA}A${d},${d},0,1,${eA},${this._x1 = CA},${this._y1 = BA}` : iA > epsilon$4 && this._append`A${d},${d},0,${+(iA >= pi$2)},${eA},${this._x1 = t + d * Math.cos(H)},${this._y1 = g + d * Math.sin(H)}`);
  }
  rect(t, g, d, k) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +g}h${d = +d}v${+k}h${-d}Z`;
  }
  toString() {
    return this._;
  }
};
function path$4() {
  return new Path$1();
}
path$4.prototype = Path$1.prototype;
function withPath(n) {
  let t = 3;
  return n.digits = function(g) {
    if (!arguments.length) return t;
    if (g == null)
      t = null;
    else {
      const d = Math.floor(g);
      if (!(d >= 0)) throw new RangeError(`invalid digits: ${g}`);
      t = d;
    }
    return n;
  }, () => new Path$1(t);
}
function arcInnerRadius(n) {
  return n.innerRadius;
}
function arcOuterRadius(n) {
  return n.outerRadius;
}
function arcStartAngle(n) {
  return n.startAngle;
}
function arcEndAngle(n) {
  return n.endAngle;
}
function arcPadAngle(n) {
  return n && n.padAngle;
}
function intersect$3(n, t, g, d, k, H, AA, gA) {
  var IA = g - n, CA = d - t, BA = AA - k, eA = gA - H, iA = eA * IA - BA * CA;
  if (!(iA * iA < epsilon$5))
    return iA = (BA * (t - H) - eA * (n - k)) / iA, [n + iA * IA, t + iA * CA];
}
function cornerTangents(n, t, g, d, k, H, AA) {
  var gA = n - g, IA = t - d, CA = (AA ? H : -H) / sqrt$3(gA * gA + IA * IA), BA = CA * IA, eA = -CA * gA, iA = n + BA, QA = t + eA, tA = g + BA, oA = d + eA, EA = (iA + tA) / 2, aA = (QA + oA) / 2, nA = tA - iA, lA = oA - QA, cA = nA * nA + lA * lA, sA = k - H, rA = iA * oA - tA * QA, uA = (lA < 0 ? -1 : 1) * sqrt$3(max$1(0, sA * sA * cA - rA * rA)), hA = (rA * lA - nA * uA) / cA, dA = (-rA * nA - lA * uA) / cA, GA = (rA * lA + nA * uA) / cA, DA = (-rA * nA + lA * uA) / cA, wA = hA - EA, bA = dA - aA, yA = GA - EA, pA = DA - aA;
  return wA * wA + bA * bA > yA * yA + pA * pA && (hA = GA, dA = DA), {
    cx: hA,
    cy: dA,
    x01: -BA,
    y01: -eA,
    x11: hA * (k / sA - 1),
    y11: dA * (k / sA - 1)
  };
}
function arc$2$1() {
  var n = arcInnerRadius, t = arcOuterRadius, g = constant$4(0), d = null, k = arcStartAngle, H = arcEndAngle, AA = arcPadAngle, gA = null, IA = withPath(CA);
  function CA() {
    var BA, eA, iA = +n.apply(this, arguments), QA = +t.apply(this, arguments), tA = k.apply(this, arguments) - halfPi$2, oA = H.apply(this, arguments) - halfPi$2, EA = abs$2(oA - tA), aA = oA > tA;
    if (gA || (gA = BA = IA()), QA < iA && (eA = QA, QA = iA, iA = eA), !(QA > epsilon$5)) gA.moveTo(0, 0);
    else if (EA > tau$3 - epsilon$5)
      gA.moveTo(QA * cos$2(tA), QA * sin$2(tA)), gA.arc(0, 0, QA, tA, oA, !aA), iA > epsilon$5 && (gA.moveTo(iA * cos$2(oA), iA * sin$2(oA)), gA.arc(0, 0, iA, oA, tA, aA));
    else {
      var nA = tA, lA = oA, cA = tA, sA = oA, rA = EA, uA = EA, hA = AA.apply(this, arguments) / 2, dA = hA > epsilon$5 && (d ? +d.apply(this, arguments) : sqrt$3(iA * iA + QA * QA)), GA = min$1(abs$2(QA - iA) / 2, +g.apply(this, arguments)), DA = GA, wA = GA, bA, yA;
      if (dA > epsilon$5) {
        var pA = asin$2(dA / iA * sin$2(hA)), MA = asin$2(dA / QA * sin$2(hA));
        (rA -= pA * 2) > epsilon$5 ? (pA *= aA ? 1 : -1, cA += pA, sA -= pA) : (rA = 0, cA = sA = (tA + oA) / 2), (uA -= MA * 2) > epsilon$5 ? (MA *= aA ? 1 : -1, nA += MA, lA -= MA) : (uA = 0, nA = lA = (tA + oA) / 2);
      }
      var LA = QA * cos$2(nA), xA = QA * sin$2(nA), TA = iA * cos$2(sA), NA = iA * sin$2(sA);
      if (GA > epsilon$5) {
        var zA = QA * cos$2(lA), XA = QA * sin$2(lA), fA = iA * cos$2(cA), vA = iA * sin$2(cA), Cg;
        if (EA < pi$3)
          if (Cg = intersect$3(LA, xA, fA, vA, zA, XA, TA, NA)) {
            var Ig = LA - Cg[0], gg = xA - Cg[1], og = zA - Cg[0], eg = XA - Cg[1], kA = 1 / sin$2(acos$1((Ig * og + gg * eg) / (sqrt$3(Ig * Ig + gg * gg) * sqrt$3(og * og + eg * eg))) / 2), YA = sqrt$3(Cg[0] * Cg[0] + Cg[1] * Cg[1]);
            DA = min$1(GA, (iA - YA) / (kA - 1)), wA = min$1(GA, (QA - YA) / (kA + 1));
          } else
            DA = wA = 0;
      }
      uA > epsilon$5 ? wA > epsilon$5 ? (bA = cornerTangents(fA, vA, LA, xA, QA, wA, aA), yA = cornerTangents(zA, XA, TA, NA, QA, wA, aA), gA.moveTo(bA.cx + bA.x01, bA.cy + bA.y01), wA < GA ? gA.arc(bA.cx, bA.cy, wA, atan2$1(bA.y01, bA.x01), atan2$1(yA.y01, yA.x01), !aA) : (gA.arc(bA.cx, bA.cy, wA, atan2$1(bA.y01, bA.x01), atan2$1(bA.y11, bA.x11), !aA), gA.arc(0, 0, QA, atan2$1(bA.cy + bA.y11, bA.cx + bA.x11), atan2$1(yA.cy + yA.y11, yA.cx + yA.x11), !aA), gA.arc(yA.cx, yA.cy, wA, atan2$1(yA.y11, yA.x11), atan2$1(yA.y01, yA.x01), !aA))) : (gA.moveTo(LA, xA), gA.arc(0, 0, QA, nA, lA, !aA)) : gA.moveTo(LA, xA), !(iA > epsilon$5) || !(rA > epsilon$5) ? gA.lineTo(TA, NA) : DA > epsilon$5 ? (bA = cornerTangents(TA, NA, zA, XA, iA, -DA, aA), yA = cornerTangents(LA, xA, fA, vA, iA, -DA, aA), gA.lineTo(bA.cx + bA.x01, bA.cy + bA.y01), DA < GA ? gA.arc(bA.cx, bA.cy, DA, atan2$1(bA.y01, bA.x01), atan2$1(yA.y01, yA.x01), !aA) : (gA.arc(bA.cx, bA.cy, DA, atan2$1(bA.y01, bA.x01), atan2$1(bA.y11, bA.x11), !aA), gA.arc(0, 0, iA, atan2$1(bA.cy + bA.y11, bA.cx + bA.x11), atan2$1(yA.cy + yA.y11, yA.cx + yA.x11), aA), gA.arc(yA.cx, yA.cy, DA, atan2$1(yA.y11, yA.x11), atan2$1(yA.y01, yA.x01), !aA))) : gA.arc(0, 0, iA, sA, cA, aA);
    }
    if (gA.closePath(), BA) return gA = null, BA + "" || null;
  }
  return CA.centroid = function() {
    var BA = (+n.apply(this, arguments) + +t.apply(this, arguments)) / 2, eA = (+k.apply(this, arguments) + +H.apply(this, arguments)) / 2 - pi$3 / 2;
    return [cos$2(eA) * BA, sin$2(eA) * BA];
  }, CA.innerRadius = function(BA) {
    return arguments.length ? (n = typeof BA == "function" ? BA : constant$4(+BA), CA) : n;
  }, CA.outerRadius = function(BA) {
    return arguments.length ? (t = typeof BA == "function" ? BA : constant$4(+BA), CA) : t;
  }, CA.cornerRadius = function(BA) {
    return arguments.length ? (g = typeof BA == "function" ? BA : constant$4(+BA), CA) : g;
  }, CA.padRadius = function(BA) {
    return arguments.length ? (d = BA == null ? null : typeof BA == "function" ? BA : constant$4(+BA), CA) : d;
  }, CA.startAngle = function(BA) {
    return arguments.length ? (k = typeof BA == "function" ? BA : constant$4(+BA), CA) : k;
  }, CA.endAngle = function(BA) {
    return arguments.length ? (H = typeof BA == "function" ? BA : constant$4(+BA), CA) : H;
  }, CA.padAngle = function(BA) {
    return arguments.length ? (AA = typeof BA == "function" ? BA : constant$4(+BA), CA) : AA;
  }, CA.context = function(BA) {
    return arguments.length ? (gA = BA ?? null, CA) : gA;
  }, CA;
}
function array$5(n) {
  return typeof n == "object" && "length" in n ? n : Array.from(n);
}
function Linear$1(n) {
  this._context = n;
}
Linear$1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, t) : this._context.moveTo(n, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(n, t);
        break;
    }
  }
};
function curveLinear(n) {
  return new Linear$1(n);
}
function x$3(n) {
  return n[0];
}
function y$4(n) {
  return n[1];
}
function line$2$1(n, t) {
  var g = constant$4(!0), d = null, k = curveLinear, H = null, AA = withPath(gA);
  n = typeof n == "function" ? n : n === void 0 ? x$3 : constant$4(n), t = typeof t == "function" ? t : t === void 0 ? y$4 : constant$4(t);
  function gA(IA) {
    var CA, BA = (IA = array$5(IA)).length, eA, iA = !1, QA;
    for (d == null && (H = k(QA = AA())), CA = 0; CA <= BA; ++CA)
      !(CA < BA && g(eA = IA[CA], CA, IA)) === iA && ((iA = !iA) ? H.lineStart() : H.lineEnd()), iA && H.point(+n(eA, CA, IA), +t(eA, CA, IA));
    if (QA) return H = null, QA + "" || null;
  }
  return gA.x = function(IA) {
    return arguments.length ? (n = typeof IA == "function" ? IA : constant$4(+IA), gA) : n;
  }, gA.y = function(IA) {
    return arguments.length ? (t = typeof IA == "function" ? IA : constant$4(+IA), gA) : t;
  }, gA.defined = function(IA) {
    return arguments.length ? (g = typeof IA == "function" ? IA : constant$4(!!IA), gA) : g;
  }, gA.curve = function(IA) {
    return arguments.length ? (k = IA, d != null && (H = k(d)), gA) : k;
  }, gA.context = function(IA) {
    return arguments.length ? (IA == null ? d = H = null : H = k(d = IA), gA) : d;
  }, gA;
}
function area$2$1(n, t, g) {
  var d = null, k = constant$4(!0), H = null, AA = curveLinear, gA = null, IA = withPath(CA);
  n = typeof n == "function" ? n : n === void 0 ? x$3 : constant$4(+n), t = typeof t == "function" ? t : constant$4(t === void 0 ? 0 : +t), g = typeof g == "function" ? g : g === void 0 ? y$4 : constant$4(+g);
  function CA(eA) {
    var iA, QA, tA, oA = (eA = array$5(eA)).length, EA, aA = !1, nA, lA = new Array(oA), cA = new Array(oA);
    for (H == null && (gA = AA(nA = IA())), iA = 0; iA <= oA; ++iA) {
      if (!(iA < oA && k(EA = eA[iA], iA, eA)) === aA)
        if (aA = !aA)
          QA = iA, gA.areaStart(), gA.lineStart();
        else {
          for (gA.lineEnd(), gA.lineStart(), tA = iA - 1; tA >= QA; --tA)
            gA.point(lA[tA], cA[tA]);
          gA.lineEnd(), gA.areaEnd();
        }
      aA && (lA[iA] = +n(EA, iA, eA), cA[iA] = +t(EA, iA, eA), gA.point(d ? +d(EA, iA, eA) : lA[iA], g ? +g(EA, iA, eA) : cA[iA]));
    }
    if (nA) return gA = null, nA + "" || null;
  }
  function BA() {
    return line$2$1().defined(k).curve(AA).context(H);
  }
  return CA.x = function(eA) {
    return arguments.length ? (n = typeof eA == "function" ? eA : constant$4(+eA), d = null, CA) : n;
  }, CA.x0 = function(eA) {
    return arguments.length ? (n = typeof eA == "function" ? eA : constant$4(+eA), CA) : n;
  }, CA.x1 = function(eA) {
    return arguments.length ? (d = eA == null ? null : typeof eA == "function" ? eA : constant$4(+eA), CA) : d;
  }, CA.y = function(eA) {
    return arguments.length ? (t = typeof eA == "function" ? eA : constant$4(+eA), g = null, CA) : t;
  }, CA.y0 = function(eA) {
    return arguments.length ? (t = typeof eA == "function" ? eA : constant$4(+eA), CA) : t;
  }, CA.y1 = function(eA) {
    return arguments.length ? (g = eA == null ? null : typeof eA == "function" ? eA : constant$4(+eA), CA) : g;
  }, CA.lineX0 = CA.lineY0 = function() {
    return BA().x(n).y(t);
  }, CA.lineY1 = function() {
    return BA().x(n).y(g);
  }, CA.lineX1 = function() {
    return BA().x(d).y(t);
  }, CA.defined = function(eA) {
    return arguments.length ? (k = typeof eA == "function" ? eA : constant$4(!!eA), CA) : k;
  }, CA.curve = function(eA) {
    return arguments.length ? (AA = eA, H != null && (gA = AA(H)), CA) : AA;
  }, CA.context = function(eA) {
    return arguments.length ? (eA == null ? H = gA = null : gA = AA(H = eA), CA) : H;
  }, CA;
}
const circle$1 = {
  draw(n, t) {
    const g = sqrt$3(t / pi$3);
    n.moveTo(g, 0), n.arc(0, 0, g, 0, tau$3);
  }
};
function Symbol$2(n, t) {
  let g = null, d = withPath(k);
  n = typeof n == "function" ? n : constant$4(n || circle$1), t = typeof t == "function" ? t : constant$4(t === void 0 ? 64 : +t);
  function k() {
    let H;
    if (g || (g = H = d()), n.apply(this, arguments).draw(g, +t.apply(this, arguments)), H) return g = null, H + "" || null;
  }
  return k.type = function(H) {
    return arguments.length ? (n = typeof H == "function" ? H : constant$4(H), k) : n;
  }, k.size = function(H) {
    return arguments.length ? (t = typeof H == "function" ? H : constant$4(+H), k) : t;
  }, k.context = function(H) {
    return arguments.length ? (g = H ?? null, k) : g;
  }, k;
}
function noop$5() {
}
function point$7(n, t, g) {
  n._context.bezierCurveTo(
    (2 * n._x0 + n._x1) / 3,
    (2 * n._y0 + n._y1) / 3,
    (n._x0 + 2 * n._x1) / 3,
    (n._y0 + 2 * n._y1) / 3,
    (n._x0 + 4 * n._x1 + t) / 6,
    (n._y0 + 4 * n._y1 + g) / 6
  );
}
function Basis(n) {
  this._context = n;
}
Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        point$7(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, t) : this._context.moveTo(n, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        point$7(this, n, t);
        break;
    }
    this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = t;
  }
};
function curveBasis(n) {
  return new Basis(n);
}
function BasisClosed(n) {
  this._context = n;
}
BasisClosed.prototype = {
  areaStart: noop$5,
  areaEnd: noop$5,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = n, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = n, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = n, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + n) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        point$7(this, n, t);
        break;
    }
    this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = t;
  }
};
function curveBasisClosed(n) {
  return new BasisClosed(n);
}
function BasisOpen(n) {
  this._context = n;
}
BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var g = (this._x0 + 4 * this._x1 + n) / 6, d = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(g, d) : this._context.moveTo(g, d);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        point$7(this, n, t);
        break;
    }
    this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = t;
  }
};
function curveBasisOpen(n) {
  return new BasisOpen(n);
}
function Bundle(n, t) {
  this._basis = new Basis(n), this._beta = t;
}
Bundle.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var n = this._x, t = this._y, g = n.length - 1;
    if (g > 0)
      for (var d = n[0], k = t[0], H = n[g] - d, AA = t[g] - k, gA = -1, IA; ++gA <= g; )
        IA = gA / g, this._basis.point(
          this._beta * n[gA] + (1 - this._beta) * (d + IA * H),
          this._beta * t[gA] + (1 - this._beta) * (k + IA * AA)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(n, t) {
    this._x.push(+n), this._y.push(+t);
  }
};
const curveBundle = (function n(t) {
  function g(d) {
    return t === 1 ? new Basis(d) : new Bundle(d, t);
  }
  return g.beta = function(d) {
    return n(+d);
  }, g;
})(0.85);
function point$6(n, t, g) {
  n._context.bezierCurveTo(
    n._x1 + n._k * (n._x2 - n._x0),
    n._y1 + n._k * (n._y2 - n._y0),
    n._x2 + n._k * (n._x1 - t),
    n._y2 + n._k * (n._y1 - g),
    n._x2,
    n._y2
  );
}
function Cardinal(n, t) {
  this._context = n, this._k = (1 - t) / 6;
}
Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        point$6(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, t) : this._context.moveTo(n, t);
        break;
      case 1:
        this._point = 2, this._x1 = n, this._y1 = t;
        break;
      case 2:
        this._point = 3;
      // falls through
      default:
        point$6(this, n, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const curveCardinal = (function n(t) {
  function g(d) {
    return new Cardinal(d, t);
  }
  return g.tension = function(d) {
    return n(+d);
  }, g;
})(0);
function CardinalClosed(n, t) {
  this._context = n, this._k = (1 - t) / 6;
}
CardinalClosed.prototype = {
  areaStart: noop$5,
  areaEnd: noop$5,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1, this._x3 = n, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = n, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = n, this._y5 = t;
        break;
      default:
        point$6(this, n, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const curveCardinalClosed = (function n(t) {
  function g(d) {
    return new CardinalClosed(d, t);
  }
  return g.tension = function(d) {
    return n(+d);
  }, g;
})(0);
function CardinalOpen(n, t) {
  this._context = n, this._k = (1 - t) / 6;
}
CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        point$6(this, n, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const curveCardinalOpen = (function n(t) {
  function g(d) {
    return new CardinalOpen(d, t);
  }
  return g.tension = function(d) {
    return n(+d);
  }, g;
})(0);
function point$5(n, t, g) {
  var d = n._x1, k = n._y1, H = n._x2, AA = n._y2;
  if (n._l01_a > epsilon$5) {
    var gA = 2 * n._l01_2a + 3 * n._l01_a * n._l12_a + n._l12_2a, IA = 3 * n._l01_a * (n._l01_a + n._l12_a);
    d = (d * gA - n._x0 * n._l12_2a + n._x2 * n._l01_2a) / IA, k = (k * gA - n._y0 * n._l12_2a + n._y2 * n._l01_2a) / IA;
  }
  if (n._l23_a > epsilon$5) {
    var CA = 2 * n._l23_2a + 3 * n._l23_a * n._l12_a + n._l12_2a, BA = 3 * n._l23_a * (n._l23_a + n._l12_a);
    H = (H * CA + n._x1 * n._l23_2a - t * n._l12_2a) / BA, AA = (AA * CA + n._y1 * n._l23_2a - g * n._l12_2a) / BA;
  }
  n._context.bezierCurveTo(d, k, H, AA, n._x2, n._y2);
}
function CatmullRom(n, t) {
  this._context = n, this._alpha = t;
}
CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    if (n = +n, t = +t, this._point) {
      var g = this._x2 - n, d = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(g * g + d * d, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, t) : this._context.moveTo(n, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      // falls through
      default:
        point$5(this, n, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const curveCatmullRom = (function n(t) {
  function g(d) {
    return t ? new CatmullRom(d, t) : new Cardinal(d, 0);
  }
  return g.alpha = function(d) {
    return n(+d);
  }, g;
})(0.5);
function CatmullRomClosed(n, t) {
  this._context = n, this._alpha = t;
}
CatmullRomClosed.prototype = {
  areaStart: noop$5,
  areaEnd: noop$5,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(n, t) {
    if (n = +n, t = +t, this._point) {
      var g = this._x2 - n, d = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(g * g + d * d, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = n, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = n, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = n, this._y5 = t;
        break;
      default:
        point$5(this, n, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const curveCatmullRomClosed = (function n(t) {
  function g(d) {
    return t ? new CatmullRomClosed(d, t) : new CardinalClosed(d, 0);
  }
  return g.alpha = function(d) {
    return n(+d);
  }, g;
})(0.5);
function CatmullRomOpen(n, t) {
  this._context = n, this._alpha = t;
}
CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    if (n = +n, t = +t, this._point) {
      var g = this._x2 - n, d = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(g * g + d * d, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        point$5(this, n, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const curveCatmullRomOpen = (function n(t) {
  function g(d) {
    return t ? new CatmullRomOpen(d, t) : new CardinalOpen(d, 0);
  }
  return g.alpha = function(d) {
    return n(+d);
  }, g;
})(0.5);
function LinearClosed(n) {
  this._context = n;
}
LinearClosed.prototype = {
  areaStart: noop$5,
  areaEnd: noop$5,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(n, t) {
    n = +n, t = +t, this._point ? this._context.lineTo(n, t) : (this._point = 1, this._context.moveTo(n, t));
  }
};
function curveLinearClosed(n) {
  return new LinearClosed(n);
}
function sign$1(n) {
  return n < 0 ? -1 : 1;
}
function slope3(n, t, g) {
  var d = n._x1 - n._x0, k = t - n._x1, H = (n._y1 - n._y0) / (d || k < 0 && -0), AA = (g - n._y1) / (k || d < 0 && -0), gA = (H * k + AA * d) / (d + k);
  return (sign$1(H) + sign$1(AA)) * Math.min(Math.abs(H), Math.abs(AA), 0.5 * Math.abs(gA)) || 0;
}
function slope2(n, t) {
  var g = n._x1 - n._x0;
  return g ? (3 * (n._y1 - n._y0) / g - t) / 2 : t;
}
function point$4(n, t, g) {
  var d = n._x0, k = n._y0, H = n._x1, AA = n._y1, gA = (H - d) / 3;
  n._context.bezierCurveTo(d + gA, k + gA * t, H - gA, AA - gA * g, H, AA);
}
function MonotoneX(n) {
  this._context = n;
}
MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point$4(this, this._t0, slope2(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    var g = NaN;
    if (n = +n, t = +t, !(n === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(n, t) : this._context.moveTo(n, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, point$4(this, slope2(this, g = slope3(this, n, t)), g);
          break;
        default:
          point$4(this, this._t0, g = slope3(this, n, t));
          break;
      }
      this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = t, this._t0 = g;
    }
  }
};
function MonotoneY(n) {
  this._context = new ReflectContext(n);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(n, t) {
  MonotoneX.prototype.point.call(this, t, n);
};
function ReflectContext(n) {
  this._context = n;
}
ReflectContext.prototype = {
  moveTo: function(n, t) {
    this._context.moveTo(t, n);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(n, t) {
    this._context.lineTo(t, n);
  },
  bezierCurveTo: function(n, t, g, d, k, H) {
    this._context.bezierCurveTo(t, n, d, g, H, k);
  }
};
function monotoneX(n) {
  return new MonotoneX(n);
}
function monotoneY(n) {
  return new MonotoneY(n);
}
function Natural(n) {
  this._context = n;
}
Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var n = this._x, t = this._y, g = n.length;
    if (g)
      if (this._line ? this._context.lineTo(n[0], t[0]) : this._context.moveTo(n[0], t[0]), g === 2)
        this._context.lineTo(n[1], t[1]);
      else
        for (var d = controlPoints(n), k = controlPoints(t), H = 0, AA = 1; AA < g; ++H, ++AA)
          this._context.bezierCurveTo(d[0][H], k[0][H], d[1][H], k[1][H], n[AA], t[AA]);
    (this._line || this._line !== 0 && g === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(n, t) {
    this._x.push(+n), this._y.push(+t);
  }
};
function controlPoints(n) {
  var t, g = n.length - 1, d, k = new Array(g), H = new Array(g), AA = new Array(g);
  for (k[0] = 0, H[0] = 2, AA[0] = n[0] + 2 * n[1], t = 1; t < g - 1; ++t) k[t] = 1, H[t] = 4, AA[t] = 4 * n[t] + 2 * n[t + 1];
  for (k[g - 1] = 2, H[g - 1] = 7, AA[g - 1] = 8 * n[g - 1] + n[g], t = 1; t < g; ++t) d = k[t] / H[t - 1], H[t] -= d, AA[t] -= d * AA[t - 1];
  for (k[g - 1] = AA[g - 1] / H[g - 1], t = g - 2; t >= 0; --t) k[t] = (AA[t] - k[t + 1]) / H[t];
  for (H[g - 1] = (n[g] + k[g - 1]) / 2, t = 0; t < g - 1; ++t) H[t] = 2 * n[t + 1] - k[t + 1];
  return [k, H];
}
function curveNatural(n) {
  return new Natural(n);
}
function Step(n, t) {
  this._context = n, this._t = t;
}
Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, t) : this._context.moveTo(n, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(n, t);
        else {
          var g = this._x * (1 - this._t) + n * this._t;
          this._context.lineTo(g, this._y), this._context.lineTo(g, t);
        }
        break;
      }
    }
    this._x = n, this._y = t;
  }
};
function curveStep(n) {
  return new Step(n, 0.5);
}
function stepBefore(n) {
  return new Step(n, 0);
}
function stepAfter(n) {
  return new Step(n, 1);
}
function domCanvas(n, t) {
  if (typeof document < "u" && document.createElement) {
    const g = document.createElement("canvas");
    if (g && g.getContext)
      return g.width = n, g.height = t, g;
  }
  return null;
}
const domImage = () => typeof Image < "u" ? Image : null;
function initRange(n, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(n);
      break;
    default:
      this.range(t).domain(n);
      break;
  }
  return this;
}
function initInterpolator(n, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof n == "function" ? this.interpolator(n) : this.range(n);
      break;
    }
    default: {
      this.domain(n), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const implicit = Symbol("implicit");
function ordinal() {
  var n = new InternMap(), t = [], g = [], d = implicit;
  function k(H) {
    let AA = n.get(H);
    if (AA === void 0) {
      if (d !== implicit) return d;
      n.set(H, AA = t.push(H) - 1);
    }
    return g[AA % g.length];
  }
  return k.domain = function(H) {
    if (!arguments.length) return t.slice();
    t = [], n = new InternMap();
    for (const AA of H)
      n.has(AA) || n.set(AA, t.push(AA) - 1);
    return k;
  }, k.range = function(H) {
    return arguments.length ? (g = Array.from(H), k) : g.slice();
  }, k.unknown = function(H) {
    return arguments.length ? (d = H, k) : d;
  }, k.copy = function() {
    return ordinal(t, g).unknown(d);
  }, initRange.apply(k, arguments), k;
}
function define(n, t, g) {
  n.prototype = t.prototype = g, g.constructor = n;
}
function extend$1(n, t) {
  var g = Object.create(n.prototype);
  for (var d in t) g[d] = t[d];
  return g;
}
function Color() {
}
var darker = 0.7, brighter = 1 / darker, reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`), named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define(Color, color$3, {
  copy(n) {
    return Object.assign(new this.constructor(), this, n);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color$3(n) {
  var t, g;
  return n = (n + "").trim().toLowerCase(), (t = reHex.exec(n)) ? (g = t[1].length, t = parseInt(t[1], 16), g === 6 ? rgbn(t) : g === 3 ? new Rgb(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : g === 8 ? rgba$1(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : g === 4 ? rgba$1(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = reRgbInteger.exec(n)) ? new Rgb(t[1], t[2], t[3], 1) : (t = reRgbPercent.exec(n)) ? new Rgb(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = reRgbaInteger.exec(n)) ? rgba$1(t[1], t[2], t[3], t[4]) : (t = reRgbaPercent.exec(n)) ? rgba$1(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = reHslPercent.exec(n)) ? hsla(t[1], t[2] / 100, t[3] / 100, 1) : (t = reHslaPercent.exec(n)) ? hsla(t[1], t[2] / 100, t[3] / 100, t[4]) : named.hasOwnProperty(n) ? rgbn(named[n]) : n === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function rgba$1(n, t, g, d) {
  return d <= 0 && (n = t = g = NaN), new Rgb(n, t, g, d);
}
function rgbConvert(n) {
  return n instanceof Color || (n = color$3(n)), n ? (n = n.rgb(), new Rgb(n.r, n.g, n.b, n.opacity)) : new Rgb();
}
function rgb$1(n, t, g, d) {
  return arguments.length === 1 ? rgbConvert(n) : new Rgb(n, t, g, d ?? 1);
}
function Rgb(n, t, g, d) {
  this.r = +n, this.g = +t, this.b = +g, this.opacity = +d;
}
define(Rgb, rgb$1, extend$1(Color, {
  brighter(n) {
    return n = n == null ? brighter : Math.pow(brighter, n), new Rgb(this.r * n, this.g * n, this.b * n, this.opacity);
  },
  darker(n) {
    return n = n == null ? darker : Math.pow(darker, n), new Rgb(this.r * n, this.g * n, this.b * n, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const n = clampa(this.opacity);
  return `${n === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${n === 1 ? ")" : `, ${n})`}`;
}
function clampa(n) {
  return isNaN(n) ? 1 : Math.max(0, Math.min(1, n));
}
function clampi(n) {
  return Math.max(0, Math.min(255, Math.round(n) || 0));
}
function hex(n) {
  return n = clampi(n), (n < 16 ? "0" : "") + n.toString(16);
}
function hsla(n, t, g, d) {
  return d <= 0 ? n = t = g = NaN : g <= 0 || g >= 1 ? n = t = NaN : t <= 0 && (n = NaN), new Hsl(n, t, g, d);
}
function hslConvert(n) {
  if (n instanceof Hsl) return new Hsl(n.h, n.s, n.l, n.opacity);
  if (n instanceof Color || (n = color$3(n)), !n) return new Hsl();
  if (n instanceof Hsl) return n;
  n = n.rgb();
  var t = n.r / 255, g = n.g / 255, d = n.b / 255, k = Math.min(t, g, d), H = Math.max(t, g, d), AA = NaN, gA = H - k, IA = (H + k) / 2;
  return gA ? (t === H ? AA = (g - d) / gA + (g < d) * 6 : g === H ? AA = (d - t) / gA + 2 : AA = (t - g) / gA + 4, gA /= IA < 0.5 ? H + k : 2 - H - k, AA *= 60) : gA = IA > 0 && IA < 1 ? 0 : AA, new Hsl(AA, gA, IA, n.opacity);
}
function hsl$1(n, t, g, d) {
  return arguments.length === 1 ? hslConvert(n) : new Hsl(n, t, g, d ?? 1);
}
function Hsl(n, t, g, d) {
  this.h = +n, this.s = +t, this.l = +g, this.opacity = +d;
}
define(Hsl, hsl$1, extend$1(Color, {
  brighter(n) {
    return n = n == null ? brighter : Math.pow(brighter, n), new Hsl(this.h, this.s, this.l * n, this.opacity);
  },
  darker(n) {
    return n = n == null ? darker : Math.pow(darker, n), new Hsl(this.h, this.s, this.l * n, this.opacity);
  },
  rgb() {
    var n = this.h % 360 + (this.h < 0) * 360, t = isNaN(n) || isNaN(this.s) ? 0 : this.s, g = this.l, d = g + (g < 0.5 ? g : 1 - g) * t, k = 2 * g - d;
    return new Rgb(
      hsl2rgb(n >= 240 ? n - 240 : n + 120, k, d),
      hsl2rgb(n, k, d),
      hsl2rgb(n < 120 ? n + 240 : n - 120, k, d),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const n = clampa(this.opacity);
    return `${n === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${n === 1 ? ")" : `, ${n})`}`;
  }
}));
function clamph(n) {
  return n = (n || 0) % 360, n < 0 ? n + 360 : n;
}
function clampt(n) {
  return Math.max(0, Math.min(1, n || 0));
}
function hsl2rgb(n, t, g) {
  return (n < 60 ? t + (g - t) * n / 60 : n < 180 ? g : n < 240 ? t + (g - t) * (240 - n) / 60 : t) * 255;
}
const radians$1 = Math.PI / 180, degrees$2 = 180 / Math.PI, K$1 = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(n) {
  if (n instanceof Lab) return new Lab(n.l, n.a, n.b, n.opacity);
  if (n instanceof Hcl) return hcl2lab(n);
  n instanceof Rgb || (n = rgbConvert(n));
  var t = rgb2lrgb(n.r), g = rgb2lrgb(n.g), d = rgb2lrgb(n.b), k = xyz2lab((0.2225045 * t + 0.7168786 * g + 0.0606169 * d) / Yn), H, AA;
  return t === g && g === d ? H = AA = k : (H = xyz2lab((0.4360747 * t + 0.3850649 * g + 0.1430804 * d) / Xn), AA = xyz2lab((0.0139322 * t + 0.0971045 * g + 0.7141733 * d) / Zn)), new Lab(116 * k - 16, 500 * (H - k), 200 * (k - AA), n.opacity);
}
function lab$1(n, t, g, d) {
  return arguments.length === 1 ? labConvert(n) : new Lab(n, t, g, d ?? 1);
}
function Lab(n, t, g, d) {
  this.l = +n, this.a = +t, this.b = +g, this.opacity = +d;
}
define(Lab, lab$1, extend$1(Color, {
  brighter(n) {
    return new Lab(this.l + K$1 * (n ?? 1), this.a, this.b, this.opacity);
  },
  darker(n) {
    return new Lab(this.l - K$1 * (n ?? 1), this.a, this.b, this.opacity);
  },
  rgb() {
    var n = (this.l + 16) / 116, t = isNaN(this.a) ? n : n + this.a / 500, g = isNaN(this.b) ? n : n - this.b / 200;
    return t = Xn * lab2xyz(t), n = Yn * lab2xyz(n), g = Zn * lab2xyz(g), new Rgb(
      lrgb2rgb(3.1338561 * t - 1.6168667 * n - 0.4906146 * g),
      lrgb2rgb(-0.9787684 * t + 1.9161415 * n + 0.033454 * g),
      lrgb2rgb(0.0719453 * t - 0.2289914 * n + 1.4052427 * g),
      this.opacity
    );
  }
}));
function xyz2lab(n) {
  return n > t3 ? Math.pow(n, 1 / 3) : n / t2 + t0;
}
function lab2xyz(n) {
  return n > t1 ? n * n * n : t2 * (n - t0);
}
function lrgb2rgb(n) {
  return 255 * (n <= 31308e-7 ? 12.92 * n : 1.055 * Math.pow(n, 1 / 2.4) - 0.055);
}
function rgb2lrgb(n) {
  return (n /= 255) <= 0.04045 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
}
function hclConvert(n) {
  if (n instanceof Hcl) return new Hcl(n.h, n.c, n.l, n.opacity);
  if (n instanceof Lab || (n = labConvert(n)), n.a === 0 && n.b === 0) return new Hcl(NaN, 0 < n.l && n.l < 100 ? 0 : NaN, n.l, n.opacity);
  var t = Math.atan2(n.b, n.a) * degrees$2;
  return new Hcl(t < 0 ? t + 360 : t, Math.sqrt(n.a * n.a + n.b * n.b), n.l, n.opacity);
}
function hcl$1(n, t, g, d) {
  return arguments.length === 1 ? hclConvert(n) : new Hcl(n, t, g, d ?? 1);
}
function Hcl(n, t, g, d) {
  this.h = +n, this.c = +t, this.l = +g, this.opacity = +d;
}
function hcl2lab(n) {
  if (isNaN(n.h)) return new Lab(n.l, 0, 0, n.opacity);
  var t = n.h * radians$1;
  return new Lab(n.l, Math.cos(t) * n.c, Math.sin(t) * n.c, n.opacity);
}
define(Hcl, hcl$1, extend$1(Color, {
  brighter(n) {
    return new Hcl(this.h, this.c, this.l + K$1 * (n ?? 1), this.opacity);
  },
  darker(n) {
    return new Hcl(this.h, this.c, this.l - K$1 * (n ?? 1), this.opacity);
  },
  rgb() {
    return hcl2lab(this).rgb();
  }
}));
var A = -0.14861, B$2 = 1.78277, C$1 = -0.29227, D$1 = -0.90649, E = 1.97294, ED = E * D$1, EB = E * B$2, BC_DA = B$2 * C$1 - D$1 * A;
function cubehelixConvert(n) {
  if (n instanceof Cubehelix) return new Cubehelix(n.h, n.s, n.l, n.opacity);
  n instanceof Rgb || (n = rgbConvert(n));
  var t = n.r / 255, g = n.g / 255, d = n.b / 255, k = (BC_DA * d + ED * t - EB * g) / (BC_DA + ED - EB), H = d - k, AA = (E * (g - k) - C$1 * H) / D$1, gA = Math.sqrt(AA * AA + H * H) / (E * k * (1 - k)), IA = gA ? Math.atan2(AA, H) * degrees$2 - 120 : NaN;
  return new Cubehelix(IA < 0 ? IA + 360 : IA, gA, k, n.opacity);
}
function cubehelix$1(n, t, g, d) {
  return arguments.length === 1 ? cubehelixConvert(n) : new Cubehelix(n, t, g, d ?? 1);
}
function Cubehelix(n, t, g, d) {
  this.h = +n, this.s = +t, this.l = +g, this.opacity = +d;
}
define(Cubehelix, cubehelix$1, extend$1(Color, {
  brighter(n) {
    return n = n == null ? brighter : Math.pow(brighter, n), new Cubehelix(this.h, this.s, this.l * n, this.opacity);
  },
  darker(n) {
    return n = n == null ? darker : Math.pow(darker, n), new Cubehelix(this.h, this.s, this.l * n, this.opacity);
  },
  rgb() {
    var n = isNaN(this.h) ? 0 : (this.h + 120) * radians$1, t = +this.l, g = isNaN(this.s) ? 0 : this.s * t * (1 - t), d = Math.cos(n), k = Math.sin(n);
    return new Rgb(
      255 * (t + g * (A * d + B$2 * k)),
      255 * (t + g * (C$1 * d + D$1 * k)),
      255 * (t + g * (E * d)),
      this.opacity
    );
  }
}));
function basis(n, t, g, d, k) {
  var H = n * n, AA = H * n;
  return ((1 - 3 * n + 3 * H - AA) * t + (4 - 6 * H + 3 * AA) * g + (1 + 3 * n + 3 * H - 3 * AA) * d + AA * k) / 6;
}
function basis$1(n) {
  var t = n.length - 1;
  return function(g) {
    var d = g <= 0 ? g = 0 : g >= 1 ? (g = 1, t - 1) : Math.floor(g * t), k = n[d], H = n[d + 1], AA = d > 0 ? n[d - 1] : 2 * k - H, gA = d < t - 1 ? n[d + 2] : 2 * H - k;
    return basis((g - d / t) * t, AA, k, H, gA);
  };
}
function basisClosed(n) {
  var t = n.length;
  return function(g) {
    var d = Math.floor(((g %= 1) < 0 ? ++g : g) * t), k = n[(d + t - 1) % t], H = n[d % t], AA = n[(d + 1) % t], gA = n[(d + 2) % t];
    return basis((g - d / t) * t, k, H, AA, gA);
  };
}
const constant$3 = (n) => () => n;
function linear$1(n, t) {
  return function(g) {
    return n + g * t;
  };
}
function exponential(n, t, g) {
  return n = Math.pow(n, g), t = Math.pow(t, g) - n, g = 1 / g, function(d) {
    return Math.pow(n + d * t, g);
  };
}
function hue$1(n, t) {
  var g = t - n;
  return g ? linear$1(n, g > 180 || g < -180 ? g - 360 * Math.round(g / 360) : g) : constant$3(isNaN(n) ? t : n);
}
function gamma(n) {
  return (n = +n) == 1 ? nogamma : function(t, g) {
    return g - t ? exponential(t, g, n) : constant$3(isNaN(t) ? g : t);
  };
}
function nogamma(n, t) {
  var g = t - n;
  return g ? linear$1(n, g) : constant$3(isNaN(n) ? t : n);
}
const interpolateRgb = (function n(t) {
  var g = gamma(t);
  function d(k, H) {
    var AA = g((k = rgb$1(k)).r, (H = rgb$1(H)).r), gA = g(k.g, H.g), IA = g(k.b, H.b), CA = nogamma(k.opacity, H.opacity);
    return function(BA) {
      return k.r = AA(BA), k.g = gA(BA), k.b = IA(BA), k.opacity = CA(BA), k + "";
    };
  }
  return d.gamma = n, d;
})(1);
function rgbSpline(n) {
  return function(t) {
    var g = t.length, d = new Array(g), k = new Array(g), H = new Array(g), AA, gA;
    for (AA = 0; AA < g; ++AA)
      gA = rgb$1(t[AA]), d[AA] = gA.r || 0, k[AA] = gA.g || 0, H[AA] = gA.b || 0;
    return d = n(d), k = n(k), H = n(H), gA.opacity = 1, function(IA) {
      return gA.r = d(IA), gA.g = k(IA), gA.b = H(IA), gA + "";
    };
  };
}
var rgbBasis = rgbSpline(basis$1), rgbBasisClosed = rgbSpline(basisClosed);
function numberArray(n, t) {
  t || (t = []);
  var g = n ? Math.min(t.length, n.length) : 0, d = t.slice(), k;
  return function(H) {
    for (k = 0; k < g; ++k) d[k] = n[k] * (1 - H) + t[k] * H;
    return d;
  };
}
function isNumberArray(n) {
  return ArrayBuffer.isView(n) && !(n instanceof DataView);
}
function array$4(n, t) {
  return (isNumberArray(t) ? numberArray : genericArray)(n, t);
}
function genericArray(n, t) {
  var g = t ? t.length : 0, d = n ? Math.min(g, n.length) : 0, k = new Array(d), H = new Array(g), AA;
  for (AA = 0; AA < d; ++AA) k[AA] = interpolate$2(n[AA], t[AA]);
  for (; AA < g; ++AA) H[AA] = t[AA];
  return function(gA) {
    for (AA = 0; AA < d; ++AA) H[AA] = k[AA](gA);
    return H;
  };
}
function date$1(n, t) {
  var g = /* @__PURE__ */ new Date();
  return n = +n, t = +t, function(d) {
    return g.setTime(n * (1 - d) + t * d), g;
  };
}
function interpolateNumber(n, t) {
  return n = +n, t = +t, function(g) {
    return n * (1 - g) + t * g;
  };
}
function object$1(n, t) {
  var g = {}, d = {}, k;
  (n === null || typeof n != "object") && (n = {}), (t === null || typeof t != "object") && (t = {});
  for (k in t)
    k in n ? g[k] = interpolate$2(n[k], t[k]) : d[k] = t[k];
  return function(H) {
    for (k in g) d[k] = g[k](H);
    return d;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero$2(n) {
  return function() {
    return n;
  };
}
function one$1(n) {
  return function(t) {
    return n(t) + "";
  };
}
function interpolateString(n, t) {
  var g = reA.lastIndex = reB.lastIndex = 0, d, k, H, AA = -1, gA = [], IA = [];
  for (n = n + "", t = t + ""; (d = reA.exec(n)) && (k = reB.exec(t)); )
    (H = k.index) > g && (H = t.slice(g, H), gA[AA] ? gA[AA] += H : gA[++AA] = H), (d = d[0]) === (k = k[0]) ? gA[AA] ? gA[AA] += k : gA[++AA] = k : (gA[++AA] = null, IA.push({ i: AA, x: interpolateNumber(d, k) })), g = reB.lastIndex;
  return g < t.length && (H = t.slice(g), gA[AA] ? gA[AA] += H : gA[++AA] = H), gA.length < 2 ? IA[0] ? one$1(IA[0].x) : zero$2(t) : (t = IA.length, function(CA) {
    for (var BA = 0, eA; BA < t; ++BA) gA[(eA = IA[BA]).i] = eA.x(CA);
    return gA.join("");
  });
}
function interpolate$2(n, t) {
  var g = typeof t, d;
  return t == null || g === "boolean" ? constant$3(t) : (g === "number" ? interpolateNumber : g === "string" ? (d = color$3(t)) ? (t = d, interpolateRgb) : interpolateString : t instanceof color$3 ? interpolateRgb : t instanceof Date ? date$1 : isNumberArray(t) ? numberArray : Array.isArray(t) ? genericArray : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? object$1 : interpolateNumber)(n, t);
}
function discrete$1(n) {
  var t = n.length;
  return function(g) {
    return n[Math.max(0, Math.min(t - 1, Math.floor(g * t)))];
  };
}
function hue(n, t) {
  var g = hue$1(+n, +t);
  return function(d) {
    var k = g(d);
    return k - 360 * Math.floor(k / 360);
  };
}
function interpolateRound(n, t) {
  return n = +n, t = +t, function(g) {
    return Math.round(n * (1 - g) + t * g);
  };
}
var degrees$1 = 180 / Math.PI, identity$5 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function decompose(n, t, g, d, k, H) {
  var AA, gA, IA;
  return (AA = Math.sqrt(n * n + t * t)) && (n /= AA, t /= AA), (IA = n * g + t * d) && (g -= n * IA, d -= t * IA), (gA = Math.sqrt(g * g + d * d)) && (g /= gA, d /= gA, IA /= gA), n * d < t * g && (n = -n, t = -t, IA = -IA, AA = -AA), {
    translateX: k,
    translateY: H,
    rotate: Math.atan2(t, n) * degrees$1,
    skewX: Math.atan(IA) * degrees$1,
    scaleX: AA,
    scaleY: gA
  };
}
var svgNode;
function parseCss(n) {
  const t = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(n + "");
  return t.isIdentity ? identity$5 : decompose(t.a, t.b, t.c, t.d, t.e, t.f);
}
function parseSvg(n) {
  return n == null || (svgNode || (svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g")), svgNode.setAttribute("transform", n), !(n = svgNode.transform.baseVal.consolidate())) ? identity$5 : (n = n.matrix, decompose(n.a, n.b, n.c, n.d, n.e, n.f));
}
function interpolateTransform(n, t, g, d) {
  function k(CA) {
    return CA.length ? CA.pop() + " " : "";
  }
  function H(CA, BA, eA, iA, QA, tA) {
    if (CA !== eA || BA !== iA) {
      var oA = QA.push("translate(", null, t, null, g);
      tA.push({ i: oA - 4, x: interpolateNumber(CA, eA) }, { i: oA - 2, x: interpolateNumber(BA, iA) });
    } else (eA || iA) && QA.push("translate(" + eA + t + iA + g);
  }
  function AA(CA, BA, eA, iA) {
    CA !== BA ? (CA - BA > 180 ? BA += 360 : BA - CA > 180 && (CA += 360), iA.push({ i: eA.push(k(eA) + "rotate(", null, d) - 2, x: interpolateNumber(CA, BA) })) : BA && eA.push(k(eA) + "rotate(" + BA + d);
  }
  function gA(CA, BA, eA, iA) {
    CA !== BA ? iA.push({ i: eA.push(k(eA) + "skewX(", null, d) - 2, x: interpolateNumber(CA, BA) }) : BA && eA.push(k(eA) + "skewX(" + BA + d);
  }
  function IA(CA, BA, eA, iA, QA, tA) {
    if (CA !== eA || BA !== iA) {
      var oA = QA.push(k(QA) + "scale(", null, ",", null, ")");
      tA.push({ i: oA - 4, x: interpolateNumber(CA, eA) }, { i: oA - 2, x: interpolateNumber(BA, iA) });
    } else (eA !== 1 || iA !== 1) && QA.push(k(QA) + "scale(" + eA + "," + iA + ")");
  }
  return function(CA, BA) {
    var eA = [], iA = [];
    return CA = n(CA), BA = n(BA), H(CA.translateX, CA.translateY, BA.translateX, BA.translateY, eA, iA), AA(CA.rotate, BA.rotate, eA, iA), gA(CA.skewX, BA.skewX, eA, iA), IA(CA.scaleX, CA.scaleY, BA.scaleX, BA.scaleY, eA, iA), CA = BA = null, function(QA) {
      for (var tA = -1, oA = iA.length, EA; ++tA < oA; ) eA[(EA = iA[tA]).i] = EA.x(QA);
      return eA.join("");
    };
  };
}
var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)"), interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")"), epsilon2$1 = 1e-12;
function cosh(n) {
  return ((n = Math.exp(n)) + 1 / n) / 2;
}
function sinh(n) {
  return ((n = Math.exp(n)) - 1 / n) / 2;
}
function tanh(n) {
  return ((n = Math.exp(2 * n)) - 1) / (n + 1);
}
const interpolateZoom = (function n(t, g, d) {
  function k(H, AA) {
    var gA = H[0], IA = H[1], CA = H[2], BA = AA[0], eA = AA[1], iA = AA[2], QA = BA - gA, tA = eA - IA, oA = QA * QA + tA * tA, EA, aA;
    if (oA < epsilon2$1)
      aA = Math.log(iA / CA) / t, EA = function(uA) {
        return [
          gA + uA * QA,
          IA + uA * tA,
          CA * Math.exp(t * uA * aA)
        ];
      };
    else {
      var nA = Math.sqrt(oA), lA = (iA * iA - CA * CA + d * oA) / (2 * CA * g * nA), cA = (iA * iA - CA * CA - d * oA) / (2 * iA * g * nA), sA = Math.log(Math.sqrt(lA * lA + 1) - lA), rA = Math.log(Math.sqrt(cA * cA + 1) - cA);
      aA = (rA - sA) / t, EA = function(uA) {
        var hA = uA * aA, dA = cosh(sA), GA = CA / (g * nA) * (dA * tanh(t * hA + sA) - sinh(sA));
        return [
          gA + GA * QA,
          IA + GA * tA,
          CA * dA / cosh(t * hA + sA)
        ];
      };
    }
    return EA.duration = aA * 1e3 * t / Math.SQRT2, EA;
  }
  return k.rho = function(H) {
    var AA = Math.max(1e-3, +H), gA = AA * AA, IA = gA * gA;
    return n(AA, gA, IA);
  }, k;
})(Math.SQRT2, 2, 4);
function hsl(n) {
  return function(t, g) {
    var d = n((t = hsl$1(t)).h, (g = hsl$1(g)).h), k = nogamma(t.s, g.s), H = nogamma(t.l, g.l), AA = nogamma(t.opacity, g.opacity);
    return function(gA) {
      return t.h = d(gA), t.s = k(gA), t.l = H(gA), t.opacity = AA(gA), t + "";
    };
  };
}
const hsl_default = hsl(hue$1);
var hslLong = hsl(nogamma);
function lab(n, t) {
  var g = nogamma((n = lab$1(n)).l, (t = lab$1(t)).l), d = nogamma(n.a, t.a), k = nogamma(n.b, t.b), H = nogamma(n.opacity, t.opacity);
  return function(AA) {
    return n.l = g(AA), n.a = d(AA), n.b = k(AA), n.opacity = H(AA), n + "";
  };
}
function hcl(n) {
  return function(t, g) {
    var d = n((t = hcl$1(t)).h, (g = hcl$1(g)).h), k = nogamma(t.c, g.c), H = nogamma(t.l, g.l), AA = nogamma(t.opacity, g.opacity);
    return function(gA) {
      return t.h = d(gA), t.c = k(gA), t.l = H(gA), t.opacity = AA(gA), t + "";
    };
  };
}
const hcl_default = hcl(hue$1);
var hclLong = hcl(nogamma);
function cubehelix(n) {
  return (function t(g) {
    g = +g;
    function d(k, H) {
      var AA = n((k = cubehelix$1(k)).h, (H = cubehelix$1(H)).h), gA = nogamma(k.s, H.s), IA = nogamma(k.l, H.l), CA = nogamma(k.opacity, H.opacity);
      return function(BA) {
        return k.h = AA(BA), k.s = gA(BA), k.l = IA(Math.pow(BA, g)), k.opacity = CA(BA), k + "";
      };
    }
    return d.gamma = t, d;
  })(1);
}
const cubehelix_default = cubehelix(hue$1);
var cubehelixLong = cubehelix(nogamma);
function piecewise(n, t) {
  t === void 0 && (t = n, n = interpolate$2);
  for (var g = 0, d = t.length - 1, k = t[0], H = new Array(d < 0 ? 0 : d); g < d; ) H[g] = n(k, k = t[++g]);
  return function(AA) {
    var gA = Math.max(0, Math.min(d - 1, Math.floor(AA *= d)));
    return H[gA](AA - gA);
  };
}
function quantize$2(n, t) {
  for (var g = new Array(t), d = 0; d < t; ++d) g[d] = n(d / (t - 1));
  return g;
}
const $$1$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  interpolate: interpolate$2,
  interpolateArray: array$4,
  interpolateBasis: basis$1,
  interpolateBasisClosed: basisClosed,
  interpolateCubehelix: cubehelix_default,
  interpolateCubehelixLong: cubehelixLong,
  interpolateDate: date$1,
  interpolateDiscrete: discrete$1,
  interpolateHcl: hcl_default,
  interpolateHclLong: hclLong,
  interpolateHsl: hsl_default,
  interpolateHslLong: hslLong,
  interpolateHue: hue,
  interpolateLab: lab,
  interpolateNumber,
  interpolateNumberArray: numberArray,
  interpolateObject: object$1,
  interpolateRgb,
  interpolateRgbBasis: rgbBasis,
  interpolateRgbBasisClosed: rgbBasisClosed,
  interpolateRound,
  interpolateString,
  interpolateTransformCss,
  interpolateTransformSvg,
  interpolateZoom,
  piecewise,
  quantize: quantize$2
}, Symbol.toStringTag, { value: "Module" }));
function constants$1(n) {
  return function() {
    return n;
  };
}
function number$5(n) {
  return +n;
}
var unit = [0, 1];
function identity$4(n) {
  return n;
}
function normalize$2(n, t) {
  return (t -= n = +n) ? function(g) {
    return (g - n) / t;
  } : constants$1(isNaN(t) ? NaN : 0.5);
}
function clamper(n, t) {
  var g;
  return n > t && (g = n, n = t, t = g), function(d) {
    return Math.max(n, Math.min(t, d));
  };
}
function bimap(n, t, g) {
  var d = n[0], k = n[1], H = t[0], AA = t[1];
  return k < d ? (d = normalize$2(k, d), H = g(AA, H)) : (d = normalize$2(d, k), H = g(H, AA)), function(gA) {
    return H(d(gA));
  };
}
function polymap(n, t, g) {
  var d = Math.min(n.length, t.length) - 1, k = new Array(d), H = new Array(d), AA = -1;
  for (n[d] < n[0] && (n = n.slice().reverse(), t = t.slice().reverse()); ++AA < d; )
    k[AA] = normalize$2(n[AA], n[AA + 1]), H[AA] = g(t[AA], t[AA + 1]);
  return function(gA) {
    var IA = bisectRight$1(n, gA, 1, d) - 1;
    return H[IA](k[IA](gA));
  };
}
function copy$2(n, t) {
  return t.domain(n.domain()).range(n.range()).interpolate(n.interpolate()).clamp(n.clamp()).unknown(n.unknown());
}
function transformer$3() {
  var n = unit, t = unit, g = interpolate$2, d, k, H, AA = identity$4, gA, IA, CA;
  function BA() {
    var iA = Math.min(n.length, t.length);
    return AA !== identity$4 && (AA = clamper(n[0], n[iA - 1])), gA = iA > 2 ? polymap : bimap, IA = CA = null, eA;
  }
  function eA(iA) {
    return iA == null || isNaN(iA = +iA) ? H : (IA || (IA = gA(n.map(d), t, g)))(d(AA(iA)));
  }
  return eA.invert = function(iA) {
    return AA(k((CA || (CA = gA(t, n.map(d), interpolateNumber)))(iA)));
  }, eA.domain = function(iA) {
    return arguments.length ? (n = Array.from(iA, number$5), BA()) : n.slice();
  }, eA.range = function(iA) {
    return arguments.length ? (t = Array.from(iA), BA()) : t.slice();
  }, eA.rangeRound = function(iA) {
    return t = Array.from(iA), g = interpolateRound, BA();
  }, eA.clamp = function(iA) {
    return arguments.length ? (AA = iA ? !0 : identity$4, BA()) : AA !== identity$4;
  }, eA.interpolate = function(iA) {
    return arguments.length ? (g = iA, BA()) : g;
  }, eA.unknown = function(iA) {
    return arguments.length ? (H = iA, eA) : H;
  }, function(iA, QA) {
    return d = iA, k = QA, BA();
  };
}
function continuous$1() {
  return transformer$3()(identity$4, identity$4);
}
function tickFormat$1(n, t, g, d) {
  var k = tickStep(n, t, g), H;
  switch (d = formatSpecifier(d ?? ",f"), d.type) {
    case "s": {
      var AA = Math.max(Math.abs(n), Math.abs(t));
      return d.precision == null && !isNaN(H = precisionPrefix(k, AA)) && (d.precision = H), formatPrefix(d, AA);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      d.precision == null && !isNaN(H = precisionRound(k, Math.max(Math.abs(n), Math.abs(t)))) && (d.precision = H - (d.type === "e"));
      break;
    }
    case "f":
    case "%": {
      d.precision == null && !isNaN(H = precisionFixed(k)) && (d.precision = H - (d.type === "%") * 2);
      break;
    }
  }
  return format$3(d);
}
function linearish(n) {
  var t = n.domain;
  return n.ticks = function(g) {
    var d = t();
    return ticks(d[0], d[d.length - 1], g ?? 10);
  }, n.tickFormat = function(g, d) {
    var k = t();
    return tickFormat$1(k[0], k[k.length - 1], g ?? 10, d);
  }, n.nice = function(g) {
    g == null && (g = 10);
    var d = t(), k = 0, H = d.length - 1, AA = d[k], gA = d[H], IA, CA, BA = 10;
    for (gA < AA && (CA = AA, AA = gA, gA = CA, CA = k, k = H, H = CA); BA-- > 0; ) {
      if (CA = tickIncrement(AA, gA, g), CA === IA)
        return d[k] = AA, d[H] = gA, t(d);
      if (CA > 0)
        AA = Math.floor(AA / CA) * CA, gA = Math.ceil(gA / CA) * CA;
      else if (CA < 0)
        AA = Math.ceil(AA * CA) / CA, gA = Math.floor(gA * CA) / CA;
      else
        break;
      IA = CA;
    }
    return n;
  }, n;
}
function linear() {
  var n = continuous$1();
  return n.copy = function() {
    return copy$2(n, linear());
  }, initRange.apply(n, arguments), linearish(n);
}
function identity$3(n) {
  var t;
  function g(d) {
    return d == null || isNaN(d = +d) ? t : d;
  }
  return g.invert = g, g.domain = g.range = function(d) {
    return arguments.length ? (n = Array.from(d, number$5), g) : n.slice();
  }, g.unknown = function(d) {
    return arguments.length ? (t = d, g) : t;
  }, g.copy = function() {
    return identity$3(n).unknown(t);
  }, n = arguments.length ? Array.from(n, number$5) : [0, 1], linearish(g);
}
function nice$1(n, t) {
  n = n.slice();
  var g = 0, d = n.length - 1, k = n[g], H = n[d], AA;
  return H < k && (AA = g, g = d, d = AA, AA = k, k = H, H = AA), n[g] = t.floor(k), n[d] = t.ceil(H), n;
}
function transformLog(n) {
  return Math.log(n);
}
function transformExp(n) {
  return Math.exp(n);
}
function transformLogn(n) {
  return -Math.log(-n);
}
function transformExpn(n) {
  return -Math.exp(-n);
}
function pow10(n) {
  return isFinite(n) ? +("1e" + n) : n < 0 ? 0 : n;
}
function powp(n) {
  return n === 10 ? pow10 : n === Math.E ? Math.exp : (t) => Math.pow(n, t);
}
function logp(n) {
  return n === Math.E ? Math.log : n === 10 && Math.log10 || n === 2 && Math.log2 || (n = Math.log(n), (t) => Math.log(t) / n);
}
function reflect(n) {
  return (t, g) => -n(-t, g);
}
function loggish(n) {
  const t = n(transformLog, transformExp), g = t.domain;
  let d = 10, k, H;
  function AA() {
    return k = logp(d), H = powp(d), g()[0] < 0 ? (k = reflect(k), H = reflect(H), n(transformLogn, transformExpn)) : n(transformLog, transformExp), t;
  }
  return t.base = function(gA) {
    return arguments.length ? (d = +gA, AA()) : d;
  }, t.domain = function(gA) {
    return arguments.length ? (g(gA), AA()) : g();
  }, t.ticks = (gA) => {
    const IA = g();
    let CA = IA[0], BA = IA[IA.length - 1];
    const eA = BA < CA;
    eA && ([CA, BA] = [BA, CA]);
    let iA = k(CA), QA = k(BA), tA, oA;
    const EA = gA == null ? 10 : +gA;
    let aA = [];
    if (!(d % 1) && QA - iA < EA) {
      if (iA = Math.floor(iA), QA = Math.ceil(QA), CA > 0) {
        for (; iA <= QA; ++iA)
          for (tA = 1; tA < d; ++tA)
            if (oA = iA < 0 ? tA / H(-iA) : tA * H(iA), !(oA < CA)) {
              if (oA > BA) break;
              aA.push(oA);
            }
      } else for (; iA <= QA; ++iA)
        for (tA = d - 1; tA >= 1; --tA)
          if (oA = iA > 0 ? tA / H(-iA) : tA * H(iA), !(oA < CA)) {
            if (oA > BA) break;
            aA.push(oA);
          }
      aA.length * 2 < EA && (aA = ticks(CA, BA, EA));
    } else
      aA = ticks(iA, QA, Math.min(QA - iA, EA)).map(H);
    return eA ? aA.reverse() : aA;
  }, t.tickFormat = (gA, IA) => {
    if (gA == null && (gA = 10), IA == null && (IA = d === 10 ? "s" : ","), typeof IA != "function" && (!(d % 1) && (IA = formatSpecifier(IA)).precision == null && (IA.trim = !0), IA = format$3(IA)), gA === 1 / 0) return IA;
    const CA = Math.max(1, d * gA / t.ticks().length);
    return (BA) => {
      let eA = BA / H(Math.round(k(BA)));
      return eA * d < d - 0.5 && (eA *= d), eA <= CA ? IA(BA) : "";
    };
  }, t.nice = () => g(nice$1(g(), {
    floor: (gA) => H(Math.floor(k(gA))),
    ceil: (gA) => H(Math.ceil(k(gA)))
  })), t;
}
function log$3() {
  const n = loggish(transformer$3()).domain([1, 10]);
  return n.copy = () => copy$2(n, log$3()).base(n.base()), initRange.apply(n, arguments), n;
}
function transformSymlog(n) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / n));
  };
}
function transformSymexp(n) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * n;
  };
}
function symlogish(n) {
  var t = 1, g = n(transformSymlog(t), transformSymexp(t));
  return g.constant = function(d) {
    return arguments.length ? n(transformSymlog(t = +d), transformSymexp(t)) : t;
  }, linearish(g);
}
function symlog() {
  var n = symlogish(transformer$3());
  return n.copy = function() {
    return copy$2(n, symlog()).constant(n.constant());
  }, initRange.apply(n, arguments);
}
function transformPow(n) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, n) : Math.pow(t, n);
  };
}
function transformSqrt(n) {
  return n < 0 ? -Math.sqrt(-n) : Math.sqrt(n);
}
function transformSquare(n) {
  return n < 0 ? -n * n : n * n;
}
function powish(n) {
  var t = n(identity$4, identity$4), g = 1;
  function d() {
    return g === 1 ? n(identity$4, identity$4) : g === 0.5 ? n(transformSqrt, transformSquare) : n(transformPow(g), transformPow(1 / g));
  }
  return t.exponent = function(k) {
    return arguments.length ? (g = +k, d()) : g;
  }, linearish(t);
}
function pow$2() {
  var n = powish(transformer$3());
  return n.copy = function() {
    return copy$2(n, pow$2()).exponent(n.exponent());
  }, initRange.apply(n, arguments), n;
}
function sqrt$2() {
  return pow$2.apply(null, arguments).exponent(0.5);
}
function quantile() {
  var n = [], t = [], g = [], d;
  function k() {
    var AA = 0, gA = Math.max(1, t.length);
    for (g = new Array(gA - 1); ++AA < gA; ) g[AA - 1] = quantileSorted(n, AA / gA);
    return H;
  }
  function H(AA) {
    return AA == null || isNaN(AA = +AA) ? d : t[bisectRight$1(g, AA)];
  }
  return H.invertExtent = function(AA) {
    var gA = t.indexOf(AA);
    return gA < 0 ? [NaN, NaN] : [
      gA > 0 ? g[gA - 1] : n[0],
      gA < g.length ? g[gA] : n[n.length - 1]
    ];
  }, H.domain = function(AA) {
    if (!arguments.length) return n.slice();
    n = [];
    for (let gA of AA) gA != null && !isNaN(gA = +gA) && n.push(gA);
    return n.sort(ascending$1), k();
  }, H.range = function(AA) {
    return arguments.length ? (t = Array.from(AA), k()) : t.slice();
  }, H.unknown = function(AA) {
    return arguments.length ? (d = AA, H) : d;
  }, H.quantiles = function() {
    return g.slice();
  }, H.copy = function() {
    return quantile().domain(n).range(t).unknown(d);
  }, initRange.apply(H, arguments);
}
function quantize$1() {
  var n = 0, t = 1, g = 1, d = [0.5], k = [0, 1], H;
  function AA(IA) {
    return IA != null && IA <= IA ? k[bisectRight$1(d, IA, 0, g)] : H;
  }
  function gA() {
    var IA = -1;
    for (d = new Array(g); ++IA < g; ) d[IA] = ((IA + 1) * t - (IA - g) * n) / (g + 1);
    return AA;
  }
  return AA.domain = function(IA) {
    return arguments.length ? ([n, t] = IA, n = +n, t = +t, gA()) : [n, t];
  }, AA.range = function(IA) {
    return arguments.length ? (g = (k = Array.from(IA)).length - 1, gA()) : k.slice();
  }, AA.invertExtent = function(IA) {
    var CA = k.indexOf(IA);
    return CA < 0 ? [NaN, NaN] : CA < 1 ? [n, d[0]] : CA >= g ? [d[g - 1], t] : [d[CA - 1], d[CA]];
  }, AA.unknown = function(IA) {
    return arguments.length && (H = IA), AA;
  }, AA.thresholds = function() {
    return d.slice();
  }, AA.copy = function() {
    return quantize$1().domain([n, t]).range(k).unknown(H);
  }, initRange.apply(linearish(AA), arguments);
}
function threshold() {
  var n = [0.5], t = [0, 1], g, d = 1;
  function k(H) {
    return H != null && H <= H ? t[bisectRight$1(n, H, 0, d)] : g;
  }
  return k.domain = function(H) {
    return arguments.length ? (n = Array.from(H), d = Math.min(n.length, t.length - 1), k) : n.slice();
  }, k.range = function(H) {
    return arguments.length ? (t = Array.from(H), d = Math.min(n.length, t.length - 1), k) : t.slice();
  }, k.invertExtent = function(H) {
    var AA = t.indexOf(H);
    return [n[AA - 1], n[AA]];
  }, k.unknown = function(H) {
    return arguments.length ? (g = H, k) : g;
  }, k.copy = function() {
    return threshold().domain(n).range(t).unknown(g);
  }, initRange.apply(k, arguments);
}
function date(n) {
  return new Date(n);
}
function number$4(n) {
  return n instanceof Date ? +n : +/* @__PURE__ */ new Date(+n);
}
function calendar(n, t, g, d, k, H, AA, gA, IA, CA) {
  var BA = continuous$1(), eA = BA.invert, iA = BA.domain, QA = CA(".%L"), tA = CA(":%S"), oA = CA("%I:%M"), EA = CA("%I %p"), aA = CA("%a %d"), nA = CA("%b %d"), lA = CA("%B"), cA = CA("%Y");
  function sA(rA) {
    return (IA(rA) < rA ? QA : gA(rA) < rA ? tA : AA(rA) < rA ? oA : H(rA) < rA ? EA : d(rA) < rA ? k(rA) < rA ? aA : nA : g(rA) < rA ? lA : cA)(rA);
  }
  return BA.invert = function(rA) {
    return new Date(eA(rA));
  }, BA.domain = function(rA) {
    return arguments.length ? iA(Array.from(rA, number$4)) : iA().map(date);
  }, BA.ticks = function(rA) {
    var uA = iA();
    return n(uA[0], uA[uA.length - 1], rA ?? 10);
  }, BA.tickFormat = function(rA, uA) {
    return uA == null ? sA : CA(uA);
  }, BA.nice = function(rA) {
    var uA = iA();
    return (!rA || typeof rA.range != "function") && (rA = t(uA[0], uA[uA.length - 1], rA ?? 10)), rA ? iA(nice$1(uA, rA)) : BA;
  }, BA.copy = function() {
    return copy$2(BA, calendar(n, t, g, d, k, H, AA, gA, IA, CA));
  }, BA;
}
function time$1() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, timeFormat$2).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, utcFormat$1).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function transformer$2() {
  var n = 0, t = 1, g, d, k, H, AA = identity$4, gA = !1, IA;
  function CA(eA) {
    return eA == null || isNaN(eA = +eA) ? IA : AA(k === 0 ? 0.5 : (eA = (H(eA) - g) * k, gA ? Math.max(0, Math.min(1, eA)) : eA));
  }
  CA.domain = function(eA) {
    return arguments.length ? ([n, t] = eA, g = H(n = +n), d = H(t = +t), k = g === d ? 0 : 1 / (d - g), CA) : [n, t];
  }, CA.clamp = function(eA) {
    return arguments.length ? (gA = !!eA, CA) : gA;
  }, CA.interpolator = function(eA) {
    return arguments.length ? (AA = eA, CA) : AA;
  };
  function BA(eA) {
    return function(iA) {
      var QA, tA;
      return arguments.length ? ([QA, tA] = iA, AA = eA(QA, tA), CA) : [AA(0), AA(1)];
    };
  }
  return CA.range = BA(interpolate$2), CA.rangeRound = BA(interpolateRound), CA.unknown = function(eA) {
    return arguments.length ? (IA = eA, CA) : IA;
  }, function(eA) {
    return H = eA, g = eA(n), d = eA(t), k = g === d ? 0 : 1 / (d - g), CA;
  };
}
function copy$1(n, t) {
  return t.domain(n.domain()).interpolator(n.interpolator()).clamp(n.clamp()).unknown(n.unknown());
}
function sequential() {
  var n = linearish(transformer$2()(identity$4));
  return n.copy = function() {
    return copy$1(n, sequential());
  }, initInterpolator.apply(n, arguments);
}
function sequentialLog() {
  var n = loggish(transformer$2()).domain([1, 10]);
  return n.copy = function() {
    return copy$1(n, sequentialLog()).base(n.base());
  }, initInterpolator.apply(n, arguments);
}
function sequentialSymlog() {
  var n = symlogish(transformer$2());
  return n.copy = function() {
    return copy$1(n, sequentialSymlog()).constant(n.constant());
  }, initInterpolator.apply(n, arguments);
}
function sequentialPow() {
  var n = powish(transformer$2());
  return n.copy = function() {
    return copy$1(n, sequentialPow()).exponent(n.exponent());
  }, initInterpolator.apply(n, arguments);
}
function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}
function transformer$1() {
  var n = 0, t = 0.5, g = 1, d = 1, k, H, AA, gA, IA, CA = identity$4, BA, eA = !1, iA;
  function QA(oA) {
    return isNaN(oA = +oA) ? iA : (oA = 0.5 + ((oA = +BA(oA)) - H) * (d * oA < d * H ? gA : IA), CA(eA ? Math.max(0, Math.min(1, oA)) : oA));
  }
  QA.domain = function(oA) {
    return arguments.length ? ([n, t, g] = oA, k = BA(n = +n), H = BA(t = +t), AA = BA(g = +g), gA = k === H ? 0 : 0.5 / (H - k), IA = H === AA ? 0 : 0.5 / (AA - H), d = H < k ? -1 : 1, QA) : [n, t, g];
  }, QA.clamp = function(oA) {
    return arguments.length ? (eA = !!oA, QA) : eA;
  }, QA.interpolator = function(oA) {
    return arguments.length ? (CA = oA, QA) : CA;
  };
  function tA(oA) {
    return function(EA) {
      var aA, nA, lA;
      return arguments.length ? ([aA, nA, lA] = EA, CA = piecewise(oA, [aA, nA, lA]), QA) : [CA(0), CA(0.5), CA(1)];
    };
  }
  return QA.range = tA(interpolate$2), QA.rangeRound = tA(interpolateRound), QA.unknown = function(oA) {
    return arguments.length ? (iA = oA, QA) : iA;
  }, function(oA) {
    return BA = oA, k = oA(n), H = oA(t), AA = oA(g), gA = k === H ? 0 : 0.5 / (H - k), IA = H === AA ? 0 : 0.5 / (AA - H), d = H < k ? -1 : 1, QA;
  };
}
function diverging() {
  var n = linearish(transformer$1()(identity$4));
  return n.copy = function() {
    return copy$1(n, diverging());
  }, initInterpolator.apply(n, arguments);
}
function divergingLog() {
  var n = loggish(transformer$1()).domain([0.1, 1, 10]);
  return n.copy = function() {
    return copy$1(n, divergingLog()).base(n.base());
  }, initInterpolator.apply(n, arguments);
}
function divergingSymlog() {
  var n = symlogish(transformer$1());
  return n.copy = function() {
    return copy$1(n, divergingSymlog()).constant(n.constant());
  }, initInterpolator.apply(n, arguments);
}
function divergingPow() {
  var n = powish(transformer$1());
  return n.copy = function() {
    return copy$1(n, divergingPow()).exponent(n.exponent());
  }, initInterpolator.apply(n, arguments);
}
function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}
function colors$1(n) {
  for (var t = n.length / 6 | 0, g = new Array(t), d = 0; d < t; ) g[d] = "#" + n.slice(d * 6, ++d * 6);
  return g;
}
const schemeCategory10 = colors$1("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), schemeAccent = colors$1("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"), schemeDark2 = colors$1("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"), schemeObservable10 = colors$1("4269d0efb118ff725c6cc5b03ca951ff8ab7a463f297bbf59c6b4e9498a0"), schemePaired = colors$1("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"), schemePastel1 = colors$1("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"), schemePastel2 = colors$1("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"), schemeSet1 = colors$1("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"), schemeSet2 = colors$1("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"), schemeSet3 = colors$1("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
function bandSpace(n, t, g) {
  const d = n - t + g * 2;
  return n ? d > 0 ? d : 1 : 0;
}
const Identity = "identity", Linear = "linear", Log = "log", Pow = "pow", Sqrt = "sqrt", Symlog = "symlog", Time = "time", UTC = "utc", Sequential = "sequential", Diverging = "diverging", Quantile = "quantile", Quantize = "quantize", Threshold = "threshold", Ordinal = "ordinal", Point = "point", Band = "band", BinOrdinal = "bin-ordinal", Continuous = "continuous", Discrete$1 = "discrete", Discretizing = "discretizing", Interpolating = "interpolating", Temporal = "temporal";
function invertRange(n) {
  return function(t) {
    let g = t[0], d = t[1], k;
    return d < g && (k = g, g = d, d = k), [n.invert(g), n.invert(d)];
  };
}
function invertRangeExtent(n) {
  return function(t) {
    const g = n.range();
    let d = t[0], k = t[1], H = -1, AA, gA, IA, CA;
    for (k < d && (gA = d, d = k, k = gA), IA = 0, CA = g.length; IA < CA; ++IA)
      g[IA] >= d && g[IA] <= k && (H < 0 && (H = IA), AA = IA);
    if (!(H < 0))
      return d = n.invertExtent(g[H]), k = n.invertExtent(g[AA]), [d[0] === void 0 ? d[1] : d[0], k[1] === void 0 ? k[0] : k[1]];
  };
}
function band() {
  const n = ordinal().unknown(void 0), t = n.domain, g = n.range;
  let d = [0, 1], k, H, AA = !1, gA = 0, IA = 0, CA = 0.5;
  delete n.unknown;
  function BA() {
    const eA = t().length, iA = d[1] < d[0], QA = d[1 - iA], tA = bandSpace(eA, gA, IA);
    let oA = d[iA - 0];
    k = (QA - oA) / (tA || 1), AA && (k = Math.floor(k)), oA += (QA - oA - k * (eA - gA)) * CA, H = k * (1 - gA), AA && (oA = Math.round(oA), H = Math.round(H));
    const EA = range$5(eA).map((aA) => oA + k * aA);
    return g(iA ? EA.reverse() : EA);
  }
  return n.domain = function(eA) {
    return arguments.length ? (t(eA), BA()) : t();
  }, n.range = function(eA) {
    return arguments.length ? (d = [+eA[0], +eA[1]], BA()) : d.slice();
  }, n.rangeRound = function(eA) {
    return d = [+eA[0], +eA[1]], AA = !0, BA();
  }, n.bandwidth = function() {
    return H;
  }, n.step = function() {
    return k;
  }, n.round = function(eA) {
    return arguments.length ? (AA = !!eA, BA()) : AA;
  }, n.padding = function(eA) {
    return arguments.length ? (IA = Math.max(0, Math.min(1, eA)), gA = IA, BA()) : gA;
  }, n.paddingInner = function(eA) {
    return arguments.length ? (gA = Math.max(0, Math.min(1, eA)), BA()) : gA;
  }, n.paddingOuter = function(eA) {
    return arguments.length ? (IA = Math.max(0, Math.min(1, eA)), BA()) : IA;
  }, n.align = function(eA) {
    return arguments.length ? (CA = Math.max(0, Math.min(1, eA)), BA()) : CA;
  }, n.invertRange = function(eA) {
    if (eA[0] == null || eA[1] == null) return;
    const iA = d[1] < d[0], QA = iA ? g().reverse() : g(), tA = QA.length - 1;
    let oA = +eA[0], EA = +eA[1], aA, nA, lA;
    if (!(oA !== oA || EA !== EA) && (EA < oA && (lA = oA, oA = EA, EA = lA), !(EA < QA[0] || oA > d[1 - iA])))
      return aA = Math.max(0, bisectRight$1(QA, oA) - 1), nA = oA === EA ? aA : bisectRight$1(QA, EA) - 1, oA - QA[aA] > H + 1e-10 && ++aA, iA && (lA = aA, aA = tA - nA, nA = tA - lA), aA > nA ? void 0 : t().slice(aA, nA + 1);
  }, n.invert = function(eA) {
    const iA = n.invertRange([eA, eA]);
    return iA && iA[0];
  }, n.copy = function() {
    return band().domain(t()).range(d).round(AA).paddingInner(gA).paddingOuter(IA).align(CA);
  }, BA();
}
function pointish(n) {
  const t = n.copy;
  return n.padding = n.paddingOuter, delete n.paddingInner, n.copy = function() {
    return pointish(t());
  }, n;
}
function point$3() {
  return pointish(band().paddingInner(1));
}
var map$1 = Array.prototype.map;
function numbers(n) {
  return map$1.call(n, toNumber$1);
}
const slice$2 = Array.prototype.slice;
function scaleBinOrdinal() {
  let n = [], t = [];
  function g(d) {
    return d == null || d !== d ? void 0 : t[(bisectRight$1(n, d) - 1) % t.length];
  }
  return g.domain = function(d) {
    return arguments.length ? (n = numbers(d), g) : n.slice();
  }, g.range = function(d) {
    return arguments.length ? (t = slice$2.call(d), g) : t.slice();
  }, g.tickFormat = function(d, k) {
    return tickFormat$1(n[0], peek$2(n), d ?? 10, k);
  }, g.copy = function() {
    return scaleBinOrdinal().domain(g.domain()).range(g.range());
  }, g;
}
const scales = /* @__PURE__ */ new Map(), VEGA_SCALE = Symbol("vega_scale");
function registerScale(n) {
  return n[VEGA_SCALE] = !0, n;
}
function isRegisteredScale(n) {
  return n && n[VEGA_SCALE] === !0;
}
function create$2(n, t, g) {
  const d = function() {
    const H = t();
    return H.invertRange || (H.invertRange = H.invert ? invertRange(H) : H.invertExtent ? invertRangeExtent(H) : void 0), H.type = n, registerScale(H);
  };
  return d.metadata = toSet(array$6(g)), d;
}
function scale$4(n, t, g) {
  return arguments.length > 1 ? (scales.set(n, create$2(n, t, g)), this) : isValidScaleType(n) ? scales.get(n) : void 0;
}
scale$4(Identity, identity$3);
scale$4(Linear, linear, Continuous);
scale$4(Log, log$3, [Continuous, Log]);
scale$4(Pow, pow$2, Continuous);
scale$4(Sqrt, sqrt$2, Continuous);
scale$4(Symlog, symlog, Continuous);
scale$4(Time, time$1, [Continuous, Temporal]);
scale$4(UTC, utcTime, [Continuous, Temporal]);
scale$4(Sequential, sequential, [Continuous, Interpolating]);
scale$4(`${Sequential}-${Linear}`, sequential, [Continuous, Interpolating]);
scale$4(`${Sequential}-${Log}`, sequentialLog, [Continuous, Interpolating, Log]);
scale$4(`${Sequential}-${Pow}`, sequentialPow, [Continuous, Interpolating]);
scale$4(`${Sequential}-${Sqrt}`, sequentialSqrt, [Continuous, Interpolating]);
scale$4(`${Sequential}-${Symlog}`, sequentialSymlog, [Continuous, Interpolating]);
scale$4(`${Diverging}-${Linear}`, diverging, [Continuous, Interpolating]);
scale$4(`${Diverging}-${Log}`, divergingLog, [Continuous, Interpolating, Log]);
scale$4(`${Diverging}-${Pow}`, divergingPow, [Continuous, Interpolating]);
scale$4(`${Diverging}-${Sqrt}`, divergingSqrt, [Continuous, Interpolating]);
scale$4(`${Diverging}-${Symlog}`, divergingSymlog, [Continuous, Interpolating]);
scale$4(Quantile, quantile, [Discretizing, Quantile]);
scale$4(Quantize, quantize$1, Discretizing);
scale$4(Threshold, threshold, Discretizing);
scale$4(BinOrdinal, scaleBinOrdinal, [Discrete$1, Discretizing]);
scale$4(Ordinal, ordinal, Discrete$1);
scale$4(Band, band, Discrete$1);
scale$4(Point, point$3, Discrete$1);
function isValidScaleType(n) {
  return scales.has(n);
}
function hasType(n, t) {
  const g = scales.get(n);
  return g && g.metadata[t];
}
function isContinuous$1(n) {
  return hasType(n, Continuous);
}
function isDiscrete$2(n) {
  return hasType(n, Discrete$1);
}
function isDiscretizing$1(n) {
  return hasType(n, Discretizing);
}
function isLogarithmic(n) {
  return hasType(n, Log);
}
function isTemporal(n) {
  return hasType(n, Temporal);
}
function isInterpolating(n) {
  return hasType(n, Interpolating);
}
function isQuantile$1(n) {
  return hasType(n, Quantile);
}
const scaleProps = ["clamp", "base", "constant", "exponent"];
function interpolateRange$1(n, t) {
  const g = t[0], d = peek$2(t) - g;
  return function(k) {
    return n(g + k * d);
  };
}
function interpolateColors(n, t, g) {
  return piecewise(interpolate$1(t || "rgb", g), n);
}
function quantizeInterpolator(n, t) {
  const g = new Array(t), d = t + 1;
  for (let k = 0; k < t; ) g[k] = n(++k / d);
  return g;
}
function scaleFraction(n, t, g) {
  const d = g - t;
  let k, H, AA;
  return !d || !Number.isFinite(d) ? constant$6(0.5) : (k = (H = n.type).indexOf("-"), H = k < 0 ? H : H.slice(k + 1), AA = scale$4(H)().domain([t, g]).range([0, 1]), scaleProps.forEach((gA) => n[gA] ? AA[gA](n[gA]()) : 0), AA);
}
function interpolate$1(n, t) {
  const g = $$1$1[method$1(n)];
  return t != null && g && g.gamma ? g.gamma(t) : g;
}
function method$1(n) {
  return "interpolate" + n.toLowerCase().split("-").map((t) => t[0].toUpperCase() + t.slice(1)).join("");
}
const continuous = {
  blues: "cfe1f2bed8eca8cee58fc1de74b2d75ba3cf4592c63181bd206fb2125ca40a4a90",
  greens: "d3eecdc0e6baabdda594d3917bc77d60ba6c46ab5e329a512089430e7735036429",
  greys: "e2e2e2d4d4d4c4c4c4b1b1b19d9d9d8888887575756262624d4d4d3535351e1e1e",
  oranges: "fdd8b3fdc998fdb87bfda55efc9244f87f2cf06b18e4580bd14904b93d029f3303",
  purples: "e2e1efd4d4e8c4c5e0b4b3d6a3a0cc928ec3827cb97566ae684ea25c3696501f8c",
  reds: "fdc9b4fcb49afc9e80fc8767fa7051f6573fec3f2fdc2a25c81b1db21218970b13",
  blueGreen: "d5efedc1e8e0a7ddd18bd2be70c6a958ba9144ad77319c5d2089460e7736036429",
  bluePurple: "ccddecbad0e4a8c2dd9ab0d4919cc98d85be8b6db28a55a6873c99822287730f71",
  greenBlue: "d3eecec5e8c3b1e1bb9bd8bb82cec269c2ca51b2cd3c9fc7288abd1675b10b60a1",
  orangeRed: "fddcaffdcf9bfdc18afdad77fb9562f67d53ee6545e24932d32d1ebf130da70403",
  purpleBlue: "dbdaebc8cee4b1c3de97b7d87bacd15b9fc93a90c01e7fb70b70ab056199045281",
  purpleBlueGreen: "dbd8eac8cee4b0c3de93b7d872acd1549fc83892bb1c88a3097f8702736b016353",
  purpleRed: "dcc9e2d3b3d7ce9eccd186c0da6bb2e14da0e23189d91e6fc61159ab07498f023a",
  redPurple: "fccfccfcbec0faa9b8f98faff571a5ec539ddb3695c41b8aa908808d0179700174",
  yellowGreen: "e4f4acd1eca0b9e2949ed68880c97c62bb6e47aa5e3297502083440e723b036034",
  yellowOrangeBrown: "feeaa1fedd84fecc63feb746fca031f68921eb7215db5e0bc54c05ab3d038f3204",
  yellowOrangeRed: "fee087fed16ffebd59fea849fd903efc7335f9522bee3423de1b20ca0b22af0225",
  blueOrange: "134b852f78b35da2cb9dcae1d2e5eff2f0ebfce0bafbbf74e8932fc5690d994a07",
  brownBlueGreen: "704108a0651ac79548e3c78af3e6c6eef1eac9e9e48ed1c74da79e187a72025147",
  purpleGreen: "5b1667834792a67fb6c9aed3e6d6e8eff0efd9efd5aedda971bb75368e490e5e29",
  purpleOrange: "4114696647968f83b7b9b4d6dadbebf3eeeafce0bafbbf74e8932fc5690d994a07",
  redBlue: "8c0d25bf363adf745ef4ae91fbdbc9f2efeed2e5ef9dcae15da2cb2f78b3134b85",
  redGrey: "8c0d25bf363adf745ef4ae91fcdccbfaf4f1e2e2e2c0c0c0969696646464343434",
  yellowGreenBlue: "eff9bddbf1b4bde5b594d5b969c5be45b4c22c9ec02182b82163aa23479c1c3185",
  redYellowBlue: "a50026d4322cf16e43fcac64fedd90faf8c1dcf1ecabd6e875abd04a74b4313695",
  redYellowGreen: "a50026d4322cf16e43fcac63fedd8df9f7aed7ee8ea4d86e64bc6122964f006837",
  pinkYellowGreen: "8e0152c0267edd72adf0b3d6faddedf5f3efe1f2cab6de8780bb474f9125276419",
  spectral: "9e0142d13c4bf0704afcac63fedd8dfbf8b0e0f3a1a9dda269bda94288b55e4fa2",
  viridis: "440154470e61481a6c482575472f7d443a834144873d4e8a39568c35608d31688e2d708e2a788e27818e23888e21918d1f988b1fa08822a8842ab07f35b77943bf7154c56866cc5d7ad1518fd744a5db36bcdf27d2e21be9e51afde725",
  magma: "0000040404130b0924150e3720114b2c11603b0f704a107957157e651a80721f817f24828c29819a2e80a8327db6377ac43c75d1426fde4968e95462f1605df76f5cfa7f5efc8f65fe9f6dfeaf78febf84fece91fddea0fcedaffcfdbf",
  inferno: "0000040403130c0826170c3b240c4f330a5f420a68500d6c5d126e6b176e781c6d86216b932667a12b62ae305cbb3755c73e4cd24644dd513ae65c30ed6925f3771af8850ffb9506fca50afcb519fac62df6d645f2e661f3f484fcffa4",
  plasma: "0d088723069033059742039d5002a25d01a66a00a87801a88405a7900da49c179ea72198b12a90ba3488c33d80cb4779d35171da5a69e16462e76e5bed7953f2834cf68f44fa9a3dfca636fdb32ffec029fcce25f9dc24f5ea27f0f921",
  cividis: "00205100235800265d002961012b65042e670831690d346b11366c16396d1c3c6e213f6e26426e2c456e31476e374a6e3c4d6e42506e47536d4c566d51586e555b6e5a5e6e5e616e62646f66676f6a6a706e6d717270717573727976737c79747f7c75827f758682768985778c8877908b78938e789691789a94789e9778a19b78a59e77a9a177aea575b2a874b6ab73bbaf71c0b26fc5b66dc9b96acebd68d3c065d8c462ddc85fe2cb5ce7cf58ebd355f0d652f3da4ff7de4cfae249fce647",
  rainbow: "6e40aa883eb1a43db3bf3cafd83fa4ee4395fe4b83ff576eff6659ff7847ff8c38f3a130e2b72fcfcc36bee044aff05b8ff4576ff65b52f6673af27828ea8d1ddfa319d0b81cbecb23abd82f96e03d82e14c6edb5a5dd0664dbf6e40aa",
  sinebow: "ff4040fc582af47218e78d0bd5a703bfbf00a7d5038de70b72f41858fc2a40ff402afc5818f4720be78d03d5a700bfbf03a7d50b8de71872f42a58fc4040ff582afc7218f48d0be7a703d5bf00bfd503a7e70b8df41872fc2a58ff4040",
  turbo: "23171b32204a3e2a71453493493eae4b49c54a53d7485ee44569ee4074f53c7ff8378af93295f72e9ff42ba9ef28b3e926bce125c5d925cdcf27d5c629dcbc2de3b232e9a738ee9d3ff39347f68950f9805afc7765fd6e70fe667cfd5e88fc5795fb51a1f84badf545b9f140c5ec3cd0e637dae034e4d931ecd12ef4c92bfac029ffb626ffad24ffa223ff9821ff8d1fff821dff771cfd6c1af76118f05616e84b14df4111d5380fcb2f0dc0260ab61f07ac1805a313029b0f00950c00910b00",
  browns: "eedbbdecca96e9b97ae4a865dc9856d18954c7784cc0673fb85536ad44339f3632",
  tealBlues: "bce4d89dd3d181c3cb65b3c245a2b9368fae347da0306a932c5985",
  teals: "bbdfdfa2d4d58ac9c975bcbb61b0af4da5a43799982b8b8c1e7f7f127273006667",
  warmGreys: "dcd4d0cec5c1c0b8b4b3aaa7a59c9998908c8b827f7e7673726866665c5a59504e",
  goldGreen: "f4d166d5ca60b6c35c98bb597cb25760a6564b9c533f8f4f33834a257740146c36",
  goldOrange: "f4d166f8be5cf8aa4cf5983bf3852aef701be2621fd65322c54923b142239e3a26",
  goldRed: "f4d166f6be59f9aa51fc964ef6834bee734ae56249db5247cf4244c43141b71d3e",
  lightGreyRed: "efe9e6e1dad7d5cbc8c8bdb9bbaea9cd967ddc7b43e15f19df4011dc000b",
  lightGreyTeal: "e4eaead6dcddc8ced2b7c2c7a6b4bc64b0bf22a6c32295c11f85be1876bc",
  lightMulti: "e0f1f2c4e9d0b0de9fd0e181f6e072f6c053f3993ef77440ef4a3c",
  lightOrange: "f2e7daf7d5baf9c499fab184fa9c73f68967ef7860e8645bde515bd43d5b",
  lightTealBlue: "e3e9e0c0dccf9aceca7abfc859afc0389fb9328dad2f7ca0276b95255988",
  darkBlue: "3232322d46681a5c930074af008cbf05a7ce25c0dd38daed50f3faffffff",
  darkGold: "3c3c3c584b37725e348c7631ae8b2bcfa424ecc31ef9de30fff184ffffff",
  darkGreen: "3a3a3a215748006f4d048942489e4276b340a6c63dd2d836ffeb2cffffaa",
  darkMulti: "3737371f5287197d8c29a86995ce3fffe800ffffff",
  darkRed: "3434347036339e3c38cc4037e75d1eec8620eeab29f0ce32ffeb2c"
}, discrete = {
  accent: schemeAccent,
  category10: schemeCategory10,
  category20: "1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5",
  category20b: "393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6",
  category20c: "3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9",
  dark2: schemeDark2,
  observable10: schemeObservable10,
  paired: schemePaired,
  pastel1: schemePastel1,
  pastel2: schemePastel2,
  set1: schemeSet1,
  set2: schemeSet2,
  set3: schemeSet3,
  tableau10: "4c78a8f58518e4575672b7b254a24beeca3bb279a2ff9da69d755dbab0ac",
  tableau20: "4c78a89ecae9f58518ffbf7954a24b88d27ab79a20f2cf5b43989483bcb6e45756ff9d9879706ebab0acd67195fcbfd2b279a2d6a5c99e765fd8b5a5"
};
function colors(n) {
  if (isArray$3(n)) return n;
  const t = n.length / 6 | 0, g = new Array(t);
  for (let d = 0; d < t; )
    g[d] = "#" + n.slice(d * 6, ++d * 6);
  return g;
}
function apply$2(n, t) {
  for (const g in n) scheme$1(g, t(n[g]));
}
const schemes = {};
apply$2(discrete, colors);
apply$2(continuous, (n) => interpolateColors(colors(n)));
function scheme$1(n, t) {
  return n = n && n.toLowerCase(), arguments.length > 1 ? (schemes[n] = t, this) : schemes[n];
}
const SymbolLegend = "symbol", DiscreteLegend = "discrete", GradientLegend = "gradient", defaultFormatter = (n) => isArray$3(n) ? n.map((t) => String(t)) : String(n), ascending = (n, t) => n[1] - t[1], descending = (n, t) => t[1] - n[1];
function tickCount(n, t, g) {
  let d;
  return isNumber$3(t) && (n.bins && (t = Math.max(t, n.bins.length)), g != null && (t = Math.min(t, Math.floor(span(n.domain()) / g || 1) + 1))), isObject$4(t) && (d = t.step, t = t.interval), isString$2(t) && (t = n.type === Time ? timeInterval(t) : n.type == UTC ? utcInterval(t) : error$3("Only time and utc scales accept interval strings."), d && (t = t.every(d))), t;
}
function validTicks(n, t, g) {
  let d = n.range(), k = d[0], H = peek$2(d), AA = ascending;
  if (k > H && (d = H, H = k, k = d, AA = descending), k = Math.floor(k), H = Math.ceil(H), t = t.map((gA) => [gA, n(gA)]).filter((gA) => k <= gA[1] && gA[1] <= H).sort(AA).map((gA) => gA[0]), g > 0 && t.length > 1) {
    const gA = [t[0], peek$2(t)];
    for (; t.length > g && t.length >= 3; )
      t = t.filter((IA, CA) => !(CA % 2));
    t.length < 3 && (t = gA);
  }
  return t;
}
function tickValues(n, t) {
  return n.bins ? validTicks(n, n.bins, t) : n.ticks ? n.ticks(t) : n.domain();
}
function tickFormat(n, t, g, d, k, H) {
  const AA = t.type;
  let gA = defaultFormatter;
  if (AA === Time || k === Time)
    gA = n.timeFormat(d);
  else if (AA === UTC || k === UTC)
    gA = n.utcFormat(d);
  else if (isLogarithmic(AA)) {
    const IA = n.formatFloat(d);
    if (H || t.bins)
      gA = IA;
    else {
      const CA = tickLog(t, g, !1);
      gA = (BA) => CA(BA) ? IA(BA) : "";
    }
  } else if (t.tickFormat) {
    const IA = t.domain();
    gA = n.formatSpan(IA[0], IA[IA.length - 1], g, d);
  } else d && (gA = n.format(d));
  return gA;
}
function tickLog(n, t, g) {
  const d = tickValues(n, t), k = n.base(), H = Math.log(k), AA = Math.max(1, k * t / d.length), gA = (IA) => {
    let CA = IA / Math.pow(k, Math.round(Math.log(IA) / H));
    return CA * k < k - 0.5 && (CA *= k), CA <= AA;
  };
  return g ? d.filter(gA) : gA;
}
const symbols$2 = {
  [Quantile]: "quantiles",
  [Quantize]: "thresholds",
  [Threshold]: "domain"
}, formats = {
  [Quantile]: "quantiles",
  [Quantize]: "domain"
};
function labelValues(n, t) {
  return n.bins ? binValues(n.bins) : n.type === Log ? tickLog(n, t, !0) : symbols$2[n.type] ? thresholdValues(n[symbols$2[n.type]]()) : tickValues(n, t);
}
function thresholdFormat(n, t, g) {
  const d = t[formats[t.type]](), k = d.length;
  let H = k > 1 ? d[1] - d[0] : d[0], AA;
  for (AA = 1; AA < k; ++AA)
    H = Math.min(H, d[AA] - d[AA - 1]);
  return n.formatSpan(0, H, 30, g);
}
function thresholdValues(n) {
  const t = [-1 / 0].concat(n);
  return t.max = 1 / 0, t;
}
function binValues(n) {
  const t = n.slice(0, -1);
  return t.max = peek$2(n), t;
}
const isDiscreteRange = (n) => symbols$2[n.type] || n.bins;
function labelFormat(n, t, g, d, k, H, AA) {
  const gA = formats[t.type] && H !== Time && H !== UTC ? thresholdFormat(n, t, k) : tickFormat(n, t, g, k, H, AA);
  return d === SymbolLegend && isDiscreteRange(t) ? formatRange(gA) : d === DiscreteLegend ? formatDiscrete(gA) : formatPoint(gA);
}
const formatRange = (n) => (t, g, d) => {
  const k = get$5(d[g + 1], get$5(d.max, 1 / 0)), H = formatValue$2(t, n), AA = formatValue$2(k, n);
  return H && AA ? H + " – " + AA : AA ? "< " + AA : "≥ " + H;
}, get$5 = (n, t) => n ?? t, formatDiscrete = (n) => (t, g) => g ? n(t) : null, formatPoint = (n) => (t) => n(t), formatValue$2 = (n, t) => Number.isFinite(n) ? t(n) : null;
function labelFraction(n) {
  const t = n.domain(), g = t.length - 1;
  let d = +t[0], k = +peek$2(t), H = k - d;
  if (n.type === Threshold) {
    const AA = g ? H / g : 0.1;
    d -= AA, k += AA, H = k - d;
  }
  return (AA) => (AA - d) / H;
}
function format$1(n, t, g, d) {
  const k = d || t.type;
  return isString$2(g) && isTemporal(k) && (g = g.replace(/%a/g, "%A").replace(/%b/g, "%B")), !g && k === Time ? n.timeFormat("%A, %d %B %Y, %X") : !g && k === UTC ? n.utcFormat("%A, %d %B %Y, %X UTC") : labelFormat(n, t, 5, null, g, d, !0);
}
function domainCaption(n, t, g) {
  g = g || {};
  const d = Math.max(3, g.maxlen || 7), k = format$1(n, t, g.format, g.formatType);
  if (isDiscretizing$1(t.type)) {
    const H = labelValues(t).slice(1).map(k), AA = H.length;
    return `${AA} boundar${AA === 1 ? "y" : "ies"}: ${H.join(", ")}`;
  } else if (isDiscrete$2(t.type)) {
    const H = t.domain(), AA = H.length, gA = AA > d ? H.slice(0, d - 2).map(k).join(", ") + ", ending with " + H.slice(-1).map(k) : H.map(k).join(", ");
    return `${AA} value${AA === 1 ? "" : "s"}: ${gA}`;
  } else {
    const H = t.domain();
    return `values from ${k(H[0])} to ${k(peek$2(H))}`;
  }
}
let gradient_id = 0;
function resetSVGGradientId() {
  gradient_id = 0;
}
const patternPrefix = "p_";
function isGradient(n) {
  return n && n.gradient;
}
function gradientRef(n, t, g) {
  const d = n.gradient;
  let k = n.id, H = d === "radial" ? patternPrefix : "";
  return k || (k = n.id = "gradient_" + gradient_id++, d === "radial" ? (n.x1 = get$4(n.x1, 0.5), n.y1 = get$4(n.y1, 0.5), n.r1 = get$4(n.r1, 0), n.x2 = get$4(n.x2, 0.5), n.y2 = get$4(n.y2, 0.5), n.r2 = get$4(n.r2, 0.5), H = patternPrefix) : (n.x1 = get$4(n.x1, 0), n.y1 = get$4(n.y1, 0), n.x2 = get$4(n.x2, 1), n.y2 = get$4(n.y2, 0))), t[k] = n, "url(" + (g || "") + "#" + H + k + ")";
}
function get$4(n, t) {
  return n ?? t;
}
function Gradient$1(n, t) {
  var g = [], d;
  return d = {
    gradient: "linear",
    x1: n ? n[0] : 0,
    y1: n ? n[1] : 0,
    x2: t ? t[0] : 1,
    y2: t ? t[1] : 0,
    stops: g,
    stop: function(k, H) {
      return g.push({
        offset: k,
        color: H
      }), d;
    }
  };
}
const lookup$4 = {
  basis: {
    curve: curveBasis
  },
  "basis-closed": {
    curve: curveBasisClosed
  },
  "basis-open": {
    curve: curveBasisOpen
  },
  bundle: {
    curve: curveBundle,
    tension: "beta",
    value: 0.85
  },
  cardinal: {
    curve: curveCardinal,
    tension: "tension",
    value: 0
  },
  "cardinal-open": {
    curve: curveCardinalOpen,
    tension: "tension",
    value: 0
  },
  "cardinal-closed": {
    curve: curveCardinalClosed,
    tension: "tension",
    value: 0
  },
  "catmull-rom": {
    curve: curveCatmullRom,
    tension: "alpha",
    value: 0.5
  },
  "catmull-rom-closed": {
    curve: curveCatmullRomClosed,
    tension: "alpha",
    value: 0.5
  },
  "catmull-rom-open": {
    curve: curveCatmullRomOpen,
    tension: "alpha",
    value: 0.5
  },
  linear: {
    curve: curveLinear
  },
  "linear-closed": {
    curve: curveLinearClosed
  },
  monotone: {
    horizontal: monotoneY,
    vertical: monotoneX
  },
  natural: {
    curve: curveNatural
  },
  step: {
    curve: curveStep
  },
  "step-after": {
    curve: stepAfter
  },
  "step-before": {
    curve: stepBefore
  }
};
function curves(n, t, g) {
  var d = has$2(lookup$4, n) && lookup$4[n], k = null;
  return d && (k = d.curve || d[t || "vertical"], d.tension && g != null && (k = k[d.tension](g))), k;
}
const paramCounts = {
  m: 2,
  l: 2,
  h: 1,
  v: 1,
  z: 0,
  c: 6,
  s: 4,
  q: 4,
  t: 2,
  a: 7
}, commandPattern = /[mlhvzcsqta]([^mlhvzcsqta]+|$)/gi, numberPattern = /^[+-]?(([0-9]*\.[0-9]+)|([0-9]+\.)|([0-9]+))([eE][+-]?[0-9]+)?/, spacePattern = /^((\s+,?\s*)|(,\s*))/, flagPattern = /^[01]/;
function parse$3(n) {
  const t = [];
  return (n.match(commandPattern) || []).forEach((d) => {
    let k = d[0];
    const H = k.toLowerCase(), AA = paramCounts[H], gA = parseParams(H, AA, d.slice(1).trim()), IA = gA.length;
    if (IA < AA || IA && IA % AA !== 0)
      throw Error("Invalid SVG path, incorrect parameter count");
    if (t.push([k, ...gA.slice(0, AA)]), IA !== AA) {
      H === "m" && (k = k === "M" ? "L" : "l");
      for (let CA = AA; CA < IA; CA += AA)
        t.push([k, ...gA.slice(CA, CA + AA)]);
    }
  }), t;
}
function parseParams(n, t, g) {
  const d = [];
  for (let k = 0; t && k < g.length; )
    for (let H = 0; H < t; ++H) {
      const AA = n === "a" && (H === 3 || H === 4) ? flagPattern : numberPattern, gA = g.slice(k).match(AA);
      if (gA === null)
        throw Error("Invalid SVG path, incorrect parameter type");
      k += gA[0].length, d.push(+gA[0]);
      const IA = g.slice(k).match(spacePattern);
      IA !== null && (k += IA[0].length);
    }
  return d;
}
const DegToRad = Math.PI / 180, Epsilon = 1e-14, HalfPi = Math.PI / 2, Tau = Math.PI * 2, HalfSqrt3 = Math.sqrt(3) / 2;
var segmentCache = {}, bezierCache = {}, join$1 = [].join;
function segments(n, t, g, d, k, H, AA, gA, IA) {
  const CA = join$1.call(arguments);
  if (segmentCache[CA])
    return segmentCache[CA];
  const BA = AA * DegToRad, eA = Math.sin(BA), iA = Math.cos(BA);
  g = Math.abs(g), d = Math.abs(d);
  const QA = iA * (gA - n) * 0.5 + eA * (IA - t) * 0.5, tA = iA * (IA - t) * 0.5 - eA * (gA - n) * 0.5;
  let oA = QA * QA / (g * g) + tA * tA / (d * d);
  oA > 1 && (oA = Math.sqrt(oA), g *= oA, d *= oA);
  const EA = iA / g, aA = eA / g, nA = -eA / d, lA = iA / d, cA = EA * gA + aA * IA, sA = nA * gA + lA * IA, rA = EA * n + aA * t, uA = nA * n + lA * t;
  let dA = 1 / ((rA - cA) * (rA - cA) + (uA - sA) * (uA - sA)) - 0.25;
  dA < 0 && (dA = 0);
  let GA = Math.sqrt(dA);
  H == k && (GA = -GA);
  const DA = 0.5 * (cA + rA) - GA * (uA - sA), wA = 0.5 * (sA + uA) + GA * (rA - cA), bA = Math.atan2(sA - wA, cA - DA);
  let pA = Math.atan2(uA - wA, rA - DA) - bA;
  pA < 0 && H === 1 ? pA += Tau : pA > 0 && H === 0 && (pA -= Tau);
  const MA = Math.ceil(Math.abs(pA / (HalfPi + 1e-3))), LA = [];
  for (let xA = 0; xA < MA; ++xA) {
    const TA = bA + xA * pA / MA, NA = bA + (xA + 1) * pA / MA;
    LA[xA] = [DA, wA, TA, NA, g, d, eA, iA];
  }
  return segmentCache[CA] = LA;
}
function bezier(n) {
  const t = join$1.call(n);
  if (bezierCache[t])
    return bezierCache[t];
  var g = n[0], d = n[1], k = n[2], H = n[3], AA = n[4], gA = n[5], IA = n[6], CA = n[7];
  const BA = CA * AA, eA = -IA * gA, iA = IA * AA, QA = CA * gA, tA = Math.cos(k), oA = Math.sin(k), EA = Math.cos(H), aA = Math.sin(H), nA = 0.5 * (H - k), lA = Math.sin(nA * 0.5), cA = 8 / 3 * lA * lA / Math.sin(nA), sA = g + tA - cA * oA, rA = d + oA + cA * tA, uA = g + EA, hA = d + aA, dA = uA + cA * aA, GA = hA - cA * EA;
  return bezierCache[t] = [BA * sA + eA * rA, iA * sA + QA * rA, BA * dA + eA * GA, iA * dA + QA * GA, BA * uA + eA * hA, iA * uA + QA * hA];
}
const temp = ["l", 0, 0, 0, 0, 0, 0, 0];
function scale$1$1(n, t, g) {
  const d = temp[0] = n[0];
  if (d === "a" || d === "A")
    temp[1] = t * n[1], temp[2] = g * n[2], temp[3] = n[3], temp[4] = n[4], temp[5] = n[5], temp[6] = t * n[6], temp[7] = g * n[7];
  else if (d === "h" || d === "H")
    temp[1] = t * n[1];
  else if (d === "v" || d === "V")
    temp[1] = g * n[1];
  else
    for (var k = 1, H = n.length; k < H; ++k)
      temp[k] = (k % 2 == 1 ? t : g) * n[k];
  return temp;
}
function pathRender(n, t, g, d, k, H) {
  var AA, gA = null, IA = 0, CA = 0, BA = 0, eA = 0, iA, QA, tA, oA, EA = 0, aA = 0;
  g == null && (g = 0), d == null && (d = 0), k == null && (k = 1), H == null && (H = k), n.beginPath && n.beginPath();
  for (var nA = 0, lA = t.length; nA < lA; ++nA) {
    switch (AA = t[nA], (k !== 1 || H !== 1) && (AA = scale$1$1(AA, k, H)), AA[0]) {
      // first letter
      case "l":
        IA += AA[1], CA += AA[2], n.lineTo(IA + g, CA + d);
        break;
      case "L":
        IA = AA[1], CA = AA[2], n.lineTo(IA + g, CA + d);
        break;
      case "h":
        IA += AA[1], n.lineTo(IA + g, CA + d);
        break;
      case "H":
        IA = AA[1], n.lineTo(IA + g, CA + d);
        break;
      case "v":
        CA += AA[1], n.lineTo(IA + g, CA + d);
        break;
      case "V":
        CA = AA[1], n.lineTo(IA + g, CA + d);
        break;
      case "m":
        IA += AA[1], CA += AA[2], EA = IA, aA = CA, n.moveTo(IA + g, CA + d);
        break;
      case "M":
        IA = AA[1], CA = AA[2], EA = IA, aA = CA, n.moveTo(IA + g, CA + d);
        break;
      case "c":
        iA = IA + AA[5], QA = CA + AA[6], BA = IA + AA[3], eA = CA + AA[4], n.bezierCurveTo(
          IA + AA[1] + g,
          // x1
          CA + AA[2] + d,
          // y1
          BA + g,
          // x2
          eA + d,
          // y2
          iA + g,
          QA + d
        ), IA = iA, CA = QA;
        break;
      case "C":
        IA = AA[5], CA = AA[6], BA = AA[3], eA = AA[4], n.bezierCurveTo(AA[1] + g, AA[2] + d, BA + g, eA + d, IA + g, CA + d);
        break;
      case "s":
        iA = IA + AA[3], QA = CA + AA[4], BA = 2 * IA - BA, eA = 2 * CA - eA, n.bezierCurveTo(BA + g, eA + d, IA + AA[1] + g, CA + AA[2] + d, iA + g, QA + d), BA = IA + AA[1], eA = CA + AA[2], IA = iA, CA = QA;
        break;
      case "S":
        iA = AA[3], QA = AA[4], BA = 2 * IA - BA, eA = 2 * CA - eA, n.bezierCurveTo(BA + g, eA + d, AA[1] + g, AA[2] + d, iA + g, QA + d), IA = iA, CA = QA, BA = AA[1], eA = AA[2];
        break;
      case "q":
        iA = IA + AA[3], QA = CA + AA[4], BA = IA + AA[1], eA = CA + AA[2], n.quadraticCurveTo(BA + g, eA + d, iA + g, QA + d), IA = iA, CA = QA;
        break;
      case "Q":
        iA = AA[3], QA = AA[4], n.quadraticCurveTo(AA[1] + g, AA[2] + d, iA + g, QA + d), IA = iA, CA = QA, BA = AA[1], eA = AA[2];
        break;
      case "t":
        iA = IA + AA[1], QA = CA + AA[2], gA[0].match(/[QqTt]/) === null ? (BA = IA, eA = CA) : gA[0] === "t" ? (BA = 2 * IA - tA, eA = 2 * CA - oA) : gA[0] === "q" && (BA = 2 * IA - BA, eA = 2 * CA - eA), tA = BA, oA = eA, n.quadraticCurveTo(BA + g, eA + d, iA + g, QA + d), IA = iA, CA = QA, BA = IA + AA[1], eA = CA + AA[2];
        break;
      case "T":
        iA = AA[1], QA = AA[2], BA = 2 * IA - BA, eA = 2 * CA - eA, n.quadraticCurveTo(BA + g, eA + d, iA + g, QA + d), IA = iA, CA = QA;
        break;
      case "a":
        drawArc(n, IA + g, CA + d, [AA[1], AA[2], AA[3], AA[4], AA[5], AA[6] + IA + g, AA[7] + CA + d]), IA += AA[6], CA += AA[7];
        break;
      case "A":
        drawArc(n, IA + g, CA + d, [AA[1], AA[2], AA[3], AA[4], AA[5], AA[6] + g, AA[7] + d]), IA = AA[6], CA = AA[7];
        break;
      case "z":
      case "Z":
        IA = EA, CA = aA, n.closePath();
        break;
    }
    gA = AA;
  }
}
function drawArc(n, t, g, d) {
  const k = segments(
    d[5],
    // end x
    d[6],
    // end y
    d[0],
    // radius x
    d[1],
    // radius y
    d[3],
    // large flag
    d[4],
    // sweep flag
    d[2],
    // rotation
    t,
    g
  );
  for (let H = 0; H < k.length; ++H) {
    const AA = bezier(k[H]);
    n.bezierCurveTo(AA[0], AA[1], AA[2], AA[3], AA[4], AA[5]);
  }
}
const Tan30 = 0.5773502691896257, builtins = {
  circle: {
    draw: function(n, t) {
      const g = Math.sqrt(t) / 2;
      n.moveTo(g, 0), n.arc(0, 0, g, 0, Tau);
    }
  },
  cross: {
    draw: function(n, t) {
      var g = Math.sqrt(t) / 2, d = g / 2.5;
      n.moveTo(-g, -d), n.lineTo(-g, d), n.lineTo(-d, d), n.lineTo(-d, g), n.lineTo(d, g), n.lineTo(d, d), n.lineTo(g, d), n.lineTo(g, -d), n.lineTo(d, -d), n.lineTo(d, -g), n.lineTo(-d, -g), n.lineTo(-d, -d), n.closePath();
    }
  },
  diamond: {
    draw: function(n, t) {
      const g = Math.sqrt(t) / 2;
      n.moveTo(-g, 0), n.lineTo(0, -g), n.lineTo(g, 0), n.lineTo(0, g), n.closePath();
    }
  },
  square: {
    draw: function(n, t) {
      var g = Math.sqrt(t), d = -g / 2;
      n.rect(d, d, g, g);
    }
  },
  arrow: {
    draw: function(n, t) {
      var g = Math.sqrt(t) / 2, d = g / 7, k = g / 2.5, H = g / 8;
      n.moveTo(-d, g), n.lineTo(d, g), n.lineTo(d, -H), n.lineTo(k, -H), n.lineTo(0, -g), n.lineTo(-k, -H), n.lineTo(-d, -H), n.closePath();
    }
  },
  wedge: {
    draw: function(n, t) {
      var g = Math.sqrt(t) / 2, d = HalfSqrt3 * g, k = d - g * Tan30, H = g / 4;
      n.moveTo(0, -d - k), n.lineTo(-H, d - k), n.lineTo(H, d - k), n.closePath();
    }
  },
  triangle: {
    draw: function(n, t) {
      var g = Math.sqrt(t) / 2, d = HalfSqrt3 * g, k = d - g * Tan30;
      n.moveTo(0, -d - k), n.lineTo(-g, d - k), n.lineTo(g, d - k), n.closePath();
    }
  },
  "triangle-up": {
    draw: function(n, t) {
      var g = Math.sqrt(t) / 2, d = HalfSqrt3 * g;
      n.moveTo(0, -d), n.lineTo(-g, d), n.lineTo(g, d), n.closePath();
    }
  },
  "triangle-down": {
    draw: function(n, t) {
      var g = Math.sqrt(t) / 2, d = HalfSqrt3 * g;
      n.moveTo(0, d), n.lineTo(-g, -d), n.lineTo(g, -d), n.closePath();
    }
  },
  "triangle-right": {
    draw: function(n, t) {
      var g = Math.sqrt(t) / 2, d = HalfSqrt3 * g;
      n.moveTo(d, 0), n.lineTo(-d, -g), n.lineTo(-d, g), n.closePath();
    }
  },
  "triangle-left": {
    draw: function(n, t) {
      var g = Math.sqrt(t) / 2, d = HalfSqrt3 * g;
      n.moveTo(-d, 0), n.lineTo(d, -g), n.lineTo(d, g), n.closePath();
    }
  },
  stroke: {
    draw: function(n, t) {
      const g = Math.sqrt(t) / 2;
      n.moveTo(-g, 0), n.lineTo(g, 0);
    }
  }
};
function symbols$1(n) {
  return has$2(builtins, n) ? builtins[n] : customSymbol(n);
}
var custom = {};
function customSymbol(n) {
  if (!has$2(custom, n)) {
    const t = parse$3(n);
    custom[n] = {
      draw: function(g, d) {
        pathRender(g, t, 0, 0, Math.sqrt(d) / 2);
      }
    };
  }
  return custom[n];
}
const C = 0.448084975506;
function rectangleX(n) {
  return n.x;
}
function rectangleY(n) {
  return n.y;
}
function rectangleWidth(n) {
  return n.width;
}
function rectangleHeight(n) {
  return n.height;
}
function number$3(n) {
  return typeof n == "function" ? n : () => +n;
}
function clamp$1(n, t, g) {
  return Math.max(t, Math.min(n, g));
}
function vg_rect() {
  var n = rectangleX, t = rectangleY, g = rectangleWidth, d = rectangleHeight, k = number$3(0), H = k, AA = k, gA = k, IA = null;
  function CA(BA, eA, iA) {
    var QA, tA = eA ?? +n.call(this, BA), oA = iA ?? +t.call(this, BA), EA = +g.call(this, BA), aA = +d.call(this, BA), nA = Math.min(EA, aA) / 2, lA = clamp$1(+k.call(this, BA), 0, nA), cA = clamp$1(+H.call(this, BA), 0, nA), sA = clamp$1(+AA.call(this, BA), 0, nA), rA = clamp$1(+gA.call(this, BA), 0, nA);
    if (IA || (IA = QA = path$4()), lA <= 0 && cA <= 0 && sA <= 0 && rA <= 0)
      IA.rect(tA, oA, EA, aA);
    else {
      var uA = tA + EA, hA = oA + aA;
      IA.moveTo(tA + lA, oA), IA.lineTo(uA - cA, oA), IA.bezierCurveTo(uA - C * cA, oA, uA, oA + C * cA, uA, oA + cA), IA.lineTo(uA, hA - rA), IA.bezierCurveTo(uA, hA - C * rA, uA - C * rA, hA, uA - rA, hA), IA.lineTo(tA + sA, hA), IA.bezierCurveTo(tA + C * sA, hA, tA, hA - C * sA, tA, hA - sA), IA.lineTo(tA, oA + lA), IA.bezierCurveTo(tA, oA + C * lA, tA + C * lA, oA, tA + lA, oA), IA.closePath();
    }
    if (QA)
      return IA = null, QA + "" || null;
  }
  return CA.x = function(BA) {
    return arguments.length ? (n = number$3(BA), CA) : n;
  }, CA.y = function(BA) {
    return arguments.length ? (t = number$3(BA), CA) : t;
  }, CA.width = function(BA) {
    return arguments.length ? (g = number$3(BA), CA) : g;
  }, CA.height = function(BA) {
    return arguments.length ? (d = number$3(BA), CA) : d;
  }, CA.cornerRadius = function(BA, eA, iA, QA) {
    return arguments.length ? (k = number$3(BA), H = eA != null ? number$3(eA) : k, gA = iA != null ? number$3(iA) : k, AA = QA != null ? number$3(QA) : H, CA) : k;
  }, CA.context = function(BA) {
    return arguments.length ? (IA = BA ?? null, CA) : IA;
  }, CA;
}
function vg_trail() {
  var n, t, g, d, k = null, H, AA, gA, IA;
  function CA(eA, iA, QA) {
    const tA = QA / 2;
    if (H) {
      var oA = gA - iA, EA = eA - AA;
      if (oA || EA) {
        var aA = Math.hypot(oA, EA), nA = (oA /= aA) * IA, lA = (EA /= aA) * IA, cA = Math.atan2(EA, oA);
        k.moveTo(AA - nA, gA - lA), k.lineTo(eA - oA * tA, iA - EA * tA), k.arc(eA, iA, tA, cA - Math.PI, cA), k.lineTo(AA + nA, gA + lA), k.arc(AA, gA, IA, cA, cA + Math.PI);
      } else
        k.arc(eA, iA, tA, 0, Tau);
      k.closePath();
    } else
      H = 1;
    AA = eA, gA = iA, IA = tA;
  }
  function BA(eA) {
    var iA, QA = eA.length, tA, oA = !1, EA;
    for (k == null && (k = EA = path$4()), iA = 0; iA <= QA; ++iA)
      !(iA < QA && d(tA = eA[iA], iA, eA)) === oA && (oA = !oA) && (H = 0), oA && CA(+n(tA, iA, eA), +t(tA, iA, eA), +g(tA, iA, eA));
    if (EA)
      return k = null, EA + "" || null;
  }
  return BA.x = function(eA) {
    return arguments.length ? (n = eA, BA) : n;
  }, BA.y = function(eA) {
    return arguments.length ? (t = eA, BA) : t;
  }, BA.size = function(eA) {
    return arguments.length ? (g = eA, BA) : g;
  }, BA.defined = function(eA) {
    return arguments.length ? (d = eA, BA) : d;
  }, BA.context = function(eA) {
    return arguments.length ? (eA == null ? k = null : k = eA, BA) : k;
  }, BA;
}
function value$1(n, t) {
  return n ?? t;
}
const x$2 = (n) => n.x || 0, y$3 = (n) => n.y || 0, w$2 = (n) => n.width || 0, h = (n) => n.height || 0, xw = (n) => (n.x || 0) + (n.width || 0), yh = (n) => (n.y || 0) + (n.height || 0), sa = (n) => n.startAngle || 0, ea = (n) => n.endAngle || 0, pa = (n) => n.padAngle || 0, ir = (n) => n.innerRadius || 0, or = (n) => n.outerRadius || 0, cr = (n) => n.cornerRadius || 0, tl = (n) => value$1(n.cornerRadiusTopLeft, n.cornerRadius) || 0, tr = (n) => value$1(n.cornerRadiusTopRight, n.cornerRadius) || 0, br = (n) => value$1(n.cornerRadiusBottomRight, n.cornerRadius) || 0, bl = (n) => value$1(n.cornerRadiusBottomLeft, n.cornerRadius) || 0, sz = (n) => value$1(n.size, 64), ts = (n) => n.size || 1, def = (n) => n.defined !== !1, type$2 = (n) => symbols$1(n.shape || "circle"), arcShape = arc$2$1().startAngle(sa).endAngle(ea).padAngle(pa).innerRadius(ir).outerRadius(or).cornerRadius(cr), areavShape = area$2$1().x(x$2).y1(y$3).y0(yh).defined(def), areahShape = area$2$1().y(y$3).x1(x$2).x0(xw).defined(def), lineShape = line$2$1().x(x$2).y(y$3).defined(def), rectShape = vg_rect().x(x$2).y(y$3).width(w$2).height(h).cornerRadius(tl, tr, br, bl), symbolShape = Symbol$2().type(type$2).size(sz), trailShape = vg_trail().x(x$2).y(y$3).defined(def).size(ts);
function hasCornerRadius(n) {
  return n.cornerRadius || n.cornerRadiusTopLeft || n.cornerRadiusTopRight || n.cornerRadiusBottomRight || n.cornerRadiusBottomLeft;
}
function arc$1$1(n, t) {
  return arcShape.context(n)(t);
}
function area$1$1(n, t) {
  const g = t[0], d = g.interpolate || "linear";
  return (g.orient === "horizontal" ? areahShape : areavShape).curve(curves(d, g.orient, g.tension)).context(n)(t);
}
function line$1$1(n, t) {
  const g = t[0], d = g.interpolate || "linear";
  return lineShape.curve(curves(d, g.orient, g.tension)).context(n)(t);
}
function rectangle(n, t, g, d) {
  return rectShape.context(n)(t, g, d);
}
function shape$1(n, t) {
  return (t.mark.shape || t.shape).context(n)(t);
}
function symbol$1(n, t) {
  return symbolShape.context(n)(t);
}
function trail$1(n, t) {
  return trailShape.context(n)(t);
}
var clip_id = 1;
function resetSVGClipId() {
  clip_id = 1;
}
function clip$1$1(n, t, g) {
  var d = t.clip, k = n._defs, H = t.clip_id || (t.clip_id = "clip" + clip_id++), AA = k.clipping[H] || (k.clipping[H] = {
    id: H
  });
  return isFunction$5(d) ? AA.path = d(null) : hasCornerRadius(g) ? AA.path = rectangle(null, g, 0, 0) : (AA.width = g.width || 0, AA.height = g.height || 0), "url(#" + H + ")";
}
function Bounds(n) {
  this.clear(), n && this.union(n);
}
Bounds.prototype = {
  clone() {
    return new Bounds(this);
  },
  clear() {
    return this.x1 = +Number.MAX_VALUE, this.y1 = +Number.MAX_VALUE, this.x2 = -Number.MAX_VALUE, this.y2 = -Number.MAX_VALUE, this;
  },
  empty() {
    return this.x1 === +Number.MAX_VALUE && this.y1 === +Number.MAX_VALUE && this.x2 === -Number.MAX_VALUE && this.y2 === -Number.MAX_VALUE;
  },
  equals(n) {
    return this.x1 === n.x1 && this.y1 === n.y1 && this.x2 === n.x2 && this.y2 === n.y2;
  },
  set(n, t, g, d) {
    return g < n ? (this.x2 = n, this.x1 = g) : (this.x1 = n, this.x2 = g), d < t ? (this.y2 = t, this.y1 = d) : (this.y1 = t, this.y2 = d), this;
  },
  add(n, t) {
    return n < this.x1 && (this.x1 = n), t < this.y1 && (this.y1 = t), n > this.x2 && (this.x2 = n), t > this.y2 && (this.y2 = t), this;
  },
  expand(n) {
    return this.x1 -= n, this.y1 -= n, this.x2 += n, this.y2 += n, this;
  },
  round() {
    return this.x1 = Math.floor(this.x1), this.y1 = Math.floor(this.y1), this.x2 = Math.ceil(this.x2), this.y2 = Math.ceil(this.y2), this;
  },
  scale(n) {
    return this.x1 *= n, this.y1 *= n, this.x2 *= n, this.y2 *= n, this;
  },
  translate(n, t) {
    return this.x1 += n, this.x2 += n, this.y1 += t, this.y2 += t, this;
  },
  rotate(n, t, g) {
    const d = this.rotatedPoints(n, t, g);
    return this.clear().add(d[0], d[1]).add(d[2], d[3]).add(d[4], d[5]).add(d[6], d[7]);
  },
  rotatedPoints(n, t, g) {
    var {
      x1: d,
      y1: k,
      x2: H,
      y2: AA
    } = this, gA = Math.cos(n), IA = Math.sin(n), CA = t - t * gA + g * IA, BA = g - t * IA - g * gA;
    return [gA * d - IA * k + CA, IA * d + gA * k + BA, gA * d - IA * AA + CA, IA * d + gA * AA + BA, gA * H - IA * k + CA, IA * H + gA * k + BA, gA * H - IA * AA + CA, IA * H + gA * AA + BA];
  },
  union(n) {
    return n.x1 < this.x1 && (this.x1 = n.x1), n.y1 < this.y1 && (this.y1 = n.y1), n.x2 > this.x2 && (this.x2 = n.x2), n.y2 > this.y2 && (this.y2 = n.y2), this;
  },
  intersect(n) {
    return n.x1 > this.x1 && (this.x1 = n.x1), n.y1 > this.y1 && (this.y1 = n.y1), n.x2 < this.x2 && (this.x2 = n.x2), n.y2 < this.y2 && (this.y2 = n.y2), this;
  },
  encloses(n) {
    return n && this.x1 <= n.x1 && this.x2 >= n.x2 && this.y1 <= n.y1 && this.y2 >= n.y2;
  },
  alignsWith(n) {
    return n && (this.x1 == n.x1 || this.x2 == n.x2 || this.y1 == n.y1 || this.y2 == n.y2);
  },
  intersects(n) {
    return n && !(this.x2 < n.x1 || this.x1 > n.x2 || this.y2 < n.y1 || this.y1 > n.y2);
  },
  contains(n, t) {
    return !(n < this.x1 || n > this.x2 || t < this.y1 || t > this.y2);
  },
  width() {
    return this.x2 - this.x1;
  },
  height() {
    return this.y2 - this.y1;
  }
};
function Item$1(n) {
  this.mark = n, this.bounds = this.bounds || new Bounds();
}
function GroupItem(n) {
  Item$1.call(this, n), this.items = this.items || [];
}
inherits$1(GroupItem, Item$1);
class ResourceLoader {
  constructor(t) {
    this._pending = 0, this._loader = t || loader();
  }
  pending() {
    return this._pending;
  }
  sanitizeURL(t) {
    const g = this;
    return increment(g), g._loader.sanitize(t, {
      context: "href"
    }).then((d) => (decrement(g), d)).catch(() => (decrement(g), null));
  }
  loadImage(t) {
    const g = this, d = domImage();
    return increment(g), g._loader.sanitize(t, {
      context: "image"
    }).then((k) => {
      const H = k.href;
      if (!H || !d) throw {
        url: H
      };
      const AA = new d(), gA = has$2(k, "crossOrigin") ? k.crossOrigin : "anonymous";
      return gA != null && (AA.crossOrigin = gA), AA.onload = () => decrement(g), AA.onerror = () => decrement(g), AA.src = H, AA;
    }).catch((k) => (decrement(g), {
      complete: !1,
      width: 0,
      height: 0,
      src: k && k.url || ""
    }));
  }
  ready() {
    const t = this;
    return new Promise((g) => {
      function d(k) {
        t.pending() ? setTimeout(() => {
          d(!0);
        }, 10) : g(k);
      }
      d(!1);
    });
  }
}
function increment(n) {
  n._pending += 1;
}
function decrement(n) {
  n._pending -= 1;
}
function boundStroke(n, t, g) {
  if (t.stroke && t.opacity !== 0 && t.strokeOpacity !== 0) {
    const d = t.strokeWidth != null ? +t.strokeWidth : 1;
    n.expand(d + (g ? miterAdjustment(t, d) : 0));
  }
  return n;
}
function miterAdjustment(n, t) {
  return n.strokeJoin && n.strokeJoin !== "miter" ? 0 : t;
}
const circleThreshold = Tau - 1e-8;
let bounds, lx, ly, rot, ma, mb, mc, md;
const add$2 = (n, t) => bounds.add(n, t), addL = (n, t) => add$2(lx = n, ly = t), addX = (n) => add$2(n, bounds.y1), addY = (n) => add$2(bounds.x1, n), px = (n, t) => ma * n + mc * t, py = (n, t) => mb * n + md * t, addp = (n, t) => add$2(px(n, t), py(n, t)), addpL = (n, t) => addL(px(n, t), py(n, t));
function boundContext(n, t) {
  return bounds = n, t ? (rot = t * DegToRad, ma = md = Math.cos(rot), mb = Math.sin(rot), mc = -mb) : (ma = md = 1, rot = mb = mc = 0), context$1;
}
const context$1 = {
  beginPath() {
  },
  closePath() {
  },
  moveTo: addpL,
  lineTo: addpL,
  rect(n, t, g, d) {
    rot ? (addp(n + g, t), addp(n + g, t + d), addp(n, t + d), addpL(n, t)) : (add$2(n + g, t + d), addL(n, t));
  },
  quadraticCurveTo(n, t, g, d) {
    const k = px(n, t), H = py(n, t), AA = px(g, d), gA = py(g, d);
    quadExtrema(lx, k, AA, addX), quadExtrema(ly, H, gA, addY), addL(AA, gA);
  },
  bezierCurveTo(n, t, g, d, k, H) {
    const AA = px(n, t), gA = py(n, t), IA = px(g, d), CA = py(g, d), BA = px(k, H), eA = py(k, H);
    cubicExtrema(lx, AA, IA, BA, addX), cubicExtrema(ly, gA, CA, eA, addY), addL(BA, eA);
  },
  arc(n, t, g, d, k, H) {
    if (d += rot, k += rot, lx = g * Math.cos(k) + n, ly = g * Math.sin(k) + t, Math.abs(k - d) > circleThreshold)
      add$2(n - g, t - g), add$2(n + g, t + g);
    else {
      const AA = (CA) => add$2(g * Math.cos(CA) + n, g * Math.sin(CA) + t);
      let gA, IA;
      if (AA(d), AA(k), k !== d)
        if (d = d % Tau, d < 0 && (d += Tau), k = k % Tau, k < 0 && (k += Tau), k < d && (H = !H, gA = d, d = k, k = gA), H)
          for (k -= Tau, gA = d - d % HalfPi, IA = 0; IA < 4 && gA > k; ++IA, gA -= HalfPi) AA(gA);
        else
          for (gA = d - d % HalfPi + HalfPi, IA = 0; IA < 4 && gA < k; ++IA, gA = gA + HalfPi) AA(gA);
    }
  }
};
function quadExtrema(n, t, g, d) {
  const k = (n - t) / (n + g - 2 * t);
  0 < k && k < 1 && d(n + (t - n) * k);
}
function cubicExtrema(n, t, g, d, k) {
  const H = d - n + 3 * t - 3 * g, AA = n + g - 2 * t, gA = n - t;
  let IA = 0, CA = 0, BA;
  Math.abs(H) > Epsilon ? (BA = AA * AA + gA * H, BA >= 0 && (BA = Math.sqrt(BA), IA = (-AA + BA) / H, CA = (-AA - BA) / H)) : IA = 0.5 * gA / AA, 0 < IA && IA < 1 && k(cubic(IA, n, t, g, d)), 0 < CA && CA < 1 && k(cubic(CA, n, t, g, d));
}
function cubic(n, t, g, d, k) {
  const H = 1 - n, AA = H * H, gA = n * n;
  return AA * H * t + 3 * AA * n * g + 3 * H * gA * d + gA * n * k;
}
var context$2 = (context$2 = domCanvas(1, 1)) ? context$2.getContext("2d") : null;
const b = new Bounds();
function intersectPath(n) {
  return function(t, g) {
    if (!context$2) return !0;
    n(context$2, t), b.clear().union(t.bounds).intersect(g).round();
    const {
      x1: d,
      y1: k,
      x2: H,
      y2: AA
    } = b;
    for (let gA = k; gA <= AA; ++gA)
      for (let IA = d; IA <= H; ++IA)
        if (context$2.isPointInPath(IA, gA))
          return !0;
    return !1;
  };
}
function intersectPoint(n, t) {
  return t.contains(n.x || 0, n.y || 0);
}
function intersectRect(n, t) {
  const g = n.x || 0, d = n.y || 0, k = n.width || 0, H = n.height || 0;
  return t.intersects(b.set(g, d, g + k, d + H));
}
function intersectRule(n, t) {
  const g = n.x || 0, d = n.y || 0, k = n.x2 != null ? n.x2 : g, H = n.y2 != null ? n.y2 : d;
  return intersectBoxLine(t, g, d, k, H);
}
function intersectBoxLine(n, t, g, d, k) {
  const {
    x1: H,
    y1: AA,
    x2: gA,
    y2: IA
  } = n, CA = d - t, BA = k - g;
  let eA = 0, iA = 1, QA, tA, oA, EA;
  for (EA = 0; EA < 4; ++EA) {
    if (EA === 0 && (QA = -CA, tA = -(H - t)), EA === 1 && (QA = CA, tA = gA - t), EA === 2 && (QA = -BA, tA = -(AA - g)), EA === 3 && (QA = BA, tA = IA - g), Math.abs(QA) < 1e-10 && tA < 0) return !1;
    if (oA = tA / QA, QA < 0) {
      if (oA > iA) return !1;
      oA > eA && (eA = oA);
    } else if (QA > 0) {
      if (oA < eA) return !1;
      oA < iA && (iA = oA);
    }
  }
  return !0;
}
function blend(n, t) {
  n.globalCompositeOperation = t.blend || "source-over";
}
function value$2(n, t) {
  return n ?? t;
}
function addStops(n, t) {
  const g = t.length;
  for (let d = 0; d < g; ++d)
    n.addColorStop(t[d].offset, t[d].color);
  return n;
}
function gradient$3(n, t, g) {
  const d = g.width(), k = g.height();
  let H;
  if (t.gradient === "radial")
    H = n.createRadialGradient(g.x1 + value$2(t.x1, 0.5) * d, g.y1 + value$2(t.y1, 0.5) * k, Math.max(d, k) * value$2(t.r1, 0), g.x1 + value$2(t.x2, 0.5) * d, g.y1 + value$2(t.y2, 0.5) * k, Math.max(d, k) * value$2(t.r2, 0.5));
  else {
    const AA = value$2(t.x1, 0), gA = value$2(t.y1, 0), IA = value$2(t.x2, 1), CA = value$2(t.y2, 0);
    if (AA === IA || gA === CA || d === k)
      H = n.createLinearGradient(g.x1 + AA * d, g.y1 + gA * k, g.x1 + IA * d, g.y1 + CA * k);
    else {
      const BA = domCanvas(Math.ceil(d), Math.ceil(k)), eA = BA.getContext("2d");
      return eA.scale(d, k), eA.fillStyle = addStops(eA.createLinearGradient(AA, gA, IA, CA), t.stops), eA.fillRect(0, 0, d, k), n.createPattern(BA, "no-repeat");
    }
  }
  return addStops(H, t.stops);
}
function color$2(n, t, g) {
  return isGradient(g) ? gradient$3(n, g, t.bounds) : g;
}
function fill(n, t, g) {
  return g *= t.fillOpacity == null ? 1 : t.fillOpacity, g > 0 ? (n.globalAlpha = g, n.fillStyle = color$2(n, t, t.fill), !0) : !1;
}
var Empty = [];
function stroke(n, t, g) {
  var d = (d = t.strokeWidth) != null ? d : 1;
  return d <= 0 ? !1 : (g *= t.strokeOpacity == null ? 1 : t.strokeOpacity, g > 0 ? (n.globalAlpha = g, n.strokeStyle = color$2(n, t, t.stroke), n.lineWidth = d, n.lineCap = t.strokeCap || "butt", n.lineJoin = t.strokeJoin || "miter", n.miterLimit = t.strokeMiterLimit || 10, n.setLineDash && (n.setLineDash(t.strokeDash || Empty), n.lineDashOffset = t.strokeDashOffset || 0), !0) : !1);
}
function compare$2(n, t) {
  return n.zindex - t.zindex || n.index - t.index;
}
function zorder(n) {
  if (!n.zdirty) return n.zitems;
  var t = n.items, g = [], d, k, H;
  for (k = 0, H = t.length; k < H; ++k)
    d = t[k], d.index = k, d.zindex && g.push(d);
  return n.zdirty = !1, n.zitems = g.sort(compare$2);
}
function visit(n, t) {
  var g = n.items, d, k;
  if (!g || !g.length) return;
  const H = zorder(n);
  if (H && H.length) {
    for (d = 0, k = g.length; d < k; ++d)
      g[d].zindex || t(g[d]);
    g = H;
  }
  for (d = 0, k = g.length; d < k; ++d)
    t(g[d]);
}
function pickVisit(n, t) {
  var g = n.items, d, k;
  if (!g || !g.length) return null;
  const H = zorder(n);
  for (H && H.length && (g = H), k = g.length; --k >= 0; )
    if (d = t(g[k])) return d;
  if (g === H) {
    for (g = n.items, k = g.length; --k >= 0; )
      if (!g[k].zindex && (d = t(g[k])))
        return d;
  }
  return null;
}
function drawAll(n) {
  return function(t, g, d) {
    visit(g, (k) => {
      (!d || d.intersects(k.bounds)) && drawPath(n, t, k, k);
    });
  };
}
function drawOne(n) {
  return function(t, g, d) {
    g.items.length && (!d || d.intersects(g.bounds)) && drawPath(n, t, g.items[0], g.items);
  };
}
function drawPath(n, t, g, d) {
  var k = g.opacity == null ? 1 : g.opacity;
  k !== 0 && (n(t, d) || (blend(t, g), g.fill && fill(t, g, k) && t.fill(), g.stroke && stroke(t, g, k) && t.stroke()));
}
function pick$1$1(n) {
  return n = n || truthy, function(t, g, d, k, H, AA) {
    return d *= t.pixelRatio, k *= t.pixelRatio, pickVisit(g, (gA) => {
      const IA = gA.bounds;
      if (!(IA && !IA.contains(H, AA) || !IA) && n(t, gA, d, k, H, AA))
        return gA;
    });
  };
}
function hitPath(n, t) {
  return function(g, d, k, H) {
    var AA = Array.isArray(d) ? d[0] : d, gA = t ?? AA.fill, IA = AA.stroke && g.isPointInStroke, CA, BA;
    return IA && (CA = AA.strokeWidth, BA = AA.strokeCap, g.lineWidth = CA ?? 1, g.lineCap = BA ?? "butt"), n(g, d) ? !1 : gA && g.isPointInPath(k, H) || IA && g.isPointInStroke(k, H);
  };
}
function pickPath(n) {
  return pick$1$1(hitPath(n));
}
function translate$2(n, t) {
  return "translate(" + n + "," + t + ")";
}
function rotate(n) {
  return "rotate(" + n + ")";
}
function scale$3(n, t) {
  return "scale(" + n + "," + t + ")";
}
function translateItem(n) {
  return translate$2(n.x || 0, n.y || 0);
}
function rotateItem(n) {
  return translate$2(n.x || 0, n.y || 0) + (n.angle ? " " + rotate(n.angle) : "");
}
function transformItem(n) {
  return translate$2(n.x || 0, n.y || 0) + (n.angle ? " " + rotate(n.angle) : "") + (n.scaleX || n.scaleY ? " " + scale$3(n.scaleX || 1, n.scaleY || 1) : "");
}
function markItemPath(n, t, g) {
  function d(AA, gA) {
    AA("transform", rotateItem(gA)), AA("d", t(null, gA));
  }
  function k(AA, gA) {
    return t(boundContext(AA, gA.angle), gA), boundStroke(AA, gA).translate(gA.x || 0, gA.y || 0);
  }
  function H(AA, gA) {
    var IA = gA.x || 0, CA = gA.y || 0, BA = gA.angle || 0;
    AA.translate(IA, CA), BA && AA.rotate(BA *= DegToRad), AA.beginPath(), t(AA, gA), BA && AA.rotate(-BA), AA.translate(-IA, -CA);
  }
  return {
    type: n,
    tag: "path",
    nested: !1,
    attr: d,
    bound: k,
    draw: drawAll(H),
    pick: pickPath(H),
    isect: g || intersectPath(H)
  };
}
var arc$2 = markItemPath("arc", arc$1$1);
function pickArea(n, t) {
  for (var g = n[0].orient === "horizontal" ? t[1] : t[0], d = n[0].orient === "horizontal" ? "y" : "x", k = n.length, H = 1 / 0, AA, gA; --k >= 0; )
    n[k].defined !== !1 && (gA = Math.abs(n[k][d] - g), gA < H && (H = gA, AA = n[k]));
  return AA;
}
function pickLine(n, t) {
  for (var g = Math.pow(n[0].strokeWidth || 1, 2), d = n.length, k, H, AA; --d >= 0; )
    if (n[d].defined !== !1 && (k = n[d].x - t[0], H = n[d].y - t[1], AA = k * k + H * H, AA < g))
      return n[d];
  return null;
}
function pickTrail(n, t) {
  for (var g = n.length, d, k, H; --g >= 0; )
    if (n[g].defined !== !1 && (d = n[g].x - t[0], k = n[g].y - t[1], H = d * d + k * k, d = n[g].size || 1, H < d * d))
      return n[g];
  return null;
}
function markMultiItemPath(n, t, g) {
  function d(IA, CA) {
    var BA = CA.mark.items;
    BA.length && IA("d", t(null, BA));
  }
  function k(IA, CA) {
    var BA = CA.items;
    return BA.length === 0 ? IA : (t(boundContext(IA), BA), boundStroke(IA, BA[0]));
  }
  function H(IA, CA) {
    IA.beginPath(), t(IA, CA);
  }
  const AA = hitPath(H);
  function gA(IA, CA, BA, eA, iA, QA) {
    var tA = CA.items, oA = CA.bounds;
    return !tA || !tA.length || oA && !oA.contains(iA, QA) ? null : (BA *= IA.pixelRatio, eA *= IA.pixelRatio, AA(IA, tA, BA, eA) ? tA[0] : null);
  }
  return {
    type: n,
    tag: "path",
    nested: !0,
    attr: d,
    bound: k,
    draw: drawOne(H),
    pick: gA,
    isect: intersectPoint,
    tip: g
  };
}
var area$2 = markMultiItemPath("area", area$1$1, pickArea);
function clip$2(n, t) {
  var g = t.clip;
  n.save(), isFunction$5(g) ? (n.beginPath(), g(n), n.clip()) : clipGroup(n, t.group);
}
function clipGroup(n, t) {
  n.beginPath(), hasCornerRadius(t) ? rectangle(n, t, 0, 0) : n.rect(0, 0, t.width || 0, t.height || 0), n.clip();
}
function offset$1(n) {
  const t = value$2(n.strokeWidth, 1);
  return n.strokeOffset != null ? n.strokeOffset : n.stroke && t > 0.5 && t < 1.5 ? 0.5 - Math.abs(t - 1) : 0;
}
function attr$5(n, t) {
  n("transform", translateItem(t));
}
function emitRectangle(n, t) {
  const g = offset$1(t);
  n("d", rectangle(null, t, g, g));
}
function background$1(n, t) {
  n("class", "background"), n("aria-hidden", !0), emitRectangle(n, t);
}
function foreground(n, t) {
  n("class", "foreground"), n("aria-hidden", !0), t.strokeForeground ? emitRectangle(n, t) : n("d", "");
}
function content(n, t, g) {
  const d = t.clip ? clip$1$1(g, t, t) : null;
  n("clip-path", d);
}
function bound$5(n, t) {
  if (!t.clip && t.items) {
    const g = t.items, d = g.length;
    for (let k = 0; k < d; ++k)
      n.union(g[k].bounds);
  }
  return (t.clip || t.width || t.height) && !t.noBound && n.add(0, 0).add(t.width || 0, t.height || 0), boundStroke(n, t), n.translate(t.x || 0, t.y || 0);
}
function rectanglePath(n, t, g, d) {
  const k = offset$1(t);
  n.beginPath(), rectangle(n, t, (g || 0) + k, (d || 0) + k);
}
const hitBackground = hitPath(rectanglePath), hitForeground = hitPath(rectanglePath, !1), hitCorner = hitPath(rectanglePath, !0);
function draw$4(n, t, g, d) {
  visit(t, (k) => {
    const H = k.x || 0, AA = k.y || 0, gA = k.strokeForeground, IA = k.opacity == null ? 1 : k.opacity;
    (k.stroke || k.fill) && IA && (rectanglePath(n, k, H, AA), blend(n, k), k.fill && fill(n, k, IA) && n.fill(), k.stroke && !gA && stroke(n, k, IA) && n.stroke()), n.save(), n.translate(H, AA), k.clip && clipGroup(n, k), g && g.translate(-H, -AA), visit(k, (CA) => {
      (CA.marktype === "group" || d == null || d.includes(CA.marktype)) && this.draw(n, CA, g, d);
    }), g && g.translate(H, AA), n.restore(), gA && k.stroke && IA && (rectanglePath(n, k, H, AA), blend(n, k), stroke(n, k, IA) && n.stroke());
  });
}
function pick$3(n, t, g, d, k, H) {
  if (t.bounds && !t.bounds.contains(k, H) || !t.items)
    return null;
  const AA = g * n.pixelRatio, gA = d * n.pixelRatio;
  return pickVisit(t, (IA) => {
    let CA, BA, eA;
    const iA = IA.bounds;
    if (iA && !iA.contains(k, H)) return;
    BA = IA.x || 0, eA = IA.y || 0;
    const QA = BA + (IA.width || 0), tA = eA + (IA.height || 0), oA = IA.clip;
    if (oA && (k < BA || k > QA || H < eA || H > tA)) return;
    if (n.save(), n.translate(BA, eA), BA = k - BA, eA = H - eA, oA && hasCornerRadius(IA) && !hitCorner(n, IA, AA, gA))
      return n.restore(), null;
    const EA = IA.strokeForeground, aA = t.interactive !== !1;
    return aA && EA && IA.stroke && hitForeground(n, IA, AA, gA) ? (n.restore(), IA) : (CA = pickVisit(IA, (nA) => pickMark(nA, BA, eA) ? this.pick(nA, g, d, BA, eA) : null), !CA && aA && (IA.fill || !EA && IA.stroke) && hitBackground(n, IA, AA, gA) && (CA = IA), n.restore(), CA || null);
  });
}
function pickMark(n, t, g) {
  return (n.interactive !== !1 || n.marktype === "group") && n.bounds && n.bounds.contains(t, g);
}
var group = {
  type: "group",
  tag: "g",
  nested: !1,
  attr: attr$5,
  bound: bound$5,
  draw: draw$4,
  pick: pick$3,
  isect: intersectRect,
  content,
  background: background$1,
  foreground
}, metadata = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1"
};
function getImage(n, t) {
  var g = n.image;
  return (!g || n.url && n.url !== g.url) && (g = {
    complete: !1,
    width: 0,
    height: 0
  }, t.loadImage(n.url).then((d) => {
    n.image = d, n.image.url = n.url;
  })), g;
}
function imageWidth(n, t) {
  return n.width != null ? n.width : !t || !t.width ? 0 : n.aspect !== !1 && n.height ? n.height * t.width / t.height : t.width;
}
function imageHeight(n, t) {
  return n.height != null ? n.height : !t || !t.height ? 0 : n.aspect !== !1 && n.width ? n.width * t.height / t.width : t.height;
}
function imageXOffset(n, t) {
  return n === "center" ? t / 2 : n === "right" ? t : 0;
}
function imageYOffset(n, t) {
  return n === "middle" ? t / 2 : n === "bottom" ? t : 0;
}
function attr$4(n, t, g) {
  const d = getImage(t, g), k = imageWidth(t, d), H = imageHeight(t, d), AA = (t.x || 0) - imageXOffset(t.align, k), gA = (t.y || 0) - imageYOffset(t.baseline, H), IA = !d.src && d.toDataURL ? d.toDataURL() : d.src || "";
  n("href", IA, metadata["xmlns:xlink"], "xlink:href"), n("transform", translate$2(AA, gA)), n("width", k), n("height", H), n("preserveAspectRatio", t.aspect === !1 ? "none" : "xMidYMid");
}
function bound$4(n, t) {
  const g = t.image, d = imageWidth(t, g), k = imageHeight(t, g), H = (t.x || 0) - imageXOffset(t.align, d), AA = (t.y || 0) - imageYOffset(t.baseline, k);
  return n.set(H, AA, H + d, AA + k);
}
function draw$3(n, t, g) {
  visit(t, (d) => {
    if (g && !g.intersects(d.bounds)) return;
    const k = getImage(d, this);
    let H = imageWidth(d, k), AA = imageHeight(d, k);
    if (H === 0 || AA === 0) return;
    let gA = (d.x || 0) - imageXOffset(d.align, H), IA = (d.y || 0) - imageYOffset(d.baseline, AA), CA, BA, eA, iA;
    d.aspect !== !1 && (BA = k.width / k.height, eA = d.width / d.height, BA === BA && eA === eA && BA !== eA && (eA < BA ? (iA = H / BA, IA += (AA - iA) / 2, AA = iA) : (iA = AA * BA, gA += (H - iA) / 2, H = iA))), (k.complete || k.toDataURL) && (blend(n, d), n.globalAlpha = (CA = d.opacity) != null ? CA : 1, n.imageSmoothingEnabled = d.smooth !== !1, n.drawImage(k, gA, IA, H, AA));
  });
}
var image$1 = {
  type: "image",
  tag: "image",
  nested: !1,
  attr: attr$4,
  bound: bound$4,
  draw: draw$3,
  pick: pick$1$1(),
  isect: truthy,
  // bounds check is sufficient
  get: getImage,
  xOffset: imageXOffset,
  yOffset: imageYOffset
}, line$2 = markMultiItemPath("line", line$1$1, pickLine);
function attr$3(n, t) {
  var g = t.scaleX || 1, d = t.scaleY || 1;
  (g !== 1 || d !== 1) && n("vector-effect", "non-scaling-stroke"), n("transform", transformItem(t)), n("d", t.path);
}
function path$1(n, t) {
  var g = t.path;
  if (g == null) return !0;
  var d = t.x || 0, k = t.y || 0, H = t.scaleX || 1, AA = t.scaleY || 1, gA = (t.angle || 0) * DegToRad, IA = t.pathCache;
  (!IA || IA.path !== g) && ((t.pathCache = IA = parse$3(g)).path = g), gA && n.rotate && n.translate ? (n.translate(d, k), n.rotate(gA), pathRender(n, IA, 0, 0, H, AA), n.rotate(-gA), n.translate(-d, -k)) : pathRender(n, IA, d, k, H, AA);
}
function bound$3(n, t) {
  return path$1(boundContext(n, t.angle), t) ? n.set(0, 0, 0, 0) : boundStroke(n, t, !0);
}
var path$2 = {
  type: "path",
  tag: "path",
  nested: !1,
  attr: attr$3,
  bound: bound$3,
  draw: drawAll(path$1),
  pick: pickPath(path$1),
  isect: intersectPath(path$1)
};
function attr$2(n, t) {
  n("d", rectangle(null, t));
}
function bound$2(n, t) {
  var g, d;
  return boundStroke(n.set(g = t.x || 0, d = t.y || 0, g + t.width || 0, d + t.height || 0), t);
}
function draw$2(n, t) {
  n.beginPath(), rectangle(n, t);
}
var rect$1 = {
  type: "rect",
  tag: "path",
  nested: !1,
  attr: attr$2,
  bound: bound$2,
  draw: drawAll(draw$2),
  pick: pickPath(draw$2),
  isect: intersectRect
};
function attr$1(n, t) {
  n("transform", translateItem(t)), n("x2", t.x2 != null ? t.x2 - (t.x || 0) : 0), n("y2", t.y2 != null ? t.y2 - (t.y || 0) : 0);
}
function bound$1(n, t) {
  var g, d;
  return boundStroke(n.set(g = t.x || 0, d = t.y || 0, t.x2 != null ? t.x2 : g, t.y2 != null ? t.y2 : d), t);
}
function path$3(n, t, g) {
  var d, k, H, AA;
  return t.stroke && stroke(n, t, g) ? (d = t.x || 0, k = t.y || 0, H = t.x2 != null ? t.x2 : d, AA = t.y2 != null ? t.y2 : k, n.beginPath(), n.moveTo(d, k), n.lineTo(H, AA), !0) : !1;
}
function draw$1(n, t, g) {
  visit(t, (d) => {
    if (!(g && !g.intersects(d.bounds))) {
      var k = d.opacity == null ? 1 : d.opacity;
      k && path$3(n, d, k) && (blend(n, d), n.stroke());
    }
  });
}
function hit$1(n, t, g, d) {
  return n.isPointInStroke ? path$3(n, t, 1) && n.isPointInStroke(g, d) : !1;
}
var rule$2 = {
  type: "rule",
  tag: "line",
  nested: !1,
  attr: attr$1,
  bound: bound$1,
  draw: draw$1,
  pick: pick$1$1(hit$1),
  isect: intersectRule
}, shape = markItemPath("shape", shape$1), symbol = markItemPath("symbol", symbol$1, intersectPoint);
const widthCache = lruCache();
var textMetrics = {
  height: fontSize,
  measureWidth,
  estimateWidth,
  width: estimateWidth,
  canvas: useCanvas
};
useCanvas(!0);
function useCanvas(n) {
  textMetrics.width = n && context$2 ? measureWidth : estimateWidth;
}
function estimateWidth(n, t) {
  return _estimateWidth(textValue(n, t), fontSize(n));
}
function _estimateWidth(n, t) {
  return ~~(0.8 * n.length * t);
}
function measureWidth(n, t) {
  return fontSize(n) <= 0 || !(t = textValue(n, t)) ? 0 : _measureWidth(t, font$1(n));
}
function _measureWidth(n, t) {
  const g = `(${t}) ${n}`;
  let d = widthCache.get(g);
  return d === void 0 && (context$2.font = t, d = context$2.measureText(n).width, widthCache.set(g, d)), d;
}
function fontSize(n) {
  return n.fontSize != null ? +n.fontSize || 0 : 11;
}
function lineHeight(n) {
  return n.lineHeight != null ? n.lineHeight : fontSize(n) + 2;
}
function lineArray(n) {
  return isArray$3(n) ? n.length > 1 ? n : n[0] : n;
}
function textLines(n) {
  return lineArray(n.lineBreak && n.text && !isArray$3(n.text) ? n.text.split(n.lineBreak) : n.text);
}
function multiLineOffset(n) {
  const t = textLines(n);
  return (isArray$3(t) ? t.length - 1 : 0) * lineHeight(n);
}
function textValue(n, t) {
  const g = t == null ? "" : (t + "").trim();
  return n.limit > 0 && g.length ? truncate(n, g) : g;
}
function widthGetter(n) {
  if (textMetrics.width === measureWidth) {
    const t = font$1(n);
    return (g) => _measureWidth(g, t);
  } else if (textMetrics.width === estimateWidth) {
    const t = fontSize(n);
    return (g) => _estimateWidth(g, t);
  } else
    return (t) => textMetrics.width(n, t);
}
function truncate(n, t) {
  var g = +n.limit, d = widthGetter(n);
  if (d(t) < g) return t;
  var k = n.ellipsis || "…", H = n.dir === "rtl", AA = 0, gA = t.length, IA;
  if (g -= d(k), H) {
    for (; AA < gA; )
      IA = AA + gA >>> 1, d(t.slice(IA)) > g ? AA = IA + 1 : gA = IA;
    return k + t.slice(AA);
  } else {
    for (; AA < gA; )
      IA = 1 + (AA + gA >>> 1), d(t.slice(0, IA)) < g ? AA = IA : gA = IA - 1;
    return t.slice(0, AA) + k;
  }
}
function fontFamily(n, t) {
  var g = n.font;
  return (t && g ? String(g).replace(/"/g, "'") : g) || "sans-serif";
}
function font$1(n, t) {
  return (n.fontStyle ? n.fontStyle + " " : "") + (n.fontVariant ? n.fontVariant + " " : "") + (n.fontWeight ? n.fontWeight + " " : "") + fontSize(n) + "px " + fontFamily(n, t);
}
function offset$2(n) {
  var t = n.baseline, g = fontSize(n);
  return Math.round(t === "top" ? 0.79 * g : t === "middle" ? 0.3 * g : t === "bottom" ? -0.21 * g : t === "line-top" ? 0.29 * g + 0.5 * lineHeight(n) : t === "line-bottom" ? 0.29 * g - 0.5 * lineHeight(n) : 0);
}
const textAlign = {
  left: "start",
  center: "middle",
  right: "end"
}, tempBounds$1 = new Bounds();
function anchorPoint(n) {
  var t = n.x || 0, g = n.y || 0, d = n.radius || 0, k;
  return d && (k = (n.theta || 0) - HalfPi, t += d * Math.cos(k), g += d * Math.sin(k)), tempBounds$1.x1 = t, tempBounds$1.y1 = g, tempBounds$1;
}
function attr(n, t) {
  var g = t.dx || 0, d = (t.dy || 0) + offset$2(t), k = anchorPoint(t), H = k.x1, AA = k.y1, gA = t.angle || 0, IA;
  n("text-anchor", textAlign[t.align] || "start"), gA ? (IA = translate$2(H, AA) + " " + rotate(gA), (g || d) && (IA += " " + translate$2(g, d))) : IA = translate$2(H + g, AA + d), n("transform", IA);
}
function bound(n, t, g) {
  var d = textMetrics.height(t), k = t.align, H = anchorPoint(t), AA = H.x1, gA = H.y1, IA = t.dx || 0, CA = (t.dy || 0) + offset$2(t) - Math.round(0.8 * d), BA = textLines(t), eA;
  if (isArray$3(BA) ? (d += lineHeight(t) * (BA.length - 1), eA = BA.reduce((iA, QA) => Math.max(iA, textMetrics.width(t, QA)), 0)) : eA = textMetrics.width(t, BA), k === "center" ? IA -= eA / 2 : k === "right" && (IA -= eA), n.set(IA += AA, CA += gA, IA + eA, CA + d), t.angle && !g)
    n.rotate(t.angle * DegToRad, AA, gA);
  else if (g === 2)
    return n.rotatedPoints(t.angle * DegToRad, AA, gA);
  return n;
}
function draw$5(n, t, g) {
  visit(t, (d) => {
    var k = d.opacity == null ? 1 : d.opacity, H, AA, gA, IA, CA, BA, eA;
    if (!(g && !g.intersects(d.bounds) || // bounds check
    k === 0 || d.fontSize <= 0 || d.text == null || d.text.length === 0)) {
      if (n.font = font$1(d), n.textAlign = d.align || "left", H = anchorPoint(d), AA = H.x1, gA = H.y1, d.angle && (n.save(), n.translate(AA, gA), n.rotate(d.angle * DegToRad), AA = gA = 0), AA += d.dx || 0, gA += (d.dy || 0) + offset$2(d), BA = textLines(d), blend(n, d), isArray$3(BA))
        for (CA = lineHeight(d), IA = 0; IA < BA.length; ++IA)
          eA = textValue(d, BA[IA]), d.fill && fill(n, d, k) && n.fillText(eA, AA, gA), d.stroke && stroke(n, d, k) && n.strokeText(eA, AA, gA), gA += CA;
      else
        eA = textValue(d, BA), d.fill && fill(n, d, k) && n.fillText(eA, AA, gA), d.stroke && stroke(n, d, k) && n.strokeText(eA, AA, gA);
      d.angle && n.restore();
    }
  });
}
function hit(n, t, g, d, k, H) {
  if (t.fontSize <= 0) return !1;
  if (!t.angle) return !0;
  var AA = anchorPoint(t), gA = AA.x1, IA = AA.y1, CA = bound(tempBounds$1, t, 1), BA = -t.angle * DegToRad, eA = Math.cos(BA), iA = Math.sin(BA), QA = eA * k - iA * H + (gA - eA * gA + iA * IA), tA = iA * k + eA * H + (IA - iA * gA - eA * IA);
  return CA.contains(QA, tA);
}
function intersectText(n, t) {
  const g = bound(tempBounds$1, n, 2);
  return intersectBoxLine(t, g[0], g[1], g[2], g[3]) || intersectBoxLine(t, g[0], g[1], g[4], g[5]) || intersectBoxLine(t, g[4], g[5], g[6], g[7]) || intersectBoxLine(t, g[2], g[3], g[6], g[7]);
}
var text$2 = {
  type: "text",
  tag: "text",
  nested: !1,
  attr,
  bound,
  draw: draw$5,
  pick: pick$1$1(hit),
  isect: intersectText
}, trail$2 = markMultiItemPath("trail", trail$1, pickTrail), Marks = {
  arc: arc$2,
  area: area$2,
  group,
  image: image$1,
  line: line$2,
  path: path$2,
  rect: rect$1,
  rule: rule$2,
  shape,
  symbol,
  text: text$2,
  trail: trail$2
};
function boundItem$1(n, t, g) {
  var d = Marks[n.mark.marktype], k = t || d.bound;
  return d.nested && (n = n.mark), k(n.bounds || (n.bounds = new Bounds()), n, g);
}
var DUMMY = {
  mark: null
};
function boundMark(n, t, g) {
  var d = Marks[n.marktype], k = d.bound, H = n.items, AA = H && H.length, gA, IA, CA, BA;
  if (d.nested)
    return AA ? CA = H[0] : (DUMMY.mark = n, CA = DUMMY), BA = boundItem$1(CA, k, g), t = t && t.union(BA) || BA, t;
  if (t = t || n.bounds && n.bounds.clear() || new Bounds(), AA)
    for (gA = 0, IA = H.length; gA < IA; ++gA)
      t.union(boundItem$1(H[gA], k, g));
  return n.bounds = t;
}
const keys$3 = [
  "marktype",
  "name",
  "role",
  "interactive",
  "clip",
  "items",
  "zindex",
  "x",
  "y",
  "width",
  "height",
  "align",
  "baseline",
  // layout
  "fill",
  "fillOpacity",
  "opacity",
  "blend",
  // fill
  "stroke",
  "strokeOpacity",
  "strokeWidth",
  "strokeCap",
  // stroke
  "strokeDash",
  "strokeDashOffset",
  // stroke dash
  "strokeForeground",
  "strokeOffset",
  // group
  "startAngle",
  "endAngle",
  "innerRadius",
  "outerRadius",
  // arc
  "cornerRadius",
  "padAngle",
  // arc, rect
  "cornerRadiusTopLeft",
  "cornerRadiusTopRight",
  // rect, group
  "cornerRadiusBottomLeft",
  "cornerRadiusBottomRight",
  "interpolate",
  "tension",
  "orient",
  "defined",
  // area, line
  "url",
  "aspect",
  "smooth",
  // image
  "path",
  "scaleX",
  "scaleY",
  // path
  "x2",
  "y2",
  // rule
  "size",
  "shape",
  // symbol
  "text",
  "angle",
  "theta",
  "radius",
  "dir",
  "dx",
  "dy",
  // text
  "ellipsis",
  "limit",
  "lineBreak",
  "lineHeight",
  "font",
  "fontSize",
  "fontWeight",
  "fontStyle",
  "fontVariant",
  // font
  "description",
  "aria",
  "ariaRole",
  "ariaRoleDescription"
  // aria
];
function sceneToJSON(n, t) {
  return JSON.stringify(n, keys$3, t);
}
function sceneFromJSON(n) {
  const t = typeof n == "string" ? JSON.parse(n) : n;
  return initialize$1(t);
}
function initialize$1(n) {
  var t = n.marktype, g = n.items, d, k, H;
  if (g)
    for (k = 0, H = g.length; k < H; ++k)
      d = t ? "mark" : "group", g[k][d] = n, g[k].zindex && (g[k][d].zdirty = !0), (t || d) === "group" && initialize$1(g[k]);
  return t && boundMark(n), n;
}
class Scenegraph {
  constructor(t) {
    arguments.length ? this.root = sceneFromJSON(t) : (this.root = createMark({
      marktype: "group",
      name: "root",
      role: "frame"
    }), this.root.items = [new GroupItem(this.root)]);
  }
  toJSON(t) {
    return sceneToJSON(this.root, t || 0);
  }
  mark(t, g, d) {
    g = g || this.root.items[0];
    const k = createMark(t, g);
    return g.items[d] = k, k.zindex && (k.group.zdirty = !0), k;
  }
}
function createMark(n, t) {
  const g = {
    bounds: new Bounds(),
    clip: !!n.clip,
    group: t,
    interactive: n.interactive !== !1,
    items: [],
    marktype: n.marktype,
    name: n.name || void 0,
    role: n.role || void 0,
    zindex: n.zindex || 0
  };
  return n.aria != null && (g.aria = n.aria), n.description && (g.description = n.description), g;
}
function domCreate(n, t, g) {
  return !n && typeof document < "u" && document.createElement && (n = document), n ? g ? n.createElementNS(g, t) : n.createElement(t) : null;
}
function domFind(n, t) {
  t = t.toLowerCase();
  for (var g = n.childNodes, d = 0, k = g.length; d < k; ++d) if (g[d].tagName.toLowerCase() === t)
    return g[d];
}
function domChild(n, t, g, d) {
  var k = n.childNodes[t], H;
  return (!k || k.tagName.toLowerCase() !== g.toLowerCase()) && (H = k || null, k = domCreate(n.ownerDocument, g, d), n.insertBefore(k, H)), k;
}
function domClear(n, t) {
  for (var g = n.childNodes, d = g.length; d > t; ) n.removeChild(g[--d]);
  return n;
}
function cssClass(n) {
  return "mark-" + n.marktype + (n.role ? " role-" + n.role : "") + (n.name ? " " + n.name : "");
}
function point$2(n, t) {
  const g = t.getBoundingClientRect();
  return [n.clientX - g.left - (t.clientLeft || 0), n.clientY - g.top - (t.clientTop || 0)];
}
function resolveItem(n, t, g, d) {
  var k = n && n.mark, H, AA;
  if (k && (H = Marks[k.marktype]).tip) {
    for (AA = point$2(t, g), AA[0] -= d[0], AA[1] -= d[1]; n = n.mark.group; )
      AA[0] -= n.x || 0, AA[1] -= n.y || 0;
    n = H.tip(k.items, AA);
  }
  return n;
}
let Handler$1 = class {
  /**
   * Create a new Handler instance.
   * @param {object} [customLoader] - Optional loader instance for
   *   href URL sanitization. If not specified, a standard loader
   *   instance will be generated.
   * @param {function} [customTooltip] - Optional tooltip handler
   *   function for custom tooltip display.
   * @constructor
   */
  constructor(t, g) {
    this._active = null, this._handlers = {}, this._loader = t || loader(), this._tooltip = g || defaultTooltip$1;
  }
  /**
   * Initialize a new Handler instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {object} [obj] - Optional context object that should serve as
   *   the "this" context for event callbacks.
   * @return {Handler} - This handler instance.
   */
  initialize(t, g, d) {
    return this._el = t, this._obj = d || null, this.origin(g);
  }
  /**
   * Returns the parent container element for a visualization.
   * @return {DOMElement} - The containing DOM element.
   */
  element() {
    return this._el;
  }
  /**
   * Returns the scene element (e.g., canvas or SVG) of the visualization
   * Subclasses must override if the first child is not the scene element.
   * @return {DOMElement} - The scene (e.g., canvas or SVG) element.
   */
  canvas() {
    return this._el && this._el.firstChild;
  }
  /**
   * Get / set the origin coordinates of the visualization.
   */
  origin(t) {
    return arguments.length ? (this._origin = t || [0, 0], this) : this._origin.slice();
  }
  /**
   * Get / set the scenegraph root.
   */
  scene(t) {
    return arguments.length ? (this._scene = t, this) : this._scene;
  }
  /**
   * Add an event handler. Subclasses should override this method.
   */
  on() {
  }
  /**
   * Remove an event handler. Subclasses should override this method.
   */
  off() {
  }
  /**
   * Utility method for finding the array index of an event handler.
   * @param {Array} h - An array of registered event handlers.
   * @param {string} type - The event type.
   * @param {function} handler - The event handler instance to find.
   * @return {number} - The handler's array index or -1 if not registered.
   */
  _handlerIndex(t, g, d) {
    for (let k = t ? t.length : 0; --k >= 0; )
      if (t[k].type === g && (!d || t[k].handler === d))
        return k;
    return -1;
  }
  /**
   * Returns an array with registered event handlers.
   * @param {string} [type] - The event type to query. Any annotations
   *   are ignored; for example, for the argument "click.foo", ".foo" will
   *   be ignored and the method returns all "click" handlers. If type is
   *   null or unspecified, this method returns handlers for all types.
   * @return {Array} - A new array containing all registered event handlers.
   */
  handlers(t) {
    const g = this._handlers, d = [];
    if (t)
      d.push(...g[this.eventName(t)]);
    else
      for (const k in g)
        d.push(...g[k]);
    return d;
  }
  /**
   * Parses an event name string to return the specific event type.
   * For example, given "click.foo" returns "click"
   * @param {string} name - The input event type string.
   * @return {string} - A string with the event type only.
   */
  eventName(t) {
    const g = t.indexOf(".");
    return g < 0 ? t : t.slice(0, g);
  }
  /**
   * Handle hyperlink navigation in response to an item.href value.
   * @param {Event} event - The event triggering hyperlink navigation.
   * @param {Item} item - The scenegraph item.
   * @param {string} href - The URL to navigate to.
   */
  handleHref(t, g, d) {
    this._loader.sanitize(d, {
      context: "href"
    }).then((k) => {
      const H = new MouseEvent(t.type, t), AA = domCreate(null, "a");
      for (const gA in k) AA.setAttribute(gA, k[gA]);
      AA.dispatchEvent(H);
    }).catch(() => {
    });
  }
  /**
   * Handle tooltip display in response to an item.tooltip value.
   * @param {Event} event - The event triggering tooltip display.
   * @param {Item} item - The scenegraph item.
   * @param {boolean} show - A boolean flag indicating whether
   *   to show or hide a tooltip for the given item.
   */
  handleTooltip(t, g, d) {
    if (g && g.tooltip != null) {
      g = resolveItem(g, t, this.canvas(), this._origin);
      const k = d && g && g.tooltip || null;
      this._tooltip.call(this._obj, this, t, g, k);
    }
  }
  /**
   * Returns the size of a scenegraph item and its position relative
   * to the viewport.
   * @param {Item} item - The scenegraph item.
   * @return {object} - A bounding box object (compatible with the
   *   DOMRect type) consisting of x, y, width, heigh, top, left,
   *   right, and bottom properties.
   */
  getItemBoundingClientRect(t) {
    const g = this.canvas();
    if (!g) return;
    const d = g.getBoundingClientRect(), k = this._origin, H = t.bounds, AA = H.width(), gA = H.height();
    let IA = H.x1 + k[0] + d.left, CA = H.y1 + k[1] + d.top;
    for (; t.mark && (t = t.mark.group); )
      IA += t.x || 0, CA += t.y || 0;
    return {
      x: IA,
      y: CA,
      width: AA,
      height: gA,
      left: IA,
      top: CA,
      right: IA + AA,
      bottom: CA + gA
    };
  }
};
function defaultTooltip$1(n, t, g, d) {
  n.element().setAttribute("title", d || "");
}
class Renderer {
  /**
   * Create a new Renderer instance.
   * @param {object} [loader] - Optional loader instance for
   *   image and href URL sanitization. If not specified, a
   *   standard loader instance will be generated.
   * @constructor
   */
  constructor(t) {
    this._el = null, this._bgcolor = null, this._loader = new ResourceLoader(t);
  }
  /**
   * Initialize a new Renderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {Renderer} - This renderer instance.
   */
  initialize(t, g, d, k, H) {
    return this._el = t, this.resize(g, d, k, H);
  }
  /**
   * Returns the parent container element for a visualization.
   * @return {DOMElement} - The containing DOM element.
   */
  element() {
    return this._el;
  }
  /**
   * Returns the scene element (e.g., canvas or SVG) of the visualization
   * Subclasses must override if the first child is not the scene element.
   * @return {DOMElement} - The scene (e.g., canvas or SVG) element.
   */
  canvas() {
    return this._el && this._el.firstChild;
  }
  /**
   * Get / set the background color.
   */
  background(t) {
    return arguments.length === 0 ? this._bgcolor : (this._bgcolor = t, this);
  }
  /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {Renderer} - This renderer instance;
   */
  resize(t, g, d, k) {
    return this._width = t, this._height = g, this._origin = d || [0, 0], this._scale = k || 1, this;
  }
  /**
   * Report a dirty item whose bounds should be redrawn.
   * This base class method does nothing. Subclasses that perform
   * incremental should implement this method.
   * @param {Item} item - The dirty item whose bounds should be redrawn.
   */
  dirty() {
  }
  /**
   * Render an input scenegraph, potentially with a set of dirty items.
   * This method will perform an immediate rendering with available resources.
   * The renderer may also need to perform image loading to perform a complete
   * render. This process can lead to asynchronous re-rendering of the scene
   * after this method returns. To receive notification when rendering is
   * complete, use the renderAsync method instead.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   * @return {Renderer} - This renderer instance.
   */
  render(t, g) {
    const d = this;
    return d._call = function() {
      d._render(t, g);
    }, d._call(), d._call = null, d;
  }
  /**
   * Internal rendering method. Renderer subclasses should override this
   * method to actually perform rendering.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */
  _render() {
  }
  /**
   * Asynchronous rendering method. Similar to render, but returns a Promise
   * that resolves when all rendering is completed. Sometimes a renderer must
   * perform image loading to get a complete rendering. The returned
   * Promise will not resolve until this process completes.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   * @return {Promise} - A Promise that resolves when rendering is complete.
   */
  renderAsync(t, g) {
    const d = this.render(t, g);
    return this._ready ? this._ready.then(() => d) : Promise.resolve(d);
  }
  /**
   * Internal method for asynchronous resource loading.
   * Proxies method calls to the ImageLoader, and tracks loading
   * progress to invoke a re-render once complete.
   * @param {string} method - The method name to invoke on the ImageLoader.
   * @param {string} uri - The URI for the requested resource.
   * @return {Promise} - A Promise that resolves to the requested resource.
   */
  _load(t, g) {
    var d = this, k = d._loader[t](g);
    if (!d._ready) {
      const H = d._call;
      d._ready = d._loader.ready().then((AA) => {
        AA && H(), d._ready = null;
      });
    }
    return k;
  }
  /**
   * Sanitize a URL to include as a hyperlink in the rendered scene.
   * This method proxies a call to ImageLoader.sanitizeURL, but also tracks
   * image loading progress and invokes a re-render once complete.
   * @param {string} uri - The URI string to sanitize.
   * @return {Promise} - A Promise that resolves to the sanitized URL.
   */
  sanitizeURL(t) {
    return this._load("sanitizeURL", t);
  }
  /**
   * Requests an image to include in the rendered scene.
   * This method proxies a call to ImageLoader.loadImage, but also tracks
   * image loading progress and invokes a re-render once complete.
   * @param {string} uri - The URI string of the image.
   * @return {Promise} - A Promise that resolves to the loaded Image.
   */
  loadImage(t) {
    return this._load("loadImage", t);
  }
}
const KeyDownEvent = "keydown", KeyPressEvent = "keypress", KeyUpEvent = "keyup", DragEnterEvent = "dragenter", DragLeaveEvent = "dragleave", DragOverEvent = "dragover", PointerDownEvent = "pointerdown", PointerUpEvent = "pointerup", PointerMoveEvent = "pointermove", PointerOutEvent = "pointerout", PointerOverEvent = "pointerover", MouseDownEvent = "mousedown", MouseUpEvent = "mouseup", MouseMoveEvent = "mousemove", MouseOutEvent = "mouseout", MouseOverEvent = "mouseover", ClickEvent = "click", DoubleClickEvent = "dblclick", WheelEvent = "wheel", MouseWheelEvent = "mousewheel", TouchStartEvent = "touchstart", TouchMoveEvent = "touchmove", TouchEndEvent = "touchend", Events = [KeyDownEvent, KeyPressEvent, KeyUpEvent, DragEnterEvent, DragLeaveEvent, DragOverEvent, PointerDownEvent, PointerUpEvent, PointerMoveEvent, PointerOutEvent, PointerOverEvent, MouseDownEvent, MouseUpEvent, MouseMoveEvent, MouseOutEvent, MouseOverEvent, ClickEvent, DoubleClickEvent, WheelEvent, MouseWheelEvent, TouchStartEvent, TouchMoveEvent, TouchEndEvent], TooltipShowEvent = PointerMoveEvent, TooltipHideEvent = MouseOutEvent, HrefEvent = ClickEvent;
class CanvasHandler extends Handler$1 {
  constructor(t, g) {
    super(t, g), this._down = null, this._touch = null, this._first = !0, this._events = {}, this.events = Events, this.pointermove = move([PointerMoveEvent, MouseMoveEvent], [PointerOverEvent, MouseOverEvent], [PointerOutEvent, MouseOutEvent]), this.dragover = move([DragOverEvent], [DragEnterEvent], [DragLeaveEvent]), this.pointerout = inactive([PointerOutEvent, MouseOutEvent]), this.dragleave = inactive([DragLeaveEvent]);
  }
  initialize(t, g, d) {
    return this._canvas = t && domFind(t, "canvas"), [ClickEvent, MouseDownEvent, PointerDownEvent, PointerMoveEvent, PointerOutEvent, DragLeaveEvent].forEach((k) => eventListenerCheck(this, k)), super.initialize(t, g, d);
  }
  // return the backing canvas instance
  canvas() {
    return this._canvas;
  }
  // retrieve the current canvas context
  context() {
    return this._canvas.getContext("2d");
  }
  // to keep old versions of firefox happy
  DOMMouseScroll(t) {
    this.fire(MouseWheelEvent, t);
  }
  pointerdown(t) {
    this._down = this._active, this.fire(PointerDownEvent, t);
  }
  mousedown(t) {
    this._down = this._active, this.fire(MouseDownEvent, t);
  }
  click(t) {
    this._down === this._active && (this.fire(ClickEvent, t), this._down = null);
  }
  touchstart(t) {
    this._touch = this.pickEvent(t.changedTouches[0]), this._first && (this._active = this._touch, this._first = !1), this.fire(TouchStartEvent, t, !0);
  }
  touchmove(t) {
    this.fire(TouchMoveEvent, t, !0);
  }
  touchend(t) {
    this.fire(TouchEndEvent, t, !0), this._touch = null;
  }
  // fire an event
  fire(t, g, d) {
    const k = d ? this._touch : this._active, H = this._handlers[t];
    if (g.vegaType = t, t === HrefEvent && k && k.href ? this.handleHref(g, k, k.href) : (t === TooltipShowEvent || t === TooltipHideEvent) && this.handleTooltip(g, k, t !== TooltipHideEvent), H)
      for (let AA = 0, gA = H.length; AA < gA; ++AA)
        H[AA].handler.call(this._obj, g, k);
  }
  // add an event handler
  on(t, g) {
    const d = this.eventName(t), k = this._handlers;
    return this._handlerIndex(k[d], t, g) < 0 && (eventListenerCheck(this, t), (k[d] || (k[d] = [])).push({
      type: t,
      handler: g
    })), this;
  }
  // remove an event handler
  off(t, g) {
    const d = this.eventName(t), k = this._handlers[d], H = this._handlerIndex(k, t, g);
    return H >= 0 && k.splice(H, 1), this;
  }
  pickEvent(t) {
    const g = point$2(t, this._canvas), d = this._origin;
    return this.pick(this._scene, g[0], g[1], g[0] - d[0], g[1] - d[1]);
  }
  // find the scenegraph item at the current pointer position
  // x, y -- the absolute x, y pointer coordinates on the canvas element
  // gx, gy -- the relative coordinates within the current group
  pick(t, g, d, k, H) {
    const AA = this.context();
    return Marks[t.marktype].pick.call(this, AA, t, g, d, k, H);
  }
}
const eventBundle = (n) => n === TouchStartEvent || n === TouchMoveEvent || n === TouchEndEvent ? [TouchStartEvent, TouchMoveEvent, TouchEndEvent] : [n];
function eventListenerCheck(n, t) {
  eventBundle(t).forEach((g) => addEventListener(n, g));
}
function addEventListener(n, t) {
  const g = n.canvas();
  g && !n._events[t] && (n._events[t] = 1, g.addEventListener(t, n[t] ? (d) => n[t](d) : (d) => n.fire(t, d)));
}
function fireAll(n, t, g) {
  t.forEach((d) => n.fire(d, g));
}
function move(n, t, g) {
  return function(d) {
    const k = this._active, H = this.pickEvent(d);
    H === k ? fireAll(this, n, d) : ((!k || !k.exit) && fireAll(this, g, d), this._active = H, fireAll(this, t, d), fireAll(this, n, d));
  };
}
function inactive(n) {
  return function(t) {
    fireAll(this, n, t), this._active = null;
  };
}
function devicePixelRatio() {
  return typeof window < "u" && window.devicePixelRatio || 1;
}
function resize(n, t, g, d, k, H) {
  const AA = typeof HTMLElement < "u" && n instanceof HTMLElement && n.parentNode != null, gA = n.getContext("2d"), IA = AA ? devicePixelRatio() : k;
  n.width = t * IA, n.height = g * IA;
  for (const CA in H)
    gA[CA] = H[CA];
  return AA && IA !== 1 && (n.style.width = t + "px", n.style.height = g + "px"), gA.pixelRatio = IA, gA.setTransform(IA, 0, 0, IA, IA * d[0], IA * d[1]), n;
}
class CanvasRenderer extends Renderer {
  constructor(t) {
    super(t), this._options = {}, this._redraw = !1, this._dirty = new Bounds(), this._tempb = new Bounds();
  }
  initialize(t, g, d, k, H, AA) {
    return this._options = AA || {}, this._canvas = this._options.externalContext ? null : domCanvas(1, 1, this._options.type), t && this._canvas && (domClear(t, 0).appendChild(this._canvas), this._canvas.setAttribute("class", "marks")), super.initialize(t, g, d, k, H);
  }
  resize(t, g, d, k) {
    if (super.resize(t, g, d, k), this._canvas)
      resize(this._canvas, this._width, this._height, this._origin, this._scale, this._options.context);
    else {
      const H = this._options.externalContext;
      H || error$3("CanvasRenderer is missing a valid canvas or context"), H.scale(this._scale, this._scale), H.translate(this._origin[0], this._origin[1]);
    }
    return this._redraw = !0, this;
  }
  canvas() {
    return this._canvas;
  }
  context() {
    return this._options.externalContext || (this._canvas ? this._canvas.getContext("2d") : null);
  }
  dirty(t) {
    const g = this._tempb.clear().union(t.bounds);
    let d = t.mark.group;
    for (; d; )
      g.translate(d.x || 0, d.y || 0), d = d.mark.group;
    this._dirty.union(g);
  }
  _render(t, g) {
    const d = this.context(), k = this._origin, H = this._width, AA = this._height, gA = this._dirty, IA = viewBounds(k, H, AA);
    d.save();
    const CA = this._redraw || gA.empty() ? (this._redraw = !1, IA.expand(1)) : clipToBounds(d, IA.intersect(gA), k);
    return this.clear(-k[0], -k[1], H, AA), this.draw(d, t, CA, g), d.restore(), gA.clear(), this;
  }
  draw(t, g, d, k) {
    if (g.marktype !== "group" && k != null && !k.includes(g.marktype))
      return;
    const H = Marks[g.marktype];
    g.clip && clip$2(t, g), H.draw.call(this, t, g, d, k), g.clip && t.restore();
  }
  clear(t, g, d, k) {
    const H = this._options, AA = this.context();
    H.type !== "pdf" && !H.externalContext && AA.clearRect(t, g, d, k), this._bgcolor != null && (AA.fillStyle = this._bgcolor, AA.fillRect(t, g, d, k));
  }
}
const viewBounds = (n, t, g) => new Bounds().set(0, 0, t, g).translate(-n[0], -n[1]);
function clipToBounds(n, t, g) {
  return t.expand(1).round(), n.pixelRatio % 1 && t.scale(n.pixelRatio).round().scale(1 / n.pixelRatio), t.translate(-(g[0] % 1), -(g[1] % 1)), n.beginPath(), n.rect(t.x1, t.y1, t.width(), t.height()), n.clip(), t;
}
class SVGHandler extends Handler$1 {
  constructor(t, g) {
    super(t, g);
    const d = this;
    d._hrefHandler = listener(d, (k, H) => {
      H && H.href && d.handleHref(k, H, H.href);
    }), d._tooltipHandler = listener(d, (k, H) => {
      d.handleTooltip(k, H, k.type !== TooltipHideEvent);
    });
  }
  initialize(t, g, d) {
    let k = this._svg;
    return k && (k.removeEventListener(HrefEvent, this._hrefHandler), k.removeEventListener(TooltipShowEvent, this._tooltipHandler), k.removeEventListener(TooltipHideEvent, this._tooltipHandler)), this._svg = k = t && domFind(t, "svg"), k && (k.addEventListener(HrefEvent, this._hrefHandler), k.addEventListener(TooltipShowEvent, this._tooltipHandler), k.addEventListener(TooltipHideEvent, this._tooltipHandler)), super.initialize(t, g, d);
  }
  canvas() {
    return this._svg;
  }
  // add an event handler
  on(t, g) {
    const d = this.eventName(t), k = this._handlers;
    if (this._handlerIndex(k[d], t, g) < 0) {
      const AA = {
        type: t,
        handler: g,
        listener: listener(this, g)
      };
      (k[d] || (k[d] = [])).push(AA), this._svg && this._svg.addEventListener(d, AA.listener);
    }
    return this;
  }
  // remove an event handler
  off(t, g) {
    const d = this.eventName(t), k = this._handlers[d], H = this._handlerIndex(k, t, g);
    return H >= 0 && (this._svg && this._svg.removeEventListener(d, k[H].listener), k.splice(H, 1)), this;
  }
}
const listener = (n, t) => (g) => {
  let d = g.target.__data__;
  d = Array.isArray(d) ? d[0] : d, g.vegaType = g.type, t.call(n._obj, g, d);
}, ARIA_HIDDEN = "aria-hidden", ARIA_LABEL = "aria-label", ARIA_ROLE = "role", ARIA_ROLEDESCRIPTION = "aria-roledescription", GRAPHICS_OBJECT = "graphics-object", GRAPHICS_SYMBOL = "graphics-symbol", bundle = (n, t, g) => ({
  [ARIA_ROLE]: n,
  [ARIA_ROLEDESCRIPTION]: t,
  [ARIA_LABEL]: g || void 0
}), AriaIgnore = toSet(["axis-domain", "axis-grid", "axis-label", "axis-tick", "axis-title", "legend-band", "legend-entry", "legend-gradient", "legend-label", "legend-title", "legend-symbol", "title"]), AriaGuides = {
  axis: {
    desc: "axis",
    caption: axisCaption
  },
  legend: {
    desc: "legend",
    caption: legendCaption
  },
  "title-text": {
    desc: "title",
    caption: (n) => `Title text '${titleCaption(n)}'`
  },
  "title-subtitle": {
    desc: "subtitle",
    caption: (n) => `Subtitle text '${titleCaption(n)}'`
  }
}, AriaEncode = {
  ariaRole: ARIA_ROLE,
  ariaRoleDescription: ARIA_ROLEDESCRIPTION,
  description: ARIA_LABEL
};
function ariaItemAttributes(n, t) {
  const g = t.aria === !1;
  if (n(ARIA_HIDDEN, g || void 0), g || t.description == null)
    for (const d in AriaEncode)
      n(AriaEncode[d], void 0);
  else {
    const d = t.mark.marktype;
    n(ARIA_LABEL, t.description), n(ARIA_ROLE, t.ariaRole || (d === "group" ? GRAPHICS_OBJECT : GRAPHICS_SYMBOL)), n(ARIA_ROLEDESCRIPTION, t.ariaRoleDescription || `${d} mark`);
  }
}
function ariaMarkAttributes(n) {
  return n.aria === !1 ? {
    [ARIA_HIDDEN]: !0
  } : AriaIgnore[n.role] ? null : AriaGuides[n.role] ? ariaGuide(n, AriaGuides[n.role]) : ariaMark(n);
}
function ariaMark(n) {
  const t = n.marktype, g = t === "group" || t === "text" || n.items.some((d) => d.description != null && d.aria !== !1);
  return bundle(g ? GRAPHICS_OBJECT : GRAPHICS_SYMBOL, `${t} mark container`, n.description);
}
function ariaGuide(n, t) {
  try {
    const g = n.items[0], d = t.caption || (() => "");
    return bundle(t.role || GRAPHICS_SYMBOL, t.desc, g.description || d(g));
  } catch {
    return null;
  }
}
function titleCaption(n) {
  return array$6(n.text).join(" ");
}
function axisCaption(n) {
  const t = n.datum, g = n.orient, d = t.title ? extractTitle(n) : null, k = n.context, H = k.scales[t.scale].value, AA = k.dataflow.locale(), gA = H.type;
  return `${g === "left" || g === "right" ? "Y" : "X"}-axis` + (d ? ` titled '${d}'` : "") + ` for a ${isDiscrete$2(gA) ? "discrete" : gA} scale with ${domainCaption(AA, H, n)}`;
}
function legendCaption(n) {
  const t = n.datum, g = t.title ? extractTitle(n) : null, d = `${t.type || ""} legend`.trim(), k = t.scales, H = Object.keys(k), AA = n.context, gA = AA.scales[k[H[0]]].value, IA = AA.dataflow.locale();
  return capitalize(d) + (g ? ` titled '${g}'` : "") + ` for ${channelCaption(H)} with ${domainCaption(IA, gA, n)}`;
}
function extractTitle(n) {
  try {
    return array$6(peek$2(n.items).items[0].text).join(" ");
  } catch {
    return null;
  }
}
function channelCaption(n) {
  return n = n.map((t) => t + (t === "fill" || t === "stroke" ? " color" : "")), n.length < 2 ? n[0] : n.slice(0, -1).join(", ") + " and " + peek$2(n);
}
function capitalize(n) {
  return n.length ? n[0].toUpperCase() + n.slice(1) : n;
}
const innerText = (n) => (n + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), attrText = (n) => innerText(n).replace(/"/g, "&quot;").replace(/\t/g, "&#x9;").replace(/\n/g, "&#xA;").replace(/\r/g, "&#xD;");
function markup() {
  let n = "", t = "", g = "";
  const d = [], k = () => t = g = "", H = (IA) => {
    t && (n += `${t}>${g}`, k()), d.push(IA);
  }, AA = (IA, CA) => (CA != null && (t += ` ${IA}="${attrText(CA)}"`), gA), gA = {
    open(IA, ...CA) {
      H(IA), t = "<" + IA;
      for (const BA of CA)
        for (const eA in BA) AA(eA, BA[eA]);
      return gA;
    },
    close() {
      const IA = d.pop();
      return t ? n += t + (g ? `>${g}</${IA}>` : "/>") : n += `</${IA}>`, k(), gA;
    },
    attr: AA,
    text: (IA) => (g += innerText(IA), gA),
    toString: () => n
  };
  return gA;
}
const serializeXML = (n) => _serialize(markup(), n) + "";
function _serialize(n, t) {
  if (n.open(t.tagName), t.hasAttributes()) {
    const g = t.attributes, d = g.length;
    for (let k = 0; k < d; ++k)
      n.attr(g[k].name, g[k].value);
  }
  if (t.hasChildNodes()) {
    const g = t.childNodes;
    for (const d of g)
      d.nodeType === 3 ? n.text(d.nodeValue) : _serialize(n, d);
  }
  return n.close();
}
const stylesAttr = {
  fill: "fill",
  fillOpacity: "fill-opacity",
  stroke: "stroke",
  strokeOpacity: "stroke-opacity",
  strokeWidth: "stroke-width",
  strokeCap: "stroke-linecap",
  strokeJoin: "stroke-linejoin",
  strokeDash: "stroke-dasharray",
  strokeDashOffset: "stroke-dashoffset",
  strokeMiterLimit: "stroke-miterlimit",
  opacity: "opacity"
}, stylesCss = {
  blend: "mix-blend-mode"
}, rootAttributes = {
  fill: "none",
  "stroke-miterlimit": 10
}, RootIndex = 0, xmlns = "http://www.w3.org/2000/xmlns/", svgns = metadata.xmlns;
class SVGRenderer extends Renderer {
  constructor(t) {
    super(t), this._dirtyID = 0, this._dirty = [], this._svg = null, this._root = null, this._defs = null;
  }
  /**
   * Initialize a new SVGRenderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance.
   */
  initialize(t, g, d, k, H) {
    return this._defs = {}, this._clearDefs(), t && (this._svg = domChild(t, 0, "svg", svgns), this._svg.setAttributeNS(xmlns, "xmlns", svgns), this._svg.setAttributeNS(xmlns, "xmlns:xlink", metadata["xmlns:xlink"]), this._svg.setAttribute("version", metadata.version), this._svg.setAttribute("class", "marks"), domClear(t, 1), this._root = domChild(this._svg, RootIndex, "g", svgns), setAttributes(this._root, rootAttributes), domClear(this._svg, RootIndex + 1)), this.background(this._bgcolor), super.initialize(t, g, d, k, H);
  }
  /**
   * Get / set the background color.
   */
  background(t) {
    return arguments.length && this._svg && this._svg.style.setProperty("background-color", t), super.background(...arguments);
  }
  /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance;
   */
  resize(t, g, d, k) {
    return super.resize(t, g, d, k), this._svg && (setAttributes(this._svg, {
      width: this._width * this._scale,
      height: this._height * this._scale,
      viewBox: `0 0 ${this._width} ${this._height}`
    }), this._root.setAttribute("transform", `translate(${this._origin})`)), this._dirty = [], this;
  }
  /**
   * Returns the SVG element of the visualization.
   * @return {DOMElement} - The SVG element.
   */
  canvas() {
    return this._svg;
  }
  /**
   * Returns an SVG text string for the rendered content,
   * or null if this renderer is currently headless.
   */
  svg() {
    const t = this._svg, g = this._bgcolor;
    if (!t) return null;
    let d;
    g && (t.removeAttribute("style"), d = domChild(t, RootIndex, "rect", svgns), setAttributes(d, {
      width: this._width,
      height: this._height,
      fill: g
    }));
    const k = serializeXML(t);
    return g && (t.removeChild(d), this._svg.style.setProperty("background-color", g)), k;
  }
  /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */
  _render(t, g) {
    return this._dirtyCheck() && (this._dirtyAll && this._clearDefs(), this.mark(this._root, t, void 0, g), domClear(this._root, 1)), this.defs(), this._dirty = [], ++this._dirtyID, this;
  }
  // -- Manage rendering of items marked as dirty --
  /**
   * Flag a mark item as dirty.
   * @param {Item} item - The mark item.
   */
  dirty(t) {
    t.dirty !== this._dirtyID && (t.dirty = this._dirtyID, this._dirty.push(t));
  }
  /**
   * Check if a mark item is considered dirty.
   * @param {Item} item - The mark item.
   */
  isDirty(t) {
    return this._dirtyAll || !t._svg || !t._svg.ownerSVGElement || t.dirty === this._dirtyID;
  }
  /**
   * Internal method to check dirty status and, if possible,
   * make targetted updates without a full rendering pass.
   */
  _dirtyCheck() {
    this._dirtyAll = !0;
    const t = this._dirty;
    if (!t.length || !this._dirtyID) return !0;
    const g = ++this._dirtyID;
    let d, k, H, AA, gA, IA, CA;
    for (gA = 0, IA = t.length; gA < IA; ++gA)
      if (d = t[gA], k = d.mark, k.marktype !== H && (H = k.marktype, AA = Marks[H]), k.zdirty && k.dirty !== g && (this._dirtyAll = !1, dirtyParents(d, g), k.items.forEach((BA) => {
        BA.dirty = g;
      })), !k.zdirty) {
        if (d.exit) {
          AA.nested && k.items.length ? (CA = k.items[0], CA._svg && this._update(AA, CA._svg, CA)) : d._svg && (CA = d._svg.parentNode, CA && CA.removeChild(d._svg)), d._svg = null;
          continue;
        }
        d = AA.nested ? k.items[0] : d, d._update !== g && (!d._svg || !d._svg.ownerSVGElement ? (this._dirtyAll = !1, dirtyParents(d, g)) : this._update(AA, d._svg, d), d._update = g);
      }
    return !this._dirtyAll;
  }
  // -- Construct & maintain scenegraph to SVG mapping ---
  /**
   * Render a set of mark items.
   * @param {SVGElement} el - The parent element in the SVG tree.
   * @param {object} scene - The mark parent to render.
   * @param {SVGElement} prev - The previous sibling in the SVG tree.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */
  mark(t, g, d, k) {
    if (!this.isDirty(g))
      return g._svg;
    const H = this._svg, AA = g.marktype, gA = Marks[AA], IA = g.interactive === !1 ? "none" : null, CA = gA.tag === "g", BA = bind$2(g, t, d, "g", H);
    if (AA !== "group" && k != null && !k.includes(AA))
      return domClear(BA, 0), g._svg;
    BA.setAttribute("class", cssClass(g));
    const eA = ariaMarkAttributes(g);
    for (const oA in eA) setAttribute(BA, oA, eA[oA]);
    CA || setAttribute(BA, "pointer-events", IA), setAttribute(BA, "clip-path", g.clip ? clip$1$1(this, g, g.group) : null);
    let iA = null, QA = 0;
    const tA = (oA) => {
      const EA = this.isDirty(oA), aA = bind$2(oA, BA, iA, gA.tag, H);
      EA && (this._update(gA, aA, oA), CA && recurse(this, aA, oA, k)), iA = aA, ++QA;
    };
    return gA.nested ? g.items.length && tA(g.items[0]) : visit(g, tA), domClear(BA, QA), BA;
  }
  /**
   * Update the attributes of an SVG element for a mark item.
   * @param {object} mdef - The mark definition object
   * @param {SVGElement} el - The SVG element.
   * @param {Item} item - The mark item.
   */
  _update(t, g, d) {
    element$1 = g, values$5 = g.__values__, ariaItemAttributes(emit, d), t.attr(emit, d, this);
    const k = mark_extras[t.type];
    k && k.call(this, t, g, d), element$1 && this.style(element$1, d);
  }
  /**
   * Update the presentation attributes of an SVG element for a mark item.
   * @param {SVGElement} el - The SVG element.
   * @param {Item} item - The mark item.
   */
  style(t, g) {
    if (g != null) {
      for (const d in stylesAttr) {
        let k = d === "font" ? fontFamily(g) : g[d];
        if (k === values$5[d]) continue;
        const H = stylesAttr[d];
        k == null ? t.removeAttribute(H) : (isGradient(k) && (k = gradientRef(k, this._defs.gradient, href())), t.setAttribute(H, k + "")), values$5[d] = k;
      }
      for (const d in stylesCss)
        setStyle(t, stylesCss[d], g[d]);
    }
  }
  /**
   * Render SVG defs, as needed.
   * Must be called *after* marks have been processed to ensure the
   * collected state is current and accurate.
   */
  defs() {
    const t = this._svg, g = this._defs;
    let d = g.el, k = 0;
    for (const H in g.gradient)
      d || (g.el = d = domChild(t, RootIndex + 1, "defs", svgns)), k = updateGradient(d, g.gradient[H], k);
    for (const H in g.clipping)
      d || (g.el = d = domChild(t, RootIndex + 1, "defs", svgns)), k = updateClipping(d, g.clipping[H], k);
    d && (k === 0 ? (t.removeChild(d), g.el = null) : domClear(d, k));
  }
  /**
   * Clear defs caches.
   */
  _clearDefs() {
    const t = this._defs;
    t.gradient = {}, t.clipping = {};
  }
}
function dirtyParents(n, t) {
  for (; n && n.dirty !== t; n = n.mark.group)
    if (n.dirty = t, n.mark && n.mark.dirty !== t)
      n.mark.dirty = t;
    else return;
}
function updateGradient(n, t, g) {
  let d, k, H;
  if (t.gradient === "radial") {
    let AA = domChild(n, g++, "pattern", svgns);
    setAttributes(AA, {
      id: patternPrefix + t.id,
      viewBox: "0,0,1,1",
      width: "100%",
      height: "100%",
      preserveAspectRatio: "xMidYMid slice"
    }), AA = domChild(AA, 0, "rect", svgns), setAttributes(AA, {
      width: 1,
      height: 1,
      fill: `url(${href()}#${t.id})`
    }), n = domChild(n, g++, "radialGradient", svgns), setAttributes(n, {
      id: t.id,
      fx: t.x1,
      fy: t.y1,
      fr: t.r1,
      cx: t.x2,
      cy: t.y2,
      r: t.r2
    });
  } else
    n = domChild(n, g++, "linearGradient", svgns), setAttributes(n, {
      id: t.id,
      x1: t.x1,
      x2: t.x2,
      y1: t.y1,
      y2: t.y2
    });
  for (d = 0, k = t.stops.length; d < k; ++d)
    H = domChild(n, d, "stop", svgns), H.setAttribute("offset", t.stops[d].offset), H.setAttribute("stop-color", t.stops[d].color);
  return domClear(n, d), g;
}
function updateClipping(n, t, g) {
  let d;
  return n = domChild(n, g, "clipPath", svgns), n.setAttribute("id", t.id), t.path ? (d = domChild(n, 0, "path", svgns), d.setAttribute("d", t.path)) : (d = domChild(n, 0, "rect", svgns), setAttributes(d, {
    x: 0,
    y: 0,
    width: t.width,
    height: t.height
  })), domClear(n, 1), g + 1;
}
function recurse(n, t, g, d) {
  t = t.lastChild.previousSibling;
  let k, H = 0;
  visit(g, (AA) => {
    k = n.mark(t, AA, k, d), ++H;
  }), domClear(t, 1 + H);
}
function bind$2(n, t, g, d, k) {
  let H = n._svg, AA;
  if (!H && (AA = t.ownerDocument, H = domCreate(AA, d, svgns), n._svg = H, n.mark && (H.__data__ = n, H.__values__ = {
    fill: "default"
  }, d === "g"))) {
    const gA = domCreate(AA, "path", svgns);
    H.appendChild(gA), gA.__data__ = n;
    const IA = domCreate(AA, "g", svgns);
    H.appendChild(IA), IA.__data__ = n;
    const CA = domCreate(AA, "path", svgns);
    H.appendChild(CA), CA.__data__ = n, CA.__values__ = {
      fill: "default"
    };
  }
  return (H.ownerSVGElement !== k || siblingCheck(H, g)) && t.insertBefore(H, g ? g.nextSibling : t.firstChild), H;
}
function siblingCheck(n, t) {
  return n.parentNode && n.parentNode.childNodes.length > 1 && n.previousSibling != t;
}
let element$1 = null, values$5 = null;
const mark_extras = {
  group(n, t, g) {
    const d = element$1 = t.childNodes[2];
    values$5 = d.__values__, n.foreground(emit, g, this), values$5 = t.__values__, element$1 = t.childNodes[1], n.content(emit, g, this);
    const k = element$1 = t.childNodes[0];
    n.background(emit, g, this);
    const H = g.mark.interactive === !1 ? "none" : null;
    if (H !== values$5.events && (setAttribute(d, "pointer-events", H), setAttribute(k, "pointer-events", H), values$5.events = H), g.strokeForeground && g.stroke) {
      const AA = g.fill;
      setAttribute(d, "display", null), this.style(k, g), setAttribute(k, "stroke", null), AA && (g.fill = null), values$5 = d.__values__, this.style(d, g), AA && (g.fill = AA), element$1 = null;
    } else
      setAttribute(d, "display", "none");
  },
  image(n, t, g) {
    g.smooth === !1 ? (setStyle(t, "image-rendering", "optimizeSpeed"), setStyle(t, "image-rendering", "pixelated")) : setStyle(t, "image-rendering", null);
  },
  text(n, t, g) {
    const d = textLines(g);
    let k, H, AA, gA;
    isArray$3(d) ? (H = d.map((IA) => textValue(g, IA)), k = H.join(`
`), k !== values$5.text && (domClear(t, 0), AA = t.ownerDocument, gA = lineHeight(g), H.forEach((IA, CA) => {
      const BA = domCreate(AA, "tspan", svgns);
      BA.__data__ = g, BA.textContent = IA, CA && (BA.setAttribute("x", 0), BA.setAttribute("dy", gA)), t.appendChild(BA);
    }), values$5.text = k)) : (H = textValue(g, d), H !== values$5.text && (t.textContent = H, values$5.text = H)), setAttribute(t, "font-family", fontFamily(g)), setAttribute(t, "font-size", fontSize(g) + "px"), setAttribute(t, "font-style", g.fontStyle), setAttribute(t, "font-variant", g.fontVariant), setAttribute(t, "font-weight", g.fontWeight);
  }
};
function emit(n, t, g) {
  t !== values$5[n] && (g ? setAttributeNS(element$1, n, t, g) : setAttribute(element$1, n, t), values$5[n] = t);
}
function setStyle(n, t, g) {
  g !== values$5[t] && (g == null ? n.style.removeProperty(t) : n.style.setProperty(t, g + ""), values$5[t] = g);
}
function setAttributes(n, t) {
  for (const g in t)
    setAttribute(n, g, t[g]);
}
function setAttribute(n, t, g) {
  g != null ? n.setAttribute(t, g) : n.removeAttribute(t);
}
function setAttributeNS(n, t, g, d) {
  g != null ? n.setAttributeNS(d, t, g) : n.removeAttributeNS(d, t);
}
function href() {
  let n;
  return typeof window > "u" ? "" : (n = window.location).hash ? n.href.slice(0, -n.hash.length) : n.href;
}
class SVGStringRenderer extends Renderer {
  constructor(t) {
    super(t), this._text = null, this._defs = {
      gradient: {},
      clipping: {}
    };
  }
  /**
   * Returns the rendered SVG text string,
   * or null if rendering has not yet occurred.
   */
  svg() {
    return this._text;
  }
  /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   */
  _render(t) {
    const g = markup();
    g.open("svg", extend$2({}, metadata, {
      class: "marks",
      width: this._width * this._scale,
      height: this._height * this._scale,
      viewBox: `0 0 ${this._width} ${this._height}`
    }));
    const d = this._bgcolor;
    return d && d !== "transparent" && d !== "none" && g.open("rect", {
      width: this._width,
      height: this._height,
      fill: d
    }).close(), g.open("g", rootAttributes, {
      transform: "translate(" + this._origin + ")"
    }), this.mark(g, t), g.close(), this.defs(g), this._text = g.close() + "", this;
  }
  /**
   * Render a set of mark items.
   * @param {object} m - The markup context.
   * @param {object} scene - The mark parent to render.
   */
  mark(t, g) {
    const d = Marks[g.marktype], k = d.tag, H = [ariaItemAttributes, d.attr];
    t.open("g", {
      class: cssClass(g),
      "clip-path": g.clip ? clip$1$1(this, g, g.group) : null
    }, ariaMarkAttributes(g), {
      "pointer-events": k !== "g" && g.interactive === !1 ? "none" : null
    });
    const AA = (gA) => {
      const IA = this.href(gA);
      if (IA && t.open("a", IA), t.open(k, this.attr(g, gA, H, k !== "g" ? k : null)), k === "text") {
        const CA = textLines(gA);
        if (isArray$3(CA)) {
          const BA = {
            x: 0,
            dy: lineHeight(gA)
          };
          for (let eA = 0; eA < CA.length; ++eA)
            t.open("tspan", eA ? BA : null).text(textValue(gA, CA[eA])).close();
        } else
          t.text(textValue(gA, CA));
      } else if (k === "g") {
        const CA = gA.strokeForeground, BA = gA.fill, eA = gA.stroke;
        CA && eA && (gA.stroke = null), t.open("path", this.attr(g, gA, d.background, "bgrect")).close(), t.open("g", this.attr(g, gA, d.content)), visit(gA, (iA) => this.mark(t, iA)), t.close(), CA && eA ? (BA && (gA.fill = null), gA.stroke = eA, t.open("path", this.attr(g, gA, d.foreground, "bgrect")).close(), BA && (gA.fill = BA)) : t.open("path", this.attr(g, gA, d.foreground, "bgfore")).close();
      }
      t.close(), IA && t.close();
    };
    return d.nested ? g.items && g.items.length && AA(g.items[0]) : visit(g, AA), t.close();
  }
  /**
   * Get href attributes for a hyperlinked mark item.
   * @param {Item} item - The mark item.
   */
  href(t) {
    const g = t.href;
    let d;
    if (g) {
      if (d = this._hrefs && this._hrefs[g])
        return d;
      this.sanitizeURL(g).then((k) => {
        k["xlink:href"] = k.href, k.href = null, (this._hrefs || (this._hrefs = {}))[g] = k;
      });
    }
    return null;
  }
  /**
   * Get an object of SVG attributes for a mark item.
   * @param {object} scene - The mark parent.
   * @param {Item} item - The mark item.
   * @param {array|function} attrs - One or more attribute emitters.
   * @param {string} tag - The tag being rendered.
   */
  attr(t, g, d, k) {
    const H = {}, AA = (gA, IA, CA, BA) => {
      H[BA || gA] = IA;
    };
    return Array.isArray(d) ? d.forEach((gA) => gA(AA, g, this)) : d(AA, g, this), k && style(H, g, t, k, this._defs), H;
  }
  /**
   * Render SVG defs, as needed.
   * Must be called *after* marks have been processed to ensure the
   * collected state is current and accurate.
   * @param {object} m - The markup context.
   */
  defs(t) {
    const g = this._defs.gradient, d = this._defs.clipping;
    if (Object.keys(g).length + Object.keys(d).length !== 0) {
      t.open("defs");
      for (const H in g) {
        const AA = g[H], gA = AA.stops;
        AA.gradient === "radial" ? (t.open("pattern", {
          id: patternPrefix + H,
          viewBox: "0,0,1,1",
          width: "100%",
          height: "100%",
          preserveAspectRatio: "xMidYMid slice"
        }), t.open("rect", {
          width: "1",
          height: "1",
          fill: "url(#" + H + ")"
        }).close(), t.close(), t.open("radialGradient", {
          id: H,
          fx: AA.x1,
          fy: AA.y1,
          fr: AA.r1,
          cx: AA.x2,
          cy: AA.y2,
          r: AA.r2
        })) : t.open("linearGradient", {
          id: H,
          x1: AA.x1,
          x2: AA.x2,
          y1: AA.y1,
          y2: AA.y2
        });
        for (let IA = 0; IA < gA.length; ++IA)
          t.open("stop", {
            offset: gA[IA].offset,
            "stop-color": gA[IA].color
          }).close();
        t.close();
      }
      for (const H in d) {
        const AA = d[H];
        t.open("clipPath", {
          id: H
        }), AA.path ? t.open("path", {
          d: AA.path
        }).close() : t.open("rect", {
          x: 0,
          y: 0,
          width: AA.width,
          height: AA.height
        }).close(), t.close();
      }
      t.close();
    }
  }
}
function style(n, t, g, d, k) {
  let H;
  if (t == null || (d === "bgrect" && g.interactive === !1 && (n["pointer-events"] = "none"), d === "bgfore" && (g.interactive === !1 && (n["pointer-events"] = "none"), n.display = "none", t.fill !== null)))
    return n;
  d === "image" && t.smooth === !1 && (H = ["image-rendering: optimizeSpeed;", "image-rendering: pixelated;"]), d === "text" && (n["font-family"] = fontFamily(t), n["font-size"] = fontSize(t) + "px", n["font-style"] = t.fontStyle, n["font-variant"] = t.fontVariant, n["font-weight"] = t.fontWeight);
  for (const AA in stylesAttr) {
    let gA = t[AA];
    const IA = stylesAttr[AA];
    gA === "transparent" && (IA === "fill" || IA === "stroke") || gA != null && (isGradient(gA) && (gA = gradientRef(gA, k.gradient, "")), n[IA] = gA);
  }
  for (const AA in stylesCss) {
    const gA = t[AA];
    gA != null && (H = H || [], H.push(`${stylesCss[AA]}: ${gA};`));
  }
  return H && (n.style = H.join(" ")), n;
}
const OPTS = {
  svgMarkTypes: ["text"],
  svgOnTop: !0,
  debug: !1
};
function setHybridRendererOptions(n) {
  OPTS.svgMarkTypes = n.svgMarkTypes ?? ["text"], OPTS.svgOnTop = n.svgOnTop ?? !0, OPTS.debug = n.debug ?? !1;
}
class HybridRenderer extends Renderer {
  constructor(t) {
    super(t), this._svgRenderer = new SVGRenderer(t), this._canvasRenderer = new CanvasRenderer(t);
  }
  /**
   * Initialize a new HybridRenderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {HybridRenderer} - This renderer instance.
   */
  initialize(t, g, d, k, H) {
    this._root_el = domChild(t, 0, "div");
    const AA = domChild(this._root_el, 0, "div"), gA = domChild(this._root_el, 1, "div");
    return this._root_el.style.position = "relative", OPTS.debug || (AA.style.height = "100%", gA.style.position = "absolute", gA.style.top = "0", gA.style.left = "0", gA.style.height = "100%", gA.style.width = "100%"), this._svgEl = OPTS.svgOnTop ? gA : AA, this._canvasEl = OPTS.svgOnTop ? AA : gA, this._svgEl.style.pointerEvents = "none", this._canvasRenderer.initialize(this._canvasEl, g, d, k, H), this._svgRenderer.initialize(this._svgEl, g, d, k, H), super.initialize(t, g, d, k, H);
  }
  /**
   * Flag a mark item as dirty.
   * @param {Item} item - The mark item.
   */
  dirty(t) {
    return OPTS.svgMarkTypes.includes(t.mark.marktype) ? this._svgRenderer.dirty(t) : this._canvasRenderer.dirty(t), this;
  }
  /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */
  _render(t, g) {
    const k = (g ?? ["arc", "area", "image", "line", "path", "rect", "rule", "shape", "symbol", "text", "trail"]).filter((H) => !OPTS.svgMarkTypes.includes(H));
    this._svgRenderer.render(t, OPTS.svgMarkTypes), this._canvasRenderer.render(t, k);
  }
  /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance;
   */
  resize(t, g, d, k) {
    return super.resize(t, g, d, k), this._svgRenderer.resize(t, g, d, k), this._canvasRenderer.resize(t, g, d, k), this;
  }
  background(t) {
    return OPTS.svgOnTop ? this._canvasRenderer.background(t) : this._svgRenderer.background(t), this;
  }
}
class HybridHandler extends CanvasHandler {
  constructor(t, g) {
    super(t, g);
  }
  initialize(t, g, d) {
    const k = domChild(domChild(t, 0, "div"), OPTS.svgOnTop ? 0 : 1, "div");
    return super.initialize(k, g, d);
  }
}
const Canvas = "canvas", Hybrid = "hybrid", PNG = "png", SVG = "svg", None$2 = "none", RenderType = {
  Canvas,
  PNG,
  SVG,
  Hybrid,
  None: None$2
}, modules = {};
modules[Canvas] = modules[PNG] = {
  renderer: CanvasRenderer,
  headless: CanvasRenderer,
  handler: CanvasHandler
};
modules[SVG] = {
  renderer: SVGRenderer,
  headless: SVGStringRenderer,
  handler: SVGHandler
};
modules[Hybrid] = {
  renderer: HybridRenderer,
  headless: HybridRenderer,
  handler: HybridHandler
};
modules[None$2] = {};
function renderModule(n, t) {
  return n = String(n || "").toLowerCase(), arguments.length > 1 ? (modules[n] = t, this) : modules[n];
}
function intersect$2(n, t, g) {
  const d = [], k = new Bounds().union(t), H = n.marktype;
  return H ? intersectMark(n, k, g, d) : H === "group" ? intersectGroup(n, k, g, d) : error$3("Intersect scene must be mark node or group item.");
}
function intersectMark(n, t, g, d) {
  if (visitMark(n, t, g)) {
    const k = n.items, H = n.marktype, AA = k.length;
    let gA = 0;
    if (H === "group")
      for (; gA < AA; ++gA)
        intersectGroup(k[gA], t, g, d);
    else
      for (const IA = Marks[H].isect; gA < AA; ++gA) {
        const CA = k[gA];
        intersectItem(CA, t, IA) && d.push(CA);
      }
  }
  return d;
}
function visitMark(n, t, g) {
  return n.bounds && t.intersects(n.bounds) && (n.marktype === "group" || n.interactive !== !1 && (!g || g(n)));
}
function intersectGroup(n, t, g, d) {
  g && g(n.mark) && intersectItem(n, t, Marks.group.isect) && d.push(n);
  const k = n.items, H = k && k.length;
  if (H) {
    const AA = n.x || 0, gA = n.y || 0;
    t.translate(-AA, -gA);
    for (let IA = 0; IA < H; ++IA)
      intersectMark(k[IA], t, g, d);
    t.translate(AA, gA);
  }
  return d;
}
function intersectItem(n, t, g) {
  const d = n.bounds;
  return t.encloses(d) || t.intersects(d) && g(n, t);
}
const clipBounds = new Bounds();
function boundClip(n) {
  const t = n.clip;
  if (isFunction$5(t))
    t(boundContext(clipBounds.clear()));
  else if (t)
    clipBounds.set(0, 0, n.group.width, n.group.height);
  else return;
  n.bounds.intersect(clipBounds);
}
const TOLERANCE = 1e-9;
function sceneEqual(n, t, g) {
  return n === t ? !0 : g === "path" ? pathEqual(n, t) : n instanceof Date && t instanceof Date ? +n == +t : isNumber$3(n) && isNumber$3(t) ? Math.abs(n - t) <= TOLERANCE : !n || !t || !isObject$4(n) && !isObject$4(t) ? n == t : objectEqual(n, t);
}
function pathEqual(n, t) {
  return sceneEqual(parse$3(n), parse$3(t));
}
function objectEqual(n, t) {
  var g = Object.keys(n), d = Object.keys(t), k, H;
  if (g.length !== d.length) return !1;
  for (g.sort(), d.sort(), H = g.length - 1; H >= 0; H--)
    if (g[H] != d[H]) return !1;
  for (H = g.length - 1; H >= 0; H--)
    if (k = g[H], !sceneEqual(n[k], t[k], k)) return !1;
  return typeof n == typeof t;
}
function resetSVGDefIds() {
  resetSVGClipId(), resetSVGGradientId();
}
const Top$1 = "top", Left$1 = "left", Right$1 = "right", Bottom$1 = "bottom", TopLeft = "top-left", TopRight = "top-right", BottomLeft = "bottom-left", BottomRight = "bottom-right", Start$1 = "start", Middle$1 = "middle", End$1 = "end", X$2 = "x", Y$1 = "y", Group = "group", AxisRole$1 = "axis", TitleRole$1 = "title", FrameRole$1 = "frame", ScopeRole$1 = "scope", LegendRole$1 = "legend", RowHeader = "row-header", RowFooter = "row-footer", RowTitle = "row-title", ColHeader = "column-header", ColFooter = "column-footer", ColTitle = "column-title", Padding$1 = "padding", Symbols$1 = "symbol", Fit = "fit", FitX = "fit-x", FitY = "fit-y", Pad = "pad", None$1 = "none", All = "all", Each = "each", Flush = "flush", Column = "column", Row = "row";
function Bound$1(n) {
  Transform.call(this, null, n);
}
inherits$1(Bound$1, Transform, {
  transform(n, t) {
    const g = t.dataflow, d = n.mark, k = d.marktype, H = Marks[k], AA = H.bound;
    let gA = d.bounds, IA;
    if (H.nested)
      d.items.length && g.dirty(d.items[0]), gA = boundItem(d, AA), d.items.forEach((CA) => {
        CA.bounds.clear().union(gA);
      });
    else if (k === Group || n.modified())
      switch (t.visit(t.MOD, (CA) => g.dirty(CA)), gA.clear(), d.items.forEach((CA) => gA.union(boundItem(CA, AA))), d.role) {
        case AxisRole$1:
        case LegendRole$1:
        case TitleRole$1:
          t.reflow();
      }
    else
      IA = t.changed(t.REM), t.visit(t.ADD, (CA) => {
        gA.union(boundItem(CA, AA));
      }), t.visit(t.MOD, (CA) => {
        IA = IA || gA.alignsWith(CA.bounds), g.dirty(CA), gA.union(boundItem(CA, AA));
      }), IA && (gA.clear(), d.items.forEach((CA) => gA.union(CA.bounds)));
    return boundClip(d), t.modifies("bounds");
  }
});
function boundItem(n, t, g) {
  return t(n.bounds.clear(), n, g);
}
const COUNTER_NAME = ":vega_identifier:";
function Identifier$2(n) {
  Transform.call(this, 0, n);
}
Identifier$2.Definition = {
  type: "Identifier",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "as",
    type: "string",
    required: !0
  }]
};
inherits$1(Identifier$2, Transform, {
  transform(n, t) {
    const g = getCounter(t.dataflow), d = n.as;
    let k = g.value;
    return t.visit(t.ADD, (H) => H[d] = H[d] || ++k), g.set(this.value = k), t;
  }
});
function getCounter(n) {
  return n._signals[COUNTER_NAME] || (n._signals[COUNTER_NAME] = n.add(0));
}
function Mark$2(n) {
  Transform.call(this, null, n);
}
inherits$1(Mark$2, Transform, {
  transform(n, t) {
    let g = this.value;
    g || (g = t.dataflow.scenegraph().mark(n.markdef, lookup$1$1(n), n.index), g.group.context = n.context, n.context.group || (n.context.group = g.group), g.source = this.source, g.clip = n.clip, g.interactive = n.interactive, this.value = g);
    const d = g.marktype === Group ? GroupItem : Item$1;
    return t.visit(t.ADD, (k) => d.call(k, g)), (n.modified("clip") || n.modified("interactive")) && (g.clip = n.clip, g.interactive = !!n.interactive, g.zdirty = !0, t.reflow()), g.items = t.source, t;
  }
});
function lookup$1$1(n) {
  const t = n.groups, g = n.parent;
  return t && t.size === 1 ? t.get(Object.keys(t.object)[0]) : t && g ? t.lookup(g) : null;
}
function Overlap$1(n) {
  Transform.call(this, null, n);
}
const methods = {
  parity: (n) => n.filter((t, g) => g % 2 ? t.opacity = 0 : 1),
  greedy: (n, t) => {
    let g;
    return n.filter((d, k) => !k || !intersect$1(g.bounds, d.bounds, t) ? (g = d, 1) : d.opacity = 0);
  }
}, intersect$1 = (n, t, g) => g > Math.max(t.x1 - n.x2, n.x1 - t.x2, t.y1 - n.y2, n.y1 - t.y2), hasOverlap = (n, t) => {
  for (var g = 1, d = n.length, k = n[0].bounds, H; g < d; k = H, ++g)
    if (intersect$1(k, H = n[g].bounds, t)) return !0;
}, hasBounds = (n) => {
  const t = n.bounds;
  return t.width() > 1 && t.height() > 1;
}, boundTest = (n, t, g) => {
  var d = n.range(), k = new Bounds();
  return t === Top$1 || t === Bottom$1 ? k.set(d[0], -1 / 0, d[1], 1 / 0) : k.set(-1 / 0, d[0], 1 / 0, d[1]), k.expand(g || 1), (H) => k.encloses(H.bounds);
}, reset$1 = (n) => (n.forEach((t) => t.opacity = 1), n), reflow = (n, t) => n.reflow(t.modified()).modifies("opacity");
inherits$1(Overlap$1, Transform, {
  transform(n, t) {
    const g = methods[n.method] || methods.parity, d = n.separation || 0;
    let k = t.materialize(t.SOURCE).source, H, AA;
    if (!k || !k.length) return;
    if (!n.method)
      return n.modified("method") && (reset$1(k), t = reflow(t, n)), t;
    if (k = k.filter(hasBounds), !k.length) return;
    if (n.sort && (k = k.slice().sort(n.sort)), H = reset$1(k), t = reflow(t, n), H.length >= 3 && hasOverlap(H, d)) {
      do
        H = g(H, d);
      while (H.length >= 3 && hasOverlap(H, d));
      H.length < 3 && !peek$2(k).opacity && (H.length > 1 && (peek$2(H).opacity = 0), peek$2(k).opacity = 1);
    }
    n.boundScale && n.boundTolerance >= 0 && (AA = boundTest(n.boundScale, n.boundOrient, +n.boundTolerance), k.forEach((IA) => {
      AA(IA) || (IA.opacity = 0);
    }));
    const gA = H[0].mark.bounds.clear();
    return k.forEach((IA) => {
      IA.opacity && gA.union(IA.bounds);
    }), t;
  }
});
function Render$1(n) {
  Transform.call(this, null, n);
}
inherits$1(Render$1, Transform, {
  transform(n, t) {
    const g = t.dataflow;
    if (t.visit(t.ALL, (d) => g.dirty(d)), t.fields && t.fields.zindex) {
      const d = t.source && t.source[0];
      d && (d.mark.zdirty = !0);
    }
  }
});
const tempBounds = new Bounds();
function set$3(n, t, g) {
  return n[t] === g ? 0 : (n[t] = g, 1);
}
function isYAxis(n) {
  var t = n.items[0].orient;
  return t === Left$1 || t === Right$1;
}
function axisIndices(n) {
  let t = +n.grid;
  return [
    n.ticks ? t++ : -1,
    // ticks index
    n.labels ? t++ : -1,
    // labels index
    t + +n.domain
    // title index
  ];
}
function axisLayout(n, t, g, d) {
  var k = t.items[0], H = k.datum, AA = k.translate != null ? k.translate : 0.5, gA = k.orient, IA = axisIndices(H), CA = k.range, BA = k.offset, eA = k.position, iA = k.minExtent, QA = k.maxExtent, tA = H.title && k.items[IA[2]].items[0], oA = k.titlePadding, EA = k.bounds, aA = tA && multiLineOffset(tA), nA = 0, lA = 0, cA, sA;
  switch (tempBounds.clear().union(EA), EA.clear(), (cA = IA[0]) > -1 && EA.union(k.items[cA].bounds), (cA = IA[1]) > -1 && EA.union(k.items[cA].bounds), gA) {
    case Top$1:
      nA = eA || 0, lA = -BA, sA = Math.max(iA, Math.min(QA, -EA.y1)), EA.add(0, -sA).add(CA, 0), tA && axisTitleLayout(n, tA, sA, oA, aA, 0, -1, EA);
      break;
    case Left$1:
      nA = -BA, lA = eA || 0, sA = Math.max(iA, Math.min(QA, -EA.x1)), EA.add(-sA, 0).add(0, CA), tA && axisTitleLayout(n, tA, sA, oA, aA, 1, -1, EA);
      break;
    case Right$1:
      nA = g + BA, lA = eA || 0, sA = Math.max(iA, Math.min(QA, EA.x2)), EA.add(0, 0).add(sA, CA), tA && axisTitleLayout(n, tA, sA, oA, aA, 1, 1, EA);
      break;
    case Bottom$1:
      nA = eA || 0, lA = d + BA, sA = Math.max(iA, Math.min(QA, EA.y2)), EA.add(0, 0).add(CA, sA), tA && axisTitleLayout(n, tA, sA, oA, 0, 0, 1, EA);
      break;
    default:
      nA = k.x, lA = k.y;
  }
  return boundStroke(EA.translate(nA, lA), k), set$3(k, "x", nA + AA) | set$3(k, "y", lA + AA) && (k.bounds = tempBounds, n.dirty(k), k.bounds = EA, n.dirty(k)), k.mark.bounds.clear().union(EA);
}
function axisTitleLayout(n, t, g, d, k, H, AA, gA) {
  const IA = t.bounds;
  if (t.auto) {
    const CA = AA * (g + k + d);
    let BA = 0, eA = 0;
    n.dirty(t), H ? BA = (t.x || 0) - (t.x = CA) : eA = (t.y || 0) - (t.y = CA), t.mark.bounds.clear().union(IA.translate(-BA, -eA)), n.dirty(t);
  }
  gA.union(IA);
}
const min = (n, t) => Math.floor(Math.min(n, t)), max = (n, t) => Math.ceil(Math.max(n, t));
function gridLayoutGroups(n) {
  var t = n.items, g = t.length, d = 0, k, H;
  const AA = {
    marks: [],
    rowheaders: [],
    rowfooters: [],
    colheaders: [],
    colfooters: [],
    rowtitle: null,
    coltitle: null
  };
  for (; d < g; ++d)
    if (k = t[d], H = k.items, k.marktype === Group)
      switch (k.role) {
        case AxisRole$1:
        case LegendRole$1:
        case TitleRole$1:
          break;
        case RowHeader:
          AA.rowheaders.push(...H);
          break;
        case RowFooter:
          AA.rowfooters.push(...H);
          break;
        case ColHeader:
          AA.colheaders.push(...H);
          break;
        case ColFooter:
          AA.colfooters.push(...H);
          break;
        case RowTitle:
          AA.rowtitle = H[0];
          break;
        case ColTitle:
          AA.coltitle = H[0];
          break;
        default:
          AA.marks.push(...H);
      }
  return AA;
}
function bboxFlush(n) {
  return new Bounds().set(0, 0, n.width || 0, n.height || 0);
}
function bboxFull(n) {
  const t = n.bounds.clone();
  return t.empty() ? t.set(0, 0, 0, 0) : t.translate(-(n.x || 0), -(n.y || 0));
}
function get$3(n, t, g) {
  const d = isObject$4(n) ? n[t] : n;
  return d ?? (g !== void 0 ? g : 0);
}
function offsetValue$1(n) {
  return n < 0 ? Math.ceil(-n) : 0;
}
function gridLayout(n, t, g) {
  var d = !g.nodirty, k = g.bounds === Flush ? bboxFlush : bboxFull, H = tempBounds.set(0, 0, 0, 0), AA = get$3(g.align, Column), gA = get$3(g.align, Row), IA = get$3(g.padding, Column), CA = get$3(g.padding, Row), BA = g.columns || t.length, eA = BA <= 0 ? 1 : Math.ceil(t.length / BA), iA = t.length, QA = Array(iA), tA = Array(BA), oA = 0, EA = Array(iA), aA = Array(eA), nA = 0, lA = Array(iA), cA = Array(iA), sA = Array(iA), rA, uA, hA, dA, GA, DA, wA, bA, yA, pA, MA;
  for (uA = 0; uA < BA; ++uA) tA[uA] = 0;
  for (uA = 0; uA < eA; ++uA) aA[uA] = 0;
  for (uA = 0; uA < iA; ++uA)
    DA = t[uA], GA = sA[uA] = k(DA), DA.x = DA.x || 0, lA[uA] = 0, DA.y = DA.y || 0, cA[uA] = 0, hA = uA % BA, dA = ~~(uA / BA), oA = Math.max(oA, wA = Math.ceil(GA.x2)), nA = Math.max(nA, bA = Math.ceil(GA.y2)), tA[hA] = Math.max(tA[hA], wA), aA[dA] = Math.max(aA[dA], bA), QA[uA] = IA + offsetValue$1(GA.x1), EA[uA] = CA + offsetValue$1(GA.y1), d && n.dirty(t[uA]);
  for (uA = 0; uA < iA; ++uA)
    uA % BA === 0 && (QA[uA] = 0), uA < BA && (EA[uA] = 0);
  if (AA === Each)
    for (hA = 1; hA < BA; ++hA) {
      for (MA = 0, uA = hA; uA < iA; uA += BA)
        MA < QA[uA] && (MA = QA[uA]);
      for (uA = hA; uA < iA; uA += BA)
        QA[uA] = MA + tA[hA - 1];
    }
  else if (AA === All) {
    for (MA = 0, uA = 0; uA < iA; ++uA)
      uA % BA && MA < QA[uA] && (MA = QA[uA]);
    for (uA = 0; uA < iA; ++uA)
      uA % BA && (QA[uA] = MA + oA);
  } else
    for (AA = !1, hA = 1; hA < BA; ++hA)
      for (uA = hA; uA < iA; uA += BA)
        QA[uA] += tA[hA - 1];
  if (gA === Each)
    for (dA = 1; dA < eA; ++dA) {
      for (MA = 0, uA = dA * BA, rA = uA + BA; uA < rA; ++uA)
        MA < EA[uA] && (MA = EA[uA]);
      for (uA = dA * BA; uA < rA; ++uA)
        EA[uA] = MA + aA[dA - 1];
    }
  else if (gA === All) {
    for (MA = 0, uA = BA; uA < iA; ++uA)
      MA < EA[uA] && (MA = EA[uA]);
    for (uA = BA; uA < iA; ++uA)
      EA[uA] = MA + nA;
  } else
    for (gA = !1, dA = 1; dA < eA; ++dA)
      for (uA = dA * BA, rA = uA + BA; uA < rA; ++uA)
        EA[uA] += aA[dA - 1];
  for (yA = 0, uA = 0; uA < iA; ++uA)
    yA = QA[uA] + (uA % BA ? yA : 0), lA[uA] += yA - t[uA].x;
  for (hA = 0; hA < BA; ++hA)
    for (pA = 0, uA = hA; uA < iA; uA += BA)
      pA += EA[uA], cA[uA] += pA - t[uA].y;
  if (AA && get$3(g.center, Column) && eA > 1)
    for (uA = 0; uA < iA; ++uA)
      GA = AA === All ? oA : tA[uA % BA], yA = GA - sA[uA].x2 - t[uA].x - lA[uA], yA > 0 && (lA[uA] += yA / 2);
  if (gA && get$3(g.center, Row) && BA !== 1)
    for (uA = 0; uA < iA; ++uA)
      GA = gA === All ? nA : aA[~~(uA / BA)], pA = GA - sA[uA].y2 - t[uA].y - cA[uA], pA > 0 && (cA[uA] += pA / 2);
  for (uA = 0; uA < iA; ++uA)
    H.union(sA[uA].translate(lA[uA], cA[uA]));
  switch (yA = get$3(g.anchor, X$2), pA = get$3(g.anchor, Y$1), get$3(g.anchor, Column)) {
    case End$1:
      yA -= H.width();
      break;
    case Middle$1:
      yA -= H.width() / 2;
  }
  switch (get$3(g.anchor, Row)) {
    case End$1:
      pA -= H.height();
      break;
    case Middle$1:
      pA -= H.height() / 2;
  }
  for (yA = Math.round(yA), pA = Math.round(pA), H.clear(), uA = 0; uA < iA; ++uA)
    t[uA].mark.bounds.clear();
  for (uA = 0; uA < iA; ++uA)
    DA = t[uA], DA.x += lA[uA] += yA, DA.y += cA[uA] += pA, H.union(DA.mark.bounds.union(DA.bounds.translate(lA[uA], cA[uA]))), d && n.dirty(DA);
  return H;
}
function trellisLayout(n, t, g) {
  var d = gridLayoutGroups(t), k = d.marks, H = g.bounds === Flush ? boundFlush : boundFull, AA = g.offset, gA = g.columns || k.length, IA = gA <= 0 ? 1 : Math.ceil(k.length / gA), CA = IA * gA, BA, eA, iA, QA, tA, oA, EA;
  const aA = gridLayout(n, k, g);
  aA.empty() && aA.set(0, 0, 0, 0), d.rowheaders && (oA = get$3(g.headerBand, Row, null), BA = layoutHeaders(n, d.rowheaders, k, gA, IA, -get$3(AA, "rowHeader"), min, 0, H, "x1", 0, gA, 1, oA)), d.colheaders && (oA = get$3(g.headerBand, Column, null), eA = layoutHeaders(n, d.colheaders, k, gA, gA, -get$3(AA, "columnHeader"), min, 1, H, "y1", 0, 1, gA, oA)), d.rowfooters && (oA = get$3(g.footerBand, Row, null), iA = layoutHeaders(n, d.rowfooters, k, gA, IA, get$3(AA, "rowFooter"), max, 0, H, "x2", gA - 1, gA, 1, oA)), d.colfooters && (oA = get$3(g.footerBand, Column, null), QA = layoutHeaders(n, d.colfooters, k, gA, gA, get$3(AA, "columnFooter"), max, 1, H, "y2", CA - gA, 1, gA, oA)), d.rowtitle && (tA = get$3(g.titleAnchor, Row), EA = get$3(AA, "rowTitle"), EA = tA === End$1 ? iA + EA : BA - EA, oA = get$3(g.titleBand, Row, 0.5), layoutTitle(n, d.rowtitle, EA, 0, aA, oA)), d.coltitle && (tA = get$3(g.titleAnchor, Column), EA = get$3(AA, "columnTitle"), EA = tA === End$1 ? QA + EA : eA - EA, oA = get$3(g.titleBand, Column, 0.5), layoutTitle(n, d.coltitle, EA, 1, aA, oA));
}
function boundFlush(n, t) {
  return t === "x1" ? n.x || 0 : t === "y1" ? n.y || 0 : t === "x2" ? (n.x || 0) + (n.width || 0) : t === "y2" ? (n.y || 0) + (n.height || 0) : void 0;
}
function boundFull(n, t) {
  return n.bounds[t];
}
function layoutHeaders(n, t, g, d, k, H, AA, gA, IA, CA, BA, eA, iA, QA) {
  var tA = g.length, oA = 0, EA = 0, aA, nA, lA, cA, sA, rA, uA, hA, dA;
  if (!tA) return oA;
  for (aA = BA; aA < tA; aA += eA)
    g[aA] && (oA = AA(oA, IA(g[aA], CA)));
  if (!t.length) return oA;
  for (t.length > k && (n.warn("Grid headers exceed limit: " + k), t = t.slice(0, k)), oA += H, nA = 0, cA = t.length; nA < cA; ++nA)
    n.dirty(t[nA]), t[nA].mark.bounds.clear();
  for (aA = BA, nA = 0, cA = t.length; nA < cA; ++nA, aA += eA) {
    for (rA = t[nA], sA = rA.mark.bounds, lA = aA; lA >= 0 && (uA = g[lA]) == null; lA -= iA) ;
    gA ? (hA = QA == null ? uA.x : Math.round(uA.bounds.x1 + QA * uA.bounds.width()), dA = oA) : (hA = oA, dA = QA == null ? uA.y : Math.round(uA.bounds.y1 + QA * uA.bounds.height())), sA.union(rA.bounds.translate(hA - (rA.x || 0), dA - (rA.y || 0))), rA.x = hA, rA.y = dA, n.dirty(rA), EA = AA(EA, sA[CA]);
  }
  return EA;
}
function layoutTitle(n, t, g, d, k, H) {
  if (t) {
    n.dirty(t);
    var AA = g, gA = g;
    d ? AA = Math.round(k.x1 + H * k.width()) : gA = Math.round(k.y1 + H * k.height()), t.bounds.translate(AA - (t.x || 0), gA - (t.y || 0)), t.mark.bounds.clear().union(t.bounds), t.x = AA, t.y = gA, n.dirty(t);
  }
}
function lookup$3(n, t) {
  const g = n[t] || {};
  return (d, k) => g[d] != null ? g[d] : n[d] != null ? n[d] : k;
}
function offsets(n, t) {
  let g = -1 / 0;
  return n.forEach((d) => {
    d.offset != null && (g = Math.max(g, d.offset));
  }), g > -1 / 0 ? g : t;
}
function legendParams(n, t, g, d, k, H, AA) {
  const gA = lookup$3(g, t), IA = offsets(n, gA("offset", 0)), CA = gA("anchor", Start$1), BA = CA === End$1 ? 1 : CA === Middle$1 ? 0.5 : 0, eA = {
    align: Each,
    bounds: gA("bounds", Flush),
    columns: gA("direction") === "vertical" ? 1 : n.length,
    padding: gA("margin", 8),
    center: gA("center"),
    nodirty: !0
  };
  switch (t) {
    case Left$1:
      eA.anchor = {
        x: Math.floor(d.x1) - IA,
        column: End$1,
        y: BA * (AA || d.height() + 2 * d.y1),
        row: CA
      };
      break;
    case Right$1:
      eA.anchor = {
        x: Math.ceil(d.x2) + IA,
        y: BA * (AA || d.height() + 2 * d.y1),
        row: CA
      };
      break;
    case Top$1:
      eA.anchor = {
        y: Math.floor(k.y1) - IA,
        row: End$1,
        x: BA * (H || k.width() + 2 * k.x1),
        column: CA
      };
      break;
    case Bottom$1:
      eA.anchor = {
        y: Math.ceil(k.y2) + IA,
        x: BA * (H || k.width() + 2 * k.x1),
        column: CA
      };
      break;
    case TopLeft:
      eA.anchor = {
        x: IA,
        y: IA
      };
      break;
    case TopRight:
      eA.anchor = {
        x: H - IA,
        y: IA,
        column: End$1
      };
      break;
    case BottomLeft:
      eA.anchor = {
        x: IA,
        y: AA - IA,
        row: End$1
      };
      break;
    case BottomRight:
      eA.anchor = {
        x: H - IA,
        y: AA - IA,
        column: End$1,
        row: End$1
      };
      break;
  }
  return eA;
}
function legendLayout(n, t) {
  var g = t.items[0], d = g.datum, k = g.orient, H = g.bounds, AA = g.x, gA = g.y, IA, CA;
  return g._bounds ? g._bounds.clear().union(H) : g._bounds = H.clone(), H.clear(), legendGroupLayout(n, g, g.items[0].items[0]), H = legendBounds(g, H), IA = 2 * g.padding, CA = 2 * g.padding, H.empty() || (IA = Math.ceil(H.width() + IA), CA = Math.ceil(H.height() + CA)), d.type === Symbols$1 && legendEntryLayout(g.items[0].items[0].items[0].items), k !== None$1 && (g.x = AA = 0, g.y = gA = 0), g.width = IA, g.height = CA, boundStroke(H.set(AA, gA, AA + IA, gA + CA), g), g.mark.bounds.clear().union(H), g;
}
function legendBounds(n, t) {
  return n.items.forEach((g) => t.union(g.bounds)), t.x1 = n.padding, t.y1 = n.padding, t;
}
function legendGroupLayout(n, t, g) {
  var d = t.padding, k = d - g.x, H = d - g.y;
  if (!t.datum.title)
    (k || H) && translate$1(n, g, k, H);
  else {
    var AA = t.items[1].items[0], gA = AA.anchor, IA = t.titlePadding || 0, CA = d - AA.x, BA = d - AA.y;
    switch (AA.orient) {
      case Left$1:
        k += Math.ceil(AA.bounds.width()) + IA;
        break;
      case Right$1:
      case Bottom$1:
        break;
      default:
        H += AA.bounds.height() + IA;
    }
    switch ((k || H) && translate$1(n, g, k, H), AA.orient) {
      case Left$1:
        BA += legendTitleOffset(t, g, AA, gA, 1, 1);
        break;
      case Right$1:
        CA += legendTitleOffset(t, g, AA, End$1, 0, 0) + IA, BA += legendTitleOffset(t, g, AA, gA, 1, 1);
        break;
      case Bottom$1:
        CA += legendTitleOffset(t, g, AA, gA, 0, 0), BA += legendTitleOffset(t, g, AA, End$1, -1, 0, 1) + IA;
        break;
      default:
        CA += legendTitleOffset(t, g, AA, gA, 0, 0);
    }
    (CA || BA) && translate$1(n, AA, CA, BA), (CA = Math.round(AA.bounds.x1 - d)) < 0 && (translate$1(n, g, -CA, 0), translate$1(n, AA, -CA, 0));
  }
}
function legendTitleOffset(n, t, g, d, k, H, AA) {
  const gA = n.datum.type !== "symbol", IA = g.datum.vgrad, CA = gA && (H || !IA) && !AA ? t.items[0] : t, BA = CA.bounds[k ? "y2" : "x2"] - n.padding, eA = IA && H ? BA : 0, iA = IA && H ? 0 : BA, QA = k <= 0 ? 0 : multiLineOffset(g);
  return Math.round(d === Start$1 ? eA : d === End$1 ? iA - QA : 0.5 * (BA - QA));
}
function translate$1(n, t, g, d) {
  t.x += g, t.y += d, t.bounds.translate(g, d), t.mark.bounds.translate(g, d), n.dirty(t);
}
function legendEntryLayout(n) {
  const t = n.reduce((g, d) => (g[d.column] = Math.max(d.bounds.x2 - d.x, g[d.column] || 0), g), {});
  n.forEach((g) => {
    g.width = t[g.column], g.height = g.bounds.y2 - g.y;
  });
}
function titleLayout(n, t, g, d, k) {
  var H = t.items[0], AA = H.frame, gA = H.orient, IA = H.anchor, CA = H.offset, BA = H.padding, eA = H.items[0].items[0], iA = H.items[1] && H.items[1].items[0], QA = gA === Left$1 || gA === Right$1 ? d : g, tA = 0, oA = 0, EA = 0, aA = 0, nA = 0, lA;
  if (AA !== Group ? gA === Left$1 ? (tA = k.y2, QA = k.y1) : gA === Right$1 ? (tA = k.y1, QA = k.y2) : (tA = k.x1, QA = k.x2) : gA === Left$1 && (tA = d, QA = 0), lA = IA === Start$1 ? tA : IA === End$1 ? QA : (tA + QA) / 2, iA && iA.text) {
    switch (gA) {
      case Top$1:
      case Bottom$1:
        nA = eA.bounds.height() + BA;
        break;
      case Left$1:
        aA = eA.bounds.width() + BA;
        break;
      case Right$1:
        aA = -eA.bounds.width() - BA;
        break;
    }
    tempBounds.clear().union(iA.bounds), tempBounds.translate(aA - (iA.x || 0), nA - (iA.y || 0)), set$3(iA, "x", aA) | set$3(iA, "y", nA) && (n.dirty(iA), iA.bounds.clear().union(tempBounds), iA.mark.bounds.clear().union(tempBounds), n.dirty(iA)), tempBounds.clear().union(iA.bounds);
  } else
    tempBounds.clear();
  switch (tempBounds.union(eA.bounds), gA) {
    case Top$1:
      oA = lA, EA = k.y1 - tempBounds.height() - CA;
      break;
    case Left$1:
      oA = k.x1 - tempBounds.width() - CA, EA = lA;
      break;
    case Right$1:
      oA = k.x2 + tempBounds.width() + CA, EA = lA;
      break;
    case Bottom$1:
      oA = lA, EA = k.y2 + CA;
      break;
    default:
      oA = H.x, EA = H.y;
  }
  return set$3(H, "x", oA) | set$3(H, "y", EA) && (tempBounds.translate(oA, EA), n.dirty(H), H.bounds.clear().union(tempBounds), t.bounds.clear().union(tempBounds), n.dirty(H)), H.bounds;
}
function ViewLayout$1(n) {
  Transform.call(this, null, n);
}
inherits$1(ViewLayout$1, Transform, {
  transform(n, t) {
    const g = t.dataflow;
    return n.mark.items.forEach((d) => {
      n.layout && trellisLayout(g, d, n.layout), layoutGroup(g, d, n);
    }), shouldReflow(n.mark.group) ? t.reflow() : t;
  }
});
function shouldReflow(n) {
  return n && n.mark.role !== "legend-entry";
}
function layoutGroup(n, t, g) {
  var d = t.items, k = Math.max(0, t.width || 0), H = Math.max(0, t.height || 0), AA = new Bounds().set(0, 0, k, H), gA = AA.clone(), IA = AA.clone(), CA = [], BA, eA, iA, QA, tA, oA;
  for (tA = 0, oA = d.length; tA < oA; ++tA)
    switch (eA = d[tA], eA.role) {
      case AxisRole$1:
        QA = isYAxis(eA) ? gA : IA, QA.union(axisLayout(n, eA, k, H));
        break;
      case TitleRole$1:
        BA = eA;
        break;
      case LegendRole$1:
        CA.push(legendLayout(n, eA));
        break;
      case FrameRole$1:
      case ScopeRole$1:
      case RowHeader:
      case RowFooter:
      case RowTitle:
      case ColHeader:
      case ColFooter:
      case ColTitle:
        gA.union(eA.bounds), IA.union(eA.bounds);
        break;
      default:
        AA.union(eA.bounds);
    }
  if (CA.length) {
    const EA = {};
    CA.forEach((aA) => {
      iA = aA.orient || Right$1, iA !== None$1 && (EA[iA] || (EA[iA] = [])).push(aA);
    });
    for (const aA in EA) {
      const nA = EA[aA];
      gridLayout(n, nA, legendParams(nA, aA, g.legends, gA, IA, k, H));
    }
    CA.forEach((aA) => {
      const nA = aA.bounds;
      if (nA.equals(aA._bounds) || (aA.bounds = aA._bounds, n.dirty(aA), aA.bounds = nA, n.dirty(aA)), g.autosize && (g.autosize.type === Fit || g.autosize.type === FitX || g.autosize.type === FitY))
        switch (aA.orient) {
          case Left$1:
          case Right$1:
            AA.add(nA.x1, 0).add(nA.x2, 0);
            break;
          case Top$1:
          case Bottom$1:
            AA.add(0, nA.y1).add(0, nA.y2);
        }
      else
        AA.union(nA);
    });
  }
  AA.union(gA).union(IA), BA && AA.union(titleLayout(n, BA, k, H, AA)), t.clip && AA.set(0, 0, t.width || 0, t.height || 0), viewSizeLayout(n, t, AA, g);
}
function viewSizeLayout(n, t, g, d) {
  const k = d.autosize || {}, H = k.type;
  if (n._autosize < 1 || !H) return;
  let AA = n._width, gA = n._height, IA = Math.max(0, t.width || 0), CA = Math.max(0, Math.ceil(-g.x1)), BA = Math.max(0, t.height || 0), eA = Math.max(0, Math.ceil(-g.y1));
  const iA = Math.max(0, Math.ceil(g.x2 - IA)), QA = Math.max(0, Math.ceil(g.y2 - BA));
  if (k.contains === Padding$1) {
    const tA = n.padding();
    AA -= tA.left + tA.right, gA -= tA.top + tA.bottom;
  }
  H === None$1 ? (CA = 0, eA = 0, IA = AA, BA = gA) : H === Fit ? (IA = Math.max(0, AA - CA - iA), BA = Math.max(0, gA - eA - QA)) : H === FitX ? (IA = Math.max(0, AA - CA - iA), gA = BA + eA + QA) : H === FitY ? (AA = IA + CA + iA, BA = Math.max(0, gA - eA - QA)) : H === Pad && (AA = IA + CA + iA, gA = BA + eA + QA), n._resizeView(AA, gA, IA, BA, [CA, eA], k.resize);
}
const vtx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bound: Bound$1,
  identifier: Identifier$2,
  mark: Mark$2,
  overlap: Overlap$1,
  render: Render$1,
  viewlayout: ViewLayout$1
}, Symbol.toStringTag, { value: "Module" }));
function AxisTicks$1(n) {
  Transform.call(this, null, n);
}
inherits$1(AxisTicks$1, Transform, {
  transform(n, t) {
    if (this.value && !n.modified())
      return t.StopPropagation;
    var g = t.dataflow.locale(), d = t.fork(t.NO_SOURCE | t.NO_FIELDS), k = this.value, H = n.scale, AA = n.count == null ? n.values ? n.values.length : 10 : n.count, gA = tickCount(H, AA, n.minstep), IA = n.format || tickFormat(g, H, gA, n.formatSpecifier, n.formatType, !!n.values), CA = n.values ? validTicks(H, n.values, gA) : tickValues(H, gA);
    return k && (d.rem = k), k = CA.map((BA, eA) => ingest$1({
      index: eA / (CA.length - 1 || 1),
      value: BA,
      label: IA(BA)
    })), n.extra && k.length && k.push(ingest$1({
      index: -1,
      extra: {
        value: k[0].value
      },
      label: ""
    })), d.source = k, d.add = k, this.value = k, d;
  }
});
function DataJoin$1(n) {
  Transform.call(this, null, n);
}
function defaultItemCreate() {
  return ingest$1({});
}
function newMap(n) {
  const t = fastmap().test((g) => g.exit);
  return t.lookup = (g) => t.get(n(g)), t;
}
inherits$1(DataJoin$1, Transform, {
  transform(n, t) {
    var g = t.dataflow, d = t.fork(t.NO_SOURCE | t.NO_FIELDS), k = n.item || defaultItemCreate, H = n.key || tupleid, AA = this.value;
    return isArray$3(d.encode) && (d.encode = null), AA && (n.modified("key") || t.modified(H)) && error$3("DataJoin does not support modified key function or fields."), AA || (t = t.addAll(), this.value = AA = newMap(H)), t.visit(t.ADD, (gA) => {
      const IA = H(gA);
      let CA = AA.get(IA);
      CA ? CA.exit ? (AA.empty--, d.add.push(CA)) : d.mod.push(CA) : (CA = k(gA), AA.set(IA, CA), d.add.push(CA)), CA.datum = gA, CA.exit = !1;
    }), t.visit(t.MOD, (gA) => {
      const IA = H(gA), CA = AA.get(IA);
      CA && (CA.datum = gA, d.mod.push(CA));
    }), t.visit(t.REM, (gA) => {
      const IA = H(gA), CA = AA.get(IA);
      gA === CA.datum && !CA.exit && (d.rem.push(CA), CA.exit = !0, ++AA.empty);
    }), t.changed(t.ADD_MOD) && d.modifies("datum"), (t.clean() || n.clean && AA.empty > g.cleanThreshold) && g.runAfter(AA.clean), d;
  }
});
function Encode$1(n) {
  Transform.call(this, null, n);
}
inherits$1(Encode$1, Transform, {
  transform(n, t) {
    var g = t.fork(t.ADD_REM), d = n.mod || !1, k = n.encoders, H = t.encode;
    if (isArray$3(H))
      if (g.changed() || H.every((eA) => k[eA]))
        H = H[0], g.encode = null;
      else
        return t.StopPropagation;
    var AA = H === "enter", gA = k.update || falsy, IA = k.enter || falsy, CA = k.exit || falsy, BA = (H && !AA ? k[H] : gA) || falsy;
    if (t.changed(t.ADD) && (t.visit(t.ADD, (eA) => {
      IA(eA, n), gA(eA, n);
    }), g.modifies(IA.output), g.modifies(gA.output), BA !== falsy && BA !== gA && (t.visit(t.ADD, (eA) => {
      BA(eA, n);
    }), g.modifies(BA.output))), t.changed(t.REM) && CA !== falsy && (t.visit(t.REM, (eA) => {
      CA(eA, n);
    }), g.modifies(CA.output)), AA || BA !== falsy) {
      const eA = t.MOD | (n.modified() ? t.REFLOW : 0);
      AA ? (t.visit(eA, (iA) => {
        const QA = IA(iA, n) || d;
        (BA(iA, n) || QA) && g.mod.push(iA);
      }), g.mod.length && g.modifies(IA.output)) : t.visit(eA, (iA) => {
        (BA(iA, n) || d) && g.mod.push(iA);
      }), g.mod.length && g.modifies(BA.output);
    }
    return g.changed() ? g : t.StopPropagation;
  }
});
function LegendEntries$1(n) {
  Transform.call(this, [], n);
}
inherits$1(LegendEntries$1, Transform, {
  transform(n, t) {
    if (this.value != null && !n.modified())
      return t.StopPropagation;
    var g = t.dataflow.locale(), d = t.fork(t.NO_SOURCE | t.NO_FIELDS), k = this.value, H = n.type || SymbolLegend, AA = n.scale, gA = +n.limit, IA = tickCount(AA, n.count == null ? 5 : n.count, n.minstep), CA = !!n.values || H === SymbolLegend, BA = n.format || labelFormat(g, AA, IA, H, n.formatSpecifier, n.formatType, CA), eA = n.values || labelValues(AA, IA), iA, QA, tA, oA, EA;
    return k && (d.rem = k), H === SymbolLegend ? (gA && eA.length > gA ? (t.dataflow.warn("Symbol legend count exceeds limit, filtering items."), k = eA.slice(0, gA - 1), EA = !0) : k = eA, isFunction$5(tA = n.size) ? (!n.values && AA(k[0]) === 0 && (k = k.slice(1)), oA = k.reduce((aA, nA) => Math.max(aA, tA(nA, n)), 0)) : tA = constant$6(oA = tA || 8), k = k.map((aA, nA) => ingest$1({
      index: nA,
      label: BA(aA, nA, k),
      value: aA,
      offset: oA,
      size: tA(aA, n)
    })), EA && (EA = eA[k.length], k.push(ingest$1({
      index: k.length,
      label: `…${eA.length - k.length} entries`,
      value: EA,
      offset: oA,
      size: tA(EA, n)
    })))) : H === GradientLegend ? (iA = AA.domain(), QA = scaleFraction(AA, iA[0], peek$2(iA)), eA.length < 3 && !n.values && iA[0] !== peek$2(iA) && (eA = [iA[0], peek$2(iA)]), k = eA.map((aA, nA) => ingest$1({
      index: nA,
      label: BA(aA, nA, eA),
      value: aA,
      perc: QA(aA)
    }))) : (tA = eA.length - 1, QA = labelFraction(AA), k = eA.map((aA, nA) => ingest$1({
      index: nA,
      label: BA(aA, nA, eA),
      value: aA,
      perc: nA ? QA(aA) : 0,
      perc2: nA === tA ? 1 : QA(eA[nA + 1])
    }))), d.source = k, d.add = k, this.value = k, d;
  }
});
const sourceX = (n) => n.source.x, sourceY = (n) => n.source.y, targetX = (n) => n.target.x, targetY = (n) => n.target.y;
function LinkPath(n) {
  Transform.call(this, {}, n);
}
LinkPath.Definition = {
  type: "LinkPath",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "sourceX",
    type: "field",
    default: "source.x"
  }, {
    name: "sourceY",
    type: "field",
    default: "source.y"
  }, {
    name: "targetX",
    type: "field",
    default: "target.x"
  }, {
    name: "targetY",
    type: "field",
    default: "target.y"
  }, {
    name: "orient",
    type: "enum",
    default: "vertical",
    values: ["horizontal", "vertical", "radial"]
  }, {
    name: "shape",
    type: "enum",
    default: "line",
    values: ["line", "arc", "curve", "diagonal", "orthogonal"]
  }, {
    name: "require",
    type: "signal"
  }, {
    name: "as",
    type: "string",
    default: "path"
  }]
};
inherits$1(LinkPath, Transform, {
  transform(n, t) {
    var g = n.sourceX || sourceX, d = n.sourceY || sourceY, k = n.targetX || targetX, H = n.targetY || targetY, AA = n.as || "path", gA = n.orient || "vertical", IA = n.shape || "line", CA = Paths.get(IA + "-" + gA) || Paths.get(IA);
    return CA || error$3("LinkPath unsupported type: " + n.shape + (n.orient ? "-" + n.orient : "")), t.visit(t.SOURCE, (BA) => {
      BA[AA] = CA(g(BA), d(BA), k(BA), H(BA));
    }), t.reflow(n.modified()).modifies(AA);
  }
});
const line$1 = (n, t, g, d) => "M" + n + "," + t + "L" + g + "," + d, lineR = (n, t, g, d) => line$1(t * Math.cos(n), t * Math.sin(n), d * Math.cos(g), d * Math.sin(g)), arc$1 = (n, t, g, d) => {
  var k = g - n, H = d - t, AA = Math.hypot(k, H) / 2, gA = 180 * Math.atan2(H, k) / Math.PI;
  return "M" + n + "," + t + "A" + AA + "," + AA + " " + gA + " 0 1 " + g + "," + d;
}, arcR = (n, t, g, d) => arc$1(t * Math.cos(n), t * Math.sin(n), d * Math.cos(g), d * Math.sin(g)), curve = (n, t, g, d) => {
  const k = g - n, H = d - t, AA = 0.2 * (k + H), gA = 0.2 * (H - k);
  return "M" + n + "," + t + "C" + (n + AA) + "," + (t + gA) + " " + (g + gA) + "," + (d - AA) + " " + g + "," + d;
}, curveR = (n, t, g, d) => curve(t * Math.cos(n), t * Math.sin(n), d * Math.cos(g), d * Math.sin(g)), orthoX = (n, t, g, d) => "M" + n + "," + t + "V" + d + "H" + g, orthoY = (n, t, g, d) => "M" + n + "," + t + "H" + g + "V" + d, orthoR = (n, t, g, d) => {
  const k = Math.cos(n), H = Math.sin(n), AA = Math.cos(g), gA = Math.sin(g), IA = Math.abs(g - n) > Math.PI ? g <= n : g > n;
  return "M" + t * k + "," + t * H + "A" + t + "," + t + " 0 0," + (IA ? 1 : 0) + " " + t * AA + "," + t * gA + "L" + d * AA + "," + d * gA;
}, diagonalX = (n, t, g, d) => {
  const k = (n + g) / 2;
  return "M" + n + "," + t + "C" + k + "," + t + " " + k + "," + d + " " + g + "," + d;
}, diagonalY = (n, t, g, d) => {
  const k = (t + d) / 2;
  return "M" + n + "," + t + "C" + n + "," + k + " " + g + "," + k + " " + g + "," + d;
}, diagonalR = (n, t, g, d) => {
  const k = Math.cos(n), H = Math.sin(n), AA = Math.cos(g), gA = Math.sin(g), IA = (t + d) / 2;
  return "M" + t * k + "," + t * H + "C" + IA * k + "," + IA * H + " " + IA * AA + "," + IA * gA + " " + d * AA + "," + d * gA;
}, Paths = fastmap({
  line: line$1,
  "line-radial": lineR,
  arc: arc$1,
  "arc-radial": arcR,
  curve,
  "curve-radial": curveR,
  "orthogonal-horizontal": orthoX,
  "orthogonal-vertical": orthoY,
  "orthogonal-radial": orthoR,
  "diagonal-horizontal": diagonalX,
  "diagonal-vertical": diagonalY,
  "diagonal-radial": diagonalR
});
function Pie(n) {
  Transform.call(this, null, n);
}
Pie.Definition = {
  type: "Pie",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "startAngle",
    type: "number",
    default: 0
  }, {
    name: "endAngle",
    type: "number",
    default: 6.283185307179586
  }, {
    name: "sort",
    type: "boolean",
    default: !1
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: ["startAngle", "endAngle"]
  }]
};
inherits$1(Pie, Transform, {
  transform(n, t) {
    var g = n.as || ["startAngle", "endAngle"], d = g[0], k = g[1], H = n.field || one$2, AA = n.startAngle || 0, gA = n.endAngle != null ? n.endAngle : 2 * Math.PI, IA = t.source, CA = IA.map(H), BA = CA.length, eA = AA, iA = (gA - AA) / sum$1(CA), QA = range$5(BA), tA, oA, EA;
    for (n.sort && QA.sort((aA, nA) => CA[aA] - CA[nA]), tA = 0; tA < BA; ++tA)
      EA = CA[QA[tA]], oA = IA[QA[tA]], oA[d] = eA, oA[k] = eA += EA * iA;
    return this.value = CA, t.reflow(n.modified()).modifies(g);
  }
});
const DEFAULT_COUNT = 5;
function includeZero(n) {
  const t = n.type;
  return !n.bins && (t === Linear || t === Pow || t === Sqrt);
}
function includePad(n) {
  return isContinuous$1(n) && n !== Sequential;
}
const SKIP$1 = toSet(["set", "modified", "clear", "type", "scheme", "schemeExtent", "schemeCount", "domain", "domainMin", "domainMid", "domainMax", "domainRaw", "domainImplicit", "nice", "zero", "bins", "range", "rangeStep", "round", "reverse", "interpolate", "interpolateGamma"]);
function Scale$1(n) {
  Transform.call(this, null, n), this.modified(!0);
}
inherits$1(Scale$1, Transform, {
  transform(n, t) {
    var g = t.dataflow, d = this.value, k = scaleKey(n);
    (!d || k !== d.type) && (this.value = d = scale$4(k)());
    for (k in n) if (!SKIP$1[k]) {
      if (k === "padding" && includePad(d.type)) continue;
      isFunction$5(d[k]) ? d[k](n[k]) : g.warn("Unsupported scale property: " + k);
    }
    return configureRange(d, n, configureBins(d, n, configureDomain(d, n, g))), t.fork(t.NO_SOURCE | t.NO_FIELDS);
  }
});
function scaleKey(n) {
  var t = n.type, g = "", d;
  return t === Sequential ? Sequential + "-" + Linear : (isContinuousColor(n) && (d = n.rawDomain ? n.rawDomain.length : n.domain ? n.domain.length + +(n.domainMid != null) : 0, g = d === 2 ? Sequential + "-" : d === 3 ? Diverging + "-" : ""), (g + t || Linear).toLowerCase());
}
function isContinuousColor(n) {
  const t = n.type;
  return isContinuous$1(t) && t !== Time && t !== UTC && (n.scheme || n.range && n.range.length && n.range.every(isString$2));
}
function configureDomain(n, t, g) {
  const d = rawDomain(n, t.domainRaw, g);
  if (d > -1) return d;
  var k = t.domain, H = n.type, AA = t.zero || t.zero === void 0 && includeZero(n), gA, IA;
  if (!k) return 0;
  if ((AA || t.domainMin != null || t.domainMax != null || t.domainMid != null) && (gA = (k = k.slice()).length - 1 || 1, AA && (k[0] > 0 && (k[0] = 0), k[gA] < 0 && (k[gA] = 0)), t.domainMin != null && (k[0] = t.domainMin), t.domainMax != null && (k[gA] = t.domainMax), t.domainMid != null)) {
    IA = t.domainMid;
    const CA = IA > k[gA] ? gA + 1 : IA < k[0] ? 0 : gA;
    CA !== gA && g.warn("Scale domainMid exceeds domain min or max.", IA), k.splice(CA, 0, IA);
  }
  return includePad(H) && t.padding && k[0] !== peek$2(k) && (k = padDomain(H, k, t.range, t.padding, t.exponent, t.constant)), n.domain(domainCheck(H, k, g)), H === Ordinal && n.unknown(t.domainImplicit ? implicit : void 0), t.nice && n.nice && n.nice(t.nice !== !0 && tickCount(n, t.nice) || null), k.length;
}
function rawDomain(n, t, g) {
  return t ? (n.domain(domainCheck(n.type, t, g)), t.length) : -1;
}
function padDomain(n, t, g, d, k, H) {
  var AA = Math.abs(peek$2(g) - g[0]), gA = AA / (AA - 2 * d), IA = n === Log ? zoomLog(t, null, gA) : n === Sqrt ? zoomPow(t, null, gA, 0.5) : n === Pow ? zoomPow(t, null, gA, k || 1) : n === Symlog ? zoomSymlog(t, null, gA, H || 1) : zoomLinear(t, null, gA);
  return t = t.slice(), t[0] = IA[0], t[t.length - 1] = IA[1], t;
}
function domainCheck(n, t, g) {
  if (isLogarithmic(n)) {
    var d = Math.abs(t.reduce((k, H) => k + (H < 0 ? -1 : H > 0 ? 1 : 0), 0));
    d !== t.length && g.warn("Log scale domain includes zero: " + $$2(t));
  }
  return t;
}
function configureBins(n, t, g) {
  let d = t.bins;
  if (d && !isArray$3(d)) {
    const k = n.domain(), H = k[0], AA = peek$2(k), gA = d.step;
    let IA = d.start == null ? H : d.start, CA = d.stop == null ? AA : d.stop;
    gA || error$3("Scale bins parameter missing step property."), IA < H && (IA = gA * Math.ceil(H / gA)), CA > AA && (CA = gA * Math.floor(AA / gA)), d = range$5(IA, CA + gA / 2, gA);
  }
  return d ? n.bins = d : n.bins && delete n.bins, n.type === BinOrdinal && (d ? !t.domain && !t.domainRaw && (n.domain(d), g = d.length) : n.bins = n.domain()), g;
}
function configureRange(n, t, g) {
  var d = n.type, k = t.round || !1, H = t.range;
  if (t.rangeStep != null)
    H = configureRangeStep(d, t, g);
  else if (t.scheme && (H = configureScheme(d, t, g), isFunction$5(H))) {
    if (n.interpolator)
      return n.interpolator(H);
    error$3(`Scale type ${d} does not support interpolating color schemes.`);
  }
  if (H && isInterpolating(d))
    return n.interpolator(interpolateColors(flip$1(H, t.reverse), t.interpolate, t.interpolateGamma));
  H && t.interpolate && n.interpolate ? n.interpolate(interpolate$1(t.interpolate, t.interpolateGamma)) : isFunction$5(n.round) ? n.round(k) : isFunction$5(n.rangeRound) && n.interpolate(k ? interpolateRound : interpolate$2), H && n.range(flip$1(H, t.reverse));
}
function configureRangeStep(n, t, g) {
  n !== Band && n !== Point && error$3("Only band and point scales support rangeStep.");
  var d = (t.paddingOuter != null ? t.paddingOuter : t.padding) || 0, k = n === Point ? 1 : (t.paddingInner != null ? t.paddingInner : t.padding) || 0;
  return [0, t.rangeStep * bandSpace(g, k, d)];
}
function configureScheme(n, t, g) {
  var d = t.schemeExtent, k, H;
  return isArray$3(t.scheme) ? H = interpolateColors(t.scheme, t.interpolate, t.interpolateGamma) : (k = t.scheme.toLowerCase(), H = scheme$1(k), H || error$3(`Unrecognized scheme name: ${t.scheme}`)), g = n === Threshold ? g + 1 : n === BinOrdinal ? g - 1 : n === Quantile || n === Quantize ? +t.schemeCount || DEFAULT_COUNT : g, isInterpolating(n) ? adjustScheme(H, d, t.reverse) : isFunction$5(H) ? quantizeInterpolator(adjustScheme(H, d), g) : n === Ordinal ? H : H.slice(0, g);
}
function adjustScheme(n, t, g) {
  return isFunction$5(n) && (t || g) ? interpolateRange$1(n, flip$1(t || [0, 1], g)) : n;
}
function flip$1(n, t) {
  return t ? n.slice().reverse() : n;
}
function SortItems$1(n) {
  Transform.call(this, null, n);
}
inherits$1(SortItems$1, Transform, {
  transform(n, t) {
    const g = n.modified("sort") || t.changed(t.ADD) || t.modified(n.sort.fields) || t.modified("datum");
    return g && t.source.sort(stableCompare(n.sort)), this.modified(g), t;
  }
});
const Zero = "zero", Center$1 = "center", Normalize = "normalize", DefOutput = ["y0", "y1"];
function Stack$1(n) {
  Transform.call(this, null, n);
}
Stack$1.Definition = {
  type: "Stack",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "sort",
    type: "compare"
  }, {
    name: "offset",
    type: "enum",
    default: Zero,
    values: [Zero, Center$1, Normalize]
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: DefOutput
  }]
};
inherits$1(Stack$1, Transform, {
  transform(n, t) {
    var g = n.as || DefOutput, d = g[0], k = g[1], H = stableCompare(n.sort), AA = n.field || one$2, gA = n.offset === Center$1 ? stackCenter : n.offset === Normalize ? stackNormalize : stackZero, IA, CA, BA, eA;
    for (IA = partition$3(t.source, n.groupby, H, AA), CA = 0, BA = IA.length, eA = IA.max; CA < BA; ++CA)
      gA(IA[CA], eA, AA, d, k);
    return t.reflow(n.modified()).modifies(g);
  }
});
function stackCenter(n, t, g, d, k) {
  for (var H = (t - n.sum) / 2, AA = n.length, gA = 0, IA; gA < AA; ++gA)
    IA = n[gA], IA[d] = H, IA[k] = H += Math.abs(g(IA));
}
function stackNormalize(n, t, g, d, k) {
  for (var H = 1 / n.sum, AA = 0, gA = n.length, IA = 0, CA = 0, BA; IA < gA; ++IA)
    BA = n[IA], BA[d] = AA, BA[k] = AA = H * (CA += Math.abs(g(BA)));
}
function stackZero(n, t, g, d, k) {
  for (var H = 0, AA = 0, gA = n.length, IA = 0, CA, BA; IA < gA; ++IA)
    BA = n[IA], CA = +g(BA), CA < 0 ? (BA[d] = AA, BA[k] = AA += CA) : (BA[d] = H, BA[k] = H += CA);
}
function partition$3(n, t, g, d) {
  var k = [], H = (oA) => oA(BA), AA, gA, IA, CA, BA, eA, iA, QA, tA;
  if (t == null)
    k.push(n.slice());
  else
    for (AA = {}, gA = 0, IA = n.length; gA < IA; ++gA)
      BA = n[gA], eA = t.map(H), iA = AA[eA], iA || (AA[eA] = iA = [], k.push(iA)), iA.push(BA);
  for (eA = 0, tA = 0, CA = k.length; eA < CA; ++eA) {
    for (iA = k[eA], gA = 0, QA = 0, IA = iA.length; gA < IA; ++gA)
      QA += Math.abs(d(iA[gA]));
    iA.sum = QA, QA > tA && (tA = QA), g && iA.sort(g);
  }
  return k.max = tA, k;
}
const encode$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  axisticks: AxisTicks$1,
  datajoin: DataJoin$1,
  encode: Encode$1,
  legendentries: LegendEntries$1,
  linkpath: LinkPath,
  pie: Pie,
  scale: Scale$1,
  sortitems: SortItems$1,
  stack: Stack$1
}, Symbol.toStringTag, { value: "Module" }));
var epsilon$3 = 1e-6, epsilon2 = 1e-12, pi$1 = Math.PI, halfPi$1 = pi$1 / 2, quarterPi = pi$1 / 4, tau$1 = pi$1 * 2, degrees = 180 / pi$1, radians = pi$1 / 180, abs$1 = Math.abs, atan = Math.atan, atan2 = Math.atan2, cos$1 = Math.cos, ceil = Math.ceil, exp = Math.exp, hypot = Math.hypot, log$2 = Math.log, pow$1 = Math.pow, sin$1 = Math.sin, sign = Math.sign || function(n) {
  return n > 0 ? 1 : n < 0 ? -1 : 0;
}, sqrt$1 = Math.sqrt, tan = Math.tan;
function acos(n) {
  return n > 1 ? 0 : n < -1 ? pi$1 : Math.acos(n);
}
function asin$1(n) {
  return n > 1 ? halfPi$1 : n < -1 ? -halfPi$1 : Math.asin(n);
}
function noop$4() {
}
function streamGeometry(n, t) {
  n && streamGeometryType.hasOwnProperty(n.type) && streamGeometryType[n.type](n, t);
}
var streamObjectType = {
  Feature: function(n, t) {
    streamGeometry(n.geometry, t);
  },
  FeatureCollection: function(n, t) {
    for (var g = n.features, d = -1, k = g.length; ++d < k; ) streamGeometry(g[d].geometry, t);
  }
}, streamGeometryType = {
  Sphere: function(n, t) {
    t.sphere();
  },
  Point: function(n, t) {
    n = n.coordinates, t.point(n[0], n[1], n[2]);
  },
  MultiPoint: function(n, t) {
    for (var g = n.coordinates, d = -1, k = g.length; ++d < k; ) n = g[d], t.point(n[0], n[1], n[2]);
  },
  LineString: function(n, t) {
    streamLine(n.coordinates, t, 0);
  },
  MultiLineString: function(n, t) {
    for (var g = n.coordinates, d = -1, k = g.length; ++d < k; ) streamLine(g[d], t, 0);
  },
  Polygon: function(n, t) {
    streamPolygon(n.coordinates, t);
  },
  MultiPolygon: function(n, t) {
    for (var g = n.coordinates, d = -1, k = g.length; ++d < k; ) streamPolygon(g[d], t);
  },
  GeometryCollection: function(n, t) {
    for (var g = n.geometries, d = -1, k = g.length; ++d < k; ) streamGeometry(g[d], t);
  }
};
function streamLine(n, t, g) {
  var d = -1, k = n.length - g, H;
  for (t.lineStart(); ++d < k; ) H = n[d], t.point(H[0], H[1], H[2]);
  t.lineEnd();
}
function streamPolygon(n, t) {
  var g = -1, d = n.length;
  for (t.polygonStart(); ++g < d; ) streamLine(n[g], t, 1);
  t.polygonEnd();
}
function geoStream(n, t) {
  n && streamObjectType.hasOwnProperty(n.type) ? streamObjectType[n.type](n, t) : streamGeometry(n, t);
}
var areaRingSum$1 = new Adder(), areaSum$1 = new Adder(), lambda00$2, phi00$2, lambda0$1, cosPhi0, sinPhi0, areaStream$1 = {
  point: noop$4,
  lineStart: noop$4,
  lineEnd: noop$4,
  polygonStart: function() {
    areaRingSum$1 = new Adder(), areaStream$1.lineStart = areaRingStart$1, areaStream$1.lineEnd = areaRingEnd$1;
  },
  polygonEnd: function() {
    var n = +areaRingSum$1;
    areaSum$1.add(n < 0 ? tau$1 + n : n), this.lineStart = this.lineEnd = this.point = noop$4;
  },
  sphere: function() {
    areaSum$1.add(tau$1);
  }
};
function areaRingStart$1() {
  areaStream$1.point = areaPointFirst$1;
}
function areaRingEnd$1() {
  areaPoint$1(lambda00$2, phi00$2);
}
function areaPointFirst$1(n, t) {
  areaStream$1.point = areaPoint$1, lambda00$2 = n, phi00$2 = t, n *= radians, t *= radians, lambda0$1 = n, cosPhi0 = cos$1(t = t / 2 + quarterPi), sinPhi0 = sin$1(t);
}
function areaPoint$1(n, t) {
  n *= radians, t *= radians, t = t / 2 + quarterPi;
  var g = n - lambda0$1, d = g >= 0 ? 1 : -1, k = d * g, H = cos$1(t), AA = sin$1(t), gA = sinPhi0 * AA, IA = cosPhi0 * H + gA * cos$1(k), CA = gA * d * sin$1(k);
  areaRingSum$1.add(atan2(CA, IA)), lambda0$1 = n, cosPhi0 = H, sinPhi0 = AA;
}
function geoArea$1(n) {
  return areaSum$1 = new Adder(), geoStream(n, areaStream$1), areaSum$1 * 2;
}
function spherical(n) {
  return [atan2(n[1], n[0]), asin$1(n[2])];
}
function cartesian(n) {
  var t = n[0], g = n[1], d = cos$1(g);
  return [d * cos$1(t), d * sin$1(t), sin$1(g)];
}
function cartesianDot(n, t) {
  return n[0] * t[0] + n[1] * t[1] + n[2] * t[2];
}
function cartesianCross(n, t) {
  return [n[1] * t[2] - n[2] * t[1], n[2] * t[0] - n[0] * t[2], n[0] * t[1] - n[1] * t[0]];
}
function cartesianAddInPlace(n, t) {
  n[0] += t[0], n[1] += t[1], n[2] += t[2];
}
function cartesianScale(n, t) {
  return [n[0] * t, n[1] * t, n[2] * t];
}
function cartesianNormalizeInPlace(n) {
  var t = sqrt$1(n[0] * n[0] + n[1] * n[1] + n[2] * n[2]);
  n[0] /= t, n[1] /= t, n[2] /= t;
}
var lambda0, phi0, lambda1, phi1, lambda2, lambda00$1, phi00$1, p0, deltaSum, ranges, range$4, boundsStream$1 = {
  point: boundsPoint$1,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream$1.point = boundsRingPoint, boundsStream$1.lineStart = boundsRingStart, boundsStream$1.lineEnd = boundsRingEnd, deltaSum = new Adder(), areaStream$1.polygonStart();
  },
  polygonEnd: function() {
    areaStream$1.polygonEnd(), boundsStream$1.point = boundsPoint$1, boundsStream$1.lineStart = boundsLineStart, boundsStream$1.lineEnd = boundsLineEnd, areaRingSum$1 < 0 ? (lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90)) : deltaSum > epsilon$3 ? phi1 = 90 : deltaSum < -epsilon$3 && (phi0 = -90), range$4[0] = lambda0, range$4[1] = lambda1;
  },
  sphere: function() {
    lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
  }
};
function boundsPoint$1(n, t) {
  ranges.push(range$4 = [lambda0 = n, lambda1 = n]), t < phi0 && (phi0 = t), t > phi1 && (phi1 = t);
}
function linePoint(n, t) {
  var g = cartesian([n * radians, t * radians]);
  if (p0) {
    var d = cartesianCross(p0, g), k = [d[1], -d[0], 0], H = cartesianCross(k, d);
    cartesianNormalizeInPlace(H), H = spherical(H);
    var AA = n - lambda2, gA = AA > 0 ? 1 : -1, IA = H[0] * degrees * gA, CA, BA = abs$1(AA) > 180;
    BA ^ (gA * lambda2 < IA && IA < gA * n) ? (CA = H[1] * degrees, CA > phi1 && (phi1 = CA)) : (IA = (IA + 360) % 360 - 180, BA ^ (gA * lambda2 < IA && IA < gA * n) ? (CA = -H[1] * degrees, CA < phi0 && (phi0 = CA)) : (t < phi0 && (phi0 = t), t > phi1 && (phi1 = t))), BA ? n < lambda2 ? angle(lambda0, n) > angle(lambda0, lambda1) && (lambda1 = n) : angle(n, lambda1) > angle(lambda0, lambda1) && (lambda0 = n) : lambda1 >= lambda0 ? (n < lambda0 && (lambda0 = n), n > lambda1 && (lambda1 = n)) : n > lambda2 ? angle(lambda0, n) > angle(lambda0, lambda1) && (lambda1 = n) : angle(n, lambda1) > angle(lambda0, lambda1) && (lambda0 = n);
  } else
    ranges.push(range$4 = [lambda0 = n, lambda1 = n]);
  t < phi0 && (phi0 = t), t > phi1 && (phi1 = t), p0 = g, lambda2 = n;
}
function boundsLineStart() {
  boundsStream$1.point = linePoint;
}
function boundsLineEnd() {
  range$4[0] = lambda0, range$4[1] = lambda1, boundsStream$1.point = boundsPoint$1, p0 = null;
}
function boundsRingPoint(n, t) {
  if (p0) {
    var g = n - lambda2;
    deltaSum.add(abs$1(g) > 180 ? g + (g > 0 ? 360 : -360) : g);
  } else
    lambda00$1 = n, phi00$1 = t;
  areaStream$1.point(n, t), linePoint(n, t);
}
function boundsRingStart() {
  areaStream$1.lineStart();
}
function boundsRingEnd() {
  boundsRingPoint(lambda00$1, phi00$1), areaStream$1.lineEnd(), abs$1(deltaSum) > epsilon$3 && (lambda0 = -(lambda1 = 180)), range$4[0] = lambda0, range$4[1] = lambda1, p0 = null;
}
function angle(n, t) {
  return (t -= n) < 0 ? t + 360 : t;
}
function rangeCompare(n, t) {
  return n[0] - t[0];
}
function rangeContains(n, t) {
  return n[0] <= n[1] ? n[0] <= t && t <= n[1] : t < n[0] || n[1] < t;
}
function geoBounds$1(n) {
  var t, g, d, k, H, AA, gA;
  if (phi1 = lambda1 = -(lambda0 = phi0 = 1 / 0), ranges = [], geoStream(n, boundsStream$1), g = ranges.length) {
    for (ranges.sort(rangeCompare), t = 1, d = ranges[0], H = [d]; t < g; ++t)
      k = ranges[t], rangeContains(d, k[0]) || rangeContains(d, k[1]) ? (angle(d[0], k[1]) > angle(d[0], d[1]) && (d[1] = k[1]), angle(k[0], d[1]) > angle(d[0], d[1]) && (d[0] = k[0])) : H.push(d = k);
    for (AA = -1 / 0, g = H.length - 1, t = 0, d = H[g]; t <= g; d = k, ++t)
      k = H[t], (gA = angle(d[1], k[0])) > AA && (AA = gA, lambda0 = k[0], lambda1 = d[1]);
  }
  return ranges = range$4 = null, lambda0 === 1 / 0 || phi0 === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[lambda0, phi0], [lambda1, phi1]];
}
var W0, W1, X0$1, Y0$1, Z0$1, X1$1, Y1$1, Z1$1, X2$2, Y2$2, Z2$1, lambda00, phi00, x0$4, y0$4, z0, centroidStream$1 = {
  sphere: noop$4,
  point: centroidPoint$1,
  lineStart: centroidLineStart$1,
  lineEnd: centroidLineEnd$1,
  polygonStart: function() {
    centroidStream$1.lineStart = centroidRingStart$1, centroidStream$1.lineEnd = centroidRingEnd$1;
  },
  polygonEnd: function() {
    centroidStream$1.lineStart = centroidLineStart$1, centroidStream$1.lineEnd = centroidLineEnd$1;
  }
};
function centroidPoint$1(n, t) {
  n *= radians, t *= radians;
  var g = cos$1(t);
  centroidPointCartesian(g * cos$1(n), g * sin$1(n), sin$1(t));
}
function centroidPointCartesian(n, t, g) {
  ++W0, X0$1 += (n - X0$1) / W0, Y0$1 += (t - Y0$1) / W0, Z0$1 += (g - Z0$1) / W0;
}
function centroidLineStart$1() {
  centroidStream$1.point = centroidLinePointFirst;
}
function centroidLinePointFirst(n, t) {
  n *= radians, t *= radians;
  var g = cos$1(t);
  x0$4 = g * cos$1(n), y0$4 = g * sin$1(n), z0 = sin$1(t), centroidStream$1.point = centroidLinePoint, centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidLinePoint(n, t) {
  n *= radians, t *= radians;
  var g = cos$1(t), d = g * cos$1(n), k = g * sin$1(n), H = sin$1(t), AA = atan2(sqrt$1((AA = y0$4 * H - z0 * k) * AA + (AA = z0 * d - x0$4 * H) * AA + (AA = x0$4 * k - y0$4 * d) * AA), x0$4 * d + y0$4 * k + z0 * H);
  W1 += AA, X1$1 += AA * (x0$4 + (x0$4 = d)), Y1$1 += AA * (y0$4 + (y0$4 = k)), Z1$1 += AA * (z0 + (z0 = H)), centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidLineEnd$1() {
  centroidStream$1.point = centroidPoint$1;
}
function centroidRingStart$1() {
  centroidStream$1.point = centroidRingPointFirst;
}
function centroidRingEnd$1() {
  centroidRingPoint(lambda00, phi00), centroidStream$1.point = centroidPoint$1;
}
function centroidRingPointFirst(n, t) {
  lambda00 = n, phi00 = t, n *= radians, t *= radians, centroidStream$1.point = centroidRingPoint;
  var g = cos$1(t);
  x0$4 = g * cos$1(n), y0$4 = g * sin$1(n), z0 = sin$1(t), centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidRingPoint(n, t) {
  n *= radians, t *= radians;
  var g = cos$1(t), d = g * cos$1(n), k = g * sin$1(n), H = sin$1(t), AA = y0$4 * H - z0 * k, gA = z0 * d - x0$4 * H, IA = x0$4 * k - y0$4 * d, CA = hypot(AA, gA, IA), BA = asin$1(CA), eA = CA && -BA / CA;
  X2$2.add(eA * AA), Y2$2.add(eA * gA), Z2$1.add(eA * IA), W1 += BA, X1$1 += BA * (x0$4 + (x0$4 = d)), Y1$1 += BA * (y0$4 + (y0$4 = k)), Z1$1 += BA * (z0 + (z0 = H)), centroidPointCartesian(x0$4, y0$4, z0);
}
function geoCentroid$1(n) {
  W0 = W1 = X0$1 = Y0$1 = Z0$1 = X1$1 = Y1$1 = Z1$1 = 0, X2$2 = new Adder(), Y2$2 = new Adder(), Z2$1 = new Adder(), geoStream(n, centroidStream$1);
  var t = +X2$2, g = +Y2$2, d = +Z2$1, k = hypot(t, g, d);
  return k < epsilon2 && (t = X1$1, g = Y1$1, d = Z1$1, W1 < epsilon$3 && (t = X0$1, g = Y0$1, d = Z0$1), k = hypot(t, g, d), k < epsilon2) ? [NaN, NaN] : [atan2(g, t) * degrees, asin$1(d / k) * degrees];
}
function compose(n, t) {
  function g(d, k) {
    return d = n(d, k), t(d[0], d[1]);
  }
  return n.invert && t.invert && (g.invert = function(d, k) {
    return d = t.invert(d, k), d && n.invert(d[0], d[1]);
  }), g;
}
function rotationIdentity(n, t) {
  return abs$1(n) > pi$1 && (n -= Math.round(n / tau$1) * tau$1), [n, t];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(n, t, g) {
  return (n %= tau$1) ? t || g ? compose(rotationLambda(n), rotationPhiGamma(t, g)) : rotationLambda(n) : t || g ? rotationPhiGamma(t, g) : rotationIdentity;
}
function forwardRotationLambda(n) {
  return function(t, g) {
    return t += n, abs$1(t) > pi$1 && (t -= Math.round(t / tau$1) * tau$1), [t, g];
  };
}
function rotationLambda(n) {
  var t = forwardRotationLambda(n);
  return t.invert = forwardRotationLambda(-n), t;
}
function rotationPhiGamma(n, t) {
  var g = cos$1(n), d = sin$1(n), k = cos$1(t), H = sin$1(t);
  function AA(gA, IA) {
    var CA = cos$1(IA), BA = cos$1(gA) * CA, eA = sin$1(gA) * CA, iA = sin$1(IA), QA = iA * g + BA * d;
    return [
      atan2(eA * k - QA * H, BA * g - iA * d),
      asin$1(QA * k + eA * H)
    ];
  }
  return AA.invert = function(gA, IA) {
    var CA = cos$1(IA), BA = cos$1(gA) * CA, eA = sin$1(gA) * CA, iA = sin$1(IA), QA = iA * k - eA * H;
    return [
      atan2(eA * k + iA * H, BA * g + QA * d),
      asin$1(QA * g - BA * d)
    ];
  }, AA;
}
function rotation(n) {
  n = rotateRadians(n[0] * radians, n[1] * radians, n.length > 2 ? n[2] * radians : 0);
  function t(g) {
    return g = n(g[0] * radians, g[1] * radians), g[0] *= degrees, g[1] *= degrees, g;
  }
  return t.invert = function(g) {
    return g = n.invert(g[0] * radians, g[1] * radians), g[0] *= degrees, g[1] *= degrees, g;
  }, t;
}
function circleStream(n, t, g, d, k, H) {
  if (g) {
    var AA = cos$1(t), gA = sin$1(t), IA = d * g;
    k == null ? (k = t + d * tau$1, H = t - IA / 2) : (k = circleRadius(AA, k), H = circleRadius(AA, H), (d > 0 ? k < H : k > H) && (k += d * tau$1));
    for (var CA, BA = k; d > 0 ? BA > H : BA < H; BA -= IA)
      CA = spherical([AA, -gA * cos$1(BA), -gA * sin$1(BA)]), n.point(CA[0], CA[1]);
  }
}
function circleRadius(n, t) {
  t = cartesian(t), t[0] -= n, cartesianNormalizeInPlace(t);
  var g = acos(-t[1]);
  return ((-t[2] < 0 ? -g : g) + tau$1 - epsilon$3) % tau$1;
}
function clipBuffer() {
  var n = [], t;
  return {
    point: function(g, d, k) {
      t.push([g, d, k]);
    },
    lineStart: function() {
      n.push(t = []);
    },
    lineEnd: noop$4,
    rejoin: function() {
      n.length > 1 && n.push(n.pop().concat(n.shift()));
    },
    result: function() {
      var g = n;
      return n = [], t = null, g;
    }
  };
}
function pointEqual(n, t) {
  return abs$1(n[0] - t[0]) < epsilon$3 && abs$1(n[1] - t[1]) < epsilon$3;
}
function Intersection(n, t, g, d) {
  this.x = n, this.z = t, this.o = g, this.e = d, this.v = !1, this.n = this.p = null;
}
function clipRejoin(n, t, g, d, k) {
  var H = [], AA = [], gA, IA;
  if (n.forEach(function(tA) {
    if (!((oA = tA.length - 1) <= 0)) {
      var oA, EA = tA[0], aA = tA[oA], nA;
      if (pointEqual(EA, aA)) {
        if (!EA[2] && !aA[2]) {
          for (k.lineStart(), gA = 0; gA < oA; ++gA) k.point((EA = tA[gA])[0], EA[1]);
          k.lineEnd();
          return;
        }
        aA[0] += 2 * epsilon$3;
      }
      H.push(nA = new Intersection(EA, tA, null, !0)), AA.push(nA.o = new Intersection(EA, null, nA, !1)), H.push(nA = new Intersection(aA, tA, null, !1)), AA.push(nA.o = new Intersection(aA, null, nA, !0));
    }
  }), !!H.length) {
    for (AA.sort(t), link(H), link(AA), gA = 0, IA = AA.length; gA < IA; ++gA)
      AA[gA].e = g = !g;
    for (var CA = H[0], BA, eA; ; ) {
      for (var iA = CA, QA = !0; iA.v; ) if ((iA = iA.n) === CA) return;
      BA = iA.z, k.lineStart();
      do {
        if (iA.v = iA.o.v = !0, iA.e) {
          if (QA)
            for (gA = 0, IA = BA.length; gA < IA; ++gA) k.point((eA = BA[gA])[0], eA[1]);
          else
            d(iA.x, iA.n.x, 1, k);
          iA = iA.n;
        } else {
          if (QA)
            for (BA = iA.p.z, gA = BA.length - 1; gA >= 0; --gA) k.point((eA = BA[gA])[0], eA[1]);
          else
            d(iA.x, iA.p.x, -1, k);
          iA = iA.p;
        }
        iA = iA.o, BA = iA.z, QA = !QA;
      } while (!iA.v);
      k.lineEnd();
    }
  }
}
function link(n) {
  if (t = n.length) {
    for (var t, g = 0, d = n[0], k; ++g < t; )
      d.n = k = n[g], k.p = d, d = k;
    d.n = k = n[0], k.p = d;
  }
}
function longitude(n) {
  return abs$1(n[0]) <= pi$1 ? n[0] : sign(n[0]) * ((abs$1(n[0]) + pi$1) % tau$1 - pi$1);
}
function polygonContains(n, t) {
  var g = longitude(t), d = t[1], k = sin$1(d), H = [sin$1(g), -cos$1(g), 0], AA = 0, gA = 0, IA = new Adder();
  k === 1 ? d = halfPi$1 + epsilon$3 : k === -1 && (d = -halfPi$1 - epsilon$3);
  for (var CA = 0, BA = n.length; CA < BA; ++CA)
    if (iA = (eA = n[CA]).length)
      for (var eA, iA, QA = eA[iA - 1], tA = longitude(QA), oA = QA[1] / 2 + quarterPi, EA = sin$1(oA), aA = cos$1(oA), nA = 0; nA < iA; ++nA, tA = cA, EA = rA, aA = uA, QA = lA) {
        var lA = eA[nA], cA = longitude(lA), sA = lA[1] / 2 + quarterPi, rA = sin$1(sA), uA = cos$1(sA), hA = cA - tA, dA = hA >= 0 ? 1 : -1, GA = dA * hA, DA = GA > pi$1, wA = EA * rA;
        if (IA.add(atan2(wA * dA * sin$1(GA), aA * uA + wA * cos$1(GA))), AA += DA ? hA + dA * tau$1 : hA, DA ^ tA >= g ^ cA >= g) {
          var bA = cartesianCross(cartesian(QA), cartesian(lA));
          cartesianNormalizeInPlace(bA);
          var yA = cartesianCross(H, bA);
          cartesianNormalizeInPlace(yA);
          var pA = (DA ^ hA >= 0 ? -1 : 1) * asin$1(yA[2]);
          (d > pA || d === pA && (bA[0] || bA[1])) && (gA += DA ^ hA >= 0 ? 1 : -1);
        }
      }
  return (AA < -epsilon$3 || AA < epsilon$3 && IA < -epsilon2) ^ gA & 1;
}
function clip$1(n, t, g, d) {
  return function(k) {
    var H = t(k), AA = clipBuffer(), gA = t(AA), IA = !1, CA, BA, eA, iA = {
      point: QA,
      lineStart: oA,
      lineEnd: EA,
      polygonStart: function() {
        iA.point = aA, iA.lineStart = nA, iA.lineEnd = lA, BA = [], CA = [];
      },
      polygonEnd: function() {
        iA.point = QA, iA.lineStart = oA, iA.lineEnd = EA, BA = merge$4(BA);
        var cA = polygonContains(CA, d);
        BA.length ? (IA || (k.polygonStart(), IA = !0), clipRejoin(BA, compareIntersection, cA, g, k)) : cA && (IA || (k.polygonStart(), IA = !0), k.lineStart(), g(null, null, 1, k), k.lineEnd()), IA && (k.polygonEnd(), IA = !1), BA = CA = null;
      },
      sphere: function() {
        k.polygonStart(), k.lineStart(), g(null, null, 1, k), k.lineEnd(), k.polygonEnd();
      }
    };
    function QA(cA, sA) {
      n(cA, sA) && k.point(cA, sA);
    }
    function tA(cA, sA) {
      H.point(cA, sA);
    }
    function oA() {
      iA.point = tA, H.lineStart();
    }
    function EA() {
      iA.point = QA, H.lineEnd();
    }
    function aA(cA, sA) {
      eA.push([cA, sA]), gA.point(cA, sA);
    }
    function nA() {
      gA.lineStart(), eA = [];
    }
    function lA() {
      aA(eA[0][0], eA[0][1]), gA.lineEnd();
      var cA = gA.clean(), sA = AA.result(), rA, uA = sA.length, hA, dA, GA;
      if (eA.pop(), CA.push(eA), eA = null, !!uA) {
        if (cA & 1) {
          if (dA = sA[0], (hA = dA.length - 1) > 0) {
            for (IA || (k.polygonStart(), IA = !0), k.lineStart(), rA = 0; rA < hA; ++rA) k.point((GA = dA[rA])[0], GA[1]);
            k.lineEnd();
          }
          return;
        }
        uA > 1 && cA & 2 && sA.push(sA.pop().concat(sA.shift())), BA.push(sA.filter(validSegment));
      }
    }
    return iA;
  };
}
function validSegment(n) {
  return n.length > 1;
}
function compareIntersection(n, t) {
  return ((n = n.x)[0] < 0 ? n[1] - halfPi$1 - epsilon$3 : halfPi$1 - n[1]) - ((t = t.x)[0] < 0 ? t[1] - halfPi$1 - epsilon$3 : halfPi$1 - t[1]);
}
const clipAntimeridian = clip$1(
  function() {
    return !0;
  },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-pi$1, -halfPi$1]
);
function clipAntimeridianLine(n) {
  var t = NaN, g = NaN, d = NaN, k;
  return {
    lineStart: function() {
      n.lineStart(), k = 1;
    },
    point: function(H, AA) {
      var gA = H > 0 ? pi$1 : -pi$1, IA = abs$1(H - t);
      abs$1(IA - pi$1) < epsilon$3 ? (n.point(t, g = (g + AA) / 2 > 0 ? halfPi$1 : -halfPi$1), n.point(d, g), n.lineEnd(), n.lineStart(), n.point(gA, g), n.point(H, g), k = 0) : d !== gA && IA >= pi$1 && (abs$1(t - d) < epsilon$3 && (t -= d * epsilon$3), abs$1(H - gA) < epsilon$3 && (H -= gA * epsilon$3), g = clipAntimeridianIntersect(t, g, H, AA), n.point(d, g), n.lineEnd(), n.lineStart(), n.point(gA, g), k = 0), n.point(t = H, g = AA), d = gA;
    },
    lineEnd: function() {
      n.lineEnd(), t = g = NaN;
    },
    clean: function() {
      return 2 - k;
    }
  };
}
function clipAntimeridianIntersect(n, t, g, d) {
  var k, H, AA = sin$1(n - g);
  return abs$1(AA) > epsilon$3 ? atan((sin$1(t) * (H = cos$1(d)) * sin$1(g) - sin$1(d) * (k = cos$1(t)) * sin$1(n)) / (k * H * AA)) : (t + d) / 2;
}
function clipAntimeridianInterpolate(n, t, g, d) {
  var k;
  if (n == null)
    k = g * halfPi$1, d.point(-pi$1, k), d.point(0, k), d.point(pi$1, k), d.point(pi$1, 0), d.point(pi$1, -k), d.point(0, -k), d.point(-pi$1, -k), d.point(-pi$1, 0), d.point(-pi$1, k);
  else if (abs$1(n[0] - t[0]) > epsilon$3) {
    var H = n[0] < t[0] ? pi$1 : -pi$1;
    k = g * H / 2, d.point(-H, k), d.point(0, k), d.point(H, k);
  } else
    d.point(t[0], t[1]);
}
function clipCircle(n) {
  var t = cos$1(n), g = 2 * radians, d = t > 0, k = abs$1(t) > epsilon$3;
  function H(BA, eA, iA, QA) {
    circleStream(QA, n, g, iA, BA, eA);
  }
  function AA(BA, eA) {
    return cos$1(BA) * cos$1(eA) > t;
  }
  function gA(BA) {
    var eA, iA, QA, tA, oA;
    return {
      lineStart: function() {
        tA = QA = !1, oA = 1;
      },
      point: function(EA, aA) {
        var nA = [EA, aA], lA, cA = AA(EA, aA), sA = d ? cA ? 0 : CA(EA, aA) : cA ? CA(EA + (EA < 0 ? pi$1 : -pi$1), aA) : 0;
        if (!eA && (tA = QA = cA) && BA.lineStart(), cA !== QA && (lA = IA(eA, nA), (!lA || pointEqual(eA, lA) || pointEqual(nA, lA)) && (nA[2] = 1)), cA !== QA)
          oA = 0, cA ? (BA.lineStart(), lA = IA(nA, eA), BA.point(lA[0], lA[1])) : (lA = IA(eA, nA), BA.point(lA[0], lA[1], 2), BA.lineEnd()), eA = lA;
        else if (k && eA && d ^ cA) {
          var rA;
          !(sA & iA) && (rA = IA(nA, eA, !0)) && (oA = 0, d ? (BA.lineStart(), BA.point(rA[0][0], rA[0][1]), BA.point(rA[1][0], rA[1][1]), BA.lineEnd()) : (BA.point(rA[1][0], rA[1][1]), BA.lineEnd(), BA.lineStart(), BA.point(rA[0][0], rA[0][1], 3)));
        }
        cA && (!eA || !pointEqual(eA, nA)) && BA.point(nA[0], nA[1]), eA = nA, QA = cA, iA = sA;
      },
      lineEnd: function() {
        QA && BA.lineEnd(), eA = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return oA | (tA && QA) << 1;
      }
    };
  }
  function IA(BA, eA, iA) {
    var QA = cartesian(BA), tA = cartesian(eA), oA = [1, 0, 0], EA = cartesianCross(QA, tA), aA = cartesianDot(EA, EA), nA = EA[0], lA = aA - nA * nA;
    if (!lA) return !iA && BA;
    var cA = t * aA / lA, sA = -t * nA / lA, rA = cartesianCross(oA, EA), uA = cartesianScale(oA, cA), hA = cartesianScale(EA, sA);
    cartesianAddInPlace(uA, hA);
    var dA = rA, GA = cartesianDot(uA, dA), DA = cartesianDot(dA, dA), wA = GA * GA - DA * (cartesianDot(uA, uA) - 1);
    if (!(wA < 0)) {
      var bA = sqrt$1(wA), yA = cartesianScale(dA, (-GA - bA) / DA);
      if (cartesianAddInPlace(yA, uA), yA = spherical(yA), !iA) return yA;
      var pA = BA[0], MA = eA[0], LA = BA[1], xA = eA[1], TA;
      MA < pA && (TA = pA, pA = MA, MA = TA);
      var NA = MA - pA, zA = abs$1(NA - pi$1) < epsilon$3, XA = zA || NA < epsilon$3;
      if (!zA && xA < LA && (TA = LA, LA = xA, xA = TA), XA ? zA ? LA + xA > 0 ^ yA[1] < (abs$1(yA[0] - pA) < epsilon$3 ? LA : xA) : LA <= yA[1] && yA[1] <= xA : NA > pi$1 ^ (pA <= yA[0] && yA[0] <= MA)) {
        var fA = cartesianScale(dA, (-GA + bA) / DA);
        return cartesianAddInPlace(fA, uA), [yA, spherical(fA)];
      }
    }
  }
  function CA(BA, eA) {
    var iA = d ? n : pi$1 - n, QA = 0;
    return BA < -iA ? QA |= 1 : BA > iA && (QA |= 2), eA < -iA ? QA |= 4 : eA > iA && (QA |= 8), QA;
  }
  return clip$1(AA, gA, H, d ? [0, -n] : [-pi$1, n - pi$1]);
}
function clipLine(n, t, g, d, k, H) {
  var AA = n[0], gA = n[1], IA = t[0], CA = t[1], BA = 0, eA = 1, iA = IA - AA, QA = CA - gA, tA;
  if (tA = g - AA, !(!iA && tA > 0)) {
    if (tA /= iA, iA < 0) {
      if (tA < BA) return;
      tA < eA && (eA = tA);
    } else if (iA > 0) {
      if (tA > eA) return;
      tA > BA && (BA = tA);
    }
    if (tA = k - AA, !(!iA && tA < 0)) {
      if (tA /= iA, iA < 0) {
        if (tA > eA) return;
        tA > BA && (BA = tA);
      } else if (iA > 0) {
        if (tA < BA) return;
        tA < eA && (eA = tA);
      }
      if (tA = d - gA, !(!QA && tA > 0)) {
        if (tA /= QA, QA < 0) {
          if (tA < BA) return;
          tA < eA && (eA = tA);
        } else if (QA > 0) {
          if (tA > eA) return;
          tA > BA && (BA = tA);
        }
        if (tA = H - gA, !(!QA && tA < 0)) {
          if (tA /= QA, QA < 0) {
            if (tA > eA) return;
            tA > BA && (BA = tA);
          } else if (QA > 0) {
            if (tA < BA) return;
            tA < eA && (eA = tA);
          }
          return BA > 0 && (n[0] = AA + BA * iA, n[1] = gA + BA * QA), eA < 1 && (t[0] = AA + eA * iA, t[1] = gA + eA * QA), !0;
        }
      }
    }
  }
}
var clipMax = 1e9, clipMin = -clipMax;
function clipRectangle(n, t, g, d) {
  function k(CA, BA) {
    return n <= CA && CA <= g && t <= BA && BA <= d;
  }
  function H(CA, BA, eA, iA) {
    var QA = 0, tA = 0;
    if (CA == null || (QA = AA(CA, eA)) !== (tA = AA(BA, eA)) || IA(CA, BA) < 0 ^ eA > 0)
      do
        iA.point(QA === 0 || QA === 3 ? n : g, QA > 1 ? d : t);
      while ((QA = (QA + eA + 4) % 4) !== tA);
    else
      iA.point(BA[0], BA[1]);
  }
  function AA(CA, BA) {
    return abs$1(CA[0] - n) < epsilon$3 ? BA > 0 ? 0 : 3 : abs$1(CA[0] - g) < epsilon$3 ? BA > 0 ? 2 : 1 : abs$1(CA[1] - t) < epsilon$3 ? BA > 0 ? 1 : 0 : BA > 0 ? 3 : 2;
  }
  function gA(CA, BA) {
    return IA(CA.x, BA.x);
  }
  function IA(CA, BA) {
    var eA = AA(CA, 1), iA = AA(BA, 1);
    return eA !== iA ? eA - iA : eA === 0 ? BA[1] - CA[1] : eA === 1 ? CA[0] - BA[0] : eA === 2 ? CA[1] - BA[1] : BA[0] - CA[0];
  }
  return function(CA) {
    var BA = CA, eA = clipBuffer(), iA, QA, tA, oA, EA, aA, nA, lA, cA, sA, rA, uA = {
      point: hA,
      lineStart: wA,
      lineEnd: bA,
      polygonStart: GA,
      polygonEnd: DA
    };
    function hA(pA, MA) {
      k(pA, MA) && BA.point(pA, MA);
    }
    function dA() {
      for (var pA = 0, MA = 0, LA = QA.length; MA < LA; ++MA)
        for (var xA = QA[MA], TA = 1, NA = xA.length, zA = xA[0], XA, fA, vA = zA[0], Cg = zA[1]; TA < NA; ++TA)
          XA = vA, fA = Cg, zA = xA[TA], vA = zA[0], Cg = zA[1], fA <= d ? Cg > d && (vA - XA) * (d - fA) > (Cg - fA) * (n - XA) && ++pA : Cg <= d && (vA - XA) * (d - fA) < (Cg - fA) * (n - XA) && --pA;
      return pA;
    }
    function GA() {
      BA = eA, iA = [], QA = [], rA = !0;
    }
    function DA() {
      var pA = dA(), MA = rA && pA, LA = (iA = merge$4(iA)).length;
      (MA || LA) && (CA.polygonStart(), MA && (CA.lineStart(), H(null, null, 1, CA), CA.lineEnd()), LA && clipRejoin(iA, gA, pA, H, CA), CA.polygonEnd()), BA = CA, iA = QA = tA = null;
    }
    function wA() {
      uA.point = yA, QA && QA.push(tA = []), sA = !0, cA = !1, nA = lA = NaN;
    }
    function bA() {
      iA && (yA(oA, EA), aA && cA && eA.rejoin(), iA.push(eA.result())), uA.point = hA, cA && BA.lineEnd();
    }
    function yA(pA, MA) {
      var LA = k(pA, MA);
      if (QA && tA.push([pA, MA]), sA)
        oA = pA, EA = MA, aA = LA, sA = !1, LA && (BA.lineStart(), BA.point(pA, MA));
      else if (LA && cA) BA.point(pA, MA);
      else {
        var xA = [nA = Math.max(clipMin, Math.min(clipMax, nA)), lA = Math.max(clipMin, Math.min(clipMax, lA))], TA = [pA = Math.max(clipMin, Math.min(clipMax, pA)), MA = Math.max(clipMin, Math.min(clipMax, MA))];
        clipLine(xA, TA, n, t, g, d) ? (cA || (BA.lineStart(), BA.point(xA[0], xA[1])), BA.point(TA[0], TA[1]), LA || BA.lineEnd(), rA = !1) : LA && (BA.lineStart(), BA.point(pA, MA), rA = !1);
      }
      nA = pA, lA = MA, cA = LA;
    }
    return uA;
  };
}
function graticuleX(n, t, g) {
  var d = range$5(n, t - epsilon$3, g).concat(t);
  return function(k) {
    return d.map(function(H) {
      return [k, H];
    });
  };
}
function graticuleY(n, t, g) {
  var d = range$5(n, t - epsilon$3, g).concat(t);
  return function(k) {
    return d.map(function(H) {
      return [H, k];
    });
  };
}
function graticule() {
  var n, t, g, d, k, H, AA, gA, IA = 10, CA = IA, BA = 90, eA = 360, iA, QA, tA, oA, EA = 2.5;
  function aA() {
    return { type: "MultiLineString", coordinates: nA() };
  }
  function nA() {
    return range$5(ceil(d / BA) * BA, g, BA).map(tA).concat(range$5(ceil(gA / eA) * eA, AA, eA).map(oA)).concat(range$5(ceil(t / IA) * IA, n, IA).filter(function(lA) {
      return abs$1(lA % BA) > epsilon$3;
    }).map(iA)).concat(range$5(ceil(H / CA) * CA, k, CA).filter(function(lA) {
      return abs$1(lA % eA) > epsilon$3;
    }).map(QA));
  }
  return aA.lines = function() {
    return nA().map(function(lA) {
      return { type: "LineString", coordinates: lA };
    });
  }, aA.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        tA(d).concat(
          oA(AA).slice(1),
          tA(g).reverse().slice(1),
          oA(gA).reverse().slice(1)
        )
      ]
    };
  }, aA.extent = function(lA) {
    return arguments.length ? aA.extentMajor(lA).extentMinor(lA) : aA.extentMinor();
  }, aA.extentMajor = function(lA) {
    return arguments.length ? (d = +lA[0][0], g = +lA[1][0], gA = +lA[0][1], AA = +lA[1][1], d > g && (lA = d, d = g, g = lA), gA > AA && (lA = gA, gA = AA, AA = lA), aA.precision(EA)) : [[d, gA], [g, AA]];
  }, aA.extentMinor = function(lA) {
    return arguments.length ? (t = +lA[0][0], n = +lA[1][0], H = +lA[0][1], k = +lA[1][1], t > n && (lA = t, t = n, n = lA), H > k && (lA = H, H = k, k = lA), aA.precision(EA)) : [[t, H], [n, k]];
  }, aA.step = function(lA) {
    return arguments.length ? aA.stepMajor(lA).stepMinor(lA) : aA.stepMinor();
  }, aA.stepMajor = function(lA) {
    return arguments.length ? (BA = +lA[0], eA = +lA[1], aA) : [BA, eA];
  }, aA.stepMinor = function(lA) {
    return arguments.length ? (IA = +lA[0], CA = +lA[1], aA) : [IA, CA];
  }, aA.precision = function(lA) {
    return arguments.length ? (EA = +lA, iA = graticuleX(H, k, 90), QA = graticuleY(t, n, EA), tA = graticuleX(gA, AA, 90), oA = graticuleY(d, g, EA), aA) : EA;
  }, aA.extentMajor([[-180, -90 + epsilon$3], [180, 90 - epsilon$3]]).extentMinor([[-180, -80 - epsilon$3], [180, 80 + epsilon$3]]);
}
const identity$2 = (n) => n;
var areaSum = new Adder(), areaRingSum = new Adder(), x00$2, y00$2, x0$3, y0$3, areaStream = {
  point: noop$4,
  lineStart: noop$4,
  lineEnd: noop$4,
  polygonStart: function() {
    areaStream.lineStart = areaRingStart, areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop$4, areaSum.add(abs$1(areaRingSum)), areaRingSum = new Adder();
  },
  result: function() {
    var n = areaSum / 2;
    return areaSum = new Adder(), n;
  }
};
function areaRingStart() {
  areaStream.point = areaPointFirst;
}
function areaPointFirst(n, t) {
  areaStream.point = areaPoint, x00$2 = x0$3 = n, y00$2 = y0$3 = t;
}
function areaPoint(n, t) {
  areaRingSum.add(y0$3 * n - x0$3 * t), x0$3 = n, y0$3 = t;
}
function areaRingEnd() {
  areaPoint(x00$2, y00$2);
}
var x0$2 = 1 / 0, y0$2 = x0$2, x1 = -x0$2, y1 = x1, boundsStream = {
  point: boundsPoint,
  lineStart: noop$4,
  lineEnd: noop$4,
  polygonStart: noop$4,
  polygonEnd: noop$4,
  result: function() {
    var n = [[x0$2, y0$2], [x1, y1]];
    return x1 = y1 = -(y0$2 = x0$2 = 1 / 0), n;
  }
};
function boundsPoint(n, t) {
  n < x0$2 && (x0$2 = n), n > x1 && (x1 = n), t < y0$2 && (y0$2 = t), t > y1 && (y1 = t);
}
var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2$1 = 0, Y2$1 = 0, Z2 = 0, x00$1, y00$1, x0$1, y0$1, centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart, centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint, centroidStream.lineStart = centroidLineStart, centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var n = Z2 ? [X2$1 / Z2, Y2$1 / Z2] : Z1 ? [X1 / Z1, Y1 / Z1] : Z0 ? [X0 / Z0, Y0 / Z0] : [NaN, NaN];
    return X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2$1 = Y2$1 = Z2 = 0, n;
  }
};
function centroidPoint(n, t) {
  X0 += n, Y0 += t, ++Z0;
}
function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}
function centroidPointFirstLine(n, t) {
  centroidStream.point = centroidPointLine, centroidPoint(x0$1 = n, y0$1 = t);
}
function centroidPointLine(n, t) {
  var g = n - x0$1, d = t - y0$1, k = sqrt$1(g * g + d * d);
  X1 += k * (x0$1 + n) / 2, Y1 += k * (y0$1 + t) / 2, Z1 += k, centroidPoint(x0$1 = n, y0$1 = t);
}
function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}
function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}
function centroidRingEnd() {
  centroidPointRing(x00$1, y00$1);
}
function centroidPointFirstRing(n, t) {
  centroidStream.point = centroidPointRing, centroidPoint(x00$1 = x0$1 = n, y00$1 = y0$1 = t);
}
function centroidPointRing(n, t) {
  var g = n - x0$1, d = t - y0$1, k = sqrt$1(g * g + d * d);
  X1 += k * (x0$1 + n) / 2, Y1 += k * (y0$1 + t) / 2, Z1 += k, k = y0$1 * n - x0$1 * t, X2$1 += k * (x0$1 + n), Y2$1 += k * (y0$1 + t), Z2 += k * 3, centroidPoint(x0$1 = n, y0$1 = t);
}
function PathContext(n) {
  this._context = n;
}
PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(n) {
    return this._radius = n, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._context.closePath(), this._point = NaN;
  },
  point: function(n, t) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(n, t), this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(n, t);
        break;
      }
      default: {
        this._context.moveTo(n + this._radius, t), this._context.arc(n, t, this._radius, 0, tau$1);
        break;
      }
    }
  },
  result: noop$4
};
var lengthSum = new Adder(), lengthRing, x00, y00, x0, y0, lengthStream = {
  point: noop$4,
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    lengthRing && lengthPoint(x00, y00), lengthStream.point = noop$4;
  },
  polygonStart: function() {
    lengthRing = !0;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var n = +lengthSum;
    return lengthSum = new Adder(), n;
  }
};
function lengthPointFirst(n, t) {
  lengthStream.point = lengthPoint, x00 = x0 = n, y00 = y0 = t;
}
function lengthPoint(n, t) {
  x0 -= n, y0 -= t, lengthSum.add(sqrt$1(x0 * x0 + y0 * y0)), x0 = n, y0 = t;
}
let cacheDigits, cacheAppend, cacheRadius, cacheCircle;
class PathString {
  constructor(t) {
    this._append = t == null ? append : appendRound(t), this._radius = 4.5, this._ = "";
  }
  pointRadius(t) {
    return this._radius = +t, this;
  }
  polygonStart() {
    this._line = 0;
  }
  polygonEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    this._line === 0 && (this._ += "Z"), this._point = NaN;
  }
  point(t, g) {
    switch (this._point) {
      case 0: {
        this._append`M${t},${g}`, this._point = 1;
        break;
      }
      case 1: {
        this._append`L${t},${g}`;
        break;
      }
      default: {
        if (this._append`M${t},${g}`, this._radius !== cacheRadius || this._append !== cacheAppend) {
          const d = this._radius, k = this._;
          this._ = "", this._append`m0,${d}a${d},${d} 0 1,1 0,${-2 * d}a${d},${d} 0 1,1 0,${2 * d}z`, cacheRadius = d, cacheAppend = this._append, cacheCircle = this._, this._ = k;
        }
        this._ += cacheCircle;
        break;
      }
    }
  }
  result() {
    const t = this._;
    return this._ = "", t.length ? t : null;
  }
}
function append(n) {
  let t = 1;
  this._ += n[0];
  for (const g = n.length; t < g; ++t)
    this._ += arguments[t] + n[t];
}
function appendRound(n) {
  const t = Math.floor(n);
  if (!(t >= 0)) throw new RangeError(`invalid digits: ${n}`);
  if (t > 15) return append;
  if (t !== cacheDigits) {
    const g = 10 ** t;
    cacheDigits = t, cacheAppend = function(k) {
      let H = 1;
      this._ += k[0];
      for (const AA = k.length; H < AA; ++H)
        this._ += Math.round(arguments[H] * g) / g + k[H];
    };
  }
  return cacheAppend;
}
function geoPath(n, t) {
  let g = 3, d = 4.5, k, H;
  function AA(gA) {
    return gA && (typeof d == "function" && H.pointRadius(+d.apply(this, arguments)), geoStream(gA, k(H))), H.result();
  }
  return AA.area = function(gA) {
    return geoStream(gA, k(areaStream)), areaStream.result();
  }, AA.measure = function(gA) {
    return geoStream(gA, k(lengthStream)), lengthStream.result();
  }, AA.bounds = function(gA) {
    return geoStream(gA, k(boundsStream)), boundsStream.result();
  }, AA.centroid = function(gA) {
    return geoStream(gA, k(centroidStream)), centroidStream.result();
  }, AA.projection = function(gA) {
    return arguments.length ? (k = gA == null ? (n = null, identity$2) : (n = gA).stream, AA) : n;
  }, AA.context = function(gA) {
    return arguments.length ? (H = gA == null ? (t = null, new PathString(g)) : new PathContext(t = gA), typeof d != "function" && H.pointRadius(d), AA) : t;
  }, AA.pointRadius = function(gA) {
    return arguments.length ? (d = typeof gA == "function" ? gA : (H.pointRadius(+gA), +gA), AA) : d;
  }, AA.digits = function(gA) {
    if (!arguments.length) return g;
    if (gA == null) g = null;
    else {
      const IA = Math.floor(gA);
      if (!(IA >= 0)) throw new RangeError(`invalid digits: ${gA}`);
      g = IA;
    }
    return t === null && (H = new PathString(g)), AA;
  }, AA.projection(n).digits(g).context(t);
}
function transformer(n) {
  return function(t) {
    var g = new TransformStream();
    for (var d in n) g[d] = n[d];
    return g.stream = t, g;
  };
}
function TransformStream() {
}
TransformStream.prototype = {
  constructor: TransformStream,
  point: function(n, t) {
    this.stream.point(n, t);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function fit$1(n, t, g) {
  var d = n.clipExtent && n.clipExtent();
  return n.scale(150).translate([0, 0]), d != null && n.clipExtent(null), geoStream(g, n.stream(boundsStream)), t(boundsStream.result()), d != null && n.clipExtent(d), n;
}
function fitExtent(n, t, g) {
  return fit$1(n, function(d) {
    var k = t[1][0] - t[0][0], H = t[1][1] - t[0][1], AA = Math.min(k / (d[1][0] - d[0][0]), H / (d[1][1] - d[0][1])), gA = +t[0][0] + (k - AA * (d[1][0] + d[0][0])) / 2, IA = +t[0][1] + (H - AA * (d[1][1] + d[0][1])) / 2;
    n.scale(150 * AA).translate([gA, IA]);
  }, g);
}
function fitSize(n, t, g) {
  return fitExtent(n, [[0, 0], t], g);
}
function fitWidth(n, t, g) {
  return fit$1(n, function(d) {
    var k = +t, H = k / (d[1][0] - d[0][0]), AA = (k - H * (d[1][0] + d[0][0])) / 2, gA = -H * d[0][1];
    n.scale(150 * H).translate([AA, gA]);
  }, g);
}
function fitHeight(n, t, g) {
  return fit$1(n, function(d) {
    var k = +t, H = k / (d[1][1] - d[0][1]), AA = -H * d[0][0], gA = (k - H * (d[1][1] + d[0][1])) / 2;
    n.scale(150 * H).translate([AA, gA]);
  }, g);
}
var maxDepth = 16, cosMinDistance = cos$1(30 * radians);
function resample(n, t) {
  return +t ? resample$1(n, t) : resampleNone(n);
}
function resampleNone(n) {
  return transformer({
    point: function(t, g) {
      t = n(t, g), this.stream.point(t[0], t[1]);
    }
  });
}
function resample$1(n, t) {
  function g(d, k, H, AA, gA, IA, CA, BA, eA, iA, QA, tA, oA, EA) {
    var aA = CA - d, nA = BA - k, lA = aA * aA + nA * nA;
    if (lA > 4 * t && oA--) {
      var cA = AA + iA, sA = gA + QA, rA = IA + tA, uA = sqrt$1(cA * cA + sA * sA + rA * rA), hA = asin$1(rA /= uA), dA = abs$1(abs$1(rA) - 1) < epsilon$3 || abs$1(H - eA) < epsilon$3 ? (H + eA) / 2 : atan2(sA, cA), GA = n(dA, hA), DA = GA[0], wA = GA[1], bA = DA - d, yA = wA - k, pA = nA * bA - aA * yA;
      (pA * pA / lA > t || abs$1((aA * bA + nA * yA) / lA - 0.5) > 0.3 || AA * iA + gA * QA + IA * tA < cosMinDistance) && (g(d, k, H, AA, gA, IA, DA, wA, dA, cA /= uA, sA /= uA, rA, oA, EA), EA.point(DA, wA), g(DA, wA, dA, cA, sA, rA, CA, BA, eA, iA, QA, tA, oA, EA));
    }
  }
  return function(d) {
    var k, H, AA, gA, IA, CA, BA, eA, iA, QA, tA, oA, EA = {
      point: aA,
      lineStart: nA,
      lineEnd: cA,
      polygonStart: function() {
        d.polygonStart(), EA.lineStart = sA;
      },
      polygonEnd: function() {
        d.polygonEnd(), EA.lineStart = nA;
      }
    };
    function aA(hA, dA) {
      hA = n(hA, dA), d.point(hA[0], hA[1]);
    }
    function nA() {
      eA = NaN, EA.point = lA, d.lineStart();
    }
    function lA(hA, dA) {
      var GA = cartesian([hA, dA]), DA = n(hA, dA);
      g(eA, iA, BA, QA, tA, oA, eA = DA[0], iA = DA[1], BA = hA, QA = GA[0], tA = GA[1], oA = GA[2], maxDepth, d), d.point(eA, iA);
    }
    function cA() {
      EA.point = aA, d.lineEnd();
    }
    function sA() {
      nA(), EA.point = rA, EA.lineEnd = uA;
    }
    function rA(hA, dA) {
      lA(k = hA, dA), H = eA, AA = iA, gA = QA, IA = tA, CA = oA, EA.point = lA;
    }
    function uA() {
      g(eA, iA, BA, QA, tA, oA, H, AA, k, gA, IA, CA, maxDepth, d), EA.lineEnd = cA, cA();
    }
    return EA;
  };
}
var transformRadians = transformer({
  point: function(n, t) {
    this.stream.point(n * radians, t * radians);
  }
});
function transformRotate(n) {
  return transformer({
    point: function(t, g) {
      var d = n(t, g);
      return this.stream.point(d[0], d[1]);
    }
  });
}
function scaleTranslate(n, t, g, d, k) {
  function H(AA, gA) {
    return AA *= d, gA *= k, [t + n * AA, g - n * gA];
  }
  return H.invert = function(AA, gA) {
    return [(AA - t) / n * d, (g - gA) / n * k];
  }, H;
}
function scaleTranslateRotate(n, t, g, d, k, H) {
  if (!H) return scaleTranslate(n, t, g, d, k);
  var AA = cos$1(H), gA = sin$1(H), IA = AA * n, CA = gA * n, BA = AA / n, eA = gA / n, iA = (gA * g - AA * t) / n, QA = (gA * t + AA * g) / n;
  function tA(oA, EA) {
    return oA *= d, EA *= k, [IA * oA - CA * EA + t, g - CA * oA - IA * EA];
  }
  return tA.invert = function(oA, EA) {
    return [d * (BA * oA - eA * EA + iA), k * (QA - eA * oA - BA * EA)];
  }, tA;
}
function projection$1(n) {
  return projectionMutator(function() {
    return n;
  })();
}
function projectionMutator(n) {
  var t, g = 150, d = 480, k = 250, H = 0, AA = 0, gA = 0, IA = 0, CA = 0, BA, eA = 0, iA = 1, QA = 1, tA = null, oA = clipAntimeridian, EA = null, aA, nA, lA, cA = identity$2, sA = 0.5, rA, uA, hA, dA, GA;
  function DA(pA) {
    return hA(pA[0] * radians, pA[1] * radians);
  }
  function wA(pA) {
    return pA = hA.invert(pA[0], pA[1]), pA && [pA[0] * degrees, pA[1] * degrees];
  }
  DA.stream = function(pA) {
    return dA && GA === pA ? dA : dA = transformRadians(transformRotate(BA)(oA(rA(cA(GA = pA)))));
  }, DA.preclip = function(pA) {
    return arguments.length ? (oA = pA, tA = void 0, yA()) : oA;
  }, DA.postclip = function(pA) {
    return arguments.length ? (cA = pA, EA = aA = nA = lA = null, yA()) : cA;
  }, DA.clipAngle = function(pA) {
    return arguments.length ? (oA = +pA ? clipCircle(tA = pA * radians) : (tA = null, clipAntimeridian), yA()) : tA * degrees;
  }, DA.clipExtent = function(pA) {
    return arguments.length ? (cA = pA == null ? (EA = aA = nA = lA = null, identity$2) : clipRectangle(EA = +pA[0][0], aA = +pA[0][1], nA = +pA[1][0], lA = +pA[1][1]), yA()) : EA == null ? null : [[EA, aA], [nA, lA]];
  }, DA.scale = function(pA) {
    return arguments.length ? (g = +pA, bA()) : g;
  }, DA.translate = function(pA) {
    return arguments.length ? (d = +pA[0], k = +pA[1], bA()) : [d, k];
  }, DA.center = function(pA) {
    return arguments.length ? (H = pA[0] % 360 * radians, AA = pA[1] % 360 * radians, bA()) : [H * degrees, AA * degrees];
  }, DA.rotate = function(pA) {
    return arguments.length ? (gA = pA[0] % 360 * radians, IA = pA[1] % 360 * radians, CA = pA.length > 2 ? pA[2] % 360 * radians : 0, bA()) : [gA * degrees, IA * degrees, CA * degrees];
  }, DA.angle = function(pA) {
    return arguments.length ? (eA = pA % 360 * radians, bA()) : eA * degrees;
  }, DA.reflectX = function(pA) {
    return arguments.length ? (iA = pA ? -1 : 1, bA()) : iA < 0;
  }, DA.reflectY = function(pA) {
    return arguments.length ? (QA = pA ? -1 : 1, bA()) : QA < 0;
  }, DA.precision = function(pA) {
    return arguments.length ? (rA = resample(uA, sA = pA * pA), yA()) : sqrt$1(sA);
  }, DA.fitExtent = function(pA, MA) {
    return fitExtent(DA, pA, MA);
  }, DA.fitSize = function(pA, MA) {
    return fitSize(DA, pA, MA);
  }, DA.fitWidth = function(pA, MA) {
    return fitWidth(DA, pA, MA);
  }, DA.fitHeight = function(pA, MA) {
    return fitHeight(DA, pA, MA);
  };
  function bA() {
    var pA = scaleTranslateRotate(g, 0, 0, iA, QA, eA).apply(null, t(H, AA)), MA = scaleTranslateRotate(g, d - pA[0], k - pA[1], iA, QA, eA);
    return BA = rotateRadians(gA, IA, CA), uA = compose(t, MA), hA = compose(BA, uA), rA = resample(uA, sA), yA();
  }
  function yA() {
    return dA = GA = null, DA;
  }
  return function() {
    return t = n.apply(this, arguments), DA.invert = t.invert && wA, bA();
  };
}
function conicProjection(n) {
  var t = 0, g = pi$1 / 3, d = projectionMutator(n), k = d(t, g);
  return k.parallels = function(H) {
    return arguments.length ? d(t = H[0] * radians, g = H[1] * radians) : [t * degrees, g * degrees];
  }, k;
}
function cylindricalEqualAreaRaw(n) {
  var t = cos$1(n);
  function g(d, k) {
    return [d * t, sin$1(k) / t];
  }
  return g.invert = function(d, k) {
    return [d / t, asin$1(k * t)];
  }, g;
}
function conicEqualAreaRaw(n, t) {
  var g = sin$1(n), d = (g + sin$1(t)) / 2;
  if (abs$1(d) < epsilon$3) return cylindricalEqualAreaRaw(n);
  var k = 1 + g * (2 * d - g), H = sqrt$1(k) / d;
  function AA(gA, IA) {
    var CA = sqrt$1(k - 2 * d * sin$1(IA)) / d;
    return [CA * sin$1(gA *= d), H - CA * cos$1(gA)];
  }
  return AA.invert = function(gA, IA) {
    var CA = H - IA, BA = atan2(gA, abs$1(CA)) * sign(CA);
    return CA * d < 0 && (BA -= pi$1 * sign(gA) * sign(CA)), [BA / d, asin$1((k - (gA * gA + CA * CA) * d * d) / (2 * d))];
  }, AA;
}
function geoConicEqualArea() {
  return conicProjection(conicEqualAreaRaw).scale(155.424).center([0, 33.6442]);
}
function geoAlbers() {
  return geoConicEqualArea().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function multiplex(n) {
  var t = n.length;
  return {
    point: function(g, d) {
      for (var k = -1; ++k < t; ) n[k].point(g, d);
    },
    sphere: function() {
      for (var g = -1; ++g < t; ) n[g].sphere();
    },
    lineStart: function() {
      for (var g = -1; ++g < t; ) n[g].lineStart();
    },
    lineEnd: function() {
      for (var g = -1; ++g < t; ) n[g].lineEnd();
    },
    polygonStart: function() {
      for (var g = -1; ++g < t; ) n[g].polygonStart();
    },
    polygonEnd: function() {
      for (var g = -1; ++g < t; ) n[g].polygonEnd();
    }
  };
}
function geoAlbersUsa() {
  var n, t, g = geoAlbers(), d, k = geoConicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), H, AA = geoConicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), gA, IA, CA = { point: function(iA, QA) {
    IA = [iA, QA];
  } };
  function BA(iA) {
    var QA = iA[0], tA = iA[1];
    return IA = null, d.point(QA, tA), IA || (H.point(QA, tA), IA) || (gA.point(QA, tA), IA);
  }
  BA.invert = function(iA) {
    var QA = g.scale(), tA = g.translate(), oA = (iA[0] - tA[0]) / QA, EA = (iA[1] - tA[1]) / QA;
    return (EA >= 0.12 && EA < 0.234 && oA >= -0.425 && oA < -0.214 ? k : EA >= 0.166 && EA < 0.234 && oA >= -0.214 && oA < -0.115 ? AA : g).invert(iA);
  }, BA.stream = function(iA) {
    return n && t === iA ? n : n = multiplex([g.stream(t = iA), k.stream(iA), AA.stream(iA)]);
  }, BA.precision = function(iA) {
    return arguments.length ? (g.precision(iA), k.precision(iA), AA.precision(iA), eA()) : g.precision();
  }, BA.scale = function(iA) {
    return arguments.length ? (g.scale(iA), k.scale(iA * 0.35), AA.scale(iA), BA.translate(g.translate())) : g.scale();
  }, BA.translate = function(iA) {
    if (!arguments.length) return g.translate();
    var QA = g.scale(), tA = +iA[0], oA = +iA[1];
    return d = g.translate(iA).clipExtent([[tA - 0.455 * QA, oA - 0.238 * QA], [tA + 0.455 * QA, oA + 0.238 * QA]]).stream(CA), H = k.translate([tA - 0.307 * QA, oA + 0.201 * QA]).clipExtent([[tA - 0.425 * QA + epsilon$3, oA + 0.12 * QA + epsilon$3], [tA - 0.214 * QA - epsilon$3, oA + 0.234 * QA - epsilon$3]]).stream(CA), gA = AA.translate([tA - 0.205 * QA, oA + 0.212 * QA]).clipExtent([[tA - 0.214 * QA + epsilon$3, oA + 0.166 * QA + epsilon$3], [tA - 0.115 * QA - epsilon$3, oA + 0.234 * QA - epsilon$3]]).stream(CA), eA();
  }, BA.fitExtent = function(iA, QA) {
    return fitExtent(BA, iA, QA);
  }, BA.fitSize = function(iA, QA) {
    return fitSize(BA, iA, QA);
  }, BA.fitWidth = function(iA, QA) {
    return fitWidth(BA, iA, QA);
  }, BA.fitHeight = function(iA, QA) {
    return fitHeight(BA, iA, QA);
  };
  function eA() {
    return n = t = null, BA;
  }
  return BA.scale(1070);
}
function azimuthalRaw(n) {
  return function(t, g) {
    var d = cos$1(t), k = cos$1(g), H = n(d * k);
    return H === 1 / 0 ? [2, 0] : [
      H * k * sin$1(t),
      H * sin$1(g)
    ];
  };
}
function azimuthalInvert(n) {
  return function(t, g) {
    var d = sqrt$1(t * t + g * g), k = n(d), H = sin$1(k), AA = cos$1(k);
    return [
      atan2(t * H, d * AA),
      asin$1(d && g * H / d)
    ];
  };
}
var azimuthalEqualAreaRaw = azimuthalRaw(function(n) {
  return sqrt$1(2 / (1 + n));
});
azimuthalEqualAreaRaw.invert = azimuthalInvert(function(n) {
  return 2 * asin$1(n / 2);
});
function geoAzimuthalEqualArea() {
  return projection$1(azimuthalEqualAreaRaw).scale(124.75).clipAngle(180 - 1e-3);
}
var azimuthalEquidistantRaw = azimuthalRaw(function(n) {
  return (n = acos(n)) && n / sin$1(n);
});
azimuthalEquidistantRaw.invert = azimuthalInvert(function(n) {
  return n;
});
function geoAzimuthalEquidistant() {
  return projection$1(azimuthalEquidistantRaw).scale(79.4188).clipAngle(180 - 1e-3);
}
function mercatorRaw(n, t) {
  return [n, log$2(tan((halfPi$1 + t) / 2))];
}
mercatorRaw.invert = function(n, t) {
  return [n, 2 * atan(exp(t)) - halfPi$1];
};
function geoMercator() {
  return mercatorProjection(mercatorRaw).scale(961 / tau$1);
}
function mercatorProjection(n) {
  var t = projection$1(n), g = t.center, d = t.scale, k = t.translate, H = t.clipExtent, AA = null, gA, IA, CA;
  t.scale = function(eA) {
    return arguments.length ? (d(eA), BA()) : d();
  }, t.translate = function(eA) {
    return arguments.length ? (k(eA), BA()) : k();
  }, t.center = function(eA) {
    return arguments.length ? (g(eA), BA()) : g();
  }, t.clipExtent = function(eA) {
    return arguments.length ? (eA == null ? AA = gA = IA = CA = null : (AA = +eA[0][0], gA = +eA[0][1], IA = +eA[1][0], CA = +eA[1][1]), BA()) : AA == null ? null : [[AA, gA], [IA, CA]];
  };
  function BA() {
    var eA = pi$1 * d(), iA = t(rotation(t.rotate()).invert([0, 0]));
    return H(AA == null ? [[iA[0] - eA, iA[1] - eA], [iA[0] + eA, iA[1] + eA]] : n === mercatorRaw ? [[Math.max(iA[0] - eA, AA), gA], [Math.min(iA[0] + eA, IA), CA]] : [[AA, Math.max(iA[1] - eA, gA)], [IA, Math.min(iA[1] + eA, CA)]]);
  }
  return BA();
}
function tany(n) {
  return tan((halfPi$1 + n) / 2);
}
function conicConformalRaw(n, t) {
  var g = cos$1(n), d = n === t ? sin$1(n) : log$2(g / cos$1(t)) / log$2(tany(t) / tany(n)), k = g * pow$1(tany(n), d) / d;
  if (!d) return mercatorRaw;
  function H(AA, gA) {
    k > 0 ? gA < -halfPi$1 + epsilon$3 && (gA = -halfPi$1 + epsilon$3) : gA > halfPi$1 - epsilon$3 && (gA = halfPi$1 - epsilon$3);
    var IA = k / pow$1(tany(gA), d);
    return [IA * sin$1(d * AA), k - IA * cos$1(d * AA)];
  }
  return H.invert = function(AA, gA) {
    var IA = k - gA, CA = sign(d) * sqrt$1(AA * AA + IA * IA), BA = atan2(AA, abs$1(IA)) * sign(IA);
    return IA * d < 0 && (BA -= pi$1 * sign(AA) * sign(IA)), [BA / d, 2 * atan(pow$1(k / CA, 1 / d)) - halfPi$1];
  }, H;
}
function geoConicConformal() {
  return conicProjection(conicConformalRaw).scale(109.5).parallels([30, 30]);
}
function equirectangularRaw(n, t) {
  return [n, t];
}
equirectangularRaw.invert = equirectangularRaw;
function geoEquirectangular() {
  return projection$1(equirectangularRaw).scale(152.63);
}
function conicEquidistantRaw(n, t) {
  var g = cos$1(n), d = n === t ? sin$1(n) : (g - cos$1(t)) / (t - n), k = g / d + n;
  if (abs$1(d) < epsilon$3) return equirectangularRaw;
  function H(AA, gA) {
    var IA = k - gA, CA = d * AA;
    return [IA * sin$1(CA), k - IA * cos$1(CA)];
  }
  return H.invert = function(AA, gA) {
    var IA = k - gA, CA = atan2(AA, abs$1(IA)) * sign(IA);
    return IA * d < 0 && (CA -= pi$1 * sign(AA) * sign(IA)), [CA / d, k - sign(d) * sqrt$1(AA * AA + IA * IA)];
  }, H;
}
function geoConicEquidistant() {
  return conicProjection(conicEquidistantRaw).scale(131.154).center([0, 13.9389]);
}
var A1 = 1.340264, A2 = -0.081106, A3 = 893e-6, A4 = 3796e-6, M = sqrt$1(3) / 2, iterations = 12;
function equalEarthRaw(n, t) {
  var g = asin$1(M * sin$1(t)), d = g * g, k = d * d * d;
  return [
    n * cos$1(g) / (M * (A1 + 3 * A2 * d + k * (7 * A3 + 9 * A4 * d))),
    g * (A1 + A2 * d + k * (A3 + A4 * d))
  ];
}
equalEarthRaw.invert = function(n, t) {
  for (var g = t, d = g * g, k = d * d * d, H = 0, AA, gA, IA; H < iterations && (gA = g * (A1 + A2 * d + k * (A3 + A4 * d)) - t, IA = A1 + 3 * A2 * d + k * (7 * A3 + 9 * A4 * d), g -= AA = gA / IA, d = g * g, k = d * d * d, !(abs$1(AA) < epsilon2)); ++H)
    ;
  return [
    M * n * (A1 + 3 * A2 * d + k * (7 * A3 + 9 * A4 * d)) / cos$1(g),
    asin$1(sin$1(g) / M)
  ];
};
function geoEqualEarth() {
  return projection$1(equalEarthRaw).scale(177.158);
}
function gnomonicRaw(n, t) {
  var g = cos$1(t), d = cos$1(n) * g;
  return [g * sin$1(n) / d, sin$1(t) / d];
}
gnomonicRaw.invert = azimuthalInvert(atan);
function geoGnomonic() {
  return projection$1(gnomonicRaw).scale(144.049).clipAngle(60);
}
function geoIdentity() {
  var n = 1, t = 0, g = 0, d = 1, k = 1, H = 0, AA, gA, IA = null, CA, BA, eA, iA = 1, QA = 1, tA = transformer({
    point: function(cA, sA) {
      var rA = lA([cA, sA]);
      this.stream.point(rA[0], rA[1]);
    }
  }), oA = identity$2, EA, aA;
  function nA() {
    return iA = n * d, QA = n * k, EA = aA = null, lA;
  }
  function lA(cA) {
    var sA = cA[0] * iA, rA = cA[1] * QA;
    if (H) {
      var uA = rA * AA - sA * gA;
      sA = sA * AA + rA * gA, rA = uA;
    }
    return [sA + t, rA + g];
  }
  return lA.invert = function(cA) {
    var sA = cA[0] - t, rA = cA[1] - g;
    if (H) {
      var uA = rA * AA + sA * gA;
      sA = sA * AA - rA * gA, rA = uA;
    }
    return [sA / iA, rA / QA];
  }, lA.stream = function(cA) {
    return EA && aA === cA ? EA : EA = tA(oA(aA = cA));
  }, lA.postclip = function(cA) {
    return arguments.length ? (oA = cA, IA = CA = BA = eA = null, nA()) : oA;
  }, lA.clipExtent = function(cA) {
    return arguments.length ? (oA = cA == null ? (IA = CA = BA = eA = null, identity$2) : clipRectangle(IA = +cA[0][0], CA = +cA[0][1], BA = +cA[1][0], eA = +cA[1][1]), nA()) : IA == null ? null : [[IA, CA], [BA, eA]];
  }, lA.scale = function(cA) {
    return arguments.length ? (n = +cA, nA()) : n;
  }, lA.translate = function(cA) {
    return arguments.length ? (t = +cA[0], g = +cA[1], nA()) : [t, g];
  }, lA.angle = function(cA) {
    return arguments.length ? (H = cA % 360 * radians, gA = sin$1(H), AA = cos$1(H), nA()) : H * degrees;
  }, lA.reflectX = function(cA) {
    return arguments.length ? (d = cA ? -1 : 1, nA()) : d < 0;
  }, lA.reflectY = function(cA) {
    return arguments.length ? (k = cA ? -1 : 1, nA()) : k < 0;
  }, lA.fitExtent = function(cA, sA) {
    return fitExtent(lA, cA, sA);
  }, lA.fitSize = function(cA, sA) {
    return fitSize(lA, cA, sA);
  }, lA.fitWidth = function(cA, sA) {
    return fitWidth(lA, cA, sA);
  }, lA.fitHeight = function(cA, sA) {
    return fitHeight(lA, cA, sA);
  }, lA;
}
function naturalEarth1Raw(n, t) {
  var g = t * t, d = g * g;
  return [
    n * (0.8707 - 0.131979 * g + d * (-0.013791 + d * (3971e-6 * g - 1529e-6 * d))),
    t * (1.007226 + g * (0.015085 + d * (-0.044475 + 0.028874 * g - 5916e-6 * d)))
  ];
}
naturalEarth1Raw.invert = function(n, t) {
  var g = t, d = 25, k;
  do {
    var H = g * g, AA = H * H;
    g -= k = (g * (1.007226 + H * (0.015085 + AA * (-0.044475 + 0.028874 * H - 5916e-6 * AA))) - t) / (1.007226 + H * (0.015085 * 3 + AA * (-0.044475 * 7 + 0.028874 * 9 * H - 5916e-6 * 11 * AA)));
  } while (abs$1(k) > epsilon$3 && --d > 0);
  return [
    n / (0.8707 + (H = g * g) * (-0.131979 + H * (-0.013791 + H * H * H * (3971e-6 - 1529e-6 * H)))),
    g
  ];
};
function geoNaturalEarth1() {
  return projection$1(naturalEarth1Raw).scale(175.295);
}
function orthographicRaw(n, t) {
  return [cos$1(t) * sin$1(n), sin$1(t)];
}
orthographicRaw.invert = azimuthalInvert(asin$1);
function geoOrthographic() {
  return projection$1(orthographicRaw).scale(249.5).clipAngle(90 + epsilon$3);
}
function stereographicRaw(n, t) {
  var g = cos$1(t), d = 1 + cos$1(n) * g;
  return [g * sin$1(n) / d, sin$1(t) / d];
}
stereographicRaw.invert = azimuthalInvert(function(n) {
  return 2 * atan(n);
});
function geoStereographic() {
  return projection$1(stereographicRaw).scale(250).clipAngle(142);
}
function transverseMercatorRaw(n, t) {
  return [log$2(tan((halfPi$1 + t) / 2)), -n];
}
transverseMercatorRaw.invert = function(n, t) {
  return [-t, 2 * atan(exp(n)) - halfPi$1];
};
function geoTransverseMercator() {
  var n = mercatorProjection(transverseMercatorRaw), t = n.center, g = n.rotate;
  return n.center = function(d) {
    return arguments.length ? t([-d[1], d[0]]) : (d = t(), [d[1], -d[0]]);
  }, n.rotate = function(d) {
    return arguments.length ? g([d[0], d[1], d.length > 2 ? d[2] + 90 : 90]) : (d = g(), [d[0], d[1], d[2] - 90]);
  }, g([0, 0, 90]).scale(159.155);
}
var abs = Math.abs, cos = Math.cos, sin = Math.sin, epsilon$2 = 1e-6, pi = Math.PI, halfPi = pi / 2, sqrt2 = sqrt(2);
function asin(n) {
  return n > 1 ? halfPi : n < -1 ? -halfPi : Math.asin(n);
}
function sqrt(n) {
  return n > 0 ? Math.sqrt(n) : 0;
}
function mollweideBromleyTheta(n, t) {
  var g = n * sin(t), d = 30, k;
  do
    t -= k = (t + sin(t) - g) / (1 + cos(t));
  while (abs(k) > epsilon$2 && --d > 0);
  return t / 2;
}
function mollweideBromleyRaw(n, t, g) {
  function d(k, H) {
    return [n * k * cos(H = mollweideBromleyTheta(g, H)), t * sin(H)];
  }
  return d.invert = function(k, H) {
    return H = asin(H / t), [k / (n * cos(H)), asin((2 * H + sin(2 * H)) / g)];
  }, d;
}
var mollweideRaw = mollweideBromleyRaw(sqrt2 / halfPi, sqrt2, pi);
function geoMollweide() {
  return projection$1(mollweideRaw).scale(169.529);
}
const defaultPath = geoPath(), projectionProperties = [
  // standard properties in d3-geo
  "clipAngle",
  "clipExtent",
  "scale",
  "translate",
  "center",
  "rotate",
  "parallels",
  "precision",
  "reflectX",
  "reflectY",
  // extended properties in d3-geo-projections
  "coefficient",
  "distance",
  "fraction",
  "lobes",
  "parallel",
  "radius",
  "ratio",
  "spacing",
  "tilt"
];
function create$1(n, t) {
  return function g() {
    const d = t();
    return d.type = n, d.path = geoPath().projection(d), d.copy = d.copy || function() {
      const k = g();
      return projectionProperties.forEach((H) => {
        d[H] && k[H](d[H]());
      }), k.path.pointRadius(d.path.pointRadius()), k;
    }, registerScale(d);
  };
}
function projection(n, t) {
  if (!n || typeof n != "string")
    throw new Error("Projection type must be a name string.");
  return n = n.toLowerCase(), arguments.length > 1 ? (projections[n] = create$1(n, t), this) : projections[n] || null;
}
function getProjectionPath(n) {
  return n && n.path || defaultPath;
}
const projections = {
  // base d3-geo projection types
  albers: geoAlbers,
  albersusa: geoAlbersUsa,
  azimuthalequalarea: geoAzimuthalEqualArea,
  azimuthalequidistant: geoAzimuthalEquidistant,
  conicconformal: geoConicConformal,
  conicequalarea: geoConicEqualArea,
  conicequidistant: geoConicEquidistant,
  equalEarth: geoEqualEarth,
  equirectangular: geoEquirectangular,
  gnomonic: geoGnomonic,
  identity: geoIdentity,
  mercator: geoMercator,
  mollweide: geoMollweide,
  naturalEarth1: geoNaturalEarth1,
  orthographic: geoOrthographic,
  stereographic: geoStereographic,
  transversemercator: geoTransverseMercator
};
for (const n in projections)
  projection(n, projections[n]);
function noop$3() {
}
const cases = [[], [[[1, 1.5], [0.5, 1]]], [[[1.5, 1], [1, 1.5]]], [[[1.5, 1], [0.5, 1]]], [[[1, 0.5], [1.5, 1]]], [[[1, 1.5], [0.5, 1]], [[1, 0.5], [1.5, 1]]], [[[1, 0.5], [1, 1.5]]], [[[1, 0.5], [0.5, 1]]], [[[0.5, 1], [1, 0.5]]], [[[1, 1.5], [1, 0.5]]], [[[0.5, 1], [1, 0.5]], [[1.5, 1], [1, 1.5]]], [[[1.5, 1], [1, 0.5]]], [[[0.5, 1], [1.5, 1]]], [[[1, 1.5], [1.5, 1]]], [[[0.5, 1], [1, 1.5]]], []];
function contours() {
  var n = 1, t = 1, g = gA;
  function d(IA, CA) {
    return CA.map((BA) => k(IA, BA));
  }
  function k(IA, CA) {
    var BA = [], eA = [];
    return H(IA, CA, (iA) => {
      g(iA, IA, CA), area$1(iA) > 0 ? BA.push([iA]) : eA.push(iA);
    }), eA.forEach((iA) => {
      for (var QA = 0, tA = BA.length, oA; QA < tA; ++QA)
        if (contains$1((oA = BA[QA])[0], iA) !== -1) {
          oA.push(iA);
          return;
        }
    }), {
      type: "MultiPolygon",
      value: CA,
      coordinates: BA
    };
  }
  function H(IA, CA, BA) {
    var eA = [], iA = [], QA, tA, oA, EA, aA, nA;
    for (QA = tA = -1, EA = IA[0] >= CA, cases[EA << 1].forEach(lA); ++QA < n - 1; )
      oA = EA, EA = IA[QA + 1] >= CA, cases[oA | EA << 1].forEach(lA);
    for (cases[EA << 0].forEach(lA); ++tA < t - 1; ) {
      for (QA = -1, EA = IA[tA * n + n] >= CA, aA = IA[tA * n] >= CA, cases[EA << 1 | aA << 2].forEach(lA); ++QA < n - 1; )
        oA = EA, EA = IA[tA * n + n + QA + 1] >= CA, nA = aA, aA = IA[tA * n + QA + 1] >= CA, cases[oA | EA << 1 | aA << 2 | nA << 3].forEach(lA);
      cases[EA | aA << 3].forEach(lA);
    }
    for (QA = -1, aA = IA[tA * n] >= CA, cases[aA << 2].forEach(lA); ++QA < n - 1; )
      nA = aA, aA = IA[tA * n + QA + 1] >= CA, cases[aA << 2 | nA << 3].forEach(lA);
    cases[aA << 3].forEach(lA);
    function lA(cA) {
      var sA = [cA[0][0] + QA, cA[0][1] + tA], rA = [cA[1][0] + QA, cA[1][1] + tA], uA = AA(sA), hA = AA(rA), dA, GA;
      (dA = iA[uA]) ? (GA = eA[hA]) ? (delete iA[dA.end], delete eA[GA.start], dA === GA ? (dA.ring.push(rA), BA(dA.ring)) : eA[dA.start] = iA[GA.end] = {
        start: dA.start,
        end: GA.end,
        ring: dA.ring.concat(GA.ring)
      }) : (delete iA[dA.end], dA.ring.push(rA), iA[dA.end = hA] = dA) : (dA = eA[hA]) ? (GA = iA[uA]) ? (delete eA[dA.start], delete iA[GA.end], dA === GA ? (dA.ring.push(rA), BA(dA.ring)) : eA[GA.start] = iA[dA.end] = {
        start: GA.start,
        end: dA.end,
        ring: GA.ring.concat(dA.ring)
      }) : (delete eA[dA.start], dA.ring.unshift(sA), eA[dA.start = uA] = dA) : eA[uA] = iA[hA] = {
        start: uA,
        end: hA,
        ring: [sA, rA]
      };
    }
  }
  function AA(IA) {
    return IA[0] * 2 + IA[1] * (n + 1) * 4;
  }
  function gA(IA, CA, BA) {
    IA.forEach((eA) => {
      var iA = eA[0], QA = eA[1], tA = iA | 0, oA = QA | 0, EA, aA = CA[oA * n + tA];
      iA > 0 && iA < n && tA === iA && (EA = CA[oA * n + tA - 1], eA[0] = iA + (BA - EA) / (aA - EA) - 0.5), QA > 0 && QA < t && oA === QA && (EA = CA[(oA - 1) * n + tA], eA[1] = QA + (BA - EA) / (aA - EA) - 0.5);
    });
  }
  return d.contour = k, d.size = function(IA) {
    if (!arguments.length) return [n, t];
    var CA = Math.floor(IA[0]), BA = Math.floor(IA[1]);
    return CA >= 0 && BA >= 0 || error$3("invalid size"), n = CA, t = BA, d;
  }, d.smooth = function(IA) {
    return arguments.length ? (g = IA ? gA : noop$3, d) : g === gA;
  }, d;
}
function area$1(n) {
  for (var t = 0, g = n.length, d = n[g - 1][1] * n[0][0] - n[g - 1][0] * n[0][1]; ++t < g; ) d += n[t - 1][1] * n[t][0] - n[t - 1][0] * n[t][1];
  return d;
}
function contains$1(n, t) {
  for (var g = -1, d = t.length, k; ++g < d; ) if (k = ringContains(n, t[g])) return k;
  return 0;
}
function ringContains(n, t) {
  for (var g = t[0], d = t[1], k = -1, H = 0, AA = n.length, gA = AA - 1; H < AA; gA = H++) {
    var IA = n[H], CA = IA[0], BA = IA[1], eA = n[gA], iA = eA[0], QA = eA[1];
    if (segmentContains(IA, eA, t)) return 0;
    BA > d != QA > d && g < (iA - CA) * (d - BA) / (QA - BA) + CA && (k = -k);
  }
  return k;
}
function segmentContains(n, t, g) {
  var d;
  return collinear$1(n, t, g) && within(n[d = +(n[0] === t[0])], g[d], t[d]);
}
function collinear$1(n, t, g) {
  return (t[0] - n[0]) * (g[1] - n[1]) === (g[0] - n[0]) * (t[1] - n[1]);
}
function within(n, t, g) {
  return n <= t && t <= g || g <= t && t <= n;
}
function quantize(n, t, g) {
  return function(d) {
    var k = extent(d), H = g ? Math.min(k[0], 0) : k[0], AA = k[1], gA = AA - H, IA = t ? tickStep(H, AA, n) : gA / (n + 1);
    return range$5(H + IA, AA, IA);
  };
}
function Isocontour(n) {
  Transform.call(this, null, n);
}
Isocontour.Definition = {
  type: "Isocontour",
  metadata: {
    generates: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "thresholds",
    type: "number",
    array: !0
  }, {
    name: "levels",
    type: "number"
  }, {
    name: "nice",
    type: "boolean",
    default: !1
  }, {
    name: "resolve",
    type: "enum",
    values: ["shared", "independent"],
    default: "independent"
  }, {
    name: "zero",
    type: "boolean",
    default: !0
  }, {
    name: "smooth",
    type: "boolean",
    default: !0
  }, {
    name: "scale",
    type: "number",
    expr: !0
  }, {
    name: "translate",
    type: "number",
    array: !0,
    expr: !0
  }, {
    name: "as",
    type: "string",
    null: !0,
    default: "contour"
  }]
};
inherits$1(Isocontour, Transform, {
  transform(n, t) {
    if (this.value && !t.changed() && !n.modified())
      return t.StopPropagation;
    var g = t.fork(t.NO_SOURCE | t.NO_FIELDS), d = t.materialize(t.SOURCE).source, k = n.field || identity$8, H = contours().smooth(n.smooth !== !1), AA = n.thresholds || levels(d, k, n), gA = n.as === null ? null : n.as || "contour", IA = [];
    return d.forEach((CA) => {
      const BA = k(CA), eA = H.size([BA.width, BA.height])(BA.values, isArray$3(AA) ? AA : AA(BA.values));
      transformPaths(eA, BA, CA, n), eA.forEach((iA) => {
        IA.push(rederive(CA, ingest$1(gA != null ? {
          [gA]: iA
        } : iA)));
      });
    }), this.value && (g.rem = this.value), this.value = g.source = g.add = IA, g;
  }
});
function levels(n, t, g) {
  const d = quantize(g.levels || 10, g.nice, g.zero !== !1);
  return g.resolve !== "shared" ? d : d(n.map((k) => max$2(t(k).values)));
}
function transformPaths(n, t, g, d) {
  let k = d.scale || t.scale, H = d.translate || t.translate;
  if (isFunction$5(k) && (k = k(g, d)), isFunction$5(H) && (H = H(g, d)), (k === 1 || k == null) && !H) return;
  const AA = (isNumber$3(k) ? k : k[0]) || 1, gA = (isNumber$3(k) ? k : k[1]) || 1, IA = H && H[0] || 0, CA = H && H[1] || 0;
  n.forEach(transform$1(t, AA, gA, IA, CA));
}
function transform$1(n, t, g, d, k) {
  const H = n.x1 || 0, AA = n.y1 || 0, gA = t * g < 0;
  function IA(eA) {
    eA.forEach(CA);
  }
  function CA(eA) {
    gA && eA.reverse(), eA.forEach(BA);
  }
  function BA(eA) {
    eA[0] = (eA[0] - H) * t + d, eA[1] = (eA[1] - AA) * g + k;
  }
  return function(eA) {
    return eA.coordinates.forEach(IA), eA;
  };
}
function radius(n, t, g) {
  const d = n >= 0 ? n : estimateBandwidth(t, g);
  return Math.round((Math.sqrt(4 * d * d + 1) - 1) / 2);
}
function number$2(n) {
  return isFunction$5(n) ? n : constant$6(+n);
}
function density2D() {
  var n = (IA) => IA[0], t = (IA) => IA[1], g = one$2, d = [-1, -1], k = 960, H = 500, AA = 2;
  function gA(IA, CA) {
    const BA = radius(d[0], IA, n) >> AA, eA = radius(d[1], IA, t) >> AA, iA = BA ? BA + 2 : 0, QA = eA ? eA + 2 : 0, tA = 2 * iA + (k >> AA), oA = 2 * QA + (H >> AA), EA = new Float32Array(tA * oA), aA = new Float32Array(tA * oA);
    let nA = EA;
    IA.forEach((cA) => {
      const sA = iA + (+n(cA) >> AA), rA = QA + (+t(cA) >> AA);
      sA >= 0 && sA < tA && rA >= 0 && rA < oA && (EA[sA + rA * tA] += +g(cA));
    }), BA > 0 && eA > 0 ? (blurX(tA, oA, EA, aA, BA), blurY(tA, oA, aA, EA, eA), blurX(tA, oA, EA, aA, BA), blurY(tA, oA, aA, EA, eA), blurX(tA, oA, EA, aA, BA), blurY(tA, oA, aA, EA, eA)) : BA > 0 ? (blurX(tA, oA, EA, aA, BA), blurX(tA, oA, aA, EA, BA), blurX(tA, oA, EA, aA, BA), nA = aA) : eA > 0 && (blurY(tA, oA, EA, aA, eA), blurY(tA, oA, aA, EA, eA), blurY(tA, oA, EA, aA, eA), nA = aA);
    const lA = CA ? Math.pow(2, -2 * AA) : 1 / sum$1(nA);
    for (let cA = 0, sA = tA * oA; cA < sA; ++cA) nA[cA] *= lA;
    return {
      values: nA,
      scale: 1 << AA,
      width: tA,
      height: oA,
      x1: iA,
      y1: QA,
      x2: iA + (k >> AA),
      y2: QA + (H >> AA)
    };
  }
  return gA.x = function(IA) {
    return arguments.length ? (n = number$2(IA), gA) : n;
  }, gA.y = function(IA) {
    return arguments.length ? (t = number$2(IA), gA) : t;
  }, gA.weight = function(IA) {
    return arguments.length ? (g = number$2(IA), gA) : g;
  }, gA.size = function(IA) {
    if (!arguments.length) return [k, H];
    var CA = +IA[0], BA = +IA[1];
    return CA >= 0 && BA >= 0 || error$3("invalid size"), k = CA, H = BA, gA;
  }, gA.cellSize = function(IA) {
    return arguments.length ? ((IA = +IA) >= 1 || error$3("invalid cell size"), AA = Math.floor(Math.log(IA) / Math.LN2), gA) : 1 << AA;
  }, gA.bandwidth = function(IA) {
    return arguments.length ? (IA = array$6(IA), IA.length === 1 && (IA = [+IA[0], +IA[0]]), IA.length !== 2 && error$3("invalid bandwidth"), d = IA, gA) : d;
  }, gA;
}
function blurX(n, t, g, d, k) {
  const H = (k << 1) + 1;
  for (let AA = 0; AA < t; ++AA)
    for (let gA = 0, IA = 0; gA < n + k; ++gA)
      gA < n && (IA += g[gA + AA * n]), gA >= k && (gA >= H && (IA -= g[gA - H + AA * n]), d[gA - k + AA * n] = IA / Math.min(gA + 1, n - 1 + H - gA, H));
}
function blurY(n, t, g, d, k) {
  const H = (k << 1) + 1;
  for (let AA = 0; AA < n; ++AA)
    for (let gA = 0, IA = 0; gA < t + k; ++gA)
      gA < t && (IA += g[AA + gA * n]), gA >= k && (gA >= H && (IA -= g[AA + (gA - H) * n]), d[AA + (gA - k) * n] = IA / Math.min(gA + 1, t - 1 + H - gA, H));
}
function KDE2D(n) {
  Transform.call(this, null, n);
}
KDE2D.Definition = {
  type: "KDE2D",
  metadata: {
    generates: !0
  },
  params: [{
    name: "size",
    type: "number",
    array: !0,
    length: 2,
    required: !0
  }, {
    name: "x",
    type: "field",
    required: !0
  }, {
    name: "y",
    type: "field",
    required: !0
  }, {
    name: "weight",
    type: "field"
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "cellSize",
    type: "number"
  }, {
    name: "bandwidth",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "counts",
    type: "boolean",
    default: !1
  }, {
    name: "as",
    type: "string",
    default: "grid"
  }]
};
const PARAMS = ["x", "y", "weight", "size", "cellSize", "bandwidth"];
function params(n, t) {
  return PARAMS.forEach((g) => t[g] != null ? n[g](t[g]) : 0), n;
}
inherits$1(KDE2D, Transform, {
  transform(n, t) {
    if (this.value && !t.changed() && !n.modified()) return t.StopPropagation;
    var g = t.fork(t.NO_SOURCE | t.NO_FIELDS), d = t.materialize(t.SOURCE).source, k = partition$2(d, n.groupby), H = (n.groupby || []).map(accessorName), AA = params(density2D(), n), gA = n.as || "grid", IA = [];
    function CA(BA, eA) {
      for (let iA = 0; iA < H.length; ++iA) BA[H[iA]] = eA[iA];
      return BA;
    }
    return IA = k.map((BA) => ingest$1(CA({
      [gA]: AA(BA, n.counts)
    }, BA.dims))), this.value && (g.rem = this.value), this.value = g.source = g.add = IA, g;
  }
});
function partition$2(n, t) {
  var g = [], d = (BA) => BA(gA), k, H, AA, gA, IA, CA;
  if (t == null)
    g.push(n);
  else
    for (k = {}, H = 0, AA = n.length; H < AA; ++H)
      gA = n[H], IA = t.map(d), CA = k[IA], CA || (k[IA] = CA = [], CA.dims = IA, g.push(CA)), CA.push(gA);
  return g;
}
function Contour(n) {
  Transform.call(this, null, n);
}
Contour.Definition = {
  type: "Contour",
  metadata: {
    generates: !0
  },
  params: [{
    name: "size",
    type: "number",
    array: !0,
    length: 2,
    required: !0
  }, {
    name: "values",
    type: "number",
    array: !0
  }, {
    name: "x",
    type: "field"
  }, {
    name: "y",
    type: "field"
  }, {
    name: "weight",
    type: "field"
  }, {
    name: "cellSize",
    type: "number"
  }, {
    name: "bandwidth",
    type: "number"
  }, {
    name: "count",
    type: "number"
  }, {
    name: "nice",
    type: "boolean",
    default: !1
  }, {
    name: "thresholds",
    type: "number",
    array: !0
  }, {
    name: "smooth",
    type: "boolean",
    default: !0
  }]
};
inherits$1(Contour, Transform, {
  transform(n, t) {
    if (this.value && !t.changed() && !n.modified())
      return t.StopPropagation;
    var g = t.fork(t.NO_SOURCE | t.NO_FIELDS), d = contours().smooth(n.smooth !== !1), k = n.values, H = n.thresholds || quantize(n.count || 10, n.nice, !!k), AA = n.size, gA, IA;
    return k || (k = t.materialize(t.SOURCE).source, gA = params(density2D(), n)(k, !0), IA = transform$1(gA, gA.scale || 1, gA.scale || 1, 0, 0), AA = [gA.width, gA.height], k = gA.values), H = isArray$3(H) ? H : H(k), k = d.size(AA)(k, H), IA && k.forEach(IA), this.value && (g.rem = this.value), this.value = g.source = g.add = (k || []).map(ingest$1), g;
  }
});
const Feature = "Feature", FeatureCollection = "FeatureCollection", MultiPoint = "MultiPoint";
function GeoJSON(n) {
  Transform.call(this, null, n);
}
GeoJSON.Definition = {
  type: "GeoJSON",
  metadata: {},
  params: [{
    name: "fields",
    type: "field",
    array: !0,
    length: 2
  }, {
    name: "geojson",
    type: "field"
  }]
};
inherits$1(GeoJSON, Transform, {
  transform(n, t) {
    var g = this._features, d = this._points, k = n.fields, H = k && k[0], AA = k && k[1], gA = n.geojson || !k && identity$8, IA = t.ADD, CA;
    CA = n.modified() || t.changed(t.REM) || t.modified(accessorFields(gA)) || H && t.modified(accessorFields(H)) || AA && t.modified(accessorFields(AA)), (!this.value || CA) && (IA = t.SOURCE, this._features = g = [], this._points = d = []), gA && t.visit(IA, (BA) => g.push(gA(BA))), H && AA && (t.visit(IA, (BA) => {
      var eA = H(BA), iA = AA(BA);
      eA != null && iA != null && (eA = +eA) === eA && (iA = +iA) === iA && d.push([eA, iA]);
    }), g = g.concat({
      type: Feature,
      geometry: {
        type: MultiPoint,
        coordinates: d
      }
    })), this.value = {
      type: FeatureCollection,
      features: g
    };
  }
});
function GeoPath(n) {
  Transform.call(this, null, n);
}
GeoPath.Definition = {
  type: "GeoPath",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "projection",
    type: "projection"
  }, {
    name: "field",
    type: "field"
  }, {
    name: "pointRadius",
    type: "number",
    expr: !0
  }, {
    name: "as",
    type: "string",
    default: "path"
  }]
};
inherits$1(GeoPath, Transform, {
  transform(n, t) {
    var g = t.fork(t.ALL), d = this.value, k = n.field || identity$8, H = n.as || "path", AA = g.SOURCE;
    !d || n.modified() ? (this.value = d = getProjectionPath(n.projection), g.materialize().reflow()) : AA = k === identity$8 || t.modified(k.fields) ? g.ADD_MOD : g.ADD;
    const gA = initPath(d, n.pointRadius);
    return g.visit(AA, (IA) => IA[H] = d(k(IA))), d.pointRadius(gA), g.modifies(H);
  }
});
function initPath(n, t) {
  const g = n.pointRadius();
  return n.context(null), t != null && n.pointRadius(t), g;
}
function GeoPoint(n) {
  Transform.call(this, null, n);
}
GeoPoint.Definition = {
  type: "GeoPoint",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "projection",
    type: "projection",
    required: !0
  }, {
    name: "fields",
    type: "field",
    array: !0,
    required: !0,
    length: 2
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: ["x", "y"]
  }]
};
inherits$1(GeoPoint, Transform, {
  transform(n, t) {
    var g = n.projection, d = n.fields[0], k = n.fields[1], H = n.as || ["x", "y"], AA = H[0], gA = H[1], IA;
    function CA(BA) {
      const eA = g([d(BA), k(BA)]);
      eA ? (BA[AA] = eA[0], BA[gA] = eA[1]) : (BA[AA] = void 0, BA[gA] = void 0);
    }
    return n.modified() ? t = t.materialize().reflow(!0).visit(t.SOURCE, CA) : (IA = t.modified(d.fields) || t.modified(k.fields), t.visit(IA ? t.ADD_MOD : t.ADD, CA)), t.modifies(H);
  }
});
function GeoShape(n) {
  Transform.call(this, null, n);
}
GeoShape.Definition = {
  type: "GeoShape",
  metadata: {
    modifies: !0,
    nomod: !0
  },
  params: [{
    name: "projection",
    type: "projection"
  }, {
    name: "field",
    type: "field",
    default: "datum"
  }, {
    name: "pointRadius",
    type: "number",
    expr: !0
  }, {
    name: "as",
    type: "string",
    default: "shape"
  }]
};
inherits$1(GeoShape, Transform, {
  transform(n, t) {
    var g = t.fork(t.ALL), d = this.value, k = n.as || "shape", H = g.ADD;
    return (!d || n.modified()) && (this.value = d = shapeGenerator(getProjectionPath(n.projection), n.field || field$4("datum"), n.pointRadius), g.materialize().reflow(), H = g.SOURCE), g.visit(H, (AA) => AA[k] = d), g.modifies(k);
  }
});
function shapeGenerator(n, t, g) {
  const d = g == null ? (k) => n(t(k)) : (k) => {
    var H = n.pointRadius(), AA = n.pointRadius(g)(t(k));
    return n.pointRadius(H), AA;
  };
  return d.context = (k) => (n.context(k), d), d;
}
function Graticule(n) {
  Transform.call(this, [], n), this.generator = graticule();
}
Graticule.Definition = {
  type: "Graticule",
  metadata: {
    changes: !0,
    generates: !0
  },
  params: [{
    name: "extent",
    type: "array",
    array: !0,
    length: 2,
    content: {
      type: "number",
      array: !0,
      length: 2
    }
  }, {
    name: "extentMajor",
    type: "array",
    array: !0,
    length: 2,
    content: {
      type: "number",
      array: !0,
      length: 2
    }
  }, {
    name: "extentMinor",
    type: "array",
    array: !0,
    length: 2,
    content: {
      type: "number",
      array: !0,
      length: 2
    }
  }, {
    name: "step",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "stepMajor",
    type: "number",
    array: !0,
    length: 2,
    default: [90, 360]
  }, {
    name: "stepMinor",
    type: "number",
    array: !0,
    length: 2,
    default: [10, 10]
  }, {
    name: "precision",
    type: "number",
    default: 2.5
  }]
};
inherits$1(Graticule, Transform, {
  transform(n, t) {
    var g = this.value, d = this.generator, k;
    if (!g.length || n.modified())
      for (const H in n)
        isFunction$5(d[H]) && d[H](n[H]);
    return k = d(), g.length ? t.mod.push(replace$1(g[0], k)) : t.add.push(ingest$1(k)), g[0] = k, t;
  }
});
function Heatmap(n) {
  Transform.call(this, null, n);
}
Heatmap.Definition = {
  type: "heatmap",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "color",
    type: "string",
    expr: !0
  }, {
    name: "opacity",
    type: "number",
    expr: !0
  }, {
    name: "resolve",
    type: "enum",
    values: ["shared", "independent"],
    default: "independent"
  }, {
    name: "as",
    type: "string",
    default: "image"
  }]
};
inherits$1(Heatmap, Transform, {
  transform(n, t) {
    if (!t.changed() && !n.modified())
      return t.StopPropagation;
    var g = t.materialize(t.SOURCE).source, d = n.resolve === "shared", k = n.field || identity$8, H = opacity_(n.opacity, n), AA = color_(n.color, n), gA = n.as || "image", IA = {
      $x: 0,
      $y: 0,
      $value: 0,
      $max: d ? max$2(g.map((CA) => max$2(k(CA).values))) : 0
    };
    return g.forEach((CA) => {
      const BA = k(CA), eA = extend$2({}, CA, IA);
      d || (eA.$max = max$2(BA.values || [])), CA[gA] = toCanvas(BA, eA, AA.dep ? AA : constant$6(AA(eA)), H.dep ? H : constant$6(H(eA)));
    }), t.reflow(!0).modifies(gA);
  }
});
function color_(n, t) {
  let g;
  return isFunction$5(n) ? (g = (d) => rgb$1(n(d, t)), g.dep = dependency(n)) : g = constant$6(rgb$1(n || "#888")), g;
}
function opacity_(n, t) {
  let g;
  return isFunction$5(n) ? (g = (d) => n(d, t), g.dep = dependency(n)) : n ? g = constant$6(n) : (g = (d) => d.$value / d.$max || 0, g.dep = !0), g;
}
function dependency(n) {
  if (!isFunction$5(n)) return !1;
  const t = toSet(accessorFields(n));
  return t.$x || t.$y || t.$value || t.$max;
}
function toCanvas(n, t, g, d) {
  const k = n.width, H = n.height, AA = n.x1 || 0, gA = n.y1 || 0, IA = n.x2 || k, CA = n.y2 || H, BA = n.values, eA = BA ? (EA) => BA[EA] : zero$4, iA = domCanvas(IA - AA, CA - gA), QA = iA.getContext("2d"), tA = QA.getImageData(0, 0, IA - AA, CA - gA), oA = tA.data;
  for (let EA = gA, aA = 0; EA < CA; ++EA) {
    t.$y = EA - gA;
    for (let nA = AA, lA = EA * k; nA < IA; ++nA, aA += 4) {
      t.$x = nA - AA, t.$value = eA(nA + lA);
      const cA = g(t);
      oA[aA + 0] = cA.r, oA[aA + 1] = cA.g, oA[aA + 2] = cA.b, oA[aA + 3] = ~~(255 * d(t));
    }
  }
  return QA.putImageData(tA, 0, 0), iA;
}
function Projection$1(n) {
  Transform.call(this, null, n), this.modified(!0);
}
inherits$1(Projection$1, Transform, {
  transform(n, t) {
    let g = this.value;
    return !g || n.modified("type") ? (this.value = g = create(n.type), projectionProperties.forEach((d) => {
      n[d] != null && set$2(g, d, n[d]);
    })) : projectionProperties.forEach((d) => {
      n.modified(d) && set$2(g, d, n[d]);
    }), n.pointRadius != null && g.path.pointRadius(n.pointRadius), n.fit && fit(g, n), t.fork(t.NO_SOURCE | t.NO_FIELDS);
  }
});
function fit(n, t) {
  const g = collectGeoJSON(t.fit);
  t.extent ? n.fitExtent(t.extent, g) : t.size && n.fitSize(t.size, g);
}
function create(n) {
  const t = projection((n || "mercator").toLowerCase());
  return t || error$3("Unrecognized projection type: " + n), t();
}
function set$2(n, t, g) {
  isFunction$5(n[t]) && n[t](g);
}
function collectGeoJSON(n) {
  return n = array$6(n), n.length === 1 ? n[0] : {
    type: FeatureCollection,
    features: n.reduce((t, g) => t.concat(featurize(g)), [])
  };
}
function featurize(n) {
  return n.type === FeatureCollection ? n.features : array$6(n).filter((t) => t != null).map((t) => t.type === Feature ? t : {
    type: Feature,
    geometry: t
  });
}
const geo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  contour: Contour,
  geojson: GeoJSON,
  geopath: GeoPath,
  geopoint: GeoPoint,
  geoshape: GeoShape,
  graticule: Graticule,
  heatmap: Heatmap,
  isocontour: Isocontour,
  kde2d: KDE2D,
  projection: Projection$1
}, Symbol.toStringTag, { value: "Module" }));
function forceCenter(n, t) {
  var g, d = 1;
  n == null && (n = 0), t == null && (t = 0);
  function k() {
    var H, AA = g.length, gA, IA = 0, CA = 0;
    for (H = 0; H < AA; ++H)
      gA = g[H], IA += gA.x, CA += gA.y;
    for (IA = (IA / AA - n) * d, CA = (CA / AA - t) * d, H = 0; H < AA; ++H)
      gA = g[H], gA.x -= IA, gA.y -= CA;
  }
  return k.initialize = function(H) {
    g = H;
  }, k.x = function(H) {
    return arguments.length ? (n = +H, k) : n;
  }, k.y = function(H) {
    return arguments.length ? (t = +H, k) : t;
  }, k.strength = function(H) {
    return arguments.length ? (d = +H, k) : d;
  }, k;
}
function tree_add(n) {
  const t = +this._x.call(null, n), g = +this._y.call(null, n);
  return add$1(this.cover(t, g), t, g, n);
}
function add$1(n, t, g, d) {
  if (isNaN(t) || isNaN(g)) return n;
  var k, H = n._root, AA = { data: d }, gA = n._x0, IA = n._y0, CA = n._x1, BA = n._y1, eA, iA, QA, tA, oA, EA, aA, nA;
  if (!H) return n._root = AA, n;
  for (; H.length; )
    if ((oA = t >= (eA = (gA + CA) / 2)) ? gA = eA : CA = eA, (EA = g >= (iA = (IA + BA) / 2)) ? IA = iA : BA = iA, k = H, !(H = H[aA = EA << 1 | oA])) return k[aA] = AA, n;
  if (QA = +n._x.call(null, H.data), tA = +n._y.call(null, H.data), t === QA && g === tA) return AA.next = H, k ? k[aA] = AA : n._root = AA, n;
  do
    k = k ? k[aA] = new Array(4) : n._root = new Array(4), (oA = t >= (eA = (gA + CA) / 2)) ? gA = eA : CA = eA, (EA = g >= (iA = (IA + BA) / 2)) ? IA = iA : BA = iA;
  while ((aA = EA << 1 | oA) === (nA = (tA >= iA) << 1 | QA >= eA));
  return k[nA] = H, k[aA] = AA, n;
}
function addAll(n) {
  var t, g, d = n.length, k, H, AA = new Array(d), gA = new Array(d), IA = 1 / 0, CA = 1 / 0, BA = -1 / 0, eA = -1 / 0;
  for (g = 0; g < d; ++g)
    isNaN(k = +this._x.call(null, t = n[g])) || isNaN(H = +this._y.call(null, t)) || (AA[g] = k, gA[g] = H, k < IA && (IA = k), k > BA && (BA = k), H < CA && (CA = H), H > eA && (eA = H));
  if (IA > BA || CA > eA) return this;
  for (this.cover(IA, CA).cover(BA, eA), g = 0; g < d; ++g)
    add$1(this, AA[g], gA[g], n[g]);
  return this;
}
function tree_cover(n, t) {
  if (isNaN(n = +n) || isNaN(t = +t)) return this;
  var g = this._x0, d = this._y0, k = this._x1, H = this._y1;
  if (isNaN(g))
    k = (g = Math.floor(n)) + 1, H = (d = Math.floor(t)) + 1;
  else {
    for (var AA = k - g || 1, gA = this._root, IA, CA; g > n || n >= k || d > t || t >= H; )
      switch (CA = (t < d) << 1 | n < g, IA = new Array(4), IA[CA] = gA, gA = IA, AA *= 2, CA) {
        case 0:
          k = g + AA, H = d + AA;
          break;
        case 1:
          g = k - AA, H = d + AA;
          break;
        case 2:
          k = g + AA, d = H - AA;
          break;
        case 3:
          g = k - AA, d = H - AA;
          break;
      }
    this._root && this._root.length && (this._root = gA);
  }
  return this._x0 = g, this._y0 = d, this._x1 = k, this._y1 = H, this;
}
function tree_data() {
  var n = [];
  return this.visit(function(t) {
    if (!t.length) do
      n.push(t.data);
    while (t = t.next);
  }), n;
}
function tree_extent(n) {
  return arguments.length ? this.cover(+n[0][0], +n[0][1]).cover(+n[1][0], +n[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function Quad(n, t, g, d, k) {
  this.node = n, this.x0 = t, this.y0 = g, this.x1 = d, this.y1 = k;
}
function tree_find(n, t, g) {
  var d, k = this._x0, H = this._y0, AA, gA, IA, CA, BA = this._x1, eA = this._y1, iA = [], QA = this._root, tA, oA;
  for (QA && iA.push(new Quad(QA, k, H, BA, eA)), g == null ? g = 1 / 0 : (k = n - g, H = t - g, BA = n + g, eA = t + g, g *= g); tA = iA.pop(); )
    if (!(!(QA = tA.node) || (AA = tA.x0) > BA || (gA = tA.y0) > eA || (IA = tA.x1) < k || (CA = tA.y1) < H))
      if (QA.length) {
        var EA = (AA + IA) / 2, aA = (gA + CA) / 2;
        iA.push(
          new Quad(QA[3], EA, aA, IA, CA),
          new Quad(QA[2], AA, aA, EA, CA),
          new Quad(QA[1], EA, gA, IA, aA),
          new Quad(QA[0], AA, gA, EA, aA)
        ), (oA = (t >= aA) << 1 | n >= EA) && (tA = iA[iA.length - 1], iA[iA.length - 1] = iA[iA.length - 1 - oA], iA[iA.length - 1 - oA] = tA);
      } else {
        var nA = n - +this._x.call(null, QA.data), lA = t - +this._y.call(null, QA.data), cA = nA * nA + lA * lA;
        if (cA < g) {
          var sA = Math.sqrt(g = cA);
          k = n - sA, H = t - sA, BA = n + sA, eA = t + sA, d = QA.data;
        }
      }
  return d;
}
function tree_remove(n) {
  if (isNaN(BA = +this._x.call(null, n)) || isNaN(eA = +this._y.call(null, n))) return this;
  var t, g = this._root, d, k, H, AA = this._x0, gA = this._y0, IA = this._x1, CA = this._y1, BA, eA, iA, QA, tA, oA, EA, aA;
  if (!g) return this;
  if (g.length) for (; ; ) {
    if ((tA = BA >= (iA = (AA + IA) / 2)) ? AA = iA : IA = iA, (oA = eA >= (QA = (gA + CA) / 2)) ? gA = QA : CA = QA, t = g, !(g = g[EA = oA << 1 | tA])) return this;
    if (!g.length) break;
    (t[EA + 1 & 3] || t[EA + 2 & 3] || t[EA + 3 & 3]) && (d = t, aA = EA);
  }
  for (; g.data !== n; ) if (k = g, !(g = g.next)) return this;
  return (H = g.next) && delete g.next, k ? (H ? k.next = H : delete k.next, this) : t ? (H ? t[EA] = H : delete t[EA], (g = t[0] || t[1] || t[2] || t[3]) && g === (t[3] || t[2] || t[1] || t[0]) && !g.length && (d ? d[aA] = g : this._root = g), this) : (this._root = H, this);
}
function removeAll(n) {
  for (var t = 0, g = n.length; t < g; ++t) this.remove(n[t]);
  return this;
}
function tree_root() {
  return this._root;
}
function tree_size() {
  var n = 0;
  return this.visit(function(t) {
    if (!t.length) do
      ++n;
    while (t = t.next);
  }), n;
}
function tree_visit(n) {
  var t = [], g, d = this._root, k, H, AA, gA, IA;
  for (d && t.push(new Quad(d, this._x0, this._y0, this._x1, this._y1)); g = t.pop(); )
    if (!n(d = g.node, H = g.x0, AA = g.y0, gA = g.x1, IA = g.y1) && d.length) {
      var CA = (H + gA) / 2, BA = (AA + IA) / 2;
      (k = d[3]) && t.push(new Quad(k, CA, BA, gA, IA)), (k = d[2]) && t.push(new Quad(k, H, BA, CA, IA)), (k = d[1]) && t.push(new Quad(k, CA, AA, gA, BA)), (k = d[0]) && t.push(new Quad(k, H, AA, CA, BA));
    }
  return this;
}
function tree_visitAfter(n) {
  var t = [], g = [], d;
  for (this._root && t.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1)); d = t.pop(); ) {
    var k = d.node;
    if (k.length) {
      var H, AA = d.x0, gA = d.y0, IA = d.x1, CA = d.y1, BA = (AA + IA) / 2, eA = (gA + CA) / 2;
      (H = k[0]) && t.push(new Quad(H, AA, gA, BA, eA)), (H = k[1]) && t.push(new Quad(H, BA, gA, IA, eA)), (H = k[2]) && t.push(new Quad(H, AA, eA, BA, CA)), (H = k[3]) && t.push(new Quad(H, BA, eA, IA, CA));
    }
    g.push(d);
  }
  for (; d = g.pop(); )
    n(d.node, d.x0, d.y0, d.x1, d.y1);
  return this;
}
function defaultX(n) {
  return n[0];
}
function tree_x(n) {
  return arguments.length ? (this._x = n, this) : this._x;
}
function defaultY(n) {
  return n[1];
}
function tree_y(n) {
  return arguments.length ? (this._y = n, this) : this._y;
}
function quadtree(n, t, g) {
  var d = new Quadtree(t ?? defaultX, g ?? defaultY, NaN, NaN, NaN, NaN);
  return n == null ? d : d.addAll(n);
}
function Quadtree(n, t, g, d, k, H) {
  this._x = n, this._y = t, this._x0 = g, this._y0 = d, this._x1 = k, this._y1 = H, this._root = void 0;
}
function leaf_copy(n) {
  for (var t = { data: n.data }, g = t; n = n.next; ) g = g.next = { data: n.data };
  return t;
}
var treeProto = quadtree.prototype = Quadtree.prototype;
treeProto.copy = function() {
  var n = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), t = this._root, g, d;
  if (!t) return n;
  if (!t.length) return n._root = leaf_copy(t), n;
  for (g = [{ source: t, target: n._root = new Array(4) }]; t = g.pop(); )
    for (var k = 0; k < 4; ++k)
      (d = t.source[k]) && (d.length ? g.push({ source: d, target: t.target[k] = new Array(4) }) : t.target[k] = leaf_copy(d));
  return n;
};
treeProto.add = tree_add;
treeProto.addAll = addAll;
treeProto.cover = tree_cover;
treeProto.data = tree_data;
treeProto.extent = tree_extent;
treeProto.find = tree_find;
treeProto.remove = tree_remove;
treeProto.removeAll = removeAll;
treeProto.root = tree_root;
treeProto.size = tree_size;
treeProto.visit = tree_visit;
treeProto.visitAfter = tree_visitAfter;
treeProto.x = tree_x;
treeProto.y = tree_y;
function constant$2(n) {
  return function() {
    return n;
  };
}
function jiggle(n) {
  return (n() - 0.5) * 1e-6;
}
function x$1(n) {
  return n.x + n.vx;
}
function y$2(n) {
  return n.y + n.vy;
}
function forceCollide(n) {
  var t, g, d, k = 1, H = 1;
  typeof n != "function" && (n = constant$2(n == null ? 1 : +n));
  function AA() {
    for (var CA, BA = t.length, eA, iA, QA, tA, oA, EA, aA = 0; aA < H; ++aA)
      for (eA = quadtree(t, x$1, y$2).visitAfter(gA), CA = 0; CA < BA; ++CA)
        iA = t[CA], oA = g[iA.index], EA = oA * oA, QA = iA.x + iA.vx, tA = iA.y + iA.vy, eA.visit(nA);
    function nA(lA, cA, sA, rA, uA) {
      var hA = lA.data, dA = lA.r, GA = oA + dA;
      if (hA) {
        if (hA.index > iA.index) {
          var DA = QA - hA.x - hA.vx, wA = tA - hA.y - hA.vy, bA = DA * DA + wA * wA;
          bA < GA * GA && (DA === 0 && (DA = jiggle(d), bA += DA * DA), wA === 0 && (wA = jiggle(d), bA += wA * wA), bA = (GA - (bA = Math.sqrt(bA))) / bA * k, iA.vx += (DA *= bA) * (GA = (dA *= dA) / (EA + dA)), iA.vy += (wA *= bA) * GA, hA.vx -= DA * (GA = 1 - GA), hA.vy -= wA * GA);
        }
        return;
      }
      return cA > QA + GA || rA < QA - GA || sA > tA + GA || uA < tA - GA;
    }
  }
  function gA(CA) {
    if (CA.data) return CA.r = g[CA.data.index];
    for (var BA = CA.r = 0; BA < 4; ++BA)
      CA[BA] && CA[BA].r > CA.r && (CA.r = CA[BA].r);
  }
  function IA() {
    if (t) {
      var CA, BA = t.length, eA;
      for (g = new Array(BA), CA = 0; CA < BA; ++CA) eA = t[CA], g[eA.index] = +n(eA, CA, t);
    }
  }
  return AA.initialize = function(CA, BA) {
    t = CA, d = BA, IA();
  }, AA.iterations = function(CA) {
    return arguments.length ? (H = +CA, AA) : H;
  }, AA.strength = function(CA) {
    return arguments.length ? (k = +CA, AA) : k;
  }, AA.radius = function(CA) {
    return arguments.length ? (n = typeof CA == "function" ? CA : constant$2(+CA), IA(), AA) : n;
  }, AA;
}
function index$3(n) {
  return n.index;
}
function find$1(n, t) {
  var g = n.get(t);
  if (!g) throw new Error("node not found: " + t);
  return g;
}
function forceLink(n) {
  var t = index$3, g = eA, d, k = constant$2(30), H, AA, gA, IA, CA, BA = 1;
  n == null && (n = []);
  function eA(EA) {
    return 1 / Math.min(gA[EA.source.index], gA[EA.target.index]);
  }
  function iA(EA) {
    for (var aA = 0, nA = n.length; aA < BA; ++aA)
      for (var lA = 0, cA, sA, rA, uA, hA, dA, GA; lA < nA; ++lA)
        cA = n[lA], sA = cA.source, rA = cA.target, uA = rA.x + rA.vx - sA.x - sA.vx || jiggle(CA), hA = rA.y + rA.vy - sA.y - sA.vy || jiggle(CA), dA = Math.sqrt(uA * uA + hA * hA), dA = (dA - H[lA]) / dA * EA * d[lA], uA *= dA, hA *= dA, rA.vx -= uA * (GA = IA[lA]), rA.vy -= hA * GA, sA.vx += uA * (GA = 1 - GA), sA.vy += hA * GA;
  }
  function QA() {
    if (AA) {
      var EA, aA = AA.length, nA = n.length, lA = new Map(AA.map((sA, rA) => [t(sA, rA, AA), sA])), cA;
      for (EA = 0, gA = new Array(aA); EA < nA; ++EA)
        cA = n[EA], cA.index = EA, typeof cA.source != "object" && (cA.source = find$1(lA, cA.source)), typeof cA.target != "object" && (cA.target = find$1(lA, cA.target)), gA[cA.source.index] = (gA[cA.source.index] || 0) + 1, gA[cA.target.index] = (gA[cA.target.index] || 0) + 1;
      for (EA = 0, IA = new Array(nA); EA < nA; ++EA)
        cA = n[EA], IA[EA] = gA[cA.source.index] / (gA[cA.source.index] + gA[cA.target.index]);
      d = new Array(nA), tA(), H = new Array(nA), oA();
    }
  }
  function tA() {
    if (AA)
      for (var EA = 0, aA = n.length; EA < aA; ++EA)
        d[EA] = +g(n[EA], EA, n);
  }
  function oA() {
    if (AA)
      for (var EA = 0, aA = n.length; EA < aA; ++EA)
        H[EA] = +k(n[EA], EA, n);
  }
  return iA.initialize = function(EA, aA) {
    AA = EA, CA = aA, QA();
  }, iA.links = function(EA) {
    return arguments.length ? (n = EA, QA(), iA) : n;
  }, iA.id = function(EA) {
    return arguments.length ? (t = EA, iA) : t;
  }, iA.iterations = function(EA) {
    return arguments.length ? (BA = +EA, iA) : BA;
  }, iA.strength = function(EA) {
    return arguments.length ? (g = typeof EA == "function" ? EA : constant$2(+EA), tA(), iA) : g;
  }, iA.distance = function(EA) {
    return arguments.length ? (k = typeof EA == "function" ? EA : constant$2(+EA), oA(), iA) : k;
  }, iA;
}
var noop$2 = { value: () => {
} };
function dispatch$1() {
  for (var n = 0, t = arguments.length, g = {}, d; n < t; ++n) {
    if (!(d = arguments[n] + "") || d in g || /[\s.]/.test(d)) throw new Error("illegal type: " + d);
    g[d] = [];
  }
  return new Dispatch(g);
}
function Dispatch(n) {
  this._ = n;
}
function parseTypenames(n, t) {
  return n.trim().split(/^|\s+/).map(function(g) {
    var d = "", k = g.indexOf(".");
    if (k >= 0 && (d = g.slice(k + 1), g = g.slice(0, k)), g && !t.hasOwnProperty(g)) throw new Error("unknown type: " + g);
    return { type: g, name: d };
  });
}
Dispatch.prototype = dispatch$1.prototype = {
  constructor: Dispatch,
  on: function(n, t) {
    var g = this._, d = parseTypenames(n + "", g), k, H = -1, AA = d.length;
    if (arguments.length < 2) {
      for (; ++H < AA; ) if ((k = (n = d[H]).type) && (k = get$2(g[k], n.name))) return k;
      return;
    }
    if (t != null && typeof t != "function") throw new Error("invalid callback: " + t);
    for (; ++H < AA; )
      if (k = (n = d[H]).type) g[k] = set$1(g[k], n.name, t);
      else if (t == null) for (k in g) g[k] = set$1(g[k], n.name, null);
    return this;
  },
  copy: function() {
    var n = {}, t = this._;
    for (var g in t) n[g] = t[g].slice();
    return new Dispatch(n);
  },
  call: function(n, t) {
    if ((k = arguments.length - 2) > 0) for (var g = new Array(k), d = 0, k, H; d < k; ++d) g[d] = arguments[d + 2];
    if (!this._.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    for (H = this._[n], d = 0, k = H.length; d < k; ++d) H[d].value.apply(t, g);
  },
  apply: function(n, t, g) {
    if (!this._.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    for (var d = this._[n], k = 0, H = d.length; k < H; ++k) d[k].value.apply(t, g);
  }
};
function get$2(n, t) {
  for (var g = 0, d = n.length, k; g < d; ++g)
    if ((k = n[g]).name === t)
      return k.value;
}
function set$1(n, t, g) {
  for (var d = 0, k = n.length; d < k; ++d)
    if (n[d].name === t) {
      n[d] = noop$2, n = n.slice(0, d).concat(n.slice(d + 1));
      break;
    }
  return g != null && n.push({ name: t, value: g }), n;
}
var frame = 0, timeout = 0, interval$2 = 0, pokeDelay = 1e3, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance == "object" && performance.now ? performance : Date, setFrame = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(n) {
  setTimeout(n, 17);
};
function now$2() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
  clockNow = 0;
}
function Timer$2() {
  this._call = this._time = this._next = null;
}
Timer$2.prototype = timer$1.prototype = {
  constructor: Timer$2,
  restart: function(n, t, g) {
    if (typeof n != "function") throw new TypeError("callback is not a function");
    g = (g == null ? now$2() : +g) + (t == null ? 0 : +t), !this._next && taskTail !== this && (taskTail ? taskTail._next = this : taskHead = this, taskTail = this), this._call = n, this._time = g, sleep();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, sleep());
  }
};
function timer$1(n, t, g) {
  var d = new Timer$2();
  return d.restart(n, t, g), d;
}
function timerFlush() {
  now$2(), ++frame;
  for (var n = taskHead, t; n; )
    (t = clockNow - n._time) >= 0 && n._call.call(void 0, t), n = n._next;
  --frame;
}
function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew, frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0, nap(), clockNow = 0;
  }
}
function poke() {
  var n = clock.now(), t = n - clockLast;
  t > pokeDelay && (clockSkew -= t, clockLast = n);
}
function nap() {
  for (var n, t = taskHead, g, d = 1 / 0; t; )
    t._call ? (d > t._time && (d = t._time), n = t, t = t._next) : (g = t._next, t._next = null, t = n ? n._next = g : taskHead = g);
  taskTail = n, sleep(d);
}
function sleep(n) {
  if (!frame) {
    timeout && (timeout = clearTimeout(timeout));
    var t = n - clockNow;
    t > 24 ? (n < 1 / 0 && (timeout = setTimeout(wake, n - clock.now() - clockSkew)), interval$2 && (interval$2 = clearInterval(interval$2))) : (interval$2 || (clockLast = clock.now(), interval$2 = setInterval(poke, pokeDelay)), frame = 1, setFrame(wake));
  }
}
function interval$1(n, t, g) {
  var d = new Timer$2(), k = t;
  return t == null ? (d.restart(n, t, g), d) : (d._restart = d.restart, d.restart = function(H, AA, gA) {
    AA = +AA, gA = gA == null ? now$2() : +gA, d._restart(function IA(CA) {
      CA += k, d._restart(IA, k += AA, gA), H(CA);
    }, AA, gA);
  }, d.restart(n, t, g), d);
}
const a$1 = 1664525, c$1 = 1013904223, m$3 = 4294967296;
function lcg$1() {
  let n = 1;
  return () => (n = (a$1 * n + c$1) % m$3) / m$3;
}
function x(n) {
  return n.x;
}
function y$1(n) {
  return n.y;
}
var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));
function forceSimulation(n) {
  var t, g = 1, d = 1e-3, k = 1 - Math.pow(d, 1 / 300), H = 0, AA = 0.6, gA = /* @__PURE__ */ new Map(), IA = timer$1(eA), CA = dispatch$1("tick", "end"), BA = lcg$1();
  n == null && (n = []);
  function eA() {
    iA(), CA.call("tick", t), g < d && (IA.stop(), CA.call("end", t));
  }
  function iA(oA) {
    var EA, aA = n.length, nA;
    oA === void 0 && (oA = 1);
    for (var lA = 0; lA < oA; ++lA)
      for (g += (H - g) * k, gA.forEach(function(cA) {
        cA(g);
      }), EA = 0; EA < aA; ++EA)
        nA = n[EA], nA.fx == null ? nA.x += nA.vx *= AA : (nA.x = nA.fx, nA.vx = 0), nA.fy == null ? nA.y += nA.vy *= AA : (nA.y = nA.fy, nA.vy = 0);
    return t;
  }
  function QA() {
    for (var oA = 0, EA = n.length, aA; oA < EA; ++oA) {
      if (aA = n[oA], aA.index = oA, aA.fx != null && (aA.x = aA.fx), aA.fy != null && (aA.y = aA.fy), isNaN(aA.x) || isNaN(aA.y)) {
        var nA = initialRadius * Math.sqrt(0.5 + oA), lA = oA * initialAngle;
        aA.x = nA * Math.cos(lA), aA.y = nA * Math.sin(lA);
      }
      (isNaN(aA.vx) || isNaN(aA.vy)) && (aA.vx = aA.vy = 0);
    }
  }
  function tA(oA) {
    return oA.initialize && oA.initialize(n, BA), oA;
  }
  return QA(), t = {
    tick: iA,
    restart: function() {
      return IA.restart(eA), t;
    },
    stop: function() {
      return IA.stop(), t;
    },
    nodes: function(oA) {
      return arguments.length ? (n = oA, QA(), gA.forEach(tA), t) : n;
    },
    alpha: function(oA) {
      return arguments.length ? (g = +oA, t) : g;
    },
    alphaMin: function(oA) {
      return arguments.length ? (d = +oA, t) : d;
    },
    alphaDecay: function(oA) {
      return arguments.length ? (k = +oA, t) : +k;
    },
    alphaTarget: function(oA) {
      return arguments.length ? (H = +oA, t) : H;
    },
    velocityDecay: function(oA) {
      return arguments.length ? (AA = 1 - oA, t) : 1 - AA;
    },
    randomSource: function(oA) {
      return arguments.length ? (BA = oA, gA.forEach(tA), t) : BA;
    },
    force: function(oA, EA) {
      return arguments.length > 1 ? (EA == null ? gA.delete(oA) : gA.set(oA, tA(EA)), t) : gA.get(oA);
    },
    find: function(oA, EA, aA) {
      var nA = 0, lA = n.length, cA, sA, rA, uA, hA;
      for (aA == null ? aA = 1 / 0 : aA *= aA, nA = 0; nA < lA; ++nA)
        uA = n[nA], cA = oA - uA.x, sA = EA - uA.y, rA = cA * cA + sA * sA, rA < aA && (hA = uA, aA = rA);
      return hA;
    },
    on: function(oA, EA) {
      return arguments.length > 1 ? (CA.on(oA, EA), t) : CA.on(oA);
    }
  };
}
function forceManyBody() {
  var n, t, g, d, k = constant$2(-30), H, AA = 1, gA = 1 / 0, IA = 0.81;
  function CA(QA) {
    var tA, oA = n.length, EA = quadtree(n, x, y$1).visitAfter(eA);
    for (d = QA, tA = 0; tA < oA; ++tA) t = n[tA], EA.visit(iA);
  }
  function BA() {
    if (n) {
      var QA, tA = n.length, oA;
      for (H = new Array(tA), QA = 0; QA < tA; ++QA) oA = n[QA], H[oA.index] = +k(oA, QA, n);
    }
  }
  function eA(QA) {
    var tA = 0, oA, EA, aA = 0, nA, lA, cA;
    if (QA.length) {
      for (nA = lA = cA = 0; cA < 4; ++cA)
        (oA = QA[cA]) && (EA = Math.abs(oA.value)) && (tA += oA.value, aA += EA, nA += EA * oA.x, lA += EA * oA.y);
      QA.x = nA / aA, QA.y = lA / aA;
    } else {
      oA = QA, oA.x = oA.data.x, oA.y = oA.data.y;
      do
        tA += H[oA.data.index];
      while (oA = oA.next);
    }
    QA.value = tA;
  }
  function iA(QA, tA, oA, EA) {
    if (!QA.value) return !0;
    var aA = QA.x - t.x, nA = QA.y - t.y, lA = EA - tA, cA = aA * aA + nA * nA;
    if (lA * lA / IA < cA)
      return cA < gA && (aA === 0 && (aA = jiggle(g), cA += aA * aA), nA === 0 && (nA = jiggle(g), cA += nA * nA), cA < AA && (cA = Math.sqrt(AA * cA)), t.vx += aA * QA.value * d / cA, t.vy += nA * QA.value * d / cA), !0;
    if (QA.length || cA >= gA) return;
    (QA.data !== t || QA.next) && (aA === 0 && (aA = jiggle(g), cA += aA * aA), nA === 0 && (nA = jiggle(g), cA += nA * nA), cA < AA && (cA = Math.sqrt(AA * cA)));
    do
      QA.data !== t && (lA = H[QA.data.index] * d / cA, t.vx += aA * lA, t.vy += nA * lA);
    while (QA = QA.next);
  }
  return CA.initialize = function(QA, tA) {
    n = QA, g = tA, BA();
  }, CA.strength = function(QA) {
    return arguments.length ? (k = typeof QA == "function" ? QA : constant$2(+QA), BA(), CA) : k;
  }, CA.distanceMin = function(QA) {
    return arguments.length ? (AA = QA * QA, CA) : Math.sqrt(AA);
  }, CA.distanceMax = function(QA) {
    return arguments.length ? (gA = QA * QA, CA) : Math.sqrt(gA);
  }, CA.theta = function(QA) {
    return arguments.length ? (IA = QA * QA, CA) : Math.sqrt(IA);
  }, CA;
}
function forceX(n) {
  var t = constant$2(0.1), g, d, k;
  typeof n != "function" && (n = constant$2(n == null ? 0 : +n));
  function H(gA) {
    for (var IA = 0, CA = g.length, BA; IA < CA; ++IA)
      BA = g[IA], BA.vx += (k[IA] - BA.x) * d[IA] * gA;
  }
  function AA() {
    if (g) {
      var gA, IA = g.length;
      for (d = new Array(IA), k = new Array(IA), gA = 0; gA < IA; ++gA)
        d[gA] = isNaN(k[gA] = +n(g[gA], gA, g)) ? 0 : +t(g[gA], gA, g);
    }
  }
  return H.initialize = function(gA) {
    g = gA, AA();
  }, H.strength = function(gA) {
    return arguments.length ? (t = typeof gA == "function" ? gA : constant$2(+gA), AA(), H) : t;
  }, H.x = function(gA) {
    return arguments.length ? (n = typeof gA == "function" ? gA : constant$2(+gA), AA(), H) : n;
  }, H;
}
function forceY(n) {
  var t = constant$2(0.1), g, d, k;
  typeof n != "function" && (n = constant$2(n == null ? 0 : +n));
  function H(gA) {
    for (var IA = 0, CA = g.length, BA; IA < CA; ++IA)
      BA = g[IA], BA.vy += (k[IA] - BA.y) * d[IA] * gA;
  }
  function AA() {
    if (g) {
      var gA, IA = g.length;
      for (d = new Array(IA), k = new Array(IA), gA = 0; gA < IA; ++gA)
        d[gA] = isNaN(k[gA] = +n(g[gA], gA, g)) ? 0 : +t(g[gA], gA, g);
    }
  }
  return H.initialize = function(gA) {
    g = gA, AA();
  }, H.strength = function(gA) {
    return arguments.length ? (t = typeof gA == "function" ? gA : constant$2(+gA), AA(), H) : t;
  }, H.y = function(gA) {
    return arguments.length ? (n = typeof gA == "function" ? gA : constant$2(+gA), AA(), H) : n;
  }, H;
}
const ForceMap = {
  center: forceCenter,
  collide: forceCollide,
  nbody: forceManyBody,
  link: forceLink,
  x: forceX,
  y: forceY
}, Forces = "forces", ForceParams = ["alpha", "alphaMin", "alphaTarget", "velocityDecay", "forces"], ForceConfig = ["static", "iterations"], ForceOutput = ["x", "y", "vx", "vy"];
function Force(n) {
  Transform.call(this, null, n);
}
Force.Definition = {
  type: "Force",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "static",
    type: "boolean",
    default: !1
  }, {
    name: "restart",
    type: "boolean",
    default: !1
  }, {
    name: "iterations",
    type: "number",
    default: 300
  }, {
    name: "alpha",
    type: "number",
    default: 1
  }, {
    name: "alphaMin",
    type: "number",
    default: 1e-3
  }, {
    name: "alphaTarget",
    type: "number",
    default: 0
  }, {
    name: "velocityDecay",
    type: "number",
    default: 0.4
  }, {
    name: "forces",
    type: "param",
    array: !0,
    params: [{
      key: {
        force: "center"
      },
      params: [{
        name: "x",
        type: "number",
        default: 0
      }, {
        name: "y",
        type: "number",
        default: 0
      }]
    }, {
      key: {
        force: "collide"
      },
      params: [{
        name: "radius",
        type: "number",
        expr: !0
      }, {
        name: "strength",
        type: "number",
        default: 0.7
      }, {
        name: "iterations",
        type: "number",
        default: 1
      }]
    }, {
      key: {
        force: "nbody"
      },
      params: [{
        name: "strength",
        type: "number",
        default: -30,
        expr: !0
      }, {
        name: "theta",
        type: "number",
        default: 0.9
      }, {
        name: "distanceMin",
        type: "number",
        default: 1
      }, {
        name: "distanceMax",
        type: "number"
      }]
    }, {
      key: {
        force: "link"
      },
      params: [{
        name: "links",
        type: "data"
      }, {
        name: "id",
        type: "field"
      }, {
        name: "distance",
        type: "number",
        default: 30,
        expr: !0
      }, {
        name: "strength",
        type: "number",
        expr: !0
      }, {
        name: "iterations",
        type: "number",
        default: 1
      }]
    }, {
      key: {
        force: "x"
      },
      params: [{
        name: "strength",
        type: "number",
        default: 0.1
      }, {
        name: "x",
        type: "field"
      }]
    }, {
      key: {
        force: "y"
      },
      params: [{
        name: "strength",
        type: "number",
        default: 0.1
      }, {
        name: "y",
        type: "field"
      }]
    }]
  }, {
    name: "as",
    type: "string",
    array: !0,
    modify: !1,
    default: ForceOutput
  }]
};
inherits$1(Force, Transform, {
  transform(n, t) {
    var g = this.value, d = t.changed(t.ADD_REM), k = n.modified(ForceParams), H = n.iterations || 300;
    if (g ? (d && (t.modifies("index"), g.nodes(t.source)), (k || t.changed(t.MOD)) && setup(g, n, 0, t)) : (this.value = g = simulation(t.source, n), g.on("tick", rerun(t.dataflow, this)), n.static || (d = !0, g.tick()), t.modifies("index")), k || d || n.modified(ForceConfig) || t.changed() && n.restart) {
      if (g.alpha(Math.max(g.alpha(), n.alpha || 1)).alphaDecay(1 - Math.pow(g.alphaMin(), 1 / H)), n.static)
        for (g.stop(); --H >= 0; ) g.tick();
      else if (g.stopped() && g.restart(), !d) return t.StopPropagation;
    }
    return this.finish(n, t);
  },
  finish(n, t) {
    const g = t.dataflow;
    for (let gA = this._argops, IA = 0, CA = gA.length, BA; IA < CA; ++IA)
      if (BA = gA[IA], !(BA.name !== Forces || BA.op._argval.force !== "link")) {
        for (var d = BA.op._argops, k = 0, H = d.length, AA; k < H; ++k)
          if (d[k].name === "links" && (AA = d[k].op.source)) {
            g.pulse(AA, g.changeset().reflow());
            break;
          }
      }
    return t.reflow(n.modified()).modifies(ForceOutput);
  }
});
function rerun(n, t) {
  return () => n.touch(t).run();
}
function simulation(n, t) {
  const g = forceSimulation(n), d = g.stop, k = g.restart;
  let H = !1;
  return g.stopped = () => H, g.restart = () => (H = !1, k()), g.stop = () => (H = !0, d()), setup(g, t, !0).on("end", () => H = !0);
}
function setup(n, t, g, d) {
  var k = array$6(t.forces), H, AA, gA, IA;
  for (H = 0, AA = ForceParams.length; H < AA; ++H)
    gA = ForceParams[H], gA !== Forces && t.modified(gA) && n[gA](t[gA]);
  for (H = 0, AA = k.length; H < AA; ++H)
    IA = Forces + H, gA = g || t.modified(Forces, H) ? getForce(k[H]) : d && modified(k[H], d) ? n.force(IA) : null, gA && n.force(IA, gA);
  for (AA = n.numForces || 0; H < AA; ++H)
    n.force(Forces + H, null);
  return n.numForces = k.length, n;
}
function modified(n, t) {
  var g, d;
  for (g in n)
    if (isFunction$5(d = n[g]) && t.modified(accessorFields(d))) return 1;
  return 0;
}
function getForce(n) {
  var t, g;
  has$2(ForceMap, n.force) || error$3("Unrecognized force: " + n.force), t = ForceMap[n.force]();
  for (g in n)
    isFunction$5(t[g]) && setForceParam(t[g], n[g], n);
  return t;
}
function setForceParam(n, t, g) {
  n(isFunction$5(t) ? (d) => t(d, g) : t);
}
const force = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  force: Force
}, Symbol.toStringTag, { value: "Module" }));
function defaultSeparation$2(n, t) {
  return n.parent === t.parent ? 1 : 2;
}
function meanX(n) {
  return n.reduce(meanXReduce, 0) / n.length;
}
function meanXReduce(n, t) {
  return n + t.x;
}
function maxY(n) {
  return 1 + n.reduce(maxYReduce, 0);
}
function maxYReduce(n, t) {
  return Math.max(n, t.y);
}
function leafLeft(n) {
  for (var t; t = n.children; ) n = t[0];
  return n;
}
function leafRight(n) {
  for (var t; t = n.children; ) n = t[t.length - 1];
  return n;
}
function cluster() {
  var n = defaultSeparation$2, t = 1, g = 1, d = !1;
  function k(H) {
    var AA, gA = 0;
    H.eachAfter(function(iA) {
      var QA = iA.children;
      QA ? (iA.x = meanX(QA), iA.y = maxY(QA)) : (iA.x = AA ? gA += n(iA, AA) : 0, iA.y = 0, AA = iA);
    });
    var IA = leafLeft(H), CA = leafRight(H), BA = IA.x - n(IA, CA) / 2, eA = CA.x + n(CA, IA) / 2;
    return H.eachAfter(d ? function(iA) {
      iA.x = (iA.x - H.x) * t, iA.y = (H.y - iA.y) * g;
    } : function(iA) {
      iA.x = (iA.x - BA) / (eA - BA) * t, iA.y = (1 - (H.y ? iA.y / H.y : 1)) * g;
    });
  }
  return k.separation = function(H) {
    return arguments.length ? (n = H, k) : n;
  }, k.size = function(H) {
    return arguments.length ? (d = !1, t = +H[0], g = +H[1], k) : d ? null : [t, g];
  }, k.nodeSize = function(H) {
    return arguments.length ? (d = !0, t = +H[0], g = +H[1], k) : d ? [t, g] : null;
  }, k;
}
function count(n) {
  var t = 0, g = n.children, d = g && g.length;
  if (!d) t = 1;
  else for (; --d >= 0; ) t += g[d].value;
  n.value = t;
}
function node_count() {
  return this.eachAfter(count);
}
function node_each(n, t) {
  let g = -1;
  for (const d of this)
    n.call(t, d, ++g, this);
  return this;
}
function node_eachBefore(n, t) {
  for (var g = this, d = [g], k, H, AA = -1; g = d.pop(); )
    if (n.call(t, g, ++AA, this), k = g.children)
      for (H = k.length - 1; H >= 0; --H)
        d.push(k[H]);
  return this;
}
function node_eachAfter(n, t) {
  for (var g = this, d = [g], k = [], H, AA, gA, IA = -1; g = d.pop(); )
    if (k.push(g), H = g.children)
      for (AA = 0, gA = H.length; AA < gA; ++AA)
        d.push(H[AA]);
  for (; g = k.pop(); )
    n.call(t, g, ++IA, this);
  return this;
}
function node_find(n, t) {
  let g = -1;
  for (const d of this)
    if (n.call(t, d, ++g, this))
      return d;
}
function node_sum(n) {
  return this.eachAfter(function(t) {
    for (var g = +n(t.data) || 0, d = t.children, k = d && d.length; --k >= 0; ) g += d[k].value;
    t.value = g;
  });
}
function node_sort(n) {
  return this.eachBefore(function(t) {
    t.children && t.children.sort(n);
  });
}
function node_path(n) {
  for (var t = this, g = leastCommonAncestor(t, n), d = [t]; t !== g; )
    t = t.parent, d.push(t);
  for (var k = d.length; n !== g; )
    d.splice(k, 0, n), n = n.parent;
  return d;
}
function leastCommonAncestor(n, t) {
  if (n === t) return n;
  var g = n.ancestors(), d = t.ancestors(), k = null;
  for (n = g.pop(), t = d.pop(); n === t; )
    k = n, n = g.pop(), t = d.pop();
  return k;
}
function node_ancestors() {
  for (var n = this, t = [n]; n = n.parent; )
    t.push(n);
  return t;
}
function node_descendants() {
  return Array.from(this);
}
function node_leaves() {
  var n = [];
  return this.eachBefore(function(t) {
    t.children || n.push(t);
  }), n;
}
function node_links() {
  var n = this, t = [];
  return n.each(function(g) {
    g !== n && t.push({ source: g.parent, target: g });
  }), t;
}
function* node_iterator() {
  var n = this, t, g = [n], d, k, H;
  do
    for (t = g.reverse(), g = []; n = t.pop(); )
      if (yield n, d = n.children)
        for (k = 0, H = d.length; k < H; ++k)
          g.push(d[k]);
  while (g.length);
}
function hierarchy(n, t) {
  n instanceof Map ? (n = [void 0, n], t === void 0 && (t = mapChildren)) : t === void 0 && (t = objectChildren);
  for (var g = new Node$2(n), d, k = [g], H, AA, gA, IA; d = k.pop(); )
    if ((AA = t(d.data)) && (IA = (AA = Array.from(AA)).length))
      for (d.children = AA, gA = IA - 1; gA >= 0; --gA)
        k.push(H = AA[gA] = new Node$2(AA[gA])), H.parent = d, H.depth = d.depth + 1;
  return g.eachBefore(computeHeight);
}
function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}
function objectChildren(n) {
  return n.children;
}
function mapChildren(n) {
  return Array.isArray(n) ? n[1] : null;
}
function copyData(n) {
  n.data.value !== void 0 && (n.value = n.data.value), n.data = n.data.data;
}
function computeHeight(n) {
  var t = 0;
  do
    n.height = t;
  while ((n = n.parent) && n.height < ++t);
}
function Node$2(n) {
  this.data = n, this.depth = this.height = 0, this.parent = null;
}
Node$2.prototype = hierarchy.prototype = {
  constructor: Node$2,
  count: node_count,
  each: node_each,
  eachAfter: node_eachAfter,
  eachBefore: node_eachBefore,
  find: node_find,
  sum: node_sum,
  sort: node_sort,
  path: node_path,
  ancestors: node_ancestors,
  descendants: node_descendants,
  leaves: node_leaves,
  links: node_links,
  copy: node_copy,
  [Symbol.iterator]: node_iterator
};
function optional(n) {
  return n == null ? null : required(n);
}
function required(n) {
  if (typeof n != "function") throw new Error();
  return n;
}
function constantZero() {
  return 0;
}
function constant$1(n) {
  return function() {
    return n;
  };
}
const a = 1664525, c = 1013904223, m$2 = 4294967296;
function lcg() {
  let n = 1;
  return () => (n = (a * n + c) % m$2) / m$2;
}
function array$3(n) {
  return typeof n == "object" && "length" in n ? n : Array.from(n);
}
function shuffle(n, t) {
  let g = n.length, d, k;
  for (; g; )
    k = t() * g-- | 0, d = n[g], n[g] = n[k], n[k] = d;
  return n;
}
function packEncloseRandom(n, t) {
  for (var g = 0, d = (n = shuffle(Array.from(n), t)).length, k = [], H, AA; g < d; )
    H = n[g], AA && enclosesWeak(AA, H) ? ++g : (AA = encloseBasis(k = extendBasis(k, H)), g = 0);
  return AA;
}
function extendBasis(n, t) {
  var g, d;
  if (enclosesWeakAll(t, n)) return [t];
  for (g = 0; g < n.length; ++g)
    if (enclosesNot(t, n[g]) && enclosesWeakAll(encloseBasis2(n[g], t), n))
      return [n[g], t];
  for (g = 0; g < n.length - 1; ++g)
    for (d = g + 1; d < n.length; ++d)
      if (enclosesNot(encloseBasis2(n[g], n[d]), t) && enclosesNot(encloseBasis2(n[g], t), n[d]) && enclosesNot(encloseBasis2(n[d], t), n[g]) && enclosesWeakAll(encloseBasis3(n[g], n[d], t), n))
        return [n[g], n[d], t];
  throw new Error();
}
function enclosesNot(n, t) {
  var g = n.r - t.r, d = t.x - n.x, k = t.y - n.y;
  return g < 0 || g * g < d * d + k * k;
}
function enclosesWeak(n, t) {
  var g = n.r - t.r + Math.max(n.r, t.r, 1) * 1e-9, d = t.x - n.x, k = t.y - n.y;
  return g > 0 && g * g > d * d + k * k;
}
function enclosesWeakAll(n, t) {
  for (var g = 0; g < t.length; ++g)
    if (!enclosesWeak(n, t[g]))
      return !1;
  return !0;
}
function encloseBasis(n) {
  switch (n.length) {
    case 1:
      return encloseBasis1(n[0]);
    case 2:
      return encloseBasis2(n[0], n[1]);
    case 3:
      return encloseBasis3(n[0], n[1], n[2]);
  }
}
function encloseBasis1(n) {
  return {
    x: n.x,
    y: n.y,
    r: n.r
  };
}
function encloseBasis2(n, t) {
  var g = n.x, d = n.y, k = n.r, H = t.x, AA = t.y, gA = t.r, IA = H - g, CA = AA - d, BA = gA - k, eA = Math.sqrt(IA * IA + CA * CA);
  return {
    x: (g + H + IA / eA * BA) / 2,
    y: (d + AA + CA / eA * BA) / 2,
    r: (eA + k + gA) / 2
  };
}
function encloseBasis3(n, t, g) {
  var d = n.x, k = n.y, H = n.r, AA = t.x, gA = t.y, IA = t.r, CA = g.x, BA = g.y, eA = g.r, iA = d - AA, QA = d - CA, tA = k - gA, oA = k - BA, EA = IA - H, aA = eA - H, nA = d * d + k * k - H * H, lA = nA - AA * AA - gA * gA + IA * IA, cA = nA - CA * CA - BA * BA + eA * eA, sA = QA * tA - iA * oA, rA = (tA * cA - oA * lA) / (sA * 2) - d, uA = (oA * EA - tA * aA) / sA, hA = (QA * lA - iA * cA) / (sA * 2) - k, dA = (iA * aA - QA * EA) / sA, GA = uA * uA + dA * dA - 1, DA = 2 * (H + rA * uA + hA * dA), wA = rA * rA + hA * hA - H * H, bA = -(Math.abs(GA) > 1e-6 ? (DA + Math.sqrt(DA * DA - 4 * GA * wA)) / (2 * GA) : wA / DA);
  return {
    x: d + rA + uA * bA,
    y: k + hA + dA * bA,
    r: bA
  };
}
function place(n, t, g) {
  var d = n.x - t.x, k, H, AA = n.y - t.y, gA, IA, CA = d * d + AA * AA;
  CA ? (H = t.r + g.r, H *= H, IA = n.r + g.r, IA *= IA, H > IA ? (k = (CA + IA - H) / (2 * CA), gA = Math.sqrt(Math.max(0, IA / CA - k * k)), g.x = n.x - k * d - gA * AA, g.y = n.y - k * AA + gA * d) : (k = (CA + H - IA) / (2 * CA), gA = Math.sqrt(Math.max(0, H / CA - k * k)), g.x = t.x + k * d - gA * AA, g.y = t.y + k * AA + gA * d)) : (g.x = t.x + g.r, g.y = t.y);
}
function intersects(n, t) {
  var g = n.r + t.r - 1e-6, d = t.x - n.x, k = t.y - n.y;
  return g > 0 && g * g > d * d + k * k;
}
function score$1(n) {
  var t = n._, g = n.next._, d = t.r + g.r, k = (t.x * g.r + g.x * t.r) / d, H = (t.y * g.r + g.y * t.r) / d;
  return k * k + H * H;
}
function Node$1(n) {
  this._ = n, this.next = null, this.previous = null;
}
function packSiblingsRandom(n, t) {
  if (!(H = (n = array$3(n)).length)) return 0;
  var g, d, k, H, AA, gA, IA, CA, BA, eA, iA;
  if (g = n[0], g.x = 0, g.y = 0, !(H > 1)) return g.r;
  if (d = n[1], g.x = -d.r, d.x = g.r, d.y = 0, !(H > 2)) return g.r + d.r;
  place(d, g, k = n[2]), g = new Node$1(g), d = new Node$1(d), k = new Node$1(k), g.next = k.previous = d, d.next = g.previous = k, k.next = d.previous = g;
  A: for (IA = 3; IA < H; ++IA) {
    place(g._, d._, k = n[IA]), k = new Node$1(k), CA = d.next, BA = g.previous, eA = d._.r, iA = g._.r;
    do
      if (eA <= iA) {
        if (intersects(CA._, k._)) {
          d = CA, g.next = d, d.previous = g, --IA;
          continue A;
        }
        eA += CA._.r, CA = CA.next;
      } else {
        if (intersects(BA._, k._)) {
          g = BA, g.next = d, d.previous = g, --IA;
          continue A;
        }
        iA += BA._.r, BA = BA.previous;
      }
    while (CA !== BA.next);
    for (k.previous = g, k.next = d, g.next = d.previous = d = k, AA = score$1(g); (k = k.next) !== d; )
      (gA = score$1(k)) < AA && (g = k, AA = gA);
    d = g.next;
  }
  for (g = [d._], k = d; (k = k.next) !== d; ) g.push(k._);
  for (k = packEncloseRandom(g, t), IA = 0; IA < H; ++IA) g = n[IA], g.x -= k.x, g.y -= k.y;
  return k.r;
}
function defaultRadius(n) {
  return Math.sqrt(n.value);
}
function pack() {
  var n = null, t = 1, g = 1, d = constantZero;
  function k(H) {
    const AA = lcg();
    return H.x = t / 2, H.y = g / 2, n ? H.eachBefore(radiusLeaf(n)).eachAfter(packChildrenRandom(d, 0.5, AA)).eachBefore(translateChild(1)) : H.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildrenRandom(constantZero, 1, AA)).eachAfter(packChildrenRandom(d, H.r / Math.min(t, g), AA)).eachBefore(translateChild(Math.min(t, g) / (2 * H.r))), H;
  }
  return k.radius = function(H) {
    return arguments.length ? (n = optional(H), k) : n;
  }, k.size = function(H) {
    return arguments.length ? (t = +H[0], g = +H[1], k) : [t, g];
  }, k.padding = function(H) {
    return arguments.length ? (d = typeof H == "function" ? H : constant$1(+H), k) : d;
  }, k;
}
function radiusLeaf(n) {
  return function(t) {
    t.children || (t.r = Math.max(0, +n(t) || 0));
  };
}
function packChildrenRandom(n, t, g) {
  return function(d) {
    if (k = d.children) {
      var k, H, AA = k.length, gA = n(d) * t || 0, IA;
      if (gA) for (H = 0; H < AA; ++H) k[H].r += gA;
      if (IA = packSiblingsRandom(k, g), gA) for (H = 0; H < AA; ++H) k[H].r -= gA;
      d.r = IA + gA;
    }
  };
}
function translateChild(n) {
  return function(t) {
    var g = t.parent;
    t.r *= n, g && (t.x = g.x + n * t.x, t.y = g.y + n * t.y);
  };
}
function roundNode(n) {
  n.x0 = Math.round(n.x0), n.y0 = Math.round(n.y0), n.x1 = Math.round(n.x1), n.y1 = Math.round(n.y1);
}
function treemapDice(n, t, g, d, k) {
  for (var H = n.children, AA, gA = -1, IA = H.length, CA = n.value && (d - t) / n.value; ++gA < IA; )
    AA = H[gA], AA.y0 = g, AA.y1 = k, AA.x0 = t, AA.x1 = t += AA.value * CA;
}
function partition$1() {
  var n = 1, t = 1, g = 0, d = !1;
  function k(AA) {
    var gA = AA.height + 1;
    return AA.x0 = AA.y0 = g, AA.x1 = n, AA.y1 = t / gA, AA.eachBefore(H(t, gA)), d && AA.eachBefore(roundNode), AA;
  }
  function H(AA, gA) {
    return function(IA) {
      IA.children && treemapDice(IA, IA.x0, AA * (IA.depth + 1) / gA, IA.x1, AA * (IA.depth + 2) / gA);
      var CA = IA.x0, BA = IA.y0, eA = IA.x1 - g, iA = IA.y1 - g;
      eA < CA && (CA = eA = (CA + eA) / 2), iA < BA && (BA = iA = (BA + iA) / 2), IA.x0 = CA, IA.y0 = BA, IA.x1 = eA, IA.y1 = iA;
    };
  }
  return k.round = function(AA) {
    return arguments.length ? (d = !!AA, k) : d;
  }, k.size = function(AA) {
    return arguments.length ? (n = +AA[0], t = +AA[1], k) : [n, t];
  }, k.padding = function(AA) {
    return arguments.length ? (g = +AA, k) : g;
  }, k;
}
var preroot = { depth: -1 }, ambiguous = {}, imputed = {};
function defaultId(n) {
  return n.id;
}
function defaultParentId(n) {
  return n.parentId;
}
function stratify() {
  var n = defaultId, t = defaultParentId, g;
  function d(k) {
    var H = Array.from(k), AA = n, gA = t, IA, CA, BA, eA, iA, QA, tA, oA, EA = /* @__PURE__ */ new Map();
    if (g != null) {
      const aA = H.map((cA, sA) => normalize$1(g(cA, sA, k))), nA = aA.map(parentof), lA = new Set(aA).add("");
      for (const cA of nA)
        lA.has(cA) || (lA.add(cA), aA.push(cA), nA.push(parentof(cA)), H.push(imputed));
      AA = (cA, sA) => aA[sA], gA = (cA, sA) => nA[sA];
    }
    for (BA = 0, IA = H.length; BA < IA; ++BA)
      CA = H[BA], QA = H[BA] = new Node$2(CA), (tA = AA(CA, BA, k)) != null && (tA += "") && (oA = QA.id = tA, EA.set(oA, EA.has(oA) ? ambiguous : QA)), (tA = gA(CA, BA, k)) != null && (tA += "") && (QA.parent = tA);
    for (BA = 0; BA < IA; ++BA)
      if (QA = H[BA], tA = QA.parent) {
        if (iA = EA.get(tA), !iA) throw new Error("missing: " + tA);
        if (iA === ambiguous) throw new Error("ambiguous: " + tA);
        iA.children ? iA.children.push(QA) : iA.children = [QA], QA.parent = iA;
      } else {
        if (eA) throw new Error("multiple roots");
        eA = QA;
      }
    if (!eA) throw new Error("no root");
    if (g != null) {
      for (; eA.data === imputed && eA.children.length === 1; )
        eA = eA.children[0], --IA;
      for (let aA = H.length - 1; aA >= 0 && (QA = H[aA], QA.data === imputed); --aA)
        QA.data = null;
    }
    if (eA.parent = preroot, eA.eachBefore(function(aA) {
      aA.depth = aA.parent.depth + 1, --IA;
    }).eachBefore(computeHeight), eA.parent = null, IA > 0) throw new Error("cycle");
    return eA;
  }
  return d.id = function(k) {
    return arguments.length ? (n = optional(k), d) : n;
  }, d.parentId = function(k) {
    return arguments.length ? (t = optional(k), d) : t;
  }, d.path = function(k) {
    return arguments.length ? (g = optional(k), d) : g;
  }, d;
}
function normalize$1(n) {
  n = `${n}`;
  let t = n.length;
  return slash(n, t - 1) && !slash(n, t - 2) && (n = n.slice(0, -1)), n[0] === "/" ? n : `/${n}`;
}
function parentof(n) {
  let t = n.length;
  if (t < 2) return "";
  for (; --t > 1 && !slash(n, t); ) ;
  return n.slice(0, t);
}
function slash(n, t) {
  if (n[t] === "/") {
    let g = 0;
    for (; t > 0 && n[--t] === "\\"; ) ++g;
    if ((g & 1) === 0) return !0;
  }
  return !1;
}
function defaultSeparation$1(n, t) {
  return n.parent === t.parent ? 1 : 2;
}
function nextLeft(n) {
  var t = n.children;
  return t ? t[0] : n.t;
}
function nextRight(n) {
  var t = n.children;
  return t ? t[t.length - 1] : n.t;
}
function moveSubtree(n, t, g) {
  var d = g / (t.i - n.i);
  t.c -= d, t.s += g, n.c += d, t.z += g, t.m += g;
}
function executeShifts(n) {
  for (var t = 0, g = 0, d = n.children, k = d.length, H; --k >= 0; )
    H = d[k], H.z += t, H.m += t, t += H.s + (g += H.c);
}
function nextAncestor(n, t, g) {
  return n.a.parent === t.parent ? n.a : g;
}
function TreeNode(n, t) {
  this._ = n, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = t;
}
TreeNode.prototype = Object.create(Node$2.prototype);
function treeRoot(n) {
  for (var t = new TreeNode(n, 0), g, d = [t], k, H, AA, gA; g = d.pop(); )
    if (H = g._.children)
      for (g.children = new Array(gA = H.length), AA = gA - 1; AA >= 0; --AA)
        d.push(k = g.children[AA] = new TreeNode(H[AA], AA)), k.parent = g;
  return (t.parent = new TreeNode(null, 0)).children = [t], t;
}
function tree$1() {
  var n = defaultSeparation$1, t = 1, g = 1, d = null;
  function k(CA) {
    var BA = treeRoot(CA);
    if (BA.eachAfter(H), BA.parent.m = -BA.z, BA.eachBefore(AA), d) CA.eachBefore(IA);
    else {
      var eA = CA, iA = CA, QA = CA;
      CA.eachBefore(function(nA) {
        nA.x < eA.x && (eA = nA), nA.x > iA.x && (iA = nA), nA.depth > QA.depth && (QA = nA);
      });
      var tA = eA === iA ? 1 : n(eA, iA) / 2, oA = tA - eA.x, EA = t / (iA.x + tA + oA), aA = g / (QA.depth || 1);
      CA.eachBefore(function(nA) {
        nA.x = (nA.x + oA) * EA, nA.y = nA.depth * aA;
      });
    }
    return CA;
  }
  function H(CA) {
    var BA = CA.children, eA = CA.parent.children, iA = CA.i ? eA[CA.i - 1] : null;
    if (BA) {
      executeShifts(CA);
      var QA = (BA[0].z + BA[BA.length - 1].z) / 2;
      iA ? (CA.z = iA.z + n(CA._, iA._), CA.m = CA.z - QA) : CA.z = QA;
    } else iA && (CA.z = iA.z + n(CA._, iA._));
    CA.parent.A = gA(CA, iA, CA.parent.A || eA[0]);
  }
  function AA(CA) {
    CA._.x = CA.z + CA.parent.m, CA.m += CA.parent.m;
  }
  function gA(CA, BA, eA) {
    if (BA) {
      for (var iA = CA, QA = CA, tA = BA, oA = iA.parent.children[0], EA = iA.m, aA = QA.m, nA = tA.m, lA = oA.m, cA; tA = nextRight(tA), iA = nextLeft(iA), tA && iA; )
        oA = nextLeft(oA), QA = nextRight(QA), QA.a = CA, cA = tA.z + nA - iA.z - EA + n(tA._, iA._), cA > 0 && (moveSubtree(nextAncestor(tA, CA, eA), CA, cA), EA += cA, aA += cA), nA += tA.m, EA += iA.m, lA += oA.m, aA += QA.m;
      tA && !nextRight(QA) && (QA.t = tA, QA.m += nA - aA), iA && !nextLeft(oA) && (oA.t = iA, oA.m += EA - lA, eA = CA);
    }
    return eA;
  }
  function IA(CA) {
    CA.x *= t, CA.y = CA.depth * g;
  }
  return k.separation = function(CA) {
    return arguments.length ? (n = CA, k) : n;
  }, k.size = function(CA) {
    return arguments.length ? (d = !1, t = +CA[0], g = +CA[1], k) : d ? null : [t, g];
  }, k.nodeSize = function(CA) {
    return arguments.length ? (d = !0, t = +CA[0], g = +CA[1], k) : d ? [t, g] : null;
  }, k;
}
function treemapSlice(n, t, g, d, k) {
  for (var H = n.children, AA, gA = -1, IA = H.length, CA = n.value && (k - g) / n.value; ++gA < IA; )
    AA = H[gA], AA.x0 = t, AA.x1 = d, AA.y0 = g, AA.y1 = g += AA.value * CA;
}
var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(n, t, g, d, k, H) {
  for (var AA = [], gA = t.children, IA, CA, BA = 0, eA = 0, iA = gA.length, QA, tA, oA = t.value, EA, aA, nA, lA, cA, sA, rA; BA < iA; ) {
    QA = k - g, tA = H - d;
    do
      EA = gA[eA++].value;
    while (!EA && eA < iA);
    for (aA = nA = EA, sA = Math.max(tA / QA, QA / tA) / (oA * n), rA = EA * EA * sA, cA = Math.max(nA / rA, rA / aA); eA < iA; ++eA) {
      if (EA += CA = gA[eA].value, CA < aA && (aA = CA), CA > nA && (nA = CA), rA = EA * EA * sA, lA = Math.max(nA / rA, rA / aA), lA > cA) {
        EA -= CA;
        break;
      }
      cA = lA;
    }
    AA.push(IA = { value: EA, dice: QA < tA, children: gA.slice(BA, eA) }), IA.dice ? treemapDice(IA, g, d, k, oA ? d += tA * EA / oA : H) : treemapSlice(IA, g, d, oA ? g += QA * EA / oA : k, H), oA -= EA, BA = eA;
  }
  return AA;
}
const treemapSquarify = (function n(t) {
  function g(d, k, H, AA, gA) {
    squarifyRatio(t, d, k, H, AA, gA);
  }
  return g.ratio = function(d) {
    return n((d = +d) > 1 ? d : 1);
  }, g;
})(phi);
function treemap() {
  var n = treemapSquarify, t = !1, g = 1, d = 1, k = [0], H = constantZero, AA = constantZero, gA = constantZero, IA = constantZero, CA = constantZero;
  function BA(iA) {
    return iA.x0 = iA.y0 = 0, iA.x1 = g, iA.y1 = d, iA.eachBefore(eA), k = [0], t && iA.eachBefore(roundNode), iA;
  }
  function eA(iA) {
    var QA = k[iA.depth], tA = iA.x0 + QA, oA = iA.y0 + QA, EA = iA.x1 - QA, aA = iA.y1 - QA;
    EA < tA && (tA = EA = (tA + EA) / 2), aA < oA && (oA = aA = (oA + aA) / 2), iA.x0 = tA, iA.y0 = oA, iA.x1 = EA, iA.y1 = aA, iA.children && (QA = k[iA.depth + 1] = H(iA) / 2, tA += CA(iA) - QA, oA += AA(iA) - QA, EA -= gA(iA) - QA, aA -= IA(iA) - QA, EA < tA && (tA = EA = (tA + EA) / 2), aA < oA && (oA = aA = (oA + aA) / 2), n(iA, tA, oA, EA, aA));
  }
  return BA.round = function(iA) {
    return arguments.length ? (t = !!iA, BA) : t;
  }, BA.size = function(iA) {
    return arguments.length ? (g = +iA[0], d = +iA[1], BA) : [g, d];
  }, BA.tile = function(iA) {
    return arguments.length ? (n = required(iA), BA) : n;
  }, BA.padding = function(iA) {
    return arguments.length ? BA.paddingInner(iA).paddingOuter(iA) : BA.paddingInner();
  }, BA.paddingInner = function(iA) {
    return arguments.length ? (H = typeof iA == "function" ? iA : constant$1(+iA), BA) : H;
  }, BA.paddingOuter = function(iA) {
    return arguments.length ? BA.paddingTop(iA).paddingRight(iA).paddingBottom(iA).paddingLeft(iA) : BA.paddingTop();
  }, BA.paddingTop = function(iA) {
    return arguments.length ? (AA = typeof iA == "function" ? iA : constant$1(+iA), BA) : AA;
  }, BA.paddingRight = function(iA) {
    return arguments.length ? (gA = typeof iA == "function" ? iA : constant$1(+iA), BA) : gA;
  }, BA.paddingBottom = function(iA) {
    return arguments.length ? (IA = typeof iA == "function" ? iA : constant$1(+iA), BA) : IA;
  }, BA.paddingLeft = function(iA) {
    return arguments.length ? (CA = typeof iA == "function" ? iA : constant$1(+iA), BA) : CA;
  }, BA;
}
function treemapBinary(n, t, g, d, k) {
  var H = n.children, AA, gA = H.length, IA, CA = new Array(gA + 1);
  for (CA[0] = IA = AA = 0; AA < gA; ++AA)
    CA[AA + 1] = IA += H[AA].value;
  BA(0, gA, n.value, t, g, d, k);
  function BA(eA, iA, QA, tA, oA, EA, aA) {
    if (eA >= iA - 1) {
      var nA = H[eA];
      nA.x0 = tA, nA.y0 = oA, nA.x1 = EA, nA.y1 = aA;
      return;
    }
    for (var lA = CA[eA], cA = QA / 2 + lA, sA = eA + 1, rA = iA - 1; sA < rA; ) {
      var uA = sA + rA >>> 1;
      CA[uA] < cA ? sA = uA + 1 : rA = uA;
    }
    cA - CA[sA - 1] < CA[sA] - cA && eA + 1 < sA && --sA;
    var hA = CA[sA] - lA, dA = QA - hA;
    if (EA - tA > aA - oA) {
      var GA = QA ? (tA * dA + EA * hA) / QA : EA;
      BA(eA, sA, hA, tA, oA, GA, aA), BA(sA, iA, dA, GA, oA, EA, aA);
    } else {
      var DA = QA ? (oA * dA + aA * hA) / QA : aA;
      BA(eA, sA, hA, tA, oA, EA, DA), BA(sA, iA, dA, tA, DA, EA, aA);
    }
  }
}
function treemapSliceDice(n, t, g, d, k) {
  (n.depth & 1 ? treemapSlice : treemapDice)(n, t, g, d, k);
}
const treemapResquarify = (function n(t) {
  function g(d, k, H, AA, gA) {
    if ((IA = d._squarify) && IA.ratio === t)
      for (var IA, CA, BA, eA, iA = -1, QA, tA = IA.length, oA = d.value; ++iA < tA; ) {
        for (CA = IA[iA], BA = CA.children, eA = CA.value = 0, QA = BA.length; eA < QA; ++eA) CA.value += BA[eA].value;
        CA.dice ? treemapDice(CA, k, H, AA, oA ? H += (gA - H) * CA.value / oA : gA) : treemapSlice(CA, k, H, oA ? k += (AA - k) * CA.value / oA : AA, gA), oA -= CA.value;
      }
    else
      d._squarify = IA = squarifyRatio(t, d, k, H, AA, gA), IA.ratio = t;
  }
  return g.ratio = function(d) {
    return n((d = +d) > 1 ? d : 1);
  }, g;
})(phi);
function lookup$2(n, t, g) {
  const d = {};
  return n.each((k) => {
    const H = k.data;
    g(H) && (d[t(H)] = k);
  }), n.lookup = d, n;
}
function Nest(n) {
  Transform.call(this, null, n);
}
Nest.Definition = {
  type: "Nest",
  metadata: {
    treesource: !0,
    changes: !0
  },
  params: [{
    name: "keys",
    type: "field",
    array: !0
  }, {
    name: "generate",
    type: "boolean"
  }]
};
const children$2 = (n) => n.values;
inherits$1(Nest, Transform, {
  transform(n, t) {
    t.source || error$3("Nest transform requires an upstream data source.");
    var g = n.generate, d = n.modified(), k = t.clone(), H = this.value;
    return (!H || d || t.changed()) && (H && H.each((AA) => {
      AA.children && isTuple(AA.data) && k.rem.push(AA.data);
    }), this.value = H = hierarchy({
      values: array$6(n.keys).reduce((AA, gA) => (AA.key(gA), AA), nest()).entries(k.source)
    }, children$2), g && H.each((AA) => {
      AA.children && (AA = ingest$1(AA.data), k.add.push(AA), k.source.push(AA));
    }), lookup$2(H, tupleid, tupleid)), k.source.root = H, k;
  }
});
function nest() {
  const n = [], t = {
    entries: (k) => d(g(k, 0), 0),
    key: (k) => (n.push(k), t)
  };
  function g(k, H) {
    if (H >= n.length)
      return k;
    const AA = k.length, gA = n[H++], IA = {}, CA = {};
    let BA = -1, eA, iA, QA;
    for (; ++BA < AA; )
      eA = gA(iA = k[BA]) + "", (QA = IA[eA]) ? QA.push(iA) : IA[eA] = [iA];
    for (eA in IA)
      CA[eA] = g(IA[eA], H);
    return CA;
  }
  function d(k, H) {
    if (++H > n.length) return k;
    const AA = [];
    for (const gA in k)
      AA.push({
        key: gA,
        values: d(k[gA], H)
      });
    return AA;
  }
  return t;
}
function HierarchyLayout(n) {
  Transform.call(this, null, n);
}
const defaultSeparation = (n, t) => n.parent === t.parent ? 1 : 2;
inherits$1(HierarchyLayout, Transform, {
  transform(n, t) {
    (!t.source || !t.source.root) && error$3(this.constructor.name + " transform requires a backing tree data source.");
    const g = this.layout(n.method), d = this.fields, k = t.source.root, H = n.as || d;
    n.field ? k.sum(n.field) : k.count(), n.sort && k.sort(stableCompare(n.sort, (AA) => AA.data)), setParams(g, this.params, n), g.separation && g.separation(n.separation !== !1 ? defaultSeparation : one$2);
    try {
      this.value = g(k);
    } catch (AA) {
      error$3(AA);
    }
    return k.each((AA) => setFields(AA, d, H)), t.reflow(n.modified()).modifies(H).modifies("leaf");
  }
});
function setParams(n, t, g) {
  for (let d, k = 0, H = t.length; k < H; ++k)
    d = t[k], d in g && n[d](g[d]);
}
function setFields(n, t, g) {
  const d = n.data, k = t.length - 1;
  for (let H = 0; H < k; ++H)
    d[g[H]] = n[t[H]];
  d[g[k]] = n.children ? n.children.length : 0;
}
const Output$3 = ["x", "y", "r", "depth", "children"];
function Pack(n) {
  HierarchyLayout.call(this, n);
}
Pack.Definition = {
  type: "Pack",
  metadata: {
    tree: !0,
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "sort",
    type: "compare"
  }, {
    name: "padding",
    type: "number",
    default: 0
  }, {
    name: "radius",
    type: "field",
    default: null
  }, {
    name: "size",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: Output$3.length,
    default: Output$3
  }]
};
inherits$1(Pack, HierarchyLayout, {
  layout: pack,
  params: ["radius", "size", "padding"],
  fields: Output$3
});
const Output$2 = ["x0", "y0", "x1", "y1", "depth", "children"];
function Partition(n) {
  HierarchyLayout.call(this, n);
}
Partition.Definition = {
  type: "Partition",
  metadata: {
    tree: !0,
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "sort",
    type: "compare"
  }, {
    name: "padding",
    type: "number",
    default: 0
  }, {
    name: "round",
    type: "boolean",
    default: !1
  }, {
    name: "size",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: Output$2.length,
    default: Output$2
  }]
};
inherits$1(Partition, HierarchyLayout, {
  layout: partition$1,
  params: ["size", "round", "padding"],
  fields: Output$2
});
function Stratify(n) {
  Transform.call(this, null, n);
}
Stratify.Definition = {
  type: "Stratify",
  metadata: {
    treesource: !0
  },
  params: [{
    name: "key",
    type: "field",
    required: !0
  }, {
    name: "parentKey",
    type: "field",
    required: !0
  }]
};
inherits$1(Stratify, Transform, {
  transform(n, t) {
    t.source || error$3("Stratify transform requires an upstream data source.");
    let g = this.value;
    const d = n.modified(), k = t.fork(t.ALL).materialize(t.SOURCE), H = !g || d || t.changed(t.ADD_REM) || t.modified(n.key.fields) || t.modified(n.parentKey.fields);
    return k.source = k.source.slice(), H && (g = k.source.length ? lookup$2(stratify().id(n.key).parentId(n.parentKey)(k.source), n.key, truthy) : lookup$2(stratify()([{}]), n.key, n.key)), k.source.root = this.value = g, k;
  }
});
const Layouts = {
  tidy: tree$1,
  cluster
}, Output$1$1 = ["x", "y", "depth", "children"];
function Tree(n) {
  HierarchyLayout.call(this, n);
}
Tree.Definition = {
  type: "Tree",
  metadata: {
    tree: !0,
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "sort",
    type: "compare"
  }, {
    name: "method",
    type: "enum",
    default: "tidy",
    values: ["tidy", "cluster"]
  }, {
    name: "size",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "nodeSize",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "separation",
    type: "boolean",
    default: !0
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: Output$1$1.length,
    default: Output$1$1
  }]
};
inherits$1(Tree, HierarchyLayout, {
  /**
   * Tree layout generator. Supports both 'tidy' and 'cluster' layouts.
   */
  layout(n) {
    const t = n || "tidy";
    if (has$2(Layouts, t)) return Layouts[t]();
    error$3("Unrecognized Tree layout method: " + t);
  },
  params: ["size", "nodeSize"],
  fields: Output$1$1
});
function TreeLinks(n) {
  Transform.call(this, [], n);
}
TreeLinks.Definition = {
  type: "TreeLinks",
  metadata: {
    tree: !0,
    generates: !0,
    changes: !0
  },
  params: []
};
inherits$1(TreeLinks, Transform, {
  transform(n, t) {
    const g = this.value, d = t.source && t.source.root, k = t.fork(t.NO_SOURCE), H = {};
    return d || error$3("TreeLinks transform requires a tree data source."), t.changed(t.ADD_REM) ? (k.rem = g, t.visit(t.SOURCE, (AA) => H[tupleid(AA)] = 1), d.each((AA) => {
      const gA = AA.data, IA = AA.parent && AA.parent.data;
      IA && H[tupleid(gA)] && H[tupleid(IA)] && k.add.push(ingest$1({
        source: IA,
        target: gA
      }));
    }), this.value = k.add) : t.changed(t.MOD) && (t.visit(t.MOD, (AA) => H[tupleid(AA)] = 1), g.forEach((AA) => {
      (H[tupleid(AA.source)] || H[tupleid(AA.target)]) && k.mod.push(AA);
    })), k;
  }
});
const Tiles = {
  binary: treemapBinary,
  dice: treemapDice,
  slice: treemapSlice,
  slicedice: treemapSliceDice,
  squarify: treemapSquarify,
  resquarify: treemapResquarify
}, Output$4 = ["x0", "y0", "x1", "y1", "depth", "children"];
function Treemap(n) {
  HierarchyLayout.call(this, n);
}
Treemap.Definition = {
  type: "Treemap",
  metadata: {
    tree: !0,
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "sort",
    type: "compare"
  }, {
    name: "method",
    type: "enum",
    default: "squarify",
    values: ["squarify", "resquarify", "binary", "dice", "slice", "slicedice"]
  }, {
    name: "padding",
    type: "number",
    default: 0
  }, {
    name: "paddingInner",
    type: "number",
    default: 0
  }, {
    name: "paddingOuter",
    type: "number",
    default: 0
  }, {
    name: "paddingTop",
    type: "number",
    default: 0
  }, {
    name: "paddingRight",
    type: "number",
    default: 0
  }, {
    name: "paddingBottom",
    type: "number",
    default: 0
  }, {
    name: "paddingLeft",
    type: "number",
    default: 0
  }, {
    name: "ratio",
    type: "number",
    default: 1.618033988749895
  }, {
    name: "round",
    type: "boolean",
    default: !1
  }, {
    name: "size",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: Output$4.length,
    default: Output$4
  }]
};
inherits$1(Treemap, HierarchyLayout, {
  /**
   * Treemap layout generator. Adds 'method' and 'ratio' parameters
   * to configure the underlying tile method.
   */
  layout() {
    const n = treemap();
    return n.ratio = (t) => {
      const g = n.tile();
      g.ratio && n.tile(g.ratio(t));
    }, n.method = (t) => {
      has$2(Tiles, t) ? n.tile(Tiles[t]) : error$3("Unrecognized Treemap layout method: " + t);
    }, n;
  },
  params: ["method", "ratio", "size", "round", "padding", "paddingInner", "paddingOuter", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"],
  fields: Output$4
});
const tree = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  nest: Nest,
  pack: Pack,
  partition: Partition,
  stratify: Stratify,
  tree: Tree,
  treelinks: TreeLinks,
  treemap: Treemap
}, Symbol.toStringTag, { value: "Module" })), ALPHA_MASK = 4278190080;
function baseBitmaps(n, t) {
  const g = n.bitmap();
  return (t || []).forEach((d) => g.set(n(d.boundary[0]), n(d.boundary[3]))), [g, void 0];
}
function markBitmaps(n, t, g, d, k) {
  const H = n.width, AA = n.height, gA = d || k, IA = domCanvas(H, AA).getContext("2d"), CA = domCanvas(H, AA).getContext("2d"), BA = gA && domCanvas(H, AA).getContext("2d");
  g.forEach((hA) => draw(IA, hA, !1)), draw(CA, t, !1), gA && draw(BA, t, !0);
  const eA = getBuffer(IA, H, AA), iA = getBuffer(CA, H, AA), QA = gA && getBuffer(BA, H, AA), tA = n.bitmap(), oA = gA && n.bitmap();
  let EA, aA, nA, lA, cA, sA, rA, uA;
  for (aA = 0; aA < AA; ++aA)
    for (EA = 0; EA < H; ++EA)
      cA = aA * H + EA, sA = eA[cA] & ALPHA_MASK, uA = iA[cA] & ALPHA_MASK, rA = gA && QA[cA] & ALPHA_MASK, (sA || rA || uA) && (nA = n(EA), lA = n(aA), !k && (sA || uA) && tA.set(nA, lA), gA && (sA || rA) && oA.set(nA, lA));
  return [tA, oA];
}
function getBuffer(n, t, g) {
  return new Uint32Array(n.getImageData(0, 0, t, g).data.buffer);
}
function draw(n, t, g) {
  if (!t.length) return;
  const d = t[0].mark.marktype;
  d === "group" ? t.forEach((k) => {
    k.items.forEach((H) => draw(n, H.items, g));
  }) : Marks[d].draw(n, {
    items: g ? t.map(prepare) : t
  });
}
function prepare(n) {
  const t = rederive(n, {});
  return t.stroke && t.strokeOpacity !== 0 || t.fill && t.fillOpacity !== 0 ? {
    ...t,
    strokeOpacity: 1,
    stroke: "#000",
    fillOpacity: 0
  } : t;
}
const DIV = 5, MOD = 31, SIZE$3 = 32, RIGHT0 = new Uint32Array(SIZE$3 + 1), RIGHT1 = new Uint32Array(SIZE$3 + 1);
RIGHT1[0] = 0;
RIGHT0[0] = ~RIGHT1[0];
for (let n = 1; n <= SIZE$3; ++n)
  RIGHT1[n] = RIGHT1[n - 1] << 1 | 1, RIGHT0[n] = ~RIGHT1[n];
function Bitmap(n, t) {
  const g = new Uint32Array(~~((n * t + SIZE$3) / SIZE$3));
  function d(H, AA) {
    g[H] |= AA;
  }
  function k(H, AA) {
    g[H] &= AA;
  }
  return {
    array: g,
    get: (H, AA) => {
      const gA = AA * n + H;
      return g[gA >>> DIV] & 1 << (gA & MOD);
    },
    set: (H, AA) => {
      const gA = AA * n + H;
      d(gA >>> DIV, 1 << (gA & MOD));
    },
    clear: (H, AA) => {
      const gA = AA * n + H;
      k(gA >>> DIV, ~(1 << (gA & MOD)));
    },
    getRange: (H, AA, gA, IA) => {
      let CA = IA, BA, eA, iA, QA;
      for (; CA >= AA; --CA)
        if (BA = CA * n + H, eA = CA * n + gA, iA = BA >>> DIV, QA = eA >>> DIV, iA === QA) {
          if (g[iA] & RIGHT0[BA & MOD] & RIGHT1[(eA & MOD) + 1])
            return !0;
        } else {
          if (g[iA] & RIGHT0[BA & MOD] || g[QA] & RIGHT1[(eA & MOD) + 1]) return !0;
          for (let tA = iA + 1; tA < QA; ++tA)
            if (g[tA]) return !0;
        }
      return !1;
    },
    setRange: (H, AA, gA, IA) => {
      let CA, BA, eA, iA, QA;
      for (; AA <= IA; ++AA)
        if (CA = AA * n + H, BA = AA * n + gA, eA = CA >>> DIV, iA = BA >>> DIV, eA === iA)
          d(eA, RIGHT0[CA & MOD] & RIGHT1[(BA & MOD) + 1]);
        else
          for (d(eA, RIGHT0[CA & MOD]), d(iA, RIGHT1[(BA & MOD) + 1]), QA = eA + 1; QA < iA; ++QA) d(QA, 4294967295);
    },
    clearRange: (H, AA, gA, IA) => {
      let CA, BA, eA, iA, QA;
      for (; AA <= IA; ++AA)
        if (CA = AA * n + H, BA = AA * n + gA, eA = CA >>> DIV, iA = BA >>> DIV, eA === iA)
          k(eA, RIGHT1[CA & MOD] | RIGHT0[(BA & MOD) + 1]);
        else
          for (k(eA, RIGHT1[CA & MOD]), k(iA, RIGHT0[(BA & MOD) + 1]), QA = eA + 1; QA < iA; ++QA) k(QA, 0);
    },
    outOfBounds: (H, AA, gA, IA) => H < 0 || AA < 0 || IA >= t || gA >= n
  };
}
function scaler(n, t, g) {
  const d = Math.max(1, Math.sqrt(n * t / 1e6)), k = ~~((n + 2 * g + d) / d), H = ~~((t + 2 * g + d) / d), AA = (gA) => ~~((gA + g) / d);
  return AA.invert = (gA) => gA * d - g, AA.bitmap = () => Bitmap(k, H), AA.ratio = d, AA.padding = g, AA.width = n, AA.height = t, AA;
}
function placeAreaLabelNaive(n, t, g, d) {
  const k = n.width, H = n.height;
  return function(AA) {
    const gA = AA.datum.datum.items[d].items, IA = gA.length, CA = AA.datum.fontSize, BA = textMetrics.width(AA.datum, AA.datum.text);
    let eA = 0, iA, QA, tA, oA, EA, aA, nA;
    for (let lA = 0; lA < IA; ++lA)
      iA = gA[lA].x, tA = gA[lA].y, QA = gA[lA].x2 === void 0 ? iA : gA[lA].x2, oA = gA[lA].y2 === void 0 ? tA : gA[lA].y2, EA = (iA + QA) / 2, aA = (tA + oA) / 2, nA = Math.abs(QA - iA + oA - tA), nA >= eA && (eA = nA, AA.x = EA, AA.y = aA);
    return EA = BA / 2, aA = CA / 2, iA = AA.x - EA, QA = AA.x + EA, tA = AA.y - aA, oA = AA.y + aA, AA.align = "center", iA < 0 && QA <= k ? AA.align = "left" : 0 <= iA && k < QA && (AA.align = "right"), AA.baseline = "middle", tA < 0 && oA <= H ? AA.baseline = "top" : 0 <= tA && H < oA && (AA.baseline = "bottom"), !0;
  };
}
function outOfBounds(n, t, g, d, k, H) {
  let AA = g / 2;
  return n - AA < 0 || n + AA > k || t - (AA = d / 2) < 0 || t + AA > H;
}
function collision(n, t, g, d, k, H, AA, gA) {
  const IA = k * H / (d * 2), CA = n(t - IA), BA = n(t + IA), eA = n(g - (H = H / 2)), iA = n(g + H);
  return AA.outOfBounds(CA, eA, BA, iA) || AA.getRange(CA, eA, BA, iA) || gA && gA.getRange(CA, eA, BA, iA);
}
function placeAreaLabelReducedSearch(n, t, g, d) {
  const k = n.width, H = n.height, AA = t[0], gA = t[1];
  function IA(CA, BA, eA, iA, QA) {
    const tA = n.invert(CA), oA = n.invert(BA);
    let EA = eA, aA = H, nA;
    if (!outOfBounds(tA, oA, iA, QA, k, H) && !collision(n, tA, oA, QA, iA, EA, AA, gA) && !collision(n, tA, oA, QA, iA, QA, AA, null)) {
      for (; aA - EA >= 1; )
        nA = (EA + aA) / 2, collision(n, tA, oA, QA, iA, nA, AA, gA) ? aA = nA : EA = nA;
      if (EA > eA)
        return [tA, oA, EA, !0];
    }
  }
  return function(CA) {
    const BA = CA.datum.datum.items[d].items, eA = BA.length, iA = CA.datum.fontSize, QA = textMetrics.width(CA.datum, CA.datum.text);
    let tA = g ? iA : 0, oA = !1, EA = !1, aA = 0, nA, lA, cA, sA, rA, uA, hA, dA, GA, DA, wA, bA, yA, pA, MA, LA, xA;
    for (let TA = 0; TA < eA; ++TA) {
      for (nA = BA[TA].x, cA = BA[TA].y, lA = BA[TA].x2 === void 0 ? nA : BA[TA].x2, sA = BA[TA].y2 === void 0 ? cA : BA[TA].y2, nA > lA && (xA = nA, nA = lA, lA = xA), cA > sA && (xA = cA, cA = sA, sA = xA), GA = n(nA), wA = n(lA), DA = ~~((GA + wA) / 2), bA = n(cA), pA = n(sA), yA = ~~((bA + pA) / 2), hA = DA; hA >= GA; --hA)
        for (dA = yA; dA >= bA; --dA)
          LA = IA(hA, dA, tA, QA, iA), LA && ([CA.x, CA.y, tA, oA] = LA);
      for (hA = DA; hA <= wA; ++hA)
        for (dA = yA; dA <= pA; ++dA)
          LA = IA(hA, dA, tA, QA, iA), LA && ([CA.x, CA.y, tA, oA] = LA);
      !oA && !g && (MA = Math.abs(lA - nA + sA - cA), rA = (nA + lA) / 2, uA = (cA + sA) / 2, MA >= aA && !outOfBounds(rA, uA, QA, iA, k, H) && !collision(n, rA, uA, iA, QA, iA, AA, null) && (aA = MA, CA.x = rA, CA.y = uA, EA = !0));
    }
    return oA || EA ? (rA = QA / 2, uA = iA / 2, AA.setRange(n(CA.x - rA), n(CA.y - uA), n(CA.x + rA), n(CA.y + uA)), CA.align = "center", CA.baseline = "middle", !0) : !1;
  };
}
const X_DIR = [-1, -1, 1, 1], Y_DIR = [-1, 1, -1, 1];
function placeAreaLabelFloodFill(n, t, g, d) {
  const k = n.width, H = n.height, AA = t[0], gA = t[1], IA = n.bitmap();
  return function(CA) {
    const BA = CA.datum.datum.items[d].items, eA = BA.length, iA = CA.datum.fontSize, QA = textMetrics.width(CA.datum, CA.datum.text), tA = [];
    let oA = g ? iA : 0, EA = !1, aA = !1, nA = 0, lA, cA, sA, rA, uA, hA, dA, GA, DA, wA, bA, yA;
    for (let pA = 0; pA < eA; ++pA) {
      for (lA = BA[pA].x, sA = BA[pA].y, cA = BA[pA].x2 === void 0 ? lA : BA[pA].x2, rA = BA[pA].y2 === void 0 ? sA : BA[pA].y2, tA.push([n((lA + cA) / 2), n((sA + rA) / 2)]); tA.length; )
        if ([dA, GA] = tA.pop(), !(AA.get(dA, GA) || gA.get(dA, GA) || IA.get(dA, GA))) {
          IA.set(dA, GA);
          for (let MA = 0; MA < 4; ++MA)
            uA = dA + X_DIR[MA], hA = GA + Y_DIR[MA], IA.outOfBounds(uA, hA, uA, hA) || tA.push([uA, hA]);
          if (uA = n.invert(dA), hA = n.invert(GA), DA = oA, wA = H, !outOfBounds(uA, hA, QA, iA, k, H) && !collision(n, uA, hA, iA, QA, DA, AA, gA) && !collision(n, uA, hA, iA, QA, iA, AA, null)) {
            for (; wA - DA >= 1; )
              bA = (DA + wA) / 2, collision(n, uA, hA, iA, QA, bA, AA, gA) ? wA = bA : DA = bA;
            DA > oA && (CA.x = uA, CA.y = hA, oA = DA, EA = !0);
          }
        }
      !EA && !g && (yA = Math.abs(cA - lA + rA - sA), uA = (lA + cA) / 2, hA = (sA + rA) / 2, yA >= nA && !outOfBounds(uA, hA, QA, iA, k, H) && !collision(n, uA, hA, iA, QA, iA, AA, null) && (nA = yA, CA.x = uA, CA.y = hA, aA = !0));
    }
    return EA || aA ? (uA = QA / 2, hA = iA / 2, AA.setRange(n(CA.x - uA), n(CA.y - hA), n(CA.x + uA), n(CA.y + hA)), CA.align = "center", CA.baseline = "middle", !0) : !1;
  };
}
const Aligns = ["right", "center", "left"], Baselines = ["bottom", "middle", "top"];
function placeMarkLabel(n, t, g, d) {
  const k = n.width, H = n.height, AA = t[0], gA = t[1], IA = d.length;
  return function(CA) {
    const BA = CA.boundary, eA = CA.datum.fontSize;
    if (BA[2] < 0 || BA[5] < 0 || BA[0] > k || BA[3] > H)
      return !1;
    let iA = CA.textWidth ?? 0, QA, tA, oA, EA, aA, nA, lA, cA, sA, rA, uA, hA, dA, GA, DA;
    for (let wA = 0; wA < IA; ++wA) {
      if (QA = (g[wA] & 3) - 1, tA = (g[wA] >>> 2 & 3) - 1, oA = QA === 0 && tA === 0 || d[wA] < 0, EA = QA && tA ? Math.SQRT1_2 : 1, aA = d[wA] < 0 ? -1 : 1, nA = BA[1 + QA] + d[wA] * QA * EA, uA = BA[4 + tA] + aA * eA * tA / 2 + d[wA] * tA * EA, cA = uA - eA / 2, sA = uA + eA / 2, hA = n(nA), GA = n(cA), DA = n(sA), !iA)
        if (test$1(hA, hA, GA, DA, AA, gA, nA, nA, cA, sA, BA, oA))
          iA = textMetrics.width(CA.datum, CA.datum.text);
        else
          continue;
      if (rA = nA + aA * iA * QA / 2, nA = rA - iA / 2, lA = rA + iA / 2, hA = n(nA), dA = n(lA), test$1(hA, dA, GA, DA, AA, gA, nA, lA, cA, sA, BA, oA))
        return CA.x = QA ? QA * aA < 0 ? lA : nA : rA, CA.y = tA ? tA * aA < 0 ? sA : cA : uA, CA.align = Aligns[QA * aA + 1], CA.baseline = Baselines[tA * aA + 1], AA.setRange(hA, GA, dA, DA), !0;
    }
    return !1;
  };
}
function test$1(n, t, g, d, k, H, AA, gA, IA, CA, BA, eA) {
  return !(k.outOfBounds(n, g, t, d) || (eA && H || k).getRange(n, g, t, d));
}
const TOP = 0, MIDDLE = 4, BOTTOM = 8, LEFT = 0, CENTER$1 = 1, RIGHT = 2, anchorCode = {
  "top-left": TOP + LEFT,
  top: TOP + CENTER$1,
  "top-right": TOP + RIGHT,
  left: MIDDLE + LEFT,
  middle: MIDDLE + CENTER$1,
  right: MIDDLE + RIGHT,
  "bottom-left": BOTTOM + LEFT,
  bottom: BOTTOM + CENTER$1,
  "bottom-right": BOTTOM + RIGHT
}, placeAreaLabel = {
  naive: placeAreaLabelNaive,
  "reduced-search": placeAreaLabelReducedSearch,
  floodfill: placeAreaLabelFloodFill
};
function labelLayout(n, t, g, d, k, H, AA, gA, IA, CA, BA) {
  if (!n.length) return n;
  const eA = Math.max(d.length, k.length), iA = getOffsets(d, eA), QA = getAnchors(k, eA), tA = markType(n[0].datum), oA = tA === "group" && n[0].datum.items[IA].marktype, EA = oA === "area", aA = markBoundary(tA, oA, gA, IA), nA = CA === null || CA === 1 / 0, lA = EA && BA === "naive";
  let cA = -1, sA = -1;
  const rA = n.map((GA) => {
    const DA = nA ? textMetrics.width(GA, GA.text) : void 0;
    return cA = Math.max(cA, DA), sA = Math.max(sA, GA.fontSize), {
      datum: GA,
      opacity: 0,
      x: void 0,
      y: void 0,
      align: void 0,
      baseline: void 0,
      boundary: aA(GA),
      textWidth: DA
    };
  });
  CA = CA === null || CA === 1 / 0 ? Math.max(cA, sA) + Math.max(...d) : CA;
  const uA = scaler(t[0], t[1], CA);
  let hA;
  if (!lA) {
    g && rA.sort((wA, bA) => g(wA.datum, bA.datum));
    let GA = !1;
    for (let wA = 0; wA < QA.length && !GA; ++wA)
      GA = QA[wA] === 5 || iA[wA] < 0;
    const DA = (tA && AA || EA) && n.map((wA) => wA.datum);
    hA = H.length || DA ? markBitmaps(uA, DA || [], H, GA, EA) : baseBitmaps(uA, AA && rA);
  }
  const dA = EA ? placeAreaLabel[BA](uA, hA, AA, IA) : placeMarkLabel(uA, hA, QA, iA);
  return rA.forEach((GA) => GA.opacity = +dA(GA)), rA;
}
function getOffsets(n, t) {
  const g = new Float64Array(t), d = n.length;
  for (let k = 0; k < d; ++k) g[k] = n[k] || 0;
  for (let k = d; k < t; ++k) g[k] = g[d - 1];
  return g;
}
function getAnchors(n, t) {
  const g = new Int8Array(t), d = n.length;
  for (let k = 0; k < d; ++k) g[k] |= anchorCode[n[k]];
  for (let k = d; k < t; ++k) g[k] = g[d - 1];
  return g;
}
function markType(n) {
  return n && n.mark && n.mark.marktype;
}
function markBoundary(n, t, g, d) {
  const k = (H) => [H.x, H.x, H.x, H.y, H.y, H.y];
  return n ? n === "line" || n === "area" ? (H) => k(H.datum) : t === "line" ? (H) => {
    const AA = H.datum.items[d].items;
    return k(AA.length ? AA[g === "start" ? 0 : AA.length - 1] : {
      x: NaN,
      y: NaN
    });
  } : (H) => {
    const AA = H.datum.bounds;
    return [AA.x1, (AA.x1 + AA.x2) / 2, AA.x2, AA.y1, (AA.y1 + AA.y2) / 2, AA.y2];
  } : k;
}
const Output$1 = ["x", "y", "opacity", "align", "baseline"], Anchors = ["top-left", "left", "bottom-left", "top", "bottom", "top-right", "right", "bottom-right"];
function Label$1(n) {
  Transform.call(this, null, n);
}
Label$1.Definition = {
  type: "Label",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "size",
    type: "number",
    array: !0,
    length: 2,
    required: !0
  }, {
    name: "sort",
    type: "compare"
  }, {
    name: "anchor",
    type: "string",
    array: !0,
    default: Anchors
  }, {
    name: "offset",
    type: "number",
    array: !0,
    default: [1]
  }, {
    name: "padding",
    type: "number",
    default: 0,
    null: !0
  }, {
    name: "lineAnchor",
    type: "string",
    values: ["start", "end"],
    default: "end"
  }, {
    name: "markIndex",
    type: "number",
    default: 0
  }, {
    name: "avoidBaseMark",
    type: "boolean",
    default: !0
  }, {
    name: "avoidMarks",
    type: "data",
    array: !0
  }, {
    name: "method",
    type: "string",
    default: "naive"
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: Output$1.length,
    default: Output$1
  }]
};
inherits$1(Label$1, Transform, {
  transform(n, t) {
    function g(H) {
      const AA = n[H];
      return isFunction$5(AA) && t.modified(AA.fields);
    }
    const d = n.modified();
    if (!(d || t.changed(t.ADD_REM) || g("sort"))) return;
    (!n.size || n.size.length !== 2) && error$3("Size parameter should be specified as a [width, height] array.");
    const k = n.as || Output$1;
    return labelLayout(t.materialize(t.SOURCE).source || [], n.size, n.sort, array$6(n.offset == null ? 1 : n.offset), array$6(n.anchor || Anchors), n.avoidMarks || [], n.avoidBaseMark !== !1, n.lineAnchor || "end", n.markIndex || 0, n.padding === void 0 ? 0 : n.padding, n.method || "naive").forEach((H) => {
      const AA = H.datum;
      AA[k[0]] = H.x, AA[k[1]] = H.y, AA[k[2]] = H.opacity, AA[k[3]] = H.align, AA[k[4]] = H.baseline;
    }), t.reflow(d).modifies(k);
  }
});
const label = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  label: Label$1
}, Symbol.toStringTag, { value: "Module" }));
function partition(n, t) {
  var g = [], d = function(BA) {
    return BA(gA);
  }, k, H, AA, gA, IA, CA;
  if (t == null)
    g.push(n);
  else
    for (k = {}, H = 0, AA = n.length; H < AA; ++H)
      gA = n[H], IA = t.map(d), CA = k[IA], CA || (k[IA] = CA = [], CA.dims = IA, g.push(CA)), CA.push(gA);
  return g;
}
function Loess(n) {
  Transform.call(this, null, n);
}
Loess.Definition = {
  type: "Loess",
  metadata: {
    generates: !0
  },
  params: [{
    name: "x",
    type: "field",
    required: !0
  }, {
    name: "y",
    type: "field",
    required: !0
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "bandwidth",
    type: "number",
    default: 0.3
  }, {
    name: "as",
    type: "string",
    array: !0
  }]
};
inherits$1(Loess, Transform, {
  transform(n, t) {
    const g = t.fork(t.NO_SOURCE | t.NO_FIELDS);
    if (!this.value || t.changed() || n.modified()) {
      const d = t.materialize(t.SOURCE).source, k = partition(d, n.groupby), H = (n.groupby || []).map(accessorName), AA = H.length, gA = n.as || [accessorName(n.x), accessorName(n.y)], IA = [];
      k.forEach((CA) => {
        loess(CA, n.x, n.y, n.bandwidth || 0.3).forEach((BA) => {
          const eA = {};
          for (let iA = 0; iA < AA; ++iA)
            eA[H[iA]] = CA.dims[iA];
          eA[gA[0]] = BA[0], eA[gA[1]] = BA[1], IA.push(ingest$1(eA));
        });
      }), this.value && (g.rem = this.value), this.value = g.add = g.source = IA;
    }
    return g;
  }
});
const Methods = {
  constant: constant$5,
  linear: linear$2,
  log: log$4,
  exp: exp$1,
  pow: pow$3,
  quad,
  poly
}, degreesOfFreedom = (n, t) => n === "poly" ? t : n === "quad" ? 2 : 1;
function Regression(n) {
  Transform.call(this, null, n);
}
Regression.Definition = {
  type: "Regression",
  metadata: {
    generates: !0
  },
  params: [{
    name: "x",
    type: "field",
    required: !0
  }, {
    name: "y",
    type: "field",
    required: !0
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "method",
    type: "string",
    default: "linear",
    values: Object.keys(Methods)
  }, {
    name: "order",
    type: "number",
    default: 3
  }, {
    name: "extent",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "params",
    type: "boolean",
    default: !1
  }, {
    name: "as",
    type: "string",
    array: !0
  }]
};
inherits$1(Regression, Transform, {
  transform(n, t) {
    const g = t.fork(t.NO_SOURCE | t.NO_FIELDS);
    if (!this.value || t.changed() || n.modified()) {
      const d = t.materialize(t.SOURCE).source, k = partition(d, n.groupby), H = (n.groupby || []).map(accessorName), AA = n.method || "linear", gA = n.order == null ? 3 : n.order, IA = degreesOfFreedom(AA, gA), CA = n.as || [accessorName(n.x), accessorName(n.y)], BA = Methods[AA], eA = [];
      let iA = n.extent;
      has$2(Methods, AA) || error$3("Invalid regression method: " + AA), iA != null && AA === "log" && iA[0] <= 0 && (t.dataflow.warn("Ignoring extent with values <= 0 for log regression."), iA = null), k.forEach((QA) => {
        if (QA.length <= IA) {
          t.dataflow.warn("Skipping regression with more parameters than data points.");
          return;
        }
        const oA = BA(QA, n.x, n.y, gA);
        if (n.params) {
          eA.push(ingest$1({
            keys: QA.dims,
            coef: oA.coef,
            rSquared: oA.rSquared
          }));
          return;
        }
        const EA = iA || extent(QA, n.x), aA = (nA) => {
          const lA = {};
          for (let cA = 0; cA < H.length; ++cA)
            lA[H[cA]] = QA.dims[cA];
          lA[CA[0]] = nA[0], lA[CA[1]] = nA[1], eA.push(ingest$1(lA));
        };
        AA === "linear" || AA === "constant" ? EA.forEach((nA) => aA([nA, oA.predict(nA)])) : sampleCurve(oA.predict, EA, 25, 200).forEach(aA);
      }), this.value && (g.rem = this.value), this.value = g.add = g.source = eA;
    }
    return g;
  }
});
const reg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  loess: Loess,
  regression: Regression
}, Symbol.toStringTag, { value: "Module" })), epsilon$1 = 11102230246251565e-32, splitter = 134217729, resulterrbound = (3 + 8 * epsilon$1) * epsilon$1;
function sum(n, t, g, d, k) {
  let H, AA, gA, IA, CA = t[0], BA = d[0], eA = 0, iA = 0;
  BA > CA == BA > -CA ? (H = CA, CA = t[++eA]) : (H = BA, BA = d[++iA]);
  let QA = 0;
  if (eA < n && iA < g)
    for (BA > CA == BA > -CA ? (AA = CA + H, gA = H - (AA - CA), CA = t[++eA]) : (AA = BA + H, gA = H - (AA - BA), BA = d[++iA]), H = AA, gA !== 0 && (k[QA++] = gA); eA < n && iA < g; )
      BA > CA == BA > -CA ? (AA = H + CA, IA = AA - H, gA = H - (AA - IA) + (CA - IA), CA = t[++eA]) : (AA = H + BA, IA = AA - H, gA = H - (AA - IA) + (BA - IA), BA = d[++iA]), H = AA, gA !== 0 && (k[QA++] = gA);
  for (; eA < n; )
    AA = H + CA, IA = AA - H, gA = H - (AA - IA) + (CA - IA), CA = t[++eA], H = AA, gA !== 0 && (k[QA++] = gA);
  for (; iA < g; )
    AA = H + BA, IA = AA - H, gA = H - (AA - IA) + (BA - IA), BA = d[++iA], H = AA, gA !== 0 && (k[QA++] = gA);
  return (H !== 0 || QA === 0) && (k[QA++] = H), QA;
}
function estimate(n, t) {
  let g = t[0];
  for (let d = 1; d < n; d++) g += t[d];
  return g;
}
function vec(n) {
  return new Float64Array(n);
}
const ccwerrboundA = (3 + 16 * epsilon$1) * epsilon$1, ccwerrboundB = (2 + 12 * epsilon$1) * epsilon$1, ccwerrboundC = (9 + 64 * epsilon$1) * epsilon$1 * epsilon$1, B$1 = vec(4), C1 = vec(8), C2 = vec(12), D = vec(16), u$1 = vec(4);
function orient2dadapt(n, t, g, d, k, H, AA) {
  let gA, IA, CA, BA, eA, iA, QA, tA, oA, EA, aA, nA, lA, cA, sA, rA, uA, hA;
  const dA = n - k, GA = g - k, DA = t - H, wA = d - H;
  cA = dA * wA, iA = splitter * dA, QA = iA - (iA - dA), tA = dA - QA, iA = splitter * wA, oA = iA - (iA - wA), EA = wA - oA, sA = tA * EA - (cA - QA * oA - tA * oA - QA * EA), rA = DA * GA, iA = splitter * DA, QA = iA - (iA - DA), tA = DA - QA, iA = splitter * GA, oA = iA - (iA - GA), EA = GA - oA, uA = tA * EA - (rA - QA * oA - tA * oA - QA * EA), aA = sA - uA, eA = sA - aA, B$1[0] = sA - (aA + eA) + (eA - uA), nA = cA + aA, eA = nA - cA, lA = cA - (nA - eA) + (aA - eA), aA = lA - rA, eA = lA - aA, B$1[1] = lA - (aA + eA) + (eA - rA), hA = nA + aA, eA = hA - nA, B$1[2] = nA - (hA - eA) + (aA - eA), B$1[3] = hA;
  let bA = estimate(4, B$1), yA = ccwerrboundB * AA;
  if (bA >= yA || -bA >= yA || (eA = n - dA, gA = n - (dA + eA) + (eA - k), eA = g - GA, CA = g - (GA + eA) + (eA - k), eA = t - DA, IA = t - (DA + eA) + (eA - H), eA = d - wA, BA = d - (wA + eA) + (eA - H), gA === 0 && IA === 0 && CA === 0 && BA === 0) || (yA = ccwerrboundC * AA + resulterrbound * Math.abs(bA), bA += dA * BA + wA * gA - (DA * CA + GA * IA), bA >= yA || -bA >= yA)) return bA;
  cA = gA * wA, iA = splitter * gA, QA = iA - (iA - gA), tA = gA - QA, iA = splitter * wA, oA = iA - (iA - wA), EA = wA - oA, sA = tA * EA - (cA - QA * oA - tA * oA - QA * EA), rA = IA * GA, iA = splitter * IA, QA = iA - (iA - IA), tA = IA - QA, iA = splitter * GA, oA = iA - (iA - GA), EA = GA - oA, uA = tA * EA - (rA - QA * oA - tA * oA - QA * EA), aA = sA - uA, eA = sA - aA, u$1[0] = sA - (aA + eA) + (eA - uA), nA = cA + aA, eA = nA - cA, lA = cA - (nA - eA) + (aA - eA), aA = lA - rA, eA = lA - aA, u$1[1] = lA - (aA + eA) + (eA - rA), hA = nA + aA, eA = hA - nA, u$1[2] = nA - (hA - eA) + (aA - eA), u$1[3] = hA;
  const pA = sum(4, B$1, 4, u$1, C1);
  cA = dA * BA, iA = splitter * dA, QA = iA - (iA - dA), tA = dA - QA, iA = splitter * BA, oA = iA - (iA - BA), EA = BA - oA, sA = tA * EA - (cA - QA * oA - tA * oA - QA * EA), rA = DA * CA, iA = splitter * DA, QA = iA - (iA - DA), tA = DA - QA, iA = splitter * CA, oA = iA - (iA - CA), EA = CA - oA, uA = tA * EA - (rA - QA * oA - tA * oA - QA * EA), aA = sA - uA, eA = sA - aA, u$1[0] = sA - (aA + eA) + (eA - uA), nA = cA + aA, eA = nA - cA, lA = cA - (nA - eA) + (aA - eA), aA = lA - rA, eA = lA - aA, u$1[1] = lA - (aA + eA) + (eA - rA), hA = nA + aA, eA = hA - nA, u$1[2] = nA - (hA - eA) + (aA - eA), u$1[3] = hA;
  const MA = sum(pA, C1, 4, u$1, C2);
  cA = gA * BA, iA = splitter * gA, QA = iA - (iA - gA), tA = gA - QA, iA = splitter * BA, oA = iA - (iA - BA), EA = BA - oA, sA = tA * EA - (cA - QA * oA - tA * oA - QA * EA), rA = IA * CA, iA = splitter * IA, QA = iA - (iA - IA), tA = IA - QA, iA = splitter * CA, oA = iA - (iA - CA), EA = CA - oA, uA = tA * EA - (rA - QA * oA - tA * oA - QA * EA), aA = sA - uA, eA = sA - aA, u$1[0] = sA - (aA + eA) + (eA - uA), nA = cA + aA, eA = nA - cA, lA = cA - (nA - eA) + (aA - eA), aA = lA - rA, eA = lA - aA, u$1[1] = lA - (aA + eA) + (eA - rA), hA = nA + aA, eA = hA - nA, u$1[2] = nA - (hA - eA) + (aA - eA), u$1[3] = hA;
  const LA = sum(MA, C2, 4, u$1, D);
  return D[LA - 1];
}
function orient2d(n, t, g, d, k, H) {
  const AA = (t - H) * (g - k), gA = (n - k) * (d - H), IA = AA - gA, CA = Math.abs(AA + gA);
  return Math.abs(IA) >= ccwerrboundA * CA ? IA : -orient2dadapt(n, t, g, d, k, H, CA);
}
const EPSILON = Math.pow(2, -52), EDGE_STACK = new Uint32Array(512);
class Delaunator {
  static from(t, g = defaultGetX, d = defaultGetY) {
    const k = t.length, H = new Float64Array(k * 2);
    for (let AA = 0; AA < k; AA++) {
      const gA = t[AA];
      H[2 * AA] = g(gA), H[2 * AA + 1] = d(gA);
    }
    return new Delaunator(H);
  }
  constructor(t) {
    const g = t.length >> 1;
    if (g > 0 && typeof t[0] != "number") throw new Error("Expected coords to contain numbers.");
    this.coords = t;
    const d = Math.max(2 * g - 5, 0);
    this._triangles = new Uint32Array(d * 3), this._halfedges = new Int32Array(d * 3), this._hashSize = Math.ceil(Math.sqrt(g)), this._hullPrev = new Uint32Array(g), this._hullNext = new Uint32Array(g), this._hullTri = new Uint32Array(g), this._hullHash = new Int32Array(this._hashSize), this._ids = new Uint32Array(g), this._dists = new Float64Array(g), this.update();
  }
  update() {
    const { coords: t, _hullPrev: g, _hullNext: d, _hullTri: k, _hullHash: H } = this, AA = t.length >> 1;
    let gA = 1 / 0, IA = 1 / 0, CA = -1 / 0, BA = -1 / 0;
    for (let dA = 0; dA < AA; dA++) {
      const GA = t[2 * dA], DA = t[2 * dA + 1];
      GA < gA && (gA = GA), DA < IA && (IA = DA), GA > CA && (CA = GA), DA > BA && (BA = DA), this._ids[dA] = dA;
    }
    const eA = (gA + CA) / 2, iA = (IA + BA) / 2;
    let QA, tA, oA;
    for (let dA = 0, GA = 1 / 0; dA < AA; dA++) {
      const DA = dist$1(eA, iA, t[2 * dA], t[2 * dA + 1]);
      DA < GA && (QA = dA, GA = DA);
    }
    const EA = t[2 * QA], aA = t[2 * QA + 1];
    for (let dA = 0, GA = 1 / 0; dA < AA; dA++) {
      if (dA === QA) continue;
      const DA = dist$1(EA, aA, t[2 * dA], t[2 * dA + 1]);
      DA < GA && DA > 0 && (tA = dA, GA = DA);
    }
    let nA = t[2 * tA], lA = t[2 * tA + 1], cA = 1 / 0;
    for (let dA = 0; dA < AA; dA++) {
      if (dA === QA || dA === tA) continue;
      const GA = circumradius(EA, aA, nA, lA, t[2 * dA], t[2 * dA + 1]);
      GA < cA && (oA = dA, cA = GA);
    }
    let sA = t[2 * oA], rA = t[2 * oA + 1];
    if (cA === 1 / 0) {
      for (let DA = 0; DA < AA; DA++)
        this._dists[DA] = t[2 * DA] - t[0] || t[2 * DA + 1] - t[1];
      quicksort(this._ids, this._dists, 0, AA - 1);
      const dA = new Uint32Array(AA);
      let GA = 0;
      for (let DA = 0, wA = -1 / 0; DA < AA; DA++) {
        const bA = this._ids[DA], yA = this._dists[bA];
        yA > wA && (dA[GA++] = bA, wA = yA);
      }
      this.hull = dA.subarray(0, GA), this.triangles = new Uint32Array(0), this.halfedges = new Uint32Array(0);
      return;
    }
    if (orient2d(EA, aA, nA, lA, sA, rA) < 0) {
      const dA = tA, GA = nA, DA = lA;
      tA = oA, nA = sA, lA = rA, oA = dA, sA = GA, rA = DA;
    }
    const uA = circumcenter(EA, aA, nA, lA, sA, rA);
    this._cx = uA.x, this._cy = uA.y;
    for (let dA = 0; dA < AA; dA++)
      this._dists[dA] = dist$1(t[2 * dA], t[2 * dA + 1], uA.x, uA.y);
    quicksort(this._ids, this._dists, 0, AA - 1), this._hullStart = QA;
    let hA = 3;
    d[QA] = g[oA] = tA, d[tA] = g[QA] = oA, d[oA] = g[tA] = QA, k[QA] = 0, k[tA] = 1, k[oA] = 2, H.fill(-1), H[this._hashKey(EA, aA)] = QA, H[this._hashKey(nA, lA)] = tA, H[this._hashKey(sA, rA)] = oA, this.trianglesLen = 0, this._addTriangle(QA, tA, oA, -1, -1, -1);
    for (let dA = 0, GA, DA; dA < this._ids.length; dA++) {
      const wA = this._ids[dA], bA = t[2 * wA], yA = t[2 * wA + 1];
      if (dA > 0 && Math.abs(bA - GA) <= EPSILON && Math.abs(yA - DA) <= EPSILON || (GA = bA, DA = yA, wA === QA || wA === tA || wA === oA)) continue;
      let pA = 0;
      for (let NA = 0, zA = this._hashKey(bA, yA); NA < this._hashSize && (pA = H[(zA + NA) % this._hashSize], !(pA !== -1 && pA !== d[pA])); NA++)
        ;
      pA = g[pA];
      let MA = pA, LA;
      for (; LA = d[MA], orient2d(bA, yA, t[2 * MA], t[2 * MA + 1], t[2 * LA], t[2 * LA + 1]) >= 0; )
        if (MA = LA, MA === pA) {
          MA = -1;
          break;
        }
      if (MA === -1) continue;
      let xA = this._addTriangle(MA, wA, d[MA], -1, -1, k[MA]);
      k[wA] = this._legalize(xA + 2), k[MA] = xA, hA++;
      let TA = d[MA];
      for (; LA = d[TA], orient2d(bA, yA, t[2 * TA], t[2 * TA + 1], t[2 * LA], t[2 * LA + 1]) < 0; )
        xA = this._addTriangle(TA, wA, LA, k[wA], -1, k[TA]), k[wA] = this._legalize(xA + 2), d[TA] = TA, hA--, TA = LA;
      if (MA === pA)
        for (; LA = g[MA], orient2d(bA, yA, t[2 * LA], t[2 * LA + 1], t[2 * MA], t[2 * MA + 1]) < 0; )
          xA = this._addTriangle(LA, wA, MA, -1, k[MA], k[LA]), this._legalize(xA + 2), k[LA] = xA, d[MA] = MA, hA--, MA = LA;
      this._hullStart = g[wA] = MA, d[MA] = g[TA] = wA, d[wA] = TA, H[this._hashKey(bA, yA)] = wA, H[this._hashKey(t[2 * MA], t[2 * MA + 1])] = MA;
    }
    this.hull = new Uint32Array(hA);
    for (let dA = 0, GA = this._hullStart; dA < hA; dA++)
      this.hull[dA] = GA, GA = d[GA];
    this.triangles = this._triangles.subarray(0, this.trianglesLen), this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
  }
  _hashKey(t, g) {
    return Math.floor(pseudoAngle(t - this._cx, g - this._cy) * this._hashSize) % this._hashSize;
  }
  _legalize(t) {
    const { _triangles: g, _halfedges: d, coords: k } = this;
    let H = 0, AA = 0;
    for (; ; ) {
      const gA = d[t], IA = t - t % 3;
      if (AA = IA + (t + 2) % 3, gA === -1) {
        if (H === 0) break;
        t = EDGE_STACK[--H];
        continue;
      }
      const CA = gA - gA % 3, BA = IA + (t + 1) % 3, eA = CA + (gA + 2) % 3, iA = g[AA], QA = g[t], tA = g[BA], oA = g[eA];
      if (inCircle(
        k[2 * iA],
        k[2 * iA + 1],
        k[2 * QA],
        k[2 * QA + 1],
        k[2 * tA],
        k[2 * tA + 1],
        k[2 * oA],
        k[2 * oA + 1]
      )) {
        g[t] = oA, g[gA] = iA;
        const aA = d[eA];
        if (aA === -1) {
          let lA = this._hullStart;
          do {
            if (this._hullTri[lA] === eA) {
              this._hullTri[lA] = t;
              break;
            }
            lA = this._hullPrev[lA];
          } while (lA !== this._hullStart);
        }
        this._link(t, aA), this._link(gA, d[AA]), this._link(AA, eA);
        const nA = CA + (gA + 1) % 3;
        H < EDGE_STACK.length && (EDGE_STACK[H++] = nA);
      } else {
        if (H === 0) break;
        t = EDGE_STACK[--H];
      }
    }
    return AA;
  }
  _link(t, g) {
    this._halfedges[t] = g, g !== -1 && (this._halfedges[g] = t);
  }
  // add a new triangle given vertex indices and adjacent half-edge ids
  _addTriangle(t, g, d, k, H, AA) {
    const gA = this.trianglesLen;
    return this._triangles[gA] = t, this._triangles[gA + 1] = g, this._triangles[gA + 2] = d, this._link(gA, k), this._link(gA + 1, H), this._link(gA + 2, AA), this.trianglesLen += 3, gA;
  }
}
function pseudoAngle(n, t) {
  const g = n / (Math.abs(n) + Math.abs(t));
  return (t > 0 ? 3 - g : 1 + g) / 4;
}
function dist$1(n, t, g, d) {
  const k = n - g, H = t - d;
  return k * k + H * H;
}
function inCircle(n, t, g, d, k, H, AA, gA) {
  const IA = n - AA, CA = t - gA, BA = g - AA, eA = d - gA, iA = k - AA, QA = H - gA, tA = IA * IA + CA * CA, oA = BA * BA + eA * eA, EA = iA * iA + QA * QA;
  return IA * (eA * EA - oA * QA) - CA * (BA * EA - oA * iA) + tA * (BA * QA - eA * iA) < 0;
}
function circumradius(n, t, g, d, k, H) {
  const AA = g - n, gA = d - t, IA = k - n, CA = H - t, BA = AA * AA + gA * gA, eA = IA * IA + CA * CA, iA = 0.5 / (AA * CA - gA * IA), QA = (CA * BA - gA * eA) * iA, tA = (AA * eA - IA * BA) * iA;
  return QA * QA + tA * tA;
}
function circumcenter(n, t, g, d, k, H) {
  const AA = g - n, gA = d - t, IA = k - n, CA = H - t, BA = AA * AA + gA * gA, eA = IA * IA + CA * CA, iA = 0.5 / (AA * CA - gA * IA), QA = n + (CA * BA - gA * eA) * iA, tA = t + (AA * eA - IA * BA) * iA;
  return { x: QA, y: tA };
}
function quicksort(n, t, g, d) {
  if (d - g <= 20)
    for (let k = g + 1; k <= d; k++) {
      const H = n[k], AA = t[H];
      let gA = k - 1;
      for (; gA >= g && t[n[gA]] > AA; ) n[gA + 1] = n[gA--];
      n[gA + 1] = H;
    }
  else {
    const k = g + d >> 1;
    let H = g + 1, AA = d;
    swap(n, k, H), t[n[g]] > t[n[d]] && swap(n, g, d), t[n[H]] > t[n[d]] && swap(n, H, d), t[n[g]] > t[n[H]] && swap(n, g, H);
    const gA = n[H], IA = t[gA];
    for (; ; ) {
      do
        H++;
      while (t[n[H]] < IA);
      do
        AA--;
      while (t[n[AA]] > IA);
      if (AA < H) break;
      swap(n, H, AA);
    }
    n[g + 1] = n[AA], n[AA] = gA, d - H + 1 >= AA - g ? (quicksort(n, t, H, d), quicksort(n, t, g, AA - 1)) : (quicksort(n, t, g, AA - 1), quicksort(n, t, H, d));
  }
}
function swap(n, t, g) {
  const d = n[t];
  n[t] = n[g], n[g] = d;
}
function defaultGetX(n) {
  return n[0];
}
function defaultGetY(n) {
  return n[1];
}
const epsilon = 1e-6;
class Path {
  constructor() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "";
  }
  moveTo(t, g) {
    this._ += `M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +g}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  }
  lineTo(t, g) {
    this._ += `L${this._x1 = +t},${this._y1 = +g}`;
  }
  arc(t, g, d) {
    t = +t, g = +g, d = +d;
    const k = t + d, H = g;
    if (d < 0) throw new Error("negative radius");
    this._x1 === null ? this._ += `M${k},${H}` : (Math.abs(this._x1 - k) > epsilon || Math.abs(this._y1 - H) > epsilon) && (this._ += "L" + k + "," + H), d && (this._ += `A${d},${d},0,1,1,${t - d},${g}A${d},${d},0,1,1,${this._x1 = k},${this._y1 = H}`);
  }
  rect(t, g, d, k) {
    this._ += `M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +g}h${+d}v${+k}h${-d}Z`;
  }
  value() {
    return this._ || null;
  }
}
class Polygon {
  constructor() {
    this._ = [];
  }
  moveTo(t, g) {
    this._.push([t, g]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(t, g) {
    this._.push([t, g]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}
let Voronoi$1 = class {
  constructor(t, [g, d, k, H] = [0, 0, 960, 500]) {
    if (!((k = +k) >= (g = +g)) || !((H = +H) >= (d = +d))) throw new Error("invalid bounds");
    this.delaunay = t, this._circumcenters = new Float64Array(t.points.length * 2), this.vectors = new Float64Array(t.points.length * 2), this.xmax = k, this.xmin = g, this.ymax = H, this.ymin = d, this._init();
  }
  update() {
    return this.delaunay.update(), this._init(), this;
  }
  _init() {
    const { delaunay: { points: t, hull: g, triangles: d }, vectors: k } = this;
    let H, AA;
    const gA = this.circumcenters = this._circumcenters.subarray(0, d.length / 3 * 2);
    for (let oA = 0, EA = 0, aA = d.length, nA, lA; oA < aA; oA += 3, EA += 2) {
      const cA = d[oA] * 2, sA = d[oA + 1] * 2, rA = d[oA + 2] * 2, uA = t[cA], hA = t[cA + 1], dA = t[sA], GA = t[sA + 1], DA = t[rA], wA = t[rA + 1], bA = dA - uA, yA = GA - hA, pA = DA - uA, MA = wA - hA, LA = (bA * MA - yA * pA) * 2;
      if (Math.abs(LA) < 1e-9) {
        if (H === void 0) {
          H = AA = 0;
          for (const TA of g) H += t[TA * 2], AA += t[TA * 2 + 1];
          H /= g.length, AA /= g.length;
        }
        const xA = 1e9 * Math.sign((H - uA) * MA - (AA - hA) * pA);
        nA = (uA + DA) / 2 - xA * MA, lA = (hA + wA) / 2 + xA * pA;
      } else {
        const xA = 1 / LA, TA = bA * bA + yA * yA, NA = pA * pA + MA * MA;
        nA = uA + (MA * TA - yA * NA) * xA, lA = hA + (bA * NA - pA * TA) * xA;
      }
      gA[EA] = nA, gA[EA + 1] = lA;
    }
    let IA = g[g.length - 1], CA, BA = IA * 4, eA, iA = t[2 * IA], QA, tA = t[2 * IA + 1];
    k.fill(0);
    for (let oA = 0; oA < g.length; ++oA)
      IA = g[oA], CA = BA, eA = iA, QA = tA, BA = IA * 4, iA = t[2 * IA], tA = t[2 * IA + 1], k[CA + 2] = k[BA] = QA - tA, k[CA + 3] = k[BA + 1] = iA - eA;
  }
  render(t) {
    const g = t == null ? t = new Path() : void 0, { delaunay: { halfedges: d, inedges: k, hull: H }, circumcenters: AA, vectors: gA } = this;
    if (H.length <= 1) return null;
    for (let BA = 0, eA = d.length; BA < eA; ++BA) {
      const iA = d[BA];
      if (iA < BA) continue;
      const QA = Math.floor(BA / 3) * 2, tA = Math.floor(iA / 3) * 2, oA = AA[QA], EA = AA[QA + 1], aA = AA[tA], nA = AA[tA + 1];
      this._renderSegment(oA, EA, aA, nA, t);
    }
    let IA, CA = H[H.length - 1];
    for (let BA = 0; BA < H.length; ++BA) {
      IA = CA, CA = H[BA];
      const eA = Math.floor(k[CA] / 3) * 2, iA = AA[eA], QA = AA[eA + 1], tA = IA * 4, oA = this._project(iA, QA, gA[tA + 2], gA[tA + 3]);
      oA && this._renderSegment(iA, QA, oA[0], oA[1], t);
    }
    return g && g.value();
  }
  renderBounds(t) {
    const g = t == null ? t = new Path() : void 0;
    return t.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin), g && g.value();
  }
  renderCell(t, g) {
    const d = g == null ? g = new Path() : void 0, k = this._clip(t);
    if (k === null || !k.length) return;
    g.moveTo(k[0], k[1]);
    let H = k.length;
    for (; k[0] === k[H - 2] && k[1] === k[H - 1] && H > 1; ) H -= 2;
    for (let AA = 2; AA < H; AA += 2)
      (k[AA] !== k[AA - 2] || k[AA + 1] !== k[AA - 1]) && g.lineTo(k[AA], k[AA + 1]);
    return g.closePath(), d && d.value();
  }
  *cellPolygons() {
    const { delaunay: { points: t } } = this;
    for (let g = 0, d = t.length / 2; g < d; ++g) {
      const k = this.cellPolygon(g);
      k && (k.index = g, yield k);
    }
  }
  cellPolygon(t) {
    const g = new Polygon();
    return this.renderCell(t, g), g.value();
  }
  _renderSegment(t, g, d, k, H) {
    let AA;
    const gA = this._regioncode(t, g), IA = this._regioncode(d, k);
    gA === 0 && IA === 0 ? (H.moveTo(t, g), H.lineTo(d, k)) : (AA = this._clipSegment(t, g, d, k, gA, IA)) && (H.moveTo(AA[0], AA[1]), H.lineTo(AA[2], AA[3]));
  }
  contains(t, g, d) {
    return g = +g, g !== g || (d = +d, d !== d) ? !1 : this.delaunay._step(t, g, d) === t;
  }
  *neighbors(t) {
    const g = this._clip(t);
    if (g) for (const d of this.delaunay.neighbors(t)) {
      const k = this._clip(d);
      if (k) {
        A: for (let H = 0, AA = g.length; H < AA; H += 2)
          for (let gA = 0, IA = k.length; gA < IA; gA += 2)
            if (g[H] === k[gA] && g[H + 1] === k[gA + 1] && g[(H + 2) % AA] === k[(gA + IA - 2) % IA] && g[(H + 3) % AA] === k[(gA + IA - 1) % IA]) {
              yield d;
              break A;
            }
      }
    }
  }
  _cell(t) {
    const { circumcenters: g, delaunay: { inedges: d, halfedges: k, triangles: H } } = this, AA = d[t];
    if (AA === -1) return null;
    const gA = [];
    let IA = AA;
    do {
      const CA = Math.floor(IA / 3);
      if (gA.push(g[CA * 2], g[CA * 2 + 1]), IA = IA % 3 === 2 ? IA - 2 : IA + 1, H[IA] !== t) break;
      IA = k[IA];
    } while (IA !== AA && IA !== -1);
    return gA;
  }
  _clip(t) {
    if (t === 0 && this.delaunay.hull.length === 1)
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    const g = this._cell(t);
    if (g === null) return null;
    const { vectors: d } = this, k = t * 4;
    return this._simplify(d[k] || d[k + 1] ? this._clipInfinite(t, g, d[k], d[k + 1], d[k + 2], d[k + 3]) : this._clipFinite(t, g));
  }
  _clipFinite(t, g) {
    const d = g.length;
    let k = null, H, AA, gA = g[d - 2], IA = g[d - 1], CA, BA = this._regioncode(gA, IA), eA, iA = 0;
    for (let QA = 0; QA < d; QA += 2)
      if (H = gA, AA = IA, gA = g[QA], IA = g[QA + 1], CA = BA, BA = this._regioncode(gA, IA), CA === 0 && BA === 0)
        eA = iA, iA = 0, k ? k.push(gA, IA) : k = [gA, IA];
      else {
        let tA, oA, EA, aA, nA;
        if (CA === 0) {
          if ((tA = this._clipSegment(H, AA, gA, IA, CA, BA)) === null) continue;
          [oA, EA, aA, nA] = tA;
        } else {
          if ((tA = this._clipSegment(gA, IA, H, AA, BA, CA)) === null) continue;
          [aA, nA, oA, EA] = tA, eA = iA, iA = this._edgecode(oA, EA), eA && iA && this._edge(t, eA, iA, k, k.length), k ? k.push(oA, EA) : k = [oA, EA];
        }
        eA = iA, iA = this._edgecode(aA, nA), eA && iA && this._edge(t, eA, iA, k, k.length), k ? k.push(aA, nA) : k = [aA, nA];
      }
    if (k)
      eA = iA, iA = this._edgecode(k[0], k[1]), eA && iA && this._edge(t, eA, iA, k, k.length);
    else if (this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2))
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    return k;
  }
  _clipSegment(t, g, d, k, H, AA) {
    const gA = H < AA;
    for (gA && ([t, g, d, k, H, AA] = [d, k, t, g, AA, H]); ; ) {
      if (H === 0 && AA === 0) return gA ? [d, k, t, g] : [t, g, d, k];
      if (H & AA) return null;
      let IA, CA, BA = H || AA;
      BA & 8 ? (IA = t + (d - t) * (this.ymax - g) / (k - g), CA = this.ymax) : BA & 4 ? (IA = t + (d - t) * (this.ymin - g) / (k - g), CA = this.ymin) : BA & 2 ? (CA = g + (k - g) * (this.xmax - t) / (d - t), IA = this.xmax) : (CA = g + (k - g) * (this.xmin - t) / (d - t), IA = this.xmin), H ? (t = IA, g = CA, H = this._regioncode(t, g)) : (d = IA, k = CA, AA = this._regioncode(d, k));
    }
  }
  _clipInfinite(t, g, d, k, H, AA) {
    let gA = Array.from(g), IA;
    if ((IA = this._project(gA[0], gA[1], d, k)) && gA.unshift(IA[0], IA[1]), (IA = this._project(gA[gA.length - 2], gA[gA.length - 1], H, AA)) && gA.push(IA[0], IA[1]), gA = this._clipFinite(t, gA))
      for (let CA = 0, BA = gA.length, eA, iA = this._edgecode(gA[BA - 2], gA[BA - 1]); CA < BA; CA += 2)
        eA = iA, iA = this._edgecode(gA[CA], gA[CA + 1]), eA && iA && (CA = this._edge(t, eA, iA, gA, CA), BA = gA.length);
    else this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2) && (gA = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax]);
    return gA;
  }
  _edge(t, g, d, k, H) {
    for (; g !== d; ) {
      let AA, gA;
      switch (g) {
        case 5:
          g = 4;
          continue;
        // top-left
        case 4:
          g = 6, AA = this.xmax, gA = this.ymin;
          break;
        // top
        case 6:
          g = 2;
          continue;
        // top-right
        case 2:
          g = 10, AA = this.xmax, gA = this.ymax;
          break;
        // right
        case 10:
          g = 8;
          continue;
        // bottom-right
        case 8:
          g = 9, AA = this.xmin, gA = this.ymax;
          break;
        // bottom
        case 9:
          g = 1;
          continue;
        // bottom-left
        case 1:
          g = 5, AA = this.xmin, gA = this.ymin;
          break;
      }
      (k[H] !== AA || k[H + 1] !== gA) && this.contains(t, AA, gA) && (k.splice(H, 0, AA, gA), H += 2);
    }
    return H;
  }
  _project(t, g, d, k) {
    let H = 1 / 0, AA, gA, IA;
    if (k < 0) {
      if (g <= this.ymin) return null;
      (AA = (this.ymin - g) / k) < H && (IA = this.ymin, gA = t + (H = AA) * d);
    } else if (k > 0) {
      if (g >= this.ymax) return null;
      (AA = (this.ymax - g) / k) < H && (IA = this.ymax, gA = t + (H = AA) * d);
    }
    if (d > 0) {
      if (t >= this.xmax) return null;
      (AA = (this.xmax - t) / d) < H && (gA = this.xmax, IA = g + (H = AA) * k);
    } else if (d < 0) {
      if (t <= this.xmin) return null;
      (AA = (this.xmin - t) / d) < H && (gA = this.xmin, IA = g + (H = AA) * k);
    }
    return [gA, IA];
  }
  _edgecode(t, g) {
    return (t === this.xmin ? 1 : t === this.xmax ? 2 : 0) | (g === this.ymin ? 4 : g === this.ymax ? 8 : 0);
  }
  _regioncode(t, g) {
    return (t < this.xmin ? 1 : t > this.xmax ? 2 : 0) | (g < this.ymin ? 4 : g > this.ymax ? 8 : 0);
  }
  _simplify(t) {
    if (t && t.length > 4) {
      for (let g = 0; g < t.length; g += 2) {
        const d = (g + 2) % t.length, k = (g + 4) % t.length;
        (t[g] === t[d] && t[d] === t[k] || t[g + 1] === t[d + 1] && t[d + 1] === t[k + 1]) && (t.splice(d, 2), g -= 2);
      }
      t.length || (t = null);
    }
    return t;
  }
};
const tau = 2 * Math.PI, pow = Math.pow;
function pointX(n) {
  return n[0];
}
function pointY(n) {
  return n[1];
}
function collinear(n) {
  const { triangles: t, coords: g } = n;
  for (let d = 0; d < t.length; d += 3) {
    const k = 2 * t[d], H = 2 * t[d + 1], AA = 2 * t[d + 2];
    if ((g[AA] - g[k]) * (g[H + 1] - g[k + 1]) - (g[H] - g[k]) * (g[AA + 1] - g[k + 1]) > 1e-10) return !1;
  }
  return !0;
}
function jitter(n, t, g) {
  return [n + Math.sin(n + t) * g, t + Math.cos(n - t) * g];
}
class Delaunay {
  static from(t, g = pointX, d = pointY, k) {
    return new Delaunay("length" in t ? flatArray(t, g, d, k) : Float64Array.from(flatIterable(t, g, d, k)));
  }
  constructor(t) {
    this._delaunator = new Delaunator(t), this.inedges = new Int32Array(t.length / 2), this._hullIndex = new Int32Array(t.length / 2), this.points = this._delaunator.coords, this._init();
  }
  update() {
    return this._delaunator.update(), this._init(), this;
  }
  _init() {
    const t = this._delaunator, g = this.points;
    if (t.hull && t.hull.length > 2 && collinear(t)) {
      this.collinear = Int32Array.from({ length: g.length / 2 }, (iA, QA) => QA).sort((iA, QA) => g[2 * iA] - g[2 * QA] || g[2 * iA + 1] - g[2 * QA + 1]);
      const IA = this.collinear[0], CA = this.collinear[this.collinear.length - 1], BA = [g[2 * IA], g[2 * IA + 1], g[2 * CA], g[2 * CA + 1]], eA = 1e-8 * Math.hypot(BA[3] - BA[1], BA[2] - BA[0]);
      for (let iA = 0, QA = g.length / 2; iA < QA; ++iA) {
        const tA = jitter(g[2 * iA], g[2 * iA + 1], eA);
        g[2 * iA] = tA[0], g[2 * iA + 1] = tA[1];
      }
      this._delaunator = new Delaunator(g);
    } else
      delete this.collinear;
    const d = this.halfedges = this._delaunator.halfedges, k = this.hull = this._delaunator.hull, H = this.triangles = this._delaunator.triangles, AA = this.inedges.fill(-1), gA = this._hullIndex.fill(-1);
    for (let IA = 0, CA = d.length; IA < CA; ++IA) {
      const BA = H[IA % 3 === 2 ? IA - 2 : IA + 1];
      (d[IA] === -1 || AA[BA] === -1) && (AA[BA] = IA);
    }
    for (let IA = 0, CA = k.length; IA < CA; ++IA)
      gA[k[IA]] = IA;
    k.length <= 2 && k.length > 0 && (this.triangles = new Int32Array(3).fill(-1), this.halfedges = new Int32Array(3).fill(-1), this.triangles[0] = k[0], AA[k[0]] = 1, k.length === 2 && (AA[k[1]] = 0, this.triangles[1] = k[1], this.triangles[2] = k[1]));
  }
  voronoi(t) {
    return new Voronoi$1(this, t);
  }
  *neighbors(t) {
    const { inedges: g, hull: d, _hullIndex: k, halfedges: H, triangles: AA, collinear: gA } = this;
    if (gA) {
      const eA = gA.indexOf(t);
      eA > 0 && (yield gA[eA - 1]), eA < gA.length - 1 && (yield gA[eA + 1]);
      return;
    }
    const IA = g[t];
    if (IA === -1) return;
    let CA = IA, BA = -1;
    do {
      if (yield BA = AA[CA], CA = CA % 3 === 2 ? CA - 2 : CA + 1, AA[CA] !== t) return;
      if (CA = H[CA], CA === -1) {
        const eA = d[(k[t] + 1) % d.length];
        eA !== BA && (yield eA);
        return;
      }
    } while (CA !== IA);
  }
  find(t, g, d = 0) {
    if (t = +t, t !== t || (g = +g, g !== g)) return -1;
    const k = d;
    let H;
    for (; (H = this._step(d, t, g)) >= 0 && H !== d && H !== k; ) d = H;
    return H;
  }
  _step(t, g, d) {
    const { inedges: k, hull: H, _hullIndex: AA, halfedges: gA, triangles: IA, points: CA } = this;
    if (k[t] === -1 || !CA.length) return (t + 1) % (CA.length >> 1);
    let BA = t, eA = pow(g - CA[t * 2], 2) + pow(d - CA[t * 2 + 1], 2);
    const iA = k[t];
    let QA = iA;
    do {
      let tA = IA[QA];
      const oA = pow(g - CA[tA * 2], 2) + pow(d - CA[tA * 2 + 1], 2);
      if (oA < eA && (eA = oA, BA = tA), QA = QA % 3 === 2 ? QA - 2 : QA + 1, IA[QA] !== t) break;
      if (QA = gA[QA], QA === -1) {
        if (QA = H[(AA[t] + 1) % H.length], QA !== tA && pow(g - CA[QA * 2], 2) + pow(d - CA[QA * 2 + 1], 2) < eA)
          return QA;
        break;
      }
    } while (QA !== iA);
    return BA;
  }
  render(t) {
    const g = t == null ? t = new Path() : void 0, { points: d, halfedges: k, triangles: H } = this;
    for (let AA = 0, gA = k.length; AA < gA; ++AA) {
      const IA = k[AA];
      if (IA < AA) continue;
      const CA = H[AA] * 2, BA = H[IA] * 2;
      t.moveTo(d[CA], d[CA + 1]), t.lineTo(d[BA], d[BA + 1]);
    }
    return this.renderHull(t), g && g.value();
  }
  renderPoints(t, g) {
    g === void 0 && (!t || typeof t.moveTo != "function") && (g = t, t = null), g = g == null ? 2 : +g;
    const d = t == null ? t = new Path() : void 0, { points: k } = this;
    for (let H = 0, AA = k.length; H < AA; H += 2) {
      const gA = k[H], IA = k[H + 1];
      t.moveTo(gA + g, IA), t.arc(gA, IA, g, 0, tau);
    }
    return d && d.value();
  }
  renderHull(t) {
    const g = t == null ? t = new Path() : void 0, { hull: d, points: k } = this, H = d[0] * 2, AA = d.length;
    t.moveTo(k[H], k[H + 1]);
    for (let gA = 1; gA < AA; ++gA) {
      const IA = 2 * d[gA];
      t.lineTo(k[IA], k[IA + 1]);
    }
    return t.closePath(), g && g.value();
  }
  hullPolygon() {
    const t = new Polygon();
    return this.renderHull(t), t.value();
  }
  renderTriangle(t, g) {
    const d = g == null ? g = new Path() : void 0, { points: k, triangles: H } = this, AA = H[t *= 3] * 2, gA = H[t + 1] * 2, IA = H[t + 2] * 2;
    return g.moveTo(k[AA], k[AA + 1]), g.lineTo(k[gA], k[gA + 1]), g.lineTo(k[IA], k[IA + 1]), g.closePath(), d && d.value();
  }
  *trianglePolygons() {
    const { triangles: t } = this;
    for (let g = 0, d = t.length / 3; g < d; ++g)
      yield this.trianglePolygon(g);
  }
  trianglePolygon(t) {
    const g = new Polygon();
    return this.renderTriangle(t, g), g.value();
  }
}
function flatArray(n, t, g, d) {
  const k = n.length, H = new Float64Array(k * 2);
  for (let AA = 0; AA < k; ++AA) {
    const gA = n[AA];
    H[AA * 2] = t.call(d, gA, AA, n), H[AA * 2 + 1] = g.call(d, gA, AA, n);
  }
  return H;
}
function* flatIterable(n, t, g, d) {
  let k = 0;
  for (const H of n)
    yield t.call(d, H, k, n), yield g.call(d, H, k, n), ++k;
}
function Voronoi(n) {
  Transform.call(this, null, n);
}
Voronoi.Definition = {
  type: "Voronoi",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "x",
    type: "field",
    required: !0
  }, {
    name: "y",
    type: "field",
    required: !0
  }, {
    name: "size",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "extent",
    type: "array",
    array: !0,
    length: 2,
    default: [[-1e5, -1e5], [1e5, 1e5]],
    content: {
      type: "number",
      array: !0,
      length: 2
    }
  }, {
    name: "as",
    type: "string",
    default: "path"
  }]
};
const defaultExtent = [-1e5, -1e5, 1e5, 1e5];
inherits$1(Voronoi, Transform, {
  transform(n, t) {
    const g = n.as || "path", d = t.source;
    if (!d || !d.length) return t;
    let k = n.size;
    k = k ? [0, 0, k[0], k[1]] : (k = n.extent) ? [k[0][0], k[0][1], k[1][0], k[1][1]] : defaultExtent;
    const H = this.value = Delaunay.from(d, n.x, n.y).voronoi(k);
    for (let AA = 0, gA = d.length; AA < gA; ++AA) {
      const IA = H.cellPolygon(AA);
      d[AA][g] = IA && !isPoint(IA) ? toPathString(IA) : null;
    }
    return t.reflow(n.modified()).modifies(g);
  }
});
function toPathString(n) {
  const t = n[0][0], g = n[0][1];
  let d = n.length - 1;
  for (; n[d][0] === t && n[d][1] === g; --d) ;
  return "M" + n.slice(0, d + 1).join("L") + "Z";
}
function isPoint(n) {
  return n.length === 2 && n[0][0] === n[1][0] && n[0][1] === n[1][1];
}
const voronoi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  voronoi: Voronoi
}, Symbol.toStringTag, { value: "Module" }));
var cloudRadians = Math.PI / 180, cw = 64, ch = 2048;
function cloud() {
  var n = [256, 256], t, g, d, k, H, AA, gA, IA = archimedeanSpiral, CA = [], BA = Math.random, eA = {};
  eA.layout = function() {
    for (var tA = iA(domCanvas()), oA = zeroArray((n[0] >> 5) * n[1]), EA = null, aA = CA.length, nA = -1, lA = [], cA = CA.map((rA) => ({
      text: t(rA),
      font: g(rA),
      style: k(rA),
      weight: H(rA),
      rotate: AA(rA),
      size: ~~(d(rA) + 1e-14),
      padding: gA(rA),
      xoff: 0,
      yoff: 0,
      x1: 0,
      y1: 0,
      x0: 0,
      y0: 0,
      hasText: !1,
      sprite: null,
      datum: rA
    })).sort((rA, uA) => uA.size - rA.size); ++nA < aA; ) {
      var sA = cA[nA];
      sA.x = n[0] * (BA() + 0.5) >> 1, sA.y = n[1] * (BA() + 0.5) >> 1, cloudSprite(tA, sA, cA, nA), sA.hasText && QA(oA, sA, EA) && (lA.push(sA), EA ? cloudBounds(EA, sA) : EA = [{
        x: sA.x + sA.x0,
        y: sA.y + sA.y0
      }, {
        x: sA.x + sA.x1,
        y: sA.y + sA.y1
      }], sA.x -= n[0] >> 1, sA.y -= n[1] >> 1);
    }
    return lA;
  };
  function iA(tA) {
    tA.width = tA.height = 1;
    var oA = Math.sqrt(tA.getContext("2d").getImageData(0, 0, 1, 1).data.length >> 2);
    tA.width = (cw << 5) / oA, tA.height = ch / oA;
    var EA = tA.getContext("2d");
    return EA.fillStyle = EA.strokeStyle = "red", EA.textAlign = "center", {
      context: EA,
      ratio: oA
    };
  }
  function QA(tA, oA, EA) {
    for (var aA = oA.x, nA = oA.y, lA = Math.hypot(n[0], n[1]), cA = IA(n), sA = BA() < 0.5 ? 1 : -1, rA = -sA, uA, hA, dA; (uA = cA(rA += sA)) && (hA = ~~uA[0], dA = ~~uA[1], !(Math.min(Math.abs(hA), Math.abs(dA)) >= lA)); )
      if (oA.x = aA + hA, oA.y = nA + dA, !(oA.x + oA.x0 < 0 || oA.y + oA.y0 < 0 || oA.x + oA.x1 > n[0] || oA.y + oA.y1 > n[1]) && (!EA || !cloudCollide(oA, tA, n[0])) && (!EA || collideRects(oA, EA))) {
        for (var GA = oA.sprite, DA = oA.width >> 5, wA = n[0] >> 5, bA = oA.x - (DA << 4), yA = bA & 127, pA = 32 - yA, MA = oA.y1 - oA.y0, LA = (oA.y + oA.y0) * wA + (bA >> 5), xA, TA = 0; TA < MA; TA++) {
          xA = 0;
          for (var NA = 0; NA <= DA; NA++)
            tA[LA + NA] |= xA << pA | (NA < DA ? (xA = GA[TA * DA + NA]) >>> yA : 0);
          LA += wA;
        }
        return oA.sprite = null, !0;
      }
    return !1;
  }
  return eA.words = function(tA) {
    return arguments.length ? (CA = tA, eA) : CA;
  }, eA.size = function(tA) {
    return arguments.length ? (n = [+tA[0], +tA[1]], eA) : n;
  }, eA.font = function(tA) {
    return arguments.length ? (g = functor(tA), eA) : g;
  }, eA.fontStyle = function(tA) {
    return arguments.length ? (k = functor(tA), eA) : k;
  }, eA.fontWeight = function(tA) {
    return arguments.length ? (H = functor(tA), eA) : H;
  }, eA.rotate = function(tA) {
    return arguments.length ? (AA = functor(tA), eA) : AA;
  }, eA.text = function(tA) {
    return arguments.length ? (t = functor(tA), eA) : t;
  }, eA.spiral = function(tA) {
    return arguments.length ? (IA = spirals[tA] || tA, eA) : IA;
  }, eA.fontSize = function(tA) {
    return arguments.length ? (d = functor(tA), eA) : d;
  }, eA.padding = function(tA) {
    return arguments.length ? (gA = functor(tA), eA) : gA;
  }, eA.random = function(tA) {
    return arguments.length ? (BA = tA, eA) : BA;
  }, eA;
}
function cloudSprite(n, t, g, d) {
  if (!t.sprite) {
    var k = n.context, H = n.ratio;
    k.clearRect(0, 0, (cw << 5) / H, ch / H);
    var AA = 0, gA = 0, IA = 0, CA = g.length, BA, eA, iA, QA, tA;
    for (--d; ++d < CA; ) {
      if (t = g[d], k.save(), k.font = t.style + " " + t.weight + " " + ~~((t.size + 1) / H) + "px " + t.font, BA = k.measureText(t.text + "m").width * H, iA = t.size << 1, t.rotate) {
        var oA = Math.sin(t.rotate * cloudRadians), EA = Math.cos(t.rotate * cloudRadians), aA = BA * EA, nA = BA * oA, lA = iA * EA, cA = iA * oA;
        BA = Math.max(Math.abs(aA + cA), Math.abs(aA - cA)) + 31 >> 5 << 5, iA = ~~Math.max(Math.abs(nA + lA), Math.abs(nA - lA));
      } else
        BA = BA + 31 >> 5 << 5;
      if (iA > IA && (IA = iA), AA + BA >= cw << 5 && (AA = 0, gA += IA, IA = 0), gA + iA >= ch) break;
      k.translate((AA + (BA >> 1)) / H, (gA + (iA >> 1)) / H), t.rotate && k.rotate(t.rotate * cloudRadians), k.fillText(t.text, 0, 0), t.padding && (k.lineWidth = 2 * t.padding, k.strokeText(t.text, 0, 0)), k.restore(), t.width = BA, t.height = iA, t.xoff = AA, t.yoff = gA, t.x1 = BA >> 1, t.y1 = iA >> 1, t.x0 = -t.x1, t.y0 = -t.y1, t.hasText = !0, AA += BA;
    }
    for (var sA = k.getImageData(0, 0, (cw << 5) / H, ch / H).data, rA = []; --d >= 0; )
      if (t = g[d], !!t.hasText) {
        for (BA = t.width, eA = BA >> 5, iA = t.y1 - t.y0, QA = 0; QA < iA * eA; QA++) rA[QA] = 0;
        if (AA = t.xoff, AA == null) return;
        gA = t.yoff;
        var uA = 0, hA = -1;
        for (tA = 0; tA < iA; tA++) {
          for (QA = 0; QA < BA; QA++) {
            var dA = eA * tA + (QA >> 5), GA = sA[(gA + tA) * (cw << 5) + (AA + QA) << 2] ? 1 << 31 - QA % 32 : 0;
            rA[dA] |= GA, uA |= GA;
          }
          uA ? hA = tA : (t.y0++, iA--, tA--, gA++);
        }
        t.y1 = t.y0 + hA, t.sprite = rA.slice(0, (t.y1 - t.y0) * eA);
      }
  }
}
function cloudCollide(n, t, g) {
  g >>= 5;
  for (var d = n.sprite, k = n.width >> 5, H = n.x - (k << 4), AA = H & 127, gA = 32 - AA, IA = n.y1 - n.y0, CA = (n.y + n.y0) * g + (H >> 5), BA, eA = 0; eA < IA; eA++) {
    BA = 0;
    for (var iA = 0; iA <= k; iA++)
      if ((BA << gA | (iA < k ? (BA = d[eA * k + iA]) >>> AA : 0)) & t[CA + iA]) return !0;
    CA += g;
  }
  return !1;
}
function cloudBounds(n, t) {
  var g = n[0], d = n[1];
  t.x + t.x0 < g.x && (g.x = t.x + t.x0), t.y + t.y0 < g.y && (g.y = t.y + t.y0), t.x + t.x1 > d.x && (d.x = t.x + t.x1), t.y + t.y1 > d.y && (d.y = t.y + t.y1);
}
function collideRects(n, t) {
  return n.x + n.x1 > t[0].x && n.x + n.x0 < t[1].x && n.y + n.y1 > t[0].y && n.y + n.y0 < t[1].y;
}
function archimedeanSpiral(n) {
  var t = n[0] / n[1];
  return function(g) {
    return [t * (g *= 0.1) * Math.cos(g), g * Math.sin(g)];
  };
}
function rectangularSpiral(n) {
  var t = 4, g = t * n[0] / n[1], d = 0, k = 0;
  return function(H) {
    var AA = H < 0 ? -1 : 1;
    switch (Math.sqrt(1 + 4 * AA * H) - AA & 3) {
      case 0:
        d += g;
        break;
      case 1:
        k += t;
        break;
      case 2:
        d -= g;
        break;
      default:
        k -= t;
        break;
    }
    return [d, k];
  };
}
function zeroArray(n) {
  for (var t = [], g = -1; ++g < n; ) t[g] = 0;
  return t;
}
function functor(n) {
  return typeof n == "function" ? n : function() {
    return n;
  };
}
var spirals = {
  archimedean: archimedeanSpiral,
  rectangular: rectangularSpiral
};
const Output = ["x", "y", "font", "fontSize", "fontStyle", "fontWeight", "angle"], Params$1 = ["text", "font", "rotate", "fontSize", "fontStyle", "fontWeight"];
function Wordcloud(n) {
  Transform.call(this, cloud(), n);
}
Wordcloud.Definition = {
  type: "Wordcloud",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "size",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "font",
    type: "string",
    expr: !0,
    default: "sans-serif"
  }, {
    name: "fontStyle",
    type: "string",
    expr: !0,
    default: "normal"
  }, {
    name: "fontWeight",
    type: "string",
    expr: !0,
    default: "normal"
  }, {
    name: "fontSize",
    type: "number",
    expr: !0,
    default: 14
  }, {
    name: "fontSizeRange",
    type: "number",
    array: "nullable",
    default: [10, 50]
  }, {
    name: "rotate",
    type: "number",
    expr: !0,
    default: 0
  }, {
    name: "text",
    type: "field"
  }, {
    name: "spiral",
    type: "string",
    values: ["archimedean", "rectangular"]
  }, {
    name: "padding",
    type: "number",
    expr: !0
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 7,
    default: Output
  }]
};
inherits$1(Wordcloud, Transform, {
  transform(n, t) {
    n.size && !(n.size[0] && n.size[1]) && error$3("Wordcloud size dimensions must be non-zero.");
    function g(tA) {
      const oA = n[tA];
      return isFunction$5(oA) && t.modified(oA.fields);
    }
    const d = n.modified();
    if (!(d || t.changed(t.ADD_REM) || Params$1.some(g))) return;
    const k = t.materialize(t.SOURCE).source, H = this.value, AA = n.as || Output;
    let gA = n.fontSize || 14, IA;
    if (isFunction$5(gA) ? IA = n.fontSizeRange : gA = constant$6(gA), IA) {
      const tA = gA, oA = scale$4("sqrt")().domain(extent(k, tA)).range(IA);
      gA = (EA) => oA(tA(EA));
    }
    k.forEach((tA) => {
      tA[AA[0]] = NaN, tA[AA[1]] = NaN, tA[AA[3]] = 0;
    });
    const CA = H.words(k).text(n.text).size(n.size || [500, 500]).padding(n.padding || 1).spiral(n.spiral || "archimedean").rotate(n.rotate || 0).font(n.font || "sans-serif").fontStyle(n.fontStyle || "normal").fontWeight(n.fontWeight || "normal").fontSize(gA).random(random).layout(), BA = H.size(), eA = BA[0] >> 1, iA = BA[1] >> 1, QA = CA.length;
    for (let tA = 0, oA, EA; tA < QA; ++tA)
      oA = CA[tA], EA = oA.datum, EA[AA[0]] = oA.x + eA, EA[AA[1]] = oA.y + iA, EA[AA[2]] = oA.font, EA[AA[3]] = oA.size, EA[AA[4]] = oA.style, EA[AA[5]] = oA.weight, EA[AA[6]] = oA.rotate;
    return t.reflow(d).modifies(AA);
  }
});
const wordcloud = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  wordcloud: Wordcloud
}, Symbol.toStringTag, { value: "Module" })), array8 = (n) => new Uint8Array(n), array16 = (n) => new Uint16Array(n), array32 = (n) => new Uint32Array(n);
function Bitmaps() {
  let n = 8, t = [], g = array32(0), d = array$2(0, n), k = array$2(0, n);
  return {
    data: () => t,
    seen: () => g = lengthen(g, t.length),
    add(H) {
      for (let AA = 0, gA = t.length, IA = H.length, CA; AA < IA; ++AA)
        CA = H[AA], CA._index = gA++, t.push(CA);
    },
    remove(H, AA) {
      const gA = t.length, IA = Array(gA - H), CA = t;
      let BA, eA, iA;
      for (eA = 0; !AA[eA] && eA < gA; ++eA)
        IA[eA] = t[eA], CA[eA] = eA;
      for (iA = eA; eA < gA; ++eA)
        BA = t[eA], AA[eA] ? CA[eA] = -1 : (CA[eA] = iA, d[iA] = d[eA], k[iA] = k[eA], IA[iA] = BA, BA._index = iA++), d[eA] = 0;
      return t = IA, CA;
    },
    size: () => t.length,
    curr: () => d,
    prev: () => k,
    reset: (H) => k[H] = d[H],
    all: () => n < 257 ? 255 : n < 65537 ? 65535 : 4294967295,
    set(H, AA) {
      d[H] |= AA;
    },
    clear(H, AA) {
      d[H] &= ~AA;
    },
    resize(H, AA) {
      const gA = d.length;
      (H > gA || AA > n) && (n = Math.max(AA, n), d = array$2(H, n, d), k = array$2(H, n));
    }
  };
}
function lengthen(n, t, g) {
  return n.length >= t ? n : (g = g || new n.constructor(t), g.set(n), g);
}
function array$2(n, t, g) {
  const d = (t < 257 ? array8 : t < 65537 ? array16 : array32)(n);
  return g && d.set(g), d;
}
function Dimension(n, t, g) {
  const d = 1 << t;
  return {
    one: d,
    zero: ~d,
    range: g.slice(),
    bisect: n.bisect,
    index: n.index,
    size: n.size,
    onAdd(k, H) {
      const AA = this, gA = AA.bisect(AA.range, k.value), IA = k.index, CA = gA[0], BA = gA[1], eA = IA.length;
      let iA;
      for (iA = 0; iA < CA; ++iA) H[IA[iA]] |= d;
      for (iA = BA; iA < eA; ++iA) H[IA[iA]] |= d;
      return AA;
    }
  };
}
function SortedIndex() {
  let n = array32(0), t = [], g = 0;
  function d(gA, IA, CA) {
    if (!IA.length) return [];
    const BA = g, eA = IA.length, iA = array32(eA);
    let QA = Array(eA), tA, oA, EA;
    for (EA = 0; EA < eA; ++EA)
      QA[EA] = gA(IA[EA]), iA[EA] = EA;
    if (QA = sort$1(QA, iA), BA)
      tA = t, oA = n, t = Array(BA + eA), n = array32(BA + eA), merge$3(CA, tA, oA, BA, QA, iA, eA, t, n);
    else {
      if (CA > 0) for (EA = 0; EA < eA; ++EA)
        iA[EA] += CA;
      t = QA, n = iA;
    }
    return g = BA + eA, {
      index: iA,
      value: QA
    };
  }
  function k(gA, IA) {
    const CA = g;
    let BA, eA, iA;
    for (eA = 0; !IA[n[eA]] && eA < CA; ++eA) ;
    for (iA = eA; eA < CA; ++eA)
      IA[BA = n[eA]] || (n[iA] = BA, t[iA] = t[eA], ++iA);
    g = CA - gA;
  }
  function H(gA) {
    for (let IA = 0, CA = g; IA < CA; ++IA)
      n[IA] = gA[n[IA]];
  }
  function AA(gA, IA) {
    let CA;
    return IA ? CA = IA.length : (IA = t, CA = g), [bisectLeft$1(IA, gA[0], 0, CA), bisectRight$1(IA, gA[1], 0, CA)];
  }
  return {
    insert: d,
    remove: k,
    bisect: AA,
    reindex: H,
    index: () => n,
    size: () => g
  };
}
function sort$1(n, t) {
  return n.sort.call(t, (g, d) => {
    const k = n[g], H = n[d];
    return k < H ? -1 : k > H ? 1 : 0;
  }), permute(n, t);
}
function merge$3(n, t, g, d, k, H, AA, gA, IA) {
  let CA = 0, BA = 0, eA;
  for (eA = 0; CA < d && BA < AA; ++eA)
    t[CA] < k[BA] ? (gA[eA] = t[CA], IA[eA] = g[CA++]) : (gA[eA] = k[BA], IA[eA] = H[BA++] + n);
  for (; CA < d; ++CA, ++eA)
    gA[eA] = t[CA], IA[eA] = g[CA];
  for (; BA < AA; ++BA, ++eA)
    gA[eA] = k[BA], IA[eA] = H[BA] + n;
}
function CrossFilter(n) {
  Transform.call(this, Bitmaps(), n), this._indices = null, this._dims = null;
}
CrossFilter.Definition = {
  type: "CrossFilter",
  metadata: {},
  params: [{
    name: "fields",
    type: "field",
    array: !0,
    required: !0
  }, {
    name: "query",
    type: "array",
    array: !0,
    required: !0,
    content: {
      type: "number",
      array: !0,
      length: 2
    }
  }]
};
inherits$1(CrossFilter, Transform, {
  transform(n, t) {
    if (this._dims) {
      var g = n.modified("fields") || n.fields.some((d) => t.modified(d.fields));
      return g ? this.reinit(n, t) : this.eval(n, t);
    } else
      return this.init(n, t);
  },
  init(n, t) {
    const g = n.fields, d = n.query, k = this._indices = {}, H = this._dims = [], AA = d.length;
    let gA = 0, IA, CA;
    for (; gA < AA; ++gA)
      IA = g[gA].fname, CA = k[IA] || (k[IA] = SortedIndex()), H.push(Dimension(CA, gA, d[gA]));
    return this.eval(n, t);
  },
  reinit(n, t) {
    const g = t.materialize().fork(), d = n.fields, k = n.query, H = this._indices, AA = this._dims, gA = this.value, IA = gA.curr(), CA = gA.prev(), BA = gA.all(), eA = g.rem = g.add, iA = g.mod, QA = k.length, tA = {};
    let oA, EA, aA, nA, lA, cA, sA, rA, uA;
    if (CA.set(IA), t.rem.length && (lA = this.remove(n, t, g)), t.add.length && gA.add(t.add), t.mod.length)
      for (cA = {}, nA = t.mod, sA = 0, rA = nA.length; sA < rA; ++sA)
        cA[nA[sA]._index] = 1;
    for (sA = 0; sA < QA; ++sA)
      uA = d[sA], (!AA[sA] || n.modified("fields", sA) || t.modified(uA.fields)) && (aA = uA.fname, (oA = tA[aA]) || (H[aA] = EA = SortedIndex(), tA[aA] = oA = EA.insert(uA, t.source, 0)), AA[sA] = Dimension(EA, sA, k[sA]).onAdd(oA, IA));
    for (sA = 0, rA = gA.data().length; sA < rA; ++sA)
      lA[sA] || (CA[sA] !== IA[sA] ? eA.push(sA) : cA[sA] && IA[sA] !== BA && iA.push(sA));
    return gA.mask = (1 << QA) - 1, g;
  },
  eval(n, t) {
    const g = t.materialize().fork(), d = this._dims.length;
    let k = 0;
    return t.rem.length && (this.remove(n, t, g), k |= (1 << d) - 1), n.modified("query") && !n.modified("fields") && (k |= this.update(n, t, g)), t.add.length && (this.insert(n, t, g), k |= (1 << d) - 1), t.mod.length && (this.modify(t, g), k |= (1 << d) - 1), this.value.mask = k, g;
  },
  insert(n, t, g) {
    const d = t.add, k = this.value, H = this._dims, AA = this._indices, gA = n.fields, IA = {}, CA = g.add, BA = k.size() + d.length, eA = H.length;
    let iA = k.size(), QA, tA, oA;
    k.resize(BA, eA), k.add(d);
    const EA = k.curr(), aA = k.prev(), nA = k.all();
    for (QA = 0; QA < eA; ++QA)
      tA = gA[QA].fname, oA = IA[tA] || (IA[tA] = AA[tA].insert(gA[QA], d, iA)), H[QA].onAdd(oA, EA);
    for (; iA < BA; ++iA)
      aA[iA] = nA, EA[iA] !== nA && CA.push(iA);
  },
  modify(n, t) {
    const g = t.mod, d = this.value, k = d.curr(), H = d.all(), AA = n.mod;
    let gA, IA, CA;
    for (gA = 0, IA = AA.length; gA < IA; ++gA)
      CA = AA[gA]._index, k[CA] !== H && g.push(CA);
  },
  remove(n, t, g) {
    const d = this._indices, k = this.value, H = k.curr(), AA = k.prev(), gA = k.all(), IA = {}, CA = g.rem, BA = t.rem;
    let eA, iA, QA, tA;
    for (eA = 0, iA = BA.length; eA < iA; ++eA)
      QA = BA[eA]._index, IA[QA] = 1, AA[QA] = tA = H[QA], H[QA] = gA, tA !== gA && CA.push(QA);
    for (QA in d)
      d[QA].remove(iA, IA);
    return this.reindex(t, iA, IA), IA;
  },
  // reindex filters and indices after propagation completes
  reindex(n, t, g) {
    const d = this._indices, k = this.value;
    n.runAfter(() => {
      const H = k.remove(t, g);
      for (const AA in d) d[AA].reindex(H);
    });
  },
  update(n, t, g) {
    const d = this._dims, k = n.query, H = t.stamp, AA = d.length;
    let gA = 0, IA, CA;
    for (g.filters = 0, CA = 0; CA < AA; ++CA)
      n.modified("query", CA) && (IA = CA, ++gA);
    if (gA === 1)
      gA = d[IA].one, this.incrementOne(d[IA], k[IA], g.add, g.rem);
    else
      for (CA = 0, gA = 0; CA < AA; ++CA)
        n.modified("query", CA) && (gA |= d[CA].one, this.incrementAll(d[CA], k[CA], H, g.add), g.rem = g.add);
    return gA;
  },
  incrementAll(n, t, g, d) {
    const k = this.value, H = k.seen(), AA = k.curr(), gA = k.prev(), IA = n.index(), CA = n.bisect(n.range), BA = n.bisect(t), eA = BA[0], iA = BA[1], QA = CA[0], tA = CA[1], oA = n.one;
    let EA, aA, nA;
    if (eA < QA)
      for (EA = eA, aA = Math.min(QA, iA); EA < aA; ++EA)
        nA = IA[EA], H[nA] !== g && (gA[nA] = AA[nA], H[nA] = g, d.push(nA)), AA[nA] ^= oA;
    else if (eA > QA)
      for (EA = QA, aA = Math.min(eA, tA); EA < aA; ++EA)
        nA = IA[EA], H[nA] !== g && (gA[nA] = AA[nA], H[nA] = g, d.push(nA)), AA[nA] ^= oA;
    if (iA > tA)
      for (EA = Math.max(eA, tA), aA = iA; EA < aA; ++EA)
        nA = IA[EA], H[nA] !== g && (gA[nA] = AA[nA], H[nA] = g, d.push(nA)), AA[nA] ^= oA;
    else if (iA < tA)
      for (EA = Math.max(QA, iA), aA = tA; EA < aA; ++EA)
        nA = IA[EA], H[nA] !== g && (gA[nA] = AA[nA], H[nA] = g, d.push(nA)), AA[nA] ^= oA;
    n.range = t.slice();
  },
  incrementOne(n, t, g, d) {
    const k = this.value, H = k.curr(), AA = n.index(), gA = n.bisect(n.range), IA = n.bisect(t), CA = IA[0], BA = IA[1], eA = gA[0], iA = gA[1], QA = n.one;
    let tA, oA, EA;
    if (CA < eA)
      for (tA = CA, oA = Math.min(eA, BA); tA < oA; ++tA)
        EA = AA[tA], H[EA] ^= QA, g.push(EA);
    else if (CA > eA)
      for (tA = eA, oA = Math.min(CA, iA); tA < oA; ++tA)
        EA = AA[tA], H[EA] ^= QA, d.push(EA);
    if (BA > iA)
      for (tA = Math.max(CA, iA), oA = BA; tA < oA; ++tA)
        EA = AA[tA], H[EA] ^= QA, g.push(EA);
    else if (BA < iA)
      for (tA = Math.max(eA, BA), oA = iA; tA < oA; ++tA)
        EA = AA[tA], H[EA] ^= QA, d.push(EA);
    n.range = t.slice();
  }
});
function ResolveFilter(n) {
  Transform.call(this, null, n);
}
ResolveFilter.Definition = {
  type: "ResolveFilter",
  metadata: {},
  params: [{
    name: "ignore",
    type: "number",
    required: !0,
    description: "A bit mask indicating which filters to ignore."
  }, {
    name: "filter",
    type: "object",
    required: !0,
    description: "Per-tuple filter bitmaps from a CrossFilter transform."
  }]
};
inherits$1(ResolveFilter, Transform, {
  transform(n, t) {
    const g = ~(n.ignore || 0), d = n.filter, k = d.mask;
    if ((k & g) === 0) return t.StopPropagation;
    const H = t.fork(t.ALL), AA = d.data(), gA = d.curr(), IA = d.prev(), CA = (BA) => gA[BA] & g ? null : AA[BA];
    return H.filter(H.MOD, CA), k & k - 1 ? (H.filter(H.ADD, (BA) => {
      const eA = gA[BA] & g;
      return !eA && eA ^ IA[BA] & g ? AA[BA] : null;
    }), H.filter(H.REM, (BA) => {
      const eA = gA[BA] & g;
      return eA && !(eA ^ (eA ^ IA[BA] & g)) ? AA[BA] : null;
    })) : (H.filter(H.ADD, CA), H.filter(H.REM, (BA) => (gA[BA] & g) === k ? AA[BA] : null)), H.filter(H.SOURCE, (BA) => CA(BA._index));
  }
});
const xf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  crossfilter: CrossFilter,
  resolvefilter: ResolveFilter
}, Symbol.toStringTag, { value: "Module" })), RawCode$1 = "RawCode", Literal$1 = "Literal", Property$1 = "Property", Identifier$1 = "Identifier", ArrayExpression$1 = "ArrayExpression", BinaryExpression$1 = "BinaryExpression", CallExpression$1 = "CallExpression", ConditionalExpression$1 = "ConditionalExpression", LogicalExpression$1 = "LogicalExpression", MemberExpression$1 = "MemberExpression", ObjectExpression$1 = "ObjectExpression", UnaryExpression$1 = "UnaryExpression";
function ASTNode$1(n) {
  this.type = n;
}
ASTNode$1.prototype.visit = function(n) {
  let t, g, d;
  if (n(this)) return 1;
  for (t = children$1(this), g = 0, d = t.length; g < d; ++g)
    if (t[g].visit(n)) return 1;
};
function children$1(n) {
  switch (n.type) {
    case ArrayExpression$1:
      return n.elements;
    case BinaryExpression$1:
    case LogicalExpression$1:
      return [n.left, n.right];
    case CallExpression$1:
      return [n.callee].concat(n.arguments);
    case ConditionalExpression$1:
      return [n.test, n.consequent, n.alternate];
    case MemberExpression$1:
      return [n.object, n.property];
    case ObjectExpression$1:
      return n.properties;
    case Property$1:
      return [n.key, n.value];
    case UnaryExpression$1:
      return [n.argument];
    case Identifier$1:
    case Literal$1:
    case RawCode$1:
    default:
      return [];
  }
}
var TokenName$1, source$1, index$2, length$1, lookahead$1, TokenBooleanLiteral$1 = 1, TokenEOF$1 = 2, TokenIdentifier$1 = 3, TokenKeyword$1 = 4, TokenNullLiteral$1 = 5, TokenNumericLiteral$1 = 6, TokenPunctuator$1 = 7, TokenStringLiteral$1 = 8, TokenRegularExpression$1 = 9;
TokenName$1 = {};
TokenName$1[TokenBooleanLiteral$1] = "Boolean";
TokenName$1[TokenEOF$1] = "<end>";
TokenName$1[TokenIdentifier$1] = "Identifier";
TokenName$1[TokenKeyword$1] = "Keyword";
TokenName$1[TokenNullLiteral$1] = "Null";
TokenName$1[TokenNumericLiteral$1] = "Numeric";
TokenName$1[TokenPunctuator$1] = "Punctuator";
TokenName$1[TokenStringLiteral$1] = "String";
TokenName$1[TokenRegularExpression$1] = "RegularExpression";
var SyntaxArrayExpression$1 = "ArrayExpression", SyntaxBinaryExpression$1 = "BinaryExpression", SyntaxCallExpression$1 = "CallExpression", SyntaxConditionalExpression$1 = "ConditionalExpression", SyntaxIdentifier$1 = "Identifier", SyntaxLiteral$1 = "Literal", SyntaxLogicalExpression$1 = "LogicalExpression", SyntaxMemberExpression$1 = "MemberExpression", SyntaxObjectExpression$1 = "ObjectExpression", SyntaxProperty$1 = "Property", SyntaxUnaryExpression$1 = "UnaryExpression", MessageUnexpectedToken$1 = "Unexpected token %0", MessageUnexpectedNumber$1 = "Unexpected number", MessageUnexpectedString$1 = "Unexpected string", MessageUnexpectedIdentifier$1 = "Unexpected identifier", MessageUnexpectedReserved$1 = "Unexpected reserved word", MessageUnexpectedEOS$1 = "Unexpected end of input", MessageInvalidRegExp$1 = "Invalid regular expression", MessageUnterminatedRegExp$1 = "Invalid regular expression: missing /", MessageStrictOctalLiteral$1 = "Octal literals are not allowed in strict mode.", MessageStrictDuplicateProperty$1 = "Duplicate data property in object literal not allowed in strict mode", ILLEGAL$2 = "ILLEGAL", DISABLED$1 = "Disabled.", RegexNonAsciiIdentifierStart$1 = new RegExp("[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0-\\u08B2\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]"), RegexNonAsciiIdentifierPart$1 = new RegExp("[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0300-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u0483-\\u0487\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u0591-\\u05BD\\u05BF\\u05C1\\u05C2\\u05C4\\u05C5\\u05C7\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0610-\\u061A\\u0620-\\u0669\\u066E-\\u06D3\\u06D5-\\u06DC\\u06DF-\\u06E8\\u06EA-\\u06FC\\u06FF\\u0710-\\u074A\\u074D-\\u07B1\\u07C0-\\u07F5\\u07FA\\u0800-\\u082D\\u0840-\\u085B\\u08A0-\\u08B2\\u08E4-\\u0963\\u0966-\\u096F\\u0971-\\u0983\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BC-\\u09C4\\u09C7\\u09C8\\u09CB-\\u09CE\\u09D7\\u09DC\\u09DD\\u09DF-\\u09E3\\u09E6-\\u09F1\\u0A01-\\u0A03\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A3C\\u0A3E-\\u0A42\\u0A47\\u0A48\\u0A4B-\\u0A4D\\u0A51\\u0A59-\\u0A5C\\u0A5E\\u0A66-\\u0A75\\u0A81-\\u0A83\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABC-\\u0AC5\\u0AC7-\\u0AC9\\u0ACB-\\u0ACD\\u0AD0\\u0AE0-\\u0AE3\\u0AE6-\\u0AEF\\u0B01-\\u0B03\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3C-\\u0B44\\u0B47\\u0B48\\u0B4B-\\u0B4D\\u0B56\\u0B57\\u0B5C\\u0B5D\\u0B5F-\\u0B63\\u0B66-\\u0B6F\\u0B71\\u0B82\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BBE-\\u0BC2\\u0BC6-\\u0BC8\\u0BCA-\\u0BCD\\u0BD0\\u0BD7\\u0BE6-\\u0BEF\\u0C00-\\u0C03\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D-\\u0C44\\u0C46-\\u0C48\\u0C4A-\\u0C4D\\u0C55\\u0C56\\u0C58\\u0C59\\u0C60-\\u0C63\\u0C66-\\u0C6F\\u0C81-\\u0C83\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBC-\\u0CC4\\u0CC6-\\u0CC8\\u0CCA-\\u0CCD\\u0CD5\\u0CD6\\u0CDE\\u0CE0-\\u0CE3\\u0CE6-\\u0CEF\\u0CF1\\u0CF2\\u0D01-\\u0D03\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D-\\u0D44\\u0D46-\\u0D48\\u0D4A-\\u0D4E\\u0D57\\u0D60-\\u0D63\\u0D66-\\u0D6F\\u0D7A-\\u0D7F\\u0D82\\u0D83\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0DCA\\u0DCF-\\u0DD4\\u0DD6\\u0DD8-\\u0DDF\\u0DE6-\\u0DEF\\u0DF2\\u0DF3\\u0E01-\\u0E3A\\u0E40-\\u0E4E\\u0E50-\\u0E59\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB9\\u0EBB-\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EC8-\\u0ECD\\u0ED0-\\u0ED9\\u0EDC-\\u0EDF\\u0F00\\u0F18\\u0F19\\u0F20-\\u0F29\\u0F35\\u0F37\\u0F39\\u0F3E-\\u0F47\\u0F49-\\u0F6C\\u0F71-\\u0F84\\u0F86-\\u0F97\\u0F99-\\u0FBC\\u0FC6\\u1000-\\u1049\\u1050-\\u109D\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u135D-\\u135F\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1714\\u1720-\\u1734\\u1740-\\u1753\\u1760-\\u176C\\u176E-\\u1770\\u1772\\u1773\\u1780-\\u17D3\\u17D7\\u17DC\\u17DD\\u17E0-\\u17E9\\u180B-\\u180D\\u1810-\\u1819\\u1820-\\u1877\\u1880-\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1920-\\u192B\\u1930-\\u193B\\u1946-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19B0-\\u19C9\\u19D0-\\u19D9\\u1A00-\\u1A1B\\u1A20-\\u1A5E\\u1A60-\\u1A7C\\u1A7F-\\u1A89\\u1A90-\\u1A99\\u1AA7\\u1AB0-\\u1ABD\\u1B00-\\u1B4B\\u1B50-\\u1B59\\u1B6B-\\u1B73\\u1B80-\\u1BF3\\u1C00-\\u1C37\\u1C40-\\u1C49\\u1C4D-\\u1C7D\\u1CD0-\\u1CD2\\u1CD4-\\u1CF6\\u1CF8\\u1CF9\\u1D00-\\u1DF5\\u1DFC-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u200C\\u200D\\u203F\\u2040\\u2054\\u2071\\u207F\\u2090-\\u209C\\u20D0-\\u20DC\\u20E1\\u20E5-\\u20F0\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D7F-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2DE0-\\u2DFF\\u2E2F\\u3005-\\u3007\\u3021-\\u302F\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u3099\\u309A\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA62B\\uA640-\\uA66F\\uA674-\\uA67D\\uA67F-\\uA69D\\uA69F-\\uA6F1\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA827\\uA840-\\uA873\\uA880-\\uA8C4\\uA8D0-\\uA8D9\\uA8E0-\\uA8F7\\uA8FB\\uA900-\\uA92D\\uA930-\\uA953\\uA960-\\uA97C\\uA980-\\uA9C0\\uA9CF-\\uA9D9\\uA9E0-\\uA9FE\\uAA00-\\uAA36\\uAA40-\\uAA4D\\uAA50-\\uAA59\\uAA60-\\uAA76\\uAA7A-\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEF\\uAAF2-\\uAAF6\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABEA\\uABEC\\uABED\\uABF0-\\uABF9\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE00-\\uFE0F\\uFE20-\\uFE2D\\uFE33\\uFE34\\uFE4D-\\uFE4F\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF10-\\uFF19\\uFF21-\\uFF3A\\uFF3F\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]");
function assert$1(n, t) {
  if (!n)
    throw new Error("ASSERT: " + t);
}
function isDecimalDigit$1(n) {
  return n >= 48 && n <= 57;
}
function isHexDigit$1(n) {
  return "0123456789abcdefABCDEF".includes(n);
}
function isOctalDigit$1(n) {
  return "01234567".includes(n);
}
function isWhiteSpace$1(n) {
  return n === 32 || n === 9 || n === 11 || n === 12 || n === 160 || n >= 5760 && [5760, 6158, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279].includes(n);
}
function isLineTerminator$1(n) {
  return n === 10 || n === 13 || n === 8232 || n === 8233;
}
function isIdentifierStart$1(n) {
  return n === 36 || n === 95 || // $ (dollar) and _ (underscore)
  n >= 65 && n <= 90 || // A..Z
  n >= 97 && n <= 122 || // a..z
  n === 92 || // \ (backslash)
  n >= 128 && RegexNonAsciiIdentifierStart$1.test(String.fromCharCode(n));
}
function isIdentifierPart$1(n) {
  return n === 36 || n === 95 || // $ (dollar) and _ (underscore)
  n >= 65 && n <= 90 || // A..Z
  n >= 97 && n <= 122 || // a..z
  n >= 48 && n <= 57 || // 0..9
  n === 92 || // \ (backslash)
  n >= 128 && RegexNonAsciiIdentifierPart$1.test(String.fromCharCode(n));
}
const keywords$1 = {
  if: 1,
  in: 1,
  do: 1,
  var: 1,
  for: 1,
  new: 1,
  try: 1,
  let: 1,
  this: 1,
  else: 1,
  case: 1,
  void: 1,
  with: 1,
  enum: 1,
  while: 1,
  break: 1,
  catch: 1,
  throw: 1,
  const: 1,
  yield: 1,
  class: 1,
  super: 1,
  return: 1,
  typeof: 1,
  delete: 1,
  switch: 1,
  export: 1,
  import: 1,
  public: 1,
  static: 1,
  default: 1,
  finally: 1,
  extends: 1,
  package: 1,
  private: 1,
  function: 1,
  continue: 1,
  debugger: 1,
  interface: 1,
  protected: 1,
  instanceof: 1,
  implements: 1
};
function skipComment$1() {
  for (; index$2 < length$1; ) {
    const n = source$1.charCodeAt(index$2);
    if (isWhiteSpace$1(n) || isLineTerminator$1(n))
      ++index$2;
    else
      break;
  }
}
function scanHexEscape$1(n) {
  var t, g, d, k = 0;
  for (g = n === "u" ? 4 : 2, t = 0; t < g; ++t)
    index$2 < length$1 && isHexDigit$1(source$1[index$2]) ? (d = source$1[index$2++], k = k * 16 + "0123456789abcdef".indexOf(d.toLowerCase())) : throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2);
  return String.fromCharCode(k);
}
function scanUnicodeCodePointEscape$1() {
  var n, t, g, d;
  for (n = source$1[index$2], t = 0, n === "}" && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2); index$2 < length$1 && (n = source$1[index$2++], !!isHexDigit$1(n)); )
    t = t * 16 + "0123456789abcdef".indexOf(n.toLowerCase());
  return (t > 1114111 || n !== "}") && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2), t <= 65535 ? String.fromCharCode(t) : (g = (t - 65536 >> 10) + 55296, d = (t - 65536 & 1023) + 56320, String.fromCharCode(g, d));
}
function getEscapedIdentifier$1() {
  var n, t;
  for (n = source$1.charCodeAt(index$2++), t = String.fromCharCode(n), n === 92 && (source$1.charCodeAt(index$2) !== 117 && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2), ++index$2, n = scanHexEscape$1("u"), (!n || n === "\\" || !isIdentifierStart$1(n.charCodeAt(0))) && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2), t = n); index$2 < length$1 && (n = source$1.charCodeAt(index$2), !!isIdentifierPart$1(n)); )
    ++index$2, t += String.fromCharCode(n), n === 92 && (t = t.substr(0, t.length - 1), source$1.charCodeAt(index$2) !== 117 && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2), ++index$2, n = scanHexEscape$1("u"), (!n || n === "\\" || !isIdentifierPart$1(n.charCodeAt(0))) && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2), t += n);
  return t;
}
function getIdentifier$1() {
  var n, t;
  for (n = index$2++; index$2 < length$1; ) {
    if (t = source$1.charCodeAt(index$2), t === 92)
      return index$2 = n, getEscapedIdentifier$1();
    if (isIdentifierPart$1(t))
      ++index$2;
    else
      break;
  }
  return source$1.slice(n, index$2);
}
function scanIdentifier$1() {
  var n, t, g;
  return n = index$2, t = source$1.charCodeAt(index$2) === 92 ? getEscapedIdentifier$1() : getIdentifier$1(), t.length === 1 ? g = TokenIdentifier$1 : keywords$1.hasOwnProperty(t) ? g = TokenKeyword$1 : t === "null" ? g = TokenNullLiteral$1 : t === "true" || t === "false" ? g = TokenBooleanLiteral$1 : g = TokenIdentifier$1, {
    type: g,
    value: t,
    start: n,
    end: index$2
  };
}
function scanPunctuator$1() {
  var n = index$2, t = source$1.charCodeAt(index$2), g, d = source$1[index$2], k, H, AA;
  switch (t) {
    // Check for most common single-character punctuators.
    case 46:
    // . dot
    case 40:
    // ( open bracket
    case 41:
    // ) close bracket
    case 59:
    // ; semicolon
    case 44:
    // , comma
    case 123:
    // { open curly brace
    case 125:
    // } close curly brace
    case 91:
    // [
    case 93:
    // ]
    case 58:
    // :
    case 63:
    // ?
    case 126:
      return ++index$2, {
        type: TokenPunctuator$1,
        value: String.fromCharCode(t),
        start: n,
        end: index$2
      };
    default:
      if (g = source$1.charCodeAt(index$2 + 1), g === 61)
        switch (t) {
          case 43:
          // +
          case 45:
          // -
          case 47:
          // /
          case 60:
          // <
          case 62:
          // >
          case 94:
          // ^
          case 124:
          // |
          case 37:
          // %
          case 38:
          // &
          case 42:
            return index$2 += 2, {
              type: TokenPunctuator$1,
              value: String.fromCharCode(t) + String.fromCharCode(g),
              start: n,
              end: index$2
            };
          case 33:
          // !
          case 61:
            return index$2 += 2, source$1.charCodeAt(index$2) === 61 && ++index$2, {
              type: TokenPunctuator$1,
              value: source$1.slice(n, index$2),
              start: n,
              end: index$2
            };
        }
  }
  if (AA = source$1.substr(index$2, 4), AA === ">>>=")
    return index$2 += 4, {
      type: TokenPunctuator$1,
      value: AA,
      start: n,
      end: index$2
    };
  if (H = AA.substr(0, 3), H === ">>>" || H === "<<=" || H === ">>=")
    return index$2 += 3, {
      type: TokenPunctuator$1,
      value: H,
      start: n,
      end: index$2
    };
  if (k = H.substr(0, 2), d === k[1] && "+-<>&|".includes(d) || k === "=>")
    return index$2 += 2, {
      type: TokenPunctuator$1,
      value: k,
      start: n,
      end: index$2
    };
  if (k === "//" && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2), "<>=!+-*%&|^/".includes(d))
    return ++index$2, {
      type: TokenPunctuator$1,
      value: d,
      start: n,
      end: index$2
    };
  throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2);
}
function scanHexLiteral$1(n) {
  let t = "";
  for (; index$2 < length$1 && isHexDigit$1(source$1[index$2]); )
    t += source$1[index$2++];
  return t.length === 0 && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2), isIdentifierStart$1(source$1.charCodeAt(index$2)) && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2), {
    type: TokenNumericLiteral$1,
    value: parseInt("0x" + t, 16),
    start: n,
    end: index$2
  };
}
function scanOctalLiteral$1(n) {
  let t = "0" + source$1[index$2++];
  for (; index$2 < length$1 && isOctalDigit$1(source$1[index$2]); )
    t += source$1[index$2++];
  return (isIdentifierStart$1(source$1.charCodeAt(index$2)) || isDecimalDigit$1(source$1.charCodeAt(index$2))) && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2), {
    type: TokenNumericLiteral$1,
    value: parseInt(t, 8),
    octal: !0,
    start: n,
    end: index$2
  };
}
function scanNumericLiteral$1() {
  var n, t, g;
  if (g = source$1[index$2], assert$1(isDecimalDigit$1(g.charCodeAt(0)) || g === ".", "Numeric literal must start with a decimal digit or a decimal point"), t = index$2, n = "", g !== ".") {
    if (n = source$1[index$2++], g = source$1[index$2], n === "0") {
      if (g === "x" || g === "X")
        return ++index$2, scanHexLiteral$1(t);
      if (isOctalDigit$1(g))
        return scanOctalLiteral$1(t);
      g && isDecimalDigit$1(g.charCodeAt(0)) && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2);
    }
    for (; isDecimalDigit$1(source$1.charCodeAt(index$2)); )
      n += source$1[index$2++];
    g = source$1[index$2];
  }
  if (g === ".") {
    for (n += source$1[index$2++]; isDecimalDigit$1(source$1.charCodeAt(index$2)); )
      n += source$1[index$2++];
    g = source$1[index$2];
  }
  if (g === "e" || g === "E")
    if (n += source$1[index$2++], g = source$1[index$2], (g === "+" || g === "-") && (n += source$1[index$2++]), isDecimalDigit$1(source$1.charCodeAt(index$2)))
      for (; isDecimalDigit$1(source$1.charCodeAt(index$2)); )
        n += source$1[index$2++];
    else
      throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2);
  return isIdentifierStart$1(source$1.charCodeAt(index$2)) && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2), {
    type: TokenNumericLiteral$1,
    value: parseFloat(n),
    start: t,
    end: index$2
  };
}
function scanStringLiteral$1() {
  var n = "", t, g, d, k, H = !1;
  for (t = source$1[index$2], assert$1(t === "'" || t === '"', "String literal must starts with a quote"), g = index$2, ++index$2; index$2 < length$1; )
    if (d = source$1[index$2++], d === t) {
      t = "";
      break;
    } else if (d === "\\")
      if (d = source$1[index$2++], !d || !isLineTerminator$1(d.charCodeAt(0)))
        switch (d) {
          case "u":
          case "x":
            source$1[index$2] === "{" ? (++index$2, n += scanUnicodeCodePointEscape$1()) : n += scanHexEscape$1(d);
            break;
          case "n":
            n += `
`;
            break;
          case "r":
            n += "\r";
            break;
          case "t":
            n += "	";
            break;
          case "b":
            n += "\b";
            break;
          case "f":
            n += "\f";
            break;
          case "v":
            n += "\v";
            break;
          default:
            isOctalDigit$1(d) ? (k = "01234567".indexOf(d), k !== 0 && (H = !0), index$2 < length$1 && isOctalDigit$1(source$1[index$2]) && (H = !0, k = k * 8 + "01234567".indexOf(source$1[index$2++]), "0123".includes(d) && index$2 < length$1 && isOctalDigit$1(source$1[index$2]) && (k = k * 8 + "01234567".indexOf(source$1[index$2++]))), n += String.fromCharCode(k)) : n += d;
            break;
        }
      else
        d === "\r" && source$1[index$2] === `
` && ++index$2;
    else {
      if (isLineTerminator$1(d.charCodeAt(0)))
        break;
      n += d;
    }
  return t !== "" && throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2), {
    type: TokenStringLiteral$1,
    value: n,
    octal: H,
    start: g,
    end: index$2
  };
}
function testRegExp$1(n, t) {
  let g = n;
  t.includes("u") && (g = g.replace(/\\u\{([0-9a-fA-F]+)\}/g, (d, k) => {
    if (parseInt(k, 16) <= 1114111)
      return "x";
    throwError$1({}, MessageInvalidRegExp$1);
  }).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "x"));
  try {
    new RegExp(g);
  } catch {
    throwError$1({}, MessageInvalidRegExp$1);
  }
  try {
    return new RegExp(n, t);
  } catch {
    return null;
  }
}
function scanRegExpBody$1() {
  var n, t, g, d, k;
  for (n = source$1[index$2], assert$1(n === "/", "Regular expression literal must start with a slash"), t = source$1[index$2++], g = !1, d = !1; index$2 < length$1; )
    if (n = source$1[index$2++], t += n, n === "\\")
      n = source$1[index$2++], isLineTerminator$1(n.charCodeAt(0)) && throwError$1({}, MessageUnterminatedRegExp$1), t += n;
    else if (isLineTerminator$1(n.charCodeAt(0)))
      throwError$1({}, MessageUnterminatedRegExp$1);
    else if (g)
      n === "]" && (g = !1);
    else if (n === "/") {
      d = !0;
      break;
    } else n === "[" && (g = !0);
  return d || throwError$1({}, MessageUnterminatedRegExp$1), k = t.substr(1, t.length - 2), {
    value: k,
    literal: t
  };
}
function scanRegExpFlags$1() {
  var n, t, g;
  for (t = "", g = ""; index$2 < length$1 && (n = source$1[index$2], !!isIdentifierPart$1(n.charCodeAt(0))); )
    ++index$2, n === "\\" && index$2 < length$1 ? throwError$1({}, MessageUnexpectedToken$1, ILLEGAL$2) : (g += n, t += n);
  return g.search(/[^gimuy]/g) >= 0 && throwError$1({}, MessageInvalidRegExp$1, g), {
    value: g,
    literal: t
  };
}
function scanRegExp$1() {
  var n, t, g, d;
  return lookahead$1 = null, skipComment$1(), n = index$2, t = scanRegExpBody$1(), g = scanRegExpFlags$1(), d = testRegExp$1(t.value, g.value), {
    literal: t.literal + g.literal,
    value: d,
    regex: {
      pattern: t.value,
      flags: g.value
    },
    start: n,
    end: index$2
  };
}
function isIdentifierName$1(n) {
  return n.type === TokenIdentifier$1 || n.type === TokenKeyword$1 || n.type === TokenBooleanLiteral$1 || n.type === TokenNullLiteral$1;
}
function advance$1() {
  if (skipComment$1(), index$2 >= length$1)
    return {
      type: TokenEOF$1,
      start: index$2,
      end: index$2
    };
  const n = source$1.charCodeAt(index$2);
  return isIdentifierStart$1(n) ? scanIdentifier$1() : n === 40 || n === 41 || n === 59 ? scanPunctuator$1() : n === 39 || n === 34 ? scanStringLiteral$1() : n === 46 ? isDecimalDigit$1(source$1.charCodeAt(index$2 + 1)) ? scanNumericLiteral$1() : scanPunctuator$1() : isDecimalDigit$1(n) ? scanNumericLiteral$1() : scanPunctuator$1();
}
function lex$1() {
  const n = lookahead$1;
  return index$2 = n.end, lookahead$1 = advance$1(), index$2 = n.end, n;
}
function peek$1() {
  const n = index$2;
  lookahead$1 = advance$1(), index$2 = n;
}
function finishArrayExpression$1(n) {
  const t = new ASTNode$1(SyntaxArrayExpression$1);
  return t.elements = n, t;
}
function finishBinaryExpression$1(n, t, g) {
  const d = new ASTNode$1(n === "||" || n === "&&" ? SyntaxLogicalExpression$1 : SyntaxBinaryExpression$1);
  return d.operator = n, d.left = t, d.right = g, d;
}
function finishCallExpression$1(n, t) {
  const g = new ASTNode$1(SyntaxCallExpression$1);
  return g.callee = n, g.arguments = t, g;
}
function finishConditionalExpression$1(n, t, g) {
  const d = new ASTNode$1(SyntaxConditionalExpression$1);
  return d.test = n, d.consequent = t, d.alternate = g, d;
}
function finishIdentifier$1(n) {
  const t = new ASTNode$1(SyntaxIdentifier$1);
  return t.name = n, t;
}
function finishLiteral$1(n) {
  const t = new ASTNode$1(SyntaxLiteral$1);
  return t.value = n.value, t.raw = source$1.slice(n.start, n.end), n.regex && (t.raw === "//" && (t.raw = "/(?:)/"), t.regex = n.regex), t;
}
function finishMemberExpression$1(n, t, g) {
  const d = new ASTNode$1(SyntaxMemberExpression$1);
  return d.computed = n === "[", d.object = t, d.property = g, d.computed || (g.member = !0), d;
}
function finishObjectExpression$1(n) {
  const t = new ASTNode$1(SyntaxObjectExpression$1);
  return t.properties = n, t;
}
function finishProperty$1(n, t, g) {
  const d = new ASTNode$1(SyntaxProperty$1);
  return d.key = t, d.value = g, d.kind = n, d;
}
function finishUnaryExpression$1(n, t) {
  const g = new ASTNode$1(SyntaxUnaryExpression$1);
  return g.operator = n, g.argument = t, g.prefix = !0, g;
}
function throwError$1(n, t) {
  var g, d = Array.prototype.slice.call(arguments, 2), k = t.replace(/%(\d)/g, (H, AA) => (assert$1(AA < d.length, "Message reference must be in range"), d[AA]));
  throw g = new Error(k), g.index = index$2, g.description = k, g;
}
function throwUnexpected$1(n) {
  n.type === TokenEOF$1 && throwError$1(n, MessageUnexpectedEOS$1), n.type === TokenNumericLiteral$1 && throwError$1(n, MessageUnexpectedNumber$1), n.type === TokenStringLiteral$1 && throwError$1(n, MessageUnexpectedString$1), n.type === TokenIdentifier$1 && throwError$1(n, MessageUnexpectedIdentifier$1), n.type === TokenKeyword$1 && throwError$1(n, MessageUnexpectedReserved$1), throwError$1(n, MessageUnexpectedToken$1, n.value);
}
function expect$1(n) {
  const t = lex$1();
  (t.type !== TokenPunctuator$1 || t.value !== n) && throwUnexpected$1(t);
}
function match$1(n) {
  return lookahead$1.type === TokenPunctuator$1 && lookahead$1.value === n;
}
function matchKeyword$1(n) {
  return lookahead$1.type === TokenKeyword$1 && lookahead$1.value === n;
}
function parseArrayInitialiser$1() {
  const n = [];
  for (index$2 = lookahead$1.start, expect$1("["); !match$1("]"); )
    match$1(",") ? (lex$1(), n.push(null)) : (n.push(parseConditionalExpression$1()), match$1("]") || expect$1(","));
  return lex$1(), finishArrayExpression$1(n);
}
function parseObjectPropertyKey$1() {
  index$2 = lookahead$1.start;
  const n = lex$1();
  return n.type === TokenStringLiteral$1 || n.type === TokenNumericLiteral$1 ? (n.octal && throwError$1(n, MessageStrictOctalLiteral$1), finishLiteral$1(n)) : finishIdentifier$1(n.value);
}
function parseObjectProperty$1() {
  var n, t, g, d;
  if (index$2 = lookahead$1.start, n = lookahead$1, n.type === TokenIdentifier$1)
    return g = parseObjectPropertyKey$1(), expect$1(":"), d = parseConditionalExpression$1(), finishProperty$1("init", g, d);
  if (n.type === TokenEOF$1 || n.type === TokenPunctuator$1)
    throwUnexpected$1(n);
  else
    return t = parseObjectPropertyKey$1(), expect$1(":"), d = parseConditionalExpression$1(), finishProperty$1("init", t, d);
}
function parseObjectInitialiser$1() {
  var n = [], t, g, d, k = {}, H = String;
  for (index$2 = lookahead$1.start, expect$1("{"); !match$1("}"); )
    t = parseObjectProperty$1(), t.key.type === SyntaxIdentifier$1 ? g = t.key.name : g = H(t.key.value), d = "$" + g, Object.prototype.hasOwnProperty.call(k, d) ? throwError$1({}, MessageStrictDuplicateProperty$1) : k[d] = !0, n.push(t), match$1("}") || expect$1(",");
  return expect$1("}"), finishObjectExpression$1(n);
}
function parseGroupExpression$1() {
  expect$1("(");
  const n = parseExpression$2();
  return expect$1(")"), n;
}
const legalKeywords$1 = {
  if: 1
};
function parsePrimaryExpression$1() {
  var n, t, g;
  if (match$1("("))
    return parseGroupExpression$1();
  if (match$1("["))
    return parseArrayInitialiser$1();
  if (match$1("{"))
    return parseObjectInitialiser$1();
  if (n = lookahead$1.type, index$2 = lookahead$1.start, n === TokenIdentifier$1 || legalKeywords$1[lookahead$1.value])
    g = finishIdentifier$1(lex$1().value);
  else if (n === TokenStringLiteral$1 || n === TokenNumericLiteral$1)
    lookahead$1.octal && throwError$1(lookahead$1, MessageStrictOctalLiteral$1), g = finishLiteral$1(lex$1());
  else {
    if (n === TokenKeyword$1)
      throw new Error(DISABLED$1);
    n === TokenBooleanLiteral$1 ? (t = lex$1(), t.value = t.value === "true", g = finishLiteral$1(t)) : n === TokenNullLiteral$1 ? (t = lex$1(), t.value = null, g = finishLiteral$1(t)) : match$1("/") || match$1("/=") ? (g = finishLiteral$1(scanRegExp$1()), peek$1()) : throwUnexpected$1(lex$1());
  }
  return g;
}
function parseArguments$1() {
  const n = [];
  if (expect$1("("), !match$1(")"))
    for (; index$2 < length$1 && (n.push(parseConditionalExpression$1()), !match$1(")")); )
      expect$1(",");
  return expect$1(")"), n;
}
function parseNonComputedProperty$1() {
  index$2 = lookahead$1.start;
  const n = lex$1();
  return isIdentifierName$1(n) || throwUnexpected$1(n), finishIdentifier$1(n.value);
}
function parseNonComputedMember$1() {
  return expect$1("."), parseNonComputedProperty$1();
}
function parseComputedMember$1() {
  expect$1("[");
  const n = parseExpression$2();
  return expect$1("]"), n;
}
function parseLeftHandSideExpressionAllowCall$1() {
  var n, t, g;
  for (n = parsePrimaryExpression$1(); ; )
    if (match$1("."))
      g = parseNonComputedMember$1(), n = finishMemberExpression$1(".", n, g);
    else if (match$1("("))
      t = parseArguments$1(), n = finishCallExpression$1(n, t);
    else if (match$1("["))
      g = parseComputedMember$1(), n = finishMemberExpression$1("[", n, g);
    else
      break;
  return n;
}
function parsePostfixExpression$1() {
  const n = parseLeftHandSideExpressionAllowCall$1();
  if (lookahead$1.type === TokenPunctuator$1 && (match$1("++") || match$1("--")))
    throw new Error(DISABLED$1);
  return n;
}
function parseUnaryExpression$1() {
  var n, t;
  if (lookahead$1.type !== TokenPunctuator$1 && lookahead$1.type !== TokenKeyword$1)
    t = parsePostfixExpression$1();
  else {
    if (match$1("++") || match$1("--"))
      throw new Error(DISABLED$1);
    if (match$1("+") || match$1("-") || match$1("~") || match$1("!"))
      n = lex$1(), t = parseUnaryExpression$1(), t = finishUnaryExpression$1(n.value, t);
    else {
      if (matchKeyword$1("delete") || matchKeyword$1("void") || matchKeyword$1("typeof"))
        throw new Error(DISABLED$1);
      t = parsePostfixExpression$1();
    }
  }
  return t;
}
function binaryPrecedence$1(n) {
  let t = 0;
  if (n.type !== TokenPunctuator$1 && n.type !== TokenKeyword$1)
    return 0;
  switch (n.value) {
    case "||":
      t = 1;
      break;
    case "&&":
      t = 2;
      break;
    case "|":
      t = 3;
      break;
    case "^":
      t = 4;
      break;
    case "&":
      t = 5;
      break;
    case "==":
    case "!=":
    case "===":
    case "!==":
      t = 6;
      break;
    case "<":
    case ">":
    case "<=":
    case ">=":
    case "instanceof":
    case "in":
      t = 7;
      break;
    case "<<":
    case ">>":
    case ">>>":
      t = 8;
      break;
    case "+":
    case "-":
      t = 9;
      break;
    case "*":
    case "/":
    case "%":
      t = 11;
      break;
  }
  return t;
}
function parseBinaryExpression$1() {
  var n, t, g, d, k, H, AA, gA, IA, CA;
  if (n = lookahead$1, IA = parseUnaryExpression$1(), d = lookahead$1, k = binaryPrecedence$1(d), k === 0)
    return IA;
  for (d.prec = k, lex$1(), t = [n, lookahead$1], AA = parseUnaryExpression$1(), H = [IA, d, AA]; (k = binaryPrecedence$1(lookahead$1)) > 0; ) {
    for (; H.length > 2 && k <= H[H.length - 2].prec; )
      AA = H.pop(), gA = H.pop().value, IA = H.pop(), t.pop(), g = finishBinaryExpression$1(gA, IA, AA), H.push(g);
    d = lex$1(), d.prec = k, H.push(d), t.push(lookahead$1), g = parseUnaryExpression$1(), H.push(g);
  }
  for (CA = H.length - 1, g = H[CA], t.pop(); CA > 1; )
    t.pop(), g = finishBinaryExpression$1(H[CA - 1].value, H[CA - 2], g), CA -= 2;
  return g;
}
function parseConditionalExpression$1() {
  var n, t, g;
  return n = parseBinaryExpression$1(), match$1("?") && (lex$1(), t = parseConditionalExpression$1(), expect$1(":"), g = parseConditionalExpression$1(), n = finishConditionalExpression$1(n, t, g)), n;
}
function parseExpression$2() {
  const n = parseConditionalExpression$1();
  if (match$1(","))
    throw new Error(DISABLED$1);
  return n;
}
function parser$3(n) {
  source$1 = n, index$2 = 0, length$1 = source$1.length, lookahead$1 = null, peek$1();
  const t = parseExpression$2();
  if (lookahead$1.type !== TokenEOF$1)
    throw new Error("Unexpect token after expression.");
  return t;
}
var Constants$1 = {
  NaN: "NaN",
  E: "Math.E",
  LN2: "Math.LN2",
  LN10: "Math.LN10",
  LOG2E: "Math.LOG2E",
  LOG10E: "Math.LOG10E",
  PI: "Math.PI",
  SQRT1_2: "Math.SQRT1_2",
  SQRT2: "Math.SQRT2",
  MIN_VALUE: "Number.MIN_VALUE",
  MAX_VALUE: "Number.MAX_VALUE"
};
function Functions$1(n) {
  function t(AA, gA, IA, CA) {
    let BA = n(gA[0]);
    return IA && (BA = IA + "(" + BA + ")", IA.lastIndexOf("new ", 0) === 0 && (BA = "(" + BA + ")")), BA + "." + AA + (CA < 0 ? "" : CA === 0 ? "()" : "(" + gA.slice(1).map(n).join(",") + ")");
  }
  function g(AA, gA, IA) {
    return (CA) => t(AA, CA, gA, IA);
  }
  const d = "new Date", k = "String", H = "RegExp";
  return {
    // MATH functions
    isNaN: "Number.isNaN",
    isFinite: "Number.isFinite",
    abs: "Math.abs",
    acos: "Math.acos",
    asin: "Math.asin",
    atan: "Math.atan",
    atan2: "Math.atan2",
    ceil: "Math.ceil",
    cos: "Math.cos",
    exp: "Math.exp",
    floor: "Math.floor",
    hypot: "Math.hypot",
    log: "Math.log",
    max: "Math.max",
    min: "Math.min",
    pow: "Math.pow",
    random: "Math.random",
    round: "Math.round",
    sin: "Math.sin",
    sqrt: "Math.sqrt",
    tan: "Math.tan",
    clamp: function(AA) {
      AA.length < 3 && error$3("Missing arguments to clamp function."), AA.length > 3 && error$3("Too many arguments to clamp function.");
      const gA = AA.map(n);
      return "Math.max(" + gA[1] + ", Math.min(" + gA[2] + "," + gA[0] + "))";
    },
    // DATE functions
    now: "Date.now",
    utc: "Date.UTC",
    datetime: d,
    date: g("getDate", d, 0),
    day: g("getDay", d, 0),
    year: g("getFullYear", d, 0),
    month: g("getMonth", d, 0),
    hours: g("getHours", d, 0),
    minutes: g("getMinutes", d, 0),
    seconds: g("getSeconds", d, 0),
    milliseconds: g("getMilliseconds", d, 0),
    time: g("getTime", d, 0),
    timezoneoffset: g("getTimezoneOffset", d, 0),
    utcdate: g("getUTCDate", d, 0),
    utcday: g("getUTCDay", d, 0),
    utcyear: g("getUTCFullYear", d, 0),
    utcmonth: g("getUTCMonth", d, 0),
    utchours: g("getUTCHours", d, 0),
    utcminutes: g("getUTCMinutes", d, 0),
    utcseconds: g("getUTCSeconds", d, 0),
    utcmilliseconds: g("getUTCMilliseconds", d, 0),
    // sequence functions
    length: g("length", null, -1),
    // STRING functions
    parseFloat: "parseFloat",
    parseInt: "parseInt",
    upper: g("toUpperCase", k, 0),
    lower: g("toLowerCase", k, 0),
    substring: g("substring", k),
    split: g("split", k),
    trim: g("trim", k, 0),
    // base64 encode/decode
    btoa: "btoa",
    atob: "atob",
    // REGEXP functions
    regexp: H,
    test: g("test", H),
    // Control Flow functions
    if: function(AA) {
      AA.length < 3 && error$3("Missing arguments to if function."), AA.length > 3 && error$3("Too many arguments to if function.");
      const gA = AA.map(n);
      return "(" + gA[0] + "?" + gA[1] + ":" + gA[2] + ")";
    }
  };
}
function stripQuotes(n) {
  const t = n && n.length - 1;
  return t && (n[0] === '"' && n[t] === '"' || n[0] === "'" && n[t] === "'") ? n.slice(1, -1) : n;
}
function codegen(n) {
  n = n || {};
  const t = n.allowed ? toSet(n.allowed) : {}, g = n.forbidden ? toSet(n.forbidden) : {}, d = n.constants || Constants$1, k = (n.functions || Functions$1)(eA), H = n.globalvar, AA = n.fieldvar, gA = isFunction$5(H) ? H : (tA) => `${H}["${tA}"]`;
  [...Object.getOwnPropertyNames(Object.prototype).filter((tA) => typeof Object.prototype[tA] == "function")];
  let IA = {}, CA = {}, BA = 0;
  function eA(tA) {
    if (isString$2(tA)) return tA;
    const oA = iA[tA.type];
    return oA == null && error$3("Unsupported type: " + tA.type), oA(tA);
  }
  const iA = {
    Literal: (tA) => tA.raw,
    Identifier: (tA) => {
      const oA = tA.name;
      return BA > 0 ? oA : has$2(g, oA) ? error$3("Illegal identifier: " + oA) : has$2(d, oA) ? d[oA] : has$2(t, oA) ? oA : (IA[oA] = 1, gA(oA));
    },
    MemberExpression: (tA) => {
      const oA = !tA.computed, EA = eA(tA.object);
      oA && (BA += 1);
      const aA = eA(tA.property);
      return EA === AA && (CA[stripQuotes(aA)] = 1), oA && (BA -= 1), EA + (oA ? "." + aA : "[" + aA + "]");
    },
    CallExpression: (tA) => {
      tA.callee.type !== "Identifier" && error$3("Illegal callee type: " + tA.callee.type);
      const oA = tA.callee.name, EA = tA.arguments, aA = has$2(k, oA) && k[oA];
      return aA || error$3("Unrecognized function: " + oA), isFunction$5(aA) ? aA(EA) : aA + "(" + EA.map(eA).join(",") + ")";
    },
    ArrayExpression: (tA) => "[" + tA.elements.map(eA).join(",") + "]",
    BinaryExpression: (tA) => "(" + eA(tA.left) + " " + tA.operator + " " + eA(tA.right) + ")",
    UnaryExpression: (tA) => "(" + tA.operator + eA(tA.argument) + ")",
    ConditionalExpression: (tA) => "(" + eA(tA.test) + "?" + eA(tA.consequent) + ":" + eA(tA.alternate) + ")",
    LogicalExpression: (tA) => "(" + eA(tA.left) + tA.operator + eA(tA.right) + ")",
    ObjectExpression: (tA) => {
      for (const oA of tA.properties) {
        const EA = oA.key.name;
        DisallowedObjectProperties.has(EA) && error$3("Illegal property: " + EA);
      }
      return "{" + tA.properties.map(eA).join(",") + "}";
    },
    Property: (tA) => {
      BA += 1;
      const oA = eA(tA.key);
      return BA -= 1, oA + ":" + eA(tA.value);
    }
  };
  function QA(tA) {
    const oA = {
      code: eA(tA),
      globals: Object.keys(IA),
      fields: Object.keys(CA)
    };
    return IA = {}, CA = {}, oA;
  }
  return QA.functions = k, QA.constants = d, QA;
}
const SELECTION_GETTER = Symbol("vega_selection_getter");
function getter$2(n) {
  return (!n.getter || !n.getter[SELECTION_GETTER]) && (n.getter = field$4(n.field), n.getter[SELECTION_GETTER] = !0), n.getter;
}
const Intersect = "intersect", Union = "union", VlMulti = "vlMulti", VlPoint = "vlPoint", Or = "or", And = "and", SelectionId = "_vgsid_", $selectionId = field$4(SelectionId), TYPE_ENUM = "E", TYPE_RANGE_INC = "R", TYPE_RANGE_EXC = "R-E", TYPE_RANGE_LE = "R-LE", TYPE_RANGE_RE = "R-RE", TYPE_PRED_LT = "E-LT", TYPE_PRED_LTE = "E-LTE", TYPE_PRED_GT = "E-GT", TYPE_PRED_GTE = "E-GTE", TYPE_PRED_VALID = "E-VALID", TYPE_PRED_ONE_OF = "E-ONE", UNIT_INDEX = "index:unit";
function testPoint(n, t) {
  for (var g = t.fields, d = t.values, k = g.length, H = 0, AA, gA; H < k; ++H)
    if (gA = g[H], AA = getter$2(gA)(n), isDate$2(AA) && (AA = toNumber$1(AA)), isDate$2(d[H]) && (d[H] = toNumber$1(d[H])), isArray$3(d[H]) && isDate$2(d[H][0]) && (d[H] = d[H].map(toNumber$1)), gA.type === TYPE_ENUM) {
      if (isArray$3(d[H]) ? !d[H].includes(AA) : AA !== d[H])
        return !1;
    } else if (gA.type === TYPE_RANGE_INC) {
      if (!inrange(AA, d[H])) return !1;
    } else if (gA.type === TYPE_RANGE_RE) {
      if (!inrange(AA, d[H], !0, !1)) return !1;
    } else if (gA.type === TYPE_RANGE_EXC) {
      if (!inrange(AA, d[H], !1, !1)) return !1;
    } else if (gA.type === TYPE_RANGE_LE) {
      if (!inrange(AA, d[H], !1, !0)) return !1;
    } else if (gA.type === TYPE_PRED_LT) {
      if (AA >= d[H]) return !1;
    } else if (gA.type === TYPE_PRED_LTE) {
      if (AA > d[H]) return !1;
    } else if (gA.type === TYPE_PRED_GT) {
      if (AA <= d[H]) return !1;
    } else if (gA.type === TYPE_PRED_GTE) {
      if (AA < d[H]) return !1;
    } else if (gA.type === TYPE_PRED_VALID) {
      if (AA === null || isNaN(AA)) return !1;
    } else if (gA.type === TYPE_PRED_ONE_OF && d[H].indexOf(AA) === -1)
      return !1;
  return !0;
}
function selectionTest(n, t, g) {
  for (var d = this.context.data[n], k = d ? d.values.value : [], H = d ? d[UNIT_INDEX] && d[UNIT_INDEX].value : void 0, AA = g === Intersect, gA = k.length, IA = 0, CA, BA, eA, iA, QA; IA < gA; ++IA)
    if (CA = k[IA], H && AA) {
      if (BA = BA || {}, eA = BA[iA = CA.unit] || 0, eA === -1) continue;
      if (QA = testPoint(t, CA), BA[iA] = QA ? -1 : ++eA, QA && H.size === 1) return !0;
      if (!QA && eA === H.get(iA).count) return !1;
    } else if (QA = testPoint(t, CA), AA ^ QA) return QA;
  return gA && AA;
}
const bisect = bisector($selectionId), bisectLeft = bisect.left, bisectRight = bisect.right;
function selectionIdTest(n, t, g) {
  const d = this.context.data[n], k = d ? d.values.value : [], H = d ? d[UNIT_INDEX] && d[UNIT_INDEX].value : void 0, AA = g === Intersect, gA = $selectionId(t), IA = bisectLeft(k, gA);
  if (IA === k.length || $selectionId(k[IA]) !== gA) return !1;
  if (H && AA) {
    if (H.size === 1) return !0;
    if (bisectRight(k, gA) - IA < H.size) return !1;
  }
  return !0;
}
function selectionTuples(n, t) {
  return n.map((g) => extend$2(t.fields ? {
    values: t.fields.map((d) => getter$2(d)(g.datum))
  } : {
    [SelectionId]: $selectionId(g.datum)
  }, t));
}
function selectionResolve(n, t, g, d) {
  for (var k = this.context.data[n], H = k ? k.values.value : [], AA = {}, gA = {}, IA = {}, CA, BA, eA, iA, QA, tA, oA, EA, aA, nA, lA = H.length, cA = 0, sA, rA; cA < lA; ++cA)
    if (CA = H[cA], iA = CA.unit, BA = CA.fields, eA = CA.values, BA && eA) {
      for (sA = 0, rA = BA.length; sA < rA; ++sA)
        QA = BA[sA], oA = AA[QA.field] || (AA[QA.field] = {}), EA = oA[iA] || (oA[iA] = []), IA[QA.field] = aA = QA.type.charAt(0), nA = ops[`${aA}_union`], oA[iA] = nA(EA, array$6(eA[sA]));
      g && (EA = gA[iA] || (gA[iA] = []), EA.push(array$6(eA).reduce((uA, hA, dA) => (uA[BA[dA].field] = hA, uA), {})));
    } else
      QA = SelectionId, tA = $selectionId(CA), oA = AA[QA] || (AA[QA] = {}), EA = oA[iA] || (oA[iA] = []), EA.push(tA), g && (EA = gA[iA] || (gA[iA] = []), EA.push({
        [SelectionId]: tA
      }));
  if (t = t || Union, AA[SelectionId] ? AA[SelectionId] = ops[`${SelectionId}_${t}`](...Object.values(AA[SelectionId])) : Object.keys(AA).forEach((uA) => {
    AA[uA] = Object.keys(AA[uA]).map((hA) => AA[uA][hA]).reduce((hA, dA) => hA === void 0 ? dA : ops[`${IA[uA]}_${t}`](hA, dA));
  }), H = Object.keys(gA), g && H.length) {
    const uA = d ? VlPoint : VlMulti;
    AA[uA] = t === Union ? {
      [Or]: H.reduce((hA, dA) => (hA.push(...gA[dA]), hA), [])
    } : {
      [And]: H.map((hA) => ({
        [Or]: gA[hA]
      }))
    };
  }
  return AA;
}
var ops = {
  [`${SelectionId}_union`]: union,
  [`${SelectionId}_intersect`]: intersection,
  E_union: function(n, t) {
    if (!n.length) return t;
    for (var g = 0, d = t.length; g < d; ++g) n.includes(t[g]) || n.push(t[g]);
    return n;
  },
  E_intersect: function(n, t) {
    return n.length ? n.filter((g) => t.includes(g)) : t;
  },
  R_union: function(n, t) {
    var g = toNumber$1(t[0]), d = toNumber$1(t[1]);
    return g > d && (g = t[1], d = t[0]), n.length ? (n[0] > g && (n[0] = g), n[1] < d && (n[1] = d), n) : [g, d];
  },
  R_intersect: function(n, t) {
    var g = toNumber$1(t[0]), d = toNumber$1(t[1]);
    return g > d && (g = t[1], d = t[0]), n.length ? d < n[0] || n[1] < g ? [] : (n[0] < g && (n[0] = g), n[1] > d && (n[1] = d), n) : [g, d];
  }
};
const DataPrefix$1 = ":", IndexPrefix$1 = "@";
function selectionVisitor(n, t, g, d) {
  t[0].type !== Literal$1 && error$3("First argument to selection functions must be a string literal.");
  const k = t[0].value, H = t.length >= 2 && peek$2(t).value, AA = "unit", gA = IndexPrefix$1 + AA, IA = DataPrefix$1 + k;
  H === Intersect && !has$2(d, gA) && (d[gA] = g.getData(k).indataRef(g, AA)), has$2(d, IA) || (d[IA] = g.getData(k).tuplesRef());
}
function data$2(n) {
  const t = this.context.data[n];
  return t ? t.values.value : [];
}
function indata(n, t, g) {
  const d = this.context.data[n]["index:" + t], k = d ? d.value.get(g) : void 0;
  return k && k.count;
}
function setdata(n, t) {
  const g = this.context.dataflow, d = this.context.data[n], k = d.input;
  return g.pulse(k, g.changeset().remove(truthy).insert(t)), 1;
}
function encode$2(n, t, g) {
  if (n) {
    const d = this.context.dataflow, k = n.mark.source;
    d.pulse(k, d.changeset().encode(n, t));
  }
  return g !== void 0 ? g : n;
}
const wrap = (n) => function(t, g) {
  const d = this.context.dataflow.locale();
  return t === null ? "null" : d[n](g)(t);
}, format = wrap("format"), timeFormat$1 = wrap("timeFormat"), utcFormat = wrap("utcFormat"), timeParse = wrap("timeParse"), utcParse = wrap("utcParse"), dateObj = new Date(2e3, 0, 1);
function time(n, t, g) {
  return !Number.isInteger(n) || !Number.isInteger(t) ? "" : (dateObj.setYear(2e3), dateObj.setMonth(n), dateObj.setDate(t), timeFormat$1.call(this, dateObj, g));
}
function monthFormat(n) {
  return time.call(this, n, 1, "%B");
}
function monthAbbrevFormat(n) {
  return time.call(this, n, 1, "%b");
}
function dayFormat(n) {
  return time.call(this, 0, 2 + n, "%A");
}
function dayAbbrevFormat(n) {
  return time.call(this, 0, 2 + n, "%a");
}
const DataPrefix = ":", IndexPrefix = "@", ScalePrefix = "%", SignalPrefix = "$";
function dataVisitor(n, t, g, d) {
  t[0].type !== Literal$1 && error$3("First argument to data functions must be a string literal.");
  const k = t[0].value, H = DataPrefix + k;
  if (!has$2(H, d))
    try {
      d[H] = g.getData(k).tuplesRef();
    } catch {
    }
}
function indataVisitor(n, t, g, d) {
  t[0].type !== Literal$1 && error$3("First argument to indata must be a string literal."), t[1].type !== Literal$1 && error$3("Second argument to indata must be a string literal.");
  const k = t[0].value, H = t[1].value, AA = IndexPrefix + H;
  has$2(AA, d) || (d[AA] = g.getData(k).indataRef(g, H));
}
function scaleVisitor(n, t, g, d) {
  if (t[0].type === Literal$1)
    addScaleDependency(g, d, t[0].value);
  else
    for (n in g.scales)
      addScaleDependency(g, d, n);
}
function addScaleDependency(n, t, g) {
  const d = ScalePrefix + g;
  if (!has$2(t, d))
    try {
      t[d] = n.scaleRef(g);
    } catch {
    }
}
function getScale(n, t) {
  if (isString$2(n)) {
    const g = t.scales[n];
    return g && isRegisteredScale(g.value) ? g.value : void 0;
  } else if (isFunction$5(n))
    return isRegisteredScale(n) ? n : void 0;
}
function internalScaleFunctions(n, t, g) {
  t.__bandwidth = (k) => k && k.bandwidth ? k.bandwidth() : 0, g._bandwidth = scaleVisitor, g._range = scaleVisitor, g._scale = scaleVisitor;
  const d = (k) => "_[" + (k.type === Literal$1 ? $$2(ScalePrefix + k.value) : $$2(ScalePrefix) + "+" + n(k)) + "]";
  return {
    _bandwidth: (k) => `this.__bandwidth(${d(k[0])})`,
    _range: (k) => `${d(k[0])}.range()`,
    _scale: (k) => `${d(k[0])}(${n(k[1])})`
  };
}
function geoMethod(n, t) {
  return function(g, d, k) {
    if (g) {
      const H = getScale(g, (k || this).context);
      return H && H.path[n](d);
    } else
      return t(d);
  };
}
const geoArea = geoMethod("area", geoArea$1), geoBounds = geoMethod("bounds", geoBounds$1), geoCentroid = geoMethod("centroid", geoCentroid$1);
function geoScale(n, t) {
  const g = getScale(n, (t || this).context);
  return g && g.scale();
}
function inScope(n) {
  const t = this.context.group;
  let g = !1;
  if (t) for (; n; ) {
    if (n === t) {
      g = !0;
      break;
    }
    n = n.mark.group;
  }
  return g;
}
function log(n, t, g) {
  try {
    n[t].apply(n, ["EXPRESSION"].concat([].slice.call(g)));
  } catch (d) {
    n.warn(d);
  }
  return g[g.length - 1];
}
function warn$1() {
  return log(this.context.dataflow, "warn", arguments);
}
function info() {
  return log(this.context.dataflow, "info", arguments);
}
function debug$1() {
  return log(this.context.dataflow, "debug", arguments);
}
function channel_luminance_value(n) {
  const t = n / 255;
  return t <= 0.03928 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}
function luminance(n) {
  const t = rgb$1(n), g = channel_luminance_value(t.r), d = channel_luminance_value(t.g), k = channel_luminance_value(t.b);
  return 0.2126 * g + 0.7152 * d + 0.0722 * k;
}
function contrast(n, t) {
  const g = luminance(n), d = luminance(t), k = Math.max(g, d), H = Math.min(g, d);
  return (k + 0.05) / (H + 0.05);
}
function merge$2() {
  const n = [].slice.call(arguments);
  return n.unshift({}), extend$2(...n);
}
function equal(n, t) {
  return n === t || n !== n && t !== t ? !0 : isArray$3(n) ? isArray$3(t) && n.length === t.length ? equalArray(n, t) : !1 : isObject$4(n) && isObject$4(t) ? equalObject(n, t) : !1;
}
function equalArray(n, t) {
  for (let g = 0, d = n.length; g < d; ++g)
    if (!equal(n[g], t[g])) return !1;
  return !0;
}
function equalObject(n, t) {
  for (const g in n)
    if (!equal(n[g], t[g])) return !1;
  return !0;
}
function removePredicate(n) {
  return (t) => equalObject(n, t);
}
function modify(n, t, g, d, k, H) {
  const AA = this.context.dataflow, gA = this.context.data[n], IA = gA.input, CA = AA.stamp();
  let BA = gA.changes, eA, iA;
  if (AA._trigger === !1 || !(IA.value.length || t || d))
    return 0;
  if ((!BA || BA.stamp < CA) && (gA.changes = BA = AA.changeset(), BA.stamp = CA, AA.runAfter(() => {
    gA.modified = !0, AA.pulse(IA, BA).run();
  }, !0, 1)), g && (eA = g === !0 ? truthy : isArray$3(g) || isTuple(g) ? g : removePredicate(g), BA.remove(eA)), t && BA.insert(t), d && (eA = removePredicate(d), IA.value.some(eA) ? BA.remove(eA) : BA.insert(d)), k)
    for (iA in H)
      BA.modify(k, iA, H[iA]);
  return 1;
}
function pinchDistance(n) {
  const t = n.touches, g = t[0].clientX - t[1].clientX, d = t[0].clientY - t[1].clientY;
  return Math.hypot(g, d);
}
function pinchAngle(n) {
  const t = n.touches;
  return Math.atan2(t[0].clientY - t[1].clientY, t[0].clientX - t[1].clientX);
}
const accessors = {};
function pluck(n, t) {
  const g = accessors[t] || (accessors[t] = field$4(t));
  return isArray$3(n) ? n.map(g) : g(n);
}
function array$1(n) {
  return isArray$3(n) || ArrayBuffer.isView(n) ? n : null;
}
function sequence(n) {
  return array$1(n) || (isString$2(n) ? n : null);
}
function join(n, ...t) {
  return array$1(n).join(...t);
}
function indexof(n, ...t) {
  return sequence(n).indexOf(...t);
}
function lastindexof(n, ...t) {
  return sequence(n).lastIndexOf(...t);
}
function slice$1(n, ...t) {
  return sequence(n).slice(...t);
}
function replace(n, t, g) {
  return isFunction$5(g) && error$3("Function argument passed to replace."), !isString$2(t) && !isRegExp$1(t) && error$3("Please pass a string or RegExp argument to replace."), String(n).replace(t, g);
}
function reverse$1(n) {
  return array$1(n).slice().reverse();
}
function sort(n) {
  return array$1(n).slice().sort(ascending$2);
}
function bandspace(n, t, g) {
  return bandSpace(n || 0, t || 0, g || 0);
}
function bandwidth(n, t) {
  const g = getScale(n, (t || this).context);
  return g && g.bandwidth ? g.bandwidth() : 0;
}
function copy(n, t) {
  const g = getScale(n, (t || this).context);
  return g ? g.copy() : void 0;
}
function domain$2(n, t) {
  const g = getScale(n, (t || this).context);
  return g ? g.domain() : [];
}
function invert(n, t, g) {
  const d = getScale(n, (g || this).context);
  return d ? isArray$3(t) ? (d.invertRange || d.invert)(t) : (d.invert || d.invertExtent)(t) : void 0;
}
function range$3(n, t) {
  const g = getScale(n, (t || this).context);
  return g && g.range ? g.range() : [];
}
function scale$2(n, t, g) {
  const d = getScale(n, (g || this).context);
  return d ? d(t) : void 0;
}
function scaleGradient(n, t, g, d, k) {
  n = getScale(n, (k || this).context);
  const H = Gradient$1(t, g);
  let AA = n.domain(), gA = AA[0], IA = peek$2(AA), CA = identity$8;
  return IA - gA ? CA = scaleFraction(n, gA, IA) : n = (n.interpolator ? scale$4("sequential")().interpolator(n.interpolator()) : scale$4("linear")().interpolate(n.interpolate()).range(n.range())).domain([gA = 0, IA = 1]), n.ticks && (AA = n.ticks(+d || 15), gA !== AA[0] && AA.unshift(gA), IA !== peek$2(AA) && AA.push(IA)), AA.forEach((BA) => H.stop(CA(BA), n(BA))), H;
}
function geoShape(n, t, g) {
  const d = getScale(n, (g || this).context);
  return function(k) {
    return d ? d.path.context(k)(t) : "";
  };
}
function pathShape(n) {
  let t = null;
  return function(g) {
    return g ? pathRender(g, t = t || parse$3(n)) : n;
  };
}
const datum = (n) => n.data;
function treeNodes(n, t) {
  const g = data$2.call(t, n);
  return g.root && g.root.lookup || {};
}
function treePath(n, t, g) {
  const d = treeNodes(n, this), k = d[t], H = d[g];
  return k && H ? k.path(H).map(datum) : void 0;
}
function treeAncestors(n, t) {
  const g = treeNodes(n, this)[t];
  return g ? g.ancestors().map(datum) : void 0;
}
const _window = () => typeof window < "u" && window || null;
function screen() {
  const n = _window();
  return n ? n.screen : {};
}
function windowSize() {
  const n = _window();
  return n ? [n.innerWidth, n.innerHeight] : [void 0, void 0];
}
function containerSize() {
  const n = this.context.dataflow, t = n.container && n.container();
  return t ? [t.clientWidth, t.clientHeight] : [void 0, void 0];
}
function intersect(n, t, g) {
  if (!n) return [];
  const [d, k] = n, H = new Bounds().set(d[0], d[1], k[0], k[1]), AA = g || this.context.dataflow.scenegraph().root;
  return intersect$2(AA, H, filter$2(t));
}
function filter$2(n) {
  let t = null;
  if (n) {
    const g = array$6(n.marktype), d = array$6(n.markname);
    t = (k) => (!g.length || g.some((H) => k.marktype === H)) && (!d.length || d.some((H) => k.name === H));
  }
  return t;
}
function lassoAppend(n, t, g, d = 5) {
  n = array$6(n);
  const k = n[n.length - 1];
  return k === void 0 || Math.hypot(k[0] - t, k[1] - g) > d ? [...n, [t, g]] : n;
}
function lassoPath(n) {
  return array$6(n).reduce((t, [g, d], k) => t += k == 0 ? `M ${g},${d} ` : k === n.length - 1 ? " Z" : `L ${g},${d} `, "");
}
function intersectLasso(n, t, g) {
  const {
    x: d,
    y: k,
    mark: H
  } = g, AA = new Bounds().set(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER);
  for (const [IA, CA] of t)
    IA < AA.x1 && (AA.x1 = IA), IA > AA.x2 && (AA.x2 = IA), CA < AA.y1 && (AA.y1 = CA), CA > AA.y2 && (AA.y2 = CA);
  return AA.translate(d, k), intersect([[AA.x1, AA.y1], [AA.x2, AA.y2]], n, H).filter((IA) => pointInPolygon(IA.x, IA.y, t));
}
function pointInPolygon(n, t, g) {
  let d = 0;
  for (let k = 0, H = g.length - 1; k < g.length; H = k++) {
    const [AA, gA] = g[H], [IA, CA] = g[k];
    CA > t != gA > t && n < (AA - IA) * (t - CA) / (gA - CA) + IA && d++;
  }
  return d & 1;
}
const functionContext = {
  random() {
    return random();
  },
  // override default
  cumulativeNormal,
  cumulativeLogNormal,
  cumulativeUniform,
  densityNormal,
  densityLogNormal,
  densityUniform,
  quantileNormal,
  quantileLogNormal,
  quantileUniform,
  sampleNormal,
  sampleLogNormal,
  sampleUniform,
  isArray: isArray$3,
  isBoolean: isBoolean$4,
  isDate: isDate$2,
  isDefined(n) {
    return n !== void 0;
  },
  isNumber: isNumber$3,
  isObject: isObject$4,
  isRegExp: isRegExp$1,
  isString: isString$2,
  isTuple,
  isValid(n) {
    return n != null && n === n;
  },
  toBoolean,
  toDate(n) {
    return toDate(n);
  },
  // suppress extra arguments
  toNumber: toNumber$1,
  toString: toString$3,
  indexof,
  join,
  lastindexof,
  replace,
  reverse: reverse$1,
  sort,
  slice: slice$1,
  flush,
  lerp,
  merge: merge$2,
  pad: pad$2,
  peek: peek$2,
  pluck,
  span,
  inrange,
  truncate: truncate$1,
  rgb: rgb$1,
  lab: lab$1,
  hcl: hcl$1,
  hsl: hsl$1,
  luminance,
  contrast,
  sequence: range$5,
  format,
  utcFormat,
  utcParse,
  utcOffset,
  utcSequence,
  timeFormat: timeFormat$1,
  timeParse,
  timeOffset,
  timeSequence,
  timeUnitSpecifier,
  monthFormat,
  monthAbbrevFormat,
  dayFormat,
  dayAbbrevFormat,
  quarter,
  utcquarter,
  week,
  utcweek,
  dayofyear,
  utcdayofyear,
  warn: warn$1,
  info,
  debug: debug$1,
  extent(n) {
    return extent(n);
  },
  // suppress extra arguments
  inScope,
  intersect,
  clampRange,
  pinchDistance,
  pinchAngle,
  screen,
  containerSize,
  windowSize,
  bandspace,
  setdata,
  pathShape,
  panLinear,
  panLog,
  panPow,
  panSymlog,
  zoomLinear,
  zoomLog,
  zoomPow,
  zoomSymlog,
  encode: encode$2,
  modify,
  lassoAppend,
  lassoPath,
  intersectLasso
}, eventFunctions = ["view", "item", "group", "xy", "x", "y"], eventPrefix = "event.vega.", thisPrefix = "this.", astVisitors = {}, codegenParams = {
  forbidden: ["_"],
  allowed: ["datum", "event", "item"],
  fieldvar: "datum",
  globalvar: (n) => `_[${$$2(SignalPrefix + n)}]`,
  functions: buildFunctions,
  constants: Constants$1,
  visitors: astVisitors
}, codeGenerator = codegen(codegenParams);
function buildFunctions(n) {
  const t = Functions$1(n);
  eventFunctions.forEach((g) => t[g] = eventPrefix + g);
  for (const g in functionContext)
    t[g] = thisPrefix + g;
  return extend$2(t, internalScaleFunctions(n, functionContext, astVisitors)), t;
}
function expressionFunction(n, t, g) {
  return arguments.length === 1 ? functionContext[n] : (functionContext[n] = t, g && (astVisitors[n] = g), codeGenerator && (codeGenerator.functions[n] = thisPrefix + n), this);
}
expressionFunction("bandwidth", bandwidth, scaleVisitor);
expressionFunction("copy", copy, scaleVisitor);
expressionFunction("domain", domain$2, scaleVisitor);
expressionFunction("range", range$3, scaleVisitor);
expressionFunction("invert", invert, scaleVisitor);
expressionFunction("scale", scale$2, scaleVisitor);
expressionFunction("gradient", scaleGradient, scaleVisitor);
expressionFunction("geoArea", geoArea, scaleVisitor);
expressionFunction("geoBounds", geoBounds, scaleVisitor);
expressionFunction("geoCentroid", geoCentroid, scaleVisitor);
expressionFunction("geoShape", geoShape, scaleVisitor);
expressionFunction("geoScale", geoScale, scaleVisitor);
expressionFunction("indata", indata, indataVisitor);
expressionFunction("data", data$2, dataVisitor);
expressionFunction("treePath", treePath, dataVisitor);
expressionFunction("treeAncestors", treeAncestors, dataVisitor);
expressionFunction("vlSelectionTest", selectionTest, selectionVisitor);
expressionFunction("vlSelectionIdTest", selectionIdTest, selectionVisitor);
expressionFunction("vlSelectionResolve", selectionResolve, selectionVisitor);
expressionFunction("vlSelectionTuples", selectionTuples);
function parser$2(n, t) {
  const g = {};
  let d;
  try {
    n = isString$2(n) ? n : $$2(n) + "", d = parser$3(n);
  } catch {
    error$3("Expression parse error: " + n);
  }
  d.visit((H) => {
    if (H.type !== CallExpression$1) return;
    const AA = H.callee.name, gA = codegenParams.visitors[AA];
    gA && gA(AA, H.arguments, t, g);
  });
  const k = codeGenerator(d);
  return k.globals.forEach((H) => {
    const AA = SignalPrefix + H;
    !has$2(g, AA) && t.getSignal(H) && (g[AA] = t.signalRef(H));
  }), {
    $expr: extend$2({
      code: k.code
    }, t.options.ast ? {
      ast: d
    } : null),
    $fields: k.fields,
    $params: g
  };
}
function parse$2(n) {
  const t = this, g = n.operators || [];
  return n.background && (t.background = n.background), n.eventConfig && (t.eventConfig = n.eventConfig), n.locale && (t.locale = n.locale), g.forEach((d) => t.parseOperator(d)), g.forEach((d) => t.parseOperatorParameters(d)), (n.streams || []).forEach((d) => t.parseStream(d)), (n.updates || []).forEach((d) => t.parseUpdate(d)), t.resolve();
}
const Skip$2 = toSet(["rule"]), Swap = toSet(["group", "image", "rect"]);
function adjustSpatial$1(n, t) {
  let g = "";
  return Skip$2[t] || (n.x2 && (n.x ? (Swap[t] && (g += "if(o.x>o.x2)$=o.x,o.x=o.x2,o.x2=$;"), g += "o.width=o.x2-o.x;") : g += "o.x=o.x2-(o.width||0);"), n.xc && (g += "o.x=o.xc-(o.width||0)/2;"), n.y2 && (n.y ? (Swap[t] && (g += "if(o.y>o.y2)$=o.y,o.y=o.y2,o.y2=$;"), g += "o.height=o.y2-o.y;") : g += "o.y=o.y2-(o.height||0);"), n.yc && (g += "o.y=o.yc-(o.height||0)/2;")), g;
}
function canonicalType(n) {
  return (n + "").toLowerCase();
}
function isOperator(n) {
  return canonicalType(n) === "operator";
}
function isCollect(n) {
  return canonicalType(n) === "collect";
}
function expression$2(n, t, g) {
  g.endsWith(";") || (g = "return(" + g + ");");
  const d = Function(...t.concat(g));
  return n && n.functions ? d.bind(n.functions) : d;
}
function _compare(n, t, g, d) {
  return `((u = ${n}) < (v = ${t}) || u == null) && v != null ? ${g}
  : (u > v || v == null) && u != null ? ${d}
  : ((v = v instanceof Date ? +v : v), (u = u instanceof Date ? +u : u)) !== u && v === v ? ${g}
  : v !== v && u === u ? ${d} : `;
}
var expressionCodegen = {
  /**
   * Parse an expression used to update an operator value.
   */
  operator: (n, t) => expression$2(n, ["_"], t.code),
  /**
   * Parse an expression provided as an operator parameter value.
   */
  parameter: (n, t) => expression$2(n, ["datum", "_"], t.code),
  /**
   * Parse an expression applied to an event stream.
   */
  event: (n, t) => expression$2(n, ["event"], t.code),
  /**
   * Parse an expression used to handle an event-driven operator update.
   */
  handler: (n, t) => {
    const g = `var datum=event.item&&event.item.datum;return ${t.code};`;
    return expression$2(n, ["_", "event"], g);
  },
  /**
   * Parse an expression that performs visual encoding.
   */
  encode: (n, t) => {
    const {
      marktype: g,
      channels: d
    } = t;
    let k = "var o=item,datum=o.datum,m=0,$;";
    for (const H in d) {
      const AA = "o[" + $$2(H) + "]";
      k += `$=${d[H].code};if(${AA}!==$)${AA}=$,m=1;`;
    }
    return k += adjustSpatial$1(d, g), k += "return m;", expression$2(n, ["item", "_"], k);
  },
  /**
   * Optimized code generators for access and comparison.
   */
  codegen: {
    get(n) {
      const t = `[${n.map($$2).join("][")}]`, g = Function("_", `return _${t};`);
      return g.path = t, g;
    },
    comparator(n, t) {
      let g;
      const d = (H, AA) => {
        const gA = t[AA];
        let IA, CA;
        return H.path ? (IA = `a${H.path}`, CA = `b${H.path}`) : ((g = g || {})["f" + AA] = H, IA = `this.f${AA}(a)`, CA = `this.f${AA}(b)`), _compare(IA, CA, -gA, gA);
      }, k = Function("a", "b", "var u, v; return " + n.map(d).join("") + "0;");
      return g ? k.bind(g) : k;
    }
  }
};
function parseOperator(n) {
  const t = this;
  isOperator(n.type) || !n.type ? t.operator(n, n.update ? t.operatorExpression(n.update) : null) : t.transform(n, n.type);
}
function parseOperatorParameters(n) {
  const t = this;
  if (n.params) {
    const g = t.get(n.id);
    g || error$3("Invalid operator id: " + n.id), t.dataflow.connect(g, g.parameters(t.parseParameters(n.params), n.react, n.initonly));
  }
}
function parseParameters$1(n, t) {
  t = t || {};
  const g = this;
  for (const d in n) {
    const k = n[d];
    t[d] = isArray$3(k) ? k.map((H) => parseParameter$2(H, g, t)) : parseParameter$2(k, g, t);
  }
  return t;
}
function parseParameter$2(n, t, g) {
  if (!n || !isObject$4(n)) return n;
  for (let d = 0, k = PARSERS.length, H; d < k; ++d)
    if (H = PARSERS[d], has$2(n, H.key))
      return H.parse(n, t, g);
  return n;
}
var PARSERS = [{
  key: "$ref",
  parse: getOperator
}, {
  key: "$key",
  parse: getKey$1
}, {
  key: "$expr",
  parse: getExpression
}, {
  key: "$field",
  parse: getField
}, {
  key: "$encode",
  parse: getEncode
}, {
  key: "$compare",
  parse: getCompare
}, {
  key: "$context",
  parse: getContext
}, {
  key: "$subflow",
  parse: getSubflow
}, {
  key: "$tupleid",
  parse: getTupleId
}];
function getOperator(n, t) {
  return t.get(n.$ref) || error$3("Operator not defined: " + n.$ref);
}
function getExpression(n, t, g) {
  n.$params && t.parseParameters(n.$params, g);
  const d = "e:" + n.$expr.code;
  return t.fn[d] || (t.fn[d] = accessor$2(t.parameterExpression(n.$expr), n.$fields));
}
function getKey$1(n, t) {
  const g = "k:" + n.$key + "_" + !!n.$flat;
  return t.fn[g] || (t.fn[g] = key(n.$key, n.$flat, t.expr.codegen));
}
function getField(n, t) {
  if (!n.$field) return null;
  const g = "f:" + n.$field + "_" + n.$name;
  return t.fn[g] || (t.fn[g] = field$4(n.$field, n.$name, t.expr.codegen));
}
function getCompare(n, t) {
  const g = "c:" + n.$compare + "_" + n.$order, d = array$6(n.$compare).map((k) => k && k.$tupleid ? tupleid : k);
  return t.fn[g] || (t.fn[g] = compare$3(d, n.$order, t.expr.codegen));
}
function getEncode(n, t) {
  const g = n.$encode, d = {};
  for (const k in g) {
    const H = g[k];
    d[k] = accessor$2(t.encodeExpression(H.$expr), H.$fields), d[k].output = H.$output;
  }
  return d;
}
function getContext(n, t) {
  return t;
}
function getSubflow(n, t) {
  const g = n.$subflow;
  return function(d, k, H) {
    const AA = t.fork().parse(g), gA = AA.get(g.operators[0].id), IA = AA.signals.parent;
    return IA && IA.set(H), gA.detachSubflow = () => t.detach(AA), gA;
  };
}
function getTupleId() {
  return tupleid;
}
function parseStream$2(n) {
  var t = this, g = n.filter != null ? t.eventExpression(n.filter) : void 0, d = n.stream != null ? t.get(n.stream) : void 0, k;
  n.source ? d = t.events(n.source, n.type, g) : n.merge && (k = n.merge.map((H) => t.get(H)), d = k[0].merge.apply(k[0], k.slice(1))), n.between && (k = n.between.map((H) => t.get(H)), d = d.between(k[0], k[1])), n.filter && (d = d.filter(g)), n.throttle != null && (d = d.throttle(+n.throttle)), n.debounce != null && (d = d.debounce(+n.debounce)), d == null && error$3("Invalid stream definition: " + JSON.stringify(n)), n.consume && d.consume(!0), t.stream(n, d);
}
function parseUpdate$1(n) {
  var t = this, g = isObject$4(g = n.source) ? g.$ref : g, d = t.get(g), k = null, H = n.update, AA = void 0;
  d || error$3("Source not defined: " + n.source), k = n.target && n.target.$expr ? t.eventExpression(n.target.$expr) : t.get(n.target), H && H.$expr && (H.$params && (AA = t.parseParameters(H.$params)), H = t.handlerExpression(H.$expr)), t.update(n, d, k, H, AA);
}
const SKIP = {
  skip: !0
};
function getState$1(n) {
  var t = this, g = {};
  if (n.signals) {
    var d = g.signals = {};
    Object.keys(t.signals).forEach((H) => {
      const AA = t.signals[H];
      n.signals(H, AA) && (d[H] = AA.value);
    });
  }
  if (n.data) {
    var k = g.data = {};
    Object.keys(t.data).forEach((H) => {
      const AA = t.data[H];
      n.data(H, AA) && (k[H] = AA.input.value);
    });
  }
  return t.subcontext && n.recurse !== !1 && (g.subcontext = t.subcontext.map((H) => H.getState(n))), g;
}
function setState$1(n) {
  var t = this, g = t.dataflow, d = n.data, k = n.signals;
  Object.keys(k || {}).forEach((H) => {
    g.update(t.signals[H], k[H], SKIP);
  }), Object.keys(d || {}).forEach((H) => {
    g.pulse(t.data[H].input, g.changeset().remove(truthy).insert(d[H]));
  }), (n.subcontext || []).forEach((H, AA) => {
    const gA = t.subcontext[AA];
    gA && gA.setState(H);
  });
}
function context(n, t, g, d) {
  return new Context(n, t, g, d);
}
function Context(n, t, g, d) {
  this.dataflow = n, this.transforms = t, this.events = n.events.bind(n), this.expr = d || expressionCodegen, this.signals = {}, this.scales = {}, this.nodes = {}, this.data = {}, this.fn = {}, g && (this.functions = Object.create(g), this.functions.context = this);
}
function Subcontext(n) {
  this.dataflow = n.dataflow, this.transforms = n.transforms, this.events = n.events, this.expr = n.expr, this.signals = Object.create(n.signals), this.scales = Object.create(n.scales), this.nodes = Object.create(n.nodes), this.data = Object.create(n.data), this.fn = Object.create(n.fn), n.functions && (this.functions = Object.create(n.functions), this.functions.context = this);
}
Context.prototype = Subcontext.prototype = {
  fork() {
    const n = new Subcontext(this);
    return (this.subcontext || (this.subcontext = [])).push(n), n;
  },
  detach(n) {
    this.subcontext = this.subcontext.filter((g) => g !== n);
    const t = Object.keys(n.nodes);
    for (const g of t) n.nodes[g]._targets = null;
    for (const g of t) n.nodes[g].detach();
    n.nodes = null;
  },
  get(n) {
    return this.nodes[n];
  },
  set(n, t) {
    return this.nodes[n] = t;
  },
  add(n, t) {
    const g = this, d = g.dataflow, k = n.value;
    if (g.set(n.id, t), isCollect(n.type) && k && (k.$ingest ? d.ingest(t, k.$ingest, k.$format) : k.$request ? d.preload(t, k.$request, k.$format) : d.pulse(t, d.changeset().insert(k))), n.root && (g.root = t), n.parent) {
      let H = g.get(n.parent.$ref);
      H ? (d.connect(H, [t]), t.targets().add(H)) : (g.unresolved = g.unresolved || []).push(() => {
        H = g.get(n.parent.$ref), d.connect(H, [t]), t.targets().add(H);
      });
    }
    if (n.signal && (g.signals[n.signal] = t), n.scale && (g.scales[n.scale] = t), n.data)
      for (const H in n.data) {
        const AA = g.data[H] || (g.data[H] = {});
        n.data[H].forEach((gA) => AA[gA] = t);
      }
  },
  resolve() {
    return (this.unresolved || []).forEach((n) => n()), delete this.unresolved, this;
  },
  operator(n, t) {
    this.add(n, this.dataflow.add(n.value, t));
  },
  transform(n, t) {
    this.add(n, this.dataflow.add(this.transforms[canonicalType(t)]));
  },
  stream(n, t) {
    this.set(n.id, t);
  },
  update(n, t, g, d, k) {
    this.dataflow.on(t, g, d, k, n.options);
  },
  // expression parsing
  operatorExpression(n) {
    return this.expr.operator(this, n);
  },
  parameterExpression(n) {
    return this.expr.parameter(this, n);
  },
  eventExpression(n) {
    return this.expr.event(this, n);
  },
  handlerExpression(n) {
    return this.expr.handler(this, n);
  },
  encodeExpression(n) {
    return this.expr.encode(this, n);
  },
  // parse methods
  parse: parse$2,
  parseOperator,
  parseOperatorParameters,
  parseParameters: parseParameters$1,
  parseStream: parseStream$2,
  parseUpdate: parseUpdate$1,
  // state methods
  getState: getState$1,
  setState: setState$1
};
function initializeAria(n) {
  const t = n.container();
  t && (t.setAttribute("role", "graphics-document"), t.setAttribute("aria-roleDescription", "visualization"), ariaLabel(t, n.description()));
}
function ariaLabel(n, t) {
  n && (t == null ? n.removeAttribute("aria-label") : n.setAttribute("aria-label", t));
}
function background(n) {
  n.add(null, (t) => (n._background = t.bg, n._resize = 1, t.bg), {
    bg: n._signals.background
  });
}
const Default = "default";
function cursor$2(n) {
  const t = n._signals.cursor || (n._signals.cursor = n.add({
    user: Default,
    item: null
  }));
  n.on(n.events("view", "pointermove"), t, (g, d) => {
    const k = t.value, H = k ? isString$2(k) ? k : k.user : Default, AA = d.item && d.item.cursor || null;
    return k && H === k.user && AA == k.item ? k : {
      user: H,
      item: AA
    };
  }), n.add(null, function(g) {
    let d = g.cursor, k = this.value;
    return isString$2(d) || (k = d.item, d = d.user), setCursor(n, d && d !== Default ? d : k || d), k;
  }, {
    cursor: t
  });
}
function setCursor(n, t) {
  const g = n.globalCursor() ? typeof document < "u" && document.body : n.container();
  if (g)
    return t == null ? g.style.removeProperty("cursor") : g.style.cursor = t;
}
function dataref(n, t) {
  var g = n._runtime.data;
  return has$2(g, t) || error$3("Unrecognized data set: " + t), g[t];
}
function data$1(n, t) {
  return arguments.length < 2 ? dataref(this, n).values.value : change.call(this, n, changeset().remove(truthy).insert(t));
}
function change(n, t) {
  isChangeSet(t) || error$3("Second argument to changes must be a changeset.");
  const g = dataref(this, n);
  return g.modified = !0, this.pulse(g.input, t);
}
function insert(n, t) {
  return change.call(this, n, changeset().insert(t));
}
function remove(n, t) {
  return change.call(this, n, changeset().remove(t));
}
function width(n) {
  var t = n.padding();
  return Math.max(0, n._viewWidth + t.left + t.right);
}
function height(n) {
  var t = n.padding();
  return Math.max(0, n._viewHeight + t.top + t.bottom);
}
function offset(n) {
  var t = n.padding(), g = n._origin;
  return [t.left + g[0], t.top + g[1]];
}
function resizeRenderer(n) {
  var t = offset(n), g = width(n), d = height(n);
  n._renderer.background(n.background()), n._renderer.resize(g, d, t), n._handler.origin(t), n._resizeListeners.forEach((k) => {
    try {
      k(g, d);
    } catch (H) {
      n.error(H);
    }
  });
}
function eventExtend(n, t, g) {
  var d = n._renderer, k = d && d.canvas(), H, AA, gA;
  return k && (gA = offset(n), AA = t.changedTouches ? t.changedTouches[0] : t, H = point$2(AA, k), H[0] -= gA[0], H[1] -= gA[1]), t.dataflow = n, t.item = g, t.vega = extension(n, g, H), t;
}
function extension(n, t, g) {
  const d = t ? t.mark.marktype === "group" ? t : t.mark.group : null;
  function k(AA) {
    var gA = d, IA;
    if (AA) {
      for (IA = t; IA; IA = IA.mark.group)
        if (IA.mark.name === AA) {
          gA = IA;
          break;
        }
    }
    return gA && gA.mark && gA.mark.interactive ? gA : {};
  }
  function H(AA) {
    if (!AA) return g;
    isString$2(AA) && (AA = k(AA));
    const gA = g.slice();
    for (; AA; )
      gA[0] -= AA.x || 0, gA[1] -= AA.y || 0, AA = AA.mark && AA.mark.group;
    return gA;
  }
  return {
    view: constant$6(n),
    item: constant$6(t || {}),
    group: k,
    xy: H,
    x: (AA) => H(AA)[0],
    y: (AA) => H(AA)[1]
  };
}
const VIEW$1 = "view", TIMER = "timer", WINDOW = "window", NO_TRAP = {
  trap: !1
};
function initializeEventConfig(n) {
  const t = extend$2({
    defaults: {}
  }, n), g = (d, k) => {
    k.forEach((H) => {
      isArray$3(d[H]) && (d[H] = toSet(d[H]));
    });
  };
  return g(t.defaults, ["prevent", "allow"]), g(t, ["view", "window", "selector"]), t;
}
function trackEventListener(n, t, g, d) {
  n._eventListeners.push({
    type: g,
    sources: array$6(t),
    handler: d
  });
}
function prevent(n, t) {
  var g = n._eventConfig.defaults, d = g.prevent, k = g.allow;
  return d === !1 || k === !0 ? !1 : d === !0 || k === !1 ? !0 : d ? d[t] : k ? !k[t] : n.preventDefault();
}
function permit(n, t, g) {
  const d = n._eventConfig && n._eventConfig[t];
  return d === !1 || isObject$4(d) && !d[g] ? (n.warn(`Blocked ${t} ${g} event listener.`), !1) : !0;
}
function events(n, t, g) {
  var d = this, k = new EventStream(g), H = function(CA, BA) {
    d.runAsync(null, () => {
      n === VIEW$1 && prevent(d, t) && CA.preventDefault(), k.receive(eventExtend(d, CA, BA));
    });
  }, AA;
  if (n === TIMER)
    permit(d, "timer", t) && d.timer(H, t);
  else if (n === VIEW$1)
    permit(d, "view", t) && d.addEventListener(t, H, NO_TRAP);
  else if (n === WINDOW ? permit(d, "window", t) && typeof window < "u" && (AA = [window]) : typeof document < "u" && permit(d, "selector", t) && (AA = Array.from(document.querySelectorAll(n))), !AA)
    d.warn("Can not resolve event source: " + n);
  else {
    for (var gA = 0, IA = AA.length; gA < IA; ++gA)
      AA[gA].addEventListener(t, H);
    trackEventListener(d, AA, t, H);
  }
  return k;
}
function itemFilter(n) {
  return n.item;
}
function markTarget(n) {
  return n.item.mark.source;
}
function invoke(n) {
  return function(t, g) {
    return g.vega.view().changeset().encode(g.item, n);
  };
}
function hover$1(n, t) {
  return n = [n || "hover"], t = [t || "update", n[0]], this.on(this.events("view", "pointerover", itemFilter), markTarget, invoke(n)), this.on(this.events("view", "pointerout", itemFilter), markTarget, invoke(t)), this;
}
function finalize() {
  var n = this._tooltip, t = this._timers, g = this._handler.handlers(), d = this._eventListeners, k, H, AA, gA, IA;
  for (k = t.length; --k >= 0; )
    t[k].stop();
  for (k = d.length; --k >= 0; )
    for (AA = d[k], H = AA.sources.length; --H >= 0; )
      AA.sources[H].removeEventListener(AA.type, AA.handler);
  for (n && n.call(this, this._handler, null, null, null), k = g.length; --k >= 0; )
    IA = g[k].type, gA = g[k].handler, this._handler.off(IA, gA);
  return this;
}
function element(n, t, g) {
  const d = document.createElement(n);
  for (const k in t) d.setAttribute(k, t[k]);
  return g != null && (d.textContent = g), d;
}
const BindClass = "vega-bind", NameClass = "vega-bind-name", RadioClass = "vega-bind-radio";
function bind$1(n, t, g) {
  if (!t) return;
  const d = g.param;
  let k = g.state;
  return k || (k = g.state = {
    elements: null,
    active: !1,
    set: null,
    update: (AA) => {
      AA != n.signal(d.signal) && n.runAsync(null, () => {
        k.source = !0, n.signal(d.signal, AA);
      });
    }
  }, d.debounce && (k.update = debounce$1(d.debounce, k.update))), (d.input == null && d.element ? target : generate$1)(k, t, d, n), k.active || (n.on(n._signals[d.signal], null, () => {
    k.source ? k.source = !1 : k.set(n.signal(d.signal));
  }), k.active = !0), k;
}
function target(n, t, g, d) {
  const k = g.event || "input", H = () => n.update(t.value);
  d.signal(g.signal, t.value), t.addEventListener(k, H), trackEventListener(d, t, k, H), n.set = (AA) => {
    t.value = AA, t.dispatchEvent(event(k));
  };
}
function event(n) {
  return typeof Event < "u" ? new Event(n) : {
    type: n
  };
}
function generate$1(n, t, g, d) {
  const k = d.signal(g.signal), H = element("div", {
    class: BindClass
  }), AA = g.input === "radio" ? H : H.appendChild(element("label"));
  AA.appendChild(element("span", {
    class: NameClass
  }, g.name || g.signal)), t.appendChild(H);
  let gA = form;
  switch (g.input) {
    case "checkbox":
      gA = checkbox;
      break;
    case "select":
      gA = select;
      break;
    case "radio":
      gA = radio;
      break;
    case "range":
      gA = range$2;
      break;
  }
  gA(n, AA, g, k);
}
function form(n, t, g, d) {
  const k = element("input");
  for (const H in g)
    H !== "signal" && H !== "element" && k.setAttribute(H === "input" ? "type" : H, g[H]);
  k.setAttribute("name", g.signal), k.value = d, t.appendChild(k), k.addEventListener("input", () => n.update(k.value)), n.elements = [k], n.set = (H) => k.value = H;
}
function checkbox(n, t, g, d) {
  const k = {
    type: "checkbox",
    name: g.signal
  };
  d && (k.checked = !0);
  const H = element("input", k);
  t.appendChild(H), H.addEventListener("change", () => n.update(H.checked)), n.elements = [H], n.set = (AA) => H.checked = !!AA || null;
}
function select(n, t, g, d) {
  const k = element("select", {
    name: g.signal
  }), H = g.labels || [];
  g.options.forEach((AA, gA) => {
    const IA = {
      value: AA
    };
    valuesEqual(AA, d) && (IA.selected = !0), k.appendChild(element("option", IA, (H[gA] || AA) + ""));
  }), t.appendChild(k), k.addEventListener("change", () => {
    n.update(g.options[k.selectedIndex]);
  }), n.elements = [k], n.set = (AA) => {
    for (let gA = 0, IA = g.options.length; gA < IA; ++gA)
      if (valuesEqual(g.options[gA], AA)) {
        k.selectedIndex = gA;
        return;
      }
  };
}
function radio(n, t, g, d) {
  const k = element("span", {
    class: RadioClass
  }), H = g.labels || [];
  t.appendChild(k), n.elements = g.options.map((AA, gA) => {
    const IA = {
      type: "radio",
      name: g.signal,
      value: AA
    };
    valuesEqual(AA, d) && (IA.checked = !0);
    const CA = element("input", IA);
    CA.addEventListener("change", () => n.update(AA));
    const BA = element("label", {}, (H[gA] || AA) + "");
    return BA.prepend(CA), k.appendChild(BA), CA;
  }), n.set = (AA) => {
    const gA = n.elements, IA = gA.length;
    for (let CA = 0; CA < IA; ++CA)
      valuesEqual(gA[CA].value, AA) && (gA[CA].checked = !0);
  };
}
function range$2(n, t, g, d) {
  d = d !== void 0 ? d : (+g.max + +g.min) / 2;
  const k = g.max != null ? g.max : Math.max(100, +d) || 100, H = g.min || Math.min(0, k, +d) || 0, AA = g.step || tickStep(H, k, 100), gA = element("input", {
    type: "range",
    name: g.signal,
    min: H,
    max: k,
    step: AA
  });
  gA.value = d;
  const IA = element("span", {}, +d);
  t.appendChild(gA), t.appendChild(IA);
  const CA = () => {
    IA.textContent = gA.value, n.update(+gA.value);
  };
  gA.addEventListener("input", CA), gA.addEventListener("change", CA), n.elements = [gA], n.set = (BA) => {
    gA.value = BA, IA.textContent = BA;
  };
}
function valuesEqual(n, t) {
  return n === t || n + "" == t + "";
}
function initializeRenderer(n, t, g, d, k, H) {
  return t = t || new d(n.loader()), t.initialize(g, width(n), height(n), offset(n), k, H).background(n.background());
}
function trap(n, t) {
  return t ? function() {
    try {
      t.apply(this, arguments);
    } catch (g) {
      n.error(g);
    }
  } : null;
}
function initializeHandler(n, t, g, d) {
  const k = new d(n.loader(), trap(n, n.tooltip())).scene(n.scenegraph().root).initialize(g, offset(n), n);
  return t && t.handlers().forEach((H) => {
    k.on(H.type, H.handler);
  }), k;
}
function initialize(n, t) {
  const g = this, d = g._renderType, k = g._eventConfig.bind, H = renderModule(d);
  n = g._el = n ? lookup$1(g, n, !0) : null, initializeAria(g), H || g.error("Unrecognized renderer type: " + d);
  const AA = H.handler || CanvasHandler, gA = n ? H.renderer : H.headless;
  return g._renderer = gA ? initializeRenderer(g, g._renderer, n, gA) : null, g._handler = initializeHandler(g, g._handler, n, AA), g._redraw = !0, n && k !== "none" && (t = t ? g._elBind = lookup$1(g, t, !0) : n.appendChild(element("form", {
    class: "vega-bindings"
  })), g._bind.forEach((IA) => {
    IA.param.element && k !== "container" && (IA.element = lookup$1(g, IA.param.element, !!IA.param.input));
  }), g._bind.forEach((IA) => {
    bind$1(g, IA.element || t, IA);
  })), g;
}
function lookup$1(n, t, g) {
  if (typeof t == "string")
    if (typeof document < "u") {
      if (t = document.querySelector(t), !t)
        return n.error("Signal bind element not found: " + t), null;
    } else
      return n.error("DOM document instance not found."), null;
  if (t && g)
    try {
      t.textContent = "";
    } catch (d) {
      t = null, n.error(d);
    }
  return t;
}
const number$1 = (n) => +n || 0, paddingObject$1 = (n) => ({
  top: n,
  bottom: n,
  left: n,
  right: n
});
function padding$1(n) {
  return isObject$4(n) ? {
    top: number$1(n.top),
    bottom: number$1(n.bottom),
    left: number$1(n.left),
    right: number$1(n.right)
  } : paddingObject$1(number$1(n));
}
async function renderHeadless(n, t, g, d) {
  const k = renderModule(t), H = k && k.headless;
  return H || error$3("Unrecognized renderer type: " + t), await n.runAsync(), initializeRenderer(n, null, null, H, g, d).renderAsync(n._scenegraph.root);
}
async function renderToImageURL(n, t) {
  n !== RenderType.Canvas && n !== RenderType.SVG && n !== RenderType.PNG && error$3("Unrecognized image type: " + n);
  const g = await renderHeadless(this, n, t);
  return n === RenderType.SVG ? toBlobURL(g.svg(), "image/svg+xml") : g.canvas().toDataURL("image/png");
}
function toBlobURL(n, t) {
  const g = new Blob([n], {
    type: t
  });
  return window.URL.createObjectURL(g);
}
async function renderToCanvas(n, t) {
  return (await renderHeadless(this, RenderType.Canvas, n, t)).canvas();
}
async function renderToSVG(n) {
  return (await renderHeadless(this, RenderType.SVG, n)).svg();
}
function runtime(n, t, g) {
  return context(n, transforms, functionContext, g).parse(t);
}
function scale$1(n) {
  var t = this._runtime.scales;
  return has$2(t, n) || error$3("Unrecognized scale or projection: " + n), t[n].value;
}
var Width = "width", Height = "height", Padding = "padding", Skip$1 = {
  skip: !0
};
function viewWidth(n, t) {
  var g = n.autosize(), d = n.padding();
  return t - (g && g.contains === Padding ? d.left + d.right : 0);
}
function viewHeight(n, t) {
  var g = n.autosize(), d = n.padding();
  return t - (g && g.contains === Padding ? d.top + d.bottom : 0);
}
function initializeResize(n) {
  var t = n._signals, g = t[Width], d = t[Height], k = t[Padding];
  function H() {
    n._autosize = n._resize = 1;
  }
  n._resizeWidth = n.add(null, (gA) => {
    n._width = gA.size, n._viewWidth = viewWidth(n, gA.size), H();
  }, {
    size: g
  }), n._resizeHeight = n.add(null, (gA) => {
    n._height = gA.size, n._viewHeight = viewHeight(n, gA.size), H();
  }, {
    size: d
  });
  const AA = n.add(null, H, {
    pad: k
  });
  n._resizeWidth.rank = g.rank + 1, n._resizeHeight.rank = d.rank + 1, AA.rank = k.rank + 1;
}
function resizeView(n, t, g, d, k, H) {
  this.runAfter((AA) => {
    let gA = 0;
    AA._autosize = 0, AA.width() !== g && (gA = 1, AA.signal(Width, g, Skip$1), AA._resizeWidth.skip(!0)), AA.height() !== d && (gA = 1, AA.signal(Height, d, Skip$1), AA._resizeHeight.skip(!0)), AA._viewWidth !== n && (AA._resize = 1, AA._viewWidth = n), AA._viewHeight !== t && (AA._resize = 1, AA._viewHeight = t), (AA._origin[0] !== k[0] || AA._origin[1] !== k[1]) && (AA._resize = 1, AA._origin = k), gA && AA.run("enter"), H && AA.runAfter((IA) => IA.resize());
  }, !1, 1);
}
function getState(n) {
  return this._runtime.getState(n || {
    data: dataTest,
    signals: signalTest,
    recurse: !0
  });
}
function dataTest(n, t) {
  return t.modified && isArray$3(t.input.value) && !n.startsWith("_:vega:_");
}
function signalTest(n, t) {
  return !(n === "parent" || t instanceof transforms.proxy);
}
function setState(n) {
  return this.runAsync(null, (t) => {
    t._trigger = !1, t._runtime.setState(n);
  }, (t) => {
    t._trigger = !0;
  }), this;
}
function timer(n, t) {
  function g(d) {
    n({
      timestamp: Date.now(),
      elapsed: d
    });
  }
  this._timers.push(interval$1(g, t));
}
function defaultTooltip(n, t, g, d) {
  const k = n.element();
  k && k.setAttribute("title", formatTooltip(d));
}
function formatTooltip(n) {
  return n == null ? "" : isArray$3(n) ? formatArray(n) : isObject$4(n) && !isDate$2(n) ? formatObject(n) : n + "";
}
function formatObject(n) {
  return Object.keys(n).map((t) => {
    const g = n[t];
    return t + ": " + (isArray$3(g) ? formatArray(g) : formatValue$1(g));
  }).join(`
`);
}
function formatArray(n) {
  return "[" + n.map(formatValue$1).join(", ") + "]";
}
function formatValue$1(n) {
  return isArray$3(n) ? "[…]" : isObject$4(n) && !isDate$2(n) ? "{…}" : n;
}
function watchPixelRatio() {
  if (this.renderer() === "canvas" && this._renderer._canvas) {
    let n = null;
    const t = () => {
      n?.();
      const g = matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
      g.addEventListener("change", t), n = () => {
        g.removeEventListener("change", t);
      }, this._renderer._canvas.getContext("2d").pixelRatio = window.devicePixelRatio || 1, this._redraw = !0, this._resize = 1, this.resize().runAsync();
    };
    t();
  }
}
function View$1(n, t) {
  const g = this;
  if (t = t || {}, Dataflow.call(g), t.loader && g.loader(t.loader), t.logger && g.logger(t.logger), t.logLevel != null && g.logLevel(t.logLevel), t.locale || n.locale) {
    const H = extend$2({}, n.locale, t.locale);
    g.locale(locale(H.number, H.time));
  }
  g._el = null, g._elBind = null, g._renderType = t.renderer || RenderType.Canvas, g._scenegraph = new Scenegraph();
  const d = g._scenegraph.root;
  g._renderer = null, g._tooltip = t.tooltip || defaultTooltip, g._redraw = !0, g._handler = new CanvasHandler().scene(d), g._globalCursor = !1, g._preventDefault = !1, g._timers = [], g._eventListeners = [], g._resizeListeners = [], g._eventConfig = initializeEventConfig(n.eventConfig), g.globalCursor(g._eventConfig.globalCursor);
  const k = runtime(g, n, t.expr);
  g._runtime = k, g._signals = k.signals, g._bind = (n.bindings || []).map((H) => ({
    state: null,
    param: extend$2({}, H)
  })), k.root && k.root.set(d), d.source = k.data.root.input, g.pulse(k.data.root.input, g.changeset().insert(d.items)), g._width = g.width(), g._height = g.height(), g._viewWidth = viewWidth(g, g._width), g._viewHeight = viewHeight(g, g._height), g._origin = [0, 0], g._resize = 0, g._autosize = 1, initializeResize(g), background(g), cursor$2(g), g.description(n.description), t.hover && g.hover(), t.container && g.initialize(t.container, t.bind), t.watchPixelRatio && g._watchPixelRatio();
}
function lookupSignal(n, t) {
  return has$2(n._signals, t) ? n._signals[t] : error$3("Unrecognized signal name: " + $$2(t));
}
function findOperatorHandler(n, t) {
  const g = (n._targets || []).filter((d) => d._update && d._update.handler === t);
  return g.length ? g[0] : null;
}
function addOperatorListener(n, t, g, d) {
  let k = findOperatorHandler(g, d);
  return k || (k = trap(n, () => d(t, g.value)), k.handler = d, n.on(g, null, k)), n;
}
function removeOperatorListener(n, t, g) {
  const d = findOperatorHandler(t, g);
  return d && t._targets.remove(d), n;
}
inherits$1(View$1, Dataflow, {
  // -- DATAFLOW / RENDERING ----
  async evaluate(n, t, g) {
    if (await Dataflow.prototype.evaluate.call(this, n, t), this._redraw || this._resize)
      try {
        this._renderer && (this._resize && (this._resize = 0, resizeRenderer(this)), await this._renderer.renderAsync(this._scenegraph.root)), this._redraw = !1;
      } catch (d) {
        this.error(d);
      }
    return g && asyncCallback(this, g), this;
  },
  dirty(n) {
    this._redraw = !0, this._renderer && this._renderer.dirty(n);
  },
  // -- GET / SET ----
  description(n) {
    if (arguments.length) {
      const t = n != null ? n + "" : null;
      return t !== this._desc && ariaLabel(this._el, this._desc = t), this;
    }
    return this._desc;
  },
  container() {
    return this._el;
  },
  scenegraph() {
    return this._scenegraph;
  },
  origin() {
    return this._origin.slice();
  },
  signal(n, t, g) {
    const d = lookupSignal(this, n);
    return arguments.length === 1 ? d.value : this.update(d, t, g);
  },
  width(n) {
    return arguments.length ? this.signal("width", n) : this.signal("width");
  },
  height(n) {
    return arguments.length ? this.signal("height", n) : this.signal("height");
  },
  padding(n) {
    return arguments.length ? this.signal("padding", padding$1(n)) : padding$1(this.signal("padding"));
  },
  autosize(n) {
    return arguments.length ? this.signal("autosize", n) : this.signal("autosize");
  },
  background(n) {
    return arguments.length ? this.signal("background", n) : this.signal("background");
  },
  renderer(n) {
    return arguments.length ? (renderModule(n) || error$3("Unrecognized renderer type: " + n), n !== this._renderType && (this._renderType = n, this._resetRenderer()), this) : this._renderType;
  },
  tooltip(n) {
    return arguments.length ? (n !== this._tooltip && (this._tooltip = n, this._resetRenderer()), this) : this._tooltip;
  },
  loader(n) {
    return arguments.length ? (n !== this._loader && (Dataflow.prototype.loader.call(this, n), this._resetRenderer()), this) : this._loader;
  },
  resize() {
    return this._autosize = 1, this.touch(lookupSignal(this, "autosize"));
  },
  _resetRenderer() {
    this._renderer && (this._renderer = null, this.initialize(this._el, this._elBind));
  },
  // -- SIZING ----
  _resizeView: resizeView,
  // -- EVENT HANDLING ----
  addEventListener(n, t, g) {
    let d = t;
    return g && g.trap === !1 || (d = trap(this, t), d.raw = t), this._handler.on(n, d), this;
  },
  removeEventListener(n, t) {
    for (var g = this._handler.handlers(n), d = g.length, k, H; --d >= 0; )
      if (H = g[d].type, k = g[d].handler, n === H && (t === k || t === k.raw)) {
        this._handler.off(H, k);
        break;
      }
    return this;
  },
  addResizeListener(n) {
    const t = this._resizeListeners;
    return t.includes(n) || t.push(n), this;
  },
  removeResizeListener(n) {
    var t = this._resizeListeners, g = t.indexOf(n);
    return g >= 0 && t.splice(g, 1), this;
  },
  addSignalListener(n, t) {
    return addOperatorListener(this, n, lookupSignal(this, n), t);
  },
  removeSignalListener(n, t) {
    return removeOperatorListener(this, lookupSignal(this, n), t);
  },
  addDataListener(n, t) {
    return addOperatorListener(this, n, dataref(this, n).values, t);
  },
  removeDataListener(n, t) {
    return removeOperatorListener(this, dataref(this, n).values, t);
  },
  globalCursor(n) {
    if (arguments.length) {
      if (this._globalCursor !== !!n) {
        const t = setCursor(this, null);
        this._globalCursor = !!n, t && setCursor(this, t);
      }
      return this;
    } else
      return this._globalCursor;
  },
  preventDefault(n) {
    return arguments.length ? (this._preventDefault = n, this) : this._preventDefault;
  },
  timer,
  events,
  finalize,
  hover: hover$1,
  // -- DATA ----
  data: data$1,
  change,
  insert,
  remove,
  // -- SCALES --
  scale: scale$1,
  // -- INITIALIZATION ----
  initialize,
  // -- HEADLESS RENDERING ----
  toImageURL: renderToImageURL,
  toCanvas: renderToCanvas,
  toSVG: renderToSVG,
  // -- SAVE / RESTORE STATE ----
  getState,
  setState,
  // RE-RENDER ON ZOOM
  _watchPixelRatio: watchPixelRatio
});
const VIEW = "view", LBRACK = "[", RBRACK = "]", LBRACE = "{", RBRACE = "}", COLON = ":", COMMA = ",", NAME = "@", GT = ">", ILLEGAL$1 = /[[\]{}]/, DEFAULT_MARKS = {
  "*": 1,
  arc: 1,
  area: 1,
  group: 1,
  image: 1,
  line: 1,
  path: 1,
  rect: 1,
  rule: 1,
  shape: 1,
  symbol: 1,
  text: 1,
  trail: 1
};
let DEFAULT_SOURCE, MARKS;
function eventSelector(n, t, g) {
  return DEFAULT_SOURCE = t || VIEW, MARKS = g || DEFAULT_MARKS, parseMerge(n.trim()).map(parseSelector);
}
function isMarkType(n) {
  return MARKS[n];
}
function find(n, t, g, d, k) {
  const H = n.length;
  let AA = 0, gA;
  for (; t < H; ++t) {
    if (gA = n[t], !AA && gA === g) return t;
    k && k.includes(gA) ? --AA : d && d.includes(gA) && ++AA;
  }
  return t;
}
function parseMerge(n) {
  const t = [], g = n.length;
  let d = 0, k = 0;
  for (; k < g; )
    k = find(n, k, COMMA, LBRACK + LBRACE, RBRACK + RBRACE), t.push(n.substring(d, k).trim()), d = ++k;
  if (t.length === 0)
    throw "Empty event selector: " + n;
  return t;
}
function parseSelector(n) {
  return n[0] === "[" ? parseBetween(n) : parseStream$1(n);
}
function parseBetween(n) {
  const t = n.length;
  let g = 1, d;
  if (g = find(n, g, RBRACK, LBRACK, RBRACK), g === t)
    throw "Empty between selector: " + n;
  if (d = parseMerge(n.substring(1, g)), d.length !== 2)
    throw "Between selector must have two elements: " + n;
  if (n = n.slice(g + 1).trim(), n[0] !== GT)
    throw "Expected '>' after between selector: " + n;
  d = d.map(parseSelector);
  const k = parseSelector(n.slice(1).trim());
  return k.between ? {
    between: d,
    stream: k
  } : (k.between = d, k);
}
function parseStream$1(n) {
  const t = {
    source: DEFAULT_SOURCE
  }, g = [];
  let d = [0, 0], k = 0, H = 0, AA = n.length, gA = 0, IA, CA;
  if (n[AA - 1] === RBRACE) {
    if (gA = n.lastIndexOf(LBRACE), gA >= 0) {
      try {
        d = parseThrottle(n.substring(gA + 1, AA - 1));
      } catch {
        throw "Invalid throttle specification: " + n;
      }
      n = n.slice(0, gA).trim(), AA = n.length;
    } else throw "Unmatched right brace: " + n;
    gA = 0;
  }
  if (!AA) throw n;
  if (n[0] === NAME && (k = ++gA), IA = find(n, gA, COLON), IA < AA && (g.push(n.substring(H, IA).trim()), H = gA = ++IA), gA = find(n, gA, LBRACK), gA === AA)
    g.push(n.substring(H, AA).trim());
  else if (g.push(n.substring(H, gA).trim()), CA = [], H = ++gA, H === AA) throw "Unmatched left bracket: " + n;
  for (; gA < AA; ) {
    if (gA = find(n, gA, RBRACK), gA === AA) throw "Unmatched left bracket: " + n;
    if (CA.push(n.substring(H, gA).trim()), gA < AA - 1 && n[++gA] !== LBRACK) throw "Expected left bracket: " + n;
    H = ++gA;
  }
  if (!(AA = g.length) || ILLEGAL$1.test(g[AA - 1]))
    throw "Invalid event selector: " + n;
  return AA > 1 ? (t.type = g[1], k ? t.markname = g[0].slice(1) : isMarkType(g[0]) ? t.marktype = g[0] : t.source = g[0]) : t.type = g[0], t.type.slice(-1) === "!" && (t.consume = !0, t.type = t.type.slice(0, -1)), CA != null && (t.filter = CA), d[0] && (t.throttle = d[0]), d[1] && (t.debounce = d[1]), t;
}
function parseThrottle(n) {
  const t = n.split(COMMA);
  if (!n.length || t.length > 2) throw n;
  return t.map((g) => {
    const d = +g;
    if (d !== d) throw n;
    return d;
  });
}
function parseAutosize(n) {
  return isObject$4(n) ? n : {
    type: n || "pad"
  };
}
const number = (n) => +n || 0, paddingObject = (n) => ({
  top: n,
  bottom: n,
  left: n,
  right: n
});
function parsePadding(n) {
  return isObject$4(n) ? n.signal ? n : {
    top: number(n.top),
    bottom: number(n.bottom),
    left: number(n.left),
    right: number(n.right)
  } : paddingObject(number(n));
}
const encoder = (n) => isObject$4(n) && !isArray$3(n) ? extend$2({}, n) : {
  value: n
};
function addEncode(n, t, g, d) {
  return g != null ? (isObject$4(g) && !isArray$3(g) || isArray$3(g) && g.length && isObject$4(g[0]) ? n.update[t] = g : n[d || "enter"][t] = {
    value: g
  }, 1) : 0;
}
function addEncoders(n, t, g) {
  for (const d in t)
    addEncode(n, d, t[d]);
  for (const d in g)
    addEncode(n, d, g[d], "update");
}
function extendEncode(n, t, g) {
  for (const d in t)
    g && has$2(g, d) || (n[d] = extend$2(n[d] || {}, t[d]));
  return n;
}
function has$1(n, t) {
  return t && (t.enter && t.enter[n] || t.update && t.update[n]);
}
const MarkRole = "mark", FrameRole = "frame", ScopeRole = "scope", AxisRole = "axis", AxisDomainRole = "axis-domain", AxisGridRole = "axis-grid", AxisLabelRole = "axis-label", AxisTickRole = "axis-tick", AxisTitleRole = "axis-title", LegendRole = "legend", LegendBandRole = "legend-band", LegendEntryRole = "legend-entry", LegendGradientRole = "legend-gradient", LegendLabelRole = "legend-label", LegendSymbolRole = "legend-symbol", LegendTitleRole = "legend-title", TitleRole = "title", TitleTextRole = "title-text", TitleSubtitleRole = "title-subtitle";
function applyDefaults(n, t, g, d, k) {
  const H = {}, AA = {};
  let gA, IA, CA, BA;
  IA = "lineBreak", t === "text" && k[IA] != null && !has$1(IA, n) && applyDefault(H, IA, k[IA]), (g == "legend" || String(g).startsWith("axis")) && (g = null), BA = g === FrameRole ? k.group : g === MarkRole ? extend$2({}, k.mark, k[t]) : null;
  for (IA in BA)
    CA = has$1(IA, n) || (IA === "fill" || IA === "stroke") && (has$1("fill", n) || has$1("stroke", n)), CA || applyDefault(H, IA, BA[IA]);
  array$6(d).forEach((eA) => {
    const iA = k.style && k.style[eA];
    for (const QA in iA)
      has$1(QA, n) || applyDefault(H, QA, iA[QA]);
  }), n = extend$2({}, n);
  for (IA in H)
    BA = H[IA], BA.signal ? (gA = gA || {})[IA] = BA : AA[IA] = BA;
  return n.enter = extend$2(AA, n.enter), gA && (n.update = extend$2(gA, n.update)), n;
}
function applyDefault(n, t, g) {
  n[t] = g && g.signal ? {
    signal: g.signal
  } : {
    value: g
  };
}
const scaleRef = (n) => isString$2(n) ? $$2(n) : n.signal ? `(${n.signal})` : field$3(n);
function entry$1(n) {
  if (n.gradient != null)
    return gradient$2(n);
  let t = n.signal ? `(${n.signal})` : n.color ? color$1(n.color) : n.field != null ? field$3(n.field) : n.value !== void 0 ? $$2(n.value) : void 0;
  return n.scale != null && (t = scale(n, t)), t === void 0 && (t = null), n.exponent != null && (t = `pow(${t},${property$1(n.exponent)})`), n.mult != null && (t += `*${property$1(n.mult)}`), n.offset != null && (t += `+${property$1(n.offset)}`), n.round && (t = `round(${t})`), t;
}
const _color = (n, t, g, d) => `(${n}(${[t, g, d].map(entry$1).join(",")})+'')`;
function color$1(n) {
  return n.c ? _color("hcl", n.h, n.c, n.l) : n.h || n.s ? _color("hsl", n.h, n.s, n.l) : n.l || n.a ? _color("lab", n.l, n.a, n.b) : n.r || n.g || n.b ? _color("rgb", n.r, n.g, n.b) : null;
}
function gradient$2(n) {
  const t = [n.start, n.stop, n.count].map((g) => g == null ? null : $$2(g));
  for (; t.length && peek$2(t) == null; ) t.pop();
  return t.unshift(scaleRef(n.gradient)), `gradient(${t.join(",")})`;
}
function property$1(n) {
  return isObject$4(n) ? "(" + entry$1(n) + ")" : n;
}
function field$3(n) {
  return resolveField(isObject$4(n) ? n : {
    datum: n
  });
}
function resolveField(n) {
  let t, g, d;
  if (n.signal)
    t = "datum", d = n.signal;
  else if (n.group || n.parent) {
    for (g = Math.max(1, n.level || 1), t = "item"; g-- > 0; )
      t += ".mark.group";
    n.parent ? (d = n.parent, t += ".datum") : d = n.group;
  } else n.datum ? (t = "datum", d = n.datum) : error$3("Invalid field reference: " + $$2(n));
  return n.signal || (d = isString$2(d) ? splitAccessPath$2(d).map($$2).join("][") : resolveField(d)), t + "[" + d + "]";
}
function scale(n, t) {
  const g = scaleRef(n.scale);
  return n.range != null ? t = `lerp(_range(${g}), ${+n.range})` : (t !== void 0 && (t = `_scale(${g}, ${t})`), n.band && (t = (t ? t + "+" : "") + `_bandwidth(${g})` + (+n.band == 1 ? "" : "*" + property$1(n.band)), n.extra && (t = `(datum.extra ? _scale(${g}, datum.extra.value) : ${t})`)), t == null && (t = "0")), t;
}
function rule$1(n) {
  let t = "";
  return n.forEach((g) => {
    const d = entry$1(g);
    t += g.test ? `(${g.test})?${d}:` : d;
  }), peek$2(t) === ":" && (t += "null"), t;
}
function parseEncode(n, t, g, d, k, H) {
  const AA = {};
  H = H || {}, H.encoders = {
    $encode: AA
  }, n = applyDefaults(n, t, g, d, k.config);
  for (const gA in n)
    AA[gA] = parseBlock(n[gA], t, H, k);
  return H;
}
function parseBlock(n, t, g, d) {
  const k = {}, H = {};
  for (const AA in n)
    n[AA] != null && (k[AA] = parse$1(expr(n[AA]), d, g, H));
  return {
    $expr: {
      marktype: t,
      channels: k
    },
    $fields: Object.keys(H),
    $output: Object.keys(n)
  };
}
function expr(n) {
  return isArray$3(n) ? rule$1(n) : entry$1(n);
}
function parse$1(n, t, g, d) {
  const k = parser$2(n, t);
  return k.$fields.forEach((H) => d[H] = 1), extend$2(g, k.$params), k.$expr;
}
const OUTER = "outer", OUTER_INVALID = ["value", "update", "init", "react", "bind"];
function outerError(n, t) {
  error$3(n + ' for "outer" push: ' + $$2(t));
}
function parseSignal(n, t) {
  const g = n.name;
  if (n.push === OUTER)
    t.signals[g] || outerError("No prior signal definition", g), OUTER_INVALID.forEach((d) => {
      n[d] !== void 0 && outerError("Invalid property ", d);
    });
  else {
    const d = t.addSignal(g, n.value);
    n.react === !1 && (d.react = !1), n.bind && t.addBinding(g, n.bind);
  }
}
function Entry(n, t, g, d) {
  this.id = -1, this.type = n, this.value = t, this.params = g, d && (this.parent = d);
}
function entry(n, t, g, d) {
  return new Entry(n, t, g, d);
}
function operator(n, t) {
  return entry("operator", n, t);
}
function ref(n) {
  const t = {
    $ref: n.id
  };
  return n.id < 0 && (n.refs = n.refs || []).push(t), t;
}
function fieldRef$1(n, t) {
  return t ? {
    $field: n,
    $name: t
  } : {
    $field: n
  };
}
const keyFieldRef = fieldRef$1("key");
function compareRef(n, t) {
  return {
    $compare: n,
    $order: t
  };
}
function keyRef(n, t) {
  const g = {
    $key: n
  };
  return t && (g.$flat = !0), g;
}
const Ascending = "ascending", Descending = "descending";
function sortKey(n) {
  return isObject$4(n) ? (n.order === Descending ? "-" : "+") + aggrField(n.op, n.field) : "";
}
function aggrField(n, t) {
  return (n && n.signal ? "$" + n.signal : n || "") + (n && t ? "_" : "") + (t && t.signal ? "$" + t.signal : t || "");
}
const Scope$1 = "scope", View = "view";
function isSignal(n) {
  return n && n.signal;
}
function isExpr$1(n) {
  return n && n.expr;
}
function hasSignal(n) {
  if (isSignal(n)) return !0;
  if (isObject$4(n)) {
    for (const t in n)
      if (hasSignal(n[t])) return !0;
  }
  return !1;
}
function value(n, t) {
  return n ?? t;
}
function deref(n) {
  return n && n.signal || n;
}
const Timer$1 = "timer";
function parseStream(n, t) {
  return (n.merge ? mergeStream : n.stream ? nestedStream : n.type ? eventStream : error$3("Invalid stream specification: " + $$2(n)))(n, t);
}
function eventSource(n) {
  return n === Scope$1 ? View : n || View;
}
function mergeStream(n, t) {
  const g = n.merge.map((k) => parseStream(k, t)), d = streamParameters({
    merge: g
  }, n, t);
  return t.addStream(d).id;
}
function nestedStream(n, t) {
  const g = parseStream(n.stream, t), d = streamParameters({
    stream: g
  }, n, t);
  return t.addStream(d).id;
}
function eventStream(n, t) {
  let g;
  n.type === Timer$1 ? (g = t.event(Timer$1, n.throttle), n = {
    between: n.between,
    filter: n.filter
  }) : g = t.event(eventSource(n.source), n.type);
  const d = streamParameters({
    stream: g
  }, n, t);
  return Object.keys(d).length === 1 ? g : t.addStream(d).id;
}
function streamParameters(n, t, g) {
  let d = t.between;
  return d && (d.length !== 2 && error$3('Stream "between" parameter must have 2 entries: ' + $$2(t)), n.between = [parseStream(d[0], g), parseStream(d[1], g)]), d = t.filter ? [].concat(t.filter) : [], (t.marktype || t.markname || t.markrole) && d.push(filterMark(t.marktype, t.markname, t.markrole)), t.source === Scope$1 && d.push("inScope(event.item)"), d.length && (n.filter = parser$2("(" + d.join(")&&(") + ")", g).$expr), (d = t.throttle) != null && (n.throttle = +d), (d = t.debounce) != null && (n.debounce = +d), t.consume && (n.consume = !0), n;
}
function filterMark(n, t, g) {
  const d = "event.item";
  return d + (n && n !== "*" ? "&&" + d + ".mark.marktype==='" + n + "'" : "") + (g ? "&&" + d + ".mark.role==='" + g + "'" : "") + (t ? "&&" + d + ".mark.name==='" + t + "'" : "");
}
const OP_VALUE_EXPR = {
  code: "_.$value",
  ast: {
    type: "Identifier",
    value: "value"
  }
};
function parseUpdate(n, t, g) {
  const d = n.encode, k = {
    target: g
  };
  let H = n.events, AA = n.update, gA = [];
  H || error$3("Signal update missing events specification."), isString$2(H) && (H = eventSelector(H, t.isSubscope() ? Scope$1 : View)), H = array$6(H).filter((IA) => IA.signal || IA.scale ? (gA.push(IA), 0) : 1), gA.length > 1 && (gA = [mergeSources(gA)]), H.length && gA.push(H.length > 1 ? {
    merge: H
  } : H[0]), d != null && (AA && error$3("Signal encode and update are mutually exclusive."), AA = "encode(item()," + $$2(d) + ")"), k.update = isString$2(AA) ? parser$2(AA, t) : AA.expr != null ? parser$2(AA.expr, t) : AA.value != null ? AA.value : AA.signal != null ? {
    $expr: OP_VALUE_EXPR,
    $params: {
      $value: t.signalRef(AA.signal)
    }
  } : error$3("Invalid signal update specification."), n.force && (k.options = {
    force: !0
  }), gA.forEach((IA) => t.addUpdate(extend$2(streamSource(IA, t), k)));
}
function streamSource(n, t) {
  return {
    source: n.signal ? t.signalRef(n.signal) : n.scale ? t.scaleRef(n.scale) : parseStream(n, t)
  };
}
function mergeSources(n) {
  return {
    signal: "[" + n.map((t) => t.scale ? 'scale("' + t.scale + '")' : t.signal) + "]"
  };
}
function parseSignalUpdates(n, t) {
  const g = t.getSignal(n.name);
  let d = n.update;
  n.init && (d ? error$3("Signals can not include both init and update expressions.") : (d = n.init, g.initonly = !0)), d && (d = parser$2(d, t), g.update = d.$expr, g.params = d.$params), n.on && n.on.forEach((k) => parseUpdate(k, t, g.id));
}
const transform = (n) => (t, g, d) => entry(n, g, t || void 0, d), Aggregate = transform("aggregate"), AxisTicks = transform("axisticks"), Bound = transform("bound"), Collect = transform("collect"), Compare = transform("compare"), DataJoin = transform("datajoin"), Encode = transform("encode"), Expression = transform("expression"), Facet = transform("facet"), Field = transform("field"), Key = transform("key"), LegendEntries = transform("legendentries"), Load = transform("load"), Mark$1 = transform("mark"), MultiExtent = transform("multiextent"), MultiValues = transform("multivalues"), Overlap = transform("overlap"), Params = transform("params"), PreFacet = transform("prefacet"), Projection = transform("projection"), Proxy$1 = transform("proxy"), Relay = transform("relay"), Render = transform("render"), Scale = transform("scale"), Sieve = transform("sieve"), SortItems = transform("sortitems"), ViewLayout = transform("viewlayout"), Values = transform("values");
let FIELD_REF_ID = 0;
const MULTIDOMAIN_SORT_OPS = {
  min: "min",
  max: "max",
  count: "sum"
};
function initScale(n, t) {
  const g = n.type || "linear";
  isValidScaleType(g) || error$3("Unrecognized scale type: " + $$2(g)), t.addScale(n.name, {
    type: g,
    domain: void 0
  });
}
function parseScale(n, t) {
  const g = t.getScale(n.name).params;
  let d;
  g.domain = parseScaleDomain$1(n.domain, n, t), n.range != null && (g.range = parseScaleRange$1(n, t, g)), n.interpolate != null && parseScaleInterpolate(n.interpolate, g), n.nice != null && (g.nice = parseScaleNice(n.nice, t)), n.bins != null && (g.bins = parseScaleBins(n.bins, t));
  for (d in n)
    has$2(g, d) || d === "name" || (g[d] = parseLiteral(n[d], t));
}
function parseLiteral(n, t) {
  return isObject$4(n) ? n.signal ? t.signalRef(n.signal) : error$3("Unsupported object: " + $$2(n)) : n;
}
function parseArray(n, t) {
  return n.signal ? t.signalRef(n.signal) : n.map((g) => parseLiteral(g, t));
}
function dataLookupError(n) {
  error$3("Can not find data set: " + $$2(n));
}
function parseScaleDomain$1(n, t, g) {
  if (!n) {
    (t.domainMin != null || t.domainMax != null) && error$3("No scale domain defined for domainMin/domainMax to override.");
    return;
  }
  return n.signal ? g.signalRef(n.signal) : (isArray$3(n) ? explicitDomain : n.fields ? multipleDomain : singularDomain)(n, t, g);
}
function explicitDomain(n, t, g) {
  return n.map((d) => parseLiteral(d, g));
}
function singularDomain(n, t, g) {
  const d = g.getData(n.data);
  return d || dataLookupError(n.data), isDiscrete$2(t.type) ? d.valuesRef(g, n.field, parseSort(n.sort, !1)) : isQuantile$1(t.type) ? d.domainRef(g, n.field) : d.extentRef(g, n.field);
}
function multipleDomain(n, t, g) {
  const d = n.data, k = n.fields.reduce((H, AA) => (AA = isString$2(AA) ? {
    data: d,
    field: AA
  } : isArray$3(AA) || AA.signal ? fieldRef(AA, g) : AA, H.push(AA), H), []);
  return (isDiscrete$2(t.type) ? ordinalMultipleDomain : isQuantile$1(t.type) ? quantileMultipleDomain : numericMultipleDomain)(n, g, k);
}
function fieldRef(n, t) {
  const g = "_:vega:_" + FIELD_REF_ID++, d = Collect({});
  if (isArray$3(n))
    d.value = {
      $ingest: n
    };
  else if (n.signal) {
    const k = "setdata(" + $$2(g) + "," + n.signal + ")";
    d.params.input = t.signalRef(k);
  }
  return t.addDataPipeline(g, [d, Sieve({})]), {
    data: g,
    field: "data"
  };
}
function ordinalMultipleDomain(n, t, g) {
  const d = parseSort(n.sort, !0);
  let k, H;
  const AA = g.map((CA) => {
    const BA = t.getData(CA.data);
    return BA || dataLookupError(CA.data), BA.countsRef(t, CA.field, d);
  }), gA = {
    groupby: keyFieldRef,
    pulse: AA
  };
  d && (k = d.op || "count", H = d.field ? aggrField(k, d.field) : "count", gA.ops = [MULTIDOMAIN_SORT_OPS[k]], gA.fields = [t.fieldRef(H)], gA.as = [H]), k = t.add(Aggregate(gA));
  const IA = t.add(Collect({
    pulse: ref(k)
  }));
  return H = t.add(Values({
    field: keyFieldRef,
    sort: t.sortRef(d),
    pulse: ref(IA)
  })), ref(H);
}
function parseSort(n, t) {
  return n && (!n.field && !n.op ? isObject$4(n) ? n.field = "key" : n = {
    field: "key"
  } : !n.field && n.op !== "count" ? error$3("No field provided for sort aggregate op: " + n.op) : t && n.field && n.op && !MULTIDOMAIN_SORT_OPS[n.op] && error$3("Multiple domain scales can not be sorted using " + n.op)), n;
}
function quantileMultipleDomain(n, t, g) {
  const d = g.map((k) => {
    const H = t.getData(k.data);
    return H || dataLookupError(k.data), H.domainRef(t, k.field);
  });
  return ref(t.add(MultiValues({
    values: d
  })));
}
function numericMultipleDomain(n, t, g) {
  const d = g.map((k) => {
    const H = t.getData(k.data);
    return H || dataLookupError(k.data), H.extentRef(t, k.field);
  });
  return ref(t.add(MultiExtent({
    extents: d
  })));
}
function parseScaleBins(n, t) {
  return n.signal || isArray$3(n) ? parseArray(n, t) : t.objectProperty(n);
}
function parseScaleNice(n, t) {
  return n.signal ? t.signalRef(n.signal) : isObject$4(n) ? {
    interval: parseLiteral(n.interval),
    step: parseLiteral(n.step)
  } : parseLiteral(n);
}
function parseScaleInterpolate(n, t) {
  t.interpolate = parseLiteral(n.type || n), n.gamma != null && (t.interpolateGamma = parseLiteral(n.gamma));
}
function parseScaleRange$1(n, t, g) {
  const d = t.config.range;
  let k = n.range;
  if (k.signal)
    return t.signalRef(k.signal);
  if (isString$2(k)) {
    if (d && has$2(d, k))
      return n = extend$2({}, n, {
        range: d[k]
      }), parseScaleRange$1(n, t, g);
    k === "width" ? k = [0, {
      signal: "width"
    }] : k === "height" ? k = isDiscrete$2(n.type) ? [0, {
      signal: "height"
    }] : [{
      signal: "height"
    }, 0] : error$3("Unrecognized scale range value: " + $$2(k));
  } else if (k.scheme) {
    g.scheme = isArray$3(k.scheme) ? parseArray(k.scheme, t) : parseLiteral(k.scheme, t), k.extent && (g.schemeExtent = parseArray(k.extent, t)), k.count && (g.schemeCount = parseLiteral(k.count, t));
    return;
  } else if (k.step) {
    g.rangeStep = parseLiteral(k.step, t);
    return;
  } else {
    if (isDiscrete$2(n.type) && !isArray$3(k))
      return parseScaleDomain$1(k, n, t);
    isArray$3(k) || error$3("Unsupported range type: " + $$2(k));
  }
  return k.map((H) => (isArray$3(H) ? parseArray : parseLiteral)(H, t));
}
function parseProjection$1(n, t) {
  const g = t.config.projection || {}, d = {};
  for (const k in n)
    k !== "name" && (d[k] = parseParameter$1(n[k], k, t));
  for (const k in g)
    d[k] == null && (d[k] = parseParameter$1(g[k], k, t));
  t.addProjection(n.name, d);
}
function parseParameter$1(n, t, g) {
  return isArray$3(n) ? n.map((d) => parseParameter$1(d, t, g)) : isObject$4(n) ? n.signal ? g.signalRef(n.signal) : t === "fit" ? n : error$3("Unsupported parameter object: " + $$2(n)) : n;
}
const Top = "top", Left = "left", Right = "right", Bottom = "bottom", Center = "center", Vertical = "vertical", Start = "start", Middle = "middle", End = "end", Index = "index", Label = "label", Offset = "offset", Perc = "perc", Perc2 = "perc2", Value$1 = "value", GuideLabelStyle = "guide-label", GuideTitleStyle = "guide-title", GroupTitleStyle = "group-title", GroupSubtitleStyle = "group-subtitle", Symbols = "symbol", Gradient = "gradient", Discrete = "discrete", Size = "size", Shape = "shape", Fill = "fill", Stroke = "stroke", StrokeWidth = "strokeWidth", StrokeDash = "strokeDash", Opacity = "opacity", LegendScales = [Size, Shape, Fill, Stroke, StrokeWidth, StrokeDash, Opacity], Skip = {
  name: 1,
  style: 1,
  interactive: 1
}, zero$1 = {
  value: 0
}, one = {
  value: 1
}, GroupMark = "group", RectMark = "rect", RuleMark = "rule", SymbolMark = "symbol", TextMark = "text";
function guideGroup(n) {
  return n.type = GroupMark, n.interactive = n.interactive || !1, n;
}
function lookup(n, t) {
  const g = (d, k) => value(n[d], value(t[d], k));
  return g.isVertical = (d) => Vertical === value(n.direction, t.direction || (d ? t.symbolDirection : t.gradientDirection)), g.gradientLength = () => value(n.gradientLength, t.gradientLength || t.gradientWidth), g.gradientThickness = () => value(n.gradientThickness, t.gradientThickness || t.gradientHeight), g.entryColumns = () => value(n.columns, value(t.columns, +g.isVertical(!0))), g;
}
function getEncoding(n, t) {
  const g = t && (t.update && t.update[n] || t.enter && t.enter[n]);
  return g && g.signal ? g : g ? g.value : null;
}
function getStyle(n, t, g) {
  const d = t.config.style[g];
  return d && d[n];
}
function anchorExpr(n, t, g) {
  return `item.anchor === '${Start}' ? ${n} : item.anchor === '${End}' ? ${t} : ${g}`;
}
const alignExpr$1 = anchorExpr($$2(Left), $$2(Right), $$2(Center));
function tickBand(n) {
  const t = n("tickBand");
  let g = n("tickOffset"), d, k;
  return t ? t.signal ? (d = {
    signal: `(${t.signal}) === 'extent' ? 1 : 0.5`
  }, k = {
    signal: `(${t.signal}) === 'extent'`
  }, isObject$4(g) || (g = {
    signal: `(${t.signal}) === 'extent' ? 0 : ${g}`
  })) : t === "extent" ? (d = 1, k = !0, g = 0) : (d = 0.5, k = !1) : (d = n("bandPosition"), k = n("tickExtra")), {
    extra: k,
    band: d,
    offset: g
  };
}
function extendOffset(n, t) {
  return t ? n ? isObject$4(n) ? Object.assign({}, n, {
    offset: extendOffset(n.offset, t)
  }) : {
    value: n,
    offset: t
  } : t : n;
}
function guideMark(n, t) {
  return t ? (n.name = t.name, n.style = t.style || n.style, n.interactive = !!t.interactive, n.encode = extendEncode(n.encode, t, Skip)) : n.interactive = !1, n;
}
function legendGradient(n, t, g, d) {
  const k = lookup(n, g), H = k.isVertical(), AA = k.gradientThickness(), gA = k.gradientLength();
  let IA, CA, BA, eA, iA;
  H ? (CA = [0, 1], BA = [0, 0], eA = AA, iA = gA) : (CA = [0, 0], BA = [1, 0], eA = gA, iA = AA);
  const QA = {
    enter: IA = {
      opacity: zero$1,
      x: zero$1,
      y: zero$1,
      width: encoder(eA),
      height: encoder(iA)
    },
    update: extend$2({}, IA, {
      opacity: one,
      fill: {
        gradient: t,
        start: CA,
        stop: BA
      }
    }),
    exit: {
      opacity: zero$1
    }
  };
  return addEncoders(QA, {
    stroke: k("gradientStrokeColor"),
    strokeWidth: k("gradientStrokeWidth")
  }, {
    // update
    opacity: k("gradientOpacity")
  }), guideMark({
    type: RectMark,
    role: LegendGradientRole,
    encode: QA
  }, d);
}
function legendGradientDiscrete(n, t, g, d, k) {
  const H = lookup(n, g), AA = H.isVertical(), gA = H.gradientThickness(), IA = H.gradientLength();
  let CA, BA, eA, iA, QA = "";
  AA ? (CA = "y", eA = "y2", BA = "x", iA = "width", QA = "1-") : (CA = "x", eA = "x2", BA = "y", iA = "height");
  const tA = {
    opacity: zero$1,
    fill: {
      scale: t,
      field: Value$1
    }
  };
  tA[CA] = {
    signal: QA + "datum." + Perc,
    mult: IA
  }, tA[BA] = zero$1, tA[eA] = {
    signal: QA + "datum." + Perc2,
    mult: IA
  }, tA[iA] = encoder(gA);
  const oA = {
    enter: tA,
    update: extend$2({}, tA, {
      opacity: one
    }),
    exit: {
      opacity: zero$1
    }
  };
  return addEncoders(oA, {
    stroke: H("gradientStrokeColor"),
    strokeWidth: H("gradientStrokeWidth")
  }, {
    // update
    opacity: H("gradientOpacity")
  }), guideMark({
    type: RectMark,
    role: LegendBandRole,
    key: Value$1,
    from: k,
    encode: oA
  }, d);
}
const alignExpr = `datum.${Perc}<=0?"${Left}":datum.${Perc}>=1?"${Right}":"${Center}"`, baselineExpr = `datum.${Perc}<=0?"${Bottom}":datum.${Perc}>=1?"${Top}":"${Middle}"`;
function legendGradientLabels(n, t, g, d) {
  const k = lookup(n, t), H = k.isVertical(), AA = encoder(k.gradientThickness()), gA = k.gradientLength();
  let IA = k("labelOverlap"), CA, BA, eA, iA, QA = "";
  const tA = {
    enter: CA = {
      opacity: zero$1
    },
    update: BA = {
      opacity: one,
      text: {
        field: Label
      }
    },
    exit: {
      opacity: zero$1
    }
  };
  return addEncoders(tA, {
    fill: k("labelColor"),
    fillOpacity: k("labelOpacity"),
    font: k("labelFont"),
    fontSize: k("labelFontSize"),
    fontStyle: k("labelFontStyle"),
    fontWeight: k("labelFontWeight"),
    limit: value(n.labelLimit, t.gradientLabelLimit)
  }), H ? (CA.align = {
    value: "left"
  }, CA.baseline = BA.baseline = {
    signal: baselineExpr
  }, eA = "y", iA = "x", QA = "1-") : (CA.align = BA.align = {
    signal: alignExpr
  }, CA.baseline = {
    value: "top"
  }, eA = "x", iA = "y"), CA[eA] = BA[eA] = {
    signal: QA + "datum." + Perc,
    mult: gA
  }, CA[iA] = BA[iA] = AA, AA.offset = value(n.labelOffset, t.gradientLabelOffset) || 0, IA = IA ? {
    separation: k("labelSeparation"),
    method: IA,
    order: "datum." + Index
  } : void 0, guideMark({
    type: TextMark,
    role: LegendLabelRole,
    style: GuideLabelStyle,
    key: Value$1,
    from: d,
    encode: tA,
    overlap: IA
  }, g);
}
function legendSymbolGroups(n, t, g, d, k) {
  const H = lookup(n, t), AA = g.entries, gA = !!(AA && AA.interactive), IA = AA ? AA.name : void 0, CA = H("clipHeight"), BA = H("symbolOffset"), eA = {
    data: "value"
  }, iA = `(${k}) ? datum.${Offset} : datum.${Size}`, QA = CA ? encoder(CA) : {
    field: Size
  }, tA = `datum.${Index}`, oA = `max(1, ${k})`;
  let EA, aA, nA, lA, cA;
  QA.mult = 0.5, EA = {
    enter: aA = {
      opacity: zero$1,
      x: {
        signal: iA,
        mult: 0.5,
        offset: BA
      },
      y: QA
    },
    update: nA = {
      opacity: one,
      x: aA.x,
      y: aA.y
    },
    exit: {
      opacity: zero$1
    }
  };
  let sA = null, rA = null;
  n.fill || (sA = t.symbolBaseFillColor, rA = t.symbolBaseStrokeColor), addEncoders(EA, {
    fill: H("symbolFillColor", sA),
    shape: H("symbolType"),
    size: H("symbolSize"),
    stroke: H("symbolStrokeColor", rA),
    strokeDash: H("symbolDash"),
    strokeDashOffset: H("symbolDashOffset"),
    strokeWidth: H("symbolStrokeWidth")
  }, {
    // update
    opacity: H("symbolOpacity")
  }), LegendScales.forEach((GA) => {
    n[GA] && (nA[GA] = aA[GA] = {
      scale: n[GA],
      field: Value$1
    });
  });
  const uA = guideMark({
    type: SymbolMark,
    role: LegendSymbolRole,
    key: Value$1,
    from: eA,
    clip: CA ? !0 : void 0,
    encode: EA
  }, g.symbols), hA = encoder(BA);
  hA.offset = H("labelOffset"), EA = {
    enter: aA = {
      opacity: zero$1,
      x: {
        signal: iA,
        offset: hA
      },
      y: QA
    },
    update: nA = {
      opacity: one,
      text: {
        field: Label
      },
      x: aA.x,
      y: aA.y
    },
    exit: {
      opacity: zero$1
    }
  }, addEncoders(EA, {
    align: H("labelAlign"),
    baseline: H("labelBaseline"),
    fill: H("labelColor"),
    fillOpacity: H("labelOpacity"),
    font: H("labelFont"),
    fontSize: H("labelFontSize"),
    fontStyle: H("labelFontStyle"),
    fontWeight: H("labelFontWeight"),
    limit: H("labelLimit")
  });
  const dA = guideMark({
    type: TextMark,
    role: LegendLabelRole,
    style: GuideLabelStyle,
    key: Value$1,
    from: eA,
    encode: EA
  }, g.labels);
  return EA = {
    enter: {
      noBound: {
        value: !CA
      },
      // ignore width/height in bounds calc
      width: zero$1,
      height: CA ? encoder(CA) : zero$1,
      opacity: zero$1
    },
    exit: {
      opacity: zero$1
    },
    update: nA = {
      opacity: one,
      row: {
        signal: null
      },
      column: {
        signal: null
      }
    }
  }, H.isVertical(!0) ? (lA = `ceil(item.mark.items.length / ${oA})`, nA.row.signal = `${tA}%${lA}`, nA.column.signal = `floor(${tA} / ${lA})`, cA = {
    field: ["row", tA]
  }) : (nA.row.signal = `floor(${tA} / ${oA})`, nA.column.signal = `${tA} % ${oA}`, cA = {
    field: tA
  }), nA.column.signal = `(${k})?${nA.column.signal}:${tA}`, d = {
    facet: {
      data: d,
      name: "value",
      groupby: Index
    }
  }, guideGroup({
    role: ScopeRole,
    from: d,
    encode: extendEncode(EA, AA, Skip),
    marks: [uA, dA],
    name: IA,
    interactive: gA,
    sort: cA
  });
}
function legendSymbolLayout(n, t) {
  const g = lookup(n, t);
  return {
    align: g("gridAlign"),
    columns: g.entryColumns(),
    center: {
      row: !0,
      column: !1
    },
    padding: {
      row: g("rowPadding"),
      column: g("columnPadding")
    }
  };
}
const isL = 'item.orient === "left"', isR = 'item.orient === "right"', isLR = `(${isL} || ${isR})`, isVG = `datum.vgrad && ${isLR}`, baseline$1 = anchorExpr('"top"', '"bottom"', '"middle"'), alignFlip = anchorExpr('"right"', '"left"', '"center"'), exprAlign = `datum.vgrad && ${isR} ? (${alignFlip}) : (${isLR} && !(datum.vgrad && ${isL})) ? "left" : ${alignExpr$1}`, exprAnchor = `item._anchor || (${isLR} ? "middle" : "start")`, exprAngle = `${isVG} ? (${isL} ? -90 : 90) : 0`, exprBaseline = `${isLR} ? (datum.vgrad ? (${isR} ? "bottom" : "top") : ${baseline$1}) : "top"`;
function legendTitle(n, t, g, d) {
  const k = lookup(n, t), H = {
    enter: {
      opacity: zero$1
    },
    update: {
      opacity: one,
      x: {
        field: {
          group: "padding"
        }
      },
      y: {
        field: {
          group: "padding"
        }
      }
    },
    exit: {
      opacity: zero$1
    }
  };
  return addEncoders(H, {
    orient: k("titleOrient"),
    _anchor: k("titleAnchor"),
    anchor: {
      signal: exprAnchor
    },
    angle: {
      signal: exprAngle
    },
    align: {
      signal: exprAlign
    },
    baseline: {
      signal: exprBaseline
    },
    text: n.title,
    fill: k("titleColor"),
    fillOpacity: k("titleOpacity"),
    font: k("titleFont"),
    fontSize: k("titleFontSize"),
    fontStyle: k("titleFontStyle"),
    fontWeight: k("titleFontWeight"),
    limit: k("titleLimit"),
    lineHeight: k("titleLineHeight")
  }, {
    // require update
    align: k("titleAlign"),
    baseline: k("titleBaseline")
  }), guideMark({
    type: TextMark,
    role: LegendTitleRole,
    style: GuideTitleStyle,
    from: d,
    encode: H
  }, g);
}
function clip(n, t) {
  let g;
  return isObject$4(n) && (n.signal ? g = n.signal : n.path ? g = "pathShape(" + param(n.path) + ")" : n.sphere && (g = "geoShape(" + param(n.sphere) + ', {type: "Sphere"})')), g ? t.signalRef(g) : !!n;
}
function param(n) {
  return isObject$4(n) && n.signal ? n.signal : $$2(n);
}
function getRole(n) {
  const t = n.role || "";
  return t.startsWith("axis") || t.startsWith("legend") || t.startsWith("title") ? t : n.type === GroupMark ? ScopeRole : t || MarkRole;
}
function definition(n) {
  return {
    marktype: n.type,
    name: n.name || void 0,
    role: n.role || getRole(n),
    zindex: +n.zindex || void 0,
    aria: n.aria,
    description: n.description
  };
}
function interactive(n, t) {
  return n && n.signal ? t.signalRef(n.signal) : n !== !1;
}
function parseTransform(n, t) {
  const g = definition$1(n.type);
  g || error$3("Unrecognized transform type: " + $$2(n.type));
  const d = entry(g.type.toLowerCase(), null, parseParameters(g, n, t));
  return n.signal && t.addSignal(n.signal, t.proxy(d)), d.metadata = g.metadata || {}, d;
}
function parseParameters(n, t, g) {
  const d = {}, k = n.params.length;
  for (let H = 0; H < k; ++H) {
    const AA = n.params[H];
    d[AA.name] = parseParameter(AA, t, g);
  }
  return d;
}
function parseParameter(n, t, g) {
  const d = n.type, k = t[n.name];
  if (d === "index")
    return parseIndexParameter(n, t, g);
  if (k === void 0) {
    n.required && error$3("Missing required " + $$2(t.type) + " parameter: " + $$2(n.name));
    return;
  } else {
    if (d === "param")
      return parseSubParameters(n, t, g);
    if (d === "projection")
      return g.projectionRef(t[n.name]);
  }
  return n.array && !isSignal(k) ? k.map((H) => parameterValue(n, H, g)) : parameterValue(n, k, g);
}
function parameterValue(n, t, g) {
  const d = n.type;
  if (isSignal(t))
    return isExpr(d) ? error$3("Expression references can not be signals.") : isField(d) ? g.fieldRef(t) : isCompare(d) ? g.compareRef(t) : g.signalRef(t.signal);
  {
    const k = n.expr || isField(d);
    return k && outerExpr(t) ? g.exprRef(t.expr, t.as) : k && outerField(t) ? fieldRef$1(t.field, t.as) : isExpr(d) ? parser$2(t, g) : isData(d) ? ref(g.getData(t).values) : isField(d) ? fieldRef$1(t) : isCompare(d) ? g.compareRef(t) : t;
  }
}
function parseIndexParameter(n, t, g) {
  return isString$2(t.from) || error$3('Lookup "from" parameter must be a string literal.'), g.getData(t.from).lookupRef(g, t.key);
}
function parseSubParameters(n, t, g) {
  const d = t[n.name];
  return n.array ? (isArray$3(d) || error$3("Expected an array of sub-parameters. Instead: " + $$2(d)), d.map((k) => parseSubParameter(n, k, g))) : parseSubParameter(n, d, g);
}
function parseSubParameter(n, t, g) {
  const d = n.params.length;
  let k;
  for (let AA = 0; AA < d; ++AA) {
    k = n.params[AA];
    for (const gA in k.key)
      if (k.key[gA] !== t[gA]) {
        k = null;
        break;
      }
    if (k) break;
  }
  k || error$3("Unsupported parameter: " + $$2(t));
  const H = extend$2(parseParameters(k, t, g), k.key);
  return ref(g.add(Params(H)));
}
const outerExpr = (n) => n && n.expr, outerField = (n) => n && n.field, isData = (n) => n === "data", isExpr = (n) => n === "expr", isField = (n) => n === "field", isCompare = (n) => n === "compare";
function parseData$1(n, t, g) {
  let d, k, H, AA, gA;
  return n ? (d = n.facet) && (t || error$3("Only group marks can be faceted."), d.field != null ? AA = gA = getDataRef(d, g) : (n.data ? gA = ref(g.getData(n.data).aggregate) : (H = parseTransform(extend$2({
    type: "aggregate",
    groupby: array$6(d.groupby)
  }, d.aggregate), g), H.params.key = g.keyRef(d.groupby), H.params.pulse = getDataRef(d, g), AA = gA = ref(g.add(H))), k = g.keyRef(d.groupby, !0))) : AA = ref(g.add(Collect(null, [{}]))), AA || (AA = getDataRef(n, g)), {
    key: k,
    pulse: AA,
    parent: gA
  };
}
function getDataRef(n, t) {
  return n.$ref ? n : n.data && n.data.$ref ? n.data : ref(t.getData(n.data).output);
}
function DataScope(n, t, g, d, k) {
  this.scope = n, this.input = t, this.output = g, this.values = d, this.aggregate = k, this.index = {};
}
DataScope.fromEntries = function(n, t) {
  const g = t.length, d = t[g - 1], k = t[g - 2];
  let H = t[0], AA = null, gA = 1;
  for (H && H.type === "load" && (H = t[1]), n.add(t[0]); gA < g; ++gA)
    t[gA].params.pulse = ref(t[gA - 1]), n.add(t[gA]), t[gA].type === "aggregate" && (AA = t[gA]);
  return new DataScope(n, H, k, d, AA);
};
function fieldKey(n) {
  return isString$2(n) ? n : null;
}
function addSortField(n, t, g) {
  const d = aggrField(g.op, g.field);
  let k;
  if (t.ops) {
    for (let H = 0, AA = t.as.length; H < AA; ++H)
      if (t.as[H] === d) return;
  } else
    t.ops = ["count"], t.fields = [null], t.as = ["count"];
  g.op && (t.ops.push((k = g.op.signal) ? n.signalRef(k) : g.op), t.fields.push(n.fieldRef(g.field)), t.as.push(d));
}
function cache$3(n, t, g, d, k, H, AA) {
  const gA = t[g] || (t[g] = {}), IA = sortKey(H);
  let CA = fieldKey(k), BA, eA;
  if (CA != null && (n = t.scope, CA = CA + (IA ? "|" + IA : ""), BA = gA[CA]), !BA) {
    const iA = H ? {
      field: keyFieldRef,
      pulse: t.countsRef(n, k, H)
    } : {
      field: n.fieldRef(k),
      pulse: ref(t.output)
    };
    IA && (iA.sort = n.sortRef(H)), eA = n.add(entry(d, void 0, iA)), AA && (t.index[k] = eA), BA = ref(eA), CA != null && (gA[CA] = BA);
  }
  return BA;
}
DataScope.prototype = {
  countsRef(n, t, g) {
    const d = this, k = d.counts || (d.counts = {}), H = fieldKey(t);
    let AA, gA, IA;
    return H != null && (n = d.scope, AA = k[H]), AA ? g && g.field && addSortField(n, AA.agg.params, g) : (IA = {
      groupby: n.fieldRef(t, "key"),
      pulse: ref(d.output)
    }, g && g.field && addSortField(n, IA, g), gA = n.add(Aggregate(IA)), AA = n.add(Collect({
      pulse: ref(gA)
    })), AA = {
      agg: gA,
      ref: ref(AA)
    }, H != null && (k[H] = AA)), AA.ref;
  },
  tuplesRef() {
    return ref(this.values);
  },
  extentRef(n, t) {
    return cache$3(n, this, "extent", "extent", t, !1);
  },
  domainRef(n, t) {
    return cache$3(n, this, "domain", "values", t, !1);
  },
  valuesRef(n, t, g) {
    return cache$3(n, this, "vals", "values", t, g || !0);
  },
  lookupRef(n, t) {
    return cache$3(n, this, "lookup", "tupleindex", t, !1);
  },
  indataRef(n, t) {
    return cache$3(n, this, "indata", "tupleindex", t, !0, !0);
  }
};
function parseFacet(n, t, g) {
  const d = n.from.facet, k = d.name, H = getDataRef(d, t);
  let AA;
  d.name || error$3("Facet must have a name: " + $$2(d)), d.data || error$3("Facet must reference a data set: " + $$2(d)), d.field ? AA = t.add(PreFacet({
    field: t.fieldRef(d.field),
    pulse: H
  })) : d.groupby ? AA = t.add(Facet({
    key: t.keyRef(d.groupby),
    group: ref(t.proxy(g.parent)),
    pulse: H
  })) : error$3("Facet must specify groupby or field: " + $$2(d));
  const gA = t.fork(), IA = gA.add(Collect()), CA = gA.add(Sieve({
    pulse: ref(IA)
  }));
  gA.addData(k, new DataScope(gA, IA, IA, CA)), gA.addSignal("parent", null), AA.params.subflow = {
    $subflow: gA.parse(n).toRuntime()
  };
}
function parseSubflow(n, t, g) {
  const d = t.add(PreFacet({
    pulse: g.pulse
  })), k = t.fork();
  k.add(Sieve()), k.addSignal("parent", null), d.params.subflow = {
    $subflow: k.parse(n).toRuntime()
  };
}
function parseTrigger(n, t, g) {
  const d = n.remove, k = n.insert, H = n.toggle, AA = n.modify, gA = n.values, IA = t.add(operator()), CA = "if(" + n.trigger + ',modify("' + g + '",' + [k, d, H, AA, gA].map((eA) => eA ?? "null").join(",") + "),0)", BA = parser$2(CA, t);
  IA.update = BA.$expr, IA.params = BA.$params;
}
function parseMark(n, t) {
  const g = getRole(n), d = n.type === GroupMark, k = n.from && n.from.facet, H = n.overlap;
  let AA = n.layout || g === ScopeRole || g === FrameRole, gA, IA, CA, BA, eA, iA, QA;
  const tA = g === MarkRole || AA || k, oA = parseData$1(n.from, d, t);
  IA = t.add(DataJoin({
    key: oA.key || (n.key ? fieldRef$1(n.key) : void 0),
    pulse: oA.pulse,
    clean: !d
  }));
  const EA = ref(IA);
  IA = CA = t.add(Collect({
    pulse: EA
  })), IA = t.add(Mark$1({
    markdef: definition(n),
    interactive: interactive(n.interactive, t),
    clip: clip(n.clip, t),
    context: {
      $context: !0
    },
    groups: t.lookup(),
    parent: t.signals.parent ? t.signalRef("parent") : null,
    index: t.markpath(),
    pulse: ref(IA)
  }));
  const aA = ref(IA);
  IA = BA = t.add(Encode(parseEncode(n.encode, n.type, g, n.style, t, {
    mod: !1,
    pulse: aA
  }))), IA.params.parent = t.encode(), n.transform && n.transform.forEach((rA) => {
    const uA = parseTransform(rA, t), hA = uA.metadata;
    (hA.generates || hA.changes) && error$3("Mark transforms should not generate new data."), hA.nomod || (BA.params.mod = !0), uA.params.pulse = ref(IA), t.add(IA = uA);
  }), n.sort && (IA = t.add(SortItems({
    sort: t.compareRef(n.sort),
    pulse: ref(IA)
  })));
  const nA = ref(IA);
  (k || AA) && (AA = t.add(ViewLayout({
    layout: t.objectProperty(n.layout),
    legends: t.legends,
    mark: aA,
    pulse: nA
  })), iA = ref(AA));
  const lA = t.add(Bound({
    mark: aA,
    pulse: iA || nA
  }));
  QA = ref(lA), d && (tA && (gA = t.operators, gA.pop(), AA && gA.pop()), t.pushState(nA, iA || QA, EA), k ? parseFacet(n, t, oA) : tA ? parseSubflow(n, t, oA) : t.parse(n), t.popState(), tA && (AA && gA.push(AA), gA.push(lA))), H && (QA = parseOverlap(H, QA, t));
  const cA = t.add(Render({
    pulse: QA
  })), sA = t.add(Sieve({
    pulse: ref(cA)
  }, void 0, t.parent()));
  n.name != null && (eA = n.name, t.addData(eA, new DataScope(t, CA, cA, sA)), n.on && n.on.forEach((rA) => {
    (rA.insert || rA.remove || rA.toggle) && error$3("Marks only support modify triggers."), parseTrigger(rA, t, eA);
  }));
}
function parseOverlap(n, t, g) {
  const d = n.method, k = n.bound, H = n.separation, AA = {
    separation: isSignal(H) ? g.signalRef(H.signal) : H,
    method: isSignal(d) ? g.signalRef(d.signal) : d,
    pulse: t
  };
  if (n.order && (AA.sort = g.compareRef({
    field: n.order
  })), k) {
    const gA = k.tolerance;
    AA.boundTolerance = isSignal(gA) ? g.signalRef(gA.signal) : +gA, AA.boundScale = g.scaleRef(k.scale), AA.boundOrient = k.orient;
  }
  return ref(g.add(Overlap(AA)));
}
function parseLegend$1(n, t) {
  const g = t.config.legend, d = n.encode || {}, k = lookup(n, g), H = d.legend || {}, AA = H.name || void 0, gA = H.interactive, IA = H.style, CA = {};
  let BA = 0, eA, iA, QA;
  LegendScales.forEach((lA) => n[lA] ? (CA[lA] = n[lA], BA = BA || n[lA]) : 0), BA || error$3("Missing valid scale for legend.");
  const tA = legendType(n, t.scaleType(BA)), oA = {
    title: n.title != null,
    scales: CA,
    type: tA,
    vgrad: tA !== "symbol" && k.isVertical()
  }, EA = ref(t.add(Collect(null, [oA]))), aA = {
    enter: {
      x: {
        value: 0
      },
      y: {
        value: 0
      }
    }
  }, nA = ref(t.add(LegendEntries(iA = {
    type: tA,
    scale: t.scaleRef(BA),
    count: t.objectProperty(k("tickCount")),
    limit: t.property(k("symbolLimit")),
    values: t.objectProperty(n.values),
    minstep: t.property(n.tickMinStep),
    formatType: t.property(n.formatType),
    formatSpecifier: t.property(n.format)
  })));
  return tA === Gradient ? (QA = [legendGradient(n, BA, g, d.gradient), legendGradientLabels(n, g, d.labels, nA)], iA.count = iA.count || t.signalRef(`max(2,2*floor((${deref(k.gradientLength())})/100))`)) : tA === Discrete ? QA = [legendGradientDiscrete(n, BA, g, d.gradient, nA), legendGradientLabels(n, g, d.labels, nA)] : (eA = legendSymbolLayout(n, g), QA = [legendSymbolGroups(n, g, d, nA, deref(eA.columns))], iA.size = sizeExpression(n, t, QA[0].marks)), QA = [guideGroup({
    role: LegendEntryRole,
    from: EA,
    encode: aA,
    marks: QA,
    layout: eA,
    interactive: gA
  })], oA.title && QA.push(legendTitle(n, g, d.title, EA)), parseMark(guideGroup({
    role: LegendRole,
    from: EA,
    encode: extendEncode(buildLegendEncode(k, n, g), H, Skip),
    marks: QA,
    aria: k("aria"),
    description: k("description"),
    zindex: k("zindex"),
    name: AA,
    interactive: gA,
    style: IA
  }), t);
}
function legendType(n, t) {
  let g = n.type || Symbols;
  return !n.type && scaleCount(n) === 1 && (n.fill || n.stroke) && (g = isContinuous$1(t) ? Gradient : isDiscretizing$1(t) ? Discrete : Symbols), g !== Gradient ? g : isDiscretizing$1(t) ? Discrete : Gradient;
}
function scaleCount(n) {
  return LegendScales.reduce((t, g) => t + (n[g] ? 1 : 0), 0);
}
function buildLegendEncode(n, t, g) {
  const d = {
    enter: {},
    update: {}
  };
  return addEncoders(d, {
    orient: n("orient"),
    offset: n("offset"),
    padding: n("padding"),
    titlePadding: n("titlePadding"),
    cornerRadius: n("cornerRadius"),
    fill: n("fillColor"),
    stroke: n("strokeColor"),
    strokeWidth: g.strokeWidth,
    strokeDash: g.strokeDash,
    x: n("legendX"),
    y: n("legendY"),
    // accessibility support
    format: t.format,
    formatType: t.formatType
  }), d;
}
function sizeExpression(n, t, g) {
  const d = deref(getChannel("size", n, g)), k = deref(getChannel("strokeWidth", n, g)), H = deref(getFontSize(g[1].encode, t, GuideLabelStyle));
  return parser$2(`max(ceil(sqrt(${d})+${k}),${H})`, t);
}
function getChannel(n, t, g) {
  return t[n] ? `scale("${t[n]}",datum)` : getEncoding(n, g[0].encode);
}
function getFontSize(n, t, g) {
  return getEncoding("fontSize", n) || getStyle("fontSize", t, g);
}
const angleExpr = `item.orient==="${Left}"?-90:item.orient==="${Right}"?90:0`;
function parseTitle(n, t) {
  n = isString$2(n) ? {
    text: n
  } : n;
  const g = lookup(n, t.config.title), d = n.encode || {}, k = d.group || {}, H = k.name || void 0, AA = k.interactive, gA = k.style, IA = [], CA = {}, BA = ref(t.add(Collect(null, [CA])));
  return IA.push(buildTitle(n, g, titleEncode(n), BA)), n.subtitle && IA.push(buildSubTitle(n, g, d.subtitle, BA)), parseMark(guideGroup({
    role: TitleRole,
    from: BA,
    encode: groupEncode(g, k),
    marks: IA,
    aria: g("aria"),
    description: g("description"),
    zindex: g("zindex"),
    name: H,
    interactive: AA,
    style: gA
  }), t);
}
function titleEncode(n) {
  const t = n.encode;
  return t && t.title || extend$2({
    name: n.name,
    interactive: n.interactive,
    style: n.style
  }, t);
}
function groupEncode(n, t) {
  const g = {
    enter: {},
    update: {}
  };
  return addEncoders(g, {
    orient: n("orient"),
    anchor: n("anchor"),
    align: {
      signal: alignExpr$1
    },
    angle: {
      signal: angleExpr
    },
    limit: n("limit"),
    frame: n("frame"),
    offset: n("offset") || 0,
    padding: n("subtitlePadding")
  }), extendEncode(g, t, Skip);
}
function buildTitle(n, t, g, d) {
  const k = {
    value: 0
  }, H = n.text, AA = {
    enter: {
      opacity: k
    },
    update: {
      opacity: {
        value: 1
      }
    },
    exit: {
      opacity: k
    }
  };
  return addEncoders(AA, {
    text: H,
    align: {
      signal: "item.mark.group.align"
    },
    angle: {
      signal: "item.mark.group.angle"
    },
    limit: {
      signal: "item.mark.group.limit"
    },
    baseline: "top",
    dx: t("dx"),
    dy: t("dy"),
    fill: t("color"),
    font: t("font"),
    fontSize: t("fontSize"),
    fontStyle: t("fontStyle"),
    fontWeight: t("fontWeight"),
    lineHeight: t("lineHeight")
  }, {
    // update
    align: t("align"),
    angle: t("angle"),
    baseline: t("baseline")
  }), guideMark({
    type: TextMark,
    role: TitleTextRole,
    style: GroupTitleStyle,
    from: d,
    encode: AA
  }, g);
}
function buildSubTitle(n, t, g, d) {
  const k = {
    value: 0
  }, H = n.subtitle, AA = {
    enter: {
      opacity: k
    },
    update: {
      opacity: {
        value: 1
      }
    },
    exit: {
      opacity: k
    }
  };
  return addEncoders(AA, {
    text: H,
    align: {
      signal: "item.mark.group.align"
    },
    angle: {
      signal: "item.mark.group.angle"
    },
    limit: {
      signal: "item.mark.group.limit"
    },
    baseline: "top",
    dx: t("dx"),
    dy: t("dy"),
    fill: t("subtitleColor"),
    font: t("subtitleFont"),
    fontSize: t("subtitleFontSize"),
    fontStyle: t("subtitleFontStyle"),
    fontWeight: t("subtitleFontWeight"),
    lineHeight: t("subtitleLineHeight")
  }, {
    // update
    align: t("align"),
    angle: t("angle"),
    baseline: t("baseline")
  }), guideMark({
    type: TextMark,
    role: TitleSubtitleRole,
    style: GroupSubtitleStyle,
    from: d,
    encode: AA
  }, g);
}
function parseData$2(n, t) {
  const g = [];
  n.transform && n.transform.forEach((d) => {
    g.push(parseTransform(d, t));
  }), n.on && n.on.forEach((d) => {
    parseTrigger(d, t, n.name);
  }), t.addDataPipeline(n.name, analyze(n, t, g));
}
function analyze(n, t, g) {
  const d = [];
  let k = null, H = !1, AA = !1, gA, IA, CA, BA, eA;
  for (n.values ? isSignal(n.values) || hasSignal(n.format) ? (d.push(load(t, n)), d.push(k = collect())) : d.push(k = collect({
    $ingest: n.values,
    $format: n.format
  })) : n.url ? hasSignal(n.url) || hasSignal(n.format) ? (d.push(load(t, n)), d.push(k = collect())) : d.push(k = collect({
    $request: n.url,
    $format: n.format
  })) : n.source && (k = gA = array$6(n.source).map((iA) => ref(t.getData(iA).output)), d.push(null)), IA = 0, CA = g.length; IA < CA; ++IA)
    BA = g[IA], eA = BA.metadata, !k && !eA.source && d.push(k = collect()), d.push(BA), eA.generates && (AA = !0), eA.modifies && !AA && (H = !0), eA.source ? k = BA : eA.changes && (k = null);
  return gA && (CA = gA.length - 1, d[0] = Relay({
    derive: H,
    pulse: CA ? gA : gA[0]
  }), (H || CA) && d.splice(1, 0, collect())), k || d.push(collect()), d.push(Sieve({})), d;
}
function collect(n) {
  const t = Collect({}, n);
  return t.metadata = {
    source: !0
  }, t;
}
function load(n, t) {
  return Load({
    url: t.url ? n.property(t.url) : void 0,
    async: t.async ? n.property(t.async) : void 0,
    values: t.values ? n.property(t.values) : void 0,
    format: n.objectProperty(t.format)
  });
}
const isX = (n) => n === Bottom || n === Top, getSign = (n, t, g) => isSignal(n) ? ifLeftTopExpr(n.signal, t, g) : n === Left || n === Top ? t : g, ifX = (n, t, g) => isSignal(n) ? ifXEnc(n.signal, t, g) : isX(n) ? t : g, ifY = (n, t, g) => isSignal(n) ? ifYEnc(n.signal, t, g) : isX(n) ? g : t, ifTop = (n, t, g) => isSignal(n) ? ifTopExpr(n.signal, t, g) : n === Top ? {
  value: t
} : {
  value: g
}, ifRight = (n, t, g) => isSignal(n) ? ifRightExpr(n.signal, t, g) : n === Right ? {
  value: t
} : {
  value: g
}, ifXEnc = (n, t, g) => ifEnc(`${n} === '${Top}' || ${n} === '${Bottom}'`, t, g), ifYEnc = (n, t, g) => ifEnc(`${n} !== '${Top}' && ${n} !== '${Bottom}'`, t, g), ifLeftTopExpr = (n, t, g) => ifExpr(`${n} === '${Left}' || ${n} === '${Top}'`, t, g), ifTopExpr = (n, t, g) => ifExpr(`${n} === '${Top}'`, t, g), ifRightExpr = (n, t, g) => ifExpr(`${n} === '${Right}'`, t, g), ifEnc = (n, t, g) => (t = t != null ? encoder(t) : t, g = g != null ? encoder(g) : g, isSimple(t) && isSimple(g) ? (t = t ? t.signal || $$2(t.value) : null, g = g ? g.signal || $$2(g.value) : null, {
  signal: `${n} ? (${t}) : (${g})`
}) : [extend$2({
  test: n
}, t)].concat(g || [])), isSimple = (n) => n == null || Object.keys(n).length === 1, ifExpr = (n, t, g) => ({
  signal: `${n} ? (${toExpr(t)}) : (${toExpr(g)})`
}), ifOrient = (n, t, g, d, k) => ({
  signal: (d != null ? `${n} === '${Left}' ? (${toExpr(d)}) : ` : "") + (g != null ? `${n} === '${Bottom}' ? (${toExpr(g)}) : ` : "") + (k != null ? `${n} === '${Right}' ? (${toExpr(k)}) : ` : "") + (t != null ? `${n} === '${Top}' ? (${toExpr(t)}) : ` : "") + "(null)"
}), toExpr = (n) => isSignal(n) ? n.signal : n == null ? null : $$2(n), mult = (n, t) => t === 0 ? 0 : isSignal(n) ? {
  signal: `(${n.signal}) * ${t}`
} : {
  value: n * t
}, patch = (n, t) => {
  const g = n.signal;
  return g && g.endsWith("(null)") ? {
    signal: g.slice(0, -6) + t.signal
  } : n;
};
function fallback(n, t, g, d) {
  let k;
  if (t && has$2(t, n))
    return t[n];
  if (has$2(g, n))
    return g[n];
  if (n.startsWith("title")) {
    switch (n) {
      case "titleColor":
        k = "fill";
        break;
      case "titleFont":
      case "titleFontSize":
      case "titleFontWeight":
        k = n[5].toLowerCase() + n.slice(6);
    }
    return d[GuideTitleStyle][k];
  } else if (n.startsWith("label")) {
    switch (n) {
      case "labelColor":
        k = "fill";
        break;
      case "labelFont":
      case "labelFontSize":
        k = n[5].toLowerCase() + n.slice(6);
    }
    return d[GuideLabelStyle][k];
  }
  return null;
}
function keys$2(n) {
  const t = {};
  for (const g of n)
    if (g)
      for (const d in g) t[d] = 1;
  return Object.keys(t);
}
function axisConfig(n, t) {
  var g = t.config, d = g.style, k = g.axis, H = t.scaleType(n.scale) === "band" && g.axisBand, AA = n.orient, gA, IA, CA;
  if (isSignal(AA)) {
    const eA = keys$2([g.axisX, g.axisY]), iA = keys$2([g.axisTop, g.axisBottom, g.axisLeft, g.axisRight]);
    gA = {};
    for (CA of eA)
      gA[CA] = ifX(AA, fallback(CA, g.axisX, k, d), fallback(CA, g.axisY, k, d));
    IA = {};
    for (CA of iA)
      IA[CA] = ifOrient(AA.signal, fallback(CA, g.axisTop, k, d), fallback(CA, g.axisBottom, k, d), fallback(CA, g.axisLeft, k, d), fallback(CA, g.axisRight, k, d));
  } else
    gA = AA === Top || AA === Bottom ? g.axisX : g.axisY, IA = g["axis" + AA[0].toUpperCase() + AA.slice(1)];
  return gA || IA || H ? extend$2({}, k, gA, IA, H) : k;
}
function axisDomain(n, t, g, d) {
  const k = lookup(n, t), H = n.orient;
  let AA, gA;
  const IA = {
    enter: AA = {
      opacity: zero$1
    },
    update: gA = {
      opacity: one
    },
    exit: {
      opacity: zero$1
    }
  };
  addEncoders(IA, {
    stroke: k("domainColor"),
    strokeCap: k("domainCap"),
    strokeDash: k("domainDash"),
    strokeDashOffset: k("domainDashOffset"),
    strokeWidth: k("domainWidth"),
    strokeOpacity: k("domainOpacity")
  });
  const CA = position$1(n, 0), BA = position$1(n, 1);
  return AA.x = gA.x = ifX(H, CA, zero$1), AA.x2 = gA.x2 = ifX(H, BA), AA.y = gA.y = ifY(H, CA, zero$1), AA.y2 = gA.y2 = ifY(H, BA), guideMark({
    type: RuleMark,
    role: AxisDomainRole,
    from: d,
    encode: IA
  }, g);
}
function position$1(n, t) {
  return {
    scale: n.scale,
    range: t
  };
}
function axisGrid(n, t, g, d, k) {
  const H = lookup(n, t), AA = n.orient, gA = n.gridScale, IA = getSign(AA, 1, -1), CA = offsetValue(n.offset, IA);
  let BA, eA, iA;
  const QA = {
    enter: BA = {
      opacity: zero$1
    },
    update: iA = {
      opacity: one
    },
    exit: eA = {
      opacity: zero$1
    }
  };
  addEncoders(QA, {
    stroke: H("gridColor"),
    strokeCap: H("gridCap"),
    strokeDash: H("gridDash"),
    strokeDashOffset: H("gridDashOffset"),
    strokeOpacity: H("gridOpacity"),
    strokeWidth: H("gridWidth")
  });
  const tA = {
    scale: n.scale,
    field: Value$1,
    band: k.band,
    extra: k.extra,
    offset: k.offset,
    round: H("tickRound")
  }, oA = ifX(AA, {
    signal: "height"
  }, {
    signal: "width"
  }), EA = gA ? {
    scale: gA,
    range: 0,
    mult: IA,
    offset: CA
  } : {
    value: 0,
    offset: CA
  }, aA = gA ? {
    scale: gA,
    range: 1,
    mult: IA,
    offset: CA
  } : extend$2(oA, {
    mult: IA,
    offset: CA
  });
  return BA.x = iA.x = ifX(AA, tA, EA), BA.y = iA.y = ifY(AA, tA, EA), BA.x2 = iA.x2 = ifY(AA, aA), BA.y2 = iA.y2 = ifX(AA, aA), eA.x = ifX(AA, tA), eA.y = ifY(AA, tA), guideMark({
    type: RuleMark,
    role: AxisGridRole,
    key: Value$1,
    from: d,
    encode: QA
  }, g);
}
function offsetValue(n, t) {
  if (t !== 1) if (!isObject$4(n))
    n = isSignal(t) ? {
      signal: `(${t.signal}) * (${n || 0})`
    } : t * (n || 0);
  else {
    let g = n = extend$2({}, n);
    for (; g.mult != null; )
      if (isObject$4(g.mult))
        g = g.mult = extend$2({}, g.mult);
      else
        return g.mult = isSignal(t) ? {
          signal: `(${g.mult}) * (${t.signal})`
        } : g.mult * t, n;
    g.mult = t;
  }
  return n;
}
function axisTicks(n, t, g, d, k, H) {
  const AA = lookup(n, t), gA = n.orient, IA = getSign(gA, -1, 1);
  let CA, BA, eA;
  const iA = {
    enter: CA = {
      opacity: zero$1
    },
    update: eA = {
      opacity: one
    },
    exit: BA = {
      opacity: zero$1
    }
  };
  addEncoders(iA, {
    stroke: AA("tickColor"),
    strokeCap: AA("tickCap"),
    strokeDash: AA("tickDash"),
    strokeDashOffset: AA("tickDashOffset"),
    strokeOpacity: AA("tickOpacity"),
    strokeWidth: AA("tickWidth")
  });
  const QA = encoder(k);
  QA.mult = IA;
  const tA = {
    scale: n.scale,
    field: Value$1,
    band: H.band,
    extra: H.extra,
    offset: H.offset,
    round: AA("tickRound")
  };
  return eA.y = CA.y = ifX(gA, zero$1, tA), eA.y2 = CA.y2 = ifX(gA, QA), BA.x = ifX(gA, tA), eA.x = CA.x = ifY(gA, zero$1, tA), eA.x2 = CA.x2 = ifY(gA, QA), BA.y = ifY(gA, tA), guideMark({
    type: RuleMark,
    role: AxisTickRole,
    key: Value$1,
    from: d,
    encode: iA
  }, g);
}
function flushExpr(n, t, g, d, k) {
  return {
    signal: 'flush(range("' + n + '"), scale("' + n + '", datum.value), ' + t + "," + g + "," + d + "," + k + ")"
  };
}
function axisLabels(n, t, g, d, k, H) {
  const AA = lookup(n, t), gA = n.orient, IA = n.scale, CA = getSign(gA, -1, 1), BA = deref(AA("labelFlush")), eA = deref(AA("labelFlushOffset")), iA = AA("labelAlign"), QA = AA("labelBaseline");
  let tA = BA === 0 || !!BA, oA;
  const EA = encoder(k);
  EA.mult = CA, EA.offset = encoder(AA("labelPadding") || 0), EA.offset.mult = CA;
  const aA = {
    scale: IA,
    field: Value$1,
    band: 0.5,
    offset: extendOffset(H.offset, AA("labelOffset"))
  }, nA = ifX(gA, tA ? flushExpr(IA, BA, '"left"', '"right"', '"center"') : {
    value: "center"
  }, ifRight(gA, "left", "right")), lA = ifX(gA, ifTop(gA, "bottom", "top"), tA ? flushExpr(IA, BA, '"top"', '"bottom"', '"middle"') : {
    value: "middle"
  }), cA = flushExpr(IA, BA, `-(${eA})`, eA, 0);
  tA = tA && eA;
  const sA = {
    opacity: zero$1,
    x: ifX(gA, aA, EA),
    y: ifY(gA, aA, EA)
  }, rA = {
    enter: sA,
    update: oA = {
      opacity: one,
      text: {
        field: Label
      },
      x: sA.x,
      y: sA.y,
      align: nA,
      baseline: lA
    },
    exit: {
      opacity: zero$1,
      x: sA.x,
      y: sA.y
    }
  };
  addEncoders(rA, {
    dx: !iA && tA ? ifX(gA, cA) : null,
    dy: !QA && tA ? ifY(gA, cA) : null
  }), addEncoders(rA, {
    angle: AA("labelAngle"),
    fill: AA("labelColor"),
    fillOpacity: AA("labelOpacity"),
    font: AA("labelFont"),
    fontSize: AA("labelFontSize"),
    fontWeight: AA("labelFontWeight"),
    fontStyle: AA("labelFontStyle"),
    limit: AA("labelLimit"),
    lineHeight: AA("labelLineHeight")
  }, {
    align: iA,
    baseline: QA
  });
  const uA = AA("labelBound");
  let hA = AA("labelOverlap");
  return hA = hA || uA ? {
    separation: AA("labelSeparation"),
    method: hA,
    order: "datum.index",
    bound: uA ? {
      scale: IA,
      orient: gA,
      tolerance: uA
    } : null
  } : void 0, oA.align !== nA && (oA.align = patch(oA.align, nA)), oA.baseline !== lA && (oA.baseline = patch(oA.baseline, lA)), guideMark({
    type: TextMark,
    role: AxisLabelRole,
    style: GuideLabelStyle,
    key: Value$1,
    from: d,
    encode: rA,
    overlap: hA
  }, g);
}
function axisTitle(n, t, g, d) {
  const k = lookup(n, t), H = n.orient, AA = getSign(H, -1, 1);
  let gA, IA;
  const CA = {
    enter: gA = {
      opacity: zero$1,
      anchor: encoder(k("titleAnchor", null)),
      align: {
        signal: alignExpr$1
      }
    },
    update: IA = extend$2({}, gA, {
      opacity: one,
      text: encoder(n.title)
    }),
    exit: {
      opacity: zero$1
    }
  }, BA = {
    signal: `lerp(range("${n.scale}"), ${anchorExpr(0, 1, 0.5)})`
  };
  return IA.x = ifX(H, BA), IA.y = ifY(H, BA), gA.angle = ifX(H, zero$1, mult(AA, 90)), gA.baseline = ifX(H, ifTop(H, Bottom, Top), {
    value: Bottom
  }), IA.angle = gA.angle, IA.baseline = gA.baseline, addEncoders(CA, {
    fill: k("titleColor"),
    fillOpacity: k("titleOpacity"),
    font: k("titleFont"),
    fontSize: k("titleFontSize"),
    fontStyle: k("titleFontStyle"),
    fontWeight: k("titleFontWeight"),
    limit: k("titleLimit"),
    lineHeight: k("titleLineHeight")
  }, {
    // require update
    align: k("titleAlign"),
    angle: k("titleAngle"),
    baseline: k("titleBaseline")
  }), autoLayout(k, H, CA, g), CA.update.align = patch(CA.update.align, gA.align), CA.update.angle = patch(CA.update.angle, gA.angle), CA.update.baseline = patch(CA.update.baseline, gA.baseline), guideMark({
    type: TextMark,
    role: AxisTitleRole,
    style: GuideTitleStyle,
    from: d,
    encode: CA
  }, g);
}
function autoLayout(n, t, g, d) {
  const k = (gA, IA) => gA != null ? (g.update[IA] = patch(encoder(gA), g.update[IA]), !1) : !has$1(IA, d), H = k(n("titleX"), "x"), AA = k(n("titleY"), "y");
  g.enter.auto = AA === H ? encoder(AA) : ifX(t, encoder(AA), encoder(H));
}
function parseAxis$1(n, t) {
  const g = axisConfig(n, t), d = n.encode || {}, k = d.axis || {}, H = k.name || void 0, AA = k.interactive, gA = k.style, IA = lookup(n, g), CA = tickBand(IA), BA = {
    scale: n.scale,
    ticks: !!IA("ticks"),
    labels: !!IA("labels"),
    grid: !!IA("grid"),
    domain: !!IA("domain"),
    title: n.title != null
  }, eA = ref(t.add(Collect({}, [BA]))), iA = ref(t.add(AxisTicks({
    scale: t.scaleRef(n.scale),
    extra: t.property(CA.extra),
    count: t.objectProperty(n.tickCount),
    values: t.objectProperty(n.values),
    minstep: t.property(n.tickMinStep),
    formatType: t.property(n.formatType),
    formatSpecifier: t.property(n.format)
  }))), QA = [];
  let tA;
  return BA.grid && QA.push(axisGrid(n, g, d.grid, iA, CA)), BA.ticks && (tA = IA("tickSize"), QA.push(axisTicks(n, g, d.ticks, iA, tA, CA))), BA.labels && (tA = BA.ticks ? tA : 0, QA.push(axisLabels(n, g, d.labels, iA, tA, CA))), BA.domain && QA.push(axisDomain(n, g, d.domain, eA)), BA.title && QA.push(axisTitle(n, g, d.title, eA)), parseMark(guideGroup({
    role: AxisRole,
    from: eA,
    encode: extendEncode(buildAxisEncode(IA, n), k, Skip),
    marks: QA,
    aria: IA("aria"),
    description: IA("description"),
    zindex: IA("zindex"),
    name: H,
    interactive: AA,
    style: gA
  }), t);
}
function buildAxisEncode(n, t) {
  const g = {
    enter: {},
    update: {}
  };
  return addEncoders(g, {
    orient: n("orient"),
    offset: n("offset") || 0,
    position: value(t.position, 0),
    titlePadding: n("titlePadding"),
    minExtent: n("minExtent"),
    maxExtent: n("maxExtent"),
    range: {
      signal: `abs(span(range("${t.scale}")))`
    },
    translate: n("translate"),
    // accessibility support
    format: t.format,
    formatType: t.formatType
  }), g;
}
function parseScope(n, t, g) {
  const d = array$6(n.signals), k = array$6(n.scales);
  return g || d.forEach((H) => parseSignal(H, t)), array$6(n.projections).forEach((H) => parseProjection$1(H, t)), k.forEach((H) => initScale(H, t)), array$6(n.data).forEach((H) => parseData$2(H, t)), k.forEach((H) => parseScale(H, t)), (g || d).forEach((H) => parseSignalUpdates(H, t)), array$6(n.axes).forEach((H) => parseAxis$1(H, t)), array$6(n.marks).forEach((H) => parseMark(H, t)), array$6(n.legends).forEach((H) => parseLegend$1(H, t)), n.title && parseTitle(n.title, t), t.parseLambdas(), t;
}
const rootEncode = (n) => extendEncode({
  enter: {
    x: {
      value: 0
    },
    y: {
      value: 0
    }
  },
  update: {
    width: {
      signal: "width"
    },
    height: {
      signal: "height"
    }
  }
}, n);
function parseView(n, t) {
  const g = t.config, d = ref(t.root = t.add(operator())), k = collectSignals(n, g);
  k.forEach((CA) => parseSignal(CA, t)), t.description = n.description || g.description, t.eventConfig = g.events, t.legends = t.objectProperty(g.legend && g.legend.layout), t.locale = g.locale;
  const H = t.add(Collect()), AA = t.add(Encode(parseEncode(rootEncode(n.encode), GroupMark, FrameRole, n.style, t, {
    pulse: ref(H)
  }))), gA = t.add(ViewLayout({
    layout: t.objectProperty(n.layout),
    legends: t.legends,
    autosize: t.signalRef("autosize"),
    mark: d,
    pulse: ref(AA)
  }));
  t.operators.pop(), t.pushState(ref(AA), ref(gA), null), parseScope(n, t, k), t.operators.push(gA);
  let IA = t.add(Bound({
    mark: d,
    pulse: ref(gA)
  }));
  return IA = t.add(Render({
    pulse: ref(IA)
  })), IA = t.add(Sieve({
    pulse: ref(IA)
  })), t.addData("root", new DataScope(t, H, H, IA)), t;
}
function signalObject(n, t) {
  return t && t.signal ? {
    name: n,
    update: t.signal
  } : {
    name: n,
    value: t
  };
}
function collectSignals(n, t) {
  const g = (AA) => value(n[AA], t[AA]), d = [signalObject("background", g("background")), signalObject("autosize", parseAutosize(g("autosize"))), signalObject("padding", parsePadding(g("padding"))), signalObject("width", g("width") || 0), signalObject("height", g("height") || 0)], k = d.reduce((AA, gA) => (AA[gA.name] = gA, AA), {}), H = {};
  return array$6(n.signals).forEach((AA) => {
    has$2(k, AA.name) ? AA = extend$2(k[AA.name], AA) : d.push(AA), H[AA.name] = AA;
  }), array$6(t.signals).forEach((AA) => {
    !has$2(H, AA.name) && !has$2(k, AA.name) && d.push(AA);
  }), d;
}
function Scope(n, t) {
  this.config = n || {}, this.options = t || {}, this.bindings = [], this.field = {}, this.signals = {}, this.lambdas = {}, this.scales = {}, this.events = {}, this.data = {}, this.streams = [], this.updates = [], this.operators = [], this.eventConfig = null, this.locale = null, this._id = 0, this._subid = 0, this._nextsub = [0], this._parent = [], this._encode = [], this._lookup = [], this._markpath = [];
}
function Subscope(n) {
  this.config = n.config, this.options = n.options, this.legends = n.legends, this.field = Object.create(n.field), this.signals = Object.create(n.signals), this.lambdas = Object.create(n.lambdas), this.scales = Object.create(n.scales), this.events = Object.create(n.events), this.data = Object.create(n.data), this.streams = [], this.updates = [], this.operators = [], this._id = 0, this._subid = ++n._nextsub[0], this._nextsub = n._nextsub, this._parent = n._parent.slice(), this._encode = n._encode.slice(), this._lookup = n._lookup.slice(), this._markpath = n._markpath;
}
Scope.prototype = Subscope.prototype = {
  parse(n) {
    return parseScope(n, this);
  },
  fork() {
    return new Subscope(this);
  },
  isSubscope() {
    return this._subid > 0;
  },
  toRuntime() {
    return this.finish(), {
      description: this.description,
      operators: this.operators,
      streams: this.streams,
      updates: this.updates,
      bindings: this.bindings,
      eventConfig: this.eventConfig,
      locale: this.locale
    };
  },
  id() {
    return (this._subid ? this._subid + ":" : 0) + this._id++;
  },
  add(n) {
    return this.operators.push(n), n.id = this.id(), n.refs && (n.refs.forEach((t) => {
      t.$ref = n.id;
    }), n.refs = null), n;
  },
  proxy(n) {
    const t = n instanceof Entry ? ref(n) : n;
    return this.add(Proxy$1({
      value: t
    }));
  },
  addStream(n) {
    return this.streams.push(n), n.id = this.id(), n;
  },
  addUpdate(n) {
    return this.updates.push(n), n;
  },
  // Apply metadata
  finish() {
    let n, t;
    this.root && (this.root.root = !0);
    for (n in this.signals)
      this.signals[n].signal = n;
    for (n in this.scales)
      this.scales[n].scale = n;
    function g(d, k, H) {
      let AA, gA;
      d && (AA = d.data || (d.data = {}), gA = AA[k] || (AA[k] = []), gA.push(H));
    }
    for (n in this.data) {
      t = this.data[n], g(t.input, n, "input"), g(t.output, n, "output"), g(t.values, n, "values");
      for (const d in t.index)
        g(t.index[d], n, "index:" + d);
    }
    return this;
  },
  // ----
  pushState(n, t, g) {
    this._encode.push(ref(this.add(Sieve({
      pulse: n
    })))), this._parent.push(t), this._lookup.push(g ? ref(this.proxy(g)) : null), this._markpath.push(-1);
  },
  popState() {
    this._encode.pop(), this._parent.pop(), this._lookup.pop(), this._markpath.pop();
  },
  parent() {
    return peek$2(this._parent);
  },
  encode() {
    return peek$2(this._encode);
  },
  lookup() {
    return peek$2(this._lookup);
  },
  markpath() {
    const n = this._markpath;
    return ++n[n.length - 1];
  },
  // ----
  fieldRef(n, t) {
    if (isString$2(n)) return fieldRef$1(n, t);
    n.signal || error$3("Unsupported field reference: " + $$2(n));
    const g = n.signal;
    let d = this.field[g];
    if (!d) {
      const k = {
        name: this.signalRef(g)
      };
      t && (k.as = t), this.field[g] = d = ref(this.add(Field(k)));
    }
    return d;
  },
  compareRef(n) {
    let t = !1;
    const g = (H) => isSignal(H) ? (t = !0, this.signalRef(H.signal)) : isExpr$1(H) ? (t = !0, this.exprRef(H.expr)) : H, d = array$6(n.field).map(g), k = array$6(n.order).map(g);
    return t ? ref(this.add(Compare({
      fields: d,
      orders: k
    }))) : compareRef(d, k);
  },
  keyRef(n, t) {
    let g = !1;
    const d = (H) => isSignal(H) ? (g = !0, ref(k[H.signal])) : H, k = this.signals;
    return n = array$6(n).map(d), g ? ref(this.add(Key({
      fields: n,
      flat: t
    }))) : keyRef(n, t);
  },
  sortRef(n) {
    if (!n) return n;
    const t = aggrField(n.op, n.field), g = n.order || Ascending;
    return g.signal ? ref(this.add(Compare({
      fields: t,
      orders: this.signalRef(g.signal)
    }))) : compareRef(t, g);
  },
  // ----
  event(n, t) {
    const g = n + ":" + t;
    if (!this.events[g]) {
      const d = this.id();
      this.streams.push({
        id: d,
        source: n,
        type: t
      }), this.events[g] = d;
    }
    return this.events[g];
  },
  // ----
  hasOwnSignal(n) {
    return has$2(this.signals, n);
  },
  addSignal(n, t) {
    this.hasOwnSignal(n) && error$3("Duplicate signal name: " + $$2(n));
    const g = t instanceof Entry ? t : this.add(operator(t));
    return this.signals[n] = g;
  },
  getSignal(n) {
    return this.signals[n] || error$3("Unrecognized signal name: " + $$2(n)), this.signals[n];
  },
  signalRef(n) {
    return this.signals[n] ? ref(this.signals[n]) : (has$2(this.lambdas, n) || (this.lambdas[n] = this.add(operator(null))), ref(this.lambdas[n]));
  },
  parseLambdas() {
    const n = Object.keys(this.lambdas);
    for (let t = 0, g = n.length; t < g; ++t) {
      const d = n[t], k = parser$2(d, this), H = this.lambdas[d];
      H.params = k.$params, H.update = k.$expr;
    }
  },
  property(n) {
    return n && n.signal ? this.signalRef(n.signal) : n;
  },
  objectProperty(n) {
    return !n || !isObject$4(n) ? n : this.signalRef(n.signal || propertyLambda(n));
  },
  exprRef(n, t) {
    const g = {
      expr: parser$2(n, this)
    };
    return t && (g.expr.$name = t), ref(this.add(Expression(g)));
  },
  addBinding(n, t) {
    this.bindings || error$3("Nested signals do not support binding: " + $$2(n)), this.bindings.push(extend$2({
      signal: n
    }, t));
  },
  // ----
  addScaleProj(n, t) {
    has$2(this.scales, n) && error$3("Duplicate scale or projection name: " + $$2(n)), this.scales[n] = this.add(t);
  },
  addScale(n, t) {
    this.addScaleProj(n, Scale(t));
  },
  addProjection(n, t) {
    this.addScaleProj(n, Projection(t));
  },
  getScale(n) {
    return this.scales[n] || error$3("Unrecognized scale name: " + $$2(n)), this.scales[n];
  },
  scaleRef(n) {
    return ref(this.getScale(n));
  },
  scaleType(n) {
    return this.getScale(n).params.type;
  },
  projectionRef(n) {
    return this.scaleRef(n);
  },
  projectionType(n) {
    return this.scaleType(n);
  },
  // ----
  addData(n, t) {
    return has$2(this.data, n) && error$3("Duplicate data set name: " + $$2(n)), this.data[n] = t;
  },
  getData(n) {
    return this.data[n] || error$3("Undefined data set name: " + $$2(n)), this.data[n];
  },
  addDataPipeline(n, t) {
    return has$2(this.data, n) && error$3("Duplicate data set name: " + $$2(n)), this.addData(n, DataScope.fromEntries(this, t));
  }
};
function propertyLambda(n) {
  return (isArray$3(n) ? arrayLambda : objectLambda)(n);
}
function arrayLambda(n) {
  const t = n.length;
  let g = "[";
  for (let d = 0; d < t; ++d) {
    const k = n[d];
    g += (d > 0 ? "," : "") + (isObject$4(k) ? k.signal || propertyLambda(k) : $$2(k));
  }
  return g + "]";
}
function objectLambda(n) {
  let t = "{", g = 0, d, k;
  for (d in n)
    k = n[d], t += (++g > 1 ? "," : "") + $$2(d) + ":" + (isObject$4(k) ? k.signal || propertyLambda(k) : $$2(k));
  return t + "}";
}
function defaults$1() {
  const n = "sans-serif", d = "#4c78a8", k = "#000", H = "#888", AA = "#ddd";
  return {
    // default visualization description
    description: "Vega visualization",
    // default padding around visualization
    padding: 0,
    // default for automatic sizing; options: 'none', 'pad', 'fit'
    // or provide an object (e.g., {'type': 'pad', 'resize': true})
    autosize: "pad",
    // default view background color
    // covers the entire view component
    background: null,
    // default event handling configuration
    // preventDefault for view-sourced event types except 'wheel'
    events: {
      defaults: {
        allow: ["wheel"]
      }
    },
    // defaults for top-level group marks
    // accepts mark properties (fill, stroke, etc)
    // covers the data rectangle within group width/height
    group: null,
    // defaults for basic mark types
    // each subset accepts mark properties (fill, stroke, etc)
    mark: null,
    arc: {
      fill: d
    },
    area: {
      fill: d
    },
    image: null,
    line: {
      stroke: d,
      strokeWidth: 2
    },
    path: {
      stroke: d
    },
    rect: {
      fill: d
    },
    rule: {
      stroke: k
    },
    shape: {
      stroke: d
    },
    symbol: {
      fill: d,
      size: 64
    },
    text: {
      fill: k,
      font: n,
      fontSize: 11
    },
    trail: {
      fill: d,
      size: 2
    },
    // style definitions
    style: {
      // axis & legend labels
      "guide-label": {
        fill: k,
        font: n,
        fontSize: 10
      },
      // axis & legend titles
      "guide-title": {
        fill: k,
        font: n,
        fontSize: 11,
        fontWeight: "bold"
      },
      // headers, including chart title
      "group-title": {
        fill: k,
        font: n,
        fontSize: 13,
        fontWeight: "bold"
      },
      // chart subtitle
      "group-subtitle": {
        fill: k,
        font: n,
        fontSize: 12
      },
      // defaults for styled point marks in Vega-Lite
      point: {
        size: 30,
        strokeWidth: 2,
        shape: "circle"
      },
      circle: {
        size: 30,
        strokeWidth: 2
      },
      square: {
        size: 30,
        strokeWidth: 2,
        shape: "square"
      },
      // defaults for styled group marks in Vega-Lite
      cell: {
        fill: "transparent",
        stroke: AA
      },
      view: {
        fill: "transparent"
      }
    },
    // defaults for title
    title: {
      orient: "top",
      anchor: "middle",
      offset: 4,
      subtitlePadding: 3
    },
    // defaults for axes
    axis: {
      minExtent: 0,
      maxExtent: 200,
      bandPosition: 0.5,
      domain: !0,
      domainWidth: 1,
      domainColor: H,
      grid: !1,
      gridWidth: 1,
      gridColor: AA,
      labels: !0,
      labelAngle: 0,
      labelLimit: 180,
      labelOffset: 0,
      labelPadding: 2,
      ticks: !0,
      tickColor: H,
      tickOffset: 0,
      tickRound: !0,
      tickSize: 5,
      tickWidth: 1,
      titlePadding: 4
    },
    // correction for centering bias
    axisBand: {
      tickOffset: -0.5
    },
    // defaults for cartographic projection
    projection: {
      type: "mercator"
    },
    // defaults for legends
    legend: {
      orient: "right",
      padding: 0,
      gridAlign: "each",
      columnPadding: 10,
      rowPadding: 2,
      symbolDirection: "vertical",
      gradientDirection: "vertical",
      gradientLength: 200,
      gradientThickness: 16,
      gradientStrokeColor: AA,
      gradientStrokeWidth: 0,
      gradientLabelOffset: 2,
      labelAlign: "left",
      labelBaseline: "middle",
      labelLimit: 160,
      labelOffset: 4,
      labelOverlap: !0,
      symbolLimit: 30,
      symbolType: "circle",
      symbolSize: 100,
      symbolOffset: 0,
      symbolStrokeWidth: 1.5,
      symbolBaseFillColor: "transparent",
      symbolBaseStrokeColor: H,
      titleLimit: 180,
      titleOrient: "top",
      titlePadding: 5,
      layout: {
        offset: 18,
        direction: "horizontal",
        left: {
          direction: "vertical"
        },
        right: {
          direction: "vertical"
        }
      }
    },
    // defaults for scale ranges
    range: {
      category: {
        scheme: "tableau10"
      },
      ordinal: {
        scheme: "blues"
      },
      heatmap: {
        scheme: "yellowgreenblue"
      },
      ramp: {
        scheme: "blues"
      },
      diverging: {
        scheme: "blueorange",
        extent: [1, 0]
      },
      symbol: ["circle", "square", "triangle-up", "cross", "diamond", "triangle-right", "triangle-down", "triangle-left"]
    }
  };
}
function parse(n, t, g) {
  return isObject$4(n) || error$3("Input Vega specification must be an object."), t = mergeConfig$3(defaults$1(), t, n.config), parseView(n, new Scope(t, g)).toRuntime();
}
var version$1$2 = "6.2.0";
extend$2(transforms, tx, vtx, encode$3, geo, force, label, tree, reg, voronoi, wordcloud, xf);
const version$3 = version$1$2, vegaImport = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Bounds,
  CanvasHandler,
  CanvasRenderer,
  DATE,
  DAY,
  DAYOFYEAR,
  Dataflow,
  Debug: Debug$1,
  DisallowedObjectProperties,
  Error: Error$1$1,
  EventStream,
  Gradient: Gradient$1,
  GroupItem,
  HOURS,
  Handler: Handler$1,
  HybridHandler,
  HybridRenderer,
  Info: Info$1,
  Item: Item$1,
  MILLISECONDS,
  MINUTES,
  MONTH,
  Marks,
  MultiPulse,
  None: None$3,
  Operator,
  Parameters,
  Pulse,
  QUARTER,
  RenderType,
  Renderer,
  ResourceLoader,
  SECONDS,
  SVGHandler,
  SVGRenderer,
  SVGStringRenderer,
  Scenegraph,
  TIME_UNITS,
  Transform,
  View: View$1,
  WEEK,
  Warn: Warn$1,
  YEAR,
  accessor: accessor$2,
  accessorFields,
  accessorName,
  array: array$6,
  ascending: ascending$2,
  bandwidthNRD: estimateBandwidth,
  bin,
  bootstrapCI,
  boundClip,
  boundContext,
  boundItem: boundItem$1,
  boundMark,
  boundStroke,
  changeset,
  clampRange,
  codegenExpression: codegen,
  compare: compare$3,
  constant: constant$6,
  cumulativeLogNormal,
  cumulativeNormal,
  cumulativeUniform,
  dayofyear,
  debounce: debounce$1,
  defaultLocale,
  definition: definition$1,
  densityLogNormal,
  densityNormal,
  densityUniform,
  domChild,
  domClear,
  domCreate,
  domFind,
  dotbin,
  error: error$3,
  expressionFunction,
  extend: extend$2,
  extent,
  extentIndex,
  falsy,
  fastmap,
  field: field$4,
  flush,
  font: font$1,
  fontFamily,
  fontSize,
  format: format$2,
  formatLocale: numberFormatDefaultLocale,
  formats: formats$1,
  hasOwnProperty: has$2,
  id,
  identity: identity$8,
  inferType,
  inferTypes,
  ingest: ingest$1,
  inherits: inherits$1,
  inrange,
  interpolate: interpolate$1,
  interpolateColors,
  interpolateRange: interpolateRange$1,
  intersect: intersect$2,
  intersectBoxLine,
  intersectPath,
  intersectPoint,
  intersectRule,
  isArray: isArray$3,
  isBoolean: isBoolean$4,
  isDate: isDate$2,
  isFunction: isFunction$5,
  isIterable: isIterable$1,
  isNumber: isNumber$3,
  isObject: isObject$4,
  isRegExp: isRegExp$1,
  isString: isString$2,
  isTuple,
  key,
  lerp,
  lineHeight,
  loader,
  locale,
  logger: logger$1,
  lruCache,
  markup,
  merge: merge$5,
  mergeConfig: mergeConfig$3,
  multiLineOffset,
  one: one$2,
  pad: pad$2,
  panLinear,
  panLog,
  panPow,
  panSymlog,
  parse,
  parseExpression: parser$3,
  parseSelector: eventSelector,
  path: path$4,
  pathCurves: curves,
  pathEqual,
  pathParse: parse$3,
  pathRectangle: vg_rect,
  pathRender,
  pathSymbols: symbols$1,
  pathTrail: vg_trail,
  peek: peek$2,
  point: point$2,
  projection,
  quantileLogNormal,
  quantileNormal,
  quantileUniform,
  quantiles,
  quantizeInterpolator,
  quarter,
  quartiles,
  get random() {
    return random;
  },
  randomInteger: integer,
  randomKDE: kde,
  randomLCG: lcg$2,
  randomLogNormal: lognormal,
  randomMixture: mixture$1,
  randomNormal: gaussian,
  randomUniform: uniform,
  read,
  regressionConstant: constant$5,
  regressionExp: exp$1,
  regressionLinear: linear$2,
  regressionLoess: loess,
  regressionLog: log$4,
  regressionPoly: poly,
  regressionPow: pow$3,
  regressionQuad: quad,
  renderModule,
  repeat,
  resetDefaultLocale,
  resetSVGDefIds,
  responseType,
  runtimeContext: context,
  sampleCurve,
  sampleLogNormal,
  sampleNormal,
  sampleUniform,
  scale: scale$4,
  sceneEqual,
  sceneFromJSON,
  scenePickVisit: pickVisit,
  sceneToJSON,
  sceneVisit: visit,
  sceneZOrder: zorder,
  scheme: scheme$1,
  serializeXML,
  setHybridRendererOptions,
  setRandom,
  span,
  splitAccessPath: splitAccessPath$2,
  stringValue: $$2,
  textMetrics,
  timeBin: bin$1,
  timeFloor,
  timeFormatLocale: timeFormatDefaultLocale,
  timeInterval,
  timeOffset,
  timeSequence,
  timeUnitSpecifier,
  timeUnits,
  toBoolean,
  toDate,
  toNumber: toNumber$1,
  toSet,
  toString: toString$3,
  transform: transform$2,
  transforms,
  truncate: truncate$1,
  truthy,
  tupleid,
  typeParsers,
  utcFloor,
  utcInterval,
  utcOffset,
  utcSequence,
  utcdayofyear,
  utcquarter,
  utcweek,
  version: version$3,
  visitArray,
  week,
  writeConfig: writeConfig$1,
  zero: zero$4,
  zoomLinear,
  zoomLog,
  zoomPow,
  zoomSymlog
}, Symbol.toStringTag, { value: "Module" }));
function adjustSpatial(n, t, g) {
  let d;
  t.x2 && (t.x ? (g && n.x > n.x2 && (d = n.x, n.x = n.x2, n.x2 = d), n.width = n.x2 - n.x) : n.x = n.x2 - (n.width || 0)), t.xc && (n.x = n.xc - (n.width || 0) / 2), t.y2 && (t.y ? (g && n.y > n.y2 && (d = n.y, n.y = n.y2, n.y2 = d), n.height = n.y2 - n.y) : n.y = n.y2 - (n.height || 0)), t.yc && (n.y = n.yc - (n.height || 0) / 2);
}
var Constants = {
  NaN: NaN,
  E: Math.E,
  LN2: Math.LN2,
  LN10: Math.LN10,
  LOG2E: Math.LOG2E,
  LOG10E: Math.LOG10E,
  PI: Math.PI,
  SQRT1_2: Math.SQRT1_2,
  SQRT2: Math.SQRT2,
  MIN_VALUE: Number.MIN_VALUE,
  MAX_VALUE: Number.MAX_VALUE
}, Ops = {
  "*": (n, t) => n * t,
  "+": (n, t) => n + t,
  "-": (n, t) => n - t,
  "/": (n, t) => n / t,
  "%": (n, t) => n % t,
  ">": (n, t) => n > t,
  "<": (n, t) => n < t,
  "<=": (n, t) => n <= t,
  ">=": (n, t) => n >= t,
  "==": (n, t) => n == t,
  "!=": (n, t) => n != t,
  "===": (n, t) => n === t,
  "!==": (n, t) => n !== t,
  "&": (n, t) => n & t,
  "|": (n, t) => n | t,
  "^": (n, t) => n ^ t,
  "<<": (n, t) => n << t,
  ">>": (n, t) => n >> t,
  ">>>": (n, t) => n >>> t
}, Unary = {
  "+": (n) => +n,
  "-": (n) => -n,
  "~": (n) => ~n,
  "!": (n) => !n
};
const slice = Array.prototype.slice, apply$1 = (n, t, g) => {
  const d = g ? g(t[0]) : t[0];
  return d[n].apply(d, slice.call(t, 1));
}, datetime = (n, t = 0, g = 1, d = 0, k = 0, H = 0, AA = 0) => isString$2(n) ? new Date(n) : new Date(n, t, g, d, k, H, AA);
var Functions = {
  // math functions
  isNaN: Number.isNaN,
  isFinite: Number.isFinite,
  abs: Math.abs,
  acos: Math.acos,
  asin: Math.asin,
  atan: Math.atan,
  atan2: Math.atan2,
  ceil: Math.ceil,
  cos: Math.cos,
  exp: Math.exp,
  floor: Math.floor,
  log: Math.log,
  max: Math.max,
  min: Math.min,
  pow: Math.pow,
  random: Math.random,
  round: Math.round,
  sin: Math.sin,
  sqrt: Math.sqrt,
  tan: Math.tan,
  clamp: (n, t, g) => Math.max(t, Math.min(g, n)),
  // date functions
  now: Date.now,
  utc: Date.UTC,
  datetime,
  date: (n) => new Date(n).getDate(),
  day: (n) => new Date(n).getDay(),
  year: (n) => new Date(n).getFullYear(),
  month: (n) => new Date(n).getMonth(),
  hours: (n) => new Date(n).getHours(),
  minutes: (n) => new Date(n).getMinutes(),
  seconds: (n) => new Date(n).getSeconds(),
  milliseconds: (n) => new Date(n).getMilliseconds(),
  time: (n) => new Date(n).getTime(),
  timezoneoffset: (n) => new Date(n).getTimezoneOffset(),
  utcdate: (n) => new Date(n).getUTCDate(),
  utcday: (n) => new Date(n).getUTCDay(),
  utcyear: (n) => new Date(n).getUTCFullYear(),
  utcmonth: (n) => new Date(n).getUTCMonth(),
  utchours: (n) => new Date(n).getUTCHours(),
  utcminutes: (n) => new Date(n).getUTCMinutes(),
  utcseconds: (n) => new Date(n).getUTCSeconds(),
  utcmilliseconds: (n) => new Date(n).getUTCMilliseconds(),
  // sequence functions
  length: (n) => n.length,
  join: function() {
    return apply$1("join", arguments);
  },
  indexof: function() {
    return apply$1("indexOf", arguments);
  },
  lastindexof: function() {
    return apply$1("lastIndexOf", arguments);
  },
  slice: function() {
    return apply$1("slice", arguments);
  },
  reverse: (n) => n.slice().reverse(),
  sort: (n) => n.slice().sort(ascending$2),
  // string functions
  parseFloat,
  parseInt,
  upper: (n) => String(n).toUpperCase(),
  lower: (n) => String(n).toLowerCase(),
  substring: function() {
    return apply$1("substring", arguments, String);
  },
  split: function() {
    return apply$1("split", arguments, String);
  },
  replace: function() {
    return apply$1("replace", arguments, String);
  },
  trim: (n) => String(n).trim(),
  // Base64 encode/decode
  // Convert binary string to base64-encoded ascii
  btoa: (n) => btoa(n),
  // Convert base64-encoded ascii to binary string
  atob: (n) => atob(n),
  // regexp functions
  regexp: RegExp,
  test: (n, t) => RegExp(n).test(t)
};
const EventFunctions = ["view", "item", "group", "xy", "x", "y"], DisallowedMethods = /* @__PURE__ */ new Set([Function, eval, setTimeout, setInterval]);
typeof setImmediate == "function" && DisallowedMethods.add(setImmediate);
const Visitors = {
  Literal: (n, t) => t.value,
  Identifier: (n, t) => {
    const g = t.name;
    return n.memberDepth > 0 ? g : g === "datum" ? n.datum : g === "event" ? n.event : g === "item" ? n.item : Constants[g] || n.params["$" + g];
  },
  MemberExpression: (n, t) => {
    const g = !t.computed, d = n(t.object);
    g && (n.memberDepth += 1);
    const k = n(t.property);
    if (g && (n.memberDepth -= 1), DisallowedMethods.has(d[k])) {
      console.error(`Prevented interpretation of member "${k}" which could lead to insecure code execution`);
      return;
    }
    return d[k];
  },
  CallExpression: (n, t) => {
    const g = t.arguments;
    let d = t.callee.name;
    return d.startsWith("_") && (d = d.slice(1)), d === "if" ? n(g[0]) ? n(g[1]) : n(g[2]) : (n.fn[d] || Functions[d]).apply(n.fn, g.map(n));
  },
  ArrayExpression: (n, t) => t.elements.map(n),
  BinaryExpression: (n, t) => Ops[t.operator](n(t.left), n(t.right)),
  UnaryExpression: (n, t) => Unary[t.operator](n(t.argument)),
  ConditionalExpression: (n, t) => n(t.test) ? n(t.consequent) : n(t.alternate),
  LogicalExpression: (n, t) => t.operator === "&&" ? n(t.left) && n(t.right) : n(t.left) || n(t.right),
  ObjectExpression: (n, t) => t.properties.reduce((g, d) => {
    n.memberDepth += 1;
    const k = n(d.key);
    n.memberDepth -= 1;
    const H = n(d.value);
    return DisallowedObjectProperties.has(k) ? console.error(`Prevented interpretation of property "${k}" which could lead to insecure code execution`) : DisallowedMethods.has(H) ? console.error(`Prevented interpretation of method "${k}" which could lead to insecure code execution`) : g[k] = H, g;
  }, {})
};
function interpret(n, t, g, d, k, H) {
  const AA = (gA) => Visitors[gA.type](AA, gA);
  return AA.memberDepth = 0, AA.fn = Object.create(t), AA.params = g, AA.datum = d, AA.event = k, AA.item = H, EventFunctions.forEach((gA) => AA.fn[gA] = (...IA) => k.vega[gA](...IA)), AA(n);
}
var expression$1 = {
  /**
   * Parse an expression used to update an operator value.
   */
  operator(n, t) {
    const g = t.ast, d = n.functions;
    return (k) => interpret(g, d, k);
  },
  /**
   * Parse an expression provided as an operator parameter value.
   */
  parameter(n, t) {
    const g = t.ast, d = n.functions;
    return (k, H) => interpret(g, d, H, k);
  },
  /**
   * Parse an expression applied to an event stream.
   */
  event(n, t) {
    const g = t.ast, d = n.functions;
    return (k) => interpret(g, d, void 0, void 0, k);
  },
  /**
   * Parse an expression used to handle an event-driven operator update.
   */
  handler(n, t) {
    const g = t.ast, d = n.functions;
    return (k, H) => {
      const AA = H.item && H.item.datum;
      return interpret(g, d, k, AA, H);
    };
  },
  /**
   * Parse an expression that performs visual encoding.
   */
  encode(n, t) {
    const {
      marktype: g,
      channels: d
    } = t, k = n.functions, H = g === "group" || g === "image" || g === "rect";
    return (AA, gA) => {
      const IA = AA.datum;
      let CA = 0, BA;
      for (const eA in d)
        BA = interpret(d[eA].ast, k, gA, IA, void 0, AA), AA[eA] !== BA && (AA[eA] = BA, CA = 1);
      return g !== "rule" && adjustSpatial(AA, d, H), CA;
    };
  }
};
function accessor$1(n, t, g) {
  return n.fields = t || [], n.fname = g, n;
}
function getter$1(n) {
  return n.length === 1 ? get1$1(n[0]) : getN$1(n);
}
const get1$1 = (n) => function(t) {
  return t[n];
}, getN$1 = (n) => {
  const t = n.length;
  return function(g) {
    for (let d = 0; d < t; ++d)
      g = g[n[d]];
    return g;
  };
};
function error$2(n) {
  throw Error(n);
}
function splitAccessPath$1(n) {
  const t = [], g = n.length;
  let d = null, k = 0, H = "", AA, gA, IA;
  n = n + "";
  function CA() {
    t.push(H + n.substring(AA, gA)), H = "", AA = gA + 1;
  }
  for (AA = gA = 0; gA < g; ++gA)
    if (IA = n[gA], IA === "\\")
      H += n.substring(AA, gA++), AA = gA;
    else if (IA === d)
      CA(), d = null, k = -1;
    else {
      if (d)
        continue;
      AA === k && IA === '"' || AA === k && IA === "'" ? (AA = gA + 1, d = IA) : IA === "." && !k ? gA > AA ? CA() : AA = gA + 1 : IA === "[" ? (gA > AA && CA(), k = AA = gA + 1) : IA === "]" && (k || error$2("Access path missing open bracket: " + n), k > 0 && CA(), k = 0, AA = gA + 1);
    }
  return k && error$2("Access path missing closing bracket: " + n), d && error$2("Access path missing closing quote: " + n), gA > AA && (gA++, CA()), t;
}
function field$2(n, t, g) {
  const d = splitAccessPath$1(n);
  return n = d.length === 1 ? d[0] : n, accessor$1(getter$1(d), [n], n);
}
field$2("id");
const identity$1 = accessor$1((n) => n, [], "identity");
accessor$1(() => 0, [], "zero");
accessor$1(() => 1, [], "one");
accessor$1(() => !0, [], "true");
accessor$1(() => !1, [], "false");
function log$1(n, t, g) {
  const d = [t].concat([].slice.call(g));
  console[n].apply(console, d);
}
const None = 0, Error$1 = 1, Warn = 2, Info = 3, Debug = 4;
function logger(n, t) {
  let g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : log$1, d = n || None;
  return {
    level(k) {
      return arguments.length ? (d = +k, this) : d;
    },
    error() {
      return d >= Error$1 && g("error", "ERROR", arguments), this;
    },
    warn() {
      return d >= Warn && g("warn", "WARN", arguments), this;
    },
    info() {
      return d >= Info && g("log", "INFO", arguments), this;
    },
    debug() {
      return d >= Debug && g("log", "DEBUG", arguments), this;
    }
  };
}
var isArray$2 = Array.isArray;
function isObject$3(n) {
  return n === Object(n);
}
const isLegalKey = (n) => n !== "__proto__";
function mergeConfig$2() {
  for (var n = arguments.length, t = new Array(n), g = 0; g < n; g++)
    t[g] = arguments[g];
  return t.reduce((d, k) => {
    for (const H in k)
      if (H === "signals")
        d.signals = mergeNamed(d.signals, k.signals);
      else {
        const AA = H === "legend" ? {
          layout: 1
        } : H === "style" ? !0 : null;
        writeConfig(d, H, k[H], AA);
      }
    return d;
  }, {});
}
function writeConfig(n, t, g, d) {
  if (!isLegalKey(t)) return;
  let k, H;
  if (isObject$3(g) && !isArray$2(g)) {
    H = isObject$3(n[t]) ? n[t] : n[t] = {};
    for (k in g)
      d && (d === !0 || d[k]) ? writeConfig(H, k, g[k]) : isLegalKey(k) && (H[k] = g[k]);
  } else
    n[t] = g;
}
function mergeNamed(n, t) {
  if (n == null) return t;
  const g = {}, d = [];
  function k(H) {
    g[H.name] || (g[H.name] = 1, d.push(H));
  }
  return t.forEach(k), n.forEach(k), d;
}
function array(n) {
  return n != null ? isArray$2(n) ? n : [n] : [];
}
function isFunction$4(n) {
  return typeof n == "function";
}
function has(n, t) {
  return Object.hasOwn(n, t);
}
function isBoolean$2(n) {
  return typeof n == "boolean";
}
function isNumber$1(n) {
  return typeof n == "number";
}
function isString$1(n) {
  return typeof n == "string";
}
function $$1(n) {
  return isArray$2(n) ? "[" + n.map($$1) + "]" : isObject$3(n) || isString$1(n) ? (
    // Output valid JSON and JS source strings.
    // See http://timelessrepo.com/json-isnt-a-javascript-subset
    JSON.stringify(n).replace("\u2028", "\\u2028").replace("\u2029", "\\u2029")
  ) : n;
}
function accessor(n, t, g) {
  return n.fields = t || [], n.fname = g, n;
}
function getter(n) {
  return n.length === 1 ? get1(n[0]) : getN(n);
}
const get1 = (n) => function(t) {
  return t[n];
}, getN = (n) => {
  const t = n.length;
  return function(g) {
    for (let d = 0; d < t; ++d)
      g = g[n[d]];
    return g;
  };
};
function error$1(n) {
  throw Error(n);
}
function splitAccessPath(n) {
  const t = [], g = n.length;
  let d = null, k = 0, H = "", AA, gA, IA;
  n = n + "";
  function CA() {
    t.push(H + n.substring(AA, gA)), H = "", AA = gA + 1;
  }
  for (AA = gA = 0; gA < g; ++gA)
    if (IA = n[gA], IA === "\\")
      H += n.substring(AA, gA++), AA = gA;
    else if (IA === d)
      CA(), d = null, k = -1;
    else {
      if (d)
        continue;
      AA === k && IA === '"' || AA === k && IA === "'" ? (AA = gA + 1, d = IA) : IA === "." && !k ? gA > AA ? CA() : AA = gA + 1 : IA === "[" ? (gA > AA && CA(), k = AA = gA + 1) : IA === "]" && (k || error$1("Access path missing open bracket: " + n), k > 0 && CA(), k = 0, AA = gA + 1);
    }
  return k && error$1("Access path missing closing bracket: " + n), d && error$1("Access path missing closing quote: " + n), gA > AA && (gA++, CA()), t;
}
function field$1(n, t, g) {
  const d = splitAccessPath(n);
  return n = d.length === 1 ? d[0] : n, accessor(getter(d), [n], n);
}
field$1("id");
accessor((n) => n, [], "identity");
accessor(() => 0, [], "zero");
accessor(() => 1, [], "one");
accessor(() => !0, [], "true");
accessor(() => !1, [], "false");
[...Object.getOwnPropertyNames(Object.prototype).filter((n) => typeof Object.prototype[n] == "function")];
const RawCode = "RawCode", Literal = "Literal", Property = "Property", Identifier = "Identifier", ArrayExpression = "ArrayExpression", BinaryExpression = "BinaryExpression", CallExpression = "CallExpression", ConditionalExpression = "ConditionalExpression", LogicalExpression = "LogicalExpression", MemberExpression = "MemberExpression", ObjectExpression = "ObjectExpression", UnaryExpression = "UnaryExpression";
function ASTNode(n) {
  this.type = n;
}
ASTNode.prototype.visit = function(n) {
  let t, g, d;
  if (n(this)) return 1;
  for (t = children(this), g = 0, d = t.length; g < d; ++g)
    if (t[g].visit(n)) return 1;
};
function children(n) {
  switch (n.type) {
    case ArrayExpression:
      return n.elements;
    case BinaryExpression:
    case LogicalExpression:
      return [n.left, n.right];
    case CallExpression:
      return [n.callee].concat(n.arguments);
    case ConditionalExpression:
      return [n.test, n.consequent, n.alternate];
    case MemberExpression:
      return [n.object, n.property];
    case ObjectExpression:
      return n.properties;
    case Property:
      return [n.key, n.value];
    case UnaryExpression:
      return [n.argument];
    case Identifier:
    case Literal:
    case RawCode:
    default:
      return [];
  }
}
var TokenName, source, index$1, length, lookahead, TokenBooleanLiteral = 1, TokenEOF = 2, TokenIdentifier = 3, TokenKeyword = 4, TokenNullLiteral = 5, TokenNumericLiteral = 6, TokenPunctuator = 7, TokenStringLiteral = 8, TokenRegularExpression = 9;
TokenName = {};
TokenName[TokenBooleanLiteral] = "Boolean";
TokenName[TokenEOF] = "<end>";
TokenName[TokenIdentifier] = "Identifier";
TokenName[TokenKeyword] = "Keyword";
TokenName[TokenNullLiteral] = "Null";
TokenName[TokenNumericLiteral] = "Numeric";
TokenName[TokenPunctuator] = "Punctuator";
TokenName[TokenStringLiteral] = "String";
TokenName[TokenRegularExpression] = "RegularExpression";
var SyntaxArrayExpression = "ArrayExpression", SyntaxBinaryExpression = "BinaryExpression", SyntaxCallExpression = "CallExpression", SyntaxConditionalExpression = "ConditionalExpression", SyntaxIdentifier = "Identifier", SyntaxLiteral = "Literal", SyntaxLogicalExpression = "LogicalExpression", SyntaxMemberExpression = "MemberExpression", SyntaxObjectExpression = "ObjectExpression", SyntaxProperty = "Property", SyntaxUnaryExpression = "UnaryExpression", MessageUnexpectedToken = "Unexpected token %0", MessageUnexpectedNumber = "Unexpected number", MessageUnexpectedString = "Unexpected string", MessageUnexpectedIdentifier = "Unexpected identifier", MessageUnexpectedReserved = "Unexpected reserved word", MessageUnexpectedEOS = "Unexpected end of input", MessageInvalidRegExp = "Invalid regular expression", MessageUnterminatedRegExp = "Invalid regular expression: missing /", MessageStrictOctalLiteral = "Octal literals are not allowed in strict mode.", MessageStrictDuplicateProperty = "Duplicate data property in object literal not allowed in strict mode", ILLEGAL = "ILLEGAL", DISABLED = "Disabled.", RegexNonAsciiIdentifierStart = new RegExp("[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0-\\u08B2\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]"), RegexNonAsciiIdentifierPart = new RegExp("[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0300-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u0483-\\u0487\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u0591-\\u05BD\\u05BF\\u05C1\\u05C2\\u05C4\\u05C5\\u05C7\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0610-\\u061A\\u0620-\\u0669\\u066E-\\u06D3\\u06D5-\\u06DC\\u06DF-\\u06E8\\u06EA-\\u06FC\\u06FF\\u0710-\\u074A\\u074D-\\u07B1\\u07C0-\\u07F5\\u07FA\\u0800-\\u082D\\u0840-\\u085B\\u08A0-\\u08B2\\u08E4-\\u0963\\u0966-\\u096F\\u0971-\\u0983\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BC-\\u09C4\\u09C7\\u09C8\\u09CB-\\u09CE\\u09D7\\u09DC\\u09DD\\u09DF-\\u09E3\\u09E6-\\u09F1\\u0A01-\\u0A03\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A3C\\u0A3E-\\u0A42\\u0A47\\u0A48\\u0A4B-\\u0A4D\\u0A51\\u0A59-\\u0A5C\\u0A5E\\u0A66-\\u0A75\\u0A81-\\u0A83\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABC-\\u0AC5\\u0AC7-\\u0AC9\\u0ACB-\\u0ACD\\u0AD0\\u0AE0-\\u0AE3\\u0AE6-\\u0AEF\\u0B01-\\u0B03\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3C-\\u0B44\\u0B47\\u0B48\\u0B4B-\\u0B4D\\u0B56\\u0B57\\u0B5C\\u0B5D\\u0B5F-\\u0B63\\u0B66-\\u0B6F\\u0B71\\u0B82\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BBE-\\u0BC2\\u0BC6-\\u0BC8\\u0BCA-\\u0BCD\\u0BD0\\u0BD7\\u0BE6-\\u0BEF\\u0C00-\\u0C03\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D-\\u0C44\\u0C46-\\u0C48\\u0C4A-\\u0C4D\\u0C55\\u0C56\\u0C58\\u0C59\\u0C60-\\u0C63\\u0C66-\\u0C6F\\u0C81-\\u0C83\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBC-\\u0CC4\\u0CC6-\\u0CC8\\u0CCA-\\u0CCD\\u0CD5\\u0CD6\\u0CDE\\u0CE0-\\u0CE3\\u0CE6-\\u0CEF\\u0CF1\\u0CF2\\u0D01-\\u0D03\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D-\\u0D44\\u0D46-\\u0D48\\u0D4A-\\u0D4E\\u0D57\\u0D60-\\u0D63\\u0D66-\\u0D6F\\u0D7A-\\u0D7F\\u0D82\\u0D83\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0DCA\\u0DCF-\\u0DD4\\u0DD6\\u0DD8-\\u0DDF\\u0DE6-\\u0DEF\\u0DF2\\u0DF3\\u0E01-\\u0E3A\\u0E40-\\u0E4E\\u0E50-\\u0E59\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB9\\u0EBB-\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EC8-\\u0ECD\\u0ED0-\\u0ED9\\u0EDC-\\u0EDF\\u0F00\\u0F18\\u0F19\\u0F20-\\u0F29\\u0F35\\u0F37\\u0F39\\u0F3E-\\u0F47\\u0F49-\\u0F6C\\u0F71-\\u0F84\\u0F86-\\u0F97\\u0F99-\\u0FBC\\u0FC6\\u1000-\\u1049\\u1050-\\u109D\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u135D-\\u135F\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1714\\u1720-\\u1734\\u1740-\\u1753\\u1760-\\u176C\\u176E-\\u1770\\u1772\\u1773\\u1780-\\u17D3\\u17D7\\u17DC\\u17DD\\u17E0-\\u17E9\\u180B-\\u180D\\u1810-\\u1819\\u1820-\\u1877\\u1880-\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1920-\\u192B\\u1930-\\u193B\\u1946-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19B0-\\u19C9\\u19D0-\\u19D9\\u1A00-\\u1A1B\\u1A20-\\u1A5E\\u1A60-\\u1A7C\\u1A7F-\\u1A89\\u1A90-\\u1A99\\u1AA7\\u1AB0-\\u1ABD\\u1B00-\\u1B4B\\u1B50-\\u1B59\\u1B6B-\\u1B73\\u1B80-\\u1BF3\\u1C00-\\u1C37\\u1C40-\\u1C49\\u1C4D-\\u1C7D\\u1CD0-\\u1CD2\\u1CD4-\\u1CF6\\u1CF8\\u1CF9\\u1D00-\\u1DF5\\u1DFC-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u200C\\u200D\\u203F\\u2040\\u2054\\u2071\\u207F\\u2090-\\u209C\\u20D0-\\u20DC\\u20E1\\u20E5-\\u20F0\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D7F-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2DE0-\\u2DFF\\u2E2F\\u3005-\\u3007\\u3021-\\u302F\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u3099\\u309A\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA62B\\uA640-\\uA66F\\uA674-\\uA67D\\uA67F-\\uA69D\\uA69F-\\uA6F1\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA827\\uA840-\\uA873\\uA880-\\uA8C4\\uA8D0-\\uA8D9\\uA8E0-\\uA8F7\\uA8FB\\uA900-\\uA92D\\uA930-\\uA953\\uA960-\\uA97C\\uA980-\\uA9C0\\uA9CF-\\uA9D9\\uA9E0-\\uA9FE\\uAA00-\\uAA36\\uAA40-\\uAA4D\\uAA50-\\uAA59\\uAA60-\\uAA76\\uAA7A-\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEF\\uAAF2-\\uAAF6\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABEA\\uABEC\\uABED\\uABF0-\\uABF9\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE00-\\uFE0F\\uFE20-\\uFE2D\\uFE33\\uFE34\\uFE4D-\\uFE4F\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF10-\\uFF19\\uFF21-\\uFF3A\\uFF3F\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]");
function assert(n, t) {
  if (!n)
    throw new Error("ASSERT: " + t);
}
function isDecimalDigit(n) {
  return n >= 48 && n <= 57;
}
function isHexDigit(n) {
  return "0123456789abcdefABCDEF".includes(n);
}
function isOctalDigit(n) {
  return "01234567".includes(n);
}
function isWhiteSpace(n) {
  return n === 32 || n === 9 || n === 11 || n === 12 || n === 160 || n >= 5760 && [5760, 6158, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279].includes(n);
}
function isLineTerminator(n) {
  return n === 10 || n === 13 || n === 8232 || n === 8233;
}
function isIdentifierStart(n) {
  return n === 36 || n === 95 || // $ (dollar) and _ (underscore)
  n >= 65 && n <= 90 || // A..Z
  n >= 97 && n <= 122 || // a..z
  n === 92 || // \ (backslash)
  n >= 128 && RegexNonAsciiIdentifierStart.test(String.fromCharCode(n));
}
function isIdentifierPart(n) {
  return n === 36 || n === 95 || // $ (dollar) and _ (underscore)
  n >= 65 && n <= 90 || // A..Z
  n >= 97 && n <= 122 || // a..z
  n >= 48 && n <= 57 || // 0..9
  n === 92 || // \ (backslash)
  n >= 128 && RegexNonAsciiIdentifierPart.test(String.fromCharCode(n));
}
const keywords = {
  if: 1,
  in: 1,
  do: 1,
  var: 1,
  for: 1,
  new: 1,
  try: 1,
  let: 1,
  this: 1,
  else: 1,
  case: 1,
  void: 1,
  with: 1,
  enum: 1,
  while: 1,
  break: 1,
  catch: 1,
  throw: 1,
  const: 1,
  yield: 1,
  class: 1,
  super: 1,
  return: 1,
  typeof: 1,
  delete: 1,
  switch: 1,
  export: 1,
  import: 1,
  public: 1,
  static: 1,
  default: 1,
  finally: 1,
  extends: 1,
  package: 1,
  private: 1,
  function: 1,
  continue: 1,
  debugger: 1,
  interface: 1,
  protected: 1,
  instanceof: 1,
  implements: 1
};
function skipComment() {
  for (; index$1 < length; ) {
    const n = source.charCodeAt(index$1);
    if (isWhiteSpace(n) || isLineTerminator(n))
      ++index$1;
    else
      break;
  }
}
function scanHexEscape(n) {
  var t, g, d, k = 0;
  for (g = n === "u" ? 4 : 2, t = 0; t < g; ++t)
    index$1 < length && isHexDigit(source[index$1]) ? (d = source[index$1++], k = k * 16 + "0123456789abcdef".indexOf(d.toLowerCase())) : throwError({}, MessageUnexpectedToken, ILLEGAL);
  return String.fromCharCode(k);
}
function scanUnicodeCodePointEscape() {
  var n, t, g, d;
  for (n = source[index$1], t = 0, n === "}" && throwError({}, MessageUnexpectedToken, ILLEGAL); index$1 < length && (n = source[index$1++], !!isHexDigit(n)); )
    t = t * 16 + "0123456789abcdef".indexOf(n.toLowerCase());
  return (t > 1114111 || n !== "}") && throwError({}, MessageUnexpectedToken, ILLEGAL), t <= 65535 ? String.fromCharCode(t) : (g = (t - 65536 >> 10) + 55296, d = (t - 65536 & 1023) + 56320, String.fromCharCode(g, d));
}
function getEscapedIdentifier() {
  var n, t;
  for (n = source.charCodeAt(index$1++), t = String.fromCharCode(n), n === 92 && (source.charCodeAt(index$1) !== 117 && throwError({}, MessageUnexpectedToken, ILLEGAL), ++index$1, n = scanHexEscape("u"), (!n || n === "\\" || !isIdentifierStart(n.charCodeAt(0))) && throwError({}, MessageUnexpectedToken, ILLEGAL), t = n); index$1 < length && (n = source.charCodeAt(index$1), !!isIdentifierPart(n)); )
    ++index$1, t += String.fromCharCode(n), n === 92 && (t = t.substr(0, t.length - 1), source.charCodeAt(index$1) !== 117 && throwError({}, MessageUnexpectedToken, ILLEGAL), ++index$1, n = scanHexEscape("u"), (!n || n === "\\" || !isIdentifierPart(n.charCodeAt(0))) && throwError({}, MessageUnexpectedToken, ILLEGAL), t += n);
  return t;
}
function getIdentifier() {
  var n, t;
  for (n = index$1++; index$1 < length; ) {
    if (t = source.charCodeAt(index$1), t === 92)
      return index$1 = n, getEscapedIdentifier();
    if (isIdentifierPart(t))
      ++index$1;
    else
      break;
  }
  return source.slice(n, index$1);
}
function scanIdentifier() {
  var n, t, g;
  return n = index$1, t = source.charCodeAt(index$1) === 92 ? getEscapedIdentifier() : getIdentifier(), t.length === 1 ? g = TokenIdentifier : keywords.hasOwnProperty(t) ? g = TokenKeyword : t === "null" ? g = TokenNullLiteral : t === "true" || t === "false" ? g = TokenBooleanLiteral : g = TokenIdentifier, {
    type: g,
    value: t,
    start: n,
    end: index$1
  };
}
function scanPunctuator() {
  var n = index$1, t = source.charCodeAt(index$1), g, d = source[index$1], k, H, AA;
  switch (t) {
    // Check for most common single-character punctuators.
    case 46:
    // . dot
    case 40:
    // ( open bracket
    case 41:
    // ) close bracket
    case 59:
    // ; semicolon
    case 44:
    // , comma
    case 123:
    // { open curly brace
    case 125:
    // } close curly brace
    case 91:
    // [
    case 93:
    // ]
    case 58:
    // :
    case 63:
    // ?
    case 126:
      return ++index$1, {
        type: TokenPunctuator,
        value: String.fromCharCode(t),
        start: n,
        end: index$1
      };
    default:
      if (g = source.charCodeAt(index$1 + 1), g === 61)
        switch (t) {
          case 43:
          // +
          case 45:
          // -
          case 47:
          // /
          case 60:
          // <
          case 62:
          // >
          case 94:
          // ^
          case 124:
          // |
          case 37:
          // %
          case 38:
          // &
          case 42:
            return index$1 += 2, {
              type: TokenPunctuator,
              value: String.fromCharCode(t) + String.fromCharCode(g),
              start: n,
              end: index$1
            };
          case 33:
          // !
          case 61:
            return index$1 += 2, source.charCodeAt(index$1) === 61 && ++index$1, {
              type: TokenPunctuator,
              value: source.slice(n, index$1),
              start: n,
              end: index$1
            };
        }
  }
  if (AA = source.substr(index$1, 4), AA === ">>>=")
    return index$1 += 4, {
      type: TokenPunctuator,
      value: AA,
      start: n,
      end: index$1
    };
  if (H = AA.substr(0, 3), H === ">>>" || H === "<<=" || H === ">>=")
    return index$1 += 3, {
      type: TokenPunctuator,
      value: H,
      start: n,
      end: index$1
    };
  if (k = H.substr(0, 2), d === k[1] && "+-<>&|".includes(d) || k === "=>")
    return index$1 += 2, {
      type: TokenPunctuator,
      value: k,
      start: n,
      end: index$1
    };
  if (k === "//" && throwError({}, MessageUnexpectedToken, ILLEGAL), "<>=!+-*%&|^/".includes(d))
    return ++index$1, {
      type: TokenPunctuator,
      value: d,
      start: n,
      end: index$1
    };
  throwError({}, MessageUnexpectedToken, ILLEGAL);
}
function scanHexLiteral(n) {
  let t = "";
  for (; index$1 < length && isHexDigit(source[index$1]); )
    t += source[index$1++];
  return t.length === 0 && throwError({}, MessageUnexpectedToken, ILLEGAL), isIdentifierStart(source.charCodeAt(index$1)) && throwError({}, MessageUnexpectedToken, ILLEGAL), {
    type: TokenNumericLiteral,
    value: parseInt("0x" + t, 16),
    start: n,
    end: index$1
  };
}
function scanOctalLiteral(n) {
  let t = "0" + source[index$1++];
  for (; index$1 < length && isOctalDigit(source[index$1]); )
    t += source[index$1++];
  return (isIdentifierStart(source.charCodeAt(index$1)) || isDecimalDigit(source.charCodeAt(index$1))) && throwError({}, MessageUnexpectedToken, ILLEGAL), {
    type: TokenNumericLiteral,
    value: parseInt(t, 8),
    octal: !0,
    start: n,
    end: index$1
  };
}
function scanNumericLiteral() {
  var n, t, g;
  if (g = source[index$1], assert(isDecimalDigit(g.charCodeAt(0)) || g === ".", "Numeric literal must start with a decimal digit or a decimal point"), t = index$1, n = "", g !== ".") {
    if (n = source[index$1++], g = source[index$1], n === "0") {
      if (g === "x" || g === "X")
        return ++index$1, scanHexLiteral(t);
      if (isOctalDigit(g))
        return scanOctalLiteral(t);
      g && isDecimalDigit(g.charCodeAt(0)) && throwError({}, MessageUnexpectedToken, ILLEGAL);
    }
    for (; isDecimalDigit(source.charCodeAt(index$1)); )
      n += source[index$1++];
    g = source[index$1];
  }
  if (g === ".") {
    for (n += source[index$1++]; isDecimalDigit(source.charCodeAt(index$1)); )
      n += source[index$1++];
    g = source[index$1];
  }
  if (g === "e" || g === "E")
    if (n += source[index$1++], g = source[index$1], (g === "+" || g === "-") && (n += source[index$1++]), isDecimalDigit(source.charCodeAt(index$1)))
      for (; isDecimalDigit(source.charCodeAt(index$1)); )
        n += source[index$1++];
    else
      throwError({}, MessageUnexpectedToken, ILLEGAL);
  return isIdentifierStart(source.charCodeAt(index$1)) && throwError({}, MessageUnexpectedToken, ILLEGAL), {
    type: TokenNumericLiteral,
    value: parseFloat(n),
    start: t,
    end: index$1
  };
}
function scanStringLiteral() {
  var n = "", t, g, d, k, H = !1;
  for (t = source[index$1], assert(t === "'" || t === '"', "String literal must starts with a quote"), g = index$1, ++index$1; index$1 < length; )
    if (d = source[index$1++], d === t) {
      t = "";
      break;
    } else if (d === "\\")
      if (d = source[index$1++], !d || !isLineTerminator(d.charCodeAt(0)))
        switch (d) {
          case "u":
          case "x":
            source[index$1] === "{" ? (++index$1, n += scanUnicodeCodePointEscape()) : n += scanHexEscape(d);
            break;
          case "n":
            n += `
`;
            break;
          case "r":
            n += "\r";
            break;
          case "t":
            n += "	";
            break;
          case "b":
            n += "\b";
            break;
          case "f":
            n += "\f";
            break;
          case "v":
            n += "\v";
            break;
          default:
            isOctalDigit(d) ? (k = "01234567".indexOf(d), k !== 0 && (H = !0), index$1 < length && isOctalDigit(source[index$1]) && (H = !0, k = k * 8 + "01234567".indexOf(source[index$1++]), "0123".includes(d) && index$1 < length && isOctalDigit(source[index$1]) && (k = k * 8 + "01234567".indexOf(source[index$1++]))), n += String.fromCharCode(k)) : n += d;
            break;
        }
      else
        d === "\r" && source[index$1] === `
` && ++index$1;
    else {
      if (isLineTerminator(d.charCodeAt(0)))
        break;
      n += d;
    }
  return t !== "" && throwError({}, MessageUnexpectedToken, ILLEGAL), {
    type: TokenStringLiteral,
    value: n,
    octal: H,
    start: g,
    end: index$1
  };
}
function testRegExp(n, t) {
  let g = n;
  t.includes("u") && (g = g.replace(/\\u\{([0-9a-fA-F]+)\}/g, (d, k) => {
    if (parseInt(k, 16) <= 1114111)
      return "x";
    throwError({}, MessageInvalidRegExp);
  }).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "x"));
  try {
    new RegExp(g);
  } catch {
    throwError({}, MessageInvalidRegExp);
  }
  try {
    return new RegExp(n, t);
  } catch {
    return null;
  }
}
function scanRegExpBody() {
  var n, t, g, d, k;
  for (n = source[index$1], assert(n === "/", "Regular expression literal must start with a slash"), t = source[index$1++], g = !1, d = !1; index$1 < length; )
    if (n = source[index$1++], t += n, n === "\\")
      n = source[index$1++], isLineTerminator(n.charCodeAt(0)) && throwError({}, MessageUnterminatedRegExp), t += n;
    else if (isLineTerminator(n.charCodeAt(0)))
      throwError({}, MessageUnterminatedRegExp);
    else if (g)
      n === "]" && (g = !1);
    else if (n === "/") {
      d = !0;
      break;
    } else n === "[" && (g = !0);
  return d || throwError({}, MessageUnterminatedRegExp), k = t.substr(1, t.length - 2), {
    value: k,
    literal: t
  };
}
function scanRegExpFlags() {
  var n, t, g;
  for (t = "", g = ""; index$1 < length && (n = source[index$1], !!isIdentifierPart(n.charCodeAt(0))); )
    ++index$1, n === "\\" && index$1 < length ? throwError({}, MessageUnexpectedToken, ILLEGAL) : (g += n, t += n);
  return g.search(/[^gimuy]/g) >= 0 && throwError({}, MessageInvalidRegExp, g), {
    value: g,
    literal: t
  };
}
function scanRegExp() {
  var n, t, g, d;
  return lookahead = null, skipComment(), n = index$1, t = scanRegExpBody(), g = scanRegExpFlags(), d = testRegExp(t.value, g.value), {
    literal: t.literal + g.literal,
    value: d,
    regex: {
      pattern: t.value,
      flags: g.value
    },
    start: n,
    end: index$1
  };
}
function isIdentifierName(n) {
  return n.type === TokenIdentifier || n.type === TokenKeyword || n.type === TokenBooleanLiteral || n.type === TokenNullLiteral;
}
function advance() {
  if (skipComment(), index$1 >= length)
    return {
      type: TokenEOF,
      start: index$1,
      end: index$1
    };
  const n = source.charCodeAt(index$1);
  return isIdentifierStart(n) ? scanIdentifier() : n === 40 || n === 41 || n === 59 ? scanPunctuator() : n === 39 || n === 34 ? scanStringLiteral() : n === 46 ? isDecimalDigit(source.charCodeAt(index$1 + 1)) ? scanNumericLiteral() : scanPunctuator() : isDecimalDigit(n) ? scanNumericLiteral() : scanPunctuator();
}
function lex() {
  const n = lookahead;
  return index$1 = n.end, lookahead = advance(), index$1 = n.end, n;
}
function peek() {
  const n = index$1;
  lookahead = advance(), index$1 = n;
}
function finishArrayExpression(n) {
  const t = new ASTNode(SyntaxArrayExpression);
  return t.elements = n, t;
}
function finishBinaryExpression(n, t, g) {
  const d = new ASTNode(n === "||" || n === "&&" ? SyntaxLogicalExpression : SyntaxBinaryExpression);
  return d.operator = n, d.left = t, d.right = g, d;
}
function finishCallExpression(n, t) {
  const g = new ASTNode(SyntaxCallExpression);
  return g.callee = n, g.arguments = t, g;
}
function finishConditionalExpression(n, t, g) {
  const d = new ASTNode(SyntaxConditionalExpression);
  return d.test = n, d.consequent = t, d.alternate = g, d;
}
function finishIdentifier(n) {
  const t = new ASTNode(SyntaxIdentifier);
  return t.name = n, t;
}
function finishLiteral(n) {
  const t = new ASTNode(SyntaxLiteral);
  return t.value = n.value, t.raw = source.slice(n.start, n.end), n.regex && (t.raw === "//" && (t.raw = "/(?:)/"), t.regex = n.regex), t;
}
function finishMemberExpression(n, t, g) {
  const d = new ASTNode(SyntaxMemberExpression);
  return d.computed = n === "[", d.object = t, d.property = g, d.computed || (g.member = !0), d;
}
function finishObjectExpression(n) {
  const t = new ASTNode(SyntaxObjectExpression);
  return t.properties = n, t;
}
function finishProperty(n, t, g) {
  const d = new ASTNode(SyntaxProperty);
  return d.key = t, d.value = g, d.kind = n, d;
}
function finishUnaryExpression(n, t) {
  const g = new ASTNode(SyntaxUnaryExpression);
  return g.operator = n, g.argument = t, g.prefix = !0, g;
}
function throwError(n, t) {
  var g, d = Array.prototype.slice.call(arguments, 2), k = t.replace(/%(\d)/g, (H, AA) => (assert(AA < d.length, "Message reference must be in range"), d[AA]));
  throw g = new Error(k), g.index = index$1, g.description = k, g;
}
function throwUnexpected(n) {
  n.type === TokenEOF && throwError(n, MessageUnexpectedEOS), n.type === TokenNumericLiteral && throwError(n, MessageUnexpectedNumber), n.type === TokenStringLiteral && throwError(n, MessageUnexpectedString), n.type === TokenIdentifier && throwError(n, MessageUnexpectedIdentifier), n.type === TokenKeyword && throwError(n, MessageUnexpectedReserved), throwError(n, MessageUnexpectedToken, n.value);
}
function expect(n) {
  const t = lex();
  (t.type !== TokenPunctuator || t.value !== n) && throwUnexpected(t);
}
function match(n) {
  return lookahead.type === TokenPunctuator && lookahead.value === n;
}
function matchKeyword(n) {
  return lookahead.type === TokenKeyword && lookahead.value === n;
}
function parseArrayInitialiser() {
  const n = [];
  for (index$1 = lookahead.start, expect("["); !match("]"); )
    match(",") ? (lex(), n.push(null)) : (n.push(parseConditionalExpression()), match("]") || expect(","));
  return lex(), finishArrayExpression(n);
}
function parseObjectPropertyKey() {
  index$1 = lookahead.start;
  const n = lex();
  return n.type === TokenStringLiteral || n.type === TokenNumericLiteral ? (n.octal && throwError(n, MessageStrictOctalLiteral), finishLiteral(n)) : finishIdentifier(n.value);
}
function parseObjectProperty() {
  var n, t, g, d;
  if (index$1 = lookahead.start, n = lookahead, n.type === TokenIdentifier)
    return g = parseObjectPropertyKey(), expect(":"), d = parseConditionalExpression(), finishProperty("init", g, d);
  if (n.type === TokenEOF || n.type === TokenPunctuator)
    throwUnexpected(n);
  else
    return t = parseObjectPropertyKey(), expect(":"), d = parseConditionalExpression(), finishProperty("init", t, d);
}
function parseObjectInitialiser() {
  var n = [], t, g, d, k = {}, H = String;
  for (index$1 = lookahead.start, expect("{"); !match("}"); )
    t = parseObjectProperty(), t.key.type === SyntaxIdentifier ? g = t.key.name : g = H(t.key.value), d = "$" + g, Object.prototype.hasOwnProperty.call(k, d) ? throwError({}, MessageStrictDuplicateProperty) : k[d] = !0, n.push(t), match("}") || expect(",");
  return expect("}"), finishObjectExpression(n);
}
function parseGroupExpression() {
  expect("(");
  const n = parseExpression$1();
  return expect(")"), n;
}
const legalKeywords = {
  if: 1
};
function parsePrimaryExpression() {
  var n, t, g;
  if (match("("))
    return parseGroupExpression();
  if (match("["))
    return parseArrayInitialiser();
  if (match("{"))
    return parseObjectInitialiser();
  if (n = lookahead.type, index$1 = lookahead.start, n === TokenIdentifier || legalKeywords[lookahead.value])
    g = finishIdentifier(lex().value);
  else if (n === TokenStringLiteral || n === TokenNumericLiteral)
    lookahead.octal && throwError(lookahead, MessageStrictOctalLiteral), g = finishLiteral(lex());
  else {
    if (n === TokenKeyword)
      throw new Error(DISABLED);
    n === TokenBooleanLiteral ? (t = lex(), t.value = t.value === "true", g = finishLiteral(t)) : n === TokenNullLiteral ? (t = lex(), t.value = null, g = finishLiteral(t)) : match("/") || match("/=") ? (g = finishLiteral(scanRegExp()), peek()) : throwUnexpected(lex());
  }
  return g;
}
function parseArguments() {
  const n = [];
  if (expect("("), !match(")"))
    for (; index$1 < length && (n.push(parseConditionalExpression()), !match(")")); )
      expect(",");
  return expect(")"), n;
}
function parseNonComputedProperty() {
  index$1 = lookahead.start;
  const n = lex();
  return isIdentifierName(n) || throwUnexpected(n), finishIdentifier(n.value);
}
function parseNonComputedMember() {
  return expect("."), parseNonComputedProperty();
}
function parseComputedMember() {
  expect("[");
  const n = parseExpression$1();
  return expect("]"), n;
}
function parseLeftHandSideExpressionAllowCall() {
  var n, t, g;
  for (n = parsePrimaryExpression(); ; )
    if (match("."))
      g = parseNonComputedMember(), n = finishMemberExpression(".", n, g);
    else if (match("("))
      t = parseArguments(), n = finishCallExpression(n, t);
    else if (match("["))
      g = parseComputedMember(), n = finishMemberExpression("[", n, g);
    else
      break;
  return n;
}
function parsePostfixExpression() {
  const n = parseLeftHandSideExpressionAllowCall();
  if (lookahead.type === TokenPunctuator && (match("++") || match("--")))
    throw new Error(DISABLED);
  return n;
}
function parseUnaryExpression() {
  var n, t;
  if (lookahead.type !== TokenPunctuator && lookahead.type !== TokenKeyword)
    t = parsePostfixExpression();
  else {
    if (match("++") || match("--"))
      throw new Error(DISABLED);
    if (match("+") || match("-") || match("~") || match("!"))
      n = lex(), t = parseUnaryExpression(), t = finishUnaryExpression(n.value, t);
    else {
      if (matchKeyword("delete") || matchKeyword("void") || matchKeyword("typeof"))
        throw new Error(DISABLED);
      t = parsePostfixExpression();
    }
  }
  return t;
}
function binaryPrecedence(n) {
  let t = 0;
  if (n.type !== TokenPunctuator && n.type !== TokenKeyword)
    return 0;
  switch (n.value) {
    case "||":
      t = 1;
      break;
    case "&&":
      t = 2;
      break;
    case "|":
      t = 3;
      break;
    case "^":
      t = 4;
      break;
    case "&":
      t = 5;
      break;
    case "==":
    case "!=":
    case "===":
    case "!==":
      t = 6;
      break;
    case "<":
    case ">":
    case "<=":
    case ">=":
    case "instanceof":
    case "in":
      t = 7;
      break;
    case "<<":
    case ">>":
    case ">>>":
      t = 8;
      break;
    case "+":
    case "-":
      t = 9;
      break;
    case "*":
    case "/":
    case "%":
      t = 11;
      break;
  }
  return t;
}
function parseBinaryExpression() {
  var n, t, g, d, k, H, AA, gA, IA, CA;
  if (n = lookahead, IA = parseUnaryExpression(), d = lookahead, k = binaryPrecedence(d), k === 0)
    return IA;
  for (d.prec = k, lex(), t = [n, lookahead], AA = parseUnaryExpression(), H = [IA, d, AA]; (k = binaryPrecedence(lookahead)) > 0; ) {
    for (; H.length > 2 && k <= H[H.length - 2].prec; )
      AA = H.pop(), gA = H.pop().value, IA = H.pop(), t.pop(), g = finishBinaryExpression(gA, IA, AA), H.push(g);
    d = lex(), d.prec = k, H.push(d), t.push(lookahead), g = parseUnaryExpression(), H.push(g);
  }
  for (CA = H.length - 1, g = H[CA], t.pop(); CA > 1; )
    t.pop(), g = finishBinaryExpression(H[CA - 1].value, H[CA - 2], g), CA -= 2;
  return g;
}
function parseConditionalExpression() {
  var n, t, g;
  return n = parseBinaryExpression(), match("?") && (lex(), t = parseConditionalExpression(), expect(":"), g = parseConditionalExpression(), n = finishConditionalExpression(n, t, g)), n;
}
function parseExpression$1() {
  const n = parseConditionalExpression();
  if (match(","))
    throw new Error(DISABLED);
  return n;
}
function parser$1(n) {
  source = n, index$1 = 0, length = source.length, lookahead = null, peek();
  const t = parseExpression$1();
  if (lookahead.type !== TokenEOF)
    throw new Error("Unexpect token after expression.");
  return t;
}
var version$1$1 = "6.3.1", pkg$1 = {
  version: version$1$1
};
function isLogicalOr(n) {
  return hasProperty(n, "or");
}
function isLogicalAnd(n) {
  return hasProperty(n, "and");
}
function isLogicalNot(n) {
  return hasProperty(n, "not");
}
function forEachLeaf(n, t) {
  if (isLogicalNot(n))
    forEachLeaf(n.not, t);
  else if (isLogicalAnd(n))
    for (const g of n.and)
      forEachLeaf(g, t);
  else if (isLogicalOr(n))
    for (const g of n.or)
      forEachLeaf(g, t);
  else
    t(n);
}
function normalizeLogicalComposition(n, t) {
  return isLogicalNot(n) ? { not: normalizeLogicalComposition(n.not, t) } : isLogicalAnd(n) ? { and: n.and.map((g) => normalizeLogicalComposition(g, t)) } : isLogicalOr(n) ? { or: n.or.map((g) => normalizeLogicalComposition(g, t)) } : t(n);
}
const duplicate = structuredClone;
function never(n) {
  throw new Error(n);
}
function pick$2(n, t) {
  const g = {};
  for (const d of t)
    has(n, d) && (g[d] = n[d]);
  return g;
}
function omit(n, t) {
  const g = { ...n };
  for (const d of t)
    delete g[d];
  return g;
}
Set.prototype.toJSON = function() {
  return `Set(${[...this].map((n) => stringify$1(n)).join(",")})`;
};
function hash(n) {
  if (isNumber$1(n))
    return n;
  const t = isString$1(n) ? n : stringify$1(n);
  if (t.length < 250)
    return t;
  let g = 0;
  for (let d = 0; d < t.length; d++) {
    const k = t.charCodeAt(d);
    g = (g << 5) - g + k, g = g & g;
  }
  return g;
}
function isNullOrFalse(n) {
  return n === !1 || n === null;
}
function contains(n, t) {
  return n.includes(t);
}
function some(n, t) {
  let g = 0;
  for (const [d, k] of n.entries())
    if (t(k, d, g++))
      return !0;
  return !1;
}
function every(n, t) {
  let g = 0;
  for (const [d, k] of n.entries())
    if (!t(k, d, g++))
      return !1;
  return !0;
}
function mergeDeep$1(n, ...t) {
  for (const g of t)
    deepMerge_$1(n, g ?? {});
  return n;
}
function deepMerge_$1(n, t) {
  for (const g of keys$1(t))
    writeConfig(n, g, t[g], !0);
}
function unique(n, t) {
  const g = [], d = {};
  let k;
  for (const H of n)
    k = t(H), !(k in d) && (d[k] = 1, g.push(H));
  return g;
}
function isEqual$2(n, t) {
  const g = keys$1(n), d = keys$1(t);
  if (g.length !== d.length)
    return !1;
  for (const k of g)
    if (n[k] !== t[k])
      return !1;
  return !0;
}
function setEqual(n, t) {
  if (n.size !== t.size)
    return !1;
  for (const g of n)
    if (!t.has(g))
      return !1;
  return !0;
}
function hasIntersection(n, t) {
  for (const g of n)
    if (t.has(g))
      return !0;
  return !1;
}
function prefixGenerator(n) {
  const t = /* @__PURE__ */ new Set();
  for (const g of n) {
    const k = splitAccessPath$1(g).map((AA, gA) => gA === 0 ? AA : `[${AA}]`), H = k.map((AA, gA) => k.slice(0, gA + 1).join(""));
    for (const AA of H)
      t.add(AA);
  }
  return t;
}
function fieldIntersection(n, t) {
  return n === void 0 || t === void 0 ? !0 : hasIntersection(prefixGenerator(n), prefixGenerator(t));
}
function isEmpty(n) {
  return keys$1(n).length === 0;
}
const keys$1 = Object.keys, vals = Object.values, entries$1 = Object.entries;
function isBoolean$1(n) {
  return n === !0 || n === !1;
}
function varName(n) {
  const t = n.replace(/\W/g, "_");
  return (n.match(/^\d+/) ? "_" : "") + t;
}
function logicalExpr(n, t) {
  return isLogicalNot(n) ? `!(${logicalExpr(n.not, t)})` : isLogicalAnd(n) ? `(${n.and.map((g) => logicalExpr(g, t)).join(") && (")})` : isLogicalOr(n) ? `(${n.or.map((g) => logicalExpr(g, t)).join(") || (")})` : t(n);
}
function deleteNestedProperty(n, t) {
  if (t.length === 0)
    return !0;
  const g = t.shift();
  return g in n && deleteNestedProperty(n[g], t) && delete n[g], isEmpty(n);
}
function titleCase(n) {
  return n.charAt(0).toUpperCase() + n.substr(1);
}
function accessPathWithDatum(n, t = "datum") {
  const g = splitAccessPath$1(n), d = [];
  for (let k = 1; k <= g.length; k++) {
    const H = `[${g.slice(0, k).map($$1).join("][")}]`;
    d.push(`${t}${H}`);
  }
  return d.join(" && ");
}
function flatAccessWithDatum(n, t = "datum") {
  return `${t}[${$$1(splitAccessPath$1(n).join("."))}]`;
}
function accessWithDatumToUnescapedPath(n) {
  return `datum['${n.replaceAll("'", "\\'")}']`;
}
function unescapeSingleQuoteAndPathDot(n) {
  return n.replaceAll("\\'", "'").replaceAll("\\.", ".");
}
function escapePathAccess(n) {
  return n.replace(/(\[|\]|\.|'|")/g, "\\$1");
}
function replacePathInField(n) {
  return `${splitAccessPath$1(n).map(escapePathAccess).join("\\.")}`;
}
function replaceAll(n, t, g) {
  return n.replace(new RegExp(t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "g"), g);
}
function removePathFromField(n) {
  return `${splitAccessPath$1(n).join(".")}`;
}
function accessPathDepth(n) {
  return n ? splitAccessPath$1(n).length : 0;
}
function getFirstDefined(...n) {
  return n.find((t) => t !== void 0);
}
let idCounter$1 = 42;
function uniqueId(n) {
  const t = ++idCounter$1;
  return n ? String(n) + t : t;
}
function resetIdCounter() {
  idCounter$1 = 42;
}
function internalField(n) {
  return isInternalField(n) ? n : `__${n}`;
}
function isInternalField(n) {
  return n.startsWith("__");
}
function normalizeAngle(n) {
  if (n !== void 0)
    return (n % 360 + 360) % 360;
}
function isNumeric(n) {
  return isNumber$1(n) ? !0 : !isNaN(n) && !isNaN(parseFloat(n));
}
const clonedProto = Object.getPrototypeOf(structuredClone({}));
function deepEqual(n, t) {
  if (n === t)
    return !0;
  if (n && t && typeof n == "object" && typeof t == "object") {
    if (n.constructor.name !== t.constructor.name)
      return !1;
    let g, d;
    if (Array.isArray(n)) {
      if (g = n.length, g != t.length)
        return !1;
      for (d = g; d-- !== 0; )
        if (!deepEqual(n[d], t[d]))
          return !1;
      return !0;
    }
    if (n instanceof Map && t instanceof Map) {
      if (n.size !== t.size)
        return !1;
      for (const H of n.entries())
        if (!t.has(H[0]))
          return !1;
      for (const H of n.entries())
        if (!deepEqual(H[1], t.get(H[0])))
          return !1;
      return !0;
    }
    if (n instanceof Set && t instanceof Set) {
      if (n.size !== t.size)
        return !1;
      for (const H of n.entries())
        if (!t.has(H[0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(n) && ArrayBuffer.isView(t)) {
      if (g = n.length, g != t.length)
        return !1;
      for (d = g; d-- !== 0; )
        if (n[d] !== t[d])
          return !1;
      return !0;
    }
    if (n.constructor === RegExp)
      return n.source === t.source && n.flags === t.flags;
    if (n.valueOf !== Object.prototype.valueOf && n.valueOf !== clonedProto.valueOf)
      return n.valueOf() === t.valueOf();
    if (n.toString !== Object.prototype.toString && n.toString !== clonedProto.toString)
      return n.toString() === t.toString();
    const k = Object.keys(n);
    if (g = k.length, g !== Object.keys(t).length)
      return !1;
    for (d = g; d-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, k[d]))
        return !1;
    for (d = g; d-- !== 0; ) {
      const H = k[d];
      if (!deepEqual(n[H], t[H]))
        return !1;
    }
    return !0;
  }
  return n !== n && t !== t;
}
function stringify$1(n) {
  const t = [];
  return (function g(d) {
    if (d?.toJSON && typeof d.toJSON == "function" && (d = d.toJSON()), d === void 0)
      return;
    if (typeof d == "number")
      return isFinite(d) ? `${d}` : "null";
    if (typeof d != "object")
      return JSON.stringify(d);
    let k, H;
    if (Array.isArray(d)) {
      for (H = "[", k = 0; k < d.length; k++)
        k && (H += ","), H += g(d[k]) || "null";
      return `${H}]`;
    }
    if (d === null)
      return "null";
    if (t.includes(d))
      throw new TypeError("Converting circular structure to JSON");
    const AA = t.push(d) - 1, gA = Object.keys(d).sort();
    for (H = "", k = 0; k < gA.length; k++) {
      const IA = gA[k], CA = g(d[IA]);
      CA && (H && (H += ","), H += `${JSON.stringify(IA)}:${CA}`);
    }
    return t.splice(AA, 1), `{${H}}`;
  })(n);
}
function hasProperty(n, t) {
  return isObject$3(n) && has(n, t) && n[t] !== void 0;
}
const ROW = "row", COLUMN = "column", FACET = "facet", X$1 = "x", Y = "y", X2 = "x2", Y2 = "y2", XOFFSET = "xOffset", YOFFSET = "yOffset", RADIUS = "radius", RADIUS2 = "radius2", THETA = "theta", THETA2 = "theta2", LATITUDE = "latitude", LONGITUDE = "longitude", LATITUDE2 = "latitude2", LONGITUDE2 = "longitude2", TIME = "time", COLOR = "color", FILL = "fill", STROKE = "stroke", SHAPE = "shape", SIZE$2 = "size", ANGLE = "angle", OPACITY = "opacity", FILLOPACITY = "fillOpacity", STROKEOPACITY = "strokeOpacity", STROKEWIDTH = "strokeWidth", STROKEDASH = "strokeDash", TEXT$1 = "text", ORDER = "order", DETAIL = "detail", KEY = "key", TOOLTIP = "tooltip", HREF = "href", URL$1 = "url", DESCRIPTION = "description", POSITION_CHANNEL_INDEX = {
  x: 1,
  y: 1,
  x2: 1,
  y2: 1
}, POLAR_POSITION_CHANNEL_INDEX = {
  theta: 1,
  theta2: 1,
  radius: 1,
  radius2: 1
};
function isPolarPositionChannel(n) {
  return has(POLAR_POSITION_CHANNEL_INDEX, n);
}
const GEO_POSIITON_CHANNEL_INDEX = {
  longitude: 1,
  longitude2: 1,
  latitude: 1,
  latitude2: 1
};
function getPositionChannelFromLatLong(n) {
  switch (n) {
    case LATITUDE:
      return "y";
    case LATITUDE2:
      return "y2";
    case LONGITUDE:
      return "x";
    case LONGITUDE2:
      return "x2";
  }
}
function isGeoPositionChannel(n) {
  return has(GEO_POSIITON_CHANNEL_INDEX, n);
}
const GEOPOSITION_CHANNELS = keys$1(GEO_POSIITON_CHANNEL_INDEX), UNIT_CHANNEL_INDEX = {
  ...POSITION_CHANNEL_INDEX,
  ...POLAR_POSITION_CHANNEL_INDEX,
  ...GEO_POSIITON_CHANNEL_INDEX,
  xOffset: 1,
  yOffset: 1,
  // color
  color: 1,
  fill: 1,
  stroke: 1,
  // time
  time: 1,
  // other non-position with scale
  opacity: 1,
  fillOpacity: 1,
  strokeOpacity: 1,
  strokeWidth: 1,
  strokeDash: 1,
  size: 1,
  angle: 1,
  shape: 1,
  // channels without scales
  order: 1,
  text: 1,
  detail: 1,
  key: 1,
  tooltip: 1,
  href: 1,
  url: 1,
  description: 1
};
function isColorChannel(n) {
  return n === COLOR || n === FILL || n === STROKE;
}
const FACET_CHANNEL_INDEX = {
  row: 1,
  column: 1,
  facet: 1
}, FACET_CHANNELS = keys$1(FACET_CHANNEL_INDEX), CHANNEL_INDEX = {
  ...UNIT_CHANNEL_INDEX,
  ...FACET_CHANNEL_INDEX
}, CHANNELS = keys$1(CHANNEL_INDEX), { order: _o$1, detail: _d, tooltip: _tt1, ...SINGLE_DEF_CHANNEL_INDEX } = CHANNEL_INDEX, { row: _r, column: _c, facet: _f, ...SINGLE_DEF_UNIT_CHANNEL_INDEX } = SINGLE_DEF_CHANNEL_INDEX;
function isSingleDefUnitChannel(n) {
  return has(SINGLE_DEF_UNIT_CHANNEL_INDEX, n);
}
function isChannel(n) {
  return has(CHANNEL_INDEX, n);
}
const SECONDARY_RANGE_CHANNEL = [X2, Y2, LATITUDE2, LONGITUDE2, THETA2, RADIUS2];
function isSecondaryRangeChannel(n) {
  return getMainRangeChannel(n) !== n;
}
function getMainRangeChannel(n) {
  switch (n) {
    case X2:
      return X$1;
    case Y2:
      return Y;
    case LATITUDE2:
      return LATITUDE;
    case LONGITUDE2:
      return LONGITUDE;
    case THETA2:
      return THETA;
    case RADIUS2:
      return RADIUS;
  }
  return n;
}
function getVgPositionChannel(n) {
  if (isPolarPositionChannel(n))
    switch (n) {
      case THETA:
        return "startAngle";
      case THETA2:
        return "endAngle";
      case RADIUS:
        return "outerRadius";
      case RADIUS2:
        return "innerRadius";
    }
  return n;
}
function getSecondaryRangeChannel(n) {
  switch (n) {
    case X$1:
      return X2;
    case Y:
      return Y2;
    case LATITUDE:
      return LATITUDE2;
    case LONGITUDE:
      return LONGITUDE2;
    case THETA:
      return THETA2;
    case RADIUS:
      return RADIUS2;
  }
}
function getSizeChannel(n) {
  switch (n) {
    case X$1:
    case X2:
      return "width";
    case Y:
    case Y2:
      return "height";
  }
}
function getOffsetChannel(n) {
  switch (n) {
    case X$1:
      return "xOffset";
    case Y:
      return "yOffset";
    case X2:
      return "x2Offset";
    case Y2:
      return "y2Offset";
    case THETA:
      return "thetaOffset";
    case RADIUS:
      return "radiusOffset";
    case THETA2:
      return "theta2Offset";
    case RADIUS2:
      return "radius2Offset";
  }
}
function getOffsetScaleChannel(n) {
  switch (n) {
    case X$1:
      return "xOffset";
    case Y:
      return "yOffset";
  }
}
function getMainChannelFromOffsetChannel(n) {
  switch (n) {
    case "xOffset":
      return "x";
    case "yOffset":
      return "y";
  }
}
const UNIT_CHANNELS = keys$1(UNIT_CHANNEL_INDEX), {
  x: _x,
  y: _y,
  // x2 and y2 share the same scale as x and y
  x2: _x2,
  y2: _y2,
  //
  xOffset: _xo,
  yOffset: _yo,
  latitude: _latitude,
  longitude: _longitude,
  latitude2: _latitude2,
  longitude2: _longitude2,
  theta: _theta,
  theta2: _theta2,
  radius: _radius,
  radius2: _radius2,
  // The rest of unit channels then have scale
  ...NONPOSITION_CHANNEL_INDEX
} = UNIT_CHANNEL_INDEX, NONPOSITION_CHANNELS = keys$1(NONPOSITION_CHANNEL_INDEX), POSITION_SCALE_CHANNEL_INDEX = {
  x: 1,
  y: 1
}, POSITION_SCALE_CHANNELS = keys$1(POSITION_SCALE_CHANNEL_INDEX);
function isXorY(n) {
  return has(POSITION_SCALE_CHANNEL_INDEX, n);
}
const POLAR_POSITION_SCALE_CHANNEL_INDEX = {
  theta: 1,
  radius: 1
}, POLAR_POSITION_SCALE_CHANNELS = keys$1(POLAR_POSITION_SCALE_CHANNEL_INDEX);
function getPositionScaleChannel(n) {
  return n === "width" ? X$1 : Y;
}
const OFFSET_SCALE_CHANNEL_INDEX = { xOffset: 1, yOffset: 1 };
function isXorYOffset(n) {
  return has(OFFSET_SCALE_CHANNEL_INDEX, n);
}
const TIME_SCALE_CHANNEL_INDEX = {
  time: 1
};
function isTime(n) {
  return n in TIME_SCALE_CHANNEL_INDEX;
}
const {
  // x2 and y2 share the same scale as x and y
  // text and tooltip have format instead of scale,
  // href has neither format, nor scale
  text: _t$1,
  tooltip: _tt,
  href: _hr,
  url: _u,
  description: _al,
  // detail and order have no scale
  detail: _dd,
  key: _k,
  order: _oo,
  ...NONPOSITION_SCALE_CHANNEL_INDEX
} = NONPOSITION_CHANNEL_INDEX, NONPOSITION_SCALE_CHANNELS = keys$1(NONPOSITION_SCALE_CHANNEL_INDEX);
function isNonPositionScaleChannel(n) {
  return has(NONPOSITION_CHANNEL_INDEX, n);
}
function supportLegend(n) {
  switch (n) {
    case COLOR:
    case FILL:
    case STROKE:
    case SIZE$2:
    case SHAPE:
    case OPACITY:
    case STROKEWIDTH:
    case STROKEDASH:
      return !0;
    case FILLOPACITY:
    case STROKEOPACITY:
    case ANGLE:
    case TIME:
      return !1;
  }
}
const SCALE_CHANNEL_INDEX = {
  ...POSITION_SCALE_CHANNEL_INDEX,
  ...POLAR_POSITION_SCALE_CHANNEL_INDEX,
  ...OFFSET_SCALE_CHANNEL_INDEX,
  ...NONPOSITION_SCALE_CHANNEL_INDEX
}, SCALE_CHANNELS = keys$1(SCALE_CHANNEL_INDEX);
function isScaleChannel(n) {
  return has(SCALE_CHANNEL_INDEX, n);
}
function supportMark(n, t) {
  return getSupportedMark(n)[t];
}
const ALL_MARKS = {
  // all marks
  arc: "always",
  area: "always",
  bar: "always",
  circle: "always",
  geoshape: "always",
  image: "always",
  line: "always",
  rule: "always",
  point: "always",
  rect: "always",
  square: "always",
  trail: "always",
  text: "always",
  tick: "always"
}, { geoshape: _g, ...ALL_MARKS_EXCEPT_GEOSHAPE } = ALL_MARKS;
function getSupportedMark(n) {
  switch (n) {
    case COLOR:
    case FILL:
    case STROKE:
    // falls through
    case DESCRIPTION:
    case DETAIL:
    case KEY:
    case TOOLTIP:
    case HREF:
    case ORDER:
    // TODO: revise (order might not support rect, which is not stackable?)
    case OPACITY:
    case FILLOPACITY:
    case STROKEOPACITY:
    case STROKEWIDTH:
    // falls through
    case FACET:
    case ROW:
    // falls through
    case COLUMN:
      return ALL_MARKS;
    case X$1:
    case Y:
    case XOFFSET:
    case YOFFSET:
    case LATITUDE:
    case LONGITUDE:
    case TIME:
      return ALL_MARKS_EXCEPT_GEOSHAPE;
    case X2:
    case Y2:
    case LATITUDE2:
    case LONGITUDE2:
      return {
        area: "always",
        bar: "always",
        image: "always",
        rect: "always",
        rule: "always",
        circle: "binned",
        point: "binned",
        square: "binned",
        tick: "binned",
        line: "binned",
        trail: "binned"
      };
    case SIZE$2:
      return {
        point: "always",
        tick: "always",
        rule: "always",
        circle: "always",
        square: "always",
        bar: "always",
        text: "always",
        line: "always",
        trail: "always"
      };
    case STROKEDASH:
      return {
        line: "always",
        point: "always",
        tick: "always",
        rule: "always",
        circle: "always",
        square: "always",
        bar: "always",
        geoshape: "always"
      };
    case SHAPE:
      return { point: "always", geoshape: "always" };
    case TEXT$1:
      return { text: "always" };
    case ANGLE:
      return { point: "always", square: "always", text: "always" };
    case URL$1:
      return { image: "always" };
    case THETA:
      return { text: "always", arc: "always" };
    case RADIUS:
      return { text: "always", arc: "always" };
    case THETA2:
    case RADIUS2:
      return { arc: "always" };
  }
}
function rangeType(n) {
  switch (n) {
    case X$1:
    case Y:
    case THETA:
    case RADIUS:
    case XOFFSET:
    case YOFFSET:
    case SIZE$2:
    case ANGLE:
    case STROKEWIDTH:
    case OPACITY:
    case FILLOPACITY:
    case STROKEOPACITY:
    case TIME:
    // X2 and Y2 use X and Y scales, so they similarly have continuous range. [falls through]
    case X2:
    case Y2:
    case THETA2:
    case RADIUS2:
      return;
    case FACET:
    case ROW:
    case COLUMN:
    case SHAPE:
    case STROKEDASH:
    // TEXT, TOOLTIP, URL, and HREF have no scale but have discrete output [falls through]
    case TEXT$1:
    case TOOLTIP:
    case HREF:
    case URL$1:
    case DESCRIPTION:
      return "discrete";
    // Color can be either continuous or discrete, depending on scale type.
    case COLOR:
    case FILL:
    case STROKE:
      return "flexible";
    // No scale, no range type.
    case LATITUDE:
    case LONGITUDE:
    case LATITUDE2:
    case LONGITUDE2:
    case DETAIL:
    case KEY:
    case ORDER:
      return;
  }
}
const AGGREGATE_OP_INDEX = {
  argmax: 1,
  argmin: 1,
  average: 1,
  count: 1,
  distinct: 1,
  exponential: 1,
  exponentialb: 1,
  product: 1,
  max: 1,
  mean: 1,
  median: 1,
  min: 1,
  missing: 1,
  q1: 1,
  q3: 1,
  ci0: 1,
  ci1: 1,
  stderr: 1,
  stdev: 1,
  stdevp: 1,
  sum: 1,
  valid: 1,
  values: 1,
  variance: 1,
  variancep: 1
}, MULTIDOMAIN_SORT_OP_INDEX = {
  count: 1,
  min: 1,
  max: 1
};
function isArgminDef(n) {
  return hasProperty(n, "argmin");
}
function isArgmaxDef(n) {
  return hasProperty(n, "argmax");
}
function isAggregateOp(n) {
  return isString$1(n) && has(AGGREGATE_OP_INDEX, n);
}
const COUNTING_OPS = /* @__PURE__ */ new Set([
  "count",
  "valid",
  "missing",
  "distinct"
]);
function isCountingAggregateOp(n) {
  return isString$1(n) && COUNTING_OPS.has(n);
}
function isMinMaxOp(n) {
  return isString$1(n) && contains(["min", "max"], n);
}
const SUM_OPS = /* @__PURE__ */ new Set([
  "count",
  "sum",
  "distinct",
  "valid",
  "missing"
]), SHARED_DOMAIN_OPS = /* @__PURE__ */ new Set([
  "mean",
  "average",
  "median",
  "q1",
  "q3",
  "min",
  "max"
]);
function binToString(n) {
  return isBoolean$2(n) && (n = normalizeBin(n, void 0)), `bin${keys$1(n).map((t) => isParameterExtent(n[t]) ? varName(`_${t}_${entries$1(n[t])}`) : varName(`_${t}_${n[t]}`)).join("")}`;
}
function isBinning(n) {
  return n === !0 || isBinParams(n) && !n.binned;
}
function isBinned(n) {
  return n === "binned" || isBinParams(n) && n.binned === !0;
}
function isBinParams(n) {
  return isObject$3(n);
}
function isParameterExtent(n) {
  return hasProperty(n, "param");
}
function autoMaxBins(n) {
  switch (n) {
    case ROW:
    case COLUMN:
    case SIZE$2:
    case COLOR:
    case FILL:
    case STROKE:
    case STROKEWIDTH:
    case OPACITY:
    case FILLOPACITY:
    case STROKEOPACITY:
    // Facets and Size shouldn't have too many bins
    // We choose 6 like shape to simplify the rule [falls through]
    case SHAPE:
      return 6;
    // Vega's "shape" has 6 distinct values
    case STROKEDASH:
      return 4;
    // We only provide 5 different stroke dash values (but 4 is more effective)
    default:
      return 10;
  }
}
function isExprRef(n) {
  return hasProperty(n, "expr");
}
function replaceExprRef(n, { level: t } = { level: 0 }) {
  const g = keys$1(n || {}), d = {};
  for (const k of g)
    d[k] = t === 0 ? signalRefOrValue(n[k]) : replaceExprRef(n[k], { level: t - 1 });
  return d;
}
function extractTitleConfig(n) {
  const {
    // These are non-mark title config that need to be hardcoded
    anchor: t,
    frame: g,
    offset: d,
    orient: k,
    angle: H,
    limit: AA,
    // color needs to be redirect to fill
    color: gA,
    // subtitle properties
    subtitleColor: IA,
    subtitleFont: CA,
    subtitleFontSize: BA,
    subtitleFontStyle: eA,
    subtitleFontWeight: iA,
    subtitleLineHeight: QA,
    subtitlePadding: tA,
    // The rest are mark config.
    ...oA
  } = n, EA = {
    ...oA,
    ...gA ? { fill: gA } : {}
  }, aA = {
    ...t ? { anchor: t } : {},
    ...g ? { frame: g } : {},
    ...d ? { offset: d } : {},
    ...k ? { orient: k } : {},
    ...H !== void 0 ? { angle: H } : {},
    ...AA !== void 0 ? { limit: AA } : {}
  }, nA = {
    ...IA ? { subtitleColor: IA } : {},
    ...CA ? { subtitleFont: CA } : {},
    ...BA ? { subtitleFontSize: BA } : {},
    ...eA ? { subtitleFontStyle: eA } : {},
    ...iA ? { subtitleFontWeight: iA } : {},
    ...QA ? { subtitleLineHeight: QA } : {},
    ...tA ? { subtitlePadding: tA } : {}
  }, lA = pick$2(n, ["align", "baseline", "dx", "dy", "limit"]);
  return { titleMarkConfig: EA, subtitleMarkConfig: lA, nonMarkTitleProperties: aA, subtitle: nA };
}
function isText(n) {
  return isString$1(n) || isArray$2(n) && isString$1(n[0]);
}
function isSignalRef(n) {
  return hasProperty(n, "signal");
}
function isVgRangeStep(n) {
  return hasProperty(n, "step");
}
function isDataRefUnionedDomain(n) {
  return isArray$2(n) ? !1 : hasProperty(n, "fields") && !hasProperty(n, "data");
}
function isFieldRefUnionDomain(n) {
  return isArray$2(n) ? !1 : hasProperty(n, "fields") && hasProperty(n, "data");
}
function isDataRefDomain(n) {
  return isArray$2(n) ? !1 : hasProperty(n, "field") && hasProperty(n, "data");
}
const VG_MARK_CONFIG_INDEX = {
  aria: 1,
  description: 1,
  ariaRole: 1,
  ariaRoleDescription: 1,
  blend: 1,
  opacity: 1,
  fill: 1,
  fillOpacity: 1,
  stroke: 1,
  strokeCap: 1,
  strokeWidth: 1,
  strokeOpacity: 1,
  strokeDash: 1,
  strokeDashOffset: 1,
  strokeJoin: 1,
  strokeOffset: 1,
  strokeMiterLimit: 1,
  startAngle: 1,
  endAngle: 1,
  padAngle: 1,
  innerRadius: 1,
  outerRadius: 1,
  size: 1,
  shape: 1,
  interpolate: 1,
  tension: 1,
  orient: 1,
  align: 1,
  baseline: 1,
  text: 1,
  dir: 1,
  dx: 1,
  dy: 1,
  ellipsis: 1,
  limit: 1,
  radius: 1,
  theta: 1,
  angle: 1,
  font: 1,
  fontSize: 1,
  fontWeight: 1,
  fontStyle: 1,
  lineBreak: 1,
  lineHeight: 1,
  cursor: 1,
  href: 1,
  tooltip: 1,
  cornerRadius: 1,
  cornerRadiusTopLeft: 1,
  cornerRadiusTopRight: 1,
  cornerRadiusBottomLeft: 1,
  cornerRadiusBottomRight: 1,
  aspect: 1,
  width: 1,
  height: 1,
  url: 1,
  smooth: 1
  // commented below are vg channel that do not have mark config.
  // x: 1,
  // y: 1,
  // x2: 1,
  // y2: 1,
  // xc'|'yc'
  // clip: 1,
  // path: 1,
  // url: 1,
}, VG_MARK_CONFIGS = keys$1(VG_MARK_CONFIG_INDEX), VG_MARK_INDEX = {
  arc: 1,
  area: 1,
  group: 1,
  image: 1,
  line: 1,
  path: 1,
  rect: 1,
  rule: 1,
  shape: 1,
  symbol: 1,
  text: 1,
  trail: 1
}, VG_CORNERRADIUS_CHANNELS = [
  "cornerRadius",
  "cornerRadiusTopLeft",
  "cornerRadiusTopRight",
  "cornerRadiusBottomLeft",
  "cornerRadiusBottomRight"
], BIN_RANGE_DELIMITER = " – ";
function signalOrValueRefWithCondition(n) {
  const t = isArray$2(n.condition) ? n.condition.map(conditionalSignalRefOrValue) : conditionalSignalRefOrValue(n.condition);
  return {
    ...signalRefOrValue(n),
    condition: t
  };
}
function signalRefOrValue(n) {
  if (isExprRef(n)) {
    const { expr: t, ...g } = n;
    return { signal: t, ...g };
  }
  return n;
}
function conditionalSignalRefOrValue(n) {
  if (isExprRef(n)) {
    const { expr: t, ...g } = n;
    return { signal: t, ...g };
  }
  return n;
}
function signalOrValueRef(n) {
  if (isExprRef(n)) {
    const { expr: t, ...g } = n;
    return { signal: t, ...g };
  }
  return isSignalRef(n) ? n : n !== void 0 ? { value: n } : void 0;
}
function exprFromSignalRefOrValue(n) {
  return isSignalRef(n) ? n.signal : $$1(n);
}
function exprFromValueRefOrSignalRef(n) {
  return isSignalRef(n) ? n.signal : $$1(n.value);
}
function signalOrStringValue(n) {
  return isSignalRef(n) ? n.signal : n == null ? null : $$1(n);
}
function applyMarkConfig(n, t, g) {
  for (const d of g) {
    const k = getMarkConfig(d, t.markDef, t.config);
    k !== void 0 && (n[d] = signalOrValueRef(k));
  }
  return n;
}
function getStyles(n) {
  return [].concat(n.type, n.style ?? []);
}
function getMarkPropOrConfig(n, t, g, d = {}) {
  const { vgChannel: k, ignoreVgConfig: H } = d;
  return k && hasProperty(t, k) ? t[k] : t[n] !== void 0 ? t[n] : H && (!k || k === n) ? void 0 : getMarkConfig(n, t, g, d);
}
function getMarkConfig(n, t, g, { vgChannel: d } = {}) {
  const k = getMarkStyleConfig(n, t, g.style);
  return getFirstDefined(
    // style config has highest precedence
    d ? k : void 0,
    k,
    // then mark-specific config
    d ? g[t.type][d] : void 0,
    g[t.type][n],
    // Need to cast because MarkDef doesn't perfectly match with AnyMarkConfig, but if the type isn't available, we'll get nothing here, which is fine
    // If there is vgChannel, skip vl channel.
    // For example, vl size for text is vg fontSize, but config.mark.size is only for point size.
    d ? g.mark[d] : g.mark[n]
  );
}
function getMarkStyleConfig(n, t, g) {
  return getStyleConfig(n, getStyles(t), g);
}
function getStyleConfig(n, t, g) {
  t = array(t);
  let d;
  for (const k of t) {
    const H = g[k];
    hasProperty(H, n) && (d = H[n]);
  }
  return d;
}
function sortParams(n, t) {
  return array(n).reduce((g, d) => (g.field.push(vgField(d, t)), g.order.push(d.sort ?? "ascending"), g), { field: [], order: [] });
}
function mergeTitleFieldDefs(n, t) {
  const g = [...n];
  return t.forEach((d) => {
    for (const k of g)
      if (deepEqual(k, d))
        return;
    g.push(d);
  }), g;
}
function mergeTitle(n, t) {
  return deepEqual(n, t) || !t ? n : n ? [...array(n), ...array(t)].join(", ") : t;
}
function mergeTitleComponent(n, t) {
  const g = n.value, d = t.value;
  if (g == null || d === null)
    return {
      explicit: n.explicit,
      value: null
    };
  if ((isText(g) || isSignalRef(g)) && (isText(d) || isSignalRef(d)))
    return {
      explicit: n.explicit,
      value: mergeTitle(g, d)
    };
  if (isText(g) || isSignalRef(g))
    return {
      explicit: n.explicit,
      value: g
    };
  if (isText(d) || isSignalRef(d))
    return {
      explicit: n.explicit,
      value: d
    };
  if (!isText(g) && !isSignalRef(g) && !isText(d) && !isSignalRef(d))
    return {
      explicit: n.explicit,
      value: mergeTitleFieldDefs(g, d)
    };
  throw new Error("It should never reach here");
}
function invalidSpec(n) {
  return `Invalid specification ${stringify$1(n)}. Make sure the specification includes at least one of the following properties: "mark", "layer", "facet", "hconcat", "vconcat", "concat", or "repeat".`;
}
const FIT_NON_SINGLE = 'Autosize "fit" only works for single views and layered views.';
function containerSizeNonSingle(n) {
  return `${n == "width" ? "Width" : "Height"} "container" only works for single views and layered views.`;
}
function containerSizeNotCompatibleWithAutosize(n) {
  const t = n == "width" ? "Width" : "Height", g = n == "width" ? "x" : "y";
  return `${t} "container" only works well with autosize "fit" or "fit-${g}".`;
}
function droppingFit(n) {
  return n ? `Dropping "fit-${n}" because spec has discrete ${getSizeChannel(n)}.` : 'Dropping "fit" because spec has discrete size.';
}
function unknownField(n) {
  return `Unknown field for ${n}. Cannot calculate view size.`;
}
function cannotProjectOnChannelWithoutField(n) {
  return `Cannot project a selection on encoding channel "${n}", which has no field.`;
}
function cannotProjectAggregate(n, t) {
  return `Cannot project a selection on encoding channel "${n}" as it uses an aggregate function ("${t}").`;
}
function nearestNotSupportForContinuous(n) {
  return `The "nearest" transform is not supported for ${n} marks.`;
}
function selectionNotSupported(n) {
  return `Selection not supported for ${n} yet.`;
}
function selectionNotFound(n) {
  return `Cannot find a selection named "${n}".`;
}
const SCALE_BINDINGS_CONTINUOUS = "Scale bindings are currently only supported for scales with unbinned, continuous domains.", SEQUENTIAL_SCALE_DEPRECATED = "Sequntial scales are deprecated. The available quantitative scale type values are linear, log, pow, sqrt, symlog, time and utc", LEGEND_BINDINGS_MUST_HAVE_PROJECTION = "Legend bindings are only supported for selections over an individual field or encoding channel.";
function cannotLookupVariableParameter(n) {
  return `Lookups can only be performed on selection parameters. "${n}" is a variable parameter.`;
}
function noSameUnitLookup(n) {
  return `Cannot define and lookup the "${n}" selection in the same view. Try moving the lookup into a second, layered view?`;
}
const NEEDS_SAME_SELECTION = "The same selection must be used to override scale domains in a layered view.", INTERVAL_INITIALIZED_WITH_POS = 'Interval selections should be initialized using "x", "y", "longitude", or "latitude" keys.';
function noSuchRepeatedValue(n) {
  return `Unknown repeated value "${n}".`;
}
function columnsNotSupportByRowCol(n) {
  return `The "columns" property cannot be used when "${n}" has nested row/column.`;
}
const MULTIPLE_TIMER_ANIMATION_SELECTION = "Multiple timer selections in one unit spec are not supported. Ignoring all but the first.", MULTI_VIEW_ANIMATION_UNSUPPORTED = "Animation involving facet, layer, or concat is currently unsupported.";
function selectionAsScaleDomainWithoutField(n) {
  return `A "field" or "encoding" must be specified when using a selection as a scale domain. Using "field": ${$$2(n)}.`;
}
function selectionAsScaleDomainWrongEncodings(n, t, g, d) {
  return `${n.length ? "Multiple " : "No "}matching ${$$2(t)} encoding found for selection ${$$2(g.param)}. Using "field": ${$$2(d)}.`;
}
const CONCAT_CANNOT_SHARE_AXIS = "Axes cannot be shared in concatenated or repeated views yet (https://github.com/vega/vega-lite/issues/2415).";
function unrecognizedParse(n) {
  return `Unrecognized parse "${n}".`;
}
function differentParse(n, t, g) {
  return `An ancestor parsed field "${n}" as ${g} but a child wants to parse the field as ${t}.`;
}
const ADD_SAME_CHILD_TWICE = "Attempt to add the same child twice.";
function invalidTransformIgnored(n) {
  return `Ignoring an invalid transform: ${stringify$1(n)}.`;
}
const NO_FIELDS_NEEDS_AS = 'If "from.fields" is not specified, "as" has to be a string that specifies the key to be used for the data from the secondary source.';
function customFormatTypeNotAllowed(n) {
  return `Config.customFormatTypes is not true, thus custom format type and format for channel ${n} are dropped.`;
}
function projectionOverridden(n) {
  const { parentProjection: t, projection: g } = n;
  return `Layer's shared projection ${stringify$1(t)} is overridden by a child projection ${stringify$1(g)}.`;
}
const REPLACE_ANGLE_WITH_THETA = "Arc marks uses theta channel rather than angle, replacing angle with theta.";
function offsetNestedInsideContinuousPositionScaleDropped(n) {
  return `${n}Offset dropped because ${n} is continuous`;
}
function primitiveChannelDef(n, t, g) {
  return `Channel ${n} is a ${t}. Converted to {value: ${stringify$1(g)}}.`;
}
function invalidFieldType(n) {
  return `Invalid field type "${n}".`;
}
function invalidFieldTypeForCountAggregate(n, t) {
  return `Invalid field type "${n}" for aggregate: "${t}", using "quantitative" instead.`;
}
function invalidAggregate(n) {
  return `Invalid aggregation operator "${n}".`;
}
function droppingColor(n, t) {
  const { fill: g, stroke: d } = t;
  return `Dropping color ${n} as the plot also has ${g && d ? "fill and stroke" : g ? "fill" : "stroke"}.`;
}
function relativeBandSizeNotSupported(n) {
  return `Position range does not support relative band size for ${n}.`;
}
function emptyFieldDef(n, t) {
  return `Dropping ${stringify$1(n)} from channel "${t}" since it does not contain any data field, datum, value, or signal.`;
}
const LINE_WITH_VARYING_SIZE = "Line marks cannot encode size with a non-groupby field. You may want to use trail marks instead.";
function incompatibleChannel(n, t, g) {
  return `${n} dropped as it is incompatible with "${t}".`;
}
function invalidEncodingChannel(n) {
  return `${n}-encoding is dropped as ${n} is not a valid encoding channel.`;
}
function channelShouldBeDiscrete(n) {
  return `${n} encoding should be discrete (ordinal / nominal / binned).`;
}
function channelShouldBeDiscreteOrDiscretizing(n) {
  return `${n} encoding should be discrete (ordinal / nominal / binned) or use a discretizing scale (e.g. threshold).`;
}
function facetChannelDropped(n) {
  return `Facet encoding dropped as ${n.join(" and ")} ${n.length > 1 ? "are" : "is"} also specified.`;
}
function discreteChannelCannotEncode(n, t) {
  return `Using discrete channel "${n}" to encode "${t}" field can be misleading as it does not encode ${t === "ordinal" ? "order" : "magnitude"}.`;
}
function rangeMarkAlignmentCannotBeExpression(n) {
  return `The ${n} for range marks cannot be an expression`;
}
function lineWithRange(n, t) {
  return `Line mark is for continuous lines and thus cannot be used with ${n && t ? "x2 and y2" : n ? "x2" : "y2"}. We will use the rule mark (line segments) instead.`;
}
function orientOverridden(n, t) {
  return `Specified orient "${n}" overridden with "${t}".`;
}
function cannotUseScalePropertyWithNonColor(n) {
  return `Cannot use the scale property "${n}" with non-color channel.`;
}
function cannotUseRelativeBandSizeWithNonBandScale(n) {
  return `Cannot use the relative band size with ${n} scale.`;
}
function unaggregateDomainHasNoEffectForRawField(n) {
  return `Using unaggregated domain with raw field has no effect (${stringify$1(n)}).`;
}
function unaggregateDomainWithNonSharedDomainOp(n) {
  return `Unaggregated domain not applicable for "${n}" since it produces values outside the origin domain of the source data.`;
}
function unaggregatedDomainWithLogScale(n) {
  return `Unaggregated domain is currently unsupported for log scale (${stringify$1(n)}).`;
}
function cannotApplySizeToNonOrientedMark(n) {
  return `Cannot apply size to non-oriented mark "${n}".`;
}
function scaleTypeNotWorkWithChannel(n, t, g) {
  return `Channel "${n}" does not work with "${t}" scale. We are using "${g}" scale instead.`;
}
function scaleTypeNotWorkWithFieldDef(n, t) {
  return `FieldDef does not work with "${n}" scale. We are using "${t}" scale instead.`;
}
function scalePropertyNotWorkWithScaleType(n, t, g) {
  return `${g}-scale's "${t}" is dropped as it does not work with ${n} scale.`;
}
function stepDropped(n) {
  return `The step for "${n}" is dropped because the ${n === "width" ? "x" : "y"} is continuous.`;
}
function mergeConflictingProperty(n, t, g, d) {
  return `Conflicting ${t.toString()} property "${n.toString()}" (${stringify$1(g)} and ${stringify$1(d)}). Using ${stringify$1(g)}.`;
}
function mergeConflictingDomainProperty(n, t, g, d) {
  return `Conflicting ${t.toString()} property "${n.toString()}" (${stringify$1(g)} and ${stringify$1(d)}). Using the union of the two domains.`;
}
function independentScaleMeansIndependentGuide(n) {
  return `Setting the scale to be independent for "${n}" means we also have to set the guide (axis or legend) to be independent.`;
}
function domainSortDropped(n) {
  return `Dropping sort property ${stringify$1(n)} as unioned domains only support boolean or op "count", "min", and "max".`;
}
const MORE_THAN_ONE_SORT = "Domains that should be unioned has conflicting sort properties. Sort will be set to true.", FACETED_INDEPENDENT_DIFFERENT_SOURCES = "Detected faceted independent scales that union domain of multiple fields from different data sources. We will use the first field. The result view size may be incorrect.", FACETED_INDEPENDENT_SAME_FIELDS_DIFFERENT_SOURCES = "Detected faceted independent scales that union domain of the same fields from different source. We will assume that this is the same field from a different fork of the same data source. However, if this is not the case, the result view size may be incorrect.", FACETED_INDEPENDENT_SAME_SOURCE = "Detected faceted independent scales that union domain of multiple fields from the same data source. We will use the first field. The result view size may be incorrect.";
function cannotStackRangedMark(n) {
  return `Cannot stack "${n}" if there is already "${n}2".`;
}
function stackNonLinearScale(n) {
  return `Stack is applied to a non-linear scale (${n}).`;
}
function stackNonSummativeAggregate(n) {
  return `Stacking is applied even though the aggregate function is non-summative ("${n}").`;
}
function invalidTimeUnit(n, t) {
  return `Invalid ${n}: ${stringify$1(t)}.`;
}
function droppedDay(n) {
  return `Dropping day from datetime ${stringify$1(n)} as day cannot be combined with other units.`;
}
function errorBarCenterAndExtentAreNotNeeded(n, t) {
  return `${t ? "extent " : ""}${t && n ? "and " : ""}${n ? "center " : ""}${t && n ? "are " : "is "}not needed when data are aggregated.`;
}
function errorBarCenterIsUsedWithWrongExtent(n, t, g) {
  return `${n} is not usually used with ${t} for ${g}.`;
}
function errorBarContinuousAxisHasCustomizedAggregate(n, t) {
  return `Continuous axis should not have customized aggregation function ${n}; ${t} already agregates the axis.`;
}
function errorBand1DNotSupport(n) {
  return `1D error band does not support ${n}.`;
}
function channelRequiredForBinned(n) {
  return `Channel ${n} is required for "binned" bin.`;
}
function channelShouldNotBeUsedForBinned(n) {
  return `Channel ${n} should not be used with "binned" bin.`;
}
function domainRequiredForThresholdScale(n) {
  return `Domain for ${n} is required for threshold scale.`;
}
const main = logger(Warn);
let current = main;
function set(n) {
  return current = n, current;
}
function reset() {
  return current = main, current;
}
function error(...n) {
  current.error(...n);
}
function warn(...n) {
  current.warn(...n);
}
function debug(...n) {
  current.debug(...n);
}
function isDateTime(n) {
  if (n && isObject$3(n)) {
    for (const t of TIMEUNIT_PARTS)
      if (hasProperty(n, t))
        return !0;
  }
  return !1;
}
const MONTHS = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december"
], SHORT_MONTHS = MONTHS.map((n) => n.substr(0, 3)), DAYS = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"], SHORT_DAYS = DAYS.map((n) => n.substr(0, 3));
function normalizeQuarter(n) {
  if (isNumeric(n) && (n = +n), isNumber$1(n))
    return n > 4 && warn(invalidTimeUnit("quarter", n)), n - 1;
  throw new Error(invalidTimeUnit("quarter", n));
}
function normalizeMonth(n) {
  if (isNumeric(n) && (n = +n), isNumber$1(n))
    return n - 1;
  {
    const t = n.toLowerCase(), g = MONTHS.indexOf(t);
    if (g !== -1)
      return g;
    const d = t.substr(0, 3), k = SHORT_MONTHS.indexOf(d);
    if (k !== -1)
      return k;
    throw new Error(invalidTimeUnit("month", n));
  }
}
function normalizeDay(n) {
  if (isNumeric(n) && (n = +n), isNumber$1(n))
    return n % 7;
  {
    const t = n.toLowerCase(), g = DAYS.indexOf(t);
    if (g !== -1)
      return g;
    const d = t.substr(0, 3), k = SHORT_DAYS.indexOf(d);
    if (k !== -1)
      return k;
    throw new Error(invalidTimeUnit("day", n));
  }
}
function dateTimeParts(n, t) {
  const g = [];
  if (t && n.day !== void 0 && keys$1(n).length > 1 && (warn(droppedDay(n)), n = duplicate(n), delete n.day), n.year !== void 0 ? g.push(n.year) : g.push(2012), n.month !== void 0) {
    const d = t ? normalizeMonth(n.month) : n.month;
    g.push(d);
  } else if (n.quarter !== void 0) {
    const d = t ? normalizeQuarter(n.quarter) : n.quarter;
    g.push(isNumber$1(d) ? d * 3 : `${d}*3`);
  } else
    g.push(0);
  if (n.date !== void 0)
    g.push(n.date);
  else if (n.day !== void 0) {
    const d = t ? normalizeDay(n.day) : n.day;
    g.push(isNumber$1(d) ? d + 1 : `${d}+1`);
  } else
    g.push(1);
  for (const d of ["hours", "minutes", "seconds", "milliseconds"]) {
    const k = n[d];
    g.push(typeof k > "u" ? 0 : k);
  }
  return g;
}
function dateTimeToExpr(n) {
  const g = dateTimeParts(n, !0).join(", ");
  return n.utc ? `utc(${g})` : `datetime(${g})`;
}
function dateTimeExprToExpr(n) {
  const g = dateTimeParts(n, !1).join(", ");
  return n.utc ? `utc(${g})` : `datetime(${g})`;
}
function dateTimeToTimestamp(n) {
  const t = dateTimeParts(n, !0);
  return n.utc ? +new Date(Date.UTC(...t)) : +new Date(...t);
}
const LOCAL_SINGLE_TIMEUNIT_INDEX = {
  year: 1,
  quarter: 1,
  month: 1,
  week: 1,
  day: 1,
  dayofyear: 1,
  date: 1,
  hours: 1,
  minutes: 1,
  seconds: 1,
  milliseconds: 1
}, TIMEUNIT_PARTS = keys$1(LOCAL_SINGLE_TIMEUNIT_INDEX);
function isLocalSingleTimeUnit(n) {
  return has$2(LOCAL_SINGLE_TIMEUNIT_INDEX, n);
}
function isBinnedTimeUnit(n) {
  return isObject$3(n) ? n.binned : isBinnedTimeUnitString(n);
}
function isBinnedTimeUnitString(n) {
  return n?.startsWith("binned");
}
function isUTCTimeUnit(n) {
  return n.startsWith("utc");
}
function getLocalTimeUnitFromUTCTimeUnit(n) {
  return n.substring(3);
}
const VEGALITE_TIMEFORMAT = {
  "year-month": "%b %Y ",
  "year-month-date": "%b %d, %Y "
};
function getTimeUnitParts(n) {
  return TIMEUNIT_PARTS.filter((t) => containsTimeUnit(n, t));
}
function getSmallestTimeUnitPart(n) {
  const t = getTimeUnitParts(n);
  return t[t.length - 1];
}
function containsTimeUnit(n, t) {
  const g = n.indexOf(t);
  return !(g < 0 || g > 0 && t === "seconds" && n.charAt(g - 1) === "i" || n.length > g + 3 && t === "day" && n.charAt(g + 3) === "o" || g > 0 && t === "year" && n.charAt(g - 1) === "f");
}
function fieldExpr(n, t, { end: g } = { end: !1 }) {
  const d = accessPathWithDatum(t), k = isUTCTimeUnit(n) ? "utc" : "";
  function H(IA) {
    return IA === "quarter" ? `(${k}quarter(${d})-1)` : `${k}${IA}(${d})`;
  }
  let AA;
  const gA = {};
  for (const IA of TIMEUNIT_PARTS)
    containsTimeUnit(n, IA) && (gA[IA] = H(IA), AA = IA);
  return g && (gA[AA] += "+1"), dateTimeExprToExpr(gA);
}
function timeUnitSpecifierExpression(n) {
  if (!n)
    return;
  const t = getTimeUnitParts(n);
  return `timeUnitSpecifier(${stringify$1(t)}, ${stringify$1(VEGALITE_TIMEFORMAT)})`;
}
function formatExpression(n, t, g) {
  if (!n)
    return;
  const d = timeUnitSpecifierExpression(n);
  return `${g || isUTCTimeUnit(n) ? "utc" : "time"}Format(${t}, ${d})`;
}
function normalizeTimeUnit(n) {
  if (!n)
    return;
  let t;
  return isString$1(n) ? isBinnedTimeUnitString(n) ? t = {
    unit: n.substring(6),
    binned: !0
  } : t = {
    unit: n
  } : isObject$3(n) && (t = {
    ...n,
    ...n.unit ? { unit: n.unit } : {}
  }), isUTCTimeUnit(t.unit) && (t.utc = !0, t.unit = getLocalTimeUnitFromUTCTimeUnit(t.unit)), t;
}
function timeUnitToString(n) {
  const { utc: t, ...g } = normalizeTimeUnit(n);
  return g.unit ? (t ? "utc" : "") + keys$1(g).map((d) => varName(`${d === "unit" ? "" : `_${d}_`}${g[d]}`)).join("") : `${t ? "utc" : ""}timeunit${keys$1(g).map((d) => varName(`_${d}_${g[d]}`)).join("")}`;
}
function durationExpr(n, t = (g) => g) {
  const g = normalizeTimeUnit(n), d = getSmallestTimeUnitPart(g.unit);
  if (d && d !== "day") {
    const k = {
      year: 2001,
      // pick a non-leap year
      month: 1,
      date: 1,
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0
    }, { step: H, part: AA } = getDateTimePartAndStep(d, g.step), gA = {
      ...k,
      [AA]: +k[AA] + H
    };
    return `${t(dateTimeToExpr(gA))} - ${t(dateTimeToExpr(k))}`;
  }
}
const DATE_PARTS = {
  year: 1,
  month: 1,
  date: 1,
  hours: 1,
  minutes: 1,
  seconds: 1,
  milliseconds: 1
};
function isDatePart(n) {
  return has$2(DATE_PARTS, n);
}
function getDateTimePartAndStep(n, t = 1) {
  if (isDatePart(n))
    return { part: n, step: t };
  switch (n) {
    case "day":
    case "dayofyear":
      return { part: "date", step: t };
    case "quarter":
      return { part: "month", step: t * 3 };
    case "week":
      return { part: "date", step: t * 7 };
  }
}
function isSelectionPredicate(n) {
  return hasProperty(n, "param");
}
function isFieldEqualPredicate(n) {
  return !!n?.field && n.equal !== void 0;
}
function isFieldLTPredicate(n) {
  return !!n?.field && n.lt !== void 0;
}
function isFieldLTEPredicate(n) {
  return !!n?.field && n.lte !== void 0;
}
function isFieldGTPredicate(n) {
  return !!n?.field && n.gt !== void 0;
}
function isFieldGTEPredicate(n) {
  return !!n?.field && n.gte !== void 0;
}
function isFieldRangePredicate(n) {
  if (n?.field) {
    if (isArray$2(n.range) && n.range.length === 2)
      return !0;
    if (isSignalRef(n.range))
      return !0;
  }
  return !1;
}
function isFieldOneOfPredicate(n) {
  return !!n?.field && (isArray$2(n.oneOf) || isArray$2(n.in));
}
function isFieldValidPredicate(n) {
  return !!n?.field && n.valid !== void 0;
}
function isFieldPredicate(n) {
  return isFieldOneOfPredicate(n) || isFieldEqualPredicate(n) || isFieldRangePredicate(n) || isFieldLTPredicate(n) || isFieldGTPredicate(n) || isFieldLTEPredicate(n) || isFieldGTEPredicate(n);
}
function predicateValueExpr(n, t) {
  return valueExpr(n, { timeUnit: t, wrapTime: !0 });
}
function predicateValuesExpr(n, t) {
  return n.map((g) => predicateValueExpr(g, t));
}
function fieldFilterExpression(n, t = !0) {
  const { field: g } = n, d = normalizeTimeUnit(n.timeUnit), { unit: k, binned: H } = d || {}, AA = vgField(n, { expr: "datum" }), gA = k ? (
    // For timeUnit, cast into integer with time() so we can use ===, inrange, indexOf to compare values directly.
    // TODO: We calculate timeUnit on the fly here. Consider if we would like to consolidate this with timeUnit pipeline
    // TODO: support utc
    `time(${H ? AA : fieldExpr(k, g)})`
  ) : AA;
  if (isFieldEqualPredicate(n))
    return `${gA}===${predicateValueExpr(n.equal, k)}`;
  if (isFieldLTPredicate(n)) {
    const IA = n.lt;
    return `${gA}<${predicateValueExpr(IA, k)}`;
  } else if (isFieldGTPredicate(n)) {
    const IA = n.gt;
    return `${gA}>${predicateValueExpr(IA, k)}`;
  } else if (isFieldLTEPredicate(n)) {
    const IA = n.lte;
    return `${gA}<=${predicateValueExpr(IA, k)}`;
  } else if (isFieldGTEPredicate(n)) {
    const IA = n.gte;
    return `${gA}>=${predicateValueExpr(IA, k)}`;
  } else {
    if (isFieldOneOfPredicate(n))
      return `indexof([${predicateValuesExpr(n.oneOf, k).join(",")}], ${gA}) !== -1`;
    if (isFieldValidPredicate(n))
      return fieldValidPredicate(gA, n.valid);
    if (isFieldRangePredicate(n)) {
      const { range: IA } = replaceExprRef(n), CA = isSignalRef(IA) ? { signal: `${IA.signal}[0]` } : IA[0], BA = isSignalRef(IA) ? { signal: `${IA.signal}[1]` } : IA[1];
      if (CA !== null && BA !== null && t)
        return `inrange(${gA}, [${predicateValueExpr(CA, k)}, ${predicateValueExpr(BA, k)}])`;
      const eA = [];
      return CA !== null && eA.push(`${gA} >= ${predicateValueExpr(CA, k)}`), BA !== null && eA.push(`${gA} <= ${predicateValueExpr(BA, k)}`), eA.length > 0 ? eA.join(" && ") : "true";
    }
  }
  throw new Error(`Invalid field predicate: ${stringify$1(n)}`);
}
function fieldValidPredicate(n, t = !0) {
  return t ? `isValid(${n}) && isFinite(+${n})` : `!isValid(${n}) || !isFinite(+${n})`;
}
function normalizePredicate$1(n) {
  return isFieldPredicate(n) && n.timeUnit ? {
    ...n,
    timeUnit: normalizeTimeUnit(n.timeUnit)
  } : n;
}
const Type = {
  quantitative: "quantitative",
  ordinal: "ordinal",
  temporal: "temporal",
  nominal: "nominal",
  geojson: "geojson"
};
function isContinuous(n) {
  return n === "quantitative" || n === "temporal";
}
function isDiscrete$1(n) {
  return n === "ordinal" || n === "nominal";
}
const QUANTITATIVE = Type.quantitative, ORDINAL = Type.ordinal, TEMPORAL = Type.temporal, NOMINAL = Type.nominal, GEOJSON = Type.geojson;
function getFullName(n) {
  if (n)
    switch (n = n.toLowerCase(), n) {
      case "q":
      case QUANTITATIVE:
        return "quantitative";
      case "t":
      case TEMPORAL:
        return "temporal";
      case "o":
      case ORDINAL:
        return "ordinal";
      case "n":
      case NOMINAL:
        return "nominal";
      case GEOJSON:
        return "geojson";
    }
}
const ScaleType = {
  // Continuous - Quantitative
  LINEAR: "linear",
  LOG: "log",
  POW: "pow",
  SQRT: "sqrt",
  // Continuous - Time
  TIME: "time",
  UTC: "utc",
  POINT: "point",
  BAND: "band"
}, SCALE_CATEGORY_INDEX = {
  linear: "numeric",
  log: "numeric",
  pow: "numeric",
  sqrt: "numeric",
  symlog: "numeric",
  identity: "numeric",
  sequential: "numeric",
  time: "time",
  utc: "time",
  ordinal: "ordinal",
  "bin-ordinal": "bin-ordinal",
  // TODO: should bin-ordinal support merging with other
  point: "ordinal-position",
  band: "ordinal-position",
  quantile: "discretizing",
  quantize: "discretizing",
  threshold: "discretizing"
};
function scaleCompatible(n, t) {
  const g = SCALE_CATEGORY_INDEX[n], d = SCALE_CATEGORY_INDEX[t];
  return g === d || g === "ordinal-position" && d === "time" || d === "ordinal-position" && g === "time";
}
const SCALE_PRECEDENCE_INDEX = {
  // numeric
  linear: 0,
  log: 1,
  pow: 1,
  sqrt: 1,
  symlog: 1,
  identity: 1,
  sequential: 1,
  // time
  time: 0,
  utc: 0,
  // ordinal-position -- these have higher precedence than continuous scales as they support more types of data
  point: 10,
  band: 11,
  // band has higher precedence as it is better for interaction
  // non grouped types
  ordinal: 0,
  "bin-ordinal": 0,
  quantile: 0,
  quantize: 0,
  threshold: 0
};
function scaleTypePrecedence(n) {
  return SCALE_PRECEDENCE_INDEX[n];
}
const QUANTITATIVE_SCALES = /* @__PURE__ */ new Set([
  "linear",
  "log",
  "pow",
  "sqrt",
  "symlog"
]), CONTINUOUS_TO_CONTINUOUS_SCALES = /* @__PURE__ */ new Set([
  ...QUANTITATIVE_SCALES,
  "time",
  "utc"
]);
function isQuantitative(n) {
  return QUANTITATIVE_SCALES.has(n);
}
const CONTINUOUS_TO_DISCRETE_SCALES = /* @__PURE__ */ new Set([
  "quantile",
  "quantize",
  "threshold"
]), CONTINUOUS_DOMAIN_SCALES = /* @__PURE__ */ new Set([
  ...CONTINUOUS_TO_CONTINUOUS_SCALES,
  ...CONTINUOUS_TO_DISCRETE_SCALES,
  "sequential",
  "identity"
]), DISCRETE_DOMAIN_SCALES = /* @__PURE__ */ new Set([
  "ordinal",
  "bin-ordinal",
  "point",
  "band"
]);
function hasDiscreteDomain(n) {
  return DISCRETE_DOMAIN_SCALES.has(n);
}
function hasContinuousDomain(n) {
  return CONTINUOUS_DOMAIN_SCALES.has(n);
}
function isContinuousToContinuous(n) {
  return CONTINUOUS_TO_CONTINUOUS_SCALES.has(n);
}
function isContinuousToDiscrete(n) {
  return CONTINUOUS_TO_DISCRETE_SCALES.has(n);
}
const defaultScaleConfig = {
  pointPadding: 0.5,
  barBandPaddingInner: 0.1,
  rectBandPaddingInner: 0,
  tickBandPaddingInner: 0.25,
  bandWithNestedOffsetPaddingInner: 0.2,
  bandWithNestedOffsetPaddingOuter: 0.2,
  minBandSize: 2,
  minFontSize: 8,
  maxFontSize: 40,
  minOpacity: 0.3,
  maxOpacity: 0.8,
  // FIXME: revise if these *can* become ratios of width/height step
  minSize: 4,
  // Point size is area. For square point, 9 = 3 pixel ^ 2, not too small!
  minStrokeWidth: 1,
  maxStrokeWidth: 4,
  quantileCount: 4,
  quantizeCount: 4,
  zero: !0,
  framesPerSecond: 2,
  animationDuration: 5
};
function isExtendedScheme(n) {
  return !isString$1(n) && hasProperty(n, "name");
}
function isParameterDomain(n) {
  return hasProperty(n, "param");
}
function isDomainUnionWith(n) {
  return hasProperty(n, "unionWith");
}
function isFieldRange(n) {
  return isObject$3(n) && "field" in n;
}
const SCALE_PROPERTY_INDEX = {
  type: 1,
  domain: 1,
  domainMax: 1,
  domainMin: 1,
  domainMid: 1,
  domainRaw: 1,
  align: 1,
  range: 1,
  rangeMax: 1,
  rangeMin: 1,
  scheme: 1,
  bins: 1,
  // Other properties
  reverse: 1,
  round: 1,
  // quantitative / time
  clamp: 1,
  nice: 1,
  // quantitative
  base: 1,
  exponent: 1,
  constant: 1,
  interpolate: 1,
  zero: 1,
  // zero depends on domain
  // band/point
  padding: 1,
  paddingInner: 1,
  paddingOuter: 1
}, { type: type$1, domain: domain$1, range: range$1, rangeMax, rangeMin, scheme, ...NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTY_INDEX } = SCALE_PROPERTY_INDEX, NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTIES = keys$1(NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTY_INDEX);
function scaleTypeSupportProperty(n, t) {
  switch (t) {
    case "type":
    case "domain":
    case "reverse":
    case "range":
      return !0;
    case "scheme":
    case "interpolate":
      return !["point", "band", "identity"].includes(n);
    case "bins":
      return !["point", "band", "identity", "ordinal"].includes(n);
    case "round":
      return isContinuousToContinuous(n) || n === "band" || n === "point";
    case "padding":
    case "rangeMin":
    case "rangeMax":
      return isContinuousToContinuous(n) || ["point", "band"].includes(n);
    case "paddingOuter":
    case "align":
      return ["point", "band"].includes(n);
    case "paddingInner":
      return n === "band";
    case "domainMax":
    case "domainMid":
    case "domainMin":
    case "domainRaw":
    case "clamp":
      return isContinuousToContinuous(n);
    case "nice":
      return isContinuousToContinuous(n) || n === "quantize" || n === "threshold";
    case "exponent":
      return n === "pow";
    case "base":
      return n === "log";
    case "constant":
      return n === "symlog";
    case "zero":
      return hasContinuousDomain(n) && !contains([
        "log",
        // log scale cannot have zero value
        "time",
        "utc",
        // zero is not meaningful for time
        "threshold",
        // threshold requires custom domain so zero does not matter
        "quantile"
        // quantile depends on distribution so zero does not matter
      ], n);
  }
}
function channelScalePropertyIncompatability(n, t) {
  switch (t) {
    case "interpolate":
    case "scheme":
    case "domainMid":
      return isColorChannel(n) ? void 0 : cannotUseScalePropertyWithNonColor(t);
    case "align":
    case "type":
    case "bins":
    case "domain":
    case "domainMax":
    case "domainMin":
    case "domainRaw":
    case "range":
    case "base":
    case "exponent":
    case "constant":
    case "nice":
    case "padding":
    case "paddingInner":
    case "paddingOuter":
    case "rangeMax":
    case "rangeMin":
    case "reverse":
    case "round":
    case "clamp":
    case "zero":
      return;
  }
}
function scaleTypeSupportDataType(n, t) {
  return contains([ORDINAL, NOMINAL], t) ? n === void 0 || hasDiscreteDomain(n) : t === TEMPORAL ? contains([ScaleType.TIME, ScaleType.UTC, void 0], n) : t === QUANTITATIVE ? isQuantitative(n) || isContinuousToDiscrete(n) || n === void 0 : !0;
}
function channelSupportScaleType(n, t, g = !1) {
  if (!isScaleChannel(n))
    return !1;
  switch (n) {
    case X$1:
    case Y:
    case XOFFSET:
    case YOFFSET:
    case THETA:
    case RADIUS:
      return isContinuousToContinuous(t) || t === "band" ? !0 : t === "point" ? !g : !1;
    case TIME:
      return contains(["linear", "band"], t);
    case SIZE$2:
    // TODO: size and opacity can support ordinal with more modification
    case STROKEWIDTH:
    case OPACITY:
    case FILLOPACITY:
    case STROKEOPACITY:
    case ANGLE:
      return isContinuousToContinuous(t) || isContinuousToDiscrete(t) || contains(["band", "point", "ordinal"], t);
    case COLOR:
    case FILL:
    case STROKE:
      return t !== "band";
    // band does not make sense with color
    case STROKEDASH:
    case SHAPE:
      return t === "ordinal" || isContinuousToDiscrete(t);
  }
}
function isScaleInvalidDataIncludeAsValue(n) {
  return isObject$3(n) && "value" in n;
}
const Mark = {
  arc: "arc",
  area: "area",
  bar: "bar",
  image: "image",
  line: "line",
  point: "point",
  rect: "rect",
  rule: "rule",
  text: "text",
  tick: "tick",
  trail: "trail",
  circle: "circle",
  square: "square",
  geoshape: "geoshape"
}, ARC = Mark.arc, AREA = Mark.area, BAR = Mark.bar, IMAGE = Mark.image, LINE = Mark.line, POINT = Mark.point, RECT = Mark.rect, RULE = Mark.rule, TEXT = Mark.text, TICK = Mark.tick, TRAIL = Mark.trail, CIRCLE = Mark.circle, SQUARE = Mark.square, GEOSHAPE = Mark.geoshape;
function isPathMark(n) {
  return ["line", "area", "trail"].includes(n);
}
function isRectBasedMark(n) {
  return [
    "rect",
    "bar",
    "image",
    "arc",
    "tick"
    /* arc is rect/interval in polar coordinate */
  ].includes(n);
}
const PRIMITIVE_MARKS = new Set(keys$1(Mark));
function isMarkDef(n) {
  return hasProperty(n, "type");
}
const STROKE_CONFIG = [
  "stroke",
  "strokeWidth",
  "strokeDash",
  "strokeDashOffset",
  "strokeOpacity",
  "strokeJoin",
  "strokeMiterLimit"
], FILL_CONFIG = ["fill", "fillOpacity"], FILL_STROKE_CONFIG = [...STROKE_CONFIG, ...FILL_CONFIG], VL_ONLY_MARK_CONFIG_INDEX = {
  color: 1,
  filled: 1,
  invalid: 1,
  order: 1,
  radius2: 1,
  theta2: 1,
  timeUnitBandSize: 1,
  timeUnitBandPosition: 1
}, VL_ONLY_MARK_CONFIG_PROPERTIES = keys$1(VL_ONLY_MARK_CONFIG_INDEX), VL_ONLY_RECT_CONFIG = [
  "binSpacing",
  "continuousBandSize",
  "discreteBandSize",
  "minBandSize"
], VL_ONLY_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX = {
  area: ["line", "point"],
  bar: VL_ONLY_RECT_CONFIG,
  rect: VL_ONLY_RECT_CONFIG,
  line: ["point"],
  tick: ["bandSize", "thickness", ...VL_ONLY_RECT_CONFIG]
}, defaultMarkConfig = {
  color: "#4c78a8",
  invalid: "break-paths-show-path-domains",
  timeUnitBandSize: 1
}, MARK_CONFIG_INDEX = {
  mark: 1,
  arc: 1,
  area: 1,
  bar: 1,
  circle: 1,
  image: 1,
  line: 1,
  point: 1,
  rect: 1,
  rule: 1,
  square: 1,
  text: 1,
  tick: 1,
  trail: 1,
  geoshape: 1
}, MARK_CONFIGS = keys$1(MARK_CONFIG_INDEX);
function isRelativeBandSize(n) {
  return hasProperty(n, "band");
}
const BAR_CORNER_RADIUS_INDEX = {
  horizontal: ["cornerRadiusTopRight", "cornerRadiusBottomRight"],
  vertical: ["cornerRadiusTopLeft", "cornerRadiusTopRight"]
}, DEFAULT_RECT_BAND_SIZE = 5, defaultRectConfig = {
  binSpacing: 0,
  continuousBandSize: DEFAULT_RECT_BAND_SIZE,
  minBandSize: 0.25,
  timeUnitBandPosition: 0.5
}, defaultBarConfig = {
  ...defaultRectConfig,
  binSpacing: 1
}, defaultTickConfig = {
  ...defaultRectConfig,
  thickness: 1
};
function getMarkType(n) {
  return isMarkDef(n) ? n.type : n;
}
function normalizeInvalidDataMode(n, { isPath: t }) {
  return n === void 0 || n === "break-paths-show-path-domains" ? t ? "break-paths-show-domains" : "filter" : n === null ? "show" : n;
}
function getScaleInvalidDataMode({ markDef: n, config: t, scaleChannel: g, scaleType: d, isCountAggregate: k }) {
  if (!d || !hasContinuousDomain(d) || k)
    return "always-valid";
  const H = normalizeInvalidDataMode(getMarkPropOrConfig("invalid", n, t), {
    isPath: isPathMark(n.type)
  });
  return t.scale?.invalid?.[g] !== void 0 ? "show" : H;
}
function shouldBreakPath(n) {
  return n === "break-paths-filter-domains" || n === "break-paths-show-domains";
}
function scaledZeroOrMinOrMax({ scaleName: n, scale: t, mode: g }) {
  const d = `domain('${n}')`;
  if (!t || !n)
    return;
  const k = `${d}[0]`, H = `peek(${d})`, AA = t.domainHasZero();
  return AA === "definitely" ? {
    scale: n,
    value: 0
  } : AA === "maybe" ? { signal: `scale('${n}', inrange(0, ${d}) ? 0 : ${g === "zeroOrMin" ? k : H})` } : { signal: `scale('${n}', ${g === "zeroOrMin" ? k : H})` };
}
function getConditionalValueRefForIncludingInvalidValue({ scaleChannel: n, channelDef: t, scale: g, scaleName: d, markDef: k, config: H }) {
  const AA = g?.get("type"), gA = getFieldDef(t), IA = isCountingAggregateOp(gA?.aggregate), CA = getScaleInvalidDataMode({
    scaleChannel: n,
    markDef: k,
    config: H,
    scaleType: AA,
    isCountAggregate: IA
  });
  if (gA && CA === "show") {
    const BA = H.scale.invalid?.[n] ?? "zero-or-min";
    return {
      test: fieldValidPredicate(vgField(gA, { expr: "datum" }), !1),
      ...refForInvalidValues(BA, g, d)
    };
  }
}
function refForInvalidValues(n, t, g) {
  if (isScaleInvalidDataIncludeAsValue(n)) {
    const { value: d } = n;
    return isSignalRef(d) ? { signal: d.signal } : { value: d };
  }
  return scaledZeroOrMinOrMax({
    scale: t,
    scaleName: g,
    mode: "zeroOrMin"
  });
}
function midPointRefWithPositionInvalidTest(n) {
  const { channel: t, channelDef: g, markDef: d, scale: k, scaleName: H, config: AA } = n, gA = getMainRangeChannel(t), IA = midPoint(n), CA = getConditionalValueRefForIncludingInvalidValue({
    scaleChannel: gA,
    channelDef: g,
    scale: k,
    scaleName: H,
    markDef: d,
    config: AA
  });
  return CA !== void 0 ? [CA, IA] : IA;
}
function datumDefToExpr(n) {
  const { datum: t } = n;
  return isDateTime(t) ? dateTimeToExpr(t) : `${stringify$1(t)}`;
}
function valueRefForFieldOrDatumDef(n, t, g, d) {
  const k = {};
  if (t && (k.scale = t), isDatumDef(n)) {
    const { datum: H } = n;
    isDateTime(H) ? k.signal = dateTimeToExpr(H) : isSignalRef(H) ? k.signal = H.signal : isExprRef(H) ? k.signal = H.expr : k.value = H;
  } else
    k.field = vgField(n, g);
  if (d) {
    const { offset: H, band: AA } = d;
    H && (k.offset = H), AA && (k.band = AA);
  }
  return k;
}
function interpolatedSignalRef({ scaleName: n, fieldOrDatumDef: t, fieldOrDatumDef2: g, offset: d, startSuffix: k, endSuffix: H = "end", bandPosition: AA = 0.5 }) {
  const gA = !isSignalRef(AA) && 0 < AA && AA < 1 ? "datum" : void 0, IA = vgField(t, { expr: gA, suffix: k }), CA = g !== void 0 ? vgField(g, { expr: gA }) : vgField(t, { suffix: H, expr: gA }), BA = {};
  if (AA === 0 || AA === 1) {
    BA.scale = n;
    const eA = AA === 0 ? IA : CA;
    BA.field = eA;
  } else {
    const eA = isSignalRef(AA) ? `(1-${AA.signal}) * ${IA} + ${AA.signal} * ${CA}` : `${1 - AA} * ${IA} + ${AA} * ${CA}`;
    BA.signal = `scale("${n}", ${eA})`;
  }
  return d && (BA.offset = d), BA;
}
function binSizeExpr({ scaleName: n, fieldDef: t }) {
  const g = vgField(t, { expr: "datum" }), d = vgField(t, { expr: "datum", suffix: "end" });
  return `abs(scale("${n}", ${d}) - scale("${n}", ${g}))`;
}
function midPoint({ channel: n, channelDef: t, channel2Def: g, markDef: d, config: k, scaleName: H, scale: AA, stack: gA, offset: IA, defaultRef: CA, bandPosition: BA }) {
  if (t) {
    if (isFieldOrDatumDef(t)) {
      const eA = AA?.get("type");
      if (isTypedFieldDef(t)) {
        BA ??= getBandPosition({
          fieldDef: t,
          fieldDef2: g,
          markDef: d,
          config: k
        });
        const { bin: iA, timeUnit: QA, type: tA } = t;
        if (isBinning(iA) || BA && QA && tA === TEMPORAL)
          return gA?.impute ? valueRefForFieldOrDatumDef(t, H, { binSuffix: "mid" }, { offset: IA }) : BA && !hasDiscreteDomain(eA) ? interpolatedSignalRef({ scaleName: H, fieldOrDatumDef: t, bandPosition: BA, offset: IA }) : valueRefForFieldOrDatumDef(t, H, binRequiresRange(t, n) ? { binSuffix: "range" } : {}, {
            offset: IA
          });
        if (isBinned(iA)) {
          if (isFieldDef(g))
            return interpolatedSignalRef({
              scaleName: H,
              fieldOrDatumDef: t,
              fieldOrDatumDef2: g,
              bandPosition: BA,
              offset: IA
            });
          warn(channelRequiredForBinned(n === X$1 ? X2 : Y2));
        }
      }
      return valueRefForFieldOrDatumDef(
        t,
        H,
        hasDiscreteDomain(eA) ? { binSuffix: "range" } : {},
        // no need for bin suffix if there is no scale
        {
          offset: IA,
          // For band, to get mid point, need to offset by half of the band
          band: eA === "band" ? BA ?? t.bandPosition ?? 0.5 : void 0
        }
      );
    } else if (isValueDef(t)) {
      const eA = t.value, iA = IA ? { offset: IA } : {};
      return { ...widthHeightValueOrSignalRef(n, eA), ...iA };
    }
  }
  return isFunction$4(CA) && (CA = CA()), CA && {
    ...CA,
    // only include offset when it is non-zero (zero = no offset)
    ...IA ? { offset: IA } : {}
  };
}
function widthHeightValueOrSignalRef(n, t) {
  return contains(["x", "x2"], n) && t === "width" ? { field: { group: "width" } } : contains(["y", "y2"], n) && t === "height" ? { field: { group: "height" } } : signalOrValueRef(t);
}
function isCustomFormatType(n) {
  return n && n !== "number" && n !== "time";
}
function customFormatExpr(n, t, g) {
  return `${n}(${t}${g ? `, ${stringify$1(g)}` : ""})`;
}
function formatSignalRef({ fieldOrDatumDef: n, format: t, formatType: g, expr: d, normalizeStack: k, config: H }) {
  if (isCustomFormatType(g))
    return formatCustomType({
      fieldOrDatumDef: n,
      format: t,
      formatType: g,
      expr: d,
      config: H
    });
  const AA = fieldToFormat(n, d, k), gA = channelDefType(n);
  if (t === void 0 && g === void 0 && H.customFormatTypes) {
    if (gA === "quantitative") {
      if (k && H.normalizedNumberFormatType)
        return formatCustomType({
          fieldOrDatumDef: n,
          format: H.normalizedNumberFormat,
          formatType: H.normalizedNumberFormatType,
          expr: d,
          config: H
        });
      if (H.numberFormatType)
        return formatCustomType({
          fieldOrDatumDef: n,
          format: H.numberFormat,
          formatType: H.numberFormatType,
          expr: d,
          config: H
        });
    }
    if (gA === "temporal" && H.timeFormatType && isFieldDef(n) && n.timeUnit === void 0)
      return formatCustomType({
        fieldOrDatumDef: n,
        format: H.timeFormat,
        formatType: H.timeFormatType,
        expr: d,
        config: H
      });
  }
  function IA(CA) {
    return isFieldDef(CA) ? normalizeTimeUnit(CA.timeUnit) || {} : {
      unit: void 0,
      utc: void 0
    };
  }
  if (isFieldOrDatumDefForTimeFormat(n)) {
    const { unit: CA, utc: BA } = IA(n), eA = timeFormatExpression({
      field: AA,
      timeUnit: CA,
      format: t,
      formatType: H.timeFormatType,
      rawTimeFormat: H.timeFormat,
      isUTCScale: BA || isScaleFieldDef(n) && n.scale?.type === ScaleType.UTC
    });
    return eA ? { signal: eA } : void 0;
  }
  if (t = numberFormat({ type: gA, specifiedFormat: t, config: H, normalizeStack: k }), isFieldDef(n) && isBinning(n.bin)) {
    const CA = vgField(n, { expr: d, binSuffix: "end" });
    return {
      signal: binFormatExpression(AA, CA, t, g, H)
    };
  } else return t || channelDefType(n) === "quantitative" ? {
    signal: `${formatExpr(AA, t)}`
  } : { signal: `isValid(${AA}) ? ${AA} : ""+${AA}` };
}
function fieldToFormat(n, t, g) {
  return isFieldDef(n) ? g ? `${vgField(n, { expr: t, suffix: "end" })}-${vgField(n, {
    expr: t,
    suffix: "start"
  })}` : vgField(n, { expr: t }) : datumDefToExpr(n);
}
function formatCustomType({ fieldOrDatumDef: n, format: t, formatType: g, expr: d, normalizeStack: k, config: H, field: AA }) {
  if (AA ??= fieldToFormat(n, d, k), AA !== "datum.value" && // For axis/legend, we can't correctly know the end of the bin from `datum`
  isFieldDef(n) && isBinning(n.bin)) {
    const gA = vgField(n, { expr: d, binSuffix: "end" });
    return {
      signal: binFormatExpression(AA, gA, t, g, H)
    };
  }
  return { signal: customFormatExpr(g, AA, t) };
}
function guideFormat(n, t, g, d, k, H) {
  if (!(isString$1(d) && isCustomFormatType(d)) && !(g === void 0 && d === void 0 && k.customFormatTypes && channelDefType(n) === "quantitative" && (k.normalizedNumberFormatType && isPositionFieldOrDatumDef(n) && n.stack === "normalize" || k.numberFormatType))) {
    if (isPositionFieldOrDatumDef(n) && n.stack === "normalize" && k.normalizedNumberFormat)
      return numberFormat({
        type: "quantitative",
        config: k,
        normalizeStack: !0
      });
    if (isFieldOrDatumDefForTimeFormat(n)) {
      const AA = isFieldDef(n) ? normalizeTimeUnit(n.timeUnit)?.unit : void 0;
      return AA === void 0 && k.customFormatTypes && k.timeFormatType ? void 0 : timeFormat({ specifiedFormat: g, timeUnit: AA, config: k, omitTimeFormatConfig: H });
    }
    return numberFormat({ type: t, specifiedFormat: g, config: k });
  }
}
function guideFormatType(n, t, g) {
  if (n && (isSignalRef(n) || n === "number" || n === "time"))
    return n;
  if (isFieldOrDatumDefForTimeFormat(t) && g !== "time" && g !== "utc")
    return isFieldDef(t) && normalizeTimeUnit(t?.timeUnit)?.utc ? "utc" : "time";
}
function numberFormat({ type: n, specifiedFormat: t, config: g, normalizeStack: d }) {
  if (isString$1(t))
    return t;
  if (n === QUANTITATIVE)
    return d ? g.normalizedNumberFormat : g.numberFormat;
}
function timeFormat({ specifiedFormat: n, timeUnit: t, config: g, omitTimeFormatConfig: d }) {
  return n || (t ? {
    signal: timeUnitSpecifierExpression(t)
  } : d ? void 0 : g.timeFormat);
}
function formatExpr(n, t) {
  return `format(${n}, "${t || ""}")`;
}
function binNumberFormatExpr(n, t, g, d) {
  return isCustomFormatType(g) ? customFormatExpr(g, n, t) : formatExpr(n, (isString$1(t) ? t : void 0) ?? d.numberFormat);
}
function binFormatExpression(n, t, g, d, k) {
  if (g === void 0 && d === void 0 && k.customFormatTypes && k.numberFormatType)
    return binFormatExpression(n, t, k.numberFormat, k.numberFormatType, k);
  const H = binNumberFormatExpr(n, g, d, k), AA = binNumberFormatExpr(t, g, d, k);
  return `${fieldValidPredicate(n, !1)} ? "null" : ${H} + "${BIN_RANGE_DELIMITER}" + ${AA}`;
}
function timeFormatExpression({ field: n, timeUnit: t, format: g, formatType: d, rawTimeFormat: k, isUTCScale: H }) {
  return !t || g ? !t && d ? `${d}(${n}, ${stringify$1(g)})` : (g = isString$1(g) ? g : k, `${H ? "utc" : "time"}Format(${n}, ${stringify$1(g)})`) : formatExpression(t, n, H);
}
const DEFAULT_SORT_OP = "min", SORT_BY_CHANNEL_INDEX = {
  x: 1,
  y: 1,
  color: 1,
  fill: 1,
  stroke: 1,
  strokeWidth: 1,
  size: 1,
  shape: 1,
  fillOpacity: 1,
  strokeOpacity: 1,
  opacity: 1,
  text: 1
};
function isSortByChannel(n) {
  return has(SORT_BY_CHANNEL_INDEX, n);
}
function isSortByEncoding(n) {
  return hasProperty(n, "encoding");
}
function isSortField(n) {
  return n && (n.op === "count" || hasProperty(n, "field"));
}
function isSortArray(n) {
  return n && isArray$2(n);
}
function isFacetMapping(n) {
  return hasProperty(n, "row") || hasProperty(n, "column");
}
function isFacetFieldDef(n) {
  return hasProperty(n, "header");
}
function isFacetSpec(n) {
  return hasProperty(n, "facet");
}
function isConditionalParameter(n) {
  return hasProperty(n, "param");
}
function isRepeatRef(n) {
  return !isString$1(n) && hasProperty(n, "repeat");
}
function toFieldDefBase(n) {
  const { field: t, timeUnit: g, bin: d, aggregate: k } = n;
  return {
    ...g ? { timeUnit: g } : {},
    ...d ? { bin: d } : {},
    ...k ? { aggregate: k } : {},
    field: t
  };
}
function isSortableFieldDef(n) {
  return hasProperty(n, "sort");
}
function getBandPosition({ fieldDef: n, fieldDef2: t, markDef: g, config: d }) {
  if (isFieldOrDatumDef(n) && n.bandPosition !== void 0)
    return n.bandPosition;
  if (isFieldDef(n)) {
    const { timeUnit: k, bin: H } = n;
    if (k && !t)
      return getMarkConfig("timeUnitBandPosition", g, d);
    if (isBinning(H))
      return 0.5;
  }
}
function getBandSize({ channel: n, fieldDef: t, fieldDef2: g, markDef: d, config: k, scaleType: H, useVlSizeChannel: AA }) {
  const gA = getSizeChannel(n), IA = getMarkPropOrConfig(AA ? "size" : gA, d, k, {
    vgChannel: gA
  });
  if (IA !== void 0)
    return IA;
  if (isFieldDef(t)) {
    const { timeUnit: CA, bin: BA } = t;
    if (CA && !g)
      return { band: getMarkConfig("timeUnitBandSize", d, k) };
    if (isBinning(BA) && !hasDiscreteDomain(H))
      return { band: 1 };
  }
  if (isRectBasedMark(d.type))
    return H ? hasDiscreteDomain(H) ? k[d.type]?.discreteBandSize || { band: 1 } : k[d.type]?.continuousBandSize : k[d.type]?.discreteBandSize;
}
function hasBandEnd(n, t, g, d) {
  return isBinning(n.bin) || n.timeUnit && isTypedFieldDef(n) && n.type === "temporal" ? getBandPosition({ fieldDef: n, fieldDef2: t, markDef: g, config: d }) !== void 0 : !1;
}
function isOrderOnlyDef(n) {
  return hasProperty(n, "sort") && !hasProperty(n, "field");
}
function isConditionalDef(n) {
  return hasProperty(n, "condition");
}
function hasConditionalFieldDef(n) {
  const t = n?.condition;
  return !!t && !isArray$2(t) && isFieldDef(t);
}
function hasConditionalFieldOrDatumDef(n) {
  const t = n?.condition;
  return !!t && !isArray$2(t) && isFieldOrDatumDef(t);
}
function hasConditionalValueDef(n) {
  const t = n?.condition;
  return !!t && (isArray$2(t) || isValueDef(t));
}
function isFieldDef(n) {
  return hasProperty(n, "field") || n?.aggregate === "count";
}
function channelDefType(n) {
  return n?.type;
}
function isDatumDef(n) {
  return hasProperty(n, "datum");
}
function isContinuousFieldOrDatumDef(n) {
  return isTypedFieldDef(n) && !isDiscrete(n) || isNumericDataDef(n);
}
function isUnbinnedQuantitativeFieldOrDatumDef(n) {
  return isTypedFieldDef(n) && n.type === "quantitative" && !n.bin || isNumericDataDef(n);
}
function isNumericDataDef(n) {
  return isDatumDef(n) && isNumber$1(n.datum);
}
function isFieldOrDatumDef(n) {
  return isFieldDef(n) || isDatumDef(n);
}
function isTypedFieldDef(n) {
  return n && (hasProperty(n, "field") || n.aggregate === "count") && hasProperty(n, "type");
}
function isValueDef(n) {
  return hasProperty(n, "value");
}
function isScaleFieldDef(n) {
  return hasProperty(n, "scale") || hasProperty(n, "sort");
}
function isPositionFieldOrDatumDef(n) {
  return hasProperty(n, "axis") || hasProperty(n, "stack") || hasProperty(n, "impute");
}
function isMarkPropFieldOrDatumDef(n) {
  return hasProperty(n, "legend");
}
function isStringFieldOrDatumDef(n) {
  return hasProperty(n, "format") || hasProperty(n, "formatType");
}
function toStringFieldDef(n) {
  return omit(n, ["legend", "axis", "header", "scale"]);
}
function isOpFieldDef(n) {
  return hasProperty(n, "op");
}
function vgField(n, t = {}) {
  let g = n.field;
  const d = t.prefix;
  let k = t.suffix, H = "";
  if (isCount(n))
    g = internalField("count");
  else {
    let AA;
    if (!t.nofn)
      if (isOpFieldDef(n))
        AA = n.op;
      else {
        const { bin: gA, aggregate: IA, timeUnit: CA } = n;
        isBinning(gA) ? (AA = binToString(gA), k = (t.binSuffix ?? "") + (t.suffix ?? "")) : IA ? isArgmaxDef(IA) ? (H = `["${g}"]`, g = `argmax_${IA.argmax}`) : isArgminDef(IA) ? (H = `["${g}"]`, g = `argmin_${IA.argmin}`) : AA = String(IA) : CA && !isBinnedTimeUnit(CA) && (AA = timeUnitToString(CA), k = (!["range", "mid"].includes(t.binSuffix) && t.binSuffix || "") + (t.suffix ?? ""));
      }
    AA && (g = g ? `${AA}_${g}` : AA);
  }
  return k && (g = `${g}_${k}`), d && (g = `${d}_${g}`), t.forAs ? removePathFromField(g) : t.expr ? flatAccessWithDatum(g, t.expr) + H : replacePathInField(g) + H;
}
function isDiscrete(n) {
  switch (n.type) {
    case "nominal":
    case "ordinal":
    case "geojson":
      return !0;
    case "quantitative":
      return isFieldDef(n) && !!n.bin;
    case "temporal":
      return !1;
  }
  throw new Error(invalidFieldType(n.type));
}
function isDiscretizing(n) {
  return isScaleFieldDef(n) && isContinuousToDiscrete(n.scale?.type);
}
function isCount(n) {
  return n.aggregate === "count";
}
function verbalTitleFormatter(n, t) {
  const { field: g, bin: d, timeUnit: k, aggregate: H } = n;
  if (H === "count")
    return t.countTitle;
  if (isBinning(d))
    return `${g} (binned)`;
  if (k && !isBinnedTimeUnit(k)) {
    const AA = normalizeTimeUnit(k)?.unit;
    if (AA)
      return `${g} (${getTimeUnitParts(AA).join("-")})`;
  } else if (H)
    return isArgmaxDef(H) ? `${g} for max ${H.argmax}` : isArgminDef(H) ? `${g} for min ${H.argmin}` : `${titleCase(H)} of ${g}`;
  return g;
}
function functionalTitleFormatter(n) {
  const { aggregate: t, bin: g, timeUnit: d, field: k } = n;
  if (isArgmaxDef(t))
    return `${k} for argmax(${t.argmax})`;
  if (isArgminDef(t))
    return `${k} for argmin(${t.argmin})`;
  const H = d && !isBinnedTimeUnit(d) ? normalizeTimeUnit(d) : void 0, AA = t || H?.unit || H?.maxbins && "timeunit" || isBinning(g) && "bin";
  return AA ? `${AA.toUpperCase()}(${k})` : k;
}
const defaultTitleFormatter = (n, t) => {
  switch (t.fieldTitle) {
    case "plain":
      return n.field;
    case "functional":
      return functionalTitleFormatter(n);
    default:
      return verbalTitleFormatter(n, t);
  }
};
let titleFormatter = defaultTitleFormatter;
function setTitleFormatter(n) {
  titleFormatter = n;
}
function resetTitleFormatter() {
  setTitleFormatter(defaultTitleFormatter);
}
function title(n, t, { allowDisabling: g, includeDefault: d = !0 }) {
  const k = getGuide(n)?.title;
  if (!isFieldDef(n))
    return k ?? n.title;
  const H = n, AA = d ? defaultTitle(H, t) : void 0;
  return g ? getFirstDefined(k, H.title, AA) : k ?? H.title ?? AA;
}
function getGuide(n) {
  if (isPositionFieldOrDatumDef(n) && n.axis)
    return n.axis;
  if (isMarkPropFieldOrDatumDef(n) && n.legend)
    return n.legend;
  if (isFacetFieldDef(n) && n.header)
    return n.header;
}
function defaultTitle(n, t) {
  return titleFormatter(n, t);
}
function getFormatMixins(n) {
  if (isStringFieldOrDatumDef(n)) {
    const { format: t, formatType: g } = n;
    return { format: t, formatType: g };
  } else {
    const t = getGuide(n) ?? {}, { format: g, formatType: d } = t;
    return { format: g, formatType: d };
  }
}
function defaultType$2(n, t) {
  switch (t) {
    case "latitude":
    case "longitude":
      return "quantitative";
    case "row":
    case "column":
    case "facet":
    case "shape":
    case "strokeDash":
      return "nominal";
    case "order":
      return "ordinal";
  }
  if (isSortableFieldDef(n) && isArray$2(n.sort))
    return "ordinal";
  const { aggregate: g, bin: d, timeUnit: k } = n;
  if (k)
    return "temporal";
  if (d || g && !isArgmaxDef(g) && !isArgminDef(g))
    return "quantitative";
  if (isScaleFieldDef(n) && n.scale?.type)
    switch (SCALE_CATEGORY_INDEX[n.scale.type]) {
      case "numeric":
      case "discretizing":
        return "quantitative";
      case "time":
        return "temporal";
    }
  return "nominal";
}
function getFieldDef(n) {
  if (isFieldDef(n))
    return n;
  if (hasConditionalFieldDef(n))
    return n.condition;
}
function getFieldOrDatumDef(n) {
  if (isFieldOrDatumDef(n))
    return n;
  if (hasConditionalFieldOrDatumDef(n))
    return n.condition;
}
function initChannelDef(n, t, g, d = {}) {
  if (isString$1(n) || isNumber$1(n) || isBoolean$2(n)) {
    const k = isString$1(n) ? "string" : isNumber$1(n) ? "number" : "boolean";
    return warn(primitiveChannelDef(t, k, n)), { value: n };
  }
  return isFieldOrDatumDef(n) ? initFieldOrDatumDef(n, t, g, d) : hasConditionalFieldOrDatumDef(n) ? {
    ...n,
    // Need to cast as normalizeFieldDef normally return FieldDef, but here we know that it is definitely Condition<FieldDef>
    condition: initFieldOrDatumDef(n.condition, t, g, d)
  } : n;
}
function initFieldOrDatumDef(n, t, g, d) {
  if (isStringFieldOrDatumDef(n)) {
    const { format: k, formatType: H, ...AA } = n;
    if (isCustomFormatType(H) && !g.customFormatTypes)
      return warn(customFormatTypeNotAllowed(t)), initFieldOrDatumDef(AA, t, g, d);
  } else {
    const k = isPositionFieldOrDatumDef(n) ? "axis" : isMarkPropFieldOrDatumDef(n) ? "legend" : isFacetFieldDef(n) ? "header" : null;
    if (k && n[k]) {
      const { format: H, formatType: AA, ...gA } = n[k];
      if (isCustomFormatType(AA) && !g.customFormatTypes)
        return warn(customFormatTypeNotAllowed(t)), initFieldOrDatumDef({ ...n, [k]: gA }, t, g, d);
    }
  }
  return isFieldDef(n) ? initFieldDef(n, t, d) : initDatumDef(n);
}
function initDatumDef(n) {
  let t = n.type;
  if (t)
    return n;
  const { datum: g } = n;
  return t = isNumber$1(g) ? "quantitative" : isString$1(g) ? "nominal" : isDateTime(g) ? "temporal" : void 0, { ...n, type: t };
}
function initFieldDef(n, t, { compositeMark: g = !1 } = {}) {
  const { aggregate: d, timeUnit: k, bin: H, field: AA } = n, gA = { ...n };
  if (!g && d && !isAggregateOp(d) && !isArgmaxDef(d) && !isArgminDef(d) && (warn(invalidAggregate(d)), delete gA.aggregate), k && (gA.timeUnit = normalizeTimeUnit(k)), AA && (gA.field = `${AA}`), isBinning(H) && (gA.bin = normalizeBin(H, t)), isBinned(H) && !isXorY(t) && warn(channelShouldNotBeUsedForBinned(t)), isTypedFieldDef(gA)) {
    const { type: IA } = gA, CA = getFullName(IA);
    IA !== CA && (gA.type = CA), IA !== "quantitative" && isCountingAggregateOp(d) && (warn(invalidFieldTypeForCountAggregate(IA, d)), gA.type = "quantitative");
  } else if (!isSecondaryRangeChannel(t)) {
    const IA = defaultType$2(gA, t);
    gA.type = IA;
  }
  if (isTypedFieldDef(gA)) {
    const { compatible: IA, warning: CA } = channelCompatibility(gA, t) || {};
    IA === !1 && warn(CA);
  }
  if (isSortableFieldDef(gA) && isString$1(gA.sort)) {
    const { sort: IA } = gA;
    if (isSortByChannel(IA))
      return {
        ...gA,
        sort: { encoding: IA }
      };
    const CA = IA.substring(1);
    if (IA.charAt(0) === "-" && isSortByChannel(CA))
      return {
        ...gA,
        sort: { encoding: CA, order: "descending" }
      };
  }
  if (isFacetFieldDef(gA)) {
    const { header: IA } = gA;
    if (IA) {
      const { orient: CA, ...BA } = IA;
      if (CA)
        return {
          ...gA,
          header: {
            ...BA,
            labelOrient: IA.labelOrient || CA,
            titleOrient: IA.titleOrient || CA
          }
        };
    }
  }
  return gA;
}
function normalizeBin(n, t) {
  return isBoolean$2(n) ? { maxbins: autoMaxBins(t) } : n === "binned" ? {
    binned: !0
  } : !n.maxbins && !n.step ? { ...n, maxbins: autoMaxBins(t) } : n;
}
const COMPATIBLE = { compatible: !0 };
function channelCompatibility(n, t) {
  const g = n.type;
  if (g === "geojson" && t !== "shape")
    return {
      compatible: !1,
      warning: `Channel ${t} should not be used with a geojson data.`
    };
  switch (t) {
    case ROW:
    case COLUMN:
    case FACET:
      return isDiscrete(n) ? COMPATIBLE : {
        compatible: !1,
        warning: channelShouldBeDiscrete(t)
      };
    case X$1:
    case Y:
    case XOFFSET:
    case YOFFSET:
    case COLOR:
    case FILL:
    case STROKE:
    case TEXT$1:
    case DETAIL:
    case KEY:
    case TOOLTIP:
    case HREF:
    case URL$1:
    case ANGLE:
    case THETA:
    case RADIUS:
    case DESCRIPTION:
      return COMPATIBLE;
    case LONGITUDE:
    case LONGITUDE2:
    case LATITUDE:
    case LATITUDE2:
      return g !== QUANTITATIVE ? {
        compatible: !1,
        warning: `Channel ${t} should be used with a quantitative field only, not ${n.type} field.`
      } : COMPATIBLE;
    case OPACITY:
    case FILLOPACITY:
    case STROKEOPACITY:
    case STROKEWIDTH:
    case SIZE$2:
    case THETA2:
    case RADIUS2:
    case X2:
    case Y2:
    case TIME:
      return g === "nominal" && !n.sort ? {
        compatible: !1,
        warning: `Channel ${t} should not be used with an unsorted discrete field.`
      } : COMPATIBLE;
    case SHAPE:
    case STROKEDASH:
      return !isDiscrete(n) && !isDiscretizing(n) ? {
        compatible: !1,
        warning: channelShouldBeDiscreteOrDiscretizing(t)
      } : COMPATIBLE;
    case ORDER:
      return n.type === "nominal" && !("sort" in n) ? {
        compatible: !1,
        warning: "Channel order is inappropriate for nominal field, which has no inherent order."
      } : COMPATIBLE;
  }
}
function isFieldOrDatumDefForTimeFormat(n) {
  const { formatType: t } = getFormatMixins(n);
  return t === "time" || !t && isTemporalFieldDef(n);
}
function isTemporalFieldDef(n) {
  return n && (n.type === "temporal" || isFieldDef(n) && !!n.timeUnit);
}
function valueExpr(n, { timeUnit: t, type: g, wrapTime: d, undefinedIfExprNotRequired: k }) {
  const H = t && normalizeTimeUnit(t)?.unit;
  let AA = H || g === "temporal", gA;
  return isExprRef(n) ? gA = n.expr : isSignalRef(n) ? gA = n.signal : isDateTime(n) ? (AA = !0, gA = dateTimeToExpr(n)) : (isString$1(n) || isNumber$1(n)) && AA && (gA = `datetime(${stringify$1(n)})`, isLocalSingleTimeUnit(H) && (isNumber$1(n) && n < 1e4 || isString$1(n) && isNaN(Date.parse(n))) && (gA = dateTimeToExpr({ [H]: n }))), gA ? d && AA ? `time(${gA})` : gA : k ? void 0 : stringify$1(n);
}
function valueArray(n, t) {
  const { type: g } = n;
  return t.map((d) => {
    const k = isFieldDef(n) && !isBinnedTimeUnit(n.timeUnit) ? n.timeUnit : void 0, H = valueExpr(d, {
      timeUnit: k,
      type: g,
      undefinedIfExprNotRequired: !0
    });
    return H !== void 0 ? { signal: H } : d;
  });
}
function binRequiresRange(n, t) {
  return isBinning(n.bin) ? isScaleChannel(t) && ["ordinal", "nominal"].includes(n.type) : (console.warn("Only call this method for binned field defs."), !1);
}
const CONDITIONAL_AXIS_PROP_INDEX = {
  labelAlign: {
    part: "labels",
    vgProp: "align"
  },
  labelBaseline: {
    part: "labels",
    vgProp: "baseline"
  },
  labelColor: {
    part: "labels",
    vgProp: "fill"
  },
  labelFont: {
    part: "labels",
    vgProp: "font"
  },
  labelFontSize: {
    part: "labels",
    vgProp: "fontSize"
  },
  labelFontStyle: {
    part: "labels",
    vgProp: "fontStyle"
  },
  labelFontWeight: {
    part: "labels",
    vgProp: "fontWeight"
  },
  labelOpacity: {
    part: "labels",
    vgProp: "opacity"
  },
  labelOffset: null,
  labelPadding: null,
  // There is no fixed vgProp for tickSize, need to use signal.
  gridColor: {
    part: "grid",
    vgProp: "stroke"
  },
  gridDash: {
    part: "grid",
    vgProp: "strokeDash"
  },
  gridDashOffset: {
    part: "grid",
    vgProp: "strokeDashOffset"
  },
  gridOpacity: {
    part: "grid",
    vgProp: "opacity"
  },
  gridWidth: {
    part: "grid",
    vgProp: "strokeWidth"
  },
  tickColor: {
    part: "ticks",
    vgProp: "stroke"
  },
  tickDash: {
    part: "ticks",
    vgProp: "strokeDash"
  },
  tickDashOffset: {
    part: "ticks",
    vgProp: "strokeDashOffset"
  },
  tickOpacity: {
    part: "ticks",
    vgProp: "opacity"
  },
  tickSize: null,
  // There is no fixed vgProp for tickSize, need to use signal.
  tickWidth: {
    part: "ticks",
    vgProp: "strokeWidth"
  }
};
function isConditionalAxisValue(n) {
  return n?.condition;
}
const AXIS_PARTS = ["domain", "grid", "labels", "ticks", "title"], AXIS_PROPERTY_TYPE = {
  grid: "grid",
  gridCap: "grid",
  gridColor: "grid",
  gridDash: "grid",
  gridDashOffset: "grid",
  gridOpacity: "grid",
  gridScale: "grid",
  gridWidth: "grid",
  orient: "main",
  bandPosition: "both",
  // Need to be applied to grid axis too, so the grid will align with ticks.
  aria: "main",
  description: "main",
  domain: "main",
  domainCap: "main",
  domainColor: "main",
  domainDash: "main",
  domainDashOffset: "main",
  domainOpacity: "main",
  domainWidth: "main",
  format: "main",
  formatType: "main",
  labelAlign: "main",
  labelAngle: "main",
  labelBaseline: "main",
  labelBound: "main",
  labelColor: "main",
  labelFlush: "main",
  labelFlushOffset: "main",
  labelFont: "main",
  labelFontSize: "main",
  labelFontStyle: "main",
  labelFontWeight: "main",
  labelLimit: "main",
  labelLineHeight: "main",
  labelOffset: "main",
  labelOpacity: "main",
  labelOverlap: "main",
  labelPadding: "main",
  labels: "main",
  labelSeparation: "main",
  maxExtent: "main",
  minExtent: "main",
  offset: "both",
  position: "main",
  tickCap: "main",
  tickColor: "main",
  tickDash: "main",
  tickDashOffset: "main",
  tickMinStep: "both",
  tickOffset: "both",
  // Need to be applied to grid axis too, so the grid will align with ticks.
  tickOpacity: "main",
  tickRound: "both",
  // Apply rounding to grid and ticks so they are aligned.
  ticks: "main",
  tickSize: "main",
  tickWidth: "both",
  title: "main",
  titleAlign: "main",
  titleAnchor: "main",
  titleAngle: "main",
  titleBaseline: "main",
  titleColor: "main",
  titleFont: "main",
  titleFontSize: "main",
  titleFontStyle: "main",
  titleFontWeight: "main",
  titleLimit: "main",
  titleLineHeight: "main",
  titleOpacity: "main",
  titlePadding: "main",
  titleX: "main",
  titleY: "main",
  encode: "both",
  // we hide this in Vega-Lite
  scale: "both",
  tickBand: "both",
  tickCount: "both",
  tickExtra: "both",
  translate: "both",
  values: "both",
  zindex: "both"
  // this is actually set afterward, so it doesn't matter
}, COMMON_AXIS_PROPERTIES_INDEX = {
  orient: 1,
  // other things can depend on orient
  aria: 1,
  bandPosition: 1,
  description: 1,
  domain: 1,
  domainCap: 1,
  domainColor: 1,
  domainDash: 1,
  domainDashOffset: 1,
  domainOpacity: 1,
  domainWidth: 1,
  format: 1,
  formatType: 1,
  grid: 1,
  gridCap: 1,
  gridColor: 1,
  gridDash: 1,
  gridDashOffset: 1,
  gridOpacity: 1,
  gridWidth: 1,
  labelAlign: 1,
  labelAngle: 1,
  labelBaseline: 1,
  labelBound: 1,
  labelColor: 1,
  labelFlush: 1,
  labelFlushOffset: 1,
  labelFont: 1,
  labelFontSize: 1,
  labelFontStyle: 1,
  labelFontWeight: 1,
  labelLimit: 1,
  labelLineHeight: 1,
  labelOffset: 1,
  labelOpacity: 1,
  labelOverlap: 1,
  labelPadding: 1,
  labels: 1,
  labelSeparation: 1,
  maxExtent: 1,
  minExtent: 1,
  offset: 1,
  position: 1,
  tickBand: 1,
  tickCap: 1,
  tickColor: 1,
  tickCount: 1,
  tickDash: 1,
  tickDashOffset: 1,
  tickExtra: 1,
  tickMinStep: 1,
  tickOffset: 1,
  tickOpacity: 1,
  tickRound: 1,
  ticks: 1,
  tickSize: 1,
  tickWidth: 1,
  title: 1,
  titleAlign: 1,
  titleAnchor: 1,
  titleAngle: 1,
  titleBaseline: 1,
  titleColor: 1,
  titleFont: 1,
  titleFontSize: 1,
  titleFontStyle: 1,
  titleFontWeight: 1,
  titleLimit: 1,
  titleLineHeight: 1,
  titleOpacity: 1,
  titlePadding: 1,
  titleX: 1,
  titleY: 1,
  translate: 1,
  values: 1,
  zindex: 1
}, AXIS_PROPERTIES_INDEX = {
  ...COMMON_AXIS_PROPERTIES_INDEX,
  style: 1,
  labelExpr: 1,
  encoding: 1
};
function isAxisProperty(n) {
  return has(AXIS_PROPERTIES_INDEX, n);
}
const AXIS_CONFIGS_INDEX = {
  axis: 1,
  axisBand: 1,
  axisBottom: 1,
  axisDiscrete: 1,
  axisLeft: 1,
  axisPoint: 1,
  axisQuantitative: 1,
  axisRight: 1,
  axisTemporal: 1,
  axisTop: 1,
  axisX: 1,
  axisXBand: 1,
  axisXDiscrete: 1,
  axisXPoint: 1,
  axisXQuantitative: 1,
  axisXTemporal: 1,
  axisY: 1,
  axisYBand: 1,
  axisYDiscrete: 1,
  axisYPoint: 1,
  axisYQuantitative: 1,
  axisYTemporal: 1
}, AXIS_CONFIGS = keys$1(AXIS_CONFIGS_INDEX);
function isUnitSpec(n) {
  return hasProperty(n, "mark");
}
class CompositeMarkNormalizer {
  name;
  run;
  constructor(t, g) {
    this.name = t, this.run = g;
  }
  hasMatchingType(t) {
    return isUnitSpec(t) ? getMarkType(t.mark) === this.name : !1;
  }
}
function channelHasField(n, t) {
  const g = n?.[t];
  return g ? isArray$2(g) ? some(g, (d) => !!d.field) : isFieldDef(g) || hasConditionalFieldDef(g) : !1;
}
function channelHasFieldOrDatum(n, t) {
  const g = n?.[t];
  return g ? isArray$2(g) ? some(g, (d) => !!d.field) : isFieldDef(g) || isDatumDef(g) || hasConditionalFieldOrDatumDef(g) : !1;
}
function channelHasNestedOffsetScale(n, t) {
  if (isXorY(t)) {
    const g = n[t];
    if ((isFieldDef(g) || isDatumDef(g)) && (isDiscrete$1(g.type) || isFieldDef(g) && g.timeUnit)) {
      const d = getOffsetScaleChannel(t);
      return channelHasFieldOrDatum(n, d);
    }
  }
  return !1;
}
function isAggregate$1(n) {
  return some(CHANNELS, (t) => {
    if (channelHasField(n, t)) {
      const g = n[t];
      if (isArray$2(g))
        return some(g, (d) => !!d.aggregate);
      {
        const d = getFieldDef(g);
        return d && !!d.aggregate;
      }
    }
    return !1;
  });
}
function extractTransformsFromEncoding(n, t) {
  const g = [], d = [], k = [], H = [], AA = {};
  return forEach$2(n, (gA, IA) => {
    if (isFieldDef(gA)) {
      const { field: CA, aggregate: BA, bin: eA, timeUnit: iA, ...QA } = gA;
      if (BA || iA || eA) {
        const oA = getGuide(gA)?.title;
        let EA = vgField(gA, { forAs: !0 });
        const aA = {
          // Only add title if it doesn't exist
          ...oA ? [] : { title: title(gA, t, { allowDisabling: !0 }) },
          ...QA,
          // Always overwrite field
          field: EA
        };
        if (BA) {
          let nA;
          if (isArgmaxDef(BA) ? (nA = "argmax", EA = vgField({ op: "argmax", field: BA.argmax }, { forAs: !0 }), aA.field = `${EA}.${CA}`) : isArgminDef(BA) ? (nA = "argmin", EA = vgField({ op: "argmin", field: BA.argmin }, { forAs: !0 }), aA.field = `${EA}.${CA}`) : BA !== "boxplot" && BA !== "errorbar" && BA !== "errorband" && (nA = BA), nA) {
            const lA = {
              op: nA,
              as: EA
            };
            CA && (lA.field = CA), H.push(lA);
          }
        } else if (g.push(EA), isTypedFieldDef(gA) && isBinning(eA)) {
          if (d.push({ bin: eA, field: CA, as: EA }), g.push(vgField(gA, { binSuffix: "end" })), binRequiresRange(gA, IA) && g.push(vgField(gA, { binSuffix: "range" })), isXorY(IA)) {
            const nA = {
              field: `${EA}_end`
            };
            AA[`${IA}2`] = nA;
          }
          aA.bin = "binned", isSecondaryRangeChannel(IA) || (aA.type = QUANTITATIVE);
        } else if (iA && !isBinnedTimeUnit(iA)) {
          k.push({
            timeUnit: iA,
            field: CA,
            as: EA
          });
          const nA = isTypedFieldDef(gA) && gA.type !== TEMPORAL && "time";
          nA && (IA === TEXT$1 || IA === TOOLTIP ? aA.formatType = nA : isNonPositionScaleChannel(IA) ? aA.legend = {
            formatType: nA,
            ...aA.legend
          } : isXorY(IA) && (aA.axis = {
            formatType: nA,
            ...aA.axis
          }));
        }
        AA[IA] = aA;
      } else
        g.push(CA), AA[IA] = n[IA];
    } else
      AA[IA] = n[IA];
  }), {
    bins: d,
    timeUnits: k,
    aggregate: H,
    groupby: g,
    encoding: AA
  };
}
function markChannelCompatible(n, t, g) {
  const d = supportMark(t, g);
  if (d) {
    if (d === "binned") {
      const k = n[t === X2 ? X$1 : Y];
      return !!(isFieldDef(k) && isFieldDef(n[t]) && isBinned(k.bin));
    }
  } else return !1;
  return !0;
}
function initEncoding(n, t, g, d) {
  const k = {};
  for (const H of keys$1(n))
    isChannel(H) || warn(invalidEncodingChannel(H));
  for (let H of UNIT_CHANNELS) {
    if (!n[H])
      continue;
    const AA = n[H];
    if (isXorYOffset(H)) {
      const gA = getMainChannelFromOffsetChannel(H), IA = k[gA];
      if (isFieldDef(IA) && isContinuous(IA.type) && isFieldDef(AA) && !IA.timeUnit) {
        warn(offsetNestedInsideContinuousPositionScaleDropped(gA));
        continue;
      }
    }
    if (H === "angle" && t === "arc" && !n.theta && (warn(REPLACE_ANGLE_WITH_THETA), H = THETA), !markChannelCompatible(n, H, t)) {
      warn(incompatibleChannel(H, t));
      continue;
    }
    if (H === SIZE$2 && t === "line" && getFieldDef(n[H])?.aggregate) {
      warn(LINE_WITH_VARYING_SIZE);
      continue;
    }
    if (H === COLOR && (g ? "fill" in n : "stroke" in n)) {
      warn(droppingColor("encoding", { fill: "fill" in n, stroke: "stroke" in n }));
      continue;
    }
    if (H === DETAIL || H === ORDER && !isArray$2(AA) && !isValueDef(AA) || H === TOOLTIP && isArray$2(AA)) {
      if (AA) {
        if (H === ORDER) {
          const gA = n[H];
          if (isOrderOnlyDef(gA)) {
            k[H] = gA;
            continue;
          }
        }
        k[H] = array(AA).reduce((gA, IA) => (isFieldDef(IA) ? gA.push(initFieldDef(IA, H)) : warn(emptyFieldDef(IA, H)), gA), []);
      }
    } else {
      if (H === TOOLTIP && AA === null)
        k[H] = null;
      else if (!isFieldDef(AA) && !isDatumDef(AA) && !isValueDef(AA) && !isConditionalDef(AA) && !isSignalRef(AA)) {
        warn(emptyFieldDef(AA, H));
        continue;
      }
      k[H] = initChannelDef(AA, H, d);
    }
  }
  return k;
}
function normalizeEncoding(n, t) {
  const g = {};
  for (const d of keys$1(n)) {
    const k = initChannelDef(n[d], d, t, { compositeMark: !0 });
    g[d] = k;
  }
  return g;
}
function fieldDefs(n) {
  const t = [];
  for (const g of keys$1(n))
    if (channelHasField(n, g)) {
      const d = n[g], k = array(d);
      for (const H of k)
        isFieldDef(H) ? t.push(H) : hasConditionalFieldDef(H) && t.push(H.condition);
    }
  return t;
}
function forEach$2(n, t, g) {
  if (n)
    for (const d of keys$1(n)) {
      const k = n[d];
      if (isArray$2(k))
        for (const H of k)
          t.call(g, H, d);
      else
        t.call(g, k, d);
    }
}
function reduce(n, t, g, d) {
  return n ? keys$1(n).reduce((k, H) => {
    const AA = n[H];
    return isArray$2(AA) ? AA.reduce((gA, IA) => t.call(d, gA, IA, H), k) : t.call(d, k, AA, H);
  }, g) : g;
}
function pathGroupingFields(n, t) {
  return keys$1(t).reduce((g, d) => {
    switch (d) {
      // x, y, x2, y2, lat, long, lat1, long2, order, tooltip, href, aria label, cursor should not cause lines to group
      case X$1:
      case Y:
      case HREF:
      case DESCRIPTION:
      case URL$1:
      case X2:
      case Y2:
      case XOFFSET:
      case YOFFSET:
      case THETA:
      case THETA2:
      case RADIUS:
      case RADIUS2:
      case TIME:
      // falls through
      case LATITUDE:
      case LONGITUDE:
      case LATITUDE2:
      case LONGITUDE2:
      // TODO: case 'cursor':
      // text, shape, shouldn't be a part of line/trail/area [falls through]
      case TEXT$1:
      case SHAPE:
      case ANGLE:
      // falls through
      // tooltip fields should not be added to group by [falls through]
      case TOOLTIP:
        return g;
      case ORDER:
        if (n === "line" || n === "trail")
          return g;
      // but order should group area for stacking (falls through)
      case DETAIL:
      case KEY: {
        const k = t[d];
        if (isArray$2(k) || isFieldDef(k))
          for (const H of array(k))
            H.aggregate || g.push(vgField(H, {}));
        return g;
      }
      case SIZE$2:
        if (n === "trail")
          return g;
      // For line, size should group lines.
      // falls through
      case COLOR:
      case FILL:
      case STROKE:
      case OPACITY:
      case FILLOPACITY:
      case STROKEOPACITY:
      case STROKEDASH:
      case STROKEWIDTH: {
        const k = getFieldDef(t[d]);
        return k && !k.aggregate && g.push(vgField(k, {})), g;
      }
    }
  }, []);
}
function filterTooltipWithAggregatedField(n) {
  const { tooltip: t, ...g } = n;
  if (!t)
    return { filteredEncoding: g };
  let d, k;
  if (isArray$2(t)) {
    for (const H of t)
      H.aggregate ? (d || (d = []), d.push(H)) : (k || (k = []), k.push(H));
    d && (g.tooltip = d);
  } else
    t.aggregate ? g.tooltip = t : k = t;
  return isArray$2(k) && k.length === 1 && (k = k[0]), { customTooltipWithoutAggregatedField: k, filteredEncoding: g };
}
function getCompositeMarkTooltip(n, t, g, d = !0) {
  if ("tooltip" in g)
    return { tooltip: g.tooltip };
  const k = n.map(({ fieldPrefix: AA, titlePrefix: gA }) => {
    const IA = d ? ` of ${getTitle$1(t)}` : "";
    return {
      field: AA + t.field,
      type: t.type,
      title: isSignalRef(gA) ? { signal: `${gA}"${escape(IA)}"` } : gA + IA
    };
  }), H = fieldDefs(g).map(toStringFieldDef);
  return {
    tooltip: [
      ...k,
      // need to cast because TextFieldDef supports fewer types of bin
      ...unique(H, hash)
    ]
  };
}
function getTitle$1(n) {
  const { title: t, field: g } = n;
  return getFirstDefined(t, g);
}
function makeCompositeAggregatePartFactory(n, t, g, d, k) {
  const { scale: H, axis: AA } = g;
  return ({ partName: gA, mark: IA, positionPrefix: CA, endPositionPrefix: BA = void 0, extraEncoding: eA = {} }) => {
    const iA = getTitle$1(g);
    return partLayerMixins(n, gA, k, {
      mark: IA,
      // TODO better remove this method and just have mark as a parameter of the method
      encoding: {
        [t]: {
          field: `${CA}_${g.field}`,
          type: g.type,
          ...iA !== void 0 ? { title: iA } : {},
          ...H !== void 0 ? { scale: H } : {},
          ...AA !== void 0 ? { axis: AA } : {}
        },
        ...isString$1(BA) ? {
          [`${t}2`]: {
            field: `${BA}_${g.field}`
          }
        } : {},
        ...d,
        ...eA
      }
    });
  };
}
function partLayerMixins(n, t, g, d) {
  const { clip: k, color: H, opacity: AA } = n, gA = n.type;
  return n[t] || n[t] === void 0 && g[t] ? [
    {
      ...d,
      mark: {
        ...g[t],
        ...k ? { clip: k } : {},
        ...H ? { color: H } : {},
        ...AA ? { opacity: AA } : {},
        ...isMarkDef(d.mark) ? d.mark : { type: d.mark },
        style: `${gA}-${String(t)}`,
        ...isBoolean$2(n[t]) ? {} : n[t]
      }
    }
  ] : [];
}
function compositeMarkContinuousAxis(n, t, g) {
  const { encoding: d } = n, k = t === "vertical" ? "y" : "x", H = d[k], AA = d[`${k}2`], gA = d[`${k}Error`], IA = d[`${k}Error2`];
  return {
    continuousAxisChannelDef: filterAggregateFromChannelDef(H, g),
    continuousAxisChannelDef2: filterAggregateFromChannelDef(AA, g),
    continuousAxisChannelDefError: filterAggregateFromChannelDef(gA, g),
    continuousAxisChannelDefError2: filterAggregateFromChannelDef(IA, g),
    continuousAxis: k
  };
}
function filterAggregateFromChannelDef(n, t) {
  if (n?.aggregate) {
    const { aggregate: g, ...d } = n;
    return g !== t && warn(errorBarContinuousAxisHasCustomizedAggregate(g, t)), d;
  } else
    return n;
}
function compositeMarkOrient(n, t) {
  const { mark: g, encoding: d } = n, { x: k, y: H } = d;
  if (isMarkDef(g) && g.orient)
    return g.orient;
  if (isContinuousFieldOrDatumDef(k)) {
    if (isContinuousFieldOrDatumDef(H)) {
      const AA = isFieldDef(k) && k.aggregate, gA = isFieldDef(H) && H.aggregate;
      if (!AA && gA === t)
        return "vertical";
      if (!gA && AA === t)
        return "horizontal";
      if (AA === t && gA === t)
        throw new Error("Both x and y cannot have aggregate");
      return isFieldOrDatumDefForTimeFormat(H) && !isFieldOrDatumDefForTimeFormat(k) ? "horizontal" : "vertical";
    }
    return "horizontal";
  } else {
    if (isContinuousFieldOrDatumDef(H))
      return "vertical";
    throw new Error(`Need a valid continuous axis for ${t}s`);
  }
}
const BOXPLOT = "boxplot", BOXPLOT_PARTS = ["box", "median", "outliers", "rule", "ticks"], boxPlotNormalizer = new CompositeMarkNormalizer(BOXPLOT, normalizeBoxPlot);
function getBoxPlotType(n) {
  return isNumber$1(n) ? "tukey" : n;
}
function normalizeBoxPlot(n, { config: t }) {
  n = {
    ...n,
    encoding: normalizeEncoding(n.encoding, t)
  };
  const { mark: g, encoding: d, params: k, projection: H, ...AA } = n, gA = isMarkDef(g) ? g : { type: g };
  k && warn(selectionNotSupported("boxplot"));
  const IA = gA.extent ?? t.boxplot.extent, CA = getMarkPropOrConfig(
    "size",
    gA,
    // TODO: https://github.com/vega/vega-lite/issues/6245
    t
  ), BA = gA.invalid, eA = getBoxPlotType(IA), { bins: iA, timeUnits: QA, transform: tA, continuousAxisChannelDef: oA, continuousAxis: EA, groupby: aA, aggregate: nA, encodingWithoutContinuousAxis: lA, ticksOrient: cA, boxOrient: sA, customTooltipWithoutAggregatedField: rA } = boxParams(n, IA, t), uA = removePathFromField(oA.field), { color: hA, size: dA, ...GA } = lA, DA = (HA) => makeCompositeAggregatePartFactory(gA, EA, oA, HA, t.boxplot), wA = DA(GA), bA = DA(lA), yA = (isObject$3(t.boxplot.box) ? t.boxplot.box.color : t.mark.color) || "#4c78a8", pA = DA({
    ...GA,
    ...dA ? { size: dA } : {},
    color: {
      condition: {
        test: `${accessWithDatumToUnescapedPath(`lower_box_${oA.field}`)} >= ${accessWithDatumToUnescapedPath(`upper_box_${oA.field}`)}`,
        ...hA || { value: yA }
      }
    }
  }), MA = getCompositeMarkTooltip([
    { fieldPrefix: eA === "min-max" ? "upper_whisker_" : "max_", titlePrefix: "Max" },
    { fieldPrefix: "upper_box_", titlePrefix: "Q3" },
    { fieldPrefix: "mid_box_", titlePrefix: "Median" },
    { fieldPrefix: "lower_box_", titlePrefix: "Q1" },
    { fieldPrefix: eA === "min-max" ? "lower_whisker_" : "min_", titlePrefix: "Min" }
  ], oA, lA), LA = { type: "tick", color: "black", opacity: 1, orient: cA, invalid: BA, aria: !1 }, xA = eA === "min-max" ? MA : (
    // for tukey / k-IQR, just show upper/lower-whisker
    getCompositeMarkTooltip([
      { fieldPrefix: "upper_whisker_", titlePrefix: "Upper Whisker" },
      { fieldPrefix: "lower_whisker_", titlePrefix: "Lower Whisker" }
    ], oA, lA)
  ), TA = [
    ...wA({
      partName: "rule",
      mark: { type: "rule", invalid: BA, aria: !1 },
      positionPrefix: "lower_whisker",
      endPositionPrefix: "lower_box",
      extraEncoding: xA
    }),
    ...wA({
      partName: "rule",
      mark: { type: "rule", invalid: BA, aria: !1 },
      positionPrefix: "upper_box",
      endPositionPrefix: "upper_whisker",
      extraEncoding: xA
    }),
    ...wA({
      partName: "ticks",
      mark: LA,
      positionPrefix: "lower_whisker",
      extraEncoding: xA
    }),
    ...wA({
      partName: "ticks",
      mark: LA,
      positionPrefix: "upper_whisker",
      extraEncoding: xA
    })
  ], NA = [
    ...eA !== "tukey" ? TA : [],
    ...bA({
      partName: "box",
      mark: {
        type: "bar",
        ...CA ? { size: CA } : {},
        orient: sA,
        invalid: BA,
        ariaRoleDescription: "box"
      },
      positionPrefix: "lower_box",
      endPositionPrefix: "upper_box",
      extraEncoding: MA
    }),
    ...pA({
      partName: "median",
      mark: {
        type: "tick",
        invalid: BA,
        ...isObject$3(t.boxplot.median) && t.boxplot.median.color ? { color: t.boxplot.median.color } : {},
        ...CA ? { size: CA } : {},
        orient: cA,
        aria: !1
      },
      positionPrefix: "mid_box",
      extraEncoding: MA
    })
  ];
  if (eA === "min-max")
    return {
      ...AA,
      transform: (AA.transform ?? []).concat(tA),
      layer: NA
    };
  const zA = accessWithDatumToUnescapedPath(`lower_box_${oA.field}`), XA = accessWithDatumToUnescapedPath(`upper_box_${oA.field}`), fA = `(${XA} - ${zA})`, vA = `${zA} - ${IA} * ${fA}`, Cg = `${XA} + ${IA} * ${fA}`, Ig = accessWithDatumToUnescapedPath(oA.field), gg = {
    joinaggregate: boxParamsQuartiles(oA.field),
    groupby: aA
  }, og = {
    transform: [
      {
        filter: `(${vA} <= ${Ig}) && (${Ig} <= ${Cg})`
      },
      {
        aggregate: [
          {
            op: "min",
            field: oA.field,
            as: `lower_whisker_${uA}`
          },
          {
            op: "max",
            field: oA.field,
            as: `upper_whisker_${uA}`
          },
          // preserve lower_box / upper_box
          {
            op: "min",
            field: `lower_box_${oA.field}`,
            as: `lower_box_${uA}`
          },
          {
            op: "max",
            field: `upper_box_${oA.field}`,
            as: `upper_box_${uA}`
          },
          ...nA
        ],
        groupby: aA
      }
    ],
    layer: TA
  }, { tooltip: eg, ...kA } = GA, { scale: YA, axis: RA } = oA, FA = getTitle$1(oA), mA = partLayerMixins(gA, "outliers", t.boxplot, {
    transform: [{ filter: `(${Ig} < ${vA}) || (${Ig} > ${Cg})` }],
    mark: "point",
    encoding: {
      [EA]: {
        field: oA.field,
        type: oA.type,
        ...FA !== void 0 ? { title: FA } : {},
        ...YA !== void 0 ? { scale: YA } : {},
        ...RA !== void 0 ? { axis: RA } : {}
      },
      ...kA,
      ...hA ? { color: hA } : {},
      ...rA ? { tooltip: rA } : {}
    }
  })[0];
  let JA;
  const VA = [...iA, ...QA, gg];
  return mA ? JA = {
    transform: VA,
    layer: [mA, og]
  } : (JA = og, JA.transform.unshift(...VA)), {
    ...AA,
    layer: [
      JA,
      {
        // boxplot
        transform: tA,
        layer: NA
      }
    ]
  };
}
function boxParamsQuartiles(n) {
  const t = removePathFromField(n);
  return [
    {
      op: "q1",
      field: n,
      as: `lower_box_${t}`
    },
    {
      op: "q3",
      field: n,
      as: `upper_box_${t}`
    }
  ];
}
function boxParams(n, t, g) {
  const d = compositeMarkOrient(n, BOXPLOT), { continuousAxisChannelDef: k, continuousAxis: H } = compositeMarkContinuousAxis(n, d, BOXPLOT), AA = k.field, gA = removePathFromField(AA), IA = getBoxPlotType(t), CA = [
    ...boxParamsQuartiles(AA),
    {
      op: "median",
      field: AA,
      as: `mid_box_${gA}`
    },
    {
      op: "min",
      field: AA,
      as: (IA === "min-max" ? "lower_whisker_" : "min_") + gA
    },
    {
      op: "max",
      field: AA,
      as: (IA === "min-max" ? "upper_whisker_" : "max_") + gA
    }
  ], BA = IA === "min-max" || IA === "tukey" ? [] : [
    // This is for the  original k-IQR, which we do not expose
    {
      calculate: `${accessWithDatumToUnescapedPath(`upper_box_${gA}`)} - ${accessWithDatumToUnescapedPath(`lower_box_${gA}`)}`,
      as: `iqr_${gA}`
    },
    {
      calculate: `min(${accessWithDatumToUnescapedPath(`upper_box_${gA}`)} + ${accessWithDatumToUnescapedPath(`iqr_${gA}`)} * ${t}, ${accessWithDatumToUnescapedPath(`max_${gA}`)})`,
      as: `upper_whisker_${gA}`
    },
    {
      calculate: `max(${accessWithDatumToUnescapedPath(`lower_box_${gA}`)} - ${accessWithDatumToUnescapedPath(`iqr_${gA}`)} * ${t}, ${accessWithDatumToUnescapedPath(`min_${gA}`)})`,
      as: `lower_whisker_${gA}`
    }
  ], { [H]: eA, ...iA } = n.encoding, { customTooltipWithoutAggregatedField: QA, filteredEncoding: tA } = filterTooltipWithAggregatedField(iA), { bins: oA, timeUnits: EA, aggregate: aA, groupby: nA, encoding: lA } = extractTransformsFromEncoding(tA, g), cA = d === "vertical" ? "horizontal" : "vertical", sA = d, rA = [
    ...oA,
    ...EA,
    {
      aggregate: [...aA, ...CA],
      groupby: nA
    },
    ...BA
  ];
  return {
    bins: oA,
    timeUnits: EA,
    transform: rA,
    groupby: nA,
    aggregate: aA,
    continuousAxisChannelDef: k,
    continuousAxis: H,
    encodingWithoutContinuousAxis: lA,
    ticksOrient: cA,
    boxOrient: sA,
    customTooltipWithoutAggregatedField: QA
  };
}
const ERRORBAR = "errorbar", ERRORBAR_PARTS = ["ticks", "rule"], errorBarNormalizer = new CompositeMarkNormalizer(ERRORBAR, normalizeErrorBar);
function normalizeErrorBar(n, { config: t }) {
  n = {
    ...n,
    encoding: normalizeEncoding(n.encoding, t)
  };
  const { transform: g, continuousAxisChannelDef: d, continuousAxis: k, encodingWithoutContinuousAxis: H, ticksOrient: AA, markDef: gA, outerSpec: IA, tooltipEncoding: CA } = errorBarParams(n, ERRORBAR, t);
  delete H.size;
  const BA = makeCompositeAggregatePartFactory(gA, k, d, H, t.errorbar), eA = gA.thickness, iA = gA.size, QA = {
    type: "tick",
    orient: AA,
    aria: !1,
    ...eA !== void 0 ? { thickness: eA } : {},
    ...iA !== void 0 ? { size: iA } : {}
  }, tA = [
    ...BA({
      partName: "ticks",
      mark: QA,
      positionPrefix: "lower",
      extraEncoding: CA
    }),
    ...BA({
      partName: "ticks",
      mark: QA,
      positionPrefix: "upper",
      extraEncoding: CA
    }),
    ...BA({
      partName: "rule",
      mark: {
        type: "rule",
        ariaRoleDescription: "errorbar",
        ...eA !== void 0 ? { size: eA } : {}
      },
      positionPrefix: "lower",
      endPositionPrefix: "upper",
      extraEncoding: CA
    })
  ];
  return {
    ...IA,
    transform: g,
    ...tA.length > 1 ? { layer: tA } : { ...tA[0] }
  };
}
function errorBarOrientAndInputType(n, t) {
  const { encoding: g } = n;
  if (errorBarIsInputTypeRaw(g))
    return {
      orient: compositeMarkOrient(n, t),
      inputType: "raw"
    };
  const d = errorBarIsInputTypeAggregatedUpperLower(g), k = errorBarIsInputTypeAggregatedError(g), H = g.x, AA = g.y;
  if (d) {
    if (k)
      throw new Error(`${t} cannot be both type aggregated-upper-lower and aggregated-error`);
    const gA = g.x2, IA = g.y2;
    if (isFieldOrDatumDef(gA) && isFieldOrDatumDef(IA))
      throw new Error(`${t} cannot have both x2 and y2`);
    if (isFieldOrDatumDef(gA)) {
      if (isContinuousFieldOrDatumDef(H))
        return { orient: "horizontal", inputType: "aggregated-upper-lower" };
      throw new Error(`Both x and x2 have to be quantitative in ${t}`);
    } else if (isFieldOrDatumDef(IA)) {
      if (isContinuousFieldOrDatumDef(AA))
        return { orient: "vertical", inputType: "aggregated-upper-lower" };
      throw new Error(`Both y and y2 have to be quantitative in ${t}`);
    }
    throw new Error("No ranged axis");
  } else {
    const gA = g.xError, IA = g.xError2, CA = g.yError, BA = g.yError2;
    if (isFieldOrDatumDef(IA) && !isFieldOrDatumDef(gA))
      throw new Error(`${t} cannot have xError2 without xError`);
    if (isFieldOrDatumDef(BA) && !isFieldOrDatumDef(CA))
      throw new Error(`${t} cannot have yError2 without yError`);
    if (isFieldOrDatumDef(gA) && isFieldOrDatumDef(CA))
      throw new Error(`${t} cannot have both xError and yError with both are quantiative`);
    if (isFieldOrDatumDef(gA)) {
      if (isContinuousFieldOrDatumDef(H))
        return { orient: "horizontal", inputType: "aggregated-error" };
      throw new Error("All x, xError, and xError2 (if exist) have to be quantitative");
    } else if (isFieldOrDatumDef(CA)) {
      if (isContinuousFieldOrDatumDef(AA))
        return { orient: "vertical", inputType: "aggregated-error" };
      throw new Error("All y, yError, and yError2 (if exist) have to be quantitative");
    }
    throw new Error("No ranged axis");
  }
}
function errorBarIsInputTypeRaw(n) {
  return (isFieldOrDatumDef(n.x) || isFieldOrDatumDef(n.y)) && !isFieldOrDatumDef(n.x2) && !isFieldOrDatumDef(n.y2) && !isFieldOrDatumDef(n.xError) && !isFieldOrDatumDef(n.xError2) && !isFieldOrDatumDef(n.yError) && !isFieldOrDatumDef(n.yError2);
}
function errorBarIsInputTypeAggregatedUpperLower(n) {
  return isFieldOrDatumDef(n.x2) || isFieldOrDatumDef(n.y2);
}
function errorBarIsInputTypeAggregatedError(n) {
  return isFieldOrDatumDef(n.xError) || isFieldOrDatumDef(n.xError2) || isFieldOrDatumDef(n.yError) || isFieldOrDatumDef(n.yError2);
}
function errorBarParams(n, t, g) {
  const { mark: d, encoding: k, params: H, projection: AA, ...gA } = n, IA = isMarkDef(d) ? d : { type: d };
  H && warn(selectionNotSupported(t));
  const { orient: CA, inputType: BA } = errorBarOrientAndInputType(n, t), { continuousAxisChannelDef: eA, continuousAxisChannelDef2: iA, continuousAxisChannelDefError: QA, continuousAxisChannelDefError2: tA, continuousAxis: oA } = compositeMarkContinuousAxis(n, CA, t), { errorBarSpecificAggregate: EA, postAggregateCalculates: aA, tooltipSummary: nA, tooltipTitleWithFieldName: lA } = errorBarAggregationAndCalculation(IA, eA, iA, QA, tA, BA, t, g), { [oA]: cA, [oA === "x" ? "x2" : "y2"]: sA, [oA === "x" ? "xError" : "yError"]: rA, [oA === "x" ? "xError2" : "yError2"]: uA, ...hA } = k, { bins: dA, timeUnits: GA, aggregate: DA, groupby: wA, encoding: bA } = extractTransformsFromEncoding(hA, g), yA = [...DA, ...EA], pA = BA !== "raw" ? [] : wA, MA = getCompositeMarkTooltip(nA, eA, bA, lA);
  return {
    transform: [
      ...gA.transform ?? [],
      ...dA,
      ...GA,
      ...yA.length === 0 ? [] : [{ aggregate: yA, groupby: pA }],
      ...aA
    ],
    groupby: pA,
    continuousAxisChannelDef: eA,
    continuousAxis: oA,
    encodingWithoutContinuousAxis: bA,
    ticksOrient: CA === "vertical" ? "horizontal" : "vertical",
    markDef: IA,
    outerSpec: gA,
    tooltipEncoding: MA
  };
}
function errorBarAggregationAndCalculation(n, t, g, d, k, H, AA, gA) {
  let IA = [], CA = [];
  const BA = t.field;
  let eA, iA = !1;
  if (H === "raw") {
    const QA = n.center ? n.center : n.extent ? n.extent === "iqr" ? "median" : "mean" : gA.errorbar.center, tA = n.extent ? n.extent : QA === "mean" ? "stderr" : "iqr";
    if (QA === "median" != (tA === "iqr") && warn(errorBarCenterIsUsedWithWrongExtent(QA, tA, AA)), tA === "stderr" || tA === "stdev")
      IA = [
        { op: tA, field: BA, as: `extent_${BA}` },
        { op: QA, field: BA, as: `center_${BA}` }
      ], CA = [
        {
          calculate: `${accessWithDatumToUnescapedPath(`center_${BA}`)} + ${accessWithDatumToUnescapedPath(`extent_${BA}`)}`,
          as: `upper_${BA}`
        },
        {
          calculate: `${accessWithDatumToUnescapedPath(`center_${BA}`)} - ${accessWithDatumToUnescapedPath(`extent_${BA}`)}`,
          as: `lower_${BA}`
        }
      ], eA = [
        { fieldPrefix: "center_", titlePrefix: titleCase(QA) },
        { fieldPrefix: "upper_", titlePrefix: getTitlePrefix(QA, tA, "+") },
        { fieldPrefix: "lower_", titlePrefix: getTitlePrefix(QA, tA, "-") }
      ], iA = !0;
    else {
      let oA, EA, aA;
      tA === "ci" ? (oA = "mean", EA = "ci0", aA = "ci1") : (oA = "median", EA = "q1", aA = "q3"), IA = [
        { op: EA, field: BA, as: `lower_${BA}` },
        { op: aA, field: BA, as: `upper_${BA}` },
        { op: oA, field: BA, as: `center_${BA}` }
      ], eA = [
        {
          fieldPrefix: "upper_",
          titlePrefix: title({ field: BA, aggregate: aA, type: "quantitative" }, gA, {
            allowDisabling: !1
          })
        },
        {
          fieldPrefix: "lower_",
          titlePrefix: title({ field: BA, aggregate: EA, type: "quantitative" }, gA, {
            allowDisabling: !1
          })
        },
        {
          fieldPrefix: "center_",
          titlePrefix: title({ field: BA, aggregate: oA, type: "quantitative" }, gA, {
            allowDisabling: !1
          })
        }
      ];
    }
  } else {
    (n.center || n.extent) && warn(errorBarCenterAndExtentAreNotNeeded(n.center, n.extent)), H === "aggregated-upper-lower" ? (eA = [], CA = [
      {
        calculate: accessWithDatumToUnescapedPath(g.field),
        as: `upper_${BA}`
      },
      { calculate: accessWithDatumToUnescapedPath(BA), as: `lower_${BA}` }
    ]) : H === "aggregated-error" && (eA = [{ fieldPrefix: "", titlePrefix: BA }], CA = [
      {
        calculate: `${accessWithDatumToUnescapedPath(BA)} + ${accessWithDatumToUnescapedPath(d.field)}`,
        as: `upper_${BA}`
      }
    ], k ? CA.push({
      calculate: `${accessWithDatumToUnescapedPath(BA)} + ${accessWithDatumToUnescapedPath(k.field)}`,
      as: `lower_${BA}`
    }) : CA.push({
      calculate: `${accessWithDatumToUnescapedPath(BA)} - ${accessWithDatumToUnescapedPath(d.field)}`,
      as: `lower_${BA}`
    }));
    for (const QA of CA)
      eA.push({
        fieldPrefix: QA.as.substring(0, 6),
        titlePrefix: replaceAll(replaceAll(QA.calculate, "datum['", ""), "']", "")
      });
  }
  return { postAggregateCalculates: CA, errorBarSpecificAggregate: IA, tooltipSummary: eA, tooltipTitleWithFieldName: iA };
}
function getTitlePrefix(n, t, g) {
  return `${titleCase(n)} ${g} ${t}`;
}
const ERRORBAND = "errorband", ERRORBAND_PARTS = ["band", "borders"], errorBandNormalizer = new CompositeMarkNormalizer(ERRORBAND, normalizeErrorBand);
function normalizeErrorBand(n, { config: t }) {
  n = {
    ...n,
    encoding: normalizeEncoding(n.encoding, t)
  };
  const { transform: g, continuousAxisChannelDef: d, continuousAxis: k, encodingWithoutContinuousAxis: H, markDef: AA, outerSpec: gA, tooltipEncoding: IA } = errorBarParams(n, ERRORBAND, t), CA = AA, BA = makeCompositeAggregatePartFactory(CA, k, d, H, t.errorband), eA = n.encoding.x !== void 0 && n.encoding.y !== void 0;
  let iA = { type: eA ? "area" : "rect" }, QA = { type: eA ? "line" : "rule" };
  const tA = {
    ...CA.interpolate ? { interpolate: CA.interpolate } : {},
    ...CA.tension && CA.interpolate ? { tension: CA.tension } : {}
  };
  return eA ? (iA = {
    ...iA,
    ...tA,
    ariaRoleDescription: "errorband"
  }, QA = {
    ...QA,
    ...tA,
    aria: !1
  }) : CA.interpolate ? warn(errorBand1DNotSupport("interpolate")) : CA.tension && warn(errorBand1DNotSupport("tension")), {
    ...gA,
    transform: g,
    layer: [
      ...BA({
        partName: "band",
        mark: iA,
        positionPrefix: "lower",
        endPositionPrefix: "upper",
        extraEncoding: IA
      }),
      ...BA({
        partName: "borders",
        mark: QA,
        positionPrefix: "lower",
        extraEncoding: IA
      }),
      ...BA({
        partName: "borders",
        mark: QA,
        positionPrefix: "upper",
        extraEncoding: IA
      })
    ]
  };
}
const compositeMarkRegistry = {};
function add(n, t, g) {
  const d = new CompositeMarkNormalizer(n, t);
  compositeMarkRegistry[n] = { normalizer: d, parts: g };
}
function getAllCompositeMarks() {
  return keys$1(compositeMarkRegistry);
}
add(BOXPLOT, normalizeBoxPlot, BOXPLOT_PARTS);
add(ERRORBAR, normalizeErrorBar, ERRORBAR_PARTS);
add(ERRORBAND, normalizeErrorBand, ERRORBAND_PARTS);
const VL_ONLY_LEGEND_CONFIG = [
  "gradientHorizontalMaxLength",
  "gradientHorizontalMinLength",
  "gradientVerticalMaxLength",
  "gradientVerticalMinLength",
  "unselectedOpacity"
], HEADER_TITLE_PROPERTIES_MAP = {
  titleAlign: "align",
  titleAnchor: "anchor",
  titleAngle: "angle",
  titleBaseline: "baseline",
  titleColor: "color",
  titleFont: "font",
  titleFontSize: "fontSize",
  titleFontStyle: "fontStyle",
  titleFontWeight: "fontWeight",
  titleLimit: "limit",
  titleLineHeight: "lineHeight",
  titleOrient: "orient",
  titlePadding: "offset"
}, HEADER_LABEL_PROPERTIES_MAP = {
  labelAlign: "align",
  labelAnchor: "anchor",
  labelAngle: "angle",
  labelBaseline: "baseline",
  labelColor: "color",
  labelFont: "font",
  labelFontSize: "fontSize",
  labelFontStyle: "fontStyle",
  labelFontWeight: "fontWeight",
  labelLimit: "limit",
  labelLineHeight: "lineHeight",
  labelOrient: "orient",
  labelPadding: "offset"
}, HEADER_TITLE_PROPERTIES = keys$1(HEADER_TITLE_PROPERTIES_MAP), HEADER_LABEL_PROPERTIES = keys$1(HEADER_LABEL_PROPERTIES_MAP), HEADER_CONFIGS_INDEX = {
  header: 1,
  headerRow: 1,
  headerColumn: 1,
  headerFacet: 1
}, HEADER_CONFIGS = keys$1(HEADER_CONFIGS_INDEX), LEGEND_SCALE_CHANNELS = [
  "size",
  "shape",
  "fill",
  "stroke",
  "strokeDash",
  "strokeWidth",
  "opacity"
], defaultLegendConfig = {
  gradientHorizontalMaxLength: 200,
  gradientHorizontalMinLength: 100,
  gradientVerticalMaxLength: 200,
  gradientVerticalMinLength: 64,
  // This is Vega's minimum.
  unselectedOpacity: 0.35
}, COMMON_LEGEND_PROPERTY_INDEX = {
  aria: 1,
  clipHeight: 1,
  columnPadding: 1,
  columns: 1,
  cornerRadius: 1,
  description: 1,
  direction: 1,
  fillColor: 1,
  format: 1,
  formatType: 1,
  gradientLength: 1,
  gradientOpacity: 1,
  gradientStrokeColor: 1,
  gradientStrokeWidth: 1,
  gradientThickness: 1,
  gridAlign: 1,
  labelAlign: 1,
  labelBaseline: 1,
  labelColor: 1,
  labelFont: 1,
  labelFontSize: 1,
  labelFontStyle: 1,
  labelFontWeight: 1,
  labelLimit: 1,
  labelOffset: 1,
  labelOpacity: 1,
  labelOverlap: 1,
  labelPadding: 1,
  labelSeparation: 1,
  legendX: 1,
  legendY: 1,
  offset: 1,
  orient: 1,
  padding: 1,
  rowPadding: 1,
  strokeColor: 1,
  symbolDash: 1,
  symbolDashOffset: 1,
  symbolFillColor: 1,
  symbolLimit: 1,
  symbolOffset: 1,
  symbolOpacity: 1,
  symbolSize: 1,
  symbolStrokeColor: 1,
  symbolStrokeWidth: 1,
  symbolType: 1,
  tickCount: 1,
  tickMinStep: 1,
  title: 1,
  titleAlign: 1,
  titleAnchor: 1,
  titleBaseline: 1,
  titleColor: 1,
  titleFont: 1,
  titleFontSize: 1,
  titleFontStyle: 1,
  titleFontWeight: 1,
  titleLimit: 1,
  titleLineHeight: 1,
  titleOpacity: 1,
  titleOrient: 1,
  titlePadding: 1,
  type: 1,
  values: 1,
  zindex: 1
}, SELECTION_ID = "_vgsid_", defaultConfig$1 = {
  point: {
    on: "click",
    fields: [SELECTION_ID],
    toggle: "event.shiftKey",
    resolve: "global",
    clear: "dblclick"
  },
  interval: {
    on: "[pointerdown, window:pointerup] > window:pointermove!",
    encodings: ["x", "y"],
    translate: "[pointerdown, window:pointerup] > window:pointermove!",
    zoom: "wheel!",
    mark: { fill: "#333", fillOpacity: 0.125, stroke: "white" },
    resolve: "global",
    clear: "dblclick"
  }
};
function isLegendBinding(n) {
  return n === "legend" || !!n?.legend;
}
function isLegendStreamBinding(n) {
  return isLegendBinding(n) && isObject$3(n);
}
function isSelectionParameter(n) {
  return !!n?.select;
}
function assembleParameterSignals(n) {
  const t = [];
  for (const g of n || []) {
    if (isSelectionParameter(g))
      continue;
    const { expr: d, bind: k, ...H } = g;
    if (k && d) {
      const AA = {
        ...H,
        bind: k,
        init: d
      };
      t.push(AA);
    } else {
      const AA = {
        ...H,
        ...d ? { update: d } : {},
        ...k ? { bind: k } : {}
      };
      t.push(AA);
    }
  }
  return t;
}
function isAnyConcatSpec(n) {
  return isVConcatSpec(n) || isHConcatSpec(n) || isConcatSpec(n);
}
function isConcatSpec(n) {
  return hasProperty(n, "concat");
}
function isVConcatSpec(n) {
  return hasProperty(n, "vconcat");
}
function isHConcatSpec(n) {
  return hasProperty(n, "hconcat");
}
function getStepFor({ step: n, offsetIsDiscrete: t }) {
  return t ? n.for ?? "offset" : "position";
}
function isStep(n) {
  return hasProperty(n, "step");
}
function isFrameMixins(n) {
  return hasProperty(n, "view") || hasProperty(n, "width") || hasProperty(n, "height");
}
const DEFAULT_SPACING = 20, COMPOSITION_LAYOUT_INDEX = {
  align: 1,
  bounds: 1,
  center: 1,
  columns: 1,
  spacing: 1
}, COMPOSITION_LAYOUT_PROPERTIES = keys$1(COMPOSITION_LAYOUT_INDEX);
function extractCompositionLayout(n, t, g) {
  const d = g[t], k = {}, { spacing: H, columns: AA } = d;
  H !== void 0 && (k.spacing = H), AA !== void 0 && (isFacetSpec(n) && !isFacetMapping(n.facet) || isConcatSpec(n)) && (k.columns = AA), isVConcatSpec(n) && (k.columns = 1);
  for (const gA of COMPOSITION_LAYOUT_PROPERTIES)
    if (n[gA] !== void 0)
      if (gA === "spacing") {
        const IA = n[gA];
        k[gA] = isNumber$1(IA) ? IA : {
          row: IA.row ?? H,
          column: IA.column ?? H
        };
      } else
        k[gA] = n[gA];
  return k;
}
function getViewConfigContinuousSize(n, t) {
  return n[t] ?? n[t === "width" ? "continuousWidth" : "continuousHeight"];
}
function getViewConfigDiscreteStep(n, t) {
  const g = getViewConfigDiscreteSize(n, t);
  return isStep(g) ? g.step : DEFAULT_STEP;
}
function getViewConfigDiscreteSize(n, t) {
  const g = n[t] ?? n[t === "width" ? "discreteWidth" : "discreteHeight"];
  return getFirstDefined(g, { step: n.step });
}
const DEFAULT_STEP = 20, defaultViewConfig = {
  continuousWidth: 300,
  continuousHeight: 300,
  step: DEFAULT_STEP
}, defaultConfig = {
  background: "white",
  padding: 5,
  timeFormat: "%b %d, %Y",
  countTitle: "Count of Records",
  view: defaultViewConfig,
  mark: defaultMarkConfig,
  arc: {},
  area: {},
  bar: defaultBarConfig,
  circle: {},
  geoshape: {},
  image: {},
  line: {},
  point: {},
  rect: defaultRectConfig,
  rule: { color: "black" },
  // Need this to override default color in mark config
  square: {},
  text: { color: "black" },
  // Need this to override default color in mark config
  tick: defaultTickConfig,
  trail: {},
  boxplot: {
    size: 14,
    extent: 1.5,
    box: {},
    median: { color: "white" },
    outliers: {},
    rule: {},
    ticks: null
  },
  errorbar: {
    center: "mean",
    rule: !0,
    ticks: !1
  },
  errorband: {
    band: {
      opacity: 0.3
    },
    borders: !1
  },
  scale: defaultScaleConfig,
  projection: {},
  legend: defaultLegendConfig,
  header: { titlePadding: 10, labelPadding: 10 },
  headerColumn: {},
  headerRow: {},
  headerFacet: {},
  selection: defaultConfig$1,
  style: {},
  title: {},
  facet: { spacing: DEFAULT_SPACING },
  concat: { spacing: DEFAULT_SPACING },
  normalizedNumberFormat: ".0%"
}, tab10 = [
  "#4c78a8",
  "#f58518",
  "#e45756",
  "#72b7b2",
  "#54a24b",
  "#eeca3b",
  "#b279a2",
  "#ff9da6",
  "#9d755d",
  "#bab0ac"
], DEFAULT_FONT_SIZE = {
  text: 11,
  guideLabel: 10,
  guideTitle: 11,
  groupTitle: 13,
  groupSubtitle: 12
}, DEFAULT_COLOR = {
  blue: tab10[0],
  orange: tab10[1],
  red: tab10[2],
  teal: tab10[3],
  green: tab10[4],
  yellow: tab10[5],
  purple: tab10[6],
  pink: tab10[7],
  brown: tab10[8],
  gray0: "#000",
  gray1: "#111",
  gray2: "#222",
  gray3: "#333",
  gray4: "#444",
  gray5: "#555",
  gray6: "#666",
  gray7: "#777",
  gray8: "#888",
  gray9: "#999",
  gray10: "#aaa",
  gray11: "#bbb",
  gray12: "#ccc",
  gray13: "#ddd",
  gray14: "#eee",
  gray15: "#fff"
};
function colorSignalConfig(n = {}) {
  return {
    signals: [
      {
        name: "color",
        value: isObject$3(n) ? { ...DEFAULT_COLOR, ...n } : DEFAULT_COLOR
      }
    ],
    mark: { color: { signal: "color.blue" } },
    rule: { color: { signal: "color.gray0" } },
    text: {
      color: { signal: "color.gray0" }
    },
    style: {
      "guide-label": {
        fill: { signal: "color.gray0" }
      },
      "guide-title": {
        fill: { signal: "color.gray0" }
      },
      "group-title": {
        fill: { signal: "color.gray0" }
      },
      "group-subtitle": {
        fill: { signal: "color.gray0" }
      },
      cell: {
        stroke: { signal: "color.gray8" }
      }
    },
    axis: {
      domainColor: { signal: "color.gray13" },
      gridColor: { signal: "color.gray8" },
      tickColor: { signal: "color.gray13" }
    },
    range: {
      category: [
        { signal: "color.blue" },
        { signal: "color.orange" },
        { signal: "color.red" },
        { signal: "color.teal" },
        { signal: "color.green" },
        { signal: "color.yellow" },
        { signal: "color.purple" },
        { signal: "color.pink" },
        { signal: "color.brown" },
        { signal: "color.grey8" }
      ]
    }
  };
}
function fontSizeSignalConfig(n) {
  return {
    signals: [
      {
        name: "fontSize",
        value: isObject$3(n) ? { ...DEFAULT_FONT_SIZE, ...n } : DEFAULT_FONT_SIZE
      }
    ],
    text: {
      fontSize: { signal: "fontSize.text" }
    },
    style: {
      "guide-label": {
        fontSize: { signal: "fontSize.guideLabel" }
      },
      "guide-title": {
        fontSize: { signal: "fontSize.guideTitle" }
      },
      "group-title": {
        fontSize: { signal: "fontSize.groupTitle" }
      },
      "group-subtitle": {
        fontSize: { signal: "fontSize.groupSubtitle" }
      }
    }
  };
}
function fontConfig(n) {
  return {
    text: { font: n },
    style: {
      "guide-label": { font: n },
      "guide-title": { font: n },
      "group-title": { font: n },
      "group-subtitle": { font: n }
    }
  };
}
function getAxisConfigInternal(n) {
  const t = keys$1(n || {}), g = {};
  for (const d of t) {
    const k = n[d];
    g[d] = isConditionalAxisValue(k) ? signalOrValueRefWithCondition(k) : signalRefOrValue(k);
  }
  return g;
}
function getStyleConfigInternal(n) {
  const t = keys$1(n), g = {};
  for (const d of t)
    g[d] = getAxisConfigInternal(n[d]);
  return g;
}
const configPropsWithExpr = [
  ...MARK_CONFIGS,
  ...AXIS_CONFIGS,
  ...HEADER_CONFIGS,
  "background",
  "padding",
  "legend",
  "lineBreak",
  "scale",
  "style",
  "title",
  "view"
];
function initConfig(n = {}) {
  const { color: t, font: g, fontSize: d, selection: k, ...H } = n, AA = mergeConfig$2({}, duplicate(defaultConfig), g ? fontConfig(g) : {}, t ? colorSignalConfig(t) : {}, d ? fontSizeSignalConfig(d) : {}, H || {});
  k && writeConfig(AA, "selection", k, !0);
  const gA = omit(AA, configPropsWithExpr);
  for (const IA of ["background", "lineBreak", "padding"])
    AA[IA] && (gA[IA] = signalRefOrValue(AA[IA]));
  for (const IA of MARK_CONFIGS)
    AA[IA] && (gA[IA] = replaceExprRef(AA[IA]));
  for (const IA of AXIS_CONFIGS)
    AA[IA] && (gA[IA] = getAxisConfigInternal(AA[IA]));
  for (const IA of HEADER_CONFIGS)
    AA[IA] && (gA[IA] = replaceExprRef(AA[IA]));
  if (AA.legend && (gA.legend = replaceExprRef(AA.legend)), AA.scale) {
    const { invalid: IA, ...CA } = AA.scale, BA = replaceExprRef(IA, { level: 1 });
    gA.scale = {
      ...replaceExprRef(CA),
      ...keys$1(BA).length > 0 ? { invalid: BA } : {}
    };
  }
  return AA.style && (gA.style = getStyleConfigInternal(AA.style)), AA.title && (gA.title = replaceExprRef(AA.title)), AA.view && (gA.view = replaceExprRef(AA.view)), gA;
}
const MARK_STYLES = /* @__PURE__ */ new Set(["view", ...PRIMITIVE_MARKS]), VL_ONLY_CONFIG_PROPERTIES = [
  "color",
  "fontSize",
  "background",
  // We apply background to the spec directly.
  "padding",
  "facet",
  "concat",
  "numberFormat",
  "numberFormatType",
  "normalizedNumberFormat",
  "normalizedNumberFormatType",
  "timeFormat",
  "countTitle",
  "header",
  "axisQuantitative",
  "axisTemporal",
  "axisDiscrete",
  "axisPoint",
  "axisXBand",
  "axisXPoint",
  "axisXDiscrete",
  "axisXQuantitative",
  "axisXTemporal",
  "axisYBand",
  "axisYPoint",
  "axisYDiscrete",
  "axisYQuantitative",
  "axisYTemporal",
  "scale",
  "selection",
  "overlay"
], VL_ONLY_ALL_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX = {
  view: ["continuousWidth", "continuousHeight", "discreteWidth", "discreteHeight", "step"],
  ...VL_ONLY_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX
};
function stripAndRedirectConfig(n) {
  n = duplicate(n);
  for (const t of VL_ONLY_CONFIG_PROPERTIES)
    delete n[t];
  if (n.axis)
    for (const t in n.axis)
      isConditionalAxisValue(n.axis[t]) && delete n.axis[t];
  if (n.legend)
    for (const t of VL_ONLY_LEGEND_CONFIG)
      delete n.legend[t];
  if (n.mark) {
    for (const t of VL_ONLY_MARK_CONFIG_PROPERTIES)
      delete n.mark[t];
    n.mark.tooltip && isObject$3(n.mark.tooltip) && delete n.mark.tooltip;
  }
  n.params && (n.signals = (n.signals || []).concat(assembleParameterSignals(n.params)), delete n.params);
  for (const t of MARK_STYLES) {
    for (const d of VL_ONLY_MARK_CONFIG_PROPERTIES)
      delete n[t][d];
    const g = VL_ONLY_ALL_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX[t];
    if (g)
      for (const d of g)
        delete n[t][d];
    redirectConfigToStyleConfig(n, t);
  }
  for (const t of getAllCompositeMarks())
    delete n[t];
  redirectTitleConfig(n);
  for (const t in n)
    isObject$3(n[t]) && isEmpty(n[t]) && delete n[t];
  return isEmpty(n) ? void 0 : n;
}
function redirectTitleConfig(n) {
  const { titleMarkConfig: t, subtitleMarkConfig: g, subtitle: d } = extractTitleConfig(n.title);
  isEmpty(t) || (n.style["group-title"] = {
    ...n.style["group-title"],
    ...t
    // config.title has higher precedence than config.style.group-title in Vega
  }), isEmpty(g) || (n.style["group-subtitle"] = {
    ...n.style["group-subtitle"],
    ...g
  }), isEmpty(d) ? delete n.title : n.title = d;
}
function redirectConfigToStyleConfig(n, t, g, d) {
  const k = n[t];
  t === "view" && (g = "cell");
  const H = {
    ...k,
    ...n.style[g ?? t]
  };
  isEmpty(H) || (n.style[g ?? t] = H), delete n[t];
}
function isLayerSpec(n) {
  return hasProperty(n, "layer");
}
function isRepeatSpec(n) {
  return hasProperty(n, "repeat");
}
function isLayerRepeatSpec(n) {
  return !isArray$2(n.repeat) && hasProperty(n.repeat, "layer");
}
class SpecMapper {
  map(t, g) {
    return isFacetSpec(t) ? this.mapFacet(t, g) : isRepeatSpec(t) ? this.mapRepeat(t, g) : isHConcatSpec(t) ? this.mapHConcat(t, g) : isVConcatSpec(t) ? this.mapVConcat(t, g) : isConcatSpec(t) ? this.mapConcat(t, g) : this.mapLayerOrUnit(t, g);
  }
  mapLayerOrUnit(t, g) {
    if (isLayerSpec(t))
      return this.mapLayer(t, g);
    if (isUnitSpec(t))
      return this.mapUnit(t, g);
    throw new Error(invalidSpec(t));
  }
  mapLayer(t, g) {
    return {
      ...t,
      layer: t.layer.map((d) => this.mapLayerOrUnit(d, g))
    };
  }
  mapHConcat(t, g) {
    return {
      ...t,
      hconcat: t.hconcat.map((d) => this.map(d, g))
    };
  }
  mapVConcat(t, g) {
    return {
      ...t,
      vconcat: t.vconcat.map((d) => this.map(d, g))
    };
  }
  mapConcat(t, g) {
    const { concat: d, ...k } = t;
    return {
      ...k,
      concat: d.map((H) => this.map(H, g))
    };
  }
  mapFacet(t, g) {
    return {
      // as any is required here since TS cannot infer that FO may only be FieldName or Field, but not RepeatRef
      ...t,
      // TODO: remove "any" once we support all facet listed in https://github.com/vega/vega-lite/issues/2760
      spec: this.map(t.spec, g)
    };
  }
  mapRepeat(t, g) {
    return {
      ...t,
      // as any is required here since TS cannot infer that the output type satisfies the input type
      spec: this.map(t.spec, g)
    };
  }
}
const STACK_OFFSET_INDEX = {
  zero: 1,
  center: 1,
  normalize: 1
};
function isStackOffset(n) {
  return has(STACK_OFFSET_INDEX, n);
}
const STACKABLE_MARKS = /* @__PURE__ */ new Set([ARC, BAR, AREA, RULE, POINT, CIRCLE, SQUARE, LINE, TEXT, TICK]), STACK_BY_DEFAULT_MARKS = /* @__PURE__ */ new Set([BAR, AREA, ARC]);
function isUnbinnedQuantitative(n) {
  return isFieldDef(n) && channelDefType(n) === "quantitative" && !n.bin;
}
function potentialStackedChannel(n, t, { orient: g, type: d }) {
  const k = t === "x" ? "y" : "radius", H = t === "x" && ["bar", "area"].includes(d), AA = n[t], gA = n[k];
  if (isFieldDef(AA) && isFieldDef(gA))
    if (isUnbinnedQuantitative(AA) && isUnbinnedQuantitative(gA)) {
      if (AA.stack)
        return t;
      if (gA.stack)
        return k;
      const IA = isFieldDef(AA) && !!AA.aggregate, CA = isFieldDef(gA) && !!gA.aggregate;
      if (IA !== CA)
        return IA ? t : k;
      if (H) {
        if (g === "vertical")
          return k;
        if (g === "horizontal")
          return t;
      }
    } else {
      if (isUnbinnedQuantitative(AA))
        return t;
      if (isUnbinnedQuantitative(gA))
        return k;
    }
  else {
    if (isUnbinnedQuantitative(AA))
      return H && g === "vertical" ? void 0 : t;
    if (isUnbinnedQuantitative(gA))
      return H && g === "horizontal" ? void 0 : k;
  }
}
function getDimensionChannel(n) {
  switch (n) {
    case "x":
      return "y";
    case "y":
      return "x";
    case "theta":
      return "radius";
    case "radius":
      return "theta";
  }
}
function stack(n, t) {
  const g = isMarkDef(n) ? n : { type: n }, d = g.type;
  if (!STACKABLE_MARKS.has(d))
    return null;
  const k = potentialStackedChannel(t, "x", g) || potentialStackedChannel(t, "theta", g);
  if (!k)
    return null;
  const H = t[k], AA = isFieldDef(H) ? vgField(H, {}) : void 0, gA = getDimensionChannel(k), IA = [], CA = /* @__PURE__ */ new Set();
  if (t[gA]) {
    const oA = t[gA], EA = isFieldDef(oA) ? vgField(oA, {}) : void 0;
    EA && EA !== AA && (IA.push(gA), CA.add(EA));
  }
  const BA = gA === "x" ? "xOffset" : "yOffset", eA = t[BA], iA = isFieldDef(eA) ? vgField(eA, {}) : void 0;
  iA && iA !== AA && (IA.push(BA), CA.add(iA));
  const QA = NONPOSITION_CHANNELS.reduce((oA, EA) => {
    if (EA !== "tooltip" && channelHasField(t, EA)) {
      const aA = t[EA];
      for (const nA of array(aA)) {
        const lA = getFieldDef(nA);
        if (lA.aggregate)
          continue;
        const cA = vgField(lA, {});
        // if fielddef is a repeat, just include it in the stack by
        (!cA || // otherwise, the field must be different from the groupBy fields.
        !CA.has(cA)) && oA.push({ channel: EA, fieldDef: lA });
      }
    }
    return oA;
  }, []);
  let tA;
  return H.stack !== void 0 ? isBoolean$2(H.stack) ? tA = H.stack ? "zero" : null : tA = H.stack : STACK_BY_DEFAULT_MARKS.has(d) && (tA = "zero"), !tA || !isStackOffset(tA) || isAggregate$1(t) && QA.length === 0 ? null : (H?.scale?.type && H?.scale?.type !== ScaleType.LINEAR && H?.stack && warn(stackNonLinearScale(H.scale.type)), isFieldOrDatumDef(t[getSecondaryRangeChannel(k)]) ? (H.stack !== void 0 && warn(cannotStackRangedMark(k)), null) : (isFieldDef(H) && H.aggregate && !SUM_OPS.has(H.aggregate) && warn(stackNonSummativeAggregate(H.aggregate)), {
    groupbyChannels: IA,
    groupbyFields: CA,
    fieldChannel: k,
    impute: H.impute === null ? !1 : isPathMark(d),
    stackBy: QA,
    offset: tA
  }));
}
function initMarkdef(n, t, g) {
  const d = replaceExprRef(n), k = getMarkPropOrConfig("orient", d, g);
  if (d.orient = orient(d.type, t, k), k !== void 0 && k !== d.orient && warn(orientOverridden(d.orient, k)), d.type === "bar" && d.orient) {
    const IA = getMarkPropOrConfig("cornerRadiusEnd", d, g);
    if (IA !== void 0) {
      const CA = d.orient === "horizontal" && t.x2 || d.orient === "vertical" && t.y2 ? ["cornerRadius"] : BAR_CORNER_RADIUS_INDEX[d.orient];
      for (const BA of CA)
        d[BA] = IA;
      d.cornerRadiusEnd !== void 0 && delete d.cornerRadiusEnd;
    }
  }
  const H = getMarkPropOrConfig("opacity", d, g), AA = getMarkPropOrConfig("fillOpacity", d, g);
  return H === void 0 && AA === void 0 && (d.opacity = opacity(d.type, t)), getMarkPropOrConfig("cursor", d, g) === void 0 && (d.cursor = cursor$1(d, t, g)), d;
}
function cursor$1(n, t, g) {
  return t.href || n.href || getMarkPropOrConfig("href", n, g) ? "pointer" : n.cursor;
}
const DEFAULT_REDUCED_OPACITY = 0.7;
function opacity(n, t) {
  if (contains([POINT, TICK, CIRCLE, SQUARE], n) && !isAggregate$1(t))
    return DEFAULT_REDUCED_OPACITY;
}
function defaultFilled(n, t, { graticule: g }) {
  if (g)
    return !1;
  const d = getMarkConfig("filled", n, t), k = n.type;
  return getFirstDefined(d, k !== POINT && k !== LINE && k !== RULE);
}
function orient(n, t, g) {
  switch (n) {
    case POINT:
    case CIRCLE:
    case SQUARE:
    case RECT:
    case IMAGE:
      return;
  }
  const { x: d, y: k, x2: H, y2: AA } = t;
  switch (n) {
    case TEXT:
    case BAR:
      if (isFieldDef(d) && (isBinned(d.bin) || isFieldDef(k) && k.aggregate && !d.aggregate))
        return "vertical";
      if (isFieldDef(k) && (isBinned(k.bin) || isFieldDef(d) && d.aggregate && !k.aggregate))
        return "horizontal";
      if (AA || H) {
        if (g)
          return g;
        if (!H)
          return (isFieldDef(d) && d.type === QUANTITATIVE && !isBinning(d.bin) || isNumericDataDef(d)) && isFieldDef(k) && isBinned(k.bin) ? "horizontal" : "vertical";
        if (!AA)
          return (isFieldDef(k) && k.type === QUANTITATIVE && !isBinning(k.bin) || isNumericDataDef(k)) && isFieldDef(d) && isBinned(d.bin) ? "vertical" : "horizontal";
      }
    // falls through
    case RULE:
      if (H && !(isFieldDef(d) && isBinned(d.bin)) && AA && !(isFieldDef(k) && isBinned(k.bin)))
        return;
    // falls through
    case AREA:
      if (AA)
        return isFieldDef(k) && isBinned(k.bin) ? "horizontal" : "vertical";
      if (H)
        return isFieldDef(d) && isBinned(d.bin) ? "vertical" : "horizontal";
      if (n === RULE) {
        if (d && !k)
          return "vertical";
        if (k && !d)
          return "horizontal";
      }
    // falls through
    case LINE:
    case TICK: {
      const gA = isUnbinnedQuantitativeFieldOrDatumDef(d), IA = isUnbinnedQuantitativeFieldOrDatumDef(k);
      if (g)
        return g;
      if (gA && !IA)
        return n !== "tick" ? "horizontal" : "vertical";
      if (!gA && IA)
        return n !== "tick" ? "vertical" : "horizontal";
      if (gA && IA)
        return "vertical";
      {
        const CA = isTypedFieldDef(d) && d.type === TEMPORAL, BA = isTypedFieldDef(k) && k.type === TEMPORAL;
        if (CA && !BA)
          return "vertical";
        if (!CA && BA)
          return "horizontal";
      }
      return;
    }
  }
  return "vertical";
}
function dropLineAndPoint(n) {
  const { point: t, line: g, ...d } = n;
  return keys$1(d).length > 1 ? d : d.type;
}
function dropLineAndPointFromConfig(n) {
  for (const t of ["line", "area", "rule", "trail"])
    n[t] && (n = {
      ...n,
      // TODO: remove as any
      [t]: omit(n[t], ["point", "line"])
    });
  return n;
}
function getPointOverlay(n, t = {}, g) {
  return n.point === "transparent" ? { opacity: 0 } : n.point ? isObject$3(n.point) ? n.point : {} : n.point !== void 0 ? null : t.point || g.shape ? isObject$3(t.point) ? t.point : {} : void 0;
}
function getLineOverlay(n, t = {}) {
  return n.line ? n.line === !0 ? {} : n.line : n.line !== void 0 ? null : t.line ? t.line === !0 ? {} : t.line : void 0;
}
class PathOverlayNormalizer {
  name = "path-overlay";
  hasMatchingType(t, g) {
    if (isUnitSpec(t)) {
      const { mark: d, encoding: k } = t, H = isMarkDef(d) ? d : { type: d };
      switch (H.type) {
        case "line":
        case "rule":
        case "trail":
          return !!getPointOverlay(H, g[H.type], k);
        case "area":
          return (
            // false / null are also included as we want to remove the properties
            !!getPointOverlay(H, g[H.type], k) || !!getLineOverlay(H, g[H.type])
          );
      }
    }
    return !1;
  }
  run(t, g, d) {
    const { config: k } = g, { params: H, projection: AA, mark: gA, name: IA, encoding: CA, ...BA } = t, eA = normalizeEncoding(CA, k), iA = isMarkDef(gA) ? gA : { type: gA }, QA = getPointOverlay(iA, k[iA.type], eA), tA = iA.type === "area" && getLineOverlay(iA, k[iA.type]), oA = [
      {
        name: IA,
        ...H ? { params: H } : {},
        mark: dropLineAndPoint({
          ...iA.type === "area" && getMarkPropOrConfig("opacity", iA, k) == null && getMarkPropOrConfig("fillOpacity", iA, k) == null ? { opacity: DEFAULT_REDUCED_OPACITY } : {},
          ...iA
        }),
        // drop shape from encoding as this might be used to trigger point overlay
        encoding: omit(eA, ["shape"])
      }
    ], EA = stack(initMarkdef(iA, eA, k), eA);
    let aA = eA;
    if (EA) {
      const { fieldChannel: nA, offset: lA } = EA;
      aA = {
        ...eA,
        [nA]: {
          ...eA[nA],
          ...lA ? { stack: lA } : {}
        }
      };
    }
    return aA = omit(aA, ["y2", "x2"]), tA && oA.push({
      ...AA ? { projection: AA } : {},
      mark: {
        type: "line",
        ...pick$2(iA, ["clip", "interpolate", "tension", "tooltip"]),
        ...tA
      },
      encoding: aA
    }), QA && oA.push({
      ...AA ? { projection: AA } : {},
      mark: {
        type: "point",
        opacity: 1,
        filled: !0,
        ...pick$2(iA, ["clip", "tooltip"]),
        ...QA
      },
      encoding: aA
    }), d({
      ...BA,
      layer: oA
    }, {
      ...g,
      config: dropLineAndPointFromConfig(k)
    });
  }
}
function replaceRepeaterInFacet(n, t) {
  return t ? isFacetMapping(n) ? replaceRepeaterInMapping(n, t) : replaceRepeaterInFieldDef(n, t) : n;
}
function replaceRepeaterInEncoding(n, t) {
  return t ? replaceRepeaterInMapping(n, t) : n;
}
function replaceRepeatInProp(n, t, g) {
  const d = t[n];
  if (isRepeatRef(d)) {
    if (d.repeat in g)
      return { ...t, [n]: g[d.repeat] };
    warn(noSuchRepeatedValue(d.repeat));
    return;
  }
  return t;
}
function replaceRepeaterInFieldDef(n, t) {
  if (n = replaceRepeatInProp("field", n, t), n !== void 0) {
    if (n === null)
      return null;
    if (isSortableFieldDef(n) && isSortField(n.sort)) {
      const g = replaceRepeatInProp("field", n.sort, t);
      n = {
        ...n,
        ...g ? { sort: g } : {}
      };
    }
    return n;
  }
}
function replaceRepeaterInFieldOrDatumDef(n, t) {
  if (isFieldDef(n))
    return replaceRepeaterInFieldDef(n, t);
  {
    const g = replaceRepeatInProp("datum", n, t);
    return g !== n && !g.type && (g.type = "nominal"), g;
  }
}
function replaceRepeaterInChannelDef(n, t) {
  if (isFieldOrDatumDef(n)) {
    const g = replaceRepeaterInFieldOrDatumDef(n, t);
    if (g)
      return g;
    if (isConditionalDef(n))
      return { condition: n.condition };
  } else {
    if (hasConditionalFieldOrDatumDef(n)) {
      const g = replaceRepeaterInFieldOrDatumDef(n.condition, t);
      if (g)
        return {
          ...n,
          condition: g
        };
      {
        const { condition: d, ...k } = n;
        return k;
      }
    }
    return n;
  }
}
function replaceRepeaterInMapping(n, t) {
  const g = {};
  for (const d in n)
    if (hasProperty(n, d)) {
      const k = n[d];
      if (isArray$2(k))
        g[d] = k.map((H) => replaceRepeaterInChannelDef(H, t)).filter((H) => H);
      else {
        const H = replaceRepeaterInChannelDef(k, t);
        H !== void 0 && (g[d] = H);
      }
    }
  return g;
}
class RuleForRangedLineNormalizer {
  name = "RuleForRangedLine";
  hasMatchingType(t) {
    if (isUnitSpec(t)) {
      const { encoding: g, mark: d } = t;
      if (d === "line" || isMarkDef(d) && d.type === "line")
        for (const k of SECONDARY_RANGE_CHANNEL) {
          const H = getMainRangeChannel(k), AA = g[H];
          if (g[k] && (isFieldDef(AA) && !isBinned(AA.bin) || isDatumDef(AA)))
            return !0;
        }
    }
    return !1;
  }
  run(t, g, d) {
    const { encoding: k, mark: H } = t;
    return warn(lineWithRange(!!k.x2, !!k.y2)), d({
      ...t,
      mark: isObject$3(H) ? { ...H, type: "rule" } : "rule"
    }, g);
  }
}
class CoreNormalizer extends SpecMapper {
  nonFacetUnitNormalizers = [
    boxPlotNormalizer,
    errorBarNormalizer,
    errorBandNormalizer,
    new PathOverlayNormalizer(),
    new RuleForRangedLineNormalizer()
  ];
  map(t, g) {
    if (isUnitSpec(t)) {
      const d = channelHasField(t.encoding, ROW), k = channelHasField(t.encoding, COLUMN), H = channelHasField(t.encoding, FACET);
      if (d || k || H)
        return this.mapFacetedUnit(t, g);
    }
    return super.map(t, g);
  }
  // This is for normalizing non-facet unit
  mapUnit(t, g) {
    const { parentEncoding: d, parentProjection: k } = g, H = replaceRepeaterInEncoding(t.encoding, g.repeater), AA = {
      ...t,
      ...t.name ? { name: [g.repeaterPrefix, t.name].filter((IA) => IA).join("_") } : {},
      ...H ? { encoding: H } : {}
    };
    if (d || k)
      return this.mapUnitWithParentEncodingOrProjection(AA, g);
    const gA = this.mapLayerOrUnit.bind(this);
    for (const IA of this.nonFacetUnitNormalizers)
      if (IA.hasMatchingType(AA, g.config))
        return IA.run(AA, g, gA);
    return AA;
  }
  mapRepeat(t, g) {
    return isLayerRepeatSpec(t) ? this.mapLayerRepeat(t, g) : this.mapNonLayerRepeat(t, g);
  }
  mapLayerRepeat(t, g) {
    const { repeat: d, spec: k, ...H } = t, { row: AA, column: gA, layer: IA } = d, { repeater: CA = {}, repeaterPrefix: BA = "" } = g;
    return AA || gA ? this.mapRepeat({
      ...t,
      repeat: {
        ...AA ? { row: AA } : {},
        ...gA ? { column: gA } : {}
      },
      spec: {
        repeat: { layer: IA },
        spec: k
      }
    }, g) : {
      ...H,
      layer: IA.map((eA) => {
        const iA = {
          ...CA,
          layer: eA
        }, QA = `${(k.name ? `${k.name}_` : "") + BA}child__layer_${varName(eA)}`, tA = this.mapLayerOrUnit(k, { ...g, repeater: iA, repeaterPrefix: QA });
        return tA.name = QA, tA;
      })
    };
  }
  mapNonLayerRepeat(t, g) {
    const { repeat: d, spec: k, data: H, ...AA } = t;
    !isArray$2(d) && t.columns && (t = omit(t, ["columns"]), warn(columnsNotSupportByRowCol("repeat")));
    const gA = [], { repeater: IA = {}, repeaterPrefix: CA = "" } = g, BA = !isArray$2(d) && d.row || [IA ? IA.row : null], eA = !isArray$2(d) && d.column || [IA ? IA.column : null], iA = isArray$2(d) && d || [IA ? IA.repeat : null];
    for (const tA of iA)
      for (const oA of BA)
        for (const EA of eA) {
          const aA = {
            repeat: tA,
            row: oA,
            column: EA,
            layer: IA.layer
          }, nA = `${(k.name ? `${k.name}_` : "") + CA}child__${isArray$2(d) ? `${varName(tA)}` : (d.row ? `row_${varName(oA)}` : "") + (d.column ? `column_${varName(EA)}` : "")}`, lA = this.map(k, { ...g, repeater: aA, repeaterPrefix: nA });
          lA.name = nA, gA.push(omit(lA, ["data"]));
        }
    const QA = isArray$2(d) ? t.columns : d.column ? d.column.length : 1;
    return {
      data: k.data ?? H,
      // data from child spec should have precedence
      align: "all",
      ...AA,
      columns: QA,
      concat: gA
    };
  }
  mapFacet(t, g) {
    const { facet: d } = t;
    return isFacetMapping(d) && t.columns && (t = omit(t, ["columns"]), warn(columnsNotSupportByRowCol("facet"))), super.mapFacet(t, g);
  }
  mapUnitWithParentEncodingOrProjection(t, g) {
    const { encoding: d, projection: k } = t, { parentEncoding: H, parentProjection: AA, config: gA } = g, IA = mergeProjection({ parentProjection: AA, projection: k }), CA = mergeEncoding({
      parentEncoding: H,
      encoding: replaceRepeaterInEncoding(d, g.repeater)
    });
    return this.mapUnit({
      ...t,
      ...IA ? { projection: IA } : {},
      ...CA ? { encoding: CA } : {}
    }, { config: gA });
  }
  mapFacetedUnit(t, g) {
    const { row: d, column: k, facet: H, ...AA } = t.encoding, { mark: gA, width: IA, projection: CA, height: BA, view: eA, params: iA, encoding: QA, ...tA } = t, { facetMapping: oA, layout: EA } = this.getFacetMappingAndLayout({ row: d, column: k, facet: H }, g), aA = replaceRepeaterInEncoding(AA, g.repeater);
    return this.mapFacet({
      ...tA,
      ...EA,
      // row / column has higher precedence than facet
      facet: oA,
      spec: {
        ...IA ? { width: IA } : {},
        ...BA ? { height: BA } : {},
        ...eA ? { view: eA } : {},
        ...CA ? { projection: CA } : {},
        mark: gA,
        encoding: aA,
        ...iA ? { params: iA } : {}
      }
    }, g);
  }
  getFacetMappingAndLayout(t, g) {
    const { row: d, column: k, facet: H } = t;
    if (d || k) {
      H && warn(facetChannelDropped([...d ? [ROW] : [], ...k ? [COLUMN] : []]));
      const AA = {}, gA = {};
      for (const IA of [ROW, COLUMN]) {
        const CA = t[IA];
        if (CA) {
          const { align: BA, center: eA, spacing: iA, columns: QA, ...tA } = CA;
          AA[IA] = tA;
          for (const oA of ["align", "center", "spacing"])
            CA[oA] !== void 0 && (gA[oA] ??= {}, gA[oA][IA] = CA[oA]);
        }
      }
      return { facetMapping: AA, layout: gA };
    } else {
      const { align: AA, center: gA, spacing: IA, columns: CA, ...BA } = H;
      return {
        facetMapping: replaceRepeaterInFacet(BA, g.repeater),
        layout: {
          ...AA ? { align: AA } : {},
          ...gA ? { center: gA } : {},
          ...IA ? { spacing: IA } : {},
          ...CA ? { columns: CA } : {}
        }
      };
    }
  }
  mapLayer(t, { parentEncoding: g, parentProjection: d, ...k }) {
    const { encoding: H, projection: AA, ...gA } = t, IA = {
      ...k,
      parentEncoding: mergeEncoding({ parentEncoding: g, encoding: H, layer: !0 }),
      parentProjection: mergeProjection({ parentProjection: d, projection: AA })
    };
    return super.mapLayer({
      ...gA,
      ...t.name ? { name: [IA.repeaterPrefix, t.name].filter((CA) => CA).join("_") } : {}
    }, IA);
  }
}
function mergeEncoding({ parentEncoding: n, encoding: t = {}, layer: g }) {
  let d = {};
  if (n) {
    const k = /* @__PURE__ */ new Set([...keys$1(n), ...keys$1(t)]);
    for (const H of k) {
      const AA = t[H], gA = n[H];
      if (isFieldOrDatumDef(AA)) {
        const IA = {
          ...gA,
          ...AA
        };
        d[H] = IA;
      } else hasConditionalFieldOrDatumDef(AA) ? d[H] = {
        ...AA,
        condition: {
          ...gA,
          ...AA.condition
        }
      } : AA || AA === null ? d[H] = AA : (g || isValueDef(gA) || isSignalRef(gA) || isFieldOrDatumDef(gA) || isArray$2(gA)) && (d[H] = gA);
    }
  } else
    d = t;
  return !d || isEmpty(d) ? void 0 : d;
}
function mergeProjection(n) {
  const { parentProjection: t, projection: g } = n;
  return t && g && warn(projectionOverridden({ parentProjection: t, projection: g })), g ?? t;
}
function isFilter(n) {
  return hasProperty(n, "filter");
}
function isImputeSequence(n) {
  return hasProperty(n, "stop");
}
function isLookup(n) {
  return hasProperty(n, "lookup");
}
function isLookupData(n) {
  return hasProperty(n, "data");
}
function isLookupSelection(n) {
  return hasProperty(n, "param");
}
function isPivot(n) {
  return hasProperty(n, "pivot");
}
function isDensity(n) {
  return hasProperty(n, "density");
}
function isQuantile(n) {
  return hasProperty(n, "quantile");
}
function isRegression(n) {
  return hasProperty(n, "regression");
}
function isLoess(n) {
  return hasProperty(n, "loess");
}
function isSample(n) {
  return hasProperty(n, "sample");
}
function isWindow(n) {
  return hasProperty(n, "window");
}
function isJoinAggregate(n) {
  return hasProperty(n, "joinaggregate");
}
function isFlatten(n) {
  return hasProperty(n, "flatten");
}
function isCalculate(n) {
  return hasProperty(n, "calculate");
}
function isBin(n) {
  return hasProperty(n, "bin");
}
function isImpute(n) {
  return hasProperty(n, "impute");
}
function isTimeUnit(n) {
  return hasProperty(n, "timeUnit");
}
function isAggregate(n) {
  return hasProperty(n, "aggregate");
}
function isStack(n) {
  return hasProperty(n, "stack");
}
function isFold(n) {
  return hasProperty(n, "fold");
}
function isExtent(n) {
  return hasProperty(n, "extent") && !hasProperty(n, "density") && !hasProperty(n, "regression");
}
function normalizeTransform(n) {
  return n.map((t) => isFilter(t) ? {
    filter: normalizeLogicalComposition(t.filter, normalizePredicate$1)
  } : t);
}
class SelectionCompatibilityNormalizer extends SpecMapper {
  map(t, g) {
    return g.emptySelections ??= {}, g.selectionPredicates ??= {}, t = normalizeTransforms(t, g), super.map(t, g);
  }
  mapLayerOrUnit(t, g) {
    if (t = normalizeTransforms(t, g), t.encoding) {
      const d = {};
      for (const [k, H] of entries$1(t.encoding))
        d[k] = normalizeChannelDef(H, g);
      t = { ...t, encoding: d };
    }
    return super.mapLayerOrUnit(t, g);
  }
  mapUnit(t, g) {
    const { selection: d, ...k } = t;
    return d ? {
      ...k,
      params: entries$1(d).map(([H, AA]) => {
        const { init: gA, bind: IA, empty: CA, ...BA } = AA;
        BA.type === "single" ? (BA.type = "point", BA.toggle = !1) : BA.type === "multi" && (BA.type = "point"), g.emptySelections[H] = CA !== "none";
        for (const eA of vals(g.selectionPredicates[H] ?? {}))
          eA.empty = CA !== "none";
        return { name: H, value: gA, select: BA, bind: IA };
      })
    } : t;
  }
}
function normalizeTransforms(n, t) {
  const { transform: g, ...d } = n;
  if (g) {
    const k = g.map((H) => {
      if (isFilter(H))
        return { filter: normalizePredicate(H, t) };
      if (isBin(H) && isBinParams(H.bin))
        return {
          ...H,
          bin: normalizeBinExtent(H.bin)
        };
      if (isLookup(H)) {
        const { selection: AA, ...gA } = H.from;
        return AA ? {
          ...H,
          from: { param: AA, ...gA }
        } : H;
      }
      return H;
    });
    return { ...d, transform: k };
  }
  return n;
}
function normalizeChannelDef(n, t) {
  const g = duplicate(n);
  if (isFieldDef(g) && isBinParams(g.bin) && (g.bin = normalizeBinExtent(g.bin)), isScaleFieldDef(g) && g.scale?.domain?.selection) {
    const { selection: d, ...k } = g.scale.domain;
    g.scale.domain = { ...k, ...d ? { param: d } : {} };
  }
  if (isConditionalDef(g))
    if (isArray$2(g.condition))
      g.condition = g.condition.map((d) => {
        const { selection: k, param: H, test: AA, ...gA } = d;
        return H ? d : { ...gA, test: normalizePredicate(d, t) };
      });
    else {
      const { selection: d, param: k, test: H, ...AA } = normalizeChannelDef(g.condition, t);
      g.condition = k ? g.condition : {
        ...AA,
        test: normalizePredicate(g.condition, t)
      };
    }
  return g;
}
function normalizeBinExtent(n) {
  const t = n.extent;
  if (t?.selection) {
    const { selection: g, ...d } = t;
    return { ...n, extent: { ...d, param: g } };
  }
  return n;
}
function normalizePredicate(n, t) {
  const g = (d) => normalizeLogicalComposition(d, (k) => {
    const H = t.emptySelections[k] ?? !0, AA = { param: k, empty: H };
    return t.selectionPredicates[k] ??= [], t.selectionPredicates[k].push(AA), AA;
  });
  return n.selection ? g(n.selection) : normalizeLogicalComposition(n.test || n.filter, (d) => d.selection ? g(d.selection) : d);
}
class TopLevelSelectionsNormalizer extends SpecMapper {
  map(t, g) {
    const d = g.selections ?? [];
    if (t.params && !isUnitSpec(t)) {
      const k = [];
      for (const H of t.params)
        isSelectionParameter(H) ? d.push(H) : k.push(H);
      t.params = k;
    }
    return g.selections = d, super.map(t, g);
  }
  mapUnit(t, g) {
    const d = g.selections;
    if (!d || !d.length)
      return t;
    const k = (g.path ?? []).concat(t.name), H = [];
    for (const AA of d)
      if (!AA.views || !AA.views.length)
        H.push(AA);
      else
        for (const gA of AA.views)
          (isString$1(gA) && (gA === t.name || k.includes(gA)) || isArray$2(gA) && // logic for backwards compatibility with view paths before we had unique names
          gA.map((IA) => k.indexOf(IA)).every((IA, CA, BA) => IA !== -1 && (CA === 0 || IA > BA[CA - 1]))) && H.push(AA);
    return H.length && (t.params = H), t;
  }
}
for (const n of ["mapFacet", "mapRepeat", "mapHConcat", "mapVConcat", "mapLayer"]) {
  const t = TopLevelSelectionsNormalizer.prototype[n];
  TopLevelSelectionsNormalizer.prototype[n] = function(g, d) {
    return t.call(this, g, addSpecNameToParams(g, d));
  };
}
function addSpecNameToParams(n, t) {
  return n.name ? {
    ...t,
    path: (t.path ?? []).concat(n.name)
  } : t;
}
function normalize(n, t) {
  t === void 0 && (t = initConfig(n.config));
  const g = normalizeGenericSpec(n, t), { width: d, height: k } = n, H = normalizeAutoSize(g, { width: d, height: k, autosize: n.autosize }, t);
  return {
    ...g,
    ...H ? { autosize: H } : {}
  };
}
const coreNormalizer = new CoreNormalizer(), selectionCompatNormalizer = new SelectionCompatibilityNormalizer(), topLevelSelectionNormalizer = new TopLevelSelectionsNormalizer();
function normalizeGenericSpec(n, t = {}) {
  const g = { config: t };
  return topLevelSelectionNormalizer.map(coreNormalizer.map(selectionCompatNormalizer.map(n, g), g), g);
}
function _normalizeAutoSize(n) {
  return isString$1(n) ? { type: n } : n ?? {};
}
function normalizeAutoSize(n, t, g) {
  let { width: d, height: k } = t;
  const H = isUnitSpec(n) || isLayerSpec(n), AA = {};
  H ? d == "container" && k == "container" ? (AA.type = "fit", AA.contains = "padding") : d == "container" ? (AA.type = "fit-x", AA.contains = "padding") : k == "container" && (AA.type = "fit-y", AA.contains = "padding") : (d == "container" && (warn(containerSizeNonSingle("width")), d = void 0), k == "container" && (warn(containerSizeNonSingle("height")), k = void 0));
  const gA = {
    type: "pad",
    ...AA,
    ...g ? _normalizeAutoSize(g.autosize) : {},
    ..._normalizeAutoSize(n.autosize)
  };
  if (gA.type === "fit" && !H && (warn(FIT_NON_SINGLE), gA.type = "pad"), d == "container" && !(gA.type == "fit" || gA.type == "fit-x") && warn(containerSizeNotCompatibleWithAutosize("width")), k == "container" && !(gA.type == "fit" || gA.type == "fit-y") && warn(containerSizeNotCompatibleWithAutosize("height")), !deepEqual(gA, { type: "pad" }))
    return gA;
}
function isFitType(n) {
  return ["fit", "fit-x", "fit-y"].includes(n);
}
function getFitType(n) {
  return n ? `fit-${getPositionScaleChannel(n)}` : "fit";
}
const TOP_LEVEL_PROPERTIES = [
  "background",
  "padding"
  // We do not include "autosize" here as it is supported by only unit and layer specs and thus need to be normalized
];
function extractTopLevelProperties(n, t) {
  const g = {};
  for (const d of TOP_LEVEL_PROPERTIES)
    n && n[d] !== void 0 && (g[d] = signalRefOrValue(n[d]));
  return t && (g.params = n.params), g;
}
class Split {
  explicit;
  implicit;
  constructor(t = {}, g = {}) {
    this.explicit = t, this.implicit = g;
  }
  clone() {
    return new Split(duplicate(this.explicit), duplicate(this.implicit));
  }
  combine() {
    return {
      ...this.explicit,
      // Explicit properties comes first
      ...this.implicit
    };
  }
  get(t) {
    return getFirstDefined(this.explicit[t], this.implicit[t]);
  }
  getWithExplicit(t) {
    return this.explicit[t] !== void 0 ? { explicit: !0, value: this.explicit[t] } : this.implicit[t] !== void 0 ? { explicit: !1, value: this.implicit[t] } : { explicit: !1, value: void 0 };
  }
  setWithExplicit(t, { value: g, explicit: d }) {
    g !== void 0 && this.set(t, g, d);
  }
  set(t, g, d) {
    return delete this[d ? "implicit" : "explicit"][t], this[d ? "explicit" : "implicit"][t] = g, this;
  }
  copyKeyFromSplit(t, { explicit: g, implicit: d }) {
    g[t] !== void 0 ? this.set(t, g[t], !0) : d[t] !== void 0 && this.set(t, d[t], !1);
  }
  copyKeyFromObject(t, g) {
    g[t] !== void 0 && this.set(t, g[t], !0);
  }
  /**
   * Merge split object into this split object. Properties from the other split
   * overwrite properties from this split.
   */
  copyAll(t) {
    for (const g of keys$1(t.combine())) {
      const d = t.getWithExplicit(g);
      this.setWithExplicit(g, d);
    }
  }
}
function makeExplicit(n) {
  return {
    explicit: !0,
    value: n
  };
}
function makeImplicit(n) {
  return {
    explicit: !1,
    value: n
  };
}
function tieBreakByComparing(n) {
  return (t, g, d, k) => {
    const H = n(t.value, g.value);
    return H > 0 ? t : H < 0 ? g : defaultTieBreaker(t, g, d, k);
  };
}
function defaultTieBreaker(n, t, g, d) {
  return n.explicit && t.explicit && warn(mergeConflictingProperty(g, d, n.value, t.value)), n;
}
function mergeValuesWithExplicit(n, t, g, d, k = defaultTieBreaker) {
  return n === void 0 || n.value === void 0 ? t : n.explicit && !t.explicit ? n : t.explicit && !n.explicit ? t : deepEqual(n.value, t.value) ? n : k(n, t, g, d);
}
class AncestorParse extends Split {
  explicit;
  implicit;
  parseNothing;
  constructor(t = {}, g = {}, d = !1) {
    super(t, g), this.explicit = t, this.implicit = g, this.parseNothing = d;
  }
  clone() {
    const t = super.clone();
    return t.parseNothing = this.parseNothing, t;
  }
}
function isUrlData(n) {
  return hasProperty(n, "url");
}
function isInlineData(n) {
  return hasProperty(n, "values");
}
function isNamedData(n) {
  return hasProperty(n, "name") && !isUrlData(n) && !isInlineData(n) && !isGenerator(n);
}
function isGenerator(n) {
  return n && (isSequenceGenerator(n) || isSphereGenerator(n) || isGraticuleGenerator(n));
}
function isSequenceGenerator(n) {
  return hasProperty(n, "sequence");
}
function isSphereGenerator(n) {
  return hasProperty(n, "sphere");
}
function isGraticuleGenerator(n) {
  return hasProperty(n, "graticule");
}
var DataSourceType;
(function(n) {
  n[n.Raw = 0] = "Raw", n[n.Main = 1] = "Main", n[n.Row = 2] = "Row", n[n.Column = 3] = "Column", n[n.Lookup = 4] = "Lookup", n[n.PreFilterInvalid = 5] = "PreFilterInvalid", n[n.PostFilterInvalid = 6] = "PostFilterInvalid";
})(DataSourceType || (DataSourceType = {}));
function getDataSourcesForHandlingInvalidValues({ invalid: n, isPath: t }) {
  switch (normalizeInvalidDataMode(n, { isPath: t })) {
    case "filter":
      return {
        marks: "exclude-invalid-values",
        scales: "exclude-invalid-values"
      };
    case "break-paths-show-domains":
      return {
        // Path-based marks use pre-filter data so we know to skip these invalid points in the path.
        // For non-path based marks, we skip by not showing them at all.
        marks: t ? "include-invalid-values" : "exclude-invalid-values",
        scales: "include-invalid-values"
      };
    case "break-paths-filter-domains":
      return {
        marks: t ? "include-invalid-values" : "exclude-invalid-values",
        // Unlike 'break-paths-show-domains', 'break-paths-filter-domains' uses post-filter data to feed scale.
        scales: "exclude-invalid-values"
      };
    case "show":
      return {
        marks: "include-invalid-values",
        scales: "include-invalid-values"
      };
  }
}
function getScaleDataSourceForHandlingInvalidValues(n) {
  const { marks: t, scales: g } = getDataSourcesForHandlingInvalidValues(n);
  return t === g ? DataSourceType.Main : g === "include-invalid-values" ? DataSourceType.PreFilterInvalid : DataSourceType.PostFilterInvalid;
}
class DataFlowNode {
  debugName;
  _children = [];
  _parent = null;
  _hash;
  constructor(t, g) {
    this.debugName = g, t && (this.parent = t);
  }
  /**
   * Clone this node with a deep copy but don't clone links to children or parents.
   */
  clone() {
    throw new Error("Cannot clone node");
  }
  get parent() {
    return this._parent;
  }
  /**
   * Set the parent of the node and also add this node to the parent's children.
   */
  set parent(t) {
    this._parent = t, t && t.addChild(this);
  }
  get children() {
    return this._children;
  }
  numChildren() {
    return this._children.length;
  }
  addChild(t, g) {
    if (this._children.includes(t)) {
      warn(ADD_SAME_CHILD_TWICE);
      return;
    }
    g !== void 0 ? this._children.splice(g, 0, t) : this._children.push(t);
  }
  removeChild(t) {
    const g = this._children.indexOf(t);
    return this._children.splice(g, 1), g;
  }
  /**
   * Remove node from the dataflow.
   */
  remove() {
    let t = this._parent.removeChild(this);
    for (const g of this._children)
      g._parent = this._parent, this._parent.addChild(g, t++);
  }
  /**
   * Insert another node as a parent of this node.
   */
  insertAsParentOf(t) {
    const g = t.parent;
    g.removeChild(this), this.parent = g, t.parent = this;
  }
  swapWithParent() {
    const t = this._parent, g = t.parent;
    for (const k of this._children)
      k.parent = t;
    this._children = [], t.removeChild(this);
    const d = t.parent.removeChild(t);
    this._parent = g, g.addChild(this, d), t.parent = this;
  }
}
class OutputNode extends DataFlowNode {
  type;
  refCounts;
  _source;
  _name;
  clone() {
    const t = new this.constructor();
    return t.debugName = `clone_${this.debugName}`, t._source = this._source, t._name = `clone_${this._name}`, t.type = this.type, t.refCounts = this.refCounts, t.refCounts[t._name] = 0, t;
  }
  /**
   * @param source The name of the source. Will change in assemble.
   * @param type The type of the output node.
   * @param refCounts A global ref counter map.
   */
  constructor(t, g, d, k) {
    super(t, g), this.type = d, this.refCounts = k, this._source = this._name = g, this.refCounts && !(this._name in this.refCounts) && (this.refCounts[this._name] = 0);
  }
  dependentFields() {
    return /* @__PURE__ */ new Set();
  }
  producedFields() {
    return /* @__PURE__ */ new Set();
  }
  hash() {
    return this._hash === void 0 && (this._hash = `Output ${uniqueId()}`), this._hash;
  }
  /**
   * Request the datasource name and increase the ref counter.
   *
   * During the parsing phase, this will return the simple name such as 'main' or 'raw'.
   * It is crucial to request the name from an output node to mark it as a required node.
   * If nobody ever requests the name, this datasource will not be instantiated in the assemble phase.
   *
   * In the assemble phase, this will return the correct name.
   */
  getSource() {
    return this.refCounts[this._name]++, this._source;
  }
  isRequired() {
    return !!this.refCounts[this._name];
  }
  setSource(t) {
    this._source = t;
  }
}
function isTimeUnitTransformComponent(n) {
  return n.as !== void 0;
}
function offsetAs(n) {
  return `${n}_end`;
}
class TimeUnitNode extends DataFlowNode {
  timeUnits;
  clone() {
    return new TimeUnitNode(null, duplicate(this.timeUnits));
  }
  constructor(t, g) {
    super(t), this.timeUnits = g;
  }
  static makeFromEncoding(t, g) {
    const d = g.reduceFieldDef((k, H, AA) => {
      const { field: gA, timeUnit: IA } = H;
      if (IA) {
        let CA;
        if (isBinnedTimeUnit(IA)) {
          if (isUnitModel(g)) {
            const { mark: BA, markDef: eA, config: iA } = g, QA = getBandPosition({ fieldDef: H, markDef: eA, config: iA });
            (isRectBasedMark(BA) || QA) && (CA = {
              timeUnit: normalizeTimeUnit(IA),
              field: gA
            });
          }
        } else
          CA = {
            as: vgField(H, { forAs: !0 }),
            field: gA,
            timeUnit: IA
          };
        if (isUnitModel(g)) {
          const { mark: BA, markDef: eA, config: iA } = g, QA = getBandPosition({ fieldDef: H, markDef: eA, config: iA });
          isRectBasedMark(BA) && isXorY(AA) && QA !== 0.5 && (CA.rectBandPosition = QA);
        }
        CA && (k[hash(CA)] = CA);
      }
      return k;
    }, {});
    return isEmpty(d) ? null : new TimeUnitNode(t, d);
  }
  static makeFromTransform(t, g) {
    const { timeUnit: d, ...k } = { ...g }, H = normalizeTimeUnit(d), AA = {
      ...k,
      timeUnit: H
    };
    return new TimeUnitNode(t, {
      [hash(AA)]: AA
    });
  }
  /**
   * Merge together TimeUnitNodes assigning the children of `other` to `this`
   * and removing `other`.
   */
  merge(t) {
    this.timeUnits = { ...this.timeUnits };
    for (const g in t.timeUnits)
      this.timeUnits[g] || (this.timeUnits[g] = t.timeUnits[g]);
    for (const g of t.children)
      t.removeChild(g), g.parent = this;
    t.remove();
  }
  /**
   * Remove time units coming from the other node.
   */
  removeFormulas(t) {
    const g = {};
    for (const [d, k] of entries$1(this.timeUnits)) {
      const H = isTimeUnitTransformComponent(k) ? k.as : `${k.field}_end`;
      t.has(H) || (g[d] = k);
    }
    this.timeUnits = g;
  }
  producedFields() {
    return new Set(vals(this.timeUnits).map((t) => isTimeUnitTransformComponent(t) ? t.as : offsetAs(t.field)));
  }
  dependentFields() {
    return new Set(vals(this.timeUnits).map((t) => t.field));
  }
  hash() {
    return `TimeUnit ${hash(this.timeUnits)}`;
  }
  assemble() {
    const t = [];
    for (const g of vals(this.timeUnits)) {
      const { rectBandPosition: d } = g, k = normalizeTimeUnit(g.timeUnit);
      if (isTimeUnitTransformComponent(g)) {
        const { field: H, as: AA } = g, { unit: gA, utc: IA, ...CA } = k, BA = [AA, `${AA}_end`];
        t.push({
          field: replacePathInField(H),
          type: "timeunit",
          ...gA ? { units: getTimeUnitParts(gA) } : {},
          ...IA ? { timezone: "utc" } : {},
          ...CA,
          as: BA
        }), t.push(...offsetedRectFormulas(BA, d, k));
      } else if (g) {
        const { field: H } = g, AA = unescapeSingleQuoteAndPathDot(H), gA = offsetExpr({ timeUnit: k, field: AA }), IA = offsetAs(AA);
        t.push({
          type: "formula",
          expr: gA,
          as: IA
        }), t.push(...offsetedRectFormulas([AA, IA], d, k));
      }
    }
    return t;
  }
}
const OFFSETTED_RECT_START_SUFFIX = "offsetted_rect_start", OFFSETTED_RECT_END_SUFFIX = "offsetted_rect_end";
function offsetExpr({ timeUnit: n, field: t, reverse: g }) {
  const { unit: d, utc: k } = n, H = getSmallestTimeUnitPart(d), { part: AA, step: gA } = getDateTimePartAndStep(H, n.step);
  return `${k ? "utcOffset" : "timeOffset"}('${AA}', ${accessWithDatumToUnescapedPath(t)}, ${g ? -gA : gA})`;
}
function offsetedRectFormulas([n, t], g, d) {
  if (g !== void 0 && g !== 0.5) {
    const k = accessWithDatumToUnescapedPath(n), H = accessWithDatumToUnescapedPath(t);
    return [
      {
        type: "formula",
        expr: interpolateExpr([
          offsetExpr({
            timeUnit: d,
            field: n,
            reverse: !0
          }),
          k
        ], g + 0.5),
        as: `${n}_${OFFSETTED_RECT_START_SUFFIX}`
      },
      {
        type: "formula",
        expr: interpolateExpr([k, H], g + 0.5),
        as: `${n}_${OFFSETTED_RECT_END_SUFFIX}`
      }
    ];
  }
  return [];
}
function interpolateExpr([n, t], g) {
  return `${1 - g} * ${n} + ${g} * ${t}`;
}
const TUPLE_FIELDS = "_tuple_fields";
class SelectionProjectionComponent {
  hasChannel;
  hasField;
  hasSelectionId;
  timeUnit;
  items;
  constructor(...t) {
    this.items = t, this.hasChannel = {}, this.hasField = {}, this.hasSelectionId = !1;
  }
}
const project = {
  defined: () => !0,
  parse: (n, t, g) => {
    const d = t.name, k = t.project ??= new SelectionProjectionComponent(), H = {}, AA = {}, gA = /* @__PURE__ */ new Set(), IA = (tA, oA) => {
      const EA = oA === "visual" ? tA.channel : tA.field;
      let aA = varName(`${d}_${EA}`);
      for (let nA = 1; gA.has(aA); nA++)
        aA = varName(`${d}_${EA}_${nA}`);
      return gA.add(aA), { [oA]: aA };
    }, CA = t.type, BA = n.config.selection[CA], eA = g.value !== void 0 ? array(g.value) : null;
    let { fields: iA, encodings: QA } = isObject$3(g.select) ? g.select : {};
    if (!iA && !QA && eA) {
      for (const tA of eA)
        if (isObject$3(tA))
          for (const oA of keys$1(tA))
            isSingleDefUnitChannel(oA) ? (QA || (QA = [])).push(oA) : CA === "interval" ? (warn(INTERVAL_INITIALIZED_WITH_POS), QA = BA.encodings) : (iA ??= []).push(oA);
    }
    !iA && !QA && (QA = BA.encodings, "fields" in BA && (iA = BA.fields));
    for (const tA of QA ?? []) {
      const oA = n.fieldDef(tA);
      if (oA) {
        let EA = oA.field;
        if (oA.aggregate) {
          warn(cannotProjectAggregate(tA, oA.aggregate));
          continue;
        } else if (!EA) {
          warn(cannotProjectOnChannelWithoutField(tA));
          continue;
        }
        if (oA.timeUnit && !isBinnedTimeUnit(oA.timeUnit)) {
          EA = n.vgField(tA);
          const aA = {
            timeUnit: oA.timeUnit,
            as: EA,
            field: oA.field
          };
          AA[hash(aA)] = aA;
        }
        if (!H[EA]) {
          const aA = CA === "interval" && isScaleChannel(tA) && hasContinuousDomain(n.getScaleComponent(tA).get("type")) ? "R" : oA.bin ? "R-RE" : "E", nA = { field: EA, channel: tA, type: aA, index: k.items.length };
          nA.signals = { ...IA(nA, "data"), ...IA(nA, "visual") }, k.items.push(H[EA] = nA), k.hasField[EA] = H[EA], k.hasSelectionId = k.hasSelectionId || EA === SELECTION_ID, isGeoPositionChannel(tA) ? (nA.geoChannel = tA, nA.channel = getPositionChannelFromLatLong(tA), k.hasChannel[nA.channel] = H[EA]) : k.hasChannel[tA] = H[EA];
        }
      } else
        warn(cannotProjectOnChannelWithoutField(tA));
    }
    for (const tA of iA ?? []) {
      if (k.hasField[tA])
        continue;
      const oA = { type: "E", field: tA, index: k.items.length };
      oA.signals = { ...IA(oA, "data") }, k.items.push(oA), k.hasField[tA] = oA, k.hasSelectionId = k.hasSelectionId || tA === SELECTION_ID;
    }
    eA && (t.init = eA.map((tA) => k.items.map((oA) => isObject$3(tA) ? tA[oA.geoChannel || oA.channel] !== void 0 ? tA[oA.geoChannel || oA.channel] : tA[oA.field] : tA))), isEmpty(AA) || (k.timeUnit = new TimeUnitNode(null, AA));
  },
  signals: (n, t, g) => {
    const d = t.name + TUPLE_FIELDS;
    return g.filter((H) => H.name === d).length > 0 || t.project.hasSelectionId ? g : g.concat({
      name: d,
      value: t.project.items.map(assembleProjection)
    });
  }
}, CURR = "_curr", ANIM_VALUE = "anim_value", ANIM_CLOCK = "anim_clock", EASED_ANIM_CLOCK = "eased_anim_clock", MIN_EXTENT = "min_extent", MAX_RANGE_EXTENT = "max_range_extent", LAST_TICK = "last_tick_at", IS_PLAYING = "is_playing", THROTTLE = 1 / 60 * 1e3, animationSignals = (n, t) => [
  // timer signals
  {
    name: EASED_ANIM_CLOCK,
    // update: 'easeLinear(anim_clock / max_range_extent) * max_range_extent'
    update: ANIM_CLOCK
    // TODO: replace with above once easing functions are implemented in vega-functions
  },
  // scale signals
  // TODO(jzong): uncomment commented signals below when implementing interpolation
  { name: `${n}_domain`, init: `domain('${t}')` },
  { name: MIN_EXTENT, init: `extent(${n}_domain)[0]` },
  // {name: 'max_extent', init: `extent(${selectionName}_domain)[1]`},
  { name: MAX_RANGE_EXTENT, init: `extent(range('${t}'))[1]` },
  // {name: 't_index', update: `indexof(${selectionName}_domain, anim_value)`},
  { name: ANIM_VALUE, update: `invert('${t}', ${EASED_ANIM_CLOCK})` }
], point$1 = {
  defined: (n) => n.type === "point",
  topLevelSignals: (n, t, g) => (isTimerSelection(t) && (g = g.concat([
    {
      name: ANIM_CLOCK,
      init: "0",
      on: [
        {
          events: { type: "timer", throttle: THROTTLE },
          update: `${IS_PLAYING} ? (${ANIM_CLOCK} + (now() - ${LAST_TICK}) > ${MAX_RANGE_EXTENT} ? 0 : ${ANIM_CLOCK} + (now() - ${LAST_TICK})) : ${ANIM_CLOCK}`
        }
      ]
    },
    {
      name: LAST_TICK,
      init: "now()",
      on: [{ events: [{ signal: ANIM_CLOCK }, { signal: IS_PLAYING }], update: "now()" }]
    },
    {
      name: IS_PLAYING,
      init: "true"
    }
  ])), g),
  signals: (n, t, g) => {
    const d = t.name, k = d + TUPLE_FIELDS, H = t.project, AA = "(item().isVoronoi ? datum.datum : datum)", gA = vals(n.component.selection ?? {}).reduce((BA, eA) => eA.type === "interval" ? BA.concat(eA.name + BRUSH) : BA, []).map((BA) => `indexof(item().mark.name, '${BA}') < 0`).join(" && "), IA = `datum && item().mark.marktype !== 'group' && indexof(item().mark.role, 'legend') < 0${gA ? ` && ${gA}` : ""}`;
    let CA = `unit: ${unitName(n)}, `;
    if (t.project.hasSelectionId)
      CA += `${SELECTION_ID}: ${AA}[${$$1(SELECTION_ID)}]`;
    else if (isTimerSelection(t))
      CA += `fields: ${k}, values: [${ANIM_VALUE} ? ${ANIM_VALUE} : ${MIN_EXTENT}]`;
    else {
      const BA = H.items.map((eA) => n.fieldDef(eA.channel)?.bin ? `[${AA}[${$$1(n.vgField(eA.channel, {}))}], ${AA}[${$$1(n.vgField(eA.channel, { binSuffix: "end" }))}]]` : `${AA}[${$$1(eA.field)}]`).join(", ");
      CA += `fields: ${k}, values: [${BA}]`;
    }
    if (isTimerSelection(t))
      return g.concat(animationSignals(t.name, n.scaleName(TIME)), [
        {
          name: d + TUPLE,
          on: [
            {
              events: [{ signal: EASED_ANIM_CLOCK }, { signal: ANIM_VALUE }],
              update: `{${CA}}`,
              force: !0
            }
          ]
        }
      ]);
    {
      const BA = t.events;
      return g.concat([
        {
          name: d + TUPLE,
          on: BA ? [
            {
              events: BA,
              update: `${IA} ? {${CA}} : null`,
              force: !0
            }
          ] : []
        }
      ]);
    }
  }
};
function assembleProjection(n) {
  const { signals: t, hasLegend: g, index: d, ...k } = n;
  return k.field = replacePathInField(k.field), k;
}
function assembleInit(n, t = !0, g = identity$1) {
  if (isArray$2(n)) {
    const d = n.map((k) => assembleInit(k, t, g));
    return t ? `[${d.join(", ")}]` : d;
  } else if (isDateTime(n))
    return g(t ? dateTimeToExpr(n) : dateTimeToTimestamp(n));
  return t ? g(stringify$1(n)) : n;
}
function assembleUnitSelectionSignals(n, t) {
  for (const g of vals(n.component.selection ?? {})) {
    const d = g.name;
    let k = `${d}${TUPLE}, ${g.resolve === "global" ? "true" : `{unit: ${unitName(n)}}`}`;
    for (const H of selectionCompilers)
      H.defined(g) && (H.signals && (t = H.signals(n, g, t)), H.modifyExpr && (k = H.modifyExpr(n, g, k)));
    t.push({
      name: d + MODIFY,
      on: [
        {
          events: { signal: g.name + TUPLE },
          update: `modify(${$$1(g.name + STORE)}, ${k})`
        }
      ]
    });
  }
  return cleanupEmptyOnArray(t);
}
function assembleFacetSignals(n, t) {
  if (n.component.selection && keys$1(n.component.selection).length) {
    const g = $$1(n.getName("cell"));
    t.unshift({
      name: "facet",
      value: {},
      on: [
        {
          events: eventSelector("pointermove", "scope"),
          update: `isTuple(facet) ? facet : group(${g}).datum`
        }
      ]
    });
  }
  return cleanupEmptyOnArray(t);
}
function assembleTopLevelSignals(n, t) {
  let g = !1;
  for (const d of vals(n.component.selection ?? {})) {
    const k = d.name, H = $$1(k + STORE);
    if (t.filter((gA) => gA.name === k).length === 0) {
      const gA = d.resolve === "global" ? "union" : d.resolve, IA = d.type === "point" ? ", true, true)" : ")";
      t.push({
        name: d.name,
        update: `${VL_SELECTION_RESOLVE}(${H}, ${$$1(gA)}${IA}`
      });
    }
    g = !0;
    for (const gA of selectionCompilers)
      gA.defined(d) && gA.topLevelSignals && (t = gA.topLevelSignals(n, d, t));
  }
  return g && t.filter((k) => k.name === "unit").length === 0 && t.unshift({
    name: "unit",
    value: {},
    on: [{ events: "pointermove", update: "isTuple(group()) ? group() : unit" }]
  }), cleanupEmptyOnArray(t);
}
function assembleUnitSelectionData(n, t) {
  const g = [], d = [], k = unitName(n, { escape: !1 });
  for (const H of vals(n.component.selection ?? {})) {
    const AA = { name: H.name + STORE };
    if (H.project.hasSelectionId && (AA.transform = [{ type: "collect", sort: { field: SELECTION_ID } }]), H.init) {
      const IA = H.project.items.map(assembleProjection);
      AA.values = H.project.hasSelectionId ? H.init.map((CA) => ({ unit: k, [SELECTION_ID]: assembleInit(CA, !1)[0] })) : H.init.map((CA) => ({ unit: k, fields: IA, values: assembleInit(CA, !1) }));
    }
    if ([...g, ...t].filter((IA) => IA.name === H.name + STORE).length || g.push(AA), isTimerSelection(H) && t.length) {
      const IA = n.lookupDataSource(n.getDataName(DataSourceType.Main)), CA = t.find((eA) => eA.name === IA), BA = CA.transform.find((eA) => eA.type === "filter" && eA.expr.includes("vlSelectionTest"));
      if (BA) {
        CA.transform = CA.transform.filter((iA) => iA !== BA);
        const eA = {
          name: CA.name + CURR,
          source: CA.name,
          transform: [BA]
          // add the selection filter to the animation dataset
        };
        d.push(eA);
      }
    }
  }
  return g.concat(t, d);
}
function assembleUnitSelectionMarks(n, t) {
  for (const g of vals(n.component.selection ?? {}))
    for (const d of selectionCompilers)
      d.defined(g) && d.marks && (t = d.marks(n, g, t));
  return t;
}
function assembleLayerSelectionMarks(n, t) {
  for (const g of n.children)
    isUnitModel(g) && (t = assembleUnitSelectionMarks(g, t));
  return t;
}
function assembleSelectionScaleDomain(n, t, g, d) {
  const k = parseSelectionExtent(n, t.param, t);
  return {
    signal: hasContinuousDomain(g.get("type")) && isArray$2(d) && d[0] > d[1] ? `isValid(${k}) && reverse(${k})` : k
  };
}
function cleanupEmptyOnArray(n) {
  return n.map((t) => (t.on && !t.on.length && delete t.on, t));
}
const scaleBindings = {
  defined: (n) => n.type === "interval" && n.resolve === "global" && n.bind && n.bind === "scales",
  parse: (n, t) => {
    const g = t.scales = [];
    for (const d of t.project.items) {
      const k = d.channel;
      if (!isScaleChannel(k))
        continue;
      const H = n.getScaleComponent(k), AA = H ? H.get("type") : void 0;
      if (AA == "sequential" && warn(SEQUENTIAL_SCALE_DEPRECATED), !H || !hasContinuousDomain(AA)) {
        warn(SCALE_BINDINGS_CONTINUOUS);
        continue;
      }
      H.set("selectionExtent", { param: t.name, field: d.field }, !0), g.push(d);
    }
  },
  topLevelSignals: (n, t, g) => {
    const d = t.scales.filter((AA) => g.filter((gA) => gA.name === AA.signals.data).length === 0);
    if (!n.parent || isTopLevelLayer(n) || d.length === 0)
      return g;
    const k = g.find((AA) => AA.name === t.name);
    let H = k.update;
    if (H.includes(VL_SELECTION_RESOLVE))
      k.update = `{${d.map((AA) => `${$$1(replacePathInField(AA.field))}: ${AA.signals.data}`).join(", ")}}`;
    else {
      for (const AA of d) {
        const gA = `${$$1(replacePathInField(AA.field))}: ${AA.signals.data}`;
        H.includes(gA) || (H = `${H.substring(0, H.length - 1)}, ${gA}}`);
      }
      k.update = H;
    }
    return g.concat(d.map((AA) => ({ name: AA.signals.data })));
  },
  signals: (n, t, g) => {
    if (n.parent && !isTopLevelLayer(n))
      for (const d of t.scales) {
        const k = g.find((H) => H.name === d.signals.data);
        k.push = "outer", delete k.value, delete k.update;
      }
    return g;
  }
};
function domain(n, t) {
  return `domain(${$$1(n.scaleName(t))})`;
}
function isTopLevelLayer(n) {
  return n.parent && isLayerModel(n.parent) && (!n.parent.parent || isTopLevelLayer(n.parent.parent));
}
const BRUSH = "_brush", SCALE_TRIGGER = "_scale_trigger", GEO_INIT_TICK = "geo_interval_init_tick", INIT = "_init", CENTER = "_center", interval = {
  defined: (n) => n.type === "interval",
  parse: (n, t, g) => {
    if (n.hasProjection) {
      const d = { ...isObject$4(g.select) ? g.select : {} };
      d.fields = [SELECTION_ID], d.encodings || (d.encodings = g.value ? keys$1(g.value) : [LONGITUDE, LATITUDE]), g.select = { type: "interval", ...d };
    }
    if (t.translate && !scaleBindings.defined(t)) {
      const d = `!event.item || event.item.mark.name !== ${$$1(t.name + BRUSH)}`;
      for (const k of t.events) {
        if (!k.between) {
          warn(`${k} is not an ordered event stream for interval selections.`);
          continue;
        }
        const H = array(k.between[0].filter ??= []);
        H.includes(d) || H.push(d);
      }
    }
  },
  signals: (n, t, g) => {
    const d = t.name, k = d + TUPLE, H = vals(t.project.hasChannel).filter((gA) => gA.channel === X$1 || gA.channel === Y), AA = t.init ? t.init[0] : null;
    if (g.push(...H.reduce((gA, IA) => gA.concat(channelSignals(n, t, IA, AA?.[IA.index])), [])), n.hasProjection) {
      const gA = $$1(n.projectionName()), IA = n.projectionName() + CENTER, { x: CA, y: BA } = t.project.hasChannel, eA = CA?.signals.visual, iA = BA?.signals.visual, QA = CA ? AA?.[CA.index] : `${IA}[0]`, tA = BA ? AA?.[BA.index] : `${IA}[1]`, oA = (sA) => n.getSizeSignalRef(sA).signal, EA = `[[${eA ? `${eA}[0]` : "0"}, ${iA ? `${iA}[0]` : "0"}],[${eA ? `${eA}[1]` : oA("width")}, ${iA ? `${iA}[1]` : oA("height")}]]`;
      AA && (g.unshift({
        name: d + INIT,
        init: `[scale(${gA}, [${CA ? QA[0] : QA}, ${BA ? tA[0] : tA}]), scale(${gA}, [${CA ? QA[1] : QA}, ${BA ? tA[1] : tA}])]`
      }), (!CA || !BA) && (g.find((rA) => rA.name === IA) || g.unshift({
        name: IA,
        update: `invert(${gA}, [${oA("width")}/2, ${oA("height")}/2])`
      })));
      const aA = `intersect(${EA}, {markname: ${$$1(n.getName("marks"))}}, unit.mark)`, nA = `{unit: ${unitName(n)}}`, lA = `vlSelectionTuples(${aA}, ${nA})`, cA = H.map((sA) => sA.signals.visual);
      return g.concat({
        name: k,
        on: [
          {
            events: [
              ...cA.length ? [{ signal: cA.join(" || ") }] : [],
              ...AA ? [{ signal: GEO_INIT_TICK }] : []
            ],
            update: lA
          }
        ]
      });
    } else {
      if (!scaleBindings.defined(t)) {
        const CA = d + SCALE_TRIGGER, BA = H.map((eA) => {
          const iA = eA.channel, { data: QA, visual: tA } = eA.signals, oA = $$1(n.scaleName(iA)), EA = n.getScaleComponent(iA).get("type"), aA = hasContinuousDomain(EA) ? "+" : "";
          return `(!isArray(${QA}) || (${aA}invert(${oA}, ${tA})[0] === ${aA}${QA}[0] && ${aA}invert(${oA}, ${tA})[1] === ${aA}${QA}[1]))`;
        });
        BA.length && g.push({
          name: CA,
          value: {},
          on: [
            {
              events: H.map((eA) => ({ scale: n.scaleName(eA.channel) })),
              update: `${BA.join(" && ")} ? ${CA} : {}`
            }
          ]
        });
      }
      const gA = H.map((CA) => CA.signals.data), IA = `unit: ${unitName(n)}, fields: ${d + TUPLE_FIELDS}, values`;
      return g.concat({
        name: k,
        ...AA ? { init: `{${IA}: ${assembleInit(AA)}}` } : {},
        ...gA.length ? {
          on: [
            {
              events: [{ signal: gA.join(" || ") }],
              // Prevents double invocation, see https://github.com/vega/vega/issues/1672.
              update: `${gA.join(" && ")} ? {${IA}: [${gA}]} : null`
            }
          ]
        } : {}
      });
    }
  },
  topLevelSignals: (n, t, g) => (isUnitModel(n) && n.hasProjection && t.init && (g.filter((k) => k.name === GEO_INIT_TICK).length || g.unshift({
    name: GEO_INIT_TICK,
    value: null,
    on: [
      {
        events: "timer{1}",
        update: `${GEO_INIT_TICK} === null ? {} : ${GEO_INIT_TICK}`
      }
    ]
  })), g),
  marks: (n, t, g) => {
    const d = t.name, { x: k, y: H } = t.project.hasChannel, AA = k?.signals.visual, gA = H?.signals.visual, IA = `data(${$$1(t.name + STORE)})`;
    if (scaleBindings.defined(t) || !k && !H)
      return g;
    const CA = {
      x: k !== void 0 ? { signal: `${AA}[0]` } : { value: 0 },
      y: H !== void 0 ? { signal: `${gA}[0]` } : { value: 0 },
      x2: k !== void 0 ? { signal: `${AA}[1]` } : { field: { group: "width" } },
      y2: H !== void 0 ? { signal: `${gA}[1]` } : { field: { group: "height" } }
    };
    if (t.resolve === "global")
      for (const EA of keys$1(CA))
        CA[EA] = [
          {
            test: `${IA}.length && ${IA}[0].unit === ${unitName(n)}`,
            ...CA[EA]
          },
          { value: 0 }
        ];
    const { fill: BA, fillOpacity: eA, cursor: iA, ...QA } = t.mark, tA = keys$1(QA).reduce((EA, aA) => (EA[aA] = [
      {
        test: [
          k !== void 0 && `${AA}[0] !== ${AA}[1]`,
          H !== void 0 && `${gA}[0] !== ${gA}[1]`
        ].filter((nA) => nA).join(" && "),
        value: QA[aA]
      },
      { value: null }
    ], EA), {}), oA = iA ?? (t.translate ? "move" : null);
    return [
      {
        name: `${d + BRUSH}_bg`,
        type: "rect",
        clip: !0,
        encode: {
          enter: {
            fill: { value: BA },
            fillOpacity: { value: eA }
          },
          update: CA
        }
      },
      ...g,
      {
        name: d + BRUSH,
        type: "rect",
        clip: !0,
        encode: {
          enter: {
            ...oA ? { cursor: { value: oA } } : {},
            fill: { value: "transparent" }
          },
          update: { ...CA, ...tA }
        }
      }
    ];
  }
};
function channelSignals(n, t, g, d) {
  const k = !n.hasProjection, H = g.channel, AA = g.signals.visual, gA = $$1(k ? n.scaleName(H) : n.projectionName()), IA = (iA) => `scale(${gA}, ${iA})`, CA = n.getSizeSignalRef(H === X$1 ? "width" : "height").signal, BA = `${H}(unit)`, eA = t.events.reduce((iA, QA) => [
    ...iA,
    { events: QA.between[0], update: `[${BA}, ${BA}]` },
    // Brush Start
    { events: QA, update: `[${AA}[0], clamp(${BA}, 0, ${CA})]` }
    // Brush End
  ], []);
  if (k) {
    const iA = g.signals.data, QA = scaleBindings.defined(t), tA = n.getScaleComponent(H), oA = tA ? tA.get("type") : void 0, EA = d ? { init: assembleInit(d, !0, IA) } : { value: [] };
    return eA.push({
      events: { signal: t.name + SCALE_TRIGGER },
      update: hasContinuousDomain(oA) ? `[${IA(`${iA}[0]`)}, ${IA(`${iA}[1]`)}]` : "[0, 0]"
    }), QA ? [{ name: iA, on: [] }] : [
      { name: AA, ...EA, on: eA },
      {
        name: iA,
        ...d ? { init: assembleInit(d) } : {},
        // Cannot be `value` as `init` may require datetime exprs.
        on: [
          {
            events: { signal: AA },
            update: `${AA}[0] === ${AA}[1] ? null : invert(${gA}, ${AA})`
          }
        ]
      }
    ];
  } else {
    const iA = H === X$1 ? 0 : 1, QA = t.name + INIT, tA = d ? { init: `[${QA}[0][${iA}], ${QA}[1][${iA}]]` } : { value: [] };
    return [{ name: AA, ...tA, on: eA }];
  }
}
function wrapCondition({ model: n, channelDef: t, vgChannel: g, invalidValueRef: d, mainRefFn: k }) {
  const H = isConditionalDef(t) && t.condition;
  let AA = [];
  H && (AA = array(H).map((CA) => {
    const BA = k(CA);
    if (isConditionalParameter(CA)) {
      const { param: eA, empty: iA } = CA;
      return { test: parseSelectionPredicate(n, { param: eA, empty: iA }), ...BA };
    } else
      return { test: expression(n, CA.test), ...BA };
  })), d !== void 0 && AA.push(d);
  const gA = k(t);
  return gA !== void 0 && AA.push(gA), AA.length > 1 || AA.length === 1 && AA[0].test ? { [g]: AA } : AA.length === 1 ? { [g]: AA[0] } : {};
}
function text$1(n, t = "text") {
  const g = n.encoding[t];
  return wrapCondition({
    model: n,
    channelDef: g,
    vgChannel: t,
    mainRefFn: (d) => textRef(d, n.config),
    invalidValueRef: void 0
    // text encoding doesn't have continuous scales and thus can't have invalid values
  });
}
function textRef(n, t, g = "datum") {
  if (n) {
    if (isValueDef(n))
      return signalOrValueRef(n.value);
    if (isFieldOrDatumDef(n)) {
      const { format: d, formatType: k } = getFormatMixins(n);
      return formatSignalRef({ fieldOrDatumDef: n, format: d, formatType: k, expr: g, config: t });
    }
  }
}
function tooltip(n, t = {}) {
  const { encoding: g, markDef: d, config: k, stack: H } = n, AA = g.tooltip;
  if (isArray$2(AA))
    return { tooltip: tooltipRefForEncoding({ tooltip: AA }, H, k, t) };
  {
    const gA = t.reactiveGeom ? "datum.datum" : "datum";
    return wrapCondition({
      model: n,
      channelDef: AA,
      vgChannel: "tooltip",
      mainRefFn: (CA) => {
        const BA = textRef(CA, k, gA);
        if (BA)
          return BA;
        if (CA === null)
          return;
        let eA = getMarkPropOrConfig("tooltip", d, k);
        if (eA === !0 && (eA = { content: "encoding" }), isString$1(eA))
          return { value: eA };
        if (isObject$3(eA))
          return isSignalRef(eA) ? eA : eA.content === "encoding" ? tooltipRefForEncoding(g, H, k, t) : { signal: gA };
      },
      invalidValueRef: void 0
      // tooltip encoding doesn't have continuous scales and thus can't have invalid values
    });
  }
}
function tooltipData(n, t, g, { reactiveGeom: d } = {}) {
  const k = { ...g, ...g.tooltipFormat }, H = /* @__PURE__ */ new Set(), AA = d ? "datum.datum" : "datum", gA = [];
  function IA(BA, eA) {
    const iA = getMainRangeChannel(eA), QA = isTypedFieldDef(BA) ? BA : {
      ...BA,
      type: n[iA].type
      // for secondary field def, copy type from main channel
    }, tA = QA.title || defaultTitle(QA, k), oA = array(tA).join(", ").replaceAll(/"/g, '\\"');
    let EA;
    if (isXorY(eA)) {
      const aA = eA === "x" ? "x2" : "y2", nA = getFieldDef(n[aA]);
      if (isBinned(QA.bin) && nA) {
        const lA = vgField(QA, { expr: AA }), cA = vgField(nA, { expr: AA }), { format: sA, formatType: rA } = getFormatMixins(QA);
        EA = binFormatExpression(lA, cA, sA, rA, k), H.add(aA);
      }
    }
    if ((isXorY(eA) || eA === THETA || eA === RADIUS) && t && t.fieldChannel === eA && t.offset === "normalize") {
      const { format: aA, formatType: nA } = getFormatMixins(QA);
      EA = formatSignalRef({
        fieldOrDatumDef: QA,
        format: aA,
        formatType: nA,
        expr: AA,
        config: k,
        normalizeStack: !0
      }).signal;
    }
    EA ??= textRef(QA, k, AA).signal, gA.push({ channel: eA, key: oA, value: EA });
  }
  forEach$2(n, (BA, eA) => {
    isFieldDef(BA) ? IA(BA, eA) : hasConditionalFieldDef(BA) && IA(BA.condition, eA);
  });
  const CA = {};
  for (const { channel: BA, key: eA, value: iA } of gA)
    !H.has(BA) && !CA[eA] && (CA[eA] = iA);
  return CA;
}
function tooltipRefForEncoding(n, t, g, { reactiveGeom: d } = {}) {
  const k = tooltipData(n, t, g, { reactiveGeom: d }), H = entries$1(k).map(([AA, gA]) => `"${AA}": ${gA}`);
  return H.length > 0 ? { signal: `{${H.join(", ")}}` } : void 0;
}
function aria(n) {
  const { markDef: t, config: g } = n, d = getMarkPropOrConfig("aria", t, g);
  return d === !1 ? {} : {
    ...d ? { aria: d } : {},
    ...ariaRoleDescription(n),
    ...description(n)
  };
}
function ariaRoleDescription(n) {
  const { mark: t, markDef: g, config: d } = n;
  if (d.aria === !1)
    return {};
  const k = getMarkPropOrConfig("ariaRoleDescription", g, d);
  return k != null ? { ariaRoleDescription: { value: k } } : has(VG_MARK_INDEX, t) ? {} : { ariaRoleDescription: { value: t } };
}
function description(n) {
  const { encoding: t, markDef: g, config: d, stack: k } = n, H = t.description;
  if (H)
    return wrapCondition({
      model: n,
      channelDef: H,
      vgChannel: "description",
      mainRefFn: (IA) => textRef(IA, n.config),
      invalidValueRef: void 0
      // aria encoding doesn't have continuous scales and thus can't have invalid values
    });
  const AA = getMarkPropOrConfig("description", g, d);
  if (AA != null)
    return {
      description: signalOrValueRef(AA)
    };
  if (d.aria === !1)
    return {};
  const gA = tooltipData(t, k, d);
  if (!isEmpty(gA))
    return {
      description: {
        signal: entries$1(gA).filter(([IA]) => !IA.startsWith("_")).map(([IA, CA], BA) => `"${BA > 0 ? "; " : ""}${IA}: " + (${CA})`).join(" + ")
      }
    };
}
function nonPosition(n, t, g = {}) {
  const { markDef: d, encoding: k, config: H } = t, { vgChannel: AA } = g;
  let { defaultRef: gA, defaultValue: IA } = g;
  const CA = k[n];
  gA === void 0 && (IA ??= getMarkPropOrConfig(n, d, H, {
    vgChannel: AA,
    // If there is no conditonal def, we ignore vgConfig so the output spec is concise.
    // However, if there is a conditional def, we must include vgConfig so the default is respected.
    ignoreVgConfig: !isConditionalDef(CA)
  }), IA !== void 0 && (gA = signalOrValueRef(IA)));
  const BA = {
    markDef: d,
    config: H,
    scaleName: t.scaleName(n),
    scale: t.getScaleComponent(n)
  }, eA = getConditionalValueRefForIncludingInvalidValue({
    ...BA,
    scaleChannel: n,
    channelDef: CA
  });
  return wrapCondition({
    model: t,
    channelDef: CA,
    vgChannel: AA ?? n,
    invalidValueRef: eA,
    mainRefFn: (QA) => midPoint({
      ...BA,
      channel: n,
      channelDef: QA,
      stack: null,
      // No need to provide stack for non-position as it does not affect mid point
      defaultRef: gA
    })
  });
}
function color(n, t = { filled: void 0 }) {
  const { markDef: g, encoding: d, config: k } = n, { type: H } = g, AA = t.filled ?? getMarkPropOrConfig("filled", g, k), gA = contains(["bar", "point", "circle", "square", "geoshape"], H) ? "transparent" : void 0, IA = getMarkPropOrConfig(AA === !0 ? "color" : void 0, g, k, { vgChannel: "fill" }) ?? // need to add this manually as getMarkConfig normally drops config.mark[channel] if vgChannel is specified
  k.mark[AA === !0 && "color"] ?? // If there is no fill, always fill symbols, bar, geoshape
  // with transparent fills https://github.com/vega/vega-lite/issues/1316
  gA, CA = getMarkPropOrConfig(AA === !1 ? "color" : void 0, g, k, { vgChannel: "stroke" }) ?? // need to add this manually as getMarkConfig normally drops config.mark[channel] if vgChannel is specified
  k.mark[AA === !1 && "color"], BA = AA ? "fill" : "stroke", eA = {
    ...IA ? { fill: signalOrValueRef(IA) } : {},
    ...CA ? { stroke: signalOrValueRef(CA) } : {}
  };
  return g.color && (AA ? g.fill : g.stroke) && warn(droppingColor("property", { fill: "fill" in g, stroke: "stroke" in g })), {
    ...eA,
    ...nonPosition("color", n, {
      vgChannel: BA,
      defaultValue: AA ? IA : CA
    }),
    ...nonPosition("fill", n, {
      // if there is encoding.fill, include default fill just in case we have conditional-only fill encoding
      defaultValue: d.fill ? IA : void 0
    }),
    ...nonPosition("stroke", n, {
      // if there is encoding.stroke, include default fill just in case we have conditional-only stroke encoding
      defaultValue: d.stroke ? CA : void 0
    })
  };
}
function zindex(n) {
  const { encoding: t, mark: g } = n, d = t.order;
  return !isPathMark(g) && isValueDef(d) ? wrapCondition({
    model: n,
    channelDef: d,
    vgChannel: "zindex",
    mainRefFn: (k) => signalOrValueRef(k.value),
    invalidValueRef: void 0
    // zindex encoding doesn't have continuous scales and thus can't have invalid values
  }) : {};
}
function positionOffset({ channel: n, markDef: t, encoding: g = {}, model: d, bandPosition: k }) {
  const H = `${n}Offset`, AA = t[H], gA = g[H];
  if ((H === "xOffset" || H === "yOffset") && gA)
    return { offsetType: "encoding", offset: midPoint({
      channel: H,
      channelDef: gA,
      markDef: t,
      config: d?.config,
      scaleName: d.scaleName(H),
      scale: d.getScaleComponent(H),
      stack: null,
      defaultRef: signalOrValueRef(AA),
      bandPosition: k
    }) };
  const IA = t[H];
  return IA ? { offsetType: "visual", offset: IA } : {};
}
function pointPosition(n, t, { defaultPos: g, vgChannel: d }) {
  const { encoding: k, markDef: H, config: AA, stack: gA } = t, IA = k[n], CA = k[getSecondaryRangeChannel(n)], BA = t.scaleName(n), eA = t.getScaleComponent(n), { offset: iA, offsetType: QA } = positionOffset({
    channel: n,
    markDef: H,
    encoding: k,
    model: t,
    bandPosition: 0.5
  }), tA = pointPositionDefaultRef({
    model: t,
    defaultPos: g,
    channel: n,
    scaleName: BA,
    scale: eA
  }), oA = !IA && isXorY(n) && (k.latitude || k.longitude) ? (
    // use geopoint output if there are lat/long and there is no point position overriding lat/long.
    { field: t.getName(n) }
  ) : positionRef({
    channel: n,
    channelDef: IA,
    channel2Def: CA,
    markDef: H,
    config: AA,
    scaleName: BA,
    scale: eA,
    stack: gA,
    offset: iA,
    defaultRef: tA,
    bandPosition: QA === "encoding" ? 0 : void 0
  });
  return oA ? { [d || n]: oA } : void 0;
}
function positionRef(n) {
  const { channel: t, channelDef: g, scaleName: d, stack: k, offset: H, markDef: AA } = n;
  if (isFieldOrDatumDef(g) && k && t === k.fieldChannel) {
    if (isFieldDef(g)) {
      let gA = g.bandPosition;
      if (gA === void 0 && AA.type === "text" && (t === "radius" || t === "theta") && (gA = 0.5), gA !== void 0)
        return interpolatedSignalRef({
          scaleName: d,
          fieldOrDatumDef: g,
          // positionRef always have type
          startSuffix: "start",
          bandPosition: gA,
          offset: H
        });
    }
    return valueRefForFieldOrDatumDef(g, d, { suffix: "end" }, { offset: H });
  }
  return midPointRefWithPositionInvalidTest(n);
}
function pointPositionDefaultRef({ model: n, defaultPos: t, channel: g, scaleName: d, scale: k }) {
  const { markDef: H, config: AA } = n;
  return () => {
    const gA = getMainRangeChannel(g), IA = getVgPositionChannel(g), CA = getMarkPropOrConfig(g, H, AA, { vgChannel: IA });
    if (CA !== void 0)
      return widthHeightValueOrSignalRef(g, CA);
    switch (t) {
      case "zeroOrMin":
        return zeroOrMinOrMaxPosition({ scaleName: d, scale: k, mode: "zeroOrMin", mainChannel: gA, config: AA });
      case "zeroOrMax":
        return zeroOrMinOrMaxPosition({
          scaleName: d,
          scale: k,
          mode: { zeroOrMax: { widthSignal: n.width.signal, heightSignal: n.height.signal } },
          mainChannel: gA,
          config: AA
        });
      case "mid":
        return { ...n[getSizeChannel(g)], mult: 0.5 };
    }
  };
}
function zeroOrMinOrMaxPosition({ mainChannel: n, config: t, ...g }) {
  const d = scaledZeroOrMinOrMax(g), { mode: k } = g;
  if (d)
    return d;
  switch (n) {
    case "radius": {
      if (k === "zeroOrMin")
        return { value: 0 };
      const { widthSignal: H, heightSignal: AA } = k.zeroOrMax;
      return {
        signal: `min(${H},${AA})/2`
      };
    }
    case "theta":
      return k === "zeroOrMin" ? { value: 0 } : { signal: "2*PI" };
    case "x":
      return k === "zeroOrMin" ? { value: 0 } : { field: { group: "width" } };
    case "y":
      return k === "zeroOrMin" ? { field: { group: "height" } } : { value: 0 };
  }
}
const ALIGNED_X_CHANNEL = {
  left: "x",
  center: "xc",
  right: "x2"
}, BASELINED_Y_CHANNEL = {
  top: "y",
  middle: "yc",
  bottom: "y2"
};
function vgAlignedPositionChannel(n, t, g, d = "middle") {
  if (n === "radius" || n === "theta")
    return getVgPositionChannel(n);
  const k = n === "x" ? "align" : "baseline", H = getMarkPropOrConfig(k, t, g);
  let AA;
  return isSignalRef(H) ? (warn(rangeMarkAlignmentCannotBeExpression(k)), AA = void 0) : AA = H, n === "x" ? ALIGNED_X_CHANNEL[AA || (d === "top" ? "left" : "center")] : BASELINED_Y_CHANNEL[AA || d];
}
function pointOrRangePosition(n, t, { defaultPos: g, defaultPos2: d, range: k }) {
  return k ? rangePosition(n, t, { defaultPos: g, defaultPos2: d }) : pointPosition(n, t, { defaultPos: g });
}
function rangePosition(n, t, { defaultPos: g, defaultPos2: d }) {
  const { markDef: k, config: H } = t, AA = getSecondaryRangeChannel(n), gA = getSizeChannel(n), IA = pointPosition2OrSize(t, d, AA), CA = IA[gA] ? (
    // If there is width/height, we need to position the marks based on the alignment.
    vgAlignedPositionChannel(n, k, H)
  ) : (
    // Otherwise, make sure to apply to the right Vg Channel (for arc mark)
    getVgPositionChannel(n)
  );
  return {
    ...pointPosition(n, t, { defaultPos: g, vgChannel: CA }),
    ...IA
  };
}
function pointPosition2OrSize(n, t, g) {
  const { encoding: d, mark: k, markDef: H, stack: AA, config: gA } = n, IA = getMainRangeChannel(g), CA = getSizeChannel(g), BA = getVgPositionChannel(g), eA = d[IA], iA = n.scaleName(IA), QA = n.getScaleComponent(IA), { offset: tA } = g in d || g in H ? positionOffset({ channel: g, markDef: H, encoding: d, model: n }) : positionOffset({ channel: IA, markDef: H, encoding: d, model: n });
  if (!eA && (g === "x2" || g === "y2") && (d.latitude || d.longitude)) {
    const EA = getSizeChannel(g), aA = n.markDef[EA];
    return aA != null ? {
      [EA]: { value: aA }
    } : {
      [BA]: { field: n.getName(g) }
    };
  }
  const oA = position2Ref({
    channel: g,
    channelDef: eA,
    channel2Def: d[g],
    markDef: H,
    config: gA,
    scaleName: iA,
    scale: QA,
    stack: AA,
    offset: tA,
    defaultRef: void 0
  });
  return oA !== void 0 ? { [BA]: oA } : position2orSize(g, H) || position2orSize(g, {
    [g]: getMarkStyleConfig(g, H, gA.style),
    [CA]: getMarkStyleConfig(CA, H, gA.style)
  }) || position2orSize(g, gA[k]) || position2orSize(g, gA.mark) || {
    [BA]: pointPositionDefaultRef({
      model: n,
      defaultPos: t,
      channel: g,
      scaleName: iA,
      scale: QA
    })()
  };
}
function position2Ref({ channel: n, channelDef: t, channel2Def: g, markDef: d, config: k, scaleName: H, scale: AA, stack: gA, offset: IA, defaultRef: CA }) {
  return isFieldOrDatumDef(t) && gA && // If fieldChannel is X and channel is X2 (or Y and Y2)
  n.charAt(0) === gA.fieldChannel.charAt(0) ? valueRefForFieldOrDatumDef(t, H, { suffix: "start" }, { offset: IA }) : midPointRefWithPositionInvalidTest({
    channel: n,
    channelDef: g,
    scaleName: H,
    scale: AA,
    stack: gA,
    markDef: d,
    config: k,
    offset: IA,
    defaultRef: CA
  });
}
function position2orSize(n, t) {
  const g = getSizeChannel(n), d = getVgPositionChannel(n);
  if (t[d] !== void 0)
    return { [d]: widthHeightValueOrSignalRef(n, t[d]) };
  if (t[n] !== void 0)
    return { [d]: widthHeightValueOrSignalRef(n, t[n]) };
  if (t[g]) {
    const k = t[g];
    if (isRelativeBandSize(k))
      warn(relativeBandSizeNotSupported(g));
    else
      return { [g]: widthHeightValueOrSignalRef(n, k) };
  }
}
function rectPosition(n, t) {
  const { config: g, encoding: d, markDef: k } = n, H = k.type, AA = getSecondaryRangeChannel(t), gA = getSizeChannel(t), IA = d[t], CA = d[AA], BA = n.getScaleComponent(t), eA = BA ? BA.get("type") : void 0, iA = k.orient, QA = d[gA] ?? d.size ?? getMarkPropOrConfig("size", k, g, { vgChannel: gA }), tA = getOffsetChannel(t), oA = H === "bar" && (t === "x" ? iA === "vertical" : iA === "horizontal") || H === "tick" && (t === "y" ? iA === "vertical" : iA === "horizontal");
  return isFieldDef(IA) && (isBinning(IA.bin) || isBinned(IA.bin) || IA.timeUnit && !CA) && !(QA && !isRelativeBandSize(QA)) && !d[tA] && !hasDiscreteDomain(eA) ? rectBinPosition({
    fieldDef: IA,
    fieldDef2: CA,
    channel: t,
    model: n
  }) : (isFieldOrDatumDef(IA) && hasDiscreteDomain(eA) || oA) && !CA ? positionAndSize(IA, t, n) : rangePosition(t, n, { defaultPos: "zeroOrMax", defaultPos2: "zeroOrMin" });
}
function defaultSizeRef(n, t, g, d, k, H, AA) {
  if (isRelativeBandSize(k))
    if (g) {
      const IA = g.get("type");
      if (IA === "band") {
        let CA = `bandwidth('${t}')`;
        k.band !== 1 && (CA = `${k.band} * ${CA}`);
        const BA = getMarkConfig("minBandSize", { type: AA }, d);
        return { signal: BA ? `max(${signalOrStringValue(BA)}, ${CA})` : CA };
      } else k.band !== 1 && (warn(cannotUseRelativeBandSizeWithNonBandScale(IA)), k = void 0);
    } else
      return {
        mult: k.band,
        field: { group: n }
      };
  else {
    if (isSignalRef(k))
      return k;
    if (k)
      return { value: k };
  }
  if (g) {
    const IA = g.get("range");
    if (isVgRangeStep(IA) && isNumber$1(IA.step))
      return { value: IA.step - 2 };
  }
  if (!H) {
    const { bandPaddingInner: IA, barBandPaddingInner: CA, rectBandPaddingInner: BA, tickBandPaddingInner: eA } = d.scale, iA = getFirstDefined(IA, AA === "tick" ? eA : AA === "bar" ? CA : BA);
    if (isSignalRef(iA))
      return { signal: `(1 - (${iA.signal})) * ${n}` };
    if (isNumber$1(iA))
      return { signal: `${1 - iA} * ${n}` };
  }
  return { value: getViewConfigDiscreteStep(d.view, n) - 2 };
}
function positionAndSize(n, t, g) {
  const { markDef: d, encoding: k, config: H, stack: AA } = g, gA = d.orient, IA = g.scaleName(t), CA = g.getScaleComponent(t), BA = getSizeChannel(t), eA = getSecondaryRangeChannel(t), iA = getOffsetChannel(t), QA = g.scaleName(iA), tA = g.getScaleComponent(getOffsetScaleChannel(t)), oA = (
    // Always uses size channel for ticks, because tick only calls rectPosition() for the size channel
    d.type === "tick" || // use "size" channel for bars, if there is orient and the channel matches the right orientation
    gA === "horizontal" && t === "y" || gA === "vertical" && t === "x"
  );
  let EA;
  (k.size || d.size) && (oA ? EA = nonPosition("size", g, {
    vgChannel: BA,
    defaultRef: signalOrValueRef(d.size)
  }) : warn(cannotApplySizeToNonOrientedMark(d.type)));
  const aA = !!EA, nA = getBandSize({
    channel: t,
    fieldDef: n,
    markDef: d,
    config: H,
    scaleType: (CA || tA)?.get("type"),
    useVlSizeChannel: oA
  });
  EA = EA || {
    [BA]: defaultSizeRef(BA, QA || IA, tA || CA, H, nA, !!n, d.type)
  };
  const lA = (CA || tA)?.get("type") === "band" && isRelativeBandSize(nA) && !aA ? "top" : "middle", cA = vgAlignedPositionChannel(t, d, H, lA), sA = cA === "xc" || cA === "yc", { offset: rA, offsetType: uA } = positionOffset({ channel: t, markDef: d, encoding: k, model: g, bandPosition: sA ? 0.5 : 0 }), hA = midPointRefWithPositionInvalidTest({
    channel: t,
    channelDef: n,
    markDef: d,
    config: H,
    scaleName: IA,
    scale: CA,
    stack: AA,
    offset: rA,
    defaultRef: pointPositionDefaultRef({ model: g, defaultPos: "mid", channel: t, scaleName: IA, scale: CA }),
    bandPosition: sA ? uA === "encoding" ? 0 : 0.5 : isSignalRef(nA) ? { signal: `(1-${nA})/2` } : isRelativeBandSize(nA) ? (1 - nA.band) / 2 : 0
  });
  if (BA)
    return { [cA]: hA, ...EA };
  {
    const dA = getVgPositionChannel(eA), GA = EA[BA], DA = rA ? { ...GA, offset: rA } : GA;
    return {
      [cA]: hA,
      // posRef might be an array that wraps position invalid test
      [dA]: isArray$2(hA) ? [hA[0], { ...hA[1], offset: DA }] : {
        ...hA,
        offset: DA
      }
    };
  }
}
function getBinSpacing(n, t, g, d, k, H, AA) {
  if (isPolarPositionChannel(n))
    return 0;
  const gA = n === "x" || n === "y2", IA = gA ? -t / 2 : t / 2;
  if (isSignalRef(g) || isSignalRef(k) || isSignalRef(d) || H) {
    const CA = signalOrStringValue(g), BA = signalOrStringValue(k), eA = signalOrStringValue(d), iA = signalOrStringValue(H), tA = H ? `(${AA} < ${iA} ? ${gA ? "" : "-"}0.5 * (${iA} - (${AA})) : ${IA})` : IA, oA = eA ? `${eA} + ` : "", EA = CA ? `(${CA} ? -1 : 1) * ` : "", aA = BA ? `(${BA} + ${tA})` : tA;
    return {
      signal: oA + EA + aA
    };
  } else
    return k = k || 0, d + (g ? -k - IA : +k + IA);
}
function rectBinPosition({ fieldDef: n, fieldDef2: t, channel: g, model: d }) {
  const { config: k, markDef: H, encoding: AA } = d, gA = d.getScaleComponent(g), IA = d.scaleName(g), CA = gA ? gA.get("type") : void 0, BA = gA.get("reverse"), eA = getBandSize({ channel: g, fieldDef: n, markDef: H, config: k, scaleType: CA }), QA = d.component.axes[g]?.[0]?.get("translate") ?? 0.5, tA = isXorY(g) ? getMarkPropOrConfig("binSpacing", H, k) ?? 0 : 0, oA = getSecondaryRangeChannel(g), EA = getVgPositionChannel(g), aA = getVgPositionChannel(oA), nA = getMarkConfig("minBandSize", H, k), { offset: lA } = positionOffset({ channel: g, markDef: H, encoding: AA, model: d, bandPosition: 0 }), { offset: cA } = positionOffset({ channel: oA, markDef: H, encoding: AA, model: d, bandPosition: 0 }), sA = binSizeExpr({ fieldDef: n, scaleName: IA }), rA = getBinSpacing(g, tA, BA, QA, lA, nA, sA), uA = getBinSpacing(oA, tA, BA, QA, cA ?? lA, nA, sA), hA = isSignalRef(eA) ? { signal: `(1-${eA.signal})/2` } : isRelativeBandSize(eA) ? (1 - eA.band) / 2 : 0.5, dA = getBandPosition({ fieldDef: n, fieldDef2: t, markDef: H, config: k });
  if (isBinning(n.bin) || n.timeUnit) {
    const GA = n.timeUnit && dA !== 0.5;
    return {
      [aA]: rectBinRef({
        fieldDef: n,
        scaleName: IA,
        bandPosition: hA,
        offset: uA,
        useRectOffsetField: GA
      }),
      [EA]: rectBinRef({
        fieldDef: n,
        scaleName: IA,
        bandPosition: isSignalRef(hA) ? { signal: `1-${hA.signal}` } : 1 - hA,
        offset: rA,
        useRectOffsetField: GA
      })
    };
  } else if (isBinned(n.bin)) {
    const GA = valueRefForFieldOrDatumDef(n, IA, {}, { offset: uA });
    if (isFieldDef(t))
      return {
        [aA]: GA,
        [EA]: valueRefForFieldOrDatumDef(t, IA, {}, { offset: rA })
      };
    if (isBinParams(n.bin) && n.bin.step)
      return {
        [aA]: GA,
        [EA]: {
          signal: `scale("${IA}", ${vgField(n, { expr: "datum" })} + ${n.bin.step})`,
          offset: rA
        }
      };
  }
  warn(channelRequiredForBinned(oA));
}
function rectBinRef({ fieldDef: n, scaleName: t, bandPosition: g, offset: d, useRectOffsetField: k }) {
  return interpolatedSignalRef({
    scaleName: t,
    fieldOrDatumDef: n,
    bandPosition: g,
    offset: d,
    ...k ? {
      startSuffix: OFFSETTED_RECT_START_SUFFIX,
      endSuffix: OFFSETTED_RECT_END_SUFFIX
    } : {}
  });
}
const ALWAYS_IGNORE = /* @__PURE__ */ new Set(["aria", "width", "height"]);
function baseEncodeEntry(n, t) {
  const { fill: g = void 0, stroke: d = void 0 } = t.color === "include" ? color(n) : {};
  return {
    ...markDefProperties(n.markDef, t),
    ...colorRef("fill", g),
    ...colorRef("stroke", d),
    ...nonPosition("opacity", n),
    ...nonPosition("fillOpacity", n),
    ...nonPosition("strokeOpacity", n),
    ...nonPosition("strokeWidth", n),
    ...nonPosition("strokeDash", n),
    ...zindex(n),
    ...tooltip(n),
    ...text$1(n, "href"),
    ...aria(n)
  };
}
function colorRef(n, t) {
  return t ? { [n]: t } : {};
}
function markDefProperties(n, t) {
  return VG_MARK_CONFIGS.reduce((g, d) => (!ALWAYS_IGNORE.has(d) && hasProperty(n, d) && t[d] !== "ignore" && (g[d] = signalOrValueRef(n[d])), g), {});
}
function defined(n) {
  const { config: t, markDef: g } = n, d = /* @__PURE__ */ new Set();
  if (n.forEachFieldDef((k, H) => {
    let AA;
    if (!isScaleChannel(H) || !(AA = n.getScaleType(H)))
      return;
    const gA = isCountingAggregateOp(k.aggregate), IA = getScaleInvalidDataMode({
      scaleChannel: H,
      markDef: g,
      config: t,
      scaleType: AA,
      isCountAggregate: gA
    });
    if (shouldBreakPath(IA)) {
      const CA = n.vgField(H, { expr: "datum", binSuffix: n.stack?.impute ? "mid" : void 0 });
      CA && d.add(CA);
    }
  }), d.size > 0)
    return { defined: { signal: [...d].map((H) => fieldValidPredicate(H, !0)).join(" && ") } };
}
function valueIfDefined(n, t) {
  if (t !== void 0)
    return { [n]: signalOrValueRef(t) };
}
const VORONOI = "voronoi", nearest = {
  defined: (n) => n.type === "point" && n.nearest,
  parse: (n, t) => {
    if (t.events)
      for (const g of t.events)
        g.markname = n.getName(VORONOI);
  },
  marks: (n, t, g) => {
    const { x: d, y: k } = t.project.hasChannel, H = n.mark;
    if (isPathMark(H))
      return warn(nearestNotSupportForContinuous(H)), g;
    const AA = {
      name: n.getName(VORONOI),
      type: "path",
      interactive: !0,
      aria: !1,
      from: { data: n.getName("marks") },
      encode: {
        update: {
          fill: { value: "transparent" },
          strokeWidth: { value: 0.35 },
          stroke: { value: "transparent" },
          isVoronoi: { value: !0 },
          ...tooltip(n, { reactiveGeom: !0 })
        }
      },
      transform: [
        {
          type: "voronoi",
          x: { expr: d || !k ? "datum.datum.x || 0" : "0" },
          y: { expr: k || !d ? "datum.datum.y || 0" : "0" },
          size: [n.getSizeSignalRef("width"), n.getSizeSignalRef("height")]
        }
      ]
    };
    let gA = 0, IA = !1;
    return g.forEach((CA, BA) => {
      const eA = CA.name ?? "";
      eA === n.component.mark[0].name ? gA = BA : eA.includes(VORONOI) && (IA = !0);
    }), IA || g.splice(gA + 1, 0, AA), g;
  }
}, inputBindings = {
  defined: (n) => n.type === "point" && n.resolve === "global" && n.bind && n.bind !== "scales" && !isLegendBinding(n.bind),
  parse: (n, t, g) => disableDirectManipulation(t, g),
  topLevelSignals: (n, t, g) => {
    const d = t.name, k = t.project, H = t.bind, AA = t.init?.[0], gA = nearest.defined(t) ? "(item().isVoronoi ? datum.datum : datum)" : "datum";
    return k.items.forEach((IA, CA) => {
      const BA = varName(`${d}_${IA.field}`);
      g.filter((iA) => iA.name === BA).length || g.unshift({
        name: BA,
        ...AA ? { init: assembleInit(AA[CA]) } : { value: null },
        on: t.events ? [
          {
            events: t.events,
            update: `datum && item().mark.marktype !== 'group' ? ${gA}[${$$1(IA.field)}] : null`
          }
        ] : [],
        bind: H[IA.field] ?? H[IA.channel] ?? H
      });
    }), g;
  },
  signals: (n, t, g) => {
    const d = t.name, k = t.project, H = g.find((CA) => CA.name === d + TUPLE), AA = d + TUPLE_FIELDS, gA = k.items.map((CA) => varName(`${d}_${CA.field}`)), IA = gA.map((CA) => `${CA} !== null`).join(" && ");
    return gA.length && (H.update = `${IA} ? {fields: ${AA}, values: [${gA.join(", ")}]} : null`), delete H.value, delete H.on, g;
  }
}, TOGGLE = "_toggle", toggle = {
  defined: (n) => n.type === "point" && !isTimerSelection(n) && !!n.toggle,
  signals: (n, t, g) => g.concat({
    name: t.name + TOGGLE,
    value: !1,
    on: [{ events: t.events, update: t.toggle }]
  }),
  modifyExpr: (n, t) => {
    const g = t.name + TUPLE, d = t.name + TOGGLE;
    return `${d} ? null : ${g}, ${t.resolve === "global" ? `${d} ? null : true, ` : `${d} ? null : {unit: ${unitName(n)}}, `}${d} ? ${g} : null`;
  }
}, clear = {
  defined: (n) => n.clear !== void 0 && n.clear !== !1 && !isTimerSelection(n),
  parse: (n, t) => {
    t.clear && (t.clear = isString$1(t.clear) ? eventSelector(t.clear, "view") : t.clear);
  },
  topLevelSignals: (n, t, g) => {
    if (inputBindings.defined(t))
      for (const d of t.project.items) {
        const k = g.findIndex((H) => H.name === varName(`${t.name}_${d.field}`));
        k !== -1 && g[k].on.push({ events: t.clear, update: "null" });
      }
    return g;
  },
  signals: (n, t, g) => {
    function d(k, H) {
      k !== -1 && g[k].on && g[k].on.push({ events: t.clear, update: H });
    }
    if (t.type === "interval")
      for (const k of t.project.items) {
        const H = g.findIndex((AA) => AA.name === k.signals.visual);
        if (d(H, "[0, 0]"), H === -1) {
          const AA = g.findIndex((gA) => gA.name === k.signals.data);
          d(AA, "null");
        }
      }
    else {
      let k = g.findIndex((H) => H.name === t.name + TUPLE);
      d(k, "null"), toggle.defined(t) && (k = g.findIndex((H) => H.name === t.name + TOGGLE), d(k, "false"));
    }
    return g;
  }
}, legendBindings = {
  defined: (n) => {
    const t = n.resolve === "global" && n.bind && isLegendBinding(n.bind), g = n.project.items.length === 1 && n.project.items[0].field !== SELECTION_ID;
    return t && !g && warn(LEGEND_BINDINGS_MUST_HAVE_PROJECTION), t && g;
  },
  parse: (n, t, g) => {
    const d = duplicate(g);
    if (d.select = isString$1(d.select) ? { type: d.select, toggle: t.toggle } : { ...d.select, toggle: t.toggle }, disableDirectManipulation(t, d), isObject$4(g.select) && (g.select.on || g.select.clear)) {
      const AA = 'event.item && indexof(event.item.mark.role, "legend") < 0';
      for (const gA of t.events)
        gA.filter = array(gA.filter ?? []), gA.filter.includes(AA) || gA.filter.push(AA);
    }
    const k = isLegendStreamBinding(t.bind) ? t.bind.legend : "click", H = isString$1(k) ? eventSelector(k, "view") : array(k);
    t.bind = { legend: { merge: H } };
  },
  topLevelSignals: (n, t, g) => {
    const d = t.name, k = isLegendStreamBinding(t.bind) && t.bind.legend, H = (AA) => (gA) => {
      const IA = duplicate(gA);
      return IA.markname = AA, IA;
    };
    for (const AA of t.project.items) {
      if (!AA.hasLegend)
        continue;
      const gA = `${varName(AA.field)}_legend`, IA = `${d}_${gA}`;
      if (g.filter((BA) => BA.name === IA).length === 0) {
        const BA = k.merge.map(H(`${gA}_symbols`)).concat(k.merge.map(H(`${gA}_labels`))).concat(k.merge.map(H(`${gA}_entries`)));
        g.unshift({
          name: IA,
          ...t.init ? {} : { value: null },
          on: [
            // Legend entries do not store values, so we need to walk the scenegraph to the symbol datum.
            {
              events: BA,
              update: "isDefined(datum.value) ? datum.value : item().items[0].items[0].datum.value",
              force: !0
            },
            { events: k.merge, update: `!event.item || !datum ? null : ${IA}`, force: !0 }
          ]
        });
      }
    }
    return g;
  },
  signals: (n, t, g) => {
    const d = t.name, k = t.project, H = g.find((iA) => iA.name === d + TUPLE), AA = d + TUPLE_FIELDS, gA = k.items.filter((iA) => iA.hasLegend).map((iA) => varName(`${d}_${varName(iA.field)}_legend`)), CA = `${gA.map((iA) => `${iA} !== null`).join(" && ")} ? {fields: ${AA}, values: [${gA.join(", ")}]} : null`;
    t.events && gA.length > 0 ? H.on.push({
      events: gA.map((iA) => ({ signal: iA })),
      update: CA
    }) : gA.length > 0 && (H.update = CA, delete H.value, delete H.on);
    const BA = g.find((iA) => iA.name === d + TOGGLE), eA = isLegendStreamBinding(t.bind) && t.bind.legend;
    return BA && (t.events ? BA.on.push({ ...BA.on[0], events: eA }) : BA.on[0].events = eA), g;
  }
};
function parseInteractiveLegend(n, t, g) {
  const d = n.fieldDef(t)?.field;
  for (const k of vals(n.component.selection ?? {})) {
    const H = k.project.hasField[d] ?? k.project.hasChannel[t];
    if (H && legendBindings.defined(k)) {
      const AA = g.get("selections") ?? [];
      AA.push(k.name), g.set("selections", AA, !1), H.hasLegend = !0;
    }
  }
}
const ANCHOR$1 = "_translate_anchor", DELTA$1 = "_translate_delta", translate = {
  defined: (n) => n.type === "interval" && n.translate,
  signals: (n, t, g) => {
    const d = t.name, k = scaleBindings.defined(t), H = d + ANCHOR$1, { x: AA, y: gA } = t.project.hasChannel;
    let IA = eventSelector(t.translate, "scope");
    return k || (IA = IA.map((CA) => (CA.between[0].markname = d + BRUSH, CA))), g.push({
      name: H,
      value: {},
      on: [
        {
          events: IA.map((CA) => CA.between[0]),
          update: `{x: x(unit), y: y(unit)${AA !== void 0 ? `, extent_x: ${k ? domain(n, X$1) : `slice(${AA.signals.visual})`}` : ""}${gA !== void 0 ? `, extent_y: ${k ? domain(n, Y) : `slice(${gA.signals.visual})`}` : ""}}`
        }
      ]
    }, {
      name: d + DELTA$1,
      value: {},
      on: [
        {
          events: IA,
          update: `{x: ${H}.x - x(unit), y: ${H}.y - y(unit)}`
        }
      ]
    }), AA !== void 0 && onDelta$1(n, t, AA, "width", g), gA !== void 0 && onDelta$1(n, t, gA, "height", g), g;
  }
};
function onDelta$1(n, t, g, d, k) {
  const H = t.name, AA = H + ANCHOR$1, gA = H + DELTA$1, IA = g.channel, CA = scaleBindings.defined(t), BA = k.find((sA) => sA.name === g.signals[CA ? "data" : "visual"]), eA = n.getSizeSignalRef(d).signal, iA = n.getScaleComponent(IA), QA = iA?.get("type"), tA = iA?.get("reverse"), oA = CA ? IA === X$1 ? tA ? "" : "-" : tA ? "-" : "" : "", EA = `${AA}.extent_${IA}`, aA = `${oA}${gA}.${IA} / ${CA ? `${eA}` : `span(${EA})`}`, nA = !CA || !iA ? "panLinear" : QA === "log" ? "panLog" : QA === "symlog" ? "panSymlog" : QA === "pow" ? "panPow" : "panLinear", lA = CA ? QA === "pow" ? `, ${iA.get("exponent") ?? 1}` : QA === "symlog" ? `, ${iA.get("constant") ?? 1}` : "" : "", cA = `${nA}(${EA}, ${aA}${lA})`;
  BA.on.push({
    events: { signal: gA },
    update: CA ? cA : `clampRange(${cA}, 0, ${eA})`
  });
}
const ANCHOR = "_zoom_anchor", DELTA = "_zoom_delta", zoom = {
  defined: (n) => n.type === "interval" && n.zoom,
  signals: (n, t, g) => {
    const d = t.name, k = scaleBindings.defined(t), H = d + DELTA, { x: AA, y: gA } = t.project.hasChannel, IA = $$1(n.scaleName(X$1)), CA = $$1(n.scaleName(Y));
    let BA = eventSelector(t.zoom, "scope");
    return k || (BA = BA.map((eA) => (eA.markname = d + BRUSH, eA))), g.push({
      name: d + ANCHOR,
      on: [
        {
          events: BA,
          update: k ? `{${[IA ? `x: invert(${IA}, x(unit))` : "", CA ? `y: invert(${CA}, y(unit))` : ""].filter((eA) => eA).join(", ")}}` : "{x: x(unit), y: y(unit)}"
        }
      ]
    }, {
      name: H,
      on: [
        {
          events: BA,
          force: !0,
          update: "pow(1.001, event.deltaY * pow(16, event.deltaMode))"
        }
      ]
    }), AA !== void 0 && onDelta(n, t, AA, "width", g), gA !== void 0 && onDelta(n, t, gA, "height", g), g;
  }
};
function onDelta(n, t, g, d, k) {
  const H = t.name, AA = g.channel, gA = scaleBindings.defined(t), IA = k.find((nA) => nA.name === g.signals[gA ? "data" : "visual"]), CA = n.getSizeSignalRef(d).signal, BA = n.getScaleComponent(AA), eA = BA?.get("type"), iA = gA ? domain(n, AA) : IA.name, QA = H + DELTA, tA = `${H}${ANCHOR}.${AA}`, oA = !gA || !BA ? "zoomLinear" : eA === "log" ? "zoomLog" : eA === "symlog" ? "zoomSymlog" : eA === "pow" ? "zoomPow" : "zoomLinear", EA = gA ? eA === "pow" ? `, ${BA.get("exponent") ?? 1}` : eA === "symlog" ? `, ${BA.get("constant") ?? 1}` : "" : "", aA = `${oA}(${iA}, ${tA}, ${QA}${EA})`;
  IA.on.push({
    events: { signal: QA },
    update: gA ? aA : `clampRange(${aA}, 0, ${CA})`
  });
}
const STORE = "_store", TUPLE = "_tuple", MODIFY = "_modify", VL_SELECTION_RESOLVE = "vlSelectionResolve", selectionCompilers = [
  point$1,
  interval,
  project,
  toggle,
  // Bindings may disable direct manipulation.
  inputBindings,
  scaleBindings,
  legendBindings,
  clear,
  translate,
  zoom,
  nearest
];
function getFacetModel(n) {
  let t = n.parent;
  for (; t && !isFacetModel(t); )
    t = t.parent;
  return t;
}
function unitName(n, { escape: t } = { escape: !0 }) {
  let g = t ? $$1(n.name) : n.name;
  const d = getFacetModel(n);
  if (d) {
    const { facet: k } = d;
    for (const H of FACET_CHANNELS)
      k[H] && (g += ` + '__facet_${H}_' + (facet[${$$1(d.vgField(H))}])`);
  }
  return g;
}
function requiresSelectionId(n) {
  return vals(n.component.selection ?? {}).reduce((t, g) => t || g.project.hasSelectionId, !1);
}
function disableDirectManipulation(n, t) {
  (isString$2(t.select) || !t.select.on) && delete n.events, (isString$2(t.select) || !t.select.clear) && delete n.clear, (isString$2(t.select) || !t.select.toggle) && delete n.toggle;
}
function isTimerSelection(n) {
  return n.events?.find((t) => "type" in t && t.type === "timer");
}
function getName(n) {
  const t = [];
  return n.type === "Identifier" ? [n.name] : n.type === "Literal" ? [n.value] : (n.type === "MemberExpression" && (t.push(...getName(n.object)), t.push(...getName(n.property))), t);
}
function startsWithDatum(n) {
  return n.object.type === "MemberExpression" ? startsWithDatum(n.object) : n.object.name === "datum";
}
function getDependentFields(n) {
  const t = parser$1(n), g = /* @__PURE__ */ new Set();
  return t.visit((d) => {
    d.type === "MemberExpression" && startsWithDatum(d) && g.add(getName(d).slice(1).join("."));
  }), g;
}
class FilterNode extends DataFlowNode {
  model;
  filter;
  expr;
  _dependentFields;
  clone() {
    return new FilterNode(null, this.model, duplicate(this.filter));
  }
  constructor(t, g, d) {
    super(t), this.model = g, this.filter = d, this.expr = expression(this.model, this.filter, this), this._dependentFields = getDependentFields(this.expr);
  }
  dependentFields() {
    return this._dependentFields;
  }
  producedFields() {
    return /* @__PURE__ */ new Set();
  }
  assemble() {
    return {
      type: "filter",
      expr: this.expr
    };
  }
  hash() {
    return `Filter ${this.expr}`;
  }
}
function parseUnitSelection(n, t) {
  const g = {}, d = n.config.selection;
  if (!t || !t.length)
    return g;
  let k = 0;
  for (const H of t) {
    const AA = varName(H.name), gA = H.select, IA = isString$1(gA) ? gA : gA.type, CA = isObject$3(gA) ? duplicate(gA) : { type: IA }, BA = d[IA];
    for (const QA in BA)
      QA === "fields" || QA === "encodings" || (QA === "mark" && (CA.mark = { ...BA.mark, ...CA.mark }), (CA[QA] === void 0 || CA[QA] === !0) && (CA[QA] = duplicate(BA[QA] ?? CA[QA])));
    const eA = g[AA] = {
      ...CA,
      name: AA,
      type: IA,
      init: H.value,
      bind: H.bind,
      events: isString$1(CA.on) ? eventSelector(CA.on, "scope") : array(duplicate(CA.on))
    };
    if (isTimerSelection(eA) && (k++, k > 1)) {
      delete g[AA];
      continue;
    }
    const iA = duplicate(H);
    for (const QA of selectionCompilers)
      QA.defined(eA) && QA.parse && QA.parse(n, eA, iA);
  }
  return k > 1 && warn(MULTIPLE_TIMER_ANIMATION_SELECTION), g;
}
function parseSelectionPredicate(n, t, g, d = "datum") {
  const k = isString$1(t) ? t : t.param, H = varName(k), AA = $$1(H + STORE);
  let gA;
  try {
    gA = n.getSelectionComponent(H, k);
  } catch {
    return `!!${H}`;
  }
  if (gA.project.timeUnit) {
    const iA = g ?? n.component.data.raw, QA = gA.project.timeUnit.clone();
    iA.parent ? QA.insertAsParentOf(iA) : iA.parent = QA;
  }
  const IA = gA.project.hasSelectionId ? "vlSelectionIdTest(" : "vlSelectionTest(", CA = gA.resolve === "global" ? ")" : `, ${$$1(gA.resolve)})`, BA = `${IA}${AA}, ${d}${CA}`, eA = `length(data(${AA}))`;
  return t.empty === !1 ? `${eA} && ${BA}` : `!${eA} || ${BA}`;
}
function parseSelectionExtent(n, t, g) {
  const d = varName(t), k = g.encoding;
  let H = g.field, AA;
  try {
    AA = n.getSelectionComponent(d, t);
  } catch {
    return d;
  }
  if (!k && !H)
    H = AA.project.items[0].field, AA.project.items.length > 1 && warn(selectionAsScaleDomainWithoutField(H));
  else if (k && !H) {
    const gA = AA.project.items.filter((IA) => IA.channel === k);
    !gA.length || gA.length > 1 ? (H = AA.project.items[0].field, warn(selectionAsScaleDomainWrongEncodings(gA, k, g, H))) : H = gA[0].field;
  }
  return `${AA.name}[${$$1(replacePathInField(H))}]`;
}
function materializeSelections(n, t) {
  for (const [g, d] of entries$1(n.component.selection ?? {})) {
    const k = n.getName(`lookup_${g}`);
    n.component.data.outputNodes[k] = d.materialized = new OutputNode(new FilterNode(t, n, { param: g }), k, DataSourceType.Lookup, n.component.data.outputNodeRefCounts);
  }
}
function expression(n, t, g) {
  return logicalExpr(t, (d) => isString$1(d) ? d : isSelectionPredicate(d) ? parseSelectionPredicate(n, d, g) : fieldFilterExpression(d));
}
function assembleTitle(n, t) {
  if (n)
    return isArray$2(n) && !isText(n) ? n.map((g) => defaultTitle(g, t)).join(", ") : n;
}
function setAxisEncode(n, t, g, d) {
  n.encode ??= {}, n.encode[t] ??= {}, n.encode[t].update ??= {}, n.encode[t].update[g] = d;
}
function assembleAxis(n, t, g, d = { header: !1 }) {
  const { disable: k, orient: H, scale: AA, labelExpr: gA, title: IA, zindex: CA, ...BA } = n.combine();
  if (!k) {
    for (const eA in BA) {
      const iA = eA, QA = AXIS_PROPERTY_TYPE[iA], tA = BA[iA];
      if (QA && QA !== t && QA !== "both")
        delete BA[iA];
      else if (isConditionalAxisValue(tA)) {
        const { condition: oA, ...EA } = tA, aA = array(oA), nA = CONDITIONAL_AXIS_PROP_INDEX[iA];
        if (nA) {
          const { vgProp: lA, part: cA } = nA, sA = [
            ...aA.map((rA) => {
              const { test: uA, ...hA } = rA;
              return {
                test: expression(null, uA),
                ...hA
              };
            }),
            EA
          ];
          setAxisEncode(BA, cA, lA, sA), delete BA[iA];
        } else if (nA === null) {
          const lA = {
            signal: aA.map((cA) => {
              const { test: sA, ...rA } = cA;
              return `${expression(null, sA)} ? ${exprFromValueRefOrSignalRef(rA)} : `;
            }).join("") + exprFromValueRefOrSignalRef(EA)
          };
          BA[iA] = lA;
        }
      } else if (isSignalRef(tA)) {
        const oA = CONDITIONAL_AXIS_PROP_INDEX[iA];
        if (oA) {
          const { vgProp: EA, part: aA } = oA;
          setAxisEncode(BA, aA, EA, tA), delete BA[iA];
        }
      }
      contains(["labelAlign", "labelBaseline"], iA) && BA[iA] === null && delete BA[iA];
    }
    if (t === "grid") {
      if (!BA.grid)
        return;
      if (BA.encode) {
        const { grid: eA } = BA.encode;
        BA.encode = {
          ...eA ? { grid: eA } : {}
        }, isEmpty(BA.encode) && delete BA.encode;
      }
      return {
        scale: AA,
        orient: H,
        ...BA,
        domain: !1,
        labels: !1,
        aria: !1,
        // always hide grid axis
        // Always set min/maxExtent to 0 to ensure that `config.axis*.minExtent` and `config.axis*.maxExtent`
        // would not affect gridAxis
        maxExtent: 0,
        minExtent: 0,
        ticks: !1,
        zindex: getFirstDefined(CA, 0)
        // put grid behind marks by default
      };
    } else {
      if (!d.header && n.mainExtracted)
        return;
      if (gA !== void 0) {
        let iA = gA;
        BA.encode?.labels?.update && isSignalRef(BA.encode.labels.update.text) && (iA = replaceAll(gA, "datum.label", BA.encode.labels.update.text.signal)), setAxisEncode(BA, "labels", "text", { signal: iA });
      }
      if (BA.labelAlign === null && delete BA.labelAlign, BA.encode) {
        for (const iA of AXIS_PARTS)
          n.hasAxisPart(iA) || delete BA.encode[iA];
        isEmpty(BA.encode) && delete BA.encode;
      }
      const eA = assembleTitle(IA, g);
      return {
        scale: AA,
        orient: H,
        grid: !1,
        ...eA ? { title: eA } : {},
        ...BA,
        ...g.aria === !1 ? { aria: !1 } : {},
        zindex: getFirstDefined(CA, 0)
        // put axis line above marks by default
      };
    }
  }
}
function assembleAxisSignals(n) {
  const { axes: t } = n.component, g = [];
  for (const d of POSITION_SCALE_CHANNELS)
    if (t[d]) {
      for (const k of t[d])
        if (!k.get("disable") && !k.get("gridScale")) {
          const H = d === "x" ? "height" : "width", AA = n.getSizeSignalRef(H).signal;
          H !== AA && g.push({
            name: H,
            update: AA
          });
        }
    }
  return g;
}
function assembleAxes(n, t) {
  const { x: g = [], y: d = [] } = n;
  return [
    ...g.map((k) => assembleAxis(k, "grid", t)),
    ...d.map((k) => assembleAxis(k, "grid", t)),
    ...g.map((k) => assembleAxis(k, "main", t)),
    ...d.map((k) => assembleAxis(k, "main", t))
  ].filter((k) => k);
}
function getAxisConfigFromConfigTypes(n, t, g, d) {
  return Object.assign.apply(null, [
    {},
    ...n.map((k) => {
      if (k === "axisOrient") {
        const H = g === "x" ? "bottom" : "left", AA = t[g === "x" ? "axisBottom" : "axisLeft"] || {}, gA = t[g === "x" ? "axisTop" : "axisRight"] || {}, IA = /* @__PURE__ */ new Set([...keys$1(AA), ...keys$1(gA)]), CA = {};
        for (const BA of IA.values())
          CA[BA] = {
            // orient is surely signal in this case
            signal: `${d.signal} === "${H}" ? ${signalOrStringValue(AA[BA])} : ${signalOrStringValue(gA[BA])}`
          };
        return CA;
      }
      return t[k];
    })
  ]);
}
function getAxisConfigs(n, t, g, d) {
  const k = t === "band" ? ["axisDiscrete", "axisBand"] : t === "point" ? ["axisDiscrete", "axisPoint"] : isQuantitative(t) ? ["axisQuantitative"] : t === "time" || t === "utc" ? ["axisTemporal"] : [], H = n === "x" ? "axisX" : "axisY", AA = isSignalRef(g) ? "axisOrient" : `axis${titleCase(g)}`, gA = [
    // technically Vega does have axisBand, but if we make another separation here,
    // it will further introduce complexity in the code
    ...k,
    ...k.map((CA) => H + CA.substr(4))
  ], IA = ["axis", AA, H];
  return {
    vlOnlyAxisConfig: getAxisConfigFromConfigTypes(gA, d, n, g),
    vgAxisConfig: getAxisConfigFromConfigTypes(IA, d, n, g),
    axisConfigStyle: getAxisConfigStyle([...IA, ...gA], d)
  };
}
function getAxisConfigStyle(n, t) {
  const g = [{}];
  for (const d of n) {
    let k = t[d]?.style;
    if (k) {
      k = array(k);
      for (const H of k)
        g.push(t.style[H]);
    }
  }
  return Object.assign.apply(null, g);
}
function getAxisConfig(n, t, g, d = {}) {
  const k = getStyleConfig(n, g, t);
  if (k !== void 0)
    return {
      configFrom: "style",
      configValue: k
    };
  for (const H of ["vlOnlyAxisConfig", "vgAxisConfig", "axisConfigStyle"])
    if (d[H]?.[n] !== void 0)
      return { configFrom: H, configValue: d[H][n] };
  return {};
}
const axisRules = {
  scale: ({ model: n, channel: t }) => n.scaleName(t),
  format: ({ format: n }) => n,
  // we already calculate this in parse
  formatType: ({ formatType: n }) => n,
  // we already calculate this in parse
  grid: ({ fieldOrDatumDef: n, axis: t, scaleType: g }) => t.grid ?? defaultGrid(g, n),
  gridScale: ({ model: n, channel: t }) => gridScale(n, t),
  labelAlign: ({ axis: n, labelAngle: t, orient: g, channel: d }) => n.labelAlign || defaultLabelAlign(t, g, d),
  labelAngle: ({ labelAngle: n }) => n,
  // we already calculate this in parse
  labelBaseline: ({ axis: n, labelAngle: t, orient: g, channel: d }) => n.labelBaseline || defaultLabelBaseline(t, g, d),
  labelFlush: ({ axis: n, fieldOrDatumDef: t, channel: g }) => n.labelFlush ?? defaultLabelFlush(t.type, g),
  labelOverlap: ({ axis: n, fieldOrDatumDef: t, scaleType: g }) => n.labelOverlap ?? defaultLabelOverlap$1(t.type, g, isFieldDef(t) && !!t.timeUnit, isFieldDef(t) ? t.sort : void 0),
  // we already calculate orient in parse
  orient: ({ orient: n }) => n,
  // Need to cast until Vega supports signal
  tickCount: ({ channel: n, model: t, axis: g, fieldOrDatumDef: d, scaleType: k }) => {
    const H = n === "x" ? "width" : n === "y" ? "height" : void 0, AA = H ? t.getSizeSignalRef(H) : void 0;
    return g.tickCount ?? defaultTickCount({ fieldOrDatumDef: d, scaleType: k, size: AA, values: g.values });
  },
  tickMinStep: ({ axis: n, format: t, fieldOrDatumDef: g }) => n.tickMinStep ?? defaultTickMinStep({ format: t, fieldOrDatumDef: g }),
  title: ({ axis: n, model: t, channel: g }) => {
    if (n.title !== void 0)
      return n.title;
    const d = getFieldDefTitle(t, g);
    if (d !== void 0)
      return d;
    const k = t.typedFieldDef(g), H = g === "x" ? "x2" : "y2", AA = t.fieldDef(H);
    return mergeTitleFieldDefs(k ? [toFieldDefBase(k)] : [], isFieldDef(AA) ? [toFieldDefBase(AA)] : []);
  },
  values: ({ axis: n, fieldOrDatumDef: t }) => values$1$1(n, t),
  zindex: ({ axis: n, fieldOrDatumDef: t, mark: g }) => n.zindex ?? defaultZindex(g, t)
};
function defaultGrid(n, t) {
  return !hasDiscreteDomain(n) && isFieldDef(t) && !isBinning(t?.bin) && !isBinned(t?.bin);
}
function gridScale(n, t) {
  const g = t === "x" ? "y" : "x";
  if (n.getScaleComponent(g))
    return n.scaleName(g);
}
function getLabelAngle(n, t, g, d, k) {
  const H = t?.labelAngle;
  if (H !== void 0)
    return isSignalRef(H) ? H : normalizeAngle(H);
  {
    const { configValue: AA } = getAxisConfig("labelAngle", d, t?.style, k);
    return AA !== void 0 ? normalizeAngle(AA) : g === X$1 && contains([NOMINAL, ORDINAL], n.type) && !(isFieldDef(n) && n.timeUnit) ? 270 : void 0;
  }
}
function normalizeAngleExpr(n) {
  return `(((${n.signal} % 360) + 360) % 360)`;
}
function defaultLabelBaseline(n, t, g, d) {
  if (n !== void 0)
    if (g === "x") {
      if (isSignalRef(n)) {
        const k = normalizeAngleExpr(n), H = isSignalRef(t) ? `(${t.signal} === "top")` : t === "top";
        return {
          signal: `(45 < ${k} && ${k} < 135) || (225 < ${k} && ${k} < 315) ? "middle" :(${k} <= 45 || 315 <= ${k}) === ${H} ? "bottom" : "top"`
        };
      }
      if (45 < n && n < 135 || 225 < n && n < 315)
        return "middle";
      if (isSignalRef(t)) {
        const k = n <= 45 || 315 <= n ? "===" : "!==";
        return { signal: `${t.signal} ${k} "top" ? "bottom" : "top"` };
      }
      return (n <= 45 || 315 <= n) == (t === "top") ? "bottom" : "top";
    } else {
      if (isSignalRef(n)) {
        const k = normalizeAngleExpr(n), H = isSignalRef(t) ? `(${t.signal} === "left")` : t === "left";
        return {
          signal: `${k} <= 45 || 315 <= ${k} || (135 <= ${k} && ${k} <= 225) ? ${d ? '"middle"' : "null"} : (45 <= ${k} && ${k} <= 135) === ${H} ? "top" : "bottom"`
        };
      }
      if (n <= 45 || 315 <= n || 135 <= n && n <= 225)
        return d ? "middle" : null;
      if (isSignalRef(t)) {
        const k = 45 <= n && n <= 135 ? "===" : "!==";
        return { signal: `${t.signal} ${k} "left" ? "top" : "bottom"` };
      }
      return (45 <= n && n <= 135) == (t === "left") ? "top" : "bottom";
    }
}
function defaultLabelAlign(n, t, g) {
  if (n === void 0)
    return;
  const d = g === "x", k = d ? 0 : 90, H = d ? "bottom" : "left";
  if (isSignalRef(n)) {
    const AA = normalizeAngleExpr(n), gA = isSignalRef(t) ? `(${t.signal} === "${H}")` : t === H;
    return {
      signal: `(${k ? `(${AA} + 90)` : AA} % 180 === 0) ? ${d ? null : '"center"'} :(${k} < ${AA} && ${AA} < ${180 + k}) === ${gA} ? "left" : "right"`
    };
  }
  if ((n + k) % 180 === 0)
    return d ? null : "center";
  if (isSignalRef(t)) {
    const AA = k < n && n < 180 + k ? "===" : "!==";
    return {
      signal: `${`${t.signal} ${AA} "${H}"`} ? "left" : "right"`
    };
  }
  return (k < n && n < 180 + k) == (t === H) ? "left" : "right";
}
function defaultLabelFlush(n, t) {
  if (t === "x" && contains(["quantitative", "temporal"], n))
    return !0;
}
function defaultLabelOverlap$1(n, t, g, d) {
  if (g && !isObject$3(d) || n !== "nominal" && n !== "ordinal")
    return t === "log" || t === "symlog" ? "greedy" : !0;
}
function defaultOrient(n) {
  return n === "x" ? "bottom" : "left";
}
function defaultTickCount({ fieldOrDatumDef: n, scaleType: t, size: g, values: d }) {
  if (!d && !hasDiscreteDomain(t) && t !== "log") {
    if (isFieldDef(n)) {
      if (isBinning(n.bin))
        return { signal: `ceil(${g.signal}/10)` };
      if (n.timeUnit && contains(["month", "hours", "day", "quarter"], normalizeTimeUnit(n.timeUnit)?.unit))
        return;
    }
    return { signal: `ceil(${g.signal}/40)` };
  }
}
function defaultTickMinStep({ format: n, fieldOrDatumDef: t }) {
  if (n === "d")
    return 1;
  if (isFieldDef(t)) {
    const { timeUnit: g } = t;
    if (g) {
      const d = durationExpr(g);
      if (d)
        return { signal: d };
    }
  }
}
function getFieldDefTitle(n, t) {
  const g = t === "x" ? "x2" : "y2", d = n.fieldDef(t), k = n.fieldDef(g), H = d ? d.title : void 0, AA = k ? k.title : void 0;
  if (H && AA)
    return mergeTitle(H, AA);
  if (H)
    return H;
  if (AA)
    return AA;
  if (H !== void 0)
    return H;
  if (AA !== void 0)
    return AA;
}
function values$1$1(n, t) {
  const g = n.values;
  if (isArray$2(g))
    return valueArray(t, g);
  if (isSignalRef(g))
    return g;
}
function defaultZindex(n, t) {
  return n === "rect" && isDiscrete(t) ? 1 : 0;
}
class CalculateNode extends DataFlowNode {
  transform;
  _dependentFields;
  clone() {
    return new CalculateNode(null, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g, this._dependentFields = getDependentFields(this.transform.calculate);
  }
  static parseAllForSortIndex(t, g) {
    return g.forEachFieldDef((d, k) => {
      if (isScaleFieldDef(d) && isSortArray(d.sort)) {
        const { field: H, timeUnit: AA } = d, gA = d.sort, IA = gA.map((CA, BA) => `${fieldFilterExpression({ field: H, timeUnit: AA, equal: CA })} ? ${BA} : `).join("") + gA.length;
        t = new CalculateNode(t, {
          calculate: IA,
          as: sortArrayIndexField(d, k, { forAs: !0 })
        });
      }
    }), t;
  }
  producedFields() {
    return /* @__PURE__ */ new Set([this.transform.as]);
  }
  dependentFields() {
    return this._dependentFields;
  }
  assemble() {
    return {
      type: "formula",
      expr: this.transform.calculate,
      as: this.transform.as
    };
  }
  hash() {
    return `Calculate ${hash(this.transform)}`;
  }
}
function sortArrayIndexField(n, t, g) {
  return vgField(n, { prefix: t, suffix: "sort_index", ...g });
}
function getHeaderChannel(n, t) {
  return contains(["top", "bottom"], t) ? "column" : contains(["left", "right"], t) || n === "row" ? "row" : "column";
}
function getHeaderProperty(n, t, g, d) {
  const k = d === "row" ? g.headerRow : d === "column" ? g.headerColumn : g.headerFacet;
  return getFirstDefined((t || {})[n], k[n], g.header[n]);
}
function getHeaderProperties(n, t, g, d) {
  const k = {};
  for (const H of n) {
    const AA = getHeaderProperty(H, t || {}, g, d);
    AA !== void 0 && (k[H] = AA);
  }
  return k;
}
const HEADER_CHANNELS = ["row", "column"], HEADER_TYPES = ["header", "footer"];
function assembleTitleGroup(n, t) {
  const g = n.component.layoutHeaders[t].title, d = n.config ? n.config : void 0, k = n.component.layoutHeaders[t].facetFieldDef ? n.component.layoutHeaders[t].facetFieldDef : void 0, { titleAnchor: H, titleAngle: AA, titleOrient: gA } = getHeaderProperties(["titleAnchor", "titleAngle", "titleOrient"], k.header, d, t), IA = getHeaderChannel(t, gA), CA = normalizeAngle(AA);
  return {
    name: `${t}-title`,
    type: "group",
    role: `${IA}-title`,
    title: {
      text: g,
      ...t === "row" ? { orient: "left" } : {},
      style: "guide-title",
      ...defaultHeaderGuideBaseline(CA, IA),
      ...defaultHeaderGuideAlign(IA, CA, H),
      ...assembleHeaderProperties(d, k, t, HEADER_TITLE_PROPERTIES, HEADER_TITLE_PROPERTIES_MAP)
    }
  };
}
function defaultHeaderGuideAlign(n, t, g = "middle") {
  switch (g) {
    case "start":
      return { align: "left" };
    case "end":
      return { align: "right" };
  }
  const d = defaultLabelAlign(t, n === "row" ? "left" : "top", n === "row" ? "y" : "x");
  return d ? { align: d } : {};
}
function defaultHeaderGuideBaseline(n, t) {
  const g = defaultLabelBaseline(n, t === "row" ? "left" : "top", t === "row" ? "y" : "x", !0);
  return g ? { baseline: g } : {};
}
function assembleHeaderGroups(n, t) {
  const g = n.component.layoutHeaders[t], d = [];
  for (const k of HEADER_TYPES)
    if (g[k])
      for (const H of g[k]) {
        const AA = assembleHeaderGroup(n, t, k, g, H);
        AA != null && d.push(AA);
      }
  return d;
}
function getSort$1(n, t) {
  const { sort: g } = n;
  return isSortField(g) ? {
    field: vgField(g, { expr: "datum" }),
    order: g.order ?? "ascending"
  } : isArray$2(g) ? {
    field: sortArrayIndexField(n, t, { expr: "datum" }),
    order: "ascending"
  } : {
    field: vgField(n, { expr: "datum" }),
    order: g ?? "ascending"
  };
}
function assembleLabelTitle(n, t, g) {
  const { format: d, formatType: k, labelAngle: H, labelAnchor: AA, labelOrient: gA, labelExpr: IA } = getHeaderProperties(["format", "formatType", "labelAngle", "labelAnchor", "labelOrient", "labelExpr"], n.header, g, t), CA = formatSignalRef({
    fieldOrDatumDef: n,
    format: d,
    formatType: k,
    expr: "parent",
    config: g
  }).signal, BA = getHeaderChannel(t, gA);
  return {
    text: {
      signal: IA ? replaceAll(replaceAll(IA, "datum.label", CA), "datum.value", vgField(n, { expr: "parent" })) : CA
    },
    ...t === "row" ? { orient: "left" } : {},
    style: "guide-label",
    frame: "group",
    ...defaultHeaderGuideBaseline(H, BA),
    ...defaultHeaderGuideAlign(BA, H, AA),
    ...assembleHeaderProperties(g, n, t, HEADER_LABEL_PROPERTIES, HEADER_LABEL_PROPERTIES_MAP)
  };
}
function assembleHeaderGroup(n, t, g, d, k) {
  if (k) {
    let H = null;
    const { facetFieldDef: AA } = d, gA = n.config ? n.config : void 0;
    if (AA && k.labels) {
      const { labelOrient: eA } = getHeaderProperties(["labelOrient"], AA.header, gA, t);
      (t === "row" && !contains(["top", "bottom"], eA) || t === "column" && !contains(["left", "right"], eA)) && (H = assembleLabelTitle(AA, t, gA));
    }
    const IA = isFacetModel(n) && !isFacetMapping(n.facet), CA = k.axes, BA = CA?.length > 0;
    if (H || BA) {
      const eA = t === "row" ? "height" : "width";
      return {
        name: n.getName(`${t}_${g}`),
        type: "group",
        role: `${t}-${g}`,
        ...d.facetFieldDef ? {
          from: { data: n.getName(`${t}_domain`) },
          sort: getSort$1(AA, t)
        } : {},
        ...BA && IA ? {
          from: { data: n.getName(`facet_domain_${t}`) }
        } : {},
        ...H ? { title: H } : {},
        ...k.sizeSignal ? {
          encode: {
            update: {
              [eA]: k.sizeSignal
            }
          }
        } : {},
        ...BA ? { axes: CA } : {}
      };
    }
  }
  return null;
}
const LAYOUT_TITLE_BAND = {
  column: {
    start: 0,
    end: 1
  },
  row: {
    start: 1,
    end: 0
  }
};
function getLayoutTitleBand(n, t) {
  return LAYOUT_TITLE_BAND[t][n];
}
function assembleLayoutTitleBand(n, t) {
  const g = {};
  for (const d of FACET_CHANNELS) {
    const k = n[d];
    if (k?.facetFieldDef) {
      const { titleAnchor: H, titleOrient: AA } = getHeaderProperties(["titleAnchor", "titleOrient"], k.facetFieldDef.header, t, d), gA = getHeaderChannel(d, AA), IA = getLayoutTitleBand(H, gA);
      IA !== void 0 && (g[gA] = IA);
    }
  }
  return isEmpty(g) ? void 0 : g;
}
function assembleHeaderProperties(n, t, g, d, k) {
  const H = {};
  for (const AA of d) {
    if (!k[AA])
      continue;
    const gA = getHeaderProperty(AA, t?.header, n, g);
    gA !== void 0 && (H[k[AA]] = gA);
  }
  return H;
}
function assembleLayoutSignals(n) {
  return [
    ...sizeSignals(n, "width"),
    ...sizeSignals(n, "height"),
    ...sizeSignals(n, "childWidth"),
    ...sizeSignals(n, "childHeight")
  ];
}
function sizeSignals(n, t) {
  const g = t === "width" ? "x" : "y", d = n.component.layoutSize.get(t);
  if (!d || d === "merged")
    return [];
  const k = n.getSizeSignalRef(t).signal;
  if (d === "step") {
    const H = n.getScaleComponent(g);
    if (H) {
      const AA = H.get("type"), gA = H.get("range");
      if (hasDiscreteDomain(AA) && isVgRangeStep(gA)) {
        const IA = n.scaleName(g);
        return isFacetModel(n.parent) && n.parent.component.resolve.scale[g] === "independent" ? [stepSignal(IA, gA)] : [
          stepSignal(IA, gA),
          {
            name: k,
            update: sizeExpr(IA, H, `domain('${IA}').length`)
          }
        ];
      }
    }
    throw new Error("layout size is step although width/height is not step.");
  } else if (d == "container") {
    const H = k.endsWith("width"), AA = H ? "containerSize()[0]" : "containerSize()[1]", gA = getViewConfigContinuousSize(n.config.view, H ? "width" : "height"), IA = `isFinite(${AA}) ? ${AA} : ${gA}`;
    return [{ name: k, init: IA, on: [{ update: IA, events: "window:resize" }] }];
  } else
    return [
      {
        name: k,
        value: d
      }
    ];
}
function stepSignal(n, t) {
  const g = `${n}_step`;
  return isSignalRef(t.step) ? { name: g, update: t.step.signal } : { name: g, value: t.step };
}
function sizeExpr(n, t, g) {
  const d = t.get("type"), k = t.get("padding"), H = getFirstDefined(t.get("paddingOuter"), k);
  let AA = t.get("paddingInner");
  return AA = d === "band" ? (
    // only band has real paddingInner
    AA !== void 0 ? AA : k
  ) : (
    // For point, as calculated in https://github.com/vega/vega-scale/blob/master/src/band.js#L128,
    // it's equivalent to have paddingInner = 1 since there is only n-1 steps between n points.
    1
  ), `bandspace(${g}, ${signalOrStringValue(AA)}, ${signalOrStringValue(H)}) * ${n}_step`;
}
function getSizeTypeFromLayoutSizeType(n) {
  return n === "childWidth" ? "width" : n === "childHeight" ? "height" : n;
}
function guideEncodeEntry(n, t) {
  return keys$1(n).reduce((g, d) => ({
    ...g,
    ...wrapCondition({
      model: t,
      channelDef: n[d],
      vgChannel: d,
      mainRefFn: (k) => signalOrValueRef(k.value),
      invalidValueRef: void 0
      // guide encoding won't show invalid values for the scale
    })
  }), {});
}
function defaultScaleResolve(n, t) {
  if (isFacetModel(t))
    return n === "theta" ? "independent" : "shared";
  if (isLayerModel(t))
    return "shared";
  if (isConcatModel(t))
    return isXorY(n) || n === "theta" || n === "radius" ? "independent" : "shared";
  throw new Error("invalid model type for resolve");
}
function parseGuideResolve(n, t) {
  const g = n.scale[t], d = isXorY(t) ? "axis" : "legend";
  return g === "independent" ? (n[d][t] === "shared" && warn(independentScaleMeansIndependentGuide(t)), "independent") : n[d][t] || "shared";
}
const LEGEND_COMPONENT_PROPERTY_INDEX = {
  ...COMMON_LEGEND_PROPERTY_INDEX,
  disable: 1,
  labelExpr: 1,
  selections: 1,
  // channel scales
  opacity: 1,
  shape: 1,
  stroke: 1,
  fill: 1,
  size: 1,
  strokeWidth: 1,
  strokeDash: 1,
  // encode
  encode: 1
}, LEGEND_COMPONENT_PROPERTIES = keys$1(LEGEND_COMPONENT_PROPERTY_INDEX);
class LegendComponent extends Split {
}
const legendEncodeRules = {
  symbols,
  gradient: gradient$1,
  labels: labels$1,
  entries
};
function symbols(n, { fieldOrDatumDef: t, model: g, channel: d, legendCmpt: k, legendType: H }) {
  if (H !== "symbol")
    return;
  const { markDef: AA, encoding: gA, config: IA, mark: CA } = g, BA = AA.filled && CA !== "trail";
  let eA = {
    ...applyMarkConfig({}, g, FILL_STROKE_CONFIG),
    ...color(g, { filled: BA })
  };
  const iA = k.get("symbolOpacity") ?? IA.legend.symbolOpacity, QA = k.get("symbolFillColor") ?? IA.legend.symbolFillColor, tA = k.get("symbolStrokeColor") ?? IA.legend.symbolStrokeColor, oA = iA === void 0 ? getMaxValue(gA.opacity) ?? AA.opacity : void 0;
  if (eA.fill) {
    if (d === "fill" || BA && d === COLOR)
      delete eA.fill;
    else if (hasProperty(eA.fill, "field"))
      QA ? delete eA.fill : (eA.fill = signalOrValueRef(IA.legend.symbolBaseFillColor ?? "black"), eA.fillOpacity = signalOrValueRef(oA ?? 1));
    else if (isArray$2(eA.fill)) {
      const EA = getFirstConditionValue(gA.fill ?? gA.color) ?? AA.fill ?? (BA && AA.color);
      EA && (eA.fill = signalOrValueRef(EA));
    }
  }
  if (eA.stroke) {
    if (d === "stroke" || !BA && d === COLOR)
      delete eA.stroke;
    else if (hasProperty(eA.stroke, "field") || tA)
      delete eA.stroke;
    else if (isArray$2(eA.stroke)) {
      const EA = getFirstDefined(getFirstConditionValue(gA.stroke || gA.color), AA.stroke, BA ? AA.color : void 0);
      EA && (eA.stroke = { value: EA });
    }
  }
  if (d !== OPACITY) {
    const EA = isFieldDef(t) && selectedCondition(g, k, t);
    EA ? eA.opacity = [
      { test: EA, ...signalOrValueRef(oA ?? 1) },
      signalOrValueRef(IA.legend.unselectedOpacity)
    ] : oA && (eA.opacity = signalOrValueRef(oA));
  }
  return eA = { ...eA, ...n }, isEmpty(eA) ? void 0 : eA;
}
function gradient$1(n, { model: t, legendType: g, legendCmpt: d }) {
  if (g !== "gradient")
    return;
  const { config: k, markDef: H, encoding: AA } = t;
  let gA = {};
  const CA = (d.get("gradientOpacity") ?? k.legend.gradientOpacity) === void 0 ? getMaxValue(AA.opacity) || H.opacity : void 0;
  return CA && (gA.opacity = signalOrValueRef(CA)), gA = { ...gA, ...n }, isEmpty(gA) ? void 0 : gA;
}
function labels$1(n, { fieldOrDatumDef: t, model: g, channel: d, legendCmpt: k }) {
  const H = g.legend(d) || {}, AA = g.config, gA = isFieldDef(t) ? selectedCondition(g, k, t) : void 0, IA = gA ? [{ test: gA, value: 1 }, { value: AA.legend.unselectedOpacity }] : void 0, { format: CA, formatType: BA } = H;
  let eA;
  isCustomFormatType(BA) ? eA = formatCustomType({
    fieldOrDatumDef: t,
    field: "datum.value",
    format: CA,
    formatType: BA,
    config: AA
  }) : CA === void 0 && BA === void 0 && AA.customFormatTypes && (t.type === "quantitative" && AA.numberFormatType ? eA = formatCustomType({
    fieldOrDatumDef: t,
    field: "datum.value",
    format: AA.numberFormat,
    formatType: AA.numberFormatType,
    config: AA
  }) : t.type === "temporal" && AA.timeFormatType && isFieldDef(t) && t.timeUnit === void 0 && (eA = formatCustomType({
    fieldOrDatumDef: t,
    field: "datum.value",
    format: AA.timeFormat,
    formatType: AA.timeFormatType,
    config: AA
  })));
  const iA = {
    ...IA ? { opacity: IA } : {},
    ...eA ? { text: eA } : {},
    ...n
  };
  return isEmpty(iA) ? void 0 : iA;
}
function entries(n, { legendCmpt: t }) {
  return t.get("selections")?.length ? { ...n, fill: { value: "transparent" } } : n;
}
function getMaxValue(n) {
  return getConditionValue(n, (t, g) => Math.max(t, g.value));
}
function getFirstConditionValue(n) {
  return getConditionValue(n, (t, g) => getFirstDefined(t, g.value));
}
function getConditionValue(n, t) {
  if (hasConditionalValueDef(n))
    return array(n.condition).reduce(t, n.value);
  if (isValueDef(n))
    return n.value;
}
function selectedCondition(n, t, g) {
  const d = t.get("selections");
  if (!d?.length)
    return;
  const k = $$1(g.field);
  return d.map((H) => `(!length(data(${$$1(varName(H) + STORE)})) || (${H}[${k}] && indexof(${H}[${k}], datum.value) >= 0))`).join(" || ");
}
const legendRules = {
  direction: ({ direction: n }) => n,
  format: ({ fieldOrDatumDef: n, legend: t, config: g }) => {
    const { format: d, formatType: k } = t;
    return guideFormat(n, n.type, d, k, g, !1);
  },
  formatType: ({ legend: n, fieldOrDatumDef: t, scaleType: g }) => {
    const { formatType: d } = n;
    return guideFormatType(d, t, g);
  },
  gradientLength: (n) => {
    const { legend: t, legendConfig: g } = n;
    return t.gradientLength ?? g.gradientLength ?? defaultGradientLength(n);
  },
  labelOverlap: ({ legend: n, legendConfig: t, scaleType: g }) => n.labelOverlap ?? t.labelOverlap ?? defaultLabelOverlap(g),
  symbolType: ({ legend: n, markDef: t, channel: g, encoding: d }) => n.symbolType ?? defaultSymbolType(t.type, g, d.shape, t.shape),
  title: ({ fieldOrDatumDef: n, config: t }) => title(n, t, { allowDisabling: !0 }),
  type: ({ legendType: n, scaleType: t, channel: g }) => {
    if (isColorChannel(g) && isContinuousToContinuous(t)) {
      if (n === "gradient")
        return;
    } else if (n === "symbol")
      return;
    return n;
  },
  // depended by other property, let's define upfront
  values: ({ fieldOrDatumDef: n, legend: t }) => values$4(t, n)
};
function values$4(n, t) {
  const g = n.values;
  if (isArray$2(g))
    return valueArray(t, g);
  if (isSignalRef(g))
    return g;
}
function defaultSymbolType(n, t, g, d) {
  if (t !== "shape") {
    const k = getFirstConditionValue(g) ?? d;
    if (k)
      return k;
  }
  switch (n) {
    case "bar":
    case "rect":
    case "image":
    case "square":
      return "square";
    case "line":
    case "trail":
    case "rule":
      return "stroke";
    case "arc":
    case "point":
    case "circle":
    case "tick":
    case "geoshape":
    case "area":
    case "text":
      return "circle";
  }
}
function getLegendType(n) {
  const { legend: t } = n;
  return getFirstDefined(t.type, defaultType$1(n));
}
function defaultType$1({ channel: n, timeUnit: t, scaleType: g }) {
  if (isColorChannel(n)) {
    if (contains(["quarter", "month", "day"], t))
      return "symbol";
    if (isContinuousToContinuous(g))
      return "gradient";
  }
  return "symbol";
}
function getDirection({ legendConfig: n, legendType: t, orient: g, legend: d }) {
  return d.direction ?? n[t ? "gradientDirection" : "symbolDirection"] ?? defaultDirection(g, t);
}
function defaultDirection(n, t) {
  switch (n) {
    case "top":
    case "bottom":
      return "horizontal";
    case "left":
    case "right":
    case "none":
    case void 0:
      return;
    // vertical is Vega's default
    default:
      return t === "gradient" ? "horizontal" : void 0;
  }
}
function defaultGradientLength({ legendConfig: n, model: t, direction: g, orient: d, scaleType: k }) {
  const { gradientHorizontalMaxLength: H, gradientHorizontalMinLength: AA, gradientVerticalMaxLength: gA, gradientVerticalMinLength: IA } = n;
  if (isContinuousToContinuous(k))
    return g === "horizontal" ? d === "top" || d === "bottom" ? gradientLengthSignal(t, "width", AA, H) : AA : gradientLengthSignal(t, "height", IA, gA);
}
function gradientLengthSignal(n, t, g, d) {
  return { signal: `clamp(${n.getSizeSignalRef(t).signal}, ${g}, ${d})` };
}
function defaultLabelOverlap(n) {
  if (contains(["quantile", "threshold", "log", "symlog"], n))
    return "greedy";
}
function parseLegend(n) {
  const t = isUnitModel(n) ? parseUnitLegend(n) : parseNonUnitLegend(n);
  return n.component.legends = t, t;
}
function parseUnitLegend(n) {
  const { encoding: t } = n, g = {};
  for (const d of [COLOR, ...LEGEND_SCALE_CHANNELS]) {
    const k = getFieldOrDatumDef(t[d]);
    !k || !n.getScaleComponent(d) || d === SHAPE && isFieldDef(k) && k.type === GEOJSON || (g[d] = parseLegendForChannel(n, d));
  }
  return g;
}
function getLegendDefWithScale(n, t) {
  const g = n.scaleName(t);
  if (n.mark === "trail") {
    if (t === "color")
      return { stroke: g };
    if (t === "size")
      return { strokeWidth: g };
  }
  return t === "color" ? n.markDef.filled ? { fill: g } : { stroke: g } : { [t]: g };
}
function isExplicit$1(n, t, g, d) {
  switch (t) {
    case "disable":
      return g !== void 0;
    // if axis is specified or null/false, then its enable/disable state is explicit
    case "values":
      return !!g?.values;
    case "title":
      if (t === "title" && n === d?.title)
        return !0;
  }
  return n === (g || {})[t];
}
function parseLegendForChannel(n, t) {
  let g = n.legend(t);
  const { markDef: d, encoding: k, config: H } = n, AA = H.legend, gA = new LegendComponent({}, getLegendDefWithScale(n, t));
  parseInteractiveLegend(n, t, gA);
  const IA = g !== void 0 ? !g : AA.disable;
  if (gA.set("disable", IA, g !== void 0), IA)
    return gA;
  g = g || {};
  const CA = n.getScaleComponent(t).get("type"), BA = getFieldOrDatumDef(k[t]), eA = isFieldDef(BA) ? normalizeTimeUnit(BA.timeUnit)?.unit : void 0, iA = g.orient || H.legend.orient || "right", QA = getLegendType({ legend: g, channel: t, timeUnit: eA, scaleType: CA }), tA = getDirection({ legend: g, legendType: QA, orient: iA, legendConfig: AA }), oA = {
    legend: g,
    channel: t,
    model: n,
    markDef: d,
    encoding: k,
    fieldOrDatumDef: BA,
    legendConfig: AA,
    config: H,
    scaleType: CA,
    orient: iA,
    legendType: QA,
    direction: tA
  };
  for (const cA of LEGEND_COMPONENT_PROPERTIES) {
    if (QA === "gradient" && cA.startsWith("symbol") || QA === "symbol" && cA.startsWith("gradient"))
      continue;
    const sA = cA in legendRules ? legendRules[cA](oA) : g[cA];
    if (sA !== void 0) {
      const rA = isExplicit$1(sA, cA, g, n.fieldDef(t));
      (rA || H.legend[cA] === void 0) && gA.set(cA, sA, rA);
    }
  }
  const EA = g?.encoding ?? {}, aA = gA.get("selections"), nA = {}, lA = { fieldOrDatumDef: BA, model: n, channel: t, legendCmpt: gA, legendType: QA };
  for (const cA of ["labels", "legend", "title", "symbols", "gradient", "entries"]) {
    const sA = guideEncodeEntry(EA[cA] ?? {}, n), rA = cA in legendEncodeRules ? legendEncodeRules[cA](sA, lA) : sA;
    rA !== void 0 && !isEmpty(rA) && (nA[cA] = {
      ...aA?.length && isFieldDef(BA) ? { name: `${varName(BA.field)}_legend_${cA}` } : {},
      ...aA?.length ? { interactive: !0 } : {},
      update: aA?.length ? { ...rA, cursor: { value: "pointer" } } : rA
    });
  }
  return isEmpty(nA) || gA.set("encode", nA, !!g?.encoding), gA;
}
function parseNonUnitLegend(n) {
  const { legends: t, resolve: g } = n.component;
  for (const d of n.children) {
    parseLegend(d);
    for (const k of keys$1(d.component.legends))
      g.legend[k] = parseGuideResolve(n.component.resolve, k), g.legend[k] === "shared" && (t[k] = mergeLegendComponent(t[k], d.component.legends[k]), t[k] || (g.legend[k] = "independent", delete t[k]));
  }
  for (const d of keys$1(t))
    for (const k of n.children)
      k.component.legends[d] && g.legend[d] === "shared" && delete k.component.legends[d];
  return t;
}
function mergeLegendComponent(n, t) {
  if (!n)
    return t.clone();
  const g = n.getWithExplicit("orient"), d = t.getWithExplicit("orient");
  if (g.explicit && d.explicit && g.value !== d.value)
    return;
  let k = !1;
  for (const H of LEGEND_COMPONENT_PROPERTIES) {
    const AA = mergeValuesWithExplicit(
      n.getWithExplicit(H),
      t.getWithExplicit(H),
      H,
      "legend",
      // Tie breaker function
      (gA, IA) => {
        switch (H) {
          case "symbolType":
            return mergeSymbolType(gA, IA);
          case "title":
            return mergeTitleComponent(gA, IA);
          case "type":
            return k = !0, makeImplicit("symbol");
        }
        return defaultTieBreaker(gA, IA, H, "legend");
      }
    );
    n.setWithExplicit(H, AA);
  }
  return k && (n.implicit?.encode?.gradient && deleteNestedProperty(n.implicit, ["encode", "gradient"]), n.explicit?.encode?.gradient && deleteNestedProperty(n.explicit, ["encode", "gradient"])), n;
}
function mergeSymbolType(n, t) {
  return t.value === "circle" ? t : n;
}
function setLegendEncode(n, t, g, d) {
  n.encode ??= {}, n.encode[t] ??= {}, n.encode[t].update ??= {}, n.encode[t].update[g] = d;
}
function assembleLegends(n) {
  const t = n.component.legends, g = {};
  for (const k of keys$1(t)) {
    const H = n.getScaleComponent(k), AA = stringify$1(H.get("domains"));
    if (g[AA])
      for (const gA of g[AA])
        mergeLegendComponent(gA, t[k]) || g[AA].push(t[k]);
    else
      g[AA] = [t[k].clone()];
  }
  return vals(g).flat().map((k) => assembleLegend(k, n.config)).filter((k) => k !== void 0);
}
function assembleLegend(n, t) {
  const { disable: g, labelExpr: d, selections: k, ...H } = n.combine();
  if (!g) {
    if (t.aria === !1 && H.aria == null && (H.aria = !1), H.encode?.symbols) {
      const AA = H.encode.symbols.update;
      AA.fill && AA.fill.value !== "transparent" && !AA.stroke && !H.stroke && (AA.stroke = { value: "transparent" });
      for (const gA of LEGEND_SCALE_CHANNELS)
        H[gA] && delete AA[gA];
    }
    if (H.title || delete H.title, d !== void 0) {
      let AA = d;
      H.encode?.labels?.update && isSignalRef(H.encode.labels.update.text) && (AA = replaceAll(d, "datum.label", H.encode.labels.update.text.signal)), setLegendEncode(H, "labels", "text", { signal: AA });
    }
    return H;
  }
}
function assembleProjections(n) {
  return isLayerModel(n) || isConcatModel(n) ? assembleProjectionsForModelAndChildren(n) : assembleProjectionForModel(n);
}
function assembleProjectionsForModelAndChildren(n) {
  return n.children.reduce((t, g) => t.concat(g.assembleProjections()), assembleProjectionForModel(n));
}
function assembleProjectionForModel(n) {
  const t = n.component.projection;
  if (!t || t.merged)
    return [];
  const g = t.combine(), { name: d } = g;
  if (t.data) {
    const k = {
      signal: `[${t.size.map((AA) => AA.signal).join(", ")}]`
    }, H = t.data.reduce((AA, gA) => {
      const IA = isSignalRef(gA) ? gA.signal : `data('${n.lookupDataSource(gA)}')`;
      return contains(AA, IA) || AA.push(IA), AA;
    }, []);
    if (H.length <= 0)
      throw new Error("Projection's fit didn't find any data sources");
    return [
      {
        name: d,
        size: k,
        fit: {
          signal: H.length > 1 ? `[${H.join(", ")}]` : H[0]
        },
        ...g
      }
    ];
  } else
    return [
      {
        name: d,
        // translate to center by default
        translate: { signal: "[width / 2, height / 2]" },
        // parameters, overwrite default translate if specified
        ...g
      }
    ];
}
const PROJECTION_PROPERTIES = [
  "type",
  "clipAngle",
  "clipExtent",
  "center",
  "rotate",
  "precision",
  "reflectX",
  "reflectY",
  "coefficient",
  "distance",
  "fraction",
  "lobes",
  "parallel",
  "radius",
  "ratio",
  "spacing",
  "tilt"
];
class ProjectionComponent extends Split {
  specifiedProjection;
  size;
  data;
  merged = !1;
  constructor(t, g, d, k) {
    super(
      { ...g },
      // all explicit properties of projection
      { name: t }
    ), this.specifiedProjection = g, this.size = d, this.data = k;
  }
  /**
   * Whether the projection parameters should fit provided data.
   */
  get isFit() {
    return !!this.data;
  }
}
function parseProjection(n) {
  n.component.projection = isUnitModel(n) ? parseUnitProjection(n) : parseNonUnitProjections(n);
}
function parseUnitProjection(n) {
  if (n.hasProjection) {
    const t = replaceExprRef(n.specifiedProjection), g = !(t && (t.scale != null || t.translate != null)), d = g ? [n.getSizeSignalRef("width"), n.getSizeSignalRef("height")] : void 0, k = g ? gatherFitData(n) : void 0, H = new ProjectionComponent(n.projectionName(!0), {
      ...replaceExprRef(n.config.projection),
      ...t
    }, d, k);
    return H.get("type") || H.set("type", "equalEarth", !1), H;
  }
}
function gatherFitData(n) {
  const t = [], { encoding: g } = n;
  for (const d of [
    [LONGITUDE, LATITUDE],
    [LONGITUDE2, LATITUDE2]
  ])
    (getFieldOrDatumDef(g[d[0]]) || getFieldOrDatumDef(g[d[1]])) && t.push({
      signal: n.getName(`geojson_${t.length}`)
    });
  return n.channelHasField(SHAPE) && n.typedFieldDef(SHAPE).type === GEOJSON && t.push({
    signal: n.getName(`geojson_${t.length}`)
  }), t.length === 0 && t.push(n.requestDataName(DataSourceType.Main)), t;
}
function mergeIfNoConflict(n, t) {
  const g = every(PROJECTION_PROPERTIES, (k) => !!(!has(n.explicit, k) && !has(t.explicit, k) || has(n.explicit, k) && has(t.explicit, k) && // some properties might be signals or objects and require hashing for comparison
  deepEqual(n.get(k), t.get(k))));
  if (deepEqual(n.size, t.size)) {
    if (g)
      return n;
    if (deepEqual(n.explicit, {}))
      return t;
    if (deepEqual(t.explicit, {}))
      return n;
  }
  return null;
}
function parseNonUnitProjections(n) {
  if (n.children.length === 0)
    return;
  let t;
  for (const d of n.children)
    parseProjection(d);
  const g = every(n.children, (d) => {
    const k = d.component.projection;
    if (k)
      if (t) {
        const H = mergeIfNoConflict(t, k);
        return H && (t = H), !!H;
      } else
        return t = k, !0;
    else return !0;
  });
  if (t && g) {
    const d = n.projectionName(!0), k = new ProjectionComponent(d, t.specifiedProjection, t.size, duplicate(t.data));
    for (const H of n.children) {
      const AA = H.component.projection;
      AA && (AA.isFit && k.data.push(...H.component.projection.data), H.renameProjection(AA.get("name"), d), AA.merged = !0);
    }
    return k;
  }
}
function rangeFormula(n, t, g, d) {
  if (binRequiresRange(t, g)) {
    const k = isUnitModel(n) ? n.axis(g) ?? n.legend(g) ?? {} : {}, H = vgField(t, { expr: "datum" }), AA = vgField(t, { expr: "datum", binSuffix: "end" });
    return {
      formulaAs: vgField(t, { binSuffix: "range", forAs: !0 }),
      formula: binFormatExpression(H, AA, k.format, k.formatType, d)
    };
  }
  return {};
}
function binKey(n, t) {
  return `${binToString(n)}_${t}`;
}
function getSignalsFromModel(n, t) {
  return {
    signal: n.getName(`${t}_bins`),
    extentSignal: n.getName(`${t}_extent`)
  };
}
function getBinSignalName(n, t, g) {
  const d = normalizeBin(g, void 0) ?? {}, k = binKey(d, t);
  return n.getName(`${k}_bins`);
}
function isBinTransform(n) {
  return "as" in n;
}
function createBinComponent(n, t, g) {
  let d, k;
  isBinTransform(n) ? d = isString$1(n.as) ? [n.as, `${n.as}_end`] : [n.as[0], n.as[1]] : d = [vgField(n, { forAs: !0 }), vgField(n, { binSuffix: "end", forAs: !0 })];
  const H = { ...normalizeBin(t, void 0) }, AA = binKey(H, n.field), { signal: gA, extentSignal: IA } = getSignalsFromModel(g, AA);
  if (isParameterExtent(H.extent)) {
    const BA = H.extent;
    k = parseSelectionExtent(g, BA.param, BA), delete H.extent;
  }
  const CA = {
    bin: H,
    field: n.field,
    as: [d],
    ...gA ? { signal: gA } : {},
    ...IA ? { extentSignal: IA } : {},
    ...k ? { span: k } : {}
  };
  return { key: AA, binComponent: CA };
}
class BinNode extends DataFlowNode {
  bins;
  clone() {
    return new BinNode(null, duplicate(this.bins));
  }
  constructor(t, g) {
    super(t), this.bins = g;
  }
  static makeFromEncoding(t, g) {
    const d = g.reduceFieldDef((k, H, AA) => {
      if (isTypedFieldDef(H) && isBinning(H.bin)) {
        const { key: gA, binComponent: IA } = createBinComponent(H, H.bin, g);
        k[gA] = {
          ...IA,
          ...k[gA],
          ...rangeFormula(g, H, AA, g.config)
        };
      }
      return k;
    }, {});
    return isEmpty(d) ? null : new BinNode(t, d);
  }
  /**
   * Creates a bin node from BinTransform.
   * The optional parameter should provide
   */
  static makeFromTransform(t, g, d) {
    const { key: k, binComponent: H } = createBinComponent(g, g.bin, d);
    return new BinNode(t, {
      [k]: H
    });
  }
  /**
   * Merge bin nodes. This method either integrates the bin config from the other node
   * or if this node already has a bin config, renames the corresponding signal in the model.
   */
  merge(t, g) {
    for (const d of keys$1(t.bins))
      d in this.bins ? (g(t.bins[d].signal, this.bins[d].signal), this.bins[d].as = unique([...this.bins[d].as, ...t.bins[d].as], hash)) : this.bins[d] = t.bins[d];
    for (const d of t.children)
      t.removeChild(d), d.parent = this;
    t.remove();
  }
  producedFields() {
    return new Set(vals(this.bins).map((t) => t.as).flat(2));
  }
  dependentFields() {
    return new Set(vals(this.bins).map((t) => t.field));
  }
  hash() {
    return `Bin ${hash(this.bins)}`;
  }
  assemble() {
    return vals(this.bins).flatMap((t) => {
      const g = [], [d, ...k] = t.as, { extent: H, ...AA } = t.bin, gA = {
        type: "bin",
        field: replacePathInField(t.field),
        as: d,
        signal: t.signal,
        ...isParameterExtent(H) ? { extent: null } : { extent: H },
        ...t.span ? { span: { signal: `span(${t.span})` } } : {},
        ...AA
      };
      !H && t.extentSignal && (g.push({
        type: "extent",
        field: replacePathInField(t.field),
        signal: t.extentSignal
      }), gA.extent = { signal: t.extentSignal }), g.push(gA);
      for (const IA of k)
        for (let CA = 0; CA < 2; CA++)
          g.push({
            type: "formula",
            expr: vgField({ field: d[CA] }, { expr: "datum" }),
            as: IA[CA]
          });
      return t.formula && g.push({
        type: "formula",
        expr: t.formula,
        as: t.formulaAs
      }), g;
    });
  }
}
function addDimension(n, t, g, d) {
  const k = isUnitModel(d) ? d.encoding[getSecondaryRangeChannel(t)] : void 0;
  if (isTypedFieldDef(g) && isUnitModel(d) && hasBandEnd(g, k, d.markDef, d.config)) {
    n.add(vgField(g, {})), n.add(vgField(g, { suffix: "end" }));
    const { mark: H, markDef: AA, config: gA } = d, IA = getBandPosition({ fieldDef: g, markDef: AA, config: gA });
    isRectBasedMark(H) && IA !== 0.5 && isXorY(t) && (n.add(vgField(g, { suffix: OFFSETTED_RECT_START_SUFFIX })), n.add(vgField(g, { suffix: OFFSETTED_RECT_END_SUFFIX }))), g.bin && binRequiresRange(g, t) && n.add(vgField(g, { binSuffix: "range" }));
  } else if (isGeoPositionChannel(t)) {
    const H = getPositionChannelFromLatLong(t);
    n.add(d.getName(H));
  } else
    n.add(vgField(g));
  return isScaleFieldDef(g) && isFieldRange(g.scale?.range) && n.add(g.scale.range.field), n;
}
function mergeMeasures(n, t) {
  for (const g of keys$1(t)) {
    const d = t[g];
    for (const k of keys$1(d))
      g in n ? n[g][k] = /* @__PURE__ */ new Set([...n[g][k] ?? [], ...d[k]]) : n[g] = { [k]: d[k] };
  }
}
class AggregateNode extends DataFlowNode {
  dimensions;
  measures;
  clone() {
    return new AggregateNode(null, new Set(this.dimensions), duplicate(this.measures));
  }
  /**
   * @param dimensions string set for dimensions
   * @param measures dictionary mapping field name => dict of aggregation functions and names to use
   */
  constructor(t, g, d) {
    super(t), this.dimensions = g, this.measures = d;
  }
  get groupBy() {
    return this.dimensions;
  }
  static makeFromEncoding(t, g) {
    let d = !1;
    g.forEachFieldDef((AA) => {
      AA.aggregate && (d = !0);
    });
    const k = {}, H = /* @__PURE__ */ new Set();
    return !d || (g.forEachFieldDef((AA, gA) => {
      const { aggregate: IA, field: CA } = AA;
      if (IA)
        if (IA === "count")
          k["*"] ??= {}, k["*"].count = /* @__PURE__ */ new Set([vgField(AA, { forAs: !0 })]);
        else {
          if (isArgminDef(IA) || isArgmaxDef(IA)) {
            const BA = isArgminDef(IA) ? "argmin" : "argmax", eA = IA[BA];
            k[eA] ??= {}, k[eA][BA] = /* @__PURE__ */ new Set([vgField({ op: BA, field: eA }, { forAs: !0 })]);
          } else
            k[CA] ??= {}, k[CA][IA] = /* @__PURE__ */ new Set([vgField(AA, { forAs: !0 })]);
          isScaleChannel(gA) && g.scaleDomain(gA) === "unaggregated" && (k[CA] ??= {}, k[CA].min = /* @__PURE__ */ new Set([vgField({ field: CA, aggregate: "min" }, { forAs: !0 })]), k[CA].max = /* @__PURE__ */ new Set([vgField({ field: CA, aggregate: "max" }, { forAs: !0 })]));
        }
      else
        addDimension(H, gA, AA, g);
    }), H.size + keys$1(k).length === 0) ? null : new AggregateNode(t, H, k);
  }
  static makeFromTransform(t, g) {
    const d = /* @__PURE__ */ new Set(), k = {};
    for (const H of g.aggregate) {
      const { op: AA, field: gA, as: IA } = H;
      AA && (AA === "count" ? (k["*"] ??= {}, k["*"].count = /* @__PURE__ */ new Set([IA || vgField(H, { forAs: !0 })])) : (k[gA] ??= {}, k[gA][AA] ??= /* @__PURE__ */ new Set(), k[gA][AA].add(IA || vgField(H, { forAs: !0 }))));
    }
    for (const H of g.groupby ?? [])
      d.add(H);
    return d.size + keys$1(k).length === 0 ? null : new AggregateNode(t, d, k);
  }
  merge(t) {
    return setEqual(this.dimensions, t.dimensions) ? (mergeMeasures(this.measures, t.measures), !0) : (debug("different dimensions, cannot merge"), !1);
  }
  addDimensions(t) {
    t.forEach(this.dimensions.add, this.dimensions);
  }
  dependentFields() {
    return /* @__PURE__ */ new Set([...this.dimensions, ...keys$1(this.measures)]);
  }
  producedFields() {
    const t = /* @__PURE__ */ new Set();
    for (const g of keys$1(this.measures))
      for (const d of keys$1(this.measures[g])) {
        const k = this.measures[g][d];
        k.size === 0 ? t.add(`${d}_${g}`) : k.forEach(t.add, t);
      }
    return t;
  }
  hash() {
    return `Aggregate ${hash({ dimensions: this.dimensions, measures: this.measures })}`;
  }
  assemble() {
    const t = [], g = [], d = [];
    for (const H of keys$1(this.measures))
      for (const AA of keys$1(this.measures[H]))
        for (const gA of this.measures[H][AA])
          d.push(gA), t.push(AA), g.push(H === "*" ? null : replacePathInField(H));
    return {
      type: "aggregate",
      groupby: [...this.dimensions].map(replacePathInField),
      ops: t,
      fields: g,
      as: d
    };
  }
}
class FacetNode extends DataFlowNode {
  model;
  name;
  data;
  column;
  row;
  facet;
  childModel;
  /**
   * @param model The facet model.
   * @param name The name that this facet source will have.
   * @param data The source data for this facet data.
   */
  constructor(t, g, d, k) {
    super(t), this.model = g, this.name = d, this.data = k;
    for (const H of FACET_CHANNELS) {
      const AA = g.facet[H];
      if (AA) {
        const { bin: gA, sort: IA } = AA;
        this[H] = {
          name: g.getName(`${H}_domain`),
          fields: [vgField(AA), ...isBinning(gA) ? [vgField(AA, { binSuffix: "end" })] : []],
          ...isSortField(IA) ? { sortField: IA } : isArray$2(IA) ? { sortIndexField: sortArrayIndexField(AA, H) } : {}
        };
      }
    }
    this.childModel = g.child;
  }
  hash() {
    let t = "Facet";
    for (const g of FACET_CHANNELS)
      this[g] && (t += ` ${g.charAt(0)}:${hash(this[g])}`);
    return t;
  }
  get fields() {
    const t = [];
    for (const g of FACET_CHANNELS)
      this[g]?.fields && t.push(...this[g].fields);
    return t;
  }
  dependentFields() {
    const t = new Set(this.fields);
    for (const g of FACET_CHANNELS)
      this[g] && (this[g].sortField && t.add(this[g].sortField.field), this[g].sortIndexField && t.add(this[g].sortIndexField));
    return t;
  }
  producedFields() {
    return /* @__PURE__ */ new Set();
  }
  /**
   * The name to reference this source is its name.
   */
  getSource() {
    return this.name;
  }
  getChildIndependentFieldsWithStep() {
    const t = {};
    for (const g of POSITION_SCALE_CHANNELS) {
      const d = this.childModel.component.scales[g];
      if (d && !d.merged) {
        const k = d.get("type"), H = d.get("range");
        if (hasDiscreteDomain(k) && isVgRangeStep(H)) {
          const AA = assembleDomain(this.childModel, g), gA = getFieldFromDomain(AA);
          gA ? t[g] = gA : warn(unknownField(g));
        }
      }
    }
    return t;
  }
  assembleRowColumnHeaderData(t, g, d) {
    const k = { row: "y", column: "x", facet: void 0 }[t], H = [], AA = [], gA = [];
    k && d && d[k] && (g ? (H.push(`distinct_${d[k]}`), AA.push("max")) : (H.push(d[k]), AA.push("distinct")), gA.push(`distinct_${d[k]}`));
    const { sortField: IA, sortIndexField: CA } = this[t];
    if (IA) {
      const { op: BA = DEFAULT_SORT_OP, field: eA } = IA;
      H.push(eA), AA.push(BA), gA.push(vgField(IA, { forAs: !0 }));
    } else CA && (H.push(CA), AA.push("max"), gA.push(CA));
    return {
      name: this[t].name,
      // Use data from the crossed one if it exist
      source: g ?? this.data,
      transform: [
        {
          type: "aggregate",
          groupby: this[t].fields,
          ...H.length ? {
            fields: H,
            ops: AA,
            as: gA
          } : {}
        }
      ]
    };
  }
  assembleFacetHeaderData(t) {
    const { columns: g } = this.model.layout, { layoutHeaders: d } = this.model.component, k = [], H = {};
    for (const IA of HEADER_CHANNELS) {
      for (const CA of HEADER_TYPES) {
        const BA = d[IA]?.[CA] ?? [];
        for (const eA of BA)
          if (eA.axes?.length > 0) {
            H[IA] = !0;
            break;
          }
      }
      if (H[IA]) {
        const CA = `length(data("${this.facet.name}"))`, BA = IA === "row" ? g ? { signal: `ceil(${CA} / ${g})` } : 1 : g ? { signal: `min(${CA}, ${g})` } : { signal: CA };
        k.push({
          name: `${this.facet.name}_${IA}`,
          transform: [
            {
              type: "sequence",
              start: 0,
              stop: BA
            }
          ]
        });
      }
    }
    const { row: AA, column: gA } = H;
    return (AA || gA) && k.unshift(this.assembleRowColumnHeaderData("facet", null, t)), k;
  }
  assemble() {
    const t = [];
    let g = null;
    const d = this.getChildIndependentFieldsWithStep(), { column: k, row: H, facet: AA } = this;
    if (k && H && (d.x || d.y)) {
      g = `cross_${this.column.name}_${this.row.name}`;
      const gA = [].concat(d.x ?? [], d.y ?? []), IA = gA.map(() => "distinct");
      t.push({
        name: g,
        source: this.data,
        transform: [
          {
            type: "aggregate",
            groupby: this.fields,
            fields: gA,
            ops: IA
          }
        ]
      });
    }
    for (const gA of [COLUMN, ROW])
      this[gA] && t.push(this.assembleRowColumnHeaderData(gA, g, d));
    if (AA) {
      const gA = this.assembleFacetHeaderData(d);
      gA && t.push(...gA);
    }
    return t;
  }
}
function unquote(n) {
  return n.startsWith("'") && n.endsWith("'") || n.startsWith('"') && n.endsWith('"') ? n.slice(1, -1) : n;
}
function parseExpression(n, t) {
  const g = accessPathWithDatum(n);
  if (t === "number")
    return `toNumber(${g})`;
  if (t === "boolean")
    return `toBoolean(${g})`;
  if (t === "string")
    return `toString(${g})`;
  if (t === "date")
    return `toDate(${g})`;
  if (t === "flatten")
    return g;
  if (t.startsWith("date:")) {
    const d = unquote(t.slice(5, t.length));
    return `timeParse(${g},'${d}')`;
  } else if (t.startsWith("utc:")) {
    const d = unquote(t.slice(4, t.length));
    return `utcParse(${g},'${d}')`;
  } else
    return warn(unrecognizedParse(t)), null;
}
function getImplicitFromFilterTransform(n) {
  const t = {};
  return forEachLeaf(n.filter, (g) => {
    if (isFieldPredicate(g)) {
      let d = null;
      isFieldEqualPredicate(g) ? d = signalRefOrValue(g.equal) : isFieldLTEPredicate(g) ? d = signalRefOrValue(g.lte) : isFieldLTPredicate(g) ? d = signalRefOrValue(g.lt) : isFieldGTPredicate(g) ? d = signalRefOrValue(g.gt) : isFieldGTEPredicate(g) ? d = signalRefOrValue(g.gte) : isFieldRangePredicate(g) ? d = g.range[0] : isFieldOneOfPredicate(g) && (d = (g.oneOf ?? g.in)[0]), d && (isDateTime(d) ? t[g.field] = "date" : isNumber$1(d) ? t[g.field] = "number" : isString$1(d) && (t[g.field] = "string")), g.timeUnit && (t[g.field] = "date");
    }
  }), t;
}
function getImplicitFromEncoding(n) {
  const t = {};
  function g(d) {
    isFieldOrDatumDefForTimeFormat(d) ? t[d.field] = "date" : d.type === "quantitative" && isMinMaxOp(d.aggregate) ? t[d.field] = "number" : accessPathDepth(d.field) > 1 ? d.field in t || (t[d.field] = "flatten") : isScaleFieldDef(d) && isSortField(d.sort) && accessPathDepth(d.sort.field) > 1 && (d.sort.field in t || (t[d.sort.field] = "flatten"));
  }
  if ((isUnitModel(n) || isFacetModel(n)) && n.forEachFieldDef((d, k) => {
    if (isTypedFieldDef(d))
      g(d);
    else {
      const H = getMainRangeChannel(k), AA = n.fieldDef(H);
      g({
        ...d,
        type: AA.type
      });
    }
  }), isUnitModel(n)) {
    const { mark: d, markDef: k, encoding: H } = n;
    if (isPathMark(d) && // No need to sort by dimension if we have a connected scatterplot (order channel is present)
    !n.encoding.order) {
      const AA = k.orient === "horizontal" ? "y" : "x", gA = H[AA];
      isFieldDef(gA) && gA.type === "quantitative" && !(gA.field in t) && (t[gA.field] = "number");
    }
  }
  return t;
}
function getImplicitFromSelection(n) {
  const t = {};
  if (isUnitModel(n) && n.component.selection)
    for (const g of keys$1(n.component.selection)) {
      const d = n.component.selection[g];
      for (const k of d.project.items)
        !k.channel && accessPathDepth(k.field) > 1 && (t[k.field] = "flatten");
    }
  return t;
}
class ParseNode extends DataFlowNode {
  _parse;
  clone() {
    return new ParseNode(null, duplicate(this._parse));
  }
  constructor(t, g) {
    super(t), this._parse = g;
  }
  hash() {
    return `Parse ${hash(this._parse)}`;
  }
  /**
   * Creates a parse node from a data.format.parse and updates ancestorParse.
   */
  static makeExplicit(t, g, d) {
    let k = {};
    const H = g.data;
    return !isGenerator(H) && H?.format?.parse && (k = H.format.parse), this.makeWithAncestors(t, k, {}, d);
  }
  /**
   * Creates a parse node from "explicit" parse and "implicit" parse and updates ancestorParse.
   */
  static makeWithAncestors(t, g, d, k) {
    for (const gA of keys$1(d)) {
      const IA = k.getWithExplicit(gA);
      IA.value !== void 0 && (IA.explicit || IA.value === d[gA] || IA.value === "derived" || d[gA] === "flatten" ? delete d[gA] : warn(differentParse(gA, d[gA], IA.value)));
    }
    for (const gA of keys$1(g)) {
      const IA = k.get(gA);
      IA !== void 0 && (IA === g[gA] ? delete g[gA] : warn(differentParse(gA, g[gA], IA)));
    }
    const H = new Split(g, d);
    k.copyAll(H);
    const AA = {};
    for (const gA of keys$1(H.combine())) {
      const IA = H.get(gA);
      IA !== null && (AA[gA] = IA);
    }
    return keys$1(AA).length === 0 || k.parseNothing ? null : new ParseNode(t, AA);
  }
  get parse() {
    return this._parse;
  }
  merge(t) {
    this._parse = { ...this._parse, ...t.parse }, t.remove();
  }
  /**
   * Assemble an object for Vega's format.parse property.
   */
  assembleFormatParse() {
    const t = {};
    for (const g of keys$1(this._parse)) {
      const d = this._parse[g];
      accessPathDepth(g) === 1 && (t[g] = d);
    }
    return t;
  }
  // format parse depends and produces all fields in its parse
  producedFields() {
    return new Set(keys$1(this._parse));
  }
  dependentFields() {
    return new Set(keys$1(this._parse));
  }
  assembleTransforms(t = !1) {
    return keys$1(this._parse).filter((g) => t ? accessPathDepth(g) > 1 : !0).map((g) => {
      const d = parseExpression(g, this._parse[g]);
      return d ? {
        type: "formula",
        expr: d,
        as: removePathFromField(g)
        // Vega output is always flattened
      } : null;
    }).filter((g) => g !== null);
  }
}
class IdentifierNode extends DataFlowNode {
  clone() {
    return new IdentifierNode(null);
  }
  constructor(t) {
    super(t);
  }
  dependentFields() {
    return /* @__PURE__ */ new Set();
  }
  producedFields() {
    return /* @__PURE__ */ new Set([SELECTION_ID]);
  }
  hash() {
    return "Identifier";
  }
  assemble() {
    return { type: "identifier", as: SELECTION_ID };
  }
}
class GraticuleNode extends DataFlowNode {
  params;
  clone() {
    return new GraticuleNode(null, this.params);
  }
  constructor(t, g) {
    super(t), this.params = g;
  }
  dependentFields() {
    return /* @__PURE__ */ new Set();
  }
  producedFields() {
  }
  hash() {
    return `Graticule ${hash(this.params)}`;
  }
  assemble() {
    return {
      type: "graticule",
      ...this.params === !0 ? {} : this.params
    };
  }
}
class SequenceNode extends DataFlowNode {
  params;
  clone() {
    return new SequenceNode(null, this.params);
  }
  constructor(t, g) {
    super(t), this.params = g;
  }
  dependentFields() {
    return /* @__PURE__ */ new Set();
  }
  producedFields() {
    return /* @__PURE__ */ new Set([this.params.as ?? "data"]);
  }
  hash() {
    return `Hash ${hash(this.params)}`;
  }
  assemble() {
    return {
      type: "sequence",
      ...this.params
    };
  }
}
class SourceNode extends DataFlowNode {
  _data;
  _name;
  _generator;
  constructor(t) {
    super(null), t ??= { name: "source" };
    let g;
    if (isGenerator(t) || (g = t.format ? { ...omit(t.format, ["parse"]) } : {}), isInlineData(t))
      this._data = { values: t.values };
    else if (isUrlData(t)) {
      if (this._data = { url: t.url }, !g.type) {
        let d = /(?:\.([^.]+))?$/.exec(t.url)[1];
        contains(["json", "csv", "tsv", "dsv", "topojson"], d) || (d = "json"), g.type = d;
      }
    } else isSphereGenerator(t) ? this._data = { values: [{ type: "Sphere" }] } : (isNamedData(t) || isGenerator(t)) && (this._data = {});
    this._generator = isGenerator(t), t.name && (this._name = t.name), g && !isEmpty(g) && (this._data.format = g);
  }
  dependentFields() {
    return /* @__PURE__ */ new Set();
  }
  producedFields() {
  }
  get data() {
    return this._data;
  }
  hasName() {
    return !!this._name;
  }
  get isGenerator() {
    return this._generator;
  }
  get dataName() {
    return this._name;
  }
  set dataName(t) {
    this._name = t;
  }
  set parent(t) {
    throw new Error("Source nodes have to be roots.");
  }
  remove() {
    throw new Error("Source nodes are roots and cannot be removed.");
  }
  hash() {
    throw new Error("Cannot hash sources");
  }
  assemble() {
    return {
      name: this._name,
      ...this._data,
      transform: []
    };
  }
}
function isDataSourceNode(n) {
  return n instanceof SourceNode || n instanceof GraticuleNode || n instanceof SequenceNode;
}
class Optimizer {
  #B;
  constructor() {
    this.#B = !1;
  }
  // Once true, #modified is never set to false
  setModified() {
    this.#B = !0;
  }
  get modifiedFlag() {
    return this.#B;
  }
}
class BottomUpOptimizer extends Optimizer {
  /**
   * Compute a map of node depths that we can use to determine a topological sort order.
   */
  getNodeDepths(t, g, d) {
    d.set(t, g);
    for (const k of t.children)
      this.getNodeDepths(k, g + 1, d);
    return d;
  }
  /**
   * Run the optimizer on all nodes starting from the leaves.
   */
  optimize(t) {
    const d = [...this.getNodeDepths(t, 0, /* @__PURE__ */ new Map()).entries()].sort((k, H) => H[1] - k[1]);
    for (const k of d)
      this.run(k[0]);
    return this.modifiedFlag;
  }
}
class TopDownOptimizer extends Optimizer {
  /**
   * Run the optimizer depth first on all nodes starting from the roots.
   */
  optimize(t) {
    this.run(t);
    for (const g of t.children)
      this.optimize(g);
    return this.modifiedFlag;
  }
}
class MergeIdenticalNodes extends TopDownOptimizer {
  mergeNodes(t, g) {
    const d = g.shift();
    for (const k of g)
      t.removeChild(k), k.parent = d, k.remove();
  }
  run(t) {
    const g = t.children.map((k) => k.hash()), d = {};
    for (let k = 0; k < g.length; k++)
      d[g[k]] === void 0 ? d[g[k]] = [t.children[k]] : d[g[k]].push(t.children[k]);
    for (const k of keys$1(d))
      d[k].length > 1 && (this.setModified(), this.mergeNodes(t, d[k]));
  }
}
class RemoveUnnecessaryIdentifierNodes extends TopDownOptimizer {
  requiresSelectionId;
  constructor(t) {
    super(), this.requiresSelectionId = t && requiresSelectionId(t);
  }
  run(t) {
    t instanceof IdentifierNode && (this.requiresSelectionId && (isDataSourceNode(t.parent) || t.parent instanceof AggregateNode || t.parent instanceof ParseNode) || (this.setModified(), t.remove()));
  }
}
class RemoveDuplicateTimeUnits extends Optimizer {
  optimize(t) {
    return this.run(t, /* @__PURE__ */ new Set()), this.modifiedFlag;
  }
  run(t, g) {
    let d = /* @__PURE__ */ new Set();
    t instanceof TimeUnitNode && (d = t.producedFields(), hasIntersection(d, g) && (this.setModified(), t.removeFormulas(g), t.producedFields.length === 0 && t.remove()));
    for (const k of t.children)
      this.run(k, /* @__PURE__ */ new Set([...g, ...d]));
  }
}
class RemoveUnnecessaryOutputNodes extends TopDownOptimizer {
  constructor() {
    super();
  }
  run(t) {
    t instanceof OutputNode && !t.isRequired() && (this.setModified(), t.remove());
  }
}
class MoveParseUp extends BottomUpOptimizer {
  run(t) {
    if (!isDataSourceNode(t) && !(t.numChildren() > 1)) {
      for (const g of t.children)
        if (g instanceof ParseNode)
          if (t instanceof ParseNode)
            this.setModified(), t.merge(g);
          else {
            if (fieldIntersection(t.producedFields(), g.dependentFields()))
              continue;
            this.setModified(), g.swapWithParent();
          }
    }
  }
}
class MergeParse extends BottomUpOptimizer {
  run(t) {
    const g = [...t.children], d = t.children.filter((k) => k instanceof ParseNode);
    if (t.numChildren() > 1 && d.length >= 1) {
      const k = {}, H = /* @__PURE__ */ new Set();
      for (const AA of d) {
        const gA = AA.parse;
        for (const IA of keys$1(gA))
          IA in k ? k[IA] !== gA[IA] && H.add(IA) : k[IA] = gA[IA];
      }
      for (const AA of H)
        delete k[AA];
      if (!isEmpty(k)) {
        this.setModified();
        const AA = new ParseNode(t, k);
        for (const gA of g) {
          if (gA instanceof ParseNode)
            for (const IA of keys$1(k))
              delete gA.parse[IA];
          t.removeChild(gA), gA.parent = AA, gA instanceof ParseNode && keys$1(gA.parse).length === 0 && gA.remove();
        }
      }
    }
  }
}
class RemoveUnusedSubtrees extends BottomUpOptimizer {
  run(t) {
    t instanceof OutputNode || t.numChildren() > 0 || t instanceof FacetNode || t instanceof SourceNode || (this.setModified(), t.remove());
  }
}
class MergeTimeUnits extends BottomUpOptimizer {
  run(t) {
    const g = t.children.filter((k) => k instanceof TimeUnitNode), d = g.pop();
    for (const k of g)
      this.setModified(), d.merge(k);
  }
}
class MergeAggregates extends BottomUpOptimizer {
  run(t) {
    const g = t.children.filter((k) => k instanceof AggregateNode), d = {};
    for (const k of g) {
      const H = hash(k.groupBy);
      H in d || (d[H] = []), d[H].push(k);
    }
    for (const k of keys$1(d)) {
      const H = d[k];
      if (H.length > 1) {
        const AA = H.pop();
        for (const gA of H)
          AA.merge(gA) && (t.removeChild(gA), gA.parent = AA, gA.remove(), this.setModified());
      }
    }
  }
}
class MergeBins extends BottomUpOptimizer {
  model;
  constructor(t) {
    super(), this.model = t;
  }
  run(t) {
    const g = !(isDataSourceNode(t) || t instanceof FilterNode || t instanceof ParseNode || t instanceof IdentifierNode), d = [], k = [];
    for (const H of t.children)
      H instanceof BinNode && (g && !fieldIntersection(t.producedFields(), H.dependentFields()) ? d.push(H) : k.push(H));
    if (d.length > 0) {
      const H = d.pop();
      for (const AA of d)
        H.merge(AA, this.model.renameSignal.bind(this.model));
      this.setModified(), t instanceof BinNode ? t.merge(H, this.model.renameSignal.bind(this.model)) : H.swapWithParent();
    }
    if (k.length > 1) {
      const H = k.pop();
      for (const AA of k)
        H.merge(AA, this.model.renameSignal.bind(this.model));
      this.setModified();
    }
  }
}
class MergeOutputs extends BottomUpOptimizer {
  run(t) {
    const g = [...t.children];
    if (!some(g, (AA) => AA instanceof OutputNode) || t.numChildren() <= 1)
      return;
    const k = [];
    let H;
    for (const AA of g)
      if (AA instanceof OutputNode) {
        let gA = AA;
        for (; gA.numChildren() === 1; ) {
          const [IA] = gA.children;
          if (IA instanceof OutputNode)
            gA = IA;
          else
            break;
        }
        k.push(...gA.children), H ? (t.removeChild(AA), AA.parent = H.parent, H.parent.removeChild(H), H.parent = gA, this.setModified()) : H = gA;
      } else
        k.push(AA);
    if (k.length) {
      this.setModified();
      for (const AA of k)
        AA.parent.removeChild(AA), AA.parent = H;
    }
  }
}
class JoinAggregateTransformNode extends DataFlowNode {
  transform;
  clone() {
    return new JoinAggregateTransformNode(null, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g;
  }
  addDimensions(t) {
    this.transform.groupby = unique(this.transform.groupby.concat(t), (g) => g);
  }
  dependentFields() {
    const t = /* @__PURE__ */ new Set();
    return this.transform.groupby && this.transform.groupby.forEach(t.add, t), this.transform.joinaggregate.map((g) => g.field).filter((g) => g !== void 0).forEach(t.add, t), t;
  }
  producedFields() {
    return new Set(this.transform.joinaggregate.map(this.getDefaultName));
  }
  getDefaultName(t) {
    return t.as ?? vgField(t);
  }
  hash() {
    return `JoinAggregateTransform ${hash(this.transform)}`;
  }
  assemble() {
    const t = [], g = [], d = [];
    for (const H of this.transform.joinaggregate)
      g.push(H.op), d.push(this.getDefaultName(H)), t.push(H.field === void 0 ? null : H.field);
    const k = this.transform.groupby;
    return {
      type: "joinaggregate",
      as: d,
      ops: g,
      fields: t,
      ...k !== void 0 ? { groupby: k } : {}
    };
  }
}
class FilterInvalidNode extends DataFlowNode {
  filter;
  clone() {
    return new FilterInvalidNode(null, { ...this.filter });
  }
  constructor(t, g) {
    super(t), this.filter = g;
  }
  static make(t, g, d) {
    const { config: k, markDef: H } = g, { marks: AA, scales: gA } = d;
    if (AA === "include-invalid-values" && gA === "include-invalid-values")
      return null;
    const IA = g.reduceFieldDef((CA, BA, eA) => {
      const iA = isScaleChannel(eA) && g.getScaleComponent(eA);
      if (iA) {
        const QA = iA.get("type"), { aggregate: tA } = BA, oA = getScaleInvalidDataMode({
          scaleChannel: eA,
          markDef: H,
          config: k,
          scaleType: QA,
          isCountAggregate: isCountingAggregateOp(tA)
        });
        oA !== "show" && oA !== "always-valid" && (CA[BA.field] = BA);
      }
      return CA;
    }, {});
    return keys$1(IA).length ? new FilterInvalidNode(t, IA) : null;
  }
  dependentFields() {
    return new Set(keys$1(this.filter));
  }
  producedFields() {
    return /* @__PURE__ */ new Set();
  }
  hash() {
    return `FilterInvalid ${hash(this.filter)}`;
  }
  /**
   * Create the VgTransforms for each of the filtered fields.
   */
  assemble() {
    const t = keys$1(this.filter).reduce((g, d) => {
      const k = this.filter[d], H = vgField(k, { expr: "datum" });
      return k !== null && (k.type === "temporal" ? g.push(`(isDate(${H}) || (${isValidFiniteNumberExpr(H)}))`) : k.type === "quantitative" && g.push(isValidFiniteNumberExpr(H))), g;
    }, []);
    return t.length > 0 ? {
      type: "filter",
      expr: t.join(" && ")
    } : null;
  }
}
function isValidFiniteNumberExpr(n) {
  return `isValid(${n}) && isFinite(+${n})`;
}
function getStackByFields(n) {
  return n.stack.stackBy.reduce((t, g) => {
    const d = g.fieldDef, k = vgField(d);
    return k && t.push(k), t;
  }, []);
}
function isValidAsArray(n) {
  return isArray$2(n) && n.every((t) => isString$1(t)) && n.length > 1;
}
class StackNode extends DataFlowNode {
  _stack;
  clone() {
    return new StackNode(null, duplicate(this._stack));
  }
  constructor(t, g) {
    super(t), this._stack = g;
  }
  static makeFromTransform(t, g) {
    const { stack: d, groupby: k, as: H, offset: AA = "zero" } = g, gA = [], IA = [];
    if (g.sort !== void 0)
      for (const eA of g.sort)
        gA.push(eA.field), IA.push(getFirstDefined(eA.order, "ascending"));
    const CA = {
      field: gA,
      order: IA
    };
    let BA;
    return isValidAsArray(H) ? BA = H : isString$1(H) ? BA = [H, `${H}_end`] : BA = [`${g.stack}_start`, `${g.stack}_end`], new StackNode(t, {
      dimensionFieldDefs: [],
      stackField: d,
      groupby: k,
      offset: AA,
      sort: CA,
      facetby: [],
      as: BA
    });
  }
  static makeFromEncoding(t, g) {
    const d = g.stack, { encoding: k } = g;
    if (!d)
      return null;
    const { groupbyChannels: H, fieldChannel: AA, offset: gA, impute: IA } = d, CA = H.map((QA) => {
      const tA = k[QA];
      return getFieldDef(tA);
    }).filter((QA) => !!QA), BA = getStackByFields(g), eA = g.encoding.order;
    let iA;
    if (isArray$2(eA) || isFieldDef(eA))
      iA = sortParams(eA);
    else {
      const QA = isOrderOnlyDef(eA) ? eA.sort : AA === "y" ? "descending" : "ascending";
      iA = BA.reduce((tA, oA) => (tA.field.includes(oA) || (tA.field.push(oA), tA.order.push(QA)), tA), { field: [], order: [] });
    }
    return new StackNode(t, {
      dimensionFieldDefs: CA,
      stackField: g.vgField(AA),
      facetby: [],
      stackby: BA,
      sort: iA,
      offset: gA,
      impute: IA,
      as: [
        g.vgField(AA, { suffix: "start", forAs: !0 }),
        g.vgField(AA, { suffix: "end", forAs: !0 })
      ]
    });
  }
  get stack() {
    return this._stack;
  }
  addDimensions(t) {
    this._stack.facetby.push(...t);
  }
  dependentFields() {
    const t = /* @__PURE__ */ new Set();
    return t.add(this._stack.stackField), this.getGroupbyFields().forEach(t.add, t), this._stack.facetby.forEach(t.add, t), this._stack.sort.field.forEach(t.add, t), t;
  }
  producedFields() {
    return new Set(this._stack.as);
  }
  hash() {
    return `Stack ${hash(this._stack)}`;
  }
  getGroupbyFields() {
    const { dimensionFieldDefs: t, impute: g, groupby: d } = this._stack;
    return t.length > 0 ? t.map((k) => k.bin ? g ? [vgField(k, { binSuffix: "mid" })] : [
      // For binned group by field without impute, we need both bin (start) and bin_end
      vgField(k, {}),
      vgField(k, { binSuffix: "end" })
    ] : [vgField(k)]).flat() : d ?? [];
  }
  assemble() {
    const t = [], { facetby: g, dimensionFieldDefs: d, stackField: k, stackby: H, sort: AA, offset: gA, impute: IA, as: CA } = this._stack;
    if (IA)
      for (const BA of d) {
        const { bandPosition: eA = 0.5, bin: iA } = BA;
        if (iA) {
          const QA = vgField(BA, { expr: "datum" }), tA = vgField(BA, { expr: "datum", binSuffix: "end" });
          t.push({
            type: "formula",
            expr: `${isValidFiniteNumberExpr(QA)} ? ${eA}*${QA}+${1 - eA}*${tA} : ${QA}`,
            as: vgField(BA, { binSuffix: "mid", forAs: !0 })
          });
        }
        t.push({
          type: "impute",
          field: k,
          groupby: [...H, ...g],
          key: vgField(BA, { binSuffix: "mid" }),
          method: "value",
          value: 0
        });
      }
    return t.push({
      type: "stack",
      groupby: [...this.getGroupbyFields(), ...g],
      field: k,
      sort: AA,
      as: CA,
      offset: gA
    }), t;
  }
}
class WindowTransformNode extends DataFlowNode {
  transform;
  clone() {
    return new WindowTransformNode(null, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g;
  }
  addDimensions(t) {
    this.transform.groupby = unique(this.transform.groupby.concat(t), (g) => g);
  }
  dependentFields() {
    const t = /* @__PURE__ */ new Set();
    return (this.transform.groupby ?? []).forEach(t.add, t), (this.transform.sort ?? []).forEach((g) => t.add(g.field)), this.transform.window.map((g) => g.field).filter((g) => g !== void 0).forEach(t.add, t), t;
  }
  producedFields() {
    return new Set(this.transform.window.map(this.getDefaultName));
  }
  getDefaultName(t) {
    return t.as ?? vgField(t);
  }
  hash() {
    return `WindowTransform ${hash(this.transform)}`;
  }
  assemble() {
    const t = [], g = [], d = [], k = [];
    for (const eA of this.transform.window)
      g.push(eA.op), d.push(this.getDefaultName(eA)), k.push(eA.param === void 0 ? null : eA.param), t.push(eA.field === void 0 ? null : eA.field);
    const H = this.transform.frame, AA = this.transform.groupby;
    if (H && H[0] === null && H[1] === null && g.every((eA) => isAggregateOp(eA)))
      return {
        type: "joinaggregate",
        as: d,
        ops: g,
        fields: t,
        ...AA !== void 0 ? { groupby: AA } : {}
      };
    const gA = [], IA = [];
    if (this.transform.sort !== void 0)
      for (const eA of this.transform.sort)
        gA.push(eA.field), IA.push(eA.order ?? "ascending");
    const CA = {
      field: gA,
      order: IA
    }, BA = this.transform.ignorePeers;
    return {
      type: "window",
      params: k,
      as: d,
      ops: g,
      fields: t,
      sort: CA,
      ...BA !== void 0 ? { ignorePeers: BA } : {},
      ...AA !== void 0 ? { groupby: AA } : {},
      ...H !== void 0 ? { frame: H } : {}
    };
  }
}
function cloneSubtree(n) {
  function t(g) {
    if (!(g instanceof FacetNode)) {
      const d = g.clone();
      if (d instanceof OutputNode) {
        const k = FACET_SCALE_PREFIX + d.getSource();
        d.setSource(k), n.model.component.data.outputNodes[k] = d;
      } else (d instanceof AggregateNode || d instanceof StackNode || d instanceof WindowTransformNode || d instanceof JoinAggregateTransformNode) && d.addDimensions(n.fields);
      for (const k of g.children.flatMap(t))
        k.parent = d;
      return [d];
    }
    return g.children.flatMap(t);
  }
  return t;
}
function moveFacetDown(n) {
  if (n instanceof FacetNode)
    if (n.numChildren() === 1 && !(n.children[0] instanceof OutputNode)) {
      const t = n.children[0];
      (t instanceof AggregateNode || t instanceof StackNode || t instanceof WindowTransformNode || t instanceof JoinAggregateTransformNode) && t.addDimensions(n.fields), t.swapWithParent(), moveFacetDown(n);
    } else {
      const t = n.model.component.data.main;
      moveMainDownToFacet(t);
      const g = cloneSubtree(n), d = n.children.map(g).flat();
      for (const k of d)
        k.parent = t;
    }
  else
    n.children.map(moveFacetDown);
}
function moveMainDownToFacet(n) {
  if (n instanceof OutputNode && n.type === DataSourceType.Main && n.numChildren() === 1) {
    const t = n.children[0];
    t instanceof FacetNode || (t.swapWithParent(), moveMainDownToFacet(n));
  }
}
const FACET_SCALE_PREFIX = "scale_", MAX_OPTIMIZATION_RUNS = 5;
function checkLinks(n) {
  for (const t of n) {
    for (const g of t.children)
      if (g.parent !== t)
        return !1;
    if (!checkLinks(t.children))
      return !1;
  }
  return !0;
}
function runOptimizer(n, t) {
  let g = !1;
  for (const d of t)
    g = n.optimize(d) || g;
  return g;
}
function optimizationDataflowHelper(n, t, g) {
  let d = n.sources, k = !1;
  return k = runOptimizer(new RemoveUnnecessaryOutputNodes(), d) || k, k = runOptimizer(new RemoveUnnecessaryIdentifierNodes(t), d) || k, d = d.filter((H) => H.numChildren() > 0), k = runOptimizer(new RemoveUnusedSubtrees(), d) || k, d = d.filter((H) => H.numChildren() > 0), g || (k = runOptimizer(new MoveParseUp(), d) || k, k = runOptimizer(new MergeBins(t), d) || k, k = runOptimizer(new RemoveDuplicateTimeUnits(), d) || k, k = runOptimizer(new MergeParse(), d) || k, k = runOptimizer(new MergeAggregates(), d) || k, k = runOptimizer(new MergeTimeUnits(), d) || k, k = runOptimizer(new MergeIdenticalNodes(), d) || k, k = runOptimizer(new MergeOutputs(), d) || k), n.sources = d, k;
}
function optimizeDataflow(n, t) {
  checkLinks(n.sources);
  let g = 0, d = 0;
  for (let k = 0; k < MAX_OPTIMIZATION_RUNS && optimizationDataflowHelper(n, t, !0); k++)
    g++;
  n.sources.map(moveFacetDown);
  for (let k = 0; k < MAX_OPTIMIZATION_RUNS && optimizationDataflowHelper(n, t, !1); k++)
    d++;
  checkLinks(n.sources), Math.max(g, d) === MAX_OPTIMIZATION_RUNS && warn(`Maximum optimization runs(${MAX_OPTIMIZATION_RUNS}) reached.`);
}
class SignalRefWrapper {
  constructor(t) {
    Object.defineProperty(this, "signal", {
      enumerable: !0,
      get: t
    });
  }
  signal;
  // for ts
  static fromName(t, g) {
    return new SignalRefWrapper(() => t(g));
  }
}
function parseScaleDomain(n) {
  isUnitModel(n) ? parseUnitScaleDomain(n) : parseNonUnitScaleDomain(n);
}
function parseUnitScaleDomain(n) {
  const t = n.component.scales;
  for (const g of keys$1(t)) {
    const d = parseDomainForChannel(n, g);
    if (t[g].setWithExplicit("domains", d), parseSelectionDomain(n, g), n.component.data.isFaceted) {
      let H = n;
      for (; !isFacetModel(H) && H.parent; )
        H = H.parent;
      if (H.component.resolve.scale[g] === "shared")
        for (const gA of d.value)
          isDataRefDomain(gA) && (gA.data = FACET_SCALE_PREFIX + gA.data.replace(FACET_SCALE_PREFIX, ""));
    }
  }
}
function parseNonUnitScaleDomain(n) {
  for (const g of n.children)
    parseScaleDomain(g);
  const t = n.component.scales;
  for (const g of keys$1(t)) {
    let d, k = null;
    for (const H of n.children) {
      const AA = H.component.scales[g];
      if (AA) {
        d === void 0 ? d = AA.getWithExplicit("domains") : d = mergeValuesWithExplicit(d, AA.getWithExplicit("domains"), "domains", "scale", domainsTieBreaker);
        const gA = AA.get("selectionExtent");
        k && gA && k.param !== gA.param && warn(NEEDS_SAME_SELECTION), k = gA;
      }
    }
    t[g].setWithExplicit("domains", d), k && t[g].set("selectionExtent", k, !0);
  }
}
function normalizeUnaggregatedDomain(n, t, g, d) {
  if (n === "unaggregated") {
    const { valid: k, reason: H } = canUseUnaggregatedDomain(t, g);
    if (!k) {
      warn(H);
      return;
    }
  } else if (n === void 0 && d.useUnaggregatedDomain) {
    const { valid: k } = canUseUnaggregatedDomain(t, g);
    if (k)
      return "unaggregated";
  }
  return n;
}
function parseDomainForChannel(n, t) {
  const g = n.getScaleComponent(t).get("type"), { encoding: d } = n, k = normalizeUnaggregatedDomain(n.scaleDomain(t), n.typedFieldDef(t), g, n.config.scale);
  return k !== n.scaleDomain(t) && (n.specifiedScales[t] = {
    ...n.specifiedScales[t],
    domain: k
  }), t === "x" && getFieldOrDatumDef(d.x2) ? getFieldOrDatumDef(d.x) ? mergeValuesWithExplicit(parseSingleChannelDomain(g, k, n, "x"), parseSingleChannelDomain(g, k, n, "x2"), "domain", "scale", domainsTieBreaker) : parseSingleChannelDomain(g, k, n, "x2") : t === "y" && getFieldOrDatumDef(d.y2) ? getFieldOrDatumDef(d.y) ? mergeValuesWithExplicit(parseSingleChannelDomain(g, k, n, "y"), parseSingleChannelDomain(g, k, n, "y2"), "domain", "scale", domainsTieBreaker) : parseSingleChannelDomain(g, k, n, "y2") : parseSingleChannelDomain(g, k, n, t);
}
function mapDomainToDataSignal(n, t, g) {
  return n.map((d) => ({ signal: `{data: ${valueExpr(d, { timeUnit: g, type: t })}}` }));
}
function convertDomainIfItIsDateTime(n, t, g) {
  const d = normalizeTimeUnit(g)?.unit;
  return t === "temporal" || d ? mapDomainToDataSignal(n, t, d) : [n];
}
function parseSingleChannelDomain(n, t, g, d) {
  const { encoding: k, markDef: H, mark: AA, config: gA, stack: IA } = g, CA = getFieldOrDatumDef(k[d]), { type: BA } = CA, eA = CA.timeUnit, iA = getScaleDataSourceForHandlingInvalidValues({
    invalid: getMarkConfig("invalid", H, gA),
    isPath: isPathMark(AA)
  });
  if (isDomainUnionWith(t)) {
    const oA = parseSingleChannelDomain(n, void 0, g, d), EA = convertDomainIfItIsDateTime(t.unionWith, BA, eA);
    return makeExplicit([...EA, ...oA.value]);
  } else {
    if (isSignalRef(t))
      return makeExplicit([t]);
    if (t && t !== "unaggregated" && !isParameterDomain(t))
      return makeExplicit(convertDomainIfItIsDateTime(t, BA, eA));
  }
  if (IA && d === IA.fieldChannel) {
    if (IA.offset === "normalize")
      return makeImplicit([[0, 1]]);
    const oA = g.requestDataName(iA);
    return makeImplicit([
      {
        data: oA,
        field: g.vgField(d, { suffix: "start" })
      },
      {
        data: oA,
        field: g.vgField(d, { suffix: "end" })
      }
    ]);
  }
  const QA = isScaleChannel(d) && isFieldDef(CA) ? domainSort(g, d, n) : void 0;
  if (isDatumDef(CA)) {
    const oA = convertDomainIfItIsDateTime([CA.datum], BA, eA);
    return makeImplicit(oA);
  }
  const tA = CA;
  if (t === "unaggregated") {
    const { field: oA } = CA;
    return makeImplicit([
      {
        data: g.requestDataName(iA),
        field: vgField({ field: oA, aggregate: "min" })
      },
      {
        data: g.requestDataName(iA),
        field: vgField({ field: oA, aggregate: "max" })
      }
    ]);
  } else if (isBinning(tA.bin)) {
    if (hasDiscreteDomain(n))
      return makeImplicit(n === "bin-ordinal" ? [] : [
        {
          // If sort by aggregation of a specified sort field, we need to use RAW table,
          // so we can aggregate values for the scale independently from the main aggregation.
          data: isBoolean$1(QA) ? g.requestDataName(iA) : g.requestDataName(DataSourceType.Raw),
          // Use range if we added it and the scale does not support computing a range as a signal.
          field: g.vgField(d, binRequiresRange(tA, d) ? { binSuffix: "range" } : {}),
          // we have to use a sort object if sort = true to make the sort correct by bin start
          sort: QA === !0 || !isObject$3(QA) ? {
            field: g.vgField(d, {}),
            op: "min"
            // min or max doesn't matter since we sort by the start of the bin range
          } : QA
        }
      ]);
    {
      const { bin: oA } = tA;
      if (isBinning(oA)) {
        const EA = getBinSignalName(g, tA.field, oA);
        return makeImplicit([
          new SignalRefWrapper(() => {
            const aA = g.getSignalName(EA);
            return `[${aA}.start, ${aA}.stop]`;
          })
        ]);
      } else
        return makeImplicit([
          {
            data: g.requestDataName(iA),
            field: g.vgField(d, {})
          }
        ]);
    }
  } else if (tA.timeUnit && contains(["time", "utc"], n)) {
    const oA = k[getSecondaryRangeChannel(d)];
    if (hasBandEnd(tA, oA, H, gA)) {
      const EA = g.requestDataName(iA), aA = getBandPosition({ fieldDef: tA, fieldDef2: oA, markDef: H, config: gA }), nA = isRectBasedMark(AA) && aA !== 0.5 && isXorY(d);
      return makeImplicit([
        {
          data: EA,
          field: g.vgField(d, nA ? { suffix: OFFSETTED_RECT_START_SUFFIX } : {})
        },
        {
          data: EA,
          field: g.vgField(d, { suffix: nA ? OFFSETTED_RECT_END_SUFFIX : "end" })
        }
      ]);
    }
  }
  return makeImplicit(QA ? [
    {
      // If sort by aggregation of a specified sort field, we need to use RAW table,
      // so we can aggregate values for the scale independently from the main aggregation.
      data: isBoolean$1(QA) ? g.requestDataName(iA) : g.requestDataName(DataSourceType.Raw),
      field: g.vgField(d),
      sort: QA
    }
  ] : [
    {
      data: g.requestDataName(iA),
      field: g.vgField(d)
    }
  ]);
}
function normalizeSortField(n, t) {
  const { op: g, field: d, order: k } = n;
  return {
    // Apply default op
    op: g ?? (t ? "sum" : DEFAULT_SORT_OP),
    // flatten nested fields
    ...d ? { field: replacePathInField(d) } : {},
    ...k ? { order: k } : {}
  };
}
function parseSelectionDomain(n, t) {
  const g = n.component.scales[t], d = n.specifiedScales[t].domain, k = n.fieldDef(t)?.bin, H = isParameterDomain(d) ? d : void 0, AA = isBinParams(k) && isParameterExtent(k.extent) ? k.extent : void 0;
  (H || AA) && g.set("selectionExtent", H ?? AA, !0);
}
function domainSort(n, t, g) {
  if (!hasDiscreteDomain(g))
    return;
  const d = n.fieldDef(t), k = d.sort;
  if (isSortArray(k))
    return {
      op: "min",
      field: sortArrayIndexField(d, t),
      order: "ascending"
    };
  const { stack: H } = n, AA = H ? /* @__PURE__ */ new Set([...H.groupbyFields, ...H.stackBy.map((gA) => gA.fieldDef.field)]) : void 0;
  if (isSortField(k)) {
    const gA = H && !AA.has(k.field);
    return normalizeSortField(k, gA);
  } else if (isSortByEncoding(k)) {
    const { encoding: gA, order: IA } = k, CA = n.fieldDef(gA), { aggregate: BA, field: eA } = CA, iA = H && !AA.has(eA);
    if (isArgminDef(BA) || isArgmaxDef(BA))
      return normalizeSortField({
        field: vgField(CA),
        order: IA
      }, iA);
    if (isAggregateOp(BA) || !BA)
      return normalizeSortField({
        op: BA,
        // can't be argmin/argmax since we don't support them in encoding field def
        field: eA,
        order: IA
      }, iA);
  } else {
    if (k === "descending")
      return {
        op: "min",
        field: n.vgField(t),
        order: "descending"
      };
    if (contains([
      "ascending",
      void 0
      /* default =ascending*/
    ], k))
      return !0;
  }
}
function canUseUnaggregatedDomain(n, t) {
  const { aggregate: g, type: d } = n;
  return g ? isString$1(g) && !SHARED_DOMAIN_OPS.has(g) ? {
    valid: !1,
    reason: unaggregateDomainWithNonSharedDomainOp(g)
  } : d === "quantitative" && t === "log" ? {
    valid: !1,
    reason: unaggregatedDomainWithLogScale(n)
  } : { valid: !0 } : {
    valid: !1,
    reason: unaggregateDomainHasNoEffectForRawField(n)
  };
}
function domainsTieBreaker(n, t, g, d) {
  return n.explicit && t.explicit && warn(mergeConflictingDomainProperty(g, d, n.value, t.value)), { explicit: n.explicit, value: [...n.value, ...t.value] };
}
function mergeDomains(n) {
  const t = unique(n.map((AA) => {
    if (isDataRefDomain(AA)) {
      const { sort: gA, ...IA } = AA;
      return IA;
    }
    return AA;
  }), hash), g = unique(n.map((AA) => {
    if (isDataRefDomain(AA)) {
      const gA = AA.sort;
      return gA !== void 0 && !isBoolean$1(gA) && ("op" in gA && gA.op === "count" && delete gA.field, gA.order === "ascending" && delete gA.order), gA;
    }
  }).filter((AA) => AA !== void 0), hash);
  if (t.length === 0)
    return;
  if (t.length === 1) {
    const AA = n[0];
    if (isDataRefDomain(AA) && g.length > 0) {
      let gA = g[0];
      if (g.length > 1) {
        warn(MORE_THAN_ONE_SORT);
        const IA = g.filter((CA) => isObject$3(CA) && "op" in CA && CA.op !== "min");
        g.every((CA) => isObject$3(CA) && "op" in CA) && IA.length === 1 ? gA = IA[0] : gA = !0;
      } else if (isObject$3(gA) && "field" in gA) {
        const IA = gA.field;
        AA.field === IA && (gA = gA.order ? { order: gA.order } : !0);
      }
      return {
        ...AA,
        sort: gA
      };
    }
    return AA;
  }
  const d = unique(g.map((AA) => isBoolean$1(AA) || !("op" in AA) || isString$1(AA.op) && has(MULTIDOMAIN_SORT_OP_INDEX, AA.op) ? AA : (warn(domainSortDropped(AA)), !0)), hash);
  let k;
  d.length === 1 ? k = d[0] : d.length > 1 && (warn(MORE_THAN_ONE_SORT), k = !0);
  const H = unique(n.map((AA) => isDataRefDomain(AA) ? AA.data : null), (AA) => AA);
  return H.length === 1 && H[0] !== null ? {
    data: H[0],
    fields: t.map((gA) => gA.field),
    ...k ? { sort: k } : {}
  } : { fields: t, ...k ? { sort: k } : {} };
}
function getFieldFromDomain(n) {
  if (isDataRefDomain(n) && isString$1(n.field))
    return n.field;
  if (isDataRefUnionedDomain(n)) {
    let t;
    for (const g of n.fields)
      if (isDataRefDomain(g) && isString$1(g.field)) {
        if (!t)
          t = g.field;
        else if (t !== g.field)
          return warn(FACETED_INDEPENDENT_DIFFERENT_SOURCES), t;
      }
    return warn(FACETED_INDEPENDENT_SAME_FIELDS_DIFFERENT_SOURCES), t;
  } else if (isFieldRefUnionDomain(n)) {
    warn(FACETED_INDEPENDENT_SAME_SOURCE);
    const t = n.fields[0];
    return isString$1(t) ? t : void 0;
  }
}
function assembleDomain(n, t) {
  const d = n.component.scales[t].get("domains").map((k) => (isDataRefDomain(k) && (k.data = n.lookupDataSource(k.data)), k));
  return mergeDomains(d);
}
function assembleScales(n) {
  return isLayerModel(n) || isConcatModel(n) ? n.children.reduce((t, g) => t.concat(assembleScales(g)), assembleScalesForModel(n)) : assembleScalesForModel(n);
}
function assembleScalesForModel(n) {
  return keys$1(n.component.scales).reduce((t, g) => {
    const d = n.component.scales[g];
    if (d.merged)
      return t;
    const k = d.combine(), { name: H, type: AA, selectionExtent: gA, domains: IA, range: CA, reverse: BA, ...eA } = k, iA = assembleScaleRange(k.range, H, g, n), QA = assembleDomain(n, g), tA = gA ? assembleSelectionScaleDomain(n, gA, d, QA) : null;
    return t.push({
      name: H,
      type: AA,
      ...QA ? { domain: QA } : {},
      ...tA ? { domainRaw: tA } : {},
      range: iA,
      ...BA !== void 0 ? { reverse: BA } : {},
      ...eA
    }), t;
  }, []);
}
function assembleScaleRange(n, t, g, d) {
  if (isXorY(g)) {
    if (isVgRangeStep(n))
      return {
        step: { signal: `${t}_step` }
      };
  } else if (isObject$3(n) && isDataRefDomain(n))
    return {
      ...n,
      data: d.lookupDataSource(n.data)
    };
  return n;
}
class ScaleComponent extends Split {
  merged = !1;
  constructor(t, g) {
    super(
      {},
      // no initial explicit property
      { name: t }
    ), this.setWithExplicit("type", g);
  }
  /**
   * Whether the scale definitely includes or not include zero in the domain
   */
  domainHasZero() {
    const t = this.get("type");
    if (contains([ScaleType.LOG, ScaleType.TIME, ScaleType.UTC], t))
      return "definitely-not";
    const g = this.get("zero");
    if (g === !0 || // If zero is undefined, linear/sqrt/pow scales have zero by default.
    g === void 0 && contains([ScaleType.LINEAR, ScaleType.SQRT, ScaleType.POW], t))
      return "definitely";
    const d = this.get("domains");
    if (d.length > 0) {
      let k = !1, H = !1, AA = !1;
      for (const gA of d) {
        if (isArray$2(gA)) {
          const IA = gA[0], CA = gA[gA.length - 1];
          if (isNumber$1(IA) && isNumber$1(CA))
            if (IA <= 0 && CA >= 0) {
              k = !0;
              continue;
            } else {
              H = !0;
              continue;
            }
        }
        AA = !0;
      }
      if (k)
        return "definitely";
      if (H && !AA)
        return "definitely-not";
    }
    return "maybe";
  }
}
const RANGE_PROPERTIES = ["range", "scheme"];
function parseUnitScaleRange(n) {
  const t = n.component.scales;
  for (const g of SCALE_CHANNELS) {
    const d = t[g];
    if (!d)
      continue;
    const k = parseRangeForChannel(g, n);
    d.setWithExplicit("range", k);
  }
}
function getBinStepSignal(n, t) {
  const g = n.fieldDef(t);
  if (g?.bin) {
    const { bin: d, field: k } = g, H = getSizeChannel(t), AA = n.getName(H);
    if (isObject$3(d) && d.binned && d.step !== void 0)
      return new SignalRefWrapper(() => {
        const gA = n.scaleName(t), IA = `(domain("${gA}")[1] - domain("${gA}")[0]) / ${d.step}`;
        return `${n.getSignalName(AA)} / (${IA})`;
      });
    if (isBinning(d)) {
      const gA = getBinSignalName(n, k, d);
      return new SignalRefWrapper(() => {
        const IA = n.getSignalName(gA), CA = `(${IA}.stop - ${IA}.start) / ${IA}.step`;
        return `${n.getSignalName(AA)} / (${CA})`;
      });
    }
  }
}
function parseRangeForChannel(n, t) {
  const g = t.specifiedScales[n], { size: d } = t, H = t.getScaleComponent(n).get("type");
  for (const eA of RANGE_PROPERTIES)
    if (g[eA] !== void 0) {
      const iA = scaleTypeSupportProperty(H, eA), QA = channelScalePropertyIncompatability(n, eA);
      if (!iA)
        warn(scalePropertyNotWorkWithScaleType(H, eA, n));
      else if (QA)
        warn(QA);
      else
        switch (eA) {
          case "range": {
            const tA = g.range;
            if (isArray$2(tA)) {
              if (isXorY(n))
                return makeExplicit(tA.map((oA) => {
                  if (oA === "width" || oA === "height") {
                    const EA = t.getName(oA), aA = t.getSignalName.bind(t);
                    return SignalRefWrapper.fromName(aA, EA);
                  }
                  return oA;
                }));
            } else if (isObject$3(tA))
              return makeExplicit({
                data: t.requestDataName(DataSourceType.Main),
                field: tA.field,
                sort: { op: "min", field: t.vgField(n) }
              });
            return makeExplicit(tA);
          }
          case "scheme":
            return makeExplicit(parseScheme(g[eA]));
        }
    }
  const AA = n === X$1 || n === "xOffset" ? "width" : "height", gA = d[AA];
  if (isStep(gA)) {
    if (isXorY(n))
      if (hasDiscreteDomain(H)) {
        const eA = getPositionStep(gA, t, n);
        if (eA)
          return makeExplicit({ step: eA });
      } else
        warn(stepDropped(AA));
    else if (isXorYOffset(n)) {
      const eA = n === XOFFSET ? "x" : "y";
      if (t.getScaleComponent(eA).get("type") === "band") {
        const tA = getOffsetStep(gA, H);
        if (tA)
          return makeExplicit(tA);
      }
    }
  }
  const { rangeMin: IA, rangeMax: CA } = g, BA = defaultRange(n, t);
  return (IA !== void 0 || CA !== void 0) && // it's ok to check just rangeMin's compatibility since rangeMin/rangeMax are the same
  scaleTypeSupportProperty(H, "rangeMin") && isArray$2(BA) && BA.length === 2 ? makeExplicit([IA ?? BA[0], CA ?? BA[1]]) : makeImplicit(BA);
}
function parseScheme(n) {
  return isExtendedScheme(n) ? {
    scheme: n.name,
    ...omit(n, ["name"])
  } : { scheme: n };
}
function fullWidthOrHeightRange(n, t, g, { center: d } = {}) {
  const k = getSizeChannel(n), H = t.getName(k), AA = t.getSignalName.bind(t);
  return n === Y && hasContinuousDomain(g) ? d ? [
    SignalRefWrapper.fromName((gA) => `${AA(gA)}/2`, H),
    SignalRefWrapper.fromName((gA) => `-${AA(gA)}/2`, H)
  ] : [SignalRefWrapper.fromName(AA, H), 0] : d ? [
    SignalRefWrapper.fromName((gA) => `-${AA(gA)}/2`, H),
    SignalRefWrapper.fromName((gA) => `${AA(gA)}/2`, H)
  ] : [0, SignalRefWrapper.fromName(AA, H)];
}
function defaultRange(n, t) {
  const { size: g, config: d, mark: k, encoding: H } = t, { type: AA } = getFieldOrDatumDef(H[n]), IA = t.getScaleComponent(n).get("type"), { domain: CA, domainMid: BA } = t.specifiedScales[n];
  switch (n) {
    case X$1:
    case Y: {
      if (contains(["point", "band"], IA)) {
        const eA = getDiscretePositionSize(n, g, d.view);
        if (isStep(eA))
          return { step: getPositionStep(eA, t, n) };
      }
      return fullWidthOrHeightRange(n, t, IA);
    }
    case XOFFSET:
    case YOFFSET:
      return getOffsetRange(n, t, IA);
    case SIZE$2: {
      const eA = sizeRangeMin(k, d), iA = sizeRangeMax(k, g, t, d);
      return isContinuousToDiscrete(IA) ? interpolateRange(eA, iA, defaultContinuousToDiscreteCount(IA, d, CA, n)) : [eA, iA];
    }
    case THETA:
      return [0, Math.PI * 2];
    case ANGLE:
      return [0, 360];
    case RADIUS:
      return [
        0,
        new SignalRefWrapper(() => {
          const eA = t.getSignalName(isFacetModel(t.parent) ? "child_width" : "width"), iA = t.getSignalName(isFacetModel(t.parent) ? "child_height" : "height");
          return `min(${eA},${iA})/2`;
        })
      ];
    case TIME:
      return { step: 1e3 / d.scale.framesPerSecond };
    case STROKEWIDTH:
      return [d.scale.minStrokeWidth, d.scale.maxStrokeWidth];
    case STROKEDASH:
      return [
        // TODO: add this to Vega's config.range?
        [1, 0],
        [4, 2],
        [2, 1],
        [1, 1],
        [1, 2, 4, 2]
      ];
    case SHAPE:
      return "symbol";
    case COLOR:
    case FILL:
    case STROKE:
      return IA === "ordinal" ? AA === "nominal" ? "category" : "ordinal" : BA !== void 0 ? "diverging" : k === "rect" || k === "geoshape" ? "heatmap" : "ramp";
    case OPACITY:
    case FILLOPACITY:
    case STROKEOPACITY:
      return [d.scale.minOpacity, d.scale.maxOpacity];
  }
}
function getPositionStep(n, t, g) {
  const { encoding: d } = t, k = t.getScaleComponent(g), H = getOffsetScaleChannel(g), AA = d[H];
  if (getStepFor({ step: n, offsetIsDiscrete: isFieldOrDatumDef(AA) && isDiscrete$1(AA.type) }) === "offset" && channelHasFieldOrDatum(d, H)) {
    const IA = t.getScaleComponent(H);
    let BA = `domain('${t.scaleName(H)}').length`;
    if (IA.get("type") === "band") {
      const iA = IA.get("paddingInner") ?? IA.get("padding") ?? 0, QA = IA.get("paddingOuter") ?? IA.get("padding") ?? 0;
      BA = `bandspace(${BA}, ${iA}, ${QA})`;
    }
    const eA = k.get("paddingInner") ?? k.get("padding");
    return {
      signal: `${n.step} * ${BA} / (1-${exprFromSignalRefOrValue(eA)})`
    };
  } else
    return n.step;
}
function getOffsetStep(n, t) {
  if (getStepFor({ step: n, offsetIsDiscrete: hasDiscreteDomain(t) }) === "offset")
    return { step: n.step };
}
function getOffsetRange(n, t, g) {
  const d = n === XOFFSET ? "x" : "y", k = t.getScaleComponent(d);
  if (!k)
    return fullWidthOrHeightRange(d, t, g, { center: !0 });
  const H = k.get("type"), AA = t.scaleName(d), { markDef: gA, config: IA } = t;
  if (H === "band") {
    const CA = getDiscretePositionSize(d, t.size, t.config.view);
    if (isStep(CA)) {
      const BA = getOffsetStep(CA, g);
      if (BA)
        return BA;
    }
    return [0, { signal: `bandwidth('${AA}')` }];
  } else {
    const CA = t.encoding[d];
    if (isFieldDef(CA) && CA.timeUnit) {
      const BA = durationExpr(CA.timeUnit, (tA) => `scale('${AA}', ${tA})`), eA = t.config.scale.bandWithNestedOffsetPaddingInner, iA = getBandPosition({
        fieldDef: CA,
        markDef: gA,
        config: IA
      }) - 0.5, QA = iA !== 0 ? ` + ${iA}` : "";
      if (eA) {
        const tA = isSignalRef(eA) ? `${eA.signal}/2${QA}` : `${eA / 2 + iA}`, oA = isSignalRef(eA) ? `(1 - ${eA.signal}/2)${QA}` : `${1 - eA / 2 + iA}`;
        return [{ signal: `${tA} * (${BA})` }, { signal: `${oA} * (${BA})` }];
      }
      return [0, { signal: BA }];
    }
    return never(`Cannot use ${n} scale if ${d} scale is not discrete.`);
  }
}
function getDiscretePositionSize(n, t, g) {
  const d = n === X$1 ? "width" : "height", k = t[d];
  return k || getViewConfigDiscreteSize(g, d);
}
function defaultContinuousToDiscreteCount(n, t, g, d) {
  switch (n) {
    case "quantile":
      return t.scale.quantileCount;
    case "quantize":
      return t.scale.quantizeCount;
    case "threshold":
      return g !== void 0 && isArray$2(g) ? g.length + 1 : (warn(domainRequiredForThresholdScale(d)), 3);
  }
}
function interpolateRange(n, t, g) {
  const d = () => {
    const k = signalOrStringValue(t), H = signalOrStringValue(n), AA = `(${k} - ${H}) / (${g} - 1)`;
    return `sequence(${H}, ${k} + ${AA}, ${AA})`;
  };
  return isSignalRef(t) ? new SignalRefWrapper(d) : { signal: d() };
}
function sizeRangeMin(n, t) {
  switch (n) {
    case "bar":
    case "tick":
      return t.scale.minBandSize;
    case "line":
    case "trail":
    case "rule":
      return t.scale.minStrokeWidth;
    case "text":
      return t.scale.minFontSize;
    case "point":
    case "square":
    case "circle":
      return t.scale.minSize;
  }
  throw new Error(incompatibleChannel("size", n));
}
const MAX_SIZE_RANGE_STEP_RATIO = 0.95;
function sizeRangeMax(n, t, g, d) {
  const k = {
    x: getBinStepSignal(g, "x"),
    y: getBinStepSignal(g, "y")
  };
  switch (n) {
    case "bar":
    case "tick": {
      if (d.scale.maxBandSize !== void 0)
        return d.scale.maxBandSize;
      const H = minXYStep(t, k, d.view);
      return isNumber$1(H) ? H - 1 : new SignalRefWrapper(() => `${H.signal} - 1`);
    }
    case "line":
    case "trail":
    case "rule":
      return d.scale.maxStrokeWidth;
    case "text":
      return d.scale.maxFontSize;
    case "point":
    case "square":
    case "circle": {
      if (d.scale.maxSize)
        return d.scale.maxSize;
      const H = minXYStep(t, k, d.view);
      return isNumber$1(H) ? Math.pow(MAX_SIZE_RANGE_STEP_RATIO * H, 2) : new SignalRefWrapper(() => `pow(${MAX_SIZE_RANGE_STEP_RATIO} * ${H.signal}, 2)`);
    }
  }
  throw new Error(incompatibleChannel("size", n));
}
function minXYStep(n, t, g) {
  const d = isStep(n.width) ? n.width.step : getViewConfigDiscreteStep(g, "width"), k = isStep(n.height) ? n.height.step : getViewConfigDiscreteStep(g, "height");
  return t.x || t.y ? new SignalRefWrapper(() => `min(${[
    t.x ? t.x.signal : d,
    t.y ? t.y.signal : k
  ].join(", ")})`) : Math.min(d, k);
}
function parseScaleProperty(n, t) {
  isUnitModel(n) ? parseUnitScaleProperty(n, t) : parseNonUnitScaleProperty(n, t);
}
function parseUnitScaleProperty(n, t) {
  const g = n.component.scales, { config: d, encoding: k, markDef: H, specifiedScales: AA } = n;
  for (const gA of keys$1(g)) {
    const IA = AA[gA], CA = g[gA], BA = n.getScaleComponent(gA), eA = getFieldOrDatumDef(k[gA]), iA = IA[t], QA = BA.get("type"), tA = BA.get("padding"), oA = BA.get("paddingInner"), EA = scaleTypeSupportProperty(QA, t), aA = channelScalePropertyIncompatability(gA, t);
    if (iA !== void 0 && (EA ? aA && warn(aA) : warn(scalePropertyNotWorkWithScaleType(QA, t, gA))), EA && aA === void 0)
      if (iA !== void 0) {
        const nA = eA.timeUnit, lA = eA.type;
        switch (t) {
          // domainMax/Min to signal if the value is a datetime object
          case "domainMax":
          case "domainMin":
            isDateTime(IA[t]) || lA === "temporal" || nA ? CA.set(t, { signal: valueExpr(IA[t], { type: lA, timeUnit: nA }) }, !0) : CA.set(t, IA[t], !0);
            break;
          default:
            CA.copyKeyFromObject(t, IA);
        }
      } else {
        const nA = hasProperty(scaleRules, t) ? scaleRules[t]({
          model: n,
          channel: gA,
          fieldOrDatumDef: eA,
          scaleType: QA,
          scalePadding: tA,
          scalePaddingInner: oA,
          domain: IA.domain,
          domainMin: IA.domainMin,
          domainMax: IA.domainMax,
          markDef: H,
          config: d,
          hasNestedOffsetScale: channelHasNestedOffsetScale(k, gA),
          hasSecondaryRangeChannel: !!k[getSecondaryRangeChannel(gA)]
        }) : d.scale[t];
        nA !== void 0 && CA.set(t, nA, !1);
      }
  }
}
const scaleRules = {
  bins: ({ model: n, fieldOrDatumDef: t }) => isFieldDef(t) ? bins(n, t) : void 0,
  interpolate: ({ channel: n, fieldOrDatumDef: t }) => interpolate(n, t.type),
  nice: ({ scaleType: n, channel: t, domain: g, domainMin: d, domainMax: k, fieldOrDatumDef: H }) => nice(n, t, g, d, k, H),
  padding: ({ channel: n, scaleType: t, fieldOrDatumDef: g, markDef: d, config: k }) => padding(n, t, k.scale, g, d, k.bar),
  paddingInner: ({ scalePadding: n, channel: t, markDef: g, scaleType: d, config: k, hasNestedOffsetScale: H }) => paddingInner(n, t, g.type, d, k.scale, H),
  paddingOuter: ({ scalePadding: n, channel: t, scaleType: g, scalePaddingInner: d, config: k, hasNestedOffsetScale: H }) => paddingOuter(n, t, g, d, k.scale, H),
  reverse: ({ fieldOrDatumDef: n, scaleType: t, channel: g, config: d }) => {
    const k = isFieldDef(n) ? n.sort : void 0;
    return reverse(t, k, g, d.scale);
  },
  zero: ({ channel: n, fieldOrDatumDef: t, domain: g, markDef: d, scaleType: k, config: H, hasSecondaryRangeChannel: AA }) => zero(n, t, g, d, k, H.scale, AA)
};
function parseScaleRange(n) {
  isUnitModel(n) ? parseUnitScaleRange(n) : parseNonUnitScaleProperty(n, "range");
}
function parseNonUnitScaleProperty(n, t) {
  const g = n.component.scales;
  for (const d of n.children)
    t === "range" ? parseScaleRange(d) : parseScaleProperty(d, t);
  for (const d of keys$1(g)) {
    let k;
    for (const H of n.children) {
      const AA = H.component.scales[d];
      if (AA) {
        const gA = AA.getWithExplicit(t);
        k = mergeValuesWithExplicit(k, gA, t, "scale", tieBreakByComparing((IA, CA) => {
          switch (t) {
            case "range":
              return IA.step && CA.step ? IA.step - CA.step : 0;
          }
          return 0;
        }));
      }
    }
    g[d].setWithExplicit(t, k);
  }
}
function bins(n, t) {
  const g = t.bin;
  if (isBinning(g)) {
    const d = getBinSignalName(n, t.field, g);
    return new SignalRefWrapper(() => n.getSignalName(d));
  } else if (isBinned(g) && isBinParams(g) && g.step !== void 0)
    return {
      step: g.step
    };
}
function interpolate(n, t) {
  if (contains([COLOR, FILL, STROKE], n) && t !== "nominal")
    return "hcl";
}
function nice(n, t, g, d, k, H) {
  if (!(getFieldDef(H)?.bin || isArray$2(g) || k != null || d != null || contains([ScaleType.TIME, ScaleType.UTC], n)))
    return isXorY(t) ? !0 : void 0;
}
function padding(n, t, g, d, k, H) {
  if (isXorY(n)) {
    if (isContinuousToContinuous(t)) {
      if (g.continuousPadding !== void 0)
        return g.continuousPadding;
      const { type: AA, orient: gA } = k;
      if (AA === "bar" && !(isFieldDef(d) && (d.bin || d.timeUnit)) && (gA === "vertical" && n === "x" || gA === "horizontal" && n === "y"))
        return H.continuousBandSize;
    }
    if (t === ScaleType.POINT)
      return g.pointPadding;
  }
}
function paddingInner(n, t, g, d, k, H = !1) {
  if (n === void 0) {
    if (isXorY(t)) {
      const { bandPaddingInner: AA, barBandPaddingInner: gA, rectBandPaddingInner: IA, tickBandPaddingInner: CA, bandWithNestedOffsetPaddingInner: BA } = k;
      return H ? BA : getFirstDefined(AA, g === "bar" ? gA : g === "tick" ? CA : IA);
    } else if (isXorYOffset(t) && d === ScaleType.BAND)
      return k.offsetBandPaddingInner;
  }
}
function paddingOuter(n, t, g, d, k, H = !1) {
  if (n === void 0) {
    if (isXorY(t)) {
      const { bandPaddingOuter: AA, bandWithNestedOffsetPaddingOuter: gA } = k;
      if (H)
        return gA;
      if (g === ScaleType.BAND)
        return getFirstDefined(
          AA,
          /* By default, paddingOuter is paddingInner / 2. The reason is that
            size (width/height) = step * (cardinality - paddingInner + 2 * paddingOuter).
            and we want the width/height to be integer by default.
            Note that step (by default) and cardinality are integers.) */
          isSignalRef(d) ? { signal: `${d.signal}/2` } : d / 2
        );
    } else if (isXorYOffset(t)) {
      if (g === ScaleType.POINT)
        return 0.5;
      if (g === ScaleType.BAND)
        return k.offsetBandPaddingOuter;
    }
  }
}
function reverse(n, t, g, d) {
  if (g === "x" && d.xReverse !== void 0)
    return hasContinuousDomain(n) && t === "descending" ? isSignalRef(d.xReverse) ? { signal: `!${d.xReverse.signal}` } : !d.xReverse : d.xReverse;
  if (hasContinuousDomain(n) && t === "descending")
    return !0;
}
function zero(n, t, g, d, k, H, AA) {
  if (!!g && g !== "unaggregated" && hasContinuousDomain(k)) {
    if (isArray$2(g)) {
      const IA = g[0], CA = g[g.length - 1];
      if (isNumber$1(IA) && IA <= 0 && isNumber$1(CA) && CA >= 0)
        return !0;
    }
    return !1;
  }
  if (n === "size" && t.type === "quantitative" && !isContinuousToDiscrete(k))
    return !0;
  if (!(isFieldDef(t) && t.bin) && contains([...POSITION_SCALE_CHANNELS, ...POLAR_POSITION_SCALE_CHANNELS], n)) {
    const { orient: IA, type: CA } = d;
    return contains(["bar", "area", "line", "trail"], CA) && (IA === "horizontal" && n === "y" || IA === "vertical" && n === "x") ? !1 : contains(["bar", "area"], CA) && !AA ? !0 : H?.zero;
  }
  return !1;
}
function scaleType(n, t, g, d, k = !1) {
  const H = defaultType(t, g, d, k), { type: AA } = n;
  return isScaleChannel(t) ? AA !== void 0 ? channelSupportScaleType(t, AA) ? isFieldDef(g) && !scaleTypeSupportDataType(AA, g.type) ? (warn(scaleTypeNotWorkWithFieldDef(AA, H)), H) : AA : (warn(scaleTypeNotWorkWithChannel(t, AA, H)), H) : H : null;
}
function defaultType(n, t, g, d) {
  switch (t.type) {
    case "nominal":
    case "ordinal": {
      if (isColorChannel(n) || rangeType(n) === "discrete")
        return n === "shape" && t.type === "ordinal" && warn(discreteChannelCannotEncode(n, "ordinal")), "ordinal";
      if (isTime(n))
        return "band";
      if (isXorY(n) || isXorYOffset(n)) {
        if (contains(["rect", "bar", "image", "rule", "tick"], g.type) || d)
          return "band";
      } else if (g.type === "arc" && n in POLAR_POSITION_SCALE_CHANNEL_INDEX)
        return "band";
      const k = g[getSizeChannel(n)];
      return isRelativeBandSize(k) || isPositionFieldOrDatumDef(t) && t.axis?.tickBand ? "band" : "point";
    }
    case "temporal":
      return isColorChannel(n) ? "time" : rangeType(n) === "discrete" ? (warn(discreteChannelCannotEncode(n, "temporal")), "ordinal") : isFieldDef(t) && t.timeUnit && normalizeTimeUnit(t.timeUnit).utc ? "utc" : isTime(n) ? "band" : "time";
    case "quantitative":
      return isColorChannel(n) ? isFieldDef(t) && isBinning(t.bin) ? "bin-ordinal" : "linear" : rangeType(n) === "discrete" ? (warn(discreteChannelCannotEncode(n, "quantitative")), "ordinal") : isTime(n) ? "band" : "linear";
    case "geojson":
      return;
  }
  throw new Error(invalidFieldType(t.type));
}
function parseScales(n, { ignoreRange: t } = {}) {
  parseScaleCore(n), parseScaleDomain(n);
  for (const g of NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTIES)
    parseScaleProperty(n, g);
  t || parseScaleRange(n);
}
function parseScaleCore(n) {
  isUnitModel(n) ? n.component.scales = parseUnitScaleCore(n) : n.component.scales = parseNonUnitScaleCore(n);
}
function parseUnitScaleCore(n) {
  const { encoding: t, mark: g, markDef: d } = n, k = {};
  for (const H of SCALE_CHANNELS) {
    const AA = getFieldOrDatumDef(t[H]);
    if (AA && g === GEOSHAPE && H === SHAPE && AA.type === GEOJSON)
      continue;
    let gA = AA && AA.scale;
    if (AA && gA !== null && gA !== !1) {
      gA ??= {};
      const IA = channelHasNestedOffsetScale(t, H), CA = scaleType(gA, H, AA, d, IA);
      k[H] = new ScaleComponent(n.scaleName(`${H}`, !0), {
        value: CA,
        explicit: gA.type === CA
      });
    }
  }
  return k;
}
const scaleTypeTieBreaker = tieBreakByComparing((n, t) => scaleTypePrecedence(n) - scaleTypePrecedence(t));
function parseNonUnitScaleCore(n) {
  const t = n.component.scales = {}, g = {}, d = n.component.resolve;
  for (const k of n.children) {
    parseScaleCore(k);
    for (const H of keys$1(k.component.scales))
      if (d.scale[H] ??= defaultScaleResolve(H, n), d.scale[H] === "shared") {
        const AA = g[H], gA = k.component.scales[H].getWithExplicit("type");
        AA ? scaleCompatible(AA.value, gA.value) ? g[H] = mergeValuesWithExplicit(AA, gA, "type", "scale", scaleTypeTieBreaker) : (d.scale[H] = "independent", delete g[H]) : g[H] = gA;
      }
  }
  for (const k of keys$1(g)) {
    const H = n.scaleName(k, !0), AA = g[k];
    t[k] = new ScaleComponent(H, AA);
    for (const gA of n.children) {
      const IA = gA.component.scales[k];
      IA && (gA.renameScale(IA.get("name"), H), IA.merged = !0);
    }
  }
  return t;
}
class NameMap {
  nameMap;
  constructor() {
    this.nameMap = {};
  }
  rename(t, g) {
    this.nameMap[t] = g;
  }
  has(t) {
    return this.nameMap[t] !== void 0;
  }
  get(t) {
    for (; this.nameMap[t] && t !== this.nameMap[t]; )
      t = this.nameMap[t];
    return t;
  }
}
function isUnitModel(n) {
  return n?.type === "unit";
}
function isFacetModel(n) {
  return n?.type === "facet";
}
function isConcatModel(n) {
  return n?.type === "concat";
}
function isLayerModel(n) {
  return n?.type === "layer";
}
class Model {
  type;
  parent;
  config;
  name;
  size;
  title;
  description;
  data;
  transforms;
  layout;
  /** Name map for scales, which can be renamed by a model's parent. */
  scaleNameMap;
  /** Name map for projections, which can be renamed by a model's parent. */
  projectionNameMap;
  /** Name map for signals, which can be renamed by a model's parent. */
  signalNameMap;
  component;
  view;
  constructor(t, g, d, k, H, AA, gA) {
    this.type = g, this.parent = d, this.config = H, this.parent = d, this.config = H, this.view = replaceExprRef(gA), this.name = t.name ?? k, this.title = isText(t.title) ? { text: t.title } : t.title ? replaceExprRef(t.title) : void 0, this.scaleNameMap = d ? d.scaleNameMap : new NameMap(), this.projectionNameMap = d ? d.projectionNameMap : new NameMap(), this.signalNameMap = d ? d.signalNameMap : new NameMap(), this.data = t.data, this.description = t.description, this.transforms = normalizeTransform(t.transform ?? []), this.layout = g === "layer" || g === "unit" ? {} : extractCompositionLayout(t, g, H), this.component = {
      data: {
        sources: d ? d.component.data.sources : [],
        outputNodes: d ? d.component.data.outputNodes : {},
        outputNodeRefCounts: d ? d.component.data.outputNodeRefCounts : {},
        // data is faceted if the spec is a facet spec or the parent has faceted data and data is undefined
        isFaceted: isFacetSpec(t) || d?.component.data.isFaceted && t.data === void 0
      },
      layoutSize: new Split(),
      layoutHeaders: { row: {}, column: {}, facet: {} },
      mark: null,
      resolve: {
        scale: {},
        axis: {},
        legend: {},
        ...AA ? duplicate(AA) : {}
      },
      selection: null,
      scales: null,
      projection: null,
      axes: {},
      legends: {}
    };
  }
  get width() {
    return this.getSizeSignalRef("width");
  }
  get height() {
    return this.getSizeSignalRef("height");
  }
  parse() {
    this.parseScale(), this.parseLayoutSize(), this.renameTopLevelLayoutSizeSignal(), this.parseSelections(), this.parseProjection(), this.parseData(), this.parseAxesAndHeaders(), this.parseLegends(), this.parseMarkGroup();
  }
  parseScale() {
    parseScales(this);
  }
  parseProjection() {
    parseProjection(this);
  }
  /**
   * Rename top-level spec's size to be just width / height, ignoring model name.
   * This essentially merges the top-level spec's width/height signals with the width/height signals
   * to help us reduce redundant signals declaration.
   */
  renameTopLevelLayoutSizeSignal() {
    this.getName("width") !== "width" && this.renameSignal(this.getName("width"), "width"), this.getName("height") !== "height" && this.renameSignal(this.getName("height"), "height");
  }
  parseLegends() {
    parseLegend(this);
  }
  assembleEncodeFromView(t) {
    const { style: g, ...d } = t, k = {};
    for (const H of keys$1(d)) {
      const AA = d[H];
      AA !== void 0 && (k[H] = signalOrValueRef(AA));
    }
    return k;
  }
  assembleGroupEncodeEntry(t) {
    let g = {};
    return this.view && (g = this.assembleEncodeFromView(this.view)), !t && (this.description && (g.description = signalOrValueRef(this.description)), this.type === "unit" || this.type === "layer") ? {
      width: this.getSizeSignalRef("width"),
      height: this.getSizeSignalRef("height"),
      ...g
    } : isEmpty(g) ? void 0 : g;
  }
  assembleLayout() {
    if (!this.layout)
      return;
    const { spacing: t, ...g } = this.layout, { component: d, config: k } = this, H = assembleLayoutTitleBand(d.layoutHeaders, k);
    return {
      padding: t,
      ...this.assembleDefaultLayout(),
      ...g,
      ...H ? { titleBand: H } : {}
    };
  }
  assembleDefaultLayout() {
    return {};
  }
  assembleHeaderMarks() {
    const { layoutHeaders: t } = this.component;
    let g = [];
    for (const d of FACET_CHANNELS)
      t[d].title && g.push(assembleTitleGroup(this, d));
    for (const d of HEADER_CHANNELS)
      g = g.concat(assembleHeaderGroups(this, d));
    return g;
  }
  assembleAxes() {
    return assembleAxes(this.component.axes, this.config);
  }
  assembleLegends() {
    return assembleLegends(this);
  }
  assembleProjections() {
    return assembleProjections(this);
  }
  assembleTitle() {
    const { encoding: t, ...g } = this.title ?? {}, d = {
      ...extractTitleConfig(this.config.title).nonMarkTitleProperties,
      ...g,
      ...t ? { encode: { update: t } } : {}
    };
    if (d.text)
      return contains(["unit", "layer"], this.type) ? contains(["middle", void 0], d.anchor) && (d.frame ??= "group") : d.anchor ??= "start", isEmpty(d) ? void 0 : d;
  }
  /**
   * Assemble the mark group for this model. We accept optional `signals` so that we can include concat top-level signals with the top-level model's local signals.
   */
  assembleGroup(t = []) {
    const g = {};
    t = t.concat(this.assembleSignals()), t.length > 0 && (g.signals = t);
    const d = this.assembleLayout();
    d && (g.layout = d), g.marks = [].concat(this.assembleHeaderMarks(), this.assembleMarks());
    const k = !this.parent || isFacetModel(this.parent) ? assembleScales(this) : [];
    k.length > 0 && (g.scales = k);
    const H = this.assembleAxes();
    H.length > 0 && (g.axes = H);
    const AA = this.assembleLegends();
    return AA.length > 0 && (g.legends = AA), g;
  }
  getName(t) {
    return varName((this.name ? `${this.name}_` : "") + t);
  }
  getDataName(t) {
    return this.getName(DataSourceType[t].toLowerCase());
  }
  /**
   * Request a data source name for the given data source type and mark that data source as required.
   * This method should be called in parse, so that all used data source can be correctly instantiated in assembleData().
   * You can lookup the correct dataset name in assemble with `lookupDataSource`.
   */
  requestDataName(t) {
    const g = this.getDataName(t), d = this.component.data.outputNodeRefCounts;
    return d[g] = (d[g] || 0) + 1, g;
  }
  getSizeSignalRef(t) {
    if (isFacetModel(this.parent)) {
      const g = getSizeTypeFromLayoutSizeType(t), d = getPositionScaleChannel(g), k = this.component.scales[d];
      if (k && !k.merged) {
        const H = k.get("type"), AA = k.get("range");
        if (hasDiscreteDomain(H) && isVgRangeStep(AA)) {
          const gA = k.get("name"), IA = assembleDomain(this, d), CA = getFieldFromDomain(IA);
          if (CA) {
            const BA = vgField({ aggregate: "distinct", field: CA }, { expr: "datum" });
            return {
              signal: sizeExpr(gA, k, BA)
            };
          } else
            return warn(unknownField(d)), null;
        }
      }
    }
    return {
      signal: this.signalNameMap.get(this.getName(t))
    };
  }
  /**
   * Lookup the name of the datasource for an output node. You probably want to call this in assemble.
   */
  lookupDataSource(t) {
    const g = this.component.data.outputNodes[t];
    return g ? g.getSource() : t;
  }
  getSignalName(t) {
    return this.signalNameMap.get(t);
  }
  renameSignal(t, g) {
    this.signalNameMap.rename(t, g);
  }
  renameScale(t, g) {
    this.scaleNameMap.rename(t, g);
  }
  renameProjection(t, g) {
    this.projectionNameMap.rename(t, g);
  }
  /**
   * @return scale name for a given channel after the scale has been parsed and named.
   */
  scaleName(t, g) {
    if (g)
      return this.getName(t);
    if (
      // If there is a scale for the channel, there should be a local scale component for it
      isChannel(t) && isScaleChannel(t) && this.component.scales[t] || // in the scale name map (the scale get merged by its parent)
      this.scaleNameMap.has(this.getName(t))
    )
      return this.scaleNameMap.get(this.getName(t));
  }
  /**
   * @return projection name after the projection has been parsed and named.
   */
  projectionName(t) {
    if (t)
      return this.getName("projection");
    if (this.component.projection && !this.component.projection.merged || this.projectionNameMap.has(this.getName("projection")))
      return this.projectionNameMap.get(this.getName("projection"));
  }
  /**
   * Traverse a model's hierarchy to get the scale component for a particular channel.
   */
  getScaleComponent(t) {
    if (!this.component.scales)
      throw new Error("getScaleComponent cannot be called before parseScale(). Make sure you have called parseScale or use parseUnitModelWithScale().");
    const g = this.component.scales[t];
    return g && !g.merged ? g : this.parent ? this.parent.getScaleComponent(t) : void 0;
  }
  getScaleType(t) {
    const g = this.getScaleComponent(t);
    return g ? g.get("type") : void 0;
  }
  /**
   * Traverse a model's hierarchy to get a particular selection component.
   */
  getSelectionComponent(t, g) {
    let d = this.component.selection[t];
    if (!d && this.parent && (d = this.parent.getSelectionComponent(t, g)), !d)
      throw new Error(selectionNotFound(g));
    return d;
  }
  /**
   * Returns true if the model has a signalRef for an axis orient.
   */
  hasAxisOrientSignalRef() {
    return this.component.axes.x?.some((t) => t.hasOrientSignalRef()) || this.component.axes.y?.some((t) => t.hasOrientSignalRef());
  }
}
class ModelWithField extends Model {
  /** Get "field" reference for Vega */
  vgField(t, g = {}) {
    const d = this.fieldDef(t);
    if (d)
      return vgField(d, g);
  }
  reduceFieldDef(t, g) {
    return reduce(this.getMapping(), (d, k, H) => {
      const AA = getFieldDef(k);
      return AA ? t(d, AA, H) : d;
    }, g);
  }
  forEachFieldDef(t, g) {
    forEach$2(this.getMapping(), (d, k) => {
      const H = getFieldDef(d);
      H && t(H, k);
    }, g);
  }
}
class DensityTransformNode extends DataFlowNode {
  transform;
  clone() {
    return new DensityTransformNode(null, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g, this.transform = duplicate(g);
    const d = this.transform.as ?? [void 0, void 0];
    this.transform.as = [d[0] ?? "value", d[1] ?? "density"];
    const k = this.transform.resolve ?? "shared";
    this.transform.resolve = k;
  }
  dependentFields() {
    return /* @__PURE__ */ new Set([this.transform.density, ...this.transform.groupby ?? []]);
  }
  producedFields() {
    return new Set(this.transform.as);
  }
  hash() {
    return `DensityTransform ${hash(this.transform)}`;
  }
  assemble() {
    const { density: t, ...g } = this.transform, d = {
      type: "kde",
      field: t,
      ...g
    };
    return d.resolve = this.transform.resolve, d;
  }
}
class ExtentTransformNode extends DataFlowNode {
  transform;
  clone() {
    return new ExtentTransformNode(null, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g, this.transform = duplicate(g);
  }
  dependentFields() {
    return /* @__PURE__ */ new Set([this.transform.extent]);
  }
  producedFields() {
    return /* @__PURE__ */ new Set([]);
  }
  hash() {
    return `ExtentTransform ${hash(this.transform)}`;
  }
  assemble() {
    const { extent: t, param: g } = this.transform;
    return {
      type: "extent",
      field: t,
      signal: g
    };
  }
}
class FlattenTransformNode extends DataFlowNode {
  transform;
  clone() {
    return new FlattenTransformNode(this.parent, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g, this.transform = duplicate(g);
    const { flatten: d, as: k = [] } = this.transform;
    this.transform.as = d.map((H, AA) => k[AA] ?? H);
  }
  dependentFields() {
    return new Set(this.transform.flatten);
  }
  producedFields() {
    return new Set(this.transform.as);
  }
  hash() {
    return `FlattenTransform ${hash(this.transform)}`;
  }
  assemble() {
    const { flatten: t, as: g } = this.transform;
    return {
      type: "flatten",
      fields: t,
      as: g
    };
  }
}
class FoldTransformNode extends DataFlowNode {
  transform;
  clone() {
    return new FoldTransformNode(null, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g, this.transform = duplicate(g);
    const d = this.transform.as ?? [void 0, void 0];
    this.transform.as = [d[0] ?? "key", d[1] ?? "value"];
  }
  dependentFields() {
    return new Set(this.transform.fold);
  }
  producedFields() {
    return new Set(this.transform.as);
  }
  hash() {
    return `FoldTransform ${hash(this.transform)}`;
  }
  assemble() {
    const { fold: t, as: g } = this.transform;
    return {
      type: "fold",
      fields: t,
      as: g
    };
  }
}
class GeoJSONNode extends DataFlowNode {
  fields;
  geojson;
  signal;
  clone() {
    return new GeoJSONNode(null, duplicate(this.fields), this.geojson, this.signal);
  }
  static parseAll(t, g) {
    if (g.component.projection && !g.component.projection.isFit)
      return t;
    let d = 0;
    for (const k of [
      [LONGITUDE, LATITUDE],
      [LONGITUDE2, LATITUDE2]
    ]) {
      const H = k.map((AA) => {
        const gA = getFieldOrDatumDef(g.encoding[AA]);
        return isFieldDef(gA) ? gA.field : isDatumDef(gA) ? { expr: `${gA.datum}` } : isValueDef(gA) ? { expr: `${gA.value}` } : void 0;
      });
      (H[0] || H[1]) && (t = new GeoJSONNode(t, H, null, g.getName(`geojson_${d++}`)));
    }
    if (g.channelHasField(SHAPE)) {
      const k = g.typedFieldDef(SHAPE);
      k.type === GEOJSON && (t = new GeoJSONNode(t, null, k.field, g.getName(`geojson_${d++}`)));
    }
    return t;
  }
  constructor(t, g, d, k) {
    super(t), this.fields = g, this.geojson = d, this.signal = k;
  }
  dependentFields() {
    const t = (this.fields ?? []).filter(isString$1);
    return /* @__PURE__ */ new Set([...this.geojson ? [this.geojson] : [], ...t]);
  }
  producedFields() {
    return /* @__PURE__ */ new Set();
  }
  hash() {
    return `GeoJSON ${this.geojson} ${this.signal} ${hash(this.fields)}`;
  }
  assemble() {
    return [
      ...this.geojson ? [
        {
          type: "filter",
          expr: `isValid(datum["${this.geojson}"])`
        }
      ] : [],
      {
        type: "geojson",
        ...this.fields ? { fields: this.fields } : {},
        ...this.geojson ? { geojson: this.geojson } : {},
        signal: this.signal
      }
    ];
  }
}
class GeoPointNode extends DataFlowNode {
  projection;
  fields;
  as;
  clone() {
    return new GeoPointNode(null, this.projection, duplicate(this.fields), duplicate(this.as));
  }
  constructor(t, g, d, k) {
    super(t), this.projection = g, this.fields = d, this.as = k;
  }
  static parseAll(t, g) {
    if (!g.projectionName())
      return t;
    for (const d of [
      [LONGITUDE, LATITUDE],
      [LONGITUDE2, LATITUDE2]
    ]) {
      const k = d.map((AA) => {
        const gA = getFieldOrDatumDef(g.encoding[AA]);
        return isFieldDef(gA) ? gA.field : isDatumDef(gA) ? { expr: `${gA.datum}` } : isValueDef(gA) ? { expr: `${gA.value}` } : void 0;
      }), H = d[0] === LONGITUDE2 ? "2" : "";
      (k[0] || k[1]) && (t = new GeoPointNode(t, g.projectionName(), k, [
        g.getName(`x${H}`),
        g.getName(`y${H}`)
      ]));
    }
    return t;
  }
  dependentFields() {
    return new Set(this.fields.filter(isString$1));
  }
  producedFields() {
    return new Set(this.as);
  }
  hash() {
    return `Geopoint ${this.projection} ${hash(this.fields)} ${hash(this.as)}`;
  }
  assemble() {
    return {
      type: "geopoint",
      projection: this.projection,
      fields: this.fields,
      as: this.as
    };
  }
}
class ImputeNode extends DataFlowNode {
  transform;
  clone() {
    return new ImputeNode(null, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g;
  }
  dependentFields() {
    return /* @__PURE__ */ new Set([this.transform.impute, this.transform.key, ...this.transform.groupby ?? []]);
  }
  producedFields() {
    return /* @__PURE__ */ new Set([this.transform.impute]);
  }
  processSequence(t) {
    const { start: g = 0, stop: d, step: k } = t;
    return { signal: `sequence(${[g, d, ...k ? [k] : []].join(",")})` };
  }
  static makeFromTransform(t, g) {
    return new ImputeNode(t, g);
  }
  static makeFromEncoding(t, g) {
    const d = g.encoding, k = d.x, H = d.y;
    if (isFieldDef(k) && isFieldDef(H)) {
      const AA = k.impute ? k : H.impute ? H : void 0;
      if (AA === void 0)
        return;
      const gA = k.impute ? H : H.impute ? k : void 0, { method: IA, value: CA, frame: BA, keyvals: eA } = AA.impute, iA = pathGroupingFields(g.mark, d);
      return new ImputeNode(t, {
        impute: AA.field,
        key: gA.field,
        ...IA ? { method: IA } : {},
        ...CA !== void 0 ? { value: CA } : {},
        ...BA ? { frame: BA } : {},
        ...eA !== void 0 ? { keyvals: eA } : {},
        ...iA.length ? { groupby: iA } : {}
      });
    }
    return null;
  }
  hash() {
    return `Impute ${hash(this.transform)}`;
  }
  assemble() {
    const { impute: t, key: g, keyvals: d, method: k, groupby: H, value: AA, frame: gA = [null, null] } = this.transform, IA = {
      type: "impute",
      field: t,
      key: g,
      ...d ? { keyvals: isImputeSequence(d) ? this.processSequence(d) : d } : {},
      method: "value",
      ...H ? { groupby: H } : {},
      value: !k || k === "value" ? AA : null
    };
    if (k && k !== "value") {
      const CA = {
        type: "window",
        as: [`imputed_${t}_value`],
        ops: [k],
        fields: [t],
        frame: gA,
        ignorePeers: !1,
        ...H ? { groupby: H } : {}
      }, BA = {
        type: "formula",
        expr: `datum.${t} === null ? datum.imputed_${t}_value : datum.${t}`,
        as: t
      };
      return [IA, CA, BA];
    } else
      return [IA];
  }
}
class LoessTransformNode extends DataFlowNode {
  transform;
  clone() {
    return new LoessTransformNode(null, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g, this.transform = duplicate(g);
    const d = this.transform.as ?? [void 0, void 0];
    this.transform.as = [d[0] ?? g.on, d[1] ?? g.loess];
  }
  dependentFields() {
    return /* @__PURE__ */ new Set([this.transform.loess, this.transform.on, ...this.transform.groupby ?? []]);
  }
  producedFields() {
    return new Set(this.transform.as);
  }
  hash() {
    return `LoessTransform ${hash(this.transform)}`;
  }
  assemble() {
    const { loess: t, on: g, ...d } = this.transform;
    return {
      type: "loess",
      x: g,
      y: t,
      ...d
    };
  }
}
class LookupNode extends DataFlowNode {
  transform;
  secondary;
  clone() {
    return new LookupNode(null, duplicate(this.transform), this.secondary);
  }
  constructor(t, g, d) {
    super(t), this.transform = g, this.secondary = d;
  }
  static make(t, g, d, k) {
    const H = g.component.data.sources, { from: AA } = d;
    let gA = null;
    if (isLookupData(AA)) {
      let IA = findSource(AA.data, H);
      IA || (IA = new SourceNode(AA.data), H.push(IA));
      const CA = g.getName(`lookup_${k}`);
      gA = new OutputNode(IA, CA, DataSourceType.Lookup, g.component.data.outputNodeRefCounts), g.component.data.outputNodes[CA] = gA;
    } else if (isLookupSelection(AA)) {
      const IA = AA.param;
      d = { as: IA, ...d };
      let CA;
      try {
        CA = g.getSelectionComponent(varName(IA), IA);
      } catch {
        throw new Error(cannotLookupVariableParameter(IA));
      }
      if (gA = CA.materialized, !gA)
        throw new Error(noSameUnitLookup(IA));
    }
    return new LookupNode(t, d, gA.getSource());
  }
  dependentFields() {
    return /* @__PURE__ */ new Set([this.transform.lookup]);
  }
  producedFields() {
    return new Set(this.transform.as ? array(this.transform.as) : this.transform.from.fields);
  }
  hash() {
    return `Lookup ${hash({ transform: this.transform, secondary: this.secondary })}`;
  }
  assemble() {
    let t;
    if (this.transform.from.fields)
      t = {
        values: this.transform.from.fields,
        ...this.transform.as ? { as: array(this.transform.as) } : {}
      };
    else {
      let g = this.transform.as;
      isString$1(g) || (warn(NO_FIELDS_NEEDS_AS), g = "_lookup"), t = {
        as: [g]
      };
    }
    return {
      type: "lookup",
      from: this.secondary,
      key: this.transform.from.key,
      fields: [this.transform.lookup],
      ...t,
      ...this.transform.default ? { default: this.transform.default } : {}
    };
  }
}
class QuantileTransformNode extends DataFlowNode {
  transform;
  clone() {
    return new QuantileTransformNode(null, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g, this.transform = duplicate(g);
    const d = this.transform.as ?? [void 0, void 0];
    this.transform.as = [d[0] ?? "prob", d[1] ?? "value"];
  }
  dependentFields() {
    return /* @__PURE__ */ new Set([this.transform.quantile, ...this.transform.groupby ?? []]);
  }
  producedFields() {
    return new Set(this.transform.as);
  }
  hash() {
    return `QuantileTransform ${hash(this.transform)}`;
  }
  assemble() {
    const { quantile: t, ...g } = this.transform;
    return {
      type: "quantile",
      field: t,
      ...g
    };
  }
}
class RegressionTransformNode extends DataFlowNode {
  transform;
  clone() {
    return new RegressionTransformNode(null, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g, this.transform = duplicate(g);
    const d = this.transform.as ?? [void 0, void 0];
    this.transform.as = [d[0] ?? g.on, d[1] ?? g.regression];
  }
  dependentFields() {
    return /* @__PURE__ */ new Set([this.transform.regression, this.transform.on, ...this.transform.groupby ?? []]);
  }
  producedFields() {
    return new Set(this.transform.as);
  }
  hash() {
    return `RegressionTransform ${hash(this.transform)}`;
  }
  assemble() {
    const { regression: t, on: g, ...d } = this.transform;
    return {
      type: "regression",
      x: g,
      y: t,
      ...d
    };
  }
}
class PivotTransformNode extends DataFlowNode {
  transform;
  clone() {
    return new PivotTransformNode(null, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g;
  }
  addDimensions(t) {
    this.transform.groupby = unique((this.transform.groupby ?? []).concat(t), (g) => g);
  }
  producedFields() {
  }
  dependentFields() {
    return /* @__PURE__ */ new Set([this.transform.pivot, this.transform.value, ...this.transform.groupby ?? []]);
  }
  hash() {
    return `PivotTransform ${hash(this.transform)}`;
  }
  assemble() {
    const { pivot: t, value: g, groupby: d, limit: k, op: H } = this.transform;
    return {
      type: "pivot",
      field: t,
      value: g,
      ...k !== void 0 ? { limit: k } : {},
      ...H !== void 0 ? { op: H } : {},
      ...d !== void 0 ? { groupby: d } : {}
    };
  }
}
class SampleTransformNode extends DataFlowNode {
  transform;
  clone() {
    return new SampleTransformNode(null, duplicate(this.transform));
  }
  constructor(t, g) {
    super(t), this.transform = g;
  }
  dependentFields() {
    return /* @__PURE__ */ new Set();
  }
  producedFields() {
    return /* @__PURE__ */ new Set();
  }
  hash() {
    return `SampleTransform ${hash(this.transform)}`;
  }
  assemble() {
    return {
      type: "sample",
      size: this.transform.sample
    };
  }
}
function makeWalkTree(n) {
  let t = 0;
  function g(d, k) {
    if (d instanceof SourceNode && !d.isGenerator && !isUrlData(d.data) && (n.push(k), k = {
      name: null,
      source: k.name,
      transform: []
    }), d instanceof ParseNode && (d.parent instanceof SourceNode && !k.source ? (k.format = {
      ...k.format,
      parse: d.assembleFormatParse()
    }, k.transform.push(...d.assembleTransforms(!0))) : k.transform.push(...d.assembleTransforms())), d instanceof FacetNode) {
      k.name || (k.name = `data_${t++}`), !k.source || k.transform.length > 0 ? (n.push(k), d.data = k.name) : d.data = k.source, n.push(...d.assemble());
      return;
    }
    switch ((d instanceof GraticuleNode || d instanceof SequenceNode || d instanceof FilterInvalidNode || d instanceof FilterNode || d instanceof CalculateNode || d instanceof GeoPointNode || d instanceof AggregateNode || d instanceof LookupNode || d instanceof WindowTransformNode || d instanceof JoinAggregateTransformNode || d instanceof FoldTransformNode || d instanceof FlattenTransformNode || d instanceof DensityTransformNode || d instanceof LoessTransformNode || d instanceof QuantileTransformNode || d instanceof RegressionTransformNode || d instanceof IdentifierNode || d instanceof SampleTransformNode || d instanceof PivotTransformNode || d instanceof ExtentTransformNode) && k.transform.push(d.assemble()), (d instanceof BinNode || d instanceof TimeUnitNode || d instanceof ImputeNode || d instanceof StackNode || d instanceof GeoJSONNode) && k.transform.push(...d.assemble()), d instanceof OutputNode && (k.source && k.transform.length === 0 ? d.setSource(k.source) : d.parent instanceof OutputNode ? d.setSource(k.name) : (k.name || (k.name = `data_${t++}`), d.setSource(k.name), d.numChildren() === 1 && (n.push(k), k = {
      name: null,
      source: k.name,
      transform: []
    }))), d.numChildren()) {
      case 0:
        d instanceof OutputNode && (!k.source || k.transform.length > 0) && n.push(k);
        break;
      case 1:
        g(d.children[0], k);
        break;
      default: {
        k.name || (k.name = `data_${t++}`);
        let H = k.name;
        !k.source || k.transform.length > 0 ? n.push(k) : H = k.source;
        for (const AA of d.children)
          g(AA, {
            name: null,
            source: H,
            transform: []
          });
        break;
      }
    }
  }
  return g;
}
function assembleFacetData(n) {
  const t = [], g = makeWalkTree(t);
  for (const d of n.children)
    g(d, {
      source: n.name,
      name: null,
      transform: []
    });
  return t;
}
function assembleRootData(n, t) {
  const g = [], d = makeWalkTree(g);
  let k = 0;
  for (const AA of n.sources) {
    AA.hasName() || (AA.dataName = `source_${k++}`);
    const gA = AA.assemble();
    d(AA, gA);
  }
  for (const AA of g)
    AA.transform.length === 0 && delete AA.transform;
  let H = 0;
  for (const [AA, gA] of g.entries())
    (gA.transform ?? []).length === 0 && !gA.source && g.splice(H++, 0, g.splice(AA, 1)[0]);
  for (const AA of g)
    for (const gA of AA.transform ?? [])
      gA.type === "lookup" && (gA.from = n.outputNodes[gA.from].getSource());
  for (const AA of g)
    AA.name in t && (AA.values = t[AA.name]);
  return g;
}
function getHeaderType(n) {
  return n === "top" || n === "left" || isSignalRef(n) ? "header" : "footer";
}
function parseFacetHeaders(n) {
  for (const t of FACET_CHANNELS)
    parseFacetHeader(n, t);
  mergeChildAxis(n, "x"), mergeChildAxis(n, "y");
}
function parseFacetHeader(n, t) {
  const { facet: g, config: d, child: k, component: H } = n;
  if (n.channelHasField(t)) {
    const AA = g[t], gA = getHeaderProperty("title", null, d, t);
    let IA = title(AA, d, {
      allowDisabling: !0,
      includeDefault: gA === void 0 || !!gA
    });
    k.component.layoutHeaders[t].title && (IA = isArray$2(IA) ? IA.join(", ") : IA, IA += ` / ${k.component.layoutHeaders[t].title}`, k.component.layoutHeaders[t].title = null);
    const CA = getHeaderProperty("labelOrient", AA.header, d, t), BA = AA.header !== null ? getFirstDefined(AA.header?.labels, d.header.labels, !0) : !1, eA = contains(["bottom", "right"], CA) ? "footer" : "header";
    H.layoutHeaders[t] = {
      title: AA.header !== null ? IA : null,
      facetFieldDef: AA,
      [eA]: t === "facet" ? [] : [makeHeaderComponent(n, t, BA)]
    };
  }
}
function makeHeaderComponent(n, t, g) {
  const d = t === "row" ? "height" : "width";
  return {
    labels: g,
    sizeSignal: n.child.component.layoutSize.get(d) ? n.child.getSizeSignalRef(d) : void 0,
    axes: []
  };
}
function mergeChildAxis(n, t) {
  const { child: g } = n;
  if (g.component.axes[t]) {
    const { layoutHeaders: d, resolve: k } = n.component;
    if (k.axis[t] = parseGuideResolve(k, t), k.axis[t] === "shared") {
      const H = t === "x" ? "column" : "row", AA = d[H];
      for (const gA of g.component.axes[t]) {
        const IA = getHeaderType(gA.get("orient"));
        AA[IA] ??= [makeHeaderComponent(n, H, !1)];
        const CA = assembleAxis(gA, "main", n.config, { header: !0 });
        CA && AA[IA][0].axes.push(CA), gA.mainExtracted = !0;
      }
    }
  }
}
function parseLayerLayoutSize(n) {
  parseChildrenLayoutSize(n), parseNonUnitLayoutSizeForChannel(n, "width"), parseNonUnitLayoutSizeForChannel(n, "height");
}
function parseConcatLayoutSize(n) {
  parseChildrenLayoutSize(n);
  const t = n.layout.columns === 1 ? "width" : "childWidth", g = n.layout.columns === void 0 ? "height" : "childHeight";
  parseNonUnitLayoutSizeForChannel(n, t), parseNonUnitLayoutSizeForChannel(n, g);
}
function parseChildrenLayoutSize(n) {
  for (const t of n.children)
    t.parseLayoutSize();
}
function parseNonUnitLayoutSizeForChannel(n, t) {
  const g = getSizeTypeFromLayoutSizeType(t), d = getPositionScaleChannel(g), k = n.component.resolve, H = n.component.layoutSize;
  let AA;
  for (const gA of n.children) {
    const IA = gA.component.layoutSize.getWithExplicit(g), CA = k.scale[d] ?? defaultScaleResolve(d, n);
    if (CA === "independent" && IA.value === "step") {
      AA = void 0;
      break;
    }
    if (AA) {
      if (CA === "independent" && AA.value !== IA.value) {
        AA = void 0;
        break;
      }
      AA = mergeValuesWithExplicit(AA, IA, g, "");
    } else
      AA = IA;
  }
  if (AA) {
    for (const gA of n.children)
      n.renameSignal(gA.getName(g), n.getName(t)), gA.component.layoutSize.set(g, "merged", !1);
    H.setWithExplicit(t, AA);
  } else
    H.setWithExplicit(t, {
      explicit: !1,
      value: void 0
    });
}
function parseUnitLayoutSize(n) {
  const { size: t, component: g } = n;
  for (const d of POSITION_SCALE_CHANNELS) {
    const k = getSizeChannel(d);
    if (t[k]) {
      const H = t[k];
      g.layoutSize.set(k, isStep(H) ? "step" : H, !0);
    } else {
      const H = defaultUnitSize(n, k);
      g.layoutSize.set(k, H, !1);
    }
  }
}
function defaultUnitSize(n, t) {
  const g = t === "width" ? "x" : "y", d = n.config, k = n.getScaleComponent(g);
  if (k) {
    const H = k.get("type"), AA = k.get("range");
    if (hasDiscreteDomain(H)) {
      const gA = getViewConfigDiscreteSize(d.view, t);
      return isVgRangeStep(AA) || isStep(gA) ? "step" : gA;
    } else
      return getViewConfigContinuousSize(d.view, t);
  } else {
    if (n.hasProjection || n.mark === "arc")
      return getViewConfigContinuousSize(d.view, t);
    {
      const H = getViewConfigDiscreteSize(d.view, t);
      return isStep(H) ? H.step : H;
    }
  }
}
function facetSortFieldName(n, t, g) {
  return vgField(t, { suffix: `by_${vgField(n)}`, ...g });
}
class FacetModel extends ModelWithField {
  facet;
  child;
  children;
  constructor(t, g, d, k) {
    super(t, "facet", g, d, k, t.resolve), this.child = buildModel(t.spec, this, this.getName("child"), void 0, k), this.children = [this.child], this.facet = this.initFacet(t.facet);
  }
  initFacet(t) {
    if (!isFacetMapping(t))
      return { facet: this.initFacetFieldDef(t, "facet") };
    const g = keys$1(t), d = {};
    for (const k of g) {
      if (![ROW, COLUMN].includes(k)) {
        warn(incompatibleChannel(k, "facet"));
        break;
      }
      const H = t[k];
      if (H.field === void 0) {
        warn(emptyFieldDef(H, k));
        break;
      }
      d[k] = this.initFacetFieldDef(H, k);
    }
    return d;
  }
  initFacetFieldDef(t, g) {
    const d = initFieldDef(t, g);
    return d.header ? d.header = replaceExprRef(d.header) : d.header === null && (d.header = null), d;
  }
  channelHasField(t) {
    return hasProperty(this.facet, t);
  }
  fieldDef(t) {
    return this.facet[t];
  }
  parseData() {
    this.component.data = parseData(this), this.child.parseData();
  }
  parseLayoutSize() {
    parseChildrenLayoutSize(this);
  }
  parseSelections() {
    this.child.parseSelections(), this.component.selection = this.child.component.selection, vals(this.component.selection).some((t) => isTimerSelection(t)) && error(MULTI_VIEW_ANIMATION_UNSUPPORTED);
  }
  parseMarkGroup() {
    this.child.parseMarkGroup();
  }
  parseAxesAndHeaders() {
    this.child.parseAxesAndHeaders(), parseFacetHeaders(this);
  }
  assembleSelectionTopLevelSignals(t) {
    return this.child.assembleSelectionTopLevelSignals(t);
  }
  assembleSignals() {
    return this.child.assembleSignals(), [];
  }
  assembleSelectionData(t) {
    return this.child.assembleSelectionData(t);
  }
  getHeaderLayoutMixins() {
    const t = {};
    for (const g of FACET_CHANNELS)
      for (const d of HEADER_TYPES) {
        const k = this.component.layoutHeaders[g], H = k[d], { facetFieldDef: AA } = k;
        if (AA) {
          const gA = getHeaderProperty("titleOrient", AA.header, this.config, g);
          if (["right", "bottom"].includes(gA)) {
            const IA = getHeaderChannel(g, gA);
            t.titleAnchor ??= {}, t.titleAnchor[IA] = "end";
          }
        }
        if (H?.[0]) {
          const gA = g === "row" ? "height" : "width", IA = d === "header" ? "headerBand" : "footerBand";
          g !== "facet" && !this.child.component.layoutSize.get(gA) && (t[IA] ??= {}, t[IA][g] = 0.5), k.title && (t.offset ??= {}, t.offset[g === "row" ? "rowTitle" : "columnTitle"] = 10);
        }
      }
    return t;
  }
  assembleDefaultLayout() {
    const { column: t, row: g } = this.facet, d = t ? this.columnDistinctSignal() : g ? 1 : void 0;
    let k = "all";
    return (!g && this.component.resolve.scale.x === "independent" || !t && this.component.resolve.scale.y === "independent") && (k = "none"), {
      ...this.getHeaderLayoutMixins(),
      ...d ? { columns: d } : {},
      bounds: "full",
      align: k
    };
  }
  assembleLayoutSignals() {
    return this.child.assembleLayoutSignals();
  }
  columnDistinctSignal() {
    if (!(this.parent && this.parent instanceof FacetModel))
      return { signal: `length(data('${this.getName("column_domain")}'))` };
  }
  assembleGroupStyle() {
  }
  assembleGroup(t) {
    return this.parent && this.parent instanceof FacetModel ? {
      ...this.channelHasField("column") ? {
        encode: {
          update: {
            // TODO(https://github.com/vega/vega-lite/issues/2759):
            // Correct the signal for facet of concat of facet_column
            columns: { field: vgField(this.facet.column, { prefix: "distinct" }) }
          }
        }
      } : {},
      ...super.assembleGroup(t)
    } : super.assembleGroup(t);
  }
  /**
   * Aggregate cardinality for calculating size
   */
  getCardinalityAggregateForChild() {
    const t = [], g = [], d = [];
    if (this.child instanceof FacetModel) {
      if (this.child.channelHasField("column")) {
        const k = vgField(this.child.facet.column);
        t.push(k), g.push("distinct"), d.push(`distinct_${k}`);
      }
    } else
      for (const k of POSITION_SCALE_CHANNELS) {
        const H = this.child.component.scales[k];
        if (H && !H.merged) {
          const AA = H.get("type"), gA = H.get("range");
          if (hasDiscreteDomain(AA) && isVgRangeStep(gA)) {
            const IA = assembleDomain(this.child, k), CA = getFieldFromDomain(IA);
            CA ? (t.push(CA), g.push("distinct"), d.push(`distinct_${CA}`)) : warn(unknownField(k));
          }
        }
      }
    return { fields: t, ops: g, as: d };
  }
  assembleFacet() {
    const { name: t, data: g } = this.component.data.facetRoot, { row: d, column: k } = this.facet, { fields: H, ops: AA, as: gA } = this.getCardinalityAggregateForChild(), IA = [];
    for (const BA of FACET_CHANNELS) {
      const eA = this.facet[BA];
      if (eA) {
        IA.push(vgField(eA));
        const { bin: iA, sort: QA } = eA;
        if (isBinning(iA) && IA.push(vgField(eA, { binSuffix: "end" })), isSortField(QA)) {
          const { field: tA, op: oA = DEFAULT_SORT_OP } = QA, EA = facetSortFieldName(eA, QA);
          d && k ? (H.push(EA), AA.push("max"), gA.push(EA)) : (H.push(tA), AA.push(oA), gA.push(EA));
        } else if (isArray$2(QA)) {
          const tA = sortArrayIndexField(eA, BA);
          H.push(tA), AA.push("max"), gA.push(tA);
        }
      }
    }
    const CA = !!d && !!k;
    return {
      name: t,
      data: g,
      groupby: IA,
      ...CA || H.length > 0 ? {
        aggregate: {
          ...CA ? { cross: CA } : {},
          ...H.length ? { fields: H, ops: AA, as: gA } : {}
        }
      } : {}
    };
  }
  facetSortFields(t) {
    const { facet: g } = this, d = g[t];
    return d ? isSortField(d.sort) ? [facetSortFieldName(d, d.sort, { expr: "datum" })] : isArray$2(d.sort) ? [sortArrayIndexField(d, t, { expr: "datum" })] : [vgField(d, { expr: "datum" })] : [];
  }
  facetSortOrder(t) {
    const { facet: g } = this, d = g[t];
    if (d) {
      const { sort: k } = d;
      return [(isSortField(k) ? k.order : !isArray$2(k) && k) || "ascending"];
    }
    return [];
  }
  assembleLabelTitle() {
    const { facet: t, config: g } = this;
    if (t.facet)
      return assembleLabelTitle(t.facet, "facet", g);
    const d = {
      row: ["top", "bottom"],
      column: ["left", "right"]
    };
    for (const k of HEADER_CHANNELS)
      if (t[k]) {
        const H = getHeaderProperty("labelOrient", t[k]?.header, g, k);
        if (d[k].includes(H))
          return assembleLabelTitle(t[k], k, g);
      }
  }
  assembleMarks() {
    const { child: t } = this, g = this.component.data.facetRoot, d = assembleFacetData(g), k = t.assembleGroupEncodeEntry(!1), H = this.assembleLabelTitle() || t.assembleTitle(), AA = t.assembleGroupStyle();
    return [{
      name: this.getName("cell"),
      type: "group",
      ...H ? { title: H } : {},
      ...AA ? { style: AA } : {},
      from: {
        facet: this.assembleFacet()
      },
      // TODO: move this to after data
      sort: {
        field: FACET_CHANNELS.map((IA) => this.facetSortFields(IA)).flat(),
        order: FACET_CHANNELS.map((IA) => this.facetSortOrder(IA)).flat()
      },
      ...d.length > 0 ? { data: d } : {},
      ...k ? { encode: { update: k } } : {},
      ...t.assembleGroup(assembleFacetSignals(this, []))
    }];
  }
  getMapping() {
    return this.facet;
  }
}
function makeJoinAggregateFromFacet(n, t) {
  const { row: g, column: d } = t;
  if (g && d) {
    let k = null;
    for (const H of [g, d])
      if (isSortField(H.sort)) {
        const { field: AA, op: gA = DEFAULT_SORT_OP } = H.sort;
        n = k = new JoinAggregateTransformNode(n, {
          joinaggregate: [
            {
              op: gA,
              field: AA,
              as: facetSortFieldName(H, H.sort, { forAs: !0 })
            }
          ],
          groupby: [vgField(H)]
        });
      }
    return k;
  }
  return null;
}
function findSource(n, t) {
  for (const g of t) {
    const d = g.data;
    if (n.name && g.hasName() && n.name !== g.dataName)
      continue;
    const k = n.format?.mesh, H = d.format?.feature;
    if (k && H)
      continue;
    const AA = n.format?.feature;
    if ((AA || H) && AA !== H)
      continue;
    const gA = d.format?.mesh;
    if (!((k || gA) && k !== gA)) {
      if (isInlineData(n) && isInlineData(d)) {
        if (deepEqual(n.values, d.values))
          return g;
      } else if (isUrlData(n) && isUrlData(d)) {
        if (n.url === d.url)
          return g;
      } else if (isNamedData(n) && n.name === g.dataName)
        return g;
    }
  }
  return null;
}
function parseRoot(n, t) {
  if (n.data || !n.parent) {
    if (n.data === null) {
      const d = new SourceNode({ values: [] });
      return t.push(d), d;
    }
    const g = findSource(n.data, t);
    if (g)
      return isGenerator(n.data) || (g.data.format = mergeDeep$1({}, n.data.format, g.data.format)), !g.hasName() && n.data.name && (g.dataName = n.data.name), g;
    {
      const d = new SourceNode(n.data);
      return t.push(d), d;
    }
  } else
    return n.parent.component.data.facetRoot ? n.parent.component.data.facetRoot : n.parent.component.data.main;
}
function parseTransformArray(n, t, g) {
  let d = 0;
  for (const k of t.transforms) {
    let H, AA;
    if (isCalculate(k))
      AA = n = new CalculateNode(n, k), H = "derived";
    else if (isFilter(k)) {
      const gA = getImplicitFromFilterTransform(k);
      AA = n = ParseNode.makeWithAncestors(n, {}, gA, g) ?? n, n = new FilterNode(n, t, k.filter);
    } else if (isBin(k))
      AA = n = BinNode.makeFromTransform(n, k, t), H = "number";
    else if (isTimeUnit(k))
      H = "date", g.getWithExplicit(k.field).value === void 0 && (n = new ParseNode(n, { [k.field]: H }), g.set(k.field, H, !1)), AA = n = TimeUnitNode.makeFromTransform(n, k);
    else if (isAggregate(k))
      AA = n = AggregateNode.makeFromTransform(n, k), H = "number", requiresSelectionId(t) && (n = new IdentifierNode(n));
    else if (isLookup(k))
      AA = n = LookupNode.make(n, t, k, d++), H = "derived";
    else if (isWindow(k))
      AA = n = new WindowTransformNode(n, k), H = "number";
    else if (isJoinAggregate(k))
      AA = n = new JoinAggregateTransformNode(n, k), H = "number";
    else if (isStack(k))
      AA = n = StackNode.makeFromTransform(n, k), H = "derived";
    else if (isFold(k))
      AA = n = new FoldTransformNode(n, k), H = "derived";
    else if (isExtent(k))
      AA = n = new ExtentTransformNode(n, k), H = "derived";
    else if (isFlatten(k))
      AA = n = new FlattenTransformNode(n, k), H = "derived";
    else if (isPivot(k))
      AA = n = new PivotTransformNode(n, k), H = "derived";
    else if (isSample(k))
      n = new SampleTransformNode(n, k);
    else if (isImpute(k))
      AA = n = ImputeNode.makeFromTransform(n, k), H = "derived";
    else if (isDensity(k))
      AA = n = new DensityTransformNode(n, k), H = "derived";
    else if (isQuantile(k))
      AA = n = new QuantileTransformNode(n, k), H = "derived";
    else if (isRegression(k))
      AA = n = new RegressionTransformNode(n, k), H = "derived";
    else if (isLoess(k))
      AA = n = new LoessTransformNode(n, k), H = "derived";
    else {
      warn(invalidTransformIgnored(k));
      continue;
    }
    if (AA && H !== void 0)
      for (const gA of AA.producedFields() ?? [])
        g.set(gA, H, !1);
  }
  return n;
}
function parseData(n) {
  let t = parseRoot(n, n.component.data.sources);
  const { outputNodes: g, outputNodeRefCounts: d } = n.component.data, k = n.data, AA = !(k && (isGenerator(k) || isUrlData(k) || isInlineData(k))) && n.parent ? n.parent.component.data.ancestorParse.clone() : new AncestorParse();
  isGenerator(k) ? (isSequenceGenerator(k) ? t = new SequenceNode(t, k.sequence) : isGraticuleGenerator(k) && (t = new GraticuleNode(t, k.graticule)), AA.parseNothing = !0) : k?.format?.parse === null && (AA.parseNothing = !0), t = ParseNode.makeExplicit(t, n, AA) ?? t, t = new IdentifierNode(t);
  const gA = n.parent && isLayerModel(n.parent);
  (isUnitModel(n) || isFacetModel(n)) && gA && (t = BinNode.makeFromEncoding(t, n) ?? t), n.transforms.length > 0 && (t = parseTransformArray(t, n, AA));
  const IA = getImplicitFromSelection(n), CA = getImplicitFromEncoding(n);
  t = ParseNode.makeWithAncestors(t, {}, { ...IA, ...CA }, AA) ?? t, isUnitModel(n) && (t = GeoJSONNode.parseAll(t, n), t = GeoPointNode.parseAll(t, n)), (isUnitModel(n) || isFacetModel(n)) && (gA || (t = BinNode.makeFromEncoding(t, n) ?? t), t = TimeUnitNode.makeFromEncoding(t, n) ?? t, t = CalculateNode.parseAllForSortIndex(t, n));
  const BA = t = makeOutputNode(DataSourceType.Raw, n, t);
  if (isUnitModel(n)) {
    const EA = AggregateNode.makeFromEncoding(t, n);
    EA && (t = EA, requiresSelectionId(n) && (t = new IdentifierNode(t))), t = ImputeNode.makeFromEncoding(t, n) ?? t, t = StackNode.makeFromEncoding(t, n) ?? t;
  }
  let eA, iA;
  if (isUnitModel(n)) {
    const { markDef: EA, mark: aA, config: nA } = n, lA = getMarkPropOrConfig("invalid", EA, nA), { marks: cA, scales: sA } = iA = getDataSourcesForHandlingInvalidValues({
      invalid: lA,
      isPath: isPathMark(aA)
    });
    cA !== sA && sA === "include-invalid-values" && (eA = t = makeOutputNode(DataSourceType.PreFilterInvalid, n, t)), cA === "exclude-invalid-values" && (t = FilterInvalidNode.make(t, n, iA) ?? t);
  }
  const QA = t = makeOutputNode(DataSourceType.Main, n, t);
  let tA;
  if (isUnitModel(n) && iA) {
    const { marks: EA, scales: aA } = iA;
    EA === "include-invalid-values" && aA === "exclude-invalid-values" && (t = FilterInvalidNode.make(t, n, iA) ?? t, tA = t = makeOutputNode(DataSourceType.PostFilterInvalid, n, t));
  }
  isUnitModel(n) && materializeSelections(n, QA);
  let oA = null;
  if (isFacetModel(n)) {
    const EA = n.getName("facet");
    t = makeJoinAggregateFromFacet(t, n.facet) ?? t, oA = new FacetNode(t, n, EA, QA.getSource()), g[EA] = oA;
  }
  return {
    ...n.component.data,
    outputNodes: g,
    outputNodeRefCounts: d,
    raw: BA,
    main: QA,
    facetRoot: oA,
    ancestorParse: AA,
    preFilterInvalid: eA,
    postFilterInvalid: tA
  };
}
function makeOutputNode(n, t, g) {
  const { outputNodes: d, outputNodeRefCounts: k } = t.component.data, H = t.getDataName(n), AA = new OutputNode(g, H, n, k);
  return d[H] = AA, AA;
}
class ConcatModel extends Model {
  children;
  constructor(t, g, d, k) {
    super(t, "concat", g, d, k, t.resolve), (t.resolve?.axis?.x === "shared" || t.resolve?.axis?.y === "shared") && warn(CONCAT_CANNOT_SHARE_AXIS), this.children = this.getChildren(t).map((H, AA) => buildModel(H, this, this.getName(`concat_${AA}`), void 0, k));
  }
  parseData() {
    this.component.data = parseData(this);
    for (const t of this.children)
      t.parseData();
  }
  parseSelections() {
    this.component.selection = {};
    for (const t of this.children) {
      t.parseSelections();
      for (const g of keys$1(t.component.selection))
        this.component.selection[g] = t.component.selection[g];
    }
    vals(this.component.selection).some((t) => isTimerSelection(t)) && error(MULTI_VIEW_ANIMATION_UNSUPPORTED);
  }
  parseMarkGroup() {
    for (const t of this.children)
      t.parseMarkGroup();
  }
  parseAxesAndHeaders() {
    for (const t of this.children)
      t.parseAxesAndHeaders();
  }
  getChildren(t) {
    return isVConcatSpec(t) ? t.vconcat : isHConcatSpec(t) ? t.hconcat : t.concat;
  }
  parseLayoutSize() {
    parseConcatLayoutSize(this);
  }
  parseAxisGroup() {
    return null;
  }
  assembleSelectionTopLevelSignals(t) {
    return this.children.reduce((g, d) => d.assembleSelectionTopLevelSignals(g), t);
  }
  assembleSignals() {
    return this.children.forEach((t) => t.assembleSignals()), [];
  }
  assembleLayoutSignals() {
    const t = assembleLayoutSignals(this);
    for (const g of this.children)
      t.push(...g.assembleLayoutSignals());
    return t;
  }
  assembleSelectionData(t) {
    return this.children.reduce((g, d) => d.assembleSelectionData(g), t);
  }
  assembleMarks() {
    return this.children.map((t) => {
      const g = t.assembleTitle(), d = t.assembleGroupStyle(), k = t.assembleGroupEncodeEntry(!1);
      return {
        type: "group",
        name: t.getName("group"),
        ...g ? { title: g } : {},
        ...d ? { style: d } : {},
        ...k ? { encode: { update: k } } : {},
        ...t.assembleGroup()
      };
    });
  }
  assembleGroupStyle() {
  }
  assembleDefaultLayout() {
    const t = this.layout.columns;
    return {
      ...t != null ? { columns: t } : {},
      bounds: "full",
      // Use align each so it can work with multiple plots with different size
      align: "each"
    };
  }
}
function isFalseOrNull(n) {
  return n === !1 || n === null;
}
const AXIS_COMPONENT_PROPERTIES_INDEX = {
  disable: 1,
  gridScale: 1,
  scale: 1,
  ...COMMON_AXIS_PROPERTIES_INDEX,
  labelExpr: 1,
  encode: 1
}, AXIS_COMPONENT_PROPERTIES = keys$1(AXIS_COMPONENT_PROPERTIES_INDEX);
class AxisComponent extends Split {
  explicit;
  implicit;
  mainExtracted;
  constructor(t = {}, g = {}, d = !1) {
    super(), this.explicit = t, this.implicit = g, this.mainExtracted = d;
  }
  clone() {
    return new AxisComponent(duplicate(this.explicit), duplicate(this.implicit), this.mainExtracted);
  }
  hasAxisPart(t) {
    return t === "axis" ? !0 : t === "grid" || t === "title" ? !!this.get(t) : !isFalseOrNull(this.get(t));
  }
  hasOrientSignalRef() {
    return isSignalRef(this.explicit.orient);
  }
}
function labels(n, t, g) {
  const { encoding: d, config: k } = n, H = getFieldOrDatumDef(d[t]) ?? getFieldOrDatumDef(d[getSecondaryRangeChannel(t)]), AA = n.axis(t) || {}, { format: gA, formatType: IA } = AA;
  if (isCustomFormatType(IA))
    return {
      text: formatCustomType({
        fieldOrDatumDef: H,
        field: "datum.value",
        format: gA,
        formatType: IA,
        config: k
      }),
      ...g
    };
  if (gA === void 0 && IA === void 0 && k.customFormatTypes) {
    if (channelDefType(H) === "quantitative") {
      if (isPositionFieldOrDatumDef(H) && H.stack === "normalize" && k.normalizedNumberFormatType)
        return {
          text: formatCustomType({
            fieldOrDatumDef: H,
            field: "datum.value",
            format: k.normalizedNumberFormat,
            formatType: k.normalizedNumberFormatType,
            config: k
          }),
          ...g
        };
      if (k.numberFormatType)
        return {
          text: formatCustomType({
            fieldOrDatumDef: H,
            field: "datum.value",
            format: k.numberFormat,
            formatType: k.numberFormatType,
            config: k
          }),
          ...g
        };
    }
    if (channelDefType(H) === "temporal" && k.timeFormatType && isFieldDef(H) && !H.timeUnit)
      return {
        text: formatCustomType({
          fieldOrDatumDef: H,
          field: "datum.value",
          format: k.timeFormat,
          formatType: k.timeFormatType,
          config: k
        }),
        ...g
      };
  }
  return g;
}
function parseUnitAxes(n) {
  return POSITION_SCALE_CHANNELS.reduce((t, g) => (n.component.scales[g] && (t[g] = [parseAxis(g, n)]), t), {});
}
const OPPOSITE_ORIENT = {
  bottom: "top",
  top: "bottom",
  left: "right",
  right: "left"
};
function parseLayerAxes(n) {
  const { axes: t, resolve: g } = n.component, d = { top: 0, bottom: 0, right: 0, left: 0 };
  for (const k of n.children) {
    k.parseAxesAndHeaders();
    for (const H of keys$1(k.component.axes))
      g.axis[H] = parseGuideResolve(n.component.resolve, H), g.axis[H] === "shared" && (t[H] = mergeAxisComponents(t[H], k.component.axes[H]), t[H] || (g.axis[H] = "independent", delete t[H]));
  }
  for (const k of POSITION_SCALE_CHANNELS) {
    for (const H of n.children)
      if (H.component.axes[k]) {
        if (g.axis[k] === "independent") {
          t[k] = (t[k] ?? []).concat(H.component.axes[k]);
          for (const AA of H.component.axes[k]) {
            const { value: gA, explicit: IA } = AA.getWithExplicit("orient");
            if (!isSignalRef(gA)) {
              if (d[gA] > 0 && !IA) {
                const CA = OPPOSITE_ORIENT[gA];
                d[gA] > d[CA] && AA.set("orient", CA, !1);
              }
              d[gA]++;
            }
          }
        }
        delete H.component.axes[k];
      }
    if (g.axis[k] === "independent" && t[k] && t[k].length > 1)
      for (const [H, AA] of (t[k] || []).entries())
        H > 0 && AA.get("grid") && !AA.explicit.grid && (AA.implicit.grid = !1);
  }
}
function mergeAxisComponents(n, t) {
  if (n) {
    if (n.length !== t.length)
      return;
    const g = n.length;
    for (let d = 0; d < g; d++) {
      const k = n[d], H = t[d];
      if (!!k != !!H)
        return;
      if (k && H) {
        const AA = k.getWithExplicit("orient"), gA = H.getWithExplicit("orient");
        if (AA.explicit && gA.explicit && AA.value !== gA.value)
          return;
        n[d] = mergeAxisComponent(k, H);
      }
    }
  } else
    return t.map((g) => g.clone());
  return n;
}
function mergeAxisComponent(n, t) {
  for (const g of AXIS_COMPONENT_PROPERTIES) {
    const d = mergeValuesWithExplicit(
      n.getWithExplicit(g),
      t.getWithExplicit(g),
      g,
      "axis",
      // Tie breaker function
      (k, H) => {
        switch (g) {
          case "title":
            return mergeTitleComponent(k, H);
          case "gridScale":
            return {
              explicit: k.explicit,
              // keep the old explicit
              value: getFirstDefined(k.value, H.value)
            };
        }
        return defaultTieBreaker(k, H, g, "axis");
      }
    );
    n.setWithExplicit(g, d);
  }
  return n;
}
function isExplicit(n, t, g, d, k) {
  if (t === "disable")
    return g !== void 0;
  switch (g = g || {}, t) {
    case "titleAngle":
    case "labelAngle":
      return n === (isSignalRef(g.labelAngle) ? g.labelAngle : normalizeAngle(g.labelAngle));
    case "values":
      return !!g.values;
    // specified axis.values is already respected, but may get transformed.
    case "encode":
      return !!g.encoding || !!g.labelAngle;
    case "title":
      if (n === getFieldDefTitle(d, k))
        return !0;
  }
  return n === g[t];
}
const propsToAlwaysIncludeConfig = /* @__PURE__ */ new Set([
  "grid",
  // Grid is an exception because we need to set grid = true to generate another grid axis
  "translate",
  // translate has dependent logic for bar's bin position and it's 0.5 by default in Vega. If a config overrides this value, we need to know.
  // the rest are not axis configs in Vega, but are in VL, so we need to set too.
  "format",
  "formatType",
  "orient",
  "labelExpr",
  "tickCount",
  "position",
  "tickMinStep"
]);
function parseAxis(n, t) {
  let g = t.axis(n);
  const d = new AxisComponent(), k = getFieldOrDatumDef(t.encoding[n]), { mark: H, config: AA } = t, gA = g?.orient || AA[n === "x" ? "axisX" : "axisY"]?.orient || AA.axis?.orient || defaultOrient(n), IA = t.getScaleComponent(n).get("type"), CA = getAxisConfigs(n, IA, gA, t.config), BA = g !== void 0 ? !g : getAxisConfig("disable", AA.style, g?.style, CA).configValue;
  if (d.set("disable", BA, g !== void 0), BA)
    return d;
  g = g || {};
  const eA = getLabelAngle(k, g, n, AA.style, CA), iA = guideFormatType(g.formatType, k, IA), QA = guideFormat(k, k.type, g.format, g.formatType, AA, !0), tA = {
    fieldOrDatumDef: k,
    axis: g,
    channel: n,
    model: t,
    scaleType: IA,
    orient: gA,
    labelAngle: eA,
    format: QA,
    formatType: iA,
    mark: H,
    config: AA
  };
  for (const aA of AXIS_COMPONENT_PROPERTIES) {
    const nA = aA in axisRules ? axisRules[aA](tA) : isAxisProperty(aA) ? g[aA] : void 0, lA = nA !== void 0, cA = isExplicit(nA, aA, g, t, n);
    if (lA && cA)
      d.set(aA, nA, cA);
    else {
      const { configValue: sA = void 0, configFrom: rA = void 0 } = isAxisProperty(aA) && aA !== "values" ? getAxisConfig(aA, AA.style, g.style, CA) : {}, uA = sA !== void 0;
      lA && !uA ? d.set(aA, nA, cA) : (
        // Cases need implicit values
        // 1. Axis config that aren't available in Vega
        (rA !== "vgAxisConfig" || // 2. Certain properties are always included (see `propsToAlwaysIncludeConfig`'s declaration for more details)
        propsToAlwaysIncludeConfig.has(aA) && uA || // 3. Conditional axis values and signals
        isConditionalAxisValue(sA) || isSignalRef(sA)) && d.set(aA, sA, !1)
      );
    }
  }
  const oA = g.encoding ?? {}, EA = AXIS_PARTS.reduce((aA, nA) => {
    if (!d.hasAxisPart(nA))
      return aA;
    const lA = guideEncodeEntry(oA[nA] ?? {}, t), cA = nA === "labels" ? labels(t, n, lA) : lA;
    return cA !== void 0 && !isEmpty(cA) && (aA[nA] = { update: cA }), aA;
  }, {});
  return isEmpty(EA) || d.set("encode", EA, !!g.encoding || g.labelAngle !== void 0), d;
}
function initLayoutSize({ encoding: n, size: t }) {
  for (const g of POSITION_SCALE_CHANNELS) {
    const d = getSizeChannel(g);
    isStep(t[d]) && isContinuousFieldOrDatumDef(n[g]) && (delete t[d], warn(stepDropped(d)));
  }
  return t;
}
const arc = {
  vgMark: "arc",
  encodeEntry: (n) => ({
    ...baseEncodeEntry(n, {
      align: "ignore",
      baseline: "ignore",
      color: "include",
      size: "ignore",
      orient: "ignore",
      theta: "ignore"
    }),
    ...pointPosition("x", n, { defaultPos: "mid" }),
    ...pointPosition("y", n, { defaultPos: "mid" }),
    // arcs are rectangles in polar coordinates
    ...rectPosition(n, "radius"),
    ...rectPosition(n, "theta")
  })
}, area = {
  vgMark: "area",
  encodeEntry: (n) => ({
    ...baseEncodeEntry(n, {
      align: "ignore",
      baseline: "ignore",
      color: "include",
      orient: "include",
      size: "ignore",
      theta: "ignore"
    }),
    ...pointOrRangePosition("x", n, {
      defaultPos: "zeroOrMin",
      defaultPos2: "zeroOrMin",
      range: n.markDef.orient === "horizontal"
    }),
    ...pointOrRangePosition("y", n, {
      defaultPos: "zeroOrMin",
      defaultPos2: "zeroOrMin",
      range: n.markDef.orient === "vertical"
    }),
    ...defined(n)
  })
}, bar = {
  vgMark: "rect",
  encodeEntry: (n) => ({
    ...baseEncodeEntry(n, {
      align: "ignore",
      baseline: "ignore",
      color: "include",
      orient: "ignore",
      size: "ignore",
      theta: "ignore"
    }),
    ...rectPosition(n, "x"),
    ...rectPosition(n, "y")
  })
}, geoshape = {
  vgMark: "shape",
  encodeEntry: (n) => ({
    ...baseEncodeEntry(n, {
      align: "ignore",
      baseline: "ignore",
      color: "include",
      size: "ignore",
      orient: "ignore",
      theta: "ignore"
    })
  }),
  postEncodingTransform: (n) => {
    const { encoding: t } = n, g = t.shape;
    return [{
      type: "geoshape",
      projection: n.projectionName(),
      // as: 'shape',
      ...g && isFieldDef(g) && g.type === GEOJSON ? { field: vgField(g, { expr: "datum" }) } : {}
    }];
  }
}, image = {
  vgMark: "image",
  encodeEntry: (n) => ({
    ...baseEncodeEntry(n, {
      align: "ignore",
      baseline: "ignore",
      color: "ignore",
      orient: "ignore",
      size: "ignore",
      theta: "ignore"
    }),
    ...rectPosition(n, "x"),
    ...rectPosition(n, "y"),
    ...text$1(n, "url")
  })
}, line = {
  vgMark: "line",
  encodeEntry: (n) => ({
    ...baseEncodeEntry(n, {
      align: "ignore",
      baseline: "ignore",
      color: "include",
      size: "ignore",
      orient: "ignore",
      theta: "ignore"
    }),
    ...pointPosition("x", n, { defaultPos: "mid" }),
    ...pointPosition("y", n, { defaultPos: "mid" }),
    ...nonPosition("size", n, {
      vgChannel: "strokeWidth"
      // VL's line size is strokeWidth
    }),
    ...defined(n)
  })
}, trail = {
  vgMark: "trail",
  encodeEntry: (n) => ({
    ...baseEncodeEntry(n, {
      align: "ignore",
      baseline: "ignore",
      color: "include",
      size: "include",
      orient: "ignore",
      theta: "ignore"
    }),
    ...pointPosition("x", n, { defaultPos: "mid" }),
    ...pointPosition("y", n, { defaultPos: "mid" }),
    ...nonPosition("size", n),
    ...defined(n)
  })
};
function encodeEntry(n, t) {
  const { config: g } = n;
  return {
    ...baseEncodeEntry(n, {
      align: "ignore",
      baseline: "ignore",
      color: "include",
      size: "include",
      orient: "ignore",
      theta: "ignore"
    }),
    ...pointPosition("x", n, { defaultPos: "mid" }),
    ...pointPosition("y", n, { defaultPos: "mid" }),
    ...nonPosition("size", n),
    ...nonPosition("angle", n),
    ...shapeMixins(n, g, t)
  };
}
function shapeMixins(n, t, g) {
  return g ? { shape: { value: g } } : nonPosition("shape", n);
}
const point = {
  vgMark: "symbol",
  encodeEntry: (n) => encodeEntry(n)
}, circle = {
  vgMark: "symbol",
  encodeEntry: (n) => encodeEntry(n, "circle")
}, square = {
  vgMark: "symbol",
  encodeEntry: (n) => encodeEntry(n, "square")
}, rect = {
  vgMark: "rect",
  encodeEntry: (n) => ({
    ...baseEncodeEntry(n, {
      align: "ignore",
      baseline: "ignore",
      color: "include",
      orient: "ignore",
      size: "ignore",
      theta: "ignore"
    }),
    ...rectPosition(n, "x"),
    ...rectPosition(n, "y")
  })
}, rule = {
  vgMark: "rule",
  encodeEntry: (n) => {
    const { markDef: t } = n, g = t.orient;
    return !n.encoding.x && !n.encoding.y && !n.encoding.latitude && !n.encoding.longitude ? {} : {
      ...baseEncodeEntry(n, {
        align: "ignore",
        baseline: "ignore",
        color: "include",
        orient: "ignore",
        size: "ignore",
        theta: "ignore"
      }),
      ...pointOrRangePosition("x", n, {
        defaultPos: g === "horizontal" ? "zeroOrMax" : "mid",
        defaultPos2: "zeroOrMin",
        range: g !== "vertical"
        // include x2 for horizontal or line segment rule
      }),
      ...pointOrRangePosition("y", n, {
        defaultPos: g === "vertical" ? "zeroOrMax" : "mid",
        defaultPos2: "zeroOrMin",
        range: g !== "horizontal"
        // include y2 for vertical or line segment rule
      }),
      ...nonPosition("size", n, {
        vgChannel: "strokeWidth"
        // VL's rule size is strokeWidth
      })
    };
  }
}, text = {
  vgMark: "text",
  encodeEntry: (n) => {
    const { config: t, encoding: g } = n;
    return {
      ...baseEncodeEntry(n, {
        align: "include",
        baseline: "include",
        color: "include",
        size: "ignore",
        orient: "ignore",
        theta: "include"
      }),
      ...pointPosition("x", n, { defaultPos: "mid" }),
      ...pointPosition("y", n, { defaultPos: "mid" }),
      ...text$1(n),
      ...nonPosition("size", n, {
        vgChannel: "fontSize"
        // VL's text size is fontSize
      }),
      ...nonPosition("angle", n),
      ...valueIfDefined("align", align(n.markDef, g, t)),
      ...valueIfDefined("baseline", baseline(n.markDef, g, t)),
      ...pointPosition("radius", n, { defaultPos: null }),
      ...pointPosition("theta", n, { defaultPos: null })
    };
  }
};
function align(n, t, g) {
  if (getMarkPropOrConfig("align", n, g) === void 0)
    return "center";
}
function baseline(n, t, g) {
  if (getMarkPropOrConfig("baseline", n, g) === void 0)
    return "middle";
}
const tick = {
  vgMark: "rect",
  encodeEntry: (n) => {
    const { config: t, markDef: g } = n, d = g.orient, k = d === "horizontal" ? "x" : "y", H = d === "horizontal" ? "y" : "x", AA = d === "horizontal" ? "height" : "width";
    return {
      ...baseEncodeEntry(n, {
        align: "ignore",
        baseline: "ignore",
        color: "include",
        orient: "ignore",
        size: "ignore",
        theta: "ignore"
      }),
      ...rectPosition(n, k),
      ...pointPosition(H, n, {
        defaultPos: "mid",
        vgChannel: H === "y" ? "yc" : "xc"
      }),
      [AA]: signalOrValueRef(getMarkPropOrConfig("thickness", g, t))
    };
  }
}, markCompiler = {
  arc,
  area,
  bar,
  circle,
  geoshape,
  image,
  line,
  point,
  rect,
  rule,
  square,
  text,
  tick,
  trail
};
function parseMarkGroups(n) {
  if (contains([LINE, AREA, TRAIL], n.mark)) {
    const t = pathGroupingFields(n.mark, n.encoding);
    if (t.length > 0)
      return getPathGroups(n, t);
  } else if (n.mark === BAR) {
    const t = VG_CORNERRADIUS_CHANNELS.some((g) => getMarkPropOrConfig(g, n.markDef, n.config));
    if (n.stack && !n.fieldDef("size") && t)
      return getGroupsForStackedBarWithCornerRadius(n);
  }
  return getMarkGroup(n);
}
const FACETED_PATH_PREFIX = "faceted_path_";
function getPathGroups(n, t) {
  return [
    {
      name: n.getName("pathgroup"),
      type: "group",
      from: {
        facet: {
          name: FACETED_PATH_PREFIX + n.requestDataName(DataSourceType.Main),
          data: n.requestDataName(DataSourceType.Main),
          groupby: t
        }
      },
      encode: {
        update: {
          width: { field: { group: "width" } },
          height: { field: { group: "height" } }
        }
      },
      // With subfacet for line/area group, need to use faceted data from above.
      marks: getMarkGroup(n, { fromPrefix: FACETED_PATH_PREFIX })
    }
  ];
}
const STACK_GROUP_PREFIX = "stack_group_";
function getGroupsForStackedBarWithCornerRadius(n) {
  const [t] = getMarkGroup(n, { fromPrefix: STACK_GROUP_PREFIX }), g = n.scaleName(n.stack.fieldChannel), d = (CA = {}) => n.vgField(n.stack.fieldChannel, CA), k = (CA, BA) => {
    const eA = [
      d({ prefix: "min", suffix: "start", expr: BA }),
      d({ prefix: "max", suffix: "start", expr: BA }),
      d({ prefix: "min", suffix: "end", expr: BA }),
      d({ prefix: "max", suffix: "end", expr: BA })
    ];
    return `${CA}(${eA.map((iA) => `scale('${g}',${iA})`).join(",")})`;
  };
  let H, AA;
  n.stack.fieldChannel === "x" ? (H = {
    ...pick$2(t.encode.update, ["y", "yc", "y2", "height", ...VG_CORNERRADIUS_CHANNELS]),
    x: { signal: k("min", "datum") },
    x2: { signal: k("max", "datum") },
    clip: { value: !0 }
  }, AA = {
    x: { field: { group: "x" }, mult: -1 },
    height: { field: { group: "height" } }
  }, t.encode.update = {
    ...omit(t.encode.update, ["y", "yc", "y2"]),
    height: { field: { group: "height" } }
  }) : (H = {
    ...pick$2(t.encode.update, ["x", "xc", "x2", "width"]),
    y: { signal: k("min", "datum") },
    y2: { signal: k("max", "datum") },
    clip: { value: !0 }
  }, AA = {
    y: { field: { group: "y" }, mult: -1 },
    width: { field: { group: "width" } }
  }, t.encode.update = {
    ...omit(t.encode.update, ["x", "xc", "x2"]),
    width: { field: { group: "width" } }
  });
  for (const CA of VG_CORNERRADIUS_CHANNELS) {
    const BA = getMarkConfig(CA, n.markDef, n.config);
    t.encode.update[CA] ? (H[CA] = t.encode.update[CA], delete t.encode.update[CA]) : BA && (H[CA] = signalOrValueRef(BA)), BA && (t.encode.update[CA] = { value: 0 });
  }
  const gA = [];
  if (n.stack.groupbyChannels?.length > 0)
    for (const CA of n.stack.groupbyChannels) {
      const BA = n.fieldDef(CA), eA = vgField(BA);
      eA && gA.push(eA), (BA?.bin || BA?.timeUnit) && gA.push(vgField(BA, { binSuffix: "end" }));
    }
  return H = [
    "stroke",
    "strokeWidth",
    "strokeJoin",
    "strokeCap",
    "strokeDash",
    "strokeDashOffset",
    "strokeMiterLimit",
    "strokeOpacity"
  ].reduce((CA, BA) => {
    if (t.encode.update[BA])
      return { ...CA, [BA]: t.encode.update[BA] };
    {
      const eA = getMarkConfig(BA, n.markDef, n.config);
      return eA !== void 0 ? { ...CA, [BA]: signalOrValueRef(eA) } : CA;
    }
  }, H), H.stroke && (H.strokeForeground = { value: !0 }, H.strokeOffset = { value: 0 }), [
    {
      type: "group",
      from: {
        facet: {
          data: n.requestDataName(DataSourceType.Main),
          name: STACK_GROUP_PREFIX + n.requestDataName(DataSourceType.Main),
          groupby: gA,
          aggregate: {
            fields: [
              d({ suffix: "start" }),
              d({ suffix: "start" }),
              d({ suffix: "end" }),
              d({ suffix: "end" })
            ],
            ops: ["min", "max", "min", "max"]
          }
        }
      },
      encode: {
        update: H
      },
      marks: [
        {
          type: "group",
          encode: { update: AA },
          marks: [t]
        }
      ]
    }
  ];
}
function getSort(n) {
  const { encoding: t, stack: g, mark: d, markDef: k, config: H } = n, AA = t.order;
  if (!(!isArray$2(AA) && isValueDef(AA) && isNullOrFalse(AA.value) || !AA && isNullOrFalse(getMarkPropOrConfig("order", k, H)))) {
    if ((isArray$2(AA) || isFieldDef(AA)) && !g)
      return sortParams(AA, { expr: "datum" });
    if (isPathMark(d)) {
      const gA = k.orient === "horizontal" ? "y" : "x", IA = t[gA];
      if (isFieldDef(IA))
        return { field: gA };
    }
  }
}
function getMarkGroup(n, t = { fromPrefix: "" }) {
  const { mark: g, markDef: d, encoding: k, config: H } = n, AA = getFirstDefined(d.clip, scaleClip(n), projectionClip(n)), gA = getStyles(d), IA = k.key, CA = getSort(n), BA = interactiveFlag(n);
  BA && Object.values(n.component.selection).some((QA) => QA.type === "point" && !QA.bind && // if on is a pointerover (hover) the pointer makes less sense since the mark is not clickable.
  QA.on !== "pointerover") && (n.markDef.cursor ??= "pointer");
  const eA = getMarkPropOrConfig("aria", d, H), iA = markCompiler[g].postEncodingTransform ? markCompiler[g].postEncodingTransform(n) : null;
  return [
    {
      name: n.getName("marks"),
      type: markCompiler[g].vgMark,
      ...AA ? { clip: AA } : {},
      ...gA ? { style: gA } : {},
      ...IA ? { key: IA.field } : {},
      ...CA ? { sort: CA } : {},
      ...BA || {},
      ...eA === !1 ? { aria: eA } : {},
      from: { data: t.fromPrefix + n.requestDataName(DataSourceType.Main) },
      encode: {
        update: markCompiler[g].encodeEntry(n)
      },
      ...iA ? {
        transform: iA
      } : {}
    }
  ];
}
function scaleClip(n) {
  const t = n.getScaleComponent("x"), g = n.getScaleComponent("y");
  return t?.get("selectionExtent") || g?.get("selectionExtent") ? !0 : void 0;
}
function projectionClip(n) {
  const t = n.component.projection;
  return t && !t.isFit ? !0 : void 0;
}
function interactiveFlag(n) {
  if (!n.component.selection)
    return null;
  const t = keys$1(n.component.selection).length;
  let g = t, d = n.parent;
  for (; d && g === 0; )
    g = keys$1(d.component.selection).length, d = d.parent;
  return g ? {
    interactive: t > 0 || n.mark === "geoshape" || !!n.encoding.tooltip || !!n.markDef.tooltip
  } : null;
}
class UnitModel extends ModelWithField {
  markDef;
  encoding;
  specifiedScales = {};
  stack;
  specifiedAxes = {};
  specifiedLegends = {};
  specifiedProjection = {};
  selection = [];
  children = [];
  constructor(t, g, d, k = {}, H) {
    super(t, "unit", g, d, H, void 0, isFrameMixins(t) ? t.view : void 0);
    const AA = isMarkDef(t.mark) ? { ...t.mark } : { type: t.mark }, gA = AA.type;
    AA.filled === void 0 && (AA.filled = defaultFilled(AA, H, {
      graticule: t.data && isGraticuleGenerator(t.data)
    }));
    const IA = this.encoding = initEncoding(t.encoding || {}, gA, AA.filled, H);
    this.markDef = initMarkdef(AA, IA, H), this.size = initLayoutSize({
      encoding: IA,
      size: isFrameMixins(t) ? {
        ...k,
        ...t.width ? { width: t.width } : {},
        ...t.height ? { height: t.height } : {}
      } : k
    }), this.stack = stack(this.markDef, IA), this.specifiedScales = this.initScales(gA, IA), this.specifiedAxes = this.initAxes(IA), this.specifiedLegends = this.initLegends(IA), this.specifiedProjection = t.projection, this.selection = (t.params ?? []).filter((CA) => isSelectionParameter(CA)), this.alignStackOrderWithColorDomain();
  }
  get hasProjection() {
    const { encoding: t } = this, g = this.mark === GEOSHAPE, d = t && GEOPOSITION_CHANNELS.some((k) => isFieldOrDatumDef(t[k]));
    return g || d;
  }
  /**
   * Return specified Vega-Lite scale domain for a particular channel
   * @param channel
   */
  scaleDomain(t) {
    const g = this.specifiedScales[t];
    return g ? g.domain : void 0;
  }
  axis(t) {
    return this.specifiedAxes[t];
  }
  legend(t) {
    return this.specifiedLegends[t];
  }
  initScales(t, g) {
    return SCALE_CHANNELS.reduce((d, k) => {
      const H = getFieldOrDatumDef(g[k]);
      return H && (d[k] = this.initScale(H.scale ?? {})), d;
    }, {});
  }
  initScale(t) {
    const { domain: g, range: d } = t, k = replaceExprRef(t);
    return isArray$2(g) && (k.domain = g.map(signalRefOrValue)), isArray$2(d) && (k.range = d.map(signalRefOrValue)), k;
  }
  initAxes(t) {
    return POSITION_SCALE_CHANNELS.reduce((g, d) => {
      const k = t[d];
      if (isFieldOrDatumDef(k) || d === X$1 && isFieldOrDatumDef(t.x2) || d === Y && isFieldOrDatumDef(t.y2)) {
        const H = isFieldOrDatumDef(k) ? k.axis : void 0;
        g[d] = H && this.initAxis({ ...H });
      }
      return g;
    }, {});
  }
  initAxis(t) {
    const g = keys$1(t), d = {};
    for (const k of g) {
      const H = t[k];
      d[k] = isConditionalAxisValue(H) ? signalOrValueRefWithCondition(H) : signalRefOrValue(H);
    }
    return d;
  }
  initLegends(t) {
    return NONPOSITION_SCALE_CHANNELS.reduce((g, d) => {
      const k = getFieldOrDatumDef(t[d]);
      if (k && supportLegend(d)) {
        const H = k.legend;
        g[d] = H && replaceExprRef(H);
      }
      return g;
    }, {});
  }
  /**
   * If this unit lacks order encoding but does contain a color domain
   * add transform and encoding that aligns the stack order with the color domain.
   */
  alignStackOrderWithColorDomain() {
    const { color: t, fill: g, order: d, xOffset: k, yOffset: H } = this.encoding, AA = g || t, gA = isFieldDef(AA) ? AA : void 0, IA = gA?.field, CA = gA?.scale, BA = gA?.type, eA = CA?.domain, iA = k || H, QA = isFieldDef(iA) ? iA : void 0, tA = `_${IA}_sort_index`;
    if (!d && Array.isArray(eA) && typeof IA == "string" && BA === "nominal")
      if (QA && !QA.sort)
        QA.sort = eA;
      else {
        const oA = `indexof(${$$1(eA)}, datum['${IA}'])`, EA = this.markDef?.orient === "horizontal" ? "ascending" : "descending";
        this.transforms.push({ calculate: oA, as: tA }), this.encoding.order = { field: tA, type: "quantitative", sort: EA };
      }
  }
  parseData() {
    this.component.data = parseData(this);
  }
  parseLayoutSize() {
    parseUnitLayoutSize(this);
  }
  parseSelections() {
    this.component.selection = parseUnitSelection(this, this.selection);
  }
  parseMarkGroup() {
    this.component.mark = parseMarkGroups(this);
  }
  parseAxesAndHeaders() {
    this.component.axes = parseUnitAxes(this);
  }
  assembleSelectionTopLevelSignals(t) {
    return assembleTopLevelSignals(this, t);
  }
  assembleSignals() {
    return [...assembleAxisSignals(this), ...assembleUnitSelectionSignals(this, [])];
  }
  assembleSelectionData(t) {
    return assembleUnitSelectionData(this, t);
  }
  assembleLayout() {
    return null;
  }
  assembleLayoutSignals() {
    return assembleLayoutSignals(this);
  }
  /**
   * Corrects the data references in marks after assemble.
   */
  correctDataNames = (t) => (t.from?.data && (t.from.data = this.lookupDataSource(t.from.data), "time" in this.encoding && (t.from.data = t.from.data + CURR)), t.from?.facet?.data && (t.from.facet.data = this.lookupDataSource(t.from.facet.data)), t);
  assembleMarks() {
    let t = this.component.mark ?? [];
    return (!this.parent || !isLayerModel(this.parent)) && (t = assembleUnitSelectionMarks(this, t)), t.map(this.correctDataNames);
  }
  assembleGroupStyle() {
    const { style: t } = this.view || {};
    return t !== void 0 ? t : this.encoding.x || this.encoding.y ? "cell" : "view";
  }
  getMapping() {
    return this.encoding;
  }
  get mark() {
    return this.markDef.type;
  }
  channelHasField(t) {
    return channelHasField(this.encoding, t);
  }
  fieldDef(t) {
    const g = this.encoding[t];
    return getFieldDef(g);
  }
  typedFieldDef(t) {
    const g = this.fieldDef(t);
    return isTypedFieldDef(g) ? g : null;
  }
}
class LayerModel extends Model {
  // HACK: This should be (LayerModel | UnitModel)[], but setting the correct type leads to weird error.
  // So I'm just putting generic Model for now
  children;
  constructor(t, g, d, k, H) {
    super(t, "layer", g, d, H, t.resolve, t.view);
    const AA = {
      ...k,
      ...t.width ? { width: t.width } : {},
      ...t.height ? { height: t.height } : {}
    };
    this.children = t.layer.map((gA, IA) => {
      if (isLayerSpec(gA))
        return new LayerModel(gA, this, this.getName(`layer_${IA}`), AA, H);
      if (isUnitSpec(gA))
        return new UnitModel(gA, this, this.getName(`layer_${IA}`), AA, H);
      throw new Error(invalidSpec(gA));
    });
  }
  parseData() {
    this.component.data = parseData(this);
    for (const t of this.children)
      t.parseData();
  }
  parseLayoutSize() {
    parseLayerLayoutSize(this);
  }
  parseSelections() {
    this.component.selection = {};
    for (const t of this.children) {
      t.parseSelections();
      for (const g of keys$1(t.component.selection))
        this.component.selection[g] = t.component.selection[g];
    }
    vals(this.component.selection).some((t) => isTimerSelection(t)) && error(MULTI_VIEW_ANIMATION_UNSUPPORTED);
  }
  parseMarkGroup() {
    for (const t of this.children)
      t.parseMarkGroup();
  }
  parseAxesAndHeaders() {
    parseLayerAxes(this);
  }
  assembleSelectionTopLevelSignals(t) {
    return this.children.reduce((g, d) => d.assembleSelectionTopLevelSignals(g), t);
  }
  // TODO: Support same named selections across children.
  assembleSignals() {
    return this.children.reduce((t, g) => t.concat(g.assembleSignals()), assembleAxisSignals(this));
  }
  assembleLayoutSignals() {
    return this.children.reduce((t, g) => t.concat(g.assembleLayoutSignals()), assembleLayoutSignals(this));
  }
  assembleSelectionData(t) {
    return this.children.reduce((g, d) => d.assembleSelectionData(g), t);
  }
  assembleGroupStyle() {
    const t = /* @__PURE__ */ new Set();
    for (const d of this.children)
      for (const k of array(d.assembleGroupStyle()))
        t.add(k);
    const g = Array.from(t);
    return g.length > 1 ? g : g.length === 1 ? g[0] : void 0;
  }
  assembleTitle() {
    let t = super.assembleTitle();
    if (t)
      return t;
    for (const g of this.children)
      if (t = g.assembleTitle(), t)
        return t;
  }
  assembleLayout() {
    return null;
  }
  assembleMarks() {
    return assembleLayerSelectionMarks(this, this.children.flatMap((t) => t.assembleMarks()));
  }
  assembleLegends() {
    return this.children.reduce((t, g) => t.concat(g.assembleLegends()), assembleLegends(this));
  }
}
function buildModel(n, t, g, d, k) {
  if (isFacetSpec(n))
    return new FacetModel(n, t, g, k);
  if (isLayerSpec(n))
    return new LayerModel(n, t, g, d, k);
  if (isUnitSpec(n))
    return new UnitModel(n, t, g, d, k);
  if (isAnyConcatSpec(n))
    return new ConcatModel(n, t, g, k);
  throw new Error(invalidSpec(n));
}
function compile(n, t = {}) {
  t.logger && set(t.logger), t.fieldTitle && setTitleFormatter(t.fieldTitle);
  try {
    const g = initConfig(mergeConfig$2(t.config, n.config)), d = normalize(n, g), k = buildModel(d, null, "", void 0, g);
    return k.parse(), optimizeDataflow(k.component.data, k), {
      spec: assembleTopLevelModel(k, getTopLevelProperties(n, d.autosize, g, k), n.datasets, n.usermeta),
      normalized: d
    };
  } finally {
    t.logger && reset(), t.fieldTitle && resetTitleFormatter();
  }
}
function getTopLevelProperties(n, t, g, d) {
  const k = d.component.layoutSize.get("width"), H = d.component.layoutSize.get("height");
  if (t === void 0 ? (t = { type: "pad" }, d.hasAxisOrientSignalRef() && (t.resize = !0)) : isString$1(t) && (t = { type: t }), k && H && isFitType(t.type)) {
    if (k === "step" && H === "step")
      warn(droppingFit()), t.type = "pad";
    else if (k === "step" || H === "step") {
      const AA = k === "step" ? "width" : "height";
      warn(droppingFit(getPositionScaleChannel(AA)));
      const gA = AA === "width" ? "height" : "width";
      t.type = getFitType(gA);
    }
  }
  return {
    ...keys$1(t).length === 1 && t.type ? t.type === "pad" ? {} : { autosize: t.type } : { autosize: t },
    ...extractTopLevelProperties(g, !1),
    ...extractTopLevelProperties(n, !0)
  };
}
function assembleTopLevelModel(n, t, g = {}, d) {
  const k = n.config ? stripAndRedirectConfig(n.config) : void 0, H = assembleRootData(n.component.data, g), AA = n.assembleSelectionData(H), gA = n.assembleProjections(), IA = n.assembleTitle(), CA = n.assembleGroupStyle(), BA = n.assembleGroupEncodeEntry(!0);
  let eA = n.assembleLayoutSignals();
  eA = eA.filter((tA) => (tA.name === "width" || tA.name === "height") && tA.value !== void 0 ? (t[tA.name] = +tA.value, !1) : !0);
  const { params: iA, ...QA } = t;
  return {
    $schema: "https://vega.github.io/schema/vega/v6.json",
    ...n.description ? { description: n.description } : {},
    ...QA,
    ...IA ? { title: IA } : {},
    ...CA ? { style: CA } : {},
    ...BA ? { encode: { update: BA } } : {},
    data: AA,
    ...gA.length > 0 ? { projections: gA } : {},
    ...n.assembleGroup([
      ...eA,
      ...n.assembleSelectionTopLevelSignals([]),
      ...assembleParameterSignals(iA)
    ]),
    ...k ? { config: k } : {},
    ...d ? { usermeta: d } : {}
  };
}
const version$2 = pkg$1.version, vegaLiteImport = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accessPathDepth,
  accessPathWithDatum,
  accessWithDatumToUnescapedPath,
  compile,
  contains,
  deepEqual,
  deleteNestedProperty,
  duplicate,
  entries: entries$1,
  every,
  fieldIntersection,
  flatAccessWithDatum,
  getFirstDefined,
  hasIntersection,
  hasProperty,
  hash,
  internalField,
  isBoolean: isBoolean$1,
  isEmpty,
  isEqual: isEqual$2,
  isInternalField,
  isNullOrFalse,
  isNumeric,
  keys: keys$1,
  logicalExpr,
  mergeDeep: mergeDeep$1,
  never,
  normalize,
  normalizeAngle,
  omit,
  pick: pick$2,
  prefixGenerator,
  removePathFromField,
  replaceAll,
  replacePathInField,
  resetIdCounter,
  setEqual,
  some,
  stringify: stringify$1,
  titleCase,
  unescapeSingleQuoteAndPathDot,
  unique,
  uniqueId,
  vals,
  varName,
  version: version$2
}, Symbol.toStringTag, { value: "Module" }));
function e(n) {
  const [t, g] = /schema\/([\w-]+)\/([\w\.\-]+)\.json$/g.exec(n).slice(1, 3);
  return { library: t, version: g };
}
var version$1 = "3.0.0", pkg = {
  version: version$1
};
const lightColor = "#fff", medColor = "#888", darkTheme = {
  background: "#333",
  view: {
    stroke: medColor
  },
  title: {
    color: lightColor,
    subtitleColor: lightColor
  },
  style: {
    "guide-label": {
      fill: lightColor
    },
    "guide-title": {
      fill: lightColor
    }
  },
  axis: {
    domainColor: lightColor,
    gridColor: medColor,
    tickColor: lightColor
  }
}, markColor$7 = "#4572a7", excelTheme = {
  background: "#fff",
  arc: { fill: markColor$7 },
  area: { fill: markColor$7 },
  line: { stroke: markColor$7, strokeWidth: 2 },
  path: { stroke: markColor$7 },
  rect: { fill: markColor$7 },
  shape: { stroke: markColor$7 },
  symbol: { fill: markColor$7, strokeWidth: 1.5, size: 50 },
  axis: {
    bandPosition: 0.5,
    grid: !0,
    gridColor: "#000000",
    gridOpacity: 1,
    gridWidth: 0.5,
    labelPadding: 10,
    tickSize: 5,
    tickWidth: 0.5
  },
  axisBand: {
    grid: !1,
    tickExtra: !0
  },
  legend: {
    labelBaseline: "middle",
    labelFontSize: 11,
    symbolSize: 50,
    symbolType: "square"
  },
  range: {
    category: [
      "#4572a7",
      "#aa4643",
      "#8aa453",
      "#71598e",
      "#4598ae",
      "#d98445",
      "#94aace",
      "#d09393",
      "#b9cc98",
      "#a99cbc"
    ]
  }
}, markColor$6 = "#30a2da", axisColor$2 = "#cbcbcb", guideLabelColor = "#999", guideTitleColor = "#333", backgroundColor$2 = "#f0f0f0", blackTitle = "#333", fiveThirtyEightTheme = {
  arc: { fill: markColor$6 },
  area: { fill: markColor$6 },
  axis: {
    domainColor: axisColor$2,
    grid: !0,
    gridColor: axisColor$2,
    gridWidth: 1,
    labelColor: guideLabelColor,
    labelFontSize: 10,
    titleColor: guideTitleColor,
    tickColor: axisColor$2,
    tickSize: 10,
    titleFontSize: 14,
    titlePadding: 10,
    labelPadding: 4
  },
  axisBand: {
    grid: !1
  },
  background: backgroundColor$2,
  group: {
    fill: backgroundColor$2
  },
  legend: {
    labelColor: blackTitle,
    labelFontSize: 11,
    padding: 1,
    symbolSize: 30,
    symbolType: "square",
    titleColor: blackTitle,
    titleFontSize: 14,
    titlePadding: 10
  },
  line: {
    stroke: markColor$6,
    strokeWidth: 2
  },
  path: { stroke: markColor$6, strokeWidth: 0.5 },
  rect: { fill: markColor$6 },
  range: {
    category: [
      "#30a2da",
      "#fc4f30",
      "#e5ae38",
      "#6d904f",
      "#8b8b8b",
      "#b96db8",
      "#ff9e27",
      "#56cc60",
      "#52d2ca",
      "#52689e",
      "#545454",
      "#9fe4f8"
    ],
    diverging: ["#cc0020", "#e77866", "#f6e7e1", "#d6e8ed", "#91bfd9", "#1d78b5"],
    heatmap: ["#d6e8ed", "#cee0e5", "#91bfd9", "#549cc6", "#1d78b5"]
  },
  point: {
    filled: !0,
    shape: "circle"
  },
  shape: { stroke: markColor$6 },
  bar: {
    binSpacing: 2,
    fill: markColor$6,
    stroke: null
  },
  title: {
    anchor: "start",
    fontSize: 24,
    fontWeight: 600,
    offset: 20
  }
}, markColor$5 = "#000", ggplot2Theme = {
  group: {
    fill: "#e5e5e5"
  },
  arc: { fill: markColor$5 },
  area: { fill: markColor$5 },
  line: { stroke: markColor$5 },
  path: { stroke: markColor$5 },
  rect: { fill: markColor$5 },
  shape: { stroke: markColor$5 },
  symbol: { fill: markColor$5, size: 40 },
  axis: {
    domain: !1,
    grid: !0,
    gridColor: "#FFFFFF",
    gridOpacity: 1,
    labelColor: "#7F7F7F",
    labelPadding: 4,
    tickColor: "#7F7F7F",
    tickSize: 5.67,
    titleFontSize: 16,
    titleFontWeight: "normal"
  },
  legend: {
    labelBaseline: "middle",
    labelFontSize: 11,
    symbolSize: 40
  },
  range: {
    category: [
      "#000000",
      "#7F7F7F",
      "#1A1A1A",
      "#999999",
      "#333333",
      "#B0B0B0",
      "#4D4D4D",
      "#C9C9C9",
      "#666666",
      "#DCDCDC"
    ]
  }
}, headlineFontSize = 22, headlineFontWeight = "normal", labelFont$1 = "Benton Gothic, sans-serif", labelFontSize = 11.5, labelFontWeight = "normal", markColor$4 = "#82c6df", titleFont = "Benton Gothic Bold, sans-serif", titleFontWeight = "normal", titleFontSize$1 = 13, colorSchemes$1 = {
  "category-6": ["#ec8431", "#829eb1", "#c89d29", "#3580b1", "#adc839", "#ab7fb4"],
  "fire-7": ["#fbf2c7", "#f9e39c", "#f8d36e", "#f4bb6a", "#e68a4f", "#d15a40", "#ab4232"],
  "fireandice-6": ["#e68a4f", "#f4bb6a", "#f9e39c", "#dadfe2", "#a6b7c6", "#849eae"]
}, latimesTheme = {
  background: "#ffffff",
  title: {
    anchor: "start",
    color: "#000000",
    font: titleFont,
    fontSize: headlineFontSize,
    fontWeight: headlineFontWeight
  },
  arc: { fill: markColor$4 },
  area: { fill: markColor$4 },
  line: { stroke: markColor$4, strokeWidth: 2 },
  path: { stroke: markColor$4 },
  rect: { fill: markColor$4 },
  shape: { stroke: markColor$4 },
  symbol: { fill: markColor$4, size: 30 },
  axis: {
    labelFont: labelFont$1,
    labelFontSize,
    labelFontWeight,
    titleFont,
    titleFontSize: titleFontSize$1,
    titleFontWeight
  },
  axisX: {
    labelAngle: 0,
    labelPadding: 4,
    tickSize: 3
  },
  axisY: {
    labelBaseline: "middle",
    maxExtent: 45,
    minExtent: 45,
    tickSize: 2,
    titleAlign: "left",
    titleAngle: 0,
    titleX: -45,
    titleY: -11
  },
  legend: {
    labelFont: labelFont$1,
    labelFontSize,
    symbolType: "square",
    titleFont,
    titleFontSize: titleFontSize$1,
    titleFontWeight
  },
  range: {
    category: colorSchemes$1["category-6"],
    diverging: colorSchemes$1["fireandice-6"],
    heatmap: colorSchemes$1["fire-7"],
    ordinal: colorSchemes$1["fire-7"],
    ramp: colorSchemes$1["fire-7"]
  }
}, markColor$3 = "#ab5787", axisColor$1 = "#979797", quartzTheme = {
  background: "#f9f9f9",
  arc: { fill: markColor$3 },
  area: { fill: markColor$3 },
  line: { stroke: markColor$3 },
  path: { stroke: markColor$3 },
  rect: { fill: markColor$3 },
  shape: { stroke: markColor$3 },
  symbol: { fill: markColor$3, size: 30 },
  axis: {
    domainColor: axisColor$1,
    domainWidth: 0.5,
    gridWidth: 0.2,
    labelColor: axisColor$1,
    tickColor: axisColor$1,
    tickWidth: 0.2,
    titleColor: axisColor$1
  },
  axisBand: {
    grid: !1
  },
  axisX: {
    grid: !0,
    tickSize: 10
  },
  axisY: {
    domain: !1,
    grid: !0,
    tickSize: 0
  },
  legend: {
    labelFontSize: 11,
    padding: 1,
    symbolSize: 30,
    symbolType: "square"
  },
  range: {
    category: [
      "#ab5787",
      "#51b2e5",
      "#703c5c",
      "#168dd9",
      "#d190b6",
      "#00609f",
      "#d365ba",
      "#154866",
      "#666666",
      "#c4c4c4"
    ]
  }
}, markColor$2 = "#3e5c69", voxTheme = {
  background: "#fff",
  arc: { fill: markColor$2 },
  area: { fill: markColor$2 },
  line: { stroke: markColor$2 },
  path: { stroke: markColor$2 },
  rect: { fill: markColor$2 },
  shape: { stroke: markColor$2 },
  symbol: { fill: markColor$2 },
  axis: {
    domainWidth: 0.5,
    grid: !0,
    labelPadding: 2,
    tickSize: 5,
    tickWidth: 0.5,
    titleFontWeight: "normal"
  },
  axisBand: {
    grid: !1
  },
  axisX: {
    gridWidth: 0.2
  },
  axisY: {
    gridDash: [3],
    gridWidth: 0.4
  },
  legend: {
    labelFontSize: 11,
    padding: 1,
    symbolType: "square"
  },
  range: {
    category: ["#3e5c69", "#6793a6", "#182429", "#0570b0", "#3690c0", "#74a9cf", "#a6bddb", "#e2ddf2"]
  }
}, markColor$1 = "#1696d2", axisColor = "#000000", backgroundColor$1 = "#FFFFFF", font = "Lato", labelFont = "Lato", sourceFont = "Lato", gridColor$1 = "#DEDDDD", titleFontSize = 18, colorSchemes = {
  "shades-blue": ["#CFE8F3", "#A2D4EC", "#73BFE2", "#46ABDB", "#1696D2", "#12719E", "#0A4C6A", "#062635"],
  "six-groups-cat-1": ["#1696d2", "#ec008b", "#fdbf11", "#000000", "#d2d2d2", "#55b748"],
  "six-groups-seq": ["#cfe8f3", "#a2d4ec", "#73bfe2", "#46abdb", "#1696d2", "#12719e"],
  "diverging-colors": ["#ca5800", "#fdbf11", "#fdd870", "#fff2cf", "#cfe8f3", "#73bfe2", "#1696d2", "#0a4c6a"]
}, urbanInstituteTheme = {
  background: backgroundColor$1,
  title: {
    anchor: "start",
    fontSize: titleFontSize,
    font
  },
  axisX: {
    domain: !0,
    domainColor: axisColor,
    domainWidth: 1,
    grid: !1,
    labelFontSize: 12,
    labelFont,
    labelAngle: 0,
    tickColor: axisColor,
    tickSize: 5,
    titleFontSize: 12,
    titlePadding: 10,
    titleFont: font
  },
  axisY: {
    domain: !1,
    domainWidth: 1,
    grid: !0,
    gridColor: gridColor$1,
    gridWidth: 1,
    labelFontSize: 12,
    labelFont,
    labelPadding: 8,
    ticks: !1,
    titleFontSize: 12,
    titlePadding: 10,
    titleFont: font,
    titleAngle: 0,
    titleY: -10,
    titleX: 18
  },
  legend: {
    labelFontSize: 12,
    labelFont,
    symbolSize: 100,
    titleFontSize: 12,
    titlePadding: 10,
    titleFont: font,
    orient: "right",
    offset: 10
  },
  view: {
    stroke: "transparent"
  },
  range: {
    category: colorSchemes["six-groups-cat-1"],
    diverging: colorSchemes["diverging-colors"],
    heatmap: colorSchemes["diverging-colors"],
    ordinal: colorSchemes["six-groups-seq"],
    ramp: colorSchemes["shades-blue"]
  },
  area: {
    fill: markColor$1
  },
  rect: {
    fill: markColor$1
  },
  line: {
    color: markColor$1,
    stroke: markColor$1,
    strokeWidth: 5
  },
  trail: {
    color: markColor$1,
    stroke: markColor$1,
    strokeWidth: 0,
    size: 1
  },
  path: {
    stroke: markColor$1,
    strokeWidth: 0.5
  },
  point: {
    filled: !0
  },
  text: {
    font: sourceFont,
    color: markColor$1,
    fontSize: 11,
    align: "center",
    fontWeight: 400,
    size: 11
  },
  style: {
    bar: {
      fill: markColor$1,
      stroke: null
    }
  },
  arc: { fill: markColor$1 },
  shape: { stroke: markColor$1 },
  symbol: { fill: markColor$1, size: 30 }
}, markColor = "#3366CC", gridColor = "#ccc", defaultFont$1 = "Arial, sans-serif", googlechartsTheme = {
  arc: { fill: markColor },
  area: { fill: markColor },
  path: { stroke: markColor },
  rect: { fill: markColor },
  shape: { stroke: markColor },
  symbol: { stroke: markColor },
  circle: { fill: markColor },
  background: "#fff",
  padding: {
    top: 10,
    right: 10,
    bottom: 10,
    left: 10
  },
  style: {
    "guide-label": {
      font: defaultFont$1,
      fontSize: 12
    },
    "guide-title": {
      font: defaultFont$1,
      fontSize: 12
    },
    "group-title": {
      font: defaultFont$1,
      fontSize: 12
    }
  },
  title: {
    font: defaultFont$1,
    fontSize: 14,
    fontWeight: "bold",
    dy: -3,
    anchor: "start"
  },
  axis: {
    gridColor,
    tickColor: gridColor,
    domain: !1,
    grid: !0
  },
  range: {
    category: [
      "#4285F4",
      "#DB4437",
      "#F4B400",
      "#0F9D58",
      "#AB47BC",
      "#00ACC1",
      "#FF7043",
      "#9E9D24",
      "#5C6BC0",
      "#F06292",
      "#00796B",
      "#C2185B"
    ],
    heatmap: ["#c6dafc", "#5e97f6", "#2a56c6"]
  }
}, ptToPx = (n) => n * (1 / 3 + 1), fontSmallPx = ptToPx(9), legendFontPx = ptToPx(10), fontLargePx = ptToPx(12), fontStandard = "Segoe UI", fontTitle = "wf_standard-font, helvetica, arial, sans-serif", firstLevelElementColor = "#252423", secondLevelElementColor = "#605E5C", backgroundColor = "transparent", backgroundSecondaryColor = "#C8C6C4", paletteColor1 = "#118DFF", paletteColor2 = "#12239E", paletteColor3 = "#E66C37", paletteColor4 = "#6B007B", paletteColor5 = "#E044A7", paletteColor6 = "#744EC2", paletteColor7 = "#D9B300", paletteColor8 = "#D64550", divergentColorMax = paletteColor1, divergentColorMin = "#DEEFFF", divergentPalette = [divergentColorMin, divergentColorMax], ordinalPalette = [
  divergentColorMin,
  "#c7e4ff",
  "#b0d9ff",
  "#9aceff",
  "#83c3ff",
  "#6cb9ff",
  "#55aeff",
  "#3fa3ff",
  "#2898ff",
  divergentColorMax
], powerbiTheme = {
  view: { stroke: backgroundColor },
  background: backgroundColor,
  font: fontStandard,
  header: {
    titleFont: fontTitle,
    titleFontSize: fontLargePx,
    titleColor: firstLevelElementColor,
    labelFont: fontStandard,
    labelFontSize: legendFontPx,
    labelColor: secondLevelElementColor
  },
  axis: {
    ticks: !1,
    grid: !1,
    domain: !1,
    labelColor: secondLevelElementColor,
    labelFontSize: fontSmallPx,
    titleFont: fontTitle,
    titleColor: firstLevelElementColor,
    titleFontSize: fontLargePx,
    titleFontWeight: "normal"
  },
  axisQuantitative: {
    tickCount: 3,
    grid: !0,
    gridColor: backgroundSecondaryColor,
    gridDash: [1, 5],
    labelFlush: !1
  },
  axisBand: { tickExtra: !0 },
  axisX: { labelPadding: 5 },
  axisY: { labelPadding: 10 },
  bar: { fill: paletteColor1 },
  line: {
    stroke: paletteColor1,
    strokeWidth: 3,
    strokeCap: "round",
    strokeJoin: "round"
  },
  text: { font: fontStandard, fontSize: fontSmallPx, fill: secondLevelElementColor },
  arc: { fill: paletteColor1 },
  area: { fill: paletteColor1, line: !0, opacity: 0.6 },
  path: { stroke: paletteColor1 },
  rect: { fill: paletteColor1 },
  point: { fill: paletteColor1, filled: !0, size: 75 },
  shape: { stroke: paletteColor1 },
  symbol: { fill: paletteColor1, strokeWidth: 1.5, size: 50 },
  legend: {
    titleFont: fontStandard,
    titleFontWeight: "bold",
    titleColor: secondLevelElementColor,
    labelFont: fontStandard,
    labelFontSize: legendFontPx,
    labelColor: secondLevelElementColor,
    symbolType: "circle",
    symbolSize: 75
  },
  range: {
    category: [
      paletteColor1,
      paletteColor2,
      paletteColor3,
      paletteColor4,
      paletteColor5,
      paletteColor6,
      paletteColor7,
      paletteColor8
    ],
    diverging: divergentPalette,
    heatmap: divergentPalette,
    ordinal: ordinalPalette
  }
}, defaultFont = 'IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,".sfnstext-regular",sans-serif', condensedFont = 'IBM Plex Sans Condensed, system-ui, -apple-system, BlinkMacSystemFont, ".SFNSText-Regular", sans-serif', fontWeight = 400, TOKENS = {
  textPrimary: { g90: "#f4f4f4", g100: "#f4f4f4", white: "#161616", g10: "#161616" },
  textSecondary: { g90: "#c6c6c6", g100: "#c6c6c6", white: "#525252", g10: "#525252" },
  // layer
  layerAccent01: {
    white: "#e0e0e0",
    g10: "#e0e0e0",
    g90: "#525252",
    g100: "#393939"
  },
  // grid
  gridBg: {
    white: "#ffffff",
    g10: "#ffffff",
    g90: "#161616",
    g100: "#161616"
  }
}, darkCategories = [
  "#8a3ffc",
  "#33b1ff",
  "#007d79",
  "#ff7eb6",
  "#fa4d56",
  "#fff1f1",
  "#6fdc8c",
  "#4589ff",
  "#d12771",
  "#d2a106",
  "#08bdba",
  "#bae6ff",
  "#ba4e00",
  "#d4bbff"
], lightCategories = [
  "#6929c4",
  "#1192e8",
  "#005d5d",
  "#9f1853",
  "#fa4d56",
  "#570408",
  "#198038",
  "#002d9c",
  "#ee538b",
  "#b28600",
  "#009d9a",
  "#012749",
  "#8a3800",
  "#a56eff"
];
function genCarbonConfig({ theme: n, background: t }) {
  const g = ["white", "g10"].includes(n) ? "light" : "dark", d = TOKENS.gridBg[n], k = TOKENS.textPrimary[n], H = TOKENS.textSecondary[n], AA = g === "dark" ? darkCategories : lightCategories, gA = g === "dark" ? "#d4bbff" : "#6929c4";
  return {
    background: t,
    arc: { fill: gA },
    area: { fill: gA },
    path: { stroke: gA },
    rect: { fill: gA },
    shape: { stroke: gA },
    symbol: { stroke: gA },
    circle: { fill: gA },
    view: {
      fill: d,
      stroke: d
    },
    group: {
      fill: d
    },
    title: {
      color: k,
      anchor: "start",
      dy: -15,
      fontSize: 16,
      font: defaultFont,
      fontWeight: 600
    },
    axis: {
      // Axis labels
      labelColor: H,
      labelFontSize: 12,
      labelFont: condensedFont,
      labelFontWeight: fontWeight,
      // Axis titles
      titleColor: k,
      titleFontWeight: 600,
      titleFontSize: 12,
      // MISC
      grid: !0,
      gridColor: TOKENS.layerAccent01[n],
      labelAngle: 0
    },
    axisX: {
      titlePadding: 10
    },
    axisY: {
      titlePadding: 2.5
    },
    style: {
      "guide-label": {
        font: defaultFont,
        fill: H,
        fontWeight
      },
      "guide-title": {
        font: defaultFont,
        fill: H,
        fontWeight
      }
    },
    range: {
      category: AA,
      diverging: [
        "#750e13",
        "#a2191f",
        "#da1e28",
        "#fa4d56",
        "#ff8389",
        "#ffb3b8",
        "#ffd7d9",
        "#fff1f1",
        "#e5f6ff",
        "#bae6ff",
        "#82cfff",
        "#33b1ff",
        "#1192e8",
        "#0072c3",
        "#00539a",
        "#003a6d"
      ],
      heatmap: [
        "#f6f2ff",
        "#e8daff",
        "#d4bbff",
        "#be95ff",
        "#a56eff",
        "#8a3ffc",
        "#6929c4",
        "#491d8b",
        "#31135e",
        "#1c0f30"
      ]
    }
  };
}
const carbonwhite = genCarbonConfig({
  theme: "white",
  background: "#ffffff"
}), carbong10 = genCarbonConfig({
  theme: "g10",
  background: "#f4f4f4"
}), carbong90 = genCarbonConfig({
  theme: "g90",
  background: "#262626"
}), carbong100 = genCarbonConfig({
  theme: "g100",
  background: "#161616"
}), version = pkg.version, themes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  carbong10,
  carbong100,
  carbong90,
  carbonwhite,
  dark: darkTheme,
  excel: excelTheme,
  fivethirtyeight: fiveThirtyEightTheme,
  ggplot2: ggplot2Theme,
  googlecharts: googlechartsTheme,
  latimes: latimesTheme,
  powerbi: powerbiTheme,
  quartz: quartzTheme,
  urbaninstitute: urbanInstituteTheme,
  version,
  vox: voxTheme
}, Symbol.toStringTag, { value: "Module" }));
function formatValue(n, t, g, d) {
  if (isArray$3(n))
    return `[${n.map((k) => t(isString$2(k) ? k : stringify(k, g))).join(", ")}]`;
  if (isObject$4(n)) {
    let k = "";
    const { title: H, image: AA, ...gA } = n;
    H && (k += `<h2>${t(H)}</h2>`), AA && (k += `<img src="${new URL(t(AA), d || location.href).href}">`);
    const IA = Object.keys(gA);
    if (IA.length > 0) {
      k += "<table>";
      for (const CA of IA) {
        let BA = gA[CA];
        BA !== void 0 && (isObject$4(BA) && (BA = stringify(BA, g)), k += `<tr><td class="key">${t(CA)}</td><td class="value">${t(BA)}</td></tr>`);
      }
      k += "</table>";
    }
    return k || "{}";
  }
  return t(n);
}
function replacer(n) {
  const t = [];
  return function(g, d) {
    if (typeof d != "object" || d === null)
      return d;
    const k = t.indexOf(this) + 1;
    return t.length = k, t.length > n ? "[Object]" : t.indexOf(d) >= 0 ? "[Circular]" : (t.push(d), d);
  };
}
function stringify(n, t) {
  return JSON.stringify(n, replacer(t));
}
var defaultStyle = `#vg-tooltip-element {
  visibility: hidden;
  padding: 8px;
  position: fixed;
  z-index: 1000;
  font-family: sans-serif;
  font-size: 11px;
  border-radius: 3px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  /* The default theme is the light theme. */
  background-color: rgba(255, 255, 255, 0.95);
  border: 1px solid #d9d9d9;
  color: black;
}
#vg-tooltip-element.visible {
  visibility: visible;
}
#vg-tooltip-element h2 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 13px;
}
#vg-tooltip-element table {
  border-spacing: 0;
}
#vg-tooltip-element table tr {
  border: none;
}
#vg-tooltip-element table tr td {
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 2px;
  padding-bottom: 2px;
}
#vg-tooltip-element table tr td.key {
  color: #808080;
  max-width: 150px;
  text-align: right;
  padding-right: 4px;
}
#vg-tooltip-element table tr td.value {
  display: block;
  max-width: 300px;
  max-height: 7em;
  text-align: left;
}
#vg-tooltip-element.dark-theme {
  background-color: rgba(32, 32, 32, 0.9);
  border: 1px solid #f5f5f5;
  color: white;
}
#vg-tooltip-element.dark-theme td.key {
  color: #bfbfbf;
}
`;
const EL_ID = "vg-tooltip-element", DEFAULT_OPTIONS = {
  offsetX: 10,
  offsetY: 10,
  id: EL_ID,
  styleId: "vega-tooltip-style",
  theme: "light",
  disableDefaultStyle: !1,
  sanitize: escapeHTML,
  maxDepth: 2,
  formatTooltip: formatValue,
  baseURL: "",
  anchor: "cursor",
  position: ["top", "bottom", "left", "right", "top-left", "top-right", "bottom-left", "bottom-right"]
};
function escapeHTML(n) {
  return String(n).replace(/&/g, "&amp;").replace(/</g, "&lt;");
}
function createDefaultStyle(n) {
  if (!/^[A-Za-z]+[-:.\w]*$/.test(n))
    throw new Error("Invalid HTML ID");
  return defaultStyle.toString().replaceAll(EL_ID, n);
}
function calculatePositionRelativeToCursor(n, t, { offsetX: g, offsetY: d }) {
  const k = getPositions({ x1: n.clientX, x2: n.clientX, y1: n.clientY, y2: n.clientY }, t, g, d), H = ["bottom-right", "bottom-left", "top-right", "top-left"];
  for (const AA of H)
    if (tooltipIsInViewport(k[AA], t))
      return k[AA];
  return k["top-left"];
}
function calculatePositionRelativeToMark(n, t, g, d, k) {
  const { position: H, offsetX: AA, offsetY: gA } = k, IA = n._el.getBoundingClientRect(), CA = n._origin, BA = getMarkBounds(IA, CA, g), eA = getPositions(BA, d, AA, gA), iA = Array.isArray(H) ? H : [H];
  for (const QA of iA)
    if (tooltipIsInViewport(eA[QA], d) && !mouseIsOnTooltip(t, eA[QA], d))
      return eA[QA];
  return calculatePositionRelativeToCursor(t, d, k);
}
function getMarkBounds(n, t, g) {
  const d = g.isVoronoi ? g.datum.bounds : g.bounds;
  let k = n.left + t[0] + d.x1, H = n.top + t[1] + d.y1, AA = g;
  for (; AA.mark.group; )
    AA = AA.mark.group, k += AA.x ?? 0, H += AA.y ?? 0;
  const gA = d.x2 - d.x1, IA = d.y2 - d.y1;
  return {
    x1: k,
    x2: k + gA,
    y1: H,
    y2: H + IA
  };
}
function getPositions(n, t, g, d) {
  const k = (n.x1 + n.x2) / 2, H = (n.y1 + n.y2) / 2, AA = n.x1 - t.width - g, gA = k - t.width / 2, IA = n.x2 + g, CA = n.y1 - t.height - d, BA = H - t.height / 2, eA = n.y2 + d;
  return {
    top: { x: gA, y: CA },
    bottom: { x: gA, y: eA },
    left: { x: AA, y: BA },
    right: { x: IA, y: BA },
    "top-left": { x: AA, y: CA },
    "top-right": { x: IA, y: CA },
    "bottom-left": { x: AA, y: eA },
    "bottom-right": { x: IA, y: eA }
  };
}
function tooltipIsInViewport(n, t) {
  return n.x >= 0 && n.y >= 0 && n.x + t.width <= window.innerWidth && n.y + t.height <= window.innerHeight;
}
function mouseIsOnTooltip(n, t, g) {
  return n.clientX >= t.x && n.clientX <= t.x + g.width && n.clientY >= t.y && n.clientY <= t.y + g.height;
}
class Handler {
  /**
   * The handler function. We bind this to this function in the constructor.
   */
  call;
  /**
   * Complete tooltip options.
   */
  options;
  /**
   * The tooltip html element.
   */
  el;
  /**
   * Create the tooltip handler and initialize the element and style.
   *
   * @param options Tooltip Options
   */
  constructor(t) {
    this.options = { ...DEFAULT_OPTIONS, ...t };
    const g = this.options.id;
    if (this.el = null, this.call = this.tooltipHandler.bind(this), !this.options.disableDefaultStyle && !document.getElementById(this.options.styleId)) {
      const d = document.createElement("style");
      d.setAttribute("id", this.options.styleId), d.innerHTML = createDefaultStyle(g);
      const k = document.head;
      k.childNodes.length > 0 ? k.insertBefore(d, k.childNodes[0]) : k.appendChild(d);
    }
  }
  /**
   * The tooltip handler function.
   */
  tooltipHandler(t, g, d, k) {
    if (this.el = document.getElementById(this.options.id), this.el || (this.el = document.createElement("div"), this.el.setAttribute("id", this.options.id), this.el.classList.add("vg-tooltip"), (document.fullscreenElement ?? document.body).appendChild(this.el)), k == null || k === "") {
      this.el.classList.remove("visible", `${this.options.theme}-theme`);
      return;
    }
    this.el.innerHTML = this.options.formatTooltip(k, this.options.sanitize, this.options.maxDepth, this.options.baseURL), this.el.classList.add("visible", `${this.options.theme}-theme`);
    const { x: H, y: AA } = this.options.anchor === "mark" ? calculatePositionRelativeToMark(t, g, d, this.el.getBoundingClientRect(), this.options) : calculatePositionRelativeToCursor(g, this.el.getBoundingClientRect(), this.options);
    this.el.style.top = `${AA}px`, this.el.style.left = `${H}px`;
  }
}
var __extends$1 = /* @__PURE__ */ (function() {
  var n = function(t, g) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, k) {
      d.__proto__ = k;
    } || function(d, k) {
      for (var H in k) k.hasOwnProperty(H) && (d[H] = k[H]);
    }, n(t, g);
  };
  return function(t, g) {
    n(t, g);
    function d() {
      this.constructor = t;
    }
    t.prototype = g === null ? Object.create(g) : (d.prototype = g.prototype, new d());
  };
})(), _hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty$d(n, t) {
  return _hasOwnProperty.call(n, t);
}
function _objectKeys(n) {
  if (Array.isArray(n)) {
    for (var t = new Array(n.length), g = 0; g < t.length; g++)
      t[g] = "" + g;
    return t;
  }
  if (Object.keys)
    return Object.keys(n);
  var d = [];
  for (var k in n)
    hasOwnProperty$d(n, k) && d.push(k);
  return d;
}
function _deepClone(n) {
  switch (typeof n) {
    case "object":
      return JSON.parse(JSON.stringify(n));
    //Faster than ES5 clone - http://jsperf.com/deep-cloning-of-objects/5
    case "undefined":
      return null;
    //this is how JSON.stringify behaves for array items
    default:
      return n;
  }
}
function isInteger(n) {
  for (var t = 0, g = n.length, d; t < g; ) {
    if (d = n.charCodeAt(t), d >= 48 && d <= 57) {
      t++;
      continue;
    }
    return !1;
  }
  return !0;
}
function escapePathComponent(n) {
  return n.indexOf("/") === -1 && n.indexOf("~") === -1 ? n : n.replace(/~/g, "~0").replace(/\//g, "~1");
}
function unescapePathComponent(n) {
  return n.replace(/~1/g, "/").replace(/~0/g, "~");
}
function hasUndefined(n) {
  if (n === void 0)
    return !0;
  if (n) {
    if (Array.isArray(n)) {
      for (var t = 0, g = n.length; t < g; t++)
        if (hasUndefined(n[t]))
          return !0;
    } else if (typeof n == "object") {
      for (var d = _objectKeys(n), k = d.length, H = 0; H < k; H++)
        if (hasUndefined(n[d[H]]))
          return !0;
    }
  }
  return !1;
}
function patchErrorMessageFormatter(n, t) {
  var g = [n];
  for (var d in t) {
    var k = typeof t[d] == "object" ? JSON.stringify(t[d], null, 2) : t[d];
    typeof k < "u" && g.push(d + ": " + k);
  }
  return g.join(`
`);
}
var PatchError = (
  /** @class */
  (function(n) {
    __extends$1(t, n);
    function t(g, d, k, H, AA) {
      var gA = this.constructor, IA = n.call(this, patchErrorMessageFormatter(g, { name: d, index: k, operation: H, tree: AA })) || this;
      return IA.name = d, IA.index = k, IA.operation = H, IA.tree = AA, Object.setPrototypeOf(IA, gA.prototype), IA.message = patchErrorMessageFormatter(g, { name: d, index: k, operation: H, tree: AA }), IA;
    }
    return t;
  })(Error)
), JsonPatchError = PatchError, deepClone = _deepClone, objOps = {
  add: function(n, t, g) {
    return n[t] = this.value, { newDocument: g };
  },
  remove: function(n, t, g) {
    var d = n[t];
    return delete n[t], { newDocument: g, removed: d };
  },
  replace: function(n, t, g) {
    var d = n[t];
    return n[t] = this.value, { newDocument: g, removed: d };
  },
  move: function(n, t, g) {
    var d = getValueByPointer(g, this.path);
    d && (d = _deepClone(d));
    var k = applyOperation(g, { op: "remove", path: this.from }).removed;
    return applyOperation(g, { op: "add", path: this.path, value: k }), { newDocument: g, removed: d };
  },
  copy: function(n, t, g) {
    var d = getValueByPointer(g, this.from);
    return applyOperation(g, { op: "add", path: this.path, value: _deepClone(d) }), { newDocument: g };
  },
  test: function(n, t, g) {
    return { newDocument: g, test: _areEquals(n[t], this.value) };
  },
  _get: function(n, t, g) {
    return this.value = n[t], { newDocument: g };
  }
}, arrOps = {
  add: function(n, t, g) {
    return isInteger(t) ? n.splice(t, 0, this.value) : n[t] = this.value, { newDocument: g, index: t };
  },
  remove: function(n, t, g) {
    var d = n.splice(t, 1);
    return { newDocument: g, removed: d[0] };
  },
  replace: function(n, t, g) {
    var d = n[t];
    return n[t] = this.value, { newDocument: g, removed: d };
  },
  move: objOps.move,
  copy: objOps.copy,
  test: objOps.test,
  _get: objOps._get
};
function getValueByPointer(n, t) {
  if (t == "")
    return n;
  var g = { op: "_get", path: t };
  return applyOperation(n, g), g.value;
}
function applyOperation(n, t, g, d, k, H) {
  if (g === void 0 && (g = !1), d === void 0 && (d = !0), k === void 0 && (k = !0), H === void 0 && (H = 0), g && (typeof g == "function" ? g(t, 0, n, t.path) : validator$1(t, 0)), t.path === "") {
    var AA = { newDocument: n };
    if (t.op === "add")
      return AA.newDocument = t.value, AA;
    if (t.op === "replace")
      return AA.newDocument = t.value, AA.removed = n, AA;
    if (t.op === "move" || t.op === "copy")
      return AA.newDocument = getValueByPointer(n, t.from), t.op === "move" && (AA.removed = n), AA;
    if (t.op === "test") {
      if (AA.test = _areEquals(n, t.value), AA.test === !1)
        throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", H, t, n);
      return AA.newDocument = n, AA;
    } else {
      if (t.op === "remove")
        return AA.removed = n, AA.newDocument = null, AA;
      if (t.op === "_get")
        return t.value = n, AA;
      if (g)
        throw new JsonPatchError("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", H, t, n);
      return AA;
    }
  } else {
    d || (n = _deepClone(n));
    var gA = t.path || "", IA = gA.split("/"), CA = n, BA = 1, eA = IA.length, iA = void 0, QA = void 0, tA = void 0;
    for (typeof g == "function" ? tA = g : tA = validator$1; ; ) {
      if (QA = IA[BA], QA && QA.indexOf("~") != -1 && (QA = unescapePathComponent(QA)), k && (QA == "__proto__" || QA == "prototype" && BA > 0 && IA[BA - 1] == "constructor"))
        throw new TypeError("JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
      if (g && iA === void 0 && (CA[QA] === void 0 ? iA = IA.slice(0, BA).join("/") : BA == eA - 1 && (iA = t.path), iA !== void 0 && tA(t, 0, n, iA)), BA++, Array.isArray(CA)) {
        if (QA === "-")
          QA = CA.length;
        else {
          if (g && !isInteger(QA))
            throw new JsonPatchError("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", H, t, n);
          isInteger(QA) && (QA = ~~QA);
        }
        if (BA >= eA) {
          if (g && t.op === "add" && QA > CA.length)
            throw new JsonPatchError("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", H, t, n);
          var AA = arrOps[t.op].call(t, CA, QA, n);
          if (AA.test === !1)
            throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", H, t, n);
          return AA;
        }
      } else if (BA >= eA) {
        var AA = objOps[t.op].call(t, CA, QA, n);
        if (AA.test === !1)
          throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", H, t, n);
        return AA;
      }
      if (CA = CA[QA], g && BA < eA && (!CA || typeof CA != "object"))
        throw new JsonPatchError("Cannot perform operation at the desired path", "OPERATION_PATH_UNRESOLVABLE", H, t, n);
    }
  }
}
function applyPatch(n, t, g, d, k) {
  if (d === void 0 && (d = !0), k === void 0 && (k = !0), g && !Array.isArray(t))
    throw new JsonPatchError("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
  d || (n = _deepClone(n));
  for (var H = new Array(t.length), AA = 0, gA = t.length; AA < gA; AA++)
    H[AA] = applyOperation(n, t[AA], g, !0, k, AA), n = H[AA].newDocument;
  return H.newDocument = n, H;
}
function applyReducer(n, t, g) {
  var d = applyOperation(n, t);
  if (d.test === !1)
    throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", g, t, n);
  return d.newDocument;
}
function validator$1(n, t, g, d) {
  if (typeof n != "object" || n === null || Array.isArray(n))
    throw new JsonPatchError("Operation is not an object", "OPERATION_NOT_AN_OBJECT", t, n, g);
  if (objOps[n.op]) {
    if (typeof n.path != "string")
      throw new JsonPatchError("Operation `path` property is not a string", "OPERATION_PATH_INVALID", t, n, g);
    if (n.path.indexOf("/") !== 0 && n.path.length > 0)
      throw new JsonPatchError('Operation `path` property must start with "/"', "OPERATION_PATH_INVALID", t, n, g);
    if ((n.op === "move" || n.op === "copy") && typeof n.from != "string")
      throw new JsonPatchError("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", t, n, g);
    if ((n.op === "add" || n.op === "replace" || n.op === "test") && n.value === void 0)
      throw new JsonPatchError("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", t, n, g);
    if ((n.op === "add" || n.op === "replace" || n.op === "test") && hasUndefined(n.value))
      throw new JsonPatchError("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", t, n, g);
    if (g) {
      if (n.op == "add") {
        var k = n.path.split("/").length, H = d.split("/").length;
        if (k !== H + 1 && k !== H)
          throw new JsonPatchError("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", t, n, g);
      } else if (n.op === "replace" || n.op === "remove" || n.op === "_get") {
        if (n.path !== d)
          throw new JsonPatchError("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", t, n, g);
      } else if (n.op === "move" || n.op === "copy") {
        var AA = { op: "_get", path: n.from, value: void 0 }, gA = validate([AA], g);
        if (gA && gA.name === "OPERATION_PATH_UNRESOLVABLE")
          throw new JsonPatchError("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", t, n, g);
      }
    }
  } else throw new JsonPatchError("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", t, n, g);
}
function validate(n, t, g) {
  try {
    if (!Array.isArray(n))
      throw new JsonPatchError("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    if (t)
      applyPatch(_deepClone(t), _deepClone(n), g || !0);
    else {
      g = g || validator$1;
      for (var d = 0; d < n.length; d++)
        g(n[d], d, t, void 0);
    }
  } catch (k) {
    if (k instanceof JsonPatchError)
      return k;
    throw k;
  }
}
function _areEquals(n, t) {
  if (n === t)
    return !0;
  if (n && t && typeof n == "object" && typeof t == "object") {
    var g = Array.isArray(n), d = Array.isArray(t), k, H, AA;
    if (g && d) {
      if (H = n.length, H != t.length)
        return !1;
      for (k = H; k-- !== 0; )
        if (!_areEquals(n[k], t[k]))
          return !1;
      return !0;
    }
    if (g != d)
      return !1;
    var gA = Object.keys(n);
    if (H = gA.length, H !== Object.keys(t).length)
      return !1;
    for (k = H; k-- !== 0; )
      if (!t.hasOwnProperty(gA[k]))
        return !1;
    for (k = H; k-- !== 0; )
      if (AA = gA[k], !_areEquals(n[AA], t[AA]))
        return !1;
    return !0;
  }
  return n !== n && t !== t;
}
var core = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  JsonPatchError,
  _areEquals,
  applyOperation,
  applyPatch,
  applyReducer,
  deepClone,
  getValueByPointer,
  validate,
  validator: validator$1
});
var beforeDict = /* @__PURE__ */ new WeakMap(), Mirror = (
  /** @class */
  /* @__PURE__ */ (function() {
    function n(t) {
      this.observers = /* @__PURE__ */ new Map(), this.obj = t;
    }
    return n;
  })()
), ObserverInfo = (
  /** @class */
  /* @__PURE__ */ (function() {
    function n(t, g) {
      this.callback = t, this.observer = g;
    }
    return n;
  })()
);
function getMirror(n) {
  return beforeDict.get(n);
}
function getObserverFromMirror(n, t) {
  return n.observers.get(t);
}
function removeObserverFromMirror(n, t) {
  n.observers.delete(t.callback);
}
function unobserve$1(n, t) {
  t.unobserve();
}
function observe$1(n, t) {
  var g = [], d, k = getMirror(n);
  if (!k)
    k = new Mirror(n), beforeDict.set(n, k);
  else {
    var H = getObserverFromMirror(k, t);
    d = H && H.observer;
  }
  if (d)
    return d;
  if (d = {}, k.value = _deepClone(n), t) {
    d.callback = t, d.next = null;
    var AA = function() {
      generate(d);
    }, gA = function() {
      clearTimeout(d.next), d.next = setTimeout(AA);
    };
    typeof window < "u" && (window.addEventListener("mouseup", gA), window.addEventListener("keyup", gA), window.addEventListener("mousedown", gA), window.addEventListener("keydown", gA), window.addEventListener("change", gA));
  }
  return d.patches = g, d.object = n, d.unobserve = function() {
    generate(d), clearTimeout(d.next), removeObserverFromMirror(k, d), typeof window < "u" && (window.removeEventListener("mouseup", gA), window.removeEventListener("keyup", gA), window.removeEventListener("mousedown", gA), window.removeEventListener("keydown", gA), window.removeEventListener("change", gA));
  }, k.observers.set(t, new ObserverInfo(t, d)), d;
}
function generate(n, t) {
  t === void 0 && (t = !1);
  var g = beforeDict.get(n.object);
  _generate(g.value, n.object, n.patches, "", t), n.patches.length && applyPatch(g.value, n.patches);
  var d = n.patches;
  return d.length > 0 && (n.patches = [], n.callback && n.callback(d)), d;
}
function _generate(n, t, g, d, k) {
  if (t !== n) {
    typeof t.toJSON == "function" && (t = t.toJSON());
    for (var H = _objectKeys(t), AA = _objectKeys(n), gA = !1, IA = AA.length - 1; IA >= 0; IA--) {
      var CA = AA[IA], BA = n[CA];
      if (hasOwnProperty$d(t, CA) && !(t[CA] === void 0 && BA !== void 0 && Array.isArray(t) === !1)) {
        var eA = t[CA];
        typeof BA == "object" && BA != null && typeof eA == "object" && eA != null && Array.isArray(BA) === Array.isArray(eA) ? _generate(BA, eA, g, d + "/" + escapePathComponent(CA), k) : BA !== eA && (k && g.push({ op: "test", path: d + "/" + escapePathComponent(CA), value: _deepClone(BA) }), g.push({ op: "replace", path: d + "/" + escapePathComponent(CA), value: _deepClone(eA) }));
      } else Array.isArray(n) === Array.isArray(t) ? (k && g.push({ op: "test", path: d + "/" + escapePathComponent(CA), value: _deepClone(BA) }), g.push({ op: "remove", path: d + "/" + escapePathComponent(CA) }), gA = !0) : (k && g.push({ op: "test", path: d, value: n }), g.push({ op: "replace", path: d, value: t }));
    }
    if (!(!gA && H.length == AA.length))
      for (var IA = 0; IA < H.length; IA++) {
        var CA = H[IA];
        !hasOwnProperty$d(n, CA) && t[CA] !== void 0 && g.push({ op: "add", path: d + "/" + escapePathComponent(CA), value: _deepClone(t[CA]) });
      }
  }
}
function compare$1(n, t, g) {
  g === void 0 && (g = !1);
  var d = [];
  return _generate(n, t, d, "", g), d;
}
var duplex = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  compare: compare$1,
  generate,
  observe: observe$1,
  unobserve: unobserve$1
});
Object.assign({}, core, duplex, {
  JsonPatchError: PatchError,
  deepClone: _deepClone,
  escapePathComponent,
  unescapePathComponent
});
function getDefaultExportFromCjs(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var lrucache, hasRequiredLrucache;
function requireLrucache() {
  if (hasRequiredLrucache) return lrucache;
  hasRequiredLrucache = 1;
  class n {
    constructor() {
      this.max = 1e3, this.map = /* @__PURE__ */ new Map();
    }
    get(g) {
      const d = this.map.get(g);
      if (d !== void 0)
        return this.map.delete(g), this.map.set(g, d), d;
    }
    delete(g) {
      return this.map.delete(g);
    }
    set(g, d) {
      if (!this.delete(g) && d !== void 0) {
        if (this.map.size >= this.max) {
          const H = this.map.keys().next().value;
          this.delete(H);
        }
        this.map.set(g, d);
      }
      return this;
    }
  }
  return lrucache = n, lrucache;
}
var parseOptions_1, hasRequiredParseOptions;
function requireParseOptions() {
  if (hasRequiredParseOptions) return parseOptions_1;
  hasRequiredParseOptions = 1;
  const n = Object.freeze({ loose: !0 }), t = Object.freeze({});
  return parseOptions_1 = (d) => d ? typeof d != "object" ? n : d : t, parseOptions_1;
}
var re = { exports: {} }, constants, hasRequiredConstants;
function requireConstants() {
  if (hasRequiredConstants) return constants;
  hasRequiredConstants = 1;
  const n = "2.0.0", t = 256, g = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
  9007199254740991, d = 16, k = t - 6;
  return constants = {
    MAX_LENGTH: t,
    MAX_SAFE_COMPONENT_LENGTH: d,
    MAX_SAFE_BUILD_LENGTH: k,
    MAX_SAFE_INTEGER: g,
    RELEASE_TYPES: [
      "major",
      "premajor",
      "minor",
      "preminor",
      "patch",
      "prepatch",
      "prerelease"
    ],
    SEMVER_SPEC_VERSION: n,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
  }, constants;
}
var debug_1, hasRequiredDebug;
function requireDebug() {
  return hasRequiredDebug || (hasRequiredDebug = 1, debug_1 = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...t) => console.error("SEMVER", ...t) : () => {
  }), debug_1;
}
var hasRequiredRe;
function requireRe() {
  return hasRequiredRe || (hasRequiredRe = 1, (function(n, t) {
    const {
      MAX_SAFE_COMPONENT_LENGTH: g,
      MAX_SAFE_BUILD_LENGTH: d,
      MAX_LENGTH: k
    } = requireConstants(), H = requireDebug();
    t = n.exports = {};
    const AA = t.re = [], gA = t.safeRe = [], IA = t.src = [], CA = t.safeSrc = [], BA = t.t = {};
    let eA = 0;
    const iA = "[a-zA-Z0-9-]", QA = [
      ["\\s", 1],
      ["\\d", k],
      [iA, d]
    ], tA = (EA) => {
      for (const [aA, nA] of QA)
        EA = EA.split(`${aA}*`).join(`${aA}{0,${nA}}`).split(`${aA}+`).join(`${aA}{1,${nA}}`);
      return EA;
    }, oA = (EA, aA, nA) => {
      const lA = tA(aA), cA = eA++;
      H(EA, cA, aA), BA[EA] = cA, IA[cA] = aA, CA[cA] = lA, AA[cA] = new RegExp(aA, nA ? "g" : void 0), gA[cA] = new RegExp(lA, nA ? "g" : void 0);
    };
    oA("NUMERICIDENTIFIER", "0|[1-9]\\d*"), oA("NUMERICIDENTIFIERLOOSE", "\\d+"), oA("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${iA}*`), oA("MAINVERSION", `(${IA[BA.NUMERICIDENTIFIER]})\\.(${IA[BA.NUMERICIDENTIFIER]})\\.(${IA[BA.NUMERICIDENTIFIER]})`), oA("MAINVERSIONLOOSE", `(${IA[BA.NUMERICIDENTIFIERLOOSE]})\\.(${IA[BA.NUMERICIDENTIFIERLOOSE]})\\.(${IA[BA.NUMERICIDENTIFIERLOOSE]})`), oA("PRERELEASEIDENTIFIER", `(?:${IA[BA.NONNUMERICIDENTIFIER]}|${IA[BA.NUMERICIDENTIFIER]})`), oA("PRERELEASEIDENTIFIERLOOSE", `(?:${IA[BA.NONNUMERICIDENTIFIER]}|${IA[BA.NUMERICIDENTIFIERLOOSE]})`), oA("PRERELEASE", `(?:-(${IA[BA.PRERELEASEIDENTIFIER]}(?:\\.${IA[BA.PRERELEASEIDENTIFIER]})*))`), oA("PRERELEASELOOSE", `(?:-?(${IA[BA.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${IA[BA.PRERELEASEIDENTIFIERLOOSE]})*))`), oA("BUILDIDENTIFIER", `${iA}+`), oA("BUILD", `(?:\\+(${IA[BA.BUILDIDENTIFIER]}(?:\\.${IA[BA.BUILDIDENTIFIER]})*))`), oA("FULLPLAIN", `v?${IA[BA.MAINVERSION]}${IA[BA.PRERELEASE]}?${IA[BA.BUILD]}?`), oA("FULL", `^${IA[BA.FULLPLAIN]}$`), oA("LOOSEPLAIN", `[v=\\s]*${IA[BA.MAINVERSIONLOOSE]}${IA[BA.PRERELEASELOOSE]}?${IA[BA.BUILD]}?`), oA("LOOSE", `^${IA[BA.LOOSEPLAIN]}$`), oA("GTLT", "((?:<|>)?=?)"), oA("XRANGEIDENTIFIERLOOSE", `${IA[BA.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), oA("XRANGEIDENTIFIER", `${IA[BA.NUMERICIDENTIFIER]}|x|X|\\*`), oA("XRANGEPLAIN", `[v=\\s]*(${IA[BA.XRANGEIDENTIFIER]})(?:\\.(${IA[BA.XRANGEIDENTIFIER]})(?:\\.(${IA[BA.XRANGEIDENTIFIER]})(?:${IA[BA.PRERELEASE]})?${IA[BA.BUILD]}?)?)?`), oA("XRANGEPLAINLOOSE", `[v=\\s]*(${IA[BA.XRANGEIDENTIFIERLOOSE]})(?:\\.(${IA[BA.XRANGEIDENTIFIERLOOSE]})(?:\\.(${IA[BA.XRANGEIDENTIFIERLOOSE]})(?:${IA[BA.PRERELEASELOOSE]})?${IA[BA.BUILD]}?)?)?`), oA("XRANGE", `^${IA[BA.GTLT]}\\s*${IA[BA.XRANGEPLAIN]}$`), oA("XRANGELOOSE", `^${IA[BA.GTLT]}\\s*${IA[BA.XRANGEPLAINLOOSE]}$`), oA("COERCEPLAIN", `(^|[^\\d])(\\d{1,${g}})(?:\\.(\\d{1,${g}}))?(?:\\.(\\d{1,${g}}))?`), oA("COERCE", `${IA[BA.COERCEPLAIN]}(?:$|[^\\d])`), oA("COERCEFULL", IA[BA.COERCEPLAIN] + `(?:${IA[BA.PRERELEASE]})?(?:${IA[BA.BUILD]})?(?:$|[^\\d])`), oA("COERCERTL", IA[BA.COERCE], !0), oA("COERCERTLFULL", IA[BA.COERCEFULL], !0), oA("LONETILDE", "(?:~>?)"), oA("TILDETRIM", `(\\s*)${IA[BA.LONETILDE]}\\s+`, !0), t.tildeTrimReplace = "$1~", oA("TILDE", `^${IA[BA.LONETILDE]}${IA[BA.XRANGEPLAIN]}$`), oA("TILDELOOSE", `^${IA[BA.LONETILDE]}${IA[BA.XRANGEPLAINLOOSE]}$`), oA("LONECARET", "(?:\\^)"), oA("CARETTRIM", `(\\s*)${IA[BA.LONECARET]}\\s+`, !0), t.caretTrimReplace = "$1^", oA("CARET", `^${IA[BA.LONECARET]}${IA[BA.XRANGEPLAIN]}$`), oA("CARETLOOSE", `^${IA[BA.LONECARET]}${IA[BA.XRANGEPLAINLOOSE]}$`), oA("COMPARATORLOOSE", `^${IA[BA.GTLT]}\\s*(${IA[BA.LOOSEPLAIN]})$|^$`), oA("COMPARATOR", `^${IA[BA.GTLT]}\\s*(${IA[BA.FULLPLAIN]})$|^$`), oA("COMPARATORTRIM", `(\\s*)${IA[BA.GTLT]}\\s*(${IA[BA.LOOSEPLAIN]}|${IA[BA.XRANGEPLAIN]})`, !0), t.comparatorTrimReplace = "$1$2$3", oA("HYPHENRANGE", `^\\s*(${IA[BA.XRANGEPLAIN]})\\s+-\\s+(${IA[BA.XRANGEPLAIN]})\\s*$`), oA("HYPHENRANGELOOSE", `^\\s*(${IA[BA.XRANGEPLAINLOOSE]})\\s+-\\s+(${IA[BA.XRANGEPLAINLOOSE]})\\s*$`), oA("STAR", "(<|>)?=?\\s*\\*"), oA("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), oA("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
  })(re, re.exports)), re.exports;
}
var identifiers, hasRequiredIdentifiers;
function requireIdentifiers() {
  if (hasRequiredIdentifiers) return identifiers;
  hasRequiredIdentifiers = 1;
  const n = /^[0-9]+$/, t = (d, k) => {
    const H = n.test(d), AA = n.test(k);
    return H && AA && (d = +d, k = +k), d === k ? 0 : H && !AA ? -1 : AA && !H ? 1 : d < k ? -1 : 1;
  };
  return identifiers = {
    compareIdentifiers: t,
    rcompareIdentifiers: (d, k) => t(k, d)
  }, identifiers;
}
var semver, hasRequiredSemver;
function requireSemver() {
  if (hasRequiredSemver) return semver;
  hasRequiredSemver = 1;
  const n = requireDebug(), { MAX_LENGTH: t, MAX_SAFE_INTEGER: g } = requireConstants(), { safeRe: d, t: k } = requireRe(), H = requireParseOptions(), { compareIdentifiers: AA } = requireIdentifiers();
  class gA {
    constructor(CA, BA) {
      if (BA = H(BA), CA instanceof gA) {
        if (CA.loose === !!BA.loose && CA.includePrerelease === !!BA.includePrerelease)
          return CA;
        CA = CA.version;
      } else if (typeof CA != "string")
        throw new TypeError(`Invalid version. Must be a string. Got type "${typeof CA}".`);
      if (CA.length > t)
        throw new TypeError(
          `version is longer than ${t} characters`
        );
      n("SemVer", CA, BA), this.options = BA, this.loose = !!BA.loose, this.includePrerelease = !!BA.includePrerelease;
      const eA = CA.trim().match(BA.loose ? d[k.LOOSE] : d[k.FULL]);
      if (!eA)
        throw new TypeError(`Invalid Version: ${CA}`);
      if (this.raw = CA, this.major = +eA[1], this.minor = +eA[2], this.patch = +eA[3], this.major > g || this.major < 0)
        throw new TypeError("Invalid major version");
      if (this.minor > g || this.minor < 0)
        throw new TypeError("Invalid minor version");
      if (this.patch > g || this.patch < 0)
        throw new TypeError("Invalid patch version");
      eA[4] ? this.prerelease = eA[4].split(".").map((iA) => {
        if (/^[0-9]+$/.test(iA)) {
          const QA = +iA;
          if (QA >= 0 && QA < g)
            return QA;
        }
        return iA;
      }) : this.prerelease = [], this.build = eA[5] ? eA[5].split(".") : [], this.format();
    }
    format() {
      return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
    }
    toString() {
      return this.version;
    }
    compare(CA) {
      if (n("SemVer.compare", this.version, this.options, CA), !(CA instanceof gA)) {
        if (typeof CA == "string" && CA === this.version)
          return 0;
        CA = new gA(CA, this.options);
      }
      return CA.version === this.version ? 0 : this.compareMain(CA) || this.comparePre(CA);
    }
    compareMain(CA) {
      return CA instanceof gA || (CA = new gA(CA, this.options)), AA(this.major, CA.major) || AA(this.minor, CA.minor) || AA(this.patch, CA.patch);
    }
    comparePre(CA) {
      if (CA instanceof gA || (CA = new gA(CA, this.options)), this.prerelease.length && !CA.prerelease.length)
        return -1;
      if (!this.prerelease.length && CA.prerelease.length)
        return 1;
      if (!this.prerelease.length && !CA.prerelease.length)
        return 0;
      let BA = 0;
      do {
        const eA = this.prerelease[BA], iA = CA.prerelease[BA];
        if (n("prerelease compare", BA, eA, iA), eA === void 0 && iA === void 0)
          return 0;
        if (iA === void 0)
          return 1;
        if (eA === void 0)
          return -1;
        if (eA === iA)
          continue;
        return AA(eA, iA);
      } while (++BA);
    }
    compareBuild(CA) {
      CA instanceof gA || (CA = new gA(CA, this.options));
      let BA = 0;
      do {
        const eA = this.build[BA], iA = CA.build[BA];
        if (n("build compare", BA, eA, iA), eA === void 0 && iA === void 0)
          return 0;
        if (iA === void 0)
          return 1;
        if (eA === void 0)
          return -1;
        if (eA === iA)
          continue;
        return AA(eA, iA);
      } while (++BA);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(CA, BA, eA) {
      if (CA.startsWith("pre")) {
        if (!BA && eA === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (BA) {
          const iA = `-${BA}`.match(this.options.loose ? d[k.PRERELEASELOOSE] : d[k.PRERELEASE]);
          if (!iA || iA[1] !== BA)
            throw new Error(`invalid identifier: ${BA}`);
        }
      }
      switch (CA) {
        case "premajor":
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", BA, eA);
          break;
        case "preminor":
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", BA, eA);
          break;
        case "prepatch":
          this.prerelease.length = 0, this.inc("patch", BA, eA), this.inc("pre", BA, eA);
          break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case "prerelease":
          this.prerelease.length === 0 && this.inc("patch", BA, eA), this.inc("pre", BA, eA);
          break;
        case "release":
          if (this.prerelease.length === 0)
            throw new Error(`version ${this.raw} is not a prerelease`);
          this.prerelease.length = 0;
          break;
        case "major":
          (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;
        case "minor":
          (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
          break;
        case "patch":
          this.prerelease.length === 0 && this.patch++, this.prerelease = [];
          break;
        // This probably shouldn't be used publicly.
        // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
        case "pre": {
          const iA = Number(eA) ? 1 : 0;
          if (this.prerelease.length === 0)
            this.prerelease = [iA];
          else {
            let QA = this.prerelease.length;
            for (; --QA >= 0; )
              typeof this.prerelease[QA] == "number" && (this.prerelease[QA]++, QA = -2);
            if (QA === -1) {
              if (BA === this.prerelease.join(".") && eA === !1)
                throw new Error("invalid increment argument: identifier already exists");
              this.prerelease.push(iA);
            }
          }
          if (BA) {
            let QA = [BA, iA];
            eA === !1 && (QA = [BA]), AA(this.prerelease[0], BA) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = QA) : this.prerelease = QA;
          }
          break;
        }
        default:
          throw new Error(`invalid increment argument: ${CA}`);
      }
      return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
    }
  }
  return semver = gA, semver;
}
var compare_1, hasRequiredCompare;
function requireCompare() {
  if (hasRequiredCompare) return compare_1;
  hasRequiredCompare = 1;
  const n = requireSemver();
  return compare_1 = (g, d, k) => new n(g, k).compare(new n(d, k)), compare_1;
}
var eq_1, hasRequiredEq;
function requireEq() {
  if (hasRequiredEq) return eq_1;
  hasRequiredEq = 1;
  const n = requireCompare();
  return eq_1 = (g, d, k) => n(g, d, k) === 0, eq_1;
}
var neq_1, hasRequiredNeq;
function requireNeq() {
  if (hasRequiredNeq) return neq_1;
  hasRequiredNeq = 1;
  const n = requireCompare();
  return neq_1 = (g, d, k) => n(g, d, k) !== 0, neq_1;
}
var gt_1, hasRequiredGt;
function requireGt() {
  if (hasRequiredGt) return gt_1;
  hasRequiredGt = 1;
  const n = requireCompare();
  return gt_1 = (g, d, k) => n(g, d, k) > 0, gt_1;
}
var gte_1, hasRequiredGte;
function requireGte() {
  if (hasRequiredGte) return gte_1;
  hasRequiredGte = 1;
  const n = requireCompare();
  return gte_1 = (g, d, k) => n(g, d, k) >= 0, gte_1;
}
var lt_1, hasRequiredLt;
function requireLt() {
  if (hasRequiredLt) return lt_1;
  hasRequiredLt = 1;
  const n = requireCompare();
  return lt_1 = (g, d, k) => n(g, d, k) < 0, lt_1;
}
var lte_1, hasRequiredLte;
function requireLte() {
  if (hasRequiredLte) return lte_1;
  hasRequiredLte = 1;
  const n = requireCompare();
  return lte_1 = (g, d, k) => n(g, d, k) <= 0, lte_1;
}
var cmp_1, hasRequiredCmp;
function requireCmp() {
  if (hasRequiredCmp) return cmp_1;
  hasRequiredCmp = 1;
  const n = requireEq(), t = requireNeq(), g = requireGt(), d = requireGte(), k = requireLt(), H = requireLte();
  return cmp_1 = (gA, IA, CA, BA) => {
    switch (IA) {
      case "===":
        return typeof gA == "object" && (gA = gA.version), typeof CA == "object" && (CA = CA.version), gA === CA;
      case "!==":
        return typeof gA == "object" && (gA = gA.version), typeof CA == "object" && (CA = CA.version), gA !== CA;
      case "":
      case "=":
      case "==":
        return n(gA, CA, BA);
      case "!=":
        return t(gA, CA, BA);
      case ">":
        return g(gA, CA, BA);
      case ">=":
        return d(gA, CA, BA);
      case "<":
        return k(gA, CA, BA);
      case "<=":
        return H(gA, CA, BA);
      default:
        throw new TypeError(`Invalid operator: ${IA}`);
    }
  }, cmp_1;
}
var comparator, hasRequiredComparator;
function requireComparator() {
  if (hasRequiredComparator) return comparator;
  hasRequiredComparator = 1;
  const n = Symbol("SemVer ANY");
  class t {
    static get ANY() {
      return n;
    }
    constructor(BA, eA) {
      if (eA = g(eA), BA instanceof t) {
        if (BA.loose === !!eA.loose)
          return BA;
        BA = BA.value;
      }
      BA = BA.trim().split(/\s+/).join(" "), AA("comparator", BA, eA), this.options = eA, this.loose = !!eA.loose, this.parse(BA), this.semver === n ? this.value = "" : this.value = this.operator + this.semver.version, AA("comp", this);
    }
    parse(BA) {
      const eA = this.options.loose ? d[k.COMPARATORLOOSE] : d[k.COMPARATOR], iA = BA.match(eA);
      if (!iA)
        throw new TypeError(`Invalid comparator: ${BA}`);
      this.operator = iA[1] !== void 0 ? iA[1] : "", this.operator === "=" && (this.operator = ""), iA[2] ? this.semver = new gA(iA[2], this.options.loose) : this.semver = n;
    }
    toString() {
      return this.value;
    }
    test(BA) {
      if (AA("Comparator.test", BA, this.options.loose), this.semver === n || BA === n)
        return !0;
      if (typeof BA == "string")
        try {
          BA = new gA(BA, this.options);
        } catch {
          return !1;
        }
      return H(BA, this.operator, this.semver, this.options);
    }
    intersects(BA, eA) {
      if (!(BA instanceof t))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new IA(BA.value, eA).test(this.value) : BA.operator === "" ? BA.value === "" ? !0 : new IA(this.value, eA).test(BA.semver) : (eA = g(eA), eA.includePrerelease && (this.value === "<0.0.0-0" || BA.value === "<0.0.0-0") || !eA.includePrerelease && (this.value.startsWith("<0.0.0") || BA.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && BA.operator.startsWith(">") || this.operator.startsWith("<") && BA.operator.startsWith("<") || this.semver.version === BA.semver.version && this.operator.includes("=") && BA.operator.includes("=") || H(this.semver, "<", BA.semver, eA) && this.operator.startsWith(">") && BA.operator.startsWith("<") || H(this.semver, ">", BA.semver, eA) && this.operator.startsWith("<") && BA.operator.startsWith(">")));
    }
  }
  comparator = t;
  const g = requireParseOptions(), { safeRe: d, t: k } = requireRe(), H = requireCmp(), AA = requireDebug(), gA = requireSemver(), IA = requireRange();
  return comparator;
}
var range, hasRequiredRange;
function requireRange() {
  if (hasRequiredRange) return range;
  hasRequiredRange = 1;
  const n = /\s+/g;
  class t {
    constructor(pA, MA) {
      if (MA = k(MA), pA instanceof t)
        return pA.loose === !!MA.loose && pA.includePrerelease === !!MA.includePrerelease ? pA : new t(pA.raw, MA);
      if (pA instanceof H)
        return this.raw = pA.value, this.set = [[pA]], this.formatted = void 0, this;
      if (this.options = MA, this.loose = !!MA.loose, this.includePrerelease = !!MA.includePrerelease, this.raw = pA.trim().replace(n, " "), this.set = this.raw.split("||").map((LA) => this.parseRange(LA.trim())).filter((LA) => LA.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const LA = this.set[0];
        if (this.set = this.set.filter((xA) => !oA(xA[0])), this.set.length === 0)
          this.set = [LA];
        else if (this.set.length > 1) {
          for (const xA of this.set)
            if (xA.length === 1 && EA(xA[0])) {
              this.set = [xA];
              break;
            }
        }
      }
      this.formatted = void 0;
    }
    get range() {
      if (this.formatted === void 0) {
        this.formatted = "";
        for (let pA = 0; pA < this.set.length; pA++) {
          pA > 0 && (this.formatted += "||");
          const MA = this.set[pA];
          for (let LA = 0; LA < MA.length; LA++)
            LA > 0 && (this.formatted += " "), this.formatted += MA[LA].toString().trim();
        }
      }
      return this.formatted;
    }
    format() {
      return this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(pA) {
      const LA = ((this.options.includePrerelease && QA) | (this.options.loose && tA)) + ":" + pA, xA = d.get(LA);
      if (xA)
        return xA;
      const TA = this.options.loose, NA = TA ? IA[CA.HYPHENRANGELOOSE] : IA[CA.HYPHENRANGE];
      pA = pA.replace(NA, wA(this.options.includePrerelease)), AA("hyphen replace", pA), pA = pA.replace(IA[CA.COMPARATORTRIM], BA), AA("comparator trim", pA), pA = pA.replace(IA[CA.TILDETRIM], eA), AA("tilde trim", pA), pA = pA.replace(IA[CA.CARETTRIM], iA), AA("caret trim", pA);
      let zA = pA.split(" ").map((Cg) => nA(Cg, this.options)).join(" ").split(/\s+/).map((Cg) => DA(Cg, this.options));
      TA && (zA = zA.filter((Cg) => (AA("loose invalid filter", Cg, this.options), !!Cg.match(IA[CA.COMPARATORLOOSE])))), AA("range list", zA);
      const XA = /* @__PURE__ */ new Map(), fA = zA.map((Cg) => new H(Cg, this.options));
      for (const Cg of fA) {
        if (oA(Cg))
          return [Cg];
        XA.set(Cg.value, Cg);
      }
      XA.size > 1 && XA.has("") && XA.delete("");
      const vA = [...XA.values()];
      return d.set(LA, vA), vA;
    }
    intersects(pA, MA) {
      if (!(pA instanceof t))
        throw new TypeError("a Range is required");
      return this.set.some((LA) => aA(LA, MA) && pA.set.some((xA) => aA(xA, MA) && LA.every((TA) => xA.every((NA) => TA.intersects(NA, MA)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(pA) {
      if (!pA)
        return !1;
      if (typeof pA == "string")
        try {
          pA = new gA(pA, this.options);
        } catch {
          return !1;
        }
      for (let MA = 0; MA < this.set.length; MA++)
        if (bA(this.set[MA], pA, this.options))
          return !0;
      return !1;
    }
  }
  range = t;
  const g = requireLrucache(), d = new g(), k = requireParseOptions(), H = requireComparator(), AA = requireDebug(), gA = requireSemver(), {
    safeRe: IA,
    t: CA,
    comparatorTrimReplace: BA,
    tildeTrimReplace: eA,
    caretTrimReplace: iA
  } = requireRe(), { FLAG_INCLUDE_PRERELEASE: QA, FLAG_LOOSE: tA } = requireConstants(), oA = (yA) => yA.value === "<0.0.0-0", EA = (yA) => yA.value === "", aA = (yA, pA) => {
    let MA = !0;
    const LA = yA.slice();
    let xA = LA.pop();
    for (; MA && LA.length; )
      MA = LA.every((TA) => xA.intersects(TA, pA)), xA = LA.pop();
    return MA;
  }, nA = (yA, pA) => (AA("comp", yA, pA), yA = rA(yA, pA), AA("caret", yA), yA = cA(yA, pA), AA("tildes", yA), yA = hA(yA, pA), AA("xrange", yA), yA = GA(yA, pA), AA("stars", yA), yA), lA = (yA) => !yA || yA.toLowerCase() === "x" || yA === "*", cA = (yA, pA) => yA.trim().split(/\s+/).map((MA) => sA(MA, pA)).join(" "), sA = (yA, pA) => {
    const MA = pA.loose ? IA[CA.TILDELOOSE] : IA[CA.TILDE];
    return yA.replace(MA, (LA, xA, TA, NA, zA) => {
      AA("tilde", yA, LA, xA, TA, NA, zA);
      let XA;
      return lA(xA) ? XA = "" : lA(TA) ? XA = `>=${xA}.0.0 <${+xA + 1}.0.0-0` : lA(NA) ? XA = `>=${xA}.${TA}.0 <${xA}.${+TA + 1}.0-0` : zA ? (AA("replaceTilde pr", zA), XA = `>=${xA}.${TA}.${NA}-${zA} <${xA}.${+TA + 1}.0-0`) : XA = `>=${xA}.${TA}.${NA} <${xA}.${+TA + 1}.0-0`, AA("tilde return", XA), XA;
    });
  }, rA = (yA, pA) => yA.trim().split(/\s+/).map((MA) => uA(MA, pA)).join(" "), uA = (yA, pA) => {
    AA("caret", yA, pA);
    const MA = pA.loose ? IA[CA.CARETLOOSE] : IA[CA.CARET], LA = pA.includePrerelease ? "-0" : "";
    return yA.replace(MA, (xA, TA, NA, zA, XA) => {
      AA("caret", yA, xA, TA, NA, zA, XA);
      let fA;
      return lA(TA) ? fA = "" : lA(NA) ? fA = `>=${TA}.0.0${LA} <${+TA + 1}.0.0-0` : lA(zA) ? TA === "0" ? fA = `>=${TA}.${NA}.0${LA} <${TA}.${+NA + 1}.0-0` : fA = `>=${TA}.${NA}.0${LA} <${+TA + 1}.0.0-0` : XA ? (AA("replaceCaret pr", XA), TA === "0" ? NA === "0" ? fA = `>=${TA}.${NA}.${zA}-${XA} <${TA}.${NA}.${+zA + 1}-0` : fA = `>=${TA}.${NA}.${zA}-${XA} <${TA}.${+NA + 1}.0-0` : fA = `>=${TA}.${NA}.${zA}-${XA} <${+TA + 1}.0.0-0`) : (AA("no pr"), TA === "0" ? NA === "0" ? fA = `>=${TA}.${NA}.${zA}${LA} <${TA}.${NA}.${+zA + 1}-0` : fA = `>=${TA}.${NA}.${zA}${LA} <${TA}.${+NA + 1}.0-0` : fA = `>=${TA}.${NA}.${zA} <${+TA + 1}.0.0-0`), AA("caret return", fA), fA;
    });
  }, hA = (yA, pA) => (AA("replaceXRanges", yA, pA), yA.split(/\s+/).map((MA) => dA(MA, pA)).join(" ")), dA = (yA, pA) => {
    yA = yA.trim();
    const MA = pA.loose ? IA[CA.XRANGELOOSE] : IA[CA.XRANGE];
    return yA.replace(MA, (LA, xA, TA, NA, zA, XA) => {
      AA("xRange", yA, LA, xA, TA, NA, zA, XA);
      const fA = lA(TA), vA = fA || lA(NA), Cg = vA || lA(zA), Ig = Cg;
      return xA === "=" && Ig && (xA = ""), XA = pA.includePrerelease ? "-0" : "", fA ? xA === ">" || xA === "<" ? LA = "<0.0.0-0" : LA = "*" : xA && Ig ? (vA && (NA = 0), zA = 0, xA === ">" ? (xA = ">=", vA ? (TA = +TA + 1, NA = 0, zA = 0) : (NA = +NA + 1, zA = 0)) : xA === "<=" && (xA = "<", vA ? TA = +TA + 1 : NA = +NA + 1), xA === "<" && (XA = "-0"), LA = `${xA + TA}.${NA}.${zA}${XA}`) : vA ? LA = `>=${TA}.0.0${XA} <${+TA + 1}.0.0-0` : Cg && (LA = `>=${TA}.${NA}.0${XA} <${TA}.${+NA + 1}.0-0`), AA("xRange return", LA), LA;
    });
  }, GA = (yA, pA) => (AA("replaceStars", yA, pA), yA.trim().replace(IA[CA.STAR], "")), DA = (yA, pA) => (AA("replaceGTE0", yA, pA), yA.trim().replace(IA[pA.includePrerelease ? CA.GTE0PRE : CA.GTE0], "")), wA = (yA) => (pA, MA, LA, xA, TA, NA, zA, XA, fA, vA, Cg, Ig) => (lA(LA) ? MA = "" : lA(xA) ? MA = `>=${LA}.0.0${yA ? "-0" : ""}` : lA(TA) ? MA = `>=${LA}.${xA}.0${yA ? "-0" : ""}` : NA ? MA = `>=${MA}` : MA = `>=${MA}${yA ? "-0" : ""}`, lA(fA) ? XA = "" : lA(vA) ? XA = `<${+fA + 1}.0.0-0` : lA(Cg) ? XA = `<${fA}.${+vA + 1}.0-0` : Ig ? XA = `<=${fA}.${vA}.${Cg}-${Ig}` : yA ? XA = `<${fA}.${vA}.${+Cg + 1}-0` : XA = `<=${XA}`, `${MA} ${XA}`.trim()), bA = (yA, pA, MA) => {
    for (let LA = 0; LA < yA.length; LA++)
      if (!yA[LA].test(pA))
        return !1;
    if (pA.prerelease.length && !MA.includePrerelease) {
      for (let LA = 0; LA < yA.length; LA++)
        if (AA(yA[LA].semver), yA[LA].semver !== H.ANY && yA[LA].semver.prerelease.length > 0) {
          const xA = yA[LA].semver;
          if (xA.major === pA.major && xA.minor === pA.minor && xA.patch === pA.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return range;
}
var satisfies_1, hasRequiredSatisfies;
function requireSatisfies() {
  if (hasRequiredSatisfies) return satisfies_1;
  hasRequiredSatisfies = 1;
  const n = requireRange();
  return satisfies_1 = (g, d, k) => {
    try {
      d = new n(d, k);
    } catch {
      return !1;
    }
    return d.test(g);
  }, satisfies_1;
}
var satisfiesExports = requireSatisfies(), satisfies = /* @__PURE__ */ getDefaultExportFromCjs(satisfiesExports);
function post(n, t, g) {
  const d = n.open(t), k = 250, { origin: H } = new URL(t);
  let AA = 40;
  function gA(CA) {
    CA.source === d && (AA = 0, n.removeEventListener("message", gA, !1));
  }
  n.addEventListener("message", gA, !1);
  function IA() {
    AA <= 0 || (d.postMessage(g, H), setTimeout(IA, k), AA -= 1);
  }
  setTimeout(IA, k);
}
var embedStyle = `.vega-embed {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
}
.vega-embed.has-actions {
  padding-right: 38px;
}
.vega-embed details:not([open]) > :not(summary) {
  display: none !important;
}
.vega-embed summary {
  list-style: none;
  position: absolute;
  top: 0;
  right: 0;
  padding: 6px;
  z-index: 1000;
  background: white;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
  color: #1b1e23;
  border: 1px solid #aaa;
  border-radius: 999px;
  opacity: 0.2;
  transition: opacity 0.4s ease-in;
  cursor: pointer;
  line-height: 0px;
}
.vega-embed summary::-webkit-details-marker {
  display: none;
}
.vega-embed summary:active {
  box-shadow: #aaa 0px 0px 0px 1px inset;
}
.vega-embed summary svg {
  width: 14px;
  height: 14px;
}
.vega-embed details[open] summary {
  opacity: 0.7;
}
.vega-embed:hover summary, .vega-embed:focus-within summary {
  opacity: 1 !important;
  transition: opacity 0.2s ease;
}
.vega-embed .vega-actions {
  position: absolute;
  z-index: 1001;
  top: 35px;
  right: -9px;
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
  padding-top: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid #d9d9d9;
  background: white;
  animation-duration: 0.15s;
  animation-name: scale-in;
  animation-timing-function: cubic-bezier(0.2, 0, 0.13, 1.5);
  text-align: left;
}
.vega-embed .vega-actions a {
  padding: 8px 16px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  color: #434a56;
  text-decoration: none;
}
.vega-embed .vega-actions a:hover, .vega-embed .vega-actions a:focus {
  background-color: #f7f7f9;
  color: black;
}
.vega-embed .vega-actions::before, .vega-embed .vega-actions::after {
  content: "";
  display: inline-block;
  position: absolute;
}
.vega-embed .vega-actions::before {
  left: auto;
  right: 14px;
  top: -16px;
  border: 8px solid rgba(0, 0, 0, 0);
  border-bottom-color: #d9d9d9;
}
.vega-embed .vega-actions::after {
  left: auto;
  right: 15px;
  top: -14px;
  border: 7px solid rgba(0, 0, 0, 0);
  border-bottom-color: #fff;
}
.vega-embed .chart-wrapper.fit-x {
  width: 100%;
}
.vega-embed .chart-wrapper.fit-y {
  height: 100%;
}

.vega-embed-wrapper {
  max-width: 100%;
  overflow: auto;
  padding-right: 14px;
}

@keyframes scale-in {
  from {
    opacity: 0;
    transform: scale(0.6);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`;
function mergeDeep(n, ...t) {
  for (const g of t)
    deepMerge_(n, g);
  return n;
}
function deepMerge_(n, t) {
  for (const g of Object.keys(t))
    writeConfig$1(n, g, t[g], !0);
}
const vega = vegaImport;
let vegaLite = vegaLiteImport;
const w$1 = typeof window < "u" ? window : void 0;
vegaLite === void 0 && w$1?.vl?.compile && (vegaLite = w$1.vl);
const DEFAULT_ACTIONS = { export: { svg: !0, png: !0 }, source: !0, compiled: !0, editor: !0 }, I18N = {
  CLICK_TO_VIEW_ACTIONS: "Click to view actions",
  COMPILED_ACTION: "View Compiled Vega",
  EDITOR_ACTION: "Open in Vega Editor",
  PNG_ACTION: "Save as PNG",
  SOURCE_ACTION: "View Source",
  SVG_ACTION: "Save as SVG"
}, NAMES = {
  vega: "Vega",
  "vega-lite": "Vega-Lite"
}, VERSION$2 = {
  vega: vega.version,
  "vega-lite": vegaLite ? vegaLite.version : "not available"
}, PREPROCESSOR = {
  vega: (n) => n,
  "vega-lite": (n, t, g) => vegaLite.compile(n, { config: g, logger: t }).spec
}, SVG_CIRCLES = `
<svg viewBox="0 0 16 16" fill="currentColor" stroke="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
  <circle r="2" cy="8" cx="2"></circle>
  <circle r="2" cy="8" cx="8"></circle>
  <circle r="2" cy="8" cx="14"></circle>
</svg>`, CHART_WRAPPER_CLASS = "chart-wrapper";
function isTooltipHandler(n) {
  return typeof n == "function";
}
function viewSource(n, t, g, d) {
  const k = `<html><head>${t}</head><body><pre><code class="json">`, H = `</code></pre>${g}</body></html>`, AA = window.open("");
  AA.document.write(k + n + H), AA.document.title = `${NAMES[d]} JSON Source`;
}
function guessMode(n, t, g) {
  if (n.$schema) {
    const d = e(n.$schema);
    g && g !== d.library && t.warn(`The given visualization spec is written in ${NAMES[d.library]}, but mode argument sets ${NAMES[g] ?? g}.`);
    const k = d.library;
    return satisfies(VERSION$2[k], `^${d.version.slice(1)}`) || t.warn(`The input spec uses ${NAMES[k]} ${d.version}, but the current version of ${NAMES[k]} is v${VERSION$2[k]}.`), k;
  }
  return "mark" in n || "encoding" in n || "layer" in n || "hconcat" in n || "vconcat" in n || "facet" in n || "repeat" in n ? "vega-lite" : "marks" in n || "signals" in n || "scales" in n || "axes" in n ? "vega" : g ?? "vega";
}
function isLoader(n) {
  return !!(n && "load" in n);
}
function createLoader(n) {
  return isLoader(n) ? n : vega.loader(n);
}
function embedOptionsFromUsermeta(n) {
  const t = n.usermeta?.embedOptions ?? {};
  return isString$2(t.defaultStyle) && (t.defaultStyle = !1), t;
}
async function embed(n, t, g = {}) {
  let d, k;
  isString$2(t) ? (k = createLoader(g.loader), d = JSON.parse(await k.load(t))) : d = t;
  const H = embedOptionsFromUsermeta(d), AA = H.loader;
  (!k || AA) && (k = createLoader(g.loader ?? AA));
  const gA = await loadOpts(H, k), IA = await loadOpts(g, k), CA = {
    ...mergeDeep(IA, gA),
    config: mergeConfig$3(IA.config ?? {}, gA.config ?? {})
  };
  return await _embed(n, d, CA, k);
}
async function loadOpts(n, t) {
  const g = isString$2(n.config) ? JSON.parse(await t.load(n.config)) : n.config ?? {}, d = isString$2(n.patch) ? JSON.parse(await t.load(n.patch)) : n.patch;
  return {
    ...n,
    ...d ? { patch: d } : {},
    ...g ? { config: g } : {}
  };
}
function getRoot(n) {
  const t = n.getRootNode ? n.getRootNode() : document;
  return t instanceof ShadowRoot ? { root: t, rootContainer: t } : { root: document, rootContainer: document.head ?? document.body };
}
async function _embed(n, t, g = {}, d) {
  const k = g.theme ? mergeConfig$3(themes[g.theme], g.config ?? {}) : g.config, H = isBoolean$4(g.actions) ? g.actions : mergeDeep({}, DEFAULT_ACTIONS, g.actions ?? {}), AA = { ...I18N, ...g.i18n }, gA = g.renderer ?? "svg", IA = g.logger ?? logger$1(vega.Warn);
  g.logLevel !== void 0 && IA.level(g.logLevel);
  const CA = g.downloadFileName ?? "visualization", BA = typeof n == "string" ? document.querySelector(n) : n;
  if (!BA)
    throw new Error(`${n} does not exist`);
  if (g.defaultStyle !== !1) {
    const sA = "vega-embed-style", { root: rA, rootContainer: uA } = getRoot(BA);
    if (!rA.getElementById(sA)) {
      const hA = document.createElement("style");
      hA.id = sA, hA.innerHTML = g.defaultStyle === void 0 || g.defaultStyle === !0 ? embedStyle.toString() : g.defaultStyle, uA.appendChild(hA);
    }
  }
  const eA = guessMode(t, IA, g.mode);
  let iA = PREPROCESSOR[eA](t, IA, k);
  if (eA === "vega-lite" && iA.$schema) {
    const sA = e(iA.$schema);
    satisfies(VERSION$2.vega, `^${sA.version.slice(1)}`) || IA.warn(`The compiled spec uses Vega ${sA.version}, but current version is v${VERSION$2.vega}.`);
  }
  BA.classList.add("vega-embed"), H && BA.classList.add("has-actions"), BA.innerHTML = "";
  let QA = BA;
  if (H) {
    const sA = document.createElement("div");
    sA.classList.add(CHART_WRAPPER_CLASS), BA.appendChild(sA), QA = sA;
  }
  const tA = g.patch;
  if (tA && (iA = tA instanceof Function ? tA(iA) : applyPatch(iA, tA, !0, !1).newDocument), g.formatLocale && vega.formatLocale(g.formatLocale), g.timeFormatLocale && vega.timeFormatLocale(g.timeFormatLocale), g.expressionFunctions)
    for (const sA in g.expressionFunctions) {
      const rA = g.expressionFunctions[sA];
      "fn" in rA ? vega.expressionFunction(sA, rA.fn, rA.visitor) : rA instanceof Function && vega.expressionFunction(sA, rA);
    }
  const { ast: oA } = g, EA = vega.parse(iA, eA === "vega-lite" ? {} : k, { ast: oA }), aA = new (g.viewClass || vega.View)(EA, {
    loader: d,
    logger: IA,
    renderer: gA,
    ...oA ? { expr: vega.expressionInterpreter ?? g.expr ?? expression$1 } : {}
  });
  if (aA.addSignalListener("autosize", (sA, rA) => {
    const { type: uA } = rA;
    uA == "fit-x" ? (QA.classList.add("fit-x"), QA.classList.remove("fit-y")) : uA == "fit-y" ? (QA.classList.remove("fit-x"), QA.classList.add("fit-y")) : uA == "fit" ? QA.classList.add("fit-x", "fit-y") : QA.classList.remove("fit-x", "fit-y");
  }), g.tooltip !== !1) {
    const { loader: sA, tooltip: rA } = g, uA = sA && !isLoader(sA) ? sA?.baseURL : void 0, hA = isTooltipHandler(rA) ? rA : (
      // user provided boolean true or tooltip options
      new Handler({ baseURL: uA, ...rA === !0 ? {} : rA }).call
    );
    aA.tooltip(hA);
  }
  let { hover: nA } = g;
  if (nA === void 0 && (nA = eA === "vega"), nA) {
    const { hoverSet: sA, updateSet: rA } = typeof nA == "boolean" ? {} : nA;
    aA.hover(sA, rA);
  }
  g && (g.width != null && aA.width(g.width), g.height != null && aA.height(g.height), g.padding != null && aA.padding(g.padding)), await aA.initialize(QA, g.bind).runAsync();
  let lA;
  if (H !== !1) {
    let sA = BA;
    if (g.defaultStyle !== !1 || g.forceActionsMenu) {
      const uA = document.createElement("details");
      uA.title = AA.CLICK_TO_VIEW_ACTIONS, BA.append(uA), sA = uA;
      const hA = document.createElement("summary");
      hA.innerHTML = SVG_CIRCLES, uA.append(hA), lA = (dA) => {
        uA.contains(dA.target) || uA.removeAttribute("open");
      }, document.addEventListener("click", lA);
    }
    const rA = document.createElement("div");
    if (sA.append(rA), rA.classList.add("vega-actions"), H === !0 || H.export !== !1) {
      for (const uA of ["svg", "png"])
        if (H === !0 || H.export === !0 || H.export[uA]) {
          const hA = AA[`${uA.toUpperCase()}_ACTION`], dA = document.createElement("a"), GA = isObject$4(g.scaleFactor) ? g.scaleFactor[uA] : g.scaleFactor;
          dA.text = hA, dA.href = "#", dA.target = "_blank", dA.download = `${CA}.${uA}`, dA.addEventListener("mousedown", async function(DA) {
            DA.preventDefault();
            const wA = await aA.toImageURL(uA, GA);
            this.href = wA;
          }), rA.append(dA);
        }
    }
    if (H === !0 || H.source !== !1) {
      const uA = document.createElement("a");
      uA.text = AA.SOURCE_ACTION, uA.href = "#", uA.addEventListener("click", function(hA) {
        viewSource(stringify$2(t), g.sourceHeader ?? "", g.sourceFooter ?? "", eA), hA.preventDefault();
      }), rA.append(uA);
    }
    if (eA === "vega-lite" && (H === !0 || H.compiled !== !1)) {
      const uA = document.createElement("a");
      uA.text = AA.COMPILED_ACTION, uA.href = "#", uA.addEventListener("click", function(hA) {
        viewSource(stringify$2(iA), g.sourceHeader ?? "", g.sourceFooter ?? "", "vega"), hA.preventDefault();
      }), rA.append(uA);
    }
    if (H === !0 || H.editor !== !1) {
      const uA = g.editorUrl ?? "https://vega.github.io/editor/", hA = document.createElement("a");
      hA.text = AA.EDITOR_ACTION, hA.href = "#", hA.addEventListener("click", function(dA) {
        post(window, uA, {
          config: k,
          mode: tA ? "vega" : eA,
          renderer: gA,
          spec: stringify$2(tA ? iA : t)
        }), dA.preventDefault();
      }), rA.append(hA);
    }
  }
  function cA() {
    lA && document.removeEventListener("click", lA), aA.finalize();
  }
  return { view: aA, spec: t, vgSpec: iA, finalize: cA, embedOptions: g };
}
const WindowDimensionsContext = createContext(null);
WindowDimensionsContext.displayName = "WindowDimensionsContext";
const useWindowDimensionsContext = () => useRequiredContext(WindowDimensionsContext);
var _hasPath, hasRequired_hasPath;
function require_hasPath() {
  if (hasRequired_hasPath) return _hasPath;
  hasRequired_hasPath = 1;
  var n = require_castPath(), t = requireIsArguments(), g = requireIsArray(), d = require_isIndex(), k = requireIsLength(), H = require_toKey();
  function AA(gA, IA, CA) {
    IA = n(IA, gA);
    for (var BA = -1, eA = IA.length, iA = !1; ++BA < eA; ) {
      var QA = H(IA[BA]);
      if (!(iA = gA != null && CA(gA, QA)))
        break;
      gA = gA[QA];
    }
    return iA || ++BA != eA ? iA : (eA = gA == null ? 0 : gA.length, !!eA && k(eA) && d(QA, eA) && (g(gA) || t(gA)));
  }
  return _hasPath = AA, _hasPath;
}
var _setCacheAdd, hasRequired_setCacheAdd;
function require_setCacheAdd() {
  if (hasRequired_setCacheAdd) return _setCacheAdd;
  hasRequired_setCacheAdd = 1;
  var n = "__lodash_hash_undefined__";
  function t(g) {
    return this.__data__.set(g, n), this;
  }
  return _setCacheAdd = t, _setCacheAdd;
}
var _setCacheHas, hasRequired_setCacheHas;
function require_setCacheHas() {
  if (hasRequired_setCacheHas) return _setCacheHas;
  hasRequired_setCacheHas = 1;
  function n(t) {
    return this.__data__.has(t);
  }
  return _setCacheHas = n, _setCacheHas;
}
var _SetCache, hasRequired_SetCache;
function require_SetCache() {
  if (hasRequired_SetCache) return _SetCache;
  hasRequired_SetCache = 1;
  var n = require_MapCache(), t = require_setCacheAdd(), g = require_setCacheHas();
  function d(k) {
    var H = -1, AA = k == null ? 0 : k.length;
    for (this.__data__ = new n(); ++H < AA; )
      this.add(k[H]);
  }
  return d.prototype.add = d.prototype.push = t, d.prototype.has = g, _SetCache = d, _SetCache;
}
var _arrayIncludes, hasRequired_arrayIncludes;
function require_arrayIncludes() {
  if (hasRequired_arrayIncludes) return _arrayIncludes;
  hasRequired_arrayIncludes = 1;
  var n = require_baseIndexOf();
  function t(g, d) {
    var k = g == null ? 0 : g.length;
    return !!k && n(g, d, 0) > -1;
  }
  return _arrayIncludes = t, _arrayIncludes;
}
var _arrayIncludesWith, hasRequired_arrayIncludesWith;
function require_arrayIncludesWith() {
  if (hasRequired_arrayIncludesWith) return _arrayIncludesWith;
  hasRequired_arrayIncludesWith = 1;
  function n(t, g, d) {
    for (var k = -1, H = t == null ? 0 : t.length; ++k < H; )
      if (d(g, t[k]))
        return !0;
    return !1;
  }
  return _arrayIncludesWith = n, _arrayIncludesWith;
}
var _cacheHas, hasRequired_cacheHas;
function require_cacheHas() {
  if (hasRequired_cacheHas) return _cacheHas;
  hasRequired_cacheHas = 1;
  function n(t, g) {
    return t.has(g);
  }
  return _cacheHas = n, _cacheHas;
}
var _setToArray, hasRequired_setToArray;
function require_setToArray() {
  if (hasRequired_setToArray) return _setToArray;
  hasRequired_setToArray = 1;
  function n(t) {
    var g = -1, d = Array(t.size);
    return t.forEach(function(k) {
      d[++g] = k;
    }), d;
  }
  return _setToArray = n, _setToArray;
}
var _arrayAggregator, hasRequired_arrayAggregator;
function require_arrayAggregator() {
  if (hasRequired_arrayAggregator) return _arrayAggregator;
  hasRequired_arrayAggregator = 1;
  function n(t, g, d, k) {
    for (var H = -1, AA = t == null ? 0 : t.length; ++H < AA; ) {
      var gA = t[H];
      g(k, gA, d(gA), t);
    }
    return k;
  }
  return _arrayAggregator = n, _arrayAggregator;
}
var _baseForOwn, hasRequired_baseForOwn;
function require_baseForOwn() {
  if (hasRequired_baseForOwn) return _baseForOwn;
  hasRequired_baseForOwn = 1;
  var n = require_baseFor(), t = requireKeys();
  function g(d, k) {
    return d && n(d, k, t);
  }
  return _baseForOwn = g, _baseForOwn;
}
var _createBaseEach, hasRequired_createBaseEach;
function require_createBaseEach() {
  if (hasRequired_createBaseEach) return _createBaseEach;
  hasRequired_createBaseEach = 1;
  var n = requireIsArrayLike();
  function t(g, d) {
    return function(k, H) {
      if (k == null)
        return k;
      if (!n(k))
        return g(k, H);
      for (var AA = k.length, gA = d ? AA : -1, IA = Object(k); (d ? gA-- : ++gA < AA) && H(IA[gA], gA, IA) !== !1; )
        ;
      return k;
    };
  }
  return _createBaseEach = t, _createBaseEach;
}
var _baseEach, hasRequired_baseEach;
function require_baseEach() {
  if (hasRequired_baseEach) return _baseEach;
  hasRequired_baseEach = 1;
  var n = require_baseForOwn(), t = require_createBaseEach(), g = t(n);
  return _baseEach = g, _baseEach;
}
var _baseAggregator, hasRequired_baseAggregator;
function require_baseAggregator() {
  if (hasRequired_baseAggregator) return _baseAggregator;
  hasRequired_baseAggregator = 1;
  var n = require_baseEach();
  function t(g, d, k, H) {
    return n(g, function(AA, gA, IA) {
      d(H, AA, k(AA), IA);
    }), H;
  }
  return _baseAggregator = t, _baseAggregator;
}
var _arraySome, hasRequired_arraySome;
function require_arraySome() {
  if (hasRequired_arraySome) return _arraySome;
  hasRequired_arraySome = 1;
  function n(t, g) {
    for (var d = -1, k = t == null ? 0 : t.length; ++d < k; )
      if (g(t[d], d, t))
        return !0;
    return !1;
  }
  return _arraySome = n, _arraySome;
}
var _equalArrays, hasRequired_equalArrays;
function require_equalArrays() {
  if (hasRequired_equalArrays) return _equalArrays;
  hasRequired_equalArrays = 1;
  var n = require_SetCache(), t = require_arraySome(), g = require_cacheHas(), d = 1, k = 2;
  function H(AA, gA, IA, CA, BA, eA) {
    var iA = IA & d, QA = AA.length, tA = gA.length;
    if (QA != tA && !(iA && tA > QA))
      return !1;
    var oA = eA.get(AA), EA = eA.get(gA);
    if (oA && EA)
      return oA == gA && EA == AA;
    var aA = -1, nA = !0, lA = IA & k ? new n() : void 0;
    for (eA.set(AA, gA), eA.set(gA, AA); ++aA < QA; ) {
      var cA = AA[aA], sA = gA[aA];
      if (CA)
        var rA = iA ? CA(sA, cA, aA, gA, AA, eA) : CA(cA, sA, aA, AA, gA, eA);
      if (rA !== void 0) {
        if (rA)
          continue;
        nA = !1;
        break;
      }
      if (lA) {
        if (!t(gA, function(uA, hA) {
          if (!g(lA, hA) && (cA === uA || BA(cA, uA, IA, CA, eA)))
            return lA.push(hA);
        })) {
          nA = !1;
          break;
        }
      } else if (!(cA === sA || BA(cA, sA, IA, CA, eA))) {
        nA = !1;
        break;
      }
    }
    return eA.delete(AA), eA.delete(gA), nA;
  }
  return _equalArrays = H, _equalArrays;
}
var _mapToArray, hasRequired_mapToArray;
function require_mapToArray() {
  if (hasRequired_mapToArray) return _mapToArray;
  hasRequired_mapToArray = 1;
  function n(t) {
    var g = -1, d = Array(t.size);
    return t.forEach(function(k, H) {
      d[++g] = [H, k];
    }), d;
  }
  return _mapToArray = n, _mapToArray;
}
var _equalByTag, hasRequired_equalByTag;
function require_equalByTag() {
  if (hasRequired_equalByTag) return _equalByTag;
  hasRequired_equalByTag = 1;
  var n = require_Symbol(), t = require_Uint8Array(), g = requireEq$1(), d = require_equalArrays(), k = require_mapToArray(), H = require_setToArray(), AA = 1, gA = 2, IA = "[object Boolean]", CA = "[object Date]", BA = "[object Error]", eA = "[object Map]", iA = "[object Number]", QA = "[object RegExp]", tA = "[object Set]", oA = "[object String]", EA = "[object Symbol]", aA = "[object ArrayBuffer]", nA = "[object DataView]", lA = n ? n.prototype : void 0, cA = lA ? lA.valueOf : void 0;
  function sA(rA, uA, hA, dA, GA, DA, wA) {
    switch (hA) {
      case nA:
        if (rA.byteLength != uA.byteLength || rA.byteOffset != uA.byteOffset)
          return !1;
        rA = rA.buffer, uA = uA.buffer;
      case aA:
        return !(rA.byteLength != uA.byteLength || !DA(new t(rA), new t(uA)));
      case IA:
      case CA:
      case iA:
        return g(+rA, +uA);
      case BA:
        return rA.name == uA.name && rA.message == uA.message;
      case QA:
      case oA:
        return rA == uA + "";
      case eA:
        var bA = k;
      case tA:
        var yA = dA & AA;
        if (bA || (bA = H), rA.size != uA.size && !yA)
          return !1;
        var pA = wA.get(rA);
        if (pA)
          return pA == uA;
        dA |= gA, wA.set(rA, uA);
        var MA = d(bA(rA), bA(uA), dA, GA, DA, wA);
        return wA.delete(rA), MA;
      case EA:
        if (cA)
          return cA.call(rA) == cA.call(uA);
    }
    return !1;
  }
  return _equalByTag = sA, _equalByTag;
}
var _equalObjects, hasRequired_equalObjects;
function require_equalObjects() {
  if (hasRequired_equalObjects) return _equalObjects;
  hasRequired_equalObjects = 1;
  var n = require_getAllKeys(), t = 1, g = Object.prototype, d = g.hasOwnProperty;
  function k(H, AA, gA, IA, CA, BA) {
    var eA = gA & t, iA = n(H), QA = iA.length, tA = n(AA), oA = tA.length;
    if (QA != oA && !eA)
      return !1;
    for (var EA = QA; EA--; ) {
      var aA = iA[EA];
      if (!(eA ? aA in AA : d.call(AA, aA)))
        return !1;
    }
    var nA = BA.get(H), lA = BA.get(AA);
    if (nA && lA)
      return nA == AA && lA == H;
    var cA = !0;
    BA.set(H, AA), BA.set(AA, H);
    for (var sA = eA; ++EA < QA; ) {
      aA = iA[EA];
      var rA = H[aA], uA = AA[aA];
      if (IA)
        var hA = eA ? IA(uA, rA, aA, AA, H, BA) : IA(rA, uA, aA, H, AA, BA);
      if (!(hA === void 0 ? rA === uA || CA(rA, uA, gA, IA, BA) : hA)) {
        cA = !1;
        break;
      }
      sA || (sA = aA == "constructor");
    }
    if (cA && !sA) {
      var dA = H.constructor, GA = AA.constructor;
      dA != GA && "constructor" in H && "constructor" in AA && !(typeof dA == "function" && dA instanceof dA && typeof GA == "function" && GA instanceof GA) && (cA = !1);
    }
    return BA.delete(H), BA.delete(AA), cA;
  }
  return _equalObjects = k, _equalObjects;
}
var _baseIsEqualDeep, hasRequired_baseIsEqualDeep;
function require_baseIsEqualDeep() {
  if (hasRequired_baseIsEqualDeep) return _baseIsEqualDeep;
  hasRequired_baseIsEqualDeep = 1;
  var n = require_Stack(), t = require_equalArrays(), g = require_equalByTag(), d = require_equalObjects(), k = require_getTag(), H = requireIsArray(), AA = requireIsBuffer(), gA = requireIsTypedArray(), IA = 1, CA = "[object Arguments]", BA = "[object Array]", eA = "[object Object]", iA = Object.prototype, QA = iA.hasOwnProperty;
  function tA(oA, EA, aA, nA, lA, cA) {
    var sA = H(oA), rA = H(EA), uA = sA ? BA : k(oA), hA = rA ? BA : k(EA);
    uA = uA == CA ? eA : uA, hA = hA == CA ? eA : hA;
    var dA = uA == eA, GA = hA == eA, DA = uA == hA;
    if (DA && AA(oA)) {
      if (!AA(EA))
        return !1;
      sA = !0, dA = !1;
    }
    if (DA && !dA)
      return cA || (cA = new n()), sA || gA(oA) ? t(oA, EA, aA, nA, lA, cA) : g(oA, EA, uA, aA, nA, lA, cA);
    if (!(aA & IA)) {
      var wA = dA && QA.call(oA, "__wrapped__"), bA = GA && QA.call(EA, "__wrapped__");
      if (wA || bA) {
        var yA = wA ? oA.value() : oA, pA = bA ? EA.value() : EA;
        return cA || (cA = new n()), lA(yA, pA, aA, nA, cA);
      }
    }
    return DA ? (cA || (cA = new n()), d(oA, EA, aA, nA, lA, cA)) : !1;
  }
  return _baseIsEqualDeep = tA, _baseIsEqualDeep;
}
var _baseIsEqual, hasRequired_baseIsEqual;
function require_baseIsEqual() {
  if (hasRequired_baseIsEqual) return _baseIsEqual;
  hasRequired_baseIsEqual = 1;
  var n = require_baseIsEqualDeep(), t = requireIsObjectLike();
  function g(d, k, H, AA, gA) {
    return d === k ? !0 : d == null || k == null || !t(d) && !t(k) ? d !== d && k !== k : n(d, k, H, AA, g, gA);
  }
  return _baseIsEqual = g, _baseIsEqual;
}
var _baseIsMatch, hasRequired_baseIsMatch;
function require_baseIsMatch() {
  if (hasRequired_baseIsMatch) return _baseIsMatch;
  hasRequired_baseIsMatch = 1;
  var n = require_Stack(), t = require_baseIsEqual(), g = 1, d = 2;
  function k(H, AA, gA, IA) {
    var CA = gA.length, BA = CA, eA = !IA;
    if (H == null)
      return !BA;
    for (H = Object(H); CA--; ) {
      var iA = gA[CA];
      if (eA && iA[2] ? iA[1] !== H[iA[0]] : !(iA[0] in H))
        return !1;
    }
    for (; ++CA < BA; ) {
      iA = gA[CA];
      var QA = iA[0], tA = H[QA], oA = iA[1];
      if (eA && iA[2]) {
        if (tA === void 0 && !(QA in H))
          return !1;
      } else {
        var EA = new n();
        if (IA)
          var aA = IA(tA, oA, QA, H, AA, EA);
        if (!(aA === void 0 ? t(oA, tA, g | d, IA, EA) : aA))
          return !1;
      }
    }
    return !0;
  }
  return _baseIsMatch = k, _baseIsMatch;
}
var _isStrictComparable, hasRequired_isStrictComparable;
function require_isStrictComparable() {
  if (hasRequired_isStrictComparable) return _isStrictComparable;
  hasRequired_isStrictComparable = 1;
  var n = requireIsObject();
  function t(g) {
    return g === g && !n(g);
  }
  return _isStrictComparable = t, _isStrictComparable;
}
var _getMatchData, hasRequired_getMatchData;
function require_getMatchData() {
  if (hasRequired_getMatchData) return _getMatchData;
  hasRequired_getMatchData = 1;
  var n = require_isStrictComparable(), t = requireKeys();
  function g(d) {
    for (var k = t(d), H = k.length; H--; ) {
      var AA = k[H], gA = d[AA];
      k[H] = [AA, gA, n(gA)];
    }
    return k;
  }
  return _getMatchData = g, _getMatchData;
}
var _matchesStrictComparable, hasRequired_matchesStrictComparable;
function require_matchesStrictComparable() {
  if (hasRequired_matchesStrictComparable) return _matchesStrictComparable;
  hasRequired_matchesStrictComparable = 1;
  function n(t, g) {
    return function(d) {
      return d == null ? !1 : d[t] === g && (g !== void 0 || t in Object(d));
    };
  }
  return _matchesStrictComparable = n, _matchesStrictComparable;
}
var _baseMatches, hasRequired_baseMatches;
function require_baseMatches() {
  if (hasRequired_baseMatches) return _baseMatches;
  hasRequired_baseMatches = 1;
  var n = require_baseIsMatch(), t = require_getMatchData(), g = require_matchesStrictComparable();
  function d(k) {
    var H = t(k);
    return H.length == 1 && H[0][2] ? g(H[0][0], H[0][1]) : function(AA) {
      return AA === k || n(AA, k, H);
    };
  }
  return _baseMatches = d, _baseMatches;
}
var _baseHasIn, hasRequired_baseHasIn;
function require_baseHasIn() {
  if (hasRequired_baseHasIn) return _baseHasIn;
  hasRequired_baseHasIn = 1;
  function n(t, g) {
    return t != null && g in Object(t);
  }
  return _baseHasIn = n, _baseHasIn;
}
var hasIn_1, hasRequiredHasIn;
function requireHasIn() {
  if (hasRequiredHasIn) return hasIn_1;
  hasRequiredHasIn = 1;
  var n = require_baseHasIn(), t = require_hasPath();
  function g(d, k) {
    return d != null && t(d, k, n);
  }
  return hasIn_1 = g, hasIn_1;
}
var _baseMatchesProperty, hasRequired_baseMatchesProperty;
function require_baseMatchesProperty() {
  if (hasRequired_baseMatchesProperty) return _baseMatchesProperty;
  hasRequired_baseMatchesProperty = 1;
  var n = require_baseIsEqual(), t = requireGet(), g = requireHasIn(), d = require_isKey(), k = require_isStrictComparable(), H = require_matchesStrictComparable(), AA = require_toKey(), gA = 1, IA = 2;
  function CA(BA, eA) {
    return d(BA) && k(eA) ? H(AA(BA), eA) : function(iA) {
      var QA = t(iA, BA);
      return QA === void 0 && QA === eA ? g(iA, BA) : n(eA, QA, gA | IA);
    };
  }
  return _baseMatchesProperty = CA, _baseMatchesProperty;
}
var _basePropertyDeep, hasRequired_basePropertyDeep;
function require_basePropertyDeep() {
  if (hasRequired_basePropertyDeep) return _basePropertyDeep;
  hasRequired_basePropertyDeep = 1;
  var n = require_baseGet();
  function t(g) {
    return function(d) {
      return n(d, g);
    };
  }
  return _basePropertyDeep = t, _basePropertyDeep;
}
var property_1, hasRequiredProperty;
function requireProperty() {
  if (hasRequiredProperty) return property_1;
  hasRequiredProperty = 1;
  var n = require_baseProperty(), t = require_basePropertyDeep(), g = require_isKey(), d = require_toKey();
  function k(H) {
    return g(H) ? n(d(H)) : t(H);
  }
  return property_1 = k, property_1;
}
var _baseIteratee, hasRequired_baseIteratee;
function require_baseIteratee() {
  if (hasRequired_baseIteratee) return _baseIteratee;
  hasRequired_baseIteratee = 1;
  var n = require_baseMatches(), t = require_baseMatchesProperty(), g = requireIdentity(), d = requireIsArray(), k = requireProperty();
  function H(AA) {
    return typeof AA == "function" ? AA : AA == null ? g : typeof AA == "object" ? d(AA) ? t(AA[0], AA[1]) : n(AA) : k(AA);
  }
  return _baseIteratee = H, _baseIteratee;
}
var _createAggregator, hasRequired_createAggregator;
function require_createAggregator() {
  if (hasRequired_createAggregator) return _createAggregator;
  hasRequired_createAggregator = 1;
  var n = require_arrayAggregator(), t = require_baseAggregator(), g = require_baseIteratee(), d = requireIsArray();
  function k(H, AA) {
    return function(gA, IA) {
      var CA = d(gA) ? n : t, BA = AA ? AA() : {};
      return CA(gA, H, g(IA, 2), BA);
    };
  }
  return _createAggregator = k, _createAggregator;
}
var groupBy_1, hasRequiredGroupBy;
function requireGroupBy() {
  if (hasRequiredGroupBy) return groupBy_1;
  hasRequiredGroupBy = 1;
  var n = require_baseAssignValue(), t = require_createAggregator(), g = Object.prototype, d = g.hasOwnProperty, k = t(function(H, AA, gA) {
    d.call(H, gA) ? H[gA].push(AA) : n(H, gA, [AA]);
  });
  return groupBy_1 = k, groupBy_1;
}
var groupByExports = requireGroupBy();
const groupBy = /* @__PURE__ */ getDefaultExportFromCjs$2(groupByExports);
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(n) {
    for (var t, g = 1, d = arguments.length; g < d; g++) {
      t = arguments[g];
      for (var k in t) Object.prototype.hasOwnProperty.call(t, k) && (n[k] = t[k]);
    }
    return n;
  }, __assign$1.apply(this, arguments);
}, rowSizeBase = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, colSizeBase = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, edgeBase = {
  width: "20px",
  height: "20px",
  position: "absolute",
  zIndex: 1
}, styles = {
  top: __assign$1(__assign$1({}, rowSizeBase), { top: "-5px" }),
  right: __assign$1(__assign$1({}, colSizeBase), { left: void 0, right: "-5px" }),
  bottom: __assign$1(__assign$1({}, rowSizeBase), { top: void 0, bottom: "-5px" }),
  left: __assign$1(__assign$1({}, colSizeBase), { left: "-5px" }),
  topRight: __assign$1(__assign$1({}, edgeBase), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: __assign$1(__assign$1({}, edgeBase), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: __assign$1(__assign$1({}, edgeBase), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: __assign$1(__assign$1({}, edgeBase), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, Resizer = memo$1(function(n) {
  var t = n.onResizeStart, g = n.direction, d = n.children, k = n.replaceStyles, H = n.className, AA = useCallback(function(CA) {
    t(CA, g);
  }, [t, g]), gA = useCallback(function(CA) {
    t(CA, g);
  }, [t, g]), IA = useMemo$1(function() {
    return __assign$1(__assign$1({ position: "absolute", userSelect: "none" }, styles[g]), k ?? {});
  }, [k, g]);
  return jsxRuntimeExports.jsx("div", { className: H || void 0, style: IA, onMouseDown: AA, onTouchStart: gA, children: d });
}), __extends = /* @__PURE__ */ (function() {
  var n = function(t, g) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, k) {
      d.__proto__ = k;
    } || function(d, k) {
      for (var H in k) Object.prototype.hasOwnProperty.call(k, H) && (d[H] = k[H]);
    }, n(t, g);
  };
  return function(t, g) {
    if (typeof g != "function" && g !== null)
      throw new TypeError("Class extends value " + String(g) + " is not a constructor or null");
    n(t, g);
    function d() {
      this.constructor = t;
    }
    t.prototype = g === null ? Object.create(g) : (d.prototype = g.prototype, new d());
  };
})(), __assign = function() {
  return __assign = Object.assign || function(n) {
    for (var t, g = 1, d = arguments.length; g < d; g++) {
      t = arguments[g];
      for (var k in t) Object.prototype.hasOwnProperty.call(t, k) && (n[k] = t[k]);
    }
    return n;
  }, __assign.apply(this, arguments);
}, DEFAULT_SIZE = {
  width: "auto",
  height: "auto"
}, clamp = function(n, t, g) {
  return Math.max(Math.min(n, g), t);
}, snap = function(n, t, g) {
  var d = Math.round(n / t);
  return d * t + g * (d - 1);
}, hasDirection = function(n, t) {
  return new RegExp(n, "i").test(t);
}, isTouchEvent = function(n) {
  return !!(n.touches && n.touches.length);
}, isMouseEvent = function(n) {
  return !!((n.clientX || n.clientX === 0) && (n.clientY || n.clientY === 0));
}, findClosestSnap = function(n, t, g) {
  g === void 0 && (g = 0);
  var d = t.reduce(function(H, AA, gA) {
    return Math.abs(AA - n) < Math.abs(t[H] - n) ? gA : H;
  }, 0), k = Math.abs(t[d] - n);
  return g === 0 || k < g ? t[d] : n;
}, getStringSize = function(n) {
  return n = n.toString(), n === "auto" || n.endsWith("px") || n.endsWith("%") || n.endsWith("vh") || n.endsWith("vw") || n.endsWith("vmax") || n.endsWith("vmin") ? n : "".concat(n, "px");
}, getPixelSize = function(n, t, g, d) {
  if (n && typeof n == "string") {
    if (n.endsWith("px"))
      return Number(n.replace("px", ""));
    if (n.endsWith("%")) {
      var k = Number(n.replace("%", "")) / 100;
      return t * k;
    }
    if (n.endsWith("vw")) {
      var k = Number(n.replace("vw", "")) / 100;
      return g * k;
    }
    if (n.endsWith("vh")) {
      var k = Number(n.replace("vh", "")) / 100;
      return d * k;
    }
  }
  return n;
}, calculateNewMax = function(n, t, g, d, k, H, AA) {
  return d = getPixelSize(d, n.width, t, g), k = getPixelSize(k, n.height, t, g), H = getPixelSize(H, n.width, t, g), AA = getPixelSize(AA, n.height, t, g), {
    maxWidth: typeof d > "u" ? void 0 : Number(d),
    maxHeight: typeof k > "u" ? void 0 : Number(k),
    minWidth: typeof H > "u" ? void 0 : Number(H),
    minHeight: typeof AA > "u" ? void 0 : Number(AA)
  };
}, normalizeToPair = function(n) {
  return Array.isArray(n) ? n : [n, n];
}, definedProps = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "gridGap",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], baseClassName = "__resizable_base__", Resizable = (
  /** @class */
  (function(n) {
    __extends(t, n);
    function t(g) {
      var d, k, H, AA, gA = n.call(this, g) || this;
      return gA.ratio = 1, gA.resizable = null, gA.parentLeft = 0, gA.parentTop = 0, gA.resizableLeft = 0, gA.resizableRight = 0, gA.resizableTop = 0, gA.resizableBottom = 0, gA.targetLeft = 0, gA.targetTop = 0, gA.delta = {
        width: 0,
        height: 0
      }, gA.appendBase = function() {
        if (!gA.resizable || !gA.window)
          return null;
        var IA = gA.parentNode;
        if (!IA)
          return null;
        var CA = gA.window.document.createElement("div");
        return CA.style.width = "100%", CA.style.height = "100%", CA.style.position = "absolute", CA.style.transform = "scale(0, 0)", CA.style.left = "0", CA.style.flex = "0 0 100%", CA.classList ? CA.classList.add(baseClassName) : CA.className += baseClassName, IA.appendChild(CA), CA;
      }, gA.removeBase = function(IA) {
        var CA = gA.parentNode;
        CA && CA.removeChild(IA);
      }, gA.state = {
        isResizing: !1,
        width: (k = (d = gA.propsSize) === null || d === void 0 ? void 0 : d.width) !== null && k !== void 0 ? k : "auto",
        height: (AA = (H = gA.propsSize) === null || H === void 0 ? void 0 : H.height) !== null && AA !== void 0 ? AA : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, gA.onResizeStart = gA.onResizeStart.bind(gA), gA.onMouseMove = gA.onMouseMove.bind(gA), gA.onMouseUp = gA.onMouseUp.bind(gA), gA;
    }
    return Object.defineProperty(t.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || DEFAULT_SIZE;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
      get: function() {
        var g = 0, d = 0;
        if (this.resizable && this.window) {
          var k = this.resizable.offsetWidth, H = this.resizable.offsetHeight, AA = this.resizable.style.position;
          AA !== "relative" && (this.resizable.style.position = "relative"), g = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : k, d = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : H, this.resizable.style.position = AA;
        }
        return { width: g, height: d };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sizeStyle", {
      get: function() {
        var g = this, d = this.props.size, k = function(gA) {
          var IA;
          if (typeof g.state[gA] > "u" || g.state[gA] === "auto")
            return "auto";
          if (g.propsSize && g.propsSize[gA] && (!((IA = g.propsSize[gA]) === null || IA === void 0) && IA.toString().endsWith("%"))) {
            if (g.state[gA].toString().endsWith("%"))
              return g.state[gA].toString();
            var CA = g.getParentSize(), BA = Number(g.state[gA].toString().replace("px", "")), eA = BA / CA[gA] * 100;
            return "".concat(eA, "%");
          }
          return getStringSize(g.state[gA]);
        }, H = d && typeof d.width < "u" && !this.state.isResizing ? getStringSize(d.width) : k("width"), AA = d && typeof d.height < "u" && !this.state.isResizing ? getStringSize(d.height) : k("height");
        return { width: H, height: AA };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var g = this.appendBase();
      if (!g)
        return { width: 0, height: 0 };
      var d = !1, k = this.parentNode.style.flexWrap;
      k !== "wrap" && (d = !0, this.parentNode.style.flexWrap = "wrap"), g.style.position = "relative", g.style.minWidth = "100%", g.style.minHeight = "100%";
      var H = {
        width: g.offsetWidth,
        height: g.offsetHeight
      };
      return d && (this.parentNode.style.flexWrap = k), this.removeBase(g), H;
    }, t.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, t.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, t.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var g = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: g.flexBasis !== "auto" ? g.flexBasis : void 0
        });
      }
    }, t.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, t.prototype.createSizeForCssProperty = function(g, d) {
      var k = this.propsSize && this.propsSize[d];
      return this.state[d] === "auto" && this.state.original[d] === g && (typeof k > "u" || k === "auto") ? "auto" : g;
    }, t.prototype.calculateNewMaxFromBoundary = function(g, d) {
      var k = this.props.boundsByDirection, H = this.state.direction, AA = k && hasDirection("left", H), gA = k && hasDirection("top", H), IA, CA;
      if (this.props.bounds === "parent") {
        var BA = this.parentNode;
        BA && (IA = AA ? this.resizableRight - this.parentLeft : BA.offsetWidth + (this.parentLeft - this.resizableLeft), CA = gA ? this.resizableBottom - this.parentTop : BA.offsetHeight + (this.parentTop - this.resizableTop));
      } else this.props.bounds === "window" ? this.window && (IA = AA ? this.resizableRight : this.window.innerWidth - this.resizableLeft, CA = gA ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (IA = AA ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), CA = gA ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return IA && Number.isFinite(IA) && (g = g && g < IA ? g : IA), CA && Number.isFinite(CA) && (d = d && d < CA ? d : CA), { maxWidth: g, maxHeight: d };
    }, t.prototype.calculateNewSizeFromDirection = function(g, d) {
      var k = this.props.scale || 1, H = normalizeToPair(this.props.resizeRatio || 1), AA = H[0], gA = H[1], IA = this.state, CA = IA.direction, BA = IA.original, eA = this.props, iA = eA.lockAspectRatio, QA = eA.lockAspectRatioExtraHeight, tA = eA.lockAspectRatioExtraWidth, oA = BA.width, EA = BA.height, aA = QA || 0, nA = tA || 0;
      return hasDirection("right", CA) && (oA = BA.width + (g - BA.x) * AA / k, iA && (EA = (oA - nA) / this.ratio + aA)), hasDirection("left", CA) && (oA = BA.width - (g - BA.x) * AA / k, iA && (EA = (oA - nA) / this.ratio + aA)), hasDirection("bottom", CA) && (EA = BA.height + (d - BA.y) * gA / k, iA && (oA = (EA - aA) * this.ratio + nA)), hasDirection("top", CA) && (EA = BA.height - (d - BA.y) * gA / k, iA && (oA = (EA - aA) * this.ratio + nA)), { newWidth: oA, newHeight: EA };
    }, t.prototype.calculateNewSizeFromAspectRatio = function(g, d, k, H) {
      var AA = this.props, gA = AA.lockAspectRatio, IA = AA.lockAspectRatioExtraHeight, CA = AA.lockAspectRatioExtraWidth, BA = typeof H.width > "u" ? 10 : H.width, eA = typeof k.width > "u" || k.width < 0 ? g : k.width, iA = typeof H.height > "u" ? 10 : H.height, QA = typeof k.height > "u" || k.height < 0 ? d : k.height, tA = IA || 0, oA = CA || 0;
      if (gA) {
        var EA = (iA - tA) * this.ratio + oA, aA = (QA - tA) * this.ratio + oA, nA = (BA - oA) / this.ratio + tA, lA = (eA - oA) / this.ratio + tA, cA = Math.max(BA, EA), sA = Math.min(eA, aA), rA = Math.max(iA, nA), uA = Math.min(QA, lA);
        g = clamp(g, cA, sA), d = clamp(d, rA, uA);
      } else
        g = clamp(g, BA, eA), d = clamp(d, iA, QA);
      return { newWidth: g, newHeight: d };
    }, t.prototype.setBoundingClientRect = function() {
      var g = 1 / (this.props.scale || 1);
      if (this.props.bounds === "parent") {
        var d = this.parentNode;
        if (d) {
          var k = d.getBoundingClientRect();
          this.parentLeft = k.left * g, this.parentTop = k.top * g;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var H = this.props.bounds.getBoundingClientRect();
        this.targetLeft = H.left * g, this.targetTop = H.top * g;
      }
      if (this.resizable) {
        var AA = this.resizable.getBoundingClientRect(), gA = AA.left, IA = AA.top, CA = AA.right, BA = AA.bottom;
        this.resizableLeft = gA * g, this.resizableRight = CA * g, this.resizableTop = IA * g, this.resizableBottom = BA * g;
      }
    }, t.prototype.onResizeStart = function(g, d) {
      if (!(!this.resizable || !this.window)) {
        var k = 0, H = 0;
        if (g.nativeEvent && isMouseEvent(g.nativeEvent) ? (k = g.nativeEvent.clientX, H = g.nativeEvent.clientY) : g.nativeEvent && isTouchEvent(g.nativeEvent) && (k = g.nativeEvent.touches[0].clientX, H = g.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var AA = this.props.onResizeStart(g, d, this.resizable);
          if (AA === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var gA, IA = this.window.getComputedStyle(this.resizable);
        if (IA.flexBasis !== "auto") {
          var CA = this.parentNode;
          if (CA) {
            var BA = this.window.getComputedStyle(CA).flexDirection;
            this.flexDir = BA.startsWith("row") ? "row" : "column", gA = IA.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var eA = {
          original: {
            x: k,
            y: H,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(g.target).cursor || "auto" }),
          direction: d,
          flexBasis: gA
        };
        this.setState(eA);
      }
    }, t.prototype.onMouseMove = function(g) {
      var d = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && isTouchEvent(g))
          try {
            g.preventDefault(), g.stopPropagation();
          } catch {
          }
        var k = this.props, H = k.maxWidth, AA = k.maxHeight, gA = k.minWidth, IA = k.minHeight, CA = isTouchEvent(g) ? g.touches[0].clientX : g.clientX, BA = isTouchEvent(g) ? g.touches[0].clientY : g.clientY, eA = this.state, iA = eA.direction, QA = eA.original, tA = eA.width, oA = eA.height, EA = this.getParentSize(), aA = calculateNewMax(EA, this.window.innerWidth, this.window.innerHeight, H, AA, gA, IA);
        H = aA.maxWidth, AA = aA.maxHeight, gA = aA.minWidth, IA = aA.minHeight;
        var nA = this.calculateNewSizeFromDirection(CA, BA), lA = nA.newHeight, cA = nA.newWidth, sA = this.calculateNewMaxFromBoundary(H, AA);
        this.props.snap && this.props.snap.x && (cA = findClosestSnap(cA, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (lA = findClosestSnap(lA, this.props.snap.y, this.props.snapGap));
        var rA = this.calculateNewSizeFromAspectRatio(cA, lA, { width: sA.maxWidth, height: sA.maxHeight }, { width: gA, height: IA });
        if (cA = rA.newWidth, lA = rA.newHeight, this.props.grid) {
          var uA = snap(cA, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0), hA = snap(lA, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0), dA = this.props.snapGap || 0, GA = dA === 0 || Math.abs(uA - cA) <= dA ? uA : cA, DA = dA === 0 || Math.abs(hA - lA) <= dA ? hA : lA;
          cA = GA, lA = DA;
        }
        var wA = {
          width: cA - QA.width,
          height: lA - QA.height
        };
        if (this.delta = wA, tA && typeof tA == "string") {
          if (tA.endsWith("%")) {
            var bA = cA / EA.width * 100;
            cA = "".concat(bA, "%");
          } else if (tA.endsWith("vw")) {
            var yA = cA / this.window.innerWidth * 100;
            cA = "".concat(yA, "vw");
          } else if (tA.endsWith("vh")) {
            var pA = cA / this.window.innerHeight * 100;
            cA = "".concat(pA, "vh");
          }
        }
        if (oA && typeof oA == "string") {
          if (oA.endsWith("%")) {
            var bA = lA / EA.height * 100;
            lA = "".concat(bA, "%");
          } else if (oA.endsWith("vw")) {
            var yA = lA / this.window.innerWidth * 100;
            lA = "".concat(yA, "vw");
          } else if (oA.endsWith("vh")) {
            var pA = lA / this.window.innerHeight * 100;
            lA = "".concat(pA, "vh");
          }
        }
        var MA = {
          width: this.createSizeForCssProperty(cA, "width"),
          height: this.createSizeForCssProperty(lA, "height")
        };
        this.flexDir === "row" ? MA.flexBasis = MA.width : this.flexDir === "column" && (MA.flexBasis = MA.height);
        var LA = this.state.width !== MA.width, xA = this.state.height !== MA.height, TA = this.state.flexBasis !== MA.flexBasis, NA = LA || xA || TA;
        NA && flushSync(function() {
          d.setState(MA);
        }), this.props.onResize && NA && this.props.onResize(g, iA, this.resizable, wA);
      }
    }, t.prototype.onMouseUp = function(g) {
      var d, k, H = this.state, AA = H.isResizing, gA = H.direction;
      H.original, !(!AA || !this.resizable) && (this.props.onResizeStop && this.props.onResizeStop(g, gA, this.resizable, this.delta), this.props.size && this.setState({ width: (d = this.props.size.width) !== null && d !== void 0 ? d : "auto", height: (k = this.props.size.height) !== null && k !== void 0 ? k : "auto" }), this.unbindEvents(), this.setState({
        isResizing: !1,
        backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: "auto" })
      }));
    }, t.prototype.updateSize = function(g) {
      var d, k;
      this.setState({ width: (d = g.width) !== null && d !== void 0 ? d : "auto", height: (k = g.height) !== null && k !== void 0 ? k : "auto" });
    }, t.prototype.renderResizer = function() {
      var g = this, d = this.props, k = d.enable, H = d.handleStyles, AA = d.handleClasses, gA = d.handleWrapperStyle, IA = d.handleWrapperClass, CA = d.handleComponent;
      if (!k)
        return null;
      var BA = Object.keys(k).map(function(eA) {
        return k[eA] !== !1 ? jsxRuntimeExports.jsx(Resizer, { direction: eA, onResizeStart: g.onResizeStart, replaceStyles: H && H[eA], className: AA && AA[eA], children: CA && CA[eA] ? CA[eA] : null }, eA) : null;
      });
      return jsxRuntimeExports.jsx("div", { className: IA, style: gA, children: BA });
    }, t.prototype.render = function() {
      var g = this, d = Object.keys(this.props).reduce(function(AA, gA) {
        return definedProps.indexOf(gA) !== -1 || (AA[gA] = g.props[gA]), AA;
      }, {}), k = __assign(__assign(__assign({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (k.flexBasis = this.state.flexBasis);
      var H = this.props.as || "div";
      return jsxRuntimeExports.jsxs(H, __assign({ style: k, className: this.props.className }, d, {
        // `ref` is after `extendsProps` to ensure this one wins over a version
        // passed in
        ref: function(AA) {
          AA && (g.resizable = AA);
        },
        children: [this.state.isResizing && jsxRuntimeExports.jsx("div", { style: this.state.backgroundStyle }), this.props.children, this.renderResizer()]
      }));
    }, t.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      gridGap: [0, 0],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, t;
  })(PureComponent)
);
const measureScrollbarGutterSize = () => {
  const n = document.createElement("div");
  n.style.position = "absolute", n.style.top = "-9999px", n.style.left = "-9999px", n.style.visibility = "hidden", n.style.overflow = "scroll", n.style.width = "50px", n.style.height = "50px", document.body.appendChild(n);
  const t = document.createElement("div");
  t.style.width = "100%", t.style.height = "100%", n.appendChild(t);
  const g = n.offsetWidth - t.offsetWidth;
  return n.remove(), g;
}, useScrollbarGutterSize = () => {
  const n = window.devicePixelRatio;
  return useMemo$1(() => measureScrollbarGutterSize(), [n]);
};
var mergeWith_1, hasRequiredMergeWith;
function requireMergeWith() {
  if (hasRequiredMergeWith) return mergeWith_1;
  hasRequiredMergeWith = 1;
  var n = require_baseMerge(), t = require_createAssigner(), g = t(function(d, k, H, AA) {
    n(d, k, H, AA);
  });
  return mergeWith_1 = g, mergeWith_1;
}
var mergeWithExports = requireMergeWith();
const mergeWith = /* @__PURE__ */ getDefaultExportFromCjs$2(mergeWithExports);
var _baseMap, hasRequired_baseMap;
function require_baseMap() {
  if (hasRequired_baseMap) return _baseMap;
  hasRequired_baseMap = 1;
  var n = require_baseEach(), t = requireIsArrayLike();
  function g(d, k) {
    var H = -1, AA = t(d) ? Array(d.length) : [];
    return n(d, function(gA, IA, CA) {
      AA[++H] = k(gA, IA, CA);
    }), AA;
  }
  return _baseMap = g, _baseMap;
}
var _baseSortBy, hasRequired_baseSortBy;
function require_baseSortBy() {
  if (hasRequired_baseSortBy) return _baseSortBy;
  hasRequired_baseSortBy = 1;
  function n(t, g) {
    var d = t.length;
    for (t.sort(g); d--; )
      t[d] = t[d].value;
    return t;
  }
  return _baseSortBy = n, _baseSortBy;
}
var _compareAscending, hasRequired_compareAscending;
function require_compareAscending() {
  if (hasRequired_compareAscending) return _compareAscending;
  hasRequired_compareAscending = 1;
  var n = requireIsSymbol();
  function t(g, d) {
    if (g !== d) {
      var k = g !== void 0, H = g === null, AA = g === g, gA = n(g), IA = d !== void 0, CA = d === null, BA = d === d, eA = n(d);
      if (!CA && !eA && !gA && g > d || gA && IA && BA && !CA && !eA || H && IA && BA || !k && BA || !AA)
        return 1;
      if (!H && !gA && !eA && g < d || eA && k && AA && !H && !gA || CA && k && AA || !IA && AA || !BA)
        return -1;
    }
    return 0;
  }
  return _compareAscending = t, _compareAscending;
}
var _compareMultiple, hasRequired_compareMultiple;
function require_compareMultiple() {
  if (hasRequired_compareMultiple) return _compareMultiple;
  hasRequired_compareMultiple = 1;
  var n = require_compareAscending();
  function t(g, d, k) {
    for (var H = -1, AA = g.criteria, gA = d.criteria, IA = AA.length, CA = k.length; ++H < IA; ) {
      var BA = n(AA[H], gA[H]);
      if (BA) {
        if (H >= CA)
          return BA;
        var eA = k[H];
        return BA * (eA == "desc" ? -1 : 1);
      }
    }
    return g.index - d.index;
  }
  return _compareMultiple = t, _compareMultiple;
}
var _baseOrderBy, hasRequired_baseOrderBy;
function require_baseOrderBy() {
  if (hasRequired_baseOrderBy) return _baseOrderBy;
  hasRequired_baseOrderBy = 1;
  var n = require_arrayMap(), t = require_baseGet(), g = require_baseIteratee(), d = require_baseMap(), k = require_baseSortBy(), H = require_baseUnary(), AA = require_compareMultiple(), gA = requireIdentity(), IA = requireIsArray();
  function CA(BA, eA, iA) {
    eA.length ? eA = n(eA, function(oA) {
      return IA(oA) ? function(EA) {
        return t(EA, oA.length === 1 ? oA[0] : oA);
      } : oA;
    }) : eA = [gA];
    var QA = -1;
    eA = n(eA, H(g));
    var tA = d(BA, function(oA, EA, aA) {
      var nA = n(eA, function(lA) {
        return lA(oA);
      });
      return { criteria: nA, index: ++QA, value: oA };
    });
    return k(tA, function(oA, EA) {
      return AA(oA, EA, iA);
    });
  }
  return _baseOrderBy = CA, _baseOrderBy;
}
var isEqual_1, hasRequiredIsEqual;
function requireIsEqual() {
  if (hasRequiredIsEqual) return isEqual_1;
  hasRequiredIsEqual = 1;
  var n = require_baseIsEqual();
  function t(g, d) {
    return n(g, d);
  }
  return isEqual_1 = t, isEqual_1;
}
var isEqualExports = requireIsEqual();
const isEqual$1 = /* @__PURE__ */ getDefaultExportFromCjs$2(isEqualExports), StyledVegaLiteChartTooltips = (n) => ({
  "#vg-tooltip-element": {
    visibility: "hidden",
    position: "fixed",
    fontFamily: n.genericFonts.bodyFont,
    color: n.colors.bodyText,
    border: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
    backgroundColor: transparentize(n.colors.bgColor, 0.05),
    fontSize: n.fontSizes.twoSm,
    boxShadow: "rgb(0 0 0 / 16%) 0px 1px 4px",
    maxWidth: n.sizes.maxChartTooltipWidth,
    padding: `${n.spacing.xs} ${n.spacing.md}`,
    borderRadius: n.radii.default,
    zIndex: n.zIndices.popup,
    "&.visible": {
      visibility: "visible"
    },
    h2: {
      marginTop: n.spacing.none,
      marginBottom: n.spacing.sm,
      fontSize: n.fontSizes.sm
    },
    td: {
      border: "none"
    },
    table: {
      borderSpacing: 0,
      tr: {
        border: "none",
        td: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          paddingTop: n.spacing.threeXS,
          paddingBottom: n.spacing.threeXS
        },
        "td.key": {
          // This should use a max of 40% of the available width (- padding):
          maxWidth: `calc((${n.sizes.maxChartTooltipWidth} - 2 * ${n.spacing.md}) * 0.4)`,
          textAlign: "right",
          color: n.colors.fadedText60,
          whiteSpace: "nowrap",
          paddingRight: n.spacing.twoXS
        },
        "td.value": {
          // This should use a max of 60% of the available width (- padding):
          maxWidth: `calc((${n.sizes.maxChartTooltipWidth} - 2 * ${n.spacing.md}) * 0.6)`,
          textAlign: "left",
          // We are limiting the height of the value to a max of 5 lines via
          // the a webkit property that is supported by all major browsers:
          // https://caniuse.com/?search=-webkit-line-clamp
          display: "-webkit-box",
          WebkitLineClamp: "5",
          WebkitBoxOrient: "vertical",
          lineClamp: "5",
          wordWrap: "break-word"
        }
      }
    }
  }
}), StyledVegaLiteChartContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "egd2k5h0"
} : {
  target: "egd2k5h0",
  label: "StyledVegaLiteChartContainer"
})(({
  theme: n,
  useContainerWidth: t,
  useContainerHeight: g
}) => ({
  width: t ? "100%" : "auto",
  height: g ? "100%" : "auto",
  // These styles come from VegaLite Library
  "&.vega-embed": {
    position: "relative",
    display: "inline-block",
    boxSizing: "border-box",
    "details:not([open]) > :not(summary)": {
      display: "none !important"
    },
    "details[open] summary": {
      opacity: 0.7
    },
    "&:hover summary, .vega-embed:focus summary": {
      background: "transparent"
    },
    "&:hover summary, &:focus-within summary": {
      opacity: "1 !important",
      transition: "opacity 0.2s ease"
    },
    "&.has-actions": {
      paddingRight: 0
    },
    ".vega-actions": {
      position: "absolute",
      display: "flex",
      flexDirection: "column",
      paddingBottom: n.spacing.sm,
      paddingTop: n.spacing.sm,
      zIndex: n.zIndices.popup,
      // Position under the menu button. The size of the menu button
      // iconSizes.md + padding (2 * spacing.xs)
      //+ some additional spacing (spacing.xs)
      top: `calc(${n.iconSizes.md} + 2 * ${n.spacing.xs} + ${n.spacing.xs})`,
      right: 0,
      // Customize menu UI to look like the Streamlit menu:
      backgroundColor: n.colors.bgColor,
      boxShadow: "rgb(0 0 0 / 16%) 0px 4px 16px",
      border: `${n.sizes.borderWidth} solid ${n.colors.fadedText10}`,
      animationDuration: "0.15s",
      animationName: "scale-in",
      animationTimingFunction: "cubic-bezier(0.2, 0, 0.13, 1.5)",
      textAlign: "left",
      borderRadius: n.radii.default,
      a: {
        fontFamily: n.genericFonts.bodyFont,
        fontWeight: n.fontWeights.normal,
        fontSize: n.fontSizes.md,
        margin: 0,
        padding: `${n.spacing.twoXS} ${n.spacing.twoXL}`,
        color: n.colors.bodyText,
        whiteSpace: "nowrap",
        textDecoration: "none"
      },
      "a:hover, a:focus": {
        backgroundColor: n.colors.darkenedBgMix15,
        color: n.colors.bodyText
      },
      ":before": {
        content: "none"
      },
      ":after": {
        content: "none"
      }
    },
    "@keyframes scale-in": {
      from: {
        opacity: 0,
        transform: "scale(0.6)"
      },
      to: {
        opacity: 1,
        transform: "scale(1)"
      }
    },
    ".chart-wrapper": {
      "&.fit-x": {
        width: "100%"
      },
      "&.fit-y": {
        height: "100%"
      }
    },
    summary: {
      position: "absolute",
      top: 0,
      right: 0,
      opacity: 0,
      listStyle: "none",
      cursor: "pointer",
      display: "list-item",
      padding: n.spacing.xs,
      // Fix weird floating button height issue in Vega Lite.
      height: "auto",
      // Fix floating button appearing above pop-ups.
      zIndex: n.zIndices.menuButton,
      border: "none",
      boxShadow: "none",
      borderRadius: n.radii.default,
      color: n.colors.fadedText10,
      backgroundColor: "transparent",
      transition: "opacity 300ms 150ms,transform 300ms 150ms",
      lineHeight: 0,
      "&::-webkit-details-marker": {
        display: "none"
      },
      "&:active, &:focus-visible, &:hover": {
        border: "none",
        boxShadow: "none",
        color: n.colors.bodyText,
        opacity: "1 !important",
        background: n.colors.darkenedBgMix15
      },
      svg: {
        width: n.iconSizes.md,
        height: n.iconSizes.md
      }
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function applyStreamlitTheme(n, t) {
  const g = {
    font: t.genericFonts.bodyFont,
    background: t.colors.bgColor,
    fieldTitle: "verbal",
    autosize: {
      type: "fit",
      contains: "padding"
    },
    title: {
      align: "left",
      anchor: "start",
      color: t.colors.headingColor,
      titleFontStyle: "normal",
      fontWeight: t.fontWeights.bold,
      fontSize: convertRemToPx(t.fontSizes.md),
      orient: "top",
      offset: 26
    },
    header: {
      titleFontWeight: t.fontWeights.normal,
      titleFontSize: convertRemToPx(t.fontSizes.md),
      titleColor: getGray70(t),
      titleFontStyle: "normal",
      labelFontSize: convertRemToPx(t.fontSizes.twoSm),
      labelFontWeight: t.fontWeights.normal,
      labelColor: getGray70(t),
      labelFontStyle: "normal"
    },
    axis: {
      labelFontSize: convertRemToPx(t.fontSizes.twoSm),
      labelFontWeight: t.fontWeights.normal,
      labelColor: getGray70(t),
      labelFontStyle: "normal",
      titleFontWeight: t.fontWeights.normal,
      titleFontSize: convertRemToPx(t.fontSizes.sm),
      titleColor: getGray70(t),
      titleFontStyle: "normal",
      ticks: !1,
      gridColor: getGray30(t),
      domain: !1,
      domainWidth: 1,
      domainColor: getGray30(t),
      labelFlush: !0,
      labelFlushOffset: 1,
      labelBound: !1,
      labelLimit: 100,
      titlePadding: convertRemToPx(t.spacing.lg),
      labelPadding: convertRemToPx(t.spacing.lg),
      labelSeparation: convertRemToPx(t.spacing.twoXS),
      labelOverlap: !0
    },
    legend: {
      labelFontSize: convertRemToPx(t.fontSizes.sm),
      labelFontWeight: t.fontWeights.normal,
      labelColor: getGray70(t),
      titleFontSize: convertRemToPx(t.fontSizes.sm),
      titleFontWeight: t.fontWeights.normal,
      titleFontStyle: "normal",
      titleColor: getGray70(t),
      // TODO(lukasmasuch): Change padding here to use a spacing
      // based on our available spacings (-> 4px = 0.25rem)
      titlePadding: 5,
      labelPadding: convertRemToPx(t.spacing.lg),
      columnPadding: convertRemToPx(t.spacing.sm),
      rowPadding: convertRemToPx(t.spacing.twoXS),
      // TODO(lukasmasuch): Change padding here to use a spacing
      // based on our available spacings (-> 8px = 0.5rem)
      // eslint-disable-next-line streamlit-custom/no-hardcoded-theme-values
      padding: 7,
      symbolStrokeWidth: convertRemToPx(t.spacing.twoXS)
    },
    range: {
      category: t.colors.chartCategoricalColors,
      diverging: getDivergingColorsArray(t),
      ramp: t.colors.chartSequentialColors,
      heatmap: t.colors.chartSequentialColors
    },
    view: {
      columns: 1,
      strokeWidth: 0,
      stroke: "transparent",
      continuousHeight: convertRemToPx(t.sizes.defaultChartHeight),
      continuousWidth: convertRemToPx(t.sizes.defaultChartWidth)
    },
    concat: {
      columns: 1
    },
    facet: {
      columns: 1
    },
    mark: {
      tooltip: {
        content: "encoding"
      },
      color: t.colors.chartCategoricalColors[0]
    },
    bar: {
      binSpacing: convertRemToPx(t.spacing.twoXS),
      discreteBandSize: {
        band: 0.85
      }
    },
    axisDiscrete: {
      grid: !1
    },
    axisXPoint: {
      grid: !1
    },
    axisTemporal: {
      grid: !1
    },
    axisXBand: {
      grid: !1
    }
  };
  return n ? mergeWith({}, g, n, (d, k) => Array.isArray(k) ? k : void 0) : g;
}
function applyThemeDefaults(n, t) {
  const {
    colors: g,
    fontSizes: d,
    genericFonts: k
  } = t, H = {
    labelFont: k.bodyFont,
    titleFont: k.bodyFont,
    labelFontSize: convertRemToPx(d.twoSm),
    titleFontSize: convertRemToPx(d.twoSm)
  }, AA = {
    background: g.bgColor,
    axis: {
      labelColor: g.bodyText,
      titleColor: g.bodyText,
      gridColor: getGray30(t),
      ...H
    },
    legend: {
      labelColor: g.bodyText,
      titleColor: g.bodyText,
      ...H
    },
    title: {
      color: g.bodyText,
      subtitleColor: g.bodyText,
      ...H
    },
    header: {
      labelColor: g.bodyText,
      titleColor: g.bodyText,
      ...H
    },
    view: {
      stroke: getGray30(t),
      continuousHeight: convertRemToPx(t.sizes.defaultChartHeight),
      continuousWidth: convertRemToPx(t.sizes.defaultChartWidth)
    },
    mark: {
      tooltip: !0
    }
  };
  return n ? merge$8({}, AA, n) : AA;
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$a() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledWidgetLabel = /* @__PURE__ */ createStyled$1("label", process.env.NODE_ENV === "production" ? {
  target: "e1y5xkzn3"
} : {
  target: "e1y5xkzn3",
  label: "StyledWidgetLabel"
})(({
  disabled: n,
  labelVisibility: t,
  theme: g
}) => ({
  fontSize: g.fontSizes.sm,
  color: n ? g.colors.fadedText40 : g.colors.bodyText,
  display: t === LabelVisibilityOptions.Collapsed ? "none" : "flex",
  visibility: t === LabelVisibilityOptions.Hidden ? "hidden" : "visible",
  marginBottom: g.spacing.twoXS,
  height: "auto",
  minHeight: g.fontSizes.xl,
  verticalAlign: "middle",
  flexDirection: "row",
  alignItems: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledWidgetLabelHelp = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1y5xkzn2"
} : {
  target: "e1y5xkzn2",
  label: "StyledWidgetLabelHelp"
})(process.env.NODE_ENV === "production" ? {
  name: "1h97c9v",
  styles: "display:flex;flex-direction:row;justify-content:flex-end;flex:1"
} : {
  name: "1h97c9v",
  styles: "display:flex;flex-direction:row;justify-content:flex-end;flex:1/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
}), StyledWidgetInstructions = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1y5xkzn1"
} : {
  target: "e1y5xkzn1",
  label: "StyledWidgetInstructions"
})(({
  theme: n
}) => ({
  fontSize: n.fontSizes.twoSm,
  color: n.colors.fadedText60,
  margin: n.spacing.none,
  textAlign: "right",
  position: "absolute",
  bottom: n.spacing.threeXS,
  right: `calc(${n.fontSizes.mdLg} * 0.5)`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledWidgetLabelHelpInline = /* @__PURE__ */ createStyled$1("label", process.env.NODE_ENV === "production" ? {
  target: "e1y5xkzn0"
} : {
  target: "e1y5xkzn0",
  label: "StyledWidgetLabelHelpInline"
})(({
  theme: n
}) => ({
  marginLeft: n.spacing.xs,
  position: "relative",
  display: "flex",
  flexDirection: "row"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function WidgetLabel({
  label: n,
  children: t,
  disabled: g,
  labelVisibility: d,
  htmlFor: k
}) {
  return isNullOrUndefined$1(n) ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : (
    // we use aria-hidden to disable ARIA for StyleWidgetLabel, because each
    // widget should have its own aria-label and/or implement accessibility.
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledWidgetLabel, { "data-testid": "stWidgetLabel", "aria-hidden": "true", disabled: g, labelVisibility: d, htmlFor: k, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: n, allowHTML: !1, isLabel: !0 }),
      t
    ] })
  );
}
const StyledMetricContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1i5pmia6"
} : {
  target: "e1i5pmia6",
  label: "StyledMetricContainer"
})(({
  theme: n,
  showBorder: t
}) => ({
  height: "100%",
  ...t && {
    border: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
    borderRadius: n.radii.default,
    overflow: "hidden"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9NZXRyaWMvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0JxQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvTWV0cmljL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmltcG9ydCB7IE1ldHJpYyBhcyBNZXRyaWNQcm90byB9IGZyb20gXCJAc3RyZWFtbGl0L3Byb3RvYnVmXCJcblxuaW1wb3J0IHsgU3R5bGVkV2lkZ2V0TGFiZWwgfSBmcm9tIFwifmxpYi9jb21wb25lbnRzL3dpZGdldHMvQmFzZVdpZGdldC9zdHlsZWQtY29tcG9uZW50c1wiXG5pbXBvcnQge1xuICBnZXRNZXRyaWNCYWNrZ3JvdW5kQ29sb3IsXG4gIGdldE1ldHJpY1RleHRDb2xvcixcbn0gZnJvbSBcIn5saWIvdGhlbWUvZ2V0Q29sb3JzXCJcbmltcG9ydCB7IExhYmVsVmlzaWJpbGl0eU9wdGlvbnMgfSBmcm9tIFwifmxpYi91dGlsL3V0aWxzXCJcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRNZXRyaWNDb250YWluZXJQcm9wcyB7XG4gIHNob3dCb3JkZXI6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1ldHJpY0NvbnRhaW5lciA9IHN0eWxlZC5kaXY8U3R5bGVkTWV0cmljQ29udGFpbmVyUHJvcHM+KFxuICAoeyB0aGVtZSwgc2hvd0JvcmRlciB9KSA9PiAoe1xuICAgIGhlaWdodDogXCIxMDAlXCIsXG4gICAgLi4uKHNob3dCb3JkZXIgJiYge1xuICAgICAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0pLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWV0cmljQ29udGVudCA9IHN0eWxlZC5kaXY8eyBzaG93Qm9yZGVyOiBib29sZWFuIH0+KFxuICAoeyB0aGVtZSwgc2hvd0JvcmRlciB9KSA9PiAoe1xuICAgIC4uLihzaG93Qm9yZGVyICYmIHtcbiAgICAgIHBhZGRpbmc6IGBjYWxjKCR7dGhlbWUuc3BhY2luZy5sZ30gLSAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSlgLFxuICAgIH0pLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWV0cmljQ2hhcnQgPSBzdHlsZWQuZGl2PHsgc2hvd0JvcmRlcjogYm9vbGVhbiB9PihcbiAgKHsgdGhlbWUsIHNob3dCb3JkZXIgfSkgPT4gKHtcbiAgICBtYXJnaW5Ub3A6IHNob3dCb3JkZXIgPyB1bmRlZmluZWQgOiB0aGVtZS5zcGFjaW5nLmxnLFxuICAgIG1hcmdpbkJvdHRvbTogc2hvd0JvcmRlciA/IHRoZW1lLnNwYWNpbmcudHdvWEwgOiB1bmRlZmluZWQsXG4gIH0pXG4pXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkTWV0cmljTGFiZWxUZXh0UHJvcHMge1xuICB2aXNpYmlsaXR5PzogTGFiZWxWaXNpYmlsaXR5T3B0aW9uc1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVHJ1bmNhdGVUZXh0ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBvdmVyZmxvd1dyYXA6IFwibm9ybWFsXCIsXG4gIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICB3aWR0aDogXCIxMDAlXCIsXG4gIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuYm9keUZvbnQsXG4gIGxpbmVIZWlnaHQ6IFwibm9ybWFsXCIsXG4gIHZlcnRpY2FsQWxpZ246IFwibWlkZGxlXCIsXG5cbiAgLy8gU3R5bGVzIHRvIHRydW5jYXRlIHRoZSB0ZXh0IGluc2lkZSB0aGUgU3R5bGVkU3RyZWFtbGl0TWFya2Rvd24gZGl2LlxuICBcIiYgPiBkaXZcIjoge1xuICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuXG4gICAgXCImID4gcFwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1ldHJpY0xhYmVsVGV4dCA9IHN0eWxlZChcbiAgU3R5bGVkV2lkZ2V0TGFiZWxcbik8U3R5bGVkTWV0cmljTGFiZWxUZXh0UHJvcHM+KCh7IHZpc2liaWxpdHkgfSkgPT4gKHtcbiAgbWFyZ2luQm90dG9tOiAwLFxuICBkaXNwbGF5OiB2aXNpYmlsaXR5ID09PSBMYWJlbFZpc2liaWxpdHlPcHRpb25zLkNvbGxhcHNlZCA/IFwibm9uZVwiIDogXCJncmlkXCIsXG4gIGdyaWRUZW1wbGF0ZUNvbHVtbnM6XG4gICAgdmlzaWJpbGl0eSA9PT0gTGFiZWxWaXNpYmlsaXR5T3B0aW9ucy5Db2xsYXBzZWQgPyBcImluaXRpYWxcIiA6IFwiYXV0byAxZnJcIixcbiAgdmlzaWJpbGl0eTpcbiAgICB2aXNpYmlsaXR5ID09PSBMYWJlbFZpc2liaWxpdHlPcHRpb25zLkhpZGRlbiA/IFwiaGlkZGVuXCIgOiBcInZpc2libGVcIixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWV0cmljVmFsdWVUZXh0ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnRocmVlWEwsXG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gIHBhZGRpbmdCb3R0b206IHRoZW1lLnNwYWNpbmcudHdvWFMsXG59KSlcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRNZXRyaWNEZWx0YVRleHRQcm9wcyB7XG4gIG1ldHJpY0NvbG9yOiBNZXRyaWNQcm90by5NZXRyaWNDb2xvclxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWV0cmljRGVsdGFUZXh0ID0gc3R5bGVkLmRpdjxTdHlsZWRNZXRyaWNEZWx0YVRleHRQcm9wcz4oXG4gICh7IHRoZW1lLCBtZXRyaWNDb2xvciB9KSA9PiAoe1xuICAgIC8vIFVzZXMgdGV4dCBjb2xvcnNcbiAgICBjb2xvcjogZ2V0TWV0cmljVGV4dENvbG9yKHRoZW1lLCBtZXRyaWNDb2xvciksXG4gICAgLy8gVXNlcyBzYW1lIGNvbG9yIGFzIHNoYWRlZCBiZyBvZiBhcmVhIGNoYXJ0IChiZyBjb2xvcilcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGdldE1ldHJpY0JhY2tncm91bmRDb2xvcih0aGVtZSwgbWV0cmljQ29sb3IpLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5mdWxsLFxuICAgIC8vIFVzaW5nIG9ubHkgdHdvWFMgKDRweCkgb24gdGhlIGxlZnQgc2lkZSBiZWNhdXNlIHRoZSBhcnJvdyBpY29uIGhhcyBhbiBhZGRpdGlvbmFsXG4gICAgLy8gMnB4IHBhZGRpbmcuIE5vdGUgdGhhdCB0aGlzIHNob3VsZCBiZSBhZGp1c3RlZCBpbiBjYXNlIHdlIGNoYW5nZSB0aGUgYXJyb3cgaWNvblxuICAgIC8vIG9yIGRvbid0IHNob3cgaXQgKHJpZ2h0IG5vdyBpdCdzIGFsd2F5cyBzaG93bikuXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcueHN9ICR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcudHdvWFN9YCxcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gIH0pXG4pXG4iXX0= */"), StyledMetricContent = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1i5pmia5"
} : {
  target: "e1i5pmia5",
  label: "StyledMetricContent"
})(({
  theme: n,
  showBorder: t
}) => ({
  ...t && {
    padding: `calc(${n.spacing.lg} - ${n.sizes.borderWidth})`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9NZXRyaWMvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMENtQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvTWV0cmljL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmltcG9ydCB7IE1ldHJpYyBhcyBNZXRyaWNQcm90byB9IGZyb20gXCJAc3RyZWFtbGl0L3Byb3RvYnVmXCJcblxuaW1wb3J0IHsgU3R5bGVkV2lkZ2V0TGFiZWwgfSBmcm9tIFwifmxpYi9jb21wb25lbnRzL3dpZGdldHMvQmFzZVdpZGdldC9zdHlsZWQtY29tcG9uZW50c1wiXG5pbXBvcnQge1xuICBnZXRNZXRyaWNCYWNrZ3JvdW5kQ29sb3IsXG4gIGdldE1ldHJpY1RleHRDb2xvcixcbn0gZnJvbSBcIn5saWIvdGhlbWUvZ2V0Q29sb3JzXCJcbmltcG9ydCB7IExhYmVsVmlzaWJpbGl0eU9wdGlvbnMgfSBmcm9tIFwifmxpYi91dGlsL3V0aWxzXCJcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRNZXRyaWNDb250YWluZXJQcm9wcyB7XG4gIHNob3dCb3JkZXI6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1ldHJpY0NvbnRhaW5lciA9IHN0eWxlZC5kaXY8U3R5bGVkTWV0cmljQ29udGFpbmVyUHJvcHM+KFxuICAoeyB0aGVtZSwgc2hvd0JvcmRlciB9KSA9PiAoe1xuICAgIGhlaWdodDogXCIxMDAlXCIsXG4gICAgLi4uKHNob3dCb3JkZXIgJiYge1xuICAgICAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0pLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWV0cmljQ29udGVudCA9IHN0eWxlZC5kaXY8eyBzaG93Qm9yZGVyOiBib29sZWFuIH0+KFxuICAoeyB0aGVtZSwgc2hvd0JvcmRlciB9KSA9PiAoe1xuICAgIC4uLihzaG93Qm9yZGVyICYmIHtcbiAgICAgIHBhZGRpbmc6IGBjYWxjKCR7dGhlbWUuc3BhY2luZy5sZ30gLSAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSlgLFxuICAgIH0pLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWV0cmljQ2hhcnQgPSBzdHlsZWQuZGl2PHsgc2hvd0JvcmRlcjogYm9vbGVhbiB9PihcbiAgKHsgdGhlbWUsIHNob3dCb3JkZXIgfSkgPT4gKHtcbiAgICBtYXJnaW5Ub3A6IHNob3dCb3JkZXIgPyB1bmRlZmluZWQgOiB0aGVtZS5zcGFjaW5nLmxnLFxuICAgIG1hcmdpbkJvdHRvbTogc2hvd0JvcmRlciA/IHRoZW1lLnNwYWNpbmcudHdvWEwgOiB1bmRlZmluZWQsXG4gIH0pXG4pXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkTWV0cmljTGFiZWxUZXh0UHJvcHMge1xuICB2aXNpYmlsaXR5PzogTGFiZWxWaXNpYmlsaXR5T3B0aW9uc1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVHJ1bmNhdGVUZXh0ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBvdmVyZmxvd1dyYXA6IFwibm9ybWFsXCIsXG4gIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICB3aWR0aDogXCIxMDAlXCIsXG4gIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuYm9keUZvbnQsXG4gIGxpbmVIZWlnaHQ6IFwibm9ybWFsXCIsXG4gIHZlcnRpY2FsQWxpZ246IFwibWlkZGxlXCIsXG5cbiAgLy8gU3R5bGVzIHRvIHRydW5jYXRlIHRoZSB0ZXh0IGluc2lkZSB0aGUgU3R5bGVkU3RyZWFtbGl0TWFya2Rvd24gZGl2LlxuICBcIiYgPiBkaXZcIjoge1xuICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuXG4gICAgXCImID4gcFwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1ldHJpY0xhYmVsVGV4dCA9IHN0eWxlZChcbiAgU3R5bGVkV2lkZ2V0TGFiZWxcbik8U3R5bGVkTWV0cmljTGFiZWxUZXh0UHJvcHM+KCh7IHZpc2liaWxpdHkgfSkgPT4gKHtcbiAgbWFyZ2luQm90dG9tOiAwLFxuICBkaXNwbGF5OiB2aXNpYmlsaXR5ID09PSBMYWJlbFZpc2liaWxpdHlPcHRpb25zLkNvbGxhcHNlZCA/IFwibm9uZVwiIDogXCJncmlkXCIsXG4gIGdyaWRUZW1wbGF0ZUNvbHVtbnM6XG4gICAgdmlzaWJpbGl0eSA9PT0gTGFiZWxWaXNpYmlsaXR5T3B0aW9ucy5Db2xsYXBzZWQgPyBcImluaXRpYWxcIiA6IFwiYXV0byAxZnJcIixcbiAgdmlzaWJpbGl0eTpcbiAgICB2aXNpYmlsaXR5ID09PSBMYWJlbFZpc2liaWxpdHlPcHRpb25zLkhpZGRlbiA/IFwiaGlkZGVuXCIgOiBcInZpc2libGVcIixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWV0cmljVmFsdWVUZXh0ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnRocmVlWEwsXG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gIHBhZGRpbmdCb3R0b206IHRoZW1lLnNwYWNpbmcudHdvWFMsXG59KSlcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRNZXRyaWNEZWx0YVRleHRQcm9wcyB7XG4gIG1ldHJpY0NvbG9yOiBNZXRyaWNQcm90by5NZXRyaWNDb2xvclxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWV0cmljRGVsdGFUZXh0ID0gc3R5bGVkLmRpdjxTdHlsZWRNZXRyaWNEZWx0YVRleHRQcm9wcz4oXG4gICh7IHRoZW1lLCBtZXRyaWNDb2xvciB9KSA9PiAoe1xuICAgIC8vIFVzZXMgdGV4dCBjb2xvcnNcbiAgICBjb2xvcjogZ2V0TWV0cmljVGV4dENvbG9yKHRoZW1lLCBtZXRyaWNDb2xvciksXG4gICAgLy8gVXNlcyBzYW1lIGNvbG9yIGFzIHNoYWRlZCBiZyBvZiBhcmVhIGNoYXJ0IChiZyBjb2xvcilcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGdldE1ldHJpY0JhY2tncm91bmRDb2xvcih0aGVtZSwgbWV0cmljQ29sb3IpLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5mdWxsLFxuICAgIC8vIFVzaW5nIG9ubHkgdHdvWFMgKDRweCkgb24gdGhlIGxlZnQgc2lkZSBiZWNhdXNlIHRoZSBhcnJvdyBpY29uIGhhcyBhbiBhZGRpdGlvbmFsXG4gICAgLy8gMnB4IHBhZGRpbmcuIE5vdGUgdGhhdCB0aGlzIHNob3VsZCBiZSBhZGp1c3RlZCBpbiBjYXNlIHdlIGNoYW5nZSB0aGUgYXJyb3cgaWNvblxuICAgIC8vIG9yIGRvbid0IHNob3cgaXQgKHJpZ2h0IG5vdyBpdCdzIGFsd2F5cyBzaG93bikuXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcueHN9ICR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcudHdvWFN9YCxcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gIH0pXG4pXG4iXX0= */"), StyledMetricChart = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1i5pmia4"
} : {
  target: "e1i5pmia4",
  label: "StyledMetricChart"
})(({
  theme: n,
  showBorder: t
}) => ({
  marginTop: t ? void 0 : n.spacing.lg,
  marginBottom: t ? n.spacing.twoXL : void 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTruncateText = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1i5pmia3"
} : {
  target: "e1i5pmia3",
  label: "StyledTruncateText"
})(({
  theme: n
}) => ({
  overflowWrap: "normal",
  textOverflow: "ellipsis",
  width: "100%",
  overflow: "hidden",
  whiteSpace: "nowrap",
  fontFamily: n.genericFonts.bodyFont,
  lineHeight: "normal",
  verticalAlign: "middle",
  // Styles to truncate the text inside the StyledStreamlitMarkdown div.
  "& > div": {
    overflow: "hidden",
    "& > p": {
      textOverflow: "ellipsis",
      overflow: "hidden"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMetricLabelText = /* @__PURE__ */ createStyled$1(StyledWidgetLabel, process.env.NODE_ENV === "production" ? {
  target: "e1i5pmia2"
} : {
  target: "e1i5pmia2",
  label: "StyledMetricLabelText"
})(({
  visibility: n
}) => ({
  marginBottom: 0,
  display: n === LabelVisibilityOptions.Collapsed ? "none" : "grid",
  gridTemplateColumns: n === LabelVisibilityOptions.Collapsed ? "initial" : "auto 1fr",
  visibility: n === LabelVisibilityOptions.Hidden ? "hidden" : "visible"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9NZXRyaWMvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0ZxQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvTWV0cmljL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmltcG9ydCB7IE1ldHJpYyBhcyBNZXRyaWNQcm90byB9IGZyb20gXCJAc3RyZWFtbGl0L3Byb3RvYnVmXCJcblxuaW1wb3J0IHsgU3R5bGVkV2lkZ2V0TGFiZWwgfSBmcm9tIFwifmxpYi9jb21wb25lbnRzL3dpZGdldHMvQmFzZVdpZGdldC9zdHlsZWQtY29tcG9uZW50c1wiXG5pbXBvcnQge1xuICBnZXRNZXRyaWNCYWNrZ3JvdW5kQ29sb3IsXG4gIGdldE1ldHJpY1RleHRDb2xvcixcbn0gZnJvbSBcIn5saWIvdGhlbWUvZ2V0Q29sb3JzXCJcbmltcG9ydCB7IExhYmVsVmlzaWJpbGl0eU9wdGlvbnMgfSBmcm9tIFwifmxpYi91dGlsL3V0aWxzXCJcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRNZXRyaWNDb250YWluZXJQcm9wcyB7XG4gIHNob3dCb3JkZXI6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1ldHJpY0NvbnRhaW5lciA9IHN0eWxlZC5kaXY8U3R5bGVkTWV0cmljQ29udGFpbmVyUHJvcHM+KFxuICAoeyB0aGVtZSwgc2hvd0JvcmRlciB9KSA9PiAoe1xuICAgIGhlaWdodDogXCIxMDAlXCIsXG4gICAgLi4uKHNob3dCb3JkZXIgJiYge1xuICAgICAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0pLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWV0cmljQ29udGVudCA9IHN0eWxlZC5kaXY8eyBzaG93Qm9yZGVyOiBib29sZWFuIH0+KFxuICAoeyB0aGVtZSwgc2hvd0JvcmRlciB9KSA9PiAoe1xuICAgIC4uLihzaG93Qm9yZGVyICYmIHtcbiAgICAgIHBhZGRpbmc6IGBjYWxjKCR7dGhlbWUuc3BhY2luZy5sZ30gLSAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSlgLFxuICAgIH0pLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWV0cmljQ2hhcnQgPSBzdHlsZWQuZGl2PHsgc2hvd0JvcmRlcjogYm9vbGVhbiB9PihcbiAgKHsgdGhlbWUsIHNob3dCb3JkZXIgfSkgPT4gKHtcbiAgICBtYXJnaW5Ub3A6IHNob3dCb3JkZXIgPyB1bmRlZmluZWQgOiB0aGVtZS5zcGFjaW5nLmxnLFxuICAgIG1hcmdpbkJvdHRvbTogc2hvd0JvcmRlciA/IHRoZW1lLnNwYWNpbmcudHdvWEwgOiB1bmRlZmluZWQsXG4gIH0pXG4pXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkTWV0cmljTGFiZWxUZXh0UHJvcHMge1xuICB2aXNpYmlsaXR5PzogTGFiZWxWaXNpYmlsaXR5T3B0aW9uc1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVHJ1bmNhdGVUZXh0ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBvdmVyZmxvd1dyYXA6IFwibm9ybWFsXCIsXG4gIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICB3aWR0aDogXCIxMDAlXCIsXG4gIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuYm9keUZvbnQsXG4gIGxpbmVIZWlnaHQ6IFwibm9ybWFsXCIsXG4gIHZlcnRpY2FsQWxpZ246IFwibWlkZGxlXCIsXG5cbiAgLy8gU3R5bGVzIHRvIHRydW5jYXRlIHRoZSB0ZXh0IGluc2lkZSB0aGUgU3R5bGVkU3RyZWFtbGl0TWFya2Rvd24gZGl2LlxuICBcIiYgPiBkaXZcIjoge1xuICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuXG4gICAgXCImID4gcFwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1ldHJpY0xhYmVsVGV4dCA9IHN0eWxlZChcbiAgU3R5bGVkV2lkZ2V0TGFiZWxcbik8U3R5bGVkTWV0cmljTGFiZWxUZXh0UHJvcHM+KCh7IHZpc2liaWxpdHkgfSkgPT4gKHtcbiAgbWFyZ2luQm90dG9tOiAwLFxuICBkaXNwbGF5OiB2aXNpYmlsaXR5ID09PSBMYWJlbFZpc2liaWxpdHlPcHRpb25zLkNvbGxhcHNlZCA/IFwibm9uZVwiIDogXCJncmlkXCIsXG4gIGdyaWRUZW1wbGF0ZUNvbHVtbnM6XG4gICAgdmlzaWJpbGl0eSA9PT0gTGFiZWxWaXNpYmlsaXR5T3B0aW9ucy5Db2xsYXBzZWQgPyBcImluaXRpYWxcIiA6IFwiYXV0byAxZnJcIixcbiAgdmlzaWJpbGl0eTpcbiAgICB2aXNpYmlsaXR5ID09PSBMYWJlbFZpc2liaWxpdHlPcHRpb25zLkhpZGRlbiA/IFwiaGlkZGVuXCIgOiBcInZpc2libGVcIixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWV0cmljVmFsdWVUZXh0ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnRocmVlWEwsXG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gIHBhZGRpbmdCb3R0b206IHRoZW1lLnNwYWNpbmcudHdvWFMsXG59KSlcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRNZXRyaWNEZWx0YVRleHRQcm9wcyB7XG4gIG1ldHJpY0NvbG9yOiBNZXRyaWNQcm90by5NZXRyaWNDb2xvclxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWV0cmljRGVsdGFUZXh0ID0gc3R5bGVkLmRpdjxTdHlsZWRNZXRyaWNEZWx0YVRleHRQcm9wcz4oXG4gICh7IHRoZW1lLCBtZXRyaWNDb2xvciB9KSA9PiAoe1xuICAgIC8vIFVzZXMgdGV4dCBjb2xvcnNcbiAgICBjb2xvcjogZ2V0TWV0cmljVGV4dENvbG9yKHRoZW1lLCBtZXRyaWNDb2xvciksXG4gICAgLy8gVXNlcyBzYW1lIGNvbG9yIGFzIHNoYWRlZCBiZyBvZiBhcmVhIGNoYXJ0IChiZyBjb2xvcilcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGdldE1ldHJpY0JhY2tncm91bmRDb2xvcih0aGVtZSwgbWV0cmljQ29sb3IpLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5mdWxsLFxuICAgIC8vIFVzaW5nIG9ubHkgdHdvWFMgKDRweCkgb24gdGhlIGxlZnQgc2lkZSBiZWNhdXNlIHRoZSBhcnJvdyBpY29uIGhhcyBhbiBhZGRpdGlvbmFsXG4gICAgLy8gMnB4IHBhZGRpbmcuIE5vdGUgdGhhdCB0aGlzIHNob3VsZCBiZSBhZGp1c3RlZCBpbiBjYXNlIHdlIGNoYW5nZSB0aGUgYXJyb3cgaWNvblxuICAgIC8vIG9yIGRvbid0IHNob3cgaXQgKHJpZ2h0IG5vdyBpdCdzIGFsd2F5cyBzaG93bikuXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcueHN9ICR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcudHdvWFN9YCxcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gIH0pXG4pXG4iXX0= */"), StyledMetricValueText = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1i5pmia1"
} : {
  target: "e1i5pmia1",
  label: "StyledMetricValueText"
})(({
  theme: n
}) => ({
  fontSize: n.fontSizes.threeXL,
  color: n.colors.bodyText,
  paddingBottom: n.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMetricDeltaText = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1i5pmia0"
} : {
  target: "e1i5pmia0",
  label: "StyledMetricDeltaText"
})(({
  theme: n,
  metricColor: t
}) => ({
  // Uses text colors
  color: getMetricTextColor(n, t),
  // Uses same color as shaded bg of area chart (bg color)
  backgroundColor: getMetricBackgroundColor(n, t),
  fontSize: n.fontSizes.sm,
  display: "inline-flex",
  flexDirection: "row",
  alignItems: "center",
  fontWeight: n.fontWeights.normal,
  borderRadius: n.radii.full,
  // Using only twoXS (4px) on the left side because the arrow icon has an additional
  // 2px padding. Note that this should be adjusted in case we change the arrow icon
  // or don't show it (right now it's always shown).
  padding: `${n.spacing.threeXS} ${n.spacing.xs} ${n.spacing.threeXS} ${n.spacing.twoXS}`,
  maxWidth: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function getMetricChartSpec(n, t, g, d, k) {
  const AA = `metric_chart_${Math.random().toString(36).slice(2, 10)}`, gA = n.length === 1 ? [n[0], n[0]] : n, IA = {
    $schema: "https://vega.github.io/schema/vega-lite/v5.json",
    width: Math.round(g),
    height: Math.round(convertRemToPx("3.5rem")),
    data: {
      values: gA.map((CA, BA) => ({
        x: BA,
        y: CA
      }))
    },
    layer: [{
      // The actual line/bar/area chart layer:
      name: `${AA}_mark`,
      mark: {
        type: "line",
        ...t === Metric$2.ChartType.LINE && {
          type: "line",
          strokeCap: "round",
          strokeWidth: 2
        },
        ...t === Metric$2.ChartType.BAR && {
          type: "bar",
          cornerRadius: parseFloat(d.radii.full)
        },
        ...t === Metric$2.ChartType.AREA && {
          type: "area",
          // Controls the color of the shaded area of area chart (bg color)
          color: getMetricBackgroundColor(d, k),
          opacity: 1,
          line: {
            // Controls the color of the line in area chart (main color)
            color: getMetricColor(d, k),
            opacity: 1,
            strokeWidth: 2,
            strokeCap: "round"
          }
        }
      },
      encoding: {
        x: {
          field: "x",
          type: "quantitative",
          axis: null,
          scale: {
            zero: !1,
            nice: !1
          }
        },
        y: {
          field: "y",
          type: "quantitative",
          axis: null,
          scale: {
            zero: !1,
            nice: !1
          }
        }
      }
    }, {
      // This layer is needed for detecting the nearest point on the
      // chart that gets selected when hovering over the chart:
      name: `${AA}_points`,
      mark: {
        type: "point",
        opacity: 0
      },
      encoding: {
        x: {
          field: "x",
          type: "quantitative",
          axis: null,
          scale: {
            zero: !1,
            nice: !1
          }
        },
        y: {
          field: "y",
          type: "quantitative",
          axis: null,
          scale: {
            zero: !1,
            nice: !1
          }
        }
      },
      params: [{
        name: `${AA}_hover_selection`,
        select: {
          type: "point",
          encodings: ["x"],
          nearest: !0,
          on: "mousemove",
          clear: "mouseout"
        }
      }]
    }, {
      // This is used to render the point on the chart when hovering:
      name: `${AA}_highlighted_points`,
      transform: [{
        filter: {
          param: `${AA}_hover_selection`,
          empty: !1
        }
      }, {
        window: [{
          op: "row_number",
          as: "hover_selection_rank"
        }]
      }, {
        filter: "datum.hover_selection_rank === 1"
      }],
      mark: {
        type: "point",
        filled: !0,
        size: 65,
        tooltip: !0
      },
      encoding: {
        x: {
          field: "x",
          type: "quantitative",
          axis: null,
          scale: {
            zero: !1,
            nice: !1
          }
        },
        y: {
          field: "y",
          type: "quantitative",
          axis: null,
          scale: {
            zero: !1,
            nice: !1
          }
        }
      }
    }],
    config: {
      view: {
        stroke: null
      },
      // We need negative padding here to allow the chart to go from
      // left to right. For whatever reason, there is a ~3px padding
      // otherwise.
      padding: {
        left: -3,
        right: -3,
        top: 2,
        bottom: 2
      },
      ...t === Metric$2.ChartType.BAR && {
        // Bar chart doesn't need the negative padding:
        padding: {
          left: 0,
          right: 0,
          top: 2,
          bottom: 2
        }
      },
      mark: {
        tooltip: {
          content: "encoding"
        },
        color: getMetricColor(d, k)
      }
    }
  };
  return IA.config = applyStreamlitTheme(IA.config, d), IA;
}
function Metric({
  element: n
}) {
  const t = useEmotionTheme(), g = useRef(null), {
    width: d,
    elementRef: k
  } = useCalculatedDimensions(), {
    MetricDirection: H
  } = Metric$2, {
    body: AA,
    label: gA,
    delta: IA,
    direction: CA,
    color: BA,
    labelVisibility: eA,
    help: iA,
    showBorder: QA,
    chartData: tA,
    chartType: oA
  } = n;
  let EA = null;
  switch (CA) {
    case H.DOWN:
      EA = ArrowDownward;
      break;
    case H.UP:
      EA = ArrowUpward;
      break;
  }
  const aA = "0 threeXS 0 0", nA = IA !== "";
  return useEffect(() => {
    if (tA && tA.length > 0 && g.current && // Having a chart width <= 0 causes issues with vega-embed:
    d > 0) {
      const lA = getMetricChartSpec(tA, oA, d, t, BA);
      embed(g.current, lA, {
        actions: !1,
        renderer: "svg",
        ast: !0,
        expr: expression$1,
        tooltip: {
          theme: "custom",
          formatTooltip: (cA) => `${cA.y}`
        }
      });
    }
  }, [tA, BA, t, d, oA, g]), /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMetricContainer, { className: "stMetric", "data-testid": "stMetric", showBorder: QA, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMetricContent, { showBorder: QA, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMetricLabelText, { "data-testid": "stMetricLabel", visibility: labelVisibilityProtoValueToEnum(eA?.value), children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTruncateText, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: gA, allowHTML: !1, isLabel: !0 }) }),
        iA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledWidgetLabelHelpInline, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { content: iA, placement: Placement.TOP_RIGHT }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMetricValueText, { "data-testid": "stMetricValue", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledTruncateText, { children: [
        " ",
        AA,
        " "
      ] }) }),
      nA && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMetricDeltaText, { "data-testid": "stMetricDelta", metricColor: BA, children: [
        EA && /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { testid: EA === ArrowUpward ? "stMetricDeltaIcon-Up" : "stMetricDeltaIcon-Down", content: EA, size: "md", margin: aA }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledTruncateText, { children: [
          " ",
          IA,
          " "
        ] })
      ] })
    ] }),
    tA && tA.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: k, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Global, { styles: StyledVegaLiteChartTooltips }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMetricChart, { ref: g, "data-testid": "stMetricChart", showBorder: QA })
    ] })
  ] });
}
const Metric$1 = memo$1(Metric), StyledText = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "exotz4b0"
} : {
  target: "exotz4b0",
  label: "StyledText"
})(({
  theme: n
}) => ({
  fontFamily: n.genericFonts.bodyFont,
  color: n.colors.bodyText,
  whiteSpace: "pre-line",
  whiteSpaceCollapse: "preserve",
  wordBreak: "break-word"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9UZXh0RWxlbWVudC9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQjBCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9UZXh0RWxlbWVudC9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGV4dCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZm9udEZhbWlseTogdGhlbWUuZ2VuZXJpY0ZvbnRzLmJvZHlGb250LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICB3aGl0ZVNwYWNlOiBcInByZS1saW5lXCIsXG4gIHdoaXRlU3BhY2VDb2xsYXBzZTogXCJwcmVzZXJ2ZVwiLFxuICB3b3JkQnJlYWs6IFwiYnJlYWstd29yZFwiLFxufSkpXG4iXX0= */");
function TextElement({
  element: n
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledLabelHelpWrapper, { className: "stText", "data-testid": "stText", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledText, { children: n.body }),
    n.help && /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: n.help })
  ] });
}
const TextElement$1 = memo$1(TextElement);
function makeMarkdownHeading(n, t) {
  switch (n.toLowerCase()) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- TODO: Fix this
    case Tags.H1:
      return `# ${t}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- TODO: Fix this
    case Tags.H2:
      return `## ${t}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- TODO: Fix this
    case Tags.H3:
      return `### ${t}`;
    default:
      throw new Error(`Unrecognized tag for header: ${n}`);
  }
}
const OVERRIDE_COMPONENTS = {
  p: Fragment,
  h1: Fragment,
  h2: Fragment,
  h3: Fragment,
  h4: Fragment,
  h5: Fragment,
  h6: Fragment
};
function Heading(n) {
  const {
    element: t
  } = n, {
    tag: g,
    anchor: d,
    body: k,
    help: H,
    hideAnchor: AA,
    divider: gA
  } = t, IA = useContext(IsDialogContext), [CA, ...BA] = k.split(`
`);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "stHeading", "data-testid": "stHeading", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledStreamlitMarkdown, { isCaption: !1, isInDialog: IA, "data-testid": "stMarkdownContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(HeadingWithActionElements, { anchor: d, help: H, hideAnchor: AA, tag: g, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        RenderedMarkdown,
        {
          allowHTML: !1,
          source: makeMarkdownHeading(g, CA),
          overrideComponents: OVERRIDE_COMPONENTS
        }
      ) }),
      BA.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(RenderedMarkdown, { source: BA.join(`
`), allowHTML: !1 })
    ] }),
    gA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderDivider, { "data-testid": "stHeadingDivider", rainbow: gA.includes("linear"), color: gA })
  ] });
}
const StyledCheckbox$1 = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "edwcd611"
} : {
  target: "edwcd611",
  label: "StyledCheckbox"
})(({
  theme: n
}) => ({
  display: "flex",
  alignItems: "center",
  minHeight: n.sizes.smallElementHeight
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledContent = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "edwcd610"
} : {
  target: "edwcd610",
  label: "StyledContent"
})(({
  visibility: n
}) => ({
  display: n === LabelVisibilityOptions.Collapsed ? "none" : "flex",
  visibility: n === LabelVisibilityOptions.Hidden ? "hidden" : "visible",
  verticalAlign: "middle",
  flexDirection: "row",
  alignItems: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function translateGapWidth(n, t) {
  let g = t.spacing.lg;
  return n === streamlit.GapSize.MEDIUM ? g = t.spacing.threeXL : n === streamlit.GapSize.LARGE ? g = t.spacing.fourXL : n === streamlit.GapSize.NONE && (g = t.spacing.none), g;
}
const GLOBAL_ELEMENTS = ["balloons", "snow"], StyledElementContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn3"
} : {
  target: "e1f1d6gn3",
  label: "StyledElementContainer"
})(({
  theme: n,
  isStale: t,
  width: g,
  height: d,
  elementType: k,
  overflow: H,
  flex: AA
}) => ({
  width: g,
  height: d,
  maxWidth: "100%",
  // Important so that individual elements don't take up too much space
  // in horizontal layouts. Particularly when an element uses the full screen wrapper.
  // Some components support zero width (e.g. iframe).
  minWidth: g === "0px" ? 0 : "1rem",
  // Allows to have absolutely-positioned nodes inside app elements, like
  // floating buttons.
  position: "relative",
  overflow: H,
  flex: AA,
  "@media print": {
    overflow: "visible"
  },
  ":has(> .stCacheSpinner)": {
    height: n.spacing.none,
    overflow: "visible",
    visibility: "visible",
    marginBottom: `-${n.spacing.lg}`,
    zIndex: n.zIndices.cacheSpinner
  },
  ":has(> .stPageLink)": {
    marginTop: `-${n.spacing.xs}`,
    marginBottom: `-${n.spacing.xs}`
  },
  ...t && k !== "skeleton" && STALE_STYLES,
  ...k === "empty" ? {
    // Use display: none for empty elements to avoid the flexbox gap.
    display: "none"
  } : {},
  ...GLOBAL_ELEMENTS.includes(k) ? {
    // Global elements are rendered in their delta position, but they
    // are not part of the flexbox layout. We apply a negative margin
    // to remove the flexbox gap. display: none does not work for these,
    // since they needs to be visible.
    marginBottom: `-${n.spacing.lg}`
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledColumn = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn2"
} : {
  target: "e1f1d6gn2",
  label: "StyledColumn"
})(({
  theme: n,
  weight: t,
  gap: g,
  showBorder: d,
  verticalAlignment: k
}) => {
  const {
    VerticalAlignment: H
  } = Block$2.Column, AA = t * 100, gA = translateGapWidth(g, n), IA = gA === n.spacing.none ? `${AA}%` : `calc(${AA}% - ${gA})`;
  return {
    // Calculate width based on percentage, but fill all available space,
    // e.g. if it overflows to next row.
    width: IA,
    flex: `1 1 ${IA}`,
    [`@media (max-width: ${n.breakpoints.columns})`]: {
      minWidth: `calc(100% - ${n.spacing.twoXL})`
    },
    ...k === H.BOTTOM && {
      marginTop: "auto",
      // Add margin to the first checkbox/toggle within the column to align it
      // better with other input widgets.
      [`& ${StyledElementContainer}:last-of-type > ${StyledCheckbox$1}`]: {
        marginBottom: n.spacing.sm
      }
    },
    ...k === H.TOP && {
      // Add margin to the first checkbox/toggle within the column to align it
      // better with other input widgets.
      [`& ${StyledElementContainer}:first-of-type > ${StyledCheckbox$1}`]: {
        marginTop: n.spacing.sm
      }
    },
    ...k === H.CENTER && {
      marginTop: "auto",
      marginBottom: "auto"
    },
    ...d && {
      border: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
      borderRadius: n.radii.default,
      padding: `calc(${n.spacing.lg} - ${n.sizes.borderWidth})`
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9jb3JlL0Jsb2NrL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTZHNEIiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2NvcmUvQmxvY2svc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNSlcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IFJlYWN0LCB7IENTU1Byb3BlcnRpZXMgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5pbXBvcnQgeyBCbG9jayBhcyBCbG9ja1Byb3RvLCBzdHJlYW1saXQgfSBmcm9tIFwiQHN0cmVhbWxpdC9wcm90b2J1ZlwiXG5cbmltcG9ydCB7IFN0eWxlZENoZWNrYm94IH0gZnJvbSBcIn5saWIvY29tcG9uZW50cy93aWRnZXRzL0NoZWNrYm94L3N0eWxlZC1jb21wb25lbnRzXCJcbmltcG9ydCB7IEVtb3Rpb25UaGVtZSwgU1RBTEVfU1RZTEVTIH0gZnJvbSBcIn5saWIvdGhlbWVcIlxuaW1wb3J0IHsgYXNzZXJ0TmV2ZXIgfSBmcm9tIFwifmxpYi91dGlsL2Fzc2VydE5ldmVyXCJcblxuZnVuY3Rpb24gdHJhbnNsYXRlR2FwV2lkdGgoXG4gIGdhcDogc3RyZWFtbGl0LkdhcFNpemUgfCB1bmRlZmluZWQsXG4gIHRoZW1lOiBFbW90aW9uVGhlbWVcbik6IHN0cmluZyB7XG4gIGxldCBnYXBXaWR0aCA9IHRoZW1lLnNwYWNpbmcubGdcbiAgaWYgKGdhcCA9PT0gc3RyZWFtbGl0LkdhcFNpemUuTUVESVVNKSB7XG4gICAgZ2FwV2lkdGggPSB0aGVtZS5zcGFjaW5nLnRocmVlWExcbiAgfSBlbHNlIGlmIChnYXAgPT09IHN0cmVhbWxpdC5HYXBTaXplLkxBUkdFKSB7XG4gICAgZ2FwV2lkdGggPSB0aGVtZS5zcGFjaW5nLmZvdXJYTFxuICB9IGVsc2UgaWYgKGdhcCA9PT0gc3RyZWFtbGl0LkdhcFNpemUuTk9ORSkge1xuICAgIGdhcFdpZHRoID0gdGhlbWUuc3BhY2luZy5ub25lXG4gIH1cbiAgcmV0dXJuIGdhcFdpZHRoXG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkRWxlbWVudENvbnRhaW5lclByb3BzIHtcbiAgaXNTdGFsZTogYm9vbGVhblxuICB3aWR0aDogUmVhY3QuQ1NTUHJvcGVydGllc1tcIndpZHRoXCJdXG4gIGhlaWdodDogUmVhY3QuQ1NTUHJvcGVydGllc1tcImhlaWdodFwiXVxuICBlbGVtZW50VHlwZTogc3RyaW5nXG4gIG92ZXJmbG93OiBSZWFjdC5DU1NQcm9wZXJ0aWVzW1wib3ZlcmZsb3dcIl1cbiAgZmxleD86IFJlYWN0LkNTU1Byb3BlcnRpZXNbXCJmbGV4XCJdXG59XG5cbmNvbnN0IEdMT0JBTF9FTEVNRU5UUyA9IFtcImJhbGxvb25zXCIsIFwic25vd1wiXVxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnRDb250YWluZXIgPSBzdHlsZWQuZGl2PFN0eWxlZEVsZW1lbnRDb250YWluZXJQcm9wcz4oXG4gICh7IHRoZW1lLCBpc1N0YWxlLCB3aWR0aCwgaGVpZ2h0LCBlbGVtZW50VHlwZSwgb3ZlcmZsb3csIGZsZXggfSkgPT4gKHtcbiAgICB3aWR0aCxcbiAgICBoZWlnaHQsXG4gICAgbWF4V2lkdGg6IFwiMTAwJVwiLFxuICAgIC8vIEltcG9ydGFudCBzbyB0aGF0IGluZGl2aWR1YWwgZWxlbWVudHMgZG9uJ3QgdGFrZSB1cCB0b28gbXVjaCBzcGFjZVxuICAgIC8vIGluIGhvcml6b250YWwgbGF5b3V0cy4gUGFydGljdWxhcmx5IHdoZW4gYW4gZWxlbWVudCB1c2VzIHRoZSBmdWxsIHNjcmVlbiB3cmFwcGVyLlxuICAgIC8vIFNvbWUgY29tcG9uZW50cyBzdXBwb3J0IHplcm8gd2lkdGggKGUuZy4gaWZyYW1lKS5cbiAgICBtaW5XaWR0aDogd2lkdGggPT09IFwiMHB4XCIgPyAwIDogXCIxcmVtXCIsXG4gICAgLy8gQWxsb3dzIHRvIGhhdmUgYWJzb2x1dGVseS1wb3NpdGlvbmVkIG5vZGVzIGluc2lkZSBhcHAgZWxlbWVudHMsIGxpa2VcbiAgICAvLyBmbG9hdGluZyBidXR0b25zLlxuICAgIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gICAgb3ZlcmZsb3csXG4gICAgZmxleCxcblxuICAgIFwiQG1lZGlhIHByaW50XCI6IHtcbiAgICAgIG92ZXJmbG93OiBcInZpc2libGVcIixcbiAgICB9LFxuXG4gICAgXCI6aGFzKD4gLnN0Q2FjaGVTcGlubmVyKVwiOiB7XG4gICAgICBoZWlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICAgIG92ZXJmbG93OiBcInZpc2libGVcIixcbiAgICAgIHZpc2liaWxpdHk6IFwidmlzaWJsZVwiLFxuICAgICAgbWFyZ2luQm90dG9tOiBgLSR7dGhlbWUuc3BhY2luZy5sZ31gLFxuICAgICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5jYWNoZVNwaW5uZXIsXG4gICAgfSxcblxuICAgIFwiOmhhcyg+IC5zdFBhZ2VMaW5rKVwiOiB7XG4gICAgICBtYXJnaW5Ub3A6IGAtJHt0aGVtZS5zcGFjaW5nLnhzfWAsXG4gICAgICBtYXJnaW5Cb3R0b206IGAtJHt0aGVtZS5zcGFjaW5nLnhzfWAsXG4gICAgfSxcblxuICAgIC4uLihpc1N0YWxlICYmIGVsZW1lbnRUeXBlICE9PSBcInNrZWxldG9uXCIgJiYgU1RBTEVfU1RZTEVTKSxcbiAgICAuLi4oZWxlbWVudFR5cGUgPT09IFwiZW1wdHlcIlxuICAgICAgPyB7XG4gICAgICAgICAgLy8gVXNlIGRpc3BsYXk6IG5vbmUgZm9yIGVtcHR5IGVsZW1lbnRzIHRvIGF2b2lkIHRoZSBmbGV4Ym94IGdhcC5cbiAgICAgICAgICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgICAgICAgfVxuICAgICAgOiB7fSksXG4gICAgLi4uKEdMT0JBTF9FTEVNRU5UUy5pbmNsdWRlcyhlbGVtZW50VHlwZSlcbiAgICAgID8ge1xuICAgICAgICAgIC8vIEdsb2JhbCBlbGVtZW50cyBhcmUgcmVuZGVyZWQgaW4gdGhlaXIgZGVsdGEgcG9zaXRpb24sIGJ1dCB0aGV5XG4gICAgICAgICAgLy8gYXJlIG5vdCBwYXJ0IG9mIHRoZSBmbGV4Ym94IGxheW91dC4gV2UgYXBwbHkgYSBuZWdhdGl2ZSBtYXJnaW5cbiAgICAgICAgICAvLyB0byByZW1vdmUgdGhlIGZsZXhib3ggZ2FwLiBkaXNwbGF5OiBub25lIGRvZXMgbm90IHdvcmsgZm9yIHRoZXNlLFxuICAgICAgICAgIC8vIHNpbmNlIHRoZXkgbmVlZHMgdG8gYmUgdmlzaWJsZS5cbiAgICAgICAgICBtYXJnaW5Cb3R0b206IGAtJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgICAgIH1cbiAgICAgIDoge30pLFxuICB9KVxuKVxuXG5pbnRlcmZhY2UgU3R5bGVkQ29sdW1uUHJvcHMge1xuICB3ZWlnaHQ6IG51bWJlclxuICBnYXA6IHN0cmVhbWxpdC5HYXBTaXplIHwgdW5kZWZpbmVkXG4gIHNob3dCb3JkZXI6IGJvb2xlYW5cbiAgdmVydGljYWxBbGlnbm1lbnQ/OiBCbG9ja1Byb3RvLkNvbHVtbi5WZXJ0aWNhbEFsaWdubWVudFxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQ29sdW1uID0gc3R5bGVkLmRpdjxTdHlsZWRDb2x1bW5Qcm9wcz4oXG4gICh7IHRoZW1lLCB3ZWlnaHQsIGdhcCwgc2hvd0JvcmRlciwgdmVydGljYWxBbGlnbm1lbnQgfSkgPT4ge1xuICAgIGNvbnN0IHsgVmVydGljYWxBbGlnbm1lbnQgfSA9IEJsb2NrUHJvdG8uQ29sdW1uXG4gICAgY29uc3QgcGVyY2VudGFnZSA9IHdlaWdodCAqIDEwMFxuICAgIGNvbnN0IGdhcFdpZHRoID0gdHJhbnNsYXRlR2FwV2lkdGgoZ2FwLCB0aGVtZSlcbiAgICBjb25zdCB3aWR0aCA9XG4gICAgICBnYXBXaWR0aCA9PT0gdGhlbWUuc3BhY2luZy5ub25lXG4gICAgICAgID8gYCR7cGVyY2VudGFnZX0lYFxuICAgICAgICA6IGBjYWxjKCR7cGVyY2VudGFnZX0lIC0gJHtnYXBXaWR0aH0pYFxuXG4gICAgcmV0dXJuIHtcbiAgICAgIC8vIENhbGN1bGF0ZSB3aWR0aCBiYXNlZCBvbiBwZXJjZW50YWdlLCBidXQgZmlsbCBhbGwgYXZhaWxhYmxlIHNwYWNlLFxuICAgICAgLy8gZS5nLiBpZiBpdCBvdmVyZmxvd3MgdG8gbmV4dCByb3cuXG4gICAgICB3aWR0aCxcbiAgICAgIGZsZXg6IGAxIDEgJHt3aWR0aH1gLFxuXG4gICAgICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLmNvbHVtbnN9KWBdOiB7XG4gICAgICAgIG1pbldpZHRoOiBgY2FsYygxMDAlIC0gJHt0aGVtZS5zcGFjaW5nLnR3b1hMfSlgLFxuICAgICAgfSxcbiAgICAgIC4uLih2ZXJ0aWNhbEFsaWdubWVudCA9PT0gVmVydGljYWxBbGlnbm1lbnQuQk9UVE9NICYmIHtcbiAgICAgICAgbWFyZ2luVG9wOiBcImF1dG9cIixcbiAgICAgICAgLy8gQWRkIG1hcmdpbiB0byB0aGUgZmlyc3QgY2hlY2tib3gvdG9nZ2xlIHdpdGhpbiB0aGUgY29sdW1uIHRvIGFsaWduIGl0XG4gICAgICAgIC8vIGJldHRlciB3aXRoIG90aGVyIGlucHV0IHdpZGdldHMuXG4gICAgICAgIFtgJiAke1N0eWxlZEVsZW1lbnRDb250YWluZXJ9Omxhc3Qtb2YtdHlwZSA+ICR7U3R5bGVkQ2hlY2tib3h9YF06IHtcbiAgICAgICAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgICAgIH0sXG4gICAgICB9KSxcbiAgICAgIC4uLih2ZXJ0aWNhbEFsaWdubWVudCA9PT0gVmVydGljYWxBbGlnbm1lbnQuVE9QICYmIHtcbiAgICAgICAgLy8gQWRkIG1hcmdpbiB0byB0aGUgZmlyc3QgY2hlY2tib3gvdG9nZ2xlIHdpdGhpbiB0aGUgY29sdW1uIHRvIGFsaWduIGl0XG4gICAgICAgIC8vIGJldHRlciB3aXRoIG90aGVyIGlucHV0IHdpZGdldHMuXG4gICAgICAgIFtgJiAke1N0eWxlZEVsZW1lbnRDb250YWluZXJ9OmZpcnN0LW9mLXR5cGUgPiAke1N0eWxlZENoZWNrYm94fWBdOiB7XG4gICAgICAgICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgICAgICB9LFxuICAgICAgfSksXG4gICAgICAuLi4odmVydGljYWxBbGlnbm1lbnQgPT09IFZlcnRpY2FsQWxpZ25tZW50LkNFTlRFUiAmJiB7XG4gICAgICAgIG1hcmdpblRvcDogXCJhdXRvXCIsXG4gICAgICAgIG1hcmdpbkJvdHRvbTogXCJhdXRvXCIsXG4gICAgICB9KSxcbiAgICAgIC4uLihzaG93Qm9yZGVyICYmIHtcbiAgICAgICAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgICAgICBwYWRkaW5nOiBgY2FsYygke3RoZW1lLnNwYWNpbmcubGd9IC0gJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0pYCxcbiAgICAgIH0pLFxuICAgIH1cbiAgfVxuKVxuXG5jb25zdCBnZXRBbGlnbkl0ZW1zID0gKFxuICBhbGlnbjogQmxvY2tQcm90by5GbGV4Q29udGFpbmVyLkFsaWduIHwgdW5kZWZpbmVkIHwgbnVsbFxuKTogQ1NTUHJvcGVydGllc1tcImFsaWduSXRlbXNcIl0gPT4ge1xuICBzd2l0Y2ggKGFsaWduKSB7XG4gICAgY2FzZSBCbG9ja1Byb3RvLkZsZXhDb250YWluZXIuQWxpZ24uQUxJR05fU1RBUlQ6XG4gICAgICByZXR1cm4gXCJzdGFydFwiXG4gICAgY2FzZSBCbG9ja1Byb3RvLkZsZXhDb250YWluZXIuQWxpZ24uQUxJR05fQ0VOVEVSOlxuICAgICAgcmV0dXJuIFwiY2VudGVyXCJcbiAgICBjYXNlIEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5BbGlnbi5BTElHTl9FTkQ6XG4gICAgICByZXR1cm4gXCJlbmRcIlxuICAgIGNhc2UgQmxvY2tQcm90by5GbGV4Q29udGFpbmVyLkFsaWduLlNUUkVUQ0g6XG4gICAgICByZXR1cm4gXCJzdHJldGNoXCJcbiAgICBjYXNlIEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5BbGlnbi5BTElHTl9VTkRFRklORUQ6XG4gICAgY2FzZSB1bmRlZmluZWQ6XG4gICAgY2FzZSBudWxsOlxuICAgICAgcmV0dXJuIFwic3RyZXRjaFwiXG4gICAgZGVmYXVsdDpcbiAgICAgIGFzc2VydE5ldmVyKGFsaWduKVxuICB9XG59XG5cbmNvbnN0IGdldEp1c3RpZnlDb250ZW50ID0gKFxuICBqdXN0aWZ5OiBCbG9ja1Byb3RvLkZsZXhDb250YWluZXIuSnVzdGlmeSB8IHVuZGVmaW5lZCB8IG51bGxcbik6IENTU1Byb3BlcnRpZXNbXCJqdXN0aWZ5Q29udGVudFwiXSA9PiB7XG4gIHN3aXRjaCAoanVzdGlmeSkge1xuICAgIGNhc2UgQmxvY2tQcm90by5GbGV4Q29udGFpbmVyLkp1c3RpZnkuSlVTVElGWV9TVEFSVDpcbiAgICAgIHJldHVybiBcInN0YXJ0XCJcbiAgICBjYXNlIEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5KdXN0aWZ5LkpVU1RJRllfQ0VOVEVSOlxuICAgICAgcmV0dXJuIFwiY2VudGVyXCJcbiAgICBjYXNlIEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5KdXN0aWZ5LkpVU1RJRllfRU5EOlxuICAgICAgcmV0dXJuIFwiZW5kXCJcbiAgICBjYXNlIEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5KdXN0aWZ5LlNQQUNFX0JFVFdFRU46XG4gICAgICByZXR1cm4gXCJzcGFjZS1iZXR3ZWVuXCJcbiAgICBjYXNlIEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5KdXN0aWZ5LkpVU1RJRllfVU5ERUZJTkVEOlxuICAgIGNhc2UgdW5kZWZpbmVkOlxuICAgIGNhc2UgbnVsbDpcbiAgICAgIHJldHVybiBcInN0YXJ0XCJcbiAgICBkZWZhdWx0OlxuICAgICAgYXNzZXJ0TmV2ZXIoanVzdGlmeSlcbiAgfVxufVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZEZsZXhDb250YWluZXJCbG9ja1Byb3BzIHtcbiAgZGlyZWN0aW9uOiBSZWFjdC5DU1NQcm9wZXJ0aWVzW1wiZmxleERpcmVjdGlvblwiXVxuICBnYXA/OiBzdHJlYW1saXQuR2FwU2l6ZSB8IHVuZGVmaW5lZFxuICBmbGV4PzogUmVhY3QuQ1NTUHJvcGVydGllc1tcImZsZXhcIl1cbiAgLy8gVGhpcyBtYXJrcyB0aGUgcHJvcCBhcyBhIHRyYW5zaWVudCBwcm9wZXJ0eSBzbyBpdCBpc1xuICAvLyBub3QgcGFzc2VkIHRvIHRoZSBET00uIEl0IG92ZXJsYXBzIHdpdGggYSB2YWxpZCBhdHRyaWJ1dGVcbiAgLy8gc28gcGFzc2luZyBpdCB0byB0aGUgRE9NIHdpbGwgY2F1c2UgYW4gZXJyb3IgaW4gdGhlIGNvbnNvbGUuXG4gICR3cmFwPzogYm9vbGVhblxuICBoZWlnaHQ/OiBSZWFjdC5DU1NQcm9wZXJ0aWVzW1wiaGVpZ2h0XCJdXG4gIGJvcmRlcjogYm9vbGVhblxuICBhbGlnbj86IEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5BbGlnbiB8IG51bGxcbiAganVzdGlmeT86IEJsb2NrUHJvdG8uRmxleENvbnRhaW5lci5KdXN0aWZ5IHwgbnVsbFxuICBvdmVyZmxvdz86IFJlYWN0LkNTU1Byb3BlcnRpZXNbXCJvdmVyZmxvd1wiXVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRmxleENvbnRhaW5lckJsb2NrID1cbiAgc3R5bGVkLmRpdjxTdHlsZWRGbGV4Q29udGFpbmVyQmxvY2tQcm9wcz4oXG4gICAgKHtcbiAgICAgIHRoZW1lLFxuICAgICAgZGlyZWN0aW9uLFxuICAgICAgZ2FwLFxuICAgICAgZmxleCxcbiAgICAgICR3cmFwLFxuICAgICAgaGVpZ2h0LFxuICAgICAgYm9yZGVyLFxuICAgICAgYWxpZ24sXG4gICAgICBqdXN0aWZ5LFxuICAgICAgb3ZlcmZsb3csXG4gICAgfSkgPT4ge1xuICAgICAgbGV0IGdhcFdpZHRoXG4gICAgICBpZiAoZ2FwICE9PSB1bmRlZmluZWQpIHtcbiAgICAgICAgZ2FwV2lkdGggPSB0cmFuc2xhdGVHYXBXaWR0aChnYXAsIHRoZW1lKVxuICAgICAgfVxuXG4gICAgICByZXR1cm4ge1xuICAgICAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICAgICAgZ2FwOiBnYXBXaWR0aCxcbiAgICAgICAgd2lkdGg6IFwiMTAwJVwiLFxuICAgICAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgICAgIGhlaWdodDogaGVpZ2h0ID8/IFwiYXV0b1wiLFxuICAgICAgICBtaW5XaWR0aDogXCIxcmVtXCIsXG4gICAgICAgIGZsZXhEaXJlY3Rpb246IGRpcmVjdGlvbixcbiAgICAgICAgZmxleCxcbiAgICAgICAgYWxpZ25JdGVtczogZ2V0QWxpZ25JdGVtcyhhbGlnbiksXG4gICAgICAgIGp1c3RpZnlDb250ZW50OiBnZXRKdXN0aWZ5Q29udGVudChqdXN0aWZ5KSxcbiAgICAgICAgZmxleFdyYXA6ICR3cmFwID8gXCJ3cmFwXCIgOiBcIm5vd3JhcFwiLFxuICAgICAgICAuLi4oYm9yZGVyICYmIHtcbiAgICAgICAgICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICAgICAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICAgICAgICBwYWRkaW5nOiBgY2FsYygke3RoZW1lLnNwYWNpbmcubGd9IC0gJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0pYCxcbiAgICAgICAgfSksXG4gICAgICAgIG92ZXJmbG93LFxuICAgICAgfVxuICAgIH1cbiAgKVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZExheW91dFdyYXBwZXJQcm9wcyB7XG4gIHdpZHRoPzogUmVhY3QuQ1NTUHJvcGVydGllc1tcIndpZHRoXCJdXG4gIGhlaWdodD86IFJlYWN0LkNTU1Byb3BlcnRpZXNbXCJoZWlnaHRcIl1cbiAgZmxleD86IFJlYWN0LkNTU1Byb3BlcnRpZXNbXCJmbGV4XCJdXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRMYXlvdXRXcmFwcGVyID0gc3R5bGVkLmRpdjxTdHlsZWRMYXlvdXRXcmFwcGVyUHJvcHM+KFxuICAoeyB3aWR0aCwgaGVpZ2h0LCBmbGV4IH0pID0+ICh7XG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgLy8gVGhpcyBzaG91bGRuJ3QgbWF0dGVyIHNpbmNlIHRoaXMgaXMgYSB3cmFwcGVyIGFuZCBzaG91bGQgb25seSBoYXZlIG9uZSBjaGlsZC5cbiAgICAvLyBIb3dldmVyLCBhZGRpbmcgaXQgaGVyZSB0byBiZSBleHBsaWNpdC5cbiAgICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICAgIHdpZHRoLFxuICAgIG1heFdpZHRoOiBcIjEwMCVcIixcbiAgICBtaW5XaWR0aDogXCIxcmVtXCIsXG4gICAgaGVpZ2h0LFxuICAgIGZsZXgsXG4gIH0pXG4pXG4iXX0= */"), getAlignItems = (n) => {
  switch (n) {
    case Block$2.FlexContainer.Align.ALIGN_START:
      return "start";
    case Block$2.FlexContainer.Align.ALIGN_CENTER:
      return "center";
    case Block$2.FlexContainer.Align.ALIGN_END:
      return "end";
    case Block$2.FlexContainer.Align.STRETCH:
      return "stretch";
    case Block$2.FlexContainer.Align.ALIGN_UNDEFINED:
    case void 0:
    case null:
      return "stretch";
    default:
      assertNever(n);
  }
}, getJustifyContent = (n) => {
  switch (n) {
    case Block$2.FlexContainer.Justify.JUSTIFY_START:
      return "start";
    case Block$2.FlexContainer.Justify.JUSTIFY_CENTER:
      return "center";
    case Block$2.FlexContainer.Justify.JUSTIFY_END:
      return "end";
    case Block$2.FlexContainer.Justify.SPACE_BETWEEN:
      return "space-between";
    case Block$2.FlexContainer.Justify.JUSTIFY_UNDEFINED:
    case void 0:
    case null:
      return "start";
    default:
      assertNever(n);
  }
}, StyledFlexContainerBlock = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn1"
} : {
  target: "e1f1d6gn1",
  label: "StyledFlexContainerBlock"
})(({
  theme: n,
  direction: t,
  gap: g,
  flex: d,
  $wrap: k,
  height: H,
  border: AA,
  align: gA,
  justify: IA,
  overflow: CA
}) => {
  let BA;
  return g !== void 0 && (BA = translateGapWidth(g, n)), {
    display: "flex",
    gap: BA,
    width: "100%",
    maxWidth: "100%",
    height: H ?? "auto",
    minWidth: "1rem",
    flexDirection: t,
    flex: d,
    alignItems: getAlignItems(gA),
    justifyContent: getJustifyContent(IA),
    flexWrap: k ? "wrap" : "nowrap",
    ...AA && {
      border: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
      borderRadius: n.radii.default,
      padding: `calc(${n.spacing.lg} - ${n.sizes.borderWidth})`
    },
    overflow: CA
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLayoutWrapper = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn0"
} : {
  target: "e1f1d6gn0",
  label: "StyledLayoutWrapper"
})(({
  width: n,
  height: t,
  flex: g
}) => ({
  display: "flex",
  // This shouldn't matter since this is a wrapper and should only have one child.
  // However, adding it here to be explicit.
  flexDirection: "column",
  width: n,
  maxWidth: "100%",
  minWidth: "1rem",
  height: t,
  flex: g
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), LARGE_STRETCH_BEHAVIOR$1 = [
  "graphvizChart",
  "arrowVegaLiteChart",
  "deckGlJsonChart",
  "plotlyChart",
  "docString",
  "arrowDataFrame",
  "json",
  "audioInput",
  "fileUploader",
  "cameraInput",
  "audio",
  "video",
  "code",
  // also includes st.echo
  "buttonGroup",
  "iframe"
], MEDIUM_STRETCH_BEHAVIOR$1 = [
  "dateInput",
  "radio",
  "slider",
  // also includes st.select_slider
  "textArea",
  "progress",
  "multiselect",
  "selectbox",
  "timeInput",
  "numberInput",
  "textInput"
], WIDTH_STRETCH_OVERRIDE = [
  // Because of how width is handled for custom components, we need the
  // element wrapper to be full width.
  "componentInstance",
  // TODO (lawilby): This can probably be removed once width is
  // implemented for plotly charts. But currently, it seems like when
  // we have use_container_width=False and the minWidth change the image
  // doesn't render large enough.
  "plotlyChart",
  // Without this style, the skeleton width relies on the flex container that
  // wraps the page contents having align-items: stretch. There was a regression
  // where this default was changed. It is more robust to ensure that the skeleton
  // has this width.
  "skeleton"
], VISIBLE_OVERFLOW_OVERRIDE = [
  // TODO(lwilby): Some elements need overflow to be visible in webkit. Will investigate
  // if we can remove this custom handling in future layouts work.
  "iframe",
  "arrowDataFrame",
  "deckGlJsonChart",
  "arrowVegaLiteChart",
  "graphvizChart"
], StyledElementContainerLayoutWrapper = ({
  node: n,
  ...t
}) => {
  const {
    isInHorizontalLayout: g
  } = useRequiredContext(FlexContext);
  let d = "fit-content";
  g && LARGE_STRETCH_BEHAVIOR$1.includes(n.element.type ?? "") ? d = "14rem" : g && MEDIUM_STRETCH_BEHAVIOR$1.includes(n.element.type ?? "") && (d = "8rem"), n.element.type === "buttonGroup" && n.element.buttonGroup?.style === ButtonGroup$1.Style.BORDERLESS && (d = "fit-content");
  const k = useMemo$1(() => {
    const AA = {};
    return WIDTH_STRETCH_OVERRIDE.includes(n.element.type ?? "") && (AA.width = "100%"), VISIBLE_OVERFLOW_OVERRIDE.includes(n.element.type ?? "") && (AA.overflow = "visible"), n.element.type === "textArea" ? n.element.heightConfig?.useStretch ? {
      height: "100%",
      flex: "1 1 8rem"
    } : g ? {
      height: "auto"
    } : {
      height: "auto",
      // Content height text area in vertical layout cannot have flex.
      flex: ""
    } : n.element.type === "deckGlJsonChart" ? (!n.element.deckGlJsonChart?.useContainerWidth && !n.element.deckGlJsonChart?.width && (AA.width = "100%"), AA) : n.element.type === "arrowVegaLiteChart" ? (n.element.widthConfig?.useContent && (AA.width = "100%"), g && !n.element.widthConfig && (AA.flex = "1 1 14rem"), AA) : n.element.type === "arrowDataFrame" ? (n.element.widthConfig?.useContent && (AA.width = "100%"), AA) : (n.element.type === "imgs" && (AA.width = "auto"), AA);
  }, [n.element.type, n.element.heightConfig?.useStretch, n.element.deckGlJsonChart?.useContainerWidth, n.element.deckGlJsonChart?.width, g, n.element.widthConfig]), H = useLayoutStyles({
    element: n.element,
    subElement: n.element?.type && n.element[n.element.type] || void 0,
    styleOverrides: k,
    minStretchBehavior: d
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledElementContainer, { ...t, ...H });
}, Audio = lazy(() => import("./index-BPsr3GBY.js")), Balloons = lazy(() => import("./index-CFJPpmiv.js")), Snow = lazy(() => import("./index-xHja9EuR.js")), ArrowDataFrame = lazy(() => import("./index-Cwu3avS4.js")), ArrowVegaLiteChart = lazy(() => import("./index-0V3zFawH.js")), Toast = lazy(() => import("./index-DJv86VV6.js")), BokehChart = lazy(() => import("./index-DfmwwL-F.js")), DebouncedBokehChart = withCalculatedWidth(debounceRender(BokehChart, 100)), DeckGlJsonChart = lazy(() => import("./index-CqUzXpnq.js")), GraphVizChart = lazy(() => import("./index-CKLXnSph.js")), IFrame = lazy(() => import("./index-zCpSIFXF.js")), ImageList = lazy(() => import("./index-DpgEDPmz.js")), LinkButton = lazy(() => import("./index-B7QM9sAr.js")), PageLink = lazy(() => import("./index-BV9PPylv.js")), PlotlyChart = lazy(() => import("./index-CZG1F3wS.js")), Video = lazy(() => import("./index-BkEF79ga.js")), AudioInput = lazy(() => import("./index-CQ0SOKgT.js")), Button = lazy(() => import("./index-CK3GkxeH.js")), ButtonGroup = lazy(() => import("./index-CxQBvv94.js")), DownloadButton = lazy(() => import("./index-BaDPYxKb.js")), CameraInput = lazy(() => import("./index-pBZdYFXV.js")), ChatInput = lazy(() => import("./index-BQabGVla.js")), Checkbox = lazy(() => import("./index-Ng0C2pop.js")), ColorPicker = lazy(() => import("./index-D--Ibtdf.js")), DateInput = lazy(() => import("./index-fJZU9fvL.js")), Html = lazy(() => import("./index-DDzvi540.js")), Multiselect = lazy(() => import("./index-BacWTAj2.js")), Progress = lazy(() => import("./index-D6seXbqB.js")), Spinner = lazy(() => import("./index-DdN7bQv1.js")), Radio = lazy(() => import("./index-Hwxwzkvz.js")), Selectbox$1 = lazy(() => import("./index-j0zTFwH2.js")), Slider$1 = lazy(() => import("./index-DlIOBmG6.js")), FileUploader = lazy(() => import("./index-BFxpMDN6.js")), TextArea = lazy(() => import("./index-p30tlBB-.js")), TextInput = lazy(() => import("./index-DUxsAr3N.js")), TimeInput = lazy(() => import("./index-B77TIzH-.js")), NumberInput = lazy(() => import("./index-fUOYudAa.js")), StreamlitSyntaxHighlighter = lazy(() => Promise.resolve().then(() => StreamlitSyntaxHighlighter$3));
function hideIfStale(n, t) {
  return n ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : t;
}
const RawElementNodeRenderer = (n) => {
  const {
    node: t
  } = n;
  if (!t)
    throw new Error("ElementNode not found.");
  const g = {
    disableFullscreenMode: n.disableFullscreenMode,
    widthConfig: t.element.widthConfig,
    heightConfig: t.element.heightConfig
  }, d = {
    ...g,
    widgetMgr: n.widgetMgr,
    disabled: n.widgetsDisabled,
    fragmentId: t.fragmentId
  };
  switch (t.element.type) {
    case "alert": {
      const k = t.element.alert;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AlertElement$1, { icon: k.icon, body: k.body, kind: getAlertElementKind(k.format), ...g });
    }
    case "arrowTable": {
      const k = t.element.arrowTable;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowTable$1, { element: k, data: t.quiverElement, ...g });
    }
    case "audio":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Audio, { element: t.element.audio, endpoints: n.endpoints, ...g, elementMgr: n.widgetMgr });
    case "balloons":
      return hideIfStale(n.isStale, /* @__PURE__ */ jsxRuntimeExports.jsx(Balloons, { scriptRunId: t.scriptRunId }));
    case "bokehChart":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DebouncedBokehChart, { element: t.element.bokehChart, ...g });
    case "code": {
      const k = t.element.code;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitSyntaxHighlighter, { language: k.language, showLineNumbers: k.showLineNumbers, wrapLines: k.wrapLines, children: k.codeText });
    }
    case "deckGlJsonChart":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DeckGlJsonChart, { element: t.element.deckGlJsonChart, ...d });
    case "docString":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DocString$1, { element: t.element.docString, ...g });
    case "empty":
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stEmpty", "data-testid": "stEmpty" });
    case "exception":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ExceptionElement$1, { element: t.element.exception, ...g });
    case "graphvizChart":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(GraphVizChart, { element: t.element.graphvizChart, ...g });
    case "heading":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Heading, { element: t.element.heading, ...g });
    case "iframe":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(IFrame, { element: t.element.iframe, ...g });
    case "imgs":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ImageList, { element: t.element.imgs, endpoints: n.endpoints, ...g });
    case "json":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Json$1, { element: t.element.json, ...g });
    case "markdown":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown$1, { element: t.element.markdown, ...g });
    case "metric":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Metric$1, { element: t.element.metric, ...g });
    case "html":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Html, { element: t.element.html, ...g });
    case "pageLink": {
      const k = t.element.pageLink, H = d.disabled || k.disabled;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PageLink, { element: k, disabled: H, ...g });
    }
    case "progress":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Progress, { element: t.element.progress, ...g });
    case "skeleton":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: t.element.skeleton });
    case "snow":
      return hideIfStale(n.isStale, /* @__PURE__ */ jsxRuntimeExports.jsx(Snow, { scriptRunId: t.scriptRunId }));
    case "spinner":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { element: t.element.spinner, ...g });
    case "text":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(TextElement$1, { element: t.element.text, ...g });
    case "video":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Video, { element: t.element.video, endpoints: n.endpoints, ...g, elementMgr: n.widgetMgr });
    // Events:
    case "toast": {
      const k = t.element.toast;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Toast,
        {
          element: k,
          ...g
        },
        t.scriptRunId
      );
    }
    // Widgets:
    case "arrowDataFrame": {
      const k = t.element.arrowDataFrame;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(
        ArrowDataFrame,
        {
          element: k,
          data: t.quiverElement,
          ...d
        },
        k.id || void 0
      );
    }
    case "arrowVegaLiteChart": {
      const k = t.vegaLiteChartElement;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        ArrowVegaLiteChart,
        {
          element: k,
          ...d
        },
        k.id || void 0
      );
    }
    case "audioInput": {
      const k = t.element.audioInput;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(AudioInput, { uploadClient: n.uploadClient, element: k, ...d }, k.id);
    }
    case "button": {
      const k = t.element.button;
      return d.disabled = d.disabled || k.disabled, k.isFormSubmitter ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormSubmitContent, { element: k, ...d }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { element: k, ...d });
    }
    case "buttonGroup": {
      const k = t.element.buttonGroup;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroup, { element: k, ...d }, k.id);
    }
    case "downloadButton": {
      const k = t.element.downloadButton;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(DownloadButton, { endpoints: n.endpoints, element: k, ...d }, k.id);
    }
    case "cameraInput": {
      const k = t.element.cameraInput;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(CameraInput, { element: k, uploadClient: n.uploadClient, ...d }, k.id);
    }
    case "chatInput": {
      const k = t.element.chatInput;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ChatInput, { element: k, uploadClient: n.uploadClient, ...d }, k.id);
    }
    case "checkbox": {
      const k = t.element.checkbox;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { element: k, ...d }, k.id);
    }
    case "colorPicker": {
      const k = t.element.colorPicker;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ColorPicker, { element: k, ...d }, k.id);
    }
    case "componentInstance":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ComponentInstance$1, { element: t.element.componentInstance, ...d });
    case "dateInput": {
      const k = t.element.dateInput;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(DateInput, { element: k, ...d }, k.id);
    }
    case "fileUploader": {
      const k = t.element.fileUploader;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(FileUploader, { element: k, uploadClient: n.uploadClient, ...d }, k.id);
    }
    case "linkButton": {
      const k = t.element.linkButton;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LinkButton, { element: k, ...g });
    }
    case "multiselect": {
      const k = t.element.multiselect;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Multiselect, { element: k, ...d }, k.id);
    }
    case "numberInput": {
      const k = t.element.numberInput;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInput, { element: k, ...d }, k.id);
    }
    case "plotlyChart": {
      const k = t.element.plotlyChart;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PlotlyChart, { element: k, ...d }, k.id);
    }
    case "radio": {
      const k = t.element.radio;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { element: k, ...d }, k.id);
    }
    case "selectbox": {
      const k = t.element.selectbox;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Selectbox$1, { element: k, ...d }, k.id);
    }
    case "slider": {
      const k = t.element.slider;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(Slider$1, { element: k, ...d }, k.id);
    }
    case "textArea": {
      const k = t.element.textArea;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(TextArea, { element: k, outerElement: t.element, ...d }, k.id);
    }
    case "textInput": {
      const k = t.element.textInput;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { element: k, ...d }, k.id);
    }
    case "timeInput": {
      const k = t.element.timeInput;
      return d.disabled = d.disabled || k.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(TimeInput, { element: k, ...d }, k.id);
    }
    default:
      throw new Error(`Unrecognized Element type ${t.element.type}`);
  }
}, ElementNodeRenderer = (n) => {
  const {
    isFullScreen: t,
    fragmentIdsThisRun: g,
    scriptRunState: d,
    scriptRunId: k
  } = useContext(LibContext), {
    node: H
  } = n, AA = H.element.type || "", gA = shouldComponentBeEnabled(AA, d), IA = isComponentStale(gA, H, d, k, g), CA = getElementId(H.element), BA = getKeyFromId(CA);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Maybe, { enable: gA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    StyledElementContainerLayoutWrapper,
    {
      className: classNames("stElementContainer", "element-container", convertKeyToClassName(BA)),
      "data-testid": "stElementContainer",
      "data-stale": IA,
      isStale: IA && !t,
      elementType: AA,
      node: H,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: Skeleton$1.create({
        style: Skeleton$1.SkeletonStyle.ELEMENT
      }) }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(RawElementNodeRenderer, { ...n, isStale: IA }) }) })
    }
  ) });
}, ChildRenderer = (n) => {
  const {
    libConfig: t
  } = useContext(LibContext);
  assignDividerColor(n.node, useEmotionTheme());
  const g = /* @__PURE__ */ new Set();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: n.node.children?.map((d, k) => {
    const H = t.disableFullscreenMode || n.disableFullscreenMode;
    if (d instanceof ElementNode) {
      const AA = {
        ...n,
        disableFullscreenMode: H,
        node: d
      }, gA = getElementId(d.element) || k.toString();
      return g.has(gA) ? null : (g.add(gA), /* @__PURE__ */ jsxRuntimeExports.jsx(ElementNodeRenderer, { ...AA }, gA));
    }
    if (d instanceof BlockNode) {
      const AA = {
        ...n,
        disableFullscreenMode: H,
        node: d
      };
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BlockNodeRenderer, { ...AA }, k);
    }
    throw new Error(`Unrecognized AppNode: ${d}`);
  }) });
}, getLayoutSubElement = (n) => {
  const t = n.type, g = t ? n[t] : void 0;
  if (!g || typeof g != "object") return;
  const d = g, k = {
    useContainerWidth: d.useContainerWidth,
    height: d.height,
    width: d.width,
    widthConfig: d.widthConfig
  };
  if (!(k.useContainerWidth === void 0 && k.height === void 0 && k.width === void 0 && k.widthConfig === void 0))
    return k;
}, ContainerContentsWrapper = (n) => {
  const t = {
    direction: Direction.VERTICAL,
    flex: 1,
    gap: streamlit.GapSize.SMALL,
    height: n.height,
    // eslint-disable-next-line streamlit-custom/no-hardcoded-theme-values
    border: !1
  }, g = getKeyFromId(n.node.deltaBlock.id);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FlexContextProvider, { direction: Direction.VERTICAL, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFlexContainerBlock, { ...t, className: classNames(getClassnamePrefix(Direction.VERTICAL), convertKeyToClassName(g)), "data-testid": getClassnamePrefix(Direction.VERTICAL), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildRenderer, { ...n }) }) });
}, FlexBoxContainer = (n) => {
  const t = getDirectionOfBlock(n.node.deltaBlock), g = getActivateScrollToBottomBackwardsCompatible(n.node), d = useScrollToBottom(g), k = useLayoutStyles({
    element: n.node.deltaBlock,
    subElement: getLayoutSubElement(n.node.deltaBlock)
  }), H = {
    gap: (
      // This is backwards compatible with old proto messages since previously
      // the gap size was defaulted to small.
      n.node.deltaBlock.flexContainer?.gapConfig?.gapSize ?? streamlit.GapSize.SMALL
    ),
    direction: t,
    // This is also backwards compatible since previously wrap was not added
    // to the flex container.
    $wrap: n.node.deltaBlock.flexContainer?.wrap ?? !1,
    overflow: k.overflow,
    border: getBorderBackwardsCompatible(n.node.deltaBlock),
    // We need the height on the container for scrolling.
    height: k.height,
    // Flex properties are set on the LayoutWrapper.
    flex: "1",
    align: n.node.deltaBlock.flexContainer?.align,
    justify: n.node.deltaBlock.flexContainer?.justify
  }, AA = getKeyFromId(n.node.deltaBlock.id);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FlexContextProvider, { direction: t, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFlexContainerBlock, { ...H, className: classNames(getClassnamePrefix(t), convertKeyToClassName(AA)), "data-testid": getClassnamePrefix(t), ref: d, "data-test-scroll-behavior": g ? "scroll-to-bottom" : "normal", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildRenderer, { ...n }) }) });
}, LARGE_STRETCH_BEHAVIOR = ["tabContainer"], MEDIUM_STRETCH_BEHAVIOR = ["chatInput"], BlockNodeRenderer = (n) => {
  const {
    node: t
  } = n, {
    fragmentIdsThisRun: g,
    scriptRunState: d,
    scriptRunId: k
  } = useContext(LibContext), {
    formsData: H
  } = useRequiredContext(FormsContext);
  let AA;
  LARGE_STRETCH_BEHAVIOR.includes(t.deltaBlock.type ?? "") ? AA = "14rem" : MEDIUM_STRETCH_BEHAVIOR.includes(t.deltaBlock.type ?? "") ? AA = "8rem" : t.deltaBlock.type === "chatMessage" ? t.isEmpty ? AA = "8rem" : AA = "fit-content" : (t.deltaBlock.type === "flexContainer" || t.deltaBlock.column || t.deltaBlock.expandable) && (t.isEmpty || (AA = "8rem"));
  const gA = useLayoutStyles({
    element: t.deltaBlock,
    subElement: getLayoutSubElement(t.deltaBlock),
    minStretchBehavior: AA
  });
  if (t.isEmpty && !t.deltaBlock.allowEmpty)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  const IA = shouldComponentBeEnabled("", d), CA = isComponentStale(IA, t, d, k, g), BA = {
    ...n,
    node: t
  }, eA = n.disableFullscreenMode || notNullOrUndefined(t.deltaBlock.dialog) || notNullOrUndefined(t.deltaBlock.popover);
  let iA;
  const QA = /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerContentsWrapper, { ...BA, disableFullscreenMode: eA, height: "100%" });
  if (checkFlexContainerBackwardsCompatibile(t.deltaBlock) && (iA = /* @__PURE__ */ jsxRuntimeExports.jsx(FlexBoxContainer, { ...BA })), t.deltaBlock.dialog)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog$1, { element: t.deltaBlock.dialog, deltaMsgReceivedAt: t.deltaMsgReceivedAt, widgetMgr: n.widgetMgr, fragmentId: t.fragmentId, children: QA });
  if (t.deltaBlock.expandable && (iA = /* @__PURE__ */ jsxRuntimeExports.jsx(Expander$1, { isStale: CA, element: t.deltaBlock.expandable, children: QA })), t.deltaBlock.popover && (iA = /* @__PURE__ */ jsxRuntimeExports.jsx(Popover$1, { empty: t.isEmpty, element: t.deltaBlock.popover, stretchWidth: shouldWidthStretch(t.deltaBlock.widthConfig), children: QA })), t.deltaBlock.type === "form") {
    const {
      formId: tA,
      clearOnSubmit: oA,
      enterToSubmit: EA,
      border: aA
    } = t.deltaBlock.form, nA = H.submitButtons.get(tA), lA = nA !== void 0 && nA.length > 0, cA = d === ScriptRunState.NOT_RUNNING;
    iA = /* @__PURE__ */ jsxRuntimeExports.jsx(Form$1, { formId: tA, clearOnSubmit: oA, enterToSubmit: EA, hasSubmitButton: lA, scriptNotRunning: cA, widgetMgr: n.widgetMgr, border: aA, overflow: gA.overflow, children: QA });
  }
  if (t.deltaBlock.chatMessage && (iA = /* @__PURE__ */ jsxRuntimeExports.jsx(ChatMessage$1, { element: t.deltaBlock.chatMessage, endpoints: n.endpoints, children: QA })), t.deltaBlock.column)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledColumn, { weight: t.deltaBlock.column.weight ?? 0, gap: backwardsCompatibleColumnGapSize(t.deltaBlock.column), verticalAlignment: t.deltaBlock.column.verticalAlignment ?? void 0, showBorder: t.deltaBlock.column.showBorder ?? !1, className: "stColumn", "data-testid": "stColumn", children: QA });
  if (t.deltaBlock.tabContainer) {
    const oA = {
      ...BA,
      isStale: CA,
      renderTabContent: (EA) => /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerContentsWrapper, { ...EA, height: "auto" }),
      width: gA.width,
      flex: gA.flex
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Tabs$1, { ...oA });
  }
  return iA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLayoutWrapper, { "data-testid": "stLayoutWrapper", ...gA, children: iA }) : QA;
};
process.env.NODE_ENV;
const StyledDataFrameOverlay = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1v116lc0"
} : {
  target: "e1v116lc0",
  label: "StyledDataFrameOverlay"
})(({
  theme: n
}) => ({
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: n.zIndices.tablePortal,
  lineHeight: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), PortalContext = createContext(null);
PortalContext.displayName = "PortalContext";
const PortalProvider = ({
  children: n
}) => {
  const t = useRef(null), g = useCallback(() => t.current, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PortalContext.Provider, { value: g, children: [
    n,
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDataFrameOverlay, { "data-testid": "portal", id: "portal", ref: t })
  ] });
};
function ThemeProvider({
  theme: n,
  baseuiTheme: t,
  children: g
}) {
  return (
    // Type error coming from BaseUI "property children doesn't exist"
    // @ts-expect-error
    /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$1, { theme: t || baseuiLightTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$2, { theme: n, children: g }) })
  );
}
function iconToUrl(n) {
  const t = /^:(.+)\/(.+):$/, g = n.match(t);
  return g === null ? "" : `https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsrounded/${g[2]}/default/24px.svg`;
}
function handleFavicon(n, t, g) {
  const d = extractEmoji(n);
  let k;
  d && !n.startsWith(":material") ? k = `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>${d}</text></svg>` : n.startsWith(":material") ? k = iconToUrl(n) : k = g.buildMediaURL(n), overwriteFavicon(k), t({
    type: "SET_PAGE_FAVICON",
    favicon: k
  });
}
function overwriteFavicon(n) {
  const t = document.querySelector("link[rel='shortcut icon']");
  t && (t.href = n);
}
function extractEmoji(n) {
  const t = "emoji:";
  if (n.startsWith(t))
    return n.substring(t.length);
  const g = n.replace("-", "_"), d = get$8(g);
  return d !== void 0 && has$3(d) ? d : "";
}
var lib = {}, flattenNames = {}, isString_1, hasRequiredIsString;
function requireIsString() {
  if (hasRequiredIsString) return isString_1;
  hasRequiredIsString = 1;
  var n = require_baseGetTag(), t = requireIsArray(), g = requireIsObjectLike(), d = "[object String]";
  function k(H) {
    return typeof H == "string" || !t(H) && g(H) && n(H) == d;
  }
  return isString_1 = k, isString_1;
}
var _castFunction, hasRequired_castFunction;
function require_castFunction() {
  if (hasRequired_castFunction) return _castFunction;
  hasRequired_castFunction = 1;
  var n = requireIdentity();
  function t(g) {
    return typeof g == "function" ? g : n;
  }
  return _castFunction = t, _castFunction;
}
var forOwn_1, hasRequiredForOwn;
function requireForOwn() {
  if (hasRequiredForOwn) return forOwn_1;
  hasRequiredForOwn = 1;
  var n = require_baseForOwn(), t = require_castFunction();
  function g(d, k) {
    return d && n(d, t(k));
  }
  return forOwn_1 = g, forOwn_1;
}
var map_1, hasRequiredMap;
function requireMap() {
  if (hasRequiredMap) return map_1;
  hasRequiredMap = 1;
  var n = require_arrayMap(), t = require_baseIteratee(), g = require_baseMap(), d = requireIsArray();
  function k(H, AA) {
    var gA = d(H) ? n : g;
    return gA(H, t(AA, 3));
  }
  return map_1 = k, map_1;
}
var hasRequiredFlattenNames;
function requireFlattenNames() {
  if (hasRequiredFlattenNames) return flattenNames;
  hasRequiredFlattenNames = 1, Object.defineProperty(flattenNames, "__esModule", {
    value: !0
  }), flattenNames.flattenNames = void 0;
  var n = requireIsString(), t = IA(n), g = requireForOwn(), d = IA(g), k = requireIsPlainObject(), H = IA(k), AA = requireMap(), gA = IA(AA);
  function IA(BA) {
    return BA && BA.__esModule ? BA : { default: BA };
  }
  var CA = flattenNames.flattenNames = function BA() {
    var eA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], iA = [];
    return (0, gA.default)(eA, function(QA) {
      Array.isArray(QA) ? BA(QA).map(function(tA) {
        return iA.push(tA);
      }) : (0, H.default)(QA) ? (0, d.default)(QA, function(tA, oA) {
        tA === !0 && iA.push(oA), iA.push(oA + "-" + tA);
      }) : (0, t.default)(QA) && iA.push(QA);
    }), iA;
  };
  return flattenNames.default = CA, flattenNames;
}
var mergeClasses = {}, hasRequiredMergeClasses;
function requireMergeClasses() {
  if (hasRequiredMergeClasses) return mergeClasses;
  hasRequiredMergeClasses = 1, Object.defineProperty(mergeClasses, "__esModule", {
    value: !0
  }), mergeClasses.mergeClasses = void 0;
  var n = requireForOwn(), t = H(n), g = requireCloneDeep(), d = H(g), k = Object.assign || function(gA) {
    for (var IA = 1; IA < arguments.length; IA++) {
      var CA = arguments[IA];
      for (var BA in CA)
        Object.prototype.hasOwnProperty.call(CA, BA) && (gA[BA] = CA[BA]);
    }
    return gA;
  };
  function H(gA) {
    return gA && gA.__esModule ? gA : { default: gA };
  }
  var AA = mergeClasses.mergeClasses = function(IA) {
    var CA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], BA = IA.default && (0, d.default)(IA.default) || {};
    return CA.map(function(eA) {
      var iA = IA[eA];
      return iA && (0, t.default)(iA, function(QA, tA) {
        BA[tA] || (BA[tA] = {}), BA[tA] = k({}, BA[tA], iA[tA]);
      }), eA;
    }), BA;
  };
  return mergeClasses.default = AA, mergeClasses;
}
var autoprefix = {}, hasRequiredAutoprefix;
function requireAutoprefix() {
  if (hasRequiredAutoprefix) return autoprefix;
  hasRequiredAutoprefix = 1, Object.defineProperty(autoprefix, "__esModule", {
    value: !0
  }), autoprefix.autoprefix = void 0;
  var n = requireForOwn(), t = d(n), g = Object.assign || function(AA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var IA = arguments[gA];
      for (var CA in IA)
        Object.prototype.hasOwnProperty.call(IA, CA) && (AA[CA] = IA[CA]);
    }
    return AA;
  };
  function d(AA) {
    return AA && AA.__esModule ? AA : { default: AA };
  }
  var k = {
    borderRadius: function(gA) {
      return {
        msBorderRadius: gA,
        MozBorderRadius: gA,
        OBorderRadius: gA,
        WebkitBorderRadius: gA,
        borderRadius: gA
      };
    },
    boxShadow: function(gA) {
      return {
        msBoxShadow: gA,
        MozBoxShadow: gA,
        OBoxShadow: gA,
        WebkitBoxShadow: gA,
        boxShadow: gA
      };
    },
    userSelect: function(gA) {
      return {
        WebkitTouchCallout: gA,
        KhtmlUserSelect: gA,
        MozUserSelect: gA,
        msUserSelect: gA,
        WebkitUserSelect: gA,
        userSelect: gA
      };
    },
    flex: function(gA) {
      return {
        WebkitBoxFlex: gA,
        MozBoxFlex: gA,
        WebkitFlex: gA,
        msFlex: gA,
        flex: gA
      };
    },
    flexBasis: function(gA) {
      return {
        WebkitFlexBasis: gA,
        flexBasis: gA
      };
    },
    justifyContent: function(gA) {
      return {
        WebkitJustifyContent: gA,
        justifyContent: gA
      };
    },
    transition: function(gA) {
      return {
        msTransition: gA,
        MozTransition: gA,
        OTransition: gA,
        WebkitTransition: gA,
        transition: gA
      };
    },
    transform: function(gA) {
      return {
        msTransform: gA,
        MozTransform: gA,
        OTransform: gA,
        WebkitTransform: gA,
        transform: gA
      };
    },
    absolute: function(gA) {
      var IA = gA && gA.split(" ");
      return {
        position: "absolute",
        top: IA && IA[0],
        right: IA && IA[1],
        bottom: IA && IA[2],
        left: IA && IA[3]
      };
    },
    extend: function(gA, IA) {
      var CA = IA[gA];
      return CA || {
        extend: gA
      };
    }
  }, H = autoprefix.autoprefix = function(gA) {
    var IA = {};
    return (0, t.default)(gA, function(CA, BA) {
      var eA = {};
      (0, t.default)(CA, function(iA, QA) {
        var tA = k[QA];
        tA ? eA = g({}, eA, tA(iA)) : eA[QA] = iA;
      }), IA[BA] = eA;
    }), IA;
  };
  return autoprefix.default = H, autoprefix;
}
var hover = {}, hasRequiredHover;
function requireHover() {
  if (hasRequiredHover) return hover;
  hasRequiredHover = 1, Object.defineProperty(hover, "__esModule", {
    value: !0
  }), hover.hover = void 0;
  var n = Object.assign || function(IA) {
    for (var CA = 1; CA < arguments.length; CA++) {
      var BA = arguments[CA];
      for (var eA in BA)
        Object.prototype.hasOwnProperty.call(BA, eA) && (IA[eA] = BA[eA]);
    }
    return IA;
  }, t = React__default, g = d(t);
  function d(IA) {
    return IA && IA.__esModule ? IA : { default: IA };
  }
  function k(IA, CA) {
    if (!(IA instanceof CA))
      throw new TypeError("Cannot call a class as a function");
  }
  function H(IA, CA) {
    if (!IA)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return CA && (typeof CA == "object" || typeof CA == "function") ? CA : IA;
  }
  function AA(IA, CA) {
    if (typeof CA != "function" && CA !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof CA);
    IA.prototype = Object.create(CA && CA.prototype, { constructor: { value: IA, enumerable: !1, writable: !0, configurable: !0 } }), CA && (Object.setPrototypeOf ? Object.setPrototypeOf(IA, CA) : IA.__proto__ = CA);
  }
  var gA = hover.hover = function(CA) {
    var BA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
    return (function(eA) {
      AA(iA, eA);
      function iA() {
        var QA, tA, oA, EA;
        k(this, iA);
        for (var aA = arguments.length, nA = Array(aA), lA = 0; lA < aA; lA++)
          nA[lA] = arguments[lA];
        return EA = (tA = (oA = H(this, (QA = iA.__proto__ || Object.getPrototypeOf(iA)).call.apply(QA, [this].concat(nA))), oA), oA.state = { hover: !1 }, oA.handleMouseOver = function() {
          return oA.setState({ hover: !0 });
        }, oA.handleMouseOut = function() {
          return oA.setState({ hover: !1 });
        }, oA.render = function() {
          return g.default.createElement(
            BA,
            { onMouseOver: oA.handleMouseOver, onMouseOut: oA.handleMouseOut },
            g.default.createElement(CA, n({}, oA.props, oA.state))
          );
        }, tA), H(oA, EA);
      }
      return iA;
    })(g.default.Component);
  };
  return hover.default = gA, hover;
}
var active = {}, hasRequiredActive;
function requireActive() {
  if (hasRequiredActive) return active;
  hasRequiredActive = 1, Object.defineProperty(active, "__esModule", {
    value: !0
  }), active.active = void 0;
  var n = Object.assign || function(IA) {
    for (var CA = 1; CA < arguments.length; CA++) {
      var BA = arguments[CA];
      for (var eA in BA)
        Object.prototype.hasOwnProperty.call(BA, eA) && (IA[eA] = BA[eA]);
    }
    return IA;
  }, t = React__default, g = d(t);
  function d(IA) {
    return IA && IA.__esModule ? IA : { default: IA };
  }
  function k(IA, CA) {
    if (!(IA instanceof CA))
      throw new TypeError("Cannot call a class as a function");
  }
  function H(IA, CA) {
    if (!IA)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return CA && (typeof CA == "object" || typeof CA == "function") ? CA : IA;
  }
  function AA(IA, CA) {
    if (typeof CA != "function" && CA !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof CA);
    IA.prototype = Object.create(CA && CA.prototype, { constructor: { value: IA, enumerable: !1, writable: !0, configurable: !0 } }), CA && (Object.setPrototypeOf ? Object.setPrototypeOf(IA, CA) : IA.__proto__ = CA);
  }
  var gA = active.active = function(CA) {
    var BA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
    return (function(eA) {
      AA(iA, eA);
      function iA() {
        var QA, tA, oA, EA;
        k(this, iA);
        for (var aA = arguments.length, nA = Array(aA), lA = 0; lA < aA; lA++)
          nA[lA] = arguments[lA];
        return EA = (tA = (oA = H(this, (QA = iA.__proto__ || Object.getPrototypeOf(iA)).call.apply(QA, [this].concat(nA))), oA), oA.state = { active: !1 }, oA.handleMouseDown = function() {
          return oA.setState({ active: !0 });
        }, oA.handleMouseUp = function() {
          return oA.setState({ active: !1 });
        }, oA.render = function() {
          return g.default.createElement(
            BA,
            { onMouseDown: oA.handleMouseDown, onMouseUp: oA.handleMouseUp },
            g.default.createElement(CA, n({}, oA.props, oA.state))
          );
        }, tA), H(oA, EA);
      }
      return iA;
    })(g.default.Component);
  };
  return active.default = gA, active;
}
var loop = {}, hasRequiredLoop;
function requireLoop() {
  if (hasRequiredLoop) return loop;
  hasRequiredLoop = 1, Object.defineProperty(loop, "__esModule", {
    value: !0
  });
  var n = function(g, d) {
    var k = {}, H = function(gA) {
      var IA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      k[gA] = IA;
    };
    return g === 0 && H("first-child"), g === d - 1 && H("last-child"), (g === 0 || g % 2 === 0) && H("even"), Math.abs(g % 2) === 1 && H("odd"), H("nth-child", g), k;
  };
  return loop.default = n, loop;
}
var hasRequiredLib;
function requireLib() {
  if (hasRequiredLib) return lib;
  hasRequiredLib = 1, Object.defineProperty(lib, "__esModule", {
    value: !0
  }), lib.ReactCSS = lib.loop = lib.handleActive = lib.handleHover = lib.hover = void 0;
  var n = requireFlattenNames(), t = iA(n), g = requireMergeClasses(), d = iA(g), k = requireAutoprefix(), H = iA(k), AA = requireHover(), gA = iA(AA), IA = requireActive(), CA = iA(IA), BA = requireLoop(), eA = iA(BA);
  function iA(tA) {
    return tA && tA.__esModule ? tA : { default: tA };
  }
  lib.hover = gA.default, lib.handleHover = gA.default, lib.handleActive = CA.default, lib.loop = eA.default;
  var QA = lib.ReactCSS = function(oA) {
    for (var EA = arguments.length, aA = Array(EA > 1 ? EA - 1 : 0), nA = 1; nA < EA; nA++)
      aA[nA - 1] = arguments[nA];
    var lA = (0, t.default)(aA), cA = (0, d.default)(oA, lA);
    return (0, H.default)(cA);
  };
  return lib.default = QA, lib;
}
var libExports = requireLib();
const reactCSS = /* @__PURE__ */ getDefaultExportFromCjs$2(libExports);
var calculateChange$2 = function n(t, g, d, k, H) {
  var AA = H.clientWidth, gA = H.clientHeight, IA = typeof t.pageX == "number" ? t.pageX : t.touches[0].pageX, CA = typeof t.pageY == "number" ? t.pageY : t.touches[0].pageY, BA = IA - (H.getBoundingClientRect().left + window.pageXOffset), eA = CA - (H.getBoundingClientRect().top + window.pageYOffset);
  if (d === "vertical") {
    var iA = void 0;
    if (eA < 0 ? iA = 0 : eA > gA ? iA = 1 : iA = Math.round(eA * 100 / gA) / 100, g.a !== iA)
      return {
        h: g.h,
        s: g.s,
        l: g.l,
        a: iA,
        source: "rgb"
      };
  } else {
    var QA = void 0;
    if (BA < 0 ? QA = 0 : BA > AA ? QA = 1 : QA = Math.round(BA * 100 / AA) / 100, k !== QA)
      return {
        h: g.h,
        s: g.s,
        l: g.l,
        a: QA,
        source: "rgb"
      };
  }
  return null;
}, checkboardCache = {}, render = function n(t, g, d, k) {
  if (typeof document > "u" && !k)
    return null;
  var H = k ? new k() : document.createElement("canvas");
  H.width = d * 2, H.height = d * 2;
  var AA = H.getContext("2d");
  return AA ? (AA.fillStyle = t, AA.fillRect(0, 0, H.width, H.height), AA.fillStyle = g, AA.fillRect(0, 0, d, d), AA.translate(d, d), AA.fillRect(0, 0, d, d), H.toDataURL()) : null;
}, get$1 = function n(t, g, d, k) {
  var H = t + "-" + g + "-" + d + (k ? "-server" : "");
  if (checkboardCache[H])
    return checkboardCache[H];
  var AA = render(t, g, d, k);
  return checkboardCache[H] = AA, AA;
}, _extends$r = Object.assign || function(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t];
    for (var d in g)
      Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
  }
  return n;
}, Checkboard = function n(t) {
  var g = t.white, d = t.grey, k = t.size, H = t.renderers, AA = t.borderRadius, gA = t.boxShadow, IA = t.children, CA = reactCSS({
    default: {
      grid: {
        borderRadius: AA,
        boxShadow: gA,
        absolute: "0px 0px 0px 0px",
        background: "url(" + get$1(g, d, k, H.canvas) + ") center left"
      }
    }
  });
  return isValidElement(IA) ? React__default.cloneElement(IA, _extends$r({}, IA.props, { style: _extends$r({}, IA.props.style, CA.grid) })) : React__default.createElement("div", { style: CA.grid });
};
Checkboard.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var _extends$q = Object.assign || function(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t];
    for (var d in g)
      Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
  }
  return n;
}, _createClass$d = /* @__PURE__ */ (function() {
  function n(t, g) {
    for (var d = 0; d < g.length; d++) {
      var k = g[d];
      k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(t, k.key, k);
    }
  }
  return function(t, g, d) {
    return g && n(t.prototype, g), d && n(t, d), t;
  };
})();
function _classCallCheck$d(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$d(n, t) {
  if (!n)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : n;
}
function _inherits$d(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(n, t) : n.__proto__ = t);
}
var Alpha = (function(n) {
  _inherits$d(t, n);
  function t() {
    var g, d, k, H;
    _classCallCheck$d(this, t);
    for (var AA = arguments.length, gA = Array(AA), IA = 0; IA < AA; IA++)
      gA[IA] = arguments[IA];
    return H = (d = (k = _possibleConstructorReturn$d(this, (g = t.__proto__ || Object.getPrototypeOf(t)).call.apply(g, [this].concat(gA))), k), k.handleChange = function(CA) {
      var BA = calculateChange$2(CA, k.props.hsl, k.props.direction, k.props.a, k.container);
      BA && typeof k.props.onChange == "function" && k.props.onChange(BA, CA);
    }, k.handleMouseDown = function(CA) {
      k.handleChange(CA), window.addEventListener("mousemove", k.handleChange), window.addEventListener("mouseup", k.handleMouseUp);
    }, k.handleMouseUp = function() {
      k.unbindEventListeners();
    }, k.unbindEventListeners = function() {
      window.removeEventListener("mousemove", k.handleChange), window.removeEventListener("mouseup", k.handleMouseUp);
    }, d), _possibleConstructorReturn$d(k, H);
  }
  return _createClass$d(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function() {
      var d = this, k = this.props.rgb, H = reactCSS({
        default: {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + k.r + "," + k.g + "," + k.b + `, 0) 0%,
           rgba(` + k.r + "," + k.g + "," + k.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: k.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + k.r + "," + k.g + "," + k.b + `, 0) 0%,
           rgba(` + k.r + "," + k.g + "," + k.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: k.a * 100 + "%"
          }
        },
        overwrite: _extends$q({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: !0
      });
      return React__default.createElement(
        "div",
        { style: H.alpha },
        React__default.createElement(
          "div",
          { style: H.checkboard },
          React__default.createElement(Checkboard, { renderers: this.props.renderers })
        ),
        React__default.createElement("div", { style: H.gradient }),
        React__default.createElement(
          "div",
          {
            style: H.container,
            ref: function(gA) {
              return d.container = gA;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          React__default.createElement(
            "div",
            { style: H.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement("div", { style: H.slider })
          )
        )
      );
    }
  }]), t;
})(PureComponent || Component), _createClass$c = /* @__PURE__ */ (function() {
  function n(t, g) {
    for (var d = 0; d < g.length; d++) {
      var k = g[d];
      k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(t, k.key, k);
    }
  }
  return function(t, g, d) {
    return g && n(t.prototype, g), d && n(t, d), t;
  };
})();
function _defineProperty$e(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function _classCallCheck$c(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$c(n, t) {
  if (!n)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : n;
}
function _inherits$c(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(n, t) : n.__proto__ = t);
}
var DEFAULT_ARROW_OFFSET = 1, UP_KEY_CODE = 38, DOWN_KEY_CODE = 40, VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE], isValidKeyCode = function n(t) {
  return VALID_KEY_CODES.indexOf(t) > -1;
}, getNumberValue = function n(t) {
  return Number(String(t).replace(/%/g, ""));
}, idCounter = 1, EditableInput = (function(n) {
  _inherits$c(t, n);
  function t(g) {
    _classCallCheck$c(this, t);
    var d = _possibleConstructorReturn$c(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
    return d.handleBlur = function() {
      d.state.blurValue && d.setState({ value: d.state.blurValue, blurValue: null });
    }, d.handleChange = function(k) {
      d.setUpdatedValue(k.target.value, k);
    }, d.handleKeyDown = function(k) {
      var H = getNumberValue(k.target.value);
      if (!isNaN(H) && isValidKeyCode(k.keyCode)) {
        var AA = d.getArrowOffset(), gA = k.keyCode === UP_KEY_CODE ? H + AA : H - AA;
        d.setUpdatedValue(gA, k);
      }
    }, d.handleDrag = function(k) {
      if (d.props.dragLabel) {
        var H = Math.round(d.props.value + k.movementX);
        H >= 0 && H <= d.props.dragMax && d.props.onChange && d.props.onChange(d.getValueObjectWithLabel(H), k);
      }
    }, d.handleMouseDown = function(k) {
      d.props.dragLabel && (k.preventDefault(), d.handleDrag(k), window.addEventListener("mousemove", d.handleDrag), window.addEventListener("mouseup", d.handleMouseUp));
    }, d.handleMouseUp = function() {
      d.unbindEventListeners();
    }, d.unbindEventListeners = function() {
      window.removeEventListener("mousemove", d.handleDrag), window.removeEventListener("mouseup", d.handleMouseUp);
    }, d.state = {
      value: String(g.value).toUpperCase(),
      blurValue: String(g.value).toUpperCase()
    }, d.inputId = "rc-editable-input-" + idCounter++, d;
  }
  return _createClass$c(t, [{
    key: "componentDidUpdate",
    value: function(d, k) {
      this.props.value !== this.state.value && (d.value !== this.props.value || k.value !== this.state.value) && (this.input === document.activeElement ? this.setState({ blurValue: String(this.props.value).toUpperCase() }) : this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function(d) {
      return _defineProperty$e({}, this.props.label, d);
    }
  }, {
    key: "getArrowOffset",
    value: function() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: "setUpdatedValue",
    value: function(d, k) {
      var H = this.props.label ? this.getValueObjectWithLabel(d) : d;
      this.props.onChange && this.props.onChange(H, k), this.setState({ value: d });
    }
  }, {
    key: "render",
    value: function() {
      var d = this, k = reactCSS({
        default: {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": !0
      }, this.props);
      return React__default.createElement(
        "div",
        { style: k.wrap },
        React__default.createElement("input", {
          id: this.inputId,
          style: k.input,
          ref: function(AA) {
            return d.input = AA;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: "false"
        }),
        this.props.label && !this.props.hideLabel ? React__default.createElement(
          "label",
          {
            htmlFor: this.inputId,
            style: k.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]), t;
})(PureComponent || Component), calculateChange$1 = function n(t, g, d, k) {
  var H = k.clientWidth, AA = k.clientHeight, gA = typeof t.pageX == "number" ? t.pageX : t.touches[0].pageX, IA = typeof t.pageY == "number" ? t.pageY : t.touches[0].pageY, CA = gA - (k.getBoundingClientRect().left + window.pageXOffset), BA = IA - (k.getBoundingClientRect().top + window.pageYOffset);
  if (g === "vertical") {
    var eA = void 0;
    if (BA < 0)
      eA = 359;
    else if (BA > AA)
      eA = 0;
    else {
      var iA = -(BA * 100 / AA) + 100;
      eA = 360 * iA / 100;
    }
    if (d.h !== eA)
      return {
        h: eA,
        s: d.s,
        l: d.l,
        a: d.a,
        source: "hsl"
      };
  } else {
    var QA = void 0;
    if (CA < 0)
      QA = 0;
    else if (CA > H)
      QA = 359;
    else {
      var tA = CA * 100 / H;
      QA = 360 * tA / 100;
    }
    if (d.h !== QA)
      return {
        h: QA,
        s: d.s,
        l: d.l,
        a: d.a,
        source: "hsl"
      };
  }
  return null;
}, _createClass$b = /* @__PURE__ */ (function() {
  function n(t, g) {
    for (var d = 0; d < g.length; d++) {
      var k = g[d];
      k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(t, k.key, k);
    }
  }
  return function(t, g, d) {
    return g && n(t.prototype, g), d && n(t, d), t;
  };
})();
function _classCallCheck$b(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$b(n, t) {
  if (!n)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : n;
}
function _inherits$b(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(n, t) : n.__proto__ = t);
}
var Hue = (function(n) {
  _inherits$b(t, n);
  function t() {
    var g, d, k, H;
    _classCallCheck$b(this, t);
    for (var AA = arguments.length, gA = Array(AA), IA = 0; IA < AA; IA++)
      gA[IA] = arguments[IA];
    return H = (d = (k = _possibleConstructorReturn$b(this, (g = t.__proto__ || Object.getPrototypeOf(t)).call.apply(g, [this].concat(gA))), k), k.handleChange = function(CA) {
      var BA = calculateChange$1(CA, k.props.direction, k.props.hsl, k.container);
      BA && typeof k.props.onChange == "function" && k.props.onChange(BA, CA);
    }, k.handleMouseDown = function(CA) {
      k.handleChange(CA), window.addEventListener("mousemove", k.handleChange), window.addEventListener("mouseup", k.handleMouseUp);
    }, k.handleMouseUp = function() {
      k.unbindEventListeners();
    }, d), _possibleConstructorReturn$b(k, H);
  }
  return _createClass$b(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var d = this, k = this.props.direction, H = k === void 0 ? "horizontal" : k, AA = reactCSS({
        default: {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, { vertical: H === "vertical" });
      return React__default.createElement(
        "div",
        { style: AA.hue },
        React__default.createElement(
          "div",
          {
            className: "hue-" + H,
            style: AA.container,
            ref: function(IA) {
              return d.container = IA;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          React__default.createElement(
            "style",
            null,
            `
            .hue-horizontal {
              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0
                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to right, #f00 0%, #ff0
                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }

            .hue-vertical {
              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,
                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,
                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }
          `
          ),
          React__default.createElement(
            "div",
            { style: AA.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement("div", { style: AA.slider })
          )
        )
      );
    }
  }]), t;
})(PureComponent || Component);
function listCacheClear() {
  this.__data__ = [], this.size = 0;
}
function eq(n, t) {
  return n === t || n !== n && t !== t;
}
function assocIndexOf(n, t) {
  for (var g = n.length; g--; )
    if (eq(n[g][0], t))
      return g;
  return -1;
}
var arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete(n) {
  var t = this.__data__, g = assocIndexOf(t, n);
  if (g < 0)
    return !1;
  var d = t.length - 1;
  return g == d ? t.pop() : splice.call(t, g, 1), --this.size, !0;
}
function listCacheGet(n) {
  var t = this.__data__, g = assocIndexOf(t, n);
  return g < 0 ? void 0 : t[g][1];
}
function listCacheHas(n) {
  return assocIndexOf(this.__data__, n) > -1;
}
function listCacheSet(n, t) {
  var g = this.__data__, d = assocIndexOf(g, n);
  return d < 0 ? (++this.size, g.push([n, t])) : g[d][1] = t, this;
}
function ListCache(n) {
  var t = -1, g = n == null ? 0 : n.length;
  for (this.clear(); ++t < g; ) {
    var d = n[t];
    this.set(d[0], d[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype.delete = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function stackClear() {
  this.__data__ = new ListCache(), this.size = 0;
}
function stackDelete(n) {
  var t = this.__data__, g = t.delete(n);
  return this.size = t.size, g;
}
function stackGet(n) {
  return this.__data__.get(n);
}
function stackHas(n) {
  return this.__data__.has(n);
}
var freeGlobal = typeof global == "object" && global && global.Object === Object && global, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$1 = freeGlobal || freeSelf || Function("return this")(), Symbol$1 = root$1.Symbol, objectProto$e = Object.prototype, hasOwnProperty$c = objectProto$e.hasOwnProperty, nativeObjectToString$1 = objectProto$e.toString, symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(n) {
  var t = hasOwnProperty$c.call(n, symToStringTag$1), g = n[symToStringTag$1];
  try {
    n[symToStringTag$1] = void 0;
    var d = !0;
  } catch {
  }
  var k = nativeObjectToString$1.call(n);
  return d && (t ? n[symToStringTag$1] = g : delete n[symToStringTag$1]), k;
}
var objectProto$d = Object.prototype, nativeObjectToString = objectProto$d.toString;
function objectToString(n) {
  return nativeObjectToString.call(n);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(n) {
  return n == null ? n === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(n) ? getRawTag(n) : objectToString(n);
}
function isObject$2(n) {
  var t = typeof n;
  return n != null && (t == "object" || t == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$3(n) {
  if (!isObject$2(n))
    return !1;
  var t = baseGetTag(n);
  return t == funcTag$1 || t == genTag || t == asyncTag || t == proxyTag;
}
var coreJsData = root$1["__core-js_shared__"], maskSrcKey = (function() {
  var n = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return n ? "Symbol(src)_1." + n : "";
})();
function isMasked(n) {
  return !!maskSrcKey && maskSrcKey in n;
}
var funcProto$2 = Function.prototype, funcToString$2 = funcProto$2.toString;
function toSource(n) {
  if (n != null) {
    try {
      return funcToString$2.call(n);
    } catch {
    }
    try {
      return n + "";
    } catch {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto$1 = Function.prototype, objectProto$c = Object.prototype, funcToString$1 = funcProto$1.toString, hasOwnProperty$b = objectProto$c.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$b).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(n) {
  if (!isObject$2(n) || isMasked(n))
    return !1;
  var t = isFunction$3(n) ? reIsNative : reIsHostCtor;
  return t.test(toSource(n));
}
function getValue(n, t) {
  return n?.[t];
}
function getNative(n, t) {
  var g = getValue(n, t);
  return baseIsNative(g) ? g : void 0;
}
var Map$1 = getNative(root$1, "Map"), nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {}, this.size = 0;
}
function hashDelete(n) {
  var t = this.has(n) && delete this.__data__[n];
  return this.size -= t ? 1 : 0, t;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$b = Object.prototype, hasOwnProperty$a = objectProto$b.hasOwnProperty;
function hashGet(n) {
  var t = this.__data__;
  if (nativeCreate) {
    var g = t[n];
    return g === HASH_UNDEFINED$2 ? void 0 : g;
  }
  return hasOwnProperty$a.call(t, n) ? t[n] : void 0;
}
var objectProto$a = Object.prototype, hasOwnProperty$9 = objectProto$a.hasOwnProperty;
function hashHas(n) {
  var t = this.__data__;
  return nativeCreate ? t[n] !== void 0 : hasOwnProperty$9.call(t, n);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(n, t) {
  var g = this.__data__;
  return this.size += this.has(n) ? 0 : 1, g[n] = nativeCreate && t === void 0 ? HASH_UNDEFINED$1 : t, this;
}
function Hash(n) {
  var t = -1, g = n == null ? 0 : n.length;
  for (this.clear(); ++t < g; ) {
    var d = n[t];
    this.set(d[0], d[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype.delete = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function mapCacheClear() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$1 || ListCache)(),
    string: new Hash()
  };
}
function isKeyable(n) {
  var t = typeof n;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
}
function getMapData(n, t) {
  var g = n.__data__;
  return isKeyable(t) ? g[typeof t == "string" ? "string" : "hash"] : g.map;
}
function mapCacheDelete(n) {
  var t = getMapData(this, n).delete(n);
  return this.size -= t ? 1 : 0, t;
}
function mapCacheGet(n) {
  return getMapData(this, n).get(n);
}
function mapCacheHas(n) {
  return getMapData(this, n).has(n);
}
function mapCacheSet(n, t) {
  var g = getMapData(this, n), d = g.size;
  return g.set(n, t), this.size += g.size == d ? 0 : 1, this;
}
function MapCache(n) {
  var t = -1, g = n == null ? 0 : n.length;
  for (this.clear(); ++t < g; ) {
    var d = n[t];
    this.set(d[0], d[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype.delete = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var LARGE_ARRAY_SIZE = 200;
function stackSet(n, t) {
  var g = this.__data__;
  if (g instanceof ListCache) {
    var d = g.__data__;
    if (!Map$1 || d.length < LARGE_ARRAY_SIZE - 1)
      return d.push([n, t]), this.size = ++g.size, this;
    g = this.__data__ = new MapCache(d);
  }
  return g.set(n, t), this.size = g.size, this;
}
function Stack(n) {
  var t = this.__data__ = new ListCache(n);
  this.size = t.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype.delete = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var defineProperty = (function() {
  try {
    var n = getNative(Object, "defineProperty");
    return n({}, "", {}), n;
  } catch {
  }
})();
function baseAssignValue(n, t, g) {
  t == "__proto__" && defineProperty ? defineProperty(n, t, {
    configurable: !0,
    enumerable: !0,
    value: g,
    writable: !0
  }) : n[t] = g;
}
function assignMergeValue(n, t, g) {
  (g !== void 0 && !eq(n[t], g) || g === void 0 && !(t in n)) && baseAssignValue(n, t, g);
}
function createBaseFor(n) {
  return function(t, g, d) {
    for (var k = -1, H = Object(t), AA = d(t), gA = AA.length; gA--; ) {
      var IA = AA[++k];
      if (g(H[IA], IA, H) === !1)
        break;
    }
    return t;
  };
}
var baseFor = createBaseFor(), freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module, moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2, Buffer$2 = moduleExports$2 ? root$1.Buffer : void 0;
Buffer$2 && Buffer$2.allocUnsafe;
function cloneBuffer(n, t) {
  return n.slice();
}
var Uint8Array$1 = root$1.Uint8Array;
function cloneArrayBuffer(n) {
  var t = new n.constructor(n.byteLength);
  return new Uint8Array$1(t).set(new Uint8Array$1(n)), t;
}
function cloneTypedArray(n, t) {
  var g = cloneArrayBuffer(n.buffer);
  return new n.constructor(g, n.byteOffset, n.length);
}
function copyArray(n, t) {
  var g = -1, d = n.length;
  for (t || (t = Array(d)); ++g < d; )
    t[g] = n[g];
  return t;
}
var objectCreate = Object.create, baseCreate = /* @__PURE__ */ (function() {
  function n() {
  }
  return function(t) {
    if (!isObject$2(t))
      return {};
    if (objectCreate)
      return objectCreate(t);
    n.prototype = t;
    var g = new n();
    return n.prototype = void 0, g;
  };
})();
function overArg(n, t) {
  return function(g) {
    return n(t(g));
  };
}
var getPrototype = overArg(Object.getPrototypeOf, Object), objectProto$9 = Object.prototype;
function isPrototype(n) {
  var t = n && n.constructor, g = typeof t == "function" && t.prototype || objectProto$9;
  return n === g;
}
function initCloneObject(n) {
  return typeof n.constructor == "function" && !isPrototype(n) ? baseCreate(getPrototype(n)) : {};
}
function isObjectLike(n) {
  return n != null && typeof n == "object";
}
var argsTag$2 = "[object Arguments]";
function baseIsArguments(n) {
  return isObjectLike(n) && baseGetTag(n) == argsTag$2;
}
var objectProto$8 = Object.prototype, hasOwnProperty$8 = objectProto$8.hasOwnProperty, propertyIsEnumerable$1 = objectProto$8.propertyIsEnumerable, isArguments = baseIsArguments(/* @__PURE__ */ (function() {
  return arguments;
})()) ? baseIsArguments : function(n) {
  return isObjectLike(n) && hasOwnProperty$8.call(n, "callee") && !propertyIsEnumerable$1.call(n, "callee");
}, isArray$1 = Array.isArray, MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength(n) {
  return typeof n == "number" && n > -1 && n % 1 == 0 && n <= MAX_SAFE_INTEGER$1;
}
function isArrayLike(n) {
  return n != null && isLength(n.length) && !isFunction$3(n);
}
function isArrayLikeObject(n) {
  return isObjectLike(n) && isArrayLike(n);
}
function stubFalse() {
  return !1;
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module, moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1, Buffer$1 = moduleExports$1 ? root$1.Buffer : void 0, nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : void 0, isBuffer$1 = nativeIsBuffer || stubFalse, objectTag$3 = "[object Object]", funcProto = Function.prototype, objectProto$7 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$7 = objectProto$7.hasOwnProperty, objectCtorString = funcToString.call(Object);
function isPlainObject$2(n) {
  if (!isObjectLike(n) || baseGetTag(n) != objectTag$3)
    return !1;
  var t = getPrototype(n);
  if (t === null)
    return !0;
  var g = hasOwnProperty$7.call(t, "constructor") && t.constructor;
  return typeof g == "function" && g instanceof g && funcToString.call(g) == objectCtorString;
}
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$2 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag$1 = "[object WeakMap]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = !1;
function baseIsTypedArray(n) {
  return isObjectLike(n) && isLength(n.length) && !!typedArrayTags[baseGetTag(n)];
}
function baseUnary(n) {
  return function(t) {
    return n(t);
  };
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, freeProcess = moduleExports && freeGlobal.process, nodeUtil = (function() {
  try {
    var n = freeModule && freeModule.require && freeModule.require("util").types;
    return n || freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch {
  }
})(), nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray$1 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
function safeGet(n, t) {
  if (!(t === "constructor" && typeof n[t] == "function") && t != "__proto__")
    return n[t];
}
var objectProto$6 = Object.prototype, hasOwnProperty$6 = objectProto$6.hasOwnProperty;
function assignValue(n, t, g) {
  var d = n[t];
  (!(hasOwnProperty$6.call(n, t) && eq(d, g)) || g === void 0 && !(t in n)) && baseAssignValue(n, t, g);
}
function copyObject(n, t, g, d) {
  var k = !g;
  g || (g = {});
  for (var H = -1, AA = t.length; ++H < AA; ) {
    var gA = t[H], IA = void 0;
    IA === void 0 && (IA = n[gA]), k ? baseAssignValue(g, gA, IA) : assignValue(g, gA, IA);
  }
  return g;
}
function baseTimes(n, t) {
  for (var g = -1, d = Array(n); ++g < n; )
    d[g] = t(g);
  return d;
}
var MAX_SAFE_INTEGER = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(n, t) {
  var g = typeof n;
  return t = t ?? MAX_SAFE_INTEGER, !!t && (g == "number" || g != "symbol" && reIsUint.test(n)) && n > -1 && n % 1 == 0 && n < t;
}
var objectProto$5 = Object.prototype, hasOwnProperty$5 = objectProto$5.hasOwnProperty;
function arrayLikeKeys(n, t) {
  var g = isArray$1(n), d = !g && isArguments(n), k = !g && !d && isBuffer$1(n), H = !g && !d && !k && isTypedArray$1(n), AA = g || d || k || H, gA = AA ? baseTimes(n.length, String) : [], IA = gA.length;
  for (var CA in n)
    (t || hasOwnProperty$5.call(n, CA)) && !(AA && // Safari 9 has enumerable `arguments.length` in strict mode.
    (CA == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    k && (CA == "offset" || CA == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    H && (CA == "buffer" || CA == "byteLength" || CA == "byteOffset") || // Skip index properties.
    isIndex(CA, IA))) && gA.push(CA);
  return gA;
}
function nativeKeysIn(n) {
  var t = [];
  if (n != null)
    for (var g in Object(n))
      t.push(g);
  return t;
}
var objectProto$4 = Object.prototype, hasOwnProperty$4 = objectProto$4.hasOwnProperty;
function baseKeysIn(n) {
  if (!isObject$2(n))
    return nativeKeysIn(n);
  var t = isPrototype(n), g = [];
  for (var d in n)
    d == "constructor" && (t || !hasOwnProperty$4.call(n, d)) || g.push(d);
  return g;
}
function keysIn(n) {
  return isArrayLike(n) ? arrayLikeKeys(n, !0) : baseKeysIn(n);
}
function toPlainObject(n) {
  return copyObject(n, keysIn(n));
}
function baseMergeDeep(n, t, g, d, k, H, AA) {
  var gA = safeGet(n, g), IA = safeGet(t, g), CA = AA.get(IA);
  if (CA) {
    assignMergeValue(n, g, CA);
    return;
  }
  var BA = H ? H(gA, IA, g + "", n, t, AA) : void 0, eA = BA === void 0;
  if (eA) {
    var iA = isArray$1(IA), QA = !iA && isBuffer$1(IA), tA = !iA && !QA && isTypedArray$1(IA);
    BA = IA, iA || QA || tA ? isArray$1(gA) ? BA = gA : isArrayLikeObject(gA) ? BA = copyArray(gA) : QA ? (eA = !1, BA = cloneBuffer(IA)) : tA ? (eA = !1, BA = cloneTypedArray(IA)) : BA = [] : isPlainObject$2(IA) || isArguments(IA) ? (BA = gA, isArguments(gA) ? BA = toPlainObject(gA) : (!isObject$2(gA) || isFunction$3(gA)) && (BA = initCloneObject(IA))) : eA = !1;
  }
  eA && (AA.set(IA, BA), k(BA, IA, d, H, AA), AA.delete(IA)), assignMergeValue(n, g, BA);
}
function baseMerge(n, t, g, d, k) {
  n !== t && baseFor(t, function(H, AA) {
    if (k || (k = new Stack()), isObject$2(H))
      baseMergeDeep(n, t, AA, g, baseMerge, d, k);
    else {
      var gA = d ? d(safeGet(n, AA), H, AA + "", n, t, k) : void 0;
      gA === void 0 && (gA = H), assignMergeValue(n, AA, gA);
    }
  }, keysIn);
}
function identity(n) {
  return n;
}
function apply(n, t, g) {
  switch (g.length) {
    case 0:
      return n.call(t);
    case 1:
      return n.call(t, g[0]);
    case 2:
      return n.call(t, g[0], g[1]);
    case 3:
      return n.call(t, g[0], g[1], g[2]);
  }
  return n.apply(t, g);
}
var nativeMax$1 = Math.max;
function overRest(n, t, g) {
  return t = nativeMax$1(t === void 0 ? n.length - 1 : t, 0), function() {
    for (var d = arguments, k = -1, H = nativeMax$1(d.length - t, 0), AA = Array(H); ++k < H; )
      AA[k] = d[t + k];
    k = -1;
    for (var gA = Array(t + 1); ++k < t; )
      gA[k] = d[k];
    return gA[t] = g(AA), apply(n, this, gA);
  };
}
function constant(n) {
  return function() {
    return n;
  };
}
var baseSetToString = defineProperty ? function(n, t) {
  return defineProperty(n, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant(t),
    writable: !0
  });
} : identity, HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
function shortOut(n) {
  var t = 0, g = 0;
  return function() {
    var d = nativeNow(), k = HOT_SPAN - (d - g);
    if (g = d, k > 0) {
      if (++t >= HOT_COUNT)
        return arguments[0];
    } else
      t = 0;
    return n.apply(void 0, arguments);
  };
}
var setToString = shortOut(baseSetToString);
function baseRest(n, t) {
  return setToString(overRest(n, t, identity), n + "");
}
function isIterateeCall(n, t, g) {
  if (!isObject$2(g))
    return !1;
  var d = typeof t;
  return (d == "number" ? isArrayLike(g) && isIndex(t, g.length) : d == "string" && t in g) ? eq(g[t], n) : !1;
}
function createAssigner(n) {
  return baseRest(function(t, g) {
    var d = -1, k = g.length, H = k > 1 ? g[k - 1] : void 0, AA = k > 2 ? g[2] : void 0;
    for (H = n.length > 3 && typeof H == "function" ? (k--, H) : void 0, AA && isIterateeCall(g[0], g[1], AA) && (H = k < 3 ? void 0 : H, k = 1), t = Object(t); ++d < k; ) {
      var gA = g[d];
      gA && n(t, gA, d, H);
    }
    return t;
  });
}
var merge$1 = createAssigner(function(n, t, g) {
  baseMerge(n, t, g);
}), Raised = function n(t) {
  var g = t.zDepth, d = t.radius, k = t.background, H = t.children, AA = t.styles, gA = AA === void 0 ? {} : AA, IA = reactCSS(merge$1({
    default: {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + g + "px " + g * 4 + "px rgba(0,0,0,.24)",
        borderRadius: d,
        background: k
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    square: {
      bg: {
        borderRadius: "0"
      }
    },
    circle: {
      bg: {
        borderRadius: "50%"
      }
    }
  }, gA), { "zDepth-1": g === 1 });
  return React__default.createElement(
    "div",
    { style: IA.wrap },
    React__default.createElement("div", { style: IA.bg }),
    React__default.createElement(
      "div",
      { style: IA.content },
      H
    )
  );
};
Raised.propTypes = {
  background: PropTypes.string,
  zDepth: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
  radius: PropTypes.number,
  styles: PropTypes.object
};
Raised.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
var now$1 = function() {
  return root$1.Date.now();
}, reWhitespace = /\s/;
function trimmedEndIndex(n) {
  for (var t = n.length; t-- && reWhitespace.test(n.charAt(t)); )
    ;
  return t;
}
var reTrimStart = /^\s+/;
function baseTrim(n) {
  return n && n.slice(0, trimmedEndIndex(n) + 1).replace(reTrimStart, "");
}
var symbolTag$1 = "[object Symbol]";
function isSymbol(n) {
  return typeof n == "symbol" || isObjectLike(n) && baseGetTag(n) == symbolTag$1;
}
var NAN = NaN, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
function toNumber(n) {
  if (typeof n == "number")
    return n;
  if (isSymbol(n))
    return NAN;
  if (isObject$2(n)) {
    var t = typeof n.valueOf == "function" ? n.valueOf() : n;
    n = isObject$2(t) ? t + "" : t;
  }
  if (typeof n != "string")
    return n === 0 ? n : +n;
  n = baseTrim(n);
  var g = reIsBinary.test(n);
  return g || reIsOctal.test(n) ? freeParseInt(n.slice(2), g ? 2 : 8) : reIsBadHex.test(n) ? NAN : +n;
}
var FUNC_ERROR_TEXT$2 = "Expected a function", nativeMax = Math.max, nativeMin = Math.min;
function debounce(n, t, g) {
  var d, k, H, AA, gA, IA, CA = 0, BA = !1, eA = !1, iA = !0;
  if (typeof n != "function")
    throw new TypeError(FUNC_ERROR_TEXT$2);
  t = toNumber(t) || 0, isObject$2(g) && (BA = !!g.leading, eA = "maxWait" in g, H = eA ? nativeMax(toNumber(g.maxWait) || 0, t) : H, iA = "trailing" in g ? !!g.trailing : iA);
  function QA(rA) {
    var uA = d, hA = k;
    return d = k = void 0, CA = rA, AA = n.apply(hA, uA), AA;
  }
  function tA(rA) {
    return CA = rA, gA = setTimeout(aA, t), BA ? QA(rA) : AA;
  }
  function oA(rA) {
    var uA = rA - IA, hA = rA - CA, dA = t - uA;
    return eA ? nativeMin(dA, H - hA) : dA;
  }
  function EA(rA) {
    var uA = rA - IA, hA = rA - CA;
    return IA === void 0 || uA >= t || uA < 0 || eA && hA >= H;
  }
  function aA() {
    var rA = now$1();
    if (EA(rA))
      return nA(rA);
    gA = setTimeout(aA, oA(rA));
  }
  function nA(rA) {
    return gA = void 0, iA && d ? QA(rA) : (d = k = void 0, AA);
  }
  function lA() {
    gA !== void 0 && clearTimeout(gA), CA = 0, d = IA = k = gA = void 0;
  }
  function cA() {
    return gA === void 0 ? AA : nA(now$1());
  }
  function sA() {
    var rA = now$1(), uA = EA(rA);
    if (d = arguments, k = this, IA = rA, uA) {
      if (gA === void 0)
        return tA(IA);
      if (eA)
        return clearTimeout(gA), gA = setTimeout(aA, t), QA(IA);
    }
    return gA === void 0 && (gA = setTimeout(aA, t)), AA;
  }
  return sA.cancel = lA, sA.flush = cA, sA;
}
var FUNC_ERROR_TEXT$1 = "Expected a function";
function throttle$2(n, t, g) {
  var d = !0, k = !0;
  if (typeof n != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  return isObject$2(g) && (d = "leading" in g ? !!g.leading : d, k = "trailing" in g ? !!g.trailing : k), debounce(n, t, {
    leading: d,
    maxWait: t,
    trailing: k
  });
}
var calculateChange = function n(t, g, d) {
  var k = d.getBoundingClientRect(), H = k.width, AA = k.height, gA = typeof t.pageX == "number" ? t.pageX : t.touches[0].pageX, IA = typeof t.pageY == "number" ? t.pageY : t.touches[0].pageY, CA = gA - (d.getBoundingClientRect().left + window.pageXOffset), BA = IA - (d.getBoundingClientRect().top + window.pageYOffset);
  CA < 0 ? CA = 0 : CA > H && (CA = H), BA < 0 ? BA = 0 : BA > AA && (BA = AA);
  var eA = CA / H, iA = 1 - BA / AA;
  return {
    h: g.h,
    s: eA,
    v: iA,
    a: g.a,
    source: "hsv"
  };
}, _createClass$a = /* @__PURE__ */ (function() {
  function n(t, g) {
    for (var d = 0; d < g.length; d++) {
      var k = g[d];
      k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(t, k.key, k);
    }
  }
  return function(t, g, d) {
    return g && n(t.prototype, g), d && n(t, d), t;
  };
})();
function _classCallCheck$a(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$a(n, t) {
  if (!n)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : n;
}
function _inherits$a(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(n, t) : n.__proto__ = t);
}
var Saturation = (function(n) {
  _inherits$a(t, n);
  function t(g) {
    _classCallCheck$a(this, t);
    var d = _possibleConstructorReturn$a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, g));
    return d.handleChange = function(k) {
      typeof d.props.onChange == "function" && d.throttle(d.props.onChange, calculateChange(k, d.props.hsl, d.container), k);
    }, d.handleMouseDown = function(k) {
      d.handleChange(k);
      var H = d.getContainerRenderWindow();
      H.addEventListener("mousemove", d.handleChange), H.addEventListener("mouseup", d.handleMouseUp);
    }, d.handleMouseUp = function() {
      d.unbindEventListeners();
    }, d.throttle = throttle$2(function(k, H, AA) {
      k(H, AA);
    }, 50), d;
  }
  return _createClass$a(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.throttle.cancel(), this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function() {
      for (var d = this.container, k = window; !k.document.contains(d) && k.parent !== k; )
        k = k.parent;
      return k;
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      var d = this.getContainerRenderWindow();
      d.removeEventListener("mousemove", this.handleChange), d.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var d = this, k = this.props.style || {}, H = k.color, AA = k.white, gA = k.black, IA = k.pointer, CA = k.circle, BA = reactCSS({
        default: {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: `0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),
            0 0 1px 2px rgba(0,0,0,.4)`,
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        custom: {
          color: H,
          white: AA,
          black: gA,
          pointer: IA,
          circle: CA
        }
      }, { custom: !!this.props.style });
      return React__default.createElement(
        "div",
        {
          style: BA.color,
          ref: function(iA) {
            return d.container = iA;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        React__default.createElement(
          "style",
          null,
          `
          .saturation-white {
            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
            background: linear-gradient(to right, #fff, rgba(255,255,255,0));
          }
          .saturation-black {
            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));
            background: linear-gradient(to top, #000, rgba(0,0,0,0));
          }
        `
        ),
        React__default.createElement(
          "div",
          { style: BA.white, className: "saturation-white" },
          React__default.createElement("div", { style: BA.black, className: "saturation-black" }),
          React__default.createElement(
            "div",
            { style: BA.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement("div", { style: BA.circle })
          )
        )
      );
    }
  }]), t;
})(PureComponent || Component);
function arrayEach(n, t) {
  for (var g = -1, d = n == null ? 0 : n.length; ++g < d && t(n[g], g, n) !== !1; )
    ;
  return n;
}
var nativeKeys = overArg(Object.keys, Object), objectProto$3 = Object.prototype, hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function baseKeys(n) {
  if (!isPrototype(n))
    return nativeKeys(n);
  var t = [];
  for (var g in Object(n))
    hasOwnProperty$3.call(n, g) && g != "constructor" && t.push(g);
  return t;
}
function keys(n) {
  return isArrayLike(n) ? arrayLikeKeys(n) : baseKeys(n);
}
function baseForOwn(n, t) {
  return n && baseFor(n, t, keys);
}
function createBaseEach(n, t) {
  return function(g, d) {
    if (g == null)
      return g;
    if (!isArrayLike(g))
      return n(g, d);
    for (var k = g.length, H = -1, AA = Object(g); ++H < k && d(AA[H], H, AA) !== !1; )
      ;
    return g;
  };
}
var baseEach = createBaseEach(baseForOwn);
function castFunction(n) {
  return typeof n == "function" ? n : identity;
}
function forEach$1(n, t) {
  var g = isArray$1(n) ? arrayEach : baseEach;
  return g(n, castFunction(t));
}
function _typeof$8(n) {
  "@babel/helpers - typeof";
  return _typeof$8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$8(n);
}
var trimLeft = /^\s+/, trimRight = /\s+$/;
function tinycolor(n, t) {
  if (n = n || "", t = t || {}, n instanceof tinycolor)
    return n;
  if (!(this instanceof tinycolor))
    return new tinycolor(n, t);
  var g = inputToRGB(n);
  this._originalInput = n, this._r = g.r, this._g = g.g, this._b = g.b, this._a = g.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || g.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = g.ok;
}
tinycolor.prototype = {
  isDark: function n() {
    return this.getBrightness() < 128;
  },
  isLight: function n() {
    return !this.isDark();
  },
  isValid: function n() {
    return this._ok;
  },
  getOriginalInput: function n() {
    return this._originalInput;
  },
  getFormat: function n() {
    return this._format;
  },
  getAlpha: function n() {
    return this._a;
  },
  getBrightness: function n() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  },
  getLuminance: function n() {
    var t = this.toRgb(), g, d, k, H, AA, gA;
    return g = t.r / 255, d = t.g / 255, k = t.b / 255, g <= 0.03928 ? H = g / 12.92 : H = Math.pow((g + 0.055) / 1.055, 2.4), d <= 0.03928 ? AA = d / 12.92 : AA = Math.pow((d + 0.055) / 1.055, 2.4), k <= 0.03928 ? gA = k / 12.92 : gA = Math.pow((k + 0.055) / 1.055, 2.4), 0.2126 * H + 0.7152 * AA + 0.0722 * gA;
  },
  setAlpha: function n(t) {
    return this._a = boundAlpha(t), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function n() {
    var t = rgbToHsv(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      v: t.v,
      a: this._a
    };
  },
  toHsvString: function n() {
    var t = rgbToHsv(this._r, this._g, this._b), g = Math.round(t.h * 360), d = Math.round(t.s * 100), k = Math.round(t.v * 100);
    return this._a == 1 ? "hsv(" + g + ", " + d + "%, " + k + "%)" : "hsva(" + g + ", " + d + "%, " + k + "%, " + this._roundA + ")";
  },
  toHsl: function n() {
    var t = rgbToHsl(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      l: t.l,
      a: this._a
    };
  },
  toHslString: function n() {
    var t = rgbToHsl(this._r, this._g, this._b), g = Math.round(t.h * 360), d = Math.round(t.s * 100), k = Math.round(t.l * 100);
    return this._a == 1 ? "hsl(" + g + ", " + d + "%, " + k + "%)" : "hsla(" + g + ", " + d + "%, " + k + "%, " + this._roundA + ")";
  },
  toHex: function n(t) {
    return rgbToHex(this._r, this._g, this._b, t);
  },
  toHexString: function n(t) {
    return "#" + this.toHex(t);
  },
  toHex8: function n(t) {
    return rgbaToHex(this._r, this._g, this._b, this._a, t);
  },
  toHex8String: function n(t) {
    return "#" + this.toHex8(t);
  },
  toRgb: function n() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function n() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function n() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function n() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function n() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : hexNames[rgbToHex(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function n(t) {
    var g = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a), d = g, k = this._gradientType ? "GradientType = 1, " : "";
    if (t) {
      var H = tinycolor(t);
      d = "#" + rgbaToArgbHex(H._r, H._g, H._b, H._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + k + "startColorstr=" + g + ",endColorstr=" + d + ")";
  },
  toString: function n(t) {
    var g = !!t;
    t = t || this._format;
    var d = !1, k = this._a < 1 && this._a >= 0, H = !g && k && (t === "hex" || t === "hex6" || t === "hex3" || t === "hex4" || t === "hex8" || t === "name");
    return H ? t === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (d = this.toRgbString()), t === "prgb" && (d = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (d = this.toHexString()), t === "hex3" && (d = this.toHexString(!0)), t === "hex4" && (d = this.toHex8String(!0)), t === "hex8" && (d = this.toHex8String()), t === "name" && (d = this.toName()), t === "hsl" && (d = this.toHslString()), t === "hsv" && (d = this.toHsvString()), d || this.toHexString());
  },
  clone: function n() {
    return tinycolor(this.toString());
  },
  _applyModification: function n(t, g) {
    var d = t.apply(null, [this].concat([].slice.call(g)));
    return this._r = d._r, this._g = d._g, this._b = d._b, this.setAlpha(d._a), this;
  },
  lighten: function n() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function n() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function n() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function n() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function n() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function n() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function n() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function n(t, g) {
    return t.apply(null, [this].concat([].slice.call(g)));
  },
  analogous: function n() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function n() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function n() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function n() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function n() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function n() {
    return this._applyCombination(polyad, [4]);
  }
};
tinycolor.fromRatio = function(n, t) {
  if (_typeof$8(n) == "object") {
    var g = {};
    for (var d in n)
      n.hasOwnProperty(d) && (d === "a" ? g[d] = n[d] : g[d] = convertToPercentage(n[d]));
    n = g;
  }
  return tinycolor(n, t);
};
function inputToRGB(n) {
  var t = {
    r: 0,
    g: 0,
    b: 0
  }, g = 1, d = null, k = null, H = null, AA = !1, gA = !1;
  return typeof n == "string" && (n = stringInputToObject(n)), _typeof$8(n) == "object" && (isValidCSSUnit(n.r) && isValidCSSUnit(n.g) && isValidCSSUnit(n.b) ? (t = rgbToRgb(n.r, n.g, n.b), AA = !0, gA = String(n.r).substr(-1) === "%" ? "prgb" : "rgb") : isValidCSSUnit(n.h) && isValidCSSUnit(n.s) && isValidCSSUnit(n.v) ? (d = convertToPercentage(n.s), k = convertToPercentage(n.v), t = hsvToRgb(n.h, d, k), AA = !0, gA = "hsv") : isValidCSSUnit(n.h) && isValidCSSUnit(n.s) && isValidCSSUnit(n.l) && (d = convertToPercentage(n.s), H = convertToPercentage(n.l), t = hslToRgb(n.h, d, H), AA = !0, gA = "hsl"), n.hasOwnProperty("a") && (g = n.a)), g = boundAlpha(g), {
    ok: AA,
    format: n.format || gA,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: g
  };
}
function rgbToRgb(n, t, g) {
  return {
    r: bound01(n, 255) * 255,
    g: bound01(t, 255) * 255,
    b: bound01(g, 255) * 255
  };
}
function rgbToHsl(n, t, g) {
  n = bound01(n, 255), t = bound01(t, 255), g = bound01(g, 255);
  var d = Math.max(n, t, g), k = Math.min(n, t, g), H, AA, gA = (d + k) / 2;
  if (d == k)
    H = AA = 0;
  else {
    var IA = d - k;
    switch (AA = gA > 0.5 ? IA / (2 - d - k) : IA / (d + k), d) {
      case n:
        H = (t - g) / IA + (t < g ? 6 : 0);
        break;
      case t:
        H = (g - n) / IA + 2;
        break;
      case g:
        H = (n - t) / IA + 4;
        break;
    }
    H /= 6;
  }
  return {
    h: H,
    s: AA,
    l: gA
  };
}
function hslToRgb(n, t, g) {
  var d, k, H;
  n = bound01(n, 360), t = bound01(t, 100), g = bound01(g, 100);
  function AA(CA, BA, eA) {
    return eA < 0 && (eA += 1), eA > 1 && (eA -= 1), eA < 1 / 6 ? CA + (BA - CA) * 6 * eA : eA < 1 / 2 ? BA : eA < 2 / 3 ? CA + (BA - CA) * (2 / 3 - eA) * 6 : CA;
  }
  if (t === 0)
    d = k = H = g;
  else {
    var gA = g < 0.5 ? g * (1 + t) : g + t - g * t, IA = 2 * g - gA;
    d = AA(IA, gA, n + 1 / 3), k = AA(IA, gA, n), H = AA(IA, gA, n - 1 / 3);
  }
  return {
    r: d * 255,
    g: k * 255,
    b: H * 255
  };
}
function rgbToHsv(n, t, g) {
  n = bound01(n, 255), t = bound01(t, 255), g = bound01(g, 255);
  var d = Math.max(n, t, g), k = Math.min(n, t, g), H, AA, gA = d, IA = d - k;
  if (AA = d === 0 ? 0 : IA / d, d == k)
    H = 0;
  else {
    switch (d) {
      case n:
        H = (t - g) / IA + (t < g ? 6 : 0);
        break;
      case t:
        H = (g - n) / IA + 2;
        break;
      case g:
        H = (n - t) / IA + 4;
        break;
    }
    H /= 6;
  }
  return {
    h: H,
    s: AA,
    v: gA
  };
}
function hsvToRgb(n, t, g) {
  n = bound01(n, 360) * 6, t = bound01(t, 100), g = bound01(g, 100);
  var d = Math.floor(n), k = n - d, H = g * (1 - t), AA = g * (1 - k * t), gA = g * (1 - (1 - k) * t), IA = d % 6, CA = [g, AA, H, H, gA, g][IA], BA = [gA, g, g, AA, H, H][IA], eA = [H, H, gA, g, g, AA][IA];
  return {
    r: CA * 255,
    g: BA * 255,
    b: eA * 255
  };
}
function rgbToHex(n, t, g, d) {
  var k = [pad2(Math.round(n).toString(16)), pad2(Math.round(t).toString(16)), pad2(Math.round(g).toString(16))];
  return d && k[0].charAt(0) == k[0].charAt(1) && k[1].charAt(0) == k[1].charAt(1) && k[2].charAt(0) == k[2].charAt(1) ? k[0].charAt(0) + k[1].charAt(0) + k[2].charAt(0) : k.join("");
}
function rgbaToHex(n, t, g, d, k) {
  var H = [pad2(Math.round(n).toString(16)), pad2(Math.round(t).toString(16)), pad2(Math.round(g).toString(16)), pad2(convertDecimalToHex(d))];
  return k && H[0].charAt(0) == H[0].charAt(1) && H[1].charAt(0) == H[1].charAt(1) && H[2].charAt(0) == H[2].charAt(1) && H[3].charAt(0) == H[3].charAt(1) ? H[0].charAt(0) + H[1].charAt(0) + H[2].charAt(0) + H[3].charAt(0) : H.join("");
}
function rgbaToArgbHex(n, t, g, d) {
  var k = [pad2(convertDecimalToHex(d)), pad2(Math.round(n).toString(16)), pad2(Math.round(t).toString(16)), pad2(Math.round(g).toString(16))];
  return k.join("");
}
tinycolor.equals = function(n, t) {
  return !n || !t ? !1 : tinycolor(n).toRgbString() == tinycolor(t).toRgbString();
};
tinycolor.random = function() {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function _desaturate(n, t) {
  t = t === 0 ? 0 : t || 10;
  var g = tinycolor(n).toHsl();
  return g.s -= t / 100, g.s = clamp01(g.s), tinycolor(g);
}
function _saturate(n, t) {
  t = t === 0 ? 0 : t || 10;
  var g = tinycolor(n).toHsl();
  return g.s += t / 100, g.s = clamp01(g.s), tinycolor(g);
}
function _greyscale(n) {
  return tinycolor(n).desaturate(100);
}
function _lighten(n, t) {
  t = t === 0 ? 0 : t || 10;
  var g = tinycolor(n).toHsl();
  return g.l += t / 100, g.l = clamp01(g.l), tinycolor(g);
}
function _brighten(n, t) {
  t = t === 0 ? 0 : t || 10;
  var g = tinycolor(n).toRgb();
  return g.r = Math.max(0, Math.min(255, g.r - Math.round(255 * -(t / 100)))), g.g = Math.max(0, Math.min(255, g.g - Math.round(255 * -(t / 100)))), g.b = Math.max(0, Math.min(255, g.b - Math.round(255 * -(t / 100)))), tinycolor(g);
}
function _darken(n, t) {
  t = t === 0 ? 0 : t || 10;
  var g = tinycolor(n).toHsl();
  return g.l -= t / 100, g.l = clamp01(g.l), tinycolor(g);
}
function _spin(n, t) {
  var g = tinycolor(n).toHsl(), d = (g.h + t) % 360;
  return g.h = d < 0 ? 360 + d : d, tinycolor(g);
}
function _complement(n) {
  var t = tinycolor(n).toHsl();
  return t.h = (t.h + 180) % 360, tinycolor(t);
}
function polyad(n, t) {
  if (isNaN(t) || t <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var g = tinycolor(n).toHsl(), d = [tinycolor(n)], k = 360 / t, H = 1; H < t; H++)
    d.push(tinycolor({
      h: (g.h + H * k) % 360,
      s: g.s,
      l: g.l
    }));
  return d;
}
function _splitcomplement(n) {
  var t = tinycolor(n).toHsl(), g = t.h;
  return [tinycolor(n), tinycolor({
    h: (g + 72) % 360,
    s: t.s,
    l: t.l
  }), tinycolor({
    h: (g + 216) % 360,
    s: t.s,
    l: t.l
  })];
}
function _analogous(n, t, g) {
  t = t || 6, g = g || 30;
  var d = tinycolor(n).toHsl(), k = 360 / g, H = [tinycolor(n)];
  for (d.h = (d.h - (k * t >> 1) + 720) % 360; --t; )
    d.h = (d.h + k) % 360, H.push(tinycolor(d));
  return H;
}
function _monochromatic(n, t) {
  t = t || 6;
  for (var g = tinycolor(n).toHsv(), d = g.h, k = g.s, H = g.v, AA = [], gA = 1 / t; t--; )
    AA.push(tinycolor({
      h: d,
      s: k,
      v: H
    })), H = (H + gA) % 1;
  return AA;
}
tinycolor.mix = function(n, t, g) {
  g = g === 0 ? 0 : g || 50;
  var d = tinycolor(n).toRgb(), k = tinycolor(t).toRgb(), H = g / 100, AA = {
    r: (k.r - d.r) * H + d.r,
    g: (k.g - d.g) * H + d.g,
    b: (k.b - d.b) * H + d.b,
    a: (k.a - d.a) * H + d.a
  };
  return tinycolor(AA);
};
tinycolor.readability = function(n, t) {
  var g = tinycolor(n), d = tinycolor(t);
  return (Math.max(g.getLuminance(), d.getLuminance()) + 0.05) / (Math.min(g.getLuminance(), d.getLuminance()) + 0.05);
};
tinycolor.isReadable = function(n, t, g) {
  var d = tinycolor.readability(n, t), k, H;
  switch (H = !1, k = validateWCAG2Parms(g), k.level + k.size) {
    case "AAsmall":
    case "AAAlarge":
      H = d >= 4.5;
      break;
    case "AAlarge":
      H = d >= 3;
      break;
    case "AAAsmall":
      H = d >= 7;
      break;
  }
  return H;
};
tinycolor.mostReadable = function(n, t, g) {
  var d = null, k = 0, H, AA, gA, IA;
  g = g || {}, AA = g.includeFallbackColors, gA = g.level, IA = g.size;
  for (var CA = 0; CA < t.length; CA++)
    H = tinycolor.readability(n, t[CA]), H > k && (k = H, d = tinycolor(t[CA]));
  return tinycolor.isReadable(n, d, {
    level: gA,
    size: IA
  }) || !AA ? d : (g.includeFallbackColors = !1, tinycolor.mostReadable(n, ["#fff", "#000"], g));
};
var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, hexNames = tinycolor.hexNames = flip(names);
function flip(n) {
  var t = {};
  for (var g in n)
    n.hasOwnProperty(g) && (t[n[g]] = g);
  return t;
}
function boundAlpha(n) {
  return n = parseFloat(n), (isNaN(n) || n < 0 || n > 1) && (n = 1), n;
}
function bound01(n, t) {
  isOnePointZero(n) && (n = "100%");
  var g = isPercentage(n);
  return n = Math.min(t, Math.max(0, parseFloat(n))), g && (n = parseInt(n * t, 10) / 100), Math.abs(n - t) < 1e-6 ? 1 : n % t / parseFloat(t);
}
function clamp01(n) {
  return Math.min(1, Math.max(0, n));
}
function parseIntFromHex(n) {
  return parseInt(n, 16);
}
function isOnePointZero(n) {
  return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
function isPercentage(n) {
  return typeof n == "string" && n.indexOf("%") != -1;
}
function pad2(n) {
  return n.length == 1 ? "0" + n : "" + n;
}
function convertToPercentage(n) {
  return n <= 1 && (n = n * 100 + "%"), n;
}
function convertDecimalToHex(n) {
  return Math.round(parseFloat(n) * 255).toString(16);
}
function convertHexToDecimal(n) {
  return parseIntFromHex(n) / 255;
}
var matchers = (function() {
  var n = "[-\\+]?\\d+%?", t = "[-\\+]?\\d*\\.\\d+%?", g = "(?:" + t + ")|(?:" + n + ")", d = "[\\s|\\(]+(" + g + ")[,|\\s]+(" + g + ")[,|\\s]+(" + g + ")\\s*\\)?", k = "[\\s|\\(]+(" + g + ")[,|\\s]+(" + g + ")[,|\\s]+(" + g + ")[,|\\s]+(" + g + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(g),
    rgb: new RegExp("rgb" + d),
    rgba: new RegExp("rgba" + k),
    hsl: new RegExp("hsl" + d),
    hsla: new RegExp("hsla" + k),
    hsv: new RegExp("hsv" + d),
    hsva: new RegExp("hsva" + k),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
})();
function isValidCSSUnit(n) {
  return !!matchers.CSS_UNIT.exec(n);
}
function stringInputToObject(n) {
  n = n.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var t = !1;
  if (names[n])
    n = names[n], t = !0;
  else if (n == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var g;
  return (g = matchers.rgb.exec(n)) ? {
    r: g[1],
    g: g[2],
    b: g[3]
  } : (g = matchers.rgba.exec(n)) ? {
    r: g[1],
    g: g[2],
    b: g[3],
    a: g[4]
  } : (g = matchers.hsl.exec(n)) ? {
    h: g[1],
    s: g[2],
    l: g[3]
  } : (g = matchers.hsla.exec(n)) ? {
    h: g[1],
    s: g[2],
    l: g[3],
    a: g[4]
  } : (g = matchers.hsv.exec(n)) ? {
    h: g[1],
    s: g[2],
    v: g[3]
  } : (g = matchers.hsva.exec(n)) ? {
    h: g[1],
    s: g[2],
    v: g[3],
    a: g[4]
  } : (g = matchers.hex8.exec(n)) ? {
    r: parseIntFromHex(g[1]),
    g: parseIntFromHex(g[2]),
    b: parseIntFromHex(g[3]),
    a: convertHexToDecimal(g[4]),
    format: t ? "name" : "hex8"
  } : (g = matchers.hex6.exec(n)) ? {
    r: parseIntFromHex(g[1]),
    g: parseIntFromHex(g[2]),
    b: parseIntFromHex(g[3]),
    format: t ? "name" : "hex"
  } : (g = matchers.hex4.exec(n)) ? {
    r: parseIntFromHex(g[1] + "" + g[1]),
    g: parseIntFromHex(g[2] + "" + g[2]),
    b: parseIntFromHex(g[3] + "" + g[3]),
    a: convertHexToDecimal(g[4] + "" + g[4]),
    format: t ? "name" : "hex8"
  } : (g = matchers.hex3.exec(n)) ? {
    r: parseIntFromHex(g[1] + "" + g[1]),
    g: parseIntFromHex(g[2] + "" + g[2]),
    b: parseIntFromHex(g[3] + "" + g[3]),
    format: t ? "name" : "hex"
  } : !1;
}
function validateWCAG2Parms(n) {
  var t, g;
  return n = n || {
    level: "AA",
    size: "small"
  }, t = (n.level || "AA").toUpperCase(), g = (n.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), g !== "small" && g !== "large" && (g = "small"), {
    level: t,
    size: g
  };
}
var simpleCheckForValidColor = function n(t) {
  var g = ["r", "g", "b", "a", "h", "s", "l", "v"], d = 0, k = 0;
  return forEach$1(g, function(H) {
    if (t[H] && (d += 1, isNaN(t[H]) || (k += 1), H === "s" || H === "l")) {
      var AA = /^\d+%$/;
      AA.test(t[H]) && (k += 1);
    }
  }), d === k ? t : !1;
}, toState = function n(t, g) {
  var d = t.hex ? tinycolor(t.hex) : tinycolor(t), k = d.toHsl(), H = d.toHsv(), AA = d.toRgb(), gA = d.toHex();
  k.s === 0 && (k.h = g || 0, H.h = g || 0);
  var IA = gA === "000000" && AA.a === 0;
  return {
    hsl: k,
    hex: IA ? "transparent" : "#" + gA,
    rgb: AA,
    hsv: H,
    oldHue: t.h || g || k.h,
    source: t.source
  };
}, isValidHex = function n(t) {
  if (t === "transparent")
    return !0;
  var g = String(t).charAt(0) === "#" ? 1 : 0;
  return t.length !== 4 + g && t.length < 7 + g && tinycolor(t).isValid();
}, getContrastingColor = function n(t) {
  if (!t)
    return "#fff";
  var g = toState(t);
  if (g.hex === "transparent")
    return "rgba(0,0,0,0.4)";
  var d = (g.rgb.r * 299 + g.rgb.g * 587 + g.rgb.b * 114) / 1e3;
  return d >= 128 ? "#000" : "#fff";
}, isvalidColorString = function n(t, g) {
  var d = t.replace("°", "");
  return tinycolor(g + " (" + d + ")")._ok;
}, _extends$p = Object.assign || function(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t];
    for (var d in g)
      Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
  }
  return n;
}, _createClass$9 = /* @__PURE__ */ (function() {
  function n(t, g) {
    for (var d = 0; d < g.length; d++) {
      var k = g[d];
      k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(t, k.key, k);
    }
  }
  return function(t, g, d) {
    return g && n(t.prototype, g), d && n(t, d), t;
  };
})();
function _classCallCheck$9(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$9(n, t) {
  if (!n)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : n;
}
function _inherits$9(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(n, t) : n.__proto__ = t);
}
var ColorWrap = function n(t) {
  var g = (function(d) {
    _inherits$9(k, d);
    function k(H) {
      _classCallCheck$9(this, k);
      var AA = _possibleConstructorReturn$9(this, (k.__proto__ || Object.getPrototypeOf(k)).call(this));
      return AA.handleChange = function(gA, IA) {
        var CA = simpleCheckForValidColor(gA);
        if (CA) {
          var BA = toState(gA, gA.h || AA.state.oldHue);
          AA.setState(BA), AA.props.onChangeComplete && AA.debounce(AA.props.onChangeComplete, BA, IA), AA.props.onChange && AA.props.onChange(BA, IA);
        }
      }, AA.handleSwatchHover = function(gA, IA) {
        var CA = simpleCheckForValidColor(gA);
        if (CA) {
          var BA = toState(gA, gA.h || AA.state.oldHue);
          AA.props.onSwatchHover && AA.props.onSwatchHover(BA, IA);
        }
      }, AA.state = _extends$p({}, toState(H.color, 0)), AA.debounce = debounce(function(gA, IA, CA) {
        gA(IA, CA);
      }, 100), AA;
    }
    return _createClass$9(k, [{
      key: "render",
      value: function() {
        var AA = {};
        return this.props.onSwatchHover && (AA.onSwatchHover = this.handleSwatchHover), React__default.createElement(t, _extends$p({}, this.props, this.state, {
          onChange: this.handleChange
        }, AA));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(AA, gA) {
        return _extends$p({}, toState(AA.color, gA.oldHue));
      }
    }]), k;
  })(PureComponent || Component);
  return g.propTypes = _extends$p({}, t.propTypes), g.defaultProps = _extends$p({}, t.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  }), g;
}, _extends$o = Object.assign || function(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t];
    for (var d in g)
      Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
  }
  return n;
}, _createClass$8 = /* @__PURE__ */ (function() {
  function n(t, g) {
    for (var d = 0; d < g.length; d++) {
      var k = g[d];
      k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(t, k.key, k);
    }
  }
  return function(t, g, d) {
    return g && n(t.prototype, g), d && n(t, d), t;
  };
})();
function _classCallCheck$8(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$8(n, t) {
  if (!n)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : n;
}
function _inherits$8(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(n, t) : n.__proto__ = t);
}
var handleFocus = function n(t) {
  var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return (function(d) {
    _inherits$8(k, d);
    function k() {
      var H, AA, gA, IA;
      _classCallCheck$8(this, k);
      for (var CA = arguments.length, BA = Array(CA), eA = 0; eA < CA; eA++)
        BA[eA] = arguments[eA];
      return IA = (AA = (gA = _possibleConstructorReturn$8(this, (H = k.__proto__ || Object.getPrototypeOf(k)).call.apply(H, [this].concat(BA))), gA), gA.state = { focus: !1 }, gA.handleFocus = function() {
        return gA.setState({ focus: !0 });
      }, gA.handleBlur = function() {
        return gA.setState({ focus: !1 });
      }, AA), _possibleConstructorReturn$8(gA, IA);
    }
    return _createClass$8(k, [{
      key: "render",
      value: function() {
        return React__default.createElement(
          g,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          React__default.createElement(t, _extends$o({}, this.props, this.state))
        );
      }
    }]), k;
  })(React__default.Component);
}, _extends$n = Object.assign || function(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t];
    for (var d in g)
      Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
  }
  return n;
}, ENTER = 13, Swatch = function n(t) {
  var g = t.color, d = t.style, k = t.onClick, H = k === void 0 ? function() {
  } : k, AA = t.onHover, gA = t.title, IA = gA === void 0 ? g : gA, CA = t.children, BA = t.focus, eA = t.focusStyle, iA = eA === void 0 ? {} : eA, QA = g === "transparent", tA = reactCSS({
    default: {
      swatch: _extends$n({
        background: g,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, d, BA ? iA : {})
    }
  }), oA = function(cA) {
    return H(g, cA);
  }, EA = function(cA) {
    return cA.keyCode === ENTER && H(g, cA);
  }, aA = function(cA) {
    return AA(g, cA);
  }, nA = {};
  return AA && (nA.onMouseOver = aA), React__default.createElement(
    "div",
    _extends$n({
      style: tA.swatch,
      onClick: oA,
      title: IA,
      tabIndex: 0,
      onKeyDown: EA
    }, nA),
    CA,
    QA && React__default.createElement(Checkboard, {
      borderRadius: tA.swatch.borderRadius,
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    })
  );
};
const Swatch$1 = handleFocus(Swatch);
var AlphaPointer = function n(t) {
  var g = t.direction, d = reactCSS({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: g === "vertical" });
  return React__default.createElement("div", { style: d.picker });
}, _extends$m = Object.assign || function(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t];
    for (var d in g)
      Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
  }
  return n;
}, AlphaPicker = function n(t) {
  var g = t.rgb, d = t.hsl, k = t.width, H = t.height, AA = t.onChange, gA = t.direction, IA = t.style, CA = t.renderers, BA = t.pointer, eA = t.className, iA = eA === void 0 ? "" : eA, QA = reactCSS({
    default: {
      picker: {
        position: "relative",
        width: k,
        height: H
      },
      alpha: {
        radius: "2px",
        style: IA
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: QA.picker, className: "alpha-picker " + iA },
    React__default.createElement(Alpha, _extends$m({}, QA.alpha, {
      rgb: g,
      hsl: d,
      pointer: BA,
      renderers: CA,
      onChange: AA,
      direction: gA
    }))
  );
};
AlphaPicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: AlphaPointer
};
ColorWrap(AlphaPicker);
function arrayMap(n, t) {
  for (var g = -1, d = n == null ? 0 : n.length, k = Array(d); ++g < d; )
    k[g] = t(n[g], g, n);
  return k;
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(n) {
  return this.__data__.set(n, HASH_UNDEFINED), this;
}
function setCacheHas(n) {
  return this.__data__.has(n);
}
function SetCache(n) {
  var t = -1, g = n == null ? 0 : n.length;
  for (this.__data__ = new MapCache(); ++t < g; )
    this.add(n[t]);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(n, t) {
  for (var g = -1, d = n == null ? 0 : n.length; ++g < d; )
    if (t(n[g], g, n))
      return !0;
  return !1;
}
function cacheHas(n, t) {
  return n.has(t);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(n, t, g, d, k, H) {
  var AA = g & COMPARE_PARTIAL_FLAG$5, gA = n.length, IA = t.length;
  if (gA != IA && !(AA && IA > gA))
    return !1;
  var CA = H.get(n), BA = H.get(t);
  if (CA && BA)
    return CA == t && BA == n;
  var eA = -1, iA = !0, QA = g & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (H.set(n, t), H.set(t, n); ++eA < gA; ) {
    var tA = n[eA], oA = t[eA];
    if (d)
      var EA = AA ? d(oA, tA, eA, t, n, H) : d(tA, oA, eA, n, t, H);
    if (EA !== void 0) {
      if (EA)
        continue;
      iA = !1;
      break;
    }
    if (QA) {
      if (!arraySome(t, function(aA, nA) {
        if (!cacheHas(QA, nA) && (tA === aA || k(tA, aA, g, d, H)))
          return QA.push(nA);
      })) {
        iA = !1;
        break;
      }
    } else if (!(tA === oA || k(tA, oA, g, d, H))) {
      iA = !1;
      break;
    }
  }
  return H.delete(n), H.delete(t), iA;
}
function mapToArray(n) {
  var t = -1, g = Array(n.size);
  return n.forEach(function(d, k) {
    g[++t] = [k, d];
  }), g;
}
function setToArray(n) {
  var t = -1, g = Array(n.size);
  return n.forEach(function(d) {
    g[++t] = d;
  }), g;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function equalByTag(n, t, g, d, k, H, AA) {
  switch (g) {
    case dataViewTag$1:
      if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset)
        return !1;
      n = n.buffer, t = t.buffer;
    case arrayBufferTag:
      return !(n.byteLength != t.byteLength || !H(new Uint8Array$1(n), new Uint8Array$1(t)));
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+n, +t);
    case errorTag:
      return n.name == t.name && n.message == t.message;
    case regexpTag:
    case stringTag:
      return n == t + "";
    case mapTag$1:
      var gA = mapToArray;
    case setTag$1:
      var IA = d & COMPARE_PARTIAL_FLAG$4;
      if (gA || (gA = setToArray), n.size != t.size && !IA)
        return !1;
      var CA = AA.get(n);
      if (CA)
        return CA == t;
      d |= COMPARE_UNORDERED_FLAG$2, AA.set(n, t);
      var BA = equalArrays(gA(n), gA(t), d, k, H, AA);
      return AA.delete(n), BA;
    case symbolTag:
      if (symbolValueOf)
        return symbolValueOf.call(n) == symbolValueOf.call(t);
  }
  return !1;
}
function arrayPush(n, t) {
  for (var g = -1, d = t.length, k = n.length; ++g < d; )
    n[k + g] = t[g];
  return n;
}
function baseGetAllKeys(n, t, g) {
  var d = t(n);
  return isArray$1(n) ? d : arrayPush(d, g(n));
}
function arrayFilter(n, t) {
  for (var g = -1, d = n == null ? 0 : n.length, k = 0, H = []; ++g < d; ) {
    var AA = n[g];
    t(AA, g, n) && (H[k++] = AA);
  }
  return H;
}
function stubArray() {
  return [];
}
var objectProto$2 = Object.prototype, propertyIsEnumerable = objectProto$2.propertyIsEnumerable, nativeGetSymbols = Object.getOwnPropertySymbols, getSymbols = nativeGetSymbols ? function(n) {
  return n == null ? [] : (n = Object(n), arrayFilter(nativeGetSymbols(n), function(t) {
    return propertyIsEnumerable.call(n, t);
  }));
} : stubArray;
function getAllKeys(n) {
  return baseGetAllKeys(n, keys, getSymbols);
}
var COMPARE_PARTIAL_FLAG$3 = 1, objectProto$1 = Object.prototype, hasOwnProperty$2 = objectProto$1.hasOwnProperty;
function equalObjects(n, t, g, d, k, H) {
  var AA = g & COMPARE_PARTIAL_FLAG$3, gA = getAllKeys(n), IA = gA.length, CA = getAllKeys(t), BA = CA.length;
  if (IA != BA && !AA)
    return !1;
  for (var eA = IA; eA--; ) {
    var iA = gA[eA];
    if (!(AA ? iA in t : hasOwnProperty$2.call(t, iA)))
      return !1;
  }
  var QA = H.get(n), tA = H.get(t);
  if (QA && tA)
    return QA == t && tA == n;
  var oA = !0;
  H.set(n, t), H.set(t, n);
  for (var EA = AA; ++eA < IA; ) {
    iA = gA[eA];
    var aA = n[iA], nA = t[iA];
    if (d)
      var lA = AA ? d(nA, aA, iA, t, n, H) : d(aA, nA, iA, n, t, H);
    if (!(lA === void 0 ? aA === nA || k(aA, nA, g, d, H) : lA)) {
      oA = !1;
      break;
    }
    EA || (EA = iA == "constructor");
  }
  if (oA && !EA) {
    var cA = n.constructor, sA = t.constructor;
    cA != sA && "constructor" in n && "constructor" in t && !(typeof cA == "function" && cA instanceof cA && typeof sA == "function" && sA instanceof sA) && (oA = !1);
  }
  return H.delete(n), H.delete(t), oA;
}
var DataView$1 = getNative(root$1, "DataView"), Promise$1 = getNative(root$1, "Promise"), Set$1 = getNative(root$1, "Set"), WeakMap$1 = getNative(root$1, "WeakMap"), mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]", dataViewTag = "[object DataView]", dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1), getTag = baseGetTag;
(DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag(new Map$1()) != mapTag || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag) && (getTag = function(n) {
  var t = baseGetTag(n), g = t == objectTag$1 ? n.constructor : void 0, d = g ? toSource(g) : "";
  if (d)
    switch (d) {
      case dataViewCtorString:
        return dataViewTag;
      case mapCtorString:
        return mapTag;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag;
      case weakMapCtorString:
        return weakMapTag;
    }
  return t;
});
var COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto = Object.prototype, hasOwnProperty$1 = objectProto.hasOwnProperty;
function baseIsEqualDeep(n, t, g, d, k, H) {
  var AA = isArray$1(n), gA = isArray$1(t), IA = AA ? arrayTag : getTag(n), CA = gA ? arrayTag : getTag(t);
  IA = IA == argsTag ? objectTag : IA, CA = CA == argsTag ? objectTag : CA;
  var BA = IA == objectTag, eA = CA == objectTag, iA = IA == CA;
  if (iA && isBuffer$1(n)) {
    if (!isBuffer$1(t))
      return !1;
    AA = !0, BA = !1;
  }
  if (iA && !BA)
    return H || (H = new Stack()), AA || isTypedArray$1(n) ? equalArrays(n, t, g, d, k, H) : equalByTag(n, t, IA, g, d, k, H);
  if (!(g & COMPARE_PARTIAL_FLAG$2)) {
    var QA = BA && hasOwnProperty$1.call(n, "__wrapped__"), tA = eA && hasOwnProperty$1.call(t, "__wrapped__");
    if (QA || tA) {
      var oA = QA ? n.value() : n, EA = tA ? t.value() : t;
      return H || (H = new Stack()), k(oA, EA, g, d, H);
    }
  }
  return iA ? (H || (H = new Stack()), equalObjects(n, t, g, d, k, H)) : !1;
}
function baseIsEqual(n, t, g, d, k) {
  return n === t ? !0 : n == null || t == null || !isObjectLike(n) && !isObjectLike(t) ? n !== n && t !== t : baseIsEqualDeep(n, t, g, d, baseIsEqual, k);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(n, t, g, d) {
  var k = g.length, H = k;
  if (n == null)
    return !H;
  for (n = Object(n); k--; ) {
    var AA = g[k];
    if (AA[2] ? AA[1] !== n[AA[0]] : !(AA[0] in n))
      return !1;
  }
  for (; ++k < H; ) {
    AA = g[k];
    var gA = AA[0], IA = n[gA], CA = AA[1];
    if (AA[2]) {
      if (IA === void 0 && !(gA in n))
        return !1;
    } else {
      var BA = new Stack(), eA;
      if (!(eA === void 0 ? baseIsEqual(CA, IA, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, d, BA) : eA))
        return !1;
    }
  }
  return !0;
}
function isStrictComparable(n) {
  return n === n && !isObject$2(n);
}
function getMatchData(n) {
  for (var t = keys(n), g = t.length; g--; ) {
    var d = t[g], k = n[d];
    t[g] = [d, k, isStrictComparable(k)];
  }
  return t;
}
function matchesStrictComparable(n, t) {
  return function(g) {
    return g == null ? !1 : g[n] === t && (t !== void 0 || n in Object(g));
  };
}
function baseMatches(n) {
  var t = getMatchData(n);
  return t.length == 1 && t[0][2] ? matchesStrictComparable(t[0][0], t[0][1]) : function(g) {
    return g === n || baseIsMatch(g, n, t);
  };
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(n, t) {
  if (isArray$1(n))
    return !1;
  var g = typeof n;
  return g == "number" || g == "symbol" || g == "boolean" || n == null || isSymbol(n) ? !0 : reIsPlainProp.test(n) || !reIsDeepProp.test(n) || t != null && n in Object(t);
}
var FUNC_ERROR_TEXT = "Expected a function";
function memoize(n, t) {
  if (typeof n != "function" || t != null && typeof t != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  var g = function() {
    var d = arguments, k = t ? t.apply(this, d) : d[0], H = g.cache;
    if (H.has(k))
      return H.get(k);
    var AA = n.apply(this, d);
    return g.cache = H.set(k, AA) || H, AA;
  };
  return g.cache = new (memoize.Cache || MapCache)(), g;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(n) {
  var t = memoize(n, function(d) {
    return g.size === MAX_MEMOIZE_SIZE && g.clear(), d;
  }), g = t.cache;
  return t;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = memoizeCapped(function(n) {
  var t = [];
  return n.charCodeAt(0) === 46 && t.push(""), n.replace(rePropName, function(g, d, k, H) {
    t.push(k ? H.replace(reEscapeChar, "$1") : d || g);
  }), t;
}), symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString(n) {
  if (typeof n == "string")
    return n;
  if (isArray$1(n))
    return arrayMap(n, baseToString) + "";
  if (isSymbol(n))
    return symbolToString ? symbolToString.call(n) : "";
  var t = n + "";
  return t == "0" && 1 / n == -1 / 0 ? "-0" : t;
}
function toString$2(n) {
  return n == null ? "" : baseToString(n);
}
function castPath(n, t) {
  return isArray$1(n) ? n : isKey(n, t) ? [n] : stringToPath(toString$2(n));
}
function toKey(n) {
  if (typeof n == "string" || isSymbol(n))
    return n;
  var t = n + "";
  return t == "0" && 1 / n == -1 / 0 ? "-0" : t;
}
function baseGet(n, t) {
  t = castPath(t, n);
  for (var g = 0, d = t.length; n != null && g < d; )
    n = n[toKey(t[g++])];
  return g && g == d ? n : void 0;
}
function get(n, t, g) {
  var d = n == null ? void 0 : baseGet(n, t);
  return d === void 0 ? g : d;
}
function baseHasIn(n, t) {
  return n != null && t in Object(n);
}
function hasPath(n, t, g) {
  t = castPath(t, n);
  for (var d = -1, k = t.length, H = !1; ++d < k; ) {
    var AA = toKey(t[d]);
    if (!(H = n != null && g(n, AA)))
      break;
    n = n[AA];
  }
  return H || ++d != k ? H : (k = n == null ? 0 : n.length, !!k && isLength(k) && isIndex(AA, k) && (isArray$1(n) || isArguments(n)));
}
function hasIn(n, t) {
  return n != null && hasPath(n, t, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(n, t) {
  return isKey(n) && isStrictComparable(t) ? matchesStrictComparable(toKey(n), t) : function(g) {
    var d = get(g, n);
    return d === void 0 && d === t ? hasIn(g, n) : baseIsEqual(t, d, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(n) {
  return function(t) {
    return t?.[n];
  };
}
function basePropertyDeep(n) {
  return function(t) {
    return baseGet(t, n);
  };
}
function property(n) {
  return isKey(n) ? baseProperty(toKey(n)) : basePropertyDeep(n);
}
function baseIteratee(n) {
  return typeof n == "function" ? n : n == null ? identity : typeof n == "object" ? isArray$1(n) ? baseMatchesProperty(n[0], n[1]) : baseMatches(n) : property(n);
}
function baseMap(n, t) {
  var g = -1, d = isArrayLike(n) ? Array(n.length) : [];
  return baseEach(n, function(k, H, AA) {
    d[++g] = t(k, H, AA);
  }), d;
}
function map(n, t) {
  var g = isArray$1(n) ? arrayMap : baseMap;
  return g(n, baseIteratee(t));
}
var BlockSwatches = function n(t) {
  var g = t.colors, d = t.onClick, k = t.onSwatchHover, H = reactCSS({
    default: {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: H.swatches },
    map(g, function(AA) {
      return React__default.createElement(Swatch$1, {
        key: AA,
        color: AA,
        style: H.swatch,
        onClick: d,
        onHover: k,
        focusStyle: {
          boxShadow: "0 0 4px " + AA
        }
      });
    }),
    React__default.createElement("div", { style: H.clear })
  );
}, Block = function n(t) {
  var g = t.onChange, d = t.onSwatchHover, k = t.hex, H = t.colors, AA = t.width, gA = t.triangle, IA = t.styles, CA = IA === void 0 ? {} : IA, BA = t.className, eA = BA === void 0 ? "" : BA, iA = k === "transparent", QA = function(EA, aA) {
    isValidHex(EA) && g({
      hex: EA,
      source: "hex"
    }, aA);
  }, tA = reactCSS(merge$1({
    default: {
      card: {
        width: AA,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: k,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: getContrastingColor(k),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + k + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, CA), { "hide-triangle": gA === "hide" });
  return React__default.createElement(
    "div",
    { style: tA.card, className: "block-picker " + eA },
    React__default.createElement("div", { style: tA.triangle }),
    React__default.createElement(
      "div",
      { style: tA.head },
      iA && React__default.createElement(Checkboard, { borderRadius: "6px 6px 0 0" }),
      React__default.createElement(
        "div",
        { style: tA.label },
        k
      )
    ),
    React__default.createElement(
      "div",
      { style: tA.body },
      React__default.createElement(BlockSwatches, { colors: H, onClick: QA, onSwatchHover: d }),
      React__default.createElement(EditableInput, {
        style: { input: tA.input },
        value: k,
        onChange: QA
      })
    )
  );
};
Block.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(["top", "hide"]),
  styles: PropTypes.object
};
Block.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top",
  styles: {}
};
ColorWrap(Block);
var red = { 100: "#ffcdd2", 300: "#e57373", 500: "#f44336", 700: "#d32f2f", 900: "#b71c1c" }, pink = { 100: "#f8bbd0", 300: "#f06292", 500: "#e91e63", 700: "#c2185b", 900: "#880e4f" }, purple = { 100: "#e1bee7", 300: "#ba68c8", 500: "#9c27b0", 700: "#7b1fa2", 900: "#4a148c" }, deepPurple = { 100: "#d1c4e9", 300: "#9575cd", 500: "#673ab7", 700: "#512da8", 900: "#311b92" }, indigo = { 100: "#c5cae9", 300: "#7986cb", 500: "#3f51b5", 700: "#303f9f", 900: "#1a237e" }, blue = { 100: "#bbdefb", 300: "#64b5f6", 500: "#2196f3", 700: "#1976d2", 900: "#0d47a1" }, lightBlue = { 100: "#b3e5fc", 300: "#4fc3f7", 500: "#03a9f4", 700: "#0288d1", 900: "#01579b" }, cyan = { 100: "#b2ebf2", 300: "#4dd0e1", 500: "#00bcd4", 700: "#0097a7", 900: "#006064" }, teal = { 100: "#b2dfdb", 300: "#4db6ac", 500: "#009688", 700: "#00796b", 900: "#004d40" }, green = { 100: "#c8e6c9", 300: "#81c784", 500: "#4caf50", 700: "#388e3c" }, lightGreen = { 100: "#dcedc8", 300: "#aed581", 500: "#8bc34a", 700: "#689f38", 900: "#33691e" }, lime = { 100: "#f0f4c3", 300: "#dce775", 500: "#cddc39", 700: "#afb42b", 900: "#827717" }, yellow = { 100: "#fff9c4", 300: "#fff176", 500: "#ffeb3b", 700: "#fbc02d", 900: "#f57f17" }, amber = { 100: "#ffecb3", 300: "#ffd54f", 500: "#ffc107", 700: "#ffa000", 900: "#ff6f00" }, orange = { 100: "#ffe0b2", 300: "#ffb74d", 500: "#ff9800", 700: "#f57c00", 900: "#e65100" }, deepOrange = { 100: "#ffccbc", 300: "#ff8a65", 500: "#ff5722", 700: "#e64a19", 900: "#bf360c" }, brown = { 100: "#d7ccc8", 300: "#a1887f", 500: "#795548", 700: "#5d4037", 900: "#3e2723" }, blueGrey = { 100: "#cfd8dc", 300: "#90a4ae", 500: "#607d8b", 700: "#455a64", 900: "#263238" }, CircleSwatch = function n(t) {
  var g = t.color, d = t.onClick, k = t.onSwatchHover, H = t.hover, AA = t.active, gA = t.circleSize, IA = t.circleSpacing, CA = reactCSS({
    default: {
      swatch: {
        width: gA,
        height: gA,
        marginRight: IA,
        marginBottom: IA,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + (gA / 2 + 1) + "px " + g,
        transition: "100ms box-shadow ease"
      }
    },
    hover: {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    active: {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + g
      }
    }
  }, { hover: H, active: AA });
  return React__default.createElement(
    "div",
    { style: CA.swatch },
    React__default.createElement(Swatch$1, {
      style: CA.Swatch,
      color: g,
      onClick: d,
      onHover: k,
      focusStyle: { boxShadow: CA.Swatch.boxShadow + ", 0 0 5px " + g }
    })
  );
};
CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
const CircleSwatch$1 = libExports.handleHover(CircleSwatch);
var Circle = function n(t) {
  var g = t.width, d = t.onChange, k = t.onSwatchHover, H = t.colors, AA = t.hex, gA = t.circleSize, IA = t.styles, CA = IA === void 0 ? {} : IA, BA = t.circleSpacing, eA = t.className, iA = eA === void 0 ? "" : eA, QA = reactCSS(merge$1({
    default: {
      card: {
        width: g,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -BA,
        marginBottom: -BA
      }
    }
  }, CA)), tA = function(EA, aA) {
    return d({ hex: EA, source: "hex" }, aA);
  };
  return React__default.createElement(
    "div",
    { style: QA.card, className: "circle-picker " + iA },
    map(H, function(oA) {
      return React__default.createElement(CircleSwatch$1, {
        key: oA,
        color: oA,
        onClick: tA,
        onSwatchHover: k,
        active: AA === oA.toLowerCase(),
        circleSize: gA,
        circleSpacing: BA
      });
    })
  );
};
Circle.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  circleSize: PropTypes.number,
  circleSpacing: PropTypes.number,
  styles: PropTypes.object
};
Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [red[500], pink[500], purple[500], deepPurple[500], indigo[500], blue[500], lightBlue[500], cyan[500], teal[500], green[500], lightGreen[500], lime[500], yellow[500], amber[500], orange[500], deepOrange[500], brown[500], blueGrey[500]],
  styles: {}
};
ColorWrap(Circle);
function isUndefined$1(n) {
  return n === void 0;
}
var UnfoldMoreHorizontalIcon$1 = {}, hasRequiredUnfoldMoreHorizontalIcon;
function requireUnfoldMoreHorizontalIcon() {
  if (hasRequiredUnfoldMoreHorizontalIcon) return UnfoldMoreHorizontalIcon$1;
  hasRequiredUnfoldMoreHorizontalIcon = 1, Object.defineProperty(UnfoldMoreHorizontalIcon$1, "__esModule", {
    value: !0
  });
  var n = Object.assign || function(AA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var IA = arguments[gA];
      for (var CA in IA)
        Object.prototype.hasOwnProperty.call(IA, CA) && (AA[CA] = IA[CA]);
    }
    return AA;
  }, t = React__default, g = d(t);
  function d(AA) {
    return AA && AA.__esModule ? AA : { default: AA };
  }
  function k(AA, gA) {
    var IA = {};
    for (var CA in AA)
      gA.indexOf(CA) >= 0 || Object.prototype.hasOwnProperty.call(AA, CA) && (IA[CA] = AA[CA]);
    return IA;
  }
  var H = 24;
  return UnfoldMoreHorizontalIcon$1.default = function(AA) {
    var gA = AA.fill, IA = gA === void 0 ? "currentColor" : gA, CA = AA.width, BA = CA === void 0 ? H : CA, eA = AA.height, iA = eA === void 0 ? H : eA, QA = AA.style, tA = QA === void 0 ? {} : QA, oA = k(AA, ["fill", "width", "height", "style"]);
    return g.default.createElement(
      "svg",
      n({
        viewBox: "0 0 " + H + " " + H,
        style: n({ fill: IA, width: BA, height: iA }, tA)
      }, oA),
      g.default.createElement("path", { d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" })
    );
  }, UnfoldMoreHorizontalIcon$1;
}
var UnfoldMoreHorizontalIconExports = requireUnfoldMoreHorizontalIcon();
const UnfoldMoreHorizontalIcon = /* @__PURE__ */ getDefaultExportFromCjs$2(UnfoldMoreHorizontalIconExports);
var _createClass$7 = /* @__PURE__ */ (function() {
  function n(t, g) {
    for (var d = 0; d < g.length; d++) {
      var k = g[d];
      k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(t, k.key, k);
    }
  }
  return function(t, g, d) {
    return g && n(t.prototype, g), d && n(t, d), t;
  };
})();
function _classCallCheck$7(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$7(n, t) {
  if (!n)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : n;
}
function _inherits$7(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(n, t) : n.__proto__ = t);
}
var ChromeFields = (function(n) {
  _inherits$7(t, n);
  function t(g) {
    _classCallCheck$7(this, t);
    var d = _possibleConstructorReturn$7(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
    return d.toggleViews = function() {
      d.state.view === "hex" ? d.setState({ view: "rgb" }) : d.state.view === "rgb" ? d.setState({ view: "hsl" }) : d.state.view === "hsl" && (d.props.hsl.a === 1 ? d.setState({ view: "hex" }) : d.setState({ view: "rgb" }));
    }, d.handleChange = function(k, H) {
      k.hex ? isValidHex(k.hex) && d.props.onChange({
        hex: k.hex,
        source: "hex"
      }, H) : k.r || k.g || k.b ? d.props.onChange({
        r: k.r || d.props.rgb.r,
        g: k.g || d.props.rgb.g,
        b: k.b || d.props.rgb.b,
        source: "rgb"
      }, H) : k.a ? (k.a < 0 ? k.a = 0 : k.a > 1 && (k.a = 1), d.props.onChange({
        h: d.props.hsl.h,
        s: d.props.hsl.s,
        l: d.props.hsl.l,
        a: Math.round(k.a * 100) / 100,
        source: "rgb"
      }, H)) : (k.h || k.s || k.l) && (typeof k.s == "string" && k.s.includes("%") && (k.s = k.s.replace("%", "")), typeof k.l == "string" && k.l.includes("%") && (k.l = k.l.replace("%", "")), k.s == 1 ? k.s = 0.01 : k.l == 1 && (k.l = 0.01), d.props.onChange({
        h: k.h || d.props.hsl.h,
        s: Number(isUndefined$1(k.s) ? d.props.hsl.s : k.s),
        l: Number(isUndefined$1(k.l) ? d.props.hsl.l : k.l),
        source: "hsl"
      }, H));
    }, d.showHighlight = function(k) {
      k.currentTarget.style.background = "#eee";
    }, d.hideHighlight = function(k) {
      k.currentTarget.style.background = "transparent";
    }, g.hsl.a !== 1 && g.view === "hex" ? d.state = {
      view: "rgb"
    } : d.state = {
      view: g.view
    }, d;
  }
  return _createClass$7(t, [{
    key: "render",
    value: function() {
      var d = this, k = reactCSS({
        default: {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            fill: "#333",
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        disableAlpha: {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state), H = void 0;
      return this.state.view === "hex" ? H = React__default.createElement(
        "div",
        { style: k.fields, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: k.field },
          React__default.createElement(EditableInput, {
            style: { input: k.input, label: k.label },
            label: "hex",
            value: this.props.hex,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "rgb" ? H = React__default.createElement(
        "div",
        { style: k.fields, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: k.field },
          React__default.createElement(EditableInput, {
            style: { input: k.input, label: k.label },
            label: "r",
            value: this.props.rgb.r,
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: k.field },
          React__default.createElement(EditableInput, {
            style: { input: k.input, label: k.label },
            label: "g",
            value: this.props.rgb.g,
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: k.field },
          React__default.createElement(EditableInput, {
            style: { input: k.input, label: k.label },
            label: "b",
            value: this.props.rgb.b,
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: k.alpha },
          React__default.createElement(EditableInput, {
            style: { input: k.input, label: k.label },
            label: "a",
            value: this.props.rgb.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "hsl" && (H = React__default.createElement(
        "div",
        { style: k.fields, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: k.field },
          React__default.createElement(EditableInput, {
            style: { input: k.input, label: k.label },
            label: "h",
            value: Math.round(this.props.hsl.h),
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: k.field },
          React__default.createElement(EditableInput, {
            style: { input: k.input, label: k.label },
            label: "s",
            value: Math.round(this.props.hsl.s * 100) + "%",
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: k.field },
          React__default.createElement(EditableInput, {
            style: { input: k.input, label: k.label },
            label: "l",
            value: Math.round(this.props.hsl.l * 100) + "%",
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: k.alpha },
          React__default.createElement(EditableInput, {
            style: { input: k.input, label: k.label },
            label: "a",
            value: this.props.hsl.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      )), React__default.createElement(
        "div",
        { style: k.wrap, className: "flexbox-fix" },
        H,
        React__default.createElement(
          "div",
          { style: k.toggle },
          React__default.createElement(
            "div",
            { style: k.icon, onClick: this.toggleViews, ref: function(gA) {
              return d.icon = gA;
            } },
            React__default.createElement(UnfoldMoreHorizontalIcon, {
              style: k.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(d, k) {
      return d.hsl.a !== 1 && k.view === "hex" ? { view: "rgb" } : null;
    }
  }]), t;
})(React__default.Component);
ChromeFields.defaultProps = {
  view: "hex"
};
var ChromePointer = function n() {
  var t = reactCSS({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return React__default.createElement("div", { style: t.picker });
}, ChromePointerCircle = function n() {
  var t = reactCSS({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return React__default.createElement("div", { style: t.picker });
}, Chrome = function n(t) {
  var g = t.width, d = t.onChange, k = t.disableAlpha, H = t.rgb, AA = t.hsl, gA = t.hsv, IA = t.hex, CA = t.renderers, BA = t.styles, eA = BA === void 0 ? {} : BA, iA = t.className, QA = iA === void 0 ? "" : iA, tA = t.defaultView, oA = reactCSS(merge$1({
    default: {
      picker: {
        width: g,
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + H.r + ", " + H.g + ", " + H.b + ", " + H.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    disableAlpha: {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, eA), { disableAlpha: k });
  return React__default.createElement(
    "div",
    { style: oA.picker, className: "chrome-picker " + QA },
    React__default.createElement(
      "div",
      { style: oA.saturation },
      React__default.createElement(Saturation, {
        style: oA.Saturation,
        hsl: AA,
        hsv: gA,
        pointer: ChromePointerCircle,
        onChange: d
      })
    ),
    React__default.createElement(
      "div",
      { style: oA.body },
      React__default.createElement(
        "div",
        { style: oA.controls, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: oA.color },
          React__default.createElement(
            "div",
            { style: oA.swatch },
            React__default.createElement("div", { style: oA.active }),
            React__default.createElement(Checkboard, { renderers: CA })
          )
        ),
        React__default.createElement(
          "div",
          { style: oA.toggles },
          React__default.createElement(
            "div",
            { style: oA.hue },
            React__default.createElement(Hue, {
              style: oA.Hue,
              hsl: AA,
              pointer: ChromePointer,
              onChange: d
            })
          ),
          React__default.createElement(
            "div",
            { style: oA.alpha },
            React__default.createElement(Alpha, {
              style: oA.Alpha,
              rgb: H,
              hsl: AA,
              pointer: ChromePointer,
              renderers: CA,
              onChange: d
            })
          )
        )
      ),
      React__default.createElement(ChromeFields, {
        rgb: H,
        hsl: AA,
        hex: IA,
        view: tA,
        onChange: d,
        disableAlpha: k
      })
    )
  );
};
Chrome.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disableAlpha: PropTypes.bool,
  styles: PropTypes.object,
  defaultView: PropTypes.oneOf(["hex", "rgb", "hsl"])
};
Chrome.defaultProps = {
  width: 225,
  disableAlpha: !1,
  styles: {}
};
const ChromePicker = ColorWrap(Chrome);
var CompactColor = function n(t) {
  var g = t.color, d = t.onClick, k = d === void 0 ? function() {
  } : d, H = t.onSwatchHover, AA = t.active, gA = reactCSS({
    default: {
      color: {
        background: g,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: getContrastingColor(g),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    active: {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    transparent: {
      dot: {
        background: "#000"
      }
    }
  }, { active: AA, "color-#FFFFFF": g === "#FFFFFF", transparent: g === "transparent" });
  return React__default.createElement(
    Swatch$1,
    {
      style: gA.color,
      color: g,
      onClick: k,
      onHover: H,
      focusStyle: { boxShadow: "0 0 4px " + g }
    },
    React__default.createElement("div", { style: gA.dot })
  );
}, CompactFields = function n(t) {
  var g = t.hex, d = t.rgb, k = t.onChange, H = reactCSS({
    default: {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: g
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  }), AA = function(IA, CA) {
    IA.r || IA.g || IA.b ? k({
      r: IA.r || d.r,
      g: IA.g || d.g,
      b: IA.b || d.b,
      source: "rgb"
    }, CA) : k({
      hex: IA.hex,
      source: "hex"
    }, CA);
  };
  return React__default.createElement(
    "div",
    { style: H.fields, className: "flexbox-fix" },
    React__default.createElement("div", { style: H.active }),
    React__default.createElement(EditableInput, {
      style: { wrap: H.HEXwrap, input: H.HEXinput, label: H.HEXlabel },
      label: "hex",
      value: g,
      onChange: AA
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: H.RGBwrap, input: H.RGBinput, label: H.RGBlabel },
      label: "r",
      value: d.r,
      onChange: AA
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: H.RGBwrap, input: H.RGBinput, label: H.RGBlabel },
      label: "g",
      value: d.g,
      onChange: AA
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: H.RGBwrap, input: H.RGBinput, label: H.RGBlabel },
      label: "b",
      value: d.b,
      onChange: AA
    })
  );
}, Compact = function n(t) {
  var g = t.onChange, d = t.onSwatchHover, k = t.colors, H = t.hex, AA = t.rgb, gA = t.styles, IA = gA === void 0 ? {} : gA, CA = t.className, BA = CA === void 0 ? "" : CA, eA = reactCSS(merge$1({
    default: {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  }, IA)), iA = function(tA, oA) {
    tA.hex ? isValidHex(tA.hex) && g({
      hex: tA.hex,
      source: "hex"
    }, oA) : g(tA, oA);
  };
  return React__default.createElement(
    Raised,
    { style: eA.Compact, styles: IA },
    React__default.createElement(
      "div",
      { style: eA.compact, className: "compact-picker " + BA },
      React__default.createElement(
        "div",
        null,
        map(k, function(QA) {
          return React__default.createElement(CompactColor, {
            key: QA,
            color: QA,
            active: QA.toLowerCase() === H,
            onClick: iA,
            onSwatchHover: d
          });
        }),
        React__default.createElement("div", { style: eA.clear })
      ),
      React__default.createElement(CompactFields, { hex: H, rgb: AA, onChange: iA })
    )
  );
};
Compact.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};
Compact.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
  styles: {}
};
ColorWrap(Compact);
var GithubSwatch = function n(t) {
  var g = t.hover, d = t.color, k = t.onClick, H = t.onSwatchHover, AA = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  }, gA = reactCSS({
    default: {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    hover: {
      swatch: AA
    }
  }, { hover: g });
  return React__default.createElement(
    "div",
    { style: gA.swatch },
    React__default.createElement(Swatch$1, {
      color: d,
      onClick: k,
      onHover: H,
      focusStyle: AA
    })
  );
};
const GithubSwatch$1 = libExports.handleHover(GithubSwatch);
var Github = function n(t) {
  var g = t.width, d = t.colors, k = t.onChange, H = t.onSwatchHover, AA = t.triangle, gA = t.styles, IA = gA === void 0 ? {} : gA, CA = t.className, BA = CA === void 0 ? "" : CA, eA = reactCSS(merge$1({
    default: {
      card: {
        width: g,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-left-triangle": {
      triangle: {
        top: "35px",
        left: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        left: "9px",
        transform: "rotate(180deg)"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, IA), {
    "hide-triangle": AA === "hide",
    "top-left-triangle": AA === "top-left",
    "top-right-triangle": AA === "top-right",
    "bottom-left-triangle": AA === "bottom-left",
    "bottom-right-triangle": AA === "bottom-right"
  }), iA = function(tA, oA) {
    return k({ hex: tA, source: "hex" }, oA);
  };
  return React__default.createElement(
    "div",
    { style: eA.card, className: "github-picker " + BA },
    React__default.createElement("div", { style: eA.triangleShadow }),
    React__default.createElement("div", { style: eA.triangle }),
    map(d, function(QA) {
      return React__default.createElement(GithubSwatch$1, {
        color: QA,
        key: QA,
        onClick: iA,
        onSwatchHover: H
      });
    })
  );
};
Github.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
  styles: PropTypes.object
};
Github.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left",
  styles: {}
};
ColorWrap(Github);
var SliderPointer$1 = function n(t) {
  var g = t.direction, d = reactCSS({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: g === "vertical" });
  return React__default.createElement("div", { style: d.picker });
}, _extends$l = Object.assign || function(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t];
    for (var d in g)
      Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
  }
  return n;
}, HuePicker = function n(t) {
  var g = t.width, d = t.height, k = t.onChange, H = t.hsl, AA = t.direction, gA = t.pointer, IA = t.styles, CA = IA === void 0 ? {} : IA, BA = t.className, eA = BA === void 0 ? "" : BA, iA = reactCSS(merge$1({
    default: {
      picker: {
        position: "relative",
        width: g,
        height: d
      },
      hue: {
        radius: "2px"
      }
    }
  }, CA)), QA = function(oA) {
    return k({ a: 1, h: oA.h, l: 0.5, s: 1 });
  };
  return React__default.createElement(
    "div",
    { style: iA.picker, className: "hue-picker " + eA },
    React__default.createElement(Hue, _extends$l({}, iA.hue, {
      hsl: H,
      pointer: gA,
      onChange: QA,
      direction: AA
    }))
  );
};
HuePicker.propTypes = {
  styles: PropTypes.object
};
HuePicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: SliderPointer$1,
  styles: {}
};
ColorWrap(HuePicker);
var Material = function n(t) {
  var g = t.onChange, d = t.hex, k = t.rgb, H = t.styles, AA = H === void 0 ? {} : H, gA = t.className, IA = gA === void 0 ? "" : gA, CA = reactCSS(merge$1({
    default: {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + d,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  }, AA)), BA = function(iA, QA) {
    iA.hex ? isValidHex(iA.hex) && g({
      hex: iA.hex,
      source: "hex"
    }, QA) : (iA.r || iA.g || iA.b) && g({
      r: iA.r || k.r,
      g: iA.g || k.g,
      b: iA.b || k.b,
      source: "rgb"
    }, QA);
  };
  return React__default.createElement(
    Raised,
    { styles: AA },
    React__default.createElement(
      "div",
      { style: CA.material, className: "material-picker " + IA },
      React__default.createElement(EditableInput, {
        style: { wrap: CA.HEXwrap, input: CA.HEXinput, label: CA.HEXlabel },
        label: "hex",
        value: d,
        onChange: BA
      }),
      React__default.createElement(
        "div",
        { style: CA.split, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: CA.third },
          React__default.createElement(EditableInput, {
            style: { wrap: CA.RGBwrap, input: CA.RGBinput, label: CA.RGBlabel },
            label: "r",
            value: k.r,
            onChange: BA
          })
        ),
        React__default.createElement(
          "div",
          { style: CA.third },
          React__default.createElement(EditableInput, {
            style: { wrap: CA.RGBwrap, input: CA.RGBinput, label: CA.RGBlabel },
            label: "g",
            value: k.g,
            onChange: BA
          })
        ),
        React__default.createElement(
          "div",
          { style: CA.third },
          React__default.createElement(EditableInput, {
            style: { wrap: CA.RGBwrap, input: CA.RGBinput, label: CA.RGBlabel },
            label: "b",
            value: k.b,
            onChange: BA
          })
        )
      )
    )
  );
};
ColorWrap(Material);
var PhotoshopPicker = function n(t) {
  var g = t.onChange, d = t.rgb, k = t.hsv, H = t.hex, AA = reactCSS({
    default: {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        top: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  }), gA = function(CA, BA) {
    CA["#"] ? isValidHex(CA["#"]) && g({
      hex: CA["#"],
      source: "hex"
    }, BA) : CA.r || CA.g || CA.b ? g({
      r: CA.r || d.r,
      g: CA.g || d.g,
      b: CA.b || d.b,
      source: "rgb"
    }, BA) : (CA.h || CA.s || CA.v) && g({
      h: CA.h || k.h,
      s: CA.s || k.s,
      v: CA.v || k.v,
      source: "hsv"
    }, BA);
  };
  return React__default.createElement(
    "div",
    { style: AA.fields },
    React__default.createElement(EditableInput, {
      style: { wrap: AA.RGBwrap, input: AA.RGBinput, label: AA.RGBlabel },
      label: "h",
      value: Math.round(k.h),
      onChange: gA
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: AA.RGBwrap, input: AA.RGBinput, label: AA.RGBlabel },
      label: "s",
      value: Math.round(k.s * 100),
      onChange: gA
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: AA.RGBwrap, input: AA.RGBinput, label: AA.RGBlabel },
      label: "v",
      value: Math.round(k.v * 100),
      onChange: gA
    }),
    React__default.createElement("div", { style: AA.divider }),
    React__default.createElement(EditableInput, {
      style: { wrap: AA.RGBwrap, input: AA.RGBinput, label: AA.RGBlabel },
      label: "r",
      value: d.r,
      onChange: gA
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: AA.RGBwrap, input: AA.RGBinput, label: AA.RGBlabel },
      label: "g",
      value: d.g,
      onChange: gA
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: AA.RGBwrap, input: AA.RGBinput, label: AA.RGBlabel },
      label: "b",
      value: d.b,
      onChange: gA
    }),
    React__default.createElement("div", { style: AA.divider }),
    React__default.createElement(EditableInput, {
      style: { wrap: AA.HEXwrap, input: AA.HEXinput, label: AA.HEXlabel },
      label: "#",
      value: H.replace("#", ""),
      onChange: gA
    }),
    React__default.createElement(
      "div",
      { style: AA.fieldSymbols },
      React__default.createElement(
        "div",
        { style: AA.symbol },
        "°"
      ),
      React__default.createElement(
        "div",
        { style: AA.symbol },
        "%"
      ),
      React__default.createElement(
        "div",
        { style: AA.symbol },
        "%"
      )
    )
  );
}, PhotoshopPointerCircle$1 = function n(t) {
  var g = t.hsl, d = reactCSS({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, { "black-outline": g.l > 0.5 });
  return React__default.createElement("div", { style: d.picker });
}, PhotoshopPointerCircle = function n() {
  var t = reactCSS({
    default: {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: t.pointer },
    React__default.createElement(
      "div",
      { style: t.left },
      React__default.createElement("div", { style: t.leftInside })
    ),
    React__default.createElement(
      "div",
      { style: t.right },
      React__default.createElement("div", { style: t.rightInside })
    )
  );
}, PhotoshopButton = function n(t) {
  var g = t.onClick, d = t.label, k = t.children, H = t.active, AA = reactCSS({
    default: {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    active: {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, { active: H });
  return React__default.createElement(
    "div",
    { style: AA.button, onClick: g },
    d || k
  );
}, PhotoshopPreviews = function n(t) {
  var g = t.rgb, d = t.currentColor, k = reactCSS({
    default: {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + g.r + "," + g.g + ", " + g.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: d,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return React__default.createElement(
    "div",
    null,
    React__default.createElement(
      "div",
      { style: k.label },
      "new"
    ),
    React__default.createElement(
      "div",
      { style: k.swatches },
      React__default.createElement("div", { style: k.new }),
      React__default.createElement("div", { style: k.current })
    ),
    React__default.createElement(
      "div",
      { style: k.label },
      "current"
    )
  );
}, _createClass$6 = /* @__PURE__ */ (function() {
  function n(t, g) {
    for (var d = 0; d < g.length; d++) {
      var k = g[d];
      k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(t, k.key, k);
    }
  }
  return function(t, g, d) {
    return g && n(t.prototype, g), d && n(t, d), t;
  };
})();
function _classCallCheck$6(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$6(n, t) {
  if (!n)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : n;
}
function _inherits$6(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(n, t) : n.__proto__ = t);
}
var Photoshop = (function(n) {
  _inherits$6(t, n);
  function t(g) {
    _classCallCheck$6(this, t);
    var d = _possibleConstructorReturn$6(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
    return d.state = {
      currentColor: g.hex
    }, d;
  }
  return _createClass$6(t, [{
    key: "render",
    value: function() {
      var d = this.props, k = d.styles, H = k === void 0 ? {} : k, AA = d.className, gA = AA === void 0 ? "" : AA, IA = reactCSS(merge$1({
        default: {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      }, H));
      return React__default.createElement(
        "div",
        { style: IA.picker, className: "photoshop-picker " + gA },
        React__default.createElement(
          "div",
          { style: IA.head },
          this.props.header
        ),
        React__default.createElement(
          "div",
          { style: IA.body, className: "flexbox-fix" },
          React__default.createElement(
            "div",
            { style: IA.saturation },
            React__default.createElement(Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: PhotoshopPointerCircle$1,
              onChange: this.props.onChange
            })
          ),
          React__default.createElement(
            "div",
            { style: IA.hue },
            React__default.createElement(Hue, {
              direction: "vertical",
              hsl: this.props.hsl,
              pointer: PhotoshopPointerCircle,
              onChange: this.props.onChange
            })
          ),
          React__default.createElement(
            "div",
            { style: IA.controls },
            React__default.createElement(
              "div",
              { style: IA.top, className: "flexbox-fix" },
              React__default.createElement(
                "div",
                { style: IA.previews },
                React__default.createElement(PhotoshopPreviews, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              React__default.createElement(
                "div",
                { style: IA.actions },
                React__default.createElement(PhotoshopButton, { label: "OK", onClick: this.props.onAccept, active: !0 }),
                React__default.createElement(PhotoshopButton, { label: "Cancel", onClick: this.props.onCancel }),
                React__default.createElement(PhotoshopPicker, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]), t;
})(React__default.Component);
Photoshop.propTypes = {
  header: PropTypes.string,
  styles: PropTypes.object
};
Photoshop.defaultProps = {
  header: "Color Picker",
  styles: {}
};
ColorWrap(Photoshop);
var SketchFields = function n(t) {
  var g = t.onChange, d = t.rgb, k = t.hsl, H = t.hex, AA = t.disableAlpha, gA = reactCSS({
    default: {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    disableAlpha: {
      alpha: {
        display: "none"
      }
    }
  }, { disableAlpha: AA }), IA = function(BA, eA) {
    BA.hex ? isValidHex(BA.hex) && g({
      hex: BA.hex,
      source: "hex"
    }, eA) : BA.r || BA.g || BA.b ? g({
      r: BA.r || d.r,
      g: BA.g || d.g,
      b: BA.b || d.b,
      a: d.a,
      source: "rgb"
    }, eA) : BA.a && (BA.a < 0 ? BA.a = 0 : BA.a > 100 && (BA.a = 100), BA.a /= 100, g({
      h: k.h,
      s: k.s,
      l: k.l,
      a: BA.a,
      source: "rgb"
    }, eA));
  };
  return React__default.createElement(
    "div",
    { style: gA.fields, className: "flexbox-fix" },
    React__default.createElement(
      "div",
      { style: gA.double },
      React__default.createElement(EditableInput, {
        style: { input: gA.input, label: gA.label },
        label: "hex",
        value: H.replace("#", ""),
        onChange: IA
      })
    ),
    React__default.createElement(
      "div",
      { style: gA.single },
      React__default.createElement(EditableInput, {
        style: { input: gA.input, label: gA.label },
        label: "r",
        value: d.r,
        onChange: IA,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    React__default.createElement(
      "div",
      { style: gA.single },
      React__default.createElement(EditableInput, {
        style: { input: gA.input, label: gA.label },
        label: "g",
        value: d.g,
        onChange: IA,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    React__default.createElement(
      "div",
      { style: gA.single },
      React__default.createElement(EditableInput, {
        style: { input: gA.input, label: gA.label },
        label: "b",
        value: d.b,
        onChange: IA,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    React__default.createElement(
      "div",
      { style: gA.alpha },
      React__default.createElement(EditableInput, {
        style: { input: gA.input, label: gA.label },
        label: "a",
        value: Math.round(d.a * 100),
        onChange: IA,
        dragLabel: "true",
        dragMax: "100"
      })
    )
  );
}, _extends$k = Object.assign || function(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t];
    for (var d in g)
      Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
  }
  return n;
}, SketchPresetColors = function n(t) {
  var g = t.colors, d = t.onClick, k = d === void 0 ? function() {
  } : d, H = t.onSwatchHover, AA = reactCSS({
    default: {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !g || !g.length
  }), gA = function(CA, BA) {
    k({
      hex: CA,
      source: "hex"
    }, BA);
  };
  return React__default.createElement(
    "div",
    { style: AA.colors, className: "flexbox-fix" },
    g.map(function(IA) {
      var CA = typeof IA == "string" ? { color: IA } : IA, BA = "" + CA.color + (CA.title || "");
      return React__default.createElement(
        "div",
        { key: BA, style: AA.swatchWrap },
        React__default.createElement(Swatch$1, _extends$k({}, CA, {
          style: AA.swatch,
          onClick: gA,
          onHover: H,
          focusStyle: {
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + CA.color
          }
        }))
      );
    })
  );
};
SketchPresetColors.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    color: PropTypes.string,
    title: PropTypes.string
  })])).isRequired
};
var _extends$j = Object.assign || function(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t];
    for (var d in g)
      Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
  }
  return n;
}, Sketch = function n(t) {
  var g = t.width, d = t.rgb, k = t.hex, H = t.hsv, AA = t.hsl, gA = t.onChange, IA = t.onSwatchHover, CA = t.disableAlpha, BA = t.presetColors, eA = t.renderers, iA = t.styles, QA = iA === void 0 ? {} : iA, tA = t.className, oA = tA === void 0 ? "" : tA, EA = reactCSS(merge$1({
    default: _extends$j({
      picker: {
        width: g,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + d.r + "," + d.g + "," + d.b + "," + d.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    }, QA),
    disableAlpha: {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, QA), { disableAlpha: CA });
  return React__default.createElement(
    "div",
    { style: EA.picker, className: "sketch-picker " + oA },
    React__default.createElement(
      "div",
      { style: EA.saturation },
      React__default.createElement(Saturation, {
        style: EA.Saturation,
        hsl: AA,
        hsv: H,
        onChange: gA
      })
    ),
    React__default.createElement(
      "div",
      { style: EA.controls, className: "flexbox-fix" },
      React__default.createElement(
        "div",
        { style: EA.sliders },
        React__default.createElement(
          "div",
          { style: EA.hue },
          React__default.createElement(Hue, {
            style: EA.Hue,
            hsl: AA,
            onChange: gA
          })
        ),
        React__default.createElement(
          "div",
          { style: EA.alpha },
          React__default.createElement(Alpha, {
            style: EA.Alpha,
            rgb: d,
            hsl: AA,
            renderers: eA,
            onChange: gA
          })
        )
      ),
      React__default.createElement(
        "div",
        { style: EA.color },
        React__default.createElement(Checkboard, null),
        React__default.createElement("div", { style: EA.activeColor })
      )
    ),
    React__default.createElement(SketchFields, {
      rgb: d,
      hsl: AA,
      hex: k,
      onChange: gA,
      disableAlpha: CA
    }),
    React__default.createElement(SketchPresetColors, {
      colors: BA,
      onClick: gA,
      onSwatchHover: IA
    })
  );
};
Sketch.propTypes = {
  disableAlpha: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object
};
Sketch.defaultProps = {
  disableAlpha: !1,
  width: 200,
  styles: {},
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
ColorWrap(Sketch);
var SliderSwatch = function n(t) {
  var g = t.hsl, d = t.offset, k = t.onClick, H = k === void 0 ? function() {
  } : k, AA = t.active, gA = t.first, IA = t.last, CA = reactCSS({
    default: {
      swatch: {
        height: "12px",
        background: "hsl(" + g.h + ", 50%, " + d * 100 + "%)",
        cursor: "pointer"
      }
    },
    first: {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    last: {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    active: {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, { active: AA, first: gA, last: IA }), BA = function(iA) {
    return H({
      h: g.h,
      s: 0.5,
      l: d,
      source: "hsl"
    }, iA);
  };
  return React__default.createElement("div", { style: CA.swatch, onClick: BA });
}, SliderSwatches = function n(t) {
  var g = t.onClick, d = t.hsl, k = reactCSS({
    default: {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  }), H = 0.1;
  return React__default.createElement(
    "div",
    { style: k.swatches },
    React__default.createElement(
      "div",
      { style: k.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: d,
        offset: ".80",
        active: Math.abs(d.l - 0.8) < H && Math.abs(d.s - 0.5) < H,
        onClick: g,
        first: !0
      })
    ),
    React__default.createElement(
      "div",
      { style: k.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: d,
        offset: ".65",
        active: Math.abs(d.l - 0.65) < H && Math.abs(d.s - 0.5) < H,
        onClick: g
      })
    ),
    React__default.createElement(
      "div",
      { style: k.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: d,
        offset: ".50",
        active: Math.abs(d.l - 0.5) < H && Math.abs(d.s - 0.5) < H,
        onClick: g
      })
    ),
    React__default.createElement(
      "div",
      { style: k.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: d,
        offset: ".35",
        active: Math.abs(d.l - 0.35) < H && Math.abs(d.s - 0.5) < H,
        onClick: g
      })
    ),
    React__default.createElement(
      "div",
      { style: k.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: d,
        offset: ".20",
        active: Math.abs(d.l - 0.2) < H && Math.abs(d.s - 0.5) < H,
        onClick: g,
        last: !0
      })
    ),
    React__default.createElement("div", { style: k.clear })
  );
}, SliderPointer = function n() {
  var t = reactCSS({
    default: {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return React__default.createElement("div", { style: t.picker });
}, Slider = function n(t) {
  var g = t.hsl, d = t.onChange, k = t.pointer, H = t.styles, AA = H === void 0 ? {} : H, gA = t.className, IA = gA === void 0 ? "" : gA, CA = reactCSS(merge$1({
    default: {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, AA));
  return React__default.createElement(
    "div",
    { style: CA.wrap || {}, className: "slider-picker " + IA },
    React__default.createElement(
      "div",
      { style: CA.hue },
      React__default.createElement(Hue, {
        style: CA.Hue,
        hsl: g,
        pointer: k,
        onChange: d
      })
    ),
    React__default.createElement(
      "div",
      { style: CA.swatches },
      React__default.createElement(SliderSwatches, { hsl: g, onClick: d })
    )
  );
};
Slider.propTypes = {
  styles: PropTypes.object
};
Slider.defaultProps = {
  pointer: SliderPointer,
  styles: {}
};
ColorWrap(Slider);
var CheckIcon$1 = {}, hasRequiredCheckIcon;
function requireCheckIcon() {
  if (hasRequiredCheckIcon) return CheckIcon$1;
  hasRequiredCheckIcon = 1, Object.defineProperty(CheckIcon$1, "__esModule", {
    value: !0
  });
  var n = Object.assign || function(AA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var IA = arguments[gA];
      for (var CA in IA)
        Object.prototype.hasOwnProperty.call(IA, CA) && (AA[CA] = IA[CA]);
    }
    return AA;
  }, t = React__default, g = d(t);
  function d(AA) {
    return AA && AA.__esModule ? AA : { default: AA };
  }
  function k(AA, gA) {
    var IA = {};
    for (var CA in AA)
      gA.indexOf(CA) >= 0 || Object.prototype.hasOwnProperty.call(AA, CA) && (IA[CA] = AA[CA]);
    return IA;
  }
  var H = 24;
  return CheckIcon$1.default = function(AA) {
    var gA = AA.fill, IA = gA === void 0 ? "currentColor" : gA, CA = AA.width, BA = CA === void 0 ? H : CA, eA = AA.height, iA = eA === void 0 ? H : eA, QA = AA.style, tA = QA === void 0 ? {} : QA, oA = k(AA, ["fill", "width", "height", "style"]);
    return g.default.createElement(
      "svg",
      n({
        viewBox: "0 0 " + H + " " + H,
        style: n({ fill: IA, width: BA, height: iA }, tA)
      }, oA),
      g.default.createElement("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
    );
  }, CheckIcon$1;
}
var CheckIconExports = requireCheckIcon();
const CheckIcon = /* @__PURE__ */ getDefaultExportFromCjs$2(CheckIconExports);
var SwatchesColor = function n(t) {
  var g = t.color, d = t.onClick, k = d === void 0 ? function() {
  } : d, H = t.onSwatchHover, AA = t.first, gA = t.last, IA = t.active, CA = reactCSS({
    default: {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: g,
        marginBottom: "1px"
      },
      check: {
        color: getContrastingColor(g),
        marginLeft: "8px",
        display: "none"
      }
    },
    first: {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    last: {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    active: {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        color: "#333"
      }
    },
    transparent: {
      check: {
        color: "#333"
      }
    }
  }, {
    first: AA,
    last: gA,
    active: IA,
    "color-#FFFFFF": g === "#FFFFFF",
    transparent: g === "transparent"
  });
  return React__default.createElement(
    Swatch$1,
    {
      color: g,
      style: CA.color,
      onClick: k,
      onHover: H,
      focusStyle: { boxShadow: "0 0 4px " + g }
    },
    React__default.createElement(
      "div",
      { style: CA.check },
      React__default.createElement(CheckIcon, null)
    )
  );
}, SwatchesGroup = function n(t) {
  var g = t.onClick, d = t.onSwatchHover, k = t.group, H = t.active, AA = reactCSS({
    default: {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: AA.group },
    map(k, function(gA, IA) {
      return React__default.createElement(SwatchesColor, {
        key: gA,
        color: gA,
        active: gA.toLowerCase() === H,
        first: IA === 0,
        last: IA === k.length - 1,
        onClick: g,
        onSwatchHover: d
      });
    })
  );
}, Swatches = function n(t) {
  var g = t.width, d = t.height, k = t.onChange, H = t.onSwatchHover, AA = t.colors, gA = t.hex, IA = t.styles, CA = IA === void 0 ? {} : IA, BA = t.className, eA = BA === void 0 ? "" : BA, iA = reactCSS(merge$1({
    default: {
      picker: {
        width: g,
        height: d
      },
      overflow: {
        height: d,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  }, CA)), QA = function(oA, EA) {
    return k({ hex: oA, source: "hex" }, EA);
  };
  return React__default.createElement(
    "div",
    { style: iA.picker, className: "swatches-picker " + eA },
    React__default.createElement(
      Raised,
      null,
      React__default.createElement(
        "div",
        { style: iA.overflow },
        React__default.createElement(
          "div",
          { style: iA.body },
          map(AA, function(tA) {
            return React__default.createElement(SwatchesGroup, {
              key: tA.toString(),
              group: tA,
              active: gA,
              onClick: QA,
              onSwatchHover: H
            });
          }),
          React__default.createElement("div", { style: iA.clear })
        )
      )
    )
  );
};
Swatches.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  styles: PropTypes.object
  /* eslint-disable max-len */
};
Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[red[900], red[700], red[500], red[300], red[100]], [pink[900], pink[700], pink[500], pink[300], pink[100]], [purple[900], purple[700], purple[500], purple[300], purple[100]], [deepPurple[900], deepPurple[700], deepPurple[500], deepPurple[300], deepPurple[100]], [indigo[900], indigo[700], indigo[500], indigo[300], indigo[100]], [blue[900], blue[700], blue[500], blue[300], blue[100]], [lightBlue[900], lightBlue[700], lightBlue[500], lightBlue[300], lightBlue[100]], [cyan[900], cyan[700], cyan[500], cyan[300], cyan[100]], [teal[900], teal[700], teal[500], teal[300], teal[100]], ["#194D33", green[700], green[500], green[300], green[100]], [lightGreen[900], lightGreen[700], lightGreen[500], lightGreen[300], lightGreen[100]], [lime[900], lime[700], lime[500], lime[300], lime[100]], [yellow[900], yellow[700], yellow[500], yellow[300], yellow[100]], [amber[900], amber[700], amber[500], amber[300], amber[100]], [orange[900], orange[700], orange[500], orange[300], orange[100]], [deepOrange[900], deepOrange[700], deepOrange[500], deepOrange[300], deepOrange[100]], [brown[900], brown[700], brown[500], brown[300], brown[100]], [blueGrey[900], blueGrey[700], blueGrey[500], blueGrey[300], blueGrey[100]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
  styles: {}
};
ColorWrap(Swatches);
var Twitter = function n(t) {
  var g = t.onChange, d = t.onSwatchHover, k = t.hex, H = t.colors, AA = t.width, gA = t.triangle, IA = t.styles, CA = IA === void 0 ? {} : IA, BA = t.className, eA = BA === void 0 ? "" : BA, iA = reactCSS(merge$1({
    default: {
      card: {
        width: AA,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, CA), {
    "hide-triangle": gA === "hide",
    "top-left-triangle": gA === "top-left",
    "top-right-triangle": gA === "top-right"
  }), QA = function(oA, EA) {
    isValidHex(oA) && g({
      hex: oA,
      source: "hex"
    }, EA);
  };
  return React__default.createElement(
    "div",
    { style: iA.card, className: "twitter-picker " + eA },
    React__default.createElement("div", { style: iA.triangleShadow }),
    React__default.createElement("div", { style: iA.triangle }),
    React__default.createElement(
      "div",
      { style: iA.body },
      map(H, function(tA, oA) {
        return React__default.createElement(Swatch$1, {
          key: oA,
          color: tA,
          hex: tA,
          style: iA.swatch,
          onClick: QA,
          onHover: d,
          focusStyle: {
            boxShadow: "0 0 4px " + tA
          }
        });
      }),
      React__default.createElement(
        "div",
        { style: iA.hash },
        "#"
      ),
      React__default.createElement(EditableInput, {
        label: null,
        style: { input: iA.input },
        value: k.replace("#", ""),
        onChange: QA
      }),
      React__default.createElement("div", { style: iA.clear })
    )
  );
};
Twitter.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  triangle: PropTypes.oneOf(["hide", "top-left", "top-right"]),
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};
Twitter.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left",
  styles: {}
};
ColorWrap(Twitter);
var GooglePointerCircle = function n(t) {
  var g = reactCSS({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        border: "2px #fff solid",
        transform: "translate(-12px, -13px)",
        background: "hsl(" + Math.round(t.hsl.h) + ", " + Math.round(t.hsl.s * 100) + "%, " + Math.round(t.hsl.l * 100) + "%)"
      }
    }
  });
  return React__default.createElement("div", { style: g.picker });
};
GooglePointerCircle.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};
GooglePointerCircle.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var GooglePointer = function n(t) {
  var g = reactCSS({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        transform: "translate(-10px, -7px)",
        background: "hsl(" + Math.round(t.hsl.h) + ", 100%, 50%)",
        border: "2px white solid"
      }
    }
  });
  return React__default.createElement("div", { style: g.picker });
};
GooglePointer.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};
GooglePointer.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var GoogleFields = function n(t) {
  var g = t.onChange, d = t.rgb, k = t.hsl, H = t.hex, AA = t.hsv, gA = function(QA, tA) {
    if (QA.hex)
      isValidHex(QA.hex) && g({
        hex: QA.hex,
        source: "hex"
      }, tA);
    else if (QA.rgb) {
      var oA = QA.rgb.split(",");
      isvalidColorString(QA.rgb, "rgb") && g({
        r: oA[0],
        g: oA[1],
        b: oA[2],
        a: 1,
        source: "rgb"
      }, tA);
    } else if (QA.hsv) {
      var EA = QA.hsv.split(",");
      isvalidColorString(QA.hsv, "hsv") && (EA[2] = EA[2].replace("%", ""), EA[1] = EA[1].replace("%", ""), EA[0] = EA[0].replace("°", ""), EA[1] == 1 ? EA[1] = 0.01 : EA[2] == 1 && (EA[2] = 0.01), g({
        h: Number(EA[0]),
        s: Number(EA[1]),
        v: Number(EA[2]),
        source: "hsv"
      }, tA));
    } else if (QA.hsl) {
      var aA = QA.hsl.split(",");
      isvalidColorString(QA.hsl, "hsl") && (aA[2] = aA[2].replace("%", ""), aA[1] = aA[1].replace("%", ""), aA[0] = aA[0].replace("°", ""), eA[1] == 1 ? eA[1] = 0.01 : eA[2] == 1 && (eA[2] = 0.01), g({
        h: Number(aA[0]),
        s: Number(aA[1]),
        v: Number(aA[2]),
        source: "hsl"
      }, tA));
    }
  }, IA = reactCSS({
    default: {
      wrap: {
        display: "flex",
        height: "100px",
        marginTop: "4px"
      },
      fields: {
        width: "100%"
      },
      column: {
        paddingTop: "10px",
        display: "flex",
        justifyContent: "space-between"
      },
      double: {
        padding: "0px 4.4px",
        boxSizing: "border-box"
      },
      input: {
        width: "100%",
        height: "38px",
        boxSizing: "border-box",
        padding: "4px 10% 3px",
        textAlign: "center",
        border: "1px solid #dadce0",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      input2: {
        height: "38px",
        width: "100%",
        border: "1px solid #dadce0",
        boxSizing: "border-box",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        paddingLeft: "10px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label: {
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "35px",
        top: "-6px",
        left: "0",
        right: "0",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label2: {
        left: "10px",
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "32px",
        top: "-6px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      single: {
        flexGrow: "1",
        margin: "0px 4.4px"
      }
    }
  }), CA = d.r + ", " + d.g + ", " + d.b, BA = Math.round(k.h) + "°, " + Math.round(k.s * 100) + "%, " + Math.round(k.l * 100) + "%", eA = Math.round(AA.h) + "°, " + Math.round(AA.s * 100) + "%, " + Math.round(AA.v * 100) + "%";
  return React__default.createElement(
    "div",
    { style: IA.wrap, className: "flexbox-fix" },
    React__default.createElement(
      "div",
      { style: IA.fields },
      React__default.createElement(
        "div",
        { style: IA.double },
        React__default.createElement(EditableInput, {
          style: { input: IA.input, label: IA.label },
          label: "hex",
          value: H,
          onChange: gA
        })
      ),
      React__default.createElement(
        "div",
        { style: IA.column },
        React__default.createElement(
          "div",
          { style: IA.single },
          React__default.createElement(EditableInput, {
            style: { input: IA.input2, label: IA.label2 },
            label: "rgb",
            value: CA,
            onChange: gA
          })
        ),
        React__default.createElement(
          "div",
          { style: IA.single },
          React__default.createElement(EditableInput, {
            style: { input: IA.input2, label: IA.label2 },
            label: "hsv",
            value: eA,
            onChange: gA
          })
        ),
        React__default.createElement(
          "div",
          { style: IA.single },
          React__default.createElement(EditableInput, {
            style: { input: IA.input2, label: IA.label2 },
            label: "hsl",
            value: BA,
            onChange: gA
          })
        )
      )
    )
  );
}, Google = function n(t) {
  var g = t.width, d = t.onChange, k = t.rgb, H = t.hsl, AA = t.hsv, gA = t.hex, IA = t.header, CA = t.styles, BA = CA === void 0 ? {} : CA, eA = t.className, iA = eA === void 0 ? "" : eA, QA = reactCSS(merge$1({
    default: {
      picker: {
        width: g,
        background: "#fff",
        border: "1px solid #dfe1e5",
        boxSizing: "initial",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "8px 8px 0px 0px"
      },
      head: {
        height: "57px",
        width: "100%",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        fontSize: "20px",
        boxSizing: "border-box",
        fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
      },
      saturation: {
        width: "70%",
        padding: "0px",
        position: "relative",
        overflow: "hidden"
      },
      swatch: {
        width: "30%",
        height: "228px",
        padding: "0px",
        background: "rgba(" + k.r + ", " + k.g + ", " + k.b + ", 1)",
        position: "relative",
        overflow: "hidden"
      },
      body: {
        margin: "auto",
        width: "95%"
      },
      controls: {
        display: "flex",
        boxSizing: "border-box",
        height: "52px",
        paddingTop: "22px"
      },
      color: {
        width: "32px"
      },
      hue: {
        height: "8px",
        position: "relative",
        margin: "0px 16px 0px 16px",
        width: "100%"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, BA));
  return React__default.createElement(
    "div",
    { style: QA.picker, className: "google-picker " + iA },
    React__default.createElement(
      "div",
      { style: QA.head },
      IA
    ),
    React__default.createElement("div", { style: QA.swatch }),
    React__default.createElement(
      "div",
      { style: QA.saturation },
      React__default.createElement(Saturation, {
        hsl: H,
        hsv: AA,
        pointer: GooglePointerCircle,
        onChange: d
      })
    ),
    React__default.createElement(
      "div",
      { style: QA.body },
      React__default.createElement(
        "div",
        { style: QA.controls, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: QA.hue },
          React__default.createElement(Hue, {
            style: QA.Hue,
            hsl: H,
            radius: "4px",
            pointer: GooglePointer,
            onChange: d
          })
        )
      ),
      React__default.createElement(GoogleFields, {
        rgb: k,
        hsl: H,
        hex: gA,
        hsv: AA,
        onChange: d
      })
    )
  );
};
Google.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object,
  header: PropTypes.string
};
Google.defaultProps = {
  width: 652,
  styles: {},
  header: "Color picker"
};
ColorWrap(Google);
function _EMOTION_STRINGIFIED_CSS_ERROR__$9() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledColorPicker = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1rgp0874"
} : {
  target: "e1rgp0874",
  label: "StyledColorPicker"
})(({
  disabled: n,
  theme: t
}) => ({
  fontFamily: t.genericFonts.bodyFont,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  cursor: n ? "not-allowed" : "default"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledChromePicker = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1rgp0873"
} : {
  target: "e1rgp0873",
  label: "StyledChromePicker"
})(({
  theme: n
}) => ({
  div: {
    fontFamily: `${n.genericFonts.bodyFont} !important`
  },
  // The overrides below are a bit hacky but unfortunately the ChromePicker component
  // doesn't offer a way to override labels and inputs, see
  // https://github.com/casesandberg/react-color/issues/643
  label: {
    fontSize: `${n.fontSizes.sm} !important`,
    color: `${n.colors.bodyText} !important`
  },
  input: {
    fontSize: `${n.fontSizes.md} !important`,
    height: `${n.sizes.minElementHeight} !important`,
    backgroundColor: `${n.colors.secondaryBg} !important`,
    color: `${n.colors.bodyText} !important`,
    borderRadius: `${n.radii.default} !important`,
    boxShadow: "none !important",
    "&:focus-visible": {
      outline: `${n.sizes.borderWidth} solid ${n.colors.primary} !important`
    }
  },
  svg: {
    // This is the arrow button on the right. The hover color for the background is
    // apparently set by JS and not CSS, so we can't override it.
    fill: `${n.colors.bodyText} !important`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledColorPreview = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1rgp0872"
} : {
  target: "e1rgp0872",
  label: "StyledColorPreview"
})(({
  disabled: n,
  theme: t
}) => ({
  height: t.sizes.minElementHeight,
  borderRadius: t.radii.default,
  borderColor: t.colors.borderColor,
  cursor: n ? "not-allowed" : "pointer",
  pointerEvents: n ? "none" : "auto",
  boxShadow: "none",
  lineHeight: t.lineHeights.base,
  gap: t.spacing.md,
  "&:focus": {
    outline: "none"
  },
  display: "flex"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledColorBlock = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1rgp0871"
} : {
  target: "e1rgp0871",
  label: "StyledColorBlock"
})(({
  backgroundColor: n,
  disabled: t,
  theme: g
}) => ({
  width: g.sizes.minElementHeight,
  height: g.sizes.minElementHeight,
  borderRadius: g.radii.default,
  borderColor: g.colors.borderColor,
  borderWidth: g.sizes.borderWidth,
  opacity: t ? "0.4" : "",
  backgroundColor: n,
  borderStyle: "solid",
  cursor: "pointer",
  lineHeight: g.lineHeights.base,
  "&:focus": {
    outline: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledColorValue = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1rgp0870"
} : {
  target: "e1rgp0870",
  label: "StyledColorValue"
})(process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "s5xdrg",
  styles: "display:flex;align-items:center/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});
Saturation.prototype.getContainerRenderWindow = function() {
  const n = this.container;
  let t = window, g = window;
  try {
    for (; !t.document.contains(n) && t.parent !== t; )
      g = t, t = t.parent;
  } catch {
    t = g;
  }
  return t;
};
const BaseColorPicker = (n) => {
  const {
    disabled: t,
    value: g,
    showValue: d,
    label: k,
    labelVisibility: H,
    onChange: AA,
    help: gA
  } = n, [IA, CA] = useState(g), BA = useEmotionTheme();
  useEffect(() => {
    CA(g);
  }, [g]);
  const eA = useCallback((tA) => {
    CA(tA.hex);
  }, []), iA = useCallback(() => {
    AA(IA);
  }, [AA, IA]), QA = {
    default: {
      picker: {
        borderRadius: BA.radii.default,
        // Remove the box shadow from the color picker component since we're already
        // applying a shadow to the popover that contains the color picker.
        boxShadow: "none",
        backgroundColor: BA.colors.bgColor
      },
      saturation: {
        borderRadius: `${BA.radii.default} ${BA.radii.default} 0 0`,
        // Prevent text selection while the mouse is clicked to select a color. This
        // can be annoying if you select a color and then move the mouse outside the
        // color picker.
        // We need the `as const` here to prevent a typing error (even though it
        // also works correctly without it).
        userSelect: "none"
      },
      body: {
        padding: BA.spacing.xl
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledColorPicker, { className: "stColorPicker", "data-testid": "stColorPicker", disabled: t, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(WidgetLabel, { label: k, disabled: t, labelVisibility: H, children: gA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledWidgetLabelHelpInline, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { content: gA, placement: Placement.TOP_RIGHT }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StatefulPopover, { onClose: iA, placement: "bottomLeft", content: () => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledChromePicker, { "data-testid": "stColorPickerPopover", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChromePicker, { color: IA, onChange: eA, disableAlpha: !0, styles: QA }) }), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledColorPreview, { disabled: t, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledColorBlock, { "data-testid": "stColorPickerBlock", backgroundColor: IA, disabled: t }),
      d && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledColorValue, { children: IA.toUpperCase() })
    ] }) })
  ] });
}, BaseColorPicker$1 = memo$1(BaseColorPicker);
var _excluded$h = ["title", "size", "color", "overrides"];
function _extends$i() {
  return _extends$i = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$i.apply(this, arguments);
}
function _objectWithoutProperties$f(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$f(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$f(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _slicedToArray$e(n, t) {
  return _arrayWithHoles$d(n) || _iterableToArrayLimit$d(n, t) || _unsupportedIterableToArray$d(n, t) || _nonIterableRest$d();
}
function _nonIterableRest$d() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$d(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$d(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$d(n, t);
  }
}
function _arrayLikeToArray$d(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$d(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$d(n) {
  if (Array.isArray(n)) return n;
}
function ChevronDown(n, t) {
  var g = useStyletron(), d = _slicedToArray$e(g, 2), k = d[1], H = n.title, AA = H === void 0 ? "Down" : H, gA = n.size, IA = n.color, CA = n.overrides, BA = CA === void 0 ? {} : CA, eA = _objectWithoutProperties$f(n, _excluded$h), iA = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: k.icons && k.icons.ChevronDown ? k.icons.ChevronDown : null
    },
    BA && BA.Svg ? toObjectOverride(BA.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$2, _extends$i({
    viewBox: "0 0 24 24",
    ref: t,
    title: AA,
    size: gA,
    color: IA,
    overrides: {
      Svg: iA
    }
  }, eA), /* @__PURE__ */ React.createElement("path", {
    transform: "rotate(270, 12, 12)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12C9 12.2652 9.10536 12.5196 9.29289 12.7071L13.2929 16.7071C13.6834 17.0976 14.3166 17.0976 14.7071 16.7071C15.0976 16.3166 15.0976 15.6834 14.7071 15.2929L11.4142 12L14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289C14.3166 6.90237 13.6834 6.90237 13.2929 7.29289L9.29289 11.2929C9.10536 11.4804 9 11.7348 9 12Z"
  }));
}
const ChevronDown$1 = /* @__PURE__ */ React.forwardRef(ChevronDown);
var _excluded$g = ["title", "size", "color", "overrides"];
function _extends$h() {
  return _extends$h = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$h.apply(this, arguments);
}
function _objectWithoutProperties$e(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$e(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$e(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _slicedToArray$d(n, t) {
  return _arrayWithHoles$c(n) || _iterableToArrayLimit$c(n, t) || _unsupportedIterableToArray$c(n, t) || _nonIterableRest$c();
}
function _nonIterableRest$c() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$c(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$c(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$c(n, t);
  }
}
function _arrayLikeToArray$c(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$c(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$c(n) {
  if (Array.isArray(n)) return n;
}
function DeleteAlt(n, t) {
  var g = useStyletron(), d = _slicedToArray$d(g, 2), k = d[1], H = n.title, AA = H === void 0 ? "Delete Alt" : H, gA = n.size, IA = n.color, CA = n.overrides, BA = CA === void 0 ? {} : CA, eA = _objectWithoutProperties$e(n, _excluded$g), iA = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: k.icons && k.icons.DeleteAlt ? k.icons.DeleteAlt : null
    },
    BA && BA.Svg ? toObjectOverride(BA.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$2, _extends$h({
    viewBox: "0 0 24 24",
    ref: t,
    title: AA,
    size: gA,
    color: IA,
    overrides: {
      Svg: iA
    }
  }, eA), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58173 16.4183 4 12 4C7.58173 4 4 7.58173 4 12C4 16.4183 7.58173 20 12 20ZM10.0303 8.96967C9.73743 8.67679 9.26257 8.67679 8.96967 8.96967C8.67676 9.26257 8.67676 9.73743 8.96967 10.0303L10.9393 12L8.96967 13.9697C8.67676 14.2626 8.67676 14.7374 8.96967 15.0303C9.26257 15.3232 9.73743 15.3232 10.0303 15.0303L12 13.0607L13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L13.0607 12L15.0303 10.0303C15.3232 9.73743 15.3232 9.26257 15.0303 8.96967C14.7374 8.67679 14.2626 8.67679 13.9697 8.96967L12 10.9393L10.0303 8.96967Z"
  }));
}
const DeleteAlt$1 = /* @__PURE__ */ React.forwardRef(DeleteAlt);
var _excluded$f = ["title", "size", "color", "overrides"];
function _extends$g() {
  return _extends$g = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$g.apply(this, arguments);
}
function _objectWithoutProperties$d(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$d(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$d(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _slicedToArray$c(n, t) {
  return _arrayWithHoles$b(n) || _iterableToArrayLimit$b(n, t) || _unsupportedIterableToArray$b(n, t) || _nonIterableRest$b();
}
function _nonIterableRest$b() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$b(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$b(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$b(n, t);
  }
}
function _arrayLikeToArray$b(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$b(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$b(n) {
  if (Array.isArray(n)) return n;
}
function Search(n, t) {
  var g = useStyletron(), d = _slicedToArray$c(g, 2), k = d[1], H = n.title, AA = H === void 0 ? "Search" : H, gA = n.size, IA = n.color, CA = n.overrides, BA = CA === void 0 ? {} : CA, eA = _objectWithoutProperties$d(n, _excluded$f), iA = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: k.icons && k.icons.Search ? k.icons.Search : null
    },
    BA && BA.Svg ? toObjectOverride(BA.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$2, _extends$g({
    viewBox: "0 0 24 24",
    ref: t,
    title: AA,
    size: gA,
    color: IA,
    overrides: {
      Svg: iA
    }
  }, eA), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6C8.79086 6 7 7.79086 7 10C7 12.2091 8.79086 14 11 14C13.2091 14 15 12.2091 15 10C15 7.79086 13.2091 6 11 6ZM5 10C5 6.68629 7.68629 4 11 4C14.3137 4 17 6.68629 17 10C17 11.2958 16.5892 12.4957 15.8907 13.4765L19.7071 17.2929C20.0976 17.6834 20.0976 18.3166 19.7071 18.7071C19.3166 19.0976 18.6834 19.0976 18.2929 18.7071L14.4765 14.8907C13.4957 15.5892 12.2958 16 11 16C7.68629 16 5 13.3137 5 10Z"
  }));
}
const SearchIconComponent = /* @__PURE__ */ React.forwardRef(Search);
var _excluded$e = ["title", "size", "color", "overrides"];
function _extends$f() {
  return _extends$f = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$f.apply(this, arguments);
}
function _objectWithoutProperties$c(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$c(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$c(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _slicedToArray$b(n, t) {
  return _arrayWithHoles$a(n) || _iterableToArrayLimit$a(n, t) || _unsupportedIterableToArray$a(n, t) || _nonIterableRest$a();
}
function _nonIterableRest$a() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$a(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$a(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$a(n, t);
  }
}
function _arrayLikeToArray$a(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$a(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$a(n) {
  if (Array.isArray(n)) return n;
}
function TriangleDown(n, t) {
  var g = useStyletron(), d = _slicedToArray$b(g, 2), k = d[1], H = n.title, AA = H === void 0 ? "Triangle Down" : H, gA = n.size, IA = n.color, CA = n.overrides, BA = CA === void 0 ? {} : CA, eA = _objectWithoutProperties$c(n, _excluded$e), iA = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: k.icons && k.icons.TriangleDown ? k.icons.TriangleDown : null
    },
    BA && BA.Svg ? toObjectOverride(BA.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$2, _extends$f({
    viewBox: "0 0 24 24",
    ref: t,
    title: AA,
    size: gA,
    color: IA,
    overrides: {
      Svg: iA
    }
  }, eA), /* @__PURE__ */ React.createElement("path", {
    d: "M12.7071 15.2929L17.1464 10.8536C17.4614 10.5386 17.2383 10 16.7929 10L7.20711 10C6.76165 10 6.53857 10.5386 6.85355 10.8536L11.2929 15.2929C11.6834 15.6834 12.3166 15.6834 12.7071 15.2929Z"
  }));
}
const TriangleDownIcon = /* @__PURE__ */ React.forwardRef(TriangleDown);
var CUSTOM_INPUT_TYPE = {
  textarea: "textarea"
}, ADJOINED = {
  none: "none",
  left: "left",
  right: "right",
  both: "both"
}, SIZE$1 = {
  mini: "mini",
  default: "default",
  compact: "compact",
  large: "large"
}, ENHANCER_POSITION = {
  start: "start",
  end: "end"
}, TYPE = {
  select: "select",
  search: "search"
}, STATE_CHANGE_TYPE = Object.freeze({
  select: "select",
  remove: "remove",
  clear: "clear"
}), STATE_CHANGE_TYPES = {
  click: "click",
  moveUp: "moveUp",
  moveDown: "moveDown",
  mouseEnter: "mouseEnter",
  focus: "focus",
  reset: "reset",
  character: "character",
  enter: "enter"
}, KEY_STRINGS = {
  ArrowUp: "ArrowUp",
  ArrowDown: "ArrowDown",
  ArrowLeft: "ArrowLeft",
  ArrowRight: "ArrowRight",
  Enter: "Enter",
  Home: "Home",
  End: "End"
}, OPTION_LIST_SIZE = {
  default: "default",
  compact: "compact"
}, _excluded$d = ["item"];
function _objectWithoutProperties$b(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$b(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$b(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function ownKeys$b(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$9(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$b(Object(g), !0).forEach(function(d) {
      _defineProperty$d(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$b(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$d(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var StyledList = styled("ul", function(n) {
  var t = n.$theme, g = n.$isFocusVisible;
  return {
    backgroundColor: t.colors.menuFill,
    position: "relative",
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    paddingTop: t.sizing.scale300,
    paddingBottom: t.sizing.scale300,
    paddingLeft: 0,
    paddingRight: 0,
    borderTopLeftRadius: t.borders.popoverBorderRadius,
    borderTopRightRadius: t.borders.popoverBorderRadius,
    borderBottomRightRadius: t.borders.popoverBorderRadius,
    borderBottomLeftRadius: t.borders.popoverBorderRadius,
    boxShadow: t.lighting.shadow600,
    overflow: "auto",
    ":focus": {
      outline: g ? "3px solid ".concat(t.colors.accent) : "none"
    }
  };
});
StyledList.displayName = "StyledList";
StyledList.displayName = "StyledList";
function getFontColor(n) {
  return n.$disabled ? n.$theme.colors.menuFontDisabled : n.$isHighlighted && n.$isFocused ? n.$theme.colors.menuFontHighlighted : n.$isHighlighted && !n.$isFocused ? n.$theme.colors.menuFontSelected : n.$theme.colors.menuFontDefault;
}
function getBackgroundColor(n) {
  return n.$disabled ? "transparent" : n.$isHighlighted ? n.$theme.colors.menuFillHover : "transparent";
}
var StyledEmptyState = styled("li", function(n) {
  var t = n.$theme, g = n.$size;
  return _objectSpread$9(_objectSpread$9({}, g === OPTION_LIST_SIZE.compact ? t.typography.font100 : t.typography.font200), {}, {
    position: "relative",
    display: "block",
    color: t.colors.menuFontDisabled,
    textAlign: "center",
    cursor: "not-allowed",
    backgroundColor: "transparent",
    marginBottom: 0,
    paddingTop: t.sizing.scale800,
    paddingBottom: t.sizing.scale800,
    paddingRight: t.sizing.scale800,
    paddingLeft: t.sizing.scale800
  });
});
StyledEmptyState.displayName = "StyledEmptyState";
StyledEmptyState.displayName = "StyledEmptyState";
var StyledOptgroupHeader = styled("li", function(n) {
  var t = n.$theme.sizing.scale300, g = n.$theme.sizing.scale200;
  return _objectSpread$9(_objectSpread$9({}, n.$theme.typography.font250), {}, {
    color: n.$theme.colors.contentPrimary,
    paddingTop: g,
    paddingBottom: g,
    paddingRight: t,
    paddingLeft: t
  });
});
StyledOptgroupHeader.displayName = "StyledOptgroupHeader";
StyledOptgroupHeader.displayName = "StyledOptgroupHeader";
var StyledListItemAnchor = styled("a", function(n) {
  return {
    display: "block",
    color: getFontColor(n)
  };
});
StyledListItemAnchor.displayName = "StyledListItemAnchor";
StyledListItemAnchor.displayName = "StyledListItemAnchor";
var StyledListItemElement = styled("li", function(n) {
  var t = n.$disabled, g = n.$theme, d = n.$size;
  return _objectSpread$9(_objectSpread$9({}, d === OPTION_LIST_SIZE.compact ? g.typography.font100 : g.typography.font200), {}, {
    boxSizing: "border-box",
    position: "relative",
    display: "block",
    color: getFontColor(n),
    cursor: t ? "not-allowed" : "pointer",
    backgroundColor: getBackgroundColor(n),
    transitionProperty: "color, background-color",
    transitionDuration: g.animation.timing200,
    transitionTimingFunction: g.animation.easeOutCurve,
    marginBottom: 0,
    paddingTop: d === OPTION_LIST_SIZE.compact ? g.sizing.scale100 : g.sizing.scale300,
    paddingBottom: d === OPTION_LIST_SIZE.compact ? g.sizing.scale100 : g.sizing.scale300,
    paddingRight: d === OPTION_LIST_SIZE.compact ? g.sizing.scale900 : g.sizing.scale600,
    paddingLeft: d === OPTION_LIST_SIZE.compact ? g.sizing.scale900 : g.sizing.scale600,
    ":focus": {
      outline: "none"
    }
  });
});
StyledListItemElement.displayName = "StyledListItemElement";
StyledListItemElement.displayName = "StyledListItemElement";
var StyledListItem = withWrapper(StyledListItemElement, function(n) {
  return (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (function(g) {
      g.item;
      var d = _objectWithoutProperties$b(g, _excluded$d);
      return /* @__PURE__ */ React.createElement(n, d);
    })
  );
}), StyledListItemProfile = styled("li", function(n) {
  var t = n.$theme;
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: t.sizing.scale300,
    paddingBottom: t.sizing.scale300,
    paddingRight: t.sizing.scale800,
    paddingLeft: t.sizing.scale800,
    transitionProperty: "color, background-color",
    transitionDuration: t.animation.timing200,
    transitionTimingFunction: t.animation.easeOutCurve,
    ":hover": {
      backgroundColor: t.colors.menuFillHover
    }
  };
});
StyledListItemProfile.displayName = "StyledListItemProfile";
StyledListItemProfile.displayName = "StyledListItemProfile";
var StyledProfileImgContainer = styled("div", {
  width: "60px",
  height: "60px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});
StyledProfileImgContainer.displayName = "StyledProfileImgContainer";
StyledProfileImgContainer.displayName = "StyledProfileImgContainer";
var StyledProfileImg = styled("img", {
  width: "100%",
  height: "100%",
  borderTopLeftRadius: "50%",
  borderTopRightRadius: "50%",
  borderBottomRightRadius: "50%",
  borderBottomLeftRadius: "50%"
});
StyledProfileImg.displayName = "StyledProfileImg";
StyledProfileImg.displayName = "StyledProfileImg";
var StyledProfileLabelsContainer = styled("div", function(n) {
  var t = n.$theme, g = t.direction, d = t.sizing;
  return _objectSpread$9({
    alignSelf: g === "rtl" ? "flex-end" : "flex-start",
    display: "flex",
    flexDirection: "column"
  }, g === "rtl" ? {
    marginRight: d.scale600
  } : {
    marginLeft: d.scale600
  });
});
StyledProfileLabelsContainer.displayName = "StyledProfileLabelsContainer";
StyledProfileLabelsContainer.displayName = "StyledProfileLabelsContainer";
var StyledProfileTitle = styled("h6", function(n) {
  var t = n.$theme;
  return _objectSpread$9(_objectSpread$9({}, t.typography.font350), {}, {
    color: t.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileTitle.displayName = "StyledProfileTitle";
StyledProfileTitle.displayName = "StyledProfileTitle";
var StyledProfileSubtitle = styled("p", function(n) {
  var t = n.$theme;
  return _objectSpread$9(_objectSpread$9({}, t.typography.font200), {}, {
    color: t.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileSubtitle.displayName = "StyledProfileSubtitle";
StyledProfileSubtitle.displayName = "StyledProfileSubtitle";
var StyledProfileBody = styled("p", function(n) {
  var t = n.$theme;
  return _objectSpread$9(_objectSpread$9({}, t.typography.font100), {}, {
    color: t.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileBody.displayName = "StyledProfileBody";
StyledProfileBody.displayName = "StyledProfileBody";
var StyledMenuDivider$1 = styled("li", function(n) {
  var t = n.$theme;
  return {
    color: t.colors.contentPrimary,
    borderBottomWidth: t.borders.border300.borderWidth,
    borderBottomStyle: t.borders.border300.borderStyle,
    borderBottomColor: t.borders.border300.borderColor,
    marginTop: t.sizing.scale100,
    marginBottom: t.sizing.scale100,
    marginLeft: t.sizing.scale500,
    marginRight: t.sizing.scale500,
    listStyle: "none",
    height: 0
  };
});
StyledMenuDivider$1.displayName = "StyledMenuDivider";
StyledProfileBody.displayName = "StyledMenuDivider";
var NestedMenuContext = /* @__PURE__ */ React.createContext({
  addMenuToNesting: function n() {
  },
  removeMenuFromNesting: function n() {
  },
  // @ts-expect-error todo(flow->ts): incorrect default value
  getParentMenu: function n() {
  },
  // @ts-expect-error todo(flow->ts): incorrect default value
  getChildMenu: function n() {
  },
  nestedMenuHoverIndex: -1,
  isNestedMenuVisible: function n() {
    return !1;
  },
  mountRef: {
    current: null
  }
});
function _extends$e() {
  return _extends$e = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$e.apply(this, arguments);
}
function _slicedToArray$a(n, t) {
  return _arrayWithHoles$9(n) || _iterableToArrayLimit$9(n, t) || _unsupportedIterableToArray$9(n, t) || _nonIterableRest$9();
}
function _nonIterableRest$9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$9(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$9(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$9(n, t);
  }
}
function _arrayLikeToArray$9(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$9(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$9(n) {
  if (Array.isArray(n)) return n;
}
var MaybeChildMenu = function n(t) {
  if (!t.getChildMenu)
    return t.children;
  var g = t.getChildMenu(t.item);
  if (!g)
    return t.children;
  var d = t.overrides, k = d === void 0 ? {} : d, H = getOverrides(k.ChildMenuPopover, Popover$2), AA = _slicedToArray$a(H, 2), gA = AA[0], IA = AA[1];
  return /* @__PURE__ */ React.createElement(NestedMenuContext.Consumer, null, function(CA) {
    return /* @__PURE__ */ React.createElement(gA, _extends$e({
      focusLock: !1,
      autoFocus: !1,
      isOpen: t.isOpen,
      renderAll: t.renderAll,
      content: g,
      ignoreBoundary: !0,
      mountNode: CA.mountRef.current ? CA.mountRef.current : void 0,
      onClick: t.onClick,
      onMouseEnterDelay: 30,
      onMouseLeaveDelay: 30,
      onEsc: t.resetParentMenu,
      placement: "rightTop"
    }, IA, {
      overrides: mergeOverrides({
        Body: {
          props: {
            // Trap tabbing when focused on a child menu. Popover mounts the element at the end of
            // the html body by default. If a user was to tab to the next element it would navigate
            // to elements not within the immediate area surrounding the menu.
            onKeyDown: function(eA) {
              eA.keyCode === 9 && eA.preventDefault();
            }
          }
        }
      }, IA.overrides)
    }), t.children);
  });
}, _excluded$c = ["getChildMenu", "getItemLabel", "item", "onClick", "onMouseEnter", "overrides", "renderHrefAsAnchor", "resetMenu", "size", "$isHighlighted", "renderAll"];
function ownKeys$a(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$8(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$a(Object(g), !0).forEach(function(d) {
      _defineProperty$c(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$a(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$c(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function _extends$d() {
  return _extends$d = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$d.apply(this, arguments);
}
function _slicedToArray$9(n, t) {
  return _arrayWithHoles$8(n) || _iterableToArrayLimit$8(n, t) || _unsupportedIterableToArray$8(n, t) || _nonIterableRest$8();
}
function _nonIterableRest$8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$8(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$8(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$8(n, t);
  }
}
function _arrayLikeToArray$8(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$8(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$8(n) {
  if (Array.isArray(n)) return n;
}
function _objectWithoutProperties$a(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$a(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$a(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function OptionList(n, t) {
  var g = n.getChildMenu, d = n.getItemLabel, k = d === void 0 ? function(yA) {
    return yA ? yA.label : "";
  } : d, H = n.item, AA = n.onClick, gA = AA === void 0 ? function() {
  } : AA, IA = n.onMouseEnter, CA = IA === void 0 ? function() {
  } : IA, BA = n.overrides, eA = BA === void 0 ? {} : BA, iA = n.renderHrefAsAnchor, QA = iA === void 0 ? !0 : iA, tA = n.resetMenu, oA = tA === void 0 ? function() {
  } : tA, EA = n.size, aA = EA === void 0 ? OPTION_LIST_SIZE.default : EA, nA = n.$isHighlighted, lA = n.renderAll, cA = _objectWithoutProperties$a(n, _excluded$c), sA = getOverrides(eA.ListItem, StyledListItem), rA = _slicedToArray$9(sA, 2), uA = rA[0], hA = rA[1], dA = getOverrides(eA.ListItemAnchor, StyledListItemAnchor), GA = _slicedToArray$9(dA, 2), DA = GA[0], wA = GA[1], bA = function(pA) {
    return pA.href && QA ? /* @__PURE__ */ React.createElement(DA, _extends$d({
      $item: pA,
      href: pA.href
    }, wA), k(pA)) : /* @__PURE__ */ React.createElement(React.Fragment, null, k(pA));
  };
  return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(yA) {
    return /* @__PURE__ */ React.createElement(MaybeChildMenu, {
      getChildMenu: g,
      isOpen: !!nA,
      item: H,
      resetParentMenu: oA,
      renderAll: lA,
      onClick: gA,
      overrides: eA
    }, /* @__PURE__ */ React.createElement(uA, _extends$d({
      ref: t,
      "aria-label": g && g(H) ? yA.menu.parentMenuItemAriaLabel : null,
      item: H,
      onClick: gA,
      onMouseEnter: CA,
      $size: aA,
      $isHighlighted: nA
    }, cA, hA), bA(_objectSpread$8({
      isHighlighted: nA
    }, H))));
  });
}
function areEqualShallow(n, t) {
  if (!n || !t) return !1;
  for (var g in n)
    if (n[g] !== t[g])
      return !1;
  return !0;
}
function compare(n, t) {
  return n.$isHighlighted === t.$isHighlighted && n.$isFocused === t.$isFocused && areEqualShallow(n.item, t.item) && areEqualShallow(n.overrides, t.overrides) && n.size === t.size && n.getItemLabel === t.getItemLabel && n.getChildMenu === t.getChildMenu && n.resetMenu === t.resetMenu;
}
var forwarded = /* @__PURE__ */ React.forwardRef(OptionList);
forwarded.displayName = "OptionList";
const OptionList$1 = /* @__PURE__ */ React.memo(forwarded, compare);
var _excluded$b = ["disabled", "isFocused", "isHighlighted", "resetMenu"];
function _objectWithoutProperties$9(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$9(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$9(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _extends$c() {
  return _extends$c = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$c.apply(this, arguments);
}
function _slicedToArray$8(n, t) {
  return _arrayWithHoles$7(n) || _iterableToArrayLimit$7(n, t) || _unsupportedIterableToArray$7(n, t) || _nonIterableRest$7();
}
function _nonIterableRest$7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$7(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$7(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$7(n, t);
  }
}
function _arrayLikeToArray$7(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$7(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$7(n) {
  if (Array.isArray(n)) return n;
}
function Menu(n) {
  var t = n.overrides, g = t === void 0 ? {} : t, d = n["aria-label"], k = d === void 0 ? "Menu" : d, H = n.rootRef, AA = H === void 0 ? /* @__PURE__ */ React.createRef() : H, gA = n.focusMenu, IA = gA === void 0 ? function() {
  } : gA, CA = n.unfocusMenu, BA = CA === void 0 ? function() {
  } : CA, eA = n.handleMouseLeave, iA = eA === void 0 ? function() {
  } : eA, QA = n.handleKeyDown, tA = QA === void 0 ? function(FA) {
  } : QA, oA = n.renderAll, EA = oA === void 0 ? !1 : oA, aA = React.useState(!1), nA = _slicedToArray$8(aA, 2), lA = nA[0], cA = nA[1], sA = function(mA) {
    isFocusVisible(mA) && cA(!0);
  }, rA = function(mA) {
    lA !== !1 && cA(!1);
  }, uA = getOverrides(g.List, StyledList), hA = _slicedToArray$8(uA, 2), dA = hA[0], GA = hA[1], DA = getOverrides(g.Option, OptionList$1), wA = _slicedToArray$8(DA, 2), bA = wA[0], yA = wA[1], pA = getOverrides(g.EmptyState, StyledEmptyState), MA = _slicedToArray$8(pA, 2), LA = MA[0], xA = MA[1], TA = getOverrides(g.OptgroupHeader, StyledOptgroupHeader), NA = _slicedToArray$8(TA, 2), zA = NA[0], XA = NA[1], fA = getOverrides(g.MenuDivider, StyledMenuDivider$1), vA = _slicedToArray$8(fA, 2), Cg = vA[0], Ig = vA[1], gg = Array.isArray(n.items) ? {
    __ungrouped: n.items
  } : n.items, og = Object.keys(gg), eg = og.reduce(function(FA, mA) {
    var JA = _slicedToArray$8(FA, 2), VA = JA[0], HA = JA[1];
    mA !== "__ungrouped" && VA.push(/* @__PURE__ */ React.createElement(zA, _extends$c({
      key: mA
    }, XA), mA));
    var jA = gg[mA].map(function(_A, $A) {
      HA = HA + 1;
      var rg = n.getRequiredItemProps, wg = rg === void 0 ? function(Gg, bg) {
        return {};
      } : rg;
      if (_A.divider === !0)
        return /* @__PURE__ */ React.createElement(Cg, Ig);
      var Dg = wg(_A, HA), kg = Dg.disabled, ig = Dg.isFocused, ZA = Dg.isHighlighted, KA = Dg.resetMenu, PA = KA === void 0 ? function() {
      } : KA, ag = _objectWithoutProperties$9(Dg, _excluded$b);
      return /* @__PURE__ */ React.createElement(bA, _extends$c({
        renderAll: EA,
        key: HA,
        item: _A,
        overrides: n.overrides,
        resetMenu: PA,
        role: "option",
        $disabled: kg,
        $isFocused: ig,
        $isHighlighted: ZA,
        "aria-disabled": kg,
        "aria-selected": ZA && ig
      }, ag, yA));
    });
    return [VA.concat(jA), HA];
  }, [[], -1]), kA = _slicedToArray$8(eg, 1), YA = kA[0], RA = og.every(function(FA) {
    return !gg[FA].length;
  });
  return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(FA) {
    return /* @__PURE__ */ React.createElement(dA, _extends$c({
      "aria-activedescendant": n.activedescendantId || null,
      role: "listbox",
      "aria-label": k,
      ref: AA,
      onMouseEnter: IA,
      onMouseLeave: iA,
      onMouseOver: IA,
      onFocus: forkFocus({
        onFocus: IA
      }, sA),
      onBlur: forkBlur({
        onBlur: BA
      }, rA),
      onKeyDown: function(JA) {
        n.isFocused && tA(JA);
      },
      tabIndex: 0,
      "data-baseweb": "menu",
      $isFocusVisible: lA
    }, GA), RA ? /* @__PURE__ */ React.createElement(LA, _extends$c({
      "aria-live": "polite",
      "aria-atomic": !0
    }, xA), n.noResultsMsg || FA.menu.noResultsMsg) : YA);
  });
}
function scrollItemIntoView(n, t, g, d) {
  var k = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "auto";
  if (n) {
    var H = n.getBoundingClientRect(), AA = t.getBoundingClientRect();
    if (H.bottom > AA.bottom)
      if (d)
        t.scrollTop = t.scrollHeight - AA.height;
      else {
        var gA = n.offsetTop + H.height;
        t.scrollTop = gA - (k === "center" ? Math.round((AA.height + H.height) / 2) : AA.height);
      }
    else H.top < AA.top && (g ? t.scrollTop = 0 : t.scrollTop = n.offsetTop - (k === "center" ? Math.round((AA.height - H.height) / 2) : 0));
  }
}
function _typeof$7(n) {
  "@babel/helpers - typeof";
  return _typeof$7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$7(n);
}
var _excluded$a = ["disabled"], _excluded2$3 = ["initialState", "stateReducer", "children", "onItemSelect", "addMenuToNesting", "removeMenuFromNesting", "getParentMenu", "getChildMenu", "forceHighlight"];
function _extends$b() {
  return _extends$b = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$b.apply(this, arguments);
}
function _objectWithoutProperties$8(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$8(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$8(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function ownKeys$9(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$7(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$9(Object(g), !0).forEach(function(d) {
      _defineProperty$b(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$9(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _classCallCheck$5(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$5(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$5(n, t, g) {
  return t && _defineProperties$5(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$5(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$5(n, t);
}
function _setPrototypeOf$5(n, t) {
  return _setPrototypeOf$5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$5(n, t);
}
function _createSuper$5(n) {
  var t = _isNativeReflectConstruct$5();
  return function() {
    var d = _getPrototypeOf$5(n), k;
    if (t) {
      var H = _getPrototypeOf$5(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$5(this, k);
  };
}
function _possibleConstructorReturn$5(n, t) {
  if (t && (_typeof$7(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$5(n);
}
function _assertThisInitialized$5(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$5() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$5(n) {
  return _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$5(n);
}
function _defineProperty$b(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var DEFAULT_PROPS = {
  // keeping it in defaultProps to satisfy Flow
  initialState: {
    // We start the index at -1 to indicate that no highlighting exists initially
    highlightedIndex: -1,
    isFocused: !1
  },
  typeAhead: !0,
  keyboardControlNode: {
    current: null
  },
  stateReducer: function(n, t) {
    return t;
  },
  onItemSelect: function n() {
  },
  getRequiredItemProps: function n() {
    return {};
  },
  children: function n() {
    return null;
  },
  // from nested-menus context
  addMenuToNesting: function n() {
  },
  removeMenuFromNesting: function n() {
  },
  getParentMenu: function n() {
  },
  getChildMenu: function n() {
  },
  nestedMenuHoverIndex: -1,
  isNestedMenuVisible: function n() {
    return !1;
  },
  forceHighlight: !1
}, MenuStatefulContainerInner = /* @__PURE__ */ (function(n) {
  _inherits$5(g, n);
  var t = _createSuper$5(g);
  function g() {
    var d;
    _classCallCheck$5(this, g);
    for (var k = arguments.length, H = new Array(k), AA = 0; AA < k; AA++)
      H[AA] = arguments[AA];
    return d = t.call.apply(t, [this].concat(H)), _defineProperty$b(_assertThisInitialized$5(d), "state", _objectSpread$7(_objectSpread$7({}, d.constructor.defaultProps.initialState), d.props.initialState)), _defineProperty$b(_assertThisInitialized$5(d), "rootRef", /* @__PURE__ */ React.createRef()), _defineProperty$b(_assertThisInitialized$5(d), "keyboardControlNode", d.props.keyboardControlNode.current), _defineProperty$b(_assertThisInitialized$5(d), "refList", []), _defineProperty$b(_assertThisInitialized$5(d), "optionIds", []), _defineProperty$b(_assertThisInitialized$5(d), "typeAheadChars", ""), _defineProperty$b(_assertThisInitialized$5(d), "typeAheadTimeOut", null), _defineProperty$b(_assertThisInitialized$5(d), "onKeyDown", function(gA) {
      switch (gA.key) {
        case KEY_STRINGS.ArrowUp:
        case KEY_STRINGS.ArrowDown:
        case KEY_STRINGS.ArrowLeft:
        case KEY_STRINGS.ArrowRight:
        case KEY_STRINGS.Home:
        case KEY_STRINGS.End:
          d.handleArrowKey(gA);
          break;
        case KEY_STRINGS.Enter:
          if (gA.keyCode === 229)
            break;
          d.handleEnterKey(gA);
          break;
        default:
          d.props.typeAhead && (clearTimeout(d.typeAheadTimeOut), d.handleAlphaDown(gA));
          break;
      }
    }), _defineProperty$b(_assertThisInitialized$5(d), "handleAlphaDown", function(gA) {
      var IA = d.props.rootRef ? d.props.rootRef : d.rootRef, CA = d.state.highlightedIndex;
      d.typeAheadChars += gA.key, d.typeAheadTimeOut = setTimeout(function() {
        d.typeAheadChars = "";
      }, 500);
      var BA = CA, eA = d.getItems();
      if (!(eA.length === 0 || !("label" in eA[0]))) {
        for (var iA = !0, QA = 0; QA < eA.length; QA++) {
          var tA = eA[QA].label;
          if (tA && tA.toUpperCase && tA.toUpperCase().indexOf(d.typeAheadChars.toUpperCase()) === 0) {
            BA = QA, iA = !1;
            break;
          }
        }
        if (iA)
          for (var oA = 0; oA < eA.length; oA++) {
            var EA = eA[oA].label;
            if (EA && EA.toUpperCase && EA.toUpperCase().indexOf(d.typeAheadChars.toUpperCase()) > 0) {
              BA = oA;
              break;
            }
          }
        d.internalSetState(STATE_CHANGE_TYPES.character, {
          highlightedIndex: BA
        }), d.refList[BA] && scrollItemIntoView(d.refList[BA].current, IA.current, BA === 0, BA === eA.length - 1);
      }
    }), _defineProperty$b(_assertThisInitialized$5(d), "handleArrowKey", function(gA) {
      var IA = d.props.rootRef ? d.props.rootRef : d.rootRef, CA = d.state.highlightedIndex, BA = CA;
      if (gA.key === KEY_STRINGS.ArrowUp)
        gA.preventDefault(), BA = Math.max(0, CA - 1), d.internalSetState(STATE_CHANGE_TYPES.moveUp, {
          highlightedIndex: BA
        });
      else if (gA.key === KEY_STRINGS.ArrowDown)
        gA.preventDefault(), BA = Math.min(CA + 1, d.getItems().length - 1), d.internalSetState(STATE_CHANGE_TYPES.moveDown, {
          highlightedIndex: BA
        });
      else if (gA.key === KEY_STRINGS.Home)
        gA.preventDefault(), BA = 0, d.internalSetState(STATE_CHANGE_TYPES.moveUp, {
          highlightedIndex: BA
        });
      else if (gA.key === KEY_STRINGS.End)
        gA.preventDefault(), BA = d.getItems().length - 1, d.internalSetState(STATE_CHANGE_TYPES.moveDown, {
          highlightedIndex: BA
        });
      else if (gA.key === KEY_STRINGS.ArrowLeft) {
        if (d.props.getParentMenu) {
          var eA = d.props.getParentMenu(IA);
          eA && eA.current && eA.current.focus();
        }
      } else if (gA.key === KEY_STRINGS.ArrowRight && d.props.getChildMenu) {
        var iA = d.props.getChildMenu(IA);
        iA && iA.current && iA.current.focus();
      }
      d.refList[BA] && scrollItemIntoView(d.refList[BA].current, IA.current, BA === 0, BA === d.getItems().length - 1);
    }), _defineProperty$b(_assertThisInitialized$5(d), "handleEnterKey", function(gA) {
      var IA = d.props.onItemSelect, CA = d.state.highlightedIndex, BA = d.getItems();
      BA[CA] && IA && !BA[CA].disabled && (gA.preventDefault(), IA({
        item: BA[CA],
        event: gA
      }));
    }), _defineProperty$b(_assertThisInitialized$5(d), "handleItemClick", function(gA, IA, CA) {
      d.props.onItemSelect && !IA.disabled && (d.props.onItemSelect({
        item: IA,
        event: CA
      }), d.internalSetState(STATE_CHANGE_TYPES.click, {
        highlightedIndex: gA,
        activedescendantId: d.optionIds[gA]
      }));
    }), _defineProperty$b(_assertThisInitialized$5(d), "handleMouseEnter", function(gA) {
      d.internalSetState(STATE_CHANGE_TYPES.mouseEnter, {
        highlightedIndex: gA,
        activedescendantId: d.optionIds[gA]
      });
    }), _defineProperty$b(_assertThisInitialized$5(d), "handleMouseLeave", function(gA) {
    }), _defineProperty$b(_assertThisInitialized$5(d), "getRequiredItemProps", function(gA, IA) {
      var CA = d.refList[IA];
      CA || (CA = /* @__PURE__ */ React.createRef(), d.refList[IA] = CA, d.optionIds[IA] = d.props.uidSeed(IA));
      var BA = d.props.getRequiredItemProps(gA, IA), eA = BA.disabled, iA = _objectWithoutProperties$8(BA, _excluded$a), QA = typeof eA == "boolean" ? eA : !!gA.disabled;
      return _objectSpread$7(_objectSpread$7({
        id: iA.id || d.optionIds[IA],
        disabled: QA,
        ref: CA,
        isFocused: d.state.isFocused,
        isHighlighted: d.state.highlightedIndex === IA,
        resetMenu: d.resetMenu
      }, QA ? {} : {
        onClick: d.handleItemClick.bind(_assertThisInitialized$5(d), IA, gA),
        onMouseEnter: d.handleMouseEnter.bind(_assertThisInitialized$5(d), IA)
      }), iA);
    }), _defineProperty$b(_assertThisInitialized$5(d), "focusMenu", function(gA) {
      var IA = d.props.rootRef ? d.props.rootRef : d.rootRef;
      !d.state.isFocused && IA.current && // @ts-expect-error
      IA.current.contains(gA.target) && (d.state.highlightedIndex < 0 ? d.internalSetState(STATE_CHANGE_TYPES.focus, {
        isFocused: !0,
        highlightedIndex: 0
      }) : d.internalSetState(STATE_CHANGE_TYPES.focus, {
        isFocused: !0
      }), IA.current.focus());
    }), _defineProperty$b(_assertThisInitialized$5(d), "unfocusMenu", function() {
      d.internalSetState(STATE_CHANGE_TYPES.focus, {
        isFocused: !1
      });
    }), _defineProperty$b(_assertThisInitialized$5(d), "resetMenu", function() {
      d.internalSetState(STATE_CHANGE_TYPES.reset, {
        isFocused: !1,
        highlightedIndex: -1,
        activedescendantId: null
      });
    }), d;
  }
  return _createClass$5(g, [{
    key: "getItems",
    value: function() {
      var k = this;
      if (Array.isArray(this.props.items))
        return this.props.items;
      var H = Object.keys(this.props.items);
      return H.reduce(function(AA, gA) {
        return AA.concat(k.props.items[gA]);
      }, []);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var k = this.props.rootRef ? this.props.rootRef : this.rootRef;
      typeof document < "u" && (k.current && this.state.highlightedIndex > -1 && this.refList[this.state.highlightedIndex] && scrollItemIntoView(this.refList[this.state.highlightedIndex].current, k.current, this.state.highlightedIndex === 0, this.state.highlightedIndex === this.getItems().length - 1, "center"), this.state.isFocused && this.keyboardControlNode && this.keyboardControlNode.addEventListener("keydown", this.onKeyDown)), this.props.addMenuToNesting && this.props.addMenuToNesting(k);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      var k = this.props.rootRef ? this.props.rootRef : this.rootRef;
      typeof document < "u" && this.keyboardControlNode && this.keyboardControlNode.removeEventListener("keydown", this.onKeyDown), this.props.removeMenuFromNesting && this.props.removeMenuFromNesting(k);
    }
  }, {
    key: "componentDidUpdate",
    value: function(k, H) {
      typeof document < "u" && (!H.isFocused && this.state.isFocused ? this.keyboardControlNode && this.keyboardControlNode.addEventListener("keydown", this.onKeyDown) : H.isFocused && !this.state.isFocused && this.keyboardControlNode && this.keyboardControlNode.removeEventListener("keydown", this.onKeyDown));
      var AA = this.getItems().length;
      this.props.forceHighlight && this.state.highlightedIndex === -1 && AA > 0 && this.internalSetState(STATE_CHANGE_TYPES.enter, {
        highlightedIndex: 0
      }), AA === 0 && this.state.highlightedIndex !== -1 ? this.internalSetState(STATE_CHANGE_TYPES.enter, {
        highlightedIndex: -1
      }) : this.state.highlightedIndex >= AA && this.internalSetState(STATE_CHANGE_TYPES.enter, {
        highlightedIndex: 0
      }), this.props.isNestedMenuVisible && this.props.nestedMenuHoverIndex !== k.nestedMenuHoverIndex && !this.props.isNestedMenuVisible(this.rootRef) && !this.props.forceHighlight && this.setState({
        highlightedIndex: -1
      });
    }
    // One array to hold all list item refs
  }, {
    key: "internalSetState",
    value: (
      // Internal set state function that will also invoke stateReducer
      function(k, H) {
        var AA = this.props.stateReducer;
        this.props.onActiveDescendantChange && typeof H.highlightedIndex == "number" && this.state.highlightedIndex !== H.highlightedIndex && this.props.onActiveDescendantChange(this.optionIds[H.highlightedIndex]), this.setState(AA(k, H, this.state));
      }
    )
  }, {
    key: "render",
    value: function() {
      var k = this, H = this.props;
      H.initialState, H.stateReducer, H.children, H.onItemSelect, H.addMenuToNesting, H.removeMenuFromNesting, H.getParentMenu, H.getChildMenu, H.forceHighlight;
      var AA = _objectWithoutProperties$8(H, _excluded2$3);
      return this.props.children(_objectSpread$7(_objectSpread$7({}, AA), {}, {
        rootRef: this.props.rootRef ? this.props.rootRef : this.rootRef,
        activedescendantId: this.optionIds[this.state.highlightedIndex],
        getRequiredItemProps: function(IA, CA) {
          return k.getRequiredItemProps(IA, CA);
        },
        handleMouseLeave: this.handleMouseLeave,
        highlightedIndex: this.state.highlightedIndex,
        isFocused: this.state.isFocused,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        handleKeyDown: this.props.keyboardControlNode.current ? function(gA) {
        } : this.onKeyDown,
        focusMenu: this.focusMenu,
        unfocusMenu: this.unfocusMenu
      }));
    }
  }]), g;
})(React.Component);
_defineProperty$b(MenuStatefulContainerInner, "defaultProps", DEFAULT_PROPS);
var MenuStatefulContainer = function n(t) {
  return /* @__PURE__ */ React.createElement(MenuStatefulContainerInner, _extends$b({
    uidSeed: useUIDSeed()
  }, t));
};
MenuStatefulContainer.defaultProps = DEFAULT_PROPS;
function _typeof$6(n) {
  "@babel/helpers - typeof";
  return _typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$6(n);
}
var _excluded$9 = ["overrides"];
function _extends$a() {
  return _extends$a = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$a.apply(this, arguments);
}
function _objectWithoutProperties$7(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$7(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$7(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _classCallCheck$4(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$4(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$4(n, t, g) {
  return t && _defineProperties$4(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$4(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$4(n, t);
}
function _setPrototypeOf$4(n, t) {
  return _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$4(n, t);
}
function _createSuper$4(n) {
  var t = _isNativeReflectConstruct$4();
  return function() {
    var d = _getPrototypeOf$4(n), k;
    if (t) {
      var H = _getPrototypeOf$4(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$4(this, k);
  };
}
function _possibleConstructorReturn$4(n, t) {
  if (t && (_typeof$6(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$4(n);
}
function _assertThisInitialized$4(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$4() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$4(n) {
  return _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$4(n);
}
var StatefulMenu = /* @__PURE__ */ (function(n) {
  _inherits$4(g, n);
  var t = _createSuper$4(g);
  function g() {
    return _classCallCheck$4(this, g), t.apply(this, arguments);
  }
  return _createClass$4(g, [{
    key: "render",
    value: function() {
      var k = this.props, H = k.overrides, AA = _objectWithoutProperties$7(k, _excluded$9);
      return /* @__PURE__ */ React.createElement(NestedMenuContext.Consumer, null, function(gA) {
        return (
          //$FlowExpectedError[cannot-spread-inexact]
          /* @__PURE__ */ React.createElement(MenuStatefulContainer, _extends$a({}, gA, AA), function(IA) {
            return /* @__PURE__ */ React.createElement(Menu, _extends$a({}, IA, {
              overrides: H
            }));
          })
        );
      });
    }
  }]), g;
})(React.PureComponent);
function ownKeys$8(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$6(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$8(Object(g), !0).forEach(function(d) {
      _defineProperty$a(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$8(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$a(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function getFont() {
  var n, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SIZE$1.default, g = arguments.length > 1 ? arguments[1] : void 0;
  return (n = {}, _defineProperty$a(n, SIZE$1.mini, g.font100), _defineProperty$a(n, SIZE$1.compact, g.font200), _defineProperty$a(n, SIZE$1.default, g.font300), _defineProperty$a(n, SIZE$1.large, g.font400), n)[t];
}
function getBorderRadius(n, t) {
  var g = t.inputBorderRadius;
  return n === SIZE$1.mini && (g = t.inputBorderRadiusMini), {
    borderTopLeftRadius: g,
    borderBottomLeftRadius: g,
    borderTopRightRadius: g,
    borderBottomRightRadius: g
  };
}
function getControlPadding(n) {
  var t, g, d, k, H, AA = n.$theme, gA = n.$theme.sizing, IA = n.$size, CA = IA === void 0 ? SIZE$1.default : IA, BA = n.$type, eA = n.$multi, iA = n.$isEmpty, QA = BA === TYPE.search, tA = QA ? "calc(".concat(gA.scale1000, " - ").concat(gA.scale0, ")") : gA.scale400, oA = AA.direction === "rtl" ? "paddingRight" : "paddingLeft", EA = AA.direction === "rtl" ? "paddingLeft" : "paddingRight";
  return (H = {}, _defineProperty$a(H, SIZE$1.mini, (t = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: eA && !iA ? 0 : gA.scale100,
    paddingBottom: eA && !iA ? 0 : gA.scale100
  }, _defineProperty$a(t, oA, eA && !iA ? "calc(".concat(tA, " - ").concat(gA.scale0, ")") : tA), _defineProperty$a(t, EA, "0"), t)), _defineProperty$a(H, SIZE$1.compact, (g = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: eA && !iA ? "calc(".concat(gA.scale100, " - ").concat(gA.scale0, ")") : gA.scale200,
    paddingBottom: eA && !iA ? "calc(".concat(gA.scale100, " - ").concat(gA.scale0, ")") : gA.scale200
  }, _defineProperty$a(g, oA, eA && !iA ? "calc(".concat(tA, " - ").concat(gA.scale0, ")") : tA), _defineProperty$a(g, EA, "0"), g)), _defineProperty$a(H, SIZE$1.default, (d = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: eA && !iA ? "calc(".concat(gA.scale400, " - ").concat(gA.scale0, ")") : gA.scale400,
    paddingBottom: eA && !iA ? "calc(".concat(gA.scale400, " - ").concat(gA.scale0, ")") : gA.scale400
  }, _defineProperty$a(d, oA, eA && !iA ? "calc(".concat(tA, " + ").concat(gA.scale0, ")") : tA), _defineProperty$a(d, EA, 0), d)), _defineProperty$a(H, SIZE$1.large, (k = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: eA && !iA ? "calc(".concat(gA.scale600, " - ").concat(gA.scale0, ")") : gA.scale550,
    paddingBottom: eA && !iA ? "calc(".concat(gA.scale600, " - ").concat(gA.scale0, ")") : gA.scale550
  }, _defineProperty$a(k, oA, eA && !iA ? "calc(".concat(tA, " - ").concat(gA.scale0, ")") : tA), _defineProperty$a(k, EA, 0), k)), H)[CA];
}
var StyledDropdownContainer = styled("div", function(n) {
  return {
    width: "".concat(String(n.$width), "px")
  };
});
StyledDropdownContainer.displayName = "StyledDropdownContainer";
StyledDropdownContainer.displayName = "StyledDropdownContainer";
var StyledDropdown = StyledList, StyledDropdownListItem = StyledListItem, StyledOptionContent = styled("div", function(n) {
  var t = n.$isHighlighted, g = n.$selected, d = n.$disabled, k = n.$theme;
  return {
    cursor: d ? "not-allowed" : "pointer",
    color: g && !t ? k.colors.menuFontSelected : null,
    fontWeight: g ? "bold" : "normal"
  };
});
StyledOptionContent.displayName = "StyledOptionContent";
StyledOptionContent.displayName = "StyledOptionContent";
var StyledRoot = styled("div", function(n) {
  var t = n.$theme.typography, g = n.$size;
  return _objectSpread$6(_objectSpread$6({}, getFont(g, t)), {}, {
    boxSizing: "border-box",
    position: "relative",
    width: "100%"
  });
});
StyledRoot.displayName = "StyledRoot";
StyledRoot.displayName = "StyledRoot";
function getControlContainerColors(n, t, g, d, k, H) {
  return n ? {
    color: H.inputTextDisabled,
    borderLeftColor: H.inputFillDisabled,
    borderRightColor: H.inputFillDisabled,
    borderTopColor: H.inputFillDisabled,
    borderBottomColor: H.inputFillDisabled,
    backgroundColor: H.inputFillDisabled
  } : t || g ? {
    color: H.contentPrimary,
    borderLeftColor: H.borderSelected,
    borderRightColor: H.borderSelected,
    borderTopColor: H.borderSelected,
    borderBottomColor: H.borderSelected,
    backgroundColor: H.inputFillActive
  } : k ? {
    color: H.contentPrimary,
    borderLeftColor: H.inputBorderError,
    borderRightColor: H.inputBorderError,
    borderTopColor: H.inputBorderError,
    borderBottomColor: H.inputBorderError,
    backgroundColor: H.inputFillError
  } : d ? {
    color: H.contentPrimary,
    borderLeftColor: H.inputBorderPositive,
    borderRightColor: H.inputBorderPositive,
    borderTopColor: H.inputBorderPositive,
    borderBottomColor: H.inputBorderPositive,
    backgroundColor: H.inputFillPositive
  } : {
    color: H.contentPrimary,
    borderLeftColor: H.inputBorder,
    borderRightColor: H.inputBorder,
    borderTopColor: H.inputBorder,
    borderBottomColor: H.inputBorder,
    backgroundColor: H.inputFill
  };
}
var StyledControlContainer = styled("div", function(n) {
  var t = n.$disabled, g = n.$error, d = n.$positive, k = n.$isFocused, H = n.$isPseudoFocused, AA = n.$type, gA = n.$searchable, IA = n.$size, CA = n.$theme, BA = CA.borders, eA = CA.colors, iA = CA.animation;
  return _objectSpread$6(_objectSpread$6({}, getBorderRadius(IA, BA)), {}, {
    boxSizing: "border-box",
    overflow: "hidden",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    cursor: t ? "not-allowed" : gA || AA === TYPE.search ? "text" : "pointer",
    borderLeftWidth: "2px",
    borderRightWidth: "2px",
    borderTopWidth: "2px",
    borderBottomWidth: "2px",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    transitionProperty: "border, box-shadow, background-color",
    transitionDuration: iA.timing200,
    transitionTimingFunction: iA.easeOutCurve
  }, getControlContainerColors(t, k, H, d, g, eA));
});
StyledControlContainer.displayName = "StyledControlContainer";
StyledControlContainer.displayName = "StyledControlContainer";
var StyledValueContainer = styled("div", function(n) {
  var t = getControlPadding(n);
  return _objectSpread$6({
    boxSizing: "border-box",
    position: "relative",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "0%",
    display: "flex",
    alignItems: "center",
    flexWrap: n.$multi ? "wrap" : "nowrap",
    overflow: "hidden"
  }, t);
});
StyledValueContainer.displayName = "StyledValueContainer";
StyledValueContainer.displayName = "StyledValueContainer";
var StyledPlaceholder = styled("div", function(n) {
  var t = n.$disabled, g = n.$theme.colors;
  return {
    color: t ? g.inputPlaceholderDisabled : g.inputPlaceholder,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
});
StyledPlaceholder.displayName = "StyledPlaceholder";
StyledPlaceholder.displayName = "StyledPlaceholder";
var StyledSingleValue = styled("div", function(n) {
  var t, g = n.$searchable, d = n.$size, k = n.$theme, H = n.$theme.typography, AA = getFont(d, H), gA = k.direction === "rtl" ? "marginRight" : "marginLeft";
  return _objectSpread$6((t = {
    lineHeight: g ? "inherit" : AA.lineHeight,
    boxSizing: "border-box"
  }, _defineProperty$a(t, gA, k.sizing.scale0), _defineProperty$a(t, "height", "100%"), _defineProperty$a(t, "maxWidth", "100%"), t), ellipsisText);
});
StyledSingleValue.displayName = "StyledSingleValue";
StyledSingleValue.displayName = "StyledSingleValue";
var StyledInputContainer = styled("div", function(n) {
  var t = n.$size, g = n.$searchable, d = n.$theme, k = d.typography, H = d.sizing, AA = n.$isEmpty, gA = getFont(t, k);
  return {
    position: "relative",
    display: "inline-block",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderLeftStyle: "none",
    borderTopStyle: "none",
    borderRightStyle: "none",
    borderBottomStyle: "none",
    boxShadow: "none",
    boxSizing: "border-box",
    outline: "none",
    marginTop: 0,
    marginBottom: 0,
    marginLeft: AA ? 0 : H.scale0,
    marginRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    height: String(g ? "auto" : gA.lineHeight),
    maxHeight: String(gA.lineHeight)
  };
});
StyledInputContainer.displayName = "StyledInputContainer";
StyledInputContainer.displayName = "StyledInputContainer";
var StyledInput = styled("input", function(n) {
  var t = n.$theme, g = t.colors, d = t.typography, k = n.$size, H = n.$searchable, AA = n.$width;
  return _objectSpread$6(_objectSpread$6({}, getFont(k, d)), {}, {
    color: g.contentPrimary,
    boxSizing: "content-box",
    width: H ? AA || "100%" : "1px",
    maxWidth: "100%",
    background: "transparent",
    borderLeftStyle: "none",
    borderTopStyle: "none",
    borderRightStyle: "none",
    borderBottomStyle: "none",
    boxShadow: "none",
    display: "inline-block",
    outline: "none",
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0"
  });
});
StyledInput.displayName = "StyledInput";
StyledInput.displayName = "StyledInput";
var StyledInputSizer = styled("div", function(n) {
  var t, g = n.$size, d = n.$theme, k = n.$theme.typography, H = d.direction === "rtl" ? "right" : "left";
  return _objectSpread$6(_objectSpread$6({}, getFont(g, k)), {}, (t = {
    position: "absolute",
    top: 0
  }, _defineProperty$a(t, H, 0), _defineProperty$a(t, "visibility", "hidden"), _defineProperty$a(t, "height", 0), _defineProperty$a(t, "overflow", "scroll"), _defineProperty$a(t, "whiteSpace", "pre"), t));
});
StyledInputSizer.displayName = "StyledInputSizer";
StyledInputSizer.displayName = "StyledInputSizer";
var StyledIconsContainer = styled("div", function(n) {
  var t = n.$theme, g = n.$theme.sizing, d = t.direction === "rtl" ? "paddingLeft" : "paddingRight";
  return _defineProperty$a({
    boxSizing: "border-box",
    position: "relative",
    display: "flex",
    flexShrink: 0,
    alignItems: "center",
    alignSelf: "stretch"
  }, d, g.scale500);
});
StyledIconsContainer.displayName = "StyledIconsContainer";
StyledIconsContainer.displayName = "StyledIconsContainer";
function getSvgStyles(n) {
  var t = n.$theme;
  return {
    display: "inline-block",
    fill: "currentColor",
    color: "currentColor",
    height: t.sizing.scale600,
    width: t.sizing.scale600
  };
}
var StyledSelectArrow = styled("svg", function(n) {
  var t, g = n.$theme, d = n.$disabled, k = n.$size, H = g.colors, AA = (t = {}, _defineProperty$a(t, SIZE$1.mini, 16), _defineProperty$a(t, SIZE$1.compact, 16), _defineProperty$a(t, SIZE$1.default, 20), _defineProperty$a(t, SIZE$1.large, 24), t), gA = AA[SIZE$1.default];
  return k && (gA = AA[k]), _objectSpread$6(_objectSpread$6({}, getSvgStyles({
    $theme: g
  })), {}, {
    color: d ? H.inputTextDisabled : H.contentPrimary,
    cursor: d ? "not-allowed" : "pointer",
    height: "".concat(gA, "px"),
    width: "".concat(gA, "px")
  });
});
StyledSelectArrow.displayName = "StyledSelectArrow";
StyledSelectArrow.displayName = "StyledSelectArrow";
var StyledClearIcon = styled("svg", function(n) {
  var t, g = n.$theme, d = n.$size, k = g.colors, H = (t = {}, _defineProperty$a(t, SIZE$1.mini, 15), _defineProperty$a(t, SIZE$1.compact, 15), _defineProperty$a(t, SIZE$1.default, 18), _defineProperty$a(t, SIZE$1.large, 22), t), AA = H[SIZE$1.default];
  return d && (AA = H[d]), _objectSpread$6(_objectSpread$6({}, getSvgStyles({
    $theme: g
  })), {}, {
    color: k.contentPrimary,
    cursor: "pointer",
    height: "".concat(AA, "px"),
    width: "".concat(AA, "px")
  });
});
StyledClearIcon.displayName = "StyledClearIcon";
StyledClearIcon.displayName = "StyledClearIcon";
var StyledLoadingIndicator = withStyle(StyledSpinner, function(n) {
  var t = n.$theme;
  return {
    borderTopWidth: "2px",
    borderRightWidth: "2px",
    borderBottomWidth: "2px",
    borderLeftWidth: "2px",
    borderRightColor: t.colors.borderOpaque,
    borderBottomColor: t.colors.borderOpaque,
    borderLeftColor: t.colors.borderOpaque,
    width: "16px",
    height: "16px"
  };
});
StyledLoadingIndicator.displayName = "StyledLoadingIndicator";
StyledLoadingIndicator.displayName = "StyledLoadingIndicator";
var StyledSearchIconContainer = styled("div", function(n) {
  var t, g = n.$disabled, d = n.$theme, k = d.colors, H = d.sizing, AA = d.direction === "rtl" ? "right" : "left";
  return _objectSpread$6(_objectSpread$6({}, getSvgStyles(n)), {}, (t = {
    color: g ? k.inputTextDisabled : k.contentPrimary,
    cursor: g ? "not-allowed" : "pointer",
    position: "absolute",
    top: 0
  }, _defineProperty$a(t, AA, H.scale500), _defineProperty$a(t, "display", "flex"), _defineProperty$a(t, "alignItems", "center"), _defineProperty$a(t, "height", "100%"), t));
});
StyledSearchIconContainer.displayName = "StyledSearchIconContainer";
StyledSearchIconContainer.displayName = "StyledSearchIconContainer";
function _typeof$5(n) {
  "@babel/helpers - typeof";
  return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$5(n);
}
var _excluded$8 = ["overrides", "inputRef"];
function _extends$9() {
  return _extends$9 = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$9.apply(this, arguments);
}
function ownKeys$7(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$5(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$7(Object(g), !0).forEach(function(d) {
      _defineProperty$9(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$7(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _slicedToArray$7(n, t) {
  return _arrayWithHoles$6(n) || _iterableToArrayLimit$6(n, t) || _unsupportedIterableToArray$6(n, t) || _nonIterableRest$6();
}
function _nonIterableRest$6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$6(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$6(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$6(n, t);
  }
}
function _arrayLikeToArray$6(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$6(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$6(n) {
  if (Array.isArray(n)) return n;
}
function _objectWithoutProperties$6(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$6(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$6(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _classCallCheck$3(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$3(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$3(n, t, g) {
  return t && _defineProperties$3(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$3(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$3(n, t);
}
function _setPrototypeOf$3(n, t) {
  return _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$3(n, t);
}
function _createSuper$3(n) {
  var t = _isNativeReflectConstruct$3();
  return function() {
    var d = _getPrototypeOf$3(n), k;
    if (t) {
      var H = _getPrototypeOf$3(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$3(this, k);
  };
}
function _possibleConstructorReturn$3(n, t) {
  if (t && (_typeof$5(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$3(n);
}
function _assertThisInitialized$3(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$3(n) {
  return _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$3(n);
}
function _defineProperty$9(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var AutosizeInput = /* @__PURE__ */ (function(n) {
  _inherits$3(g, n);
  var t = _createSuper$3(g);
  function g() {
    var d;
    _classCallCheck$3(this, g);
    for (var k = arguments.length, H = new Array(k), AA = 0; AA < k; AA++)
      H[AA] = arguments[AA];
    return d = t.call.apply(t, [this].concat(H)), _defineProperty$9(_assertThisInitialized$3(d), "mounted", void 0), _defineProperty$9(_assertThisInitialized$3(d), "sizer", void 0), _defineProperty$9(_assertThisInitialized$3(d), "state", {
      inputWidth: 5
    }), _defineProperty$9(_assertThisInitialized$3(d), "sizerRef", function(gA) {
      d.sizer = gA;
    }), d;
  }
  return _createClass$3(g, [{
    key: "componentDidMount",
    value: function() {
      this.mounted = !0, this.updateInputWidth();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "componentDidUpdate",
    value: function(k, H) {
      this.updateInputWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
    }
  }, {
    key: "updateInputWidth",
    value: function() {
      if (!(!this.mounted || !this.sizer || typeof this.sizer.scrollWidth > "u")) {
        var k = this.sizer.scrollWidth + 2;
        k !== this.state.inputWidth && this.sizer.scrollWidth !== this.state.inputWidth && this.setState({
          inputWidth: k
        });
      }
    }
  }, {
    key: "render",
    value: function() {
      var k = this.props, H = k.overrides, AA = H === void 0 ? {} : H, gA = k.inputRef, IA = _objectWithoutProperties$6(k, _excluded$8), CA = getOverrides(AA.Input, StyledInput), BA = _slicedToArray$7(CA, 2), eA = BA[0], iA = BA[1], QA = [this.props.defaultValue, this.props.value, ""].reduce(function(oA, EA) {
        return oA ?? EA;
      }), tA = _objectSpread$5(_objectSpread$5({}, IA), {}, {
        $width: "".concat(this.state.inputWidth, "px")
      });
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(eA, _extends$9({}, tA, {
        ref: gA
      }, iA)), /* @__PURE__ */ React.createElement(StyledInputSizer, {
        $size: this.props.$size,
        ref: this.sizerRef,
        $style: iA.$style ? iA.$style : null
      }, QA));
    }
  }]), g;
})(React.Component);
_defineProperty$9(AutosizeInput, "defaultProps", {
  inputRef: /* @__PURE__ */ React.createRef(),
  value: "",
  overrides: {}
});
function ownKeys$6(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$4(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$6(Object(g), !0).forEach(function(d) {
      _defineProperty$8(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$6(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$8(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var escapeRegExp = function n(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}, isValid = function n(t) {
  return typeof t < "u" && t !== null && t !== "";
}, defaultProps$1 = {
  filterOption: null,
  ignoreCase: !0,
  labelKey: "label",
  matchPos: "any",
  matchProp: "any",
  trimFilter: !0,
  valueKey: "value"
}, filterOptions = function n(t, g, d, k) {
  var H = _objectSpread$4(_objectSpread$4({}, defaultProps$1), k);
  H.ignoreCase && (g = g.toLowerCase()), H.trimFilter && (g = g.trim());
  var AA = (d || []).reduce(function(IA, CA) {
    return IA.add(CA[H.valueKey]), IA;
  }, /* @__PURE__ */ new Set()), gA = new RegExp("".concat(H.matchPos === "start" ? "^" : "").concat(escapeRegExp(g)), H.ignoreCase ? "i" : "");
  return t.filter(function(IA) {
    if (AA.has(IA[H.valueKey])) return !1;
    if (H.filterOption) return H.filterOption.call(void 0, IA, g);
    if (!g) return !0;
    var CA = IA[H.valueKey], BA = IA[H.labelKey], eA = isValid(CA), iA = isValid(BA);
    if (!eA && !iA)
      return !1;
    var QA = eA ? String(CA) : null, tA = iA ? String(BA) : null;
    return QA && H.matchProp !== "label" && gA.test(QA) || tA && H.matchProp !== "value" && gA.test(tA);
  });
}, defaultProps = {
  "aria-label": null,
  "aria-describedby": null,
  "aria-errormessage": null,
  "aria-labelledby": null,
  autoFocus: !1,
  backspaceRemoves: !0,
  clearable: !0,
  closeOnSelect: !0,
  creatable: !1,
  deleteRemoves: !0,
  disabled: !1,
  error: !1,
  positive: !1,
  escapeClearsValue: !0,
  filterOptions,
  filterOutSelected: !0,
  getOptionLabel: null,
  getValueLabel: null,
  ignoreCase: !0,
  isLoading: !1,
  labelKey: "label",
  maxDropdownHeight: "40vh",
  multi: !1,
  onBlur: function n() {
  },
  onBlurResetsInput: !0,
  onChange: function n() {
  },
  onFocus: function n() {
  },
  onInputChange: function n() {
  },
  onCloseResetsInput: !0,
  onSelectResetsInput: !0,
  onOpen: null,
  onClose: null,
  openOnClick: !0,
  startOpen: !1,
  options: [],
  overrides: {},
  required: !1,
  searchable: !0,
  size: SIZE$1.default,
  type: TYPE.select,
  value: [],
  valueKey: "id"
};
function _typeof$4(n) {
  "@babel/helpers - typeof";
  return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$4(n);
}
var _excluded$7 = ["overrides"];
function ownKeys$5(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$3(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$5(Object(g), !0).forEach(function(d) {
      _defineProperty$7(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$5(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _objectWithoutProperties$5(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$5(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$5(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _extends$8() {
  return _extends$8 = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$8.apply(this, arguments);
}
function _slicedToArray$6(n, t) {
  return _arrayWithHoles$5(n) || _iterableToArrayLimit$5(n, t) || _unsupportedIterableToArray$5(n, t) || _nonIterableRest$5();
}
function _nonIterableRest$5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$5(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$5(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$5(n, t);
  }
}
function _arrayLikeToArray$5(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$5(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$5(n) {
  if (Array.isArray(n)) return n;
}
function _classCallCheck$2(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$2(n, t, g) {
  return t && _defineProperties$2(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$2(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$2(n, t);
}
function _setPrototypeOf$2(n, t) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$2(n, t);
}
function _createSuper$2(n) {
  var t = _isNativeReflectConstruct$2();
  return function() {
    var d = _getPrototypeOf$2(n), k;
    if (t) {
      var H = _getPrototypeOf$2(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$2(this, k);
  };
}
function _possibleConstructorReturn$2(n, t) {
  if (t && (_typeof$4(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$2(n);
}
function _assertThisInitialized$2(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$2(n) {
  return _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$2(n);
}
function _defineProperty$7(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function groupOptions(n) {
  return n.reduce(function(t, g) {
    return g.__optgroup ? (t[g.__optgroup] || (t[g.__optgroup] = []), t[g.__optgroup].push(g)) : t.__ungrouped.push(g), t;
  }, {
    __ungrouped: []
  });
}
var SelectDropdown = /* @__PURE__ */ (function(n) {
  _inherits$2(g, n);
  var t = _createSuper$2(g);
  function g() {
    var d;
    _classCallCheck$2(this, g);
    for (var k = arguments.length, H = new Array(k), AA = 0; AA < k; AA++)
      H[AA] = arguments[AA];
    return d = t.call.apply(t, [this].concat(H)), _defineProperty$7(_assertThisInitialized$2(d), "getItemLabel", function(gA) {
      var IA = d.props, CA = IA.getOptionLabel, BA = IA.overrides, eA = BA === void 0 ? {} : BA, iA = IA.value, QA = IA.valueKey, tA = getOverrides(eA.OptionContent, StyledOptionContent), oA = _slicedToArray$6(tA, 2), EA = oA[0], aA = oA[1], nA;
      Array.isArray(iA) ? nA = !!iA.find(function(cA) {
        return cA && cA[QA] === gA[QA];
      }) : nA = iA[QA] === gA[QA];
      var lA = {
        $selected: nA,
        $disabled: gA.disabled,
        $isHighlighted: gA.isHighlighted
      };
      return /* @__PURE__ */ React.createElement(EA, _extends$8({
        "aria-readonly": gA.disabled,
        "aria-selected": nA,
        key: gA[QA]
      }, d.getSharedProps(), lA, aA), CA({
        option: gA,
        optionState: lA
      }));
    }), _defineProperty$7(_assertThisInitialized$2(d), "onMouseDown", function(gA) {
      gA.nativeEvent.stopImmediatePropagation();
    }), _defineProperty$7(_assertThisInitialized$2(d), "getHighlightedIndex", function() {
      var gA = d.props, IA = gA.value, CA = gA.options, BA = gA.valueKey, eA = {};
      if (Array.isArray(IA) && IA.length > 0 ? eA = IA[0] : IA instanceof Array || (eA = IA), Object.keys(eA).length > 0) {
        var iA = CA.findIndex(function(QA) {
          return QA && QA[BA] === eA[BA];
        });
        return iA === -1 ? 0 : iA;
      }
      return 0;
    }), d;
  }
  return _createClass$2(g, [{
    key: "getSharedProps",
    value: function() {
      var k = this.props, H = k.error, AA = k.isLoading, gA = k.multi, IA = k.required, CA = k.size, BA = k.searchable, eA = k.type, iA = k.width;
      return {
        $error: H,
        $isLoading: AA,
        $multi: gA,
        $required: IA,
        $searchable: BA,
        $size: CA,
        $type: eA,
        $width: iA
      };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "render",
    value: function() {
      var k = this, H = this.props, AA = H.maxDropdownHeight, gA = H.multi, IA = H.noResultsMsg, CA = H.onItemSelect, BA = H.options, eA = BA === void 0 ? [] : BA, iA = H.overrides, QA = iA === void 0 ? {} : iA, tA = H.size, oA = getOverrides(QA.DropdownContainer, StyledDropdownContainer), EA = _slicedToArray$6(oA, 2), aA = EA[0], nA = EA[1], lA = getOverrides(QA.DropdownListItem, StyledDropdownListItem), cA = _slicedToArray$6(lA, 2), sA = cA[0], rA = cA[1], uA = getOverrides(QA.StatefulMenu, StatefulMenu), hA = _slicedToArray$6(uA, 2), dA = hA[0], GA = hA[1], DA = GA.overrides, wA = DA === void 0 ? {} : DA, bA = _objectWithoutProperties$5(GA, _excluded$7), yA = this.getHighlightedIndex(), pA = groupOptions(eA);
      return /* @__PURE__ */ React.createElement(aA, _extends$8({
        "data-no-focus-lock": !0,
        ref: this.props.innerRef
      }, this.getSharedProps(), nA), /* @__PURE__ */ React.createElement(dA, _extends$8({
        noResultsMsg: IA,
        onActiveDescendantChange: function(LA) {
          k.props.onActiveDescendantChange && k.props.onActiveDescendantChange(LA);
        },
        onItemSelect: CA,
        items: pA,
        size: tA,
        initialState: {
          isFocused: !0,
          highlightedIndex: yA
        },
        typeAhead: !1,
        keyboardControlNode: this.props.keyboardControlNode,
        forceHighlight: !0,
        overrides: mergeOverrides({
          List: {
            component: StyledDropdown,
            style: function(LA) {
              return {
                maxHeight: LA.$maxHeight || null
              };
            },
            props: {
              id: this.props.id ? this.props.id : null,
              $maxHeight: AA,
              "aria-multiselectable": gA
            }
          },
          Option: {
            props: {
              getItemLabel: this.getItemLabel,
              // figure out why the onClick handler is not
              // triggered without this temporary fix
              onMouseDown: this.onMouseDown,
              overrides: {
                ListItem: {
                  component: sA,
                  props: _objectSpread$3(_objectSpread$3({}, rA), {}, {
                    role: "option"
                  }),
                  // slightly hacky way to handle the list item style overrides
                  // since the menu component doesn't provide a top level overrides for it
                  style: rA.$style
                }
              },
              renderHrefAsAnchor: !1
            }
          }
        }, _objectSpread$3({
          List: QA.Dropdown || {},
          Option: QA.DropdownOption || {}
        }, wA))
      }, bA)));
    }
  }]), g;
})(React.Component);
function ownKeys$4(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$2(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$4(Object(g), !0).forEach(function(d) {
      _defineProperty$6(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$4(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$6(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function groupedOptionsToArray(n) {
  return Object.keys(n).reduce(function(t, g) {
    var d = n[g];
    return t.concat(d.map(function(k) {
      return _objectSpread$2(_objectSpread$2({}, k), {}, {
        __optgroup: g
      });
    }));
  }, []);
}
function normalizeOptions(n) {
  return n ? Array.isArray(n) ? n : groupedOptionsToArray(n) : [];
}
var expandValue = function n(t, g) {
  if (!g.options) return t;
  for (var d = normalizeOptions(g.options), k = 0; k < d.length; k++)
    if (String(d[k][g.valueKey]) === String(t[g.valueKey]))
      return d[k];
  return t;
};
function _typeof$3(n) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$3(n);
}
var _excluded$6 = ["$size"], _excluded2$2 = ["$size"];
function _objectWithoutProperties$4(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$4(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$4(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$7.apply(this, arguments);
}
function _slicedToArray$5(n, t) {
  return _arrayWithHoles$4(n) || _iterableToArrayLimit$4(n, t) || _unsupportedIterableToArray$4(n, t) || _nonIterableRest$4();
}
function _nonIterableRest$4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$4(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$4(n) {
  if (Array.isArray(n)) return n;
}
function _toConsumableArray(n) {
  return _arrayWithoutHoles(n) || _iterableToArray(n) || _unsupportedIterableToArray$4(n) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$4(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$4(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$4(n, t);
  }
}
function _iterableToArray(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function _arrayWithoutHoles(n) {
  if (Array.isArray(n)) return _arrayLikeToArray$4(n);
}
function _arrayLikeToArray$4(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _classCallCheck$1(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, d.key, d);
  }
}
function _createClass$1(n, t, g) {
  return t && _defineProperties$1(n.prototype, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _inherits$1(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && _setPrototypeOf$1(n, t);
}
function _setPrototypeOf$1(n, t) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, k) {
    return d.__proto__ = k, d;
  }, _setPrototypeOf$1(n, t);
}
function _createSuper$1(n) {
  var t = _isNativeReflectConstruct$1();
  return function() {
    var d = _getPrototypeOf$1(n), k;
    if (t) {
      var H = _getPrototypeOf$1(this).constructor;
      k = Reflect.construct(d, arguments, H);
    } else
      k = d.apply(this, arguments);
    return _possibleConstructorReturn$1(this, k);
  };
}
function _possibleConstructorReturn$1(n, t) {
  if (t && (_typeof$3(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(n);
}
function _assertThisInitialized$1(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$1(n) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
    return g.__proto__ || Object.getPrototypeOf(g);
  }, _getPrototypeOf$1(n);
}
function _defineProperty$5(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function Noop() {
  return null;
}
var isClick = function n(t) {
  return t.type === "click";
}, isLeftClick = function n(t) {
  return t.button !== null && t.button !== void 0 && t.button === 0;
}, containsNode = function n(t, g) {
  if (typeof document < "u")
    return g && t && t.contains(g);
};
function isInteractive(n, t) {
  if (n instanceof Element)
    for (var g = n; g && g !== t; ) {
      var d = g.getAttribute("role");
      if (d === "button" || d === "link")
        return !0;
      g.tagName && (g = g.parentElement);
    }
  return !1;
}
var Select$1 = /* @__PURE__ */ (function(n) {
  _inherits$1(g, n);
  var t = _createSuper$1(g);
  function g(d) {
    var k;
    return _classCallCheck$1(this, g), k = t.call(this, d), _defineProperty$5(_assertThisInitialized$1(k), "anchor", /* @__PURE__ */ React.createRef()), _defineProperty$5(_assertThisInitialized$1(k), "dropdown", /* @__PURE__ */ React.createRef()), _defineProperty$5(_assertThisInitialized$1(k), "input", void 0), _defineProperty$5(_assertThisInitialized$1(k), "dragging", void 0), _defineProperty$5(_assertThisInitialized$1(k), "focusAfterClear", void 0), _defineProperty$5(_assertThisInitialized$1(k), "openAfterFocus", void 0), _defineProperty$5(_assertThisInitialized$1(k), "justSelected", void 0), _defineProperty$5(_assertThisInitialized$1(k), "options", []), _defineProperty$5(_assertThisInitialized$1(k), "state", {
      activeDescendant: null,
      inputValue: "",
      isFocused: !1,
      isOpen: k.props.startOpen,
      isPseudoFocused: !1
    }), _defineProperty$5(_assertThisInitialized$1(k), "isItMounted", !1), _defineProperty$5(_assertThisInitialized$1(k), "handleTouchOutside", function(H) {
      containsNode(k.dropdown.current, H.target) || containsNode(k.anchor.current, H.target) || k.closeMenu();
    }), _defineProperty$5(_assertThisInitialized$1(k), "handleTouchMove", function() {
      return k.dragging = !0;
    }), _defineProperty$5(_assertThisInitialized$1(k), "handleTouchStart", function() {
      return k.dragging = !1;
    }), _defineProperty$5(_assertThisInitialized$1(k), "handleTouchEnd", function(H) {
      k.dragging || k.handleClick(H);
    }), _defineProperty$5(_assertThisInitialized$1(k), "handleClick", function(H) {
      if (!(k.props.disabled || !isClick(H) && !isLeftClick(H))) {
        if (H.target === k.input) {
          k.state.isFocused || (k.openAfterFocus = k.props.openOnClick, k.focus()), k.state.isOpen || k.setState({
            isOpen: !0,
            isFocused: !0,
            isPseudoFocused: !1
          });
          return;
        }
        if (!(k.input && isInteractive(H.target, k.input))) {
          if (!k.props.searchable) {
            k.focus(), k.state.isOpen ? k.setState({
              isOpen: !1,
              isFocused: !1
            }) : k.setState({
              isOpen: !0,
              isFocused: !0
            });
            return;
          }
          k.state.isFocused ? (k.focus(), k.input && (k.input.value = ""), k.setState(function(AA) {
            return {
              isOpen: !k.focusAfterClear && !AA.isOpen,
              isPseudoFocused: !1
            };
          }), k.focusAfterClear = !1) : (k.focusAfterClear = !1, k.openAfterFocus = k.props.openOnClick, k.focus());
        }
      }
    }), _defineProperty$5(_assertThisInitialized$1(k), "handleInputFocus", function(H) {
      if (!k.props.disabled) {
        k.props.onFocus && k.props.onFocus(H);
        var AA = k.state.isOpen || k.openAfterFocus;
        AA = !k.focusAfterClear && AA, k.setState({
          isFocused: !0,
          isOpen: !!AA
        }), k.focusAfterClear = !1, k.openAfterFocus = !1;
      }
    }), _defineProperty$5(_assertThisInitialized$1(k), "handleBlur", function(H) {
      if (H.relatedTarget) {
        if (containsNode(k.anchor.current, H.relatedTarget) || containsNode(k.dropdown.current, H.relatedTarget))
          return;
      } else if (containsNode(k.anchor.current, H.target))
        return;
      k.props.onBlur && k.props.onBlur(H), k.isItMounted && k.setState({
        isFocused: !1,
        isOpen: !1,
        isPseudoFocused: !1,
        inputValue: k.props.onBlurResetsInput ? "" : k.state.inputValue
      });
    }), _defineProperty$5(_assertThisInitialized$1(k), "handleClickOutside", function(H) {
      if (k.justSelected) {
        k.justSelected = !1;
        return;
      }
      if (!containsNode(k.dropdown.current, H.target)) {
        var AA = k.state.isFocused || k.state.isPseudoFocused;
        AA && !containsNode(k.anchor.current, H.target) && k.handleBlur(H);
      }
    }), _defineProperty$5(_assertThisInitialized$1(k), "handleInputChange", function(H) {
      var AA = H.target.value;
      k.setState({
        inputValue: AA,
        isOpen: !0,
        isPseudoFocused: !1
      }), k.props.onInputChange && k.props.onInputChange(H);
    }), _defineProperty$5(_assertThisInitialized$1(k), "handleKeyDown", function(H) {
      if (!k.props.disabled)
        switch (H.keyCode) {
          case 8:
            !k.state.inputValue && k.props.backspaceRemoves && (H.preventDefault(), k.backspaceValue());
            break;
          case 9:
            k.setState(function(AA) {
              return {
                isPseudoFocused: !1,
                isFocused: !1,
                isOpen: !1,
                inputValue: !k.props.onCloseResetsInput || !k.props.onBlurResetsInput ? AA.inputValue : ""
              };
            });
            break;
          case 27:
            !k.state.isOpen && k.props.clearable && k.props.escapeClearsValue && (k.clearValue(H), k.setState({
              isFocused: !1,
              isPseudoFocused: !1
            }));
            break;
          case 32:
            if (k.props.searchable)
              break;
            H.preventDefault(), k.state.isOpen || k.setState({
              isOpen: !0
            });
            break;
          case 38:
            H.preventDefault(), k.state.isOpen || k.setState({
              isOpen: !0
            });
            break;
          case 40:
            H.preventDefault(), k.state.isOpen || k.setState({
              isOpen: !0
            });
            break;
          case 33:
            H.preventDefault(), k.state.isOpen || k.setState({
              isOpen: !0
            });
            break;
          case 34:
            H.preventDefault(), k.state.isOpen || k.setState({
              isOpen: !0
            });
            break;
          case 35:
            if (H.shiftKey)
              break;
            H.preventDefault(), k.state.isOpen || k.setState({
              isOpen: !0
            });
            break;
          case 36:
            if (H.shiftKey)
              break;
            H.preventDefault(), k.state.isOpen || k.setState({
              isOpen: !0
            });
            break;
          case 46:
            !k.state.inputValue && k.props.deleteRemoves && (H.preventDefault(), k.popValue());
            break;
        }
    }), _defineProperty$5(_assertThisInitialized$1(k), "getOptionLabel", function(H, AA) {
      var gA = AA.option;
      return gA.isCreatable ? "".concat(H.select.create, " “").concat(gA[k.props.labelKey], "”") : gA[k.props.labelKey];
    }), _defineProperty$5(_assertThisInitialized$1(k), "getValueLabel", function(H) {
      var AA = H.option;
      return AA[k.props.labelKey];
    }), _defineProperty$5(_assertThisInitialized$1(k), "handleActiveDescendantChange", function(H) {
      H ? k.setState({
        activeDescendant: H
      }) : k.setState({
        activeDescendant: null
      });
    }), _defineProperty$5(_assertThisInitialized$1(k), "handleInputRef", function(H) {
      k.input = H, typeof k.props.inputRef == "function" ? k.props.inputRef(H) : k.props.inputRef && (k.props.inputRef.current = H), k.props.controlRef && typeof k.props.controlRef == "function" && k.props.controlRef(H);
    }), _defineProperty$5(_assertThisInitialized$1(k), "selectValue", function(H) {
      var AA = H.item;
      if (!AA.disabled) {
        k.justSelected = !0;
        var gA = k.props.onSelectResetsInput ? "" : k.state.inputValue;
        k.props.multi ? k.setState({
          inputValue: gA,
          isOpen: !k.props.closeOnSelect
        }, function() {
          var IA = k.props.value;
          IA.some(function(CA) {
            return CA[k.props.valueKey] === AA[k.props.valueKey];
          }) ? k.removeValue(AA) : k.addValue(AA);
        }) : (k.focus(), k.setState({
          inputValue: gA,
          isOpen: !k.props.closeOnSelect,
          isFocused: !0,
          isPseudoFocused: !1
        }, function() {
          k.setValue([AA], AA, STATE_CHANGE_TYPE.select);
        }));
      }
    }), _defineProperty$5(_assertThisInitialized$1(k), "addValue", function(H) {
      var AA = _toConsumableArray(k.props.value);
      k.setValue(AA.concat(H), H, STATE_CHANGE_TYPE.select);
    }), _defineProperty$5(_assertThisInitialized$1(k), "backspaceValue", function() {
      var H = k.popValue();
      if (H) {
        var AA = k.props.value.length, gA = k.props.getValueLabel || k.getValueLabel, IA = gA({
          option: H,
          index: AA - 1
        });
        if (!k.props.backspaceClearsInputValue && typeof IA == "string") {
          var CA = IA.slice(0, -1);
          k.setState({
            inputValue: CA,
            isOpen: !0
          });
        }
      }
    }), _defineProperty$5(_assertThisInitialized$1(k), "popValue", function() {
      var H = _toConsumableArray(k.props.value), AA = H.length;
      if (AA && H[AA - 1].clearableValue !== !1) {
        var gA = H.pop();
        return k.setValue(H, gA, STATE_CHANGE_TYPE.remove), gA;
      }
    }), _defineProperty$5(_assertThisInitialized$1(k), "removeValue", function(H) {
      var AA = _toConsumableArray(k.props.value);
      k.setValue(AA.filter(function(gA) {
        return gA[k.props.valueKey] !== H[k.props.valueKey];
      }), H, STATE_CHANGE_TYPE.remove), k.focus();
    }), _defineProperty$5(_assertThisInitialized$1(k), "clearValue", function(H) {
      if (!(isClick(H) && !isLeftClick(H))) {
        if (k.props.value) {
          var AA = k.props.value.filter(function(gA) {
            return gA.clearableValue === !1;
          });
          k.setValue(AA, null, STATE_CHANGE_TYPE.clear);
        }
        k.setState({
          inputValue: "",
          isOpen: !1
        }), k.focus(), k.focusAfterClear = !0;
      }
    }), _defineProperty$5(_assertThisInitialized$1(k), "shouldShowPlaceholder", function() {
      return !(k.state.inputValue || k.props.value && k.props.value.length);
    }), _defineProperty$5(_assertThisInitialized$1(k), "shouldShowValue", function() {
      return !k.state.inputValue;
    }), k.options = normalizeOptions(d.options), k;
  }
  return _createClass$1(g, [{
    key: "componentDidMount",
    value: function() {
      this.props.autoFocus && this.focus(), this.isItMounted = !0;
      var k = this.props.controlRef;
      k && typeof k != "function" && (k.current = {
        setDropdownOpen: this.handleDropdownOpen.bind(this),
        setInputValue: this.handleSetInputValue.bind(this),
        setInputFocus: this.handleSetInputFocus.bind(this),
        setInputBlur: this.handleSetInputBlur.bind(this),
        // `focus` & `blur` below are for backwards compatibility and may be removed. Use setInputFocus and setInputBlur instead.
        focus: this.handleSetInputFocus.bind(this),
        blur: this.handleSetInputBlur.bind(this)
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(k, H) {
      var AA = this;
      typeof document < "u" && (H.isOpen !== this.state.isOpen && (this.state.isOpen ? (this.props.onOpen && this.props.onOpen(), document.addEventListener("touchstart", this.handleTouchOutside)) : (this.props.onClose && this.props.onClose(), document.removeEventListener("touchstart", this.handleTouchOutside))), !H.isFocused && this.state.isFocused && setTimeout(function() {
        return document.addEventListener("click", AA.handleClickOutside);
      }, 0));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      typeof document < "u" && (document.removeEventListener("touchstart", this.handleTouchOutside), document.removeEventListener("click", this.handleClickOutside)), this.isItMounted = !1;
    }
  }, {
    key: "focus",
    value: function() {
      this.input && this.input.focus();
    }
  }, {
    key: "handleDropdownOpen",
    value: function(k) {
      this.setState({
        isOpen: k
      });
    }
  }, {
    key: "handleSetInputValue",
    value: function(k) {
      this.setState({
        inputValue: k
      });
    }
  }, {
    key: "handleSetInputFocus",
    value: function() {
      this.input.focus();
    }
  }, {
    key: "handleSetInputBlur",
    value: function() {
      this.input.blur();
    }
    // Handle touch outside on mobile to dismiss menu, ensures that the
    // touch target is not within the anchor DOM node.
  }, {
    key: "closeMenu",
    value: function() {
      this.props.onCloseResetsInput ? this.setState({
        inputValue: "",
        isOpen: !1,
        isPseudoFocused: this.state.isFocused && !this.props.multi
      }) : this.setState({
        isOpen: !1,
        isPseudoFocused: this.state.isFocused && !this.props.multi
      });
    }
  }, {
    key: "getValueArray",
    value: (
      /**
       * Extends the value into an array from the given options
       */
      function(k) {
        var H = this;
        if (!Array.isArray(k)) {
          if (k == null) return [];
          k = [k];
        }
        return k.map(function(AA) {
          return expandValue(AA, H.props);
        });
      }
    )
  }, {
    key: "setValue",
    value: function(k, H, AA) {
      this.props.onChange && this.props.onChange({
        value: k,
        option: H,
        type: AA
      });
    }
  }, {
    key: "renderLoading",
    value: function() {
      if (this.props.isLoading) {
        var k = this.props.overrides, H = k === void 0 ? {} : k, AA = getOverrides(H.LoadingIndicator, StyledLoadingIndicator), gA = _slicedToArray$5(AA, 2), IA = gA[0], CA = gA[1];
        return /* @__PURE__ */ React.createElement(IA, _extends$7({
          role: "status"
        }, CA), /* @__PURE__ */ React.createElement("span", {
          style: {
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: 0,
            margin: "-1px",
            overflow: "hidden",
            clip: "rect(0,0,0,0)",
            whiteSpace: "nowrap",
            border: 0
          }
        }, "Loading"));
      }
    }
  }, {
    key: "renderValue",
    value: function(k) {
      var H = this, AA = this.props.overrides, gA = AA === void 0 ? {} : AA, IA = this.getSharedProps(), CA = this.props.getValueLabel || this.getValueLabel, BA = this.props.valueComponent || Noop;
      if (!k.length)
        return null;
      if (this.props.multi)
        return k.map(function(eA, iA) {
          var QA = IA.$disabled || eA.clearableValue === !1;
          return /* @__PURE__ */ React.createElement(BA, _extends$7({
            value: eA,
            key: "value-".concat(iA, "-").concat(eA[H.props.valueKey]),
            removeValue: function() {
              return H.removeValue(eA);
            },
            disabled: QA,
            overrides: {
              Tag: gA.Tag,
              MultiValue: gA.MultiValue
            }
          }, IA, {
            $disabled: QA
          }), CA({
            option: eA,
            index: iA
          }));
        });
      if (this.shouldShowValue())
        return /* @__PURE__ */ React.createElement(BA, _extends$7({
          value: k[0][this.props.valueKey],
          disabled: this.props.disabled,
          overrides: {
            SingleValue: gA.SingleValue
          }
        }, IA), CA({
          option: k[0]
        }));
    }
  }, {
    key: "renderInput",
    value: function(k) {
      var H = this, AA = this.props.overrides, gA = AA === void 0 ? {} : AA, IA = getOverrides(gA.InputContainer, StyledInputContainer), CA = _slicedToArray$5(IA, 2), BA = CA[0], eA = CA[1], iA = this.getSharedProps(), QA = this.state.isOpen, tA = this.getValueArray(this.props.value).map(function(aA) {
        return aA[H.props.labelKey];
      }).join(", "), oA = tA.length ? "Selected ".concat(tA, ". ") : "", EA = "".concat(oA).concat(this.props["aria-label"] || "");
      return this.props.searchable ? /* @__PURE__ */ React.createElement(BA, _extends$7({}, iA, eA), /* @__PURE__ */ React.createElement(AutosizeInput, _extends$7({
        "aria-activedescendant": this.state.activeDescendant,
        "aria-autocomplete": "list",
        "aria-controls": this.state.isOpen ? k : null,
        "aria-describedby": this.props["aria-describedby"],
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-disabled": this.props.disabled || null,
        "aria-expanded": QA,
        "aria-haspopup": "listbox",
        "aria-label": EA,
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-required": this.props.required || null,
        disabled: this.props.disabled || null,
        id: this.props.id || null,
        inputRef: this.handleInputRef,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        overrides: {
          Input: gA.Input
        },
        required: this.props.required && !this.props.value.length || null,
        role: "combobox",
        value: this.state.inputValue,
        tabIndex: 0
      }, iA))) : /* @__PURE__ */ React.createElement(BA, _extends$7({
        "aria-activedescendant": this.state.activeDescendant,
        "aria-describedby": this.props["aria-describedby"],
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-disabled": this.props.disabled,
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-owns": this.state.isOpen ? k : null,
        "aria-required": this.props.required || null,
        onFocus: this.handleInputFocus,
        tabIndex: 0
      }, iA, eA), /* @__PURE__ */ React.createElement("input", _extends$7({
        "aria-hidden": !0,
        id: this.props.id || null,
        ref: this.handleInputRef,
        style: {
          opacity: 0,
          width: 0,
          overflow: "hidden",
          border: "none",
          padding: 0
        },
        tabIndex: -1
      }, gA.Input ? gA.Input.props ? (
        // $FlowExpectedError[not-an-object]
        gA.Input.props
      ) : {} : {})));
    }
  }, {
    key: "renderClear",
    value: function() {
      var k, H = !!(this.props.value && this.props.value.length || this.state.inputValue);
      if (!(!this.props.clearable || this.props.disabled || this.props.isLoading || !H)) {
        var AA = this.getSharedProps();
        AA.$size;
        var gA = _objectWithoutProperties$4(AA, _excluded$6), IA = this.props.overrides, CA = IA === void 0 ? {} : IA, BA = getOverrides(CA.ClearIcon, DeleteAlt$1), eA = _slicedToArray$5(BA, 2), iA = eA[0], QA = eA[1], tA = this.props.multi ? "Clear all" : "Clear value", oA = (k = {}, _defineProperty$5(k, SIZE$1.mini, 15), _defineProperty$5(k, SIZE$1.compact, 15), _defineProperty$5(k, SIZE$1.default, 18), _defineProperty$5(k, SIZE$1.large, 22), k);
        return /* @__PURE__ */ React.createElement(iA, _extends$7({
          title: tA,
          "aria-label": tA,
          onClick: this.clearValue,
          role: "button",
          size: oA[this.props.size] || oA[SIZE$1.default]
        }, gA, QA));
      }
    }
  }, {
    key: "renderArrow",
    value: function() {
      var k;
      if (this.props.type !== TYPE.select)
        return null;
      var H = this.getSharedProps();
      H.$size;
      var AA = _objectWithoutProperties$4(H, _excluded2$2), gA = this.props.overrides, IA = gA === void 0 ? {} : gA, CA = getOverrides(IA.SelectArrow, TriangleDownIcon), BA = _slicedToArray$5(CA, 2), eA = BA[0], iA = BA[1];
      iA.overrides = mergeOverrides({
        Svg: {
          style: function(oA) {
            var EA = oA.$theme, aA = oA.$disabled;
            return {
              color: aA ? EA.colors.inputTextDisabled : EA.colors.contentPrimary
            };
          }
        }
      }, iA.overrides);
      var QA = (k = {}, _defineProperty$5(k, SIZE$1.mini, 16), _defineProperty$5(k, SIZE$1.compact, 16), _defineProperty$5(k, SIZE$1.default, 20), _defineProperty$5(k, SIZE$1.large, 24), k);
      return /* @__PURE__ */ React.createElement(eA, _extends$7({
        size: QA[this.props.size] || QA[SIZE$1.default],
        title: "open"
      }, AA, iA));
    }
  }, {
    key: "renderSearch",
    value: function() {
      if (this.props.type !== TYPE.search)
        return null;
      var k = this.props.overrides, H = k === void 0 ? {} : k, AA = getOverrides(H.SearchIconContainer, StyledSearchIconContainer), gA = _slicedToArray$5(AA, 2), IA = gA[0], CA = gA[1], BA = getOverrides(H.SearchIcon, SearchIconComponent), eA = _slicedToArray$5(BA, 2), iA = eA[0], QA = eA[1], tA = this.getSharedProps();
      return /* @__PURE__ */ React.createElement(IA, _extends$7({}, tA, CA), /* @__PURE__ */ React.createElement(iA, _extends$7({
        size: 16,
        title: "search"
      }, tA, QA)));
    }
  }, {
    key: "filterOptions",
    value: function(k) {
      var H = this, AA = this.state.inputValue.trim();
      this.props.filterOptions && (this.options = this.props.filterOptions(this.options, AA, k, {
        valueKey: this.props.valueKey,
        labelKey: this.props.labelKey
      }));
      var gA = this.props.ignoreCase ? function(CA) {
        return CA[H.props.labelKey].toLowerCase() !== AA.toLowerCase().trim();
      } : function(CA) {
        return CA[H.props.labelKey] !== AA.trim();
      };
      if (AA && this.props.creatable && this.options.concat(this.props.value).every(gA)) {
        var IA;
        this.options.push((IA = {
          id: AA
        }, _defineProperty$5(IA, this.props.labelKey, AA), _defineProperty$5(IA, this.props.valueKey, AA), _defineProperty$5(IA, "isCreatable", !0), IA));
      }
      return this.options;
    }
  }, {
    key: "getSharedProps",
    value: function() {
      var k = this.props, H = k.clearable, AA = k.creatable, gA = k.disabled, IA = k.error, CA = k.positive, BA = k.isLoading, eA = k.multi, iA = k.required, QA = k.size, tA = k.searchable, oA = k.type, EA = k.value, aA = this.state, nA = aA.isOpen, lA = aA.isFocused, cA = aA.isPseudoFocused;
      return {
        $clearable: H,
        $creatable: AA,
        $disabled: gA,
        $error: IA,
        $positive: CA,
        $isFocused: lA,
        $isLoading: BA,
        $isOpen: nA,
        $isPseudoFocused: cA,
        $multi: eA,
        $required: iA,
        $searchable: tA,
        $size: QA,
        $type: oA,
        $isEmpty: !this.getValueArray(EA).length
      };
    }
  }, {
    key: "render",
    value: function() {
      var k = this;
      this.options = normalizeOptions(this.props.options);
      var H = this.props, AA = H.overrides, gA = AA === void 0 ? {} : AA, IA = H.type, CA = H.multi, BA = H.noResultsMsg, eA = H.value, iA = H.filterOutSelected;
      process.env.NODE_ENV !== "production" && eA && !Array.isArray(eA) && console.warn("The Select component expects an array as the value prop. For more information, please visit the docs at https://baseweb.design/components/select/");
      var QA = getOverrides(gA.Root, StyledRoot), tA = _slicedToArray$5(QA, 2), oA = tA[0], EA = tA[1], aA = getOverrides(gA.ControlContainer, StyledControlContainer), nA = _slicedToArray$5(aA, 2), lA = nA[0], cA = nA[1], sA = getOverrides(gA.ValueContainer, StyledValueContainer), rA = _slicedToArray$5(sA, 2), uA = rA[0], hA = rA[1], dA = getOverrides(gA.IconsContainer, StyledIconsContainer), GA = _slicedToArray$5(dA, 2), DA = GA[0], wA = GA[1], bA = getOverrides(gA.Popover, Popover$2), yA = _slicedToArray$5(bA, 2), pA = yA[0], MA = yA[1], LA = getOverrides(gA.Placeholder, StyledPlaceholder), xA = _slicedToArray$5(LA, 2), TA = xA[0], NA = xA[1], zA = this.getSharedProps(), XA = this.getValueArray(eA), fA = this.filterOptions(CA && iA ? XA : null), vA = this.state.isOpen;
      return zA.$isOpen = vA, process.env.NODE_ENV !== "production" && this.props.error && this.props.positive && console.warn("[Select] `error` and `positive` are both set to `true`. `error` will take precedence but this may not be what you want."), /* @__PURE__ */ React.createElement(UIDConsumer, null, function(Cg) {
        return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(Ig) {
          return /* @__PURE__ */ React.createElement(
            pA,
            _extends$7({
              innerRef: function(og) {
                og && (k.anchor = og.anchorRef);
              },
              accessibilityType: ACCESSIBILITY_TYPE.none,
              autoFocus: !1,
              focusLock: !1,
              mountNode: k.props.mountNode,
              onEsc: function() {
                return k.closeMenu();
              },
              isOpen: vA,
              popoverMargin: 0,
              content: function() {
                var og = {
                  error: k.props.error,
                  positive: k.props.positive,
                  getOptionLabel: k.props.getOptionLabel || k.getOptionLabel.bind(k, Ig),
                  id: Cg,
                  isLoading: k.props.isLoading,
                  labelKey: k.props.labelKey,
                  maxDropdownHeight: k.props.maxDropdownHeight,
                  multi: CA,
                  noResultsMsg: BA,
                  onActiveDescendantChange: k.handleActiveDescendantChange,
                  onItemSelect: k.selectValue,
                  options: fA,
                  overrides: gA,
                  required: k.props.required,
                  searchable: k.props.searchable,
                  size: k.props.size,
                  type: IA,
                  value: XA,
                  valueKey: k.props.valueKey,
                  width: k.anchor.current ? k.anchor.current.clientWidth : null,
                  keyboardControlNode: k.anchor
                };
                return /* @__PURE__ */ React.createElement(SelectDropdown, _extends$7({
                  innerRef: k.dropdown
                }, og));
              },
              placement: PLACEMENT.bottom
            }, MA),
            /* @__PURE__ */ React.createElement(oA, _extends$7({
              onBlur: k.handleBlur,
              "data-baseweb": "select"
            }, zA, EA), /* @__PURE__ */ React.createElement(lA, _extends$7({
              onKeyDown: k.handleKeyDown,
              onClick: k.handleClick,
              onTouchEnd: k.handleTouchEnd,
              onTouchMove: k.handleTouchMove,
              onTouchStart: k.handleTouchStart
            }, zA, cA), IA === TYPE.search ? k.renderSearch() : null, /* @__PURE__ */ React.createElement(uA, _extends$7({}, zA, hA), k.renderValue(XA), k.renderInput(Cg), k.shouldShowPlaceholder() ? /* @__PURE__ */ React.createElement(TA, _extends$7({}, zA, NA), typeof k.props.placeholder < "u" ? k.props.placeholder : Ig.select.placeholder) : null), /* @__PURE__ */ React.createElement(DA, _extends$7({}, zA, wA), k.renderLoading(), k.renderClear(), IA === TYPE.select ? k.renderArrow() : null)))
          );
        });
      });
    }
  }]), g;
})(React.Component);
_defineProperty$5(Select$1, "defaultProps", defaultProps);
var tint$1 = { exports: {} }, _curry = { exports: {} }, hasRequired_curry;
function require_curry() {
  return hasRequired_curry || (hasRequired_curry = 1, (function(n, t) {
    t.__esModule = !0, t.default = d;
    function g(k, H, AA) {
      return function() {
        var IA = AA.concat(Array.prototype.slice.call(arguments));
        return IA.length >= H ? k.apply(this, IA) : g(k, H, IA);
      };
    }
    function d(k) {
      return g(k, k.length, []);
    }
    n.exports = t.default;
  })(_curry, _curry.exports)), _curry.exports;
}
var mix = { exports: {} }, rgba = { exports: {} }, parseToRgb = { exports: {} }, _hslToRgb = { exports: {} }, hasRequired_hslToRgb;
function require_hslToRgb() {
  return hasRequired_hslToRgb || (hasRequired_hslToRgb = 1, (function(n, t) {
    t.__esModule = !0, t.default = void 0;
    function g(AA) {
      return Math.round(AA * 255);
    }
    function d(AA, gA, IA) {
      return g(AA) + "," + g(gA) + "," + g(IA);
    }
    function k(AA, gA, IA, CA) {
      if (CA === void 0 && (CA = d), gA === 0)
        return CA(IA, IA, IA);
      var BA = (AA % 360 + 360) % 360 / 60, eA = (1 - Math.abs(2 * IA - 1)) * gA, iA = eA * (1 - Math.abs(BA % 2 - 1)), QA = 0, tA = 0, oA = 0;
      BA >= 0 && BA < 1 ? (QA = eA, tA = iA) : BA >= 1 && BA < 2 ? (QA = iA, tA = eA) : BA >= 2 && BA < 3 ? (tA = eA, oA = iA) : BA >= 3 && BA < 4 ? (tA = iA, oA = eA) : BA >= 4 && BA < 5 ? (QA = iA, oA = eA) : BA >= 5 && BA < 6 && (QA = eA, oA = iA);
      var EA = IA - eA / 2, aA = QA + EA, nA = tA + EA, lA = oA + EA;
      return CA(aA, nA, lA);
    }
    var H = k;
    t.default = H, n.exports = t.default;
  })(_hslToRgb, _hslToRgb.exports)), _hslToRgb.exports;
}
var _nameToHex = { exports: {} }, hasRequired_nameToHex;
function require_nameToHex() {
  return hasRequired_nameToHex || (hasRequired_nameToHex = 1, (function(n, t) {
    t.__esModule = !0, t.default = void 0;
    var g = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "00ffff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "0000ff",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "00ffff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "ff00ff",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "639",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    };
    function d(H) {
      if (typeof H != "string") return H;
      var AA = H.toLowerCase();
      return g[AA] ? "#" + g[AA] : H;
    }
    var k = d;
    t.default = k, n.exports = t.default;
  })(_nameToHex, _nameToHex.exports)), _nameToHex.exports;
}
var _errors = { exports: {} }, hasRequired_errors;
function require_errors() {
  return hasRequired_errors || (hasRequired_errors = 1, (function(n, t) {
    t.__esModule = !0, t.default = void 0;
    function g(QA) {
      if (QA === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return QA;
    }
    function d(QA, tA) {
      QA.prototype = Object.create(tA.prototype), QA.prototype.constructor = QA, IA(QA, tA);
    }
    function k(QA) {
      var tA = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
      return k = function(EA) {
        if (EA === null || !gA(EA)) return EA;
        if (typeof EA != "function")
          throw new TypeError("Super expression must either be null or a function");
        if (typeof tA < "u") {
          if (tA.has(EA)) return tA.get(EA);
          tA.set(EA, aA);
        }
        function aA() {
          return H(EA, arguments, CA(this).constructor);
        }
        return aA.prototype = Object.create(EA.prototype, { constructor: { value: aA, enumerable: !1, writable: !0, configurable: !0 } }), IA(aA, EA);
      }, k(QA);
    }
    function H(QA, tA, oA) {
      return AA() ? H = Reflect.construct : H = function(aA, nA, lA) {
        var cA = [null];
        cA.push.apply(cA, nA);
        var sA = Function.bind.apply(aA, cA), rA = new sA();
        return lA && IA(rA, lA.prototype), rA;
      }, H.apply(null, arguments);
    }
    function AA() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function gA(QA) {
      return Function.toString.call(QA).indexOf("[native code]") !== -1;
    }
    function IA(QA, tA) {
      return IA = Object.setPrototypeOf || function(EA, aA) {
        return EA.__proto__ = aA, EA;
      }, IA(QA, tA);
    }
    function CA(QA) {
      return CA = Object.setPrototypeOf ? Object.getPrototypeOf : function(oA) {
        return oA.__proto__ || Object.getPrototypeOf(oA);
      }, CA(QA);
    }
    var BA = {
      1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
      2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
      3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
      4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
      5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
      6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
      7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
      8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
      9: `Please provide a number of steps to the modularScale helper.

`,
      10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
      11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
      12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
      13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
      14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
      15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
      16: `You must provide a template to this method.

`,
      17: `You passed an unsupported selector state to this method.

`,
      18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
      19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
      20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
      21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
      22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
      23: `fontFace expects a name of a font-family.

`,
      24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
      25: `fontFace expects localFonts to be an array.

`,
      26: `fontFace expects fileFormats to be an array.

`,
      27: `radialGradient requries at least 2 color-stops to properly render.

`,
      28: `Please supply a filename to retinaImage() as the first argument.

`,
      29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
      30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
      31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
      32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
      33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
      34: `borderRadius expects a radius value as a string or number as the second argument.

`,
      35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
      36: `Property must be a string value.

`,
      37: `Syntax Error at %s.

`,
      38: `Formula contains a function that needs parentheses at %s.

`,
      39: `Formula is missing closing parenthesis at %s.

`,
      40: `Formula has too many closing parentheses at %s.

`,
      41: `All values in a formula must have the same unit or be unitless.

`,
      42: `Please provide a number of steps to the modularScale helper.

`,
      43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
      44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
      45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
      46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
      47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
      48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
      49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
      50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
      51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
      52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
      53: `fontFace expects localFonts to be an array.

`,
      54: `fontFace expects fileFormats to be an array.

`,
      55: `fontFace expects a name of a font-family.

`,
      56: `linearGradient requries at least 2 color-stops to properly render.

`,
      57: `radialGradient requries at least 2 color-stops to properly render.

`,
      58: `Please supply a filename to retinaImage() as the first argument.

`,
      59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
      60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
      61: `Property must be a string value.

`,
      62: `borderRadius expects a radius value as a string or number as the second argument.

`,
      63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
      64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
      65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
      66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
      67: `You must provide a template to this method.

`,
      68: `You passed an unsupported selector state to this method.

`,
      69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
      70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
      71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
      72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
      73: `Please provide a valid CSS variable.

`,
      74: `CSS variable not found.

`,
      75: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.
`
    };
    function eA() {
      for (var QA = arguments.length, tA = new Array(QA), oA = 0; oA < QA; oA++)
        tA[oA] = arguments[oA];
      var EA = tA[0], aA = [], nA;
      for (nA = 1; nA < tA.length; nA += 1)
        aA.push(tA[nA]);
      return aA.forEach(function(lA) {
        EA = EA.replace(/%[a-z]/, lA);
      }), EA;
    }
    var iA = /* @__PURE__ */ (function(QA) {
      d(tA, QA);
      function tA(oA) {
        var EA;
        if (process.env.NODE_ENV === "production")
          EA = QA.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + oA + " for more information.") || this;
        else {
          for (var aA = arguments.length, nA = new Array(aA > 1 ? aA - 1 : 0), lA = 1; lA < aA; lA++)
            nA[lA - 1] = arguments[lA];
          EA = QA.call(this, eA.apply(void 0, [BA[oA]].concat(nA))) || this;
        }
        return g(EA);
      }
      return tA;
    })(/* @__PURE__ */ k(Error));
    t.default = iA, n.exports = t.default;
  })(_errors, _errors.exports)), _errors.exports;
}
var hasRequiredParseToRgb;
function requireParseToRgb() {
  return hasRequiredParseToRgb || (hasRequiredParseToRgb = 1, (function(n, t) {
    t.__esModule = !0, t.default = tA;
    var g = /* @__PURE__ */ H(/* @__PURE__ */ require_hslToRgb()), d = /* @__PURE__ */ H(/* @__PURE__ */ require_nameToHex()), k = /* @__PURE__ */ H(/* @__PURE__ */ require_errors());
    function H(oA) {
      return oA && oA.__esModule ? oA : { default: oA };
    }
    var AA = /^#[a-fA-F0-9]{6}$/, gA = /^#[a-fA-F0-9]{8}$/, IA = /^#[a-fA-F0-9]{3}$/, CA = /^#[a-fA-F0-9]{4}$/, BA = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i, eA = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i, iA = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, QA = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
    function tA(oA) {
      if (typeof oA != "string")
        throw new k.default(3);
      var EA = (0, d.default)(oA);
      if (EA.match(AA))
        return {
          red: parseInt("" + EA[1] + EA[2], 16),
          green: parseInt("" + EA[3] + EA[4], 16),
          blue: parseInt("" + EA[5] + EA[6], 16)
        };
      if (EA.match(gA)) {
        var aA = parseFloat((parseInt("" + EA[7] + EA[8], 16) / 255).toFixed(2));
        return {
          red: parseInt("" + EA[1] + EA[2], 16),
          green: parseInt("" + EA[3] + EA[4], 16),
          blue: parseInt("" + EA[5] + EA[6], 16),
          alpha: aA
        };
      }
      if (EA.match(IA))
        return {
          red: parseInt("" + EA[1] + EA[1], 16),
          green: parseInt("" + EA[2] + EA[2], 16),
          blue: parseInt("" + EA[3] + EA[3], 16)
        };
      if (EA.match(CA)) {
        var nA = parseFloat((parseInt("" + EA[4] + EA[4], 16) / 255).toFixed(2));
        return {
          red: parseInt("" + EA[1] + EA[1], 16),
          green: parseInt("" + EA[2] + EA[2], 16),
          blue: parseInt("" + EA[3] + EA[3], 16),
          alpha: nA
        };
      }
      var lA = BA.exec(EA);
      if (lA)
        return {
          red: parseInt("" + lA[1], 10),
          green: parseInt("" + lA[2], 10),
          blue: parseInt("" + lA[3], 10)
        };
      var cA = eA.exec(EA.substring(0, 50));
      if (cA)
        return {
          red: parseInt("" + cA[1], 10),
          green: parseInt("" + cA[2], 10),
          blue: parseInt("" + cA[3], 10),
          alpha: parseFloat("" + cA[4])
        };
      var sA = iA.exec(EA);
      if (sA) {
        var rA = parseInt("" + sA[1], 10), uA = parseInt("" + sA[2], 10) / 100, hA = parseInt("" + sA[3], 10) / 100, dA = "rgb(" + (0, g.default)(rA, uA, hA) + ")", GA = BA.exec(dA);
        if (!GA)
          throw new k.default(4, EA, dA);
        return {
          red: parseInt("" + GA[1], 10),
          green: parseInt("" + GA[2], 10),
          blue: parseInt("" + GA[3], 10)
        };
      }
      var DA = QA.exec(EA.substring(0, 50));
      if (DA) {
        var wA = parseInt("" + DA[1], 10), bA = parseInt("" + DA[2], 10) / 100, yA = parseInt("" + DA[3], 10) / 100, pA = "rgb(" + (0, g.default)(wA, bA, yA) + ")", MA = BA.exec(pA);
        if (!MA)
          throw new k.default(4, EA, pA);
        return {
          red: parseInt("" + MA[1], 10),
          green: parseInt("" + MA[2], 10),
          blue: parseInt("" + MA[3], 10),
          alpha: parseFloat("" + DA[4])
        };
      }
      throw new k.default(5);
    }
    n.exports = t.default;
  })(parseToRgb, parseToRgb.exports)), parseToRgb.exports;
}
var rgb = { exports: {} }, _reduceHexValue = { exports: {} }, hasRequired_reduceHexValue;
function require_reduceHexValue() {
  return hasRequired_reduceHexValue || (hasRequired_reduceHexValue = 1, (function(n, t) {
    t.__esModule = !0, t.default = void 0;
    var g = function(H) {
      return H.length === 7 && H[1] === H[2] && H[3] === H[4] && H[5] === H[6] ? "#" + H[1] + H[3] + H[5] : H;
    }, d = g;
    t.default = d, n.exports = t.default;
  })(_reduceHexValue, _reduceHexValue.exports)), _reduceHexValue.exports;
}
var _numberToHex = { exports: {} }, hasRequired_numberToHex;
function require_numberToHex() {
  return hasRequired_numberToHex || (hasRequired_numberToHex = 1, (function(n, t) {
    t.__esModule = !0, t.default = void 0;
    function g(k) {
      var H = k.toString(16);
      return H.length === 1 ? "0" + H : H;
    }
    var d = g;
    t.default = d, n.exports = t.default;
  })(_numberToHex, _numberToHex.exports)), _numberToHex.exports;
}
var hasRequiredRgb;
function requireRgb() {
  return hasRequiredRgb || (hasRequiredRgb = 1, (function(n, t) {
    t.__esModule = !0, t.default = AA;
    var g = /* @__PURE__ */ H(/* @__PURE__ */ require_reduceHexValue()), d = /* @__PURE__ */ H(/* @__PURE__ */ require_numberToHex()), k = /* @__PURE__ */ H(/* @__PURE__ */ require_errors());
    function H(gA) {
      return gA && gA.__esModule ? gA : { default: gA };
    }
    function AA(gA, IA, CA) {
      if (typeof gA == "number" && typeof IA == "number" && typeof CA == "number")
        return (0, g.default)("#" + (0, d.default)(gA) + (0, d.default)(IA) + (0, d.default)(CA));
      if (typeof gA == "object" && IA === void 0 && CA === void 0)
        return (0, g.default)("#" + (0, d.default)(gA.red) + (0, d.default)(gA.green) + (0, d.default)(gA.blue));
      throw new k.default(6);
    }
    n.exports = t.default;
  })(rgb, rgb.exports)), rgb.exports;
}
var hasRequiredRgba;
function requireRgba() {
  return hasRequiredRgba || (hasRequiredRgba = 1, (function(n, t) {
    t.__esModule = !0, t.default = AA;
    var g = /* @__PURE__ */ H(/* @__PURE__ */ requireParseToRgb()), d = /* @__PURE__ */ H(/* @__PURE__ */ requireRgb()), k = /* @__PURE__ */ H(/* @__PURE__ */ require_errors());
    function H(gA) {
      return gA && gA.__esModule ? gA : { default: gA };
    }
    function AA(gA, IA, CA, BA) {
      if (typeof gA == "string" && typeof IA == "number") {
        var eA = (0, g.default)(gA);
        return "rgba(" + eA.red + "," + eA.green + "," + eA.blue + "," + IA + ")";
      } else {
        if (typeof gA == "number" && typeof IA == "number" && typeof CA == "number" && typeof BA == "number")
          return BA >= 1 ? (0, d.default)(gA, IA, CA) : "rgba(" + gA + "," + IA + "," + CA + "," + BA + ")";
        if (typeof gA == "object" && IA === void 0 && CA === void 0 && BA === void 0)
          return gA.alpha >= 1 ? (0, d.default)(gA.red, gA.green, gA.blue) : "rgba(" + gA.red + "," + gA.green + "," + gA.blue + "," + gA.alpha + ")";
      }
      throw new k.default(7);
    }
    n.exports = t.default;
  })(rgba, rgba.exports)), rgba.exports;
}
var hasRequiredMix;
function requireMix() {
  return hasRequiredMix || (hasRequiredMix = 1, (function(n, t) {
    t.__esModule = !0, t.default = void 0;
    var g = /* @__PURE__ */ H(/* @__PURE__ */ require_curry()), d = /* @__PURE__ */ H(/* @__PURE__ */ requireRgba()), k = /* @__PURE__ */ H(/* @__PURE__ */ requireParseToRgb());
    function H(BA) {
      return BA && BA.__esModule ? BA : { default: BA };
    }
    function AA() {
      return AA = Object.assign || function(BA) {
        for (var eA = 1; eA < arguments.length; eA++) {
          var iA = arguments[eA];
          for (var QA in iA)
            Object.prototype.hasOwnProperty.call(iA, QA) && (BA[QA] = iA[QA]);
        }
        return BA;
      }, AA.apply(this, arguments);
    }
    function gA(BA, eA, iA) {
      if (eA === "transparent") return iA;
      if (iA === "transparent") return eA;
      if (BA === 0) return iA;
      var QA = (0, k.default)(eA), tA = AA({}, QA, {
        alpha: typeof QA.alpha == "number" ? QA.alpha : 1
      }), oA = (0, k.default)(iA), EA = AA({}, oA, {
        alpha: typeof oA.alpha == "number" ? oA.alpha : 1
      }), aA = tA.alpha - EA.alpha, nA = parseFloat(BA) * 2 - 1, lA = nA * aA === -1 ? nA : nA + aA, cA = 1 + nA * aA, sA = (lA / cA + 1) / 2, rA = 1 - sA, uA = {
        red: Math.floor(tA.red * sA + EA.red * rA),
        green: Math.floor(tA.green * sA + EA.green * rA),
        blue: Math.floor(tA.blue * sA + EA.blue * rA),
        alpha: tA.alpha * (parseFloat(BA) / 1) + EA.alpha * (1 - parseFloat(BA) / 1)
      };
      return (0, d.default)(uA);
    }
    var IA = /* @__PURE__ */ (0, g.default)(gA), CA = IA;
    t.default = CA, n.exports = t.default;
  })(mix, mix.exports)), mix.exports;
}
var hasRequiredTint;
function requireTint() {
  return hasRequiredTint || (hasRequiredTint = 1, (function(n, t) {
    t.__esModule = !0, t.default = void 0;
    var g = /* @__PURE__ */ k(/* @__PURE__ */ require_curry()), d = /* @__PURE__ */ k(/* @__PURE__ */ requireMix());
    function k(IA) {
      return IA && IA.__esModule ? IA : { default: IA };
    }
    function H(IA, CA) {
      return CA === "transparent" ? CA : (0, d.default)(parseFloat(IA), "rgb(255, 255, 255)", CA);
    }
    var AA = /* @__PURE__ */ (0, g.default)(H), gA = AA;
    t.default = gA, n.exports = t.default;
  })(tint$1, tint$1.exports)), tint$1.exports;
}
var tintExports = /* @__PURE__ */ requireTint();
const tint = /* @__PURE__ */ getDefaultExportFromCjs$2(tintExports);
var shade$1 = { exports: {} }, hasRequiredShade;
function requireShade() {
  return hasRequiredShade || (hasRequiredShade = 1, (function(n, t) {
    t.__esModule = !0, t.default = void 0;
    var g = /* @__PURE__ */ k(/* @__PURE__ */ require_curry()), d = /* @__PURE__ */ k(/* @__PURE__ */ requireMix());
    function k(IA) {
      return IA && IA.__esModule ? IA : { default: IA };
    }
    function H(IA, CA) {
      return CA === "transparent" ? CA : (0, d.default)(parseFloat(IA), "rgb(0, 0, 0)", CA);
    }
    var AA = /* @__PURE__ */ (0, g.default)(H), gA = AA;
    t.default = gA, n.exports = t.default;
  })(shade$1, shade$1.exports)), shade$1.exports;
}
var shadeExports = /* @__PURE__ */ requireShade();
const shade = /* @__PURE__ */ getDefaultExportFromCjs$2(shadeExports);
var SIZE = {
  small: "small",
  medium: "medium",
  large: "large"
}, VARIANT = Object.freeze({
  solid: "solid",
  light: "light",
  outlined: "outlined"
}), KIND = {
  custom: "custom",
  // semantic
  neutral: "neutral",
  primary: "primary",
  accent: "accent",
  positive: "positive",
  warning: "warning",
  negative: "negative",
  // primitive
  black: "black",
  blue: "blue",
  green: "green",
  red: "red",
  yellow: "yellow",
  orange: "orange",
  purple: "purple",
  brown: "brown"
}, _neutralColorStates, _primaryColorStates, _accentColorStates, _positiveColorStates, _warningColorStates, _negativeColorStates, _orangeColorStates, _purpleColorStates, _brownColorStates, _customColorStates, _colorMap;
function ownKeys$3(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread$1(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$3(Object(g), !0).forEach(function(d) {
      _defineProperty$4(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$3(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty$4(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function customOnRamp(n, t) {
  switch (t) {
    case "0":
      return "white";
    case "50":
      return tint(0.8, n);
    case "100":
      return tint(0.6, n);
    case "200":
      return tint(0.4, n);
    case "300":
      return tint(0.2, n);
    case "400":
      return n;
    case "500":
      return shade(0.2, n);
    case "600":
      return shade(0.4, n);
    case "700":
      return shade(0.6, n);
    case "800":
      return shade(0.8, n);
    case "1000":
      return "black";
    default:
      return n;
  }
}
var COLOR_STATE = {
  disabled: "disabled",
  solid: "solid",
  outline: "outline"
}, pick$1 = function n(t, g, d) {
  return t.name && t.name.includes("dark") ? d : g;
}, neutralColorStates = (_neutralColorStates = {}, _defineProperty$4(_neutralColorStates, COLOR_STATE.disabled, function(n, t) {
  return {
    color: n.colors.tagNeutralFontDisabled,
    backgroundColor: null,
    borderColor: n.colors.tagNeutralOutlinedDisabled
  };
}), _defineProperty$4(_neutralColorStates, COLOR_STATE.solid, function(n, t) {
  return {
    color: n.colors.tagNeutralSolidFont,
    backgroundColor: n.colors.tagNeutralSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_neutralColorStates, COLOR_STATE.outline, function(n, t) {
  return {
    color: n.colors.tagNeutralOutlinedFont,
    backgroundColor: null,
    borderColor: n.colors.tagNeutralOutlinedBackground
  };
}), _neutralColorStates), primaryColorStates = (_primaryColorStates = {}, _defineProperty$4(_primaryColorStates, COLOR_STATE.disabled, function(n, t) {
  return {
    color: n.colors.tagPrimaryFontDisabled,
    backgroundColor: null,
    borderColor: n.colors.tagPrimaryOutlinedDisabled
  };
}), _defineProperty$4(_primaryColorStates, COLOR_STATE.solid, function(n, t) {
  return {
    color: n.colors.tagPrimarySolidFont,
    backgroundColor: n.colors.tagPrimarySolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_primaryColorStates, COLOR_STATE.outline, function(n, t) {
  return {
    color: n.colors.tagPrimaryOutlinedFont,
    backgroundColor: null,
    borderColor: n.colors.tagPrimaryOutlinedBackground
  };
}), _primaryColorStates), accentColorStates = (_accentColorStates = {}, _defineProperty$4(_accentColorStates, COLOR_STATE.disabled, function(n, t) {
  return {
    color: n.colors.tagAccentFontDisabled,
    backgroundColor: null,
    borderColor: n.colors.tagAccentOutlinedDisabled
  };
}), _defineProperty$4(_accentColorStates, COLOR_STATE.solid, function(n, t) {
  return {
    color: n.colors.tagAccentSolidFont,
    backgroundColor: n.colors.tagAccentSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_accentColorStates, COLOR_STATE.outline, function(n, t) {
  return {
    color: n.colors.tagAccentOutlinedFont,
    backgroundColor: null,
    borderColor: n.colors.tagAccentOutlinedBackground
  };
}), _accentColorStates), positiveColorStates = (_positiveColorStates = {}, _defineProperty$4(_positiveColorStates, COLOR_STATE.disabled, function(n, t) {
  return {
    color: n.colors.tagPositiveFontDisabled,
    backgroundColor: null,
    borderColor: n.colors.tagPositiveOutlinedDisabled
  };
}), _defineProperty$4(_positiveColorStates, COLOR_STATE.solid, function(n, t) {
  return {
    color: n.colors.tagPositiveSolidFont,
    backgroundColor: n.colors.tagPositiveSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_positiveColorStates, COLOR_STATE.outline, function(n, t) {
  return {
    color: n.colors.tagPositiveOutlinedFont,
    backgroundColor: null,
    borderColor: n.colors.tagPositiveOutlinedBackground
  };
}), _positiveColorStates), warningColorStates = (_warningColorStates = {}, _defineProperty$4(_warningColorStates, COLOR_STATE.disabled, function(n, t) {
  return {
    color: n.colors.tagWarningFontDisabled,
    backgroundColor: null,
    borderColor: n.colors.tagWarningOutlinedDisabled
  };
}), _defineProperty$4(_warningColorStates, COLOR_STATE.solid, function(n, t) {
  return {
    color: n.colors.tagWarningSolidFont,
    backgroundColor: n.colors.tagWarningSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_warningColorStates, COLOR_STATE.outline, function(n, t) {
  return {
    color: n.colors.tagWarningOutlinedFont,
    backgroundColor: null,
    borderColor: n.colors.tagWarningOutlinedBackground
  };
}), _warningColorStates), negativeColorStates = (_negativeColorStates = {}, _defineProperty$4(_negativeColorStates, COLOR_STATE.disabled, function(n, t) {
  return {
    color: n.colors.tagNegativeFontDisabled,
    backgroundColor: null,
    borderColor: n.colors.tagNegativeOutlinedDisabled
  };
}), _defineProperty$4(_negativeColorStates, COLOR_STATE.solid, function(n, t) {
  return {
    color: n.colors.tagNegativeSolidFont,
    backgroundColor: n.colors.tagNegativeSolidBackground,
    borderColor: null
  };
}), _defineProperty$4(_negativeColorStates, COLOR_STATE.outline, function(n, t) {
  return {
    color: n.colors.tagNegativeOutlinedFont,
    backgroundColor: null,
    borderColor: n.colors.tagNegativeOutlinedBackground
  };
}), _negativeColorStates), orangeColorStates = (_orangeColorStates = {}, _defineProperty$4(_orangeColorStates, COLOR_STATE.disabled, function(n, t) {
  return {
    color: pick$1(n, colors$3.orange200, colors$3.orange600),
    backgroundColor: null,
    borderColor: pick$1(n, colors$3.orange200, colors$3.orange700)
  };
}), _defineProperty$4(_orangeColorStates, COLOR_STATE.solid, function(n, t) {
  return {
    color: colors$3.white,
    backgroundColor: pick$1(n, colors$3.orange400, colors$3.orange500),
    borderColor: null
  };
}), _defineProperty$4(_orangeColorStates, COLOR_STATE.outline, function(n, t) {
  return {
    color: pick$1(n, colors$3.orange400, colors$3.orange300),
    backgroundColor: null,
    borderColor: pick$1(n, colors$3.orange200, colors$3.orange500)
  };
}), _orangeColorStates), purpleColorStates = (_purpleColorStates = {}, _defineProperty$4(_purpleColorStates, COLOR_STATE.disabled, function(n, t) {
  return {
    color: pick$1(n, colors$3.purple200, colors$3.purple600),
    backgroundColor: null,
    borderColor: pick$1(n, colors$3.purple200, colors$3.purple700)
  };
}), _defineProperty$4(_purpleColorStates, COLOR_STATE.solid, function(n, t) {
  return {
    color: colors$3.white,
    backgroundColor: pick$1(n, colors$3.purple400, colors$3.purple500),
    borderColor: null
  };
}), _defineProperty$4(_purpleColorStates, COLOR_STATE.outline, function(n, t) {
  return {
    color: pick$1(n, colors$3.purple400, colors$3.purple300),
    backgroundColor: null,
    borderColor: pick$1(n, colors$3.purple200, colors$3.purple500)
  };
}), _purpleColorStates), brownColorStates = (_brownColorStates = {}, _defineProperty$4(_brownColorStates, COLOR_STATE.disabled, function(n, t) {
  return {
    color: pick$1(n, colors$3.brown200, colors$3.brown600),
    backgroundColor: null,
    borderColor: pick$1(n, colors$3.brown200, colors$3.brown700)
  };
}), _defineProperty$4(_brownColorStates, COLOR_STATE.solid, function(n, t) {
  return {
    color: colors$3.white,
    backgroundColor: pick$1(n, colors$3.brown400, colors$3.brown500),
    borderColor: null
  };
}), _defineProperty$4(_brownColorStates, COLOR_STATE.outline, function(n, t) {
  return {
    color: pick$1(n, colors$3.brown400, colors$3.brown300),
    backgroundColor: null,
    borderColor: pick$1(n, colors$3.brown200, colors$3.brown500)
  };
}), _brownColorStates), customColorStates = (_customColorStates = {}, _defineProperty$4(_customColorStates, COLOR_STATE.disabled, function(n, t) {
  return {
    color: customOnRamp(t, n.colors.tagFontDisabledRampUnit),
    backgroundColor: null,
    borderColor: customOnRamp(t, n.colors.tagSolidDisabledRampUnit)
  };
}), _defineProperty$4(_customColorStates, COLOR_STATE.solid, function(n, t) {
  return {
    color: customOnRamp(t, n.colors.tagSolidFontRampUnit),
    backgroundColor: customOnRamp(t, n.colors.tagSolidRampUnit),
    borderColor: null
  };
}), _defineProperty$4(_customColorStates, COLOR_STATE.outline, function(n, t) {
  return {
    color: customOnRamp(t, n.colors.tagOutlinedFontRampUnit),
    backgroundColor: null,
    borderColor: customOnRamp(t, n.colors.tagOutlinedRampUnit)
  };
}), _customColorStates), colorMap = (_colorMap = {}, _defineProperty$4(_colorMap, KIND.neutral, neutralColorStates), _defineProperty$4(_colorMap, KIND.primary, primaryColorStates), _defineProperty$4(_colorMap, KIND.accent, accentColorStates), _defineProperty$4(_colorMap, KIND.positive, positiveColorStates), _defineProperty$4(_colorMap, KIND.warning, warningColorStates), _defineProperty$4(_colorMap, KIND.negative, negativeColorStates), _defineProperty$4(_colorMap, KIND.black, primaryColorStates), _defineProperty$4(_colorMap, KIND.blue, accentColorStates), _defineProperty$4(_colorMap, KIND.green, positiveColorStates), _defineProperty$4(_colorMap, KIND.red, negativeColorStates), _defineProperty$4(_colorMap, KIND.yellow, warningColorStates), _defineProperty$4(_colorMap, KIND.orange, orangeColorStates), _defineProperty$4(_colorMap, KIND.purple, purpleColorStates), _defineProperty$4(_colorMap, KIND.brown, brownColorStates), _defineProperty$4(_colorMap, KIND.custom, customColorStates), _colorMap), getColorStateFromProps = function n(t) {
  return t.$disabled ? COLOR_STATE.disabled : t.$variant === VARIANT.solid ? COLOR_STATE.solid : COLOR_STATE.outline;
}, Action$1 = styled("span", function(n) {
  var t, g, d = n.$theme, k = n.$disabled, H = n.$size, AA = H === void 0 ? SIZE.small : H, gA = d.direction === "rtl" ? "borderBottomLeftRadius" : "borderBottomRightRadius", IA = d.direction === "rtl" ? "borderTopLeftRadius" : "borderTopRightRadius", CA = d.direction === "rtl" ? "marginRight" : "marginLeft";
  return g = {
    alignItems: "center"
  }, _defineProperty$4(g, gA, d.borders.useRoundedCorners ? d.borders.radius400 : 0), _defineProperty$4(g, IA, d.borders.useRoundedCorners ? d.borders.radius400 : 0), _defineProperty$4(g, "cursor", k ? "not-allowed" : "pointer"), _defineProperty$4(g, "display", "flex"), _defineProperty$4(g, CA, (t = {}, _defineProperty$4(t, SIZE.small, "8px"), _defineProperty$4(t, SIZE.medium, "12px"), _defineProperty$4(t, SIZE.large, "16px"), t)[AA]), _defineProperty$4(g, "outline", "none"), _defineProperty$4(g, "transitionProperty", "all"), _defineProperty$4(g, "transitionDuration", "background-color"), _defineProperty$4(g, "transitionTimingFunction", d.animation.easeOutCurve), g;
});
Action$1.displayName = "Action";
Action$1.displayName = "Action";
var StartEnhancerContainer = styled("div", function(n) {
  var t = n.$theme, g = n.$size, d = g === void 0 ? SIZE.small : g, k = t.sizing.scale300;
  d === SIZE.medium ? k = t.sizing.scale400 : d === SIZE.large && (k = t.sizing.scale600);
  var H = t.direction === "rtl" ? "paddingLeft" : "paddingRight";
  return _defineProperty$4({
    alignItems: "center",
    display: "flex"
  }, H, k);
});
StartEnhancerContainer.displayName = "StartEnhancerContainer";
StartEnhancerContainer.displayName = "StartEnhancerContainer";
var Text = styled("span", function(n) {
  var t = n.$theme;
  return {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: n.$theme.sizing.scale3200,
    order: t.direction === "rtl" ? 1 : 0
  };
});
Text.displayName = "Text";
Text.displayName = "Text";
var Root$1 = styled("span", function(n) {
  var t, g, d, k = n.$theme, H = n.$kind, AA = H === void 0 ? KIND.primary : H, gA = n.$clickable, IA = n.$variant, CA = n.$disabled, BA = n.$closeable, eA = n.$isFocusVisible, iA = n.$color, QA = n.$size, tA = QA === void 0 ? SIZE.small : QA, oA = k.borders.tagBorderRadius, EA = (t = {}, _defineProperty$4(t, SIZE.small, k.sizing.scale300), _defineProperty$4(t, SIZE.medium, k.sizing.scale500), _defineProperty$4(t, SIZE.large, k.sizing.scale600), t)[tA], aA = !CA && IA === VARIANT.solid ? 0 : "2px", nA = colorMap[AA][getColorStateFromProps(n)](k, iA), lA = nA.color, cA = nA.backgroundColor, sA = nA.borderColor;
  return _objectSpread$1(_objectSpread$1({}, (g = {}, _defineProperty$4(g, SIZE.small, k.typography.LabelSmall), _defineProperty$4(g, SIZE.medium, k.typography.LabelMedium), _defineProperty$4(g, SIZE.large, k.typography.LabelLarge), g)[tA]), {}, {
    alignItems: "center",
    color: lA,
    backgroundColor: cA,
    borderLeftColor: sA,
    borderRightColor: sA,
    borderTopColor: sA,
    borderBottomColor: sA,
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftWidth: aA,
    borderRightWidth: aA,
    borderTopWidth: aA,
    borderBottomWidth: aA,
    borderTopLeftRadius: oA,
    borderTopRightRadius: oA,
    borderBottomRightRadius: oA,
    borderBottomLeftRadius: oA,
    boxSizing: "border-box",
    cursor: CA ? "not-allowed" : gA ? "pointer" : "default",
    display: "inline-flex",
    height: (d = {}, _defineProperty$4(d, SIZE.small, "24px"), _defineProperty$4(d, SIZE.medium, "32px"), _defineProperty$4(d, SIZE.large, "40px"), d)[tA],
    justifyContent: "space-between",
    marginTop: "5px",
    marginBottom: "5px",
    marginLeft: "5px",
    marginRight: "5px",
    paddingTop: k.sizing.scale0,
    paddingBottom: k.sizing.scale0,
    paddingLeft: EA,
    paddingRight: EA,
    outline: "none",
    ":hover": CA || !gA ? {} : {
      boxShadow: "inset 0px 0px 100px ".concat(pick$1(k, "rgba(0, 0, 0, 0.08)", "rgba(255, 255, 255, 0.2)"))
    },
    ":focus": CA || !gA && !BA ? {} : {
      boxShadow: eA ? "0 0 0 3px ".concat(AA === KIND.accent ? k.colors.primaryA : k.colors.accent) : "none"
    }
  });
});
Root$1.displayName = "Root";
Root$1.displayName = "Root";
function _typeof$2(n) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$2(n);
}
var JOINABLE_TYPES = /* @__PURE__ */ new Set(["string", "number"]);
function getTextFromChildren(n) {
  var t = React.Children.toArray(n).filter(function(d) {
    return d != null;
  });
  if (!t.length)
    return null;
  var g = t.every(function(d) {
    return JOINABLE_TYPES.has(_typeof$2(d));
  });
  return g ? t.join("") : null;
}
function _defineProperty$3(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
function _slicedToArray$4(n, t) {
  return _arrayWithHoles$3(n) || _iterableToArrayLimit$3(n, t) || _unsupportedIterableToArray$3(n, t) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$3(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$3(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$3(n, t);
  }
}
function _arrayLikeToArray$3(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$3(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$3(n) {
  if (Array.isArray(n)) return n;
}
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$6.apply(this, arguments);
}
var ModifiedViewBoxDeleteIcon = function n(t) {
  return /* @__PURE__ */ React.createElement(DeleteIcon, _extends$6({
    viewBox: "5 5 13.186 13.186"
  }, t));
}, Tag = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g, d = n.children, k = n.closeable, H = k === void 0 ? !0 : k, AA = n.color, gA = n.size, IA = gA === void 0 ? SIZE.small : gA, CA = n.disabled, BA = CA === void 0 ? !1 : CA, eA = n.isFocused, iA = eA === void 0 ? !1 : eA, QA = n.isHovered, tA = QA === void 0 ? !1 : QA, oA = n.kind, EA = oA === void 0 ? KIND.primary : oA, aA = n.onActionClick, nA = aA === void 0 ? function(Gg) {
  } : aA, lA = n.onActionKeyDown, cA = lA === void 0 ? function(Gg) {
  } : lA, sA = n.onClick, rA = sA === void 0 ? null : sA, uA = n.onKeyDown, hA = uA === void 0 ? null : uA, dA = n.overrides, GA = dA === void 0 ? {} : dA, DA = n.startEnhancer, wA = n.title, bA = n.variant, yA = bA === void 0 ? VARIANT.light : bA, pA = React.useState(!1), MA = _slicedToArray$4(pA, 2), LA = MA[0], xA = MA[1];
  function TA(Gg) {
    isFocusVisible(Gg) && xA(!0);
  }
  function NA(Gg) {
    LA !== !1 && xA(!1);
  }
  function zA(Gg) {
    if (Gg.currentTarget === Gg.target) {
      var bg = Gg.key;
      rA && bg === "Enter" && rA(Gg), H && (bg === "Backspace" || bg === "Delete") && (nA(Gg), cA(Gg)), hA && hA(Gg);
    }
  }
  var XA = getOverrides(GA.Root, Root$1), fA = _slicedToArray$4(XA, 2), vA = fA[0], Cg = fA[1], Ig = getOverrides(GA.Action, Action$1), gg = _slicedToArray$4(Ig, 2), og = gg[0], eg = gg[1], kA = getOverrides(GA.ActionIcon, ModifiedViewBoxDeleteIcon), YA = _slicedToArray$4(kA, 2), RA = YA[0], FA = YA[1], mA = getOverrides(GA.StartEnhancerContainer, StartEnhancerContainer), JA = _slicedToArray$4(mA, 2), VA = JA[0], HA = JA[1], jA = getOverrides(GA.Text, Text), _A = _slicedToArray$4(jA, 2), $A = _A[0], rg = _A[1], wg = typeof rA == "function", Dg = BA ? {} : {
    onClick: rA,
    onKeyDown: zA
  }, kg = BA ? {} : {
    onClick: function(bg) {
      bg.stopPropagation(), nA(bg);
    }
  }, ig = {
    $clickable: wg,
    $closeable: H,
    $color: AA,
    $disabled: BA,
    $isFocused: iA,
    $isHovered: tA,
    $kind: EA,
    $variant: yA,
    $isFocusVisible: LA,
    $size: IA
  }, ZA = wA || getTextFromChildren(d), KA = (wg || H) && !BA, PA = (g = {}, _defineProperty$3(g, SIZE.small, 12), _defineProperty$3(g, SIZE.medium, 16), _defineProperty$3(g, SIZE.large, 20), g)[IA], ag = DA;
  return /* @__PURE__ */ React.createElement(
    vA,
    _extends$6({
      ref: t,
      "data-baseweb": "tag",
      "aria-label": KA && H ? "".concat(typeof d == "string" ? "".concat(d, ", ") : "", "close by backspace") : null,
      "aria-disabled": BA ? !0 : null,
      role: KA ? "button" : null,
      tabIndex: KA ? 0 : null
    }, Dg, ig, Cg, {
      onFocus: forkFocus(Cg, TA),
      onBlur: forkBlur(Cg, NA)
    }),
    ag && // @ts-expect-error todo(flow->ts) it is not expected to be a number
    ag !== 0 && /* @__PURE__ */ React.createElement(VA, HA, /* @__PURE__ */ React.createElement(ag, null)),
    /* @__PURE__ */ React.createElement($A, _extends$6({
      title: ZA
    }, rg), d),
    H ? /* @__PURE__ */ React.createElement(og, _extends$6({
      "aria-hidden": !0,
      role: "presentation"
    }, kg, ig, eg), /* @__PURE__ */ React.createElement(RA, _extends$6({
      size: PA
    }, FA))) : null
  );
});
Tag.displayName = "Tag";
var _excluded$5 = ["overrides", "removeValue"];
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$5.apply(this, arguments);
}
function _slicedToArray$3(n, t) {
  return _arrayWithHoles$2(n) || _iterableToArrayLimit$2(n, t) || _unsupportedIterableToArray$2(n, t) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$2(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$2(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$2(n, t);
  }
}
function _arrayLikeToArray$2(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$2(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$2(n) {
  if (Array.isArray(n)) return n;
}
function _objectWithoutProperties$3(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$3(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$3(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function MultiValue(n) {
  var t = n.overrides, g = t === void 0 ? {} : t, d = n.removeValue, k = _objectWithoutProperties$3(n, _excluded$5), H = getOverrides(g.Tag || g.MultiValue, Tag), AA = _slicedToArray$3(H, 2), gA = AA[0], IA = AA[1];
  return /* @__PURE__ */ React.createElement(gA, _extends$5({
    variant: VARIANT.solid,
    overrides: {
      Root: {
        style: function(BA) {
          var eA = BA.$theme.sizing;
          return {
            marginRight: eA.scale0,
            marginBottom: eA.scale0,
            marginLeft: eA.scale0,
            marginTop: eA.scale0
          };
        }
      }
    },
    onActionClick: d
  }, k, IA), n.children);
}
var _excluded$4 = ["overrides"];
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$4.apply(this, arguments);
}
function _slicedToArray$2(n, t) {
  return _arrayWithHoles$1(n) || _iterableToArrayLimit$1(n, t) || _unsupportedIterableToArray$1(n, t) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray$1(n, t);
    var g = Object.prototype.toString.call(n).slice(8, -1);
    if (g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set") return Array.from(n);
    if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g)) return _arrayLikeToArray$1(n, t);
  }
}
function _arrayLikeToArray$1(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = new Array(t); g < t; g++)
    d[g] = n[g];
  return d;
}
function _iterableToArrayLimit$1(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d = [], k = !0, H = !1, AA, gA;
    try {
      for (g = g.call(n); !(k = (AA = g.next()).done) && (d.push(AA.value), !(t && d.length === t)); k = !0)
        ;
    } catch (IA) {
      H = !0, gA = IA;
    } finally {
      try {
        !k && g.return != null && g.return();
      } finally {
        if (H) throw gA;
      }
    }
    return d;
  }
}
function _arrayWithHoles$1(n) {
  if (Array.isArray(n)) return n;
}
function _objectWithoutProperties$2(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose$2(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose$2(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function Value(n) {
  var t = n.overrides, g = t === void 0 ? {} : t, d = _objectWithoutProperties$2(n, _excluded$4), k = getOverrides(g.SingleValue, StyledSingleValue), H = _slicedToArray$2(k, 2), AA = H[0], gA = H[1];
  return /* @__PURE__ */ React.createElement(AA, _extends$4({}, d, gA), n.children);
}
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$3.apply(this, arguments);
}
function Select(n) {
  return /* @__PURE__ */ React.createElement(Select$1, _extends$3({}, n, {
    valueComponent: n.multi ? MultiValue : Value
  }));
}
var safeIsNaN = Number.isNaN || function n(t) {
  return typeof t == "number" && t !== t;
};
function isEqual(n, t) {
  return !!(n === t || safeIsNaN(n) && safeIsNaN(t));
}
function areInputsEqual(n, t) {
  if (n.length !== t.length)
    return !1;
  for (var g = 0; g < n.length; g++)
    if (!isEqual(n[g], t[g]))
      return !1;
  return !0;
}
function memoizeOne(n, t) {
  t === void 0 && (t = areInputsEqual);
  var g, d = [], k, H = !1;
  function AA() {
    for (var gA = [], IA = 0; IA < arguments.length; IA++)
      gA[IA] = arguments[IA];
    return H && g === this && t(gA, d) || (k = n.apply(this, gA), H = !0, g = this, d = gA), k;
  }
  return AA;
}
var hasNativePerformanceNow = typeof performance == "object" && typeof performance.now == "function", now = hasNativePerformanceNow ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function cancelTimeout(n) {
  cancelAnimationFrame(n.id);
}
function requestTimeout(n, t) {
  var g = now();
  function d() {
    now() - g >= t ? n.call(null) : k.id = requestAnimationFrame(d);
  }
  var k = {
    id: requestAnimationFrame(d)
  };
  return k;
}
var size = -1;
function getScrollbarSize(n) {
  if (n === void 0 && (n = !1), size === -1 || n) {
    var t = document.createElement("div"), g = t.style;
    g.width = "50px", g.height = "50px", g.overflow = "scroll", document.body.appendChild(t), size = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
  }
  return size;
}
var cachedRTLResult = null;
function getRTLOffsetType(n) {
  if (n === void 0 && (n = !1), cachedRTLResult === null || n) {
    var t = document.createElement("div"), g = t.style;
    g.width = "50px", g.height = "50px", g.overflow = "scroll", g.direction = "rtl";
    var d = document.createElement("div"), k = d.style;
    return k.width = "100px", k.height = "100px", t.appendChild(d), document.body.appendChild(t), t.scrollLeft > 0 ? cachedRTLResult = "positive-descending" : (t.scrollLeft = 1, t.scrollLeft === 0 ? cachedRTLResult = "negative" : cachedRTLResult = "positive-ascending"), document.body.removeChild(t), cachedRTLResult;
  }
  return cachedRTLResult;
}
process.env.NODE_ENV;
var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150, defaultItemKey$1 = function n(t, g) {
  return t;
}, devWarningsDirection = null, devWarningsTagName$1 = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (devWarningsDirection = /* @__PURE__ */ new WeakSet(), devWarningsTagName$1 = /* @__PURE__ */ new WeakSet());
function createListComponent(n) {
  var t, g = n.getItemOffset, d = n.getEstimatedTotalSize, k = n.getItemSize, H = n.getOffsetForIndexAndAlignment, AA = n.getStartIndexForOffset, gA = n.getStopIndexForStartIndex, IA = n.initInstanceProps, CA = n.shouldResetStyleCacheOnItemSizeChange, BA = n.validateProps;
  return t = /* @__PURE__ */ (function(eA) {
    _inheritsLoose(iA, eA);
    function iA(tA) {
      var oA;
      return oA = eA.call(this, tA) || this, oA._instanceProps = IA(oA.props, _assertThisInitialized$b(oA)), oA._outerRef = void 0, oA._resetIsScrollingTimeoutId = null, oA.state = {
        instance: _assertThisInitialized$b(oA),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof oA.props.initialScrollOffset == "number" ? oA.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, oA._callOnItemsRendered = void 0, oA._callOnItemsRendered = memoizeOne(function(EA, aA, nA, lA) {
        return oA.props.onItemsRendered({
          overscanStartIndex: EA,
          overscanStopIndex: aA,
          visibleStartIndex: nA,
          visibleStopIndex: lA
        });
      }), oA._callOnScroll = void 0, oA._callOnScroll = memoizeOne(function(EA, aA, nA) {
        return oA.props.onScroll({
          scrollDirection: EA,
          scrollOffset: aA,
          scrollUpdateWasRequested: nA
        });
      }), oA._getItemStyle = void 0, oA._getItemStyle = function(EA) {
        var aA = oA.props, nA = aA.direction, lA = aA.itemSize, cA = aA.layout, sA = oA._getItemStyleCache(CA && lA, CA && cA, CA && nA), rA;
        if (sA.hasOwnProperty(EA))
          rA = sA[EA];
        else {
          var uA = g(oA.props, EA, oA._instanceProps), hA = k(oA.props, EA, oA._instanceProps), dA = nA === "horizontal" || cA === "horizontal", GA = nA === "rtl", DA = dA ? uA : 0;
          sA[EA] = rA = {
            position: "absolute",
            left: GA ? void 0 : DA,
            right: GA ? DA : void 0,
            top: dA ? 0 : uA,
            height: dA ? "100%" : hA,
            width: dA ? hA : "100%"
          };
        }
        return rA;
      }, oA._getItemStyleCache = void 0, oA._getItemStyleCache = memoizeOne(function(EA, aA, nA) {
        return {};
      }), oA._onScrollHorizontal = function(EA) {
        var aA = EA.currentTarget, nA = aA.clientWidth, lA = aA.scrollLeft, cA = aA.scrollWidth;
        oA.setState(function(sA) {
          if (sA.scrollOffset === lA)
            return null;
          var rA = oA.props.direction, uA = lA;
          if (rA === "rtl")
            switch (getRTLOffsetType()) {
              case "negative":
                uA = -lA;
                break;
              case "positive-descending":
                uA = cA - nA - lA;
                break;
            }
          return uA = Math.max(0, Math.min(uA, cA - nA)), {
            isScrolling: !0,
            scrollDirection: sA.scrollOffset < uA ? "forward" : "backward",
            scrollOffset: uA,
            scrollUpdateWasRequested: !1
          };
        }, oA._resetIsScrollingDebounced);
      }, oA._onScrollVertical = function(EA) {
        var aA = EA.currentTarget, nA = aA.clientHeight, lA = aA.scrollHeight, cA = aA.scrollTop;
        oA.setState(function(sA) {
          if (sA.scrollOffset === cA)
            return null;
          var rA = Math.max(0, Math.min(cA, lA - nA));
          return {
            isScrolling: !0,
            scrollDirection: sA.scrollOffset < rA ? "forward" : "backward",
            scrollOffset: rA,
            scrollUpdateWasRequested: !1
          };
        }, oA._resetIsScrollingDebounced);
      }, oA._outerRefSetter = function(EA) {
        var aA = oA.props.outerRef;
        oA._outerRef = EA, typeof aA == "function" ? aA(EA) : aA != null && typeof aA == "object" && aA.hasOwnProperty("current") && (aA.current = EA);
      }, oA._resetIsScrollingDebounced = function() {
        oA._resetIsScrollingTimeoutId !== null && cancelTimeout(oA._resetIsScrollingTimeoutId), oA._resetIsScrollingTimeoutId = requestTimeout(oA._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      }, oA._resetIsScrolling = function() {
        oA._resetIsScrollingTimeoutId = null, oA.setState({
          isScrolling: !1
        }, function() {
          oA._getItemStyleCache(-1, null);
        });
      }, oA;
    }
    iA.getDerivedStateFromProps = function(oA, EA) {
      return validateSharedProps$1(oA, EA), BA(oA), null;
    };
    var QA = iA.prototype;
    return QA.scrollTo = function(oA) {
      oA = Math.max(0, oA), this.setState(function(EA) {
        return EA.scrollOffset === oA ? null : {
          scrollDirection: EA.scrollOffset < oA ? "forward" : "backward",
          scrollOffset: oA,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, QA.scrollToItem = function(oA, EA) {
      EA === void 0 && (EA = "auto");
      var aA = this.props, nA = aA.itemCount, lA = aA.layout, cA = this.state.scrollOffset;
      oA = Math.max(0, Math.min(oA, nA - 1));
      var sA = 0;
      if (this._outerRef) {
        var rA = this._outerRef;
        lA === "vertical" ? sA = rA.scrollWidth > rA.clientWidth ? getScrollbarSize() : 0 : sA = rA.scrollHeight > rA.clientHeight ? getScrollbarSize() : 0;
      }
      this.scrollTo(H(this.props, oA, EA, cA, this._instanceProps, sA));
    }, QA.componentDidMount = function() {
      var oA = this.props, EA = oA.direction, aA = oA.initialScrollOffset, nA = oA.layout;
      if (typeof aA == "number" && this._outerRef != null) {
        var lA = this._outerRef;
        EA === "horizontal" || nA === "horizontal" ? lA.scrollLeft = aA : lA.scrollTop = aA;
      }
      this._callPropsCallbacks();
    }, QA.componentDidUpdate = function() {
      var oA = this.props, EA = oA.direction, aA = oA.layout, nA = this.state, lA = nA.scrollOffset, cA = nA.scrollUpdateWasRequested;
      if (cA && this._outerRef != null) {
        var sA = this._outerRef;
        if (EA === "horizontal" || aA === "horizontal")
          if (EA === "rtl")
            switch (getRTLOffsetType()) {
              case "negative":
                sA.scrollLeft = -lA;
                break;
              case "positive-ascending":
                sA.scrollLeft = lA;
                break;
              default:
                var rA = sA.clientWidth, uA = sA.scrollWidth;
                sA.scrollLeft = uA - rA - lA;
                break;
            }
          else
            sA.scrollLeft = lA;
        else
          sA.scrollTop = lA;
      }
      this._callPropsCallbacks();
    }, QA.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && cancelTimeout(this._resetIsScrollingTimeoutId);
    }, QA.render = function() {
      var oA = this.props, EA = oA.children, aA = oA.className, nA = oA.direction, lA = oA.height, cA = oA.innerRef, sA = oA.innerElementType, rA = oA.innerTagName, uA = oA.itemCount, hA = oA.itemData, dA = oA.itemKey, GA = dA === void 0 ? defaultItemKey$1 : dA, DA = oA.layout, wA = oA.outerElementType, bA = oA.outerTagName, yA = oA.style, pA = oA.useIsScrolling, MA = oA.width, LA = this.state.isScrolling, xA = nA === "horizontal" || DA === "horizontal", TA = xA ? this._onScrollHorizontal : this._onScrollVertical, NA = this._getRangeToRender(), zA = NA[0], XA = NA[1], fA = [];
      if (uA > 0)
        for (var vA = zA; vA <= XA; vA++)
          fA.push(createElement$1(EA, {
            data: hA,
            key: GA(vA, hA),
            index: vA,
            isScrolling: pA ? LA : void 0,
            style: this._getItemStyle(vA)
          }));
      var Cg = d(this.props, this._instanceProps);
      return createElement$1(wA || bA || "div", {
        className: aA,
        onScroll: TA,
        ref: this._outerRefSetter,
        style: _extends$M({
          position: "relative",
          height: lA,
          width: MA,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: nA
        }, yA)
      }, createElement$1(sA || rA || "div", {
        children: fA,
        ref: cA,
        style: {
          height: xA ? "100%" : Cg,
          pointerEvents: LA ? "none" : void 0,
          width: xA ? Cg : "100%"
        }
      }));
    }, QA._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var oA = this.props.itemCount;
        if (oA > 0) {
          var EA = this._getRangeToRender(), aA = EA[0], nA = EA[1], lA = EA[2], cA = EA[3];
          this._callOnItemsRendered(aA, nA, lA, cA);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var sA = this.state, rA = sA.scrollDirection, uA = sA.scrollOffset, hA = sA.scrollUpdateWasRequested;
        this._callOnScroll(rA, uA, hA);
      }
    }, QA._getRangeToRender = function() {
      var oA = this.props, EA = oA.itemCount, aA = oA.overscanCount, nA = this.state, lA = nA.isScrolling, cA = nA.scrollDirection, sA = nA.scrollOffset;
      if (EA === 0)
        return [0, 0, 0, 0];
      var rA = AA(this.props, sA, this._instanceProps), uA = gA(this.props, rA, sA, this._instanceProps), hA = !lA || cA === "backward" ? Math.max(1, aA) : 1, dA = !lA || cA === "forward" ? Math.max(1, aA) : 1;
      return [Math.max(0, rA - hA), Math.max(0, Math.min(EA - 1, uA + dA)), rA, uA];
    }, iA;
  })(PureComponent), t.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, t;
}
var validateSharedProps$1 = function n(t, g) {
  var d = t.children, k = t.direction, H = t.height, AA = t.layout, gA = t.innerTagName, IA = t.outerTagName, CA = t.width, BA = g.instance;
  if (process.env.NODE_ENV !== "production") {
    (gA != null || IA != null) && devWarningsTagName$1 && !devWarningsTagName$1.has(BA) && (devWarningsTagName$1.add(BA), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var eA = k === "horizontal" || AA === "horizontal";
    switch (k) {
      case "horizontal":
      case "vertical":
        devWarningsDirection && !devWarningsDirection.has(BA) && (devWarningsDirection.add(BA), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + k + '" was specified.'));
    }
    switch (AA) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + AA + '" was specified.'));
    }
    if (d == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (d === null ? "null" : typeof d) + '" was specified.'));
    if (eA && typeof CA != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (CA === null ? "null" : typeof CA) + '" was specified.'));
    if (!eA && typeof H != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (H === null ? "null" : typeof H) + '" was specified.'));
  }
}, FixedSizeList = /* @__PURE__ */ createListComponent({
  getItemOffset: function n(t, g) {
    var d = t.itemSize;
    return g * d;
  },
  getItemSize: function n(t, g) {
    var d = t.itemSize;
    return d;
  },
  getEstimatedTotalSize: function n(t) {
    var g = t.itemCount, d = t.itemSize;
    return d * g;
  },
  getOffsetForIndexAndAlignment: function n(t, g, d, k, H, AA) {
    var gA = t.direction, IA = t.height, CA = t.itemCount, BA = t.itemSize, eA = t.layout, iA = t.width, QA = gA === "horizontal" || eA === "horizontal", tA = QA ? iA : IA, oA = Math.max(0, CA * BA - tA), EA = Math.min(oA, g * BA), aA = Math.max(0, g * BA - tA + BA + AA);
    switch (d === "smart" && (k >= aA - tA && k <= EA + tA ? d = "auto" : d = "center"), d) {
      case "start":
        return EA;
      case "end":
        return aA;
      case "center": {
        var nA = Math.round(aA + (EA - aA) / 2);
        return nA < Math.ceil(tA / 2) ? 0 : nA > oA + Math.floor(tA / 2) ? oA : nA;
      }
      case "auto":
      default:
        return k >= aA && k <= EA ? k : k < aA ? aA : EA;
    }
  },
  getStartIndexForOffset: function n(t, g) {
    var d = t.itemCount, k = t.itemSize;
    return Math.max(0, Math.min(d - 1, Math.floor(g / k)));
  },
  getStopIndexForStartIndex: function n(t, g, d) {
    var k = t.direction, H = t.height, AA = t.itemCount, gA = t.itemSize, IA = t.layout, CA = t.width, BA = k === "horizontal" || IA === "horizontal", eA = g * gA, iA = BA ? CA : H, QA = Math.ceil((iA + d - eA) / gA);
    return Math.max(0, Math.min(
      AA - 1,
      g + QA - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function n(t) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function n(t) {
    var g = t.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof g != "number")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a number. ' + ('"' + (g === null ? "null" : typeof g) + '" was specified.'));
  }
});
const ThemedStyledDropdownListItem = /* @__PURE__ */ createStyled$1(StyledDropdownListItem, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: isPropValid,
  target: "e1811lun0"
} : {
  shouldForwardProp: isPropValid,
  target: "e1811lun0",
  label: "ThemedStyledDropdownListItem"
})(({
  theme: n,
  $isHighlighted: t
}) => ({
  display: "flex",
  alignItems: "center",
  paddingTop: n.spacing.none,
  paddingBottom: n.spacing.none,
  paddingLeft: n.spacing.lg,
  paddingRight: n.spacing.lg,
  background: t ? n.colors.darkenedBgMix15 : void 0,
  fontWeight: n.fontWeights.normal,
  // Override the default itemSize set on the component's JSX
  // on mobile, so we can make list items taller and scrollable
  [`@media (max-width: ${n.breakpoints.md})`]: {
    minHeight: n.sizes.dropdownItemHeight,
    height: "auto !important"
  },
  "&:hover, &:active, &:focus-visible": {
    background: n.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function FixedSizeListItem(n) {
  const {
    data: t,
    index: g,
    style: d
  } = n, {
    item: k,
    overrides: H,
    ...AA
  } = t[g].props, gA = k.isCreatable ? `Add: ${k.label}` : k.label;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemedStyledDropdownListItem, { style: d, ...AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(OverflowTooltip, { content: gA, placement: Placement.AUTO, children: gA }) }, k.value);
}
const VirtualDropdown = forwardRef((n, t) => {
  const g = useEmotionTheme(), d = Children.toArray(n.children);
  if (!d[0]?.props.item) {
    const H = d[0] ? d[0].props : {};
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledList, { $style: {
      height: g.sizes.emptyDropdownHeight,
      paddingBottom: g.spacing.none,
      paddingTop: g.spacing.none,
      paddingLeft: g.spacing.none,
      paddingRight: g.spacing.none,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // Somehow this adds an additional shadow, even though we already have
      // one on the popover, so we need to remove it here.
      boxShadow: "none"
    }, ref: t, "data-testid": "stSelectboxVirtualDropdownEmpty", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEmptyState, { $style: {
      paddingBottom: g.spacing.none,
      paddingTop: g.spacing.none,
      paddingLeft: g.spacing.none,
      paddingRight: g.spacing.none,
      color: g.colors.fadedText60
    }, ...H }) });
  }
  const k = Math.min(convertRemToPx(g.sizes.maxDropdownHeight), d.length * convertRemToPx(g.sizes.dropdownItemHeight));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledList, { ref: t, $style: {
    paddingTop: 0,
    paddingBottom: 0,
    // Somehow this adds an additional shadow, even though we already have
    // one on the popover, so we need to remove it here.
    boxShadow: "none"
  }, "data-testid": "stSelectboxVirtualDropdown", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FixedSizeList, { width: "100%", height: k, itemCount: d.length, itemData: d, itemKey: (H, AA) => {
    const {
      id: gA,
      value: IA
    } = AA[H].props.item;
    return gA ?? IA;
  }, itemSize: convertRemToPx(g.sizes.dropdownItemHeight), children: FixedSizeListItem }) });
});
VirtualDropdown.displayName = "VirtualDropdown";
var sortBy_1, hasRequiredSortBy;
function requireSortBy() {
  if (hasRequiredSortBy) return sortBy_1;
  hasRequiredSortBy = 1;
  var n = require_baseFlatten(), t = require_baseOrderBy(), g = require_baseRest(), d = require_isIterateeCall(), k = g(function(H, AA) {
    if (H == null)
      return [];
    var gA = AA.length;
    return gA > 1 && d(H, AA[0], AA[1]) ? AA = [] : gA > 2 && d(AA[0], AA[1], AA[2]) && (AA = [AA[0]]), t(H, n(AA, 1), []);
  });
  return sortBy_1 = k, sortBy_1;
}
var sortByExports = requireSortBy();
const sortBy = /* @__PURE__ */ getDefaultExportFromCjs$2(sortByExports), SCORE_MIN = -1 / 0, SCORE_MAX = 1 / 0, SCORE_GAP_LEADING = -5e-3, SCORE_GAP_TRAILING = -5e-3, SCORE_GAP_INNER = -0.01, SCORE_MATCH_CONSECUTIVE = 1, SCORE_MATCH_SLASH = 0.9, SCORE_MATCH_WORD = 0.8, SCORE_MATCH_CAPITAL = 0.7, SCORE_MATCH_DOT = 0.6;
function islower(n) {
  return n.toLowerCase() === n;
}
function isupper(n) {
  return n.toUpperCase() === n;
}
function precomputeBonus(n) {
  const t = n.length, g = new Array(t);
  let d = "/";
  for (let k = 0; k < t; k++) {
    const H = n[k];
    d === "/" ? g[k] = SCORE_MATCH_SLASH : d === "-" || d === "_" || d === " " ? g[k] = SCORE_MATCH_WORD : d === "." ? g[k] = SCORE_MATCH_DOT : islower(d) && isupper(H) ? g[k] = SCORE_MATCH_CAPITAL : g[k] = 0, d = H;
  }
  return g;
}
function compute(n, t, g, d, k = !1) {
  const H = n.length, AA = t.length, gA = k ? n : n.toLowerCase(), IA = k ? t : t.toLowerCase(), CA = precomputeBonus(t);
  for (let BA = 0; BA < H; BA++) {
    g[BA] = new Array(AA), d[BA] = new Array(AA);
    let eA = SCORE_MIN;
    const iA = BA === H - 1 ? SCORE_GAP_TRAILING : SCORE_GAP_INNER;
    for (let QA = 0; QA < AA; QA++)
      if (gA[BA] === IA[QA]) {
        let tA = SCORE_MIN;
        BA ? QA && (tA = Math.max(
          d[BA - 1][QA - 1] + CA[QA],
          /* consecutive match, doesn't stack with matchBonus */
          g[BA - 1][QA - 1] + SCORE_MATCH_CONSECUTIVE
        )) : tA = QA * SCORE_GAP_LEADING + CA[QA], g[BA][QA] = tA, d[BA][QA] = eA = Math.max(tA, eA + iA);
      } else
        g[BA][QA] = SCORE_MIN, d[BA][QA] = eA = eA + iA;
  }
}
function score(n, t, g = !1) {
  const d = n.length, k = t.length;
  if (!d || !k) return SCORE_MIN;
  if (n === t || !g && k === d)
    return SCORE_MAX;
  if (k > 1024)
    return SCORE_MIN;
  const H = new Array(d), AA = new Array(d);
  return compute(n, t, H, AA, g), AA[d - 1][k - 1];
}
function hasMatch(n, t) {
  n = n.toLowerCase(), t = t.toLowerCase();
  const g = n.length;
  for (let d = 0, k = 0; d < g; d += 1)
    if (k = t.indexOf(n[d], k) + 1, k === 0) return !1;
  return !0;
}
function fuzzyFilterSelectOptions(n, t) {
  if (!t)
    return n;
  const g = n.filter((d) => hasMatch(t, d.label));
  return sortBy(
    g,
    // Use the negative score to sort the list in a stable manner
    // This ensures highest score is first
    (d) => -score(t, d.label, !0)
  );
}
var uaParser$1 = { exports: {} }, uaParser = uaParser$1.exports, hasRequiredUaParser;
function requireUaParser() {
  return hasRequiredUaParser || (hasRequiredUaParser = 1, (function(n, t) {
    (function(g, d) {
      var k = "1.0.41", H = "", AA = "?", gA = "function", IA = "undefined", CA = "object", BA = "string", eA = "major", iA = "model", QA = "name", tA = "type", oA = "vendor", EA = "version", aA = "architecture", nA = "console", lA = "mobile", cA = "tablet", sA = "smarttv", rA = "wearable", uA = "embedded", hA = 500, dA = "Amazon", GA = "Apple", DA = "ASUS", wA = "BlackBerry", bA = "Browser", yA = "Chrome", pA = "Edge", MA = "Firefox", LA = "Google", xA = "Honor", TA = "Huawei", NA = "Lenovo", zA = "LG", XA = "Microsoft", fA = "Motorola", vA = "Nvidia", Cg = "OnePlus", Ig = "Opera", gg = "OPPO", og = "Samsung", eg = "Sharp", kA = "Sony", YA = "Xiaomi", RA = "Zebra", FA = "Facebook", mA = "Chromium OS", JA = "Mac OS", VA = " Browser", HA = function(bg, yg) {
        var hg = {};
        for (var tg in bg)
          yg[tg] && yg[tg].length % 2 === 0 ? hg[tg] = yg[tg].concat(bg[tg]) : hg[tg] = bg[tg];
        return hg;
      }, jA = function(bg) {
        for (var yg = {}, hg = 0; hg < bg.length; hg++)
          yg[bg[hg].toUpperCase()] = bg[hg];
        return yg;
      }, _A = function(bg, yg) {
        return typeof bg === BA ? $A(yg).indexOf($A(bg)) !== -1 : !1;
      }, $A = function(bg) {
        return bg.toLowerCase();
      }, rg = function(bg) {
        return typeof bg === BA ? bg.replace(/[^\d\.]/g, H).split(".")[0] : d;
      }, wg = function(bg, yg) {
        if (typeof bg === BA)
          return bg = bg.replace(/^\s\s*/, H), typeof yg === IA ? bg : bg.substring(0, hA);
      }, Dg = function(bg, yg) {
        for (var hg = 0, tg, Eg, cg, sg, ug, Mg; hg < yg.length && !ug; ) {
          var Rg = yg[hg], Jg = yg[hg + 1];
          for (tg = Eg = 0; tg < Rg.length && !ug && Rg[tg]; )
            if (ug = Rg[tg++].exec(bg), ug)
              for (cg = 0; cg < Jg.length; cg++)
                Mg = ug[++Eg], sg = Jg[cg], typeof sg === CA && sg.length > 0 ? sg.length === 2 ? typeof sg[1] == gA ? this[sg[0]] = sg[1].call(this, Mg) : this[sg[0]] = sg[1] : sg.length === 3 ? typeof sg[1] === gA && !(sg[1].exec && sg[1].test) ? this[sg[0]] = Mg ? sg[1].call(this, Mg, sg[2]) : d : this[sg[0]] = Mg ? Mg.replace(sg[1], sg[2]) : d : sg.length === 4 && (this[sg[0]] = Mg ? sg[3].call(this, Mg.replace(sg[1], sg[2])) : d) : this[sg] = Mg || d;
          hg += 2;
        }
      }, kg = function(bg, yg) {
        for (var hg in yg)
          if (typeof yg[hg] === CA && yg[hg].length > 0) {
            for (var tg = 0; tg < yg[hg].length; tg++)
              if (_A(yg[hg][tg], bg))
                return hg === AA ? d : hg;
          } else if (_A(yg[hg], bg))
            return hg === AA ? d : hg;
        return yg.hasOwnProperty("*") ? yg["*"] : bg;
      }, ig = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      }, ZA = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: ["NT 5.1", "NT 5.2"],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        "8.1": "NT 6.3",
        10: ["NT 6.4", "NT 10.0"],
        RT: "ARM"
      }, KA = {
        browser: [
          [
            /\b(?:crmo|crios)\/([\w\.]+)/i
            // Chrome for Android/iOS
          ],
          [EA, [QA, "Chrome"]],
          [
            /edg(?:e|ios|a)?\/([\w\.]+)/i
            // Microsoft Edge
          ],
          [EA, [QA, "Edge"]],
          [
            // Presto based
            /(opera mini)\/([-\w\.]+)/i,
            // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
            // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            // Opera
          ],
          [QA, EA],
          [
            /opios[\/ ]+([\w\.]+)/i
            // Opera mini on iphone >= 8.0
          ],
          [EA, [QA, Ig + " Mini"]],
          [
            /\bop(?:rg)?x\/([\w\.]+)/i
            // Opera GX
          ],
          [EA, [QA, Ig + " GX"]],
          [
            /\bopr\/([\w\.]+)/i
            // Opera Webkit
          ],
          [EA, [QA, Ig]],
          [
            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            // Baidu
          ],
          [EA, [QA, "Baidu"]],
          [
            /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            // Maxthon
          ],
          [EA, [QA, "Maxthon"]],
          [
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
            // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
            // Trident based
            /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
            // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
            /(?:ms|\()(ie) ([\w\.]+)/i,
            // Internet Explorer
            // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
            // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
            /(heytap|ovi|115)browser\/([\d\.]+)/i,
            // HeyTap/Ovi/115
            /(weibo)__([\d\.]+)/i
            // Weibo
          ],
          [QA, EA],
          [
            /quark(?:pc)?\/([-\w\.]+)/i
            // Quark
          ],
          [EA, [QA, "Quark"]],
          [
            /\bddg\/([\w\.]+)/i
            // DuckDuckGo
          ],
          [EA, [QA, "DuckDuckGo"]],
          [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            // UCBrowser
          ],
          [EA, [QA, "UC" + bA]],
          [
            /microm.+\bqbcore\/([\w\.]+)/i,
            // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i
            // WeChat
          ],
          [EA, [QA, "WeChat"]],
          [
            /konqueror\/([\w\.]+)/i
            // Konqueror
          ],
          [EA, [QA, "Konqueror"]],
          [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            // IE11
          ],
          [EA, [QA, "IE"]],
          [
            /ya(?:search)?browser\/([\w\.]+)/i
            // Yandex
          ],
          [EA, [QA, "Yandex"]],
          [
            /slbrowser\/([\w\.]+)/i
            // Smart Lenovo Browser
          ],
          [EA, [QA, "Smart Lenovo " + bA]],
          [
            /(avast|avg)\/([\w\.]+)/i
            // Avast/AVG Secure Browser
          ],
          [[QA, /(.+)/, "$1 Secure " + bA], EA],
          [
            /\bfocus\/([\w\.]+)/i
            // Firefox Focus
          ],
          [EA, [QA, MA + " Focus"]],
          [
            /\bopt\/([\w\.]+)/i
            // Opera Touch
          ],
          [EA, [QA, Ig + " Touch"]],
          [
            /coc_coc\w+\/([\w\.]+)/i
            // Coc Coc Browser
          ],
          [EA, [QA, "Coc Coc"]],
          [
            /dolfin\/([\w\.]+)/i
            // Dolphin
          ],
          [EA, [QA, "Dolphin"]],
          [
            /coast\/([\w\.]+)/i
            // Opera Coast
          ],
          [EA, [QA, Ig + " Coast"]],
          [
            /miuibrowser\/([\w\.]+)/i
            // MIUI Browser
          ],
          [EA, [QA, "MIUI" + VA]],
          [
            /fxios\/([\w\.-]+)/i
            // Firefox for iOS
          ],
          [EA, [QA, MA]],
          [
            /\bqihoobrowser\/?([\w\.]*)/i
            // 360
          ],
          [EA, [QA, "360"]],
          [
            /\b(qq)\/([\w\.]+)/i
            // QQ
          ],
          [[QA, /(.+)/, "$1Browser"], EA],
          [
            /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
          ],
          [[QA, /(.+)/, "$1" + VA], EA],
          [
            // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
            /samsungbrowser\/([\w\.]+)/i
            // Samsung Internet
          ],
          [EA, [QA, og + " Internet"]],
          [
            /metasr[\/ ]?([\d\.]+)/i
            // Sogou Explorer
          ],
          [EA, [QA, "Sogou Explorer"]],
          [
            /(sogou)mo\w+\/([\d\.]+)/i
            // Sogou Mobile
          ],
          [[QA, "Sogou Mobile"], EA],
          [
            /(electron)\/([\w\.]+) safari/i,
            // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
            // Tesla
            /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            // QQ/2345
          ],
          [QA, EA],
          [
            /(lbbrowser|rekonq)/i,
            // LieBao Browser/Rekonq
            /\[(linkedin)app\]/i
            // LinkedIn App for iOS & Android
          ],
          [QA],
          [
            /ome\/([\w\.]+) \w* ?(iron) saf/i,
            // Iron
            /ome\/([\w\.]+).+qihu (360)[es]e/i
            // 360
          ],
          [EA, QA],
          [
            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            // Facebook App for iOS & Android
          ],
          [[QA, FA], EA],
          [
            /(Klarna)\/([\w\.]+)/i,
            // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
            // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
            // Naver InApp
            /(daum)apps[\/ ]([\w\.]+)/i,
            // Daum App
            /safari (line)\/([\w\.]+)/i,
            // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,
            // Line App for Android
            /(alipay)client\/([\w\.]+)/i,
            // Alipay
            /(twitter)(?:and| f.+e\/([\w\.]+))/i,
            // Twitter
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            // Chromium/Instagram/Snapchat
          ],
          [QA, EA],
          [
            /\bgsa\/([\w\.]+) .*safari\//i
            // Google Search Appliance on iOS
          ],
          [EA, [QA, "GSA"]],
          [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            // TikTok
          ],
          [EA, [QA, "TikTok"]],
          [
            /headlesschrome(?:\/([\w\.]+)| )/i
            // Chrome Headless
          ],
          [EA, [QA, yA + " Headless"]],
          [
            / wv\).+(chrome)\/([\w\.]+)/i
            // Chrome WebView
          ],
          [[QA, yA + " WebView"], EA],
          [
            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            // Android Browser
          ],
          [EA, [QA, "Android " + bA]],
          [
            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            // Chrome/OmniWeb/Arora/Tizen/Nokia
          ],
          [QA, EA],
          [
            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            // Mobile Safari
          ],
          [EA, [QA, "Mobile Safari"]],
          [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            // Safari & Safari Mobile
          ],
          [EA, QA],
          [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            // Safari < 3.0
          ],
          [QA, [EA, kg, ig]],
          [
            /(webkit|khtml)\/([\w\.]+)/i
          ],
          [QA, EA],
          [
            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i
            // Netscape
          ],
          [[QA, "Netscape"], EA],
          [
            /(wolvic|librewolf)\/([\w\.]+)/i
            // Wolvic/LibreWolf
          ],
          [QA, EA],
          [
            /mobile vr; rv:([\w\.]+)\).+firefox/i
            // Firefox Reality
          ],
          [EA, [QA, MA + " Reality"]],
          [
            /ekiohf.+(flow)\/([\w\.]+)/i,
            // Flow
            /(swiftfox)/i,
            // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
            // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
            // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,
            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
            // Mozilla
            // Other
            /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
            // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
            /\b(links) \(([\w\.]+)/i
            // Links
          ],
          [QA, [EA, /_/g, "."]],
          [
            /(cobalt)\/([\w\.]+)/i
            // Cobalt
          ],
          [QA, [EA, /master.|lts./, ""]]
        ],
        cpu: [
          [
            /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            // AMD64 (x64)
          ],
          [[aA, "amd64"]],
          [
            /(ia32(?=;))/i,
            // IA32 (quicktime)
            /\b((i[346]|x)86)(pc)?\b/i
            // IA32 (x86)
          ],
          [[aA, "ia32"]],
          [
            /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            // ARM64
          ],
          [[aA, "arm64"]],
          [
            /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            // ARMHF
          ],
          [[aA, "armhf"]],
          [
            // PocketPC mistakenly identified as PowerPC
            /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
          ],
          [[aA, "arm"]],
          [
            /((ppc|powerpc)(64)?)( mac|;|\))/i
            // PowerPC
          ],
          [[aA, /ower/, H, $A]],
          [
            / sun4\w[;\)]/i
            // SPARC
          ],
          [[aA, "sparc"]],
          [
            /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
          ],
          [[aA, $A]]
        ],
        device: [
          [
            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////
            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
          ],
          [iA, [oA, og], [tA, cA]],
          [
            /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]((?!sm-[lr])[-\w]+)/i,
            /sec-(sgh\w+)/i
          ],
          [iA, [oA, og], [tA, lA]],
          [
            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            // iPod/iPhone
          ],
          [iA, [oA, GA], [tA, lA]],
          [
            /\((ipad);[-\w\),; ]+apple/i,
            // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
          ],
          [iA, [oA, GA], [tA, cA]],
          [
            /(macintosh);/i
          ],
          [iA, [oA, GA]],
          [
            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
          ],
          [iA, [oA, eg], [tA, lA]],
          [
            // Honor
            /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
          ],
          [iA, [oA, xA], [tA, cA]],
          [
            /honor([-\w ]+)[;\)]/i
          ],
          [iA, [oA, xA], [tA, lA]],
          [
            // Huawei
            /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
          ],
          [iA, [oA, TA], [tA, cA]],
          [
            /(?:huawei)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
          ],
          [iA, [oA, TA], [tA, lA]],
          [
            // Xiaomi
            /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
            /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            // Mi Pad tablets
          ],
          [[iA, /_/g, " "], [oA, YA], [tA, cA]],
          [
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
            // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,
            // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
            // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
            // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
            // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
            // Xiaomi Mi
            / ([\w ]+) miui\/v?\d/i
          ],
          [[iA, /_/g, " "], [oA, YA], [tA, lA]],
          [
            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
          ],
          [iA, [oA, gg], [tA, lA]],
          [
            /\b(opd2(\d{3}a?))(?: bui|\))/i
          ],
          [iA, [oA, kg, { OnePlus: ["304", "403", "203"], "*": gg }], [tA, cA]],
          [
            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
          ],
          [iA, [oA, "Vivo"], [tA, lA]],
          [
            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
          ],
          [iA, [oA, "Realme"], [tA, lA]],
          [
            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
          ],
          [iA, [oA, fA], [tA, lA]],
          [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
          ],
          [iA, [oA, fA], [tA, cA]],
          [
            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
          ],
          [iA, [oA, zA], [tA, cA]],
          [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
            /\blg-?([\d\w]+) bui/i
          ],
          [iA, [oA, zA], [tA, lA]],
          [
            // Lenovo
            /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
            /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
          ],
          [iA, [oA, NA], [tA, cA]],
          [
            // Nokia
            /(nokia) (t[12][01])/i
          ],
          [oA, iA, [tA, cA]],
          [
            /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
            /nokia[-_ ]?(([-\w\. ]*))/i
          ],
          [[iA, /_/g, " "], [tA, lA], [oA, "Nokia"]],
          [
            // Google
            /(pixel (c|tablet))\b/i
            // Google Pixel C/Tablet
          ],
          [iA, [oA, LA], [tA, cA]],
          [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            // Google Pixel
          ],
          [iA, [oA, LA], [tA, lA]],
          [
            // Sony
            /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
          ],
          [iA, [oA, kA], [tA, lA]],
          [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
          ],
          [[iA, "Xperia Tablet"], [oA, kA], [tA, cA]],
          [
            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
          ],
          [iA, [oA, Cg], [tA, lA]],
          [
            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
            // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i
            // Kindle Fire HD
          ],
          [iA, [oA, dA], [tA, cA]],
          [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            // Fire Phone
          ],
          [[iA, /(.+)/g, "Fire Phone $1"], [oA, dA], [tA, lA]],
          [
            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i
            // BlackBerry PlayBook
          ],
          [iA, oA, [tA, cA]],
          [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i
            // BlackBerry 10
          ],
          [iA, [oA, wA], [tA, lA]],
          [
            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
          ],
          [iA, [oA, DA], [tA, cA]],
          [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
          ],
          [iA, [oA, DA], [tA, lA]],
          [
            // HTC
            /(nexus 9)/i
            // HTC Nexus 9
          ],
          [iA, [oA, "HTC"], [tA, cA]],
          [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
            // HTC
            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
          ],
          [oA, [iA, /_/g, " "], [tA, lA]],
          [
            // TCL
            /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
          ],
          [iA, [oA, "TCL"], [tA, cA]],
          [
            // itel
            /(itel) ((\w+))/i
          ],
          [[oA, $A], iA, [tA, kg, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
          [
            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
          ],
          [iA, [oA, "Acer"], [tA, cA]],
          [
            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
          ],
          [iA, [oA, "Meizu"], [tA, lA]],
          [
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
          ],
          [iA, [oA, "Ulefone"], [tA, lA]],
          [
            // Energizer
            /; (energy ?\w+)(?: bui|\))/i,
            /; energizer ([\w ]+)(?: bui|\))/i
          ],
          [iA, [oA, "Energizer"], [tA, lA]],
          [
            // Cat
            /; cat (b35);/i,
            /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
          ],
          [iA, [oA, "Cat"], [tA, lA]],
          [
            // Smartfren
            /((?:new )?andromax[\w- ]+)(?: bui|\))/i
          ],
          [iA, [oA, "Smartfren"], [tA, lA]],
          [
            // Nothing
            /droid.+; (a(?:015|06[35]|142p?))/i
          ],
          [iA, [oA, "Nothing"], [tA, lA]],
          [
            // Archos
            /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
            /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
          ],
          [iA, [oA, "Archos"], [tA, cA]],
          [
            /archos ([\w ]+)( b|\))/i,
            /; (ac[3-6]\d\w{2,8})( b|\))/i
          ],
          [iA, [oA, "Archos"], [tA, lA]],
          [
            // MIXED
            /(imo) (tab \w+)/i,
            // IMO
            /(infinix) (x1101b?)/i
            // Infinix XPad
          ],
          [oA, iA, [tA, cA]],
          [
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
            // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
            /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
            // HMD/IMO
            /(hp) ([\w ]+\w)/i,
            // HP iPAQ
            /(microsoft); (lumia[\w ]+)/i,
            // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
            // Lenovo
            /(oppo) ?([\w ]+) bui/i
            // OPPO
          ],
          [oA, iA, [tA, lA]],
          [
            /(kobo)\s(ereader|touch)/i,
            // Kobo
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
            // HP TouchPad
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(nook)[\w ]+build\/(\w+)/i,
            // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,
            // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
            // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,
            // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,
            // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i
            // Vodafone
          ],
          [oA, iA, [tA, cA]],
          [
            /(surface duo)/i
            // Surface Duo
          ],
          [iA, [oA, XA], [tA, cA]],
          [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i
            // Fairphone
          ],
          [iA, [oA, "Fairphone"], [tA, lA]],
          [
            /(u304aa)/i
            // AT&T
          ],
          [iA, [oA, "AT&T"], [tA, lA]],
          [
            /\bsie-(\w*)/i
            // Siemens
          ],
          [iA, [oA, "Siemens"], [tA, lA]],
          [
            /\b(rct\w+) b/i
            // RCA Tablets
          ],
          [iA, [oA, "RCA"], [tA, cA]],
          [
            /\b(venue[\d ]{2,7}) b/i
            // Dell Venue Tablets
          ],
          [iA, [oA, "Dell"], [tA, cA]],
          [
            /\b(q(?:mv|ta)\w+) b/i
            // Verizon Tablet
          ],
          [iA, [oA, "Verizon"], [tA, cA]],
          [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            // Barnes & Noble Tablet
          ],
          [iA, [oA, "Barnes & Noble"], [tA, cA]],
          [
            /\b(tm\d{3}\w+) b/i
          ],
          [iA, [oA, "NuVision"], [tA, cA]],
          [
            /\b(k88) b/i
            // ZTE K Series Tablet
          ],
          [iA, [oA, "ZTE"], [tA, cA]],
          [
            /\b(nx\d{3}j) b/i
            // ZTE Nubia
          ],
          [iA, [oA, "ZTE"], [tA, lA]],
          [
            /\b(gen\d{3}) b.+49h/i
            // Swiss GEN Mobile
          ],
          [iA, [oA, "Swiss"], [tA, lA]],
          [
            /\b(zur\d{3}) b/i
            // Swiss ZUR Tablet
          ],
          [iA, [oA, "Swiss"], [tA, cA]],
          [
            /\b((zeki)?tb.*\b) b/i
            // Zeki Tablets
          ],
          [iA, [oA, "Zeki"], [tA, cA]],
          [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            // Dragon Touch Tablet
          ],
          [[oA, "Dragon Touch"], iA, [tA, cA]],
          [
            /\b(ns-?\w{0,9}) b/i
            // Insignia Tablets
          ],
          [iA, [oA, "Insignia"], [tA, cA]],
          [
            /\b((nxa|next)-?\w{0,9}) b/i
            // NextBook Tablets
          ],
          [iA, [oA, "NextBook"], [tA, cA]],
          [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            // Voice Xtreme Phones
          ],
          [[oA, "Voice"], iA, [tA, lA]],
          [
            /\b(lvtel\-)?(v1[12]) b/i
            // LvTel Phones
          ],
          [[oA, "LvTel"], iA, [tA, lA]],
          [
            /\b(ph-1) /i
            // Essential PH-1
          ],
          [iA, [oA, "Essential"], [tA, lA]],
          [
            /\b(v(100md|700na|7011|917g).*\b) b/i
            // Envizen Tablets
          ],
          [iA, [oA, "Envizen"], [tA, cA]],
          [
            /\b(trio[-\w\. ]+) b/i
            // MachSpeed Tablets
          ],
          [iA, [oA, "MachSpeed"], [tA, cA]],
          [
            /\btu_(1491) b/i
            // Rotor Tablets
          ],
          [iA, [oA, "Rotor"], [tA, cA]],
          [
            /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            // Nvidia Tablets
          ],
          [iA, [oA, vA], [tA, cA]],
          [
            /(sprint) (\w+)/i
            // Sprint Phones
          ],
          [oA, iA, [tA, lA]],
          [
            /(kin\.[onetw]{3})/i
            // Microsoft Kin
          ],
          [[iA, /\./g, " "], [oA, XA], [tA, lA]],
          [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            // Zebra
          ],
          [iA, [oA, RA], [tA, cA]],
          [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
          ],
          [iA, [oA, RA], [tA, lA]],
          [
            ///////////////////
            // SMARTTVS
            ///////////////////
            /smart-tv.+(samsung)/i
            // Samsung
          ],
          [oA, [tA, sA]],
          [
            /hbbtv.+maple;(\d+)/i
          ],
          [[iA, /^/, "SmartTV"], [oA, og], [tA, sA]],
          [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            // LG SmartTV
          ],
          [[oA, zA], [tA, sA]],
          [
            /(apple) ?tv/i
            // Apple TV
          ],
          [oA, [iA, GA + " TV"], [tA, sA]],
          [
            /crkey/i
            // Google Chromecast
          ],
          [[iA, yA + "cast"], [oA, LA], [tA, sA]],
          [
            /droid.+aft(\w+)( bui|\))/i
            // Fire TV
          ],
          [iA, [oA, dA], [tA, sA]],
          [
            /(shield \w+ tv)/i
            // Nvidia Shield TV
          ],
          [iA, [oA, vA], [tA, sA]],
          [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i
            // Sharp
          ],
          [iA, [oA, eg], [tA, sA]],
          [
            /(bravia[\w ]+)( bui|\))/i
            // Sony
          ],
          [iA, [oA, kA], [tA, sA]],
          [
            /(mi(tv|box)-?\w+) bui/i
            // Xiaomi
          ],
          [iA, [oA, YA], [tA, sA]],
          [
            /Hbbtv.*(technisat) (.*);/i
            // TechniSAT
          ],
          [oA, iA, [tA, sA]],
          [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
            // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            // HbbTV devices
          ],
          [[oA, wg], [iA, wg], [tA, sA]],
          [
            // SmartTV from Unidentified Vendors
            /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
          ],
          [iA, [tA, sA]],
          [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          ],
          [[tA, sA]],
          [
            ///////////////////
            // CONSOLES
            ///////////////////
            /(ouya)/i,
            // Ouya
            /(nintendo) ([wids3utch]+)/i
            // Nintendo
          ],
          [oA, iA, [tA, nA]],
          [
            /droid.+; (shield)( bui|\))/i
            // Nvidia Portable
          ],
          [iA, [oA, vA], [tA, nA]],
          [
            /(playstation \w+)/i
            // Playstation
          ],
          [iA, [oA, kA], [tA, nA]],
          [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            // Microsoft Xbox
          ],
          [iA, [oA, XA], [tA, nA]],
          [
            ///////////////////
            // WEARABLES
            ///////////////////
            /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            // Samsung Galaxy Watch
          ],
          [iA, [oA, og], [tA, rA]],
          [
            /((pebble))app/i,
            // Pebble
            /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            // Asus ZenWatch / LG Watch / Pixel Watch
          ],
          [oA, iA, [tA, rA]],
          [
            /(ow(?:19|20)?we?[1-3]{1,3})/i
            // Oppo Watch
          ],
          [iA, [oA, gg], [tA, rA]],
          [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            // Apple Watch
          ],
          [iA, [oA, GA], [tA, rA]],
          [
            /(opwwe\d{3})/i
            // OnePlus Watch
          ],
          [iA, [oA, Cg], [tA, rA]],
          [
            /(moto 360)/i
            // Motorola 360
          ],
          [iA, [oA, fA], [tA, rA]],
          [
            /(smartwatch 3)/i
            // Sony SmartWatch
          ],
          [iA, [oA, kA], [tA, rA]],
          [
            /(g watch r)/i
            // LG G Watch R
          ],
          [iA, [oA, zA], [tA, rA]],
          [
            /droid.+; (wt63?0{2,3})\)/i
          ],
          [iA, [oA, RA], [tA, rA]],
          [
            ///////////////////
            // XR
            ///////////////////
            /droid.+; (glass) \d/i
            // Google Glass
          ],
          [iA, [oA, LA], [tA, rA]],
          [
            /(pico) (4|neo3(?: link|pro)?)/i
            // Pico
          ],
          [oA, iA, [tA, rA]],
          [
            /; (quest( \d| pro)?)/i
            // Oculus Quest
          ],
          [iA, [oA, FA], [tA, rA]],
          [
            ///////////////////
            // EMBEDDED
            ///////////////////
            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            // Tesla
          ],
          [oA, [tA, uA]],
          [
            /(aeobc)\b/i
            // Echo Dot
          ],
          [iA, [oA, dA], [tA, uA]],
          [
            /(homepod).+mac os/i
            // Apple HomePod
          ],
          [iA, [oA, GA], [tA, uA]],
          [
            /windows iot/i
          ],
          [[tA, uA]],
          [
            ////////////////////
            // MIXED (GENERIC)
            ///////////////////
            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            // Android Phones from Unidentified Vendors
          ],
          [iA, [tA, lA]],
          [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            // Android Tablets from Unidentified Vendors
          ],
          [iA, [tA, cA]],
          [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            // Unidentifiable Tablet
          ],
          [[tA, cA]],
          [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            // Unidentifiable Mobile
          ],
          [[tA, lA]],
          [
            /droid .+?; ([\w\. -]+)( bui|\))/i
            // Generic Android Device
          ],
          [iA, [oA, "Generic"]]
        ],
        engine: [
          [
            /windows.+ edge\/([\w\.]+)/i
            // EdgeHTML
          ],
          [EA, [QA, pA + "HTML"]],
          [
            /(arkweb)\/([\w\.]+)/i
            // ArkWeb
          ],
          [QA, EA],
          [
            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            // Blink
          ],
          [EA, [QA, "Blink"]],
          [
            /(presto)\/([\w\.]+)/i,
            // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
            // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
            /ekioh(flow)\/([\w\.]+)/i,
            // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
            // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,
            // iCab
            /\b(libweb)/i
            // LibWeb
          ],
          [QA, EA],
          [
            /ladybird\//i
          ],
          [[QA, "LibWeb"]],
          [
            /rv\:([\w\.]{1,9})\b.+(gecko)/i
            // Gecko
          ],
          [EA, QA]
        ],
        os: [
          [
            // Windows
            /microsoft (windows) (vista|xp)/i
            // Windows (iTunes)
          ],
          [QA, EA],
          [
            /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            // Windows Phone
          ],
          [QA, [EA, kg, ZA]],
          [
            /windows nt 6\.2; (arm)/i,
            // Windows RT
            /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
          ],
          [[EA, kg, ZA], [QA, "Windows"]],
          [
            // iOS/macOS
            /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
            // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
          ],
          [[EA, /_/g, "."], [QA, "iOS"]],
          [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            // Mac OS
          ],
          [[QA, JA], [EA, /_/g, "."]],
          [
            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            // Android-x86/HarmonyOS
          ],
          [EA, QA],
          [
            /(ubuntu) ([\w\.]+) like android/i
            // Ubuntu Touch
          ],
          [[QA, /(.+)/, "$1 Touch"], EA],
          [
            // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
            /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
          ],
          [QA, EA],
          [
            /\(bb(10);/i
            // BlackBerry 10
          ],
          [EA, [QA, wA]],
          [
            /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            // Symbian
          ],
          [EA, [QA, "Symbian"]],
          [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            // Firefox OS
          ],
          [EA, [QA, MA + " OS"]],
          [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            // WebOS
          ],
          [EA, [QA, "webOS"]],
          [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            // watchOS
          ],
          [EA, [QA, "watchOS"]],
          [
            // Google Chromecast
            /crkey\/([\d\.]+)/i
            // Google Chromecast
          ],
          [EA, [QA, yA + "cast"]],
          [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            // Chromium OS
          ],
          [[QA, mA], EA],
          [
            // Smart TVs
            /panasonic;(viera)/i,
            // Panasonic Viera
            /(netrange)mmh/i,
            // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,
            // NetTV
            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,
            // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,
            // Microsoft Xbox (360, One, X, S, Series X, Series S)
            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,
            // Mint
            /(mageia|vectorlinux)[; ]/i,
            // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
            // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
            // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,
            // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
            // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i
            // Haiku
          ],
          [QA, EA],
          [
            /(sunos) ?([\w\.\d]*)/i
            // Solaris
          ],
          [[QA, "Solaris"], EA],
          [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
            // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
            // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i
            // UNIX
          ],
          [QA, EA]
        ]
      }, PA = function(bg, yg) {
        if (typeof bg === CA && (yg = bg, bg = d), !(this instanceof PA))
          return new PA(bg, yg).getResult();
        var hg = typeof g !== IA && g.navigator ? g.navigator : d, tg = bg || (hg && hg.userAgent ? hg.userAgent : H), Eg = hg && hg.userAgentData ? hg.userAgentData : d, cg = yg ? HA(KA, yg) : KA, sg = hg && hg.userAgent == tg;
        return this.getBrowser = function() {
          var ug = {};
          return ug[QA] = d, ug[EA] = d, Dg.call(ug, tg, cg.browser), ug[eA] = rg(ug[EA]), sg && hg && hg.brave && typeof hg.brave.isBrave == gA && (ug[QA] = "Brave"), ug;
        }, this.getCPU = function() {
          var ug = {};
          return ug[aA] = d, Dg.call(ug, tg, cg.cpu), ug;
        }, this.getDevice = function() {
          var ug = {};
          return ug[oA] = d, ug[iA] = d, ug[tA] = d, Dg.call(ug, tg, cg.device), sg && !ug[tA] && Eg && Eg.mobile && (ug[tA] = lA), sg && ug[iA] == "Macintosh" && hg && typeof hg.standalone !== IA && hg.maxTouchPoints && hg.maxTouchPoints > 2 && (ug[iA] = "iPad", ug[tA] = cA), ug;
        }, this.getEngine = function() {
          var ug = {};
          return ug[QA] = d, ug[EA] = d, Dg.call(ug, tg, cg.engine), ug;
        }, this.getOS = function() {
          var ug = {};
          return ug[QA] = d, ug[EA] = d, Dg.call(ug, tg, cg.os), sg && !ug[QA] && Eg && Eg.platform && Eg.platform != "Unknown" && (ug[QA] = Eg.platform.replace(/chrome os/i, mA).replace(/macos/i, JA)), ug;
        }, this.getResult = function() {
          return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
          };
        }, this.getUA = function() {
          return tg;
        }, this.setUA = function(ug) {
          return tg = typeof ug === BA && ug.length > hA ? wg(ug, hA) : ug, this;
        }, this.setUA(tg), this;
      };
      PA.VERSION = k, PA.BROWSER = jA([QA, EA, eA]), PA.CPU = jA([aA]), PA.DEVICE = jA([iA, oA, tA, nA, lA, sA, cA, rA, uA]), PA.ENGINE = PA.OS = jA([QA, EA]), n.exports && (t = n.exports = PA), t.UAParser = PA;
      var ag = typeof g !== IA && (g.jQuery || g.Zepto);
      if (ag && !ag.ua) {
        var Gg = new PA();
        ag.ua = Gg.getResult(), ag.ua.get = function() {
          return Gg.getUA();
        }, ag.ua.set = function(bg) {
          Gg.setUA(bg);
          var yg = Gg.getResult();
          for (var hg in yg)
            ag.ua[hg] = yg[hg];
        };
      }
    })(typeof window == "object" ? window : uaParser);
  })(uaParser$1, uaParser$1.exports)), uaParser$1.exports;
}
var uaParserExports = requireUaParser();
const UAParser = /* @__PURE__ */ getDefaultExportFromCjs$2(uaParserExports), parser = new UAParser();
function isMobile() {
  return parser.getResult().device.type === "mobile";
}
function useSelectCommon(n) {
  const {
    options: t,
    isMulti: g,
    acceptNewOptions: d,
    placeholderInput: k
  } = n, H = useMemo$1(() => t.map((QA, tA) => ({
    label: QA,
    value: QA,
    // We are using an id because if multiple options are equal,
    // we have observed weird UI glitches
    id: `${QA}_${tA}`
  })), [t]), {
    placeholder: AA,
    shouldDisable: gA
  } = useMemo$1(() => getSelectPlaceholder(k, t, d, g), [d, g, t, k]), IA = t.length > 10, CA = isMobile() && !IA && !d ? "readonly" : null, BA = useMemo$1(() => (QA) => isNullOrUndefined$1(QA) ? [] : [{
    label: QA,
    value: QA
  }], []), eA = useMemo$1(() => (QA) => QA.map((tA) => ({
    label: tA,
    value: tA
  })), []), iA = useMemo$1(() => (QA) => (tA, oA) => {
    const EA = Array.isArray(QA) ? (
      // We need to manually filter for previously selected options here
      tA.filter((aA) => !QA.includes(aA.value))
    ) : tA;
    return fuzzyFilterSelectOptions(EA, oA);
  }, []);
  return {
    selectOptions: H,
    placeholder: AA,
    disabled: gA,
    inputReadOnly: CA,
    valueToUiSingle: BA,
    valuesToUiMulti: eA,
    createFilterOptions: iA
  };
}
const Selectbox = ({
  disabled: n,
  value: t,
  onChange: g,
  options: d,
  label: k,
  labelVisibility: H,
  help: AA,
  placeholder: gA,
  clearable: IA,
  acceptNewOptions: CA
}) => {
  const BA = useEmotionTheme(), eA = useContext(IsSidebarContext), [iA, QA] = useState(t), tA = useRef(iA);
  useEffect(() => {
    QA(t);
  }, [t]);
  const oA = useCallback((DA) => {
    if (DA.type === "remove") {
      tA.current = DA.option?.value, QA(null);
      return;
    }
    if (tA.current = null, DA.type === "clear") {
      QA(null), g(null);
      return;
    }
    const [wA] = DA.value;
    QA(wA.value), g(wA.value);
  }, [g]), EA = useCallback(() => {
    tA.current !== null && QA(tA.current);
  }, []), aA = d, {
    placeholder: nA,
    disabled: lA,
    selectOptions: cA,
    inputReadOnly: sA,
    valueToUiSingle: rA,
    createFilterOptions: uA
  } = useSelectCommon({
    options: aA,
    isMulti: !1,
    acceptNewOptions: CA,
    placeholderInput: gA
  }), hA = n || lA, dA = useMemo$1(() => uA(), [uA]), GA = rA(iA);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "stSelectbox", "data-testid": "stSelectbox", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(WidgetLabel, { label: k, labelVisibility: H, disabled: hA, children: AA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledWidgetLabelHelp, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { content: AA, placement: Placement.TOP_RIGHT }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { creatable: CA, disabled: hA, labelKey: "label", "aria-label": k || "", onChange: oA, onBlur: EA, options: cA, filterOptions: dA, clearable: IA || !1, escapeClearsValue: IA || !1, value: GA, valueKey: "value", placeholder: nA, ignoreCase: !1, overrides: {
      Root: {
        style: () => ({
          lineHeight: BA.lineHeights.inputWidget,
          fontWeight: BA.fontWeights.normal
        })
      },
      Dropdown: {
        component: VirtualDropdown
      },
      ClearIcon: {
        props: {
          overrides: {
            Svg: {
              style: {
                color: BA.colors.grayTextColor,
                // Setting this width and height makes the clear-icon align with dropdown arrows
                padding: BA.spacing.threeXS,
                height: BA.sizes.clearIconSize,
                width: BA.sizes.clearIconSize,
                ":hover": {
                  fill: BA.colors.bodyText
                }
              }
            }
          }
        }
      },
      ControlContainer: {
        style: () => ({
          height: BA.sizes.minElementHeight,
          // Baseweb requires long-hand props, short-hand leads to weird bugs & warnings.
          borderLeftWidth: BA.sizes.borderWidth,
          borderRightWidth: BA.sizes.borderWidth,
          borderTopWidth: BA.sizes.borderWidth,
          borderBottomWidth: BA.sizes.borderWidth
        })
      },
      IconsContainer: {
        style: () => ({
          paddingRight: BA.spacing.sm
        })
      },
      Placeholder: {
        style: () => ({
          color: hA ? BA.colors.fadedText40 : BA.colors.fadedText60
        })
      },
      ValueContainer: {
        style: () => ({
          // Baseweb requires long-hand props, short-hand leads to weird bugs & warnings.
          paddingRight: BA.spacing.sm,
          paddingLeft: BA.spacing.md,
          paddingBottom: BA.spacing.sm,
          paddingTop: BA.spacing.sm
        })
      },
      Input: {
        props: {
          readOnly: sA
        },
        style: () => ({
          lineHeight: BA.lineHeights.inputWidget
        })
      },
      // Nudge the dropdown menu by 1px so the focus state doesn't get cut off
      Popover: {
        props: {
          ignoreBoundary: eA,
          overrides: {
            Body: {
              style: () => ({
                marginTop: BA.spacing.px
              })
            }
          }
        }
      },
      SingleValue: {
        style: () => ({
          // remove margin from select value so that there is no jumpb, e.g. when pressing backspace on a selected option and removing a character.
          marginLeft: BA.spacing.none
        })
      },
      SelectArrow: {
        component: ChevronDown$1,
        props: {
          style: {
            cursor: "pointer"
          },
          overrides: {
            Svg: {
              style: () => ({
                width: BA.iconSizes.xl,
                height: BA.iconSizes.xl
              })
            }
          }
        }
      }
    } })
  ] });
}, UISelectbox = memo$1(Selectbox);
class CircularBuffer {
  /**
   * Creates an instance of CircularBuffer.
   * @param {number} size - The size of the buffer.
   */
  constructor(t) {
    this._buffer = new Array(t), this._size = t, this._index = 0, this._wrappedCount = 0;
  }
  /**
   * Adds a value to the buffer.
   * @param {T} value - The value to add to the buffer.
   */
  push(t) {
    this._buffer[this._index] = t, this._index = (this._index + 1) % this._size, this._index === 0 && (this._wrappedCount = this._wrappedCount + 1);
  }
  /**
   * Gets the current state of the buffer.
   * @returns {readonly T[]} The buffer array.
   */
  get buffer() {
    return this._buffer;
  }
  /**
   * Gets the total number of entries written to the buffer.
   * @returns {number} The total number of written entries.
   */
  get totalWrittenEntries() {
    return this._wrappedCount * this._size + this._index;
  }
}
const handleRender = (n, t, g, d, k, H) => {
  window.__streamlit_profiles__ = window.__streamlit_profiles__ || {}, window.__streamlit_profiles__[n] = window.__streamlit_profiles__[n] || // Use a CircularBuffer to limit the number of profiles stored in memory to
  // prevent any potential memory leaks.
  // 1000 is an arbitrary number that should be enough to store more than
  // enough entries for debugging purposes without consuming too much memory.
  new CircularBuffer(1e3), window.__streamlit_profiles__[n].push({
    phase: t,
    actualDuration: g,
    baseDuration: d,
    startTime: k,
    commitTime: H
  });
}, Profiler = ({
  id: n,
  children: t
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler$1, { id: n, onRender: handleRender, children: t }), useWindowDimensions = () => {
  const n = useEmotionTheme(), [t, g] = useState({
    fullWidth: 0,
    fullHeight: 0,
    innerWidth: 0,
    innerHeight: 0
  }), d = useCallback(() => {
    const H = convertRemToPx(n.spacing.md), AA = convertRemToPx(n.sizes.fullScreenHeaderHeight), {
      innerWidth: gA,
      innerHeight: IA
    } = window;
    return {
      fullWidth: gA - H * 2,
      // Left and right
      fullHeight: IA - (H + AA),
      // Bottom and Top
      innerWidth: gA,
      innerHeight: IA
    };
  }, [n.sizes.fullScreenHeaderHeight, n.spacing.md]), k = useCallback(() => {
    g(d());
  }, [d]);
  return useEffect(() => (window.addEventListener("resize", k), () => {
    window.removeEventListener("resize", k);
  }), [k]), useLayoutEffect$1(() => {
    k();
  }, [k]), t;
}, WindowDimensionsProvider = ({
  children: n
}) => {
  const t = useWindowDimensions();
  if (useContext(WindowDimensionsContext))
    throw new Error("WindowDimensionsProvider should only be used once per app. If you need to read window dimensions, utilize `useWindowDimensionsContext()` instead.");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(WindowDimensionsContext.Provider, { value: t, children: n });
}, byteToHex = [];
for (let n = 0; n < 256; ++n)
  byteToHex.push((n + 256).toString(16).slice(1));
function unsafeStringify(n, t = 0) {
  return (byteToHex[n[t + 0]] + byteToHex[n[t + 1]] + byteToHex[n[t + 2]] + byteToHex[n[t + 3]] + "-" + byteToHex[n[t + 4]] + byteToHex[n[t + 5]] + "-" + byteToHex[n[t + 6]] + byteToHex[n[t + 7]] + "-" + byteToHex[n[t + 8]] + byteToHex[n[t + 9]] + "-" + byteToHex[n[t + 10]] + byteToHex[n[t + 11]] + byteToHex[n[t + 12]] + byteToHex[n[t + 13]] + byteToHex[n[t + 14]] + byteToHex[n[t + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = { randomUUID };
function _v4(n, t, g) {
  n = n || {};
  const d = n.random ?? n.rng?.() ?? rng();
  if (d.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return d[6] = d[6] & 15 | 64, d[8] = d[8] & 63 | 128, unsafeStringify(d);
}
function v4(n, t, g) {
  return native.randomUUID && !n ? native.randomUUID() : _v4(n);
}
var __typeError = (n) => {
  throw TypeError(n);
}, __accessCheck = (n, t, g) => t.has(n) || __typeError("Cannot " + g), __privateGet = (n, t, g) => (__accessCheck(n, t, "read from private field"), g ? g.call(n) : t.get(n)), __privateAdd = (n, t, g) => t.has(n) ? __typeError("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(n) : t.set(n, g), __privateSet = (n, t, g, d) => (__accessCheck(n, t, "write to private field"), t.set(n, g), g), __privateMethod = (n, t, g) => (__accessCheck(n, t, "access private method"), g), MAX_CHUNK_SIZE = 65536;
function* chunk(n) {
  if (n.byteLength <= MAX_CHUNK_SIZE) {
    yield n;
    return;
  }
  let t = 0;
  for (; t < n.byteLength; ) {
    const g = Math.min(n.byteLength - t, MAX_CHUNK_SIZE), d = n.buffer.slice(t, t + g);
    t += d.byteLength, yield new Uint8Array(d);
  }
}
var alphabet = "abcdefghijklmnopqrstuvwxyz0123456789";
function createBoundary() {
  let n = 16, t = "";
  for (; n--; )
    t += alphabet[Math.random() * alphabet.length << 0];
  return t;
}
var escapeName = (n) => String(n).replace(/\r/g, "%0D").replace(/\n/g, "%0A").replace(/"/g, "%22"), isFunction$2 = (n) => typeof n == "function", isReadableStreamFallback = (n) => !!n && typeof n == "object" && !Array.isArray(n) && isFunction$2(n.getReader), isAsyncIterable = (n) => isFunction$2(n[Symbol.asyncIterator]);
async function* readStream$1(n) {
  const t = n.getReader();
  for (; ; ) {
    const { done: g, value: d } = await t.read();
    if (g)
      break;
    yield d;
  }
}
async function* chunkStream(n) {
  for await (const t of n)
    yield* chunk(t);
}
var getStreamIterator = (n) => {
  if (isAsyncIterable(n))
    return chunkStream(n);
  if (isReadableStreamFallback(n))
    return chunkStream(readStream$1(n));
  throw new TypeError(
    "Unsupported data source: Expected either ReadableStream or async iterable."
  );
}, isFile$1 = (n) => !!(n && typeof n == "object" && isFunction$2(n.constructor) && n[Symbol.toStringTag] === "File" && isFunction$2(n.stream) && n.name != null), isFormData$1 = (n) => !!(n && isFunction$2(n.constructor) && n[Symbol.toStringTag] === "FormData" && isFunction$2(n.append) && isFunction$2(n.getAll) && isFunction$2(n.entries) && isFunction$2(n[Symbol.iterator])), getType = (n) => Object.prototype.toString.call(n).slice(8, -1).toLowerCase();
function isPlainObject$1(n) {
  if (getType(n) !== "object")
    return !1;
  const t = Object.getPrototypeOf(n);
  return t == null ? !0 : t.constructor?.toString?.() === Object.toString();
}
var normalizeValue$1 = (n) => String(n).replace(/\r|\n/g, (t, g, d) => t === "\r" && d[g + 1] !== `
` || t === `
` && d[g - 1] !== "\r" ? `\r
` : t);
function getProperty(n, t) {
  if (typeof t == "string") {
    for (const [g, d] of Object.entries(n))
      if (t.toLowerCase() === g.toLowerCase())
        return d;
  }
}
var proxyHeaders = (n) => new Proxy(
  n,
  {
    get: (t, g) => getProperty(t, g),
    has: (t, g) => getProperty(t, g) !== void 0
  }
), defaultOptions = {
  enableAdditionalHeaders: !1
}, readonlyProp = { writable: !1, configurable: !1 }, _CRLF, _CRLF_BYTES, _CRLF_BYTES_LENGTH, _DASHES, _encoder, _footer, _form, _options, _FormDataEncoder_instances, getFieldHeader_fn, getContentLength_fn, FormDataEncoder = class {
  constructor(n, t, g) {
    if (__privateAdd(this, _FormDataEncoder_instances), __privateAdd(this, _CRLF, `\r
`), __privateAdd(this, _CRLF_BYTES), __privateAdd(this, _CRLF_BYTES_LENGTH), __privateAdd(this, _DASHES, "-".repeat(2)), __privateAdd(this, _encoder, new TextEncoder()), __privateAdd(this, _footer), __privateAdd(this, _form), __privateAdd(this, _options), !isFormData$1(n))
      throw new TypeError("Expected first argument to be a FormData instance.");
    let d;
    if (isPlainObject$1(t) ? g = t : d = t, d || (d = `form-data-encoder-${createBoundary()}`), typeof d != "string")
      throw new TypeError("Expected boundary argument to be a string.");
    if (g && !isPlainObject$1(g))
      throw new TypeError("Expected options argument to be an object.");
    __privateSet(this, _form, Array.from(n.entries())), __privateSet(this, _options, { ...defaultOptions, ...g }), __privateSet(this, _CRLF_BYTES, __privateGet(this, _encoder).encode(__privateGet(this, _CRLF))), __privateSet(this, _CRLF_BYTES_LENGTH, __privateGet(this, _CRLF_BYTES).byteLength), this.boundary = d, this.contentType = `multipart/form-data; boundary=${this.boundary}`, __privateSet(this, _footer, __privateGet(this, _encoder).encode(
      `${__privateGet(this, _DASHES)}${this.boundary}${__privateGet(this, _DASHES)}${__privateGet(this, _CRLF).repeat(2)}`
    ));
    const k = {
      "Content-Type": this.contentType
    }, H = __privateMethod(this, _FormDataEncoder_instances, getContentLength_fn).call(this);
    H && (this.contentLength = H, k["Content-Length"] = H), this.headers = proxyHeaders(Object.freeze(k)), Object.defineProperties(this, {
      boundary: readonlyProp,
      contentType: readonlyProp,
      contentLength: readonlyProp,
      headers: readonlyProp
    });
  }
  /**
   * Creates an iterator allowing to go through form-data parts (with metadata).
   * This method **will not** read the files and **will not** split values big into smaller chunks.
   *
   * Using this method, you can convert form-data content into Blob:
   *
   * @example
   *
   * ```ts
   * import {Readable} from "stream"
   *
   * import {FormDataEncoder} from "form-data-encoder"
   *
   * import {FormData} from "formdata-polyfill/esm-min.js"
   * import {fileFrom} from "fetch-blob/form.js"
   * import {File} from "fetch-blob/file.js"
   * import {Blob} from "fetch-blob"
   *
   * import fetch from "node-fetch"
   *
   * const form = new FormData()
   *
   * form.set("field", "Just a random string")
   * form.set("file", new File(["Using files is class amazing"]))
   * form.set("fileFromPath", await fileFrom("path/to/a/file.txt"))
   *
   * const encoder = new FormDataEncoder(form)
   *
   * const options = {
   *   method: "post",
   *   body: new Blob(encoder, {type: encoder.contentType})
   * }
   *
   * const response = await fetch("https://httpbin.org/post", options)
   *
   * console.log(await response.json())
   * ```
   */
  *values() {
    for (const [n, t] of __privateGet(this, _form)) {
      const g = isFile$1(t) ? t : __privateGet(this, _encoder).encode(normalizeValue$1(t));
      yield __privateMethod(this, _FormDataEncoder_instances, getFieldHeader_fn).call(this, n, g), yield g, yield __privateGet(this, _CRLF_BYTES);
    }
    yield __privateGet(this, _footer);
  }
  /**
   * Creates an async iterator allowing to perform the encoding by portions.
   * This method reads through files and splits big values into smaller pieces (65536 bytes per each).
   *
   * @example
   *
   * ```ts
   * import {Readable} from "stream"
   *
   * import {FormData, File, fileFromPath} from "formdata-node"
   * import {FormDataEncoder} from "form-data-encoder"
   *
   * import fetch from "node-fetch"
   *
   * const form = new FormData()
   *
   * form.set("field", "Just a random string")
   * form.set("file", new File(["Using files is class amazing"], "file.txt"))
   * form.set("fileFromPath", await fileFromPath("path/to/a/file.txt"))
   *
   * const encoder = new FormDataEncoder(form)
   *
   * const options = {
   *   method: "post",
   *   headers: encoder.headers,
   *   body: Readable.from(encoder.encode()) // or Readable.from(encoder)
   * }
   *
   * const response = await fetch("https://httpbin.org/post", options)
   *
   * console.log(await response.json())
   * ```
   */
  async *encode() {
    for (const n of this.values())
      isFile$1(n) ? yield* getStreamIterator(n.stream()) : yield* chunk(n);
  }
  /**
   * Creates an iterator allowing to read through the encoder data using for...of loops
   */
  [Symbol.iterator]() {
    return this.values();
  }
  /**
   * Creates an **async** iterator allowing to read through the encoder data using for-await...of loops
   */
  [Symbol.asyncIterator]() {
    return this.encode();
  }
};
_CRLF = /* @__PURE__ */ new WeakMap();
_CRLF_BYTES = /* @__PURE__ */ new WeakMap();
_CRLF_BYTES_LENGTH = /* @__PURE__ */ new WeakMap();
_DASHES = /* @__PURE__ */ new WeakMap();
_encoder = /* @__PURE__ */ new WeakMap();
_footer = /* @__PURE__ */ new WeakMap();
_form = /* @__PURE__ */ new WeakMap();
_options = /* @__PURE__ */ new WeakMap();
_FormDataEncoder_instances = /* @__PURE__ */ new WeakSet();
getFieldHeader_fn = function(n, t) {
  let g = "";
  if (g += `${__privateGet(this, _DASHES)}${this.boundary}${__privateGet(this, _CRLF)}`, g += `Content-Disposition: form-data; name="${escapeName(n)}"`, isFile$1(t) && (g += `; filename="${escapeName(t.name)}"${__privateGet(this, _CRLF)}`, g += `Content-Type: ${t.type || "application/octet-stream"}`), __privateGet(this, _options).enableAdditionalHeaders === !0) {
    const d = isFile$1(t) ? t.size : t.byteLength;
    d != null && !isNaN(d) && (g += `${__privateGet(this, _CRLF)}Content-Length: ${d}`);
  }
  return __privateGet(this, _encoder).encode(`${g}${__privateGet(this, _CRLF).repeat(2)}`);
};
getContentLength_fn = function() {
  let n = 0;
  for (const [t, g] of __privateGet(this, _form)) {
    const d = isFile$1(g) ? g : __privateGet(this, _encoder).encode(normalizeValue$1(g)), k = isFile$1(d) ? d.size : d.byteLength;
    if (k == null || isNaN(k))
      return;
    n += __privateMethod(this, _FormDataEncoder_instances, getFieldHeader_fn).call(this, t, d).byteLength, n += k, n += __privateGet(this, _CRLF_BYTES_LENGTH);
  }
  return String(n + __privateGet(this, _footer).byteLength);
};
const LOG$7 = loglevelExports$1.getLogger("FileUploadClient");
class FileUploadClient {
  constructor(t) {
    this.formsWithPendingRequests = /* @__PURE__ */ new Map(), this.pendingFileURLsRequests = /* @__PURE__ */ new Map(), this.sessionInfo = t.sessionInfo, this.endpoints = t.endpoints, this.pendingFormUploadsChanged = t.formsWithPendingRequestsChanged, this.requestFileURLs = t.requestFileURLs;
  }
  setKernel(t) {
    this.kernel = t;
  }
  /**
   * Upload a file to the given URL. It will be associated with this browser's
   * sessionID.
   *
   * @param widget: the FileUploader widget that's doing the upload.
   * @param fileUploadUrl: the URL to upload the file to.
   * @param file: the files to upload.
   * @param onUploadProgress: an optional function that will be called repeatedly with progress events during the upload.
   * @param signal: an optional AbortSignal that can be used to cancel the in-progress upload.
   *
   * @return a Promise<void> that resolves with a void promise when the upload is complete.
   */
  async uploadFile(t, g, d, k, H) {
    this.offsetPendingRequestCount(t.formId, 1);
    const AA = new FormData();
    AA.append(d.name, d);
    const gA = new FormDataEncoder(AA);
    return new Blob(gA, {
      type: gA.contentType
    }).arrayBuffer().then((CA) => {
      if (this.kernel == null)
        throw new Error("Kernel not ready");
      return this.kernel.sendHttpRequest({
        method: "PUT",
        path: g,
        body: CA,
        headers: {
          ...gA.headers
        }
      }).then((BA) => {
        if (Math.floor(BA.statusCode / 100) !== 2)
          throw new Error(`Unexpected status code ${BA.statusCode} when uploading file.`);
      }).finally(() => this.offsetPendingRequestCount(t.formId, -1));
    });
  }
  /**
   * Request that the file at the given URL is deleted.
   * @param fileUrl: the URL of the file to delete.
   */
  deleteFile(t) {
    if (this.kernel == null)
      throw new Error("Kernel not ready");
    return this.kernel.sendHttpRequest({
      method: "DELETE",
      path: t,
      body: "",
      headers: {}
    }).then((g) => {
      if (Math.floor(g.statusCode / 100) !== 2)
        throw new Error(`Unexpected status code ${g.statusCode} when uploading file.`);
    });
  }
  /**
   * Request that the app fetch URLs to upload/delete/get the given files. Once
   * this is done, the app should call this class' onFileURLsResponse to
   * signify completion.
   *
   * @param files: An array of files.
   *
   * @return a Promise<FileURLsResponse.IFileURLs[]> resolving to a list of
   * URLs for uploading and deleting the given files.
   */
  fetchFileURLs(t) {
    if (!this.requestFileURLs)
      return Promise.resolve([]);
    const g = Promise.withResolvers(), d = v4();
    return this.pendingFileURLsRequests.set(d, g), this.requestFileURLs(d, t), g.promise;
  }
  /**
   * Callback to be called by the app once the file URLs corresponding to a
   * call to this.requestFileURLs has been received.
   *
   * @param resp: the FileURLsResponse corresponding to a call to
   * this.requestFileURLs.
   */
  onFileURLsResponse(t) {
    const g = t.responseId, d = this.pendingFileURLsRequests.get(g);
    d ? (t.errorMsg ? d.reject(t.errorMsg) : d.resolve(t.fileUrls || []), this.pendingFileURLsRequests.delete(g)) : LOG$7.warn("fileURLsResponse received for nonexistent request, ignoring.");
  }
  getFormIdSet() {
    return new Set(this.formsWithPendingRequests.keys());
  }
  offsetPendingRequestCount(t, g) {
    if (g === 0 || !isValidFormId(t))
      return;
    const d = this.formsWithPendingRequests.get(t) ?? 0, k = d + g;
    if (k < 0)
      throw new Error(`Can't offset pendingRequestCount below 0 (formId=${t}, curCount=${d}, offset=${g})`);
    const H = this.getFormIdSet();
    k === 0 ? this.formsWithPendingRequests.delete(t) : this.formsWithPendingRequests.set(t, k);
    const AA = this.getFormIdSet();
    isEqual$1(AA, H) || this.pendingFormUploadsChanged(AA);
  }
}
const arrayComparator = (n, t) => n.length !== t.length ? !1 : n.every((g, d) => Object.is(g, t[d])), useExecuteWhenChanged = (n, t, g = arrayComparator) => {
  const [d, k] = useState(t);
  g(d, t) || (k(t), n());
}, HOST_COMM_VERSION = 1;
class HostCommunicationManager {
  constructor(t) {
    this.openHostCommunication = () => {
      window.addEventListener("message", this.receiveHostMessage), this.sendMessageToHost({
        type: "GUEST_READY",
        streamlitExecutionStartedAt: this.props.streamlitExecutionStartedAt,
        guestReadyAt: Date.now()
      });
    }, this.closeHostCommunication = () => {
      window.removeEventListener("message", this.receiveHostMessage);
    }, this.resetAuthToken = () => {
      this.deferredAuthToken = Promise.withResolvers();
    }, this.claimAuthToken = () => this.deferredAuthToken.promise, this.setAllowedOrigins = ({
      allowedOrigins: g,
      useExternalAuthToken: d
    }) => {
      d || this.deferredAuthToken.resolve(void 0), g?.length && (this.allowedOrigins = g, this.openHostCommunication());
    }, this.sendMessageToSameOriginHost = (g) => {
      window.parent.postMessage({
        stCommVersion: HOST_COMM_VERSION,
        ...g
      }, window.location.origin);
    }, this.sendMessageToHost = (g) => {
      window.parent.postMessage({
        stCommVersion: HOST_COMM_VERSION,
        ...g
      }, "*");
    }, this.receiveHostMessage = (g) => {
      const d = g.data;
      if (!(d.stCommVersion !== HOST_COMM_VERSION || !this.allowedOrigins.find((k) => isValidOrigin(k, g.origin)))) {
        if (d.type === "CLOSE_MODAL" && this.props.closeModal(), d.type === "STOP_SCRIPT" && this.props.stopScript(), d.type === "RERUN_SCRIPT" && this.props.rerunScript(), d.type === "CLEAR_CACHE" && this.props.clearCache(), d.type === "REQUEST_PAGE_CHANGE" && this.props.pageChanged(d.pageScriptHash), d.type === "SEND_APP_HEARTBEAT" && this.props.sendAppHeartbeat(), d.type === "SET_INPUTS_DISABLED" && this.props.setInputsDisabled(d.disabled), d.type === "SET_AUTH_TOKEN" && this.deferredAuthToken.resolve(d.authToken), d.type === "SET_FILE_UPLOAD_CLIENT_CONFIG") {
          const {
            prefix: k,
            headers: H
          } = d;
          this.props.fileUploadClientConfigChanged({
            prefix: k,
            headers: H
          });
        }
        d.type === "SET_IS_OWNER" && this.props.isOwnerChanged(d.isOwner), d.type === "SET_MENU_ITEMS" && this.props.hostMenuItemsChanged(d.items), d.type === "SET_METADATA" && this.props.deployedAppMetadataChanged(d.metadata), d.type === "SET_PAGE_LINK_BASE_URL" && this.props.pageLinkBaseUrlChanged(d.pageLinkBaseUrl), d.type === "SET_SIDEBAR_CHEVRON_DOWNSHIFT" && this.props.sidebarChevronDownshiftChanged(d.sidebarChevronDownshift), d.type === "SET_SIDEBAR_NAV_VISIBILITY" && this.props.hostHideSidebarNavChanged(d.hidden), d.type === "SET_TOOLBAR_ITEMS" && this.props.hostToolbarItemsChanged(d.items), d.type === "UPDATE_FROM_QUERY_PARAMS" && (this.props.queryParamsChanged(d.queryParams), this.props.sendRerunBackMsg()), d.type === "UPDATE_HASH" && (window.location.hash = d.hash), d.type === "SET_CUSTOM_THEME_CONFIG" && this.props.themeChanged(d.themeName, d.themeInfo), d.type === "RESTART_WEBSOCKET_CONNECTION" && this.props.restartWebsocketConnection(), d.type === "TERMINATE_WEBSOCKET_CONNECTION" && this.props.terminateWebsocketConnection();
      }
    }, this.props = t, this.allowedOrigins = [], this.deferredAuthToken = Promise.withResolvers();
  }
}
class SessionInfo {
  /** Return the current SessionInfo props. Throw an error if the props are undefined. */
  get current() {
    if (!this._current)
      throw new Error("Tried to use SessionInfo before it was initialized");
    return this._current;
  }
  /** Return the previous SessionInfo props. They may be undefined! */
  get last() {
    return this._last;
  }
  /**
   * Initialize `SessionInfo.current` with the given props and copy its
   * previous props to `SessionInfo.last`.
   */
  setCurrent(t) {
    this._last = notNullOrUndefined(this._current) ? {
      ...this._current
    } : void 0, this._current = notNullOrUndefined(t) ? {
      ...t
    } : void 0;
  }
  /** Marks `SessionInfo.current` as not connected and copy its previous props to `SessionInfo.last`. */
  disconnect() {
    this._current && this.setCurrent({
      ...this._current,
      isConnected: !1
    });
  }
  /** True if `SessionInfo.current` exists. */
  get isSet() {
    return notNullOrUndefined(this._current);
  }
  /** True if `SessionInfo.current` refers to a "streamlit hello" session. */
  get isHello() {
    return notNullOrUndefined(this._current) && this._current.isHello;
  }
  /** Create SessionInfo Props from the relevant bits of an initialize message. */
  static propsFromNewSessionMessage(t) {
    const g = t.initialize, d = t.config, k = g.userInfo, H = g.environmentInfo;
    return {
      appId: hashString(k.installationIdV3 + t.mainScriptPath),
      sessionId: g.sessionId,
      streamlitVersion: H.streamlitVersion,
      pythonVersion: H.pythonVersion,
      serverOS: H.serverOs,
      hasDisplay: H.hasDisplay,
      installationId: k.installationId,
      installationIdV3: k.installationIdV3,
      installationIdV4: k.installationIdV4,
      maxCachedMessageAge: d.maxCachedMessageAge,
      isHello: g.isHello,
      // We assume we are always connected because the message came directly from the server.
      isConnected: !0
    };
  }
}
const nonce = document.currentScript?.nonce || "", cache$2 = createCache({
  // The key field is required but only matters if there's more than one
  // emotion cache in use. This will probably never be true for us, so we just
  // set it arbitrarily.
  key: "st-emotion-cache",
  ...nonce && {
    nonce
  }
});
function RootStyleProvider(n) {
  const {
    children: t,
    theme: g
  } = n;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseProvider,
    {
      theme: g.basewebTheme,
      zIndex: g.emotion.zIndices.popup,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CacheProvider, { value: cache$2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider$2, { theme: g.emotion, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Global, { styles: globalStyles }),
        t
      ] }) })
    }
  );
}
var src = { exports: {} }, indexLight = { exports: {} }, types = {}, util = { exports: {} }, codegen_1, hasRequiredCodegen;
function requireCodegen() {
  if (hasRequiredCodegen) return codegen_1;
  hasRequiredCodegen = 1, codegen_1 = n;
  function n(t, g) {
    typeof t == "string" && (g = t, t = void 0);
    var d = [];
    function k(AA) {
      if (typeof AA != "string") {
        var gA = H();
        if (n.verbose && console.log("codegen: " + gA), gA = "return " + gA, AA) {
          for (var IA = Object.keys(AA), CA = new Array(IA.length + 1), BA = new Array(IA.length), eA = 0; eA < IA.length; )
            CA[eA] = IA[eA], BA[eA] = AA[IA[eA++]];
          return CA[eA] = gA, Function.apply(null, CA).apply(null, BA);
        }
        return Function(gA)();
      }
      for (var iA = new Array(arguments.length - 1), QA = 0; QA < iA.length; )
        iA[QA] = arguments[++QA];
      if (QA = 0, AA = AA.replace(/%([%dfijs])/g, function(oA, EA) {
        var aA = iA[QA++];
        switch (EA) {
          case "d":
          case "f":
            return String(Number(aA));
          case "i":
            return String(Math.floor(aA));
          case "j":
            return JSON.stringify(aA);
          case "s":
            return String(aA);
        }
        return "%";
      }), QA !== iA.length)
        throw Error("parameter count mismatch");
      return d.push(AA), k;
    }
    function H(AA) {
      return "function " + (AA || g || "") + "(" + (t && t.join(",") || "") + `){
  ` + d.join(`
  `) + `
}`;
    }
    return k.toString = H, k;
  }
  return n.verbose = !1, codegen_1;
}
var fetch_1, hasRequiredFetch;
function requireFetch() {
  if (hasRequiredFetch) return fetch_1;
  hasRequiredFetch = 1, fetch_1 = d;
  var n = requireAspromise$1(), t = requireInquire$1(), g = t("fs");
  function d(k, H, AA) {
    return typeof H == "function" ? (AA = H, H = {}) : H || (H = {}), AA ? !H.xhr && g && g.readFile ? g.readFile(k, function(IA, CA) {
      return IA && typeof XMLHttpRequest < "u" ? d.xhr(k, H, AA) : IA ? AA(IA) : AA(null, H.binary ? CA : CA.toString("utf8"));
    }) : d.xhr(k, H, AA) : n(d, this, k, H);
  }
  return d.xhr = function(H, AA, gA) {
    var IA = new XMLHttpRequest();
    IA.onreadystatechange = function() {
      if (IA.readyState === 4) {
        if (IA.status !== 0 && IA.status !== 200)
          return gA(Error("status " + IA.status));
        if (AA.binary) {
          var BA = IA.response;
          if (!BA) {
            BA = [];
            for (var eA = 0; eA < IA.responseText.length; ++eA)
              BA.push(IA.responseText.charCodeAt(eA) & 255);
          }
          return gA(null, typeof Uint8Array < "u" ? new Uint8Array(BA) : BA);
        }
        return gA(null, IA.responseText);
      }
    }, AA.binary && ("overrideMimeType" in IA && IA.overrideMimeType("text/plain; charset=x-user-defined"), IA.responseType = "arraybuffer"), IA.open("GET", H), IA.send();
  }, fetch_1;
}
var path = {}, hasRequiredPath;
function requirePath() {
  return hasRequiredPath || (hasRequiredPath = 1, (function(n) {
    var t = n, g = (
      /**
       * Tests if the specified path is absolute.
       * @param {string} path Path to test
       * @returns {boolean} `true` if path is absolute
       */
      t.isAbsolute = function(H) {
        return /^(?:\/|\w+:)/.test(H);
      }
    ), d = (
      /**
       * Normalizes the specified path.
       * @param {string} path Path to normalize
       * @returns {string} Normalized path
       */
      t.normalize = function(H) {
        H = H.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
        var AA = H.split("/"), gA = g(H), IA = "";
        gA && (IA = AA.shift() + "/");
        for (var CA = 0; CA < AA.length; )
          AA[CA] === ".." ? CA > 0 && AA[CA - 1] !== ".." ? AA.splice(--CA, 2) : gA ? AA.splice(CA, 1) : ++CA : AA[CA] === "." ? AA.splice(CA, 1) : ++CA;
        return IA + AA.join("/");
      }
    );
    t.resolve = function(H, AA, gA) {
      return gA || (AA = d(AA)), g(AA) ? AA : (gA || (H = d(H)), (H = H.replace(/(?:\/|^)[^/]+$/, "")).length ? d(H + "/" + AA) : AA);
    };
  })(path)), path;
}
var namespace, hasRequiredNamespace;
function requireNamespace() {
  if (hasRequiredNamespace) return namespace;
  hasRequiredNamespace = 1, namespace = IA;
  var n = requireObject();
  ((IA.prototype = Object.create(n.prototype)).constructor = IA).className = "Namespace";
  var t = requireField(), g = requireUtil(), d = requireOneof(), k, H, AA;
  IA.fromJSON = function(eA, iA) {
    return new IA(eA, iA.options).addJSON(iA.nested);
  };
  function gA(BA, eA) {
    if (BA && BA.length) {
      for (var iA = {}, QA = 0; QA < BA.length; ++QA)
        iA[BA[QA].name] = BA[QA].toJSON(eA);
      return iA;
    }
  }
  IA.arrayToJSON = gA, IA.isReservedId = function(eA, iA) {
    if (eA) {
      for (var QA = 0; QA < eA.length; ++QA)
        if (typeof eA[QA] != "string" && eA[QA][0] <= iA && eA[QA][1] > iA)
          return !0;
    }
    return !1;
  }, IA.isReservedName = function(eA, iA) {
    if (eA) {
      for (var QA = 0; QA < eA.length; ++QA)
        if (eA[QA] === iA)
          return !0;
    }
    return !1;
  };
  function IA(BA, eA) {
    n.call(this, BA, eA), this.nested = void 0, this._nestedArray = null, this._lookupCache = {}, this._needsRecursiveFeatureResolution = !0, this._needsRecursiveResolve = !0;
  }
  function CA(BA) {
    BA._nestedArray = null, BA._lookupCache = {};
    for (var eA = BA; eA = eA.parent; )
      eA._lookupCache = {};
    return BA;
  }
  return Object.defineProperty(IA.prototype, "nestedArray", {
    get: function() {
      return this._nestedArray || (this._nestedArray = g.toArray(this.nested));
    }
  }), IA.prototype.toJSON = function(eA) {
    return g.toObject([
      "options",
      this.options,
      "nested",
      gA(this.nestedArray, eA)
    ]);
  }, IA.prototype.addJSON = function(eA) {
    var iA = this;
    if (eA)
      for (var QA = Object.keys(eA), tA = 0, oA; tA < QA.length; ++tA)
        oA = eA[QA[tA]], iA.add(
          // most to least likely
          (oA.fields !== void 0 ? k.fromJSON : oA.values !== void 0 ? AA.fromJSON : oA.methods !== void 0 ? H.fromJSON : oA.id !== void 0 ? t.fromJSON : IA.fromJSON)(QA[tA], oA)
        );
    return this;
  }, IA.prototype.get = function(eA) {
    return this.nested && this.nested[eA] || null;
  }, IA.prototype.getEnum = function(eA) {
    if (this.nested && this.nested[eA] instanceof AA)
      return this.nested[eA].values;
    throw Error("no such enum: " + eA);
  }, IA.prototype.add = function(eA) {
    if (!(eA instanceof t && eA.extend !== void 0 || eA instanceof k || eA instanceof d || eA instanceof AA || eA instanceof H || eA instanceof IA))
      throw TypeError("object must be a valid nested object");
    if (!this.nested)
      this.nested = {};
    else {
      var iA = this.get(eA.name);
      if (iA)
        if (iA instanceof IA && eA instanceof IA && !(iA instanceof k || iA instanceof H)) {
          for (var QA = iA.nestedArray, tA = 0; tA < QA.length; ++tA)
            eA.add(QA[tA]);
          this.remove(iA), this.nested || (this.nested = {}), eA.setOptions(iA.options, !0);
        } else
          throw Error("duplicate name '" + eA.name + "' in " + this);
    }
    this.nested[eA.name] = eA, this instanceof k || this instanceof H || this instanceof AA || this instanceof t || eA._edition || (eA._edition = eA._defaultEdition), this._needsRecursiveFeatureResolution = !0, this._needsRecursiveResolve = !0;
    for (var oA = this; oA = oA.parent; )
      oA._needsRecursiveFeatureResolution = !0, oA._needsRecursiveResolve = !0;
    return eA.onAdd(this), CA(this);
  }, IA.prototype.remove = function(eA) {
    if (!(eA instanceof n))
      throw TypeError("object must be a ReflectionObject");
    if (eA.parent !== this)
      throw Error(eA + " is not a member of " + this);
    return delete this.nested[eA.name], Object.keys(this.nested).length || (this.nested = void 0), eA.onRemove(this), CA(this);
  }, IA.prototype.define = function(eA, iA) {
    if (g.isString(eA))
      eA = eA.split(".");
    else if (!Array.isArray(eA))
      throw TypeError("illegal path");
    if (eA && eA.length && eA[0] === "")
      throw Error("path must be relative");
    for (var QA = this; eA.length > 0; ) {
      var tA = eA.shift();
      if (QA.nested && QA.nested[tA]) {
        if (QA = QA.nested[tA], !(QA instanceof IA))
          throw Error("path conflicts with non-namespace objects");
      } else
        QA.add(QA = new IA(tA));
    }
    return iA && QA.addJSON(iA), QA;
  }, IA.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    this._resolveFeaturesRecursive(this._edition);
    var eA = this.nestedArray, iA = 0;
    for (this.resolve(); iA < eA.length; )
      eA[iA] instanceof IA ? eA[iA++].resolveAll() : eA[iA++].resolve();
    return this._needsRecursiveResolve = !1, this;
  }, IA.prototype._resolveFeaturesRecursive = function(eA) {
    return this._needsRecursiveFeatureResolution ? (this._needsRecursiveFeatureResolution = !1, eA = this._edition || eA, n.prototype._resolveFeaturesRecursive.call(this, eA), this.nestedArray.forEach((iA) => {
      iA._resolveFeaturesRecursive(eA);
    }), this) : this;
  }, IA.prototype.lookup = function(eA, iA, QA) {
    if (typeof iA == "boolean" ? (QA = iA, iA = void 0) : iA && !Array.isArray(iA) && (iA = [iA]), g.isString(eA) && eA.length) {
      if (eA === ".")
        return this.root;
      eA = eA.split(".");
    } else if (!eA.length)
      return this;
    var tA = eA.join(".");
    if (eA[0] === "")
      return this.root.lookup(eA.slice(1), iA);
    var oA = this.root._fullyQualifiedObjects && this.root._fullyQualifiedObjects["." + tA];
    if (oA && (!iA || iA.indexOf(oA.constructor) > -1) || (oA = this._lookupImpl(eA, tA), oA && (!iA || iA.indexOf(oA.constructor) > -1)))
      return oA;
    if (QA)
      return null;
    for (var EA = this; EA.parent; ) {
      if (oA = EA.parent._lookupImpl(eA, tA), oA && (!iA || iA.indexOf(oA.constructor) > -1))
        return oA;
      EA = EA.parent;
    }
    return null;
  }, IA.prototype._lookupImpl = function(eA, iA) {
    if (Object.prototype.hasOwnProperty.call(this._lookupCache, iA))
      return this._lookupCache[iA];
    var QA = this.get(eA[0]), tA = null;
    if (QA)
      eA.length === 1 ? tA = QA : QA instanceof IA && (eA = eA.slice(1), tA = QA._lookupImpl(eA, eA.join(".")));
    else
      for (var oA = 0; oA < this.nestedArray.length; ++oA)
        this._nestedArray[oA] instanceof IA && (QA = this._nestedArray[oA]._lookupImpl(eA, iA)) && (tA = QA);
    return this._lookupCache[iA] = tA, tA;
  }, IA.prototype.lookupType = function(eA) {
    var iA = this.lookup(eA, [k]);
    if (!iA)
      throw Error("no such type: " + eA);
    return iA;
  }, IA.prototype.lookupEnum = function(eA) {
    var iA = this.lookup(eA, [AA]);
    if (!iA)
      throw Error("no such Enum '" + eA + "' in " + this);
    return iA;
  }, IA.prototype.lookupTypeOrEnum = function(eA) {
    var iA = this.lookup(eA, [k, AA]);
    if (!iA)
      throw Error("no such Type or Enum '" + eA + "' in " + this);
    return iA;
  }, IA.prototype.lookupService = function(eA) {
    var iA = this.lookup(eA, [H]);
    if (!iA)
      throw Error("no such Service '" + eA + "' in " + this);
    return iA;
  }, IA._configure = function(BA, eA, iA) {
    k = BA, H = eA, AA = iA;
  }, namespace;
}
var mapfield, hasRequiredMapfield;
function requireMapfield() {
  if (hasRequiredMapfield) return mapfield;
  hasRequiredMapfield = 1, mapfield = d;
  var n = requireField();
  ((d.prototype = Object.create(n.prototype)).constructor = d).className = "MapField";
  var t = requireTypes(), g = requireUtil();
  function d(k, H, AA, gA, IA, CA) {
    if (n.call(this, k, H, gA, void 0, void 0, IA, CA), !g.isString(AA))
      throw TypeError("keyType must be a string");
    this.keyType = AA, this.resolvedKeyType = null, this.map = !0;
  }
  return d.fromJSON = function(H, AA) {
    return new d(H, AA.id, AA.keyType, AA.type, AA.options, AA.comment);
  }, d.prototype.toJSON = function(H) {
    var AA = H ? !!H.keepComments : !1;
    return g.toObject([
      "keyType",
      this.keyType,
      "type",
      this.type,
      "id",
      this.id,
      "extend",
      this.extend,
      "options",
      this.options,
      "comment",
      AA ? this.comment : void 0
    ]);
  }, d.prototype.resolve = function() {
    if (this.resolved)
      return this;
    if (t.mapKey[this.keyType] === void 0)
      throw Error("invalid key type: " + this.keyType);
    return n.prototype.resolve.call(this);
  }, d.d = function(H, AA, gA) {
    return typeof gA == "function" ? gA = g.decorateType(gA).name : gA && typeof gA == "object" && (gA = g.decorateEnum(gA).name), function(CA, BA) {
      g.decorateType(CA.constructor).add(new d(BA, H, AA, gA));
    };
  }, mapfield;
}
var method, hasRequiredMethod;
function requireMethod() {
  if (hasRequiredMethod) return method;
  hasRequiredMethod = 1, method = g;
  var n = requireObject();
  ((g.prototype = Object.create(n.prototype)).constructor = g).className = "Method";
  var t = requireUtil();
  function g(d, k, H, AA, gA, IA, CA, BA, eA) {
    if (t.isObject(gA) ? (CA = gA, gA = IA = void 0) : t.isObject(IA) && (CA = IA, IA = void 0), !(k === void 0 || t.isString(k)))
      throw TypeError("type must be a string");
    if (!t.isString(H))
      throw TypeError("requestType must be a string");
    if (!t.isString(AA))
      throw TypeError("responseType must be a string");
    n.call(this, d, CA), this.type = k || "rpc", this.requestType = H, this.requestStream = gA ? !0 : void 0, this.responseType = AA, this.responseStream = IA ? !0 : void 0, this.resolvedRequestType = null, this.resolvedResponseType = null, this.comment = BA, this.parsedOptions = eA;
  }
  return g.fromJSON = function(k, H) {
    return new g(k, H.type, H.requestType, H.responseType, H.requestStream, H.responseStream, H.options, H.comment, H.parsedOptions);
  }, g.prototype.toJSON = function(k) {
    var H = k ? !!k.keepComments : !1;
    return t.toObject([
      "type",
      this.type !== "rpc" && /* istanbul ignore next */
      this.type || void 0,
      "requestType",
      this.requestType,
      "requestStream",
      this.requestStream,
      "responseType",
      this.responseType,
      "responseStream",
      this.responseStream,
      "options",
      this.options,
      "comment",
      H ? this.comment : void 0,
      "parsedOptions",
      this.parsedOptions
    ]);
  }, g.prototype.resolve = function() {
    return this.resolved ? this : (this.resolvedRequestType = this.parent.lookupType(this.requestType), this.resolvedResponseType = this.parent.lookupType(this.responseType), n.prototype.resolve.call(this));
  }, method;
}
var service, hasRequiredService;
function requireService() {
  if (hasRequiredService) return service;
  hasRequiredService = 1, service = k;
  var n = requireNamespace();
  ((k.prototype = Object.create(n.prototype)).constructor = k).className = "Service";
  var t = requireMethod(), g = requireUtil(), d = requireRpc$1();
  function k(AA, gA) {
    n.call(this, AA, gA), this.methods = {}, this._methodsArray = null;
  }
  k.fromJSON = function(gA, IA) {
    var CA = new k(gA, IA.options);
    if (IA.methods)
      for (var BA = Object.keys(IA.methods), eA = 0; eA < BA.length; ++eA)
        CA.add(t.fromJSON(BA[eA], IA.methods[BA[eA]]));
    return IA.nested && CA.addJSON(IA.nested), IA.edition && (CA._edition = IA.edition), CA.comment = IA.comment, CA._defaultEdition = "proto3", CA;
  }, k.prototype.toJSON = function(gA) {
    var IA = n.prototype.toJSON.call(this, gA), CA = gA ? !!gA.keepComments : !1;
    return g.toObject([
      "edition",
      this._editionToJSON(),
      "options",
      IA && IA.options || void 0,
      "methods",
      n.arrayToJSON(this.methodsArray, gA) || /* istanbul ignore next */
      {},
      "nested",
      IA && IA.nested || void 0,
      "comment",
      CA ? this.comment : void 0
    ]);
  }, Object.defineProperty(k.prototype, "methodsArray", {
    get: function() {
      return this._methodsArray || (this._methodsArray = g.toArray(this.methods));
    }
  });
  function H(AA) {
    return AA._methodsArray = null, AA;
  }
  return k.prototype.get = function(gA) {
    return this.methods[gA] || n.prototype.get.call(this, gA);
  }, k.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    n.prototype.resolve.call(this);
    for (var gA = this.methodsArray, IA = 0; IA < gA.length; ++IA)
      gA[IA].resolve();
    return this;
  }, k.prototype._resolveFeaturesRecursive = function(gA) {
    return this._needsRecursiveFeatureResolution ? (gA = this._edition || gA, n.prototype._resolveFeaturesRecursive.call(this, gA), this.methodsArray.forEach((IA) => {
      IA._resolveFeaturesRecursive(gA);
    }), this) : this;
  }, k.prototype.add = function(gA) {
    if (this.get(gA.name))
      throw Error("duplicate name '" + gA.name + "' in " + this);
    return gA instanceof t ? (this.methods[gA.name] = gA, gA.parent = this, H(this)) : n.prototype.add.call(this, gA);
  }, k.prototype.remove = function(gA) {
    if (gA instanceof t) {
      if (this.methods[gA.name] !== gA)
        throw Error(gA + " is not a member of " + this);
      return delete this.methods[gA.name], gA.parent = null, H(this);
    }
    return n.prototype.remove.call(this, gA);
  }, k.prototype.create = function(gA, IA, CA) {
    for (var BA = new d.Service(gA, IA, CA), eA = 0, iA; eA < /* initializes */
    this.methodsArray.length; ++eA) {
      var QA = g.lcFirst((iA = this._methodsArray[eA]).resolve().name).replace(/[^$\w_]/g, "");
      BA[QA] = g.codegen(["r", "c"], g.isReserved(QA) ? QA + "_" : QA)("return this.rpcCall(m,q,s,r,c)")({
        m: iA,
        q: iA.resolvedRequestType.ctor,
        s: iA.resolvedResponseType.ctor
      });
    }
    return BA;
  }, service;
}
var message, hasRequiredMessage;
function requireMessage() {
  if (hasRequiredMessage) return message;
  hasRequiredMessage = 1, message = t;
  var n = requireMinimal$3();
  function t(g) {
    if (g)
      for (var d = Object.keys(g), k = 0; k < d.length; ++k)
        this[d[k]] = g[d[k]];
  }
  return t.create = function(d) {
    return this.$type.create(d);
  }, t.encode = function(d, k) {
    return this.$type.encode(d, k);
  }, t.encodeDelimited = function(d, k) {
    return this.$type.encodeDelimited(d, k);
  }, t.decode = function(d) {
    return this.$type.decode(d);
  }, t.decodeDelimited = function(d) {
    return this.$type.decodeDelimited(d);
  }, t.verify = function(d) {
    return this.$type.verify(d);
  }, t.fromObject = function(d) {
    return this.$type.fromObject(d);
  }, t.toObject = function(d, k) {
    return this.$type.toObject(d, k);
  }, t.prototype.toJSON = function() {
    return this.$type.toObject(this, n.toJSONOptions);
  }, message;
}
var decoder_1, hasRequiredDecoder;
function requireDecoder() {
  if (hasRequiredDecoder) return decoder_1;
  hasRequiredDecoder = 1, decoder_1 = k;
  var n = require_enum(), t = requireTypes(), g = requireUtil();
  function d(H) {
    return "missing required '" + H.name + "'";
  }
  function k(H) {
    for (var AA = g.codegen(["r", "l", "e"], H.name + "$decode")("if(!(r instanceof Reader))")("r=Reader.create(r)")("var c=l===undefined?r.len:r.pos+l,m=new this.ctor" + (H.fieldsArray.filter(function(iA) {
      return iA.map;
    }).length ? ",k,value" : ""))("while(r.pos<c){")("var t=r.uint32()")("if(t===e)")("break")("switch(t>>>3){"), gA = 0; gA < /* initializes */
    H.fieldsArray.length; ++gA) {
      var IA = H._fieldsArray[gA].resolve(), CA = IA.resolvedType instanceof n ? "int32" : IA.type, BA = "m" + g.safeProp(IA.name);
      AA("case %i: {", IA.id), IA.map ? (AA("if(%s===util.emptyObject)", BA)("%s={}", BA)("var c2 = r.uint32()+r.pos"), t.defaults[IA.keyType] !== void 0 ? AA("k=%j", t.defaults[IA.keyType]) : AA("k=null"), t.defaults[CA] !== void 0 ? AA("value=%j", t.defaults[CA]) : AA("value=null"), AA("while(r.pos<c2){")("var tag2=r.uint32()")("switch(tag2>>>3){")("case 1: k=r.%s(); break", IA.keyType)("case 2:"), t.basic[CA] === void 0 ? AA("value=types[%i].decode(r,r.uint32())", gA) : AA("value=r.%s()", CA), AA("break")("default:")("r.skipType(tag2&7)")("break")("}")("}"), t.long[IA.keyType] !== void 0 ? AA('%s[typeof k==="object"?util.longToHash(k):k]=value', BA) : AA("%s[k]=value", BA)) : IA.repeated ? (AA("if(!(%s&&%s.length))", BA, BA)("%s=[]", BA), t.packed[CA] !== void 0 && AA("if((t&7)===2){")("var c2=r.uint32()+r.pos")("while(r.pos<c2)")("%s.push(r.%s())", BA, CA)("}else"), t.basic[CA] === void 0 ? AA(IA.delimited ? "%s.push(types[%i].decode(r,undefined,((t&~7)|4)))" : "%s.push(types[%i].decode(r,r.uint32()))", BA, gA) : AA("%s.push(r.%s())", BA, CA)) : t.basic[CA] === void 0 ? AA(IA.delimited ? "%s=types[%i].decode(r,undefined,((t&~7)|4))" : "%s=types[%i].decode(r,r.uint32())", BA, gA) : AA("%s=r.%s()", BA, CA), AA("break")("}");
    }
    for (AA("default:")("r.skipType(t&7)")("break")("}")("}"), gA = 0; gA < H._fieldsArray.length; ++gA) {
      var eA = H._fieldsArray[gA];
      eA.required && AA("if(!m.hasOwnProperty(%j))", eA.name)("throw util.ProtocolError(%j,{instance:m})", d(eA));
    }
    return AA("return m");
  }
  return decoder_1;
}
var verifier_1, hasRequiredVerifier;
function requireVerifier() {
  if (hasRequiredVerifier) return verifier_1;
  hasRequiredVerifier = 1, verifier_1 = H;
  var n = require_enum(), t = requireUtil();
  function g(AA, gA) {
    return AA.name + ": " + gA + (AA.repeated && gA !== "array" ? "[]" : AA.map && gA !== "object" ? "{k:" + AA.keyType + "}" : "") + " expected";
  }
  function d(AA, gA, IA, CA) {
    if (gA.resolvedType)
      if (gA.resolvedType instanceof n) {
        AA("switch(%s){", CA)("default:")("return%j", g(gA, "enum value"));
        for (var BA = Object.keys(gA.resolvedType.values), eA = 0; eA < BA.length; ++eA) AA("case %i:", gA.resolvedType.values[BA[eA]]);
        AA("break")("}");
      } else
        AA("{")("var e=types[%i].verify(%s);", IA, CA)("if(e)")("return%j+e", gA.name + ".")("}");
    else
      switch (gA.type) {
        case "int32":
        case "uint32":
        case "sint32":
        case "fixed32":
        case "sfixed32":
          AA("if(!util.isInteger(%s))", CA)("return%j", g(gA, "integer"));
          break;
        case "int64":
        case "uint64":
        case "sint64":
        case "fixed64":
        case "sfixed64":
          AA("if(!util.isInteger(%s)&&!(%s&&util.isInteger(%s.low)&&util.isInteger(%s.high)))", CA, CA, CA, CA)("return%j", g(gA, "integer|Long"));
          break;
        case "float":
        case "double":
          AA('if(typeof %s!=="number")', CA)("return%j", g(gA, "number"));
          break;
        case "bool":
          AA('if(typeof %s!=="boolean")', CA)("return%j", g(gA, "boolean"));
          break;
        case "string":
          AA("if(!util.isString(%s))", CA)("return%j", g(gA, "string"));
          break;
        case "bytes":
          AA('if(!(%s&&typeof %s.length==="number"||util.isString(%s)))', CA, CA, CA)("return%j", g(gA, "buffer"));
          break;
      }
    return AA;
  }
  function k(AA, gA, IA) {
    switch (gA.keyType) {
      case "int32":
      case "uint32":
      case "sint32":
      case "fixed32":
      case "sfixed32":
        AA("if(!util.key32Re.test(%s))", IA)("return%j", g(gA, "integer key"));
        break;
      case "int64":
      case "uint64":
      case "sint64":
      case "fixed64":
      case "sfixed64":
        AA("if(!util.key64Re.test(%s))", IA)("return%j", g(gA, "integer|Long key"));
        break;
      case "bool":
        AA("if(!util.key2Re.test(%s))", IA)("return%j", g(gA, "boolean key"));
        break;
    }
    return AA;
  }
  function H(AA) {
    var gA = t.codegen(["m"], AA.name + "$verify")('if(typeof m!=="object"||m===null)')("return%j", "object expected"), IA = AA.oneofsArray, CA = {};
    IA.length && gA("var p={}");
    for (var BA = 0; BA < /* initializes */
    AA.fieldsArray.length; ++BA) {
      var eA = AA._fieldsArray[BA].resolve(), iA = "m" + t.safeProp(eA.name);
      if (eA.optional && gA("if(%s!=null&&m.hasOwnProperty(%j)){", iA, eA.name), eA.map)
        gA("if(!util.isObject(%s))", iA)("return%j", g(eA, "object"))("var k=Object.keys(%s)", iA)("for(var i=0;i<k.length;++i){"), k(gA, eA, "k[i]"), d(gA, eA, BA, iA + "[k[i]]")("}");
      else if (eA.repeated)
        gA("if(!Array.isArray(%s))", iA)("return%j", g(eA, "array"))("for(var i=0;i<%s.length;++i){", iA), d(gA, eA, BA, iA + "[i]")("}");
      else {
        if (eA.partOf) {
          var QA = t.safeProp(eA.partOf.name);
          CA[eA.partOf.name] === 1 && gA("if(p%s===1)", QA)("return%j", eA.partOf.name + ": multiple values"), CA[eA.partOf.name] = 1, gA("p%s=1", QA);
        }
        d(gA, eA, BA, iA);
      }
      eA.optional && gA("}");
    }
    return gA("return null");
  }
  return verifier_1;
}
var converter = {}, hasRequiredConverter;
function requireConverter() {
  return hasRequiredConverter || (hasRequiredConverter = 1, (function(n) {
    var t = n, g = require_enum(), d = requireUtil();
    function k(AA, gA, IA, CA) {
      var BA = !1;
      if (gA.resolvedType)
        if (gA.resolvedType instanceof g) {
          AA("switch(d%s){", CA);
          for (var eA = gA.resolvedType.values, iA = Object.keys(eA), QA = 0; QA < iA.length; ++QA)
            eA[iA[QA]] === gA.typeDefault && !BA && (AA("default:")('if(typeof(d%s)==="number"){m%s=d%s;break}', CA, CA, CA), gA.repeated || AA("break"), BA = !0), AA("case%j:", iA[QA])("case %i:", eA[iA[QA]])("m%s=%j", CA, eA[iA[QA]])("break");
          AA("}");
        } else AA('if(typeof d%s!=="object")', CA)("throw TypeError(%j)", gA.fullName + ": object expected")("m%s=types[%i].fromObject(d%s)", CA, IA, CA);
      else {
        var tA = !1;
        switch (gA.type) {
          case "double":
          case "float":
            AA("m%s=Number(d%s)", CA, CA);
            break;
          case "uint32":
          case "fixed32":
            AA("m%s=d%s>>>0", CA, CA);
            break;
          case "int32":
          case "sint32":
          case "sfixed32":
            AA("m%s=d%s|0", CA, CA);
            break;
          case "uint64":
            tA = !0;
          // eslint-disable-next-line no-fallthrough
          case "int64":
          case "sint64":
          case "fixed64":
          case "sfixed64":
            AA("if(util.Long)")("(m%s=util.Long.fromValue(d%s)).unsigned=%j", CA, CA, tA)('else if(typeof d%s==="string")', CA)("m%s=parseInt(d%s,10)", CA, CA)('else if(typeof d%s==="number")', CA)("m%s=d%s", CA, CA)('else if(typeof d%s==="object")', CA)("m%s=new util.LongBits(d%s.low>>>0,d%s.high>>>0).toNumber(%s)", CA, CA, CA, tA ? "true" : "");
            break;
          case "bytes":
            AA('if(typeof d%s==="string")', CA)("util.base64.decode(d%s,m%s=util.newBuffer(util.base64.length(d%s)),0)", CA, CA, CA)("else if(d%s.length >= 0)", CA)("m%s=d%s", CA, CA);
            break;
          case "string":
            AA("m%s=String(d%s)", CA, CA);
            break;
          case "bool":
            AA("m%s=Boolean(d%s)", CA, CA);
            break;
        }
      }
      return AA;
    }
    t.fromObject = function(gA) {
      var IA = gA.fieldsArray, CA = d.codegen(["d"], gA.name + "$fromObject")("if(d instanceof this.ctor)")("return d");
      if (!IA.length) return CA("return new this.ctor");
      CA("var m=new this.ctor");
      for (var BA = 0; BA < IA.length; ++BA) {
        var eA = IA[BA].resolve(), iA = d.safeProp(eA.name);
        eA.map ? (CA("if(d%s){", iA)('if(typeof d%s!=="object")', iA)("throw TypeError(%j)", eA.fullName + ": object expected")("m%s={}", iA)("for(var ks=Object.keys(d%s),i=0;i<ks.length;++i){", iA), k(
          CA,
          eA,
          /* not sorted */
          BA,
          iA + "[ks[i]]"
        )("}")("}")) : eA.repeated ? (CA("if(d%s){", iA)("if(!Array.isArray(d%s))", iA)("throw TypeError(%j)", eA.fullName + ": array expected")("m%s=[]", iA)("for(var i=0;i<d%s.length;++i){", iA), k(
          CA,
          eA,
          /* not sorted */
          BA,
          iA + "[i]"
        )("}")("}")) : (eA.resolvedType instanceof g || CA("if(d%s!=null){", iA), k(
          CA,
          eA,
          /* not sorted */
          BA,
          iA
        ), eA.resolvedType instanceof g || CA("}"));
      }
      return CA("return m");
    };
    function H(AA, gA, IA, CA) {
      if (gA.resolvedType)
        gA.resolvedType instanceof g ? AA("d%s=o.enums===String?(types[%i].values[m%s]===undefined?m%s:types[%i].values[m%s]):m%s", CA, IA, CA, CA, IA, CA, CA) : AA("d%s=types[%i].toObject(m%s,o)", CA, IA, CA);
      else {
        var BA = !1;
        switch (gA.type) {
          case "double":
          case "float":
            AA("d%s=o.json&&!isFinite(m%s)?String(m%s):m%s", CA, CA, CA, CA);
            break;
          case "uint64":
            BA = !0;
          // eslint-disable-next-line no-fallthrough
          case "int64":
          case "sint64":
          case "fixed64":
          case "sfixed64":
            AA('if(typeof m%s==="number")', CA)("d%s=o.longs===String?String(m%s):m%s", CA, CA, CA)("else")("d%s=o.longs===String?util.Long.prototype.toString.call(m%s):o.longs===Number?new util.LongBits(m%s.low>>>0,m%s.high>>>0).toNumber(%s):m%s", CA, CA, CA, CA, BA ? "true" : "", CA);
            break;
          case "bytes":
            AA("d%s=o.bytes===String?util.base64.encode(m%s,0,m%s.length):o.bytes===Array?Array.prototype.slice.call(m%s):m%s", CA, CA, CA, CA, CA);
            break;
          default:
            AA("d%s=m%s", CA, CA);
            break;
        }
      }
      return AA;
    }
    t.toObject = function(gA) {
      var IA = gA.fieldsArray.slice().sort(d.compareFieldsById);
      if (!IA.length)
        return d.codegen()("return {}");
      for (var CA = d.codegen(["m", "o"], gA.name + "$toObject")("if(!o)")("o={}")("var d={}"), BA = [], eA = [], iA = [], QA = 0; QA < IA.length; ++QA)
        IA[QA].partOf || (IA[QA].resolve().repeated ? BA : IA[QA].map ? eA : iA).push(IA[QA]);
      if (BA.length) {
        for (CA("if(o.arrays||o.defaults){"), QA = 0; QA < BA.length; ++QA) CA("d%s=[]", d.safeProp(BA[QA].name));
        CA("}");
      }
      if (eA.length) {
        for (CA("if(o.objects||o.defaults){"), QA = 0; QA < eA.length; ++QA) CA("d%s={}", d.safeProp(eA[QA].name));
        CA("}");
      }
      if (iA.length) {
        for (CA("if(o.defaults){"), QA = 0; QA < iA.length; ++QA) {
          var tA = iA[QA], oA = d.safeProp(tA.name);
          if (tA.resolvedType instanceof g) CA("d%s=o.enums===String?%j:%j", oA, tA.resolvedType.valuesById[tA.typeDefault], tA.typeDefault);
          else if (tA.long) CA("if(util.Long){")("var n=new util.Long(%i,%i,%j)", tA.typeDefault.low, tA.typeDefault.high, tA.typeDefault.unsigned)("d%s=o.longs===String?n.toString():o.longs===Number?n.toNumber():n", oA)("}else")("d%s=o.longs===String?%j:%i", oA, tA.typeDefault.toString(), tA.typeDefault.toNumber());
          else if (tA.bytes) {
            var EA = "[" + Array.prototype.slice.call(tA.typeDefault).join(",") + "]";
            CA("if(o.bytes===String)d%s=%j", oA, String.fromCharCode.apply(String, tA.typeDefault))("else{")("d%s=%s", oA, EA)("if(o.bytes!==Array)d%s=util.newBuffer(d%s)", oA, oA)("}");
          } else CA("d%s=%j", oA, tA.typeDefault);
        }
        CA("}");
      }
      var aA = !1;
      for (QA = 0; QA < IA.length; ++QA) {
        var tA = IA[QA], nA = gA._fieldsArray.indexOf(tA), oA = d.safeProp(tA.name);
        tA.map ? (aA || (aA = !0, CA("var ks2")), CA("if(m%s&&(ks2=Object.keys(m%s)).length){", oA, oA)("d%s={}", oA)("for(var j=0;j<ks2.length;++j){"), H(
          CA,
          tA,
          /* sorted */
          nA,
          oA + "[ks2[j]]"
        )("}")) : tA.repeated ? (CA("if(m%s&&m%s.length){", oA, oA)("d%s=[]", oA)("for(var j=0;j<m%s.length;++j){", oA), H(
          CA,
          tA,
          /* sorted */
          nA,
          oA + "[j]"
        )("}")) : (CA("if(m%s!=null&&m.hasOwnProperty(%j)){", oA, tA.name), H(
          CA,
          tA,
          /* sorted */
          nA,
          oA
        ), tA.partOf && CA("if(o.oneofs)")("d%s=%j", d.safeProp(tA.partOf.name), tA.name)), CA("}");
      }
      return CA("return d");
    };
  })(converter)), converter;
}
var wrappers = {}, hasRequiredWrappers;
function requireWrappers() {
  return hasRequiredWrappers || (hasRequiredWrappers = 1, (function(n) {
    var t = n, g = requireMessage();
    t[".google.protobuf.Any"] = {
      fromObject: function(d) {
        if (d && d["@type"]) {
          var k = d["@type"].substring(d["@type"].lastIndexOf("/") + 1), H = this.lookup(k);
          if (H) {
            var AA = d["@type"].charAt(0) === "." ? d["@type"].slice(1) : d["@type"];
            return AA.indexOf("/") === -1 && (AA = "/" + AA), this.create({
              type_url: AA,
              value: H.encode(H.fromObject(d)).finish()
            });
          }
        }
        return this.fromObject(d);
      },
      toObject: function(d, k) {
        var H = "type.googleapis.com/", AA = "", gA = "";
        if (k && k.json && d.type_url && d.value) {
          gA = d.type_url.substring(d.type_url.lastIndexOf("/") + 1), AA = d.type_url.substring(0, d.type_url.lastIndexOf("/") + 1);
          var IA = this.lookup(gA);
          IA && (d = IA.decode(d.value));
        }
        if (!(d instanceof this.ctor) && d instanceof g) {
          var CA = d.$type.toObject(d, k), BA = d.$type.fullName[0] === "." ? d.$type.fullName.slice(1) : d.$type.fullName;
          return AA === "" && (AA = H), gA = AA + BA, CA["@type"] = gA, CA;
        }
        return this.toObject(d, k);
      }
    };
  })(wrappers)), wrappers;
}
var type, hasRequiredType;
function requireType() {
  if (hasRequiredType) return type;
  hasRequiredType = 1, type = oA;
  var n = requireNamespace();
  ((oA.prototype = Object.create(n.prototype)).constructor = oA).className = "Type";
  var t = require_enum(), g = requireOneof(), d = requireField(), k = requireMapfield(), H = requireService(), AA = requireMessage(), gA = requireReader$1(), IA = requireWriter$1(), CA = requireUtil(), BA = requireEncoder(), eA = requireDecoder(), iA = requireVerifier(), QA = requireConverter(), tA = requireWrappers();
  function oA(aA, nA) {
    n.call(this, aA, nA), this.fields = {}, this.oneofs = void 0, this.extensions = void 0, this.reserved = void 0, this.group = void 0, this._fieldsById = null, this._fieldsArray = null, this._oneofsArray = null, this._ctor = null;
  }
  Object.defineProperties(oA.prototype, {
    /**
     * Message fields by id.
     * @name Type#fieldsById
     * @type {Object.<number,Field>}
     * @readonly
     */
    fieldsById: {
      get: function() {
        if (this._fieldsById)
          return this._fieldsById;
        this._fieldsById = {};
        for (var aA = Object.keys(this.fields), nA = 0; nA < aA.length; ++nA) {
          var lA = this.fields[aA[nA]], cA = lA.id;
          if (this._fieldsById[cA])
            throw Error("duplicate id " + cA + " in " + this);
          this._fieldsById[cA] = lA;
        }
        return this._fieldsById;
      }
    },
    /**
     * Fields of this message as an array for iteration.
     * @name Type#fieldsArray
     * @type {Field[]}
     * @readonly
     */
    fieldsArray: {
      get: function() {
        return this._fieldsArray || (this._fieldsArray = CA.toArray(this.fields));
      }
    },
    /**
     * Oneofs of this message as an array for iteration.
     * @name Type#oneofsArray
     * @type {OneOf[]}
     * @readonly
     */
    oneofsArray: {
      get: function() {
        return this._oneofsArray || (this._oneofsArray = CA.toArray(this.oneofs));
      }
    },
    /**
     * The registered constructor, if any registered, otherwise a generic constructor.
     * Assigning a function replaces the internal constructor. If the function does not extend {@link Message} yet, its prototype will be setup accordingly and static methods will be populated. If it already extends {@link Message}, it will just replace the internal constructor.
     * @name Type#ctor
     * @type {Constructor<{}>}
     */
    ctor: {
      get: function() {
        return this._ctor || (this.ctor = oA.generateConstructor(this)());
      },
      set: function(aA) {
        var nA = aA.prototype;
        nA instanceof AA || ((aA.prototype = new AA()).constructor = aA, CA.merge(aA.prototype, nA)), aA.$type = aA.prototype.$type = this, CA.merge(aA, AA, !0), this._ctor = aA;
        for (var lA = 0; lA < /* initializes */
        this.fieldsArray.length; ++lA)
          this._fieldsArray[lA].resolve();
        var cA = {};
        for (lA = 0; lA < /* initializes */
        this.oneofsArray.length; ++lA)
          cA[this._oneofsArray[lA].resolve().name] = {
            get: CA.oneOfGetter(this._oneofsArray[lA].oneof),
            set: CA.oneOfSetter(this._oneofsArray[lA].oneof)
          };
        lA && Object.defineProperties(aA.prototype, cA);
      }
    }
  }), oA.generateConstructor = function(nA) {
    for (var lA = CA.codegen(["p"], nA.name), cA = 0, sA; cA < nA.fieldsArray.length; ++cA)
      (sA = nA._fieldsArray[cA]).map ? lA("this%s={}", CA.safeProp(sA.name)) : sA.repeated && lA("this%s=[]", CA.safeProp(sA.name));
    return lA("if(p)for(var ks=Object.keys(p),i=0;i<ks.length;++i)if(p[ks[i]]!=null)")("this[ks[i]]=p[ks[i]]");
  };
  function EA(aA) {
    return aA._fieldsById = aA._fieldsArray = aA._oneofsArray = null, delete aA.encode, delete aA.decode, delete aA.verify, aA;
  }
  return oA.fromJSON = function(nA, lA) {
    var cA = new oA(nA, lA.options);
    cA.extensions = lA.extensions, cA.reserved = lA.reserved;
    for (var sA = Object.keys(lA.fields), rA = 0; rA < sA.length; ++rA)
      cA.add(
        (typeof lA.fields[sA[rA]].keyType < "u" ? k.fromJSON : d.fromJSON)(sA[rA], lA.fields[sA[rA]])
      );
    if (lA.oneofs)
      for (sA = Object.keys(lA.oneofs), rA = 0; rA < sA.length; ++rA)
        cA.add(g.fromJSON(sA[rA], lA.oneofs[sA[rA]]));
    if (lA.nested)
      for (sA = Object.keys(lA.nested), rA = 0; rA < sA.length; ++rA) {
        var uA = lA.nested[sA[rA]];
        cA.add(
          // most to least likely
          (uA.id !== void 0 ? d.fromJSON : uA.fields !== void 0 ? oA.fromJSON : uA.values !== void 0 ? t.fromJSON : uA.methods !== void 0 ? H.fromJSON : n.fromJSON)(sA[rA], uA)
        );
      }
    return lA.extensions && lA.extensions.length && (cA.extensions = lA.extensions), lA.reserved && lA.reserved.length && (cA.reserved = lA.reserved), lA.group && (cA.group = !0), lA.comment && (cA.comment = lA.comment), lA.edition && (cA._edition = lA.edition), cA._defaultEdition = "proto3", cA;
  }, oA.prototype.toJSON = function(nA) {
    var lA = n.prototype.toJSON.call(this, nA), cA = nA ? !!nA.keepComments : !1;
    return CA.toObject([
      "edition",
      this._editionToJSON(),
      "options",
      lA && lA.options || void 0,
      "oneofs",
      n.arrayToJSON(this.oneofsArray, nA),
      "fields",
      n.arrayToJSON(this.fieldsArray.filter(function(sA) {
        return !sA.declaringField;
      }), nA) || {},
      "extensions",
      this.extensions && this.extensions.length ? this.extensions : void 0,
      "reserved",
      this.reserved && this.reserved.length ? this.reserved : void 0,
      "group",
      this.group || void 0,
      "nested",
      lA && lA.nested || void 0,
      "comment",
      cA ? this.comment : void 0
    ]);
  }, oA.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    n.prototype.resolveAll.call(this);
    var nA = this.oneofsArray;
    for (cA = 0; cA < nA.length; )
      nA[cA++].resolve();
    for (var lA = this.fieldsArray, cA = 0; cA < lA.length; )
      lA[cA++].resolve();
    return this;
  }, oA.prototype._resolveFeaturesRecursive = function(nA) {
    return this._needsRecursiveFeatureResolution ? (nA = this._edition || nA, n.prototype._resolveFeaturesRecursive.call(this, nA), this.oneofsArray.forEach((lA) => {
      lA._resolveFeatures(nA);
    }), this.fieldsArray.forEach((lA) => {
      lA._resolveFeatures(nA);
    }), this) : this;
  }, oA.prototype.get = function(nA) {
    return this.fields[nA] || this.oneofs && this.oneofs[nA] || this.nested && this.nested[nA] || null;
  }, oA.prototype.add = function(nA) {
    if (this.get(nA.name))
      throw Error("duplicate name '" + nA.name + "' in " + this);
    if (nA instanceof d && nA.extend === void 0) {
      if (this._fieldsById ? (
        /* istanbul ignore next */
        this._fieldsById[nA.id]
      ) : this.fieldsById[nA.id])
        throw Error("duplicate id " + nA.id + " in " + this);
      if (this.isReservedId(nA.id))
        throw Error("id " + nA.id + " is reserved in " + this);
      if (this.isReservedName(nA.name))
        throw Error("name '" + nA.name + "' is reserved in " + this);
      return nA.parent && nA.parent.remove(nA), this.fields[nA.name] = nA, nA.message = this, nA.onAdd(this), EA(this);
    }
    return nA instanceof g ? (this.oneofs || (this.oneofs = {}), this.oneofs[nA.name] = nA, nA.onAdd(this), EA(this)) : n.prototype.add.call(this, nA);
  }, oA.prototype.remove = function(nA) {
    if (nA instanceof d && nA.extend === void 0) {
      if (!this.fields || this.fields[nA.name] !== nA)
        throw Error(nA + " is not a member of " + this);
      return delete this.fields[nA.name], nA.parent = null, nA.onRemove(this), EA(this);
    }
    if (nA instanceof g) {
      if (!this.oneofs || this.oneofs[nA.name] !== nA)
        throw Error(nA + " is not a member of " + this);
      return delete this.oneofs[nA.name], nA.parent = null, nA.onRemove(this), EA(this);
    }
    return n.prototype.remove.call(this, nA);
  }, oA.prototype.isReservedId = function(nA) {
    return n.isReservedId(this.reserved, nA);
  }, oA.prototype.isReservedName = function(nA) {
    return n.isReservedName(this.reserved, nA);
  }, oA.prototype.create = function(nA) {
    return new this.ctor(nA);
  }, oA.prototype.setup = function() {
    for (var nA = this.fullName, lA = [], cA = 0; cA < /* initializes */
    this.fieldsArray.length; ++cA)
      lA.push(this._fieldsArray[cA].resolve().resolvedType);
    this.encode = BA(this)({
      Writer: IA,
      types: lA,
      util: CA
    }), this.decode = eA(this)({
      Reader: gA,
      types: lA,
      util: CA
    }), this.verify = iA(this)({
      types: lA,
      util: CA
    }), this.fromObject = QA.fromObject(this)({
      types: lA,
      util: CA
    }), this.toObject = QA.toObject(this)({
      types: lA,
      util: CA
    });
    var sA = tA[nA];
    if (sA) {
      var rA = Object.create(this);
      rA.fromObject = this.fromObject, this.fromObject = sA.fromObject.bind(rA), rA.toObject = this.toObject, this.toObject = sA.toObject.bind(rA);
    }
    return this;
  }, oA.prototype.encode = function(nA, lA) {
    return this.setup().encode(nA, lA);
  }, oA.prototype.encodeDelimited = function(nA, lA) {
    return this.encode(nA, lA && lA.len ? lA.fork() : lA).ldelim();
  }, oA.prototype.decode = function(nA, lA) {
    return this.setup().decode(nA, lA);
  }, oA.prototype.decodeDelimited = function(nA) {
    return nA instanceof gA || (nA = gA.create(nA)), this.decode(nA, nA.uint32());
  }, oA.prototype.verify = function(nA) {
    return this.setup().verify(nA);
  }, oA.prototype.fromObject = function(nA) {
    return this.setup().fromObject(nA);
  }, oA.prototype.toObject = function(nA, lA) {
    return this.setup().toObject(nA, lA);
  }, oA.d = function(nA) {
    return function(cA) {
      CA.decorateType(cA, nA);
    };
  }, type;
}
var root, hasRequiredRoot;
function requireRoot() {
  if (hasRequiredRoot) return root;
  hasRequiredRoot = 1, root = IA;
  var n = requireNamespace();
  ((IA.prototype = Object.create(n.prototype)).constructor = IA).className = "Root";
  var t = requireField(), g = require_enum(), d = requireOneof(), k = requireUtil(), H, AA, gA;
  function IA(iA) {
    n.call(this, "", iA), this.deferred = [], this.files = [], this._edition = "proto2", this._fullyQualifiedObjects = {};
  }
  IA.fromJSON = function(QA, tA) {
    return tA || (tA = new IA()), QA.options && tA.setOptions(QA.options), tA.addJSON(QA.nested).resolveAll();
  }, IA.prototype.resolvePath = k.path.resolve, IA.prototype.fetch = k.fetch;
  function CA() {
  }
  IA.prototype.load = function iA(QA, tA, oA) {
    typeof tA == "function" && (oA = tA, tA = void 0);
    var EA = this;
    if (!oA)
      return k.asPromise(iA, EA, QA, tA);
    var aA = oA === CA;
    function nA(dA, GA) {
      if (oA) {
        if (aA)
          throw dA;
        GA && GA.resolveAll();
        var DA = oA;
        oA = null, DA(dA, GA);
      }
    }
    function lA(dA) {
      var GA = dA.lastIndexOf("google/protobuf/");
      if (GA > -1) {
        var DA = dA.substring(GA);
        if (DA in gA) return DA;
      }
      return null;
    }
    function cA(dA, GA) {
      try {
        if (k.isString(GA) && GA.charAt(0) === "{" && (GA = JSON.parse(GA)), !k.isString(GA))
          EA.setOptions(GA.options).addJSON(GA.nested);
        else {
          AA.filename = dA;
          var DA = AA(GA, EA, tA), wA, bA = 0;
          if (DA.imports)
            for (; bA < DA.imports.length; ++bA)
              (wA = lA(DA.imports[bA]) || EA.resolvePath(dA, DA.imports[bA])) && sA(wA);
          if (DA.weakImports)
            for (bA = 0; bA < DA.weakImports.length; ++bA)
              (wA = lA(DA.weakImports[bA]) || EA.resolvePath(dA, DA.weakImports[bA])) && sA(wA, !0);
        }
      } catch (yA) {
        nA(yA);
      }
      !aA && !rA && nA(null, EA);
    }
    function sA(dA, GA) {
      if (dA = lA(dA) || dA, !(EA.files.indexOf(dA) > -1)) {
        if (EA.files.push(dA), dA in gA) {
          aA ? cA(dA, gA[dA]) : (++rA, setTimeout(function() {
            --rA, cA(dA, gA[dA]);
          }));
          return;
        }
        if (aA) {
          var DA;
          try {
            DA = k.fs.readFileSync(dA).toString("utf8");
          } catch (wA) {
            GA || nA(wA);
            return;
          }
          cA(dA, DA);
        } else
          ++rA, EA.fetch(dA, function(wA, bA) {
            if (--rA, !!oA) {
              if (wA) {
                GA ? rA || nA(null, EA) : nA(wA);
                return;
              }
              cA(dA, bA);
            }
          });
      }
    }
    var rA = 0;
    k.isString(QA) && (QA = [QA]);
    for (var uA = 0, hA; uA < QA.length; ++uA)
      (hA = EA.resolvePath("", QA[uA])) && sA(hA);
    return aA ? (EA.resolveAll(), EA) : (rA || nA(null, EA), EA);
  }, IA.prototype.loadSync = function(QA, tA) {
    if (!k.isNode)
      throw Error("not supported");
    return this.load(QA, tA, CA);
  }, IA.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    if (this.deferred.length)
      throw Error("unresolvable extensions: " + this.deferred.map(function(QA) {
        return "'extend " + QA.extend + "' in " + QA.parent.fullName;
      }).join(", "));
    return n.prototype.resolveAll.call(this);
  };
  var BA = /^[A-Z]/;
  function eA(iA, QA) {
    var tA = QA.parent.lookup(QA.extend);
    if (tA) {
      var oA = new t(QA.fullName, QA.id, QA.type, QA.rule, void 0, QA.options);
      return tA.get(oA.name) || (oA.declaringField = QA, QA.extensionField = oA, tA.add(oA)), !0;
    }
    return !1;
  }
  return IA.prototype._handleAdd = function(QA) {
    if (QA instanceof t)
      /* an extension field (implies not part of a oneof) */
      QA.extend !== void 0 && /* not already handled */
      !QA.extensionField && (eA(this, QA) || this.deferred.push(QA));
    else if (QA instanceof g)
      BA.test(QA.name) && (QA.parent[QA.name] = QA.values);
    else if (!(QA instanceof d)) {
      if (QA instanceof H)
        for (var tA = 0; tA < this.deferred.length; )
          eA(this, this.deferred[tA]) ? this.deferred.splice(tA, 1) : ++tA;
      for (var oA = 0; oA < /* initializes */
      QA.nestedArray.length; ++oA)
        this._handleAdd(QA._nestedArray[oA]);
      BA.test(QA.name) && (QA.parent[QA.name] = QA);
    }
    (QA instanceof H || QA instanceof g || QA instanceof t) && (this._fullyQualifiedObjects[QA.fullName] = QA);
  }, IA.prototype._handleRemove = function(QA) {
    if (QA instanceof t) {
      if (
        /* an extension field */
        QA.extend !== void 0
      )
        if (
          /* already handled */
          QA.extensionField
        )
          QA.extensionField.parent.remove(QA.extensionField), QA.extensionField = null;
        else {
          var tA = this.deferred.indexOf(QA);
          tA > -1 && this.deferred.splice(tA, 1);
        }
    } else if (QA instanceof g)
      BA.test(QA.name) && delete QA.parent[QA.name];
    else if (QA instanceof n) {
      for (var oA = 0; oA < /* initializes */
      QA.nestedArray.length; ++oA)
        this._handleRemove(QA._nestedArray[oA]);
      BA.test(QA.name) && delete QA.parent[QA.name];
    }
    delete this._fullyQualifiedObjects[QA.fullName];
  }, IA._configure = function(iA, QA, tA) {
    H = iA, AA = QA, gA = tA;
  }, root;
}
var hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util.exports;
  hasRequiredUtil = 1;
  var n = util.exports = requireMinimal$3(), t = requireRoots$1(), g, d;
  n.codegen = requireCodegen(), n.fetch = requireFetch(), n.path = requirePath(), n.fs = n.inquire("fs"), n.toArray = function(CA) {
    if (CA) {
      for (var BA = Object.keys(CA), eA = new Array(BA.length), iA = 0; iA < BA.length; )
        eA[iA] = CA[BA[iA++]];
      return eA;
    }
    return [];
  }, n.toObject = function(CA) {
    for (var BA = {}, eA = 0; eA < CA.length; ) {
      var iA = CA[eA++], QA = CA[eA++];
      QA !== void 0 && (BA[iA] = QA);
    }
    return BA;
  };
  var k = /\\/g, H = /"/g;
  n.isReserved = function(CA) {
    return /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/.test(CA);
  }, n.safeProp = function(CA) {
    return !/^[$\w_]+$/.test(CA) || n.isReserved(CA) ? '["' + CA.replace(k, "\\\\").replace(H, '\\"') + '"]' : "." + CA;
  }, n.ucFirst = function(CA) {
    return CA.charAt(0).toUpperCase() + CA.substring(1);
  };
  var AA = /_([a-z])/g;
  n.camelCase = function(CA) {
    return CA.substring(0, 1) + CA.substring(1).replace(AA, function(BA, eA) {
      return eA.toUpperCase();
    });
  }, n.compareFieldsById = function(CA, BA) {
    return CA.id - BA.id;
  }, n.decorateType = function(CA, BA) {
    if (CA.$type)
      return BA && CA.$type.name !== BA && (n.decorateRoot.remove(CA.$type), CA.$type.name = BA, n.decorateRoot.add(CA.$type)), CA.$type;
    g || (g = requireType());
    var eA = new g(BA || CA.name);
    return n.decorateRoot.add(eA), eA.ctor = CA, Object.defineProperty(CA, "$type", { value: eA, enumerable: !1 }), Object.defineProperty(CA.prototype, "$type", { value: eA, enumerable: !1 }), eA;
  };
  var gA = 0;
  return n.decorateEnum = function(CA) {
    if (CA.$type)
      return CA.$type;
    d || (d = require_enum());
    var BA = new d("Enum" + gA++, CA);
    return n.decorateRoot.add(BA), Object.defineProperty(CA, "$type", { value: BA, enumerable: !1 }), BA;
  }, n.setProperty = function(CA, BA, eA, iA) {
    function QA(tA, oA, EA) {
      var aA = oA.shift();
      if (aA === "__proto__" || aA === "prototype")
        return tA;
      if (oA.length > 0)
        tA[aA] = QA(tA[aA] || {}, oA, EA);
      else {
        var nA = tA[aA];
        if (nA && iA)
          return tA;
        nA && (EA = [].concat(nA).concat(EA)), tA[aA] = EA;
      }
      return tA;
    }
    if (typeof CA != "object")
      throw TypeError("dst must be an object");
    if (!BA)
      throw TypeError("path must be specified");
    return BA = BA.split("."), QA(CA, BA, eA);
  }, Object.defineProperty(n, "decorateRoot", {
    get: function() {
      return t.decorated || (t.decorated = new (requireRoot())());
    }
  }), util.exports;
}
var hasRequiredTypes;
function requireTypes() {
  return hasRequiredTypes || (hasRequiredTypes = 1, (function(n) {
    var t = n, g = requireUtil(), d = [
      "double",
      // 0
      "float",
      // 1
      "int32",
      // 2
      "uint32",
      // 3
      "sint32",
      // 4
      "fixed32",
      // 5
      "sfixed32",
      // 6
      "int64",
      // 7
      "uint64",
      // 8
      "sint64",
      // 9
      "fixed64",
      // 10
      "sfixed64",
      // 11
      "bool",
      // 12
      "string",
      // 13
      "bytes"
      // 14
    ];
    function k(H, AA) {
      var gA = 0, IA = {};
      for (AA |= 0; gA < H.length; ) IA[d[gA + AA]] = H[gA++];
      return IA;
    }
    t.basic = k([
      /* double   */
      1,
      /* float    */
      5,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0,
      /* string   */
      2,
      /* bytes    */
      2
    ]), t.defaults = k([
      /* double   */
      0,
      /* float    */
      0,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      0,
      /* sfixed32 */
      0,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      0,
      /* sfixed64 */
      0,
      /* bool     */
      !1,
      /* string   */
      "",
      /* bytes    */
      g.emptyArray,
      /* message  */
      null
    ]), t.long = k([
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1
    ], 7), t.mapKey = k([
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0,
      /* string   */
      2
    ], 2), t.packed = k([
      /* double   */
      1,
      /* float    */
      5,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0
    ]);
  })(types)), types;
}
var field, hasRequiredField;
function requireField() {
  if (hasRequiredField) return field;
  hasRequiredField = 1, field = AA;
  var n = requireObject();
  ((AA.prototype = Object.create(n.prototype)).constructor = AA).className = "Field";
  var t = require_enum(), g = requireTypes(), d = requireUtil(), k, H = /^required|optional|repeated$/;
  AA.fromJSON = function(IA, CA) {
    var BA = new AA(IA, CA.id, CA.type, CA.rule, CA.extend, CA.options, CA.comment);
    return CA.edition && (BA._edition = CA.edition), BA._defaultEdition = "proto3", BA;
  };
  function AA(gA, IA, CA, BA, eA, iA, QA) {
    if (d.isObject(BA) ? (QA = eA, iA = BA, BA = eA = void 0) : d.isObject(eA) && (QA = iA, iA = eA, eA = void 0), n.call(this, gA, iA), !d.isInteger(IA) || IA < 0)
      throw TypeError("id must be a non-negative integer");
    if (!d.isString(CA))
      throw TypeError("type must be a string");
    if (BA !== void 0 && !H.test(BA = BA.toString().toLowerCase()))
      throw TypeError("rule must be a string rule");
    if (eA !== void 0 && !d.isString(eA))
      throw TypeError("extend must be a string");
    BA === "proto3_optional" && (BA = "optional"), this.rule = BA && BA !== "optional" ? BA : void 0, this.type = CA, this.id = IA, this.extend = eA || void 0, this.repeated = BA === "repeated", this.map = !1, this.message = null, this.partOf = null, this.typeDefault = null, this.defaultValue = null, this.long = d.Long ? g.long[CA] !== void 0 : (
      /* istanbul ignore next */
      !1
    ), this.bytes = CA === "bytes", this.resolvedType = null, this.extensionField = null, this.declaringField = null, this.comment = QA;
  }
  return Object.defineProperty(AA.prototype, "required", {
    get: function() {
      return this._features.field_presence === "LEGACY_REQUIRED";
    }
  }), Object.defineProperty(AA.prototype, "optional", {
    get: function() {
      return !this.required;
    }
  }), Object.defineProperty(AA.prototype, "delimited", {
    get: function() {
      return this.resolvedType instanceof k && this._features.message_encoding === "DELIMITED";
    }
  }), Object.defineProperty(AA.prototype, "packed", {
    get: function() {
      return this._features.repeated_field_encoding === "PACKED";
    }
  }), Object.defineProperty(AA.prototype, "hasPresence", {
    get: function() {
      return this.repeated || this.map ? !1 : this.partOf || // oneofs
      this.declaringField || this.extensionField || // extensions
      this._features.field_presence !== "IMPLICIT";
    }
  }), AA.prototype.setOption = function(IA, CA, BA) {
    return n.prototype.setOption.call(this, IA, CA, BA);
  }, AA.prototype.toJSON = function(IA) {
    var CA = IA ? !!IA.keepComments : !1;
    return d.toObject([
      "edition",
      this._editionToJSON(),
      "rule",
      this.rule !== "optional" && this.rule || void 0,
      "type",
      this.type,
      "id",
      this.id,
      "extend",
      this.extend,
      "options",
      this.options,
      "comment",
      CA ? this.comment : void 0
    ]);
  }, AA.prototype.resolve = function() {
    if (this.resolved)
      return this;
    if ((this.typeDefault = g.defaults[this.type]) === void 0 ? (this.resolvedType = (this.declaringField ? this.declaringField.parent : this.parent).lookupTypeOrEnum(this.type), this.resolvedType instanceof k ? this.typeDefault = null : this.typeDefault = this.resolvedType.values[Object.keys(this.resolvedType.values)[0]]) : this.options && this.options.proto3_optional && (this.typeDefault = null), this.options && this.options.default != null && (this.typeDefault = this.options.default, this.resolvedType instanceof t && typeof this.typeDefault == "string" && (this.typeDefault = this.resolvedType.values[this.typeDefault])), this.options && (this.options.packed !== void 0 && this.resolvedType && !(this.resolvedType instanceof t) && delete this.options.packed, Object.keys(this.options).length || (this.options = void 0)), this.long)
      this.typeDefault = d.Long.fromNumber(this.typeDefault, this.type.charAt(0) === "u"), Object.freeze && Object.freeze(this.typeDefault);
    else if (this.bytes && typeof this.typeDefault == "string") {
      var IA;
      d.base64.test(this.typeDefault) ? d.base64.decode(this.typeDefault, IA = d.newBuffer(d.base64.length(this.typeDefault)), 0) : d.utf8.write(this.typeDefault, IA = d.newBuffer(d.utf8.length(this.typeDefault)), 0), this.typeDefault = IA;
    }
    return this.map ? this.defaultValue = d.emptyObject : this.repeated ? this.defaultValue = d.emptyArray : this.defaultValue = this.typeDefault, this.parent instanceof k && (this.parent.ctor.prototype[this.name] = this.defaultValue), n.prototype.resolve.call(this);
  }, AA.prototype._inferLegacyProtoFeatures = function(IA) {
    if (IA !== "proto2" && IA !== "proto3")
      return {};
    var CA = {};
    if (this.rule === "required" && (CA.field_presence = "LEGACY_REQUIRED"), this.parent && g.defaults[this.type] === void 0) {
      var BA = this.parent.get(this.type.split(".").pop());
      BA && BA instanceof k && BA.group && (CA.message_encoding = "DELIMITED");
    }
    return this.getOption("packed") === !0 ? CA.repeated_field_encoding = "PACKED" : this.getOption("packed") === !1 && (CA.repeated_field_encoding = "EXPANDED"), CA;
  }, AA.prototype._resolveFeatures = function(IA) {
    return n.prototype._resolveFeatures.call(this, this._edition || IA);
  }, AA.d = function(IA, CA, BA, eA) {
    return typeof CA == "function" ? CA = d.decorateType(CA).name : CA && typeof CA == "object" && (CA = d.decorateEnum(CA).name), function(QA, tA) {
      d.decorateType(QA.constructor).add(new AA(tA, IA, CA, BA, { default: eA }));
    };
  }, AA._configure = function(IA) {
    k = IA;
  }, field;
}
var oneof, hasRequiredOneof;
function requireOneof() {
  if (hasRequiredOneof) return oneof;
  hasRequiredOneof = 1, oneof = d;
  var n = requireObject();
  ((d.prototype = Object.create(n.prototype)).constructor = d).className = "OneOf";
  var t = requireField(), g = requireUtil();
  function d(H, AA, gA, IA) {
    if (Array.isArray(AA) || (gA = AA, AA = void 0), n.call(this, H, gA), !(AA === void 0 || Array.isArray(AA)))
      throw TypeError("fieldNames must be an Array");
    this.oneof = AA || [], this.fieldsArray = [], this.comment = IA;
  }
  d.fromJSON = function(AA, gA) {
    return new d(AA, gA.oneof, gA.options, gA.comment);
  }, d.prototype.toJSON = function(AA) {
    var gA = AA ? !!AA.keepComments : !1;
    return g.toObject([
      "options",
      this.options,
      "oneof",
      this.oneof,
      "comment",
      gA ? this.comment : void 0
    ]);
  };
  function k(H) {
    if (H.parent)
      for (var AA = 0; AA < H.fieldsArray.length; ++AA)
        H.fieldsArray[AA].parent || H.parent.add(H.fieldsArray[AA]);
  }
  return d.prototype.add = function(AA) {
    if (!(AA instanceof t))
      throw TypeError("field must be a Field");
    return AA.parent && AA.parent !== this.parent && AA.parent.remove(AA), this.oneof.push(AA.name), this.fieldsArray.push(AA), AA.partOf = this, k(this), this;
  }, d.prototype.remove = function(AA) {
    if (!(AA instanceof t))
      throw TypeError("field must be a Field");
    var gA = this.fieldsArray.indexOf(AA);
    if (gA < 0)
      throw Error(AA + " is not a member of " + this);
    return this.fieldsArray.splice(gA, 1), gA = this.oneof.indexOf(AA.name), gA > -1 && this.oneof.splice(gA, 1), AA.partOf = null, this;
  }, d.prototype.onAdd = function(AA) {
    n.prototype.onAdd.call(this, AA);
    for (var gA = this, IA = 0; IA < this.oneof.length; ++IA) {
      var CA = AA.get(this.oneof[IA]);
      CA && !CA.partOf && (CA.partOf = gA, gA.fieldsArray.push(CA));
    }
    k(this);
  }, d.prototype.onRemove = function(AA) {
    for (var gA = 0, IA; gA < this.fieldsArray.length; ++gA)
      (IA = this.fieldsArray[gA]).parent && IA.parent.remove(IA);
    n.prototype.onRemove.call(this, AA);
  }, Object.defineProperty(d.prototype, "isProto3Optional", {
    get: function() {
      if (this.fieldsArray == null || this.fieldsArray.length !== 1)
        return !1;
      var H = this.fieldsArray[0];
      return H.options != null && H.options.proto3_optional === !0;
    }
  }), d.d = function() {
    for (var AA = new Array(arguments.length), gA = 0; gA < arguments.length; )
      AA[gA] = arguments[gA++];
    return function(CA, BA) {
      g.decorateType(CA.constructor).add(new d(BA, AA)), Object.defineProperty(CA, BA, {
        get: g.oneOfGetter(AA),
        set: g.oneOfSetter(AA)
      });
    };
  }, oneof;
}
var object, hasRequiredObject;
function requireObject() {
  if (hasRequiredObject) return object;
  hasRequiredObject = 1, object = AA, AA.className = "ReflectionObject";
  const n = requireOneof();
  var t = requireUtil(), g, d = { enum_type: "OPEN", field_presence: "EXPLICIT", json_format: "ALLOW", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "PACKED", utf8_validation: "VERIFY" }, k = { enum_type: "CLOSED", field_presence: "EXPLICIT", json_format: "LEGACY_BEST_EFFORT", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "EXPANDED", utf8_validation: "NONE" }, H = { enum_type: "OPEN", field_presence: "IMPLICIT", json_format: "ALLOW", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "PACKED", utf8_validation: "VERIFY" };
  function AA(gA, IA) {
    if (!t.isString(gA))
      throw TypeError("name must be a string");
    if (IA && !t.isObject(IA))
      throw TypeError("options must be an object");
    this.options = IA, this.parsedOptions = null, this.name = gA, this._edition = null, this._defaultEdition = "proto2", this._features = {}, this._featuresResolved = !1, this.parent = null, this.resolved = !1, this.comment = null, this.filename = null;
  }
  return Object.defineProperties(AA.prototype, {
    /**
     * Reference to the root namespace.
     * @name ReflectionObject#root
     * @type {Root}
     * @readonly
     */
    root: {
      get: function() {
        for (var gA = this; gA.parent !== null; )
          gA = gA.parent;
        return gA;
      }
    },
    /**
     * Full name including leading dot.
     * @name ReflectionObject#fullName
     * @type {string}
     * @readonly
     */
    fullName: {
      get: function() {
        for (var gA = [this.name], IA = this.parent; IA; )
          gA.unshift(IA.name), IA = IA.parent;
        return gA.join(".");
      }
    }
  }), AA.prototype.toJSON = /* istanbul ignore next */
  function() {
    throw Error();
  }, AA.prototype.onAdd = function(IA) {
    this.parent && this.parent !== IA && this.parent.remove(this), this.parent = IA, this.resolved = !1;
    var CA = IA.root;
    CA instanceof g && CA._handleAdd(this);
  }, AA.prototype.onRemove = function(IA) {
    var CA = IA.root;
    CA instanceof g && CA._handleRemove(this), this.parent = null, this.resolved = !1;
  }, AA.prototype.resolve = function() {
    return this.resolved ? this : (this.root instanceof g && (this.resolved = !0), this);
  }, AA.prototype._resolveFeaturesRecursive = function(IA) {
    return this._resolveFeatures(this._edition || IA);
  }, AA.prototype._resolveFeatures = function(IA) {
    if (!this._featuresResolved) {
      var CA = {};
      if (!IA)
        throw new Error("Unknown edition for " + this.fullName);
      var BA = Object.assign(
        this.options ? Object.assign({}, this.options.features) : {},
        this._inferLegacyProtoFeatures(IA)
      );
      if (this._edition) {
        if (IA === "proto2")
          CA = Object.assign({}, k);
        else if (IA === "proto3")
          CA = Object.assign({}, H);
        else if (IA === "2023")
          CA = Object.assign({}, d);
        else
          throw new Error("Unknown edition: " + IA);
        this._features = Object.assign(CA, BA || {}), this._featuresResolved = !0;
        return;
      }
      if (this.partOf instanceof n) {
        var eA = Object.assign({}, this.partOf._features);
        this._features = Object.assign(eA, BA || {});
      } else if (!this.declaringField) if (this.parent) {
        var iA = Object.assign({}, this.parent._features);
        this._features = Object.assign(iA, BA || {});
      } else
        throw new Error("Unable to find a parent for " + this.fullName);
      this.extensionField && (this.extensionField._features = this._features), this._featuresResolved = !0;
    }
  }, AA.prototype._inferLegacyProtoFeatures = function() {
    return {};
  }, AA.prototype.getOption = function(IA) {
    if (this.options)
      return this.options[IA];
  }, AA.prototype.setOption = function(IA, CA, BA) {
    return this.options || (this.options = {}), /^features\./.test(IA) ? t.setProperty(this.options, IA, CA, BA) : (!BA || this.options[IA] === void 0) && (this.getOption(IA) !== CA && (this.resolved = !1), this.options[IA] = CA), this;
  }, AA.prototype.setParsedOption = function(IA, CA, BA) {
    this.parsedOptions || (this.parsedOptions = []);
    var eA = this.parsedOptions;
    if (BA) {
      var iA = eA.find(function(oA) {
        return Object.prototype.hasOwnProperty.call(oA, IA);
      });
      if (iA) {
        var QA = iA[IA];
        t.setProperty(QA, BA, CA);
      } else
        iA = {}, iA[IA] = t.setProperty({}, BA, CA), eA.push(iA);
    } else {
      var tA = {};
      tA[IA] = CA, eA.push(tA);
    }
    return this;
  }, AA.prototype.setOptions = function(IA, CA) {
    if (IA)
      for (var BA = Object.keys(IA), eA = 0; eA < BA.length; ++eA)
        this.setOption(BA[eA], IA[BA[eA]], CA);
    return this;
  }, AA.prototype.toString = function() {
    var IA = this.constructor.className, CA = this.fullName;
    return CA.length ? IA + " " + CA : IA;
  }, AA.prototype._editionToJSON = function() {
    if (!(!this._edition || this._edition === "proto3"))
      return this._edition;
  }, AA._configure = function(gA) {
    g = gA;
  }, object;
}
var _enum, hasRequired_enum;
function require_enum() {
  if (hasRequired_enum) return _enum;
  hasRequired_enum = 1, _enum = d;
  var n = requireObject();
  ((d.prototype = Object.create(n.prototype)).constructor = d).className = "Enum";
  var t = requireNamespace(), g = requireUtil();
  function d(k, H, AA, gA, IA, CA) {
    if (n.call(this, k, AA), H && typeof H != "object")
      throw TypeError("values must be an object");
    if (this.valuesById = {}, this.values = Object.create(this.valuesById), this.comment = gA, this.comments = IA || {}, this.valuesOptions = CA, this._valuesFeatures = {}, this.reserved = void 0, H)
      for (var BA = Object.keys(H), eA = 0; eA < BA.length; ++eA)
        typeof H[BA[eA]] == "number" && (this.valuesById[this.values[BA[eA]] = H[BA[eA]]] = BA[eA]);
  }
  return d.prototype._resolveFeatures = function(H) {
    return H = this._edition || H, n.prototype._resolveFeatures.call(this, H), Object.keys(this.values).forEach((AA) => {
      var gA = Object.assign({}, this._features);
      this._valuesFeatures[AA] = Object.assign(gA, this.valuesOptions && this.valuesOptions[AA] && this.valuesOptions[AA].features);
    }), this;
  }, d.fromJSON = function(H, AA) {
    var gA = new d(H, AA.values, AA.options, AA.comment, AA.comments);
    return gA.reserved = AA.reserved, AA.edition && (gA._edition = AA.edition), gA._defaultEdition = "proto3", gA;
  }, d.prototype.toJSON = function(H) {
    var AA = H ? !!H.keepComments : !1;
    return g.toObject([
      "edition",
      this._editionToJSON(),
      "options",
      this.options,
      "valuesOptions",
      this.valuesOptions,
      "values",
      this.values,
      "reserved",
      this.reserved && this.reserved.length ? this.reserved : void 0,
      "comment",
      AA ? this.comment : void 0,
      "comments",
      AA ? this.comments : void 0
    ]);
  }, d.prototype.add = function(H, AA, gA, IA) {
    if (!g.isString(H))
      throw TypeError("name must be a string");
    if (!g.isInteger(AA))
      throw TypeError("id must be an integer");
    if (this.values[H] !== void 0)
      throw Error("duplicate name '" + H + "' in " + this);
    if (this.isReservedId(AA))
      throw Error("id " + AA + " is reserved in " + this);
    if (this.isReservedName(H))
      throw Error("name '" + H + "' is reserved in " + this);
    if (this.valuesById[AA] !== void 0) {
      if (!(this.options && this.options.allow_alias))
        throw Error("duplicate id " + AA + " in " + this);
      this.values[H] = AA;
    } else
      this.valuesById[this.values[H] = AA] = H;
    return IA && (this.valuesOptions === void 0 && (this.valuesOptions = {}), this.valuesOptions[H] = IA || null), this.comments[H] = gA || null, this;
  }, d.prototype.remove = function(H) {
    if (!g.isString(H))
      throw TypeError("name must be a string");
    var AA = this.values[H];
    if (AA == null)
      throw Error("name '" + H + "' does not exist in " + this);
    return delete this.valuesById[AA], delete this.values[H], delete this.comments[H], this.valuesOptions && delete this.valuesOptions[H], this;
  }, d.prototype.isReservedId = function(H) {
    return t.isReservedId(this.reserved, H);
  }, d.prototype.isReservedName = function(H) {
    return t.isReservedName(this.reserved, H);
  }, _enum;
}
var encoder_1, hasRequiredEncoder;
function requireEncoder() {
  if (hasRequiredEncoder) return encoder_1;
  hasRequiredEncoder = 1, encoder_1 = k;
  var n = require_enum(), t = requireTypes(), g = requireUtil();
  function d(H, AA, gA, IA) {
    return AA.delimited ? H("types[%i].encode(%s,w.uint32(%i)).uint32(%i)", gA, IA, (AA.id << 3 | 3) >>> 0, (AA.id << 3 | 4) >>> 0) : H("types[%i].encode(%s,w.uint32(%i).fork()).ldelim()", gA, IA, (AA.id << 3 | 2) >>> 0);
  }
  function k(H) {
    for (var AA = g.codegen(["m", "w"], H.name + "$encode")("if(!w)")("w=Writer.create()"), gA, IA, CA = (
      /* initializes */
      H.fieldsArray.slice().sort(g.compareFieldsById)
    ), gA = 0; gA < CA.length; ++gA) {
      var BA = CA[gA].resolve(), eA = H._fieldsArray.indexOf(BA), iA = BA.resolvedType instanceof n ? "int32" : BA.type, QA = t.basic[iA];
      IA = "m" + g.safeProp(BA.name), BA.map ? (AA("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", IA, BA.name)("for(var ks=Object.keys(%s),i=0;i<ks.length;++i){", IA)("w.uint32(%i).fork().uint32(%i).%s(ks[i])", (BA.id << 3 | 2) >>> 0, 8 | t.mapKey[BA.keyType], BA.keyType), QA === void 0 ? AA("types[%i].encode(%s[ks[i]],w.uint32(18).fork()).ldelim().ldelim()", eA, IA) : AA(".uint32(%i).%s(%s[ks[i]]).ldelim()", 16 | QA, iA, IA), AA("}")("}")) : BA.repeated ? (AA("if(%s!=null&&%s.length){", IA, IA), BA.packed && t.packed[iA] !== void 0 ? AA("w.uint32(%i).fork()", (BA.id << 3 | 2) >>> 0)("for(var i=0;i<%s.length;++i)", IA)("w.%s(%s[i])", iA, IA)("w.ldelim()") : (AA("for(var i=0;i<%s.length;++i)", IA), QA === void 0 ? d(AA, BA, eA, IA + "[i]") : AA("w.uint32(%i).%s(%s[i])", (BA.id << 3 | QA) >>> 0, iA, IA)), AA("}")) : (BA.optional && AA("if(%s!=null&&Object.hasOwnProperty.call(m,%j))", IA, BA.name), QA === void 0 ? d(AA, BA, eA, IA) : AA("w.uint32(%i).%s(%s)", (BA.id << 3 | QA) >>> 0, iA, IA));
    }
    return AA("return w");
  }
  return encoder_1;
}
var hasRequiredIndexLight;
function requireIndexLight() {
  if (hasRequiredIndexLight) return indexLight.exports;
  hasRequiredIndexLight = 1;
  var n = indexLight.exports = requireIndexMinimal$1();
  n.build = "light";
  function t(d, k, H) {
    return typeof k == "function" ? (H = k, k = new n.Root()) : k || (k = new n.Root()), k.load(d, H);
  }
  n.load = t;
  function g(d, k) {
    return k || (k = new n.Root()), k.loadSync(d);
  }
  return n.loadSync = g, n.encoder = requireEncoder(), n.decoder = requireDecoder(), n.verifier = requireVerifier(), n.converter = requireConverter(), n.ReflectionObject = requireObject(), n.Namespace = requireNamespace(), n.Root = requireRoot(), n.Enum = require_enum(), n.Type = requireType(), n.Field = requireField(), n.OneOf = requireOneof(), n.MapField = requireMapfield(), n.Service = requireService(), n.Method = requireMethod(), n.Message = requireMessage(), n.wrappers = requireWrappers(), n.types = requireTypes(), n.util = requireUtil(), n.ReflectionObject._configure(n.Root), n.Namespace._configure(n.Type, n.Service, n.Enum), n.Root._configure(n.Type), n.Field._configure(n.Type), indexLight.exports;
}
var tokenize_1, hasRequiredTokenize;
function requireTokenize() {
  if (hasRequiredTokenize) return tokenize_1;
  hasRequiredTokenize = 1, tokenize_1 = BA;
  var n = /[\s{}=;:[\],'"()<>]/g, t = /(?:"([^"\\]*(?:\\.[^"\\]*)*)")/g, g = /(?:'([^'\\]*(?:\\.[^'\\]*)*)')/g, d = /^ *[*/]+ */, k = /^\s*\*?\/*/, H = /\n/g, AA = /\s/, gA = /\\(.?)/g, IA = {
    0: "\0",
    r: "\r",
    n: `
`,
    t: "	"
  };
  function CA(eA) {
    return eA.replace(gA, function(iA, QA) {
      switch (QA) {
        case "\\":
        case "":
          return QA;
        default:
          return IA[QA] || "";
      }
    });
  }
  BA.unescape = CA;
  function BA(eA, iA) {
    eA = eA.toString();
    var QA = 0, tA = eA.length, oA = 1, EA = 0, aA = {}, nA = [], lA = null;
    function cA(pA) {
      return Error("illegal " + pA + " (line " + oA + ")");
    }
    function sA() {
      var pA = lA === "'" ? g : t;
      pA.lastIndex = QA - 1;
      var MA = pA.exec(eA);
      if (!MA)
        throw cA("string");
      return QA = pA.lastIndex, DA(lA), lA = null, CA(MA[1]);
    }
    function rA(pA) {
      return eA.charAt(pA);
    }
    function uA(pA, MA, LA) {
      var xA = {
        type: eA.charAt(pA++),
        lineEmpty: !1,
        leading: LA
      }, TA;
      iA ? TA = 2 : TA = 3;
      var NA = pA - TA, zA;
      do
        if (--NA < 0 || (zA = eA.charAt(NA)) === `
`) {
          xA.lineEmpty = !0;
          break;
        }
      while (zA === " " || zA === "	");
      for (var XA = eA.substring(pA, MA).split(H), fA = 0; fA < XA.length; ++fA)
        XA[fA] = XA[fA].replace(iA ? k : d, "").trim();
      xA.text = XA.join(`
`).trim(), aA[oA] = xA, EA = oA;
    }
    function hA(pA) {
      var MA = dA(pA), LA = eA.substring(pA, MA), xA = /^\s*\/\//.test(LA);
      return xA;
    }
    function dA(pA) {
      for (var MA = pA; MA < tA && rA(MA) !== `
`; )
        MA++;
      return MA;
    }
    function GA() {
      if (nA.length > 0)
        return nA.shift();
      if (lA)
        return sA();
      var pA, MA, LA, xA, TA, NA = QA === 0;
      do {
        if (QA === tA)
          return null;
        for (pA = !1; AA.test(LA = rA(QA)); )
          if (LA === `
` && (NA = !0, ++oA), ++QA === tA)
            return null;
        if (rA(QA) === "/") {
          if (++QA === tA)
            throw cA("comment");
          if (rA(QA) === "/")
            if (iA) {
              if (xA = QA, TA = !1, hA(QA - 1)) {
                TA = !0;
                do
                  if (QA = dA(QA), QA === tA || (QA++, !NA))
                    break;
                while (hA(QA));
              } else
                QA = Math.min(tA, dA(QA) + 1);
              TA && (uA(xA, QA, NA), NA = !0), oA++, pA = !0;
            } else {
              for (TA = rA(xA = QA + 1) === "/"; rA(++QA) !== `
`; )
                if (QA === tA)
                  return null;
              ++QA, TA && (uA(xA, QA - 1, NA), NA = !0), ++oA, pA = !0;
            }
          else if ((LA = rA(QA)) === "*") {
            xA = QA + 1, TA = iA || rA(xA) === "*";
            do {
              if (LA === `
` && ++oA, ++QA === tA)
                throw cA("comment");
              MA = LA, LA = rA(QA);
            } while (MA !== "*" || LA !== "/");
            ++QA, TA && (uA(xA, QA - 2, NA), NA = !0), pA = !0;
          } else
            return "/";
        }
      } while (pA);
      var zA = QA;
      n.lastIndex = 0;
      var XA = n.test(rA(zA++));
      if (!XA)
        for (; zA < tA && !n.test(rA(zA)); )
          ++zA;
      var fA = eA.substring(QA, QA = zA);
      return (fA === '"' || fA === "'") && (lA = fA), fA;
    }
    function DA(pA) {
      nA.push(pA);
    }
    function wA() {
      if (!nA.length) {
        var pA = GA();
        if (pA === null)
          return null;
        DA(pA);
      }
      return nA[0];
    }
    function bA(pA, MA) {
      var LA = wA(), xA = LA === pA;
      if (xA)
        return GA(), !0;
      if (!MA)
        throw cA("token '" + LA + "', '" + pA + "' expected");
      return !1;
    }
    function yA(pA) {
      var MA = null, LA;
      return pA === void 0 ? (LA = aA[oA - 1], delete aA[oA - 1], LA && (iA || LA.type === "*" || LA.lineEmpty) && (MA = LA.leading ? LA.text : null)) : (EA < pA && wA(), LA = aA[pA], delete aA[pA], LA && !LA.lineEmpty && (iA || LA.type === "/") && (MA = LA.leading ? null : LA.text)), MA;
    }
    return Object.defineProperty({
      next: GA,
      peek: wA,
      push: DA,
      skip: bA,
      cmnt: yA
    }, "line", {
      get: function() {
        return oA;
      }
    });
  }
  return tokenize_1;
}
var parse_1, hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse_1;
  hasRequiredParse = 1, parse_1 = sA, sA.filename = null, sA.defaults = { keepCase: !1 };
  var n = requireTokenize(), t = requireRoot(), g = requireType(), d = requireField(), k = requireMapfield(), H = requireOneof(), AA = require_enum(), gA = requireService(), IA = requireMethod(), CA = requireObject(), BA = requireTypes(), eA = requireUtil(), iA = /^[1-9][0-9]*$/, QA = /^-?[1-9][0-9]*$/, tA = /^0[x][0-9a-fA-F]+$/, oA = /^-?0[x][0-9a-fA-F]+$/, EA = /^0[0-7]+$/, aA = /^-?0[0-7]+$/, nA = /^(?![eE])[0-9]*(?:\.[0-9]*)?(?:[eE][+-]?[0-9]+)?$/, lA = /^[a-zA-Z_][a-zA-Z_0-9]*$/, cA = /^(?:\.?[a-zA-Z_][a-zA-Z_0-9]*)(?:\.[a-zA-Z_][a-zA-Z_0-9]*)*$/;
  function sA(rA, uA, hA) {
    uA instanceof t || (hA = uA, uA = new t()), hA || (hA = sA.defaults);
    var dA = hA.preferTrailingComment || !1, GA = n(rA, hA.alternateCommentMode || !1), DA = GA.next, wA = GA.push, bA = GA.peek, yA = GA.skip, pA = GA.cmnt, MA = !0, LA, xA, TA, NA = "proto2", zA = uA, XA = [], fA = {}, vA = hA.keepCase ? function(tg) {
      return tg;
    } : eA.camelCase;
    function Cg() {
      XA.forEach((tg) => {
        tg._edition = NA, Object.keys(fA).forEach((Eg) => {
          tg.getOption(Eg) === void 0 && tg.setOption(Eg, fA[Eg], !0);
        });
      });
    }
    function Ig(tg, Eg, cg) {
      var sg = sA.filename;
      return cg || (sA.filename = null), Error("illegal " + (Eg || "token") + " '" + tg + "' (" + (sg ? sg + ", " : "") + "line " + GA.line + ")");
    }
    function gg() {
      var tg = [], Eg;
      do {
        if ((Eg = DA()) !== '"' && Eg !== "'")
          throw Ig(Eg);
        tg.push(DA()), yA(Eg), Eg = bA();
      } while (Eg === '"' || Eg === "'");
      return tg.join("");
    }
    function og(tg) {
      var Eg = DA();
      switch (Eg) {
        case "'":
        case '"':
          return wA(Eg), gg();
        case "true":
        case "TRUE":
          return !0;
        case "false":
        case "FALSE":
          return !1;
      }
      try {
        return kA(
          Eg,
          /* insideTryCatch */
          !0
        );
      } catch {
        if (cA.test(Eg))
          return Eg;
        throw Ig(Eg, "value");
      }
    }
    function eg(tg, Eg) {
      var cg, sg;
      do
        if (Eg && ((cg = bA()) === '"' || cg === "'")) {
          var ug = gg();
          if (tg.push(ug), NA >= 2023)
            throw Ig(ug, "id");
        } else
          try {
            tg.push([sg = YA(DA()), yA("to", !0) ? YA(DA()) : sg]);
          } catch (Rg) {
            if (Eg && cA.test(cg) && NA >= 2023)
              tg.push(cg);
            else
              throw Rg;
          }
      while (yA(",", !0));
      var Mg = { options: void 0 };
      Mg.setOption = function(Rg, Jg) {
        this.options === void 0 && (this.options = {}), this.options[Rg] = Jg;
      }, HA(
        Mg,
        function(Jg) {
          if (Jg === "option")
            ig(Mg, Jg), yA(";");
          else
            throw Ig(Jg);
        },
        function() {
          ag(Mg);
        }
      );
    }
    function kA(tg, Eg) {
      var cg = 1;
      switch (tg.charAt(0) === "-" && (cg = -1, tg = tg.substring(1)), tg) {
        case "inf":
        case "INF":
        case "Inf":
          return cg * (1 / 0);
        case "nan":
        case "NAN":
        case "Nan":
        case "NaN":
          return NaN;
        case "0":
          return 0;
      }
      if (iA.test(tg))
        return cg * parseInt(tg, 10);
      if (tA.test(tg))
        return cg * parseInt(tg, 16);
      if (EA.test(tg))
        return cg * parseInt(tg, 8);
      if (nA.test(tg))
        return cg * parseFloat(tg);
      throw Ig(tg, "number", Eg);
    }
    function YA(tg, Eg) {
      switch (tg) {
        case "max":
        case "MAX":
        case "Max":
          return 536870911;
        case "0":
          return 0;
      }
      if (!Eg && tg.charAt(0) === "-")
        throw Ig(tg, "id");
      if (QA.test(tg))
        return parseInt(tg, 10);
      if (oA.test(tg))
        return parseInt(tg, 16);
      if (aA.test(tg))
        return parseInt(tg, 8);
      throw Ig(tg, "id");
    }
    function RA() {
      if (LA !== void 0)
        throw Ig("package");
      if (LA = DA(), !cA.test(LA))
        throw Ig(LA, "name");
      zA = zA.define(LA), yA(";");
    }
    function FA() {
      var tg = bA(), Eg;
      switch (tg) {
        case "weak":
          Eg = TA || (TA = []), DA();
          break;
        case "public":
          DA();
        // eslint-disable-next-line no-fallthrough
        default:
          Eg = xA || (xA = []);
          break;
      }
      tg = gg(), yA(";"), Eg.push(tg);
    }
    function mA() {
      if (yA("="), NA = gg(), NA < 2023)
        throw Ig(NA, "syntax");
      yA(";");
    }
    function JA() {
      if (yA("="), NA = gg(), !["2023"].includes(NA))
        throw Ig(NA, "edition");
      yA(";");
    }
    function VA(tg, Eg) {
      switch (Eg) {
        case "option":
          return ig(tg, Eg), yA(";"), !0;
        case "message":
          return jA(tg, Eg), !0;
        case "enum":
          return Dg(tg, Eg), !0;
        case "service":
          return Gg(tg, Eg), !0;
        case "extend":
          return yg(tg, Eg), !0;
      }
      return !1;
    }
    function HA(tg, Eg, cg) {
      var sg = GA.line;
      if (tg && (typeof tg.comment != "string" && (tg.comment = pA()), tg.filename = sA.filename), yA("{", !0)) {
        for (var ug; (ug = DA()) !== "}"; )
          Eg(ug);
        yA(";", !0);
      } else
        cg && cg(), yA(";"), tg && (typeof tg.comment != "string" || dA) && (tg.comment = pA(sg) || tg.comment);
    }
    function jA(tg, Eg) {
      if (!lA.test(Eg = DA()))
        throw Ig(Eg, "type name");
      var cg = new g(Eg);
      HA(cg, function(ug) {
        if (!VA(cg, ug))
          switch (ug) {
            case "map":
              rg(cg);
              break;
            case "required":
              if (NA !== "proto2")
                throw Ig(ug);
            /* eslint-disable no-fallthrough */
            case "repeated":
              _A(cg, ug);
              break;
            case "optional":
              if (NA === "proto3")
                _A(cg, "proto3_optional");
              else {
                if (NA !== "proto2")
                  throw Ig(ug);
                _A(cg, "optional");
              }
              break;
            case "oneof":
              wg(cg, ug);
              break;
            case "extensions":
              eg(cg.extensions || (cg.extensions = []));
              break;
            case "reserved":
              eg(cg.reserved || (cg.reserved = []), !0);
              break;
            default:
              if (NA === "proto2" || !cA.test(ug))
                throw Ig(ug);
              wA(ug), _A(cg, "optional");
              break;
          }
      }), tg.add(cg), tg === zA && XA.push(cg);
    }
    function _A(tg, Eg, cg) {
      var sg = DA();
      if (sg === "group") {
        $A(tg, Eg);
        return;
      }
      for (; sg.endsWith(".") || bA().startsWith("."); )
        sg += DA();
      if (!cA.test(sg))
        throw Ig(sg, "type");
      var ug = DA();
      if (!lA.test(ug))
        throw Ig(ug, "name");
      ug = vA(ug), yA("=");
      var Mg = new d(ug, YA(DA()), sg, Eg, cg);
      if (HA(Mg, function(Hg) {
        if (Hg === "option")
          ig(Mg, Hg), yA(";");
        else
          throw Ig(Hg);
      }, function() {
        ag(Mg);
      }), Eg === "proto3_optional") {
        var Rg = new H("_" + ug);
        Mg.setOption("proto3_optional", !0), Rg.add(Mg), tg.add(Rg);
      } else
        tg.add(Mg);
      tg === zA && XA.push(Mg);
    }
    function $A(tg, Eg) {
      if (NA >= 2023)
        throw Ig("group");
      var cg = DA();
      if (!lA.test(cg))
        throw Ig(cg, "name");
      var sg = eA.lcFirst(cg);
      cg === sg && (cg = eA.ucFirst(cg)), yA("=");
      var ug = YA(DA()), Mg = new g(cg);
      Mg.group = !0;
      var Rg = new d(sg, ug, cg, Eg);
      Rg.filename = sA.filename, HA(Mg, function(Hg) {
        switch (Hg) {
          case "option":
            ig(Mg, Hg), yA(";");
            break;
          case "required":
          case "repeated":
            _A(Mg, Hg);
            break;
          case "optional":
            NA === "proto3" ? _A(Mg, "proto3_optional") : _A(Mg, "optional");
            break;
          case "message":
            jA(Mg, Hg);
            break;
          case "enum":
            Dg(Mg, Hg);
            break;
          case "reserved":
            eg(Mg.reserved || (Mg.reserved = []), !0);
            break;
          /* istanbul ignore next */
          default:
            throw Ig(Hg);
        }
      }), tg.add(Mg).add(Rg);
    }
    function rg(tg) {
      yA("<");
      var Eg = DA();
      if (BA.mapKey[Eg] === void 0)
        throw Ig(Eg, "type");
      yA(",");
      var cg = DA();
      if (!cA.test(cg))
        throw Ig(cg, "type");
      yA(">");
      var sg = DA();
      if (!lA.test(sg))
        throw Ig(sg, "name");
      yA("=");
      var ug = new k(vA(sg), YA(DA()), Eg, cg);
      HA(ug, function(Rg) {
        if (Rg === "option")
          ig(ug, Rg), yA(";");
        else
          throw Ig(Rg);
      }, function() {
        ag(ug);
      }), tg.add(ug);
    }
    function wg(tg, Eg) {
      if (!lA.test(Eg = DA()))
        throw Ig(Eg, "name");
      var cg = new H(vA(Eg));
      HA(cg, function(ug) {
        ug === "option" ? (ig(cg, ug), yA(";")) : (wA(ug), _A(cg, "optional"));
      }), tg.add(cg);
    }
    function Dg(tg, Eg) {
      if (!lA.test(Eg = DA()))
        throw Ig(Eg, "name");
      var cg = new AA(Eg);
      HA(cg, function(ug) {
        switch (ug) {
          case "option":
            ig(cg, ug), yA(";");
            break;
          case "reserved":
            eg(cg.reserved || (cg.reserved = []), !0), cg.reserved === void 0 && (cg.reserved = []);
            break;
          default:
            kg(cg, ug);
        }
      }), tg.add(cg), tg === zA && XA.push(cg);
    }
    function kg(tg, Eg) {
      if (!lA.test(Eg))
        throw Ig(Eg, "name");
      yA("=");
      var cg = YA(DA(), !0), sg = {
        options: void 0
      };
      sg.getOption = function(ug) {
        return this.options[ug];
      }, sg.setOption = function(ug, Mg) {
        CA.prototype.setOption.call(sg, ug, Mg);
      }, sg.setParsedOption = function() {
      }, HA(sg, function(Mg) {
        if (Mg === "option")
          ig(sg, Mg), yA(";");
        else
          throw Ig(Mg);
      }, function() {
        ag(sg);
      }), tg.add(Eg, cg, sg.comment, sg.parsedOptions || sg.options);
    }
    function ig(tg, Eg) {
      var cg, sg, ug = !0;
      for (Eg === "option" && (Eg = DA()); Eg !== "="; ) {
        if (Eg === "(") {
          var Mg = DA();
          yA(")"), Eg = "(" + Mg + ")";
        }
        if (ug) {
          if (ug = !1, Eg.includes(".") && !Eg.includes("(")) {
            var Rg = Eg.split(".");
            cg = Rg[0] + ".", Eg = Rg[1];
            continue;
          }
          cg = Eg;
        } else
          sg = sg ? sg += Eg : Eg;
        Eg = DA();
      }
      var Jg = sg ? cg.concat(sg) : cg, Hg = ZA(tg, Jg);
      sg = sg && sg[0] === "." ? sg.slice(1) : sg, cg = cg && cg[cg.length - 1] === "." ? cg.slice(0, -1) : cg, PA(tg, cg, Hg, sg);
    }
    function ZA(tg, Eg) {
      if (yA("{", !0)) {
        for (var cg = {}; !yA("}", !0); ) {
          if (!lA.test(hg = DA()))
            throw Ig(hg, "name");
          if (hg === null)
            throw Ig(hg, "end of input");
          var sg, ug = hg;
          if (yA(":", !0), bA() === "{")
            sg = ZA(tg, Eg + "." + hg);
          else if (bA() === "[") {
            sg = [];
            var Mg;
            if (yA("[", !0)) {
              do
                Mg = og(), sg.push(Mg);
              while (yA(",", !0));
              yA("]"), typeof Mg < "u" && KA(tg, Eg + "." + hg, Mg);
            }
          } else
            sg = og(), KA(tg, Eg + "." + hg, sg);
          var Rg = cg[ug];
          Rg && (sg = [].concat(Rg).concat(sg)), cg[ug] = sg, yA(",", !0), yA(";", !0);
        }
        return cg;
      }
      var Jg = og();
      return KA(tg, Eg, Jg), Jg;
    }
    function KA(tg, Eg, cg) {
      if (zA === tg && /^features\./.test(Eg)) {
        fA[Eg] = cg;
        return;
      }
      tg.setOption && tg.setOption(Eg, cg);
    }
    function PA(tg, Eg, cg, sg) {
      tg.setParsedOption && tg.setParsedOption(Eg, cg, sg);
    }
    function ag(tg) {
      if (yA("[", !0)) {
        do
          ig(tg, "option");
        while (yA(",", !0));
        yA("]");
      }
      return tg;
    }
    function Gg(tg, Eg) {
      if (!lA.test(Eg = DA()))
        throw Ig(Eg, "service name");
      var cg = new gA(Eg);
      HA(cg, function(ug) {
        if (!VA(cg, ug))
          if (ug === "rpc")
            bg(cg, ug);
          else
            throw Ig(ug);
      }), tg.add(cg), tg === zA && XA.push(cg);
    }
    function bg(tg, Eg) {
      var cg = pA(), sg = Eg;
      if (!lA.test(Eg = DA()))
        throw Ig(Eg, "name");
      var ug = Eg, Mg, Rg, Jg, Hg;
      if (yA("("), yA("stream", !0) && (Rg = !0), !cA.test(Eg = DA()) || (Mg = Eg, yA(")"), yA("returns"), yA("("), yA("stream", !0) && (Hg = !0), !cA.test(Eg = DA())))
        throw Ig(Eg);
      Jg = Eg, yA(")");
      var mg = new IA(ug, sg, Mg, Jg, Rg, Hg);
      mg.comment = cg, HA(mg, function(Kg) {
        if (Kg === "option")
          ig(mg, Kg), yA(";");
        else
          throw Ig(Kg);
      }), tg.add(mg);
    }
    function yg(tg, Eg) {
      if (!cA.test(Eg = DA()))
        throw Ig(Eg, "reference");
      var cg = Eg;
      HA(null, function(ug) {
        switch (ug) {
          case "required":
          case "repeated":
            _A(tg, ug, cg);
            break;
          case "optional":
            NA === "proto3" ? _A(tg, "proto3_optional", cg) : _A(tg, "optional", cg);
            break;
          default:
            if (NA === "proto2" || !cA.test(ug))
              throw Ig(ug);
            wA(ug), _A(tg, "optional", cg);
            break;
        }
      });
    }
    for (var hg; (hg = DA()) !== null; )
      switch (hg) {
        case "package":
          if (!MA)
            throw Ig(hg);
          RA();
          break;
        case "import":
          if (!MA)
            throw Ig(hg);
          FA();
          break;
        case "syntax":
          if (!MA)
            throw Ig(hg);
          mA();
          break;
        case "edition":
          if (!MA)
            throw Ig(hg);
          JA();
          break;
        case "option":
          ig(zA, hg), yA(";", !0);
          break;
        default:
          if (VA(zA, hg)) {
            MA = !1;
            continue;
          }
          throw Ig(hg);
      }
    return Cg(), sA.filename = null, {
      package: LA,
      imports: xA,
      weakImports: TA,
      root: uA
    };
  }
  return parse_1;
}
var common_1, hasRequiredCommon;
function requireCommon() {
  if (hasRequiredCommon) return common_1;
  hasRequiredCommon = 1, common_1 = t;
  var n = /\/|\./;
  function t(d, k) {
    n.test(d) || (d = "google/protobuf/" + d + ".proto", k = { nested: { google: { nested: { protobuf: { nested: k } } } } }), t[d] = k;
  }
  t("any", {
    /**
     * Properties of a google.protobuf.Any message.
     * @interface IAny
     * @type {Object}
     * @property {string} [typeUrl]
     * @property {Uint8Array} [bytes]
     * @memberof common
     */
    Any: {
      fields: {
        type_url: {
          type: "string",
          id: 1
        },
        value: {
          type: "bytes",
          id: 2
        }
      }
    }
  });
  var g;
  return t("duration", {
    /**
     * Properties of a google.protobuf.Duration message.
     * @interface IDuration
     * @type {Object}
     * @property {number|Long} [seconds]
     * @property {number} [nanos]
     * @memberof common
     */
    Duration: g = {
      fields: {
        seconds: {
          type: "int64",
          id: 1
        },
        nanos: {
          type: "int32",
          id: 2
        }
      }
    }
  }), t("timestamp", {
    /**
     * Properties of a google.protobuf.Timestamp message.
     * @interface ITimestamp
     * @type {Object}
     * @property {number|Long} [seconds]
     * @property {number} [nanos]
     * @memberof common
     */
    Timestamp: g
  }), t("empty", {
    /**
     * Properties of a google.protobuf.Empty message.
     * @interface IEmpty
     * @memberof common
     */
    Empty: {
      fields: {}
    }
  }), t("struct", {
    /**
     * Properties of a google.protobuf.Struct message.
     * @interface IStruct
     * @type {Object}
     * @property {Object.<string,IValue>} [fields]
     * @memberof common
     */
    Struct: {
      fields: {
        fields: {
          keyType: "string",
          type: "Value",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.Value message.
     * @interface IValue
     * @type {Object}
     * @property {string} [kind]
     * @property {0} [nullValue]
     * @property {number} [numberValue]
     * @property {string} [stringValue]
     * @property {boolean} [boolValue]
     * @property {IStruct} [structValue]
     * @property {IListValue} [listValue]
     * @memberof common
     */
    Value: {
      oneofs: {
        kind: {
          oneof: [
            "nullValue",
            "numberValue",
            "stringValue",
            "boolValue",
            "structValue",
            "listValue"
          ]
        }
      },
      fields: {
        nullValue: {
          type: "NullValue",
          id: 1
        },
        numberValue: {
          type: "double",
          id: 2
        },
        stringValue: {
          type: "string",
          id: 3
        },
        boolValue: {
          type: "bool",
          id: 4
        },
        structValue: {
          type: "Struct",
          id: 5
        },
        listValue: {
          type: "ListValue",
          id: 6
        }
      }
    },
    NullValue: {
      values: {
        NULL_VALUE: 0
      }
    },
    /**
     * Properties of a google.protobuf.ListValue message.
     * @interface IListValue
     * @type {Object}
     * @property {Array.<IValue>} [values]
     * @memberof common
     */
    ListValue: {
      fields: {
        values: {
          rule: "repeated",
          type: "Value",
          id: 1
        }
      }
    }
  }), t("wrappers", {
    /**
     * Properties of a google.protobuf.DoubleValue message.
     * @interface IDoubleValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    DoubleValue: {
      fields: {
        value: {
          type: "double",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.FloatValue message.
     * @interface IFloatValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    FloatValue: {
      fields: {
        value: {
          type: "float",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.Int64Value message.
     * @interface IInt64Value
     * @type {Object}
     * @property {number|Long} [value]
     * @memberof common
     */
    Int64Value: {
      fields: {
        value: {
          type: "int64",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.UInt64Value message.
     * @interface IUInt64Value
     * @type {Object}
     * @property {number|Long} [value]
     * @memberof common
     */
    UInt64Value: {
      fields: {
        value: {
          type: "uint64",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.Int32Value message.
     * @interface IInt32Value
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    Int32Value: {
      fields: {
        value: {
          type: "int32",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.UInt32Value message.
     * @interface IUInt32Value
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    UInt32Value: {
      fields: {
        value: {
          type: "uint32",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.BoolValue message.
     * @interface IBoolValue
     * @type {Object}
     * @property {boolean} [value]
     * @memberof common
     */
    BoolValue: {
      fields: {
        value: {
          type: "bool",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.StringValue message.
     * @interface IStringValue
     * @type {Object}
     * @property {string} [value]
     * @memberof common
     */
    StringValue: {
      fields: {
        value: {
          type: "string",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.BytesValue message.
     * @interface IBytesValue
     * @type {Object}
     * @property {Uint8Array} [value]
     * @memberof common
     */
    BytesValue: {
      fields: {
        value: {
          type: "bytes",
          id: 1
        }
      }
    }
  }), t("field_mask", {
    /**
     * Properties of a google.protobuf.FieldMask message.
     * @interface IDoubleValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    FieldMask: {
      fields: {
        paths: {
          rule: "repeated",
          type: "string",
          id: 1
        }
      }
    }
  }), t.get = function(k) {
    return t[k] || null;
  }, common_1;
}
var hasRequiredSrc;
function requireSrc() {
  if (hasRequiredSrc) return src.exports;
  hasRequiredSrc = 1;
  var n = src.exports = requireIndexLight();
  return n.build = "full", n.tokenize = requireTokenize(), n.parse = requireParse(), n.common = requireCommon(), n.Root._configure(n.Type, n.parse, n.common), src.exports;
}
var protobufjs, hasRequiredProtobufjs;
function requireProtobufjs() {
  return hasRequiredProtobufjs || (hasRequiredProtobufjs = 1, protobufjs = requireSrc()), protobufjs;
}
var protobufjsExports = requireProtobufjs(), dist = {}, Collector = {}, hasRequiredCollector;
function requireCollector() {
  if (hasRequiredCollector) return Collector;
  hasRequiredCollector = 1, Object.defineProperty(Collector, "__esModule", { value: !0 }), Collector.Collector = void 0;
  let n = class {
    /**
     * Create a new collector.
     *
     * @param signal The signal to emit.
     */
    constructor(g) {
      this.emit = (...d) => {
        g.emitCollecting(this, d);
      };
    }
  };
  return Collector.Collector = n, Collector;
}
var CollectorArray = {}, hasRequiredCollectorArray;
function requireCollectorArray() {
  if (hasRequiredCollectorArray) return CollectorArray;
  hasRequiredCollectorArray = 1, Object.defineProperty(CollectorArray, "__esModule", { value: !0 }), CollectorArray.CollectorArray = void 0;
  const n = requireCollector();
  let t = class extends n.Collector {
    constructor() {
      super(...arguments), this.result = [];
    }
    handleResult(d) {
      return this.result.push(d), !0;
    }
    /**
     * Get the list of results from the signal handlers.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      this.result.length = 0;
    }
  };
  return CollectorArray.CollectorArray = t, CollectorArray;
}
var CollectorLast = {}, hasRequiredCollectorLast;
function requireCollectorLast() {
  if (hasRequiredCollectorLast) return CollectorLast;
  hasRequiredCollectorLast = 1, Object.defineProperty(CollectorLast, "__esModule", { value: !0 }), CollectorLast.CollectorLast = void 0;
  const n = requireCollector();
  let t = class extends n.Collector {
    handleResult(d) {
      return this.result = d, !0;
    }
    /**
     * Get the result of the last signal handler.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      delete this.result;
    }
  };
  return CollectorLast.CollectorLast = t, CollectorLast;
}
var CollectorUntil0 = {}, hasRequiredCollectorUntil0;
function requireCollectorUntil0() {
  if (hasRequiredCollectorUntil0) return CollectorUntil0;
  hasRequiredCollectorUntil0 = 1, Object.defineProperty(CollectorUntil0, "__esModule", { value: !0 }), CollectorUntil0.CollectorUntil0 = void 0;
  const n = requireCollector();
  let t = class extends n.Collector {
    constructor() {
      super(...arguments), this.result = !1;
    }
    handleResult(d) {
      return this.result = d, this.result;
    }
    /**
     * Get the result of the last signal handler.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      this.result = !1;
    }
  };
  return CollectorUntil0.CollectorUntil0 = t, CollectorUntil0;
}
var CollectorWhile0 = {}, hasRequiredCollectorWhile0;
function requireCollectorWhile0() {
  if (hasRequiredCollectorWhile0) return CollectorWhile0;
  hasRequiredCollectorWhile0 = 1, Object.defineProperty(CollectorWhile0, "__esModule", { value: !0 }), CollectorWhile0.CollectorWhile0 = void 0;
  const n = requireCollector();
  let t = class extends n.Collector {
    constructor() {
      super(...arguments), this.result = !1;
    }
    handleResult(d) {
      return this.result = d, !this.result;
    }
    /**
     * Get the result of the last signal handler.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      this.result = !1;
    }
  };
  return CollectorWhile0.CollectorWhile0 = t, CollectorWhile0;
}
var Signal = {}, SignalConnection = {}, hasRequiredSignalConnection;
function requireSignalConnection() {
  if (hasRequiredSignalConnection) return SignalConnection;
  hasRequiredSignalConnection = 1, Object.defineProperty(SignalConnection, "__esModule", { value: !0 }), SignalConnection.SignalConnectionImpl = void 0;
  class n {
    /**
     * @param link The actual link of the connection.
     */
    constructor(g) {
      this.link = g;
    }
    disconnect() {
      return this.link.unlink();
    }
    set enabled(g) {
      this.link.setEnabled(g);
    }
    get enabled() {
      return this.link.isEnabled();
    }
  }
  return SignalConnection.SignalConnectionImpl = n, SignalConnection;
}
var SignalLink = {}, hasRequiredSignalLink;
function requireSignalLink() {
  if (hasRequiredSignalLink) return SignalLink;
  hasRequiredSignalLink = 1, Object.defineProperty(SignalLink, "__esModule", { value: !0 }), SignalLink.SignalLink = void 0;
  let n = class $I {
    constructor(g, d, k) {
      this.enabled = !0, this.newLink = !1, this.prev = g ?? this, this.next = d ?? this, this.order = k.order, this.isPublic = k.isPublic, this.callback = k.callback, this.onUnlink = k.onUnlink;
    }
    isEnabled() {
      return this.enabled && !this.newLink;
    }
    setEnabled(g) {
      this.enabled = g;
    }
    unlink() {
      return this.callback ? (delete this.callback, this.next.prev = this.prev, this.prev.next = this.next, this.onUnlink(), !0) : !1;
    }
    insert(g) {
      const { order: d } = g;
      let k = this.prev;
      for (; k !== this && !(k.order <= d); )
        k = k.prev;
      const H = new $I(k, k.next, g);
      return k.next = H, H.next.prev = H, H;
    }
  };
  return SignalLink.SignalLink = n, SignalLink;
}
var hasRequiredSignal;
function requireSignal() {
  if (hasRequiredSignal) return Signal;
  hasRequiredSignal = 1, Object.defineProperty(Signal, "__esModule", { value: !0 }), Signal.Signal = void 0;
  const n = requireSignalConnection(), t = requireSignalLink(), g = { order: 0, isPublic: !0, onUnlink() {
  } };
  let d = class {
    constructor() {
      this.head = new t.SignalLink(null, null, g), this.hasNewLinks = !1, this.emitDepth = 0, this.connectionsCount = 0, this.onUnlink = () => {
        this.connectionsCount--;
      };
    }
    /**
     * @returns The number of connections on this signal.
     */
    getConnectionsCount() {
      return this.connectionsCount;
    }
    /**
     * @returns true if this signal has connections.
     */
    hasConnections() {
      return this.connectionsCount > 0;
    }
    /**
     * Subscribe to this signal.
     *
     * @param callback This callback will be run when emit() is called.
     * @param options Configure options for the connection
     */
    connect(H, { order: AA = 0, isPublic: gA = !0 } = {}) {
      this.connectionsCount++;
      const IA = this.head.insert({ callback: H, order: AA, isPublic: gA, onUnlink: this.onUnlink });
      return this.emitDepth > 0 && (this.hasNewLinks = !0, IA.newLink = !0), new n.SignalConnectionImpl(IA);
    }
    /**
     * Unsubscribe from this signal with the original callback instance.
     * While you can use this method, the SignalConnection returned by connect() will not be updated!
     *
     * @param callback The callback you passed to connect().
     */
    disconnect(H) {
      for (let AA = this.head.next; AA !== this.head; AA = AA.next)
        if (AA.callback === H)
          return AA.unlink(), !0;
      return !1;
    }
    /**
     * Disconnect all handlers from this signal event.
     */
    disconnectAll() {
      let { next: H } = this.head;
      for (; H !== this.head; )
        H.isPublic && H.unlink(), H = H.next;
    }
    /**
     * Publish this signal event (call all handlers).
     */
    emit(...H) {
      this.emitDepth++;
      for (let AA = this.head.next; AA !== this.head; AA = AA.next)
        AA.isEnabled() && AA.callback && AA.callback.apply(null, H);
      this.emitDepth--, this.unsetNewLink();
    }
    emitCollecting(H, AA) {
      this.emitDepth++;
      for (let gA = this.head.next; gA !== this.head; gA = gA.next)
        if (gA.isEnabled() && gA.callback) {
          const IA = gA.callback.apply(null, AA);
          if (!H.handleResult(IA))
            break;
        }
      this.emitDepth--, this.unsetNewLink();
    }
    unsetNewLink() {
      if (this.hasNewLinks && this.emitDepth === 0) {
        for (let H = this.head.next; H !== this.head; H = H.next)
          H.newLink = !1;
        this.hasNewLinks = !1;
      }
    }
  };
  return Signal.Signal = d, Signal;
}
var SignalConnections = {}, hasRequiredSignalConnections;
function requireSignalConnections() {
  if (hasRequiredSignalConnections) return SignalConnections;
  hasRequiredSignalConnections = 1, Object.defineProperty(SignalConnections, "__esModule", { value: !0 }), SignalConnections.SignalConnections = void 0;
  let n = class {
    constructor() {
      this.list = [];
    }
    /**
     * Add a connection to the list.
     * @param connection
     */
    add(g) {
      this.list.push(g);
    }
    /**
     * Disconnect all connections in the list and empty the list.
     */
    disconnectAll() {
      for (const g of this.list)
        g.disconnect();
      this.list = [];
    }
    /**
     * @returns The number of connections in this list.
     */
    getCount() {
      return this.list.length;
    }
    /**
     * @returns true if this list is empty.
     */
    isEmpty() {
      return this.list.length === 0;
    }
  };
  return SignalConnections.SignalConnections = n, SignalConnections;
}
var hasRequiredDist;
function requireDist() {
  return hasRequiredDist || (hasRequiredDist = 1, (function(n) {
    Object.defineProperty(n, "__esModule", { value: !0 }), n.SignalConnections = n.Signal = n.CollectorWhile0 = n.CollectorUntil0 = n.CollectorLast = n.CollectorArray = n.Collector = void 0;
    var t = requireCollector();
    Object.defineProperty(n, "Collector", { enumerable: !0, get: function() {
      return t.Collector;
    } });
    var g = requireCollectorArray();
    Object.defineProperty(n, "CollectorArray", { enumerable: !0, get: function() {
      return g.CollectorArray;
    } });
    var d = requireCollectorLast();
    Object.defineProperty(n, "CollectorLast", { enumerable: !0, get: function() {
      return d.CollectorLast;
    } });
    var k = requireCollectorUntil0();
    Object.defineProperty(n, "CollectorUntil0", { enumerable: !0, get: function() {
      return k.CollectorUntil0;
    } });
    var H = requireCollectorWhile0();
    Object.defineProperty(n, "CollectorWhile0", { enumerable: !0, get: function() {
      return H.CollectorWhile0;
    } });
    var AA = requireSignal();
    Object.defineProperty(n, "Signal", { enumerable: !0, get: function() {
      return AA.Signal;
    } });
    var gA = requireSignalConnections();
    Object.defineProperty(n, "SignalConnections", { enumerable: !0, get: function() {
      return gA.SignalConnections;
    } });
  })(dist)), dist;
}
var distExports = requireDist();
function createFormsData() {
  return {
    formsWithPendingChanges: /* @__PURE__ */ new Set(),
    formsWithUploads: /* @__PURE__ */ new Set(),
    submitButtons: /* @__PURE__ */ new Map()
  };
}
class WidgetStateDict {
  constructor() {
    this.widgetStates = /* @__PURE__ */ new Map();
  }
  /**
   * Create a new WidgetState proto for the widget with the given ID,
   * overwriting any that currently exists.
   */
  createState(t) {
    const g = new WidgetState({
      id: t
    });
    return this.widgetStates.set(t, g), g;
  }
  /** Return the WidgetState for the given widgetID if it exists. */
  getState(t) {
    return this.widgetStates.get(t);
  }
  /** Remove the WidgetState proto with the given id, if it exists. */
  deleteState(t) {
    this.widgetStates.delete(t);
  }
  /** Remove the state of widgets that are not contained in `activeIds`. */
  removeInactive(t) {
    this.widgetStates.forEach((g, d) => {
      t.has(d) || this.widgetStates.delete(d);
    });
  }
  /** Remove all widget states. */
  clear() {
    this.widgetStates.clear();
  }
  get isEmpty() {
    return this.widgetStates.size === 0;
  }
  createWidgetStatesMsg() {
    const t = new WidgetStates();
    return this.widgetStates.forEach((g) => t.widgets.push(g)), t;
  }
  /**
   * Copy the contents of another WidgetStateDict into this one, overwriting
   * any values with duplicate keys.
   */
  copyFrom(t) {
    t.widgetStates.forEach((g, d) => {
      this.widgetStates.set(d, g);
    });
  }
  /** Call a function for each value in the dict. */
  forEach(t) {
    this.widgetStates.forEach(t);
  }
}
class FormState {
  constructor() {
    this.widgetStates = new WidgetStateDict(), this.clearOnSubmit = !1, this.enterToSubmit = !0, this.formCleared = new distExports.Signal();
  }
  /** True if the form has a non-empty WidgetStateDict. */
  get hasPendingChanges() {
    return !this.widgetStates.isEmpty;
  }
}
class WidgetStateManager {
  constructor(t) {
    this.widgetStates = new WidgetStateDict(), this.forms = /* @__PURE__ */ new Map(), this.elementStates = /* @__PURE__ */ new Map(), this.props = t, this.formsData = createFormsData();
  }
  /**
   * Register a function that will be called when the given form is cleared.
   * Returns an object that can be used to de-register the listener.
   */
  addFormClearedListener(t, g) {
    return this.getOrCreateFormState(t).formCleared.connect(g);
  }
  /**
   * Register a Form, and assign its clearOnSubmit & enterToSubmit values.
   * The `Form` element calls this when it's first mounted.
   */
  setFormSubmitBehaviors(t, g, d = !0) {
    const k = this.getOrCreateFormState(t);
    k.clearOnSubmit = g, k.enterToSubmit = d;
  }
  /**
   * Commit pending changes for widgets that belong to the given form,
   * and send a rerunBackMsg to the server.
   */
  submitForm(t, g, d) {
    if (!isValidFormId(t))
      throw new Error(`invalid formID '${t}'`);
    const k = this.getOrCreateFormState(t), H = this.formsData.submitButtons.get(t);
    let AA;
    d !== void 0 ? AA = d : H !== void 0 && H.length > 0 && (AA = H[0]), AA && (this.createWidgetState(AA, {
      fromUi: !0
    }).triggerValue = !0), this.widgetStates.copyFrom(k.widgetStates), k.widgetStates.clear(), this.sendUpdateWidgetsMessage(g), this.syncFormsWithPendingChanges(), AA && this.deleteWidgetState(AA.id), k.clearOnSubmit && k.formCleared.emit();
  }
  /* Sometimes users change an input field and directly click on a button - which uses the trigger value -
   * to trigger a rerun. We wrap the code that sends the trigger update in `setTimeout` so that trigger-based
   * updates will be executed at the end of JavaScript's event loop. Callbacks for other elements, for example,
   * the onBlur event of an input field, will be deterministically executed first in the event loop since they
   * were encountered first in the sequential execution and will be executed FIFO from the task queue.
   *
   * Returns a promise that is resolved as soon as the timeout was triggered, mainly to make this easier to test.
   * in our unit tests.
   */
  setTriggerValueAtEndOfEventLoop(t, g, d) {
    return new Promise((k) => {
      setTimeout(() => {
        this.onWidgetValueChanged(t.formId, g, d), this.deleteWidgetState(t.id), k();
      }, 0);
    });
  }
  setChatInputValue(t, g, d, k) {
    this.createWidgetState(t, d).chatInputValue = new ChatInputValue(g), this.onWidgetValueChanged(t.formId, d, k), this.deleteWidgetState(t.id);
  }
  /**
   * Sets the trigger value for the given widget ID to true, sends a rerunScript message
   * to the server, and then immediately unsets the trigger value.
   */
  setTriggerValue(t, g, d) {
    return this.createWidgetState(t, g).triggerValue = !0, this.setTriggerValueAtEndOfEventLoop(t, g, d);
  }
  getBoolValue(t) {
    const g = this.getWidgetState(t);
    if (notNullOrUndefined(g) && g.value === "boolValue")
      return g.boolValue;
  }
  setBoolValue(t, g, d, k) {
    this.createWidgetState(t, d).boolValue = g, this.onWidgetValueChanged(t.formId, d, k);
  }
  getIntValue(t) {
    const g = this.getWidgetState(t);
    if (notNullOrUndefined(g) && g.value === "intValue")
      return requireNumberInt(g.intValue);
  }
  setIntValue(t, g, d, k) {
    this.createWidgetState(t, d).intValue = g, this.onWidgetValueChanged(t.formId, d, k);
  }
  getDoubleValue(t) {
    const g = this.getWidgetState(t);
    if (notNullOrUndefined(g) && g.value === "doubleValue")
      return g.doubleValue;
  }
  setDoubleValue(t, g, d, k) {
    this.createWidgetState(t, d).doubleValue = g, this.onWidgetValueChanged(t.formId, d, k);
  }
  getStringValue(t) {
    const g = this.getWidgetState(t);
    if (notNullOrUndefined(g) && g.value === "stringValue")
      return g.stringValue;
  }
  setStringValue(t, g, d, k) {
    this.createWidgetState(t, d).stringValue = g, this.onWidgetValueChanged(t.formId, d, k);
  }
  setStringArrayValue(t, g, d, k) {
    this.createWidgetState(t, d).stringArrayValue = new StringArray({
      data: g
    }), this.onWidgetValueChanged(t.formId, d, k);
  }
  getStringArrayValue(t) {
    const g = this.getWidgetState(t);
    if (notNullOrUndefined(g) && g.value === "stringArrayValue" && notNullOrUndefined(g.stringArrayValue) && notNullOrUndefined(g.stringArrayValue.data))
      return g.stringArrayValue.data;
  }
  getDoubleArrayValue(t) {
    const g = this.getWidgetState(t);
    if (notNullOrUndefined(g) && g.value === "doubleArrayValue" && notNullOrUndefined(g.doubleArrayValue) && notNullOrUndefined(g.doubleArrayValue.data))
      return g.doubleArrayValue.data;
  }
  setDoubleArrayValue(t, g, d, k) {
    this.createWidgetState(t, d).doubleArrayValue = new DoubleArray({
      data: g
    }), this.onWidgetValueChanged(t.formId, d, k);
  }
  getIntArrayValue(t) {
    const g = this.getWidgetState(t);
    if (notNullOrUndefined(g) && g.value === "intArrayValue" && notNullOrUndefined(g.intArrayValue) && notNullOrUndefined(g.intArrayValue.data))
      return g.intArrayValue.data.map(requireNumberInt);
  }
  setIntArrayValue(t, g, d, k) {
    this.createWidgetState(t, d).intArrayValue = new SInt64Array({
      data: g
    }), this.onWidgetValueChanged(t.formId, d, k);
  }
  getJsonValue(t) {
    const g = this.getWidgetState(t);
    if (notNullOrUndefined(g) && g.value === "jsonValue")
      return g.jsonValue;
  }
  setJsonValue(t, g, d, k) {
    this.createWidgetState(t, d).jsonValue = JSON.stringify(g), this.onWidgetValueChanged(t.formId, d, k);
  }
  setArrowValue(t, g, d, k) {
    this.createWidgetState(t, d).arrowValue = g, this.onWidgetValueChanged(t.formId, d, k);
  }
  getArrowValue(t) {
    const g = this.getWidgetState(t);
    if (notNullOrUndefined(g) && g.value === "arrowValue" && notNullOrUndefined(g.arrowValue))
      return g.arrowValue;
  }
  setBytesValue(t, g, d, k) {
    this.createWidgetState(t, d).bytesValue = g, this.onWidgetValueChanged(t.formId, d, k);
  }
  getBytesValue(t) {
    const g = this.getWidgetState(t);
    if (notNullOrUndefined(g) && g.value === "bytesValue")
      return g.bytesValue;
  }
  setFileUploaderStateValue(t, g, d, k) {
    this.createWidgetState(t, d).fileUploaderStateValue = g, this.onWidgetValueChanged(t.formId, d, k);
  }
  getFileUploaderStateValue(t) {
    const g = this.getWidgetState(t);
    if (notNullOrUndefined(g) && g.value === "fileUploaderStateValue")
      return g.fileUploaderStateValue;
  }
  /**
   * Perform housekeeping every time a widget value changes.
   * - If the widget does not belong to a form, and the value update came from
   *   a user action, send the "updateWidgets" message
   * - If the widget belongs to a form, dispatch the "pendingFormsChanged"
   *   callback if needed.
   *
   * Called by every "setValue" function.
   */
  onWidgetValueChanged(t, g, d) {
    isValidFormId(t) ? this.syncFormsWithPendingChanges() : g.fromUi && this.sendUpdateWidgetsMessage(d);
  }
  /**
   * Update FormsData.formsWithPendingChanges with the current set of forms
   * that have pending changes. This is called after widget values are updated.
   */
  syncFormsWithPendingChanges() {
    const t = /* @__PURE__ */ new Set();
    this.forms.forEach((g, d) => {
      g.hasPendingChanges && t.add(d);
    }), this.updateFormsData((g) => {
      g.formsWithPendingChanges = t;
    });
  }
  sendUpdateWidgetsMessage(t, g = void 0) {
    this.props.sendRerunBackMsg(this.widgetStates.createWidgetStatesMsg(), t, void 0, g);
  }
  getActiveWidgetStates(t) {
    const g = new WidgetStates();
    return this.widgetStates.forEach((d) => {
      t.has(d.id) && g.widgets.push(d);
    }), g;
  }
  /**
   * Remove the state of widgets that are not contained in `activeIds`.
   * This is called when a script finishes running, so that we don't retain
   * data for widgets that have been removed from the app.
   */
  removeInactive(t) {
    this.widgetStates.removeInactive(t), this.forms.forEach((g) => g.widgetStates.removeInactive(t)), this.elementStates.forEach((g, d) => {
      t.has(d) || this.deleteElementState(d);
    });
  }
  /**
   * Create and return a new WidgetState proto for the given widget ID,
   * overwriting any that currently exists. If the widget belongs to a form,
   * the WidgetState will be created inside the form's WidgetStateDict.
   */
  createWidgetState(t, g) {
    return (isValidFormId(t.formId) && g.fromUi ? this.getOrCreateFormState(t.formId).widgetStates : this.widgetStates).createState(t.id);
  }
  /**
   * Get the WidgetState proto for the given widget ID, if it exists.
   */
  getWidgetState(t) {
    if (isValidFormId(t.formId)) {
      const g = this.forms.get(t.formId)?.widgetStates.getState(t.id);
      if (notNullOrUndefined(g))
        return g;
    }
    return this.widgetStates.getState(t.id);
  }
  /**
   * Remove the WidgetState proto with the given id, if it exists
   */
  deleteWidgetState(t) {
    this.widgetStates.deleteState(t);
  }
  /** Return the FormState for the given form. Create it if it doesn't exist. */
  getOrCreateFormState(t) {
    let g = this.forms.get(t);
    return notNullOrUndefined(g) || (g = new FormState(), this.forms.set(t, g)), g;
  }
  /** Store the IDs of all forms with in-progress uploads. */
  setFormsWithUploadsInProgress(t) {
    this.updateFormsData((g) => {
      g.formsWithUploads = t;
    });
  }
  /**
   * Helper function to determine whether a form allows enter to submit
   * for input elements (st.number_input, st.text_input, etc.)
   * If in form, checks form's enterToSubmit paramf first, otherwise default
   * behavior: Must have 1st submit button enabled to allow
   */
  allowFormEnterToSubmit(t) {
    if (!isValidFormId(t)) return !1;
    const g = this.forms.get(t);
    if (g && !g.enterToSubmit) return !1;
    const k = this.formsData.submitButtons.get(t)?.[0];
    return k ? !k.disabled : !1;
  }
  /**
   * Called by FormSubmitButton on creation. Add the SubmitButtonProto for
   * the given form and update FormsData.
   */
  addSubmitButton(t, g) {
    const d = this.formsData.submitButtons.get(t);
    if (d === void 0)
      this.setSubmitButtons(t, [g]);
    else {
      const k = Object.assign([], d);
      k.push(g), this.setSubmitButtons(t, k);
    }
  }
  /**
   * Called by FormSubmitButton on creation. Remove the SubmitButtonProto for
   * the given form, and update FormsData.
   */
  removeSubmitButton(t, g) {
    const d = this.formsData.submitButtons.get(t);
    if (d !== void 0) {
      const k = Object.assign([], d), H = k.indexOf(g, 0);
      H > -1 && k.splice(H, 1), this.setSubmitButtons(t, k);
    }
  }
  setSubmitButtons(t, g) {
    if (g.length < 0)
      throw new Error(`Bad submitButtons length ${g.length} (must be >= 0)`);
    this.updateFormsData((d) => {
      d.submitButtons.set(t, g);
    });
  }
  /**
   * Produce a new FormsData with the given recipe, and fire off the
   * formsDataChanged callback with that new data.
   */
  updateFormsData(t) {
    const g = produce(this.formsData, t);
    this.formsData !== g && (this.formsData = g, this.props.formsDataChanged(this.formsData));
  }
  /**
   * Get the element state value for the given element ID and key, if it exists.
   * This is a frontend-only state that is never sent to the server.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  getElementState(t, g) {
    return this.elementStates.get(t)?.get(g);
  }
  /**
   * Sets the state of an element identified by its ID and its key.
   * This is a frontend-only state that is never sent to the server.
   * It can be used to store element state to restore the state
   * of an element in situations where an element is removed and re-added.
   *
   * @param {string} elementId - The unique identifier of the element.
   * @param {string} key - The key to set
   * @param {any} value - The value to set for the element's state.
   * @returns {void}
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  setElementState(t, g, d) {
    this.elementStates.has(t) || this.elementStates.set(t, /* @__PURE__ */ new Map()), this.elementStates.get(t).set(g, d);
  }
  /**
   * Deletes the state associated with a specific element by ID. If a key is provided,
   * only the state corresponding to that key is removed. If no key is specified, all states
   * associated with the element ID are removed.
   */
  deleteElementState(t, g) {
    notNullOrUndefined(g) ? this.elementStates.get(t)?.delete(g) : this.elementStates.delete(t);
  }
}
function requireNumberInt(n) {
  if (typeof n == "number")
    return n;
  const t = protobufjsExports.util.LongBits.from(n).toNumber();
  if (Number.isSafeInteger(t))
    return t;
  throw new Error(
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions -- TODO: Fix this
    `value ${n} cannot be converted to number without a loss of precision!`
  );
}
const measure = (n, t, g) => performance.measure(n, t, g), mark = (n) => performance.mark(n);
class Timer {
  constructor() {
    this.duration = 0, this.startTime = 0, this.running = !1;
  }
  /** True if the timer is currently running */
  get isRunning() {
    return this.running;
  }
  /** Remaining time before timeout, or 0 if the timer is not running */
  get remainingTime() {
    if (!this.running)
      return 0;
    const t = Date.now() - this.startTime;
    return Math.max(this.duration - t, 0);
  }
  /**
   * Starts the Timer with the given callback.
   * If the Timer is already running, it will be canceled first.
   */
  setTimeout(t, g) {
    this.cancel(), this.startTime = Date.now(), this.duration = g, this.running = !0, this.timerHandle = window.setTimeout(() => {
      this.running = !1, t();
    }, g);
  }
  /** Cancels the Timer. If the Timer is not already running, this is a no-op. */
  cancel() {
    this.timerHandle !== void 0 && (window.clearTimeout(this.timerHandle), this.timerHandle = void 0, this.running = !1);
  }
}
var _baseDifference, hasRequired_baseDifference;
function require_baseDifference() {
  if (hasRequired_baseDifference) return _baseDifference;
  hasRequired_baseDifference = 1;
  var n = require_SetCache(), t = require_arrayIncludes(), g = require_arrayIncludesWith(), d = require_arrayMap(), k = require_baseUnary(), H = require_cacheHas(), AA = 200;
  function gA(IA, CA, BA, eA) {
    var iA = -1, QA = t, tA = !0, oA = IA.length, EA = [], aA = CA.length;
    if (!oA)
      return EA;
    BA && (CA = d(CA, k(BA))), eA ? (QA = g, tA = !1) : CA.length >= AA && (QA = H, tA = !1, CA = new n(CA));
    A:
      for (; ++iA < oA; ) {
        var nA = IA[iA], lA = BA == null ? nA : BA(nA);
        if (nA = eA || nA !== 0 ? nA : 0, tA && lA === lA) {
          for (var cA = aA; cA--; )
            if (CA[cA] === lA)
              continue A;
          EA.push(nA);
        } else QA(CA, lA, eA) || EA.push(nA);
      }
    return EA;
  }
  return _baseDifference = gA, _baseDifference;
}
var without_1, hasRequiredWithout;
function requireWithout() {
  if (hasRequiredWithout) return without_1;
  hasRequiredWithout = 1;
  var n = require_baseDifference(), t = require_baseRest(), g = requireIsArrayLikeObject(), d = t(function(k, H) {
    return g(k) ? n(k, H) : [];
  });
  return without_1 = d, without_1;
}
var withoutExports = requireWithout();
const without = /* @__PURE__ */ getDefaultExportFromCjs$2(withoutExports), isff = typeof navigator < "u" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : !1;
function addEvent(n, t, g, d) {
  n.addEventListener ? n.addEventListener(t, g, d) : n.attachEvent && n.attachEvent("on".concat(t), g);
}
function removeEvent(n, t, g, d) {
  n.removeEventListener ? n.removeEventListener(t, g, d) : n.detachEvent && n.detachEvent("on".concat(t), g);
}
function getMods(n, t) {
  const g = t.slice(0, t.length - 1);
  for (let d = 0; d < g.length; d++) g[d] = n[g[d].toLowerCase()];
  return g;
}
function getKeys(n) {
  typeof n != "string" && (n = ""), n = n.replace(/\s/g, "");
  const t = n.split(",");
  let g = t.lastIndexOf("");
  for (; g >= 0; )
    t[g - 1] += ",", t.splice(g, 1), g = t.lastIndexOf("");
  return t;
}
function compareArray(n, t) {
  const g = n.length >= t.length ? n : t, d = n.length >= t.length ? t : n;
  let k = !0;
  for (let H = 0; H < g.length; H++)
    d.indexOf(g[H]) === -1 && (k = !1);
  return k;
}
const _keyMap = {
  backspace: 8,
  "⌫": 8,
  tab: 9,
  clear: 12,
  enter: 13,
  "↩": 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  /// https://w3c.github.io/uievents/#events-keyboard-key-location
  arrowup: 38,
  arrowdown: 40,
  arrowleft: 37,
  arrowright: 39,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "⇪": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": isff ? 173 : 189,
  "=": isff ? 61 : 187,
  ";": isff ? 59 : 186,
  "'": 222,
  "{": 219,
  "}": 221,
  "[": 219,
  "]": 221,
  "\\": 220
}, _modifier = {
  // shiftKey
  "⇧": 16,
  shift: 16,
  // altKey
  "⌥": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "⌃": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "⌘": 91,
  cmd: 91,
  meta: 91,
  command: 91
}, modifierMap = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
}, _mods = {
  16: !1,
  18: !1,
  17: !1,
  91: !1
}, _handlers = {};
for (let n = 1; n < 20; n++)
  _keyMap["f".concat(n)] = 111 + n;
let _downKeys = [], winListendFocus = null, _scope = "all";
const elementEventMap = /* @__PURE__ */ new Map(), code = (n) => _keyMap[n.toLowerCase()] || _modifier[n.toLowerCase()] || n.toUpperCase().charCodeAt(0), getKey = (n) => Object.keys(_keyMap).find((t) => _keyMap[t] === n), getModifier = (n) => Object.keys(_modifier).find((t) => _modifier[t] === n);
function setScope(n) {
  _scope = n || "all";
}
function getScope() {
  return _scope || "all";
}
function getPressedKeyCodes() {
  return _downKeys.slice(0);
}
function getPressedKeyString() {
  return _downKeys.map((n) => getKey(n) || getModifier(n) || String.fromCharCode(n));
}
function getAllKeyCodes() {
  const n = [];
  return Object.keys(_handlers).forEach((t) => {
    _handlers[t].forEach((g) => {
      let {
        key: d,
        scope: k,
        mods: H,
        shortcut: AA
      } = g;
      n.push({
        scope: k,
        shortcut: AA,
        mods: H,
        keys: d.split("+").map((gA) => code(gA))
      });
    });
  }), n;
}
function filter$1(n) {
  const t = n.target || n.srcElement, {
    tagName: g
  } = t;
  let d = !0;
  const k = g === "INPUT" && !["checkbox", "radio", "range", "button", "file", "reset", "submit", "color"].includes(t.type);
  return (t.isContentEditable || (k || g === "TEXTAREA" || g === "SELECT") && !t.readOnly) && (d = !1), d;
}
function isPressed(n) {
  return typeof n == "string" && (n = code(n)), _downKeys.indexOf(n) !== -1;
}
function deleteScope(n, t) {
  let g, d;
  n || (n = getScope());
  for (const k in _handlers)
    if (Object.prototype.hasOwnProperty.call(_handlers, k))
      for (g = _handlers[k], d = 0; d < g.length; )
        g[d].scope === n ? g.splice(d, 1).forEach((AA) => {
          let {
            element: gA
          } = AA;
          return removeKeyEvent(gA);
        }) : d++;
  getScope() === n && setScope(t || "all");
}
function clearModifier(n) {
  let t = n.keyCode || n.which || n.charCode;
  n.key && n.key.toLowerCase() === "capslock" && (t = code(n.key));
  const g = _downKeys.indexOf(t);
  if (g >= 0 && _downKeys.splice(g, 1), n.key && n.key.toLowerCase() === "meta" && _downKeys.splice(0, _downKeys.length), (t === 93 || t === 224) && (t = 91), t in _mods) {
    _mods[t] = !1;
    for (const d in _modifier) _modifier[d] === t && (hotkeys[d] = !1);
  }
}
function unbind(n) {
  if (typeof n > "u")
    Object.keys(_handlers).forEach((k) => {
      Array.isArray(_handlers[k]) && _handlers[k].forEach((H) => eachUnbind(H)), delete _handlers[k];
    }), removeKeyEvent(null);
  else if (Array.isArray(n))
    n.forEach((k) => {
      k.key && eachUnbind(k);
    });
  else if (typeof n == "object")
    n.key && eachUnbind(n);
  else if (typeof n == "string") {
    for (var t = arguments.length, g = new Array(t > 1 ? t - 1 : 0), d = 1; d < t; d++)
      g[d - 1] = arguments[d];
    let [k, H] = g;
    typeof k == "function" && (H = k, k = ""), eachUnbind({
      key: n,
      scope: k,
      method: H,
      splitKey: "+"
    });
  }
}
const eachUnbind = (n) => {
  let {
    key: t,
    scope: g,
    method: d,
    splitKey: k = "+"
  } = n;
  getKeys(t).forEach((AA) => {
    const gA = AA.split(k), IA = gA.length, CA = gA[IA - 1], BA = CA === "*" ? "*" : code(CA);
    if (!_handlers[BA]) return;
    g || (g = getScope());
    const eA = IA > 1 ? getMods(_modifier, gA) : [], iA = [];
    _handlers[BA] = _handlers[BA].filter((QA) => {
      const oA = (d ? QA.method === d : !0) && QA.scope === g && compareArray(QA.mods, eA);
      return oA && iA.push(QA.element), !oA;
    }), iA.forEach((QA) => removeKeyEvent(QA));
  });
};
function eventHandler(n, t, g, d) {
  if (t.element !== d)
    return;
  let k;
  if (t.scope === g || t.scope === "all") {
    k = t.mods.length > 0;
    for (const H in _mods)
      Object.prototype.hasOwnProperty.call(_mods, H) && (!_mods[H] && t.mods.indexOf(+H) > -1 || _mods[H] && t.mods.indexOf(+H) === -1) && (k = !1);
    (t.mods.length === 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91] || k || t.shortcut === "*") && (t.keys = [], t.keys = t.keys.concat(_downKeys), t.method(n, t) === !1 && (n.preventDefault ? n.preventDefault() : n.returnValue = !1, n.stopPropagation && n.stopPropagation(), n.cancelBubble && (n.cancelBubble = !0)));
  }
}
function dispatch(n, t) {
  const g = _handlers["*"];
  let d = n.keyCode || n.which || n.charCode;
  if (n.key && n.key.toLowerCase() === "capslock" || !hotkeys.filter.call(this, n)) return;
  if ((d === 93 || d === 224) && (d = 91), _downKeys.indexOf(d) === -1 && d !== 229 && _downKeys.push(d), ["metaKey", "ctrlKey", "altKey", "shiftKey"].forEach((gA) => {
    const IA = modifierMap[gA];
    n[gA] && _downKeys.indexOf(IA) === -1 ? _downKeys.push(IA) : !n[gA] && _downKeys.indexOf(IA) > -1 ? _downKeys.splice(_downKeys.indexOf(IA), 1) : gA === "metaKey" && n[gA] && (_downKeys = _downKeys.filter((CA) => CA in modifierMap || CA === d));
  }), d in _mods) {
    _mods[d] = !0;
    for (const gA in _modifier)
      if (Object.prototype.hasOwnProperty.call(_modifier, gA)) {
        const IA = modifierMap[_modifier[gA]];
        hotkeys[gA] = n[IA];
      }
    if (!g) return;
  }
  for (const gA in _mods)
    Object.prototype.hasOwnProperty.call(_mods, gA) && (_mods[gA] = n[modifierMap[gA]]);
  n.getModifierState && !(n.altKey && !n.ctrlKey) && n.getModifierState("AltGraph") && (_downKeys.indexOf(17) === -1 && _downKeys.push(17), _downKeys.indexOf(18) === -1 && _downKeys.push(18), _mods[17] = !0, _mods[18] = !0);
  const k = getScope();
  if (g)
    for (let gA = 0; gA < g.length; gA++)
      g[gA].scope === k && (n.type === "keydown" && g[gA].keydown || n.type === "keyup" && g[gA].keyup) && eventHandler(n, g[gA], k, t);
  if (!(d in _handlers)) return;
  const H = _handlers[d], AA = H.length;
  for (let gA = 0; gA < AA; gA++)
    if ((n.type === "keydown" && H[gA].keydown || n.type === "keyup" && H[gA].keyup) && H[gA].key) {
      const IA = H[gA], {
        splitKey: CA
      } = IA, BA = IA.key.split(CA), eA = [];
      for (let iA = 0; iA < BA.length; iA++)
        eA.push(code(BA[iA]));
      eA.sort().join("") === _downKeys.sort().join("") && eventHandler(n, IA, k, t);
    }
}
function hotkeys(n, t, g) {
  _downKeys = [];
  const d = getKeys(n);
  let k = [], H = "all", AA = document, gA = 0, IA = !1, CA = !0, BA = "+", eA = !1, iA = !1;
  for (g === void 0 && typeof t == "function" && (g = t), Object.prototype.toString.call(t) === "[object Object]" && (t.scope && (H = t.scope), t.element && (AA = t.element), t.keyup && (IA = t.keyup), t.keydown !== void 0 && (CA = t.keydown), t.capture !== void 0 && (eA = t.capture), typeof t.splitKey == "string" && (BA = t.splitKey), t.single === !0 && (iA = !0)), typeof t == "string" && (H = t), iA && unbind(n, H); gA < d.length; gA++)
    n = d[gA].split(BA), k = [], n.length > 1 && (k = getMods(_modifier, n)), n = n[n.length - 1], n = n === "*" ? "*" : code(n), n in _handlers || (_handlers[n] = []), _handlers[n].push({
      keyup: IA,
      keydown: CA,
      scope: H,
      mods: k,
      shortcut: d[gA],
      method: g,
      key: d[gA],
      splitKey: BA,
      element: AA
    });
  if (typeof AA < "u" && window) {
    if (!elementEventMap.has(AA)) {
      const QA = function() {
        let oA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        return dispatch(oA, AA);
      }, tA = function() {
        let oA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        dispatch(oA, AA), clearModifier(oA);
      };
      elementEventMap.set(AA, {
        keydownListener: QA,
        keyupListenr: tA,
        capture: eA
      }), addEvent(AA, "keydown", QA, eA), addEvent(AA, "keyup", tA, eA);
    }
    if (!winListendFocus) {
      const QA = () => {
        _downKeys = [];
      };
      winListendFocus = {
        listener: QA,
        capture: eA
      }, addEvent(window, "focus", QA, eA);
    }
  }
}
function trigger(n) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all";
  Object.keys(_handlers).forEach((g) => {
    _handlers[g].filter((k) => k.scope === t && k.shortcut === n).forEach((k) => {
      k && k.method && k.method();
    });
  });
}
function removeKeyEvent(n) {
  const t = Object.values(_handlers).flat();
  if (t.findIndex((d) => {
    let {
      element: k
    } = d;
    return k === n;
  }) < 0) {
    const {
      keydownListener: d,
      keyupListenr: k,
      capture: H
    } = elementEventMap.get(n) || {};
    d && k && (removeEvent(n, "keyup", k, H), removeEvent(n, "keydown", d, H), elementEventMap.delete(n));
  }
  if ((t.length <= 0 || elementEventMap.size <= 0) && (Object.keys(elementEventMap).forEach((k) => {
    const {
      keydownListener: H,
      keyupListenr: AA,
      capture: gA
    } = elementEventMap.get(k) || {};
    H && AA && (removeEvent(k, "keyup", AA, gA), removeEvent(k, "keydown", H, gA), elementEventMap.delete(k));
  }), elementEventMap.clear(), Object.keys(_handlers).forEach((k) => delete _handlers[k]), winListendFocus)) {
    const {
      listener: k,
      capture: H
    } = winListendFocus;
    removeEvent(window, "focus", k, H), winListendFocus = null;
  }
}
const _api = {
  getPressedKeyString,
  setScope,
  getScope,
  deleteScope,
  getPressedKeyCodes,
  getAllKeyCodes,
  isPressed,
  filter: filter$1,
  trigger,
  unbind,
  keyMap: _keyMap,
  modifier: _modifier,
  modifierMap
};
for (const n in _api)
  Object.prototype.hasOwnProperty.call(_api, n) && (hotkeys[n] = _api[n]);
if (typeof window < "u") {
  const n = window.hotkeys;
  hotkeys.noConflict = (t) => (t && window.hotkeys === hotkeys && (window.hotkeys = n), hotkeys), window.hotkeys = hotkeys;
}
class ReactHotkeys extends React__default.Component {
  constructor(t) {
    super(t), this.isKeyDown = !1, this.handle = void 0, this.onKeyDown = this.onKeyDown.bind(this), this.onKeyUp = this.onKeyUp.bind(this), this.handleKeyUpEvent = this.handleKeyUpEvent.bind(this), this.handle = {};
  }
  componentDidMount() {
    var {
      filter: t,
      splitKey: g
    } = this.props;
    t && (hotkeys.filter = t), hotkeys.unbind(this.props.keyName), hotkeys(this.props.keyName, {
      splitKey: g
    }, this.onKeyDown), document && document.body.addEventListener("keyup", this.handleKeyUpEvent);
  }
  componentWillUnmount() {
    hotkeys.unbind(this.props.keyName), this.isKeyDown = !0, this.handle = {}, document && document.body.removeEventListener("keyup", this.handleKeyUpEvent);
  }
  onKeyUp(t, g) {
    var {
      onKeyUp: d,
      disabled: k
    } = this.props;
    !k && d && d(g.shortcut, t, g);
  }
  onKeyDown(t, g) {
    var {
      onKeyDown: d,
      allowRepeat: k,
      disabled: H
    } = this.props;
    this.isKeyDown && !k || (this.isKeyDown = !0, this.handle = g, !H && d && d(g.shortcut, t, g));
  }
  handleKeyUpEvent(t) {
    this.isKeyDown && (this.isKeyDown = !1, !(this.props.keyName && this.props.keyName.indexOf(this.handle.shortcut) < 0) && (this.onKeyUp(t, this.handle), this.handle = {}));
  }
  render() {
    return this.props.children || null;
  }
}
ReactHotkeys.defaultProps = {
  filter(n) {
    var t = n.target || n.srcElement, g = t.tagName;
    return !(t.isContentEditable || g === "INPUT" || g === "SELECT" || g === "TEXTAREA");
  }
};
ReactHotkeys.propTypes = {
  keyName: propTypesExports.string,
  filter: propTypesExports.func,
  onKeyDown: propTypesExports.func,
  onKeyUp: propTypesExports.func,
  disabled: propTypesExports.bool,
  splitKey: propTypesExports.string
};
function EventContainer({
  children: n
}) {
  const t = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ToasterContainer,
      {
        placement: PLACEMENT$1.topRight,
        autoHideDuration: 4 * 1e3,
        overrides: {
          Root: {
            style: {
              // Avoids blocking the header
              top: t.sizes.headerHeight,
              zIndex: t.zIndices.toast
            },
            props: {
              "data-testid": "stToastContainer",
              className: "stToastContainer"
            }
          }
        }
      }
    ),
    n
  ] });
}
const AppContext = createContext({
  initialSidebarState: PageConfig.SidebarState.AUTO,
  pageLinkBaseUrl: "",
  currentPageScriptHash: "",
  onPageChange: () => {
  },
  navSections: [],
  appPages: [],
  appLogo: null,
  sidebarChevronDownshift: 0,
  expandSidebarNav: !1,
  hideSidebarNav: !1,
  widgetsDisabled: !1,
  gitInfo: null,
  showToolbar: !0
});
AppContext.displayName = "AppContext";
const StreamlitContextProvider = ({
  // AppContext
  initialSidebarState: n,
  pageLinkBaseUrl: t,
  navSections: g,
  appPages: d,
  appLogo: k,
  sidebarChevronDownshift: H,
  expandSidebarNav: AA,
  hideSidebarNav: gA,
  widgetsDisabled: IA,
  gitInfo: CA,
  showToolbar: BA,
  // LibContext
  isFullScreen: eA,
  setFullScreen: iA,
  addScriptFinishedHandler: QA,
  removeScriptFinishedHandler: tA,
  activeTheme: oA,
  setTheme: EA,
  availableThemes: aA,
  addThemes: nA,
  libConfig: lA,
  fragmentIdsThisRun: cA,
  locale: sA,
  scriptRunState: rA,
  scriptRunId: uA,
  componentRegistry: hA,
  // Used in both contexts
  currentPageScriptHash: dA,
  onPageChange: GA,
  // FormsContext
  formsData: DA,
  // Children passed through
  children: wA
}) => {
  const bA = useMemo$1(() => ({
    initialSidebarState: n,
    pageLinkBaseUrl: t,
    currentPageScriptHash: dA,
    onPageChange: GA,
    navSections: g,
    appPages: d,
    appLogo: k,
    sidebarChevronDownshift: H,
    expandSidebarNav: AA,
    hideSidebarNav: gA,
    widgetsDisabled: IA,
    gitInfo: CA,
    showToolbar: BA
  }), [n, t, dA, GA, g, d, k, H, AA, gA, IA, CA, BA]), yA = useMemo$1(() => ({
    isFullScreen: eA,
    setFullScreen: iA,
    addScriptFinishedHandler: QA,
    removeScriptFinishedHandler: tA,
    activeTheme: oA,
    setTheme: EA,
    availableThemes: aA,
    addThemes: nA,
    onPageChange: GA,
    currentPageScriptHash: dA,
    libConfig: lA,
    fragmentIdsThisRun: cA,
    locale: sA,
    scriptRunState: rA,
    scriptRunId: uA,
    componentRegistry: hA
  }), [eA, iA, QA, tA, oA, EA, aA, nA, GA, dA, lA, cA, sA, rA, uA, hA]), pA = {
    formsData: DA
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AppContext.Provider, { value: bA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(LibContext.Provider, { value: yA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormsContext.Provider, { value: pA, children: wA }) }) });
}, useAppContext = () => useRequiredContext(AppContext), StreamlitContextProvider$1 = memo$1(StreamlitContextProvider), StyledLogoContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby6"
} : {
  target: "ezrtsby6",
  label: "StyledLogoContainer"
})(({
  theme: n
}) => ({
  marginLeft: n.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeader$2 = /* @__PURE__ */ createStyled$1("header", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby5"
} : {
  target: "ezrtsby5",
  label: "StyledHeader"
})(({
  theme: n,
  isTransparentBackground: t
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  display: "flex",
  alignItems: "center",
  height: n.sizes.headerHeight,
  minHeight: n.sizes.headerHeight,
  width: "100%",
  background: t ? "transparent" : n.colors.bgColor,
  outline: "none",
  zIndex: n.zIndices.header,
  pointerEvents: t ? "none" : "auto",
  fontSize: n.fontSizes.sm,
  "@media print": {
    position: "absolute",
    background: "transparent",
    // Hide all descendants by default
    "& *": {
      display: "none !important"
    },
    // Show the logo container and its parents/contents
    [`& ${StyledLogoContainer}, & ${StyledLogoContainer} *, & :has(${StyledLogoContainer})`]: {
      display: "flex !important"
    },
    [`& ${StyledLogoContainer} img`]: {
      display: "block !important"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderToolbar = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby4"
} : {
  target: "ezrtsby4",
  label: "StyledHeaderToolbar"
})(({
  theme: n
}) => ({
  display: "flex",
  alignItems: "center",
  height: "100%",
  width: "100%",
  padding: 0,
  pointerEvents: "auto",
  position: "relative",
  zIndex: n.zIndices.header
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledOpenSidebarButton = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby3"
} : {
  target: "ezrtsby3",
  label: "StyledOpenSidebarButton"
})(({
  theme: n
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: n.spacing.lg,
  "@media print": {
    display: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderContent = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby2"
} : {
  target: "ezrtsby2",
  label: "StyledHeaderContent"
})(() => ({
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  margin: 0,
  border: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderLeftSection = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby1"
} : {
  target: "ezrtsby1",
  label: "StyledHeaderLeftSection"
})(() => ({
  display: "flex",
  alignItems: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9IZWFkZXIvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0d1QyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2NvbXBvbmVudHMvSGVhZGVyL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmltcG9ydCB7IEVtb3Rpb25UaGVtZSB9IGZyb20gXCJAc3RyZWFtbGl0L2xpYlwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRMb2dvQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLmxnLFxufSkpXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkSGVhZGVyUHJvcHMge1xuICBpc1RyYW5zcGFyZW50QmFja2dyb3VuZD86IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlciA9IHN0eWxlZC5oZWFkZXI8U3R5bGVkSGVhZGVyUHJvcHM+KFxuICAoeyB0aGVtZSwgaXNUcmFuc3BhcmVudEJhY2tncm91bmQgfSkgPT4gKHtcbiAgICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICAgIHRvcDogMCxcbiAgICBsZWZ0OiAwLFxuICAgIHJpZ2h0OiAwLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgaGVpZ2h0OiB0aGVtZS5zaXplcy5oZWFkZXJIZWlnaHQsXG4gICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5oZWFkZXJIZWlnaHQsXG4gICAgd2lkdGg6IFwiMTAwJVwiLFxuICAgIGJhY2tncm91bmQ6IGlzVHJhbnNwYXJlbnRCYWNrZ3JvdW5kID8gXCJ0cmFuc3BhcmVudFwiIDogdGhlbWUuY29sb3JzLmJnQ29sb3IsXG4gICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5oZWFkZXIsXG4gICAgcG9pbnRlckV2ZW50czogaXNUcmFuc3BhcmVudEJhY2tncm91bmQgPyBcIm5vbmVcIiA6IFwiYXV0b1wiLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgXCJAbWVkaWEgcHJpbnRcIjoge1xuICAgICAgcG9zaXRpb246IFwiYWJzb2x1dGVcIixcbiAgICAgIGJhY2tncm91bmQ6IFwidHJhbnNwYXJlbnRcIixcbiAgICAgIC8vIEhpZGUgYWxsIGRlc2NlbmRhbnRzIGJ5IGRlZmF1bHRcbiAgICAgIFwiJiAqXCI6IHtcbiAgICAgICAgZGlzcGxheTogXCJub25lICFpbXBvcnRhbnRcIixcbiAgICAgIH0sXG4gICAgICAvLyBTaG93IHRoZSBsb2dvIGNvbnRhaW5lciBhbmQgaXRzIHBhcmVudHMvY29udGVudHNcbiAgICAgIFtgJiAke1N0eWxlZExvZ29Db250YWluZXJ9LCAmICR7U3R5bGVkTG9nb0NvbnRhaW5lcn0gKiwgJiA6aGFzKCR7U3R5bGVkTG9nb0NvbnRhaW5lcn0pYF06XG4gICAgICAgIHtcbiAgICAgICAgICBkaXNwbGF5OiBcImZsZXggIWltcG9ydGFudFwiLFxuICAgICAgICB9LFxuICAgICAgW2AmICR7U3R5bGVkTG9nb0NvbnRhaW5lcn0gaW1nYF06IHtcbiAgICAgICAgZGlzcGxheTogXCJibG9jayAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJUb29sYmFyID0gc3R5bGVkLmRpdjx7XG4gIHRoZW1lOiBFbW90aW9uVGhlbWVcbn0+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBoZWlnaHQ6IFwiMTAwJVwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG4gIHBhZGRpbmc6IDAsXG4gIHBvaW50ZXJFdmVudHM6IFwiYXV0b1wiLFxuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICB6SW5kZXg6IHRoZW1lLnpJbmRpY2VzLmhlYWRlcixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkT3BlblNpZGViYXJCdXR0b24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5sZyxcbiAgW2BAbWVkaWEgcHJpbnRgXToge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJDb250ZW50ID0gc3R5bGVkLmRpdigoKSA9PiAoe1xuICBmbGV4U2hyaW5rOiAwLFxuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwic3BhY2UtYmV0d2VlblwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG4gIG1hcmdpbjogMCxcbiAgYm9yZGVyOiAwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJMZWZ0U2VjdGlvbiA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlclJpZ2h0U2VjdGlvbiA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZmxleFNocmluazogMCxcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImZsZXgtZW5kXCIsXG4gIG1hcmdpbkxlZnQ6IFwiYXV0b1wiLFxuICBoZWlnaHQ6IFwiMTAwJVwiLFxuICBtaW5XaWR0aDogdGhlbWUuc2l6ZXMuaGVhZGVyUmlnaHRDb250ZW50TWF4V2lkdGgsXG4gIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLmxnLFxufSkpXG4iXX0= */"), StyledHeaderRightSection = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby0"
} : {
  target: "ezrtsby0",
  label: "StyledHeaderRightSection"
})(({
  theme: n
}) => ({
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  marginLeft: "auto",
  height: "100%",
  minWidth: n.sizes.headerRightContentMaxWidth,
  marginRight: n.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Header = ({
  hasSidebar: n,
  isSidebarOpen: t,
  onToggleSidebar: g,
  navigation: d,
  rightContent: k,
  logoComponent: H
}) => {
  const {
    showToolbar: AA
  } = useAppContext(), {
    activeTheme: gA
  } = useContext(LibContext), IA = H && !t, CA = n && !t, BA = AA && k, eA = IA || CA || d || BA;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$2, { className: "stAppHeader", "data-testid": "stHeader", isTransparentBackground: !eA, children: eA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderToolbar, { className: "stAppToolbar", "data-testid": "stToolbar", theme: gA.emotion, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeaderContent, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeaderLeftSection, { children: [
      IA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLogoContainer, { children: H }) : null,
      CA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOpenSidebarButton, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_NO_PADDING, onClick: g, "data-testid": "stExpandSidebarButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "xl", iconValue: ":material/keyboard_double_arrow_right:", color: gA.emotion.colors.fadedText60 }) }) })
    ] }),
    d,
    BA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderRightSection, { children: k }) : null
  ] }) }) : null });
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$8() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const getSidebarHorizontalSpacing = (n, t) => `max(
    ${t}px,
    calc(${n.spacing.xl} - ${t}px)
  )`, StyledSidebar = /* @__PURE__ */ createStyled$1("section", process.env.NODE_ENV === "production" ? {
  target: "eczjsme8"
} : {
  target: "eczjsme8",
  label: "StyledSidebar"
})(({
  theme: n,
  isCollapsed: t,
  adjustTop: g,
  sidebarWidth: d,
  windowInnerWidth: k
}) => {
  const H = t ? 0 : Math.min(200, k), AA = t ? 0 : Math.min(600, k * 0.9);
  return {
    position: "relative",
    // Nudge the sidebar by 2px so the header decoration doesn't go below it
    top: g ? n.sizes.headerDecorationHeight : n.spacing.none,
    backgroundColor: n.colors.bgColor,
    // Since the sidebar can have a different theme (+ background)
    // we need to explicitly set the font color and color scheme
    // here again so that it is inherited correctly by all sidebar elements:
    color: n.colors.bodyText,
    colorScheme: hasLightBackgroundColor(n) ? "light" : "dark",
    zIndex: n.zIndices.header + 1,
    minWidth: H,
    maxWidth: AA,
    transform: t ? `translateX(-${d}px)` : "none",
    transition: "transform 300ms, min-width 300ms, max-width 300ms",
    "&:focus": {
      outline: "none"
    },
    [`@media (max-width: ${n.breakpoints.md})`]: {
      boxShadow: `-2rem 0 2rem 2rem ${t ? "transparent" : "#00000029"}`
    },
    "@media print": {
      display: t ? "none" : "initial",
      // set to auto, otherwise the sidebar does not take up the whole page
      height: "auto !important",
      // set maxHeight to little bit less than 100%, otherwise the sidebar might start a mostly blank page
      maxHeight: "99%",
      // on Chrome, sth. adds a box-shadow in printing mode which looks weird
      boxShadow: "none"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarUserContent = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme7"
} : {
  target: "eczjsme7",
  label: "StyledSidebarUserContent"
})(({
  hasPageNavAbove: n,
  theme: t
}) => ({
  paddingTop: n ? t.spacing.twoXL : 0,
  paddingBottom: t.sizes.sidebarTopSpace
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarContent = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme6"
} : {
  target: "eczjsme6",
  label: "StyledSidebarContent"
})(({
  theme: n,
  scrollbarGutterSize: t
}) => ({
  position: "relative",
  height: "100%",
  width: "100%",
  overflow: "auto",
  /**
   * Ensure that space is reserved for scrollbars, even when they are not
   * visible. This is necessary to prevent layout shifts when the scrollbars
   * appear and disappear.
   *
   * We utilize both-edges so that things look visually centered and aligned.
   *
   * @see https://github.com/streamlit/streamlit/issues/10310
   */
  scrollbarGutter: "stable both-edges",
  paddingLeft: getSidebarHorizontalSpacing(n, t),
  paddingRight: getSidebarHorizontalSpacing(n, t)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TaWRlYmFyL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRHb0MiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL1NpZGViYXIvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNSlcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lLCBoYXNMaWdodEJhY2tncm91bmRDb2xvciB9IGZyb20gXCJAc3RyZWFtbGl0L2xpYlwiXG5cbi8qKlxuICogUmV0dXJucyB0aGUgaG9yaXpvbnRhbCBzcGFjaW5nIGZvciB0aGUgc2lkZWJhciwgdGFraW5nIGludG8gY29uc2lkZXJhdGlvblxuICogdGhlIHNjcm9sbGJhciBndXR0ZXJzIChvbmUgb24gZWFjaCBzaWRlKSB3aGljaCBhcmUgcHJlc2VudCB3aGVuIHRoZSBPU1xuICogZG9lc24ndCBzdXBwb3J0IG92ZXJsYXkgc2Nyb2xsYmFycy5cbiAqXG4gKiBAcGFyYW0gdGhlbWUgVGhlIHRoZW1lIHRvIHVzZS5cbiAqIEByZXR1cm5zIFRoZSBob3Jpem9udGFsIHNwYWNpbmcgZm9yIHRoZSBzaWRlYmFyLlxuICovXG5leHBvcnQgY29uc3QgZ2V0U2lkZWJhckhvcml6b250YWxTcGFjaW5nID0gKFxuICB0aGVtZTogRW1vdGlvblRoZW1lLFxuICBzY3JvbGxiYXJHdXR0ZXJTaXplOiBudW1iZXJcbik6IHN0cmluZyA9PiB7XG4gIC8vIFRoaXMgc2hvdWxkIGJlIG1heCgwcHgsIC4uLiksIGJ1dCB0aGVyZSdzIGEgQ2hyb21lIGJ1ZyB0aGF0XG4gIC8vIGNhdXNlcyBjb250ZW50IHRvIGNsaXAgd2hlbiBzY3JvbGxiYXItZ3V0dGVyIGlzIHNldCB0byBcInN0YWJsZSBib3RoLWVkZ2VzXCIuXG4gIC8vIFNvIHdlIGNoYW5nZSB0aGUgbWluIGZyb20gMHB4IHRvIHNjcm9sbGJhckd1dHRlclNpemUgdG8gYWNjb3VudCBmb3IgdGhhdC5cbiAgLy8gQ2hyb21lIGJ1ZzogaHR0cHM6Ly9pc3N1ZXMuY2hyb21pdW0ub3JnL2lzc3Vlcy80MDA2NDg3OVxuICByZXR1cm4gYG1heChcbiAgICAke3Njcm9sbGJhckd1dHRlclNpemV9cHgsXG4gICAgY2FsYygke3RoZW1lLnNwYWNpbmcueGx9IC0gJHtzY3JvbGxiYXJHdXR0ZXJTaXplfXB4KVxuICApYFxufVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZFNpZGViYXJQcm9wcyB7XG4gIGlzQ29sbGFwc2VkOiBib29sZWFuXG4gIGFkanVzdFRvcDogYm9vbGVhblxuICBzaWRlYmFyV2lkdGg6IHN0cmluZ1xuICB3aW5kb3dJbm5lcldpZHRoOiBudW1iZXJcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXIgPSBzdHlsZWQuc2VjdGlvbjxTdHlsZWRTaWRlYmFyUHJvcHM+KFxuICAoeyB0aGVtZSwgaXNDb2xsYXBzZWQsIGFkanVzdFRvcCwgc2lkZWJhcldpZHRoLCB3aW5kb3dJbm5lcldpZHRoIH0pID0+IHtcbiAgICBjb25zdCBtaW5XaWR0aCA9IGlzQ29sbGFwc2VkID8gMCA6IE1hdGgubWluKDIwMCwgd2luZG93SW5uZXJXaWR0aClcbiAgICBjb25zdCBtYXhXaWR0aCA9IGlzQ29sbGFwc2VkID8gMCA6IE1hdGgubWluKDYwMCwgd2luZG93SW5uZXJXaWR0aCAqIDAuOSlcblxuICAgIHJldHVybiB7XG4gICAgICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICAgICAgLy8gTnVkZ2UgdGhlIHNpZGViYXIgYnkgMnB4IHNvIHRoZSBoZWFkZXIgZGVjb3JhdGlvbiBkb2Vzbid0IGdvIGJlbG93IGl0XG4gICAgICB0b3A6IGFkanVzdFRvcCA/IHRoZW1lLnNpemVzLmhlYWRlckRlY29yYXRpb25IZWlnaHQgOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgICAgLy8gU2luY2UgdGhlIHNpZGViYXIgY2FuIGhhdmUgYSBkaWZmZXJlbnQgdGhlbWUgKCsgYmFja2dyb3VuZClcbiAgICAgIC8vIHdlIG5lZWQgdG8gZXhwbGljaXRseSBzZXQgdGhlIGZvbnQgY29sb3IgYW5kIGNvbG9yIHNjaGVtZVxuICAgICAgLy8gaGVyZSBhZ2FpbiBzbyB0aGF0IGl0IGlzIGluaGVyaXRlZCBjb3JyZWN0bHkgYnkgYWxsIHNpZGViYXIgZWxlbWVudHM6XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgICAgY29sb3JTY2hlbWU6IGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yKHRoZW1lKSA/IFwibGlnaHRcIiA6IFwiZGFya1wiLFxuICAgICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5oZWFkZXIgKyAxLFxuXG4gICAgICBtaW5XaWR0aCxcbiAgICAgIG1heFdpZHRoLFxuICAgICAgdHJhbnNmb3JtOiBpc0NvbGxhcHNlZCA/IGB0cmFuc2xhdGVYKC0ke3NpZGViYXJXaWR0aH1weClgIDogXCJub25lXCIsXG4gICAgICB0cmFuc2l0aW9uOiBcInRyYW5zZm9ybSAzMDBtcywgbWluLXdpZHRoIDMwMG1zLCBtYXgtd2lkdGggMzAwbXNcIixcblxuICAgICAgXCImOmZvY3VzXCI6IHtcbiAgICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgICB9LFxuXG4gICAgICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLm1kfSlgXToge1xuICAgICAgICBib3hTaGFkb3c6IGAtMnJlbSAwIDJyZW0gMnJlbSAke1xuICAgICAgICAgIGlzQ29sbGFwc2VkID8gXCJ0cmFuc3BhcmVudFwiIDogXCIjMDAwMDAwMjlcIlxuICAgICAgICB9YCxcbiAgICAgIH0sXG5cbiAgICAgIFtgQG1lZGlhIHByaW50YF06IHtcbiAgICAgICAgZGlzcGxheTogaXNDb2xsYXBzZWQgPyBcIm5vbmVcIiA6IFwiaW5pdGlhbFwiLFxuICAgICAgICAvLyBzZXQgdG8gYXV0bywgb3RoZXJ3aXNlIHRoZSBzaWRlYmFyIGRvZXMgbm90IHRha2UgdXAgdGhlIHdob2xlIHBhZ2VcbiAgICAgICAgaGVpZ2h0OiBcImF1dG8gIWltcG9ydGFudFwiLFxuICAgICAgICAvLyBzZXQgbWF4SGVpZ2h0IHRvIGxpdHRsZSBiaXQgbGVzcyB0aGFuIDEwMCUsIG90aGVyd2lzZSB0aGUgc2lkZWJhciBtaWdodCBzdGFydCBhIG1vc3RseSBibGFuayBwYWdlXG4gICAgICAgIG1heEhlaWdodDogXCI5OSVcIixcbiAgICAgICAgLy8gb24gQ2hyb21lLCBzdGguIGFkZHMgYSBib3gtc2hhZG93IGluIHByaW50aW5nIG1vZGUgd2hpY2ggbG9va3Mgd2VpcmRcbiAgICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkU2lkZWJhclVzZXJDb250ZW50UHJvcHMge1xuICBoYXNQYWdlTmF2QWJvdmU6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJVc2VyQ29udGVudCA9XG4gIHN0eWxlZC5kaXY8U3R5bGVkU2lkZWJhclVzZXJDb250ZW50UHJvcHM+KCh7IGhhc1BhZ2VOYXZBYm92ZSwgdGhlbWUgfSkgPT4gKHtcbiAgICBwYWRkaW5nVG9wOiBoYXNQYWdlTmF2QWJvdmUgPyB0aGVtZS5zcGFjaW5nLnR3b1hMIDogMCxcbiAgICBwYWRkaW5nQm90dG9tOiB0aGVtZS5zaXplcy5zaWRlYmFyVG9wU3BhY2UsXG4gIH0pKVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZFNpZGViYXJDb250ZW50UHJvcHMge1xuICBzY3JvbGxiYXJHdXR0ZXJTaXplOiBudW1iZXJcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJDb250ZW50ID0gc3R5bGVkLmRpdjxTdHlsZWRTaWRlYmFyQ29udGVudFByb3BzPihcbiAgKHsgdGhlbWUsIHNjcm9sbGJhckd1dHRlclNpemUgfSkgPT4gKHtcbiAgICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICAgIGhlaWdodDogXCIxMDAlXCIsXG4gICAgd2lkdGg6IFwiMTAwJVwiLFxuICAgIG92ZXJmbG93OiBcImF1dG9cIixcbiAgICAvKipcbiAgICAgKiBFbnN1cmUgdGhhdCBzcGFjZSBpcyByZXNlcnZlZCBmb3Igc2Nyb2xsYmFycywgZXZlbiB3aGVuIHRoZXkgYXJlIG5vdFxuICAgICAqIHZpc2libGUuIFRoaXMgaXMgbmVjZXNzYXJ5IHRvIHByZXZlbnQgbGF5b3V0IHNoaWZ0cyB3aGVuIHRoZSBzY3JvbGxiYXJzXG4gICAgICogYXBwZWFyIGFuZCBkaXNhcHBlYXIuXG4gICAgICpcbiAgICAgKiBXZSB1dGlsaXplIGJvdGgtZWRnZXMgc28gdGhhdCB0aGluZ3MgbG9vayB2aXN1YWxseSBjZW50ZXJlZCBhbmQgYWxpZ25lZC5cbiAgICAgKlxuICAgICAqIEBzZWUgaHR0cHM6Ly9naXRodWIuY29tL3N0cmVhbWxpdC9zdHJlYW1saXQvaXNzdWVzLzEwMzEwXG4gICAgICovXG4gICAgc2Nyb2xsYmFyR3V0dGVyOiBcInN0YWJsZSBib3RoLWVkZ2VzXCIsXG4gICAgcGFkZGluZ0xlZnQ6IGdldFNpZGViYXJIb3Jpem9udGFsU3BhY2luZyh0aGVtZSwgc2Nyb2xsYmFyR3V0dGVyU2l6ZSksXG4gICAgcGFkZGluZ1JpZ2h0OiBnZXRTaWRlYmFySG9yaXpvbnRhbFNwYWNpbmcodGhlbWUsIHNjcm9sbGJhckd1dHRlclNpemUpLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgUkVTSVpFX0hBTkRMRV9XSURUSCA9IFwiOHB4XCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFJlc2l6ZUhhbmRsZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgcG9zaXRpb246IFwiYWJzb2x1dGVcIixcbiAgd2lkdGg6IFJFU0laRV9IQU5ETEVfV0lEVEgsXG4gIGhlaWdodDogXCIxMDAlXCIsXG4gIGN1cnNvcjogXCJjb2wtcmVzaXplXCIsXG4gIHpJbmRleDogdGhlbWUuekluZGljZXMuc2lkZWJhck1vYmlsZSxcbiAgYmFja2dyb3VuZEltYWdlOiB0aGVtZS5zaG93U2lkZWJhckJvcmRlclxuICAgID8gYGxpbmVhci1ncmFkaWVudCh0byByaWdodCwgdHJhbnNwYXJlbnQgMjAlLCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn0gMjglLCB0cmFuc3BhcmVudCAzNiUpYFxuICAgIDogXCJub25lXCIsXG5cbiAgXCImOmhvdmVyXCI6IHtcbiAgICBiYWNrZ3JvdW5kSW1hZ2U6IGBsaW5lYXItZ3JhZGllbnQodG8gcmlnaHQsIHRyYW5zcGFyZW50IDIwJSwgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9IDI4JSwgdHJhbnNwYXJlbnQgNDQlKWAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJIZWFkZXJDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJzcGFjZS1iZXR3ZWVuXCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5sZyxcbiAgaGVpZ2h0OiB0aGVtZS5zaXplcy5oZWFkZXJIZWlnaHQsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZExvZ29MaW5rID0gc3R5bGVkLmEoe1xuICBcIiY6aG92ZXJcIjoge1xuICAgIG9wYWNpdHk6IFwiMC43XCIsXG4gIH0sXG59KVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZExvZ29Qcm9wcyB7XG4gIHNpemU6IHN0cmluZ1xuICBzaWRlYmFyV2lkdGg/OiBzdHJpbmdcbn1cblxuLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnkgLS0gVE9ETzogUmVwbGFjZSAnYW55JyB3aXRoIGEgbW9yZSBzcGVjaWZpYyB0eXBlLlxuZnVuY3Rpb24gdHJhbnNsYXRlTG9nb0hlaWdodCh0aGVtZTogYW55LCBzaXplOiBzdHJpbmcpOiBzdHJpbmcge1xuICBpZiAoc2l6ZSA9PT0gXCJzbWFsbFwiKSB7XG4gICAgcmV0dXJuIHRoZW1lLnNpemVzLnNtYWxsTG9nb0hlaWdodFxuICB9IGVsc2UgaWYgKHNpemUgPT09IFwibGFyZ2VcIikge1xuICAgIHJldHVybiB0aGVtZS5zaXplcy5sYXJnZUxvZ29IZWlnaHRcbiAgfVxuICAvLyBEZWZhdWx0IGxvZ28gc2l6ZVxuICByZXR1cm4gdGhlbWUuc2l6ZXMuZGVmYXVsdExvZ29IZWlnaHRcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZExvZ28gPSBzdHlsZWQuaW1nPFN0eWxlZExvZ29Qcm9wcz4oKHsgdGhlbWUsIHNpemUgfSkgPT4gKHtcbiAgaGVpZ2h0OiB0cmFuc2xhdGVMb2dvSGVpZ2h0KHRoZW1lLCBzaXplKSxcbiAgLy8gRXh0cmEgbWFyZ2luIHRvIGFsaWduIHNtYWxsIGxvZ28gd2l0aCBzaWRlYmFyIGNvbGxhcHNlIGFycm93XG4gIG1hcmdpblRvcDogc2l6ZSA9PSBcInNtYWxsXCIgPyB0aGVtZS5zcGFjaW5nLnhzIDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgbWFyZ2luQm90dG9tOiBzaXplID09IFwic21hbGxcIiA/IHRoZW1lLnNwYWNpbmcueHMgOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIHpJbmRleDogdGhlbWUuekluZGljZXMuaGVhZGVyLFxuICBvYmplY3RGaXQ6IFwiY29udGFpblwiLFxuICBvYmplY3RQb3NpdGlvbjogXCJsZWZ0XCIsXG4gIHZlcnRpY2FsQWxpZ246IFwibWlkZGxlXCIsXG4gIG1heFdpZHRoOiBgMTAwJWAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5vTG9nb1NwYWNlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgaGVpZ2h0OiB0aGVtZS5zaXplcy5sYXJnZUxvZ29IZWlnaHQsXG59KSlcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRDb2xsYXBzZVNpZGViYXJCdXR0b25Qcm9wcyB7XG4gIHNob3dTaWRlYmFyQ29sbGFwc2U6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvbGxhcHNlU2lkZWJhckJ1dHRvbiA9XG4gIHN0eWxlZC5kaXY8U3R5bGVkQ29sbGFwc2VTaWRlYmFyQnV0dG9uUHJvcHM+KFxuICAgICh7IHNob3dTaWRlYmFyQ29sbGFwc2UsIHRoZW1lIH0pID0+IHtcbiAgICAgIHJldHVybiB7XG4gICAgICAgIGRpc3BsYXk6IFwiaW5saW5lXCIsXG4gICAgICAgIHZpc2liaWxpdHk6IHNob3dTaWRlYmFyQ29sbGFwc2UgPyBcInZpc2libGVcIiA6IFwiaGlkZGVuXCIsXG4gICAgICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgICAgIHRyYW5zaXRpb246IFwibGVmdCAzMDBtc1wiLFxuICAgICAgICB0cmFuc2l0aW9uRGVsYXk6IFwibGVmdCAzMDBtc1wiLFxuICAgICAgICBjb2xvcjogaGFzTGlnaHRCYWNrZ3JvdW5kQ29sb3IodGhlbWUpXG4gICAgICAgICAgPyB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjBcbiAgICAgICAgICA6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICAgICAgbGluZUhlaWdodDogXCIwXCIsXG5cbiAgICAgICAgW2BAbWVkaWEgcHJpbnRgXToge1xuICAgICAgICAgIC8vIEFsd2F5cyBoaWRlIHRoZSBjb2xsYXBzZSBidXR0b24gb24gcHJpbnQ6XG4gICAgICAgICAgdmlzaWJpbGl0eTogXCJoaWRkZW5cIixcbiAgICAgICAgfSxcblxuICAgICAgICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgICAgICAgIC8vIEFsd2F5cyBzaG93IHRoZSBjb2xsYXBzZSBidXR0b24gb24gc21hbGwgc2NyZWVuczpcbiAgICAgICAgICB2aXNpYmlsaXR5OiBcInZpc2libGVcIixcbiAgICAgICAgfSxcbiAgICAgIH1cbiAgICB9XG4gIClcbiJdfQ== */"), RESIZE_HANDLE_WIDTH = "8px", StyledResizeHandle = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme5"
} : {
  target: "eczjsme5",
  label: "StyledResizeHandle"
})(({
  theme: n
}) => ({
  position: "absolute",
  width: RESIZE_HANDLE_WIDTH,
  height: "100%",
  cursor: "col-resize",
  zIndex: n.zIndices.sidebarMobile,
  backgroundImage: n.showSidebarBorder ? `linear-gradient(to right, transparent 20%, ${n.colors.borderColor} 28%, transparent 36%)` : "none",
  "&:hover": {
    backgroundImage: `linear-gradient(to right, transparent 20%, ${n.colors.borderColor} 28%, transparent 44%)`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarHeaderContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme4"
} : {
  target: "eczjsme4",
  label: "StyledSidebarHeaderContainer"
})(({
  theme: n
}) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: n.spacing.lg,
  height: n.sizes.headerHeight
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLogoLink = /* @__PURE__ */ createStyled$1("a", process.env.NODE_ENV === "production" ? {
  target: "eczjsme3"
} : {
  target: "eczjsme3",
  label: "StyledLogoLink"
})(process.env.NODE_ENV === "production" ? {
  name: "t02jc9",
  styles: "&:hover{opacity:0.7;}"
} : {
  name: "t02jc9",
  styles: "&:hover{opacity:0.7;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
});
function translateLogoHeight(n, t) {
  return t === "small" ? n.sizes.smallLogoHeight : t === "large" ? n.sizes.largeLogoHeight : n.sizes.defaultLogoHeight;
}
const StyledLogo = /* @__PURE__ */ createStyled$1("img", process.env.NODE_ENV === "production" ? {
  target: "eczjsme2"
} : {
  target: "eczjsme2",
  label: "StyledLogo"
})(({
  theme: n,
  size: t
}) => ({
  height: translateLogoHeight(n, t),
  // Extra margin to align small logo with sidebar collapse arrow
  marginTop: t == "small" ? n.spacing.xs : n.spacing.twoXS,
  marginBottom: t == "small" ? n.spacing.xs : n.spacing.twoXS,
  marginLeft: n.spacing.none,
  zIndex: n.zIndices.header,
  objectFit: "contain",
  objectPosition: "left",
  verticalAlign: "middle",
  maxWidth: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNoLogoSpacer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme1"
} : {
  target: "eczjsme1",
  label: "StyledNoLogoSpacer"
})(({
  theme: n
}) => ({
  height: n.sizes.largeLogoHeight
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCollapseSidebarButton = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme0"
} : {
  target: "eczjsme0",
  label: "StyledCollapseSidebarButton"
})(({
  showSidebarCollapse: n,
  theme: t
}) => ({
  display: "inline",
  visibility: n ? "visible" : "hidden",
  marginLeft: t.spacing.sm,
  transition: "left 300ms",
  transitionDelay: "left 300ms",
  color: hasLightBackgroundColor(t) ? t.colors.fadedText60 : t.colors.bodyText,
  lineHeight: "0",
  "@media print": {
    // Always hide the collapse button on print:
    visibility: "hidden"
  },
  [`@media (max-width: ${t.breakpoints.sm})`]: {
    // Always show the collapse button on small screens:
    visibility: "visible"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TaWRlYmFyL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXNNRSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2NvbXBvbmVudHMvU2lkZWJhci9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5pbXBvcnQgeyBFbW90aW9uVGhlbWUsIGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuLyoqXG4gKiBSZXR1cm5zIHRoZSBob3Jpem9udGFsIHNwYWNpbmcgZm9yIHRoZSBzaWRlYmFyLCB0YWtpbmcgaW50byBjb25zaWRlcmF0aW9uXG4gKiB0aGUgc2Nyb2xsYmFyIGd1dHRlcnMgKG9uZSBvbiBlYWNoIHNpZGUpIHdoaWNoIGFyZSBwcmVzZW50IHdoZW4gdGhlIE9TXG4gKiBkb2Vzbid0IHN1cHBvcnQgb3ZlcmxheSBzY3JvbGxiYXJzLlxuICpcbiAqIEBwYXJhbSB0aGVtZSBUaGUgdGhlbWUgdG8gdXNlLlxuICogQHJldHVybnMgVGhlIGhvcml6b250YWwgc3BhY2luZyBmb3IgdGhlIHNpZGViYXIuXG4gKi9cbmV4cG9ydCBjb25zdCBnZXRTaWRlYmFySG9yaXpvbnRhbFNwYWNpbmcgPSAoXG4gIHRoZW1lOiBFbW90aW9uVGhlbWUsXG4gIHNjcm9sbGJhckd1dHRlclNpemU6IG51bWJlclxuKTogc3RyaW5nID0+IHtcbiAgLy8gVGhpcyBzaG91bGQgYmUgbWF4KDBweCwgLi4uKSwgYnV0IHRoZXJlJ3MgYSBDaHJvbWUgYnVnIHRoYXRcbiAgLy8gY2F1c2VzIGNvbnRlbnQgdG8gY2xpcCB3aGVuIHNjcm9sbGJhci1ndXR0ZXIgaXMgc2V0IHRvIFwic3RhYmxlIGJvdGgtZWRnZXNcIi5cbiAgLy8gU28gd2UgY2hhbmdlIHRoZSBtaW4gZnJvbSAwcHggdG8gc2Nyb2xsYmFyR3V0dGVyU2l6ZSB0byBhY2NvdW50IGZvciB0aGF0LlxuICAvLyBDaHJvbWUgYnVnOiBodHRwczovL2lzc3Vlcy5jaHJvbWl1bS5vcmcvaXNzdWVzLzQwMDY0ODc5XG4gIHJldHVybiBgbWF4KFxuICAgICR7c2Nyb2xsYmFyR3V0dGVyU2l6ZX1weCxcbiAgICBjYWxjKCR7dGhlbWUuc3BhY2luZy54bH0gLSAke3Njcm9sbGJhckd1dHRlclNpemV9cHgpXG4gIClgXG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkU2lkZWJhclByb3BzIHtcbiAgaXNDb2xsYXBzZWQ6IGJvb2xlYW5cbiAgYWRqdXN0VG9wOiBib29sZWFuXG4gIHNpZGViYXJXaWR0aDogc3RyaW5nXG4gIHdpbmRvd0lubmVyV2lkdGg6IG51bWJlclxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhciA9IHN0eWxlZC5zZWN0aW9uPFN0eWxlZFNpZGViYXJQcm9wcz4oXG4gICh7IHRoZW1lLCBpc0NvbGxhcHNlZCwgYWRqdXN0VG9wLCBzaWRlYmFyV2lkdGgsIHdpbmRvd0lubmVyV2lkdGggfSkgPT4ge1xuICAgIGNvbnN0IG1pbldpZHRoID0gaXNDb2xsYXBzZWQgPyAwIDogTWF0aC5taW4oMjAwLCB3aW5kb3dJbm5lcldpZHRoKVxuICAgIGNvbnN0IG1heFdpZHRoID0gaXNDb2xsYXBzZWQgPyAwIDogTWF0aC5taW4oNjAwLCB3aW5kb3dJbm5lcldpZHRoICogMC45KVxuXG4gICAgcmV0dXJuIHtcbiAgICAgIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gICAgICAvLyBOdWRnZSB0aGUgc2lkZWJhciBieSAycHggc28gdGhlIGhlYWRlciBkZWNvcmF0aW9uIGRvZXNuJ3QgZ28gYmVsb3cgaXRcbiAgICAgIHRvcDogYWRqdXN0VG9wID8gdGhlbWUuc2l6ZXMuaGVhZGVyRGVjb3JhdGlvbkhlaWdodCA6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmJnQ29sb3IsXG4gICAgICAvLyBTaW5jZSB0aGUgc2lkZWJhciBjYW4gaGF2ZSBhIGRpZmZlcmVudCB0aGVtZSAoKyBiYWNrZ3JvdW5kKVxuICAgICAgLy8gd2UgbmVlZCB0byBleHBsaWNpdGx5IHNldCB0aGUgZm9udCBjb2xvciBhbmQgY29sb3Igc2NoZW1lXG4gICAgICAvLyBoZXJlIGFnYWluIHNvIHRoYXQgaXQgaXMgaW5oZXJpdGVkIGNvcnJlY3RseSBieSBhbGwgc2lkZWJhciBlbGVtZW50czpcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgICBjb2xvclNjaGVtZTogaGFzTGlnaHRCYWNrZ3JvdW5kQ29sb3IodGhlbWUpID8gXCJsaWdodFwiIDogXCJkYXJrXCIsXG4gICAgICB6SW5kZXg6IHRoZW1lLnpJbmRpY2VzLmhlYWRlciArIDEsXG5cbiAgICAgIG1pbldpZHRoLFxuICAgICAgbWF4V2lkdGgsXG4gICAgICB0cmFuc2Zvcm06IGlzQ29sbGFwc2VkID8gYHRyYW5zbGF0ZVgoLSR7c2lkZWJhcldpZHRofXB4KWAgOiBcIm5vbmVcIixcbiAgICAgIHRyYW5zaXRpb246IFwidHJhbnNmb3JtIDMwMG1zLCBtaW4td2lkdGggMzAwbXMsIG1heC13aWR0aCAzMDBtc1wiLFxuXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG5cbiAgICAgIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMubWR9KWBdOiB7XG4gICAgICAgIGJveFNoYWRvdzogYC0ycmVtIDAgMnJlbSAycmVtICR7XG4gICAgICAgICAgaXNDb2xsYXBzZWQgPyBcInRyYW5zcGFyZW50XCIgOiBcIiMwMDAwMDAyOVwiXG4gICAgICAgIH1gLFxuICAgICAgfSxcblxuICAgICAgW2BAbWVkaWEgcHJpbnRgXToge1xuICAgICAgICBkaXNwbGF5OiBpc0NvbGxhcHNlZCA/IFwibm9uZVwiIDogXCJpbml0aWFsXCIsXG4gICAgICAgIC8vIHNldCB0byBhdXRvLCBvdGhlcndpc2UgdGhlIHNpZGViYXIgZG9lcyBub3QgdGFrZSB1cCB0aGUgd2hvbGUgcGFnZVxuICAgICAgICBoZWlnaHQ6IFwiYXV0byAhaW1wb3J0YW50XCIsXG4gICAgICAgIC8vIHNldCBtYXhIZWlnaHQgdG8gbGl0dGxlIGJpdCBsZXNzIHRoYW4gMTAwJSwgb3RoZXJ3aXNlIHRoZSBzaWRlYmFyIG1pZ2h0IHN0YXJ0IGEgbW9zdGx5IGJsYW5rIHBhZ2VcbiAgICAgICAgbWF4SGVpZ2h0OiBcIjk5JVwiLFxuICAgICAgICAvLyBvbiBDaHJvbWUsIHN0aC4gYWRkcyBhIGJveC1zaGFkb3cgaW4gcHJpbnRpbmcgbW9kZSB3aGljaCBsb29rcyB3ZWlyZFxuICAgICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgICAgfSxcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRTaWRlYmFyVXNlckNvbnRlbnRQcm9wcyB7XG4gIGhhc1BhZ2VOYXZBYm92ZTogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhclVzZXJDb250ZW50ID1cbiAgc3R5bGVkLmRpdjxTdHlsZWRTaWRlYmFyVXNlckNvbnRlbnRQcm9wcz4oKHsgaGFzUGFnZU5hdkFib3ZlLCB0aGVtZSB9KSA9PiAoe1xuICAgIHBhZGRpbmdUb3A6IGhhc1BhZ2VOYXZBYm92ZSA/IHRoZW1lLnNwYWNpbmcudHdvWEwgOiAwLFxuICAgIHBhZGRpbmdCb3R0b206IHRoZW1lLnNpemVzLnNpZGViYXJUb3BTcGFjZSxcbiAgfSkpXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkU2lkZWJhckNvbnRlbnRQcm9wcyB7XG4gIHNjcm9sbGJhckd1dHRlclNpemU6IG51bWJlclxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhckNvbnRlbnQgPSBzdHlsZWQuZGl2PFN0eWxlZFNpZGViYXJDb250ZW50UHJvcHM+KFxuICAoeyB0aGVtZSwgc2Nyb2xsYmFyR3V0dGVyU2l6ZSB9KSA9PiAoe1xuICAgIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gICAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgICB3aWR0aDogXCIxMDAlXCIsXG4gICAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxuICAgIC8qKlxuICAgICAqIEVuc3VyZSB0aGF0IHNwYWNlIGlzIHJlc2VydmVkIGZvciBzY3JvbGxiYXJzLCBldmVuIHdoZW4gdGhleSBhcmUgbm90XG4gICAgICogdmlzaWJsZS4gVGhpcyBpcyBuZWNlc3NhcnkgdG8gcHJldmVudCBsYXlvdXQgc2hpZnRzIHdoZW4gdGhlIHNjcm9sbGJhcnNcbiAgICAgKiBhcHBlYXIgYW5kIGRpc2FwcGVhci5cbiAgICAgKlxuICAgICAqIFdlIHV0aWxpemUgYm90aC1lZGdlcyBzbyB0aGF0IHRoaW5ncyBsb29rIHZpc3VhbGx5IGNlbnRlcmVkIGFuZCBhbGlnbmVkLlxuICAgICAqXG4gICAgICogQHNlZSBodHRwczovL2dpdGh1Yi5jb20vc3RyZWFtbGl0L3N0cmVhbWxpdC9pc3N1ZXMvMTAzMTBcbiAgICAgKi9cbiAgICBzY3JvbGxiYXJHdXR0ZXI6IFwic3RhYmxlIGJvdGgtZWRnZXNcIixcbiAgICBwYWRkaW5nTGVmdDogZ2V0U2lkZWJhckhvcml6b250YWxTcGFjaW5nKHRoZW1lLCBzY3JvbGxiYXJHdXR0ZXJTaXplKSxcbiAgICBwYWRkaW5nUmlnaHQ6IGdldFNpZGViYXJIb3Jpem9udGFsU3BhY2luZyh0aGVtZSwgc2Nyb2xsYmFyR3V0dGVyU2l6ZSksXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBSRVNJWkVfSEFORExFX1dJRFRIID0gXCI4cHhcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkUmVzaXplSGFuZGxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICB3aWR0aDogUkVTSVpFX0hBTkRMRV9XSURUSCxcbiAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgY3Vyc29yOiBcImNvbC1yZXNpemVcIixcbiAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5zaWRlYmFyTW9iaWxlLFxuICBiYWNrZ3JvdW5kSW1hZ2U6IHRoZW1lLnNob3dTaWRlYmFyQm9yZGVyXG4gICAgPyBgbGluZWFyLWdyYWRpZW50KHRvIHJpZ2h0LCB0cmFuc3BhcmVudCAyMCUsICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfSAyOCUsIHRyYW5zcGFyZW50IDM2JSlgXG4gICAgOiBcIm5vbmVcIixcblxuICBcIiY6aG92ZXJcIjoge1xuICAgIGJhY2tncm91bmRJbWFnZTogYGxpbmVhci1ncmFkaWVudCh0byByaWdodCwgdHJhbnNwYXJlbnQgMjAlLCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn0gMjglLCB0cmFuc3BhcmVudCA0NCUpYCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhckhlYWRlckNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGp1c3RpZnlDb250ZW50OiBcInNwYWNlLWJldHdlZW5cIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLmxnLFxuICBoZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckhlaWdodCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTG9nb0xpbmsgPSBzdHlsZWQuYSh7XG4gIFwiJjpob3ZlclwiOiB7XG4gICAgb3BhY2l0eTogXCIwLjdcIixcbiAgfSxcbn0pXG5cbmV4cG9ydCBpbnRlcmZhY2UgU3R5bGVkTG9nb1Byb3BzIHtcbiAgc2l6ZTogc3RyaW5nXG4gIHNpZGViYXJXaWR0aD86IHN0cmluZ1xufVxuXG4vLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgQHR5cGVzY3JpcHQtZXNsaW50L25vLWV4cGxpY2l0LWFueSAtLSBUT0RPOiBSZXBsYWNlICdhbnknIHdpdGggYSBtb3JlIHNwZWNpZmljIHR5cGUuXG5mdW5jdGlvbiB0cmFuc2xhdGVMb2dvSGVpZ2h0KHRoZW1lOiBhbnksIHNpemU6IHN0cmluZyk6IHN0cmluZyB7XG4gIGlmIChzaXplID09PSBcInNtYWxsXCIpIHtcbiAgICByZXR1cm4gdGhlbWUuc2l6ZXMuc21hbGxMb2dvSGVpZ2h0XG4gIH0gZWxzZSBpZiAoc2l6ZSA9PT0gXCJsYXJnZVwiKSB7XG4gICAgcmV0dXJuIHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodFxuICB9XG4gIC8vIERlZmF1bHQgbG9nbyBzaXplXG4gIHJldHVybiB0aGVtZS5zaXplcy5kZWZhdWx0TG9nb0hlaWdodFxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTG9nbyA9IHN0eWxlZC5pbWc8U3R5bGVkTG9nb1Byb3BzPigoeyB0aGVtZSwgc2l6ZSB9KSA9PiAoe1xuICBoZWlnaHQ6IHRyYW5zbGF0ZUxvZ29IZWlnaHQodGhlbWUsIHNpemUpLFxuICAvLyBFeHRyYSBtYXJnaW4gdG8gYWxpZ24gc21hbGwgbG9nbyB3aXRoIHNpZGViYXIgY29sbGFwc2UgYXJyb3dcbiAgbWFyZ2luVG9wOiBzaXplID09IFwic21hbGxcIiA/IHRoZW1lLnNwYWNpbmcueHMgOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICBtYXJnaW5Cb3R0b206IHNpemUgPT0gXCJzbWFsbFwiID8gdGhlbWUuc3BhY2luZy54cyA6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5oZWFkZXIsXG4gIG9iamVjdEZpdDogXCJjb250YWluXCIsXG4gIG9iamVjdFBvc2l0aW9uOiBcImxlZnRcIixcbiAgdmVydGljYWxBbGlnbjogXCJtaWRkbGVcIixcbiAgbWF4V2lkdGg6IGAxMDAlYCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTm9Mb2dvU3BhY2VyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBoZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbn0pKVxuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlZENvbGxhcHNlU2lkZWJhckJ1dHRvblByb3BzIHtcbiAgc2hvd1NpZGViYXJDb2xsYXBzZTogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQ29sbGFwc2VTaWRlYmFyQnV0dG9uID1cbiAgc3R5bGVkLmRpdjxTdHlsZWRDb2xsYXBzZVNpZGViYXJCdXR0b25Qcm9wcz4oXG4gICAgKHsgc2hvd1NpZGViYXJDb2xsYXBzZSwgdGhlbWUgfSkgPT4ge1xuICAgICAgcmV0dXJuIHtcbiAgICAgICAgZGlzcGxheTogXCJpbmxpbmVcIixcbiAgICAgICAgdmlzaWJpbGl0eTogc2hvd1NpZGViYXJDb2xsYXBzZSA/IFwidmlzaWJsZVwiIDogXCJoaWRkZW5cIixcbiAgICAgICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICAgICAgdHJhbnNpdGlvbjogXCJsZWZ0IDMwMG1zXCIsXG4gICAgICAgIHRyYW5zaXRpb25EZWxheTogXCJsZWZ0IDMwMG1zXCIsXG4gICAgICAgIGNvbG9yOiBoYXNMaWdodEJhY2tncm91bmRDb2xvcih0aGVtZSlcbiAgICAgICAgICA/IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ2MFxuICAgICAgICAgIDogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgICAgICBsaW5lSGVpZ2h0OiBcIjBcIixcblxuICAgICAgICBbYEBtZWRpYSBwcmludGBdOiB7XG4gICAgICAgICAgLy8gQWx3YXlzIGhpZGUgdGhlIGNvbGxhcHNlIGJ1dHRvbiBvbiBwcmludDpcbiAgICAgICAgICB2aXNpYmlsaXR5OiBcImhpZGRlblwiLFxuICAgICAgICB9LFxuXG4gICAgICAgIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMuc219KWBdOiB7XG4gICAgICAgICAgLy8gQWx3YXlzIHNob3cgdGhlIGNvbGxhcHNlIGJ1dHRvbiBvbiBzbWFsbCBzY3JlZW5zOlxuICAgICAgICAgIHZpc2liaWxpdHk6IFwidmlzaWJsZVwiLFxuICAgICAgICB9LFxuICAgICAgfVxuICAgIH1cbiAgKVxuIl19 */"), LOG$6 = loglevelExports$1.getLogger("LogoComponent"), LogoComponent = ({
  appLogo: n,
  endpoints: t,
  collapsed: g = !1,
  componentName: d = "Logo",
  dataTestId: k = "stLogo"
}) => {
  const {
    libConfig: H
  } = useContext(LibContext);
  if (n = useStliteResolvedLogo(n), !n)
    return null;
  const AA = (eA) => {
    LOG$6.error(`Client Error: ${d} source error - ${eA}`), t.sendClientErrorToHost(d, "Logo source failed to load", "onerror triggered", eA);
  }, gA = g && n.iconImage ? n.iconImage : n.image, IA = t.buildMediaURL(gA), CA = getCrossOriginAttribute(H.resourceCrossOriginMode, gA), BA = /* @__PURE__ */ jsxRuntimeExports.jsx(
    StyledLogo,
    {
      src: IA,
      size: n.size,
      alt: "Logo",
      className: "stLogo",
      "data-testid": k,
      onError: (eA) => AA(IA),
      crossOrigin: CA
    }
  );
  return n.link ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLogoLink, { href: n.link, target: "_blank", rel: "noreferrer", "data-testid": "stLogoLink", children: BA }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: BA });
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$7() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const getNavTextColor = (n, t, g = !1, d) => {
  if (g)
    return n.colors.fadedText40;
  if (d)
    return n.colors.bodyText;
  const k = hasLightBackgroundColor(n);
  return t ? n.colors.bodyText : k ? transparentize(n.colors.bodyText, 0.2) : transparentize(n.colors.bodyText, 0.25);
}, StyledSidebarNavContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl920"
} : {
  target: "e10lwvl920",
  label: "StyledSidebarNavContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
}), StyledSidebarNavItems = /* @__PURE__ */ createStyled$1("ul", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl919"
} : {
  target: "e10lwvl919",
  label: "StyledSidebarNavItems"
})(({
  theme: n
}) => ({
  listStyle: "none",
  margin: n.spacing.none,
  paddingBottom: n.spacing.threeXS,
  paddingTop: n.spacing.none,
  paddingRight: n.spacing.none,
  paddingLeft: n.spacing.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavLinkContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl918"
} : {
  target: "e10lwvl918",
  label: "StyledSidebarNavLinkContainer"
})(({
  disabled: n
}) => ({
  display: "flex",
  flexDirection: "column",
  cursor: n ? "not-allowed" : "pointer"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavIcon = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl917"
} : {
  target: "e10lwvl917",
  label: "StyledSidebarNavIcon"
})(({
  theme: n,
  isActive: t
}) => ({
  display: "inline-flex",
  // Apply a different font weight to the icon if it is active
  // The icon is in a span element.
  span: {
    fontWeight: t ? n.fontWeights.bold : n.fontWeights.normal
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavLinkListItem = /* @__PURE__ */ createStyled$1("li", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl916"
} : {
  target: "e10lwvl916",
  label: "StyledSidebarNavLinkListItem"
})(({
  theme: n
}) => ({
  marginTop: n.spacing.threeXS,
  marginBottom: n.spacing.threeXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavLink = /* @__PURE__ */ createStyled$1("a", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl915"
} : {
  target: "e10lwvl915",
  label: "StyledSidebarNavLink"
})(({
  theme: n,
  isActive: t,
  disabled: g
}) => {
  const d = {
    textDecoration: "none",
    fontWeight: t ? n.fontWeights.bold : n.fontWeights.normal
  };
  return {
    ...d,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: n.spacing.sm,
    borderRadius: n.radii.default,
    paddingLeft: n.spacing.sm,
    paddingRight: n.spacing.sm,
    marginTop: n.spacing.threeXS,
    marginBottom: n.spacing.threeXS,
    lineHeight: n.lineHeights.menuItem,
    color: getNavTextColor(n, t),
    backgroundColor: t ? n.colors.darkenedBgMix25 : "transparent",
    ...g && {
      pointerEvents: "none"
    },
    "&:hover": {
      backgroundColor: n.colors.darkenedBgMix15
    },
    "&:active,&:visited,&:hover": {
      ...d
    },
    "&:focus": {
      outline: "none"
    },
    "&:focus-visible": {
      backgroundColor: n.colors.darkenedBgMix15
    },
    "@media print": {
      paddingLeft: n.spacing.none
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarLinkText = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl914"
} : {
  target: "e10lwvl914",
  label: "StyledSidebarLinkText"
})(({
  isActive: n,
  theme: t,
  disabled: g,
  isTopNav: d,
  label: k
}) => ({
  color: getNavTextColor(t, n, g, d),
  fontSize: t.fontSizes.sm,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  display: "table-cell",
  /* Pseudo-element to reserve bold width */
  "&::after": {
    content: `"${k}"`,
    fontWeight: t.fontWeights.bold,
    visibility: "hidden",
    display: "block",
    width: "fit-content",
    height: 0
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledChevronContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl913"
} : {
  target: "e10lwvl913",
  label: "StyledChevronContainer"
})(({
  isExpanded: n
}) => ({
  visibility: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transform: n ? "rotate(0deg)" : "rotate(-90deg)",
  transition: "transform 200ms ease",
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSectionHeaderText = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl912"
} : {
  target: "e10lwvl912",
  label: "StyledNavSectionHeaderText"
})(() => ({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  minWidth: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavSectionHeader = /* @__PURE__ */ createStyled$1("header", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl911"
} : {
  target: "e10lwvl911",
  label: "StyledSidebarNavSectionHeader"
})(({
  theme: n
}) => ({
  fontSize: n.fontSizes.sm,
  fontWeight: n.fontWeights.semiBold,
  color: getNavTextColor(n, !1),
  lineHeight: n.lineHeights.small,
  paddingRight: n.spacing.sm,
  marginTop: n.spacing.sm,
  marginBottom: n.spacing.twoXS,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: n.spacing.sm,
  cursor: "pointer",
  userSelect: "none",
  "&:hover": {
    [`& > ${StyledChevronContainer}`]: {
      visibility: "visible"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledViewButton = /* @__PURE__ */ createStyled$1("button", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl910"
} : {
  target: "e10lwvl910",
  label: "StyledViewButton"
})(({
  theme: n
}) => ({
  fontSize: n.fontSizes.sm,
  fontFamily: "inherit",
  lineHeight: n.lineHeights.base,
  color: getNavTextColor(n, !0),
  backgroundColor: n.colors.transparent,
  border: "none",
  borderRadius: n.radii.default,
  marginTop: n.spacing.twoXS,
  marginLeft: n.spacing.none,
  marginBottom: n.spacing.none,
  marginRight: n.spacing.none,
  padding: `${n.spacing.threeXS} ${n.spacing.sm}`,
  "&:hover, &:active, &:focus": {
    border: "none",
    outline: "none",
    boxShadow: "none"
  },
  "&:hover": {
    backgroundColor: n.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavSeparator = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl99"
} : {
  target: "e10lwvl99",
  label: "StyledSidebarNavSeparator"
})(({
  theme: n
}) => ({
  paddingTop: n.spacing.lg,
  borderBottom: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSectionContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl98"
} : {
  target: "e10lwvl98",
  label: "StyledNavSectionContainer"
})(({
  theme: n
}) => ({
  "&:not(:first-child)": {
    marginTop: n.spacing.lg
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledOverflowContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl97"
} : {
  target: "e10lwvl97",
  label: "StyledOverflowContainer"
})(({
  theme: n
}) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  flexShrink: 1,
  overflow: "hidden",
  padding: `0 ${n.spacing.lg}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSection = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl96"
} : {
  target: "e10lwvl96",
  label: "StyledNavSection"
})(({
  theme: n,
  isOpen: t
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  position: "relative",
  lineHeight: n.lineHeights.menuItem,
  fontSize: n.fontSizes.sm,
  padding: `0 ${n.spacing.sm}`,
  color: getNavTextColor(n, !1, !1, !0),
  borderRadius: n.radii.default,
  marginRight: n.spacing.twoXS,
  "&:not(:first-of-type)": {
    marginLeft: n.spacing.twoXS
  },
  ...t ? {
    backgroundColor: n.colors.darkenedBgMix25
  } : {},
  "&:hover": {
    backgroundColor: n.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTopNavLinkContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl95"
} : {
  target: "e10lwvl95",
  label: "StyledTopNavLinkContainer"
})(({
  theme: n
}) => ({
  marginRight: n.spacing.twoXS,
  "&:not(:first-of-type)": {
    marginLeft: n.spacing.twoXS
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTopNavSidebarNavLinkContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl94"
} : {
  target: "e10lwvl94",
  label: "StyledTopNavSidebarNavLinkContainer"
})(({
  theme: n
}) => ({
  margin: `${n.spacing.twoXS} ${n.spacing.sm}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSectionText = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl93"
} : {
  target: "e10lwvl93",
  label: "StyledNavSectionText"
})(() => ({
  whiteSpace: "nowrap"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSectionName = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl92"
} : {
  target: "e10lwvl92",
  label: "StyledSectionName"
})(({
  theme: n
}) => ({
  marginLeft: n.spacing.sm,
  marginTop: n.spacing.sm,
  marginBottom: n.spacing.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPopoverContent = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl91"
} : {
  target: "e10lwvl91",
  label: "StyledPopoverContent"
})(({
  theme: n
}) => ({
  padding: `${n.spacing.twoXS} 0`,
  fontSize: n.fontSizes.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIconContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl90"
} : {
  target: "e10lwvl90",
  label: "StyledIconContainer"
})(({
  theme: n
}) => ({
  marginLeft: n.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), NavSection = ({
  header: n = "",
  children: t,
  isExpanded: g,
  onToggle: d
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledNavSectionContainer, { children: [
  n && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarNavSectionHeader, { "data-testid": "stNavSectionHeader", onClick: d, isExpanded: g, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNavSectionHeaderText, { children: n }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledChevronContainer, { isExpanded: g, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: ":material/expand_more:", size: "lg" }) })
  ] }),
  g && t
] }), SidebarNavLink = ({
  isActive: n,
  pageUrl: t,
  icon: g,
  onClick: d,
  isTopNav: k,
  isInDropdown: H,
  children: AA
}) => {
  const gA = useEmotionTheme(), {
    widgetsDisabled: IA
  } = useAppContext();
  let CA;
  k && H ? CA = "stTopNavDropdownLink" : k ? CA = "stTopNavLink" : CA = "stSidebarNavLink";
  const BA = k ? "stTopNavLinkContainer" : "stSidebarNavLinkContainer";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavLinkContainer, { disabled: IA, "data-testid": BA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarNavLink, { "data-testid": CA, isActive: n, disabled: IA, href: t, onClick: d, "aria-current": n ? "page" : void 0, children: [
    g?.length ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavIcon, { isActive: n, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "base", iconValue: g, color: !n && isMaterialIcon(g) ? (
      // Apply color with opacity on material icons
      // But we don't want to apply opacity on emoji icons
      gA.colors.fadedText60
    ) : gA.colors.bodyText }) }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarLinkText, { isActive: n, disabled: IA, isTopNav: k, label: AA, children: AA })
  ] }) });
};
function shouldShowNavigation(n, t) {
  return n.length <= 1 ? !1 : (t.length === 0 || t.length > 1, !0);
}
function groupPagesBySection(n) {
  return groupBy(n, (t) => t.sectionHeader || "");
}
function hasNonEmptySections(n) {
  return Object.keys(n).some((t) => t !== "");
}
function processNavigationStructure(n) {
  if (!hasNonEmptySections(n))
    return {
      individualPages: Object.values(n).flat(),
      sections: {}
    };
  const g = n[""] || [], d = {};
  return Object.entries(n).forEach(([k, H]) => {
    k && k !== "" && k !== "undefined" && (d[k] = H);
  }), {
    individualPages: g,
    sections: d
  };
}
const COLLAPSE_THRESHOLD = 12, NUM_PAGES_TO_SHOW_WHEN_COLLAPSED = 10, LOG$5 = loglevelExports$1.getLogger("SidebarNav");
function NavLink({
  pageUrl: n,
  page: t,
  isActive: g,
  onClick: d
}) {
  const k = t.pageName;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavLinkListItem, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNavLink, { isActive: g, pageUrl: n, icon: t.icon, onClick: d, children: k }) });
}
function generateNavSections(n, t, g, d, k, H) {
  const AA = [];
  let gA = H;
  return Object.entries(n).forEach(([IA, CA]) => {
    const BA = [...CA];
    let eA = BA;
    const iA = d[IA];
    if (t) {
      const QA = NUM_PAGES_TO_SHOW_WHEN_COLLAPSED - gA;
      QA <= 0 ? eA = [] : BA.length > QA && (eA = BA.slice(0, QA));
    }
    iA && (gA += eA.length), eA.length > 0 && AA.push(/* @__PURE__ */ jsxRuntimeExports.jsx(NavSection, { header: IA, isExpanded: iA, onToggle: () => k(IA), children: eA.map(g) }, IA));
  }), {
    sections: AA,
    updatedPageCount: gA
  };
}
const SidebarNav = ({
  endpoints: n,
  appPages: t,
  collapseSidebar: g,
  hasSidebarElements: d,
  onPageChange: k,
  currentPageScriptHash: H,
  expandSidebarNav: AA
}) => {
  const [gA, IA] = useState(!1), {
    pageLinkBaseUrl: CA
  } = useAppContext(), BA = `stSidebarSectionsState-${CA}`, [eA, iA] = useState(null), QA = useMemo$1(() => processNavigationStructure(groupPagesBySection(t)), [t]), tA = useMemo$1(() => {
    if (!(Object.keys(QA.sections).length > 0))
      return t.length;
    let uA = QA.individualPages.length;
    return Object.entries(QA.sections).forEach(([hA, dA]) => {
      eA?.[hA] && (uA += dA.length);
    }), uA;
  }, [t.length, eA, QA]);
  useEffect(() => {
    const rA = localStorageAvailable() && window.localStorage.getItem("sidebarNavState") === "expanded";
    !gA && (AA || rA) && IA(!0);
  }, [gA, AA]), useEffect(() => {
    if (localStorageAvailable()) {
      const rA = window.localStorage.getItem(BA);
      let uA = {};
      if (rA)
        try {
          uA = JSON.parse(rA);
        } catch (dA) {
          uA = {}, LOG$5.warn("Could not parse sidebar nav state from localStorage", dA);
        }
      const hA = Object.keys(QA.sections).reduce((dA, GA) => (dA[GA] = uA[GA] ?? !0, dA), {});
      iA(hA);
    } else {
      const rA = Object.keys(QA.sections).reduce((uA, hA) => (uA[hA] = !0, uA), {});
      iA(rA);
    }
  }, [QA.sections, BA]), useEffect(() => {
    localStorageAvailable() && eA && window.localStorage.setItem(BA, JSON.stringify(eA));
  }, [eA, BA]);
  const oA = useCallback((rA) => {
    iA((uA) => uA ? {
      ...uA,
      [rA]: !uA[rA]
    } : null);
  }, []), EA = useCallback(() => {
    const rA = !gA;
    localStorageAvailable() && (rA ? window.localStorage.setItem("sidebarNavState", "expanded") : window.localStorage.removeItem("sidebarNavState")), IA(rA);
  }, [gA]), aA = useCallback((rA, uA) => {
    const hA = n.buildAppPageURL(CA, rA), dA = rA.pageScriptHash === H;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(NavLink, { pageUrl: hA, page: rA, isActive: dA, onClick: (GA) => {
      GA.preventDefault(), k(rA.pageScriptHash), isMobile() && g();
    } }, `${rA.pageName}-${uA}`);
  }, [g, H, n, k, CA]);
  if (!eA)
    return null;
  const nA = [], lA = d && tA > COLLAPSE_THRESHOLD && !AA, cA = lA && !gA;
  let sA = 0;
  if (QA.individualPages.length > 0) {
    const rA = cA ? QA.individualPages.slice(0, NUM_PAGES_TO_SHOW_WHEN_COLLAPSED) : QA.individualPages;
    nA.push(...rA.map(aA)), sA += rA.length;
  }
  if (Object.keys(QA.sections).length > 0) {
    const rA = generateNavSections(QA.sections, cA, aA, eA, oA, sA);
    nA.push(...rA.sections);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarNavContainer, { "data-testid": "stSidebarNav", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavItems, { "data-testid": "stSidebarNavItems", children: nA }),
    lA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledViewButton, { onClick: EA, "data-testid": "stSidebarNavViewButton", children: gA ? "View less" : `View ${tA - NUM_PAGES_TO_SHOW_WHEN_COLLAPSED} more` }),
    d && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavSeparator, { "data-testid": "stSidebarNavSeparator" })
  ] });
};
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g) ({}).hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$2.apply(null, arguments);
}
function _typeof$1(n) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$1(n);
}
function toPrimitive$1(n, t) {
  if (_typeof$1(n) != "object" || !n) return n;
  var g = n[Symbol.toPrimitive];
  if (g !== void 0) {
    var d = g.call(n, t);
    if (_typeof$1(d) != "object") return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(n);
}
function toPropertyKey$1(n) {
  var t = toPrimitive$1(n, "string");
  return _typeof$1(t) == "symbol" ? t : t + "";
}
function _defineProperty$2(n, t, g) {
  return (t = toPropertyKey$1(t)) in n ? Object.defineProperty(n, t, {
    value: g,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[t] = g, n;
}
function ownKeys$2(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread2$1(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$2(Object(g), !0).forEach(function(d) {
      _defineProperty$2(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$2(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _arrayWithHoles(n) {
  if (Array.isArray(n)) return n;
}
function _iterableToArrayLimit(n, t) {
  var g = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (g != null) {
    var d, k, H, AA, gA = [], IA = !0, CA = !1;
    try {
      if (H = (g = g.call(n)).next, t !== 0) for (; !(IA = (d = H.call(g)).done) && (gA.push(d.value), gA.length !== t); IA = !0) ;
    } catch (BA) {
      CA = !0, k = BA;
    } finally {
      try {
        if (!IA && g.return != null && (AA = g.return(), Object(AA) !== AA)) return;
      } finally {
        if (CA) throw k;
      }
    }
    return gA;
  }
}
function _arrayLikeToArray(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var g = 0, d = Array(t); g < t; g++) d[g] = n[g];
  return d;
}
function _unsupportedIterableToArray(n, t) {
  if (n) {
    if (typeof n == "string") return _arrayLikeToArray(n, t);
    var g = {}.toString.call(n).slice(8, -1);
    return g === "Object" && n.constructor && (g = n.constructor.name), g === "Map" || g === "Set" ? Array.from(n) : g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g) ? _arrayLikeToArray(n, t) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _slicedToArray$1(n, t) {
  return _arrayWithHoles(n) || _iterableToArrayLimit(n, t) || _unsupportedIterableToArray(n, t) || _nonIterableRest();
}
function _objectWithoutPropertiesLoose$1(n, t) {
  if (n == null) return {};
  var g = {};
  for (var d in n) if ({}.hasOwnProperty.call(n, d)) {
    if (t.indexOf(d) !== -1) continue;
    g[d] = n[d];
  }
  return g;
}
function _objectWithoutProperties$1(n, t) {
  if (n == null) return {};
  var g, d, k = _objectWithoutPropertiesLoose$1(n, t);
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (d = 0; d < H.length; d++) g = H[d], t.indexOf(g) === -1 && {}.propertyIsEnumerable.call(n, g) && (k[g] = n[g]);
  }
  return k;
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g) ({}).hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
var REACT_ELEMENT_TYPE_18 = Symbol.for("react.element"), REACT_ELEMENT_TYPE_19 = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function isFragment(n) {
  return (
    // Base object type
    n && _typeof$e(n) === "object" && // React Element type
    (n.$$typeof === REACT_ELEMENT_TYPE_18 || n.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    n.type === REACT_FRAGMENT_TYPE
  );
}
function toArray$1(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, g = [];
  return React__default.Children.forEach(n, function(d) {
    d == null && !t.keepEmpty || (Array.isArray(d) ? g = g.concat(toArray$1(d)) : isFragment(d) && d.props ? g = g.concat(toArray$1(d.props.children, t)) : g.push(d));
  }), g;
}
var preWarningFns = [];
function warning(n, t) {
  if (process.env.NODE_ENV !== "production" && console !== void 0) {
    var g = preWarningFns.reduce(function(d, k) {
      return k(d ?? "", "warning");
    }, t);
    g && console.error("Warning: ".concat(g));
  }
}
function _typeof(n) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof(n);
}
function toPrimitive(n, t) {
  if (_typeof(n) != "object" || !n) return n;
  var g = n[Symbol.toPrimitive];
  if (g !== void 0) {
    var d = g.call(n, t);
    if (_typeof(d) != "object") return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(n);
}
function toPropertyKey(n) {
  var t = toPrimitive(n, "string");
  return _typeof(t) == "symbol" ? t : t + "";
}
function _defineProperty$1(n, t, g) {
  return (t = toPropertyKey(t)) in n ? Object.defineProperty(n, t, {
    value: g,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[t] = g, n;
}
function ownKeys$1(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread2(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$1(Object(g), !0).forEach(function(d) {
      _defineProperty$1(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys$1(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function isDOM(n) {
  return n instanceof HTMLElement || n instanceof SVGElement;
}
function getDOM(n) {
  return n && _typeof$e(n) === "object" && isDOM(n.nativeElement) ? n.nativeElement : isDOM(n) ? n : null;
}
function findDOMNode(n) {
  var t = getDOM(n);
  if (t)
    return t;
  if (n instanceof React__default.Component) {
    var g;
    return (g = ReactDOM.findDOMNode) === null || g === void 0 ? void 0 : g.call(ReactDOM, n);
  }
  return null;
}
var reactIs = { exports: {} }, reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var n = Symbol.for("react.element"), t = Symbol.for("react.portal"), g = Symbol.for("react.fragment"), d = Symbol.for("react.strict_mode"), k = Symbol.for("react.profiler"), H = Symbol.for("react.provider"), AA = Symbol.for("react.context"), gA = Symbol.for("react.server_context"), IA = Symbol.for("react.forward_ref"), CA = Symbol.for("react.suspense"), BA = Symbol.for("react.suspense_list"), eA = Symbol.for("react.memo"), iA = Symbol.for("react.lazy"), QA = Symbol.for("react.offscreen"), tA;
  tA = Symbol.for("react.module.reference");
  function oA(EA) {
    if (typeof EA == "object" && EA !== null) {
      var aA = EA.$$typeof;
      switch (aA) {
        case n:
          switch (EA = EA.type, EA) {
            case g:
            case k:
            case d:
            case CA:
            case BA:
              return EA;
            default:
              switch (EA = EA && EA.$$typeof, EA) {
                case gA:
                case AA:
                case IA:
                case iA:
                case eA:
                case H:
                  return EA;
                default:
                  return aA;
              }
          }
        case t:
          return aA;
      }
    }
  }
  return reactIs_production_min.ContextConsumer = AA, reactIs_production_min.ContextProvider = H, reactIs_production_min.Element = n, reactIs_production_min.ForwardRef = IA, reactIs_production_min.Fragment = g, reactIs_production_min.Lazy = iA, reactIs_production_min.Memo = eA, reactIs_production_min.Portal = t, reactIs_production_min.Profiler = k, reactIs_production_min.StrictMode = d, reactIs_production_min.Suspense = CA, reactIs_production_min.SuspenseList = BA, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(EA) {
    return oA(EA) === AA;
  }, reactIs_production_min.isContextProvider = function(EA) {
    return oA(EA) === H;
  }, reactIs_production_min.isElement = function(EA) {
    return typeof EA == "object" && EA !== null && EA.$$typeof === n;
  }, reactIs_production_min.isForwardRef = function(EA) {
    return oA(EA) === IA;
  }, reactIs_production_min.isFragment = function(EA) {
    return oA(EA) === g;
  }, reactIs_production_min.isLazy = function(EA) {
    return oA(EA) === iA;
  }, reactIs_production_min.isMemo = function(EA) {
    return oA(EA) === eA;
  }, reactIs_production_min.isPortal = function(EA) {
    return oA(EA) === t;
  }, reactIs_production_min.isProfiler = function(EA) {
    return oA(EA) === k;
  }, reactIs_production_min.isStrictMode = function(EA) {
    return oA(EA) === d;
  }, reactIs_production_min.isSuspense = function(EA) {
    return oA(EA) === CA;
  }, reactIs_production_min.isSuspenseList = function(EA) {
    return oA(EA) === BA;
  }, reactIs_production_min.isValidElementType = function(EA) {
    return typeof EA == "string" || typeof EA == "function" || EA === g || EA === k || EA === d || EA === CA || EA === BA || EA === QA || typeof EA == "object" && EA !== null && (EA.$$typeof === iA || EA.$$typeof === eA || EA.$$typeof === H || EA.$$typeof === AA || EA.$$typeof === IA || EA.$$typeof === tA || EA.getModuleId !== void 0);
  }, reactIs_production_min.typeOf = oA, reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && (function() {
    var n = Symbol.for("react.element"), t = Symbol.for("react.portal"), g = Symbol.for("react.fragment"), d = Symbol.for("react.strict_mode"), k = Symbol.for("react.profiler"), H = Symbol.for("react.provider"), AA = Symbol.for("react.context"), gA = Symbol.for("react.server_context"), IA = Symbol.for("react.forward_ref"), CA = Symbol.for("react.suspense"), BA = Symbol.for("react.suspense_list"), eA = Symbol.for("react.memo"), iA = Symbol.for("react.lazy"), QA = Symbol.for("react.offscreen"), tA = !1, oA = !1, EA = !1, aA = !1, nA = !1, lA;
    lA = Symbol.for("react.module.reference");
    function cA(mA) {
      return !!(typeof mA == "string" || typeof mA == "function" || mA === g || mA === k || nA || mA === d || mA === CA || mA === BA || aA || mA === QA || tA || oA || EA || typeof mA == "object" && mA !== null && (mA.$$typeof === iA || mA.$$typeof === eA || mA.$$typeof === H || mA.$$typeof === AA || mA.$$typeof === IA || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      mA.$$typeof === lA || mA.getModuleId !== void 0));
    }
    function sA(mA) {
      if (typeof mA == "object" && mA !== null) {
        var JA = mA.$$typeof;
        switch (JA) {
          case n:
            var VA = mA.type;
            switch (VA) {
              case g:
              case k:
              case d:
              case CA:
              case BA:
                return VA;
              default:
                var HA = VA && VA.$$typeof;
                switch (HA) {
                  case gA:
                  case AA:
                  case IA:
                  case iA:
                  case eA:
                  case H:
                    return HA;
                  default:
                    return JA;
                }
            }
          case t:
            return JA;
        }
      }
    }
    var rA = AA, uA = H, hA = n, dA = IA, GA = g, DA = iA, wA = eA, bA = t, yA = k, pA = d, MA = CA, LA = BA, xA = !1, TA = !1;
    function NA(mA) {
      return xA || (xA = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function zA(mA) {
      return TA || (TA = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function XA(mA) {
      return sA(mA) === AA;
    }
    function fA(mA) {
      return sA(mA) === H;
    }
    function vA(mA) {
      return typeof mA == "object" && mA !== null && mA.$$typeof === n;
    }
    function Cg(mA) {
      return sA(mA) === IA;
    }
    function Ig(mA) {
      return sA(mA) === g;
    }
    function gg(mA) {
      return sA(mA) === iA;
    }
    function og(mA) {
      return sA(mA) === eA;
    }
    function eg(mA) {
      return sA(mA) === t;
    }
    function kA(mA) {
      return sA(mA) === k;
    }
    function YA(mA) {
      return sA(mA) === d;
    }
    function RA(mA) {
      return sA(mA) === CA;
    }
    function FA(mA) {
      return sA(mA) === BA;
    }
    reactIs_development.ContextConsumer = rA, reactIs_development.ContextProvider = uA, reactIs_development.Element = hA, reactIs_development.ForwardRef = dA, reactIs_development.Fragment = GA, reactIs_development.Lazy = DA, reactIs_development.Memo = wA, reactIs_development.Portal = bA, reactIs_development.Profiler = yA, reactIs_development.StrictMode = pA, reactIs_development.Suspense = MA, reactIs_development.SuspenseList = LA, reactIs_development.isAsyncMode = NA, reactIs_development.isConcurrentMode = zA, reactIs_development.isContextConsumer = XA, reactIs_development.isContextProvider = fA, reactIs_development.isElement = vA, reactIs_development.isForwardRef = Cg, reactIs_development.isFragment = Ig, reactIs_development.isLazy = gg, reactIs_development.isMemo = og, reactIs_development.isPortal = eg, reactIs_development.isProfiler = kA, reactIs_development.isStrictMode = YA, reactIs_development.isSuspense = RA, reactIs_development.isSuspenseList = FA, reactIs_development.isValidElementType = cA, reactIs_development.typeOf = sA;
  })()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development()), reactIs.exports;
}
var reactIsExports = requireReactIs();
function useMemo(n, t, g) {
  var d = React.useRef({});
  return (!("value" in d.current) || g(d.current.condition, t)) && (d.current.value = n(), d.current.condition = t), d.current.value;
}
var ReactMajorVersion = Number(version$6.split(".")[0]), fillRef = function n(t, g) {
  typeof t == "function" ? t(g) : _typeof$e(t) === "object" && t && "current" in t && (t.current = g);
}, composeRef = function n() {
  for (var t = arguments.length, g = new Array(t), d = 0; d < t; d++)
    g[d] = arguments[d];
  var k = g.filter(Boolean);
  return k.length <= 1 ? k[0] : function(H) {
    g.forEach(function(AA) {
      fillRef(AA, H);
    });
  };
}, useComposeRef = function n() {
  for (var t = arguments.length, g = new Array(t), d = 0; d < t; d++)
    g[d] = arguments[d];
  return useMemo(function() {
    return composeRef.apply(void 0, g);
  }, g, function(k, H) {
    return k.length !== H.length || k.every(function(AA, gA) {
      return AA !== H[gA];
    });
  });
}, supportRef = function n(t) {
  var g, d;
  if (!t)
    return !1;
  if (isReactElement(t) && ReactMajorVersion >= 19)
    return !0;
  var k = reactIsExports.isMemo(t) ? t.type.type : t.type;
  return !(typeof k == "function" && !((g = k.prototype) !== null && g !== void 0 && g.render) && k.$$typeof !== reactIsExports.ForwardRef || typeof t == "function" && !((d = t.prototype) !== null && d !== void 0 && d.render) && t.$$typeof !== reactIsExports.ForwardRef);
};
function isReactElement(n) {
  return /* @__PURE__ */ isValidElement(n) && !isFragment(n);
}
var getNodeRef = function n(t) {
  if (t && isReactElement(t)) {
    var g = t;
    return g.props.propertyIsEnumerable("ref") ? g.props.ref : g.ref;
  }
  return null;
}, CollectionContext = /* @__PURE__ */ React.createContext(null);
function Collection(n) {
  var t = n.children, g = n.onBatchResize, d = React.useRef(0), k = React.useRef([]), H = React.useContext(CollectionContext), AA = React.useCallback(function(gA, IA, CA) {
    d.current += 1;
    var BA = d.current;
    k.current.push({
      size: gA,
      element: IA,
      data: CA
    }), Promise.resolve().then(function() {
      BA === d.current && (g?.(k.current), k.current = []);
    }), H?.(gA, IA, CA);
  }, [g, H]);
  return /* @__PURE__ */ React.createElement(CollectionContext.Provider, {
    value: AA
  }, t);
}
var MapShim = (function() {
  if (typeof Map < "u")
    return Map;
  function n(t, g) {
    var d = -1;
    return t.some(function(k, H) {
      return k[0] === g ? (d = H, !0) : !1;
    }), d;
  }
  return (
    /** @class */
    (function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(g) {
        var d = n(this.__entries__, g), k = this.__entries__[d];
        return k && k[1];
      }, t.prototype.set = function(g, d) {
        var k = n(this.__entries__, g);
        ~k ? this.__entries__[k][1] = d : this.__entries__.push([g, d]);
      }, t.prototype.delete = function(g) {
        var d = this.__entries__, k = n(d, g);
        ~k && d.splice(k, 1);
      }, t.prototype.has = function(g) {
        return !!~n(this.__entries__, g);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(g, d) {
        d === void 0 && (d = null);
        for (var k = 0, H = this.__entries__; k < H.length; k++) {
          var AA = H[k];
          g.call(d, AA[1], AA[0]);
        }
      }, t;
    })()
  );
})(), isBrowser = typeof window < "u" && typeof document < "u" && window.document === document, global$1 = (function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
})(), requestAnimationFrame$1 = (function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(global$1) : function(n) {
    return setTimeout(function() {
      return n(Date.now());
    }, 1e3 / 60);
  };
})(), trailingTimeout = 2;
function throttle$1(n, t) {
  var g = !1, d = !1, k = 0;
  function H() {
    g && (g = !1, n()), d && gA();
  }
  function AA() {
    requestAnimationFrame$1(H);
  }
  function gA() {
    var IA = Date.now();
    if (g) {
      if (IA - k < trailingTimeout)
        return;
      d = !0;
    } else
      g = !0, d = !1, setTimeout(AA, t);
    k = IA;
  }
  return gA;
}
var REFRESH_DELAY = 20, transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], mutationObserverSupported = typeof MutationObserver < "u", ResizeObserverController = (
  /** @class */
  (function() {
    function n() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = throttle$1(this.refresh.bind(this), REFRESH_DELAY);
    }
    return n.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, n.prototype.removeObserver = function(t) {
      var g = this.observers_, d = g.indexOf(t);
      ~d && g.splice(d, 1), !g.length && this.connected_ && this.disconnect_();
    }, n.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, n.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(g) {
        return g.gatherActive(), g.hasActive();
      });
      return t.forEach(function(g) {
        return g.broadcastActive();
      }), t.length > 0;
    }, n.prototype.connect_ = function() {
      !isBrowser || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), mutationObserverSupported ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, n.prototype.disconnect_ = function() {
      !isBrowser || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, n.prototype.onTransitionEnd_ = function(t) {
      var g = t.propertyName, d = g === void 0 ? "" : g, k = transitionKeys.some(function(H) {
        return !!~d.indexOf(H);
      });
      k && this.refresh();
    }, n.getInstance = function() {
      return this.instance_ || (this.instance_ = new n()), this.instance_;
    }, n.instance_ = null, n;
  })()
), defineConfigurable = (function(n, t) {
  for (var g = 0, d = Object.keys(t); g < d.length; g++) {
    var k = d[g];
    Object.defineProperty(n, k, {
      value: t[k],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return n;
}), getWindowOf = (function(n) {
  var t = n && n.ownerDocument && n.ownerDocument.defaultView;
  return t || global$1;
}), emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(n) {
  return parseFloat(n) || 0;
}
function getBordersSize(n) {
  for (var t = [], g = 1; g < arguments.length; g++)
    t[g - 1] = arguments[g];
  return t.reduce(function(d, k) {
    var H = n["border-" + k + "-width"];
    return d + toFloat(H);
  }, 0);
}
function getPaddings(n) {
  for (var t = ["top", "right", "bottom", "left"], g = {}, d = 0, k = t; d < k.length; d++) {
    var H = k[d], AA = n["padding-" + H];
    g[H] = toFloat(AA);
  }
  return g;
}
function getSVGContentRect(n) {
  var t = n.getBBox();
  return createRectInit(0, 0, t.width, t.height);
}
function getHTMLElementContentRect(n) {
  var t = n.clientWidth, g = n.clientHeight;
  if (!t && !g)
    return emptyRect;
  var d = getWindowOf(n).getComputedStyle(n), k = getPaddings(d), H = k.left + k.right, AA = k.top + k.bottom, gA = toFloat(d.width), IA = toFloat(d.height);
  if (d.boxSizing === "border-box" && (Math.round(gA + H) !== t && (gA -= getBordersSize(d, "left", "right") + H), Math.round(IA + AA) !== g && (IA -= getBordersSize(d, "top", "bottom") + AA)), !isDocumentElement(n)) {
    var CA = Math.round(gA + H) - t, BA = Math.round(IA + AA) - g;
    Math.abs(CA) !== 1 && (gA -= CA), Math.abs(BA) !== 1 && (IA -= BA);
  }
  return createRectInit(k.left, k.top, gA, IA);
}
var isSVGGraphicsElement = /* @__PURE__ */ (function() {
  return typeof SVGGraphicsElement < "u" ? function(n) {
    return n instanceof getWindowOf(n).SVGGraphicsElement;
  } : function(n) {
    return n instanceof getWindowOf(n).SVGElement && typeof n.getBBox == "function";
  };
})();
function isDocumentElement(n) {
  return n === getWindowOf(n).document.documentElement;
}
function getContentRect(n) {
  return isBrowser ? isSVGGraphicsElement(n) ? getSVGContentRect(n) : getHTMLElementContentRect(n) : emptyRect;
}
function createReadOnlyRect(n) {
  var t = n.x, g = n.y, d = n.width, k = n.height, H = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, AA = Object.create(H.prototype);
  return defineConfigurable(AA, {
    x: t,
    y: g,
    width: d,
    height: k,
    top: g,
    right: t + d,
    bottom: k + g,
    left: t
  }), AA;
}
function createRectInit(n, t, g, d) {
  return { x: n, y: t, width: g, height: d };
}
var ResizeObservation = (
  /** @class */
  (function() {
    function n(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = createRectInit(0, 0, 0, 0), this.target = t;
    }
    return n.prototype.isActive = function() {
      var t = getContentRect(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, n.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, n;
  })()
), ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ (function() {
    function n(t, g) {
      var d = createReadOnlyRect(g);
      defineConfigurable(this, { target: t, contentRect: d });
    }
    return n;
  })()
), ResizeObserverSPI = (
  /** @class */
  (function() {
    function n(t, g, d) {
      if (this.activeObservations_ = [], this.observations_ = new MapShim(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = g, this.callbackCtx_ = d;
    }
    return n.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof getWindowOf(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var g = this.observations_;
        g.has(t) || (g.set(t, new ResizeObservation(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, n.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof getWindowOf(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var g = this.observations_;
        g.has(t) && (g.delete(t), g.size || this.controller_.removeObserver(this));
      }
    }, n.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, n.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(g) {
        g.isActive() && t.activeObservations_.push(g);
      });
    }, n.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, g = this.activeObservations_.map(function(d) {
          return new ResizeObserverEntry(d.target, d.broadcastRect());
        });
        this.callback_.call(t, g, t), this.clearActive();
      }
    }, n.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, n.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, n;
  })()
), observers = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new MapShim(), ResizeObserver$2 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function n(t) {
      if (!(this instanceof n))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var g = ResizeObserverController.getInstance(), d = new ResizeObserverSPI(t, g, this);
      observers.set(this, d);
    }
    return n;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(n) {
  ResizeObserver$2.prototype[n] = function() {
    var t;
    return (t = observers.get(this))[n].apply(t, arguments);
  };
});
var index = (function() {
  return typeof global$1.ResizeObserver < "u" ? global$1.ResizeObserver : ResizeObserver$2;
})(), elementListeners = /* @__PURE__ */ new Map();
function onResize(n) {
  n.forEach(function(t) {
    var g, d = t.target;
    (g = elementListeners.get(d)) === null || g === void 0 || g.forEach(function(k) {
      return k(d);
    });
  });
}
var resizeObserver = new index(onResize);
process.env.NODE_ENV;
process.env.NODE_ENV;
function observe(n, t) {
  elementListeners.has(n) || (elementListeners.set(n, /* @__PURE__ */ new Set()), resizeObserver.observe(n)), elementListeners.get(n).add(t);
}
function unobserve(n, t) {
  elementListeners.has(n) && (elementListeners.get(n).delete(t), elementListeners.get(n).size || (resizeObserver.unobserve(n), elementListeners.delete(n)));
}
function _classCallCheck(n, t) {
  if (!(n instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(n, t) {
  for (var g = 0; g < t.length; g++) {
    var d = t[g];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(n, toPropertyKey(d.key), d);
  }
}
function _createClass(n, t, g) {
  return t && _defineProperties(n.prototype, t), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
function _setPrototypeOf(n, t) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, d) {
    return g.__proto__ = d, g;
  }, _setPrototypeOf(n, t);
}
function _inherits(n, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: n,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(n, "prototype", {
    writable: !1
  }), t && _setPrototypeOf(n, t);
}
function _getPrototypeOf(n) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(n);
}
function _isNativeReflectConstruct() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = function() {
    return !!n;
  })();
}
function _assertThisInitialized(n) {
  if (n === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function _possibleConstructorReturn(n, t) {
  if (t && (_typeof(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(n);
}
function _createSuper(n) {
  var t = _isNativeReflectConstruct();
  return function() {
    var g, d = _getPrototypeOf(n);
    if (t) {
      var k = _getPrototypeOf(this).constructor;
      g = Reflect.construct(d, arguments, k);
    } else g = d.apply(this, arguments);
    return _possibleConstructorReturn(this, g);
  };
}
var DomWrapper = /* @__PURE__ */ (function(n) {
  _inherits(g, n);
  var t = _createSuper(g);
  function g() {
    return _classCallCheck(this, g), t.apply(this, arguments);
  }
  return _createClass(g, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), g;
})(React.Component);
function SingleObserver(n, t) {
  var g = n.children, d = n.disabled, k = React.useRef(null), H = React.useRef(null), AA = React.useContext(CollectionContext), gA = typeof g == "function", IA = gA ? g(k) : g, CA = React.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), BA = !gA && /* @__PURE__ */ React.isValidElement(IA) && supportRef(IA), eA = BA ? getNodeRef(IA) : null, iA = useComposeRef(eA, k), QA = function() {
    var aA;
    return findDOMNode(k.current) || // Support `nativeElement` format
    (k.current && _typeof(k.current) === "object" ? findDOMNode((aA = k.current) === null || aA === void 0 ? void 0 : aA.nativeElement) : null) || findDOMNode(H.current);
  };
  React.useImperativeHandle(t, function() {
    return QA();
  });
  var tA = React.useRef(n);
  tA.current = n;
  var oA = React.useCallback(function(EA) {
    var aA = tA.current, nA = aA.onResize, lA = aA.data, cA = EA.getBoundingClientRect(), sA = cA.width, rA = cA.height, uA = EA.offsetWidth, hA = EA.offsetHeight, dA = Math.floor(sA), GA = Math.floor(rA);
    if (CA.current.width !== dA || CA.current.height !== GA || CA.current.offsetWidth !== uA || CA.current.offsetHeight !== hA) {
      var DA = {
        width: dA,
        height: GA,
        offsetWidth: uA,
        offsetHeight: hA
      };
      CA.current = DA;
      var wA = uA === Math.round(sA) ? sA : uA, bA = hA === Math.round(rA) ? rA : hA, yA = _objectSpread2(_objectSpread2({}, DA), {}, {
        offsetWidth: wA,
        offsetHeight: bA
      });
      AA?.(yA, EA, lA), nA && Promise.resolve().then(function() {
        nA(yA, EA);
      });
    }
  }, []);
  return React.useEffect(function() {
    var EA = QA();
    return EA && !d && observe(EA, oA), function() {
      return unobserve(EA, oA);
    };
  }, [k.current, d]), /* @__PURE__ */ React.createElement(DomWrapper, {
    ref: H
  }, BA ? /* @__PURE__ */ React.cloneElement(IA, {
    ref: iA
  }) : IA);
}
var RefSingleObserver = /* @__PURE__ */ React.forwardRef(SingleObserver);
process.env.NODE_ENV !== "production" && (RefSingleObserver.displayName = "SingleObserver");
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver$1(n, t) {
  var g = n.children, d = typeof g == "function" ? [g] : toArray$1(g);
  return process.env.NODE_ENV !== "production" && (d.length > 1 ? warning(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : d.length === 0 && warning(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), d.map(function(k, H) {
    var AA = k?.key || "".concat(INTERNAL_PREFIX_KEY, "-").concat(H);
    return /* @__PURE__ */ React.createElement(RefSingleObserver, _extends$1({}, n, {
      key: AA,
      ref: H === 0 ? t : void 0
    }), k);
  });
}
var RefResizeObserver = /* @__PURE__ */ React.forwardRef(ResizeObserver$1);
process.env.NODE_ENV !== "production" && (RefResizeObserver.displayName = "ResizeObserver");
RefResizeObserver.Collection = Collection;
function canUseDom() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var useInternalLayoutEffect = process.env.NODE_ENV !== "test" && canUseDom() ? React.useLayoutEffect : React.useEffect, useLayoutEffect = function n(t, g) {
  var d = React.useRef(!0);
  useInternalLayoutEffect(function() {
    return t(d.current);
  }, g), useInternalLayoutEffect(function() {
    return d.current = !1, function() {
      d.current = !0;
    };
  }, []);
}, _excluded$3 = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], UNDEFINED = void 0;
function InternalItem(n, t) {
  var g = n.prefixCls, d = n.invalidate, k = n.item, H = n.renderItem, AA = n.responsive, gA = n.responsiveDisabled, IA = n.registerSize, CA = n.itemKey, BA = n.className, eA = n.style, iA = n.children, QA = n.display, tA = n.order, oA = n.component, EA = oA === void 0 ? "div" : oA, aA = _objectWithoutProperties$1(n, _excluded$3), nA = AA && !QA;
  function lA(hA) {
    IA(CA, hA);
  }
  React.useEffect(function() {
    return function() {
      lA(null);
    };
  }, []);
  var cA = H && k !== UNDEFINED ? H(k, {
    index: tA
  }) : iA, sA;
  d || (sA = {
    opacity: nA ? 0 : 1,
    height: nA ? 0 : UNDEFINED,
    overflowY: nA ? "hidden" : UNDEFINED,
    order: AA ? tA : UNDEFINED,
    pointerEvents: nA ? "none" : UNDEFINED,
    position: nA ? "absolute" : UNDEFINED
  });
  var rA = {};
  nA && (rA["aria-hidden"] = !0);
  var uA = /* @__PURE__ */ React.createElement(EA, _extends$2({
    className: classNames(!d && g, BA),
    style: _objectSpread2$1(_objectSpread2$1({}, sA), eA)
  }, rA, aA, {
    ref: t
  }), cA);
  return AA && (uA = /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: function(dA) {
      var GA = dA.offsetWidth;
      lA(GA);
    },
    disabled: gA
  }, uA)), uA;
}
var Item = /* @__PURE__ */ React.forwardRef(InternalItem);
Item.displayName = "Item";
function useEvent(n) {
  var t = React.useRef();
  t.current = n;
  var g = React.useCallback(function() {
    for (var d, k = arguments.length, H = new Array(k), AA = 0; AA < k; AA++)
      H[AA] = arguments[AA];
    return (d = t.current) === null || d === void 0 ? void 0 : d.call.apply(d, [t].concat(H));
  }, []);
  return g;
}
var raf = function n(t) {
  return +setTimeout(t, 16);
}, caf = function n(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (raf = function(t) {
  return window.requestAnimationFrame(t);
}, caf = function(t) {
  return window.cancelAnimationFrame(t);
});
var rafUUID = 0, rafIds = /* @__PURE__ */ new Map();
function cleanup(n) {
  rafIds.delete(n);
}
var wrapperRaf = function n(t) {
  var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var d = rafUUID;
  function k(H) {
    if (H === 0)
      cleanup(d), t();
    else {
      var AA = raf(function() {
        k(H - 1);
      });
      rafIds.set(d, AA);
    }
  }
  return k(g), d;
};
wrapperRaf.cancel = function(n) {
  var t = rafIds.get(n);
  return cleanup(n), caf(t);
};
process.env.NODE_ENV !== "production" && (wrapperRaf.ids = function() {
  return rafIds;
});
function channelUpdate(n) {
  if (typeof MessageChannel > "u")
    wrapperRaf(n);
  else {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return n();
    }, t.port2.postMessage(void 0);
  }
}
function useBatcher() {
  var n = React.useRef(null), t = function(d) {
    n.current || (n.current = [], channelUpdate(function() {
      unstable_batchedUpdates(function() {
        n.current.forEach(function(k) {
          k();
        }), n.current = null;
      });
    })), n.current.push(d);
  };
  return t;
}
function useEffectState(n, t) {
  var g = React.useState(t), d = _slicedToArray$1(g, 2), k = d[0], H = d[1], AA = useEvent(function(gA) {
    n(function() {
      H(gA);
    });
  });
  return [k, AA];
}
var OverflowContext = /* @__PURE__ */ React__default.createContext(null), _excluded$2 = ["component"], _excluded2$1 = ["className"], _excluded3 = ["className"], InternalRawItem = function n(t, g) {
  var d = React.useContext(OverflowContext);
  if (!d) {
    var k = t.component, H = k === void 0 ? "div" : k, AA = _objectWithoutProperties$1(t, _excluded$2);
    return /* @__PURE__ */ React.createElement(H, _extends$2({}, AA, {
      ref: g
    }));
  }
  var gA = d.className, IA = _objectWithoutProperties$1(d, _excluded2$1), CA = t.className, BA = _objectWithoutProperties$1(t, _excluded3);
  return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ React.createElement(Item, _extends$2({
    ref: g,
    className: classNames(gA, CA)
  }, IA, BA)));
}, RawItem = /* @__PURE__ */ React.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var _excluded$1 = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "prefix", "suffix", "component", "itemComponent", "onVisibleChange"], RESPONSIVE = "responsive", INVALIDATE = "invalidate";
function defaultRenderRest(n) {
  return "+ ".concat(n.length, " ...");
}
function Overflow(n, t) {
  var g = n.prefixCls, d = g === void 0 ? "rc-overflow" : g, k = n.data, H = k === void 0 ? [] : k, AA = n.renderItem, gA = n.renderRawItem, IA = n.itemKey, CA = n.itemWidth, BA = CA === void 0 ? 10 : CA, eA = n.ssr, iA = n.style, QA = n.className, tA = n.maxCount, oA = n.renderRest, EA = n.renderRawRest, aA = n.prefix, nA = n.suffix, lA = n.component, cA = lA === void 0 ? "div" : lA, sA = n.itemComponent, rA = n.onVisibleChange, uA = _objectWithoutProperties$1(n, _excluded$1), hA = eA === "full", dA = useBatcher(), GA = useEffectState(dA, null), DA = _slicedToArray$1(GA, 2), wA = DA[0], bA = DA[1], yA = wA || 0, pA = useEffectState(dA, /* @__PURE__ */ new Map()), MA = _slicedToArray$1(pA, 2), LA = MA[0], xA = MA[1], TA = useEffectState(dA, 0), NA = _slicedToArray$1(TA, 2), zA = NA[0], XA = NA[1], fA = useEffectState(dA, 0), vA = _slicedToArray$1(fA, 2), Cg = vA[0], Ig = vA[1], gg = useEffectState(dA, 0), og = _slicedToArray$1(gg, 2), eg = og[0], kA = og[1], YA = useEffectState(dA, 0), RA = _slicedToArray$1(YA, 2), FA = RA[0], mA = RA[1], JA = useState(null), VA = _slicedToArray$1(JA, 2), HA = VA[0], jA = VA[1], _A = useState(null), $A = _slicedToArray$1(_A, 2), rg = $A[0], wg = $A[1], Dg = React.useMemo(function() {
    return rg === null && hA ? Number.MAX_SAFE_INTEGER : rg || 0;
  }, [rg, wA]), kg = useState(!1), ig = _slicedToArray$1(kg, 2), ZA = ig[0], KA = ig[1], PA = "".concat(d, "-item"), ag = Math.max(zA, Cg), Gg = tA === RESPONSIVE, bg = H.length && Gg, yg = tA === INVALIDATE, hg = bg || typeof tA == "number" && H.length > tA, tg = useMemo$1(function() {
    var Sg = H;
    return bg ? wA === null && hA ? Sg = H : Sg = H.slice(0, Math.min(H.length, yA / BA)) : typeof tA == "number" && (Sg = H.slice(0, tA)), Sg;
  }, [H, BA, wA, tA, bg]), Eg = useMemo$1(function() {
    return bg ? H.slice(Dg + 1) : H.slice(tg.length);
  }, [H, tg, bg, Dg]), cg = useCallback(function(Sg, Zg) {
    var qg;
    return typeof IA == "function" ? IA(Sg) : (qg = IA && Sg?.[IA]) !== null && qg !== void 0 ? qg : Zg;
  }, [IA]), sg = useCallback(AA || function(Sg) {
    return Sg;
  }, [AA]);
  function ug(Sg, Zg, qg) {
    rg === Sg && (Zg === void 0 || Zg === HA) || (wg(Sg), qg || (KA(Sg < H.length - 1), rA?.(Sg)), Zg !== void 0 && jA(Zg));
  }
  function Mg(Sg, Zg) {
    bA(Zg.clientWidth);
  }
  function Rg(Sg, Zg) {
    xA(function(qg) {
      var $g = new Map(qg);
      return Zg === null ? $g.delete(Sg) : $g.set(Sg, Zg), $g;
    });
  }
  function Jg(Sg, Zg) {
    Ig(Zg), XA(Cg);
  }
  function Hg(Sg, Zg) {
    kA(Zg);
  }
  function mg(Sg, Zg) {
    mA(Zg);
  }
  function Og(Sg) {
    return LA.get(cg(tg[Sg], Sg));
  }
  useLayoutEffect(function() {
    if (yA && typeof ag == "number" && tg) {
      var Sg = eg + FA, Zg = tg.length, qg = Zg - 1;
      if (!Zg) {
        ug(0, null);
        return;
      }
      for (var $g = 0; $g < Zg; $g += 1) {
        var Ag = Og($g);
        if (hA && (Ag = Ag || 0), Ag === void 0) {
          ug($g - 1, void 0, !0);
          break;
        }
        if (Sg += Ag, // Only one means `totalWidth` is the final width
        qg === 0 && Sg <= yA || // Last two width will be the final width
        $g === qg - 1 && Sg + Og(qg) <= yA) {
          ug(qg, null);
          break;
        } else if (Sg + ag > yA) {
          ug($g - 1, Sg - Ag - FA + Cg);
          break;
        }
      }
      nA && Og(0) + FA > yA && jA(null);
    }
  }, [yA, LA, Cg, eg, FA, cg, tg]);
  var Kg = ZA && !!Eg.length, vg = {};
  HA !== null && bg && (vg = {
    position: "absolute",
    left: HA,
    top: 0
  });
  var Vg = {
    prefixCls: PA,
    responsive: bg,
    component: sA,
    invalidate: yg
  }, Xg = gA ? function(Sg, Zg) {
    var qg = cg(Sg, Zg);
    return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
      key: qg,
      value: _objectSpread2$1(_objectSpread2$1({}, Vg), {}, {
        order: Zg,
        item: Sg,
        itemKey: qg,
        registerSize: Rg,
        display: Zg <= Dg
      })
    }, gA(Sg, Zg));
  } : function(Sg, Zg) {
    var qg = cg(Sg, Zg);
    return /* @__PURE__ */ React.createElement(Item, _extends$2({}, Vg, {
      order: Zg,
      key: qg,
      item: Sg,
      renderItem: sg,
      itemKey: qg,
      registerSize: Rg,
      display: Zg <= Dg
    }));
  }, jg = {
    order: Kg ? Dg : Number.MAX_SAFE_INTEGER,
    className: "".concat(PA, "-rest"),
    registerSize: Jg,
    display: Kg
  }, gI = oA || defaultRenderRest, II = EA ? /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: _objectSpread2$1(_objectSpread2$1({}, Vg), jg)
  }, EA(Eg)) : /* @__PURE__ */ React.createElement(Item, _extends$2({}, Vg, jg), typeof gI == "function" ? gI(Eg) : gI), tI = /* @__PURE__ */ React.createElement(cA, _extends$2({
    className: classNames(!yg && d, QA),
    style: iA,
    ref: t
  }, uA), aA && /* @__PURE__ */ React.createElement(Item, _extends$2({}, Vg, {
    responsive: Gg,
    responsiveDisabled: !bg,
    order: -1,
    className: "".concat(PA, "-prefix"),
    registerSize: Hg,
    display: !0
  }), aA), tg.map(Xg), hg ? II : null, nA && /* @__PURE__ */ React.createElement(Item, _extends$2({}, Vg, {
    responsive: Gg,
    responsiveDisabled: !bg,
    order: Dg,
    className: "".concat(PA, "-suffix"),
    registerSize: mg,
    display: !0,
    style: vg
  }), nA));
  return Gg ? /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: Mg,
    disabled: !bg
  }, tI) : tI;
}
var ForwardOverflow = /* @__PURE__ */ React.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
const TopNavSection = ({
  title: n,
  sections: t,
  handlePageChange: g,
  endpoints: d,
  pageLinkBaseUrl: k,
  currentPageScriptHash: H,
  hideChevron: AA = !1
}) => {
  const [gA, IA] = useState(!1), CA = useTheme(), BA = hasLightBackgroundColor(CA), eA = t.length > 1;
  return isNullOrUndefined$1(t) || t.length === 0 || t[0].length === 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    Popover$2,
    {
      triggerType: TRIGGER_TYPE.click,
      placement: PLACEMENT.bottomLeft,
      content: () => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPopoverContent, { "data-testid": "stTopNavPopover", children: t.map((iA, QA) => {
        const tA = iA[0].sectionHeader;
        return iA.map((oA, EA) => {
          const aA = (lA) => (lA.preventDefault(), oA.pageScriptHash && g(oA.pageScriptHash), IA(!1), !1), nA = String(oA.pageName || "");
          return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
            EA === 0 && eA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSectionName, { children: tA }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTopNavSidebarNavLinkContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNavLink, { ...oA, icon: oA.icon || null, isTopNav: !0, isInDropdown: !0, isActive: H === oA.pageScriptHash, onClick: aA, pageUrl: d.buildAppPageURL(k, oA), children: nA }) })
          ] }, `${oA.pageScriptHash}-${nA}`);
        });
      }) }),
      isOpen: gA,
      onClickOutside: () => IA(!1),
      onClick: () => gA ? IA(!1) : void 0,
      onEsc: () => IA(!1),
      renderAll: !0,
      overrides: {
        Body: {
          style: () => ({
            marginTop: CA.spacing.sm,
            marginRight: CA.spacing.lg,
            marginBottom: CA.spacing.lg,
            maxHeight: "70vh",
            minWidth: "8rem",
            overflow: "auto",
            maxWidth: `calc(${CA.sizes.contentMaxWidth} - 2*${CA.spacing.lg})`,
            borderTopLeftRadius: CA.radii.xl,
            borderTopRightRadius: CA.radii.xl,
            borderBottomRightRadius: CA.radii.xl,
            borderBottomLeftRadius: CA.radii.xl,
            borderLeftWidth: CA.sizes.borderWidth,
            borderRightWidth: CA.sizes.borderWidth,
            borderTopWidth: CA.sizes.borderWidth,
            borderBottomWidth: CA.sizes.borderWidth,
            borderLeftStyle: "solid",
            borderRightStyle: "solid",
            borderTopStyle: "solid",
            borderBottomStyle: "solid",
            borderLeftColor: CA.colors.borderColor,
            borderRightColor: CA.colors.borderColor,
            borderTopColor: CA.colors.borderColor,
            borderBottomColor: CA.colors.borderColor,
            boxShadow: BA ? "0px 4px 16px rgba(0, 0, 0, 0.16)" : "0px 4px 16px rgba(0, 0, 0, 0.7)",
            [`@media (max-width: ${CA.breakpoints.sm})`]: {
              maxWidth: `calc(100% - ${CA.spacing.threeXL})`
            }
          })
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledNavSection, { tabIndex: 0, onClick: () => IA(!gA), isOpen: gA, "data-testid": "stTopNavSection", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNavSectionText, { children: n }),
        !AA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIconContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { content: gA ? KeyboardArrowUp : KeyboardArrowDown, size: "lg" }) })
      ] }) })
    }
  );
}, TopNav = ({
  endpoints: n,
  pageLinkBaseUrl: t,
  currentPageScriptHash: g,
  appPages: d,
  onPageChange: k
}) => {
  const {
    data: H,
    itemKey: AA
  } = useMemo$1(() => {
    const CA = groupPagesBySection(d), BA = processNavigationStructure(CA);
    return {
      data: [...BA.individualPages, ...Object.entries(BA.sections).map(([QA, tA]) => tA)],
      itemKey: (QA) => Array.isArray(QA) ? QA[0]?.sectionHeader ?? "" : QA.pageScriptHash ?? ""
    };
  }, [d]), gA = useCallback((CA, BA) => Array.isArray(CA) ? /* @__PURE__ */ jsxRuntimeExports.jsx(TopNavSection, { sections: [CA], title: CA[0].sectionHeader || "", handlePageChange: k, endpoints: n, pageLinkBaseUrl: t, currentPageScriptHash: g }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTopNavLinkContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNavLink, { isTopNav: !0, isInDropdown: !1, isActive: g === CA.pageScriptHash, icon: CA.icon, pageUrl: n.buildAppPageURL(t, CA), onClick: (eA) => {
    eA.preventDefault(), CA.pageScriptHash && k(CA.pageScriptHash);
  }, children: String(CA.pageName) }) }), [k, n, t, g]), IA = useCallback((CA) => {
    if (isNullOrUndefined$1(CA))
      return null;
    const eA = `${CA.flat().length} more`, iA = CA.map((QA) => Array.isArray(QA) ? QA : [QA]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TopNavSection, { hideChevron: !0, sections: iA, title: eA, handlePageChange: k, endpoints: n, pageLinkBaseUrl: t, currentPageScriptHash: g });
  }, [k, n, t, g]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ForwardOverflow, { component: StyledOverflowContainer, itemKey: AA, data: H, maxCount: "responsive", renderItem: gA, renderRest: IA });
}, DEFAULT_WIDTH = "256";
function calculateMaxBreakpoint(n) {
  return parseInt(n, 10) - 0.02;
}
const Sidebar = ({
  appLogo: n,
  endpoints: t,
  appPages: g,
  children: d,
  hasElements: k,
  onPageChange: H,
  currentPageScriptHash: AA,
  hideSidebarNav: gA,
  expandSidebarNav: IA,
  navSections: CA,
  isCollapsed: BA,
  onToggleCollapse: eA
}) => {
  const iA = useEmotionTheme(), QA = calculateMaxBreakpoint(iA.breakpoints.md), {
    innerWidth: tA
  } = useWindowDimensionsContext(), oA = useScrollbarGutterSize(), EA = useRef(null), aA = localStorageAvailable() ? window.localStorage.getItem("sidebarWidth") : void 0, [nA, lA] = useState(aA || DEFAULT_WIDTH), [cA, sA] = useState(tA ?? 1 / 0), [rA, uA] = useState(!1), hA = useCallback(() => {
    uA(!0);
  }, []), dA = useCallback(() => {
    uA(!1);
  }, []), GA = useCallback((MA) => {
    const LA = MA.toString();
    lA(LA), localStorageAvailable() && window.localStorage.setItem("sidebarWidth", LA);
  }, []), DA = useCallback((MA, LA, xA, TA) => {
    if (xA) {
      const NA = xA.clientWidth || xA.offsetWidth;
      GA(NA);
    }
  }, [GA]);
  useExecuteWhenChanged(() => {
    tA < cA && tA <= QA && (BA || eA(!0, !1)), sA(tA);
  }, [tA]), useEffect(() => {
    const MA = (LA) => {
      if (EA && window) {
        const {
          current: xA
        } = EA;
        xA && !xA.contains(LA.target) && tA <= QA && (BA || eA(!0));
      }
    };
    return document.addEventListener("mousedown", MA), () => {
      document.removeEventListener("mousedown", MA);
    };
  }, [cA, QA, BA, eA, tA]);
  function wA() {
    lA(DEFAULT_WIDTH), localStorageAvailable() && window.localStorage.setItem("sidebarWidth", DEFAULT_WIDTH);
  }
  const bA = useCallback(() => {
    eA(!BA);
  }, [BA, eA]), yA = () => n ? /* @__PURE__ */ jsxRuntimeExports.jsx(LogoComponent, { appLogo: n, endpoints: t, collapsed: BA, componentName: "Sidebar Logo", dataTestId: "stSidebarLogo" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNoLogoSpacer, { "data-testid": "stLogoSpacer" }), pA = shouldShowNavigation(g, CA) && !gA;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Resizable,
    {
      className: "stSidebar",
      "data-testid": "stSidebar",
      "aria-expanded": !BA,
      enable: {
        top: !1,
        right: !0,
        bottom: !1,
        left: !1
      },
      handleStyles: {
        right: {
          width: RESIZE_HANDLE_WIDTH,
          right: "-6px"
        }
      },
      handleComponent: {
        right: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledResizeHandle, { onDoubleClick: wA })
      },
      size: {
        width: nA,
        height: "auto"
      },
      as: StyledSidebar,
      onResizeStop: DA,
      isCollapsed: BA,
      sidebarWidth: nA,
      windowInnerWidth: tA,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarContent, { "data-testid": "stSidebarContent", ref: EA, onMouseOver: hA, onMouseOut: dA, scrollbarGutterSize: oA, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarHeaderContainer, { "data-testid": "stSidebarHeader", children: [
          yA(),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCollapseSidebarButton, { showSidebarCollapse: rA, "data-testid": "stSidebarCollapseButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_NO_PADDING, onClick: bA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "xl", iconValue: ":material/keyboard_double_arrow_left:", color: iA.colors.fadedText60 }) }) })
        ] }),
        pA && /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNav, { endpoints: t, appPages: g, collapseSidebar: bA, currentPageScriptHash: AA, hasSidebarElements: k, expandSidebarNav: IA, onPageChange: H }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarUserContent, { hasPageNavAbove: pA, "data-testid": "stSidebarUserContent", children: d })
      ] })
    }
  );
};
function SidebarWithProvider(n) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IsSidebarContext.Provider, { value: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Sidebar, { ...n }) });
}
const setSidebarHeadingFontSizes = (n) => {
  const t = ["1.5rem", "1.25rem", "1.125rem", "1rem", "0.875rem", "0.75rem"];
  return n && n.forEach((g, d) => {
    t[d] = g;
  }), t;
}, createSidebarTheme = (n) => {
  let t = {};
  notNullOrUndefined(n.themeInput?.sidebar) && (t = {
    ...n.themeInput.sidebar
  }, Object.keys(t).forEach((AA) => {
    const gA = t[AA];
    Array.isArray(gA) && gA.length === 0 && delete t[AA];
  }));
  const g = setSidebarHeadingFontSizes(n.themeInput?.sidebar?.headingFontSizes), d = n.themeInput?.sidebar?.backgroundColor || n.emotion.colors.secondaryBg, k = n.themeInput?.sidebar?.secondaryBackgroundColor || n.emotion.colors.bgColor;
  t = {
    ...t,
    backgroundColor: d,
    secondaryBackgroundColor: k,
    headingFontSizes: g
  };
  const H = getLuminance(d) > 0.5 ? CustomThemeConfig.BaseTheme.LIGHT : CustomThemeConfig.BaseTheme.DARK;
  return createTheme(
    "Sidebar",
    {
      ...n.themeInput,
      // Use the theme props from the main theme as basis
      base: H,
      ...t
    },
    void 0,
    // Creating a new theme from scratch
    !0
    // inSidebar
  );
}, ThemedSidebar = ({
  children: n,
  ...t
}) => {
  const {
    activeTheme: g
  } = useContext(LibContext), d = createSidebarTheme(g);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: d.emotion, baseuiTheme: d.basewebTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarWithProvider, { ...t, children: n }) });
};
function shouldCollapse(n, t, g) {
  switch (n) {
    case PageConfig.SidebarState.EXPANDED:
      return !1;
    case PageConfig.SidebarState.COLLAPSED:
      return !0;
    case PageConfig.SidebarState.AUTO:
    default:
      return g <= t;
  }
}
const getSidebarCollapsedKey = (n) => `stSidebarCollapsed-${n}`, getSavedSidebarState = (n) => {
  if (!localStorageAvailable())
    return null;
  const t = window.localStorage.getItem(getSidebarCollapsedKey(n));
  return t === null ? null : t === "true";
}, saveSidebarState = (n, t) => {
  localStorageAvailable() && window.localStorage.setItem(getSidebarCollapsedKey(n), t.toString());
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$6() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledAppViewContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi10"
} : {
  target: "ea3mdgi10",
  label: "StyledAppViewContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1yiq2ps",
  styles: "display:flex;flex-direction:row;justify-content:flex-start;align-items:stretch;align-content:flex-start;position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;@media print{overflow:visible;}"
} : {
  name: "1yiq2ps",
  styles: "display:flex;flex-direction:row;justify-content:flex-start;align-items:stretch;align-content:flex-start;position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;@media print{overflow:visible;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
}), StyledAppViewMain = /* @__PURE__ */ createStyled$1("section", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi9"
} : {
  target: "ea3mdgi9",
  label: "StyledAppViewMain"
})(({
  disableScrolling: n,
  theme: t
}) => ({
  display: "flex",
  flexDirection: "column",
  width: t.sizes.full,
  overflow: n ? "hidden" : "auto",
  alignItems: "center",
  height: "100dvh",
  "&:focus": {
    outline: "none"
  },
  // Added so sidebar overlays main app content on
  // smaller screen sizes, except when printing
  "@media not print": {
    [`@media (max-width: ${t.breakpoints.md})`]: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      height: "100dvh"
    }
  },
  "@media print": {
    // print multiple pages if app is scrollable in Safari
    overflow: "visible"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStickyBottomContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi8"
} : {
  target: "ea3mdgi8",
  label: "StyledStickyBottomContainer"
})(({
  theme: n
}) => ({
  position: "sticky",
  left: 0,
  bottom: 0,
  width: "100%",
  zIndex: n.zIndices.bottom,
  // move the bottom container to the end of pages in print-mode so that nothing
  // (e.g. a floating chat-input) overlays the actual app content
  "@media print": {
    position: "static"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledInnerBottomContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi7"
} : {
  target: "ea3mdgi7",
  label: "StyledInnerBottomContainer"
})(({
  theme: n
}) => ({
  position: "relative",
  bottom: 0,
  width: "100%",
  minWidth: "100%",
  backgroundColor: n.colors.bgColor,
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), applyWideModePadding = (n) => ({
  // Increase side padding, if layout = wide and the screen is wide enough
  // The calculation is used to make sure that wide mode always has the same or larger
  // content compared to centered mode.
  [`@media (min-width: calc(${n.sizes.contentMaxWidth} + 2 * (${n.sizes.wideSidePadding} - ${n.spacing.lg})))`]: {
    paddingLeft: n.sizes.wideSidePadding,
    paddingRight: n.sizes.wideSidePadding
  },
  minWidth: "auto",
  maxWidth: "initial"
}), StyledAppViewBlockContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi6"
} : {
  target: "ea3mdgi6",
  label: "StyledAppViewBlockContainer"
})(({
  hasBottom: n,
  isWideMode: t,
  showPadding: g,
  hasHeader: d,
  showToolbar: k,
  hasTopNav: H,
  hasSidebar: AA,
  embedded: gA,
  theme: IA
}) => {
  const CA = "2.25rem";
  let BA = CA;
  gA ? g || k ? BA = "6rem" : (d || AA) && (BA = "4.5rem") : BA = H ? "8rem" : "6rem";
  const eA = g && !n ? "10rem" : IA.spacing.lg;
  return {
    width: IA.sizes.full,
    paddingLeft: IA.spacing.lg,
    paddingRight: IA.spacing.lg,
    paddingTop: BA,
    paddingBottom: eA,
    maxWidth: IA.sizes.contentMaxWidth,
    ...t && applyWideModePadding(IA),
    "@media print": {
      paddingTop: CA
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarBlockContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi5"
} : {
  target: "ea3mdgi5",
  label: "StyledSidebarBlockContainer"
})(({
  theme: n
}) => ({
  width: n.sizes.full
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledEventBlockContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi4"
} : {
  target: "ea3mdgi4",
  label: "StyledEventBlockContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "eivff4",
  styles: "display:none/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
}), StyledBottomBlockContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi3"
} : {
  target: "ea3mdgi3",
  label: "StyledBottomBlockContainer"
})(({
  isWideMode: n,
  showPadding: t,
  theme: g
}) => ({
  width: g.sizes.full,
  paddingLeft: g.spacing.lg,
  paddingRight: g.spacing.lg,
  paddingTop: g.spacing.lg,
  paddingBottom: t ? g.sizes.appDefaultBottomPadding : g.spacing.threeXL,
  maxWidth: g.sizes.contentMaxWidth,
  ...n && applyWideModePadding(g),
  "@media print": {
    paddingTop: g.spacing.none
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppViewBlockSpacer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi2"
} : {
  target: "ea3mdgi2",
  label: "StyledAppViewBlockSpacer"
})(({
  theme: n
}) => ({
  width: n.sizes.full,
  flexGrow: 1
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIFrameResizerAnchor = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi1"
} : {
  target: "ea3mdgi1",
  label: "StyledIFrameResizerAnchor"
})(({
  theme: n
}) => ({
  position: "relative",
  bottom: n.spacing.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMainContent = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi0"
} : {
  target: "ea3mdgi0",
  label: "StyledMainContent"
})(({
  theme: n
}) => ({
  width: n.sizes.full,
  minWidth: 0,
  height: "100dvh",
  // Apply relative positioning only on desktop to fix header positioning when sidebar opens.
  // On mobile, relative positioning is omitted to allow the sidebar to properly overlay
  // the app content for st.navigation(position='top') functionality (#11349).
  // Without this conditional positioning, the sidebar would overlap the top navigation
  // when opened on desktop devices.
  [`@media (min-width: ${n.breakpoints.md})`]: {
    position: "relative"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function ScrollToBottomContainer(n) {
  const {
    className: t,
    tabIndex: g,
    children: d,
    isEmbedded: k,
    disableScrolling: H
  } = n, AA = useScrollToBottom(!0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppViewMain, { tabIndex: g, className: t, isEmbedded: k, disableScrolling: H, ref: AA, "data-testid": "stAppScrollToBottomContainer", children: d });
}
function AppView(n) {
  const {
    elements: t,
    widgetMgr: g,
    uploadClient: d,
    appLogo: k,
    appPages: H,
    navSections: AA,
    onPageChange: gA,
    expandSidebarNav: IA,
    hideSidebarNav: CA,
    sendMessageToHost: BA,
    endpoints: eA,
    navigationPosition: iA,
    topRightContent: QA,
    pageLinkBaseUrl: tA = "",
    wideMode: oA,
    embedded: EA,
    showPadding: aA,
    disableScrolling: nA,
    currentPageScriptHash: lA
  } = n;
  useEffect(() => {
    const kA = () => {
      BA({
        type: "UPDATE_HASH",
        hash: window.location.hash
      });
    };
    return window.addEventListener("hashchange", kA, !1), () => window.removeEventListener("hashchange", kA, !1);
  }, [BA]);
  const {
    initialSidebarState: cA,
    widgetsDisabled: sA,
    showToolbar: rA
  } = useAppContext(), {
    addScriptFinishedHandler: uA,
    removeScriptFinishedHandler: hA,
    activeTheme: dA
  } = useContext(LibContext), {
    innerWidth: GA
  } = useWindowDimensionsContext(), DA = oA ? "wide" : "narrow", wA = !t.sidebar.isEmpty, bA = !t.event.isEmpty, yA = !t.bottom.isEmpty, [pA, MA] = useState(!1), LA = GA > 0 && (wA || iA === Navigation.Position.SIDEBAR && !CA && H.length > 1 || pA);
  useEffect(() => {
    LA && CA && !pA && MA(!0);
  }, [LA, CA, pA]);
  const xA = useCallback(() => {
    !wA && pA && MA(!1);
  }, [wA, pA]);
  useEffect(() => (uA(xA), () => {
    hA(xA);
  }), [xA, uA, hA]);
  const TA = yA ? ScrollToBottomContainer : StyledAppViewMain, NA = (kA) => /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerContentsWrapper, { node: kA, endpoints: eA, widgetMgr: g, widgetsDisabled: sA, uploadClient: d, height: "auto" }), [zA, XA] = useState(() => {
    const kA = getSavedSidebarState(tA);
    return kA !== null ? kA : shouldCollapse(cA, parseInt(dA.emotion.breakpoints.md, 10), GA);
  });
  useExecuteWhenChanged(() => {
    if (GA > 0 && LA) {
      const kA = getSavedSidebarState(tA);
      XA(kA !== null ? kA : shouldCollapse(cA, parseInt(dA.emotion.breakpoints.md, 10), GA));
    }
  }, [GA, LA, cA, dA.emotion.breakpoints.md, tA]);
  const fA = useCallback((kA, YA = !0) => {
    XA(kA), YA && saveSidebarState(tA, kA);
  }, [tA]), vA = useCallback(() => {
    fA(!zA, !0);
  }, [fA, zA]), Cg = k ? /* @__PURE__ */ jsxRuntimeExports.jsx(LogoComponent, { appLogo: k, endpoints: eA, collapsed: zA || !LA, componentName: "Header Logo", dataTestId: "stHeaderLogo" }) : null, Ig = Cg && (!LA || zA), gg = LA && zA, og = iA === Navigation.Position.TOP && shouldShowNavigation(H, AA), eg = Ig || gg || og || rA;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAppViewContainer, { className: "stAppViewContainer appview-container", "data-testid": "stAppViewContainer", "data-layout": DA, children: [
    LA && /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler, { id: "Sidebar", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemedSidebar, { endpoints: eA, appLogo: k, appPages: H, navSections: AA, hasElements: wA, onPageChange: gA, currentPageScriptHash: lA, hideSidebarNav: CA, expandSidebarNav: IA, isCollapsed: zA, onToggleCollapse: fA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarBlockContainer, { children: NA(t.sidebar) }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMainContent, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Header, { hasSidebar: LA, isSidebarOpen: LA && !zA, onToggleSidebar: vA, navigation: iA === Navigation.Position.TOP && shouldShowNavigation(H, AA) ? /* @__PURE__ */ jsxRuntimeExports.jsx(TopNav, { endpoints: eA, pageLinkBaseUrl: tA, currentPageScriptHash: lA, appPages: H, onPageChange: gA }) : null, rightContent: QA, logoComponent: Cg }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(TA, { tabIndex: 0, isEmbedded: EA, disableScrolling: nA, className: "stMain", "data-testid": "stMain", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler, { id: "Main", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppViewBlockContainer, { className: "stMainBlockContainer block-container", "data-testid": "stMainBlockContainer", isWideMode: oA, showPadding: aA, hasBottom: yA, hasHeader: eg, hasSidebar: LA, showToolbar: rA, hasTopNav: og, embedded: EA, children: NA(t.main) }) }),
        !yA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIFrameResizerAnchor, { "data-testid": "stAppIframeResizerAnchor", "data-iframe-height": !0 }),
        yA && /* @__PURE__ */ jsxRuntimeExports.jsxs(Profiler, { id: "Bottom", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppViewBlockSpacer, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStickyBottomContainer, { className: "stBottom", "data-testid": "stBottom", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInnerBottomContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledBottomBlockContainer, { "data-testid": "stBottomBlockContainer", isWideMode: oA, showPadding: aA, children: NA(t.bottom) }) }) })
        ] })
      ] })
    ] }),
    bA && /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler, { id: "Event", children: /* @__PURE__ */ jsxRuntimeExports.jsx(EventContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEventBlockContainer, { className: "stEvent", "data-testid": "stEvent", children: NA(t.event) }) }) })
  ] }) });
}
const DeployButtonContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e17vllj40"
} : {
  target: "e17vllj40",
  label: "DeployButtonContainer"
})(({
  theme: n
}) => ({
  display: "flex",
  gap: n.spacing.sm,
  alignItems: "center",
  lineHeight: n.iconSizes.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9EZXBsb3lCdXR0b24vc3R5bGVkLWNvbXBvbmVudHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCcUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL0RlcGxveUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNSlcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IERlcGxveUJ1dHRvbkNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgbGluZUhlaWdodDogdGhlbWUuaWNvblNpemVzLm1kLFxufSkpXG4iXX0= */"), DeployButton = ({
  onClick: n
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stAppDeployButton", "data-testid": "stAppDeployButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_BUTTON, onClick: n, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DeployButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Deploy" }) }) }) });
var MoreVert = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }));
});
MoreVert.displayName = "MoreVert";
const BLOB_TYPE = "video/webm", LOG$4 = loglevelExports$1.getLogger("ScreenCastRecorder");
class ScreenCastRecorder {
  /** True if the current browser likely supports screencasts. */
  static isSupportedBrowser() {
    try {
      return notNullOrUndefined(navigator.mediaDevices) && notNullOrUndefined(navigator.mediaDevices.getUserMedia) && notNullOrUndefined(navigator.mediaDevices.getDisplayMedia) && MediaRecorder.isTypeSupported(BLOB_TYPE);
    } catch {
      return !1;
    }
  }
  constructor({
    recordAudio: t,
    onErrorOrStop: g
  }) {
    this.recordAudio = t, this.onErrorOrStopCallback = g, this.inputStream = null, this.recordedChunks = [], this.mediaRecorder = null;
  }
  /**
   * This asynchronous method will initialize the screen recording object asking
   * for permissions to the user which are needed to start recording.
   */
  async initialize() {
    let g = (await navigator.mediaDevices.getDisplayMedia({
      video: !0
    })).getTracks();
    if (this.recordAudio) {
      const d = await navigator.mediaDevices.getUserMedia({
        video: !1,
        audio: !0
      });
      g = g.concat(d.getAudioTracks());
    }
    this.recordedChunks = [], this.inputStream = new MediaStream(g), this.mediaRecorder = new MediaRecorder(this.inputStream, {
      mimeType: BLOB_TYPE
    }), this.mediaRecorder.ondataavailable = (d) => this.recordedChunks.push(d.data);
  }
  getState() {
    return this.mediaRecorder ? this.mediaRecorder.state : "inactive";
  }
  /**
   * This method will start the screen recording if the user has granted permissions
   * and the mediaRecorder has been initialized
   *
   * @returns {boolean}
   */
  start() {
    if (!this.mediaRecorder)
      return LOG$4.warn("ScreenCastRecorder.start: mediaRecorder is null"), !1;
    const t = (g) => {
      LOG$4.warn(`mediaRecorder.start threw an error: ${g}`);
    };
    this.mediaRecorder.onerror = (g) => {
      t(g), this.onErrorOrStopCallback();
    }, this.mediaRecorder.onstop = () => this.onErrorOrStopCallback();
    try {
      this.mediaRecorder.start();
    } catch (g) {
      return t(g), !1;
    }
    return !0;
  }
  /**
   * This method will stop recording and then return the generated Blob
   *
   * @returns {(Promise|undefined)}
   *  A Promise which will return the generated Blob
   *  Undefined if the MediaRecorder could not initialize
   */
  stop() {
    if (!this.mediaRecorder)
      return;
    let t;
    const g = new Promise((d) => {
      t = d;
    });
    return this.mediaRecorder.onstop = () => t(), this.mediaRecorder.stop(), this.inputStream && (this.inputStream.getTracks().forEach((d) => d.stop()), this.inputStream = null), g.then(() => this.buildOutputBlob());
  }
  buildOutputBlob() {
    return new Blob(this.recordedChunks, {
      type: BLOB_TYPE
    });
  }
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$5() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const recordingIndicatorPulse = (n) => keyframes`
0% {
  box-shadow: 0 0 ${n.spacing.twoXS} ${n.colors.redTextColor};
}
50% {
  box-shadow: 0 0 ${n.spacing.sm} ${n.spacing.twoXS} ${n.colors.redTextColor};
}
100% {
  box-shadow: 0 0 ${n.spacing.twoXS} ${n.colors.redTextColor};
}`, StyledRecordingIndicator = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq808"
} : {
  target: "e16jpq808",
  label: "StyledRecordingIndicator"
})(({
  theme: n
}) => ({
  position: "absolute",
  bottom: n.spacing.lg,
  right: n.spacing.sm,
  width: n.spacing.sm,
  height: n.spacing.sm,
  backgroundColor: n.colors.redTextColor,
  borderRadius: n.radii.full,
  boxShadow: `0 0 ${n.spacing.twoXS} ${n.colors.redTextColor}`,
  animation: `${recordingIndicatorPulse(n)} 2s linear infinite`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuDivider = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq807"
} : {
  target: "e16jpq807",
  label: "StyledMenuDivider"
})(({
  theme: n
}) => ({
  borderTop: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
  margin: `${n.spacing.sm} ${n.spacing.none}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9NYWluTWVudS9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE4Q2lDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9NYWluTWVudS9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBrZXlmcmFtZXMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIlxuaW1wb3J0IHsgS2V5ZnJhbWVzIH0gZnJvbSBcIkBlbW90aW9uL3NlcmlhbGl6ZVwiXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgdHJhbnNwYXJlbnRpemUgfSBmcm9tIFwiY29sb3Iya1wiXG5cbmltcG9ydCB7IEVtb3Rpb25UaGVtZSB9IGZyb20gXCJAc3RyZWFtbGl0L2xpYlwiXG5cbmNvbnN0IHJlY29yZGluZ0luZGljYXRvclB1bHNlID0gKHRoZW1lOiBFbW90aW9uVGhlbWUpOiBLZXlmcmFtZXMgPT4ga2V5ZnJhbWVzYFxuMCUge1xuICBib3gtc2hhZG93OiAwIDAgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3J9O1xufVxuNTAlIHtcbiAgYm94LXNoYWRvdzogMCAwICR7dGhlbWUuc3BhY2luZy5zbX0gJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3J9O1xufVxuMTAwJSB7XG4gIGJveC1zaGFkb3c6IDAgMCAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuY29sb3JzLnJlZFRleHRDb2xvcn07XG59YFxuXG5leHBvcnQgY29uc3QgU3R5bGVkUmVjb3JkaW5nSW5kaWNhdG9yID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICBib3R0b206IHRoZW1lLnNwYWNpbmcubGcsXG4gIHJpZ2h0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICB3aWR0aDogdGhlbWUuc3BhY2luZy5zbSxcbiAgaGVpZ2h0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3IsXG4gIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZnVsbCxcbiAgYm94U2hhZG93OiBgMCAwICR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5jb2xvcnMucmVkVGV4dENvbG9yfWAsXG4gIGFuaW1hdGlvbjogYCR7cmVjb3JkaW5nSW5kaWNhdG9yUHVsc2UodGhlbWUpfSAycyBsaW5lYXIgaW5maW5pdGVgLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51RGl2aWRlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgYm9yZGVyVG9wOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgbWFyZ2luOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubm9uZX1gLFxufSkpXG5cbmV4cG9ydCBpbnRlcmZhY2UgSXRlbVByb3BzIHtcbiAgaXNEaXNhYmxlZDogYm9vbGVhblxuICBpc1JlY29yZGluZzogYm9vbGVhblxufVxuXG5leHBvcnQgaW50ZXJmYWNlIEl0ZW1TdHlsZVByb3BzIHtcbiAgaXNIaWdobGlnaHRlZDogYm9vbGVhblxuICBzdHlsZVByb3BzPzogUmVhY3QuQ1NTUHJvcGVydGllc1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVudUl0ZW1TaG9ydGN1dCA9IHN0eWxlZC5zcGFuPEl0ZW1Qcm9wcz4oXG4gICh7IGlzUmVjb3JkaW5nLCB0aGVtZSB9KSA9PiB7XG4gICAgcmV0dXJuIHtcbiAgICAgIGNvbG9yOiBpc1JlY29yZGluZ1xuICAgICAgICA/IHRoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3JcbiAgICAgICAgOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgICAgZm9udFZhcmlhbnQ6IFwic21hbGwtY2Fwc1wiLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJ1cHBlcmNhc2VcIixcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVJdGVtID0gc3R5bGVkLnVsPEl0ZW1Qcm9wcz4oXG4gICh7IGlzRGlzYWJsZWQsIGlzUmVjb3JkaW5nLCB0aGVtZSB9KSA9PiB7XG4gICAgY29uc3QgZGlzYWJsZWRTdHlsZXMgPSBpc0Rpc2FibGVkXG4gICAgICA/IHtcbiAgICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICAgICAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgICAgICB9XG4gICAgICA6IHtcbiAgICAgICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAgICAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMud2hpdGUsXG4gICAgICAgICAgfSxcbiAgICAgICAgfVxuXG4gICAgY29uc3QgcmVjb3JkaW5nU3R5bGVzID0gaXNSZWNvcmRpbmcgJiYge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3IsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ib2xkLFxuICAgIH1cblxuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICBmbGV4RGlyZWN0aW9uOiBcInJvd1wiLFxuICAgICAgYWxpZ25JdGVtczogXCJmbGV4LXN0YXJ0XCIsXG4gICAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgLi4uKHJlY29yZGluZ1N0eWxlcyB8fCB7fSksXG4gICAgICAuLi5kaXNhYmxlZFN0eWxlcyxcbiAgICAgIFwiQG1lZGlhIHByaW50XCI6IHtcbiAgICAgICAgZGlzcGxheTogXCJub25lICFpbXBvcnRhbnRcIixcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDb3JlSXRlbSA9IHN0eWxlZC5saTxJdGVtU3R5bGVQcm9wcz4oXG4gICh7IGlzSGlnaGxpZ2h0ZWQsIHN0eWxlUHJvcHMsIHRoZW1lIH0pID0+IHtcbiAgICBjb25zdCBoaWdobGlnaHRlZFN0eWxlcyA9IGlzSGlnaGxpZ2h0ZWQgJiYge1xuICAgICAgXCImOmhvdmVyXCI6IHtcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgICAgfSxcbiAgICB9XG5cbiAgICBjb25zdCBtYXJnaW4gPSBzdHlsZVByb3BzPy5tYXJnaW4gfHwgMFxuICAgIGNvbnN0IHBhZGRpbmcgPVxuICAgICAgc3R5bGVQcm9wcz8ucGFkZGluZyB8fCBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcudHdvWEx9YFxuICAgIGNvbnN0IGJhY2tncm91bmRDb2xvciA9IHN0eWxlUHJvcHM/LmJhY2tncm91bmRDb2xvciB8fCB0aGVtZS5jb2xvcnMuYmdDb2xvclxuICAgIGNvbnN0IGZvbnRTaXplID0gc3R5bGVQcm9wcz8uZm9udFNpemUgfHwgdGhlbWUuZm9udFNpemVzLm1kXG5cbiAgICByZXR1cm4ge1xuICAgICAgbWFyZ2luLFxuICAgICAgcGFkZGluZyxcbiAgICAgIGJhY2tncm91bmRDb2xvcixcbiAgICAgIGZvbnRTaXplLFxuICAgICAgLi4uKGhpZ2hsaWdodGVkU3R5bGVzIHx8IHt9KSxcbiAgICAgIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERldkl0ZW0gPSBzdHlsZWQubGk8SXRlbVN0eWxlUHJvcHM+KFxuICAoeyBpc0hpZ2hsaWdodGVkLCBzdHlsZVByb3BzLCB0aGVtZSB9KSA9PiB7XG4gICAgY29uc3QgaGlnaGxpZ2h0ZWRTdHlsZXMgPSBpc0hpZ2hsaWdodGVkICYmIHtcbiAgICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICAgIC8vIFdoYXRldmVyIGNvbG9yIHdlIHVzZSBoZXJlIGFzIHRoZSBob3ZlciBzdGF0ZSwgd2Ugd2FudCB0byB0cmFuc3BhcmVudGl6ZSBpdFxuICAgICAgICAvLyB0byBpdHMgZnVsbCBleHRlbmQsIHNvIHlvdSBjYW4gc2VlIHRoZSB1bmRlcmx5aW5nIGNvbG9yIG9mIHRoZSBtZW51LlxuICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsIDEpLFxuICAgICAgfSxcbiAgICB9XG4gICAgY29uc3QgbWFyZ2luID0gc3R5bGVQcm9wcz8ubWFyZ2luIHx8IDBcbiAgICBjb25zdCBwYWRkaW5nID1cbiAgICAgIHN0eWxlUHJvcHM/LnBhZGRpbmcgfHwgYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLnR3b1hMfWBcbiAgICBjb25zdCBiYWNrZ3JvdW5kQ29sb3IgPVxuICAgICAgc3R5bGVQcm9wcz8uYmFja2dyb3VuZENvbG9yIHx8IHRoZW1lLmNvbG9ycy5zZWNvbmRhcnlCZ1xuICAgIGNvbnN0IGZvbnRTaXplID0gc3R5bGVQcm9wcz8uZm9udFNpemUgfHwgdGhlbWUuZm9udFNpemVzLm1kXG4gICAgcmV0dXJuIHtcbiAgICAgIG1hcmdpbixcbiAgICAgIHBhZGRpbmcsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3IsXG4gICAgICBmb250U2l6ZSxcbiAgICAgIC4uLihoaWdobGlnaHRlZFN0eWxlcyB8fCB7fSksXG4gICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51SXRlbUxhYmVsID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubWQsXG4gIGZsZXhHcm93OiAxLFxuICAvLyBXZSBkbyBub3Qgd2FudCB0byBjaGFuZ2UgdGhlIGZvbnQgZm9yIHRoaXMgYmFzZWQgb24gdGhlbWUuXG4gIGZvbnRGYW1pbHk6IHRoZW1lLmZvbnRzLnNhbnNTZXJpZixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVudUNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgLy8gV2Ugc3RhcnQgYnkgYWRkaW5nIGJvcmRlciByYWRpdXMgdG8gYWxsIG1lbnVzXG4gIHVsOiB7XG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICB9LFxuXG4gIC8vIFRoaXMgc2VsZWN0cyB0aGUgc3RhbmRhcmQgbWVudSBvbmx5IGlmIHRoZXJlJ3MgYW5vdGhlciBtZW51IGJlbG93LlxuICAvLyBXZSB1c2UgdGhpcyB0byBvdmVycmlkZSB0aGUgYm90dG9tIGJvcmRlciByYWRpdXMgb24gdGhlIGxhc3QgaXRlbSBpZiB0aGUgZGV2ZWxvcGVyIG9wdGlvbnMgbWVudSBpcyB2aXNpYmxlLlxuICBcIiYgPiB1bFtyb2xlPWxpc3Rib3hdOm5vdCg6bGFzdC1jaGlsZClcIjoge1xuICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IDAsXG4gICAgYm9yZGVyQm90dG9tUmlnaHRSYWRpdXM6IDAsXG4gIH0sXG5cbiAgLy8gVGhpcyBzZWxlY3RzIHRoZSBkZXZlbG9wZXIgb3B0aW9ucyBtZW51LCBpZiBpdCBleGlzdHMuXG4gIC8vIFdlIHVzZSB0aGlzIHRvIG92ZXJyaWRlIHRoZSB0b3AgYm9yZGVyIHJhZGl1cy5cbiAgXCJ1bFtyb2xlPWxpc3Rib3hdIH4gdWxbcm9sZT1saXN0Ym94XVwiOiB7XG4gICAgYm9yZGVyVG9wTGVmdFJhZGl1czogMCxcbiAgICBib3JkZXJUb3BSaWdodFJhZGl1czogMCxcbiAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgIGJvcmRlclRvcDogXCJub25lXCIsXG4gIH0sXG4gIFwiQG1lZGlhIHByaW50XCI6IHtcbiAgICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWFpbk1lbnVDb250YWluZXIgPSBzdHlsZWQuc3Bhbih7XG4gIGxpbmVIZWlnaHQ6IFwiaW5pdGlhbFwiLFxufSlcbiJdfQ== */"), StyledMenuItemShortcut = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq806"
} : {
  target: "e16jpq806",
  label: "StyledMenuItemShortcut"
})(({
  isRecording: n,
  theme: t
}) => ({
  color: n ? t.colors.redTextColor : t.colors.fadedText60,
  fontSize: t.fontSizes.sm,
  marginTop: t.spacing.twoXS,
  fontVariant: "small-caps",
  textTransform: "uppercase"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuItem = /* @__PURE__ */ createStyled$1("ul", process.env.NODE_ENV === "production" ? {
  target: "e16jpq805"
} : {
  target: "e16jpq805",
  label: "StyledMenuItem"
})(({
  isDisabled: n,
  isRecording: t,
  theme: g
}) => {
  const d = n ? {
    backgroundColor: g.colors.transparent,
    color: g.colors.fadedText60,
    cursor: "not-allowed"
  } : {
    "&:focus": {
      backgroundColor: g.colors.primary,
      color: g.colors.white
    }
  }, k = t && {
    color: g.colors.redTextColor,
    fontWeight: g.fontWeights.bold
  };
  return {
    display: "block",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: g.spacing.none,
    cursor: "pointer",
    ...k || {},
    ...d,
    "@media print": {
      display: "none !important"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCoreItem = /* @__PURE__ */ createStyled$1("li", process.env.NODE_ENV === "production" ? {
  target: "e16jpq804"
} : {
  target: "e16jpq804",
  label: "StyledCoreItem"
})(({
  isHighlighted: n,
  styleProps: t,
  theme: g
}) => {
  const d = n && {
    "&:hover": {
      backgroundColor: g.colors.darkenedBgMix15
    }
  }, k = t?.margin || 0, H = t?.padding || `${g.spacing.twoXS} ${g.spacing.twoXL}`, AA = t?.backgroundColor || g.colors.bgColor, gA = t?.fontSize || g.fontSizes.md;
  return {
    margin: k,
    padding: H,
    backgroundColor: AA,
    fontSize: gA,
    ...d || {},
    display: "block"
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDevItem = /* @__PURE__ */ createStyled$1("li", process.env.NODE_ENV === "production" ? {
  target: "e16jpq803"
} : {
  target: "e16jpq803",
  label: "StyledDevItem"
})(({
  isHighlighted: n,
  styleProps: t,
  theme: g
}) => {
  const d = n && {
    "&:hover": {
      // Whatever color we use here as the hover state, we want to transparentize it
      // to its full extend, so you can see the underlying color of the menu.
      backgroundColor: transparentize(g.colors.darkenedBgMix15, 1)
    }
  }, k = t?.margin || 0, H = t?.padding || `${g.spacing.twoXS} ${g.spacing.twoXL}`, AA = t?.backgroundColor || g.colors.secondaryBg, gA = t?.fontSize || g.fontSizes.md;
  return {
    margin: k,
    padding: H,
    backgroundColor: AA,
    fontSize: gA,
    ...d || {},
    display: "block"
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuItemLabel = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq802"
} : {
  target: "e16jpq802",
  label: "StyledMenuItemLabel"
})(({
  theme: n
}) => ({
  marginRight: n.spacing.md,
  flexGrow: 1,
  // We do not want to change the font for this based on theme.
  fontFamily: n.fonts.sansSerif
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq801"
} : {
  target: "e16jpq801",
  label: "StyledMenuContainer"
})(({
  theme: n
}) => ({
  // We start by adding border radius to all menus
  ul: {
    borderRadius: n.radii.default
  },
  // This selects the standard menu only if there's another menu below.
  // We use this to override the bottom border radius on the last item if the developer options menu is visible.
  "& > ul[role=listbox]:not(:last-child)": {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  // This selects the developer options menu, if it exists.
  // We use this to override the top border radius.
  "ul[role=listbox] ~ ul[role=listbox]": {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    boxShadow: "none",
    borderTop: "none"
  },
  "@media print": {
    display: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMainMenuContainer = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq800"
} : {
  target: "e16jpq800",
  label: "StyledMainMenuContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "hwawmg",
  styles: "line-height:initial"
} : {
  name: "hwawmg",
  styles: "line-height:initial/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
}), SCREENCAST_LABEL = {
  COUNTDOWN: "Cancel screencast",
  RECORDING: "Stop recording"
}, getOpenInWindowCallback = (n) => () => {
  window.open(n, "_blank");
};
function buildMenuItemComponent(n, t) {
  const g = forwardRef(({
    item: d,
    "aria-selected": k,
    onClick: H,
    onMouseEnter: AA,
    $disabled: gA,
    $isHighlighted: IA
  }, CA) => {
    const {
      label: BA,
      shortcut: eA,
      hasDividerAbove: iA,
      styleProps: QA,
      noHighlight: tA,
      interactions: oA
    } = d, EA = {
      isDisabled: gA,
      isRecording: !!d.stopRecordingIndicator
    }, aA = {
      isHighlighted: !tA && IA,
      styleProps: QA
    }, nA = oA || (gA ? {} : {
      onClick: (lA) => {
        t.enqueue("menuClick", {
          label: BA
        }), H(lA);
      },
      onMouseEnter: AA
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      iA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuDivider, { "data-testid": "stMainMenuDivider" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuItem, { ref: CA, role: "option", "aria-selected": k, "aria-disabled": gA, ...EA, ...nA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(n, { ...aA, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuItemLabel, { ...EA, children: BA }),
        eA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuItemShortcut, { ...EA, children: eA })
      ] }) })
    ] });
  });
  return g.displayName = "MenuItem", g;
}
const SubMenu = (n) => {
  const {
    colors: t,
    sizes: g,
    spacing: d
  } = useEmotionTheme(), k = n.isDevMenu ? StyledDevItem : StyledCoreItem;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StatefulMenu, { items: n.menuItems, onItemSelect: ({
    item: H
  }) => {
    H.onClick(), n.closeMenu();
  }, overrides: {
    Option: buildMenuItemComponent(k, n.metricsMgr),
    List: {
      props: {
        "data-testid": "stMainMenuList"
      },
      style: {
        backgroundColor: "inherit",
        borderBottomRadius: 0,
        borderTopRadius: 0,
        borderLeftRadius: 0,
        borderRightRadius: 0,
        paddingBottom: d.sm,
        paddingTop: d.sm,
        ":focus": {
          outline: "none"
        },
        border: `${g.borderWidth} solid ${t.borderColor}`
      }
    }
  } });
};
function getDevMenuItems(n, t) {
  const g = [], d = [t.developerOptions, t.clearCache];
  let k = null;
  for (const H of d)
    H && (H !== t.DIVIDER && (k === t.DIVIDER ? g.push({
      ...H,
      hasDividerAbove: !0
    }) : g.push(H)), k = H);
  return notNullOrUndefined(k) && (k.styleProps = {
    margin: `0 0 -${n.spacing.sm} 0`,
    padding: `${n.spacing.twoXS} ${n.spacing.none} ${n.spacing.twoXS} ${n.spacing.twoXL}`
  }), g;
}
function getPreferredMenuOrder(n, t, g) {
  let d;
  if (n.toolbarMode == Config.ToolbarMode.MINIMAL) {
    for (d = [g.report, g.community, g.DIVIDER, ...t.length > 0 ? t : [g.DIVIDER], g.about], d = d.filter((k) => k); d.length > 0 && d[0] == g.DIVIDER; )
      d.shift();
    for (; d.length > 0 && d.at(d.length - 1) == g.DIVIDER; )
      d.pop();
    return d;
  }
  return [g.rerun, g.settings, g.DIVIDER, g.print, ...ScreenCastRecorder.isSupportedBrowser() ? [g.recordScreencast] : [], g.DIVIDER, g.report, g.community, ...t.length > 0 ? t : [g.DIVIDER], g.about];
}
function MainMenu(n) {
  const t = useEmotionTheme(), g = !n.isServerConnected, d = {
    DIVIDER: {
      isDivider: !0
    },
    rerun: {
      disabled: g,
      onClick: n.quickRerunCallback,
      label: "Rerun",
      shortcut: "r"
    },
    print: {
      onClick: n.printCallback,
      label: "Print"
    },
    recordScreencast: {
      onClick: n.screencastCallback,
      label: SCREENCAST_LABEL[n.screenCastState] || "Record a screencast",
      shortcut: SCREENCAST_LABEL[n.screenCastState] ? "esc" : "",
      stopRecordingIndicator: !!SCREENCAST_LABEL[n.screenCastState]
    },
    ...!n.menuItems?.hideGetHelp && n.menuItems?.getHelpUrl && {
      community: {
        onClick: getOpenInWindowCallback(n.menuItems?.getHelpUrl),
        label: "Get help"
      }
    },
    ...!n.menuItems?.hideReportABug && n.menuItems?.reportABugUrl && {
      report: {
        onClick: getOpenInWindowCallback(n.menuItems?.reportABugUrl),
        label: "Report a bug"
      }
    },
    settings: {
      onClick: n.settingsCallback,
      label: "Settings"
    },
    ...n.menuItems?.aboutSectionMd && {
      about: {
        onClick: n.aboutCallback,
        label: "About"
      }
    }
  }, k = {
    DIVIDER: {},
    developerOptions: {
      label: "Developer options",
      noHighlight: !0,
      interactions: {},
      styleProps: {
        fontSize: convertRemToPx(t.fontSizes.twoSm),
        margin: `-${t.spacing.sm} 0 0 0`,
        padding: `${t.spacing.twoXS} ${t.spacing.none} ${t.spacing.twoXS} ${t.spacing.twoXL}`,
        pointerEvents: "none"
      }
    },
    clearCache: {
      disabled: g,
      onClick: n.clearCacheCallback,
      label: "Clear cache",
      shortcut: "c"
    }
  }, H = n.hostMenuItems.map((BA) => BA.type === "separator" ? d.DIVIDER : BA.key === "reportBug" && n.menuItems?.hideGetHelp || BA.key === "about" && n.menuItems?.aboutSectionMd !== "" ? null : {
    onClick: () => n.sendMessageToHost({
      type: "MENU_ITEM_CALLBACK",
      key: BA.key
    }),
    label: BA.label
  }, []), AA = getPreferredMenuOrder(n, H, d), gA = [];
  let IA = null;
  for (const BA of AA)
    BA && (BA !== d.DIVIDER && (IA === d.DIVIDER ? gA.push({
      ...BA,
      hasDividerAbove: !0
    }) : gA.push(BA)), IA = BA);
  const CA = n.developmentMode ? getDevMenuItems(t, k) : [];
  return gA.length == 0 && CA.length == 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(StatefulPopover, { focusLock: !0, placement: PLACEMENT.bottomRight, content: ({
    close: BA
  }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMenuContainer, { children: [
    gA.length != 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(SubMenu, { menuItems: gA, closeMenu: BA, isDevMenu: !1, metricsMgr: n.metricsMgr }),
    CA.length != 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(SubMenu, { menuItems: CA, closeMenu: BA, isDevMenu: !0, metricsMgr: n.metricsMgr })
  ] }), overrides: {
    Body: {
      props: {
        "data-testid": "stMainMenuPopover",
        className: "stMainMenuPopover"
      }
    }
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMainMenuContainer, { id: "MainMenu", className: "stMainMenu", "data-testid": "stMainMenu", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_NO_PADDING, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { content: MoreVert, size: "lg" }) }),
    n.screenCastState === "RECORDING" && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledRecordingIndicator, {})
  ] }) });
}
const MainMenu$1 = memo$1(MainMenu);
function hasClass(n, t) {
  return n.classList ? !!t && n.classList.contains(t) : (" " + (n.className.baseVal || n.className) + " ").indexOf(" " + t + " ") !== -1;
}
function addClass(n, t) {
  n.classList ? n.classList.add(t) : hasClass(n, t) || (typeof n.className == "string" ? n.className = n.className + " " + t : n.setAttribute("class", (n.className && n.className.baseVal || "") + " " + t));
}
function replaceClassName(n, t) {
  return n.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass$1(n, t) {
  n.classList ? n.classList.remove(t) : typeof n.className == "string" ? n.className = replaceClassName(n.className, t) : n.setAttribute("class", replaceClassName(n.className && n.className.baseVal || "", t));
}
const config = {
  disabled: !1
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null, classNamesShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function n(t) {
  return t.scrollTop;
}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ (function(n) {
  _inheritsLoose(t, n);
  function t(d, k) {
    var H;
    H = n.call(this, d, k) || this;
    var AA = k, gA = AA && !AA.isMounting ? d.enter : d.appear, IA;
    return H.appearStatus = null, d.in ? gA ? (IA = EXITED, H.appearStatus = ENTERING) : IA = ENTERED : d.unmountOnExit || d.mountOnEnter ? IA = UNMOUNTED : IA = EXITED, H.state = {
      status: IA
    }, H.nextCallback = null, H;
  }
  t.getDerivedStateFromProps = function(k, H) {
    var AA = k.in;
    return AA && H.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var g = t.prototype;
  return g.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, g.componentDidUpdate = function(k) {
    var H = null;
    if (k !== this.props) {
      var AA = this.state.status;
      this.props.in ? AA !== ENTERING && AA !== ENTERED && (H = ENTERING) : (AA === ENTERING || AA === ENTERED) && (H = EXITING);
    }
    this.updateStatus(!1, H);
  }, g.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, g.getTimeouts = function() {
    var k = this.props.timeout, H, AA, gA;
    return H = AA = gA = k, k != null && typeof k != "number" && (H = k.exit, AA = k.enter, gA = k.appear !== void 0 ? k.appear : AA), {
      exit: H,
      enter: AA,
      appear: gA
    };
  }, g.updateStatus = function(k, H) {
    if (k === void 0 && (k = !1), H !== null)
      if (this.cancelNextCallback(), H === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var AA = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
          AA && forceReflow(AA);
        }
        this.performEnter(k);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === EXITED && this.setState({
      status: UNMOUNTED
    });
  }, g.performEnter = function(k) {
    var H = this, AA = this.props.enter, gA = this.context ? this.context.isMounting : k, IA = this.props.nodeRef ? [gA] : [ReactDOM.findDOMNode(this), gA], CA = IA[0], BA = IA[1], eA = this.getTimeouts(), iA = gA ? eA.appear : eA.enter;
    if (!k && !AA || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        H.props.onEntered(CA);
      });
      return;
    }
    this.props.onEnter(CA, BA), this.safeSetState({
      status: ENTERING
    }, function() {
      H.props.onEntering(CA, BA), H.onTransitionEnd(iA, function() {
        H.safeSetState({
          status: ENTERED
        }, function() {
          H.props.onEntered(CA, BA);
        });
      });
    });
  }, g.performExit = function() {
    var k = this, H = this.props.exit, AA = this.getTimeouts(), gA = this.props.nodeRef ? void 0 : ReactDOM.findDOMNode(this);
    if (!H || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        k.props.onExited(gA);
      });
      return;
    }
    this.props.onExit(gA), this.safeSetState({
      status: EXITING
    }, function() {
      k.props.onExiting(gA), k.onTransitionEnd(AA.exit, function() {
        k.safeSetState({
          status: EXITED
        }, function() {
          k.props.onExited(gA);
        });
      });
    });
  }, g.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, g.safeSetState = function(k, H) {
    H = this.setNextCallback(H), this.setState(k, H);
  }, g.setNextCallback = function(k) {
    var H = this, AA = !0;
    return this.nextCallback = function(gA) {
      AA && (AA = !1, H.nextCallback = null, k(gA));
    }, this.nextCallback.cancel = function() {
      AA = !1;
    }, this.nextCallback;
  }, g.onTransitionEnd = function(k, H) {
    this.setNextCallback(H);
    var AA = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this), gA = k == null && !this.props.addEndListener;
    if (!AA || gA) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var IA = this.props.nodeRef ? [this.nextCallback] : [AA, this.nextCallback], CA = IA[0], BA = IA[1];
      this.props.addEndListener(CA, BA);
    }
    k != null && setTimeout(this.nextCallback, k);
  }, g.render = function() {
    var k = this.state.status;
    if (k === UNMOUNTED)
      return null;
    var H = this.props, AA = H.children;
    H.in, H.mountOnEnter, H.unmountOnExit, H.appear, H.enter, H.exit, H.timeout, H.addEndListener, H.onEnter, H.onEntering, H.onEntered, H.onExit, H.onExiting, H.onExited, H.nodeRef;
    var gA = _objectWithoutPropertiesLoose$j(H, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof AA == "function" ? AA(k, gA) : React__default.cloneElement(React__default.Children.only(AA), gA))
    );
  }, t;
})(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(n, t, g, d, k, H) {
      var AA = n[t];
      return PropTypes.instanceOf(AA && "ownerDocument" in AA ? AA.ownerDocument.defaultView.Element : Element)(n, t, g, d, k, H);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function n(t) {
    var g = timeoutsShape;
    t.addEndListener || (g = g.isRequired);
    for (var d = arguments.length, k = new Array(d > 1 ? d - 1 : 0), H = 1; H < d; H++)
      k[H - 1] = arguments[H];
    return g.apply(void 0, [t].concat(k));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop$1() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop$1,
  onEntering: noop$1,
  onEntered: noop$1,
  onExit: noop$1,
  onExiting: noop$1,
  onExited: noop$1
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var _addClass = function n(t, g) {
  return t && g && g.split(" ").forEach(function(d) {
    return addClass(t, d);
  });
}, removeClass = function n(t, g) {
  return t && g && g.split(" ").forEach(function(d) {
    return removeClass$1(t, d);
  });
}, CSSTransition = /* @__PURE__ */ (function(n) {
  _inheritsLoose(t, n);
  function t() {
    for (var d, k = arguments.length, H = new Array(k), AA = 0; AA < k; AA++)
      H[AA] = arguments[AA];
    return d = n.call.apply(n, [this].concat(H)) || this, d.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, d.onEnter = function(gA, IA) {
      var CA = d.resolveArguments(gA, IA), BA = CA[0], eA = CA[1];
      d.removeClasses(BA, "exit"), d.addClass(BA, eA ? "appear" : "enter", "base"), d.props.onEnter && d.props.onEnter(gA, IA);
    }, d.onEntering = function(gA, IA) {
      var CA = d.resolveArguments(gA, IA), BA = CA[0], eA = CA[1], iA = eA ? "appear" : "enter";
      d.addClass(BA, iA, "active"), d.props.onEntering && d.props.onEntering(gA, IA);
    }, d.onEntered = function(gA, IA) {
      var CA = d.resolveArguments(gA, IA), BA = CA[0], eA = CA[1], iA = eA ? "appear" : "enter";
      d.removeClasses(BA, iA), d.addClass(BA, iA, "done"), d.props.onEntered && d.props.onEntered(gA, IA);
    }, d.onExit = function(gA) {
      var IA = d.resolveArguments(gA), CA = IA[0];
      d.removeClasses(CA, "appear"), d.removeClasses(CA, "enter"), d.addClass(CA, "exit", "base"), d.props.onExit && d.props.onExit(gA);
    }, d.onExiting = function(gA) {
      var IA = d.resolveArguments(gA), CA = IA[0];
      d.addClass(CA, "exit", "active"), d.props.onExiting && d.props.onExiting(gA);
    }, d.onExited = function(gA) {
      var IA = d.resolveArguments(gA), CA = IA[0];
      d.removeClasses(CA, "exit"), d.addClass(CA, "exit", "done"), d.props.onExited && d.props.onExited(gA);
    }, d.resolveArguments = function(gA, IA) {
      return d.props.nodeRef ? [d.props.nodeRef.current, gA] : [gA, IA];
    }, d.getClassNames = function(gA) {
      var IA = d.props.classNames, CA = typeof IA == "string", BA = CA && IA ? IA + "-" : "", eA = CA ? "" + BA + gA : IA[gA], iA = CA ? eA + "-active" : IA[gA + "Active"], QA = CA ? eA + "-done" : IA[gA + "Done"];
      return {
        baseClassName: eA,
        activeClassName: iA,
        doneClassName: QA
      };
    }, d;
  }
  var g = t.prototype;
  return g.addClass = function(k, H, AA) {
    var gA = this.getClassNames(H)[AA + "ClassName"], IA = this.getClassNames("enter"), CA = IA.doneClassName;
    H === "appear" && AA === "done" && CA && (gA += " " + CA), AA === "active" && k && forceReflow(k), gA && (this.appliedClasses[H][AA] = gA, _addClass(k, gA));
  }, g.removeClasses = function(k, H) {
    var AA = this.appliedClasses[H], gA = AA.base, IA = AA.active, CA = AA.done;
    this.appliedClasses[H] = {}, gA && removeClass(k, gA), IA && removeClass(k, IA), CA && removeClass(k, CA);
  }, g.render = function() {
    var k = this.props;
    k.classNames;
    var H = _objectWithoutPropertiesLoose$j(k, ["classNames"]);
    return /* @__PURE__ */ React__default.createElement(Transition, _extends$M({}, H, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
})(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ""
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$M({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var ConnectionState = /* @__PURE__ */ ((n) => (n.CONNECTED = "CONNECTED", n.DISCONNECTED_FOREVER = "DISCONNECTED_FOREVER", n.INITIAL = "INITIAL", n.PINGING_SERVER = "PINGING_SERVER", n.CONNECTING = "CONNECTING", n.STATIC_CONNECTING = "STATIC_CONNECTING", n.STATIC_CONNECTED = "STATIC_CONNECTED", n))(ConnectionState || {});
const IS_DEV_ENV = process.env.NODE_ENV === "development";
typeof Promise.withResolvers > "u" && (Promise.withResolvers = () => {
  let n, t;
  const g = new Promise((d, k) => {
    n = d, t = k;
  });
  return {
    resolve: n,
    reject: t,
    promise: g
  };
});
function u(n) {
  const t = document.cookie.match(`\\b${n}=([^;]*)\\b`);
  return t ? t[1] : void 0;
}
function m$1(n) {
  return n != null;
}
const i = /\/+$/, l = /^\/+/;
function f({
  hostname: n,
  port: t,
  pathname: g,
  protocol: d
}, k) {
  const H = s(g, k);
  return `${d}//${n}${t ? `:${t}` : ""}/${H}`;
}
function s(n, t) {
  return n = n.replace(i, "").replace(l, ""), t = t.replace(i, "").replace(l, ""), n.length === 0 ? t : `${n}/${t}`;
}
loglevelExports$1.getLogger("StaticConnection");
const FINAL_SLASH_RE = /\/+$/, INITIAL_SLASH_RE = /^\/+/;
function parseUriIntoBaseParts(n) {
  const t = new URL(window.location.href === "about:blank" ? "" : window.location.href);
  return t.pathname = t.pathname.replace(FINAL_SLASH_RE, "").replace(INITIAL_SLASH_RE, ""), t;
}
function bind(n, t) {
  return function() {
    return n.apply(t, arguments);
  };
}
const { toString: toString$1 } = Object.prototype, { getPrototypeOf } = Object, { iterator, toStringTag } = Symbol, kindOf = /* @__PURE__ */ ((n) => (t) => {
  const g = toString$1.call(t);
  return n[g] || (n[g] = g.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest = (n) => (n = n.toLowerCase(), (t) => kindOf(t) === n), typeOfTest = (n) => (t) => typeof t === n, { isArray } = Array, isUndefined = typeOfTest("undefined");
function isBuffer(n) {
  return n !== null && !isUndefined(n) && n.constructor !== null && !isUndefined(n.constructor) && isFunction$1(n.constructor.isBuffer) && n.constructor.isBuffer(n);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(n) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(n) : t = n && n.buffer && isArrayBuffer(n.buffer), t;
}
const isString = typeOfTest("string"), isFunction$1 = typeOfTest("function"), isNumber = typeOfTest("number"), isObject$1 = (n) => n !== null && typeof n == "object", isBoolean = (n) => n === !0 || n === !1, isPlainObject = (n) => {
  if (kindOf(n) !== "object")
    return !1;
  const t = getPrototypeOf(n);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(toStringTag in n) && !(iterator in n);
}, isEmptyObject = (n) => {
  if (!isObject$1(n) || isBuffer(n))
    return !1;
  try {
    return Object.keys(n).length === 0 && Object.getPrototypeOf(n) === Object.prototype;
  } catch {
    return !1;
  }
}, isDate = kindOfTest("Date"), isFile = kindOfTest("File"), isBlob = kindOfTest("Blob"), isFileList = kindOfTest("FileList"), isStream = (n) => isObject$1(n) && isFunction$1(n.pipe), isFormData = (n) => {
  let t;
  return n && (typeof FormData == "function" && n instanceof FormData || isFunction$1(n.append) && ((t = kindOf(n)) === "formdata" || // detect form-data instance
  t === "object" && isFunction$1(n.toString) && n.toString() === "[object FormData]"));
}, isURLSearchParams = kindOfTest("URLSearchParams"), [isReadableStream, isRequest, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest), trim = (n) => n.trim ? n.trim() : n.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(n, t, { allOwnKeys: g = !1 } = {}) {
  if (n === null || typeof n > "u")
    return;
  let d, k;
  if (typeof n != "object" && (n = [n]), isArray(n))
    for (d = 0, k = n.length; d < k; d++)
      t.call(null, n[d], d, n);
  else {
    if (isBuffer(n))
      return;
    const H = g ? Object.getOwnPropertyNames(n) : Object.keys(n), AA = H.length;
    let gA;
    for (d = 0; d < AA; d++)
      gA = H[d], t.call(null, n[gA], gA, n);
  }
}
function findKey(n, t) {
  if (isBuffer(n))
    return null;
  t = t.toLowerCase();
  const g = Object.keys(n);
  let d = g.length, k;
  for (; d-- > 0; )
    if (k = g[d], t === k.toLowerCase())
      return k;
  return null;
}
const _global = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, isContextDefined = (n) => !isUndefined(n) && n !== _global;
function merge() {
  const { caseless: n, skipUndefined: t } = isContextDefined(this) && this || {}, g = {}, d = (k, H) => {
    const AA = n && findKey(g, H) || H;
    isPlainObject(g[AA]) && isPlainObject(k) ? g[AA] = merge(g[AA], k) : isPlainObject(k) ? g[AA] = merge({}, k) : isArray(k) ? g[AA] = k.slice() : (!t || !isUndefined(k)) && (g[AA] = k);
  };
  for (let k = 0, H = arguments.length; k < H; k++)
    arguments[k] && forEach(arguments[k], d);
  return g;
}
const extend = (n, t, g, { allOwnKeys: d } = {}) => (forEach(t, (k, H) => {
  g && isFunction$1(k) ? n[H] = bind(k, g) : n[H] = k;
}, { allOwnKeys: d }), n), stripBOM = (n) => (n.charCodeAt(0) === 65279 && (n = n.slice(1)), n), inherits = (n, t, g, d) => {
  n.prototype = Object.create(t.prototype, d), n.prototype.constructor = n, Object.defineProperty(n, "super", {
    value: t.prototype
  }), g && Object.assign(n.prototype, g);
}, toFlatObject = (n, t, g, d) => {
  let k, H, AA;
  const gA = {};
  if (t = t || {}, n == null) return t;
  do {
    for (k = Object.getOwnPropertyNames(n), H = k.length; H-- > 0; )
      AA = k[H], (!d || d(AA, n, t)) && !gA[AA] && (t[AA] = n[AA], gA[AA] = !0);
    n = g !== !1 && getPrototypeOf(n);
  } while (n && (!g || g(n, t)) && n !== Object.prototype);
  return t;
}, endsWith = (n, t, g) => {
  n = String(n), (g === void 0 || g > n.length) && (g = n.length), g -= t.length;
  const d = n.indexOf(t, g);
  return d !== -1 && d === g;
}, toArray = (n) => {
  if (!n) return null;
  if (isArray(n)) return n;
  let t = n.length;
  if (!isNumber(t)) return null;
  const g = new Array(t);
  for (; t-- > 0; )
    g[t] = n[t];
  return g;
}, isTypedArray = /* @__PURE__ */ ((n) => (t) => n && t instanceof n)(typeof Uint8Array < "u" && getPrototypeOf(Uint8Array)), forEachEntry = (n, t) => {
  const d = (n && n[iterator]).call(n);
  let k;
  for (; (k = d.next()) && !k.done; ) {
    const H = k.value;
    t.call(n, H[0], H[1]);
  }
}, matchAll = (n, t) => {
  let g;
  const d = [];
  for (; (g = n.exec(t)) !== null; )
    d.push(g);
  return d;
}, isHTMLForm = kindOfTest("HTMLFormElement"), toCamelCase = (n) => n.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(g, d, k) {
    return d.toUpperCase() + k;
  }
), hasOwnProperty = (({ hasOwnProperty: n }) => (t, g) => n.call(t, g))(Object.prototype), isRegExp = kindOfTest("RegExp"), reduceDescriptors = (n, t) => {
  const g = Object.getOwnPropertyDescriptors(n), d = {};
  forEach(g, (k, H) => {
    let AA;
    (AA = t(k, H, n)) !== !1 && (d[H] = AA || k);
  }), Object.defineProperties(n, d);
}, freezeMethods = (n) => {
  reduceDescriptors(n, (t, g) => {
    if (isFunction$1(n) && ["arguments", "caller", "callee"].indexOf(g) !== -1)
      return !1;
    const d = n[g];
    if (isFunction$1(d)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + g + "'");
      });
    }
  });
}, toObjectSet = (n, t) => {
  const g = {}, d = (k) => {
    k.forEach((H) => {
      g[H] = !0;
    });
  };
  return isArray(n) ? d(n) : d(String(n).split(t)), g;
}, noop = () => {
}, toFiniteNumber = (n, t) => n != null && Number.isFinite(n = +n) ? n : t;
function isSpecCompliantForm(n) {
  return !!(n && isFunction$1(n.append) && n[toStringTag] === "FormData" && n[iterator]);
}
const toJSONObject = (n) => {
  const t = new Array(10), g = (d, k) => {
    if (isObject$1(d)) {
      if (t.indexOf(d) >= 0)
        return;
      if (isBuffer(d))
        return d;
      if (!("toJSON" in d)) {
        t[k] = d;
        const H = isArray(d) ? [] : {};
        return forEach(d, (AA, gA) => {
          const IA = g(AA, k + 1);
          !isUndefined(IA) && (H[gA] = IA);
        }), t[k] = void 0, H;
      }
    }
    return d;
  };
  return g(n, 0);
}, isAsyncFn = kindOfTest("AsyncFunction"), isThenable = (n) => n && (isObject$1(n) || isFunction$1(n)) && isFunction$1(n.then) && isFunction$1(n.catch), _setImmediate = ((n, t) => n ? setImmediate : t ? ((g, d) => (_global.addEventListener("message", ({ source: k, data: H }) => {
  k === _global && H === g && d.length && d.shift()();
}, !1), (k) => {
  d.push(k), _global.postMessage(g, "*");
}))(`axios@${Math.random()}`, []) : (g) => setTimeout(g))(
  typeof setImmediate == "function",
  isFunction$1(_global.postMessage)
), asap = typeof queueMicrotask < "u" ? queueMicrotask.bind(_global) : typeof process < "u" && process.nextTick || _setImmediate, isIterable = (n) => n != null && isFunction$1(n[iterator]), utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject: isObject$1,
  isPlainObject,
  isEmptyObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction: isFunction$1,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap,
  isIterable
};
function AxiosError$1(n, t, g, d, k) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = n, this.name = "AxiosError", t && (this.code = t), g && (this.config = g), d && (this.request = d), k && (this.response = k, this.status = k.status ? k.status : null);
}
utils$1.inherits(AxiosError$1, Error, {
  toJSON: function n() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const prototype$1 = AxiosError$1.prototype, descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((n) => {
  descriptors[n] = { value: n };
});
Object.defineProperties(AxiosError$1, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: !0 });
AxiosError$1.from = (n, t, g, d, k, H) => {
  const AA = Object.create(prototype$1);
  utils$1.toFlatObject(n, AA, function(BA) {
    return BA !== Error.prototype;
  }, (CA) => CA !== "isAxiosError");
  const gA = n && n.message ? n.message : "Error", IA = t == null && n ? n.code : t;
  return AxiosError$1.call(AA, gA, IA, g, d, k), n && AA.cause == null && Object.defineProperty(AA, "cause", { value: n, configurable: !0 }), AA.name = n && n.name || "Error", H && Object.assign(AA, H), AA;
};
const httpAdapter = null;
function isVisitable(n) {
  return utils$1.isPlainObject(n) || utils$1.isArray(n);
}
function removeBrackets(n) {
  return utils$1.endsWith(n, "[]") ? n.slice(0, -2) : n;
}
function renderKey(n, t, g) {
  return n ? n.concat(t).map(function(k, H) {
    return k = removeBrackets(k), !g && H ? "[" + k + "]" : k;
  }).join(g ? "." : "") : t;
}
function isFlatArray(n) {
  return utils$1.isArray(n) && !n.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function n(t) {
  return /^is[A-Z]/.test(t);
});
function toFormData$1(n, t, g) {
  if (!utils$1.isObject(n))
    throw new TypeError("target must be an object");
  t = t || new FormData(), g = utils$1.toFlatObject(g, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(oA, EA) {
    return !utils$1.isUndefined(EA[oA]);
  });
  const d = g.metaTokens, k = g.visitor || BA, H = g.dots, AA = g.indexes, IA = (g.Blob || typeof Blob < "u" && Blob) && utils$1.isSpecCompliantForm(t);
  if (!utils$1.isFunction(k))
    throw new TypeError("visitor must be a function");
  function CA(tA) {
    if (tA === null) return "";
    if (utils$1.isDate(tA))
      return tA.toISOString();
    if (utils$1.isBoolean(tA))
      return tA.toString();
    if (!IA && utils$1.isBlob(tA))
      throw new AxiosError$1("Blob is not supported. Use a Buffer instead.");
    return utils$1.isArrayBuffer(tA) || utils$1.isTypedArray(tA) ? IA && typeof Blob == "function" ? new Blob([tA]) : Buffer.from(tA) : tA;
  }
  function BA(tA, oA, EA) {
    let aA = tA;
    if (tA && !EA && typeof tA == "object") {
      if (utils$1.endsWith(oA, "{}"))
        oA = d ? oA : oA.slice(0, -2), tA = JSON.stringify(tA);
      else if (utils$1.isArray(tA) && isFlatArray(tA) || (utils$1.isFileList(tA) || utils$1.endsWith(oA, "[]")) && (aA = utils$1.toArray(tA)))
        return oA = removeBrackets(oA), aA.forEach(function(lA, cA) {
          !(utils$1.isUndefined(lA) || lA === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            AA === !0 ? renderKey([oA], cA, H) : AA === null ? oA : oA + "[]",
            CA(lA)
          );
        }), !1;
    }
    return isVisitable(tA) ? !0 : (t.append(renderKey(EA, oA, H), CA(tA)), !1);
  }
  const eA = [], iA = Object.assign(predicates, {
    defaultVisitor: BA,
    convertValue: CA,
    isVisitable
  });
  function QA(tA, oA) {
    if (!utils$1.isUndefined(tA)) {
      if (eA.indexOf(tA) !== -1)
        throw Error("Circular reference detected in " + oA.join("."));
      eA.push(tA), utils$1.forEach(tA, function(aA, nA) {
        (!(utils$1.isUndefined(aA) || aA === null) && k.call(
          t,
          aA,
          utils$1.isString(nA) ? nA.trim() : nA,
          oA,
          iA
        )) === !0 && QA(aA, oA ? oA.concat(nA) : [nA]);
      }), eA.pop();
    }
  }
  if (!utils$1.isObject(n))
    throw new TypeError("data must be an object");
  return QA(n), t;
}
function encode$1(n) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(n).replace(/[!'()~]|%20|%00/g, function(d) {
    return t[d];
  });
}
function AxiosURLSearchParams(n, t) {
  this._pairs = [], n && toFormData$1(n, this, t);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function n(t, g) {
  this._pairs.push([t, g]);
};
prototype.toString = function n(t) {
  const g = t ? function(d) {
    return t.call(this, d, encode$1);
  } : encode$1;
  return this._pairs.map(function(k) {
    return g(k[0]) + "=" + g(k[1]);
  }, "").join("&");
};
function encode(n) {
  return encodeURIComponent(n).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function buildURL(n, t, g) {
  if (!t)
    return n;
  const d = g && g.encode || encode;
  utils$1.isFunction(g) && (g = {
    serialize: g
  });
  const k = g && g.serialize;
  let H;
  if (k ? H = k(t, g) : H = utils$1.isURLSearchParams(t) ? t.toString() : new AxiosURLSearchParams(t, g).toString(d), H) {
    const AA = n.indexOf("#");
    AA !== -1 && (n = n.slice(0, AA)), n += (n.indexOf("?") === -1 ? "?" : "&") + H;
  }
  return n;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, g, d) {
    return this.handlers.push({
      fulfilled: t,
      rejected: g,
      synchronous: d ? d.synchronous : !1,
      runWhen: d ? d.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    utils$1.forEach(this.handlers, function(d) {
      d !== null && t(d);
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams, FormData$1 = typeof FormData < "u" ? FormData : null, Blob$1 = typeof Blob < "u" ? Blob : null, platform$1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, hasBrowserEnv = typeof window < "u" && typeof document < "u", _navigator = typeof navigator == "object" && navigator || void 0, hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0), hasStandardBrowserWebWorkerEnv = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", origin = hasBrowserEnv && window.location.href || "http://localhost", utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  navigator: _navigator,
  origin
}, Symbol.toStringTag, { value: "Module" })), platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(n, t) {
  return toFormData$1(n, new platform.classes.URLSearchParams(), {
    visitor: function(g, d, k, H) {
      return platform.isNode && utils$1.isBuffer(g) ? (this.append(d, g.toString("base64")), !1) : H.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function parsePropPath(n) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, n).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function arrayToObject(n) {
  const t = {}, g = Object.keys(n);
  let d;
  const k = g.length;
  let H;
  for (d = 0; d < k; d++)
    H = g[d], t[H] = n[H];
  return t;
}
function formDataToJSON(n) {
  function t(g, d, k, H) {
    let AA = g[H++];
    if (AA === "__proto__") return !0;
    const gA = Number.isFinite(+AA), IA = H >= g.length;
    return AA = !AA && utils$1.isArray(k) ? k.length : AA, IA ? (utils$1.hasOwnProp(k, AA) ? k[AA] = [k[AA], d] : k[AA] = d, !gA) : ((!k[AA] || !utils$1.isObject(k[AA])) && (k[AA] = []), t(g, d, k[AA], H) && utils$1.isArray(k[AA]) && (k[AA] = arrayToObject(k[AA])), !gA);
  }
  if (utils$1.isFormData(n) && utils$1.isFunction(n.entries)) {
    const g = {};
    return utils$1.forEachEntry(n, (d, k) => {
      t(parsePropPath(d), k, g, 0);
    }), g;
  }
  return null;
}
function stringifySafely(n, t, g) {
  if (utils$1.isString(n))
    try {
      return (t || JSON.parse)(n), utils$1.trim(n);
    } catch (d) {
      if (d.name !== "SyntaxError")
        throw d;
    }
  return (g || JSON.stringify)(n);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function n(t, g) {
    const d = g.getContentType() || "", k = d.indexOf("application/json") > -1, H = utils$1.isObject(t);
    if (H && utils$1.isHTMLForm(t) && (t = new FormData(t)), utils$1.isFormData(t))
      return k ? JSON.stringify(formDataToJSON(t)) : t;
    if (utils$1.isArrayBuffer(t) || utils$1.isBuffer(t) || utils$1.isStream(t) || utils$1.isFile(t) || utils$1.isBlob(t) || utils$1.isReadableStream(t))
      return t;
    if (utils$1.isArrayBufferView(t))
      return t.buffer;
    if (utils$1.isURLSearchParams(t))
      return g.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let gA;
    if (H) {
      if (d.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm(t, this.formSerializer).toString();
      if ((gA = utils$1.isFileList(t)) || d.indexOf("multipart/form-data") > -1) {
        const IA = this.env && this.env.FormData;
        return toFormData$1(
          gA ? { "files[]": t } : t,
          IA && new IA(),
          this.formSerializer
        );
      }
    }
    return H || k ? (g.setContentType("application/json", !1), stringifySafely(t)) : t;
  }],
  transformResponse: [function n(t) {
    const g = this.transitional || defaults.transitional, d = g && g.forcedJSONParsing, k = this.responseType === "json";
    if (utils$1.isResponse(t) || utils$1.isReadableStream(t))
      return t;
    if (t && utils$1.isString(t) && (d && !this.responseType || k)) {
      const AA = !(g && g.silentJSONParsing) && k;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (gA) {
        if (AA)
          throw gA.name === "SyntaxError" ? AxiosError$1.from(gA, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response) : gA;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function n(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (n) => {
  defaults.headers[n] = {};
});
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), parseHeaders = (n) => {
  const t = {};
  let g, d, k;
  return n && n.split(`
`).forEach(function(AA) {
    k = AA.indexOf(":"), g = AA.substring(0, k).trim().toLowerCase(), d = AA.substring(k + 1).trim(), !(!g || t[g] && ignoreDuplicateOf[g]) && (g === "set-cookie" ? t[g] ? t[g].push(d) : t[g] = [d] : t[g] = t[g] ? t[g] + ", " + d : d);
  }), t;
}, $internals = Symbol("internals");
function normalizeHeader(n) {
  return n && String(n).trim().toLowerCase();
}
function normalizeValue(n) {
  return n === !1 || n == null ? n : utils$1.isArray(n) ? n.map(normalizeValue) : String(n);
}
function parseTokens(n) {
  const t = /* @__PURE__ */ Object.create(null), g = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let d;
  for (; d = g.exec(n); )
    t[d[1]] = d[2];
  return t;
}
const isValidHeaderName = (n) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(n.trim());
function matchHeaderValue(n, t, g, d, k) {
  if (utils$1.isFunction(d))
    return d.call(this, t, g);
  if (k && (t = g), !!utils$1.isString(t)) {
    if (utils$1.isString(d))
      return t.indexOf(d) !== -1;
    if (utils$1.isRegExp(d))
      return d.test(t);
  }
}
function formatHeader(n) {
  return n.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, g, d) => g.toUpperCase() + d);
}
function buildAccessors(n, t) {
  const g = utils$1.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((d) => {
    Object.defineProperty(n, d + g, {
      value: function(k, H, AA) {
        return this[d].call(this, t, k, H, AA);
      },
      configurable: !0
    });
  });
}
let AxiosHeaders$1 = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, g, d) {
    const k = this;
    function H(gA, IA, CA) {
      const BA = normalizeHeader(IA);
      if (!BA)
        throw new Error("header name must be a non-empty string");
      const eA = utils$1.findKey(k, BA);
      (!eA || k[eA] === void 0 || CA === !0 || CA === void 0 && k[eA] !== !1) && (k[eA || IA] = normalizeValue(gA));
    }
    const AA = (gA, IA) => utils$1.forEach(gA, (CA, BA) => H(CA, BA, IA));
    if (utils$1.isPlainObject(t) || t instanceof this.constructor)
      AA(t, g);
    else if (utils$1.isString(t) && (t = t.trim()) && !isValidHeaderName(t))
      AA(parseHeaders(t), g);
    else if (utils$1.isObject(t) && utils$1.isIterable(t)) {
      let gA = {}, IA, CA;
      for (const BA of t) {
        if (!utils$1.isArray(BA))
          throw TypeError("Object iterator must return a key-value pair");
        gA[CA = BA[0]] = (IA = gA[CA]) ? utils$1.isArray(IA) ? [...IA, BA[1]] : [IA, BA[1]] : BA[1];
      }
      AA(gA, g);
    } else
      t != null && H(g, t, d);
    return this;
  }
  get(t, g) {
    if (t = normalizeHeader(t), t) {
      const d = utils$1.findKey(this, t);
      if (d) {
        const k = this[d];
        if (!g)
          return k;
        if (g === !0)
          return parseTokens(k);
        if (utils$1.isFunction(g))
          return g.call(this, k, d);
        if (utils$1.isRegExp(g))
          return g.exec(k);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, g) {
    if (t = normalizeHeader(t), t) {
      const d = utils$1.findKey(this, t);
      return !!(d && this[d] !== void 0 && (!g || matchHeaderValue(this, this[d], d, g)));
    }
    return !1;
  }
  delete(t, g) {
    const d = this;
    let k = !1;
    function H(AA) {
      if (AA = normalizeHeader(AA), AA) {
        const gA = utils$1.findKey(d, AA);
        gA && (!g || matchHeaderValue(d, d[gA], gA, g)) && (delete d[gA], k = !0);
      }
    }
    return utils$1.isArray(t) ? t.forEach(H) : H(t), k;
  }
  clear(t) {
    const g = Object.keys(this);
    let d = g.length, k = !1;
    for (; d--; ) {
      const H = g[d];
      (!t || matchHeaderValue(this, this[H], H, t, !0)) && (delete this[H], k = !0);
    }
    return k;
  }
  normalize(t) {
    const g = this, d = {};
    return utils$1.forEach(this, (k, H) => {
      const AA = utils$1.findKey(d, H);
      if (AA) {
        g[AA] = normalizeValue(k), delete g[H];
        return;
      }
      const gA = t ? formatHeader(H) : String(H).trim();
      gA !== H && delete g[H], g[gA] = normalizeValue(k), d[gA] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const g = /* @__PURE__ */ Object.create(null);
    return utils$1.forEach(this, (d, k) => {
      d != null && d !== !1 && (g[k] = t && utils$1.isArray(d) ? d.join(", ") : d);
    }), g;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, g]) => t + ": " + g).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...g) {
    const d = new this(t);
    return g.forEach((k) => d.set(k)), d;
  }
  static accessor(t) {
    const d = (this[$internals] = this[$internals] = {
      accessors: {}
    }).accessors, k = this.prototype;
    function H(AA) {
      const gA = normalizeHeader(AA);
      d[gA] || (buildAccessors(k, AA), d[gA] = !0);
    }
    return utils$1.isArray(t) ? t.forEach(H) : H(t), this;
  }
};
AxiosHeaders$1.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders$1.prototype, ({ value: n }, t) => {
  let g = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => n,
    set(d) {
      this[g] = d;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders$1);
function transformData(n, t) {
  const g = this || defaults, d = t || g, k = AxiosHeaders$1.from(d.headers);
  let H = d.data;
  return utils$1.forEach(n, function(gA) {
    H = gA.call(g, H, k.normalize(), t ? t.status : void 0);
  }), k.normalize(), H;
}
function isCancel$1(n) {
  return !!(n && n.__CANCEL__);
}
function CanceledError$1(n, t, g) {
  AxiosError$1.call(this, n ?? "canceled", AxiosError$1.ERR_CANCELED, t, g), this.name = "CanceledError";
}
utils$1.inherits(CanceledError$1, AxiosError$1, {
  __CANCEL__: !0
});
function settle(n, t, g) {
  const d = g.config.validateStatus;
  !g.status || !d || d(g.status) ? n(g) : t(new AxiosError$1(
    "Request failed with status code " + g.status,
    [AxiosError$1.ERR_BAD_REQUEST, AxiosError$1.ERR_BAD_RESPONSE][Math.floor(g.status / 100) - 4],
    g.config,
    g.request,
    g
  ));
}
function parseProtocol(n) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(n);
  return t && t[1] || "";
}
function speedometer(n, t) {
  n = n || 10;
  const g = new Array(n), d = new Array(n);
  let k = 0, H = 0, AA;
  return t = t !== void 0 ? t : 1e3, function(IA) {
    const CA = Date.now(), BA = d[H];
    AA || (AA = CA), g[k] = IA, d[k] = CA;
    let eA = H, iA = 0;
    for (; eA !== k; )
      iA += g[eA++], eA = eA % n;
    if (k = (k + 1) % n, k === H && (H = (H + 1) % n), CA - AA < t)
      return;
    const QA = BA && CA - BA;
    return QA ? Math.round(iA * 1e3 / QA) : void 0;
  };
}
function throttle(n, t) {
  let g = 0, d = 1e3 / t, k, H;
  const AA = (CA, BA = Date.now()) => {
    g = BA, k = null, H && (clearTimeout(H), H = null), n(...CA);
  };
  return [(...CA) => {
    const BA = Date.now(), eA = BA - g;
    eA >= d ? AA(CA, BA) : (k = CA, H || (H = setTimeout(() => {
      H = null, AA(k);
    }, d - eA)));
  }, () => k && AA(k)];
}
const progressEventReducer = (n, t, g = 3) => {
  let d = 0;
  const k = speedometer(50, 250);
  return throttle((H) => {
    const AA = H.loaded, gA = H.lengthComputable ? H.total : void 0, IA = AA - d, CA = k(IA), BA = AA <= gA;
    d = AA;
    const eA = {
      loaded: AA,
      total: gA,
      progress: gA ? AA / gA : void 0,
      bytes: IA,
      rate: CA || void 0,
      estimated: CA && gA && BA ? (gA - AA) / CA : void 0,
      event: H,
      lengthComputable: gA != null,
      [t ? "download" : "upload"]: !0
    };
    n(eA);
  }, g);
}, progressEventDecorator = (n, t) => {
  const g = n != null;
  return [(d) => t[0]({
    lengthComputable: g,
    total: n,
    loaded: d
  }), t[1]];
}, asyncDecorator = (n) => (...t) => utils$1.asap(() => n(...t)), isURLSameOrigin = platform.hasStandardBrowserEnv ? /* @__PURE__ */ ((n, t) => (g) => (g = new URL(g, platform.origin), n.protocol === g.protocol && n.host === g.host && (t || n.port === g.port)))(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => !0, cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(n, t, g, d, k, H, AA) {
      if (typeof document > "u") return;
      const gA = [`${n}=${encodeURIComponent(t)}`];
      utils$1.isNumber(g) && gA.push(`expires=${new Date(g).toUTCString()}`), utils$1.isString(d) && gA.push(`path=${d}`), utils$1.isString(k) && gA.push(`domain=${k}`), H === !0 && gA.push("secure"), utils$1.isString(AA) && gA.push(`SameSite=${AA}`), document.cookie = gA.join("; ");
    },
    read(n) {
      if (typeof document > "u") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + n + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(n) {
      this.write(n, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(n) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(n);
}
function combineURLs(n, t) {
  return t ? n.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : n;
}
function buildFullPath(n, t, g) {
  let d = !isAbsoluteURL(t);
  return n && (d || g == !1) ? combineURLs(n, t) : t;
}
const headersToObject = (n) => n instanceof AxiosHeaders$1 ? { ...n } : n;
function mergeConfig$1(n, t) {
  t = t || {};
  const g = {};
  function d(CA, BA, eA, iA) {
    return utils$1.isPlainObject(CA) && utils$1.isPlainObject(BA) ? utils$1.merge.call({ caseless: iA }, CA, BA) : utils$1.isPlainObject(BA) ? utils$1.merge({}, BA) : utils$1.isArray(BA) ? BA.slice() : BA;
  }
  function k(CA, BA, eA, iA) {
    if (utils$1.isUndefined(BA)) {
      if (!utils$1.isUndefined(CA))
        return d(void 0, CA, eA, iA);
    } else return d(CA, BA, eA, iA);
  }
  function H(CA, BA) {
    if (!utils$1.isUndefined(BA))
      return d(void 0, BA);
  }
  function AA(CA, BA) {
    if (utils$1.isUndefined(BA)) {
      if (!utils$1.isUndefined(CA))
        return d(void 0, CA);
    } else return d(void 0, BA);
  }
  function gA(CA, BA, eA) {
    if (eA in t)
      return d(CA, BA);
    if (eA in n)
      return d(void 0, CA);
  }
  const IA = {
    url: H,
    method: H,
    data: H,
    baseURL: AA,
    transformRequest: AA,
    transformResponse: AA,
    paramsSerializer: AA,
    timeout: AA,
    timeoutMessage: AA,
    withCredentials: AA,
    withXSRFToken: AA,
    adapter: AA,
    responseType: AA,
    xsrfCookieName: AA,
    xsrfHeaderName: AA,
    onUploadProgress: AA,
    onDownloadProgress: AA,
    decompress: AA,
    maxContentLength: AA,
    maxBodyLength: AA,
    beforeRedirect: AA,
    transport: AA,
    httpAgent: AA,
    httpsAgent: AA,
    cancelToken: AA,
    socketPath: AA,
    responseEncoding: AA,
    validateStatus: gA,
    headers: (CA, BA, eA) => k(headersToObject(CA), headersToObject(BA), eA, !0)
  };
  return utils$1.forEach(Object.keys({ ...n, ...t }), function(BA) {
    const eA = IA[BA] || k, iA = eA(n[BA], t[BA], BA);
    utils$1.isUndefined(iA) && eA !== gA || (g[BA] = iA);
  }), g;
}
const resolveConfig = (n) => {
  const t = mergeConfig$1({}, n);
  let { data: g, withXSRFToken: d, xsrfHeaderName: k, xsrfCookieName: H, headers: AA, auth: gA } = t;
  if (t.headers = AA = AxiosHeaders$1.from(AA), t.url = buildURL(buildFullPath(t.baseURL, t.url, t.allowAbsoluteUrls), n.params, n.paramsSerializer), gA && AA.set(
    "Authorization",
    "Basic " + btoa((gA.username || "") + ":" + (gA.password ? unescape(encodeURIComponent(gA.password)) : ""))
  ), utils$1.isFormData(g)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv)
      AA.setContentType(void 0);
    else if (utils$1.isFunction(g.getHeaders)) {
      const IA = g.getHeaders(), CA = ["content-type", "content-length"];
      Object.entries(IA).forEach(([BA, eA]) => {
        CA.includes(BA.toLowerCase()) && AA.set(BA, eA);
      });
    }
  }
  if (platform.hasStandardBrowserEnv && (d && utils$1.isFunction(d) && (d = d(t)), d || d !== !1 && isURLSameOrigin(t.url))) {
    const IA = k && H && cookies.read(H);
    IA && AA.set(k, IA);
  }
  return t;
}, isXHRAdapterSupported = typeof XMLHttpRequest < "u", xhrAdapter = isXHRAdapterSupported && function(n) {
  return new Promise(function(g, d) {
    const k = resolveConfig(n);
    let H = k.data;
    const AA = AxiosHeaders$1.from(k.headers).normalize();
    let { responseType: gA, onUploadProgress: IA, onDownloadProgress: CA } = k, BA, eA, iA, QA, tA;
    function oA() {
      QA && QA(), tA && tA(), k.cancelToken && k.cancelToken.unsubscribe(BA), k.signal && k.signal.removeEventListener("abort", BA);
    }
    let EA = new XMLHttpRequest();
    EA.open(k.method.toUpperCase(), k.url, !0), EA.timeout = k.timeout;
    function aA() {
      if (!EA)
        return;
      const lA = AxiosHeaders$1.from(
        "getAllResponseHeaders" in EA && EA.getAllResponseHeaders()
      ), sA = {
        data: !gA || gA === "text" || gA === "json" ? EA.responseText : EA.response,
        status: EA.status,
        statusText: EA.statusText,
        headers: lA,
        config: n,
        request: EA
      };
      settle(function(uA) {
        g(uA), oA();
      }, function(uA) {
        d(uA), oA();
      }, sA), EA = null;
    }
    "onloadend" in EA ? EA.onloadend = aA : EA.onreadystatechange = function() {
      !EA || EA.readyState !== 4 || EA.status === 0 && !(EA.responseURL && EA.responseURL.indexOf("file:") === 0) || setTimeout(aA);
    }, EA.onabort = function() {
      EA && (d(new AxiosError$1("Request aborted", AxiosError$1.ECONNABORTED, n, EA)), EA = null);
    }, EA.onerror = function(cA) {
      const sA = cA && cA.message ? cA.message : "Network Error", rA = new AxiosError$1(sA, AxiosError$1.ERR_NETWORK, n, EA);
      rA.event = cA || null, d(rA), EA = null;
    }, EA.ontimeout = function() {
      let cA = k.timeout ? "timeout of " + k.timeout + "ms exceeded" : "timeout exceeded";
      const sA = k.transitional || transitionalDefaults;
      k.timeoutErrorMessage && (cA = k.timeoutErrorMessage), d(new AxiosError$1(
        cA,
        sA.clarifyTimeoutError ? AxiosError$1.ETIMEDOUT : AxiosError$1.ECONNABORTED,
        n,
        EA
      )), EA = null;
    }, H === void 0 && AA.setContentType(null), "setRequestHeader" in EA && utils$1.forEach(AA.toJSON(), function(cA, sA) {
      EA.setRequestHeader(sA, cA);
    }), utils$1.isUndefined(k.withCredentials) || (EA.withCredentials = !!k.withCredentials), gA && gA !== "json" && (EA.responseType = k.responseType), CA && ([iA, tA] = progressEventReducer(CA, !0), EA.addEventListener("progress", iA)), IA && EA.upload && ([eA, QA] = progressEventReducer(IA), EA.upload.addEventListener("progress", eA), EA.upload.addEventListener("loadend", QA)), (k.cancelToken || k.signal) && (BA = (lA) => {
      EA && (d(!lA || lA.type ? new CanceledError$1(null, n, EA) : lA), EA.abort(), EA = null);
    }, k.cancelToken && k.cancelToken.subscribe(BA), k.signal && (k.signal.aborted ? BA() : k.signal.addEventListener("abort", BA)));
    const nA = parseProtocol(k.url);
    if (nA && platform.protocols.indexOf(nA) === -1) {
      d(new AxiosError$1("Unsupported protocol " + nA + ":", AxiosError$1.ERR_BAD_REQUEST, n));
      return;
    }
    EA.send(H || null);
  });
}, composeSignals = (n, t) => {
  const { length: g } = n = n ? n.filter(Boolean) : [];
  if (t || g) {
    let d = new AbortController(), k;
    const H = function(CA) {
      if (!k) {
        k = !0, gA();
        const BA = CA instanceof Error ? CA : this.reason;
        d.abort(BA instanceof AxiosError$1 ? BA : new CanceledError$1(BA instanceof Error ? BA.message : BA));
      }
    };
    let AA = t && setTimeout(() => {
      AA = null, H(new AxiosError$1(`timeout ${t} of ms exceeded`, AxiosError$1.ETIMEDOUT));
    }, t);
    const gA = () => {
      n && (AA && clearTimeout(AA), AA = null, n.forEach((CA) => {
        CA.unsubscribe ? CA.unsubscribe(H) : CA.removeEventListener("abort", H);
      }), n = null);
    };
    n.forEach((CA) => CA.addEventListener("abort", H));
    const { signal: IA } = d;
    return IA.unsubscribe = () => utils$1.asap(gA), IA;
  }
}, streamChunk = function* (n, t) {
  let g = n.byteLength;
  if (g < t) {
    yield n;
    return;
  }
  let d = 0, k;
  for (; d < g; )
    k = d + t, yield n.slice(d, k), d = k;
}, readBytes = async function* (n, t) {
  for await (const g of readStream(n))
    yield* streamChunk(g, t);
}, readStream = async function* (n) {
  if (n[Symbol.asyncIterator]) {
    yield* n;
    return;
  }
  const t = n.getReader();
  try {
    for (; ; ) {
      const { done: g, value: d } = await t.read();
      if (g)
        break;
      yield d;
    }
  } finally {
    await t.cancel();
  }
}, trackStream = (n, t, g, d) => {
  const k = readBytes(n, t);
  let H = 0, AA, gA = (IA) => {
    AA || (AA = !0, d && d(IA));
  };
  return new ReadableStream({
    async pull(IA) {
      try {
        const { done: CA, value: BA } = await k.next();
        if (CA) {
          gA(), IA.close();
          return;
        }
        let eA = BA.byteLength;
        if (g) {
          let iA = H += eA;
          g(iA);
        }
        IA.enqueue(new Uint8Array(BA));
      } catch (CA) {
        throw gA(CA), CA;
      }
    },
    cancel(IA) {
      return gA(IA), k.return();
    }
  }, {
    highWaterMark: 2
  });
}, DEFAULT_CHUNK_SIZE = 64 * 1024, { isFunction } = utils$1, globalFetchAPI = (({ Request: n, Response: t }) => ({
  Request: n,
  Response: t
}))(utils$1.global), {
  ReadableStream: ReadableStream$1,
  TextEncoder: TextEncoder$1
} = utils$1.global, test = (n, ...t) => {
  try {
    return !!n(...t);
  } catch {
    return !1;
  }
}, factory = (n) => {
  n = utils$1.merge.call({
    skipUndefined: !0
  }, globalFetchAPI, n);
  const { fetch: t, Request: g, Response: d } = n, k = t ? isFunction(t) : typeof fetch == "function", H = isFunction(g), AA = isFunction(d);
  if (!k)
    return !1;
  const gA = k && isFunction(ReadableStream$1), IA = k && (typeof TextEncoder$1 == "function" ? /* @__PURE__ */ ((tA) => (oA) => tA.encode(oA))(new TextEncoder$1()) : async (tA) => new Uint8Array(await new g(tA).arrayBuffer())), CA = H && gA && test(() => {
    let tA = !1;
    const oA = new g(platform.origin, {
      body: new ReadableStream$1(),
      method: "POST",
      get duplex() {
        return tA = !0, "half";
      }
    }).headers.has("Content-Type");
    return tA && !oA;
  }), BA = AA && gA && test(() => utils$1.isReadableStream(new d("").body)), eA = {
    stream: BA && ((tA) => tA.body)
  };
  k && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((tA) => {
    !eA[tA] && (eA[tA] = (oA, EA) => {
      let aA = oA && oA[tA];
      if (aA)
        return aA.call(oA);
      throw new AxiosError$1(`Response type '${tA}' is not supported`, AxiosError$1.ERR_NOT_SUPPORT, EA);
    });
  });
  const iA = async (tA) => {
    if (tA == null)
      return 0;
    if (utils$1.isBlob(tA))
      return tA.size;
    if (utils$1.isSpecCompliantForm(tA))
      return (await new g(platform.origin, {
        method: "POST",
        body: tA
      }).arrayBuffer()).byteLength;
    if (utils$1.isArrayBufferView(tA) || utils$1.isArrayBuffer(tA))
      return tA.byteLength;
    if (utils$1.isURLSearchParams(tA) && (tA = tA + ""), utils$1.isString(tA))
      return (await IA(tA)).byteLength;
  }, QA = async (tA, oA) => {
    const EA = utils$1.toFiniteNumber(tA.getContentLength());
    return EA ?? iA(oA);
  };
  return async (tA) => {
    let {
      url: oA,
      method: EA,
      data: aA,
      signal: nA,
      cancelToken: lA,
      timeout: cA,
      onDownloadProgress: sA,
      onUploadProgress: rA,
      responseType: uA,
      headers: hA,
      withCredentials: dA = "same-origin",
      fetchOptions: GA
    } = resolveConfig(tA), DA = t || fetch;
    uA = uA ? (uA + "").toLowerCase() : "text";
    let wA = composeSignals([nA, lA && lA.toAbortSignal()], cA), bA = null;
    const yA = wA && wA.unsubscribe && (() => {
      wA.unsubscribe();
    });
    let pA;
    try {
      if (rA && CA && EA !== "get" && EA !== "head" && (pA = await QA(hA, aA)) !== 0) {
        let zA = new g(oA, {
          method: "POST",
          body: aA,
          duplex: "half"
        }), XA;
        if (utils$1.isFormData(aA) && (XA = zA.headers.get("content-type")) && hA.setContentType(XA), zA.body) {
          const [fA, vA] = progressEventDecorator(
            pA,
            progressEventReducer(asyncDecorator(rA))
          );
          aA = trackStream(zA.body, DEFAULT_CHUNK_SIZE, fA, vA);
        }
      }
      utils$1.isString(dA) || (dA = dA ? "include" : "omit");
      const MA = H && "credentials" in g.prototype, LA = {
        ...GA,
        signal: wA,
        method: EA.toUpperCase(),
        headers: hA.normalize().toJSON(),
        body: aA,
        duplex: "half",
        credentials: MA ? dA : void 0
      };
      bA = H && new g(oA, LA);
      let xA = await (H ? DA(bA, GA) : DA(oA, LA));
      const TA = BA && (uA === "stream" || uA === "response");
      if (BA && (sA || TA && yA)) {
        const zA = {};
        ["status", "statusText", "headers"].forEach((Cg) => {
          zA[Cg] = xA[Cg];
        });
        const XA = utils$1.toFiniteNumber(xA.headers.get("content-length")), [fA, vA] = sA && progressEventDecorator(
          XA,
          progressEventReducer(asyncDecorator(sA), !0)
        ) || [];
        xA = new d(
          trackStream(xA.body, DEFAULT_CHUNK_SIZE, fA, () => {
            vA && vA(), yA && yA();
          }),
          zA
        );
      }
      uA = uA || "text";
      let NA = await eA[utils$1.findKey(eA, uA) || "text"](xA, tA);
      return !TA && yA && yA(), await new Promise((zA, XA) => {
        settle(zA, XA, {
          data: NA,
          headers: AxiosHeaders$1.from(xA.headers),
          status: xA.status,
          statusText: xA.statusText,
          config: tA,
          request: bA
        });
      });
    } catch (MA) {
      throw yA && yA(), MA && MA.name === "TypeError" && /Load failed|fetch/i.test(MA.message) ? Object.assign(
        new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, tA, bA),
        {
          cause: MA.cause || MA
        }
      ) : AxiosError$1.from(MA, MA && MA.code, tA, bA);
    }
  };
}, seedCache = /* @__PURE__ */ new Map(), getFetch = (n) => {
  let t = n && n.env || {};
  const { fetch: g, Request: d, Response: k } = t, H = [
    d,
    k,
    g
  ];
  let AA = H.length, gA = AA, IA, CA, BA = seedCache;
  for (; gA--; )
    IA = H[gA], CA = BA.get(IA), CA === void 0 && BA.set(IA, CA = gA ? /* @__PURE__ */ new Map() : factory(t)), BA = CA;
  return CA;
};
getFetch();
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: {
    get: getFetch
  }
};
utils$1.forEach(knownAdapters, (n, t) => {
  if (n) {
    try {
      Object.defineProperty(n, "name", { value: t });
    } catch {
    }
    Object.defineProperty(n, "adapterName", { value: t });
  }
});
const renderReason = (n) => `- ${n}`, isResolvedHandle = (n) => utils$1.isFunction(n) || n === null || n === !1;
function getAdapter$1(n, t) {
  n = utils$1.isArray(n) ? n : [n];
  const { length: g } = n;
  let d, k;
  const H = {};
  for (let AA = 0; AA < g; AA++) {
    d = n[AA];
    let gA;
    if (k = d, !isResolvedHandle(d) && (k = knownAdapters[(gA = String(d)).toLowerCase()], k === void 0))
      throw new AxiosError$1(`Unknown adapter '${gA}'`);
    if (k && (utils$1.isFunction(k) || (k = k.get(t))))
      break;
    H[gA || "#" + AA] = k;
  }
  if (!k) {
    const AA = Object.entries(H).map(
      ([IA, CA]) => `adapter ${IA} ` + (CA === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let gA = g ? AA.length > 1 ? `since :
` + AA.map(renderReason).join(`
`) : " " + renderReason(AA[0]) : "as no adapter specified";
    throw new AxiosError$1(
      "There is no suitable adapter to dispatch the request " + gA,
      "ERR_NOT_SUPPORT"
    );
  }
  return k;
}
const adapters = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: getAdapter$1,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: knownAdapters
};
function throwIfCancellationRequested(n) {
  if (n.cancelToken && n.cancelToken.throwIfRequested(), n.signal && n.signal.aborted)
    throw new CanceledError$1(null, n);
}
function dispatchRequest(n) {
  return throwIfCancellationRequested(n), n.headers = AxiosHeaders$1.from(n.headers), n.data = transformData.call(
    n,
    n.transformRequest
  ), ["post", "put", "patch"].indexOf(n.method) !== -1 && n.headers.setContentType("application/x-www-form-urlencoded", !1), adapters.getAdapter(n.adapter || defaults.adapter, n)(n).then(function(d) {
    return throwIfCancellationRequested(n), d.data = transformData.call(
      n,
      n.transformResponse,
      d
    ), d.headers = AxiosHeaders$1.from(d.headers), d;
  }, function(d) {
    return isCancel$1(d) || (throwIfCancellationRequested(n), d && d.response && (d.response.data = transformData.call(
      n,
      n.transformResponse,
      d.response
    ), d.response.headers = AxiosHeaders$1.from(d.response.headers))), Promise.reject(d);
  });
}
const VERSION$1 = "1.13.2", validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((n, t) => {
  validators$1[n] = function(d) {
    return typeof d === n || "a" + (t < 1 ? "n " : " ") + n;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function n(t, g, d) {
  function k(H, AA) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + H + "'" + AA + (d ? ". " + d : "");
  }
  return (H, AA, gA) => {
    if (t === !1)
      throw new AxiosError$1(
        k(AA, " has been removed" + (g ? " in " + g : "")),
        AxiosError$1.ERR_DEPRECATED
      );
    return g && !deprecatedWarnings[AA] && (deprecatedWarnings[AA] = !0, console.warn(
      k(
        AA,
        " has been deprecated since v" + g + " and will be removed in the near future"
      )
    )), t ? t(H, AA, gA) : !0;
  };
};
validators$1.spelling = function n(t) {
  return (g, d) => (console.warn(`${d} is likely a misspelling of ${t}`), !0);
};
function assertOptions(n, t, g) {
  if (typeof n != "object")
    throw new AxiosError$1("options must be an object", AxiosError$1.ERR_BAD_OPTION_VALUE);
  const d = Object.keys(n);
  let k = d.length;
  for (; k-- > 0; ) {
    const H = d[k], AA = t[H];
    if (AA) {
      const gA = n[H], IA = gA === void 0 || AA(gA, H, n);
      if (IA !== !0)
        throw new AxiosError$1("option " + H + " must be " + IA, AxiosError$1.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (g !== !0)
      throw new AxiosError$1("Unknown option " + H, AxiosError$1.ERR_BAD_OPTION);
  }
}
const validator = {
  assertOptions,
  validators: validators$1
}, validators = validator.validators;
let Axios$1 = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, g) {
    try {
      return await this._request(t, g);
    } catch (d) {
      if (d instanceof Error) {
        let k = {};
        Error.captureStackTrace ? Error.captureStackTrace(k) : k = new Error();
        const H = k.stack ? k.stack.replace(/^.+\n/, "") : "";
        try {
          d.stack ? H && !String(d.stack).endsWith(H.replace(/^.+\n.+\n/, "")) && (d.stack += `
` + H) : d.stack = H;
        } catch {
        }
      }
      throw d;
    }
  }
  _request(t, g) {
    typeof t == "string" ? (g = g || {}, g.url = t) : g = t || {}, g = mergeConfig$1(this.defaults, g);
    const { transitional: d, paramsSerializer: k, headers: H } = g;
    d !== void 0 && validator.assertOptions(d, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, !1), k != null && (utils$1.isFunction(k) ? g.paramsSerializer = {
      serialize: k
    } : validator.assertOptions(k, {
      encode: validators.function,
      serialize: validators.function
    }, !0)), g.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? g.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : g.allowAbsoluteUrls = !0), validator.assertOptions(g, {
      baseUrl: validators.spelling("baseURL"),
      withXsrfToken: validators.spelling("withXSRFToken")
    }, !0), g.method = (g.method || this.defaults.method || "get").toLowerCase();
    let AA = H && utils$1.merge(
      H.common,
      H[g.method]
    );
    H && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (tA) => {
        delete H[tA];
      }
    ), g.headers = AxiosHeaders$1.concat(AA, H);
    const gA = [];
    let IA = !0;
    this.interceptors.request.forEach(function(oA) {
      typeof oA.runWhen == "function" && oA.runWhen(g) === !1 || (IA = IA && oA.synchronous, gA.unshift(oA.fulfilled, oA.rejected));
    });
    const CA = [];
    this.interceptors.response.forEach(function(oA) {
      CA.push(oA.fulfilled, oA.rejected);
    });
    let BA, eA = 0, iA;
    if (!IA) {
      const tA = [dispatchRequest.bind(this), void 0];
      for (tA.unshift(...gA), tA.push(...CA), iA = tA.length, BA = Promise.resolve(g); eA < iA; )
        BA = BA.then(tA[eA++], tA[eA++]);
      return BA;
    }
    iA = gA.length;
    let QA = g;
    for (; eA < iA; ) {
      const tA = gA[eA++], oA = gA[eA++];
      try {
        QA = tA(QA);
      } catch (EA) {
        oA.call(this, EA);
        break;
      }
    }
    try {
      BA = dispatchRequest.call(this, QA);
    } catch (tA) {
      return Promise.reject(tA);
    }
    for (eA = 0, iA = CA.length; eA < iA; )
      BA = BA.then(CA[eA++], CA[eA++]);
    return BA;
  }
  getUri(t) {
    t = mergeConfig$1(this.defaults, t);
    const g = buildFullPath(t.baseURL, t.url, t.allowAbsoluteUrls);
    return buildURL(g, t.params, t.paramsSerializer);
  }
};
utils$1.forEach(["delete", "get", "head", "options"], function n(t) {
  Axios$1.prototype[t] = function(g, d) {
    return this.request(mergeConfig$1(d || {}, {
      method: t,
      url: g,
      data: (d || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function n(t) {
  function g(d) {
    return function(H, AA, gA) {
      return this.request(mergeConfig$1(gA || {}, {
        method: t,
        headers: d ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: H,
        data: AA
      }));
    };
  }
  Axios$1.prototype[t] = g(), Axios$1.prototype[t + "Form"] = g(!0);
});
let CancelToken$1 = class AC {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let g;
    this.promise = new Promise(function(H) {
      g = H;
    });
    const d = this;
    this.promise.then((k) => {
      if (!d._listeners) return;
      let H = d._listeners.length;
      for (; H-- > 0; )
        d._listeners[H](k);
      d._listeners = null;
    }), this.promise.then = (k) => {
      let H;
      const AA = new Promise((gA) => {
        d.subscribe(gA), H = gA;
      }).then(k);
      return AA.cancel = function() {
        d.unsubscribe(H);
      }, AA;
    }, t(function(H, AA, gA) {
      d.reason || (d.reason = new CanceledError$1(H, AA, gA), g(d.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const g = this._listeners.indexOf(t);
    g !== -1 && this._listeners.splice(g, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), g = (d) => {
      t.abort(d);
    };
    return this.subscribe(g), t.signal.unsubscribe = () => this.unsubscribe(g), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new AC(function(k) {
        t = k;
      }),
      cancel: t
    };
  }
};
function spread$1(n) {
  return function(g) {
    return n.apply(null, g);
  };
}
function isAxiosError$1(n) {
  return utils$1.isObject(n) && n.isAxiosError === !0;
}
const HttpStatusCode$1 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(HttpStatusCode$1).forEach(([n, t]) => {
  HttpStatusCode$1[t] = n;
});
function createInstance(n) {
  const t = new Axios$1(n), g = bind(Axios$1.prototype.request, t);
  return utils$1.extend(g, Axios$1.prototype, t, { allOwnKeys: !0 }), utils$1.extend(g, t, null, { allOwnKeys: !0 }), g.create = function(k) {
    return createInstance(mergeConfig$1(n, k));
  }, g;
}
const axios = createInstance(defaults);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError$1;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel$1;
axios.VERSION = VERSION$1;
axios.toFormData = toFormData$1;
axios.AxiosError = AxiosError$1;
axios.Cancel = axios.CanceledError;
axios.all = function n(t) {
  return Promise.all(t);
};
axios.spread = spread$1;
axios.isAxiosError = isAxiosError$1;
axios.mergeConfig = mergeConfig$1;
axios.AxiosHeaders = AxiosHeaders$1;
axios.formToJSON = (n) => formDataToJSON(utils$1.isHTMLForm(n) ? new FormData(n) : n);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$1;
axios.default = axios;
const {
  Axios,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken,
  VERSION,
  all,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders,
  HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig
} = axios;
loglevelExports$1.getLogger("DoInitPings");
loglevelExports$1.getLogger("ForwardMessageCache");
loglevelExports$1.getLogger("WebsocketConnection");
loglevelExports$1.getLogger("ConnectionManager");
const LOG$3 = loglevelExports$1.getLogger("DefaultStreamlitEndpoints"), MEDIA_ENDPOINT = "/media", UPLOAD_FILE_ENDPOINT = "/_stcore/upload_file", COMPONENT_ENDPOINT_BASE = "/component";
class DefaultStreamlitEndpoints {
  constructor(t) {
    this.getServerUri = t.getServerUri, this.csrfEnabled = t.csrfEnabled, this.sendClientError = t.sendClientError, this.staticConfigUrl = null;
  }
  setStaticConfigUrl(t) {
    this.staticConfigUrl = t;
  }
  sendClientErrorToHost(t, g, d, k, H) {
    this.sendClientError(t, g, d, k, H);
  }
  /**
   * Check the source of a component for successful response (for those without onerror event)
   * If the response is not ok, or fetch otherwise fails, send an error to the host.
   */
  async checkSourceUrlResponse(t, g, d) {
    const k = d ? `${g} ${d}` : g;
    try {
      const H = await fetch(t);
      H.ok || (LOG$3.error(`Client Error: ${k} source error - ${H.status}`), this.sendClientErrorToHost(g, H.status, H.statusText, t, d));
    } catch (H) {
      const AA = H instanceof Error ? H.message : "Unknown Error";
      LOG$3.error(`Client Error: ${k} fetch error - ${AA}`), this.sendClientErrorToHost(g, "Error fetching source", AA, t, d);
    }
  }
  buildComponentURL(t, g) {
    return f(this.requireServerUri(), `${COMPONENT_ENDPOINT_BASE}/${t}/${g}`);
  }
  setFileUploadClientConfig({
    prefix: t,
    headers: g
  }) {
    this.fileUploadClientConfig = {
      prefix: t,
      headers: g
    };
  }
  /**
   * If we are using a static connection, return S3 URL for that file. Otherwise, return null.
   */
  buildStaticUrl(t) {
    const d = new URLSearchParams(document.location.search).get("staticAppId");
    return `${this.staticConfigUrl}/${d}${t}`;
  }
  /**
   * Construct a URL for a media file. If the `staticConfigUrl` is set, we have a static app
   * and will serve media from S3. If the url is relative and starts with  "/media",
   * assume it's being served from Streamlit and construct it appropriately.
   * Otherwise leave it alone.
   */
  buildMediaURL(t) {
    return this.staticConfigUrl && t.startsWith(MEDIA_ENDPOINT) ? this.buildStaticUrl(t) : t.startsWith(MEDIA_ENDPOINT) ? f(this.requireServerUri(), t) : t;
  }
  /**
   * Construct a URL for a download file.
   * @param url a relative or absolute URL. If `url` is absolute, it will be
   * returned unchanged. Otherwise, the return value will be a URL for fetching
   * the media file from the connected Streamlit instance. The target server can
   * be changed by setting window.__streamlit?.DOWNLOAD_ASSETS_BASE_URL.
   */
  buildDownloadUrl(t) {
    if (!t.startsWith(MEDIA_ENDPOINT))
      return t;
    const g = window.__streamlit?.DOWNLOAD_ASSETS_BASE_URL;
    return f(g ? parseUriIntoBaseParts() : this.requireServerUri(), t);
  }
  /**
   * Construct a URL for uploading a file. If the `fileUploadClientConfig`
   * exists, we build URL by prefixing URL with prefix from the config,
   * otherwise if the `fileUploadClientConfig` is not present, if URL is
   * relative and starts with "/_stcore/upload_file", assume we're uploading
   * the file to the Streamlit Tornado server and construct the URL
   * appropriately. Otherwise, we're probably uploading the file to some
   * external service, so we leave the URL alone.
   */
  buildFileUploadURL(t) {
    return this.fileUploadClientConfig ? s(this.fileUploadClientConfig.prefix, t) : t.startsWith(UPLOAD_FILE_ENDPOINT) ? f(this.requireServerUri(), t) : t;
  }
  /** Construct a URL for an app page in a multi-page app. */
  buildAppPageURL(t, g) {
    const d = g.urlPathname, k = g.isDefault ? "" : d;
    if (typeof t == "string" && t.length > 0)
      return `${t}/${k}`;
    const {
      port: H,
      protocol: AA
    } = window.location, {
      pathname: gA,
      hostname: IA
    } = this.requireServerUri(), CA = H ? `:${H}` : "", BA = gA === "/" ? "/" : `${gA}/`;
    return `${AA}//${IA}${CA}${BA}${k}`;
  }
  async uploadFileUploaderFile(t, g, d, k, H) {
    const AA = new FormData(), {
      name: gA,
      webkitRelativePath: IA
    } = g, CA = IA || gA;
    AA.append(gA, g, CA);
    const BA = this.getAdditionalHeaders(), eA = this.buildFileUploadURL(t);
    try {
      await this.csrfRequest(eA, {
        signal: H,
        method: "PUT",
        data: AA,
        responseType: "text",
        headers: BA,
        onUploadProgress: k
      });
    } catch (iA) {
      LOG$3.error(`Client Error: File uploader error on file upload - ${iA}`);
      const QA = iA instanceof Error ? iA.message : "Unknown Error";
      throw this.sendClientErrorToHost("File Uploader", "Error uploading file", QA, eA), iA;
    }
  }
  getAdditionalHeaders() {
    let t = {};
    return this.fileUploadClientConfig && (t = {
      ...t,
      ...this.fileUploadClientConfig.headers
    }), t;
  }
  /**
   * Send an HTTP DELETE request to the given URL.
   */
  async deleteFileAtURL(t, g) {
    const d = this.getAdditionalHeaders(), k = this.buildFileUploadURL(t);
    try {
      await this.csrfRequest(k, {
        method: "DELETE",
        data: {
          sessionId: g
        },
        headers: d
      });
    } catch (H) {
      LOG$3.error(`Client Error: File uploader error on file delete - ${H}`);
      const AA = H instanceof Error ? H.message : "Unknown Error";
      throw this.sendClientErrorToHost("File Uploader", "Error deleting file", AA, k), H;
    }
  }
  /**
   * Fetch the server URI. If our server is disconnected, default to the most
   * recent cached value of the URI. If we're disconnected and have no cached
   * value, throw an Error.
   */
  requireServerUri() {
    const t = this.getServerUri();
    if (m$1(t))
      return this.cachedServerUri = t, t;
    if (m$1(this.cachedServerUri))
      return this.cachedServerUri;
    throw new Error("not connected to a server!");
  }
  /**
   * Wrapper around axios.request to update the request config with
   * CSRF headers if client has CSRF protection enabled.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  csrfRequest(t, g) {
    if (g.url = t, this.csrfEnabled) {
      const d = u("_streamlit_xsrf");
      m$1(d) && (g.headers = {
        "X-Xsrftoken": d,
        ...g.headers || {}
      }, g.withCredentials = !0);
    }
    return axios.request(g);
  }
}
var Ellipses = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 8 8"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M0 3v2h2V3H0zm3 0v2h2V3H3zm3 0v2h2V3H6z"
  }));
});
Ellipses.displayName = "Ellipses";
var Warning = /* @__PURE__ */ React.forwardRef(function(n, t) {
  var g = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$M({
    iconAttrs: g,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 8 8"
  }, n, {
    ref: t
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M3.09 0c-.06 0-.1.04-.13.09L.02 6.9c-.02.05-.03.13-.03.19v.81c0 .05.04.09.09.09h6.81c.05 0 .09-.04.09-.09v-.81c0-.05-.01-.14-.03-.19L4.01.09A.142.142 0 003.88 0h-.81zM3 3h1v2H3V3zm0 3h1v1H3V6z"
  }));
});
Warning.displayName = "Warning";
const CONNECTING_LABEL = "Connecting", CONNECTING_TOOLTIP_TEXT = "Connecting to Streamlit server", CONNECTING_STATIC_TOOLTIP_TEXT = "Connecting to static app", ERROR_LABEL = "Error", ERROR_TOOLTIP_TEXT = "Unable to connect to Streamlit server";
function getConnectionStateUI(n) {
  switch (n) {
    case ConnectionState.INITIAL:
    case ConnectionState.PINGING_SERVER:
    case ConnectionState.CONNECTING:
      return {
        icon: Ellipses,
        label: CONNECTING_LABEL,
        tooltip: CONNECTING_TOOLTIP_TEXT
      };
    case ConnectionState.CONNECTED:
      return;
    case ConnectionState.STATIC_CONNECTING:
      return {
        icon: Ellipses,
        label: CONNECTING_LABEL,
        tooltip: CONNECTING_STATIC_TOOLTIP_TEXT
      };
    case ConnectionState.STATIC_CONNECTED:
      return;
    case ConnectionState.DISCONNECTED_FOREVER:
    default:
      return {
        icon: Warning,
        label: ERROR_LABEL,
        tooltip: ERROR_TOOLTIP_TEXT
      };
  }
}
const newYearsRunning = "data:image/gif;base64,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";
function _EMOTION_STRINGIFIED_CSS_ERROR__$4() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledConnectionStatus = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib67"
} : {
  target: "en6cib67",
  label: "StyledConnectionStatus"
})(({
  theme: n
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: n.colors.gray60
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledConnectionStatusLabel = /* @__PURE__ */ createStyled$1("label", process.env.NODE_ENV === "production" ? {
  target: "en6cib66"
} : {
  target: "en6cib66",
  label: "StyledConnectionStatusLabel"
})(({
  theme: n
}) => ({
  fontSize: n.fontSizes.sm,
  color: n.colors.gray60,
  textTransform: "uppercase",
  marginTop: n.spacing.none,
  marginRight: n.spacing.lg,
  marginBottom: n.spacing.none,
  marginLeft: n.spacing.sm,
  whiteSpace: "nowrap",
  maxWidth: n.sizes.appStatusMaxWidth,
  lineHeight: n.lineHeights.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppStatus = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib65"
} : {
  target: "en6cib65",
  label: "StyledAppStatus"
})(({
  theme: n
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: n.radii.md,
  margin: `0 ${n.spacing.sm} 0 0`,
  paddingLeft: n.spacing.sm,
  height: n.sizes.appRunningMen
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppStatusLabel = /* @__PURE__ */ createStyled$1("label", process.env.NODE_ENV === "production" ? {
  target: "en6cib64"
} : {
  target: "en6cib64",
  label: "StyledAppStatusLabel"
})(({
  isPrompt: n,
  theme: t
}) => ({
  fontSize: t.fontSizes.sm,
  color: n ? t.colors.bodyText : t.colors.gray60,
  textTransform: n ? "none" : "uppercase",
  margin: `0 0 0 ${t.spacing.sm}`,
  whiteSpace: "nowrap",
  maxWidth: t.sizes.appStatusMaxWidth,
  borderRadius: n ? t.radii.md : void 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppButtonContainer = /* @__PURE__ */ createStyled$1("span", process.env.NODE_ENV === "production" ? {
  target: "en6cib63"
} : {
  target: "en6cib63",
  label: "StyledAppButtonContainer"
})(({
  theme: n
}) => ({
  marginLeft: n.spacing.md,
  whiteSpace: "nowrap",
  color: n.colors.bodyText
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppRunningIcon = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib62"
} : {
  target: "en6cib62",
  label: "StyledAppRunningIcon"
})(({
  isNewYears: n,
  theme: t
}) => ({
  width: n ? "2.2rem" : t.sizes.appRunningMen,
  height: n ? "2.2rem" : t.sizes.appRunningMen,
  marginRight: `-${t.spacing.sm}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "opacity 0.3s ease-in-out",
  cursor: "wait"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStatusWidget = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib61"
} : {
  target: "en6cib61",
  label: "StyledStatusWidget"
})(process.env.NODE_ENV === "production" ? {
  name: "19or5k2",
  styles: "&.StatusWidget-appear{opacity:0;}&.StatusWidget-appear-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-enter{opacity:0;}&.StatusWidget-enter-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-exit{opacity:1;}&.StatusWidget-exit-active{opacity:0;transition:opacity 200ms ease-out;}"
} : {
  name: "19or5k2",
  styles: "&.StatusWidget-appear{opacity:0;}&.StatusWidget-appear-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-enter{opacity:0;}&.StatusWidget-enter-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-exit{opacity:1;}&.StatusWidget-exit-active{opacity:0;transition:opacity 200ms ease-out;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
}), StyledShortcutLabel = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib60"
} : {
  target: "en6cib60",
  label: "StyledShortcutLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "jdyw56",
  styles: "&::first-letter{text-decoration:underline;}"
} : {
  name: "jdyw56",
  styles: "&::first-letter{text-decoration:underline;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
}), icons = [{
  component: AccessibleForward,
  name: "accessible-forward"
}, {
  component: AccessibilityNew,
  name: "accessibility-new"
}, {
  component: DirectionsBike,
  name: "directions-bike"
}, {
  component: DirectionsRun,
  name: "directions-run"
}, {
  component: Pool,
  name: "pool"
}, {
  component: Rowing,
  name: "rowing"
}], isNewYears = () => {
  const n = /* @__PURE__ */ new Date(), t = n.getMonth(), g = n.getDate();
  return t === 11 && g === 31 || t === 0 && g <= 6;
}, DEFAULT_SPEED = 200, IconRunning = () => {
  const [n, t] = useState(0), g = useTheme(), d = useMemo$1(() => isNewYears(), []);
  useEffect(() => {
    if (d) return;
    const AA = setInterval(() => {
      t((gA) => (gA + 1) % icons.length);
    }, DEFAULT_SPEED);
    return () => clearInterval(AA);
  }, [d]);
  const H = icons[n].component;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppRunningIcon, { isNewYears: d, "aria-label": "Running...", role: "img", "data-testid": "stStatusWidgetRunningIcon", children: d ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: newYearsRunning, alt: "New Year's Celebration", style: {
    width: "100%",
    height: "100%",
    objectFit: "contain"
  }, "data-testid": "stStatusWidgetNewYearsIcon" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(H, { color: g.colors.fadedText60, "aria-hidden": "true", "data-testid": "stStatusWidgetRunningManIcon", style: {
    width: g.sizes.appRunningMen,
    height: g.sizes.appRunningMen
  } }) });
}, RUNNING_MAN_DISPLAY_DELAY_TIME_MS = 500, PromptButton = (n) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_BUTTON, disabled: n.disabled, containerWidth: !0, onClick: n.onClick, children: n.title }) }), StatusWidget = ({
  connectionState: n,
  scriptRunState: t,
  rerunScript: g,
  stopScript: d,
  allowRunOnSave: k,
  showScriptChangedActions: H
}) => {
  const [AA, gA] = useState(!1), IA = useRef(null), CA = useRef(null), BA = useEmotionTheme(), eA = () => {
    k && g(!0);
  }, iA = (dA) => {
    dA === "a" && eA();
  }, QA = n === ConnectionState.CONNECTED, tA = useCallback((dA) => {
    CA.current !== null && CA.current.setTimeout(() => {
      gA(!0);
    }, dA);
  }, []), oA = () => {
    d();
  }, EA = () => {
    g(!1);
  };
  useEffect(() => {
    IA.current === null && (IA.current = new Timer()), CA.current === null && (CA.current = new Timer());
    const dA = IA.current, GA = IA.current;
    return () => {
      dA.cancel(), GA.cancel();
    };
  }, []), useEffect(() => {
    QA && (t === ScriptRunState.RUNNING || t === ScriptRunState.RERUN_REQUESTED) && tA(RUNNING_MAN_DISPLAY_DELAY_TIME_MS), t === ScriptRunState.NOT_RUNNING && gA(!1);
  }, [t, tA, QA]);
  const aA = () => {
    const dA = t === ScriptRunState.STOP_REQUESTED;
    return AA ? /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAppStatus, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(IconRunning, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PromptButton, { title: dA ? "Stopping..." : "Stop", disabled: dA, onClick: oA })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  }, nA = () => {
    const dA = t === ScriptRunState.RERUN_REQUESTED;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ReactHotkeys, { keyName: "a", onKeyDown: iA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAppStatus, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: ":material/info:", color: BA.colors.fadedText60 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppStatusLabel, { isPrompt: !0, children: "File change." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PromptButton, { title: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledShortcutLabel, { children: "Rerun" }), disabled: dA, onClick: EA }),
      k && /* @__PURE__ */ jsxRuntimeExports.jsx(PromptButton, { title: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledShortcutLabel, { children: "Always rerun" }), disabled: dA, onClick: eA })
    ] }) });
  }, lA = () => {
    const dA = getConnectionStateUI(n);
    return dA === void 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { content: dA.tooltip, placement: Placement.BOTTOM, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledConnectionStatus, { className: "stConnectionStatus", "data-testid": "stConnectionStatus", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { size: "sm", content: dA.icon }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledConnectionStatusLabel, { children: dA.label })
    ] }) });
  }, cA = () => {
    if (QA) {
      if (t === ScriptRunState.RUNNING || t === ScriptRunState.RERUN_REQUESTED)
        return aA();
      if (H)
        return nA();
    }
    return lA();
  }, sA = useRef(), rA = sA.current;
  if (sA.current = cA(), isNullOrUndefined$1(sA.current) && isNullOrUndefined$1(rA))
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  let uA, hA;
  return notNullOrUndefined(sA.current) ? (uA = !0, hA = sA.current) : (uA = !1, hA = rA), /* @__PURE__ */ jsxRuntimeExports.jsx(CSSTransition, { appear: !0, in: uA, timeout: 200, unmountOnExit: !0, classNames: "StatusWidget", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStatusWidget, { className: "stStatusWidget", "data-testid": "stStatusWidget", children: hA }, "StatusWidget") });
};
var DialogType = /* @__PURE__ */ ((n) => (n.ABOUT = "about", n.CLEAR_CACHE = "clearCache", n.CONNECTION_ERROR = "connectionError", n.SETTINGS = "settings", n.SCRIPT_COMPILE_ERROR = "scriptCompileError", n.THEME_CREATOR = "themeCreator", n.WARNING = "warning", n.DEPLOY_ERROR = "deployError", n.DEPLOY_DIALOG = "deployDialog", n))(DialogType || {}), LevelContext = /* @__PURE__ */ React.createContext(0);
function ownKeys(n, t) {
  var g = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(n);
    t && (d = d.filter(function(k) {
      return Object.getOwnPropertyDescriptor(n, k).enumerable;
    })), g.push.apply(g, d);
  }
  return g;
}
function _objectSpread(n) {
  for (var t = 1; t < arguments.length; t++) {
    var g = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys(Object(g), !0).forEach(function(d) {
      _defineProperty(n, d, g[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(g)) : ownKeys(Object(g)).forEach(function(d) {
      Object.defineProperty(n, d, Object.getOwnPropertyDescriptor(g, d));
    });
  }
  return n;
}
function _defineProperty(n, t, g) {
  return t in n ? Object.defineProperty(n, t, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = g, n;
}
var Action = styled("div", function(n) {
  var t = n.$theme;
  return _objectSpread({}, t.typography.LabelMedium);
});
Action.displayName = "Action";
Action.displayName = "Action";
var Body = styled("div", function(n) {
  var t = n.$theme;
  return _objectSpread({
    marginBottom: t.sizing.scale600,
    color: t.colors.contentPrimary
  }, t.typography.ParagraphMedium);
});
Body.displayName = "Body";
Body.displayName = "Body";
var Contents = styled("div", function(n) {
  var t = n.$theme;
  return {
    marginLeft: t.sizing.scale600,
    marginTop: t.sizing.scale600,
    marginRight: t.sizing.scale600,
    marginBottom: t.sizing.scale600
  };
});
Contents.displayName = "Contents";
Contents.displayName = "Contents";
var HeaderImage = styled("img", function(n) {
  var t = n.$theme;
  return {
    borderTopLeftRadius: t.borders.surfaceBorderRadius,
    borderTopRightRadius: t.borders.surfaceBorderRadius,
    objectFit: "contain",
    maxWidth: "100%"
  };
});
HeaderImage.displayName = "HeaderImage";
HeaderImage.displayName = "HeaderImage";
var Root = styled("section", function(n) {
  var t = n.$theme;
  return {
    borderLeftWidth: "2px",
    borderTopWidth: "2px",
    borderRightWidth: "2px",
    borderBottomWidth: "2px",
    borderLeftStyle: "solid",
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftColor: t.colors.borderOpaque,
    borderRightColor: t.colors.borderOpaque,
    borderTopColor: t.colors.borderOpaque,
    borderBottomColor: t.colors.borderOpaque,
    borderTopLeftRadius: t.borders.radius400,
    borderTopRightRadius: t.borders.radius400,
    borderBottomLeftRadius: t.borders.radius400,
    borderBottomRightRadius: t.borders.radius400,
    backgroundColor: t.colors.backgroundPrimary,
    overflow: "hidden"
  };
});
Root.displayName = "Root";
Root.displayName = "Root";
var Thumbnail = styled("img", function(n) {
  var t = n.$theme;
  return _objectSpread(_objectSpread({
    float: "right",
    height: t.sizing.scale2400,
    width: t.sizing.scale2400,
    objectFit: "cover",
    borderTopLeftRadius: t.borders.surfaceBorderRadius,
    borderTopRightRadius: t.borders.surfaceBorderRadius,
    borderBottomLeftRadius: t.borders.surfaceBorderRadius,
    borderBottomRightRadius: t.borders.surfaceBorderRadius
  }, expandBorderStyles(t.borders.border200)), {}, {
    margin: "0 0 ".concat(t.sizing.scale500, " ").concat(t.sizing.scale500)
  });
});
Thumbnail.displayName = "Thumbnail";
Thumbnail.displayName = "Thumbnail";
var Title = styled("h1", function(n) {
  var t = n.$theme;
  return _objectSpread(_objectSpread({}, t.typography.HeadingSmall), {}, {
    color: t.colors.contentPrimary,
    marginLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: t.sizing.scale500,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0
  });
});
Title.displayName = "Title";
Title.displayName = "Title";
var _excluded = ["children"], _excluded2 = ["action", "children", "hasThumbnail", "headerImage", "thumbnail", "title", "overrides"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var g = arguments[t];
      for (var d in g)
        Object.prototype.hasOwnProperty.call(g, d) && (n[d] = g[d]);
    }
    return n;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties(n, t) {
  if (n == null) return {};
  var g = _objectWithoutPropertiesLoose(n, t), d, k;
  if (Object.getOwnPropertySymbols) {
    var H = Object.getOwnPropertySymbols(n);
    for (k = 0; k < H.length; k++)
      d = H[k], !(t.indexOf(d) >= 0) && Object.prototype.propertyIsEnumerable.call(n, d) && (g[d] = n[d]);
  }
  return g;
}
function _objectWithoutPropertiesLoose(n, t) {
  if (n == null) return {};
  var g = {}, d = Object.keys(n), k, H;
  for (H = 0; H < d.length; H++)
    k = d[H], !(t.indexOf(k) >= 0) && (g[k] = n[k]);
  return g;
}
function hasThumbnail(n) {
  return !!n.thumbnail;
}
var SemanticTitle = function n(t) {
  var g = t.children, d = _objectWithoutProperties(t, _excluded), k = ["", "h1", "h2", "h3", "h4", "h5", "h6"];
  return /* @__PURE__ */ React.createElement(LevelContext.Consumer, null, function(H) {
    return (
      // @ts-expect-error
      /* @__PURE__ */ React.createElement(Title, _extends({
        $as: k[H]
      }, d), g)
    );
  });
};
function Card(n) {
  var t = n.action, g = n.children, d = n.hasThumbnail, k = n.headerImage, H = n.thumbnail, AA = n.title, gA = n.overrides, IA = _objectWithoutProperties(n, _excluded2), CA = gA.Action, BA = gA.Body, eA = gA.Contents, iA = gA.HeaderImage, QA = gA.Root, tA = gA.Thumbnail, oA = gA.Title, EA = getOverride(CA) || Action, aA = getOverride(BA) || Body, nA = getOverride(eA) || Contents, lA = getOverride(iA) || HeaderImage, cA = getOverride(QA) || Root, sA = getOverride(tA) || Thumbnail, rA = getOverride(oA) || SemanticTitle, uA = typeof k == "string" ? {
    src: k
  } : k, hA = d(n);
  return /* @__PURE__ */ React.createElement(cA, _extends({
    "data-baseweb": "card"
  }, IA, getOverrideProps(QA)), k && /* @__PURE__ */ React.createElement(lA, _extends({}, uA, getOverrideProps(iA))), /* @__PURE__ */ React.createElement(nA, getOverrideProps(eA), H && /* @__PURE__ */ React.createElement(sA, _extends({
    src: H
  }, getOverrideProps(tA))), AA && /* @__PURE__ */ React.createElement(rA, _extends({
    $hasThumbnail: hA
  }, getOverrideProps(oA)), AA), /* @__PURE__ */ React.createElement(aA, getOverrideProps(BA), g), t && /* @__PURE__ */ React.createElement(EA, getOverrideProps(CA), t)));
}
Card.defaultProps = {
  action: null,
  children: null,
  hasThumbnail,
  overrides: {}
};
const StreamlitLogo = "data:image/svg+xml,%3csvg%20width='32'%20height='19'%20viewBox='0%200%2032%2019'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Group%202'%3e%3cpath%20id='path3858'%20d='M15.998%2011.078L10.3882%208.04522L0.650371%202.78157C0.641482%202.77247%200.623705%202.77248%200.614816%202.77248C0.259259%202.59975%20-0.105186%202.96338%200.0281476%203.32702L4.98994%2016.2698L4.99083%2016.2725C4.99616%2016.2852%205.00061%2016.298%205.00594%2016.3107C5.2095%2016.7934%205.65394%2017.0916%206.1375%2017.2089C6.17839%2017.218%206.20764%2017.2262%206.25673%2017.2362C6.30559%2017.2473%206.37394%2017.2625%206.43261%2017.2671C6.44239%2017.268%206.45128%2017.268%206.46106%2017.2689H6.46817C6.47528%2017.2698%206.48239%2017.2698%206.4895%2017.2707H6.49928C6.5055%2017.2716%206.51261%2017.2716%206.51883%2017.2716H6.53039C6.5375%2017.2725%206.54461%2017.2725%206.55172%2017.2725C12.8348%2017.9731%2019.1763%2017.9731%2025.4593%2017.2725C25.5349%2017.2725%2025.6087%2017.2689%2025.6798%2017.2616C25.7029%2017.2589%2025.7251%2017.2562%2025.7473%2017.2534C25.75%2017.2525%2025.7536%2017.2525%2025.7562%2017.2516C25.7713%2017.2498%2025.7864%2017.2471%2025.8016%2017.2443C25.8238%2017.2416%2025.846%2017.2371%2025.8682%2017.2325C25.9127%2017.2225%2025.9329%2017.2152%2025.9932%2017.194C26.0535%2017.1729%2026.1536%2017.1358%2026.2163%2017.1049C26.279%2017.074%2026.3224%2017.0443%2026.3749%2017.0107C26.4398%2016.9689%2026.5015%2016.9261%2026.5641%2016.8781C26.5911%2016.8569%2026.6096%2016.8434%2026.6291%2016.8243L26.6184%2016.818L15.998%2011.078Z'%20fill='%23FF2B2B'/%3e%3cpath%20id='path5063'%20d='M31.3616%202.78158H31.3527L21.6113%208.04524L27.0265%2016.2935L31.9758%203.32704V3.30886C32.1003%202.92704%2031.7181%202.58158%2031.3616%202.78158Z'%20fill='%237D353B'/%3e%3cpath%20id='path5101'%20d='M16.5171%200.278788C16.2682%20-0.0930318%2015.726%20-0.0930318%2015.486%200.278788L10.3882%208.04518L15.998%2011.0779L26.6291%2016.8242C26.6959%2016.7574%2026.7494%2016.6922%2026.806%2016.6234C26.886%2016.5225%2026.9607%2016.4143%2027.0265%2016.2934L21.6113%208.04518L16.5171%200.278788Z'%20fill='%23BD4043'/%3e%3c/g%3e%3c/svg%3e", Rocket = "data:image/svg+xml,%3csvg%20width='25'%20height='24'%20viewBox='0%200%2025%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Frame'%3e%3cpath%20id='Vector'%20d='M5.95077%2010.7642L8.09076%2011.6685C8.34683%2011.157%208.61204%2010.6637%208.8864%2010.1887C9.16076%209.71374%209.46256%209.23875%209.79179%208.76376L8.25538%208.46232L5.95077%2010.7642ZM9.84666%2013.0387L12.9743%2016.1352C13.7426%2015.8429%2014.5656%2015.3954%2015.4436%2014.7925C16.3215%2014.1896%2017.1446%2013.5045%2017.9128%2012.7372C19.1931%2011.4584%2020.1946%2010.038%2020.917%208.47602C21.6395%206.91403%2021.955%205.47536%2021.8636%204.16C20.5466%204.06866%2019.1017%204.38379%2017.5287%205.10541C15.9557%205.82703%2014.529%206.82726%2013.2487%208.10608C12.4805%208.87337%2011.7946%209.69547%2011.191%2010.5724C10.5874%2011.4493%2010.1393%2012.2714%209.84666%2013.0387ZM14.7302%2011.2575C14.3096%2010.8373%2014.0992%2010.3212%2014.0992%209.70917C14.0992%209.09716%2014.3096%208.58107%2014.7302%208.16088C15.1509%207.7407%2015.6722%207.53061%2016.2941%207.53061C16.916%207.53061%2017.4373%207.7407%2017.8579%208.16088C18.2786%208.58107%2018.489%209.09716%2018.489%209.70917C18.489%2010.3212%2018.2786%2010.8373%2017.8579%2011.2575C17.4373%2011.6776%2016.916%2011.8877%2016.2941%2011.8877C15.6722%2011.8877%2015.1509%2011.6776%2014.7302%2011.2575ZM15.2515%2020.0539L17.5561%2017.752L17.2543%2016.2175C16.7788%2016.5463%2016.3032%2016.8432%2015.8277%2017.1081C15.3521%2017.373%2014.8583%2017.6333%2014.3461%2017.8891L15.2515%2020.0539ZM23.839%202.15956C24.1865%204.37009%2023.9716%206.52125%2023.1942%208.61304C22.4169%2010.7048%2021.0771%2012.7007%2019.1749%2014.6007L19.7236%2017.3136C19.7967%2017.679%2019.7784%2018.0352%2019.6687%2018.3823C19.559%2018.7294%2019.3761%2019.0309%2019.12%2019.2866L14.5108%2023.8904L12.2061%2018.4919L7.51461%2013.806L2.10974%2011.5041L6.69153%206.90033C6.9476%206.64457%207.25397%206.46188%207.61064%206.35227C7.9673%206.24265%208.32854%206.22438%208.69435%206.29746L11.4105%206.84553C13.3127%204.94556%2015.3064%203.6028%2017.3915%202.81724C19.4767%202.03168%2021.6258%201.81245%2023.839%202.15956ZM4.05769%2017.2862C4.69786%2016.6468%205.47978%2016.3225%206.40346%2016.3134C7.32713%2016.3042%208.10905%2016.6194%208.74922%2017.2588C9.38939%2017.8982%209.70491%2018.6792%209.69576%2019.6018C9.68662%2020.5243%209.36196%2021.3053%208.72179%2021.9448C8.26452%2022.4015%207.50089%2022.7943%206.43089%2023.1231C5.36089%2023.4519%203.88393%2023.7442%202%2024C2.25607%2022.1183%202.54872%2020.6431%202.87795%2019.5744C3.20718%2018.5056%203.60043%2017.7429%204.05769%2017.2862ZM5.62154%2018.8208C5.43863%2019.0035%205.25572%2019.3369%205.07282%2019.821C4.88991%2020.3051%204.76188%2020.7938%204.68872%2021.2871C5.18256%2021.214%205.67183%2021.0907%206.15653%2020.9171C6.64123%2020.7436%206.97504%2020.5655%207.15794%2020.3828C7.37743%2020.1635%207.49632%2019.8986%207.51461%2019.5881C7.5329%2019.2775%207.4323%2019.0126%207.21282%2018.7934C6.99333%2018.5741%206.72812%2018.4691%206.41718%2018.4782C6.10624%2018.4874%205.84102%2018.6015%205.62154%2018.8208Z'%20fill='%23A3A8B8'/%3e%3c/g%3e%3c/svg%3e", Snowflake = "data:image/svg+xml,%3csvg%20width='25'%20height='24'%20viewBox='0%200%2025%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Logo-solid'%3e%3cpath%20id='inside'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M13.5357%2012.1774L12.801%2012.912C12.7029%2013.0101%2012.5439%2013.0101%2012.4458%2012.912L11.7112%2012.1774C11.6131%2012.0794%2011.6131%2011.9203%2011.7112%2011.8223L12.4458%2011.0876C12.5439%2010.9894%2012.703%2010.9894%2012.8011%2011.0876L13.5357%2011.8222C13.6337%2011.9203%2013.6337%2012.0793%2013.5357%2012.1774ZM15.0724%2011.2524L13.3708%209.55073C12.9581%209.13804%2012.2889%209.13804%2011.8761%209.55073L10.1744%2011.2525C9.76154%2011.6653%209.76154%2012.3345%2010.1744%2012.7473L11.876%2014.4489C12.2887%2014.8616%2012.9579%2014.8616%2013.3707%2014.4489L15.0724%2012.7471C15.4852%2012.3343%2015.4852%2011.6651%2015.0724%2011.2524Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%206'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.79594%200C8.95801%200%208.2787%200.679312%208.2787%201.51724V4.65891L5.53731%203.07614C4.81165%202.65718%203.88372%202.9058%203.46476%203.63153C3.04579%204.35718%203.29441%205.28512%204.02007%205.70408L8.83304%208.48285C9.09497%208.69823%209.43036%208.82761%209.79594%208.82761C10.6339%208.82761%2011.3132%208.14829%2011.3132%207.31036V1.51724C11.3132%200.679312%2010.6339%200%209.79594%200Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%205'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8.60315%2012.5758C8.61253%2012.553%208.62177%2012.5303%208.62997%2012.5071C8.63915%2012.4812%208.64722%2012.4552%208.65494%2012.429C8.66087%2012.4088%208.66673%2012.3888%208.67184%2012.3685C8.67887%2012.3405%208.6848%2012.3124%208.69018%2012.2841C8.69397%2012.2642%208.69756%2012.2443%208.7006%2012.2243C8.70473%2012.1967%208.70791%2012.1692%208.71046%2012.1414C8.71253%2012.1194%208.71425%2012.0975%208.71542%2012.0754C8.71666%2012.0503%208.71708%2012.0252%208.71708%2012C8.71708%2011.9748%208.71666%2011.9498%208.71542%2011.9246C8.71425%2011.9025%208.71253%2011.8805%208.71046%2011.8586C8.70791%2011.8309%208.70473%2011.8034%208.7006%2011.7756C8.69756%2011.7556%208.69397%2011.7358%208.69018%2011.7158C8.6848%2011.6876%208.67887%2011.6596%208.67184%2011.6315C8.66673%2011.6112%208.66087%2011.5912%208.65494%2011.5711C8.64722%2011.5449%208.63915%2011.5188%208.62997%2011.4929C8.62177%2011.4697%208.61253%2011.4469%208.60315%2011.4242C8.59418%2011.4023%208.58528%2011.3805%208.57522%2011.3589C8.56246%2011.3316%208.54825%2011.3049%208.53391%2011.2784C8.52722%2011.2661%208.52198%2011.2535%208.51501%2011.2414C8.51232%2011.2367%208.50901%2011.2325%208.50625%2011.2279C8.48956%2011.1996%208.47122%2011.1722%208.45259%2011.1449C8.44266%2011.1303%208.43308%2011.1152%208.42266%2011.1009C8.40466%2011.0765%208.38515%2011.0532%208.3657%2011.0298C8.35253%2011.014%208.3399%2010.9978%208.32625%2010.9826C8.30922%2010.9638%208.29087%2010.9462%208.27287%2010.9281C8.2548%2010.9101%208.23715%2010.8917%208.21839%2010.8747C8.20322%2010.8612%208.18701%2010.8485%208.17122%2010.8354C8.14777%2010.8158%208.12453%2010.7963%208.10004%2010.7784C8.08584%2010.7679%208.07073%2010.7583%208.05604%2010.7484C8.0288%2010.7298%208.00142%2010.7115%207.97308%2010.6947C7.96846%2010.6921%207.96432%2010.6887%207.95963%2010.6861L2.94265%207.78949C2.21693%207.37046%201.28899%207.61915%200.870026%208.3448C0.45106%209.07053%200.699681%209.99846%201.42541%2010.4174L4.16652%2012L1.42541%2013.5826C0.699681%2014.0016%200.45106%2014.9295%200.870026%2015.6552C1.28899%2016.3809%202.21693%2016.6295%202.94265%2016.2105L7.95963%2013.314C7.96432%2013.3112%207.96846%2013.308%207.97308%2013.3052C8.00142%2013.2885%208.0288%2013.2702%208.05604%2013.2516C8.07073%2013.2416%208.08584%2013.2321%208.10004%2013.2216C8.12453%2013.2036%208.14777%2013.1841%208.17122%2013.1646C8.18701%2013.1516%208.20322%2013.1389%208.21839%2013.1252C8.23708%2013.1083%208.2548%2013.0899%208.2728%2013.0719C8.29087%2013.0539%208.30922%2013.0361%208.32625%2013.0173C8.3399%2013.0023%208.35246%2012.986%208.36563%2012.9703C8.38515%2012.9469%208.40466%2012.9235%208.42266%2012.899C8.43308%2012.8848%208.4426%2012.8698%208.45253%2012.8551C8.47122%2012.8278%208.48956%2012.8004%208.50632%2012.7721C8.50908%2012.7674%208.51232%2012.7633%208.51501%2012.7586C8.52198%2012.7465%208.52722%2012.7339%208.53384%2012.7217C8.54825%2012.695%208.56246%2012.6684%208.57522%2012.641C8.58528%2012.6194%208.59418%2012.5976%208.60315%2012.5758Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%204'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.79594%2015.1724C9.43036%2015.1724%209.09504%2015.3017%208.83304%2015.5171L4.02007%2018.2958C3.29441%2018.7148%203.04579%2019.6427%203.46476%2020.3684C3.88372%2021.0941%204.81165%2021.3428%205.53731%2020.9238L8.2787%2019.3411V22.4827C8.2787%2023.3207%208.95801%2024%209.79594%2024C10.6339%2024%2011.3132%2023.3207%2011.3132%2022.4827V16.6896C11.3132%2015.8517%2010.6339%2015.1724%209.79594%2015.1724Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%203'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.2272%2018.2958L16.4142%2015.5171C16.1522%2015.3017%2015.8169%2015.1724%2015.4513%2015.1724C14.6134%2015.1724%2013.9341%2015.8517%2013.9341%2016.6896V22.4827C13.9341%2023.3207%2014.6134%2024%2015.4513%2024C16.2893%2024%2016.9686%2023.3207%2016.9686%2022.4827V19.3411L19.71%2020.9238C20.4356%2021.3428%2021.3636%2021.0941%2021.7826%2020.3684C22.2015%2019.6427%2021.9529%2018.7148%2021.2272%2018.2958Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%202'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M23.8219%2013.5826L21.0808%2012L23.8219%2010.4174C24.5476%209.99843%2024.7963%209.0705%2024.3773%208.34484C23.9584%207.61911%2023.0304%207.37049%2022.3047%207.78946L17.2877%2010.686C17.283%2010.6887%2017.2789%2010.692%2017.2743%2010.6947C17.2459%2010.7115%2017.2186%2010.7298%2017.1912%2010.7484C17.1766%2010.7584%2017.1615%2010.7679%2017.1473%2010.7784C17.1228%2010.7964%2017.0995%2010.8159%2017.0761%2010.8353C17.0603%2010.8484%2017.0441%2010.8611%2017.029%2010.8747C17.0101%2010.8917%2016.9926%2010.9101%2016.9745%2010.9282C16.9565%2010.9462%2016.9381%2010.9638%2016.921%2010.9826C16.9074%2010.9978%2016.8948%2011.014%2016.8817%2011.0297C16.8622%2011.0532%2016.8427%2011.0765%2016.8247%2011.101C16.8143%2011.1152%2016.8048%2011.1302%2016.7947%2011.1449C16.7761%2011.1722%2016.7578%2011.1995%2016.7411%2011.2279C16.7383%2011.2326%2016.735%2011.2366%2016.7323%2011.2414C16.7254%2011.2535%2016.7201%2011.2661%2016.7134%2011.2784C16.6991%2011.305%2016.6849%2011.3316%2016.6721%2011.359C16.6621%2011.3805%2016.6532%2011.4024%2016.6442%2011.4242C16.6348%2011.4469%2016.6256%2011.4697%2016.6174%2011.4928C16.6081%2011.5188%2016.6001%2011.5448%2016.5924%2011.5711C16.5865%2011.5911%2016.5806%2011.6112%2016.5756%2011.6315C16.5685%2011.6595%2016.5625%2011.6876%2016.5572%2011.7159C16.5534%2011.7358%2016.5498%2011.7557%2016.5468%2011.7757C16.5426%2011.8033%2016.5394%2011.8309%2016.5369%2011.8586C16.5348%2011.8805%2016.5331%2011.9025%2016.5319%2011.9246C16.5307%2011.9497%2016.5303%2011.9748%2016.5303%2012C16.5303%2012.0251%2016.5307%2012.0502%2016.5319%2012.0754C16.5331%2012.0975%2016.5348%2012.1194%2016.5369%2012.1415C16.5394%2012.1691%2016.5426%2012.1966%2016.5468%2012.2243C16.5498%2012.2444%2016.5534%2012.2642%2016.5572%2012.2841C16.5625%2012.3124%2016.5685%2012.3404%2016.5756%2012.3685C16.5806%2012.3888%2016.5865%2012.4088%2016.5924%2012.4289C16.6001%2012.4551%2016.6081%2012.4811%2016.6174%2012.5071C16.6256%2012.5303%2016.6348%2012.553%2016.6442%2012.5757C16.6532%2012.5976%2016.6621%2012.6194%2016.6721%2012.641C16.6849%2012.6684%2016.6991%2012.6951%2016.7135%2012.7217C16.7201%2012.7339%2016.7254%2012.7465%2016.7323%2012.7586C16.735%2012.7633%2016.7383%2012.7675%2016.741%2012.7721C16.7578%2012.8004%2016.7761%2012.8278%2016.7948%2012.8551C16.8048%2012.8697%2016.8143%2012.8849%2016.8247%2012.899C16.8427%2012.9235%2016.8622%2012.9469%2016.8818%2012.9703C16.8949%2012.986%2016.9074%2013.0022%2016.921%2013.0173C16.9381%2013.0361%2016.9565%2013.0538%2016.9746%2013.0719C16.9926%2013.0899%2017.0102%2013.1082%2017.029%2013.1252C17.0441%2013.1389%2017.0603%2013.1515%2017.0761%2013.1646C17.0995%2013.1842%2017.1228%2013.2037%2017.1473%2013.2216C17.1615%2013.2321%2017.1766%2013.2416%2017.1912%2013.2516C17.2186%2013.2702%2017.2459%2013.2885%2017.2743%2013.3053C17.2789%2013.308%2017.283%2013.3112%2017.2877%2013.314L22.3047%2016.2105C23.0304%2016.6295%2023.9584%2016.3809%2024.3773%2015.6552C24.7963%2014.9295%2024.5476%2014.0015%2023.8219%2013.5826Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%201'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.7826%203.63153C21.3636%202.90587%2020.4357%202.65718%2019.71%203.07614L16.9686%204.65891V1.51724C16.9686%200.679312%2016.2893%200%2015.4513%200C14.6134%200%2013.9341%200.679312%2013.9341%201.51724V7.31036C13.9341%208.14836%2014.6134%208.82761%2015.4513%208.82761C15.8169%208.82761%2016.1523%208.69823%2016.4142%208.48285L21.2272%205.70408C21.9529%205.28518%2022.2015%204.35718%2021.7826%203.63153Z'%20fill='%2329B5E8'/%3e%3c/g%3e%3c/svg%3e";
function DetachedHead() {
  return {
    title: "Unable to deploy",
    body: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "This Git tree is in a detached HEAD state." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Please commit the latest changes and push to GitHub to continue." })
    ] })
  };
}
function ModuleIsNotAdded(n) {
  return {
    title: "Unable to deploy",
    body: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: `
The app's main file \`${n}\` has
not been pushed to GitHub. Please add it to continue.
`, allowHTML: !1 })
  };
}
const DEPLOY_URL = "https://share.streamlit.io/deploy", STREAMLIT_CLOUD_URL = "https://streamlit.io/cloud", STREAMLIT_COMMUNITY_CLOUD_DOCS_URL = "https://share.streamlit.io/cloud-getting-started", STREAMLIT_DEPLOY_TUTORIAL_URL = "https://share.streamlit.io/deployment-tutorial", SNOWFLAKE_LEARN_MORE_URL = "https://share.streamlit.io/sis-about", SNOWFLAKE_TRIAL_URL = "https://share.streamlit.io/snowflake-trial";
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledParagraph = /* @__PURE__ */ createStyled$1("p", process.env.NODE_ENV === "production" ? {
  target: "epbg7au0"
} : {
  target: "epbg7au0",
  label: "StyledParagraph"
})(process.env.NODE_ENV === "production" ? {
  name: "1aujq9w",
  styles: "text-align:justify"
} : {
  name: "1aujq9w",
  styles: "text-align:justify/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvRGVwbG95RXJyb3JEaWFsb2dzL3N0eWxlZC1jb21wb25lbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQitCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvRGVwbG95RXJyb3JEaWFsb2dzL3N0eWxlZC1jb21wb25lbnRzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGFyYWdyYXBoID0gc3R5bGVkLnAoe1xuICB0ZXh0QWxpZ246IFwianVzdGlmeVwiLFxufSlcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});
function NoRepositoryDetected() {
  return {
    title: "Unable to deploy",
    body: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledParagraph, { children: [
      "The app’s code is not connected to a remote GitHub repository. To deploy on Streamlit Community Cloud, please put your code in a GitHub repository and publish the current branch. Read more in",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: STREAMLIT_COMMUNITY_CLOUD_DOCS_URL, rel: "noopener noreferrer", target: "_blank", children: "our documentation" }),
      "."
    ] })
  };
}
function DeployCard(n) {
  const {
    colors: t,
    spacing: g,
    radii: d,
    breakpoints: k,
    sizes: H
  } = useEmotionTheme(), {
    children: AA
  } = n;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { overrides: {
    Root: {
      style: {
        borderTopWidth: H.borderWidth,
        borderBottomWidth: H.borderWidth,
        borderLeftWidth: H.borderWidth,
        borderRightWidth: H.borderWidth,
        borderTopStyle: "solid",
        borderBottomStyle: "none",
        borderLeftStyle: "none",
        borderRightStyle: "solid",
        borderTopColor: t.borderColor,
        borderBottomColor: t.borderColor,
        borderLeftColor: t.borderColor,
        borderRightColor: t.borderColor,
        borderTopLeftRadius: "none",
        borderTopRightRadius: "none",
        borderBottomLeftRadius: "none",
        borderBottomRightRadius: "none",
        ":last-child": {
          borderRightStyle: "none",
          borderBottomRightRadius: d.xl
        },
        ":first-child": {
          borderBottomLeftRadius: d.xl
        },
        [`@media (max-width: ${k.md})`]: {
          ":last-child": {
            borderBottomLeftRadius: d.xl
          }
        }
      }
    },
    Contents: {
      style: {
        marginBottom: 0,
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        height: "100%"
      }
    },
    Body: {
      style: {
        padding: g.twoXL,
        marginBottom: 0,
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        [`@media (max-width: ${k.md})`]: {
          padding: g.xl
        }
      }
    }
  }, children: AA });
}
const Checkmark = "data:image/svg+xml,%3csvg%20width='12'%20height='9'%20viewBox='0%200%2012%209'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.00009%206.78L1.68676%204.46667C1.42676%204.20667%201.00676%204.20667%200.746758%204.46667C0.486758%204.72667%200.486758%205.14667%200.746758%205.40667L3.53342%208.19334C3.79342%208.45334%204.21342%208.45334%204.47342%208.19334L11.5268%201.14C11.7868%200.880005%2011.7868%200.460005%2011.5268%200.200005C11.2668%20-0.0599951%2010.8468%20-0.0599951%2010.5868%200.200005L4.00009%206.78Z'%20fill='%23808495'/%3e%3c/svg%3e", StyledHeader$1 = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve4"
} : {
  target: "e97l2ve4",
  label: "StyledHeader"
})(({
  theme: n
}) => ({
  // We do not want to change the font for this based on theme.
  fontFamily: n.fonts.sansSerif,
  fontWeight: n.fontWeights.bold,
  fontSize: n.fontSizes.lg,
  marginTop: n.spacing.twoXL,
  marginBottom: n.spacing.twoXS,
  [`@media (max-width: ${n.breakpoints.md})`]: {
    marginTop: n.spacing.md
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSubheader = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve3"
} : {
  target: "e97l2ve3",
  label: "StyledSubheader"
})(({
  theme: n
}) => ({
  // We do not want to change the font for this based on theme.
  fontFamily: n.fonts.sansSerif,
  fontWeight: n.fontWeights.normal,
  fontSize: n.fontSizes.md,
  marginTop: n.spacing.twoXS,
  marginBottom: n.spacing.md,
  [`@media (max-width: ${n.breakpoints.md})`]: {
    marginTop: n.spacing.md
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCardContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve2"
} : {
  target: "e97l2ve2",
  label: "StyledCardContainer"
})(({
  theme: n
}) => ({
  display: "grid",
  maxWidth: `calc(1.25 * ${n.sizes.contentMaxWidth})`,
  gridTemplateColumns: "1fr 1fr 1fr",
  gridGap: n.spacing.none,
  [`@media (max-width: ${n.breakpoints.md})`]: {
    gridTemplateColumns: "1fr"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledElement = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve1"
} : {
  target: "e97l2ve1",
  label: "StyledElement"
})(({
  theme: n
}) => ({
  display: "inline-flex",
  marginTop: n.spacing.sm,
  "& > span": {
    // We do not want to change the font for this based on theme.
    fontFamily: n.fonts.sansSerif,
    fontWeight: n.fontWeights.normal,
    fontSize: n.fontSizes.md,
    marginLeft: n.spacing.twoXL,
    color: n.colors.gray70
  },
  "& > img": {
    position: "absolute",
    marginTop: n.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledActionsWrapper = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve0"
} : {
  target: "e97l2ve0",
  label: "StyledActionsWrapper"
})(({
  theme: n
}) => ({
  display: "flex",
  marginTop: n.spacing.threeXL,
  "& > button": {
    marginRight: n.spacing.twoXL
  },
  [`@media (max-width: ${n.breakpoints.md})`]: {
    marginTop: n.spacing.xl
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function DeployListElement(n) {
  const {
    children: t
  } = n;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledElement, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Checkmark, alt: "Checkmark" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: t })
  ] });
}
function ModalBody({
  children: n
}) {
  const {
    colors: t,
    fontSizes: g,
    spacing: d
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$2, { style: {
    marginTop: d.none,
    marginLeft: d.none,
    marginRight: d.none,
    marginBottom: d.none,
    paddingTop: d.md,
    paddingRight: d.none,
    paddingBottom: d.none,
    paddingLeft: d.none,
    color: t.bodyText,
    fontSize: g.md,
    overflowY: "auto"
  }, children: n });
}
function DeployModal(n) {
  const {
    children: t,
    onClose: g
  } = n;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, closeable: !0, onClose: g, size: "auto", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Deploy this app using..." }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: t })
  ] });
}
const {
  GitStates
} = GitInfo, openUrl = (n) => {
  window.open(n, "_blank");
}, getDeployAppUrl = (n) => {
  if (n) {
    const t = new URL(DEPLOY_URL);
    return t.searchParams.set("repository", n.repository ?? ""), t.searchParams.set("branch", n.branch ?? ""), t.searchParams.set("mainModule", n.module ?? ""), t.toString();
  }
  return STREAMLIT_CLOUD_URL;
};
function DeployDialog(n) {
  const {
    gitInfo: t
  } = useAppContext(), {
    onClose: g,
    metricsMgr: d,
    showDeployError: k,
    isDeployErrorModalOpen: H
  } = n, AA = useCallback(() => {
    if (d.enqueue("menuClick", {
      label: "deployButtonInDialog"
    }), !t) {
      const QA = NoRepositoryDetected();
      k(QA.title, QA.body);
      return;
    }
    const {
      repository: gA,
      branch: IA,
      module: CA,
      untrackedFiles: BA,
      state: eA
    } = t;
    if ((!gA || !IA || !CA) && eA === GitStates.DEFAULT) {
      const QA = NoRepositoryDetected();
      k(QA.title, QA.body);
      return;
    }
    if (eA === GitStates.HEAD_DETACHED) {
      const QA = DetachedHead();
      k(QA.title, QA.body);
      return;
    }
    if (CA && BA?.includes(CA)) {
      const QA = ModuleIsNotAdded(CA);
      k(QA.title, QA.body);
      return;
    }
    H && g(), openUrl(getDeployAppUrl(t));
  }, [d, t, H, k, g]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DeployModal, { onClose: g, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledCardContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeployCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Body, { style: {
        flexGrow: 1
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: StreamlitLogo, alt: "Streamlit Logo", "data-testid": "stDeployDialogCommunityCloudIcon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$1, { children: "Streamlit Community Cloud" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSubheader, { children: "For community, always free" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "For personal hobbies and learning" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Deploy unlimited public apps" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Explore and learn from Streamlit’s community and popular apps" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Action, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledActionsWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.PRIMARY, onClick: AA, children: "Deploy now" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: () => {
          d.enqueue("menuClick", {
            label: "readMoreCommunityCloudInDeployDialog"
          }), openUrl(STREAMLIT_COMMUNITY_CLOUD_DOCS_URL);
        }, kind: BaseButtonKind.MINIMAL, children: "Learn more" })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeployCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Body, { style: {
        flexGrow: 1
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Snowflake, alt: "Snowflake", "data-testid": "stDeployDialogSnowflakeDeploymentIcon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$1, { children: "Snowflake" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSubheader, { children: "For enterprise" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Enterprise-level security, support, and fully managed infrastructure" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Deploy unlimited private apps with role-based sharing" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Integrate with Snowflake’s full data stack" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Action, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledActionsWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.SECONDARY, onClick: () => {
          d.enqueue("menuClick", {
            label: "startTrialInDeployDialog"
          }), openUrl(SNOWFLAKE_TRIAL_URL);
        }, children: "Start trial" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: () => {
          d.enqueue("menuClick", {
            label: "learnMoreSnowflakeInDeployDialog"
          }), openUrl(SNOWFLAKE_LEARN_MORE_URL);
        }, kind: BaseButtonKind.MINIMAL, children: "Learn more" })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeployCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Body, { style: {
        flexGrow: 2
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Rocket, alt: "Rocket", "data-testid": "stDeployDialogCustomDeploymentIcon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$1, { children: "Other platforms" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSubheader, { children: "For custom deployment " }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Deploy on your own hardware or cloud service" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Set up and maintain your own authentication, resources, and costs" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Action, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledActionsWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: () => {
        d.enqueue("menuClick", {
          label: "readMoreDeployTutorialInDeployDialog"
        }), openUrl(STREAMLIT_DEPLOY_TUTORIAL_URL);
      }, kind: BaseButtonKind.MINIMAL, children: "Learn more" }) }) })
    ] })
  ] }) });
}
const StyledBackButton = /* @__PURE__ */ createStyled$1(ChevronLeft, process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc8"
} : {
  target: "e1x90zqc8",
  label: "StyledBackButton"
})(({
  theme: n
}) => ({
  cursor: "pointer",
  marginRight: n.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDialogBody = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc7"
} : {
  target: "e1x90zqc7",
  label: "StyledDialogBody"
})(({
  theme: n
}) => ({
  display: "grid",
  gap: n.spacing.twoXL,
  gridTemplateColumns: "1fr 1fr",
  margin: 0,
  padding: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledFullRow = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc6"
} : {
  target: "e1x90zqc6",
  label: "StyledFullRow"
})(({
  theme: n
}) => ({
  gridColumnStart: 1,
  gridColumnEnd: -1,
  display: "grid",
  gap: n.spacing.xs
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeader = /* @__PURE__ */ createStyled$1("h2", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc5"
} : {
  target: "e1x90zqc5",
  label: "StyledHeader"
})(({
  theme: n
}) => ({
  paddingBottom: 0,
  paddingTop: 0,
  marginBottom: n.spacing.md,
  marginTop: "0",
  fontWeight: n.fontWeights.bold,
  fontSize: n.fontSizes.md,
  lineHeight: n.lineHeights.tight,
  color: n.colors.bodyText,
  display: "grid",
  gridAutoFlow: "row",
  gap: n.spacing.xs,
  // Override the default global style for a h2:first-of-type
  "&:first-of-type": {
    marginTop: 0
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLabel = /* @__PURE__ */ createStyled$1("label", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc4"
} : {
  target: "e1x90zqc4",
  label: "StyledLabel"
})(({
  theme: n
}) => ({
  paddingBottom: 0,
  paddingTop: 0,
  marginBottom: 0,
  marginTop: 0,
  lineHeight: n.lineHeights.tight,
  fontSize: n.fontSizes.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
process.env.NODE_ENV;
const StyledButtonContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc2"
} : {
  target: "e1x90zqc2",
  label: "StyledButtonContainer"
})(({
  theme: n
}) => ({
  marginTop: n.spacing.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCheckbox = /* @__PURE__ */ createStyled$1("input", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc1"
} : {
  target: "e1x90zqc1",
  label: "StyledCheckbox"
})(({
  theme: n
}) => ({
  marginRight: n.spacing.xs,
  appearance: "none",
  border: `${n.sizes.borderWidth} solid ${n.colors.borderColor}`,
  width: n.fontSizes.md,
  height: n.fontSizes.md,
  borderRadius: `min(${n.radii.md}, ${n.radii.maxCheckbox})`,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  verticalAlign: "middle",
  overflow: "hidden",
  "&:focus-visible": {
    outline: `2px solid ${n.colors.primary}`
  },
  "&:checked": {
    backgroundColor: n.colors.primary,
    "&:after": {
      content: '"✓"',
      fontFamily: n.fonts.monospace,
      fontSize: n.fontSizes.md,
      color: n.colors.white,
      lineHeight: n.lineHeights.none
    }
  },
  "&:disabled": {
    backgroundColor: n.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDeployErrorContent = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc0"
} : {
  target: "e1x90zqc0",
  label: "StyledDeployErrorContent"
})(({
  theme: n
}) => ({
  "& > ul": {
    paddingLeft: n.spacing.twoXL
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ThemeCreatorButton = ({
  openThemeCreator: n
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledButtonContainer, { "data-testid": "edit-theme", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: n, kind: BaseButtonKind.SECONDARY, children: "Edit active theme" }) }), SettingsDialog = memo$1(function n({
  isServerConnected: t,
  onClose: g,
  onSave: d,
  settings: k,
  allowRunOnSave: H,
  developerMode: AA,
  openThemeCreator: gA,
  animateModal: IA,
  metricsMgr: CA,
  sessionInfo: BA
}) {
  const eA = useContext(LibContext), iA = useRef(k), QA = useRef(!0), [tA, oA] = useState({
    ...k
  }), EA = useCallback((lA, cA) => {
    oA((sA) => ({
      ...sA,
      [lA]: cA
    }));
  }, []);
  useEffect(() => {
    if (QA.current) {
      QA.current = !1;
      return;
    }
    iA.current = tA, d(iA.current);
  }, [d, tA]);
  const aA = useCallback((lA) => {
    EA(lA.target.name, lA.target.checked);
  }, [EA]), nA = useCallback((lA) => {
    let cA;
    lA && (cA = eA.availableThemes.find((sA) => sA.name === lA)), cA === void 0 && (cA = eA.availableThemes[0]), CA.enqueue("menuClick", {
      label: "changeTheme"
    }), eA.setTheme(cA);
  }, [eA, CA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { animate: IA, isOpen: !0, onClose: g, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Settings" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDialogBody, { children: [
      H && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledFullRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader, { children: "Development" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCheckbox, { disabled: !t, type: "checkbox", name: "runOnSave", checked: tA.runOnSave && t, onChange: aA }),
          " ",
          "Run on save"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: "Automatically updates the app when the underlying code is updated.", allowHTML: !1, isCaption: !0 })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledFullRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader, { children: "Appearance" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCheckbox, { type: "checkbox", name: "wideMode", checked: tA.wideMode, onChange: aA }),
          " ",
          "Wide mode"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: " Turn on to make this app occupy the entire width of the screen.", allowHTML: !1, isCaption: !0 })
      ] }),
      !!eA.availableThemes.length && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledFullRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabel, { children: "Choose app theme, colors and fonts" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(UISelectbox, { options: eA.availableThemes.map((lA) => lA.name), disabled: !1, onChange: nA, value: eA.activeTheme.name, placeholder: "", acceptNewOptions: !1 }),
        AA && /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeCreatorButton, { openThemeCreator: gA })
      ] }),
      BA.isSet && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "stVersionInfo", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: `Made with Streamlit ${BA.current.streamlitVersion}`, allowHTML: !1, isCaption: !0 }) })
    ] }) })
  ] });
});
function humanizeString(n, t = {}) {
  if (typeof n != "string")
    throw new TypeError("Expected a string");
  return t.preserveCase || (n = decamelize$1(n), n = n.toLowerCase()), n = n.replace(/[_-]+/g, " ").replace(/\s{2,}/g, " ").trim(), n = n.charAt(0).toUpperCase() + n.slice(1), n;
}
var mapValues_1, hasRequiredMapValues;
function requireMapValues() {
  if (hasRequiredMapValues) return mapValues_1;
  hasRequiredMapValues = 1;
  var n = require_baseAssignValue(), t = require_baseForOwn(), g = require_baseIteratee();
  function d(k, H) {
    var AA = {};
    return H = g(H, 3), t(k, function(gA, IA, CA) {
      n(AA, IA, H(gA, IA, CA));
    }), AA;
  }
  return mapValues_1 = d, mapValues_1;
}
var mapValuesExports = requireMapValues();
const mapValues = /* @__PURE__ */ getDefaultExportFromCjs$2(mapValuesExports), valueToColor = (n, t) => toHex(n).toUpperCase(), changedColorConfig = (n, t) => {
  const g = (H) => typeof H == "string" ? H.toLowerCase() : H, d = mapValues(toThemeInput(t), g);
  n = mapValues(n, g);
  const k = [];
  return n.primaryColor !== d.primaryColor && k.push(`primaryColor="${n.primaryColor}"`), n.backgroundColor !== d.backgroundColor && k.push(`backgroundColor="${n.backgroundColor}"`), n.secondaryBackgroundColor !== d.secondaryBackgroundColor && k.push(`secondaryBackgroundColor="${n.secondaryBackgroundColor}"`), n.textColor !== d.textColor && k.push(`textColor="${n.textColor}"`), k;
}, displayFontOption = (n) => (
  // @ts-expect-error
  humanizeString(CustomThemeConfig.FontFamily[n])
), themeBuilder = {
  primaryColor: {
    help: "Primary accent color for interactive elements.",
    title: "Primary color",
    component: BaseColorPicker$1,
    getValue: valueToColor
  },
  backgroundColor: {
    help: "Background color for the main content area.",
    title: "Background color",
    component: BaseColorPicker$1,
    getValue: valueToColor
  },
  secondaryBackgroundColor: {
    help: "Background color used for the sidebar and most interactive widgets.",
    title: "Secondary background color",
    component: BaseColorPicker$1,
    getValue: valueToColor
  },
  textColor: {
    help: "Color used for almost all text.",
    title: "Text color",
    component: BaseColorPicker$1,
    getValue: valueToColor
  },
  font: {
    help: "Font family for all text in the app, except code blocks.",
    title: "Font family",
    options: Object.keys(CustomThemeConfig.FontFamily).map((n) => humanizeString(n)),
    getValue: (n, t) => t.options?.findIndex((g) => g === displayFontOption(n)) || 0,
    component: UISelectbox
  }
}, toMinimalToml = (n) => {
  const t = ["[theme]"], g = changedColorConfig(n, lightTheme.emotion), d = changedColorConfig(n, darkTheme$1.emotion), k = g.length, H = d.length;
  if (k === H ? t.push(...g) : k < H ? t.push('base="light"', ...g) : t.push('base="dark"', ...d), n.font) {
    const AA = displayFontOption(n.font).toLowerCase();
    t.push(`font="${AA}"`);
  }
  return [
    ...t,
    // Add a newline to the end.
    ""
  ].join(`
`);
}, ThemeOption = ({
  name: n,
  value: t,
  onThemeOptionChange: g
}) => {
  const d = themeBuilder[n], k = d.component === BaseColorPicker$1, H = {
    options: d.options || void 0,
    showValue: k,
    value: d.getValue(t, d)
  }, AA = useCallback((gA) => {
    g(n, gA);
  }, [n, g]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(d.component, { disabled: !1, label: d.title, help: d.help, onChange: AA, ...H }) }, n);
}, ThemeCreatorDialog = (n) => {
  const {
    activeTheme: t,
    addThemes: g,
    setTheme: d
  } = useContext(LibContext), k = toThemeInput(t.emotion), H = (EA) => {
    g([EA]), d(EA);
  }, AA = (EA, aA) => {
    const nA = createTheme(CUSTOM_THEME_NAME, {
      ...k,
      [EA]: aA
    });
    H(nA);
  }, gA = toMinimalToml(k), {
    isCopied: IA,
    copyToClipboard: CA
  } = useCopyToClipboard(), BA = () => {
    n.metricsMgr.enqueue("menuClick", {
      label: "copyThemeToClipboard"
    }), CA(gA);
  }, eA = () => {
    n.backToSettings(!1);
  }, {
    primaryColor: iA,
    textColor: QA,
    backgroundColor: tA,
    secondaryBackgroundColor: oA
  } = k;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { animate: !1, isOpen: !0, onClose: n.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalHeader, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledBackButton, { onClick: eA, "data-testid": "stThemeCreatorBack" }),
      "Edit active theme"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDialogBody, { "data-testid": "stThemeCreatorDialog", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFullRow, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: `
Changes made to the active theme will exist for the duration of a
session. To discard changes and recover the original theme,
refresh the page.`, allowHTML: !1, isCaption: !0 }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeOption, { name: "primaryColor", value: iA, onThemeOptionChange: AA }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeOption, { name: "backgroundColor", value: tA, onThemeOptionChange: AA }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeOption, { name: "textColor", value: QA, onThemeOptionChange: AA }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeOption, { name: "secondaryBackgroundColor", value: oA, onThemeOptionChange: AA }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFullRow, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFullRow, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: "\nTo save your changes, copy your custom theme into the clipboard and paste it into the\n`[theme]` section of your `.streamlit/config.toml` file.\n", allowHTML: !1, isCaption: !0 }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFullRow, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: BA, kind: BaseButtonKind.SECONDARY, children: IA ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
        "Copied to clipboard ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { content: Check, size: "lg", color: t.emotion.colors.greenTextColor })
      ] }) : "Copy theme to clipboard" }) }) })
    ] }) })
  ] });
};
function StreamlitDialog(n) {
  switch (n.type) {
    case DialogType.ABOUT:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AboutDialog, { ...n });
    case DialogType.CLEAR_CACHE:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ClearCacheDialog, { ...n });
    case DialogType.SETTINGS:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsDialog, { ...n });
    case DialogType.SCRIPT_COMPILE_ERROR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ScriptCompileErrorDialog, { ...n });
    case DialogType.THEME_CREATOR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeCreatorDialog, { ...n });
    case DialogType.WARNING:
    case DialogType.CONNECTION_ERROR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(WarningDialog, { ...n });
    case DialogType.DEPLOY_DIALOG:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DeployDialog, { ...n });
    case DialogType.DEPLOY_ERROR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DeployErrorDialog, { ...n });
    case void 0:
      return noDialog(n);
    default:
      return typeNotRecognizedDialog(n);
  }
}
function AboutDialog(n) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: n.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "About" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: n.aboutSectionMd && /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: n.aboutSectionMd, allowHTML: !1 }) })
  ] });
}
function ClearCacheDialog(n) {
  const g = ["**Are you sure you want to clear the app's function caches?**", "This will remove all cached entries from functions using", "`@st.cache_data` and `@st.cache_resource`."].join(`  
`);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "stClearCacheDialog", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: n.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Clear caches" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: g, allowHTML: !1 }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalFooter, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.GHOST, onClick: n.onClose, children: "Cancel" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { autoFocus: !0, kind: BaseButtonKind.SECONDARY, onClick: n.confirmCallback, children: "Clear caches" })
    ] })
  ] }) });
}
function ScriptCompileErrorDialog(n) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: n.onClose, size: "auto", autoFocus: !1, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Script execution error" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitSyntaxHighlighter$2, { showLineNumbers: !1, wrapLines: !1, children: n.exception?.message ? n.exception.message : "No message" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: n.onClose, children: "Close" }) })
  ] });
}
function WarningDialog(n) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: n.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: n.title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: n.msg })
  ] });
}
function DeployErrorDialog({
  title: n,
  msg: t,
  onClose: g,
  onContinue: d,
  onTryAgain: k
}) {
  const H = () => {
    g(), d && d();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: g, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: n }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDeployErrorContent, { children: t }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalFooter, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.GHOST, onClick: k, children: "Try again" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: H, children: d ? "Continue anyway" : "Close" })
    ] })
  ] });
}
function noDialog({
  onClose: n
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { isOpen: !1, onClose: n });
}
function typeNotRecognizedDialog(n) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { isOpen: !0, onClose: n.onClose, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: `Dialog type "${n.type}" not recognized.` }) });
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledActionButtonContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e3g6aar2"
} : {
  target: "e3g6aar2",
  label: "StyledActionButtonContainer"
})(({
  theme: n
}) => ({
  display: "flex",
  gap: n.spacing.sm,
  alignItems: "center",
  // line height should be the same as the icon size
  lineHeight: n.iconSizes.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9Ub29sYmFyQWN0aW9ucy9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQjJDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9Ub29sYmFyQWN0aW9ucy9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkQWN0aW9uQnV0dG9uQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAvLyBsaW5lIGhlaWdodCBzaG91bGQgYmUgdGhlIHNhbWUgYXMgdGhlIGljb24gc2l6ZVxuICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG59KSlcblxuZXhwb3J0IGludGVyZmFjZSBTdHlsZWRBY3Rpb25CdXR0b25JY29uUHJvcHMge1xuICBpY29uOiBzdHJpbmdcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZEFjdGlvbkJ1dHRvbkljb24gPSBzdHlsZWQuZGl2PFN0eWxlZEFjdGlvbkJ1dHRvbkljb25Qcm9wcz4oXG4gICh7IHRoZW1lLCBpY29uIH0pID0+ICh7XG4gICAgYmFja2dyb3VuZDogYHVybChcIiR7aWNvbn1cIikgbm8tcmVwZWF0IGNlbnRlciAvIGNvbnRhaW5gLFxuICAgIHdpZHRoOiB0aGVtZS5pY29uU2l6ZXMuYmFzZSxcbiAgICBoZWlnaHQ6IHRoZW1lLmljb25TaXplcy5iYXNlLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbGJhckFjdGlvbnMgPSBzdHlsZWQuZGl2KHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG59KVxuIl19 */"), StyledActionButtonIcon = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e3g6aar1"
} : {
  target: "e3g6aar1",
  label: "StyledActionButtonIcon"
})(({
  theme: n,
  icon: t
}) => ({
  background: `url("${t}") no-repeat center / contain`,
  width: n.iconSizes.base,
  height: n.iconSizes.base
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledToolbarActions = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e3g6aar0"
} : {
  target: "e3g6aar0",
  label: "StyledToolbarActions"
})(process.env.NODE_ENV === "production" ? {
  name: "ye2gio",
  styles: "display:flex;align-items:center;flex-direction:row"
} : {
  name: "ye2gio",
  styles: "display:flex;align-items:center;flex-direction:row/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
function ActionButton({
  label: n,
  icon: t,
  onClick: g
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stToolbarActionButton", "data-testid": "stToolbarActionButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: g, kind: BaseButtonKind.HEADER_BUTTON, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledActionButtonContainer, { children: [
    t && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledActionButtonIcon, { "data-testid": "stToolbarActionButtonIcon", icon: t }),
    n && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "data-testid": "stToolbarActionButtonLabel", children: n })
  ] }) }) });
}
function ToolbarActions({
  sendMessageToHost: n,
  hostToolbarItems: t,
  metricsMgr: g
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledToolbarActions, { className: "stToolbarActions", "data-testid": "stToolbarActions", children: t.map(({
    key: d,
    label: k,
    icon: H
  }) => /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton, { label: k, icon: H, onClick: () => {
    g.enqueue("menuClick", {
      label: d
    }), n({
      type: "TOOLBAR_ITEM_CALLBACK",
      key: d
    });
  } }, d)) });
}
const screencastCounterAnimation = keyframes`
0% {
  opacity: 0;
}
25% {
  opacity: 1;
}
100% {
  opacity: 0;
}`, StyledCountdown = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e7qru6u0"
} : {
  target: "e7qru6u0",
  label: "StyledCountdown"
})(({
  theme: n
}) => ({
  position: "fixed",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  top: 0,
  left: 0,
  width: n.sizes.full,
  height: n.sizes.full,
  fontSize: "40vh",
  color: n.colors.redTextColor,
  fontWeight: n.fontWeights.bold,
  opacity: "0.8",
  textShadow: `1px 1px 10px ${n.colors.grayTextColor}`,
  transition: "opacity 0.3s ease-in-out",
  animation: `${screencastCounterAnimation} 1s`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Countdown = ({
  countdown: n,
  endCallback: t
}) => {
  const [g, d] = useState(n), k = () => {
    const H = g - 1;
    H >= 0 && d(H), H === 0 && t();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCountdown, { "data-testid": "stCountdown", onAnimationEnd: k, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: g }) }, `frame${g}`);
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledRecordAudioLabel = /* @__PURE__ */ createStyled$1("label", process.env.NODE_ENV === "production" ? {
  target: "emfz9mr1"
} : {
  target: "emfz9mr1",
  label: "StyledRecordAudioLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1NjcmVlbmNhc3REaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JzQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2hvY3Mvd2l0aFNjcmVlbmNhc3QvY29tcG9uZW50cy9TY3JlZW5jYXN0RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRSZWNvcmRBdWRpb0xhYmVsID0gc3R5bGVkLmxhYmVsKHtcbiAgbWFyZ2luOiAwLFxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEluc3RydWN0aW9uID0gc3R5bGVkLnAoe1xuICBtYXJnaW46IDAsXG59KVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
}), StyledInstruction = /* @__PURE__ */ createStyled$1("p", process.env.NODE_ENV === "production" ? {
  target: "emfz9mr0"
} : {
  target: "emfz9mr0",
  label: "StyledInstruction"
})(process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1NjcmVlbmNhc3REaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBc0JpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2hvY3Mvd2l0aFNjcmVlbmNhc3QvY29tcG9uZW50cy9TY3JlZW5jYXN0RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRSZWNvcmRBdWRpb0xhYmVsID0gc3R5bGVkLmxhYmVsKHtcbiAgbWFyZ2luOiAwLFxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEluc3RydWN0aW9uID0gc3R5bGVkLnAoe1xuICBtYXJnaW46IDAsXG59KVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
}), ScreencastDialog = ({
  onClose: n,
  toggleRecordAudio: t,
  recordAudio: g,
  startRecording: d
}) => {
  const [k, H] = useState(g), AA = useCallback((IA) => {
    const {
      checked: CA
    } = IA.target;
    CA !== k && (H(CA), t());
  }, [k, t]), gA = useCallback(() => {
    d(), n();
  }, [d, n]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: n, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Record a screencast" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "This will record a video with the contents of your screen, so you can easily share what you're seeing with others." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRecordAudioLabel, { "data-testid": "stScreencastAudioCheckbox", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "checkbox", name: "recordAudio", checked: k, onChange: AA }),
        " ",
        "Also record audio"
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInstruction, { "data-testid": "stScreencastInstruction", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: "Press `Esc` any time to stop recording.", allowHTML: !1 }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: gA, children: "Start recording!" }) })
  ] });
}, StyledVideo = /* @__PURE__ */ createStyled$1("video", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r6"
} : {
  target: "ecutw1r6",
  label: "StyledVideo"
})(({
  theme: n
}) => ({
  width: n.sizes.full,
  borderRadius: n.radii.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDialogContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r5"
} : {
  target: "ecutw1r5",
  label: "StyledDialogContainer"
})(({
  theme: n
}) => ({
  display: "flex",
  flexDirection: "column",
  width: n.sizes.full
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1ZpZGVvUmVjb3JkZWREaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUJxQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2hvY3Mvd2l0aFNjcmVlbmNhc3QvY29tcG9uZW50cy9WaWRlb1JlY29yZGVkRGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjUpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRWaWRlbyA9IHN0eWxlZC52aWRlbygoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogdGhlbWUuc2l6ZXMuZnVsbCxcbiAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5tZCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRGlhbG9nQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgd2lkdGg6IHRoZW1lLnNpemVzLmZ1bGwsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFJvdyA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gIHBhZGRpbmdUb3A6IHRoZW1lLnNwYWNpbmcubWQsXG4gIHBhZGRpbmdCb3R0b206IHRoZW1lLnNwYWNpbmcubWQsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEZpcnN0Q29sdW1uID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nUmlnaHQ6IHRoZW1lLnNwYWNpbmcubGcsXG4gIHRleHRBbGlnbjogXCJyaWdodFwiLFxuICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXlUZXh0Q29sb3IsXG4gIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLmJvbGQsXG4gIHdpZHRoOiBcIjZlbVwiLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWNvbmRDb2x1bW4gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGZsZXg6IDEsXG4gIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5sZyxcbiAgbWFyZ2luUmlnaHQ6IFwiNmVtXCIsXG4gIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMuc219KWBdOiB7XG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVmlkZW9Gb3JtYXRJbnN0cnVjdGlvbnMgPSBzdHlsZWQucCgoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcuc20sXG4gIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5ub25lLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb3dubG9hZEJ1dHRvbkNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxufSkpXG4iXX0= */"), StyledRow = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r4"
} : {
  target: "ecutw1r4",
  label: "StyledRow"
})(({
  theme: n
}) => ({
  display: "flex",
  flexDirection: "row",
  paddingTop: n.spacing.md,
  paddingBottom: n.spacing.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledFirstColumn = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r3"
} : {
  target: "ecutw1r3",
  label: "StyledFirstColumn"
})(({
  theme: n
}) => ({
  paddingRight: n.spacing.lg,
  textAlign: "right",
  color: n.colors.grayTextColor,
  fontWeight: n.fontWeights.bold,
  width: "6em"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSecondColumn = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r2"
} : {
  target: "ecutw1r2",
  label: "StyledSecondColumn"
})(({
  theme: n
}) => ({
  flex: 1,
  paddingRight: n.spacing.lg,
  marginRight: "6em",
  [`@media (max-width: ${n.breakpoints.sm})`]: {
    marginRight: n.spacing.none
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledVideoFormatInstructions = /* @__PURE__ */ createStyled$1("p", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r1"
} : {
  target: "ecutw1r1",
  label: "StyledVideoFormatInstructions"
})(({
  theme: n
}) => ({
  marginTop: n.spacing.sm,
  marginBottom: n.spacing.none,
  fontSize: n.fontSizes.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDownloadButtonContainer = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r0"
} : {
  target: "ecutw1r0",
  label: "StyledDownloadButtonContainer"
})(({
  theme: n
}) => ({
  marginTop: n.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), VideoRecordedDialog = ({
  onClose: n,
  videoBlob: t,
  fileName: g
}) => {
  const d = URL.createObjectURL(t), k = () => {
    const H = document.createElement("a");
    H.setAttribute("href", d), H.setAttribute("download", `${g}.webm`), H.click(), n();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: n, overrides: {
    Dialog: {
      style: {
        width: "80vw"
      }
    }
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Next steps" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDialogContainer, { "data-testid": "stVideoRecordedDialog", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFirstColumn, { children: "Step 1" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSecondColumn, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Preview your video below:" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledVideo, { src: d, controls: !0 })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFirstColumn, { children: "Step 2" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSecondColumn, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDownloadButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.SECONDARY, onClick: k, children: "Save video to disk" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledVideoFormatInstructions, { children: [
            "This video is encoded in the",
            " ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://www.webmproject.org/", children: "WebM format" }),
            ", which is only supported by newer video players. You can also play it by dragging the file directly into your browser."
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFirstColumn, { children: "Step 3" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSecondColumn, { children: [
          "Share your video with the world on Twitter, LinkedIn, YouTube, or just plain email!",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { role: "img", "aria-label": "Happy", children: "😀" })
        ] })
      ] })
    ] }) })
  ] });
};
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledScreenCastWarningDialog = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e16i1uly2"
} : {
  target: "e16i1uly2",
  label: "StyledScreenCastWarningDialog"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1Vuc3VwcG9ydGVkQnJvd3NlckRpYWxvZy9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQjZDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1Vuc3VwcG9ydGVkQnJvd3NlckRpYWxvZy9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2NyZWVuQ2FzdFdhcm5pbmdEaWFsb2cgPSBzdHlsZWQuZGl2KHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVW5zdXBwb3J0ZWRTY3JlZW5DYXN0SWNvbiA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlJdGVtczogXCJjZW50ZXJcIixcbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudHdvWEwsXG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuZm91clhMLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRVbnN1cHBvcnRlZFNjcmVlbkNhc3RFeHBsYW5hdGlvbiA9IHN0eWxlZC5wKFxuICAoeyB0aGVtZSB9KSA9PiAoe1xuICAgIG1hcmdpbjogdGhlbWUuc3BhY2luZy5ub25lLFxuICB9KVxuKVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
}), StyledUnsupportedScreenCastIcon = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "e16i1uly1"
} : {
  target: "e16i1uly1",
  label: "StyledUnsupportedScreenCastIcon"
})(({
  theme: n
}) => ({
  display: "flex",
  alignItems: "center",
  justifyItems: "center",
  marginRight: n.spacing.twoXL,
  marginLeft: n.spacing.sm,
  fontSize: n.fontSizes.fourXL
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1Vuc3VwcG9ydGVkQnJvd3NlckRpYWxvZy9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQitDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1Vuc3VwcG9ydGVkQnJvd3NlckRpYWxvZy9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI1KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2NyZWVuQ2FzdFdhcm5pbmdEaWFsb2cgPSBzdHlsZWQuZGl2KHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVW5zdXBwb3J0ZWRTY3JlZW5DYXN0SWNvbiA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlJdGVtczogXCJjZW50ZXJcIixcbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudHdvWEwsXG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuZm91clhMLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRVbnN1cHBvcnRlZFNjcmVlbkNhc3RFeHBsYW5hdGlvbiA9IHN0eWxlZC5wKFxuICAoeyB0aGVtZSB9KSA9PiAoe1xuICAgIG1hcmdpbjogdGhlbWUuc3BhY2luZy5ub25lLFxuICB9KVxuKVxuIl19 */"), StyledUnsupportedScreenCastExplanation = /* @__PURE__ */ createStyled$1("p", process.env.NODE_ENV === "production" ? {
  target: "e16i1uly0"
} : {
  target: "e16i1uly0",
  label: "StyledUnsupportedScreenCastExplanation"
})(({
  theme: n
}) => ({
  margin: n.spacing.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), UnsupportedBrowserDialog = ({
  onClose: n
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: n, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Record a screencast" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledScreenCastWarningDialog, { "data-testid": "stUnsupportedBrowserDialog", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledUnsupportedScreenCastIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { role: "img", "aria-label": "Alien Monster", children: "👾" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledUnsupportedScreenCastExplanation, { children: "Due to limitations with some browsers, this feature is only supported on recent desktop versions of Chrome, Firefox, and Edge." })
  ] }) })
] }), UnsupportedBrowserDialog$1 = memo$1(UnsupportedBrowserDialog), LOG$2 = loglevelExports$1.getLogger("withScreencast");
function withScreencast(n) {
  const t = (g) => {
    const {
      testOverride: d
    } = g, k = useRef(null), [H, AA] = useState("streamlit-screencast"), [gA, IA] = useState(!1), [CA, BA] = useState(void 0), [eA, iA] = useState(d || "OFF"), QA = useCallback(() => {
      IA((cA) => !cA);
    }, []), tA = useCallback(async () => {
      if (!(eA === "OFF" || isNullOrUndefined$1(k.current))) {
        if (eA === "COUNTDOWN") {
          iA("OFF");
          return;
        }
        if (eA === "RECORDING") {
          const cA = k.current;
          if (!cA || cA.getState() === "inactive")
            iA("OFF");
          else {
            const sA = await cA.stop();
            BA(sA), iA("PREVIEW_FILE");
          }
        }
      }
    }, [eA]), oA = useCallback(async () => {
      if (!ScreenCastRecorder.isSupportedBrowser()) {
        iA("UNSUPPORTED");
        return;
      }
      k.current = new ScreenCastRecorder({
        recordAudio: gA,
        onErrorOrStop: () => {
          tA().catch((cA) => LOG$2.warn(`withScreencast.stopRecording threw an error: ${cA}`));
        }
      });
      try {
        await k.current.initialize();
      } catch (cA) {
        LOG$2.warn(`ScreenCastRecorder.initialize error: ${cA}`), iA("UNSUPPORTED");
        return;
      }
      iA("COUNTDOWN");
    }, [gA, tA]), EA = useCallback((cA) => {
      if (!ScreenCastRecorder.isSupportedBrowser()) {
        iA("UNSUPPORTED");
        return;
      }
      if (eA === "OFF") {
        AA(cA), iA("SETUP");
        return;
      }
      tA().catch((sA) => LOG$2.warn(`withScreencast.stopRecording threw an error: ${sA}`));
    }, [eA, tA]), aA = useCallback(() => {
      if (isNullOrUndefined$1(k.current))
        throw new Error("Countdown finished but recorder is null");
      k.current.start() ? iA("RECORDING") : tA().catch((sA) => LOG$2.warn(`withScreencast.stopRecording threw an error: ${sA}`));
    }, [tA]), nA = useCallback(() => {
      iA("OFF");
    }, []), lA = {
      currentState: eA,
      toggleRecordAudio: QA,
      startRecording: EA,
      // triggers the setup/showDialog process
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      stopRecording: tA
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "withScreencast", "data-testid": "stScreencast", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(n, { ...g, screenCast: lA }),
      eA === "UNSUPPORTED" && /* @__PURE__ */ jsxRuntimeExports.jsx(UnsupportedBrowserDialog$1, { onClose: nA }),
      eA === "SETUP" && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ScreencastDialog,
        {
          recordAudio: gA,
          onClose: nA,
          startRecording: oA,
          toggleRecordAudio: QA
        }
      ),
      eA === "COUNTDOWN" && /* @__PURE__ */ jsxRuntimeExports.jsx(Countdown, { countdown: 3, endCallback: aA }),
      eA === "PREVIEW_FILE" && CA && /* @__PURE__ */ jsxRuntimeExports.jsx(VideoRecordedDialog, { onClose: nA, videoBlob: CA, fileName: H })
    ] });
  };
  return t.displayName = `withScreencast(${n.displayName || n.name || "Component"})`, hoistNonReactStatics(t, n);
}
const useViewportSize = () => {
  const {
    activeTheme: n
  } = useContext(LibContext), {
    innerWidth: t
  } = useWindowDimensionsContext(), g = parseInt(n.emotion.breakpoints.md, 10);
  return {
    isMobile: t < g
  };
};
var _baseSet, hasRequired_baseSet;
function require_baseSet() {
  if (hasRequired_baseSet) return _baseSet;
  hasRequired_baseSet = 1;
  var n = require_assignValue(), t = require_castPath(), g = require_isIndex(), d = requireIsObject(), k = require_toKey();
  function H(AA, gA, IA, CA) {
    if (!d(AA))
      return AA;
    gA = t(gA, AA);
    for (var BA = -1, eA = gA.length, iA = eA - 1, QA = AA; QA != null && ++BA < eA; ) {
      var tA = k(gA[BA]), oA = IA;
      if (tA === "__proto__" || tA === "constructor" || tA === "prototype")
        return AA;
      if (BA != iA) {
        var EA = QA[tA];
        oA = CA ? CA(EA, tA, QA) : void 0, oA === void 0 && (oA = d(EA) ? EA : g(gA[BA + 1]) ? [] : {});
      }
      n(QA, tA, oA), QA = QA[tA];
    }
    return AA;
  }
  return _baseSet = H, _baseSet;
}
var _basePickBy, hasRequired_basePickBy;
function require_basePickBy() {
  if (hasRequired_basePickBy) return _basePickBy;
  hasRequired_basePickBy = 1;
  var n = require_baseGet(), t = require_baseSet(), g = require_castPath();
  function d(k, H, AA) {
    for (var gA = -1, IA = H.length, CA = {}; ++gA < IA; ) {
      var BA = H[gA], eA = n(k, BA);
      AA(eA, BA) && t(CA, g(BA, k), eA);
    }
    return CA;
  }
  return _basePickBy = d, _basePickBy;
}
var _basePick, hasRequired_basePick;
function require_basePick() {
  if (hasRequired_basePick) return _basePick;
  hasRequired_basePick = 1;
  var n = require_basePickBy(), t = requireHasIn();
  function g(d, k) {
    return n(d, k, function(H, AA) {
      return t(d, AA);
    });
  }
  return _basePick = g, _basePick;
}
var pick_1, hasRequiredPick;
function requirePick() {
  if (hasRequiredPick) return pick_1;
  hasRequiredPick = 1;
  var n = require_basePick(), t = require_flatRest(), g = t(function(d, k) {
    return d == null ? {} : n(d, k);
  });
  return pick_1 = g, pick_1;
}
var pickExports = requirePick();
const pick = /* @__PURE__ */ getDefaultExportFromCjs$2(pickExports), DEFAULT_METRICS_CONFIG = "https://data.streamlit.io/metrics.json", LOG$1 = loglevelExports$1.getLogger("MetricsManager");
class MetricsManager {
  constructor(t) {
    this.initialized = !1, this.actuallySendMetrics = !1, this.metricsUrl = void 0, this.sendMessageToHost = () => {
    }, this.anonymousId = "", this.pendingEvents = [], this.appHash = "Not initialized", this.metadata = {}, this.setAppHash = (g) => {
      this.appHash = g;
    }, this.setMetricsConfig = (g = "") => {
      this.metricsUrl = g;
    }, this.sessionInfo = t;
  }
  async initialize({
    gatherUsageStats: t,
    sendMessageToHost: g
  }) {
    this.sendMessageToHost = g, this.actuallySendMetrics = t && this.metricsUrl !== "off", this.getAnonymousId(), this.actuallySendMetrics && !this.metricsUrl && (await this.requestDefaultMetricsConfig(), this.metricsUrl || (LOG$1.error("Undefined metrics config - deactivating metrics tracking."), this.actuallySendMetrics = !1)), this.actuallySendMetrics && this.sendPendingEvents(), LOG$1.info("Gather usage stats: ", this.actuallySendMetrics), this.initialized = !0;
  }
  enqueue(t, g = {}) {
    if (!this.initialized || !this.sessionInfo.isSet) {
      this.pendingEvents.push([t, g]);
      return;
    }
    this.actuallySendMetrics && (this.pendingEvents.length && this.sendPendingEvents(), this.send(t, g));
  }
  setMetadata(t) {
    this.metadata = t;
  }
  // Fallback - Checks if cached in localStorage, otherwise fetches the config from a default URL
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  async requestDefaultMetricsConfig() {
    const t = localStorageAvailable();
    if (t) {
      const g = window.localStorage.getItem("stMetricsConfig");
      if (g) {
        this.metricsUrl = g;
        return;
      }
    }
    try {
      const g = await fetch(DEFAULT_METRICS_CONFIG, {
        signal: AbortSignal.timeout(5e3)
      });
      if (!g.ok)
        this.metricsUrl = void 0, LOG$1.error("Failed to fetch metrics config: ", g.status);
      else {
        const d = await g.json();
        this.metricsUrl = d.url ?? void 0, t && this.metricsUrl && window.localStorage.setItem("stMetricsConfig", this.metricsUrl);
      }
    } catch (g) {
      LOG$1.error("Failed to fetch metrics config:", g);
    }
  }
  // The schema of metrics events (including key names and value types) should
  // only be changed when requested by the data team. This is why `reportHash`
  // retains its old name.
  send(t, g = {}) {
    const d = this.buildEventProto(t, g);
    IS_DEV_ENV ? LOG$1.info("[Dev mode] Not tracking stat datapoint: ", t, d) : this.metricsUrl === "postMessage" ? this.postMessageEvent(t, d) : this.track(d);
  }
  sendPendingEvents() {
    this.pendingEvents.forEach(([t, g]) => {
      this.send(t, g);
    }), this.pendingEvents = [];
  }
  async track(t) {
    const g = new Request(this.metricsUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(t.toJSON())
    });
    await fetch(g);
  }
  // Helper to send metrics events to host
  postMessageEvent(t, g) {
    this.sendMessageToHost({
      type: "METRICS_EVENT",
      eventName: t,
      data: g
    });
  }
  // Helper to build the event proto
  buildEventProto(t, g) {
    const d = new MetricsEvent({
      event: t,
      anonymousId: this.anonymousId,
      ...this.getHostTrackingData(),
      ...this.getInstallationData(),
      reportHash: this.appHash,
      dev: IS_DEV_ENV,
      source: "browser",
      streamlitVersion: this.sessionInfo.current.streamlitVersion,
      isHello: this.sessionInfo.isHello,
      appId: this.sessionInfo.current.appId,
      sessionId: this.sessionInfo.current.sessionId,
      pythonVersion: this.sessionInfo.current.pythonVersion,
      serverOs: this.sessionInfo.current.serverOS,
      hasDisplay: this.sessionInfo.current.hasDisplay,
      isWebdriver: isWebdriver(),
      ...this.getContextData()
    });
    if (t === "menuClick")
      d.label = g.label;
    else if (t === "pageProfile")
      return new MetricsEvent({
        ...d,
        ...g
      });
    return d;
  }
  // Get the installation IDs from the session
  getInstallationData() {
    return {
      machineIdV3: this.sessionInfo.current.installationIdV3,
      machineIdV4: this.sessionInfo.current.installationIdV4
    };
  }
  // Use the tracking data injected by the host of the app if included.
  getHostTrackingData() {
    return this.metadata ? pick(this.metadata, ["hostedAt", "owner", "repo", "branch", "mainModule", "creatorId"]) : {};
  }
  // Get context data for events
  getContextData() {
    return {
      contextPageUrl: window.location.href,
      contextPageTitle: document.title,
      contextPagePath: window.location.pathname,
      contextPageReferrer: document.referrer,
      contextPageSearch: window.location.search,
      contextLocale: window.navigator.language,
      contextUserAgent: window.navigator.userAgent
    };
  }
  /**
   * Get/Create user's anonymous ID
   * Checks if existing in cookie or localStorage, otherwise generates
   * a new UUID and stores it in both.
   */
  getAnonymousId() {
    if (!this.actuallySendMetrics) return;
    const t = "ajs_anonymous_id", g = localStorageAvailable(), d = getCookie(t), k = g ? window.localStorage.getItem(t) : null, H = /* @__PURE__ */ new Date();
    if (H.setFullYear((/* @__PURE__ */ new Date()).getFullYear() + 1), d)
      this.anonymousId = d, g && window.localStorage.setItem(t, d);
    else if (k) {
      try {
        this.anonymousId = JSON.parse(k);
      } catch {
        this.anonymousId = k;
      }
      setCookie(t, this.anonymousId, H);
    } else
      this.anonymousId = v4(), setCookie(t, this.anonymousId, H), g && window.localStorage.setItem(t, this.anonymousId);
  }
}
function isWebdriver() {
  return window.navigator?.webdriver ?? !1;
}
class SessionEventDispatcher {
  constructor() {
    this.onSessionEvent = new distExports.Signal();
  }
  /** Redispatches a ForwardMsg.SessionEvent via a signal. */
  handleSessionEventMsg(t) {
    this.onSessionEvent.emit(t);
  }
}
const StyledApp = /* @__PURE__ */ createStyled$1("div", process.env.NODE_ENV === "production" ? {
  target: "erw9t6i0"
} : {
  target: "erw9t6i0",
  label: "StyledApp"
})(({
  theme: n
}) => {
  const t = hasLightBackgroundColor(n);
  return {
    position: "absolute",
    background: n.colors.bgColor,
    color: n.colors.bodyText,
    top: n.spacing.none,
    left: n.spacing.none,
    right: n.spacing.none,
    bottom: n.spacing.none,
    colorScheme: t ? "light" : "dark",
    overflow: "hidden",
    "@media print": {
      float: "none",
      height: n.sizes.full,
      position: "static",
      overflow: "visible"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function getBrowserInfo() {
  const t = new UAParser().getResult();
  return {
    browserName: t.browser.name || "Unknown",
    browserVersion: t.browser.version || "Unknown",
    /**
     * 'desktop' is not a valid value for device.type in ua-parser-js.
     * We default to 'desktop' if the value is not present.
     * Possible options from ua-parser-js are:
     * 'mobile', 'tablet', 'smarttv', 'wearable', 'embedded', 'console'
     */
    deviceType: t.device.type || "desktop",
    os: t.os.name || "Unknown"
  };
}
const showDevelopmentOptions = (n, t) => t == Config.ToolbarMode.DEVELOPER ? !0 : Config.ToolbarMode.VIEWER == t || Config.ToolbarMode.MINIMAL == t ? !1 : n || isLocalhost();
function getTitle(n) {
  return n || "Streamlit";
}
class AppNavigation {
  constructor(t, g, d, k) {
    this.hostCommunicationMgr = t, this.onUpdatePageUrl = g, this.onPageNotFound = d, this.onPageIconChange = k, this.isPageIconSet = !1, this.isPageTitleSet = !1, this.mainScriptHash = null, this.appPages = [], this.mainPage = null, this.hideSidebarNav = null;
  }
  handleNewSession(t) {
    return this.isPageTitleSet = !1, this.isPageIconSet = !1, this.mainScriptHash = t.mainScriptHash, this.hideSidebarNav === null && (this.hideSidebarNav = t.config?.hideSidebarNav ?? null), document.title = getTitle(""), [{
      // Set current page script hash to handle SPA case
      currentPageScriptHash: t.pageScriptHash,
      hideSidebarNav: this.hideSidebarNav ?? !1
    }, () => {
    }];
  }
  handleNavigation(t) {
    const {
      sections: g,
      position: d,
      appPages: k
    } = t;
    this.appPages = k, this.hideSidebarNav = d === Navigation.Position.HIDDEN;
    const H = t.pageScriptHash, AA = k.find((CA) => CA.pageScriptHash === H), gA = k.find((CA) => CA.isDefault);
    this.mainPage = gA;
    const IA = AA.urlPathname;
    if (!this.isPageTitleSet) {
      const CA = getTitle(AA.pageName);
      document.title = CA, this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_PAGE_TITLE",
        title: AA.pageName ?? ""
      });
    }
    return !this.isPageIconSet && AA.icon && this.onPageIconChange(AA.icon), this.onUpdatePageUrl(gA.urlPathname ?? "", IA, AA.isDefault ?? !1), [{
      appPages: k,
      navSections: g,
      hideSidebarNav: this.hideSidebarNav,
      expandSidebarNav: t.expanded,
      currentPageScriptHash: H
    }, () => {
      this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_APP_PAGES",
        appPages: k
      }), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_CURRENT_PAGE_NAME",
        // Make sure we don't send the official page name for the main page
        // This command is used to update the URL in the url bar, so the main page
        // should not have a page name in the URL.
        currentPageName: AA.isDefault ? "" : IA,
        currentPageScriptHash: H
      });
    }];
  }
  handlePageNotFound(t) {
    return this.onPageNotFound(t), [{
      currentPageScriptHash: this.mainScriptHash ?? ""
    }, () => {
      this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_CURRENT_PAGE_NAME",
        currentPageName: "",
        currentPageScriptHash: this.mainScriptHash ?? ""
      });
    }];
  }
  findPageByUrlPath(t) {
    return this.appPages.find((g) => (
      // The page name is embedded at the end of the URL path, and if not, we are in the main page.
      // See https://github.com/streamlit/streamlit/blob/1.19.0/frontend/src/App.tsx#L740
      t.endsWith("/" + g.urlPathname)
    )) ?? this.mainPage;
  }
  handlePageConfigChanged(t) {
    this.isPageIconSet = !!t.favicon, this.isPageTitleSet = !!t.title;
  }
  clearPageElements(t, g) {
    return t.filterMainScriptElements(g);
  }
}
const INITIAL_SCRIPT_RUN_ID = "<null>", LOG = loglevelExports$1.getLogger("App"), VI = class VI extends PureComponent {
  constructor(t) {
    super(t), this.sessionInfo = new SessionInfo(), this.metricsMgr = new MetricsManager(this.sessionInfo), this.sessionEventDispatcher = new SessionEventDispatcher(), this.embeddingId = generateUID$2(), this.isInitializingConnectionManager = !0, this.hasReceivedNewSession = !1, this.showDeployError = (d, k, H) => {
      const AA = {
        type: DialogType.DEPLOY_ERROR,
        title: d,
        msg: k,
        onContinue: H,
        onClose: () => {
        },
        onTryAgain: this.sendLoadGitInfoBackMsg
      };
      this.openDialog(AA);
    }, this.handleThemeMessage = (d, k) => {
      const [, H, AA] = createPresetThemes(), gA = isPresetTheme(this.props.theme.activeTheme);
      d === H.name && gA ? this.props.theme.setTheme(H) : d === AA.name && gA ? this.props.theme.setTheme(AA) : k && this.props.theme.setImportedTheme(k);
    }, this.handleConnectionStateChanged = (d) => {
      if (LOG.info(`Connection state changed from ${this.state.connectionState} to ${d}`), d === ConnectionState.CONNECTED) {
        LOG.info("Reconnected to server."), this.state.connectionErrorDismissed && this.setState({
          connectionErrorDismissed: !1
        });
        const k = this.state.scriptRunState === ScriptRunState.RUNNING, H = this.state.scriptRunState === ScriptRunState.RERUN_REQUESTED;
        !this.sessionInfo.last || k || H || // Script is using fragments (fragments in last run or
        // fragment auto-reruns configured):
        this.state.fragmentIdsThisRun.length > 0 || this.state.autoReruns.length > 0 ? (LOG.info("Requesting a script run."), this.widgetMgr.sendUpdateWidgetsMessage(void 0), this.setState({
          dialog: null
        })) : this.state.dialog?.type === DialogType.CONNECTION_ERROR && this.setState({
          dialog: null
        }), this.hostCommunicationMgr.sendMessageToHost({
          type: "WEBSOCKET_CONNECTED"
        });
      } else
        this.state.connectionState === ConnectionState.CONNECTED && this.hostCommunicationMgr.sendMessageToHost({
          type: "WEBSOCKET_DISCONNECTED",
          attemptingToReconnect: d !== ConnectionState.DISCONNECTED_FOREVER
        }), this.sessionInfo.isSet && this.sessionInfo.disconnect();
      this.isInitializingConnectionManager ? this.setState({
        connectionState: d
      }) : flushSync(() => {
        this.setState({
          connectionState: d
        });
      });
    }, this.handleGitInfoChanged = (d) => {
      this.setState({
        gitInfo: d
      });
    }, this.handleCustomParentMessage = (d) => {
      this.state.appConfig.enableCustomParentMessages ? this.hostCommunicationMgr.sendMessageToHost({
        type: "CUSTOM_PARENT_MESSAGE",
        message: d.message
      }) : LOG.error("Sending messages to the host is disabled in line with the platform policy.");
    }, this.handleMessage = (d) => {
      const k = (H, AA, gA) => {
        const IA = H[AA];
        if (IA in gA)
          return gA[IA](H[IA]);
        throw new Error(`Cannot handle ${AA} "${IA}".`);
      };
      try {
        k(d, "type", {
          newSession: (H) => this.handleNewSession(H),
          sessionStatusChanged: (H) => this.handleSessionStatusChanged(H),
          sessionEvent: (H) => this.handleSessionEvent(H),
          delta: (H) => this.handleDeltaMsg(H, d.metadata),
          pageConfigChanged: (H) => this.handlePageConfigChanged(H),
          pageInfoChanged: (H) => this.handlePageInfoChanged(H),
          // Deprecated protobuf option as navigation will always inform us of pages
          pagesChanged: (H) => {
          },
          pageNotFound: (H) => this.handlePageNotFound(H),
          gitInfoChanged: (H) => this.handleGitInfoChanged(H),
          scriptFinished: (H) => this.handleScriptFinished(H),
          pageProfile: (H) => this.handlePageProfileMsg(H),
          autoRerun: (H) => this.handleAutoRerun(H),
          fileUrlsResponse: (H) => this.uploadClient.onFileURLsResponse(H),
          parentMessage: (H) => this.handleCustomParentMessage(H),
          logo: (H) => this.handleLogo(H, d.metadata),
          navigation: (H) => this.handleNavigation(H),
          authRedirect: (H) => {
            isInChildFrame() ? this.hostCommunicationMgr.sendMessageToSameOriginHost({
              type: "REDIRECT_TO_URL",
              url: H.url
            }) : window.location.href = H.url;
          }
        });
      } catch (H) {
        const AA = ensureError(H);
        LOG.error(AA), this.showError("Bad message format", AA.message);
      }
    }, this.handleLogo = (d, k) => {
      this.setState((H) => ({
        elements: H.elements.appRootWithLogo(d, {
          // Pass the current page & run ID for cleanup
          activeScriptHash: k.activeScriptHash,
          scriptRunId: H.scriptRunId
        })
      }));
    }, this.handlePageConfigChanged = (d) => {
      const {
        title: k,
        favicon: H,
        layout: AA,
        initialSidebarState: gA,
        menuItems: IA
      } = d;
      this.appNavigation.handlePageConfigChanged(d), k && (this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_PAGE_TITLE",
        title: k
      }), document.title = k), H && this.onPageIconChanged(H), AA !== this.state.layout && AA !== PageConfig.Layout.LAYOUT_UNSET && this.setState((CA) => ({
        layout: AA,
        userSettings: {
          ...CA.userSettings,
          wideMode: AA === PageConfig.Layout.WIDE
        }
      })), gA !== this.state.initialSidebarState && gA !== PageConfig.SidebarState.SIDEBAR_UNSET && this.setState(() => ({
        initialSidebarState: gA
      })), IA && this.setState((CA) => (IA.clearAboutMd && (IA.aboutSectionMd = ""), {
        menuItems: {
          ...CA.menuItems,
          ...IA
        }
      }));
    }, this.handlePageInfoChanged = (d) => {
      const {
        queryString: k
      } = d, H = document.location.pathname + (k ? `?${k}` : "");
      window.history.pushState({}, "", H), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_QUERY_PARAM",
        queryParams: k ? `?${k}` : ""
      });
    }, this.onPageNotFound = (d) => {
      const k = d ? `You have requested page /${d}, but no corresponding file was found in the app's pages/ directory` : "The page that you have requested does not seem to exist";
      this.showError("Page not found", `${k}. Running the app's main page.`);
    }, this.handlePageNotFound = (d) => {
      const {
        pageName: k
      } = d;
      this.maybeSetState(this.appNavigation.handlePageNotFound(k));
    }, this.onPageIconChanged = (d) => {
      handleFavicon(d, this.hostCommunicationMgr.sendMessageToHost, this.endpoints);
    }, this.handleNavigation = (d) => {
      this.setState({
        navigationPosition: d.position
      }), this.maybeSetState(this.appNavigation.handleNavigation(d));
    }, this.handlePageProfileMsg = (d) => {
      const k = PageProfile.toObject(d), H = getBrowserInfo();
      this.metricsMgr.enqueue("pageProfile", {
        ...k,
        isFragmentRun: !!k.isFragmentRun,
        numPages: this.state.appPages?.length,
        pageScriptHash: this.state.currentPageScriptHash,
        activeTheme: this.props.theme?.activeTheme?.name,
        totalLoadTime: Math.round((performance.now() - this.state.latestRunTime) * 1e3),
        browserInfo: H
      });
    }, this.handleAutoRerun = (d) => {
      const k = setInterval(() => {
        this.widgetMgr.sendUpdateWidgetsMessage(d.fragmentId, !0);
      }, d.interval * 1e3);
      this.setState((H) => ({
        autoReruns: [...H.autoReruns, k]
      }));
    }, this.handleSessionStatusChanged = (d) => {
      this.setState((k) => {
        let {
          scriptRunState: H
        } = k, {
          dialog: AA
        } = k;
        return d.scriptIsRunning && k.scriptRunState !== ScriptRunState.STOP_REQUESTED ? (H = ScriptRunState.RUNNING, notNullOrUndefined(AA) && AA.type === DialogType.SCRIPT_COMPILE_ERROR && (AA = void 0)) : !d.scriptIsRunning && k.scriptRunState !== ScriptRunState.RERUN_REQUESTED && k.scriptRunState !== ScriptRunState.COMPILATION_ERROR && (H = ScriptRunState.NOT_RUNNING), {
          userSettings: {
            ...k.userSettings,
            runOnSave: !!d.runOnSave
          },
          dialog: AA,
          scriptRunState: H,
          // Reset scriptChangedOnDisk when script starts running
          scriptChangedOnDisk: d.scriptIsRunning ? !1 : k.scriptChangedOnDisk
        };
      });
    }, this.handleSessionEvent = (d) => {
      if (this.sessionEventDispatcher.handleSessionEventMsg(d), d.type === "scriptCompilationException") {
        this.setState({
          scriptRunState: ScriptRunState.COMPILATION_ERROR
        });
        const k = {
          type: DialogType.SCRIPT_COMPILE_ERROR,
          exception: d.scriptCompilationException,
          onClose: () => {
          }
        };
        this.maybeShowErrorDialog(k, d.scriptCompilationException?.message ?? "No message");
      } else d.type === "scriptChangedOnDisk" && this.setState({
        scriptChangedOnDisk: !0
      });
    }, this.maybeUpdatePageUrl = (d, k, H) => {
      const AA = this.getBaseUriParts();
      if (AA) {
        let gA;
        window.__streamlit?.MAIN_PAGE_BASE_URL ? gA = parseUriIntoBaseParts(window.__streamlit.MAIN_PAGE_BASE_URL).pathname : gA = AA.pathname;
        const IA = extractPageNameFromPathName(document.location.pathname, gA);
        if ((IA === "" ? d : IA) !== k) {
          const BA = H ? "" : k, eA = preserveEmbedQueryParams(), iA = eA ? `?${eA}` : "", tA = `${gA === "/" ? "" : gA}/${BA}${iA}`, oA = tA.endsWith("/") && tA !== "/" ? tA.slice(0, -1) : tA;
          window.history.pushState({}, "", oA);
        }
      }
    }, this.handleNewSession = (d) => {
      const k = d.initialize;
      if (this.hasStreamlitVersionChanged(k)) {
        window.location.reload();
        return;
      }
      this.hasReceivedNewSession = !0, (!this.sessionInfo.isSet || !this.sessionInfo.current.isConnected) && this.handleInitialization(d);
      const {
        appHash: H,
        currentPageScriptHash: AA
      } = this.state, {
        scriptRunId: gA,
        name: IA,
        mainScriptPath: CA,
        fragmentIdsThisRun: BA,
        pageScriptHash: eA,
        mainScriptHash: iA
      } = d;
      if (BA.length)
        this.setState({
          fragmentIdsThisRun: BA,
          latestRunTime: performance.now()
        });
      else {
        this.cleanupAutoReruns();
        const tA = d.config, oA = d.customTheme;
        this.processThemeInput(oA), this.setState({
          allowRunOnSave: tA.allowRunOnSave,
          hideTopBar: tA.hideTopBar,
          toolbarMode: tA.toolbarMode,
          latestRunTime: performance.now(),
          mainScriptHash: iA,
          // If we're here, the fragmentIdsThisRun variable is always the
          // empty array.
          fragmentIdsThisRun: BA
        }), this.maybeSetState(this.appNavigation.handleNewSession(d)), this.onPageIconChanged("./favicon.png");
      }
      const QA = hashString(this.sessionInfo.current.installationId + CA);
      this.metricsMgr.setMetadata(this.state.deployedAppMetadata), this.metricsMgr.setAppHash(QA), this.metricsMgr.enqueue("updateReport"), H === QA && AA === eA ? this.setState({
        scriptRunId: gA
      }) : this.clearAppState(QA, gA, IA, iA);
    }, this.handleInitialization = (d) => {
      const k = d.initialize, H = d.config;
      this.sessionInfo.setCurrent(SessionInfo.propsFromNewSessionMessage(d)), this.metricsMgr.initialize({
        gatherUsageStats: H.gatherUsageStats,
        sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost
      }), this.handleSessionStatusChanged(k.sessionStatus);
    }, this.onHistoryChange = () => {
      const {
        currentPageScriptHash: d
      } = this.state, k = this.appNavigation.findPageByUrlPath(document.location.pathname), H = document.location.toString().includes("#"), AA = k?.pageScriptHash === d;
      isNullOrUndefined$1(k) || H && AA || this.onPageChange(k.pageScriptHash);
    }, this.setAndSendTheme = (d) => {
      this.props.theme.setTheme(d), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_THEME_CONFIG",
        themeInfo: toExportedTheme(d.emotion)
      });
    }, this.createThemeHash = (d) => d ? hashString(JSON.stringify(d, Object.keys(d).sort())) : "hash_for_undefined_custom_theme", this.closeDialog = () => {
      this.state.dialog?.type === DialogType.CONNECTION_ERROR ? this.setState({
        dialog: void 0,
        connectionErrorDismissed: !0
      }) : this.setState({
        dialog: void 0
      });
    }, this.saveSettings = (d) => {
      const {
        runOnSave: k
      } = this.state.userSettings, {
        runOnSave: H
      } = d;
      if (this.setState({
        userSettings: d
      }), k !== H && this.isServerConnected()) {
        const AA = new BackMsg({
          setRunOnSave: H
        });
        AA.type = "setRunOnSave", this.sendBackMsg(AA);
      }
    }, this.handleDeltaMsg = (d, k) => {
      this.setState((H) => ({
        elements: H.elements.applyDelta(H.scriptRunId, d, k)
      }));
    }, this.debugShutdownRuntime = () => {
      if (this.isServerConnected()) {
        const d = new BackMsg({
          debugShutdownRuntime: !0
        });
        d.type = "debugShutdownRuntime", this.sendBackMsg(d);
      }
    }, this.debugDisconnectWebsocket = () => {
      if (this.isServerConnected()) {
        const d = new BackMsg({
          debugDisconnectWebsocket: !0
        });
        d.type = "debugDisconnectWebsocket", this.sendBackMsg(d);
      }
    }, this.debugClearForwardMsgCache = () => {
      isLocalhost() && this.connectionManager?.websocketConnection?.cache.messages.clear();
    }, this.cleanupAutoReruns = () => {
      this.state.autoReruns.forEach((d) => {
        clearInterval(d);
      }), this.setState({
        autoReruns: []
      });
    }, this.rerunScript = (d = !1) => {
      if (this.closeDialog(), !this.isServerConnected()) {
        LOG.error("Cannot rerun script when disconnected from server.");
        return;
      }
      this.state.scriptRunState === ScriptRunState.RUNNING || this.state.scriptRunState === ScriptRunState.RERUN_REQUESTED || (this.setState({
        scriptRunState: ScriptRunState.RERUN_REQUESTED
      }), d === !0 && this.saveSettings({
        ...this.state.userSettings,
        runOnSave: !0
      }), this.widgetMgr.sendUpdateWidgetsMessage(void 0));
    }, this.sendLoadGitInfoBackMsg = () => {
      if (!this.isServerConnected()) {
        LOG.error("Cannot load git information when disconnected from server.");
        return;
      }
      this.sendBackMsg(new BackMsg({
        loadGitInfo: !0
      }));
    }, this.onPageChange = (d) => {
      const {
        elements: k,
        mainScriptHash: H
      } = this.state;
      this.cleanupAutoReruns();
      const AA = this.appNavigation.clearPageElements(k, H), gA = new Set(Array.from(AA.getElements()).map((IA) => getElementId(IA)).filter(notUndefined));
      this.sendRerunBackMsg(this.widgetMgr.getActiveWidgetStates(gA), void 0, d);
    }, this.isAppInReadyState = (d) => this.state.connectionState === ConnectionState.CONNECTED && this.state.scriptRunState === ScriptRunState.NOT_RUNNING && d.scriptRunState === ScriptRunState.RUNNING && d.connectionState === ConnectionState.CONNECTED, this.sendRerunBackMsg = (d, k, H, AA) => {
      const gA = this.getBaseUriParts();
      if (!gA) {
        LOG.error("Cannot send rerun backMessage when disconnected from server.");
        return;
      }
      const {
        currentPageScriptHash: IA
      } = this.state;
      let CA = this.getQueryString(), BA = "";
      const eA = {
        timezone: getTimezone$1(),
        timezoneOffset: getTimezoneOffset(),
        locale: getLocaleLanguage(),
        url: getUrl(),
        isEmbedded: isEmbed(),
        colorScheme: this.getThemeColorScheme()
      };
      if (H)
        H != IA && (CA = preserveEmbedQueryParams(), this.hostCommunicationMgr.sendMessageToHost({
          type: "SET_QUERY_PARAM",
          queryParams: CA
        }));
      else if (IA)
        H = IA;
      else {
        let QA;
        window.__streamlit?.MAIN_PAGE_BASE_URL ? QA = parseUriIntoBaseParts(window.__streamlit.MAIN_PAGE_BASE_URL).pathname : QA = gA.pathname, BA = extractPageNameFromPathName(document.location.pathname, QA), H = "";
      }
      const iA = this.connectionManager?.getCachedMessageHashes() ?? [];
      this.sendBackMsg(new BackMsg({
        rerunScript: {
          queryString: CA,
          widgetStates: d,
          pageScriptHash: H,
          pageName: BA,
          fragmentId: k,
          isAutoRerun: AA,
          cachedMessageHashes: iA,
          contextInfo: eA
        }
      })), this.hasReceivedNewSession = !1;
    }, this.stopScript = () => {
      if (!this.isServerConnected()) {
        LOG.error("Cannot stop app when disconnected from server.");
        return;
      }
      if (this.state.scriptRunState === ScriptRunState.NOT_RUNNING || this.state.scriptRunState === ScriptRunState.STOP_REQUESTED)
        return;
      const d = new BackMsg({
        stopScript: !0
      });
      d.type = "stopScript", this.sendBackMsg(d), this.setState({
        scriptRunState: ScriptRunState.STOP_REQUESTED
      });
    }, this.openClearCacheDialog = () => {
      if (this.isServerConnected()) {
        const d = {
          type: DialogType.CLEAR_CACHE,
          confirmCallback: this.clearCache,
          defaultAction: this.clearCache,
          onClose: () => {
          }
        };
        this.openDialog(d);
      } else
        LOG.error("Cannot clear cache: disconnected from server");
    }, this.openDeployDialog = () => {
      const d = {
        type: DialogType.DEPLOY_DIALOG,
        onClose: this.closeDialog,
        showDeployError: this.showDeployError,
        isDeployErrorModalOpen: this.state.dialog?.type === DialogType.DEPLOY_ERROR,
        metricsMgr: this.metricsMgr
      };
      this.openDialog(d);
    }, this.openThemeCreatorDialog = () => {
      this.metricsMgr.enqueue("menuClick", {
        label: "editTheme"
      });
      const d = {
        type: DialogType.THEME_CREATOR,
        backToSettings: this.settingsCallback,
        onClose: this.closeDialog,
        metricsMgr: this.metricsMgr
      };
      this.openDialog(d);
    }, this.clearCache = () => {
      if (this.closeDialog(), this.isServerConnected()) {
        const d = new BackMsg({
          clearCache: !0
        });
        d.type = "clearCache", this.sendBackMsg(d);
      } else
        LOG.error("Cannot clear cache: disconnected from server");
    }, this.sendAppHeartbeat = () => {
      if (this.isServerConnected()) {
        const d = new BackMsg({
          appHeartbeat: !0
        });
        d.type = "appHeartbeat", this.sendBackMsg(d);
      } else
        LOG.error("Cannot send app heartbeat: disconnected from server");
    }, this.sendBackMsg = (d) => {
      this.connectionManager ? (LOG.info(d), this.connectionManager.sendMessage(d)) : LOG.error(`Not connected. Cannot send back message: ${d}`);
    }, this.handleConnectionError = (d) => {
      this.state.connectionErrorDismissed || this.showError("Connection error", d, DialogType.CONNECTION_ERROR);
    }, this.isServerConnected = () => this.connectionManager ? this.connectionManager.isConnected() : !1, this.settingsCallback = (d = !0) => {
      const k = {
        type: DialogType.SETTINGS,
        sessionInfo: this.sessionInfo,
        isServerConnected: this.isServerConnected(),
        settings: this.state.userSettings,
        allowRunOnSave: this.state.allowRunOnSave,
        onSave: this.saveSettings,
        onClose: () => {
        },
        developerMode: showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode),
        openThemeCreator: this.openThemeCreatorDialog,
        animateModal: d,
        metricsMgr: this.metricsMgr
      };
      this.openDialog(k);
    }, this.aboutCallback = () => {
      const {
        menuItems: d
      } = this.state, k = {
        type: DialogType.ABOUT,
        onClose: this.closeDialog,
        aboutSectionMd: d?.aboutSectionMd
      };
      this.openDialog(k);
    }, this.printCallback = () => {
      const {
        scriptRunState: d
      } = this.state;
      if (d !== ScriptRunState.NOT_RUNNING) {
        setTimeout(this.printCallback, 500);
        return;
      }
      let k;
      try {
        const H = getIFrameEnclosingApp(this.embeddingId);
        H?.contentWindow ? k = H.contentWindow.window : k = window;
      } catch {
        k = window;
      } finally {
        k || (k = window), k.print();
      }
    }, this.screencastCallback = () => {
      const {
        scriptName: d
      } = this.state, {
        startRecording: k
      } = this.props.screenCast, H = hooks().format("YYYY-MM-DD-HH-MM-SS");
      k(`streamlit-${d}-${H}`);
    }, this.handleFullScreen = (d) => {
      this.setState({
        isFullScreen: d
      });
    }, this.setLibConfig = (d) => {
      this.setState({
        libConfig: d
      });
    }, this.setAppConfig = (d) => {
      this.setState({
        appConfig: d
      });
    }, this.addScriptFinishedHandler = (d) => {
      this.setState((k, H) => ({
        scriptFinishedHandlers: k.scriptFinishedHandlers.concat(d)
      }));
    }, this.removeScriptFinishedHandler = (d) => {
      this.setState((k, H) => ({
        scriptFinishedHandlers: without(k.scriptFinishedHandlers, d)
      }));
    }, this.getBaseUriParts = () => this.connectionManager ? this.connectionManager.getBaseUriParts() : void 0, this.getQueryString = () => {
      const {
        queryParams: d
      } = this.state, k = d && d.length > 0 ? d : document.location.search;
      return k.startsWith("?") ? k.substring(1) : k;
    }, this.getThemeColorScheme = () => {
      const {
        activeTheme: d
      } = this.props.theme;
      return hasLightBackgroundColor(d.emotion) ? "light" : "dark";
    }, this.isInCloudEnvironment = () => {
      const {
        hostMenuItems: d
      } = this.state;
      return d && d?.length > 0;
    }, this.showDeployButton = () => showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode) && !this.isInCloudEnvironment() && this.sessionInfo.isSet && !this.sessionInfo.isHello, this.deployButtonClicked = () => {
      this.metricsMgr.enqueue("menuClick", {
        label: "deployButtonInApp"
      }), this.sendLoadGitInfoBackMsg(), this.openDeployDialog();
    }, this.requestFileURLs = (d, k) => {
      const H = this.isServerConnected(), AA = this.sessionInfo.isSet;
      if (H && AA) {
        const gA = new BackMsg({
          fileUrlsRequest: {
            requestId: d,
            fileNames: k.map((IA) => IA.name),
            sessionId: this.sessionInfo.current.sessionId
          }
        });
        gA.type = "fileUrlsRequest", this.sendBackMsg(gA);
      } else
        LOG.warn(`Cannot request file URLs (isServerConnected: ${H}, isSessionInfoSet: ${AA})`);
    }, this.handleKeyDown = (d) => {
      switch (d) {
        case "c":
          showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode) && this.openClearCacheDialog();
          break;
        case "r":
          this.rerunScript();
          break;
      }
    }, this.handleKeyUp = (d) => {
      d === "esc" && this.props.screenCast.stopRecording();
    }, this.hasAppDefinedMenuItems = () => {
      const {
        menuItems: d
      } = this.state;
      return !!(d?.aboutSectionMd || d?.getHelpUrl && !d?.hideGetHelp || d?.reportABugUrl && !d?.hideReportABug);
    }, this.shouldShowToolbar = (d, k) => {
      const H = !isEmbed() || isToolbarDisplayed();
      let AA;
      return this.state.toolbarMode === Config.ToolbarMode.MINIMAL ? AA = d.length > 0 || k.length > 0 || this.hasAppDefinedMenuItems() : AA = !0, H && AA;
    }, enablePatches(), enableMapSet();
    let g = this.createThemeHash();
    isPresetTheme(t.theme.activeTheme) || (g = this.createThemeHash(toThemeInput(t.theme.activeTheme.emotion))), this.state = {
      connectionState: ConnectionState.INITIAL,
      elements: AppRoot.empty("", !0),
      // Blank Main Script Hash for initial render
      isFullScreen: !1,
      scriptName: "",
      scriptRunId: INITIAL_SCRIPT_RUN_ID,
      appHash: null,
      scriptRunState: ScriptRunState.NOT_RUNNING,
      userSettings: {
        wideMode: !1,
        runOnSave: !1
      },
      connectionErrorDismissed: !1,
      layout: PageConfig.Layout.CENTERED,
      initialSidebarState: PageConfig.SidebarState.AUTO,
      menuItems: void 0,
      allowRunOnSave: !0,
      scriptFinishedHandlers: [],
      themeHash: g,
      gitInfo: null,
      formsData: createFormsData(),
      appPages: [],
      navSections: [],
      currentPageScriptHash: "",
      mainScriptHash: "",
      // We set hideTopBar to true by default because this information isn't
      // available on page load (we get it when the script begins to run), so
      // the user would see top bar elements for a few ms if this defaulted to
      // false. hideSidebarNav doesn't have this issue (app pages and the value
      // of the config option are received simultaneously), but we set it to
      // true as well for consistency.
      hideTopBar: !0,
      hideSidebarNav: !0,
      expandSidebarNav: !1,
      toolbarMode: Config.ToolbarMode.MINIMAL,
      latestRunTime: performance.now(),
      fragmentIdsThisRun: [],
      // Information sent from the host
      isOwner: !1,
      hostMenuItems: [],
      hostToolbarItems: [],
      hostHideSidebarNav: !1,
      sidebarChevronDownshift: 0,
      pageLinkBaseUrl: "",
      queryParams: "",
      deployedAppMetadata: {},
      libConfig: {},
      appConfig: {},
      autoReruns: [],
      inputsDisabled: !1,
      navigationPosition: Navigation.Position.SIDEBAR,
      scriptChangedOnDisk: !1
    }, this.connectionManager = null, this.widgetMgr = new WidgetStateManager({
      sendRerunBackMsg: this.sendRerunBackMsg,
      formsDataChanged: (d) => this.setState({
        formsData: d
      })
    }), this.hostCommunicationMgr = new HostCommunicationManager({
      streamlitExecutionStartedAt: t.streamlitExecutionStartedAt,
      sendRerunBackMsg: this.sendRerunBackMsg,
      closeModal: this.closeDialog,
      stopScript: this.stopScript,
      rerunScript: this.rerunScript,
      clearCache: this.clearCache,
      sendAppHeartbeat: this.sendAppHeartbeat,
      setInputsDisabled: (d) => {
        this.setState({
          inputsDisabled: d
        });
      },
      themeChanged: this.handleThemeMessage,
      pageChanged: this.onPageChange,
      isOwnerChanged: (d) => this.setState({
        isOwner: d
      }),
      fileUploadClientConfigChanged: (d) => {
        this.endpoints.setFileUploadClientConfig !== void 0 && this.endpoints.setFileUploadClientConfig(d);
      },
      hostMenuItemsChanged: (d) => {
        this.setState({
          hostMenuItems: d
        });
      },
      hostToolbarItemsChanged: (d) => {
        this.setState({
          hostToolbarItems: d
        });
      },
      hostHideSidebarNavChanged: (d) => {
        this.setState({
          hostHideSidebarNav: d
        });
      },
      sidebarChevronDownshiftChanged: (d) => {
        this.setState({
          sidebarChevronDownshift: d
        });
      },
      pageLinkBaseUrlChanged: (d) => {
        this.setState({
          pageLinkBaseUrl: d
        });
      },
      queryParamsChanged: (d) => {
        this.setState({
          queryParams: d
        });
      },
      deployedAppMetadataChanged: (d) => {
        this.setState({
          deployedAppMetadata: d
        });
      },
      restartWebsocketConnection: () => {
        this.connectionManager || (this.setState({
          scriptRunState: ScriptRunState.RERUN_REQUESTED
        }), this.initializeConnectionManager());
      },
      terminateWebsocketConnection: () => {
        this.connectionManager?.disconnect(), this.connectionManager = null;
      }
    }), this.endpoints = new DefaultStreamlitEndpoints({
      getServerUri: this.getBaseUriParts,
      csrfEnabled: !0,
      sendClientError: (d, k, H, AA, gA) => {
        this.hostCommunicationMgr.sendMessageToHost({
          type: "CLIENT_ERROR",
          component: d,
          error: k,
          message: H,
          source: AA,
          customComponentName: gA
        });
      }
    }), this.uploadClient = new FileUploadClient({
      sessionInfo: this.sessionInfo,
      endpoints: this.endpoints,
      // A form cannot be submitted if it contains a FileUploader widget
      // that's currently uploading. We write that state here, in response
      // to a FileUploadClient callback. The FormSubmitButton element
      // reads the state.
      formsWithPendingRequestsChanged: (d) => this.widgetMgr.setFormsWithUploadsInProgress(d),
      requestFileURLs: this.requestFileURLs
    }), this.componentRegistry = new ComponentRegistry(this.endpoints), this.appNavigation = new AppNavigation(this.hostCommunicationMgr, this.maybeUpdatePageUrl, this.onPageNotFound, this.onPageIconChanged), window.streamlitDebug = {
      clearForwardMsgCache: this.debugClearForwardMsgCache,
      disconnectWebsocket: this.debugDisconnectWebsocket,
      shutdownRuntime: this.debugShutdownRuntime
    };
  }
  initializeConnectionManager() {
    this.isInitializingConnectionManager = !0;
    const t = this.context?.kernel;
    if (t == null)
      throw new Error("Kernel is not set in the context.");
    this.connectionManager = new ConnectionManager({
      kernel: t,
      getLastSessionId: () => this.sessionInfo.last?.sessionId,
      endpoints: this.endpoints,
      onMessage: this.handleMessage,
      onConnectionError: this.handleConnectionError,
      connectionStateChanged: this.handleConnectionStateChanged,
      claimHostAuthToken: this.hostCommunicationMgr.claimAuthToken,
      resetHostAuthToken: this.hostCommunicationMgr.resetAuthToken,
      sendClientError: (g, d, k) => {
        this.hostCommunicationMgr.sendMessageToHost({
          type: "CLIENT_ERROR",
          component: "Websocket Connection",
          error: g,
          message: d,
          source: k
        });
      },
      onHostConfigResp: (g) => {
        const {
          allowedOrigins: d,
          useExternalAuthToken: k,
          disableFullscreenMode: H,
          enableCustomParentMessages: AA,
          mapboxToken: gA,
          enforceDownloadInNewTab: IA,
          metricsUrl: CA,
          blockErrorDialogs: BA,
          setAnonymousCrossOriginPropertyOnMediaElements: eA,
          resourceCrossOriginMode: iA
        } = g, QA = {
          allowedOrigins: d,
          useExternalAuthToken: k,
          enableCustomParentMessages: AA,
          blockErrorDialogs: BA
        }, tA = {
          mapboxToken: gA,
          disableFullscreenMode: H,
          enforceDownloadInNewTab: IA,
          resourceCrossOriginMode: iA ?? eA ? "anonymous" : void 0
        };
        this.metricsMgr.setMetricsConfig(CA), this.hostCommunicationMgr.setAllowedOrigins(QA), this.setAppConfig(QA), this.setLibConfig(tA);
      }
    }), this.isInitializingConnectionManager = !1;
  }
  componentDidMount() {
    const t = this.context?.kernel;
    if (t == null)
      throw new Error("Kernel is not set in the context.");
    this.initializeConnectionManager(), mark(this.state.scriptRunState), this.hostCommunicationMgr.sendMessageToHost({
      type: "SCRIPT_RUN_STATE_CHANGED",
      scriptRunState: this.state.scriptRunState
    }), this.uploadClient.setKernel(t), isScrollingHidden() && document.body.classList.add("embedded"), isInChildFrame() && (window.iFrameResizer = {
      heightCalculationMethod: () => {
        const g = document.querySelectorAll("[data-iframe-height]"), d = Array.from(g).map((k) => (
          // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
          Math.ceil(k.getBoundingClientRect().bottom)
        ));
        return Math.max(0, ...d);
      }
    }, import("./iframeResizer.contentWindow-BYeUxEkG.js").then((g) => g.i)), this.hostCommunicationMgr.sendMessageToHost({
      type: "SET_THEME_CONFIG",
      themeInfo: toExportedTheme(this.props.theme.activeTheme.emotion)
    }), this.metricsMgr.enqueue("viewReport"), window.addEventListener("popstate", this.onHistoryChange, !1);
  }
  componentDidUpdate(t, g) {
    if (window.prerenderReady === !1 && this.isAppInReadyState(g) && (window.prerenderReady = !0), this.state.scriptRunState !== g.scriptRunState) {
      if (mark(this.state.scriptRunState), this.state.scriptRunState === ScriptRunState.NOT_RUNNING)
        try {
          measure("script-run-cycle", ScriptRunState.RUNNING, ScriptRunState.NOT_RUNNING);
        } catch {
        }
      this.hostCommunicationMgr.sendMessageToHost({
        type: "SCRIPT_RUN_STATE_CHANGED",
        scriptRunState: this.state.scriptRunState
      });
    }
  }
  componentWillUnmount() {
    this.connectionManager?.disconnect(), this.hostCommunicationMgr.closeHostCommunication(), window.removeEventListener("popstate", this.onHistoryChange, !1);
  }
  /**
   * Checks whether to show error dialog or send error info
   * to be handled by the host.
   */
  maybeShowErrorDialog(t, g) {
    const {
      blockErrorDialogs: d
    } = this.state.appConfig;
    d || this.openDialog(t);
    const H = t.type === DialogType.SCRIPT_COMPILE_ERROR ? t.type : t.title;
    this.hostCommunicationMgr.sendMessageToHost({
      type: "CLIENT_ERROR_DIALOG",
      error: H,
      message: g
    });
  }
  showError(t, g, d = DialogType.WARNING) {
    LOG.error(g);
    const k = {
      type: d,
      title: t,
      msg: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: g, allowHTML: !1 }),
      onClose: () => {
      }
    };
    this.maybeShowErrorDialog(k, g);
  }
  /**
   * Checks if the code version from the backend is different than the frontend
   */
  hasStreamlitVersionChanged(t) {
    let g;
    if (window.__streamlit?.ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION === !0 ? g = PACKAGE_METADATA.version : this.sessionInfo.isSet && (g = this.sessionInfo.current.streamlitVersion), g) {
      const {
        environmentInfo: d
      } = t;
      if (notNullOrUndefined(d) && notNullOrUndefined(d.streamlitVersion))
        return g != d.streamlitVersion;
    }
    return !1;
  }
  maybeSetState(t) {
    if (t) {
      const [g, d] = t;
      this.setState(g, d);
    }
  }
  processThemeInput(t) {
    const g = this.createThemeHash(t);
    if (g === this.state.themeHash)
      return;
    this.setState({
      themeHash: g
    });
    const d = !isPresetTheme(this.props.theme.activeTheme);
    if (t) {
      const k = createTheme(CUSTOM_THEME_NAME, t);
      this.props.theme.addThemes([k]), (getCachedTheme() === null || d) && this.setAndSendTheme(k);
    } else
      this.props.theme.addThemes([]), d && this.setAndSendTheme(getHostSpecifiedTheme());
    (t?.fontFaces && t.fontFaces.length > 0 || t?.fontSources && t.fontSources.length > 0) && this.props.theme.setImportedTheme(t);
  }
  /**
   * Handler for ForwardMsg.scriptFinished messages
   * @param status the ScriptFinishedStatus that the script finished with
   */
  handleScriptFinished(t) {
    (t === ForwardMsg.ScriptFinishedStatus.FINISHED_SUCCESSFULLY || t === ForwardMsg.ScriptFinishedStatus.FINISHED_EARLY_FOR_RERUN || t === ForwardMsg.ScriptFinishedStatus.FINISHED_FRAGMENT_RUN_SUCCESSFULLY) && (Promise.resolve().then(() => {
      this.state.scriptFinishedHandlers.forEach((g) => g());
    }), (t === ForwardMsg.ScriptFinishedStatus.FINISHED_SUCCESSFULLY || t === ForwardMsg.ScriptFinishedStatus.FINISHED_FRAGMENT_RUN_SUCCESSFULLY) && this.setState(({
      scriptRunId: g,
      fragmentIdsThisRun: d,
      elements: k
    }) => ({
      // Apply any pending elements that haven't been applied.
      elements: k.clearStaleNodes(g, d)
    }), () => {
      const g = new Set(
        // TODO: Update to match React best practices
        // eslint-disable-next-line @eslint-react/no-access-state-in-setstate
        Array.from(this.state.elements.getElements()).map((d) => getElementId(d)).filter(notUndefined)
      );
      this.widgetMgr.removeInactive(g);
    }), this.connectionManager !== null && t !== ForwardMsg.ScriptFinishedStatus.FINISHED_EARLY_FOR_RERUN && this.sessionInfo.isSet && // We only increment the message cache run count if we have received
    // a NewSession message after the latest rerun request. This is done
    // to ignore finished messages from previous script runs, which would
    // cause issues with deleting cached messages that are needed for the
    // current script run.
    this.hasReceivedNewSession && this.connectionManager.incrementMessageCacheRunCount(this.sessionInfo.current.maxCachedMessageAge, this.state.fragmentIdsThisRun));
  }
  /*
   * Clear all elements from the state.
   */
  clearAppState(t, g, d, k) {
    this.setState((H) => {
      const AA = this.appNavigation.clearPageElements(H.elements, k);
      return {
        scriptRunId: g,
        scriptName: d,
        appHash: t,
        elements: AA
      };
    }, () => {
      const H = new Set(
        // TODO: Update to match React best practices
        // eslint-disable-next-line @eslint-react/no-access-state-in-setstate
        Array.from(this.state.elements.getElements()).map((AA) => getElementId(AA)).filter(notUndefined)
      );
      this.widgetMgr.removeInactive(H);
    });
  }
  /**
   * Opens a dialog with the specified state.
   */
  openDialog(t) {
    this.setState({
      dialog: t
    });
  }
  render() {
    const {
      allowRunOnSave: t,
      connectionState: g,
      dialog: d,
      elements: k,
      initialSidebarState: H,
      menuItems: AA,
      isFullScreen: gA,
      scriptRunId: IA,
      scriptRunState: CA,
      userSettings: BA,
      hideTopBar: eA,
      hideSidebarNav: iA,
      expandSidebarNav: QA,
      currentPageScriptHash: tA,
      hostHideSidebarNav: oA,
      pageLinkBaseUrl: EA,
      sidebarChevronDownshift: aA,
      hostMenuItems: nA,
      hostToolbarItems: lA,
      libConfig: cA,
      inputsDisabled: sA,
      appPages: rA,
      navSections: uA,
      navigationPosition: hA,
      scriptChangedOnDisk: dA
    } = this.state, GA = this.props.isMobileViewport ? Navigation.Position.SIDEBAR : hA, DA = showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode), wA = classNames("stApp", getEmbeddingIdClassName(this.embeddingId), {
      "streamlit-embedded": isEmbed(),
      "streamlit-wide": BA.wideMode
    }), bA = d ? StreamlitDialog({
      ...d,
      onClose: this.closeDialog
    }) : null, yA = this.shouldShowToolbar(nA, lA), pA = !isEmbed() || isPaddingDisplayed(), MA = isScrollingHidden();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitContextProvider$1, { initialSidebarState: H, pageLinkBaseUrl: EA, currentPageScriptHash: tA, onPageChange: this.onPageChange, navSections: uA, appPages: rA, appLogo: k.logo, sidebarChevronDownshift: aA, expandSidebarNav: QA, hideSidebarNav: iA || oA, widgetsDisabled: sA || g !== ConnectionState.CONNECTED, gitInfo: this.state.gitInfo, isFullScreen: gA, setFullScreen: this.handleFullScreen, addScriptFinishedHandler: this.addScriptFinishedHandler, removeScriptFinishedHandler: this.removeScriptFinishedHandler, activeTheme: this.props.theme.activeTheme, setTheme: this.setAndSendTheme, availableThemes: this.props.theme.availableThemes, addThemes: this.props.theme.addThemes, libConfig: cA, fragmentIdsThisRun: this.state.fragmentIdsThisRun, locale: window.navigator.language, formsData: this.state.formsData, scriptRunState: CA, scriptRunId: IA, componentRegistry: this.componentRegistry, showToolbar: yA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReactHotkeys, { keyName: "r,c,esc", onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledApp, { className: wA, "data-testid": "stApp", "data-test-script-state": IA == INITIAL_SCRIPT_RUN_ID ? "initial" : CA, "data-test-connection-state": g, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(AppView, { endpoints: this.endpoints, sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost, elements: k, widgetMgr: this.widgetMgr, uploadClient: this.uploadClient, appLogo: k.logo, appPages: rA, navSections: uA, onPageChange: this.onPageChange, hideSidebarNav: iA || oA || GA === Navigation.Position.TOP, expandSidebarNav: QA, navigationPosition: GA, pageLinkBaseUrl: this.state.pageLinkBaseUrl, wideMode: BA.wideMode, embedded: isEmbed(), showPadding: pA, disableScrolling: MA, currentPageScriptHash: tA, topRightContent: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        !eA && /* @__PURE__ */ jsxRuntimeExports.jsx(StatusWidget, { connectionState: g, scriptRunState: CA, rerunScript: this.rerunScript, stopScript: this.stopScript, allowRunOnSave: t, showScriptChangedActions: dA }),
        !eA && /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarActions, { hostToolbarItems: lA, sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost, metricsMgr: this.metricsMgr }),
        this.showDeployButton() && !dA && /* @__PURE__ */ jsxRuntimeExports.jsx(DeployButton, { onClick: this.deployButtonClicked }),
        !eA && /* @__PURE__ */ jsxRuntimeExports.jsx(MainMenu$1, { isServerConnected: this.isServerConnected(), quickRerunCallback: this.rerunScript, clearCacheCallback: this.openClearCacheDialog, settingsCallback: this.settingsCallback, aboutCallback: this.aboutCallback, printCallback: this.printCallback, screencastCallback: this.screencastCallback, screenCastState: this.props.screenCast.currentState, hostMenuItems: nA, developmentMode: DA, sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost, menuItems: AA, metricsMgr: this.metricsMgr, toolbarMode: this.state.toolbarMode })
      ] }) }),
      bA
    ] }) }) });
  }
};
VI.contextType = StliteKernelContext;
let App = VI;
const AppWithScreenCast = withScreencast(App), AppWrapper = (n) => {
  const {
    isMobile: t
  } = useViewportSize();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AppWithScreenCast, { ...n, isMobileViewport: t });
};
function useThemeManager() {
  const n = getDefaultTheme(), [t, g] = useState(n), [d, k] = useState(n.themeInput?.fontFaces ?? []), [H, AA] = useState(null), [gA, IA] = useState(() => [...createPresetThemes(), ...isPresetTheme(n) ? [] : [n]]), CA = (QA) => {
    IA([...createPresetThemes(), ...QA]);
  }, BA = useCallback((QA) => {
    QA !== t && (g(QA), QA.name === AUTO_THEME_NAME ? removeCachedTheme() : setCachedTheme(QA));
  }, [g, t]), eA = useCallback(() => {
    t.name === AUTO_THEME_NAME && BA(getHostSpecifiedTheme());
    const QA = gA.filter((tA) => tA.name !== AUTO_THEME_NAME);
    IA([createAutoTheme(), ...QA]);
  }, [t.name, gA, BA]), iA = useCallback((QA) => {
    QA.fontFaces && k(QA.fontFaces);
    const tA = [...QA.fontSources || [], ...QA.sidebar?.fontSources || []], oA = {};
    tA.forEach((nA) => {
      nA.sourceUrl && nA.configName && (oA[nA.configName] = nA.sourceUrl);
    }), AA(Object.keys(oA).length > 0 ? oA : null);
    const EA = new CustomThemeConfig(QA), aA = createTheme(CUSTOM_THEME_NAME, EA);
    BA(aA);
  }, [k, BA]);
  return useEffect(() => {
    const QA = window.matchMedia("(prefers-color-scheme: dark)");
    return QA.addEventListener("change", eA), window.addEventListener("afterprint", eA), () => {
      window.removeEventListener("afterprint", eA), QA.removeEventListener("change", eA);
    };
  }, [t, gA, eA]), [{
    setTheme: BA,
    activeTheme: t,
    addThemes: CA,
    availableThemes: gA,
    setImportedTheme: iA
  }, d, H];
}
const ThemedApp = ({
  streamlitExecutionStartedAt: n
}) => {
  const [t, g, d] = useThemeManager(), {
    activeTheme: k
  } = t;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RootStyleProvider, { theme: k, children: /* @__PURE__ */ jsxRuntimeExports.jsx(WindowDimensionsProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(PortalProvider, { children: [
    g.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(FontFaceDeclaration, { fontFaces: g }),
    d && /* @__PURE__ */ jsxRuntimeExports.jsx(FontSources, { fontSources: d }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AppWrapper, { theme: t, streamlitExecutionStartedAt: n })
  ] }) }) });
};
class SequentialIDGenerator {
  constructor(t = "") {
    this.prefix = t, this.count = 0, this.offset = 374, this.msb = 1295, this.power = 2;
  }
  next() {
    const t = this.increment().toString(36);
    return this.prefix ? `${this.prefix}${t}` : t;
  }
  increment() {
    const t = this.count + this.offset;
    return t === this.msb && (this.offset += (this.msb + 1) * 9, this.msb = Math.pow(36, ++this.power) - 1), this.count++, t;
  }
}
const minMaxWidth = /(!?\(\s*min(-device-)?-width).+\(\s*max(-device)?-width/i, minWidth = /\(\s*min(-device)?-width/i, maxMinWidth = /(!?\(\s*max(-device)?-width).+\(\s*min(-device)?-width/i, maxWidth = /\(\s*max(-device)?-width/i, isMinWidth = _testQuery(minMaxWidth, maxMinWidth, minWidth), isMaxWidth = _testQuery(maxMinWidth, minMaxWidth, maxWidth), minMaxHeight = /(!?\(\s*min(-device)?-height).+\(\s*max(-device)?-height/i, minHeight = /\(\s*min(-device)?-height/i, maxMinHeight = /(!?\(\s*max(-device)?-height).+\(\s*min(-device)?-height/i, maxHeight = /\(\s*max(-device)?-height/i, isMinHeight = _testQuery(minMaxHeight, maxMinHeight, minHeight), isMaxHeight = _testQuery(maxMinHeight, minMaxHeight, maxHeight), isPrint = /print/i, isPrintOnly = /^print$/i, maxValue = Number.MAX_VALUE;
function _getQueryLength(n) {
  const t = /(-?\d*\.?\d+)(ch|em|ex|px|rem)/.exec(n);
  if (t === null)
    return maxValue;
  let g = t[1];
  switch (t[2]) {
    case "ch":
      g = parseFloat(g) * 8.8984375;
      break;
    case "em":
    case "rem":
      g = parseFloat(g) * 16;
      break;
    case "ex":
      g = parseFloat(g) * 8.296875;
      break;
    case "px":
      g = parseFloat(g);
      break;
  }
  return +g;
}
function _testQuery(n, t, g) {
  return function(d) {
    return n.test(d) ? !0 : t.test(d) ? !1 : g.test(d);
  };
}
function _testIsPrint(n, t) {
  const g = isPrint.test(n), d = isPrintOnly.test(n), k = isPrint.test(t), H = isPrintOnly.test(t);
  return g && k ? !d && H ? 1 : d && !H ? -1 : n.localeCompare(t) : g ? 1 : k ? -1 : null;
}
function sortCSSmq(n, t) {
  if (n === "")
    return -1;
  if (t === "")
    return 1;
  const g = _testIsPrint(n, t);
  if (g !== null)
    return g;
  const d = isMinWidth(n) || isMinHeight(n), k = isMaxWidth(n) || isMaxHeight(n), H = isMinWidth(t) || isMinHeight(t), AA = isMaxWidth(t) || isMaxHeight(t);
  if (d && AA)
    return -1;
  if (k && H)
    return 1;
  const gA = _getQueryLength(n), IA = _getQueryLength(t);
  return gA === maxValue && IA === maxValue ? n.localeCompare(t) : gA === maxValue ? 1 : IA === maxValue ? -1 : gA > IA ? k ? -1 : 1 : gA < IA ? k ? 1 : -1 : n.localeCompare(t);
}
class MultiCache {
  constructor(t, g, d) {
    this.idGenerator = t, this.onNewCache = g, this.onNewValue = d, this.sortedCacheKeys = [], this.caches = {};
  }
  getCache(t) {
    if (!this.caches[t]) {
      const g = new Cache(this.idGenerator, this.onNewValue);
      g.key = t, this.sortedCacheKeys.push(t), this.sortedCacheKeys.sort(sortCSSmq);
      const d = this.sortedCacheKeys.indexOf(t), k = d < this.sortedCacheKeys.length - 1 ? this.sortedCacheKeys[d + 1] : void 0;
      this.caches[t] = g, this.onNewCache(t, g, k);
    }
    return this.caches[t];
  }
  getSortedCacheKeys() {
    return this.sortedCacheKeys;
  }
}
class Cache {
  constructor(t, g) {
    this.cache = {}, this.idGenerator = t, this.onNewValue = g;
  }
  addValue(t, g) {
    const d = this.cache[t];
    if (d)
      return d;
    const k = this.idGenerator.next();
    return this.cache[t] = k, this.onNewValue(this, k, g), k;
  }
}
const uppercasePattern$1 = /[A-Z]/g, msPattern$1 = /^ms-/, cache$1 = {};
function hyphenateStyleName$2(n) {
  return n in cache$1 ? cache$1[n] : cache$1[n] = n.replace(uppercasePattern$1, "-$&").toLowerCase().replace(msPattern$1, "-ms-");
}
const shorthandMap = {
  // CSS 2.1: https://www.w3.org/TR/CSS2/propidx.html
  "list-style": ["list-style-type", "list-style-position", "list-style-image"],
  margin: ["margin-top", "margin-right", "margin-bottom", "margin-left"],
  outline: ["outline-width", "outline-style", "outline-color"],
  padding: ["padding-top", "padding-right", "padding-bottom", "padding-left"],
  // CSS Backgrounds and Borders Module Level 3: https://www.w3.org/TR/css3-background/
  background: ["background-image", "background-position", "background-size", "background-repeat", "background-origin", "background-clip", "background-attachment", "background-color"],
  border: ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width", "border-width", "border-top-style", "border-right-style", "border-bottom-style", "border-left-style", "border-style", "border-top-color", "border-right-color", "border-bottom-color", "border-left-color", "border-color"],
  "border-color": ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"],
  "border-style": ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"],
  "border-width": ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"],
  "border-top": ["border-top-width", "border-top-style", "border-top-color"],
  "border-right": ["border-right-width", "border-right-style", "border-right-color"],
  "border-bottom": ["border-bottom-width", "border-bottom-style", "border-bottom-color"],
  "border-left": ["border-left-width", "border-left-style", "border-left-color"],
  "border-radius": ["border-top-left-radius", "border-top-right-radius", "border-bottom-right-radius", "border-bottom-left-radius"],
  "border-image": ["border-image-source", "border-image-slice", "border-image-width", "border-image-outset", "border-image-repeat"],
  // CSS Fonts Module Level 3: https://www.w3.org/TR/css3-fonts/
  font: ["font-style", "font-variant-ligatures", "font-variant-alternates", "font-variant-caps", "font-variant-numeric", "font-variant-east-asian", "font-variant", "font-weight", "font-stretch", "font-size", "line-height", "font-family"],
  "font-variant": ["font-variant-ligatures", "font-variant-alternates", "font-variant-caps", "font-variant-numeric", "font-variant-east-asian"],
  // CSS Flexible Box Layout Module Level 1: https://www.w3.org/TR/css3-flexbox-1/
  flex: ["flex-grow", "flex-shrink", "flex-basis"],
  "flex-flow": ["flex-direction", "flex-wrap"],
  // CSS Grid Layout Module Level 1: https://www.w3.org/TR/css-grid-1/
  grid: ["grid-template-rows", "grid-template-columns", "grid-template-areas", "grid-auto-rows", "grid-auto-columns", "grid-auto-flow"],
  "grid-template": ["grid-template-rows", "grid-template-columns", "grid-template-areas"],
  "grid-row": ["grid-row-start", "grid-row-end"],
  "grid-column": ["grid-column-start", "grid-column-end"],
  "grid-area": ["grid-row-start", "grid-column-start", "grid-row-end", "grid-column-end"],
  "grid-gap": ["grid-row-gap", "grid-column-gap"],
  // CSS Masking Module Level 1: https://www.w3.org/TR/css-masking/
  mask: ["mask-image", "mask-mode", "mask-position", "mask-size", "mask-repeat", "mask-origin", "mask-clip"],
  "mask-border": ["mask-border-source", "mask-border-slice", "mask-border-width", "mask-border-outset", "mask-border-repeat", "mask-border-mode"],
  // CSS Multi-column Layout Module: https://www.w3.org/TR/css3-multicol/
  columns: ["column-width", "column-count"],
  "column-rule": ["column-rule-width", "column-rule-style", "column-rule-color"],
  // CSS Scroll Snap Module Level 1: https://www.w3.org/TR/css-scroll-snap-1/
  "scroll-padding": ["scroll-padding-top", "scroll-padding-right", "scroll-padding-bottom", "scroll-padding-left"],
  "scroll-padding-block": ["scroll-padding-block-start", "scroll-padding-block-end"],
  "scroll-padding-inline": ["scroll-padding-inline-start", "scroll-padding-inline-end"],
  "scroll-snap-margin": ["scroll-snap-margin-top", "scroll-snap-margin-right", "scroll-snap-margin-bottom", "scroll-snap-margin-left"],
  "scroll-snap-margin-block": ["scroll-snap-margin-block-start", "scroll-snap-margin-block-end"],
  "scroll-snap-margin-inline": ["scroll-snap-margin-inline-start", "scroll-snap-margin-inline-end"],
  // CSS Speech Module: https://www.w3.org/TR/css3-speech/
  cue: ["cue-before", "cue-after"],
  pause: ["pause-before", "pause-after"],
  rest: ["rest-before", "rest-after"],
  // CSS Text Decoration Module Level 3: https://www.w3.org/TR/css-text-decor-3/
  "text-decoration": ["text-decoration-line", "text-decoration-style", "text-decoration-color"],
  "text-emphasis": ["text-emphasis-style", "text-emphasis-color"],
  // CSS Animations (WD): https://www.w3.org/TR/css3-animations
  animation: ["animation-name", "animation-duration", "animation-timing-function", "animation-delay", "animation-iteration-count", "animation-direction", "animation-fill-mode", "animation-play-state"],
  // CSS Transitions (WD): https://www.w3.org/TR/css3-transitions/
  transition: ["transition-property", "transition-duration", "transition-timing-function", "transition-delay"]
};
function validateNoMixedHand(n) {
  const t = Object.keys(n).reduce((d, k) => (d[hyphenateStyleName$2(k)] = k, d), {}), g = [];
  for (const d in t)
    if (d in shorthandMap) {
      for (const k of shorthandMap[d])
        if (k in t) {
          const H = t[k], AA = t[d];
          g.push({
            shorthand: {
              property: AA,
              value: n[AA]
            },
            longhand: {
              property: H,
              value: n[H]
            }
          });
        }
    }
  return g;
}
function capitalizeString(n) {
  return n.charAt(0).toUpperCase() + n.slice(1);
}
function prefixProperty(n, t, g) {
  if (n.hasOwnProperty(t)) {
    for (var d = {}, k = n[t], H = capitalizeString(t), AA = Object.keys(g), gA = 0; gA < AA.length; gA++) {
      var IA = AA[gA];
      if (IA === t)
        for (var CA = 0; CA < k.length; CA++)
          d[k[CA] + H] = g[t];
      d[IA] = g[IA];
    }
    return d;
  }
  return g;
}
function prefixValue$1(n, t, g, d, k) {
  for (var H = 0, AA = n.length; H < AA; ++H) {
    var gA = n[H](t, g, d, k);
    if (gA)
      return gA;
  }
}
function addIfNew(n, t) {
  n.indexOf(t) === -1 && n.push(t);
}
function addNewValuesOnly(n, t) {
  if (Array.isArray(t))
    for (var g = 0, d = t.length; g < d; ++g)
      addIfNew(n, t[g]);
  else
    addIfNew(n, t);
}
function isObject(n) {
  return n instanceof Object && !Array.isArray(n);
}
function createPrefixer(n) {
  var t = n.prefixMap, g = n.plugins;
  return function d(k) {
    for (var H in k) {
      var AA = k[H];
      if (isObject(AA))
        k[H] = d(AA);
      else if (Array.isArray(AA)) {
        for (var gA = [], IA = 0, CA = AA.length; IA < CA; ++IA) {
          var BA = prefixValue$1(g, H, AA[IA], k, t);
          addNewValuesOnly(gA, BA || AA[IA]);
        }
        gA.length > 0 && (k[H] = gA);
      } else {
        var eA = prefixValue$1(g, H, AA, k, t);
        eA && (k[H] = eA), k = prefixProperty(t, H, k);
      }
    }
    return k;
  };
}
var w = ["Webkit"], m = ["Moz"], ms = ["ms"], wm = ["Webkit", "Moz"], wms = ["Webkit", "ms"], wmms = ["Webkit", "Moz", "ms"];
const data = {
  prefixMap: { appearance: wm, textEmphasisPosition: w, textEmphasis: w, textEmphasisStyle: w, textEmphasisColor: w, boxDecorationBreak: w, maskImage: w, maskMode: w, maskRepeat: w, maskPosition: w, maskClip: w, maskOrigin: w, maskSize: w, maskComposite: w, mask: w, maskBorderSource: w, maskBorderMode: w, maskBorderSlice: w, maskBorderWidth: w, maskBorderOutset: w, maskBorderRepeat: w, maskBorder: w, maskType: w, textDecorationStyle: w, textDecorationSkip: w, textDecorationLine: w, textDecorationColor: w, userSelect: wmms, backdropFilter: w, fontKerning: w, scrollSnapType: wms, scrollSnapPointsX: wms, scrollSnapPointsY: wms, scrollSnapDestination: wms, scrollSnapCoordinate: wms, clipPath: w, shapeImageThreshold: w, shapeImageMargin: w, shapeImageOutside: w, filter: w, hyphens: wms, flowInto: wms, flowFrom: wms, breakBefore: wms, breakAfter: wms, breakInside: wms, regionFragment: wms, writingMode: wms, textOrientation: w, tabSize: m, fontFeatureSettings: w, columnCount: w, columnFill: w, columnGap: w, columnRule: w, columnRuleColor: w, columnRuleStyle: w, columnRuleWidth: w, columns: w, columnSpan: w, columnWidth: w, wrapFlow: ms, wrapThrough: ms, wrapMargin: ms, textSizeAdjust: wms }
};
function backgroundClip(n, t) {
  if (typeof t == "string" && t === "text")
    return ["-webkit-text", "text"];
}
var prefixes$5 = ["-webkit-", "-moz-", ""], values$3 = {
  "zoom-in": !0,
  "zoom-out": !0,
  grab: !0,
  grabbing: !0
};
function cursor(n, t) {
  if (n === "cursor" && values$3.hasOwnProperty(t))
    return prefixes$5.map(function(g) {
      return g + t;
    });
}
var isPrefixedValue$1 = { exports: {} }, hasRequiredIsPrefixedValue;
function requireIsPrefixedValue() {
  return hasRequiredIsPrefixedValue || (hasRequiredIsPrefixedValue = 1, (function(n, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var g = /-webkit-|-moz-|-ms-/;
    function d(k) {
      return typeof k == "string" && g.test(k);
    }
    n.exports = t.default;
  })(isPrefixedValue$1, isPrefixedValue$1.exports)), isPrefixedValue$1.exports;
}
var isPrefixedValueExports = requireIsPrefixedValue();
const isPrefixedValue = /* @__PURE__ */ getDefaultExportFromCjs$2(isPrefixedValueExports);
var prefixes$4 = ["-webkit-", ""];
function crossFade(n, t) {
  if (typeof t == "string" && !isPrefixedValue(t) && t.indexOf("cross-fade(") > -1)
    return prefixes$4.map(function(g) {
      return t.replace(/cross-fade\(/g, g + "cross-fade(");
    });
}
var prefixes$3 = ["-webkit-", ""];
function filter(n, t) {
  if (typeof t == "string" && !isPrefixedValue(t) && t.indexOf("filter(") > -1)
    return prefixes$3.map(function(g) {
      return t.replace(/filter\(/g, g + "filter(");
    });
}
var values$2 = {
  flex: ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex", "flex"],
  "inline-flex": ["-webkit-inline-box", "-moz-inline-box", "-ms-inline-flexbox", "-webkit-inline-flex", "inline-flex"]
};
function flex(n, t) {
  if (n === "display" && values$2.hasOwnProperty(t))
    return values$2[t];
}
var alternativeValues = {
  "space-around": "justify",
  "space-between": "justify",
  "flex-start": "start",
  "flex-end": "end",
  "wrap-reverse": "multiple",
  wrap: "multiple"
}, alternativeProps$1 = {
  alignItems: "WebkitBoxAlign",
  justifyContent: "WebkitBoxPack",
  flexWrap: "WebkitBoxLines",
  flexGrow: "WebkitBoxFlex"
};
function flexboxOld(n, t, g) {
  n === "flexDirection" && typeof t == "string" && (t.indexOf("column") > -1 ? g.WebkitBoxOrient = "vertical" : g.WebkitBoxOrient = "horizontal", t.indexOf("reverse") > -1 ? g.WebkitBoxDirection = "reverse" : g.WebkitBoxDirection = "normal"), alternativeProps$1.hasOwnProperty(n) && (g[alternativeProps$1[n]] = alternativeValues[t] || t);
}
var prefixes$2 = ["-webkit-", "-moz-", ""], values$1 = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;
function gradient(n, t) {
  if (typeof t == "string" && !isPrefixedValue(t) && values$1.test(t))
    return prefixes$2.map(function(g) {
      return t.replace(values$1, function(d) {
        return g + d;
      });
    });
}
var _slicedToArray = /* @__PURE__ */ (function() {
  function n(t, g) {
    var d = [], k = !0, H = !1, AA = void 0;
    try {
      for (var gA = t[Symbol.iterator](), IA; !(k = (IA = gA.next()).done) && (d.push(IA.value), !(g && d.length === g)); k = !0)
        ;
    } catch (CA) {
      H = !0, AA = CA;
    } finally {
      try {
        !k && gA.return && gA.return();
      } finally {
        if (H) throw AA;
      }
    }
    return d;
  }
  return function(t, g) {
    if (Array.isArray(t))
      return t;
    if (Symbol.iterator in Object(t))
      return n(t, g);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
})();
function isSimplePositionValue(n) {
  return typeof n == "number" && !isNaN(n);
}
function isComplexSpanValue(n) {
  return typeof n == "string" && n.includes("/");
}
var alignmentValues = ["center", "end", "start", "stretch"], displayValues = {
  "inline-grid": ["-ms-inline-grid", "inline-grid"],
  grid: ["-ms-grid", "grid"]
}, propertyConverters = {
  alignSelf: function n(t, g) {
    alignmentValues.indexOf(t) > -1 && (g.msGridRowAlign = t);
  },
  gridColumn: function n(t, g) {
    if (isSimplePositionValue(t))
      g.msGridColumn = t;
    else if (isComplexSpanValue(t)) {
      var d = t.split("/"), k = _slicedToArray(d, 2), H = k[0], AA = k[1];
      propertyConverters.gridColumnStart(+H, g);
      var gA = AA.split(/ ?span /), IA = _slicedToArray(gA, 2), CA = IA[0], BA = IA[1];
      CA === "" ? propertyConverters.gridColumnEnd(+H + +BA, g) : propertyConverters.gridColumnEnd(+AA, g);
    } else
      propertyConverters.gridColumnStart(t, g);
  },
  gridColumnEnd: function n(t, g) {
    var d = g.msGridColumn;
    isSimplePositionValue(t) && isSimplePositionValue(d) && (g.msGridColumnSpan = t - d);
  },
  gridColumnStart: function n(t, g) {
    isSimplePositionValue(t) && (g.msGridColumn = t);
  },
  gridRow: function n(t, g) {
    if (isSimplePositionValue(t))
      g.msGridRow = t;
    else if (isComplexSpanValue(t)) {
      var d = t.split("/"), k = _slicedToArray(d, 2), H = k[0], AA = k[1];
      propertyConverters.gridRowStart(+H, g);
      var gA = AA.split(/ ?span /), IA = _slicedToArray(gA, 2), CA = IA[0], BA = IA[1];
      CA === "" ? propertyConverters.gridRowEnd(+H + +BA, g) : propertyConverters.gridRowEnd(+AA, g);
    } else
      propertyConverters.gridRowStart(t, g);
  },
  gridRowEnd: function n(t, g) {
    var d = g.msGridRow;
    isSimplePositionValue(t) && isSimplePositionValue(d) && (g.msGridRowSpan = t - d);
  },
  gridRowStart: function n(t, g) {
    isSimplePositionValue(t) && (g.msGridRow = t);
  },
  gridTemplateColumns: function n(t, g) {
    g.msGridColumns = t;
  },
  gridTemplateRows: function n(t, g) {
    g.msGridRows = t;
  },
  justifySelf: function n(t, g) {
    alignmentValues.indexOf(t) > -1 && (g.msGridColumnAlign = t);
  }
};
function grid(n, t, g) {
  if (n === "display" && t in displayValues)
    return displayValues[t];
  if (n in propertyConverters) {
    var d = propertyConverters[n];
    d(t, g);
  }
}
var prefixes$1 = ["-webkit-", ""];
function imageSet(n, t) {
  if (typeof t == "string" && !isPrefixedValue(t) && t.indexOf("image-set(") > -1)
    return prefixes$1.map(function(g) {
      return t.replace(/image-set\(/g, g + "image-set(");
    });
}
var alternativeProps = {
  marginBlockStart: ["WebkitMarginBefore"],
  marginBlockEnd: ["WebkitMarginAfter"],
  marginInlineStart: ["WebkitMarginStart", "MozMarginStart"],
  marginInlineEnd: ["WebkitMarginEnd", "MozMarginEnd"],
  paddingBlockStart: ["WebkitPaddingBefore"],
  paddingBlockEnd: ["WebkitPaddingAfter"],
  paddingInlineStart: ["WebkitPaddingStart", "MozPaddingStart"],
  paddingInlineEnd: ["WebkitPaddingEnd", "MozPaddingEnd"],
  borderBlockStart: ["WebkitBorderBefore"],
  borderBlockStartColor: ["WebkitBorderBeforeColor"],
  borderBlockStartStyle: ["WebkitBorderBeforeStyle"],
  borderBlockStartWidth: ["WebkitBorderBeforeWidth"],
  borderBlockEnd: ["WebkitBorderAfter"],
  borderBlockEndColor: ["WebkitBorderAfterColor"],
  borderBlockEndStyle: ["WebkitBorderAfterStyle"],
  borderBlockEndWidth: ["WebkitBorderAfterWidth"],
  borderInlineStart: ["WebkitBorderStart", "MozBorderStart"],
  borderInlineStartColor: ["WebkitBorderStartColor", "MozBorderStartColor"],
  borderInlineStartStyle: ["WebkitBorderStartStyle", "MozBorderStartStyle"],
  borderInlineStartWidth: ["WebkitBorderStartWidth", "MozBorderStartWidth"],
  borderInlineEnd: ["WebkitBorderEnd", "MozBorderEnd"],
  borderInlineEndColor: ["WebkitBorderEndColor", "MozBorderEndColor"],
  borderInlineEndStyle: ["WebkitBorderEndStyle", "MozBorderEndStyle"],
  borderInlineEndWidth: ["WebkitBorderEndWidth", "MozBorderEndWidth"]
};
function logical(n, t, g) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, n))
    for (var d = alternativeProps[n], k = 0, H = d.length; k < H; ++k)
      g[d[k]] = t;
}
function position(n, t) {
  if (n === "position" && t === "sticky")
    return ["-webkit-sticky", "sticky"];
}
var prefixes = ["-webkit-", "-moz-", ""], properties$1 = {
  maxHeight: !0,
  maxWidth: !0,
  width: !0,
  height: !0,
  columnWidth: !0,
  minWidth: !0,
  minHeight: !0
}, values = {
  "min-content": !0,
  "max-content": !0,
  "fill-available": !0,
  "fit-content": !0,
  "contain-floats": !0
};
function sizing(n, t) {
  if (properties$1.hasOwnProperty(n) && values.hasOwnProperty(t))
    return prefixes.map(function(g) {
      return g + t;
    });
}
var hyphenateProperty$1 = { exports: {} }, uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
function toHyphenLower(n) {
  return "-" + n.toLowerCase();
}
function hyphenateStyleName(n) {
  if (cache.hasOwnProperty(n))
    return cache[n];
  var t = n.replace(uppercasePattern, toHyphenLower);
  return cache[n] = msPattern.test(t) ? "-" + t : t;
}
const hyphenateStyleName$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hyphenateStyleName
}, Symbol.toStringTag, { value: "Module" })), require$$0 = /* @__PURE__ */ getAugmentedNamespace(hyphenateStyleName$1);
var hasRequiredHyphenateProperty;
function requireHyphenateProperty() {
  return hasRequiredHyphenateProperty || (hasRequiredHyphenateProperty = 1, (function(n, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = H;
    var g = require$$0, d = k(g);
    function k(AA) {
      return AA && AA.__esModule ? AA : { default: AA };
    }
    function H(AA) {
      return (0, d.default)(AA);
    }
    n.exports = t.default;
  })(hyphenateProperty$1, hyphenateProperty$1.exports)), hyphenateProperty$1.exports;
}
var hyphenatePropertyExports = requireHyphenateProperty();
const hyphenateProperty = /* @__PURE__ */ getDefaultExportFromCjs$2(hyphenatePropertyExports);
var properties = {
  transition: !0,
  transitionProperty: !0,
  WebkitTransition: !0,
  WebkitTransitionProperty: !0,
  MozTransition: !0,
  MozTransitionProperty: !0
}, prefixMapping = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  ms: "-ms-"
};
function prefixValue(n, t) {
  if (isPrefixedValue(n))
    return n;
  for (var g = n.split(/,(?![^()]*(?:\([^()]*\))?\))/g), d = 0, k = g.length; d < k; ++d) {
    var H = g[d], AA = [H];
    for (var gA in t) {
      var IA = hyphenateProperty(gA);
      if (H.indexOf(IA) > -1 && IA !== "order")
        for (var CA = t[gA], BA = 0, eA = CA.length; BA < eA; ++BA)
          AA.unshift(H.replace(IA, prefixMapping[CA[BA]] + IA));
    }
    g[d] = AA.join(",");
  }
  return g.join(",");
}
function transition(n, t, g, d) {
  if (typeof t == "string" && properties.hasOwnProperty(n)) {
    var k = prefixValue(t, d), H = k.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function(gA) {
      return !/-moz-|-ms-/.test(gA);
    }).join(",");
    if (n.indexOf("Webkit") > -1)
      return H;
    var AA = k.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function(gA) {
      return !/-webkit-|-ms-/.test(gA);
    }).join(",");
    return n.indexOf("Moz") > -1 ? AA : (g["Webkit" + capitalizeString(n)] = H, g["Moz" + capitalizeString(n)] = AA, k);
  }
}
var plugins = [backgroundClip, crossFade, cursor, filter, flexboxOld, gradient, grid, imageSet, logical, position, sizing, transition, flex], prefix = createPrefixer({
  prefixMap: data.prefixMap,
  plugins
});
function injectStylePrefixed(n, t, g, d) {
  const k = n.getCache(g);
  let H = "";
  for (const AA in t) {
    const gA = t[AA];
    if (gA != null)
      if (typeof gA != "object") {
        process.env.NODE_ENV !== "production" && validateValueType(gA, AA);
        const IA = `${hyphenateStyleName$2(AA)}:${gA}`, CA = `${d}${IA}`, BA = k.cache[CA];
        if (BA !== void 0) {
          H += " " + BA;
          continue;
        } else {
          let eA = "";
          const iA = prefix({
            [AA]: gA
          });
          for (const tA in iA) {
            const oA = iA[tA], EA = typeof oA;
            if (EA === "string" || EA === "number") {
              const aA = `${hyphenateStyleName$2(tA)}:${oA}`;
              aA !== IA && (eA += `${aA};`);
            } else if (Array.isArray(oA)) {
              const aA = hyphenateStyleName$2(tA);
              for (let nA = 0; nA < oA.length; nA++) {
                const lA = `${aA}:${oA[nA]}`;
                lA !== IA && (eA += `${lA};`);
              }
            }
          }
          eA += IA;
          const QA = k.addValue(CA, {
            pseudo: d,
            block: eA
          });
          H += " " + QA;
        }
      } else
        AA[0] === ":" ? H += " " + injectStylePrefixed(n, gA, g, d + AA) : AA.substring(0, 6) === "@media" && (H += " " + injectStylePrefixed(n, gA, AA.substr(7), d));
  }
  if (process.env.NODE_ENV !== "production") {
    const AA = validateNoMixedHand(t);
    AA.length && AA.forEach(({
      shorthand: gA,
      longhand: IA
    }) => {
      const CA = JSON.stringify({
        [gA.property]: gA.value
      }), BA = JSON.stringify({
        [IA.property]: IA.value
      });
      console.warn(`Styles \`${CA}\` and \`${BA}\` in object yielding class "${H.slice(1)}" may result in unexpected behavior. Mixing shorthand and longhand properties within the same style object is unsupported with atomic rendering.`);
    });
  }
  return H.slice(1);
}
function validateValueType(n, t) {
  if (n === null || Array.isArray(n) || typeof n != "number" && typeof n != "string")
    throw new Error(`Unsupported style value: ${JSON.stringify(n)} used in property ${JSON.stringify(t)}`);
}
const validAnimationState = /^(from|to|\+?(\d*\.)?\d+%)(\s*,\s*(from|to|\+?(\d*\.)?\d+%))*$/;
function validateKeyframesObject(n) {
  let t = !0;
  for (const g in n) {
    const d = n[g];
    validAnimationState.test(g) || (t = !1, console.warn(`Warning: property "${g}" in keyframes object ${JSON.stringify(n)} is not a valid. Must be "from", "to", or a percentage.`)), typeof d != "object" && (t = !1, console.warn(`Warning: value for "${g}" property in keyframes object ${JSON.stringify(n)} must be an object. Instead it was a ${typeof d}.`)), t || console.warn('Warning: object used as value for "animationName" style is invalid:', n);
  }
}
function atomicSelector(n, t) {
  let g = `.${n}`;
  return t && (g += t), g;
}
function keyframesToBlock(n) {
  process.env.NODE_ENV !== "production" && validateKeyframesObject(n), process.env.NODE_ENV !== "production" && typeof Object.getPrototypeOf(n) < "u" && Object.getPrototypeOf(n) !== Object.getPrototypeOf({}) && console.warn("Only plain objects should be used as animation values. Unexpectedly recieved:", n);
  let t = "";
  for (const g in n)
    t += `${g}{${declarationsToBlock(n[g])}}`;
  return t;
}
function declarationsToBlock(n) {
  let t = "";
  for (const g in n) {
    const d = n[g];
    (typeof d == "string" || typeof d == "number") && (t += `${hyphenateStyleName$2(g)}:${d};`);
  }
  return t.slice(0, -1);
}
function keyframesBlockToRule(n, t) {
  return `@keyframes ${n}{${t}}`;
}
function fontFaceBlockToRule(n, t) {
  return `@font-face{font-family:${n};${t}}`;
}
function styleBlockToRule(n, t) {
  return `${n}{${t}}`;
}
const insertRuleIntoDevtools = (n, t) => {
  const g = n.substring(1, n.indexOf(":") !== -1 ? n.indexOf(":") : n.length), d = {};
  for (const k of t.split(";"))
    k.trim() !== "" && !window.__STYLETRON_DEVTOOLS__.atomicMap[g] && (d[k.substring(0, k.indexOf(":"))] = k.substring(k.indexOf(":") + 1, k.length));
  window.__STYLETRON_DEVTOOLS__.atomicMap[g] = d;
}, hydrateDevtoolsRule = (n) => {
  const t = n.substring(0, 3), g = n.substring(4, n.length - 1);
  insertRuleIntoDevtools(t, g);
}, STYLES_HYDRATOR = /\.([^{:]+)(:[^{]+)?{(?:[^}]*;)?([^}]*?)}/g, KEYFRAMES_HYRDATOR = /@keyframes ([^{]+){((?:(?:from|to|(?:\d+\.?\d*%))\{(?:[^}])*})*)}/g, FONT_FACE_HYDRATOR = /@font-face\{font-family:([^;]+);([^}]*)\}/g;
function hydrateStyles(n, t, g) {
  let d;
  for (; d = t.exec(g); ) {
    const [, k, H, AA] = d;
    process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && hydrateDevtoolsRule(d[0]);
    const gA = H ? `${H}${AA}` : AA;
    n.cache[gA] = k, n.idGenerator.increment();
  }
}
function hydrate(n, t, g) {
  let d;
  for (; d = t.exec(g); ) {
    const [, k, H] = d;
    process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && hydrateDevtoolsRule(d[0]), n.cache[H] = k, n.idGenerator.increment();
  }
}
class StyletronClient {
  constructor(t = {}) {
    this.styleElements = {};
    const g = new SequentialIDGenerator(t.prefix), d = (k, H, AA) => {
      const {
        pseudo: gA,
        block: IA
      } = AA, CA = this.styleElements[k.key].sheet, BA = atomicSelector(H, gA), eA = styleBlockToRule(BA, IA);
      try {
        CA.insertRule(eA, CA.cssRules.length), process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && insertRuleIntoDevtools(BA, IA);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn(`Failed to inject CSS: "${eA}". Perhaps this has invalid or un-prefixed properties?`);
      }
    };
    if (this.styleCache = new MultiCache(g, (k, H, AA) => {
      const gA = document.createElement("style");
      if (gA.media = k, AA === void 0)
        this.container.appendChild(gA);
      else {
        const IA = findSheetIndexWithMedia(this.container.children, AA);
        this.container.insertBefore(gA, this.container.children[IA]);
      }
      this.styleElements[k] = gA;
    }, d), this.keyframesCache = new Cache(new SequentialIDGenerator(t.prefix), (k, H, AA) => {
      this.styleCache.getCache("");
      const gA = this.styleElements[""].sheet, IA = keyframesBlockToRule(H, keyframesToBlock(AA));
      try {
        gA.insertRule(IA, gA.cssRules.length);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn(`Failed to inject CSS: "${IA}". Perhaps this has invalid or un-prefixed properties?`);
      }
    }), this.fontFaceCache = new Cache(new SequentialIDGenerator(t.prefix), (k, H, AA) => {
      this.styleCache.getCache("");
      const gA = this.styleElements[""].sheet, IA = fontFaceBlockToRule(H, declarationsToBlock(AA));
      try {
        gA.insertRule(IA, gA.cssRules.length);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn(`Failed to inject CSS: "${IA}". Perhaps this has invalid or un-prefixed properties?`);
      }
    }), t.container && (this.container = t.container), t.hydrate && t.hydrate.length > 0) {
      if (!this.container) {
        const k = t.hydrate[0].parentElement;
        k != null && (this.container = k);
      }
      for (let k = 0; k < t.hydrate.length; k++) {
        const H = t.hydrate[k], AA = H.getAttribute("data-hydrate");
        if (AA === "font-face") {
          hydrate(this.fontFaceCache, FONT_FACE_HYDRATOR, H.textContent);
          continue;
        }
        if (AA === "keyframes") {
          hydrate(this.keyframesCache, KEYFRAMES_HYRDATOR, H.textContent);
          continue;
        }
        const gA = H.media ? H.media : "";
        this.styleElements[gA] = H;
        const IA = new Cache(g, d);
        IA.key = gA, hydrateStyles(IA, STYLES_HYDRATOR, H.textContent), this.styleCache.sortedCacheKeys.push(gA), this.styleCache.caches[gA] = IA;
      }
    }
    if (!this.container) {
      if (document.head === null)
        throw new Error("No container provided and `document.head` was null");
      this.container = document.head;
    }
  }
  renderStyle(t) {
    return injectStylePrefixed(this.styleCache, t, "", "");
  }
  renderFontFace(t) {
    const g = declarationsToBlock(t);
    return this.fontFaceCache.addValue(g, t);
  }
  renderKeyframes(t) {
    const g = keyframesToBlock(t);
    return this.keyframesCache.addValue(g, t);
  }
}
function findSheetIndexWithMedia(n, t) {
  let g = 0;
  for (; g < n.length; g++) {
    const d = n[g];
    if (d.tagName === "STYLE" && d.media === t)
      return g;
  }
  return -1;
}
const engine = new StyletronClient({
  prefix: "st-"
});
process.env.NODE_ENV === "development" && log$6.setLevel(log$6.levels.DEBUG);
const streamlitExecutionStartedAt = Date.now();
function StliteApp(n) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StliteKernelProvider, { kernel: n.kernel, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Provider$1, { value: engine, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemedApp, { streamlitExecutionStartedAt }) }) });
}
function r(n) {
  var t, g, d = "";
  if (typeof n == "string" || typeof n == "number") d += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var k = n.length;
    for (t = 0; t < k; t++) n[t] && (g = r(n[t])) && (d && (d += " "), d += g);
  } else for (g in n) n[g] && (d && (d += " "), d += g);
  return d;
}
function clsx() {
  for (var n, t, g = 0, d = "", k = arguments.length; g < k; g++) (n = arguments[g]) && (t = r(n)) && (d && (d += " "), d += t);
  return d;
}
function Mt(n) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], g = document.createElement("style");
  g.type = "text/css", t.firstChild ? t.insertBefore(g, t.firstChild) : t.appendChild(g), g.styleSheet ? g.styleSheet.cssText = n : g.appendChild(document.createTextNode(n));
}
Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var L = (n) => typeof n == "number" && !isNaN(n), N = (n) => typeof n == "string", P = (n) => typeof n == "function", mt = (n) => N(n) || L(n), B = (n) => N(n) || P(n) ? n : null, pt = (n, t) => n === !1 || L(n) && n > 0 ? n : t, z = (n) => isValidElement(n) || N(n) || P(n) || L(n);
function Z(n, t, g = 300) {
  let { scrollHeight: d, style: k } = n;
  requestAnimationFrame(() => {
    k.minHeight = "initial", k.height = d + "px", k.transition = `all ${g}ms`, requestAnimationFrame(() => {
      k.height = "0", k.padding = "0", k.margin = "0", setTimeout(t, g);
    });
  });
}
function $({ enter: n, exit: t, appendPosition: g = !1, collapse: d = !0, collapseDuration: k = 300 }) {
  return function({ children: H, position: AA, preventExitTransition: gA, done: IA, nodeRef: CA, isIn: BA, playToast: eA }) {
    let iA = g ? `${n}--${AA}` : n, QA = g ? `${t}--${AA}` : t, tA = useRef(0);
    return useLayoutEffect$1(() => {
      let oA = CA.current, EA = iA.split(" "), aA = (nA) => {
        nA.target === CA.current && (eA(), oA.removeEventListener("animationend", aA), oA.removeEventListener("animationcancel", aA), tA.current === 0 && nA.type !== "animationcancel" && oA.classList.remove(...EA));
      };
      oA.classList.add(...EA), oA.addEventListener("animationend", aA), oA.addEventListener("animationcancel", aA);
    }, []), useEffect(() => {
      let oA = CA.current, EA = () => {
        oA.removeEventListener("animationend", EA), d ? Z(oA, IA, k) : IA();
      };
      BA || (gA ? EA() : (tA.current = 1, oA.className += ` ${QA}`, oA.addEventListener("animationend", EA)));
    }, [BA]), React__default.createElement(React__default.Fragment, null, H);
  };
}
function J(n, t) {
  return { content: tt(n.content, n.props), containerId: n.props.containerId, id: n.props.toastId, theme: n.props.theme, type: n.props.type, data: n.props.data || {}, isLoading: n.props.isLoading, icon: n.props.icon, reason: n.removalReason, status: t };
}
function tt(n, t, g = !1) {
  return isValidElement(n) && !N(n.type) ? cloneElement(n, { closeToast: t.closeToast, toastProps: t, data: t.data, isPaused: g }) : P(n) ? n({ closeToast: t.closeToast, toastProps: t, data: t.data, isPaused: g }) : n;
}
function yt({ closeToast: n, theme: t, ariaLabel: g = "close" }) {
  return React__default.createElement("button", { className: `Toastify__close-button Toastify__close-button--${t}`, type: "button", onClick: (d) => {
    d.stopPropagation(), n(!0);
  }, "aria-label": g }, React__default.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, React__default.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function gt({ delay: n, isRunning: t, closeToast: g, type: d = "default", hide: k, className: H, controlledProgress: AA, progress: gA, rtl: IA, isIn: CA, theme: BA }) {
  let eA = k || AA && gA === 0, iA = { animationDuration: `${n}ms`, animationPlayState: t ? "running" : "paused" };
  AA && (iA.transform = `scaleX(${gA})`);
  let QA = clsx("Toastify__progress-bar", AA ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${BA}`, `Toastify__progress-bar--${d}`, { "Toastify__progress-bar--rtl": IA }), tA = P(H) ? H({ rtl: IA, type: d, defaultClassName: QA }) : clsx(QA, H), oA = { [AA && gA >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: AA && gA < 1 ? null : () => {
    CA && g();
  } };
  return React__default.createElement("div", { className: "Toastify__progress-bar--wrp", "data-hidden": eA }, React__default.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${BA} Toastify__progress-bar--${d}` }), React__default.createElement("div", { role: "progressbar", "aria-hidden": eA ? "true" : "false", "aria-label": "notification timer", className: tA, style: iA, ...oA }));
}
var Xt = 1, at = () => `${Xt++}`;
function _t(n, t, g) {
  let d = 1, k = 0, H = [], AA = [], gA = t, IA = /* @__PURE__ */ new Map(), CA = /* @__PURE__ */ new Set(), BA = (nA) => (CA.add(nA), () => CA.delete(nA)), eA = () => {
    AA = Array.from(IA.values()), CA.forEach((nA) => nA());
  }, iA = ({ containerId: nA, toastId: lA, updateId: cA }) => {
    let sA = nA ? nA !== n : n !== 1, rA = IA.has(lA) && cA == null;
    return sA || rA;
  }, QA = (nA, lA) => {
    IA.forEach((cA) => {
      var sA;
      (lA == null || lA === cA.props.toastId) && ((sA = cA.toggle) == null || sA.call(cA, nA));
    });
  }, tA = (nA) => {
    var lA, cA;
    (cA = (lA = nA.props) == null ? void 0 : lA.onClose) == null || cA.call(lA, nA.removalReason), nA.isActive = !1;
  }, oA = (nA) => {
    if (nA == null) IA.forEach(tA);
    else {
      let lA = IA.get(nA);
      lA && tA(lA);
    }
    eA();
  }, EA = () => {
    k -= H.length, H = [];
  }, aA = (nA) => {
    var lA, cA;
    let { toastId: sA, updateId: rA } = nA.props, uA = rA == null;
    nA.staleId && IA.delete(nA.staleId), nA.isActive = !0, IA.set(sA, nA), eA(), g(J(nA, uA ? "added" : "updated")), uA && ((cA = (lA = nA.props).onOpen) == null || cA.call(lA));
  };
  return { id: n, props: gA, observe: BA, toggle: QA, removeToast: oA, toasts: IA, clearQueue: EA, buildToast: (nA, lA) => {
    if (iA(lA)) return;
    let { toastId: cA, updateId: sA, data: rA, staleId: uA, delay: hA } = lA, dA = sA == null;
    dA && k++;
    let GA = { ...gA, style: gA.toastStyle, key: d++, ...Object.fromEntries(Object.entries(lA).filter(([wA, bA]) => bA != null)), toastId: cA, updateId: sA, data: rA, isIn: !1, className: B(lA.className || gA.toastClassName), progressClassName: B(lA.progressClassName || gA.progressClassName), autoClose: lA.isLoading ? !1 : pt(lA.autoClose, gA.autoClose), closeToast(wA) {
      IA.get(cA).removalReason = wA, oA(cA);
    }, deleteToast() {
      let wA = IA.get(cA);
      if (wA != null) {
        if (g(J(wA, "removed")), IA.delete(cA), k--, k < 0 && (k = 0), H.length > 0) {
          aA(H.shift());
          return;
        }
        eA();
      }
    } };
    GA.closeButton = gA.closeButton, lA.closeButton === !1 || z(lA.closeButton) ? GA.closeButton = lA.closeButton : lA.closeButton === !0 && (GA.closeButton = z(gA.closeButton) ? gA.closeButton : !0);
    let DA = { content: nA, props: GA, staleId: uA };
    gA.limit && gA.limit > 0 && k > gA.limit && dA ? H.push(DA) : L(hA) ? setTimeout(() => {
      aA(DA);
    }, hA) : aA(DA);
  }, setProps(nA) {
    gA = nA;
  }, setToggle: (nA, lA) => {
    let cA = IA.get(nA);
    cA && (cA.toggle = lA);
  }, isToastActive: (nA) => {
    var lA;
    return (lA = IA.get(nA)) == null ? void 0 : lA.isActive;
  }, getSnapshot: () => AA };
}
var I = /* @__PURE__ */ new Map(), F = [], st = /* @__PURE__ */ new Set(), Vt = (n) => st.forEach((t) => t(n)), bt = () => I.size > 0;
function Qt() {
  F.forEach((n) => nt(n.content, n.options)), F = [];
}
var vt = (n, { containerId: t }) => {
  var g;
  return (g = I.get(t || 1)) == null ? void 0 : g.toasts.get(n);
};
function X(n, t) {
  var g;
  if (t) return !!((g = I.get(t)) != null && g.isToastActive(n));
  let d = !1;
  return I.forEach((k) => {
    k.isToastActive(n) && (d = !0);
  }), d;
}
function ht(n) {
  if (!bt()) {
    F = F.filter((t) => n != null && t.options.toastId !== n);
    return;
  }
  if (n == null || mt(n)) I.forEach((t) => {
    t.removeToast(n);
  });
  else if (n && ("containerId" in n || "id" in n)) {
    let t = I.get(n.containerId);
    t ? t.removeToast(n.id) : I.forEach((g) => {
      g.removeToast(n.id);
    });
  }
}
var Ct = (n = {}) => {
  I.forEach((t) => {
    t.props.limit && (!n.containerId || t.id === n.containerId) && t.clearQueue();
  });
};
function nt(n, t) {
  z(n) && (bt() || F.push({ content: n, options: t }), I.forEach((g) => {
    g.buildToast(n, t);
  }));
}
function xt(n) {
  var t;
  (t = I.get(n.containerId || 1)) == null || t.setToggle(n.id, n.fn);
}
function rt(n, t) {
  I.forEach((g) => {
    (t == null || !(t != null && t.containerId) || t?.containerId === g.id) && g.toggle(n, t?.id);
  });
}
function Et(n) {
  let t = n.containerId || 1;
  return { subscribe(g) {
    let d = _t(t, n, Vt);
    I.set(t, d);
    let k = d.observe(g);
    return Qt(), () => {
      k(), I.delete(t);
    };
  }, setProps(g) {
    var d;
    (d = I.get(t)) == null || d.setProps(g);
  }, getSnapshot() {
    var g;
    return (g = I.get(t)) == null ? void 0 : g.getSnapshot();
  } };
}
function Pt(n) {
  return st.add(n), () => {
    st.delete(n);
  };
}
function Wt(n) {
  return n && (N(n.toastId) || L(n.toastId)) ? n.toastId : at();
}
function U(n, t) {
  return nt(n, t), t.toastId;
}
function V(n, t) {
  return { ...t, type: t && t.type || n, toastId: Wt(t) };
}
function Q(n) {
  return (t, g) => U(t, V(n, g));
}
function y(n, t) {
  return U(n, V("default", t));
}
y.loading = (n, t) => U(n, V("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...t }));
function Gt(n, { pending: t, error: g, success: d }, k) {
  let H;
  t && (H = N(t) ? y.loading(t, k) : y.loading(t.render, { ...k, ...t }));
  let AA = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, gA = (CA, BA, eA) => {
    if (BA == null) {
      y.dismiss(H);
      return;
    }
    let iA = { type: CA, ...AA, ...k, data: eA }, QA = N(BA) ? { render: BA } : BA;
    return H ? y.update(H, { ...iA, ...QA }) : y(QA.render, { ...iA, ...QA }), eA;
  }, IA = P(n) ? n() : n;
  return IA.then((CA) => gA("success", d, CA)).catch((CA) => gA("error", g, CA)), IA;
}
y.promise = Gt;
y.success = Q("success");
y.info = Q("info");
y.error = Q("error");
y.warning = Q("warning");
y.warn = y.warning;
y.dark = (n, t) => U(n, V("default", { theme: "dark", ...t }));
function qt(n) {
  ht(n);
}
y.dismiss = qt;
y.clearWaitingQueue = Ct;
y.isActive = X;
y.update = (n, t = {}) => {
  let g = vt(n, t);
  if (g) {
    let { props: d, content: k } = g, H = { delay: 100, ...d, ...t, toastId: t.toastId || n, updateId: at() };
    H.toastId !== n && (H.staleId = n);
    let AA = H.render || k;
    delete H.render, U(AA, H);
  }
};
y.done = (n) => {
  y.update(n, { progress: 1 });
};
y.onChange = Pt;
y.play = (n) => rt(!0, n);
y.pause = (n) => rt(!1, n);
function It(n) {
  var t;
  let { subscribe: g, getSnapshot: d, setProps: k } = useRef(Et(n)).current;
  k(n);
  let H = (t = useSyncExternalStore(g, d, d)) == null ? void 0 : t.slice();
  function AA(gA) {
    if (!H) return [];
    let IA = /* @__PURE__ */ new Map();
    return n.newestOnTop && H.reverse(), H.forEach((CA) => {
      let { position: BA } = CA.props;
      IA.has(BA) || IA.set(BA, []), IA.get(BA).push(CA);
    }), Array.from(IA, (CA) => gA(CA[0], CA[1]));
  }
  return { getToastToRender: AA, isToastActive: X, count: H?.length };
}
function At(n) {
  let [t, g] = useState(!1), [d, k] = useState(!1), H = useRef(null), AA = useRef({ start: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, didMove: !1 }).current, { autoClose: gA, pauseOnHover: IA, closeToast: CA, onClick: BA, closeOnClick: eA } = n;
  xt({ id: n.toastId, containerId: n.containerId, fn: g }), useEffect(() => {
    if (n.pauseOnFocusLoss) return iA(), () => {
      QA();
    };
  }, [n.pauseOnFocusLoss]);
  function iA() {
    document.hasFocus() || aA(), window.addEventListener("focus", EA), window.addEventListener("blur", aA);
  }
  function QA() {
    window.removeEventListener("focus", EA), window.removeEventListener("blur", aA);
  }
  function tA(uA) {
    if (n.draggable === !0 || n.draggable === uA.pointerType) {
      nA();
      let hA = H.current;
      AA.canCloseOnClick = !0, AA.canDrag = !0, hA.style.transition = "none", n.draggableDirection === "x" ? (AA.start = uA.clientX, AA.removalDistance = hA.offsetWidth * (n.draggablePercent / 100)) : (AA.start = uA.clientY, AA.removalDistance = hA.offsetHeight * (n.draggablePercent === 80 ? n.draggablePercent * 1.5 : n.draggablePercent) / 100);
    }
  }
  function oA(uA) {
    let { top: hA, bottom: dA, left: GA, right: DA } = H.current.getBoundingClientRect();
    uA.nativeEvent.type !== "touchend" && n.pauseOnHover && uA.clientX >= GA && uA.clientX <= DA && uA.clientY >= hA && uA.clientY <= dA ? aA() : EA();
  }
  function EA() {
    g(!0);
  }
  function aA() {
    g(!1);
  }
  function nA() {
    AA.didMove = !1, document.addEventListener("pointermove", cA), document.addEventListener("pointerup", sA);
  }
  function lA() {
    document.removeEventListener("pointermove", cA), document.removeEventListener("pointerup", sA);
  }
  function cA(uA) {
    let hA = H.current;
    if (AA.canDrag && hA) {
      AA.didMove = !0, t && aA(), n.draggableDirection === "x" ? AA.delta = uA.clientX - AA.start : AA.delta = uA.clientY - AA.start, AA.start !== uA.clientX && (AA.canCloseOnClick = !1);
      let dA = n.draggableDirection === "x" ? `${AA.delta}px, var(--y)` : `0, calc(${AA.delta}px + var(--y))`;
      hA.style.transform = `translate3d(${dA},0)`, hA.style.opacity = `${1 - Math.abs(AA.delta / AA.removalDistance)}`;
    }
  }
  function sA() {
    lA();
    let uA = H.current;
    if (AA.canDrag && AA.didMove && uA) {
      if (AA.canDrag = !1, Math.abs(AA.delta) > AA.removalDistance) {
        k(!0), n.closeToast(!0), n.collapseAll();
        return;
      }
      uA.style.transition = "transform 0.2s, opacity 0.2s", uA.style.removeProperty("transform"), uA.style.removeProperty("opacity");
    }
  }
  let rA = { onPointerDown: tA, onPointerUp: oA };
  return gA && IA && (rA.onMouseEnter = aA, n.stacked || (rA.onMouseLeave = EA)), eA && (rA.onClick = (uA) => {
    BA && BA(uA), AA.canCloseOnClick && CA(!0);
  }), { playToast: EA, pauseToast: aA, isRunning: t, preventExitTransition: d, toastRef: H, eventHandlers: rA };
}
var Ot = typeof window < "u" ? useLayoutEffect$1 : useEffect, G = ({ theme: n, type: t, isLoading: g, ...d }) => React__default.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: n === "colored" ? "currentColor" : `var(--toastify-icon-color-${t})`, ...d });
function ao(n) {
  return React__default.createElement(G, { ...n }, React__default.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}
function so(n) {
  return React__default.createElement(G, { ...n }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}
function no(n) {
  return React__default.createElement(G, { ...n }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}
function ro(n) {
  return React__default.createElement(G, { ...n }, React__default.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}
function io() {
  return React__default.createElement("div", { className: "Toastify__spinner" });
}
var W = { info: so, warning: ao, success: no, error: ro, spinner: io }, lo = (n) => n in W;
function Nt({ theme: n, type: t, isLoading: g, icon: d }) {
  let k = null, H = { theme: n, type: t };
  return d === !1 || (P(d) ? k = d({ ...H, isLoading: g }) : isValidElement(d) ? k = cloneElement(d, H) : g ? k = W.spinner() : lo(t) && (k = W[t](H))), k;
}
var wt = (n) => {
  let { isRunning: t, preventExitTransition: g, toastRef: d, eventHandlers: k, playToast: H } = At(n), { closeButton: AA, children: gA, autoClose: IA, onClick: CA, type: BA, hideProgressBar: eA, closeToast: iA, transition: QA, position: tA, className: oA, style: EA, progressClassName: aA, updateId: nA, role: lA, progress: cA, rtl: sA, toastId: rA, deleteToast: uA, isIn: hA, isLoading: dA, closeOnClick: GA, theme: DA, ariaLabel: wA } = n, bA = clsx("Toastify__toast", `Toastify__toast-theme--${DA}`, `Toastify__toast--${BA}`, { "Toastify__toast--rtl": sA }, { "Toastify__toast--close-on-click": GA }), yA = P(oA) ? oA({ rtl: sA, position: tA, type: BA, defaultClassName: bA }) : clsx(bA, oA), pA = Nt(n), MA = !!cA || !IA, LA = { closeToast: iA, type: BA, theme: DA }, xA = null;
  return AA === !1 || (P(AA) ? xA = AA(LA) : isValidElement(AA) ? xA = cloneElement(AA, LA) : xA = yt(LA)), React__default.createElement(QA, { isIn: hA, done: uA, position: tA, preventExitTransition: g, nodeRef: d, playToast: H }, React__default.createElement("div", { id: rA, tabIndex: 0, onClick: CA, "data-in": hA, className: yA, ...k, style: EA, ref: d, ...hA && { role: lA, "aria-label": wA } }, pA != null && React__default.createElement("div", { className: clsx("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !dA }) }, pA), tt(gA, n, !t), xA, !n.customProgressBar && React__default.createElement(gt, { ...nA && !MA ? { key: `p-${nA}` } : {}, rtl: sA, theme: DA, delay: IA, isRunning: t, isIn: hA, closeToast: iA, hide: eA, type: BA, className: aA, controlledProgress: MA, progress: cA || 0 })));
}, K = (n, t = !1) => ({ enter: `Toastify--animate Toastify__${n}-enter`, exit: `Toastify--animate Toastify__${n}-exit`, appendPosition: t }), lt = $(K("bounce", !0)), mo = $(K("slide", !0)), _o = { position: "top-right", transition: lt, autoClose: 5e3, closeButton: !0, pauseOnHover: !0, pauseOnFocusLoss: !0, draggable: "touch", draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light", "aria-label": "Notifications Alt+T", hotKeys: (n) => n.altKey && n.code === "KeyT" };
function Lt(n) {
  let t = { ..._o, ...n }, g = n.stacked, [d, k] = useState(!0), H = useRef(null), { getToastToRender: AA, isToastActive: gA, count: IA } = It(t), { className: CA, style: BA, rtl: eA, containerId: iA, hotKeys: QA } = t;
  function tA(EA) {
    let aA = clsx("Toastify__toast-container", `Toastify__toast-container--${EA}`, { "Toastify__toast-container--rtl": eA });
    return P(CA) ? CA({ position: EA, rtl: eA, defaultClassName: aA }) : clsx(aA, B(CA));
  }
  function oA() {
    g && (k(!0), y.play());
  }
  return Ot(() => {
    var EA;
    if (g) {
      let aA = H.current.querySelectorAll('[data-in="true"]'), nA = 12, lA = (EA = t.position) == null ? void 0 : EA.includes("top"), cA = 0, sA = 0;
      Array.from(aA).reverse().forEach((rA, uA) => {
        let hA = rA;
        hA.classList.add("Toastify__toast--stacked"), uA > 0 && (hA.dataset.collapsed = `${d}`), hA.dataset.pos || (hA.dataset.pos = lA ? "top" : "bot");
        let dA = cA * (d ? 0.2 : 1) + (d ? 0 : nA * uA);
        hA.style.setProperty("--y", `${lA ? dA : dA * -1}px`), hA.style.setProperty("--g", `${nA}`), hA.style.setProperty("--s", `${1 - (d ? sA : 0)}`), cA += hA.offsetHeight, sA += 0.025;
      });
    }
  }, [d, IA, g]), useEffect(() => {
    function EA(aA) {
      var nA;
      let lA = H.current;
      QA(aA) && ((nA = lA.querySelector('[tabIndex="0"]')) == null || nA.focus(), k(!1), y.pause()), aA.key === "Escape" && (document.activeElement === lA || lA != null && lA.contains(document.activeElement)) && (k(!0), y.play());
    }
    return document.addEventListener("keydown", EA), () => {
      document.removeEventListener("keydown", EA);
    };
  }, [QA]), React__default.createElement("section", { ref: H, className: "Toastify", id: iA, onMouseEnter: () => {
    g && (k(!1), y.pause());
  }, onMouseLeave: oA, "aria-live": "polite", "aria-atomic": "false", "aria-relevant": "additions text", "aria-label": t["aria-label"] }, AA((EA, aA) => {
    let nA = aA.length ? { ...BA } : { ...BA, pointerEvents: "none" };
    return React__default.createElement("div", { tabIndex: -1, className: tA(EA), "data-stacked": g, style: nA, key: `c-${EA}` }, aA.map(({ content: lA, props: cA }) => React__default.createElement(wt, { ...cA, stacked: g, collapseAll: oA, isIn: gA(cA.toastId, cA.containerId), key: `t-${cA.key}` }, lA)));
  }));
}
function ErrorToastContent(n) {
  const t = n;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: {
    width: "100%",
    padding: 0
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: t.message }),
    t.error && /* @__PURE__ */ jsxRuntimeExports.jsx("pre", { style: {
      width: "100%",
      padding: 0,
      overflow: "scroll",
      maxHeight: 300
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("code", { style: {
      padding: "16px"
    }, children: t.error.message }) })
  ] });
}
function stliteStyledPromiseToast(n, t) {
  const g = t.error;
  return y.promise(n, {
    pending: t.pending,
    success: t.success,
    error: typeof g == "string" ? {
      render({
        data: d
      }) {
        return d ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorToastContent, { message: g, error: d }) : g;
      },
      autoClose: !1,
      closeOnClick: !1
    } : g
  }, {
    hideProgressBar: !0,
    position: "bottom-right"
  });
}
function makeToastKernelEventListeners() {
  let n = null;
  const t = [];
  return {
    onLoadProgress: (iA) => {
      const QA = y(iA.detail, {
        position: "bottom-right",
        transition: mo,
        isLoading: !0,
        hideProgressBar: !0,
        closeButton: !1
      });
      t.push(QA), n && y.update(n, {
        isLoading: !1,
        autoClose: 3e3
      }), n = QA;
    },
    onLoadFinished: () => {
      t.forEach((iA) => y.dismiss(iA));
    },
    onLoadError: (iA) => {
      y(/* @__PURE__ */ jsxRuntimeExports.jsx(ErrorToastContent, { message: "Error during booting up", error: iA.detail }), {
        position: "bottom-right",
        type: "error",
        autoClose: !1,
        closeOnClick: !1
      });
    },
    onModuleAutoLoad: (iA) => {
      const {
        promise: QA
      } = iA.detail;
      stliteStyledPromiseToast(QA, {
        success: {
          render({
            data: tA
          }) {
            return `Auto-loaded${tA ? ": " + tA.map((oA) => oA.name).join(", ") : " packages"}`;
          }
        },
        error: "Failed to auto-load packages",
        pending: "Auto-loading packages"
      });
    },
    onInstall: (iA) => {
      const {
        requirements: QA,
        promise: tA
      } = iA.detail;
      stliteStyledPromiseToast(tA, {
        pending: "Installing",
        success: `Successfully installed: ${QA.join(", ")}`,
        error: `Failed to install: ${QA.join(", ")}`
      });
    },
    onWriteFile: (iA) => {
      const {
        path: QA,
        promise: tA
      } = iA.detail;
      stliteStyledPromiseToast(tA, {
        error: `Failed to write file: ${QA}`
      });
    },
    onRenameFile: (iA) => {
      const {
        oldPath: QA,
        newPath: tA,
        promise: oA
      } = iA.detail;
      stliteStyledPromiseToast(oA, {
        error: `Failed to rename file from ${QA} to ${tA}`
      });
    },
    onUnlink: (iA) => {
      const {
        path: QA,
        promise: tA
      } = iA.detail;
      stliteStyledPromiseToast(tA, {
        error: `Failed to unlink: ${QA}`
      });
    },
    onReadFile: (iA) => {
      const {
        path: QA,
        promise: tA
      } = iA.detail;
      stliteStyledPromiseToast(tA, {
        error: `Failed to read file: ${QA}`
      });
    },
    onReboot: (iA) => {
      const {
        promise: QA
      } = iA.detail;
      stliteStyledPromiseToast(QA, {
        pending: "Rebooting",
        success: "Successfully rebooted",
        error: "Failed to reboot"
      });
    }
  };
}
function isDarkTheme() {
  const n = getDefaultTheme().name;
  return n === AUTO_THEME_NAME ? window.matchMedia("(prefers-color-scheme: dark)").matches : n === darkTheme$1.name;
}
function ToastContainer() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Lt, { style: {
    zIndex: 999999
  }, theme: isDarkTheme() ? "dark" : "light" });
}
function StliteAppWithToast(n) {
  const {
    kernel: t,
    disableProgressToasts: g,
    disableErrorToasts: d,
    disableModuleAutoLoadToasts: k
  } = n, {
    onLoadProgress: H,
    onLoadFinished: AA,
    onLoadError: gA,
    onModuleAutoLoad: IA,
    onInstall: CA,
    onWriteFile: BA,
    onRenameFile: eA,
    onUnlink: iA,
    onReadFile: QA,
    onReboot: tA
  } = useMemo$1(() => makeToastKernelEventListeners(), []);
  return useEffect(() => {
    if (!g)
      return t.addEventListener("loadProgress", H), t.addEventListener("loadFinished", AA), () => {
        t.removeEventListener("loadProgress", H), t.removeEventListener("loadFinished", AA);
      };
  }, [t, g, H, AA]), useEffect(() => {
    if (!d)
      return t.addEventListener("loadError", gA), () => {
        t.removeEventListener("loadError", gA);
      };
  }, [t, d, gA]), useEffect(() => {
    if (!k)
      return t.addEventListener("moduleAutoLoad", IA), () => {
        t.removeEventListener("moduleAutoLoad", IA);
      };
  }, [t, k, IA]), useEffect(() => (t.addEventListener("install", CA), t.addEventListener("writeFile", BA), t.addEventListener("renameFile", eA), t.addEventListener("unlink", iA), t.addEventListener("readFile", QA), t.addEventListener("reboot", tA), () => {
    t.removeEventListener("install", CA), t.removeEventListener("writeFile", BA), t.removeEventListener("renameFile", eA), t.removeEventListener("unlink", iA), t.removeEventListener("readFile", QA), t.removeEventListener("reboot", tA);
  }), [t, CA, BA, eA, iA, QA, tA]), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StliteApp, { kernel: t }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ToastContainer, {})
  ] });
}
function createKernel(n) {
  return new StliteKernel({
    ...n,
    workerType: n.workerType ?? "module"
    // Default value is "module" because Vite loads the worker scripts as ES modules without bundling at dev time, so we need to specify the type as "module" for the "import" statements in the worker script to work.
  });
}
export {
  StyledWidgetInstructions as $,
  ADJOINED as A,
  BaseButtonKind as B,
  Checkbox$1 as C,
  DynamicButtonLabel as D,
  EmotionIconBase as E,
  DEFAULT_IFRAME_SANDBOX_POLICY as F,
  DEFAULT_IFRAME_FEATURE_POLICY as G,
  useStliteMediaObjects as H,
  useRequiredContext as I,
  IsSidebarContext as J,
  Kind as K,
  LibContext as L,
  without as M,
  useSelectCommon as N,
  StyledWidgetLabelHelp as O,
  Placement as P,
  Select as Q,
  VirtualDropdown as R,
  StyledCheckbox$1 as S,
  TooltipIcon as T,
  UISelectbox as U,
  Video$1 as V,
  WidgetLabel as W,
  ChevronDown$1 as X,
  TYPE as Y,
  keyframes as Z,
  _extends$M as _,
  Box as a,
  ensureError as a$,
  isFromMac as a0,
  requireToString as a1,
  getDefaultExportFromCjs$2 as a2,
  useCalculatedDimensions as a3,
  isInForm as a4,
  TextInput$1 as a5,
  PortalContext as a6,
  range$6 as a7,
  darken as a8,
  useStliteKernel as a9,
  NumberInput$1 as aA,
  convertRemToPx as aB,
  addCssUnit as aC,
  useStyletron as aD,
  mergeOverride as aE,
  toObjectOverride as aF,
  Icon$2 as aG,
  DeleteAlt$1 as aH,
  forkBlur as aI,
  forkFocus as aJ,
  applyStreamlitTheme as aK,
  applyThemeDefaults as aL,
  DataFrameCellType as aM,
  isNumericType as aN,
  isDatetimeType as aO,
  isDateType as aP,
  getTimezone as aQ,
  debounce$4 as aR,
  isEqual$1 as aS,
  embed as aT,
  expression$1 as aU,
  truthy as aV,
  shouldHeightStretch as aW,
  Global as aX,
  StyledVegaLiteChartTooltips as aY,
  StyledVegaLiteChartContainer as aZ,
  requirePropTypes as a_,
  styled as aa,
  isFocusVisible as ab,
  getOverride as ac,
  getOverrideProps as ad,
  classNames as ae,
  StyledSpinnerIcon as af,
  mergeOverrides as ag,
  CUSTOM_INPUT_TYPE as ah,
  LabelVisibilityOptions as ai,
  Tooltip$1 as aj,
  Icon as ak,
  hexToRgb as al,
  withWrapper as am,
  getCrossOriginAttribute as an,
  _unsupportedIterableToArray$h as ao,
  useWindowDimensionsContext as ap,
  hoistNonReactStatics as aq,
  LocaleContext as ar,
  shouldWidthStretch as as,
  ButtonGroup$1 as at,
  StyledButtonGroup as au,
  LabelVisibilityMessage as av,
  toPropertyKey$2 as aw,
  _typeof$e as ax,
  _assertThisInitialized$b as ay,
  _setPrototypeOf$b as az,
  BaseButtonTooltip as b,
  require_root as b$,
  merge$8 as b0,
  getIncreasingGreen as b1,
  getDecreasingRed as b2,
  getBlue80 as b3,
  getGray30 as b4,
  getGray70 as b5,
  getGray90 as b6,
  getDivergingColorsArray as b7,
  keysToSnakeCase as b8,
  PlotlyChart$1 as b9,
  requireReactIs$1 as bA,
  isPropValid as bB,
  StyledDropdownListItem as bC,
  requireBrowser as bD,
  UIDConsumer as bE,
  Popover$2 as bF,
  StatefulMenu as bG,
  PLACEMENT as bH,
  ACCESSIBILITY_TYPE as bI,
  _defineProperty$q as bJ,
  filterOptions as bK,
  Timer$2 as bL,
  timer$1 as bM,
  dispatch$1 as bN,
  interpolateNumber as bO,
  interpolateRgb as bP,
  interpolateString as bQ,
  color$3 as bR,
  interpolateTransformSvg as bS,
  interpolateTransformCss as bT,
  now$2 as bU,
  interpolateZoom as bV,
  interpolate$2 as bW,
  format$3 as bX,
  path$4 as bY,
  require_hasPath as bZ,
  requireClassnames as b_,
  themeColors as ba,
  isMobile as bb,
  CAMERA_PERMISSION_URL as bc,
  withCalculatedWidth as bd,
  UploadedFileInfo as be,
  FileUploaderState as bf,
  __awaiter as bg,
  PropTypes as bh,
  isFromWindows as bi,
  AcceptFileValue as bj,
  assertNever as bk,
  zip as bl,
  chatInputAcceptFileProtoValueToEnum as bm,
  ThemeContext as bn,
  pick as bo,
  hooks as bp,
  Slider$2 as bq,
  ENABLE_PERIPHERALS_DOCS_URL as br,
  blend$1 as bs,
  ThemeProvider$1 as bt,
  createThemedStyled as bu,
  createThemedUseStyletron as bv,
  createThemedWithStyle as bw,
  expandBorderStyles as bx,
  withStyle as by,
  getAugmentedNamespace as bz,
  BaseButton as c,
  alloc as c$,
  requireIsObject as c0,
  requireToNumber as c1,
  require_Set as c2,
  require_setToArray as c3,
  require_SetCache as c4,
  require_arrayIncludes as c5,
  require_cacheHas as c6,
  require_arrayIncludesWith as c7,
  requireFlatten as c8,
  groupBy as c9,
  Null as cA,
  isTimeType as cB,
  convertTimeToDate as cC,
  isDecimalType as cD,
  isRangeIndexType as cE,
  isStringType as cF,
  isEmptyType as cG,
  isObjectType as cH,
  isBytesType as cI,
  isCategoricalType as cJ,
  isListType as cK,
  fontSizes as cL,
  Arrow$2 as cM,
  mergeWith as cN,
  _objectWithoutProperties$j as cO,
  stringify$7 as cP,
  rulesheet as cQ,
  COMMENT as cR,
  middleware as cS,
  RULESET as cT,
  combine as cU,
  KEYFRAMES as cV,
  serialize$2 as cW,
  copy$4 as cX,
  replace$3 as cY,
  DECLARATION as cZ,
  dealloc as c_,
  require$$0$1 as ca,
  numbro$1 as cb,
  Vector as cc,
  lib$1 as cd,
  ReactJson as ce,
  getLuminance as cf,
  moment as cg,
  isMaterialIcon as ch,
  parseIconPackEntry as ci,
  genericFonts as cj,
  getMarkdownBgColors as ck,
  isUnsignedIntegerType as cl,
  isIntegerType as cm,
  isDurationType as cn,
  isPeriodType as co,
  format$4 as cp,
  isBooleanType as cq,
  requireIsArray as cr,
  require_baseKeys as cs,
  require_getTag as ct,
  requireIsArguments as cu,
  requireIsArrayLike as cv,
  requireIsBuffer as cw,
  require_isPrototype as cx,
  requireIsTypedArray as cy,
  Field$2 as cz,
  BaseButtonSize as d,
  hash$3 as d0,
  charat as d1,
  WEBKIT as d2,
  MS as d3,
  strlen as d4,
  indexof$1 as d5,
  MOZ as d6,
  match$2 as d7,
  next$1 as d8,
  token$3 as d9,
  parseToRgba as dA,
  DeckGlJsonChart$1 as dB,
  StliteApp as dC,
  StliteAppWithToast as dD,
  createKernel as dE,
  from$1 as da,
  peek$5 as db,
  delimit as dc,
  slice$3 as dd,
  position$5 as de,
  compile$1 as df,
  getRegisteredStyles as dg,
  serializeStyles as dh,
  registerStyles as di,
  insertStyles as dj,
  _toConsumableArray$2 as dk,
  lighten as dl,
  mix$1 as dm,
  getStyledCell as dn,
  TRIGGER_TYPE as dp,
  useCopyToClipboard as dq,
  StyledTooltipContentWrapper as dr,
  FlexContext as ds,
  useScrollbarGutterSize as dt,
  Resizable as du,
  streamlit as dv,
  propTypesExports as dw,
  index as dx,
  threshold as dy,
  linear as dz,
  StyledContent as e,
  StreamlitMarkdown$1 as f,
  StyledWidgetLabelHelpInline as g,
  hasLightBackgroundColor as h,
  BaseColorPicker$1 as i,
  jsxRuntimeExports as j,
  isValidFormId as k,
  labelVisibilityProtoValueToEnum as l,
  isNullOrUndefined$1 as m,
  notNullOrUndefined as n,
  getOverrides as o,
  SIZE$1 as p,
  ENHANCER_POSITION as q,
  createStyled$1 as r,
  useStliteMediaObjectUrl as s,
  transparentize as t,
  useEmotionTheme as u,
  useCrossOriginAttribute as v,
  loglevelExports$1 as w,
  DynamicIcon as x,
  toaster as y,
  AlertElement$1 as z
};
//# sourceMappingURL=index-C_Xpi9RO.js.map
